
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire399f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire399f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8S27K", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $675503a822348589$export$ffb0004e005737fa, (v) => $675503a822348589$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $675503a822348589$export$34b9dba7ce09269b, (v) => $675503a822348589$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $675503a822348589$export$25062201e9e25d76, (v) => $675503a822348589$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $675503a822348589$export$ffb0004e005737fa;
var $675503a822348589$export$34b9dba7ce09269b;
var $675503a822348589$export$25062201e9e25d76;
"use strict";
var $675503a822348589$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $675503a822348589$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $675503a822348589$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $675503a822348589$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$675503a822348589$export$ffb0004e005737fa = $675503a822348589$var$REACT_FRAGMENT_TYPE;
$675503a822348589$export$34b9dba7ce09269b = $675503a822348589$var$jsxProd;
$675503a822348589$export$25062201e9e25d76 = $675503a822348589$var$jsxProd;

});

parcelRegister("03XiP", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $00be48392311af6a$export$882461b6382ed46c, (v) => $00be48392311af6a$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $00be48392311af6a$export$757ceba2d55c277e, (v) => $00be48392311af6a$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $00be48392311af6a$export$83d89fbfd8236492, (v) => $00be48392311af6a$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $00be48392311af6a$export$882461b6382ed46c;
var $00be48392311af6a$export$757ceba2d55c277e;
var $00be48392311af6a$export$83d89fbfd8236492;
"use strict";

var $6XCI2 = parcelRequire("6XCI2");

var $5E6i4 = parcelRequire("5E6i4");

var $ibUU1 = parcelRequire("ibUU1");
function $00be48392311af6a$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $00be48392311af6a$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $00be48392311af6a$var$getNearestMountedFiber(fiber) {
    for(var node = fiber, nextNode = node; nextNode && !nextNode.alternate;)node = nextNode, 0 !== (node.flags & 4098) && (fiber = node.return), nextNode = node.return;
    for(; node.return;)node = node.return;
    return 3 === node.tag ? fiber : null;
}
function $00be48392311af6a$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $00be48392311af6a$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $00be48392311af6a$var$assertIsMounted(fiber) {
    if ($00be48392311af6a$var$getNearestMountedFiber(fiber) !== fiber) throw Error($00be48392311af6a$var$formatProdErrorMessage(188));
}
function $00be48392311af6a$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $00be48392311af6a$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($00be48392311af6a$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $00be48392311af6a$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $00be48392311af6a$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($00be48392311af6a$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($00be48392311af6a$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($00be48392311af6a$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($00be48392311af6a$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $00be48392311af6a$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $00be48392311af6a$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
function $00be48392311af6a$var$traverseVisibleInstancesAndTextInstances(child, searchWithinHosts, fn, a, b, c) {
    for(; null !== child;){
        if ((5 === child.tag || 27 === child.tag || 6 === child.tag) && fn(child, a, b, c) || (22 !== child.tag || null === child.memoizedState) && (searchWithinHosts || 5 !== child.tag && 27 !== child.tag) && $00be48392311af6a$var$traverseVisibleInstancesAndTextInstances(child.child, searchWithinHosts, fn, a, b, c)) return !0;
        child = child.sibling;
    }
    return !1;
}
function $00be48392311af6a$var$getFragmentParentInstanceOrContainerFiber(fiber) {
    for(fiber = fiber.return; null !== fiber;){
        if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) return fiber;
        fiber = fiber.return;
    }
    return null;
}
function $00be48392311af6a$var$fiberIsPortaledIntoHost(fiber) {
    var foundPortalParent = !1;
    for(fiber = fiber.return; null !== fiber;){
        4 === fiber.tag && (foundPortalParent = !0);
        if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) break;
        fiber = fiber.return;
    }
    return foundPortalParent;
}
function $00be48392311af6a$var$getFragmentInstanceOrTextInstanceSiblings(fiber) {
    var result = [
        null,
        null
    ], parentHostFiber = $00be48392311af6a$var$getFragmentParentInstanceOrContainerFiber(fiber);
    if (null === parentHostFiber) return result;
    $00be48392311af6a$var$findFragmentInstanceOrTextInstanceSiblings(result, fiber, parentHostFiber.child, {
        foundSelf: !1
    });
    return result;
}
function $00be48392311af6a$var$findFragmentInstanceOrTextInstanceSiblings(result, self, child, state) {
    for(; null !== child;){
        if (child === self) state.foundSelf = !0;
        else if (5 === child.tag || 27 === child.tag || 6 === child.tag) {
            if (state.foundSelf) return result[1] = child, !0;
            result[0] = child;
        } else if ((22 !== child.tag || null === child.memoizedState) && $00be48392311af6a$var$findFragmentInstanceOrTextInstanceSiblings(result, self, child.child, state)) return !0;
        child = child.sibling;
    }
    return !1;
}
function $00be48392311af6a$var$getInstanceFromHostFiber(fiber) {
    switch(fiber.tag){
        case 5:
        case 27:
        case 6:
            return fiber.stateNode;
        case 3:
            return fiber.stateNode.containerInfo;
        default:
            throw Error($00be48392311af6a$var$formatProdErrorMessage(559));
    }
}
var $00be48392311af6a$var$searchTarget = null, $00be48392311af6a$var$searchBoundary = null;
function $00be48392311af6a$var$isFiberPrecedingCheck(child, target, boundary) {
    return child === boundary ? !0 : child === target ? ($00be48392311af6a$var$searchTarget = child, !0) : !1;
}
function $00be48392311af6a$var$isFiberFollowingCheck(child, target, boundary) {
    return child === boundary ? ($00be48392311af6a$var$searchBoundary = child, !1) : child === target ? (null !== $00be48392311af6a$var$searchBoundary && ($00be48392311af6a$var$searchTarget = child), !0) : !1;
}
function $00be48392311af6a$var$getParentForFragmentAncestors(inst) {
    if (null === inst) return null;
    do inst = null === inst ? null : inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag && 3 !== inst.tag);
    return inst ? inst : null;
}
function $00be48392311af6a$var$getLowestCommonAncestor(instA, instB, getParent) {
    for(var depthA = 0, tempA = instA; tempA; tempA = getParent(tempA))depthA++;
    tempA = 0;
    for(var tempB = instB; tempB; tempB = getParent(tempB))tempA++;
    for(; 0 < depthA - tempA;)instA = getParent(instA), depthA--;
    for(; 0 < tempA - depthA;)instB = getParent(instB), tempA--;
    for(; depthA--;){
        if (instA === instB || null !== instB && instA === instB.alternate) return instA;
        instA = getParent(instA);
        instB = getParent(instB);
    }
    return null;
}
var $00be48392311af6a$var$assign = Object.assign, $00be48392311af6a$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $00be48392311af6a$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $00be48392311af6a$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $00be48392311af6a$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $00be48392311af6a$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $00be48392311af6a$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $00be48392311af6a$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $00be48392311af6a$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $00be48392311af6a$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $00be48392311af6a$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $00be48392311af6a$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $00be48392311af6a$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $00be48392311af6a$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $00be48392311af6a$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $00be48392311af6a$var$REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $00be48392311af6a$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), $00be48392311af6a$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $00be48392311af6a$var$REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), $00be48392311af6a$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $00be48392311af6a$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $00be48392311af6a$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$00be48392311af6a$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $00be48392311af6a$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $00be48392311af6a$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $00be48392311af6a$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $00be48392311af6a$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $00be48392311af6a$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $00be48392311af6a$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $00be48392311af6a$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $00be48392311af6a$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $00be48392311af6a$var$REACT_ACTIVITY_TYPE:
            return "Activity";
        case $00be48392311af6a$var$REACT_VIEW_TRANSITION_TYPE:
            return "ViewTransition";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $00be48392311af6a$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $00be48392311af6a$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $00be48392311af6a$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $00be48392311af6a$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $00be48392311af6a$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $00be48392311af6a$var$getComponentNameFromType(type.type) || "Memo";
        case $00be48392311af6a$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $00be48392311af6a$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $00be48392311af6a$var$isArrayImpl = Array.isArray, $00be48392311af6a$var$ReactSharedInternals = $5E6i4.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $00be48392311af6a$var$ReactDOMSharedInternals = $ibUU1.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $00be48392311af6a$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $00be48392311af6a$var$valueStack = [], $00be48392311af6a$var$index = -1;
function $00be48392311af6a$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $00be48392311af6a$var$pop(cursor) {
    0 > $00be48392311af6a$var$index || (cursor.current = $00be48392311af6a$var$valueStack[$00be48392311af6a$var$index], $00be48392311af6a$var$valueStack[$00be48392311af6a$var$index] = null, $00be48392311af6a$var$index--);
}
function $00be48392311af6a$var$push(cursor, value) {
    $00be48392311af6a$var$index++;
    $00be48392311af6a$var$valueStack[$00be48392311af6a$var$index] = cursor.current;
    cursor.current = value;
}
var $00be48392311af6a$var$contextStackCursor = $00be48392311af6a$var$createCursor(null), $00be48392311af6a$var$contextFiberStackCursor = $00be48392311af6a$var$createCursor(null), $00be48392311af6a$var$rootInstanceStackCursor = $00be48392311af6a$var$createCursor(null), $00be48392311af6a$var$hostTransitionProviderCursor = $00be48392311af6a$var$createCursor(null);
function $00be48392311af6a$var$pushHostContainer(fiber, nextRootInstance) {
    $00be48392311af6a$var$push($00be48392311af6a$var$rootInstanceStackCursor, nextRootInstance);
    $00be48392311af6a$var$push($00be48392311af6a$var$contextFiberStackCursor, fiber);
    $00be48392311af6a$var$push($00be48392311af6a$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $00be48392311af6a$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $00be48392311af6a$var$getOwnHostContext(nextRootInstance), fiber = $00be48392311af6a$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $00be48392311af6a$var$pop($00be48392311af6a$var$contextStackCursor);
    $00be48392311af6a$var$push($00be48392311af6a$var$contextStackCursor, fiber);
}
function $00be48392311af6a$var$popHostContainer() {
    $00be48392311af6a$var$pop($00be48392311af6a$var$contextStackCursor);
    $00be48392311af6a$var$pop($00be48392311af6a$var$contextFiberStackCursor);
    $00be48392311af6a$var$pop($00be48392311af6a$var$rootInstanceStackCursor);
}
function $00be48392311af6a$var$pushHostContext(fiber) {
    var stateHook = fiber.memoizedState;
    null !== stateHook && ($00be48392311af6a$var$HostTransitionContext._currentValue = stateHook.memoizedState, $00be48392311af6a$var$push($00be48392311af6a$var$hostTransitionProviderCursor, fiber));
    stateHook = $00be48392311af6a$var$contextStackCursor.current;
    var JSCompiler_inline_result = $00be48392311af6a$var$getChildHostContextProd(stateHook, fiber.type);
    stateHook !== JSCompiler_inline_result && ($00be48392311af6a$var$push($00be48392311af6a$var$contextFiberStackCursor, fiber), $00be48392311af6a$var$push($00be48392311af6a$var$contextStackCursor, JSCompiler_inline_result));
}
function $00be48392311af6a$var$popHostContext(fiber) {
    $00be48392311af6a$var$contextFiberStackCursor.current === fiber && ($00be48392311af6a$var$pop($00be48392311af6a$var$contextStackCursor), $00be48392311af6a$var$pop($00be48392311af6a$var$contextFiberStackCursor));
    $00be48392311af6a$var$hostTransitionProviderCursor.current === fiber && ($00be48392311af6a$var$pop($00be48392311af6a$var$hostTransitionProviderCursor), $00be48392311af6a$var$HostTransitionContext._currentValue = $00be48392311af6a$var$sharedNotPendingObject);
}
var $00be48392311af6a$var$prefix, $00be48392311af6a$var$suffix;
function $00be48392311af6a$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $00be48392311af6a$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $00be48392311af6a$var$prefix = match && match[1] || "";
        $00be48392311af6a$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $00be48392311af6a$var$prefix + name + $00be48392311af6a$var$suffix;
}
var $00be48392311af6a$var$reentry = !1;
function $00be48392311af6a$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $00be48392311af6a$var$reentry) return "";
    $00be48392311af6a$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            Fake = !1;
                            try {
                                var prevProps = Object.getOwnPropertyDescriptor(fn.prototype, "props");
                                Object.defineProperty(fn.prototype, "props", {
                                    configurable: !0,
                                    set: function() {
                                        throw Error();
                                    }
                                });
                                Fake = !0;
                                new fn();
                            } finally{
                                Fake && (void 0 !== prevProps ? Object.defineProperty(fn.prototype, "props", prevProps) : delete fn.prototype.props);
                            }
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $00be48392311af6a$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $00be48392311af6a$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $00be48392311af6a$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $00be48392311af6a$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $00be48392311af6a$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $00be48392311af6a$var$describeBuiltInComponentFrame("Suspense Fallback") : $00be48392311af6a$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $00be48392311af6a$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $00be48392311af6a$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $00be48392311af6a$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $00be48392311af6a$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $00be48392311af6a$var$describeBuiltInComponentFrame("Activity");
        case 30:
            return $00be48392311af6a$var$describeBuiltInComponentFrame("ViewTransition");
        default:
            return "";
    }
}
function $00be48392311af6a$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $00be48392311af6a$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $00be48392311af6a$var$hasOwnProperty = Object.prototype.hasOwnProperty, $00be48392311af6a$var$scheduleCallback$3 = $6XCI2.unstable_scheduleCallback, $00be48392311af6a$var$cancelCallback$1 = $6XCI2.unstable_cancelCallback, $00be48392311af6a$var$shouldYield = $6XCI2.unstable_shouldYield, $00be48392311af6a$var$requestPaint = $6XCI2.unstable_requestPaint, $00be48392311af6a$var$now = $6XCI2.unstable_now, $00be48392311af6a$var$getCurrentPriorityLevel = $6XCI2.unstable_getCurrentPriorityLevel, $00be48392311af6a$var$ImmediatePriority = $6XCI2.unstable_ImmediatePriority, $00be48392311af6a$var$UserBlockingPriority = $6XCI2.unstable_UserBlockingPriority, $00be48392311af6a$var$NormalPriority$1 = $6XCI2.unstable_NormalPriority, $00be48392311af6a$var$LowPriority = $6XCI2.unstable_LowPriority, $00be48392311af6a$var$IdlePriority = $6XCI2.unstable_IdlePriority, $00be48392311af6a$var$log$1 = $6XCI2.log, $00be48392311af6a$var$unstable_setDisableYieldValue = $6XCI2.unstable_setDisableYieldValue, $00be48392311af6a$var$rendererID = null, $00be48392311af6a$var$injectedHook = null;
function $00be48392311af6a$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $00be48392311af6a$var$log$1 && $00be48392311af6a$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($00be48392311af6a$var$injectedHook && "function" === typeof $00be48392311af6a$var$injectedHook.setStrictMode) try {
        $00be48392311af6a$var$injectedHook.setStrictMode($00be48392311af6a$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $00be48392311af6a$var$clz32 = Math.clz32 ? Math.clz32 : $00be48392311af6a$var$clz32Fallback, $00be48392311af6a$var$log = Math.log, $00be48392311af6a$var$LN2 = Math.LN2;
function $00be48392311af6a$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($00be48392311af6a$var$log(x) / $00be48392311af6a$var$LN2 | 0) | 0;
}
var $00be48392311af6a$var$nextTransitionUpdateLane = 256, $00be48392311af6a$var$nextTransitionDeferredLane = 262144, $00be48392311af6a$var$nextRetryLane = 4194304;
function $00be48392311af6a$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & -lanes;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $00be48392311af6a$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $00be48392311af6a$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $00be48392311af6a$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $00be48392311af6a$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $00be48392311af6a$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $00be48392311af6a$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $00be48392311af6a$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $00be48392311af6a$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $00be48392311af6a$var$getEntangledLanes(root, renderLanes) {
    0 !== (renderLanes & 8) && (renderLanes |= renderLanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= renderLanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $00be48392311af6a$var$clz32(allEntangledLanes), lane = 1 << index$4;
        renderLanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    return renderLanes;
}
function $00be48392311af6a$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $00be48392311af6a$var$claimNextRetryLane() {
    var lane = $00be48392311af6a$var$nextRetryLane;
    $00be48392311af6a$var$nextRetryLane <<= 1;
    0 === ($00be48392311af6a$var$nextRetryLane & 62914560) && ($00be48392311af6a$var$nextRetryLane = 4194304);
    return lane;
}
function $00be48392311af6a$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $00be48392311af6a$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $00be48392311af6a$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $00be48392311af6a$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $00be48392311af6a$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $00be48392311af6a$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $00be48392311af6a$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $00be48392311af6a$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $00be48392311af6a$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $00be48392311af6a$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $00be48392311af6a$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $00be48392311af6a$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $00be48392311af6a$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $00be48392311af6a$var$resolveUpdatePriority() {
    var updatePriority = $00be48392311af6a$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $00be48392311af6a$var$getEventPriority(updatePriority.type);
}
function $00be48392311af6a$var$runWithPriority(priority, fn) {
    var previousPriority = $00be48392311af6a$var$ReactDOMSharedInternals.p;
    try {
        return $00be48392311af6a$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $00be48392311af6a$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $00be48392311af6a$var$randomKey = Math.random().toString(36).slice(2), $00be48392311af6a$var$internalInstanceKey = "__reactFiber$" + $00be48392311af6a$var$randomKey, $00be48392311af6a$var$internalPropsKey = "__reactProps$" + $00be48392311af6a$var$randomKey, $00be48392311af6a$var$internalContainerInstanceKey = "__reactContainer$" + $00be48392311af6a$var$randomKey, $00be48392311af6a$var$internalEventHandlersKey = "__reactEvents$" + $00be48392311af6a$var$randomKey, $00be48392311af6a$var$internalEventHandlerListenersKey = "__reactListeners$" + $00be48392311af6a$var$randomKey, $00be48392311af6a$var$internalEventHandlesSetKey = "__reactHandles$" + $00be48392311af6a$var$randomKey, $00be48392311af6a$var$internalRootNodeResourcesKey = "__reactResources$" + $00be48392311af6a$var$randomKey, $00be48392311af6a$var$internalHoistableMarker = "__reactMarker$" + $00be48392311af6a$var$randomKey, $00be48392311af6a$var$internalLoadPendingKey = "__reactLoad$" + $00be48392311af6a$var$randomKey;
function $00be48392311af6a$var$detachDeletedInstance(node) {
    delete node[$00be48392311af6a$var$internalInstanceKey];
    delete node[$00be48392311af6a$var$internalPropsKey];
    delete node[$00be48392311af6a$var$internalEventHandlerListenersKey];
    delete node[$00be48392311af6a$var$internalEventHandlesSetKey];
}
function $00be48392311af6a$var$getClosestInstanceFromNode(targetNode) {
    var targetInst;
    if (targetInst = targetNode[$00be48392311af6a$var$internalInstanceKey]) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$00be48392311af6a$var$internalContainerInstanceKey] || parentNode[$00be48392311af6a$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $00be48392311af6a$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$00be48392311af6a$var$internalInstanceKey]) return parentNode;
                targetNode = $00be48392311af6a$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $00be48392311af6a$var$getInstanceFromNode(node) {
    if (node = node[$00be48392311af6a$var$internalInstanceKey] || node[$00be48392311af6a$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $00be48392311af6a$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($00be48392311af6a$var$formatProdErrorMessage(33));
}
function $00be48392311af6a$var$getResourcesFromRoot(root) {
    var resources = root[$00be48392311af6a$var$internalRootNodeResourcesKey];
    resources || (resources = root[$00be48392311af6a$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $00be48392311af6a$var$markNodeAsHoistable(node) {
    node[$00be48392311af6a$var$internalHoistableMarker] = !0;
}
function $00be48392311af6a$var$clearPendingLoadOnNode(node) {
    node[$00be48392311af6a$var$internalLoadPendingKey] = void 0;
}
var $00be48392311af6a$var$allNativeEvents = new Set(), $00be48392311af6a$var$registrationNameDependencies = {};
function $00be48392311af6a$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $00be48392311af6a$var$registerDirectEvent(registrationName, dependencies);
    $00be48392311af6a$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $00be48392311af6a$var$registerDirectEvent(registrationName, dependencies) {
    $00be48392311af6a$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$00be48392311af6a$var$allNativeEvents.add(dependencies[registrationName]);
}
var $00be48392311af6a$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $00be48392311af6a$var$illegalAttributeNameCache = {}, $00be48392311af6a$var$validatedAttributeNameCache = {};
function $00be48392311af6a$var$isAttributeNameSafe(attributeName) {
    if ($00be48392311af6a$var$hasOwnProperty.call($00be48392311af6a$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($00be48392311af6a$var$hasOwnProperty.call($00be48392311af6a$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($00be48392311af6a$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $00be48392311af6a$var$validatedAttributeNameCache[attributeName] = !0;
    $00be48392311af6a$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
var $00be48392311af6a$var$viewTransitionMutationContext = !1;
function $00be48392311af6a$var$pushMutationContext() {
    var prev = $00be48392311af6a$var$viewTransitionMutationContext;
    $00be48392311af6a$var$viewTransitionMutationContext = !1;
    return prev;
}
function $00be48392311af6a$var$setValueForAttribute(node, name, value) {
    if ($00be48392311af6a$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, value);
        }
    }
}
function $00be48392311af6a$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, value);
    }
}
function $00be48392311af6a$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, value);
    }
}
function $00be48392311af6a$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $00be48392311af6a$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $00be48392311af6a$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $00be48392311af6a$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $00be48392311af6a$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $00be48392311af6a$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $00be48392311af6a$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $00be48392311af6a$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
var $00be48392311af6a$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $00be48392311af6a$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($00be48392311af6a$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $00be48392311af6a$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $00be48392311af6a$var$getToStringValue(value);
        } else element.value !== "" + $00be48392311af6a$var$getToStringValue(value) && (element.value = "" + $00be48392311af6a$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? "number" === type && element.value == value ? $00be48392311af6a$var$setDefaultValue(element, $00be48392311af6a$var$getToStringValue(element.value)) : $00be48392311af6a$var$setDefaultValue(element, $00be48392311af6a$var$getToStringValue(value)) : null != defaultValue ? $00be48392311af6a$var$setDefaultValue(element, $00be48392311af6a$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $00be48392311af6a$var$getToStringValue(name) : element.removeAttribute("name");
}
function $00be48392311af6a$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $00be48392311af6a$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $00be48392311af6a$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $00be48392311af6a$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $00be48392311af6a$var$track(element);
}
function $00be48392311af6a$var$setDefaultValue(node, value) {
    node.defaultValue !== "" + value && (node.defaultValue = "" + value);
}
function $00be48392311af6a$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $00be48392311af6a$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $00be48392311af6a$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $00be48392311af6a$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $00be48392311af6a$var$getToStringValue(defaultValue) : "";
}
function $00be48392311af6a$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($00be48392311af6a$var$formatProdErrorMessage(92));
            if ($00be48392311af6a$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($00be48392311af6a$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $00be48392311af6a$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $00be48392311af6a$var$track(element);
}
function $00be48392311af6a$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $00be48392311af6a$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $00be48392311af6a$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $00be48392311af6a$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $00be48392311af6a$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($00be48392311af6a$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "", $00be48392311af6a$var$viewTransitionMutationContext = !0);
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && ($00be48392311af6a$var$setValueForStyle(node, styleName$16, styleName), $00be48392311af6a$var$viewTransitionMutationContext = !0);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $00be48392311af6a$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $00be48392311af6a$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $00be48392311af6a$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "maskType",
        "mask-type"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $00be48392311af6a$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $00be48392311af6a$var$sanitizeURL(url) {
    return $00be48392311af6a$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $00be48392311af6a$var$noop$1() {}
var $00be48392311af6a$var$currentReplayingEvent = null;
function $00be48392311af6a$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $00be48392311af6a$var$restoreTarget = null, $00be48392311af6a$var$restoreQueue = null;
function $00be48392311af6a$var$restoreStateOfTarget(target) {
    var internalInstance = $00be48392311af6a$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$00be48392311af6a$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $00be48392311af6a$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $00be48392311af6a$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$00be48392311af6a$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($00be48392311af6a$var$formatProdErrorMessage(90));
                            $00be48392311af6a$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $00be48392311af6a$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $00be48392311af6a$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $00be48392311af6a$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $00be48392311af6a$var$isInsideEventHandler = !1;
function $00be48392311af6a$var$batchedUpdates$1(fn, a, b) {
    if ($00be48392311af6a$var$isInsideEventHandler) return fn(a, b);
    $00be48392311af6a$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($00be48392311af6a$var$isInsideEventHandler = !1, null !== $00be48392311af6a$var$restoreTarget || null !== $00be48392311af6a$var$restoreQueue) {
            if ($00be48392311af6a$var$flushSyncWork$1(), $00be48392311af6a$var$restoreTarget && (a = $00be48392311af6a$var$restoreTarget, fn = $00be48392311af6a$var$restoreQueue, $00be48392311af6a$var$restoreQueue = $00be48392311af6a$var$restoreTarget = null, $00be48392311af6a$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$00be48392311af6a$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $00be48392311af6a$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$00be48392311af6a$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($00be48392311af6a$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $00be48392311af6a$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $00be48392311af6a$var$passiveBrowserEventsSupported = !1;
if ($00be48392311af6a$var$canUseDOM) try {
    var $00be48392311af6a$var$options = {};
    Object.defineProperty($00be48392311af6a$var$options, "passive", {
        get: function() {
            $00be48392311af6a$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $00be48392311af6a$var$options, $00be48392311af6a$var$options);
    window.removeEventListener("test", $00be48392311af6a$var$options, $00be48392311af6a$var$options);
} catch (e) {
    $00be48392311af6a$var$passiveBrowserEventsSupported = !1;
}
var $00be48392311af6a$var$root = null, $00be48392311af6a$var$startText = null, $00be48392311af6a$var$fallbackText = null;
function $00be48392311af6a$var$getData() {
    if ($00be48392311af6a$var$fallbackText) return $00be48392311af6a$var$fallbackText;
    var start, startValue = $00be48392311af6a$var$startText, startLength = startValue.length, end, endValue = "value" in $00be48392311af6a$var$root ? $00be48392311af6a$var$root.value : $00be48392311af6a$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $00be48392311af6a$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $00be48392311af6a$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $00be48392311af6a$var$functionThatReturnsTrue() {
    return !0;
}
function $00be48392311af6a$var$functionThatReturnsFalse() {
    return !1;
}
function $00be48392311af6a$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $00be48392311af6a$var$functionThatReturnsTrue : $00be48392311af6a$var$functionThatReturnsFalse;
        this.isPropagationStopped = $00be48392311af6a$var$functionThatReturnsFalse;
        return this;
    }
    $00be48392311af6a$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $00be48392311af6a$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $00be48392311af6a$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $00be48392311af6a$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $00be48392311af6a$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $00be48392311af6a$var$SyntheticEvent = $00be48392311af6a$var$createSyntheticEvent($00be48392311af6a$var$EventInterface), $00be48392311af6a$var$UIEventInterface = $00be48392311af6a$var$assign({}, $00be48392311af6a$var$EventInterface, {
    view: 0,
    detail: 0
}), $00be48392311af6a$var$SyntheticUIEvent = $00be48392311af6a$var$createSyntheticEvent($00be48392311af6a$var$UIEventInterface), $00be48392311af6a$var$lastMovementX, $00be48392311af6a$var$lastMovementY, $00be48392311af6a$var$lastMouseEvent, $00be48392311af6a$var$MouseEventInterface = $00be48392311af6a$var$assign({}, $00be48392311af6a$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $00be48392311af6a$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $00be48392311af6a$var$lastMouseEvent && ($00be48392311af6a$var$lastMouseEvent && "mousemove" === event.type ? ($00be48392311af6a$var$lastMovementX = event.screenX - $00be48392311af6a$var$lastMouseEvent.screenX, $00be48392311af6a$var$lastMovementY = event.screenY - $00be48392311af6a$var$lastMouseEvent.screenY) : $00be48392311af6a$var$lastMovementY = $00be48392311af6a$var$lastMovementX = 0, $00be48392311af6a$var$lastMouseEvent = event);
        return $00be48392311af6a$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $00be48392311af6a$var$lastMovementY;
    }
}), $00be48392311af6a$var$SyntheticMouseEvent = $00be48392311af6a$var$createSyntheticEvent($00be48392311af6a$var$MouseEventInterface), $00be48392311af6a$var$DragEventInterface = $00be48392311af6a$var$assign({}, $00be48392311af6a$var$MouseEventInterface, {
    dataTransfer: 0
}), $00be48392311af6a$var$SyntheticDragEvent = $00be48392311af6a$var$createSyntheticEvent($00be48392311af6a$var$DragEventInterface), $00be48392311af6a$var$FocusEventInterface = $00be48392311af6a$var$assign({}, $00be48392311af6a$var$UIEventInterface, {
    relatedTarget: 0
}), $00be48392311af6a$var$SyntheticFocusEvent = $00be48392311af6a$var$createSyntheticEvent($00be48392311af6a$var$FocusEventInterface), $00be48392311af6a$var$AnimationEventInterface = $00be48392311af6a$var$assign({}, $00be48392311af6a$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $00be48392311af6a$var$SyntheticAnimationEvent = $00be48392311af6a$var$createSyntheticEvent($00be48392311af6a$var$AnimationEventInterface), $00be48392311af6a$var$ClipboardEventInterface = $00be48392311af6a$var$assign({}, $00be48392311af6a$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $00be48392311af6a$var$SyntheticClipboardEvent = $00be48392311af6a$var$createSyntheticEvent($00be48392311af6a$var$ClipboardEventInterface), $00be48392311af6a$var$CompositionEventInterface = $00be48392311af6a$var$assign({}, $00be48392311af6a$var$EventInterface, {
    data: 0
}), $00be48392311af6a$var$SyntheticCompositionEvent = $00be48392311af6a$var$createSyntheticEvent($00be48392311af6a$var$CompositionEventInterface), $00be48392311af6a$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $00be48392311af6a$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $00be48392311af6a$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $00be48392311af6a$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $00be48392311af6a$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $00be48392311af6a$var$getEventModifierState() {
    return $00be48392311af6a$var$modifierStateGetter;
}
var $00be48392311af6a$var$KeyboardEventInterface = $00be48392311af6a$var$assign({}, $00be48392311af6a$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $00be48392311af6a$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $00be48392311af6a$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $00be48392311af6a$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $00be48392311af6a$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $00be48392311af6a$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $00be48392311af6a$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $00be48392311af6a$var$SyntheticKeyboardEvent = $00be48392311af6a$var$createSyntheticEvent($00be48392311af6a$var$KeyboardEventInterface), $00be48392311af6a$var$PointerEventInterface = $00be48392311af6a$var$assign({}, $00be48392311af6a$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $00be48392311af6a$var$SyntheticPointerEvent = $00be48392311af6a$var$createSyntheticEvent($00be48392311af6a$var$PointerEventInterface), $00be48392311af6a$var$SubmitEventInterface = $00be48392311af6a$var$assign({}, $00be48392311af6a$var$EventInterface, {
    submitter: 0
}), $00be48392311af6a$var$SyntheticSubmitEvent = $00be48392311af6a$var$createSyntheticEvent($00be48392311af6a$var$SubmitEventInterface), $00be48392311af6a$var$TouchEventInterface = $00be48392311af6a$var$assign({}, $00be48392311af6a$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $00be48392311af6a$var$getEventModifierState
}), $00be48392311af6a$var$SyntheticTouchEvent = $00be48392311af6a$var$createSyntheticEvent($00be48392311af6a$var$TouchEventInterface), $00be48392311af6a$var$TransitionEventInterface = $00be48392311af6a$var$assign({}, $00be48392311af6a$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $00be48392311af6a$var$SyntheticTransitionEvent = $00be48392311af6a$var$createSyntheticEvent($00be48392311af6a$var$TransitionEventInterface), $00be48392311af6a$var$WheelEventInterface = $00be48392311af6a$var$assign({}, $00be48392311af6a$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $00be48392311af6a$var$SyntheticWheelEvent = $00be48392311af6a$var$createSyntheticEvent($00be48392311af6a$var$WheelEventInterface), $00be48392311af6a$var$ToggleEventInterface = $00be48392311af6a$var$assign({}, $00be48392311af6a$var$EventInterface, {
    newState: 0,
    oldState: 0,
    source: 0
}), $00be48392311af6a$var$SyntheticToggleEvent = $00be48392311af6a$var$createSyntheticEvent($00be48392311af6a$var$ToggleEventInterface), $00be48392311af6a$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $00be48392311af6a$var$canUseCompositionEvent = $00be48392311af6a$var$canUseDOM && "CompositionEvent" in window, $00be48392311af6a$var$documentMode = null;
$00be48392311af6a$var$canUseDOM && "documentMode" in document && ($00be48392311af6a$var$documentMode = document.documentMode);
var $00be48392311af6a$var$canUseTextInputEvent = $00be48392311af6a$var$canUseDOM && "TextEvent" in window && !$00be48392311af6a$var$documentMode, $00be48392311af6a$var$useFallbackCompositionData = $00be48392311af6a$var$canUseDOM && (!$00be48392311af6a$var$canUseCompositionEvent || $00be48392311af6a$var$documentMode && 8 < $00be48392311af6a$var$documentMode && 11 >= $00be48392311af6a$var$documentMode), $00be48392311af6a$var$SPACEBAR_CHAR = String.fromCharCode(32), $00be48392311af6a$var$hasSpaceKeypress = !1;
function $00be48392311af6a$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $00be48392311af6a$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $00be48392311af6a$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $00be48392311af6a$var$isComposing = !1;
function $00be48392311af6a$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $00be48392311af6a$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $00be48392311af6a$var$hasSpaceKeypress = !0;
            return $00be48392311af6a$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $00be48392311af6a$var$SPACEBAR_CHAR && $00be48392311af6a$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $00be48392311af6a$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($00be48392311af6a$var$isComposing) return "compositionend" === domEventName || !$00be48392311af6a$var$canUseCompositionEvent && $00be48392311af6a$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $00be48392311af6a$var$getData(), $00be48392311af6a$var$fallbackText = $00be48392311af6a$var$startText = $00be48392311af6a$var$root = null, $00be48392311af6a$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $00be48392311af6a$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $00be48392311af6a$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $00be48392311af6a$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$00be48392311af6a$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $00be48392311af6a$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $00be48392311af6a$var$restoreTarget ? $00be48392311af6a$var$restoreQueue ? $00be48392311af6a$var$restoreQueue.push(target) : $00be48392311af6a$var$restoreQueue = [
        target
    ] : $00be48392311af6a$var$restoreTarget = target;
    inst = $00be48392311af6a$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $00be48392311af6a$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $00be48392311af6a$var$activeElement$1 = null, $00be48392311af6a$var$activeElementInst$1 = null;
function $00be48392311af6a$var$runEventInBatch(dispatchQueue) {
    $00be48392311af6a$var$processDispatchQueue(dispatchQueue, 0);
}
function $00be48392311af6a$var$getInstIfValueChanged(targetInst) {
    var targetNode = $00be48392311af6a$var$getNodeFromInstance(targetInst);
    if ($00be48392311af6a$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $00be48392311af6a$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $00be48392311af6a$var$isInputEventSupported = !1;
if ($00be48392311af6a$var$canUseDOM) {
    var $00be48392311af6a$var$JSCompiler_inline_result$jscomp$318;
    if ($00be48392311af6a$var$canUseDOM) {
        var $00be48392311af6a$var$isSupported$jscomp$inline_474 = "oninput" in document;
        if (!$00be48392311af6a$var$isSupported$jscomp$inline_474) {
            var $00be48392311af6a$var$element$jscomp$inline_475 = document.createElement("div");
            $00be48392311af6a$var$element$jscomp$inline_475.setAttribute("oninput", "return;");
            $00be48392311af6a$var$isSupported$jscomp$inline_474 = "function" === typeof $00be48392311af6a$var$element$jscomp$inline_475.oninput;
        }
        $00be48392311af6a$var$JSCompiler_inline_result$jscomp$318 = $00be48392311af6a$var$isSupported$jscomp$inline_474;
    } else $00be48392311af6a$var$JSCompiler_inline_result$jscomp$318 = !1;
    $00be48392311af6a$var$isInputEventSupported = $00be48392311af6a$var$JSCompiler_inline_result$jscomp$318 && (!document.documentMode || 9 < document.documentMode);
}
function $00be48392311af6a$var$stopWatchingForValueChange() {
    $00be48392311af6a$var$activeElement$1 && ($00be48392311af6a$var$activeElement$1.detachEvent("onpropertychange", $00be48392311af6a$var$handlePropertyChange), $00be48392311af6a$var$activeElementInst$1 = $00be48392311af6a$var$activeElement$1 = null);
}
function $00be48392311af6a$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $00be48392311af6a$var$getInstIfValueChanged($00be48392311af6a$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $00be48392311af6a$var$createAndAccumulateChangeEvent(dispatchQueue, $00be48392311af6a$var$activeElementInst$1, nativeEvent, $00be48392311af6a$var$getEventTarget(nativeEvent));
        $00be48392311af6a$var$batchedUpdates$1($00be48392311af6a$var$runEventInBatch, dispatchQueue);
    }
}
function $00be48392311af6a$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($00be48392311af6a$var$stopWatchingForValueChange(), $00be48392311af6a$var$activeElement$1 = target, $00be48392311af6a$var$activeElementInst$1 = targetInst, $00be48392311af6a$var$activeElement$1.attachEvent("onpropertychange", $00be48392311af6a$var$handlePropertyChange)) : "focusout" === domEventName && $00be48392311af6a$var$stopWatchingForValueChange();
}
function $00be48392311af6a$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $00be48392311af6a$var$getInstIfValueChanged($00be48392311af6a$var$activeElementInst$1);
}
function $00be48392311af6a$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $00be48392311af6a$var$getInstIfValueChanged(targetInst);
}
function $00be48392311af6a$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $00be48392311af6a$var$getInstIfValueChanged(targetInst);
}
function $00be48392311af6a$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $00be48392311af6a$var$objectIs = "function" === typeof Object.is ? Object.is : $00be48392311af6a$var$is;
function $00be48392311af6a$var$shallowEqual(objA, objB) {
    if ($00be48392311af6a$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$00be48392311af6a$var$hasOwnProperty.call(objB, currentKey) || !$00be48392311af6a$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $00be48392311af6a$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e$20) {
        return doc.body;
    }
}
function $00be48392311af6a$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $00be48392311af6a$var$getNodeForCharacterOffset(root, offset) {
    var node = $00be48392311af6a$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $00be48392311af6a$var$getLeafNode(node);
    }
}
function $00be48392311af6a$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $00be48392311af6a$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $00be48392311af6a$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $00be48392311af6a$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $00be48392311af6a$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $00be48392311af6a$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $00be48392311af6a$var$skipSelectionChangeEvent = $00be48392311af6a$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $00be48392311af6a$var$activeElement = null, $00be48392311af6a$var$activeElementInst = null, $00be48392311af6a$var$lastSelection = null, $00be48392311af6a$var$mouseDown = !1;
function $00be48392311af6a$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $00be48392311af6a$var$mouseDown || null == $00be48392311af6a$var$activeElement || $00be48392311af6a$var$activeElement !== $00be48392311af6a$var$getActiveElement(doc) || (doc = $00be48392311af6a$var$activeElement, "selectionStart" in doc && $00be48392311af6a$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $00be48392311af6a$var$lastSelection && $00be48392311af6a$var$shallowEqual($00be48392311af6a$var$lastSelection, doc) || ($00be48392311af6a$var$lastSelection = doc, doc = $00be48392311af6a$var$accumulateTwoPhaseListeners($00be48392311af6a$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $00be48392311af6a$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $00be48392311af6a$var$activeElement)));
}
function $00be48392311af6a$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $00be48392311af6a$var$vendorPrefixes = {
    animationend: $00be48392311af6a$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $00be48392311af6a$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $00be48392311af6a$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $00be48392311af6a$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $00be48392311af6a$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $00be48392311af6a$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $00be48392311af6a$var$makePrefixMap("Transition", "TransitionEnd")
}, $00be48392311af6a$var$prefixedEventNames = {}, $00be48392311af6a$var$style = {};
$00be48392311af6a$var$canUseDOM && ($00be48392311af6a$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $00be48392311af6a$var$vendorPrefixes.animationend.animation, delete $00be48392311af6a$var$vendorPrefixes.animationiteration.animation, delete $00be48392311af6a$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $00be48392311af6a$var$vendorPrefixes.transitionend.transition);
function $00be48392311af6a$var$getVendorPrefixedEventName(eventName) {
    if ($00be48392311af6a$var$prefixedEventNames[eventName]) return $00be48392311af6a$var$prefixedEventNames[eventName];
    if (!$00be48392311af6a$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $00be48392311af6a$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $00be48392311af6a$var$style) return $00be48392311af6a$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $00be48392311af6a$var$ANIMATION_END = $00be48392311af6a$var$getVendorPrefixedEventName("animationend"), $00be48392311af6a$var$ANIMATION_ITERATION = $00be48392311af6a$var$getVendorPrefixedEventName("animationiteration"), $00be48392311af6a$var$ANIMATION_START = $00be48392311af6a$var$getVendorPrefixedEventName("animationstart"), $00be48392311af6a$var$TRANSITION_RUN = $00be48392311af6a$var$getVendorPrefixedEventName("transitionrun"), $00be48392311af6a$var$TRANSITION_START = $00be48392311af6a$var$getVendorPrefixedEventName("transitionstart"), $00be48392311af6a$var$TRANSITION_CANCEL = $00be48392311af6a$var$getVendorPrefixedEventName("transitioncancel"), $00be48392311af6a$var$TRANSITION_END = $00be48392311af6a$var$getVendorPrefixedEventName("transitionend"), $00be48392311af6a$var$topLevelEventsToReactNames = new Map(), $00be48392311af6a$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error fullscreenChange fullscreenError gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$00be48392311af6a$var$simpleEventPluginEvents.push("scrollEnd");
function $00be48392311af6a$var$registerSimpleEvent(domEventName, reactName) {
    $00be48392311af6a$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $00be48392311af6a$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $00be48392311af6a$var$globalClientIdCounter$1 = 0;
function $00be48392311af6a$var$getViewTransitionName(props, instance) {
    if (null != props.name && "auto" !== props.name) return props.name;
    if (null !== instance.autoName) return instance.autoName;
    props = $00be48392311af6a$var$pendingEffectsRoot.identifierPrefix;
    var globalClientId = $00be48392311af6a$var$globalClientIdCounter$1++;
    props = "_" + props + "t_" + globalClientId.toString(32) + "_";
    return instance.autoName = props;
}
function $00be48392311af6a$var$getClassNameByType(classByType) {
    if (null == classByType || "string" === typeof classByType) return classByType;
    var className = null, activeTypes = $00be48392311af6a$var$pendingTransitionTypes;
    if (null !== activeTypes) for(var i = 0; i < activeTypes.length; i++){
        var match = classByType[activeTypes[i]];
        if (null != match) {
            if ("none" === match) return "none";
            className = null == className ? match : className + (" " + match);
        }
    }
    return null == className ? classByType.default : className;
}
function $00be48392311af6a$var$getViewTransitionClassName(defaultClass, eventClass) {
    defaultClass = $00be48392311af6a$var$getClassNameByType(defaultClass);
    eventClass = $00be48392311af6a$var$getClassNameByType(eventClass);
    return null == eventClass ? "auto" === defaultClass ? null : defaultClass : "auto" === eventClass ? null : eventClass;
}
var $00be48392311af6a$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $00be48392311af6a$var$concurrentQueues = [], $00be48392311af6a$var$concurrentQueuesIndex = 0, $00be48392311af6a$var$concurrentlyUpdatedLanes = 0;
function $00be48392311af6a$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $00be48392311af6a$var$concurrentQueuesIndex, i = $00be48392311af6a$var$concurrentlyUpdatedLanes = $00be48392311af6a$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $00be48392311af6a$var$concurrentQueues[i];
        $00be48392311af6a$var$concurrentQueues[i++] = null;
        var queue = $00be48392311af6a$var$concurrentQueues[i];
        $00be48392311af6a$var$concurrentQueues[i++] = null;
        var update = $00be48392311af6a$var$concurrentQueues[i];
        $00be48392311af6a$var$concurrentQueues[i++] = null;
        var lane = $00be48392311af6a$var$concurrentQueues[i];
        $00be48392311af6a$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $00be48392311af6a$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $00be48392311af6a$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $00be48392311af6a$var$concurrentQueues[$00be48392311af6a$var$concurrentQueuesIndex++] = fiber;
    $00be48392311af6a$var$concurrentQueues[$00be48392311af6a$var$concurrentQueuesIndex++] = queue;
    $00be48392311af6a$var$concurrentQueues[$00be48392311af6a$var$concurrentQueuesIndex++] = update;
    $00be48392311af6a$var$concurrentQueues[$00be48392311af6a$var$concurrentQueuesIndex++] = lane;
    $00be48392311af6a$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $00be48392311af6a$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $00be48392311af6a$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $00be48392311af6a$var$getRootForUpdatedFiber(fiber);
}
function $00be48392311af6a$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $00be48392311af6a$var$enqueueUpdate$1(fiber, null, null, lane);
    return $00be48392311af6a$var$getRootForUpdatedFiber(fiber);
}
function $00be48392311af6a$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $00be48392311af6a$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $00be48392311af6a$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $00be48392311af6a$var$nestedUpdateCount) throw $00be48392311af6a$var$nestedUpdateCount = 0, $00be48392311af6a$var$rootWithNestedUpdates = null, Error($00be48392311af6a$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $00be48392311af6a$var$emptyContextObject = {};
function $00be48392311af6a$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $00be48392311af6a$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $00be48392311af6a$var$FiberNode(tag, pendingProps, key, mode);
}
function $00be48392311af6a$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $00be48392311af6a$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $00be48392311af6a$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 1206910976;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $00be48392311af6a$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 1206910978;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $00be48392311af6a$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof owner) $00be48392311af6a$var$shouldConstruct(owner) && (fiberTag = 1);
    else if ("string" === typeof owner) fiberTag = $00be48392311af6a$var$isHostHoistableType(type, pendingProps, $00be48392311af6a$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(owner){
        case $00be48392311af6a$var$REACT_ACTIVITY_TYPE:
            return type = $00be48392311af6a$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $00be48392311af6a$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $00be48392311af6a$var$REACT_FRAGMENT_TYPE:
            return $00be48392311af6a$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $00be48392311af6a$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $00be48392311af6a$var$REACT_PROFILER_TYPE:
            return type = $00be48392311af6a$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $00be48392311af6a$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $00be48392311af6a$var$REACT_SUSPENSE_TYPE:
            return type = $00be48392311af6a$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $00be48392311af6a$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $00be48392311af6a$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $00be48392311af6a$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $00be48392311af6a$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        case $00be48392311af6a$var$REACT_LEGACY_HIDDEN_TYPE:
        case $00be48392311af6a$var$REACT_VIEW_TRANSITION_TYPE:
            return type = mode | 32, type = $00be48392311af6a$var$createFiberImplClass(30, pendingProps, key, type), type.elementType = $00be48392311af6a$var$REACT_VIEW_TRANSITION_TYPE, type.lanes = lanes, type.stateNode = {
                autoName: null,
                paired: null,
                clones: null,
                ref: null
            }, type;
        default:
            if ("object" === typeof owner && null !== owner) switch(owner.$$typeof){
                case $00be48392311af6a$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $00be48392311af6a$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $00be48392311af6a$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $00be48392311af6a$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $00be48392311af6a$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($00be48392311af6a$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $00be48392311af6a$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $00be48392311af6a$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $00be48392311af6a$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $00be48392311af6a$var$createFiberFromText(content, mode, lanes) {
    content = $00be48392311af6a$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $00be48392311af6a$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $00be48392311af6a$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $00be48392311af6a$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $00be48392311af6a$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $00be48392311af6a$var$CapturedStacks = new WeakMap();
function $00be48392311af6a$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $00be48392311af6a$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $00be48392311af6a$var$getStackByFiberInDevAndProd(source)
        };
        $00be48392311af6a$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $00be48392311af6a$var$getStackByFiberInDevAndProd(source)
    };
}
var $00be48392311af6a$var$forkStack = [], $00be48392311af6a$var$forkStackIndex = 0, $00be48392311af6a$var$treeForkProvider = null, $00be48392311af6a$var$treeForkCount = 0, $00be48392311af6a$var$idStack = [], $00be48392311af6a$var$idStackIndex = 0, $00be48392311af6a$var$treeContextProvider = null, $00be48392311af6a$var$treeContextId = 1, $00be48392311af6a$var$treeContextOverflow = "";
function $00be48392311af6a$var$pushTreeFork(workInProgress, totalChildren) {
    $00be48392311af6a$var$forkStack[$00be48392311af6a$var$forkStackIndex++] = $00be48392311af6a$var$treeForkCount;
    $00be48392311af6a$var$forkStack[$00be48392311af6a$var$forkStackIndex++] = $00be48392311af6a$var$treeForkProvider;
    $00be48392311af6a$var$treeForkProvider = workInProgress;
    $00be48392311af6a$var$treeForkCount = totalChildren;
}
function $00be48392311af6a$var$pushTreeId(workInProgress, totalChildren, index) {
    $00be48392311af6a$var$idStack[$00be48392311af6a$var$idStackIndex++] = $00be48392311af6a$var$treeContextId;
    $00be48392311af6a$var$idStack[$00be48392311af6a$var$idStackIndex++] = $00be48392311af6a$var$treeContextOverflow;
    $00be48392311af6a$var$idStack[$00be48392311af6a$var$idStackIndex++] = $00be48392311af6a$var$treeContextProvider;
    $00be48392311af6a$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $00be48392311af6a$var$treeContextId;
    workInProgress = $00be48392311af6a$var$treeContextOverflow;
    var baseLength = 32 - $00be48392311af6a$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $00be48392311af6a$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $00be48392311af6a$var$treeContextId = 1 << 32 - $00be48392311af6a$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $00be48392311af6a$var$treeContextOverflow = length + workInProgress;
    } else $00be48392311af6a$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $00be48392311af6a$var$treeContextOverflow = workInProgress;
}
function $00be48392311af6a$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($00be48392311af6a$var$pushTreeFork(workInProgress, 1), $00be48392311af6a$var$pushTreeId(workInProgress, 1, 0));
}
function $00be48392311af6a$var$popTreeContext(workInProgress) {
    for(; workInProgress === $00be48392311af6a$var$treeForkProvider;)$00be48392311af6a$var$treeForkProvider = $00be48392311af6a$var$forkStack[--$00be48392311af6a$var$forkStackIndex], $00be48392311af6a$var$forkStack[$00be48392311af6a$var$forkStackIndex] = null, $00be48392311af6a$var$treeForkCount = $00be48392311af6a$var$forkStack[--$00be48392311af6a$var$forkStackIndex], $00be48392311af6a$var$forkStack[$00be48392311af6a$var$forkStackIndex] = null;
    for(; workInProgress === $00be48392311af6a$var$treeContextProvider;)$00be48392311af6a$var$treeContextProvider = $00be48392311af6a$var$idStack[--$00be48392311af6a$var$idStackIndex], $00be48392311af6a$var$idStack[$00be48392311af6a$var$idStackIndex] = null, $00be48392311af6a$var$treeContextOverflow = $00be48392311af6a$var$idStack[--$00be48392311af6a$var$idStackIndex], $00be48392311af6a$var$idStack[$00be48392311af6a$var$idStackIndex] = null, $00be48392311af6a$var$treeContextId = $00be48392311af6a$var$idStack[--$00be48392311af6a$var$idStackIndex], $00be48392311af6a$var$idStack[$00be48392311af6a$var$idStackIndex] = null;
}
function $00be48392311af6a$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $00be48392311af6a$var$idStack[$00be48392311af6a$var$idStackIndex++] = $00be48392311af6a$var$treeContextId;
    $00be48392311af6a$var$idStack[$00be48392311af6a$var$idStackIndex++] = $00be48392311af6a$var$treeContextOverflow;
    $00be48392311af6a$var$idStack[$00be48392311af6a$var$idStackIndex++] = $00be48392311af6a$var$treeContextProvider;
    $00be48392311af6a$var$treeContextId = suspendedContext.id;
    $00be48392311af6a$var$treeContextOverflow = suspendedContext.overflow;
    $00be48392311af6a$var$treeContextProvider = workInProgress;
}
var $00be48392311af6a$var$hydrationParentFiber = null, $00be48392311af6a$var$nextHydratableInstance = null, $00be48392311af6a$var$isHydrating = !1, $00be48392311af6a$var$hydrationErrors = null, $00be48392311af6a$var$rootOrSingletonContext = !1, $00be48392311af6a$var$HydrationMismatchException = Error($00be48392311af6a$var$formatProdErrorMessage(519));
function $00be48392311af6a$var$throwOnHydrationMismatch(fiber) {
    var error = Error($00be48392311af6a$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $00be48392311af6a$var$queueHydrationError($00be48392311af6a$var$createCapturedValueAtFiber(error, fiber));
    throw $00be48392311af6a$var$HydrationMismatchException;
}
function $00be48392311af6a$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$00be48392311af6a$var$internalInstanceKey] = fiber;
    instance[$00be48392311af6a$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $00be48392311af6a$var$listenToNonDelegatedEvent("cancel", instance);
            $00be48392311af6a$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $00be48392311af6a$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $00be48392311af6a$var$mediaEventTypes.length; type++)$00be48392311af6a$var$listenToNonDelegatedEvent($00be48392311af6a$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $00be48392311af6a$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $00be48392311af6a$var$listenToNonDelegatedEvent("error", instance);
            $00be48392311af6a$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $00be48392311af6a$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $00be48392311af6a$var$listenToNonDelegatedEvent("invalid", instance);
            $00be48392311af6a$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $00be48392311af6a$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $00be48392311af6a$var$listenToNonDelegatedEvent("invalid", instance), $00be48392311af6a$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $00be48392311af6a$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($00be48392311af6a$var$listenToNonDelegatedEvent("beforetoggle", instance), $00be48392311af6a$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $00be48392311af6a$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $00be48392311af6a$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $00be48392311af6a$var$noop$1), instance = !0) : instance = !1;
    instance || $00be48392311af6a$var$throwOnHydrationMismatch(fiber, !0);
}
function $00be48392311af6a$var$popToNextHostParent(fiber) {
    for($00be48392311af6a$var$hydrationParentFiber = fiber.return; $00be48392311af6a$var$hydrationParentFiber;)switch($00be48392311af6a$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $00be48392311af6a$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $00be48392311af6a$var$rootOrSingletonContext = !0;
            return;
        default:
            $00be48392311af6a$var$hydrationParentFiber = $00be48392311af6a$var$hydrationParentFiber.return;
    }
}
function $00be48392311af6a$var$popHydrationState(fiber) {
    if (fiber !== $00be48392311af6a$var$hydrationParentFiber) return !1;
    if (!$00be48392311af6a$var$isHydrating) return $00be48392311af6a$var$popToNextHostParent(fiber), $00be48392311af6a$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $00be48392311af6a$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $00be48392311af6a$var$nextHydratableInstance && $00be48392311af6a$var$throwOnHydrationMismatch(fiber);
    $00be48392311af6a$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($00be48392311af6a$var$formatProdErrorMessage(317));
        $00be48392311af6a$var$nextHydratableInstance = $00be48392311af6a$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($00be48392311af6a$var$formatProdErrorMessage(317));
        $00be48392311af6a$var$nextHydratableInstance = $00be48392311af6a$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $00be48392311af6a$var$nextHydratableInstance, $00be48392311af6a$var$isSingletonScope(fiber.type) ? (fiber = $00be48392311af6a$var$previousHydratableOnEnteringScopedSingleton, $00be48392311af6a$var$previousHydratableOnEnteringScopedSingleton = null, $00be48392311af6a$var$nextHydratableInstance = fiber) : $00be48392311af6a$var$nextHydratableInstance = tag) : $00be48392311af6a$var$nextHydratableInstance = $00be48392311af6a$var$hydrationParentFiber ? $00be48392311af6a$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $00be48392311af6a$var$resetHydrationState() {
    $00be48392311af6a$var$nextHydratableInstance = $00be48392311af6a$var$hydrationParentFiber = null;
    $00be48392311af6a$var$isHydrating = !1;
}
function $00be48392311af6a$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $00be48392311af6a$var$hydrationErrors;
    null !== queuedErrors && (null === $00be48392311af6a$var$workInProgressRootRecoverableErrors ? $00be48392311af6a$var$workInProgressRootRecoverableErrors = queuedErrors : $00be48392311af6a$var$workInProgressRootRecoverableErrors.push.apply($00be48392311af6a$var$workInProgressRootRecoverableErrors, queuedErrors), $00be48392311af6a$var$hydrationErrors = null);
    return queuedErrors;
}
function $00be48392311af6a$var$queueHydrationError(error) {
    null === $00be48392311af6a$var$hydrationErrors ? $00be48392311af6a$var$hydrationErrors = [
        error
    ] : $00be48392311af6a$var$hydrationErrors.push(error);
}
var $00be48392311af6a$var$valueCursor = $00be48392311af6a$var$createCursor(null), $00be48392311af6a$var$currentlyRenderingFiber$1 = null, $00be48392311af6a$var$lastContextDependency = null;
function $00be48392311af6a$var$pushProvider(providerFiber, context, nextValue) {
    $00be48392311af6a$var$push($00be48392311af6a$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $00be48392311af6a$var$popProvider(context) {
    context._currentValue = $00be48392311af6a$var$valueCursor.current;
    $00be48392311af6a$var$pop($00be48392311af6a$var$valueCursor);
}
function $00be48392311af6a$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $00be48392311af6a$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $00be48392311af6a$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($00be48392311af6a$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $00be48392311af6a$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else 13 === fiber.tag && null !== fiber.memoizedState && null === fiber.memoizedState.dehydrated ? (fiber.lanes |= renderLanes, nextFiber = fiber.alternate, null !== nextFiber && (nextFiber.lanes |= renderLanes), $00be48392311af6a$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, workInProgress), nextFiber = fiber.child, nextFiber = null !== nextFiber ? nextFiber.sibling : null) : nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $00be48392311af6a$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($00be48392311af6a$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $00be48392311af6a$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $00be48392311af6a$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($00be48392311af6a$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($00be48392311af6a$var$HostTransitionContext) : current = [
                $00be48392311af6a$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $00be48392311af6a$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
    return null !== current;
}
function $00be48392311af6a$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$00be48392311af6a$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $00be48392311af6a$var$prepareToReadContext(workInProgress) {
    $00be48392311af6a$var$currentlyRenderingFiber$1 = workInProgress;
    $00be48392311af6a$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $00be48392311af6a$var$readContext(context) {
    return $00be48392311af6a$var$readContextForConsumer($00be48392311af6a$var$currentlyRenderingFiber$1, context);
}
function $00be48392311af6a$var$readContextDuringReconciliation(consumer, context) {
    null === $00be48392311af6a$var$currentlyRenderingFiber$1 && $00be48392311af6a$var$prepareToReadContext(consumer);
    return $00be48392311af6a$var$readContextForConsumer(consumer, context);
}
function $00be48392311af6a$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $00be48392311af6a$var$lastContextDependency) {
        if (null === consumer) throw Error($00be48392311af6a$var$formatProdErrorMessage(308));
        $00be48392311af6a$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $00be48392311af6a$var$lastContextDependency = $00be48392311af6a$var$lastContextDependency.next = context;
    return value;
}
var $00be48392311af6a$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $00be48392311af6a$var$scheduleCallback$2 = $6XCI2.unstable_scheduleCallback, $00be48392311af6a$var$NormalPriority = $6XCI2.unstable_NormalPriority, $00be48392311af6a$var$CacheContext = {
    $$typeof: $00be48392311af6a$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $00be48392311af6a$var$createCache() {
    return {
        controller: new $00be48392311af6a$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $00be48392311af6a$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $00be48392311af6a$var$scheduleCallback$2($00be48392311af6a$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
function $00be48392311af6a$var$queueTransitionTypes(root, transitionTypes) {
    if (0 !== (root.pendingLanes & 4194048)) {
        var queued = root.transitionTypes;
        null === queued && (queued = root.transitionTypes = []);
        for(root = 0; root < transitionTypes.length; root++){
            var transitionType = transitionTypes[root];
            -1 === queued.indexOf(transitionType) && queued.push(transitionType);
        }
    }
}
var $00be48392311af6a$var$entangledTransitionTypes = null;
function $00be48392311af6a$var$claimQueuedTransitionTypes(root) {
    var claimed = root.transitionTypes;
    root.transitionTypes = null;
    return claimed;
}
var $00be48392311af6a$var$currentEntangledListeners = null, $00be48392311af6a$var$currentEntangledPendingCount = 0, $00be48392311af6a$var$currentEntangledLane = 0, $00be48392311af6a$var$currentEntangledActionThenable = null;
function $00be48392311af6a$var$entangleAsyncAction(transition, thenable) {
    if (null === $00be48392311af6a$var$currentEntangledListeners) {
        var entangledListeners = $00be48392311af6a$var$currentEntangledListeners = [];
        $00be48392311af6a$var$currentEntangledPendingCount = 0;
        $00be48392311af6a$var$currentEntangledLane = $00be48392311af6a$var$requestTransitionLane();
        $00be48392311af6a$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $00be48392311af6a$var$currentEntangledPendingCount++;
    thenable.then($00be48392311af6a$var$pingEngtangledActionScope, $00be48392311af6a$var$pingEngtangledActionScope);
    return thenable;
}
function $00be48392311af6a$var$pingEngtangledActionScope() {
    if (0 === --$00be48392311af6a$var$currentEntangledPendingCount && ($00be48392311af6a$var$entangledTransitionTypes = null, null !== $00be48392311af6a$var$currentEntangledListeners)) {
        null !== $00be48392311af6a$var$currentEntangledActionThenable && ($00be48392311af6a$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $00be48392311af6a$var$currentEntangledListeners;
        $00be48392311af6a$var$currentEntangledListeners = null;
        $00be48392311af6a$var$currentEntangledLane = 0;
        $00be48392311af6a$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $00be48392311af6a$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $00be48392311af6a$var$prevOnStartTransitionFinish = $00be48392311af6a$var$ReactSharedInternals.S;
$00be48392311af6a$var$ReactSharedInternals.S = function(transition, returnValue) {
    $00be48392311af6a$var$globalMostRecentTransitionTime = $00be48392311af6a$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $00be48392311af6a$var$entangleAsyncAction(transition, returnValue);
    if (null !== $00be48392311af6a$var$entangledTransitionTypes) for(var root$28 = $00be48392311af6a$var$firstScheduledRoot; null !== root$28;)$00be48392311af6a$var$queueTransitionTypes(root$28, $00be48392311af6a$var$entangledTransitionTypes), root$28 = root$28.next;
    root$28 = transition.types;
    if (null !== root$28) {
        for(var root$29 = $00be48392311af6a$var$firstScheduledRoot; null !== root$29;)$00be48392311af6a$var$queueTransitionTypes(root$29, root$28), root$29 = root$29.next;
        if (0 !== $00be48392311af6a$var$currentEntangledLane) {
            root$29 = $00be48392311af6a$var$entangledTransitionTypes;
            null === root$29 && (root$29 = $00be48392311af6a$var$entangledTransitionTypes = []);
            for(var i = 0; i < root$28.length; i++){
                var transitionType = root$28[i];
                -1 === root$29.indexOf(transitionType) && root$29.push(transitionType);
            }
        }
    }
    null !== $00be48392311af6a$var$prevOnStartTransitionFinish && $00be48392311af6a$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $00be48392311af6a$var$resumedCache = $00be48392311af6a$var$createCursor(null);
function $00be48392311af6a$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $00be48392311af6a$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $00be48392311af6a$var$workInProgressRoot.pooledCache;
}
function $00be48392311af6a$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $00be48392311af6a$var$push($00be48392311af6a$var$resumedCache, $00be48392311af6a$var$resumedCache.current) : $00be48392311af6a$var$push($00be48392311af6a$var$resumedCache, prevCachePool.pool);
}
function $00be48392311af6a$var$getSuspendedCache() {
    var cacheFromPool = $00be48392311af6a$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $00be48392311af6a$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $00be48392311af6a$var$SuspenseException = Error($00be48392311af6a$var$formatProdErrorMessage(460)), $00be48392311af6a$var$SuspenseyCommitException = Error($00be48392311af6a$var$formatProdErrorMessage(474)), $00be48392311af6a$var$SuspenseActionException = Error($00be48392311af6a$var$formatProdErrorMessage(542)), $00be48392311af6a$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $00be48392311af6a$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $00be48392311af6a$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($00be48392311af6a$var$noop$1, $00be48392311af6a$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            thenableState = thenable.reason;
            $00be48392311af6a$var$checkIfUseWrappedInAsyncCatch(thenableState);
            if (void 0 === thenableState && !("reason" in thenable)) throw Error($00be48392311af6a$var$formatProdErrorMessage(600));
            throw thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($00be48392311af6a$var$noop$1, $00be48392311af6a$var$noop$1);
            else {
                thenableState = $00be48392311af6a$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($00be48392311af6a$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $00be48392311af6a$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $00be48392311af6a$var$suspendedThenable = thenable;
            throw $00be48392311af6a$var$SuspenseException;
    }
}
function $00be48392311af6a$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $00be48392311af6a$var$suspendedThenable = x, $00be48392311af6a$var$SuspenseException;
        throw x;
    }
}
var $00be48392311af6a$var$suspendedThenable = null;
function $00be48392311af6a$var$getSuspendedThenable() {
    if (null === $00be48392311af6a$var$suspendedThenable) throw Error($00be48392311af6a$var$formatProdErrorMessage(459));
    var thenable = $00be48392311af6a$var$suspendedThenable;
    $00be48392311af6a$var$suspendedThenable = null;
    return thenable;
}
function $00be48392311af6a$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $00be48392311af6a$var$SuspenseException || rejectedReason === $00be48392311af6a$var$SuspenseActionException) throw Error($00be48392311af6a$var$formatProdErrorMessage(483));
}
var $00be48392311af6a$var$thenableState$1 = null, $00be48392311af6a$var$thenableIndexCounter$1 = 0;
function $00be48392311af6a$var$unwrapThenable(thenable) {
    var index = $00be48392311af6a$var$thenableIndexCounter$1;
    $00be48392311af6a$var$thenableIndexCounter$1 += 1;
    null === $00be48392311af6a$var$thenableState$1 && ($00be48392311af6a$var$thenableState$1 = []);
    return $00be48392311af6a$var$trackUsedThenable($00be48392311af6a$var$thenableState$1, thenable, index);
}
function $00be48392311af6a$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $00be48392311af6a$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $00be48392311af6a$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($00be48392311af6a$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($00be48392311af6a$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $00be48392311af6a$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null === currentFirstChild.key ? existingChildren.set(currentFirstChild.index, currentFirstChild) : existingChildren.set(currentFirstChild.key, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $00be48392311af6a$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 2, lastPlacedIndex) : newIndex;
        newFiber.flags |= 134217730;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 134217730);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $00be48392311af6a$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $00be48392311af6a$var$REACT_FRAGMENT_TYPE) return returnFiber = updateFragment(returnFiber, current, element.props.children, lanes, element.key), $00be48392311af6a$var$coerceRef(returnFiber, element), returnFiber;
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $00be48392311af6a$var$REACT_LAZY_TYPE && $00be48392311af6a$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $00be48392311af6a$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $00be48392311af6a$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $00be48392311af6a$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $00be48392311af6a$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $00be48392311af6a$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $00be48392311af6a$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $00be48392311af6a$var$REACT_ELEMENT_TYPE:
                    return lanes = $00be48392311af6a$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $00be48392311af6a$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $00be48392311af6a$var$REACT_PORTAL_TYPE:
                    return newChild = $00be48392311af6a$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $00be48392311af6a$var$REACT_LAZY_TYPE:
                    return newChild = $00be48392311af6a$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($00be48392311af6a$var$isArrayImpl(newChild) || $00be48392311af6a$var$getIteratorFn(newChild)) return newChild = $00be48392311af6a$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $00be48392311af6a$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $00be48392311af6a$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $00be48392311af6a$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $00be48392311af6a$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $00be48392311af6a$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $00be48392311af6a$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $00be48392311af6a$var$REACT_LAZY_TYPE:
                    return newChild = $00be48392311af6a$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($00be48392311af6a$var$isArrayImpl(newChild) || $00be48392311af6a$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $00be48392311af6a$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $00be48392311af6a$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $00be48392311af6a$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $00be48392311af6a$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $00be48392311af6a$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $00be48392311af6a$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $00be48392311af6a$var$REACT_LAZY_TYPE:
                    return newChild = $00be48392311af6a$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($00be48392311af6a$var$isArrayImpl(newChild) || $00be48392311af6a$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $00be48392311af6a$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $00be48392311af6a$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $00be48392311af6a$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $00be48392311af6a$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $00be48392311af6a$var$isHydrating && $00be48392311af6a$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $00be48392311af6a$var$isHydrating && $00be48392311af6a$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && (newFiber = nextOldFiber.alternate, null !== newFiber && oldFiber.delete(null === newFiber.key ? newIdx : newFiber.key)), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $00be48392311af6a$var$isHydrating && $00be48392311af6a$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($00be48392311af6a$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $00be48392311af6a$var$isHydrating && $00be48392311af6a$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $00be48392311af6a$var$isHydrating && $00be48392311af6a$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && (nextOldFiber = step.alternate, null !== nextOldFiber && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key)), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $00be48392311af6a$var$isHydrating && $00be48392311af6a$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $00be48392311af6a$var$REACT_FRAGMENT_TYPE && null === newChild.key && void 0 === newChild.props.ref && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $00be48392311af6a$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $00be48392311af6a$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        $00be48392311af6a$var$coerceRef(lanes, newChild);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $00be48392311af6a$var$REACT_LAZY_TYPE && $00be48392311af6a$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $00be48392311af6a$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $00be48392311af6a$var$REACT_FRAGMENT_TYPE ? (lanes = $00be48392311af6a$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), $00be48392311af6a$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $00be48392311af6a$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $00be48392311af6a$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $00be48392311af6a$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $00be48392311af6a$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $00be48392311af6a$var$REACT_LAZY_TYPE:
                    return newChild = $00be48392311af6a$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($00be48392311af6a$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($00be48392311af6a$var$getIteratorFn(newChild)) {
                key = $00be48392311af6a$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($00be48392311af6a$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $00be48392311af6a$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $00be48392311af6a$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $00be48392311af6a$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $00be48392311af6a$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $00be48392311af6a$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $00be48392311af6a$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $00be48392311af6a$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $00be48392311af6a$var$SuspenseException || x === $00be48392311af6a$var$SuspenseActionException) throw x;
            var fiber = $00be48392311af6a$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $00be48392311af6a$var$reconcileChildFibers = $00be48392311af6a$var$createChildReconciler(!0), $00be48392311af6a$var$mountChildFibers = $00be48392311af6a$var$createChildReconciler(!1), $00be48392311af6a$var$hasForceUpdate = !1;
function $00be48392311af6a$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $00be48392311af6a$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $00be48392311af6a$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $00be48392311af6a$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($00be48392311af6a$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $00be48392311af6a$var$getRootForUpdatedFiber(fiber);
        $00be48392311af6a$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $00be48392311af6a$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $00be48392311af6a$var$getRootForUpdatedFiber(fiber);
}
function $00be48392311af6a$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $00be48392311af6a$var$markRootEntangled(root, lane);
    }
}
function $00be48392311af6a$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $00be48392311af6a$var$didReadFromEntangledAsyncAction = !1;
function $00be48392311af6a$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($00be48392311af6a$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $00be48392311af6a$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $00be48392311af6a$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $00be48392311af6a$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $00be48392311af6a$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($00be48392311af6a$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $00be48392311af6a$var$currentEntangledLane && ($00be48392311af6a$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $00be48392311af6a$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $00be48392311af6a$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $00be48392311af6a$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $00be48392311af6a$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($00be48392311af6a$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $00be48392311af6a$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$00be48392311af6a$var$callCallback(callbacks[updateQueue], context);
}
var $00be48392311af6a$var$currentTreeHiddenStackCursor = $00be48392311af6a$var$createCursor(null), $00be48392311af6a$var$prevEntangledRenderLanesCursor = $00be48392311af6a$var$createCursor(0);
function $00be48392311af6a$var$pushHiddenContext(fiber, context) {
    fiber = $00be48392311af6a$var$entangledRenderLanes;
    $00be48392311af6a$var$push($00be48392311af6a$var$prevEntangledRenderLanesCursor, fiber);
    $00be48392311af6a$var$push($00be48392311af6a$var$currentTreeHiddenStackCursor, context);
    $00be48392311af6a$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $00be48392311af6a$var$reuseHiddenContextOnStack() {
    $00be48392311af6a$var$push($00be48392311af6a$var$prevEntangledRenderLanesCursor, $00be48392311af6a$var$entangledRenderLanes);
    $00be48392311af6a$var$push($00be48392311af6a$var$currentTreeHiddenStackCursor, $00be48392311af6a$var$currentTreeHiddenStackCursor.current);
}
function $00be48392311af6a$var$popHiddenContext() {
    $00be48392311af6a$var$entangledRenderLanes = $00be48392311af6a$var$prevEntangledRenderLanesCursor.current;
    $00be48392311af6a$var$pop($00be48392311af6a$var$currentTreeHiddenStackCursor);
    $00be48392311af6a$var$pop($00be48392311af6a$var$prevEntangledRenderLanesCursor);
}
var $00be48392311af6a$var$suspenseHandlerStackCursor = $00be48392311af6a$var$createCursor(null), $00be48392311af6a$var$shellBoundary = null;
function $00be48392311af6a$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $00be48392311af6a$var$push($00be48392311af6a$var$suspenseStackCursor, $00be48392311af6a$var$suspenseStackCursor.current & 1);
    $00be48392311af6a$var$push($00be48392311af6a$var$suspenseHandlerStackCursor, handler);
    null === $00be48392311af6a$var$shellBoundary && (null === current || null !== $00be48392311af6a$var$currentTreeHiddenStackCursor.current ? $00be48392311af6a$var$shellBoundary = handler : null !== current.memoizedState && ($00be48392311af6a$var$shellBoundary = handler));
}
function $00be48392311af6a$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $00be48392311af6a$var$push($00be48392311af6a$var$suspenseStackCursor, $00be48392311af6a$var$suspenseStackCursor.current);
    $00be48392311af6a$var$push($00be48392311af6a$var$suspenseHandlerStackCursor, fiber);
    null === $00be48392311af6a$var$shellBoundary && ($00be48392311af6a$var$shellBoundary = fiber);
}
function $00be48392311af6a$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($00be48392311af6a$var$push($00be48392311af6a$var$suspenseStackCursor, $00be48392311af6a$var$suspenseStackCursor.current), $00be48392311af6a$var$push($00be48392311af6a$var$suspenseHandlerStackCursor, fiber), null === $00be48392311af6a$var$shellBoundary && ($00be48392311af6a$var$shellBoundary = fiber)) : $00be48392311af6a$var$reuseSuspenseHandlerOnStack();
}
function $00be48392311af6a$var$reuseSuspenseHandlerOnStack() {
    $00be48392311af6a$var$push($00be48392311af6a$var$suspenseStackCursor, $00be48392311af6a$var$suspenseStackCursor.current);
    $00be48392311af6a$var$push($00be48392311af6a$var$suspenseHandlerStackCursor, $00be48392311af6a$var$suspenseHandlerStackCursor.current);
}
function $00be48392311af6a$var$popSuspenseHandler(fiber) {
    $00be48392311af6a$var$pop($00be48392311af6a$var$suspenseHandlerStackCursor);
    $00be48392311af6a$var$shellBoundary === fiber && ($00be48392311af6a$var$shellBoundary = null);
    $00be48392311af6a$var$pop($00be48392311af6a$var$suspenseStackCursor);
}
var $00be48392311af6a$var$suspenseStackCursor = $00be48392311af6a$var$createCursor(0);
function $00be48392311af6a$var$pushSuspenseListContext(fiber, newContext) {
    $00be48392311af6a$var$push($00be48392311af6a$var$suspenseHandlerStackCursor, $00be48392311af6a$var$suspenseHandlerStackCursor.current);
    $00be48392311af6a$var$push($00be48392311af6a$var$suspenseStackCursor, newContext);
}
function $00be48392311af6a$var$popSuspenseListContext(fiber) {
    $00be48392311af6a$var$pop($00be48392311af6a$var$suspenseStackCursor);
    $00be48392311af6a$var$pop($00be48392311af6a$var$suspenseHandlerStackCursor);
    $00be48392311af6a$var$shellBoundary === fiber && ($00be48392311af6a$var$shellBoundary = null);
}
function $00be48392311af6a$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $00be48392311af6a$var$isSuspenseInstancePending(state) || $00be48392311af6a$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && "independent" !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $00be48392311af6a$var$renderLanes = 0, $00be48392311af6a$var$currentlyRenderingFiber = null, $00be48392311af6a$var$currentHook = null, $00be48392311af6a$var$workInProgressHook = null, $00be48392311af6a$var$didScheduleRenderPhaseUpdate = !1, $00be48392311af6a$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $00be48392311af6a$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $00be48392311af6a$var$localIdCounter = 0, $00be48392311af6a$var$thenableIndexCounter = 0, $00be48392311af6a$var$thenableState = null, $00be48392311af6a$var$globalClientIdCounter = 0;
function $00be48392311af6a$var$throwInvalidHookError() {
    throw Error($00be48392311af6a$var$formatProdErrorMessage(321));
}
function $00be48392311af6a$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$00be48392311af6a$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $00be48392311af6a$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $00be48392311af6a$var$renderLanes = nextRenderLanes;
    $00be48392311af6a$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $00be48392311af6a$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $00be48392311af6a$var$HooksDispatcherOnMount : $00be48392311af6a$var$HooksDispatcherOnUpdate;
    $00be48392311af6a$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $00be48392311af6a$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $00be48392311af6a$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $00be48392311af6a$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $00be48392311af6a$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $00be48392311af6a$var$finishRenderingHooks(current) {
    $00be48392311af6a$var$ReactSharedInternals.H = $00be48392311af6a$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $00be48392311af6a$var$currentHook && null !== $00be48392311af6a$var$currentHook.next;
    $00be48392311af6a$var$renderLanes = 0;
    $00be48392311af6a$var$workInProgressHook = $00be48392311af6a$var$currentHook = $00be48392311af6a$var$currentlyRenderingFiber = null;
    $00be48392311af6a$var$didScheduleRenderPhaseUpdate = !1;
    $00be48392311af6a$var$thenableIndexCounter = 0;
    $00be48392311af6a$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($00be48392311af6a$var$formatProdErrorMessage(300));
    null === current || $00be48392311af6a$var$didReceiveUpdate || (current = current.dependencies, null !== current && $00be48392311af6a$var$checkIfContextChanged(current) && ($00be48392311af6a$var$didReceiveUpdate = !0));
}
function $00be48392311af6a$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $00be48392311af6a$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $00be48392311af6a$var$didScheduleRenderPhaseUpdateDuringThisPass && ($00be48392311af6a$var$thenableState = null);
        $00be48392311af6a$var$thenableIndexCounter = 0;
        $00be48392311af6a$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($00be48392311af6a$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $00be48392311af6a$var$workInProgressHook = $00be48392311af6a$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $00be48392311af6a$var$ReactSharedInternals.H = $00be48392311af6a$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($00be48392311af6a$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $00be48392311af6a$var$TransitionAwareHostComponent() {
    var dispatcher = $00be48392311af6a$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $00be48392311af6a$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $00be48392311af6a$var$currentHook ? $00be48392311af6a$var$currentHook.memoizedState : null) !== dispatcher && ($00be48392311af6a$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $00be48392311af6a$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $00be48392311af6a$var$localIdCounter;
    $00be48392311af6a$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $00be48392311af6a$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $00be48392311af6a$var$resetHooksOnUnwind(workInProgress) {
    if ($00be48392311af6a$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $00be48392311af6a$var$didScheduleRenderPhaseUpdate = !1;
    }
    $00be48392311af6a$var$renderLanes = 0;
    $00be48392311af6a$var$workInProgressHook = $00be48392311af6a$var$currentHook = $00be48392311af6a$var$currentlyRenderingFiber = null;
    $00be48392311af6a$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $00be48392311af6a$var$thenableIndexCounter = $00be48392311af6a$var$localIdCounter = 0;
    $00be48392311af6a$var$thenableState = null;
}
function $00be48392311af6a$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $00be48392311af6a$var$workInProgressHook ? $00be48392311af6a$var$currentlyRenderingFiber.memoizedState = $00be48392311af6a$var$workInProgressHook = hook : $00be48392311af6a$var$workInProgressHook = $00be48392311af6a$var$workInProgressHook.next = hook;
    return $00be48392311af6a$var$workInProgressHook;
}
function $00be48392311af6a$var$updateWorkInProgressHook() {
    if (null === $00be48392311af6a$var$currentHook) {
        var nextCurrentHook = $00be48392311af6a$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $00be48392311af6a$var$currentHook.next;
    var nextWorkInProgressHook = null === $00be48392311af6a$var$workInProgressHook ? $00be48392311af6a$var$currentlyRenderingFiber.memoizedState : $00be48392311af6a$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $00be48392311af6a$var$workInProgressHook = nextWorkInProgressHook, $00be48392311af6a$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $00be48392311af6a$var$currentlyRenderingFiber.alternate) throw Error($00be48392311af6a$var$formatProdErrorMessage(467));
            throw Error($00be48392311af6a$var$formatProdErrorMessage(310));
        }
        $00be48392311af6a$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $00be48392311af6a$var$currentHook.memoizedState,
            baseState: $00be48392311af6a$var$currentHook.baseState,
            baseQueue: $00be48392311af6a$var$currentHook.baseQueue,
            queue: $00be48392311af6a$var$currentHook.queue,
            next: null
        };
        null === $00be48392311af6a$var$workInProgressHook ? $00be48392311af6a$var$currentlyRenderingFiber.memoizedState = $00be48392311af6a$var$workInProgressHook = nextCurrentHook : $00be48392311af6a$var$workInProgressHook = $00be48392311af6a$var$workInProgressHook.next = nextCurrentHook;
    }
    return $00be48392311af6a$var$workInProgressHook;
}
function $00be48392311af6a$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $00be48392311af6a$var$useThenable(thenable) {
    var index = $00be48392311af6a$var$thenableIndexCounter;
    $00be48392311af6a$var$thenableIndexCounter += 1;
    null === $00be48392311af6a$var$thenableState && ($00be48392311af6a$var$thenableState = []);
    thenable = $00be48392311af6a$var$trackUsedThenable($00be48392311af6a$var$thenableState, thenable, index);
    index = $00be48392311af6a$var$currentlyRenderingFiber;
    null === (null === $00be48392311af6a$var$workInProgressHook ? index.memoizedState : $00be48392311af6a$var$workInProgressHook.next) && (index = index.alternate, $00be48392311af6a$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $00be48392311af6a$var$HooksDispatcherOnMount : $00be48392311af6a$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $00be48392311af6a$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $00be48392311af6a$var$useThenable(usable);
        if (usable.$$typeof === $00be48392311af6a$var$REACT_RECOVERABLE_TYPE) return;
        if (usable.$$typeof === $00be48392311af6a$var$REACT_CONTEXT_TYPE) return $00be48392311af6a$var$readContext(usable);
    }
    throw Error($00be48392311af6a$var$formatProdErrorMessage(438, String(usable)));
}
function $00be48392311af6a$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $00be48392311af6a$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $00be48392311af6a$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $00be48392311af6a$var$createFunctionComponentUpdateQueue(), $00be48392311af6a$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $00be48392311af6a$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $00be48392311af6a$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $00be48392311af6a$var$updateReducer(reducer) {
    var hook = $00be48392311af6a$var$updateWorkInProgressHook();
    return $00be48392311af6a$var$updateReducerImpl(hook, $00be48392311af6a$var$currentHook, reducer);
}
function $00be48392311af6a$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($00be48392311af6a$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$64 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($00be48392311af6a$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($00be48392311af6a$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $00be48392311af6a$var$currentEntangledLane && (didReadFromEntangledAsyncAction$64 = !0);
                else if (($00be48392311af6a$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $00be48392311af6a$var$currentEntangledLane && (didReadFromEntangledAsyncAction$64 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $00be48392311af6a$var$currentlyRenderingFiber.lanes |= revertLane, $00be48392311af6a$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $00be48392311af6a$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $00be48392311af6a$var$currentlyRenderingFiber.lanes |= updateLane, $00be48392311af6a$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$00be48392311af6a$var$objectIs(pendingQueue, hook.memoizedState) && ($00be48392311af6a$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$64 && (reducer = $00be48392311af6a$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $00be48392311af6a$var$rerenderReducer(reducer) {
    var hook = $00be48392311af6a$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($00be48392311af6a$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $00be48392311af6a$var$objectIs(newState, hook.memoizedState) || ($00be48392311af6a$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $00be48392311af6a$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $00be48392311af6a$var$currentlyRenderingFiber, hook = $00be48392311af6a$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $00be48392311af6a$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($00be48392311af6a$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$00be48392311af6a$var$objectIs(($00be48392311af6a$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $00be48392311af6a$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $00be48392311af6a$var$updateEffect($00be48392311af6a$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    subscribe = hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $00be48392311af6a$var$workInProgressHook && 0 !== ($00be48392311af6a$var$workInProgressHook.memoizedState.tag & 1);
    $00be48392311af6a$var$pushSimpleEffect(subscribe ? 9 : 8, {
        destroy: void 0
    }, $00be48392311af6a$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
    if (subscribe) {
        fiber.flags |= 2048;
        if (null === $00be48392311af6a$var$workInProgressRoot) throw Error($00be48392311af6a$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($00be48392311af6a$var$renderLanes & 127) || $00be48392311af6a$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $00be48392311af6a$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $00be48392311af6a$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $00be48392311af6a$var$createFunctionComponentUpdateQueue(), $00be48392311af6a$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $00be48392311af6a$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $00be48392311af6a$var$checkIfSnapshotChanged(inst) && $00be48392311af6a$var$forceStoreRerender(fiber);
}
function $00be48392311af6a$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $00be48392311af6a$var$checkIfSnapshotChanged(inst) && $00be48392311af6a$var$forceStoreRerender(fiber);
    });
}
function $00be48392311af6a$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$00be48392311af6a$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $00be48392311af6a$var$forceStoreRerender(fiber) {
    var root = $00be48392311af6a$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $00be48392311af6a$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $00be48392311af6a$var$mountStateImpl(initialState) {
    var hook = $00be48392311af6a$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($00be48392311af6a$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $00be48392311af6a$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $00be48392311af6a$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $00be48392311af6a$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $00be48392311af6a$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $00be48392311af6a$var$updateReducerImpl(hook, $00be48392311af6a$var$currentHook, "function" === typeof reducer ? reducer : $00be48392311af6a$var$basicStateReducer);
}
function $00be48392311af6a$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($00be48392311af6a$var$isRenderPhaseUpdate(fiber)) throw Error($00be48392311af6a$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $00be48392311af6a$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $00be48392311af6a$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $00be48392311af6a$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $00be48392311af6a$var$ReactSharedInternals.T, currentTransition = {};
        currentTransition.types = null !== prevTransition ? prevTransition.types : null;
        $00be48392311af6a$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $00be48392311af6a$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $00be48392311af6a$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $00be48392311af6a$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $00be48392311af6a$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $00be48392311af6a$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$70) {
        $00be48392311af6a$var$onActionError(actionQueue, node, error$70);
    }
}
function $00be48392311af6a$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $00be48392311af6a$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $00be48392311af6a$var$onActionError(actionQueue, node, error);
    }) : $00be48392311af6a$var$onActionSuccess(actionQueue, node, returnValue);
}
function $00be48392311af6a$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $00be48392311af6a$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $00be48392311af6a$var$runActionStateAction(actionQueue, nextState)));
}
function $00be48392311af6a$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $00be48392311af6a$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $00be48392311af6a$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $00be48392311af6a$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $00be48392311af6a$var$mountActionState(action, initialStateProp) {
    if ($00be48392311af6a$var$isHydrating) {
        var ssrFormState = $00be48392311af6a$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $00be48392311af6a$var$currentlyRenderingFiber;
                if ($00be48392311af6a$var$isHydrating) {
                    if ($00be48392311af6a$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $00be48392311af6a$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $00be48392311af6a$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $00be48392311af6a$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $00be48392311af6a$var$nextHydratableInstance = $00be48392311af6a$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $00be48392311af6a$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $00be48392311af6a$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $00be48392311af6a$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $00be48392311af6a$var$dispatchSetState.bind(null, $00be48392311af6a$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $00be48392311af6a$var$mountStateImpl(!1);
    inRootOrSingleton = $00be48392311af6a$var$dispatchOptimisticSetState.bind(null, $00be48392311af6a$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $00be48392311af6a$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $00be48392311af6a$var$dispatchActionState.bind(null, $00be48392311af6a$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $00be48392311af6a$var$updateActionState(action) {
    var stateHook = $00be48392311af6a$var$updateWorkInProgressHook();
    return $00be48392311af6a$var$updateActionStateImpl(stateHook, $00be48392311af6a$var$currentHook, action);
}
function $00be48392311af6a$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $00be48392311af6a$var$updateReducerImpl(stateHook, currentStateHook, $00be48392311af6a$var$actionStateReducer)[0];
    stateHook = $00be48392311af6a$var$updateReducer($00be48392311af6a$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $00be48392311af6a$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $00be48392311af6a$var$SuspenseException) throw $00be48392311af6a$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $00be48392311af6a$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($00be48392311af6a$var$currentlyRenderingFiber.flags |= 2048, $00be48392311af6a$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $00be48392311af6a$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $00be48392311af6a$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $00be48392311af6a$var$rerenderActionState(action) {
    var stateHook = $00be48392311af6a$var$updateWorkInProgressHook(), currentStateHook = $00be48392311af6a$var$currentHook;
    if (null !== currentStateHook) return $00be48392311af6a$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $00be48392311af6a$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $00be48392311af6a$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $00be48392311af6a$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $00be48392311af6a$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $00be48392311af6a$var$createFunctionComponentUpdateQueue(), $00be48392311af6a$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $00be48392311af6a$var$updateRef() {
    return $00be48392311af6a$var$updateWorkInProgressHook().memoizedState;
}
function $00be48392311af6a$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $00be48392311af6a$var$mountWorkInProgressHook();
    $00be48392311af6a$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $00be48392311af6a$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $00be48392311af6a$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $00be48392311af6a$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $00be48392311af6a$var$currentHook && null !== deps && $00be48392311af6a$var$areHookInputsEqual(deps, $00be48392311af6a$var$currentHook.memoizedState.deps) ? hook.memoizedState = $00be48392311af6a$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($00be48392311af6a$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $00be48392311af6a$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $00be48392311af6a$var$mountEffect(create, deps) {
    $00be48392311af6a$var$mountEffectImpl(8390656, 8, create, deps);
}
function $00be48392311af6a$var$updateEffect(create, deps) {
    $00be48392311af6a$var$updateEffectImpl(2048, 8, create, deps);
}
function $00be48392311af6a$var$useEffectEventImpl(payload) {
    $00be48392311af6a$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $00be48392311af6a$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $00be48392311af6a$var$createFunctionComponentUpdateQueue(), $00be48392311af6a$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $00be48392311af6a$var$updateEvent(callback) {
    var ref = $00be48392311af6a$var$updateWorkInProgressHook().memoizedState;
    $00be48392311af6a$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($00be48392311af6a$var$executionContext & 2)) throw Error($00be48392311af6a$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $00be48392311af6a$var$updateInsertionEffect(create, deps) {
    return $00be48392311af6a$var$updateEffectImpl(4, 2, create, deps);
}
function $00be48392311af6a$var$updateLayoutEffect(create, deps) {
    return $00be48392311af6a$var$updateEffectImpl(4, 4, create, deps);
}
function $00be48392311af6a$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $00be48392311af6a$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $00be48392311af6a$var$updateEffectImpl(4, 4, $00be48392311af6a$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $00be48392311af6a$var$mountDebugValue() {}
function $00be48392311af6a$var$updateCallback(callback, deps) {
    var hook = $00be48392311af6a$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $00be48392311af6a$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $00be48392311af6a$var$updateMemo(nextCreate, deps) {
    var hook = $00be48392311af6a$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $00be48392311af6a$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($00be48392311af6a$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $00be48392311af6a$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $00be48392311af6a$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $00be48392311af6a$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($00be48392311af6a$var$renderLanes & 1073741824) && 0 === ($00be48392311af6a$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $00be48392311af6a$var$requestDeferredLane();
    $00be48392311af6a$var$currentlyRenderingFiber.lanes |= hook;
    $00be48392311af6a$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $00be48392311af6a$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($00be48392311af6a$var$objectIs(value, prevValue)) return value;
    if (null !== $00be48392311af6a$var$currentTreeHiddenStackCursor.current) return hook = $00be48392311af6a$var$mountDeferredValueImpl(hook, value, initialValue), $00be48392311af6a$var$objectIs(hook, prevValue) || ($00be48392311af6a$var$didReceiveUpdate = !0), hook;
    if (0 === ($00be48392311af6a$var$renderLanes & 106) || 0 !== ($00be48392311af6a$var$renderLanes & 1073741824) && 0 === ($00be48392311af6a$var$workInProgressRootRenderLanes & 261930)) return $00be48392311af6a$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $00be48392311af6a$var$requestDeferredLane();
    $00be48392311af6a$var$currentlyRenderingFiber.lanes |= hook;
    $00be48392311af6a$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $00be48392311af6a$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $00be48392311af6a$var$ReactDOMSharedInternals.p;
    $00be48392311af6a$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $00be48392311af6a$var$ReactSharedInternals.T, currentTransition = {};
    currentTransition.types = null !== prevTransition ? prevTransition.types : null;
    $00be48392311af6a$var$ReactSharedInternals.T = currentTransition;
    $00be48392311af6a$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $00be48392311af6a$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $00be48392311af6a$var$chainThenableValue(returnValue, finishedState);
            $00be48392311af6a$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $00be48392311af6a$var$requestUpdateLane(fiber));
        } else $00be48392311af6a$var$dispatchSetStateInternal(fiber, queue, finishedState, $00be48392311af6a$var$requestUpdateLane(fiber));
    } catch (error) {
        $00be48392311af6a$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $00be48392311af6a$var$requestUpdateLane());
    } finally{
        $00be48392311af6a$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $00be48392311af6a$var$ReactSharedInternals.T = prevTransition;
    }
}
function $00be48392311af6a$var$noop() {}
function $00be48392311af6a$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($00be48392311af6a$var$formatProdErrorMessage(476));
    var queue = $00be48392311af6a$var$ensureFormComponentIsStateful(formFiber).queue;
    $00be48392311af6a$var$startTransition(formFiber, queue, pendingState, $00be48392311af6a$var$sharedNotPendingObject, null === action ? $00be48392311af6a$var$noop : function() {
        $00be48392311af6a$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $00be48392311af6a$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $00be48392311af6a$var$sharedNotPendingObject,
        baseState: $00be48392311af6a$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $00be48392311af6a$var$basicStateReducer,
            lastRenderedState: $00be48392311af6a$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $00be48392311af6a$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $00be48392311af6a$var$requestFormReset$1(formFiber) {
    var stateHook = $00be48392311af6a$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $00be48392311af6a$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $00be48392311af6a$var$requestUpdateLane());
}
function $00be48392311af6a$var$useHostTransitionStatus() {
    return $00be48392311af6a$var$readContext($00be48392311af6a$var$HostTransitionContext);
}
function $00be48392311af6a$var$updateId() {
    return $00be48392311af6a$var$updateWorkInProgressHook().memoizedState;
}
function $00be48392311af6a$var$updateRefresh() {
    return $00be48392311af6a$var$updateWorkInProgressHook().memoizedState;
}
function $00be48392311af6a$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $00be48392311af6a$var$requestUpdateLane();
                fiber = $00be48392311af6a$var$createUpdate(lane);
                var root$73 = $00be48392311af6a$var$enqueueUpdate(provider, fiber, lane);
                null !== root$73 && ($00be48392311af6a$var$scheduleUpdateOnFiber(root$73, provider, lane), $00be48392311af6a$var$entangleTransitions(root$73, provider, lane));
                provider = {
                    cache: $00be48392311af6a$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $00be48392311af6a$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $00be48392311af6a$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $00be48392311af6a$var$isRenderPhaseUpdate(fiber) ? $00be48392311af6a$var$enqueueRenderPhaseUpdate(queue, action) : (action = $00be48392311af6a$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($00be48392311af6a$var$scheduleUpdateOnFiber(action, fiber, lane), $00be48392311af6a$var$entangleTransitionUpdate(action, queue, lane)));
}
function $00be48392311af6a$var$dispatchSetState(fiber, queue, action) {
    var lane = $00be48392311af6a$var$requestUpdateLane();
    $00be48392311af6a$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $00be48392311af6a$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($00be48392311af6a$var$isRenderPhaseUpdate(fiber)) $00be48392311af6a$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($00be48392311af6a$var$objectIs(eagerState, currentState)) return $00be48392311af6a$var$enqueueUpdate$1(fiber, queue, update, 0), null === $00be48392311af6a$var$workInProgressRoot && $00be48392311af6a$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $00be48392311af6a$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $00be48392311af6a$var$scheduleUpdateOnFiber(action, fiber, lane), $00be48392311af6a$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $00be48392311af6a$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $00be48392311af6a$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($00be48392311af6a$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($00be48392311af6a$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $00be48392311af6a$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $00be48392311af6a$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $00be48392311af6a$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $00be48392311af6a$var$currentlyRenderingFiber || null !== alternate && alternate === $00be48392311af6a$var$currentlyRenderingFiber;
}
function $00be48392311af6a$var$enqueueRenderPhaseUpdate(queue, update) {
    $00be48392311af6a$var$didScheduleRenderPhaseUpdateDuringThisPass = $00be48392311af6a$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $00be48392311af6a$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $00be48392311af6a$var$markRootEntangled(root, lane);
    }
}
var $00be48392311af6a$var$ContextOnlyDispatcher = {
    readContext: $00be48392311af6a$var$readContext,
    use: $00be48392311af6a$var$use,
    useCallback: $00be48392311af6a$var$throwInvalidHookError,
    useContext: $00be48392311af6a$var$throwInvalidHookError,
    useEffect: $00be48392311af6a$var$throwInvalidHookError,
    useImperativeHandle: $00be48392311af6a$var$throwInvalidHookError,
    useLayoutEffect: $00be48392311af6a$var$throwInvalidHookError,
    useInsertionEffect: $00be48392311af6a$var$throwInvalidHookError,
    useMemo: $00be48392311af6a$var$throwInvalidHookError,
    useReducer: $00be48392311af6a$var$throwInvalidHookError,
    useRef: $00be48392311af6a$var$throwInvalidHookError,
    useState: $00be48392311af6a$var$throwInvalidHookError,
    useDebugValue: $00be48392311af6a$var$throwInvalidHookError,
    useDeferredValue: $00be48392311af6a$var$throwInvalidHookError,
    useTransition: $00be48392311af6a$var$throwInvalidHookError,
    useSyncExternalStore: $00be48392311af6a$var$throwInvalidHookError,
    useId: $00be48392311af6a$var$throwInvalidHookError,
    useHostTransitionStatus: $00be48392311af6a$var$throwInvalidHookError,
    useFormState: $00be48392311af6a$var$throwInvalidHookError,
    useActionState: $00be48392311af6a$var$throwInvalidHookError,
    useOptimistic: $00be48392311af6a$var$throwInvalidHookError,
    useMemoCache: $00be48392311af6a$var$throwInvalidHookError,
    useCacheRefresh: $00be48392311af6a$var$throwInvalidHookError,
    useEffectEvent: $00be48392311af6a$var$throwInvalidHookError
}, $00be48392311af6a$var$HooksDispatcherOnMount = {
    readContext: $00be48392311af6a$var$readContext,
    use: $00be48392311af6a$var$use,
    useCallback: function(callback, deps) {
        $00be48392311af6a$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $00be48392311af6a$var$readContext,
    useEffect: $00be48392311af6a$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $00be48392311af6a$var$mountEffectImpl(4194308, 4, $00be48392311af6a$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $00be48392311af6a$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $00be48392311af6a$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $00be48392311af6a$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($00be48392311af6a$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $00be48392311af6a$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $00be48392311af6a$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $00be48392311af6a$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($00be48392311af6a$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $00be48392311af6a$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $00be48392311af6a$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $00be48392311af6a$var$dispatchReducerAction.bind(null, $00be48392311af6a$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $00be48392311af6a$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $00be48392311af6a$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $00be48392311af6a$var$dispatchSetState.bind(null, $00be48392311af6a$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $00be48392311af6a$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $00be48392311af6a$var$mountWorkInProgressHook();
        return $00be48392311af6a$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $00be48392311af6a$var$mountStateImpl(!1);
        stateHook = $00be48392311af6a$var$startTransition.bind(null, $00be48392311af6a$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $00be48392311af6a$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $00be48392311af6a$var$currentlyRenderingFiber, hook = $00be48392311af6a$var$mountWorkInProgressHook();
        if ($00be48392311af6a$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($00be48392311af6a$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $00be48392311af6a$var$workInProgressRoot) throw Error($00be48392311af6a$var$formatProdErrorMessage(349));
            0 !== ($00be48392311af6a$var$workInProgressRootRenderLanes & 127) || $00be48392311af6a$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $00be48392311af6a$var$mountEffect($00be48392311af6a$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $00be48392311af6a$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $00be48392311af6a$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $00be48392311af6a$var$mountWorkInProgressHook(), identifierPrefix = $00be48392311af6a$var$workInProgressRoot.identifierPrefix;
        if ($00be48392311af6a$var$isHydrating) {
            var JSCompiler_inline_result = $00be48392311af6a$var$treeContextOverflow;
            var idWithLeadingBit = $00be48392311af6a$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $00be48392311af6a$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $00be48392311af6a$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $00be48392311af6a$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $00be48392311af6a$var$useHostTransitionStatus,
    useFormState: $00be48392311af6a$var$mountActionState,
    useActionState: $00be48392311af6a$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $00be48392311af6a$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $00be48392311af6a$var$dispatchOptimisticSetState.bind(null, $00be48392311af6a$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $00be48392311af6a$var$useMemoCache,
    useCacheRefresh: function() {
        return $00be48392311af6a$var$mountWorkInProgressHook().memoizedState = $00be48392311af6a$var$refreshCache.bind(null, $00be48392311af6a$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $00be48392311af6a$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($00be48392311af6a$var$executionContext & 2)) throw Error($00be48392311af6a$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $00be48392311af6a$var$HooksDispatcherOnUpdate = {
    readContext: $00be48392311af6a$var$readContext,
    use: $00be48392311af6a$var$use,
    useCallback: $00be48392311af6a$var$updateCallback,
    useContext: $00be48392311af6a$var$readContext,
    useEffect: $00be48392311af6a$var$updateEffect,
    useImperativeHandle: $00be48392311af6a$var$updateImperativeHandle,
    useInsertionEffect: $00be48392311af6a$var$updateInsertionEffect,
    useLayoutEffect: $00be48392311af6a$var$updateLayoutEffect,
    useMemo: $00be48392311af6a$var$updateMemo,
    useReducer: $00be48392311af6a$var$updateReducer,
    useRef: $00be48392311af6a$var$updateRef,
    useState: function() {
        return $00be48392311af6a$var$updateReducer($00be48392311af6a$var$basicStateReducer);
    },
    useDebugValue: $00be48392311af6a$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $00be48392311af6a$var$updateWorkInProgressHook();
        return $00be48392311af6a$var$updateDeferredValueImpl(hook, $00be48392311af6a$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $00be48392311af6a$var$updateReducer($00be48392311af6a$var$basicStateReducer)[0], start = $00be48392311af6a$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $00be48392311af6a$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $00be48392311af6a$var$updateSyncExternalStore,
    useId: $00be48392311af6a$var$updateId,
    useHostTransitionStatus: $00be48392311af6a$var$useHostTransitionStatus,
    useFormState: $00be48392311af6a$var$updateActionState,
    useActionState: $00be48392311af6a$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $00be48392311af6a$var$updateWorkInProgressHook();
        return $00be48392311af6a$var$updateOptimisticImpl(hook, $00be48392311af6a$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $00be48392311af6a$var$useMemoCache,
    useCacheRefresh: $00be48392311af6a$var$updateRefresh,
    useEffectEvent: $00be48392311af6a$var$updateEvent
}, $00be48392311af6a$var$HooksDispatcherOnRerender = {
    readContext: $00be48392311af6a$var$readContext,
    use: $00be48392311af6a$var$use,
    useCallback: $00be48392311af6a$var$updateCallback,
    useContext: $00be48392311af6a$var$readContext,
    useEffect: $00be48392311af6a$var$updateEffect,
    useImperativeHandle: $00be48392311af6a$var$updateImperativeHandle,
    useInsertionEffect: $00be48392311af6a$var$updateInsertionEffect,
    useLayoutEffect: $00be48392311af6a$var$updateLayoutEffect,
    useMemo: $00be48392311af6a$var$updateMemo,
    useReducer: $00be48392311af6a$var$rerenderReducer,
    useRef: $00be48392311af6a$var$updateRef,
    useState: function() {
        return $00be48392311af6a$var$rerenderReducer($00be48392311af6a$var$basicStateReducer);
    },
    useDebugValue: $00be48392311af6a$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $00be48392311af6a$var$updateWorkInProgressHook();
        return null === $00be48392311af6a$var$currentHook ? $00be48392311af6a$var$mountDeferredValueImpl(hook, value, initialValue) : $00be48392311af6a$var$updateDeferredValueImpl(hook, $00be48392311af6a$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $00be48392311af6a$var$rerenderReducer($00be48392311af6a$var$basicStateReducer)[0], start = $00be48392311af6a$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $00be48392311af6a$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $00be48392311af6a$var$updateSyncExternalStore,
    useId: $00be48392311af6a$var$updateId,
    useHostTransitionStatus: $00be48392311af6a$var$useHostTransitionStatus,
    useFormState: $00be48392311af6a$var$rerenderActionState,
    useActionState: $00be48392311af6a$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $00be48392311af6a$var$updateWorkInProgressHook();
        if (null !== $00be48392311af6a$var$currentHook) return $00be48392311af6a$var$updateOptimisticImpl(hook, $00be48392311af6a$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $00be48392311af6a$var$useMemoCache,
    useCacheRefresh: $00be48392311af6a$var$updateRefresh,
    useEffectEvent: $00be48392311af6a$var$updateEvent
};
function $00be48392311af6a$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $00be48392311af6a$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $00be48392311af6a$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $00be48392311af6a$var$requestUpdateLane(), update = $00be48392311af6a$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $00be48392311af6a$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($00be48392311af6a$var$scheduleUpdateOnFiber(payload, inst, lane), $00be48392311af6a$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $00be48392311af6a$var$requestUpdateLane(), update = $00be48392311af6a$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $00be48392311af6a$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($00be48392311af6a$var$scheduleUpdateOnFiber(payload, inst, lane), $00be48392311af6a$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $00be48392311af6a$var$requestUpdateLane(), update = $00be48392311af6a$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $00be48392311af6a$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($00be48392311af6a$var$scheduleUpdateOnFiber(callback, inst, lane), $00be48392311af6a$var$entangleTransitions(callback, inst, lane));
    }
};
function $00be48392311af6a$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$00be48392311af6a$var$shallowEqual(oldProps, newProps) || !$00be48392311af6a$var$shallowEqual(oldState, newState) : !0;
}
function $00be48392311af6a$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $00be48392311af6a$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $00be48392311af6a$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $00be48392311af6a$var$assign({}, newProps));
        for(var propName$77 in Component)void 0 === newProps[propName$77] && (newProps[propName$77] = Component[propName$77]);
    }
    return newProps;
}
function $00be48392311af6a$var$defaultOnUncaughtError(error) {
    $00be48392311af6a$var$reportGlobalError(error);
}
function $00be48392311af6a$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $00be48392311af6a$var$defaultOnRecoverableError(error) {
    $00be48392311af6a$var$reportGlobalError(error);
}
function $00be48392311af6a$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$78) {
        setTimeout(function() {
            throw e$78;
        });
    }
}
function $00be48392311af6a$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$79) {
        setTimeout(function() {
            throw e$79;
        });
    }
}
function $00be48392311af6a$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $00be48392311af6a$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $00be48392311af6a$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $00be48392311af6a$var$createClassErrorUpdate(lane) {
    lane = $00be48392311af6a$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $00be48392311af6a$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $00be48392311af6a$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $00be48392311af6a$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $00be48392311af6a$var$legacyErrorBoundariesThatAlreadyFailed ? $00be48392311af6a$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $00be48392311af6a$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $00be48392311af6a$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $00be48392311af6a$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $00be48392311af6a$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                case 19:
                    return null === $00be48392311af6a$var$shellBoundary ? $00be48392311af6a$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $00be48392311af6a$var$workInProgressRootExitStatus && ($00be48392311af6a$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $00be48392311af6a$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $00be48392311af6a$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $00be48392311af6a$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $00be48392311af6a$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($00be48392311af6a$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $00be48392311af6a$var$attachPingListener(root, value, rootRenderLanes);
        $00be48392311af6a$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($00be48392311af6a$var$isHydrating) return returnFiber = $00be48392311af6a$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $00be48392311af6a$var$HydrationMismatchException && (root = Error($00be48392311af6a$var$formatProdErrorMessage(422), {
        cause: value
    }), $00be48392311af6a$var$queueHydrationError($00be48392311af6a$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $00be48392311af6a$var$HydrationMismatchException && (returnFiber = Error($00be48392311af6a$var$formatProdErrorMessage(423), {
        cause: value
    }), $00be48392311af6a$var$queueHydrationError($00be48392311af6a$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $00be48392311af6a$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $00be48392311af6a$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $00be48392311af6a$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $00be48392311af6a$var$workInProgressRootExitStatus && ($00be48392311af6a$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($00be48392311af6a$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $00be48392311af6a$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $00be48392311af6a$var$workInProgressRootConcurrentErrors ? $00be48392311af6a$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $00be48392311af6a$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $00be48392311af6a$var$workInProgressRootExitStatus && ($00be48392311af6a$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $00be48392311af6a$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $00be48392311af6a$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $00be48392311af6a$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                returnFiber = sourceFiber.type;
                wrapperError = sourceFiber.stateNode;
                if (0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $00be48392311af6a$var$legacyErrorBoundariesThatAlreadyFailed || !$00be48392311af6a$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $00be48392311af6a$var$createClassErrorUpdate(rootRenderLanes), $00be48392311af6a$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $00be48392311af6a$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
                break;
            case 22:
                if (null !== sourceFiber.memoizedState) return sourceFiber.flags |= 65536, !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $00be48392311af6a$var$SelectiveHydrationException = Error($00be48392311af6a$var$formatProdErrorMessage(461)), $00be48392311af6a$var$didReceiveUpdate = !1;
function $00be48392311af6a$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $00be48392311af6a$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $00be48392311af6a$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $00be48392311af6a$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $00be48392311af6a$var$prepareToReadContext(workInProgress);
    nextProps = $00be48392311af6a$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $00be48392311af6a$var$checkDidRenderIdHook();
    if (null !== current && !$00be48392311af6a$var$didReceiveUpdate) return $00be48392311af6a$var$bailoutHooks(current, workInProgress, renderLanes), $00be48392311af6a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $00be48392311af6a$var$isHydrating && key && $00be48392311af6a$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $00be48392311af6a$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $00be48392311af6a$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$00be48392311af6a$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $00be48392311af6a$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $00be48392311af6a$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$00be48392311af6a$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $00be48392311af6a$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $00be48392311af6a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $00be48392311af6a$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $00be48392311af6a$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($00be48392311af6a$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($00be48392311af6a$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $00be48392311af6a$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($00be48392311af6a$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $00be48392311af6a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $00be48392311af6a$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $00be48392311af6a$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $00be48392311af6a$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $00be48392311af6a$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $00be48392311af6a$var$pushHiddenContext(workInProgress, prevState) : $00be48392311af6a$var$reuseHiddenContextOnStack(), $00be48392311af6a$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $00be48392311af6a$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($00be48392311af6a$var$pushTransition(workInProgress, prevState.cachePool), $00be48392311af6a$var$pushHiddenContext(workInProgress, prevState), $00be48392311af6a$var$reuseSuspenseHandlerOnStack(), workInProgress.memoizedState = null) : (null !== current && $00be48392311af6a$var$pushTransition(workInProgress, null), $00be48392311af6a$var$reuseHiddenContextOnStack(), $00be48392311af6a$var$reuseSuspenseHandlerOnStack());
    $00be48392311af6a$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $00be48392311af6a$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $00be48392311af6a$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $00be48392311af6a$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $00be48392311af6a$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $00be48392311af6a$var$pushTransition(workInProgress, null);
    $00be48392311af6a$var$reuseHiddenContextOnStack();
    $00be48392311af6a$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $00be48392311af6a$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $00be48392311af6a$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $00be48392311af6a$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $00be48392311af6a$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $00be48392311af6a$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $00be48392311af6a$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $00be48392311af6a$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $00be48392311af6a$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($00be48392311af6a$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $00be48392311af6a$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, current.memoizedState = {
                baseLanes: 0,
                cachePool: null
            }, $00be48392311af6a$var$bailoutOffscreenComponent(null, current);
            $00be48392311af6a$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $00be48392311af6a$var$nextHydratableInstance) ? (current = $00be48392311af6a$var$canHydrateHydrationBoundary(current, $00be48392311af6a$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $00be48392311af6a$var$treeContextProvider ? {
                    id: $00be48392311af6a$var$treeContextId,
                    overflow: $00be48392311af6a$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $00be48392311af6a$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $00be48392311af6a$var$hydrationParentFiber = workInProgress, $00be48392311af6a$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $00be48392311af6a$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $00be48392311af6a$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $00be48392311af6a$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $00be48392311af6a$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($00be48392311af6a$var$formatProdErrorMessage(558));
        } else if ($00be48392311af6a$var$didReceiveUpdate || $00be48392311af6a$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $00be48392311af6a$var$didReceiveUpdate || didSuspend) {
            if (null === $00be48392311af6a$var$currentTreeHiddenStackCursor.current) {
                nextProps = $00be48392311af6a$var$workInProgressRoot;
                if (null !== nextProps && (dehydrated = $00be48392311af6a$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $00be48392311af6a$var$enqueueConcurrentRenderForLane(current, dehydrated), $00be48392311af6a$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $00be48392311af6a$var$SelectiveHydrationException;
                $00be48392311af6a$var$renderDidSuspendDelayIfPossible();
            }
            workInProgress = $00be48392311af6a$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $00be48392311af6a$var$nextHydratableInstance = $00be48392311af6a$var$getNextHydratable(dehydrated.nextSibling), $00be48392311af6a$var$hydrationParentFiber = workInProgress, $00be48392311af6a$var$isHydrating = !0, $00be48392311af6a$var$hydrationErrors = null, $00be48392311af6a$var$rootOrSingletonContext = !1, null !== current && $00be48392311af6a$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $00be48392311af6a$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 134221824;
        return workInProgress;
    }
    current = $00be48392311af6a$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $00be48392311af6a$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($00be48392311af6a$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $00be48392311af6a$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $00be48392311af6a$var$prepareToReadContext(workInProgress);
    Component = $00be48392311af6a$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $00be48392311af6a$var$checkDidRenderIdHook();
    if (null !== current && !$00be48392311af6a$var$didReceiveUpdate) return $00be48392311af6a$var$bailoutHooks(current, workInProgress, renderLanes), $00be48392311af6a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $00be48392311af6a$var$isHydrating && nextProps && $00be48392311af6a$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $00be48392311af6a$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $00be48392311af6a$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $00be48392311af6a$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $00be48392311af6a$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $00be48392311af6a$var$finishRenderingHooks(current);
    Component = $00be48392311af6a$var$checkDidRenderIdHook();
    if (null !== current && !$00be48392311af6a$var$didReceiveUpdate) return $00be48392311af6a$var$bailoutHooks(current, workInProgress, renderLanes), $00be48392311af6a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $00be48392311af6a$var$isHydrating && Component && $00be48392311af6a$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $00be48392311af6a$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $00be48392311af6a$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $00be48392311af6a$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $00be48392311af6a$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $00be48392311af6a$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $00be48392311af6a$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $00be48392311af6a$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $00be48392311af6a$var$readContext(contextType) : $00be48392311af6a$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($00be48392311af6a$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $00be48392311af6a$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $00be48392311af6a$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $00be48392311af6a$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $00be48392311af6a$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $00be48392311af6a$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $00be48392311af6a$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $00be48392311af6a$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $00be48392311af6a$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $00be48392311af6a$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $00be48392311af6a$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $00be48392311af6a$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($00be48392311af6a$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $00be48392311af6a$var$hasForceUpdate || $00be48392311af6a$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $00be48392311af6a$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $00be48392311af6a$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $00be48392311af6a$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $00be48392311af6a$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $00be48392311af6a$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $00be48392311af6a$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $00be48392311af6a$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $00be48392311af6a$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $00be48392311af6a$var$hasForceUpdate || null !== current && null !== current.dependencies && $00be48392311af6a$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($00be48392311af6a$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $00be48392311af6a$var$hasForceUpdate || $00be48392311af6a$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $00be48392311af6a$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $00be48392311af6a$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $00be48392311af6a$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $00be48392311af6a$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $00be48392311af6a$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $00be48392311af6a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $00be48392311af6a$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $00be48392311af6a$var$resetHydrationState();
    workInProgress.flags |= 256;
    $00be48392311af6a$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $00be48392311af6a$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $00be48392311af6a$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $00be48392311af6a$var$getSuspendedCache()
    };
}
function $00be48392311af6a$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $00be48392311af6a$var$workInProgressDeferredLane);
    return current;
}
function $00be48392311af6a$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($00be48392311af6a$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($00be48392311af6a$var$isHydrating) {
            showFallback ? $00be48392311af6a$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $00be48392311af6a$var$reuseSuspenseHandlerOnStack();
            (current = $00be48392311af6a$var$nextHydratableInstance) ? (current = $00be48392311af6a$var$canHydrateHydrationBoundary(current, $00be48392311af6a$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $00be48392311af6a$var$treeContextProvider ? {
                    id: $00be48392311af6a$var$treeContextId,
                    overflow: $00be48392311af6a$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $00be48392311af6a$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $00be48392311af6a$var$hydrationParentFiber = workInProgress, $00be48392311af6a$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $00be48392311af6a$var$throwOnHydrationMismatch(workInProgress);
            $00be48392311af6a$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        didSuspend = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $00be48392311af6a$var$reuseSuspenseHandlerOnStack(), showFallback = workInProgress.mode, didSuspend = $00be48392311af6a$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: didSuspend
        }, showFallback), nextProps = $00be48392311af6a$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), didSuspend.return = workInProgress, nextProps.return = workInProgress, didSuspend.sibling = nextProps, workInProgress.child = didSuspend, nextProps = workInProgress.child, nextProps.memoizedState = $00be48392311af6a$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $00be48392311af6a$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $00be48392311af6a$var$SUSPENDED_MARKER, $00be48392311af6a$var$bailoutOffscreenComponent(null, nextProps);
        $00be48392311af6a$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $00be48392311af6a$var$mountSuspensePrimaryChildren(workInProgress, didSuspend);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated$96 = prevState.dehydrated;
        if (null !== dehydrated$96) return $00be48392311af6a$var$updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, JSCompiler_temp, nextProps, dehydrated$96, prevState, renderLanes);
    }
    if (showFallback) return $00be48392311af6a$var$reuseSuspenseHandlerOnStack(), showFallback = nextProps.fallback, didSuspend = workInProgress.mode, prevState = current.child, dehydrated$96 = prevState.sibling, nextProps = $00be48392311af6a$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 1206910976, null !== dehydrated$96 ? showFallback = $00be48392311af6a$var$createWorkInProgress(dehydrated$96, showFallback) : (showFallback = $00be48392311af6a$var$createFiberFromFragment(showFallback, didSuspend, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $00be48392311af6a$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, showFallback = current.child.memoizedState, null === showFallback ? showFallback = $00be48392311af6a$var$mountSuspenseOffscreenState(renderLanes) : (didSuspend = showFallback.cachePool, null !== didSuspend ? (prevState = $00be48392311af6a$var$CacheContext._currentValue, didSuspend = didSuspend.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : didSuspend) : didSuspend = $00be48392311af6a$var$getSuspendedCache(), showFallback = {
        baseLanes: showFallback.baseLanes | renderLanes,
        cachePool: didSuspend
    }), nextProps.memoizedState = showFallback, nextProps.childLanes = $00be48392311af6a$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $00be48392311af6a$var$SUSPENDED_MARKER, $00be48392311af6a$var$bailoutOffscreenComponent(current.child, nextProps);
    $00be48392311af6a$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $00be48392311af6a$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $00be48392311af6a$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $00be48392311af6a$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $00be48392311af6a$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $00be48392311af6a$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $00be48392311af6a$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $00be48392311af6a$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $00be48392311af6a$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $00be48392311af6a$var$updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, didPrimaryChildrenDefer, nextProps, suspenseInstance, suspenseState, renderLanes) {
    if (didSuspend) {
        if (workInProgress.flags & 256) return $00be48392311af6a$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, $00be48392311af6a$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        if (null !== workInProgress.memoizedState) return $00be48392311af6a$var$reuseSuspenseHandlerOnStack(), workInProgress.child = current.child, workInProgress.flags |= 128, null;
        $00be48392311af6a$var$reuseSuspenseHandlerOnStack();
        suspenseInstance = nextProps.fallback;
        suspenseState = workInProgress.mode;
        nextProps = $00be48392311af6a$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, suspenseState);
        suspenseInstance = $00be48392311af6a$var$createFiberFromFragment(suspenseInstance, suspenseState, renderLanes, null);
        suspenseInstance.flags |= 2;
        nextProps.return = workInProgress;
        suspenseInstance.return = workInProgress;
        nextProps.sibling = suspenseInstance;
        workInProgress.child = nextProps;
        $00be48392311af6a$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        nextProps = workInProgress.child;
        nextProps.memoizedState = $00be48392311af6a$var$mountSuspenseOffscreenState(renderLanes);
        nextProps.childLanes = $00be48392311af6a$var$getRemainingWorkInPrimaryTree(current, didPrimaryChildrenDefer, renderLanes);
        workInProgress.memoizedState = $00be48392311af6a$var$SUSPENDED_MARKER;
        return $00be48392311af6a$var$bailoutOffscreenComponent(null, nextProps);
    }
    $00be48392311af6a$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    if ($00be48392311af6a$var$isSuspenseInstanceFallback(suspenseInstance)) {
        didPrimaryChildrenDefer = suspenseInstance.nextSibling && suspenseInstance.nextSibling.dataset;
        if (didPrimaryChildrenDefer) var digest = didPrimaryChildrenDefer.dgst;
        didPrimaryChildrenDefer = digest;
        "" !== didPrimaryChildrenDefer && (nextProps = Error($00be48392311af6a$var$formatProdErrorMessage(419)), nextProps.stack = "", nextProps.digest = didPrimaryChildrenDefer, $00be48392311af6a$var$queueHydrationError({
            value: nextProps,
            source: null,
            stack: null
        }));
        return $00be48392311af6a$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
    }
    $00be48392311af6a$var$didReceiveUpdate || $00be48392311af6a$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1);
    didPrimaryChildrenDefer = 0 !== (renderLanes & current.childLanes);
    if ($00be48392311af6a$var$didReceiveUpdate || didPrimaryChildrenDefer) {
        if (null !== $00be48392311af6a$var$currentTreeHiddenStackCursor.current) return $00be48392311af6a$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        didPrimaryChildrenDefer = $00be48392311af6a$var$workInProgressRoot;
        if (null !== didPrimaryChildrenDefer && (nextProps = $00be48392311af6a$var$getBumpedLaneForHydration(didPrimaryChildrenDefer, renderLanes), 0 !== nextProps && nextProps !== suspenseState.retryLane)) throw suspenseState.retryLane = nextProps, $00be48392311af6a$var$enqueueConcurrentRenderForLane(current, nextProps), $00be48392311af6a$var$scheduleUpdateOnFiber(didPrimaryChildrenDefer, current, nextProps), $00be48392311af6a$var$SelectiveHydrationException;
        $00be48392311af6a$var$isSuspenseInstancePending(suspenseInstance) || $00be48392311af6a$var$renderDidSuspendDelayIfPossible();
        return $00be48392311af6a$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
    }
    if ($00be48392311af6a$var$isSuspenseInstancePending(suspenseInstance)) return workInProgress.flags |= 192, workInProgress.child = current.child, null;
    current = suspenseState.treeContext;
    $00be48392311af6a$var$nextHydratableInstance = $00be48392311af6a$var$getNextHydratable(suspenseInstance.nextSibling);
    $00be48392311af6a$var$hydrationParentFiber = workInProgress;
    $00be48392311af6a$var$isHydrating = !0;
    $00be48392311af6a$var$hydrationErrors = null;
    $00be48392311af6a$var$rootOrSingletonContext = !1;
    null !== current && $00be48392311af6a$var$restoreSuspendedTreeContext(workInProgress, current);
    workInProgress = $00be48392311af6a$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children);
    workInProgress.flags |= 134221824;
    return workInProgress;
}
function $00be48392311af6a$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $00be48392311af6a$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $00be48392311af6a$var$findLastContentRow(firstChild) {
    for(var lastContentRow = null; null !== firstChild;){
        var currentRow = firstChild.alternate;
        null !== currentRow && null === $00be48392311af6a$var$findFirstSuspended(currentRow) && (lastContentRow = firstChild);
        firstChild = firstChild.sibling;
    }
    return lastContentRow;
}
function $00be48392311af6a$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $00be48392311af6a$var$reverseChildren(fiber) {
    var row = fiber.child;
    for(fiber.child = null; null !== row;){
        var nextRow = row.sibling;
        row.sibling = fiber.child;
        fiber.child = row;
        row = nextRow;
    }
}
function $00be48392311af6a$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $00be48392311af6a$var$suspenseStackCursor.current;
    if (workInProgress.flags & 128) return $00be48392311af6a$var$pushSuspenseListContext(workInProgress, suspenseContext), null;
    var shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $00be48392311af6a$var$pushSuspenseListContext(workInProgress, suspenseContext);
    "backwards" === revealOrder && null !== current ? ($00be48392311af6a$var$reverseChildren(current), $00be48392311af6a$var$reconcileChildren(current, workInProgress, nextProps, renderLanes), $00be48392311af6a$var$reverseChildren(current)) : $00be48392311af6a$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $00be48392311af6a$var$isHydrating ? $00be48392311af6a$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $00be48392311af6a$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $00be48392311af6a$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "backwards":
            renderLanes = $00be48392311af6a$var$findLastContentRow(workInProgress.child);
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null, $00be48392311af6a$var$reverseChildren(workInProgress));
            $00be48392311af6a$var$initSuspenseListRenderState(workInProgress, !0, revealOrder, null, tailMode, nextProps);
            break;
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $00be48392311af6a$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $00be48392311af6a$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $00be48392311af6a$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        case "independent":
            workInProgress.memoizedState = null;
            break;
        default:
            renderLanes = $00be48392311af6a$var$findLastContentRow(workInProgress.child), null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null), $00be48392311af6a$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
    }
    return workInProgress.child;
}
function $00be48392311af6a$var$updateContextProvider(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $00be48392311af6a$var$pushProvider(workInProgress, workInProgress.type, newProps.value);
    $00be48392311af6a$var$reconcileChildren(current, workInProgress, newProps.children, renderLanes);
    return workInProgress.child;
}
function $00be48392311af6a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $00be48392311af6a$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($00be48392311af6a$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($00be48392311af6a$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $00be48392311af6a$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $00be48392311af6a$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $00be48392311af6a$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $00be48392311af6a$var$checkIfContextChanged(current) ? !0 : !1;
}
function $00be48392311af6a$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $00be48392311af6a$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $00be48392311af6a$var$pushProvider(workInProgress, $00be48392311af6a$var$CacheContext, current.memoizedState.cache);
            $00be48392311af6a$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $00be48392311af6a$var$pushHostContext(workInProgress);
            break;
        case 4:
            $00be48392311af6a$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $00be48392311af6a$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $00be48392311af6a$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$108 = workInProgress.memoizedState;
            if (null !== state$108) {
                if (null !== state$108.dehydrated) return $00be48392311af6a$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                state$108 = $00be48392311af6a$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1);
                var primaryChildLanes = workInProgress.child.childLanes;
                if (state$108 || 0 !== (renderLanes & primaryChildLanes)) return $00be48392311af6a$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $00be48392311af6a$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $00be48392311af6a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $00be48392311af6a$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            if (workInProgress.flags & 128) return $00be48392311af6a$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
            primaryChildLanes = 0 !== (current.flags & 128);
            state$108 = 0 !== (renderLanes & workInProgress.childLanes);
            state$108 || ($00be48392311af6a$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$108 = 0 !== (renderLanes & workInProgress.childLanes));
            if (primaryChildLanes) {
                if (state$108) return $00be48392311af6a$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            primaryChildLanes = workInProgress.memoizedState;
            null !== primaryChildLanes && (primaryChildLanes.rendering = null, primaryChildLanes.tail = null, primaryChildLanes.lastEffect = null);
            $00be48392311af6a$var$pushSuspenseListContext(workInProgress, $00be48392311af6a$var$suspenseStackCursor.current);
            if (state$108) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $00be48392311af6a$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $00be48392311af6a$var$pushProvider(workInProgress, $00be48392311af6a$var$CacheContext, current.memoizedState.cache);
    }
    return $00be48392311af6a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $00be48392311af6a$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $00be48392311af6a$var$didReceiveUpdate = !0;
        else {
            if (!$00be48392311af6a$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $00be48392311af6a$var$didReceiveUpdate = !1, $00be48392311af6a$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $00be48392311af6a$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $00be48392311af6a$var$didReceiveUpdate = !1, $00be48392311af6a$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $00be48392311af6a$var$pushTreeId(workInProgress, $00be48392311af6a$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $00be48392311af6a$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $00be48392311af6a$var$shouldConstruct(current) ? (props = $00be48392311af6a$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $00be48392311af6a$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $00be48392311af6a$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $00be48392311af6a$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $00be48392311af6a$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $00be48392311af6a$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $00be48392311af6a$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $00be48392311af6a$var$REACT_CONTEXT_TYPE) {
                            workInProgress.tag = 10;
                            workInProgress.type = current;
                            workInProgress = $00be48392311af6a$var$updateContextProvider(null, workInProgress, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $00be48392311af6a$var$getComponentNameFromType(current) || current;
                    throw Error($00be48392311af6a$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $00be48392311af6a$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $00be48392311af6a$var$resolveClassComponentProps(props, workInProgress.pendingProps), $00be48392311af6a$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $00be48392311af6a$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($00be48392311af6a$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $00be48392311af6a$var$cloneUpdateQueue(current, workInProgress);
                $00be48392311af6a$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $00be48392311af6a$var$pushProvider(workInProgress, $00be48392311af6a$var$CacheContext, props);
                props !== prevState.cache && $00be48392311af6a$var$propagateContextChanges(workInProgress, [
                    $00be48392311af6a$var$CacheContext
                ], renderLanes, !0);
                $00be48392311af6a$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $00be48392311af6a$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $00be48392311af6a$var$createCapturedValueAtFiber(Error($00be48392311af6a$var$formatProdErrorMessage(424)), workInProgress);
                        $00be48392311af6a$var$queueHydrationError($$typeof);
                        workInProgress = $00be48392311af6a$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $00be48392311af6a$var$nextHydratableInstance = $00be48392311af6a$var$getNextHydratable(current.firstChild);
                        $00be48392311af6a$var$hydrationParentFiber = workInProgress;
                        $00be48392311af6a$var$isHydrating = !0;
                        $00be48392311af6a$var$hydrationErrors = null;
                        $00be48392311af6a$var$rootOrSingletonContext = !0;
                        renderLanes = $00be48392311af6a$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 134221824, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $00be48392311af6a$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $00be48392311af6a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $00be48392311af6a$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $00be48392311af6a$var$markRef(current, workInProgress), null === current ? (renderLanes = $00be48392311af6a$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $00be48392311af6a$var$isHydrating || (workInProgress.stateNode = $00be48392311af6a$var$createHoistableInstance(workInProgress.type, workInProgress.pendingProps, $00be48392311af6a$var$rootInstanceStackCursor.current, workInProgress)) : workInProgress.memoizedState = $00be48392311af6a$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $00be48392311af6a$var$pushHostContext(workInProgress), null === current && $00be48392311af6a$var$isHydrating && (props = workInProgress.stateNode = $00be48392311af6a$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $00be48392311af6a$var$rootInstanceStackCursor.current), $00be48392311af6a$var$hydrationParentFiber = workInProgress, $00be48392311af6a$var$rootOrSingletonContext = !0, $$typeof = $00be48392311af6a$var$nextHydratableInstance, $00be48392311af6a$var$isSingletonScope(workInProgress.type) ? ($00be48392311af6a$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $00be48392311af6a$var$nextHydratableInstance = $00be48392311af6a$var$getNextHydratable(props.firstChild)) : $00be48392311af6a$var$nextHydratableInstance = $$typeof), $00be48392311af6a$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $00be48392311af6a$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $00be48392311af6a$var$isHydrating) {
                if ($$typeof = props = $00be48392311af6a$var$nextHydratableInstance) props = $00be48392311af6a$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $00be48392311af6a$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $00be48392311af6a$var$hydrationParentFiber = workInProgress, $00be48392311af6a$var$nextHydratableInstance = $00be48392311af6a$var$getNextHydratable(props.firstChild), $00be48392311af6a$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $00be48392311af6a$var$throwOnHydrationMismatch(workInProgress);
            }
            $00be48392311af6a$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $00be48392311af6a$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $00be48392311af6a$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $00be48392311af6a$var$renderWithHooks(current, workInProgress, $00be48392311af6a$var$TransitionAwareHostComponent, null, null, renderLanes), $00be48392311af6a$var$HostTransitionContext._currentValue = $$typeof);
            $00be48392311af6a$var$markRef(current, workInProgress);
            $00be48392311af6a$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $00be48392311af6a$var$isHydrating) {
                if (current = renderLanes = $00be48392311af6a$var$nextHydratableInstance) renderLanes = $00be48392311af6a$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $00be48392311af6a$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $00be48392311af6a$var$hydrationParentFiber = workInProgress, $00be48392311af6a$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $00be48392311af6a$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $00be48392311af6a$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $00be48392311af6a$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $00be48392311af6a$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $00be48392311af6a$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $00be48392311af6a$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return props = workInProgress.pendingProps, $00be48392311af6a$var$markRef(current, workInProgress), $00be48392311af6a$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 8:
            return $00be48392311af6a$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $00be48392311af6a$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return $00be48392311af6a$var$updateContextProvider(current, workInProgress, renderLanes);
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $00be48392311af6a$var$prepareToReadContext(workInProgress), $$typeof = $00be48392311af6a$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $00be48392311af6a$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $00be48392311af6a$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $00be48392311af6a$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $00be48392311af6a$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $00be48392311af6a$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $00be48392311af6a$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $00be48392311af6a$var$prepareToReadContext(workInProgress), props = $00be48392311af6a$var$readContext($00be48392311af6a$var$CacheContext), null === current ? ($$typeof = $00be48392311af6a$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $00be48392311af6a$var$workInProgressRoot, prevState = $00be48392311af6a$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $00be48392311af6a$var$initializeUpdateQueue(workInProgress), $00be48392311af6a$var$pushProvider(workInProgress, $00be48392311af6a$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($00be48392311af6a$var$cloneUpdateQueue(current, workInProgress), $00be48392311af6a$var$processUpdateQueue(workInProgress, null, null, renderLanes), $00be48392311af6a$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $00be48392311af6a$var$pushProvider(workInProgress, $00be48392311af6a$var$CacheContext, props)) : (props = prevState.cache, $00be48392311af6a$var$pushProvider(workInProgress, $00be48392311af6a$var$CacheContext, props), props !== $$typeof.cache && $00be48392311af6a$var$propagateContextChanges(workInProgress, [
                $00be48392311af6a$var$CacheContext
            ], renderLanes, !0))), $00be48392311af6a$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 30:
            return null === workInProgress.stateNode && (workInProgress.stateNode = {
                autoName: null,
                paired: null,
                clones: null,
                ref: null
            }), props = workInProgress.pendingProps, null != props.name && "auto" !== props.name ? workInProgress.flags |= null === current ? 18882560 : 18874368 : $00be48392311af6a$var$isHydrating && $00be48392311af6a$var$pushMaterializedTreeId(workInProgress), null !== current && current.memoizedProps.name !== props.name ? workInProgress.flags |= 4194816 : $00be48392311af6a$var$markRef(current, workInProgress), $00be48392311af6a$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($00be48392311af6a$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $00be48392311af6a$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $00be48392311af6a$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    var JSCompiler_temp;
    if (JSCompiler_temp = 0 !== (workInProgress.mode & 32)) JSCompiler_temp = null === oldProps ? $00be48392311af6a$var$maySuspendCommit(type, newProps) : $00be48392311af6a$var$maySuspendCommit(type, newProps) && (newProps.src !== oldProps.src || newProps.srcSet !== oldProps.srcSet);
    if (JSCompiler_temp) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($00be48392311af6a$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $00be48392311af6a$var$suspendedThenable = $00be48392311af6a$var$noopSuspenseyCommitThenable, $00be48392311af6a$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $00be48392311af6a$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$00be48392311af6a$var$preloadResource(resource)) {
        if ($00be48392311af6a$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $00be48392311af6a$var$suspendedThenable = $00be48392311af6a$var$noopSuspenseyCommitThenable, $00be48392311af6a$var$SuspenseyCommitException;
    }
}
function $00be48392311af6a$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $00be48392311af6a$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $00be48392311af6a$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $00be48392311af6a$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$00be48392311af6a$var$isHydrating) switch(renderState.tailMode){
        case "visible":
            break;
        case "collapsed":
            for(var tailNode = renderState.tail, lastTailNode = null; null !== tailNode;)null !== tailNode.alternate && (lastTailNode = tailNode), tailNode = tailNode.sibling;
            null === lastTailNode ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode.sibling = null;
            break;
        default:
            hasRenderedATailFallback = renderState.tail;
            for(tailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (tailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === tailNode ? renderState.tail = null : tailNode.sibling = null;
    }
}
function $00be48392311af6a$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$113 = completedWork.child; null !== child$113;)newChildLanes |= child$113.lanes | child$113.childLanes, subtreeFlags |= child$113.subtreeFlags & 1206910976, subtreeFlags |= child$113.flags & 1206910976, child$113.return = completedWork, child$113 = child$113.sibling;
    else for(child$113 = completedWork.child; null !== child$113;)newChildLanes |= child$113.lanes | child$113.childLanes, subtreeFlags |= child$113.subtreeFlags, subtreeFlags |= child$113.flags, child$113.return = completedWork, child$113 = child$113.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $00be48392311af6a$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $00be48392311af6a$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $00be48392311af6a$var$bubbleProperties(workInProgress), null;
        case 1:
            return $00be48392311af6a$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $00be48392311af6a$var$popProvider($00be48392311af6a$var$CacheContext);
            $00be48392311af6a$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $00be48392311af6a$var$popHydrationState(workInProgress) ? $00be48392311af6a$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $00be48392311af6a$var$upgradeHydrationErrorsToRecoverable());
            $00be48392311af6a$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($00be48392311af6a$var$markUpdate(workInProgress), null !== nextResource ? ($00be48392311af6a$var$bubbleProperties(workInProgress), $00be48392311af6a$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($00be48392311af6a$var$bubbleProperties(workInProgress), $00be48392311af6a$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($00be48392311af6a$var$markUpdate(workInProgress), $00be48392311af6a$var$bubbleProperties(workInProgress), $00be48392311af6a$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($00be48392311af6a$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $00be48392311af6a$var$markUpdate(workInProgress), $00be48392311af6a$var$bubbleProperties(workInProgress), $00be48392311af6a$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $00be48392311af6a$var$popHostContext(workInProgress);
            renderLanes = $00be48392311af6a$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $00be48392311af6a$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($00be48392311af6a$var$formatProdErrorMessage(166));
                    $00be48392311af6a$var$bubbleProperties(workInProgress);
                    workInProgress.subtreeFlags &= -33554433;
                    return null;
                }
                current = $00be48392311af6a$var$contextStackCursor.current;
                $00be48392311af6a$var$popHydrationState(workInProgress) ? $00be48392311af6a$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $00be48392311af6a$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $00be48392311af6a$var$markUpdate(workInProgress));
            }
            $00be48392311af6a$var$bubbleProperties(workInProgress);
            workInProgress.subtreeFlags &= -33554433;
            return null;
        case 5:
            $00be48392311af6a$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $00be48392311af6a$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($00be48392311af6a$var$formatProdErrorMessage(166));
                    $00be48392311af6a$var$bubbleProperties(workInProgress);
                    workInProgress.subtreeFlags &= -33554433;
                    return null;
                }
                nextResource = $00be48392311af6a$var$contextStackCursor.current;
                if ($00be48392311af6a$var$popHydrationState(workInProgress)) $00be48392311af6a$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $00be48392311af6a$var$getOwnerDocumentFromRootContainer($00be48392311af6a$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$00be48392311af6a$var$internalInstanceKey] = workInProgress;
                    nextResource[$00be48392311af6a$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($00be48392311af6a$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $00be48392311af6a$var$markUpdate(workInProgress);
                }
            }
            $00be48392311af6a$var$bubbleProperties(workInProgress);
            workInProgress.subtreeFlags &= -33554433;
            $00be48392311af6a$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $00be48392311af6a$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($00be48392311af6a$var$formatProdErrorMessage(166));
                current = $00be48392311af6a$var$rootInstanceStackCursor.current;
                if ($00be48392311af6a$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $00be48392311af6a$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$00be48392311af6a$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $00be48392311af6a$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $00be48392311af6a$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $00be48392311af6a$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$00be48392311af6a$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $00be48392311af6a$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $00be48392311af6a$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($00be48392311af6a$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($00be48392311af6a$var$formatProdErrorMessage(557));
                        current[$00be48392311af6a$var$internalInstanceKey] = workInProgress;
                    } else $00be48392311af6a$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $00be48392311af6a$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $00be48392311af6a$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $00be48392311af6a$var$popSuspenseHandler(workInProgress), workInProgress;
                    $00be48392311af6a$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($00be48392311af6a$var$formatProdErrorMessage(558));
            }
            $00be48392311af6a$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $00be48392311af6a$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($00be48392311af6a$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($00be48392311af6a$var$formatProdErrorMessage(317));
                        type[$00be48392311af6a$var$internalInstanceKey] = workInProgress;
                    } else $00be48392311af6a$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $00be48392311af6a$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $00be48392311af6a$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $00be48392311af6a$var$popSuspenseHandler(workInProgress), workInProgress;
                    $00be48392311af6a$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $00be48392311af6a$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $00be48392311af6a$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $00be48392311af6a$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $00be48392311af6a$var$popHostContainer(), null === current && $00be48392311af6a$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), workInProgress.flags |= 67108864, $00be48392311af6a$var$bubbleProperties(workInProgress), null;
        case 10:
            return $00be48392311af6a$var$popProvider(workInProgress.type), $00be48392311af6a$var$bubbleProperties(workInProgress), null;
        case 19:
            $00be48392311af6a$var$popSuspenseListContext(workInProgress);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $00be48392311af6a$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $00be48392311af6a$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $00be48392311af6a$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $00be48392311af6a$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $00be48392311af6a$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $00be48392311af6a$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$00be48392311af6a$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $00be48392311af6a$var$pushSuspenseListContext(workInProgress, $00be48392311af6a$var$suspenseStackCursor.current & 1 | 2);
                            $00be48392311af6a$var$isHydrating && $00be48392311af6a$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $00be48392311af6a$var$now() > $00be48392311af6a$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $00be48392311af6a$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $00be48392311af6a$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $00be48392311af6a$var$scheduleRetryEffect(workInProgress, current), $00be48392311af6a$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "collapsed" !== newProps.tailMode && "visible" !== newProps.tailMode && !nextResource.alternate && !$00be48392311af6a$var$isHydrating) return $00be48392311af6a$var$bubbleProperties(workInProgress), null;
                    } else 2 * $00be48392311af6a$var$now() - newProps.renderingStartTime > $00be48392311af6a$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $00be48392311af6a$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) {
                current = newProps.tail;
                a: {
                    for(renderLanes = current; null !== renderLanes;){
                        if (null !== renderLanes.alternate) {
                            renderLanes = !1;
                            break a;
                        }
                        renderLanes = renderLanes.sibling;
                    }
                    renderLanes = !0;
                }
                newProps.rendering = current;
                newProps.tail = current.sibling;
                newProps.renderingStartTime = $00be48392311af6a$var$now();
                current.sibling = null;
                nextResource = $00be48392311af6a$var$suspenseStackCursor.current;
                nextResource = type ? nextResource & 1 | 2 : nextResource & 1;
                "visible" === newProps.tailMode || "collapsed" === newProps.tailMode || !renderLanes || $00be48392311af6a$var$isHydrating ? $00be48392311af6a$var$pushSuspenseListContext(workInProgress, nextResource) : (renderLanes = nextResource, $00be48392311af6a$var$push($00be48392311af6a$var$suspenseHandlerStackCursor, workInProgress), $00be48392311af6a$var$push($00be48392311af6a$var$suspenseStackCursor, renderLanes), null === $00be48392311af6a$var$shellBoundary && ($00be48392311af6a$var$shellBoundary = workInProgress));
                $00be48392311af6a$var$isHydrating && $00be48392311af6a$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                return current;
            }
            $00be48392311af6a$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $00be48392311af6a$var$popSuspenseHandler(workInProgress), $00be48392311af6a$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($00be48392311af6a$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $00be48392311af6a$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $00be48392311af6a$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $00be48392311af6a$var$pop($00be48392311af6a$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $00be48392311af6a$var$popProvider($00be48392311af6a$var$CacheContext), $00be48392311af6a$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return workInProgress.flags |= 33554432, $00be48392311af6a$var$bubbleProperties(workInProgress), null;
    }
    throw Error($00be48392311af6a$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $00be48392311af6a$var$unwindWork(current, workInProgress) {
    $00be48392311af6a$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $00be48392311af6a$var$popProvider($00be48392311af6a$var$CacheContext), $00be48392311af6a$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $00be48392311af6a$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $00be48392311af6a$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($00be48392311af6a$var$formatProdErrorMessage(340));
                $00be48392311af6a$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $00be48392311af6a$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($00be48392311af6a$var$formatProdErrorMessage(340));
                $00be48392311af6a$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $00be48392311af6a$var$popSuspenseListContext(workInProgress), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, current = workInProgress.memoizedState, null !== current && (current.rendering = null, current.tail = null), workInProgress.flags |= 4, workInProgress) : null;
        case 4:
            return $00be48392311af6a$var$popHostContainer(), null;
        case 10:
            return $00be48392311af6a$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $00be48392311af6a$var$popSuspenseHandler(workInProgress), $00be48392311af6a$var$popHiddenContext(), null !== current && $00be48392311af6a$var$pop($00be48392311af6a$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $00be48392311af6a$var$popProvider($00be48392311af6a$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $00be48392311af6a$var$unwindInterruptedWork(current, interruptedWork) {
    $00be48392311af6a$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $00be48392311af6a$var$popProvider($00be48392311af6a$var$CacheContext);
            $00be48392311af6a$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $00be48392311af6a$var$popHostContext(interruptedWork);
            break;
        case 4:
            $00be48392311af6a$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $00be48392311af6a$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $00be48392311af6a$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $00be48392311af6a$var$popSuspenseListContext(interruptedWork);
            break;
        case 10:
            $00be48392311af6a$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $00be48392311af6a$var$popSuspenseHandler(interruptedWork);
            $00be48392311af6a$var$popHiddenContext();
            null !== current && $00be48392311af6a$var$pop($00be48392311af6a$var$resumedCache);
            break;
        case 24:
            $00be48392311af6a$var$popProvider($00be48392311af6a$var$CacheContext);
    }
}
function $00be48392311af6a$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $00be48392311af6a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $00be48392311af6a$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $00be48392311af6a$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $00be48392311af6a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $00be48392311af6a$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $00be48392311af6a$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $00be48392311af6a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $00be48392311af6a$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $00be48392311af6a$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $00be48392311af6a$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $00be48392311af6a$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    var instance = current.stateNode, name = $00be48392311af6a$var$getViewTransitionName(current.memoizedProps, instance);
                    if (null === instance.ref || instance.ref.name !== name) instance.ref = $00be48392311af6a$var$createViewTransitionInstance(name);
                    instanceToUse = instance.ref;
                    break;
                case 7:
                    if (null === current.stateNode) {
                        var fragmentInstance = new $00be48392311af6a$var$FragmentInstance(current);
                        $00be48392311af6a$var$traverseVisibleInstancesAndTextInstances(current.child, !1, $00be48392311af6a$var$addFragmentHandleToFiber, fragmentInstance, void 0, void 0);
                        current.stateNode = fragmentInstance;
                    }
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $00be48392311af6a$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $00be48392311af6a$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $00be48392311af6a$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$148) {
            $00be48392311af6a$var$captureCommitPhaseError(current, nearestMountedAncestor, error$148);
        }
        else ref.current = null;
    }
}
function $00be48392311af6a$var$commitNewChildToFragmentInstances(fiber, parentFragmentInstances) {
    if ((5 === fiber.tag || 27 === fiber.tag || 6 === fiber.tag) && null === fiber.alternate && null !== parentFragmentInstances) for(var i = 0; i < parentFragmentInstances.length; i++)$00be48392311af6a$var$commitNewChildToFragmentInstance(fiber.stateNode, parentFragmentInstances[i]);
}
function $00be48392311af6a$var$commitFragmentInstanceInsertionEffects(fiber) {
    for(var parent = fiber.return; null !== parent;){
        $00be48392311af6a$var$isFragmentInstanceParent(parent) && $00be48392311af6a$var$commitNewChildToFragmentInstance(fiber.stateNode, parent.stateNode);
        if ($00be48392311af6a$var$isFragmentInstanceHostBoundary(parent)) break;
        parent = parent.return;
    }
}
function $00be48392311af6a$var$commitFragmentInstanceDeletionEffects(fiber) {
    for(var parent = fiber.return; null !== parent;){
        $00be48392311af6a$var$isFragmentInstanceParent(parent) && $00be48392311af6a$var$deleteChildFromFragmentInstance(fiber.stateNode, parent.stateNode);
        if ($00be48392311af6a$var$isFragmentInstanceHostBoundary(parent)) break;
        parent = parent.return;
    }
}
function $00be48392311af6a$var$isFragmentInstanceHostBoundary(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 27 === fiber.tag;
}
function $00be48392311af6a$var$isFragmentInstanceParent(fiber) {
    return fiber && 7 === fiber.tag && null !== fiber.stateNode;
}
function $00be48392311af6a$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $00be48392311af6a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $00be48392311af6a$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $00be48392311af6a$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$00be48392311af6a$var$internalPropsKey] = newProps;
    } catch (error) {
        $00be48392311af6a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $00be48392311af6a$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $00be48392311af6a$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $00be48392311af6a$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $00be48392311af6a$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $00be48392311af6a$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $00be48392311af6a$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) tag = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(tag, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(tag), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $00be48392311af6a$var$noop$1)), $00be48392311af6a$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), $00be48392311af6a$var$viewTransitionMutationContext = !0;
    else if (4 !== tag && (27 === tag && ($00be48392311af6a$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, $00be48392311af6a$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null)), node = node.child, null !== node)) for($00be48392311af6a$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)$00be48392311af6a$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling;
}
function $00be48392311af6a$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) tag = node.stateNode, before ? parent.insertBefore(tag, before) : parent.appendChild(tag), $00be48392311af6a$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), $00be48392311af6a$var$viewTransitionMutationContext = !0;
    else if (4 !== tag && (27 === tag && ($00be48392311af6a$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, $00be48392311af6a$var$isSingletonScope(node.type) && (parent = node.stateNode)), node = node.child, null !== node)) for($00be48392311af6a$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)$00be48392311af6a$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling;
}
function $00be48392311af6a$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $00be48392311af6a$var$setInitialProperties(singleton, type, props);
        singleton[$00be48392311af6a$var$internalInstanceKey] = finishedWork;
        singleton[$00be48392311af6a$var$internalPropsKey] = props;
    } catch (error) {
        $00be48392311af6a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $00be48392311af6a$var$shouldStartViewTransition = !1, $00be48392311af6a$var$appearingViewTransitions = null;
function $00be48392311af6a$var$trackEnterViewTransitions(placement) {
    if (30 === placement.tag || 0 !== (placement.subtreeFlags & 33554432)) $00be48392311af6a$var$shouldStartViewTransition = !0;
}
var $00be48392311af6a$var$viewTransitionCancelableChildren = null;
function $00be48392311af6a$var$pushViewTransitionCancelableScope() {
    var prevChildren = $00be48392311af6a$var$viewTransitionCancelableChildren;
    $00be48392311af6a$var$viewTransitionCancelableChildren = null;
    return prevChildren;
}
var $00be48392311af6a$var$viewTransitionHostInstanceIdx = 0;
function $00be48392311af6a$var$applyViewTransitionToHostInstances(fiber, name, className, collectMeasurements, stopAtNestedViewTransitions) {
    $00be48392311af6a$var$viewTransitionHostInstanceIdx = 0;
    return $00be48392311af6a$var$applyViewTransitionToHostInstancesRecursive(fiber.child, name, className, collectMeasurements, stopAtNestedViewTransitions);
}
function $00be48392311af6a$var$applyViewTransitionToHostInstancesRecursive(child, name, className, collectMeasurements, stopAtNestedViewTransitions) {
    for(var inViewport = !1; null !== child;){
        if (5 === child.tag) {
            var instance = child.stateNode;
            if (null !== collectMeasurements) {
                var measurement = $00be48392311af6a$var$measureInstance(instance);
                collectMeasurements.push(measurement);
                measurement.view && (inViewport = !0);
            } else inViewport || $00be48392311af6a$var$measureInstance(instance).view && (inViewport = !0);
            $00be48392311af6a$var$shouldStartViewTransition = !0;
            $00be48392311af6a$var$applyViewTransitionName(instance, 0 === $00be48392311af6a$var$viewTransitionHostInstanceIdx ? name : name + "_" + $00be48392311af6a$var$viewTransitionHostInstanceIdx, className);
            $00be48392311af6a$var$viewTransitionHostInstanceIdx++;
        } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || $00be48392311af6a$var$applyViewTransitionToHostInstancesRecursive(child.child, name, className, collectMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
        child = child.sibling;
    }
    return inViewport;
}
function $00be48392311af6a$var$restoreViewTransitionOnHostInstances(child, stopAtNestedViewTransitions) {
    for(; null !== child;){
        if (5 === child.tag) $00be48392311af6a$var$restoreViewTransitionName(child.stateNode, child.memoizedProps);
        else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || $00be48392311af6a$var$restoreViewTransitionOnHostInstances(child.child, stopAtNestedViewTransitions);
        child = child.sibling;
    }
}
function $00be48392311af6a$var$commitAppearingPairViewTransitions(placement) {
    if (0 !== (placement.subtreeFlags & 18874368)) for(placement = placement.child; null !== placement;){
        if (22 !== placement.tag || null === placement.memoizedState) {
            if ($00be48392311af6a$var$commitAppearingPairViewTransitions(placement), 30 === placement.tag && 0 !== (placement.flags & 18874368) && placement.stateNode.paired) {
                var props = placement.memoizedProps;
                if (null == props.name || "auto" === props.name) throw Error($00be48392311af6a$var$formatProdErrorMessage(544));
                var name = props.name;
                props = $00be48392311af6a$var$getViewTransitionClassName(props.default, props.share);
                "none" !== props && ($00be48392311af6a$var$applyViewTransitionToHostInstances(placement, name, props, null, !1) || $00be48392311af6a$var$restoreViewTransitionOnHostInstances(placement.child, !1));
            }
        }
        placement = placement.sibling;
    }
}
function $00be48392311af6a$var$commitEnterViewTransitions(placement, gesture) {
    if (30 === placement.tag) {
        var state = placement.stateNode, props = placement.memoizedProps, name = $00be48392311af6a$var$getViewTransitionName(props, state), className = $00be48392311af6a$var$getViewTransitionClassName(props.default, state.paired ? props.share : props.enter);
        "none" !== className ? $00be48392311af6a$var$applyViewTransitionToHostInstances(placement, name, className, null, !1) ? ($00be48392311af6a$var$commitAppearingPairViewTransitions(placement), state.paired || gesture || $00be48392311af6a$var$scheduleViewTransitionEvent(placement, props.onEnter)) : $00be48392311af6a$var$restoreViewTransitionOnHostInstances(placement.child, !1) : $00be48392311af6a$var$commitAppearingPairViewTransitions(placement);
    } else if (0 !== (placement.subtreeFlags & 33554432)) for(placement = placement.child; null !== placement;)$00be48392311af6a$var$commitEnterViewTransitions(placement, gesture), placement = placement.sibling;
    else $00be48392311af6a$var$commitAppearingPairViewTransitions(placement);
}
function $00be48392311af6a$var$commitDeletedPairViewTransitions(deletion) {
    if (null !== $00be48392311af6a$var$appearingViewTransitions && 0 !== $00be48392311af6a$var$appearingViewTransitions.size) {
        var pairs = $00be48392311af6a$var$appearingViewTransitions;
        if (0 !== (deletion.subtreeFlags & 18874368)) for(deletion = deletion.child; null !== deletion;){
            if (22 !== deletion.tag || null === deletion.memoizedState) {
                if (30 === deletion.tag && 0 !== (deletion.flags & 18874368)) {
                    var props = deletion.memoizedProps, name = props.name;
                    if (null != name && "auto" !== name) {
                        var pair = pairs.get(name);
                        if (void 0 !== pair) {
                            var className = $00be48392311af6a$var$getViewTransitionClassName(props.default, props.share);
                            "none" !== className && ($00be48392311af6a$var$applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, $00be48392311af6a$var$scheduleViewTransitionEvent(deletion, props.onShare)) : $00be48392311af6a$var$restoreViewTransitionOnHostInstances(deletion.child, !1));
                            pairs.delete(name);
                            if (0 === pairs.size) break;
                        }
                    }
                }
                $00be48392311af6a$var$commitDeletedPairViewTransitions(deletion);
            }
            deletion = deletion.sibling;
        }
    }
}
function $00be48392311af6a$var$commitExitViewTransitions(deletion) {
    if (30 === deletion.tag) {
        var props = deletion.memoizedProps, name = $00be48392311af6a$var$getViewTransitionName(props, deletion.stateNode), pair = null !== $00be48392311af6a$var$appearingViewTransitions ? $00be48392311af6a$var$appearingViewTransitions.get(name) : void 0, className = $00be48392311af6a$var$getViewTransitionClassName(props.default, void 0 !== pair ? props.share : props.exit);
        "none" !== className && ($00be48392311af6a$var$applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? void 0 !== pair ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, $00be48392311af6a$var$appearingViewTransitions.delete(name), $00be48392311af6a$var$scheduleViewTransitionEvent(deletion, props.onShare)) : $00be48392311af6a$var$scheduleViewTransitionEvent(deletion, props.onExit) : $00be48392311af6a$var$restoreViewTransitionOnHostInstances(deletion.child, !1));
        null !== $00be48392311af6a$var$appearingViewTransitions && $00be48392311af6a$var$commitDeletedPairViewTransitions(deletion);
    } else if (0 !== (deletion.subtreeFlags & 33554432)) for(deletion = deletion.child; null !== deletion;)$00be48392311af6a$var$commitExitViewTransitions(deletion), deletion = deletion.sibling;
    else null !== $00be48392311af6a$var$appearingViewTransitions && $00be48392311af6a$var$commitDeletedPairViewTransitions(deletion);
}
function $00be48392311af6a$var$commitNestedViewTransitions(changedParent) {
    for(changedParent = changedParent.child; null !== changedParent;){
        if (30 === changedParent.tag) {
            var props = changedParent.memoizedProps, name = $00be48392311af6a$var$getViewTransitionName(props, changedParent.stateNode);
            props = $00be48392311af6a$var$getViewTransitionClassName(props.default, props.update);
            changedParent.flags &= -5;
            "none" !== props && $00be48392311af6a$var$applyViewTransitionToHostInstances(changedParent, name, props, changedParent.memoizedState = [], !1);
        } else 0 !== (changedParent.subtreeFlags & 33554432) && $00be48392311af6a$var$commitNestedViewTransitions(changedParent);
        changedParent = changedParent.sibling;
    }
}
function $00be48392311af6a$var$restorePairedViewTransitions(parent) {
    if (0 !== (parent.subtreeFlags & 18874368)) for(parent = parent.child; null !== parent;){
        if (22 !== parent.tag || null === parent.memoizedState) {
            if (30 === parent.tag && 0 !== (parent.flags & 18874368)) {
                var instance = parent.stateNode;
                null !== instance.paired && (instance.paired = null, $00be48392311af6a$var$restoreViewTransitionOnHostInstances(parent.child, !1));
            }
            $00be48392311af6a$var$restorePairedViewTransitions(parent);
        }
        parent = parent.sibling;
    }
}
function $00be48392311af6a$var$restoreEnterOrExitViewTransitions(fiber) {
    if (30 === fiber.tag) fiber.stateNode.paired = null, $00be48392311af6a$var$restoreViewTransitionOnHostInstances(fiber.child, !1), $00be48392311af6a$var$restorePairedViewTransitions(fiber);
    else if (0 !== (fiber.subtreeFlags & 33554432)) for(fiber = fiber.child; null !== fiber;)$00be48392311af6a$var$restoreEnterOrExitViewTransitions(fiber), fiber = fiber.sibling;
    else $00be48392311af6a$var$restorePairedViewTransitions(fiber);
}
function $00be48392311af6a$var$restoreNestedViewTransitions(changedParent) {
    for(changedParent = changedParent.child; null !== changedParent;)30 === changedParent.tag ? $00be48392311af6a$var$restoreViewTransitionOnHostInstances(changedParent.child, !1) : 0 !== (changedParent.subtreeFlags & 33554432) && $00be48392311af6a$var$restoreNestedViewTransitions(changedParent), changedParent = changedParent.sibling;
}
function $00be48392311af6a$var$measureViewTransitionHostInstancesRecursive(parentViewTransition, child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) {
    for(var inViewport = !1; null !== child;){
        if (5 === child.tag) {
            var instance = child.stateNode;
            if (null !== previousMeasurements && $00be48392311af6a$var$viewTransitionHostInstanceIdx < previousMeasurements.length) {
                var previousMeasurement = previousMeasurements[$00be48392311af6a$var$viewTransitionHostInstanceIdx], nextMeasurement = $00be48392311af6a$var$measureInstance(instance);
                if (previousMeasurement.view || nextMeasurement.view) inViewport = !0;
                var JSCompiler_temp;
                if (JSCompiler_temp = 0 === (parentViewTransition.flags & 4)) {
                    if (nextMeasurement.clip) JSCompiler_temp = !0;
                    else {
                        JSCompiler_temp = previousMeasurement.rect;
                        var newRect = nextMeasurement.rect;
                        JSCompiler_temp = JSCompiler_temp.y !== newRect.y || JSCompiler_temp.x !== newRect.x || JSCompiler_temp.height !== newRect.height || JSCompiler_temp.width !== newRect.width;
                    }
                }
                JSCompiler_temp && (parentViewTransition.flags |= 4);
                nextMeasurement.abs ? nextMeasurement = !previousMeasurement.abs : (previousMeasurement = previousMeasurement.rect, nextMeasurement = nextMeasurement.rect, nextMeasurement = previousMeasurement.height !== nextMeasurement.height || previousMeasurement.width !== nextMeasurement.width);
                nextMeasurement && (parentViewTransition.flags |= 32);
            } else parentViewTransition.flags |= 32;
            0 !== (parentViewTransition.flags & 4) && $00be48392311af6a$var$applyViewTransitionName(instance, 0 === $00be48392311af6a$var$viewTransitionHostInstanceIdx ? newName : newName + "_" + $00be48392311af6a$var$viewTransitionHostInstanceIdx, className);
            inViewport && 0 !== (parentViewTransition.flags & 4) || (null === $00be48392311af6a$var$viewTransitionCancelableChildren && ($00be48392311af6a$var$viewTransitionCancelableChildren = []), $00be48392311af6a$var$viewTransitionCancelableChildren.push(instance, 0 === $00be48392311af6a$var$viewTransitionHostInstanceIdx ? oldName : oldName + "_" + $00be48392311af6a$var$viewTransitionHostInstanceIdx, child.memoizedProps));
            $00be48392311af6a$var$viewTransitionHostInstanceIdx++;
        } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions ? parentViewTransition.flags |= child.flags & 32 : $00be48392311af6a$var$measureViewTransitionHostInstancesRecursive(parentViewTransition, child.child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
        child = child.sibling;
    }
    return inViewport;
}
function $00be48392311af6a$var$measureNestedViewTransitions(changedParent, gesture) {
    for(changedParent = changedParent.child; null !== changedParent;){
        if (30 === changedParent.tag) {
            var props = changedParent.memoizedProps, state = changedParent.stateNode, name = $00be48392311af6a$var$getViewTransitionName(props, state), className = $00be48392311af6a$var$getViewTransitionClassName(props.default, props.update);
            if (gesture) {
                state = state.clones;
                var previousMeasurements = null === state ? null : state.map($00be48392311af6a$var$measureClonedInstance);
            } else previousMeasurements = changedParent.memoizedState, changedParent.memoizedState = null;
            state = changedParent;
            var child = changedParent.child;
            $00be48392311af6a$var$viewTransitionHostInstanceIdx = 0;
            name = $00be48392311af6a$var$measureViewTransitionHostInstancesRecursive(state, child, name, name, className, previousMeasurements, !1);
            0 !== (changedParent.flags & 4) && name && (gesture || $00be48392311af6a$var$scheduleViewTransitionEvent(changedParent, props.onUpdate));
        } else 0 !== (changedParent.subtreeFlags & 33554432) && $00be48392311af6a$var$measureNestedViewTransitions(changedParent, gesture);
        changedParent = changedParent.sibling;
    }
}
var $00be48392311af6a$var$offscreenSubtreeIsHidden = !1, $00be48392311af6a$var$offscreenSubtreeWasHidden = !1, $00be48392311af6a$var$offscreenDirectParentIsHidden = !1, $00be48392311af6a$var$needsFormReset = !1, $00be48392311af6a$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $00be48392311af6a$var$nextEffect = null, $00be48392311af6a$var$viewTransitionContextChanged = !1, $00be48392311af6a$var$inUpdateViewTransition = !1, $00be48392311af6a$var$rootViewTransitionAffected = !1, $00be48392311af6a$var$rootViewTransitionNameCanceled = !1;
function $00be48392311af6a$var$commitBeforeMutationEffects(root, firstChild, committedLanes) {
    root = root.containerInfo;
    $00be48392311af6a$var$eventsEnabled = $00be48392311af6a$var$_enabled;
    root = $00be48392311af6a$var$getActiveElementDeep(root);
    if ($00be48392311af6a$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$21) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $00be48392311af6a$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $00be48392311af6a$var$_enabled = !1;
    committedLanes = (committedLanes & 335544064) === committedLanes;
    $00be48392311af6a$var$nextEffect = firstChild;
    for(firstChild = committedLanes ? 9270 : 1024; null !== $00be48392311af6a$var$nextEffect;){
        root = $00be48392311af6a$var$nextEffect;
        if (committedLanes && (JSCompiler_temp = root.deletions, null !== JSCompiler_temp)) for(anchorOffset = 0; anchorOffset < JSCompiler_temp.length; anchorOffset++)committedLanes && $00be48392311af6a$var$commitExitViewTransitions(JSCompiler_temp[anchorOffset]);
        if (null === root.alternate && 0 !== (root.flags & 2)) committedLanes && $00be48392311af6a$var$trackEnterViewTransitions(root), $00be48392311af6a$var$commitBeforeMutationEffects_complete(committedLanes);
        else {
            if (22 === root.tag) {
                if (JSCompiler_temp = root.alternate, null !== root.memoizedState) {
                    null !== JSCompiler_temp && null === JSCompiler_temp.memoizedState && committedLanes && $00be48392311af6a$var$commitExitViewTransitions(JSCompiler_temp);
                    $00be48392311af6a$var$commitBeforeMutationEffects_complete(committedLanes);
                    continue;
                } else if (null !== JSCompiler_temp && null !== JSCompiler_temp.memoizedState) {
                    committedLanes && $00be48392311af6a$var$trackEnterViewTransitions(root);
                    $00be48392311af6a$var$commitBeforeMutationEffects_complete(committedLanes);
                    continue;
                }
            }
            JSCompiler_temp = root.child;
            0 !== (root.subtreeFlags & firstChild) && null !== JSCompiler_temp ? (JSCompiler_temp.return = root, $00be48392311af6a$var$nextEffect = JSCompiler_temp) : (committedLanes && $00be48392311af6a$var$commitNestedViewTransitions(root), $00be48392311af6a$var$commitBeforeMutationEffects_complete(committedLanes));
        }
    }
    $00be48392311af6a$var$appearingViewTransitions = null;
}
function $00be48392311af6a$var$commitBeforeMutationEffects_complete(isViewTransitionEligible$jscomp$0) {
    for(; null !== $00be48392311af6a$var$nextEffect;){
        var fiber = $00be48392311af6a$var$nextEffect, isViewTransitionEligible = isViewTransitionEligible$jscomp$0, current = fiber.alternate, flags = fiber.flags;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (flags & 1024) && null !== current) {
                    isViewTransitionEligible = void 0;
                    flags = current.memoizedProps;
                    current = current.memoizedState;
                    var instance = fiber.stateNode;
                    try {
                        var resolvedPrevProps = $00be48392311af6a$var$resolveClassComponentProps(fiber.type, flags);
                        isViewTransitionEligible = instance.getSnapshotBeforeUpdate(resolvedPrevProps, current);
                        instance.__reactInternalSnapshotBeforeUpdate = isViewTransitionEligible;
                    } catch (error) {
                        $00be48392311af6a$var$captureCommitPhaseError(fiber, fiber.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (flags & 1024)) {
                    if (current = fiber.stateNode.containerInfo, isViewTransitionEligible = current.nodeType, 9 === isViewTransitionEligible) $00be48392311af6a$var$clearContainerSparingly(current);
                    else if (1 === isViewTransitionEligible) switch(current.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $00be48392311af6a$var$clearContainerSparingly(current);
                            break;
                        default:
                            current.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            case 30:
                isViewTransitionEligible && null !== current && (isViewTransitionEligible = $00be48392311af6a$var$getViewTransitionName(current.memoizedProps, current.stateNode), flags = fiber.memoizedProps, flags = $00be48392311af6a$var$getViewTransitionClassName(flags.default, flags.update), "none" !== flags && $00be48392311af6a$var$applyViewTransitionToHostInstances(current, isViewTransitionEligible, flags, current.memoizedState = [], !0));
                break;
            default:
                if (0 !== (flags & 1024)) throw Error($00be48392311af6a$var$formatProdErrorMessage(163));
        }
        current = fiber.sibling;
        if (null !== current) {
            current.return = fiber.return;
            $00be48392311af6a$var$nextEffect = current;
            break;
        }
        $00be48392311af6a$var$nextEffect = fiber.return;
    }
}
function $00be48392311af6a$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $00be48392311af6a$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $00be48392311af6a$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $00be48392311af6a$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $00be48392311af6a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $00be48392311af6a$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$146) {
                        $00be48392311af6a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$146);
                    }
                }
            }
            flags & 64 && $00be48392311af6a$var$commitClassCallbacks(finishedWork);
            flags & 512 && $00be48392311af6a$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $00be48392311af6a$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $00be48392311af6a$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $00be48392311af6a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $00be48392311af6a$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $00be48392311af6a$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $00be48392311af6a$var$commitHostMount(finishedWork);
            flags & 512 && $00be48392311af6a$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $00be48392311af6a$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $00be48392311af6a$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $00be48392311af6a$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $00be48392311af6a$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $00be48392311af6a$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $00be48392311af6a$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $00be48392311af6a$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $00be48392311af6a$var$offscreenSubtreeIsHidden;
            if (!flags) {
                var newOffscreenSubtreeWasHidden = null !== current && null !== current.memoizedState || $00be48392311af6a$var$offscreenSubtreeWasHidden;
                current = $00be48392311af6a$var$offscreenSubtreeIsHidden;
                prevProps = $00be48392311af6a$var$offscreenSubtreeWasHidden;
                $00be48392311af6a$var$offscreenSubtreeIsHidden = flags;
                ($00be48392311af6a$var$offscreenSubtreeWasHidden = newOffscreenSubtreeWasHidden) && !prevProps ? (flags = 2, 0 !== (finishedWork.subtreeFlags & 8772) && (flags |= 1), $00be48392311af6a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, flags)) : $00be48392311af6a$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $00be48392311af6a$var$offscreenSubtreeIsHidden = current;
                $00be48392311af6a$var$offscreenSubtreeWasHidden = prevProps;
            }
            break;
        case 30:
            $00be48392311af6a$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 512 && $00be48392311af6a$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 7:
            flags & 512 && $00be48392311af6a$var$safelyAttachRef(finishedWork, finishedWork.return);
        default:
            $00be48392311af6a$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $00be48392311af6a$var$hideOrUnhideAllChildren(parentFiber, isHidden) {
    for(parentFiber = parentFiber.child; null !== parentFiber;)$00be48392311af6a$var$hideOrUnhideAllChildrenOnFiber(parentFiber, isHidden), parentFiber = parentFiber.sibling;
}
function $00be48392311af6a$var$hideOrUnhideAllChildrenOnFiber(fiber, isHidden) {
    switch(fiber.tag){
        case 5:
        case 26:
            try {
                var instance = fiber.stateNode;
                if (isHidden) {
                    var style = instance.style;
                    "function" === typeof style.setProperty ? style.setProperty("display", "none", "important") : style.display = "none";
                } else {
                    var instance$jscomp$0 = fiber.stateNode, styleProp = fiber.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                    instance$jscomp$0.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                }
            } catch (error) {
                $00be48392311af6a$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            $00be48392311af6a$var$hideOrUnhideNearestPortals(fiber, isHidden);
            break;
        case 6:
            try {
                fiber.stateNode.nodeValue = isHidden ? "" : fiber.memoizedProps, $00be48392311af6a$var$viewTransitionMutationContext = !0;
            } catch (error) {
                $00be48392311af6a$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            break;
        case 18:
            try {
                var instance$jscomp$1 = fiber.stateNode;
                isHidden ? $00be48392311af6a$var$hideOrUnhideDehydratedBoundary(instance$jscomp$1, !0) : $00be48392311af6a$var$hideOrUnhideDehydratedBoundary(fiber.stateNode, !1);
            } catch (error) {
                $00be48392311af6a$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            break;
        case 22:
        case 23:
            null === fiber.memoizedState && $00be48392311af6a$var$hideOrUnhideAllChildren(fiber, isHidden);
            break;
        default:
            $00be48392311af6a$var$hideOrUnhideAllChildren(fiber, isHidden);
    }
}
function $00be48392311af6a$var$hideOrUnhideNearestPortals(parentFiber, isHidden$jscomp$0) {
    if (parentFiber.subtreeFlags & 67108864) for(parentFiber = parentFiber.child; null !== parentFiber;){
        a: {
            var fiber = parentFiber, isHidden = isHidden$jscomp$0;
            switch(fiber.tag){
                case 4:
                    $00be48392311af6a$var$hideOrUnhideAllChildrenOnFiber(fiber, isHidden);
                    break a;
                case 22:
                    null === fiber.memoizedState && $00be48392311af6a$var$hideOrUnhideNearestPortals(fiber, isHidden);
                    break a;
                default:
                    $00be48392311af6a$var$hideOrUnhideNearestPortals(fiber, isHidden);
            }
        }
        parentFiber = parentFiber.sibling;
    }
}
function $00be48392311af6a$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $00be48392311af6a$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $00be48392311af6a$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $00be48392311af6a$var$hostParent = null, $00be48392311af6a$var$hostParentIsContainer = !1;
function $00be48392311af6a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$00be48392311af6a$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $00be48392311af6a$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($00be48392311af6a$var$injectedHook && "function" === typeof $00be48392311af6a$var$injectedHook.onCommitFiberUnmount) try {
        $00be48392311af6a$var$injectedHook.onCommitFiberUnmount($00be48392311af6a$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $00be48392311af6a$var$offscreenSubtreeWasHidden || $00be48392311af6a$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $00be48392311af6a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && !$00be48392311af6a$var$offscreenSubtreeWasHidden && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $00be48392311af6a$var$offscreenSubtreeWasHidden || $00be48392311af6a$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $00be48392311af6a$var$commitFragmentInstanceDeletionEffects(deletedFiber);
            var prevHostParent = $00be48392311af6a$var$hostParent, prevHostParentIsContainer = $00be48392311af6a$var$hostParentIsContainer;
            $00be48392311af6a$var$isSingletonScope(deletedFiber.type) && ($00be48392311af6a$var$hostParent = deletedFiber.stateNode, $00be48392311af6a$var$hostParentIsContainer = !1);
            $00be48392311af6a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $00be48392311af6a$var$releaseSingletonInstance(deletedFiber.stateNode, deletedFiber.type, deletedFiber.memoizedProps);
            $00be48392311af6a$var$hostParent = prevHostParent;
            $00be48392311af6a$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $00be48392311af6a$var$offscreenSubtreeWasHidden || $00be48392311af6a$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), $00be48392311af6a$var$commitFragmentInstanceDeletionEffects(deletedFiber);
        case 6:
            6 === deletedFiber.tag && $00be48392311af6a$var$commitFragmentInstanceDeletionEffects(deletedFiber);
            prevHostParent = $00be48392311af6a$var$hostParent;
            prevHostParentIsContainer = $00be48392311af6a$var$hostParentIsContainer;
            $00be48392311af6a$var$hostParent = null;
            $00be48392311af6a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $00be48392311af6a$var$hostParent = prevHostParent;
            $00be48392311af6a$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $00be48392311af6a$var$hostParent) {
                if ($00be48392311af6a$var$hostParentIsContainer) try {
                    (9 === $00be48392311af6a$var$hostParent.nodeType ? $00be48392311af6a$var$hostParent.body : "HTML" === $00be48392311af6a$var$hostParent.nodeName ? $00be48392311af6a$var$hostParent.ownerDocument.body : $00be48392311af6a$var$hostParent).removeChild(deletedFiber.stateNode), $00be48392311af6a$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $00be48392311af6a$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $00be48392311af6a$var$hostParent.removeChild(deletedFiber.stateNode), $00be48392311af6a$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $00be48392311af6a$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $00be48392311af6a$var$hostParent && ($00be48392311af6a$var$hostParentIsContainer ? (finishedRoot = $00be48392311af6a$var$hostParent, $00be48392311af6a$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $00be48392311af6a$var$retryIfBlockedOn(finishedRoot)) : $00be48392311af6a$var$clearHydrationBoundary($00be48392311af6a$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $00be48392311af6a$var$hostParent;
            prevHostParentIsContainer = $00be48392311af6a$var$hostParentIsContainer;
            $00be48392311af6a$var$hostParent = deletedFiber.stateNode.containerInfo;
            $00be48392311af6a$var$hostParentIsContainer = !0;
            $00be48392311af6a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $00be48392311af6a$var$hostParent = prevHostParent;
            $00be48392311af6a$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $00be48392311af6a$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $00be48392311af6a$var$offscreenSubtreeWasHidden || $00be48392311af6a$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $00be48392311af6a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $00be48392311af6a$var$offscreenSubtreeWasHidden || ($00be48392311af6a$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $00be48392311af6a$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $00be48392311af6a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $00be48392311af6a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $00be48392311af6a$var$offscreenSubtreeWasHidden = (prevHostParent = $00be48392311af6a$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $00be48392311af6a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $00be48392311af6a$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        case 30:
            $00be48392311af6a$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $00be48392311af6a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 7:
            $00be48392311af6a$var$offscreenSubtreeWasHidden || $00be48392311af6a$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $00be48392311af6a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        default:
            $00be48392311af6a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $00be48392311af6a$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $00be48392311af6a$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $00be48392311af6a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $00be48392311af6a$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $00be48392311af6a$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $00be48392311af6a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $00be48392311af6a$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $00be48392311af6a$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $00be48392311af6a$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($00be48392311af6a$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $00be48392311af6a$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $00be48392311af6a$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $00be48392311af6a$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $00be48392311af6a$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber, lanes) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($00be48392311af6a$var$isSingletonScope(parent.type)) {
                        $00be48392311af6a$var$hostParent = parent.stateNode;
                        $00be48392311af6a$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $00be48392311af6a$var$hostParent = parent.stateNode;
                    $00be48392311af6a$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $00be48392311af6a$var$hostParent = parent.stateNode.containerInfo;
                    $00be48392311af6a$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $00be48392311af6a$var$hostParent) throw Error($00be48392311af6a$var$formatProdErrorMessage(160));
        $00be48392311af6a$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $00be48392311af6a$var$hostParent = null;
        $00be48392311af6a$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$00be48392311af6a$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0, lanes), parentFiber = parentFiber.sibling;
}
var $00be48392311af6a$var$currentHoistableRoot = null;
function $00be48392311af6a$var$commitMutationEffectsOnFiber(finishedWork, root, lanes) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            if (flags & 4 && (current = finishedWork.updateQueue, current = null !== current ? current.events : null, null !== current)) for(var ii = 0; ii < current.length; ii++){
                var _eventPayloads$ii2 = current[ii];
                _eventPayloads$ii2.ref.impl = _eventPayloads$ii2.nextImpl;
            }
            $00be48392311af6a$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $00be48392311af6a$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($00be48392311af6a$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $00be48392311af6a$var$commitHookEffectListMount(3, finishedWork), $00be48392311af6a$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $00be48392311af6a$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $00be48392311af6a$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($00be48392311af6a$var$offscreenSubtreeWasHidden || null === current || $00be48392311af6a$var$safelyDetachRef(current, current.return));
            flags & 64 && $00be48392311af6a$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (root = finishedWork.callbacks, null !== root && (lanes = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === lanes ? root : lanes.concat(root))));
            break;
        case 26:
            ii = $00be48392311af6a$var$currentHoistableRoot;
            $00be48392311af6a$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $00be48392311af6a$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($00be48392311af6a$var$offscreenSubtreeWasHidden || null === current || $00be48392311af6a$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                if (flags = null !== current ? current.memoizedState : null, lanes = finishedWork.memoizedState, null === current) {
                    if (null === lanes) {
                        if (null === finishedWork.stateNode) {
                            if ($00be48392311af6a$var$offscreenSubtreeIsHidden) finishedWork.stateNode = $00be48392311af6a$var$createHoistableInstance(finishedWork.type, finishedWork.memoizedProps, root.containerInfo, finishedWork);
                            else {
                                a: {
                                    root = finishedWork.type;
                                    lanes = finishedWork.memoizedProps;
                                    flags = ii.ownerDocument || ii;
                                    b: switch(root){
                                        case "title":
                                            current = flags.getElementsByTagName("title")[0];
                                            if (!current || current[$00be48392311af6a$var$internalHoistableMarker] || current[$00be48392311af6a$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === current.namespaceURI || current.hasAttribute("itemprop")) current = flags.createElement(root), flags.head.insertBefore(current, flags.querySelector("head > title"));
                                            $00be48392311af6a$var$setInitialProperties(current, root, lanes);
                                            current[$00be48392311af6a$var$internalInstanceKey] = finishedWork;
                                            $00be48392311af6a$var$markNodeAsHoistable(current);
                                            root = current;
                                            break a;
                                        case "link":
                                            if (ii = $00be48392311af6a$var$getHydratableHoistableCache("link", "href", flags).get(root + (lanes.href || ""))) {
                                                for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], current.getAttribute("href") === (null == lanes.href || "" === lanes.href ? null : lanes.href) && current.getAttribute("rel") === (null == lanes.rel ? null : lanes.rel) && current.getAttribute("title") === (null == lanes.title ? null : lanes.title) && current.getAttribute("crossorigin") === (null == lanes.crossOrigin ? null : lanes.crossOrigin)) {
                                                    ii.splice(_eventPayloads$ii2, 1);
                                                    break b;
                                                }
                                            }
                                            current = flags.createElement(root);
                                            $00be48392311af6a$var$setInitialProperties(current, root, lanes);
                                            flags.head.appendChild(current);
                                            break;
                                        case "meta":
                                            if (ii = $00be48392311af6a$var$getHydratableHoistableCache("meta", "content", flags).get(root + (lanes.content || ""))) {
                                                for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], current.getAttribute("content") === (null == lanes.content ? null : "" + lanes.content) && current.getAttribute("name") === (null == lanes.name ? null : lanes.name) && current.getAttribute("property") === (null == lanes.property ? null : lanes.property) && current.getAttribute("http-equiv") === (null == lanes.httpEquiv ? null : lanes.httpEquiv) && current.getAttribute("charset") === (null == lanes.charSet ? null : lanes.charSet)) {
                                                    ii.splice(_eventPayloads$ii2, 1);
                                                    break b;
                                                }
                                            }
                                            current = flags.createElement(root);
                                            $00be48392311af6a$var$setInitialProperties(current, root, lanes);
                                            flags.head.appendChild(current);
                                            break;
                                        default:
                                            throw Error($00be48392311af6a$var$formatProdErrorMessage(468, root));
                                    }
                                    current[$00be48392311af6a$var$internalInstanceKey] = finishedWork;
                                    $00be48392311af6a$var$markNodeAsHoistable(current);
                                    root = current;
                                }
                                finishedWork.stateNode = root;
                            }
                        } else $00be48392311af6a$var$offscreenSubtreeIsHidden || $00be48392311af6a$var$mountHoistable(ii, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $00be48392311af6a$var$acquireResource(ii, lanes, finishedWork.memoizedProps);
                } else flags !== lanes ? (null === flags ? (root = current.stateNode, null === root || $00be48392311af6a$var$offscreenSubtreeWasHidden || root.parentNode.removeChild(root)) : flags.count--, null === lanes ? $00be48392311af6a$var$offscreenSubtreeIsHidden || $00be48392311af6a$var$mountHoistable(ii, finishedWork.type, finishedWork.stateNode) : $00be48392311af6a$var$acquireResource(ii, lanes, finishedWork.memoizedProps)) : null === lanes && null !== finishedWork.stateNode && $00be48392311af6a$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $00be48392311af6a$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $00be48392311af6a$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($00be48392311af6a$var$offscreenSubtreeWasHidden || null === current || $00be48392311af6a$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $00be48392311af6a$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            ii = $00be48392311af6a$var$offscreenDirectParentIsHidden;
            $00be48392311af6a$var$offscreenDirectParentIsHidden = !1;
            $00be48392311af6a$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $00be48392311af6a$var$offscreenDirectParentIsHidden = ii;
            $00be48392311af6a$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($00be48392311af6a$var$offscreenSubtreeWasHidden || null === current || $00be48392311af6a$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                root = finishedWork.stateNode;
                try {
                    $00be48392311af6a$var$setTextContent(root, ""), $00be48392311af6a$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $00be48392311af6a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (root = finishedWork.memoizedProps, $00be48392311af6a$var$commitHostUpdate(finishedWork, root, null !== current ? current.memoizedProps : root));
            flags & 1024 && ($00be48392311af6a$var$needsFormReset = !0);
            break;
        case 6:
            $00be48392311af6a$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $00be48392311af6a$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($00be48392311af6a$var$formatProdErrorMessage(162));
                root = finishedWork.memoizedProps;
                lanes = finishedWork.stateNode;
                try {
                    lanes.nodeValue = root, $00be48392311af6a$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $00be48392311af6a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $00be48392311af6a$var$viewTransitionMutationContext = !1;
            $00be48392311af6a$var$tagCaches = null;
            ii = $00be48392311af6a$var$currentHoistableRoot;
            $00be48392311af6a$var$currentHoistableRoot = $00be48392311af6a$var$getHoistableRoot(root.containerInfo);
            $00be48392311af6a$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $00be48392311af6a$var$currentHoistableRoot = ii;
            $00be48392311af6a$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $00be48392311af6a$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $00be48392311af6a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $00be48392311af6a$var$needsFormReset && ($00be48392311af6a$var$needsFormReset = !1, $00be48392311af6a$var$recursivelyResetForms(finishedWork));
            $00be48392311af6a$var$viewTransitionMutationContext = !1;
            break;
        case 4:
            flags = $00be48392311af6a$var$offscreenDirectParentIsHidden;
            $00be48392311af6a$var$offscreenDirectParentIsHidden = $00be48392311af6a$var$offscreenSubtreeIsHidden;
            current = $00be48392311af6a$var$pushMutationContext();
            ii = $00be48392311af6a$var$currentHoistableRoot;
            $00be48392311af6a$var$currentHoistableRoot = $00be48392311af6a$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $00be48392311af6a$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $00be48392311af6a$var$commitReconciliationEffects(finishedWork);
            $00be48392311af6a$var$currentHoistableRoot = ii;
            $00be48392311af6a$var$viewTransitionMutationContext && $00be48392311af6a$var$inUpdateViewTransition && ($00be48392311af6a$var$rootViewTransitionAffected = !0);
            $00be48392311af6a$var$viewTransitionMutationContext = current;
            $00be48392311af6a$var$offscreenDirectParentIsHidden = flags;
            break;
        case 12:
            $00be48392311af6a$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $00be48392311af6a$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $00be48392311af6a$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $00be48392311af6a$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $00be48392311af6a$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 13:
            $00be48392311af6a$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $00be48392311af6a$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($00be48392311af6a$var$globalMostRecentFallbackTime = $00be48392311af6a$var$now());
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $00be48392311af6a$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 22:
            ii = null !== finishedWork.memoizedState;
            _eventPayloads$ii2 = null !== current && null !== current.memoizedState;
            var prevOffscreenSubtreeIsHidden = $00be48392311af6a$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $00be48392311af6a$var$offscreenSubtreeWasHidden, prevOffscreenDirectParentIsHidden$166 = $00be48392311af6a$var$offscreenDirectParentIsHidden;
            $00be48392311af6a$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || ii;
            $00be48392311af6a$var$offscreenDirectParentIsHidden = prevOffscreenDirectParentIsHidden$166 || ii;
            $00be48392311af6a$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || _eventPayloads$ii2;
            $00be48392311af6a$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $00be48392311af6a$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $00be48392311af6a$var$offscreenDirectParentIsHidden = prevOffscreenDirectParentIsHidden$166;
            $00be48392311af6a$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $00be48392311af6a$var$commitReconciliationEffects(finishedWork);
            flags & 8192 && (root = finishedWork.stateNode, root._visibility = ii ? root._visibility & -2 : root._visibility | 1, !ii || null === current || _eventPayloads$ii2 || $00be48392311af6a$var$offscreenSubtreeIsHidden || $00be48392311af6a$var$offscreenSubtreeWasHidden || (root = _eventPayloads$ii2 || $00be48392311af6a$var$offscreenSubtreeWasHidden, lanes = $00be48392311af6a$var$offscreenSubtreeIsHidden, current = $00be48392311af6a$var$offscreenSubtreeWasHidden, $00be48392311af6a$var$offscreenSubtreeIsHidden = ii || $00be48392311af6a$var$offscreenSubtreeIsHidden, $00be48392311af6a$var$offscreenSubtreeWasHidden = root, $00be48392311af6a$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, 2), $00be48392311af6a$var$offscreenSubtreeIsHidden = lanes, $00be48392311af6a$var$offscreenSubtreeWasHidden = current), !ii && $00be48392311af6a$var$offscreenDirectParentIsHidden || $00be48392311af6a$var$hideOrUnhideAllChildren(finishedWork, ii));
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (lanes = root.retryQueue, null !== lanes && (root.retryQueue = null, $00be48392311af6a$var$attachSuspenseRetryListeners(finishedWork, lanes))));
            break;
        case 19:
            $00be48392311af6a$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $00be48392311af6a$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $00be48392311af6a$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 30:
            flags & 512 && ($00be48392311af6a$var$offscreenSubtreeWasHidden || null === current || $00be48392311af6a$var$safelyDetachRef(current, current.return));
            flags = $00be48392311af6a$var$pushMutationContext();
            ii = $00be48392311af6a$var$inUpdateViewTransition;
            _eventPayloads$ii2 = (lanes & 335544064) === lanes;
            prevOffscreenSubtreeIsHidden = finishedWork.memoizedProps;
            $00be48392311af6a$var$inUpdateViewTransition = _eventPayloads$ii2 && "none" !== $00be48392311af6a$var$getViewTransitionClassName(prevOffscreenSubtreeIsHidden.default, prevOffscreenSubtreeIsHidden.update);
            $00be48392311af6a$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $00be48392311af6a$var$commitReconciliationEffects(finishedWork);
            _eventPayloads$ii2 && null !== current && $00be48392311af6a$var$viewTransitionMutationContext && (finishedWork.flags |= 4);
            $00be48392311af6a$var$inUpdateViewTransition = ii;
            $00be48392311af6a$var$viewTransitionMutationContext = flags;
            break;
        case 21:
            break;
        case 7:
            flags & 512 && ($00be48392311af6a$var$offscreenSubtreeWasHidden || null === current || $00be48392311af6a$var$safelyDetachRef(current, current.return)), current && null !== current.stateNode && (current.stateNode._fragmentFiber = finishedWork);
        default:
            $00be48392311af6a$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes), $00be48392311af6a$var$commitReconciliationEffects(finishedWork);
    }
}
function $00be48392311af6a$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($00be48392311af6a$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            parentFiber = null;
            for(var parent = finishedWork.return; null !== parent;){
                if ($00be48392311af6a$var$isFragmentInstanceParent(parent)) {
                    var fragmentInstance = parent.stateNode;
                    null === parentFiber ? parentFiber = [
                        fragmentInstance
                    ] : parentFiber.push(fragmentInstance);
                }
                if ($00be48392311af6a$var$isFragmentInstanceHostBoundary(parent)) break;
                parent = parent.return;
            }
            var JSCompiler_inline_result = parentFiber;
            if (null == hostParentFiber) throw Error($00be48392311af6a$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent$jscomp$0 = hostParentFiber.stateNode, before = $00be48392311af6a$var$getHostSibling(finishedWork);
                    $00be48392311af6a$var$insertOrAppendPlacementNode(finishedWork, before, parent$jscomp$0, JSCompiler_inline_result);
                    break;
                case 5:
                    var parent$149 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($00be48392311af6a$var$setTextContent(parent$149, ""), hostParentFiber.flags &= -33);
                    var before$150 = $00be48392311af6a$var$getHostSibling(finishedWork);
                    $00be48392311af6a$var$insertOrAppendPlacementNode(finishedWork, before$150, parent$149, JSCompiler_inline_result);
                    break;
                case 3:
                case 4:
                    var parent$151 = hostParentFiber.stateNode.containerInfo, before$152 = $00be48392311af6a$var$getHostSibling(finishedWork);
                    $00be48392311af6a$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$152, parent$151, JSCompiler_inline_result);
                    break;
                default:
                    throw Error($00be48392311af6a$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $00be48392311af6a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $00be48392311af6a$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $00be48392311af6a$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && (fiber = fiber.stateNode, $00be48392311af6a$var$_enabled = !0, fiber.reset(), $00be48392311af6a$var$_enabled = !1);
        parentFiber = parentFiber.sibling;
    }
}
function $00be48392311af6a$var$recursivelyTraverseAfterMutationEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 9270) for(parentFiber = parentFiber.child; null !== parentFiber;)$00be48392311af6a$var$commitAfterMutationEffectsOnFiber(parentFiber, root), parentFiber = parentFiber.sibling;
    else $00be48392311af6a$var$measureNestedViewTransitions(parentFiber, !1);
}
function $00be48392311af6a$var$commitAfterMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate;
    if (null === current) $00be48392311af6a$var$commitEnterViewTransitions(finishedWork, !1);
    else switch(finishedWork.tag){
        case 3:
            $00be48392311af6a$var$rootViewTransitionNameCanceled = $00be48392311af6a$var$viewTransitionContextChanged = !1;
            $00be48392311af6a$var$pushViewTransitionCancelableScope();
            $00be48392311af6a$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            if (!$00be48392311af6a$var$viewTransitionContextChanged && !$00be48392311af6a$var$rootViewTransitionAffected) {
                finishedWork = $00be48392311af6a$var$viewTransitionCancelableChildren;
                if (null !== finishedWork) for(var i = 0; i < finishedWork.length; i += 3){
                    current = finishedWork[i];
                    var oldName = finishedWork[i + 1];
                    $00be48392311af6a$var$restoreViewTransitionName(current, finishedWork[i + 2]);
                    current = current.ownerDocument.documentElement;
                    null !== current && current.animate({
                        opacity: [
                            0,
                            0
                        ],
                        pointerEvents: [
                            "none",
                            "none"
                        ]
                    }, {
                        duration: 0,
                        fill: "forwards",
                        pseudoElement: "::view-transition-group(" + oldName + ")"
                    });
                }
                finishedWork = root.containerInfo;
                finishedWork = 9 === finishedWork.nodeType ? finishedWork.documentElement : finishedWork.ownerDocument.documentElement;
                null !== finishedWork && "" === finishedWork.style.viewTransitionName && (finishedWork.style.viewTransitionName = "none", finishedWork.animate({
                    opacity: [
                        0,
                        0
                    ],
                    pointerEvents: [
                        "none",
                        "none"
                    ]
                }, {
                    duration: 0,
                    fill: "forwards",
                    pseudoElement: "::view-transition-group(root)"
                }), finishedWork.animate({
                    width: [
                        0,
                        0
                    ],
                    height: [
                        0,
                        0
                    ]
                }, {
                    duration: 0,
                    fill: "forwards",
                    pseudoElement: "::view-transition"
                }));
                $00be48392311af6a$var$rootViewTransitionNameCanceled = !0;
            }
            $00be48392311af6a$var$viewTransitionCancelableChildren = null;
            break;
        case 5:
            $00be48392311af6a$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            break;
        case 4:
            i = $00be48392311af6a$var$viewTransitionContextChanged;
            $00be48392311af6a$var$viewTransitionContextChanged = !1;
            $00be48392311af6a$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            $00be48392311af6a$var$viewTransitionContextChanged && ($00be48392311af6a$var$rootViewTransitionAffected = !0);
            $00be48392311af6a$var$viewTransitionContextChanged = i;
            break;
        case 22:
            null === finishedWork.memoizedState && (null !== current.memoizedState ? $00be48392311af6a$var$commitEnterViewTransitions(finishedWork, !1) : $00be48392311af6a$var$recursivelyTraverseAfterMutationEffects(root, finishedWork));
            break;
        case 30:
            i = $00be48392311af6a$var$viewTransitionContextChanged;
            oldName = $00be48392311af6a$var$pushViewTransitionCancelableScope();
            $00be48392311af6a$var$viewTransitionContextChanged = !1;
            $00be48392311af6a$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            $00be48392311af6a$var$viewTransitionContextChanged && (finishedWork.flags |= 4);
            var props = finishedWork.memoizedProps, state = finishedWork.stateNode;
            root = $00be48392311af6a$var$getViewTransitionName(props, state);
            state = $00be48392311af6a$var$getViewTransitionName(current.memoizedProps, state);
            var className = $00be48392311af6a$var$getViewTransitionClassName(props.default, props.update);
            "none" === className ? root = !1 : (props = current.memoizedState, current.memoizedState = null, current = finishedWork.child, $00be48392311af6a$var$viewTransitionHostInstanceIdx = 0, root = $00be48392311af6a$var$measureViewTransitionHostInstancesRecursive(finishedWork, current, root, state, className, props, !0), $00be48392311af6a$var$viewTransitionHostInstanceIdx !== (null === props ? 0 : props.length) && (finishedWork.flags |= 32));
            0 !== (finishedWork.flags & 4) && root ? ($00be48392311af6a$var$scheduleViewTransitionEvent(finishedWork, finishedWork.memoizedProps.onUpdate), $00be48392311af6a$var$viewTransitionCancelableChildren = oldName) : null !== oldName && (oldName.push.apply(oldName, $00be48392311af6a$var$viewTransitionCancelableChildren), $00be48392311af6a$var$viewTransitionCancelableChildren = oldName);
            $00be48392311af6a$var$viewTransitionContextChanged = 0 !== (finishedWork.flags & 32) ? !0 : i;
            break;
        default:
            $00be48392311af6a$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
    }
}
function $00be48392311af6a$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$00be48392311af6a$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $00be48392311af6a$var$recursivelyTraverseDisappearLayoutEffects(parentFiber, layoutEffectTraversalFlags$jscomp$0) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber, layoutEffectTraversalFlags = layoutEffectTraversalFlags$jscomp$0;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $00be48392311af6a$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $00be48392311af6a$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 1:
                $00be48392311af6a$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $00be48392311af6a$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $00be48392311af6a$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 27:
                0 !== (layoutEffectTraversalFlags & 2) && $00be48392311af6a$var$releaseSingletonInstance(finishedWork.stateNode, finishedWork.type, finishedWork.memoizedProps);
            case 5:
                $00be48392311af6a$var$safelyDetachRef(finishedWork, finishedWork.return);
                5 !== finishedWork.tag && 27 !== finishedWork.tag || $00be48392311af6a$var$commitFragmentInstanceDeletionEffects(finishedWork);
                $00be48392311af6a$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 6:
                $00be48392311af6a$var$commitFragmentInstanceDeletionEffects(finishedWork);
                break;
            case 26:
                $00be48392311af6a$var$safelyDetachRef(finishedWork, finishedWork.return);
                instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || $00be48392311af6a$var$offscreenSubtreeWasHidden || instance.parentNode.removeChild(instance);
                $00be48392311af6a$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 22:
                null === finishedWork.memoizedState && $00be48392311af6a$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 30:
                $00be48392311af6a$var$safelyDetachRef(finishedWork, finishedWork.return);
                $00be48392311af6a$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 7:
                $00be48392311af6a$var$safelyDetachRef(finishedWork, finishedWork.return);
            default:
                $00be48392311af6a$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $00be48392311af6a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, layoutEffectTraversalFlags) {
    layoutEffectTraversalFlags = 0 !== (parentFiber.subtreeFlags & 8772) ? layoutEffectTraversalFlags : layoutEffectTraversalFlags & -2;
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags, includeWorkInProgressEffects = 0 !== (layoutEffectTraversalFlags & 1);
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $00be48392311af6a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $00be48392311af6a$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $00be48392311af6a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $00be48392311af6a$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$00be48392311af6a$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $00be48392311af6a$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $00be48392311af6a$var$commitClassCallbacks(finishedWork);
                $00be48392311af6a$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                0 !== (layoutEffectTraversalFlags & 2) && $00be48392311af6a$var$commitHostSingletonAcquisition(finishedWork);
            case 5:
                5 !== finishedWork.tag && 27 !== finishedWork.tag || $00be48392311af6a$var$commitFragmentInstanceInsertionEffects(finishedWork);
                $00be48392311af6a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && $00be48392311af6a$var$commitHostMount(finishedWork);
                $00be48392311af6a$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 6:
                $00be48392311af6a$var$commitFragmentInstanceInsertionEffects(finishedWork);
                break;
            case 26:
                instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || $00be48392311af6a$var$offscreenSubtreeIsHidden || $00be48392311af6a$var$mountHoistable($00be48392311af6a$var$getHoistableRoot(instance.ownerDocument), finishedWork.type, instance);
                $00be48392311af6a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && $00be48392311af6a$var$commitHostMount(finishedWork);
                $00be48392311af6a$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $00be48392311af6a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                break;
            case 31:
                $00be48392311af6a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && $00be48392311af6a$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $00be48392311af6a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && $00be48392311af6a$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $00be48392311af6a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $00be48392311af6a$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                $00be48392311af6a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $00be48392311af6a$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 7:
                $00be48392311af6a$var$safelyAttachRef(finishedWork, finishedWork.return);
            default:
                $00be48392311af6a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $00be48392311af6a$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $00be48392311af6a$var$releaseCache(previousCache));
}
function $00be48392311af6a$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $00be48392311af6a$var$releaseCache(current));
}
function $00be48392311af6a$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    var isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
    if (parentFiber.subtreeFlags & (isViewTransitionEligible ? 10262 : 10256)) for(parentFiber = parentFiber.child; null !== parentFiber;)$00be48392311af6a$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
    else isViewTransitionEligible && $00be48392311af6a$var$restoreNestedViewTransitions(parentFiber);
}
function $00be48392311af6a$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
    isViewTransitionEligible && null === finishedWork.alternate && null !== finishedWork.return && null !== finishedWork.return.alternate && $00be48392311af6a$var$restoreEnterOrExitViewTransitions(finishedWork);
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $00be48392311af6a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $00be48392311af6a$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $00be48392311af6a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $00be48392311af6a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            isViewTransitionEligible && $00be48392311af6a$var$rootViewTransitionNameCanceled && (finishedRoot = finishedRoot.containerInfo, finishedRoot = 9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, "root" === finishedRoot.style.viewTransitionName && (finishedRoot.style.viewTransitionName = ""), finishedRoot = finishedRoot.ownerDocument.documentElement, null !== finishedRoot && "none" === finishedRoot.style.viewTransitionName && (finishedRoot.style.viewTransitionName = ""));
            flags & 2048 && (flags = null, null !== finishedWork.alternate && (flags = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== flags && (finishedWork.refCount++, null != flags && $00be48392311af6a$var$releaseCache(flags)));
            break;
        case 12:
            if (flags & 2048) {
                $00be48392311af6a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                flags = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", flags.passiveEffectDuration, -0);
                } catch (error) {
                    $00be48392311af6a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $00be48392311af6a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $00be48392311af6a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $00be48392311af6a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? (isViewTransitionEligible && null !== id && null === id.memoizedState && $00be48392311af6a$var$restoreEnterOrExitViewTransitions(id), _finishedWork$memoize2._visibility & 2 ? $00be48392311af6a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $00be48392311af6a$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork)) : (isViewTransitionEligible && null !== id && null !== id.memoizedState && $00be48392311af6a$var$restoreEnterOrExitViewTransitions(finishedWork), _finishedWork$memoize2._visibility & 2 ? $00be48392311af6a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $00be48392311af6a$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1)));
            flags & 2048 && $00be48392311af6a$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $00be48392311af6a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $00be48392311af6a$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        case 30:
            isViewTransitionEligible && (flags = finishedWork.alternate, null !== flags && ($00be48392311af6a$var$restoreViewTransitionOnHostInstances(flags.child, !0), $00be48392311af6a$var$restoreViewTransitionOnHostInstances(finishedWork.child, !0)));
            $00be48392311af6a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        default:
            $00be48392311af6a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $00be48392311af6a$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $00be48392311af6a$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $00be48392311af6a$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $00be48392311af6a$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $00be48392311af6a$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $00be48392311af6a$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $00be48392311af6a$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $00be48392311af6a$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $00be48392311af6a$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $00be48392311af6a$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $00be48392311af6a$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $00be48392311af6a$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $00be48392311af6a$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $00be48392311af6a$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $00be48392311af6a$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $00be48392311af6a$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $00be48392311af6a$var$suspenseyCommitFlag = 8192;
function $00be48392311af6a$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $00be48392311af6a$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$00be48392311af6a$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $00be48392311af6a$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $00be48392311af6a$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $00be48392311af6a$var$suspenseyCommitFlag && (null !== fiber.memoizedState ? $00be48392311af6a$var$suspendResource(suspendedState, $00be48392311af6a$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps) : (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && $00be48392311af6a$var$suspendInstance(suspendedState, fiber)));
            break;
        case 5:
            $00be48392311af6a$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $00be48392311af6a$var$suspenseyCommitFlag && (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && $00be48392311af6a$var$suspendInstance(suspendedState, fiber));
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $00be48392311af6a$var$currentHoistableRoot;
            $00be48392311af6a$var$currentHoistableRoot = $00be48392311af6a$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $00be48392311af6a$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $00be48392311af6a$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $00be48392311af6a$var$suspenseyCommitFlag, $00be48392311af6a$var$suspenseyCommitFlag = 16777216, $00be48392311af6a$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $00be48392311af6a$var$suspenseyCommitFlag = previousHoistableRoot) : $00be48392311af6a$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        case 30:
            if (0 !== (fiber.flags & $00be48392311af6a$var$suspenseyCommitFlag) && (previousHoistableRoot = fiber.memoizedProps.name, null != previousHoistableRoot && "auto" !== previousHoistableRoot)) {
                var state = fiber.stateNode;
                state.paired = null;
                null === $00be48392311af6a$var$appearingViewTransitions && ($00be48392311af6a$var$appearingViewTransitions = new Map());
                $00be48392311af6a$var$appearingViewTransitions.set(previousHoistableRoot, state);
            }
            $00be48392311af6a$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        default:
            $00be48392311af6a$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $00be48392311af6a$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $00be48392311af6a$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $00be48392311af6a$var$nextEffect = childToDelete;
            $00be48392311af6a$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $00be48392311af6a$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$00be48392311af6a$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $00be48392311af6a$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $00be48392311af6a$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $00be48392311af6a$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $00be48392311af6a$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $00be48392311af6a$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $00be48392311af6a$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $00be48392311af6a$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $00be48392311af6a$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $00be48392311af6a$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $00be48392311af6a$var$nextEffect = childToDelete;
            $00be48392311af6a$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $00be48392311af6a$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $00be48392311af6a$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $00be48392311af6a$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $00be48392311af6a$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $00be48392311af6a$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $00be48392311af6a$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $00be48392311af6a$var$nextEffect;){
        var fiber = $00be48392311af6a$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $00be48392311af6a$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $00be48392311af6a$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $00be48392311af6a$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $00be48392311af6a$var$nextEffect;){
            cache = $00be48392311af6a$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $00be48392311af6a$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $00be48392311af6a$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $00be48392311af6a$var$nextEffect = sibling;
                break a;
            }
            $00be48392311af6a$var$nextEffect = returnFiber;
        }
    }
}
var $00be48392311af6a$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $00be48392311af6a$var$readContext($00be48392311af6a$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $00be48392311af6a$var$readContext($00be48392311af6a$var$CacheContext).controller.signal;
    }
}, $00be48392311af6a$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $00be48392311af6a$var$executionContext = 0, $00be48392311af6a$var$workInProgressRoot = null, $00be48392311af6a$var$workInProgress = null, $00be48392311af6a$var$workInProgressRootRenderLanes = 0, $00be48392311af6a$var$workInProgressSuspendedReason = 0, $00be48392311af6a$var$workInProgressThrownValue = null, $00be48392311af6a$var$workInProgressRootDidSkipSuspendedSiblings = !1, $00be48392311af6a$var$workInProgressRootIsPrerendering = !1, $00be48392311af6a$var$workInProgressRootDidAttachPingListener = !1, $00be48392311af6a$var$entangledRenderLanes = 0, $00be48392311af6a$var$workInProgressRootExitStatus = 0, $00be48392311af6a$var$workInProgressRootSkippedLanes = 0, $00be48392311af6a$var$workInProgressRootInterleavedUpdatedLanes = 0, $00be48392311af6a$var$workInProgressRootPingedLanes = 0, $00be48392311af6a$var$workInProgressDeferredLane = 0, $00be48392311af6a$var$workInProgressSuspendedRetryLanes = 0, $00be48392311af6a$var$workInProgressRootConcurrentErrors = null, $00be48392311af6a$var$workInProgressRootRecoverableErrors = null, $00be48392311af6a$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $00be48392311af6a$var$globalMostRecentFallbackTime = 0, $00be48392311af6a$var$globalMostRecentTransitionTime = 0, $00be48392311af6a$var$workInProgressRootRenderTargetTime = Infinity, $00be48392311af6a$var$workInProgressTransitions = null, $00be48392311af6a$var$legacyErrorBoundariesThatAlreadyFailed = null, $00be48392311af6a$var$pendingEffectsStatus = 0, $00be48392311af6a$var$pendingEffectsRoot = null, $00be48392311af6a$var$pendingFinishedWork = null, $00be48392311af6a$var$pendingEffectsLanes = 0, $00be48392311af6a$var$pendingEffectsRemainingLanes = 0, $00be48392311af6a$var$pendingPassiveTransitions = null, $00be48392311af6a$var$pendingRecoverableErrors = null, $00be48392311af6a$var$pendingViewTransition = null, $00be48392311af6a$var$pendingViewTransitionEvents = null, $00be48392311af6a$var$pendingTransitionTypes = null, $00be48392311af6a$var$nestedUpdateCount = 0, $00be48392311af6a$var$rootWithNestedUpdates = null;
function $00be48392311af6a$var$requestUpdateLane() {
    return 0 !== ($00be48392311af6a$var$executionContext & 2) && 0 !== $00be48392311af6a$var$workInProgressRootRenderLanes ? $00be48392311af6a$var$workInProgressRootRenderLanes & -$00be48392311af6a$var$workInProgressRootRenderLanes : null !== $00be48392311af6a$var$ReactSharedInternals.T ? $00be48392311af6a$var$requestTransitionLane() : $00be48392311af6a$var$resolveUpdatePriority();
}
function $00be48392311af6a$var$requestDeferredLane() {
    if (0 === $00be48392311af6a$var$workInProgressDeferredLane) {
        if (0 === ($00be48392311af6a$var$workInProgressRootRenderLanes & 536870912) || $00be48392311af6a$var$isHydrating) {
            var lane = $00be48392311af6a$var$nextTransitionDeferredLane;
            $00be48392311af6a$var$nextTransitionDeferredLane <<= 1;
            0 === ($00be48392311af6a$var$nextTransitionDeferredLane & 3932160) && ($00be48392311af6a$var$nextTransitionDeferredLane = 262144);
            $00be48392311af6a$var$workInProgressDeferredLane = lane;
        } else $00be48392311af6a$var$workInProgressDeferredLane = 536870912;
    }
    lane = $00be48392311af6a$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $00be48392311af6a$var$workInProgressDeferredLane;
}
function $00be48392311af6a$var$scheduleViewTransitionEvent(fiber, callback) {
    if (null != callback) {
        var state = fiber.stateNode, instance = state.ref;
        null === instance && (instance = state.ref = $00be48392311af6a$var$createViewTransitionInstance($00be48392311af6a$var$getViewTransitionName(fiber.memoizedProps, state)));
        null === $00be48392311af6a$var$pendingViewTransitionEvents && ($00be48392311af6a$var$pendingViewTransitionEvents = []);
        $00be48392311af6a$var$pendingViewTransitionEvents.push(callback.bind(null, instance));
    }
}
function $00be48392311af6a$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $00be48392311af6a$var$workInProgressRoot && (2 === $00be48392311af6a$var$workInProgressSuspendedReason || 9 === $00be48392311af6a$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $00be48392311af6a$var$prepareFreshStack(root, 0), $00be48392311af6a$var$markRootSuspended(root, $00be48392311af6a$var$workInProgressRootRenderLanes, $00be48392311af6a$var$workInProgressDeferredLane, !1);
    $00be48392311af6a$var$markRootUpdated$1(root, lane);
    if (0 === ($00be48392311af6a$var$executionContext & 2) || root !== $00be48392311af6a$var$workInProgressRoot) root === $00be48392311af6a$var$workInProgressRoot && (0 === ($00be48392311af6a$var$executionContext & 2) && ($00be48392311af6a$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $00be48392311af6a$var$workInProgressRootExitStatus && $00be48392311af6a$var$markRootSuspended(root, $00be48392311af6a$var$workInProgressRootRenderLanes, $00be48392311af6a$var$workInProgressDeferredLane, !1)), $00be48392311af6a$var$ensureRootIsScheduled(root);
}
function $00be48392311af6a$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($00be48392311af6a$var$executionContext & 6)) throw Error($00be48392311af6a$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $00be48392311af6a$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $00be48392311af6a$var$renderRootConcurrent(root$jscomp$0, lanes) : $00be48392311af6a$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $00be48392311af6a$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $00be48392311af6a$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$00be48392311af6a$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $00be48392311af6a$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $00be48392311af6a$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($00be48392311af6a$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $00be48392311af6a$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result && 6 !== JSCompiler_inline_result) {
                            if ($00be48392311af6a$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $00be48392311af6a$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $00be48392311af6a$var$workInProgressRootRecoverableErrors;
                            $00be48392311af6a$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $00be48392311af6a$var$workInProgressRootRecoverableErrors ? $00be48392311af6a$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $00be48392311af6a$var$workInProgressRootRecoverableErrors.push.apply($00be48392311af6a$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $00be48392311af6a$var$prepareFreshStack(root$jscomp$0, 0);
                $00be48392311af6a$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($00be48392311af6a$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes && (lanes & 62914560) !== lanes) break;
                    case 6:
                        $00be48392311af6a$var$markRootSuspended(shouldTimeSlice, lanes, $00be48392311af6a$var$workInProgressDeferredLane, !$00be48392311af6a$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $00be48392311af6a$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($00be48392311af6a$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $00be48392311af6a$var$globalMostRecentFallbackTime + 300 - $00be48392311af6a$var$now(), 10 < exitStatus)) {
                    $00be48392311af6a$var$markRootSuspended(shouldTimeSlice, lanes, $00be48392311af6a$var$workInProgressDeferredLane, !$00be48392311af6a$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $00be48392311af6a$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $00be48392311af6a$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $00be48392311af6a$var$scheduleTimeout($00be48392311af6a$var$completeRootWhenReady.bind(null, shouldTimeSlice, forceSync, $00be48392311af6a$var$workInProgressRootRecoverableErrors, $00be48392311af6a$var$workInProgressTransitions, $00be48392311af6a$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $00be48392311af6a$var$workInProgressDeferredLane, $00be48392311af6a$var$workInProgressRootInterleavedUpdatedLanes, $00be48392311af6a$var$workInProgressSuspendedRetryLanes, $00be48392311af6a$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $00be48392311af6a$var$completeRootWhenReady(shouldTimeSlice, forceSync, $00be48392311af6a$var$workInProgressRootRecoverableErrors, $00be48392311af6a$var$workInProgressTransitions, $00be48392311af6a$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $00be48392311af6a$var$workInProgressDeferredLane, $00be48392311af6a$var$workInProgressRootInterleavedUpdatedLanes, $00be48392311af6a$var$workInProgressSuspendedRetryLanes, $00be48392311af6a$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $00be48392311af6a$var$ensureRootIsScheduled(root$jscomp$0);
}
function $00be48392311af6a$var$completeRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    var subtreeFlags = finishedWork.subtreeFlags, isViewTransitionEligible = (lanes & 335544064) === lanes;
    suspendedCommitReason = null;
    if (isViewTransitionEligible || subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
        if (suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $00be48392311af6a$var$noop$1
        }, $00be48392311af6a$var$appearingViewTransitions = null, $00be48392311af6a$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason), isViewTransitionEligible && (subtreeFlags = suspendedCommitReason, isViewTransitionEligible = root.containerInfo, isViewTransitionEligible = (9 === isViewTransitionEligible.nodeType ? isViewTransitionEligible : isViewTransitionEligible.ownerDocument).__reactViewTransition, null != isViewTransitionEligible && (subtreeFlags.count++, subtreeFlags.waitingForViewTransition = !0, subtreeFlags = $00be48392311af6a$var$onUnsuspend.bind(subtreeFlags), isViewTransitionEligible.finished.then(subtreeFlags, subtreeFlags))), subtreeFlags = (lanes & 62914560) === lanes ? $00be48392311af6a$var$globalMostRecentFallbackTime - $00be48392311af6a$var$now() : (lanes & 4194048) === lanes ? $00be48392311af6a$var$globalMostRecentTransitionTime - $00be48392311af6a$var$now() : 0, subtreeFlags = $00be48392311af6a$var$waitForCommitToBeReady(suspendedCommitReason, subtreeFlags), null !== subtreeFlags) {
            $00be48392311af6a$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = subtreeFlags($00be48392311af6a$var$completeRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $00be48392311af6a$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $00be48392311af6a$var$completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason);
}
function $00be48392311af6a$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$00be48392311af6a$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $00be48392311af6a$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes = $00be48392311af6a$var$getEntangledLanes(root, suspendedLanes);
    suspendedLanes &= ~$00be48392311af6a$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$00be48392311af6a$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $00be48392311af6a$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $00be48392311af6a$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $00be48392311af6a$var$flushSyncWork$1() {
    return 0 === ($00be48392311af6a$var$executionContext & 6) ? ($00be48392311af6a$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $00be48392311af6a$var$resetWorkInProgressStack() {
    if (null !== $00be48392311af6a$var$workInProgress) {
        if (0 === $00be48392311af6a$var$workInProgressSuspendedReason) var interruptedWork = $00be48392311af6a$var$workInProgress.return;
        else interruptedWork = $00be48392311af6a$var$workInProgress, $00be48392311af6a$var$lastContextDependency = $00be48392311af6a$var$currentlyRenderingFiber$1 = null, $00be48392311af6a$var$resetHooksOnUnwind(interruptedWork), $00be48392311af6a$var$thenableState$1 = null, $00be48392311af6a$var$thenableIndexCounter$1 = 0, interruptedWork = $00be48392311af6a$var$workInProgress;
        for(; null !== interruptedWork;)$00be48392311af6a$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $00be48392311af6a$var$workInProgress = null;
    }
}
function $00be48392311af6a$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $00be48392311af6a$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $00be48392311af6a$var$pendingEffectsLanes = 0;
    $00be48392311af6a$var$resetWorkInProgressStack();
    $00be48392311af6a$var$workInProgressRoot = root;
    $00be48392311af6a$var$workInProgress = timeoutHandle = $00be48392311af6a$var$createWorkInProgress(root.current, null);
    $00be48392311af6a$var$workInProgressRootRenderLanes = lanes;
    $00be48392311af6a$var$workInProgressSuspendedReason = 0;
    $00be48392311af6a$var$workInProgressThrownValue = null;
    $00be48392311af6a$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $00be48392311af6a$var$workInProgressRootIsPrerendering = $00be48392311af6a$var$checkIfRootIsPrerendering(root, lanes);
    $00be48392311af6a$var$workInProgressRootDidAttachPingListener = !1;
    $00be48392311af6a$var$workInProgressSuspendedRetryLanes = $00be48392311af6a$var$workInProgressDeferredLane = $00be48392311af6a$var$workInProgressRootPingedLanes = $00be48392311af6a$var$workInProgressRootInterleavedUpdatedLanes = $00be48392311af6a$var$workInProgressRootSkippedLanes = $00be48392311af6a$var$workInProgressRootExitStatus = 0;
    $00be48392311af6a$var$workInProgressRootRecoverableErrors = $00be48392311af6a$var$workInProgressRootConcurrentErrors = null;
    $00be48392311af6a$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    $00be48392311af6a$var$entangledRenderLanes = $00be48392311af6a$var$getEntangledLanes(root, lanes);
    $00be48392311af6a$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $00be48392311af6a$var$handleThrow(root, thrownValue) {
    $00be48392311af6a$var$currentlyRenderingFiber = null;
    $00be48392311af6a$var$ReactSharedInternals.H = $00be48392311af6a$var$ContextOnlyDispatcher;
    thrownValue === $00be48392311af6a$var$SuspenseException || thrownValue === $00be48392311af6a$var$SuspenseActionException ? (thrownValue = $00be48392311af6a$var$getSuspendedThenable(), $00be48392311af6a$var$workInProgressSuspendedReason = 3) : thrownValue === $00be48392311af6a$var$SuspenseyCommitException ? (thrownValue = $00be48392311af6a$var$getSuspendedThenable(), $00be48392311af6a$var$workInProgressSuspendedReason = 4) : $00be48392311af6a$var$workInProgressSuspendedReason = thrownValue === $00be48392311af6a$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $00be48392311af6a$var$workInProgressThrownValue = thrownValue;
    null === $00be48392311af6a$var$workInProgress && ($00be48392311af6a$var$workInProgressRootExitStatus = 1, $00be48392311af6a$var$logUncaughtError(root, $00be48392311af6a$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $00be48392311af6a$var$shouldRemainOnPreviousScreen() {
    var handler = $00be48392311af6a$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($00be48392311af6a$var$workInProgressRootRenderLanes & 4194048) === $00be48392311af6a$var$workInProgressRootRenderLanes ? null === $00be48392311af6a$var$shellBoundary ? !0 : !1 : ($00be48392311af6a$var$workInProgressRootRenderLanes & 62914560) === $00be48392311af6a$var$workInProgressRootRenderLanes || 0 !== ($00be48392311af6a$var$workInProgressRootRenderLanes & 536870912) ? handler === $00be48392311af6a$var$shellBoundary : !1;
}
function $00be48392311af6a$var$pushDispatcher() {
    var prevDispatcher = $00be48392311af6a$var$ReactSharedInternals.H;
    $00be48392311af6a$var$ReactSharedInternals.H = $00be48392311af6a$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $00be48392311af6a$var$ContextOnlyDispatcher : prevDispatcher;
}
function $00be48392311af6a$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $00be48392311af6a$var$ReactSharedInternals.A;
    $00be48392311af6a$var$ReactSharedInternals.A = $00be48392311af6a$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $00be48392311af6a$var$renderDidSuspendDelayIfPossible() {
    $00be48392311af6a$var$workInProgressRootExitStatus = 4;
    $00be48392311af6a$var$workInProgressRootDidSkipSuspendedSiblings || ($00be48392311af6a$var$workInProgressRootRenderLanes & 4194048) !== $00be48392311af6a$var$workInProgressRootRenderLanes && null !== $00be48392311af6a$var$suspenseHandlerStackCursor.current || ($00be48392311af6a$var$workInProgressRootIsPrerendering = !0);
    0 === ($00be48392311af6a$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($00be48392311af6a$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $00be48392311af6a$var$workInProgressRoot || $00be48392311af6a$var$markRootSuspended($00be48392311af6a$var$workInProgressRoot, $00be48392311af6a$var$workInProgressRootRenderLanes, $00be48392311af6a$var$workInProgressDeferredLane, !1);
}
function $00be48392311af6a$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $00be48392311af6a$var$executionContext;
    $00be48392311af6a$var$executionContext |= 2;
    var prevDispatcher = $00be48392311af6a$var$pushDispatcher(), prevAsyncDispatcher = $00be48392311af6a$var$pushAsyncDispatcher();
    if ($00be48392311af6a$var$workInProgressRoot !== root || $00be48392311af6a$var$workInProgressRootRenderLanes !== lanes) $00be48392311af6a$var$workInProgressTransitions = null, $00be48392311af6a$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $00be48392311af6a$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $00be48392311af6a$var$workInProgressSuspendedReason && null !== $00be48392311af6a$var$workInProgress) {
            var unitOfWork = $00be48392311af6a$var$workInProgress, thrownValue = $00be48392311af6a$var$workInProgressThrownValue;
            switch($00be48392311af6a$var$workInProgressSuspendedReason){
                case 8:
                    $00be48392311af6a$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $00be48392311af6a$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $00be48392311af6a$var$workInProgressSuspendedReason;
                    $00be48392311af6a$var$workInProgressSuspendedReason = 0;
                    $00be48392311af6a$var$workInProgressThrownValue = null;
                    $00be48392311af6a$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $00be48392311af6a$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $00be48392311af6a$var$workInProgressSuspendedReason, $00be48392311af6a$var$workInProgressSuspendedReason = 0, $00be48392311af6a$var$workInProgressThrownValue = null, $00be48392311af6a$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $00be48392311af6a$var$workLoopSync();
        exitStatus = $00be48392311af6a$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$184) {
        $00be48392311af6a$var$handleThrow(root, thrownValue$184);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $00be48392311af6a$var$lastContextDependency = $00be48392311af6a$var$currentlyRenderingFiber$1 = null;
    $00be48392311af6a$var$executionContext = prevExecutionContext;
    $00be48392311af6a$var$ReactSharedInternals.H = prevDispatcher;
    $00be48392311af6a$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $00be48392311af6a$var$workInProgress && ($00be48392311af6a$var$workInProgressRoot = null, $00be48392311af6a$var$workInProgressRootRenderLanes = 0, $00be48392311af6a$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $00be48392311af6a$var$workLoopSync() {
    for(; null !== $00be48392311af6a$var$workInProgress;)$00be48392311af6a$var$performUnitOfWork($00be48392311af6a$var$workInProgress);
}
function $00be48392311af6a$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $00be48392311af6a$var$executionContext;
    $00be48392311af6a$var$executionContext |= 2;
    var prevDispatcher = $00be48392311af6a$var$pushDispatcher(), prevAsyncDispatcher = $00be48392311af6a$var$pushAsyncDispatcher();
    $00be48392311af6a$var$workInProgressRoot !== root || $00be48392311af6a$var$workInProgressRootRenderLanes !== lanes ? ($00be48392311af6a$var$workInProgressTransitions = null, $00be48392311af6a$var$workInProgressRootRenderTargetTime = $00be48392311af6a$var$now() + 500, $00be48392311af6a$var$prepareFreshStack(root, lanes)) : $00be48392311af6a$var$workInProgressRootIsPrerendering = $00be48392311af6a$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $00be48392311af6a$var$workInProgressSuspendedReason && null !== $00be48392311af6a$var$workInProgress) {
            lanes = $00be48392311af6a$var$workInProgress;
            var thrownValue = $00be48392311af6a$var$workInProgressThrownValue;
            b: switch($00be48392311af6a$var$workInProgressSuspendedReason){
                case 1:
                    $00be48392311af6a$var$workInProgressSuspendedReason = 0;
                    $00be48392311af6a$var$workInProgressThrownValue = null;
                    $00be48392311af6a$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($00be48392311af6a$var$isThenableResolved(thrownValue)) {
                        $00be48392311af6a$var$workInProgressSuspendedReason = 0;
                        $00be48392311af6a$var$workInProgressThrownValue = null;
                        $00be48392311af6a$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $00be48392311af6a$var$workInProgressSuspendedReason && 9 !== $00be48392311af6a$var$workInProgressSuspendedReason || $00be48392311af6a$var$workInProgressRoot !== root || ($00be48392311af6a$var$workInProgressSuspendedReason = 7);
                        $00be48392311af6a$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $00be48392311af6a$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $00be48392311af6a$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $00be48392311af6a$var$isThenableResolved(thrownValue) ? ($00be48392311af6a$var$workInProgressSuspendedReason = 0, $00be48392311af6a$var$workInProgressThrownValue = null, $00be48392311af6a$var$replaySuspendedUnitOfWork(lanes)) : ($00be48392311af6a$var$workInProgressSuspendedReason = 0, $00be48392311af6a$var$workInProgressThrownValue = null, $00be48392311af6a$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($00be48392311af6a$var$workInProgress.tag){
                        case 26:
                            resource = $00be48392311af6a$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $00be48392311af6a$var$workInProgress;
                            if (resource ? $00be48392311af6a$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $00be48392311af6a$var$workInProgressSuspendedReason = 0;
                                $00be48392311af6a$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $00be48392311af6a$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($00be48392311af6a$var$workInProgress = returnFiber, $00be48392311af6a$var$completeUnitOfWork(returnFiber)) : $00be48392311af6a$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $00be48392311af6a$var$workInProgressSuspendedReason = 0;
                    $00be48392311af6a$var$workInProgressThrownValue = null;
                    $00be48392311af6a$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $00be48392311af6a$var$workInProgressSuspendedReason = 0;
                    $00be48392311af6a$var$workInProgressThrownValue = null;
                    $00be48392311af6a$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $00be48392311af6a$var$resetWorkInProgressStack();
                    $00be48392311af6a$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($00be48392311af6a$var$formatProdErrorMessage(462));
            }
        }
        $00be48392311af6a$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$186) {
        $00be48392311af6a$var$handleThrow(root, thrownValue$186);
    }
    while (1);
    $00be48392311af6a$var$lastContextDependency = $00be48392311af6a$var$currentlyRenderingFiber$1 = null;
    $00be48392311af6a$var$ReactSharedInternals.H = prevDispatcher;
    $00be48392311af6a$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $00be48392311af6a$var$executionContext = prevExecutionContext;
    if (null !== $00be48392311af6a$var$workInProgress) return 0;
    $00be48392311af6a$var$workInProgressRoot = null;
    $00be48392311af6a$var$workInProgressRootRenderLanes = 0;
    $00be48392311af6a$var$finishQueueingConcurrentUpdates();
    return $00be48392311af6a$var$workInProgressRootExitStatus;
}
function $00be48392311af6a$var$workLoopConcurrentByScheduler() {
    for(; null !== $00be48392311af6a$var$workInProgress && !$00be48392311af6a$var$shouldYield();)$00be48392311af6a$var$performUnitOfWork($00be48392311af6a$var$workInProgress);
}
function $00be48392311af6a$var$performUnitOfWork(unitOfWork) {
    var next = $00be48392311af6a$var$beginWork(unitOfWork.alternate, unitOfWork, $00be48392311af6a$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $00be48392311af6a$var$completeUnitOfWork(unitOfWork) : $00be48392311af6a$var$workInProgress = next;
}
function $00be48392311af6a$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $00be48392311af6a$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $00be48392311af6a$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $00be48392311af6a$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $00be48392311af6a$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $00be48392311af6a$var$resetHooksOnUnwind(next);
            var fiber = next;
            fiber === $00be48392311af6a$var$hydrationParentFiber && ($00be48392311af6a$var$isHydrating ? ($00be48392311af6a$var$popToNextHostParent(fiber), 5 === fiber.tag && null != fiber.stateNode && ($00be48392311af6a$var$nextHydratableInstance = fiber.stateNode)) : ($00be48392311af6a$var$popToNextHostParent(fiber), $00be48392311af6a$var$isHydrating = !0));
        default:
            $00be48392311af6a$var$unwindInterruptedWork(current, next), next = $00be48392311af6a$var$workInProgress = $00be48392311af6a$var$resetWorkInProgress(next, $00be48392311af6a$var$entangledRenderLanes), next = $00be48392311af6a$var$beginWork(current, next, $00be48392311af6a$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $00be48392311af6a$var$completeUnitOfWork(unitOfWork) : $00be48392311af6a$var$workInProgress = next;
}
function $00be48392311af6a$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $00be48392311af6a$var$lastContextDependency = $00be48392311af6a$var$currentlyRenderingFiber$1 = null;
    $00be48392311af6a$var$resetHooksOnUnwind(unitOfWork);
    $00be48392311af6a$var$thenableState$1 = null;
    $00be48392311af6a$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($00be48392311af6a$var$throwException(root, returnFiber, unitOfWork, thrownValue, $00be48392311af6a$var$workInProgressRootRenderLanes)) {
            $00be48392311af6a$var$workInProgressRootExitStatus = 1;
            $00be48392311af6a$var$logUncaughtError(root, $00be48392311af6a$var$createCapturedValueAtFiber(thrownValue, root.current));
            $00be48392311af6a$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $00be48392311af6a$var$workInProgress = returnFiber, error;
        $00be48392311af6a$var$workInProgressRootExitStatus = 1;
        $00be48392311af6a$var$logUncaughtError(root, $00be48392311af6a$var$createCapturedValueAtFiber(thrownValue, root.current));
        $00be48392311af6a$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($00be48392311af6a$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($00be48392311af6a$var$workInProgressRootIsPrerendering || 0 !== ($00be48392311af6a$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($00be48392311af6a$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $00be48392311af6a$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $00be48392311af6a$var$unwindUnitOfWork(unitOfWork, root);
    } else $00be48392311af6a$var$completeUnitOfWork(unitOfWork);
}
function $00be48392311af6a$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $00be48392311af6a$var$unwindUnitOfWork(completedWork, $00be48392311af6a$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $00be48392311af6a$var$completeWork(completedWork.alternate, completedWork, $00be48392311af6a$var$entangledRenderLanes);
        if (null !== next) {
            $00be48392311af6a$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $00be48392311af6a$var$workInProgress = completedWork;
            return;
        }
        $00be48392311af6a$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $00be48392311af6a$var$workInProgressRootExitStatus && ($00be48392311af6a$var$workInProgressRootExitStatus = 5);
}
function $00be48392311af6a$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $00be48392311af6a$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $00be48392311af6a$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $00be48392311af6a$var$workInProgress = unitOfWork;
            return;
        }
        $00be48392311af6a$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $00be48392311af6a$var$workInProgressRootExitStatus = 6;
    $00be48392311af6a$var$workInProgress = null;
}
function $00be48392311af6a$var$completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedState) {
    root.cancelPendingCommit = null;
    do $00be48392311af6a$var$flushPendingEffects();
    while (0 !== $00be48392311af6a$var$pendingEffectsStatus);
    if (0 !== ($00be48392311af6a$var$executionContext & 6)) throw Error($00be48392311af6a$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($00be48392311af6a$var$formatProdErrorMessage(177));
        root === $00be48392311af6a$var$workInProgressRoot && ($00be48392311af6a$var$workInProgress = $00be48392311af6a$var$workInProgressRoot = null, $00be48392311af6a$var$workInProgressRootRenderLanes = 0);
        $00be48392311af6a$var$pendingFinishedWork = finishedWork;
        $00be48392311af6a$var$pendingEffectsRoot = root;
        $00be48392311af6a$var$pendingEffectsLanes = lanes;
        $00be48392311af6a$var$pendingPassiveTransitions = transitions;
        $00be48392311af6a$var$pendingRecoverableErrors = recoverableErrors;
        $00be48392311af6a$var$commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState);
    }
}
function $00be48392311af6a$var$commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState) {
    var remainingLanes = finishedWork.lanes | finishedWork.childLanes;
    $00be48392311af6a$var$pendingEffectsRemainingLanes = remainingLanes;
    remainingLanes |= $00be48392311af6a$var$concurrentlyUpdatedLanes;
    $00be48392311af6a$var$markRootFinished(root, lanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes);
    $00be48392311af6a$var$pendingViewTransitionEvents = null;
    (lanes & 335544064) === lanes ? ($00be48392311af6a$var$pendingTransitionTypes = $00be48392311af6a$var$claimQueuedTransitionTypes(root), spawnedLane = 10262) : ($00be48392311af6a$var$pendingTransitionTypes = null, spawnedLane = 10256);
    0 !== (finishedWork.subtreeFlags & spawnedLane) || 0 !== (finishedWork.flags & spawnedLane) ? (root.callbackNode = null, root.callbackPriority = 0, $00be48392311af6a$var$scheduleCallback$1($00be48392311af6a$var$NormalPriority$1, function() {
        $00be48392311af6a$var$flushPassiveEffects();
        return null;
    })) : (root.callbackNode = null, root.callbackPriority = 0);
    $00be48392311af6a$var$shouldStartViewTransition = !1;
    spawnedLane = 0 !== (finishedWork.flags & 13878);
    if (0 !== (finishedWork.subtreeFlags & 13878) || spawnedLane) {
        spawnedLane = $00be48392311af6a$var$ReactSharedInternals.T;
        $00be48392311af6a$var$ReactSharedInternals.T = null;
        updatedLanes = $00be48392311af6a$var$ReactDOMSharedInternals.p;
        $00be48392311af6a$var$ReactDOMSharedInternals.p = 2;
        suspendedRetryLanes = $00be48392311af6a$var$executionContext;
        $00be48392311af6a$var$executionContext |= 4;
        try {
            $00be48392311af6a$var$commitBeforeMutationEffects(root, finishedWork, lanes);
        } finally{
            $00be48392311af6a$var$executionContext = suspendedRetryLanes, $00be48392311af6a$var$ReactDOMSharedInternals.p = updatedLanes, $00be48392311af6a$var$ReactSharedInternals.T = spawnedLane;
        }
    }
    $00be48392311af6a$var$pendingEffectsStatus = 1;
    $00be48392311af6a$var$shouldStartViewTransition ? $00be48392311af6a$var$pendingViewTransition = $00be48392311af6a$var$startViewTransition(suspendedState, root.containerInfo, $00be48392311af6a$var$pendingTransitionTypes, $00be48392311af6a$var$flushMutationEffects, $00be48392311af6a$var$flushLayoutEffects, $00be48392311af6a$var$flushAfterMutationEffects, $00be48392311af6a$var$flushSpawnedWork, $00be48392311af6a$var$flushPassiveEffects, $00be48392311af6a$var$reportViewTransitionError, null, null) : ($00be48392311af6a$var$flushMutationEffects(), $00be48392311af6a$var$flushLayoutEffects(), $00be48392311af6a$var$flushSpawnedWork());
}
function $00be48392311af6a$var$reportViewTransitionError(error) {
    if (0 !== $00be48392311af6a$var$pendingEffectsStatus) {
        var onRecoverableError = $00be48392311af6a$var$pendingEffectsRoot.onRecoverableError;
        onRecoverableError(error, {
            componentStack: null
        });
    }
}
function $00be48392311af6a$var$flushAfterMutationEffects() {
    3 === $00be48392311af6a$var$pendingEffectsStatus && ($00be48392311af6a$var$pendingEffectsStatus = 0, $00be48392311af6a$var$commitAfterMutationEffectsOnFiber($00be48392311af6a$var$pendingFinishedWork, $00be48392311af6a$var$pendingEffectsRoot), $00be48392311af6a$var$pendingEffectsStatus = 4);
}
function $00be48392311af6a$var$flushMutationEffects() {
    if (1 === $00be48392311af6a$var$pendingEffectsStatus) {
        $00be48392311af6a$var$pendingEffectsStatus = 0;
        var root = $00be48392311af6a$var$pendingEffectsRoot, finishedWork = $00be48392311af6a$var$pendingFinishedWork, lanes = $00be48392311af6a$var$pendingEffectsLanes, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $00be48392311af6a$var$ReactSharedInternals.T;
            $00be48392311af6a$var$ReactSharedInternals.T = null;
            var previousPriority = $00be48392311af6a$var$ReactDOMSharedInternals.p;
            $00be48392311af6a$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $00be48392311af6a$var$executionContext;
            $00be48392311af6a$var$executionContext |= 4;
            try {
                $00be48392311af6a$var$inUpdateViewTransition = $00be48392311af6a$var$rootViewTransitionAffected = !1;
                $00be48392311af6a$var$commitMutationEffectsOnFiber(finishedWork, root, lanes);
                lanes = $00be48392311af6a$var$selectionInformation;
                var curFocusedElem = $00be48392311af6a$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = lanes.focusedElem, priorSelectionRange = lanes.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $00be48392311af6a$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $00be48392311af6a$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $00be48392311af6a$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $00be48392311af6a$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $00be48392311af6a$var$_enabled = !!$00be48392311af6a$var$eventsEnabled;
                $00be48392311af6a$var$selectionInformation = $00be48392311af6a$var$eventsEnabled = null;
            } finally{
                $00be48392311af6a$var$executionContext = prevExecutionContext, $00be48392311af6a$var$ReactDOMSharedInternals.p = previousPriority, $00be48392311af6a$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $00be48392311af6a$var$pendingEffectsStatus = 2;
    }
}
function $00be48392311af6a$var$flushLayoutEffects() {
    if (2 === $00be48392311af6a$var$pendingEffectsStatus) {
        $00be48392311af6a$var$pendingEffectsStatus = 0;
        var root = $00be48392311af6a$var$pendingEffectsRoot, finishedWork = $00be48392311af6a$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $00be48392311af6a$var$ReactSharedInternals.T;
            $00be48392311af6a$var$ReactSharedInternals.T = null;
            var previousPriority = $00be48392311af6a$var$ReactDOMSharedInternals.p;
            $00be48392311af6a$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $00be48392311af6a$var$executionContext;
            $00be48392311af6a$var$executionContext |= 4;
            try {
                $00be48392311af6a$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $00be48392311af6a$var$executionContext = prevExecutionContext, $00be48392311af6a$var$ReactDOMSharedInternals.p = previousPriority, $00be48392311af6a$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $00be48392311af6a$var$pendingEffectsStatus = 3;
    }
}
function $00be48392311af6a$var$flushSpawnedWork() {
    if (4 === $00be48392311af6a$var$pendingEffectsStatus || 3 === $00be48392311af6a$var$pendingEffectsStatus) {
        $00be48392311af6a$var$pendingEffectsStatus = 0;
        var committedViewTransition = $00be48392311af6a$var$pendingViewTransition;
        $00be48392311af6a$var$pendingViewTransition = null;
        $00be48392311af6a$var$requestPaint();
        var root = $00be48392311af6a$var$pendingEffectsRoot, finishedWork = $00be48392311af6a$var$pendingFinishedWork, lanes = $00be48392311af6a$var$pendingEffectsLanes, recoverableErrors = $00be48392311af6a$var$pendingRecoverableErrors, passiveSubtreeMask = (lanes & 335544064) === lanes ? 10262 : 10256;
        0 !== (finishedWork.subtreeFlags & passiveSubtreeMask) || 0 !== (finishedWork.flags & passiveSubtreeMask) ? $00be48392311af6a$var$pendingEffectsStatus = 5 : ($00be48392311af6a$var$pendingEffectsStatus = 0, $00be48392311af6a$var$pendingFinishedWork = $00be48392311af6a$var$pendingEffectsRoot = null, $00be48392311af6a$var$releaseRootPooledCache(root, root.pendingLanes));
        passiveSubtreeMask = root.pendingLanes;
        0 === passiveSubtreeMask && ($00be48392311af6a$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $00be48392311af6a$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($00be48392311af6a$var$injectedHook && "function" === typeof $00be48392311af6a$var$injectedHook.onCommitFiberRoot) try {
            $00be48392311af6a$var$injectedHook.onCommitFiberRoot($00be48392311af6a$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $00be48392311af6a$var$ReactSharedInternals.T;
            passiveSubtreeMask = $00be48392311af6a$var$ReactDOMSharedInternals.p;
            $00be48392311af6a$var$ReactDOMSharedInternals.p = 2;
            $00be48392311af6a$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $00be48392311af6a$var$ReactSharedInternals.T = finishedWork, $00be48392311af6a$var$ReactDOMSharedInternals.p = passiveSubtreeMask;
            }
        }
        recoverableErrors = $00be48392311af6a$var$pendingViewTransitionEvents;
        onRecoverableError = $00be48392311af6a$var$pendingTransitionTypes;
        $00be48392311af6a$var$pendingTransitionTypes = null;
        if (null !== recoverableErrors && ($00be48392311af6a$var$pendingViewTransitionEvents = null, null === onRecoverableError && (onRecoverableError = []), null !== committedViewTransition)) for(recoverableError = 0; recoverableError < recoverableErrors.length; recoverableError++)finishedWork = (0, recoverableErrors[recoverableError])(onRecoverableError), void 0 !== finishedWork && committedViewTransition.finished.finally(finishedWork);
        0 !== ($00be48392311af6a$var$pendingEffectsLanes & 3) && $00be48392311af6a$var$flushPendingEffects();
        $00be48392311af6a$var$ensureRootIsScheduled(root);
        passiveSubtreeMask = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (passiveSubtreeMask & 42) ? root === $00be48392311af6a$var$rootWithNestedUpdates ? $00be48392311af6a$var$nestedUpdateCount++ : ($00be48392311af6a$var$nestedUpdateCount = 0, $00be48392311af6a$var$rootWithNestedUpdates = root) : ($00be48392311af6a$var$nestedUpdateCount = 0, $00be48392311af6a$var$rootWithNestedUpdates = null);
        $00be48392311af6a$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $00be48392311af6a$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $00be48392311af6a$var$releaseCache(remainingLanes)));
}
function $00be48392311af6a$var$flushPendingEffects() {
    null !== $00be48392311af6a$var$pendingViewTransition && ($00be48392311af6a$var$pendingViewTransition.skipTransition(), $00be48392311af6a$var$pendingViewTransition = null);
    $00be48392311af6a$var$flushMutationEffects();
    $00be48392311af6a$var$flushLayoutEffects();
    $00be48392311af6a$var$flushSpawnedWork();
    return $00be48392311af6a$var$flushPassiveEffects();
}
function $00be48392311af6a$var$flushPassiveEffects() {
    if (5 !== $00be48392311af6a$var$pendingEffectsStatus) return !1;
    var root = $00be48392311af6a$var$pendingEffectsRoot, remainingLanes = $00be48392311af6a$var$pendingEffectsRemainingLanes;
    $00be48392311af6a$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $00be48392311af6a$var$lanesToEventPriority($00be48392311af6a$var$pendingEffectsLanes), prevTransition = $00be48392311af6a$var$ReactSharedInternals.T, previousPriority = $00be48392311af6a$var$ReactDOMSharedInternals.p;
    try {
        $00be48392311af6a$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $00be48392311af6a$var$ReactSharedInternals.T = null;
        renderPriority = $00be48392311af6a$var$pendingPassiveTransitions;
        $00be48392311af6a$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $00be48392311af6a$var$pendingEffectsRoot, lanes = $00be48392311af6a$var$pendingEffectsLanes;
        $00be48392311af6a$var$pendingEffectsStatus = 0;
        $00be48392311af6a$var$pendingFinishedWork = $00be48392311af6a$var$pendingEffectsRoot = null;
        $00be48392311af6a$var$pendingEffectsLanes = 0;
        if (0 !== ($00be48392311af6a$var$executionContext & 6)) throw Error($00be48392311af6a$var$formatProdErrorMessage(331));
        var prevExecutionContext = $00be48392311af6a$var$executionContext;
        $00be48392311af6a$var$executionContext |= 4;
        $00be48392311af6a$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $00be48392311af6a$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $00be48392311af6a$var$executionContext = prevExecutionContext;
        $00be48392311af6a$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($00be48392311af6a$var$injectedHook && "function" === typeof $00be48392311af6a$var$injectedHook.onPostCommitFiberRoot) try {
            $00be48392311af6a$var$injectedHook.onPostCommitFiberRoot($00be48392311af6a$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $00be48392311af6a$var$ReactDOMSharedInternals.p = previousPriority, $00be48392311af6a$var$ReactSharedInternals.T = prevTransition, $00be48392311af6a$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $00be48392311af6a$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $00be48392311af6a$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $00be48392311af6a$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $00be48392311af6a$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($00be48392311af6a$var$markRootUpdated$1(rootFiber, 2), $00be48392311af6a$var$ensureRootIsScheduled(rootFiber));
}
function $00be48392311af6a$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $00be48392311af6a$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $00be48392311af6a$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $00be48392311af6a$var$legacyErrorBoundariesThatAlreadyFailed || !$00be48392311af6a$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $00be48392311af6a$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $00be48392311af6a$var$createClassErrorUpdate(2);
                instance = $00be48392311af6a$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($00be48392311af6a$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $00be48392311af6a$var$markRootUpdated$1(instance, 2), $00be48392311af6a$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $00be48392311af6a$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $00be48392311af6a$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($00be48392311af6a$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $00be48392311af6a$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $00be48392311af6a$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $00be48392311af6a$var$workInProgressRoot === root && ($00be48392311af6a$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $00be48392311af6a$var$workInProgressRootExitStatus || 3 === $00be48392311af6a$var$workInProgressRootExitStatus && ($00be48392311af6a$var$workInProgressRootRenderLanes & 62914560) === $00be48392311af6a$var$workInProgressRootRenderLanes && 300 > $00be48392311af6a$var$now() - $00be48392311af6a$var$globalMostRecentFallbackTime ? 0 === ($00be48392311af6a$var$executionContext & 2) ? $00be48392311af6a$var$prepareFreshStack(root, 0) : $00be48392311af6a$var$workInProgressRootPingedLanes |= pingedLanes : $00be48392311af6a$var$workInProgressRootPingedLanes |= pingedLanes, $00be48392311af6a$var$workInProgressSuspendedRetryLanes === $00be48392311af6a$var$workInProgressRootRenderLanes && ($00be48392311af6a$var$workInProgressSuspendedRetryLanes = 0));
    $00be48392311af6a$var$ensureRootIsScheduled(root);
}
function $00be48392311af6a$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $00be48392311af6a$var$claimNextRetryLane());
    boundaryFiber = $00be48392311af6a$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($00be48392311af6a$var$markRootUpdated$1(boundaryFiber, retryLane), $00be48392311af6a$var$ensureRootIsScheduled(boundaryFiber));
}
function $00be48392311af6a$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $00be48392311af6a$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $00be48392311af6a$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($00be48392311af6a$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $00be48392311af6a$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $00be48392311af6a$var$scheduleCallback$1(priorityLevel, callback) {
    return $00be48392311af6a$var$scheduleCallback$3(priorityLevel, callback);
}
var $00be48392311af6a$var$firstScheduledRoot = null, $00be48392311af6a$var$lastScheduledRoot = null, $00be48392311af6a$var$didScheduleMicrotask = !1, $00be48392311af6a$var$mightHavePendingSyncWork = !1, $00be48392311af6a$var$isFlushingWork = !1, $00be48392311af6a$var$currentEventTransitionLane = 0;
function $00be48392311af6a$var$ensureRootIsScheduled(root) {
    root !== $00be48392311af6a$var$lastScheduledRoot && null === root.next && (null === $00be48392311af6a$var$lastScheduledRoot ? $00be48392311af6a$var$firstScheduledRoot = $00be48392311af6a$var$lastScheduledRoot = root : $00be48392311af6a$var$lastScheduledRoot = $00be48392311af6a$var$lastScheduledRoot.next = root);
    $00be48392311af6a$var$mightHavePendingSyncWork = !0;
    $00be48392311af6a$var$didScheduleMicrotask || ($00be48392311af6a$var$didScheduleMicrotask = !0, $00be48392311af6a$var$scheduleImmediateRootScheduleTask());
}
function $00be48392311af6a$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$00be48392311af6a$var$isFlushingWork && $00be48392311af6a$var$mightHavePendingSyncWork) {
        $00be48392311af6a$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$190 = $00be48392311af6a$var$firstScheduledRoot; null !== root$190;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$190.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$190.suspendedLanes, pingedLanes = root$190.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $00be48392311af6a$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $00be48392311af6a$var$performSyncWorkOnRoot(root$190, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $00be48392311af6a$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $00be48392311af6a$var$getNextLanes(root$190, root$190 === $00be48392311af6a$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$190.cancelPendingCommit || -1 !== root$190.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $00be48392311af6a$var$checkIfRootIsPrerendering(root$190, JSCompiler_inline_result) || (didPerformSomeWork = !0, $00be48392311af6a$var$performSyncWorkOnRoot(root$190, JSCompiler_inline_result));
                }
                root$190 = root$190.next;
            }
        }while (didPerformSomeWork);
        $00be48392311af6a$var$isFlushingWork = !1;
    }
}
function $00be48392311af6a$var$processRootScheduleInImmediateTask() {
    $00be48392311af6a$var$processRootScheduleInMicrotask();
}
function $00be48392311af6a$var$processRootScheduleInMicrotask() {
    $00be48392311af6a$var$mightHavePendingSyncWork = $00be48392311af6a$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $00be48392311af6a$var$currentEventTransitionLane && $00be48392311af6a$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $00be48392311af6a$var$currentEventTransitionLane);
    for(var currentTime = $00be48392311af6a$var$now(), prev = null, root = $00be48392311af6a$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $00be48392311af6a$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $00be48392311af6a$var$firstScheduledRoot = next : prev.next = next, null === next && ($00be48392311af6a$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $00be48392311af6a$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $00be48392311af6a$var$pendingEffectsStatus && 5 !== $00be48392311af6a$var$pendingEffectsStatus || $00be48392311af6a$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $00be48392311af6a$var$currentEventTransitionLane && ($00be48392311af6a$var$currentEventTransitionLane = 0);
}
function $00be48392311af6a$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $00be48392311af6a$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $00be48392311af6a$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $00be48392311af6a$var$workInProgressRoot;
    suspendedLanes = $00be48392311af6a$var$workInProgressRootRenderLanes;
    suspendedLanes = $00be48392311af6a$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $00be48392311af6a$var$workInProgressSuspendedReason || 9 === $00be48392311af6a$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $00be48392311af6a$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $00be48392311af6a$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $00be48392311af6a$var$cancelCallback$1(pingedLanes);
        switch($00be48392311af6a$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $00be48392311af6a$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $00be48392311af6a$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $00be48392311af6a$var$IdlePriority;
                break;
            default:
                suspendedLanes = $00be48392311af6a$var$NormalPriority$1;
        }
        pingedLanes = $00be48392311af6a$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $00be48392311af6a$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $00be48392311af6a$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $00be48392311af6a$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $00be48392311af6a$var$pendingEffectsStatus && 5 !== $00be48392311af6a$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($00be48392311af6a$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $00be48392311af6a$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $00be48392311af6a$var$getNextLanes(root, root === $00be48392311af6a$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $00be48392311af6a$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $00be48392311af6a$var$scheduleTaskForRootDuringMicrotask(root, $00be48392311af6a$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $00be48392311af6a$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $00be48392311af6a$var$performSyncWorkOnRoot(root, lanes) {
    if ($00be48392311af6a$var$flushPendingEffects()) return null;
    $00be48392311af6a$var$performWorkOnRoot(root, lanes, !0);
}
function $00be48392311af6a$var$scheduleImmediateRootScheduleTask() {
    $00be48392311af6a$var$scheduleMicrotask(function() {
        0 !== ($00be48392311af6a$var$executionContext & 6) ? $00be48392311af6a$var$scheduleCallback$3($00be48392311af6a$var$ImmediatePriority, $00be48392311af6a$var$processRootScheduleInImmediateTask) : $00be48392311af6a$var$processRootScheduleInMicrotask();
    });
}
function $00be48392311af6a$var$requestTransitionLane() {
    if (0 === $00be48392311af6a$var$currentEventTransitionLane) {
        var actionScopeLane = $00be48392311af6a$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $00be48392311af6a$var$nextTransitionUpdateLane, $00be48392311af6a$var$nextTransitionUpdateLane <<= 1, 0 === ($00be48392311af6a$var$nextTransitionUpdateLane & 261888) && ($00be48392311af6a$var$nextTransitionUpdateLane = 256));
        $00be48392311af6a$var$currentEventTransitionLane = actionScopeLane;
    }
    return $00be48392311af6a$var$currentEventTransitionLane;
}
function $00be48392311af6a$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $00be48392311af6a$var$sanitizeURL(actionProp);
}
function $00be48392311af6a$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $00be48392311af6a$var$coerceFormActionProp((nativeEventTarget[$00be48392311af6a$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$00be48392311af6a$var$internalPropsKey] || null) ? $00be48392311af6a$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $00be48392311af6a$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $00be48392311af6a$var$currentEventTransitionLane) {
                                var formData = new FormData(nativeEventTarget, submitter);
                                $00be48392311af6a$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = new FormData(nativeEventTarget, submitter), $00be48392311af6a$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $00be48392311af6a$var$i$jscomp$inline_1667 = 0; $00be48392311af6a$var$i$jscomp$inline_1667 < $00be48392311af6a$var$simpleEventPluginEvents.length; $00be48392311af6a$var$i$jscomp$inline_1667++){
    var $00be48392311af6a$var$eventName$jscomp$inline_1668 = $00be48392311af6a$var$simpleEventPluginEvents[$00be48392311af6a$var$i$jscomp$inline_1667], $00be48392311af6a$var$domEventName$jscomp$inline_1669 = $00be48392311af6a$var$eventName$jscomp$inline_1668.toLowerCase(), $00be48392311af6a$var$capitalizedEvent$jscomp$inline_1670 = $00be48392311af6a$var$eventName$jscomp$inline_1668[0].toUpperCase() + $00be48392311af6a$var$eventName$jscomp$inline_1668.slice(1);
    $00be48392311af6a$var$registerSimpleEvent($00be48392311af6a$var$domEventName$jscomp$inline_1669, "on" + $00be48392311af6a$var$capitalizedEvent$jscomp$inline_1670);
}
$00be48392311af6a$var$registerSimpleEvent($00be48392311af6a$var$ANIMATION_END, "onAnimationEnd");
$00be48392311af6a$var$registerSimpleEvent($00be48392311af6a$var$ANIMATION_ITERATION, "onAnimationIteration");
$00be48392311af6a$var$registerSimpleEvent($00be48392311af6a$var$ANIMATION_START, "onAnimationStart");
$00be48392311af6a$var$registerSimpleEvent("dblclick", "onDoubleClick");
$00be48392311af6a$var$registerSimpleEvent("focusin", "onFocus");
$00be48392311af6a$var$registerSimpleEvent("focusout", "onBlur");
$00be48392311af6a$var$registerSimpleEvent($00be48392311af6a$var$TRANSITION_RUN, "onTransitionRun");
$00be48392311af6a$var$registerSimpleEvent($00be48392311af6a$var$TRANSITION_START, "onTransitionStart");
$00be48392311af6a$var$registerSimpleEvent($00be48392311af6a$var$TRANSITION_CANCEL, "onTransitionCancel");
$00be48392311af6a$var$registerSimpleEvent($00be48392311af6a$var$TRANSITION_END, "onTransitionEnd");
$00be48392311af6a$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$00be48392311af6a$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$00be48392311af6a$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$00be48392311af6a$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$00be48392311af6a$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$00be48392311af6a$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$00be48392311af6a$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$00be48392311af6a$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$00be48392311af6a$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$00be48392311af6a$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $00be48392311af6a$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $00be48392311af6a$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($00be48392311af6a$var$mediaEventTypes));
function $00be48392311af6a$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $00be48392311af6a$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $00be48392311af6a$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $00be48392311af6a$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$00be48392311af6a$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$00be48392311af6a$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($00be48392311af6a$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $00be48392311af6a$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $00be48392311af6a$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $00be48392311af6a$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $00be48392311af6a$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$00be48392311af6a$var$listeningMarker]) {
        rootContainerElement[$00be48392311af6a$var$listeningMarker] = !0;
        $00be48392311af6a$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($00be48392311af6a$var$nonDelegatedEvents.has(domEventName) || $00be48392311af6a$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $00be48392311af6a$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$00be48392311af6a$var$listeningMarker] || (ownerDocument[$00be48392311af6a$var$listeningMarker] = !0, $00be48392311af6a$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $00be48392311af6a$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($00be48392311af6a$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $00be48392311af6a$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $00be48392311af6a$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $00be48392311af6a$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$00be48392311af6a$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $00be48392311af6a$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $00be48392311af6a$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $00be48392311af6a$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $00be48392311af6a$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $00be48392311af6a$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $00be48392311af6a$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $00be48392311af6a$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $00be48392311af6a$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $00be48392311af6a$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $00be48392311af6a$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $00be48392311af6a$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $00be48392311af6a$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $00be48392311af6a$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $00be48392311af6a$var$SyntheticTouchEvent;
                        break;
                    case $00be48392311af6a$var$ANIMATION_END:
                    case $00be48392311af6a$var$ANIMATION_ITERATION:
                    case $00be48392311af6a$var$ANIMATION_START:
                        SyntheticEventCtor = $00be48392311af6a$var$SyntheticAnimationEvent;
                        break;
                    case $00be48392311af6a$var$TRANSITION_END:
                        SyntheticEventCtor = $00be48392311af6a$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $00be48392311af6a$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $00be48392311af6a$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $00be48392311af6a$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $00be48392311af6a$var$SyntheticPointerEvent;
                        break;
                    case "submit":
                        SyntheticEventCtor = $00be48392311af6a$var$SyntheticSubmitEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $00be48392311af6a$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $00be48392311af6a$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($00be48392311af6a$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                SyntheticEventCtor = "mouseover" === domEventName || "pointerover" === domEventName;
                reactName = "mouseout" === domEventName || "pointerout" === domEventName;
                if (SyntheticEventCtor && nativeEvent !== $00be48392311af6a$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($00be48392311af6a$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$00be48392311af6a$var$internalContainerInstanceKey])) break a;
                if (reactName || SyntheticEventCtor) {
                    reactEventType = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (SyntheticEventCtor = nativeEventTarget.ownerDocument) ? SyntheticEventCtor.defaultView || SyntheticEventCtor.parentWindow : window;
                    if (reactName) {
                        if (SyntheticEventCtor = nativeEvent.relatedTarget || nativeEvent.toElement, reactName = targetInst, SyntheticEventCtor = SyntheticEventCtor ? $00be48392311af6a$var$getClosestInstanceFromNode(SyntheticEventCtor) : null, null !== SyntheticEventCtor && (accumulateTargetOnly = $00be48392311af6a$var$getNearestMountedFiber(SyntheticEventCtor), inCapturePhase = SyntheticEventCtor.tag, SyntheticEventCtor !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) SyntheticEventCtor = null;
                    } else reactName = null, SyntheticEventCtor = targetInst;
                    if (reactName !== SyntheticEventCtor) {
                        inCapturePhase = $00be48392311af6a$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $00be48392311af6a$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == reactName ? reactEventType : $00be48392311af6a$var$getNodeFromInstance(reactName);
                        lastHostComponent = null == SyntheticEventCtor ? reactEventType : $00be48392311af6a$var$getNodeFromInstance(SyntheticEventCtor);
                        reactEventType = new inCapturePhase(_instance, instance + "leave", reactName, nativeEvent, nativeEventTarget);
                        reactEventType.target = accumulateTargetOnly;
                        reactEventType.relatedTarget = lastHostComponent;
                        _instance = null;
                        $00be48392311af6a$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", SyntheticEventCtor, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        inCapturePhase = reactName && SyntheticEventCtor ? $00be48392311af6a$var$getLowestCommonAncestor(reactName, SyntheticEventCtor, $00be48392311af6a$var$getParent) : null;
                        null !== reactName && $00be48392311af6a$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactEventType, reactName, inCapturePhase, !1);
                        null !== SyntheticEventCtor && null !== accumulateTargetOnly && $00be48392311af6a$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, SyntheticEventCtor, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $00be48392311af6a$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $00be48392311af6a$var$getTargetInstForChangeEvent;
                else if ($00be48392311af6a$var$isTextInputElement(reactName)) {
                    if ($00be48392311af6a$var$isInputEventSupported) getTargetInstFunc = $00be48392311af6a$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $00be48392311af6a$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $00be48392311af6a$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $00be48392311af6a$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $00be48392311af6a$var$getTargetInstForChangeEvent) : getTargetInstFunc = $00be48392311af6a$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $00be48392311af6a$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
            }
            handleEventFunc = targetInst ? $00be48392311af6a$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($00be48392311af6a$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $00be48392311af6a$var$activeElement = handleEventFunc, $00be48392311af6a$var$activeElementInst = targetInst, $00be48392311af6a$var$lastSelection = null;
                    break;
                case "focusout":
                    $00be48392311af6a$var$lastSelection = $00be48392311af6a$var$activeElementInst = $00be48392311af6a$var$activeElement = null;
                    break;
                case "mousedown":
                    $00be48392311af6a$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $00be48392311af6a$var$mouseDown = !1;
                    $00be48392311af6a$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($00be48392311af6a$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $00be48392311af6a$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($00be48392311af6a$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $00be48392311af6a$var$isComposing ? $00be48392311af6a$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($00be48392311af6a$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($00be48392311af6a$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $00be48392311af6a$var$isComposing && (fallbackData = $00be48392311af6a$var$getData()) : ($00be48392311af6a$var$root = nativeEventTarget, $00be48392311af6a$var$startText = "value" in $00be48392311af6a$var$root ? $00be48392311af6a$var$root.value : $00be48392311af6a$var$root.textContent, $00be48392311af6a$var$isComposing = !0)), handleEventFunc = $00be48392311af6a$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $00be48392311af6a$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $00be48392311af6a$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $00be48392311af6a$var$canUseTextInputEvent ? $00be48392311af6a$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $00be48392311af6a$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $00be48392311af6a$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $00be48392311af6a$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $00be48392311af6a$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $00be48392311af6a$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $00be48392311af6a$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $00be48392311af6a$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $00be48392311af6a$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($00be48392311af6a$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $00be48392311af6a$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($00be48392311af6a$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $00be48392311af6a$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $00be48392311af6a$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $00be48392311af6a$var$getListener(target, registrationName), null != stateNode && listeners.unshift($00be48392311af6a$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $00be48392311af6a$var$getListener(target, registrationName), null != stateNode && listeners.push($00be48392311af6a$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $00be48392311af6a$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $00be48392311af6a$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $00be48392311af6a$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($00be48392311af6a$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($00be48392311af6a$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $00be48392311af6a$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $00be48392311af6a$var$normalizeMarkupForTextOrAttribute(clientText);
    return $00be48392311af6a$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $00be48392311af6a$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            if ("string" === typeof value) "body" === tag || "textarea" === tag && "" === value || $00be48392311af6a$var$setTextContent(domElement, value);
            else if ("number" === typeof value || "bigint" === typeof value) "body" !== tag && $00be48392311af6a$var$setTextContent(domElement, "" + value);
            else return;
            break;
        case "className":
            $00be48392311af6a$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $00be48392311af6a$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $00be48392311af6a$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $00be48392311af6a$var$setValueForStyles(domElement, value, prevValue);
            return;
        case "data":
            if ("object" !== tag) {
                $00be48392311af6a$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $00be48392311af6a$var$sanitizeURL(value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $00be48392311af6a$var$setProp(domElement, tag, "name", props.name, props, null), $00be48392311af6a$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $00be48392311af6a$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $00be48392311af6a$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($00be48392311af6a$var$setProp(domElement, tag, "encType", props.encType, props, null), $00be48392311af6a$var$setProp(domElement, tag, "method", props.method, props, null), $00be48392311af6a$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $00be48392311af6a$var$sanitizeURL(value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $00be48392311af6a$var$noop$1);
            return;
        case "onScroll":
            null != value && $00be48392311af6a$var$listenToNonDelegatedEvent("scroll", domElement);
            return;
        case "onScrollEnd":
            null != value && $00be48392311af6a$var$listenToNonDelegatedEvent("scrollend", domElement);
            return;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($00be48392311af6a$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($00be48392311af6a$var$formatProdErrorMessage(60));
                    (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $00be48392311af6a$var$sanitizeURL(value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "credentialless":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $00be48392311af6a$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $00be48392311af6a$var$listenToNonDelegatedEvent("toggle", domElement);
            $00be48392311af6a$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $00be48392311af6a$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $00be48392311af6a$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $00be48392311af6a$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $00be48392311af6a$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $00be48392311af6a$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $00be48392311af6a$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $00be48392311af6a$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $00be48392311af6a$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $00be48392311af6a$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $00be48392311af6a$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            return;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $00be48392311af6a$var$aliases.get(key) || key, $00be48392311af6a$var$setValueForAttribute(domElement, key, value);
            else return;
    }
    $00be48392311af6a$var$viewTransitionMutationContext = !0;
}
function $00be48392311af6a$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $00be48392311af6a$var$setValueForStyles(domElement, value, prevValue);
            return;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($00be48392311af6a$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($00be48392311af6a$var$formatProdErrorMessage(60));
                    (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                }
            }
            break;
        case "children":
            if ("string" === typeof value) $00be48392311af6a$var$setTextContent(domElement, value);
            else if ("number" === typeof value || "bigint" === typeof value) $00be48392311af6a$var$setTextContent(domElement, "" + value);
            else return;
            break;
        case "onScroll":
            null != value && $00be48392311af6a$var$listenToNonDelegatedEvent("scroll", domElement);
            return;
        case "onScrollEnd":
            null != value && $00be48392311af6a$var$listenToNonDelegatedEvent("scrollend", domElement);
            return;
        case "onClick":
            null != value && (domElement.onclick = $00be48392311af6a$var$noop$1);
            return;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            return;
        case "innerText":
        case "textContent":
            return;
        default:
            if (!$00be48392311af6a$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), prevValue = key.slice(2, props ? key.length - 7 : void 0), tag = domElement[$00be48392311af6a$var$internalPropsKey] || null, tag = null != tag ? tag[key] : null, "function" === typeof tag && domElement.removeEventListener(prevValue, tag, props), "function" === typeof value)) {
                    "function" !== typeof tag && null !== tag && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(prevValue, value, props);
                    break a;
                }
                $00be48392311af6a$var$viewTransitionMutationContext = !0;
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $00be48392311af6a$var$setValueForAttribute(domElement, key, value);
            }
            return;
    }
    $00be48392311af6a$var$viewTransitionMutationContext = !0;
}
function $00be48392311af6a$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $00be48392311af6a$var$listenToNonDelegatedEvent("error", domElement);
            $00be48392311af6a$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($00be48392311af6a$var$formatProdErrorMessage(137, tag));
                    default:
                        $00be48392311af6a$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $00be48392311af6a$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $00be48392311af6a$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $00be48392311af6a$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$204 = props[hasSrc];
                if (null != propValue$204) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$204;
                        break;
                    case "type":
                        propValue = propValue$204;
                        break;
                    case "checked":
                        checked = propValue$204;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$204;
                        break;
                    case "value":
                        propKey = propValue$204;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$204;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$204) throw Error($00be48392311af6a$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $00be48392311af6a$var$setProp(domElement, tag, hasSrc, propValue$204, props, null);
                }
            }
            $00be48392311af6a$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $00be48392311af6a$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $00be48392311af6a$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $00be48392311af6a$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $00be48392311af6a$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $00be48392311af6a$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($00be48392311af6a$var$formatProdErrorMessage(91));
                    break;
                default:
                    $00be48392311af6a$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $00be48392311af6a$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $00be48392311af6a$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $00be48392311af6a$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $00be48392311af6a$var$listenToNonDelegatedEvent("toggle", domElement);
            $00be48392311af6a$var$listenToNonDelegatedEvent("cancel", domElement);
            $00be48392311af6a$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $00be48392311af6a$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $00be48392311af6a$var$mediaEventTypes.length; hasSrc++)$00be48392311af6a$var$listenToNonDelegatedEvent($00be48392311af6a$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $00be48392311af6a$var$listenToNonDelegatedEvent("error", domElement);
            $00be48392311af6a$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $00be48392311af6a$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $00be48392311af6a$var$listenToNonDelegatedEvent("error", domElement), $00be48392311af6a$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($00be48392311af6a$var$formatProdErrorMessage(137, tag));
                default:
                    $00be48392311af6a$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($00be48392311af6a$var$isCustomElement(tag)) {
                for(propValue$204 in props)props.hasOwnProperty(propValue$204) && (hasSrc = props[propValue$204], void 0 !== hasSrc && $00be48392311af6a$var$setPropOnCustomElement(domElement, tag, propValue$204, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $00be48392311af6a$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
var $00be48392311af6a$var$emptyProps = {};
function $00be48392311af6a$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $00be48392311af6a$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$221 in nextProps){
                var propKey = nextProps[propKey$221];
                lastProp = lastProps[propKey$221];
                if (nextProps.hasOwnProperty(propKey$221) && (null != propKey || null != lastProp)) switch(propKey$221){
                    case "type":
                        propKey !== lastProp && ($00be48392311af6a$var$viewTransitionMutationContext = !0);
                        type = propKey;
                        break;
                    case "name":
                        propKey !== lastProp && ($00be48392311af6a$var$viewTransitionMutationContext = !0);
                        name = propKey;
                        break;
                    case "checked":
                        propKey !== lastProp && ($00be48392311af6a$var$viewTransitionMutationContext = !0);
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        propKey !== lastProp && ($00be48392311af6a$var$viewTransitionMutationContext = !0);
                        defaultChecked = propKey;
                        break;
                    case "value":
                        propKey !== lastProp && ($00be48392311af6a$var$viewTransitionMutationContext = !0);
                        value = propKey;
                        break;
                    case "defaultValue":
                        propKey !== lastProp && ($00be48392311af6a$var$viewTransitionMutationContext = !0);
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($00be48392311af6a$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $00be48392311af6a$var$setProp(domElement, tag, propKey$221, propKey, nextProps, lastProp);
                }
            }
            $00be48392311af6a$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$221 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $00be48392311af6a$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    type !== lastDefaultValue && ($00be48392311af6a$var$viewTransitionMutationContext = !0);
                    propKey$221 = type;
                    break;
                case "defaultValue":
                    type !== lastDefaultValue && ($00be48392311af6a$var$viewTransitionMutationContext = !0);
                    defaultValue = type;
                    break;
                case "multiple":
                    type !== lastDefaultValue && ($00be48392311af6a$var$viewTransitionMutationContext = !0), value = type;
                default:
                    type !== lastDefaultValue && $00be48392311af6a$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$221 ? $00be48392311af6a$var$updateOptions(domElement, !!lastProps, propKey$221, !1) : !!nextProps !== !!lastProps && (null != tag ? $00be48392311af6a$var$updateOptions(domElement, !!lastProps, tag, !0) : $00be48392311af6a$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$221 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $00be48392311af6a$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    name !== type && ($00be48392311af6a$var$viewTransitionMutationContext = !0);
                    propKey$221 = name;
                    break;
                case "defaultValue":
                    name !== type && ($00be48392311af6a$var$viewTransitionMutationContext = !0);
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($00be48392311af6a$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $00be48392311af6a$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $00be48392311af6a$var$updateTextarea(domElement, propKey$221, propKey);
            return;
        case "option":
            for(var propKey$237 in lastProps)if (propKey$221 = lastProps[propKey$237], lastProps.hasOwnProperty(propKey$237) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$237)) switch(propKey$237){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $00be48392311af6a$var$setProp(domElement, tag, propKey$237, null, nextProps, propKey$221);
            }
            for(lastDefaultValue in nextProps)if (propKey$221 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$221 !== propKey && (null != propKey$221 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    propKey$221 !== propKey && ($00be48392311af6a$var$viewTransitionMutationContext = !0);
                    domElement.selected = propKey$221 && "function" !== typeof propKey$221 && "symbol" !== typeof propKey$221;
                    break;
                default:
                    $00be48392311af6a$var$setProp(domElement, tag, lastDefaultValue, propKey$221, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$242 in lastProps)propKey$221 = lastProps[propKey$242], lastProps.hasOwnProperty(propKey$242) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$242) && $00be48392311af6a$var$setProp(domElement, tag, propKey$242, null, nextProps, propKey$221);
            for(checked in nextProps)if (propKey$221 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$221 !== propKey && (null != propKey$221 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$221) throw Error($00be48392311af6a$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $00be48392311af6a$var$setProp(domElement, tag, checked, propKey$221, nextProps, propKey);
            }
            return;
        default:
            if ($00be48392311af6a$var$isCustomElement(tag)) {
                for(var propKey$247 in lastProps)propKey$221 = lastProps[propKey$247], lastProps.hasOwnProperty(propKey$247) && void 0 !== propKey$221 && !nextProps.hasOwnProperty(propKey$247) && $00be48392311af6a$var$setPropOnCustomElement(domElement, tag, propKey$247, void 0, nextProps, propKey$221);
                for(defaultChecked in nextProps)propKey$221 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$221 === propKey || void 0 === propKey$221 && void 0 === propKey || $00be48392311af6a$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$221, nextProps, propKey);
                return;
            }
    }
    for(var propKey$252 in lastProps)propKey$221 = lastProps[propKey$252], lastProps.hasOwnProperty(propKey$252) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$252) && $00be48392311af6a$var$setProp(domElement, tag, propKey$252, null, nextProps, propKey$221);
    for(lastProp in nextProps)propKey$221 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$221 === propKey || null == propKey$221 && null == propKey || $00be48392311af6a$var$setProp(domElement, tag, lastProp, propKey$221, nextProps, propKey);
}
function $00be48392311af6a$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $00be48392311af6a$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $00be48392311af6a$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $00be48392311af6a$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $00be48392311af6a$var$eventsEnabled = null, $00be48392311af6a$var$selectionInformation = null;
function $00be48392311af6a$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $00be48392311af6a$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $00be48392311af6a$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $00be48392311af6a$var$createHoistableInstance(type, props, rootContainerInstance, internalInstanceHandle) {
    rootContainerInstance = $00be48392311af6a$var$getOwnerDocumentFromRootContainer(rootContainerInstance).createElement(type);
    rootContainerInstance[$00be48392311af6a$var$internalInstanceKey] = internalInstanceHandle;
    rootContainerInstance[$00be48392311af6a$var$internalPropsKey] = props;
    $00be48392311af6a$var$setInitialProperties(rootContainerInstance, type, props);
    $00be48392311af6a$var$markNodeAsHoistable(rootContainerInstance);
    return rootContainerInstance;
}
function $00be48392311af6a$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $00be48392311af6a$var$currentPopstateTransitionEvent = null;
function $00be48392311af6a$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $00be48392311af6a$var$currentPopstateTransitionEvent) return !1;
        $00be48392311af6a$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $00be48392311af6a$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $00be48392311af6a$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $00be48392311af6a$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $00be48392311af6a$var$localPromise = "function" === typeof Promise ? Promise : void 0, $00be48392311af6a$var$localRequestAnimationFrame = "function" === typeof requestAnimationFrame ? requestAnimationFrame : $00be48392311af6a$var$scheduleTimeout, $00be48392311af6a$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $00be48392311af6a$var$localPromise ? function(callback) {
    return $00be48392311af6a$var$localPromise.resolve(null).then(callback).catch($00be48392311af6a$var$handleErrorInNextTick);
} : $00be48392311af6a$var$scheduleTimeout;
function $00be48392311af6a$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $00be48392311af6a$var$isSingletonScope(type) {
    return "head" === type;
}
function $00be48392311af6a$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $00be48392311af6a$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $00be48392311af6a$var$clearSingletonPreambleContribution(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $00be48392311af6a$var$clearSingletonPreambleContribution(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$00be48392311af6a$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $00be48392311af6a$var$clearSingletonPreambleContribution(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $00be48392311af6a$var$retryIfBlockedOn(hydrationInstance);
}
function $00be48392311af6a$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $00be48392311af6a$var$applyViewTransitionName(instance, name, className) {
    name = CSS.escape(name) !== name ? "r-" + btoa(name).replace(/=/g, "") : name;
    instance.style.viewTransitionName = name;
    null != className && (instance.style.viewTransitionClass = className);
    className = getComputedStyle(instance);
    if ("inline" === className.display) {
        name = instance.getClientRects();
        if (1 === name.length) var JSCompiler_inline_result = 1;
        else for(var i = JSCompiler_inline_result = 0; i < name.length; i++){
            var rect = name[i];
            0 < rect.width && 0 < rect.height && JSCompiler_inline_result++;
        }
        1 === JSCompiler_inline_result && (instance = instance.style, instance.display = 1 === name.length ? "inline-block" : "block", instance.marginTop = "-" + className.paddingTop, instance.marginBottom = "-" + className.paddingBottom);
    }
}
function $00be48392311af6a$var$restoreViewTransitionName(instance, props) {
    instance = instance.style;
    props = props.style;
    var viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionName") ? props.viewTransitionName : props.hasOwnProperty("view-transition-name") ? props["view-transition-name"] : null : null;
    instance.viewTransitionName = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
    viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionClass") ? props.viewTransitionClass : props.hasOwnProperty("view-transition-class") ? props["view-transition-class"] : null : null;
    instance.viewTransitionClass = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
    "inline-block" === instance.display && (null == props ? instance.display = instance.margin = "" : (viewTransitionName = props.display, instance.display = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, viewTransitionName = props.margin, null != viewTransitionName ? instance.margin = viewTransitionName : (viewTransitionName = props.hasOwnProperty("marginTop") ? props.marginTop : props["margin-top"], instance.marginTop = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, props = props.hasOwnProperty("marginBottom") ? props.marginBottom : props["margin-bottom"], instance.marginBottom = null == props || "boolean" === typeof props ? "" : props)));
}
function $00be48392311af6a$var$createMeasurement(rect, computedStyle, element) {
    element = element.ownerDocument.defaultView;
    return {
        rect: rect,
        abs: "absolute" === computedStyle.position || "fixed" === computedStyle.position,
        clip: "none" !== computedStyle.clipPath || "visible" !== computedStyle.overflow || "none" !== computedStyle.filter || "none" !== computedStyle.mask || "none" !== computedStyle.mask || "0px" !== computedStyle.borderRadius,
        view: 0 <= rect.bottom && 0 <= rect.right && rect.top <= element.innerHeight && rect.left <= element.innerWidth
    };
}
function $00be48392311af6a$var$measureInstance(instance) {
    var rect = instance.getBoundingClientRect(), computedStyle = getComputedStyle(instance);
    return $00be48392311af6a$var$createMeasurement(rect, computedStyle, instance);
}
function $00be48392311af6a$var$measureClonedInstance(instance) {
    var measuredRect = instance.getBoundingClientRect();
    measuredRect = new DOMRect(measuredRect.x + 2e4, measuredRect.y + 2e4, measuredRect.width, measuredRect.height);
    var computedStyle = getComputedStyle(instance);
    return $00be48392311af6a$var$createMeasurement(measuredRect, computedStyle, instance);
}
function $00be48392311af6a$var$forceLayout(ownerDocument) {
    return ownerDocument.documentElement.clientHeight;
}
function $00be48392311af6a$var$waitForImageToLoad(resolve) {
    this.addEventListener("load", resolve);
    this.addEventListener("error", resolve);
}
function $00be48392311af6a$var$startViewTransition(suspendedState, rootContainer, transitionTypes, mutationCallback, layoutCallback, afterMutationCallback, spawnedWorkCallback, passiveCallback, errorCallback) {
    var ownerDocument = 9 === rootContainer.nodeType ? rootContainer : rootContainer.ownerDocument;
    try {
        var transition = ownerDocument.startViewTransition({
            update: function() {
                var ownerWindow = ownerDocument.defaultView, pendingNavigation = ownerWindow.navigation && ownerWindow.navigation.transition, previousFontLoadingStatus = ownerDocument.fonts.status;
                mutationCallback();
                var blockingPromises = [];
                "loaded" === previousFontLoadingStatus && ($00be48392311af6a$var$forceLayout(ownerDocument), "loading" === ownerDocument.fonts.status && blockingPromises.push(ownerDocument.fonts.ready));
                previousFontLoadingStatus = blockingPromises.length;
                if (null !== suspendedState) for(var suspenseyImages = suspendedState.suspenseyImages, imgBytes = 0, i = 0; i < suspenseyImages.length; i++){
                    var suspenseyImage = suspenseyImages[i];
                    if (!suspenseyImage.complete) {
                        var rect = suspenseyImage.getBoundingClientRect();
                        if (0 < rect.bottom && 0 < rect.right && rect.top < ownerWindow.innerHeight && rect.left < ownerWindow.innerWidth) {
                            imgBytes += $00be48392311af6a$var$estimateImageBytes(suspenseyImage);
                            if (imgBytes > $00be48392311af6a$var$estimatedBytesWithinLimit) {
                                blockingPromises.length = previousFontLoadingStatus;
                                break;
                            }
                            suspenseyImage = new Promise($00be48392311af6a$var$waitForImageToLoad.bind(suspenseyImage));
                            blockingPromises.push(suspenseyImage);
                        }
                    }
                }
                if (0 < blockingPromises.length) return ownerWindow = Promise.race([
                    Promise.all(blockingPromises),
                    new Promise(function(resolve) {
                        return setTimeout(resolve, 500);
                    })
                ]).then(layoutCallback, layoutCallback), (pendingNavigation ? Promise.allSettled([
                    pendingNavigation.finished,
                    ownerWindow
                ]) : ownerWindow).then(afterMutationCallback, afterMutationCallback);
                layoutCallback();
                if (pendingNavigation) return pendingNavigation.finished.then(afterMutationCallback, afterMutationCallback);
                afterMutationCallback();
            },
            types: transitionTypes
        });
        ownerDocument.__reactViewTransition = transition;
        var viewTransitionAnimations = [];
        transition.ready.then(function() {
            for(var animations = ownerDocument.documentElement.getAnimations({
                subtree: !0
            }), i = 0; i < animations.length; i++){
                var animation = animations[i], effect = animation.effect, pseudoElement = effect.pseudoElement;
                if (null != pseudoElement && pseudoElement.startsWith("::view-transition")) {
                    viewTransitionAnimations.push(animation);
                    animation = effect.getKeyframes();
                    for(var height = pseudoElement = void 0, unchangedDimensions = !0, j = 0; j < animation.length; j++){
                        var keyframe = animation[j], w = keyframe.width;
                        if (void 0 === pseudoElement) pseudoElement = w;
                        else if (pseudoElement !== w) {
                            unchangedDimensions = !1;
                            break;
                        }
                        w = keyframe.height;
                        if (void 0 === height) height = w;
                        else if (height !== w) {
                            unchangedDimensions = !1;
                            break;
                        }
                        delete keyframe.width;
                        delete keyframe.height;
                        "none" === keyframe.transform && delete keyframe.transform;
                    }
                    unchangedDimensions && void 0 !== pseudoElement && void 0 !== height && (effect.setKeyframes(animation), unchangedDimensions = getComputedStyle(effect.target, effect.pseudoElement), unchangedDimensions.width !== pseudoElement || unchangedDimensions.height !== height) && (unchangedDimensions = animation[0], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, unchangedDimensions = animation[animation.length - 1], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, effect.setKeyframes(animation));
                }
            }
            spawnedWorkCallback();
        }, function(error) {
            ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
            try {
                if ("object" === typeof error && null !== error) switch(error.name){
                    case "InvalidStateError":
                        if ("View transition was skipped because document visibility state is hidden." === error.message || "Skipping view transition because document visibility state has become hidden." === error.message || "Skipping view transition because viewport size changed." === error.message || "Transition was aborted because of invalid state" === error.message) error = null;
                }
                null !== error && errorCallback(error);
            } finally{
                mutationCallback(), layoutCallback(), spawnedWorkCallback();
            }
        });
        transition.finished.finally(function() {
            for(var i = 0; i < viewTransitionAnimations.length; i++)viewTransitionAnimations[i].cancel();
            ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
            passiveCallback();
        });
        return transition;
    } catch (x) {
        return mutationCallback(), layoutCallback(), spawnedWorkCallback(), null;
    }
}
function $00be48392311af6a$var$ViewTransitionPseudoElement(pseudo, name) {
    this._scope = document.documentElement;
    this._selector = "::view-transition-" + pseudo + "(" + name + ")";
}
$00be48392311af6a$var$ViewTransitionPseudoElement.prototype.animate = function(keyframes, options) {
    options = "number" === typeof options ? {
        duration: options
    } : $00be48392311af6a$var$assign({}, options);
    options.pseudoElement = this._selector;
    return this._scope.animate(keyframes, options);
};
$00be48392311af6a$var$ViewTransitionPseudoElement.prototype.getAnimations = function() {
    for(var scope = this._scope, selector = this._selector, animations = scope.getAnimations({
        subtree: !0
    }), result = [], i = 0; i < animations.length; i++){
        var effect = animations[i].effect;
        null !== effect && effect.target === scope && effect.pseudoElement === selector && result.push(animations[i]);
    }
    return result;
};
$00be48392311af6a$var$ViewTransitionPseudoElement.prototype.getComputedStyle = function() {
    return getComputedStyle(this._scope, this._selector);
};
function $00be48392311af6a$var$createViewTransitionInstance(name) {
    return {
        name: name,
        group: new $00be48392311af6a$var$ViewTransitionPseudoElement("group", name),
        imagePair: new $00be48392311af6a$var$ViewTransitionPseudoElement("image-pair", name),
        old: new $00be48392311af6a$var$ViewTransitionPseudoElement("old", name),
        new: new $00be48392311af6a$var$ViewTransitionPseudoElement("new", name)
    };
}
function $00be48392311af6a$var$FragmentInstance(fragmentFiber) {
    this._fragmentFiber = fragmentFiber;
    this._observers = this._eventListeners = null;
}
$00be48392311af6a$var$FragmentInstance.prototype.addEventListener = function(type, listener, optionsOrUseCapture) {
    var signal = null, cleanup = null;
    if (null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && (signal = optionsOrUseCapture.signal || null, null !== signal && signal.aborted)) return;
    null === this._eventListeners && (this._eventListeners = []);
    var listeners = this._eventListeners;
    if (-1 === $00be48392311af6a$var$indexOfEventListener(listeners, type, listener, optionsOrUseCapture)) {
        var fragmentInstance = this, attachedListener = listener;
        null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && !0 === optionsOrUseCapture.once && (attachedListener = function(event) {
            fragmentInstance.removeEventListener(type, listener, optionsOrUseCapture);
            "function" === typeof listener ? listener.call(this, event) : listener.handleEvent(event);
        });
        null !== signal && (cleanup = fragmentInstance.removeEventListener.bind(fragmentInstance, type, listener, optionsOrUseCapture), signal.addEventListener("abort", cleanup, {
            once: !0
        }), cleanup = signal.removeEventListener.bind(signal, "abort", cleanup));
        signal = $00be48392311af6a$var$getAttachOptions(optionsOrUseCapture);
        listeners.push({
            type: type,
            listener: listener,
            optionsOrUseCapture: optionsOrUseCapture,
            attachedListener: attachedListener,
            cleanup: cleanup
        });
        $00be48392311af6a$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $00be48392311af6a$var$addEventListenerToChild, type, attachedListener, signal);
    }
    this._eventListeners = listeners;
};
function $00be48392311af6a$var$addEventListenerToChild(child, type, listener, optionsOrUseCapture) {
    $00be48392311af6a$var$getInstanceFromHostFiber(child).addEventListener(type, listener, optionsOrUseCapture);
    return !1;
}
$00be48392311af6a$var$FragmentInstance.prototype.removeEventListener = function(type, listener, optionsOrUseCapture) {
    var listeners = this._eventListeners;
    if (null !== listeners && (listener = $00be48392311af6a$var$indexOfEventListener(listeners, type, listener, optionsOrUseCapture), -1 !== listener)) {
        var _listeners$index = listeners[listener];
        optionsOrUseCapture = _listeners$index.attachedListener;
        var cleanup = _listeners$index.cleanup;
        _listeners$index = $00be48392311af6a$var$getAttachOptions(_listeners$index.optionsOrUseCapture);
        $00be48392311af6a$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $00be48392311af6a$var$removeEventListenerFromChild, type, optionsOrUseCapture, _listeners$index);
        listeners.splice(listener, 1);
        null !== cleanup && cleanup();
    }
};
function $00be48392311af6a$var$removeEventListenerFromChild(child, type, listener, optionsOrUseCapture) {
    $00be48392311af6a$var$getInstanceFromHostFiber(child).removeEventListener(type, listener, optionsOrUseCapture);
    return !1;
}
function $00be48392311af6a$var$getAttachOptions(opts) {
    return null != opts && "boolean" !== typeof opts && (!0 === opts.once || opts.signal instanceof AbortSignal) ? {
        capture: opts.capture,
        passive: opts.passive
    } : opts;
}
function $00be48392311af6a$var$normalizeListenerOptions(opts) {
    return null == opts ? "c=0" : "boolean" === typeof opts ? "c=" + (opts ? "1" : "0") : "c=" + (opts.capture ? "1" : "0");
}
function $00be48392311af6a$var$indexOfEventListener(eventListeners, type, listener, optionsOrUseCapture) {
    if (0 === eventListeners.length) return -1;
    optionsOrUseCapture = $00be48392311af6a$var$normalizeListenerOptions(optionsOrUseCapture);
    for(var i = 0; i < eventListeners.length; i++){
        var item = eventListeners[i];
        if (item.type === type && item.listener === listener && $00be48392311af6a$var$normalizeListenerOptions(item.optionsOrUseCapture) === optionsOrUseCapture) return i;
    }
    return -1;
}
$00be48392311af6a$var$FragmentInstance.prototype.dispatchEvent = function(event) {
    var parentHostFiber = $00be48392311af6a$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    if (null === parentHostFiber) return !0;
    parentHostFiber = $00be48392311af6a$var$getInstanceFromHostFiber(parentHostFiber);
    var eventListeners = this._eventListeners;
    if (null !== eventListeners && 0 < eventListeners.length || !event.bubbles) {
        var temp = 9 === parentHostFiber.nodeType ? parentHostFiber.createComment("") : document.createTextNode("");
        if (eventListeners) for(var i = 0; i < eventListeners.length; i++){
            var _eventListeners$i = eventListeners[i];
            temp.addEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, $00be48392311af6a$var$getAttachOptions(_eventListeners$i.optionsOrUseCapture));
        }
        parentHostFiber.appendChild(temp);
        event = temp.dispatchEvent(event);
        if (eventListeners) for(i = 0; i < eventListeners.length; i++)_eventListeners$i = eventListeners[i], temp.removeEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, $00be48392311af6a$var$getAttachOptions(_eventListeners$i.optionsOrUseCapture));
        parentHostFiber.removeChild(temp);
        return event;
    }
    return parentHostFiber.dispatchEvent(event);
};
$00be48392311af6a$var$FragmentInstance.prototype.focus = function(focusOptions) {
    $00be48392311af6a$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, $00be48392311af6a$var$setFocusOnFiberIfFocusable, focusOptions, void 0, void 0);
};
function $00be48392311af6a$var$setFocusOnFiberIfFocusable(fiber, focusOptions) {
    if (6 === fiber.tag) return !1;
    fiber = $00be48392311af6a$var$getInstanceFromHostFiber(fiber);
    return $00be48392311af6a$var$setFocusIfFocusable(fiber, focusOptions);
}
$00be48392311af6a$var$FragmentInstance.prototype.focusLast = function(focusOptions) {
    var children = [];
    $00be48392311af6a$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, $00be48392311af6a$var$collectChildren, children, void 0, void 0);
    for(var i = children.length - 1; 0 <= i && !$00be48392311af6a$var$setFocusOnFiberIfFocusable(children[i], focusOptions); i--);
};
function $00be48392311af6a$var$collectChildren(child, collection) {
    collection.push(child);
    return !1;
}
$00be48392311af6a$var$FragmentInstance.prototype.blur = function() {
    var parentHostFiber = $00be48392311af6a$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    null !== parentHostFiber && (parentHostFiber = $00be48392311af6a$var$getInstanceFromHostFiber(parentHostFiber), parentHostFiber = $00be48392311af6a$var$getOwnerDocumentFromRootContainer(parentHostFiber).activeElement, null !== parentHostFiber && $00be48392311af6a$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $00be48392311af6a$var$blurActiveElementWithinFragment, parentHostFiber, void 0, void 0));
};
function $00be48392311af6a$var$blurActiveElementWithinFragment(child, activeElement) {
    if (6 === child.tag) return !1;
    child = $00be48392311af6a$var$getInstanceFromHostFiber(child);
    return child === activeElement || child.contains(activeElement) ? (activeElement.blur(), !0) : !1;
}
$00be48392311af6a$var$FragmentInstance.prototype.observeUsing = function(observer) {
    null === this._observers && (this._observers = new Set());
    this._observers.add(observer);
    $00be48392311af6a$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $00be48392311af6a$var$observeChild, observer, void 0, void 0);
};
function $00be48392311af6a$var$observeChild(child, observer) {
    if (6 === child.tag) return !1;
    child = $00be48392311af6a$var$getInstanceFromHostFiber(child);
    observer.observe(child);
    return !1;
}
$00be48392311af6a$var$FragmentInstance.prototype.unobserveUsing = function(observer) {
    var observers = this._observers;
    if (null !== observers && observers.has(observer)) {
        observers.delete(observer);
        $00be48392311af6a$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $00be48392311af6a$var$unobserveChild, observer, void 0, void 0);
        for(var i = observers = 0; i < $00be48392311af6a$var$pendingIntersectionUnobserves.length; i++){
            var pending = $00be48392311af6a$var$pendingIntersectionUnobserves[i];
            pending.fragmentInstance === this && pending.observer === observer ? observer.unobserve(pending.instance) : $00be48392311af6a$var$pendingIntersectionUnobserves[observers++] = pending;
        }
        $00be48392311af6a$var$pendingIntersectionUnobserves.length = observers;
    }
};
function $00be48392311af6a$var$unobserveChild(child, observer) {
    if (6 === child.tag) return !1;
    child = $00be48392311af6a$var$getInstanceFromHostFiber(child);
    observer.unobserve(child);
    return !1;
}
var $00be48392311af6a$var$pendingIntersectionUnobserves = [], $00be48392311af6a$var$intersectionUnobserveScheduled = !1;
function $00be48392311af6a$var$schedulePendingIntersectionUnobserve(fragmentInstance, observer, instance) {
    $00be48392311af6a$var$pendingIntersectionUnobserves.push({
        fragmentInstance: fragmentInstance,
        observer: observer,
        instance: instance
    });
    $00be48392311af6a$var$intersectionUnobserveScheduled || ($00be48392311af6a$var$intersectionUnobserveScheduled = !0, $00be48392311af6a$var$requestPostPaintCallback(function() {
        $00be48392311af6a$var$intersectionUnobserveScheduled = !1;
        var pending = $00be48392311af6a$var$pendingIntersectionUnobserves;
        $00be48392311af6a$var$pendingIntersectionUnobserves = [];
        for(var i = 0; i < pending.length; i++){
            var item = pending[i];
            item.observer.unobserve(item.instance);
        }
    }));
}
$00be48392311af6a$var$FragmentInstance.prototype.getClientRects = function() {
    var rects = [];
    $00be48392311af6a$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $00be48392311af6a$var$collectClientRects, rects, void 0, void 0);
    return rects;
};
function $00be48392311af6a$var$collectClientRects(child, rects) {
    if (6 === child.tag) {
        child = child.stateNode;
        var range = child.ownerDocument.createRange();
        range.selectNodeContents(child);
        rects.push.apply(rects, range.getClientRects());
    } else child = $00be48392311af6a$var$getInstanceFromHostFiber(child), rects.push.apply(rects, child.getClientRects());
    return !1;
}
$00be48392311af6a$var$FragmentInstance.prototype.getRootNode = function(getRootNodeOptions) {
    var parentHostFiber = $00be48392311af6a$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    return null === parentHostFiber ? this : $00be48392311af6a$var$getInstanceFromHostFiber(parentHostFiber).getRootNode(getRootNodeOptions);
};
$00be48392311af6a$var$FragmentInstance.prototype.compareDocumentPosition = function(otherNode) {
    var parentHostFiber = $00be48392311af6a$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    if (null === parentHostFiber) return Node.DOCUMENT_POSITION_DISCONNECTED;
    var children = [];
    $00be48392311af6a$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $00be48392311af6a$var$collectChildren, children, void 0, void 0);
    var parentHostInstance = $00be48392311af6a$var$getInstanceFromHostFiber(parentHostFiber);
    if (0 === children.length) {
        children = parentHostInstance;
        if ($00be48392311af6a$var$fiberIsPortaledIntoHost(this._fragmentFiber)) {
            a: {
                for(parentHostFiber = this._fragmentFiber.return; null !== parentHostFiber;){
                    if (4 === parentHostFiber.tag) {
                        parentHostFiber = parentHostFiber.stateNode.containerInfo;
                        break a;
                    }
                    if (3 === parentHostFiber.tag || 5 === parentHostFiber.tag || 27 === parentHostFiber.tag) break;
                    parentHostFiber = parentHostFiber.return;
                }
                parentHostFiber = null;
            }
            null != parentHostFiber && (children = parentHostFiber);
        }
        parentHostFiber = this._fragmentFiber;
        var result = parentHostInstance = children.compareDocumentPosition(otherNode);
        children === otherNode ? result = Node.DOCUMENT_POSITION_CONTAINS : parentHostInstance & Node.DOCUMENT_POSITION_CONTAINED_BY && (children = $00be48392311af6a$var$getFragmentInstanceOrTextInstanceSiblings(parentHostFiber)[1], null === children ? result = Node.DOCUMENT_POSITION_PRECEDING : (otherNode = $00be48392311af6a$var$getInstanceFromHostFiber(children).compareDocumentPosition(otherNode), result = 0 === otherNode || otherNode & Node.DOCUMENT_POSITION_FOLLOWING ? Node.DOCUMENT_POSITION_FOLLOWING : Node.DOCUMENT_POSITION_PRECEDING));
        return result |= Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
    }
    parentHostFiber = $00be48392311af6a$var$getInstanceFromHostFiber(children[0]);
    result = $00be48392311af6a$var$getInstanceFromHostFiber(children[children.length - 1]);
    var parentHostInstanceFromDOM = $00be48392311af6a$var$fiberIsPortaledIntoHost(this._fragmentFiber) ? parentHostFiber.parentElement : parentHostInstance;
    if (null == parentHostInstanceFromDOM) return Node.DOCUMENT_POSITION_DISCONNECTED;
    parentHostInstance = parentHostInstanceFromDOM.compareDocumentPosition(parentHostFiber) & Node.DOCUMENT_POSITION_CONTAINED_BY;
    parentHostInstanceFromDOM = parentHostInstanceFromDOM.compareDocumentPosition(result) & Node.DOCUMENT_POSITION_CONTAINED_BY;
    var firstResult = parentHostFiber.compareDocumentPosition(otherNode), lastResult = result.compareDocumentPosition(otherNode), otherNodeIsWithinFirstOrLastChild = firstResult & Node.DOCUMENT_POSITION_CONTAINED_BY || lastResult & Node.DOCUMENT_POSITION_CONTAINED_BY;
    lastResult = parentHostInstance && parentHostInstanceFromDOM && firstResult & Node.DOCUMENT_POSITION_FOLLOWING && lastResult & Node.DOCUMENT_POSITION_PRECEDING;
    parentHostFiber = parentHostInstance && parentHostFiber === otherNode || parentHostInstanceFromDOM && result === otherNode || otherNodeIsWithinFirstOrLastChild || lastResult ? Node.DOCUMENT_POSITION_CONTAINED_BY : !parentHostInstance && parentHostFiber === otherNode || !parentHostInstanceFromDOM && result === otherNode ? Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC : firstResult;
    return parentHostFiber & Node.DOCUMENT_POSITION_DISCONNECTED || parentHostFiber & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC || $00be48392311af6a$var$validateDocumentPositionWithFiberTree(parentHostFiber, this._fragmentFiber, children[0], children[children.length - 1], otherNode) ? parentHostFiber : Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
};
function $00be48392311af6a$var$validateDocumentPositionWithFiberTree(documentPosition, fragmentFiber, precedingBoundaryFiber, followingBoundaryFiber, otherNode) {
    var otherFiber = $00be48392311af6a$var$getClosestInstanceFromNode(otherNode);
    if (documentPosition & Node.DOCUMENT_POSITION_CONTAINED_BY) {
        if (precedingBoundaryFiber = !!otherFiber) a: {
            for(; null !== otherFiber;){
                if (7 === otherFiber.tag && (otherFiber === fragmentFiber || otherFiber.alternate === fragmentFiber)) {
                    precedingBoundaryFiber = !0;
                    break a;
                }
                otherFiber = otherFiber.return;
            }
            precedingBoundaryFiber = !1;
        }
        return precedingBoundaryFiber;
    }
    if (documentPosition & Node.DOCUMENT_POSITION_CONTAINS) {
        if (null === otherFiber) return otherFiber = otherNode.ownerDocument, otherNode === otherFiber || otherNode === otherFiber.documentElement || otherNode === otherFiber.body;
        a: {
            otherFiber = fragmentFiber;
            for(fragmentFiber = $00be48392311af6a$var$getFragmentParentInstanceOrContainerFiber(fragmentFiber); null !== otherFiber;){
                if (!(5 !== otherFiber.tag && 3 !== otherFiber.tag && 27 !== otherFiber.tag || otherFiber !== fragmentFiber && otherFiber.alternate !== fragmentFiber)) {
                    otherFiber = !0;
                    break a;
                }
                otherFiber = otherFiber.return;
            }
            otherFiber = !1;
        }
        return otherFiber;
    }
    return documentPosition & Node.DOCUMENT_POSITION_PRECEDING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === precedingBoundaryFiber) && (fragmentFiber = $00be48392311af6a$var$getLowestCommonAncestor(precedingBoundaryFiber, otherFiber, $00be48392311af6a$var$getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : ($00be48392311af6a$var$traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, $00be48392311af6a$var$isFiberPrecedingCheck, otherFiber, precedingBoundaryFiber), otherFiber = $00be48392311af6a$var$searchTarget, $00be48392311af6a$var$searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : documentPosition & Node.DOCUMENT_POSITION_FOLLOWING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === followingBoundaryFiber) && (fragmentFiber = $00be48392311af6a$var$getLowestCommonAncestor(followingBoundaryFiber, otherFiber, $00be48392311af6a$var$getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : ($00be48392311af6a$var$traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, $00be48392311af6a$var$isFiberFollowingCheck, otherFiber, followingBoundaryFiber), otherFiber = $00be48392311af6a$var$searchTarget, $00be48392311af6a$var$searchBoundary = $00be48392311af6a$var$searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : !1;
}
function $00be48392311af6a$var$scrollTextNodeIntoView(textNode, resolvedAlignToTop) {
    var range = textNode.ownerDocument.createRange();
    range.selectNodeContents(textNode);
    textNode = range.getBoundingClientRect();
    window.scrollTo(window.scrollX + textNode.left, resolvedAlignToTop ? window.scrollY + textNode.top : window.scrollY + textNode.bottom - window.innerHeight);
}
$00be48392311af6a$var$FragmentInstance.prototype.scrollIntoView = function(alignToTop) {
    if ("object" === typeof alignToTop) throw Error($00be48392311af6a$var$formatProdErrorMessage(566));
    var children = [];
    $00be48392311af6a$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $00be48392311af6a$var$collectChildren, children, void 0, void 0);
    var resolvedAlignToTop = !1 !== alignToTop;
    if (0 === children.length) {
        var hostSiblings = $00be48392311af6a$var$getFragmentInstanceOrTextInstanceSiblings(this._fragmentFiber);
        hostSiblings = resolvedAlignToTop ? hostSiblings[1] || hostSiblings[0] || $00be48392311af6a$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber) : hostSiblings[0] || hostSiblings[1];
        if (null === hostSiblings) return;
        if (6 === hostSiblings.tag) {
            alignToTop = $00be48392311af6a$var$getInstanceFromHostFiber(hostSiblings);
            $00be48392311af6a$var$scrollTextNodeIntoView(alignToTop, resolvedAlignToTop);
            return;
        }
        hostSiblings = $00be48392311af6a$var$getInstanceFromHostFiber(hostSiblings);
        if (9 !== hostSiblings.nodeType) {
            if (11 === hostSiblings.nodeType) {
                resolvedAlignToTop = "host" in hostSiblings ? hostSiblings.host : null;
                null !== resolvedAlignToTop && resolvedAlignToTop.scrollIntoView(alignToTop);
                return;
            }
            hostSiblings.scrollIntoView(alignToTop);
        }
    }
    for(hostSiblings = resolvedAlignToTop ? children.length - 1 : 0; hostSiblings !== (resolvedAlignToTop ? -1 : children.length);){
        var child = children[hostSiblings];
        6 === child.tag ? (child = $00be48392311af6a$var$getInstanceFromHostFiber(child), $00be48392311af6a$var$scrollTextNodeIntoView(child, resolvedAlignToTop)) : $00be48392311af6a$var$getInstanceFromHostFiber(child).scrollIntoView(alignToTop);
        hostSiblings += resolvedAlignToTop ? -1 : 1;
    }
};
function $00be48392311af6a$var$addFragmentHandleToFiber(child, fragmentInstance) {
    child = $00be48392311af6a$var$getInstanceFromHostFiber(child);
    $00be48392311af6a$var$addFragmentHandleToInstance(child, fragmentInstance);
    return !1;
}
function $00be48392311af6a$var$addFragmentHandleToInstance(instance, fragmentInstance) {
    null == instance.reactFragments && (instance.reactFragments = new Set());
    instance.reactFragments.add(fragmentInstance);
}
function $00be48392311af6a$var$commitNewChildToFragmentInstance(childInstance, fragmentInstance) {
    var eventListeners = fragmentInstance._eventListeners;
    if (null !== eventListeners) for(var i$jscomp$0 = 0; i$jscomp$0 < eventListeners.length; i$jscomp$0++){
        var _eventListeners$i3 = eventListeners[i$jscomp$0];
        childInstance.addEventListener(_eventListeners$i3.type, _eventListeners$i3.attachedListener, $00be48392311af6a$var$getAttachOptions(_eventListeners$i3.optionsOrUseCapture));
    }
    3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
        for(var writeIdx = 0, i = 0; i < $00be48392311af6a$var$pendingIntersectionUnobserves.length; i++){
            var pending = $00be48392311af6a$var$pendingIntersectionUnobserves[i];
            if (pending.fragmentInstance !== fragmentInstance || pending.observer !== observer || pending.instance !== childInstance) $00be48392311af6a$var$pendingIntersectionUnobserves[writeIdx++] = pending;
        }
        $00be48392311af6a$var$pendingIntersectionUnobserves.length = writeIdx;
        observer.observe(childInstance);
    }), $00be48392311af6a$var$addFragmentHandleToInstance(childInstance, fragmentInstance));
}
function $00be48392311af6a$var$deleteChildFromFragmentInstance(childInstance, fragmentInstance) {
    var eventListeners = fragmentInstance._eventListeners;
    if (null !== eventListeners) for(var i = 0; i < eventListeners.length; i++){
        var _eventListeners$i4 = eventListeners[i];
        childInstance.removeEventListener(_eventListeners$i4.type, _eventListeners$i4.attachedListener, $00be48392311af6a$var$getAttachOptions(_eventListeners$i4.optionsOrUseCapture));
    }
    3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
        "string" === typeof observer.rootMargin ? $00be48392311af6a$var$schedulePendingIntersectionUnobserve(fragmentInstance, observer, childInstance) : observer.unobserve(childInstance);
    }), null != childInstance.reactFragments && childInstance.reactFragments.delete(fragmentInstance));
}
function $00be48392311af6a$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $00be48392311af6a$var$clearContainerSparingly(node);
                $00be48392311af6a$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $00be48392311af6a$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$00be48392311af6a$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $00be48392311af6a$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $00be48392311af6a$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $00be48392311af6a$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $00be48392311af6a$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $00be48392311af6a$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $00be48392311af6a$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $00be48392311af6a$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $00be48392311af6a$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $00be48392311af6a$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $00be48392311af6a$var$previousHydratableOnEnteringScopedSingleton = null;
function $00be48392311af6a$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $00be48392311af6a$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $00be48392311af6a$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $00be48392311af6a$var$setFocusIfFocusable(node, focusOptions) {
    function handleFocus() {
        didFocus = !0;
    }
    if (node.ownerDocument.activeElement === node) return !0;
    var didFocus = !1;
    try {
        node.ownerDocument.addEventListener("focus", handleFocus, !0), (node.focus || HTMLElement.prototype.focus).call(node, focusOptions);
    } finally{
        node.ownerDocument.removeEventListener("focus", handleFocus, !0);
    }
    return didFocus;
}
function $00be48392311af6a$var$requestPostPaintCallback(callback) {
    $00be48392311af6a$var$localRequestAnimationFrame(function() {
        $00be48392311af6a$var$localRequestAnimationFrame(function(time) {
            return callback(time);
        });
    });
}
function $00be48392311af6a$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $00be48392311af6a$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($00be48392311af6a$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($00be48392311af6a$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($00be48392311af6a$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($00be48392311af6a$var$formatProdErrorMessage(451));
    }
}
function $00be48392311af6a$var$releaseSingletonInstance(instance, type, props) {
    for(var propKey in props){
        var propValue = props[propKey];
        props.hasOwnProperty(propKey) && null != propValue && $00be48392311af6a$var$setProp(instance, type, propKey, null, $00be48392311af6a$var$emptyProps, propValue);
    }
    null != props.dangerouslySetInnerHTML && (instance.textContent = "");
    instance.onclick === $00be48392311af6a$var$noop$1 && (instance.onclick = null);
    $00be48392311af6a$var$detachDeletedInstance(instance);
}
function $00be48392311af6a$var$clearSingletonPreambleContribution(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $00be48392311af6a$var$detachDeletedInstance(instance);
}
var $00be48392311af6a$var$preloadPropsMap = new Map(), $00be48392311af6a$var$preconnectsSet = new Set();
function $00be48392311af6a$var$getHoistableRoot(container) {
    if ("function" === typeof container.getRootNode) {
        var rootNode = container.getRootNode();
        if (9 === rootNode.nodeType || 11 === rootNode.nodeType) return rootNode;
    }
    return 9 === container.nodeType ? container : container.ownerDocument;
}
var $00be48392311af6a$var$previousDispatcher = $00be48392311af6a$var$ReactDOMSharedInternals.d;
$00be48392311af6a$var$ReactDOMSharedInternals.d = {
    f: $00be48392311af6a$var$flushSyncWork,
    r: $00be48392311af6a$var$requestFormReset,
    D: $00be48392311af6a$var$prefetchDNS,
    C: $00be48392311af6a$var$preconnect,
    L: $00be48392311af6a$var$preload,
    m: $00be48392311af6a$var$preloadModule,
    X: $00be48392311af6a$var$preinitScript,
    S: $00be48392311af6a$var$preinitStyle,
    M: $00be48392311af6a$var$preinitModuleScript
};
function $00be48392311af6a$var$flushSyncWork() {
    var previousWasRendering = $00be48392311af6a$var$previousDispatcher.f(), wasRendering = $00be48392311af6a$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $00be48392311af6a$var$requestFormReset(form) {
    var formInst = $00be48392311af6a$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $00be48392311af6a$var$requestFormReset$1(formInst) : $00be48392311af6a$var$previousDispatcher.r(form);
}
var $00be48392311af6a$var$globalDocument = "undefined" === typeof document ? null : document;
function $00be48392311af6a$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $00be48392311af6a$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $00be48392311af6a$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $00be48392311af6a$var$preconnectsSet.has(limitedEscapedHref) || ($00be48392311af6a$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $00be48392311af6a$var$setInitialProperties(href, "link", rel), $00be48392311af6a$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $00be48392311af6a$var$prefetchDNS(href) {
    $00be48392311af6a$var$previousDispatcher.D(href);
    $00be48392311af6a$var$preconnectAs("dns-prefetch", href, null);
}
function $00be48392311af6a$var$preconnect(href, crossOrigin) {
    $00be48392311af6a$var$previousDispatcher.C(href, crossOrigin);
    $00be48392311af6a$var$preconnectAs("preconnect", href, crossOrigin);
}
function $00be48392311af6a$var$preload(href, as, options) {
    $00be48392311af6a$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $00be48392311af6a$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $00be48392311af6a$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $00be48392311af6a$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $00be48392311af6a$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $00be48392311af6a$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $00be48392311af6a$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $00be48392311af6a$var$getStyleKey(href);
                break;
            case "script":
                key = $00be48392311af6a$var$getScriptKey(href);
        }
        if (!($00be48392311af6a$var$preloadPropsMap.has(key) || (href = $00be48392311af6a$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $00be48392311af6a$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($00be48392311af6a$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($00be48392311af6a$var$getScriptSelectorFromKey(key))))) {
            var instance = ownerDocument.createElement("link");
            $00be48392311af6a$var$setInitialProperties(instance, "link", href);
            "style" === as && (instance[$00be48392311af6a$var$internalLoadPendingKey] = !0, instance.onload = instance.onerror = function() {
                $00be48392311af6a$var$clearPendingLoadOnNode(instance);
            });
            $00be48392311af6a$var$markNodeAsHoistable(instance);
            ownerDocument.head.appendChild(instance);
        }
    }
}
function $00be48392311af6a$var$preloadModule(href, options) {
    $00be48392311af6a$var$previousDispatcher.m(href, options);
    var ownerDocument = $00be48392311af6a$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $00be48392311af6a$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $00be48392311af6a$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $00be48392311af6a$var$getScriptKey(href);
        }
        if (!$00be48392311af6a$var$preloadPropsMap.has(key) && (href = $00be48392311af6a$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $00be48392311af6a$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($00be48392311af6a$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $00be48392311af6a$var$setInitialProperties(as, "link", href);
            $00be48392311af6a$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $00be48392311af6a$var$preinitStyle(href, precedence, options) {
    $00be48392311af6a$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $00be48392311af6a$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $00be48392311af6a$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $00be48392311af6a$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($00be48392311af6a$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $00be48392311af6a$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $00be48392311af6a$var$preloadPropsMap.get(key)) && $00be48392311af6a$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $00be48392311af6a$var$markNodeAsHoistable(link);
                $00be48392311af6a$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $00be48392311af6a$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $00be48392311af6a$var$preinitScript(src, options) {
    $00be48392311af6a$var$previousDispatcher.X(src, options);
    var ownerDocument = $00be48392311af6a$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $00be48392311af6a$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $00be48392311af6a$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($00be48392311af6a$var$getScriptSelectorFromKey(key)), resource || (src = $00be48392311af6a$var$assign({
            src: src,
            async: !0
        }, options), (options = $00be48392311af6a$var$preloadPropsMap.get(key)) && $00be48392311af6a$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $00be48392311af6a$var$markNodeAsHoistable(resource), $00be48392311af6a$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $00be48392311af6a$var$preinitModuleScript(src, options) {
    $00be48392311af6a$var$previousDispatcher.M(src, options);
    var ownerDocument = $00be48392311af6a$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $00be48392311af6a$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $00be48392311af6a$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($00be48392311af6a$var$getScriptSelectorFromKey(key)), resource || (src = $00be48392311af6a$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $00be48392311af6a$var$preloadPropsMap.get(key)) && $00be48392311af6a$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $00be48392311af6a$var$markNodeAsHoistable(resource), $00be48392311af6a$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $00be48392311af6a$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $00be48392311af6a$var$rootInstanceStackCursor.current) ? $00be48392311af6a$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($00be48392311af6a$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (pendingProps = $00be48392311af6a$var$getStyleKey(pendingProps.href), currentProps = $00be48392311af6a$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $00be48392311af6a$var$getStyleKey(pendingProps.href);
                var styles$268 = $00be48392311af6a$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$269 = styles$268.get(type);
                resource$269 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$269 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$268.set(type, resource$269), (styles$268 = JSCompiler_inline_result.querySelector($00be48392311af6a$var$getStylesheetSelectorFromKey(type))) ? styles$268._p || (resource$269.instance = styles$268, resource$269.state.loading = 5) : (styles$268 = $00be48392311af6a$var$preloadPropsMap.get(type), styles$268 || (styles$268 = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $00be48392311af6a$var$preloadPropsMap.set(type, styles$268)), $00be48392311af6a$var$preloadStylesheet(JSCompiler_inline_result, type, styles$268, resource$269.state)));
                if (currentProps && null === currentResource) throw Error($00be48392311af6a$var$formatProdErrorMessage(528, ""));
                return resource$269;
            }
            if (currentProps && null !== currentResource) throw Error($00be48392311af6a$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (pendingProps = $00be48392311af6a$var$getScriptKey(pendingProps), currentProps = $00be48392311af6a$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($00be48392311af6a$var$formatProdErrorMessage(444, type));
    }
}
function $00be48392311af6a$var$getStyleKey(href) {
    return 'href="' + $00be48392311af6a$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $00be48392311af6a$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $00be48392311af6a$var$stylesheetPropsFromRawProps(rawProps) {
    return $00be48392311af6a$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $00be48392311af6a$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    if (key = ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]")) {
        if (!0 !== key[$00be48392311af6a$var$internalLoadPendingKey]) {
            state.loading = 1;
            return;
        }
    } else key = ownerDocument.createElement("link"), key[$00be48392311af6a$var$internalLoadPendingKey] = !0, key.onload = key.onerror = $00be48392311af6a$var$clearPendingLoadOnNode.bind(null, key), $00be48392311af6a$var$setInitialProperties(key, "link", preloadProps), $00be48392311af6a$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key);
    state.preload = key;
    key.addEventListener("load", function() {
        return state.loading |= 1;
    });
    key.addEventListener("error", function() {
        return state.loading |= 2;
    });
}
function $00be48392311af6a$var$getScriptKey(src) {
    return '[src="' + $00be48392311af6a$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $00be48392311af6a$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $00be48392311af6a$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $00be48392311af6a$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $00be48392311af6a$var$markNodeAsHoistable(instance), instance;
            var styleProps = $00be48392311af6a$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $00be48392311af6a$var$markNodeAsHoistable(instance);
            $00be48392311af6a$var$setInitialProperties(instance, "style", styleProps);
            $00be48392311af6a$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $00be48392311af6a$var$getStyleKey(props.href);
            var instance$274 = hoistableRoot.querySelector($00be48392311af6a$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$274) return resource.state.loading |= 4, resource.instance = instance$274, $00be48392311af6a$var$markNodeAsHoistable(instance$274), instance$274;
            instance = $00be48392311af6a$var$stylesheetPropsFromRawProps(props);
            (styleProps = $00be48392311af6a$var$preloadPropsMap.get(styleProps)) && $00be48392311af6a$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$274 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $00be48392311af6a$var$markNodeAsHoistable(instance$274);
            var linkInstance = instance$274;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $00be48392311af6a$var$setInitialProperties(instance$274, "link", instance);
            resource.state.loading |= 4;
            $00be48392311af6a$var$insertStylesheet(instance$274, props.precedence, hoistableRoot);
            return resource.instance = instance$274;
        case "script":
            instance$274 = $00be48392311af6a$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($00be48392311af6a$var$getScriptSelectorFromKey(instance$274))) return resource.instance = styleProps, $00be48392311af6a$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $00be48392311af6a$var$preloadPropsMap.get(instance$274)) instance = $00be48392311af6a$var$assign({}, props), $00be48392311af6a$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $00be48392311af6a$var$markNodeAsHoistable(styleProps);
            $00be48392311af6a$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($00be48392311af6a$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $00be48392311af6a$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $00be48392311af6a$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $00be48392311af6a$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $00be48392311af6a$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $00be48392311af6a$var$tagCaches = null;
function $00be48392311af6a$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $00be48392311af6a$var$tagCaches) {
        var cache = new Map();
        var caches = $00be48392311af6a$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $00be48392311af6a$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$00be48392311af6a$var$internalHoistableMarker] || node[$00be48392311af6a$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $00be48392311af6a$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $00be48392311af6a$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $00be48392311af6a$var$maySuspendCommit(type, props) {
    return "img" === type && null != props.src && "" !== props.src && null == props.onLoad && "lazy" !== props.loading;
}
function $00be48392311af6a$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $00be48392311af6a$var$estimateImageBytes(instance) {
    return (instance.width || 100) * (instance.height || 100) * ("number" === typeof devicePixelRatio ? devicePixelRatio : 1) * 0.25;
}
function $00be48392311af6a$var$suspendInstance(state, instance) {
    "function" === typeof instance.decode && (state.imgCount++, instance.complete || (state.imgBytes += $00be48392311af6a$var$estimateImageBytes(instance), state.suspenseyImages.push(instance)), state = $00be48392311af6a$var$onUnsuspendImg.bind(state), instance.decode().then(state, state));
}
function $00be48392311af6a$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $00be48392311af6a$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($00be48392311af6a$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $00be48392311af6a$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $00be48392311af6a$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $00be48392311af6a$var$stylesheetPropsFromRawProps(props);
            (key = $00be48392311af6a$var$preloadPropsMap.get(key)) && $00be48392311af6a$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $00be48392311af6a$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $00be48392311af6a$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $00be48392311af6a$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $00be48392311af6a$var$estimatedBytesWithinLimit = 0;
function $00be48392311af6a$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $00be48392311af6a$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $00be48392311af6a$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $00be48392311af6a$var$estimatedBytesWithinLimit && ($00be48392311af6a$var$estimatedBytesWithinLimit = 62500 * $00be48392311af6a$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $00be48392311af6a$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $00be48392311af6a$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $00be48392311af6a$var$checkIfFullyUnsuspended(state) {
    if (0 === state.count && (0 === state.imgCount || !state.waitingForImages)) {
        if (state.stylesheets) $00be48392311af6a$var$insertSuspendedStylesheets(state, state.stylesheets);
        else if (state.unsuspend) {
            var unsuspend = state.unsuspend;
            state.unsuspend = null;
            unsuspend();
        }
    }
}
function $00be48392311af6a$var$onUnsuspend() {
    this.count--;
    $00be48392311af6a$var$checkIfFullyUnsuspended(this);
}
function $00be48392311af6a$var$onUnsuspendImg() {
    this.imgCount--;
    $00be48392311af6a$var$checkIfFullyUnsuspended(this);
}
var $00be48392311af6a$var$precedencesByRoot = null;
function $00be48392311af6a$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $00be48392311af6a$var$precedencesByRoot = new Map(), resources.forEach($00be48392311af6a$var$insertStylesheetIntoRoot, state), $00be48392311af6a$var$precedencesByRoot = null, $00be48392311af6a$var$onUnsuspend.call(state));
}
function $00be48392311af6a$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $00be48392311af6a$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $00be48392311af6a$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $00be48392311af6a$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $00be48392311af6a$var$HostTransitionContext = {
    $$typeof: $00be48392311af6a$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $00be48392311af6a$var$sharedNotPendingObject,
    _currentValue2: $00be48392311af6a$var$sharedNotPendingObject,
    _threadCount: 0
};
function $00be48392311af6a$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $00be48392311af6a$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $00be48392311af6a$var$createLaneMap(0);
    this.hiddenUpdates = $00be48392311af6a$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.transitionTypes = null;
    this.incompleteTransitions = new Map();
}
function $00be48392311af6a$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $00be48392311af6a$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $00be48392311af6a$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $00be48392311af6a$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $00be48392311af6a$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $00be48392311af6a$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $00be48392311af6a$var$emptyContextObject;
    parentComponent = $00be48392311af6a$var$emptyContextObject;
    return parentComponent;
}
function $00be48392311af6a$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $00be48392311af6a$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $00be48392311af6a$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $00be48392311af6a$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($00be48392311af6a$var$scheduleUpdateOnFiber(element, rootFiber, lane), $00be48392311af6a$var$entangleTransitions(element, rootFiber, lane));
}
function $00be48392311af6a$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $00be48392311af6a$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $00be48392311af6a$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $00be48392311af6a$var$markRetryLaneImpl(fiber, retryLane);
}
function $00be48392311af6a$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $00be48392311af6a$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $00be48392311af6a$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $00be48392311af6a$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $00be48392311af6a$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $00be48392311af6a$var$requestUpdateLane();
        lane = $00be48392311af6a$var$getBumpedLaneForHydrationByLane(lane);
        var root = $00be48392311af6a$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $00be48392311af6a$var$scheduleUpdateOnFiber(root, fiber, lane);
        $00be48392311af6a$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $00be48392311af6a$var$_enabled = !0;
function $00be48392311af6a$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $00be48392311af6a$var$ReactSharedInternals.T;
    $00be48392311af6a$var$ReactSharedInternals.T = null;
    var previousPriority = $00be48392311af6a$var$ReactDOMSharedInternals.p;
    try {
        $00be48392311af6a$var$ReactDOMSharedInternals.p = 2, $00be48392311af6a$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $00be48392311af6a$var$ReactDOMSharedInternals.p = previousPriority, $00be48392311af6a$var$ReactSharedInternals.T = prevTransition;
    }
}
function $00be48392311af6a$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $00be48392311af6a$var$ReactSharedInternals.T;
    $00be48392311af6a$var$ReactSharedInternals.T = null;
    var previousPriority = $00be48392311af6a$var$ReactDOMSharedInternals.p;
    try {
        $00be48392311af6a$var$ReactDOMSharedInternals.p = 8, $00be48392311af6a$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $00be48392311af6a$var$ReactDOMSharedInternals.p = previousPriority, $00be48392311af6a$var$ReactSharedInternals.T = prevTransition;
    }
}
function $00be48392311af6a$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($00be48392311af6a$var$_enabled) {
        var blockedOn = $00be48392311af6a$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $00be48392311af6a$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $00be48392311af6a$var$return_targetInst, targetContainer), $00be48392311af6a$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($00be48392311af6a$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($00be48392311af6a$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $00be48392311af6a$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $00be48392311af6a$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $00be48392311af6a$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $00be48392311af6a$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $00be48392311af6a$var$ensureRootIsScheduled(fiber);
                                0 === ($00be48392311af6a$var$executionContext & 6) && ($00be48392311af6a$var$workInProgressRootRenderTargetTime = $00be48392311af6a$var$now() + 500, $00be48392311af6a$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $00be48392311af6a$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $00be48392311af6a$var$scheduleUpdateOnFiber(root, fiber, 2), $00be48392311af6a$var$flushSyncWork$1(), $00be48392311af6a$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $00be48392311af6a$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $00be48392311af6a$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $00be48392311af6a$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $00be48392311af6a$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $00be48392311af6a$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $00be48392311af6a$var$getEventTarget(nativeEvent);
    return $00be48392311af6a$var$findInstanceBlockingTarget(nativeEvent);
}
var $00be48392311af6a$var$return_targetInst = null;
function $00be48392311af6a$var$findInstanceBlockingTarget(targetNode) {
    $00be48392311af6a$var$return_targetInst = null;
    targetNode = $00be48392311af6a$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $00be48392311af6a$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $00be48392311af6a$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $00be48392311af6a$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $00be48392311af6a$var$return_targetInst = targetNode;
    return null;
}
function $00be48392311af6a$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "fullscreenerror":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "resize":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($00be48392311af6a$var$getCurrentPriorityLevel()){
                case $00be48392311af6a$var$ImmediatePriority:
                    return 2;
                case $00be48392311af6a$var$UserBlockingPriority:
                    return 8;
                case $00be48392311af6a$var$NormalPriority$1:
                case $00be48392311af6a$var$LowPriority:
                    return 32;
                case $00be48392311af6a$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $00be48392311af6a$var$hasScheduledReplayAttempt = !1, $00be48392311af6a$var$queuedFocus = null, $00be48392311af6a$var$queuedDrag = null, $00be48392311af6a$var$queuedMouse = null, $00be48392311af6a$var$queuedPointers = new Map(), $00be48392311af6a$var$queuedPointerCaptures = new Map(), $00be48392311af6a$var$queuedExplicitHydrationTargets = [], $00be48392311af6a$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $00be48392311af6a$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $00be48392311af6a$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $00be48392311af6a$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $00be48392311af6a$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $00be48392311af6a$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $00be48392311af6a$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $00be48392311af6a$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $00be48392311af6a$var$getInstanceFromNode(blockedOn), null !== blockedOn && $00be48392311af6a$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $00be48392311af6a$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $00be48392311af6a$var$queuedFocus = $00be48392311af6a$var$accumulateOrCreateContinuousQueuedReplayableEvent($00be48392311af6a$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $00be48392311af6a$var$queuedDrag = $00be48392311af6a$var$accumulateOrCreateContinuousQueuedReplayableEvent($00be48392311af6a$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $00be48392311af6a$var$queuedMouse = $00be48392311af6a$var$accumulateOrCreateContinuousQueuedReplayableEvent($00be48392311af6a$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $00be48392311af6a$var$queuedPointers.set(pointerId, $00be48392311af6a$var$accumulateOrCreateContinuousQueuedReplayableEvent($00be48392311af6a$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $00be48392311af6a$var$queuedPointerCaptures.set(pointerId, $00be48392311af6a$var$accumulateOrCreateContinuousQueuedReplayableEvent($00be48392311af6a$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $00be48392311af6a$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $00be48392311af6a$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $00be48392311af6a$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $00be48392311af6a$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $00be48392311af6a$var$runWithPriority(queuedTarget.priority, function() {
                        $00be48392311af6a$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $00be48392311af6a$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $00be48392311af6a$var$runWithPriority(queuedTarget.priority, function() {
                        $00be48392311af6a$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $00be48392311af6a$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $00be48392311af6a$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $00be48392311af6a$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $00be48392311af6a$var$currentReplayingEvent = null;
        } else return targetContainers = $00be48392311af6a$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $00be48392311af6a$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $00be48392311af6a$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $00be48392311af6a$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $00be48392311af6a$var$replayUnblockedEvents() {
    $00be48392311af6a$var$hasScheduledReplayAttempt = !1;
    null !== $00be48392311af6a$var$queuedFocus && $00be48392311af6a$var$attemptReplayContinuousQueuedEvent($00be48392311af6a$var$queuedFocus) && ($00be48392311af6a$var$queuedFocus = null);
    null !== $00be48392311af6a$var$queuedDrag && $00be48392311af6a$var$attemptReplayContinuousQueuedEvent($00be48392311af6a$var$queuedDrag) && ($00be48392311af6a$var$queuedDrag = null);
    null !== $00be48392311af6a$var$queuedMouse && $00be48392311af6a$var$attemptReplayContinuousQueuedEvent($00be48392311af6a$var$queuedMouse) && ($00be48392311af6a$var$queuedMouse = null);
    $00be48392311af6a$var$queuedPointers.forEach($00be48392311af6a$var$attemptReplayContinuousQueuedEventInMap);
    $00be48392311af6a$var$queuedPointerCaptures.forEach($00be48392311af6a$var$attemptReplayContinuousQueuedEventInMap);
}
function $00be48392311af6a$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $00be48392311af6a$var$hasScheduledReplayAttempt || ($00be48392311af6a$var$hasScheduledReplayAttempt = !0, $6XCI2.unstable_scheduleCallback($6XCI2.unstable_NormalPriority, $00be48392311af6a$var$replayUnblockedEvents)));
}
var $00be48392311af6a$var$lastScheduledReplayQueue = null;
function $00be48392311af6a$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $00be48392311af6a$var$lastScheduledReplayQueue !== formReplayingQueue && ($00be48392311af6a$var$lastScheduledReplayQueue = formReplayingQueue, $6XCI2.unstable_scheduleCallback($6XCI2.unstable_NormalPriority, function() {
        $00be48392311af6a$var$lastScheduledReplayQueue === formReplayingQueue && ($00be48392311af6a$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $00be48392311af6a$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $00be48392311af6a$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $00be48392311af6a$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $00be48392311af6a$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $00be48392311af6a$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $00be48392311af6a$var$queuedFocus && $00be48392311af6a$var$scheduleCallbackIfUnblocked($00be48392311af6a$var$queuedFocus, unblocked);
    null !== $00be48392311af6a$var$queuedDrag && $00be48392311af6a$var$scheduleCallbackIfUnblocked($00be48392311af6a$var$queuedDrag, unblocked);
    null !== $00be48392311af6a$var$queuedMouse && $00be48392311af6a$var$scheduleCallbackIfUnblocked($00be48392311af6a$var$queuedMouse, unblocked);
    $00be48392311af6a$var$queuedPointers.forEach(unblock);
    $00be48392311af6a$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $00be48392311af6a$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $00be48392311af6a$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $00be48392311af6a$var$queuedExplicitHydrationTargets.length && (i = $00be48392311af6a$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$00be48392311af6a$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $00be48392311af6a$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$00be48392311af6a$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $00be48392311af6a$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$00be48392311af6a$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $00be48392311af6a$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $00be48392311af6a$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $00be48392311af6a$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $00be48392311af6a$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$00be48392311af6a$var$ReactDOMHydrationRoot.prototype.render = $00be48392311af6a$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($00be48392311af6a$var$formatProdErrorMessage(409));
    var current = root.current, lane = $00be48392311af6a$var$requestUpdateLane();
    $00be48392311af6a$var$updateContainerImpl(current, lane, children, root, null, null);
};
$00be48392311af6a$var$ReactDOMHydrationRoot.prototype.unmount = $00be48392311af6a$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $00be48392311af6a$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $00be48392311af6a$var$flushSyncWork$1();
        container[$00be48392311af6a$var$internalContainerInstanceKey] = null;
    }
};
function $00be48392311af6a$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$00be48392311af6a$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $00be48392311af6a$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $00be48392311af6a$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $00be48392311af6a$var$queuedExplicitHydrationTargets[i].priority; i++);
        $00be48392311af6a$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $00be48392311af6a$var$attemptExplicitHydrationTarget(target);
    }
};
var $00be48392311af6a$var$isomorphicReactPackageVersion$jscomp$inline_2043 = $5E6i4.version;
if ("19.3.1" !== $00be48392311af6a$var$isomorphicReactPackageVersion$jscomp$inline_2043) throw Error($00be48392311af6a$var$formatProdErrorMessage(527, $00be48392311af6a$var$isomorphicReactPackageVersion$jscomp$inline_2043, "19.3.1"));
$00be48392311af6a$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($00be48392311af6a$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($00be48392311af6a$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $00be48392311af6a$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $00be48392311af6a$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $00be48392311af6a$var$internals$jscomp$inline_2586 = {
    bundleType: 0,
    version: "19.3.1",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $00be48392311af6a$var$ReactSharedInternals,
    reconcilerVersion: "19.3.1"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $00be48392311af6a$var$hook$jscomp$inline_2587 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$00be48392311af6a$var$hook$jscomp$inline_2587.isDisabled && $00be48392311af6a$var$hook$jscomp$inline_2587.supportsFiber) try {
        $00be48392311af6a$var$rendererID = $00be48392311af6a$var$hook$jscomp$inline_2587.inject($00be48392311af6a$var$internals$jscomp$inline_2586), $00be48392311af6a$var$injectedHook = $00be48392311af6a$var$hook$jscomp$inline_2587;
    } catch (err) {}
}
$00be48392311af6a$export$882461b6382ed46c = function(container, options) {
    if (!$00be48392311af6a$var$isValidContainer(container)) throw Error($00be48392311af6a$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $00be48392311af6a$var$defaultOnUncaughtError, onCaughtError = $00be48392311af6a$var$defaultOnCaughtError, onRecoverableError = $00be48392311af6a$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $00be48392311af6a$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $00be48392311af6a$var$defaultOnDefaultTransitionIndicator);
    container[$00be48392311af6a$var$internalContainerInstanceKey] = options.current;
    $00be48392311af6a$var$listenToAllSupportedEvents(container);
    return new $00be48392311af6a$var$ReactDOMRoot(options);
};
$00be48392311af6a$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$00be48392311af6a$var$isValidContainer(container)) throw Error($00be48392311af6a$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $00be48392311af6a$var$defaultOnUncaughtError, onCaughtError = $00be48392311af6a$var$defaultOnCaughtError, onRecoverableError = $00be48392311af6a$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $00be48392311af6a$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $00be48392311af6a$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $00be48392311af6a$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $00be48392311af6a$var$requestUpdateLane();
    isStrictMode = $00be48392311af6a$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $00be48392311af6a$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $00be48392311af6a$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $00be48392311af6a$var$markRootUpdated$1(initialChildren, options);
    $00be48392311af6a$var$ensureRootIsScheduled(initialChildren);
    container[$00be48392311af6a$var$internalContainerInstanceKey] = initialChildren.current;
    $00be48392311af6a$var$listenToAllSupportedEvents(container);
    return new $00be48392311af6a$var$ReactDOMHydrationRoot(initialChildren);
};
$00be48392311af6a$export$83d89fbfd8236492 = "19.3.1";

});
parcelRegister("6XCI2", function(module, exports) {
'use strict';

module.exports = (parcelRequire("4Y10g"));

});
parcelRegister("4Y10g", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $39dd8b439010a789$export$c4744153514ff05d, (v) => $39dd8b439010a789$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $39dd8b439010a789$export$3e506c1ccc9cc1a7, (v) => $39dd8b439010a789$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $39dd8b439010a789$export$e26fe2ed2fa76875, (v) => $39dd8b439010a789$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $39dd8b439010a789$export$502329bbf4b505b1, (v) => $39dd8b439010a789$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $39dd8b439010a789$export$6e3807111c4874c4, (v) => $39dd8b439010a789$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $39dd8b439010a789$export$c27134553091fb3a, (v) => $39dd8b439010a789$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $39dd8b439010a789$export$33ee1acdc04fd2a2, (v) => $39dd8b439010a789$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $39dd8b439010a789$export$b00a404bbd5edef2, (v) => $39dd8b439010a789$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $39dd8b439010a789$export$d66a1c1c77bd778b, (v) => $39dd8b439010a789$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $39dd8b439010a789$export$d3dfb8e4810cb555, (v) => $39dd8b439010a789$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $39dd8b439010a789$export$72fdf0e06517287b, (v) => $39dd8b439010a789$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $39dd8b439010a789$export$816d2913ae6b83b1, (v) => $39dd8b439010a789$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $39dd8b439010a789$export$61bcfe829111a1d0, (v) => $39dd8b439010a789$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $39dd8b439010a789$export$7ee8c9beb337bc3f, (v) => $39dd8b439010a789$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $39dd8b439010a789$export$b5836b71941fa3ed, (v) => $39dd8b439010a789$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $39dd8b439010a789$export$cf845f2c119da08a, (v) => $39dd8b439010a789$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $39dd8b439010a789$export$c4744153514ff05d;
var $39dd8b439010a789$export$3e506c1ccc9cc1a7;
var $39dd8b439010a789$export$e26fe2ed2fa76875;
var $39dd8b439010a789$export$502329bbf4b505b1;
var $39dd8b439010a789$export$6e3807111c4874c4;
var $39dd8b439010a789$export$c27134553091fb3a;
var $39dd8b439010a789$export$33ee1acdc04fd2a2;
var $39dd8b439010a789$export$b00a404bbd5edef2;
var $39dd8b439010a789$export$d66a1c1c77bd778b;
var $39dd8b439010a789$export$d3dfb8e4810cb555;
var $39dd8b439010a789$export$72fdf0e06517287b;
var $39dd8b439010a789$export$816d2913ae6b83b1;
var $39dd8b439010a789$export$61bcfe829111a1d0;
var $39dd8b439010a789$export$7ee8c9beb337bc3f;
var $39dd8b439010a789$export$b5836b71941fa3ed;
var $39dd8b439010a789$export$cf845f2c119da08a;
"use strict";
function $39dd8b439010a789$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $39dd8b439010a789$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $39dd8b439010a789$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $39dd8b439010a789$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $39dd8b439010a789$var$compare(left, last)) rightIndex < length && 0 > $39dd8b439010a789$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $39dd8b439010a789$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $39dd8b439010a789$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$39dd8b439010a789$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $39dd8b439010a789$var$localPerformance = performance;
    $39dd8b439010a789$export$c4744153514ff05d = function() {
        return $39dd8b439010a789$var$localPerformance.now();
    };
} else {
    var $39dd8b439010a789$var$localDate = Date, $39dd8b439010a789$var$initialTime = $39dd8b439010a789$var$localDate.now();
    $39dd8b439010a789$export$c4744153514ff05d = function() {
        return $39dd8b439010a789$var$localDate.now() - $39dd8b439010a789$var$initialTime;
    };
}
var $39dd8b439010a789$var$taskQueue = [], $39dd8b439010a789$var$timerQueue = [], $39dd8b439010a789$var$taskIdCounter = 1, $39dd8b439010a789$var$currentTask = null, $39dd8b439010a789$var$currentPriorityLevel = 3, $39dd8b439010a789$var$isPerformingWork = !1, $39dd8b439010a789$var$isHostCallbackScheduled = !1, $39dd8b439010a789$var$isHostTimeoutScheduled = !1, $39dd8b439010a789$var$needsPaint = !1, $39dd8b439010a789$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $39dd8b439010a789$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $39dd8b439010a789$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $39dd8b439010a789$var$advanceTimers(currentTime) {
    for(var timer = $39dd8b439010a789$var$peek($39dd8b439010a789$var$timerQueue); null !== timer;){
        if (null === timer.callback) $39dd8b439010a789$var$pop($39dd8b439010a789$var$timerQueue);
        else if (timer.startTime <= currentTime) $39dd8b439010a789$var$pop($39dd8b439010a789$var$timerQueue), timer.sortIndex = timer.expirationTime, $39dd8b439010a789$var$push($39dd8b439010a789$var$taskQueue, timer);
        else break;
        timer = $39dd8b439010a789$var$peek($39dd8b439010a789$var$timerQueue);
    }
}
function $39dd8b439010a789$var$handleTimeout(currentTime) {
    $39dd8b439010a789$var$isHostTimeoutScheduled = !1;
    $39dd8b439010a789$var$advanceTimers(currentTime);
    if (!$39dd8b439010a789$var$isHostCallbackScheduled) {
        if (null !== $39dd8b439010a789$var$peek($39dd8b439010a789$var$taskQueue)) $39dd8b439010a789$var$isHostCallbackScheduled = !0, $39dd8b439010a789$var$isMessageLoopRunning || ($39dd8b439010a789$var$isMessageLoopRunning = !0, $39dd8b439010a789$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $39dd8b439010a789$var$peek($39dd8b439010a789$var$timerQueue);
            null !== firstTimer && $39dd8b439010a789$var$requestHostTimeout($39dd8b439010a789$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $39dd8b439010a789$var$isMessageLoopRunning = !1, $39dd8b439010a789$var$taskTimeoutID = -1, $39dd8b439010a789$var$frameInterval = 5, $39dd8b439010a789$var$startTime = -1;
function $39dd8b439010a789$var$shouldYieldToHost() {
    return $39dd8b439010a789$var$needsPaint ? !0 : $39dd8b439010a789$export$c4744153514ff05d() - $39dd8b439010a789$var$startTime < $39dd8b439010a789$var$frameInterval ? !1 : !0;
}
function $39dd8b439010a789$var$performWorkUntilDeadline() {
    $39dd8b439010a789$var$needsPaint = !1;
    if ($39dd8b439010a789$var$isMessageLoopRunning) {
        var currentTime = $39dd8b439010a789$export$c4744153514ff05d();
        $39dd8b439010a789$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $39dd8b439010a789$var$isHostCallbackScheduled = !1;
                $39dd8b439010a789$var$isHostTimeoutScheduled && ($39dd8b439010a789$var$isHostTimeoutScheduled = !1, $39dd8b439010a789$var$localClearTimeout($39dd8b439010a789$var$taskTimeoutID), $39dd8b439010a789$var$taskTimeoutID = -1);
                $39dd8b439010a789$var$isPerformingWork = !0;
                var previousPriorityLevel = $39dd8b439010a789$var$currentPriorityLevel;
                try {
                    b: {
                        $39dd8b439010a789$var$advanceTimers(currentTime);
                        for($39dd8b439010a789$var$currentTask = $39dd8b439010a789$var$peek($39dd8b439010a789$var$taskQueue); null !== $39dd8b439010a789$var$currentTask && !($39dd8b439010a789$var$currentTask.expirationTime > currentTime && $39dd8b439010a789$var$shouldYieldToHost());){
                            var callback = $39dd8b439010a789$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $39dd8b439010a789$var$currentTask.callback = null;
                                $39dd8b439010a789$var$currentPriorityLevel = $39dd8b439010a789$var$currentTask.priorityLevel;
                                var continuationCallback = callback($39dd8b439010a789$var$currentTask.expirationTime <= currentTime);
                                currentTime = $39dd8b439010a789$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $39dd8b439010a789$var$currentTask.callback = continuationCallback;
                                    $39dd8b439010a789$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $39dd8b439010a789$var$currentTask === $39dd8b439010a789$var$peek($39dd8b439010a789$var$taskQueue) && $39dd8b439010a789$var$pop($39dd8b439010a789$var$taskQueue);
                                $39dd8b439010a789$var$advanceTimers(currentTime);
                            } else $39dd8b439010a789$var$pop($39dd8b439010a789$var$taskQueue);
                            $39dd8b439010a789$var$currentTask = $39dd8b439010a789$var$peek($39dd8b439010a789$var$taskQueue);
                        }
                        if (null !== $39dd8b439010a789$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $39dd8b439010a789$var$peek($39dd8b439010a789$var$timerQueue);
                            null !== firstTimer && $39dd8b439010a789$var$requestHostTimeout($39dd8b439010a789$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $39dd8b439010a789$var$currentTask = null, $39dd8b439010a789$var$currentPriorityLevel = previousPriorityLevel, $39dd8b439010a789$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $39dd8b439010a789$var$schedulePerformWorkUntilDeadline() : $39dd8b439010a789$var$isMessageLoopRunning = !1;
        }
    }
}
var $39dd8b439010a789$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $39dd8b439010a789$var$localSetImmediate) $39dd8b439010a789$var$schedulePerformWorkUntilDeadline = function() {
    $39dd8b439010a789$var$localSetImmediate($39dd8b439010a789$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $39dd8b439010a789$var$channel = new MessageChannel(), $39dd8b439010a789$var$port = $39dd8b439010a789$var$channel.port2;
    $39dd8b439010a789$var$channel.port1.onmessage = $39dd8b439010a789$var$performWorkUntilDeadline;
    $39dd8b439010a789$var$schedulePerformWorkUntilDeadline = function() {
        $39dd8b439010a789$var$port.postMessage(null);
    };
} else $39dd8b439010a789$var$schedulePerformWorkUntilDeadline = function() {
    $39dd8b439010a789$var$localSetTimeout($39dd8b439010a789$var$performWorkUntilDeadline, 0);
};
function $39dd8b439010a789$var$requestHostTimeout(callback, ms) {
    $39dd8b439010a789$var$taskTimeoutID = $39dd8b439010a789$var$localSetTimeout(function() {
        callback($39dd8b439010a789$export$c4744153514ff05d());
    }, ms);
}
$39dd8b439010a789$export$3e506c1ccc9cc1a7 = 5;
$39dd8b439010a789$export$e26fe2ed2fa76875 = 1;
$39dd8b439010a789$export$502329bbf4b505b1 = 4;
$39dd8b439010a789$export$6e3807111c4874c4 = 3;
$39dd8b439010a789$export$c27134553091fb3a = null;
$39dd8b439010a789$export$33ee1acdc04fd2a2 = 2;
$39dd8b439010a789$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$39dd8b439010a789$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $39dd8b439010a789$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$39dd8b439010a789$export$d3dfb8e4810cb555 = function() {
    return $39dd8b439010a789$var$currentPriorityLevel;
};
$39dd8b439010a789$export$72fdf0e06517287b = function(eventHandler) {
    switch($39dd8b439010a789$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $39dd8b439010a789$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $39dd8b439010a789$var$currentPriorityLevel;
    $39dd8b439010a789$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $39dd8b439010a789$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$39dd8b439010a789$export$816d2913ae6b83b1 = function() {
    $39dd8b439010a789$var$needsPaint = !0;
};
$39dd8b439010a789$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $39dd8b439010a789$var$currentPriorityLevel;
    $39dd8b439010a789$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $39dd8b439010a789$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$39dd8b439010a789$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $39dd8b439010a789$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $39dd8b439010a789$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $39dd8b439010a789$var$push($39dd8b439010a789$var$timerQueue, priorityLevel), null === $39dd8b439010a789$var$peek($39dd8b439010a789$var$taskQueue) && priorityLevel === $39dd8b439010a789$var$peek($39dd8b439010a789$var$timerQueue) && ($39dd8b439010a789$var$isHostTimeoutScheduled ? ($39dd8b439010a789$var$localClearTimeout($39dd8b439010a789$var$taskTimeoutID), $39dd8b439010a789$var$taskTimeoutID = -1) : $39dd8b439010a789$var$isHostTimeoutScheduled = !0, $39dd8b439010a789$var$requestHostTimeout($39dd8b439010a789$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $39dd8b439010a789$var$push($39dd8b439010a789$var$taskQueue, priorityLevel), $39dd8b439010a789$var$isHostCallbackScheduled || $39dd8b439010a789$var$isPerformingWork || ($39dd8b439010a789$var$isHostCallbackScheduled = !0, $39dd8b439010a789$var$isMessageLoopRunning || ($39dd8b439010a789$var$isMessageLoopRunning = !0, $39dd8b439010a789$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$39dd8b439010a789$export$b5836b71941fa3ed = $39dd8b439010a789$var$shouldYieldToHost;
$39dd8b439010a789$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $39dd8b439010a789$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $39dd8b439010a789$var$currentPriorityLevel;
        $39dd8b439010a789$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $39dd8b439010a789$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("5E6i4", function(module, exports) {
'use strict';

module.exports = (parcelRequire("dhyFm"));

});
parcelRegister("dhyFm", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $9ab7c0d6abf66295$export$9c16c1426311996d, (v) => $9ab7c0d6abf66295$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $9ab7c0d6abf66295$export$dca3b0875bd9a954, (v) => $9ab7c0d6abf66295$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $9ab7c0d6abf66295$export$16fa2f45be04daa8, (v) => $9ab7c0d6abf66295$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $9ab7c0d6abf66295$export$ffb0004e005737fa, (v) => $9ab7c0d6abf66295$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $9ab7c0d6abf66295$export$e2c29f18771995cb, (v) => $9ab7c0d6abf66295$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $9ab7c0d6abf66295$export$221d75b3f55bb0bd, (v) => $9ab7c0d6abf66295$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $9ab7c0d6abf66295$export$5f8d39834fd61797, (v) => $9ab7c0d6abf66295$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $9ab7c0d6abf66295$export$74bf444e3cd11ea5, (v) => $9ab7c0d6abf66295$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "ViewTransition", () => $9ab7c0d6abf66295$export$8cdaa4703948c5e9, (v) => $9ab7c0d6abf66295$export$8cdaa4703948c5e9 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $9ab7c0d6abf66295$export$1ced07cd6b1985ce, (v) => $9ab7c0d6abf66295$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $9ab7c0d6abf66295$export$abd8e32b826d7ea7, (v) => $9ab7c0d6abf66295$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "addTransitionType", () => $9ab7c0d6abf66295$export$87c99536b1b8cdd8, (v) => $9ab7c0d6abf66295$export$87c99536b1b8cdd8 = v);
$parcel$export(module.exports, "cache", () => $9ab7c0d6abf66295$export$69a3209f1a06c04d, (v) => $9ab7c0d6abf66295$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $9ab7c0d6abf66295$export$8c538325882c7eec, (v) => $9ab7c0d6abf66295$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $9ab7c0d6abf66295$export$e530037191fcd5d7, (v) => $9ab7c0d6abf66295$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $9ab7c0d6abf66295$export$fd42f52fd3ae1109, (v) => $9ab7c0d6abf66295$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $9ab7c0d6abf66295$export$c8a8987d4410bf2d, (v) => $9ab7c0d6abf66295$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $9ab7c0d6abf66295$export$7d1e3a5e95ceca43, (v) => $9ab7c0d6abf66295$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $9ab7c0d6abf66295$export$257a8862b851cb5b, (v) => $9ab7c0d6abf66295$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $9ab7c0d6abf66295$export$a8257692ac88316c, (v) => $9ab7c0d6abf66295$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $9ab7c0d6abf66295$export$488013bae63b21da, (v) => $9ab7c0d6abf66295$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $9ab7c0d6abf66295$export$7c73462e0d25e514, (v) => $9ab7c0d6abf66295$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $9ab7c0d6abf66295$export$7568632d0d33d16d, (v) => $9ab7c0d6abf66295$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $9ab7c0d6abf66295$export$f93f40ac0ca7e3a8, (v) => $9ab7c0d6abf66295$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $9ab7c0d6abf66295$export$1f96ae73734a86cc, (v) => $9ab7c0d6abf66295$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $9ab7c0d6abf66295$export$9a47ced3238df325, (v) => $9ab7c0d6abf66295$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $9ab7c0d6abf66295$export$35808ee640e87ca7, (v) => $9ab7c0d6abf66295$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $9ab7c0d6abf66295$export$fae74005e78b1a27, (v) => $9ab7c0d6abf66295$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $9ab7c0d6abf66295$export$dc8fbce3eb94dc1e, (v) => $9ab7c0d6abf66295$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $9ab7c0d6abf66295$export$6a7bc4e911dc01cf, (v) => $9ab7c0d6abf66295$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $9ab7c0d6abf66295$export$6d9c69b0de29b591, (v) => $9ab7c0d6abf66295$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $9ab7c0d6abf66295$export$7f54fc3180508a52, (v) => $9ab7c0d6abf66295$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $9ab7c0d6abf66295$export$f680877a34711e37, (v) => $9ab7c0d6abf66295$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $9ab7c0d6abf66295$export$d5a552a76deda3c2, (v) => $9ab7c0d6abf66295$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $9ab7c0d6abf66295$export$aaabe4eda9ed9969, (v) => $9ab7c0d6abf66295$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $9ab7c0d6abf66295$export$e5c5a5f917a5871c, (v) => $9ab7c0d6abf66295$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $9ab7c0d6abf66295$export$1538c33de8887b59, (v) => $9ab7c0d6abf66295$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $9ab7c0d6abf66295$export$fca7f784ae7a249a, (v) => $9ab7c0d6abf66295$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $9ab7c0d6abf66295$export$13e3392192263954, (v) => $9ab7c0d6abf66295$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $9ab7c0d6abf66295$export$b8f5890fc79d6aca, (v) => $9ab7c0d6abf66295$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $9ab7c0d6abf66295$export$60241385465d0a34, (v) => $9ab7c0d6abf66295$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $9ab7c0d6abf66295$export$306c0aa65ff9ec16, (v) => $9ab7c0d6abf66295$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $9ab7c0d6abf66295$export$7b286972b8d8ccbf, (v) => $9ab7c0d6abf66295$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $9ab7c0d6abf66295$export$83d89fbfd8236492, (v) => $9ab7c0d6abf66295$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9ab7c0d6abf66295$export$9c16c1426311996d;
var $9ab7c0d6abf66295$export$dca3b0875bd9a954;
var $9ab7c0d6abf66295$export$16fa2f45be04daa8;
var $9ab7c0d6abf66295$export$ffb0004e005737fa;
var $9ab7c0d6abf66295$export$e2c29f18771995cb;
var $9ab7c0d6abf66295$export$221d75b3f55bb0bd;
var $9ab7c0d6abf66295$export$5f8d39834fd61797;
var $9ab7c0d6abf66295$export$74bf444e3cd11ea5;
var $9ab7c0d6abf66295$export$8cdaa4703948c5e9;
var $9ab7c0d6abf66295$export$1ced07cd6b1985ce;
var $9ab7c0d6abf66295$export$abd8e32b826d7ea7;
var $9ab7c0d6abf66295$export$87c99536b1b8cdd8;
var $9ab7c0d6abf66295$export$69a3209f1a06c04d;
var $9ab7c0d6abf66295$export$8c538325882c7eec;
var $9ab7c0d6abf66295$export$e530037191fcd5d7;
var $9ab7c0d6abf66295$export$fd42f52fd3ae1109;
var $9ab7c0d6abf66295$export$c8a8987d4410bf2d;
var $9ab7c0d6abf66295$export$7d1e3a5e95ceca43;
var $9ab7c0d6abf66295$export$257a8862b851cb5b;
var $9ab7c0d6abf66295$export$a8257692ac88316c;
var $9ab7c0d6abf66295$export$488013bae63b21da;
var $9ab7c0d6abf66295$export$7c73462e0d25e514;
var $9ab7c0d6abf66295$export$7568632d0d33d16d;
var $9ab7c0d6abf66295$export$f93f40ac0ca7e3a8;
var $9ab7c0d6abf66295$export$1f96ae73734a86cc;
var $9ab7c0d6abf66295$export$9a47ced3238df325;
var $9ab7c0d6abf66295$export$35808ee640e87ca7;
var $9ab7c0d6abf66295$export$fae74005e78b1a27;
var $9ab7c0d6abf66295$export$dc8fbce3eb94dc1e;
var $9ab7c0d6abf66295$export$6a7bc4e911dc01cf;
var $9ab7c0d6abf66295$export$6d9c69b0de29b591;
var $9ab7c0d6abf66295$export$7f54fc3180508a52;
var $9ab7c0d6abf66295$export$f680877a34711e37;
var $9ab7c0d6abf66295$export$d5a552a76deda3c2;
var $9ab7c0d6abf66295$export$aaabe4eda9ed9969;
var $9ab7c0d6abf66295$export$e5c5a5f917a5871c;
var $9ab7c0d6abf66295$export$1538c33de8887b59;
var $9ab7c0d6abf66295$export$fca7f784ae7a249a;
var $9ab7c0d6abf66295$export$13e3392192263954;
var $9ab7c0d6abf66295$export$b8f5890fc79d6aca;
var $9ab7c0d6abf66295$export$60241385465d0a34;
var $9ab7c0d6abf66295$export$306c0aa65ff9ec16;
var $9ab7c0d6abf66295$export$7b286972b8d8ccbf;
var $9ab7c0d6abf66295$export$83d89fbfd8236492;
"use strict";
var $9ab7c0d6abf66295$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $9ab7c0d6abf66295$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $9ab7c0d6abf66295$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $9ab7c0d6abf66295$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $9ab7c0d6abf66295$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $9ab7c0d6abf66295$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $9ab7c0d6abf66295$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $9ab7c0d6abf66295$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $9ab7c0d6abf66295$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $9ab7c0d6abf66295$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $9ab7c0d6abf66295$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $9ab7c0d6abf66295$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $9ab7c0d6abf66295$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $9ab7c0d6abf66295$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $9ab7c0d6abf66295$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $9ab7c0d6abf66295$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$9ab7c0d6abf66295$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $9ab7c0d6abf66295$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $9ab7c0d6abf66295$var$assign = Object.assign, $9ab7c0d6abf66295$var$emptyObject = {};
function $9ab7c0d6abf66295$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $9ab7c0d6abf66295$var$emptyObject;
    this.updater = updater || $9ab7c0d6abf66295$var$ReactNoopUpdateQueue;
}
$9ab7c0d6abf66295$var$Component.prototype.isReactComponent = {};
$9ab7c0d6abf66295$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$9ab7c0d6abf66295$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $9ab7c0d6abf66295$var$ComponentDummy() {}
$9ab7c0d6abf66295$var$ComponentDummy.prototype = $9ab7c0d6abf66295$var$Component.prototype;
function $9ab7c0d6abf66295$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $9ab7c0d6abf66295$var$emptyObject;
    this.updater = updater || $9ab7c0d6abf66295$var$ReactNoopUpdateQueue;
}
var $9ab7c0d6abf66295$var$pureComponentPrototype = $9ab7c0d6abf66295$var$PureComponent.prototype = new $9ab7c0d6abf66295$var$ComponentDummy();
$9ab7c0d6abf66295$var$pureComponentPrototype.constructor = $9ab7c0d6abf66295$var$PureComponent;
$9ab7c0d6abf66295$var$assign($9ab7c0d6abf66295$var$pureComponentPrototype, $9ab7c0d6abf66295$var$Component.prototype);
$9ab7c0d6abf66295$var$pureComponentPrototype.isPureReactComponent = !0;
var $9ab7c0d6abf66295$var$isArrayImpl = Array.isArray;
function $9ab7c0d6abf66295$var$noop() {}
var $9ab7c0d6abf66295$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $9ab7c0d6abf66295$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $9ab7c0d6abf66295$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $9ab7c0d6abf66295$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $9ab7c0d6abf66295$var$cloneAndReplaceKey(oldElement, newKey) {
    return $9ab7c0d6abf66295$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $9ab7c0d6abf66295$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $9ab7c0d6abf66295$var$REACT_ELEMENT_TYPE;
}
function $9ab7c0d6abf66295$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $9ab7c0d6abf66295$var$userProvidedKeyEscapeRegex = /\/+/g;
function $9ab7c0d6abf66295$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $9ab7c0d6abf66295$var$escape("" + element.key) : index.toString(36);
}
function $9ab7c0d6abf66295$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($9ab7c0d6abf66295$var$noop, $9ab7c0d6abf66295$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $9ab7c0d6abf66295$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $9ab7c0d6abf66295$var$REACT_ELEMENT_TYPE:
                case $9ab7c0d6abf66295$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $9ab7c0d6abf66295$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $9ab7c0d6abf66295$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $9ab7c0d6abf66295$var$getElementKey(children, 0) : nameSoFar, $9ab7c0d6abf66295$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($9ab7c0d6abf66295$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $9ab7c0d6abf66295$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($9ab7c0d6abf66295$var$isValidElement(callback) && (callback = $9ab7c0d6abf66295$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($9ab7c0d6abf66295$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($9ab7c0d6abf66295$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $9ab7c0d6abf66295$var$getElementKey(nameSoFar, i), invokeCallback += $9ab7c0d6abf66295$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $9ab7c0d6abf66295$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $9ab7c0d6abf66295$var$getElementKey(nameSoFar, i++), invokeCallback += $9ab7c0d6abf66295$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $9ab7c0d6abf66295$var$mapIntoArray($9ab7c0d6abf66295$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $9ab7c0d6abf66295$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $9ab7c0d6abf66295$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $9ab7c0d6abf66295$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result, thenable = ctor();
        thenable.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject, void 0 === thenable.status && (thenable.status = "fulfilled", thenable.value = moduleObject);
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error, void 0 === thenable.status && (thenable.status = "rejected", thenable.reason = error);
        });
        -1 === payload._status && (payload._status = 0, payload._result = thenable);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $9ab7c0d6abf66295$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $9ab7c0d6abf66295$var$startTransition(scope) {
    var prevTransition = $9ab7c0d6abf66295$var$ReactSharedInternals.T, currentTransition = {};
    currentTransition.types = null !== prevTransition ? prevTransition.types : null;
    $9ab7c0d6abf66295$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $9ab7c0d6abf66295$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($9ab7c0d6abf66295$var$noop, $9ab7c0d6abf66295$var$reportGlobalError);
    } catch (error) {
        $9ab7c0d6abf66295$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $9ab7c0d6abf66295$var$ReactSharedInternals.T = prevTransition;
    }
}
function $9ab7c0d6abf66295$var$addTransitionType(type) {
    var transition = $9ab7c0d6abf66295$var$ReactSharedInternals.T;
    if (null !== transition) {
        var transitionTypes = transition.types;
        null === transitionTypes ? transition.types = [
            type
        ] : -1 === transitionTypes.indexOf(type) && transitionTypes.push(type);
    } else $9ab7c0d6abf66295$var$startTransition($9ab7c0d6abf66295$var$addTransitionType.bind(null, type));
}
var $9ab7c0d6abf66295$var$Children = {
    map: $9ab7c0d6abf66295$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $9ab7c0d6abf66295$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $9ab7c0d6abf66295$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $9ab7c0d6abf66295$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$9ab7c0d6abf66295$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$9ab7c0d6abf66295$export$9c16c1426311996d = $9ab7c0d6abf66295$var$REACT_ACTIVITY_TYPE;
$9ab7c0d6abf66295$export$dca3b0875bd9a954 = $9ab7c0d6abf66295$var$Children;
$9ab7c0d6abf66295$export$16fa2f45be04daa8 = $9ab7c0d6abf66295$var$Component;
$9ab7c0d6abf66295$export$ffb0004e005737fa = $9ab7c0d6abf66295$var$REACT_FRAGMENT_TYPE;
$9ab7c0d6abf66295$export$e2c29f18771995cb = $9ab7c0d6abf66295$var$REACT_PROFILER_TYPE;
$9ab7c0d6abf66295$export$221d75b3f55bb0bd = $9ab7c0d6abf66295$var$PureComponent;
$9ab7c0d6abf66295$export$5f8d39834fd61797 = $9ab7c0d6abf66295$var$REACT_STRICT_MODE_TYPE;
$9ab7c0d6abf66295$export$74bf444e3cd11ea5 = $9ab7c0d6abf66295$var$REACT_SUSPENSE_TYPE;
$9ab7c0d6abf66295$export$8cdaa4703948c5e9 = $9ab7c0d6abf66295$var$REACT_VIEW_TRANSITION_TYPE;
$9ab7c0d6abf66295$export$1ced07cd6b1985ce = $9ab7c0d6abf66295$var$ReactSharedInternals;
$9ab7c0d6abf66295$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $9ab7c0d6abf66295$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$9ab7c0d6abf66295$export$87c99536b1b8cdd8 = $9ab7c0d6abf66295$var$addTransitionType;
$9ab7c0d6abf66295$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$9ab7c0d6abf66295$export$8c538325882c7eec = function() {
    return null;
};
$9ab7c0d6abf66295$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $9ab7c0d6abf66295$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$9ab7c0d6abf66295$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $9ab7c0d6abf66295$var$ReactElement(element.type, key, props);
};
$9ab7c0d6abf66295$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $9ab7c0d6abf66295$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $9ab7c0d6abf66295$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$9ab7c0d6abf66295$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$9ab7c0d6abf66295$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $9ab7c0d6abf66295$var$ReactElement(type, key, props);
};
$9ab7c0d6abf66295$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$9ab7c0d6abf66295$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $9ab7c0d6abf66295$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$9ab7c0d6abf66295$export$a8257692ac88316c = $9ab7c0d6abf66295$var$isValidElement;
$9ab7c0d6abf66295$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $9ab7c0d6abf66295$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $9ab7c0d6abf66295$var$lazyInitializer
    };
};
$9ab7c0d6abf66295$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $9ab7c0d6abf66295$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$9ab7c0d6abf66295$export$7568632d0d33d16d = $9ab7c0d6abf66295$var$startTransition;
$9ab7c0d6abf66295$export$f93f40ac0ca7e3a8 = function() {
    return $9ab7c0d6abf66295$var$ReactSharedInternals.H.useCacheRefresh();
};
$9ab7c0d6abf66295$export$1f96ae73734a86cc = function(usable) {
    return $9ab7c0d6abf66295$var$ReactSharedInternals.H.use(usable);
};
$9ab7c0d6abf66295$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $9ab7c0d6abf66295$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$9ab7c0d6abf66295$export$35808ee640e87ca7 = function(callback, deps) {
    return $9ab7c0d6abf66295$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$9ab7c0d6abf66295$export$fae74005e78b1a27 = function(Context) {
    return $9ab7c0d6abf66295$var$ReactSharedInternals.H.useContext(Context);
};
$9ab7c0d6abf66295$export$dc8fbce3eb94dc1e = function() {};
$9ab7c0d6abf66295$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $9ab7c0d6abf66295$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$9ab7c0d6abf66295$export$6d9c69b0de29b591 = function(create, deps) {
    return $9ab7c0d6abf66295$var$ReactSharedInternals.H.useEffect(create, deps);
};
$9ab7c0d6abf66295$export$7f54fc3180508a52 = function(callback) {
    return $9ab7c0d6abf66295$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$9ab7c0d6abf66295$export$f680877a34711e37 = function() {
    return $9ab7c0d6abf66295$var$ReactSharedInternals.H.useId();
};
$9ab7c0d6abf66295$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $9ab7c0d6abf66295$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$9ab7c0d6abf66295$export$aaabe4eda9ed9969 = function(create, deps) {
    return $9ab7c0d6abf66295$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$9ab7c0d6abf66295$export$e5c5a5f917a5871c = function(create, deps) {
    return $9ab7c0d6abf66295$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$9ab7c0d6abf66295$export$1538c33de8887b59 = function(create, deps) {
    return $9ab7c0d6abf66295$var$ReactSharedInternals.H.useMemo(create, deps);
};
$9ab7c0d6abf66295$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $9ab7c0d6abf66295$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$9ab7c0d6abf66295$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $9ab7c0d6abf66295$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$9ab7c0d6abf66295$export$b8f5890fc79d6aca = function(initialValue) {
    return $9ab7c0d6abf66295$var$ReactSharedInternals.H.useRef(initialValue);
};
$9ab7c0d6abf66295$export$60241385465d0a34 = function(initialState) {
    return $9ab7c0d6abf66295$var$ReactSharedInternals.H.useState(initialState);
};
$9ab7c0d6abf66295$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $9ab7c0d6abf66295$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$9ab7c0d6abf66295$export$7b286972b8d8ccbf = function() {
    return $9ab7c0d6abf66295$var$ReactSharedInternals.H.useTransition();
};
$9ab7c0d6abf66295$export$83d89fbfd8236492 = "19.3.1";

});


parcelRegister("ibUU1", function(module, exports) {
'use strict';
function $d3e564c2a700df75$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($d3e564c2a700df75$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$d3e564c2a700df75$var$checkDCE();

module.exports = (parcelRequire("eVkyY"));

});
parcelRegister("eVkyY", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $add656f78f0d744b$export$69ce8ef3fe5cead0, (v) => $add656f78f0d744b$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "browser", () => $add656f78f0d744b$export$3f2684e5d7cb1006, (v) => $add656f78f0d744b$export$3f2684e5d7cb1006 = v);
$parcel$export(module.exports, "createPortal", () => $add656f78f0d744b$export$d39a5bbd09211389, (v) => $add656f78f0d744b$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $add656f78f0d744b$export$cd75ccfd720a3cd4, (v) => $add656f78f0d744b$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $add656f78f0d744b$export$a0816fa17a9e79be, (v) => $add656f78f0d744b$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $add656f78f0d744b$export$7292efcadded39f3, (v) => $add656f78f0d744b$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $add656f78f0d744b$export$da407abadb9b8f86, (v) => $add656f78f0d744b$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $add656f78f0d744b$export$314cfea32580671c, (v) => $add656f78f0d744b$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $add656f78f0d744b$export$513ccb98c53b8039, (v) => $add656f78f0d744b$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $add656f78f0d744b$export$dbca993bc2d264a, (v) => $add656f78f0d744b$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $add656f78f0d744b$export$4797a8006f0655d0, (v) => $add656f78f0d744b$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $add656f78f0d744b$export$c78a37762a8d58e1, (v) => $add656f78f0d744b$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $add656f78f0d744b$export$606f11b2eb45ecc6, (v) => $add656f78f0d744b$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $add656f78f0d744b$export$f7e8a0bf92324b1e, (v) => $add656f78f0d744b$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $add656f78f0d744b$export$83d89fbfd8236492, (v) => $add656f78f0d744b$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $add656f78f0d744b$export$69ce8ef3fe5cead0;
var $add656f78f0d744b$export$3f2684e5d7cb1006;
var $add656f78f0d744b$export$d39a5bbd09211389;
var $add656f78f0d744b$export$cd75ccfd720a3cd4;
var $add656f78f0d744b$export$a0816fa17a9e79be;
var $add656f78f0d744b$export$7292efcadded39f3;
var $add656f78f0d744b$export$da407abadb9b8f86;
var $add656f78f0d744b$export$314cfea32580671c;
var $add656f78f0d744b$export$513ccb98c53b8039;
var $add656f78f0d744b$export$dbca993bc2d264a;
var $add656f78f0d744b$export$4797a8006f0655d0;
var $add656f78f0d744b$export$c78a37762a8d58e1;
var $add656f78f0d744b$export$606f11b2eb45ecc6;
var $add656f78f0d744b$export$f7e8a0bf92324b1e;
var $add656f78f0d744b$export$83d89fbfd8236492;
"use strict";

var $5E6i4 = parcelRequire("5E6i4");
function $add656f78f0d744b$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $add656f78f0d744b$var$noop() {}
var $add656f78f0d744b$var$Internals = {
    d: {
        f: $add656f78f0d744b$var$noop,
        r: function() {
            throw Error($add656f78f0d744b$var$formatProdErrorMessage(522));
        },
        D: $add656f78f0d744b$var$noop,
        C: $add656f78f0d744b$var$noop,
        L: $add656f78f0d744b$var$noop,
        m: $add656f78f0d744b$var$noop,
        X: $add656f78f0d744b$var$noop,
        S: $add656f78f0d744b$var$noop,
        M: $add656f78f0d744b$var$noop
    },
    p: 0,
    findDOMNode: null
}, $add656f78f0d744b$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $add656f78f0d744b$var$REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), $add656f78f0d744b$var$REACT_OPTIMISTIC_KEY = Symbol.for("react.optimistic_key");
function $add656f78f0d744b$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $add656f78f0d744b$var$REACT_PORTAL_TYPE,
        key: null == key ? null : key === $add656f78f0d744b$var$REACT_OPTIMISTIC_KEY ? $add656f78f0d744b$var$REACT_OPTIMISTIC_KEY : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $add656f78f0d744b$var$ReactSharedInternals = $5E6i4.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $add656f78f0d744b$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$add656f78f0d744b$export$69ce8ef3fe5cead0 = $add656f78f0d744b$var$Internals;
$add656f78f0d744b$export$3f2684e5d7cb1006 = function(reason) {
    return {
        $$typeof: $add656f78f0d744b$var$REACT_RECOVERABLE_TYPE,
        _reason: reason
    };
};
$add656f78f0d744b$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($add656f78f0d744b$var$formatProdErrorMessage(299));
    return $add656f78f0d744b$var$createPortal$1(children, container, null, key);
};
$add656f78f0d744b$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $add656f78f0d744b$var$ReactSharedInternals.T, previousUpdatePriority = $add656f78f0d744b$var$Internals.p;
    try {
        if ($add656f78f0d744b$var$ReactSharedInternals.T = null, $add656f78f0d744b$var$Internals.p = 2, fn) return fn();
    } finally{
        $add656f78f0d744b$var$ReactSharedInternals.T = previousTransition, $add656f78f0d744b$var$Internals.p = previousUpdatePriority, $add656f78f0d744b$var$Internals.d.f();
    }
};
$add656f78f0d744b$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $add656f78f0d744b$var$Internals.d.C(href, options));
};
$add656f78f0d744b$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $add656f78f0d744b$var$Internals.d.D(href);
};
$add656f78f0d744b$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $add656f78f0d744b$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $add656f78f0d744b$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $add656f78f0d744b$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$add656f78f0d744b$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $add656f78f0d744b$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $add656f78f0d744b$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                    fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
                });
            }
        } else null == options && $add656f78f0d744b$var$Internals.d.M(href);
    }
};
$add656f78f0d744b$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $add656f78f0d744b$var$getCrossOriginStringAs(as, options.crossOrigin);
        $add656f78f0d744b$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$add656f78f0d744b$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $add656f78f0d744b$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $add656f78f0d744b$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
            });
        } else $add656f78f0d744b$var$Internals.d.m(href);
    }
};
$add656f78f0d744b$export$4797a8006f0655d0 = function(form) {
    $add656f78f0d744b$var$Internals.d.r(form);
};
$add656f78f0d744b$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$add656f78f0d744b$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $add656f78f0d744b$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$add656f78f0d744b$export$f7e8a0bf92324b1e = function() {
    return $add656f78f0d744b$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$add656f78f0d744b$export$83d89fbfd8236492 = "19.3.1";

});



parcelRegister("9PpZJ", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $727d0a7c8addf405$export$306c0aa65ff9ec16, (v) => $727d0a7c8addf405$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $727d0a7c8addf405$export$306c0aa65ff9ec16;
"use strict";

var $5E6i4 = parcelRequire("5E6i4");
function $727d0a7c8addf405$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $727d0a7c8addf405$var$objectIs = "function" === typeof Object.is ? Object.is : $727d0a7c8addf405$var$is, $727d0a7c8addf405$var$useState = $5E6i4.useState, $727d0a7c8addf405$var$useEffect = $5E6i4.useEffect, $727d0a7c8addf405$var$useLayoutEffect = $5E6i4.useLayoutEffect, $727d0a7c8addf405$var$useDebugValue = $5E6i4.useDebugValue;
function $727d0a7c8addf405$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $727d0a7c8addf405$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $727d0a7c8addf405$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $727d0a7c8addf405$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $727d0a7c8addf405$var$useEffect(function() {
        $727d0a7c8addf405$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $727d0a7c8addf405$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $727d0a7c8addf405$var$useDebugValue(value);
    return value;
}
function $727d0a7c8addf405$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$727d0a7c8addf405$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $727d0a7c8addf405$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $727d0a7c8addf405$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $727d0a7c8addf405$var$useSyncExternalStore$1 : $727d0a7c8addf405$var$useSyncExternalStore$2;
$727d0a7c8addf405$export$306c0aa65ff9ec16 = void 0 !== $5E6i4.useSyncExternalStore ? $5E6i4.useSyncExternalStore : $727d0a7c8addf405$var$shim;

});

parcelRegister("WFrUG", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $0b0591d84e5d6c15$export$a7c73072b1a182ae, (v) => $0b0591d84e5d6c15$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $0b0591d84e5d6c15$export$9f27bc3417b4524d, (v) => $0b0591d84e5d6c15$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $0b0591d84e5d6c15$export$db77ccec0bb4ccac, (v) => $0b0591d84e5d6c15$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $0b0591d84e5d6c15$export$8392c0c9d3dcbd35, (v) => $0b0591d84e5d6c15$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $0b0591d84e5d6c15$export$ffb0004e005737fa, (v) => $0b0591d84e5d6c15$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $0b0591d84e5d6c15$export$b624eff549462981, (v) => $0b0591d84e5d6c15$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $0b0591d84e5d6c15$export$7897aa7841a5380c, (v) => $0b0591d84e5d6c15$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $0b0591d84e5d6c15$export$602eac185826482c, (v) => $0b0591d84e5d6c15$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $0b0591d84e5d6c15$export$e2c29f18771995cb, (v) => $0b0591d84e5d6c15$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $0b0591d84e5d6c15$export$5f8d39834fd61797, (v) => $0b0591d84e5d6c15$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $0b0591d84e5d6c15$export$74bf444e3cd11ea5, (v) => $0b0591d84e5d6c15$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $0b0591d84e5d6c15$export$998bcd577473dd93, (v) => $0b0591d84e5d6c15$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isContextConsumer", () => $0b0591d84e5d6c15$export$b706b080d889d2c9, (v) => $0b0591d84e5d6c15$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $0b0591d84e5d6c15$export$5be5a87408f70ddc, (v) => $0b0591d84e5d6c15$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $0b0591d84e5d6c15$export$45a5e7f76e0caa8d, (v) => $0b0591d84e5d6c15$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $0b0591d84e5d6c15$export$455c2e768291efa6, (v) => $0b0591d84e5d6c15$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $0b0591d84e5d6c15$export$9522e17588c12572, (v) => $0b0591d84e5d6c15$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $0b0591d84e5d6c15$export$2110ac352bb060b9, (v) => $0b0591d84e5d6c15$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $0b0591d84e5d6c15$export$56885ab8b9c456ab, (v) => $0b0591d84e5d6c15$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $0b0591d84e5d6c15$export$d927fcb6adf8f9de, (v) => $0b0591d84e5d6c15$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $0b0591d84e5d6c15$export$b82d16f27459e05a, (v) => $0b0591d84e5d6c15$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $0b0591d84e5d6c15$export$522c17b4f5e123e8, (v) => $0b0591d84e5d6c15$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $0b0591d84e5d6c15$export$1aabd8a0274ecfd6, (v) => $0b0591d84e5d6c15$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $0b0591d84e5d6c15$export$3d6c20d97e46b957, (v) => $0b0591d84e5d6c15$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $0b0591d84e5d6c15$export$9b621391a187a31a, (v) => $0b0591d84e5d6c15$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $0b0591d84e5d6c15$export$f5bbd400c2f4426f, (v) => $0b0591d84e5d6c15$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0b0591d84e5d6c15$export$a7c73072b1a182ae;
var $0b0591d84e5d6c15$export$9f27bc3417b4524d;
var $0b0591d84e5d6c15$export$db77ccec0bb4ccac;
var $0b0591d84e5d6c15$export$8392c0c9d3dcbd35;
var $0b0591d84e5d6c15$export$ffb0004e005737fa;
var $0b0591d84e5d6c15$export$b624eff549462981;
var $0b0591d84e5d6c15$export$7897aa7841a5380c;
var $0b0591d84e5d6c15$export$602eac185826482c;
var $0b0591d84e5d6c15$export$e2c29f18771995cb;
var $0b0591d84e5d6c15$export$5f8d39834fd61797;
var $0b0591d84e5d6c15$export$74bf444e3cd11ea5;
var $0b0591d84e5d6c15$export$998bcd577473dd93;
var $0b0591d84e5d6c15$export$b706b080d889d2c9;
var $0b0591d84e5d6c15$export$5be5a87408f70ddc;
var $0b0591d84e5d6c15$export$45a5e7f76e0caa8d;
var $0b0591d84e5d6c15$export$455c2e768291efa6;
var $0b0591d84e5d6c15$export$9522e17588c12572;
var $0b0591d84e5d6c15$export$2110ac352bb060b9;
var $0b0591d84e5d6c15$export$56885ab8b9c456ab;
var $0b0591d84e5d6c15$export$d927fcb6adf8f9de;
var $0b0591d84e5d6c15$export$b82d16f27459e05a;
var $0b0591d84e5d6c15$export$522c17b4f5e123e8;
var $0b0591d84e5d6c15$export$1aabd8a0274ecfd6;
var $0b0591d84e5d6c15$export$3d6c20d97e46b957;
var $0b0591d84e5d6c15$export$9b621391a187a31a;
var $0b0591d84e5d6c15$export$f5bbd400c2f4426f;
"use strict";
var $0b0591d84e5d6c15$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $0b0591d84e5d6c15$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $0b0591d84e5d6c15$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $0b0591d84e5d6c15$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $0b0591d84e5d6c15$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $0b0591d84e5d6c15$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $0b0591d84e5d6c15$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $0b0591d84e5d6c15$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $0b0591d84e5d6c15$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $0b0591d84e5d6c15$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $0b0591d84e5d6c15$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $0b0591d84e5d6c15$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $0b0591d84e5d6c15$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $0b0591d84e5d6c15$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $0b0591d84e5d6c15$var$typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $0b0591d84e5d6c15$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $0b0591d84e5d6c15$var$REACT_FRAGMENT_TYPE:
                    case $0b0591d84e5d6c15$var$REACT_PROFILER_TYPE:
                    case $0b0591d84e5d6c15$var$REACT_STRICT_MODE_TYPE:
                    case $0b0591d84e5d6c15$var$REACT_SUSPENSE_TYPE:
                    case $0b0591d84e5d6c15$var$REACT_SUSPENSE_LIST_TYPE:
                    case $0b0591d84e5d6c15$var$REACT_VIEW_TRANSITION_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $0b0591d84e5d6c15$var$REACT_CONTEXT_TYPE:
                            case $0b0591d84e5d6c15$var$REACT_FORWARD_REF_TYPE:
                            case $0b0591d84e5d6c15$var$REACT_LAZY_TYPE:
                            case $0b0591d84e5d6c15$var$REACT_MEMO_TYPE:
                                return object;
                            case $0b0591d84e5d6c15$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $0b0591d84e5d6c15$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
$0b0591d84e5d6c15$export$a7c73072b1a182ae = $0b0591d84e5d6c15$var$REACT_CONSUMER_TYPE;
$0b0591d84e5d6c15$export$9f27bc3417b4524d = $0b0591d84e5d6c15$var$REACT_CONTEXT_TYPE;
$0b0591d84e5d6c15$export$db77ccec0bb4ccac = $0b0591d84e5d6c15$var$REACT_ELEMENT_TYPE;
$0b0591d84e5d6c15$export$8392c0c9d3dcbd35 = $0b0591d84e5d6c15$var$REACT_FORWARD_REF_TYPE;
$0b0591d84e5d6c15$export$ffb0004e005737fa = $0b0591d84e5d6c15$var$REACT_FRAGMENT_TYPE;
$0b0591d84e5d6c15$export$b624eff549462981 = $0b0591d84e5d6c15$var$REACT_LAZY_TYPE;
$0b0591d84e5d6c15$export$7897aa7841a5380c = $0b0591d84e5d6c15$var$REACT_MEMO_TYPE;
$0b0591d84e5d6c15$export$602eac185826482c = $0b0591d84e5d6c15$var$REACT_PORTAL_TYPE;
$0b0591d84e5d6c15$export$e2c29f18771995cb = $0b0591d84e5d6c15$var$REACT_PROFILER_TYPE;
$0b0591d84e5d6c15$export$5f8d39834fd61797 = $0b0591d84e5d6c15$var$REACT_STRICT_MODE_TYPE;
$0b0591d84e5d6c15$export$74bf444e3cd11ea5 = $0b0591d84e5d6c15$var$REACT_SUSPENSE_TYPE;
$0b0591d84e5d6c15$export$998bcd577473dd93 = $0b0591d84e5d6c15$var$REACT_SUSPENSE_LIST_TYPE;
$0b0591d84e5d6c15$export$b706b080d889d2c9 = function(object) {
    return $0b0591d84e5d6c15$var$typeOf(object) === $0b0591d84e5d6c15$var$REACT_CONSUMER_TYPE;
};
$0b0591d84e5d6c15$export$5be5a87408f70ddc = function(object) {
    return $0b0591d84e5d6c15$var$typeOf(object) === $0b0591d84e5d6c15$var$REACT_CONTEXT_TYPE;
};
$0b0591d84e5d6c15$export$45a5e7f76e0caa8d = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $0b0591d84e5d6c15$var$REACT_ELEMENT_TYPE;
};
$0b0591d84e5d6c15$export$455c2e768291efa6 = function(object) {
    return $0b0591d84e5d6c15$var$typeOf(object) === $0b0591d84e5d6c15$var$REACT_FORWARD_REF_TYPE;
};
$0b0591d84e5d6c15$export$9522e17588c12572 = function(object) {
    return $0b0591d84e5d6c15$var$typeOf(object) === $0b0591d84e5d6c15$var$REACT_FRAGMENT_TYPE;
};
$0b0591d84e5d6c15$export$2110ac352bb060b9 = function(object) {
    return $0b0591d84e5d6c15$var$typeOf(object) === $0b0591d84e5d6c15$var$REACT_LAZY_TYPE;
};
$0b0591d84e5d6c15$export$56885ab8b9c456ab = function(object) {
    return $0b0591d84e5d6c15$var$typeOf(object) === $0b0591d84e5d6c15$var$REACT_MEMO_TYPE;
};
$0b0591d84e5d6c15$export$d927fcb6adf8f9de = function(object) {
    return $0b0591d84e5d6c15$var$typeOf(object) === $0b0591d84e5d6c15$var$REACT_PORTAL_TYPE;
};
$0b0591d84e5d6c15$export$b82d16f27459e05a = function(object) {
    return $0b0591d84e5d6c15$var$typeOf(object) === $0b0591d84e5d6c15$var$REACT_PROFILER_TYPE;
};
$0b0591d84e5d6c15$export$522c17b4f5e123e8 = function(object) {
    return $0b0591d84e5d6c15$var$typeOf(object) === $0b0591d84e5d6c15$var$REACT_STRICT_MODE_TYPE;
};
$0b0591d84e5d6c15$export$1aabd8a0274ecfd6 = function(object) {
    return $0b0591d84e5d6c15$var$typeOf(object) === $0b0591d84e5d6c15$var$REACT_SUSPENSE_TYPE;
};
$0b0591d84e5d6c15$export$3d6c20d97e46b957 = function(object) {
    return $0b0591d84e5d6c15$var$typeOf(object) === $0b0591d84e5d6c15$var$REACT_SUSPENSE_LIST_TYPE;
};
$0b0591d84e5d6c15$export$9b621391a187a31a = function(type) {
    return "string" === typeof type || "function" === typeof type || type === $0b0591d84e5d6c15$var$REACT_FRAGMENT_TYPE || type === $0b0591d84e5d6c15$var$REACT_PROFILER_TYPE || type === $0b0591d84e5d6c15$var$REACT_STRICT_MODE_TYPE || type === $0b0591d84e5d6c15$var$REACT_SUSPENSE_TYPE || type === $0b0591d84e5d6c15$var$REACT_SUSPENSE_LIST_TYPE || type === $0b0591d84e5d6c15$var$REACT_VIEW_TRANSITION_TYPE || "object" === typeof type && null !== type && (type.$$typeof === $0b0591d84e5d6c15$var$REACT_LAZY_TYPE || type.$$typeof === $0b0591d84e5d6c15$var$REACT_MEMO_TYPE || type.$$typeof === $0b0591d84e5d6c15$var$REACT_CONTEXT_TYPE || type.$$typeof === $0b0591d84e5d6c15$var$REACT_CONSUMER_TYPE || type.$$typeof === $0b0591d84e5d6c15$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $0b0591d84e5d6c15$var$REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
$0b0591d84e5d6c15$export$f5bbd400c2f4426f = $0b0591d84e5d6c15$var$typeOf;

});

parcelRegister("5pSp9", function(module, exports) {
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ (function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.18.1';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`', INVALID_TEMPL_IMPORTS_ERROR_TEXT = 'Invalid `imports` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * **Security:** See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md)
     * — `_.template` is insecure and will be removed in v5.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            // Prevent prototype pollution:
            // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
            // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
            var index = -1, length = path.length;
            if (!length) return true;
            while(++index < length){
                var key = toKey(path[index]);
                // Always block "__proto__" anywhere in the path if it's not expected
                if (key === '__proto__' && !hasOwnProperty.call(object, '__proto__')) return false;
                // Block constructor/prototype as non-terminal traversal keys to prevent
                // escaping the object graph into built-in constructors and prototypes.
                if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
            }
            var obj = parent(object, path);
            return obj == null || delete obj[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `-0`, `0n`, `""`, `undefined`, and `NaN` are falsy.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                baseAssignValue(result, pair[0], pair[1]);
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * **Note:** If `lower` is greater than `upper`, the values are swapped.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * // when lower is greater than upper the values are swapped
     * _.random(5, 0);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(-5);
     * // => an integer between -5 and 0
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Security:** `_.template` is insecure and should not be used. It will be
     * removed in Lodash v5. Avoid untrusted input. See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md).
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            arrayEach(importsKeys, function(key) {
                if (reForbiddenIdentifierChars.test(key)) throw new Error(INVALID_TEMPL_IMPORTS_ERROR_TEXT);
            });
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("9eF39", function(module, exports) {

$parcel$export(module.exports, "Color", () => Color);
$parcel$export(module.exports, "darker", () => darker);
$parcel$export(module.exports, "brighter", () => brighter);
$parcel$export(module.exports, "default", () => color);
$parcel$export(module.exports, "hslConvert", () => hslConvert);
$parcel$export(module.exports, "Rgb", () => Rgb);
$parcel$export(module.exports, "rgbConvert", () => rgbConvert);
$parcel$export(module.exports, "rgb", () => rgb);
$parcel$export(module.exports, "hsl", () => hsl);

var $jKHze = parcelRequire("jKHze");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $jKHze.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $jKHze.default)(Rgb, rgb, (0, $jKHze.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $jKHze.default)(Hsl, hsl, (0, $jKHze.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("jKHze", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6141bbfd30ac9e4$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extend", () => $e6141bbfd30ac9e4$export$8b58be045bf06082);
function $e6141bbfd30ac9e4$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $e6141bbfd30ac9e4$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("bARIT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.websocketWrapper = void 0;
var $870cbac62d81d38b$var$websocketWrapper = function(webSocket, start) {
    return new Proxy(webSocket, {
        get: function(obj, key) {
            var val = obj[key];
            if (key === 'reconnect') return start;
            if (typeof val === 'function') {
                console.error('Calling methods directly on the websocket is not supported at this moment. You must use the methods returned by useWebSocket.');
                //Prevent error thrown by invoking a non-function
                return function() {};
            } else return val;
        },
        set: function(obj, key, val) {
            if (/^on/.test(key)) {
                console.warn('The websocket\'s event handlers should be defined through the options object passed into useWebSocket.');
                return false;
            } else {
                obj[key] = val;
                return true;
            }
        }
    });
};
module.exports.websocketWrapper = $870cbac62d81d38b$var$websocketWrapper;
module.exports.default = module.exports.websocketWrapper;

});

parcelRegister("7NDp4", function(module, exports) {

$parcel$export(module.exports, "epsilon", () => epsilon);
$parcel$export(module.exports, "epsilon2", () => epsilon2);
$parcel$export(module.exports, "beaches", () => beaches);
$parcel$export(module.exports, "cells", () => cells);
$parcel$export(module.exports, "circles", () => circles);
$parcel$export(module.exports, "edges", () => edges);
$parcel$export(module.exports, "default", () => Diagram);

var $6p16R = parcelRequire("6p16R");

var $aZrj5 = parcelRequire("aZrj5");

var $kaXZw = parcelRequire("kaXZw");

var $ijWMp = parcelRequire("ijWMp");

var $iXUxb = parcelRequire("iXUxb");
var epsilon = 1e-6;
var epsilon2 = 1e-12;
var beaches;
var cells;
var circles;
var edges;
function triangleArea(a, b, c) {
    return (a[0] - c[0]) * (b[1] - a[1]) - (a[0] - b[0]) * (c[1] - a[1]);
}
function lexicographic(a, b) {
    return b[1] - a[1] || b[0] - a[0];
}
function Diagram(sites, extent) {
    var site = sites.sort(lexicographic).pop(), x, y, circle;
    edges = [];
    cells = new Array(sites.length);
    beaches = new (0, $iXUxb.default);
    circles = new (0, $iXUxb.default);
    while(true){
        circle = (0, $kaXZw.firstCircle);
        if (site && (!circle || site[1] < circle.y || site[1] === circle.y && site[0] < circle.x)) {
            if (site[0] !== x || site[1] !== y) {
                (0, $6p16R.addBeach)(site);
                x = site[0], y = site[1];
            }
            site = sites.pop();
        } else if (circle) (0, $6p16R.removeBeach)(circle.arc);
        else break;
    }
    (0, $aZrj5.sortCellHalfedges)();
    if (extent) {
        var x0 = +extent[0][0], y0 = +extent[0][1], x1 = +extent[1][0], y1 = +extent[1][1];
        (0, $ijWMp.clipEdges)(x0, y0, x1, y1);
        (0, $aZrj5.clipCells)(x0, y0, x1, y1);
    }
    this.edges = edges;
    this.cells = cells;
    beaches = circles = edges = cells = null;
}
Diagram.prototype = {
    constructor: Diagram,
    polygons: function() {
        var edges = this.edges;
        return this.cells.map(function(cell) {
            var polygon = cell.halfedges.map(function(i) {
                return (0, $aZrj5.cellHalfedgeStart)(cell, edges[i]);
            });
            polygon.data = cell.site.data;
            return polygon;
        });
    },
    triangles: function() {
        var triangles = [], edges = this.edges;
        this.cells.forEach(function(cell, i) {
            if (!(m = (halfedges = cell.halfedges).length)) return;
            var site = cell.site, halfedges, j = -1, m, s0, e1 = edges[halfedges[m - 1]], s1 = e1.left === site ? e1.right : e1.left;
            while(++j < m){
                s0 = s1;
                e1 = edges[halfedges[j]];
                s1 = e1.left === site ? e1.right : e1.left;
                if (s0 && s1 && i < s0.index && i < s1.index && triangleArea(site, s0, s1) < 0) triangles.push([
                    site.data,
                    s0.data,
                    s1.data
                ]);
            }
        });
        return triangles;
    },
    links: function() {
        return this.edges.filter(function(edge) {
            return edge.right;
        }).map(function(edge) {
            return {
                source: edge.left.data,
                target: edge.right.data
            };
        });
    },
    find: function(x, y, radius) {
        var that = this, i0, i1 = that._found || 0, n = that.cells.length, cell;
        // Use the previously-found cell, or start with an arbitrary one.
        while(!(cell = that.cells[i1]))if (++i1 >= n) return null;
        var dx = x - cell.site[0], dy = y - cell.site[1], d2 = dx * dx + dy * dy;
        // Traverse the half-edges to find a closer cell, if any.
        do {
            cell = that.cells[i0 = i1], i1 = null;
            cell.halfedges.forEach(function(e) {
                var edge = that.edges[e], v = edge.left;
                if ((v === cell.site || !v) && !(v = edge.right)) return;
                var vx = x - v[0], vy = y - v[1], v2 = vx * vx + vy * vy;
                if (v2 < d2) d2 = v2, i1 = v.index;
            });
        }while (i1 !== null);
        that._found = i0;
        return radius == null || d2 <= radius * radius ? cell.site : null;
    }
};

});
parcelRegister("6p16R", function(module, exports) {

$parcel$export(module.exports, "removeBeach", () => $4a95f0390aef0d9b$export$25be321a9b2d3c3c);
$parcel$export(module.exports, "addBeach", () => $4a95f0390aef0d9b$export$fec167a219592370);

var $iXUxb = parcelRequire("iXUxb");

var $aZrj5 = parcelRequire("aZrj5");

var $kaXZw = parcelRequire("kaXZw");

var $ijWMp = parcelRequire("ijWMp");

var $7NDp4 = parcelRequire("7NDp4");
var $4a95f0390aef0d9b$var$beachPool = [];
function $4a95f0390aef0d9b$var$Beach() {
    (0, $iXUxb.RedBlackNode)(this);
    this.edge = this.site = this.circle = null;
}
function $4a95f0390aef0d9b$var$createBeach(site) {
    var beach = $4a95f0390aef0d9b$var$beachPool.pop() || new $4a95f0390aef0d9b$var$Beach;
    beach.site = site;
    return beach;
}
function $4a95f0390aef0d9b$var$detachBeach(beach) {
    (0, $kaXZw.detachCircle)(beach);
    (0, $7NDp4.beaches).remove(beach);
    $4a95f0390aef0d9b$var$beachPool.push(beach);
    (0, $iXUxb.RedBlackNode)(beach);
}
function $4a95f0390aef0d9b$export$25be321a9b2d3c3c(beach) {
    var circle = beach.circle, x = circle.x, y = circle.cy, vertex = [
        x,
        y
    ], previous = beach.P, next = beach.N, disappearing = [
        beach
    ];
    $4a95f0390aef0d9b$var$detachBeach(beach);
    var lArc = previous;
    while(lArc.circle && Math.abs(x - lArc.circle.x) < (0, $7NDp4.epsilon) && Math.abs(y - lArc.circle.cy) < (0, $7NDp4.epsilon)){
        previous = lArc.P;
        disappearing.unshift(lArc);
        $4a95f0390aef0d9b$var$detachBeach(lArc);
        lArc = previous;
    }
    disappearing.unshift(lArc);
    (0, $kaXZw.detachCircle)(lArc);
    var rArc = next;
    while(rArc.circle && Math.abs(x - rArc.circle.x) < (0, $7NDp4.epsilon) && Math.abs(y - rArc.circle.cy) < (0, $7NDp4.epsilon)){
        next = rArc.N;
        disappearing.push(rArc);
        $4a95f0390aef0d9b$var$detachBeach(rArc);
        rArc = next;
    }
    disappearing.push(rArc);
    (0, $kaXZw.detachCircle)(rArc);
    var nArcs = disappearing.length, iArc;
    for(iArc = 1; iArc < nArcs; ++iArc){
        rArc = disappearing[iArc];
        lArc = disappearing[iArc - 1];
        (0, $ijWMp.setEdgeEnd)(rArc.edge, lArc.site, rArc.site, vertex);
    }
    lArc = disappearing[0];
    rArc = disappearing[nArcs - 1];
    rArc.edge = (0, $ijWMp.createEdge)(lArc.site, rArc.site, null, vertex);
    (0, $kaXZw.attachCircle)(lArc);
    (0, $kaXZw.attachCircle)(rArc);
}
function $4a95f0390aef0d9b$export$fec167a219592370(site) {
    var x = site[0], directrix = site[1], lArc, rArc, dxl, dxr, node = (0, $7NDp4.beaches)._;
    while(node){
        dxl = $4a95f0390aef0d9b$var$leftBreakPoint(node, directrix) - x;
        if (dxl > (0, $7NDp4.epsilon)) node = node.L;
        else {
            dxr = x - $4a95f0390aef0d9b$var$rightBreakPoint(node, directrix);
            if (dxr > (0, $7NDp4.epsilon)) {
                if (!node.R) {
                    lArc = node;
                    break;
                }
                node = node.R;
            } else {
                if (dxl > -(0, $7NDp4.epsilon)) {
                    lArc = node.P;
                    rArc = node;
                } else if (dxr > -(0, $7NDp4.epsilon)) {
                    lArc = node;
                    rArc = node.N;
                } else lArc = rArc = node;
                break;
            }
        }
    }
    (0, $aZrj5.createCell)(site);
    var newArc = $4a95f0390aef0d9b$var$createBeach(site);
    (0, $7NDp4.beaches).insert(lArc, newArc);
    if (!lArc && !rArc) return;
    if (lArc === rArc) {
        (0, $kaXZw.detachCircle)(lArc);
        rArc = $4a95f0390aef0d9b$var$createBeach(lArc.site);
        (0, $7NDp4.beaches).insert(newArc, rArc);
        newArc.edge = rArc.edge = (0, $ijWMp.createEdge)(lArc.site, newArc.site);
        (0, $kaXZw.attachCircle)(lArc);
        (0, $kaXZw.attachCircle)(rArc);
        return;
    }
    if (!rArc) {
        newArc.edge = (0, $ijWMp.createEdge)(lArc.site, newArc.site);
        return;
    }
    // else lArc !== rArc
    (0, $kaXZw.detachCircle)(lArc);
    (0, $kaXZw.detachCircle)(rArc);
    var lSite = lArc.site, ax = lSite[0], ay = lSite[1], bx = site[0] - ax, by = site[1] - ay, rSite = rArc.site, cx = rSite[0] - ax, cy = rSite[1] - ay, d = 2 * (bx * cy - by * cx), hb = bx * bx + by * by, hc = cx * cx + cy * cy, vertex = [
        (cy * hb - by * hc) / d + ax,
        (bx * hc - cx * hb) / d + ay
    ];
    (0, $ijWMp.setEdgeEnd)(rArc.edge, lSite, rSite, vertex);
    newArc.edge = (0, $ijWMp.createEdge)(lSite, site, null, vertex);
    rArc.edge = (0, $ijWMp.createEdge)(site, rSite, null, vertex);
    (0, $kaXZw.attachCircle)(lArc);
    (0, $kaXZw.attachCircle)(rArc);
}
function $4a95f0390aef0d9b$var$leftBreakPoint(arc, directrix) {
    var site = arc.site, rfocx = site[0], rfocy = site[1], pby2 = rfocy - directrix;
    if (!pby2) return rfocx;
    var lArc = arc.P;
    if (!lArc) return -Infinity;
    site = lArc.site;
    var lfocx = site[0], lfocy = site[1], plby2 = lfocy - directrix;
    if (!plby2) return lfocx;
    var hl = lfocx - rfocx, aby2 = 1 / pby2 - 1 / plby2, b = hl / plby2;
    if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
    return (rfocx + lfocx) / 2;
}
function $4a95f0390aef0d9b$var$rightBreakPoint(arc, directrix) {
    var rArc = arc.N;
    if (rArc) return $4a95f0390aef0d9b$var$leftBreakPoint(rArc, directrix);
    var site = arc.site;
    return site[1] === directrix ? site[0] : Infinity;
}

});
parcelRegister("iXUxb", function(module, exports) {

$parcel$export(module.exports, "RedBlackNode", () => $dce99737238424b5$export$5072552a5e64b90a);
$parcel$export(module.exports, "default", () => $dce99737238424b5$export$2e2bcd8739ae039);
function $dce99737238424b5$var$RedBlackTree() {
    this._ = null; // root node
}
function $dce99737238424b5$export$5072552a5e64b90a(node) {
    node.U = node.C = node.L = node.R = node.P = node.N = null; // next node
}
$dce99737238424b5$var$RedBlackTree.prototype = {
    constructor: $dce99737238424b5$var$RedBlackTree,
    insert: function(after, node) {
        var parent, grandpa, uncle;
        if (after) {
            node.P = after;
            node.N = after.N;
            if (after.N) after.N.P = node;
            after.N = node;
            if (after.R) {
                after = after.R;
                while(after.L)after = after.L;
                after.L = node;
            } else after.R = node;
            parent = after;
        } else if (this._) {
            after = $dce99737238424b5$var$RedBlackFirst(this._);
            node.P = null;
            node.N = after;
            after.P = after.L = node;
            parent = after;
        } else {
            node.P = node.N = null;
            this._ = node;
            parent = null;
        }
        node.L = node.R = null;
        node.U = parent;
        node.C = true;
        after = node;
        while(parent && parent.C){
            grandpa = parent.U;
            if (parent === grandpa.L) {
                uncle = grandpa.R;
                if (uncle && uncle.C) {
                    parent.C = uncle.C = false;
                    grandpa.C = true;
                    after = grandpa;
                } else {
                    if (after === parent.R) {
                        $dce99737238424b5$var$RedBlackRotateLeft(this, parent);
                        after = parent;
                        parent = after.U;
                    }
                    parent.C = false;
                    grandpa.C = true;
                    $dce99737238424b5$var$RedBlackRotateRight(this, grandpa);
                }
            } else {
                uncle = grandpa.L;
                if (uncle && uncle.C) {
                    parent.C = uncle.C = false;
                    grandpa.C = true;
                    after = grandpa;
                } else {
                    if (after === parent.L) {
                        $dce99737238424b5$var$RedBlackRotateRight(this, parent);
                        after = parent;
                        parent = after.U;
                    }
                    parent.C = false;
                    grandpa.C = true;
                    $dce99737238424b5$var$RedBlackRotateLeft(this, grandpa);
                }
            }
            parent = after.U;
        }
        this._.C = false;
    },
    remove: function(node) {
        if (node.N) node.N.P = node.P;
        if (node.P) node.P.N = node.N;
        node.N = node.P = null;
        var parent = node.U, sibling, left = node.L, right = node.R, next, red;
        if (!left) next = right;
        else if (!right) next = left;
        else next = $dce99737238424b5$var$RedBlackFirst(right);
        if (parent) {
            if (parent.L === node) parent.L = next;
            else parent.R = next;
        } else this._ = next;
        if (left && right) {
            red = next.C;
            next.C = node.C;
            next.L = left;
            left.U = next;
            if (next !== right) {
                parent = next.U;
                next.U = node.U;
                node = next.R;
                parent.L = node;
                next.R = right;
                right.U = next;
            } else {
                next.U = parent;
                parent = next;
                node = next.R;
            }
        } else {
            red = node.C;
            node = next;
        }
        if (node) node.U = parent;
        if (red) return;
        if (node && node.C) {
            node.C = false;
            return;
        }
        do {
            if (node === this._) break;
            if (node === parent.L) {
                sibling = parent.R;
                if (sibling.C) {
                    sibling.C = false;
                    parent.C = true;
                    $dce99737238424b5$var$RedBlackRotateLeft(this, parent);
                    sibling = parent.R;
                }
                if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
                    if (!sibling.R || !sibling.R.C) {
                        sibling.L.C = false;
                        sibling.C = true;
                        $dce99737238424b5$var$RedBlackRotateRight(this, sibling);
                        sibling = parent.R;
                    }
                    sibling.C = parent.C;
                    parent.C = sibling.R.C = false;
                    $dce99737238424b5$var$RedBlackRotateLeft(this, parent);
                    node = this._;
                    break;
                }
            } else {
                sibling = parent.L;
                if (sibling.C) {
                    sibling.C = false;
                    parent.C = true;
                    $dce99737238424b5$var$RedBlackRotateRight(this, parent);
                    sibling = parent.L;
                }
                if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
                    if (!sibling.L || !sibling.L.C) {
                        sibling.R.C = false;
                        sibling.C = true;
                        $dce99737238424b5$var$RedBlackRotateLeft(this, sibling);
                        sibling = parent.L;
                    }
                    sibling.C = parent.C;
                    parent.C = sibling.L.C = false;
                    $dce99737238424b5$var$RedBlackRotateRight(this, parent);
                    node = this._;
                    break;
                }
            }
            sibling.C = true;
            node = parent;
            parent = parent.U;
        }while (!node.C);
        if (node) node.C = false;
    }
};
function $dce99737238424b5$var$RedBlackRotateLeft(tree, node) {
    var p = node, q = node.R, parent = p.U;
    if (parent) {
        if (parent.L === p) parent.L = q;
        else parent.R = q;
    } else tree._ = q;
    q.U = parent;
    p.U = q;
    p.R = q.L;
    if (p.R) p.R.U = p;
    q.L = p;
}
function $dce99737238424b5$var$RedBlackRotateRight(tree, node) {
    var p = node, q = node.L, parent = p.U;
    if (parent) {
        if (parent.L === p) parent.L = q;
        else parent.R = q;
    } else tree._ = q;
    q.U = parent;
    p.U = q;
    p.L = q.R;
    if (p.L) p.L.U = p;
    q.R = p;
}
function $dce99737238424b5$var$RedBlackFirst(node) {
    while(node.L)node = node.L;
    return node;
}
var $dce99737238424b5$export$2e2bcd8739ae039 = $dce99737238424b5$var$RedBlackTree;

});

parcelRegister("aZrj5", function(module, exports) {

$parcel$export(module.exports, "createCell", () => $8004c877636a3a08$export$3cb21b6b1233300e);
$parcel$export(module.exports, "cellHalfedgeStart", () => $8004c877636a3a08$export$67c16aa967774be);
$parcel$export(module.exports, "sortCellHalfedges", () => $8004c877636a3a08$export$41888d88cbc31210);
$parcel$export(module.exports, "clipCells", () => $8004c877636a3a08$export$cdcebd68073bc3f);

var $ijWMp = parcelRequire("ijWMp");

var $7NDp4 = parcelRequire("7NDp4");
function $8004c877636a3a08$export$3cb21b6b1233300e(site) {
    return (0, $7NDp4.cells)[site.index] = {
        site: site,
        halfedges: []
    };
}
function $8004c877636a3a08$var$cellHalfedgeAngle(cell, edge) {
    var site = cell.site, va = edge.left, vb = edge.right;
    if (site === vb) vb = va, va = site;
    if (vb) return Math.atan2(vb[1] - va[1], vb[0] - va[0]);
    if (site === va) va = edge[1], vb = edge[0];
    else va = edge[0], vb = edge[1];
    return Math.atan2(va[0] - vb[0], vb[1] - va[1]);
}
function $8004c877636a3a08$export$67c16aa967774be(cell, edge) {
    return edge[+(edge.left !== cell.site)];
}
function $8004c877636a3a08$export$bf8e581ba65a00a5(cell, edge) {
    return edge[+(edge.left === cell.site)];
}
function $8004c877636a3a08$export$41888d88cbc31210() {
    for(var i = 0, n = (0, $7NDp4.cells).length, cell, halfedges, j, m; i < n; ++i)if ((cell = (0, $7NDp4.cells)[i]) && (m = (halfedges = cell.halfedges).length)) {
        var index = new Array(m), array = new Array(m);
        for(j = 0; j < m; ++j)index[j] = j, array[j] = $8004c877636a3a08$var$cellHalfedgeAngle(cell, (0, $7NDp4.edges)[halfedges[j]]);
        index.sort(function(i, j) {
            return array[j] - array[i];
        });
        for(j = 0; j < m; ++j)array[j] = halfedges[index[j]];
        for(j = 0; j < m; ++j)halfedges[j] = array[j];
    }
}
function $8004c877636a3a08$export$cdcebd68073bc3f(x0, y0, x1, y1) {
    var nCells = (0, $7NDp4.cells).length, iCell, cell, site, iHalfedge, halfedges, nHalfedges, start, startX, startY, end, endX, endY, cover = true;
    for(iCell = 0; iCell < nCells; ++iCell)if (cell = (0, $7NDp4.cells)[iCell]) {
        site = cell.site;
        halfedges = cell.halfedges;
        iHalfedge = halfedges.length;
        // Remove any dangling clipped edges.
        while(iHalfedge--)if (!(0, $7NDp4.edges)[halfedges[iHalfedge]]) halfedges.splice(iHalfedge, 1);
        // Insert any border edges as necessary.
        iHalfedge = 0, nHalfedges = halfedges.length;
        while(iHalfedge < nHalfedges){
            end = $8004c877636a3a08$export$bf8e581ba65a00a5(cell, (0, $7NDp4.edges)[halfedges[iHalfedge]]), endX = end[0], endY = end[1];
            start = $8004c877636a3a08$export$67c16aa967774be(cell, (0, $7NDp4.edges)[halfedges[++iHalfedge % nHalfedges]]), startX = start[0], startY = start[1];
            if (Math.abs(endX - startX) > (0, $7NDp4.epsilon) || Math.abs(endY - startY) > (0, $7NDp4.epsilon)) {
                halfedges.splice(iHalfedge, 0, (0, $7NDp4.edges).push((0, $ijWMp.createBorderEdge)(site, end, Math.abs(endX - x0) < (0, $7NDp4.epsilon) && y1 - endY > (0, $7NDp4.epsilon) ? [
                    x0,
                    Math.abs(startX - x0) < (0, $7NDp4.epsilon) ? startY : y1
                ] : Math.abs(endY - y1) < (0, $7NDp4.epsilon) && x1 - endX > (0, $7NDp4.epsilon) ? [
                    Math.abs(startY - y1) < (0, $7NDp4.epsilon) ? startX : x1,
                    y1
                ] : Math.abs(endX - x1) < (0, $7NDp4.epsilon) && endY - y0 > (0, $7NDp4.epsilon) ? [
                    x1,
                    Math.abs(startX - x1) < (0, $7NDp4.epsilon) ? startY : y0
                ] : Math.abs(endY - y0) < (0, $7NDp4.epsilon) && endX - x0 > (0, $7NDp4.epsilon) ? [
                    Math.abs(startY - y0) < (0, $7NDp4.epsilon) ? startX : x0,
                    y0
                ] : null)) - 1);
                ++nHalfedges;
            }
        }
        if (nHalfedges) cover = false;
    }
    // If there weren’t any edges, have the closest site cover the extent.
    // It doesn’t matter which corner of the extent we measure!
    if (cover) {
        var dx, dy, d2, dc = Infinity;
        for(iCell = 0, cover = null; iCell < nCells; ++iCell)if (cell = (0, $7NDp4.cells)[iCell]) {
            site = cell.site;
            dx = site[0] - x0;
            dy = site[1] - y0;
            d2 = dx * dx + dy * dy;
            if (d2 < dc) dc = d2, cover = cell;
        }
        if (cover) {
            var v00 = [
                x0,
                y0
            ], v01 = [
                x0,
                y1
            ], v11 = [
                x1,
                y1
            ], v10 = [
                x1,
                y0
            ];
            cover.halfedges.push((0, $7NDp4.edges).push((0, $ijWMp.createBorderEdge)(site = cover.site, v00, v01)) - 1, (0, $7NDp4.edges).push((0, $ijWMp.createBorderEdge)(site, v01, v11)) - 1, (0, $7NDp4.edges).push((0, $ijWMp.createBorderEdge)(site, v11, v10)) - 1, (0, $7NDp4.edges).push((0, $ijWMp.createBorderEdge)(site, v10, v00)) - 1);
        }
    }
    // Lastly delete any cells with no edges; these were entirely clipped.
    for(iCell = 0; iCell < nCells; ++iCell){
        if (cell = (0, $7NDp4.cells)[iCell]) {
            if (!cell.halfedges.length) delete (0, $7NDp4.cells)[iCell];
        }
    }
}

});
parcelRegister("ijWMp", function(module, exports) {

$parcel$export(module.exports, "createEdge", () => $d56798c9b8eb3d5f$export$bdd941b9b8806569);
$parcel$export(module.exports, "setEdgeEnd", () => $d56798c9b8eb3d5f$export$9e883caea829cb44);
$parcel$export(module.exports, "createBorderEdge", () => $d56798c9b8eb3d5f$export$681cc0bbec712be1);
$parcel$export(module.exports, "clipEdges", () => $d56798c9b8eb3d5f$export$db4502aa9c1617af);

var $7NDp4 = parcelRequire("7NDp4");
function $d56798c9b8eb3d5f$export$bdd941b9b8806569(left, right, v0, v1) {
    var edge = [
        null,
        null
    ], index = (0, $7NDp4.edges).push(edge) - 1;
    edge.left = left;
    edge.right = right;
    if (v0) $d56798c9b8eb3d5f$export$9e883caea829cb44(edge, left, right, v0);
    if (v1) $d56798c9b8eb3d5f$export$9e883caea829cb44(edge, right, left, v1);
    (0, $7NDp4.cells)[left.index].halfedges.push(index);
    (0, $7NDp4.cells)[right.index].halfedges.push(index);
    return edge;
}
function $d56798c9b8eb3d5f$export$681cc0bbec712be1(left, v0, v1) {
    var edge = [
        v0,
        v1
    ];
    edge.left = left;
    return edge;
}
function $d56798c9b8eb3d5f$export$9e883caea829cb44(edge, left, right, vertex) {
    if (!edge[0] && !edge[1]) {
        edge[0] = vertex;
        edge.left = left;
        edge.right = right;
    } else if (edge.left === right) edge[1] = vertex;
    else edge[0] = vertex;
}
// Liang–Barsky line clipping.
function $d56798c9b8eb3d5f$var$clipEdge(edge, x0, y0, x1, y1) {
    var a = edge[0], b = edge[1], ax = a[0], ay = a[1], bx = b[0], by = b[1], t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
    r = x0 - ax;
    if (!dx && r > 0) return;
    r /= dx;
    if (dx < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    } else if (dx > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    }
    r = x1 - ax;
    if (!dx && r < 0) return;
    r /= dx;
    if (dx < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    } else if (dx > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    }
    r = y0 - ay;
    if (!dy && r > 0) return;
    r /= dy;
    if (dy < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    } else if (dy > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    }
    r = y1 - ay;
    if (!dy && r < 0) return;
    r /= dy;
    if (dy < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    } else if (dy > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    }
    if (!(t0 > 0) && !(t1 < 1)) return true; // TODO Better check?
    if (t0 > 0) edge[0] = [
        ax + t0 * dx,
        ay + t0 * dy
    ];
    if (t1 < 1) edge[1] = [
        ax + t1 * dx,
        ay + t1 * dy
    ];
    return true;
}
function $d56798c9b8eb3d5f$var$connectEdge(edge, x0, y0, x1, y1) {
    var v1 = edge[1];
    if (v1) return true;
    var v0 = edge[0], left = edge.left, right = edge.right, lx = left[0], ly = left[1], rx = right[0], ry = right[1], fx = (lx + rx) / 2, fy = (ly + ry) / 2, fm, fb;
    if (ry === ly) {
        if (fx < x0 || fx >= x1) return;
        if (lx > rx) {
            if (!v0) v0 = [
                fx,
                y0
            ];
            else if (v0[1] >= y1) return;
            v1 = [
                fx,
                y1
            ];
        } else {
            if (!v0) v0 = [
                fx,
                y1
            ];
            else if (v0[1] < y0) return;
            v1 = [
                fx,
                y0
            ];
        }
    } else {
        fm = (lx - rx) / (ry - ly);
        fb = fy - fm * fx;
        if (fm < -1 || fm > 1) {
            if (lx > rx) {
                if (!v0) v0 = [
                    (y0 - fb) / fm,
                    y0
                ];
                else if (v0[1] >= y1) return;
                v1 = [
                    (y1 - fb) / fm,
                    y1
                ];
            } else {
                if (!v0) v0 = [
                    (y1 - fb) / fm,
                    y1
                ];
                else if (v0[1] < y0) return;
                v1 = [
                    (y0 - fb) / fm,
                    y0
                ];
            }
        } else if (ly < ry) {
            if (!v0) v0 = [
                x0,
                fm * x0 + fb
            ];
            else if (v0[0] >= x1) return;
            v1 = [
                x1,
                fm * x1 + fb
            ];
        } else {
            if (!v0) v0 = [
                x1,
                fm * x1 + fb
            ];
            else if (v0[0] < x0) return;
            v1 = [
                x0,
                fm * x0 + fb
            ];
        }
    }
    edge[0] = v0;
    edge[1] = v1;
    return true;
}
function $d56798c9b8eb3d5f$export$db4502aa9c1617af(x0, y0, x1, y1) {
    var i = (0, $7NDp4.edges).length, edge;
    while(i--)if (!$d56798c9b8eb3d5f$var$connectEdge(edge = (0, $7NDp4.edges)[i], x0, y0, x1, y1) || !$d56798c9b8eb3d5f$var$clipEdge(edge, x0, y0, x1, y1) || !(Math.abs(edge[0][0] - edge[1][0]) > (0, $7NDp4.epsilon) || Math.abs(edge[0][1] - edge[1][1]) > (0, $7NDp4.epsilon))) delete (0, $7NDp4.edges)[i];
}

});


parcelRegister("kaXZw", function(module, exports) {

$parcel$export(module.exports, "firstCircle", () => $eb0346d7101daa43$export$2ca650a30b282a37);
$parcel$export(module.exports, "attachCircle", () => $eb0346d7101daa43$export$2a19333f6373b7a2);
$parcel$export(module.exports, "detachCircle", () => $eb0346d7101daa43$export$f0bd50ff687673c1);

var $iXUxb = parcelRequire("iXUxb");

var $7NDp4 = parcelRequire("7NDp4");
var $eb0346d7101daa43$var$circlePool = [];
var $eb0346d7101daa43$export$2ca650a30b282a37;
function $eb0346d7101daa43$var$Circle() {
    (0, $iXUxb.RedBlackNode)(this);
    this.x = this.y = this.arc = this.site = this.cy = null;
}
function $eb0346d7101daa43$export$2a19333f6373b7a2(arc) {
    var lArc = arc.P, rArc = arc.N;
    if (!lArc || !rArc) return;
    var lSite = lArc.site, cSite = arc.site, rSite = rArc.site;
    if (lSite === rSite) return;
    var bx = cSite[0], by = cSite[1], ax = lSite[0] - bx, ay = lSite[1] - by, cx = rSite[0] - bx, cy = rSite[1] - by;
    var d = 2 * (ax * cy - ay * cx);
    if (d >= -(0, $7NDp4.epsilon2)) return;
    var ha = ax * ax + ay * ay, hc = cx * cx + cy * cy, x = (cy * ha - ay * hc) / d, y = (ax * hc - cx * ha) / d;
    var circle = $eb0346d7101daa43$var$circlePool.pop() || new $eb0346d7101daa43$var$Circle;
    circle.arc = arc;
    circle.site = cSite;
    circle.x = x + bx;
    circle.y = (circle.cy = y + by) + Math.sqrt(x * x + y * y); // y bottom
    arc.circle = circle;
    var before = null, node = (0, $7NDp4.circles)._;
    while(node){
        if (circle.y < node.y || circle.y === node.y && circle.x <= node.x) {
            if (node.L) node = node.L;
            else {
                before = node.P;
                break;
            }
        } else if (node.R) node = node.R;
        else {
            before = node;
            break;
        }
    }
    (0, $7NDp4.circles).insert(before, circle);
    if (!before) $eb0346d7101daa43$export$2ca650a30b282a37 = circle;
}
function $eb0346d7101daa43$export$f0bd50ff687673c1(arc) {
    var circle = arc.circle;
    if (circle) {
        if (!circle.P) $eb0346d7101daa43$export$2ca650a30b282a37 = circle.N;
        (0, $7NDp4.circles).remove(circle);
        $eb0346d7101daa43$var$circlePool.push(circle);
        (0, $iXUxb.RedBlackNode)(circle);
        arc.circle = null;
    }
}

});



parcelRegister("hpW0S", function(module, exports) {

var $cxIyV = parcelRequire("cxIyV");

var $hYSY7 = parcelRequire("hYSY7");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $cxIyV.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $hYSY7;
module.exports = isBuffer;

});
parcelRegister("cxIyV", function(module, exports) {

var $kL6qW = parcelRequire("kL6qW");
/** Detect free variable `self`. */ var $921b223d7ed8fe42$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $921b223d7ed8fe42$var$root = $kL6qW || $921b223d7ed8fe42$var$freeSelf || Function('return this')();
module.exports = $921b223d7ed8fe42$var$root;

});
parcelRegister("kL6qW", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $f1cd30049a9c6876$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $f1cd30049a9c6876$var$freeGlobal;

});


parcelRegister("hYSY7", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $d172ade26fd6fe34$var$stubFalse() {
    return false;
}
module.exports = $d172ade26fd6fe34$var$stubFalse;

});


parcelRegister("5KV2H", function(module, exports) {

var $kL6qW = parcelRequire("kL6qW");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $kL6qW.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("c6Pa8", function(module, exports) {

var $cxIyV = parcelRequire("cxIyV");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $cxIyV.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("dflA0", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $lNqgI = parcelRequire("lNqgI");
function $9a4d6a57aaaab11e$var$emptyFunction() {}
function $9a4d6a57aaaab11e$var$emptyFunctionWithReset() {}
$9a4d6a57aaaab11e$var$emptyFunctionWithReset.resetWarningCache = $9a4d6a57aaaab11e$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $lNqgI) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $9a4d6a57aaaab11e$var$emptyFunctionWithReset,
        resetWarningCache: $9a4d6a57aaaab11e$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("lNqgI", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $fde28cfe61c36500$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $fde28cfe61c36500$var$ReactPropTypesSecret;

});


parcelRegister("5cQSY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ca718c020a694de$export$2e2bcd8739ae039);

var $88ff1 = parcelRequire("88ff1");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $88ff1.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $3ca718c020a694de$export$2e2bcd8739ae039 = cloneBuffer;

});
parcelRegister("88ff1", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ebae4b62742c4c3$export$2e2bcd8739ae039);

var $5pNIB = parcelRequire("5pNIB");
/** Detect free variable `self`. */ var $5ebae4b62742c4c3$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $5ebae4b62742c4c3$var$root = (0, $5pNIB.default) || $5ebae4b62742c4c3$var$freeSelf || Function('return this')();
var $5ebae4b62742c4c3$export$2e2bcd8739ae039 = $5ebae4b62742c4c3$var$root;

});
parcelRegister("5pNIB", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f15da98c1e511c1$export$2e2bcd8739ae039);
/** Detect free variable `global` from Node.js. */ var $3f15da98c1e511c1$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $3f15da98c1e511c1$export$2e2bcd8739ae039 = $3f15da98c1e511c1$var$freeGlobal;

});



parcelRegister("kaMt5", function(module, exports) {

$parcel$export(module.exports, "default", () => $eafa569b1017bd1a$export$2e2bcd8739ae039);

var $88ff1 = parcelRequire("88ff1");

var $kzOpX = parcelRequire("kzOpX");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $88ff1.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $kzOpX.default);
var $eafa569b1017bd1a$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("kzOpX", function(module, exports) {

$parcel$export(module.exports, "default", () => $efae2f6c59100914$export$2e2bcd8739ae039);
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $efae2f6c59100914$var$stubFalse() {
    return false;
}
var $efae2f6c59100914$export$2e2bcd8739ae039 = $efae2f6c59100914$var$stubFalse;

});


parcelRegister("ecuFs", function(module, exports) {

$parcel$export(module.exports, "default", () => $a569f9a38feb46ab$export$2e2bcd8739ae039);

var $5pNIB = parcelRequire("5pNIB");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $5pNIB.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
var $a569f9a38feb46ab$export$2e2bcd8739ae039 = nodeUtil;

});

parcelRegister("7lP2n", function(module, exports) {

$parcel$export(module.exports, "handleFocus", () => handleFocus);

var $5E6i4 = parcelRequire("5E6i4");
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var handleFocus = function handleFocus(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
    return function(_React$Component) {
        _inherits(Focus, _React$Component);
        function Focus() {
            var _ref;
            var _temp, _this, _ret;
            _classCallCheck(this, Focus);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Focus.__proto__ || Object.getPrototypeOf(Focus)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                focus: false
            }, _this.handleFocus = function() {
                return _this.setState({
                    focus: true
                });
            }, _this.handleBlur = function() {
                return _this.setState({
                    focus: false
                });
            }, _temp), _possibleConstructorReturn(_this, _ret);
        }
        _createClass(Focus, [
            {
                key: 'render',
                value: function render() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement(Span, {
                        onFocus: this.handleFocus,
                        onBlur: this.handleBlur
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement(Component, _extends({}, this.props, this.state)));
                }
            }
        ]);
        return Focus;
    }((0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).Component);
};

});

parcelRegister("kaywu", function(module, exports) {

var $3bBKN = parcelRequire("3bBKN");

var $yomYX = parcelRequire("yomYX");

var $4hbJJ = parcelRequire("4hbJJ");

var $fSG8F = parcelRequire("fSG8F");
/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $eaef855d7cc3e7cd$var$forEach(collection, iteratee) {
    var func = $fSG8F(collection) ? $3bBKN : $yomYX;
    return func(collection, $4hbJJ(iteratee));
}
module.exports = $eaef855d7cc3e7cd$var$forEach;

});
parcelRegister("3bBKN", function(module, exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $251faf4afefe3e0d$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = $251faf4afefe3e0d$var$arrayEach;

});

parcelRegister("yomYX", function(module, exports) {

var $4inKO = parcelRequire("4inKO");

var $9cs60 = parcelRequire("9cs60");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $06761466b0bda781$var$baseEach = $9cs60($4inKO);
module.exports = $06761466b0bda781$var$baseEach;

});
parcelRegister("4inKO", function(module, exports) {

var $8TiJt = parcelRequire("8TiJt");

var $3LPLJ = parcelRequire("3LPLJ");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $320b44ea0283a589$var$baseForOwn(object, iteratee) {
    return object && $8TiJt(object, iteratee, $3LPLJ);
}
module.exports = $320b44ea0283a589$var$baseForOwn;

});
parcelRegister("8TiJt", function(module, exports) {

var $56yjh = parcelRequire("56yjh");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $6791fdaab5b32ddb$var$baseFor = $56yjh();
module.exports = $6791fdaab5b32ddb$var$baseFor;

});
parcelRegister("56yjh", function(module, exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $3b782086c336c127$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = $3b782086c336c127$var$createBaseFor;

});


parcelRegister("3LPLJ", function(module, exports) {

var $2WLt3 = parcelRequire("2WLt3");

var $heV7o = parcelRequire("heV7o");

var $5Yk3N = parcelRequire("5Yk3N");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $2bedeb1cb22e38d1$var$keys(object) {
    return $5Yk3N(object) ? $2WLt3(object) : $heV7o(object);
}
module.exports = $2bedeb1cb22e38d1$var$keys;

});
parcelRegister("2WLt3", function(module, exports) {

var $50Cvv = parcelRequire("50Cvv");

var $bTgvk = parcelRequire("bTgvk");

var $fSG8F = parcelRequire("fSG8F");

var $hpW0S = parcelRequire("hpW0S");

var $hK6dh = parcelRequire("hK6dh");

var $9PkbX = parcelRequire("9PkbX");
/** Used for built-in method references. */ var $2255d1a42ade86bc$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2255d1a42ade86bc$var$hasOwnProperty = $2255d1a42ade86bc$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $2255d1a42ade86bc$var$arrayLikeKeys(value, inherited) {
    var isArr = $fSG8F(value), isArg = !isArr && $bTgvk(value), isBuff = !isArr && !isArg && $hpW0S(value), isType = !isArr && !isArg && !isBuff && $9PkbX(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $50Cvv(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $2255d1a42ade86bc$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $hK6dh(key, length)))) result.push(key);
    return result;
}
module.exports = $2255d1a42ade86bc$var$arrayLikeKeys;

});
parcelRegister("50Cvv", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $3a5ad290ad844a45$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $3a5ad290ad844a45$var$baseTimes;

});

parcelRegister("bTgvk", function(module, exports) {

var $2UHOo = parcelRequire("2UHOo");

var $hemqo = parcelRequire("hemqo");
/** Used for built-in method references. */ var $8a81a2306849dc85$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8a81a2306849dc85$var$hasOwnProperty = $8a81a2306849dc85$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $8a81a2306849dc85$var$propertyIsEnumerable = $8a81a2306849dc85$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $8a81a2306849dc85$var$isArguments = $2UHOo(function() {
    return arguments;
}()) ? $2UHOo : function(value) {
    return $hemqo(value) && $8a81a2306849dc85$var$hasOwnProperty.call(value, 'callee') && !$8a81a2306849dc85$var$propertyIsEnumerable.call(value, 'callee');
};
module.exports = $8a81a2306849dc85$var$isArguments;

});
parcelRegister("2UHOo", function(module, exports) {

var $hxQbQ = parcelRequire("hxQbQ");

var $hemqo = parcelRequire("hemqo");
/** `Object#toString` result references. */ var $21f2cbd8a9aba82d$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $21f2cbd8a9aba82d$var$baseIsArguments(value) {
    return $hemqo(value) && $hxQbQ(value) == $21f2cbd8a9aba82d$var$argsTag;
}
module.exports = $21f2cbd8a9aba82d$var$baseIsArguments;

});
parcelRegister("hxQbQ", function(module, exports) {

var $cT2ec = parcelRequire("cT2ec");

var $43JSJ = parcelRequire("43JSJ");

var $fdPWK = parcelRequire("fdPWK");
/** `Object#toString` result references. */ var $cc5e0096d32f8a64$var$nullTag = '[object Null]', $cc5e0096d32f8a64$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $cc5e0096d32f8a64$var$symToStringTag = $cT2ec ? $cT2ec.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $cc5e0096d32f8a64$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $cc5e0096d32f8a64$var$undefinedTag : $cc5e0096d32f8a64$var$nullTag;
    return $cc5e0096d32f8a64$var$symToStringTag && $cc5e0096d32f8a64$var$symToStringTag in Object(value) ? $43JSJ(value) : $fdPWK(value);
}
module.exports = $cc5e0096d32f8a64$var$baseGetTag;

});
parcelRegister("cT2ec", function(module, exports) {

var $cxIyV = parcelRequire("cxIyV");
/** Built-in value references. */ var $961c598d61ba83ab$var$Symbol = $cxIyV.Symbol;
module.exports = $961c598d61ba83ab$var$Symbol;

});

parcelRegister("43JSJ", function(module, exports) {

var $cT2ec = parcelRequire("cT2ec");
/** Used for built-in method references. */ var $2f4b086bf14c486d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2f4b086bf14c486d$var$hasOwnProperty = $2f4b086bf14c486d$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $2f4b086bf14c486d$var$nativeObjectToString = $2f4b086bf14c486d$var$objectProto.toString;
/** Built-in value references. */ var $2f4b086bf14c486d$var$symToStringTag = $cT2ec ? $cT2ec.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $2f4b086bf14c486d$var$getRawTag(value) {
    var isOwn = $2f4b086bf14c486d$var$hasOwnProperty.call(value, $2f4b086bf14c486d$var$symToStringTag), tag = value[$2f4b086bf14c486d$var$symToStringTag];
    try {
        value[$2f4b086bf14c486d$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $2f4b086bf14c486d$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$2f4b086bf14c486d$var$symToStringTag] = tag;
        else delete value[$2f4b086bf14c486d$var$symToStringTag];
    }
    return result;
}
module.exports = $2f4b086bf14c486d$var$getRawTag;

});

parcelRegister("fdPWK", function(module, exports) {
/** Used for built-in method references. */ var $b1505d6960e736bb$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $b1505d6960e736bb$var$nativeObjectToString = $b1505d6960e736bb$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $b1505d6960e736bb$var$objectToString(value) {
    return $b1505d6960e736bb$var$nativeObjectToString.call(value);
}
module.exports = $b1505d6960e736bb$var$objectToString;

});


parcelRegister("hemqo", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $c8b523869c6a6e7f$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $c8b523869c6a6e7f$var$isObjectLike;

});



parcelRegister("fSG8F", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $b8fc960cc206670e$var$isArray = Array.isArray;
module.exports = $b8fc960cc206670e$var$isArray;

});

parcelRegister("hK6dh", function(module, exports) {
/** Used as references for various `Number` constants. */ var $ceab8d550fe588a3$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $ceab8d550fe588a3$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $ceab8d550fe588a3$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $ceab8d550fe588a3$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $ceab8d550fe588a3$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $ceab8d550fe588a3$var$isIndex;

});

parcelRegister("9PkbX", function(module, exports) {

var $ceJC8 = parcelRequire("ceJC8");

var $5QUe7 = parcelRequire("5QUe7");

var $5KV2H = parcelRequire("5KV2H");
/* Node.js helper references. */ var $72788a231cb7321a$var$nodeIsTypedArray = $5KV2H && $5KV2H.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $72788a231cb7321a$var$isTypedArray = $72788a231cb7321a$var$nodeIsTypedArray ? $5QUe7($72788a231cb7321a$var$nodeIsTypedArray) : $ceJC8;
module.exports = $72788a231cb7321a$var$isTypedArray;

});
parcelRegister("ceJC8", function(module, exports) {

var $hxQbQ = parcelRequire("hxQbQ");

var $4gWDz = parcelRequire("4gWDz");

var $hemqo = parcelRequire("hemqo");
/** `Object#toString` result references. */ var $024c8d1c5aafd0ae$var$argsTag = '[object Arguments]', $024c8d1c5aafd0ae$var$arrayTag = '[object Array]', $024c8d1c5aafd0ae$var$boolTag = '[object Boolean]', $024c8d1c5aafd0ae$var$dateTag = '[object Date]', $024c8d1c5aafd0ae$var$errorTag = '[object Error]', $024c8d1c5aafd0ae$var$funcTag = '[object Function]', $024c8d1c5aafd0ae$var$mapTag = '[object Map]', $024c8d1c5aafd0ae$var$numberTag = '[object Number]', $024c8d1c5aafd0ae$var$objectTag = '[object Object]', $024c8d1c5aafd0ae$var$regexpTag = '[object RegExp]', $024c8d1c5aafd0ae$var$setTag = '[object Set]', $024c8d1c5aafd0ae$var$stringTag = '[object String]', $024c8d1c5aafd0ae$var$weakMapTag = '[object WeakMap]';
var $024c8d1c5aafd0ae$var$arrayBufferTag = '[object ArrayBuffer]', $024c8d1c5aafd0ae$var$dataViewTag = '[object DataView]', $024c8d1c5aafd0ae$var$float32Tag = '[object Float32Array]', $024c8d1c5aafd0ae$var$float64Tag = '[object Float64Array]', $024c8d1c5aafd0ae$var$int8Tag = '[object Int8Array]', $024c8d1c5aafd0ae$var$int16Tag = '[object Int16Array]', $024c8d1c5aafd0ae$var$int32Tag = '[object Int32Array]', $024c8d1c5aafd0ae$var$uint8Tag = '[object Uint8Array]', $024c8d1c5aafd0ae$var$uint8ClampedTag = '[object Uint8ClampedArray]', $024c8d1c5aafd0ae$var$uint16Tag = '[object Uint16Array]', $024c8d1c5aafd0ae$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $024c8d1c5aafd0ae$var$typedArrayTags = {};
$024c8d1c5aafd0ae$var$typedArrayTags[$024c8d1c5aafd0ae$var$float32Tag] = $024c8d1c5aafd0ae$var$typedArrayTags[$024c8d1c5aafd0ae$var$float64Tag] = $024c8d1c5aafd0ae$var$typedArrayTags[$024c8d1c5aafd0ae$var$int8Tag] = $024c8d1c5aafd0ae$var$typedArrayTags[$024c8d1c5aafd0ae$var$int16Tag] = $024c8d1c5aafd0ae$var$typedArrayTags[$024c8d1c5aafd0ae$var$int32Tag] = $024c8d1c5aafd0ae$var$typedArrayTags[$024c8d1c5aafd0ae$var$uint8Tag] = $024c8d1c5aafd0ae$var$typedArrayTags[$024c8d1c5aafd0ae$var$uint8ClampedTag] = $024c8d1c5aafd0ae$var$typedArrayTags[$024c8d1c5aafd0ae$var$uint16Tag] = $024c8d1c5aafd0ae$var$typedArrayTags[$024c8d1c5aafd0ae$var$uint32Tag] = true;
$024c8d1c5aafd0ae$var$typedArrayTags[$024c8d1c5aafd0ae$var$argsTag] = $024c8d1c5aafd0ae$var$typedArrayTags[$024c8d1c5aafd0ae$var$arrayTag] = $024c8d1c5aafd0ae$var$typedArrayTags[$024c8d1c5aafd0ae$var$arrayBufferTag] = $024c8d1c5aafd0ae$var$typedArrayTags[$024c8d1c5aafd0ae$var$boolTag] = $024c8d1c5aafd0ae$var$typedArrayTags[$024c8d1c5aafd0ae$var$dataViewTag] = $024c8d1c5aafd0ae$var$typedArrayTags[$024c8d1c5aafd0ae$var$dateTag] = $024c8d1c5aafd0ae$var$typedArrayTags[$024c8d1c5aafd0ae$var$errorTag] = $024c8d1c5aafd0ae$var$typedArrayTags[$024c8d1c5aafd0ae$var$funcTag] = $024c8d1c5aafd0ae$var$typedArrayTags[$024c8d1c5aafd0ae$var$mapTag] = $024c8d1c5aafd0ae$var$typedArrayTags[$024c8d1c5aafd0ae$var$numberTag] = $024c8d1c5aafd0ae$var$typedArrayTags[$024c8d1c5aafd0ae$var$objectTag] = $024c8d1c5aafd0ae$var$typedArrayTags[$024c8d1c5aafd0ae$var$regexpTag] = $024c8d1c5aafd0ae$var$typedArrayTags[$024c8d1c5aafd0ae$var$setTag] = $024c8d1c5aafd0ae$var$typedArrayTags[$024c8d1c5aafd0ae$var$stringTag] = $024c8d1c5aafd0ae$var$typedArrayTags[$024c8d1c5aafd0ae$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $024c8d1c5aafd0ae$var$baseIsTypedArray(value) {
    return $hemqo(value) && $4gWDz(value.length) && !!$024c8d1c5aafd0ae$var$typedArrayTags[$hxQbQ(value)];
}
module.exports = $024c8d1c5aafd0ae$var$baseIsTypedArray;

});
parcelRegister("4gWDz", function(module, exports) {
/** Used as references for various `Number` constants. */ var $31c62433da92c28a$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $31c62433da92c28a$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $31c62433da92c28a$var$MAX_SAFE_INTEGER;
}
module.exports = $31c62433da92c28a$var$isLength;

});


parcelRegister("5QUe7", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $442d6c8a0cf7e258$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $442d6c8a0cf7e258$var$baseUnary;

});



parcelRegister("heV7o", function(module, exports) {

var $ag6Pp = parcelRequire("ag6Pp");

var $5LZPR = parcelRequire("5LZPR");
/** Used for built-in method references. */ var $c8d00cf462f01297$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c8d00cf462f01297$var$hasOwnProperty = $c8d00cf462f01297$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $c8d00cf462f01297$var$baseKeys(object) {
    if (!$ag6Pp(object)) return $5LZPR(object);
    var result = [];
    for(var key in Object(object))if ($c8d00cf462f01297$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
module.exports = $c8d00cf462f01297$var$baseKeys;

});
parcelRegister("ag6Pp", function(module, exports) {
/** Used for built-in method references. */ var $7780b1f2e24cf5f7$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $7780b1f2e24cf5f7$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $7780b1f2e24cf5f7$var$objectProto;
    return value === proto;
}
module.exports = $7780b1f2e24cf5f7$var$isPrototype;

});

parcelRegister("5LZPR", function(module, exports) {

var $lCxZh = parcelRequire("lCxZh");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $43414ec9d36eddff$var$nativeKeys = $lCxZh(Object.keys, Object);
module.exports = $43414ec9d36eddff$var$nativeKeys;

});
parcelRegister("lCxZh", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $fbd782c0757c624d$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $fbd782c0757c624d$var$overArg;

});



parcelRegister("5Yk3N", function(module, exports) {

var $8NZGN = parcelRequire("8NZGN");

var $4gWDz = parcelRequire("4gWDz");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $45921de7f7aa4adf$var$isArrayLike(value) {
    return value != null && $4gWDz(value.length) && !$8NZGN(value);
}
module.exports = $45921de7f7aa4adf$var$isArrayLike;

});
parcelRegister("8NZGN", function(module, exports) {

var $hxQbQ = parcelRequire("hxQbQ");

var $fFfYm = parcelRequire("fFfYm");
/** `Object#toString` result references. */ var $6692c08aa1c2a578$var$asyncTag = '[object AsyncFunction]', $6692c08aa1c2a578$var$funcTag = '[object Function]', $6692c08aa1c2a578$var$genTag = '[object GeneratorFunction]', $6692c08aa1c2a578$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $6692c08aa1c2a578$var$isFunction(value) {
    if (!$fFfYm(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $hxQbQ(value);
    return tag == $6692c08aa1c2a578$var$funcTag || tag == $6692c08aa1c2a578$var$genTag || tag == $6692c08aa1c2a578$var$asyncTag || tag == $6692c08aa1c2a578$var$proxyTag;
}
module.exports = $6692c08aa1c2a578$var$isFunction;

});
parcelRegister("fFfYm", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $b6771325a8b3c6e9$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = $b6771325a8b3c6e9$var$isObject;

});





parcelRegister("9cs60", function(module, exports) {

var $5Yk3N = parcelRequire("5Yk3N");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $6b2b074fbacc0bff$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$5Yk3N(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $6b2b074fbacc0bff$var$createBaseEach;

});


parcelRegister("4hbJJ", function(module, exports) {

var $hD1eO = parcelRequire("hD1eO");
/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $31d1da9ff0341a68$var$castFunction(value) {
    return typeof value == 'function' ? value : $hD1eO;
}
module.exports = $31d1da9ff0341a68$var$castFunction;

});
parcelRegister("hD1eO", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $cd570a05199552e9$var$identity(value) {
    return value;
}
module.exports = $cd570a05199552e9$var$identity;

});



parcelRegister("4CjQ4", function(module, exports) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.handleFocus = undefined;
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $5E6i4 = parcelRequire("5E6i4");
var _react2 = _interopRequireDefault($5E6i4);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint-disable no-invalid-this */ 
var handleFocus = exports.handleFocus = function handleFocus(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
    return function(_React$Component) {
        _inherits(Focus, _React$Component);
        function Focus() {
            var _ref;
            var _temp, _this, _ret;
            _classCallCheck(this, Focus);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Focus.__proto__ || Object.getPrototypeOf(Focus)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                focus: false
            }, _this.handleFocus = function() {
                return _this.setState({
                    focus: true
                });
            }, _this.handleBlur = function() {
                return _this.setState({
                    focus: false
                });
            }, _temp), _possibleConstructorReturn(_this, _ret);
        }
        _createClass(Focus, [
            {
                key: 'render',
                value: function render() {
                    return _react2.default.createElement(Span, {
                        onFocus: this.handleFocus,
                        onBlur: this.handleBlur
                    }, _react2.default.createElement(Component, _extends({}, this.props, this.state)));
                }
            }
        ]);
        return Focus;
    }(_react2.default.Component);
};

});

parcelRegister("9KgKE", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $7185676dc7ed1f58$var$R = typeof Reflect === 'object' ? Reflect : null;
var $7185676dc7ed1f58$var$ReflectApply = $7185676dc7ed1f58$var$R && typeof $7185676dc7ed1f58$var$R.apply === 'function' ? $7185676dc7ed1f58$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $7185676dc7ed1f58$var$ReflectOwnKeys;
if ($7185676dc7ed1f58$var$R && typeof $7185676dc7ed1f58$var$R.ownKeys === 'function') $7185676dc7ed1f58$var$ReflectOwnKeys = $7185676dc7ed1f58$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $7185676dc7ed1f58$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $7185676dc7ed1f58$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $7185676dc7ed1f58$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $7185676dc7ed1f58$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $7185676dc7ed1f58$var$EventEmitter() {
    $7185676dc7ed1f58$var$EventEmitter.init.call(this);
}
module.exports = $7185676dc7ed1f58$var$EventEmitter;
module.exports.once = $7185676dc7ed1f58$var$once;
// Backwards-compat with node 0.10.x
$7185676dc7ed1f58$var$EventEmitter.EventEmitter = $7185676dc7ed1f58$var$EventEmitter;
$7185676dc7ed1f58$var$EventEmitter.prototype._events = undefined;
$7185676dc7ed1f58$var$EventEmitter.prototype._eventsCount = 0;
$7185676dc7ed1f58$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $7185676dc7ed1f58$var$defaultMaxListeners = 10;
function $7185676dc7ed1f58$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($7185676dc7ed1f58$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $7185676dc7ed1f58$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $7185676dc7ed1f58$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $7185676dc7ed1f58$var$defaultMaxListeners = arg;
    }
});
$7185676dc7ed1f58$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$7185676dc7ed1f58$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $7185676dc7ed1f58$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $7185676dc7ed1f58$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $7185676dc7ed1f58$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$7185676dc7ed1f58$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $7185676dc7ed1f58$var$_getMaxListeners(this);
};
$7185676dc7ed1f58$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $7185676dc7ed1f58$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $7185676dc7ed1f58$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$7185676dc7ed1f58$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $7185676dc7ed1f58$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $7185676dc7ed1f58$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $7185676dc7ed1f58$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $7185676dc7ed1f58$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$7185676dc7ed1f58$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $7185676dc7ed1f58$var$_addListener(this, type, listener, false);
};
$7185676dc7ed1f58$var$EventEmitter.prototype.on = $7185676dc7ed1f58$var$EventEmitter.prototype.addListener;
$7185676dc7ed1f58$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $7185676dc7ed1f58$var$_addListener(this, type, listener, true);
};
function $7185676dc7ed1f58$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $7185676dc7ed1f58$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $7185676dc7ed1f58$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$7185676dc7ed1f58$var$EventEmitter.prototype.once = function once(type, listener) {
    $7185676dc7ed1f58$var$checkListener(listener);
    this.on(type, $7185676dc7ed1f58$var$_onceWrap(this, type, listener));
    return this;
};
$7185676dc7ed1f58$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $7185676dc7ed1f58$var$checkListener(listener);
    this.prependListener(type, $7185676dc7ed1f58$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$7185676dc7ed1f58$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $7185676dc7ed1f58$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $7185676dc7ed1f58$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$7185676dc7ed1f58$var$EventEmitter.prototype.off = $7185676dc7ed1f58$var$EventEmitter.prototype.removeListener;
$7185676dc7ed1f58$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $7185676dc7ed1f58$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $7185676dc7ed1f58$var$unwrapListeners(evlistener) : $7185676dc7ed1f58$var$arrayClone(evlistener, evlistener.length);
}
$7185676dc7ed1f58$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $7185676dc7ed1f58$var$_listeners(this, type, true);
};
$7185676dc7ed1f58$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $7185676dc7ed1f58$var$_listeners(this, type, false);
};
$7185676dc7ed1f58$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $7185676dc7ed1f58$var$listenerCount.call(emitter, type);
};
$7185676dc7ed1f58$var$EventEmitter.prototype.listenerCount = $7185676dc7ed1f58$var$listenerCount;
function $7185676dc7ed1f58$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$7185676dc7ed1f58$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $7185676dc7ed1f58$var$ReflectOwnKeys(this._events) : [];
};
function $7185676dc7ed1f58$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $7185676dc7ed1f58$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $7185676dc7ed1f58$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $7185676dc7ed1f58$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $7185676dc7ed1f58$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $7185676dc7ed1f58$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $7185676dc7ed1f58$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $7185676dc7ed1f58$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $7185676dc7ed1f58$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("9YOog", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("ljYrj", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $4Jj9n = parcelRequire("4Jj9n");
'use strict';
module.exports = $f85a4157ed2cb813$var$Readable;
/*<replacement>*/ var $f85a4157ed2cb813$var$Duplex;
/*</replacement>*/ $f85a4157ed2cb813$var$Readable.ReadableState = $f85a4157ed2cb813$var$ReadableState;

var $9KgKE = parcelRequire("9KgKE");
var $f85a4157ed2cb813$require$EE = $9KgKE.EventEmitter;
var $f85a4157ed2cb813$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $3OcAH = parcelRequire("3OcAH");

var $cbQCu = parcelRequire("cbQCu");
var $f85a4157ed2cb813$require$Buffer = $cbQCu.Buffer;
var $f85a4157ed2cb813$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $f85a4157ed2cb813$var$_uint8ArrayToBuffer(chunk) {
    return $f85a4157ed2cb813$require$Buffer.from(chunk);
}
function $f85a4157ed2cb813$var$_isUint8Array(obj) {
    return $f85a4157ed2cb813$require$Buffer.isBuffer(obj) || obj instanceof $f85a4157ed2cb813$var$OurUint8Array;
}

var $6Cym1 = parcelRequire("6Cym1");
var $f85a4157ed2cb813$var$debug;
if ($6Cym1 && $6Cym1.debuglog) $f85a4157ed2cb813$var$debug = $6Cym1.debuglog('stream');
else $f85a4157ed2cb813$var$debug = function debug() {};

var $dOyg8 = parcelRequire("dOyg8");

var $bEUDG = parcelRequire("bEUDG");

var $1NzB0 = parcelRequire("1NzB0");
var $f85a4157ed2cb813$var$getHighWaterMark = $1NzB0.getHighWaterMark;

var $aQfo6 = parcelRequire("aQfo6");
var $f85a4157ed2cb813$require$_require$codes = $aQfo6.codes;
var $f85a4157ed2cb813$var$ERR_INVALID_ARG_TYPE = $f85a4157ed2cb813$require$_require$codes.ERR_INVALID_ARG_TYPE, $f85a4157ed2cb813$var$ERR_STREAM_PUSH_AFTER_EOF = $f85a4157ed2cb813$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $f85a4157ed2cb813$var$ERR_METHOD_NOT_IMPLEMENTED = $f85a4157ed2cb813$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $f85a4157ed2cb813$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $f85a4157ed2cb813$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $f85a4157ed2cb813$var$StringDecoder;
var $f85a4157ed2cb813$var$createReadableStreamAsyncIterator;
var $f85a4157ed2cb813$var$from;

(parcelRequire("9YOog"))($f85a4157ed2cb813$var$Readable, $3OcAH);
var $f85a4157ed2cb813$var$errorOrDestroy = $bEUDG.errorOrDestroy;
var $f85a4157ed2cb813$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $f85a4157ed2cb813$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $f85a4157ed2cb813$var$ReadableState(options, stream, isDuplex) {
    $f85a4157ed2cb813$var$Duplex = $f85a4157ed2cb813$var$Duplex || (parcelRequire("5PuTj"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $f85a4157ed2cb813$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $f85a4157ed2cb813$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $dOyg8();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$f85a4157ed2cb813$var$StringDecoder) $f85a4157ed2cb813$var$StringDecoder = (parcelRequire("fr8tb")).StringDecoder;
        this.decoder = new $f85a4157ed2cb813$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $f85a4157ed2cb813$var$Readable(options) {
    $f85a4157ed2cb813$var$Duplex = $f85a4157ed2cb813$var$Duplex || (parcelRequire("5PuTj"));
    if (!(this instanceof $f85a4157ed2cb813$var$Readable)) return new $f85a4157ed2cb813$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $f85a4157ed2cb813$var$Duplex;
    this._readableState = new $f85a4157ed2cb813$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $3OcAH.call(this);
}
Object.defineProperty($f85a4157ed2cb813$var$Readable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$f85a4157ed2cb813$var$Readable.prototype.destroy = $bEUDG.destroy;
$f85a4157ed2cb813$var$Readable.prototype._undestroy = $bEUDG.undestroy;
$f85a4157ed2cb813$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$f85a4157ed2cb813$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $f85a4157ed2cb813$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $f85a4157ed2cb813$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$f85a4157ed2cb813$var$Readable.prototype.unshift = function(chunk) {
    return $f85a4157ed2cb813$var$readableAddChunk(this, chunk, null, true, false);
};
function $f85a4157ed2cb813$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $f85a4157ed2cb813$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $f85a4157ed2cb813$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $f85a4157ed2cb813$var$chunkInvalid(state, chunk);
        if (er) $f85a4157ed2cb813$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $f85a4157ed2cb813$require$Buffer.prototype) chunk = $f85a4157ed2cb813$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $f85a4157ed2cb813$var$errorOrDestroy(stream, new $f85a4157ed2cb813$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $f85a4157ed2cb813$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $f85a4157ed2cb813$var$errorOrDestroy(stream, new $f85a4157ed2cb813$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $f85a4157ed2cb813$var$addChunk(stream, state, chunk, false);
                    else $f85a4157ed2cb813$var$maybeReadMore(stream, state);
                } else $f85a4157ed2cb813$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $f85a4157ed2cb813$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $f85a4157ed2cb813$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit('data', chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $f85a4157ed2cb813$var$emitReadable(stream);
    }
    $f85a4157ed2cb813$var$maybeReadMore(stream, state);
}
function $f85a4157ed2cb813$var$chunkInvalid(state, chunk) {
    var er;
    if (!$f85a4157ed2cb813$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new $f85a4157ed2cb813$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer',
        'Uint8Array'
    ], chunk);
    return er;
}
$f85a4157ed2cb813$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$f85a4157ed2cb813$var$Readable.prototype.setEncoding = function(enc) {
    if (!$f85a4157ed2cb813$var$StringDecoder) $f85a4157ed2cb813$var$StringDecoder = (parcelRequire("fr8tb")).StringDecoder;
    var decoder = new $f85a4157ed2cb813$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = '';
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== '') this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $f85a4157ed2cb813$var$MAX_HWM = 0x40000000;
function $f85a4157ed2cb813$var$computeNewHighWaterMark(n) {
    if (n >= $f85a4157ed2cb813$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $f85a4157ed2cb813$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $f85a4157ed2cb813$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $f85a4157ed2cb813$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$f85a4157ed2cb813$var$Readable.prototype.read = function(n) {
    $f85a4157ed2cb813$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $f85a4157ed2cb813$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $f85a4157ed2cb813$var$endReadable(this);
        else $f85a4157ed2cb813$var$emitReadable(this);
        return null;
    }
    n = $f85a4157ed2cb813$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $f85a4157ed2cb813$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $f85a4157ed2cb813$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $f85a4157ed2cb813$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $f85a4157ed2cb813$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $f85a4157ed2cb813$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $f85a4157ed2cb813$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $f85a4157ed2cb813$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $f85a4157ed2cb813$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $f85a4157ed2cb813$var$onEofChunk(stream, state) {
    $f85a4157ed2cb813$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $f85a4157ed2cb813$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $f85a4157ed2cb813$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $f85a4157ed2cb813$var$emitReadable(stream) {
    var state = stream._readableState;
    $f85a4157ed2cb813$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $f85a4157ed2cb813$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $4Jj9n.nextTick($f85a4157ed2cb813$var$emitReadable_, stream);
    }
}
function $f85a4157ed2cb813$var$emitReadable_(stream) {
    var state = stream._readableState;
    $f85a4157ed2cb813$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $f85a4157ed2cb813$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $f85a4157ed2cb813$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $4Jj9n.nextTick($f85a4157ed2cb813$var$maybeReadMore_, stream, state);
    }
}
function $f85a4157ed2cb813$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $f85a4157ed2cb813$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$f85a4157ed2cb813$var$Readable.prototype._read = function(n) {
    $f85a4157ed2cb813$var$errorOrDestroy(this, new $f85a4157ed2cb813$var$ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
$f85a4157ed2cb813$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $f85a4157ed2cb813$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $4Jj9n.stdout && dest !== $4Jj9n.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $4Jj9n.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $f85a4157ed2cb813$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $f85a4157ed2cb813$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $f85a4157ed2cb813$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $f85a4157ed2cb813$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $f85a4157ed2cb813$var$debug('ondata');
        var ret = dest.write(chunk);
        $f85a4157ed2cb813$var$debug('dest.write', ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $f85a4157ed2cb813$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $f85a4157ed2cb813$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $f85a4157ed2cb813$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($f85a4157ed2cb813$var$EElistenerCount(dest, 'error') === 0) $f85a4157ed2cb813$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $f85a4157ed2cb813$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $f85a4157ed2cb813$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $f85a4157ed2cb813$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $f85a4157ed2cb813$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $f85a4157ed2cb813$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $f85a4157ed2cb813$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $f85a4157ed2cb813$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $f85a4157ed2cb813$var$flow(src);
        }
    };
}
$f85a4157ed2cb813$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $f85a4157ed2cb813$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$f85a4157ed2cb813$var$Readable.prototype.on = function(ev, fn) {
    var res = $3OcAH.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $f85a4157ed2cb813$var$debug('on readable', state.length, state.reading);
            if (state.length) $f85a4157ed2cb813$var$emitReadable(this);
            else if (!state.reading) $4Jj9n.nextTick($f85a4157ed2cb813$var$nReadingNextTick, this);
        }
    }
    return res;
};
$f85a4157ed2cb813$var$Readable.prototype.addListener = $f85a4157ed2cb813$var$Readable.prototype.on;
$f85a4157ed2cb813$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $3OcAH.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $4Jj9n.nextTick($f85a4157ed2cb813$var$updateReadableListening, this);
    return res;
};
$f85a4157ed2cb813$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $3OcAH.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $4Jj9n.nextTick($f85a4157ed2cb813$var$updateReadableListening, this);
    return res;
};
function $f85a4157ed2cb813$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount('readable') > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount('data') > 0) self1.resume();
}
function $f85a4157ed2cb813$var$nReadingNextTick(self1) {
    $f85a4157ed2cb813$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$f85a4157ed2cb813$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $f85a4157ed2cb813$var$debug('resume');
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $f85a4157ed2cb813$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $f85a4157ed2cb813$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $4Jj9n.nextTick($f85a4157ed2cb813$var$resume_, stream, state);
    }
}
function $f85a4157ed2cb813$var$resume_(stream, state) {
    $f85a4157ed2cb813$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $f85a4157ed2cb813$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$f85a4157ed2cb813$var$Readable.prototype.pause = function() {
    $f85a4157ed2cb813$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $f85a4157ed2cb813$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState.paused = true;
    return this;
};
function $f85a4157ed2cb813$var$flow(stream) {
    var state = stream._readableState;
    $f85a4157ed2cb813$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$f85a4157ed2cb813$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $f85a4157ed2cb813$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $f85a4157ed2cb813$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $f85a4157ed2cb813$var$kProxyEvents.length; n++)stream.on($f85a4157ed2cb813$var$kProxyEvents[n], this.emit.bind(this, $f85a4157ed2cb813$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $f85a4157ed2cb813$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === 'function') $f85a4157ed2cb813$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($f85a4157ed2cb813$var$createReadableStreamAsyncIterator === undefined) $f85a4157ed2cb813$var$createReadableStreamAsyncIterator = (parcelRequire("g3g84"));
    return $f85a4157ed2cb813$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($f85a4157ed2cb813$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($f85a4157ed2cb813$var$Readable.prototype, 'readableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($f85a4157ed2cb813$var$Readable.prototype, 'readableFlowing', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$f85a4157ed2cb813$var$Readable._fromList = $f85a4157ed2cb813$var$fromList;
Object.defineProperty($f85a4157ed2cb813$var$Readable.prototype, 'readableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $f85a4157ed2cb813$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $f85a4157ed2cb813$var$endReadable(stream) {
    var state = stream._readableState;
    $f85a4157ed2cb813$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $4Jj9n.nextTick($f85a4157ed2cb813$var$endReadableNT, state, stream);
    }
}
function $f85a4157ed2cb813$var$endReadableNT(state, stream) {
    $f85a4157ed2cb813$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === 'function') $f85a4157ed2cb813$var$Readable.from = function(iterable, opts) {
    if ($f85a4157ed2cb813$var$from === undefined) $f85a4157ed2cb813$var$from = (parcelRequire("fOGyj"));
    return $f85a4157ed2cb813$var$from($f85a4157ed2cb813$var$Readable, iterable, opts);
};
function $f85a4157ed2cb813$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("4Jj9n", function(module, exports) {
// shim for using process in browser
var $371a3837fd81d701$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $371a3837fd81d701$var$cachedSetTimeout;
var $371a3837fd81d701$var$cachedClearTimeout;
function $371a3837fd81d701$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $371a3837fd81d701$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $371a3837fd81d701$var$cachedSetTimeout = setTimeout;
        else $371a3837fd81d701$var$cachedSetTimeout = $371a3837fd81d701$var$defaultSetTimout;
    } catch (e) {
        $371a3837fd81d701$var$cachedSetTimeout = $371a3837fd81d701$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $371a3837fd81d701$var$cachedClearTimeout = clearTimeout;
        else $371a3837fd81d701$var$cachedClearTimeout = $371a3837fd81d701$var$defaultClearTimeout;
    } catch (e) {
        $371a3837fd81d701$var$cachedClearTimeout = $371a3837fd81d701$var$defaultClearTimeout;
    }
})();
function $371a3837fd81d701$var$runTimeout(fun) {
    if ($371a3837fd81d701$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($371a3837fd81d701$var$cachedSetTimeout === $371a3837fd81d701$var$defaultSetTimout || !$371a3837fd81d701$var$cachedSetTimeout) && setTimeout) {
        $371a3837fd81d701$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $371a3837fd81d701$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $371a3837fd81d701$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $371a3837fd81d701$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $371a3837fd81d701$var$runClearTimeout(marker) {
    if ($371a3837fd81d701$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($371a3837fd81d701$var$cachedClearTimeout === $371a3837fd81d701$var$defaultClearTimeout || !$371a3837fd81d701$var$cachedClearTimeout) && clearTimeout) {
        $371a3837fd81d701$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $371a3837fd81d701$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $371a3837fd81d701$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $371a3837fd81d701$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $371a3837fd81d701$var$queue = [];
var $371a3837fd81d701$var$draining = false;
var $371a3837fd81d701$var$currentQueue;
var $371a3837fd81d701$var$queueIndex = -1;
function $371a3837fd81d701$var$cleanUpNextTick() {
    if (!$371a3837fd81d701$var$draining || !$371a3837fd81d701$var$currentQueue) return;
    $371a3837fd81d701$var$draining = false;
    if ($371a3837fd81d701$var$currentQueue.length) $371a3837fd81d701$var$queue = $371a3837fd81d701$var$currentQueue.concat($371a3837fd81d701$var$queue);
    else $371a3837fd81d701$var$queueIndex = -1;
    if ($371a3837fd81d701$var$queue.length) $371a3837fd81d701$var$drainQueue();
}
function $371a3837fd81d701$var$drainQueue() {
    if ($371a3837fd81d701$var$draining) return;
    var timeout = $371a3837fd81d701$var$runTimeout($371a3837fd81d701$var$cleanUpNextTick);
    $371a3837fd81d701$var$draining = true;
    var len = $371a3837fd81d701$var$queue.length;
    while(len){
        $371a3837fd81d701$var$currentQueue = $371a3837fd81d701$var$queue;
        $371a3837fd81d701$var$queue = [];
        while(++$371a3837fd81d701$var$queueIndex < len)if ($371a3837fd81d701$var$currentQueue) $371a3837fd81d701$var$currentQueue[$371a3837fd81d701$var$queueIndex].run();
        $371a3837fd81d701$var$queueIndex = -1;
        len = $371a3837fd81d701$var$queue.length;
    }
    $371a3837fd81d701$var$currentQueue = null;
    $371a3837fd81d701$var$draining = false;
    $371a3837fd81d701$var$runClearTimeout(timeout);
}
$371a3837fd81d701$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $371a3837fd81d701$var$queue.push(new $371a3837fd81d701$var$Item(fun, args));
    if ($371a3837fd81d701$var$queue.length === 1 && !$371a3837fd81d701$var$draining) $371a3837fd81d701$var$runTimeout($371a3837fd81d701$var$drainQueue);
};
// v8 likes predictible objects
function $371a3837fd81d701$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$371a3837fd81d701$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$371a3837fd81d701$var$process.title = 'browser';
$371a3837fd81d701$var$process.browser = true;
$371a3837fd81d701$var$process.env = {};
$371a3837fd81d701$var$process.argv = [];
$371a3837fd81d701$var$process.version = ''; // empty string to avoid regexp issues
$371a3837fd81d701$var$process.versions = {};
function $371a3837fd81d701$var$noop() {}
$371a3837fd81d701$var$process.on = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.addListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.once = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.off = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.removeListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.removeAllListeners = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.emit = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.prependListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.prependOnceListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.listeners = function(name) {
    return [];
};
$371a3837fd81d701$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$371a3837fd81d701$var$process.cwd = function() {
    return '/';
};
$371a3837fd81d701$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$371a3837fd81d701$var$process.umask = function() {
    return 0;
};

});

parcelRegister("3OcAH", function(module, exports) {

module.exports = (parcelRequire("9KgKE")).EventEmitter;

});

parcelRegister("cbQCu", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $8dff54558831dec9$export$a143d493d941bafc, (v) => $8dff54558831dec9$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $8dff54558831dec9$export$e4cf37d7f6fb9e0a, (v) => $8dff54558831dec9$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $8dff54558831dec9$export$f99ded8fe4b79145, (v) => $8dff54558831dec9$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $8dff54558831dec9$export$599f31c3813fae4d, (v) => $8dff54558831dec9$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $8dff54558831dec9$export$a143d493d941bafc;
var $8dff54558831dec9$export$e4cf37d7f6fb9e0a;
var $8dff54558831dec9$export$f99ded8fe4b79145;
var $8dff54558831dec9$export$599f31c3813fae4d;
'use strict';

var $6ocIT = parcelRequire("6ocIT");

var $1wLos = parcelRequire("1wLos");
const $8dff54558831dec9$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$8dff54558831dec9$export$a143d493d941bafc = $8dff54558831dec9$var$Buffer;
$8dff54558831dec9$export$e4cf37d7f6fb9e0a = $8dff54558831dec9$var$SlowBuffer;
$8dff54558831dec9$export$f99ded8fe4b79145 = 50;
const $8dff54558831dec9$var$K_MAX_LENGTH = 0x7fffffff;
$8dff54558831dec9$export$599f31c3813fae4d = $8dff54558831dec9$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $8dff54558831dec9$var$Buffer.TYPED_ARRAY_SUPPORT = $8dff54558831dec9$var$typedArraySupport();
if (!$8dff54558831dec9$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $8dff54558831dec9$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($8dff54558831dec9$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$8dff54558831dec9$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($8dff54558831dec9$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$8dff54558831dec9$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $8dff54558831dec9$var$createBuffer(length) {
    if (length > $8dff54558831dec9$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $8dff54558831dec9$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $8dff54558831dec9$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $8dff54558831dec9$var$allocUnsafe(arg);
    }
    return $8dff54558831dec9$var$from(arg, encodingOrOffset, length);
}
$8dff54558831dec9$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $8dff54558831dec9$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $8dff54558831dec9$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $8dff54558831dec9$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($8dff54558831dec9$var$isInstance(value, ArrayBuffer) || value && $8dff54558831dec9$var$isInstance(value.buffer, ArrayBuffer)) return $8dff54558831dec9$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($8dff54558831dec9$var$isInstance(value, SharedArrayBuffer) || value && $8dff54558831dec9$var$isInstance(value.buffer, SharedArrayBuffer))) return $8dff54558831dec9$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $8dff54558831dec9$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $8dff54558831dec9$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $8dff54558831dec9$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $8dff54558831dec9$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $8dff54558831dec9$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($8dff54558831dec9$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($8dff54558831dec9$var$Buffer, Uint8Array);
function $8dff54558831dec9$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $8dff54558831dec9$var$alloc(size, fill, encoding) {
    $8dff54558831dec9$var$assertSize(size);
    if (size <= 0) return $8dff54558831dec9$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $8dff54558831dec9$var$createBuffer(size).fill(fill, encoding) : $8dff54558831dec9$var$createBuffer(size).fill(fill);
    return $8dff54558831dec9$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $8dff54558831dec9$var$Buffer.alloc = function(size, fill, encoding) {
    return $8dff54558831dec9$var$alloc(size, fill, encoding);
};
function $8dff54558831dec9$var$allocUnsafe(size) {
    $8dff54558831dec9$var$assertSize(size);
    return $8dff54558831dec9$var$createBuffer(size < 0 ? 0 : $8dff54558831dec9$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $8dff54558831dec9$var$Buffer.allocUnsafe = function(size) {
    return $8dff54558831dec9$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $8dff54558831dec9$var$Buffer.allocUnsafeSlow = function(size) {
    return $8dff54558831dec9$var$allocUnsafe(size);
};
function $8dff54558831dec9$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$8dff54558831dec9$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $8dff54558831dec9$var$byteLength(string, encoding) | 0;
    let buf = $8dff54558831dec9$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $8dff54558831dec9$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $8dff54558831dec9$var$checked(array.length) | 0;
    const buf = $8dff54558831dec9$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $8dff54558831dec9$var$fromArrayView(arrayView) {
    if ($8dff54558831dec9$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $8dff54558831dec9$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $8dff54558831dec9$var$fromArrayLike(arrayView);
}
function $8dff54558831dec9$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $8dff54558831dec9$var$Buffer.prototype);
    return buf;
}
function $8dff54558831dec9$var$fromObject(obj) {
    if ($8dff54558831dec9$var$Buffer.isBuffer(obj)) {
        const len = $8dff54558831dec9$var$checked(obj.length) | 0;
        const buf = $8dff54558831dec9$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $8dff54558831dec9$var$numberIsNaN(obj.length)) return $8dff54558831dec9$var$createBuffer(0);
        return $8dff54558831dec9$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $8dff54558831dec9$var$fromArrayLike(obj.data);
}
function $8dff54558831dec9$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $8dff54558831dec9$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $8dff54558831dec9$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $8dff54558831dec9$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $8dff54558831dec9$var$Buffer.alloc(+length);
}
$8dff54558831dec9$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $8dff54558831dec9$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$8dff54558831dec9$var$Buffer.compare = function compare(a, b) {
    if ($8dff54558831dec9$var$isInstance(a, Uint8Array)) a = $8dff54558831dec9$var$Buffer.from(a, a.offset, a.byteLength);
    if ($8dff54558831dec9$var$isInstance(b, Uint8Array)) b = $8dff54558831dec9$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$8dff54558831dec9$var$Buffer.isBuffer(a) || !$8dff54558831dec9$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$8dff54558831dec9$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$8dff54558831dec9$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $8dff54558831dec9$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $8dff54558831dec9$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($8dff54558831dec9$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$8dff54558831dec9$var$Buffer.isBuffer(buf)) buf = $8dff54558831dec9$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$8dff54558831dec9$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $8dff54558831dec9$var$byteLength(string, encoding) {
    if ($8dff54558831dec9$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $8dff54558831dec9$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $8dff54558831dec9$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $8dff54558831dec9$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $8dff54558831dec9$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$8dff54558831dec9$var$Buffer.byteLength = $8dff54558831dec9$var$byteLength;
function $8dff54558831dec9$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $8dff54558831dec9$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $8dff54558831dec9$var$utf8Slice(this, start, end);
        case 'ascii':
            return $8dff54558831dec9$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $8dff54558831dec9$var$latin1Slice(this, start, end);
        case 'base64':
            return $8dff54558831dec9$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $8dff54558831dec9$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$8dff54558831dec9$var$Buffer.prototype._isBuffer = true;
function $8dff54558831dec9$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$8dff54558831dec9$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$8dff54558831dec9$var$swap(this, i, i + 1);
    return this;
};
$8dff54558831dec9$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $8dff54558831dec9$var$swap(this, i, i + 3);
        $8dff54558831dec9$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$8dff54558831dec9$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $8dff54558831dec9$var$swap(this, i, i + 7);
        $8dff54558831dec9$var$swap(this, i + 1, i + 6);
        $8dff54558831dec9$var$swap(this, i + 2, i + 5);
        $8dff54558831dec9$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$8dff54558831dec9$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $8dff54558831dec9$var$utf8Slice(this, 0, length);
    return $8dff54558831dec9$var$slowToString.apply(this, arguments);
};
$8dff54558831dec9$var$Buffer.prototype.toLocaleString = $8dff54558831dec9$var$Buffer.prototype.toString;
$8dff54558831dec9$var$Buffer.prototype.equals = function equals(b) {
    if (!$8dff54558831dec9$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $8dff54558831dec9$var$Buffer.compare(this, b) === 0;
};
$8dff54558831dec9$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $8dff54558831dec9$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($8dff54558831dec9$var$customInspectSymbol) $8dff54558831dec9$var$Buffer.prototype[$8dff54558831dec9$var$customInspectSymbol] = $8dff54558831dec9$var$Buffer.prototype.inspect;
$8dff54558831dec9$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($8dff54558831dec9$var$isInstance(target, Uint8Array)) target = $8dff54558831dec9$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$8dff54558831dec9$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $8dff54558831dec9$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($8dff54558831dec9$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $8dff54558831dec9$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($8dff54558831dec9$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $8dff54558831dec9$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $8dff54558831dec9$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $8dff54558831dec9$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$8dff54558831dec9$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$8dff54558831dec9$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $8dff54558831dec9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$8dff54558831dec9$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $8dff54558831dec9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $8dff54558831dec9$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($8dff54558831dec9$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $8dff54558831dec9$var$utf8Write(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $8dff54558831dec9$var$asciiWrite(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$asciiToBytes(string), buf, offset, length);
}
function $8dff54558831dec9$var$base64Write(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$base64ToBytes(string), buf, offset, length);
}
function $8dff54558831dec9$var$ucs2Write(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$8dff54558831dec9$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $8dff54558831dec9$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $8dff54558831dec9$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $8dff54558831dec9$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $8dff54558831dec9$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $8dff54558831dec9$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$8dff54558831dec9$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $8dff54558831dec9$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $6ocIT.fromByteArray(buf);
    else return $6ocIT.fromByteArray(buf.slice(start, end));
}
function $8dff54558831dec9$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $8dff54558831dec9$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $8dff54558831dec9$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $8dff54558831dec9$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $8dff54558831dec9$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $8dff54558831dec9$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $8dff54558831dec9$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $8dff54558831dec9$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $8dff54558831dec9$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $8dff54558831dec9$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $8dff54558831dec9$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$8dff54558831dec9$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $8dff54558831dec9$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $8dff54558831dec9$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$8dff54558831dec9$var$Buffer.prototype.readUintLE = $8dff54558831dec9$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readUintBE = $8dff54558831dec9$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readUint8 = $8dff54558831dec9$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$8dff54558831dec9$var$Buffer.prototype.readUint16LE = $8dff54558831dec9$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$8dff54558831dec9$var$Buffer.prototype.readUint16BE = $8dff54558831dec9$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$8dff54558831dec9$var$Buffer.prototype.readUint32LE = $8dff54558831dec9$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$8dff54558831dec9$var$Buffer.prototype.readUint32BE = $8dff54558831dec9$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$8dff54558831dec9$var$Buffer.prototype.readBigUInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$8dff54558831dec9$var$Buffer.prototype.readBigUInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$8dff54558831dec9$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$8dff54558831dec9$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$8dff54558831dec9$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$8dff54558831dec9$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$8dff54558831dec9$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$8dff54558831dec9$var$Buffer.prototype.readBigInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$8dff54558831dec9$var$Buffer.prototype.readBigInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$8dff54558831dec9$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return $1wLos.read(this, offset, true, 23, 4);
};
$8dff54558831dec9$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return $1wLos.read(this, offset, false, 23, 4);
};
$8dff54558831dec9$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 8, this.length);
    return $1wLos.read(this, offset, true, 52, 8);
};
$8dff54558831dec9$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 8, this.length);
    return $1wLos.read(this, offset, false, 52, 8);
};
function $8dff54558831dec9$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$8dff54558831dec9$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$8dff54558831dec9$var$Buffer.prototype.writeUintLE = $8dff54558831dec9$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeUintBE = $8dff54558831dec9$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint8 = $8dff54558831dec9$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint16LE = $8dff54558831dec9$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint16BE = $8dff54558831dec9$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint32LE = $8dff54558831dec9$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint32BE = $8dff54558831dec9$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $8dff54558831dec9$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $8dff54558831dec9$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $8dff54558831dec9$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $8dff54558831dec9$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$8dff54558831dec9$var$Buffer.prototype.writeBigUInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$8dff54558831dec9$var$Buffer.prototype.writeBigUInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$8dff54558831dec9$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$8dff54558831dec9$var$Buffer.prototype.writeBigInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$8dff54558831dec9$var$Buffer.prototype.writeBigInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $8dff54558831dec9$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $8dff54558831dec9$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $1wLos.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$8dff54558831dec9$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeFloat(this, value, offset, true, noAssert);
};
$8dff54558831dec9$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeFloat(this, value, offset, false, noAssert);
};
function $8dff54558831dec9$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $1wLos.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$8dff54558831dec9$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeDouble(this, value, offset, true, noAssert);
};
$8dff54558831dec9$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$8dff54558831dec9$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$8dff54558831dec9$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$8dff54558831dec9$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$8dff54558831dec9$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $8dff54558831dec9$var$Buffer.isBuffer(val) ? val : $8dff54558831dec9$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $8dff54558831dec9$var$errors = {};
function $8dff54558831dec9$var$E(sym, getMessage, Base) {
    $8dff54558831dec9$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$8dff54558831dec9$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$8dff54558831dec9$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$8dff54558831dec9$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $8dff54558831dec9$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $8dff54558831dec9$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $8dff54558831dec9$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $8dff54558831dec9$var$checkBounds(buf, offset, byteLength) {
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $8dff54558831dec9$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $8dff54558831dec9$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $8dff54558831dec9$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $8dff54558831dec9$var$checkBounds(buf, offset, byteLength);
}
function $8dff54558831dec9$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $8dff54558831dec9$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $8dff54558831dec9$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $8dff54558831dec9$var$validateNumber(value, type);
        throw new $8dff54558831dec9$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $8dff54558831dec9$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $8dff54558831dec9$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $8dff54558831dec9$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $8dff54558831dec9$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($8dff54558831dec9$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $8dff54558831dec9$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $8dff54558831dec9$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $8dff54558831dec9$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $8dff54558831dec9$var$base64ToBytes(str) {
    return $6ocIT.toByteArray($8dff54558831dec9$var$base64clean(str));
}
function $8dff54558831dec9$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $8dff54558831dec9$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $8dff54558831dec9$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $8dff54558831dec9$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $8dff54558831dec9$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $8dff54558831dec9$var$BufferBigIntNotDefined : fn;
}
function $8dff54558831dec9$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("6ocIT", function(module, exports) {

$parcel$export(module.exports, "byteLength", () => $4a6eda7d0e4e0857$export$a48f0734ac7c2329, (v) => $4a6eda7d0e4e0857$export$a48f0734ac7c2329 = v);
$parcel$export(module.exports, "toByteArray", () => $4a6eda7d0e4e0857$export$d622b2ad8d90c771, (v) => $4a6eda7d0e4e0857$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $4a6eda7d0e4e0857$export$6100ba28696e12de, (v) => $4a6eda7d0e4e0857$export$6100ba28696e12de = v);
var $4a6eda7d0e4e0857$export$a48f0734ac7c2329;
var $4a6eda7d0e4e0857$export$d622b2ad8d90c771;
var $4a6eda7d0e4e0857$export$6100ba28696e12de;
'use strict';
$4a6eda7d0e4e0857$export$a48f0734ac7c2329 = $4a6eda7d0e4e0857$var$byteLength;
$4a6eda7d0e4e0857$export$d622b2ad8d90c771 = $4a6eda7d0e4e0857$var$toByteArray;
$4a6eda7d0e4e0857$export$6100ba28696e12de = $4a6eda7d0e4e0857$var$fromByteArray;
var $4a6eda7d0e4e0857$var$lookup = [];
var $4a6eda7d0e4e0857$var$revLookup = [];
var $4a6eda7d0e4e0857$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $4a6eda7d0e4e0857$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $4a6eda7d0e4e0857$var$i = 0, $4a6eda7d0e4e0857$var$len = $4a6eda7d0e4e0857$var$code.length; $4a6eda7d0e4e0857$var$i < $4a6eda7d0e4e0857$var$len; ++$4a6eda7d0e4e0857$var$i){
    $4a6eda7d0e4e0857$var$lookup[$4a6eda7d0e4e0857$var$i] = $4a6eda7d0e4e0857$var$code[$4a6eda7d0e4e0857$var$i];
    $4a6eda7d0e4e0857$var$revLookup[$4a6eda7d0e4e0857$var$code.charCodeAt($4a6eda7d0e4e0857$var$i)] = $4a6eda7d0e4e0857$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$4a6eda7d0e4e0857$var$revLookup['-'.charCodeAt(0)] = 62;
$4a6eda7d0e4e0857$var$revLookup['_'.charCodeAt(0)] = 63;
function $4a6eda7d0e4e0857$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $4a6eda7d0e4e0857$var$byteLength(b64) {
    var lens = $4a6eda7d0e4e0857$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $4a6eda7d0e4e0857$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $4a6eda7d0e4e0857$var$toByteArray(b64) {
    var tmp;
    var lens = $4a6eda7d0e4e0857$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $4a6eda7d0e4e0857$var$Arr($4a6eda7d0e4e0857$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 18 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 2 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 10 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $4a6eda7d0e4e0857$var$tripletToBase64(num) {
    return $4a6eda7d0e4e0857$var$lookup[num >> 18 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num >> 12 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num >> 6 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num & 0x3F];
}
function $4a6eda7d0e4e0857$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($4a6eda7d0e4e0857$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $4a6eda7d0e4e0857$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($4a6eda7d0e4e0857$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($4a6eda7d0e4e0857$var$lookup[tmp >> 2] + $4a6eda7d0e4e0857$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($4a6eda7d0e4e0857$var$lookup[tmp >> 10] + $4a6eda7d0e4e0857$var$lookup[tmp >> 4 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("1wLos", function(module, exports) {

$parcel$export(module.exports, "read", () => $11cd8afb6c84e33a$export$aafa59e2e03f2942, (v) => $11cd8afb6c84e33a$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $11cd8afb6c84e33a$export$68d8715fc104d294, (v) => $11cd8afb6c84e33a$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $11cd8afb6c84e33a$export$aafa59e2e03f2942;
var $11cd8afb6c84e33a$export$68d8715fc104d294;
$11cd8afb6c84e33a$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$11cd8afb6c84e33a$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("6Cym1", function(module, exports) {
"use strict";

});

parcelRegister("dOyg8", function(module, exports) {
'use strict';
function $a0ea850bae912876$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a0ea850bae912876$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a0ea850bae912876$var$ownKeys(Object(source), !0).forEach(function(key) {
            $a0ea850bae912876$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a0ea850bae912876$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a0ea850bae912876$var$_defineProperty(obj, key, value) {
    key = $a0ea850bae912876$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a0ea850bae912876$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a0ea850bae912876$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $a0ea850bae912876$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $a0ea850bae912876$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a0ea850bae912876$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a0ea850bae912876$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $a0ea850bae912876$var$_toPropertyKey(arg) {
    var key = $a0ea850bae912876$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $a0ea850bae912876$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $cbQCu = parcelRequire("cbQCu");
var $a0ea850bae912876$var$Buffer = $cbQCu.Buffer;

var $6Cym1 = parcelRequire("6Cym1");
var $a0ea850bae912876$var$inspect = $6Cym1.inspect;
var $a0ea850bae912876$var$custom = $a0ea850bae912876$var$inspect && $a0ea850bae912876$var$inspect.custom || 'inspect';
function $a0ea850bae912876$var$copyBuffer(src, target, offset) {
    $a0ea850bae912876$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $a0ea850bae912876$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $a0ea850bae912876$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $a0ea850bae912876$var$Buffer.alloc(0);
                var ret = $a0ea850bae912876$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $a0ea850bae912876$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $a0ea850bae912876$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $a0ea850bae912876$var$custom,
            value: function value(_, options) {
                return $a0ea850bae912876$var$inspect(this, $a0ea850bae912876$var$_objectSpread($a0ea850bae912876$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("bEUDG", function(module, exports) {

var $4Jj9n = parcelRequire("4Jj9n");
'use strict';
// undocumented cb() API, needed for core, not for public API
function $87cf5d73f27e2302$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $4Jj9n.nextTick($87cf5d73f27e2302$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $4Jj9n.nextTick($87cf5d73f27e2302$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $4Jj9n.nextTick($87cf5d73f27e2302$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $4Jj9n.nextTick($87cf5d73f27e2302$var$emitErrorAndCloseNT, _this, err);
            } else $4Jj9n.nextTick($87cf5d73f27e2302$var$emitCloseNT, _this);
        } else if (cb) {
            $4Jj9n.nextTick($87cf5d73f27e2302$var$emitCloseNT, _this);
            cb(err);
        } else $4Jj9n.nextTick($87cf5d73f27e2302$var$emitCloseNT, _this);
    });
    return this;
}
function $87cf5d73f27e2302$var$emitErrorAndCloseNT(self, err) {
    $87cf5d73f27e2302$var$emitErrorNT(self, err);
    $87cf5d73f27e2302$var$emitCloseNT(self);
}
function $87cf5d73f27e2302$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit('close');
}
function $87cf5d73f27e2302$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $87cf5d73f27e2302$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
function $87cf5d73f27e2302$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit('error', err);
}
module.exports = {
    destroy: $87cf5d73f27e2302$var$destroy,
    undestroy: $87cf5d73f27e2302$var$undestroy,
    errorOrDestroy: $87cf5d73f27e2302$var$errorOrDestroy
};

});

parcelRegister("1NzB0", function(module, exports) {
'use strict';

var $14f5faa8afc5e2c0$var$ERR_INVALID_OPT_VALUE = (parcelRequire("aQfo6")).codes.ERR_INVALID_OPT_VALUE;
function $14f5faa8afc5e2c0$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $14f5faa8afc5e2c0$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $14f5faa8afc5e2c0$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : 'highWaterMark';
            throw new $14f5faa8afc5e2c0$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $14f5faa8afc5e2c0$var$getHighWaterMark
};

});
parcelRegister("aQfo6", function(module, exports) {

$parcel$export(module.exports, "codes", () => $7e4ab26389ebdc06$export$e45cb6485273080e, (v) => $7e4ab26389ebdc06$export$e45cb6485273080e = v);
var $7e4ab26389ebdc06$export$e45cb6485273080e;
'use strict';
function $7e4ab26389ebdc06$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $7e4ab26389ebdc06$var$codes = {};
function $7e4ab26389ebdc06$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $7e4ab26389ebdc06$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $7e4ab26389ebdc06$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $7e4ab26389ebdc06$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $7e4ab26389ebdc06$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $7e4ab26389ebdc06$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $7e4ab26389ebdc06$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$7e4ab26389ebdc06$var$createErrorType('ERR_INVALID_OPT_VALUE', function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$7e4ab26389ebdc06$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $7e4ab26389ebdc06$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($7e4ab26389ebdc06$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($7e4ab26389ebdc06$var$oneOf(expected, 'type'));
    else {
        var type = $7e4ab26389ebdc06$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($7e4ab26389ebdc06$var$oneOf(expected, 'type'));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$7e4ab26389ebdc06$var$createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
$7e4ab26389ebdc06$var$createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function(name) {
    return 'The ' + name + ' method is not implemented';
});
$7e4ab26389ebdc06$var$createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
$7e4ab26389ebdc06$var$createErrorType('ERR_STREAM_DESTROYED', function(name) {
    return 'Cannot call ' + name + ' after a stream was destroyed';
});
$7e4ab26389ebdc06$var$createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
$7e4ab26389ebdc06$var$createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
$7e4ab26389ebdc06$var$createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
$7e4ab26389ebdc06$var$createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$7e4ab26389ebdc06$var$createErrorType('ERR_UNKNOWN_ENCODING', function(arg) {
    return 'Unknown encoding: ' + arg;
}, TypeError);
$7e4ab26389ebdc06$var$createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
$7e4ab26389ebdc06$export$e45cb6485273080e = $7e4ab26389ebdc06$var$codes;

});


parcelRegister("5PuTj", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $4Jj9n = parcelRequire("4Jj9n");
'use strict';
/*<replacement>*/ var $43e9ad818277d33b$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $43e9ad818277d33b$var$Duplex;

var $ljYrj = parcelRequire("ljYrj");

var $eAzUD = parcelRequire("eAzUD");

(parcelRequire("9YOog"))($43e9ad818277d33b$var$Duplex, $ljYrj);
// Allow the keys array to be GC'ed.
var $43e9ad818277d33b$var$keys = $43e9ad818277d33b$var$objectKeys($eAzUD.prototype);
for(var $43e9ad818277d33b$var$v = 0; $43e9ad818277d33b$var$v < $43e9ad818277d33b$var$keys.length; $43e9ad818277d33b$var$v++){
    var $43e9ad818277d33b$var$method = $43e9ad818277d33b$var$keys[$43e9ad818277d33b$var$v];
    if (!$43e9ad818277d33b$var$Duplex.prototype[$43e9ad818277d33b$var$method]) $43e9ad818277d33b$var$Duplex.prototype[$43e9ad818277d33b$var$method] = $eAzUD.prototype[$43e9ad818277d33b$var$method];
}
function $43e9ad818277d33b$var$Duplex(options) {
    if (!(this instanceof $43e9ad818277d33b$var$Duplex)) return new $43e9ad818277d33b$var$Duplex(options);
    $ljYrj.call(this, options);
    $eAzUD.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once('end', $43e9ad818277d33b$var$onend);
        }
    }
}
Object.defineProperty($43e9ad818277d33b$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($43e9ad818277d33b$var$Duplex.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($43e9ad818277d33b$var$Duplex.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $43e9ad818277d33b$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $4Jj9n.nextTick($43e9ad818277d33b$var$onEndNT, this);
}
function $43e9ad818277d33b$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($43e9ad818277d33b$var$Duplex.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("eAzUD", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $4Jj9n = parcelRequire("4Jj9n");
'use strict';
module.exports = $a9f048f123b6579e$var$Writable;
/* <replacement> */ function $a9f048f123b6579e$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $a9f048f123b6579e$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $a9f048f123b6579e$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $a9f048f123b6579e$var$Duplex;
/*</replacement>*/ $a9f048f123b6579e$var$Writable.WritableState = $a9f048f123b6579e$var$WritableState;

/*<replacement>*/ var $a9f048f123b6579e$var$internalUtil = {
    deprecate: (parcelRequire("hh1jD"))
};

var $3OcAH = parcelRequire("3OcAH");

var $cbQCu = parcelRequire("cbQCu");
var $a9f048f123b6579e$require$Buffer = $cbQCu.Buffer;
var $a9f048f123b6579e$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $a9f048f123b6579e$var$_uint8ArrayToBuffer(chunk) {
    return $a9f048f123b6579e$require$Buffer.from(chunk);
}
function $a9f048f123b6579e$var$_isUint8Array(obj) {
    return $a9f048f123b6579e$require$Buffer.isBuffer(obj) || obj instanceof $a9f048f123b6579e$var$OurUint8Array;
}

var $bEUDG = parcelRequire("bEUDG");

var $1NzB0 = parcelRequire("1NzB0");
var $a9f048f123b6579e$var$getHighWaterMark = $1NzB0.getHighWaterMark;

var $aQfo6 = parcelRequire("aQfo6");
var $a9f048f123b6579e$require$_require$codes = $aQfo6.codes;
var $a9f048f123b6579e$var$ERR_INVALID_ARG_TYPE = $a9f048f123b6579e$require$_require$codes.ERR_INVALID_ARG_TYPE, $a9f048f123b6579e$var$ERR_METHOD_NOT_IMPLEMENTED = $a9f048f123b6579e$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $a9f048f123b6579e$var$ERR_MULTIPLE_CALLBACK = $a9f048f123b6579e$require$_require$codes.ERR_MULTIPLE_CALLBACK, $a9f048f123b6579e$var$ERR_STREAM_CANNOT_PIPE = $a9f048f123b6579e$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $a9f048f123b6579e$var$ERR_STREAM_DESTROYED = $a9f048f123b6579e$require$_require$codes.ERR_STREAM_DESTROYED, $a9f048f123b6579e$var$ERR_STREAM_NULL_VALUES = $a9f048f123b6579e$require$_require$codes.ERR_STREAM_NULL_VALUES, $a9f048f123b6579e$var$ERR_STREAM_WRITE_AFTER_END = $a9f048f123b6579e$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $a9f048f123b6579e$var$ERR_UNKNOWN_ENCODING = $a9f048f123b6579e$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $a9f048f123b6579e$var$errorOrDestroy = $bEUDG.errorOrDestroy;

(parcelRequire("9YOog"))($a9f048f123b6579e$var$Writable, $3OcAH);
function $a9f048f123b6579e$var$nop() {}

function $a9f048f123b6579e$var$WritableState(options, stream, isDuplex) {
    $a9f048f123b6579e$var$Duplex = $a9f048f123b6579e$var$Duplex || (parcelRequire("5PuTj"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $a9f048f123b6579e$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $a9f048f123b6579e$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $a9f048f123b6579e$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $a9f048f123b6579e$var$CorkedRequest(this);
}
$a9f048f123b6579e$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($a9f048f123b6579e$var$WritableState.prototype, 'buffer', {
            get: $a9f048f123b6579e$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $a9f048f123b6579e$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $a9f048f123b6579e$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($a9f048f123b6579e$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($a9f048f123b6579e$var$realHasInstance.call(this, object)) return true;
            if (this !== $a9f048f123b6579e$var$Writable) return false;
            return object && object._writableState instanceof $a9f048f123b6579e$var$WritableState;
        }
    });
} else $a9f048f123b6579e$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $a9f048f123b6579e$var$Writable(options) {
    $a9f048f123b6579e$var$Duplex = $a9f048f123b6579e$var$Duplex || (parcelRequire("5PuTj"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $a9f048f123b6579e$var$Duplex;
    if (!isDuplex && !$a9f048f123b6579e$var$realHasInstance.call($a9f048f123b6579e$var$Writable, this)) return new $a9f048f123b6579e$var$Writable(options);
    this._writableState = new $a9f048f123b6579e$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $3OcAH.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$a9f048f123b6579e$var$Writable.prototype.pipe = function() {
    $a9f048f123b6579e$var$errorOrDestroy(this, new $a9f048f123b6579e$var$ERR_STREAM_CANNOT_PIPE());
};
function $a9f048f123b6579e$var$writeAfterEnd(stream, cb) {
    var er = new $a9f048f123b6579e$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $a9f048f123b6579e$var$errorOrDestroy(stream, er);
    $4Jj9n.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $a9f048f123b6579e$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $a9f048f123b6579e$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== 'string' && !state.objectMode) er = new $a9f048f123b6579e$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer'
    ], chunk);
    if (er) {
        $a9f048f123b6579e$var$errorOrDestroy(stream, er);
        $4Jj9n.nextTick(cb, er);
        return false;
    }
    return true;
}
$a9f048f123b6579e$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $a9f048f123b6579e$var$_isUint8Array(chunk);
    if (isBuf && !$a9f048f123b6579e$require$Buffer.isBuffer(chunk)) chunk = $a9f048f123b6579e$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $a9f048f123b6579e$var$nop;
    if (state.ending) $a9f048f123b6579e$var$writeAfterEnd(this, cb);
    else if (isBuf || $a9f048f123b6579e$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $a9f048f123b6579e$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$a9f048f123b6579e$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$a9f048f123b6579e$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $a9f048f123b6579e$var$clearBuffer(this, state);
    }
};
$a9f048f123b6579e$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new $a9f048f123b6579e$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($a9f048f123b6579e$var$Writable.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $a9f048f123b6579e$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $a9f048f123b6579e$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($a9f048f123b6579e$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $a9f048f123b6579e$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $a9f048f123b6579e$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $a9f048f123b6579e$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $a9f048f123b6579e$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $a9f048f123b6579e$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $a9f048f123b6579e$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $4Jj9n.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $4Jj9n.nextTick($a9f048f123b6579e$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $a9f048f123b6579e$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $a9f048f123b6579e$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $a9f048f123b6579e$var$finishMaybe(stream, state);
    }
}
function $a9f048f123b6579e$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $a9f048f123b6579e$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') throw new $a9f048f123b6579e$var$ERR_MULTIPLE_CALLBACK();
    $a9f048f123b6579e$var$onwriteStateUpdate(state);
    if (er) $a9f048f123b6579e$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $a9f048f123b6579e$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $a9f048f123b6579e$var$clearBuffer(stream, state);
        if (sync) $4Jj9n.nextTick($a9f048f123b6579e$var$afterWrite, stream, state, finished, cb);
        else $a9f048f123b6579e$var$afterWrite(stream, state, finished, cb);
    }
}
function $a9f048f123b6579e$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $a9f048f123b6579e$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $a9f048f123b6579e$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $a9f048f123b6579e$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $a9f048f123b6579e$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $a9f048f123b6579e$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $a9f048f123b6579e$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $a9f048f123b6579e$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$a9f048f123b6579e$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $a9f048f123b6579e$var$ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
$a9f048f123b6579e$var$Writable.prototype._writev = null;
$a9f048f123b6579e$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $a9f048f123b6579e$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($a9f048f123b6579e$var$Writable.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $a9f048f123b6579e$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $a9f048f123b6579e$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $a9f048f123b6579e$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit('prefinish');
        $a9f048f123b6579e$var$finishMaybe(stream, state);
    });
}
function $a9f048f123b6579e$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $4Jj9n.nextTick($a9f048f123b6579e$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $a9f048f123b6579e$var$finishMaybe(stream, state) {
    var need = $a9f048f123b6579e$var$needFinish(state);
    if (need) {
        $a9f048f123b6579e$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $a9f048f123b6579e$var$endWritable(stream, state, cb) {
    state.ending = true;
    $a9f048f123b6579e$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $4Jj9n.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $a9f048f123b6579e$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($a9f048f123b6579e$var$Writable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$a9f048f123b6579e$var$Writable.prototype.destroy = $bEUDG.destroy;
$a9f048f123b6579e$var$Writable.prototype._undestroy = $bEUDG.undestroy;
$a9f048f123b6579e$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("hh1jD", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $c9350b7e6b7672af$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $c9350b7e6b7672af$var$deprecate(fn, msg) {
    if ($c9350b7e6b7672af$var$config('noDeprecation')) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($c9350b7e6b7672af$var$config('throwDeprecation')) throw new Error(msg);
            else if ($c9350b7e6b7672af$var$config('traceDeprecation')) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $c9350b7e6b7672af$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === 'true';
}

});



parcelRegister("fr8tb", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $b3cff28e2ef33ead$export$63a7aa211a91ed69, (v) => $b3cff28e2ef33ead$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $b3cff28e2ef33ead$export$63a7aa211a91ed69;
'use strict';

var $jcTxY = parcelRequire("jcTxY");
var $b3cff28e2ef33ead$require$Buffer = $jcTxY.Buffer;
/*</replacement>*/ var $b3cff28e2ef33ead$var$isEncoding = $b3cff28e2ef33ead$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $b3cff28e2ef33ead$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $b3cff28e2ef33ead$var$normalizeEncoding(enc) {
    var nenc = $b3cff28e2ef33ead$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($b3cff28e2ef33ead$require$Buffer.isEncoding === $b3cff28e2ef33ead$var$isEncoding || !$b3cff28e2ef33ead$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$b3cff28e2ef33ead$export$63a7aa211a91ed69 = $b3cff28e2ef33ead$var$StringDecoder;
function $b3cff28e2ef33ead$var$StringDecoder(encoding) {
    this.encoding = $b3cff28e2ef33ead$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $b3cff28e2ef33ead$var$utf16Text;
            this.end = $b3cff28e2ef33ead$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $b3cff28e2ef33ead$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $b3cff28e2ef33ead$var$base64Text;
            this.end = $b3cff28e2ef33ead$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $b3cff28e2ef33ead$var$simpleWrite;
            this.end = $b3cff28e2ef33ead$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $b3cff28e2ef33ead$require$Buffer.allocUnsafe(nb);
}
$b3cff28e2ef33ead$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$b3cff28e2ef33ead$var$StringDecoder.prototype.end = $b3cff28e2ef33ead$var$utf8End;
// Returns only complete characters in a Buffer
$b3cff28e2ef33ead$var$StringDecoder.prototype.text = $b3cff28e2ef33ead$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$b3cff28e2ef33ead$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $b3cff28e2ef33ead$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $b3cff28e2ef33ead$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $b3cff28e2ef33ead$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $b3cff28e2ef33ead$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $b3cff28e2ef33ead$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $b3cff28e2ef33ead$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $b3cff28e2ef33ead$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $b3cff28e2ef33ead$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $b3cff28e2ef33ead$var$utf8Text(buf, i) {
    var total = $b3cff28e2ef33ead$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $b3cff28e2ef33ead$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $b3cff28e2ef33ead$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $b3cff28e2ef33ead$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $b3cff28e2ef33ead$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $b3cff28e2ef33ead$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $b3cff28e2ef33ead$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $b3cff28e2ef33ead$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});
parcelRegister("jcTxY", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $cbQCu = parcelRequire("cbQCu");
var $dfba39cd620cd3d7$var$Buffer = $cbQCu.Buffer;
// alternative to using Object.keys for old browsers
function $dfba39cd620cd3d7$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($dfba39cd620cd3d7$var$Buffer.from && $dfba39cd620cd3d7$var$Buffer.alloc && $dfba39cd620cd3d7$var$Buffer.allocUnsafe && $dfba39cd620cd3d7$var$Buffer.allocUnsafeSlow) module.exports = $cbQCu;
else {
    // Copy properties from require('buffer')
    $dfba39cd620cd3d7$var$copyProps($cbQCu, module.exports);
    module.exports.Buffer = $dfba39cd620cd3d7$var$SafeBuffer;
}
function $dfba39cd620cd3d7$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $dfba39cd620cd3d7$var$Buffer(arg, encodingOrOffset, length);
}
$dfba39cd620cd3d7$var$SafeBuffer.prototype = Object.create($dfba39cd620cd3d7$var$Buffer.prototype);
// Copy static methods from Buffer
$dfba39cd620cd3d7$var$copyProps($dfba39cd620cd3d7$var$Buffer, $dfba39cd620cd3d7$var$SafeBuffer);
$dfba39cd620cd3d7$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $dfba39cd620cd3d7$var$Buffer(arg, encodingOrOffset, length);
};
$dfba39cd620cd3d7$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $dfba39cd620cd3d7$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$dfba39cd620cd3d7$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $dfba39cd620cd3d7$var$Buffer(size);
};
$dfba39cd620cd3d7$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $cbQCu.SlowBuffer(size);
};

});


parcelRegister("g3g84", function(module, exports) {

var $4Jj9n = parcelRequire("4Jj9n");
'use strict';
var $baf970140daabb65$var$_Object$setPrototypeO;
function $baf970140daabb65$var$_defineProperty(obj, key, value) {
    key = $baf970140daabb65$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $baf970140daabb65$var$_toPropertyKey(arg) {
    var key = $baf970140daabb65$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $baf970140daabb65$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $iMJxh = parcelRequire("iMJxh");
var $baf970140daabb65$var$kLastResolve = Symbol('lastResolve');
var $baf970140daabb65$var$kLastReject = Symbol('lastReject');
var $baf970140daabb65$var$kError = Symbol('error');
var $baf970140daabb65$var$kEnded = Symbol('ended');
var $baf970140daabb65$var$kLastPromise = Symbol('lastPromise');
var $baf970140daabb65$var$kHandlePromise = Symbol('handlePromise');
var $baf970140daabb65$var$kStream = Symbol('stream');
function $baf970140daabb65$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $baf970140daabb65$var$readAndResolve(iter) {
    var resolve = iter[$baf970140daabb65$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$baf970140daabb65$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$baf970140daabb65$var$kLastPromise] = null;
            iter[$baf970140daabb65$var$kLastResolve] = null;
            iter[$baf970140daabb65$var$kLastReject] = null;
            resolve($baf970140daabb65$var$createIterResult(data, false));
        }
    }
}
function $baf970140daabb65$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $4Jj9n.nextTick($baf970140daabb65$var$readAndResolve, iter);
}
function $baf970140daabb65$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$baf970140daabb65$var$kEnded]) {
                resolve($baf970140daabb65$var$createIterResult(undefined, true));
                return;
            }
            iter[$baf970140daabb65$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $baf970140daabb65$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $baf970140daabb65$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($baf970140daabb65$var$_Object$setPrototypeO = {
    get stream () {
        return this[$baf970140daabb65$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$baf970140daabb65$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$baf970140daabb65$var$kEnded]) return Promise.resolve($baf970140daabb65$var$createIterResult(undefined, true));
        if (this[$baf970140daabb65$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $4Jj9n.nextTick(function() {
                if (_this[$baf970140daabb65$var$kError]) reject(_this[$baf970140daabb65$var$kError]);
                else resolve($baf970140daabb65$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$baf970140daabb65$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($baf970140daabb65$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$baf970140daabb65$var$kStream].read();
            if (data !== null) return Promise.resolve($baf970140daabb65$var$createIterResult(data, false));
            promise = new Promise(this[$baf970140daabb65$var$kHandlePromise]);
        }
        this[$baf970140daabb65$var$kLastPromise] = promise;
        return promise;
    }
}, $baf970140daabb65$var$_defineProperty($baf970140daabb65$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $baf970140daabb65$var$_defineProperty($baf970140daabb65$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$baf970140daabb65$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($baf970140daabb65$var$createIterResult(undefined, true));
        });
    });
}), $baf970140daabb65$var$_Object$setPrototypeO), $baf970140daabb65$var$AsyncIteratorPrototype);
var $baf970140daabb65$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($baf970140daabb65$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $baf970140daabb65$var$_defineProperty(_Object$create, $baf970140daabb65$var$kStream, {
        value: stream,
        writable: true
    }), $baf970140daabb65$var$_defineProperty(_Object$create, $baf970140daabb65$var$kLastResolve, {
        value: null,
        writable: true
    }), $baf970140daabb65$var$_defineProperty(_Object$create, $baf970140daabb65$var$kLastReject, {
        value: null,
        writable: true
    }), $baf970140daabb65$var$_defineProperty(_Object$create, $baf970140daabb65$var$kError, {
        value: null,
        writable: true
    }), $baf970140daabb65$var$_defineProperty(_Object$create, $baf970140daabb65$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $baf970140daabb65$var$_defineProperty(_Object$create, $baf970140daabb65$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$baf970140daabb65$var$kStream].read();
            if (data) {
                iterator[$baf970140daabb65$var$kLastPromise] = null;
                iterator[$baf970140daabb65$var$kLastResolve] = null;
                iterator[$baf970140daabb65$var$kLastReject] = null;
                resolve($baf970140daabb65$var$createIterResult(data, false));
            } else {
                iterator[$baf970140daabb65$var$kLastResolve] = resolve;
                iterator[$baf970140daabb65$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$baf970140daabb65$var$kLastPromise] = null;
    $iMJxh(stream, function(err) {
        if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
            var reject = iterator[$baf970140daabb65$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$baf970140daabb65$var$kLastPromise] = null;
                iterator[$baf970140daabb65$var$kLastResolve] = null;
                iterator[$baf970140daabb65$var$kLastReject] = null;
                reject(err);
            }
            iterator[$baf970140daabb65$var$kError] = err;
            return;
        }
        var resolve = iterator[$baf970140daabb65$var$kLastResolve];
        if (resolve !== null) {
            iterator[$baf970140daabb65$var$kLastPromise] = null;
            iterator[$baf970140daabb65$var$kLastResolve] = null;
            iterator[$baf970140daabb65$var$kLastReject] = null;
            resolve($baf970140daabb65$var$createIterResult(undefined, true));
        }
        iterator[$baf970140daabb65$var$kEnded] = true;
    });
    stream.on('readable', $baf970140daabb65$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $baf970140daabb65$var$createReadableStreamAsyncIterator;

});
parcelRegister("iMJxh", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $dad00820ab2d8972$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("aQfo6")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $dad00820ab2d8972$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $dad00820ab2d8972$var$noop() {}
function $dad00820ab2d8972$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
function $dad00820ab2d8972$var$eos(stream, opts, callback) {
    if (typeof opts === 'function') return $dad00820ab2d8972$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $dad00820ab2d8972$var$once(callback || $dad00820ab2d8972$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $dad00820ab2d8972$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $dad00820ab2d8972$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on('finish', onfinish);
    };
    if ($dad00820ab2d8972$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (opts.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    return function() {
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
}
module.exports = $dad00820ab2d8972$var$eos;

});


parcelRegister("fOGyj", function(module, exports) {
module.exports = function() {
    throw new Error('Readable.from is not available in the browser');
};

});


parcelRegister("9Pily", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $72771bc24748289a$var$Transform;

var $aQfo6 = parcelRequire("aQfo6");
var $72771bc24748289a$require$_require$codes = $aQfo6.codes;
var $72771bc24748289a$var$ERR_METHOD_NOT_IMPLEMENTED = $72771bc24748289a$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $72771bc24748289a$var$ERR_MULTIPLE_CALLBACK = $72771bc24748289a$require$_require$codes.ERR_MULTIPLE_CALLBACK, $72771bc24748289a$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $72771bc24748289a$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $72771bc24748289a$var$ERR_TRANSFORM_WITH_LENGTH_0 = $72771bc24748289a$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $5PuTj = parcelRequire("5PuTj");

(parcelRequire("9YOog"))($72771bc24748289a$var$Transform, $5PuTj);
function $72771bc24748289a$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit('error', new $72771bc24748289a$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $72771bc24748289a$var$Transform(options) {
    if (!(this instanceof $72771bc24748289a$var$Transform)) return new $72771bc24748289a$var$Transform(options);
    $5PuTj.call(this, options);
    this._transformState = {
        afterTransform: $72771bc24748289a$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $72771bc24748289a$var$prefinish);
}
function $72771bc24748289a$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function' && !this._readableState.destroyed) this._flush(function(er, data) {
        $72771bc24748289a$var$done(_this, er, data);
    });
    else $72771bc24748289a$var$done(this, null, null);
}
$72771bc24748289a$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $5PuTj.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$72771bc24748289a$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $72771bc24748289a$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
$72771bc24748289a$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$72771bc24748289a$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$72771bc24748289a$var$Transform.prototype._destroy = function(err, cb) {
    $5PuTj.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $72771bc24748289a$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $72771bc24748289a$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $72771bc24748289a$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("euhdJ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $a8c139a7be2bd7f4$var$PassThrough;

var $9Pily = parcelRequire("9Pily");

(parcelRequire("9YOog"))($a8c139a7be2bd7f4$var$PassThrough, $9Pily);
function $a8c139a7be2bd7f4$var$PassThrough(options) {
    if (!(this instanceof $a8c139a7be2bd7f4$var$PassThrough)) return new $a8c139a7be2bd7f4$var$PassThrough(options);
    $9Pily.call(this, options);
}
$a8c139a7be2bd7f4$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("atWzg", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';
var $7a1a0b285cb275ce$var$eos;
function $7a1a0b285cb275ce$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $aQfo6 = parcelRequire("aQfo6");
var $7a1a0b285cb275ce$require$_require$codes = $aQfo6.codes;
var $7a1a0b285cb275ce$var$ERR_MISSING_ARGS = $7a1a0b285cb275ce$require$_require$codes.ERR_MISSING_ARGS, $7a1a0b285cb275ce$var$ERR_STREAM_DESTROYED = $7a1a0b285cb275ce$require$_require$codes.ERR_STREAM_DESTROYED;
function $7a1a0b285cb275ce$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $7a1a0b285cb275ce$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}

function $7a1a0b285cb275ce$var$destroyer(stream, reading, writing, callback) {
    callback = $7a1a0b285cb275ce$var$once(callback);
    var closed = false;
    stream.on('close', function() {
        closed = true;
    });
    if ($7a1a0b285cb275ce$var$eos === undefined) $7a1a0b285cb275ce$var$eos = (parcelRequire("iMJxh"));
    $7a1a0b285cb275ce$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($7a1a0b285cb275ce$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === 'function') return stream.destroy();
        callback(err || new $7a1a0b285cb275ce$var$ERR_STREAM_DESTROYED('pipe'));
    };
}
function $7a1a0b285cb275ce$var$call(fn) {
    fn();
}
function $7a1a0b285cb275ce$var$pipe(from, to) {
    return from.pipe(to);
}
function $7a1a0b285cb275ce$var$popCallback(streams) {
    if (!streams.length) return $7a1a0b285cb275ce$var$noop;
    if (typeof streams[streams.length - 1] !== 'function') return $7a1a0b285cb275ce$var$noop;
    return streams.pop();
}
function $7a1a0b285cb275ce$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $7a1a0b285cb275ce$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $7a1a0b285cb275ce$var$ERR_MISSING_ARGS('streams');
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $7a1a0b285cb275ce$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($7a1a0b285cb275ce$var$call);
            if (reading) return;
            destroys.forEach($7a1a0b285cb275ce$var$call);
            callback(error);
        });
    });
    return streams.reduce($7a1a0b285cb275ce$var$pipe);
}
module.exports = $7a1a0b285cb275ce$var$pipeline;

});

parcelRegister("e9HhI", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';

var $jEMVV = parcelRequire("jEMVV");

var $3KZPn = parcelRequire("3KZPn");

var $8Cs36 = parcelRequire("8Cs36");

var $2BlbL = parcelRequire("2BlbL");
function $a4e37b6276faa3cc$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $a4e37b6276faa3cc$var$BigIntSupported = typeof BigInt !== 'undefined';
var $a4e37b6276faa3cc$var$SymbolSupported = typeof Symbol !== 'undefined';
var $a4e37b6276faa3cc$var$ObjectToString = $a4e37b6276faa3cc$var$uncurryThis(Object.prototype.toString);
var $a4e37b6276faa3cc$var$numberValue = $a4e37b6276faa3cc$var$uncurryThis(Number.prototype.valueOf);
var $a4e37b6276faa3cc$var$stringValue = $a4e37b6276faa3cc$var$uncurryThis(String.prototype.valueOf);
var $a4e37b6276faa3cc$var$booleanValue = $a4e37b6276faa3cc$var$uncurryThis(Boolean.prototype.valueOf);
if ($a4e37b6276faa3cc$var$BigIntSupported) var $a4e37b6276faa3cc$var$bigIntValue = $a4e37b6276faa3cc$var$uncurryThis(BigInt.prototype.valueOf);
if ($a4e37b6276faa3cc$var$SymbolSupported) var $a4e37b6276faa3cc$var$symbolValue = $a4e37b6276faa3cc$var$uncurryThis(Symbol.prototype.valueOf);
function $a4e37b6276faa3cc$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== 'object') return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $jEMVV;
module.exports.isGeneratorFunction = $3KZPn;
module.exports.isTypedArray = $2BlbL;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $a4e37b6276faa3cc$var$isPromise(input) {
    return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
}
module.exports.isPromise = $a4e37b6276faa3cc$var$isPromise;
function $a4e37b6276faa3cc$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $2BlbL(value) || $a4e37b6276faa3cc$var$isDataView(value);
}
module.exports.isArrayBufferView = $a4e37b6276faa3cc$var$isArrayBufferView;
function $a4e37b6276faa3cc$var$isUint8Array(value) {
    return $8Cs36(value) === 'Uint8Array';
}
module.exports.isUint8Array = $a4e37b6276faa3cc$var$isUint8Array;
function $a4e37b6276faa3cc$var$isUint8ClampedArray(value) {
    return $8Cs36(value) === 'Uint8ClampedArray';
}
module.exports.isUint8ClampedArray = $a4e37b6276faa3cc$var$isUint8ClampedArray;
function $a4e37b6276faa3cc$var$isUint16Array(value) {
    return $8Cs36(value) === 'Uint16Array';
}
module.exports.isUint16Array = $a4e37b6276faa3cc$var$isUint16Array;
function $a4e37b6276faa3cc$var$isUint32Array(value) {
    return $8Cs36(value) === 'Uint32Array';
}
module.exports.isUint32Array = $a4e37b6276faa3cc$var$isUint32Array;
function $a4e37b6276faa3cc$var$isInt8Array(value) {
    return $8Cs36(value) === 'Int8Array';
}
module.exports.isInt8Array = $a4e37b6276faa3cc$var$isInt8Array;
function $a4e37b6276faa3cc$var$isInt16Array(value) {
    return $8Cs36(value) === 'Int16Array';
}
module.exports.isInt16Array = $a4e37b6276faa3cc$var$isInt16Array;
function $a4e37b6276faa3cc$var$isInt32Array(value) {
    return $8Cs36(value) === 'Int32Array';
}
module.exports.isInt32Array = $a4e37b6276faa3cc$var$isInt32Array;
function $a4e37b6276faa3cc$var$isFloat32Array(value) {
    return $8Cs36(value) === 'Float32Array';
}
module.exports.isFloat32Array = $a4e37b6276faa3cc$var$isFloat32Array;
function $a4e37b6276faa3cc$var$isFloat64Array(value) {
    return $8Cs36(value) === 'Float64Array';
}
module.exports.isFloat64Array = $a4e37b6276faa3cc$var$isFloat64Array;
function $a4e37b6276faa3cc$var$isBigInt64Array(value) {
    return $8Cs36(value) === 'BigInt64Array';
}
module.exports.isBigInt64Array = $a4e37b6276faa3cc$var$isBigInt64Array;
function $a4e37b6276faa3cc$var$isBigUint64Array(value) {
    return $8Cs36(value) === 'BigUint64Array';
}
module.exports.isBigUint64Array = $a4e37b6276faa3cc$var$isBigUint64Array;
function $a4e37b6276faa3cc$var$isMapToString(value) {
    return $a4e37b6276faa3cc$var$ObjectToString(value) === '[object Map]';
}
$a4e37b6276faa3cc$var$isMapToString.working = typeof Map !== 'undefined' && $a4e37b6276faa3cc$var$isMapToString(new Map());
function $a4e37b6276faa3cc$var$isMap(value) {
    if (typeof Map === 'undefined') return false;
    return $a4e37b6276faa3cc$var$isMapToString.working ? $a4e37b6276faa3cc$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $a4e37b6276faa3cc$var$isMap;
function $a4e37b6276faa3cc$var$isSetToString(value) {
    return $a4e37b6276faa3cc$var$ObjectToString(value) === '[object Set]';
}
$a4e37b6276faa3cc$var$isSetToString.working = typeof Set !== 'undefined' && $a4e37b6276faa3cc$var$isSetToString(new Set());
function $a4e37b6276faa3cc$var$isSet(value) {
    if (typeof Set === 'undefined') return false;
    return $a4e37b6276faa3cc$var$isSetToString.working ? $a4e37b6276faa3cc$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $a4e37b6276faa3cc$var$isSet;
function $a4e37b6276faa3cc$var$isWeakMapToString(value) {
    return $a4e37b6276faa3cc$var$ObjectToString(value) === '[object WeakMap]';
}
$a4e37b6276faa3cc$var$isWeakMapToString.working = typeof WeakMap !== 'undefined' && $a4e37b6276faa3cc$var$isWeakMapToString(new WeakMap());
function $a4e37b6276faa3cc$var$isWeakMap(value) {
    if (typeof WeakMap === 'undefined') return false;
    return $a4e37b6276faa3cc$var$isWeakMapToString.working ? $a4e37b6276faa3cc$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $a4e37b6276faa3cc$var$isWeakMap;
function $a4e37b6276faa3cc$var$isWeakSetToString(value) {
    return $a4e37b6276faa3cc$var$ObjectToString(value) === '[object WeakSet]';
}
$a4e37b6276faa3cc$var$isWeakSetToString.working = typeof WeakSet !== 'undefined' && $a4e37b6276faa3cc$var$isWeakSetToString(new WeakSet());
function $a4e37b6276faa3cc$var$isWeakSet(value) {
    return $a4e37b6276faa3cc$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $a4e37b6276faa3cc$var$isWeakSet;
function $a4e37b6276faa3cc$var$isArrayBufferToString(value) {
    return $a4e37b6276faa3cc$var$ObjectToString(value) === '[object ArrayBuffer]';
}
$a4e37b6276faa3cc$var$isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && $a4e37b6276faa3cc$var$isArrayBufferToString(new ArrayBuffer());
function $a4e37b6276faa3cc$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === 'undefined') return false;
    return $a4e37b6276faa3cc$var$isArrayBufferToString.working ? $a4e37b6276faa3cc$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $a4e37b6276faa3cc$var$isArrayBuffer;
function $a4e37b6276faa3cc$var$isDataViewToString(value) {
    return $a4e37b6276faa3cc$var$ObjectToString(value) === '[object DataView]';
}
$a4e37b6276faa3cc$var$isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && $a4e37b6276faa3cc$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $a4e37b6276faa3cc$var$isDataView(value) {
    if (typeof DataView === 'undefined') return false;
    return $a4e37b6276faa3cc$var$isDataViewToString.working ? $a4e37b6276faa3cc$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $a4e37b6276faa3cc$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $a4e37b6276faa3cc$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function $a4e37b6276faa3cc$var$isSharedArrayBufferToString(value) {
    return $a4e37b6276faa3cc$var$ObjectToString(value) === '[object SharedArrayBuffer]';
}
function $a4e37b6276faa3cc$var$isSharedArrayBuffer(value) {
    if (typeof $a4e37b6276faa3cc$var$SharedArrayBufferCopy === 'undefined') return false;
    if (typeof $a4e37b6276faa3cc$var$isSharedArrayBufferToString.working === 'undefined') $a4e37b6276faa3cc$var$isSharedArrayBufferToString.working = $a4e37b6276faa3cc$var$isSharedArrayBufferToString(new $a4e37b6276faa3cc$var$SharedArrayBufferCopy());
    return $a4e37b6276faa3cc$var$isSharedArrayBufferToString.working ? $a4e37b6276faa3cc$var$isSharedArrayBufferToString(value) : value instanceof $a4e37b6276faa3cc$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $a4e37b6276faa3cc$var$isSharedArrayBuffer;
function $a4e37b6276faa3cc$var$isAsyncFunction(value) {
    return $a4e37b6276faa3cc$var$ObjectToString(value) === '[object AsyncFunction]';
}
module.exports.isAsyncFunction = $a4e37b6276faa3cc$var$isAsyncFunction;
function $a4e37b6276faa3cc$var$isMapIterator(value) {
    return $a4e37b6276faa3cc$var$ObjectToString(value) === '[object Map Iterator]';
}
module.exports.isMapIterator = $a4e37b6276faa3cc$var$isMapIterator;
function $a4e37b6276faa3cc$var$isSetIterator(value) {
    return $a4e37b6276faa3cc$var$ObjectToString(value) === '[object Set Iterator]';
}
module.exports.isSetIterator = $a4e37b6276faa3cc$var$isSetIterator;
function $a4e37b6276faa3cc$var$isGeneratorObject(value) {
    return $a4e37b6276faa3cc$var$ObjectToString(value) === '[object Generator]';
}
module.exports.isGeneratorObject = $a4e37b6276faa3cc$var$isGeneratorObject;
function $a4e37b6276faa3cc$var$isWebAssemblyCompiledModule(value) {
    return $a4e37b6276faa3cc$var$ObjectToString(value) === '[object WebAssembly.Module]';
}
module.exports.isWebAssemblyCompiledModule = $a4e37b6276faa3cc$var$isWebAssemblyCompiledModule;
function $a4e37b6276faa3cc$var$isNumberObject(value) {
    return $a4e37b6276faa3cc$var$checkBoxedPrimitive(value, $a4e37b6276faa3cc$var$numberValue);
}
module.exports.isNumberObject = $a4e37b6276faa3cc$var$isNumberObject;
function $a4e37b6276faa3cc$var$isStringObject(value) {
    return $a4e37b6276faa3cc$var$checkBoxedPrimitive(value, $a4e37b6276faa3cc$var$stringValue);
}
module.exports.isStringObject = $a4e37b6276faa3cc$var$isStringObject;
function $a4e37b6276faa3cc$var$isBooleanObject(value) {
    return $a4e37b6276faa3cc$var$checkBoxedPrimitive(value, $a4e37b6276faa3cc$var$booleanValue);
}
module.exports.isBooleanObject = $a4e37b6276faa3cc$var$isBooleanObject;
function $a4e37b6276faa3cc$var$isBigIntObject(value) {
    return $a4e37b6276faa3cc$var$BigIntSupported && $a4e37b6276faa3cc$var$checkBoxedPrimitive(value, $a4e37b6276faa3cc$var$bigIntValue);
}
module.exports.isBigIntObject = $a4e37b6276faa3cc$var$isBigIntObject;
function $a4e37b6276faa3cc$var$isSymbolObject(value) {
    return $a4e37b6276faa3cc$var$SymbolSupported && $a4e37b6276faa3cc$var$checkBoxedPrimitive(value, $a4e37b6276faa3cc$var$symbolValue);
}
module.exports.isSymbolObject = $a4e37b6276faa3cc$var$isSymbolObject;
function $a4e37b6276faa3cc$var$isBoxedPrimitive(value) {
    return $a4e37b6276faa3cc$var$isNumberObject(value) || $a4e37b6276faa3cc$var$isStringObject(value) || $a4e37b6276faa3cc$var$isBooleanObject(value) || $a4e37b6276faa3cc$var$isBigIntObject(value) || $a4e37b6276faa3cc$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $a4e37b6276faa3cc$var$isBoxedPrimitive;
function $a4e37b6276faa3cc$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== 'undefined' && ($a4e37b6276faa3cc$var$isArrayBuffer(value) || $a4e37b6276faa3cc$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $a4e37b6276faa3cc$var$isAnyArrayBuffer;
[
    'isProxy',
    'isExternal',
    'isModuleNamespaceObject'
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + ' is not supported in userland');
        }
    });
});

});
parcelRegister("jEMVV", function(module, exports) {
'use strict';

var $e4f7b5df835214a3$var$hasToStringTag = (parcelRequire("cJdfe"))();

var $exvo0 = parcelRequire("exvo0");
var $e4f7b5df835214a3$var$$toString = $exvo0('Object.prototype.toString');
/** @type {import('.')} */ var $e4f7b5df835214a3$var$isStandardArguments = function isArguments(value) {
    if ($e4f7b5df835214a3$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $e4f7b5df835214a3$var$$toString(value) === '[object Arguments]';
};
/** @type {import('.')} */ var $e4f7b5df835214a3$var$isLegacyArguments = function isArguments(value) {
    if ($e4f7b5df835214a3$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && 'length' in value && typeof value.length === 'number' && value.length >= 0 && $e4f7b5df835214a3$var$$toString(value) !== '[object Array]' && 'callee' in value && $e4f7b5df835214a3$var$$toString(value.callee) === '[object Function]';
};
var $e4f7b5df835214a3$var$supportsStandardArguments = function() {
    return $e4f7b5df835214a3$var$isStandardArguments(arguments);
}();
// @ts-expect-error TODO make this not error
$e4f7b5df835214a3$var$isStandardArguments.isLegacyArguments = $e4f7b5df835214a3$var$isLegacyArguments; // for tests
/** @type {import('.')} */ module.exports = $e4f7b5df835214a3$var$supportsStandardArguments ? $e4f7b5df835214a3$var$isStandardArguments : $e4f7b5df835214a3$var$isLegacyArguments;

});
parcelRegister("cJdfe", function(module, exports) {
'use strict';

var $9VQ4N = parcelRequire("9VQ4N");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $9VQ4N() && !!Symbol.toStringTag;
};

});
parcelRegister("9VQ4N", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("exvo0", function(module, exports) {
'use strict';

var $4YUXM = parcelRequire("4YUXM");

var $lH1kJ = parcelRequire("lH1kJ");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $a95c7e6883bd7de8$var$$indexOf = $lH1kJ([
    $4YUXM('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $4YUXM(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $a95c7e6883bd7de8$var$$indexOf(name, '.prototype.') > -1) return $lH1kJ(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});
parcelRegister("4YUXM", function(module, exports) {
'use strict';
var $3a08f3b93b399588$var$undefined1;

var $39Ldl = parcelRequire("39Ldl");

var $2DlCe = parcelRequire("2DlCe");

var $TtWO0 = parcelRequire("TtWO0");

var $aG0Ti = parcelRequire("aG0Ti");

var $cwaZa = parcelRequire("cwaZa");

var $1rcCL = parcelRequire("1rcCL");

var $jQFIR = parcelRequire("jQFIR");

var $6Unty = parcelRequire("6Unty");

var $38UJ9 = parcelRequire("38UJ9");

var $iGzt4 = parcelRequire("iGzt4");

var $dWJBO = parcelRequire("dWJBO");

var $i9udS = parcelRequire("i9udS");

var $hE7Bh = parcelRequire("hE7Bh");

var $gJSpD = parcelRequire("gJSpD");

var $8xHx6 = parcelRequire("8xHx6");
var $3a08f3b93b399588$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $3a08f3b93b399588$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $3a08f3b93b399588$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $7SE9t = parcelRequire("7SE9t");

var $cILf7 = parcelRequire("cILf7");
var $3a08f3b93b399588$var$throwTypeError = function() {
    throw new $jQFIR();
};
var $3a08f3b93b399588$var$ThrowTypeError = $7SE9t ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $3a08f3b93b399588$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $7SE9t(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $3a08f3b93b399588$var$throwTypeError;
        }
    }
}() : $3a08f3b93b399588$var$throwTypeError;

var $3a08f3b93b399588$var$hasSymbols = (parcelRequire("fa2Fq"))();

var $cKjXh = parcelRequire("cKjXh");

var $5O4uz = parcelRequire("5O4uz");

var $bOsTQ = parcelRequire("bOsTQ");

var $4G4X6 = parcelRequire("4G4X6");

var $9ttrx = parcelRequire("9ttrx");
var $3a08f3b93b399588$var$needsEval = {};
var $3a08f3b93b399588$var$TypedArray = typeof Uint8Array === 'undefined' || !$cKjXh ? undefined : $cKjXh(Uint8Array);
var $3a08f3b93b399588$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $3a08f3b93b399588$var$hasSymbols && $cKjXh ? $cKjXh([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $3a08f3b93b399588$var$needsEval,
    '%AsyncGenerator%': $3a08f3b93b399588$var$needsEval,
    '%AsyncGeneratorFunction%': $3a08f3b93b399588$var$needsEval,
    '%AsyncIteratorPrototype%': $3a08f3b93b399588$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $2DlCe,
    '%eval%': eval,
    '%EvalError%': $TtWO0,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $3a08f3b93b399588$var$$Function,
    '%GeneratorFunction%': $3a08f3b93b399588$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $3a08f3b93b399588$var$hasSymbols && $cKjXh ? $cKjXh($cKjXh([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$3a08f3b93b399588$var$hasSymbols || !$cKjXh ? undefined : $cKjXh(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $39Ldl,
    '%Object.getOwnPropertyDescriptor%': $7SE9t,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $aG0Ti,
    '%ReferenceError%': $cwaZa,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$3a08f3b93b399588$var$hasSymbols || !$cKjXh ? undefined : $cKjXh(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $3a08f3b93b399588$var$hasSymbols && $cKjXh ? $cKjXh(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $3a08f3b93b399588$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $1rcCL,
    '%ThrowTypeError%': $3a08f3b93b399588$var$ThrowTypeError,
    '%TypedArray%': $3a08f3b93b399588$var$TypedArray,
    '%TypeError%': $jQFIR,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $6Unty,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $9ttrx,
    '%Function.prototype.apply%': $4G4X6,
    '%Object.defineProperty%': $cILf7,
    '%Object.getPrototypeOf%': $5O4uz,
    '%Math.abs%': $38UJ9,
    '%Math.floor%': $iGzt4,
    '%Math.max%': $dWJBO,
    '%Math.min%': $i9udS,
    '%Math.pow%': $hE7Bh,
    '%Math.round%': $gJSpD,
    '%Math.sign%': $8xHx6,
    '%Reflect.getPrototypeOf%': $bOsTQ
};
if ($cKjXh) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $3a08f3b93b399588$var$errorProto = $cKjXh($cKjXh(e));
    $3a08f3b93b399588$var$INTRINSICS['%Error.prototype%'] = $3a08f3b93b399588$var$errorProto;
}
var $3a08f3b93b399588$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $3a08f3b93b399588$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $3a08f3b93b399588$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $3a08f3b93b399588$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $cKjXh) value = $cKjXh(gen.prototype);
    }
    $3a08f3b93b399588$var$INTRINSICS[name] = value;
    return value;
};
var $3a08f3b93b399588$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $1rs7J = parcelRequire("1rs7J");

var $bSXfZ = parcelRequire("bSXfZ");
var $3a08f3b93b399588$var$$concat = $1rs7J.call($9ttrx, Array.prototype.concat);
var $3a08f3b93b399588$var$$spliceApply = $1rs7J.call($4G4X6, Array.prototype.splice);
var $3a08f3b93b399588$var$$replace = $1rs7J.call($9ttrx, String.prototype.replace);
var $3a08f3b93b399588$var$$strSlice = $1rs7J.call($9ttrx, String.prototype.slice);
var $3a08f3b93b399588$var$$exec = $1rs7J.call($9ttrx, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $3a08f3b93b399588$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $3a08f3b93b399588$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $3a08f3b93b399588$var$stringToPath = function stringToPath(string) {
    var first = $3a08f3b93b399588$var$$strSlice(string, 0, 1);
    var last = $3a08f3b93b399588$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $1rcCL('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $1rcCL('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $3a08f3b93b399588$var$$replace(string, $3a08f3b93b399588$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $3a08f3b93b399588$var$$replace(subString, $3a08f3b93b399588$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $3a08f3b93b399588$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($bSXfZ($3a08f3b93b399588$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $3a08f3b93b399588$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($bSXfZ($3a08f3b93b399588$var$INTRINSICS, intrinsicName)) {
        var value = $3a08f3b93b399588$var$INTRINSICS[intrinsicName];
        if (value === $3a08f3b93b399588$var$needsEval) value = $3a08f3b93b399588$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $jQFIR('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $1rcCL('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $jQFIR('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $jQFIR('"allowMissing" argument must be a boolean');
    if ($3a08f3b93b399588$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $1rcCL('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $3a08f3b93b399588$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $3a08f3b93b399588$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $3a08f3b93b399588$var$$spliceApply(parts, $3a08f3b93b399588$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $3a08f3b93b399588$var$$strSlice(part, 0, 1);
        var last = $3a08f3b93b399588$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $1rcCL('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($bSXfZ($3a08f3b93b399588$var$INTRINSICS, intrinsicRealName)) value = $3a08f3b93b399588$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $jQFIR('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($7SE9t && i + 1 >= parts.length) {
                var desc = $7SE9t(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $bSXfZ(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $3a08f3b93b399588$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("39Ldl", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("2DlCe", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("TtWO0", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("aG0Ti", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("cwaZa", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("1rcCL", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("jQFIR", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("6Unty", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("38UJ9", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("iGzt4", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("dWJBO", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("i9udS", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("hE7Bh", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("gJSpD", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("8xHx6", function(module, exports) {
'use strict';

var $io64q = parcelRequire("io64q");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($io64q(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("io64q", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("7SE9t", function(module, exports) {
'use strict';

var $8rLHf = parcelRequire("8rLHf");
var $5bccb8dbb44f329c$require$$gOPD = $8rLHf;
if ($5bccb8dbb44f329c$require$$gOPD) try {
    $5bccb8dbb44f329c$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $5bccb8dbb44f329c$require$$gOPD = null;
}
module.exports = $5bccb8dbb44f329c$require$$gOPD;

});
parcelRegister("8rLHf", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("cILf7", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $942e3d902bcc477c$var$$defineProperty = Object.defineProperty || false;
if ($942e3d902bcc477c$var$$defineProperty) try {
    $942e3d902bcc477c$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $942e3d902bcc477c$var$$defineProperty = false;
}
module.exports = $942e3d902bcc477c$var$$defineProperty;

});

parcelRegister("fa2Fq", function(module, exports) {
'use strict';
var $b099dbd68238d6ce$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $9VQ4N = parcelRequire("9VQ4N");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $b099dbd68238d6ce$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $b099dbd68238d6ce$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $9VQ4N();
};

});

parcelRegister("cKjXh", function(module, exports) {
'use strict';

var $bOsTQ = parcelRequire("bOsTQ");

var $5O4uz = parcelRequire("5O4uz");

var $dv9TT = parcelRequire("dv9TT");
/** @type {import('.')} */ module.exports = $bOsTQ ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $bOsTQ(O);
} : $5O4uz ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $5O4uz(O);
} : $dv9TT ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $dv9TT(O);
} : null;

});
parcelRegister("bOsTQ", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("5O4uz", function(module, exports) {
'use strict';

var $39Ldl = parcelRequire("39Ldl");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $39Ldl.getPrototypeOf || null;

});

parcelRegister("dv9TT", function(module, exports) {
'use strict';

var $lH1kJ = parcelRequire("lH1kJ");

var $7SE9t = parcelRequire("7SE9t");
var $9d45d9abe8425603$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $9d45d9abe8425603$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $9d45d9abe8425603$var$desc = !!$9d45d9abe8425603$var$hasProtoAccessor && $7SE9t && $7SE9t(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $9d45d9abe8425603$var$$Object = Object;
var $9d45d9abe8425603$var$$getPrototypeOf = $9d45d9abe8425603$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $9d45d9abe8425603$var$desc && typeof $9d45d9abe8425603$var$desc.get === 'function' ? $lH1kJ([
    $9d45d9abe8425603$var$desc.get
]) : typeof $9d45d9abe8425603$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $9d45d9abe8425603$var$$getPrototypeOf(value == null ? value : $9d45d9abe8425603$var$$Object(value));
} : false;

});
parcelRegister("lH1kJ", function(module, exports) {
'use strict';

var $1rs7J = parcelRequire("1rs7J");

var $jQFIR = parcelRequire("jQFIR");

var $9ttrx = parcelRequire("9ttrx");

var $9LBpG = parcelRequire("9LBpG");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $jQFIR('a function is required');
    return $9LBpG($1rs7J, $9ttrx, args);
};

});
parcelRegister("1rs7J", function(module, exports) {
'use strict';

var $eXzJr = parcelRequire("eXzJr");
module.exports = Function.prototype.bind || $eXzJr;

});
parcelRegister("eXzJr", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $ae424afb5f8fb4e2$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $ae424afb5f8fb4e2$var$toStr = Object.prototype.toString;
var $ae424afb5f8fb4e2$var$max = Math.max;
var $ae424afb5f8fb4e2$var$funcType = '[object Function]';
var $ae424afb5f8fb4e2$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $ae424afb5f8fb4e2$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $ae424afb5f8fb4e2$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $ae424afb5f8fb4e2$var$toStr.apply(target) !== $ae424afb5f8fb4e2$var$funcType) throw new TypeError($ae424afb5f8fb4e2$var$ERROR_MESSAGE + target);
    var args = $ae424afb5f8fb4e2$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $ae424afb5f8fb4e2$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $ae424afb5f8fb4e2$var$concatty(args, arguments));
    };
    var boundLength = $ae424afb5f8fb4e2$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $ae424afb5f8fb4e2$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("9ttrx", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("9LBpG", function(module, exports) {
'use strict';

var $1rs7J = parcelRequire("1rs7J");

var $4G4X6 = parcelRequire("4G4X6");

var $9ttrx = parcelRequire("9ttrx");

var $4cvMh = parcelRequire("4cvMh");
/** @type {import('./actualApply')} */ module.exports = $4cvMh || $1rs7J.call($9ttrx, $4G4X6);

});
parcelRegister("4G4X6", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("4cvMh", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("bSXfZ", function(module, exports) {
'use strict';
var $8a72b41011bcef66$var$call = Function.prototype.call;
var $8a72b41011bcef66$var$$hasOwn = Object.prototype.hasOwnProperty;

var $1rs7J = parcelRequire("1rs7J");
/** @type {import('.')} */ module.exports = $1rs7J.call($8a72b41011bcef66$var$call, $8a72b41011bcef66$var$$hasOwn);

});




parcelRegister("3KZPn", function(module, exports) {
'use strict';

var $exvo0 = parcelRequire("exvo0");

var $cSOI9 = parcelRequire("cSOI9");
var $2bc5a0a7412e273a$var$isFnRegex = $cSOI9(/^\s*(?:function)?\*/);

var $2bc5a0a7412e273a$var$hasToStringTag = (parcelRequire("cJdfe"))();

var $cKjXh = parcelRequire("cKjXh");
var $2bc5a0a7412e273a$var$toStr = $exvo0('Object.prototype.toString');
var $2bc5a0a7412e273a$var$fnToStr = $exvo0('Function.prototype.toString');

var $l604U = parcelRequire("l604U");
/** @type {import('.')} */ module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== 'function') return false;
    if ($2bc5a0a7412e273a$var$isFnRegex($2bc5a0a7412e273a$var$fnToStr(fn))) return true;
    if (!$2bc5a0a7412e273a$var$hasToStringTag) {
        var str = $2bc5a0a7412e273a$var$toStr(fn);
        return str === '[object GeneratorFunction]';
    }
    if (!$cKjXh) return false;
    var GeneratorFunction = $l604U();
    return GeneratorFunction && $cKjXh(fn) === GeneratorFunction.prototype;
};

});
parcelRegister("cSOI9", function(module, exports) {
'use strict';

var $exvo0 = parcelRequire("exvo0");

var $98qmk = parcelRequire("98qmk");
var $9611dd5a5ec50113$var$$exec = $exvo0('RegExp.prototype.exec');

var $jQFIR = parcelRequire("jQFIR");
/** @type {import('.')} */ module.exports = function regexTester(regex) {
    if (!$98qmk(regex)) throw new $jQFIR('`regex` must be a RegExp');
    return function test(s) {
        return $9611dd5a5ec50113$var$$exec(regex, s) !== null;
    };
};

});
parcelRegister("98qmk", function(module, exports) {
'use strict';

var $exvo0 = parcelRequire("exvo0");

var $6a694ecd43212659$var$hasToStringTag = (parcelRequire("cJdfe"))();

var $bSXfZ = parcelRequire("bSXfZ");

var $7SE9t = parcelRequire("7SE9t");
/** @type {import('.')} */ var $6a694ecd43212659$var$fn;
if ($6a694ecd43212659$var$hasToStringTag) {
    /** @type {(receiver: ThisParameterType<typeof RegExp.prototype.exec>, ...args: Parameters<typeof RegExp.prototype.exec>) => ReturnType<typeof RegExp.prototype.exec>} */ var $6a694ecd43212659$var$$exec = $exvo0('RegExp.prototype.exec');
    /** @type {object} */ var $6a694ecd43212659$var$isRegexMarker = {};
    var $6a694ecd43212659$var$throwRegexMarker = function() {
        throw $6a694ecd43212659$var$isRegexMarker;
    };
    /** @type {{ toString(): never, valueOf(): never, [Symbol.toPrimitive]?(): never }} */ var $6a694ecd43212659$var$badStringifier = {
        toString: $6a694ecd43212659$var$throwRegexMarker,
        valueOf: $6a694ecd43212659$var$throwRegexMarker
    };
    if (typeof Symbol.toPrimitive === 'symbol') $6a694ecd43212659$var$badStringifier[Symbol.toPrimitive] = $6a694ecd43212659$var$throwRegexMarker;
    /** @type {import('.')} */ // @ts-expect-error TS can't figure out that the $exec call always throws
    // eslint-disable-next-line consistent-return
    $6a694ecd43212659$var$fn = function isRegex(value) {
        if (!value || typeof value !== 'object') return false;
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {NonNullable<typeof gOPD>} */ $7SE9t(/** @type {{ lastIndex?: unknown }} */ value, 'lastIndex');
        var hasLastIndexDataProperty = descriptor && $bSXfZ(descriptor, 'value');
        if (!hasLastIndexDataProperty) return false;
        try {
            // eslint-disable-next-line no-extra-parens
            $6a694ecd43212659$var$$exec(value, /** @type {unknown} */ $6a694ecd43212659$var$badStringifier);
        } catch (e) {
            return e === $6a694ecd43212659$var$isRegexMarker;
        }
    };
} else {
    /** @type {(receiver: ThisParameterType<typeof Object.prototype.toString>, ...args: Parameters<typeof Object.prototype.toString>) => ReturnType<typeof Object.prototype.toString>} */ var $6a694ecd43212659$var$$toString = $exvo0('Object.prototype.toString');
    /** @const @type {'[object RegExp]'} */ var $6a694ecd43212659$var$regexClass = '[object RegExp]';
    /** @type {import('.')} */ $6a694ecd43212659$var$fn = function isRegex(value) {
        // In older browsers, typeof regex incorrectly returns 'function'
        if (!value || typeof value !== 'object' && typeof value !== 'function') return false;
        return $6a694ecd43212659$var$$toString(value) === $6a694ecd43212659$var$regexClass;
    };
}
module.exports = $6a694ecd43212659$var$fn;

});


parcelRegister("l604U", function(module, exports) {
'use strict';
// eslint-disable-next-line no-extra-parens, no-empty-function
const $f5ba380e70281abd$var$cached = /** @type {GeneratorFunctionConstructor} */ (function*() {}).constructor;
/** @type {import('.')} */ module.exports = ()=>$f5ba380e70281abd$var$cached;

});


parcelRegister("8Cs36", function(module, exports) {
'use strict';

var $8VxG3 = parcelRequire("8VxG3");

var $gEiH1 = parcelRequire("gEiH1");

var $jkHVE = parcelRequire("jkHVE");

var $exvo0 = parcelRequire("exvo0");

var $7SE9t = parcelRequire("7SE9t");

var $cKjXh = parcelRequire("cKjXh");
var $6467a145798b4d0b$var$$toString = $exvo0('Object.prototype.toString');

var $6467a145798b4d0b$var$hasToStringTag = (parcelRequire("cJdfe"))();
var $6467a145798b4d0b$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $6467a145798b4d0b$var$typedArrays = $gEiH1();
var $6467a145798b4d0b$var$$slice = $exvo0('String.prototype.slice');
/** @import { BoundSet, BoundSlice, Cache, Getter } from './types' */ /** @import { TypedArrayName } from '.' */ /** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $6467a145798b4d0b$var$$indexOf = $exvo0('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @type {Cache} */ var $6467a145798b4d0b$var$cache = {
    __proto__: null
};
if ($6467a145798b4d0b$var$hasToStringTag && $7SE9t && $cKjXh) $8VxG3($6467a145798b4d0b$var$typedArrays, function(typedArray) {
    var arr = new $6467a145798b4d0b$var$g[typedArray]();
    if (Symbol.toStringTag in arr && $cKjXh) {
        var proto = $cKjXh(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $7SE9t(proto, Symbol.toStringTag);
        if (!descriptor && proto) {
            var superProto = $cKjXh(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $7SE9t(superProto, Symbol.toStringTag);
        }
        if (descriptor && descriptor.get) {
            var bound = $jkHVE(descriptor.get);
            $6467a145798b4d0b$var$cache[/** @type {`$${TypedArrayName}`} */ '$' + typedArray] = bound;
        }
    }
});
else $8VxG3($6467a145798b4d0b$var$typedArrays, function(typedArray) {
    var arr = new $6467a145798b4d0b$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) {
        var bound = /** @type {typeof BoundSlice | typeof BoundSet} */ // @ts-expect-error TODO FIXME
        $jkHVE(fn);
        $6467a145798b4d0b$var$cache[/** @type {`$${TypedArrayName}`} */ '$' + typedArray] = bound;
    }
});
/** @type {(value: object) => false | TypedArrayName} */ function $6467a145798b4d0b$var$tryTypedArrays(value) {
    /** @type {ReturnType<typeof tryTypedArrays>} */ var found = false;
    $8VxG3(/** @type {Record<`$${TypedArrayName}`, Getter>} */ $6467a145798b4d0b$var$cache, /** @param {Getter} getter @param {`$${TypedArrayName}`} typedArray */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            if ('$' + getter(value) === typedArray) found = /** @type {TypedArrayName} */ $6467a145798b4d0b$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
}
/** @type {(value: object) => false | TypedArrayName} */ function $6467a145798b4d0b$var$trySlices(value) {
    /** @type {ReturnType<typeof trySlices>} */ var found = false;
    $8VxG3(/** @type {Record<`$${TypedArrayName}`, Getter>} */ $6467a145798b4d0b$var$cache, /** @param {Getter} getter @param {`$${TypedArrayName}`} name */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            getter(value);
            found = /** @type {TypedArrayName} */ $6467a145798b4d0b$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
}
/** @type {(tag: unknown) => tag is typeof typedArrays[number]} */ function $6467a145798b4d0b$var$isTATag(tag) {
    return $6467a145798b4d0b$var$$indexOf($6467a145798b4d0b$var$typedArrays, tag) > -1;
}
/** @type {(value: unknown) => ReturnType<typeof import('.')>} */ function $6467a145798b4d0b$var$whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$6467a145798b4d0b$var$hasToStringTag) {
        var tag = $6467a145798b4d0b$var$$slice($6467a145798b4d0b$var$$toString(value), 8, -1);
        if ($6467a145798b4d0b$var$isTATag(tag)) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return $6467a145798b4d0b$var$trySlices(value);
    }
    if (!$7SE9t) return null;
     // unknown engine
    return $6467a145798b4d0b$var$tryTypedArrays(value);
}
module.exports = $6467a145798b4d0b$var$whichTypedArray;

});
parcelRegister("8VxG3", function(module, exports) {
'use strict';

var $9oota = parcelRequire("9oota");
var $67fdc52fb081d132$var$toStr = Object.prototype.toString;
var $67fdc52fb081d132$var$hasOwnProperty = Object.prototype.hasOwnProperty;
/** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */ var $67fdc52fb081d132$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($67fdc52fb081d132$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
/** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */ var $67fdc52fb081d132$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
/** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */ var $67fdc52fb081d132$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($67fdc52fb081d132$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
/** @type {(x: unknown) => x is readonly unknown[]} */ function $67fdc52fb081d132$var$isArray(x) {
    return $67fdc52fb081d132$var$toStr.call(x) === '[object Array]';
}
/** @type {import('.')._internal} */ module.exports = function forEach(list, iterator, thisArg) {
    if (!$9oota(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($67fdc52fb081d132$var$isArray(list)) $67fdc52fb081d132$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $67fdc52fb081d132$var$forEachString(list, iterator, receiver);
    else $67fdc52fb081d132$var$forEachObject(list, iterator, receiver);
};

});
parcelRegister("9oota", function(module, exports) {
'use strict';
var $6d69560fa6c74dba$var$fnToStr = Function.prototype.toString;
var $6d69560fa6c74dba$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var $6d69560fa6c74dba$var$badArrayLike;
var $6d69560fa6c74dba$var$isCallableMarker;
if (typeof $6d69560fa6c74dba$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $6d69560fa6c74dba$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw $6d69560fa6c74dba$var$isCallableMarker;
        }
    });
    $6d69560fa6c74dba$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $6d69560fa6c74dba$var$reflectApply(function() {
        throw 42;
    }, null, $6d69560fa6c74dba$var$badArrayLike);
} catch (_) {
    if (_ !== $6d69560fa6c74dba$var$isCallableMarker) $6d69560fa6c74dba$var$reflectApply = null;
}
else $6d69560fa6c74dba$var$reflectApply = null;
var $6d69560fa6c74dba$var$constructorRegex = /^\s*class\b/;
var $6d69560fa6c74dba$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $6d69560fa6c74dba$var$fnToStr.call(value);
        return $6d69560fa6c74dba$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $6d69560fa6c74dba$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($6d69560fa6c74dba$var$isES6ClassFn(value)) return false;
        $6d69560fa6c74dba$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $6d69560fa6c74dba$var$toStr = Object.prototype.toString;
var $6d69560fa6c74dba$var$objectClass = '[object Object]';
var $6d69560fa6c74dba$var$fnClass = '[object Function]';
var $6d69560fa6c74dba$var$genClass = '[object GeneratorFunction]';
var $6d69560fa6c74dba$var$ddaClass = '[object HTMLAllCollection]'; // IE 11
var $6d69560fa6c74dba$var$ddaClass2 = '[object HTML document.all class]';
var $6d69560fa6c74dba$var$ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var $6d69560fa6c74dba$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $6d69560fa6c74dba$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $6d69560fa6c74dba$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $6d69560fa6c74dba$var$all = document.all;
    if ($6d69560fa6c74dba$var$toStr.call($6d69560fa6c74dba$var$all) === $6d69560fa6c74dba$var$toStr.call(document.all)) $6d69560fa6c74dba$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($6d69560fa6c74dba$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = $6d69560fa6c74dba$var$toStr.call(value);
            return (str === $6d69560fa6c74dba$var$ddaClass || str === $6d69560fa6c74dba$var$ddaClass2 || str === $6d69560fa6c74dba$var$ddaClass3 // opera 12.16
             || str === $6d69560fa6c74dba$var$objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $6d69560fa6c74dba$var$reflectApply ? function isCallable(value) {
    if ($6d69560fa6c74dba$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        $6d69560fa6c74dba$var$reflectApply(value, null, $6d69560fa6c74dba$var$badArrayLike);
    } catch (e) {
        if (e !== $6d69560fa6c74dba$var$isCallableMarker) return false;
    }
    return !$6d69560fa6c74dba$var$isES6ClassFn(value) && $6d69560fa6c74dba$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($6d69560fa6c74dba$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if ($6d69560fa6c74dba$var$hasToStringTag) return $6d69560fa6c74dba$var$tryFunctionObject(value);
    if ($6d69560fa6c74dba$var$isES6ClassFn(value)) return false;
    var strClass = $6d69560fa6c74dba$var$toStr.call(value);
    if (strClass !== $6d69560fa6c74dba$var$fnClass && strClass !== $6d69560fa6c74dba$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $6d69560fa6c74dba$var$tryFunctionObject(value);
};

});


parcelRegister("gEiH1", function(module, exports) {
'use strict';

var $hesUA = parcelRequire("hesUA");
var $c1eee1ce878a8295$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $hesUA.length; i++)if (typeof $c1eee1ce878a8295$var$g[$hesUA[i]] === 'function') // @ts-expect-error
    out[out.length] = $hesUA[i];
    return out;
};

});
parcelRegister("hesUA", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float16Array',
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

});


parcelRegister("jkHVE", function(module, exports) {
'use strict';

var $djZMj = parcelRequire("djZMj");

var $cILf7 = parcelRequire("cILf7");

var $lH1kJ = parcelRequire("lH1kJ");

var $hS31d = parcelRequire("hS31d");
module.exports = function callBind(originalFunction) {
    var func = $lH1kJ(arguments);
    var adjustedLength = 1 + originalFunction.length - (arguments.length - 1);
    return $djZMj(func, adjustedLength > 0 ? adjustedLength : 0, true);
};
if ($cILf7) $cILf7(module.exports, 'apply', {
    value: $hS31d
});
else module.exports.apply = $hS31d;

});
parcelRegister("djZMj", function(module, exports) {
'use strict';

var $4YUXM = parcelRequire("4YUXM");

var $6dipk = parcelRequire("6dipk");

var $9b2cf88ebf061dcb$var$hasDescriptors = (parcelRequire("dp7dD"))();

var $7SE9t = parcelRequire("7SE9t");

var $jQFIR = parcelRequire("jQFIR");
var $9b2cf88ebf061dcb$var$$floor = $4YUXM('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $jQFIR('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $9b2cf88ebf061dcb$var$$floor(length) !== length) throw new $jQFIR('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $7SE9t) {
        var desc = $7SE9t(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($9b2cf88ebf061dcb$var$hasDescriptors) $6dipk(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $6dipk(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

});
parcelRegister("6dipk", function(module, exports) {
'use strict';

var $cILf7 = parcelRequire("cILf7");

var $1rcCL = parcelRequire("1rcCL");

var $jQFIR = parcelRequire("jQFIR");

var $7SE9t = parcelRequire("7SE9t");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $jQFIR('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $jQFIR('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $jQFIR('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $jQFIR('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $jQFIR('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $jQFIR('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$7SE9t && $7SE9t(obj, property);
    if ($cILf7) $cILf7(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $1rcCL('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

});

parcelRegister("dp7dD", function(module, exports) {
'use strict';

var $cILf7 = parcelRequire("cILf7");
var $9c2335b3e3936cef$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$cILf7;
};
$9c2335b3e3936cef$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$cILf7) return null;
    try {
        return $cILf7([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $9c2335b3e3936cef$var$hasPropertyDescriptors;

});


parcelRegister("hS31d", function(module, exports) {
'use strict';

var $1rs7J = parcelRequire("1rs7J");

var $4G4X6 = parcelRequire("4G4X6");

var $9LBpG = parcelRequire("9LBpG");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return $9LBpG($1rs7J, $4G4X6, arguments);
};

});



parcelRegister("2BlbL", function(module, exports) {
'use strict';

var $8Cs36 = parcelRequire("8Cs36");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$8Cs36(value);
};

});


parcelRegister("gVfcn", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

});

parcelRegister("b4Fkn", function(module, exports) {
var SVGtoPDF = function(doc, svg, x, y, options) {
    "use strict";
    const NamedColors = {
        aliceblue: [
            240,
            248,
            255
        ],
        antiquewhite: [
            250,
            235,
            215
        ],
        aqua: [
            0,
            255,
            255
        ],
        aquamarine: [
            127,
            255,
            212
        ],
        azure: [
            240,
            255,
            255
        ],
        beige: [
            245,
            245,
            220
        ],
        bisque: [
            255,
            228,
            196
        ],
        black: [
            0,
            0,
            0
        ],
        blanchedalmond: [
            255,
            235,
            205
        ],
        blue: [
            0,
            0,
            255
        ],
        blueviolet: [
            138,
            43,
            226
        ],
        brown: [
            165,
            42,
            42
        ],
        burlywood: [
            222,
            184,
            135
        ],
        cadetblue: [
            95,
            158,
            160
        ],
        chartreuse: [
            127,
            255,
            0
        ],
        chocolate: [
            210,
            105,
            30
        ],
        coral: [
            255,
            127,
            80
        ],
        cornflowerblue: [
            100,
            149,
            237
        ],
        cornsilk: [
            255,
            248,
            220
        ],
        crimson: [
            220,
            20,
            60
        ],
        cyan: [
            0,
            255,
            255
        ],
        darkblue: [
            0,
            0,
            139
        ],
        darkcyan: [
            0,
            139,
            139
        ],
        darkgoldenrod: [
            184,
            134,
            11
        ],
        darkgray: [
            169,
            169,
            169
        ],
        darkgrey: [
            169,
            169,
            169
        ],
        darkgreen: [
            0,
            100,
            0
        ],
        darkkhaki: [
            189,
            183,
            107
        ],
        darkmagenta: [
            139,
            0,
            139
        ],
        darkolivegreen: [
            85,
            107,
            47
        ],
        darkorange: [
            255,
            140,
            0
        ],
        darkorchid: [
            153,
            50,
            204
        ],
        darkred: [
            139,
            0,
            0
        ],
        darksalmon: [
            233,
            150,
            122
        ],
        darkseagreen: [
            143,
            188,
            143
        ],
        darkslateblue: [
            72,
            61,
            139
        ],
        darkslategray: [
            47,
            79,
            79
        ],
        darkslategrey: [
            47,
            79,
            79
        ],
        darkturquoise: [
            0,
            206,
            209
        ],
        darkviolet: [
            148,
            0,
            211
        ],
        deeppink: [
            255,
            20,
            147
        ],
        deepskyblue: [
            0,
            191,
            255
        ],
        dimgray: [
            105,
            105,
            105
        ],
        dimgrey: [
            105,
            105,
            105
        ],
        dodgerblue: [
            30,
            144,
            255
        ],
        firebrick: [
            178,
            34,
            34
        ],
        floralwhite: [
            255,
            250,
            240
        ],
        forestgreen: [
            34,
            139,
            34
        ],
        fuchsia: [
            255,
            0,
            255
        ],
        gainsboro: [
            220,
            220,
            220
        ],
        ghostwhite: [
            248,
            248,
            255
        ],
        gold: [
            255,
            215,
            0
        ],
        goldenrod: [
            218,
            165,
            32
        ],
        gray: [
            128,
            128,
            128
        ],
        grey: [
            128,
            128,
            128
        ],
        green: [
            0,
            128,
            0
        ],
        greenyellow: [
            173,
            255,
            47
        ],
        honeydew: [
            240,
            255,
            240
        ],
        hotpink: [
            255,
            105,
            180
        ],
        indianred: [
            205,
            92,
            92
        ],
        indigo: [
            75,
            0,
            130
        ],
        ivory: [
            255,
            255,
            240
        ],
        khaki: [
            240,
            230,
            140
        ],
        lavender: [
            230,
            230,
            250
        ],
        lavenderblush: [
            255,
            240,
            245
        ],
        lawngreen: [
            124,
            252,
            0
        ],
        lemonchiffon: [
            255,
            250,
            205
        ],
        lightblue: [
            173,
            216,
            230
        ],
        lightcoral: [
            240,
            128,
            128
        ],
        lightcyan: [
            224,
            255,
            255
        ],
        lightgoldenrodyellow: [
            250,
            250,
            210
        ],
        lightgray: [
            211,
            211,
            211
        ],
        lightgrey: [
            211,
            211,
            211
        ],
        lightgreen: [
            144,
            238,
            144
        ],
        lightpink: [
            255,
            182,
            193
        ],
        lightsalmon: [
            255,
            160,
            122
        ],
        lightseagreen: [
            32,
            178,
            170
        ],
        lightskyblue: [
            135,
            206,
            250
        ],
        lightslategray: [
            119,
            136,
            153
        ],
        lightslategrey: [
            119,
            136,
            153
        ],
        lightsteelblue: [
            176,
            196,
            222
        ],
        lightyellow: [
            255,
            255,
            224
        ],
        lime: [
            0,
            255,
            0
        ],
        limegreen: [
            50,
            205,
            50
        ],
        linen: [
            250,
            240,
            230
        ],
        magenta: [
            255,
            0,
            255
        ],
        maroon: [
            128,
            0,
            0
        ],
        mediumaquamarine: [
            102,
            205,
            170
        ],
        mediumblue: [
            0,
            0,
            205
        ],
        mediumorchid: [
            186,
            85,
            211
        ],
        mediumpurple: [
            147,
            112,
            219
        ],
        mediumseagreen: [
            60,
            179,
            113
        ],
        mediumslateblue: [
            123,
            104,
            238
        ],
        mediumspringgreen: [
            0,
            250,
            154
        ],
        mediumturquoise: [
            72,
            209,
            204
        ],
        mediumvioletred: [
            199,
            21,
            133
        ],
        midnightblue: [
            25,
            25,
            112
        ],
        mintcream: [
            245,
            255,
            250
        ],
        mistyrose: [
            255,
            228,
            225
        ],
        moccasin: [
            255,
            228,
            181
        ],
        navajowhite: [
            255,
            222,
            173
        ],
        navy: [
            0,
            0,
            128
        ],
        oldlace: [
            253,
            245,
            230
        ],
        olive: [
            128,
            128,
            0
        ],
        olivedrab: [
            107,
            142,
            35
        ],
        orange: [
            255,
            165,
            0
        ],
        orangered: [
            255,
            69,
            0
        ],
        orchid: [
            218,
            112,
            214
        ],
        palegoldenrod: [
            238,
            232,
            170
        ],
        palegreen: [
            152,
            251,
            152
        ],
        paleturquoise: [
            175,
            238,
            238
        ],
        palevioletred: [
            219,
            112,
            147
        ],
        papayawhip: [
            255,
            239,
            213
        ],
        peachpuff: [
            255,
            218,
            185
        ],
        peru: [
            205,
            133,
            63
        ],
        pink: [
            255,
            192,
            203
        ],
        plum: [
            221,
            160,
            221
        ],
        powderblue: [
            176,
            224,
            230
        ],
        purple: [
            128,
            0,
            128
        ],
        rebeccapurple: [
            102,
            51,
            153
        ],
        red: [
            255,
            0,
            0
        ],
        rosybrown: [
            188,
            143,
            143
        ],
        royalblue: [
            65,
            105,
            225
        ],
        saddlebrown: [
            139,
            69,
            19
        ],
        salmon: [
            250,
            128,
            114
        ],
        sandybrown: [
            244,
            164,
            96
        ],
        seagreen: [
            46,
            139,
            87
        ],
        seashell: [
            255,
            245,
            238
        ],
        sienna: [
            160,
            82,
            45
        ],
        silver: [
            192,
            192,
            192
        ],
        skyblue: [
            135,
            206,
            235
        ],
        slateblue: [
            106,
            90,
            205
        ],
        slategray: [
            112,
            128,
            144
        ],
        slategrey: [
            112,
            128,
            144
        ],
        snow: [
            255,
            250,
            250
        ],
        springgreen: [
            0,
            255,
            127
        ],
        steelblue: [
            70,
            130,
            180
        ],
        tan: [
            210,
            180,
            140
        ],
        teal: [
            0,
            128,
            128
        ],
        thistle: [
            216,
            191,
            216
        ],
        tomato: [
            255,
            99,
            71
        ],
        turquoise: [
            64,
            224,
            208
        ],
        violet: [
            238,
            130,
            238
        ],
        wheat: [
            245,
            222,
            179
        ],
        white: [
            255,
            255,
            255
        ],
        whitesmoke: [
            245,
            245,
            245
        ],
        yellow: [
            255,
            255,
            0
        ]
    };
    const DefaultColors = {
        black: [
            NamedColors.black,
            1
        ],
        white: [
            NamedColors.white,
            1
        ],
        transparent: [
            NamedColors.black,
            0
        ]
    };
    const Entities = {
        quot: 34,
        amp: 38,
        lt: 60,
        gt: 62,
        apos: 39,
        OElig: 338,
        oelig: 339,
        Scaron: 352,
        scaron: 353,
        Yuml: 376,
        circ: 710,
        tilde: 732,
        ensp: 8194,
        emsp: 8195,
        thinsp: 8201,
        zwnj: 8204,
        zwj: 8205,
        lrm: 8206,
        rlm: 8207,
        ndash: 8211,
        mdash: 8212,
        lsquo: 8216,
        rsquo: 8217,
        sbquo: 8218,
        ldquo: 8220,
        rdquo: 8221,
        bdquo: 8222,
        dagger: 8224,
        Dagger: 8225,
        permil: 8240,
        lsaquo: 8249,
        rsaquo: 8250,
        euro: 8364,
        nbsp: 160,
        iexcl: 161,
        cent: 162,
        pound: 163,
        curren: 164,
        yen: 165,
        brvbar: 166,
        sect: 167,
        uml: 168,
        copy: 169,
        ordf: 170,
        laquo: 171,
        not: 172,
        shy: 173,
        reg: 174,
        macr: 175,
        deg: 176,
        plusmn: 177,
        sup2: 178,
        sup3: 179,
        acute: 180,
        micro: 181,
        para: 182,
        middot: 183,
        cedil: 184,
        sup1: 185,
        ordm: 186,
        raquo: 187,
        frac14: 188,
        frac12: 189,
        frac34: 190,
        iquest: 191,
        Agrave: 192,
        Aacute: 193,
        Acirc: 194,
        Atilde: 195,
        Auml: 196,
        Aring: 197,
        AElig: 198,
        Ccedil: 199,
        Egrave: 200,
        Eacute: 201,
        Ecirc: 202,
        Euml: 203,
        Igrave: 204,
        Iacute: 205,
        Icirc: 206,
        Iuml: 207,
        ETH: 208,
        Ntilde: 209,
        Ograve: 210,
        Oacute: 211,
        Ocirc: 212,
        Otilde: 213,
        Ouml: 214,
        times: 215,
        Oslash: 216,
        Ugrave: 217,
        Uacute: 218,
        Ucirc: 219,
        Uuml: 220,
        Yacute: 221,
        THORN: 222,
        szlig: 223,
        agrave: 224,
        aacute: 225,
        acirc: 226,
        atilde: 227,
        auml: 228,
        aring: 229,
        aelig: 230,
        ccedil: 231,
        egrave: 232,
        eacute: 233,
        ecirc: 234,
        euml: 235,
        igrave: 236,
        iacute: 237,
        icirc: 238,
        iuml: 239,
        eth: 240,
        ntilde: 241,
        ograve: 242,
        oacute: 243,
        ocirc: 244,
        otilde: 245,
        ouml: 246,
        divide: 247,
        oslash: 248,
        ugrave: 249,
        uacute: 250,
        ucirc: 251,
        uuml: 252,
        yacute: 253,
        thorn: 254,
        yuml: 255,
        fnof: 402,
        Alpha: 913,
        Beta: 914,
        Gamma: 915,
        Delta: 916,
        Epsilon: 917,
        Zeta: 918,
        Eta: 919,
        Theta: 920,
        Iota: 921,
        Kappa: 922,
        Lambda: 923,
        Mu: 924,
        Nu: 925,
        Xi: 926,
        Omicron: 927,
        Pi: 928,
        Rho: 929,
        Sigma: 931,
        Tau: 932,
        Upsilon: 933,
        Phi: 934,
        Chi: 935,
        Psi: 936,
        Omega: 937,
        alpha: 945,
        beta: 946,
        gamma: 947,
        delta: 948,
        epsilon: 949,
        zeta: 950,
        eta: 951,
        theta: 952,
        iota: 953,
        kappa: 954,
        lambda: 955,
        mu: 956,
        nu: 957,
        xi: 958,
        omicron: 959,
        pi: 960,
        rho: 961,
        sigmaf: 962,
        sigma: 963,
        tau: 964,
        upsilon: 965,
        phi: 966,
        chi: 967,
        psi: 968,
        omega: 969,
        thetasym: 977,
        upsih: 978,
        piv: 982,
        bull: 8226,
        hellip: 8230,
        prime: 8242,
        Prime: 8243,
        oline: 8254,
        frasl: 8260,
        weierp: 8472,
        image: 8465,
        real: 8476,
        trade: 8482,
        alefsym: 8501,
        larr: 8592,
        uarr: 8593,
        rarr: 8594,
        darr: 8595,
        harr: 8596,
        crarr: 8629,
        lArr: 8656,
        uArr: 8657,
        rArr: 8658,
        dArr: 8659,
        hArr: 8660,
        forall: 8704,
        part: 8706,
        exist: 8707,
        empty: 8709,
        nabla: 8711,
        isin: 8712,
        notin: 8713,
        ni: 8715,
        prod: 8719,
        sum: 8721,
        minus: 8722,
        lowast: 8727,
        radic: 8730,
        prop: 8733,
        infin: 8734,
        ang: 8736,
        and: 8743,
        or: 8744,
        cap: 8745,
        cup: 8746,
        int: 8747,
        there4: 8756,
        sim: 8764,
        cong: 8773,
        asymp: 8776,
        ne: 8800,
        equiv: 8801,
        le: 8804,
        ge: 8805,
        sub: 8834,
        sup: 8835,
        nsub: 8836,
        sube: 8838,
        supe: 8839,
        oplus: 8853,
        otimes: 8855,
        perp: 8869,
        sdot: 8901,
        lceil: 8968,
        rceil: 8969,
        lfloor: 8970,
        rfloor: 8971,
        lang: 9001,
        rang: 9002,
        loz: 9674,
        spades: 9824,
        clubs: 9827,
        hearts: 9829,
        diams: 9830
    };
    const PathArguments = {
        A: 7,
        a: 7,
        C: 6,
        c: 6,
        H: 1,
        h: 1,
        L: 2,
        l: 2,
        M: 2,
        m: 2,
        Q: 4,
        q: 4,
        S: 4,
        s: 4,
        T: 2,
        t: 2,
        V: 1,
        v: 1,
        Z: 0,
        z: 0
    };
    const PathFlags = {
        A3: true,
        A4: true,
        a3: true,
        a4: true
    };
    const Properties = {
        'color': {
            inherit: true,
            initial: undefined
        },
        'visibility': {
            inherit: true,
            initial: 'visible',
            values: {
                'hidden': 'hidden',
                'collapse': 'hidden',
                'visible': 'visible'
            }
        },
        'fill': {
            inherit: true,
            initial: DefaultColors.black
        },
        'stroke': {
            inherit: true,
            initial: 'none'
        },
        'stop-color': {
            inherit: false,
            initial: DefaultColors.black
        },
        'fill-opacity': {
            inherit: true,
            initial: 1
        },
        'stroke-opacity': {
            inherit: true,
            initial: 1
        },
        'stop-opacity': {
            inherit: false,
            initial: 1
        },
        'fill-rule': {
            inherit: true,
            initial: 'nonzero',
            values: {
                'nonzero': 'nonzero',
                'evenodd': 'evenodd'
            }
        },
        'clip-rule': {
            inherit: true,
            initial: 'nonzero',
            values: {
                'nonzero': 'nonzero',
                'evenodd': 'evenodd'
            }
        },
        'stroke-width': {
            inherit: true,
            initial: 1
        },
        'stroke-dasharray': {
            inherit: true,
            initial: []
        },
        'stroke-dashoffset': {
            inherit: true,
            initial: 0
        },
        'stroke-miterlimit': {
            inherit: true,
            initial: 4
        },
        'stroke-linejoin': {
            inherit: true,
            initial: 'miter',
            values: {
                'miter': 'miter',
                'round': 'round',
                'bevel': 'bevel'
            }
        },
        'stroke-linecap': {
            inherit: true,
            initial: 'butt',
            values: {
                'butt': 'butt',
                'round': 'round',
                'square': 'square'
            }
        },
        'font-size': {
            inherit: true,
            initial: 16,
            values: {
                'xx-small': 9,
                'x-small': 10,
                'small': 13,
                'medium': 16,
                'large': 18,
                'x-large': 24,
                'xx-large': 32
            }
        },
        'font-family': {
            inherit: true,
            initial: 'sans-serif'
        },
        'font-weight': {
            inherit: true,
            initial: 'normal',
            values: {
                '600': 'bold',
                '700': 'bold',
                '800': 'bold',
                '900': 'bold',
                'bold': 'bold',
                'bolder': 'bold',
                '500': 'normal',
                '400': 'normal',
                '300': 'normal',
                '200': 'normal',
                '100': 'normal',
                'normal': 'normal',
                'lighter': 'normal'
            }
        },
        'font-style': {
            inherit: true,
            initial: 'normal',
            values: {
                'italic': 'italic',
                'oblique': 'italic',
                'normal': 'normal'
            }
        },
        'text-anchor': {
            inherit: true,
            initial: 'start',
            values: {
                'start': 'start',
                'middle': 'middle',
                'end': 'end'
            }
        },
        'direction': {
            inherit: true,
            initial: 'ltr',
            values: {
                'ltr': 'ltr',
                'rtl': 'rtl'
            }
        },
        'dominant-baseline': {
            inherit: true,
            initial: 'baseline',
            values: {
                'auto': 'baseline',
                'baseline': 'baseline',
                'before-edge': 'before-edge',
                'text-before-edge': 'before-edge',
                'middle': 'middle',
                'central': 'central',
                'after-edge': 'after-edge',
                'text-after-edge': 'after-edge',
                'ideographic': 'ideographic',
                'alphabetic': 'alphabetic',
                'hanging': 'hanging',
                'mathematical': 'mathematical'
            }
        },
        'alignment-baseline': {
            inherit: false,
            initial: undefined,
            values: {
                'auto': 'baseline',
                'baseline': 'baseline',
                'before-edge': 'before-edge',
                'text-before-edge': 'before-edge',
                'middle': 'middle',
                'central': 'central',
                'after-edge': 'after-edge',
                'text-after-edge': 'after-edge',
                'ideographic': 'ideographic',
                'alphabetic': 'alphabetic',
                'hanging': 'hanging',
                'mathematical': 'mathematical'
            }
        },
        'baseline-shift': {
            inherit: true,
            initial: 'baseline',
            values: {
                'baseline': 'baseline',
                'sub': 'sub',
                'super': 'super'
            }
        },
        'word-spacing': {
            inherit: true,
            initial: 0,
            values: {
                normal: 0
            }
        },
        'letter-spacing': {
            inherit: true,
            initial: 0,
            values: {
                normal: 0
            }
        },
        'text-decoration': {
            inherit: false,
            initial: 'none',
            values: {
                'none': 'none',
                'underline': 'underline',
                'overline': 'overline',
                'line-through': 'line-through'
            }
        },
        'xml:space': {
            inherit: true,
            initial: 'default',
            css: 'white-space',
            values: {
                'preserve': 'preserve',
                'default': 'default',
                'pre': 'preserve',
                'pre-line': 'preserve',
                'pre-wrap': 'preserve',
                'nowrap': 'default'
            }
        },
        'marker-start': {
            inherit: true,
            initial: 'none'
        },
        'marker-mid': {
            inherit: true,
            initial: 'none'
        },
        'marker-end': {
            inherit: true,
            initial: 'none'
        },
        'opacity': {
            inherit: false,
            initial: 1
        },
        'transform': {
            inherit: false,
            initial: [
                1,
                0,
                0,
                1,
                0,
                0
            ]
        },
        'display': {
            inherit: false,
            initial: 'inline',
            values: {
                'none': 'none',
                'inline': 'inline',
                'block': 'inline'
            }
        },
        'clip-path': {
            inherit: false,
            initial: 'none'
        },
        'mask': {
            inherit: false,
            initial: 'none'
        },
        'overflow': {
            inherit: false,
            initial: 'hidden',
            values: {
                'hidden': 'hidden',
                'scroll': 'hidden',
                'visible': 'visible'
            }
        }
    };
    function docBeginGroup(bbox) {
        let group = new function PDFGroup() {}();
        group.name = 'G' + (doc._groupCount = (doc._groupCount || 0) + 1);
        group.resources = doc.ref();
        group.xobj = doc.ref({
            Type: 'XObject',
            Subtype: 'Form',
            FormType: 1,
            BBox: bbox,
            Group: {
                S: 'Transparency',
                CS: 'DeviceRGB',
                I: true,
                K: false
            },
            Resources: group.resources
        });
        group.xobj.write('');
        group.savedMatrix = doc._ctm;
        group.savedPage = doc.page;
        groupStack.push(group);
        doc._ctm = [
            1,
            0,
            0,
            1,
            0,
            0
        ];
        doc.page = {
            width: doc.page.width,
            height: doc.page.height,
            write: function(data) {
                group.xobj.write(data);
            },
            fonts: {},
            xobjects: {},
            ext_gstates: {},
            patterns: {}
        };
        return group;
    }
    function docEndGroup(group) {
        if (group !== groupStack.pop()) throw 'Group not matching';
        if (Object.keys(doc.page.fonts).length) group.resources.data.Font = doc.page.fonts;
        if (Object.keys(doc.page.xobjects).length) group.resources.data.XObject = doc.page.xobjects;
        if (Object.keys(doc.page.ext_gstates).length) group.resources.data.ExtGState = doc.page.ext_gstates;
        if (Object.keys(doc.page.patterns).length) group.resources.data.Pattern = doc.page.patterns;
        group.resources.end();
        group.xobj.end();
        doc._ctm = group.savedMatrix;
        doc.page = group.savedPage;
    }
    function docInsertGroup(group) {
        doc.page.xobjects[group.name] = group.xobj;
        doc.addContent('/' + group.name + ' Do');
    }
    function docApplyMask(group, clip) {
        let name = 'M' + (doc._maskCount = (doc._maskCount || 0) + 1);
        let gstate = doc.ref({
            Type: 'ExtGState',
            CA: 1,
            ca: 1,
            BM: 'Normal',
            SMask: {
                S: 'Luminosity',
                G: group.xobj,
                BC: clip ? [
                    0,
                    0,
                    0
                ] : [
                    1,
                    1,
                    1
                ]
            }
        });
        gstate.end();
        doc.page.ext_gstates[name] = gstate;
        doc.addContent('/' + name + ' gs');
    }
    function docCreatePattern(group, dx, dy, matrix) {
        let pattern = new function PDFPattern() {}();
        pattern.group = group;
        pattern.dx = dx;
        pattern.dy = dy;
        pattern.matrix = matrix || [
            1,
            0,
            0,
            1,
            0,
            0
        ];
        return pattern;
    }
    function docUsePattern(pattern, stroke) {
        let name = 'P' + (doc._patternCount = (doc._patternCount || 0) + 1);
        let ref = doc.ref({
            Type: 'Pattern',
            PatternType: 1,
            PaintType: 1,
            TilingType: 2,
            BBox: [
                0,
                0,
                pattern.dx,
                pattern.dy
            ],
            XStep: pattern.dx,
            YStep: pattern.dy,
            Matrix: multiplyMatrix(doc._ctm, pattern.matrix),
            Resources: {
                ProcSet: [
                    'PDF',
                    'Text',
                    'ImageB',
                    'ImageC',
                    'ImageI'
                ],
                XObject: function() {
                    let temp = {};
                    temp[pattern.group.name] = pattern.group.xobj;
                    return temp;
                }()
            }
        });
        ref.write('/' + pattern.group.name + ' Do');
        ref.end();
        doc.page.patterns[name] = ref;
        if (stroke) {
            doc.addContent('/Pattern CS');
            doc.addContent('/' + name + ' SCN');
        } else {
            doc.addContent('/Pattern cs');
            doc.addContent('/' + name + ' scn');
        }
    }
    function docBeginText(font, size) {
        if (!doc.page.fonts[font.id]) doc.page.fonts[font.id] = font.ref();
        doc.addContent('BT').addContent('/' + font.id + ' ' + size + ' Tf');
    }
    function docSetTextMatrix(a, b, c, d, e, f) {
        doc.addContent(validateNumber(a) + ' ' + validateNumber(b) + ' ' + validateNumber(-c) + ' ' + validateNumber(-d) + ' ' + validateNumber(e) + ' ' + validateNumber(f) + ' Tm');
    }
    function docSetTextMode(fill, stroke) {
        let mode = fill && stroke ? 2 : stroke ? 1 : fill ? 0 : 3;
        doc.addContent(mode + ' Tr');
    }
    function docWriteGlyph(glyph) {
        doc.addContent('<' + glyph + '> Tj');
    }
    function docEndText() {
        doc.addContent('ET');
    }
    function docFillColor(color) {
        if (color[0].constructor.name === 'PDFPattern') {
            doc.fillOpacity(color[1]);
            docUsePattern(color[0], false);
        } else doc.fillColor(color[0], color[1]);
    }
    function docStrokeColor(color) {
        if (color[0].constructor.name === 'PDFPattern') {
            doc.strokeOpacity(color[1]);
            docUsePattern(color[0], true);
        } else doc.strokeColor(color[0], color[1]);
    }
    function docInsertLink(x, y, w, h, url) {
        let ref = doc.ref({
            Type: 'Annot',
            Subtype: 'Link',
            Rect: [
                x,
                y,
                w,
                h
            ],
            Border: [
                0,
                0,
                0
            ],
            A: {
                S: 'URI',
                URI: new String(url)
            }
        });
        ref.end();
        links.push(ref);
    }
    function parseXml(xml) {
        let SvgNode = function(tag, type, value, error) {
            this.error = error;
            this.nodeName = tag;
            this.nodeValue = value;
            this.nodeType = type;
            this.attributes = Object.create(null);
            this.childNodes = [];
            this.parentNode = null;
            this.id = '';
            this.textContent = '';
            this.classList = [];
        };
        SvgNode.prototype.getAttribute = function(attr) {
            return this.attributes[attr] != null ? this.attributes[attr] : null;
        };
        SvgNode.prototype.getElementById = function(id) {
            let result = null;
            (function recursive(node) {
                if (result) return;
                if (node.nodeType === 1) {
                    if (node.id === id) result = node;
                    for(let i = 0; i < node.childNodes.length; i++)recursive(node.childNodes[i]);
                }
            })(this);
            return result;
        };
        SvgNode.prototype.getElementsByTagName = function(tag) {
            let result = [];
            (function recursive(node) {
                if (node.nodeType === 1) {
                    if (node.nodeName === tag) result.push(node);
                    for(let i = 0; i < node.childNodes.length; i++)recursive(node.childNodes[i]);
                }
            })(this);
            return result;
        };
        let parser = new StringParser(xml.trim()), result, child, error = false;
        let recursive = function() {
            let temp, child;
            if (temp = parser.match(/^<([\w:.-]+)\s*/, true)) {
                let node = new SvgNode(temp[1], 1, null, error);
                while(temp = parser.match(/^([\w:.-]+)(?:\s*=\s*"([^"]*)"|\s*=\s*'([^']*)')?\s*/, true)){
                    let attr = temp[1], value = decodeEntities(temp[2] || temp[3] || '');
                    if (!node.attributes[attr]) {
                        node.attributes[attr] = value;
                        if (attr === 'id') node.id = value;
                        if (attr === 'class') node.classList = value.split(' ');
                    } else {
                        warningCallback('parseXml: duplicate attribute "' + attr + '"');
                        error = true;
                    }
                }
                if (parser.match(/^>/)) {
                    while(child = recursive()){
                        node.childNodes.push(child);
                        child.parentNode = node;
                        node.textContent += child.nodeType === 3 || child.nodeType === 4 ? child.nodeValue : child.textContent;
                    }
                    if (temp = parser.match(/^<\/([\w:.-]+)\s*>/, true)) {
                        if (temp[1] === node.nodeName) return node;
                        else {
                            warningCallback('parseXml: tag not matching, opening "' + node.nodeName + '" & closing "' + temp[1] + '"');
                            error = true;
                            return node;
                        }
                    } else {
                        warningCallback('parseXml: tag not matching, opening "' + node.nodeName + '" & not closing');
                        error = true;
                        return node;
                    }
                } else if (parser.match(/^\/>/)) return node;
                else {
                    warningCallback('parseXml: tag could not be parsed "' + node.nodeName + '"');
                    error = true;
                }
            } else if (temp = parser.match(/^<!--[\s\S]*?-->/)) return new SvgNode(null, 8, temp, error);
            else if (temp = parser.match(/^<\?[\s\S]*?\?>/)) return new SvgNode(null, 7, temp, error);
            else if (temp = parser.match(/^<!DOCTYPE\s*([\s\S]*?)>/)) return new SvgNode(null, 10, temp, error);
            else if (temp = parser.match(/^<!\[CDATA\[([\s\S]*?)\]\]>/, true)) return new SvgNode('#cdata-section', 4, temp[1], error);
            else if (temp = parser.match(/^([^<]+)/, true)) return new SvgNode('#text', 3, decodeEntities(temp[1]), error);
        };
        while(child = recursive()){
            if (child.nodeType === 1 && !result) result = child;
            else if (child.nodeType === 1 || child.nodeType === 3 && child.nodeValue.trim() !== '') warningCallback('parseXml: data after document end has been discarded');
        }
        if (parser.matchAll()) warningCallback('parseXml: parsing error');
        return result;
    }
    function decodeEntities(str) {
        return str.replace(/&(?:#([0-9]+)|#[xX]([0-9A-Fa-f]+)|([0-9A-Za-z]+));/g, function(mt, m0, m1, m2) {
            if (m0) return String.fromCharCode(parseInt(m0, 10));
            else if (m1) return String.fromCharCode(parseInt(m1, 16));
            else if (m2 && Entities[m2]) return String.fromCharCode(Entities[m2]);
            else return mt;
        });
    }
    function parseColor(raw) {
        let temp, result;
        raw = (raw || '').trim();
        if (temp = NamedColors[raw]) result = [
            temp.slice(),
            1
        ];
        else if (temp = raw.match(/^rgba\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9.]+)\s*\)$/i)) {
            temp[1] = parseInt(temp[1]);
            temp[2] = parseInt(temp[2]);
            temp[3] = parseInt(temp[3]);
            temp[4] = parseFloat(temp[4]);
            if (temp[1] < 256 && temp[2] < 256 && temp[3] < 256 && temp[4] <= 1) result = [
                temp.slice(1, 4),
                temp[4]
            ];
        } else if (temp = raw.match(/^rgb\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*\)$/i)) {
            temp[1] = parseInt(temp[1]);
            temp[2] = parseInt(temp[2]);
            temp[3] = parseInt(temp[3]);
            if (temp[1] < 256 && temp[2] < 256 && temp[3] < 256) result = [
                temp.slice(1, 4),
                1
            ];
        } else if (temp = raw.match(/^rgb\(\s*([0-9.]+)%\s*,\s*([0-9.]+)%\s*,\s*([0-9.]+)%\s*\)$/i)) {
            temp[1] = 2.55 * parseFloat(temp[1]);
            temp[2] = 2.55 * parseFloat(temp[2]);
            temp[3] = 2.55 * parseFloat(temp[3]);
            if (temp[1] < 256 && temp[2] < 256 && temp[3] < 256) result = [
                temp.slice(1, 4),
                1
            ];
        } else if (temp = raw.match(/^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i)) result = [
            [
                parseInt(temp[1], 16),
                parseInt(temp[2], 16),
                parseInt(temp[3], 16)
            ],
            1
        ];
        else if (temp = raw.match(/^#([0-9a-f])([0-9a-f])([0-9a-f])$/i)) result = [
            [
                0x11 * parseInt(temp[1], 16),
                0x11 * parseInt(temp[2], 16),
                0x11 * parseInt(temp[3], 16)
            ],
            1
        ];
        return colorCallback ? colorCallback(result, raw) : result;
    }
    function opacityToColor(color, opacity, isMask) {
        let newColor = color[0].slice(), newOpacity = color[1] * opacity;
        if (isMask) {
            for(let i = 0; i < color.length; i++)newColor[i] *= newOpacity;
            return [
                newColor,
                1
            ];
        } else return [
            newColor,
            newOpacity
        ];
    }
    function multiplyMatrix() {
        function multiply(a, b) {
            return [
                a[0] * b[0] + a[2] * b[1],
                a[1] * b[0] + a[3] * b[1],
                a[0] * b[2] + a[2] * b[3],
                a[1] * b[2] + a[3] * b[3],
                a[0] * b[4] + a[2] * b[5] + a[4],
                a[1] * b[4] + a[3] * b[5] + a[5]
            ];
        }
        let result = arguments[0];
        for(let i = 1; i < arguments.length; i++)result = multiply(result, arguments[i]);
        return result;
    }
    function transformPoint(p, m) {
        return [
            m[0] * p[0] + m[2] * p[1] + m[4],
            m[1] * p[0] + m[3] * p[1] + m[5]
        ];
    }
    function getGlobalMatrix() {
        let ctm = doc._ctm;
        for(let i = groupStack.length - 1; i >= 0; i--)ctm = multiplyMatrix(groupStack[i].savedMatrix, ctm);
        return ctm;
    }
    function getPageBBox() {
        return new SvgShape().M(0, 0).L(doc.page.width, 0).L(doc.page.width, doc.page.height).L(0, doc.page.height).transform(inverseMatrix(getGlobalMatrix())).getBoundingBox();
    }
    function inverseMatrix(m) {
        let dt = m[0] * m[3] - m[1] * m[2];
        return [
            m[3] / dt,
            -m[1] / dt,
            -m[2] / dt,
            m[0] / dt,
            (m[2] * m[5] - m[3] * m[4]) / dt,
            (m[1] * m[4] - m[0] * m[5]) / dt
        ];
    }
    function validateMatrix(m) {
        let m0 = validateNumber(m[0]), m1 = validateNumber(m[1]), m2 = validateNumber(m[2]), m3 = validateNumber(m[3]), m4 = validateNumber(m[4]), m5 = validateNumber(m[5]);
        if (isNotEqual(m0 * m3 - m1 * m2, 0)) return [
            m0,
            m1,
            m2,
            m3,
            m4,
            m5
        ];
    }
    function solveEquation(curve) {
        let a = curve[2] || 0, b = curve[1] || 0, c = curve[0] || 0;
        if (isEqual(a, 0) && isEqual(b, 0)) return [];
        else if (isEqual(a, 0)) return [
            -c / b
        ];
        else {
            let d = b * b - 4 * a * c;
            if (isNotEqual(d, 0) && d > 0) return [
                (-b + Math.sqrt(d)) / (2 * a),
                (-b - Math.sqrt(d)) / (2 * a)
            ];
            else if (isEqual(d, 0)) return [
                -b / (2 * a)
            ];
            else return [];
        }
    }
    function getCurveValue(t, curve) {
        return (curve[0] || 0) + (curve[1] || 0) * t + (curve[2] || 0) * t * t + (curve[3] || 0) * t * t * t;
    }
    function isEqual(number, ref) {
        return Math.abs(number - ref) < 1e-10;
    }
    function isNotEqual(number, ref) {
        return Math.abs(number - ref) >= 1e-10;
    }
    function validateNumber(n) {
        return n > -1000000000000000000000 && n < 1e21 ? Math.round(n * 1e6) / 1e6 : 0;
    }
    function isArrayLike(v) {
        return typeof v === 'object' && v !== null && typeof v.length === 'number';
    }
    function parseTranform(v) {
        let parser = new StringParser((v || '').trim()), result = [
            1,
            0,
            0,
            1,
            0,
            0
        ], temp;
        while(temp = parser.match(/^([A-Za-z]+)\s*[(]([^(]+)[)]/, true)){
            let func = temp[1], nums = [], parser2 = new StringParser(temp[2].trim()), temp2;
            while(temp2 = parser2.matchNumber()){
                nums.push(Number(temp2));
                parser2.matchSeparator();
            }
            if (func === 'matrix' && nums.length === 6) result = multiplyMatrix(result, [
                nums[0],
                nums[1],
                nums[2],
                nums[3],
                nums[4],
                nums[5]
            ]);
            else if (func === 'translate' && nums.length === 2) result = multiplyMatrix(result, [
                1,
                0,
                0,
                1,
                nums[0],
                nums[1]
            ]);
            else if (func === 'translate' && nums.length === 1) result = multiplyMatrix(result, [
                1,
                0,
                0,
                1,
                nums[0],
                0
            ]);
            else if (func === 'scale' && nums.length === 2) result = multiplyMatrix(result, [
                nums[0],
                0,
                0,
                nums[1],
                0,
                0
            ]);
            else if (func === 'scale' && nums.length === 1) result = multiplyMatrix(result, [
                nums[0],
                0,
                0,
                nums[0],
                0,
                0
            ]);
            else if (func === 'rotate' && nums.length === 3) {
                let a = nums[0] * Math.PI / 180;
                result = multiplyMatrix(result, [
                    1,
                    0,
                    0,
                    1,
                    nums[1],
                    nums[2]
                ], [
                    Math.cos(a),
                    Math.sin(a),
                    -Math.sin(a),
                    Math.cos(a),
                    0,
                    0
                ], [
                    1,
                    0,
                    0,
                    1,
                    -nums[1],
                    -nums[2]
                ]);
            } else if (func === 'rotate' && nums.length === 1) {
                let a = nums[0] * Math.PI / 180;
                result = multiplyMatrix(result, [
                    Math.cos(a),
                    Math.sin(a),
                    -Math.sin(a),
                    Math.cos(a),
                    0,
                    0
                ]);
            } else if (func === 'skewX' && nums.length === 1) {
                let a = nums[0] * Math.PI / 180;
                result = multiplyMatrix(result, [
                    1,
                    0,
                    Math.tan(a),
                    1,
                    0,
                    0
                ]);
            } else if (func === 'skewY' && nums.length === 1) {
                let a = nums[0] * Math.PI / 180;
                result = multiplyMatrix(result, [
                    1,
                    Math.tan(a),
                    0,
                    1,
                    0,
                    0
                ]);
            } else return;
            parser.matchSeparator();
        }
        if (parser.matchAll()) return;
        return result;
    }
    function parseAspectRatio(aspectRatio, availWidth, availHeight, elemWidth, elemHeight, initAlign) {
        let temp = (aspectRatio || '').trim().match(/^(none)$|^x(Min|Mid|Max)Y(Min|Mid|Max)(?:\s+(meet|slice))?$/) || [], ratioType = temp[1] || temp[4] || 'meet', xAlign = temp[2] || 'Mid', yAlign = temp[3] || 'Mid', scaleX = availWidth / elemWidth, scaleY = availHeight / elemHeight, dx = {
            'Min': 0,
            'Mid': 0.5,
            'Max': 1
        }[xAlign] - (initAlign || 0), dy = {
            'Min': 0,
            'Mid': 0.5,
            'Max': 1
        }[yAlign] - (initAlign || 0);
        if (ratioType === 'slice') scaleY = scaleX = Math.max(scaleX, scaleY);
        else if (ratioType === 'meet') scaleY = scaleX = Math.min(scaleX, scaleY);
        return [
            scaleX,
            0,
            0,
            scaleY,
            dx * (availWidth - elemWidth * scaleX),
            dy * (availHeight - elemHeight * scaleY)
        ];
    }
    function parseStyleAttr(v) {
        let result = Object.create(null);
        v = (v || '').trim().split(/;/);
        for(let i = 0; i < v.length; i++){
            let key = (v[i].split(':')[0] || '').trim(), value = (v[i].split(':')[1] || '').trim();
            if (key) result[key] = value;
        }
        if (result['marker']) {
            if (!result['marker-start']) result['marker-start'] = result['marker'];
            if (!result['marker-mid']) result['marker-mid'] = result['marker'];
            if (!result['marker-end']) result['marker-end'] = result['marker'];
        }
        if (result['font']) {
            let fontFamily = null, fontSize = null, fontStyle = "normal", fontWeight = "normal", fontVariant = "normal";
            let parts = result['font'].split(/\s+/);
            for(let i = 0; i < parts.length; i++)switch(parts[i]){
                case "normal":
                    break;
                case "italic":
                case "oblique":
                    fontStyle = parts[i];
                    break;
                case "small-caps":
                    fontVariant = parts[i];
                    break;
                case "bold":
                case "bolder":
                case "lighter":
                case "100":
                case "200":
                case "300":
                case "400":
                case "500":
                case "600":
                case "700":
                case "800":
                case "900":
                    fontWeight = parts[i];
                    break;
                default:
                    if (!fontSize) fontSize = parts[i].split('/')[0];
                    else if (!fontFamily) fontFamily = parts[i];
                    else fontFamily += ' ' + parts[i];
                    break;
            }
            if (!result['font-style']) result['font-style'] = fontStyle;
            if (!result['font-variant']) result['font-variant'] = fontVariant;
            if (!result['font-weight']) result['font-weight'] = fontWeight;
            if (!result['font-size']) result['font-size'] = fontSize;
            if (!result['font-family']) result['font-family'] = fontFamily;
        }
        return result;
    }
    function parseSelector(v) {
        let parts = v.split(/(?=[.#])/g), ids = [], classes = [], tags = [], temp;
        for(let i = 0; i < parts.length; i++){
            if (temp = parts[i].match(/^[#]([_A-Za-z0-9-]+)$/)) ids.push(temp[1]);
            else if (temp = parts[i].match(/^[.]([_A-Za-z0-9-]+)$/)) classes.push(temp[1]);
            else if (temp = parts[i].match(/^([_A-Za-z0-9-]+)$/)) tags.push(temp[1]);
            else if (parts[i] !== '*') return;
        }
        return {
            tags: tags,
            ids: ids,
            classes: classes,
            specificity: ids.length * 10000 + classes.length * 100 + tags.length
        };
    }
    function parseStyleSheet(v) {
        let parser = new StringParser(v.trim()), rules = [], rule;
        while(rule = parser.match(/^\s*([^\{\}]*?)\s*\{([^\{\}]*?)\}/, true)){
            let selectors = rule[1].split(/\s*,\s*/g), css = parseStyleAttr(rule[2]);
            for(let i = 0; i < selectors.length; i++){
                let selector = parseSelector(selectors[i]);
                if (selector) rules.push({
                    selector: selector,
                    css: css
                });
            }
        }
        return rules;
    }
    function matchesSelector(elem, selector) {
        if (elem.nodeType !== 1) return false;
        for(let i = 0; i < selector.tags.length; i++){
            if (selector.tags[i] !== elem.nodeName) return false;
        }
        for(let i = 0; i < selector.ids.length; i++){
            if (selector.ids[i] !== elem.id) return false;
        }
        for(let i = 0; i < selector.classes.length; i++){
            if (elem.classList.indexOf(selector.classes[i]) === -1) return false;
        }
        return true;
    }
    function getStyle(elem) {
        let result = Object.create(null);
        let specificities = Object.create(null);
        for(let i = 0; i < styleRules.length; i++){
            let rule = styleRules[i];
            if (matchesSelector(elem, rule.selector)) {
                for(let key in rule.css)if (!(specificities[key] > rule.selector.specificity)) {
                    result[key] = rule.css[key];
                    specificities[key] = rule.selector.specificity;
                }
            }
        }
        return result;
    }
    function combineArrays(array1, array2) {
        return array1.concat(array2.slice(array1.length));
    }
    function getAscent(font, size) {
        return Math.max(font.ascender, (font.bbox[3] || font.bbox.maxY) * (font.scale || 1)) * size / 1000;
    }
    function getDescent(font, size) {
        return Math.min(font.descender, (font.bbox[1] || font.bbox.minY) * (font.scale || 1)) * size / 1000;
    }
    function getXHeight(font, size) {
        return (font.xHeight || 0.5 * (font.ascender - font.descender)) * size / 1000;
    }
    function getBaseline(font, size, baseline, shift) {
        let dy1, dy2;
        switch(baseline){
            case 'middle':
                dy1 = 0.5 * getXHeight(font, size);
                break;
            case 'central':
                dy1 = 0.5 * (getDescent(font, size) + getAscent(font, size));
                break;
            case 'after-edge':
            case 'text-after-edge':
                dy1 = getDescent(font, size);
                break;
            case 'alphabetic':
            case 'auto':
            case 'baseline':
                dy1 = 0;
                break;
            case 'mathematical':
                dy1 = 0.5 * getAscent(font, size);
                break;
            case 'hanging':
                dy1 = 0.8 * getAscent(font, size);
                break;
            case 'before-edge':
            case 'text-before-edge':
                dy1 = getAscent(font, size);
                break;
            default:
                dy1 = 0;
                break;
        }
        switch(shift){
            case 'baseline':
                dy2 = 0;
                break;
            case 'super':
                dy2 = 0.6 * size;
                break;
            case 'sub':
                dy2 = -0.6 * size;
                break;
            default:
                dy2 = shift;
                break;
        }
        return dy1 - dy2;
    }
    function getTextPos(font, size, text) {
        let encoded = font.encode('' + text), hex = encoded[0], pos = encoded[1], data = [];
        for(let i = 0; i < hex.length; i++){
            let unicode = font.unicode ? font.unicode[parseInt(hex[i], 16)] : [
                text.charCodeAt(i)
            ];
            data.push({
                glyph: hex[i],
                unicode: unicode,
                width: pos[i].advanceWidth * size / 1000,
                xOffset: pos[i].xOffset * size / 1000,
                yOffset: pos[i].yOffset * size / 1000,
                xAdvance: pos[i].xAdvance * size / 1000,
                yAdvance: pos[i].yAdvance * size / 1000
            });
        }
        return data;
    }
    function createSVGElement(obj, inherits) {
        switch(obj.nodeName){
            case 'use':
                return new SvgElemUse(obj, inherits);
            case 'symbol':
                return new SvgElemSymbol(obj, inherits);
            case 'g':
                return new SvgElemGroup(obj, inherits);
            case 'a':
                return new SvgElemLink(obj, inherits);
            case 'svg':
                return new SvgElemSvg(obj, inherits);
            case 'image':
                return new SVGElemImage(obj, inherits);
            case 'rect':
                return new SvgElemRect(obj, inherits);
            case 'circle':
                return new SvgElemCircle(obj, inherits);
            case 'ellipse':
                return new SvgElemEllipse(obj, inherits);
            case 'line':
                return new SvgElemLine(obj, inherits);
            case 'polyline':
                return new SvgElemPolyline(obj, inherits);
            case 'polygon':
                return new SvgElemPolygon(obj, inherits);
            case 'path':
                return new SvgElemPath(obj, inherits);
            case 'text':
                return new SvgElemText(obj, inherits);
            case 'tspan':
                return new SvgElemTspan(obj, inherits);
            case 'textPath':
                return new SvgElemTextPath(obj, inherits);
            case '#text':
            case '#cdata-section':
                return new SvgElemTextNode(obj, inherits);
            default:
                return new SvgElem(obj, inherits);
        }
    }
    var StringParser = function(str) {
        this.match = function(exp, all) {
            let temp = str.match(exp);
            if (!temp || temp.index !== 0) return;
            str = str.substring(temp[0].length);
            return all ? temp : temp[0];
        };
        this.matchSeparator = function() {
            return this.match(/^(?:\s*,\s*|\s*|)/);
        };
        this.matchSpace = function() {
            return this.match(/^(?:\s*)/);
        };
        this.matchLengthUnit = function() {
            return this.match(/^(?:px|pt|cm|mm|in|pc|em|ex|%|)/);
        };
        this.matchNumber = function() {
            return this.match(/^(?:[-+]?(?:[0-9]+[.][0-9]+|[0-9]+[.]|[.][0-9]+|[0-9]+)(?:[eE][-+]?[0-9]+)?)/);
        };
        this.matchAll = function() {
            return this.match(/^[\s\S]+/);
        };
    };
    var BezierSegment = function(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y) {
        let divisions = 6 * precision;
        let equationX = [
            p1x,
            -3 * p1x + 3 * c1x,
            3 * p1x - 6 * c1x + 3 * c2x,
            -p1x + 3 * c1x - 3 * c2x + p2x
        ];
        let equationY = [
            p1y,
            -3 * p1y + 3 * c1y,
            3 * p1y - 6 * c1y + 3 * c2y,
            -p1y + 3 * c1y - 3 * c2y + p2y
        ];
        let derivativeX = [
            -3 * p1x + 3 * c1x,
            6 * p1x - 12 * c1x + 6 * c2x,
            -3 * p1x + 9 * c1x - 9 * c2x + 3 * p2x
        ];
        let derivativeY = [
            -3 * p1y + 3 * c1y,
            6 * p1y - 12 * c1y + 6 * c2y,
            -3 * p1y + 9 * c1y - 9 * c2y + 3 * p2y
        ];
        let lengthMap = [
            0
        ];
        for(let i = 1; i <= divisions; i++){
            let t = (i - 0.5) / divisions;
            let dx = getCurveValue(t, derivativeX) / divisions, dy = getCurveValue(t, derivativeY) / divisions, l = Math.sqrt(dx * dx + dy * dy);
            lengthMap[i] = lengthMap[i - 1] + l;
        }
        this.totalLength = lengthMap[divisions];
        this.startPoint = [
            p1x,
            p1y,
            isEqual(p1x, c1x) && isEqual(p1y, c1y) ? Math.atan2(c2y - c1y, c2x - c1x) : Math.atan2(c1y - p1y, c1x - p1x)
        ];
        this.endPoint = [
            p2x,
            p2y,
            isEqual(c2x, p2x) && isEqual(c2y, p2y) ? Math.atan2(c2y - c1y, c2x - c1x) : Math.atan2(p2y - c2y, p2x - c2x)
        ];
        this.getBoundingBox = function() {
            let temp;
            let minX = getCurveValue(0, equationX), minY = getCurveValue(0, equationY), maxX = getCurveValue(1, equationX), maxY = getCurveValue(1, equationY);
            if (minX > maxX) {
                temp = maxX;
                maxX = minX;
                minX = temp;
            }
            if (minY > maxY) {
                temp = maxY;
                maxY = minY;
                minY = temp;
            }
            let rootsX = solveEquation(derivativeX);
            for(let i = 0; i < rootsX.length; i++)if (rootsX[i] >= 0 && rootsX[i] <= 1) {
                let x = getCurveValue(rootsX[i], equationX);
                if (x < minX) minX = x;
                if (x > maxX) maxX = x;
            }
            let rootsY = solveEquation(derivativeY);
            for(let i = 0; i < rootsY.length; i++)if (rootsY[i] >= 0 && rootsY[i] <= 1) {
                let y = getCurveValue(rootsY[i], equationY);
                if (y < minY) minY = y;
                if (y > maxY) maxY = y;
            }
            return [
                minX,
                minY,
                maxX,
                maxY
            ];
        };
        this.getPointAtLength = function(l) {
            if (isEqual(l, 0)) return this.startPoint;
            if (isEqual(l, this.totalLength)) return this.endPoint;
            if (l < 0 || l > this.totalLength) return;
            for(let i = 1; i <= divisions; i++){
                let l1 = lengthMap[i - 1], l2 = lengthMap[i];
                if (l1 <= l && l <= l2) {
                    let t = (i - (l2 - l) / (l2 - l1)) / divisions, x = getCurveValue(t, equationX), y = getCurveValue(t, equationY), dx = getCurveValue(t, derivativeX), dy = getCurveValue(t, derivativeY);
                    return [
                        x,
                        y,
                        Math.atan2(dy, dx)
                    ];
                }
            }
        };
    };
    var LineSegment = function(p1x, p1y, p2x, p2y) {
        this.totalLength = Math.sqrt((p2x - p1x) * (p2x - p1x) + (p2y - p1y) * (p2y - p1y));
        this.startPoint = [
            p1x,
            p1y,
            Math.atan2(p2y - p1y, p2x - p1x)
        ];
        this.endPoint = [
            p2x,
            p2y,
            Math.atan2(p2y - p1y, p2x - p1x)
        ];
        this.getBoundingBox = function() {
            return [
                Math.min(this.startPoint[0], this.endPoint[0]),
                Math.min(this.startPoint[1], this.endPoint[1]),
                Math.max(this.startPoint[0], this.endPoint[0]),
                Math.max(this.startPoint[1], this.endPoint[1])
            ];
        };
        this.getPointAtLength = function(l) {
            if (l >= 0 && l <= this.totalLength) {
                let r = l / this.totalLength || 0, x = this.startPoint[0] + r * (this.endPoint[0] - this.startPoint[0]), y = this.startPoint[1] + r * (this.endPoint[1] - this.startPoint[1]);
                return [
                    x,
                    y,
                    this.startPoint[2]
                ];
            }
        };
    };
    var SvgShape = function() {
        this.pathCommands = [];
        this.pathSegments = [];
        this.startPoint = null;
        this.endPoint = null;
        this.totalLength = 0;
        let startX = 0, startY = 0, currX = 0, currY = 0, lastCom, lastCtrlX, lastCtrlY;
        this.move = function(x, y) {
            startX = currX = x;
            startY = currY = y;
            return null;
        };
        this.line = function(x, y) {
            let segment = new LineSegment(currX, currY, x, y);
            currX = x;
            currY = y;
            return segment;
        };
        this.curve = function(c1x, c1y, c2x, c2y, x, y) {
            let segment = new BezierSegment(currX, currY, c1x, c1y, c2x, c2y, x, y);
            currX = x;
            currY = y;
            return segment;
        };
        this.close = function() {
            let segment = new LineSegment(currX, currY, startX, startY);
            currX = startX;
            currY = startY;
            return segment;
        };
        this.addCommand = function(data) {
            this.pathCommands.push(data);
            let segment = this[data[0]].apply(this, data.slice(3));
            if (segment) {
                segment.hasStart = data[1];
                segment.hasEnd = data[2];
                this.startPoint = this.startPoint || segment.startPoint;
                this.endPoint = segment.endPoint;
                this.pathSegments.push(segment);
                this.totalLength += segment.totalLength;
            }
        };
        this.M = function(x, y) {
            this.addCommand([
                'move',
                true,
                true,
                x,
                y
            ]);
            lastCom = 'M';
            return this;
        };
        this.m = function(x, y) {
            return this.M(currX + x, currY + y);
        };
        this.Z = this.z = function() {
            this.addCommand([
                'close',
                true,
                true
            ]);
            lastCom = 'Z';
            return this;
        };
        this.L = function(x, y) {
            this.addCommand([
                'line',
                true,
                true,
                x,
                y
            ]);
            lastCom = 'L';
            return this;
        };
        this.l = function(x, y) {
            return this.L(currX + x, currY + y);
        };
        this.H = function(x) {
            return this.L(x, currY);
        };
        this.h = function(x) {
            return this.L(currX + x, currY);
        };
        this.V = function(y) {
            return this.L(currX, y);
        };
        this.v = function(y) {
            return this.L(currX, currY + y);
        };
        this.C = function(c1x, c1y, c2x, c2y, x, y) {
            this.addCommand([
                'curve',
                true,
                true,
                c1x,
                c1y,
                c2x,
                c2y,
                x,
                y
            ]);
            lastCom = 'C';
            lastCtrlX = c2x;
            lastCtrlY = c2y;
            return this;
        };
        this.c = function(c1x, c1y, c2x, c2y, x, y) {
            return this.C(currX + c1x, currY + c1y, currX + c2x, currY + c2y, currX + x, currY + y);
        };
        this.S = function(c1x, c1y, x, y) {
            return this.C(currX + (lastCom === 'C' ? currX - lastCtrlX : 0), currY + (lastCom === 'C' ? currY - lastCtrlY : 0), c1x, c1y, x, y);
        };
        this.s = function(c1x, c1y, x, y) {
            return this.C(currX + (lastCom === 'C' ? currX - lastCtrlX : 0), currY + (lastCom === 'C' ? currY - lastCtrlY : 0), currX + c1x, currY + c1y, currX + x, currY + y);
        };
        this.Q = function(cx, cy, x, y) {
            let c1x = currX + 2 / 3 * (cx - currX), c1y = currY + 2 / 3 * (cy - currY), c2x = x + 2 / 3 * (cx - x), c2y = y + 2 / 3 * (cy - y);
            this.addCommand([
                'curve',
                true,
                true,
                c1x,
                c1y,
                c2x,
                c2y,
                x,
                y
            ]);
            lastCom = 'Q';
            lastCtrlX = cx;
            lastCtrlY = cy;
            return this;
        };
        this.q = function(c1x, c1y, x, y) {
            return this.Q(currX + c1x, currY + c1y, currX + x, currY + y);
        };
        this.T = function(x, y) {
            return this.Q(currX + (lastCom === 'Q' ? currX - lastCtrlX : 0), currY + (lastCom === 'Q' ? currY - lastCtrlY : 0), x, y);
        };
        this.t = function(x, y) {
            return this.Q(currX + (lastCom === 'Q' ? currX - lastCtrlX : 0), currY + (lastCom === 'Q' ? currY - lastCtrlY : 0), currX + x, currY + y);
        };
        this.A = function(rx, ry, fi, fa, fs, x, y) {
            if (isEqual(rx, 0) || isEqual(ry, 0)) this.addCommand([
                'line',
                true,
                true,
                x,
                y
            ]);
            else {
                fi = fi * (Math.PI / 180);
                rx = Math.abs(rx);
                ry = Math.abs(ry);
                fa = 1 * !!fa;
                fs = 1 * !!fs;
                let x1 = Math.cos(fi) * (currX - x) / 2 + Math.sin(fi) * (currY - y) / 2, y1 = Math.cos(fi) * (currY - y) / 2 - Math.sin(fi) * (currX - x) / 2, lambda = x1 * x1 / (rx * rx) + y1 * y1 / (ry * ry);
                if (lambda > 1) {
                    rx *= Math.sqrt(lambda);
                    ry *= Math.sqrt(lambda);
                }
                let r = Math.sqrt(Math.max(0, rx * rx * ry * ry - rx * rx * y1 * y1 - ry * ry * x1 * x1) / (rx * rx * y1 * y1 + ry * ry * x1 * x1)), x2 = (fa === fs ? -1 : 1) * r * rx * y1 / ry, y2 = (fa === fs ? 1 : -1) * r * ry * x1 / rx;
                let cx = Math.cos(fi) * x2 - Math.sin(fi) * y2 + (currX + x) / 2, cy = Math.sin(fi) * x2 + Math.cos(fi) * y2 + (currY + y) / 2, th1 = Math.atan2((y1 - y2) / ry, (x1 - x2) / rx), th2 = Math.atan2((-y1 - y2) / ry, (-x1 - x2) / rx);
                if (fs === 0 && th2 - th1 > 0) th2 -= 2 * Math.PI;
                else if (fs === 1 && th2 - th1 < 0) th2 += 2 * Math.PI;
                let segms = Math.ceil(Math.abs(th2 - th1) / (Math.PI / precision));
                for(let i = 0; i < segms; i++){
                    let th3 = th1 + i * (th2 - th1) / segms, th4 = th1 + (i + 1) * (th2 - th1) / segms, t = 4 / 3 * Math.tan((th4 - th3) / 4);
                    let c1x = cx + Math.cos(fi) * rx * (Math.cos(th3) - t * Math.sin(th3)) - Math.sin(fi) * ry * (Math.sin(th3) + t * Math.cos(th3)), c1y = cy + Math.sin(fi) * rx * (Math.cos(th3) - t * Math.sin(th3)) + Math.cos(fi) * ry * (Math.sin(th3) + t * Math.cos(th3)), c2x = cx + Math.cos(fi) * rx * (Math.cos(th4) + t * Math.sin(th4)) - Math.sin(fi) * ry * (Math.sin(th4) - t * Math.cos(th4)), c2y = cy + Math.sin(fi) * rx * (Math.cos(th4) + t * Math.sin(th4)) + Math.cos(fi) * ry * (Math.sin(th4) - t * Math.cos(th4)), endX = cx + Math.cos(fi) * rx * Math.cos(th4) - Math.sin(fi) * ry * Math.sin(th4), endY = cy + Math.sin(fi) * rx * Math.cos(th4) + Math.cos(fi) * ry * Math.sin(th4);
                    this.addCommand([
                        'curve',
                        i === 0,
                        i === segms - 1,
                        c1x,
                        c1y,
                        c2x,
                        c2y,
                        endX,
                        endY
                    ]);
                }
            }
            lastCom = 'A';
            return this;
        };
        this.a = function(rx, ry, fi, fa, fs, x, y) {
            return this.A(rx, ry, fi, fa, fs, currX + x, currY + y);
        };
        this.path = function(d) {
            let command, value, temp, parser = new StringParser((d || '').trim());
            while(command = parser.match(/^[astvzqmhlcASTVZQMHLC]/)){
                parser.matchSeparator();
                let values = [];
                while(value = PathFlags[command + values.length] ? parser.match(/^[01]/) : parser.matchNumber()){
                    parser.matchSeparator();
                    if (values.length === PathArguments[command]) {
                        this[command].apply(this, values);
                        values = [];
                        if (command === 'M') command = 'L';
                        else if (command === 'm') command = 'l';
                    }
                    values.push(Number(value));
                }
                if (values.length === PathArguments[command]) this[command].apply(this, values);
                else {
                    warningCallback('SvgPath: command ' + command + ' with ' + values.length + ' numbers');
                    return;
                }
            }
            if (temp = parser.matchAll()) warningCallback('SvgPath: unexpected string ' + temp);
            return this;
        };
        this.getBoundingBox = function() {
            let bbox = [
                Infinity,
                Infinity,
                -Infinity,
                -Infinity
            ];
            function addBounds(bbox1) {
                if (bbox1[0] < bbox[0]) bbox[0] = bbox1[0];
                if (bbox1[2] > bbox[2]) bbox[2] = bbox1[2];
                if (bbox1[1] < bbox[1]) bbox[1] = bbox1[1];
                if (bbox1[3] > bbox[3]) bbox[3] = bbox1[3];
            }
            for(let i = 0; i < this.pathSegments.length; i++)addBounds(this.pathSegments[i].getBoundingBox());
            if (bbox[0] === Infinity) bbox[0] = 0;
            if (bbox[1] === Infinity) bbox[1] = 0;
            if (bbox[2] === -Infinity) bbox[2] = 0;
            if (bbox[3] === -Infinity) bbox[3] = 0;
            return bbox;
        };
        this.getPointAtLength = function(l) {
            if (l >= 0 && l <= this.totalLength) {
                let temp;
                for(let i = 0; i < this.pathSegments.length; i++){
                    if (temp = this.pathSegments[i].getPointAtLength(l)) return temp;
                    l -= this.pathSegments[i].totalLength;
                }
                return this.endPoint;
            }
        };
        this.transform = function(m) {
            this.pathSegments = [];
            this.startPoint = null;
            this.endPoint = null;
            this.totalLength = 0;
            for(let i = 0; i < this.pathCommands.length; i++){
                let data = this.pathCommands.shift();
                for(let j = 3; j < data.length; j += 2){
                    let p = transformPoint([
                        data[j],
                        data[j + 1]
                    ], m);
                    data[j] = p[0];
                    data[j + 1] = p[1];
                }
                this.addCommand(data);
            }
            return this;
        };
        this.mergeShape = function(shape) {
            for(let i = 0; i < shape.pathCommands.length; i++)this.addCommand(shape.pathCommands[i].slice());
            return this;
        };
        this.clone = function() {
            return new SvgShape().mergeShape(this);
        };
        this.insertInDocument = function() {
            for(let i = 0; i < this.pathCommands.length; i++){
                let command = this.pathCommands[i][0], values = this.pathCommands[i].slice(3);
                switch(command){
                    case 'move':
                        doc.moveTo(values[0], values[1]);
                        break;
                    case 'line':
                        doc.lineTo(values[0], values[1]);
                        break;
                    case 'curve':
                        doc.bezierCurveTo(values[0], values[1], values[2], values[3], values[4], values[5]);
                        break;
                    case 'close':
                        doc.closePath();
                        break;
                }
            }
        };
        this.getSubPaths = function() {
            let subPaths = [], shape = new SvgShape();
            for(let i = 0; i < this.pathCommands.length; i++){
                let data = this.pathCommands[i], command = this.pathCommands[i][0];
                if (command === 'move' && i !== 0) {
                    subPaths.push(shape);
                    shape = new SvgShape();
                }
                shape.addCommand(data);
            }
            subPaths.push(shape);
            return subPaths;
        };
        this.getMarkers = function() {
            let markers = [], subPaths = this.getSubPaths();
            for(let i = 0; i < subPaths.length; i++){
                let subPath = subPaths[i], subPathMarkers = [];
                for(let j = 0; j < subPath.pathSegments.length; j++){
                    let segment = subPath.pathSegments[j];
                    if (isNotEqual(segment.totalLength, 0) || j === 0 || j === subPath.pathSegments.length - 1) {
                        if (segment.hasStart) {
                            let startMarker = segment.getPointAtLength(0), prevEndMarker = subPathMarkers.pop();
                            if (prevEndMarker) startMarker[2] = 0.5 * (prevEndMarker[2] + startMarker[2]);
                            subPathMarkers.push(startMarker);
                        }
                        if (segment.hasEnd) {
                            let endMarker = segment.getPointAtLength(segment.totalLength);
                            subPathMarkers.push(endMarker);
                        }
                    }
                }
                markers = markers.concat(subPathMarkers);
            }
            return markers;
        };
    };
    var SvgElem = function(obj, inherits) {
        let styleCache = Object.create(null);
        let childrenCache = null;
        this.name = obj.nodeName;
        this.isOuterElement = obj === svg || !obj.parentNode;
        this.inherits = inherits || (!this.isOuterElement ? createSVGElement(obj.parentNode, null) : null);
        this.stack = this.inherits ? this.inherits.stack.concat(obj) : [
            obj
        ];
        this.style = parseStyleAttr(typeof obj.getAttribute === 'function' && obj.getAttribute('style'));
        this.css = useCSS ? getComputedStyle(obj) : getStyle(obj);
        this.allowedChildren = [];
        this.attr = function(key) {
            if (typeof obj.getAttribute === 'function') return obj.getAttribute(key);
        };
        this.resolveUrl = function(value) {
            let temp = (value || '').match(/^\s*(?:url\("(.*)#(.*)"\)|url\('(.*)#(.*)'\)|url\((.*)#(.*)\)|(.*)#(.*))\s*$/) || [];
            let file = temp[1] || temp[3] || temp[5] || temp[7], id = temp[2] || temp[4] || temp[6] || temp[8];
            if (id) {
                if (!file) {
                    let svgObj = svg.getElementById(id);
                    if (svgObj) {
                        if (this.stack.indexOf(svgObj) === -1) return svgObj;
                        else {
                            warningCallback('SVGtoPDF: loop of circular references for id "' + id + '"');
                            return;
                        }
                    }
                }
                if (documentCallback) {
                    let svgs = documentCache[file];
                    if (!svgs) {
                        svgs = documentCallback(file);
                        if (!isArrayLike(svgs)) svgs = [
                            svgs
                        ];
                        for(let i = 0; i < svgs.length; i++)if (typeof svgs[i] === 'string') svgs[i] = parseXml(svgs[i]);
                        documentCache[file] = svgs;
                    }
                    for(let i = 0; i < svgs.length; i++){
                        let svgObj = svgs[i].getElementById(id);
                        if (svgObj) {
                            if (this.stack.indexOf(svgObj) === -1) return svgObj;
                            else {
                                warningCallback('SVGtoPDF: loop of circular references for id "' + file + '#' + id + '"');
                                return;
                            }
                        }
                    }
                }
            }
        };
        this.computeUnits = function(value, unit, percent, isFontSize) {
            if (unit === '%') return parseFloat(value) / 100 * (isFontSize || percent != null ? percent : this.getViewport());
            else if (unit === 'ex' || unit === 'em') return value * ({
                'em': 1,
                'ex': 0.5
            })[unit] * (isFontSize ? percent : this.get('font-size'));
            else return value * ({
                '': 1,
                'px': 1,
                'pt': 96 / 72,
                'cm': 96 / 2.54,
                'mm': 96 / 25.4,
                'in': 96,
                'pc': 16
            })[unit];
        };
        this.computeLength = function(value, percent, initial, isFontSize) {
            let parser = new StringParser((value || '').trim()), temp1, temp2;
            if (typeof (temp1 = parser.matchNumber()) === 'string' && typeof (temp2 = parser.matchLengthUnit()) === 'string' && !parser.matchAll()) return this.computeUnits(temp1, temp2, percent, isFontSize);
            return initial;
        };
        this.computeLengthList = function(value, percent, strict) {
            let parser = new StringParser((value || '').trim()), result = [], temp1, temp2;
            while(typeof (temp1 = parser.matchNumber()) === 'string' && typeof (temp2 = parser.matchLengthUnit()) === 'string'){
                result.push(this.computeUnits(temp1, temp2, percent));
                parser.matchSeparator();
            }
            if (strict && parser.matchAll()) return;
            return result;
        };
        this.getLength = function(key, percent, initial) {
            return this.computeLength(this.attr(key), percent, initial);
        };
        this.getLengthList = function(key, percent) {
            return this.computeLengthList(this.attr(key), percent);
        };
        this.getUrl = function(key) {
            return this.resolveUrl(this.attr(key));
        };
        this.getNumberList = function(key) {
            let parser = new StringParser((this.attr(key) || '').trim()), result = [], temp;
            while(temp = parser.matchNumber()){
                result.push(Number(temp));
                parser.matchSeparator();
            }
            result.error = parser.matchAll();
            return result;
        };
        this.getViewbox = function(key, initial) {
            let viewBox = this.getNumberList(key);
            if (viewBox.length === 4 && viewBox[2] >= 0 && viewBox[3] >= 0) return viewBox;
            return initial;
        };
        this.getPercent = function(key, initial) {
            let value = this.attr(key);
            let parser = new StringParser((value || '').trim()), temp1, temp2;
            let number = parser.matchNumber();
            if (!number) return initial;
            if (parser.match('%')) number *= 0.01;
            if (parser.matchAll()) return initial;
            return Math.max(0, Math.min(1, number));
        };
        this.chooseValue = function(args) {
            for(let i = 0; i < arguments.length; i++){
                if (arguments[i] != null && arguments[i] === arguments[i]) return arguments[i];
            }
            return arguments[arguments.length - 1];
        };
        this.get = function(key) {
            if (styleCache[key] !== undefined) return styleCache[key];
            let keyInfo = Properties[key] || {}, value, result;
            for(let i = 0; i < 3; i++){
                switch(i){
                    case 0:
                        if (key !== 'transform') value = this.css[keyInfo.css || key];
                        break;
                    case 1:
                        value = this.style[key];
                        break;
                    case 2:
                        value = this.attr(key);
                        break;
                }
                if (value === 'inherit') {
                    result = this.inherits ? this.inherits.get(key) : keyInfo.initial;
                    if (result != null) return styleCache[key] = result;
                }
                if (keyInfo.values != null) {
                    result = keyInfo.values[value];
                    if (result != null) return styleCache[key] = result;
                }
                if (value != null) {
                    let parsed;
                    switch(key){
                        case 'font-size':
                            result = this.computeLength(value, this.inherits ? this.inherits.get(key) : keyInfo.initial, undefined, true);
                            break;
                        case 'baseline-shift':
                            result = this.computeLength(value, this.get('font-size'));
                            break;
                        case 'font-family':
                            result = value || undefined;
                            break;
                        case 'opacity':
                        case 'stroke-opacity':
                        case 'fill-opacity':
                        case 'stop-opacity':
                            parsed = parseFloat(value);
                            if (!isNaN(parsed)) result = Math.max(0, Math.min(1, parsed));
                            break;
                        case 'transform':
                            result = parseTranform(value);
                            break;
                        case 'stroke-dasharray':
                            if (value === 'none') result = [];
                            else if (parsed = this.computeLengthList(value, this.getViewport(), true)) {
                                let sum = 0, error = false;
                                for(let j = 0; j < parsed.length; j++){
                                    if (parsed[j] < 0) error = true;
                                    sum += parsed[j];
                                }
                                if (!error) {
                                    if (parsed.length % 2 === 1) parsed = parsed.concat(parsed);
                                    result = sum === 0 ? [] : parsed;
                                }
                            }
                            break;
                        case 'color':
                            if (value === 'none' || value === 'transparent') result = 'none';
                            else result = parseColor(value);
                            break;
                        case 'fill':
                        case 'stroke':
                            if (value === 'none' || value === 'transparent') result = 'none';
                            else if (value === 'currentColor') result = this.get('color');
                            else if (parsed = parseColor(value)) return parsed;
                            else if (parsed = (value || '').split(' ')) {
                                let object = this.resolveUrl(parsed[0]), fallbackColor = parseColor(parsed[1]);
                                if (object == null) result = fallbackColor;
                                else if (object.nodeName === 'linearGradient' || object.nodeName === 'radialGradient') result = new SvgElemGradient(object, null, fallbackColor);
                                else if (object.nodeName === 'pattern') result = new SvgElemPattern(object, null, fallbackColor);
                                else result = fallbackColor;
                            }
                            break;
                        case 'stop-color':
                            if (value === 'none' || value === 'transparent') result = 'none';
                            else if (value === 'currentColor') result = this.get('color');
                            else result = parseColor(value);
                            break;
                        case 'marker-start':
                        case 'marker-mid':
                        case 'marker-end':
                        case 'clip-path':
                        case 'mask':
                            if (value === 'none') result = 'none';
                            else result = this.resolveUrl(value);
                            break;
                        case 'stroke-width':
                            parsed = this.computeLength(value, this.getViewport());
                            if (parsed != null && parsed >= 0) result = parsed;
                            break;
                        case 'stroke-miterlimit':
                            parsed = parseFloat(value);
                            if (parsed != null && parsed >= 1) result = parsed;
                            break;
                        case 'word-spacing':
                        case 'letter-spacing':
                            result = this.computeLength(value, this.getViewport());
                            break;
                        case 'stroke-dashoffset':
                            result = this.computeLength(value, this.getViewport());
                            if (result != null) {
                                if (result < 0) {
                                    let dasharray = this.get('stroke-dasharray');
                                    for(let j = 0; j < dasharray.length; j++)result += dasharray[j];
                                }
                            }
                            break;
                    }
                    if (result != null) return styleCache[key] = result;
                }
            }
            return styleCache[key] = keyInfo.inherit && this.inherits ? this.inherits.get(key) : keyInfo.initial;
        };
        this.getChildren = function() {
            if (childrenCache != null) return childrenCache;
            let children = [];
            for(let i = 0; i < obj.childNodes.length; i++){
                let child = obj.childNodes[i];
                if (!child.error && this.allowedChildren.indexOf(child.nodeName) !== -1) children.push(createSVGElement(child, this));
            }
            return childrenCache = children;
        };
        this.getParentVWidth = function() {
            return this.inherits ? this.inherits.getVWidth() : viewportWidth;
        };
        this.getParentVHeight = function() {
            return this.inherits ? this.inherits.getVHeight() : viewportHeight;
        };
        this.getParentViewport = function() {
            return Math.sqrt(0.5 * this.getParentVWidth() * this.getParentVWidth() + 0.5 * this.getParentVHeight() * this.getParentVHeight());
        };
        this.getVWidth = function() {
            return this.getParentVWidth();
        };
        this.getVHeight = function() {
            return this.getParentVHeight();
        };
        this.getViewport = function() {
            return Math.sqrt(0.5 * this.getVWidth() * this.getVWidth() + 0.5 * this.getVHeight() * this.getVHeight());
        };
        this.getBoundingBox = function() {
            let shape = this.getBoundingShape();
            return shape.getBoundingBox();
        };
    };
    var SvgElemStylable = function(obj, inherits) {
        SvgElem.call(this, obj, inherits);
        this.transform = function() {
            doc.transform.apply(doc, this.getTransformation());
        };
        this.clip = function() {
            if (this.get('clip-path') !== 'none') {
                let clipPath = new SvgElemClipPath(this.get('clip-path'), null);
                clipPath.useMask(this.getBoundingBox());
                return true;
            }
        };
        this.mask = function() {
            if (this.get('mask') !== 'none') {
                let mask = new SvgElemMask(this.get('mask'), null);
                mask.useMask(this.getBoundingBox());
                return true;
            }
        };
        this.getFill = function(isClip, isMask) {
            let opacity = this.get('opacity'), fill = this.get('fill'), fillOpacity = this.get('fill-opacity');
            if (isClip) return DefaultColors.white;
            if (fill !== 'none' && opacity && fillOpacity) {
                if (fill instanceof SvgElemGradient || fill instanceof SvgElemPattern) return fill.getPaint(this.getBoundingBox(), fillOpacity * opacity, isClip, isMask);
                return opacityToColor(fill, fillOpacity * opacity, isMask);
            }
        };
        this.getStroke = function(isClip, isMask) {
            let opacity = this.get('opacity'), stroke = this.get('stroke'), strokeOpacity = this.get('stroke-opacity');
            if (isClip || isEqual(this.get('stroke-width'), 0)) return;
            if (stroke !== 'none' && opacity && strokeOpacity) {
                if (stroke instanceof SvgElemGradient || stroke instanceof SvgElemPattern) return stroke.getPaint(this.getBoundingBox(), strokeOpacity * opacity, isClip, isMask);
                return opacityToColor(stroke, strokeOpacity * opacity, isMask);
            }
        };
    };
    var SvgElemHasChildren = function(obj, inherits) {
        SvgElemStylable.call(this, obj, inherits);
        this.allowedChildren = [
            'use',
            'g',
            'a',
            'svg',
            'image',
            'rect',
            'circle',
            'ellipse',
            'line',
            'polyline',
            'polygon',
            'path',
            'text'
        ];
        this.getBoundingShape = function() {
            let shape = new SvgShape(), children = this.getChildren();
            for(let i = 0; i < children.length; i++){
                if (children[i].get('display') !== 'none') {
                    if (typeof children[i].getBoundingShape === 'function') {
                        let childShape = children[i].getBoundingShape().clone();
                        if (typeof children[i].getTransformation === 'function') childShape.transform(children[i].getTransformation());
                        shape.mergeShape(childShape);
                    }
                }
            }
            return shape;
        };
        this.drawChildren = function(isClip, isMask) {
            let children = this.getChildren();
            for(let i = 0; i < children.length; i++){
                if (children[i].get('display') !== 'none') {
                    if (typeof children[i].drawInDocument === 'function') children[i].drawInDocument(isClip, isMask);
                }
            }
        };
    };
    var SvgElemContainer = function(obj, inherits) {
        SvgElemHasChildren.call(this, obj, inherits);
        this.drawContent = function(isClip, isMask) {
            this.transform();
            let clipped = this.clip(), masked = this.mask(), group;
            if ((this.get('opacity') < 1 || clipped || masked) && !isClip) group = docBeginGroup(getPageBBox());
            this.drawChildren(isClip, isMask);
            if (group) {
                docEndGroup(group);
                doc.fillOpacity(this.get('opacity'));
                docInsertGroup(group);
            }
        };
    };
    var SvgElemUse = function(obj, inherits) {
        SvgElemContainer.call(this, obj, inherits);
        let x = this.getLength('x', this.getVWidth(), 0), y = this.getLength('y', this.getVHeight(), 0), child = this.getUrl('href') || this.getUrl('xlink:href');
        if (child) child = createSVGElement(child, this);
        this.getChildren = function() {
            return child ? [
                child
            ] : [];
        };
        this.drawInDocument = function(isClip, isMask) {
            doc.save();
            this.drawContent(isClip, isMask);
            doc.restore();
        };
        this.getTransformation = function() {
            return multiplyMatrix(this.get('transform'), [
                1,
                0,
                0,
                1,
                x,
                y
            ]);
        };
    };
    var SvgElemSymbol = function(obj, inherits) {
        SvgElemContainer.call(this, obj, inherits);
        let width = this.getLength('width', this.getParentVWidth(), this.getParentVWidth()), height = this.getLength('height', this.getParentVHeight(), this.getParentVHeight());
        if (inherits instanceof SvgElemUse) {
            width = inherits.getLength('width', inherits.getParentVWidth(), width);
            height = inherits.getLength('height', inherits.getParentVHeight(), height);
        }
        let aspectRatio = (this.attr('preserveAspectRatio') || '').trim(), viewBox = this.getViewbox('viewBox', [
            0,
            0,
            width,
            height
        ]);
        this.getVWidth = function() {
            return viewBox[2];
        };
        this.getVHeight = function() {
            return viewBox[3];
        };
        this.drawInDocument = function(isClip, isMask) {
            doc.save();
            this.drawContent(isClip, isMask);
            doc.restore();
        };
        this.getTransformation = function() {
            return multiplyMatrix(parseAspectRatio(aspectRatio, width, height, viewBox[2], viewBox[3]), [
                1,
                0,
                0,
                1,
                -viewBox[0],
                -viewBox[1]
            ]);
        };
    };
    var SvgElemGroup = function(obj, inherits) {
        SvgElemContainer.call(this, obj, inherits);
        this.drawInDocument = function(isClip, isMask) {
            doc.save();
            if (this.link && !isClip && !isMask) this.addLink();
            this.drawContent(isClip, isMask);
            doc.restore();
        };
        this.getTransformation = function() {
            return this.get('transform');
        };
    };
    var SvgElemLink = function(obj, inherits) {
        if (inherits && inherits.isText) {
            SvgElemTspan.call(this, obj, inherits);
            this.allowedChildren = [
                'textPath',
                'tspan',
                '#text',
                '#cdata-section',
                'a'
            ];
        } else SvgElemGroup.call(this, obj, inherits);
        this.link = this.attr('href') || this.attr('xlink:href');
        this.addLink = function() {
            if (this.link.match(/^(?:[a-z][a-z0-9+.-]*:|\/\/)?/i) && this.getChildren().length) {
                let bbox = this.getBoundingShape().transform(getGlobalMatrix()).getBoundingBox();
                docInsertLink(bbox[0], bbox[1], bbox[2], bbox[3], this.link);
            }
        };
    };
    var SvgElemSvg = function(obj, inherits) {
        SvgElemContainer.call(this, obj, inherits);
        let width = this.getLength('width', this.getParentVWidth(), this.getParentVWidth()), height = this.getLength('height', this.getParentVHeight(), this.getParentVHeight()), x = this.getLength('x', this.getParentVWidth(), 0), y = this.getLength('y', this.getParentVHeight(), 0);
        if (inherits instanceof SvgElemUse) {
            width = inherits.getLength('width', inherits.getParentVWidth(), width);
            height = inherits.getLength('height', inherits.getParentVHeight(), height);
        }
        let aspectRatio = this.attr('preserveAspectRatio'), viewBox = this.getViewbox('viewBox', [
            0,
            0,
            width,
            height
        ]);
        if (this.isOuterElement && preserveAspectRatio) {
            x = y = 0;
            width = viewportWidth;
            height = viewportHeight;
            aspectRatio = preserveAspectRatio;
        }
        this.getVWidth = function() {
            return viewBox[2];
        };
        this.getVHeight = function() {
            return viewBox[3];
        };
        this.drawInDocument = function(isClip, isMask) {
            doc.save();
            if (this.get('overflow') === 'hidden') {
                new SvgShape().M(x, y).L(x + width, y).L(x + width, y + height).L(x, y + height).Z().transform(this.get('transform')).insertInDocument();
                doc.clip();
            }
            this.drawContent(isClip, isMask);
            doc.restore();
        };
        this.getTransformation = function() {
            return multiplyMatrix(this.get('transform'), [
                1,
                0,
                0,
                1,
                x,
                y
            ], parseAspectRatio(aspectRatio, width, height, viewBox[2], viewBox[3]), [
                1,
                0,
                0,
                1,
                -viewBox[0],
                -viewBox[1]
            ]);
        };
    };
    var SVGElemImage = function(obj, inherits) {
        SvgElemStylable.call(this, obj, inherits);
        let link = imageCallback(this.attr('href') || this.attr('xlink:href') || ''), x = this.getLength('x', this.getVWidth(), 0), y = this.getLength('y', this.getVHeight(), 0), width = this.getLength('width', this.getVWidth(), 'auto'), height = this.getLength('height', this.getVHeight(), 'auto'), image;
        try {
            image = doc.openImage(link);
        } catch (e) {
            warningCallback('SVGElemImage: failed to open image "' + link + '" in PDFKit');
        }
        if (image) {
            if (width === 'auto' && height !== 'auto') width = height * image.width / image.height;
            else if (height === 'auto' && width !== 'auto') height = width * image.height / image.width;
            else if (width === 'auto' && height === 'auto') {
                width = image.width;
                height = image.height;
            }
        }
        if (width === 'auto' || width < 0) width = 0;
        if (height === 'auto' || height < 0) height = 0;
        this.getTransformation = function() {
            return this.get('transform');
        };
        this.getBoundingShape = function() {
            return new SvgShape().M(x, y).L(x + width, y).M(x + width, y + height).L(x, y + height);
        };
        this.drawInDocument = function(isClip, isMask) {
            if (this.get('visibility') === 'hidden' || !image) return;
            doc.save();
            this.transform();
            if (this.get('overflow') === 'hidden') doc.rect(x, y, width, height).clip();
            this.clip();
            this.mask();
            doc.translate(x, y);
            doc.transform.apply(doc, parseAspectRatio(this.attr('preserveAspectRatio'), width, height, image ? image.width : width, image ? image.height : height));
            if (!isClip) {
                doc.fillOpacity(this.get('opacity'));
                doc.image(image, 0, 0);
            } else {
                doc.rect(0, 0, image.width, image.height);
                docFillColor(DefaultColors.white).fill();
            }
            doc.restore();
        };
    };
    var SvgElemPattern = function(obj, inherits, fallback) {
        SvgElemHasChildren.call(this, obj, inherits);
        this.ref = (function() {
            let ref = this.getUrl('href') || this.getUrl('xlink:href');
            if (ref && ref.nodeName === obj.nodeName) return new SvgElemPattern(ref, inherits, fallback);
        }).call(this);
        let _attr = this.attr;
        this.attr = function(key) {
            let attr = _attr.call(this, key);
            if (attr != null || key === 'href' || key === 'xlink:href') return attr;
            return this.ref ? this.ref.attr(key) : null;
        };
        let _getChildren = this.getChildren;
        this.getChildren = function() {
            let children = _getChildren.call(this);
            if (children.length > 0) return children;
            return this.ref ? this.ref.getChildren() : [];
        };
        this.getPaint = function(bBox, gOpacity, isClip, isMask) {
            let bBoxUnitsPattern = this.attr('patternUnits') !== 'userSpaceOnUse', bBoxUnitsContent = this.attr('patternContentUnits') === 'objectBoundingBox', x = this.getLength('x', bBoxUnitsPattern ? 1 : this.getParentVWidth(), 0), y = this.getLength('y', bBoxUnitsPattern ? 1 : this.getParentVHeight(), 0), width = this.getLength('width', bBoxUnitsPattern ? 1 : this.getParentVWidth(), 0), height = this.getLength('height', bBoxUnitsPattern ? 1 : this.getParentVHeight(), 0);
            if (bBoxUnitsContent && !bBoxUnitsPattern) {
                x = (x - bBox[0]) / (bBox[2] - bBox[0]) || 0;
                y = (y - bBox[1]) / (bBox[3] - bBox[1]) || 0;
                width = width / (bBox[2] - bBox[0]) || 0;
                height = height / (bBox[3] - bBox[1]) || 0;
            } else if (!bBoxUnitsContent && bBoxUnitsPattern) {
                x = bBox[0] + x * (bBox[2] - bBox[0]);
                y = bBox[1] + y * (bBox[3] - bBox[1]);
                width = width * (bBox[2] - bBox[0]);
                height = height * (bBox[3] - bBox[1]);
            }
            let viewBox = this.getViewbox('viewBox', [
                0,
                0,
                width,
                height
            ]), aspectRatio = (this.attr('preserveAspectRatio') || '').trim(), aspectRatioMatrix = multiplyMatrix(parseAspectRatio(aspectRatio, width, height, viewBox[2], viewBox[3], 0), [
                1,
                0,
                0,
                1,
                -viewBox[0],
                -viewBox[1]
            ]), matrix = parseTranform(this.attr('patternTransform'));
            if (bBoxUnitsContent) matrix = multiplyMatrix([
                bBox[2] - bBox[0],
                0,
                0,
                bBox[3] - bBox[1],
                bBox[0],
                bBox[1]
            ], matrix);
            matrix = multiplyMatrix(matrix, [
                1,
                0,
                0,
                1,
                x,
                y
            ]);
            if ((matrix = validateMatrix(matrix)) && (aspectRatioMatrix = validateMatrix(aspectRatioMatrix)) && (width = validateNumber(width)) && (height = validateNumber(height))) {
                let group = docBeginGroup([
                    0,
                    0,
                    width,
                    height
                ]);
                doc.transform.apply(doc, aspectRatioMatrix);
                this.drawChildren(isClip, isMask);
                docEndGroup(group);
                return [
                    docCreatePattern(group, width, height, matrix),
                    gOpacity
                ];
            } else return fallback ? [
                fallback[0],
                fallback[1] * gOpacity
            ] : undefined;
        };
        this.getVWidth = function() {
            let bBoxUnitsPattern = this.attr('patternUnits') !== 'userSpaceOnUse', width = this.getLength('width', bBoxUnitsPattern ? 1 : this.getParentVWidth(), 0);
            return this.getViewbox('viewBox', [
                0,
                0,
                width,
                0
            ])[2];
        };
        this.getVHeight = function() {
            let bBoxUnitsPattern = this.attr('patternUnits') !== 'userSpaceOnUse', height = this.getLength('height', bBoxUnitsPattern ? 1 : this.getParentVHeight(), 0);
            return this.getViewbox('viewBox', [
                0,
                0,
                0,
                height
            ])[3];
        };
    };
    var SvgElemGradient = function(obj, inherits, fallback) {
        SvgElem.call(this, obj, inherits);
        this.allowedChildren = [
            'stop'
        ];
        this.ref = (function() {
            let ref = this.getUrl('href') || this.getUrl('xlink:href');
            if (ref && ref.nodeName === obj.nodeName) return new SvgElemGradient(ref, inherits, fallback);
        }).call(this);
        let _attr = this.attr;
        this.attr = function(key) {
            let attr = _attr.call(this, key);
            if (attr != null || key === 'href' || key === 'xlink:href') return attr;
            return this.ref ? this.ref.attr(key) : null;
        };
        let _getChildren = this.getChildren;
        this.getChildren = function() {
            let children = _getChildren.call(this);
            if (children.length > 0) return children;
            return this.ref ? this.ref.getChildren() : [];
        };
        this.getPaint = function(bBox, gOpacity, isClip, isMask) {
            let children = this.getChildren();
            if (children.length === 0) return;
            if (children.length === 1) {
                let child = children[0], stopColor = child.get('stop-color');
                if (stopColor === 'none') return;
                return opacityToColor(stopColor, child.get('stop-opacity') * gOpacity, isMask);
            }
            let bBoxUnits = this.attr('gradientUnits') !== 'userSpaceOnUse', matrix = parseTranform(this.attr('gradientTransform')), spread = this.attr('spreadMethod'), grad, x1, x2, y1, y2, r2, nAfter = 0, nBefore = 0, nTotal = 1;
            if (bBoxUnits) matrix = multiplyMatrix([
                bBox[2] - bBox[0],
                0,
                0,
                bBox[3] - bBox[1],
                bBox[0],
                bBox[1]
            ], matrix);
            if (matrix = validateMatrix(matrix)) {
                if (this.name === 'linearGradient') {
                    x1 = this.getLength('x1', bBoxUnits ? 1 : this.getVWidth(), 0);
                    x2 = this.getLength('x2', bBoxUnits ? 1 : this.getVWidth(), bBoxUnits ? 1 : this.getVWidth());
                    y1 = this.getLength('y1', bBoxUnits ? 1 : this.getVHeight(), 0);
                    y2 = this.getLength('y2', bBoxUnits ? 1 : this.getVHeight(), 0);
                } else {
                    x2 = this.getLength('cx', bBoxUnits ? 1 : this.getVWidth(), bBoxUnits ? 0.5 : 0.5 * this.getVWidth());
                    y2 = this.getLength('cy', bBoxUnits ? 1 : this.getVHeight(), bBoxUnits ? 0.5 : 0.5 * this.getVHeight());
                    r2 = this.getLength('r', bBoxUnits ? 1 : this.getViewport(), bBoxUnits ? 0.5 : 0.5 * this.getViewport());
                    x1 = this.getLength('fx', bBoxUnits ? 1 : this.getVWidth(), x2);
                    y1 = this.getLength('fy', bBoxUnits ? 1 : this.getVHeight(), y2);
                    if (r2 < 0) warningCallback('SvgElemGradient: negative r value');
                    let d = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2)), multiplier = 1;
                    if (d > r2) {
                        multiplier = r2 / d;
                        x1 = x2 + (x1 - x2) * multiplier;
                        y1 = y2 + (y1 - y2) * multiplier;
                    }
                    r2 = Math.max(r2, d * multiplier * (1 + 1e-6)); // fix for edge-case gradients see issue #84
                }
                if (spread === 'reflect' || spread === 'repeat') {
                    let inv = inverseMatrix(matrix), corner1 = transformPoint([
                        bBox[0],
                        bBox[1]
                    ], inv), corner2 = transformPoint([
                        bBox[2],
                        bBox[1]
                    ], inv), corner3 = transformPoint([
                        bBox[2],
                        bBox[3]
                    ], inv), corner4 = transformPoint([
                        bBox[0],
                        bBox[3]
                    ], inv);
                    if (this.name === 'linearGradient') {
                        nAfter = Math.max((corner1[0] - x2) * (x2 - x1) + (corner1[1] - y2) * (y2 - y1), (corner2[0] - x2) * (x2 - x1) + (corner2[1] - y2) * (y2 - y1), (corner3[0] - x2) * (x2 - x1) + (corner3[1] - y2) * (y2 - y1), (corner4[0] - x2) * (x2 - x1) + (corner4[1] - y2) * (y2 - y1)) / (Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
                        nBefore = Math.max((corner1[0] - x1) * (x1 - x2) + (corner1[1] - y1) * (y1 - y2), (corner2[0] - x1) * (x1 - x2) + (corner2[1] - y1) * (y1 - y2), (corner3[0] - x1) * (x1 - x2) + (corner3[1] - y1) * (y1 - y2), (corner4[0] - x1) * (x1 - x2) + (corner4[1] - y1) * (y1 - y2)) / (Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
                    } else nAfter = Math.sqrt(Math.max(Math.pow(corner1[0] - x2, 2) + Math.pow(corner1[1] - y2, 2), Math.pow(corner2[0] - x2, 2) + Math.pow(corner2[1] - y2, 2), Math.pow(corner3[0] - x2, 2) + Math.pow(corner3[1] - y2, 2), Math.pow(corner4[0] - x2, 2) + Math.pow(corner4[1] - y2, 2))) / r2 - 1;
                    nAfter = Math.ceil(nAfter + 0.5); // Add a little more because the stroke can extend outside of the bounding box
                    nBefore = Math.ceil(nBefore + 0.5);
                    nTotal = nBefore + 1 + nAfter; // How many times the gradient needs to be repeated to fill the object bounding box
                }
                if (this.name === 'linearGradient') grad = doc.linearGradient(x1 - nBefore * (x2 - x1), y1 - nBefore * (y2 - y1), x2 + nAfter * (x2 - x1), y2 + nAfter * (y2 - y1));
                else grad = doc.radialGradient(x1, y1, 0, x2, y2, r2 + nAfter * r2);
                for(let n = 0; n < nTotal; n++){
                    let offset = 0, inOrder = spread !== 'reflect' || (n - nBefore) % 2 === 0;
                    for(let i = 0; i < children.length; i++){
                        let child = children[inOrder ? i : children.length - 1 - i], stopColor = child.get('stop-color');
                        if (stopColor === 'none') stopColor = DefaultColors.transparent;
                        stopColor = opacityToColor(stopColor, child.get('stop-opacity') * gOpacity, isMask);
                        offset = Math.max(offset, inOrder ? child.getPercent('offset', 0) : 1 - child.getPercent('offset', 0));
                        if (i === 0 && stopColor[0].length === 4) grad._colorSpace = 'DeviceCMYK';
                         // Fix until PR #763 is merged into PDFKit
                        if (i === 0 && offset > 0) grad.stop((n + 0) / nTotal, stopColor[0], stopColor[1]);
                        grad.stop((n + offset) / (nAfter + nBefore + 1), stopColor[0], stopColor[1]);
                        if (i === children.length - 1 && offset < 1) grad.stop((n + 1) / nTotal, stopColor[0], stopColor[1]);
                    }
                }
                grad.setTransform.apply(grad, matrix);
                return [
                    grad,
                    1
                ];
            } else return fallback ? [
                fallback[0],
                fallback[1] * gOpacity
            ] : undefined;
        };
    };
    var SvgElemBasicShape = function(obj, inherits) {
        SvgElemStylable.call(this, obj, inherits);
        this.dashScale = 1;
        this.getBoundingShape = function() {
            return this.shape;
        };
        this.getTransformation = function() {
            return this.get('transform');
        };
        this.drawInDocument = function(isClip, isMask) {
            if (this.get('visibility') === 'hidden' || !this.shape) return;
            doc.save();
            this.transform();
            this.clip();
            if (!isClip) {
                let masked = this.mask(), group;
                if (masked) group = docBeginGroup(getPageBBox());
                let subPaths = this.shape.getSubPaths(), fill = this.getFill(isClip, isMask), stroke = this.getStroke(isClip, isMask), lineWidth = this.get('stroke-width'), lineCap = this.get('stroke-linecap');
                if (fill || stroke) {
                    if (fill) docFillColor(fill);
                    if (stroke) {
                        for(let j = 0; j < subPaths.length; j++)if (isEqual(subPaths[j].totalLength, 0)) {
                            if ((lineCap === 'square' || lineCap === 'round') && lineWidth > 0) {
                                if (subPaths[j].startPoint && subPaths[j].startPoint.length > 1) {
                                    let x = subPaths[j].startPoint[0], y = subPaths[j].startPoint[1];
                                    docFillColor(stroke);
                                    if (lineCap === 'square') doc.rect(x - 0.5 * lineWidth, y - 0.5 * lineWidth, lineWidth, lineWidth);
                                    else if (lineCap === 'round') doc.circle(x, y, 0.5 * lineWidth);
                                    doc.fill();
                                }
                            }
                        }
                        let dashArray = this.get('stroke-dasharray'), dashOffset = this.get('stroke-dashoffset');
                        if (isNotEqual(this.dashScale, 1)) {
                            for(let j = 0; j < dashArray.length; j++)dashArray[j] *= this.dashScale;
                            dashOffset *= this.dashScale;
                        }
                        docStrokeColor(stroke);
                        doc.lineWidth(lineWidth).miterLimit(this.get('stroke-miterlimit')).lineJoin(this.get('stroke-linejoin')).lineCap(lineCap).dash(dashArray, {
                            phase: dashOffset
                        });
                    }
                    for(let j = 0; j < subPaths.length; j++)if (subPaths[j].totalLength > 0) subPaths[j].insertInDocument();
                    if (fill && stroke) doc.fillAndStroke(this.get('fill-rule'));
                    else if (fill) doc.fill(this.get('fill-rule'));
                    else if (stroke) doc.stroke();
                }
                let markerStart = this.get('marker-start'), markerMid = this.get('marker-mid'), markerEnd = this.get('marker-end');
                if (markerStart !== 'none' || markerMid !== 'none' || markerEnd !== 'none') {
                    let markersPos = this.shape.getMarkers();
                    if (markerStart !== 'none') {
                        let marker = new SvgElemMarker(markerStart, null);
                        marker.drawMarker(false, isMask, markersPos[0], lineWidth);
                    }
                    if (markerMid !== 'none') for(let i = 1; i < markersPos.length - 1; i++){
                        let marker = new SvgElemMarker(markerMid, null);
                        marker.drawMarker(false, isMask, markersPos[i], lineWidth);
                    }
                    if (markerEnd !== 'none') {
                        let marker = new SvgElemMarker(markerEnd, null);
                        marker.drawMarker(false, isMask, markersPos[markersPos.length - 1], lineWidth);
                    }
                }
                if (group) {
                    docEndGroup(group);
                    docInsertGroup(group);
                }
            } else {
                this.shape.insertInDocument();
                docFillColor(DefaultColors.white);
                doc.fill(this.get('clip-rule'));
            }
            doc.restore();
        };
    };
    var SvgElemRect = function(obj, inherits) {
        SvgElemBasicShape.call(this, obj, inherits);
        let x = this.getLength('x', this.getVWidth(), 0), y = this.getLength('y', this.getVHeight(), 0), w = this.getLength('width', this.getVWidth(), 0), h = this.getLength('height', this.getVHeight(), 0), rx = this.getLength('rx', this.getVWidth()), ry = this.getLength('ry', this.getVHeight());
        if (rx === undefined && ry === undefined) rx = ry = 0;
        else if (rx === undefined && ry !== undefined) rx = ry;
        else if (rx !== undefined && ry === undefined) ry = rx;
        if (w > 0 && h > 0) {
            if (rx && ry) {
                rx = Math.min(rx, 0.5 * w);
                ry = Math.min(ry, 0.5 * h);
                this.shape = new SvgShape().M(x + rx, y).L(x + w - rx, y).A(rx, ry, 0, 0, 1, x + w, y + ry).L(x + w, y + h - ry).A(rx, ry, 0, 0, 1, x + w - rx, y + h).L(x + rx, y + h).A(rx, ry, 0, 0, 1, x, y + h - ry).L(x, y + ry).A(rx, ry, 0, 0, 1, x + rx, y).Z();
            } else this.shape = new SvgShape().M(x, y).L(x + w, y).L(x + w, y + h).L(x, y + h).Z();
        } else this.shape = new SvgShape();
    };
    var SvgElemCircle = function(obj, inherits) {
        SvgElemBasicShape.call(this, obj, inherits);
        let cx = this.getLength('cx', this.getVWidth(), 0), cy = this.getLength('cy', this.getVHeight(), 0), r = this.getLength('r', this.getViewport(), 0);
        if (r > 0) this.shape = new SvgShape().M(cx + r, cy).A(r, r, 0, 0, 1, cx - r, cy).A(r, r, 0, 0, 1, cx + r, cy).Z();
        else this.shape = new SvgShape();
    };
    var SvgElemEllipse = function(obj, inherits) {
        SvgElemBasicShape.call(this, obj, inherits);
        let cx = this.getLength('cx', this.getVWidth(), 0), cy = this.getLength('cy', this.getVHeight(), 0), rx = this.getLength('rx', this.getVWidth(), 0), ry = this.getLength('ry', this.getVHeight(), 0);
        if (rx > 0 && ry > 0) this.shape = new SvgShape().M(cx + rx, cy).A(rx, ry, 0, 0, 1, cx - rx, cy).A(rx, ry, 0, 0, 1, cx + rx, cy).Z();
        else this.shape = new SvgShape();
    };
    var SvgElemLine = function(obj, inherits) {
        SvgElemBasicShape.call(this, obj, inherits);
        let x1 = this.getLength('x1', this.getVWidth(), 0), y1 = this.getLength('y1', this.getVHeight(), 0), x2 = this.getLength('x2', this.getVWidth(), 0), y2 = this.getLength('y2', this.getVHeight(), 0);
        this.shape = new SvgShape().M(x1, y1).L(x2, y2);
    };
    var SvgElemPolyline = function(obj, inherits) {
        SvgElemBasicShape.call(this, obj, inherits);
        let points = this.getNumberList('points');
        this.shape = new SvgShape();
        for(let i = 0; i < points.length - 1; i += 2)if (i === 0) this.shape.M(points[i], points[i + 1]);
        else this.shape.L(points[i], points[i + 1]);
        if (points.error) warningCallback('SvgElemPolygon: unexpected string ' + points.error);
        if (points.length % 2 === 1) warningCallback('SvgElemPolyline: uneven number of coordinates');
    };
    var SvgElemPolygon = function(obj, inherits) {
        SvgElemBasicShape.call(this, obj, inherits);
        let points = this.getNumberList('points');
        this.shape = new SvgShape();
        for(let i = 0; i < points.length - 1; i += 2)if (i === 0) this.shape.M(points[i], points[i + 1]);
        else this.shape.L(points[i], points[i + 1]);
        this.shape.Z();
        if (points.error) warningCallback('SvgElemPolygon: unexpected string ' + points.error);
        if (points.length % 2 === 1) warningCallback('SvgElemPolygon: uneven number of coordinates');
    };
    var SvgElemPath = function(obj, inherits) {
        SvgElemBasicShape.call(this, obj, inherits);
        this.shape = new SvgShape().path(this.attr('d'));
        let pathLength = this.getLength('pathLength', this.getViewport());
        this.pathLength = pathLength > 0 ? pathLength : undefined;
        this.dashScale = this.pathLength !== undefined ? this.shape.totalLength / this.pathLength : 1;
    };
    var SvgElemMarker = function(obj, inherits) {
        SvgElemHasChildren.call(this, obj, inherits);
        let width = this.getLength('markerWidth', this.getParentVWidth(), 3), height = this.getLength('markerHeight', this.getParentVHeight(), 3), viewBox = this.getViewbox('viewBox', [
            0,
            0,
            width,
            height
        ]);
        this.getVWidth = function() {
            return viewBox[2];
        };
        this.getVHeight = function() {
            return viewBox[3];
        };
        this.drawMarker = function(isClip, isMask, posArray, strokeWidth) {
            doc.save();
            let orient = this.attr('orient'), units = this.attr('markerUnits'), rotate = orient === 'auto' ? posArray[2] : (parseFloat(orient) || 0) * Math.PI / 180, scale = units === 'userSpaceOnUse' ? 1 : strokeWidth;
            doc.transform(Math.cos(rotate) * scale, Math.sin(rotate) * scale, -Math.sin(rotate) * scale, Math.cos(rotate) * scale, posArray[0], posArray[1]);
            let refX = this.getLength('refX', this.getVWidth(), 0), refY = this.getLength('refY', this.getVHeight(), 0), aspectRatioMatrix = parseAspectRatio(this.attr('preserveAspectRatio'), width, height, viewBox[2], viewBox[3], 0.5);
            if (this.get('overflow') === 'hidden') doc.rect(aspectRatioMatrix[0] * (viewBox[0] + viewBox[2] / 2 - refX) - width / 2, aspectRatioMatrix[3] * (viewBox[1] + viewBox[3] / 2 - refY) - height / 2, width, height).clip();
            doc.transform.apply(doc, aspectRatioMatrix);
            doc.translate(-refX, -refY);
            let group;
            if (this.get('opacity') < 1 && !isClip) group = docBeginGroup(getPageBBox());
            this.drawChildren(isClip, isMask);
            if (group) {
                docEndGroup(group);
                doc.fillOpacity(this.get('opacity'));
                docInsertGroup(group);
            }
            doc.restore();
        };
    };
    var SvgElemClipPath = function(obj, inherits) {
        SvgElemHasChildren.call(this, obj, inherits);
        this.useMask = function(bBox) {
            let group = docBeginGroup(getPageBBox());
            doc.save();
            if (this.attr('clipPathUnits') === 'objectBoundingBox') doc.transform(bBox[2] - bBox[0], 0, 0, bBox[3] - bBox[1], bBox[0], bBox[1]);
            this.clip();
            this.drawChildren(true, false);
            doc.restore();
            docEndGroup(group);
            docApplyMask(group, true);
        };
    };
    var SvgElemMask = function(obj, inherits) {
        SvgElemHasChildren.call(this, obj, inherits);
        this.useMask = function(bBox) {
            let group = docBeginGroup(getPageBBox());
            doc.save();
            let x, y, w, h;
            if (this.attr('maskUnits') === 'userSpaceOnUse') {
                x = this.getLength('x', this.getVWidth(), -0.1 * (bBox[2] - bBox[0]) + bBox[0]);
                y = this.getLength('y', this.getVHeight(), -0.1 * (bBox[3] - bBox[1]) + bBox[1]);
                w = this.getLength('width', this.getVWidth(), 1.2 * (bBox[2] - bBox[0]));
                h = this.getLength('height', this.getVHeight(), 1.2 * (bBox[3] - bBox[1]));
            } else {
                x = this.getLength('x', this.getVWidth(), -0.1) * (bBox[2] - bBox[0]) + bBox[0];
                y = this.getLength('y', this.getVHeight(), -0.1) * (bBox[3] - bBox[1]) + bBox[1];
                w = this.getLength('width', this.getVWidth(), 1.2) * (bBox[2] - bBox[0]);
                h = this.getLength('height', this.getVHeight(), 1.2) * (bBox[3] - bBox[1]);
            }
            doc.rect(x, y, w, h).clip();
            if (this.attr('maskContentUnits') === 'objectBoundingBox') doc.transform(bBox[2] - bBox[0], 0, 0, bBox[3] - bBox[1], bBox[0], bBox[1]);
            this.clip();
            this.drawChildren(false, true);
            doc.restore();
            docEndGroup(group);
            docApplyMask(group, true);
        };
    };
    var SvgElemTextContainer = function(obj, inherits) {
        SvgElemStylable.call(this, obj, inherits);
        this.allowedChildren = [
            'tspan',
            '#text',
            '#cdata-section',
            'a'
        ];
        this.isText = true;
        this.getBoundingShape = function() {
            let shape = new SvgShape();
            for(let i = 0; i < this._pos.length; i++){
                let pos = this._pos[i];
                if (!pos.hidden) {
                    let dx0 = pos.ascent * Math.sin(pos.rotate), dy0 = -pos.ascent * Math.cos(pos.rotate), dx1 = pos.descent * Math.sin(pos.rotate), dy1 = -pos.descent * Math.cos(pos.rotate), dx2 = pos.width * Math.cos(pos.rotate), dy2 = pos.width * Math.sin(pos.rotate);
                    shape.M(pos.x + dx0, pos.y + dy0).L(pos.x + dx0 + dx2, pos.y + dy0 + dy2).M(pos.x + dx1 + dx2, pos.y + dy1 + dy2).L(pos.x + dx1, pos.y + dy1);
                }
            }
            return shape;
        };
        this.drawTextInDocument = function(isClip, isMask) {
            if (this.link && !isClip && !isMask) this.addLink();
            if (this.get('text-decoration') === 'underline') this.decorate(0.05 * this._font.size, -0.075 * this._font.size, isClip, isMask);
            if (this.get('text-decoration') === 'overline') this.decorate(0.05 * this._font.size, getAscent(this._font.font, this._font.size) + 0.075 * this._font.size, isClip, isMask);
            let fill = this.getFill(isClip, isMask), stroke = this.getStroke(isClip, isMask), strokeWidth = this.get('stroke-width');
            if (this._font.fauxBold) {
                if (!stroke) {
                    stroke = fill;
                    strokeWidth = this._font.size * 0.03;
                } else strokeWidth += this._font.size * 0.03;
            }
            let children = this.getChildren();
            for(let i = 0; i < children.length; i++){
                let childElem = children[i];
                switch(childElem.name){
                    case 'tspan':
                    case 'textPath':
                    case 'a':
                        if (childElem.get('display') !== 'none') childElem.drawTextInDocument(isClip, isMask);
                        break;
                    case '#text':
                    case '#cdata-section':
                        if (this.get('visibility') === 'hidden') continue;
                        if (fill || stroke || isClip) {
                            if (fill) docFillColor(fill);
                            if (stroke && strokeWidth) {
                                docStrokeColor(stroke);
                                doc.lineWidth(strokeWidth).miterLimit(this.get('stroke-miterlimit')).lineJoin(this.get('stroke-linejoin')).lineCap(this.get('stroke-linecap')).dash(this.get('stroke-dasharray'), {
                                    phase: this.get('stroke-dashoffset')
                                });
                            }
                            docBeginText(this._font.font, this._font.size);
                            docSetTextMode(!!fill, !!stroke);
                            for(let j = 0, pos = childElem._pos; j < pos.length; j++)if (!pos[j].hidden && isNotEqual(pos[j].width, 0)) {
                                let cos = Math.cos(pos[j].rotate), sin = Math.sin(pos[j].rotate), skew = this._font.fauxItalic ? -0.25 : 0;
                                docSetTextMatrix(cos * pos[j].scale, sin * pos[j].scale, cos * skew - sin, sin * skew + cos, pos[j].x, pos[j].y);
                                docWriteGlyph(pos[j].glyph);
                            }
                            docEndText();
                        }
                        break;
                }
            }
            if (this.get('text-decoration') === 'line-through') this.decorate(0.05 * this._font.size, 0.5 * (getAscent(this._font.font, this._font.size) + getDescent(this._font.font, this._font.size)), isClip, isMask);
        };
        this.decorate = function(lineWidth, linePosition, isClip, isMask) {
            let fill = this.getFill(isClip, isMask), stroke = this.getStroke(isClip, isMask);
            if (fill) docFillColor(fill);
            if (stroke) {
                docStrokeColor(stroke);
                doc.lineWidth(this.get('stroke-width')).miterLimit(this.get('stroke-miterlimit')).lineJoin(this.get('stroke-linejoin')).lineCap(this.get('stroke-linecap')).dash(this.get('stroke-dasharray'), {
                    phase: this.get('stroke-dashoffset')
                });
            }
            for(let j = 0, pos = this._pos; j < pos.length; j++)if (!pos[j].hidden && isNotEqual(pos[j].width, 0)) {
                let dx0 = (linePosition + lineWidth / 2) * Math.sin(pos[j].rotate), dy0 = -(linePosition + lineWidth / 2) * Math.cos(pos[j].rotate), dx1 = (linePosition - lineWidth / 2) * Math.sin(pos[j].rotate), dy1 = -(linePosition - lineWidth / 2) * Math.cos(pos[j].rotate), dx2 = pos[j].width * Math.cos(pos[j].rotate), dy2 = pos[j].width * Math.sin(pos[j].rotate);
                new SvgShape().M(pos[j].x + dx0, pos[j].y + dy0).L(pos[j].x + dx0 + dx2, pos[j].y + dy0 + dy2).L(pos[j].x + dx1 + dx2, pos[j].y + dy1 + dy2).L(pos[j].x + dx1, pos[j].y + dy1).Z().insertInDocument();
                if (fill && stroke) doc.fillAndStroke();
                else if (fill) doc.fill();
                else if (stroke) doc.stroke();
            }
        };
    };
    var SvgElemTextNode = function(obj, inherits) {
        this.name = obj.nodeName;
        this.textContent = obj.nodeValue;
    };
    var SvgElemTspan = function(obj, inherits) {
        SvgElemTextContainer.call(this, obj, inherits);
    };
    var SvgElemTextPath = function(obj, inherits) {
        SvgElemTextContainer.call(this, obj, inherits);
        let pathObject, pathLength, temp;
        if ((temp = this.attr('path')) && temp.trim() !== '') {
            let pathLength = this.getLength('pathLength', this.getViewport());
            this.pathObject = new SvgShape().path(temp);
            this.pathLength = pathLength > 0 ? pathLength : this.pathObject.totalLength;
            this.pathScale = this.pathObject.totalLength / this.pathLength;
        } else if ((temp = this.getUrl('href') || this.getUrl('xlink:href')) && temp.nodeName === 'path') {
            let pathElem = new SvgElemPath(temp, this);
            this.pathObject = pathElem.shape.clone().transform(pathElem.get('transform'));
            this.pathLength = this.chooseValue(pathElem.pathLength, this.pathObject.totalLength);
            this.pathScale = this.pathObject.totalLength / this.pathLength;
        }
    };
    var SvgElemText = function(obj, inherits) {
        SvgElemTextContainer.call(this, obj, inherits);
        this.allowedChildren = [
            'textPath',
            'tspan',
            '#text',
            '#cdata-section',
            'a'
        ];
        (function(textParentElem) {
            let processedText = '', remainingText = obj.textContent, textPaths = [], currentChunk = [], currentAnchor, currentDirection, currentX = 0, currentY = 0;
            function doAnchoring() {
                if (currentChunk.length) {
                    let last = currentChunk[currentChunk.length - 1];
                    let first = currentChunk[0];
                    let width = last.x + last.width - first.x;
                    let anchordx = {
                        'startltr': 0,
                        'middleltr': 0.5,
                        'endltr': 1,
                        'startrtl': 1,
                        'middlertl': 0.5,
                        'endrtl': 0
                    }[currentAnchor + currentDirection] * width || 0;
                    for(let i = 0; i < currentChunk.length; i++)currentChunk[i].x -= anchordx;
                }
                currentChunk = [];
            }
            function adjustLength(pos, length, spacingAndGlyphs) {
                let firstChar = pos[0], lastChar = pos[pos.length - 1], startX = firstChar.x, endX = lastChar.x + lastChar.width;
                if (spacingAndGlyphs) {
                    let textScale = length / (endX - startX);
                    if (textScale > 0 && textScale < Infinity) for(let j = 0; j < pos.length; j++){
                        pos[j].x = startX + textScale * (pos[j].x - startX);
                        pos[j].scale *= textScale;
                        pos[j].width *= textScale;
                    }
                } else if (pos.length >= 2) {
                    let spaceDiff = (length - (endX - startX)) / (pos.length - 1);
                    for(let j = 0; j < pos.length; j++)pos[j].x += j * spaceDiff;
                }
                currentX += length - (endX - startX);
            }
            function recursive(currentElem, parentElem) {
                currentElem._x = combineArrays(currentElem.getLengthList('x', currentElem.getVWidth()), parentElem ? parentElem._x.slice(parentElem._pos.length) : []);
                currentElem._y = combineArrays(currentElem.getLengthList('y', currentElem.getVHeight()), parentElem ? parentElem._y.slice(parentElem._pos.length) : []);
                currentElem._dx = combineArrays(currentElem.getLengthList('dx', currentElem.getVWidth()), parentElem ? parentElem._dx.slice(parentElem._pos.length) : []);
                currentElem._dy = combineArrays(currentElem.getLengthList('dy', currentElem.getVHeight()), parentElem ? parentElem._dy.slice(parentElem._pos.length) : []);
                currentElem._rot = combineArrays(currentElem.getNumberList('rotate'), parentElem ? parentElem._rot.slice(parentElem._pos.length) : []);
                currentElem._defRot = currentElem.chooseValue(currentElem._rot[currentElem._rot.length - 1], parentElem && parentElem._defRot, 0);
                if (currentElem.name === 'textPath') currentElem._y = [];
                let fontOptions = {
                    fauxItalic: false,
                    fauxBold: false
                }, fontNameorLink = fontCallback(currentElem.get('font-family'), currentElem.get('font-weight') === 'bold', currentElem.get('font-style') === 'italic', fontOptions);
                try {
                    doc.font(fontNameorLink);
                } catch (e) {
                    warningCallback('SVGElemText: failed to open font "' + fontNameorLink + '" in PDFKit');
                }
                currentElem._pos = [];
                currentElem._index = 0;
                currentElem._font = {
                    font: doc._font,
                    size: currentElem.get('font-size'),
                    fauxItalic: fontOptions.fauxItalic,
                    fauxBold: fontOptions.fauxBold
                };
                let textLength = currentElem.getLength('textLength', currentElem.getVWidth(), undefined), spacingAndGlyphs = currentElem.attr('lengthAdjust') === 'spacingAndGlyphs', wordSpacing = currentElem.get('word-spacing'), letterSpacing = currentElem.get('letter-spacing'), textAnchor = currentElem.get('text-anchor'), textDirection = currentElem.get('direction'), baseline = getBaseline(currentElem._font.font, currentElem._font.size, currentElem.get('alignment-baseline') || currentElem.get('dominant-baseline'), currentElem.get('baseline-shift'));
                if (currentElem.name === 'textPath') {
                    doAnchoring();
                    currentX = currentY = 0;
                }
                let children = currentElem.getChildren();
                for(let i = 0; i < children.length; i++){
                    let childElem = children[i];
                    switch(childElem.name){
                        case 'tspan':
                        case 'textPath':
                        case 'a':
                            recursive(childElem, currentElem);
                            break;
                        case '#text':
                        case '#cdata-section':
                            let rawText = childElem.textContent, renderedText = rawText, words;
                            childElem._font = currentElem._font;
                            childElem._pos = [];
                            remainingText = remainingText.substring(rawText.length);
                            if (currentElem.get('xml:space') === 'preserve') renderedText = renderedText.replace(/[\s]/g, ' ');
                            else {
                                renderedText = renderedText.replace(/[\s]+/g, ' ');
                                if (processedText.match(/[\s]$|^$/)) renderedText = renderedText.replace(/^[\s]/, '');
                                if (remainingText.match(/^[\s]*$/)) renderedText = renderedText.replace(/[\s]$/, '');
                            }
                            processedText += rawText;
                            if (wordSpacing === 0) words = [
                                renderedText
                            ];
                            else words = renderedText.split(/(\s)/);
                            for(let w = 0; w < words.length; w++){
                                let pos = getTextPos(currentElem._font.font, currentElem._font.size, words[w]);
                                for(let j = 0; j < pos.length; j++){
                                    let index = currentElem._index, xAttr = currentElem._x[index], yAttr = currentElem._y[index], dxAttr = currentElem._dx[index], dyAttr = currentElem._dy[index], rotAttr = currentElem._rot[index], continuous = !(w === 0 && j === 0);
                                    if (xAttr !== undefined) {
                                        continuous = false;
                                        doAnchoring();
                                        currentX = xAttr;
                                    }
                                    if (yAttr !== undefined) {
                                        continuous = false;
                                        doAnchoring();
                                        currentY = yAttr;
                                    }
                                    if (dxAttr !== undefined) {
                                        continuous = false;
                                        currentX += dxAttr;
                                    }
                                    if (dyAttr !== undefined) {
                                        continuous = false;
                                        currentY += dyAttr;
                                    }
                                    if (rotAttr !== undefined || currentElem._defRot !== 0) continuous = false;
                                    let position = {
                                        glyph: pos[j].glyph,
                                        rotate: Math.PI / 180 * currentElem.chooseValue(rotAttr, currentElem._defRot),
                                        x: currentX + pos[j].xOffset,
                                        y: currentY + baseline + pos[j].yOffset,
                                        width: pos[j].width,
                                        ascent: getAscent(currentElem._font.font, currentElem._font.size),
                                        descent: getDescent(currentElem._font.font, currentElem._font.size),
                                        scale: 1,
                                        hidden: false,
                                        continuous: continuous
                                    };
                                    currentChunk.push(position);
                                    childElem._pos.push(position);
                                    currentElem._pos.push(position);
                                    currentElem._index += pos[j].unicode.length;
                                    if (currentChunk.length === 1) {
                                        currentAnchor = textAnchor;
                                        currentDirection = textDirection;
                                    }
                                    currentX += pos[j].xAdvance + letterSpacing;
                                    currentY += pos[j].yAdvance;
                                }
                                if (words[w] === ' ') currentX += wordSpacing;
                            }
                            break;
                        default:
                            remainingText = remainingText.substring(childElem.textContent.length);
                    }
                }
                if (textLength && currentElem._pos.length) adjustLength(currentElem._pos, textLength, spacingAndGlyphs);
                if (currentElem.name === 'textPath' || currentElem.name === 'text') doAnchoring();
                if (currentElem.name === 'textPath') {
                    textPaths.push(currentElem);
                    let pathObject = currentElem.pathObject;
                    if (pathObject) {
                        currentX = pathObject.endPoint[0];
                        currentY = pathObject.endPoint[1];
                    }
                }
                if (parentElem) {
                    parentElem._pos = parentElem._pos.concat(currentElem._pos);
                    parentElem._index += currentElem._index;
                }
            }
            function textOnPath(currentElem) {
                let pathObject = currentElem.pathObject, pathLength = currentElem.pathLength, pathScale = currentElem.pathScale;
                if (pathObject) {
                    let textOffset = currentElem.getLength('startOffset', pathLength, 0);
                    for(let j = 0; j < currentElem._pos.length; j++){
                        let charMidX = textOffset + currentElem._pos[j].x + 0.5 * currentElem._pos[j].width;
                        if (charMidX > pathLength || charMidX < 0) currentElem._pos[j].hidden = true;
                        else {
                            let pointOnPath = pathObject.getPointAtLength(charMidX * pathScale);
                            if (isNotEqual(pathScale, 1)) {
                                currentElem._pos[j].scale *= pathScale;
                                currentElem._pos[j].width *= pathScale;
                            }
                            currentElem._pos[j].x = pointOnPath[0] - 0.5 * currentElem._pos[j].width * Math.cos(pointOnPath[2]) - currentElem._pos[j].y * Math.sin(pointOnPath[2]);
                            currentElem._pos[j].y = pointOnPath[1] - 0.5 * currentElem._pos[j].width * Math.sin(pointOnPath[2]) + currentElem._pos[j].y * Math.cos(pointOnPath[2]);
                            currentElem._pos[j].rotate = pointOnPath[2] + currentElem._pos[j].rotate;
                            currentElem._pos[j].continuous = false;
                        }
                    }
                } else for(let j = 0; j < currentElem._pos.length; j++)currentElem._pos[j].hidden = true;
            }
            recursive(textParentElem, null);
            for(let i = 0; i < textPaths.length; i++)textOnPath(textPaths[i]);
        })(this);
        this.getTransformation = function() {
            return this.get('transform');
        };
        this.drawInDocument = function(isClip, isMask) {
            doc.save();
            this.transform();
            this.clip();
            let masked = this.mask(), group;
            if (masked) group = docBeginGroup(getPageBBox());
            this.drawTextInDocument(isClip, isMask);
            if (group) {
                docEndGroup(group);
                docInsertGroup(group);
            }
            doc.restore();
        };
    };
    options = options || {};
    var pxToPt = options.assumePt ? 1 : 0.75, viewportWidth = (options.width || doc.page.width) / pxToPt, viewportHeight = (options.height || doc.page.height) / pxToPt, preserveAspectRatio = options.preserveAspectRatio || null, useCSS = options.useCSS && typeof SVGElement !== 'undefined' && svg instanceof SVGElement && typeof getComputedStyle === 'function', warningCallback = options.warningCallback, fontCallback = options.fontCallback, imageCallback = options.imageCallback, colorCallback = options.colorCallback, documentCallback = options.documentCallback, precision = Math.ceil(Math.max(1, options.precision)) || 3, groupStack = [], documentCache = {}, links = [], styleRules = [];
    if (typeof warningCallback !== 'function') warningCallback = function(str) {
        if (typeof console.warn === 'function') console.warn(str);
    };
    if (typeof fontCallback !== 'function') fontCallback = function(family, bold, italic, fontOptions) {
        // Check if the font is already registered in the document
        if (bold && italic) {
            if (doc._registeredFonts.hasOwnProperty(family + '-BoldItalic')) return family + '-BoldItalic';
            else if (doc._registeredFonts.hasOwnProperty(family + '-Italic')) {
                fontOptions.fauxBold = true;
                return family + '-Italic';
            } else if (doc._registeredFonts.hasOwnProperty(family + '-Bold')) {
                fontOptions.fauxItalic = true;
                return family + '-Bold';
            } else if (doc._registeredFonts.hasOwnProperty(family)) {
                fontOptions.fauxBold = true;
                fontOptions.fauxItalic = true;
                return family;
            }
        }
        if (bold && !italic) {
            if (doc._registeredFonts.hasOwnProperty(family + '-Bold')) return family + '-Bold';
            else if (doc._registeredFonts.hasOwnProperty(family)) {
                fontOptions.fauxBold = true;
                return family;
            }
        }
        if (!bold && italic) {
            if (doc._registeredFonts.hasOwnProperty(family + '-Italic')) return family + '-Italic';
            else if (doc._registeredFonts.hasOwnProperty(family)) {
                fontOptions.fauxItalic = true;
                return family;
            }
        }
        if (!bold && !italic) {
            if (doc._registeredFonts.hasOwnProperty(family)) return family;
        }
        // Use standard fonts as fallback
        if (family.match(/(?:^|,)\s*serif\s*$/)) {
            if (bold && italic) return 'Times-BoldItalic';
            if (bold && !italic) return 'Times-Bold';
            if (!bold && italic) return 'Times-Italic';
            if (!bold && !italic) return 'Times-Roman';
        } else if (family.match(/(?:^|,)\s*monospace\s*$/)) {
            if (bold && italic) return 'Courier-BoldOblique';
            if (bold && !italic) return 'Courier-Bold';
            if (!bold && italic) return 'Courier-Oblique';
            if (!bold && !italic) return 'Courier';
        } else {
            family.match(/(?:^|,)\s*sans-serif\s*$/);
            if (bold && italic) return 'Helvetica-BoldOblique';
            if (bold && !italic) return 'Helvetica-Bold';
            if (!bold && italic) return 'Helvetica-Oblique';
            if (!bold && !italic) return 'Helvetica';
        }
    };
    if (typeof imageCallback !== 'function') imageCallback = function(link) {
        return link.replace(/\s+/g, '');
    };
    if (typeof colorCallback !== 'function') colorCallback = null;
    else for(let color in DefaultColors){
        let newColor = colorCallback(DefaultColors[color]);
        DefaultColors[color][0] = newColor[0];
        DefaultColors[color][1] = newColor[1];
    }
    if (typeof documentCallback !== 'function') documentCallback = null;
    if (typeof svg === 'string') svg = parseXml(svg);
    if (svg) {
        let styles = svg.getElementsByTagName('style');
        for(let i = 0; i < styles.length; i++)styleRules = styleRules.concat(parseStyleSheet(styles[i].textContent));
        let elem = createSVGElement(svg, null);
        if (typeof elem.drawInDocument === 'function') {
            if (options.useCSS && !useCSS) warningCallback('SVGtoPDF: useCSS option can only be used for SVG *elements* in compatible browsers');
            let savedFillColor = doc._fillColor;
            doc.save().translate(x || 0, y || 0).scale(pxToPt);
            elem.drawInDocument();
            for(let i = 0; i < links.length; i++)doc.page.annotations.push(links[i]);
            doc.restore();
            doc._fillColor = savedFillColor;
        } else warningCallback('SVGtoPDF: this element can\'t be rendered directly: ' + svg.nodeName);
    } else warningCallback('SVGtoPDF: the input does not look like a valid SVG');
};
if (module && typeof module.exports !== 'undefined') module.exports = SVGtoPDF;

});

parcelRegister("FSPyV", function(module, exports) {

$parcel$export(module.exports, "BrotliDecompressBuffer", () => $07de5cacda4a8284$export$9840689580eff2f0, (v) => $07de5cacda4a8284$export$9840689580eff2f0 = v);
/* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ var $07de5cacda4a8284$export$fa64f32e2d0558a1;
var $07de5cacda4a8284$export$9840689580eff2f0;
var $07de5cacda4a8284$export$59cbf0b8eef2df1e;

var $kd0XG = parcelRequire("kd0XG");
var $07de5cacda4a8284$require$BrotliInput = $kd0XG.BrotliInput;

var $kd0XG = parcelRequire("kd0XG");
var $07de5cacda4a8284$require$BrotliOutput = $kd0XG.BrotliOutput;

var $1FOT7 = parcelRequire("1FOT7");

var $cLKb7 = parcelRequire("cLKb7");

var $gFLZd = parcelRequire("gFLZd");
var $07de5cacda4a8284$require$HuffmanCode = $gFLZd.HuffmanCode;

var $gFLZd = parcelRequire("gFLZd");
var $07de5cacda4a8284$require$BrotliBuildHuffmanTable = $gFLZd.BrotliBuildHuffmanTable;

var $iLHtq = parcelRequire("iLHtq");

var $cvXqP = parcelRequire("cvXqP");

var $euO8X = parcelRequire("euO8X");
var $07de5cacda4a8284$var$kDefaultCodeLength = 8;
var $07de5cacda4a8284$var$kCodeLengthRepeatCode = 16;
var $07de5cacda4a8284$var$kNumLiteralCodes = 256;
var $07de5cacda4a8284$var$kNumInsertAndCopyCodes = 704;
var $07de5cacda4a8284$var$kNumBlockLengthCodes = 26;
var $07de5cacda4a8284$var$kLiteralContextBits = 6;
var $07de5cacda4a8284$var$kDistanceContextBits = 2;
var $07de5cacda4a8284$var$HUFFMAN_TABLE_BITS = 8;
var $07de5cacda4a8284$var$HUFFMAN_TABLE_MASK = 0xff;
/* Maximum possible Huffman table size for an alphabet size of 704, max code
 * length 15 and root table bits 8. */ var $07de5cacda4a8284$var$HUFFMAN_MAX_TABLE_SIZE = 1080;
var $07de5cacda4a8284$var$CODE_LENGTH_CODES = 18;
var $07de5cacda4a8284$var$kCodeLengthCodeOrder = new Uint8Array([
    1,
    2,
    3,
    4,
    0,
    5,
    17,
    6,
    16,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15
]);
var $07de5cacda4a8284$var$NUM_DISTANCE_SHORT_CODES = 16;
var $07de5cacda4a8284$var$kDistanceShortCodeIndexOffset = new Uint8Array([
    3,
    2,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    2,
    2,
    2,
    2
]);
var $07de5cacda4a8284$var$kDistanceShortCodeValueOffset = new Int8Array([
    0,
    0,
    0,
    0,
    -1,
    1,
    -2,
    2,
    -3,
    3,
    -1,
    1,
    -2,
    2,
    -3,
    3
]);
var $07de5cacda4a8284$var$kMaxHuffmanTableSize = new Uint16Array([
    256,
    402,
    436,
    468,
    500,
    534,
    566,
    598,
    630,
    662,
    694,
    726,
    758,
    790,
    822,
    854,
    886,
    920,
    952,
    984,
    1016,
    1048,
    1080
]);
function $07de5cacda4a8284$var$DecodeWindowBits(br) {
    var n;
    if (br.readBits(1) === 0) return 16;
    n = br.readBits(3);
    if (n > 0) return 17 + n;
    n = br.readBits(3);
    if (n > 0) return 8 + n;
    return 17;
}
/* Decodes a number in the range [0..255], by reading 1 - 11 bits. */ function $07de5cacda4a8284$var$DecodeVarLenUint8(br) {
    if (br.readBits(1)) {
        var nbits = br.readBits(3);
        if (nbits === 0) return 1;
        else return br.readBits(nbits) + (1 << nbits);
    }
    return 0;
}
function $07de5cacda4a8284$var$MetaBlockLength() {
    this.meta_block_length = 0;
    this.input_end = 0;
    this.is_uncompressed = 0;
    this.is_metadata = false;
}
function $07de5cacda4a8284$var$DecodeMetaBlockLength(br) {
    var out = new $07de5cacda4a8284$var$MetaBlockLength;
    var size_nibbles;
    var size_bytes;
    var i;
    out.input_end = br.readBits(1);
    if (out.input_end && br.readBits(1)) return out;
    size_nibbles = br.readBits(2) + 4;
    if (size_nibbles === 7) {
        out.is_metadata = true;
        if (br.readBits(1) !== 0) throw new Error('Invalid reserved bit');
        size_bytes = br.readBits(2);
        if (size_bytes === 0) return out;
        for(i = 0; i < size_bytes; i++){
            var next_byte = br.readBits(8);
            if (i + 1 === size_bytes && size_bytes > 1 && next_byte === 0) throw new Error('Invalid size byte');
            out.meta_block_length |= next_byte << i * 8;
        }
    } else for(i = 0; i < size_nibbles; ++i){
        var next_nibble = br.readBits(4);
        if (i + 1 === size_nibbles && size_nibbles > 4 && next_nibble === 0) throw new Error('Invalid size nibble');
        out.meta_block_length |= next_nibble << i * 4;
    }
    ++out.meta_block_length;
    if (!out.input_end && !out.is_metadata) out.is_uncompressed = br.readBits(1);
    return out;
}
/* Decodes the next Huffman code from bit-stream. */ function $07de5cacda4a8284$var$ReadSymbol(table, index, br) {
    var start_index = index;
    var nbits;
    br.fillBitWindow();
    index += br.val_ >>> br.bit_pos_ & $07de5cacda4a8284$var$HUFFMAN_TABLE_MASK;
    nbits = table[index].bits - $07de5cacda4a8284$var$HUFFMAN_TABLE_BITS;
    if (nbits > 0) {
        br.bit_pos_ += $07de5cacda4a8284$var$HUFFMAN_TABLE_BITS;
        index += table[index].value;
        index += br.val_ >>> br.bit_pos_ & (1 << nbits) - 1;
    }
    br.bit_pos_ += table[index].bits;
    return table[index].value;
}
function $07de5cacda4a8284$var$ReadHuffmanCodeLengths(code_length_code_lengths, num_symbols, code_lengths, br) {
    var symbol = 0;
    var prev_code_len = $07de5cacda4a8284$var$kDefaultCodeLength;
    var repeat = 0;
    var repeat_code_len = 0;
    var space = 32768;
    var table = [];
    for(var i = 0; i < 32; i++)table.push(new $07de5cacda4a8284$require$HuffmanCode(0, 0));
    $07de5cacda4a8284$require$BrotliBuildHuffmanTable(table, 0, 5, code_length_code_lengths, $07de5cacda4a8284$var$CODE_LENGTH_CODES);
    while(symbol < num_symbols && space > 0){
        var p = 0;
        var code_len;
        br.readMoreInput();
        br.fillBitWindow();
        p += br.val_ >>> br.bit_pos_ & 31;
        br.bit_pos_ += table[p].bits;
        code_len = table[p].value & 0xff;
        if (code_len < $07de5cacda4a8284$var$kCodeLengthRepeatCode) {
            repeat = 0;
            code_lengths[symbol++] = code_len;
            if (code_len !== 0) {
                prev_code_len = code_len;
                space -= 32768 >> code_len;
            }
        } else {
            var extra_bits = code_len - 14;
            var old_repeat;
            var repeat_delta;
            var new_len = 0;
            if (code_len === $07de5cacda4a8284$var$kCodeLengthRepeatCode) new_len = prev_code_len;
            if (repeat_code_len !== new_len) {
                repeat = 0;
                repeat_code_len = new_len;
            }
            old_repeat = repeat;
            if (repeat > 0) {
                repeat -= 2;
                repeat <<= extra_bits;
            }
            repeat += br.readBits(extra_bits) + 3;
            repeat_delta = repeat - old_repeat;
            if (symbol + repeat_delta > num_symbols) throw new Error('[ReadHuffmanCodeLengths] symbol + repeat_delta > num_symbols');
            for(var x = 0; x < repeat_delta; x++)code_lengths[symbol + x] = repeat_code_len;
            symbol += repeat_delta;
            if (repeat_code_len !== 0) space -= repeat_delta << 15 - repeat_code_len;
        }
    }
    if (space !== 0) throw new Error("[ReadHuffmanCodeLengths] space = " + space);
    for(; symbol < num_symbols; symbol++)code_lengths[symbol] = 0;
}
function $07de5cacda4a8284$var$ReadHuffmanCode(alphabet_size, tables, table, br) {
    var table_size = 0;
    var simple_code_or_skip;
    var code_lengths = new Uint8Array(alphabet_size);
    br.readMoreInput();
    /* simple_code_or_skip is used as follows:
     1 for simple code;
     0 for no skipping, 2 skips 2 code lengths, 3 skips 3 code lengths */ simple_code_or_skip = br.readBits(2);
    if (simple_code_or_skip === 1) {
        /* Read symbols, codes & code lengths directly. */ var i;
        var max_bits_counter = alphabet_size - 1;
        var max_bits = 0;
        var symbols = new Int32Array(4);
        var num_symbols = br.readBits(2) + 1;
        while(max_bits_counter){
            max_bits_counter >>= 1;
            ++max_bits;
        }
        for(i = 0; i < num_symbols; ++i){
            symbols[i] = br.readBits(max_bits) % alphabet_size;
            code_lengths[symbols[i]] = 2;
        }
        code_lengths[symbols[0]] = 1;
        switch(num_symbols){
            case 1:
                break;
            case 3:
                if (symbols[0] === symbols[1] || symbols[0] === symbols[2] || symbols[1] === symbols[2]) throw new Error('[ReadHuffmanCode] invalid symbols');
                break;
            case 2:
                if (symbols[0] === symbols[1]) throw new Error('[ReadHuffmanCode] invalid symbols');
                code_lengths[symbols[1]] = 1;
                break;
            case 4:
                if (symbols[0] === symbols[1] || symbols[0] === symbols[2] || symbols[0] === symbols[3] || symbols[1] === symbols[2] || symbols[1] === symbols[3] || symbols[2] === symbols[3]) throw new Error('[ReadHuffmanCode] invalid symbols');
                if (br.readBits(1)) {
                    code_lengths[symbols[2]] = 3;
                    code_lengths[symbols[3]] = 3;
                } else code_lengths[symbols[0]] = 2;
                break;
        }
    } else {
        var i;
        var code_length_code_lengths = new Uint8Array($07de5cacda4a8284$var$CODE_LENGTH_CODES);
        var space = 32;
        var num_codes = 0;
        /* Static Huffman code for the code length code lengths */ var huff = [
            new $07de5cacda4a8284$require$HuffmanCode(2, 0),
            new $07de5cacda4a8284$require$HuffmanCode(2, 4),
            new $07de5cacda4a8284$require$HuffmanCode(2, 3),
            new $07de5cacda4a8284$require$HuffmanCode(3, 2),
            new $07de5cacda4a8284$require$HuffmanCode(2, 0),
            new $07de5cacda4a8284$require$HuffmanCode(2, 4),
            new $07de5cacda4a8284$require$HuffmanCode(2, 3),
            new $07de5cacda4a8284$require$HuffmanCode(4, 1),
            new $07de5cacda4a8284$require$HuffmanCode(2, 0),
            new $07de5cacda4a8284$require$HuffmanCode(2, 4),
            new $07de5cacda4a8284$require$HuffmanCode(2, 3),
            new $07de5cacda4a8284$require$HuffmanCode(3, 2),
            new $07de5cacda4a8284$require$HuffmanCode(2, 0),
            new $07de5cacda4a8284$require$HuffmanCode(2, 4),
            new $07de5cacda4a8284$require$HuffmanCode(2, 3),
            new $07de5cacda4a8284$require$HuffmanCode(4, 5)
        ];
        for(i = simple_code_or_skip; i < $07de5cacda4a8284$var$CODE_LENGTH_CODES && space > 0; ++i){
            var code_len_idx = $07de5cacda4a8284$var$kCodeLengthCodeOrder[i];
            var p = 0;
            var v;
            br.fillBitWindow();
            p += br.val_ >>> br.bit_pos_ & 15;
            br.bit_pos_ += huff[p].bits;
            v = huff[p].value;
            code_length_code_lengths[code_len_idx] = v;
            if (v !== 0) {
                space -= 32 >> v;
                ++num_codes;
            }
        }
        if (!(num_codes === 1 || space === 0)) throw new Error('[ReadHuffmanCode] invalid num_codes or space');
        $07de5cacda4a8284$var$ReadHuffmanCodeLengths(code_length_code_lengths, alphabet_size, code_lengths, br);
    }
    table_size = $07de5cacda4a8284$require$BrotliBuildHuffmanTable(tables, table, $07de5cacda4a8284$var$HUFFMAN_TABLE_BITS, code_lengths, alphabet_size);
    if (table_size === 0) throw new Error("[ReadHuffmanCode] BuildHuffmanTable failed: ");
    return table_size;
}
function $07de5cacda4a8284$var$ReadBlockLength(table, index, br) {
    var code;
    var nbits;
    code = $07de5cacda4a8284$var$ReadSymbol(table, index, br);
    nbits = $cvXqP.kBlockLengthPrefixCode[code].nbits;
    return $cvXqP.kBlockLengthPrefixCode[code].offset + br.readBits(nbits);
}
function $07de5cacda4a8284$var$TranslateShortCodes(code, ringbuffer, index) {
    var val;
    if (code < $07de5cacda4a8284$var$NUM_DISTANCE_SHORT_CODES) {
        index += $07de5cacda4a8284$var$kDistanceShortCodeIndexOffset[code];
        index &= 3;
        val = ringbuffer[index] + $07de5cacda4a8284$var$kDistanceShortCodeValueOffset[code];
    } else val = code - $07de5cacda4a8284$var$NUM_DISTANCE_SHORT_CODES + 1;
    return val;
}
function $07de5cacda4a8284$var$MoveToFront(v, index) {
    var value = v[index];
    var i = index;
    for(; i; --i)v[i] = v[i - 1];
    v[0] = value;
}
function $07de5cacda4a8284$var$InverseMoveToFrontTransform(v, v_len) {
    var mtf = new Uint8Array(256);
    var i;
    for(i = 0; i < 256; ++i)mtf[i] = i;
    for(i = 0; i < v_len; ++i){
        var index = v[i];
        v[i] = mtf[index];
        if (index) $07de5cacda4a8284$var$MoveToFront(mtf, index);
    }
}
/* Contains a collection of huffman trees with the same alphabet size. */ function $07de5cacda4a8284$var$HuffmanTreeGroup(alphabet_size, num_htrees) {
    this.alphabet_size = alphabet_size;
    this.num_htrees = num_htrees;
    this.codes = new Array(num_htrees + num_htrees * $07de5cacda4a8284$var$kMaxHuffmanTableSize[alphabet_size + 31 >>> 5]);
    this.htrees = new Uint32Array(num_htrees);
}
$07de5cacda4a8284$var$HuffmanTreeGroup.prototype.decode = function(br) {
    var i;
    var table_size;
    var next = 0;
    for(i = 0; i < this.num_htrees; ++i){
        this.htrees[i] = next;
        table_size = $07de5cacda4a8284$var$ReadHuffmanCode(this.alphabet_size, this.codes, next, br);
        next += table_size;
    }
};
function $07de5cacda4a8284$var$DecodeContextMap(context_map_size, br) {
    var out = {
        num_htrees: null,
        context_map: null
    };
    var use_rle_for_zeros;
    var max_run_length_prefix = 0;
    var table;
    var i;
    br.readMoreInput();
    var num_htrees = out.num_htrees = $07de5cacda4a8284$var$DecodeVarLenUint8(br) + 1;
    var context_map = out.context_map = new Uint8Array(context_map_size);
    if (num_htrees <= 1) return out;
    use_rle_for_zeros = br.readBits(1);
    if (use_rle_for_zeros) max_run_length_prefix = br.readBits(4) + 1;
    table = [];
    for(i = 0; i < $07de5cacda4a8284$var$HUFFMAN_MAX_TABLE_SIZE; i++)table[i] = new $07de5cacda4a8284$require$HuffmanCode(0, 0);
    $07de5cacda4a8284$var$ReadHuffmanCode(num_htrees + max_run_length_prefix, table, 0, br);
    for(i = 0; i < context_map_size;){
        var code;
        br.readMoreInput();
        code = $07de5cacda4a8284$var$ReadSymbol(table, 0, br);
        if (code === 0) {
            context_map[i] = 0;
            ++i;
        } else if (code <= max_run_length_prefix) {
            var reps = 1 + (1 << code) + br.readBits(code);
            while(--reps){
                if (i >= context_map_size) throw new Error("[DecodeContextMap] i >= context_map_size");
                context_map[i] = 0;
                ++i;
            }
        } else {
            context_map[i] = code - max_run_length_prefix;
            ++i;
        }
    }
    if (br.readBits(1)) $07de5cacda4a8284$var$InverseMoveToFrontTransform(context_map, context_map_size);
    return out;
}
function $07de5cacda4a8284$var$DecodeBlockType(max_block_type, trees, tree_type, block_types, ringbuffers, indexes, br) {
    var ringbuffer = tree_type * 2;
    var index = tree_type;
    var type_code = $07de5cacda4a8284$var$ReadSymbol(trees, tree_type * $07de5cacda4a8284$var$HUFFMAN_MAX_TABLE_SIZE, br);
    var block_type;
    if (type_code === 0) block_type = ringbuffers[ringbuffer + (indexes[index] & 1)];
    else if (type_code === 1) block_type = ringbuffers[ringbuffer + (indexes[index] - 1 & 1)] + 1;
    else block_type = type_code - 2;
    if (block_type >= max_block_type) block_type -= max_block_type;
    block_types[tree_type] = block_type;
    ringbuffers[ringbuffer + (indexes[index] & 1)] = block_type;
    ++indexes[index];
}
function $07de5cacda4a8284$var$CopyUncompressedBlockToOutput(output, len, pos, ringbuffer, ringbuffer_mask, br) {
    var rb_size = ringbuffer_mask + 1;
    var rb_pos = pos & ringbuffer_mask;
    var br_pos = br.pos_ & $1FOT7.IBUF_MASK;
    var nbytes;
    /* For short lengths copy byte-by-byte */ if (len < 8 || br.bit_pos_ + (len << 3) < br.bit_end_pos_) {
        while(len-- > 0){
            br.readMoreInput();
            ringbuffer[rb_pos++] = br.readBits(8);
            if (rb_pos === rb_size) {
                output.write(ringbuffer, rb_size);
                rb_pos = 0;
            }
        }
        return;
    }
    if (br.bit_end_pos_ < 32) throw new Error('[CopyUncompressedBlockToOutput] br.bit_end_pos_ < 32');
    /* Copy remaining 0-4 bytes from br.val_ to ringbuffer. */ while(br.bit_pos_ < 32){
        ringbuffer[rb_pos] = br.val_ >>> br.bit_pos_;
        br.bit_pos_ += 8;
        ++rb_pos;
        --len;
    }
    /* Copy remaining bytes from br.buf_ to ringbuffer. */ nbytes = br.bit_end_pos_ - br.bit_pos_ >> 3;
    if (br_pos + nbytes > $1FOT7.IBUF_MASK) {
        var tail = $1FOT7.IBUF_MASK + 1 - br_pos;
        for(var x = 0; x < tail; x++)ringbuffer[rb_pos + x] = br.buf_[br_pos + x];
        nbytes -= tail;
        rb_pos += tail;
        len -= tail;
        br_pos = 0;
    }
    for(var x = 0; x < nbytes; x++)ringbuffer[rb_pos + x] = br.buf_[br_pos + x];
    rb_pos += nbytes;
    len -= nbytes;
    /* If we wrote past the logical end of the ringbuffer, copy the tail of the
     ringbuffer to its beginning and flush the ringbuffer to the output. */ if (rb_pos >= rb_size) {
        output.write(ringbuffer, rb_size);
        rb_pos -= rb_size;
        for(var x = 0; x < rb_pos; x++)ringbuffer[x] = ringbuffer[rb_size + x];
    }
    /* If we have more to copy than the remaining size of the ringbuffer, then we
     first fill the ringbuffer from the input and then flush the ringbuffer to
     the output */ while(rb_pos + len >= rb_size){
        nbytes = rb_size - rb_pos;
        if (br.input_.read(ringbuffer, rb_pos, nbytes) < nbytes) throw new Error('[CopyUncompressedBlockToOutput] not enough bytes');
        output.write(ringbuffer, rb_size);
        len -= nbytes;
        rb_pos = 0;
    }
    /* Copy straight from the input onto the ringbuffer. The ringbuffer will be
     flushed to the output at a later time. */ if (br.input_.read(ringbuffer, rb_pos, len) < len) throw new Error('[CopyUncompressedBlockToOutput] not enough bytes');
    /* Restore the state of the bit reader. */ br.reset();
}
/* Advances the bit reader position to the next byte boundary and verifies
   that any skipped bits are set to zero. */ function $07de5cacda4a8284$var$JumpToByteBoundary(br) {
    var new_bit_pos = br.bit_pos_ + 7 & -8;
    var pad_bits = br.readBits(new_bit_pos - br.bit_pos_);
    return pad_bits == 0;
}
function $07de5cacda4a8284$var$BrotliDecompressedSize(buffer) {
    var input = new $07de5cacda4a8284$require$BrotliInput(buffer);
    var br = new $1FOT7(input);
    $07de5cacda4a8284$var$DecodeWindowBits(br);
    var out = $07de5cacda4a8284$var$DecodeMetaBlockLength(br);
    return out.meta_block_length;
}
$07de5cacda4a8284$export$fa64f32e2d0558a1 = $07de5cacda4a8284$var$BrotliDecompressedSize;
function $07de5cacda4a8284$var$BrotliDecompressBuffer(buffer, output_size) {
    var input = new $07de5cacda4a8284$require$BrotliInput(buffer);
    if (output_size == null) output_size = $07de5cacda4a8284$var$BrotliDecompressedSize(buffer);
    var output_buffer = new Uint8Array(output_size);
    var output = new $07de5cacda4a8284$require$BrotliOutput(output_buffer);
    $07de5cacda4a8284$var$BrotliDecompress(input, output);
    if (output.pos < output.buffer.length) output.buffer = output.buffer.subarray(0, output.pos);
    return output.buffer;
}
$07de5cacda4a8284$export$9840689580eff2f0 = $07de5cacda4a8284$var$BrotliDecompressBuffer;
function $07de5cacda4a8284$var$BrotliDecompress(input, output) {
    var i;
    var pos = 0;
    var input_end = 0;
    var window_bits = 0;
    var max_backward_distance;
    var max_distance = 0;
    var ringbuffer_size;
    var ringbuffer_mask;
    var ringbuffer;
    var ringbuffer_end;
    /* This ring buffer holds a few past copy distances that will be used by */ /* some special distance codes. */ var dist_rb = [
        16,
        15,
        11,
        4
    ];
    var dist_rb_idx = 0;
    /* The previous 2 bytes used for context. */ var prev_byte1 = 0;
    var prev_byte2 = 0;
    var hgroup = [
        new $07de5cacda4a8284$var$HuffmanTreeGroup(0, 0),
        new $07de5cacda4a8284$var$HuffmanTreeGroup(0, 0),
        new $07de5cacda4a8284$var$HuffmanTreeGroup(0, 0)
    ];
    var block_type_trees;
    var block_len_trees;
    var br;
    /* We need the slack region for the following reasons:
       - always doing two 8-byte copies for fast backward copying
       - transforms
       - flushing the input ringbuffer when decoding uncompressed blocks */ var kRingBufferWriteAheadSlack = 128 + $1FOT7.READ_SIZE;
    br = new $1FOT7(input);
    /* Decode window size. */ window_bits = $07de5cacda4a8284$var$DecodeWindowBits(br);
    max_backward_distance = (1 << window_bits) - 16;
    ringbuffer_size = 1 << window_bits;
    ringbuffer_mask = ringbuffer_size - 1;
    ringbuffer = new Uint8Array(ringbuffer_size + kRingBufferWriteAheadSlack + $cLKb7.maxDictionaryWordLength);
    ringbuffer_end = ringbuffer_size;
    block_type_trees = [];
    block_len_trees = [];
    for(var x = 0; x < 3 * $07de5cacda4a8284$var$HUFFMAN_MAX_TABLE_SIZE; x++){
        block_type_trees[x] = new $07de5cacda4a8284$require$HuffmanCode(0, 0);
        block_len_trees[x] = new $07de5cacda4a8284$require$HuffmanCode(0, 0);
    }
    while(!input_end){
        var meta_block_remaining_len = 0;
        var is_uncompressed;
        var block_length = [
            268435456,
            268435456,
            268435456
        ];
        var block_type = [
            0
        ];
        var num_block_types = [
            1,
            1,
            1
        ];
        var block_type_rb = [
            0,
            1,
            0,
            1,
            0,
            1
        ];
        var block_type_rb_index = [
            0
        ];
        var distance_postfix_bits;
        var num_direct_distance_codes;
        var distance_postfix_mask;
        var num_distance_codes;
        var context_map = null;
        var context_modes = null;
        var num_literal_htrees;
        var dist_context_map = null;
        var num_dist_htrees;
        var context_offset = 0;
        var context_map_slice = null;
        var literal_htree_index = 0;
        var dist_context_offset = 0;
        var dist_context_map_slice = null;
        var dist_htree_index = 0;
        var context_lookup_offset1 = 0;
        var context_lookup_offset2 = 0;
        var context_mode;
        var htree_command;
        for(i = 0; i < 3; ++i){
            hgroup[i].codes = null;
            hgroup[i].htrees = null;
        }
        br.readMoreInput();
        var _out = $07de5cacda4a8284$var$DecodeMetaBlockLength(br);
        meta_block_remaining_len = _out.meta_block_length;
        if (pos + meta_block_remaining_len > output.buffer.length) {
            /* We need to grow the output buffer to fit the additional data. */ var tmp = new Uint8Array(pos + meta_block_remaining_len);
            tmp.set(output.buffer);
            output.buffer = tmp;
        }
        input_end = _out.input_end;
        is_uncompressed = _out.is_uncompressed;
        if (_out.is_metadata) {
            $07de5cacda4a8284$var$JumpToByteBoundary(br);
            for(; meta_block_remaining_len > 0; --meta_block_remaining_len){
                br.readMoreInput();
                /* Read one byte and ignore it. */ br.readBits(8);
            }
            continue;
        }
        if (meta_block_remaining_len === 0) continue;
        if (is_uncompressed) {
            br.bit_pos_ = br.bit_pos_ + 7 & -8;
            $07de5cacda4a8284$var$CopyUncompressedBlockToOutput(output, meta_block_remaining_len, pos, ringbuffer, ringbuffer_mask, br);
            pos += meta_block_remaining_len;
            continue;
        }
        for(i = 0; i < 3; ++i){
            num_block_types[i] = $07de5cacda4a8284$var$DecodeVarLenUint8(br) + 1;
            if (num_block_types[i] >= 2) {
                $07de5cacda4a8284$var$ReadHuffmanCode(num_block_types[i] + 2, block_type_trees, i * $07de5cacda4a8284$var$HUFFMAN_MAX_TABLE_SIZE, br);
                $07de5cacda4a8284$var$ReadHuffmanCode($07de5cacda4a8284$var$kNumBlockLengthCodes, block_len_trees, i * $07de5cacda4a8284$var$HUFFMAN_MAX_TABLE_SIZE, br);
                block_length[i] = $07de5cacda4a8284$var$ReadBlockLength(block_len_trees, i * $07de5cacda4a8284$var$HUFFMAN_MAX_TABLE_SIZE, br);
                block_type_rb_index[i] = 1;
            }
        }
        br.readMoreInput();
        distance_postfix_bits = br.readBits(2);
        num_direct_distance_codes = $07de5cacda4a8284$var$NUM_DISTANCE_SHORT_CODES + (br.readBits(4) << distance_postfix_bits);
        distance_postfix_mask = (1 << distance_postfix_bits) - 1;
        num_distance_codes = num_direct_distance_codes + (48 << distance_postfix_bits);
        context_modes = new Uint8Array(num_block_types[0]);
        for(i = 0; i < num_block_types[0]; ++i){
            br.readMoreInput();
            context_modes[i] = br.readBits(2) << 1;
        }
        var _o1 = $07de5cacda4a8284$var$DecodeContextMap(num_block_types[0] << $07de5cacda4a8284$var$kLiteralContextBits, br);
        num_literal_htrees = _o1.num_htrees;
        context_map = _o1.context_map;
        var _o2 = $07de5cacda4a8284$var$DecodeContextMap(num_block_types[2] << $07de5cacda4a8284$var$kDistanceContextBits, br);
        num_dist_htrees = _o2.num_htrees;
        dist_context_map = _o2.context_map;
        hgroup[0] = new $07de5cacda4a8284$var$HuffmanTreeGroup($07de5cacda4a8284$var$kNumLiteralCodes, num_literal_htrees);
        hgroup[1] = new $07de5cacda4a8284$var$HuffmanTreeGroup($07de5cacda4a8284$var$kNumInsertAndCopyCodes, num_block_types[1]);
        hgroup[2] = new $07de5cacda4a8284$var$HuffmanTreeGroup(num_distance_codes, num_dist_htrees);
        for(i = 0; i < 3; ++i)hgroup[i].decode(br);
        context_map_slice = 0;
        dist_context_map_slice = 0;
        context_mode = context_modes[block_type[0]];
        context_lookup_offset1 = $iLHtq.lookupOffsets[context_mode];
        context_lookup_offset2 = $iLHtq.lookupOffsets[context_mode + 1];
        htree_command = hgroup[1].htrees[0];
        while(meta_block_remaining_len > 0){
            var cmd_code;
            var range_idx;
            var insert_code;
            var copy_code;
            var insert_length;
            var copy_length;
            var distance_code;
            var distance;
            var context;
            var j;
            var copy_dst;
            br.readMoreInput();
            if (block_length[1] === 0) {
                $07de5cacda4a8284$var$DecodeBlockType(num_block_types[1], block_type_trees, 1, block_type, block_type_rb, block_type_rb_index, br);
                block_length[1] = $07de5cacda4a8284$var$ReadBlockLength(block_len_trees, $07de5cacda4a8284$var$HUFFMAN_MAX_TABLE_SIZE, br);
                htree_command = hgroup[1].htrees[block_type[1]];
            }
            --block_length[1];
            cmd_code = $07de5cacda4a8284$var$ReadSymbol(hgroup[1].codes, htree_command, br);
            range_idx = cmd_code >> 6;
            if (range_idx >= 2) {
                range_idx -= 2;
                distance_code = -1;
            } else distance_code = 0;
            insert_code = $cvXqP.kInsertRangeLut[range_idx] + (cmd_code >> 3 & 7);
            copy_code = $cvXqP.kCopyRangeLut[range_idx] + (cmd_code & 7);
            insert_length = $cvXqP.kInsertLengthPrefixCode[insert_code].offset + br.readBits($cvXqP.kInsertLengthPrefixCode[insert_code].nbits);
            copy_length = $cvXqP.kCopyLengthPrefixCode[copy_code].offset + br.readBits($cvXqP.kCopyLengthPrefixCode[copy_code].nbits);
            prev_byte1 = ringbuffer[pos - 1 & ringbuffer_mask];
            prev_byte2 = ringbuffer[pos - 2 & ringbuffer_mask];
            for(j = 0; j < insert_length; ++j){
                br.readMoreInput();
                if (block_length[0] === 0) {
                    $07de5cacda4a8284$var$DecodeBlockType(num_block_types[0], block_type_trees, 0, block_type, block_type_rb, block_type_rb_index, br);
                    block_length[0] = $07de5cacda4a8284$var$ReadBlockLength(block_len_trees, 0, br);
                    context_offset = block_type[0] << $07de5cacda4a8284$var$kLiteralContextBits;
                    context_map_slice = context_offset;
                    context_mode = context_modes[block_type[0]];
                    context_lookup_offset1 = $iLHtq.lookupOffsets[context_mode];
                    context_lookup_offset2 = $iLHtq.lookupOffsets[context_mode + 1];
                }
                context = $iLHtq.lookup[context_lookup_offset1 + prev_byte1] | $iLHtq.lookup[context_lookup_offset2 + prev_byte2];
                literal_htree_index = context_map[context_map_slice + context];
                --block_length[0];
                prev_byte2 = prev_byte1;
                prev_byte1 = $07de5cacda4a8284$var$ReadSymbol(hgroup[0].codes, hgroup[0].htrees[literal_htree_index], br);
                ringbuffer[pos & ringbuffer_mask] = prev_byte1;
                if ((pos & ringbuffer_mask) === ringbuffer_mask) output.write(ringbuffer, ringbuffer_size);
                ++pos;
            }
            meta_block_remaining_len -= insert_length;
            if (meta_block_remaining_len <= 0) break;
            if (distance_code < 0) {
                var context;
                br.readMoreInput();
                if (block_length[2] === 0) {
                    $07de5cacda4a8284$var$DecodeBlockType(num_block_types[2], block_type_trees, 2, block_type, block_type_rb, block_type_rb_index, br);
                    block_length[2] = $07de5cacda4a8284$var$ReadBlockLength(block_len_trees, 2 * $07de5cacda4a8284$var$HUFFMAN_MAX_TABLE_SIZE, br);
                    dist_context_offset = block_type[2] << $07de5cacda4a8284$var$kDistanceContextBits;
                    dist_context_map_slice = dist_context_offset;
                }
                --block_length[2];
                context = (copy_length > 4 ? 3 : copy_length - 2) & 0xff;
                dist_htree_index = dist_context_map[dist_context_map_slice + context];
                distance_code = $07de5cacda4a8284$var$ReadSymbol(hgroup[2].codes, hgroup[2].htrees[dist_htree_index], br);
                if (distance_code >= num_direct_distance_codes) {
                    var nbits;
                    var postfix;
                    var offset;
                    distance_code -= num_direct_distance_codes;
                    postfix = distance_code & distance_postfix_mask;
                    distance_code >>= distance_postfix_bits;
                    nbits = (distance_code >> 1) + 1;
                    offset = (2 + (distance_code & 1) << nbits) - 4;
                    distance_code = num_direct_distance_codes + (offset + br.readBits(nbits) << distance_postfix_bits) + postfix;
                }
            }
            /* Convert the distance code to the actual distance by possibly looking */ /* up past distnaces from the ringbuffer. */ distance = $07de5cacda4a8284$var$TranslateShortCodes(distance_code, dist_rb, dist_rb_idx);
            if (distance < 0) throw new Error('[BrotliDecompress] invalid distance');
            if (pos < max_backward_distance && max_distance !== max_backward_distance) max_distance = pos;
            else max_distance = max_backward_distance;
            copy_dst = pos & ringbuffer_mask;
            if (distance > max_distance) {
                if (copy_length >= $cLKb7.minDictionaryWordLength && copy_length <= $cLKb7.maxDictionaryWordLength) {
                    var offset = $cLKb7.offsetsByLength[copy_length];
                    var word_id = distance - max_distance - 1;
                    var shift = $cLKb7.sizeBitsByLength[copy_length];
                    var mask = (1 << shift) - 1;
                    var word_idx = word_id & mask;
                    var transform_idx = word_id >> shift;
                    offset += word_idx * copy_length;
                    if (transform_idx < $euO8X.kNumTransforms) {
                        var len = $euO8X.transformDictionaryWord(ringbuffer, copy_dst, offset, copy_length, transform_idx);
                        copy_dst += len;
                        pos += len;
                        meta_block_remaining_len -= len;
                        if (copy_dst >= ringbuffer_end) {
                            output.write(ringbuffer, ringbuffer_size);
                            for(var _x = 0; _x < copy_dst - ringbuffer_end; _x++)ringbuffer[_x] = ringbuffer[ringbuffer_end + _x];
                        }
                    } else throw new Error("Invalid backward reference. pos: " + pos + " distance: " + distance + " len: " + copy_length + " bytes left: " + meta_block_remaining_len);
                } else throw new Error("Invalid backward reference. pos: " + pos + " distance: " + distance + " len: " + copy_length + " bytes left: " + meta_block_remaining_len);
            } else {
                if (distance_code > 0) {
                    dist_rb[dist_rb_idx & 3] = distance;
                    ++dist_rb_idx;
                }
                if (copy_length > meta_block_remaining_len) throw new Error("Invalid backward reference. pos: " + pos + " distance: " + distance + " len: " + copy_length + " bytes left: " + meta_block_remaining_len);
                for(j = 0; j < copy_length; ++j){
                    ringbuffer[pos & ringbuffer_mask] = ringbuffer[pos - distance & ringbuffer_mask];
                    if ((pos & ringbuffer_mask) === ringbuffer_mask) output.write(ringbuffer, ringbuffer_size);
                    ++pos;
                    --meta_block_remaining_len;
                }
            }
            /* When we get here, we must have inserted at least one literal and */ /* made a copy of at least length two, therefore accessing the last 2 */ /* bytes is valid. */ prev_byte1 = ringbuffer[pos - 1 & ringbuffer_mask];
            prev_byte2 = ringbuffer[pos - 2 & ringbuffer_mask];
        }
        /* Protect pos from overflow, wrap it around at every GB of input data */ pos &= 0x3fffffff;
    }
    output.write(ringbuffer, pos & ringbuffer_mask);
}
$07de5cacda4a8284$export$59cbf0b8eef2df1e = $07de5cacda4a8284$var$BrotliDecompress;
$cLKb7.init();

});
parcelRegister("kd0XG", function(module, exports) {

$parcel$export(module.exports, "BrotliInput", () => $eb65c487a1841c92$export$a450e20310cb640a, (v) => $eb65c487a1841c92$export$a450e20310cb640a = v);
$parcel$export(module.exports, "BrotliOutput", () => $eb65c487a1841c92$export$29d67bcb1d627ed0, (v) => $eb65c487a1841c92$export$29d67bcb1d627ed0 = v);
var $eb65c487a1841c92$export$a450e20310cb640a;
var $eb65c487a1841c92$export$29d67bcb1d627ed0;
function $eb65c487a1841c92$var$BrotliInput(buffer) {
    this.buffer = buffer;
    this.pos = 0;
}
$eb65c487a1841c92$var$BrotliInput.prototype.read = function(buf, i, count) {
    if (this.pos + count > this.buffer.length) count = this.buffer.length - this.pos;
    for(var p = 0; p < count; p++)buf[i + p] = this.buffer[this.pos + p];
    this.pos += count;
    return count;
};
$eb65c487a1841c92$export$a450e20310cb640a = $eb65c487a1841c92$var$BrotliInput;
function $eb65c487a1841c92$var$BrotliOutput(buf) {
    this.buffer = buf;
    this.pos = 0;
}
$eb65c487a1841c92$var$BrotliOutput.prototype.write = function(buf, count) {
    if (this.pos + count > this.buffer.length) throw new Error('Output buffer is not large enough');
    this.buffer.set(buf.subarray(0, count), this.pos);
    this.pos += count;
    return count;
};
$eb65c487a1841c92$export$29d67bcb1d627ed0 = $eb65c487a1841c92$var$BrotliOutput;

});

parcelRegister("1FOT7", function(module, exports) {
/* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Bit reading helpers
*/ var $1381180f9d24f991$var$BROTLI_READ_SIZE = 4096;
var $1381180f9d24f991$var$BROTLI_IBUF_SIZE = 2 * $1381180f9d24f991$var$BROTLI_READ_SIZE + 32;
var $1381180f9d24f991$var$BROTLI_IBUF_MASK = 2 * $1381180f9d24f991$var$BROTLI_READ_SIZE - 1;
var $1381180f9d24f991$var$kBitMask = new Uint32Array([
    0,
    1,
    3,
    7,
    15,
    31,
    63,
    127,
    255,
    511,
    1023,
    2047,
    4095,
    8191,
    16383,
    32767,
    65535,
    131071,
    262143,
    524287,
    1048575,
    2097151,
    4194303,
    8388607,
    16777215
]);
/* Input byte buffer, consist of a ringbuffer and a "slack" region where */ /* bytes from the start of the ringbuffer are copied. */ function $1381180f9d24f991$var$BrotliBitReader(input) {
    this.buf_ = new Uint8Array($1381180f9d24f991$var$BROTLI_IBUF_SIZE);
    this.input_ = input; /* input callback */ 
    this.reset();
}
$1381180f9d24f991$var$BrotliBitReader.READ_SIZE = $1381180f9d24f991$var$BROTLI_READ_SIZE;
$1381180f9d24f991$var$BrotliBitReader.IBUF_MASK = $1381180f9d24f991$var$BROTLI_IBUF_MASK;
$1381180f9d24f991$var$BrotliBitReader.prototype.reset = function() {
    this.buf_ptr_ = 0; /* next input will write here */ 
    this.val_ = 0; /* pre-fetched bits */ 
    this.pos_ = 0; /* byte position in stream */ 
    this.bit_pos_ = 0; /* current bit-reading position in val_ */ 
    this.bit_end_pos_ = 0; /* bit-reading end position from LSB of val_ */ 
    this.eos_ = 0; /* input stream is finished */ 
    this.readMoreInput();
    for(var i = 0; i < 4; i++){
        this.val_ |= this.buf_[this.pos_] << 8 * i;
        ++this.pos_;
    }
    return this.bit_end_pos_ > 0;
};
/* Fills up the input ringbuffer by calling the input callback.

   Does nothing if there are at least 32 bytes present after current position.

   Returns 0 if either:
    - the input callback returned an error, or
    - there is no more input and the position is past the end of the stream.

   After encountering the end of the input stream, 32 additional zero bytes are
   copied to the ringbuffer, therefore it is safe to call this function after
   every 32 bytes of input is read.
*/ $1381180f9d24f991$var$BrotliBitReader.prototype.readMoreInput = function() {
    if (this.bit_end_pos_ > 256) return;
    else if (this.eos_) {
        if (this.bit_pos_ > this.bit_end_pos_) throw new Error('Unexpected end of input ' + this.bit_pos_ + ' ' + this.bit_end_pos_);
    } else {
        var dst = this.buf_ptr_;
        var bytes_read = this.input_.read(this.buf_, dst, $1381180f9d24f991$var$BROTLI_READ_SIZE);
        if (bytes_read < 0) throw new Error('Unexpected end of input');
        if (bytes_read < $1381180f9d24f991$var$BROTLI_READ_SIZE) {
            this.eos_ = 1;
            /* Store 32 bytes of zero after the stream end. */ for(var p = 0; p < 32; p++)this.buf_[dst + bytes_read + p] = 0;
        }
        if (dst === 0) {
            /* Copy the head of the ringbuffer to the slack region. */ for(var p = 0; p < 32; p++)this.buf_[($1381180f9d24f991$var$BROTLI_READ_SIZE << 1) + p] = this.buf_[p];
            this.buf_ptr_ = $1381180f9d24f991$var$BROTLI_READ_SIZE;
        } else this.buf_ptr_ = 0;
        this.bit_end_pos_ += bytes_read << 3;
    }
};
/* Guarantees that there are at least 24 bits in the buffer. */ $1381180f9d24f991$var$BrotliBitReader.prototype.fillBitWindow = function() {
    while(this.bit_pos_ >= 8){
        this.val_ >>>= 8;
        this.val_ |= this.buf_[this.pos_ & $1381180f9d24f991$var$BROTLI_IBUF_MASK] << 24;
        ++this.pos_;
        this.bit_pos_ = this.bit_pos_ - 8 >>> 0;
        this.bit_end_pos_ = this.bit_end_pos_ - 8 >>> 0;
    }
};
/* Reads the specified number of bits from Read Buffer. */ $1381180f9d24f991$var$BrotliBitReader.prototype.readBits = function(n_bits) {
    if (32 - this.bit_pos_ < n_bits) this.fillBitWindow();
    var val = this.val_ >>> this.bit_pos_ & $1381180f9d24f991$var$kBitMask[n_bits];
    this.bit_pos_ += n_bits;
    return val;
};
module.exports = $1381180f9d24f991$var$BrotliBitReader;

});

parcelRegister("cLKb7", function(module, exports) {

$parcel$export(module.exports, "init", () => $94bdb1e3cce1d9df$export$2cd8252107eb640b, (v) => $94bdb1e3cce1d9df$export$2cd8252107eb640b = v);
$parcel$export(module.exports, "dictionary", () => $94bdb1e3cce1d9df$export$d3757880ed390b62, (v) => $94bdb1e3cce1d9df$export$d3757880ed390b62 = v);
$parcel$export(module.exports, "offsetsByLength", () => $94bdb1e3cce1d9df$export$a94670ba663785a0, (v) => $94bdb1e3cce1d9df$export$a94670ba663785a0 = v);
$parcel$export(module.exports, "sizeBitsByLength", () => $94bdb1e3cce1d9df$export$149ef025c336056f, (v) => $94bdb1e3cce1d9df$export$149ef025c336056f = v);
$parcel$export(module.exports, "minDictionaryWordLength", () => $94bdb1e3cce1d9df$export$66b25e7ba93e8824, (v) => $94bdb1e3cce1d9df$export$66b25e7ba93e8824 = v);
$parcel$export(module.exports, "maxDictionaryWordLength", () => $94bdb1e3cce1d9df$export$2ce04c23045f1c32, (v) => $94bdb1e3cce1d9df$export$2ce04c23045f1c32 = v);
/* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Collection of static dictionary words.
*/ var $94bdb1e3cce1d9df$export$2cd8252107eb640b;
var $94bdb1e3cce1d9df$export$d3757880ed390b62;
var $94bdb1e3cce1d9df$export$a94670ba663785a0;
var $94bdb1e3cce1d9df$export$149ef025c336056f;
var $94bdb1e3cce1d9df$export$66b25e7ba93e8824;
var $94bdb1e3cce1d9df$export$2ce04c23045f1c32;

var $dHOZ6 = parcelRequire("dHOZ6");
$94bdb1e3cce1d9df$export$2cd8252107eb640b = function() {
    $94bdb1e3cce1d9df$export$d3757880ed390b62 = $dHOZ6.init();
};
$94bdb1e3cce1d9df$export$a94670ba663785a0 = new Uint32Array([
    0,
    0,
    0,
    0,
    0,
    4096,
    9216,
    21504,
    35840,
    44032,
    53248,
    63488,
    74752,
    87040,
    93696,
    100864,
    104704,
    106752,
    108928,
    113536,
    115968,
    118528,
    119872,
    121280,
    122016
]);
$94bdb1e3cce1d9df$export$149ef025c336056f = new Uint8Array([
    0,
    0,
    0,
    0,
    10,
    10,
    11,
    11,
    10,
    10,
    10,
    10,
    10,
    9,
    9,
    8,
    7,
    7,
    8,
    7,
    7,
    6,
    6,
    5,
    5
]);
$94bdb1e3cce1d9df$export$66b25e7ba93e8824 = 4;
$94bdb1e3cce1d9df$export$2ce04c23045f1c32 = 24;

});
parcelRegister("dHOZ6", function(module, exports) {

$parcel$export(module.exports, "init", () => $9fa6d6ff3c9a6437$export$2cd8252107eb640b, (v) => $9fa6d6ff3c9a6437$export$2cd8252107eb640b = v);
/**
 * The normal dictionary-data.js is quite large, which makes it 
 * unsuitable for browser usage. In order to make it smaller, 
 * we read dictionary.bin, which is a compressed version of
 * the dictionary, and on initial load, Brotli decompresses 
 * it's own dictionary. 😜
 */ var $9fa6d6ff3c9a6437$export$2cd8252107eb640b;

var $6ocIT = parcelRequire("6ocIT");


$9fa6d6ff3c9a6437$export$2cd8252107eb640b = function() {
    var BrotliDecompressBuffer = (parcelRequire("FSPyV")).BrotliDecompressBuffer;
    var compressed = $6ocIT.toByteArray((parcelRequire("dCFlX")));
    return BrotliDecompressBuffer(compressed);
};

});
parcelRegister("dCFlX", function(module, exports) {
module.exports = "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";

});



parcelRegister("gFLZd", function(module, exports) {

$parcel$export(module.exports, "HuffmanCode", () => $c235b2c9cc222f78$export$209a3d84f3357583, (v) => $c235b2c9cc222f78$export$209a3d84f3357583 = v);
$parcel$export(module.exports, "BrotliBuildHuffmanTable", () => $c235b2c9cc222f78$export$8a58ff2090e8dcda, (v) => $c235b2c9cc222f78$export$8a58ff2090e8dcda = v);
var $c235b2c9cc222f78$export$209a3d84f3357583;
var $c235b2c9cc222f78$export$8a58ff2090e8dcda;
function $c235b2c9cc222f78$var$HuffmanCode(bits, value) {
    this.bits = bits; /* number of bits used for this symbol */ 
    this.value = value; /* symbol value or table offset */ 
}
$c235b2c9cc222f78$export$209a3d84f3357583 = $c235b2c9cc222f78$var$HuffmanCode;
var $c235b2c9cc222f78$var$MAX_LENGTH = 15;
/* Returns reverse(reverse(key, len) + 1, len), where reverse(key, len) is the
   bit-wise reversal of the len least significant bits of key. */ function $c235b2c9cc222f78$var$GetNextKey(key, len) {
    var step = 1 << len - 1;
    while(key & step)step >>= 1;
    return (key & step - 1) + step;
}
/* Stores code in table[0], table[step], table[2*step], ..., table[end] */ /* Assumes that end is an integer multiple of step */ function $c235b2c9cc222f78$var$ReplicateValue(table, i, step, end, code) {
    do {
        end -= step;
        table[i + end] = new $c235b2c9cc222f78$var$HuffmanCode(code.bits, code.value);
    }while (end > 0);
}
/* Returns the table width of the next 2nd level table. count is the histogram
   of bit lengths for the remaining symbols, len is the code length of the next
   processed symbol */ function $c235b2c9cc222f78$var$NextTableBitSize(count, len, root_bits) {
    var left = 1 << len - root_bits;
    while(len < $c235b2c9cc222f78$var$MAX_LENGTH){
        left -= count[len];
        if (left <= 0) break;
        ++len;
        left <<= 1;
    }
    return len - root_bits;
}
$c235b2c9cc222f78$export$8a58ff2090e8dcda = function(root_table, table, root_bits, code_lengths, code_lengths_size) {
    var start_table = table;
    var code; /* current table entry */ 
    var len; /* current code length */ 
    var symbol; /* symbol index in original or sorted table */ 
    var key; /* reversed prefix code */ 
    var step; /* step size to replicate values in current table */ 
    var low; /* low bits for current root entry */ 
    var mask; /* mask for low bits */ 
    var table_bits; /* key length of current table */ 
    var table_size; /* size of current table */ 
    var total_size; /* sum of root table size and 2nd level table sizes */ 
    var sorted; /* symbols sorted by code length */ 
    var count = new Int32Array($c235b2c9cc222f78$var$MAX_LENGTH + 1); /* number of codes of each length */ 
    var offset = new Int32Array($c235b2c9cc222f78$var$MAX_LENGTH + 1); /* offsets in sorted table for each length */ 
    sorted = new Int32Array(code_lengths_size);
    /* build histogram of code lengths */ for(symbol = 0; symbol < code_lengths_size; symbol++)count[code_lengths[symbol]]++;
    /* generate offsets into sorted symbol table by code length */ offset[1] = 0;
    for(len = 1; len < $c235b2c9cc222f78$var$MAX_LENGTH; len++)offset[len + 1] = offset[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(symbol = 0; symbol < code_lengths_size; symbol++)if (code_lengths[symbol] !== 0) sorted[offset[code_lengths[symbol]]++] = symbol;
    table_bits = root_bits;
    table_size = 1 << table_bits;
    total_size = table_size;
    /* special case code with only one value */ if (offset[$c235b2c9cc222f78$var$MAX_LENGTH] === 1) {
        for(key = 0; key < total_size; ++key)root_table[table + key] = new $c235b2c9cc222f78$var$HuffmanCode(0, sorted[0] & 0xffff);
        return total_size;
    }
    /* fill in root table */ key = 0;
    symbol = 0;
    for(len = 1, step = 2; len <= root_bits; ++len, step <<= 1)for(; count[len] > 0; --count[len]){
        code = new $c235b2c9cc222f78$var$HuffmanCode(len & 0xff, sorted[symbol++] & 0xffff);
        $c235b2c9cc222f78$var$ReplicateValue(root_table, table + key, step, table_size, code);
        key = $c235b2c9cc222f78$var$GetNextKey(key, len);
    }
    /* fill in 2nd level tables and add pointers to root table */ mask = total_size - 1;
    low = -1;
    for(len = root_bits + 1, step = 2; len <= $c235b2c9cc222f78$var$MAX_LENGTH; ++len, step <<= 1)for(; count[len] > 0; --count[len]){
        if ((key & mask) !== low) {
            table += table_size;
            table_bits = $c235b2c9cc222f78$var$NextTableBitSize(count, len, root_bits);
            table_size = 1 << table_bits;
            total_size += table_size;
            low = key & mask;
            root_table[start_table + low] = new $c235b2c9cc222f78$var$HuffmanCode(table_bits + root_bits & 0xff, table - start_table - low & 0xffff);
        }
        code = new $c235b2c9cc222f78$var$HuffmanCode(len - root_bits & 0xff, sorted[symbol++] & 0xffff);
        $c235b2c9cc222f78$var$ReplicateValue(root_table, table + (key >> root_bits), step, table_size, code);
        key = $c235b2c9cc222f78$var$GetNextKey(key, len);
    }
    return total_size;
};

});

parcelRegister("iLHtq", function(module, exports) {

$parcel$export(module.exports, "lookup", () => $da9e56ba9ea9268e$export$dfc7155ac0343b8, (v) => $da9e56ba9ea9268e$export$dfc7155ac0343b8 = v);
$parcel$export(module.exports, "lookupOffsets", () => $da9e56ba9ea9268e$export$cc8d42455ae4ca5e, (v) => $da9e56ba9ea9268e$export$cc8d42455ae4ca5e = v);
/* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Lookup table to map the previous two bytes to a context id.

   There are four different context modeling modes defined here:
     CONTEXT_LSB6: context id is the least significant 6 bits of the last byte,
     CONTEXT_MSB6: context id is the most significant 6 bits of the last byte,
     CONTEXT_UTF8: second-order context model tuned for UTF8-encoded text,
     CONTEXT_SIGNED: second-order context model tuned for signed integers.

   The context id for the UTF8 context model is calculated as follows. If p1
   and p2 are the previous two bytes, we calcualte the context as

     context = kContextLookup[p1] | kContextLookup[p2 + 256].

   If the previous two bytes are ASCII characters (i.e. < 128), this will be
   equivalent to

     context = 4 * context1(p1) + context2(p2),

   where context1 is based on the previous byte in the following way:

     0  : non-ASCII control
     1  : \t, \n, \r
     2  : space
     3  : other punctuation
     4  : " '
     5  : %
     6  : ( < [ {
     7  : ) > ] }
     8  : , ; :
     9  : .
     10 : =
     11 : number
     12 : upper-case vowel
     13 : upper-case consonant
     14 : lower-case vowel
     15 : lower-case consonant

   and context2 is based on the second last byte:

     0 : control, space
     1 : punctuation
     2 : upper-case letter, number
     3 : lower-case letter

   If the last byte is ASCII, and the second last byte is not (in a valid UTF8
   stream it will be a continuation byte, value between 128 and 191), the
   context is the same as if the second last byte was an ASCII control or space.

   If the last byte is a UTF8 lead byte (value >= 192), then the next byte will
   be a continuation byte and the context id is 2 or 3 depending on the LSB of
   the last byte and to a lesser extent on the second last byte if it is ASCII.

   If the last byte is a UTF8 continuation byte, the second last byte can be:
     - continuation byte: the next byte is probably ASCII or lead byte (assuming
       4-byte UTF8 characters are rare) and the context id is 0 or 1.
     - lead byte (192 - 207): next byte is ASCII or lead byte, context is 0 or 1
     - lead byte (208 - 255): next byte is continuation byte, context is 2 or 3

   The possible value combinations of the previous two bytes, the range of
   context ids and the type of the next byte is summarized in the table below:

   |--------\-----------------------------------------------------------------|
   |         \                         Last byte                              |
   | Second   \---------------------------------------------------------------|
   | last byte \    ASCII            |   cont. byte        |   lead byte      |
   |            \   (0-127)          |   (128-191)         |   (192-)         |
   |=============|===================|=====================|==================|
   |  ASCII      | next: ASCII/lead  |  not valid          |  next: cont.     |
   |  (0-127)    | context: 4 - 63   |                     |  context: 2 - 3  |
   |-------------|-------------------|---------------------|------------------|
   |  cont. byte | next: ASCII/lead  |  next: ASCII/lead   |  next: cont.     |
   |  (128-191)  | context: 4 - 63   |  context: 0 - 1     |  context: 2 - 3  |
   |-------------|-------------------|---------------------|------------------|
   |  lead byte  | not valid         |  next: ASCII/lead   |  not valid       |
   |  (192-207)  |                   |  context: 0 - 1     |                  |
   |-------------|-------------------|---------------------|------------------|
   |  lead byte  | not valid         |  next: cont.        |  not valid       |
   |  (208-)     |                   |  context: 2 - 3     |                  |
   |-------------|-------------------|---------------------|------------------|

   The context id for the signed context mode is calculated as:

     context = (kContextLookup[512 + p1] << 3) | kContextLookup[512 + p2].

   For any context modeling modes, the context ids can be calculated by |-ing
   together two lookups from one table using context model dependent offsets:

     context = kContextLookup[offset1 + p1] | kContextLookup[offset2 + p2].

   where offset1 and offset2 are dependent on the context mode.
*/ /* Common context lookup table for all context modes. */ var $da9e56ba9ea9268e$export$dfc7155ac0343b8;
var $da9e56ba9ea9268e$export$cc8d42455ae4ca5e;
var $da9e56ba9ea9268e$var$CONTEXT_LSB6 = 0;
var $da9e56ba9ea9268e$var$CONTEXT_MSB6 = 1;
var $da9e56ba9ea9268e$var$CONTEXT_UTF8 = 2;
var $da9e56ba9ea9268e$var$CONTEXT_SIGNED = 3;
$da9e56ba9ea9268e$export$dfc7155ac0343b8 = new Uint8Array([
    /* CONTEXT_UTF8, last byte. */ /* ASCII range. */ 0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    4,
    4,
    0,
    0,
    4,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    8,
    12,
    16,
    12,
    12,
    20,
    12,
    16,
    24,
    28,
    12,
    12,
    32,
    12,
    36,
    12,
    44,
    44,
    44,
    44,
    44,
    44,
    44,
    44,
    44,
    44,
    32,
    32,
    24,
    40,
    28,
    12,
    12,
    48,
    52,
    52,
    52,
    48,
    52,
    52,
    52,
    48,
    52,
    52,
    52,
    52,
    52,
    48,
    52,
    52,
    52,
    52,
    52,
    48,
    52,
    52,
    52,
    52,
    52,
    24,
    12,
    28,
    12,
    12,
    12,
    56,
    60,
    60,
    60,
    56,
    60,
    60,
    60,
    56,
    60,
    60,
    60,
    60,
    60,
    56,
    60,
    60,
    60,
    60,
    60,
    56,
    60,
    60,
    60,
    60,
    60,
    24,
    12,
    28,
    12,
    0,
    /* UTF8 continuation byte range. */ 0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    /* UTF8 lead byte range. */ 2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    /* CONTEXT_UTF8 second last byte. */ /* ASCII range. */ 0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    1,
    1,
    1,
    0,
    /* UTF8 continuation byte range. */ 0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    /* UTF8 lead byte range. */ 0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    /* CONTEXT_SIGNED, second last byte. */ 0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    7,
    /* CONTEXT_SIGNED, last byte, same as the above values shifted by 3 bits. */ 0,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    56,
    /* CONTEXT_LSB6, last byte. */ 0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60,
    61,
    62,
    63,
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60,
    61,
    62,
    63,
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60,
    61,
    62,
    63,
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60,
    61,
    62,
    63,
    /* CONTEXT_MSB6, last byte. */ 0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    6,
    6,
    6,
    6,
    7,
    7,
    7,
    7,
    8,
    8,
    8,
    8,
    9,
    9,
    9,
    9,
    10,
    10,
    10,
    10,
    11,
    11,
    11,
    11,
    12,
    12,
    12,
    12,
    13,
    13,
    13,
    13,
    14,
    14,
    14,
    14,
    15,
    15,
    15,
    15,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    22,
    22,
    22,
    22,
    23,
    23,
    23,
    23,
    24,
    24,
    24,
    24,
    25,
    25,
    25,
    25,
    26,
    26,
    26,
    26,
    27,
    27,
    27,
    27,
    28,
    28,
    28,
    28,
    29,
    29,
    29,
    29,
    30,
    30,
    30,
    30,
    31,
    31,
    31,
    31,
    32,
    32,
    32,
    32,
    33,
    33,
    33,
    33,
    34,
    34,
    34,
    34,
    35,
    35,
    35,
    35,
    36,
    36,
    36,
    36,
    37,
    37,
    37,
    37,
    38,
    38,
    38,
    38,
    39,
    39,
    39,
    39,
    40,
    40,
    40,
    40,
    41,
    41,
    41,
    41,
    42,
    42,
    42,
    42,
    43,
    43,
    43,
    43,
    44,
    44,
    44,
    44,
    45,
    45,
    45,
    45,
    46,
    46,
    46,
    46,
    47,
    47,
    47,
    47,
    48,
    48,
    48,
    48,
    49,
    49,
    49,
    49,
    50,
    50,
    50,
    50,
    51,
    51,
    51,
    51,
    52,
    52,
    52,
    52,
    53,
    53,
    53,
    53,
    54,
    54,
    54,
    54,
    55,
    55,
    55,
    55,
    56,
    56,
    56,
    56,
    57,
    57,
    57,
    57,
    58,
    58,
    58,
    58,
    59,
    59,
    59,
    59,
    60,
    60,
    60,
    60,
    61,
    61,
    61,
    61,
    62,
    62,
    62,
    62,
    63,
    63,
    63,
    63,
    /* CONTEXT_{M,L}SB6, second last byte, */ 0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0
]);
$da9e56ba9ea9268e$export$cc8d42455ae4ca5e = new Uint16Array([
    /* CONTEXT_LSB6 */ 1024,
    1536,
    /* CONTEXT_MSB6 */ 1280,
    1536,
    /* CONTEXT_UTF8 */ 0,
    256,
    /* CONTEXT_SIGNED */ 768,
    512
]);

});

parcelRegister("cvXqP", function(module, exports) {

$parcel$export(module.exports, "kBlockLengthPrefixCode", () => $91c67b311ffc9124$export$6e6a061a64eda771, (v) => $91c67b311ffc9124$export$6e6a061a64eda771 = v);
$parcel$export(module.exports, "kInsertLengthPrefixCode", () => $91c67b311ffc9124$export$62ffb848600e90dd, (v) => $91c67b311ffc9124$export$62ffb848600e90dd = v);
$parcel$export(module.exports, "kCopyLengthPrefixCode", () => $91c67b311ffc9124$export$cc7c44d8afc93b69, (v) => $91c67b311ffc9124$export$cc7c44d8afc93b69 = v);
$parcel$export(module.exports, "kInsertRangeLut", () => $91c67b311ffc9124$export$91c779240ecfdaca, (v) => $91c67b311ffc9124$export$91c779240ecfdaca = v);
$parcel$export(module.exports, "kCopyRangeLut", () => $91c67b311ffc9124$export$c243b934bf41e980, (v) => $91c67b311ffc9124$export$c243b934bf41e980 = v);
/* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Lookup tables to map prefix codes to value ranges. This is used during
   decoding of the block lengths, literal insertion lengths and copy lengths.
*/ /* Represents the range of values belonging to a prefix code: */ /* [offset, offset + 2^nbits) */ var $91c67b311ffc9124$export$6e6a061a64eda771;
var $91c67b311ffc9124$export$62ffb848600e90dd;
var $91c67b311ffc9124$export$cc7c44d8afc93b69;
var $91c67b311ffc9124$export$91c779240ecfdaca;
var $91c67b311ffc9124$export$c243b934bf41e980;
function $91c67b311ffc9124$var$PrefixCodeRange(offset, nbits) {
    this.offset = offset;
    this.nbits = nbits;
}
$91c67b311ffc9124$export$6e6a061a64eda771 = [
    new $91c67b311ffc9124$var$PrefixCodeRange(1, 2),
    new $91c67b311ffc9124$var$PrefixCodeRange(5, 2),
    new $91c67b311ffc9124$var$PrefixCodeRange(9, 2),
    new $91c67b311ffc9124$var$PrefixCodeRange(13, 2),
    new $91c67b311ffc9124$var$PrefixCodeRange(17, 3),
    new $91c67b311ffc9124$var$PrefixCodeRange(25, 3),
    new $91c67b311ffc9124$var$PrefixCodeRange(33, 3),
    new $91c67b311ffc9124$var$PrefixCodeRange(41, 3),
    new $91c67b311ffc9124$var$PrefixCodeRange(49, 4),
    new $91c67b311ffc9124$var$PrefixCodeRange(65, 4),
    new $91c67b311ffc9124$var$PrefixCodeRange(81, 4),
    new $91c67b311ffc9124$var$PrefixCodeRange(97, 4),
    new $91c67b311ffc9124$var$PrefixCodeRange(113, 5),
    new $91c67b311ffc9124$var$PrefixCodeRange(145, 5),
    new $91c67b311ffc9124$var$PrefixCodeRange(177, 5),
    new $91c67b311ffc9124$var$PrefixCodeRange(209, 5),
    new $91c67b311ffc9124$var$PrefixCodeRange(241, 6),
    new $91c67b311ffc9124$var$PrefixCodeRange(305, 6),
    new $91c67b311ffc9124$var$PrefixCodeRange(369, 7),
    new $91c67b311ffc9124$var$PrefixCodeRange(497, 8),
    new $91c67b311ffc9124$var$PrefixCodeRange(753, 9),
    new $91c67b311ffc9124$var$PrefixCodeRange(1265, 10),
    new $91c67b311ffc9124$var$PrefixCodeRange(2289, 11),
    new $91c67b311ffc9124$var$PrefixCodeRange(4337, 12),
    new $91c67b311ffc9124$var$PrefixCodeRange(8433, 13),
    new $91c67b311ffc9124$var$PrefixCodeRange(16625, 24)
];
$91c67b311ffc9124$export$62ffb848600e90dd = [
    new $91c67b311ffc9124$var$PrefixCodeRange(0, 0),
    new $91c67b311ffc9124$var$PrefixCodeRange(1, 0),
    new $91c67b311ffc9124$var$PrefixCodeRange(2, 0),
    new $91c67b311ffc9124$var$PrefixCodeRange(3, 0),
    new $91c67b311ffc9124$var$PrefixCodeRange(4, 0),
    new $91c67b311ffc9124$var$PrefixCodeRange(5, 0),
    new $91c67b311ffc9124$var$PrefixCodeRange(6, 1),
    new $91c67b311ffc9124$var$PrefixCodeRange(8, 1),
    new $91c67b311ffc9124$var$PrefixCodeRange(10, 2),
    new $91c67b311ffc9124$var$PrefixCodeRange(14, 2),
    new $91c67b311ffc9124$var$PrefixCodeRange(18, 3),
    new $91c67b311ffc9124$var$PrefixCodeRange(26, 3),
    new $91c67b311ffc9124$var$PrefixCodeRange(34, 4),
    new $91c67b311ffc9124$var$PrefixCodeRange(50, 4),
    new $91c67b311ffc9124$var$PrefixCodeRange(66, 5),
    new $91c67b311ffc9124$var$PrefixCodeRange(98, 5),
    new $91c67b311ffc9124$var$PrefixCodeRange(130, 6),
    new $91c67b311ffc9124$var$PrefixCodeRange(194, 7),
    new $91c67b311ffc9124$var$PrefixCodeRange(322, 8),
    new $91c67b311ffc9124$var$PrefixCodeRange(578, 9),
    new $91c67b311ffc9124$var$PrefixCodeRange(1090, 10),
    new $91c67b311ffc9124$var$PrefixCodeRange(2114, 12),
    new $91c67b311ffc9124$var$PrefixCodeRange(6210, 14),
    new $91c67b311ffc9124$var$PrefixCodeRange(22594, 24)
];
$91c67b311ffc9124$export$cc7c44d8afc93b69 = [
    new $91c67b311ffc9124$var$PrefixCodeRange(2, 0),
    new $91c67b311ffc9124$var$PrefixCodeRange(3, 0),
    new $91c67b311ffc9124$var$PrefixCodeRange(4, 0),
    new $91c67b311ffc9124$var$PrefixCodeRange(5, 0),
    new $91c67b311ffc9124$var$PrefixCodeRange(6, 0),
    new $91c67b311ffc9124$var$PrefixCodeRange(7, 0),
    new $91c67b311ffc9124$var$PrefixCodeRange(8, 0),
    new $91c67b311ffc9124$var$PrefixCodeRange(9, 0),
    new $91c67b311ffc9124$var$PrefixCodeRange(10, 1),
    new $91c67b311ffc9124$var$PrefixCodeRange(12, 1),
    new $91c67b311ffc9124$var$PrefixCodeRange(14, 2),
    new $91c67b311ffc9124$var$PrefixCodeRange(18, 2),
    new $91c67b311ffc9124$var$PrefixCodeRange(22, 3),
    new $91c67b311ffc9124$var$PrefixCodeRange(30, 3),
    new $91c67b311ffc9124$var$PrefixCodeRange(38, 4),
    new $91c67b311ffc9124$var$PrefixCodeRange(54, 4),
    new $91c67b311ffc9124$var$PrefixCodeRange(70, 5),
    new $91c67b311ffc9124$var$PrefixCodeRange(102, 5),
    new $91c67b311ffc9124$var$PrefixCodeRange(134, 6),
    new $91c67b311ffc9124$var$PrefixCodeRange(198, 7),
    new $91c67b311ffc9124$var$PrefixCodeRange(326, 8),
    new $91c67b311ffc9124$var$PrefixCodeRange(582, 9),
    new $91c67b311ffc9124$var$PrefixCodeRange(1094, 10),
    new $91c67b311ffc9124$var$PrefixCodeRange(2118, 24)
];
$91c67b311ffc9124$export$91c779240ecfdaca = [
    0,
    0,
    8,
    8,
    0,
    16,
    8,
    16,
    16
];
$91c67b311ffc9124$export$c243b934bf41e980 = [
    0,
    8,
    0,
    8,
    16,
    0,
    16,
    8,
    16
];

});

parcelRegister("euO8X", function(module, exports) {

$parcel$export(module.exports, "kNumTransforms", () => $a8dac37fdef7789e$export$5d2d653c67838a2, (v) => $a8dac37fdef7789e$export$5d2d653c67838a2 = v);
$parcel$export(module.exports, "transformDictionaryWord", () => $a8dac37fdef7789e$export$8cfa5a6f89d017bb, (v) => $a8dac37fdef7789e$export$8cfa5a6f89d017bb = v);
/* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Transformations on dictionary words.
*/ var $a8dac37fdef7789e$export$4898d75d9d9d305c;
var $a8dac37fdef7789e$export$5d2d653c67838a2;
var $a8dac37fdef7789e$export$8cfa5a6f89d017bb;

var $cLKb7 = parcelRequire("cLKb7");
var $a8dac37fdef7789e$var$kIdentity = 0;
var $a8dac37fdef7789e$var$kOmitLast1 = 1;
var $a8dac37fdef7789e$var$kOmitLast2 = 2;
var $a8dac37fdef7789e$var$kOmitLast3 = 3;
var $a8dac37fdef7789e$var$kOmitLast4 = 4;
var $a8dac37fdef7789e$var$kOmitLast5 = 5;
var $a8dac37fdef7789e$var$kOmitLast6 = 6;
var $a8dac37fdef7789e$var$kOmitLast7 = 7;
var $a8dac37fdef7789e$var$kOmitLast8 = 8;
var $a8dac37fdef7789e$var$kOmitLast9 = 9;
var $a8dac37fdef7789e$var$kUppercaseFirst = 10;
var $a8dac37fdef7789e$var$kUppercaseAll = 11;
var $a8dac37fdef7789e$var$kOmitFirst1 = 12;
var $a8dac37fdef7789e$var$kOmitFirst2 = 13;
var $a8dac37fdef7789e$var$kOmitFirst3 = 14;
var $a8dac37fdef7789e$var$kOmitFirst4 = 15;
var $a8dac37fdef7789e$var$kOmitFirst5 = 16;
var $a8dac37fdef7789e$var$kOmitFirst6 = 17;
var $a8dac37fdef7789e$var$kOmitFirst7 = 18;
var $a8dac37fdef7789e$var$kOmitFirst8 = 19;
var $a8dac37fdef7789e$var$kOmitFirst9 = 20;
function $a8dac37fdef7789e$var$Transform(prefix, transform, suffix) {
    this.prefix = new Uint8Array(prefix.length);
    this.transform = transform;
    this.suffix = new Uint8Array(suffix.length);
    for(var i = 0; i < prefix.length; i++)this.prefix[i] = prefix.charCodeAt(i);
    for(var i = 0; i < suffix.length; i++)this.suffix[i] = suffix.charCodeAt(i);
}
var $a8dac37fdef7789e$var$kTransforms = [
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kIdentity, ""),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kIdentity, " "),
    new $a8dac37fdef7789e$var$Transform(" ", $a8dac37fdef7789e$var$kIdentity, " "),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kOmitFirst1, ""),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kUppercaseFirst, " "),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kIdentity, " the "),
    new $a8dac37fdef7789e$var$Transform(" ", $a8dac37fdef7789e$var$kIdentity, ""),
    new $a8dac37fdef7789e$var$Transform("s ", $a8dac37fdef7789e$var$kIdentity, " "),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kIdentity, " of "),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kUppercaseFirst, ""),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kIdentity, " and "),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kOmitFirst2, ""),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kOmitLast1, ""),
    new $a8dac37fdef7789e$var$Transform(", ", $a8dac37fdef7789e$var$kIdentity, " "),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kIdentity, ", "),
    new $a8dac37fdef7789e$var$Transform(" ", $a8dac37fdef7789e$var$kUppercaseFirst, " "),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kIdentity, " in "),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kIdentity, " to "),
    new $a8dac37fdef7789e$var$Transform("e ", $a8dac37fdef7789e$var$kIdentity, " "),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kIdentity, "\""),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kIdentity, "."),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kIdentity, "\">"),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kIdentity, "\n"),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kOmitLast3, ""),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kIdentity, "]"),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kIdentity, " for "),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kOmitFirst3, ""),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kOmitLast2, ""),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kIdentity, " a "),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kIdentity, " that "),
    new $a8dac37fdef7789e$var$Transform(" ", $a8dac37fdef7789e$var$kUppercaseFirst, ""),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kIdentity, ". "),
    new $a8dac37fdef7789e$var$Transform(".", $a8dac37fdef7789e$var$kIdentity, ""),
    new $a8dac37fdef7789e$var$Transform(" ", $a8dac37fdef7789e$var$kIdentity, ", "),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kOmitFirst4, ""),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kIdentity, " with "),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kIdentity, "'"),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kIdentity, " from "),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kIdentity, " by "),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kOmitFirst5, ""),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kOmitFirst6, ""),
    new $a8dac37fdef7789e$var$Transform(" the ", $a8dac37fdef7789e$var$kIdentity, ""),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kOmitLast4, ""),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kIdentity, ". The "),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kUppercaseAll, ""),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kIdentity, " on "),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kIdentity, " as "),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kIdentity, " is "),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kOmitLast7, ""),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kOmitLast1, "ing "),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kIdentity, "\n\t"),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kIdentity, ":"),
    new $a8dac37fdef7789e$var$Transform(" ", $a8dac37fdef7789e$var$kIdentity, ". "),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kIdentity, "ed "),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kOmitFirst9, ""),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kOmitFirst7, ""),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kOmitLast6, ""),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kIdentity, "("),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kUppercaseFirst, ", "),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kOmitLast8, ""),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kIdentity, " at "),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kIdentity, "ly "),
    new $a8dac37fdef7789e$var$Transform(" the ", $a8dac37fdef7789e$var$kIdentity, " of "),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kOmitLast5, ""),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kOmitLast9, ""),
    new $a8dac37fdef7789e$var$Transform(" ", $a8dac37fdef7789e$var$kUppercaseFirst, ", "),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kUppercaseFirst, "\""),
    new $a8dac37fdef7789e$var$Transform(".", $a8dac37fdef7789e$var$kIdentity, "("),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kUppercaseAll, " "),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kUppercaseFirst, "\">"),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kIdentity, "=\""),
    new $a8dac37fdef7789e$var$Transform(" ", $a8dac37fdef7789e$var$kIdentity, "."),
    new $a8dac37fdef7789e$var$Transform(".com/", $a8dac37fdef7789e$var$kIdentity, ""),
    new $a8dac37fdef7789e$var$Transform(" the ", $a8dac37fdef7789e$var$kIdentity, " of the "),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kUppercaseFirst, "'"),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kIdentity, ". This "),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kIdentity, ","),
    new $a8dac37fdef7789e$var$Transform(".", $a8dac37fdef7789e$var$kIdentity, " "),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kUppercaseFirst, "("),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kUppercaseFirst, "."),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kIdentity, " not "),
    new $a8dac37fdef7789e$var$Transform(" ", $a8dac37fdef7789e$var$kIdentity, "=\""),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kIdentity, "er "),
    new $a8dac37fdef7789e$var$Transform(" ", $a8dac37fdef7789e$var$kUppercaseAll, " "),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kIdentity, "al "),
    new $a8dac37fdef7789e$var$Transform(" ", $a8dac37fdef7789e$var$kUppercaseAll, ""),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kIdentity, "='"),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kUppercaseAll, "\""),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kUppercaseFirst, ". "),
    new $a8dac37fdef7789e$var$Transform(" ", $a8dac37fdef7789e$var$kIdentity, "("),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kIdentity, "ful "),
    new $a8dac37fdef7789e$var$Transform(" ", $a8dac37fdef7789e$var$kUppercaseFirst, ". "),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kIdentity, "ive "),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kIdentity, "less "),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kUppercaseAll, "'"),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kIdentity, "est "),
    new $a8dac37fdef7789e$var$Transform(" ", $a8dac37fdef7789e$var$kUppercaseFirst, "."),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kUppercaseAll, "\">"),
    new $a8dac37fdef7789e$var$Transform(" ", $a8dac37fdef7789e$var$kIdentity, "='"),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kUppercaseFirst, ","),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kIdentity, "ize "),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kUppercaseAll, "."),
    new $a8dac37fdef7789e$var$Transform("\xc2\xa0", $a8dac37fdef7789e$var$kIdentity, ""),
    new $a8dac37fdef7789e$var$Transform(" ", $a8dac37fdef7789e$var$kIdentity, ","),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kUppercaseFirst, "=\""),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kUppercaseAll, "=\""),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kIdentity, "ous "),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kUppercaseAll, ", "),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kUppercaseFirst, "='"),
    new $a8dac37fdef7789e$var$Transform(" ", $a8dac37fdef7789e$var$kUppercaseFirst, ","),
    new $a8dac37fdef7789e$var$Transform(" ", $a8dac37fdef7789e$var$kUppercaseAll, "=\""),
    new $a8dac37fdef7789e$var$Transform(" ", $a8dac37fdef7789e$var$kUppercaseAll, ", "),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kUppercaseAll, ","),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kUppercaseAll, "("),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kUppercaseAll, ". "),
    new $a8dac37fdef7789e$var$Transform(" ", $a8dac37fdef7789e$var$kUppercaseAll, "."),
    new $a8dac37fdef7789e$var$Transform("", $a8dac37fdef7789e$var$kUppercaseAll, "='"),
    new $a8dac37fdef7789e$var$Transform(" ", $a8dac37fdef7789e$var$kUppercaseAll, ". "),
    new $a8dac37fdef7789e$var$Transform(" ", $a8dac37fdef7789e$var$kUppercaseFirst, "=\""),
    new $a8dac37fdef7789e$var$Transform(" ", $a8dac37fdef7789e$var$kUppercaseAll, "='"),
    new $a8dac37fdef7789e$var$Transform(" ", $a8dac37fdef7789e$var$kUppercaseFirst, "='")
];
$a8dac37fdef7789e$export$4898d75d9d9d305c = $a8dac37fdef7789e$var$kTransforms;
$a8dac37fdef7789e$export$5d2d653c67838a2 = $a8dac37fdef7789e$var$kTransforms.length;
function $a8dac37fdef7789e$var$ToUpperCase(p, i) {
    if (p[i] < 0xc0) {
        if (p[i] >= 97 && p[i] <= 122) p[i] ^= 32;
        return 1;
    }
    /* An overly simplified uppercasing model for utf-8. */ if (p[i] < 0xe0) {
        p[i + 1] ^= 32;
        return 2;
    }
    /* An arbitrary transform for three byte characters. */ p[i + 2] ^= 5;
    return 3;
}
$a8dac37fdef7789e$export$8cfa5a6f89d017bb = function(dst, idx, word, len, transform) {
    var prefix = $a8dac37fdef7789e$var$kTransforms[transform].prefix;
    var suffix = $a8dac37fdef7789e$var$kTransforms[transform].suffix;
    var t = $a8dac37fdef7789e$var$kTransforms[transform].transform;
    var skip = t < $a8dac37fdef7789e$var$kOmitFirst1 ? 0 : t - ($a8dac37fdef7789e$var$kOmitFirst1 - 1);
    var i = 0;
    var start_idx = idx;
    var uppercase;
    if (skip > len) skip = len;
    var prefix_pos = 0;
    while(prefix_pos < prefix.length)dst[idx++] = prefix[prefix_pos++];
    word += skip;
    len -= skip;
    if (t <= $a8dac37fdef7789e$var$kOmitLast9) len -= t;
    for(i = 0; i < len; i++)dst[idx++] = $cLKb7.dictionary[word + i];
    uppercase = idx - len;
    if (t === $a8dac37fdef7789e$var$kUppercaseFirst) $a8dac37fdef7789e$var$ToUpperCase(dst, uppercase);
    else if (t === $a8dac37fdef7789e$var$kUppercaseAll) while(len > 0){
        var step = $a8dac37fdef7789e$var$ToUpperCase(dst, uppercase);
        uppercase += step;
        len -= step;
    }
    var suffix_pos = 0;
    while(suffix_pos < suffix.length)dst[idx++] = suffix[suffix_pos++];
    return idx - start_idx;
};

});


var $90cae257cc958273$exports = {};
'use strict';

$90cae257cc958273$exports = (parcelRequire("8S27K"));


const $f5efe749b20fa0f3$var$isString = (obj)=>typeof obj === 'string';
const $f5efe749b20fa0f3$var$defer = ()=>{
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
};
const $f5efe749b20fa0f3$var$makeString = (object)=>{
    if (object == null) return '';
    return String(object);
};
const $f5efe749b20fa0f3$var$copy = (a, s, t)=>{
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
};
const $f5efe749b20fa0f3$var$lastOfPathSeparatorRegExp = /###/g;
const $f5efe749b20fa0f3$var$cleanKey = (key)=>key && key.includes('###') ? key.replace($f5efe749b20fa0f3$var$lastOfPathSeparatorRegExp, '.') : key;
const $f5efe749b20fa0f3$var$canNotTraverseDeeper = (object)=>!object || $f5efe749b20fa0f3$var$isString(object);
const $f5efe749b20fa0f3$var$getLastOfPath = (object, path, Empty)=>{
    const stack = !$f5efe749b20fa0f3$var$isString(path) ? path : path.split('.');
    let stackIndex = 0;
    while(stackIndex < stack.length - 1){
        if ($f5efe749b20fa0f3$var$canNotTraverseDeeper(object)) return {};
        const key = $f5efe749b20fa0f3$var$cleanKey(stack[stackIndex]);
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
        ++stackIndex;
    }
    if ($f5efe749b20fa0f3$var$canNotTraverseDeeper(object)) return {};
    return {
        obj: object,
        k: $f5efe749b20fa0f3$var$cleanKey(stack[stackIndex])
    };
};
const $f5efe749b20fa0f3$var$setPath = (object, path, newValue)=>{
    const { obj: obj, k: k } = $f5efe749b20fa0f3$var$getLastOfPath(object, path, Object);
    if (obj !== undefined || path.length === 1) {
        obj[k] = newValue;
        return;
    }
    let e = path[path.length - 1];
    let p = path.slice(0, path.length - 1);
    let last = $f5efe749b20fa0f3$var$getLastOfPath(object, p, Object);
    while(last.obj === undefined && p.length){
        e = `${p[p.length - 1]}.${e}`;
        p = p.slice(0, p.length - 1);
        last = $f5efe749b20fa0f3$var$getLastOfPath(object, p, Object);
        if (last?.obj && typeof last.obj[`${last.k}.${e}`] !== 'undefined') last.obj = undefined;
    }
    last.obj[`${last.k}.${e}`] = newValue;
};
const $f5efe749b20fa0f3$var$pushPath = (object, path, newValue, concat)=>{
    const { obj: obj, k: k } = $f5efe749b20fa0f3$var$getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    obj[k].push(newValue);
};
const $f5efe749b20fa0f3$var$getPath = (object, path)=>{
    const { obj: obj, k: k } = $f5efe749b20fa0f3$var$getLastOfPath(object, path);
    if (!obj) return undefined;
    if (!Object.prototype.hasOwnProperty.call(obj, k)) return undefined;
    return obj[k];
};
const $f5efe749b20fa0f3$var$getPathWithDefaults = (data, defaultData, key)=>{
    const value = $f5efe749b20fa0f3$var$getPath(data, key);
    if (value !== undefined) return value;
    return $f5efe749b20fa0f3$var$getPath(defaultData, key);
};
const $f5efe749b20fa0f3$var$deepExtend = (target, source, overwrite)=>{
    for(const prop in source)if (prop !== '__proto__' && prop !== 'constructor') {
        if (Object.prototype.hasOwnProperty.call(target, prop)) {
            if ($f5efe749b20fa0f3$var$isString(target[prop]) || target[prop] instanceof String || $f5efe749b20fa0f3$var$isString(source[prop]) || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $f5efe749b20fa0f3$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
};
const $f5efe749b20fa0f3$var$regexEscape = (str)=>str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
const $f5efe749b20fa0f3$var$_entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
};
const $f5efe749b20fa0f3$var$escape = (data)=>{
    if ($f5efe749b20fa0f3$var$isString(data)) return data.replace(/[&<>"'\/]/g, (s)=>$f5efe749b20fa0f3$var$_entityMap[s]);
    return data;
};
class $f5efe749b20fa0f3$var$RegExpCache {
    constructor(capacity){
        this.capacity = capacity;
        this.regExpMap = new Map();
        this.regExpQueue = [];
    }
    getRegExp(pattern) {
        const regExpFromCache = this.regExpMap.get(pattern);
        if (regExpFromCache !== undefined) return regExpFromCache;
        const regExpNew = new RegExp(pattern);
        if (this.regExpQueue.length === this.capacity) this.regExpMap.delete(this.regExpQueue.shift());
        this.regExpMap.set(pattern, regExpNew);
        this.regExpQueue.push(pattern);
        return regExpNew;
    }
}
const $f5efe749b20fa0f3$var$chars = [
    ' ',
    ',',
    '?',
    '!',
    ';'
];
const $f5efe749b20fa0f3$var$looksLikeObjectPathRegExpCache = new $f5efe749b20fa0f3$var$RegExpCache(20);
const $f5efe749b20fa0f3$var$looksLikeObjectPath = (key, nsSeparator, keySeparator)=>{
    nsSeparator = nsSeparator || '';
    keySeparator = keySeparator || '';
    const possibleChars = $f5efe749b20fa0f3$var$chars.filter((c)=>!nsSeparator.includes(c) && !keySeparator.includes(c));
    if (possibleChars.length === 0) return true;
    const r = $f5efe749b20fa0f3$var$looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map((c)=>c === '?' ? '\\?' : c).join('|')})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
};
const $f5efe749b20fa0f3$var$deepFind = (obj, path, keySeparator = '.')=>{
    if (!obj) return undefined;
    if (obj[path]) {
        if (!Object.prototype.hasOwnProperty.call(obj, path)) return undefined;
        return obj[path];
    }
    const tokens = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < tokens.length;){
        if (!current || typeof current !== 'object') return undefined;
        let next;
        let nextPath = '';
        for(let j = i; j < tokens.length; ++j){
            if (j !== i) nextPath += keySeparator;
            nextPath += tokens[j];
            next = current[nextPath];
            if (next !== undefined) {
                if ([
                    'string',
                    'number',
                    'boolean'
                ].includes(typeof next) && j < tokens.length - 1) continue;
                i += j - i + 1;
                break;
            }
        }
        current = next;
    }
    return current;
};
const $f5efe749b20fa0f3$var$getCleanedCode = (code)=>code?.replace(/_/g, '-');
const $f5efe749b20fa0f3$var$consoleLogger = {
    type: 'logger',
    log (args) {
        this.output('log', args);
    },
    warn (args) {
        this.output('warn', args);
    },
    error (args) {
        this.output('error', args);
    },
    output (type, args) {
        console?.[type]?.apply?.(console, args);
    }
};
class $f5efe749b20fa0f3$var$Logger {
    constructor(concreteLogger, options = {}){
        this.init(concreteLogger, options);
    }
    init(concreteLogger, options = {}) {
        this.prefix = options.prefix || 'i18next:';
        this.logger = concreteLogger || $f5efe749b20fa0f3$var$consoleLogger;
        this.options = options;
        this.debug = options.debug;
    }
    log(...args) {
        return this.forward(args, 'log', '', true);
    }
    warn(...args) {
        return this.forward(args, 'warn', '', true);
    }
    error(...args) {
        return this.forward(args, 'error', '');
    }
    deprecate(...args) {
        return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        args = args.map((a)=>$f5efe749b20fa0f3$var$isString(a) ? a.replace(/[\r\n\x00-\x1F\x7F]/g, ' ') : a);
        if ($f5efe749b20fa0f3$var$isString(args[0])) args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new $f5efe749b20fa0f3$var$Logger(this.logger, {
            prefix: `${this.prefix}:${moduleName}:`,
            ...this.options
        });
    }
    clone(options) {
        options = options || this.options;
        options.prefix = options.prefix || this.prefix;
        return new $f5efe749b20fa0f3$var$Logger(this.logger, options);
    }
}
var $f5efe749b20fa0f3$var$baseLogger = new $f5efe749b20fa0f3$var$Logger();
class $f5efe749b20fa0f3$var$EventEmitter {
    constructor(){
        this.observers = {};
    }
    on(events, listener) {
        events.split(' ').forEach((event)=>{
            if (!this.observers[event]) this.observers[event] = new Map();
            const numListeners = this.observers[event].get(listener) || 0;
            this.observers[event].set(listener, numListeners + 1);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event].delete(listener);
    }
    once(event, listener) {
        const wrapper = (...args)=>{
            listener(...args);
            this.off(event, wrapper);
        };
        this.on(event, wrapper);
        return this;
    }
    emit(event, ...args) {
        if (this.observers[event]) {
            const cloned = Array.from(this.observers[event].entries());
            cloned.forEach(([observer, numTimesAdded])=>{
                for(let i = 0; i < numTimesAdded; i++)observer(...args);
            });
        }
        if (this.observers['*']) {
            const cloned = Array.from(this.observers['*'].entries());
            cloned.forEach(([observer, numTimesAdded])=>{
                for(let i = 0; i < numTimesAdded; i++)observer(event, ...args);
            });
        }
    }
}
const $f5efe749b20fa0f3$var$nonEmptyBundles = new WeakSet();
class $f5efe749b20fa0f3$var$ResourceStore extends $f5efe749b20fa0f3$var$EventEmitter {
    constructor(data, options = {
        ns: [
            'translation'
        ],
        defaultNS: 'translation'
    }){
        super();
        this.data = data || {};
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
    addNamespaces(ns) {
        if (!this.options.ns.includes(ns)) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key, options = {}) {
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path;
        if (lng.includes('.')) path = lng.split('.');
        else {
            path = [
                lng,
                ns
            ];
            if (key) {
                if (Array.isArray(key)) path.push(...key);
                else if ($f5efe749b20fa0f3$var$isString(key) && keySeparator) path.push(...key.split(keySeparator));
                else path.push(key);
            }
        }
        const result = $f5efe749b20fa0f3$var$getPath(this.data, path);
        if (!result && !ns && !key && lng.includes('.')) {
            lng = path[0];
            ns = path[1];
            key = path.slice(2).join('.');
        }
        if (result || !ignoreJSONStructure || !$f5efe749b20fa0f3$var$isString(key)) return result;
        return $f5efe749b20fa0f3$var$deepFind(this.data?.[lng]?.[ns], key, keySeparator);
    }
    addResource(lng, ns, key, value, options = {
        silent: false
    }) {
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.includes('.')) {
            path = lng.split('.');
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        $f5efe749b20fa0f3$var$setPath(this.data, path, value);
        if (!options.silent) this.emit('added', lng, ns, key, value);
    }
    addResources(lng, ns, resources, options = {
        silent: false
    }) {
        for(const m in resources)if ($f5efe749b20fa0f3$var$isString(resources[m]) || Array.isArray(resources[m])) this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite, options = {
        silent: false,
        skipCopy: false
    }) {
        let path = [
            lng,
            ns
        ];
        if (lng.includes('.')) {
            path = lng.split('.');
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = $f5efe749b20fa0f3$var$getPath(this.data, path) || {};
        if (!options.skipCopy) resources = JSON.parse(JSON.stringify(resources));
        if (deep) $f5efe749b20fa0f3$var$deepExtend(pack, resources, overwrite);
        else pack = {
            ...pack,
            ...resources
        };
        $f5efe749b20fa0f3$var$setPath(this.data, path, pack);
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit('removed', lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>{
            const bundle = data[v];
            if ($f5efe749b20fa0f3$var$nonEmptyBundles.has(bundle)) return true;
            if (!bundle || Object.keys(bundle).length === 0) return false;
            if (typeof bundle === 'object') $f5efe749b20fa0f3$var$nonEmptyBundles.add(bundle);
            return true;
        });
    }
    toJSON() {
        return this.data;
    }
}
var $f5efe749b20fa0f3$var$postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options, translator) {
        processors.forEach((processor)=>{
            value = this.processors[processor]?.process(value, key, options, translator) ?? value;
        });
        return value;
    }
};
const $f5efe749b20fa0f3$var$PATH_KEY = Symbol('i18next/PATH_KEY');
function $f5efe749b20fa0f3$var$createProxy() {
    const state = [];
    const handler = Object.create(null);
    let proxy;
    handler.get = (target, key)=>{
        proxy?.revoke?.();
        if (key === $f5efe749b20fa0f3$var$PATH_KEY) return state;
        state.push(key);
        proxy = Proxy.revocable(target, handler);
        return proxy.proxy;
    };
    return Proxy.revocable(Object.create(null), handler).proxy;
}
function $f5efe749b20fa0f3$export$ec2cccc18ab4c2ae(selector, opts) {
    const { [$f5efe749b20fa0f3$var$PATH_KEY]: path } = selector($f5efe749b20fa0f3$var$createProxy());
    const keySeparator = opts?.keySeparator ?? '.';
    const nsSeparator = opts?.nsSeparator ?? ':';
    const strict = opts?.enableSelector === 'strict';
    if (path.length > 1 && nsSeparator) {
        const ns = opts?.ns;
        const nsList = strict ? Array.isArray(ns) ? ns : ns ? [
            ns
        ] : null : Array.isArray(ns) ? ns : null;
        if (nsList) {
            const candidates = strict ? nsList : nsList.length > 1 ? nsList.slice(1) : [];
            if (candidates.includes(path[0])) return `${path[0]}${nsSeparator}${path.slice(1).join(keySeparator)}`;
        }
    }
    return path.join(keySeparator);
}
const $f5efe749b20fa0f3$var$shouldHandleAsObject = (res)=>!$f5efe749b20fa0f3$var$isString(res) && typeof res !== 'boolean' && typeof res !== 'number';
class $f5efe749b20fa0f3$var$Translator extends $f5efe749b20fa0f3$var$EventEmitter {
    constructor(services, options = {}){
        super();
        $f5efe749b20fa0f3$var$copy([
            'resourceStore',
            'languageUtils',
            'pluralResolver',
            'interpolator',
            'backendConnector',
            'i18nFormat',
            'utils'
        ], services, this);
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        this.logger = $f5efe749b20fa0f3$var$baseLogger.create('translator');
        this.checkedLoadedFor = {};
    }
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key, o = {
        interpolation: {}
    }) {
        const opt = {
            ...o
        };
        if (key == null) return false;
        const resolved = this.resolve(key, opt);
        if (resolved?.res === undefined) return false;
        const isObject = $f5efe749b20fa0f3$var$shouldHandleAsObject(resolved.res);
        if (opt.returnObjects === false && isObject) return false;
        return true;
    }
    extractFromKey(key, opt) {
        let nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
        let namespaces = opt.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.includes(nsSeparator);
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !opt.keySeparator && !this.options.userDefinedNsSeparator && !opt.nsSeparator && !$f5efe749b20fa0f3$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key: key,
                namespaces: $f5efe749b20fa0f3$var$isString(namespaces) ? [
                    namespaces
                ] : namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.includes(parts[0])) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        return {
            key: key,
            namespaces: $f5efe749b20fa0f3$var$isString(namespaces) ? [
                namespaces
            ] : namespaces
        };
    }
    translate(keys, o, lastKey) {
        let opt = typeof o === 'object' ? {
            ...o
        } : o;
        if (typeof opt !== 'object' && this.options.overloadTranslationOptionHandler) opt = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof opt === 'object') opt = {
            ...opt
        };
        if (!opt) opt = {};
        if (keys == null) return '';
        if (typeof keys === 'function') keys = $f5efe749b20fa0f3$export$ec2cccc18ab4c2ae(keys, {
            ...this.options,
            ...opt
        });
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        keys = keys.map((k)=>typeof k === 'function' ? $f5efe749b20fa0f3$export$ec2cccc18ab4c2ae(k, {
                ...this.options,
                ...opt
            }) : String(k));
        const returnDetails = opt.returnDetails !== undefined ? opt.returnDetails : this.options.returnDetails;
        const keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
        const { key: key, namespaces: namespaces } = this.extractFromKey(keys[keys.length - 1], opt);
        const namespace = namespaces[namespaces.length - 1];
        let nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const lng = opt.lng || this.language;
        const appendNamespaceToCIMode = opt.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if (lng?.toLowerCase() === 'cimode') {
            if (appendNamespaceToCIMode) {
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace,
                    usedParams: this.getUsedParamsDetails(opt)
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace,
                usedParams: this.getUsedParamsDetails(opt)
            };
            return key;
        }
        const resolved = this.resolve(keys, opt);
        let res = resolved?.res;
        const resUsedKey = resolved?.usedKey || key;
        const resExactUsedKey = resolved?.exactUsedKey || key;
        const noObject = [
            '[object Number]',
            '[object Function]',
            '[object RegExp]'
        ];
        const joinArrays = opt.joinArrays !== undefined ? opt.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const needsPluralHandling = opt.count !== undefined && !$f5efe749b20fa0f3$var$isString(opt.count);
        const hasDefaultValue = $f5efe749b20fa0f3$var$Translator.hasDefaultValue(opt);
        const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, opt) : '';
        const defaultValueSuffixOrdinalFallback = opt.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, {
            ordinal: false
        }) : '';
        const needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
        const defaultValue = needsZeroSuffixLookup && opt[`defaultValue${this.options.pluralSeparator}zero`] || opt[`defaultValue${defaultValueSuffix}`] || opt[`defaultValue${defaultValueSuffixOrdinalFallback}`] || opt.defaultValue;
        let resForObjHndl = res;
        if (handleAsObjectInI18nFormat && !res && hasDefaultValue) resForObjHndl = defaultValue;
        const handleAsObject = $f5efe749b20fa0f3$var$shouldHandleAsObject(resForObjHndl);
        const resType = Object.prototype.toString.apply(resForObjHndl);
        if (handleAsObjectInI18nFormat && resForObjHndl && handleAsObject && !noObject.includes(resType) && !($f5efe749b20fa0f3$var$isString(joinArrays) && Array.isArray(resForObjHndl))) {
            if (!opt.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn('accessing an object - but returnObjects options is not enabled!');
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, resForObjHndl, {
                    ...opt,
                    ns: namespaces
                }) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    resolved.usedParams = this.getUsedParamsDetails(opt);
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = Array.isArray(resForObjHndl);
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in resForObjHndl)if (Object.prototype.hasOwnProperty.call(resForObjHndl, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    if (hasDefaultValue && !res) copy[m] = this.translate(deepKey, {
                        ...opt,
                        defaultValue: $f5efe749b20fa0f3$var$shouldHandleAsObject(defaultValue) ? defaultValue[m] : undefined,
                        joinArrays: false,
                        ns: namespaces
                    });
                    else copy[m] = this.translate(deepKey, {
                        ...opt,
                        joinArrays: false,
                        ns: namespaces
                    });
                    if (copy[m] === deepKey) copy[m] = resForObjHndl[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && $f5efe749b20fa0f3$var$isString(joinArrays) && Array.isArray(res)) {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, opt, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = opt.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, needsPluralHandling && !updateMissing ? `${key}${this.pluralResolver.getSuffix(lng, opt.count, opt)}` : key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, {
                        ...opt,
                        keySeparator: false
                    });
                    if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, opt.lng || this.language);
                if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === 'all') lngs = this.languageUtils.toResolveHierarchy(opt.lng || this.language);
                else lngs.push(opt.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, opt);
                    else if (this.backendConnector?.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, opt);
                    this.emit('missingKey', l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        const suffixes = this.pluralResolver.getSuffixes(language, opt);
                        if (needsZeroSuffixLookup && opt[`defaultValue${this.options.pluralSeparator}zero`] && !suffixes.includes(`${this.options.pluralSeparator}zero`)) suffixes.push(`${this.options.pluralSeparator}zero`);
                        suffixes.forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, opt[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, opt, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}${nsSeparator}${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}${nsSeparator}${key}` : key, usedDefault ? res : undefined, opt);
        }
        if (returnDetails) {
            resolved.res = res;
            resolved.usedParams = this.getUsedParamsDetails(opt);
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, opt, resolved, lastKey) {
        if (this.i18nFormat?.parse) res = this.i18nFormat.parse(res, {
            ...this.options.interpolation.defaultVariables,
            ...opt
        }, opt.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved: resolved
        });
        else if (!opt.skipInterpolation) {
            if (opt.interpolation) this.interpolator.init({
                ...opt,
                interpolation: {
                    ...this.options.interpolation,
                    ...opt.interpolation
                }
            });
            const skipOnVariables = $f5efe749b20fa0f3$var$isString(res) && (opt?.interpolation?.skipOnVariables !== undefined ? opt.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = opt.replace && !$f5efe749b20fa0f3$var$isString(opt.replace) ? opt.replace : opt;
            if (this.options.interpolation.defaultVariables) data = {
                ...this.options.interpolation.defaultVariables,
                ...data
            };
            res = this.interpolator.interpolate(res, data, opt.lng || this.language || resolved.usedLng, opt);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) opt.nest = false;
            }
            if (!opt.lng && resolved && resolved.res) opt.lng = this.language || resolved.usedLng;
            if (opt.nest !== false) res = this.interpolator.nest(res, (...args)=>{
                if (lastKey?.[0] === args[0] && !opt.context) {
                    this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return this.translate(...args, key);
            }, opt);
            if (opt.interpolation) this.interpolator.reset();
        }
        const postProcess = opt.postProcess || this.options.postProcess;
        const postProcessorNames = $f5efe749b20fa0f3$var$isString(postProcess) ? [
            postProcess
        ] : postProcess;
        if (res != null && postProcessorNames?.length && opt.applyPostProcessor !== false) res = $f5efe749b20fa0f3$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: {
                ...resolved,
                usedParams: this.getUsedParamsDetails(opt)
            },
            ...opt
        } : opt, this);
        return res;
    }
    resolve(keys, opt = {}) {
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if ($f5efe749b20fa0f3$var$isString(keys)) keys = [
            keys
        ];
        if (Array.isArray(keys)) keys = keys.map((k)=>typeof k === 'function' ? $f5efe749b20fa0f3$export$ec2cccc18ab4c2ae(k, {
                ...this.options,
                ...opt
            }) : k);
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, opt);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = opt.count !== undefined && !$f5efe749b20fa0f3$var$isString(opt.count);
            const needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
            const needsContextHandling = opt.context !== undefined && ($f5efe749b20fa0f3$var$isString(opt.context) || typeof opt.context === 'number') && opt.context !== '';
            const codes = opt.lngs ? opt.lngs : this.languageUtils.toResolveHierarchy(opt.lng || this.language, opt.fallbackLng);
            namespaces.forEach((ns)=>{
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!this.checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils?.hasLoadedNamespace && !this.utils?.hasLoadedNamespace(usedNS)) {
                    this.checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(', ')}" won't get resolved as namespace "${usedNS}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                }
                codes.forEach((code)=>{
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if (this.i18nFormat?.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, opt);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, opt.count, opt);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            if (opt.ordinal && pluralSuffix.startsWith(ordinalPrefix)) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            finalKeys.push(key + pluralSuffix);
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator || '_'}${opt.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                if (opt.ordinal && pluralSuffix.startsWith(ordinalPrefix)) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                finalKeys.push(contextKey + pluralSuffix);
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, opt);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey: usedKey,
            exactUsedKey: exactUsedKey,
            usedLng: usedLng,
            usedNS: usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
    getResource(code, ns, key, options = {}) {
        if (this.i18nFormat?.getResource) return this.i18nFormat.getResource(code, ns, key, options);
        return this.resourceStore.getResource(code, ns, key, options);
    }
    getUsedParamsDetails(options = {}) {
        const optionsKeys = [
            'defaultValue',
            'ordinal',
            'context',
            'replace',
            'lng',
            'lngs',
            'fallbackLng',
            'ns',
            'keySeparator',
            'nsSeparator',
            'returnObjects',
            'returnDetails',
            'joinArrays',
            'postProcess',
            'interpolation'
        ];
        const useOptionsReplaceForData = options.replace && !$f5efe749b20fa0f3$var$isString(options.replace);
        let data = useOptionsReplaceForData ? options.replace : options;
        if (useOptionsReplaceForData && typeof options.count !== 'undefined') data = {
            ...data,
            count: options.count
        };
        if (this.options.interpolation.defaultVariables) data = {
            ...this.options.interpolation.defaultVariables,
            ...data
        };
        if (!useOptionsReplaceForData) {
            data = {
                ...data
            };
            for (const key of optionsKeys)delete data[key];
        }
        return data;
    }
    static hasDefaultValue(options) {
        const prefix = 'defaultValue';
        for(const option in options){
            if (Object.prototype.hasOwnProperty.call(options, option) && option.startsWith(prefix) && undefined !== options[option]) return true;
        }
        return false;
    }
}
class $f5efe749b20fa0f3$var$LanguageUtil {
    constructor(options){
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $f5efe749b20fa0f3$var$baseLogger.create('languageUtils');
        this.resolveHierarchyCache = {};
    }
    clearCache() {
        this.resolveHierarchyCache = {};
    }
    getScriptPartFromCode(code) {
        code = $f5efe749b20fa0f3$var$getCleanedCode(code);
        if (!code || !code.includes('-')) return null;
        const p = code.split('-');
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === 'x') return null;
        return this.formatLanguageCode(p.join('-'));
    }
    getLanguagePartFromCode(code) {
        code = $f5efe749b20fa0f3$var$getCleanedCode(code);
        if (!code || !code.includes('-')) return code;
        const p = code.split('-');
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if ($f5efe749b20fa0f3$var$isString(code) && code.includes('-')) {
            let formattedCode;
            try {
                formattedCode = Intl.getCanonicalLocales(code)[0];
            } catch (e) {}
            if (formattedCode && this.options.lowerCaseLng) formattedCode = formattedCode.toLowerCase();
            if (formattedCode) return formattedCode;
            if (this.options.lowerCaseLng) return code.toLowerCase();
            return code;
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.includes(code);
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngScOnly = this.getScriptPartFromCode(code);
            if (this.isSupportedCode(lngScOnly)) return found = lngScOnly;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return true;
                if (!supportedLng.includes('-') && !lngOnly.includes('-')) return false;
                if (supportedLng.includes('-') && !lngOnly.includes('-') && supportedLng.slice(0, supportedLng.indexOf('-')) === lngOnly) return true;
                if (supportedLng.startsWith(lngOnly) && lngOnly.length > 1) return true;
                return false;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
        if ($f5efe749b20fa0f3$var$isString(fallbacks)) fallbacks = [
            fallbacks
        ];
        if (Array.isArray(fallbacks)) return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackLng = this.options.fallbackLng;
        const fallbackLngKey = Array.isArray(fallbackLng) ? fallbackLng.join('|') : fallbackLng;
        if (fallbackLngKey !== this._cachedFallbackLng) {
            this.resolveHierarchyCache = {};
            this._cachedFallbackLng = fallbackLngKey;
        }
        const hasCacheableFallback = fallbackCode === undefined || fallbackCode === false || $f5efe749b20fa0f3$var$isString(fallbackCode);
        const usesUncacheableOptionsFallback = fallbackCode === undefined && typeof this.options.fallbackLng === 'function';
        const cacheable = $f5efe749b20fa0f3$var$isString(code) && hasCacheableFallback && !usesUncacheableOptionsFallback;
        let cacheKey = null;
        if (cacheable) {
            let fallbackCacheKey;
            if (fallbackCode === undefined) fallbackCacheKey = 'undefined';
            else if (fallbackCode === false) fallbackCacheKey = 'boolean:false';
            else fallbackCacheKey = `string:${fallbackCode}`;
            cacheKey = `${code.length}:${code}|${fallbackCacheKey}`;
        }
        if (cacheKey !== null) {
            const cached = this.resolveHierarchyCache[cacheKey];
            if (cached !== undefined) return cached.slice();
        }
        const fallbackCodes = this.getFallbackCodes((fallbackCode === false ? [] : fallbackCode) || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if ($f5efe749b20fa0f3$var$isString(code) && (code.includes('-') || code.includes('_'))) {
            if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
            if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
        } else if ($f5efe749b20fa0f3$var$isString(code)) addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            const formattedFc = this.formatLanguageCode(fc);
            if (!codes.includes(formattedFc)) addCode(formattedFc);
        });
        if (cacheKey !== null) {
            this.resolveHierarchyCache[cacheKey] = codes;
            return codes.slice();
        }
        return codes;
    }
}
const $f5efe749b20fa0f3$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
const $f5efe749b20fa0f3$var$dummyRule = {
    select: (count)=>count === 1 ? 'one' : 'other',
    resolvedOptions: ()=>({
            pluralCategories: [
                'one',
                'other'
            ]
        })
};
class $f5efe749b20fa0f3$var$PluralResolver {
    constructor(languageUtils, options = {}){
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $f5efe749b20fa0f3$var$baseLogger.create('pluralResolver');
        this.pluralRulesCache = {};
    }
    clearCache() {
        this.pluralRulesCache = {};
    }
    getRule(code, options = {}) {
        const cleanedCode = $f5efe749b20fa0f3$var$getCleanedCode(code === 'dev' ? 'en' : code);
        const type = options.ordinal ? 'ordinal' : 'cardinal';
        const cacheKey = JSON.stringify({
            cleanedCode: cleanedCode,
            type: type
        });
        if (cacheKey in this.pluralRulesCache) return this.pluralRulesCache[cacheKey];
        let rule;
        try {
            rule = new Intl.PluralRules(cleanedCode, {
                type: type
            });
        } catch (err) {
            if (typeof Intl === 'undefined') {
                this.logger.error('No Intl support, please use an Intl polyfill!');
                return $f5efe749b20fa0f3$var$dummyRule;
            }
            if (!code.match(/-|_/)) return $f5efe749b20fa0f3$var$dummyRule;
            const lngPart = this.languageUtils.getLanguagePartFromCode(code);
            rule = this.getRule(lngPart, options);
        }
        this.pluralRulesCache[cacheKey] = rule;
        return rule;
    }
    needsPlural(code, options = {}) {
        let rule = this.getRule(code, options);
        if (!rule) rule = this.getRule('dev', options);
        return rule?.resolvedOptions().pluralCategories.length > 1;
    }
    getPluralFormsOfKey(code, key, options = {}) {
        return this.getSuffixes(code, options).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code, options = {}) {
        let rule = this.getRule(code, options);
        if (!rule) rule = this.getRule('dev', options);
        if (!rule) return [];
        return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>$f5efe749b20fa0f3$var$suffixesOrder[pluralCategory1] - $f5efe749b20fa0f3$var$suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${pluralCategory}`);
    }
    getSuffix(code, count, options = {}) {
        const rule = this.getRule(code, options);
        if (rule) return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${rule.select(count)}`;
        this.logger.warn(`no plural rule found for: ${code}`);
        return this.getSuffix('dev', count, options);
    }
}
const $f5efe749b20fa0f3$var$deepFindWithDefaults = (data, defaultData, key, keySeparator = '.', ignoreJSONStructure = true)=>{
    let path = $f5efe749b20fa0f3$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && $f5efe749b20fa0f3$var$isString(key)) {
        path = $f5efe749b20fa0f3$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $f5efe749b20fa0f3$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
};
const $f5efe749b20fa0f3$var$regexSafe = (val)=>val.replace(/\$/g, '$$$$');
class $f5efe749b20fa0f3$var$Interpolator {
    constructor(options = {}){
        this.logger = $f5efe749b20fa0f3$var$baseLogger.create('interpolator');
        this.options = options;
        this.format = options?.interpolation?.format || ((value)=>value);
        this.init(options);
    }
    init(options = {}) {
        if (!options.interpolation) options.interpolation = {
            escapeValue: true
        };
        const { escape: escape$1, escapeValue: escapeValue, useRawValueToEscape: useRawValueToEscape, prefix: prefix, prefixEscaped: prefixEscaped, suffix: suffix, suffixEscaped: suffixEscaped, formatSeparator: formatSeparator, unescapeSuffix: unescapeSuffix, unescapePrefix: unescapePrefix, nestingPrefix: nestingPrefix, nestingPrefixEscaped: nestingPrefixEscaped, nestingSuffix: nestingSuffix, nestingSuffixEscaped: nestingSuffixEscaped, nestingOptionsSeparator: nestingOptionsSeparator, maxReplaces: maxReplaces, alwaysFormat: alwaysFormat } = options.interpolation;
        this.escape = escape$1 !== undefined ? escape$1 : $f5efe749b20fa0f3$var$escape;
        this.escapeValue = escapeValue !== undefined ? escapeValue : true;
        this.useRawValueToEscape = useRawValueToEscape !== undefined ? useRawValueToEscape : false;
        this.prefix = prefix ? $f5efe749b20fa0f3$var$regexEscape(prefix) : prefixEscaped || '{{';
        this.suffix = suffix ? $f5efe749b20fa0f3$var$regexEscape(suffix) : suffixEscaped || '}}';
        this.formatSeparator = formatSeparator || ',';
        this.unescapePrefix = unescapeSuffix ? '' : unescapePrefix ? $f5efe749b20fa0f3$var$regexEscape(unescapePrefix) : '-';
        this.unescapeSuffix = this.unescapePrefix ? '' : unescapeSuffix ? $f5efe749b20fa0f3$var$regexEscape(unescapeSuffix) : '';
        this.nestingPrefix = nestingPrefix ? $f5efe749b20fa0f3$var$regexEscape(nestingPrefix) : nestingPrefixEscaped || $f5efe749b20fa0f3$var$regexEscape('$t(');
        this.nestingSuffix = nestingSuffix ? $f5efe749b20fa0f3$var$regexEscape(nestingSuffix) : nestingSuffixEscaped || $f5efe749b20fa0f3$var$regexEscape(')');
        this.nestingOptionsSeparator = nestingOptionsSeparator || ',';
        this.maxReplaces = maxReplaces || 1000;
        this.alwaysFormat = alwaysFormat !== undefined ? alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const getOrResetRegExp = (existingRegExp, pattern)=>{
            if (existingRegExp?.source === pattern) {
                existingRegExp.lastIndex = 0;
                return existingRegExp;
            }
            return new RegExp(pattern, 'g');
        };
        this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
        this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
        this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}((?:[^()"']|"[^"]*"|'[^']*'|\\((?:[^()"']|"[^"]*"|'[^']*')*\\))*?)${this.nestingSuffix}`);
    }
    interpolate(str, data, lng, options) {
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        const handleFormat = (key)=>{
            if (!key.includes(this.formatSeparator)) {
                const path = $f5efe749b20fa0f3$var$deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, {
                    ...options,
                    ...data,
                    interpolationkey: key
                }) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format($f5efe749b20fa0f3$var$deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
                ...options,
                ...data,
                interpolationkey: k
            });
        };
        this.resetRegExp();
        if (!this.escapeValue && typeof str === 'string' && /\$t\([^)]*\{[^}]*\{\{/.test(str)) this.logger.warn("nesting options string contains interpolated variables with escapeValue: false \u2014 if any of those values are attacker-controlled they can inject additional nesting options (e.g. redirect lng/ns). Sanitise untrusted input before passing it to t(), or keep escapeValue: true.");
        const missingInterpolationHandler = options?.missingInterpolationHandler || this.options.missingInterpolationHandler;
        const skipOnVariables = options?.interpolation?.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>val
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? this.escape(val) : val
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === 'function') {
                        const temp = missingInterpolationHandler(str, match, options);
                        value = $f5efe749b20fa0f3$var$isString(temp) ? temp : '';
                    } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = '';
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = '';
                    }
                } else if (!$f5efe749b20fa0f3$var$isString(value) && !this.useRawValueToEscape) value = $f5efe749b20fa0f3$var$makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], $f5efe749b20fa0f3$var$regexSafe(safeValue));
                if (skipOnVariables) {
                    todo.regex.lastIndex += safeValue.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc, options = {}) {
        let match;
        let value;
        let clonedOptions;
        const handleHasOptions = (key, inheritedOptions)=>{
            const sep = this.nestingOptionsSeparator;
            if (!key.includes(sep)) return key;
            const c = key.split(new RegExp(`${$f5efe749b20fa0f3$var$regexEscape(sep)}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            if ((matchedSingleQuotes?.length ?? 0) % 2 === 0 && !matchedDoubleQuotes || (matchedDoubleQuotes?.length ?? 0) % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = {
                    ...inheritedOptions,
                    ...clonedOptions
                };
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            if (clonedOptions.defaultValue && clonedOptions.defaultValue.includes(this.prefix)) delete clonedOptions.defaultValue;
            return key;
        };
        const nestingRegexp = new RegExp(this.nestingRegexp);
        let out = '';
        let lastEnd = 0;
        while(match = nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = {
                ...options
            };
            clonedOptions = clonedOptions.replace && !$f5efe749b20fa0f3$var$isString(clonedOptions.replace) ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            const keyEndIndex = /{.*}/s.test(match[1]) ? match[1].lastIndexOf('}') + 1 : match[1].indexOf(this.formatSeparator);
            if (keyEndIndex !== -1) {
                formatters = match[1].slice(keyEndIndex).split(this.formatSeparator).map((elem)=>elem.trim()).filter(Boolean);
                match[1] = match[1].slice(0, keyEndIndex);
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && !$f5efe749b20fa0f3$var$isString(value)) return value;
            if (!$f5efe749b20fa0f3$var$isString(value)) value = $f5efe749b20fa0f3$var$makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = '';
            }
            if (formatters.length) value = formatters.reduce((v, f)=>this.format(v, f, options.lng, {
                    ...options,
                    interpolationkey: match[1].trim()
                }), value.trim());
            out += str.slice(lastEnd, match.index) + $f5efe749b20fa0f3$var$makeString(value);
            lastEnd = nestingRegexp.lastIndex;
            this.regexp.lastIndex = 0;
        }
        return lastEnd ? out + str.slice(lastEnd) : str;
    }
}
const $f5efe749b20fa0f3$var$parseFormatStr = (formatStr)=>{
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.includes('(')) {
        const p = formatStr.split('(');
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].slice(0, -1);
        if (formatName === 'currency' && !optStr.includes(':')) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === 'relativetime' && !optStr.includes(':')) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(';');
            opts.forEach((opt)=>{
                if (opt) {
                    const [key, ...rest] = opt.split(':');
                    const val = rest.join(':').trim().replace(/^'+|'+$/g, '');
                    const trimmedKey = key.trim();
                    if (!formatOptions[trimmedKey]) formatOptions[trimmedKey] = val;
                    if (val === 'false') formatOptions[trimmedKey] = false;
                    if (val === 'true') formatOptions[trimmedKey] = true;
                    if (!isNaN(val)) formatOptions[trimmedKey] = parseInt(val, 10);
                }
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
};
const $f5efe749b20fa0f3$var$createCachedFormatter = (fn)=>{
    const cache = {};
    return (v, l, o)=>{
        let optForCache = o;
        if (o && o.interpolationkey && o.formatParams && o.formatParams[o.interpolationkey] && o[o.interpolationkey]) optForCache = {
            ...optForCache,
            [o.interpolationkey]: undefined
        };
        const key = l + JSON.stringify(optForCache);
        let frm = cache[key];
        if (!frm) {
            frm = fn($f5efe749b20fa0f3$var$getCleanedCode(l), o);
            cache[key] = frm;
        }
        return frm(v);
    };
};
const $f5efe749b20fa0f3$var$createNonCachedFormatter = (fn)=>(v, l, o)=>fn($f5efe749b20fa0f3$var$getCleanedCode(l), o)(v);
class $f5efe749b20fa0f3$var$Formatter {
    constructor(options = {}){
        this.logger = $f5efe749b20fa0f3$var$baseLogger.create('formatter');
        this.options = options;
        this.init(options);
    }
    init(services, options = {
        interpolation: {}
    }) {
        this.formatSeparator = options.interpolation.formatSeparator || ',';
        const cf = options.cacheInBuiltFormats ? $f5efe749b20fa0f3$var$createCachedFormatter : $f5efe749b20fa0f3$var$createNonCachedFormatter;
        this.formats = {
            number: cf((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            currency: cf((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt,
                    style: 'currency'
                });
                return (val)=>formatter.format(val);
            }),
            datetime: cf((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            relativetime: cf((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val, opt.range || 'day');
            }),
            list: cf((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            })
        };
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = $f5efe749b20fa0f3$var$createCachedFormatter(fc);
    }
    format(value, format, lng, options = {}) {
        if (!format) return value;
        if (value == null) return value;
        const rawFormats = format.split(this.formatSeparator);
        const formats = [];
        for(let i = 0; i < rawFormats.length; i++){
            let f = rawFormats[i];
            while(f.indexOf('(') > -1 && !f.includes(')') && i + 1 < rawFormats.length)f = `${f}${this.formatSeparator}${rawFormats[++i]}`;
            formats.push(f);
        }
        const result = formats.reduce((mem, f)=>{
            const { formatName: formatName, formatOptions: formatOptions } = $f5efe749b20fa0f3$var$parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    const valOptions = options?.formatParams?.[options.interpolationkey] || {};
                    const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                    formatted = this.formats[formatName](mem, l, {
                        ...formatOptions,
                        ...options,
                        ...valOptions
                    });
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
}
const $f5efe749b20fa0f3$var$removePending = (q, name)=>{
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
};
class $f5efe749b20fa0f3$var$Connector extends $f5efe749b20fa0f3$var$EventEmitter {
    constructor(backend, store, services, options = {}){
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options;
        this.logger = $f5efe749b20fa0f3$var$baseLogger.create('backendConnector');
        this.waitingReads = [];
        this.maxParallelReads = options.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        this.backend?.init?.(services, options.backend, options);
    }
    queueLoad(languages, namespaces, options, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending: pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback: callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit('failedLoading', lng, ns, err);
        if (!err && data) this.store.addResourceBundle(lng, ns, data, undefined, undefined, {
            skipCopy: true
        });
        this.state[name] = err ? -1 : 2;
        if (err && data) this.state[name] = 0;
        const loaded = {};
        this.queue.forEach((q)=>{
            $f5efe749b20fa0f3$var$pushPath(q.loaded, [
                lng
            ], ns);
            $f5efe749b20fa0f3$var$removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit('loaded', loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName, tried = 0, wait = this.retryTimeout, callback) {
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: lng,
                ns: ns,
                fcName: fcName,
                tried: tried,
                wait: wait,
                callback: callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read(lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === 'function') r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces, options = {}, callback) {
        if (!this.backend) {
            this.logger.warn('No backend was added via i18next.use. Will not load resources.');
            return callback && callback();
        }
        if ($f5efe749b20fa0f3$var$isString(languages)) languages = this.languageUtils.toResolveHierarchy(languages);
        if ($f5efe749b20fa0f3$var$isString(namespaces)) namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name, prefix = '') {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, 'read', undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate, options = {}, clb = ()=>{}) {
        if (this.services?.utils?.hasLoadedNamespace && !this.services?.utils?.hasLoadedNamespace(namespace)) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
            return;
        }
        if (key === undefined || key === null || key === '') return;
        if (this.backend?.create) {
            const opts = {
                ...options,
                isUpdate: isUpdate
            };
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === 'function') r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
}
const $f5efe749b20fa0f3$var$get = ()=>({
        debug: false,
        initAsync: true,
        ns: [
            'translation'
        ],
        defaultNS: [
            'translation'
        ],
        fallbackLng: [
            'dev'
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: 'all',
        preload: false,
        keySeparator: '.',
        nsSeparator: ':',
        pluralSeparator: '_',
        contextSeparator: '_',
        enableSelector: false,
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: 'fallback',
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: (args)=>{
            let ret = {};
            if (typeof args[1] === 'object') ret = args[1];
            if ($f5efe749b20fa0f3$var$isString(args[1])) ret.defaultValue = args[1];
            if ($f5efe749b20fa0f3$var$isString(args[2])) ret.tDescription = args[2];
            if (typeof args[2] === 'object' || typeof args[3] === 'object') {
                const options = args[3] || args[2];
                Object.keys(options).forEach((key)=>{
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1000,
            skipOnVariables: true
        },
        cacheInBuiltFormats: true
    });
const $f5efe749b20fa0f3$var$transformOptions = (options)=>{
    if ($f5efe749b20fa0f3$var$isString(options.ns)) options.ns = [
        options.ns
    ];
    if ($f5efe749b20fa0f3$var$isString(options.fallbackLng)) options.fallbackLng = [
        options.fallbackLng
    ];
    if ($f5efe749b20fa0f3$var$isString(options.fallbackNS)) options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && !options.supportedLngs.includes('cimode')) options.supportedLngs = options.supportedLngs.concat([
        'cimode'
    ]);
    return options;
};
const $f5efe749b20fa0f3$var$noop = ()=>{};
const $f5efe749b20fa0f3$var$bindMemberFunctions = (inst)=>{
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === 'function') inst[mem] = inst[mem].bind(inst);
    });
};
class $f5efe749b20fa0f3$var$I18n extends $f5efe749b20fa0f3$var$EventEmitter {
    constructor(options = {}, callback){
        super();
        this.options = $f5efe749b20fa0f3$var$transformOptions(options);
        this.services = {};
        this.logger = $f5efe749b20fa0f3$var$baseLogger;
        this.modules = {
            external: []
        };
        $f5efe749b20fa0f3$var$bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options.isClone) {
            if (!this.options.initAsync) {
                this.init(options, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options, callback);
            }, 0);
        }
    }
    init(options = {}, callback) {
        this.isInitializing = true;
        if (typeof options === 'function') {
            callback = options;
            options = {};
        }
        if (options.defaultNS == null && options.ns) {
            if ($f5efe749b20fa0f3$var$isString(options.ns)) options.defaultNS = options.ns;
            else if (!options.ns.includes('translation')) options.defaultNS = options.ns[0];
        }
        const defOpts = $f5efe749b20fa0f3$var$get();
        this.options = {
            ...defOpts,
            ...this.options,
            ...$f5efe749b20fa0f3$var$transformOptions(options)
        };
        this.options.interpolation = {
            ...defOpts.interpolation,
            ...this.options.interpolation
        };
        if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
        if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
        if (typeof this.options.overloadTranslationOptionHandler !== 'function') this.options.overloadTranslationOptionHandler = defOpts.overloadTranslationOptionHandler;
        const createClassOnDemand = (ClassOrObject)=>{
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === 'function') return new ClassOrObject();
            return ClassOrObject;
        };
        if (!this.options.isClone) {
            if (this.modules.logger) $f5efe749b20fa0f3$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else $f5efe749b20fa0f3$var$baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else formatter = $f5efe749b20fa0f3$var$Formatter;
            const lu = new $f5efe749b20fa0f3$var$LanguageUtil(this.options);
            this.store = new $f5efe749b20fa0f3$var$ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = $f5efe749b20fa0f3$var$baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new $f5efe749b20fa0f3$var$PluralResolver(lu, {
                prepend: this.options.pluralSeparator
            });
            if (formatter) {
                s.formatter = createClassOnDemand(formatter);
                if (s.formatter.init) s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new $f5efe749b20fa0f3$var$Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new $f5efe749b20fa0f3$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on('*', (event, ...args)=>{
                this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new $f5efe749b20fa0f3$var$Translator(this.services, this.options);
            this.translator.on('*', (event, ...args)=>{
                this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = $f5efe749b20fa0f3$var$noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn('init: no languageDetector is used and no lng is defined');
        const storeApi = [
            'getResource',
            'hasResourceBundle',
            'getResourceBundle',
            'getDataByLanguage'
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = (...args)=>this.store[fcName](...args);
        });
        const storeApiChained = [
            'addResource',
            'addResources',
            'addResourceBundle',
            'removeResourceBundle'
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = (...args)=>{
                this.store[fcName](...args);
                return this;
            };
        });
        const deferred = $f5efe749b20fa0f3$var$defer();
        const load = ()=>{
            const finish = (err, t)=>{
                this.isInitializing = false;
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn('init: i18next is already initialized. You should call init just once!');
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log('initialized', this.options);
                this.emit('initialized', this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if ((this.languages || this.isLanguageChangingTo) && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initAsync) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language, callback = $f5efe749b20fa0f3$var$noop) {
        let usedCallback = callback;
        const usedLng = $f5efe749b20fa0f3$var$isString(language) ? language : this.language;
        if (typeof language === 'function') usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            if (usedLng?.toLowerCase() === 'cimode' && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === 'cimode') return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === 'cimode') return;
                    if (!toLoad.includes(l)) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            this.options.preload?.forEach?.((l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = $f5efe749b20fa0f3$var$defer();
        if (typeof lngs === 'function') {
            callback = lngs;
            lngs = undefined;
        }
        if (typeof ns === 'function') {
            callback = ns;
            ns = undefined;
        }
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = $f5efe749b20fa0f3$var$noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
        if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
        if (module.type === 'backend') this.modules.backend = module;
        if (module.type === 'logger' || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === 'languageDetector') this.modules.languageDetector = module;
        if (module.type === 'i18nFormat') this.modules.i18nFormat = module;
        if (module.type === 'postProcessor') $f5efe749b20fa0f3$var$postProcessor.addPostProcessor(module);
        if (module.type === 'formatter') this.modules.formatter = module;
        if (module.type === '3rdParty') this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            'cimode',
            'dev'
        ].includes(l)) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                'cimode',
                'dev'
            ].includes(lngInLngs)) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
        if (!this.resolvedLanguage && !this.languages.includes(l) && this.store.hasLanguageSomeTranslations(l)) {
            this.resolvedLanguage = l;
            this.languages.unshift(l);
        }
    }
    changeLanguage(lng, callback) {
        this.isLanguageChangingTo = lng;
        const deferred = $f5efe749b20fa0f3$var$defer();
        this.emit('languageChanging', lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                if (this.isLanguageChangingTo === lng) {
                    setLngProps(l);
                    this.translator.changeLanguage(l);
                    this.isLanguageChangingTo = undefined;
                    this.emit('languageChanged', l);
                    this.logger.log('languageChanged', l);
                }
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve((...args)=>this.t(...args));
            if (callback) callback(err, (...args)=>this.t(...args));
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const fl = $f5efe749b20fa0f3$var$isString(lngs) ? lngs : lngs && lngs[0];
            const l = this.store.hasLanguageSomeTranslations(fl) ? fl : this.services.languageUtils.getBestMatchFromCodes($f5efe749b20fa0f3$var$isString(lngs) ? [
                lngs
            ] : lngs);
            if (l) {
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                this.services.languageDetector?.cacheUserLanguage?.(l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix, fixedOpts) {
        const scopeNs = fixedOpts?.scopeNs;
        const fixedT = (key, opts, ...rest)=>{
            let o;
            if (typeof opts !== 'object') o = this.options.overloadTranslationOptionHandler([
                key,
                opts
            ].concat(rest));
            else o = {
                ...opts
            };
            o.lng = o.lng || fixedT.lng;
            o.lngs = o.lngs || fixedT.lngs;
            const explicitCallNs = o.ns !== undefined && o.ns !== null;
            o.ns = o.ns || fixedT.ns;
            if (o.keyPrefix !== '') o.keyPrefix = o.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const selectorOpts = {
                ...this.options,
                ...o
            };
            if (Array.isArray(scopeNs) && !explicitCallNs) selectorOpts.ns = scopeNs;
            if (typeof o.keyPrefix === 'function') o.keyPrefix = $f5efe749b20fa0f3$export$ec2cccc18ab4c2ae(o.keyPrefix, selectorOpts);
            const keySeparator = this.options.keySeparator || '.';
            let resultKey;
            if (o.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>{
                if (typeof k === 'function') k = $f5efe749b20fa0f3$export$ec2cccc18ab4c2ae(k, selectorOpts);
                return `${o.keyPrefix}${keySeparator}${k}`;
            });
            else {
                if (typeof key === 'function') key = $f5efe749b20fa0f3$export$ec2cccc18ab4c2ae(key, selectorOpts);
                resultKey = o.keyPrefix ? `${o.keyPrefix}${keySeparator}${key}` : key;
            }
            return this.t(resultKey, o);
        };
        if ($f5efe749b20fa0f3$var$isString(lng)) fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t(...args) {
        return this.translator?.translate(...args);
    }
    exists(...args) {
        return this.translator?.exists(...args);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns, options = {}) {
        if (!this.isInitialized) {
            this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
            return false;
        }
        const lng = options.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === 'cimode') return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 0 || loadState === 2;
        };
        if (options.precheck) {
            const preResult = options.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        const { languageUtils: languageUtils } = this.services;
        const loadLng = !options.lng ? lng : languageUtils.isSupportedCode(lng) && languageUtils.toResolveHierarchy(lng, false)[0];
        if ((!loadLng || loadNotPending(loadLng, ns)) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = $f5efe749b20fa0f3$var$defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if ($f5efe749b20fa0f3$var$isString(ns)) ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (!this.options.ns.includes(n)) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = $f5efe749b20fa0f3$var$defer();
        if ($f5efe749b20fa0f3$var$isString(lngs)) lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>!preloaded.includes(lng) && this.services.languageUtils.isSupportedCode(lng));
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        if (!lng) lng = this.resolvedLanguage || (this.languages?.length > 0 ? this.languages[0] : this.language);
        if (!lng) return 'rtl';
        try {
            const l = new Intl.Locale(lng);
            if (l && l.getTextInfo) {
                const ti = l.getTextInfo();
                if (ti && ti.direction) return ti.direction;
            }
        } catch (e) {}
        const rtlLngs = [
            'ar',
            'shu',
            'sqr',
            'ssh',
            'xaa',
            'yhd',
            'yud',
            'aao',
            'abh',
            'abv',
            'acm',
            'acq',
            'acw',
            'acx',
            'acy',
            'adf',
            'ads',
            'aeb',
            'aec',
            'afb',
            'ajp',
            'apc',
            'apd',
            'arb',
            'arq',
            'ars',
            'ary',
            'arz',
            'auz',
            'avl',
            'ayh',
            'ayl',
            'ayn',
            'ayp',
            'bbz',
            'pga',
            'he',
            'iw',
            'ps',
            'pbt',
            'pbu',
            'pst',
            'prp',
            'prd',
            'ug',
            'ur',
            'ydd',
            'yds',
            'yih',
            'ji',
            'yi',
            'hbo',
            'men',
            'xmn',
            'fa',
            'jpr',
            'peo',
            'pes',
            'prs',
            'dv',
            'sam',
            'ckb'
        ];
        const languageUtils = this.services?.languageUtils || new $f5efe749b20fa0f3$var$LanguageUtil($f5efe749b20fa0f3$var$get());
        if (lng.toLowerCase().indexOf('-latn') > 1) return 'ltr';
        return rtlLngs.includes(languageUtils.getLanguagePartFromCode(lng)) || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
    static createInstance(options = {}, callback) {
        const instance = new $f5efe749b20fa0f3$var$I18n(options, callback);
        instance.createInstance = $f5efe749b20fa0f3$var$I18n.createInstance;
        return instance;
    }
    cloneInstance(options = {}, callback = $f5efe749b20fa0f3$var$noop) {
        const forkResourceStore = options.forkResourceStore;
        if (forkResourceStore) delete options.forkResourceStore;
        const mergedOptions = {
            ...this.options,
            ...options,
            isClone: true
        };
        const clone = new $f5efe749b20fa0f3$var$I18n(mergedOptions);
        if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
        const membersToCopy = [
            'store',
            'services',
            'language'
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = {
            ...this.services
        };
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            const clonedData = Object.keys(this.store.data).reduce((prev, l)=>{
                prev[l] = {
                    ...this.store.data[l]
                };
                prev[l] = Object.keys(prev[l]).reduce((acc, n)=>{
                    acc[n] = {
                        ...prev[l][n]
                    };
                    return acc;
                }, prev[l]);
                return prev;
            }, {});
            clone.store = new $f5efe749b20fa0f3$var$ResourceStore(clonedData, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        if (options.interpolation) {
            const defOpts = $f5efe749b20fa0f3$var$get();
            const mergedInterpolation = {
                ...defOpts.interpolation,
                ...this.options.interpolation,
                ...options.interpolation
            };
            const mergedForInterpolator = {
                ...mergedOptions,
                interpolation: mergedInterpolation
            };
            clone.services.interpolator = new $f5efe749b20fa0f3$var$Interpolator(mergedForInterpolator);
        }
        clone.translator = new $f5efe749b20fa0f3$var$Translator(clone.services, mergedOptions);
        clone.translator.on('*', (event, ...args)=>{
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
}
const $f5efe749b20fa0f3$export$2e2bcd8739ae039 = $f5efe749b20fa0f3$var$I18n.createInstance();
const $f5efe749b20fa0f3$export$99152e8d49ca4e7d = $f5efe749b20fa0f3$export$2e2bcd8739ae039.createInstance;
const $f5efe749b20fa0f3$export$147ec2801e896265 = $f5efe749b20fa0f3$export$2e2bcd8739ae039.dir;
const $f5efe749b20fa0f3$export$2cd8252107eb640b = $f5efe749b20fa0f3$export$2e2bcd8739ae039.init;
const $f5efe749b20fa0f3$export$d3d08d944062d7e = $f5efe749b20fa0f3$export$2e2bcd8739ae039.loadResources;
const $f5efe749b20fa0f3$export$a5d9bf5d83fcab09 = $f5efe749b20fa0f3$export$2e2bcd8739ae039.reloadResources;
const $f5efe749b20fa0f3$export$1f96ae73734a86cc = $f5efe749b20fa0f3$export$2e2bcd8739ae039.use;
const $f5efe749b20fa0f3$export$61465194746e7fd2 = $f5efe749b20fa0f3$export$2e2bcd8739ae039.changeLanguage;
const $f5efe749b20fa0f3$export$f90d180fc7da3b3b = $f5efe749b20fa0f3$export$2e2bcd8739ae039.getFixedT;
const $f5efe749b20fa0f3$export$625550452a3fa3ec = $f5efe749b20fa0f3$export$2e2bcd8739ae039.t;
const $f5efe749b20fa0f3$export$f7e9f41ea797a17 = $f5efe749b20fa0f3$export$2e2bcd8739ae039.exists;
const $f5efe749b20fa0f3$export$2b4b218e406d2d00 = $f5efe749b20fa0f3$export$2e2bcd8739ae039.setDefaultNamespace;
const $f5efe749b20fa0f3$export$93d9ee97c1ad3f31 = $f5efe749b20fa0f3$export$2e2bcd8739ae039.hasLoadedNamespace;
const $f5efe749b20fa0f3$export$83be934b53fff43b = $f5efe749b20fa0f3$export$2e2bcd8739ae039.loadNamespaces;
const $f5efe749b20fa0f3$export$8cd7e7a54fa865bc = $f5efe749b20fa0f3$export$2e2bcd8739ae039.loadLanguages;


const { slice: $2e6ea1df9a18d47e$var$slice, forEach: $2e6ea1df9a18d47e$var$forEach } = [];
function $2e6ea1df9a18d47e$var$defaults(obj) {
    $2e6ea1df9a18d47e$var$forEach.call($2e6ea1df9a18d47e$var$slice.call(arguments, 1), (source)=>{
        if (source) {
            for(const prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
function $2e6ea1df9a18d47e$var$hasXSS(input) {
    if (typeof input !== 'string') return false;
    // Common XSS attack patterns
    const xssPatterns = [
        /<\s*script.*?>/i,
        /<\s*\/\s*script\s*>/i,
        /<\s*img.*?on\w+\s*=/i,
        /<\s*\w+\s*on\w+\s*=.*?>/i,
        /javascript\s*:/i,
        /vbscript\s*:/i,
        /expression\s*\(/i,
        /eval\s*\(/i,
        /alert\s*\(/i,
        /document\.cookie/i,
        /document\.write\s*\(/i,
        /window\.location/i,
        /innerHTML/i
    ];
    return xssPatterns.some((pattern)=>pattern.test(input));
}
// eslint-disable-next-line no-control-regex
const $2e6ea1df9a18d47e$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
const $2e6ea1df9a18d47e$var$serializeCookie = function(name, val) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        path: '/'
    };
    const opt = options;
    const value = encodeURIComponent(val);
    let str = `${name}=${value}`;
    if (opt.maxAge > 0) {
        const maxAge = opt.maxAge - 0;
        if (Number.isNaN(maxAge)) throw new Error('maxAge should be a Number');
        str += `; Max-Age=${Math.floor(maxAge)}`;
    }
    if (opt.domain) {
        if (!$2e6ea1df9a18d47e$var$fieldContentRegExp.test(opt.domain)) throw new TypeError('option domain is invalid');
        str += `; Domain=${opt.domain}`;
    }
    if (opt.path) {
        if (!$2e6ea1df9a18d47e$var$fieldContentRegExp.test(opt.path)) throw new TypeError('option path is invalid');
        str += `; Path=${opt.path}`;
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== 'function') throw new TypeError('option expires is invalid');
        str += `; Expires=${opt.expires.toUTCString()}`;
    }
    if (opt.httpOnly) str += '; HttpOnly';
    if (opt.secure) str += '; Secure';
    if (opt.sameSite) {
        const sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += '; SameSite=Strict';
                break;
            case 'lax':
                str += '; SameSite=Lax';
                break;
            case 'strict':
                str += '; SameSite=Strict';
                break;
            case 'none':
                str += '; SameSite=None';
                break;
            default:
                throw new TypeError('option sameSite is invalid');
        }
    }
    if (opt.partitioned) str += '; Partitioned';
    return str;
};
const $2e6ea1df9a18d47e$var$cookie = {
    create (name, value, minutes, domain) {
        let cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            path: '/',
            sameSite: 'strict'
        };
        if (minutes) {
            cookieOptions.expires = new Date();
            cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60000);
        }
        if (domain) cookieOptions.domain = domain;
        document.cookie = $2e6ea1df9a18d47e$var$serializeCookie(name, value, cookieOptions);
    },
    read (name) {
        const nameEQ = `${name}=`;
        const ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++){
            let c = ca[i];
            while(c.charAt(0) === ' ')c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    remove (name, domain) {
        this.create(name, '', -1, domain);
    }
};
var $2e6ea1df9a18d47e$var$cookie$1 = {
    name: 'cookie',
    // Deconstruct the options object and extract the lookupCookie property
    lookup (_ref) {
        let { lookupCookie: lookupCookie } = _ref;
        if (lookupCookie && typeof document !== 'undefined') return $2e6ea1df9a18d47e$var$cookie.read(lookupCookie) || undefined;
        return undefined;
    },
    // Deconstruct the options object and extract the lookupCookie, cookieMinutes, cookieDomain, and cookieOptions properties
    cacheUserLanguage (lng, _ref2) {
        let { lookupCookie: lookupCookie, cookieMinutes: cookieMinutes, cookieDomain: cookieDomain, cookieOptions: cookieOptions } = _ref2;
        if (lookupCookie && typeof document !== 'undefined') $2e6ea1df9a18d47e$var$cookie.create(lookupCookie, lng, cookieMinutes, cookieDomain, cookieOptions);
    }
};
var $2e6ea1df9a18d47e$var$querystring = {
    name: 'querystring',
    // Deconstruct the options object and extract the lookupQuerystring property
    lookup (_ref) {
        let { lookupQuerystring: lookupQuerystring } = _ref;
        let found;
        if (typeof window !== 'undefined') {
            let { search: search } = window.location;
            if (!window.location.search && window.location.hash?.indexOf('?') > -1) search = window.location.hash.substring(window.location.hash.indexOf('?'));
            const query = search.substring(1);
            const params = query.split('&');
            for(let i = 0; i < params.length; i++){
                const pos = params[i].indexOf('=');
                if (pos > 0) {
                    const key = params[i].substring(0, pos);
                    if (key === lookupQuerystring) found = params[i].substring(pos + 1);
                }
            }
        }
        return found;
    }
};
var $2e6ea1df9a18d47e$var$hash = {
    name: 'hash',
    // Deconstruct the options object and extract the lookupHash property and the lookupFromHashIndex property
    lookup (_ref) {
        let { lookupHash: lookupHash, lookupFromHashIndex: lookupFromHashIndex } = _ref;
        let found;
        if (typeof window !== 'undefined') {
            const { hash: hash } = window.location;
            if (hash && hash.length > 2) {
                const query = hash.substring(1);
                if (lookupHash) {
                    const params = query.split('&');
                    for(let i = 0; i < params.length; i++){
                        const pos = params[i].indexOf('=');
                        if (pos > 0) {
                            const key = params[i].substring(0, pos);
                            if (key === lookupHash) found = params[i].substring(pos + 1);
                        }
                    }
                }
                if (found) return found;
                if (!found && lookupFromHashIndex > -1) {
                    const language = hash.match(/\/([a-zA-Z-]*)/g);
                    if (!Array.isArray(language)) return undefined;
                    const index = typeof lookupFromHashIndex === 'number' ? lookupFromHashIndex : 0;
                    return language[index]?.replace('/', '');
                }
            }
        }
        return found;
    }
};
let $2e6ea1df9a18d47e$var$hasLocalStorageSupport = null;
const $2e6ea1df9a18d47e$var$localStorageAvailable = ()=>{
    if ($2e6ea1df9a18d47e$var$hasLocalStorageSupport !== null) return $2e6ea1df9a18d47e$var$hasLocalStorageSupport;
    try {
        $2e6ea1df9a18d47e$var$hasLocalStorageSupport = typeof window !== 'undefined' && window.localStorage !== null;
        if (!$2e6ea1df9a18d47e$var$hasLocalStorageSupport) return false;
        const testKey = 'i18next.translate.boo';
        window.localStorage.setItem(testKey, 'foo');
        window.localStorage.removeItem(testKey);
    } catch (e) {
        $2e6ea1df9a18d47e$var$hasLocalStorageSupport = false;
    }
    return $2e6ea1df9a18d47e$var$hasLocalStorageSupport;
};
var $2e6ea1df9a18d47e$var$localStorage = {
    name: 'localStorage',
    // Deconstruct the options object and extract the lookupLocalStorage property
    lookup (_ref) {
        let { lookupLocalStorage: lookupLocalStorage } = _ref;
        if (lookupLocalStorage && $2e6ea1df9a18d47e$var$localStorageAvailable()) return window.localStorage.getItem(lookupLocalStorage) || undefined; // Undefined ensures type consistency with the previous version of this function
        return undefined;
    },
    // Deconstruct the options object and extract the lookupLocalStorage property
    cacheUserLanguage (lng, _ref2) {
        let { lookupLocalStorage: lookupLocalStorage } = _ref2;
        if (lookupLocalStorage && $2e6ea1df9a18d47e$var$localStorageAvailable()) window.localStorage.setItem(lookupLocalStorage, lng);
    }
};
let $2e6ea1df9a18d47e$var$hasSessionStorageSupport = null;
const $2e6ea1df9a18d47e$var$sessionStorageAvailable = ()=>{
    if ($2e6ea1df9a18d47e$var$hasSessionStorageSupport !== null) return $2e6ea1df9a18d47e$var$hasSessionStorageSupport;
    try {
        $2e6ea1df9a18d47e$var$hasSessionStorageSupport = typeof window !== 'undefined' && window.sessionStorage !== null;
        if (!$2e6ea1df9a18d47e$var$hasSessionStorageSupport) return false;
        const testKey = 'i18next.translate.boo';
        window.sessionStorage.setItem(testKey, 'foo');
        window.sessionStorage.removeItem(testKey);
    } catch (e) {
        $2e6ea1df9a18d47e$var$hasSessionStorageSupport = false;
    }
    return $2e6ea1df9a18d47e$var$hasSessionStorageSupport;
};
var $2e6ea1df9a18d47e$var$sessionStorage = {
    name: 'sessionStorage',
    lookup (_ref) {
        let { lookupSessionStorage: lookupSessionStorage } = _ref;
        if (lookupSessionStorage && $2e6ea1df9a18d47e$var$sessionStorageAvailable()) return window.sessionStorage.getItem(lookupSessionStorage) || undefined;
        return undefined;
    },
    cacheUserLanguage (lng, _ref2) {
        let { lookupSessionStorage: lookupSessionStorage } = _ref2;
        if (lookupSessionStorage && $2e6ea1df9a18d47e$var$sessionStorageAvailable()) window.sessionStorage.setItem(lookupSessionStorage, lng);
    }
};
var $2e6ea1df9a18d47e$var$navigator$1 = {
    name: 'navigator',
    lookup (options) {
        const found = [];
        if (typeof navigator !== 'undefined') {
            const { languages: languages, userLanguage: userLanguage, language: language } = navigator;
            if (languages) // chrome only; not an array, so can't use .push.apply instead of iterating
            for(let i = 0; i < languages.length; i++)found.push(languages[i]);
            if (userLanguage) found.push(userLanguage);
            if (language) found.push(language);
        }
        return found.length > 0 ? found : undefined;
    }
};
var $2e6ea1df9a18d47e$var$htmlTag = {
    name: 'htmlTag',
    // Deconstruct the options object and extract the htmlTag property
    lookup (_ref) {
        let { htmlTag: htmlTag } = _ref;
        let found;
        const internalHtmlTag = htmlTag || (typeof document !== 'undefined' ? document.documentElement : null);
        if (internalHtmlTag && typeof internalHtmlTag.getAttribute === 'function') found = internalHtmlTag.getAttribute('lang');
        return found;
    }
};
var $2e6ea1df9a18d47e$var$path = {
    name: 'path',
    // Deconstruct the options object and extract the lookupFromPathIndex property
    lookup (_ref) {
        let { lookupFromPathIndex: lookupFromPathIndex } = _ref;
        if (typeof window === 'undefined') return undefined;
        const language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
        if (!Array.isArray(language)) return undefined;
        const index = typeof lookupFromPathIndex === 'number' ? lookupFromPathIndex : 0;
        return language[index]?.replace('/', '');
    }
};
var $2e6ea1df9a18d47e$var$subdomain = {
    name: 'subdomain',
    lookup (_ref) {
        let { lookupFromSubdomainIndex: lookupFromSubdomainIndex } = _ref;
        // If given get the subdomain index else 1
        const internalLookupFromSubdomainIndex = typeof lookupFromSubdomainIndex === 'number' ? lookupFromSubdomainIndex + 1 : 1;
        // get all matches if window.location. is existing
        // first item of match is the match itself and the second is the first group match which should be the first subdomain match
        // is the hostname no public domain get the or option of localhost
        const language = typeof window !== 'undefined' && window.location?.hostname?.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);
        // if there is no match (null) return undefined
        if (!language) return undefined;
        // return the given group match
        return language[internalLookupFromSubdomainIndex];
    }
};
// some environments, throws when accessing document.cookie
let $2e6ea1df9a18d47e$var$canCookies = false;
try {
    // eslint-disable-next-line no-unused-expressions
    document.cookie;
    $2e6ea1df9a18d47e$var$canCookies = true;
// eslint-disable-next-line no-empty
} catch (e) {}
const $2e6ea1df9a18d47e$var$order = [
    'querystring',
    'cookie',
    'localStorage',
    'sessionStorage',
    'navigator',
    'htmlTag'
];
if (!$2e6ea1df9a18d47e$var$canCookies) $2e6ea1df9a18d47e$var$order.splice(1, 1);
const $2e6ea1df9a18d47e$var$getDefaults = ()=>({
        order: $2e6ea1df9a18d47e$var$order,
        lookupQuerystring: 'lng',
        lookupCookie: 'i18next',
        lookupLocalStorage: 'i18nextLng',
        lookupSessionStorage: 'i18nextLng',
        // cache user language
        caches: [
            'localStorage'
        ],
        excludeCacheFor: [
            'cimode'
        ],
        // cookieMinutes: 10,
        // cookieDomain: 'myDomain'
        convertDetectedLanguage: (l)=>l
    });
class $2e6ea1df9a18d47e$export$2e2bcd8739ae039 {
    constructor(services){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.type = 'languageDetector';
        this.detectors = {};
        this.init(services, options);
    }
    init() {
        let services = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            languageUtils: {}
        };
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        this.services = services;
        this.options = $2e6ea1df9a18d47e$var$defaults(options, this.options || {}, $2e6ea1df9a18d47e$var$getDefaults());
        if (typeof this.options.convertDetectedLanguage === 'string' && this.options.convertDetectedLanguage.indexOf('15897') > -1) this.options.convertDetectedLanguage = (l)=>l.replace('-', '_');
        // backwards compatibility
        if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
        this.i18nOptions = i18nOptions;
        this.addDetector($2e6ea1df9a18d47e$var$cookie$1);
        this.addDetector($2e6ea1df9a18d47e$var$querystring);
        this.addDetector($2e6ea1df9a18d47e$var$localStorage);
        this.addDetector($2e6ea1df9a18d47e$var$sessionStorage);
        this.addDetector($2e6ea1df9a18d47e$var$navigator$1);
        this.addDetector($2e6ea1df9a18d47e$var$htmlTag);
        this.addDetector($2e6ea1df9a18d47e$var$path);
        this.addDetector($2e6ea1df9a18d47e$var$subdomain);
        this.addDetector($2e6ea1df9a18d47e$var$hash);
    }
    addDetector(detector) {
        this.detectors[detector.name] = detector;
        return this;
    }
    detect() {
        let detectionOrder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.options.order;
        let detected = [];
        detectionOrder.forEach((detectorName)=>{
            if (this.detectors[detectorName]) {
                let lookup = this.detectors[detectorName].lookup(this.options);
                if (lookup && typeof lookup === 'string') lookup = [
                    lookup
                ];
                if (lookup) detected = detected.concat(lookup);
            }
        });
        detected = detected.filter((d)=>d !== undefined && d !== null && !$2e6ea1df9a18d47e$var$hasXSS(d)).map((d)=>this.options.convertDetectedLanguage(d));
        if (this.services && this.services.languageUtils && this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
        return detected.length > 0 ? detected[0] : null; // a little backward compatibility
    }
    cacheUserLanguage(lng) {
        let caches = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.options.caches;
        if (!caches) return;
        if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
        caches.forEach((cacheName)=>{
            if (this.detectors[cacheName]) this.detectors[cacheName].cacheUserLanguage(lng, this.options);
        });
    }
}
$2e6ea1df9a18d47e$export$2e2bcd8739ae039.type = 'languageDetector';


var $3b51c8a0c5045117$exports = {};
'use strict';
function $3b51c8a0c5045117$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($3b51c8a0c5045117$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$3b51c8a0c5045117$var$checkDCE();

$3b51c8a0c5045117$exports = (parcelRequire("03XiP"));



var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");

// inlined from the former `void-elements` dependency, so the package has
// zero runtime dependencies. `!doctype`/`!DOCTYPE` are treated as void so a
// doctype parses as a childless node instead of swallowing the document.
const $743f01b2201b991c$var$voidElements = {
    area: true,
    base: true,
    br: true,
    col: true,
    embed: true,
    hr: true,
    img: true,
    input: true,
    link: true,
    meta: true,
    param: true,
    source: true,
    track: true,
    wbr: true,
    '!doctype': true,
    '!DOCTYPE': true
};
const $743f01b2201b991c$var$attrRE = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?("[^"]*"|'[^']*')/g;
function $743f01b2201b991c$var$parseTag(tag) {
    const res = {
        type: 'tag',
        name: '',
        voidElement: false,
        attrs: {},
        children: []
    };
    const tagMatch = tag.match(/<\/?([^\s]+?)[/\s>]/);
    if (tagMatch) {
        res.name = tagMatch[1];
        // void-element lookup stays case sensitive on purpose: react-i18next
        // relies on `<Br>` NOT being treated as a void `<br>` (see 1df0f9d)
        if ($743f01b2201b991c$var$voidElements[tagMatch[1]] || tag.charAt(tag.length - 2) === '/') res.voidElement = true;
        // handle comment tag
        if (res.name.startsWith('!--')) {
            const endIndex = tag.indexOf('-->');
            return {
                type: 'comment',
                comment: endIndex !== -1 ? tag.slice(4, endIndex) : ''
            };
        }
    }
    const reg = new RegExp($743f01b2201b991c$var$attrRE);
    let result = null;
    for(;;){
        result = reg.exec(tag);
        if (result === null) break;
        if (!result[0].trim()) continue;
        if (result[1]) {
            const attr = result[1].trim();
            // boolean attributes carry `null` so stringify can render them bare
            // (`<input disabled/>` instead of `<input disabled=""/>`)
            let arr = [
                attr,
                null
            ];
            const eq = attr.indexOf('=');
            if (eq > -1) // split at the first `=` only, so `data-x=a=b` keeps its full value
            arr = [
                attr.slice(0, eq),
                attr.slice(eq + 1)
            ];
            res.attrs[arr[0]] = arr[1];
            reg.lastIndex--;
        } else if (result[2]) res.attrs[result[2]] = result[3].trim().substring(1, result[3].length - 1);
    }
    return res;
}
// comments are matched as a whole (so `>` inside them is fine), everything
// else tag-shaped is matched by the second alternative
const $743f01b2201b991c$var$tagRE = /<!--[\s\S]*?-->|<[a-zA-Z0-9\-!/](?:"[^"]*"|'[^']*'|[^'">])*>/g;
const $743f01b2201b991c$var$tagNameRE = /<\/?([^\s]+?)[/\s>]/;
const $743f01b2201b991c$var$whitespaceRE = /^\s*$/;
// tags whose content is raw text: nothing inside them is markup
const $743f01b2201b991c$var$rawTextRE = /^(script|style)$/i;
// placeholder for `<` of tags rejected by options.allowedTags; restored to a
// literal `<` in text/attr/comment content after parsing (U+0000 cannot appear
// in sane input, and a collision would merely render as an extra `<`)
const $743f01b2201b991c$var$sentinel = '\u0000';
// re-used obj for quick lookups of components
const $743f01b2201b991c$var$empty = Object.create(null);
function $743f01b2201b991c$var$restoreSentinels(nodes) {
    nodes.forEach(function(node) {
        if (node.type === 'text') {
            node.content = node.content.split($743f01b2201b991c$var$sentinel).join('<');
            return;
        }
        if (node.type === 'comment') {
            node.comment = node.comment.split($743f01b2201b991c$var$sentinel).join('<');
            return;
        }
        for(const key in node.attrs){
            const value = node.attrs[key];
            if (typeof value === 'string' && value.indexOf($743f01b2201b991c$var$sentinel) > -1) node.attrs[key] = value.split($743f01b2201b991c$var$sentinel).join('<');
        }
        if (node.children.length) $743f01b2201b991c$var$restoreSentinels(node.children);
    });
}
function $743f01b2201b991c$export$98e6a39c04603d36(html, options) {
    const components = options && options.components || $743f01b2201b991c$var$empty;
    const allowedTags = options && options.allowedTags;
    let restoreNeeded = false;
    if (allowedTags) {
        const isAllowed = typeof allowedTags === 'function' ? allowedTags : function(name) {
            return allowedTags.indexOf(name) > -1;
        };
        // neutralize tags whose name is not allowed, so they parse as text.
        // on a disallowed match only the leading `<` is escaped and scanning
        // resumes right after it, so a valid tag glued into the same match
        // (e.g. `<bold>` inside `<10, <20, and <bold>`) still gets recognized
        let out = '';
        let pos = 0;
        $743f01b2201b991c$var$tagRE.lastIndex = 0;
        let am;
        while(am = $743f01b2201b991c$var$tagRE.exec(html)){
            const tag = am[0];
            out += html.slice(pos, am.index);
            const nameMatch = tag.match($743f01b2201b991c$var$tagNameRE);
            if (tag.startsWith('<!--') || nameMatch && isAllowed(nameMatch[1])) {
                out += tag;
                pos = am.index + tag.length;
            } else {
                restoreNeeded = true;
                out += $743f01b2201b991c$var$sentinel;
                pos = am.index + 1;
                $743f01b2201b991c$var$tagRE.lastIndex = pos;
            }
        }
        html = out + html.slice(pos);
    }
    const result = [];
    const arr = [];
    let current;
    let level = -1;
    let inComponent = false;
    // while parsing raw-text content (script/style), tag-looking matches
    // before this index belong to the content and must be skipped
    let rawUntil = 0;
    // lazily created lowercase copy for case-insensitive raw-text close-tag search
    let htmlLower;
    // handle text at top level
    if (html.indexOf('<') !== 0) {
        const end = html.indexOf('<');
        result.push({
            type: 'text',
            content: end === -1 ? html : html.substring(0, end)
        });
    }
    // collect matches with an exec loop instead of matchAll to keep ES5 API compat
    const matches = [];
    let m;
    while(m = $743f01b2201b991c$var$tagRE.exec(html))matches.push(m);
    matches.forEach(function(match, i) {
        const tag = match[0];
        if (!tag) return;
        // comments match as a whole; their content must not trigger the
        // mismatched-bracket split below
        if (tag.startsWith('<!--')) return;
        // count brackets outside quoted attribute values, so `<` inside an
        // attribute (e.g. title="1 < 2") can't trigger a bogus split
        let lts = 0;
        let gts = 0;
        let secondLt = -1;
        let quote = null;
        for(let j = 0; j < tag.length; j++){
            const c = tag.charAt(j);
            if (quote) {
                if (c === quote) quote = null;
            } else if (c === '"' || c === "'") quote = c;
            else if (c === '<') {
                lts++;
                if (lts === 2) secondLt = j;
            } else if (c === '>') gts++;
        }
        // only split when the remainder is itself a valid tag start; otherwise
        // a fragment like `< <!-->` desyncs the string-level isComment check
        // from parseTag's name-based comment detection and crashes the walker
        const validSplit = secondLt > -1 && /[a-zA-Z0-9\-!/]/.test(tag.charAt(secondLt + 1));
        if (lts > gts && validSplit) {
            const firstPart = tag.substring(0, secondLt);
            const secondPart = tag.substring(firstPart.length);
            matches[i][0] = secondPart;
            matches[i].index += firstPart.length;
        }
    });
    matches.forEach(function(match, i) {
        const tag = match[0];
        if (!tag) return;
        const index = match.index;
        if (index < rawUntil) return;
        if (inComponent) {
            if (tag !== '</' + current.name + '>') return;
            else inComponent = false;
        }
        const isOpen = tag.charAt(1) !== '/';
        const isComment = tag.startsWith('<!--');
        const start = index + tag.length;
        const nextChar = html.charAt(start);
        const nextMatch = matches[i + 1];
        let isText;
        if (nextChar === '<' && nextMatch) {
            const nextTag = html.substring(start, nextMatch.index);
            isText = nextTag.split('<').length > nextTag.split('>').length;
        }
        let parent;
        if (isComment) {
            const comment = $743f01b2201b991c$var$parseTag(tag);
            // if we're at root, push new base node
            if (level < 0) {
                result.push(comment);
                return result;
            }
            parent = arr[level];
            parent.children.push(comment);
            const text = html.slice(start, nextMatch ? nextMatch.index : undefined);
            if (text.length > 0) parent.children.push({
                type: 'text',
                content: text
            });
            return result;
        }
        if (isOpen) {
            level++;
            current = $743f01b2201b991c$var$parseTag(tag);
            if (current.type === 'tag' && components[current.name]) {
                current.type = 'component';
                inComponent = true;
            }
            let isRawText = false;
            if (!inComponent && !current.voidElement && $743f01b2201b991c$var$rawTextRE.test(current.name)) {
                // raw-text element: everything up to the matching close tag is one
                // text child, regardless of what it looks like
                isRawText = true;
                htmlLower || (htmlLower = html.toLowerCase());
                const closeIndex = htmlLower.indexOf('</' + current.name.toLowerCase() + '>', start);
                const contentEnd = closeIndex === -1 ? html.length : closeIndex;
                const content = html.slice(start, contentEnd);
                if (content) current.children.push({
                    type: 'text',
                    content: content
                });
                rawUntil = contentEnd;
            }
            if (!current.voidElement && !inComponent && !isRawText && nextChar && nextChar !== '<') // text content runs to the next actual tag match; stray `<`
            // characters in between are part of the text
            current.children.push({
                type: 'text',
                content: html.slice(start, nextMatch ? nextMatch.index : undefined)
            });
            // if we're at root, push new base node
            if (level === 0) result.push(current);
            parent = arr[level - 1];
            if (parent) parent.children.push(current);
            arr[level] = current;
        }
        if (!isOpen || current.voidElement) {
            if (level > -1 && (current.voidElement || current.name === tag.slice(2, -1))) {
                level--;
                // move current up a level to match the end tag
                current = level === -1 ? result : arr[level];
            }
            if (!inComponent && (nextChar !== '<' || isText) && nextChar) {
                // trailing text node
                // if we're at the root, push a base text node. otherwise add as
                // a child to the current node.
                parent = level === -1 ? result : arr[level].children;
                // the text node runs to the next actual tag match; -1 means
                // there's no tag after it (trailing text)
                const end = nextMatch ? nextMatch.index : -1;
                let content = html.slice(start, end === -1 ? undefined : end);
                // if a node is nothing but whitespace, collapse it as the spec states:
                // https://www.w3.org/TR/html4/struct/text.html#h-9.1
                if ($743f01b2201b991c$var$whitespaceRE.test(content)) content = ' ';
                // don't add whitespace-only text nodes if they would be trailing text nodes
                // or if they would be leading whitespace-only text nodes:
                //  * end > -1 indicates this is not a trailing text node
                //  * leading node is when level is -1 and parent has length 0
                if (end > -1 && level + parent.length >= 0 || content !== ' ') parent.push({
                    type: 'text',
                    content: content
                });
            }
        }
    });
    if (restoreNeeded) $743f01b2201b991c$var$restoreSentinels(result);
    return result;
}
function $743f01b2201b991c$var$attrString(attrs) {
    const buff = [];
    for(const key in attrs)if (attrs[key] === null) // boolean attribute, render bare
    buff.push(key);
    else // escape double quotes so values parsed from single-quoted or
    // multiline attributes can't break out of the generated markup
    buff.push(key + '="' + String(attrs[key]).replace(/"/g, '&quot;') + '"');
    if (!buff.length) return '';
    return ' ' + buff.join(' ');
}
function $743f01b2201b991c$var$stringifyNode(buff, doc) {
    switch(doc.type){
        case 'text':
            return buff + doc.content;
        case 'tag':
            {
                // a doctype is void but must not self-close: `<!DOCTYPE html>` not `<!DOCTYPE html/>`
                const tagEnd = doc.voidElement && doc.name.toLowerCase() !== '!doctype' ? '/>' : '>';
                buff += '<' + doc.name + (doc.attrs ? $743f01b2201b991c$var$attrString(doc.attrs) : '') + tagEnd;
                if (doc.voidElement) return buff;
                return buff + doc.children.reduce($743f01b2201b991c$var$stringifyNode, '') + '</' + doc.name + '>';
            }
        case 'comment':
            buff += '<!--' + doc.comment + '-->';
            return buff;
    }
}
function $743f01b2201b991c$export$fac44ee5b035f737(doc) {
    return doc.reduce(function(token, rootEl) {
        return token + $743f01b2201b991c$var$stringifyNode('', rootEl);
    }, '');
}
var $743f01b2201b991c$export$2e2bcd8739ae039 = {
    parse: $743f01b2201b991c$export$98e6a39c04603d36,
    stringify: $743f01b2201b991c$export$fac44ee5b035f737
};


const $1e83742382a0d73f$export$c106dd0671a0fc2d = (i18n, code, msg, rest)=>{
    const args = [
        msg,
        {
            code: code,
            ...rest || {}
        }
    ];
    if (i18n?.services?.logger?.forward) return i18n.services.logger.forward(args, 'warn', 'react-i18next::', true);
    if ($1e83742382a0d73f$export$844ec244b1367d54(args[0])) args[0] = `react-i18next:: ${args[0]}`;
    if (i18n?.services?.logger?.warn) i18n.services.logger.warn(...args);
    else if (console?.warn) console.warn(...args);
};
const $1e83742382a0d73f$var$alreadyWarned = {};
const $1e83742382a0d73f$export$5b28268982f175ba = (i18n, code, msg, rest)=>{
    if ($1e83742382a0d73f$export$844ec244b1367d54(msg) && $1e83742382a0d73f$var$alreadyWarned[msg]) return;
    if ($1e83742382a0d73f$export$844ec244b1367d54(msg)) $1e83742382a0d73f$var$alreadyWarned[msg] = new Date();
    $1e83742382a0d73f$export$c106dd0671a0fc2d(i18n, code, msg, rest);
};
const $1e83742382a0d73f$var$loadedClb = (i18n, cb)=>()=>{
        if (i18n.isInitialized) cb();
        else {
            const initialized = ()=>{
                setTimeout(()=>{
                    i18n.off('initialized', initialized);
                }, 0);
                cb();
            };
            i18n.on('initialized', initialized);
        }
    };
const $1e83742382a0d73f$export$83be934b53fff43b = (i18n, ns, cb)=>{
    i18n.loadNamespaces(ns, $1e83742382a0d73f$var$loadedClb(i18n, cb));
};
const $1e83742382a0d73f$export$8cd7e7a54fa865bc = (i18n, lng, ns, cb)=>{
    if ($1e83742382a0d73f$export$844ec244b1367d54(ns)) ns = [
        ns
    ];
    if (i18n.options.preload && i18n.options.preload.indexOf(lng) > -1) return $1e83742382a0d73f$export$83be934b53fff43b(i18n, ns, cb);
    ns.forEach((n)=>{
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $1e83742382a0d73f$var$loadedClb(i18n, cb));
};
const $1e83742382a0d73f$export$93d9ee97c1ad3f31 = (ns, i18n, options = {})=>{
    if (!i18n.languages || !i18n.languages.length) {
        $1e83742382a0d73f$export$5b28268982f175ba(i18n, 'NO_LANGUAGES', 'i18n.languages were undefined or empty', {
            languages: i18n.languages
        });
        return true;
    }
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: (i18nInstance, loadNotPending)=>{
            if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
};
const $1e83742382a0d73f$export$be63e0664592e141 = (Component)=>Component.displayName || Component.name || ($1e83742382a0d73f$export$844ec244b1367d54(Component) && Component.length > 0 ? Component : 'Unknown');
const $1e83742382a0d73f$export$844ec244b1367d54 = (obj)=>typeof obj === 'string';
const $1e83742382a0d73f$export$a6cdc56e425d0d0a = (obj)=>typeof obj === 'object' && obj !== null;


const $125dc2a89174050f$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
const $125dc2a89174050f$var$htmlEntities = {
    '&amp;': '&',
    '&#38;': '&',
    '&lt;': '<',
    '&#60;': '<',
    '&gt;': '>',
    '&#62;': '>',
    '&apos;': "'",
    '&#39;': "'",
    '&quot;': '"',
    '&#34;': '"',
    '&nbsp;': '\u00A0',
    '&#160;': '\u00A0',
    '&copy;': "\xa9",
    '&#169;': "\xa9",
    '&reg;': "\xae",
    '&#174;': "\xae",
    '&hellip;': "\u2026",
    '&#8230;': "\u2026",
    '&#x2F;': '/',
    '&#47;': '/'
};
const $125dc2a89174050f$var$unescapeHtmlEntity = (m)=>$125dc2a89174050f$var$htmlEntities[m];
const $125dc2a89174050f$export$e8bacd2802a88316 = (text)=>text.replace($125dc2a89174050f$var$matchHtmlEntity, $125dc2a89174050f$var$unescapeHtmlEntity);


let $b6eb3be40d97793b$var$defaultOptions = {
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: '',
    transKeepBasicHtmlNodesFor: [
        'br',
        'strong',
        'i',
        'p'
    ],
    useSuspense: true,
    unescape: $125dc2a89174050f$export$e8bacd2802a88316,
    transDefaultProps: undefined
};
const $b6eb3be40d97793b$export$2e2366488d12e20d = (options = {})=>{
    $b6eb3be40d97793b$var$defaultOptions = {
        ...$b6eb3be40d97793b$var$defaultOptions,
        ...options
    };
};
const $b6eb3be40d97793b$export$212bb2fc580a90a8 = ()=>$b6eb3be40d97793b$var$defaultOptions;


let $854d86f3d62aada7$var$i18nInstance;
const $854d86f3d62aada7$export$a039134f2fc7e0 = (instance)=>{
    $854d86f3d62aada7$var$i18nInstance = instance;
};
const $854d86f3d62aada7$export$64af334f494c2f47 = ()=>$854d86f3d62aada7$var$i18nInstance;



const $e689a98474a69549$var$hasChildren = (node, checkLength)=>{
    if (!node) return false;
    const base = node.props?.children ?? node.children;
    if (checkLength) return base.length > 0;
    return !!base;
};
const $e689a98474a69549$var$getChildren = (node)=>{
    if (!node) return [];
    const children = node.props?.children ?? node.children;
    return node.props?.i18nIsDynamicList ? $e689a98474a69549$var$getAsArray(children) : children;
};
const $e689a98474a69549$var$hasValidReactChildren = (children)=>$e689a98474a69549$var$getAsArray(children).every((0, $5E6i4.isValidElement));
const $e689a98474a69549$var$getAsArray = (data)=>Array.isArray(data) ? data : [
        data
    ];
const $e689a98474a69549$var$mergeProps = (source, target)=>{
    const newTarget = {
        ...target
    };
    newTarget.props = {
        ...target.props,
        ...source.props
    };
    return newTarget;
};
const $e689a98474a69549$var$getValuesFromChildren = (children)=>{
    const values = {};
    if (!children) return values;
    const getData = (childs)=>{
        const childrenArray = $e689a98474a69549$var$getAsArray(childs);
        childrenArray.forEach((child)=>{
            if ((0, $1e83742382a0d73f$export$844ec244b1367d54)(child)) return;
            if ($e689a98474a69549$var$hasChildren(child)) getData($e689a98474a69549$var$getChildren(child));
            else if ((0, $1e83742382a0d73f$export$a6cdc56e425d0d0a)(child) && !(0, $5E6i4.isValidElement)(child)) Object.assign(values, child);
        });
    };
    getData(children);
    return values;
};
const $e689a98474a69549$export$4f7a36dd898f1267 = (children, i18nOptions, i18n, i18nKey)=>{
    if (!children) return '';
    let stringNode = '';
    const childrenArray = $e689a98474a69549$var$getAsArray(children);
    const keepArray = i18nOptions?.transSupportBasicHtmlNodes ? i18nOptions.transKeepBasicHtmlNodesFor ?? [] : [];
    childrenArray.forEach((child, childIndex)=>{
        if ((0, $1e83742382a0d73f$export$844ec244b1367d54)(child)) {
            stringNode += `${child}`;
            return;
        }
        if ((0, $5E6i4.isValidElement)(child)) {
            const { props: props, type: type } = child;
            const childPropsCount = Object.keys(props).length;
            const shouldKeepChild = keepArray.indexOf(type) > -1;
            const childChildren = props.children;
            if (!childChildren && shouldKeepChild && !childPropsCount) {
                stringNode += `<${type}/>`;
                return;
            }
            if (!childChildren && (!shouldKeepChild || childPropsCount) || props.i18nIsDynamicList) {
                stringNode += `<${childIndex}></${childIndex}>`;
                return;
            }
            if (shouldKeepChild && childPropsCount <= 1) {
                const cnt = (0, $1e83742382a0d73f$export$844ec244b1367d54)(childChildren) ? childChildren : $e689a98474a69549$export$4f7a36dd898f1267(childChildren, i18nOptions, i18n, i18nKey);
                stringNode += `<${type}>${cnt}</${type}>`;
                return;
            }
            const content = $e689a98474a69549$export$4f7a36dd898f1267(childChildren, i18nOptions, i18n, i18nKey);
            stringNode += `<${childIndex}>${content}</${childIndex}>`;
            return;
        }
        if (child === null) {
            (0, $1e83742382a0d73f$export$c106dd0671a0fc2d)(i18n, 'TRANS_NULL_VALUE', `Passed in a null value as child`, {
                i18nKey: i18nKey
            });
            return;
        }
        if ((0, $1e83742382a0d73f$export$a6cdc56e425d0d0a)(child)) {
            const { format: format, ...clone } = child;
            const keys = Object.keys(clone);
            if (keys.length === 1) {
                const value = format ? `${keys[0]}, ${format}` : keys[0];
                stringNode += `{{${value}}}`;
                return;
            }
            (0, $1e83742382a0d73f$export$c106dd0671a0fc2d)(i18n, 'TRANS_INVALID_OBJ', `Invalid child - Object should only have keys {{ value, format }} (format is optional).`, {
                i18nKey: i18nKey,
                child: child
            });
            return;
        }
        (0, $1e83742382a0d73f$export$c106dd0671a0fc2d)(i18n, 'TRANS_INVALID_VAR', `Passed in a variable like {number} - pass variables for interpolation as full objects like {{number}}.`, {
            i18nKey: i18nKey,
            child: child
        });
    });
    return stringNode;
};
const $e689a98474a69549$var$renderNodes = (children, knownComponentsMap, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape)=>{
    if (targetString === '') return [];
    const keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    const emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.map((keep)=>`<${keep}`).join('|')).test(targetString);
    if (!children && !knownComponentsMap && !emptyChildrenButNeedsHandling && !shouldUnescape) return [
        targetString
    ];
    const data = knownComponentsMap ?? {};
    const getData = (childs)=>{
        const childrenArray = $e689a98474a69549$var$getAsArray(childs);
        childrenArray.forEach((child)=>{
            if ((0, $1e83742382a0d73f$export$844ec244b1367d54)(child)) return;
            if ($e689a98474a69549$var$hasChildren(child)) getData($e689a98474a69549$var$getChildren(child));
            else if ((0, $1e83742382a0d73f$export$a6cdc56e425d0d0a)(child) && !(0, $5E6i4.isValidElement)(child)) Object.assign(data, child);
        });
    };
    getData(children);
    const knownNames = Object.keys(data);
    const allowedTags = (name)=>/^\d+$/.test(name) || keepArray.indexOf(name) > -1 || knownNames.indexOf(name) > -1;
    const ast = (0, $743f01b2201b991c$export$2e2bcd8739ae039).parse(`<0>${targetString}</0>`, {
        allowedTags: allowedTags
    });
    const opts = {
        ...data,
        ...combinedTOpts
    };
    const renderInner = (child, node, rootReactNode)=>{
        const childs = $e689a98474a69549$var$getChildren(child);
        const mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $e689a98474a69549$var$hasValidReactChildren(childs) && mappedChildren.length === 0 || child.props?.i18nIsDynamicList ? childs : mappedChildren;
    };
    const pushTranslatedJSX = (child, inner, mem, i, isVoid)=>{
        if (child.dummy) {
            child.children = inner;
            mem.push((0, $5E6i4.cloneElement)(child, {
                key: i
            }, isVoid ? undefined : inner));
        } else mem.push(...(0, $5E6i4.Children).map([
            child
        ], (c)=>{
            if (c.type === (0, $5E6i4.Fragment) || c.props?.i18nIsDynamicList !== undefined) {
                const freshProps = {
                    key: i
                };
                if (c && c.props) Object.keys(c.props).forEach((k)=>{
                    if (k === 'children' || k === 'i18nIsDynamicList') return;
                    freshProps[k] = c.props[k];
                });
                return (0, $5E6i4.createElement)(c.type, freshProps, isVoid ? null : inner);
            }
            const override = {
                key: i
            };
            if (c && c.props) Object.keys(c.props).forEach((k)=>{
                if (k === 'ref' || k === 'children') return;
                override[k] = c.props[k];
            });
            return (0, $5E6i4.cloneElement)(c, override, isVoid ? null : inner);
        }));
    };
    const mapAST = (reactNode, astNode, rootReactNode)=>{
        const reactNodes = $e689a98474a69549$var$getAsArray(reactNode);
        const astNodes = $e689a98474a69549$var$getAsArray(astNode);
        const keepTagOccurrence = {};
        return astNodes.reduce((mem, node, i)=>{
            const translationContent = node.children?.[0]?.content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === 'tag') {
                let tmp = reactNodes[parseInt(node.name, 10)];
                if (!tmp && knownComponentsMap) tmp = knownComponentsMap[node.name];
                if (rootReactNode.length === 1 && !tmp) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                const props = {
                    ...node.attrs
                };
                if (shouldUnescape) Object.keys(props).forEach((p)=>{
                    const val = props[p];
                    if ((0, $1e83742382a0d73f$export$844ec244b1367d54)(val)) props[p] = (0, $125dc2a89174050f$export$e8bacd2802a88316)(val);
                });
                const child = Object.keys(props).length !== 0 ? $e689a98474a69549$var$mergeProps({
                    props: props
                }, tmp) : tmp;
                const isElement = (0, $5E6i4.isValidElement)(child);
                const isValidTranslationWithChildren = isElement && $e689a98474a69549$var$hasChildren(node, true) && !node.voidElement;
                const isEmptyTransWithHTML = emptyChildrenButNeedsHandling && (0, $1e83742382a0d73f$export$a6cdc56e425d0d0a)(child) && child.dummy && !isElement;
                const isKnownComponent = (0, $1e83742382a0d73f$export$a6cdc56e425d0d0a)(knownComponentsMap) && Object.hasOwnProperty.call(knownComponentsMap, node.name);
                if ((0, $1e83742382a0d73f$export$844ec244b1367d54)(child)) {
                    const value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($e689a98474a69549$var$hasChildren(child) || isValidTranslationWithChildren) {
                    const inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    const inner = mapAST(reactNodes, node.children, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        const inner = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, inner, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $5E6i4.createElement)(node.name, {
                            key: `${node.name}-${i}`
                        }));
                        else {
                            const occurrence = keepTagOccurrence[node.name] || 0;
                            keepTagOccurrence[node.name] = occurrence + 1;
                            let matched;
                            let seen = 0;
                            for(let r = 0; r < reactNodes.length; r += 1){
                                const rn = reactNodes[r];
                                if ((0, $5E6i4.isValidElement)(rn) && rn.type === node.name) {
                                    if (seen === occurrence) {
                                        matched = rn;
                                        break;
                                    }
                                    seen += 1;
                                }
                            }
                            const innerScope = matched ? $e689a98474a69549$var$getAsArray($e689a98474a69549$var$getChildren(matched)) : reactNodes;
                            const inner = mapAST(innerScope, node.children, rootReactNode);
                            mem.push((0, $5E6i4.createElement)(node.name, {
                                key: `${node.name}-${i}`
                            }, inner));
                        }
                    } else if (node.voidElement) mem.push(`<${node.name} />`);
                    else {
                        const inner = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push(`<${node.name}>${inner}</${node.name}>`);
                    }
                } else if ((0, $1e83742382a0d73f$export$a6cdc56e425d0d0a)(child) && !isElement) {
                    const content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else pushTranslatedJSX(child, translationContent, mem, i, node.children.length !== 1 || !translationContent);
            } else if (node.type === 'text') {
                const wrapTextNodes = i18nOptions.transWrapTextNodes;
                const unescapeFn = typeof i18nOptions.unescape === 'function' ? i18nOptions.unescape : (0, $b6eb3be40d97793b$export$212bb2fc580a90a8)().unescape;
                const content = shouldUnescape ? unescapeFn(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $5E6i4.createElement)(wrapTextNodes, {
                    key: `${node.name}-${i}`
                }, content));
                else mem.push(content);
            }
            return mem;
        }, []);
    };
    const result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $e689a98474a69549$var$getAsArray(children || []));
    return $e689a98474a69549$var$getChildren(result[0]);
};
const $e689a98474a69549$var$fixComponentProps = (component, index, translation)=>{
    const componentKey = component.key || index;
    const comp = (0, $5E6i4.cloneElement)(component, {
        key: componentKey
    });
    if (!comp.props || !comp.props.children || translation.indexOf(`${index}/>`) < 0 && translation.indexOf(`${index} />`) < 0) return comp;
    function Componentized() {
        return (0, $5E6i4.createElement)((0, $5E6i4.Fragment), null, comp);
    }
    return (0, $5E6i4.createElement)(Componentized, {
        key: componentKey
    });
};
const $e689a98474a69549$var$generateArrayComponents = (components, translation)=>components.map((c, index)=>$e689a98474a69549$var$fixComponentProps(c, index, translation));
const $e689a98474a69549$var$generateObjectComponents = (components, translation)=>{
    const componentMap = {};
    Object.keys(components).forEach((c)=>{
        Object.assign(componentMap, {
            [c]: $e689a98474a69549$var$fixComponentProps(components[c], c, translation)
        });
    });
    return componentMap;
};
const $e689a98474a69549$var$generateComponents = (components, translation, i18n, i18nKey)=>{
    if (!components) return null;
    if (Array.isArray(components)) return $e689a98474a69549$var$generateArrayComponents(components, translation);
    if ((0, $1e83742382a0d73f$export$a6cdc56e425d0d0a)(components)) return $e689a98474a69549$var$generateObjectComponents(components, translation);
    (0, $1e83742382a0d73f$export$5b28268982f175ba)(i18n, 'TRANS_INVALID_COMPONENTS', `<Trans /> "components" prop expects an object or array`, {
        i18nKey: i18nKey
    });
    return null;
};
const $e689a98474a69549$var$isComponentsMap = (object)=>{
    if (!(0, $1e83742382a0d73f$export$a6cdc56e425d0d0a)(object)) return false;
    if (Array.isArray(object)) return false;
    return Object.keys(object).reduce((acc, key)=>acc && Number.isNaN(Number.parseFloat(key)), true);
};
function $e689a98474a69549$export$8d6a9236f2e3f2ce({ children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps }) {
    const i18n = i18nFromProps || (0, $854d86f3d62aada7$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $1e83742382a0d73f$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', `Trans: You need to pass in an i18next instance using initReactI18next or by passing it via props or context. In monorepo setups, make sure there is only one instance of react-i18next.`, {
            i18nKey: i18nKey
        });
        return children;
    }
    const t = tFromProps || i18n.t.bind(i18n) || ((k)=>k);
    const reactI18nextOptions = {
        ...(0, $b6eb3be40d97793b$export$212bb2fc580a90a8)(),
        ...i18n.options?.react
    };
    let namespaces = ns || (t.ns ? undefined : i18n.options?.defaultNS || 'translation');
    if ((0, $1e83742382a0d73f$export$844ec244b1367d54)(namespaces)) namespaces = [
        namespaces
    ];
    const { transDefaultProps: transDefaultProps } = reactI18nextOptions;
    const mergedTOptions = transDefaultProps?.tOptions ? {
        ...transDefaultProps.tOptions,
        ...tOptions
    } : tOptions;
    const mergedShouldUnescape = shouldUnescape ?? transDefaultProps?.shouldUnescape;
    const mergedValues = transDefaultProps?.values ? {
        ...transDefaultProps.values,
        ...values
    } : values;
    const mergedComponents = transDefaultProps?.components ? {
        ...transDefaultProps.components,
        ...components
    } : components;
    const nodeAsString = $e689a98474a69549$export$4f7a36dd898f1267(children, reactI18nextOptions, i18n, i18nKey);
    const defaultValue = defaults || mergedTOptions?.defaultValue || nodeAsString || reactI18nextOptions.transEmptyNodeValue || (typeof i18nKey === 'function' ? (0, $f5efe749b20fa0f3$export$ec2cccc18ab4c2ae)(i18nKey) : i18nKey);
    const { hashTransKey: hashTransKey } = reactI18nextOptions;
    const key = i18nKey || (hashTransKey ? hashTransKey(nodeAsString || defaultValue) : nodeAsString || defaultValue);
    if (i18n.options?.interpolation?.defaultVariables) values = mergedValues && Object.keys(mergedValues).length > 0 ? {
        ...mergedValues,
        ...i18n.options.interpolation.defaultVariables
    } : {
        ...i18n.options.interpolation.defaultVariables
    };
    else values = mergedValues;
    const valuesFromChildren = $e689a98474a69549$var$getValuesFromChildren(children);
    if (valuesFromChildren && typeof valuesFromChildren.count === 'number' && count === undefined) count = valuesFromChildren.count;
    const interpolationOverride = values || count !== undefined && !i18n.options?.interpolation?.alwaysFormat || !children ? mergedTOptions.interpolation : {
        interpolation: {
            ...mergedTOptions.interpolation,
            prefix: '#$?',
            suffix: '?$#'
        }
    };
    const combinedTOpts = {
        ...mergedTOptions,
        context: context || mergedTOptions.context,
        count: count,
        ...values,
        ...interpolationOverride,
        defaultValue: defaultValue,
        ns: namespaces
    };
    let translation = key ? t(key, combinedTOpts) : defaultValue;
    if (translation === key && defaultValue) translation = defaultValue;
    const generatedComponents = $e689a98474a69549$var$generateComponents(mergedComponents, translation, i18n, i18nKey);
    let indexedChildren = generatedComponents || children;
    let componentsMap = null;
    if ($e689a98474a69549$var$isComponentsMap(generatedComponents)) {
        componentsMap = generatedComponents;
        indexedChildren = children;
    }
    const content = $e689a98474a69549$var$renderNodes(indexedChildren, componentsMap, translation, i18n, reactI18nextOptions, combinedTOpts, mergedShouldUnescape);
    const useAsParent = parent ?? reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $5E6i4.createElement)(useAsParent, additionalProps, content) : content;
}



var $5E6i4 = parcelRequire("5E6i4");




const $f7af809e3f6ff502$export$ae7e14d40d89f296 = {
    type: '3rdParty',
    init (instance) {
        (0, $b6eb3be40d97793b$export$2e2366488d12e20d)(instance.options.react);
        (0, $854d86f3d62aada7$export$a039134f2fc7e0)(instance);
    }
};


const $7907f3439c90332a$export$5603ab5ced17ce64 = (0, $5E6i4.createContext)();
class $7907f3439c90332a$export$ea171b67e3820290 {
    constructor(){
        this.usedNamespaces = {};
    }
    addUsedNamespaces(namespaces) {
        namespaces.forEach((ns)=>{
            if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
        });
    }
    getUsedNamespaces() {
        return Object.keys(this.usedNamespaces);
    }
}
const $7907f3439c90332a$export$30ff0342ccf735a = (ForComponent)=>async (ctx)=>{
        const componentsInitialProps = await ForComponent.getInitialProps?.(ctx) ?? {};
        const i18nInitialProps = $7907f3439c90332a$export$704200e5d0b9e8f();
        return {
            ...componentsInitialProps,
            ...i18nInitialProps
        };
    };
const $7907f3439c90332a$export$704200e5d0b9e8f = ()=>{
    const i18n = (0, $854d86f3d62aada7$export$64af334f494c2f47)();
    if (!i18n) {
        console.warn('react-i18next:: getInitialProps: You will need to pass in an i18next instance by using initReactI18next');
        return {};
    }
    const namespaces = i18n.reportNamespaces?.getUsedNamespaces() ?? [];
    const ret = {};
    const initialI18nStore = {};
    i18n.languages.forEach((l)=>{
        initialI18nStore[l] = {};
        namespaces.forEach((ns)=>{
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
};


function $88057c7a4a6367ee$export$8d6a9236f2e3f2ce({ children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps }) {
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $5E6i4.useContext)((0, $7907f3439c90332a$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $854d86f3d62aada7$export$64af334f494c2f47)();
    const t = tFromProps || i18n?.t.bind(i18n);
    return (0, $e689a98474a69549$export$8d6a9236f2e3f2ce)({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || (t?.ns ? undefined : defaultNSFromContext || i18n?.options?.defaultNS),
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape,
        ...additionalProps
    });
}




var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");


class $7ae36fb432a911d7$export$aa9e222d9ffc5d1b extends Error {
    constructor(message, position, translationString){
        super(message);
        this.name = 'TranslationParserError';
        this.position = position;
        this.translationString = translationString;
        if (Error.captureStackTrace) Error.captureStackTrace(this, $7ae36fb432a911d7$export$aa9e222d9ffc5d1b);
    }
}


const $1f52196153854093$var$commonEntities = {
    '&nbsp;': '\u00A0',
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&apos;': "'",
    '&copy;': "\xa9",
    '&reg;': "\xae",
    '&trade;': "\u2122",
    '&hellip;': "\u2026",
    '&ndash;': "\u2013",
    '&mdash;': "\u2014",
    '&lsquo;': '\u2018',
    '&rsquo;': '\u2019',
    '&sbquo;': '\u201A',
    '&ldquo;': '\u201C',
    '&rdquo;': '\u201D',
    '&bdquo;': '\u201E',
    '&dagger;': "\u2020",
    '&Dagger;': "\u2021",
    '&bull;': "\u2022",
    '&prime;': "\u2032",
    '&Prime;': "\u2033",
    '&lsaquo;': "\u2039",
    '&rsaquo;': "\u203A",
    '&sect;': "\xa7",
    '&para;': "\xb6",
    '&middot;': "\xb7",
    '&ensp;': '\u2002',
    '&emsp;': '\u2003',
    '&thinsp;': '\u2009',
    '&euro;': "\u20AC",
    '&pound;': "\xa3",
    '&yen;': "\xa5",
    '&cent;': "\xa2",
    '&curren;': "\xa4",
    '&times;': "\xd7",
    '&divide;': "\xf7",
    '&minus;': "\u2212",
    '&plusmn;': "\xb1",
    '&ne;': "\u2260",
    '&le;': "\u2264",
    '&ge;': "\u2265",
    '&asymp;': "\u2248",
    '&equiv;': "\u2261",
    '&infin;': "\u221E",
    '&int;': "\u222B",
    '&sum;': "\u2211",
    '&prod;': "\u220F",
    '&radic;': "\u221A",
    '&part;': "\u2202",
    '&permil;': "\u2030",
    '&deg;': "\xb0",
    '&micro;': "\xb5",
    '&larr;': "\u2190",
    '&uarr;': "\u2191",
    '&rarr;': "\u2192",
    '&darr;': "\u2193",
    '&harr;': "\u2194",
    '&crarr;': "\u21B5",
    '&lArr;': "\u21D0",
    '&uArr;': "\u21D1",
    '&rArr;': "\u21D2",
    '&dArr;': "\u21D3",
    '&hArr;': "\u21D4",
    '&alpha;': "\u03B1",
    '&beta;': "\u03B2",
    '&gamma;': "\u03B3",
    '&delta;': "\u03B4",
    '&epsilon;': "\u03B5",
    '&zeta;': "\u03B6",
    '&eta;': "\u03B7",
    '&theta;': "\u03B8",
    '&iota;': "\u03B9",
    '&kappa;': "\u03BA",
    '&lambda;': "\u03BB",
    '&mu;': "\u03BC",
    '&nu;': "\u03BD",
    '&xi;': "\u03BE",
    '&omicron;': "\u03BF",
    '&pi;': "\u03C0",
    '&rho;': "\u03C1",
    '&sigma;': "\u03C3",
    '&tau;': "\u03C4",
    '&upsilon;': "\u03C5",
    '&phi;': "\u03C6",
    '&chi;': "\u03C7",
    '&psi;': "\u03C8",
    '&omega;': "\u03C9",
    '&Alpha;': "\u0391",
    '&Beta;': "\u0392",
    '&Gamma;': "\u0393",
    '&Delta;': "\u0394",
    '&Epsilon;': "\u0395",
    '&Zeta;': "\u0396",
    '&Eta;': "\u0397",
    '&Theta;': "\u0398",
    '&Iota;': "\u0399",
    '&Kappa;': "\u039A",
    '&Lambda;': "\u039B",
    '&Mu;': "\u039C",
    '&Nu;': "\u039D",
    '&Xi;': "\u039E",
    '&Omicron;': "\u039F",
    '&Pi;': "\u03A0",
    '&Rho;': "\u03A1",
    '&Sigma;': "\u03A3",
    '&Tau;': "\u03A4",
    '&Upsilon;': "\u03A5",
    '&Phi;': "\u03A6",
    '&Chi;': "\u03A7",
    '&Psi;': "\u03A8",
    '&Omega;': "\u03A9",
    '&Agrave;': "\xc0",
    '&Aacute;': "\xc1",
    '&Acirc;': "\xc2",
    '&Atilde;': "\xc3",
    '&Auml;': "\xc4",
    '&Aring;': "\xc5",
    '&AElig;': "\xc6",
    '&Ccedil;': "\xc7",
    '&Egrave;': "\xc8",
    '&Eacute;': "\xc9",
    '&Ecirc;': "\xca",
    '&Euml;': "\xcb",
    '&Igrave;': "\xcc",
    '&Iacute;': "\xcd",
    '&Icirc;': "\xce",
    '&Iuml;': "\xcf",
    '&ETH;': "\xd0",
    '&Ntilde;': "\xd1",
    '&Ograve;': "\xd2",
    '&Oacute;': "\xd3",
    '&Ocirc;': "\xd4",
    '&Otilde;': "\xd5",
    '&Ouml;': "\xd6",
    '&Oslash;': "\xd8",
    '&Ugrave;': "\xd9",
    '&Uacute;': "\xda",
    '&Ucirc;': "\xdb",
    '&Uuml;': "\xdc",
    '&Yacute;': "\xdd",
    '&THORN;': "\xde",
    '&szlig;': "\xdf",
    '&agrave;': "\xe0",
    '&aacute;': "\xe1",
    '&acirc;': "\xe2",
    '&atilde;': "\xe3",
    '&auml;': "\xe4",
    '&aring;': "\xe5",
    '&aelig;': "\xe6",
    '&ccedil;': "\xe7",
    '&egrave;': "\xe8",
    '&eacute;': "\xe9",
    '&ecirc;': "\xea",
    '&euml;': "\xeb",
    '&igrave;': "\xec",
    '&iacute;': "\xed",
    '&icirc;': "\xee",
    '&iuml;': "\xef",
    '&eth;': "\xf0",
    '&ntilde;': "\xf1",
    '&ograve;': "\xf2",
    '&oacute;': "\xf3",
    '&ocirc;': "\xf4",
    '&otilde;': "\xf5",
    '&ouml;': "\xf6",
    '&oslash;': "\xf8",
    '&ugrave;': "\xf9",
    '&uacute;': "\xfa",
    '&ucirc;': "\xfb",
    '&uuml;': "\xfc",
    '&yacute;': "\xfd",
    '&thorn;': "\xfe",
    '&yuml;': "\xff",
    '&iexcl;': "\xa1",
    '&iquest;': "\xbf",
    '&fnof;': "\u0192",
    '&circ;': "\u02C6",
    '&tilde;': "\u02DC",
    '&OElig;': "\u0152",
    '&oelig;': "\u0153",
    '&Scaron;': "\u0160",
    '&scaron;': "\u0161",
    '&Yuml;': "\u0178",
    '&ordf;': "\xaa",
    '&ordm;': "\xba",
    '&macr;': "\xaf",
    '&acute;': "\xb4",
    '&cedil;': "\xb8",
    '&sup1;': "\xb9",
    '&sup2;': "\xb2",
    '&sup3;': "\xb3",
    '&frac14;': "\xbc",
    '&frac12;': "\xbd",
    '&frac34;': "\xbe",
    '&spades;': "\u2660",
    '&clubs;': "\u2663",
    '&hearts;': "\u2665",
    '&diams;': "\u2666",
    '&loz;': "\u25CA",
    '&oline;': "\u203E",
    '&frasl;': "\u2044",
    '&weierp;': "\u2118",
    '&image;': "\u2111",
    '&real;': "\u211C",
    '&alefsym;': "\u2135"
};
const $1f52196153854093$var$entityPattern = new RegExp(Object.keys($1f52196153854093$var$commonEntities).map((entity)=>entity.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|'), 'g');
const $1f52196153854093$export$5cfeaa4af6841c8f = (text)=>text.replace($1f52196153854093$var$entityPattern, (match)=>$1f52196153854093$var$commonEntities[match]).replace(/&#(\d+);/g, (_, num)=>String.fromCharCode(parseInt(num, 10))).replace(/&#x([0-9a-fA-F]+);/g, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));


const $7da2d4d1c9b2bedd$export$660b2ee2d4fb4eff = (translation)=>{
    const tokens = [];
    let position = 0;
    let currentText = '';
    const flushText = ()=>{
        if (currentText) {
            tokens.push({
                type: 'Text',
                value: currentText,
                position: position - currentText.length
            });
            currentText = '';
        }
    };
    while(position < translation.length){
        const char = translation[position];
        if (char === '<') {
            const tagMatch = translation.slice(position).match(/^<(\d+)>/);
            if (tagMatch) {
                flushText();
                tokens.push({
                    type: 'TagOpen',
                    value: tagMatch[0],
                    position: position,
                    tagNumber: parseInt(tagMatch[1], 10)
                });
                position += tagMatch[0].length;
            } else {
                const closeTagMatch = translation.slice(position).match(/^<\/(\d+)>/);
                if (closeTagMatch) {
                    flushText();
                    tokens.push({
                        type: 'TagClose',
                        value: closeTagMatch[0],
                        position: position,
                        tagNumber: parseInt(closeTagMatch[1], 10)
                    });
                    position += closeTagMatch[0].length;
                } else {
                    currentText += char;
                    position += 1;
                }
            }
        } else {
            currentText += char;
            position += 1;
        }
    }
    flushText();
    return tokens;
};



var $5E6i4 = parcelRequire("5E6i4");



const $8c4a5466b7f6c709$var$renderDeclarationNode = (declaration, children, childDeclarations)=>{
    const { type: type, props: props = {} } = declaration;
    if (props.children && Array.isArray(props.children) && childDeclarations) {
        const { children: _childrenToRemove, ...propsWithoutChildren } = props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement(type, propsWithoutChildren, ...children);
    }
    if (children.length === 0) return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement(type, props);
    if (children.length === 1) return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement(type, props, children[0]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement(type, props, ...children);
};
const $8c4a5466b7f6c709$export$1038df9fa5e5f35f = (translation, declarations = [])=>{
    if (!translation) return [];
    const tokens = (0, $7da2d4d1c9b2bedd$export$660b2ee2d4fb4eff)(translation);
    const result = [];
    const stack = [];
    const literalTagNumbers = new Set();
    const getCurrentDeclarations = ()=>{
        if (stack.length === 0) return declarations;
        const parentFrame = stack[stack.length - 1];
        if (parentFrame.declaration.props?.children && Array.isArray(parentFrame.declaration.props.children)) return parentFrame.declaration.props.children;
        return parentFrame.declarations;
    };
    tokens.forEach((token)=>{
        switch(token.type){
            case 'Text':
                {
                    const decoded = (0, $1f52196153854093$export$5cfeaa4af6841c8f)(token.value);
                    const targetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                    targetArray.push(decoded);
                }
                break;
            case 'TagOpen':
                {
                    const { tagNumber: tagNumber } = token;
                    const currentDeclarations = getCurrentDeclarations();
                    const declaration = currentDeclarations[tagNumber];
                    if (!declaration) {
                        literalTagNumbers.add(tagNumber);
                        const literalText = `<${tagNumber}>`;
                        const targetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                        targetArray.push(literalText);
                        break;
                    }
                    stack.push({
                        tagNumber: tagNumber,
                        children: [],
                        position: token.position,
                        declaration: declaration,
                        declarations: currentDeclarations
                    });
                }
                break;
            case 'TagClose':
                {
                    const { tagNumber: tagNumber } = token;
                    if (literalTagNumbers.has(tagNumber)) {
                        const literalText = `</${tagNumber}>`;
                        const literalTargetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                        literalTargetArray.push(literalText);
                        literalTagNumbers.delete(tagNumber);
                        break;
                    }
                    if (stack.length === 0) throw new (0, $7ae36fb432a911d7$export$aa9e222d9ffc5d1b)(`Unexpected closing tag </${tagNumber}> at position ${token.position}`, token.position, translation);
                    const frame = stack.pop();
                    if (frame.tagNumber !== tagNumber) throw new (0, $7ae36fb432a911d7$export$aa9e222d9ffc5d1b)(`Mismatched tags: expected </${frame.tagNumber}> but got </${tagNumber}> at position ${token.position}`, token.position, translation);
                    const element = $8c4a5466b7f6c709$var$renderDeclarationNode(frame.declaration, frame.children, frame.declarations);
                    const elementTargetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                    elementTargetArray.push(element);
                }
                break;
        }
    });
    if (stack.length > 0) {
        const unclosed = stack[stack.length - 1];
        throw new (0, $7ae36fb432a911d7$export$aa9e222d9ffc5d1b)(`Unclosed tag <${unclosed.tagNumber}> at position ${unclosed.position}`, unclosed.position, translation);
    }
    return result;
};




function $24d2f0fb446aea4e$export$c70a6545d92ee1d4({ i18nKey: i18nKey, defaultTranslation: defaultTranslation, content: content, ns: ns, values: values = {}, i18n: i18nFromProps, t: tFromProps }) {
    const i18n = i18nFromProps || (0, $854d86f3d62aada7$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $1e83742382a0d73f$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', `IcuTrans: You need to pass in an i18next instance using i18nextReactModule`, {
            i18nKey: i18nKey
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).Fragment, {}, defaultTranslation);
    }
    const t = tFromProps || i18n.t?.bind(i18n) || ((k)=>k);
    let namespaces = ns || t.ns || i18n.options?.defaultNS;
    namespaces = (0, $1e83742382a0d73f$export$844ec244b1367d54)(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    let mergedValues = values;
    if (i18n.options?.interpolation?.defaultVariables) mergedValues = values && Object.keys(values).length > 0 ? {
        ...values,
        ...i18n.options.interpolation.defaultVariables
    } : {
        ...i18n.options.interpolation.defaultVariables
    };
    const translation = t(i18nKey || defaultTranslation, {
        defaultValue: defaultTranslation,
        ...mergedValues,
        ns: namespaces
    });
    try {
        const rendered = (0, $8c4a5466b7f6c709$export$1038df9fa5e5f35f)(translation, content);
        return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).Fragment, {}, ...rendered);
    } catch (error) {
        (0, $1e83742382a0d73f$export$c106dd0671a0fc2d)(i18n, 'ICU_TRANS_RENDER_ERROR', `IcuTrans component error for key "${i18nKey}": ${error.message}`, {
            i18nKey: i18nKey,
            error: error
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).Fragment, {}, translation);
    }
}
$24d2f0fb446aea4e$export$c70a6545d92ee1d4.displayName = 'IcuTransWithoutContext';



function $1cff195aad1201f1$export$c8b7e2ca8249a4be({ i18nKey: i18nKey, defaultTranslation: defaultTranslation, content: content, ns: ns, values: values = {}, i18n: i18nFromProps, t: tFromProps }) {
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $5E6i4.useContext)((0, $7907f3439c90332a$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $854d86f3d62aada7$export$64af334f494c2f47)();
    const t = tFromProps || i18n?.t.bind(i18n);
    return (0, $24d2f0fb446aea4e$export$c70a6545d92ee1d4)({
        i18nKey: i18nKey,
        defaultTranslation: defaultTranslation,
        content: content,
        ns: ns || t?.ns || defaultNSFromContext || i18n?.options?.defaultNS,
        values: values,
        i18n: i18n,
        t: tFromProps
    });
}
$1cff195aad1201f1$export$c8b7e2ca8249a4be.displayName = 'IcuTrans';




var $5E6i4 = parcelRequire("5E6i4");
var $ee5b9e121318164d$exports = {};
'use strict';

$ee5b9e121318164d$exports = (parcelRequire("9PpZJ"));




const $705ab703c44be5bc$var$notReadyT = (k, optsOrDefaultValue)=>{
    if ((0, $1e83742382a0d73f$export$844ec244b1367d54)(optsOrDefaultValue)) return optsOrDefaultValue;
    if ((0, $1e83742382a0d73f$export$a6cdc56e425d0d0a)(optsOrDefaultValue) && (0, $1e83742382a0d73f$export$844ec244b1367d54)(optsOrDefaultValue.defaultValue)) return optsOrDefaultValue.defaultValue;
    if (typeof k === 'function') return '';
    if (Array.isArray(k)) {
        const last = k[k.length - 1];
        return typeof last === 'function' ? '' : last;
    }
    return k;
};
const $705ab703c44be5bc$var$notReadySnapshot = {
    t: $705ab703c44be5bc$var$notReadyT,
    ready: false
};
const $705ab703c44be5bc$var$dummySubscribe = ()=>()=>{};
const $705ab703c44be5bc$export$9fc83ad70ead8663 = (ns, props = {})=>{
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $5E6i4.useContext)((0, $7907f3439c90332a$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $854d86f3d62aada7$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $7907f3439c90332a$export$ea171b67e3820290)();
    if (!i18n) (0, $1e83742382a0d73f$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', 'useTranslation: You will need to pass in an i18next instance by using initReactI18next or by passing it via props or context. In monorepo setups, make sure there is only one instance of react-i18next.');
    const i18nOptions = (0, $5E6i4.useMemo)(()=>({
            ...(0, $b6eb3be40d97793b$export$212bb2fc580a90a8)(),
            ...i18n?.options?.react,
            ...props
        }), [
        i18n,
        props
    ]);
    const { useSuspense: useSuspense, keyPrefix: keyPrefix, bindI18n: bindI18n, bindI18nStore: bindI18nStore } = i18nOptions;
    const nsOrContext = ns || defaultNSFromContext || i18n?.options?.defaultNS;
    const unstableNamespaces = (0, $1e83742382a0d73f$export$844ec244b1367d54)(nsOrContext) ? [
        nsOrContext
    ] : nsOrContext || [
        'translation'
    ];
    const namespaces = (0, $5E6i4.useMemo)(()=>unstableNamespaces, unstableNamespaces);
    i18n?.reportNamespaces?.addUsedNamespaces?.(namespaces);
    const revisionRef = (0, $5E6i4.useRef)(0);
    const subscribe = (0, $5E6i4.useCallback)((callback)=>{
        if (!i18n) return $705ab703c44be5bc$var$dummySubscribe;
        const wrappedCallback = ()=>{
            revisionRef.current += 1;
            callback();
        };
        if (bindI18n) i18n.on(bindI18n, wrappedCallback);
        if (bindI18nStore) i18n.store.on(bindI18nStore, wrappedCallback);
        return ()=>{
            if (bindI18n) bindI18n.split(' ').forEach((e)=>i18n.off(e, wrappedCallback));
            if (bindI18nStore) bindI18nStore.split(' ').forEach((e)=>i18n.store.off(e, wrappedCallback));
        };
    }, [
        i18n,
        bindI18n,
        bindI18nStore
    ]);
    const snapshotRef = (0, $5E6i4.useRef)();
    const getSnapshot = (0, $5E6i4.useCallback)(()=>{
        if (!i18n) return $705ab703c44be5bc$var$notReadySnapshot;
        const calculatedReady = !!(i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every((n)=>(0, $1e83742382a0d73f$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions));
        const currentLng = props.lng || i18n.language;
        const currentRevision = revisionRef.current;
        const lastSnapshot = snapshotRef.current;
        if (lastSnapshot && lastSnapshot.ready === calculatedReady && lastSnapshot.lng === currentLng && lastSnapshot.keyPrefix === keyPrefix && lastSnapshot.revision === currentRevision) return lastSnapshot;
        const calculatedT = i18n.getFixedT(currentLng, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix, {
            scopeNs: namespaces
        });
        const newSnapshot = {
            t: calculatedT,
            ready: calculatedReady,
            lng: currentLng,
            keyPrefix: keyPrefix,
            revision: currentRevision
        };
        snapshotRef.current = newSnapshot;
        return newSnapshot;
    }, [
        i18n,
        namespaces,
        keyPrefix,
        i18nOptions,
        props.lng
    ]);
    const [loadCount, setLoadCount] = (0, $5E6i4.useState)(0);
    const { t: t, ready: ready } = (0, $ee5b9e121318164d$exports.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    (0, $5E6i4.useEffect)(()=>{
        if (i18n && !ready && !useSuspense) {
            const onLoaded = ()=>setLoadCount((c)=>c + 1);
            if (props.lng) (0, $1e83742382a0d73f$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, onLoaded);
            else (0, $1e83742382a0d73f$export$83be934b53fff43b)(i18n, namespaces, onLoaded);
        }
    }, [
        i18n,
        props.lng,
        namespaces,
        ready,
        useSuspense,
        loadCount
    ]);
    const finalI18n = i18n || {};
    const wrapperRef = (0, $5E6i4.useRef)(null);
    const wrapperLangRef = (0, $5E6i4.useRef)();
    const languageKey = (inst)=>`${inst.language}|${inst.resolvedLanguage}|${inst.languages?.join(',')}`;
    const createI18nWrapper = (original)=>{
        const descriptors = Object.getOwnPropertyDescriptors(original);
        if (descriptors.__original) delete descriptors.__original;
        const wrapper = Object.create(Object.getPrototypeOf(original), descriptors);
        if (!Object.prototype.hasOwnProperty.call(wrapper, '__original')) try {
            Object.defineProperty(wrapper, '__original', {
                value: original,
                writable: false,
                enumerable: false,
                configurable: false
            });
        } catch (_) {}
        return wrapper;
    };
    const ret = (0, $5E6i4.useMemo)(()=>{
        const original = finalI18n;
        const lang = original && languageKey(original);
        let i18nWrapper = original;
        if (original) {
            if (wrapperRef.current && wrapperRef.current.__original === original) {
                if (wrapperLangRef.current !== lang) {
                    i18nWrapper = createI18nWrapper(original);
                    wrapperRef.current = i18nWrapper;
                    wrapperLangRef.current = lang;
                } else i18nWrapper = wrapperRef.current;
            } else {
                i18nWrapper = createI18nWrapper(original);
                wrapperRef.current = i18nWrapper;
                wrapperLangRef.current = lang;
            }
        }
        const effectiveT = !ready && !useSuspense ? (...args)=>{
            (0, $1e83742382a0d73f$export$5b28268982f175ba)(i18n, 'USE_T_BEFORE_READY', 'useTranslation: t was called before ready. When using useSuspense: false, make sure to check the ready flag before using t.');
            return t(...args);
        } : t;
        const arr = [
            effectiveT,
            i18nWrapper,
            ready
        ];
        arr.t = effectiveT;
        arr.i18n = i18nWrapper;
        arr.ready = ready;
        return arr;
    }, [
        t,
        finalI18n,
        ready,
        finalI18n.resolvedLanguage,
        finalI18n.language,
        finalI18n.languages
    ]);
    if (i18n && useSuspense && !ready) {
        let inDevelopment = false;
        try {
            inDevelopment = false;
        } catch (e) {}
        if (inDevelopment) (0, $1e83742382a0d73f$export$5b28268982f175ba)(i18n, 'SUSPENDED_WHILE_LOADING', 'useTranslation: suspended while translations are loading (useSuspense is true by default). Add a <Suspense> boundary above this component, or set react.useSuspense: false in the i18next init options. https://react.i18next.com/latest/usetranslation-hook');
        throw new Promise((resolve)=>{
            const onLoaded = ()=>resolve();
            if (props.lng) (0, $1e83742382a0d73f$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, onLoaded);
            else (0, $1e83742382a0d73f$export$83be934b53fff43b)(i18n, namespaces, onLoaded);
        });
    }
    return ret;
};



var $5E6i4 = parcelRequire("5E6i4");


const $b24c18aac459b779$export$2dcb0053efd21124 = (ns, options = {})=>function Extend(WrappedComponent) {
        function I18nextWithTranslation({ forwardedRef: forwardedRef, ...rest }) {
            const [t, i18n, ready] = (0, $705ab703c44be5bc$export$9fc83ad70ead8663)(ns, {
                ...rest,
                keyPrefix: options.keyPrefix
            });
            const passDownProps = {
                ...rest,
                t: t,
                i18n: i18n,
                tReady: ready
            };
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $5E6i4.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = `withI18nextTranslation(${(0, $1e83742382a0d73f$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        const forwardRef = (props, ref)=>(0, $5E6i4.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        return options.withRef ? (0, $5E6i4.forwardRef)(forwardRef) : I18nextWithTranslation;
    };



const $47c74263d549e2fb$export$b63289fbda65eed1 = ({ ns: ns, children: children, ...options })=>{
    const [t, i18n, ready] = (0, $705ab703c44be5bc$export$9fc83ad70ead8663)(ns, options);
    return children(t, {
        i18n: i18n,
        lng: i18n?.language
    }, ready);
};



var $5E6i4 = parcelRequire("5E6i4");

function $571bdaf057ae248c$export$1325e8699caa160f({ i18n: i18n, defaultNS: defaultNS, children: children }) {
    const value = (0, $5E6i4.useMemo)(()=>({
            i18n: i18n,
            defaultNS: defaultNS
        }), [
        i18n,
        defaultNS
    ]);
    return (0, $5E6i4.createElement)((0, $7907f3439c90332a$export$5603ab5ced17ce64).Provider, {
        value: value
    }, children);
}



var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");


const $434ee39ad5dcd6a6$export$3526fb65ade8d8b7 = (initialI18nStore, initialLanguage, props = {})=>{
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext } = (0, $5E6i4.useContext)((0, $7907f3439c90332a$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $854d86f3d62aada7$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $1e83742382a0d73f$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', 'useSSR: You will need to pass in an i18next instance by using initReactI18next or by passing it via props or context. In monorepo setups, make sure there is only one instance of react-i18next.');
        return;
    }
    if (i18n.options?.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        if (!i18n.services?.resourceStore) {
            (0, $1e83742382a0d73f$export$5b28268982f175ba)(i18n, 'I18N_NOT_INITIALIZED', "useSSR: i18n instance was found but not initialized (services.resourceStore is missing). Make sure you call i18next.init() before using useSSR \u2014 e.g. at module level, not only in getStaticProps/getServerSideProps.");
            return;
        }
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce((mem, lngResources)=>{
            Object.keys(lngResources).forEach((ns)=>{
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
};




const $85c7b4f58996674d$export$80dfa519af1c8605 = ()=>function Extend(WrappedComponent) {
        function I18nextWithSSR({ initialI18nStore: initialI18nStore, initialLanguage: initialLanguage, ...rest }) {
            (0, $434ee39ad5dcd6a6$export$3526fb65ade8d8b7)(initialI18nStore, initialLanguage);
            return (0, $5E6i4.createElement)(WrappedComponent, {
                ...rest
            });
        }
        I18nextWithSSR.getInitialProps = (0, $7907f3439c90332a$export$30ff0342ccf735a)(WrappedComponent);
        I18nextWithSSR.displayName = `withI18nextSSR(${(0, $1e83742382a0d73f$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };







const $71c3d571b1356991$export$324d90190a8b822a = ()=>'';
const $71c3d571b1356991$export$2da9be4cfdb689b1 = ()=>'';
const $71c3d571b1356991$export$98e628dec113755e = ()=>'';
const $71c3d571b1356991$export$2e6c959c16ff56b8 = ()=>'';
const $71c3d571b1356991$export$4e35d5c922a95490 = ()=>'';
const $71c3d571b1356991$export$720a3b9db04b7a0f = ()=>'';


var $16d711b5d7ddc5c0$exports = {};
$16d711b5d7ddc5c0$exports = JSON.parse('{"melodicPattern":{"configuration":{"color":"Farbe","confirmation":{"cancel":"Behalten","delete":"L\xf6schen","title":"Bist du dir sicher?"},"description":"Beschreibung","descriptionPlaceholder":"Beschreibe das melodische Motiv... (max. 280 Zeichen)","disclaimer":"Standardm\xe4\xdfig wird die Farbe eines Motivs\\ndurch die Farbe der Stimme bestimmt,\\nin der das Motiv zuerst vorkommt.","label":"Name","length":"L\xe4nge","occurrences":"Vorkommen (eindeutige)","title":"Melodisches\\nMotiv","lock":"Muster im Graph fixieren","delete":"Dieses Muster l\xf6schen","deleteConfirm":"Muster {{label}} mit seinen Vorschl\xe4gen l\xf6schen?","deleteSuggested":"Vorgeschlagene Muster verschwinden, wenn ihr Operator ausgeblendet oder ihr Muster gel\xf6scht wird."},"tooltip":{"disclaimer":"Um die Sichtbarkeit dieses Motivs zu garantieren, erscheint es gr\xf6\xdfer als es tats\xe4chlich ist. Die Relation zu anderen Motiven wird daher nicht korrekt abgebildet."}},"melodyAnalysis":"Melodie Analyse","melodyGraph":{"commonOccurrencesEdge_one":"{{ count }} gemeinsames Vorkommen","commonOccurrencesEdge_other":"{{ count }} gemeinsame Vorkommen","empty":"Noch keine Muster. W\xe4hle im Notenblatt die erste und die letzte Note eines Musters: Das Muster, verwandte Muster und die Operatoren, die sie verbinden, erscheinen hier.","controls":{"fit":"Graph einpassen","unlockAll":"Alle Muster l\xf6sen","focus":"Auf das ausgew\xe4hlte Muster fokussieren","entries":"Jeden Einsatz als eigenen Knoten zeigen"}},"musicSheets":{"Fugue No. 2 in C Minor (BWV 847)":"Fuge II in C-Moll (BWV 847)","Goldberg Variations: Aria":"Goldberg Variationen: Aria","Fugue No. 20 in A minor (BWV 889)":"Fuge XX in A-Moll (BWV 889)","Samples":"Beispiele","Study":"Studie","Symphony No. 5 - 1st Movement":"5. Sinfonie - erster Satz","Test":"Test","title":"{{ title }} (von {{ composer }})","The Four Seasons":"Die vier Jahreszeiten","The Silver Swan":"Der silberne Schwan","Waltz Opus 18 in E Major":"Waltz Opus 18 in E-Dur"},"onBoarding":{"step1":{"description":"Das ausgew\xe4hlte Musikst\xfcck wird \xe4hnlich wie auf dem Papier seitenweise angezeigt. F\xfcr die Melodieanalyse kannst du melodische Motive \xfcber deren erste und letzte Note durch einen Klick ausw\xe4hlen.","title":"Musikst\xfcck"},"step2":{"description":"Du kannst die Seiten des Musikst\xfccks durch Klicken auf die entsprechenden Buttons navigieren. Ebenfalls kannst du die Pfeiltasten auf deiner Tastatur verwenden, um die Seiten zu wechseln.","title":"Navigation des Musikst\xfccks"},"step3":{"description":"Die Melodie Zeitleiste gibt einen \xdcberblick \xfcber das gesamte Musikst\xfcck. Vertikale Linien markieren die Umbr\xfcche zwischen den Seiten des Musikst\xfccks. Hoverst du links und rechts von diesen vertikalen Linien wird automatisch die entsprechende Seite des Musikst\xfccks angezeigt. Melodische Motive, die du im Musikst\xfcck highlightest erscheinen automatisch in der Melodie Zeitleiste.","title":"Melodie Zeitleiste"},"step4":{"description":"Die Vorschl\xe4ge zeigen acht melodische Operatoren, mit deren Hilfe du basierend auf einem ausgew\xe4hlten melodischen Motiv andere melodische Motive finden kannst. Standardm\xe4\xdfig zeigt der Prototyp nur die anderen melodischen Motive, die durch Transposition gefunden werden. Andere melodische Operatoren kannst du durch einen Klick auf deren Bild ausw\xe4hlen. Hoverst du mit deiner Maus \xfcber ein solches Bild ohne zu klicken, wird eine Vorschau der entsprechenden melodischen Motive angezeigt.","title":"Vorschl\xe4ge"},"step5":{"description":"Der Melodie Graph zeigt alle gehighlighteten melodischen Motive als Knoten. Highlightest du ein melodisches Motiv mittels der Vorschl\xe4ge, wird es mit einem anderen melodischen Motiv \xfcber den entsprechenden melodischen Operator verbunden.","title":"Melodie Graph"},"step6":{"description":"Die melodische Motiv Konfiguration erm\xf6glicht es dir, die Bezeichnung, die Beschreibung sowie die Farbe eines melodischen Motivs zu ver\xe4ndern. Du kannst ein melodisches Motiv auch l\xf6schen, indem du rechts auf den M\xfclleimer klickst.","title":"Melodisches Motiv Konfiguration"},"tooltip":{"back":"Zur\xfcck","close":"Schlie\xdfen","next":"Weiter","skip":"\xdcberspringen","progress":"{{current}} von {{total}}"},"discovery":{"title":"Gefundene Muster","description":"MelodyVis analysiert jedes St\xfcck automatisch: Themen, Kontrasubjekte, Imitationen, Sequenzen und Motive mit all ihren Eins\xe4tzen. Zeige eine Familie im Notenblatt, h\xf6r sie dir an oder w\xe4hle sie aus, um zu sehen, wie sie durch die Stimmen wandert, wie sie transponiert oder ver\xe4ndert wird und auf welchen T\xf6nen sie beginnt."}},"settings":{"colorByVoice":"Motive gem\xe4\xdf Stimme einf\xe4rben","colorVoices":"Stimmen im Musikst\xfcck einf\xe4rben"},"suggestions":{"accept":"Annehmen","decline":"Verwerfen","generate":"Generieren","operators":{"all":{"title":"Alle"},"augmentation":{"description":"Verdoppelt L\xe4nge aller Noten","title":"Augmentation"},"deviation":{"description":"Erlaubt Abweichung des Motivs in bis zu <0>{{ deviationPercentage }} %</0> der Noten","disclaimer":"Bei einem geringen Prozentsatz erlaubt der Operator weniger Abweichung, bei einem h\xf6heren Prozentsatz ist das Gegenteil der Fall.","title":"Abweichung"},"diminution":{"description":"Halbiert L\xe4nge aller Noten","title":"Diminution"},"mirror_x":{"description":"Spiegelt Tonh\xf6hen an der x-Achse der ersten Note","title":"Spiegelung an x-Achse"},"mirror_y":{"description":"Spiegelt Noten an der y-Achse der mittleren Note(n)","title":"Spiegelung an y-Achse"},"mirror_xy":{"title":"Spiegelung an beiden Achsen","description":"Umkehrung und Krebs kombiniert (Krebsumkehrung)"},"reduction_to_pitch":{"description":"Ber\xfccksichtigt nur Tonh\xf6hen des Motivs","title":"Reduktion zu Tonh\xf6he"},"reduction_to_rhythm":{"description":"Ber\xfccksichtigt nur Rhythmus des Motivs","title":"Reduktion zu Rhythmus"},"transposition":{"description":"Transponiert das Motiv um bestimmtes, aber beliebiges Intervall","title":"Transposition"}},"title":"Vorschl\xe4ge","useAsDefault":"Als Standard festlegen","useAsDefaultTooltip":"Diese Einstellung der Sichtbarkeit von verwandten melodischen Motiven wird f\xfcr alle neuen melodischen Motive verwendet.","deviationThreshold":"Abweichungsgrenze: {{percentage}} %","tonal":"Tonale Varianten","tonalTooltip":"An: Transpositionen, Umkehrungen, Krebse und Abweichungen d\xfcrfen statt der exakten Intervalle die Tonleiterstufen beibehalten, z. B. die tonale Beantwortung einer Fuge. Aus: nur exakte Intervalle in Halbt\xf6nen. Gilt f\xfcr die n\xe4chste Suche.","hint":"W\xe4hle ein Motiv im Notenblatt oder eine entdeckte Familie, um ihre Varianten zu sehen.","family":{"summary":"{{entries}}: {{self}} wie notiert (erster Einsatz, exakte Wiederholungen), {{related}} \xfcber die Operatoren unten verwandt.","hidden":"Diese Familie ist im Notenblatt nicht eingeblendet.","show":"Im Notenblatt zeigen","all":"Zeigt oder verbirgt die Markierungen aller verwandten Eins\xe4tze; der erste Einsatz und exakte Wiederholungen bleiben.","toggle_one":"Markierung des {{count}} so verwandten Einsatzes zeigen oder verbergen","toggle_other":"Markierungen der {{count}} so verwandten Eins\xe4tze zeigen oder verbergen","none":"Kein Einsatz von {{label}} ist so mit seinem ersten Einsatz verwandt.","notSearched":"Die automatische Erkennung sucht nicht nach dieser Verwandtschaft. W\xe4hle das Motiv im Notenblatt aus, um danach zu suchen.","deviation":"Varianten: bis zu 20 % der Noten weichen ab","searchHint":"Um mit allen Operatoren zu suchen, w\xe4hle Noten im Notenblatt aus."}},"discovery":{"title":"Gefundene Muster","summary_one":"{{count}} Musterfamilie erkl\xe4rt {{share}} % der Noten","summary_other":"{{count}} Musterfamilien erkl\xe4ren {{share}} % der Noten","accompanies":"erklingt gegen {{label}}","roles":{"theme":"Thema","countersubject":"Kontrasubjekt","imitation":"Imitation (Kanon)","sequence":"Sequenz","motif":"Motiv"},"show":"Im Notenblatt zeigen","hide":"Im Notenblatt ausblenden","showAll":"Alle zeigen","hideAll":"Alle ausblenden","play":"Ersten Einsatz abspielen","stop":"Stopp","none":"In diesem St\xfcck wurden keine wiederholten Muster gefunden.","failed":"Die automatische Analyse ist fehlgeschlagen: {{error}}","computing":"Das St\xfcck wird analysiert\u2026","patternDescription_one":"{{role}}, {{count}} Einsatz in den Takten {{bars}}, automatisch gefunden.","patternDescription_other":"{{role}}, {{count}} Eins\xe4tze in den Takten {{bars}}, automatisch gefunden.","notes_one":"{{count}} Note","notes_other":"{{count}} Noten","yours_one":"dein Muster {{labels}}","yours_other":"deine Muster {{labels}}","yoursTooltip":"Eins\xe4tze dieser Familie \xfcberschneiden sich mit Mustern, die du ausgew\xe4hlt hast.","next":"Noch nicht in deiner Analyse: {{labels}}","rename":"Umbenennen","renameField":"Name von {{label}}","renamePlaceholder":"Leer lassen f\xfcr den Startnamen","figures":{"head":"Kopfmotiv von {{source}}","tail":"Schlussmotiv von {{source}}","part":"Motiv aus {{source}}","inverted":"{{name}}, umgekehrt","repetition":"Tonrepetition (Repetitio)","chromatic_up":"Chromatischer Gang aufw\xe4rts (Passus duriusculus)","chromatic_down":"Chromatischer Gang abw\xe4rts (Passus duriusculus)","scale_up":"Steigende Linie","scale_down":"Fallende Linie","tirata_up":"Lauf aufw\xe4rts (Tirata)","tirata_down":"Lauf abw\xe4rts (Tirata)","arpeggio_up":"Dreiklangsbrechung aufw\xe4rts","arpeggio_down":"Dreiklangsbrechung abw\xe4rts","sigh":"Seufzer (Suspiratio)","sighs":"Seufzerkette","neighbour_up":"Obere Wechselnote","neighbour_down":"Untere Wechselnote","turn":"Drehfigur (Circulatio)","leap_up":"{{interval}}sprung aufw\xe4rts","leap_down":"{{interval}}sprung abw\xe4rts","exclamatio":"{{name}} (Exclamatio)","contour_rising":"Steigendes Motiv","contour_falling":"Fallendes Motiv","contour_arch":"Bogenmotiv","contour_valley":"Muldenmotiv","contour_level":"Kreisendes Motiv","sequence_up":"Steigende Sequenz in {{interval}}","sequence_down":"Fallende Sequenz in {{interval}}","rhythm_dotted":"{{name}}, punktiert","rhythm_corta":"{{name}}, Figura corta","fromHead":"Motiv aus dem Kopf von {{source}}"},"leapIntervals":{"fourth":"Quart","tritone":"Tritonus","fifth":"Quint","sixth":"Sext","seventh":"Septim","octave":"Oktav"},"sequenceIntervals":{"second":"Sekunden","third":"Terzen","fourth":"Quarten","fifth":"Quinten","large":"gro\xdfen Schritten"}},"import":{"title":"Noten importieren","submit":"Importieren","file":"MusicXML-Datei","drop":"MusicXML-Datei hier ablegen oder klicken","hint":".musicxml, .xml oder komprimiertes .mxl, bis 10 MB (z. B. aus MuseScore exportiert)","titleLabel":"Titel","composer":"Komponist","fromFile":"Leer lassen, um ihn aus der Datei zu \xfcbernehmen.","button":"Importieren"},"tabs":{"operators":"Operatoren & Graph","transitions":"\xdcberg\xe4nge des Musters"},"transitions":{"hint":"Klicke ein gefundenes Muster im Notenblatt oder in der Zeitleiste an oder w\xe4hle ein eigenes (erste und letzte Note einer Stimme), um zu sehen, wie es sich durch das St\xfcck bewegt.","loading":"Die Eins\xe4tze des Musters werden gesucht\u2026"},"language":"Sprache","analysis":{"menu":"Analyse","export":"Analyse exportieren (.json)","import":"Analyse importieren (.json)","otherPiece":"Diese Analyse geh\xf6rt zu \u201E{{title}}\u201C. \xd6ffne zuerst dieses St\xfcck.","imported_one":"{{count}} Muster importiert.","imported_other":"{{count}} Muster importiert.","invalid":"Die Analyse konnte nicht importiert werden: {{reason}}"},"family":{"section":"Muster {{label}}","summary":"{{entries}} in {{voices}}, Takte {{first}}\u2013{{last}}: {{same}} gleich, {{transposed}} transponiert, {{changed}} ver\xe4ndert.","entries_one":"{{count}} Einsatz","entries_other":"{{count}} Eins\xe4tze","voices_one":"{{count}} Stimme","voices_other":"{{count}} Stimmen","sequences_one":"{{count}} Sequenz (aufeinanderfolgende transponierte Eins\xe4tze).","sequences_other":"{{count}} Sequenzen (aufeinanderfolgende transponierte Eins\xe4tze).","imitations_one":"{{count}} Imitation (zeitlich \xfcberlappende Eins\xe4tze).","imitations_other":"{{count}} Imitationen (zeitlich \xfcberlappende Eins\xe4tze).","strip":"Eins\xe4tze von Muster {{label}} pro Stimme im Zeitverlauf","voice":"Stimme {{voice}}","voiceShort":"{{voice}}","classes":{"same":"Gleiche T\xf6ne (erster Einsatz, exakt oder Oktavkopie)","transposed":"Transponiert (real oder tonal)","changed":"Ver\xe4ndert (Variante, Umkehrung, Krebs, Rhythmus)"},"byVoice":"Eins\xe4tze pro Stimme","bySemitones":"Tonlage zum 1. Einsatz (Halbt\xf6ne)","byStart":"Anfangston (Tonartbereiche)","table":"Eins\xe4tze von Muster {{label}}","columns":{"voice":"Stimme","bars":"Takte","start":"Beginnt auf","relation":"Beziehung","play":"Abspielen"},"playEntry":"Einsatz {{index}} abspielen","where":"Stimme {{voice}}, Takt {{bars}}, beginnt auf {{pitch}}","rest":"einer Pause","semitones":"{{shift}} Halbt\xf6ne","relations":{"prototype":"erster Einsatz","exact":"exakte Wiederholung","real":"reale Transposition","tonal":"tonale Transposition","variant_one":"Variante mit {{count}} ge\xe4nderter Note","variant_other":"Variante mit {{count}} ge\xe4nderten Noten","inversion":"Umkehrung","retrograde":"Krebs","augmentation":"Augmentation","diminution":"Diminution"},"glyphs":{"prototype":"1.","tonal":"t","inversion":"Umk","retrograde":"Kr"}},"views":{"sheet":"Das Notenblatt","timeline":"Die Zeitleiste","discovery":"Die gefundenen Muster","operators":"Die Operatoren und der Graph","transitions":"Die \xdcberg\xe4nge"},"errorBoundary":{"title":"{{name}} konnte nicht angezeigt werden","retry":"Erneut versuchen"},"timeline":{"page":"Seite {{page}}","playHint":"Doppelklick spielt diesen Einsatz ab."},"toolbar":{"tour":"Tour starten","exportPDF":"Notenblatt mit den Mustern als PDF exportieren","deleteAll":"Alle Muster l\xf6schen","deleteAllConfirm":"Alle Muster dieses St\xfccks l\xf6schen?","delete":"L\xf6schen","cancel":"Abbrechen","settings":"Darstellung"},"musicSheetError":{"title":"Dieses St\xfcck konnte nicht ge\xf6ffnet werden","retry":"Erneut versuchen"},"musicSheetSelection":{"label":"Musikst\xfcck"},"audio":{"credit":"Klavier: Salamander Grand Piano von Alexander Holm,","failed":"Der Einsatz kann nicht abgespielt werden: {{reason}}"},"piece":{"player":"Wiedergabe des St\xfccks","play":"St\xfcck abspielen","playFromPage":"Ab dieser Seite abspielen","pause":"Pause","resume":"Weiter","stop":"St\xfcck anhalten","tempo":"Tempo (Viertel pro Minute)","bar":"Takt {{bar}}","failed":"Das St\xfcck kann nicht abgespielt werden: {{reason}}"},"pageMode":{"group":"Seiten der Noten","a4":"A4","a4Hint":"Gedruckte A4-Seiten: Zeilen- und Seitenumbr\xfcche bleiben, der Zoom vergr\xf6\xdfert nur das Blatt","fit":"Ansicht","fitHint":"Seiten f\xfcllen die Ansicht: der Zoom \xe4ndert die Takte pro Zeile, nie seitliches Scrollen"},"sheetZoom":{"group":"Zoom der Noten","zoomIn":"Vergr\xf6\xdfern (+, Strg + Mausrad)","zoomOut":"Verkleinern (-, Strg + Mausrad)","original":"Originalgr\xf6\xdfe (0)"}}');


var $494d8c6bff879d7b$exports = {};
$494d8c6bff879d7b$exports = JSON.parse('{"melodicPattern":{"configuration":{"color":"Color","confirmation":{"cancel":"Keep","delete":"Delete","title":"Are you sure?"},"description":"Description","descriptionPlaceholder":"Describe the melodic pattern... (max. 280 characters)","disclaimer":"By default, the color of a pattern\\nis determined by the voice\\nthe pattern first occurs in.","label":"Label","length":"Length","occurrences":"Occurrences (unique)","title":"Melodic\\nPattern","lock":"Pin the pattern in the graph","delete":"Delete this pattern","deleteConfirm":"Delete pattern {{label}} with its suggestions?","deleteSuggested":"Suggested patterns disappear when their operator is hidden or their pattern is deleted."},"tooltip":{"disclaimer":"This pattern appears larger than it is to ensure its readability. Its size relative to other patterns is not correctly depicted."}},"melodyAnalysis":"Melody Analysis","melodyGraph":{"commonOccurrencesEdge_one":"{{ count }} common occurrence","commonOccurrencesEdge_other":"{{ count }} common occurrences","empty":"No patterns yet. Select the first and the last note of a pattern in the sheet: the pattern, its related patterns and the operators connecting them appear here.","controls":{"fit":"Fit the graph into view","unlockAll":"Unpin all patterns","focus":"Focus on the selected pattern","entries":"Show every entry as a node of its own"}},"musicSheets":{"title":"{{ title }} (by {{ composer }})"},"onBoarding":{"step1":{"description":"The selected music sheet is rendered in a paper-like fashion, page by page. To perform melody analysis, you can highlight a melodic pattern by selecting its first and list note through a click.","title":"Music Sheet"},"step2":{"description":"You can navigate through the pages of a music sheet by clicking the corresponding buttons. You can also use the arrow keys on your keyboard to navigate through the pages.","title":"Music Sheet Navigation"},"step3":{"description":"The melody timeline gives an overview of the complete music sheet. Vertical lines indicate the page breaks, hovering to the left and the right of these vertical lines automatically switches to the corresponding page. Melodic patterns highlighted in the music sheet appear on the corresponding voice in this timeline.","title":"Melody Timeline"},"step4":{"description":"The suggestions list eight melodic operators that can be used to generate other melodic patterns based on a melodic pattern that you highlight in the music sheet. By default, the prototype only shows melodic patterns generated through transposition. You can enable other operators by clicking on the corresponding image or hover over the corresponding image to preview the respective melodic patterns.","title":"Suggestions"},"step5":{"description":"The melody graph shows all highlighted melodic patterns as nodes. If a melodic pattern has been highlighted through the suggestions, it will be connected to another melodic pattern through the corresponding melodic operator.","title":"Melody Graph"},"step6":{"description":"The melodic pattern configuration allows you to change the label, the description, and the color of a melodic pattern. You can also delete a melodic pattern by clicking on the trash can icon.","title":"Melodic Pattern Configuration"},"tooltip":{"back":"Back","close":"Close","next":"Next","skip":"Skip","progress":"{{current}} of {{total}}"},"discovery":{"title":"Discovered patterns","description":"MelodyVis analyses every piece automatically: themes, countersubjects, imitations, sequences and motifs with all their entries. Show a family in the sheet, listen to it, or select it to see how it moves through the voices, how it is transposed or changed, and on which notes it starts."}},"settings":{"colorByVoice":"Color patterns by voice","colorVoices":"Color voices in music sheet"},"suggestions":{"accept":"Accept","decline":"Discard","generate":"Generate","operators":{"all":{"title":"All"},"augmentation":{"description":"Doubles length of all notes","title":"Augmentation"},"deviation":{"description":"Permits up to <0>{{ deviationPercentage }} %</0> of all notes to deviate from pattern","disclaimer":"A smaller percentage causes the operator to allow for less deviation, while a larger percentage causes the opposite.","title":"Deviation"},"diminution":{"description":"Halves length of all notes","title":"Diminution"},"mirror_x":{"description":"Mirrors pitches on x-axis through first pitch","title":"Mirror on x-axis"},"mirror_y":{"description":"Mirrors notes on y-axis of middle note(s)","title":"Mirror on y-axis"},"mirror_xy":{"title":"Mirror on both axes","description":"Inversion and retrograde combined (retrograde inversion)"},"reduction_to_pitch":{"description":"Only considers pitches of pattern","title":"Reduction to pitch"},"reduction_to_rhythm":{"description":"Only considers rhythm of pattern","title":"Reduction to rhythm"},"transposition":{"description":"Transposes pattern by fixed but arbitrary interval","title":"Transposition"}},"title":"Suggestions","useAsDefault":"Use as default","useAsDefaultTooltip":"This visibility setting for related melodic patterns will be used as default for new melodic patterns.","deviationThreshold":"Deviation threshold: {{percentage}} %","tonal":"Tonal variants","tonalTooltip":"On: transpositions, inversions, retrogrades and deviations may keep the scale steps instead of the exact intervals, e.g. the tonal answer of a fugue. Off: only exact intervals in semitones. Applies to the next search.","hint":"Select a pattern in the sheet or a discovered family to see its variants.","family":{"summary":"{{entries}}: {{self}} as written (first entry, exact repetitions), {{related}} related by the operators below.","hidden":"This family is not shown in the sheet.","show":"Show in the sheet","all":"Shows or hides the highlights of all related entries; the first entry and exact repetitions stay.","toggle_one":"Show or hide the highlight of the {{count}} entry related this way","toggle_other":"Show or hide the highlights of the {{count}} entries related this way","none":"No entry of {{label}} is related to its first entry this way.","notSearched":"The automatic discovery does not look for this relation. Select the pattern in the sheet to search for it.","deviation":"Variants: up to 20 % of the notes differ","searchHint":"To search with every operator, select notes in the sheet."}},"discovery":{"title":"Discovered patterns","summary_one":"{{count}} pattern family explains {{share}} % of the notes","summary_other":"{{count}} pattern families explain {{share}} % of the notes","accompanies":"sounds against {{label}}","roles":{"theme":"Theme","countersubject":"Countersubject","imitation":"Imitation (canon)","sequence":"Sequence","motif":"Motif"},"show":"Show in the sheet","hide":"Hide from the sheet","showAll":"Show all","hideAll":"Hide all","play":"Play the first entry","stop":"Stop","none":"No repeated patterns found in this piece.","failed":"The automatic analysis failed: {{error}}","computing":"Analysing the piece\u2026","patternDescription_one":"{{role}}, {{count}} entry in bars {{bars}}, found automatically.","patternDescription_other":"{{role}}, {{count}} entries in bars {{bars}}, found automatically.","notes_one":"{{count}} note","notes_other":"{{count}} notes","yours_one":"your pattern {{labels}}","yours_other":"your patterns {{labels}}","yoursTooltip":"Entries of this family overlap patterns you selected.","next":"Not yet in your analysis: {{labels}}","rename":"Rename","renameField":"Name of {{label}}","renamePlaceholder":"Leave empty for the starting name","figures":{"head":"Head of {{source}}","tail":"Tail of {{source}}","part":"Motif from {{source}}","inverted":"{{name}}, inverted","repetition":"Repeated notes (repetitio)","chromatic_up":"Rising chromatic line (passus duriusculus)","chromatic_down":"Falling chromatic line (passus duriusculus)","scale_up":"Rising stepwise line","scale_down":"Falling stepwise line","tirata_up":"Rising run (tirata)","tirata_down":"Falling run (tirata)","arpeggio_up":"Rising broken chord","arpeggio_down":"Falling broken chord","sigh":"Sigh (suspiratio)","sighs":"Chain of sighs","neighbour_up":"Upper neighbour figure","neighbour_down":"Lower neighbour figure","turn":"Turn (circulatio)","leap_up":"Leap up a {{interval}}","leap_down":"Leap down a {{interval}}","exclamatio":"{{name}} (exclamatio)","contour_rising":"Rising motif","contour_falling":"Falling motif","contour_arch":"Arch motif","contour_valley":"Valley motif","contour_level":"Circling motif","sequence_up":"Rising sequence by {{interval}}","sequence_down":"Falling sequence by {{interval}}","rhythm_dotted":"{{name}}, dotted","rhythm_corta":"{{name}}, figura corta","fromHead":"Built on the head of {{source}}"},"leapIntervals":{"fourth":"fourth","tritone":"tritone","fifth":"fifth","sixth":"sixth","seventh":"seventh","octave":"octave"},"sequenceIntervals":{"second":"seconds","third":"thirds","fourth":"fourths","fifth":"fifths","large":"large steps"}},"import":{"title":"Import sheet music","submit":"Import","file":"MusicXML file","drop":"Click or drop a MusicXML file here","hint":".musicxml, .xml or compressed .mxl, up to 10 MB (e.g. exported from MuseScore)","titleLabel":"Title","composer":"Composer","fromFile":"Leave empty to take it from the file.","button":"Import"},"tabs":{"operators":"Operators & graph","transitions":"Transitions of the pattern"},"transitions":{"hint":"Click a found pattern in the sheet or the timeline, or select your own (first and last note of a voice), to see how it moves through the piece.","loading":"Finding the entries of the pattern\u2026"},"language":"Language","analysis":{"menu":"Analysis","export":"Export analysis (.json)","import":"Import analysis (.json)","otherPiece":"This analysis belongs to \\"{{title}}\\". Open that piece first.","imported_one":"{{count}} pattern imported.","imported_other":"{{count}} patterns imported.","invalid":"The analysis could not be imported: {{reason}}"},"family":{"section":"Pattern {{label}}","summary":"{{entries}} in {{voices}}, bars {{first}}\u2013{{last}}: {{same}} same, {{transposed}} transposed, {{changed}} changed.","entries_one":"{{count}} entry","entries_other":"{{count}} entries","voices_one":"{{count}} voice","voices_other":"{{count}} voices","sequences_one":"{{count}} sequence (consecutive transposed entries).","sequences_other":"{{count}} sequences (consecutive transposed entries).","imitations_one":"{{count}} imitation (entries overlapping in time).","imitations_other":"{{count}} imitations (entries overlapping in time).","strip":"Entries of pattern {{label}} per voice over time","voice":"Voice {{voice}}","voiceShort":"{{voice}}","classes":{"same":"Same pitches (first entry, exact or octave copy)","transposed":"Transposed (real or tonal)","changed":"Changed (variant, inversion, retrograde, rhythm)"},"byVoice":"Entries per voice","bySemitones":"Pitch level vs. first entry (semitones)","byStart":"Starting note (key areas)","table":"Entries of pattern {{label}}","columns":{"voice":"Voice","bars":"Bars","start":"Starts on","relation":"Relation","play":"Play"},"playEntry":"Play entry {{index}}","where":"Voice {{voice}}, bar {{bars}}, starting on {{pitch}}","rest":"a rest","semitones":"{{shift}} semitones","relations":{"prototype":"first entry","exact":"exact repetition","real":"real transposition","tonal":"tonal transposition","variant_one":"variant with {{count}} changed note","variant_other":"variant with {{count}} changed notes","inversion":"inversion","retrograde":"retrograde","augmentation":"augmentation","diminution":"diminution"},"glyphs":{"prototype":"1st","tonal":"t","inversion":"Inv","retrograde":"Ret"}},"views":{"sheet":"The sheet","timeline":"The timeline","discovery":"The discovered patterns","operators":"The operators and the graph","transitions":"The transitions"},"errorBoundary":{"title":"{{name}} could not be shown","retry":"Try again"},"timeline":{"page":"Page {{page}}","playHint":"Double-click plays this entry."},"toolbar":{"tour":"Start the tour","exportPDF":"Export the sheet with its patterns as PDF","deleteAll":"Delete all patterns","deleteAllConfirm":"Delete all patterns of this piece?","delete":"Delete","cancel":"Cancel","settings":"Display settings"},"musicSheetError":{"title":"This piece could not be opened","retry":"Try again"},"musicSheetSelection":{"label":"Piece of music"},"audio":{"credit":"Piano: Salamander Grand Piano by Alexander Holm,","failed":"The entry cannot be played: {{reason}}"},"piece":{"player":"Playback of the piece","play":"Play the piece","playFromPage":"Play from this page","pause":"Pause","resume":"Continue","stop":"Stop the piece","tempo":"Tempo (quarter notes per minute)","bar":"Bar {{bar}}","failed":"The piece cannot be played: {{reason}}"},"pageMode":{"group":"Pages of the sheet","a4":"A4","a4Hint":"Printed A4 pages: the music keeps its line and page breaks, zooming only enlarges the paper","fit":"Fit","fitHint":"Pages that fill the view: zooming changes the bars per line, the sheet never scrolls sideways"},"sheetZoom":{"group":"Zoom of the sheet","zoomIn":"Zoom in (+, Ctrl + mouse wheel)","zoomOut":"Zoom out (-, Ctrl + mouse wheel)","original":"Original size (0)"}}');




var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $bb82dabc8f34516e$var$DownOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z"
                }
            }
        ]
    },
    "name": "down",
    "theme": "outlined"
};
var $bb82dabc8f34516e$export$2e2bcd8739ae039 = $bb82dabc8f34516e$var$DownOutlined;



var $5E6i4 = parcelRequire("5E6i4");
function $ee9d4e7b280b4edb$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $ee9d4e7b280b4edb$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $ee9d4e7b280b4edb$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $ee9d4e7b280b4edb$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $ee9d4e7b280b4edb$export$2e2bcd8739ae039 = $ee9d4e7b280b4edb$export$4f5d2d50c9deca37;



var $5E6i4 = parcelRequire("5E6i4");
const $2a60f785f1b30e7d$var$IconContext = /*#__PURE__*/ (0, $5E6i4.createContext)({});
var $2a60f785f1b30e7d$export$2e2bcd8739ae039 = $2a60f785f1b30e7d$var$IconContext;



var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");

const $04f22dc9f1aa87e4$var$APPEND_ORDER = 'data-rc-order';
const $04f22dc9f1aa87e4$var$APPEND_PRIORITY = 'data-rc-priority';
const $04f22dc9f1aa87e4$var$MARK_KEY = 'rc-util-key';
const $04f22dc9f1aa87e4$var$containerCache = new Map();
function $04f22dc9f1aa87e4$var$canUseDom() {
    return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}
function $04f22dc9f1aa87e4$var$contains(root, node) {
    if (!root || !node) return false;
    if (root.contains) return root.contains(node);
    let current = node;
    while(current){
        if (current === root) return true;
        current = current.parentNode;
    }
    return false;
}
function $04f22dc9f1aa87e4$var$getMark({ mark: mark } = {}) {
    if (mark) return mark.startsWith('data-') ? mark : `data-${mark}`;
    return $04f22dc9f1aa87e4$var$MARK_KEY;
}
function $04f22dc9f1aa87e4$var$getContainer(option) {
    if (option.attachTo) return option.attachTo;
    const head = document.querySelector('head');
    return head || document.body;
}
function $04f22dc9f1aa87e4$var$getOrder(prepend) {
    if (prepend === 'queue') return 'prependQueue';
    return prepend ? 'prepend' : 'append';
}
function $04f22dc9f1aa87e4$var$findStyles(container) {
    return Array.from(($04f22dc9f1aa87e4$var$containerCache.get(container) || container).children).filter((node)=>node.tagName === 'STYLE');
}
function $04f22dc9f1aa87e4$var$injectCSS(css, option = {}) {
    if (!$04f22dc9f1aa87e4$var$canUseDom()) return null;
    const { csp: csp, prepend: prepend, priority: priority = 0 } = option;
    const mergedOrder = $04f22dc9f1aa87e4$var$getOrder(prepend);
    const isPrependQueue = mergedOrder === 'prependQueue';
    const styleNode = document.createElement('style');
    styleNode.setAttribute($04f22dc9f1aa87e4$var$APPEND_ORDER, mergedOrder);
    if (isPrependQueue && priority) styleNode.setAttribute($04f22dc9f1aa87e4$var$APPEND_PRIORITY, `${priority}`);
    if (csp?.nonce) styleNode.nonce = csp.nonce;
    styleNode.innerHTML = css;
    const container = $04f22dc9f1aa87e4$var$getContainer(option);
    const { firstChild: firstChild } = container;
    if (prepend) {
        if (isPrependQueue) {
            const existStyle = (option.styles || $04f22dc9f1aa87e4$var$findStyles(container)).filter((node)=>{
                if (![
                    'prepend',
                    'prependQueue'
                ].includes(node.getAttribute($04f22dc9f1aa87e4$var$APPEND_ORDER))) return false;
                const nodePriority = Number(node.getAttribute($04f22dc9f1aa87e4$var$APPEND_PRIORITY) || 0);
                return priority >= nodePriority;
            });
            if (existStyle.length) {
                container.insertBefore(styleNode, existStyle[existStyle.length - 1].nextSibling);
                return styleNode;
            }
        }
        container.insertBefore(styleNode, firstChild);
    } else container.appendChild(styleNode);
    return styleNode;
}
function $04f22dc9f1aa87e4$var$findExistNode(key, option = {}) {
    let { styles: styles } = option;
    styles ||= $04f22dc9f1aa87e4$var$findStyles($04f22dc9f1aa87e4$var$getContainer(option));
    return styles.find((node)=>node.getAttribute($04f22dc9f1aa87e4$var$getMark(option)) === key);
}
function $04f22dc9f1aa87e4$var$syncRealContainer(container, option) {
    const cachedRealContainer = $04f22dc9f1aa87e4$var$containerCache.get(container);
    if (!cachedRealContainer || !$04f22dc9f1aa87e4$var$contains(document, cachedRealContainer)) {
        const placeholderStyle = $04f22dc9f1aa87e4$var$injectCSS('', option);
        if (!placeholderStyle) return;
        const { parentNode: parentNode } = placeholderStyle;
        $04f22dc9f1aa87e4$var$containerCache.set(container, parentNode);
        container.removeChild(placeholderStyle);
    }
}
function $04f22dc9f1aa87e4$export$4d99a2890bb989f0(css, key, originOption = {}) {
    if (!$04f22dc9f1aa87e4$var$canUseDom()) return null;
    const container = $04f22dc9f1aa87e4$var$getContainer(originOption);
    const styles = $04f22dc9f1aa87e4$var$findStyles(container);
    const option = {
        ...originOption,
        styles: styles
    };
    $04f22dc9f1aa87e4$var$syncRealContainer(container, option);
    const existNode = $04f22dc9f1aa87e4$var$findExistNode(key, option);
    if (existNode) {
        if (option.csp?.nonce && existNode.nonce !== option.csp.nonce) existNode.nonce = option.csp.nonce;
        if (existNode.innerHTML !== css) existNode.innerHTML = css;
        return existNode;
    }
    const newNode = $04f22dc9f1aa87e4$var$injectCSS(css, option);
    newNode?.setAttribute($04f22dc9f1aa87e4$var$getMark(option), key);
    return newNode;
}
function $04f22dc9f1aa87e4$var$getRoot(ele) {
    return ele?.getRootNode?.();
}
function $04f22dc9f1aa87e4$export$70e8259662bb498b(ele) {
    const root = $04f22dc9f1aa87e4$var$getRoot(ele);
    return typeof ShadowRoot !== 'undefined' && root instanceof ShadowRoot ? root : null;
}
const $04f22dc9f1aa87e4$var$warned = {};
function $04f22dc9f1aa87e4$export$82934adf09101657(valid, message) {
    if (valid || $04f22dc9f1aa87e4$var$warned[message]) return;
    $04f22dc9f1aa87e4$var$warned[message] = true;
}


function $6b049bda961bd2ba$var$camelCase(input) {
    return input.replace(/-(.)/g, (match, g)=>g.toUpperCase());
}
function $6b049bda961bd2ba$export$491112666e282270(valid, message) {
    (0, $04f22dc9f1aa87e4$export$82934adf09101657)(valid, `[@ant-design/icons] ${message}`);
}
function $6b049bda961bd2ba$export$ab652842c37578f4(target) {
    return target !== null && typeof target === 'object' && typeof target.name === 'string' && typeof target.theme === 'string' && (typeof target.icon === 'object' || typeof target.icon === 'function');
}
function $6b049bda961bd2ba$export$9f5073e7201cc21c(attrs = {}) {
    return Object.keys(attrs).reduce((acc, key)=>{
        const val = attrs[key];
        switch(key){
            case 'class':
                acc.className = val;
                delete acc.class;
                break;
            default:
                delete acc[key];
                acc[$6b049bda961bd2ba$var$camelCase(key)] = val;
        }
        return acc;
    }, {});
}
function $6b049bda961bd2ba$export$80d376111cc09ad7(node, key, rootProps) {
    if (!rootProps) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement(node.tag, {
        key: key,
        ...$6b049bda961bd2ba$export$9f5073e7201cc21c(node.attrs)
    }, (node.children || []).map((child, index)=>$6b049bda961bd2ba$export$80d376111cc09ad7(child, `${key}-${node.tag}-${index}`)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement(node.tag, {
        key: key,
        ...$6b049bda961bd2ba$export$9f5073e7201cc21c(node.attrs),
        ...rootProps
    }, (node.children || []).map((child, index)=>$6b049bda961bd2ba$export$80d376111cc09ad7(child, `${key}-${node.tag}-${index}`)));
}
const $6b049bda961bd2ba$export$960a899a9cccb2d5 = {
    width: '1em',
    height: '1em',
    fill: 'currentColor',
    'aria-hidden': 'true',
    focusable: 'false'
};
const $6b049bda961bd2ba$export$2c99b98b77550cb4 = `
.anticon {
  display: inline-flex;
  align-items: center;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.anticon > * {
  line-height: 1;
}

.anticon svg {
  display: inline-block;
  vertical-align: inherit;
}

.anticon::before {
  display: none;
}

.anticon .anticon-icon {
  display: block;
}

.anticon[tabindex] {
  cursor: pointer;
}

.anticon-spin {
  -webkit-animation: loadingCircle 1s infinite linear;
  animation: loadingCircle 1s infinite linear;
}

@-webkit-keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
`;
const $6b049bda961bd2ba$export$938b1f86b61613d0 = (eleRef)=>{
    const { csp: csp, prefixCls: prefixCls, layer: layer, zeroRuntime: zeroRuntime } = (0, $5E6i4.useContext)((0, $2a60f785f1b30e7d$export$2e2bcd8739ae039));
    let mergedStyleStr = $6b049bda961bd2ba$export$2c99b98b77550cb4;
    if (prefixCls) mergedStyleStr = mergedStyleStr.replace(/anticon/g, prefixCls);
    if (layer) mergedStyleStr = `@layer ${layer} {\n${mergedStyleStr}\n}`;
    (0, $5E6i4.useEffect)(()=>{
        if (zeroRuntime) return;
        const ele = eleRef.current;
        const shadowRoot = (0, $04f22dc9f1aa87e4$export$70e8259662bb498b)(ele);
        (0, $04f22dc9f1aa87e4$export$4d99a2890bb989f0)(mergedStyleStr, '@ant-design-icons', {
            prepend: !layer,
            csp: csp,
            attachTo: shadowRoot
        });
    }, []);
};


const $a5913e4198e2c7a0$var$IconBase = (props)=>{
    const { icon: icon, className: className, onClick: onClick, style: style, primaryColor: _primaryColor, secondaryColor: _secondaryColor, ...restProps } = props;
    const svgRef = $5E6i4.useRef(null);
    (0, $6b049bda961bd2ba$export$938b1f86b61613d0)(svgRef);
    (0, $6b049bda961bd2ba$export$491112666e282270)((0, $6b049bda961bd2ba$export$ab652842c37578f4)(icon), `icon should be icon definiton, but got ${typeof icon}`);
    if (!(0, $6b049bda961bd2ba$export$ab652842c37578f4)(icon)) return null;
    const target = icon;
    return (0, $6b049bda961bd2ba$export$80d376111cc09ad7)(target.icon, `svg-${target.name}`, {
        className: className,
        onClick: onClick,
        style: style,
        'data-icon': target.name,
        width: '1em',
        height: '1em',
        fill: 'currentColor',
        'aria-hidden': 'true',
        ...restProps,
        ref: svgRef
    });
};
$a5913e4198e2c7a0$var$IconBase.displayName = 'IconReact';
var $a5913e4198e2c7a0$export$2e2bcd8739ae039 = $a5913e4198e2c7a0$var$IconBase;



'use client';
function $599f238375a1dc0a$var$_extends() {
    $599f238375a1dc0a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $599f238375a1dc0a$var$_extends.apply(this, arguments);
}
const $599f238375a1dc0a$var$Icon = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { className: // affect outter <i>...</i>
    className, icon: // affect inner <svg>...</svg>
    icon, spin: spin, rotate: rotate, tabIndex: tabIndex, onClick: onClick, twoToneColor: _twoToneColor, // other
    ...restProps } = props;
    const { prefixCls: prefixCls = 'anticon', rootClassName: rootClassName } = $5E6i4.useContext((0, $2a60f785f1b30e7d$export$2e2bcd8739ae039));
    (0, $6b049bda961bd2ba$export$491112666e282270)((0, $6b049bda961bd2ba$export$ab652842c37578f4)(icon), `icon should be icon definiton, but got ${typeof icon}`);
    if (!(0, $6b049bda961bd2ba$export$ab652842c37578f4)(icon)) return null;
    const classString = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(rootClassName, prefixCls, {
        [`${prefixCls}-${icon.name}`]: !!icon.name,
        [`${prefixCls}-spin`]: !!spin || icon.name === 'loading'
    }, className);
    let iconTabIndex = tabIndex;
    if (iconTabIndex === undefined && onClick) iconTabIndex = -1;
    const svgStyle = rotate ? {
        msTransform: `rotate(${rotate}deg)`,
        transform: `rotate(${rotate}deg)`
    } : undefined;
    return /*#__PURE__*/ $5E6i4.createElement("span", $599f238375a1dc0a$var$_extends({
        role: "img",
        "aria-label": icon.name
    }, restProps, {
        ref: ref,
        tabIndex: iconTabIndex,
        onClick: onClick,
        className: classString
    }), /*#__PURE__*/ $5E6i4.createElement((0, $a5913e4198e2c7a0$export$2e2bcd8739ae039), {
        icon: icon,
        style: svgStyle
    }));
});
var $599f238375a1dc0a$export$2e2bcd8739ae039 = $599f238375a1dc0a$var$Icon;


function $55e38791308df946$var$_extends() {
    $55e38791308df946$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $55e38791308df946$var$_extends.apply(this, arguments);
}
const $55e38791308df946$var$DownOutlined = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $55e38791308df946$var$_extends({}, props, {
        ref: ref,
        icon: (0, $bb82dabc8f34516e$export$2e2bcd8739ae039)
    }));
/**![down](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg4NCAyNTZoLTc1Yy01LjEgMC05LjkgMi41LTEyLjkgNi42TDUxMiA2NTQuMiAyMjcuOSAyNjIuNmMtMy00LjEtNy44LTYuNi0xMi45LTYuNmgtNzVjLTYuNSAwLTEwLjMgNy40LTYuNSAxMi43bDM1Mi42IDQ4Ni4xYzEyLjggMTcuNiAzOSAxNy42IDUxLjcgMGwzNTIuNi00ODYuMWMzLjktNS4zLjEtMTIuNy02LjQtMTIuN3oiIC8+PC9zdmc+) */ const $55e38791308df946$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($55e38791308df946$var$DownOutlined);
var $55e38791308df946$export$2e2bcd8739ae039 = $55e38791308df946$var$RefIcon;


var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $d3467892aea546b6$var$FolderOpenOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 00-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z"
                }
            }
        ]
    },
    "name": "folder-open",
    "theme": "outlined"
};
var $d3467892aea546b6$export$2e2bcd8739ae039 = $d3467892aea546b6$var$FolderOpenOutlined;



function $492357fb2ab06613$var$_extends() {
    $492357fb2ab06613$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $492357fb2ab06613$var$_extends.apply(this, arguments);
}
const $492357fb2ab06613$var$FolderOpenOutlined = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $492357fb2ab06613$var$_extends({}, props, {
        ref: ref,
        icon: (0, $d3467892aea546b6$export$2e2bcd8739ae039)
    }));
/**![folder-open](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkyOCA0NDRIODIwVjMzMC40YzAtMTcuNy0xNC4zLTMyLTMyLTMySDQ3M0wzNTUuNyAxODYuMmE4LjE1IDguMTUgMCAwMC01LjUtMi4ySDk2Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnY1OTJjMCAxNy43IDE0LjMgMzIgMzIgMzJoNjk4YzEzIDAgMjQuOC03LjkgMjkuNy0yMGwxMzQtMzMyYzEuNS0zLjggMi4zLTcuOSAyLjMtMTIgMC0xNy43LTE0LjMtMzItMzItMzJ6TTEzNiAyNTZoMTg4LjVsMTE5LjYgMTE0LjRINzQ4VjQ0NEgyMzhjLTEzIDAtMjQuOCA3LjktMjkuNyAyMEwxMzYgNjQzLjJWMjU2em02MzUuMyA1MTJIMTU5bDEwMy4zLTI1Nmg2MTIuNEw3NzEuMyA3Njh6IiAvPjwvc3ZnPg==) */ const $492357fb2ab06613$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($492357fb2ab06613$var$FolderOpenOutlined);
var $492357fb2ab06613$export$2e2bcd8739ae039 = $492357fb2ab06613$var$RefIcon;


var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $a9885ef88a4b35fa$var$ImportOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "fill-rule": "evenodd",
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M880 912H144c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32h360c4.4 0 8 3.6 8 8v56c0 4.4-3.6 8-8 8H184v656h656V520c0-4.4 3.6-8 8-8h56c4.4 0 8 3.6 8 8v360c0 17.7-14.3 32-32 32zM653.3 424.6l52.2 52.2a8.01 8.01 0 01-4.7 13.6l-179.4 21c-5.1.6-9.5-3.7-8.9-8.9l21-179.4c.8-6.6 8.9-9.4 13.6-4.7l52.4 52.4 256.2-256.2c3.1-3.1 8.2-3.1 11.3 0l42.4 42.4c3.1 3.1 3.1 8.2 0 11.3L653.3 424.6z"
                }
            }
        ]
    },
    "name": "import",
    "theme": "outlined"
};
var $a9885ef88a4b35fa$export$2e2bcd8739ae039 = $a9885ef88a4b35fa$var$ImportOutlined;



function $6b83eb880a64fd9b$var$_extends() {
    $6b83eb880a64fd9b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6b83eb880a64fd9b$var$_extends.apply(this, arguments);
}
const $6b83eb880a64fd9b$var$ImportOutlined = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $6b83eb880a64fd9b$var$_extends({}, props, {
        ref: ref,
        icon: (0, $a9885ef88a4b35fa$export$2e2bcd8739ae039)
    }));
/**![import](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdmlld0JveD0iNjQgNjQgODk2IDg5NiIgZm9jdXNhYmxlPSJmYWxzZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNODgwIDkxMkgxNDRjLTE3LjcgMC0zMi0xNC4zLTMyLTMyVjE0NGMwLTE3LjcgMTQuMy0zMiAzMi0zMmgzNjBjNC40IDAgOCAzLjYgOCA4djU2YzAgNC40LTMuNiA4LTggOEgxODR2NjU2aDY1NlY1MjBjMC00LjQgMy42LTggOC04aDU2YzQuNCAwIDggMy42IDggOHYzNjBjMCAxNy43LTE0LjMgMzItMzIgMzJ6TTY1My4zIDQyNC42bDUyLjIgNTIuMmE4LjAxIDguMDEgMCAwMS00LjcgMTMuNmwtMTc5LjQgMjFjLTUuMS42LTkuNS0zLjctOC45LTguOWwyMS0xNzkuNGMuOC02LjYgOC45LTkuNCAxMy42LTQuN2w1Mi40IDUyLjQgMjU2LjItMjU2LjJjMy4xLTMuMSA4LjItMy4xIDExLjMgMGw0Mi40IDQyLjRjMy4xIDMuMSAzLjEgOC4yIDAgMTEuM0w2NTMuMyA0MjQuNnoiIC8+PC9zdmc+) */ const $6b83eb880a64fd9b$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($6b83eb880a64fd9b$var$ImportOutlined);
var $6b83eb880a64fd9b$export$2e2bcd8739ae039 = $6b83eb880a64fd9b$var$RefIcon;


var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $bc981a82b52eab2e$var$SaveOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M893.3 293.3L730.7 130.7c-7.5-7.5-16.7-13-26.7-16V112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 184h256v104H384V184zm456 656H184V184h136v136c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V205.8l136 136V840zM512 442c-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144zm0 224c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z"
                }
            }
        ]
    },
    "name": "save",
    "theme": "outlined"
};
var $bc981a82b52eab2e$export$2e2bcd8739ae039 = $bc981a82b52eab2e$var$SaveOutlined;



function $dd5f5231574dd3a6$var$_extends() {
    $dd5f5231574dd3a6$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dd5f5231574dd3a6$var$_extends.apply(this, arguments);
}
const $dd5f5231574dd3a6$var$SaveOutlined = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $dd5f5231574dd3a6$var$_extends({}, props, {
        ref: ref,
        icon: (0, $bc981a82b52eab2e$export$2e2bcd8739ae039)
    }));
/**![save](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg5My4zIDI5My4zTDczMC43IDEzMC43Yy03LjUtNy41LTE2LjctMTMtMjYuNy0xNlYxMTJIMTQ0Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnY3MzZjMCAxNy43IDE0LjMgMzIgMzIgMzJoNzM2YzE3LjcgMCAzMi0xNC4zIDMyLTMyVjMzOC41YzAtMTctNi43LTMzLjItMTguNy00NS4yek0zODQgMTg0aDI1NnYxMDRIMzg0VjE4NHptNDU2IDY1NkgxODRWMTg0aDEzNnYxMzZjMCAxNy43IDE0LjMgMzIgMzIgMzJoMzIwYzE3LjcgMCAzMi0xNC4zIDMyLTMyVjIwNS44bDEzNiAxMzZWODQwek01MTIgNDQyYy03OS41IDAtMTQ0IDY0LjUtMTQ0IDE0NHM2NC41IDE0NCAxNDQgMTQ0IDE0NC02NC41IDE0NC0xNDQtNjQuNS0xNDQtMTQ0LTE0NHptMCAyMjRjLTQ0LjIgMC04MC0zNS44LTgwLTgwczM1LjgtODAgODAtODAgODAgMzUuOCA4MCA4MC0zNS44IDgwLTgwIDgweiIgLz48L3N2Zz4=) */ const $dd5f5231574dd3a6$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($dd5f5231574dd3a6$var$SaveOutlined);
var $dd5f5231574dd3a6$export$2e2bcd8739ae039 = $dd5f5231574dd3a6$var$RefIcon;



var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");
function $8999424b1723e3cc$export$2e2bcd8739ae039(allowClear) {
    return $5E6i4.useMemo(()=>allowClear && typeof allowClear === 'object' ? {
            ...allowClear,
            disabled: allowClear.disabled ?? false
        } : {
            disabled: !allowClear
        }, [
        allowClear
    ]);
}



var $5E6i4 = parcelRequire("5E6i4");
const $68990f4402d2f009$var$useEvent = (callback)=>{
    const fnRef = $5E6i4.useRef(callback);
    fnRef.current = callback;
    const memoFn = $5E6i4.useCallback((...args)=>fnRef.current?.(...args), []);
    return memoFn;
};
var $68990f4402d2f009$export$2e2bcd8739ae039 = $68990f4402d2f009$var$useEvent;




var $5E6i4 = parcelRequire("5E6i4");
function $8b91ba628d942bf2$export$2e2bcd8739ae039() {
    return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}


/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */ const $518ae471aa4f03a7$var$useInternalLayoutEffect = (0, $8b91ba628d942bf2$export$2e2bcd8739ae039)() ? $5E6i4.useLayoutEffect : $5E6i4.useEffect;
const $518ae471aa4f03a7$var$useLayoutEffect = (callback, deps)=>{
    const firstMountRef = $5E6i4.useRef(true);
    $518ae471aa4f03a7$var$useInternalLayoutEffect(()=>{
        return callback(firstMountRef.current);
    }, deps);
    // We tell react that first mount has passed
    $518ae471aa4f03a7$var$useInternalLayoutEffect(()=>{
        firstMountRef.current = false;
        return ()=>{
            firstMountRef.current = true;
        };
    }, []);
};
const $518ae471aa4f03a7$export$9283e56bae2f7b0f = (callback, deps)=>{
    $518ae471aa4f03a7$var$useLayoutEffect((firstMount)=>{
        if (!firstMount) return callback();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};
var $518ae471aa4f03a7$export$2e2bcd8739ae039 = $518ae471aa4f03a7$var$useLayoutEffect;



var $5E6i4 = parcelRequire("5E6i4");
/**
 * Same as React.useState but `setState` accept `ignoreDestroy` param to not to setState after destroyed.
 * We do not make this auto is to avoid real memory leak.
 * Developer should confirm it's safe to ignore themselves.
 */ const $42260c70cd082563$var$useSafeState = (defaultValue)=>{
    const destroyRef = $5E6i4.useRef(false);
    const [value, setValue] = $5E6i4.useState(defaultValue);
    $5E6i4.useEffect(()=>{
        destroyRef.current = false;
        return ()=>{
            destroyRef.current = true;
        };
    }, []);
    function safeSetState(updater, ignoreDestroy) {
        if (ignoreDestroy && destroyRef.current) return;
        setValue(updater);
    }
    return [
        value,
        safeSetState
    ];
};
var $42260c70cd082563$export$2e2bcd8739ae039 = $42260c70cd082563$var$useSafeState;


/** We only think `undefined` is empty */ function $f96888894b7a985e$var$hasValue(value) {
    return value !== undefined;
}
function $f96888894b7a985e$export$2e2bcd8739ae039(defaultStateValue, option) {
    const { defaultValue: defaultValue, value: value, onChange: onChange, postState: postState } = option || {};
    // ======================= Init =======================
    const [innerValue, setInnerValue] = (0, $42260c70cd082563$export$2e2bcd8739ae039)(()=>{
        if ($f96888894b7a985e$var$hasValue(value)) return value;
        else if ($f96888894b7a985e$var$hasValue(defaultValue)) return typeof defaultValue === 'function' ? defaultValue() : defaultValue;
        else return typeof defaultStateValue === 'function' ? defaultStateValue() : defaultStateValue;
    });
    const mergedValue = value !== undefined ? value : innerValue;
    const postMergedValue = postState ? postState(mergedValue) : mergedValue;
    // ====================== Change ======================
    const onChangeFn = (0, $68990f4402d2f009$export$2e2bcd8739ae039)(onChange);
    const [prevValue, setPrevValue] = (0, $42260c70cd082563$export$2e2bcd8739ae039)([
        mergedValue
    ]);
    (0, $518ae471aa4f03a7$export$9283e56bae2f7b0f)(()=>{
        const prev = prevValue[0];
        if (innerValue !== prev) onChangeFn(innerValue, prev);
    }, [
        prevValue
    ]);
    // Sync value back to `undefined` when it from control to un-control
    (0, $518ae471aa4f03a7$export$9283e56bae2f7b0f)(()=>{
        if (!$f96888894b7a985e$var$hasValue(value)) setInnerValue(value);
    }, [
        value
    ]);
    // ====================== Update ======================
    const triggerChange = (0, $68990f4402d2f009$export$2e2bcd8739ae039)((updater, ignoreDestroy)=>{
        setInnerValue(updater, ignoreDestroy);
        setPrevValue([
            mergedValue
        ], ignoreDestroy);
    });
    return [
        postMergedValue,
        triggerChange
    ];
}



var $5E6i4 = parcelRequire("5E6i4");

function $e18df22f16a16360$export$2e2bcd8739ae039(defaultStateValue, value) {
    const [innerValue, setInnerValue] = (0, $5E6i4.useState)(defaultStateValue);
    const mergedValue = value !== undefined ? value : innerValue;
    (0, $518ae471aa4f03a7$export$2e2bcd8739ae039)((mount)=>{
        if (!mount) setInnerValue(value);
    }, [
        value
    ]);
    return [
        // Value
        mergedValue,
        // Update function
        setInnerValue
    ];
}



var $5E6i4 = parcelRequire("5E6i4");
let $1d949665862f071a$var$raf = (callback)=>+setTimeout(callback, 16);
let $1d949665862f071a$var$caf = (num)=>clearTimeout(num);
if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
    $1d949665862f071a$var$raf = (callback)=>window.requestAnimationFrame(callback);
    $1d949665862f071a$var$caf = (handle)=>window.cancelAnimationFrame(handle);
}
let $1d949665862f071a$var$rafUUID = 0;
const $1d949665862f071a$var$rafIds = new Map();
function $1d949665862f071a$var$cleanup(id) {
    $1d949665862f071a$var$rafIds.delete(id);
}
const $1d949665862f071a$var$wrapperRaf = (callback, times = 1)=>{
    $1d949665862f071a$var$rafUUID += 1;
    const id = $1d949665862f071a$var$rafUUID;
    function callRef(leftTimes) {
        if (leftTimes === 0) {
            // Clean up
            $1d949665862f071a$var$cleanup(id);
            // Trigger
            callback();
        } else {
            // Next raf
            const realId = $1d949665862f071a$var$raf(()=>{
                callRef(leftTimes - 1);
            });
            // Bind real raf id
            $1d949665862f071a$var$rafIds.set(id, realId);
        }
    }
    callRef(times);
    return id;
};
$1d949665862f071a$var$wrapperRaf.cancel = (id)=>{
    const realId = $1d949665862f071a$var$rafIds.get(id);
    $1d949665862f071a$var$cleanup(id);
    return $1d949665862f071a$var$caf(realId);
};
var $1d949665862f071a$export$2e2bcd8739ae039 = $1d949665862f071a$var$wrapperRaf;



function $2114fb66f76f632e$export$2e2bcd8739ae039(defaultValue) {
    const [value, setValue] = $5E6i4.useState(defaultValue);
    const delayRef = $5E6i4.useRef(null);
    const cancelPending = (0, $68990f4402d2f009$export$2e2bcd8739ae039)(()=>{
        if (delayRef.current) {
            const [isRaf, delay] = delayRef.current;
            if (isRaf) (0, $1d949665862f071a$export$2e2bcd8739ae039).cancel(delay);
            else clearTimeout(delay);
            delayRef.current = null;
        }
    });
    $5E6i4.useEffect(()=>cancelPending, [
        cancelPending
    ]);
    const setDelayValue = (0, $68990f4402d2f009$export$2e2bcd8739ae039)((nextValue, immediatelyOrDelay)=>{
        const delayConfig = immediatelyOrDelay || {
            frame: 1
        };
        cancelPending();
        if (delayConfig === true) setValue(nextValue);
        else if ('ms' in delayConfig) delayRef.current = [
            false,
            setTimeout(()=>setValue(nextValue), delayConfig.ms)
        ];
        else delayRef.current = [
            true,
            (0, $1d949665862f071a$export$2e2bcd8739ae039)(()=>setValue(nextValue), delayConfig.frame)
        ];
    });
    return [
        value,
        setDelayValue
    ];
}



var $5E6i4 = parcelRequire("5E6i4");
function $378d6dcdebc6b864$var$getUseId() {
    // We need fully clone React function here to avoid webpack warning React 17 do not export `useId`
    const fullClone = {
        ...$5E6i4
    };
    return fullClone.useId;
}
let $378d6dcdebc6b864$var$uuid = 0;
function $378d6dcdebc6b864$export$2f0435a662835942() {}
function $378d6dcdebc6b864$export$218c8c3169c024d2(prefix, key) {
    // React.Key can be string | number, convert to string first
    const keyStr = String(key);
    // Valid id characters: letters, digits, hyphen, underscore, colon, period
    // Replace all invalid characters (including spaces) with hyphens to preserve length
    const sanitizedKey = keyStr.replace(/[^a-zA-Z0-9_.:-]/g, '-');
    return `${prefix}-${sanitizedKey}`;
}
const $378d6dcdebc6b864$var$useOriginId = $378d6dcdebc6b864$var$getUseId();
var $378d6dcdebc6b864$export$2e2bcd8739ae039 = $378d6dcdebc6b864$var$useOriginId ? // Use React `useId`
function useId(id) {
    const reactId = $378d6dcdebc6b864$var$useOriginId();
    // Developer passed id is single source of truth
    if (id) return id;
    return reactId;
} : // Use compatible of `useId`
function useCompatId(id) {
    // Inner id for accessibility usage. Only work in client side
    const [innerId, setInnerId] = $5E6i4.useState('ssr-id');
    $5E6i4.useEffect(()=>{
        const nextId = $378d6dcdebc6b864$var$uuid;
        $378d6dcdebc6b864$var$uuid += 1;
        setInnerId(`rc_unique_${nextId}`);
    }, []);
    // Developer passed id is single source of truth
    if (id) return id;
    // Return react native id or inner id
    return innerId;
};




var $5E6i4 = parcelRequire("5E6i4");
function $8ae08502d6a327d3$export$2e2bcd8739ae039(getValue, condition, shouldUpdate) {
    const cacheRef = $5E6i4.useRef({});
    if (!('value' in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
        cacheRef.current.value = getValue();
        cacheRef.current.condition = condition;
    }
    return cacheRef.current.value;
}




var $5E6i4 = parcelRequire("5E6i4");

/**
 * Same as React.useState but will always get latest state.
 * This is useful when React merge multiple state updates into one.
 * e.g. onTransitionEnd trigger multiple event at once will be merged state update in React.
 */ function $63d9459522a935af$var$useSyncState(defaultValue) {
    const [, forceUpdate] = $5E6i4.useReducer((x)=>x + 1, 0);
    const currentValueRef = $5E6i4.useRef(defaultValue);
    const getValue = (0, $68990f4402d2f009$export$2e2bcd8739ae039)(()=>{
        return currentValueRef.current;
    });
    const setValue = (0, $68990f4402d2f009$export$2e2bcd8739ae039)((updater)=>{
        currentValueRef.current = typeof updater === 'function' ? updater(currentValueRef.current) : updater;
        forceUpdate();
    });
    return [
        getValue,
        setValue
    ];
}
var $63d9459522a935af$export$2e2bcd8739ae039 = $63d9459522a935af$var$useSyncState;



var $5E6i4 = parcelRequire("5E6i4");
var $d2a0a99cd9e126a2$exports = {};
'use strict';

$d2a0a99cd9e126a2$exports = (parcelRequire("WFrUG"));



const $e01be70370d1f66a$var$REACT_ELEMENT_TYPE_18 = Symbol.for('react.element');
const $e01be70370d1f66a$var$REACT_ELEMENT_TYPE_19 = Symbol.for('react.transitional.element');
const $e01be70370d1f66a$var$REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
function $e01be70370d1f66a$export$2e2bcd8739ae039(object) {
    return(// Base object type
    object && typeof object === 'object' && // React Element type
    (object.$$typeof === $e01be70370d1f66a$var$REACT_ELEMENT_TYPE_18 || object.$$typeof === $e01be70370d1f66a$var$REACT_ELEMENT_TYPE_19) && // React Fragment type
    object.type === $e01be70370d1f66a$var$REACT_FRAGMENT_TYPE);
}


const $92c8c75386168ffc$var$ReactMajorVersion = Number((0, $5E6i4.version)?.split('.')[0]);
const $92c8c75386168ffc$export$f17fd18fa51dcb5b = (ref, node)=>{
    if (typeof ref === 'function') ref(node);
    else if (typeof ref === 'object' && ref && 'current' in ref) ref.current = node;
};
const $92c8c75386168ffc$export$ab452c34e8e05029 = (...refs)=>{
    const refList = refs.filter(Boolean);
    if (refList.length <= 1) return refList[0];
    return (node)=>{
        refs.forEach((ref)=>{
            $92c8c75386168ffc$export$f17fd18fa51dcb5b(ref, node);
        });
    };
};
const $92c8c75386168ffc$export$1d1c999670a1285d = (...refs)=>{
    return (0, $8ae08502d6a327d3$export$2e2bcd8739ae039)(()=>$92c8c75386168ffc$export$ab452c34e8e05029(...refs), // eslint-disable-next-line react-hooks/exhaustive-deps
    refs, (prev, next)=>prev.length !== next.length || prev.every((ref, i)=>ref !== next[i]));
};
const $92c8c75386168ffc$export$c1cec34af06bcf7 = (nodeOrComponent)=>{
    if (!nodeOrComponent) return false;
    // React 19 no need `forwardRef` anymore. So just pass if is a React element.
    if ($92c8c75386168ffc$var$isReactElement(nodeOrComponent) && $92c8c75386168ffc$var$ReactMajorVersion >= 19) return true;
    const type = (0, $d2a0a99cd9e126a2$exports.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
    // Function component node
    if (typeof type === 'function' && !type.prototype?.render && type.$$typeof !== (0, $d2a0a99cd9e126a2$exports.ForwardRef)) return false;
    // Class component
    if (typeof nodeOrComponent === 'function' && !nodeOrComponent.prototype?.render && nodeOrComponent.$$typeof !== (0, $d2a0a99cd9e126a2$exports.ForwardRef)) return false;
    return true;
};
function $92c8c75386168ffc$var$isReactElement(node) {
    return /*#__PURE__*/ (0, $5E6i4.isValidElement)(node) && !(0, $e01be70370d1f66a$export$2e2bcd8739ae039)(node);
}
const $92c8c75386168ffc$export$b51ae67c7882a242 = (node)=>{
    return $92c8c75386168ffc$var$isReactElement(node) && $92c8c75386168ffc$export$c1cec34af06bcf7(node);
};
const $92c8c75386168ffc$export$7465e5c0bf44f19a = (node)=>{
    if (node && $92c8c75386168ffc$var$isReactElement(node)) {
        const ele = node;
        // Source from:
        // https://github.com/mui/material-ui/blob/master/packages/mui-utils/src/getReactNodeRef/getReactNodeRef.ts
        return ele.props.propertyIsEnumerable('ref') ? ele.props.ref : ele.ref;
    }
    return null;
};



function $e13c8a0b3403715d$export$2e2bcd8739ae039(root, n) {
    if (!root) return false;
    // Use native if support
    if (root.contains) return root.contains(n);
    // `document.contains` not support with IE11
    let node = n;
    while(node){
        if (node === root) return true;
        node = node.parentNode;
    }
    return false;
}




const $d5dd4df2f97e6f98$var$APPEND_ORDER = 'data-rc-order';
const $d5dd4df2f97e6f98$var$APPEND_PRIORITY = 'data-rc-priority';
const $d5dd4df2f97e6f98$var$MARK_KEY = `rc-util-key`;
const $d5dd4df2f97e6f98$var$containerCache = new Map();
function $d5dd4df2f97e6f98$var$getMark({ mark: mark } = {}) {
    if (mark) return mark.startsWith('data-') ? mark : `data-${mark}`;
    return $d5dd4df2f97e6f98$var$MARK_KEY;
}
function $d5dd4df2f97e6f98$var$getContainer(option) {
    if (option.attachTo) return option.attachTo;
    const head = document.querySelector('head');
    return head || document.body;
}
function $d5dd4df2f97e6f98$var$getOrder(prepend) {
    if (prepend === 'queue') return 'prependQueue';
    return prepend ? 'prepend' : 'append';
}
/**
 * Find style which inject by rc-util
 */ function $d5dd4df2f97e6f98$var$findStyles(container) {
    if (!container) return [];
    return Array.from(($d5dd4df2f97e6f98$var$containerCache.get(container) || container).children).filter((node)=>node.tagName === 'STYLE');
}
function $d5dd4df2f97e6f98$export$1ab5838465dbd10a(css, option = {}) {
    if (!(0, $8b91ba628d942bf2$export$2e2bcd8739ae039)()) return null;
    const { csp: csp, prepend: prepend, priority: priority = 0 } = option;
    const mergedOrder = $d5dd4df2f97e6f98$var$getOrder(prepend);
    const isPrependQueue = mergedOrder === 'prependQueue';
    const styleNode = document.createElement('style');
    styleNode.setAttribute($d5dd4df2f97e6f98$var$APPEND_ORDER, mergedOrder);
    if (isPrependQueue && priority) styleNode.setAttribute($d5dd4df2f97e6f98$var$APPEND_PRIORITY, `${priority}`);
    if (csp?.nonce) styleNode.nonce = csp?.nonce;
    styleNode.innerHTML = css;
    const container = $d5dd4df2f97e6f98$var$getContainer(option);
    if (!container) return null;
    const { firstChild: firstChild } = container;
    if (prepend) {
        // If is queue `prepend`, it will prepend first style and then append rest style
        if (isPrependQueue) {
            const existStyle = (option.styles || $d5dd4df2f97e6f98$var$findStyles(container)).filter((node)=>{
                // Ignore style which not injected by rc-util with prepend
                if (![
                    'prepend',
                    'prependQueue'
                ].includes(node.getAttribute($d5dd4df2f97e6f98$var$APPEND_ORDER))) return false;
                // Ignore style which priority less then new style
                const nodePriority = Number(node.getAttribute($d5dd4df2f97e6f98$var$APPEND_PRIORITY) || 0);
                return priority >= nodePriority;
            });
            if (existStyle.length) {
                container.insertBefore(styleNode, existStyle[existStyle.length - 1].nextSibling);
                return styleNode;
            }
        }
        // Use `insertBefore` as `prepend`
        container.insertBefore(styleNode, firstChild);
    } else container.appendChild(styleNode);
    return styleNode;
}
function $d5dd4df2f97e6f98$var$findExistNode(key, option = {}) {
    let { styles: styles } = option;
    styles ||= $d5dd4df2f97e6f98$var$findStyles($d5dd4df2f97e6f98$var$getContainer(option));
    return styles.find((node)=>node.getAttribute($d5dd4df2f97e6f98$var$getMark(option)) === key);
}
function $d5dd4df2f97e6f98$export$2232e336aecaa80a(key, option = {}) {
    const existNode = $d5dd4df2f97e6f98$var$findExistNode(key, option);
    if (existNode) {
        const container = $d5dd4df2f97e6f98$var$getContainer(option);
        container?.removeChild(existNode);
    }
}
/**
 * qiankun will inject `appendChild` to insert into other
 */ function $d5dd4df2f97e6f98$var$syncRealContainer(container, option) {
    const cachedRealContainer = $d5dd4df2f97e6f98$var$containerCache.get(container);
    // Find real container when not cached or cached container removed
    if (!cachedRealContainer || !(0, $e13c8a0b3403715d$export$2e2bcd8739ae039)(document, cachedRealContainer)) {
        const placeholderStyle = $d5dd4df2f97e6f98$export$1ab5838465dbd10a('', option);
        if (!placeholderStyle) return;
        const { parentNode: parentNode } = placeholderStyle;
        $d5dd4df2f97e6f98$var$containerCache.set(container, parentNode);
        container.removeChild(placeholderStyle);
    }
}
function $d5dd4df2f97e6f98$export$f80df667f2f5a272() {
    $d5dd4df2f97e6f98$var$containerCache.clear();
}
function $d5dd4df2f97e6f98$export$4d99a2890bb989f0(css, key, originOption = {}) {
    const container = $d5dd4df2f97e6f98$var$getContainer(originOption);
    if (!container) return null;
    const styles = $d5dd4df2f97e6f98$var$findStyles(container);
    const option = {
        ...originOption,
        styles: styles
    };
    // Sync real parent
    $d5dd4df2f97e6f98$var$syncRealContainer(container, option);
    const existNode = $d5dd4df2f97e6f98$var$findExistNode(key, option);
    if (existNode) {
        if (option.csp?.nonce && existNode.nonce !== option.csp?.nonce) existNode.nonce = option.csp?.nonce;
        if (existNode.innerHTML !== css) existNode.innerHTML = css;
        return existNode;
    }
    const newNode = $d5dd4df2f97e6f98$export$1ab5838465dbd10a(css, option);
    if (!newNode) return null;
    newNode.setAttribute($d5dd4df2f97e6f98$var$getMark(option), key);
    return newNode;
}


function $b1bf69966442e513$export$41e30d8dd0ba7a50(node) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Element
    // Since XULElement is also subclass of Element, we only need HTMLElement and SVGElement
    return node instanceof HTMLElement || node instanceof SVGElement;
}
function $b1bf69966442e513$export$9aa546fdc20ae5b3(node) {
    if (node && typeof node === 'object' && $b1bf69966442e513$export$41e30d8dd0ba7a50(node.nativeElement)) return node.nativeElement;
    if ($b1bf69966442e513$export$41e30d8dd0ba7a50(node)) return node;
    return null;
}
function $b1bf69966442e513$export$2e2bcd8739ae039(node) {
    const domNode = $b1bf69966442e513$export$9aa546fdc20ae5b3(node);
    if (domNode) return domNode;
    if (node && typeof node === 'object' && 'current' in node) {
        const refDomNode = $b1bf69966442e513$export$9aa546fdc20ae5b3(node.current);
        if (refDomNode) return refDomNode;
    }
    return null;
}



var $5E6i4 = parcelRequire("5E6i4");
var $8fba40dfe94c55fb$export$2e2bcd8739ae039 = (element)=>{
    if (!element) return false;
    if (element instanceof Element) {
        if (element.offsetParent) return true;
        if (element.getBBox) {
            const { width: width, height: height } = element.getBBox();
            if (width || height) return true;
        }
        if (element.getBoundingClientRect) {
            const { width: width, height: height } = element.getBoundingClientRect();
            if (width || height) return true;
        }
    }
    return false;
};



function $806ab00ed04609c6$var$focusable(node, includePositive = false) {
    if ((0, $8fba40dfe94c55fb$export$2e2bcd8739ae039)(node)) {
        const nodeName = node.nodeName.toLowerCase();
        const isFocusableElement = // Focusable element
        [
            'input',
            'select',
            'textarea',
            'button'
        ].includes(nodeName) || // Editable element
        node.isContentEditable || // Anchor with href element
        nodeName === 'a' && !!node.getAttribute('href');
        // Get tabIndex
        const tabIndexAttr = node.getAttribute('tabindex');
        const tabIndexNum = Number(tabIndexAttr);
        // Parse as number if validate
        let tabIndex = null;
        if (tabIndexAttr && !Number.isNaN(tabIndexNum)) tabIndex = tabIndexNum;
        else if (isFocusableElement && tabIndex === null) tabIndex = 0;
        // Block focusable if disabled
        if (isFocusableElement && node.disabled) tabIndex = null;
        return tabIndex !== null && (tabIndex >= 0 || includePositive && tabIndex < 0);
    }
    return false;
}
function $806ab00ed04609c6$export$bbc7b5f11aba534b(node, includePositive = false) {
    const res = [
        ...node.querySelectorAll('*')
    ].filter((child)=>{
        return $806ab00ed04609c6$var$focusable(child, includePositive);
    });
    if ($806ab00ed04609c6$var$focusable(node, includePositive)) res.unshift(node);
    return res;
}
function $806ab00ed04609c6$export$2b92016deb0b7aad(element, option) {
    if (!element) return;
    element.focus(option);
    // Selection content
    const { cursor: cursor } = option || {};
    if (cursor && (element instanceof HTMLInputElement || element instanceof HTMLTextAreaElement)) {
        const len = element.value.length;
        switch(cursor){
            case 'start':
                element.setSelectionRange(0, 0);
                break;
            case 'end':
                element.setSelectionRange(len, len);
                break;
            default:
                element.setSelectionRange(0, len);
        }
    }
}
// ======================================================
// ==                    Lock Focus                    ==
// ======================================================
let $806ab00ed04609c6$var$lastFocusElement = null;
let $806ab00ed04609c6$var$focusElements = [];
// Map stable ID to lock element
const $806ab00ed04609c6$var$idToElementMap = new Map();
// Map stable ID to ignored element
const $806ab00ed04609c6$var$ignoredElementMap = new Map();
function $806ab00ed04609c6$var$getLastElement() {
    return $806ab00ed04609c6$var$focusElements[$806ab00ed04609c6$var$focusElements.length - 1];
}
function $806ab00ed04609c6$var$isIgnoredElement(element) {
    const lastElement = $806ab00ed04609c6$var$getLastElement();
    if (element && lastElement) {
        // Find the ID that maps to the last element
        let lockId;
        for (const [id, ele] of $806ab00ed04609c6$var$idToElementMap.entries())if (ele === lastElement) {
            lockId = id;
            break;
        }
        const ignoredEle = $806ab00ed04609c6$var$ignoredElementMap.get(lockId);
        return !!ignoredEle && (ignoredEle === element || ignoredEle.contains(element));
    }
    return false;
}
function $806ab00ed04609c6$var$hasFocus(element) {
    const { activeElement: activeElement } = document;
    return element === activeElement || element.contains(activeElement);
}
function $806ab00ed04609c6$var$syncFocus() {
    const lastElement = $806ab00ed04609c6$var$getLastElement();
    const { activeElement: activeElement } = document;
    // If current focus is on an ignored element, don't force it back
    if ($806ab00ed04609c6$var$isIgnoredElement(activeElement)) return;
    if (lastElement && !$806ab00ed04609c6$var$hasFocus(lastElement)) {
        const focusableList = $806ab00ed04609c6$export$bbc7b5f11aba534b(lastElement);
        const matchElement = focusableList.includes($806ab00ed04609c6$var$lastFocusElement) ? $806ab00ed04609c6$var$lastFocusElement : focusableList[0];
        matchElement?.focus({
            preventScroll: true
        });
    } else $806ab00ed04609c6$var$lastFocusElement = activeElement;
}
function $806ab00ed04609c6$var$onWindowKeyDown(e) {
    if (e.key === 'Tab') {
        const { activeElement: activeElement } = document;
        const lastElement = $806ab00ed04609c6$var$getLastElement();
        const focusableList = $806ab00ed04609c6$export$bbc7b5f11aba534b(lastElement);
        const last = focusableList[focusableList.length - 1];
        if (e.shiftKey && activeElement === focusableList[0]) // Tab backward on first focusable element
        $806ab00ed04609c6$var$lastFocusElement = last;
        else if (!e.shiftKey && activeElement === last) // Tab forward on last focusable element
        $806ab00ed04609c6$var$lastFocusElement = focusableList[0];
    }
}
function $806ab00ed04609c6$export$a71918e269a02274(element, id) {
    if (element) {
        // Store the mapping between ID and element
        $806ab00ed04609c6$var$idToElementMap.set(id, element);
        // Refresh focus elements
        $806ab00ed04609c6$var$focusElements = $806ab00ed04609c6$var$focusElements.filter((ele)=>ele !== element);
        $806ab00ed04609c6$var$focusElements.push(element);
        // Just add event since it will de-duplicate
        window.addEventListener('focusin', $806ab00ed04609c6$var$syncFocus);
        window.addEventListener('keydown', $806ab00ed04609c6$var$onWindowKeyDown, true);
        $806ab00ed04609c6$var$syncFocus();
    }
    // Always return unregister function
    return ()=>{
        $806ab00ed04609c6$var$lastFocusElement = null;
        $806ab00ed04609c6$var$focusElements = $806ab00ed04609c6$var$focusElements.filter((ele)=>ele !== element);
        $806ab00ed04609c6$var$idToElementMap.delete(id);
        $806ab00ed04609c6$var$ignoredElementMap.delete(id);
        if ($806ab00ed04609c6$var$focusElements.length === 0) {
            window.removeEventListener('focusin', $806ab00ed04609c6$var$syncFocus);
            window.removeEventListener('keydown', $806ab00ed04609c6$var$onWindowKeyDown, true);
        }
    };
}
/**
 * Retry an effect until it reports ready.
 * When `ready` is `false`, it will schedule one more effect cycle and call `func` again
 * with the next `retryTimes`.
 */ function $806ab00ed04609c6$var$useRetryEffect(func, deps) {
    /* eslint-disable react-hooks/exhaustive-deps */ const retryTimesRef = (0, $5E6i4.useRef)(0);
    const [retryMark, setRetryMark] = (0, $5E6i4.useState)(0);
    (0, $5E6i4.useEffect)(()=>{
        retryTimesRef.current = 0;
    }, deps);
    (0, $5E6i4.useEffect)(()=>{
        const [clearFn, ready] = func(retryTimesRef.current);
        if (!ready) {
            retryTimesRef.current += 1;
            setRetryMark((count)=>count + 1);
        }
        return clearFn;
    }, [
        ...deps,
        retryMark
    ]);
/* eslint-enable react-hooks/exhaustive-deps */ }
function $806ab00ed04609c6$export$9e3bf6f439c42dc9(lock, getElement) {
    const id = (0, $378d6dcdebc6b864$export$2e2bcd8739ae039)();
    const getElementRef = (0, $5E6i4.useRef)(getElement);
    getElementRef.current = getElement;
    const lockEffect = (retryTimes)=>{
        if (!lock) return [
            undefined,
            true
        ];
        const element = getElementRef.current();
        if (element) return [
            $806ab00ed04609c6$export$a71918e269a02274(element, id),
            true
        ];
        return [
            undefined,
            retryTimes >= 1
        ];
    };
    $806ab00ed04609c6$var$useRetryEffect(lockEffect, [
        id,
        lock
    ]);
    const ignoreElement = (ele)=>{
        if (ele) // Set the ignored element using stable ID
        $806ab00ed04609c6$var$ignoredElementMap.set(id, ele);
    };
    return [
        ignoreElement
    ];
}



function $dc7bf2dd018fbbed$var$getRoot(ele) {
    return ele?.getRootNode?.();
}
function $dc7bf2dd018fbbed$export$cca82218ea4431a(ele) {
    return $dc7bf2dd018fbbed$var$getRoot(ele) instanceof ShadowRoot;
}
function $dc7bf2dd018fbbed$export$70e8259662bb498b(ele) {
    return $dc7bf2dd018fbbed$export$cca82218ea4431a(ele) ? $dc7bf2dd018fbbed$var$getRoot(ele) : null;
}



const $bc5e191b379ba96f$var$isStyleNameSupport = (styleName)=>{
    if ((0, $8b91ba628d942bf2$export$2e2bcd8739ae039)() && window.document.documentElement) {
        const styleNameList = Array.isArray(styleName) ? styleName : [
            styleName
        ];
        const { documentElement: documentElement } = window.document;
        return styleNameList.some((name)=>name in documentElement.style);
    }
    return false;
};
const $bc5e191b379ba96f$var$isStyleValueSupport = (styleName, value)=>{
    if (!$bc5e191b379ba96f$var$isStyleNameSupport(styleName)) return false;
    const ele = document.createElement('div');
    const origin = ele.style[styleName];
    ele.style[styleName] = value;
    return ele.style[styleName] !== origin;
};
function $bc5e191b379ba96f$export$d616d7831008e86c(styleName, styleValue) {
    if (!Array.isArray(styleName) && styleValue !== undefined) return $bc5e191b379ba96f$var$isStyleValueSupport(styleName, styleValue);
    return $bc5e191b379ba96f$var$isStyleNameSupport(styleName);
}


/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */ const $e7fae2d8671aa5c7$var$KeyCode = {
    /**
   * MAC_ENTER
   */ MAC_ENTER: 3,
    /**
   * BACKSPACE
   */ BACKSPACE: 8,
    /**
   * TAB
   */ TAB: 9,
    /**
   * NUMLOCK on FF/Safari Mac
   */ NUM_CENTER: 12,
    // NUMLOCK on FF/Safari Mac
    /**
   * ENTER
   */ ENTER: 13,
    /**
   * SHIFT
   */ SHIFT: 16,
    /**
   * CTRL
   */ CTRL: 17,
    /**
   * ALT
   */ ALT: 18,
    /**
   * PAUSE
   */ PAUSE: 19,
    /**
   * CAPS_LOCK
   */ CAPS_LOCK: 20,
    /**
   * ESC
   */ ESC: 27,
    /**
   * SPACE
   */ SPACE: 32,
    /**
   * PAGE_UP
   */ PAGE_UP: 33,
    // also NUM_NORTH_EAST
    /**
   * PAGE_DOWN
   */ PAGE_DOWN: 34,
    // also NUM_SOUTH_EAST
    /**
   * END
   */ END: 35,
    // also NUM_SOUTH_WEST
    /**
   * HOME
   */ HOME: 36,
    // also NUM_NORTH_WEST
    /**
   * LEFT
   */ LEFT: 37,
    // also NUM_WEST
    /**
   * UP
   */ UP: 38,
    // also NUM_NORTH
    /**
   * RIGHT
   */ RIGHT: 39,
    // also NUM_EAST
    /**
   * DOWN
   */ DOWN: 40,
    // also NUM_SOUTH
    /**
   * PRINT_SCREEN
   */ PRINT_SCREEN: 44,
    /**
   * INSERT
   */ INSERT: 45,
    // also NUM_INSERT
    /**
   * DELETE
   */ DELETE: 46,
    // also NUM_DELETE
    /**
   * ZERO
   */ ZERO: 48,
    /**
   * ONE
   */ ONE: 49,
    /**
   * TWO
   */ TWO: 50,
    /**
   * THREE
   */ THREE: 51,
    /**
   * FOUR
   */ FOUR: 52,
    /**
   * FIVE
   */ FIVE: 53,
    /**
   * SIX
   */ SIX: 54,
    /**
   * SEVEN
   */ SEVEN: 55,
    /**
   * EIGHT
   */ EIGHT: 56,
    /**
   * NINE
   */ NINE: 57,
    /**
   * QUESTION_MARK
   */ QUESTION_MARK: 63,
    // needs localization
    /**
   * A
   */ A: 65,
    /**
   * B
   */ B: 66,
    /**
   * C
   */ C: 67,
    /**
   * D
   */ D: 68,
    /**
   * E
   */ E: 69,
    /**
   * F
   */ F: 70,
    /**
   * G
   */ G: 71,
    /**
   * H
   */ H: 72,
    /**
   * I
   */ I: 73,
    /**
   * J
   */ J: 74,
    /**
   * K
   */ K: 75,
    /**
   * L
   */ L: 76,
    /**
   * M
   */ M: 77,
    /**
   * N
   */ N: 78,
    /**
   * O
   */ O: 79,
    /**
   * P
   */ P: 80,
    /**
   * Q
   */ Q: 81,
    /**
   * R
   */ R: 82,
    /**
   * S
   */ S: 83,
    /**
   * T
   */ T: 84,
    /**
   * U
   */ U: 85,
    /**
   * V
   */ V: 86,
    /**
   * W
   */ W: 87,
    /**
   * X
   */ X: 88,
    /**
   * Y
   */ Y: 89,
    /**
   * Z
   */ Z: 90,
    /**
   * META
   */ META: 91,
    // WIN_KEY_LEFT
    /**
   * WIN_KEY_RIGHT
   */ WIN_KEY_RIGHT: 92,
    /**
   * CONTEXT_MENU
   */ CONTEXT_MENU: 93,
    /**
   * NUM_ZERO
   */ NUM_ZERO: 96,
    /**
   * NUM_ONE
   */ NUM_ONE: 97,
    /**
   * NUM_TWO
   */ NUM_TWO: 98,
    /**
   * NUM_THREE
   */ NUM_THREE: 99,
    /**
   * NUM_FOUR
   */ NUM_FOUR: 100,
    /**
   * NUM_FIVE
   */ NUM_FIVE: 101,
    /**
   * NUM_SIX
   */ NUM_SIX: 102,
    /**
   * NUM_SEVEN
   */ NUM_SEVEN: 103,
    /**
   * NUM_EIGHT
   */ NUM_EIGHT: 104,
    /**
   * NUM_NINE
   */ NUM_NINE: 105,
    /**
   * NUM_MULTIPLY
   */ NUM_MULTIPLY: 106,
    /**
   * NUM_PLUS
   */ NUM_PLUS: 107,
    /**
   * NUM_MINUS
   */ NUM_MINUS: 109,
    /**
   * NUM_PERIOD
   */ NUM_PERIOD: 110,
    /**
   * NUM_DIVISION
   */ NUM_DIVISION: 111,
    /**
   * F1
   */ F1: 112,
    /**
   * F2
   */ F2: 113,
    /**
   * F3
   */ F3: 114,
    /**
   * F4
   */ F4: 115,
    /**
   * F5
   */ F5: 116,
    /**
   * F6
   */ F6: 117,
    /**
   * F7
   */ F7: 118,
    /**
   * F8
   */ F8: 119,
    /**
   * F9
   */ F9: 120,
    /**
   * F10
   */ F10: 121,
    /**
   * F11
   */ F11: 122,
    /**
   * F12
   */ F12: 123,
    /**
   * NUMLOCK
   */ NUMLOCK: 144,
    /**
   * SEMICOLON
   */ SEMICOLON: 186,
    // needs localization
    /**
   * DASH
   */ DASH: 189,
    // needs localization
    /**
   * EQUALS
   */ EQUALS: 187,
    // needs localization
    /**
   * COMMA
   */ COMMA: 188,
    // needs localization
    /**
   * PERIOD
   */ PERIOD: 190,
    // needs localization
    /**
   * SLASH
   */ SLASH: 191,
    // needs localization
    /**
   * APOSTROPHE
   */ APOSTROPHE: 192,
    // needs localization
    /**
   * SINGLE_QUOTE
   */ SINGLE_QUOTE: 222,
    // needs localization
    /**
   * OPEN_SQUARE_BRACKET
   */ OPEN_SQUARE_BRACKET: 219,
    // needs localization
    /**
   * BACKSLASH
   */ BACKSLASH: 220,
    // needs localization
    /**
   * CLOSE_SQUARE_BRACKET
   */ CLOSE_SQUARE_BRACKET: 221,
    // needs localization
    /**
   * WIN_KEY
   */ WIN_KEY: 224,
    /**
   * MAC_FF_META
   */ MAC_FF_META: 224,
    // Firefox (Gecko) fires this for the meta key instead of 91
    /**
   * WIN_IME
   */ WIN_IME: 229,
    // ======================== Function ========================
    /**
   * whether text and modified key is entered at the same time.
   */ isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
        const { keyCode: keyCode } = e;
        if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
        keyCode >= $e7fae2d8671aa5c7$var$KeyCode.F1 && keyCode <= $e7fae2d8671aa5c7$var$KeyCode.F12) return false;
        // The following keys are quite harmless, even in combination with
        // CTRL, ALT or SHIFT.
        switch(keyCode){
            case $e7fae2d8671aa5c7$var$KeyCode.ALT:
            case $e7fae2d8671aa5c7$var$KeyCode.CAPS_LOCK:
            case $e7fae2d8671aa5c7$var$KeyCode.CONTEXT_MENU:
            case $e7fae2d8671aa5c7$var$KeyCode.CTRL:
            case $e7fae2d8671aa5c7$var$KeyCode.DOWN:
            case $e7fae2d8671aa5c7$var$KeyCode.END:
            case $e7fae2d8671aa5c7$var$KeyCode.ESC:
            case $e7fae2d8671aa5c7$var$KeyCode.HOME:
            case $e7fae2d8671aa5c7$var$KeyCode.INSERT:
            case $e7fae2d8671aa5c7$var$KeyCode.LEFT:
            case $e7fae2d8671aa5c7$var$KeyCode.MAC_FF_META:
            case $e7fae2d8671aa5c7$var$KeyCode.META:
            case $e7fae2d8671aa5c7$var$KeyCode.NUMLOCK:
            case $e7fae2d8671aa5c7$var$KeyCode.NUM_CENTER:
            case $e7fae2d8671aa5c7$var$KeyCode.PAGE_DOWN:
            case $e7fae2d8671aa5c7$var$KeyCode.PAGE_UP:
            case $e7fae2d8671aa5c7$var$KeyCode.PAUSE:
            case $e7fae2d8671aa5c7$var$KeyCode.PRINT_SCREEN:
            case $e7fae2d8671aa5c7$var$KeyCode.RIGHT:
            case $e7fae2d8671aa5c7$var$KeyCode.SHIFT:
            case $e7fae2d8671aa5c7$var$KeyCode.UP:
            case $e7fae2d8671aa5c7$var$KeyCode.WIN_KEY:
            case $e7fae2d8671aa5c7$var$KeyCode.WIN_KEY_RIGHT:
                return false;
            default:
                return true;
        }
    },
    /**
   * whether character is entered.
   */ isCharacterKey: function isCharacterKey(keyCode) {
        if (keyCode >= $e7fae2d8671aa5c7$var$KeyCode.ZERO && keyCode <= $e7fae2d8671aa5c7$var$KeyCode.NINE) return true;
        if (keyCode >= $e7fae2d8671aa5c7$var$KeyCode.NUM_ZERO && keyCode <= $e7fae2d8671aa5c7$var$KeyCode.NUM_MULTIPLY) return true;
        if (keyCode >= $e7fae2d8671aa5c7$var$KeyCode.A && keyCode <= $e7fae2d8671aa5c7$var$KeyCode.Z) return true;
        // Safari sends zero key code for non-latin characters.
        if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) return true;
        switch(keyCode){
            case $e7fae2d8671aa5c7$var$KeyCode.SPACE:
            case $e7fae2d8671aa5c7$var$KeyCode.QUESTION_MARK:
            case $e7fae2d8671aa5c7$var$KeyCode.NUM_PLUS:
            case $e7fae2d8671aa5c7$var$KeyCode.NUM_MINUS:
            case $e7fae2d8671aa5c7$var$KeyCode.NUM_PERIOD:
            case $e7fae2d8671aa5c7$var$KeyCode.NUM_DIVISION:
            case $e7fae2d8671aa5c7$var$KeyCode.SEMICOLON:
            case $e7fae2d8671aa5c7$var$KeyCode.DASH:
            case $e7fae2d8671aa5c7$var$KeyCode.EQUALS:
            case $e7fae2d8671aa5c7$var$KeyCode.COMMA:
            case $e7fae2d8671aa5c7$var$KeyCode.PERIOD:
            case $e7fae2d8671aa5c7$var$KeyCode.SLASH:
            case $e7fae2d8671aa5c7$var$KeyCode.APOSTROPHE:
            case $e7fae2d8671aa5c7$var$KeyCode.SINGLE_QUOTE:
            case $e7fae2d8671aa5c7$var$KeyCode.OPEN_SQUARE_BRACKET:
            case $e7fae2d8671aa5c7$var$KeyCode.BACKSLASH:
            case $e7fae2d8671aa5c7$var$KeyCode.CLOSE_SQUARE_BRACKET:
                return true;
            default:
                return false;
        }
    },
    isEditableTarget: function isEditableTarget(e) {
        const target = e.target;
        if (!(target instanceof HTMLElement)) return false;
        const tagName = target.tagName;
        if (tagName === 'INPUT' || tagName === 'TEXTAREA' || tagName === 'SELECT' || target.isContentEditable) return true;
        return false;
    }
};
var $e7fae2d8671aa5c7$export$2e2bcd8739ae039 = $e7fae2d8671aa5c7$var$KeyCode;


/* eslint-disable no-param-reassign */ 
let $eb2552f4f31fd55e$var$cached;
function $eb2552f4f31fd55e$var$measureScrollbarSize(ele) {
    const randomId = `rc-scrollbar-measure-${Math.random().toString(36).substring(7)}`;
    const measureEle = document.createElement('div');
    measureEle.id = randomId;
    // Create Style
    const measureStyle = measureEle.style;
    measureStyle.position = 'absolute';
    measureStyle.left = '0';
    measureStyle.top = '0';
    measureStyle.width = '100px';
    measureStyle.height = '100px';
    measureStyle.overflow = 'scroll';
    // Clone Style if needed
    let fallbackWidth;
    let fallbackHeight;
    if (ele) {
        const targetStyle = getComputedStyle(ele);
        measureStyle.scrollbarColor = targetStyle.scrollbarColor;
        measureStyle.scrollbarWidth = targetStyle.scrollbarWidth;
        // Set Webkit style
        const webkitScrollbarStyle = getComputedStyle(ele, '::-webkit-scrollbar');
        const width = parseInt(webkitScrollbarStyle.width, 10);
        const height = parseInt(webkitScrollbarStyle.height, 10);
        // Try wrap to handle CSP case
        try {
            const widthStyle = width ? `width: ${webkitScrollbarStyle.width};` : '';
            const heightStyle = height ? `height: ${webkitScrollbarStyle.height};` : '';
            (0, $d5dd4df2f97e6f98$export$4d99a2890bb989f0)(`
#${randomId}::-webkit-scrollbar {
${widthStyle}
${heightStyle}
}`, randomId);
        } catch (e) {
            // Can't wrap, just log error
            console.error(e);
            // Get from style directly
            fallbackWidth = width;
            fallbackHeight = height;
        }
    }
    document.body.appendChild(measureEle);
    // Measure. Get fallback style if provided
    const scrollWidth = ele && fallbackWidth && !Number.isNaN(fallbackWidth) ? fallbackWidth : measureEle.offsetWidth - measureEle.clientWidth;
    const scrollHeight = ele && fallbackHeight && !Number.isNaN(fallbackHeight) ? fallbackHeight : measureEle.offsetHeight - measureEle.clientHeight;
    // Clean up
    document.body.removeChild(measureEle);
    (0, $d5dd4df2f97e6f98$export$2232e336aecaa80a)(randomId);
    return {
        width: scrollWidth,
        height: scrollHeight
    };
}
function $eb2552f4f31fd55e$export$2e2bcd8739ae039(fresh) {
    if (typeof document === 'undefined') return 0;
    if (fresh || $eb2552f4f31fd55e$var$cached === undefined) $eb2552f4f31fd55e$var$cached = $eb2552f4f31fd55e$var$measureScrollbarSize();
    return $eb2552f4f31fd55e$var$cached.width;
}
function $eb2552f4f31fd55e$export$4f3ef2310365b56a(target) {
    if (typeof document === 'undefined' || !target || !(target instanceof Element)) return {
        width: 0,
        height: 0
    };
    return $eb2552f4f31fd55e$var$measureScrollbarSize(target);
}


/* eslint-disable no-console */ let $f757b9ac02fa080d$var$warned = {};
const $f757b9ac02fa080d$var$preWarningFns = [];
const $f757b9ac02fa080d$export$61616f168f0e5a05 = (fn)=>{
    $f757b9ac02fa080d$var$preWarningFns.push(fn);
};
function $f757b9ac02fa080d$export$491112666e282270(valid, message) {}
function $f757b9ac02fa080d$export$a92e4c44d367d0af(valid, message) {}
function $f757b9ac02fa080d$export$60eef1277fe463e4() {
    $f757b9ac02fa080d$var$warned = {};
}
function $f757b9ac02fa080d$export$848feb93d8f32b9b(method, valid, message) {
    if (!valid && !$f757b9ac02fa080d$var$warned[message]) {
        method(false, message);
        $f757b9ac02fa080d$var$warned[message] = true;
    }
}
function $f757b9ac02fa080d$export$82934adf09101657(valid, message) {
    $f757b9ac02fa080d$export$848feb93d8f32b9b($f757b9ac02fa080d$export$491112666e282270, valid, message);
}
function $f757b9ac02fa080d$export$89ff31684837bbbf(valid, message) {
    $f757b9ac02fa080d$export$848feb93d8f32b9b($f757b9ac02fa080d$export$a92e4c44d367d0af, valid, message);
}
$f757b9ac02fa080d$export$82934adf09101657.preMessage = $f757b9ac02fa080d$export$61616f168f0e5a05;
$f757b9ac02fa080d$export$82934adf09101657.resetWarned = $f757b9ac02fa080d$export$60eef1277fe463e4;
$f757b9ac02fa080d$export$82934adf09101657.noteOnce = $f757b9ac02fa080d$export$89ff31684837bbbf;
var $f757b9ac02fa080d$export$2e2bcd8739ae039 = $f757b9ac02fa080d$export$82934adf09101657;


/**
 * Deeply compares two object literals.
 * @param obj1 object 1
 * @param obj2 object 2
 * @param shallow shallow compare
 * @returns
 */ function $f9cb347037ae4280$var$isEqual(obj1, obj2, shallow = false) {
    // https://github.com/mapbox/mapbox-gl-js/pull/5979/files#diff-fde7145050c47cc3a306856efd5f9c3016e86e859de9afbd02c879be5067e58f
    const refSet = new Set();
    function deepEqual(a, b, level = 1) {
        const circular = refSet.has(a);
        (0, $f757b9ac02fa080d$export$2e2bcd8739ae039)(!circular, 'Warning: There may be circular references');
        if (circular) return false;
        if (a === b) return true;
        if (shallow && level > 1) return false;
        refSet.add(a);
        const newLevel = level + 1;
        if (Array.isArray(a)) {
            if (!Array.isArray(b) || a.length !== b.length) return false;
            for(let i = 0; i < a.length; i++){
                if (!deepEqual(a[i], b[i], newLevel)) return false;
            }
            return true;
        }
        if (a && b && typeof a === 'object' && typeof b === 'object') {
            const keys = Object.keys(a);
            if (keys.length !== Object.keys(b).length) return false;
            return keys.every((key)=>deepEqual(a[key], b[key], newLevel));
        }
        // other
        return false;
    }
    return deepEqual(obj1, obj2);
}
var $f9cb347037ae4280$export$2e2bcd8739ae039 = $f9cb347037ae4280$var$isEqual;


/**
 * Check if a value is neither `null` nor `undefined`.
 */ function $b63de2b9864a5d1a$export$826fff653a329e83(value) {
    return value !== undefined && value !== null;
}
function $b63de2b9864a5d1a$export$72280d5f896dac9a(value) {
    return $b63de2b9864a5d1a$export$826fff653a329e83(value) && value !== false && value !== '';
}


var $8eea937e36a1b736$exports = {};
'use strict';
$8eea937e36a1b736$exports = $8eea937e36a1b736$var$isMobile;
$8eea937e36a1b736$exports.isMobile = $8eea937e36a1b736$var$isMobile;
$8eea937e36a1b736$exports.default = $8eea937e36a1b736$var$isMobile;
const $8eea937e36a1b736$var$mobileRE = /(android|bb\d+|meego).+mobile|armv7l|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|redmi|series[46]0|samsungbrowser.*mobile|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i;
const $8eea937e36a1b736$var$notMobileRE = /CrOS/;
const $8eea937e36a1b736$var$tabletRE = /android|ipad|playbook|silk/i;
function $8eea937e36a1b736$var$isMobile(opts) {
    if (!opts) opts = {};
    let ua = opts.ua;
    if (!ua && typeof navigator !== 'undefined') ua = navigator.userAgent;
    if (ua && ua.headers && typeof ua.headers['user-agent'] === 'string') ua = ua.headers['user-agent'];
    if (typeof ua !== 'string') return false;
    let result = $8eea937e36a1b736$var$mobileRE.test(ua) && !$8eea937e36a1b736$var$notMobileRE.test(ua) || !!opts.tablet && $8eea937e36a1b736$var$tabletRE.test(ua);
    if (!result && opts.tablet && opts.featureDetect && navigator && navigator.maxTouchPoints > 1 && ua.indexOf('Macintosh') !== -1 && ua.indexOf('Safari') !== -1) result = true;
    return result;
}


let $55735df4f86352cc$var$cached;
const $55735df4f86352cc$var$getIsMobile = ()=>{
    if (typeof $55735df4f86352cc$var$cached === 'undefined') $55735df4f86352cc$var$cached = (0, (/*@__PURE__*/$parcel$interopDefault($8eea937e36a1b736$exports)))();
    return $55735df4f86352cc$var$cached;
};
var $55735df4f86352cc$export$2e2bcd8739ae039 = $55735df4f86352cc$var$getIsMobile;


function $48bd91d9f828de66$export$2e2bcd8739ae039(obj, fields) {
    const clone = Object.assign({}, obj);
    if (Array.isArray(fields)) fields.forEach((key)=>{
        delete clone[key];
    });
    return clone;
}


const $78cde6532419ffca$var$attributes = `accept acceptCharset accessKey action allowFullScreen allowTransparency
    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge
    charSet checked classID className colSpan cols content contentEditable contextMenu
    controls coords crossOrigin data dateTime default defer dir disabled download draggable
    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder
    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity
    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media
    mediaGroup method min minLength multiple muted name noValidate nonce open
    optimum pattern placeholder poster preload radioGroup readOnly rel required
    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected
    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style
    summary tabIndex target title type useMap value width wmode wrap`;
const $78cde6532419ffca$var$eventsName = `onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown
    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick
    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown
    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel
    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough
    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata
    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad
    onPointerDown onPointerMove onPointerUp onPointerCancel onPointerEnter onPointerLeave onPointerOver onPointerOut onGotPointerCapture onLostPointerCapture
    onAnimationStart onAnimationEnd onAnimationIteration
    onTransitionEnd onTransitionRun onTransitionStart onTransitionCancel
    onBeforeInput onReset onInvalid
    onAuxClick onToggle onBeforeToggle onCancel onClose onResize onScrollEnd`;
const $78cde6532419ffca$var$propList = `${$78cde6532419ffca$var$attributes} ${$78cde6532419ffca$var$eventsName}`.split(/[\s\n]+/);
/* eslint-enable max-len */ const $78cde6532419ffca$var$ariaPrefix = 'aria-';
const $78cde6532419ffca$var$dataPrefix = 'data-';
function $78cde6532419ffca$var$match(key, prefix) {
    return key.indexOf(prefix) === 0;
}
function $78cde6532419ffca$export$2e2bcd8739ae039(props, ariaOnly = false) {
    let mergedConfig;
    if (ariaOnly === false) mergedConfig = {
        aria: true,
        data: true,
        attr: true
    };
    else if (ariaOnly === true) mergedConfig = {
        aria: true
    };
    else mergedConfig = {
        ...ariaOnly
    };
    const attrs = {};
    Object.keys(props).forEach((key)=>{
        if (// Aria
        mergedConfig.aria && (key === 'role' || $78cde6532419ffca$var$match(key, $78cde6532419ffca$var$ariaPrefix)) || // Data
        mergedConfig.data && $78cde6532419ffca$var$match(key, $78cde6532419ffca$var$dataPrefix) || // Attr
        mergedConfig.attr && $78cde6532419ffca$var$propList.includes(key)) attrs[key] = props[key];
    });
    return attrs;
}


/**
 * Proxy object if environment supported
 */ function $873f3974af782749$export$2e2bcd8739ae039(obj, extendProps) {
    if (typeof Proxy !== 'undefined' && obj) return new Proxy(obj, {
        get (target, prop) {
            if (extendProps[prop]) return extendProps[prop];
            // Proxy origin property
            const originProp = target[prop];
            return typeof originProp === 'function' ? originProp.bind(target) : originProp;
        }
    });
    return obj;
}





var $5E6i4 = parcelRequire("5E6i4");
function $2ec1a2166f2295ea$export$2e2bcd8739ae039(children, option = {}) {
    let ret = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).Children.forEach(children, (child)=>{
        if ((child === undefined || child === null) && !option.keepEmpty) return;
        if (Array.isArray(child)) ret = ret.concat($2ec1a2166f2295ea$export$2e2bcd8739ae039(child));
        else if ((0, $e01be70370d1f66a$export$2e2bcd8739ae039)(child) && child.props) ret = ret.concat($2ec1a2166f2295ea$export$2e2bcd8739ae039(child.props.children, option));
        else ret.push(child);
    });
    return ret;
}


/**
 * Merges multiple props objects into one. Unlike `Object.assign()` or `{ ...a, ...b }`, it skips
 * properties whose value is explicitly set to `undefined`.
 */ function $7b47fcffadf6d245$var$mergeProps(...items) {
    const ret = {};
    for (const item of items)if (item) {
        for (const key of Object.keys(item))if (item[key] !== undefined) ret[key] = item[key];
    }
    return ret;
}
var $7b47fcffadf6d245$export$2e2bcd8739ae039 = $7b47fcffadf6d245$var$mergeProps;


function $0dd37614b50139aa$export$2e2bcd8739ae039(entity, path) {
    let current = entity;
    for(let i = 0; i < path.length; i += 1){
        if (current === null || current === undefined) return undefined;
        current = current[path[i]];
    }
    return current;
}



function $4eb3db67adf477c8$var$internalSet(entity, paths, value, removeIfUndefined) {
    if (!paths.length) return value;
    const [path, ...restPath] = paths;
    let clone;
    if (!entity && typeof path === 'number') clone = [];
    else if (Array.isArray(entity)) clone = [
        ...entity
    ];
    else clone = {
        ...entity
    };
    // Delete prop if `removeIfUndefined` and value is undefined
    if (removeIfUndefined && value === undefined && restPath.length === 1) {
        const origin = clone[path];
        if (origin && typeof origin === 'object') {
            const child = Array.isArray(origin) ? [
                ...origin
            ] : {
                ...origin
            };
            delete child[restPath[0]];
            clone[path] = child;
        }
    } else clone[path] = $4eb3db67adf477c8$var$internalSet(clone[path], restPath, value, removeIfUndefined);
    return clone;
}
function $4eb3db67adf477c8$export$2e2bcd8739ae039(entity, paths, value, removeIfUndefined = false) {
    // Do nothing if `removeIfUndefined` and parent object not exist
    if (paths.length && removeIfUndefined && value === undefined && !(0, $0dd37614b50139aa$export$2e2bcd8739ae039)(entity, paths.slice(0, -1))) return entity;
    return $4eb3db67adf477c8$var$internalSet(entity, paths, value, removeIfUndefined);
}
function $4eb3db67adf477c8$var$isObject(obj) {
    return typeof obj === 'object' && obj !== null && Object.getPrototypeOf(obj) === Object.prototype;
}
function $4eb3db67adf477c8$var$createEmpty(source) {
    return Array.isArray(source) ? [] : {};
}
const $4eb3db67adf477c8$var$keys = typeof Reflect === 'undefined' ? Object.keys : Reflect.ownKeys;
function $4eb3db67adf477c8$export$2ee76fde9ffe109d(sources, config = {}) {
    const { prepareArray: prepareArray } = config;
    const finalPrepareArray = prepareArray || (()=>[]);
    let clone = $4eb3db67adf477c8$var$createEmpty(sources[0]);
    sources.forEach((src)=>{
        function internalMerge(path, parentLoopSet) {
            const loopSet = new Set(parentLoopSet);
            const value = (0, $0dd37614b50139aa$export$2e2bcd8739ae039)(src, path);
            const isArr = Array.isArray(value);
            if (isArr || $4eb3db67adf477c8$var$isObject(value)) // Only add not loop obj
            {
                if (!loopSet.has(value)) {
                    loopSet.add(value);
                    const originValue = (0, $0dd37614b50139aa$export$2e2bcd8739ae039)(clone, path);
                    if (isArr) // Array will always be override
                    clone = $4eb3db67adf477c8$export$2e2bcd8739ae039(clone, path, finalPrepareArray(originValue, value));
                    else if (!originValue || typeof originValue !== 'object') // Init container if not exist
                    clone = $4eb3db67adf477c8$export$2e2bcd8739ae039(clone, path, $4eb3db67adf477c8$var$createEmpty(value));
                    $4eb3db67adf477c8$var$keys(value).forEach((key)=>{
                        if (Object.getOwnPropertyDescriptor(value, key).enumerable) internalMerge([
                            ...path,
                            key
                        ], loopSet);
                    });
                }
            } else clone = $4eb3db67adf477c8$export$2e2bcd8739ae039(clone, path, value);
        }
        internalMerge([]);
    });
    return clone;
}
function $4eb3db67adf477c8$export$4950aa0f605343fb(...sources) {
    return $4eb3db67adf477c8$export$2ee76fde9ffe109d(sources);
}




const $ffa1d788dcb0dd15$var$MARK = '__rc_react_root__';
function $ffa1d788dcb0dd15$export$b3890eb0ae9dca99(node, container) {
    const root = container[$ffa1d788dcb0dd15$var$MARK] || (0, $3b51c8a0c5045117$exports.createRoot)(container);
    root.render(node);
    container[$ffa1d788dcb0dd15$var$MARK] = root;
}
async function $ffa1d788dcb0dd15$export$121e2d597d222bad(container) {
    // Delay to unmount to avoid React 18 sync warning
    return Promise.resolve().then(()=>{
        container[$ffa1d788dcb0dd15$var$MARK]?.unmount();
        delete container[$ffa1d788dcb0dd15$var$MARK];
    });
}


/* eslint-disable no-param-reassign */ const $d2aa982c3bf10bcf$var$NO_EXIST = {
    __NOT_EXIST: true
};
function $d2aa982c3bf10bcf$export$aa23418fe3feda3a(elementClass, properties) {
    const propNames = Object.keys(properties);
    const originDescriptors = {};
    propNames.forEach((propName)=>{
        const originDescriptor = Object.getOwnPropertyDescriptor(elementClass.prototype, propName);
        originDescriptors[propName] = originDescriptor || $d2aa982c3bf10bcf$var$NO_EXIST;
        const spyProp = properties[propName];
        if (typeof spyProp === 'function') // If is a function
        elementClass.prototype[propName] = function spyFunc(...args) {
            return spyProp.call(this, originDescriptor, ...args);
        };
        else // Otherwise tread as a property
        Object.defineProperty(elementClass.prototype, propName, {
            ...spyProp,
            set (value) {
                if (spyProp.set) return spyProp.set.call(this, originDescriptor, value);
                return originDescriptor.set(value);
            },
            get () {
                if (spyProp.get) return spyProp.get.call(this, originDescriptor);
                return originDescriptor.get();
            },
            configurable: true
        });
    });
    return {
        mockRestore () {
            propNames.forEach((propName)=>{
                const originDescriptor = originDescriptors[propName];
                if (originDescriptor === $d2aa982c3bf10bcf$var$NO_EXIST) delete elementClass.prototype[propName];
                else if (typeof originDescriptor === 'function') elementClass.prototype[propName] = originDescriptor;
                else Object.defineProperty(elementClass.prototype, propName, originDescriptor);
            });
        }
    };
}
function $d2aa982c3bf10bcf$export$731ccc610ab0be2e(Element, propName, property) {
    return $d2aa982c3bf10bcf$export$aa23418fe3feda3a(Element, {
        [propName]: property
    });
} /* eslint-enable */ 



var $5E6i4 = parcelRequire("5E6i4");

var $ibUU1 = parcelRequire("ibUU1");

const $3987ab0ead61f8f9$var$Portal = /*#__PURE__*/ (0, $5E6i4.forwardRef)((props, ref)=>{
    const { didUpdate: didUpdate, getContainer: getContainer, children: children } = props;
    const parentRef = (0, $5E6i4.useRef)(null);
    const containerRef = (0, $5E6i4.useRef)(null);
    // Ref return nothing, only for wrapper check exist
    (0, $5E6i4.useImperativeHandle)(ref, ()=>({}));
    // Create container in client side with sync to avoid useEffect not get ref
    const initRef = (0, $5E6i4.useRef)(false);
    if (!initRef.current && (0, $8b91ba628d942bf2$export$2e2bcd8739ae039)()) {
        containerRef.current = getContainer();
        parentRef.current = containerRef.current.parentNode;
        initRef.current = true;
    }
    // [Legacy] Used by `rc-trigger`
    (0, $5E6i4.useEffect)(()=>{
        didUpdate?.(props);
    });
    (0, $5E6i4.useEffect)(()=>{
        // Restore container to original place
        // React 18 StrictMode will unmount first and mount back for effect test:
        // https://reactjs.org/blog/2022/03/29/react-v18.html#new-strict-mode-behaviors
        if (containerRef.current.parentNode === null && parentRef.current !== null) parentRef.current.appendChild(containerRef.current);
        return ()=>{
            // [Legacy] This should not be handle by Portal but parent PortalWrapper instead.
            // Since some component use `Portal` directly, we have to keep the logic here.
            containerRef.current?.parentNode?.removeChild(containerRef.current);
        };
    }, []);
    return containerRef.current ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ibUU1))).createPortal(children, containerRef.current) : null;
});
var $3987ab0ead61f8f9$export$2e2bcd8739ae039 = $3987ab0ead61f8f9$var$Portal;





function $c3e4bc0a6798fe90$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $6fabb34b338279a5$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $c3e4bc0a6798fe90$export$2e2bcd8739ae039)(r);
}


function $0f92fedf3a137904$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $d52f659237d99996$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $c3e4bc0a6798fe90$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $c3e4bc0a6798fe90$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $6a509de93a2f23f5$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $0acfae8147afe964$export$2e2bcd8739ae039(r) {
    return (0, $6fabb34b338279a5$export$2e2bcd8739ae039)(r) || (0, $0f92fedf3a137904$export$2e2bcd8739ae039)(r) || (0, $d52f659237d99996$export$2e2bcd8739ae039)(r) || (0, $6a509de93a2f23f5$export$2e2bcd8739ae039)();
}



var $5E6i4 = parcelRequire("5E6i4");


const $addbc2fddcbb77a9$export$7e4aa119212bc614 = (val)=>{
    return typeof val === 'number' && !Number.isNaN(val);
};
const $addbc2fddcbb77a9$export$844ec244b1367d54 = (val)=>{
    return typeof val === 'string';
};
const $addbc2fddcbb77a9$export$53b83ca8eaab0383 = (val)=>{
    return val !== null && typeof val === 'object';
};
const $addbc2fddcbb77a9$export$f6e2535fb5126e54 = (val)=>{
    return typeof val === 'function';
};
const $addbc2fddcbb77a9$export$f5b060c2914b97c8 = (val)=>{
    return (0, $b63de2b9864a5d1a$export$826fff653a329e83)(val) && $addbc2fddcbb77a9$export$f6e2535fb5126e54(val.then);
};
const $addbc2fddcbb77a9$export$c3825b437cbdea5c = (val)=>{
    return typeof val !== 'object' && !$addbc2fddcbb77a9$export$f6e2535fb5126e54(val) || val === null;
};
const $addbc2fddcbb77a9$export$9e6f93c2a213a96b = (event)=>{
    return $addbc2fddcbb77a9$export$53b83ca8eaab0383(event) && 'propertyName' in event && $addbc2fddcbb77a9$export$844ec244b1367d54(event.propertyName);
};
const $addbc2fddcbb77a9$export$5a096129d439f843 = (val)=>{
    if (!(0, $b63de2b9864a5d1a$export$826fff653a329e83)(val)) return false;
    return val === val.window;
};
const $addbc2fddcbb77a9$export$62858bae88b53fd0 = (val)=>{
    if (!(0, $b63de2b9864a5d1a$export$826fff653a329e83)(val)) return false;
    return val instanceof Document || val.constructor.name === 'HTMLDocument' || val.nodeType === window.Node.DOCUMENT_NODE;
};
const $addbc2fddcbb77a9$export$1b3bfaa9684536aa = (val)=>{
    if (!(0, $b63de2b9864a5d1a$export$826fff653a329e83)(val)) return false;
    return typeof HTMLElement !== 'undefined' && val instanceof HTMLElement;
};


/**
 * Fill object structure by schema, initialize empty objects for keys with `_default` property.
 */ const $bf6ec3443b3db3ab$export$b0b33f05d3a1a8f1 = (obj, schema)=>{
    const newObj = {
        ...obj
    };
    Object.keys(schema).forEach((key)=>{
        if (schema[key]._default) newObj[key] || (newObj[key] = {});
        else newObj[key] = $bf6ec3443b3db3ab$export$b0b33f05d3a1a8f1(newObj[key], schema[key]);
    });
    return newObj;
};


const $722c8632ba7bdb89$export$8bf64cd1c29a1310 = (schema = {}, ...classNames)=>{
    return classNames.filter((item)=>Boolean(item)).reduce((acc, cur)=>{
        // Loop keys of the current classNames
        Object.keys(cur).forEach((key)=>{
            const keySchema = schema[key];
            const curVal = cur[key];
            if (keySchema) {
                if ((0, $addbc2fddcbb77a9$export$53b83ca8eaab0383)(curVal)) // Loop fill
                acc[key] = $722c8632ba7bdb89$export$8bf64cd1c29a1310(keySchema, acc[key], curVal);
                else {
                    // Convert string to object structure
                    const { _default: defaultField } = keySchema;
                    if (defaultField) {
                        acc[key] = acc[key] || {};
                        acc[key][defaultField] = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(acc[key][defaultField], curVal);
                    }
                }
            } else // Flatten fill
            acc[key] = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(acc[key], curVal);
        });
        return acc;
    }, {});
};
const $722c8632ba7bdb89$var$useSemanticClassNames = (schema, ...classNames)=>{
    return $5E6i4.useMemo(()=>$722c8632ba7bdb89$export$8bf64cd1c29a1310.apply(void 0, [
            schema
        ].concat(classNames)), [
        schema
    ].concat(classNames));
};
const $722c8632ba7bdb89$export$e618dc39ac9ad607 = (...styles)=>{
    return styles.filter((item)=>Boolean(item)).reduce((acc, cur = {})=>{
        Object.keys(cur).forEach((key)=>{
            acc[key] = {
                ...acc[key],
                ...cur[key]
            };
        });
        return acc;
    }, {});
};
const $722c8632ba7bdb89$var$useSemanticStyles = (...styles)=>{
    return $5E6i4.useMemo(()=>$722c8632ba7bdb89$export$e618dc39ac9ad607.apply(void 0, styles), [].concat(styles));
};
const $722c8632ba7bdb89$export$e6b3587a05cff7e4 = (style, key = 'root')=>{
    return $5E6i4.useMemo(()=>style ? {
            [key]: style
        } : undefined, [
        style,
        key
    ]);
};
const $722c8632ba7bdb89$export$ccd424010a24474f = (value, info)=>{
    return (0, $addbc2fddcbb77a9$export$f6e2535fb5126e54)(value) ? value(info) : value;
};
const $722c8632ba7bdb89$export$648566b068f28737 = (classNamesList, stylesList, info, schema)=>{
    const resolvedClassNamesList = classNamesList.map((classNames)=>classNames ? $722c8632ba7bdb89$export$ccd424010a24474f(classNames, info) : undefined);
    const resolvedStylesList = stylesList.map((styles)=>styles ? $722c8632ba7bdb89$export$ccd424010a24474f(styles, info) : undefined);
    const mergedClassNames = $722c8632ba7bdb89$var$useSemanticClassNames.apply(void 0, [
        schema
    ].concat((0, $0acfae8147afe964$export$2e2bcd8739ae039)(resolvedClassNamesList)));
    const mergedStyles = $722c8632ba7bdb89$var$useSemanticStyles.apply(void 0, (0, $0acfae8147afe964$export$2e2bcd8739ae039)(resolvedStylesList));
    return $5E6i4.useMemo(()=>{
        if (!schema) return [
            mergedClassNames,
            mergedStyles
        ];
        return [
            (0, $bf6ec3443b3db3ab$export$b0b33f05d3a1a8f1)(mergedClassNames, schema),
            (0, $bf6ec3443b3db3ab$export$b0b33f05d3a1a8f1)(mergedStyles, schema)
        ];
    }, [
        mergedClassNames,
        mergedStyles,
        schema
    ]);
};





var $5E6i4 = parcelRequire("5E6i4");



var $5E6i4 = parcelRequire("5E6i4");
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $265e8c0f7074eb72$var$murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
var $265e8c0f7074eb72$export$2e2bcd8739ae039 = $265e8c0f7074eb72$var$murmur2;




var $5E6i4 = parcelRequire("5E6i4");



var $5E6i4 = parcelRequire("5E6i4");
// [times, realValue]
const $ac421e03a3f726f8$var$SPLIT = '%';
function $ac421e03a3f726f8$export$1d14e1d8187b9aad(keys) {
    return keys.join($ac421e03a3f726f8$var$SPLIT);
}
/** Record update id for extract static style order. */ let $ac421e03a3f726f8$var$updateId = 0;
class $ac421e03a3f726f8$var$Entity {
    instanceId;
    constructor(instanceId){
        this.instanceId = instanceId;
    }
    /** @private Internal cache map. Do not access this directly */ cache = new Map();
    /** @private Record update times for each key */ updateTimes = new Map();
    extracted = new Set();
    get(keys) {
        return this.opGet($ac421e03a3f726f8$export$1d14e1d8187b9aad(keys));
    }
    /** A fast get cache with `get` concat. */ opGet(keyPathStr) {
        return this.cache.get(keyPathStr) || null;
    }
    update(keys, valueFn) {
        return this.opUpdate($ac421e03a3f726f8$export$1d14e1d8187b9aad(keys), valueFn);
    }
    /** A fast get cache with `get` concat. */ opUpdate(keyPathStr, valueFn) {
        const prevValue = this.cache.get(keyPathStr);
        const nextValue = valueFn(prevValue);
        if (nextValue === null) {
            this.cache.delete(keyPathStr);
            this.updateTimes.delete(keyPathStr);
        } else {
            this.cache.set(keyPathStr, nextValue);
            this.updateTimes.set(keyPathStr, $ac421e03a3f726f8$var$updateId);
            $ac421e03a3f726f8$var$updateId += 1;
        }
    }
}
var $ac421e03a3f726f8$export$2e2bcd8739ae039 = $ac421e03a3f726f8$var$Entity;


const $f306e309f9e93434$export$3a1a912fd9fd3325 = {};
const $f306e309f9e93434$var$transform = $f306e309f9e93434$export$3a1a912fd9fd3325;
var $f306e309f9e93434$export$2e2bcd8739ae039 = $f306e309f9e93434$var$transform;


const $6c29e14c4abe80bf$export$5d99297dcd5476ac = 'data-token-hash';
const $6c29e14c4abe80bf$export$89ce1123b3c0bd9e = 'data-css-hash';
const $6c29e14c4abe80bf$export$36f8a6c9fa24262a = 'data-cache-path';
const $6c29e14c4abe80bf$export$4c16a0c02134a7dc = '__cssinjs_instance__';
function $6c29e14c4abe80bf$export$cf6fa0bbcc94b912() {
    const cssinjsInstanceId = Math.random().toString(12).slice(2);
    // Tricky SSR: Move all inline style to the head.
    // PS: We do not recommend tricky mode.
    if (typeof document !== 'undefined' && document.head && document.body) {
        const styles = document.body.querySelectorAll(`style[${$6c29e14c4abe80bf$export$89ce1123b3c0bd9e}]`) || [];
        const { firstChild: firstChild } = document.head;
        Array.from(styles).forEach((style)=>{
            style[$6c29e14c4abe80bf$export$4c16a0c02134a7dc] ||= cssinjsInstanceId;
            // Not force move if no head
            if (style[$6c29e14c4abe80bf$export$4c16a0c02134a7dc] === cssinjsInstanceId) document.head.insertBefore(style, firstChild);
        });
        // Deduplicate of moved styles
        const styleHash = {};
        Array.from(document.querySelectorAll(`style[${$6c29e14c4abe80bf$export$89ce1123b3c0bd9e}]`)).forEach((style)=>{
            const hash = style.getAttribute($6c29e14c4abe80bf$export$89ce1123b3c0bd9e);
            if (styleHash[hash]) {
                if (style[$6c29e14c4abe80bf$export$4c16a0c02134a7dc] === cssinjsInstanceId) style.parentNode?.removeChild(style);
            } else styleHash[hash] = true;
        });
    }
    return new (0, $ac421e03a3f726f8$export$2e2bcd8739ae039)(cssinjsInstanceId);
}
const $6c29e14c4abe80bf$var$StyleContext = /*#__PURE__*/ $5E6i4.createContext({
    hashPriority: 'low',
    cache: $6c29e14c4abe80bf$export$cf6fa0bbcc94b912(),
    defaultCache: true,
    autoPrefix: false
});
const $6c29e14c4abe80bf$export$6aedb87c7b665270 = (props)=>{
    const { children: children, ...restProps } = props;
    const parentContext = $5E6i4.useContext($6c29e14c4abe80bf$var$StyleContext);
    const context = (0, $8ae08502d6a327d3$export$2e2bcd8739ae039)(()=>{
        const mergedContext = {
            ...parentContext
        };
        Object.keys(restProps).forEach((key)=>{
            const value = restProps[key];
            if (restProps[key] !== undefined) mergedContext[key] = value;
        });
        const { cache: cache, transformers: transformers = [] } = restProps;
        mergedContext.cache = mergedContext.cache || $6c29e14c4abe80bf$export$cf6fa0bbcc94b912();
        mergedContext.defaultCache = !cache && parentContext.defaultCache;
        // autoPrefix
        if (transformers.includes((0, $f306e309f9e93434$export$3a1a912fd9fd3325))) mergedContext.autoPrefix = true;
        return mergedContext;
    }, [
        parentContext,
        restProps
    ], (prev, next)=>!(0, $f9cb347037ae4280$export$2e2bcd8739ae039)(prev[0], next[0], true) || !(0, $f9cb347037ae4280$export$2e2bcd8739ae039)(prev[1], next[1], true));
    return /*#__PURE__*/ $5E6i4.createElement($6c29e14c4abe80bf$var$StyleContext.Provider, {
        value: context
    }, children);
};
var $6c29e14c4abe80bf$export$2e2bcd8739ae039 = $6c29e14c4abe80bf$var$StyleContext;






class $c93ff1a9a75e411e$var$AbstractCalculator {
}
var $c93ff1a9a75e411e$export$2e2bcd8739ae039 = $c93ff1a9a75e411e$var$AbstractCalculator;


const $640e10751ae9c705$var$CALC_UNIT = 'CALC_UNIT';
const $640e10751ae9c705$var$regexp = new RegExp($640e10751ae9c705$var$CALC_UNIT, 'g');
function $640e10751ae9c705$var$unit(value) {
    if (typeof value === 'number') return `${value}${$640e10751ae9c705$var$CALC_UNIT}`;
    return value;
}
class $640e10751ae9c705$export$2e2bcd8739ae039 extends (0, $c93ff1a9a75e411e$export$2e2bcd8739ae039) {
    result = '';
    unitlessCssVar;
    lowPriority;
    constructor(num, unitlessCssVar){
        super();
        const numType = typeof num;
        this.unitlessCssVar = unitlessCssVar;
        if (num instanceof $640e10751ae9c705$export$2e2bcd8739ae039) this.result = `(${num.result})`;
        else if (numType === 'number') this.result = $640e10751ae9c705$var$unit(num);
        else if (numType === 'string') this.result = num;
    }
    add(num) {
        if (num instanceof $640e10751ae9c705$export$2e2bcd8739ae039) this.result = `${this.result} + ${num.getResult()}`;
        else if (typeof num === 'number' || typeof num === 'string') this.result = `${this.result} + ${$640e10751ae9c705$var$unit(num)}`;
        this.lowPriority = true;
        return this;
    }
    sub(num) {
        if (num instanceof $640e10751ae9c705$export$2e2bcd8739ae039) this.result = `${this.result} - ${num.getResult()}`;
        else if (typeof num === 'number' || typeof num === 'string') this.result = `${this.result} - ${$640e10751ae9c705$var$unit(num)}`;
        this.lowPriority = true;
        return this;
    }
    mul(num) {
        if (this.lowPriority) this.result = `(${this.result})`;
        if (num instanceof $640e10751ae9c705$export$2e2bcd8739ae039) this.result = `${this.result} * ${num.getResult(true)}`;
        else if (typeof num === 'number' || typeof num === 'string') this.result = `${this.result} * ${num}`;
        this.lowPriority = false;
        return this;
    }
    div(num) {
        if (this.lowPriority) this.result = `(${this.result})`;
        if (num instanceof $640e10751ae9c705$export$2e2bcd8739ae039) this.result = `${this.result} / ${num.getResult(true)}`;
        else if (typeof num === 'number' || typeof num === 'string') this.result = `${this.result} / ${num}`;
        this.lowPriority = false;
        return this;
    }
    getResult(force) {
        return this.lowPriority || force ? `(${this.result})` : this.result;
    }
    equal(options) {
        const { unit: cssUnit } = options || {};
        let mergedUnit = true;
        if (typeof cssUnit === 'boolean') mergedUnit = cssUnit;
        else if (Array.from(this.unitlessCssVar).some((cssVar)=>this.result.includes(cssVar))) mergedUnit = false;
        this.result = this.result.replace($640e10751ae9c705$var$regexp, mergedUnit ? 'px' : '');
        if (typeof this.lowPriority !== 'undefined') return `calc(${this.result})`;
        return this.result;
    }
}



class $3942df7661bad610$export$2e2bcd8739ae039 extends (0, $c93ff1a9a75e411e$export$2e2bcd8739ae039) {
    result = 0;
    constructor(num){
        super();
        if (num instanceof $3942df7661bad610$export$2e2bcd8739ae039) this.result = num.result;
        else if (typeof num === 'number') this.result = num;
    }
    add(num) {
        if (num instanceof $3942df7661bad610$export$2e2bcd8739ae039) this.result += num.result;
        else if (typeof num === 'number') this.result += num;
        return this;
    }
    sub(num) {
        if (num instanceof $3942df7661bad610$export$2e2bcd8739ae039) this.result -= num.result;
        else if (typeof num === 'number') this.result -= num;
        return this;
    }
    mul(num) {
        if (num instanceof $3942df7661bad610$export$2e2bcd8739ae039) this.result *= num.result;
        else if (typeof num === 'number') this.result *= num;
        return this;
    }
    div(num) {
        if (num instanceof $3942df7661bad610$export$2e2bcd8739ae039) this.result /= num.result;
        else if (typeof num === 'number') this.result /= num;
        return this;
    }
    equal() {
        return this.result;
    }
}


const $525e5ad133f073a0$var$genCalc = (type, unitlessCssVar)=>{
    const Calculator = type === 'css' ? (0, $640e10751ae9c705$export$2e2bcd8739ae039) : (0, $3942df7661bad610$export$2e2bcd8739ae039);
    return (num)=>new Calculator(num, unitlessCssVar);
};
var $525e5ad133f073a0$export$2e2bcd8739ae039 = $525e5ad133f073a0$var$genCalc;


// ================================== Cache ==================================
function $da5effb79e407b5b$export$dd65e95e99ed0739(left, right) {
    if (left.length !== right.length) return false;
    for(let i = 0; i < left.length; i++){
        if (left[i] !== right[i]) return false;
    }
    return true;
}
class $da5effb79e407b5b$export$2e2bcd8739ae039 {
    static MAX_CACHE_SIZE = 20;
    static MAX_CACHE_OFFSET = 5;
    cache;
    keys;
    cacheCallTimes;
    constructor(){
        this.cache = new Map();
        this.keys = [];
        this.cacheCallTimes = 0;
    }
    size() {
        return this.keys.length;
    }
    internalGet(derivativeOption, updateCallTimes = false) {
        let cache = {
            map: this.cache
        };
        derivativeOption.forEach((derivative)=>{
            if (!cache) cache = undefined;
            else cache = cache?.map?.get(derivative);
        });
        if (cache?.value && updateCallTimes) cache.value[1] = this.cacheCallTimes++;
        return cache?.value;
    }
    get(derivativeOption) {
        return this.internalGet(derivativeOption, true)?.[0];
    }
    has(derivativeOption) {
        return !!this.internalGet(derivativeOption);
    }
    set(derivativeOption, value) {
        // New cache
        if (!this.has(derivativeOption)) {
            if (this.size() + 1 > $da5effb79e407b5b$export$2e2bcd8739ae039.MAX_CACHE_SIZE + $da5effb79e407b5b$export$2e2bcd8739ae039.MAX_CACHE_OFFSET) {
                const [targetKey] = this.keys.reduce((result, key)=>{
                    const [, callTimes] = result;
                    if (this.internalGet(key)[1] < callTimes) return [
                        key,
                        this.internalGet(key)[1]
                    ];
                    return result;
                }, [
                    this.keys[0],
                    this.cacheCallTimes
                ]);
                this.delete(targetKey);
            }
            this.keys.push(derivativeOption);
        }
        let cache = this.cache;
        derivativeOption.forEach((derivative, index)=>{
            if (index === derivativeOption.length - 1) cache.set(derivative, {
                value: [
                    value,
                    this.cacheCallTimes++
                ]
            });
            else {
                const cacheValue = cache.get(derivative);
                if (!cacheValue) cache.set(derivative, {
                    map: new Map()
                });
                else if (!cacheValue.map) cacheValue.map = new Map();
                cache = cache.get(derivative).map;
            }
        });
    }
    deleteByPath(currentCache, derivatives) {
        const cache = currentCache.get(derivatives[0]);
        if (derivatives.length === 1) {
            if (!cache.map) currentCache.delete(derivatives[0]);
            else currentCache.set(derivatives[0], {
                map: cache.map
            });
            return cache.value?.[0];
        }
        const result = this.deleteByPath(cache.map, derivatives.slice(1));
        if ((!cache.map || cache.map.size === 0) && !cache.value) currentCache.delete(derivatives[0]);
        return result;
    }
    delete(derivativeOption) {
        // If cache exists
        if (this.has(derivativeOption)) {
            this.keys = this.keys.filter((item)=>!$da5effb79e407b5b$export$dd65e95e99ed0739(item, derivativeOption));
            return this.deleteByPath(this.cache, derivativeOption);
        }
        return undefined;
    }
}



let $cae09107b4f429d1$var$uuid = 0;
class $cae09107b4f429d1$export$2e2bcd8739ae039 {
    derivatives;
    id;
    constructor(derivatives){
        this.derivatives = Array.isArray(derivatives) ? derivatives : [
            derivatives
        ];
        this.id = $cae09107b4f429d1$var$uuid;
        if (derivatives.length === 0) (0, $f757b9ac02fa080d$export$491112666e282270)(derivatives.length > 0, '[Ant Design CSS-in-JS] Theme should have at least one derivative function.');
        $cae09107b4f429d1$var$uuid += 1;
    }
    getDerivativeToken(token) {
        return this.derivatives.reduce((result, derivative)=>derivative(token, result), undefined);
    }
}


const $e0015b07082714af$var$cacheThemes = new (0, $da5effb79e407b5b$export$2e2bcd8739ae039)();
function $e0015b07082714af$export$2e2bcd8739ae039(derivatives) {
    const derivativeArr = Array.isArray(derivatives) ? derivatives : [
        derivatives
    ];
    // Create new theme if not exist
    if (!$e0015b07082714af$var$cacheThemes.has(derivativeArr)) $e0015b07082714af$var$cacheThemes.set(derivativeArr, new (0, $cae09107b4f429d1$export$2e2bcd8739ae039)(derivativeArr));
    // Get theme from cache and return
    return $e0015b07082714af$var$cacheThemes.get(derivativeArr);
}






// Create a cache for memo concat
const $56bae8a99c3cba6e$var$resultCache = new WeakMap();
const $56bae8a99c3cba6e$var$RESULT_VALUE = {};
function $56bae8a99c3cba6e$export$6aabcc1951563d93(callback, deps) {
    let current = $56bae8a99c3cba6e$var$resultCache;
    for(let i = 0; i < deps.length; i += 1){
        const dep = deps[i];
        if (!current.has(dep)) current.set(dep, new WeakMap());
        current = current.get(dep);
    }
    if (!current.has($56bae8a99c3cba6e$var$RESULT_VALUE)) current.set($56bae8a99c3cba6e$var$RESULT_VALUE, callback());
    return current.get($56bae8a99c3cba6e$var$RESULT_VALUE);
}
// Create a cache here to avoid always loop generate
const $56bae8a99c3cba6e$var$flattenTokenCache = new WeakMap();
function $56bae8a99c3cba6e$export$597374558a261efc(token) {
    let str = $56bae8a99c3cba6e$var$flattenTokenCache.get(token) || '';
    if (!str) {
        Object.keys(token).forEach((key)=>{
            const value = token[key];
            str += key;
            if (value instanceof (0, $cae09107b4f429d1$export$2e2bcd8739ae039)) str += value.id;
            else if (value && typeof value === 'object') str += $56bae8a99c3cba6e$export$597374558a261efc(value);
            else str += value;
        });
        // https://github.com/ant-design/ant-design/issues/48386
        // Should hash the string to avoid style tag name too long
        str = (0, $265e8c0f7074eb72$export$2e2bcd8739ae039)(str);
        // Put in cache
        $56bae8a99c3cba6e$var$flattenTokenCache.set(token, str);
    }
    return str;
}
function $56bae8a99c3cba6e$export$6c82d0ebe8f2ea2c(token, salt) {
    return (0, $265e8c0f7074eb72$export$2e2bcd8739ae039)(`${salt}_${$56bae8a99c3cba6e$export$597374558a261efc(token)}`);
}
const $56bae8a99c3cba6e$var$randomSelectorKey = `random-${Date.now()}-${Math.random()}`.replace(/\./g, '');
// Magic `content` for detect selector support
const $56bae8a99c3cba6e$var$checkContent = '_bAmBoO_';
function $56bae8a99c3cba6e$var$supportSelector(styleStr, handleElement, supportCheck) {
    if ((0, $8b91ba628d942bf2$export$2e2bcd8739ae039)()) {
        (0, $d5dd4df2f97e6f98$export$4d99a2890bb989f0)(styleStr, $56bae8a99c3cba6e$var$randomSelectorKey);
        const ele = document.createElement('div');
        ele.style.position = 'fixed';
        ele.style.left = '0';
        ele.style.top = '0';
        handleElement?.(ele);
        document.body.appendChild(ele);
        const support = supportCheck ? supportCheck(ele) : getComputedStyle(ele).content?.includes($56bae8a99c3cba6e$var$checkContent);
        ele.parentNode?.removeChild(ele);
        (0, $d5dd4df2f97e6f98$export$2232e336aecaa80a)($56bae8a99c3cba6e$var$randomSelectorKey);
        return support;
    }
    return false;
}
let $56bae8a99c3cba6e$var$canLayer = undefined;
function $56bae8a99c3cba6e$export$ac8d3fd9840e20dd() {
    if ($56bae8a99c3cba6e$var$canLayer === undefined) $56bae8a99c3cba6e$var$canLayer = $56bae8a99c3cba6e$var$supportSelector(`@layer ${$56bae8a99c3cba6e$var$randomSelectorKey} { .${$56bae8a99c3cba6e$var$randomSelectorKey} { content: "${$56bae8a99c3cba6e$var$checkContent}"!important; } }`, (ele)=>{
        ele.className = $56bae8a99c3cba6e$var$randomSelectorKey;
    });
    return $56bae8a99c3cba6e$var$canLayer;
}
let $56bae8a99c3cba6e$var$canWhere = undefined;
function $56bae8a99c3cba6e$export$f51d3b8ac4ac9ed1() {
    if ($56bae8a99c3cba6e$var$canWhere === undefined) $56bae8a99c3cba6e$var$canWhere = $56bae8a99c3cba6e$var$supportSelector(`:where(.${$56bae8a99c3cba6e$var$randomSelectorKey}) { content: "${$56bae8a99c3cba6e$var$checkContent}"!important; }`, (ele)=>{
        ele.className = $56bae8a99c3cba6e$var$randomSelectorKey;
    });
    return $56bae8a99c3cba6e$var$canWhere;
}
let $56bae8a99c3cba6e$var$canLogic = undefined;
function $56bae8a99c3cba6e$export$64a912f57d5de48e() {
    if ($56bae8a99c3cba6e$var$canLogic === undefined) $56bae8a99c3cba6e$var$canLogic = $56bae8a99c3cba6e$var$supportSelector(`.${$56bae8a99c3cba6e$var$randomSelectorKey} { inset-block: 93px !important; }`, (ele)=>{
        ele.className = $56bae8a99c3cba6e$var$randomSelectorKey;
    }, (ele)=>getComputedStyle(ele).bottom === '93px');
    return $56bae8a99c3cba6e$var$canLogic;
}
const $56bae8a99c3cba6e$export$9542afab8c2a5f48 = (0, $8b91ba628d942bf2$export$2e2bcd8739ae039)();
function $56bae8a99c3cba6e$export$523c0b569236b342(num) {
    if (typeof num === 'number') return `${num}px`;
    return num;
}
function $56bae8a99c3cba6e$export$71c98ec84f0481d3(style, tokenKey, styleId, customizeAttrs = {}, plain = false) {
    if (plain) return style;
    const attrs = {
        ...customizeAttrs,
        [(0, $6c29e14c4abe80bf$export$5d99297dcd5476ac)]: tokenKey,
        [(0, $6c29e14c4abe80bf$export$89ce1123b3c0bd9e)]: styleId
    };
    const attrStr = Object.keys(attrs).map((attr)=>{
        const val = attrs[attr];
        return val ? `${attr}="${val}"` : null;
    }).filter((v)=>v).join(' ');
    return `<style ${attrStr}>${style}</style>`;
}
function $56bae8a99c3cba6e$export$9c59b80dda569a6e(options) {
    const { hashCls: hashCls, hashPriority: hashPriority = 'low' } = options || {};
    if (!hashCls) return '';
    const hashSelector = `.${hashCls}`;
    return hashPriority === 'low' ? `:where(${hashSelector})` : hashSelector;
}
const $56bae8a99c3cba6e$export$826fff653a329e83 = (val)=>{
    return val !== undefined && val !== null;
};
function $56bae8a99c3cba6e$export$f508583337ce246(config, nonce) {
    const nonceStr = typeof nonce === 'function' ? nonce() : nonce;
    if (nonceStr) return {
        ...config,
        csp: {
            ...config.csp,
            nonce: nonceStr
        }
    };
    return config;
}



const $c0aeb8a4ecafde61$export$309b3b095f0c7662 = (token, prefix = '')=>{
    return `--${prefix ? `${prefix}-` : ''}${token}`.replace(/([a-z0-9])([A-Z])/g, '$1-$2').replace(/([A-Z]+)([A-Z][a-z0-9]+)/g, '$1-$2').replace(/([a-z])([A-Z0-9])/g, '$1-$2').toLowerCase();
};
const $c0aeb8a4ecafde61$export$a27ef1ee9bbc757e = (cssVars, hashId, options)=>{
    const { hashCls: hashCls, hashPriority: hashPriority = 'low', scope: scope } = options || {};
    if (!Object.keys(cssVars).length) return '';
    const baseSelector = `${(0, $56bae8a99c3cba6e$export$9c59b80dda569a6e)({
        hashCls: hashCls,
        hashPriority: hashPriority
    })}.${hashId}`;
    const scopes = [
        scope
    ].flat().filter(Boolean);
    const selector = scopes.length ? scopes.map((s)=>`${baseSelector}.${s}`).join(', ') : baseSelector;
    return `${selector}{${Object.entries(cssVars).map(([key, value])=>`${key}:${value};`).join('')}}`;
};
const $c0aeb8a4ecafde61$export$67858afe85bce49f = (token, themeKey, config)=>{
    const { hashCls: hashCls, hashPriority: hashPriority = 'low', prefix: prefix, unitless: unitless, ignore: ignore, preserve: preserve } = config || {};
    const cssVars = {};
    const result = {};
    Object.entries(token).forEach(([key, value])=>{
        if (preserve?.[key]) result[key] = value;
        else if ((typeof value === 'string' || typeof value === 'number') && !ignore?.[key]) {
            const cssVar = $c0aeb8a4ecafde61$export$309b3b095f0c7662(key, prefix);
            cssVars[cssVar] = typeof value === 'number' && !unitless?.[key] ? `${value}px` : String(value);
            result[key] = `var(${cssVar})`;
        }
    });
    return [
        result,
        $c0aeb8a4ecafde61$export$a27ef1ee9bbc757e(cssVars, themeKey, {
            scope: config?.scope,
            hashCls: hashCls,
            hashPriority: hashPriority
        })
    ];
};



var $5E6i4 = parcelRequire("5E6i4");


function $45629cd46e05caf3$var$useProdHMR() {
    return false;
}
let $45629cd46e05caf3$var$webpackHMR = false;
function $45629cd46e05caf3$var$useDevHMR() {
    return $45629cd46e05caf3$var$webpackHMR;
}
var $45629cd46e05caf3$export$2e2bcd8739ae039 = $45629cd46e05caf3$var$useProdHMR;
var $45629cd46e05caf3$var$args;


const $dc3c7e9a5592e2bc$var$effectMap = new Map();
function $dc3c7e9a5592e2bc$export$2e2bcd8739ae039(prefix, keyPath, cacheFn, onCacheRemove, // Add additional effect trigger by `useInsertionEffect`
onCacheEffect) {
    const { cache: globalCache } = $5E6i4.useContext((0, $6c29e14c4abe80bf$export$2e2bcd8739ae039));
    const fullPath = [
        prefix,
        ...keyPath
    ];
    const fullPathStr = (0, $ac421e03a3f726f8$export$1d14e1d8187b9aad)(fullPath);
    const HMRUpdate = (0, $45629cd46e05caf3$export$2e2bcd8739ae039)();
    const buildCache = (updater)=>{
        globalCache.opUpdate(fullPathStr, (prevCache)=>{
            const [times = 0, cache] = prevCache || [
                undefined,
                undefined
            ];
            // HMR should always ignore cache since developer may change it
            let tmpCache = cache;
            const mergedCache = tmpCache || cacheFn();
            const data = [
                times,
                mergedCache
            ];
            // Call updater if need additional logic
            return updater ? updater(data) : data;
        });
    };
    // Create cache
    $5E6i4.useMemo(()=>{
        buildCache();
    }, /* eslint-disable react-hooks/exhaustive-deps */ [
        fullPathStr
    ]);
    let cacheEntity = globalCache.opGet(fullPathStr);
    const cacheContent = cacheEntity[1];
    // Remove if no need anymore
    (0, $5E6i4.useInsertionEffect)(()=>{
        buildCache(([times, cache])=>[
                times + 1,
                cache
            ]);
        if (!$dc3c7e9a5592e2bc$var$effectMap.has(fullPathStr)) {
            onCacheEffect?.(cacheContent);
            $dc3c7e9a5592e2bc$var$effectMap.set(fullPathStr, true);
            // 微任务清理缓存，可以认为是单次 batch render 中只触发一次 effect
            Promise.resolve().then(()=>{
                $dc3c7e9a5592e2bc$var$effectMap.delete(fullPathStr);
            });
        }
        return ()=>{
            globalCache.opUpdate(fullPathStr, (prevCache)=>{
                const [times = 0, cache] = prevCache || [];
                const nextCount = times - 1;
                if (nextCount === 0) {
                    onCacheRemove?.(cache, false);
                    $dc3c7e9a5592e2bc$var$effectMap.delete(fullPathStr);
                    return null;
                }
                return [
                    times - 1,
                    cache
                ];
            });
        };
    }, [
        fullPathStr
    ]);
    return cacheContent;
}


const $efddb89bf789bd65$var$EMPTY_OVERRIDE = {};
// Generate different prefix to make user selector break in production env.
// This helps developer not to do style override directly on the hash id.
const $efddb89bf789bd65$var$hashPrefix = 'css';
const $efddb89bf789bd65$var$tokenKeys = new Map();
function $efddb89bf789bd65$var$recordCleanToken(tokenKey) {
    $efddb89bf789bd65$var$tokenKeys.set(tokenKey, ($efddb89bf789bd65$var$tokenKeys.get(tokenKey) || 0) + 1);
}
function $efddb89bf789bd65$var$removeStyleTags(key, instanceId) {
    if (typeof document !== 'undefined') {
        const styles = document.querySelectorAll(`style[${(0, $6c29e14c4abe80bf$export$5d99297dcd5476ac)}="${key}"]`);
        styles.forEach((style)=>{
            if (style[0, $6c29e14c4abe80bf$export$4c16a0c02134a7dc] === instanceId) style.parentNode?.removeChild(style);
        });
    }
}
const $efddb89bf789bd65$var$TOKEN_THRESHOLD = -1;
// Remove will check current keys first
function $efddb89bf789bd65$var$cleanTokenStyle(tokenKey, instanceId) {
    $efddb89bf789bd65$var$tokenKeys.set(tokenKey, ($efddb89bf789bd65$var$tokenKeys.get(tokenKey) || 0) - 1);
    const cleanableKeyList = new Set();
    $efddb89bf789bd65$var$tokenKeys.forEach((value, key)=>{
        if (value <= 0) cleanableKeyList.add(key);
    });
    // Should keep tokens under threshold for not to insert style too often
    if ($efddb89bf789bd65$var$tokenKeys.size - cleanableKeyList.size > $efddb89bf789bd65$var$TOKEN_THRESHOLD) cleanableKeyList.forEach((key)=>{
        $efddb89bf789bd65$var$removeStyleTags(key, instanceId);
        $efddb89bf789bd65$var$tokenKeys.delete(key);
    });
}
const $efddb89bf789bd65$export$18602cb46ae80b62 = (originToken, overrideToken, theme, format)=>{
    const derivativeToken = theme.getDerivativeToken(originToken);
    // Merge with override
    let mergedDerivativeToken = {
        ...derivativeToken,
        ...overrideToken
    };
    // Format if needed
    if (format) mergedDerivativeToken = format(mergedDerivativeToken);
    return mergedDerivativeToken;
};
const $efddb89bf789bd65$export$270fba097347f4fa = 'token';
function $efddb89bf789bd65$export$2e2bcd8739ae039(theme, tokens, option) {
    const { cache: { instanceId: instanceId }, container: container, hashPriority: hashPriority } = (0, $5E6i4.useContext)((0, $6c29e14c4abe80bf$export$2e2bcd8739ae039));
    const { salt: salt = '', override: override = $efddb89bf789bd65$var$EMPTY_OVERRIDE, formatToken: formatToken, getComputedToken: compute, cssVar: cssVar, nonce: nonce } = option;
    // Basic - We do basic cache here
    const mergedToken = (0, $56bae8a99c3cba6e$export$6aabcc1951563d93)(()=>Object.assign({}, ...tokens), tokens);
    const tokenStr = (0, $56bae8a99c3cba6e$export$597374558a261efc)(mergedToken);
    const overrideTokenStr = (0, $56bae8a99c3cba6e$export$597374558a261efc)(override);
    const cssVarStr = (0, $56bae8a99c3cba6e$export$597374558a261efc)(cssVar);
    const cachedToken = (0, $dc3c7e9a5592e2bc$export$2e2bcd8739ae039)($efddb89bf789bd65$export$270fba097347f4fa, [
        salt,
        theme.id,
        tokenStr,
        overrideTokenStr,
        cssVarStr
    ], ()=>{
        const mergedDerivativeToken = compute ? compute(mergedToken, override, theme) : $efddb89bf789bd65$export$18602cb46ae80b62(mergedToken, override, theme, formatToken);
        const actualToken = {
            ...mergedDerivativeToken
        };
        // Optimize for `useStyleRegister` performance
        const mergedSalt = `${salt}_${cssVar.prefix}`;
        const hashId = (0, $265e8c0f7074eb72$export$2e2bcd8739ae039)(mergedSalt);
        const hashCls = `${$efddb89bf789bd65$var$hashPrefix}-${hashId}`;
        actualToken._tokenKey = (0, $56bae8a99c3cba6e$export$6c82d0ebe8f2ea2c)(actualToken, mergedSalt);
        // Replace token value with css variables
        const [tokenWithCssVar, cssVarsStr] = (0, $c0aeb8a4ecafde61$export$67858afe85bce49f)(mergedDerivativeToken, cssVar.key, {
            prefix: cssVar.prefix,
            ignore: cssVar.ignore,
            unitless: cssVar.unitless,
            preserve: cssVar.preserve,
            hashPriority: hashPriority,
            hashCls: cssVar.hashed ? hashCls : undefined
        });
        tokenWithCssVar._hashId = hashId;
        $efddb89bf789bd65$var$recordCleanToken(cssVar.key);
        return [
            tokenWithCssVar,
            hashCls,
            actualToken,
            cssVarsStr,
            cssVar.key
        ];
    }, ([, , , , themeKey])=>{
        // Remove token will remove all related style
        $efddb89bf789bd65$var$cleanTokenStyle(themeKey, instanceId);
    }, ([, , , cssVarsStr, themeKey])=>{
        if (!cssVarsStr) return;
        let mergedCSSConfig = {
            mark: (0, $6c29e14c4abe80bf$export$89ce1123b3c0bd9e),
            prepend: 'queue',
            attachTo: container,
            priority: -999
        };
        mergedCSSConfig = (0, $56bae8a99c3cba6e$export$f508583337ce246)(mergedCSSConfig, nonce);
        const style = (0, $d5dd4df2f97e6f98$export$4d99a2890bb989f0)(cssVarsStr, (0, $265e8c0f7074eb72$export$2e2bcd8739ae039)(`css-var-${themeKey}`), mergedCSSConfig);
        style[0, $6c29e14c4abe80bf$export$4c16a0c02134a7dc] = instanceId;
        // Used for `useCacheToken` to remove on batch when token removed
        style.setAttribute((0, $6c29e14c4abe80bf$export$5d99297dcd5476ac), themeKey);
    });
    return cachedToken;
}
const $efddb89bf789bd65$export$f9380c9a627682d3 = (cache, effectStyles, options)=>{
    const [, , realToken, styleStr, cssVarKey] = cache;
    const { plain: plain } = options || {};
    if (!styleStr) return null;
    const styleId = realToken._tokenKey;
    const order = -999;
    // ====================== Style ======================
    // Used for @rc-component/util
    const sharedAttrs = {
        'data-rc-order': 'prependQueue',
        'data-rc-priority': `${order}`
    };
    const styleText = (0, $56bae8a99c3cba6e$export$71c98ec84f0481d3)(styleStr, cssVarKey, styleId, sharedAttrs, plain);
    return [
        order,
        styleId,
        styleText
    ];
};




var $5E6i4 = parcelRequire("5E6i4");







var $5E6i4 = parcelRequire("5E6i4");
var $885f4eee88e48c11$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $885f4eee88e48c11$export$2e2bcd8739ae039 = $885f4eee88e48c11$var$unitlessKeys;


var $c587a20864c1e429$export$71ad59f2e432cfe8 = '-ms-';
var $c587a20864c1e429$export$2c0f367103c8d01c = '-moz-';
var $c587a20864c1e429$export$39dfd62a25e0fe93 = '-webkit-';
var $c587a20864c1e429$export$a29989082612d0d9 = 'comm';
var $c587a20864c1e429$export$aa3a2e812ca8570d = 'rule';
var $c587a20864c1e429$export$527d108ccf083c2b = 'decl';
var $c587a20864c1e429$export$d3d35020fa5b54f0 = '@page';
var $c587a20864c1e429$export$500415a86c544f73 = '@media';
var $c587a20864c1e429$export$a763edbf796b780a = '@import';
var $c587a20864c1e429$export$2790aeb8b4e5c826 = '@charset';
var $c587a20864c1e429$export$1cc683e23b84b133 = '@viewport';
var $c587a20864c1e429$export$9447a5efea57e862 = '@supports';
var $c587a20864c1e429$export$ef011b4e114b1fba = '@document';
var $c587a20864c1e429$export$6aad947bda0f3f46 = '@namespace';
var $c587a20864c1e429$export$b44a8529a35fcb60 = '@keyframes';
var $c587a20864c1e429$export$2c16de31893252e6 = '@font-face';
var $c587a20864c1e429$export$3d846dd52e150c6f = '@counter-style';
var $c587a20864c1e429$export$22314bfbb57653fe = '@font-feature-values';
var $c587a20864c1e429$export$d773506282b3cfe6 = '@layer';
var $c587a20864c1e429$export$1c5a554c78c0cd12 = '@scope';


/**
 * @param {number}
 * @return {number}
 */ var $237729fe5ff6258f$export$2335f513bbd82c6d = Math.abs;
var $237729fe5ff6258f$export$6788812c4e6611e6 = String.fromCharCode;
var $237729fe5ff6258f$export$e6e34fd1f2686227 = Object.assign;
function $237729fe5ff6258f$export$d6af199866bfb566(value, length) {
    return $237729fe5ff6258f$export$a9db5e087081082d(value, 0) ^ 45 ? (((length << 2 ^ $237729fe5ff6258f$export$a9db5e087081082d(value, 0)) << 2 ^ $237729fe5ff6258f$export$a9db5e087081082d(value, 1)) << 2 ^ $237729fe5ff6258f$export$a9db5e087081082d(value, 2)) << 2 ^ $237729fe5ff6258f$export$a9db5e087081082d(value, 3) : 0;
}
function $237729fe5ff6258f$export$87c2784dc9fc4ab(value) {
    return value.trim();
}
function $237729fe5ff6258f$export$4659b591c19bdf3d(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
}
function $237729fe5ff6258f$export$77ad94ebf1c2b9ed(value, pattern, replacement) {
    return value.replace(pattern, replacement);
}
function $237729fe5ff6258f$export$f8e21b1e77979a08(value, search) {
    return value.indexOf(search);
}
function $237729fe5ff6258f$export$a9db5e087081082d(value, index) {
    return value.charCodeAt(index) | 0;
}
function $237729fe5ff6258f$export$2f35ab04d2335697(value, begin, end) {
    return value.slice(begin, end);
}
function $237729fe5ff6258f$export$36776f635604f274(value) {
    return value.length;
}
function $237729fe5ff6258f$export$f9084667e487ed46(value) {
    return value.length;
}
function $237729fe5ff6258f$export$10d8903dec122b9d(value, array) {
    return array.push(value), value;
}
function $237729fe5ff6258f$export$1be1fc439b849fdf(array, callback) {
    return array.map(callback).join('');
}
function $237729fe5ff6258f$export$3dea766d36a8935f(array, pattern) {
    return array.filter(function(value) {
        return !$237729fe5ff6258f$export$4659b591c19bdf3d(value, pattern);
    });
}



var $8a9fdd17a3d1ddf4$export$53f1d5ea8de3d7c = 1;
var $8a9fdd17a3d1ddf4$export$4e0c71f277ca26b3 = 1;
var $8a9fdd17a3d1ddf4$export$f24224f1c91d8156 = 0;
var $8a9fdd17a3d1ddf4$export$5880b8b5730aff45 = 0;
var $8a9fdd17a3d1ddf4$export$c0306caf338ac095 = 0;
var $8a9fdd17a3d1ddf4$export$30a86d91af8ff6e6 = '';
function $8a9fdd17a3d1ddf4$export$35059013cd4a06db(value, root, parent, type, props, children, length, siblings) {
    return {
        value: value,
        root: root,
        parent: parent,
        type: type,
        props: props,
        children: children,
        line: $8a9fdd17a3d1ddf4$export$53f1d5ea8de3d7c,
        column: $8a9fdd17a3d1ddf4$export$4e0c71f277ca26b3,
        length: length,
        return: '',
        siblings: siblings
    };
}
function $8a9fdd17a3d1ddf4$export$784d13d8ee351f07(root, props) {
    return (0, $237729fe5ff6258f$export$e6e34fd1f2686227)($8a9fdd17a3d1ddf4$export$35059013cd4a06db('', null, null, '', null, null, 0, root.siblings), root, {
        length: -root.length
    }, props);
}
function $8a9fdd17a3d1ddf4$export$590e8b2c435046d9(root) {
    while(root.root)root = $8a9fdd17a3d1ddf4$export$784d13d8ee351f07(root.root, {
        children: [
            root
        ]
    });
    (0, $237729fe5ff6258f$export$10d8903dec122b9d)(root, root.siblings);
}
function $8a9fdd17a3d1ddf4$export$eba6f6f03b0a92e7() {
    return $8a9fdd17a3d1ddf4$export$c0306caf338ac095;
}
function $8a9fdd17a3d1ddf4$export$232faf9add678146() {
    $8a9fdd17a3d1ddf4$export$c0306caf338ac095 = $8a9fdd17a3d1ddf4$export$5880b8b5730aff45 > 0 ? (0, $237729fe5ff6258f$export$a9db5e087081082d)($8a9fdd17a3d1ddf4$export$30a86d91af8ff6e6, --$8a9fdd17a3d1ddf4$export$5880b8b5730aff45) : 0;
    if ($8a9fdd17a3d1ddf4$export$4e0c71f277ca26b3--, $8a9fdd17a3d1ddf4$export$c0306caf338ac095 === 10) $8a9fdd17a3d1ddf4$export$4e0c71f277ca26b3 = 1, $8a9fdd17a3d1ddf4$export$53f1d5ea8de3d7c--;
    return $8a9fdd17a3d1ddf4$export$c0306caf338ac095;
}
function $8a9fdd17a3d1ddf4$export$48cfd1e771a65c4f() {
    $8a9fdd17a3d1ddf4$export$c0306caf338ac095 = $8a9fdd17a3d1ddf4$export$5880b8b5730aff45 < $8a9fdd17a3d1ddf4$export$f24224f1c91d8156 ? (0, $237729fe5ff6258f$export$a9db5e087081082d)($8a9fdd17a3d1ddf4$export$30a86d91af8ff6e6, $8a9fdd17a3d1ddf4$export$5880b8b5730aff45++) : 0;
    if ($8a9fdd17a3d1ddf4$export$4e0c71f277ca26b3++, $8a9fdd17a3d1ddf4$export$c0306caf338ac095 === 10) $8a9fdd17a3d1ddf4$export$4e0c71f277ca26b3 = 1, $8a9fdd17a3d1ddf4$export$53f1d5ea8de3d7c++;
    return $8a9fdd17a3d1ddf4$export$c0306caf338ac095;
}
function $8a9fdd17a3d1ddf4$export$4d3fb11e950abb9e() {
    return (0, $237729fe5ff6258f$export$a9db5e087081082d)($8a9fdd17a3d1ddf4$export$30a86d91af8ff6e6, $8a9fdd17a3d1ddf4$export$5880b8b5730aff45);
}
function $8a9fdd17a3d1ddf4$export$e88cb2efb12ae807() {
    return $8a9fdd17a3d1ddf4$export$5880b8b5730aff45;
}
function $8a9fdd17a3d1ddf4$export$58adb3bec8346d0f(begin, end) {
    return (0, $237729fe5ff6258f$export$2f35ab04d2335697)($8a9fdd17a3d1ddf4$export$30a86d91af8ff6e6, begin, end);
}
function $8a9fdd17a3d1ddf4$export$9e1725a4cfeada27(type) {
    switch(type){
        // \0 \t \n \r \s whitespace token
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        // ! + , / > @ ~ isolate token
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        // ; { } breakpoint token
        case 59:
        case 123:
        case 125:
            return 4;
        // : accompanied token
        case 58:
            return 3;
        // " ' ( [ opening delimit token
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        // ) ] closing delimit token
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $8a9fdd17a3d1ddf4$export$2de70f21292aac9e(value) {
    return $8a9fdd17a3d1ddf4$export$53f1d5ea8de3d7c = $8a9fdd17a3d1ddf4$export$4e0c71f277ca26b3 = 1, $8a9fdd17a3d1ddf4$export$f24224f1c91d8156 = (0, $237729fe5ff6258f$export$36776f635604f274)($8a9fdd17a3d1ddf4$export$30a86d91af8ff6e6 = value), $8a9fdd17a3d1ddf4$export$5880b8b5730aff45 = 0, [];
}
function $8a9fdd17a3d1ddf4$export$45918ac1574455b1(value) {
    return $8a9fdd17a3d1ddf4$export$30a86d91af8ff6e6 = '', value;
}
function $8a9fdd17a3d1ddf4$export$410ac95b9ec204b8(type) {
    return (0, $237729fe5ff6258f$export$87c2784dc9fc4ab)($8a9fdd17a3d1ddf4$export$58adb3bec8346d0f($8a9fdd17a3d1ddf4$export$5880b8b5730aff45 - 1, $8a9fdd17a3d1ddf4$export$c889f2fcc19dbf12(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function $8a9fdd17a3d1ddf4$export$660b2ee2d4fb4eff(value) {
    return $8a9fdd17a3d1ddf4$export$45918ac1574455b1($8a9fdd17a3d1ddf4$export$5f8c09e3ae6f64e1($8a9fdd17a3d1ddf4$export$2de70f21292aac9e(value)));
}
function $8a9fdd17a3d1ddf4$export$7af1228ff777d175(type) {
    while($8a9fdd17a3d1ddf4$export$c0306caf338ac095 = $8a9fdd17a3d1ddf4$export$4d3fb11e950abb9e())if ($8a9fdd17a3d1ddf4$export$c0306caf338ac095 < 33) $8a9fdd17a3d1ddf4$export$48cfd1e771a65c4f();
    else break;
    return $8a9fdd17a3d1ddf4$export$9e1725a4cfeada27(type) > 2 || $8a9fdd17a3d1ddf4$export$9e1725a4cfeada27($8a9fdd17a3d1ddf4$export$c0306caf338ac095) > 3 ? '' : ' ';
}
function $8a9fdd17a3d1ddf4$export$5f8c09e3ae6f64e1(children) {
    while($8a9fdd17a3d1ddf4$export$48cfd1e771a65c4f())switch($8a9fdd17a3d1ddf4$export$9e1725a4cfeada27($8a9fdd17a3d1ddf4$export$c0306caf338ac095)){
        case 0:
            (0, $237729fe5ff6258f$export$10d8903dec122b9d)($8a9fdd17a3d1ddf4$export$c2ab62c7bf24634($8a9fdd17a3d1ddf4$export$5880b8b5730aff45 - 1), children);
            break;
        case 2:
            (0, $237729fe5ff6258f$export$10d8903dec122b9d)($8a9fdd17a3d1ddf4$export$410ac95b9ec204b8($8a9fdd17a3d1ddf4$export$c0306caf338ac095), children);
            break;
        default:
            (0, $237729fe5ff6258f$export$10d8903dec122b9d)((0, $237729fe5ff6258f$export$6788812c4e6611e6)($8a9fdd17a3d1ddf4$export$c0306caf338ac095), children);
    }
    return children;
}
function $8a9fdd17a3d1ddf4$export$955ba06d119e085e(index, count) {
    while(--count && $8a9fdd17a3d1ddf4$export$48cfd1e771a65c4f())// not 0-9 A-F a-f
    if ($8a9fdd17a3d1ddf4$export$c0306caf338ac095 < 48 || $8a9fdd17a3d1ddf4$export$c0306caf338ac095 > 102 || $8a9fdd17a3d1ddf4$export$c0306caf338ac095 > 57 && $8a9fdd17a3d1ddf4$export$c0306caf338ac095 < 65 || $8a9fdd17a3d1ddf4$export$c0306caf338ac095 > 70 && $8a9fdd17a3d1ddf4$export$c0306caf338ac095 < 97) break;
    return $8a9fdd17a3d1ddf4$export$58adb3bec8346d0f(index, $8a9fdd17a3d1ddf4$export$e88cb2efb12ae807() + (count < 6 && $8a9fdd17a3d1ddf4$export$4d3fb11e950abb9e() == 32 && $8a9fdd17a3d1ddf4$export$48cfd1e771a65c4f() == 32));
}
function $8a9fdd17a3d1ddf4$export$c889f2fcc19dbf12(type) {
    while($8a9fdd17a3d1ddf4$export$48cfd1e771a65c4f())switch($8a9fdd17a3d1ddf4$export$c0306caf338ac095){
        // ] ) " '
        case type:
            return $8a9fdd17a3d1ddf4$export$5880b8b5730aff45;
        // " '
        case 34:
        case 39:
            if (type !== 34 && type !== 39) $8a9fdd17a3d1ddf4$export$c889f2fcc19dbf12($8a9fdd17a3d1ddf4$export$c0306caf338ac095);
            break;
        // (
        case 40:
            if (type === 41) $8a9fdd17a3d1ddf4$export$c889f2fcc19dbf12(type);
            break;
        // \
        case 92:
            $8a9fdd17a3d1ddf4$export$48cfd1e771a65c4f();
            break;
    }
    return $8a9fdd17a3d1ddf4$export$5880b8b5730aff45;
}
function $8a9fdd17a3d1ddf4$export$4254d4e2b3745c4c(type, index) {
    while($8a9fdd17a3d1ddf4$export$48cfd1e771a65c4f())// //
    if (type + $8a9fdd17a3d1ddf4$export$c0306caf338ac095 === 57) break;
    else if (type + $8a9fdd17a3d1ddf4$export$c0306caf338ac095 === 84 && $8a9fdd17a3d1ddf4$export$4d3fb11e950abb9e() === 47) break;
    return '/*' + $8a9fdd17a3d1ddf4$export$58adb3bec8346d0f(index, $8a9fdd17a3d1ddf4$export$5880b8b5730aff45 - 1) + '*' + (0, $237729fe5ff6258f$export$6788812c4e6611e6)(type === 47 ? type : $8a9fdd17a3d1ddf4$export$48cfd1e771a65c4f());
}
function $8a9fdd17a3d1ddf4$export$c2ab62c7bf24634(index) {
    while(!$8a9fdd17a3d1ddf4$export$9e1725a4cfeada27($8a9fdd17a3d1ddf4$export$4d3fb11e950abb9e()))$8a9fdd17a3d1ddf4$export$48cfd1e771a65c4f();
    return $8a9fdd17a3d1ddf4$export$58adb3bec8346d0f(index, $8a9fdd17a3d1ddf4$export$5880b8b5730aff45);
}


function $30315efc23bcb256$export$ef7acd7185315e22(value) {
    return (0, $8a9fdd17a3d1ddf4$export$45918ac1574455b1)($30315efc23bcb256$export$98e6a39c04603d36('', null, null, null, [
        ''
    ], value = (0, $8a9fdd17a3d1ddf4$export$2de70f21292aac9e)(value), 0, [
        0
    ], value));
}
function $30315efc23bcb256$export$98e6a39c04603d36(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    var index = 0;
    var offset = 0;
    var length = pseudo;
    var atrule = 0;
    var property = 0;
    var previous = 0;
    var variable = 1;
    var scanning = 1;
    var ampersand = 1;
    var parens = 0;
    var character = 0;
    var type = '';
    var props = rules;
    var children = rulesets;
    var reference = rule;
    var characters = type;
    while(scanning)switch(previous = character, character = (0, $8a9fdd17a3d1ddf4$export$48cfd1e771a65c4f)()){
        // (
        case 40:
            if (previous != 108 && (0, $237729fe5ff6258f$export$a9db5e087081082d)(characters, length - 1) == 58) parens++, characters += '(';
            else characters += (0, $8a9fdd17a3d1ddf4$export$410ac95b9ec204b8)(character);
            break;
        // )
        case 41:
            parens--, characters += ')';
            break;
        // " ' [
        case 34:
        case 39:
        case 91:
            characters += (0, $8a9fdd17a3d1ddf4$export$410ac95b9ec204b8)(character);
            break;
        // \t \n \r \s
        case 9:
        case 10:
        case 13:
        case 32:
            if (parens > 0) {
                characters += (0, $237729fe5ff6258f$export$6788812c4e6611e6)(character);
                break;
            }
            characters += (0, $8a9fdd17a3d1ddf4$export$7af1228ff777d175)(previous);
            break;
        // \
        case 92:
            characters += (0, $8a9fdd17a3d1ddf4$export$955ba06d119e085e)((0, $8a9fdd17a3d1ddf4$export$e88cb2efb12ae807)() - 1, 7);
            continue;
        // /
        case 47:
            switch((0, $8a9fdd17a3d1ddf4$export$4d3fb11e950abb9e)()){
                case 42:
                case 47:
                    (0, $237729fe5ff6258f$export$10d8903dec122b9d)($30315efc23bcb256$export$4a34f930e789283c((0, $8a9fdd17a3d1ddf4$export$4254d4e2b3745c4c)((0, $8a9fdd17a3d1ddf4$export$48cfd1e771a65c4f)(), (0, $8a9fdd17a3d1ddf4$export$e88cb2efb12ae807)()), root, parent, declarations), declarations);
                    if (((0, $8a9fdd17a3d1ddf4$export$9e1725a4cfeada27)(previous || 1) == 5 || (0, $8a9fdd17a3d1ddf4$export$9e1725a4cfeada27)((0, $8a9fdd17a3d1ddf4$export$4d3fb11e950abb9e)() || 1) == 5) && (0, $237729fe5ff6258f$export$36776f635604f274)(characters) && (0, $237729fe5ff6258f$export$2f35ab04d2335697)(characters, -1, void 0) !== ' ') characters += ' ';
                    break;
                default:
                    characters += '/';
            }
            break;
        // {
        case 123 * variable:
            points[index++] = (0, $237729fe5ff6258f$export$36776f635604f274)(characters) * ampersand;
        // } ; \0
        case 125 * variable:
        case 59:
        case 0:
            if (parens > 0 && character) {
                characters += (0, $237729fe5ff6258f$export$6788812c4e6611e6)(character);
                break;
            }
            switch(character){
                // \0 }
                case 0:
                case 125:
                    scanning = 0;
                // ;
                case 59 + offset:
                    if (ampersand == -1) characters = (0, $237729fe5ff6258f$export$77ad94ebf1c2b9ed)(characters, /\f/g, '');
                    if (property > 0 && ((0, $237729fe5ff6258f$export$36776f635604f274)(characters) - length || variable === 0)) (0, $237729fe5ff6258f$export$10d8903dec122b9d)(property > 32 ? $30315efc23bcb256$export$f8483753829ec8f3(characters + ';', rule, parent, length - 1, declarations) : $30315efc23bcb256$export$f8483753829ec8f3((0, $237729fe5ff6258f$export$77ad94ebf1c2b9ed)(characters, ' ', '') + ';', rule, parent, length - 2, declarations), declarations);
                    break;
                // @ ;
                case 59:
                    characters += ';';
                // { rule/at-rule
                default:
                    (0, $237729fe5ff6258f$export$10d8903dec122b9d)(reference = $30315efc23bcb256$export$3307ffa7023ede1e(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length, rulesets), rulesets);
                    if (character === 123) {
                        if (offset === 0) $30315efc23bcb256$export$98e6a39c04603d36(characters, root, reference, reference, props, rulesets, length, points, children);
                        else {
                            switch(atrule){
                                // c(ontainer)
                                case 99:
                                    if ((0, $237729fe5ff6258f$export$a9db5e087081082d)(characters, 3) === 110) break;
                                // l(ayer)
                                case 108:
                                    if ((0, $237729fe5ff6258f$export$a9db5e087081082d)(characters, 2) === 97) break;
                                default:
                                    offset = 0;
                                // d(ocument) m(edia) s(upports)
                                case 100:
                                case 109:
                                case 115:
                            }
                            if (offset) $30315efc23bcb256$export$98e6a39c04603d36(value, reference, reference, rule && (0, $237729fe5ff6258f$export$10d8903dec122b9d)($30315efc23bcb256$export$3307ffa7023ede1e(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length, children), children), rules, children, length, points, rule ? props : children);
                            else $30315efc23bcb256$export$98e6a39c04603d36(characters, reference, reference, reference, [
                                ''
                            ], children, 0, points, children);
                        }
                    }
            }
            index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
            break;
        // :
        case 58:
            length = 1 + (0, $237729fe5ff6258f$export$36776f635604f274)(characters), property = previous;
        default:
            if (variable < 1) {
                if (character == 123) --variable;
                else if (character == 125 && variable++ == 0 && (0, $8a9fdd17a3d1ddf4$export$232faf9add678146)() == 125) continue;
            }
            switch(characters += (0, $237729fe5ff6258f$export$6788812c4e6611e6)(character), character * variable){
                // &
                case 38:
                    ampersand = offset > 0 ? 1 : (characters += '\f', -1);
                    break;
                // ,
                case 44:
                    if (parens > 0) break;
                    points[index++] = ((0, $237729fe5ff6258f$export$36776f635604f274)(characters) - 1) * ampersand, ampersand = 1;
                    break;
                // @
                case 64:
                    // -
                    if ((0, $8a9fdd17a3d1ddf4$export$4d3fb11e950abb9e)() === 45) characters += (0, $8a9fdd17a3d1ddf4$export$410ac95b9ec204b8)((0, $8a9fdd17a3d1ddf4$export$48cfd1e771a65c4f)());
                    atrule = (0, $8a9fdd17a3d1ddf4$export$4d3fb11e950abb9e)(), offset = length = (0, $237729fe5ff6258f$export$36776f635604f274)(type = characters += (0, $8a9fdd17a3d1ddf4$export$c2ab62c7bf24634)((0, $8a9fdd17a3d1ddf4$export$e88cb2efb12ae807)())), character++;
                    break;
                // -
                case 45:
                    if (previous === 45 && (0, $237729fe5ff6258f$export$36776f635604f274)(characters) == 2) variable = 0;
            }
    }
    return rulesets;
}
function $30315efc23bcb256$export$3307ffa7023ede1e(value, root, parent, index, offset, rules, points, type, props, children, length, siblings) {
    var post = offset - 1;
    var rule = offset === 0 ? rules : [
        ''
    ];
    var size = (0, $237729fe5ff6258f$export$f9084667e487ed46)(rule);
    for(var i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = (0, $237729fe5ff6258f$export$2f35ab04d2335697)(value, post + 1, post = (0, $237729fe5ff6258f$export$2335f513bbd82c6d)(j = points[i])), z = value; x < size; ++x)if (z = (0, $237729fe5ff6258f$export$87c2784dc9fc4ab)(j > 0 ? rule[x] + ' ' + y : (0, $237729fe5ff6258f$export$77ad94ebf1c2b9ed)(y, /&\f/g, rule[x]))) props[k++] = z;
    return (0, $8a9fdd17a3d1ddf4$export$35059013cd4a06db)(value, root, parent, offset === 0 ? (0, $c587a20864c1e429$export$aa3a2e812ca8570d) : type, props, children, length, siblings);
}
function $30315efc23bcb256$export$4a34f930e789283c(value, root, parent, siblings) {
    return (0, $8a9fdd17a3d1ddf4$export$35059013cd4a06db)(value, root, parent, (0, $c587a20864c1e429$export$a29989082612d0d9), (0, $237729fe5ff6258f$export$6788812c4e6611e6)((0, $8a9fdd17a3d1ddf4$export$eba6f6f03b0a92e7)()), (0, $237729fe5ff6258f$export$2f35ab04d2335697)(value, 2, -2), 0, siblings);
}
function $30315efc23bcb256$export$f8483753829ec8f3(value, root, parent, length, siblings) {
    return (0, $8a9fdd17a3d1ddf4$export$35059013cd4a06db)(value, root, parent, (0, $c587a20864c1e429$export$527d108ccf083c2b), (0, $237729fe5ff6258f$export$2f35ab04d2335697)(value, 0, length), (0, $237729fe5ff6258f$export$2f35ab04d2335697)(value, length + 1, -1), length, siblings);
}






function $c6835a1964f3aa30$export$dfdc1655ccc5b9cb(children, callback) {
    var output = '';
    for(var i = 0; i < children.length; i++)output += callback(children[i], i, children, callback) || '';
    return output;
}
function $c6835a1964f3aa30$export$fac44ee5b035f737(element, index, children, callback) {
    switch(element.type){
        case 0, $c587a20864c1e429$export$d773506282b3cfe6:
            if (element.children.length) break;
        case 0, $c587a20864c1e429$export$a763edbf796b780a:
        case 0, $c587a20864c1e429$export$6aad947bda0f3f46:
        case 0, $c587a20864c1e429$export$527d108ccf083c2b:
            return element.return = element.return || element.value;
        case 0, $c587a20864c1e429$export$a29989082612d0d9:
            return '';
        case 0, $c587a20864c1e429$export$b44a8529a35fcb60:
            return element.return = element.value + '{' + $c6835a1964f3aa30$export$dfdc1655ccc5b9cb(element.children, callback) + '}';
        case 0, $c587a20864c1e429$export$aa3a2e812ca8570d:
            if (!(0, $237729fe5ff6258f$export$36776f635604f274)(element.value = element.props.join(','))) return '';
    }
    return (0, $237729fe5ff6258f$export$36776f635604f274)(children = $c6835a1964f3aa30$export$dfdc1655ccc5b9cb(element.children, callback)) ? element.return = element.value + '{' + children + '}' : '';
}




function $083f6140643fc7b0$export$82e9f45cca5ba907(value, length, children) {
    switch((0, $237729fe5ff6258f$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $c587a20864c1e429$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
        // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
            return (0, $c587a20864c1e429$export$39dfd62a25e0fe93) + value + value;
        // mask-composite
        case 4855:
            return (0, $c587a20864c1e429$export$39dfd62a25e0fe93) + value.replace('add', 'source-over').replace('substract', 'source-out').replace('intersect', 'source-in').replace('exclude', 'xor') + value;
        // tab-size
        case 4789:
            return (0, $c587a20864c1e429$export$2c0f367103c8d01c) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $c587a20864c1e429$export$39dfd62a25e0fe93) + value + (0, $c587a20864c1e429$export$2c0f367103c8d01c) + value + (0, $c587a20864c1e429$export$71ad59f2e432cfe8) + value + value;
        // writing-mode
        case 5936:
            switch((0, $237729fe5ff6258f$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $c587a20864c1e429$export$39dfd62a25e0fe93) + value + (0, $c587a20864c1e429$export$71ad59f2e432cfe8) + (0, $237729fe5ff6258f$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $c587a20864c1e429$export$39dfd62a25e0fe93) + value + (0, $c587a20864c1e429$export$71ad59f2e432cfe8) + (0, $237729fe5ff6258f$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $c587a20864c1e429$export$39dfd62a25e0fe93) + value + (0, $c587a20864c1e429$export$71ad59f2e432cfe8) + (0, $237729fe5ff6258f$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
        // flex, flex-direction, scroll-snap-type, writing-mode
        case 6828:
        case 4268:
        case 2903:
            return (0, $c587a20864c1e429$export$39dfd62a25e0fe93) + value + (0, $c587a20864c1e429$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $c587a20864c1e429$export$39dfd62a25e0fe93) + value + (0, $c587a20864c1e429$export$71ad59f2e432cfe8) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $c587a20864c1e429$export$39dfd62a25e0fe93) + value + (0, $237729fe5ff6258f$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $c587a20864c1e429$export$39dfd62a25e0fe93) + 'box-$1$2' + (0, $c587a20864c1e429$export$71ad59f2e432cfe8) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $c587a20864c1e429$export$39dfd62a25e0fe93) + value + (0, $c587a20864c1e429$export$71ad59f2e432cfe8) + 'flex-item-' + (0, $237729fe5ff6258f$export$77ad94ebf1c2b9ed)(value, /flex-|-self/g, '') + (!(0, $237729fe5ff6258f$export$4659b591c19bdf3d)(value, /flex-|baseline/) ? (0, $c587a20864c1e429$export$71ad59f2e432cfe8) + 'grid-row-' + (0, $237729fe5ff6258f$export$77ad94ebf1c2b9ed)(value, /flex-|-self/g, '') : '') + value;
        // align-content
        case 4675:
            return (0, $c587a20864c1e429$export$39dfd62a25e0fe93) + value + (0, $c587a20864c1e429$export$71ad59f2e432cfe8) + 'flex-line-pack' + (0, $237729fe5ff6258f$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/g, '') + value;
        // flex-shrink
        case 5548:
            return (0, $c587a20864c1e429$export$39dfd62a25e0fe93) + value + (0, $c587a20864c1e429$export$71ad59f2e432cfe8) + (0, $237729fe5ff6258f$export$77ad94ebf1c2b9ed)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $c587a20864c1e429$export$39dfd62a25e0fe93) + value + (0, $c587a20864c1e429$export$71ad59f2e432cfe8) + (0, $237729fe5ff6258f$export$77ad94ebf1c2b9ed)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $c587a20864c1e429$export$39dfd62a25e0fe93) + 'box-' + (0, $237729fe5ff6258f$export$77ad94ebf1c2b9ed)(value, '-grow', '') + (0, $c587a20864c1e429$export$39dfd62a25e0fe93) + value + (0, $c587a20864c1e429$export$71ad59f2e432cfe8) + (0, $237729fe5ff6258f$export$77ad94ebf1c2b9ed)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $c587a20864c1e429$export$39dfd62a25e0fe93) + (0, $237729fe5ff6258f$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, '$1' + (0, $c587a20864c1e429$export$39dfd62a25e0fe93) + '$2') + value;
        // cursor
        case 6187:
            return (0, $237729fe5ff6258f$export$77ad94ebf1c2b9ed)((0, $237729fe5ff6258f$export$77ad94ebf1c2b9ed)((0, $237729fe5ff6258f$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $c587a20864c1e429$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $c587a20864c1e429$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $237729fe5ff6258f$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $c587a20864c1e429$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $237729fe5ff6258f$export$77ad94ebf1c2b9ed)((0, $237729fe5ff6258f$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $c587a20864c1e429$export$39dfd62a25e0fe93) + 'box-pack:$3' + (0, $c587a20864c1e429$export$71ad59f2e432cfe8) + 'flex-pack:$3'), /space-between/, 'justify') + (0, $c587a20864c1e429$export$39dfd62a25e0fe93) + value + value;
        // justify-self
        case 4200:
            if (!(0, $237729fe5ff6258f$export$4659b591c19bdf3d)(value, /flex-|baseline/)) return (0, $c587a20864c1e429$export$71ad59f2e432cfe8) + 'grid-column-align' + (0, $237729fe5ff6258f$export$2f35ab04d2335697)(value, length) + value;
            break;
        // grid-template-(columns|rows)
        case 2592:
        case 3360:
            return (0, $c587a20864c1e429$export$71ad59f2e432cfe8) + (0, $237729fe5ff6258f$export$77ad94ebf1c2b9ed)(value, 'template-', '') + value;
        // grid-(row|column)-start
        case 4384:
        case 3616:
            if (children && children.some(function(element, index) {
                return length = index, (0, $237729fe5ff6258f$export$4659b591c19bdf3d)(element.props, /grid-\w+-end/);
            })) return ~(0, $237729fe5ff6258f$export$f8e21b1e77979a08)(value + (children = children[length].value), 'span') ? value : (0, $c587a20864c1e429$export$71ad59f2e432cfe8) + (0, $237729fe5ff6258f$export$77ad94ebf1c2b9ed)(value, '-start', '') + value + (0, $c587a20864c1e429$export$71ad59f2e432cfe8) + 'grid-row-span:' + (~(0, $237729fe5ff6258f$export$f8e21b1e77979a08)(children, 'span') ? (0, $237729fe5ff6258f$export$4659b591c19bdf3d)(children, /\d+/) : +(0, $237729fe5ff6258f$export$4659b591c19bdf3d)(children, /\d+/) - +(0, $237729fe5ff6258f$export$4659b591c19bdf3d)(value, /\d+/)) + ';';
            return (0, $c587a20864c1e429$export$71ad59f2e432cfe8) + (0, $237729fe5ff6258f$export$77ad94ebf1c2b9ed)(value, '-start', '') + value;
        // grid-(row|column)-end
        case 4896:
        case 4128:
            return children && children.some(function(element) {
                return (0, $237729fe5ff6258f$export$4659b591c19bdf3d)(element.props, /grid-\w+-start/);
            }) ? value : (0, $c587a20864c1e429$export$71ad59f2e432cfe8) + (0, $237729fe5ff6258f$export$77ad94ebf1c2b9ed)((0, $237729fe5ff6258f$export$77ad94ebf1c2b9ed)(value, '-end', '-span'), 'span ', '') + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $237729fe5ff6258f$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $c587a20864c1e429$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $237729fe5ff6258f$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $237729fe5ff6258f$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $237729fe5ff6258f$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $237729fe5ff6258f$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $c587a20864c1e429$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $c587a20864c1e429$export$2c0f367103c8d01c) + ((0, $237729fe5ff6258f$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $237729fe5ff6258f$export$f8e21b1e77979a08)(value, 'stretch') ? $083f6140643fc7b0$export$82e9f45cca5ba907((0, $237729fe5ff6258f$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length, children) + value : value;
            }
            break;
        // grid-(column|row)
        case 5152:
        case 5920:
            return (0, $237729fe5ff6258f$export$77ad94ebf1c2b9ed)(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(_, a, b, c, d, e, f) {
                return (0, $c587a20864c1e429$export$71ad59f2e432cfe8) + a + ':' + b + f + (c ? (0, $c587a20864c1e429$export$71ad59f2e432cfe8) + a + '-span:' + (d ? e : +e - +b) + f : '') + value;
            });
        // position: sticky
        case 4949:
            // stick(y)?
            if ((0, $237729fe5ff6258f$export$a9db5e087081082d)(value, length + 6) === 121) return (0, $237729fe5ff6258f$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $c587a20864c1e429$export$39dfd62a25e0fe93)) + value;
            break;
        // display: (flex|inline-flex|grid|inline-grid)
        case 6444:
            switch((0, $237729fe5ff6258f$export$a9db5e087081082d)(value, (0, $237729fe5ff6258f$export$a9db5e087081082d)(value, 14) === 45 ? 18 : 11)){
                // (inline-)?fle(x)
                case 120:
                    return (0, $237729fe5ff6258f$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, '$1' + (0, $c587a20864c1e429$export$39dfd62a25e0fe93) + ((0, $237729fe5ff6258f$export$a9db5e087081082d)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $c587a20864c1e429$export$39dfd62a25e0fe93) + '$2$3' + '$1' + (0, $c587a20864c1e429$export$71ad59f2e432cfe8) + '$2box$3') + value;
                // (inline-)?gri(d)
                case 100:
                    return (0, $237729fe5ff6258f$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $c587a20864c1e429$export$71ad59f2e432cfe8)) + value;
            }
            break;
        // scroll-margin, scroll-margin-(top|right|bottom|left)
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return (0, $237729fe5ff6258f$export$77ad94ebf1c2b9ed)(value, 'scroll-', 'scroll-snap-') + value;
    }
    return value;
}


function $710dec8eb6540acf$export$5a7767152ae0305f(collection) {
    var length = (0, $237729fe5ff6258f$export$f9084667e487ed46)(collection);
    return function(element, index, children, callback) {
        var output = '';
        for(var i = 0; i < length; i++)output += collection[i](element, index, children, callback) || '';
        return output;
    };
}
function $710dec8eb6540acf$export$38bcb760f1d4871c(callback) {
    return function(element) {
        if (!element.root) {
            if (element = element.return) callback(element);
        }
    };
}
function $710dec8eb6540acf$export$e08c7d021b829b7a(element, index, children, callback) {
    if (element.length > -1) {
        if (!element.return) switch(element.type){
            case 0, $c587a20864c1e429$export$527d108ccf083c2b:
                element.return = (0, $083f6140643fc7b0$export$82e9f45cca5ba907)(element.value, element.length, children);
                return;
            case 0, $c587a20864c1e429$export$b44a8529a35fcb60:
                return (0, $c6835a1964f3aa30$export$dfdc1655ccc5b9cb)([
                    (0, $8a9fdd17a3d1ddf4$export$784d13d8ee351f07)(element, {
                        value: (0, $237729fe5ff6258f$export$77ad94ebf1c2b9ed)(element.value, '@', '@' + (0, $c587a20864c1e429$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $c587a20864c1e429$export$aa3a2e812ca8570d:
                if (element.length) return (0, $237729fe5ff6258f$export$1be1fc439b849fdf)(children = element.props, function(value) {
                    switch((0, $237729fe5ff6258f$export$4659b591c19bdf3d)(value, callback = /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            (0, $8a9fdd17a3d1ddf4$export$590e8b2c435046d9)((0, $8a9fdd17a3d1ddf4$export$784d13d8ee351f07)(element, {
                                props: [
                                    (0, $237729fe5ff6258f$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $c587a20864c1e429$export$2c0f367103c8d01c) + '$1')
                                ]
                            }));
                            (0, $8a9fdd17a3d1ddf4$export$590e8b2c435046d9)((0, $8a9fdd17a3d1ddf4$export$784d13d8ee351f07)(element, {
                                props: [
                                    value
                                ]
                            }));
                            (0, $237729fe5ff6258f$export$e6e34fd1f2686227)(element, {
                                props: (0, $237729fe5ff6258f$export$3dea766d36a8935f)(children, callback)
                            });
                            break;
                        // :placeholder
                        case '::placeholder':
                            (0, $8a9fdd17a3d1ddf4$export$590e8b2c435046d9)((0, $8a9fdd17a3d1ddf4$export$784d13d8ee351f07)(element, {
                                props: [
                                    (0, $237729fe5ff6258f$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $c587a20864c1e429$export$39dfd62a25e0fe93) + 'input-$1')
                                ]
                            }));
                            (0, $8a9fdd17a3d1ddf4$export$590e8b2c435046d9)((0, $8a9fdd17a3d1ddf4$export$784d13d8ee351f07)(element, {
                                props: [
                                    (0, $237729fe5ff6258f$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $c587a20864c1e429$export$2c0f367103c8d01c) + '$1')
                                ]
                            }));
                            (0, $8a9fdd17a3d1ddf4$export$590e8b2c435046d9)((0, $8a9fdd17a3d1ddf4$export$784d13d8ee351f07)(element, {
                                props: [
                                    (0, $237729fe5ff6258f$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $c587a20864c1e429$export$71ad59f2e432cfe8) + 'input-$1')
                                ]
                            }));
                            (0, $8a9fdd17a3d1ddf4$export$590e8b2c435046d9)((0, $8a9fdd17a3d1ddf4$export$784d13d8ee351f07)(element, {
                                props: [
                                    value
                                ]
                            }));
                            (0, $237729fe5ff6258f$export$e6e34fd1f2686227)(element, {
                                props: (0, $237729fe5ff6258f$export$3dea766d36a8935f)(children, callback)
                            });
                            break;
                    }
                    return '';
                });
        }
    }
}
function $710dec8eb6540acf$export$76a88f7de6507443(element) {
    switch(element.type){
        case 0, $c587a20864c1e429$export$aa3a2e812ca8570d:
            element.props = element.props.map(function(value) {
                return (0, $237729fe5ff6258f$export$1be1fc439b849fdf)((0, $8a9fdd17a3d1ddf4$export$660b2ee2d4fb4eff)(value), function(value, index, children) {
                    switch((0, $237729fe5ff6258f$export$a9db5e087081082d)(value, 0)){
                        // \f
                        case 12:
                            return (0, $237729fe5ff6258f$export$2f35ab04d2335697)(value, 1, (0, $237729fe5ff6258f$export$36776f635604f274)(value));
                        // \0 ( + > ~
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return value;
                        // :
                        case 58:
                            if (children[++index] === 'global') children[index] = '', children[++index] = '\f' + (0, $237729fe5ff6258f$export$2f35ab04d2335697)(children[index], index = 1, -1);
                        // \s
                        case 32:
                            return index === 1 ? '' : value;
                        default:
                            switch(index){
                                case 0:
                                    element = value;
                                    return (0, $237729fe5ff6258f$export$f9084667e487ed46)(children) > 1 ? '' : value;
                                case index = (0, $237729fe5ff6258f$export$f9084667e487ed46)(children) - 1:
                                case 2:
                                    return index === 2 ? value + element + element : value + element;
                                default:
                                    return value;
                            }
                    }
                });
            });
    }
}



function $ee81e58d6c975008$export$e7b7955c4f1f8c03(message, info) {
    const { path: path, parentSelectors: parentSelectors } = info;
    (0, $f757b9ac02fa080d$export$2e2bcd8739ae039)(false, `[Ant Design CSS-in-JS] ${path ? `Error in ${path}: ` : ''}${message}${parentSelectors.length ? ` Selector: ${parentSelectors.join(' | ')}` : ''}`);
}


const $7d288f1bb5f7ffa8$var$linter = (key, value, info)=>{
    if (key === 'content') {
        // From emotion: https://github.com/emotion-js/emotion/blob/main/packages/serialize/src/index.js#L63
        const contentValuePattern = /(attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
        const contentValues = [
            'normal',
            'none',
            'initial',
            'inherit',
            'unset'
        ];
        if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && !value.startsWith('var(') && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) (0, $ee81e58d6c975008$export$e7b7955c4f1f8c03)(`You seem to be using a value for 'content' without quotes, try replacing it with \`content: '"${value}"'\`.`, info);
    }
};
var $7d288f1bb5f7ffa8$export$2e2bcd8739ae039 = $7d288f1bb5f7ffa8$var$linter;



const $1a27e753d6327f21$var$linter = (key, value, info)=>{
    if (key === 'animation') {
        if (info.hashId && value !== 'none') (0, $ee81e58d6c975008$export$e7b7955c4f1f8c03)(`You seem to be using hashed animation '${value}', in which case 'animationName' with Keyframe as value is recommended.`, info);
    }
};
var $1a27e753d6327f21$export$2e2bcd8739ae039 = $1a27e753d6327f21$var$linter;



function $8d977309fde50ae3$var$isConcatSelector(selector) {
    const notContent = selector.match(/:not\(([^)]*)\)/)?.[1] || '';
    // split selector. e.g.
    // `h1#a.b` => ['h1', #a', '.b']
    const splitCells = notContent.split(/(\[[^[]*])|(?=[.#])/).filter((str)=>str);
    return splitCells.length > 1;
}
function $8d977309fde50ae3$var$parsePath(info) {
    return info.parentSelectors.reduce((prev, cur)=>{
        if (!prev) return cur;
        return cur.includes('&') ? cur.replace(/&/g, prev) : `${prev} ${cur}`;
    }, '');
}
const $8d977309fde50ae3$var$linter = (key, value, info)=>{
    const parentSelectorPath = $8d977309fde50ae3$var$parsePath(info);
    const notList = parentSelectorPath.match(/:not\([^)]*\)/g) || [];
    if (notList.length > 0 && notList.some($8d977309fde50ae3$var$isConcatSelector)) (0, $ee81e58d6c975008$export$e7b7955c4f1f8c03)(`Concat ':not' selector not support in legacy browsers.`, info);
};
var $8d977309fde50ae3$export$2e2bcd8739ae039 = $8d977309fde50ae3$var$linter;



const $4f800486ce3b06b0$var$linter = (key, value, info)=>{
    switch(key){
        case 'marginLeft':
        case 'marginRight':
        case 'paddingLeft':
        case 'paddingRight':
        case 'left':
        case 'right':
        case 'borderLeft':
        case 'borderLeftWidth':
        case 'borderLeftStyle':
        case 'borderLeftColor':
        case 'borderRight':
        case 'borderRightWidth':
        case 'borderRightStyle':
        case 'borderRightColor':
        case 'borderTopLeftRadius':
        case 'borderTopRightRadius':
        case 'borderBottomLeftRadius':
        case 'borderBottomRightRadius':
            (0, $ee81e58d6c975008$export$e7b7955c4f1f8c03)(`You seem to be using non-logical property '${key}' which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties.`, info);
            return;
        case 'margin':
        case 'padding':
        case 'borderWidth':
        case 'borderStyle':
            // case 'borderColor':
            if (typeof value === 'string') {
                const valueArr = value.split(' ').map((item)=>item.trim());
                if (valueArr.length === 4 && valueArr[1] !== valueArr[3]) (0, $ee81e58d6c975008$export$e7b7955c4f1f8c03)(`You seem to be using '${key}' property with different left ${key} and right ${key}, which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties.`, info);
            }
            return;
        case 'clear':
        case 'textAlign':
            if (value === 'left' || value === 'right') (0, $ee81e58d6c975008$export$e7b7955c4f1f8c03)(`You seem to be using non-logical value '${value}' of ${key}, which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties.`, info);
            return;
        case 'borderRadius':
            if (typeof value === 'string') {
                const radiusGroups = value.split('/').map((item)=>item.trim());
                const invalid = radiusGroups.reduce((result, group)=>{
                    if (result) return result;
                    const radiusArr = group.split(' ').map((item)=>item.trim());
                    // borderRadius: '2px 4px'
                    if (radiusArr.length >= 2 && radiusArr[0] !== radiusArr[1]) return true;
                    // borderRadius: '4px 4px 2px'
                    if (radiusArr.length === 3 && radiusArr[1] !== radiusArr[2]) return true;
                    // borderRadius: '4px 4px 2px 4px'
                    if (radiusArr.length === 4 && radiusArr[2] !== radiusArr[3]) return true;
                    return result;
                }, false);
                if (invalid) (0, $ee81e58d6c975008$export$e7b7955c4f1f8c03)(`You seem to be using non-logical value '${value}' of ${key}, which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties.`, info);
            }
            return;
        default:
    }
};
var $4f800486ce3b06b0$export$2e2bcd8739ae039 = $4f800486ce3b06b0$var$linter;



const $75bb6f03ab6937c3$var$linter = (key, value, info)=>{
    if (typeof value === 'string' && /NaN/g.test(value) || Number.isNaN(value)) (0, $ee81e58d6c975008$export$e7b7955c4f1f8c03)(`Unexpected 'NaN' in property '${key}: ${value}'.`, info);
};
var $75bb6f03ab6937c3$export$2e2bcd8739ae039 = $75bb6f03ab6937c3$var$linter;



const $76c85cf8157712cb$var$linter = (key, value, info)=>{
    if (info.parentSelectors.some((selector)=>{
        const selectors = selector.split(',');
        return selectors.some((item)=>item.split('&').length > 2);
    })) (0, $ee81e58d6c975008$export$e7b7955c4f1f8c03)('Should not use more than one `&` in a selector.', info);
};
var $76c85cf8157712cb$export$2e2bcd8739ae039 = $76c85cf8157712cb$var$linter;








const $2346e8d48d35eba7$export$1c054aa01963e47e = 'data-ant-cssinjs-cache-path';
const $2346e8d48d35eba7$export$e0a2f8ff7fc63361 = '_FILE_STYLE__';
function $2346e8d48d35eba7$export$dfdc1655ccc5b9cb(cachePathMap) {
    return Object.keys(cachePathMap).map((path)=>{
        const hash = cachePathMap[path];
        return `${path}:${hash}`;
    }).join(';');
}
let $2346e8d48d35eba7$var$cachePathMap;
let $2346e8d48d35eba7$var$fromCSSFile = true;
function $2346e8d48d35eba7$export$aad8462122ac592b(mockCache, fromFile = true) {
    $2346e8d48d35eba7$var$cachePathMap = mockCache;
    $2346e8d48d35eba7$var$fromCSSFile = fromFile;
}
function $2346e8d48d35eba7$export$18298bb220d85216() {
    if (!$2346e8d48d35eba7$var$cachePathMap) {
        $2346e8d48d35eba7$var$cachePathMap = {};
        if ((0, $8b91ba628d942bf2$export$2e2bcd8739ae039)()) {
            const div = document.createElement('div');
            div.className = $2346e8d48d35eba7$export$1c054aa01963e47e;
            div.style.position = 'fixed';
            div.style.visibility = 'hidden';
            div.style.top = '-9999px';
            document.body.appendChild(div);
            let content = getComputedStyle(div).content || '';
            content = content.replace(/^"/, '').replace(/"$/, '');
            // Fill data
            content.split(';').forEach((item)=>{
                const [path, hash] = item.split(':');
                $2346e8d48d35eba7$var$cachePathMap[path] = hash;
            });
            // Remove inline record style
            const inlineMapStyle = document.querySelector(`style[${$2346e8d48d35eba7$export$1c054aa01963e47e}]`);
            if (inlineMapStyle) {
                $2346e8d48d35eba7$var$fromCSSFile = false;
                inlineMapStyle.parentNode?.removeChild(inlineMapStyle);
            }
            document.body.removeChild(div);
        }
    }
}
function $2346e8d48d35eba7$export$5aa0d776d676ab98(path) {
    $2346e8d48d35eba7$export$18298bb220d85216();
    return !!$2346e8d48d35eba7$var$cachePathMap[path];
}
function $2346e8d48d35eba7$export$d3851dfd3659b2ce(path) {
    const hash = $2346e8d48d35eba7$var$cachePathMap[path];
    let styleStr = null;
    if (hash && (0, $8b91ba628d942bf2$export$2e2bcd8739ae039)()) {
        if ($2346e8d48d35eba7$var$fromCSSFile) styleStr = $2346e8d48d35eba7$export$e0a2f8ff7fc63361;
        else {
            const style = document.querySelector(`style[${(0, $6c29e14c4abe80bf$export$89ce1123b3c0bd9e)}="${$2346e8d48d35eba7$var$cachePathMap[path]}"]`);
            if (style) styleStr = style.innerHTML;
            else // Clean up since not exist anymore
            delete $2346e8d48d35eba7$var$cachePathMap[path];
        }
    }
    return [
        styleStr,
        hash
    ];
}



const $4f1ffbb71c2e9fc2$var$SKIP_CHECK = '_skip_check_';
const $4f1ffbb71c2e9fc2$var$MULTI_VALUE = '_multi_value_';
function $4f1ffbb71c2e9fc2$export$8756898546458274(styleStr, autoPrefix) {
    const serialized = autoPrefix ? (0, $c6835a1964f3aa30$export$dfdc1655ccc5b9cb)((0, $30315efc23bcb256$export$ef7acd7185315e22)(styleStr), (0, $710dec8eb6540acf$export$5a7767152ae0305f)([
        (0, $710dec8eb6540acf$export$e08c7d021b829b7a),
        (0, $c6835a1964f3aa30$export$fac44ee5b035f737)
    ])) : (0, $c6835a1964f3aa30$export$dfdc1655ccc5b9cb)((0, $30315efc23bcb256$export$ef7acd7185315e22)(styleStr), (0, $c6835a1964f3aa30$export$fac44ee5b035f737));
    return serialized.replace(/\{%%%\:[^;];}/g, ';');
}
function $4f1ffbb71c2e9fc2$var$isCompoundCSSProperty(value) {
    return typeof value === 'object' && value && ($4f1ffbb71c2e9fc2$var$SKIP_CHECK in value || $4f1ffbb71c2e9fc2$var$MULTI_VALUE in value);
}
// 注入 hash 值
function $4f1ffbb71c2e9fc2$var$injectSelectorHash(key, hashId, hashPriority = 'high') {
    if (!hashId) return key;
    const hashSelector = (0, $56bae8a99c3cba6e$export$9c59b80dda569a6e)({
        hashCls: hashId,
        hashPriority: hashPriority
    });
    // 注入 hashId
    const keys = key.split(',').map((k)=>{
        const fullPath = k.trim().split(/\s+/);
        // 如果 Selector 第一个是 HTML Element，那我们就插到它的后面。反之，就插到最前面。
        let firstPath = fullPath[0] || '';
        const htmlElement = firstPath.match(/^\w+/)?.[0] || '';
        firstPath = `${htmlElement}${hashSelector}${firstPath.slice(htmlElement.length)}`;
        return [
            firstPath,
            ...fullPath.slice(1)
        ].join(' ');
    });
    return keys.join(',');
}
const $4f1ffbb71c2e9fc2$export$e13dc740254f53d7 = (interpolation, config = {}, { root: root, injectHash: injectHash, parentSelectors: parentSelectors } = {
    root: true,
    parentSelectors: []
})=>{
    const { hashId: hashId, layer: layer, path: path, hashPriority: hashPriority, transformers: transformers = [], linters: linters = [] } = config;
    let styleStr = '';
    let effectStyle = {};
    function parseKeyframes(keyframes) {
        const animationName = keyframes.getName(hashId);
        if (!effectStyle[animationName]) {
            const [parsedStr] = $4f1ffbb71c2e9fc2$export$e13dc740254f53d7(keyframes.style, config, {
                root: false,
                parentSelectors: parentSelectors
            });
            effectStyle[animationName] = `@keyframes ${keyframes.getName(hashId)}${parsedStr}`;
        }
    }
    function flattenList(list, fullList = []) {
        list.forEach((item)=>{
            if (Array.isArray(item)) flattenList(item, fullList);
            else if (item) fullList.push(item);
        });
        return fullList;
    }
    const flattenStyleList = flattenList(Array.isArray(interpolation) ? interpolation : [
        interpolation
    ]);
    flattenStyleList.forEach((originStyle)=>{
        // Only root level can use raw string
        const style = typeof originStyle === 'string' && !root ? {} : originStyle;
        if (typeof style === 'string') styleStr += `${style}\n`;
        else if (style._keyframe) // Keyframe
        parseKeyframes(style);
        else {
            const mergedStyle = transformers.reduce((prev, trans)=>trans?.visit?.(prev) || prev, style);
            // Normal CSSObject
            Object.keys(mergedStyle).forEach((key)=>{
                const value = mergedStyle[key];
                if (typeof value === 'object' && value && (key !== 'animationName' || !value._keyframe) && !$4f1ffbb71c2e9fc2$var$isCompoundCSSProperty(value)) {
                    let subInjectHash = false;
                    // 当成嵌套对象来处理
                    let mergedKey = key.trim();
                    // Whether treat child as root. In most case it is false.
                    let nextRoot = false;
                    // 拆分多个选择器
                    if ((root || injectHash) && hashId) {
                        if (mergedKey.startsWith('@')) // 略过媒体查询，交给子节点继续插入 hashId
                        subInjectHash = true;
                        else if (mergedKey === '&') // 抹掉 root selector 上的单个 &
                        mergedKey = $4f1ffbb71c2e9fc2$var$injectSelectorHash('', hashId, hashPriority);
                        else // 注入 hashId
                        mergedKey = $4f1ffbb71c2e9fc2$var$injectSelectorHash(key, hashId, hashPriority);
                    } else if (root && !hashId && (mergedKey === '&' || mergedKey === '')) {
                        // In case of `{ '&': { a: { color: 'red' } } }` or `{ '': { a: { color: 'red' } } }` without hashId,
                        // we will get `&{a:{color:red;}}` or `{a:{color:red;}}` string for stylis to compile.
                        // But it does not conform to stylis syntax,
                        // and finally we will get `{color:red;}` as css, which is wrong.
                        // So we need to remove key in root, and treat child `{ a: { color: 'red' } }` as root.
                        mergedKey = '';
                        nextRoot = true;
                    }
                    const [parsedStr, childEffectStyle] = $4f1ffbb71c2e9fc2$export$e13dc740254f53d7(value, config, {
                        root: nextRoot,
                        injectHash: subInjectHash,
                        parentSelectors: [
                            ...parentSelectors,
                            mergedKey
                        ]
                    });
                    effectStyle = {
                        ...effectStyle,
                        ...childEffectStyle
                    };
                    styleStr += `${mergedKey}${parsedStr}`;
                } else {
                    function appendStyle(cssKey, cssValue) {
                        var linter;
                        // 如果是样式则直接插入
                        const styleName = cssKey.replace(/[A-Z]/g, (match)=>`-${match.toLowerCase()}`);
                        // Auto suffix with px
                        let formatValue = cssValue;
                        if (!(0, $885f4eee88e48c11$export$2e2bcd8739ae039)[cssKey] && typeof formatValue === 'number' && formatValue !== 0) formatValue = `${formatValue}px`;
                        // handle animationName & Keyframe value
                        if (cssKey === 'animationName' && cssValue?._keyframe) {
                            parseKeyframes(cssValue);
                            formatValue = cssValue.getName(hashId);
                        }
                        styleStr += `${styleName}:${formatValue};`;
                    }
                    const actualValue = value?.value ?? value;
                    if (typeof value === 'object' && value?.[$4f1ffbb71c2e9fc2$var$MULTI_VALUE] && Array.isArray(actualValue)) actualValue.forEach((item)=>{
                        appendStyle(key, item);
                    });
                    else if ((0, $56bae8a99c3cba6e$export$826fff653a329e83)(actualValue)) appendStyle(key, actualValue);
                }
            });
        }
    });
    if (!root) styleStr = `{${styleStr}}`;
    else if (layer) {
        // fixme: https://github.com/thysultan/stylis/pull/339
        if (styleStr) styleStr = `@layer ${layer.name} {${styleStr}}`;
        if (layer.dependencies) effectStyle[`@layer ${layer.name}`] = layer.dependencies.map((deps)=>`@layer ${deps}, ${layer.name};`).join('\n');
    }
    return [
        styleStr,
        effectStyle
    ];
};
function $4f1ffbb71c2e9fc2$export$412618713057f6ca(path, styleStr) {
    return (0, $265e8c0f7074eb72$export$2e2bcd8739ae039)(`${path.join('%')}${styleStr}`);
}
const $4f1ffbb71c2e9fc2$export$1e6d9f0d06c7ec14 = 'style';
function $4f1ffbb71c2e9fc2$export$2e2bcd8739ae039(info, styleFn) {
    const { path: path, hashId: hashId, layer: layer, nonce: nonce, clientOnly: clientOnly, order: order = 0 } = info;
    const { mock: mock, hashPriority: hashPriority, container: container, transformers: transformers, linters: linters, cache: cache, layer: enableLayer, autoPrefix: autoPrefix } = $5E6i4.useContext((0, $6c29e14c4abe80bf$export$2e2bcd8739ae039));
    const fullPath = [
        hashId || ''
    ];
    if (enableLayer) fullPath.push('layer');
    fullPath.push(...path);
    // Check if need insert style
    let isMergedClientSide = (0, $56bae8a99c3cba6e$export$9542afab8c2a5f48);
    (0, $dc3c7e9a5592e2bc$export$2e2bcd8739ae039)($4f1ffbb71c2e9fc2$export$1e6d9f0d06c7ec14, fullPath, // Create cache if needed
    ()=>{
        const cachePath = fullPath.join('|');
        // Get style from SSR inline style directly
        if ((0, $2346e8d48d35eba7$export$5aa0d776d676ab98)(cachePath)) {
            const [inlineCacheStyleStr, styleHash] = (0, $2346e8d48d35eba7$export$d3851dfd3659b2ce)(cachePath);
            if (inlineCacheStyleStr) return [
                inlineCacheStyleStr,
                styleHash,
                {},
                clientOnly,
                order
            ];
        }
        // Generate style
        const styleObj = styleFn();
        const [parsedStyle, effectStyle] = $4f1ffbb71c2e9fc2$export$e13dc740254f53d7(styleObj, {
            hashId: hashId,
            hashPriority: hashPriority,
            layer: enableLayer ? layer : undefined,
            path: path.join('-'),
            transformers: transformers,
            linters: linters
        });
        const styleStr = $4f1ffbb71c2e9fc2$export$8756898546458274(parsedStyle, autoPrefix || false);
        const styleId = $4f1ffbb71c2e9fc2$export$412618713057f6ca(fullPath, styleStr);
        return [
            styleStr,
            styleId,
            effectStyle,
            clientOnly,
            order
        ];
    }, // Remove cache if no need
    (cacheValue, fromHMR)=>{
        const [, styleId] = cacheValue;
        if (fromHMR && (0, $56bae8a99c3cba6e$export$9542afab8c2a5f48)) (0, $d5dd4df2f97e6f98$export$2232e336aecaa80a)(styleId, {
            mark: (0, $6c29e14c4abe80bf$export$89ce1123b3c0bd9e),
            attachTo: container
        });
    }, // Effect: Inject style here
    (cacheValue)=>{
        const [styleStr, styleId, effectStyle, , priority] = cacheValue;
        if (isMergedClientSide && styleStr !== (0, $2346e8d48d35eba7$export$e0a2f8ff7fc63361)) {
            let mergedCSSConfig = {
                mark: (0, $6c29e14c4abe80bf$export$89ce1123b3c0bd9e),
                prepend: enableLayer ? false : 'queue',
                attachTo: container,
                priority: priority
            };
            mergedCSSConfig = (0, $56bae8a99c3cba6e$export$f508583337ce246)(mergedCSSConfig, nonce);
            // ================= Split Effect Style =================
            // We will split effectStyle here since @layer should be at the top level
            const effectLayerKeys = [];
            const effectRestKeys = [];
            Object.keys(effectStyle).forEach((key)=>{
                if (key.startsWith('@layer')) effectLayerKeys.push(key);
                else effectRestKeys.push(key);
            });
            // ================= Inject Layer Style =================
            // Inject layer style
            effectLayerKeys.forEach((effectKey)=>{
                (0, $d5dd4df2f97e6f98$export$4d99a2890bb989f0)($4f1ffbb71c2e9fc2$export$8756898546458274(effectStyle[effectKey], autoPrefix || false), `_layer-${effectKey}`, {
                    ...mergedCSSConfig,
                    prepend: true
                });
            });
            // ==================== Inject Style ====================
            // Inject style
            const style = (0, $d5dd4df2f97e6f98$export$4d99a2890bb989f0)(styleStr, styleId, mergedCSSConfig);
            style[0, $6c29e14c4abe80bf$export$4c16a0c02134a7dc] = cache.instanceId;
            // ================ Inject Effect Style =================
            // Inject client side effect style
            effectRestKeys.forEach((effectKey)=>{
                (0, $d5dd4df2f97e6f98$export$4d99a2890bb989f0)($4f1ffbb71c2e9fc2$export$8756898546458274(effectStyle[effectKey], autoPrefix || false), `_effect-${effectKey}`, mergedCSSConfig);
            });
        }
    });
}
const $4f1ffbb71c2e9fc2$export$f9380c9a627682d3 = (cache, effectStyles, options)=>{
    const [styleStr, styleId, effectStyle, clientOnly, order] = cache;
    const { plain: plain, autoPrefix: autoPrefix } = options || {};
    // Skip client only style
    if (clientOnly) return null;
    let keyStyleText = styleStr;
    // ====================== Share ======================
    // Used for @rc-component/util
    const sharedAttrs = {
        'data-rc-order': 'prependQueue',
        'data-rc-priority': `${order}`
    };
    // ====================== Style ======================
    keyStyleText = (0, $56bae8a99c3cba6e$export$71c98ec84f0481d3)(styleStr, undefined, styleId, sharedAttrs, plain);
    // =============== Create effect style ===============
    if (effectStyle) Object.keys(effectStyle).forEach((effectKey)=>{
        // Effect style can be reused
        if (!effectStyles[effectKey]) {
            effectStyles[effectKey] = true;
            const effectStyleStr = $4f1ffbb71c2e9fc2$export$8756898546458274(effectStyle[effectKey], autoPrefix || false);
            const effectStyleHTML = (0, $56bae8a99c3cba6e$export$71c98ec84f0481d3)(effectStyleStr, undefined, `_effect-${effectKey}`, sharedAttrs, plain);
            if (effectKey.startsWith('@layer')) keyStyleText = effectStyleHTML + keyStyleText;
            else keyStyleText += effectStyleHTML;
        }
    });
    return [
        order,
        styleId,
        keyStyleText
    ];
};


const $a5bf63096405ab5f$export$d96c342855c5e1fc = 'cssVar';
const $a5bf63096405ab5f$var$useCSSVarRegister = (config, fn)=>{
    const { key: key, prefix: prefix, unitless: unitless, ignore: ignore, token: token, hashId: hashId, scope: scope, nonce: nonce } = config;
    const { cache: { instanceId: instanceId }, container: container, hashPriority: hashPriority } = (0, $5E6i4.useContext)((0, $6c29e14c4abe80bf$export$2e2bcd8739ae039));
    const { _tokenKey: tokenKey } = token;
    const scopeKey = Array.isArray(scope) ? scope.join('@@') : scope;
    const stylePath = [
        ...config.path,
        key,
        scopeKey,
        tokenKey
    ];
    const cache = (0, $dc3c7e9a5592e2bc$export$2e2bcd8739ae039)($a5bf63096405ab5f$export$d96c342855c5e1fc, stylePath, ()=>{
        const originToken = fn();
        const [mergedToken, cssVarsStr] = (0, $c0aeb8a4ecafde61$export$67858afe85bce49f)(originToken, key, {
            prefix: prefix,
            unitless: unitless,
            ignore: ignore,
            scope: scope,
            hashPriority: hashPriority,
            hashCls: hashId
        });
        const styleId = (0, $4f1ffbb71c2e9fc2$export$412618713057f6ca)(stylePath, cssVarsStr);
        return [
            mergedToken,
            cssVarsStr,
            styleId,
            key
        ];
    }, ([, , styleId])=>{
        if (0, $56bae8a99c3cba6e$export$9542afab8c2a5f48) (0, $d5dd4df2f97e6f98$export$2232e336aecaa80a)(styleId, {
            mark: (0, $6c29e14c4abe80bf$export$89ce1123b3c0bd9e),
            attachTo: container
        });
    }, ([, cssVarsStr, styleId])=>{
        if (!cssVarsStr) return;
        let mergedCSSConfig = {
            mark: (0, $6c29e14c4abe80bf$export$89ce1123b3c0bd9e),
            prepend: 'queue',
            attachTo: container,
            priority: -999
        };
        mergedCSSConfig = (0, $56bae8a99c3cba6e$export$f508583337ce246)(mergedCSSConfig, nonce);
        const style = (0, $d5dd4df2f97e6f98$export$4d99a2890bb989f0)(cssVarsStr, styleId, mergedCSSConfig);
        style[0, $6c29e14c4abe80bf$export$4c16a0c02134a7dc] = instanceId;
        // Used for `useCacheToken` to remove on batch when token removed
        style.setAttribute((0, $6c29e14c4abe80bf$export$5d99297dcd5476ac), key);
    });
    return cache;
};
const $a5bf63096405ab5f$export$f9380c9a627682d3 = (cache, effectStyles, options)=>{
    const [, styleStr, styleId, cssVarKey] = cache;
    const { plain: plain } = options || {};
    if (!styleStr) return null;
    const order = -999;
    // ====================== Style ======================
    // Used for @rc-component/util
    const sharedAttrs = {
        'data-rc-order': 'prependQueue',
        'data-rc-priority': `${order}`
    };
    const styleText = (0, $56bae8a99c3cba6e$export$71c98ec84f0481d3)(styleStr, cssVarKey, styleId, sharedAttrs, plain);
    return [
        order,
        styleId,
        styleText
    ];
};
var $a5bf63096405ab5f$export$2e2bcd8739ae039 = $a5bf63096405ab5f$var$useCSSVarRegister;





const $f8610fd31c147487$var$ExtractStyleFns = {
    [(0, $4f1ffbb71c2e9fc2$export$1e6d9f0d06c7ec14)]: (0, $4f1ffbb71c2e9fc2$export$f9380c9a627682d3),
    [(0, $efddb89bf789bd65$export$270fba097347f4fa)]: (0, $efddb89bf789bd65$export$f9380c9a627682d3),
    [(0, $a5bf63096405ab5f$export$d96c342855c5e1fc)]: (0, $a5bf63096405ab5f$export$f9380c9a627682d3)
};
function $f8610fd31c147487$var$isNotNull(value) {
    return value !== null;
}
function $f8610fd31c147487$export$2e2bcd8739ae039(cache, options) {
    const { plain: plain = false, types: types = [
        'style',
        'token',
        'cssVar'
    ], once: once = false } = typeof options === 'boolean' ? {
        plain: options
    } : options || {};
    const matchPrefixRegexp = new RegExp(`^(${(typeof types === 'string' ? [
        types
    ] : types).join('|')})%`);
    // prefix with `style` is used for `useStyleRegister` to cache style context
    const styleKeys = Array.from(cache.cache.keys()).filter((key)=>matchPrefixRegexp.test(key));
    // Common effect styles like animation
    const effectStyles = {};
    // Mapping of cachePath to style hash
    const cachePathMap = {};
    let styleText = '';
    styleKeys.map((key)=>{
        if (once && cache.extracted.has(key)) return null; // Skip if already extracted
        const cachePath = key.replace(matchPrefixRegexp, '').replace(/%/g, '|');
        const [prefix] = key.split('%');
        const extractFn = $f8610fd31c147487$var$ExtractStyleFns[prefix];
        const extractedStyle = extractFn(cache.cache.get(key)[1], effectStyles, {
            plain: plain
        });
        if (!extractedStyle) return null;
        const updateTime = cache.updateTimes.get(key) || 0;
        const [order, styleId, styleStr] = extractedStyle;
        if (key.startsWith('style')) cachePathMap[cachePath] = styleId;
        // record that this style has been extracted
        cache.extracted.add(key);
        return [
            order,
            styleStr,
            updateTime
        ];
    }).filter($f8610fd31c147487$var$isNotNull).sort(([o1, , u1], [o2, , u2])=>{
        if (o1 !== o2) return o1 - o2;
        return u1 - u2;
    }).forEach(([, style])=>{
        styleText += style;
    });
    // ==================== Fill Cache Path ====================
    styleText += (0, $56bae8a99c3cba6e$export$71c98ec84f0481d3)(`.${(0, $2346e8d48d35eba7$export$1c054aa01963e47e)}{content:"${(0, $2346e8d48d35eba7$export$dfdc1655ccc5b9cb)(cachePathMap)}";}`, undefined, undefined, {
        [(0, $2346e8d48d35eba7$export$1c054aa01963e47e)]: (0, $2346e8d48d35eba7$export$1c054aa01963e47e)
    }, plain);
    return styleText;
}





class $14544cbeb8c8473b$var$Keyframe {
    name;
    style;
    constructor(name, style){
        this.name = name;
        this.style = style;
    }
    getName(hashId = '') {
        return hashId ? `${hashId}-${this.name}` : this.name;
    }
    _keyframe = true;
}
var $14544cbeb8c8473b$export$2e2bcd8739ae039 = $14544cbeb8c8473b$var$Keyframe;






function $2b438c4697f915e0$var$splitValues(value) {
    if (typeof value === 'number') return [
        [
            value
        ],
        false
    ];
    const rawStyle = String(value).trim();
    const importantCells = rawStyle.match(/(.*)(!important)/);
    const splitStyle = (importantCells ? importantCells[1] : rawStyle).trim().split(/\s+/);
    // Combine styles split in brackets, like `calc(1px + 2px)`
    let temp = [];
    let brackets = 0;
    return [
        splitStyle.reduce((list, item)=>{
            if (item.includes('(') || item.includes(')')) {
                const left = item.split('(').length - 1;
                const right = item.split(')').length - 1;
                brackets += left - right;
            }
            if (brackets >= 0) temp.push(item);
            if (brackets === 0) {
                list.push(temp.join(' '));
                temp = [];
            }
            return list;
        }, []),
        !!importantCells
    ];
}
function $2b438c4697f915e0$var$noSplit(list) {
    list.notSplit = true;
    return list;
}
const $2b438c4697f915e0$var$keyMap = {
    // Inset
    inset: [
        'top',
        'right',
        'bottom',
        'left'
    ],
    insetBlock: [
        'top',
        'bottom'
    ],
    insetBlockStart: [
        'top'
    ],
    insetBlockEnd: [
        'bottom'
    ],
    insetInline: [
        'left',
        'right'
    ],
    insetInlineStart: [
        'left'
    ],
    insetInlineEnd: [
        'right'
    ],
    // Margin
    marginBlock: [
        'marginTop',
        'marginBottom'
    ],
    marginBlockStart: [
        'marginTop'
    ],
    marginBlockEnd: [
        'marginBottom'
    ],
    marginInline: [
        'marginLeft',
        'marginRight'
    ],
    marginInlineStart: [
        'marginLeft'
    ],
    marginInlineEnd: [
        'marginRight'
    ],
    // Padding
    paddingBlock: [
        'paddingTop',
        'paddingBottom'
    ],
    paddingBlockStart: [
        'paddingTop'
    ],
    paddingBlockEnd: [
        'paddingBottom'
    ],
    paddingInline: [
        'paddingLeft',
        'paddingRight'
    ],
    paddingInlineStart: [
        'paddingLeft'
    ],
    paddingInlineEnd: [
        'paddingRight'
    ],
    // Border
    borderBlock: $2b438c4697f915e0$var$noSplit([
        'borderTop',
        'borderBottom'
    ]),
    borderBlockStart: $2b438c4697f915e0$var$noSplit([
        'borderTop'
    ]),
    borderBlockEnd: $2b438c4697f915e0$var$noSplit([
        'borderBottom'
    ]),
    borderInline: $2b438c4697f915e0$var$noSplit([
        'borderLeft',
        'borderRight'
    ]),
    borderInlineStart: $2b438c4697f915e0$var$noSplit([
        'borderLeft'
    ]),
    borderInlineEnd: $2b438c4697f915e0$var$noSplit([
        'borderRight'
    ]),
    // Border width
    borderBlockWidth: [
        'borderTopWidth',
        'borderBottomWidth'
    ],
    borderBlockStartWidth: [
        'borderTopWidth'
    ],
    borderBlockEndWidth: [
        'borderBottomWidth'
    ],
    borderInlineWidth: [
        'borderLeftWidth',
        'borderRightWidth'
    ],
    borderInlineStartWidth: [
        'borderLeftWidth'
    ],
    borderInlineEndWidth: [
        'borderRightWidth'
    ],
    // Border style
    borderBlockStyle: [
        'borderTopStyle',
        'borderBottomStyle'
    ],
    borderBlockStartStyle: [
        'borderTopStyle'
    ],
    borderBlockEndStyle: [
        'borderBottomStyle'
    ],
    borderInlineStyle: [
        'borderLeftStyle',
        'borderRightStyle'
    ],
    borderInlineStartStyle: [
        'borderLeftStyle'
    ],
    borderInlineEndStyle: [
        'borderRightStyle'
    ],
    // Border color
    borderBlockColor: [
        'borderTopColor',
        'borderBottomColor'
    ],
    borderBlockStartColor: [
        'borderTopColor'
    ],
    borderBlockEndColor: [
        'borderBottomColor'
    ],
    borderInlineColor: [
        'borderLeftColor',
        'borderRightColor'
    ],
    borderInlineStartColor: [
        'borderLeftColor'
    ],
    borderInlineEndColor: [
        'borderRightColor'
    ],
    // Border radius
    borderStartStartRadius: [
        'borderTopLeftRadius'
    ],
    borderStartEndRadius: [
        'borderTopRightRadius'
    ],
    borderEndStartRadius: [
        'borderBottomLeftRadius'
    ],
    borderEndEndRadius: [
        'borderBottomRightRadius'
    ]
};
function $2b438c4697f915e0$var$wrapImportantAndSkipCheck(value, important) {
    let parsedValue = value;
    if (important) parsedValue = `${parsedValue} !important`;
    return {
        _skip_check_: true,
        value: parsedValue
    };
}
/**
 * Convert css logical properties to legacy properties.
 * Such as: `margin-block-start` to `margin-top`.
 * Transform list:
 * - inset
 * - margin
 * - padding
 * - border
 */ const $2b438c4697f915e0$var$transform = {
    visit: (cssObj)=>{
        const clone = {};
        Object.keys(cssObj).forEach((key)=>{
            const value = cssObj[key];
            const matchValue = $2b438c4697f915e0$var$keyMap[key];
            if (matchValue && (typeof value === 'number' || typeof value === 'string')) {
                const [values, important] = $2b438c4697f915e0$var$splitValues(value);
                if (matchValue.length && matchValue.notSplit) // not split means always give same value like border
                matchValue.forEach((matchKey)=>{
                    clone[matchKey] = $2b438c4697f915e0$var$wrapImportantAndSkipCheck(value, important);
                });
                else if (matchValue.length === 1) // Handle like `marginBlockStart` => `marginTop`
                clone[matchValue[0]] = $2b438c4697f915e0$var$wrapImportantAndSkipCheck(values[0], important);
                else if (matchValue.length === 2) // Handle like `marginBlock` => `marginTop` & `marginBottom`
                matchValue.forEach((matchKey, index)=>{
                    clone[matchKey] = $2b438c4697f915e0$var$wrapImportantAndSkipCheck(values[index] ?? values[0], important);
                });
                else if (matchValue.length === 4) // Handle like `inset` => `top` & `right` & `bottom` & `left`
                matchValue.forEach((matchKey, index)=>{
                    clone[matchKey] = $2b438c4697f915e0$var$wrapImportantAndSkipCheck(values[index] ?? values[index - 2] ?? values[0], important);
                });
                else clone[key] = value;
            } else clone[key] = value;
        });
        return clone;
    }
};
var $2b438c4697f915e0$export$2e2bcd8739ae039 = $2b438c4697f915e0$var$transform;


/**
 * respect https://github.com/cuth/postcss-pxtorem
 */ // @ts-ignore

const $22c48f39541654d2$var$pxRegex = /url\([^)]+\)|var\([^)]+\)|(\d*\.?\d+)px/g;
function $22c48f39541654d2$var$toFixed(number, precision) {
    const multiplier = Math.pow(10, precision + 1), wholeNumber = Math.floor(number * multiplier);
    return Math.round(wholeNumber / 10) * 10 / multiplier;
}
const $22c48f39541654d2$var$transform = (options = {})=>{
    const { rootValue: rootValue = 16, precision: precision = 5, mediaQuery: mediaQuery = false } = options;
    const pxReplace = (m, $1)=>{
        if (!$1) return m;
        const pixels = parseFloat($1);
        // covenant: pixels <= 1, not transform to rem @zombieJ
        if (pixels <= 1) return m;
        const fixedVal = $22c48f39541654d2$var$toFixed(pixels / rootValue, precision);
        return `${fixedVal}rem`;
    };
    const visit = (cssObj)=>{
        const clone = {
            ...cssObj
        };
        Object.entries(cssObj).forEach(([key, value])=>{
            if (typeof value === 'string' && value.includes('px')) {
                const newValue = value.replace($22c48f39541654d2$var$pxRegex, pxReplace);
                clone[key] = newValue;
            }
            // no unit
            if (!(0, $885f4eee88e48c11$export$2e2bcd8739ae039)[key] && typeof value === 'number' && value !== 0) clone[key] = `${value}px`.replace($22c48f39541654d2$var$pxRegex, pxReplace);
            // Media queries
            const mergedKey = key.trim();
            if (mergedKey.startsWith('@') && mergedKey.includes('px') && mediaQuery) {
                const newKey = key.replace($22c48f39541654d2$var$pxRegex, pxReplace);
                clone[newKey] = clone[key];
                delete clone[key];
            }
        });
        return clone;
    };
    return {
        visit: visit
    };
};
var $22c48f39541654d2$export$2e2bcd8739ae039 = $22c48f39541654d2$var$transform;




const $685d4c9e92bcc5ec$export$73abaea5066f503b = {
    supportModernCSS: ()=>(0, $56bae8a99c3cba6e$export$f51d3b8ac4ac9ed1)() && (0, $56bae8a99c3cba6e$export$64a912f57d5de48e)()
};






var $5E6i4 = parcelRequire("5E6i4");

function $bedf93c14dee83a9$export$8793edee2d425525() {}
const { resetWarned: $bedf93c14dee83a9$var$rcResetWarned } = (0, $f757b9ac02fa080d$export$2e2bcd8739ae039);
let $bedf93c14dee83a9$var$deprecatedWarnList = null;
function $bedf93c14dee83a9$export$60eef1277fe463e4() {
    $bedf93c14dee83a9$var$deprecatedWarnList = null;
    $bedf93c14dee83a9$var$rcResetWarned();
}
let $bedf93c14dee83a9$var$_warning = $bedf93c14dee83a9$export$8793edee2d425525;
var $bedf93c14dee83a9$var$valid, $bedf93c14dee83a9$var$component, $bedf93c14dee83a9$var$message;
const $bedf93c14dee83a9$var$warning = $bedf93c14dee83a9$var$_warning;
const $bedf93c14dee83a9$export$11b88c75b33aa1fd = /*#__PURE__*/ $5E6i4.createContext({});
const $bedf93c14dee83a9$export$e02e8dff7b78de83 = ()=>{
    const noopWarning = ()=>{};
    noopWarning.deprecated = $bedf93c14dee83a9$export$8793edee2d425525;
    return noopWarning;
};
const $bedf93c14dee83a9$export$cf977aa92c751e61 = $bedf93c14dee83a9$export$e02e8dff7b78de83;
var $bedf93c14dee83a9$export$2e2bcd8739ae039 = $bedf93c14dee83a9$var$warning;



var $5E6i4 = parcelRequire("5E6i4");
"use client";
var // ZombieJ: We export single file here since
// ConfigProvider use this which will make loop deps
// to import whole `rc-component/form`
$0b2e649db3b80700$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5E6i4.createContext)(undefined);



var $5E6i4 = parcelRequire("5E6i4");

const $32946ac6dcaa91b3$var$locale = {
    // Options
    items_per_page: '/ page',
    jump_to: 'Go to',
    jump_to_confirm: 'confirm',
    page: 'Page',
    // Pagination
    prev_page: 'Previous Page',
    next_page: 'Next Page',
    prev_5: 'Previous 5 Pages',
    next_5: 'Next 5 Pages',
    prev_3: 'Previous 3 Pages',
    next_3: 'Next 3 Pages',
    page_size: 'Page Size'
};
var $32946ac6dcaa91b3$export$2e2bcd8739ae039 = $32946ac6dcaa91b3$var$locale;


const $6c029498bafbdde6$export$bdd78c3fd9633c1e = {
    yearFormat: 'YYYY',
    dayFormat: 'D',
    cellMeridiemFormat: 'A',
    monthBeforeYear: true
};


const $4201e2e24a1c10b5$var$locale = {
    ...(0, $6c029498bafbdde6$export$bdd78c3fd9633c1e),
    locale: 'en_US',
    today: 'Today',
    now: 'Now',
    backToToday: 'Back to today',
    ok: 'OK',
    clear: 'Clear',
    week: 'Week',
    month: 'Month',
    year: 'Year',
    timeSelect: 'select time',
    dateSelect: 'select date',
    weekSelect: 'Choose a week',
    monthSelect: 'Choose a month',
    yearSelect: 'Choose a year',
    decadeSelect: 'Choose a decade',
    previousMonth: 'Previous month',
    nextMonth: 'Next month',
    previousYear: 'Last year',
    nextYear: 'Next year',
    previousDecade: 'Last decade',
    nextDecade: 'Next decade',
    previousCentury: 'Last century',
    nextCentury: 'Next century'
};
var $4201e2e24a1c10b5$export$2e2bcd8739ae039 = $4201e2e24a1c10b5$var$locale;


const $cb685becafc29ff7$var$locale = {
    placeholder: 'Select time',
    rangePlaceholder: [
        'Start time',
        'End time'
    ]
};
var $cb685becafc29ff7$export$2e2bcd8739ae039 = $cb685becafc29ff7$var$locale;


// Merge into a locale object
const $5dca290c2013aef2$var$locale = {
    lang: {
        placeholder: 'Select date',
        yearPlaceholder: 'Select year',
        quarterPlaceholder: 'Select quarter',
        monthPlaceholder: 'Select month',
        weekPlaceholder: 'Select week',
        rangePlaceholder: [
            'Start date',
            'End date'
        ],
        rangeYearPlaceholder: [
            'Start year',
            'End year'
        ],
        rangeQuarterPlaceholder: [
            'Start quarter',
            'End quarter'
        ],
        rangeMonthPlaceholder: [
            'Start month',
            'End month'
        ],
        rangeWeekPlaceholder: [
            'Start week',
            'End week'
        ],
        ...(0, $4201e2e24a1c10b5$export$2e2bcd8739ae039)
    },
    timePickerLocale: {
        ...(0, $cb685becafc29ff7$export$2e2bcd8739ae039)
    }
};
var // All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json
$5dca290c2013aef2$export$2e2bcd8739ae039 = $5dca290c2013aef2$var$locale;


var $bdc5c83cb9600c71$export$2e2bcd8739ae039 = (0, $5dca290c2013aef2$export$2e2bcd8739ae039);




const $7a40da28675d08a9$var$typeTemplate = '${label} is not a valid ${type}';
const $7a40da28675d08a9$var$localeValues = {
    locale: 'en',
    Pagination: $32946ac6dcaa91b3$export$2e2bcd8739ae039,
    DatePicker: $5dca290c2013aef2$export$2e2bcd8739ae039,
    TimePicker: $cb685becafc29ff7$export$2e2bcd8739ae039,
    Calendar: $bdc5c83cb9600c71$export$2e2bcd8739ae039,
    global: {
        placeholder: 'Please select',
        close: 'Close',
        sortable: 'sortable',
        show: 'Show',
        hide: 'Hide'
    },
    Table: {
        filterTitle: 'Filter menu',
        filterConfirm: 'OK',
        filterReset: 'Reset',
        filterEmptyText: 'No filters',
        filterCheckAll: 'Select all items',
        filterSearchPlaceholder: 'Search in filters',
        emptyText: 'No data',
        selectAll: 'Select current page',
        selectInvert: 'Invert current page',
        selectNone: 'Clear all data',
        selectionAll: 'Select all data',
        sortTitle: 'Sort',
        expand: 'Expand row',
        collapse: 'Collapse row',
        triggerDesc: 'Click to sort descending',
        triggerAsc: 'Click to sort ascending',
        cancelSort: 'Click to cancel sorting'
    },
    Tour: {
        Next: 'Next',
        Previous: 'Previous',
        Finish: 'Finish'
    },
    Modal: {
        okText: 'OK',
        cancelText: 'Cancel',
        justOkText: 'OK'
    },
    Popconfirm: {
        okText: 'OK',
        cancelText: 'Cancel'
    },
    Transfer: {
        titles: [
            '',
            ''
        ],
        searchPlaceholder: 'Search here',
        itemUnit: 'item',
        itemsUnit: 'items',
        remove: 'Remove',
        selectCurrent: 'Select current page',
        removeCurrent: 'Remove current page',
        selectAll: 'Select all data',
        deselectAll: 'Deselect all data',
        removeAll: 'Remove all data',
        selectInvert: 'Invert current page'
    },
    Upload: {
        uploading: 'Uploading...',
        removeFile: 'Remove file',
        uploadError: 'Upload error',
        previewFile: 'Preview file',
        downloadFile: 'Download file'
    },
    Empty: {
        description: 'No data'
    },
    Icon: {
        icon: 'icon'
    },
    Text: {
        edit: 'Edit',
        copy: 'Copy',
        copied: 'Copied',
        expand: 'Expand',
        collapse: 'Collapse'
    },
    Carousel: {
        prevSlide: 'Previous slide',
        nextSlide: 'Next slide'
    },
    Form: {
        optional: '(optional)',
        defaultValidateMessages: {
            default: 'Field validation error for ${label}',
            required: 'Please enter ${label}',
            enum: '${label} must be one of [${enum}]',
            whitespace: '${label} cannot be a blank character',
            date: {
                format: '${label} date format is invalid',
                parse: '${label} cannot be converted to a date',
                invalid: '${label} is an invalid date'
            },
            types: {
                string: $7a40da28675d08a9$var$typeTemplate,
                method: $7a40da28675d08a9$var$typeTemplate,
                array: $7a40da28675d08a9$var$typeTemplate,
                object: $7a40da28675d08a9$var$typeTemplate,
                number: $7a40da28675d08a9$var$typeTemplate,
                date: $7a40da28675d08a9$var$typeTemplate,
                boolean: $7a40da28675d08a9$var$typeTemplate,
                integer: $7a40da28675d08a9$var$typeTemplate,
                float: $7a40da28675d08a9$var$typeTemplate,
                regexp: $7a40da28675d08a9$var$typeTemplate,
                email: $7a40da28675d08a9$var$typeTemplate,
                url: $7a40da28675d08a9$var$typeTemplate,
                hex: $7a40da28675d08a9$var$typeTemplate
            },
            string: {
                len: '${label} must be ${len} characters',
                min: '${label} must be at least ${min} characters',
                max: '${label} must be up to ${max} characters',
                range: '${label} must be between ${min}-${max} characters'
            },
            number: {
                len: '${label} must be equal to ${len}',
                min: '${label} must be minimum ${min}',
                max: '${label} must be maximum ${max}',
                range: '${label} must be between ${min}-${max}'
            },
            array: {
                len: 'Must be ${len} ${label}',
                min: 'At least ${min} ${label}',
                max: 'At most ${max} ${label}',
                range: 'The amount of ${label} must be between ${min}-${max}'
            },
            pattern: {
                mismatch: '${label} does not match the pattern ${pattern}'
            }
        }
    },
    QRCode: {
        expired: 'QR code expired',
        refresh: 'Refresh',
        scanned: 'Scanned'
    },
    ColorPicker: {
        presetEmpty: 'Empty',
        transparent: 'Transparent',
        singleColor: 'Single',
        gradientColor: 'Gradient'
    }
};
var $7a40da28675d08a9$export$2e2bcd8739ae039 = $7a40da28675d08a9$var$localeValues;


let $89984c3eb9021529$var$runtimeLocale = {
    ...(0, $7a40da28675d08a9$export$2e2bcd8739ae039).Modal
};
let $89984c3eb9021529$var$localeList = [];
const $89984c3eb9021529$var$generateLocale = ()=>$89984c3eb9021529$var$localeList.reduce((merged, locale)=>({
            ...merged,
            ...locale
        }), (0, $7a40da28675d08a9$export$2e2bcd8739ae039).Modal);
function $89984c3eb9021529$export$9485ecb9d81a550c(newLocale) {
    if (newLocale) {
        const cloneLocale = {
            ...newLocale
        };
        $89984c3eb9021529$var$localeList.push(cloneLocale);
        $89984c3eb9021529$var$runtimeLocale = $89984c3eb9021529$var$generateLocale();
        return ()=>{
            $89984c3eb9021529$var$localeList = $89984c3eb9021529$var$localeList.filter((locale)=>locale !== cloneLocale);
            $89984c3eb9021529$var$runtimeLocale = $89984c3eb9021529$var$generateLocale();
        };
    }
    $89984c3eb9021529$var$runtimeLocale = {
        ...(0, $7a40da28675d08a9$export$2e2bcd8739ae039).Modal
    };
}
function $89984c3eb9021529$export$1b6004afda18cd51() {
    return $89984c3eb9021529$var$runtimeLocale;
}



var $5E6i4 = parcelRequire("5E6i4");
const $8ffe7a84927cd2b0$var$LocaleContext = /*#__PURE__*/ (0, $5E6i4.createContext)(undefined);
var $8ffe7a84927cd2b0$export$2e2bcd8739ae039 = $8ffe7a84927cd2b0$var$LocaleContext;



var $5E6i4 = parcelRequire("5E6i4");



const $a2f3e1f88973a5e2$var$useLocale = (componentName, defaultLocale)=>{
    const fullLocale = $5E6i4.useContext((0, $8ffe7a84927cd2b0$export$2e2bcd8739ae039));
    const getLocale = $5E6i4.useMemo(()=>{
        const locale = defaultLocale || (0, $7a40da28675d08a9$export$2e2bcd8739ae039)[componentName];
        const localeFromContext = fullLocale?.[componentName] ?? {};
        return {
            ...(0, $addbc2fddcbb77a9$export$f6e2535fb5126e54)(locale) ? locale() : locale,
            ...localeFromContext || {}
        };
    }, [
        componentName,
        defaultLocale,
        fullLocale
    ]);
    const getLocaleCode = $5E6i4.useMemo(()=>{
        const localeCode = fullLocale?.locale;
        // Had use LocaleProvide but didn't set locale
        if (fullLocale?.exist && !localeCode) return (0, $7a40da28675d08a9$export$2e2bcd8739ae039).locale;
        return localeCode;
    }, [
        fullLocale
    ]);
    return [
        getLocale,
        getLocaleCode
    ];
};
var $a2f3e1f88973a5e2$export$2e2bcd8739ae039 = $a2f3e1f88973a5e2$var$useLocale;


"use client";
const $f2b9e4961cc759b1$export$b2f162cd5c15ea3e = 'internalMark';
const $f2b9e4961cc759b1$var$LocaleProvider = (props)=>{
    const { locale: locale = {}, children: children, _ANT_MARK__: _ANT_MARK__ } = props;
    $5E6i4.useEffect(()=>{
        const clearLocale = (0, $89984c3eb9021529$export$9485ecb9d81a550c)(locale?.Modal);
        return clearLocale;
    }, [
        locale
    ]);
    const getMemoizedContextValue = $5E6i4.useMemo(()=>({
            ...locale,
            exist: true
        }), [
        locale
    ]);
    return /*#__PURE__*/ $5E6i4.createElement((0, $8ffe7a84927cd2b0$export$2e2bcd8739ae039).Provider, {
        value: getMemoizedContextValue
    }, children);
};
var $f2b9e4961cc759b1$export$2e2bcd8739ae039 = $f2b9e4961cc759b1$var$LocaleProvider;





// 36 Hex to reduce the size of the file
var $ef60c18a8dedc216$export$2e2bcd8739ae039 = {
    aliceblue: '9ehhb',
    antiquewhite: '9sgk7',
    aqua: '1ekf',
    aquamarine: '4zsno',
    azure: '9eiv3',
    beige: '9lhp8',
    bisque: '9zg04',
    black: '0',
    blanchedalmond: '9zhe5',
    blue: '73',
    blueviolet: '5e31e',
    brown: '6g016',
    burlywood: '8ouiv',
    cadetblue: '3qba8',
    chartreuse: '4zshs',
    chocolate: '87k0u',
    coral: '9yvyo',
    cornflowerblue: '3xael',
    cornsilk: '9zjz0',
    crimson: '8l4xo',
    cyan: '1ekf',
    darkblue: '3v',
    darkcyan: 'rkb',
    darkgoldenrod: '776yz',
    darkgray: '6mbhl',
    darkgreen: 'jr4',
    darkgrey: '6mbhl',
    darkkhaki: '7ehkb',
    darkmagenta: '5f91n',
    darkolivegreen: '3bzfz',
    darkorange: '9yygw',
    darkorchid: '5z6x8',
    darkred: '5f8xs',
    darksalmon: '9441m',
    darkseagreen: '5lwgf',
    darkslateblue: '2th1n',
    darkslategray: '1ugcv',
    darkslategrey: '1ugcv',
    darkturquoise: '14up',
    darkviolet: '5rw7n',
    deeppink: '9yavn',
    deepskyblue: '11xb',
    dimgray: '442g9',
    dimgrey: '442g9',
    dodgerblue: '16xof',
    firebrick: '6y7tu',
    floralwhite: '9zkds',
    forestgreen: '1cisi',
    fuchsia: '9y70f',
    gainsboro: '8m8kc',
    ghostwhite: '9pq0v',
    goldenrod: '8j4f4',
    gold: '9zda8',
    gray: '50i2o',
    green: 'pa8',
    greenyellow: '6senj',
    grey: '50i2o',
    honeydew: '9eiuo',
    hotpink: '9yrp0',
    indianred: '80gnw',
    indigo: '2xcoy',
    ivory: '9zldc',
    khaki: '9edu4',
    lavenderblush: '9ziet',
    lavender: '90c8q',
    lawngreen: '4vk74',
    lemonchiffon: '9zkct',
    lightblue: '6s73a',
    lightcoral: '9dtog',
    lightcyan: '8s1rz',
    lightgoldenrodyellow: '9sjiq',
    lightgray: '89jo3',
    lightgreen: '5nkwg',
    lightgrey: '89jo3',
    lightpink: '9z6wx',
    lightsalmon: '9z2ii',
    lightseagreen: '19xgq',
    lightskyblue: '5arju',
    lightslategray: '4nwk9',
    lightslategrey: '4nwk9',
    lightsteelblue: '6wau6',
    lightyellow: '9zlcw',
    lime: '1edc',
    limegreen: '1zcxe',
    linen: '9shk6',
    magenta: '9y70f',
    maroon: '4zsow',
    mediumaquamarine: '40eju',
    mediumblue: '5p',
    mediumorchid: '79qkz',
    mediumpurple: '5r3rv',
    mediumseagreen: '2d9ip',
    mediumslateblue: '4tcku',
    mediumspringgreen: '1di2',
    mediumturquoise: '2uabw',
    mediumvioletred: '7rn9h',
    midnightblue: 'z980',
    mintcream: '9ljp6',
    mistyrose: '9zg0x',
    moccasin: '9zfzp',
    navajowhite: '9zest',
    navy: '3k',
    oldlace: '9wq92',
    olive: '50hz4',
    olivedrab: '472ub',
    orange: '9z3eo',
    orangered: '9ykg0',
    orchid: '8iu3a',
    palegoldenrod: '9bl4a',
    palegreen: '5yw0o',
    paleturquoise: '6v4ku',
    palevioletred: '8k8lv',
    papayawhip: '9zi6t',
    peachpuff: '9ze0p',
    peru: '80oqn',
    pink: '9z8wb',
    plum: '8nba5',
    powderblue: '6wgdi',
    purple: '4zssg',
    rebeccapurple: '3zk49',
    red: '9y6tc',
    rosybrown: '7cv4f',
    royalblue: '2jvtt',
    saddlebrown: '5fmkz',
    salmon: '9rvci',
    sandybrown: '9jn1c',
    seagreen: '1tdnb',
    seashell: '9zje6',
    sienna: '6973h',
    silver: '7ir40',
    skyblue: '5arjf',
    slateblue: '45e4t',
    slategray: '4e100',
    slategrey: '4e100',
    snow: '9zke2',
    springgreen: '1egv',
    steelblue: '2r1kk',
    tan: '87yx8',
    teal: 'pds',
    thistle: '8ggk8',
    tomato: '9yqfb',
    turquoise: '2j4r4',
    violet: '9b10u',
    wheat: '9ld4j',
    white: '9zldr',
    whitesmoke: '9lhpx',
    yellow: '9zl6o',
    yellowgreen: '61fzm'
};


const $1b0a692e36565107$var$round = Math.round;
/**
 * Support format, alpha unit will check the % mark:
 * - rgba(102, 204, 255, .5)      -> [102, 204, 255, 0.5]
 * - rgb(102 204 255 / .5)        -> [102, 204, 255, 0.5]
 * - rgb(100%, 50%, 0% / 50%)     -> [255, 128, 0, 0.5]
 * - hsl(270, 60, 40, .5)         -> [270, 60, 40, 0.5]
 * - hsl(270deg 60% 40% / 50%)   -> [270, 60, 40, 0.5]
 *
 * When `base` is provided, the percentage value will be divided by `base`.
 */ function $1b0a692e36565107$var$splitColorStr(str, parseNum) {
    const match = str// Remove str before `(`
    .replace(/^[^(]*\((.*)/, '$1')// Remove str after `)`
    .replace(/\).*/, '').match(/\d*\.?\d+%?/g) || [];
    const numList = match.map((item)=>parseFloat(item));
    for(let i = 0; i < 3; i += 1)numList[i] = parseNum(numList[i] || 0, match[i] || '', i);
    // For alpha. 50% should be 0.5
    if (match[3]) numList[3] = match[3].includes('%') ? numList[3] / 100 : numList[3];
    else // By default, alpha is 1
    numList[3] = 1;
    return numList;
}
const $1b0a692e36565107$var$parseHSVorHSL = (num, _, index)=>index === 0 ? num : num / 100;
/** round and limit number to integer between 0-255 */ function $1b0a692e36565107$var$limitRange(value, max) {
    const mergedMax = max || 255;
    if (value > mergedMax) return mergedMax;
    if (value < 0) return 0;
    return value;
}
class $1b0a692e36565107$export$2c4f38d6c0ecc25a {
    /**
   * All FastColor objects are valid. So isValid is always true. This property is kept to be compatible with TinyColor.
   */ isValid = true;
    /**
   * Red, R in RGB
   */ r = 0;
    /**
   * Green, G in RGB
   */ g = 0;
    /**
   * Blue, B in RGB
   */ b = 0;
    /**
   * Alpha/Opacity, A in RGBA/HSLA
   */ a = 1;
    // HSV privates
    _h;
    _hsl_s;
    _hsv_s;
    _l;
    _v;
    // intermediate variables to calculate HSL/HSV
    _max;
    _min;
    _brightness;
    constructor(input){
        /**
     * Always check 3 char in the object to determine the format.
     * We not use function in check to save bundle size.
     * e.g. 'rgb' -> { r: 0, g: 0, b: 0 }.
     */ function matchFormat(str) {
            return str[0] in input && str[1] in input && str[2] in input;
        }
        if (!input) ;
        else if (typeof input === 'string') {
            const trimStr = input.trim();
            function matchPrefix(prefix) {
                return trimStr.startsWith(prefix);
            }
            if (/^#?[A-F\d]{3,8}$/i.test(trimStr)) this.fromHexString(trimStr);
            else if (matchPrefix('rgb')) this.fromRgbString(trimStr);
            else if (matchPrefix('hsl')) this.fromHslString(trimStr);
            else if (matchPrefix('hsv') || matchPrefix('hsb')) this.fromHsvString(trimStr);
            else {
                // From preset color
                const presetColor = (0, $ef60c18a8dedc216$export$2e2bcd8739ae039)[trimStr.toLowerCase()];
                if (presetColor) this.fromHexString(// Convert 36 hex to 16 hex
                parseInt(presetColor, 36).toString(16).padStart(6, '0'));
            }
        } else if (input instanceof $1b0a692e36565107$export$2c4f38d6c0ecc25a) {
            this.r = input.r;
            this.g = input.g;
            this.b = input.b;
            this.a = input.a;
            this._h = input._h;
            this._hsl_s = input._hsl_s;
            this._hsv_s = input._hsv_s;
            this._l = input._l;
            this._v = input._v;
        } else if (matchFormat('rgb')) {
            this.r = $1b0a692e36565107$var$limitRange(input.r);
            this.g = $1b0a692e36565107$var$limitRange(input.g);
            this.b = $1b0a692e36565107$var$limitRange(input.b);
            this.a = typeof input.a === 'number' ? $1b0a692e36565107$var$limitRange(input.a, 1) : 1;
        } else if (matchFormat('hsl')) this.fromHsl(input);
        else if (matchFormat('hsv')) this.fromHsv(input);
        else throw new Error('@ant-design/fast-color: unsupported input ' + JSON.stringify(input));
    }
    // ======================= Setter =======================
    setR(value) {
        return this._sc('r', value);
    }
    setG(value) {
        return this._sc('g', value);
    }
    setB(value) {
        return this._sc('b', value);
    }
    setA(value) {
        return this._sc('a', value, 1);
    }
    setHue(value) {
        const hsv = this.toHsv();
        hsv.h = value;
        return this._c(hsv);
    }
    // ======================= Getter =======================
    /**
   * Returns the perceived luminance of a color, from 0-1.
   * @see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
   */ getLuminance() {
        function adjustGamma(raw) {
            const val = raw / 255;
            return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
        }
        const R = adjustGamma(this.r);
        const G = adjustGamma(this.g);
        const B = adjustGamma(this.b);
        return 0.2126 * R + 0.7152 * G + 0.0722 * B;
    }
    getHue() {
        if (typeof this._h === 'undefined') {
            const delta = this.getMax() - this.getMin();
            if (delta === 0) this._h = 0;
            else this._h = $1b0a692e36565107$var$round(60 * (this.r === this.getMax() ? (this.g - this.b) / delta + (this.g < this.b ? 6 : 0) : this.g === this.getMax() ? (this.b - this.r) / delta + 2 : (this.r - this.g) / delta + 4));
        }
        return this._h;
    }
    /**
   * @deprecated should use getHSVSaturation or getHSLSaturation instead
   */ getSaturation() {
        return this.getHSVSaturation();
    }
    getHSVSaturation() {
        if (typeof this._hsv_s === 'undefined') {
            const delta = this.getMax() - this.getMin();
            if (delta === 0) this._hsv_s = 0;
            else this._hsv_s = delta / this.getMax();
        }
        return this._hsv_s;
    }
    getHSLSaturation() {
        if (typeof this._hsl_s === 'undefined') {
            const delta = this.getMax() - this.getMin();
            if (delta === 0) this._hsl_s = 0;
            else {
                const l = this.getLightness();
                this._hsl_s = delta / 255 / (1 - Math.abs(2 * l - 1));
            }
        }
        return this._hsl_s;
    }
    getLightness() {
        if (typeof this._l === 'undefined') this._l = (this.getMax() + this.getMin()) / 510;
        return this._l;
    }
    getValue() {
        if (typeof this._v === 'undefined') this._v = this.getMax() / 255;
        return this._v;
    }
    /**
   * Returns the perceived brightness of the color, from 0-255.
   * Note: this is not the b of HSB
   * @see http://www.w3.org/TR/AERT#color-contrast
   */ getBrightness() {
        if (typeof this._brightness === 'undefined') this._brightness = (this.r * 299 + this.g * 587 + this.b * 114) / 1000;
        return this._brightness;
    }
    // ======================== Func ========================
    darken(amount = 10) {
        const h = this.getHue();
        const s = this.getSaturation();
        let l = this.getLightness() - amount / 100;
        if (l < 0) l = 0;
        return this._c({
            h: h,
            s: s,
            l: l,
            a: this.a
        });
    }
    lighten(amount = 10) {
        const h = this.getHue();
        const s = this.getSaturation();
        let l = this.getLightness() + amount / 100;
        if (l > 1) l = 1;
        return this._c({
            h: h,
            s: s,
            l: l,
            a: this.a
        });
    }
    /**
   * Mix the current color a given amount with another color, from 0 to 100.
   * 0 means no mixing (return current color).
   */ mix(input, amount = 50) {
        const color = this._c(input);
        const p = amount / 100;
        const calc = (key)=>(color[key] - this[key]) * p + this[key];
        const rgba = {
            r: $1b0a692e36565107$var$round(calc('r')),
            g: $1b0a692e36565107$var$round(calc('g')),
            b: $1b0a692e36565107$var$round(calc('b')),
            a: $1b0a692e36565107$var$round(calc('a') * 100) / 100
        };
        return this._c(rgba);
    }
    /**
   * Mix the color with pure white, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return white.
   */ tint(amount = 10) {
        return this.mix({
            r: 255,
            g: 255,
            b: 255,
            a: 1
        }, amount);
    }
    /**
   * Mix the color with pure black, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return black.
   */ shade(amount = 10) {
        return this.mix({
            r: 0,
            g: 0,
            b: 0,
            a: 1
        }, amount);
    }
    onBackground(background) {
        const bg = this._c(background);
        const alpha = this.a + bg.a * (1 - this.a);
        const calc = (key)=>{
            return $1b0a692e36565107$var$round((this[key] * this.a + bg[key] * bg.a * (1 - this.a)) / alpha);
        };
        return this._c({
            r: calc('r'),
            g: calc('g'),
            b: calc('b'),
            a: alpha
        });
    }
    // ======================= Status =======================
    isDark() {
        return this.getBrightness() < 128;
    }
    isLight() {
        return this.getBrightness() >= 128;
    }
    // ======================== MISC ========================
    equals(other) {
        return this.r === other.r && this.g === other.g && this.b === other.b && this.a === other.a;
    }
    clone() {
        return this._c(this);
    }
    // ======================= Format =======================
    toHexString() {
        let hex = '#';
        const rHex = (this.r || 0).toString(16);
        hex += rHex.length === 2 ? rHex : '0' + rHex;
        const gHex = (this.g || 0).toString(16);
        hex += gHex.length === 2 ? gHex : '0' + gHex;
        const bHex = (this.b || 0).toString(16);
        hex += bHex.length === 2 ? bHex : '0' + bHex;
        if (typeof this.a === 'number' && this.a >= 0 && this.a < 1) {
            const aHex = $1b0a692e36565107$var$round(this.a * 255).toString(16);
            hex += aHex.length === 2 ? aHex : '0' + aHex;
        }
        return hex;
    }
    /** CSS support color pattern */ toHsl() {
        return {
            h: this.getHue(),
            s: this.getHSLSaturation(),
            l: this.getLightness(),
            a: this.a
        };
    }
    /** CSS support color pattern */ toHslString() {
        const h = this.getHue();
        const s = $1b0a692e36565107$var$round(this.getHSLSaturation() * 100);
        const l = $1b0a692e36565107$var$round(this.getLightness() * 100);
        return this.a !== 1 ? `hsla(${h},${s}%,${l}%,${this.a})` : `hsl(${h},${s}%,${l}%)`;
    }
    /** Same as toHsb */ toHsv() {
        return {
            h: this.getHue(),
            s: this.getHSVSaturation(),
            v: this.getValue(),
            a: this.a
        };
    }
    toRgb() {
        return {
            r: this.r,
            g: this.g,
            b: this.b,
            a: this.a
        };
    }
    toRgbString() {
        return this.a !== 1 ? `rgba(${this.r},${this.g},${this.b},${this.a})` : `rgb(${this.r},${this.g},${this.b})`;
    }
    toString() {
        return this.toRgbString();
    }
    // ====================== Privates ======================
    /** Return a new FastColor object with one channel changed */ _sc(rgb, value, max) {
        const clone = this.clone();
        clone[rgb] = $1b0a692e36565107$var$limitRange(value, max);
        return clone;
    }
    _c(input) {
        return new this.constructor(input);
    }
    getMax() {
        if (typeof this._max === 'undefined') this._max = Math.max(this.r, this.g, this.b);
        return this._max;
    }
    getMin() {
        if (typeof this._min === 'undefined') this._min = Math.min(this.r, this.g, this.b);
        return this._min;
    }
    fromHexString(trimStr) {
        const withoutPrefix = trimStr.replace('#', '');
        function connectNum(index1, index2) {
            return parseInt(withoutPrefix[index1] + withoutPrefix[index2 || index1], 16);
        }
        if (withoutPrefix.length < 6) {
            // #rgb or #rgba
            this.r = connectNum(0);
            this.g = connectNum(1);
            this.b = connectNum(2);
            this.a = withoutPrefix[3] ? connectNum(3) / 255 : 1;
        } else {
            // #rrggbb or #rrggbbaa
            this.r = connectNum(0, 1);
            this.g = connectNum(2, 3);
            this.b = connectNum(4, 5);
            this.a = withoutPrefix[6] ? connectNum(6, 7) / 255 : 1;
        }
    }
    fromHsl({ h: _h, s: s, l: l, a: a }) {
        const h = (_h % 360 + 360) % 360;
        this._h = h;
        this._hsl_s = s;
        this._l = l;
        this.a = typeof a === 'number' ? a : 1;
        if (s <= 0) {
            const rgb = $1b0a692e36565107$var$round(l * 255);
            this.r = rgb;
            this.g = rgb;
            this.b = rgb;
            return;
        }
        let r = 0, g = 0, b = 0;
        const huePrime = h / 60;
        const chroma = (1 - Math.abs(2 * l - 1)) * s;
        const secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
        if (huePrime >= 0 && huePrime < 1) {
            r = chroma;
            g = secondComponent;
        } else if (huePrime >= 1 && huePrime < 2) {
            r = secondComponent;
            g = chroma;
        } else if (huePrime >= 2 && huePrime < 3) {
            g = chroma;
            b = secondComponent;
        } else if (huePrime >= 3 && huePrime < 4) {
            g = secondComponent;
            b = chroma;
        } else if (huePrime >= 4 && huePrime < 5) {
            r = secondComponent;
            b = chroma;
        } else if (huePrime >= 5 && huePrime < 6) {
            r = chroma;
            b = secondComponent;
        }
        const lightnessModification = l - chroma / 2;
        this.r = $1b0a692e36565107$var$round((r + lightnessModification) * 255);
        this.g = $1b0a692e36565107$var$round((g + lightnessModification) * 255);
        this.b = $1b0a692e36565107$var$round((b + lightnessModification) * 255);
    }
    fromHsv({ h: _h, s: s, v: v, a: a }) {
        const h = (_h % 360 + 360) % 360;
        this._h = h;
        this._hsv_s = s;
        this._v = v;
        this.a = typeof a === 'number' ? a : 1;
        const vv = $1b0a692e36565107$var$round(v * 255);
        this.r = vv;
        this.g = vv;
        this.b = vv;
        if (s <= 0) return;
        const hh = h / 60;
        const i = Math.floor(hh);
        const ff = hh - i;
        const p = $1b0a692e36565107$var$round(v * (1.0 - s) * 255);
        const q = $1b0a692e36565107$var$round(v * (1.0 - s * ff) * 255);
        const t = $1b0a692e36565107$var$round(v * (1.0 - s * (1.0 - ff)) * 255);
        switch(i){
            case 0:
                this.g = t;
                this.b = p;
                break;
            case 1:
                this.r = q;
                this.b = p;
                break;
            case 2:
                this.r = p;
                this.b = t;
                break;
            case 3:
                this.r = p;
                this.g = q;
                break;
            case 4:
                this.r = t;
                this.g = p;
                break;
            case 5:
            default:
                this.g = p;
                this.b = q;
                break;
        }
    }
    fromHsvString(trimStr) {
        const cells = $1b0a692e36565107$var$splitColorStr(trimStr, $1b0a692e36565107$var$parseHSVorHSL);
        this.fromHsv({
            h: cells[0],
            s: cells[1],
            v: cells[2],
            a: cells[3]
        });
    }
    fromHslString(trimStr) {
        const cells = $1b0a692e36565107$var$splitColorStr(trimStr, $1b0a692e36565107$var$parseHSVorHSL);
        this.fromHsl({
            h: cells[0],
            s: cells[1],
            l: cells[2],
            a: cells[3]
        });
    }
    fromRgbString(trimStr) {
        const cells = $1b0a692e36565107$var$splitColorStr(trimStr, (num, txt)=>// Convert percentage to number. e.g. 50% -> 128
            txt.includes('%') ? $1b0a692e36565107$var$round(num / 100 * 255) : num);
        this.r = cells[0];
        this.g = cells[1];
        this.b = cells[2];
        this.a = cells[3];
    }
}






const $0452e534096bcd2f$var$hueStep = 2; // 色相阶梯
const $0452e534096bcd2f$var$saturationStep = 0.16; // 饱和度阶梯，浅色部分
const $0452e534096bcd2f$var$saturationStep2 = 0.05; // 饱和度阶梯，深色部分
const $0452e534096bcd2f$var$brightnessStep1 = 0.05; // 亮度阶梯，浅色部分
const $0452e534096bcd2f$var$brightnessStep2 = 0.15; // 亮度阶梯，深色部分
const $0452e534096bcd2f$var$lightColorCount = 5; // 浅色数量，主色上
const $0452e534096bcd2f$var$darkColorCount = 4; // 深色数量，主色下
// 暗色主题颜色映射关系表
const $0452e534096bcd2f$var$darkColorMap = [
    {
        index: 7,
        amount: 15
    },
    {
        index: 6,
        amount: 25
    },
    {
        index: 5,
        amount: 30
    },
    {
        index: 5,
        amount: 45
    },
    {
        index: 5,
        amount: 65
    },
    {
        index: 5,
        amount: 85
    },
    {
        index: 4,
        amount: 90
    },
    {
        index: 3,
        amount: 95
    },
    {
        index: 2,
        amount: 97
    },
    {
        index: 1,
        amount: 98
    }
];
function $0452e534096bcd2f$var$getHue(hsv, i, light) {
    let hue;
    // 根据色相不同，色相转向不同
    if (Math.round(hsv.h) >= 60 && Math.round(hsv.h) <= 240) hue = light ? Math.round(hsv.h) - $0452e534096bcd2f$var$hueStep * i : Math.round(hsv.h) + $0452e534096bcd2f$var$hueStep * i;
    else hue = light ? Math.round(hsv.h) + $0452e534096bcd2f$var$hueStep * i : Math.round(hsv.h) - $0452e534096bcd2f$var$hueStep * i;
    if (hue < 0) hue += 360;
    else if (hue >= 360) hue -= 360;
    return hue;
}
function $0452e534096bcd2f$var$getSaturation(hsv, i, light) {
    // grey color don't change saturation
    if (hsv.h === 0 && hsv.s === 0) return hsv.s;
    let saturation;
    if (light) saturation = hsv.s - $0452e534096bcd2f$var$saturationStep * i;
    else if (i === $0452e534096bcd2f$var$darkColorCount) saturation = hsv.s + $0452e534096bcd2f$var$saturationStep;
    else saturation = hsv.s + $0452e534096bcd2f$var$saturationStep2 * i;
    // 边界值修正
    if (saturation > 1) saturation = 1;
    // 第一格的 s 限制在 0.06-0.1 之间
    if (light && i === $0452e534096bcd2f$var$lightColorCount && saturation > 0.1) saturation = 0.1;
    if (saturation < 0.06) saturation = 0.06;
    return Math.round(saturation * 100) / 100;
}
function $0452e534096bcd2f$var$getValue(hsv, i, light) {
    let value;
    if (light) value = hsv.v + $0452e534096bcd2f$var$brightnessStep1 * i;
    else value = hsv.v - $0452e534096bcd2f$var$brightnessStep2 * i;
    // Clamp value between 0 and 1
    value = Math.max(0, Math.min(1, value));
    return Math.round(value * 100) / 100;
}
function $0452e534096bcd2f$export$2e2bcd8739ae039(color, opts = {}) {
    const patterns = [];
    const pColor = new (0, $1b0a692e36565107$export$2c4f38d6c0ecc25a)(color);
    const hsv = pColor.toHsv();
    for(let i = $0452e534096bcd2f$var$lightColorCount; i > 0; i -= 1){
        const c = new (0, $1b0a692e36565107$export$2c4f38d6c0ecc25a)({
            h: $0452e534096bcd2f$var$getHue(hsv, i, true),
            s: $0452e534096bcd2f$var$getSaturation(hsv, i, true),
            v: $0452e534096bcd2f$var$getValue(hsv, i, true)
        });
        patterns.push(c);
    }
    patterns.push(pColor);
    for(let i = 1; i <= $0452e534096bcd2f$var$darkColorCount; i += 1){
        const c = new (0, $1b0a692e36565107$export$2c4f38d6c0ecc25a)({
            h: $0452e534096bcd2f$var$getHue(hsv, i),
            s: $0452e534096bcd2f$var$getSaturation(hsv, i),
            v: $0452e534096bcd2f$var$getValue(hsv, i)
        });
        patterns.push(c);
    }
    // dark theme patterns
    if (opts.theme === 'dark') return $0452e534096bcd2f$var$darkColorMap.map(({ index: index, amount: amount })=>new (0, $1b0a692e36565107$export$2c4f38d6c0ecc25a)(opts.backgroundColor || '#141414').mix(patterns[index], amount).toHexString());
    return patterns.map((c)=>c.toHexString());
}


// Generated by script. Do NOT modify!
const $37058c64b679ada5$export$3968a3afc810b5f5 = {
    "red": "#F5222D",
    "volcano": "#FA541C",
    "orange": "#FA8C16",
    "gold": "#FAAD14",
    "yellow": "#FADB14",
    "lime": "#A0D911",
    "green": "#52C41A",
    "cyan": "#13C2C2",
    "blue": "#1677FF",
    "geekblue": "#2F54EB",
    "purple": "#722ED1",
    "magenta": "#EB2F96",
    "grey": "#666666"
};
const $37058c64b679ada5$export$a90204d1394caf30 = [
    "#fff1f0",
    "#ffccc7",
    "#ffa39e",
    "#ff7875",
    "#ff4d4f",
    "#f5222d",
    "#cf1322",
    "#a8071a",
    "#820014",
    "#5c0011"
];
$37058c64b679ada5$export$a90204d1394caf30.primary = $37058c64b679ada5$export$a90204d1394caf30[5];
const $37058c64b679ada5$export$e63a1643b2f79b16 = [
    "#fff2e8",
    "#ffd8bf",
    "#ffbb96",
    "#ff9c6e",
    "#ff7a45",
    "#fa541c",
    "#d4380d",
    "#ad2102",
    "#871400",
    "#610b00"
];
$37058c64b679ada5$export$e63a1643b2f79b16.primary = $37058c64b679ada5$export$e63a1643b2f79b16[5];
const $37058c64b679ada5$export$ad766f34ace1cafd = [
    "#fff7e6",
    "#ffe7ba",
    "#ffd591",
    "#ffc069",
    "#ffa940",
    "#fa8c16",
    "#d46b08",
    "#ad4e00",
    "#873800",
    "#612500"
];
$37058c64b679ada5$export$ad766f34ace1cafd.primary = $37058c64b679ada5$export$ad766f34ace1cafd[5];
const $37058c64b679ada5$export$c24201f7fe3571d8 = [
    "#fffbe6",
    "#fff1b8",
    "#ffe58f",
    "#ffd666",
    "#ffc53d",
    "#faad14",
    "#d48806",
    "#ad6800",
    "#874d00",
    "#613400"
];
$37058c64b679ada5$export$c24201f7fe3571d8.primary = $37058c64b679ada5$export$c24201f7fe3571d8[5];
const $37058c64b679ada5$export$594c5a8758200c32 = [
    "#feffe6",
    "#ffffb8",
    "#fffb8f",
    "#fff566",
    "#ffec3d",
    "#fadb14",
    "#d4b106",
    "#ad8b00",
    "#876800",
    "#614700"
];
$37058c64b679ada5$export$594c5a8758200c32.primary = $37058c64b679ada5$export$594c5a8758200c32[5];
const $37058c64b679ada5$export$221d31baf2636aad = [
    "#fcffe6",
    "#f4ffb8",
    "#eaff8f",
    "#d3f261",
    "#bae637",
    "#a0d911",
    "#7cb305",
    "#5b8c00",
    "#3f6600",
    "#254000"
];
$37058c64b679ada5$export$221d31baf2636aad.primary = $37058c64b679ada5$export$221d31baf2636aad[5];
const $37058c64b679ada5$export$955a2ebd2fb142ae = [
    "#f6ffed",
    "#d9f7be",
    "#b7eb8f",
    "#95de64",
    "#73d13d",
    "#52c41a",
    "#389e0d",
    "#237804",
    "#135200",
    "#092b00"
];
$37058c64b679ada5$export$955a2ebd2fb142ae.primary = $37058c64b679ada5$export$955a2ebd2fb142ae[5];
const $37058c64b679ada5$export$7474046f446842ee = [
    "#e6fffb",
    "#b5f5ec",
    "#87e8de",
    "#5cdbd3",
    "#36cfc9",
    "#13c2c2",
    "#08979c",
    "#006d75",
    "#00474f",
    "#002329"
];
$37058c64b679ada5$export$7474046f446842ee.primary = $37058c64b679ada5$export$7474046f446842ee[5];
const $37058c64b679ada5$export$2aa0182783e7e9de = [
    "#e6f4ff",
    "#bae0ff",
    "#91caff",
    "#69b1ff",
    "#4096ff",
    "#1677ff",
    "#0958d9",
    "#003eb3",
    "#002c8c",
    "#001d66"
];
$37058c64b679ada5$export$2aa0182783e7e9de.primary = $37058c64b679ada5$export$2aa0182783e7e9de[5];
const $37058c64b679ada5$export$4138d3aeddcbf415 = [
    "#f0f5ff",
    "#d6e4ff",
    "#adc6ff",
    "#85a5ff",
    "#597ef7",
    "#2f54eb",
    "#1d39c4",
    "#10239e",
    "#061178",
    "#030852"
];
$37058c64b679ada5$export$4138d3aeddcbf415.primary = $37058c64b679ada5$export$4138d3aeddcbf415[5];
const $37058c64b679ada5$export$e13cce2a2d16a9d4 = [
    "#f9f0ff",
    "#efdbff",
    "#d3adf7",
    "#b37feb",
    "#9254de",
    "#722ed1",
    "#531dab",
    "#391085",
    "#22075e",
    "#120338"
];
$37058c64b679ada5$export$e13cce2a2d16a9d4.primary = $37058c64b679ada5$export$e13cce2a2d16a9d4[5];
const $37058c64b679ada5$export$2a9ca2e383622e18 = [
    "#fff0f6",
    "#ffd6e7",
    "#ffadd2",
    "#ff85c0",
    "#f759ab",
    "#eb2f96",
    "#c41d7f",
    "#9e1068",
    "#780650",
    "#520339"
];
$37058c64b679ada5$export$2a9ca2e383622e18.primary = $37058c64b679ada5$export$2a9ca2e383622e18[5];
const $37058c64b679ada5$export$e4c89085febbc618 = [
    "#a6a6a6",
    "#999999",
    "#8c8c8c",
    "#808080",
    "#737373",
    "#666666",
    "#404040",
    "#1a1a1a",
    "#000000",
    "#000000"
];
$37058c64b679ada5$export$e4c89085febbc618.primary = $37058c64b679ada5$export$e4c89085febbc618[5];
const $37058c64b679ada5$export$3e2c219d3ab79d01 = $37058c64b679ada5$export$e4c89085febbc618;
const $37058c64b679ada5$export$36ad6df0f83f284d = {
    red: $37058c64b679ada5$export$a90204d1394caf30,
    volcano: $37058c64b679ada5$export$e63a1643b2f79b16,
    orange: $37058c64b679ada5$export$ad766f34ace1cafd,
    gold: $37058c64b679ada5$export$c24201f7fe3571d8,
    yellow: $37058c64b679ada5$export$594c5a8758200c32,
    lime: $37058c64b679ada5$export$221d31baf2636aad,
    green: $37058c64b679ada5$export$955a2ebd2fb142ae,
    cyan: $37058c64b679ada5$export$7474046f446842ee,
    blue: $37058c64b679ada5$export$2aa0182783e7e9de,
    geekblue: $37058c64b679ada5$export$4138d3aeddcbf415,
    purple: $37058c64b679ada5$export$e13cce2a2d16a9d4,
    magenta: $37058c64b679ada5$export$2a9ca2e383622e18,
    grey: $37058c64b679ada5$export$e4c89085febbc618
};
const $37058c64b679ada5$export$e984d34fc144caa1 = [
    "#2a1215",
    "#431418",
    "#58181c",
    "#791a1f",
    "#a61d24",
    "#d32029",
    "#e84749",
    "#f37370",
    "#f89f9a",
    "#fac8c3"
];
$37058c64b679ada5$export$e984d34fc144caa1.primary = $37058c64b679ada5$export$e984d34fc144caa1[5];
const $37058c64b679ada5$export$360e10f78e17a865 = [
    "#2b1611",
    "#441d12",
    "#592716",
    "#7c3118",
    "#aa3e19",
    "#d84a1b",
    "#e87040",
    "#f3956a",
    "#f8b692",
    "#fad4bc"
];
$37058c64b679ada5$export$360e10f78e17a865.primary = $37058c64b679ada5$export$360e10f78e17a865[5];
const $37058c64b679ada5$export$d5a12c698b31fa45 = [
    "#2b1d11",
    "#442a11",
    "#593815",
    "#7c4a15",
    "#aa6215",
    "#d87a16",
    "#e89a3c",
    "#f3b765",
    "#f8cf8d",
    "#fae3b7"
];
$37058c64b679ada5$export$d5a12c698b31fa45.primary = $37058c64b679ada5$export$d5a12c698b31fa45[5];
const $37058c64b679ada5$export$2330427fb6a6af6f = [
    "#2b2111",
    "#443111",
    "#594214",
    "#7c5914",
    "#aa7714",
    "#d89614",
    "#e8b339",
    "#f3cc62",
    "#f8df8b",
    "#faedb5"
];
$37058c64b679ada5$export$2330427fb6a6af6f.primary = $37058c64b679ada5$export$2330427fb6a6af6f[5];
const $37058c64b679ada5$export$67d203119f0ecec = [
    "#2b2611",
    "#443b11",
    "#595014",
    "#7c6e14",
    "#aa9514",
    "#d8bd14",
    "#e8d639",
    "#f3ea62",
    "#f8f48b",
    "#fafab5"
];
$37058c64b679ada5$export$67d203119f0ecec.primary = $37058c64b679ada5$export$67d203119f0ecec[5];
const $37058c64b679ada5$export$51ed2a10d86576ed = [
    "#1f2611",
    "#2e3c10",
    "#3e4f13",
    "#536d13",
    "#6f9412",
    "#8bbb11",
    "#a9d134",
    "#c9e75d",
    "#e4f88b",
    "#f0fab5"
];
$37058c64b679ada5$export$51ed2a10d86576ed.primary = $37058c64b679ada5$export$51ed2a10d86576ed[5];
const $37058c64b679ada5$export$76a3d804058f9b5f = [
    "#162312",
    "#1d3712",
    "#274916",
    "#306317",
    "#3c8618",
    "#49aa19",
    "#6abe39",
    "#8fd460",
    "#b2e58b",
    "#d5f2bb"
];
$37058c64b679ada5$export$76a3d804058f9b5f.primary = $37058c64b679ada5$export$76a3d804058f9b5f[5];
const $37058c64b679ada5$export$dee6c7c6683c0d88 = [
    "#112123",
    "#113536",
    "#144848",
    "#146262",
    "#138585",
    "#13a8a8",
    "#33bcb7",
    "#58d1c9",
    "#84e2d8",
    "#b2f1e8"
];
$37058c64b679ada5$export$dee6c7c6683c0d88.primary = $37058c64b679ada5$export$dee6c7c6683c0d88[5];
const $37058c64b679ada5$export$10e0fd027e632624 = [
    "#111a2c",
    "#112545",
    "#15325b",
    "#15417e",
    "#1554ad",
    "#1668dc",
    "#3c89e8",
    "#65a9f3",
    "#8dc5f8",
    "#b7dcfa"
];
$37058c64b679ada5$export$10e0fd027e632624.primary = $37058c64b679ada5$export$10e0fd027e632624[5];
const $37058c64b679ada5$export$abdd57ab473bba66 = [
    "#131629",
    "#161d40",
    "#1c2755",
    "#203175",
    "#263ea0",
    "#2b4acb",
    "#5273e0",
    "#7f9ef3",
    "#a8c1f8",
    "#d2e0fa"
];
$37058c64b679ada5$export$abdd57ab473bba66.primary = $37058c64b679ada5$export$abdd57ab473bba66[5];
const $37058c64b679ada5$export$7a65e68792738764 = [
    "#1a1325",
    "#24163a",
    "#301c4d",
    "#3e2069",
    "#51258f",
    "#642ab5",
    "#854eca",
    "#ab7ae0",
    "#cda8f0",
    "#ebd7fa"
];
$37058c64b679ada5$export$7a65e68792738764.primary = $37058c64b679ada5$export$7a65e68792738764[5];
const $37058c64b679ada5$export$d260a9321db4ab86 = [
    "#291321",
    "#40162f",
    "#551c3b",
    "#75204f",
    "#a02669",
    "#cb2b83",
    "#e0529c",
    "#f37fb7",
    "#f8a8cc",
    "#fad2e3"
];
$37058c64b679ada5$export$d260a9321db4ab86.primary = $37058c64b679ada5$export$d260a9321db4ab86[5];
const $37058c64b679ada5$export$515283ba400ffa6c = [
    "#151515",
    "#1f1f1f",
    "#2d2d2d",
    "#393939",
    "#494949",
    "#5a5a5a",
    "#6a6a6a",
    "#7b7b7b",
    "#888888",
    "#969696"
];
$37058c64b679ada5$export$515283ba400ffa6c.primary = $37058c64b679ada5$export$515283ba400ffa6c[5];
const $37058c64b679ada5$export$24617255e4daf647 = {
    red: $37058c64b679ada5$export$e984d34fc144caa1,
    volcano: $37058c64b679ada5$export$360e10f78e17a865,
    orange: $37058c64b679ada5$export$d5a12c698b31fa45,
    gold: $37058c64b679ada5$export$2330427fb6a6af6f,
    yellow: $37058c64b679ada5$export$67d203119f0ecec,
    lime: $37058c64b679ada5$export$51ed2a10d86576ed,
    green: $37058c64b679ada5$export$76a3d804058f9b5f,
    cyan: $37058c64b679ada5$export$dee6c7c6683c0d88,
    blue: $37058c64b679ada5$export$10e0fd027e632624,
    geekblue: $37058c64b679ada5$export$abdd57ab473bba66,
    purple: $37058c64b679ada5$export$7a65e68792738764,
    magenta: $37058c64b679ada5$export$d260a9321db4ab86,
    grey: $37058c64b679ada5$export$515283ba400ffa6c
};




const $cafc407c84851727$export$37e27b43af4d16eb = {
    blue: '#1677FF',
    purple: '#722ED1',
    cyan: '#13C2C2',
    green: '#52C41A',
    magenta: '#EB2F96',
    /**
   * @deprecated Use magenta instead
   */ pink: '#EB2F96',
    red: '#F5222D',
    orange: '#FA8C16',
    yellow: '#FADB14',
    volcano: '#FA541C',
    geekblue: '#2F54EB',
    gold: '#FAAD14',
    lime: '#A0D911'
};
const $cafc407c84851727$var$seedToken = {
    // preset color palettes
    ...$cafc407c84851727$export$37e27b43af4d16eb,
    // Color
    colorPrimary: '#1677ff',
    colorSuccess: '#52c41a',
    colorWarning: '#faad14',
    colorError: '#ff4d4f',
    colorInfo: '#1677ff',
    colorLink: '',
    colorTextBase: '',
    colorBgBase: '',
    // Font
    fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
'Noto Color Emoji'`,
    fontFamilyCode: `'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace`,
    fontSize: 14,
    // Line
    lineWidth: 1,
    lineType: 'solid',
    // Motion
    motionUnit: 0.1,
    motionBase: 0,
    motionEaseOutCirc: 'cubic-bezier(0.08, 0.82, 0.17, 1)',
    motionEaseInOutCirc: 'cubic-bezier(0.78, 0.14, 0.15, 0.86)',
    motionEaseOut: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
    motionEaseInOut: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    motionEaseOutBack: 'cubic-bezier(0.12, 0.4, 0.29, 1.46)',
    motionEaseInBack: 'cubic-bezier(0.71, -0.46, 0.88, 0.6)',
    motionEaseInQuint: 'cubic-bezier(0.755, 0.05, 0.855, 0.06)',
    motionEaseOutQuint: 'cubic-bezier(0.23, 1, 0.32, 1)',
    // Radius
    borderRadius: 6,
    // Size
    sizeUnit: 4,
    sizeStep: 4,
    sizePopupArrow: 16,
    // Control Base
    controlHeight: 32,
    // zIndex
    zIndexBase: 0,
    zIndexPopupBase: 1000,
    // Image
    opacityImage: 1,
    // Wireframe
    wireframe: false,
    // Focus Outline
    focusOutline: true,
    // Motion
    motion: true
};
var $cafc407c84851727$export$2e2bcd8739ae039 = $cafc407c84851727$var$seedToken;



const $2535cf92607464fc$export$6d4fe3a00a1811ad = [
    'blue',
    'purple',
    'cyan',
    'green',
    'magenta',
    'pink',
    'red',
    'orange',
    'yellow',
    'volcano',
    'geekblue',
    'lime',
    'gold'
];


function $7880efcdb78041c8$export$2e2bcd8739ae039(seed, { generateColorPalettes: generateColorPalettes, generateNeutralColorPalettes: generateNeutralColorPalettes }) {
    const { colorSuccess: colorSuccessBase, colorWarning: colorWarningBase, colorError: colorErrorBase, colorInfo: colorInfoBase, colorPrimary: colorPrimaryBase, colorBgBase: colorBgBase, colorTextBase: colorTextBase } = seed;
    const primaryColors = generateColorPalettes(colorPrimaryBase);
    const successColors = generateColorPalettes(colorSuccessBase);
    const warningColors = generateColorPalettes(colorWarningBase);
    const errorColors = generateColorPalettes(colorErrorBase);
    const infoColors = generateColorPalettes(colorInfoBase);
    const neutralColors = generateNeutralColorPalettes(colorBgBase, colorTextBase);
    // Color Link
    const colorLink = seed.colorLink || seed.colorInfo;
    const linkColors = generateColorPalettes(colorLink);
    const colorErrorBgFilledHover = new (0, $1b0a692e36565107$export$2c4f38d6c0ecc25a)(errorColors[1]).mix(new (0, $1b0a692e36565107$export$2c4f38d6c0ecc25a)(errorColors[3]), 50).toHexString();
    const presetColorTokens = {};
    (0, $2535cf92607464fc$export$6d4fe3a00a1811ad).forEach((colorKey)=>{
        const colorBase = seed[colorKey];
        if (colorBase) {
            const colorPalette = generateColorPalettes(colorBase);
            presetColorTokens[`${colorKey}Hover`] = colorPalette[5];
            presetColorTokens[`${colorKey}Active`] = colorPalette[7];
        }
    });
    return {
        ...neutralColors,
        colorPrimaryBg: primaryColors[1],
        colorPrimaryBgHover: primaryColors[2],
        colorPrimaryBorder: primaryColors[3],
        colorPrimaryBorderHover: primaryColors[4],
        colorPrimaryHover: primaryColors[5],
        colorPrimary: primaryColors[6],
        colorPrimaryActive: primaryColors[7],
        colorPrimaryTextHover: primaryColors[8],
        colorPrimaryText: primaryColors[9],
        colorPrimaryTextActive: primaryColors[10],
        colorSuccessBg: successColors[1],
        colorSuccessBgHover: successColors[2],
        colorSuccessBorder: successColors[3],
        colorSuccessBorderHover: successColors[4],
        colorSuccessHover: successColors[4],
        colorSuccess: successColors[6],
        colorSuccessActive: successColors[7],
        colorSuccessTextHover: successColors[8],
        colorSuccessText: successColors[9],
        colorSuccessTextActive: successColors[10],
        colorErrorBg: errorColors[1],
        colorErrorBgHover: errorColors[2],
        colorErrorBgFilledHover: colorErrorBgFilledHover,
        colorErrorBgActive: errorColors[3],
        colorErrorBorder: errorColors[3],
        colorErrorBorderHover: errorColors[4],
        colorErrorHover: errorColors[5],
        colorError: errorColors[6],
        colorErrorActive: errorColors[7],
        colorErrorTextHover: errorColors[8],
        colorErrorText: errorColors[9],
        colorErrorTextActive: errorColors[10],
        colorWarningBg: warningColors[1],
        colorWarningBgHover: warningColors[2],
        colorWarningBorder: warningColors[3],
        colorWarningBorderHover: warningColors[4],
        colorWarningHover: warningColors[4],
        colorWarning: warningColors[6],
        colorWarningActive: warningColors[7],
        colorWarningTextHover: warningColors[8],
        colorWarningText: warningColors[9],
        colorWarningTextActive: warningColors[10],
        colorInfoBg: infoColors[1],
        colorInfoBgHover: infoColors[2],
        colorInfoBorder: infoColors[3],
        colorInfoBorderHover: infoColors[4],
        colorInfoHover: infoColors[4],
        colorInfo: infoColors[6],
        colorInfoActive: infoColors[7],
        colorInfoTextHover: infoColors[8],
        colorInfoText: infoColors[9],
        colorInfoTextActive: infoColors[10],
        colorLinkHover: linkColors[4],
        colorLink: linkColors[6],
        colorLinkActive: linkColors[7],
        ...presetColorTokens,
        colorBgMask: new (0, $1b0a692e36565107$export$2c4f38d6c0ecc25a)('#000').setA(0.45).toRgbString(),
        colorWhite: '#fff'
    };
}


const $e6bc29c15e1e3f95$var$genRadius = (radiusBase)=>{
    let radiusLG = radiusBase;
    let radiusSM = radiusBase;
    let radiusXS = radiusBase;
    let radiusOuter = radiusBase;
    // radiusLG
    if (radiusBase < 6 && radiusBase >= 5) radiusLG = radiusBase + 1;
    else if (radiusBase < 16 && radiusBase >= 6) radiusLG = radiusBase + 2;
    else if (radiusBase >= 16) radiusLG = 16;
    // radiusSM
    if (radiusBase < 7 && radiusBase >= 5) radiusSM = 4;
    else if (radiusBase < 8 && radiusBase >= 7) radiusSM = 5;
    else if (radiusBase < 14 && radiusBase >= 8) radiusSM = 6;
    else if (radiusBase < 16 && radiusBase >= 14) radiusSM = 7;
    else if (radiusBase >= 16) radiusSM = 8;
    // radiusXS
    if (radiusBase < 6 && radiusBase >= 2) radiusXS = 1;
    else if (radiusBase >= 6) radiusXS = 2;
    // radiusOuter
    if (radiusBase > 4 && radiusBase < 8) radiusOuter = 4;
    else if (radiusBase >= 8) radiusOuter = 6;
    return {
        borderRadius: radiusBase,
        borderRadiusXS: radiusXS,
        borderRadiusSM: radiusSM,
        borderRadiusLG: radiusLG,
        borderRadiusOuter: radiusOuter
    };
};
var $e6bc29c15e1e3f95$export$2e2bcd8739ae039 = $e6bc29c15e1e3f95$var$genRadius;


function $797b003d2de387d0$export$2e2bcd8739ae039(token) {
    const { motionUnit: motionUnit, motionBase: motionBase, borderRadius: borderRadius, lineWidth: lineWidth } = token;
    return {
        // motion
        motionDurationFast: `${(motionBase + motionUnit).toFixed(1)}s`,
        motionDurationMid: `${(motionBase + motionUnit * 2).toFixed(1)}s`,
        motionDurationSlow: `${(motionBase + motionUnit * 3).toFixed(1)}s`,
        // line
        lineWidthBold: lineWidth + 1,
        // radius
        ...(0, $e6bc29c15e1e3f95$export$2e2bcd8739ae039)(borderRadius)
    };
}


const $1922c9c35d5613d8$var$genControlHeight = (token)=>{
    const { controlHeight: controlHeight } = token;
    return {
        controlHeightSM: controlHeight * 0.75,
        controlHeightXS: controlHeight * 0.5,
        controlHeightLG: controlHeight * 1.25
    };
};
var $1922c9c35d5613d8$export$2e2bcd8739ae039 = $1922c9c35d5613d8$var$genControlHeight;


function $16a2b44eea7795a7$export$56204a27a2958a55(fontSize) {
    return (fontSize + 8) / fontSize;
}
function $16a2b44eea7795a7$export$2e2bcd8739ae039(base) {
    const fontSizes = Array.from({
        length: 10
    }).map((_, index)=>{
        const i = index - 1;
        const baseSize = base * Math.E ** (i / 5);
        const intSize = index > 1 ? Math.floor(baseSize) : Math.ceil(baseSize);
        // Convert to even
        return Math.floor(intSize / 2) * 2;
    });
    fontSizes[1] = base;
    return fontSizes.map((size)=>({
            size: size,
            lineHeight: $16a2b44eea7795a7$export$56204a27a2958a55(size)
        }));
}


const $f1ec6a371b6c7e62$var$genFontMapToken = (fontSize)=>{
    const fontSizePairs = (0, $16a2b44eea7795a7$export$2e2bcd8739ae039)(fontSize);
    const fontSizes = fontSizePairs.map((pair)=>pair.size);
    const lineHeights = fontSizePairs.map((pair)=>pair.lineHeight);
    const fontSizeMD = fontSizes[1];
    const fontSizeSM = fontSizes[0];
    const fontSizeLG = fontSizes[2];
    const lineHeight = lineHeights[1];
    const lineHeightSM = lineHeights[0];
    const lineHeightLG = lineHeights[2];
    return {
        fontSizeSM: fontSizeSM,
        fontSize: fontSizeMD,
        fontSizeLG: fontSizeLG,
        fontSizeXL: fontSizes[3],
        fontSizeHeading1: fontSizes[6],
        fontSizeHeading2: fontSizes[5],
        fontSizeHeading3: fontSizes[4],
        fontSizeHeading4: fontSizes[3],
        fontSizeHeading5: fontSizes[2],
        lineHeight: lineHeight,
        lineHeightLG: lineHeightLG,
        lineHeightSM: lineHeightSM,
        fontHeight: Math.round(lineHeight * fontSizeMD),
        fontHeightLG: Math.round(lineHeightLG * fontSizeLG),
        fontHeightSM: Math.round(lineHeightSM * fontSizeSM),
        lineHeightHeading1: lineHeights[6],
        lineHeightHeading2: lineHeights[5],
        lineHeightHeading3: lineHeights[4],
        lineHeightHeading4: lineHeights[3],
        lineHeightHeading5: lineHeights[2]
    };
};
var $f1ec6a371b6c7e62$export$2e2bcd8739ae039 = $f1ec6a371b6c7e62$var$genFontMapToken;


function $ceae46f3ace78c40$export$2e2bcd8739ae039(token) {
    const { sizeUnit: sizeUnit, sizeStep: sizeStep } = token;
    return {
        sizeXXL: sizeUnit * (sizeStep + 8),
        // 48
        sizeXL: sizeUnit * (sizeStep + 4),
        // 32
        sizeLG: sizeUnit * (sizeStep + 2),
        // 24
        sizeMD: sizeUnit * (sizeStep + 1),
        // 20
        sizeMS: sizeUnit * sizeStep,
        // 16
        size: sizeUnit * sizeStep,
        // 16
        sizeSM: sizeUnit * (sizeStep - 1),
        // 12
        sizeXS: sizeUnit * (sizeStep - 2),
        // 8
        sizeXXS: sizeUnit * (sizeStep - 3 // 4
        )
    };
}




const $8f0ac5bd3f93b9d6$export$31f6399ba7ce6bea = (baseColor, alpha)=>new (0, $1b0a692e36565107$export$2c4f38d6c0ecc25a)(baseColor).setA(alpha).toRgbString();
const $8f0ac5bd3f93b9d6$export$7003a8a990e79359 = (baseColor, brightness)=>{
    const instance = new (0, $1b0a692e36565107$export$2c4f38d6c0ecc25a)(baseColor);
    return instance.darken(brightness).toHexString();
};


const $accd14a360274b9a$export$da275153033f4ec1 = (baseColor)=>{
    const colors = (0, $0452e534096bcd2f$export$2e2bcd8739ae039)(baseColor);
    return {
        1: colors[0],
        2: colors[1],
        3: colors[2],
        4: colors[3],
        5: colors[4],
        6: colors[5],
        7: colors[6],
        8: colors[4],
        9: colors[5],
        10: colors[6]
    };
};
const $accd14a360274b9a$export$3e0cb0c1d9c1b691 = (bgBaseColor, textBaseColor, shadowColor)=>{
    const colorBgBase = bgBaseColor || '#fff';
    const colorTextBase = textBaseColor || '#000';
    const colorShadow = shadowColor || '#000';
    return {
        colorBgBase: colorBgBase,
        colorTextBase: colorTextBase,
        colorShadow: colorShadow,
        colorText: (0, $8f0ac5bd3f93b9d6$export$31f6399ba7ce6bea)(colorTextBase, 0.88),
        colorTextSecondary: (0, $8f0ac5bd3f93b9d6$export$31f6399ba7ce6bea)(colorTextBase, 0.65),
        colorTextTertiary: (0, $8f0ac5bd3f93b9d6$export$31f6399ba7ce6bea)(colorTextBase, 0.45),
        colorTextQuaternary: (0, $8f0ac5bd3f93b9d6$export$31f6399ba7ce6bea)(colorTextBase, 0.25),
        colorFill: (0, $8f0ac5bd3f93b9d6$export$31f6399ba7ce6bea)(colorTextBase, 0.15),
        colorFillSecondary: (0, $8f0ac5bd3f93b9d6$export$31f6399ba7ce6bea)(colorTextBase, 0.06),
        colorFillTertiary: (0, $8f0ac5bd3f93b9d6$export$31f6399ba7ce6bea)(colorTextBase, 0.04),
        colorFillQuaternary: (0, $8f0ac5bd3f93b9d6$export$31f6399ba7ce6bea)(colorTextBase, 0.02),
        colorBgSolid: (0, $8f0ac5bd3f93b9d6$export$31f6399ba7ce6bea)(colorTextBase, 1),
        colorBgSolidHover: (0, $8f0ac5bd3f93b9d6$export$31f6399ba7ce6bea)(colorTextBase, 0.75),
        colorBgSolidActive: (0, $8f0ac5bd3f93b9d6$export$31f6399ba7ce6bea)(colorTextBase, 0.95),
        colorBgLayout: (0, $8f0ac5bd3f93b9d6$export$7003a8a990e79359)(colorBgBase, 4),
        colorBgContainer: (0, $8f0ac5bd3f93b9d6$export$7003a8a990e79359)(colorBgBase, 0),
        colorBgElevated: (0, $8f0ac5bd3f93b9d6$export$7003a8a990e79359)(colorBgBase, 0),
        colorBgSpotlight: (0, $8f0ac5bd3f93b9d6$export$31f6399ba7ce6bea)(colorTextBase, 0.85),
        colorBgBlur: 'transparent',
        colorBorder: (0, $8f0ac5bd3f93b9d6$export$7003a8a990e79359)(colorBgBase, 15),
        colorBorderDisabled: (0, $8f0ac5bd3f93b9d6$export$7003a8a990e79359)(colorBgBase, 15),
        colorBorderSecondary: (0, $8f0ac5bd3f93b9d6$export$7003a8a990e79359)(colorBgBase, 6)
    };
};


function $0c9061ec4db9360a$export$2e2bcd8739ae039(token) {
    // pink is deprecated name of magenta, keep this for backwards compatibility
    (0, $37058c64b679ada5$export$3968a3afc810b5f5).pink = (0, $37058c64b679ada5$export$3968a3afc810b5f5).magenta;
    (0, $37058c64b679ada5$export$36ad6df0f83f284d).pink = (0, $37058c64b679ada5$export$36ad6df0f83f284d).magenta;
    const colorPalettes = Object.keys((0, $cafc407c84851727$export$37e27b43af4d16eb)).map((colorKey)=>{
        const colors = token[colorKey] === (0, $37058c64b679ada5$export$3968a3afc810b5f5)[colorKey] ? (0, $37058c64b679ada5$export$36ad6df0f83f284d)[colorKey] : (0, $0452e534096bcd2f$export$2e2bcd8739ae039)(token[colorKey]);
        return Array.from({
            length: 10
        }, ()=>1).reduce((prev, _, i)=>{
            prev[`${colorKey}-${i + 1}`] = colors[i];
            prev[`${colorKey}${i + 1}`] = colors[i];
            return prev;
        }, {});
    }).reduce((prev, cur)=>{
        prev = {
            ...prev,
            ...cur
        };
        return prev;
    }, {});
    return {
        ...token,
        ...colorPalettes,
        // Colors
        ...(0, $7880efcdb78041c8$export$2e2bcd8739ae039)(token, {
            generateColorPalettes: $accd14a360274b9a$export$da275153033f4ec1,
            generateNeutralColorPalettes: $accd14a360274b9a$export$3e0cb0c1d9c1b691
        }),
        // Font
        ...(0, $f1ec6a371b6c7e62$export$2e2bcd8739ae039)(token.fontSize),
        // Size
        ...(0, $ceae46f3ace78c40$export$2e2bcd8739ae039)(token),
        // Height
        ...(0, $1922c9c35d5613d8$export$2e2bcd8739ae039)(token),
        // Others
        ...(0, $797b003d2de387d0$export$2e2bcd8739ae039)(token)
    };
}


const $53f2aff062e85359$var$defaultTheme = (0, $e0015b07082714af$export$2e2bcd8739ae039)((0, $0c9061ec4db9360a$export$2e2bcd8739ae039));
var $53f2aff062e85359$export$2e2bcd8739ae039 = $53f2aff062e85359$var$defaultTheme;


var $5E6i4 = parcelRequire("5E6i4");


const $dbf47bce378e6980$export$f84bd70098573c5c = {
    token: (0, $cafc407c84851727$export$2e2bcd8739ae039),
    override: {
        override: (0, $cafc407c84851727$export$2e2bcd8739ae039)
    },
    hashed: true
};
const $dbf47bce378e6980$export$69b0ebb9efcddb30 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createContext($dbf47bce378e6980$export$f84bd70098573c5c);




var $5E6i4 = parcelRequire("5E6i4");


var $5E6i4 = parcelRequire("5E6i4");

var $ibUU1 = parcelRequire("ibUU1");

var $5E6i4 = parcelRequire("5E6i4");
const $d871c854d94da469$var$OrderContext = /*#__PURE__*/ $5E6i4.createContext(null);
var $d871c854d94da469$export$2e2bcd8739ae039 = $d871c854d94da469$var$OrderContext;


let $c6603abea8bd4380$export$18c8ad048e32c7d5 = false;
function $c6603abea8bd4380$export$121d9fd0ca615463(nextInline) {
    if (typeof nextInline === 'boolean') $c6603abea8bd4380$export$18c8ad048e32c7d5 = nextInline;
    return $c6603abea8bd4380$export$18c8ad048e32c7d5;
}



var $5E6i4 = parcelRequire("5E6i4");


const $f11a08c5fbf6b80f$var$EMPTY_LIST = [];
function $f11a08c5fbf6b80f$export$2e2bcd8739ae039(render, debug) {
    const [ele] = $5E6i4.useState(()=>{
        if (!(0, $8b91ba628d942bf2$export$2e2bcd8739ae039)()) return null;
        const defaultEle = document.createElement('div');
        return defaultEle;
    });
    // ========================== Order ==========================
    const appendedRef = $5E6i4.useRef(false);
    const queueCreate = $5E6i4.useContext((0, $d871c854d94da469$export$2e2bcd8739ae039));
    const [queue, setQueue] = $5E6i4.useState($f11a08c5fbf6b80f$var$EMPTY_LIST);
    const mergedQueueCreate = queueCreate || (appendedRef.current ? undefined : (appendFn)=>{
        setQueue((origin)=>{
            const newQueue = [
                appendFn,
                ...origin
            ];
            return newQueue;
        });
    });
    // =========================== DOM ===========================
    function append() {
        if (!ele.parentElement) document.body.appendChild(ele);
        appendedRef.current = true;
    }
    function cleanup() {
        ele.parentElement?.removeChild(ele);
        appendedRef.current = false;
    }
    (0, $518ae471aa4f03a7$export$2e2bcd8739ae039)(()=>{
        if (render) {
            if (queueCreate) queueCreate(append);
            else append();
        } else cleanup();
        return cleanup;
    }, [
        render
    ]);
    (0, $518ae471aa4f03a7$export$2e2bcd8739ae039)(()=>{
        if (queue.length) {
            queue.forEach((appendFn)=>appendFn());
            setQueue($f11a08c5fbf6b80f$var$EMPTY_LIST);
        }
    }, [
        queue
    ]);
    return [
        ele,
        mergedQueueCreate
    ];
}



var $5E6i4 = parcelRequire("5E6i4");

/**
 * Test usage export. Do not use in your production
 */ function $f901a06e0c7955ab$export$31b5c8f1131a3a52() {
    return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}


const $f37dc0e28caf7ce2$var$UNIQUE_ID = `rc-util-locker-${Date.now()}`;
let $f37dc0e28caf7ce2$var$uuid = 0;
function $f37dc0e28caf7ce2$export$2e2bcd8739ae039(lock) {
    const mergedLock = !!lock;
    const [id] = $5E6i4.useState(()=>{
        $f37dc0e28caf7ce2$var$uuid += 1;
        return `${$f37dc0e28caf7ce2$var$UNIQUE_ID}_${$f37dc0e28caf7ce2$var$uuid}`;
    });
    (0, $518ae471aa4f03a7$export$2e2bcd8739ae039)(()=>{
        if (mergedLock) {
            const scrollbarSize = (0, $eb2552f4f31fd55e$export$4f3ef2310365b56a)(document.body).width;
            const isOverflow = (0, $f901a06e0c7955ab$export$31b5c8f1131a3a52)();
            (0, $d5dd4df2f97e6f98$export$4d99a2890bb989f0)(`
html body {
  overflow-y: hidden;
  ${isOverflow ? `width: calc(100% - ${scrollbarSize}px);` : ''}
}`, id);
        } else (0, $d5dd4df2f97e6f98$export$2232e336aecaa80a)(id);
        return ()=>{
            (0, $d5dd4df2f97e6f98$export$2232e336aecaa80a)(id);
        };
    }, [
        mergedLock,
        id
    ]);
}




var $5E6i4 = parcelRequire("5E6i4");
let $75f08a46aa3976e4$var$stack = [];
const $75f08a46aa3976e4$var$IME_LOCK_DURATION = 200;
let $75f08a46aa3976e4$var$lastCompositionEndTime = 0;
const $75f08a46aa3976e4$export$9b72c8a279453f3a = null;
// Global event handlers
const $75f08a46aa3976e4$var$onGlobalKeyDown = (event)=>{
    if (event.key === 'Escape' && !event.isComposing) {
        const now = Date.now();
        if (now - $75f08a46aa3976e4$var$lastCompositionEndTime < $75f08a46aa3976e4$var$IME_LOCK_DURATION) return;
        const len = $75f08a46aa3976e4$var$stack.length;
        for(let i = len - 1; i >= 0; i -= 1)$75f08a46aa3976e4$var$stack[i].onEsc({
            top: i === len - 1,
            event: event
        });
    }
};
const $75f08a46aa3976e4$var$onGlobalCompositionEnd = ()=>{
    $75f08a46aa3976e4$var$lastCompositionEndTime = Date.now();
};
function $75f08a46aa3976e4$var$attachGlobalEventListeners() {
    window.addEventListener('keydown', $75f08a46aa3976e4$var$onGlobalKeyDown);
    window.addEventListener('compositionend', $75f08a46aa3976e4$var$onGlobalCompositionEnd);
}
function $75f08a46aa3976e4$var$detachGlobalEventListeners() {
    if ($75f08a46aa3976e4$var$stack.length === 0) {
        window.removeEventListener('keydown', $75f08a46aa3976e4$var$onGlobalKeyDown);
        window.removeEventListener('compositionend', $75f08a46aa3976e4$var$onGlobalCompositionEnd);
    }
}
function $75f08a46aa3976e4$export$2e2bcd8739ae039(open, onEsc) {
    const id = (0, $378d6dcdebc6b864$export$2e2bcd8739ae039)();
    const onEventEsc = (0, $68990f4402d2f009$export$2e2bcd8739ae039)(onEsc);
    const ensure = ()=>{
        if (!$75f08a46aa3976e4$var$stack.find((item)=>item.id === id)) $75f08a46aa3976e4$var$stack.push({
            id: id,
            onEsc: onEventEsc
        });
    };
    const clear = ()=>{
        $75f08a46aa3976e4$var$stack = $75f08a46aa3976e4$var$stack.filter((item)=>item.id !== id);
    };
    (0, $5E6i4.useMemo)(()=>{
        if (open) ensure();
        else if (!open) clear();
    }, [
        open
    ]);
    (0, $5E6i4.useEffect)(()=>{
        if (open) {
            ensure();
            // Attach global event listeners
            $75f08a46aa3976e4$var$attachGlobalEventListeners();
            return ()=>{
                clear();
                // Remove global event listeners if instances is empty
                $75f08a46aa3976e4$var$detachGlobalEventListeners();
            };
        }
    }, [
        open
    ]);
}


const $b7293ffcd255342d$var$getPortalContainer = (getContainer)=>{
    if (getContainer === false) return false;
    if (!(0, $8b91ba628d942bf2$export$2e2bcd8739ae039)() || !getContainer) return null;
    if (typeof getContainer === 'string') return document.querySelector(getContainer);
    if (typeof getContainer === 'function') return getContainer();
    return getContainer;
};
const $b7293ffcd255342d$var$Portal = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { open: open, autoLock: autoLock, getContainer: getContainer, debug: debug, autoDestroy: autoDestroy = true, children: children, onEsc: onEsc } = props;
    const [shouldRender, setShouldRender] = $5E6i4.useState(open);
    const mergedRender = shouldRender || open;
    // ====================== Should Render ======================
    $5E6i4.useEffect(()=>{
        if (autoDestroy || open) setShouldRender(open);
    }, [
        open,
        autoDestroy
    ]);
    // ======================== Container ========================
    const [innerContainer, setInnerContainer] = $5E6i4.useState(()=>$b7293ffcd255342d$var$getPortalContainer(getContainer));
    $5E6i4.useEffect(()=>{
        const customizeContainer = $b7293ffcd255342d$var$getPortalContainer(getContainer);
        // Tell component that we check this in effect which is safe to be `null`
        setInnerContainer(()=>// React do the state update even the value is the same,
            // Use function call to force React to compare update
            customizeContainer ?? null);
    });
    const [defaultContainer, queueCreate] = (0, $f11a08c5fbf6b80f$export$2e2bcd8739ae039)(mergedRender && !innerContainer, debug);
    const mergedContainer = innerContainer ?? defaultContainer;
    // ========================= Locker ==========================
    (0, $f37dc0e28caf7ce2$export$2e2bcd8739ae039)(autoLock && open && (0, $8b91ba628d942bf2$export$2e2bcd8739ae039)() && (mergedContainer === defaultContainer || mergedContainer === document.body));
    // ========================= Esc Keydown ==========================
    (0, $75f08a46aa3976e4$export$2e2bcd8739ae039)(open, onEsc);
    // =========================== Ref ===========================
    let childRef = null;
    if (children && (0, $92c8c75386168ffc$export$c1cec34af06bcf7)(children) && ref) childRef = (0, $92c8c75386168ffc$export$7465e5c0bf44f19a)(children);
    const mergedRef = (0, $92c8c75386168ffc$export$1d1c999670a1285d)(childRef, ref);
    // ========================= Render ==========================
    // Do not render when nothing need render
    // When innerContainer is `undefined`, it may not ready since user use ref in the same render
    if (!mergedRender || !(0, $8b91ba628d942bf2$export$2e2bcd8739ae039)() || innerContainer === undefined) return null;
    // Render inline
    const renderInline = mergedContainer === false || (0, $c6603abea8bd4380$export$121d9fd0ca615463)();
    let reffedChildren = children;
    if (ref) reffedChildren = /*#__PURE__*/ $5E6i4.cloneElement(children, {
        ref: mergedRef
    });
    return /*#__PURE__*/ $5E6i4.createElement((0, $d871c854d94da469$export$2e2bcd8739ae039).Provider, {
        value: queueCreate
    }, renderInline ? reffedChildren : /*#__PURE__*/ (0, $ibUU1.createPortal)(reffedChildren, mergedContainer));
});
var $b7293ffcd255342d$export$2e2bcd8739ae039 = $b7293ffcd255342d$var$Portal;



var $bd882e1916f36420$export$2e2bcd8739ae039 = (0, $b7293ffcd255342d$export$2e2bcd8739ae039);




var $5E6i4 = parcelRequire("5E6i4");





var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");
const $0aca5ad9f40b8630$export$db36075d98ba73d3 = /*#__PURE__*/ $5E6i4.createContext(null);
function $0aca5ad9f40b8630$export$fb8073518f34e6ec({ children: children, onBatchResize: onBatchResize }) {
    const resizeIdRef = $5E6i4.useRef(0);
    const resizeInfosRef = $5E6i4.useRef([]);
    const onCollectionResize = $5E6i4.useContext($0aca5ad9f40b8630$export$db36075d98ba73d3);
    const onResize = $5E6i4.useCallback((size, element, data)=>{
        resizeIdRef.current += 1;
        const currentId = resizeIdRef.current;
        resizeInfosRef.current.push({
            size: size,
            element: element,
            data: data
        });
        Promise.resolve().then(()=>{
            if (currentId === resizeIdRef.current) {
                onBatchResize?.(resizeInfosRef.current);
                resizeInfosRef.current = [];
            }
        });
        // Continue bubbling if parent exist
        onCollectionResize?.(size, element, data);
    }, [
        onBatchResize,
        onCollectionResize
    ]);
    return /*#__PURE__*/ $5E6i4.createElement($0aca5ad9f40b8630$export$db36075d98ba73d3.Provider, {
        value: onResize
    }, children);
}



var $5E6i4 = parcelRequire("5E6i4");
// =============================== Const ===============================
const $78bda633c31c8bcf$var$elementListeners = new Map();
function $78bda633c31c8bcf$var$onResize(entities) {
    entities.forEach((entity)=>{
        const { target: target } = entity;
        $78bda633c31c8bcf$var$elementListeners.get(target)?.forEach((listener)=>listener(target));
    });
}
// Delay create ResizeObserver since it's not supported in server side
let $78bda633c31c8bcf$var$observer;
function $78bda633c31c8bcf$var$ensureResizeObserver() {
    if (!$78bda633c31c8bcf$var$observer) $78bda633c31c8bcf$var$observer = new ResizeObserver($78bda633c31c8bcf$var$onResize);
    return $78bda633c31c8bcf$var$observer;
}
const $78bda633c31c8bcf$export$3fbe5a08fd9e4702 = null; // eslint-disable-line
const $78bda633c31c8bcf$export$524f0fd3b47831a = null; // eslint-disable-line
function $78bda633c31c8bcf$export$d1203567a167490e(element, callback) {
    if (!$78bda633c31c8bcf$var$elementListeners.has(element)) {
        $78bda633c31c8bcf$var$elementListeners.set(element, new Set());
        $78bda633c31c8bcf$var$ensureResizeObserver().observe(element);
    }
    $78bda633c31c8bcf$var$elementListeners.get(element).add(callback);
}
function $78bda633c31c8bcf$export$23a2283368c55ea2(element, callback) {
    if ($78bda633c31c8bcf$var$elementListeners.has(element)) {
        $78bda633c31c8bcf$var$elementListeners.get(element).delete(callback);
        if (!$78bda633c31c8bcf$var$elementListeners.get(element).size) {
            $78bda633c31c8bcf$var$ensureResizeObserver().unobserve(element);
            $78bda633c31c8bcf$var$elementListeners.delete(element);
        }
    }
}



function $a22daecb6ba47e50$export$2e2bcd8739ae039(enabled, getTarget, onDelayResize, onSyncResize) {
    // ============================= Size =============================
    const sizeRef = $5E6i4.useRef({
        width: -1,
        height: -1,
        offsetWidth: -1,
        offsetHeight: -1
    });
    // =========================== Observe ============================
    // Handler
    const onInternalResize = (0, $68990f4402d2f009$export$2e2bcd8739ae039)((target)=>{
        const { width: width, height: height } = target.getBoundingClientRect();
        const { offsetWidth: offsetWidth, offsetHeight: offsetHeight } = target;
        /**
     * Resize observer trigger when content size changed.
     * In most case we just care about element size,
     * let's use `boundary` instead of `contentRect` here to avoid shaking.
     */ const fixedWidth = Math.floor(width);
        const fixedHeight = Math.floor(height);
        if (sizeRef.current.width !== fixedWidth || sizeRef.current.height !== fixedHeight || sizeRef.current.offsetWidth !== offsetWidth || sizeRef.current.offsetHeight !== offsetHeight) {
            const size = {
                width: fixedWidth,
                height: fixedHeight,
                offsetWidth: offsetWidth,
                offsetHeight: offsetHeight
            };
            sizeRef.current = size;
            // IE is strange, right?
            const mergedOffsetWidth = offsetWidth === Math.round(width) ? width : offsetWidth;
            const mergedOffsetHeight = offsetHeight === Math.round(height) ? height : offsetHeight;
            const sizeInfo = {
                ...size,
                offsetWidth: mergedOffsetWidth,
                offsetHeight: mergedOffsetHeight
            };
            // Call the callback immediately, let the caller decide whether to defer
            // onResize(sizeInfo, target);
            onSyncResize?.(sizeInfo, target);
            // defer the callback but not defer to next frame
            Promise.resolve().then(()=>{
                onDelayResize?.(sizeInfo, target);
            });
        }
    });
    // Dynamic observe
    const isFuncTarget = typeof getTarget === 'function';
    const funcTargetIdRef = $5E6i4.useRef(0);
    $5E6i4.useEffect(()=>{
        const target = isFuncTarget ? getTarget() : getTarget;
        if (target && enabled) (0, $78bda633c31c8bcf$export$d1203567a167490e)(target, onInternalResize);
        else if (enabled && isFuncTarget) funcTargetIdRef.current += 1;
        return ()=>{
            if (target) (0, $78bda633c31c8bcf$export$23a2283368c55ea2)(target, onInternalResize);
        };
    }, [
        enabled,
        // If function target resolves after a parent render, the bumped ref value
        // lets the next render re-run this effect without watching the function identity.
        isFuncTarget ? funcTargetIdRef.current : getTarget
    ]);
}


function $a7e79381584716b6$var$SingleObserver(props, ref) {
    const { children: children, disabled: disabled, onResize: onResize, data: data } = props;
    const elementRef = $5E6i4.useRef(null);
    const onCollectionResize = $5E6i4.useContext((0, $0aca5ad9f40b8630$export$db36075d98ba73d3));
    // =========================== Children ===========================
    const isRenderProps = typeof children === 'function';
    const mergedChildren = isRenderProps ? children(elementRef) : children;
    // ============================= Ref ==============================
    const canRef = !isRenderProps && /*#__PURE__*/ $5E6i4.isValidElement(mergedChildren) && (0, $92c8c75386168ffc$export$c1cec34af06bcf7)(mergedChildren);
    const originRef = canRef ? (0, $92c8c75386168ffc$export$7465e5c0bf44f19a)(mergedChildren) : null;
    const mergedRef = (0, $92c8c75386168ffc$export$1d1c999670a1285d)(originRef, elementRef);
    const getDomElement = ()=>{
        return (0, $b1bf69966442e513$export$9aa546fdc20ae5b3)(elementRef.current);
    };
    $5E6i4.useImperativeHandle(ref, ()=>getDomElement());
    // =========================== Observe ============================
    (0, $a22daecb6ba47e50$export$2e2bcd8739ae039)(!disabled, getDomElement, onResize, (sizeInfo, target)=>{
        onCollectionResize?.(sizeInfo, target, data);
    });
    // ============================ Render ============================
    return canRef ? /*#__PURE__*/ $5E6i4.cloneElement(mergedChildren, {
        ref: mergedRef
    }) : mergedChildren;
}
const $a7e79381584716b6$var$RefSingleObserver = /*#__PURE__*/ $5E6i4.forwardRef($a7e79381584716b6$var$SingleObserver);
var $a7e79381584716b6$export$2e2bcd8739ae039 = $a7e79381584716b6$var$RefSingleObserver;





function $3a396118caae8741$var$_extends() {
    $3a396118caae8741$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3a396118caae8741$var$_extends.apply(this, arguments);
}
const $3a396118caae8741$var$INTERNAL_PREFIX_KEY = 'rc-observer-key';
function $3a396118caae8741$var$ResizeObserver(props, ref) {
    const { children: children } = props;
    const childNodes = typeof children === 'function' ? [
        children
    ] : (0, $2ec1a2166f2295ea$export$2e2bcd8739ae039)(children);
    return childNodes.map((child, index)=>{
        const key = child?.key || `${$3a396118caae8741$var$INTERNAL_PREFIX_KEY}-${index}`;
        return /*#__PURE__*/ $5E6i4.createElement((0, $a7e79381584716b6$export$2e2bcd8739ae039), $3a396118caae8741$var$_extends({}, props, {
            key: key,
            ref: index === 0 ? ref : undefined
        }), child);
    });
}
const $3a396118caae8741$var$RefResizeObserver = /*#__PURE__*/ $5E6i4.forwardRef($3a396118caae8741$var$ResizeObserver);
$3a396118caae8741$var$RefResizeObserver.Collection = (0, $0aca5ad9f40b8630$export$fb8073518f34e6ec);
var $3a396118caae8741$export$2e2bcd8739ae039 = $3a396118caae8741$var$RefResizeObserver;




var $5E6i4 = parcelRequire("5E6i4");

/* eslint-disable react/default-props-match-prop-types, react/no-multi-comp, react/prop-types */ 


var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");
const $e0e68dd7bf0b9181$export$841858b892ce1f4c = /*#__PURE__*/ $5E6i4.createContext({});
const $e0e68dd7bf0b9181$var$MotionProvider = (props)=>{
    const { children: children, ...rest } = props;
    const memoizedValue = $5E6i4.useMemo(()=>{
        return {
            motion: rest.motion
        };
    }, [
        rest.motion
    ]);
    return /*#__PURE__*/ $5E6i4.createElement($e0e68dd7bf0b9181$export$841858b892ce1f4c.Provider, {
        value: memoizedValue
    }, children);
};
var $e0e68dd7bf0b9181$export$2e2bcd8739ae039 = $e0e68dd7bf0b9181$var$MotionProvider;




var $5E6i4 = parcelRequire("5E6i4");
const $66016b81b7e244ad$export$de71442bbf2143da = 'none';
const $66016b81b7e244ad$export$4fc3521687bcacd2 = 'appear';
const $66016b81b7e244ad$export$5d6af549241fe2e8 = 'enter';
const $66016b81b7e244ad$export$59b1c493d29f68e4 = 'leave';
const $66016b81b7e244ad$export$40b34dd77d5522bf = 'none';
const $66016b81b7e244ad$export$1b792916a5fac4fc = 'prepare';
const $66016b81b7e244ad$export$9563153dd25a3ce8 = 'start';
const $66016b81b7e244ad$export$e205886172277ec6 = 'active';
const $66016b81b7e244ad$export$3a846c3d2fac10b8 = 'end';
const $66016b81b7e244ad$export$98351fa4e6b4f204 = 'prepared';



var $5E6i4 = parcelRequire("5E6i4");

// ================= Transition =================
// Event wrapper. Copy from react source code
function $b5528033a6cf1292$var$makePrefixMap(styleProp, eventName) {
    const prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes[`Webkit${styleProp}`] = `webkit${eventName}`;
    prefixes[`Moz${styleProp}`] = `moz${eventName}`;
    prefixes[`ms${styleProp}`] = `MS${eventName}`;
    prefixes[`O${styleProp}`] = `o${eventName.toLowerCase()}`;
    return prefixes;
}
function $b5528033a6cf1292$export$6e8b350b1a8958a0(domSupport, win) {
    const prefixes = {
        animationend: $b5528033a6cf1292$var$makePrefixMap('Animation', 'AnimationEnd'),
        transitionend: $b5528033a6cf1292$var$makePrefixMap('Transition', 'TransitionEnd')
    };
    if (domSupport) {
        if (!('AnimationEvent' in win)) delete prefixes.animationend.animation;
        if (!('TransitionEvent' in win)) delete prefixes.transitionend.transition;
    }
    return prefixes;
}
const $b5528033a6cf1292$var$vendorPrefixes = $b5528033a6cf1292$export$6e8b350b1a8958a0((0, $8b91ba628d942bf2$export$2e2bcd8739ae039)(), typeof window !== 'undefined' ? window : {});
let $b5528033a6cf1292$var$style = {};
if ((0, $8b91ba628d942bf2$export$2e2bcd8739ae039)()) ({ style: $b5528033a6cf1292$var$style } = document.createElement('div'));
const $b5528033a6cf1292$var$prefixedEventNames = {};
function $b5528033a6cf1292$export$a032e4f39350c1d8(eventName) {
    if ($b5528033a6cf1292$var$prefixedEventNames[eventName]) return $b5528033a6cf1292$var$prefixedEventNames[eventName];
    const prefixMap = $b5528033a6cf1292$var$vendorPrefixes[eventName];
    if (prefixMap) {
        const stylePropList = Object.keys(prefixMap);
        const len = stylePropList.length;
        for(let i = 0; i < len; i += 1){
            const styleProp = stylePropList[i];
            if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in $b5528033a6cf1292$var$style) {
                $b5528033a6cf1292$var$prefixedEventNames[eventName] = prefixMap[styleProp];
                return $b5528033a6cf1292$var$prefixedEventNames[eventName];
            }
        }
    }
    return '';
}
const $b5528033a6cf1292$var$internalAnimationEndName = $b5528033a6cf1292$export$a032e4f39350c1d8('animationend');
const $b5528033a6cf1292$var$internalTransitionEndName = $b5528033a6cf1292$export$a032e4f39350c1d8('transitionend');
const $b5528033a6cf1292$export$d28133ed3ad06c8b = !!($b5528033a6cf1292$var$internalAnimationEndName && $b5528033a6cf1292$var$internalTransitionEndName);
const $b5528033a6cf1292$export$760cc9769c51b738 = $b5528033a6cf1292$var$internalAnimationEndName || 'animationend';
const $b5528033a6cf1292$export$44baea64b8602e3c = $b5528033a6cf1292$var$internalTransitionEndName || 'transitionend';
function $b5528033a6cf1292$export$27c72201b1d09951(transitionName, transitionType) {
    if (!transitionName) return null;
    if (typeof transitionName === 'object') {
        const type = transitionType.replace(/-\w/g, (match)=>match[1].toUpperCase());
        return transitionName[type];
    }
    return `${transitionName}-${transitionType}`;
}


var $4cdf8ff77f3d4ec9$export$2e2bcd8739ae039 = (onInternalMotionEnd)=>{
    const cacheElementRef = (0, $5E6i4.useRef)();
    // Remove events
    function removeMotionEvents(element) {
        if (element) {
            element.removeEventListener((0, $b5528033a6cf1292$export$44baea64b8602e3c), onInternalMotionEnd);
            element.removeEventListener((0, $b5528033a6cf1292$export$760cc9769c51b738), onInternalMotionEnd);
        }
    }
    // Patch events
    function patchMotionEvents(element) {
        if (cacheElementRef.current && cacheElementRef.current !== element) removeMotionEvents(cacheElementRef.current);
        if (element && element !== cacheElementRef.current) {
            element.addEventListener((0, $b5528033a6cf1292$export$44baea64b8602e3c), onInternalMotionEnd);
            element.addEventListener((0, $b5528033a6cf1292$export$760cc9769c51b738), onInternalMotionEnd);
            // Save as cache in case dom removed trigger by `motionDeadline`
            cacheElementRef.current = element;
        }
    }
    // Clean up when removed
    $5E6i4.useEffect(()=>()=>{
            removeMotionEvents(cacheElementRef.current);
            cacheElementRef.current = null;
        }, []);
    return [
        patchMotionEvents,
        removeMotionEvents
    ];
};




var $5E6i4 = parcelRequire("5E6i4");
// It's safe to use `useLayoutEffect` but the warning is annoying
const $4c3edf8ab55861f8$var$useIsomorphicLayoutEffect = (0, $8b91ba628d942bf2$export$2e2bcd8739ae039)() ? (0, $5E6i4.useLayoutEffect) : (0, $5E6i4.useEffect);
var $4c3edf8ab55861f8$export$2e2bcd8739ae039 = $4c3edf8ab55861f8$var$useIsomorphicLayoutEffect;




var $5E6i4 = parcelRequire("5E6i4");




var $5E6i4 = parcelRequire("5E6i4");
var $15f309e0cff96456$export$2e2bcd8739ae039 = ()=>{
    const nextFrameRef = $5E6i4.useRef(null);
    function cancelNextFrame() {
        (0, $1d949665862f071a$export$2e2bcd8739ae039).cancel(nextFrameRef.current);
    }
    function nextFrame(callback, delay = 2) {
        cancelNextFrame();
        const nextFrameId = (0, $1d949665862f071a$export$2e2bcd8739ae039)(()=>{
            if (delay <= 1) callback({
                isCanceled: ()=>nextFrameId !== nextFrameRef.current
            });
            else nextFrame(callback, delay - 1);
        });
        nextFrameRef.current = nextFrameId;
    }
    $5E6i4.useEffect(()=>()=>{
            cancelNextFrame();
        }, []);
    return [
        nextFrame,
        cancelNextFrame
    ];
};


const $39762ea79d49fd4b$var$FULL_STEP_QUEUE = [
    (0, $66016b81b7e244ad$export$1b792916a5fac4fc),
    (0, $66016b81b7e244ad$export$9563153dd25a3ce8),
    (0, $66016b81b7e244ad$export$e205886172277ec6),
    (0, $66016b81b7e244ad$export$3a846c3d2fac10b8)
];
const $39762ea79d49fd4b$var$SIMPLE_STEP_QUEUE = [
    (0, $66016b81b7e244ad$export$1b792916a5fac4fc),
    (0, $66016b81b7e244ad$export$98351fa4e6b4f204)
];
const $39762ea79d49fd4b$export$c2029bf6cfdbc28a = false;
const $39762ea79d49fd4b$export$dbee1e282e8c4830 = true;
function $39762ea79d49fd4b$export$39e04e72f972b885(step) {
    return step === (0, $66016b81b7e244ad$export$e205886172277ec6) || step === (0, $66016b81b7e244ad$export$3a846c3d2fac10b8);
}
var $39762ea79d49fd4b$export$2e2bcd8739ae039 = (status, prepareOnly, callback)=>{
    const [step, setStep] = (0, $42260c70cd082563$export$2e2bcd8739ae039)((0, $66016b81b7e244ad$export$40b34dd77d5522bf));
    const [nextFrame, cancelNextFrame] = (0, $15f309e0cff96456$export$2e2bcd8739ae039)();
    function startQueue() {
        setStep((0, $66016b81b7e244ad$export$1b792916a5fac4fc), true);
    }
    const STEP_QUEUE = prepareOnly ? $39762ea79d49fd4b$var$SIMPLE_STEP_QUEUE : $39762ea79d49fd4b$var$FULL_STEP_QUEUE;
    (0, $4c3edf8ab55861f8$export$2e2bcd8739ae039)(()=>{
        if (step !== (0, $66016b81b7e244ad$export$40b34dd77d5522bf) && step !== (0, $66016b81b7e244ad$export$3a846c3d2fac10b8)) {
            const index = STEP_QUEUE.indexOf(step);
            const nextStep = STEP_QUEUE[index + 1];
            const result = callback(step);
            if (result === $39762ea79d49fd4b$export$c2029bf6cfdbc28a) // Skip when no needed
            setStep(nextStep, true);
            else if (nextStep) // Do as frame for step update
            nextFrame((info)=>{
                function doNext() {
                    // Skip since current queue is ood
                    if (info.isCanceled()) return;
                    setStep(nextStep, true);
                }
                if (result === true) doNext();
                else // Only promise should be async
                Promise.resolve(result).then(doNext);
            });
        }
    }, [
        status,
        step
    ]);
    $5E6i4.useEffect(()=>()=>{
            cancelNextFrame();
        }, []);
    return [
        startQueue,
        step
    ];
};


function $8abcd83b8b210a26$export$2e2bcd8739ae039(supportMotion, visible, getElement, { motionEnter: motionEnter = true, motionAppear: motionAppear = true, motionLeave: motionLeave = true, motionDeadline: motionDeadline, motionLeaveImmediately: motionLeaveImmediately, onAppearPrepare: onAppearPrepare, onEnterPrepare: onEnterPrepare, onLeavePrepare: onLeavePrepare, onAppearStart: onAppearStart, onEnterStart: onEnterStart, onLeaveStart: onLeaveStart, onAppearActive: onAppearActive, onEnterActive: onEnterActive, onLeaveActive: onLeaveActive, onAppearEnd: onAppearEnd, onEnterEnd: onEnterEnd, onLeaveEnd: onLeaveEnd, onVisibleChanged: onVisibleChanged }) {
    // Used for outer render usage to avoid `visible: false & status: none` to render nothing
    const [asyncVisible, setAsyncVisible] = $5E6i4.useState();
    const [getStatus, setStatus] = (0, $63d9459522a935af$export$2e2bcd8739ae039)((0, $66016b81b7e244ad$export$de71442bbf2143da));
    const [style, setStyle] = $5E6i4.useState([
        null,
        null
    ]);
    const currentStatus = getStatus();
    const mountedRef = (0, $5E6i4.useRef)(false);
    const deadlineRef = (0, $5E6i4.useRef)(null);
    // =========================== Dom Node ===========================
    function getDomElement() {
        return getElement();
    }
    // ========================== Motion End ==========================
    const activeRef = (0, $5E6i4.useRef)(false);
    /**
   * Clean up status & style
   */ function updateMotionEndStatus() {
        setStatus((0, $66016b81b7e244ad$export$de71442bbf2143da));
        setStyle([
            null,
            null
        ]);
    }
    const onInternalMotionEnd = (0, $68990f4402d2f009$export$2e2bcd8739ae039)((event)=>{
        const status = getStatus();
        // Do nothing since not in any transition status.
        // This may happen when `motionDeadline` trigger.
        if (status === (0, $66016b81b7e244ad$export$de71442bbf2143da)) return;
        const element = getDomElement();
        if (event && !event.deadline && event.target !== element) // event exists
        // not initiated by deadline
        // transitionEnd not fired by inner elements
        return;
        const currentActive = activeRef.current;
        let canEnd;
        if (status === (0, $66016b81b7e244ad$export$4fc3521687bcacd2) && currentActive) canEnd = onAppearEnd?.(element, event);
        else if (status === (0, $66016b81b7e244ad$export$5d6af549241fe2e8) && currentActive) canEnd = onEnterEnd?.(element, event);
        else if (status === (0, $66016b81b7e244ad$export$59b1c493d29f68e4) && currentActive) canEnd = onLeaveEnd?.(element, event);
        // Only update status when `canEnd` and not destroyed
        if (currentActive && canEnd !== false) updateMotionEndStatus();
    });
    const [patchMotionEvents] = (0, $4cdf8ff77f3d4ec9$export$2e2bcd8739ae039)(onInternalMotionEnd);
    // ============================= Step =============================
    const getEventHandlers = (targetStatus)=>{
        switch(targetStatus){
            case 0, $66016b81b7e244ad$export$4fc3521687bcacd2:
                return {
                    [(0, $66016b81b7e244ad$export$1b792916a5fac4fc)]: onAppearPrepare,
                    [(0, $66016b81b7e244ad$export$9563153dd25a3ce8)]: onAppearStart,
                    [(0, $66016b81b7e244ad$export$e205886172277ec6)]: onAppearActive
                };
            case 0, $66016b81b7e244ad$export$5d6af549241fe2e8:
                return {
                    [(0, $66016b81b7e244ad$export$1b792916a5fac4fc)]: onEnterPrepare,
                    [(0, $66016b81b7e244ad$export$9563153dd25a3ce8)]: onEnterStart,
                    [(0, $66016b81b7e244ad$export$e205886172277ec6)]: onEnterActive
                };
            case 0, $66016b81b7e244ad$export$59b1c493d29f68e4:
                return {
                    [(0, $66016b81b7e244ad$export$1b792916a5fac4fc)]: onLeavePrepare,
                    [(0, $66016b81b7e244ad$export$9563153dd25a3ce8)]: onLeaveStart,
                    [(0, $66016b81b7e244ad$export$e205886172277ec6)]: onLeaveActive
                };
            default:
                return {};
        }
    };
    const eventHandlers = $5E6i4.useMemo(()=>getEventHandlers(currentStatus), [
        currentStatus
    ]);
    const [startStep, step] = (0, $39762ea79d49fd4b$export$2e2bcd8739ae039)(currentStatus, !supportMotion, (newStep)=>{
        // Only prepare step can be skip
        if (newStep === (0, $66016b81b7e244ad$export$1b792916a5fac4fc)) {
            const onPrepare = eventHandlers[0, $66016b81b7e244ad$export$1b792916a5fac4fc];
            if (!onPrepare) return 0, $39762ea79d49fd4b$export$c2029bf6cfdbc28a;
            return onPrepare(getDomElement());
        }
        // Rest step is sync update
        if (newStep in eventHandlers) setStyle([
            eventHandlers[newStep]?.(getDomElement(), null) || null,
            newStep
        ]);
        if (newStep === (0, $66016b81b7e244ad$export$e205886172277ec6) && currentStatus !== (0, $66016b81b7e244ad$export$de71442bbf2143da)) {
            // Patch events when motion needed
            patchMotionEvents(getDomElement());
            if (motionDeadline > 0) {
                clearTimeout(deadlineRef.current);
                deadlineRef.current = setTimeout(()=>{
                    onInternalMotionEnd({
                        deadline: true
                    });
                }, motionDeadline);
            }
        }
        if (newStep === (0, $66016b81b7e244ad$export$98351fa4e6b4f204)) updateMotionEndStatus();
        return 0, $39762ea79d49fd4b$export$dbee1e282e8c4830;
    });
    const active = (0, $39762ea79d49fd4b$export$39e04e72f972b885)(step);
    activeRef.current = active;
    // ============================ Status ============================
    const visibleRef = (0, $5E6i4.useRef)(null);
    // Update with new status
    (0, $4c3edf8ab55861f8$export$2e2bcd8739ae039)(()=>{
        // When use Suspense, the `visible` will repeat trigger,
        // But not real change of the `visible`, we need to skip it.
        // https://github.com/ant-design/ant-design/issues/44379
        if (mountedRef.current && visibleRef.current === visible) return;
        setAsyncVisible(visible);
        const isMounted = mountedRef.current;
        mountedRef.current = true;
        // if (!supportMotion) {
        //   return;
        // }
        let nextStatus;
        // Appear
        if (!isMounted && visible && motionAppear) nextStatus = (0, $66016b81b7e244ad$export$4fc3521687bcacd2);
        // Enter
        if (isMounted && visible && motionEnter) nextStatus = (0, $66016b81b7e244ad$export$5d6af549241fe2e8);
        // Leave
        if (isMounted && !visible && motionLeave || !isMounted && motionLeaveImmediately && !visible && motionLeave) nextStatus = (0, $66016b81b7e244ad$export$59b1c493d29f68e4);
        const nextEventHandlers = getEventHandlers(nextStatus);
        // Update to next status
        if (nextStatus && (supportMotion || nextEventHandlers[0, $66016b81b7e244ad$export$1b792916a5fac4fc])) {
            setStatus(nextStatus);
            startStep();
        } else // Set back in case no motion but prev status has prepare step
        setStatus((0, $66016b81b7e244ad$export$de71442bbf2143da));
        visibleRef.current = visible;
    }, [
        visible
    ]);
    // ============================ Effect ============================
    // Reset when motion changed
    (0, $5E6i4.useEffect)(()=>{
        if (// Cancel appear
        currentStatus === (0, $66016b81b7e244ad$export$4fc3521687bcacd2) && !motionAppear || // Cancel enter
        currentStatus === (0, $66016b81b7e244ad$export$5d6af549241fe2e8) && !motionEnter || // Cancel leave
        currentStatus === (0, $66016b81b7e244ad$export$59b1c493d29f68e4) && !motionLeave) setStatus((0, $66016b81b7e244ad$export$de71442bbf2143da));
    }, [
        motionAppear,
        motionEnter,
        motionLeave
    ]);
    (0, $5E6i4.useEffect)(()=>()=>{
            mountedRef.current = false;
            clearTimeout(deadlineRef.current);
        }, []);
    // Trigger `onVisibleChanged`
    const firstMountChangeRef = $5E6i4.useRef(false);
    (0, $5E6i4.useEffect)(()=>{
        // [visible & motion not end] => [!visible & motion end] still need trigger onVisibleChanged
        if (asyncVisible) firstMountChangeRef.current = true;
        if (asyncVisible !== undefined && currentStatus === (0, $66016b81b7e244ad$export$de71442bbf2143da)) {
            // Skip first render is invisible since it's nothing changed
            if (firstMountChangeRef.current || asyncVisible) onVisibleChanged?.(asyncVisible);
            firstMountChangeRef.current = true;
        }
    }, [
        asyncVisible,
        currentStatus
    ]);
    // ============================ Styles ============================
    let mergedStyle = style[0];
    if (eventHandlers[0, $66016b81b7e244ad$export$1b792916a5fac4fc] && step === (0, $66016b81b7e244ad$export$9563153dd25a3ce8)) mergedStyle = {
        transition: 'none',
        ...mergedStyle
    };
    const styleStep = style[1];
    return [
        getStatus,
        step,
        mergedStyle,
        asyncVisible ?? visible,
        // Appear Check
        !mountedRef.current && currentStatus === (0, $66016b81b7e244ad$export$de71442bbf2143da) && supportMotion && motionAppear ? 'NONE' : // Enter or Leave check
        step === (0, $66016b81b7e244ad$export$9563153dd25a3ce8) || step === (0, $66016b81b7e244ad$export$e205886172277ec6) ? styleStep === step : true
    ];
}





function $3f18309266f0bcbd$export$35eb5aa7e3b3c295(children) {
    return children?.length < 2;
}
function $3f18309266f0bcbd$export$e265d52a86a9f199(config) {
    let transitionSupport = config;
    if (typeof config === 'object') ({ transitionSupport: transitionSupport } = config);
    function isSupportTransition(props, contextMotion) {
        return !!(props.motionName && transitionSupport && contextMotion !== false);
    }
    const CSSMotion = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
        const { visible: // Default config
        visible = true, removeOnLeave: removeOnLeave = true, forceRender: forceRender, children: children, motionName: motionName, leavedClassName: leavedClassName, eventProps: eventProps } = props;
        const { motion: contextMotion } = $5E6i4.useContext((0, $e0e68dd7bf0b9181$export$841858b892ce1f4c));
        const supportMotion = isSupportTransition(props, contextMotion);
        // Ref to the react node, it may be a HTMLElement
        const nodeRef = (0, $5E6i4.useRef)();
        function getDomElement() {
            return (0, $b1bf69966442e513$export$9aa546fdc20ae5b3)(nodeRef.current);
        }
        const [getStatus, statusStep, statusStyle, mergedVisible, styleReady] = (0, $8abcd83b8b210a26$export$2e2bcd8739ae039)(supportMotion, visible, getDomElement, props);
        const status = getStatus();
        // Record whether content has rendered
        // Will return null for un-rendered even when `removeOnLeave={false}`
        const renderedRef = $5E6i4.useRef(mergedVisible);
        if (mergedVisible) renderedRef.current = true;
        // ====================== Refs ======================
        const refObj = $5E6i4.useMemo(()=>{
            const obj = {};
            Object.defineProperties(obj, {
                nativeElement: {
                    enumerable: true,
                    get: getDomElement
                },
                inMotion: {
                    enumerable: true,
                    get: ()=>()=>getStatus() !== (0, $66016b81b7e244ad$export$de71442bbf2143da)
                },
                enableMotion: {
                    enumerable: true,
                    get: ()=>()=>supportMotion
                }
            });
            return obj;
        }, []);
        // We lock `deps` here since function return object
        // will repeat trigger ref from `refConfig` -> `null` -> `refConfig`
        $5E6i4.useImperativeHandle(ref, ()=>refObj, []);
        // ===================== Render =====================
        // return motionChildren as React.ReactElement;
        const idRef = $5E6i4.useRef(0);
        if (styleReady) idRef.current += 1;
        // We should render children when motionStyle is sync with stepStatus
        const returnNode = $5E6i4.useMemo(()=>{
            if (styleReady === 'NONE') return null;
            let motionChildren;
            const mergedProps = {
                ...eventProps,
                visible: visible
            };
            if (!children) // No children
            motionChildren = null;
            else if (status === (0, $66016b81b7e244ad$export$de71442bbf2143da)) {
                // Stable children
                if (mergedVisible) motionChildren = children({
                    ...mergedProps
                }, nodeRef);
                else if (!removeOnLeave && renderedRef.current && leavedClassName) motionChildren = children({
                    ...mergedProps,
                    className: leavedClassName
                }, nodeRef);
                else if (forceRender || !removeOnLeave && !leavedClassName) motionChildren = children({
                    ...mergedProps,
                    style: {
                        display: 'none'
                    }
                }, nodeRef);
                else motionChildren = null;
            } else {
                // In motion
                let statusSuffix;
                if (statusStep === (0, $66016b81b7e244ad$export$1b792916a5fac4fc)) statusSuffix = 'prepare';
                else if ((0, $39762ea79d49fd4b$export$39e04e72f972b885)(statusStep)) statusSuffix = 'active';
                else if (statusStep === (0, $66016b81b7e244ad$export$9563153dd25a3ce8)) statusSuffix = 'start';
                const motionCls = (0, $b5528033a6cf1292$export$27c72201b1d09951)(motionName, `${status}-${statusSuffix}`);
                motionChildren = children({
                    ...mergedProps,
                    className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)((0, $b5528033a6cf1292$export$27c72201b1d09951)(motionName, status), {
                        [motionCls]: motionCls && statusSuffix,
                        [motionName]: typeof motionName === 'string'
                    }),
                    style: statusStyle
                }, nodeRef);
            }
            return motionChildren;
        }, [
            idRef.current
        ]);
        if ($3f18309266f0bcbd$export$35eb5aa7e3b3c295(children) && (0, $92c8c75386168ffc$export$b51ae67c7882a242)(returnNode)) {
            const originNodeRef = (0, $92c8c75386168ffc$export$7465e5c0bf44f19a)(returnNode);
            if (originNodeRef !== nodeRef) return /*#__PURE__*/ $5E6i4.cloneElement(returnNode, {
                ref: (0, $92c8c75386168ffc$export$ab452c34e8e05029)(originNodeRef, nodeRef)
            });
        }
        return returnNode;
    });
    CSSMotion.displayName = 'CSSMotion';
    return CSSMotion;
}
var $3f18309266f0bcbd$export$2e2bcd8739ae039 = $3f18309266f0bcbd$export$e265d52a86a9f199((0, $b5528033a6cf1292$export$d28133ed3ad06c8b));



var $5E6i4 = parcelRequire("5E6i4");

const $3837fe74e4576bb7$export$3904baa009bc026e = 'add';
const $3837fe74e4576bb7$export$851162f0adad2cbc = 'keep';
const $3837fe74e4576bb7$export$c8b3fb08b68cfc85 = 'remove';
const $3837fe74e4576bb7$export$2ac1bd1808d2e43a = 'removed';
function $3837fe74e4576bb7$export$c47fd798e598c85c(key) {
    let keyObj;
    if (key && typeof key === 'object' && 'key' in key) keyObj = key;
    else keyObj = {
        key: key
    };
    return {
        ...keyObj,
        key: String(keyObj.key)
    };
}
function $3837fe74e4576bb7$export$84bd7bd42ccc0f72(keys = []) {
    return keys.map($3837fe74e4576bb7$export$c47fd798e598c85c);
}
function $3837fe74e4576bb7$export$14527669107aa301(prevKeys = [], currentKeys = []) {
    let list = [];
    let currentIndex = 0;
    const currentLen = currentKeys.length;
    const prevKeyObjects = $3837fe74e4576bb7$export$84bd7bd42ccc0f72(prevKeys);
    const currentKeyObjects = $3837fe74e4576bb7$export$84bd7bd42ccc0f72(currentKeys);
    // Check prev keys to insert or keep
    prevKeyObjects.forEach((keyObj)=>{
        let hit = false;
        for(let i = currentIndex; i < currentLen; i += 1){
            const currentKeyObj = currentKeyObjects[i];
            if (currentKeyObj.key === keyObj.key) {
                // New added keys should add before current key
                if (currentIndex < i) {
                    list = list.concat(currentKeyObjects.slice(currentIndex, i).map((obj)=>({
                            ...obj,
                            status: $3837fe74e4576bb7$export$3904baa009bc026e
                        })));
                    currentIndex = i;
                }
                list.push({
                    ...currentKeyObj,
                    status: $3837fe74e4576bb7$export$851162f0adad2cbc
                });
                currentIndex += 1;
                hit = true;
                break;
            }
        }
        // If not hit, it means key is removed
        if (!hit) list.push({
            ...keyObj,
            status: $3837fe74e4576bb7$export$c8b3fb08b68cfc85
        });
    });
    // Add rest to the list
    if (currentIndex < currentLen) list = list.concat(currentKeyObjects.slice(currentIndex).map((obj)=>({
            ...obj,
            status: $3837fe74e4576bb7$export$3904baa009bc026e
        })));
    /**
   * Merge same key when it remove and add again:
   *    [1 - add, 2 - keep, 1 - remove] -> [1 - keep, 2 - keep]
   */ const keys = {};
    list.forEach(({ key: key })=>{
        keys[key] = (keys[key] || 0) + 1;
    });
    const duplicatedKeys = Object.keys(keys).filter((key)=>keys[key] > 1);
    duplicatedKeys.forEach((matchKey)=>{
        // Remove `STATUS_REMOVE` node.
        list = list.filter(({ key: key, status: status })=>key !== matchKey || status !== $3837fe74e4576bb7$export$c8b3fb08b68cfc85);
        // Update `STATUS_ADD` to `STATUS_KEEP`
        list.forEach((node)=>{
            if (node.key === matchKey) // eslint-disable-next-line no-param-reassign
            node.status = $3837fe74e4576bb7$export$851162f0adad2cbc;
        });
    });
    return list;
}



function $f8bf6ab12693d160$var$_extends() {
    $f8bf6ab12693d160$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f8bf6ab12693d160$var$_extends.apply(this, arguments);
}
const $f8bf6ab12693d160$var$MOTION_PROP_NAMES = [
    'eventProps',
    'visible',
    'children',
    'motionName',
    'motionAppear',
    'motionEnter',
    'motionLeave',
    'motionLeaveImmediately',
    'motionDeadline',
    'removeOnLeave',
    'leavedClassName',
    'onAppearPrepare',
    'onAppearStart',
    'onAppearActive',
    'onAppearEnd',
    'onEnterStart',
    'onEnterActive',
    'onEnterEnd',
    'onLeaveStart',
    'onLeaveActive',
    'onLeaveEnd'
];
function $f8bf6ab12693d160$export$fcfc62c1d33d5e2e(transitionSupport, CSSMotion = (0, $3f18309266f0bcbd$export$2e2bcd8739ae039)) {
    class CSSMotionList extends $5E6i4.Component {
        static defaultProps = {
            component: 'div'
        };
        state = {
            keyEntities: []
        };
        static getDerivedStateFromProps({ keys: keys }, { keyEntities: keyEntities }) {
            const parsedKeyObjects = (0, $3837fe74e4576bb7$export$84bd7bd42ccc0f72)(keys);
            const mixedKeyEntities = (0, $3837fe74e4576bb7$export$14527669107aa301)(keyEntities, parsedKeyObjects);
            return {
                keyEntities: mixedKeyEntities.filter((entity)=>{
                    const prevEntity = keyEntities.find(({ key: key })=>entity.key === key);
                    // Remove if already mark as removed
                    if (prevEntity && prevEntity.status === (0, $3837fe74e4576bb7$export$2ac1bd1808d2e43a) && entity.status === (0, $3837fe74e4576bb7$export$c8b3fb08b68cfc85)) return false;
                    return true;
                })
            };
        }
        // ZombieJ: Return the count of rest keys. It's safe to refactor if need more info.
        removeKey = (removeKey)=>{
            this.setState((prevState)=>{
                const nextKeyEntities = prevState.keyEntities.map((entity)=>{
                    if (entity.key !== removeKey) return entity;
                    return {
                        ...entity,
                        status: (0, $3837fe74e4576bb7$export$2ac1bd1808d2e43a)
                    };
                });
                return {
                    keyEntities: nextKeyEntities
                };
            }, ()=>{
                const { keyEntities: keyEntities } = this.state;
                const restKeysCount = keyEntities.filter(({ status: status })=>status !== (0, $3837fe74e4576bb7$export$2ac1bd1808d2e43a)).length;
                if (restKeysCount === 0 && this.props.onAllRemoved) this.props.onAllRemoved();
            });
        };
        render() {
            const { keyEntities: keyEntities } = this.state;
            const { component: component, children: children, onVisibleChanged: onVisibleChanged, onAllRemoved: onAllRemoved, ...restProps } = this.props;
            const Component = component || $5E6i4.Fragment;
            const motionProps = {};
            $f8bf6ab12693d160$var$MOTION_PROP_NAMES.forEach((prop)=>{
                motionProps[prop] = restProps[prop];
                delete restProps[prop];
            });
            delete restProps.keys;
            return /*#__PURE__*/ $5E6i4.createElement(Component, restProps, keyEntities.map(({ status: status, ...eventProps }, index)=>{
                const visible = status === (0, $3837fe74e4576bb7$export$3904baa009bc026e) || status === (0, $3837fe74e4576bb7$export$851162f0adad2cbc);
                return /*#__PURE__*/ $5E6i4.createElement(CSSMotion, $f8bf6ab12693d160$var$_extends({}, motionProps, {
                    key: eventProps.key,
                    visible: visible,
                    eventProps: eventProps,
                    onVisibleChanged: (changedVisible)=>{
                        onVisibleChanged?.(changedVisible, {
                            key: eventProps.key
                        });
                        if (!changedVisible) this.removeKey(eventProps.key);
                    }
                }), (0, $3f18309266f0bcbd$export$35eb5aa7e3b3c295)(children) ? (props)=>children({
                        ...props,
                        index: index
                    }) : (props, ref)=>children({
                        ...props,
                        index: index
                    }, ref));
            }));
        }
    }
    return CSSMotionList;
}
var $f8bf6ab12693d160$export$2e2bcd8739ae039 = $f8bf6ab12693d160$export$fcfc62c1d33d5e2e((0, $b5528033a6cf1292$export$d28133ed3ad06c8b));



var $5371a8954d0d2416$export$2e2bcd8739ae039 = (0, $3f18309266f0bcbd$export$2e2bcd8739ae039);





var $5E6i4 = parcelRequire("5E6i4");


var $5E6i4 = parcelRequire("5E6i4");
function $7053bca49fc6095a$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, align: align, arrow: arrow, arrowPos: arrowPos } = props;
    const { className: className, content: content, style: style } = arrow || {};
    const { x: x = 0, y: y = 0 } = arrowPos;
    const arrowRef = $5E6i4.useRef(null);
    // Skip if no align
    if (!align || !align.points) return null;
    const alignStyle = {
        position: 'absolute'
    };
    // Skip if no need to align
    if (align.autoArrow !== false) {
        const popupPoints = align.points[0];
        const targetPoints = align.points[1];
        const popupTB = popupPoints[0];
        const popupLR = popupPoints[1];
        const targetTB = targetPoints[0];
        const targetLR = targetPoints[1];
        // Top & Bottom
        if (popupTB === targetTB || ![
            't',
            'b'
        ].includes(popupTB)) alignStyle.top = y;
        else if (popupTB === 't') alignStyle.top = 0;
        else alignStyle.bottom = 0;
        // Left & Right
        if (popupLR === targetLR || ![
            'l',
            'r'
        ].includes(popupLR)) alignStyle.left = x;
        else if (popupLR === 'l') alignStyle.left = 0;
        else alignStyle.right = 0;
    }
    return /*#__PURE__*/ $5E6i4.createElement("div", {
        ref: arrowRef,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-arrow`, className),
        style: {
            ...alignStyle,
            ...style
        }
    }, content);
}





var $5E6i4 = parcelRequire("5E6i4");
function $16dc59509db99e06$var$_extends() {
    $16dc59509db99e06$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $16dc59509db99e06$var$_extends.apply(this, arguments);
}
function $16dc59509db99e06$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, open: open, zIndex: zIndex, mask: mask, motion: motion, mobile: mobile } = props;
    if (!mask) return null;
    return /*#__PURE__*/ $5E6i4.createElement((0, $5371a8954d0d2416$export$2e2bcd8739ae039), $16dc59509db99e06$var$_extends({}, motion, {
        motionAppear: true,
        visible: open,
        removeOnLeave: true
    }), ({ className: className })=>/*#__PURE__*/ $5E6i4.createElement("div", {
            style: {
                zIndex: zIndex
            },
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-mask`, mobile && `${prefixCls}-mobile-mask`, className)
        }));
}



var $5E6i4 = parcelRequire("5E6i4");
const $07538d1e827f4af6$var$PopupContent = /*#__PURE__*/ $5E6i4.memo(({ children: children })=>children, (_, next)=>next.cache);
var $07538d1e827f4af6$export$2e2bcd8739ae039 = $07538d1e827f4af6$var$PopupContent;


function $e8fa303303ad22da$export$2e2bcd8739ae039(isMobile, ready, open, align, offsetR, offsetB, offsetX, offsetY) {
    // >>>>> Offset
    const AUTO = 'auto';
    const offsetStyle = isMobile ? {} : {
        left: '-1000vw',
        top: '-1000vh',
        right: AUTO,
        bottom: AUTO
    };
    // Set align style
    if (!isMobile && (ready || !open)) {
        const { points: points } = align;
        const dynamicInset = align.dynamicInset || align._experimental?.dynamicInset;
        const alignRight = dynamicInset && points[0][1] === 'r';
        const alignBottom = dynamicInset && points[0][0] === 'b';
        if (alignRight) {
            offsetStyle.right = offsetR;
            offsetStyle.left = AUTO;
        } else {
            offsetStyle.left = offsetX;
            offsetStyle.right = AUTO;
        }
        if (alignBottom) {
            offsetStyle.bottom = offsetB;
            offsetStyle.top = AUTO;
        } else {
            offsetStyle.top = offsetY;
            offsetStyle.bottom = AUTO;
        }
    }
    return offsetStyle;
}


function $b9b091a0924a2fd9$var$_extends() {
    $b9b091a0924a2fd9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b9b091a0924a2fd9$var$_extends.apply(this, arguments);
}
const $b9b091a0924a2fd9$var$Popup = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { onEsc: onEsc, popup: popup, className: className, prefixCls: prefixCls, style: style, target: target, onVisibleChanged: onVisibleChanged, open: // Open
    open, keepDom: keepDom, fresh: fresh, onClick: // Click
    onClick, mask: // Mask
    mask, arrow: // Arrow
    arrow, arrowPos: arrowPos, align: align, motion: // Motion
    motion, maskMotion: maskMotion, mobile: // Mobile
    mobile, forceRender: // Portal
    forceRender, getPopupContainer: getPopupContainer, autoDestroy: autoDestroy, portal: Portal, children: children, zIndex: zIndex, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onPointerEnter: onPointerEnter, onPointerDownCapture: onPointerDownCapture, ready: ready, offsetX: offsetX, offsetY: offsetY, offsetR: offsetR, offsetB: offsetB, onAlign: onAlign, onPrepare: onPrepare, onResize: // Resize
    onResize, stretch: stretch, targetWidth: targetWidth, targetHeight: targetHeight } = props;
    const popupContent = typeof popup === 'function' ? popup() : popup;
    // We can not remove holder only when motion finished.
    const isNodeVisible = open || keepDom;
    // ========================= Mobile =========================
    const isMobile = !!mobile;
    // ========================== Mask ==========================
    const [mergedMask, mergedMaskMotion, mergedPopupMotion] = $5E6i4.useMemo(()=>{
        if (mobile) return [
            mobile.mask,
            mobile.maskMotion,
            mobile.motion
        ];
        return [
            mask,
            maskMotion,
            motion
        ];
    }, [
        mobile,
        mask,
        maskMotion,
        motion
    ]);
    // ======================= Container ========================
    const getPopupContainerNeedParams = getPopupContainer?.length > 0;
    const [show, setShow] = $5E6i4.useState(!getPopupContainer || !getPopupContainerNeedParams);
    // Delay to show since `getPopupContainer` need target element
    (0, $518ae471aa4f03a7$export$2e2bcd8739ae039)(()=>{
        if (!show && getPopupContainerNeedParams && target) setShow(true);
    }, [
        show,
        getPopupContainerNeedParams,
        target
    ]);
    // ========================= Resize =========================
    const onInternalResize = (0, $68990f4402d2f009$export$2e2bcd8739ae039)((size, ele)=>{
        onResize?.(size, ele);
        onAlign();
    });
    // ========================= Styles =========================
    const offsetStyle = (0, $e8fa303303ad22da$export$2e2bcd8739ae039)(isMobile, ready, open, align, offsetR, offsetB, offsetX, offsetY);
    // ========================= Render =========================
    if (!show) return null;
    // >>>>> Misc
    const miscStyle = {};
    if (stretch) {
        if (stretch.includes('height') && targetHeight) miscStyle.height = targetHeight;
        else if (stretch.includes('minHeight') && targetHeight) miscStyle.minHeight = targetHeight;
        if (stretch.includes('width') && targetWidth) miscStyle.width = targetWidth;
        else if (stretch.includes('minWidth') && targetWidth) miscStyle.minWidth = targetWidth;
    }
    if (!open) miscStyle.pointerEvents = 'none';
    return /*#__PURE__*/ $5E6i4.createElement(Portal, {
        open: forceRender || isNodeVisible,
        getContainer: getPopupContainer && (()=>getPopupContainer(target)),
        autoDestroy: autoDestroy,
        onEsc: onEsc
    }, /*#__PURE__*/ $5E6i4.createElement((0, $16dc59509db99e06$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        open: open,
        zIndex: zIndex,
        mask: mergedMask,
        motion: mergedMaskMotion,
        mobile: isMobile
    }), /*#__PURE__*/ $5E6i4.createElement((0, $3a396118caae8741$export$2e2bcd8739ae039), {
        onResize: onInternalResize,
        disabled: !open
    }, (resizeObserverRef)=>{
        return /*#__PURE__*/ $5E6i4.createElement((0, $5371a8954d0d2416$export$2e2bcd8739ae039), $b9b091a0924a2fd9$var$_extends({
            motionAppear: true,
            motionEnter: true,
            motionLeave: true,
            removeOnLeave: false,
            forceRender: forceRender,
            leavedClassName: `${prefixCls}-hidden`
        }, mergedPopupMotion, {
            onAppearPrepare: onPrepare,
            onEnterPrepare: onPrepare,
            visible: open,
            onVisibleChanged: (nextVisible)=>{
                motion?.onVisibleChanged?.(nextVisible);
                onVisibleChanged(nextVisible);
            }
        }), ({ className: motionClassName, style: motionStyle }, motionRef)=>{
            const cls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, motionClassName, className, {
                [`${prefixCls}-mobile`]: isMobile
            });
            return /*#__PURE__*/ $5E6i4.createElement("div", {
                ref: (0, $92c8c75386168ffc$export$ab452c34e8e05029)(resizeObserverRef, ref, motionRef),
                className: cls,
                style: {
                    '--arrow-x': `${arrowPos.x || 0}px`,
                    '--arrow-y': `${arrowPos.y || 0}px`,
                    ...offsetStyle,
                    ...miscStyle,
                    ...motionStyle,
                    boxSizing: 'border-box',
                    zIndex: zIndex,
                    ...style
                },
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onPointerEnter: onPointerEnter,
                onClick: onClick,
                onPointerDownCapture: onPointerDownCapture
            }, arrow && /*#__PURE__*/ $5E6i4.createElement((0, $7053bca49fc6095a$export$2e2bcd8739ae039), {
                prefixCls: prefixCls,
                arrow: arrow,
                arrowPos: arrowPos,
                align: align
            }), /*#__PURE__*/ $5E6i4.createElement((0, $07538d1e827f4af6$export$2e2bcd8739ae039), {
                cache: !open && !fresh
            }, popupContent));
        });
    }), children);
});
var $b9b091a0924a2fd9$export$2e2bcd8739ae039 = $b9b091a0924a2fd9$var$Popup;



var $5E6i4 = parcelRequire("5E6i4");
// ===================== Nest =====================
const $4ac507189a225ce1$var$TriggerContext = /*#__PURE__*/ $5E6i4.createContext(null);
var $4ac507189a225ce1$export$2e2bcd8739ae039 = $4ac507189a225ce1$var$TriggerContext;
const $4ac507189a225ce1$export$14cc6d12cdc906c = /*#__PURE__*/ $5E6i4.createContext(null);



var $5E6i4 = parcelRequire("5E6i4");
function $fc1d846a4d3b0b81$var$toArray(val) {
    return val ? Array.isArray(val) ? val : [
        val
    ] : [];
}
function $fc1d846a4d3b0b81$export$2e2bcd8739ae039(action, showAction, hideAction) {
    return $5E6i4.useMemo(()=>{
        const mergedShowAction = $fc1d846a4d3b0b81$var$toArray(showAction ?? action);
        const mergedHideAction = $fc1d846a4d3b0b81$var$toArray(hideAction ?? action);
        const showActionSet = new Set(mergedShowAction);
        const hideActionSet = new Set(mergedHideAction);
        if (showActionSet.has('hover') && !showActionSet.has('click')) showActionSet.add('touch');
        if (hideActionSet.has('hover') && !hideActionSet.has('click')) hideActionSet.add('touch');
        return [
            showActionSet,
            hideActionSet
        ];
    }, [
        action,
        showAction,
        hideAction
    ]);
}




var $5E6i4 = parcelRequire("5E6i4");
function $e48d6d93b0c066c3$var$isPointsEq(a1 = [], a2 = [], isAlignPoint) {
    const getVal = (a, index)=>a[index] || '';
    if (isAlignPoint) return getVal(a1, 0) === getVal(a2, 0);
    return getVal(a1, 0) === getVal(a2, 0) && getVal(a1, 1) === getVal(a2, 1);
}
function $e48d6d93b0c066c3$export$faa0aa8ed2fe6432(builtinPlacements, prefixCls, align, isAlignPoint) {
    const { points: points } = align;
    const placements = Object.keys(builtinPlacements);
    for(let i = 0; i < placements.length; i += 1){
        const placement = placements[i];
        if ($e48d6d93b0c066c3$var$isPointsEq(builtinPlacements[placement]?.points, points, isAlignPoint)) return `${prefixCls}-placement-${placement}`;
    }
    return '';
}
function $e48d6d93b0c066c3$export$9c0584a7cc24d9e(ele) {
    return ele.ownerDocument.defaultView;
}
function $e48d6d93b0c066c3$export$ba21ed9400ca485b(ele) {
    const scrollerList = [];
    let current = ele?.parentElement;
    const scrollStyle = [
        'hidden',
        'scroll',
        'clip',
        'auto'
    ];
    while(current){
        const { overflowX: overflowX, overflowY: overflowY, overflow: overflow } = $e48d6d93b0c066c3$export$9c0584a7cc24d9e(current).getComputedStyle(current);
        if ([
            overflowX,
            overflowY,
            overflow
        ].some((o)=>scrollStyle.includes(o))) scrollerList.push(current);
        current = current.parentElement;
    }
    return scrollerList;
}
function $e48d6d93b0c066c3$export$34dfc8f73bbb64ae(num, defaultValue = 1) {
    return Number.isNaN(num) ? defaultValue : num;
}
function $e48d6d93b0c066c3$var$getPxValue(val) {
    return $e48d6d93b0c066c3$export$34dfc8f73bbb64ae(parseFloat(val), 0);
}
function $e48d6d93b0c066c3$export$94be9d7985092f2d(initArea, scrollerList) {
    const visibleArea = {
        ...initArea
    };
    (scrollerList || []).forEach((ele)=>{
        if (ele instanceof HTMLBodyElement || ele instanceof HTMLHtmlElement) return;
        // Skip if static position which will not affect visible area
        const { overflow: overflow, overflowClipMargin: overflowClipMargin, borderTopWidth: borderTopWidth, borderBottomWidth: borderBottomWidth, borderLeftWidth: borderLeftWidth, borderRightWidth: borderRightWidth } = $e48d6d93b0c066c3$export$9c0584a7cc24d9e(ele).getComputedStyle(ele);
        const eleRect = ele.getBoundingClientRect();
        const { offsetHeight: eleOutHeight, clientHeight: eleInnerHeight, offsetWidth: eleOutWidth, clientWidth: eleInnerWidth } = ele;
        const borderTopNum = $e48d6d93b0c066c3$var$getPxValue(borderTopWidth);
        const borderBottomNum = $e48d6d93b0c066c3$var$getPxValue(borderBottomWidth);
        const borderLeftNum = $e48d6d93b0c066c3$var$getPxValue(borderLeftWidth);
        const borderRightNum = $e48d6d93b0c066c3$var$getPxValue(borderRightWidth);
        const scaleX = $e48d6d93b0c066c3$export$34dfc8f73bbb64ae(Math.round(eleRect.width / eleOutWidth * 1000) / 1000);
        const scaleY = $e48d6d93b0c066c3$export$34dfc8f73bbb64ae(Math.round(eleRect.height / eleOutHeight * 1000) / 1000);
        // Original visible area
        const eleScrollWidth = (eleOutWidth - eleInnerWidth - borderLeftNum - borderRightNum) * scaleX;
        const eleScrollHeight = (eleOutHeight - eleInnerHeight - borderTopNum - borderBottomNum) * scaleY;
        // Cut border size
        const scaledBorderTopWidth = borderTopNum * scaleY;
        const scaledBorderBottomWidth = borderBottomNum * scaleY;
        const scaledBorderLeftWidth = borderLeftNum * scaleX;
        const scaledBorderRightWidth = borderRightNum * scaleX;
        // Clip margin
        let clipMarginWidth = 0;
        let clipMarginHeight = 0;
        if (overflow === 'clip') {
            const clipNum = $e48d6d93b0c066c3$var$getPxValue(overflowClipMargin);
            clipMarginWidth = clipNum * scaleX;
            clipMarginHeight = clipNum * scaleY;
        }
        // Region
        const eleLeft = eleRect.x + scaledBorderLeftWidth - clipMarginWidth;
        const eleTop = eleRect.y + scaledBorderTopWidth - clipMarginHeight;
        const eleRight = eleLeft + eleRect.width + 2 * clipMarginWidth - scaledBorderLeftWidth - scaledBorderRightWidth - eleScrollWidth;
        const eleBottom = eleTop + eleRect.height + 2 * clipMarginHeight - scaledBorderTopWidth - scaledBorderBottomWidth - eleScrollHeight;
        visibleArea.left = Math.max(visibleArea.left, eleLeft);
        visibleArea.top = Math.max(visibleArea.top, eleTop);
        visibleArea.right = Math.min(visibleArea.right, eleRight);
        visibleArea.bottom = Math.min(visibleArea.bottom, eleBottom);
    });
    return visibleArea;
}


function $8e7d25ac7a452041$var$getUnitOffset(size, offset = 0) {
    const offsetStr = `${offset}`;
    const cells = offsetStr.match(/^(.*)\%$/);
    if (cells) return size * (parseFloat(cells[1]) / 100);
    return parseFloat(offsetStr);
}
function $8e7d25ac7a452041$var$getNumberOffset(rect, offset) {
    const [offsetX, offsetY] = offset || [];
    return [
        $8e7d25ac7a452041$var$getUnitOffset(rect.width, offsetX),
        $8e7d25ac7a452041$var$getUnitOffset(rect.height, offsetY)
    ];
}
function $8e7d25ac7a452041$var$splitPoints(points = '') {
    return [
        points[0],
        points[1]
    ];
}
function $8e7d25ac7a452041$var$getAlignPoint(rect, points) {
    const topBottom = points[0];
    const leftRight = points[1];
    let x;
    let y;
    // Top & Bottom
    if (topBottom === 't') y = rect.y;
    else if (topBottom === 'b') y = rect.y + rect.height;
    else y = rect.y + rect.height / 2;
    // Left & Right
    if (leftRight === 'l') x = rect.x;
    else if (leftRight === 'r') x = rect.x + rect.width;
    else x = rect.x + rect.width / 2;
    return {
        x: x,
        y: y
    };
}
function $8e7d25ac7a452041$var$reversePoints(points, index) {
    const reverseMap = {
        t: 'b',
        b: 't',
        l: 'r',
        r: 'l'
    };
    const clone = [
        ...points
    ];
    clone[index] = reverseMap[points[index]] || 'c';
    return clone;
}
function $8e7d25ac7a452041$var$flatPoints(points) {
    return points.join('');
}
function $8e7d25ac7a452041$export$2e2bcd8739ae039(open, popupEle, target, placement, builtinPlacements, popupAlign, onPopupAlign, mobile) {
    const [offsetInfo, setOffsetInfo] = $5E6i4.useState({
        ready: false,
        offsetX: 0,
        offsetY: 0,
        offsetR: 0,
        offsetB: 0,
        arrowX: 0,
        arrowY: 0,
        scaleX: 1,
        scaleY: 1,
        align: builtinPlacements[placement] || {}
    });
    const alignCountRef = $5E6i4.useRef(0);
    const scrollerList = $5E6i4.useMemo(()=>{
        if (!popupEle || mobile) return [];
        return (0, $e48d6d93b0c066c3$export$ba21ed9400ca485b)(popupEle);
    }, [
        popupEle
    ]);
    // ========================= Flip ==========================
    // We will memo flip info.
    // If size change to make flip, it will memo the flip info and use it in next align.
    const prevFlipRef = $5E6i4.useRef({});
    const resetFlipCache = ()=>{
        prevFlipRef.current = {};
    };
    if (!open) resetFlipCache();
    // ========================= Align =========================
    const onAlign = (0, $68990f4402d2f009$export$2e2bcd8739ae039)(()=>{
        if (popupEle && target && open && !mobile) {
            const popupElement = popupEle;
            const doc = popupElement.ownerDocument;
            const win = (0, $e48d6d93b0c066c3$export$9c0584a7cc24d9e)(popupElement);
            const { position: popupPosition } = win.getComputedStyle(popupElement);
            const originLeft = popupElement.style.left;
            const originTop = popupElement.style.top;
            const originRight = popupElement.style.right;
            const originBottom = popupElement.style.bottom;
            const originOverflow = popupElement.style.overflow;
            const originOverflowX = popupElement.style.overflowX;
            const originOverflowY = popupElement.style.overflowY;
            // Placement
            const placementInfo = {
                ...builtinPlacements[placement],
                ...popupAlign
            };
            // placeholder element
            const placeholderElement = doc.createElement('div');
            popupElement.parentElement?.appendChild(placeholderElement);
            placeholderElement.style.left = `${popupElement.offsetLeft}px`;
            placeholderElement.style.top = `${popupElement.offsetTop}px`;
            placeholderElement.style.position = popupPosition;
            placeholderElement.style.height = `${popupElement.offsetHeight}px`;
            placeholderElement.style.width = `${popupElement.offsetWidth}px`;
            // Reset first
            popupElement.style.left = '0';
            popupElement.style.top = '0';
            popupElement.style.right = 'auto';
            popupElement.style.bottom = 'auto';
            popupElement.style.overflow = 'hidden';
            // Calculate align style, we should consider `transform` case
            let targetRect;
            if (Array.isArray(target)) targetRect = {
                x: target[0],
                y: target[1],
                width: 0,
                height: 0
            };
            else {
                const rect = target.getBoundingClientRect();
                rect.x = rect.x ?? rect.left;
                rect.y = rect.y ?? rect.top;
                targetRect = {
                    x: rect.x,
                    y: rect.y,
                    width: rect.width,
                    height: rect.height
                };
            }
            const popupRect = popupElement.getBoundingClientRect();
            const { height: height, width: width } = win.getComputedStyle(popupElement);
            popupRect.x = popupRect.x ?? popupRect.left;
            popupRect.y = popupRect.y ?? popupRect.top;
            const { clientWidth: clientWidth, clientHeight: clientHeight, scrollWidth: scrollWidth, scrollHeight: scrollHeight, scrollTop: scrollTop, scrollLeft: scrollLeft } = doc.documentElement;
            const popupHeight = popupRect.height;
            const popupWidth = popupRect.width;
            const targetHeight = targetRect.height;
            const targetWidth = targetRect.width;
            // Get bounding of visible area
            const visibleRegion = {
                left: 0,
                top: 0,
                right: clientWidth,
                bottom: clientHeight
            };
            const scrollRegion = {
                left: -scrollLeft,
                top: -scrollTop,
                right: scrollWidth - scrollLeft,
                bottom: scrollHeight - scrollTop
            };
            let { htmlRegion: htmlRegion } = placementInfo;
            const VISIBLE = 'visible';
            const VISIBLE_FIRST = 'visibleFirst';
            if (htmlRegion !== 'scroll' && htmlRegion !== VISIBLE_FIRST) htmlRegion = VISIBLE;
            const isVisibleFirst = htmlRegion === VISIBLE_FIRST;
            const scrollRegionArea = (0, $e48d6d93b0c066c3$export$94be9d7985092f2d)(scrollRegion, scrollerList);
            const visibleRegionArea = (0, $e48d6d93b0c066c3$export$94be9d7985092f2d)(visibleRegion, scrollerList);
            const visibleArea = htmlRegion === VISIBLE ? visibleRegionArea : scrollRegionArea;
            // When set to `visibleFirst`,
            // the check `adjust` logic will use `visibleRegion` for check first.
            const adjustCheckVisibleArea = isVisibleFirst ? visibleRegionArea : visibleArea;
            // Record right & bottom align data
            popupElement.style.left = 'auto';
            popupElement.style.top = 'auto';
            popupElement.style.right = '0';
            popupElement.style.bottom = '0';
            const popupMirrorRect = popupElement.getBoundingClientRect();
            // Reset back
            popupElement.style.left = originLeft;
            popupElement.style.top = originTop;
            popupElement.style.right = originRight;
            popupElement.style.bottom = originBottom;
            popupElement.style.overflow = originOverflow;
            popupElement.style.overflowX = originOverflowX;
            popupElement.style.overflowY = originOverflowY;
            popupElement.parentElement?.removeChild(placeholderElement);
            // Calculate scale
            const scaleX = (0, $e48d6d93b0c066c3$export$34dfc8f73bbb64ae)(Math.round(popupWidth / parseFloat(width) * 1000) / 1000);
            const scaleY = (0, $e48d6d93b0c066c3$export$34dfc8f73bbb64ae)(Math.round(popupHeight / parseFloat(height) * 1000) / 1000);
            // No need to align since it's not visible in view
            if (scaleX === 0 || scaleY === 0 || (0, $b1bf69966442e513$export$41e30d8dd0ba7a50)(target) && !(0, $8fba40dfe94c55fb$export$2e2bcd8739ae039)(target)) return;
            // Offset
            const { offset: offset, targetOffset: targetOffset } = placementInfo;
            let [popupOffsetX, popupOffsetY] = $8e7d25ac7a452041$var$getNumberOffset(popupRect, offset);
            const [targetOffsetX, targetOffsetY] = $8e7d25ac7a452041$var$getNumberOffset(targetRect, targetOffset);
            targetRect.x -= targetOffsetX;
            targetRect.y -= targetOffsetY;
            // Points
            const [popupPoint, targetPoint] = placementInfo.points || [];
            const targetPoints = $8e7d25ac7a452041$var$splitPoints(targetPoint);
            const popupPoints = $8e7d25ac7a452041$var$splitPoints(popupPoint);
            const targetAlignPoint = $8e7d25ac7a452041$var$getAlignPoint(targetRect, targetPoints);
            const popupAlignPoint = $8e7d25ac7a452041$var$getAlignPoint(popupRect, popupPoints);
            // Real align info may not same as origin one
            const nextAlignInfo = {
                ...placementInfo
            };
            let nextPoints = [
                popupPoints,
                targetPoints
            ];
            // Next Offset
            let nextOffsetX = targetAlignPoint.x - popupAlignPoint.x + popupOffsetX;
            let nextOffsetY = targetAlignPoint.y - popupAlignPoint.y + popupOffsetY;
            // ============== Intersection ===============
            // Get area by position. Used for check if flip area is better
            function getIntersectionVisibleArea(offsetX, offsetY, area = visibleArea) {
                const l = popupRect.x + offsetX;
                const t = popupRect.y + offsetY;
                const r = l + popupWidth;
                const b = t + popupHeight;
                const visibleL = Math.max(l, area.left);
                const visibleT = Math.max(t, area.top);
                const visibleR = Math.min(r, area.right);
                const visibleB = Math.min(b, area.bottom);
                return Math.max(0, (visibleR - visibleL) * (visibleB - visibleT));
            }
            const originIntersectionVisibleArea = getIntersectionVisibleArea(nextOffsetX, nextOffsetY);
            // As `visibleFirst`, we prepare this for check
            const originIntersectionRecommendArea = getIntersectionVisibleArea(nextOffsetX, nextOffsetY, visibleRegionArea);
            // ========================== Overflow ===========================
            const targetAlignPointTL = $8e7d25ac7a452041$var$getAlignPoint(targetRect, [
                't',
                'l'
            ]);
            const popupAlignPointTL = $8e7d25ac7a452041$var$getAlignPoint(popupRect, [
                't',
                'l'
            ]);
            const targetAlignPointBR = $8e7d25ac7a452041$var$getAlignPoint(targetRect, [
                'b',
                'r'
            ]);
            const popupAlignPointBR = $8e7d25ac7a452041$var$getAlignPoint(popupRect, [
                'b',
                'r'
            ]);
            const overflow = placementInfo.overflow || {};
            const { adjustX: adjustX, adjustY: adjustY, shiftX: shiftX, shiftY: shiftY } = overflow;
            const supportAdjust = (val)=>{
                if (typeof val === 'boolean') return val;
                return val >= 0;
            };
            // Prepare position
            let nextPopupY;
            let nextPopupBottom;
            let nextPopupX;
            let nextPopupRight;
            function syncNextPopupPosition() {
                nextPopupY = popupRect.y + nextOffsetY;
                nextPopupBottom = nextPopupY + popupHeight;
                nextPopupX = popupRect.x + nextOffsetX;
                nextPopupRight = nextPopupX + popupWidth;
            }
            syncNextPopupPosition();
            // >>>>>>>>>> Top & Bottom
            const needAdjustY = supportAdjust(adjustY);
            const sameTB = popupPoints[0] === targetPoints[0];
            // Bottom to Top
            if (needAdjustY && popupPoints[0] === 't' && (nextPopupBottom > adjustCheckVisibleArea.bottom || prevFlipRef.current.bt)) {
                let tmpNextOffsetY = nextOffsetY;
                if (sameTB) tmpNextOffsetY -= popupHeight - targetHeight;
                else tmpNextOffsetY = targetAlignPointTL.y - popupAlignPointBR.y - popupOffsetY;
                const newVisibleArea = getIntersectionVisibleArea(nextOffsetX, tmpNextOffsetY);
                const newVisibleRecommendArea = getIntersectionVisibleArea(nextOffsetX, tmpNextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                newVisibleArea > originIntersectionVisibleArea || newVisibleArea === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                newVisibleRecommendArea >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.bt = true;
                    nextOffsetY = tmpNextOffsetY;
                    popupOffsetY = -popupOffsetY;
                    nextPoints = [
                        $8e7d25ac7a452041$var$reversePoints(nextPoints[0], 0),
                        $8e7d25ac7a452041$var$reversePoints(nextPoints[1], 0)
                    ];
                } else prevFlipRef.current.bt = false;
            }
            // Top to Bottom
            if (needAdjustY && popupPoints[0] === 'b' && (nextPopupY < adjustCheckVisibleArea.top || prevFlipRef.current.tb)) {
                let tmpNextOffsetY = nextOffsetY;
                if (sameTB) tmpNextOffsetY += popupHeight - targetHeight;
                else tmpNextOffsetY = targetAlignPointBR.y - popupAlignPointTL.y - popupOffsetY;
                const newVisibleArea = getIntersectionVisibleArea(nextOffsetX, tmpNextOffsetY);
                const newVisibleRecommendArea = getIntersectionVisibleArea(nextOffsetX, tmpNextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                newVisibleArea > originIntersectionVisibleArea || newVisibleArea === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                newVisibleRecommendArea >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.tb = true;
                    nextOffsetY = tmpNextOffsetY;
                    popupOffsetY = -popupOffsetY;
                    nextPoints = [
                        $8e7d25ac7a452041$var$reversePoints(nextPoints[0], 0),
                        $8e7d25ac7a452041$var$reversePoints(nextPoints[1], 0)
                    ];
                } else prevFlipRef.current.tb = false;
            }
            // >>>>>>>>>> Left & Right
            const needAdjustX = supportAdjust(adjustX);
            // >>>>> Flip
            const sameLR = popupPoints[1] === targetPoints[1];
            // Right to Left
            if (needAdjustX && popupPoints[1] === 'l' && (nextPopupRight > adjustCheckVisibleArea.right || prevFlipRef.current.rl)) {
                let tmpNextOffsetX = nextOffsetX;
                if (sameLR) tmpNextOffsetX -= popupWidth - targetWidth;
                else tmpNextOffsetX = targetAlignPointTL.x - popupAlignPointBR.x - popupOffsetX;
                const newVisibleArea = getIntersectionVisibleArea(tmpNextOffsetX, nextOffsetY);
                const newVisibleRecommendArea = getIntersectionVisibleArea(tmpNextOffsetX, nextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                newVisibleArea > originIntersectionVisibleArea || newVisibleArea === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                newVisibleRecommendArea >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.rl = true;
                    nextOffsetX = tmpNextOffsetX;
                    popupOffsetX = -popupOffsetX;
                    nextPoints = [
                        $8e7d25ac7a452041$var$reversePoints(nextPoints[0], 1),
                        $8e7d25ac7a452041$var$reversePoints(nextPoints[1], 1)
                    ];
                } else prevFlipRef.current.rl = false;
            }
            // Left to Right
            if (needAdjustX && popupPoints[1] === 'r' && (nextPopupX < adjustCheckVisibleArea.left || prevFlipRef.current.lr)) {
                let tmpNextOffsetX = nextOffsetX;
                if (sameLR) tmpNextOffsetX += popupWidth - targetWidth;
                else tmpNextOffsetX = targetAlignPointBR.x - popupAlignPointTL.x - popupOffsetX;
                const newVisibleArea = getIntersectionVisibleArea(tmpNextOffsetX, nextOffsetY);
                const newVisibleRecommendArea = getIntersectionVisibleArea(tmpNextOffsetX, nextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                newVisibleArea > originIntersectionVisibleArea || newVisibleArea === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                newVisibleRecommendArea >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.lr = true;
                    nextOffsetX = tmpNextOffsetX;
                    popupOffsetX = -popupOffsetX;
                    nextPoints = [
                        $8e7d25ac7a452041$var$reversePoints(nextPoints[0], 1),
                        $8e7d25ac7a452041$var$reversePoints(nextPoints[1], 1)
                    ];
                } else prevFlipRef.current.lr = false;
            }
            nextAlignInfo.points = [
                $8e7d25ac7a452041$var$flatPoints(nextPoints[0]),
                $8e7d25ac7a452041$var$flatPoints(nextPoints[1])
            ];
            // ============================ Shift ============================
            syncNextPopupPosition();
            const numShiftX = shiftX === true ? 0 : shiftX;
            if (typeof numShiftX === 'number') {
                // Left
                if (nextPopupX < visibleRegionArea.left) {
                    nextOffsetX -= nextPopupX - visibleRegionArea.left - popupOffsetX;
                    if (targetRect.x + targetWidth < visibleRegionArea.left + numShiftX) nextOffsetX += targetRect.x - visibleRegionArea.left + targetWidth - numShiftX;
                }
                // Right
                if (nextPopupRight > visibleRegionArea.right) {
                    nextOffsetX -= nextPopupRight - visibleRegionArea.right - popupOffsetX;
                    if (targetRect.x > visibleRegionArea.right - numShiftX) nextOffsetX += targetRect.x - visibleRegionArea.right + numShiftX;
                }
            }
            const numShiftY = shiftY === true ? 0 : shiftY;
            if (typeof numShiftY === 'number') {
                // Top
                if (nextPopupY < visibleRegionArea.top) {
                    nextOffsetY -= nextPopupY - visibleRegionArea.top - popupOffsetY;
                    // When target if far away from visible area
                    // Stop shift
                    if (targetRect.y + targetHeight < visibleRegionArea.top + numShiftY) nextOffsetY += targetRect.y - visibleRegionArea.top + targetHeight - numShiftY;
                }
                // Bottom
                if (nextPopupBottom > visibleRegionArea.bottom) {
                    nextOffsetY -= nextPopupBottom - visibleRegionArea.bottom - popupOffsetY;
                    if (targetRect.y > visibleRegionArea.bottom - numShiftY) nextOffsetY += targetRect.y - visibleRegionArea.bottom + numShiftY;
                }
            }
            // ============================ Arrow ============================
            // Arrow center align
            const popupLeft = popupRect.x + nextOffsetX;
            const popupRight = popupLeft + popupWidth;
            const popupTop = popupRect.y + nextOffsetY;
            const popupBottom = popupTop + popupHeight;
            const targetLeft = targetRect.x;
            const targetRight = targetLeft + targetWidth;
            const targetTop = targetRect.y;
            const targetBottom = targetTop + targetHeight;
            /** Max left of the popup and target element */ const maxLeft = Math.max(popupLeft, targetLeft);
            /** Min right of the popup and target element */ const minRight = Math.min(popupRight, targetRight);
            /** The center X of popup & target cross area */ const xCenter = (maxLeft + minRight) / 2;
            /** Arrow X of popup offset */ const nextArrowX = xCenter - popupLeft;
            const maxTop = Math.max(popupTop, targetTop);
            const minBottom = Math.min(popupBottom, targetBottom);
            const yCenter = (maxTop + minBottom) / 2;
            const nextArrowY = yCenter - popupTop;
            onPopupAlign?.(popupEle, nextAlignInfo);
            // Additional calculate right & bottom position
            let offsetX4Right = popupMirrorRect.right - popupRect.x - (nextOffsetX + popupRect.width);
            let offsetY4Bottom = popupMirrorRect.bottom - popupRect.y - (nextOffsetY + popupRect.height);
            if (scaleX === 1) {
                nextOffsetX = Math.floor(nextOffsetX);
                offsetX4Right = Math.floor(offsetX4Right);
            }
            if (scaleY === 1) {
                nextOffsetY = Math.floor(nextOffsetY);
                offsetY4Bottom = Math.floor(offsetY4Bottom);
            }
            const nextOffsetInfo = {
                ready: true,
                offsetX: nextOffsetX / scaleX,
                offsetY: nextOffsetY / scaleY,
                offsetR: offsetX4Right / scaleX,
                offsetB: offsetY4Bottom / scaleY,
                arrowX: nextArrowX / scaleX,
                arrowY: nextArrowY / scaleY,
                scaleX: scaleX,
                scaleY: scaleY,
                align: nextAlignInfo
            };
            setOffsetInfo(nextOffsetInfo);
        }
    });
    const triggerAlign = ()=>{
        alignCountRef.current += 1;
        const id = alignCountRef.current;
        // Merge all align requirement into one frame
        Promise.resolve().then(()=>{
            if (alignCountRef.current === id) onAlign();
        });
    };
    // Reset ready status when placement & open changed
    const resetReady = ()=>{
        setOffsetInfo((ori)=>({
                ...ori,
                ready: false
            }));
    };
    (0, $518ae471aa4f03a7$export$2e2bcd8739ae039)(resetReady, [
        placement
    ]);
    (0, $518ae471aa4f03a7$export$2e2bcd8739ae039)(()=>{
        if (!open) resetReady();
    }, [
        open
    ]);
    return [
        offsetInfo.ready,
        offsetInfo.offsetX,
        offsetInfo.offsetY,
        offsetInfo.offsetR,
        offsetInfo.offsetB,
        offsetInfo.arrowX,
        offsetInfo.arrowY,
        offsetInfo.scaleX,
        offsetInfo.scaleY,
        offsetInfo.align,
        triggerAlign
    ];
}



var $5E6i4 = parcelRequire("5E6i4");
function $a181930df18db445$export$2e2bcd8739ae039() {
    const delayRef = $5E6i4.useRef(null);
    const clearDelay = ()=>{
        if (delayRef.current) {
            clearTimeout(delayRef.current);
            delayRef.current = null;
        }
    };
    const delayInvoke = (callback, delay)=>{
        clearDelay();
        if (delay === 0) callback();
        else delayRef.current = setTimeout(()=>{
            callback();
        }, delay * 1000);
    };
    // Clean up on unmount
    $5E6i4.useEffect(()=>{
        return ()=>{
            clearDelay();
        };
    }, []);
    return delayInvoke;
}




function $2acd4d9905f7e353$export$2e2bcd8739ae039(open, target, popup, onAlign, onScroll) {
    (0, $518ae471aa4f03a7$export$2e2bcd8739ae039)(()=>{
        if (open && target && popup) {
            const targetElement = target;
            const popupElement = popup;
            const targetScrollList = (0, $e48d6d93b0c066c3$export$ba21ed9400ca485b)(targetElement);
            const popupScrollList = (0, $e48d6d93b0c066c3$export$ba21ed9400ca485b)(popupElement);
            const win = (0, $e48d6d93b0c066c3$export$9c0584a7cc24d9e)(popupElement);
            const mergedList = new Set([
                win,
                ...targetScrollList,
                ...popupScrollList
            ]);
            function notifyScroll() {
                onAlign();
                onScroll();
            }
            mergedList.forEach((scroller)=>{
                scroller.addEventListener('scroll', notifyScroll, {
                    passive: true
                });
            });
            win.addEventListener('resize', notifyScroll, {
                passive: true
            });
            // First time always do align
            onAlign();
            return ()=>{
                mergedList.forEach((scroller)=>{
                    scroller.removeEventListener('scroll', notifyScroll);
                    win.removeEventListener('resize', notifyScroll);
                });
            };
        }
    }, [
        open,
        target,
        popup
    ]);
}




var $5E6i4 = parcelRequire("5E6i4");

function $242375f1e62616ff$export$2e2bcd8739ae039(open, clickToHide, targetEle, popupEle, mask, maskClosable, inPopupOrChild, triggerOpen) {
    const openRef = $5E6i4.useRef(open);
    openRef.current = open;
    const popupPointerDownRef = $5E6i4.useRef(false);
    // Click to hide is special action since click popup element should not hide
    $5E6i4.useEffect(()=>{
        if (clickToHide && popupEle && (!mask || maskClosable)) {
            const onPointerDown = ()=>{
                popupPointerDownRef.current = false;
            };
            const onTriggerClose = (e)=>{
                if (openRef.current && !inPopupOrChild(e.composedPath?.()?.[0] || e.target) && !popupPointerDownRef.current) triggerOpen(false);
            };
            const win = (0, $e48d6d93b0c066c3$export$9c0584a7cc24d9e)(popupEle);
            win.addEventListener('pointerdown', onPointerDown, true);
            win.addEventListener('mousedown', onTriggerClose, true);
            win.addEventListener('contextmenu', onTriggerClose, true);
            // shadow root
            const targetShadowRoot = (0, $dc7bf2dd018fbbed$export$70e8259662bb498b)(targetEle);
            if (targetShadowRoot) {
                targetShadowRoot.addEventListener('mousedown', onTriggerClose, true);
                targetShadowRoot.addEventListener('contextmenu', onTriggerClose, true);
            }
            return ()=>{
                win.removeEventListener('pointerdown', onPointerDown, true);
                win.removeEventListener('mousedown', onTriggerClose, true);
                win.removeEventListener('contextmenu', onTriggerClose, true);
                if (targetShadowRoot) {
                    targetShadowRoot.removeEventListener('mousedown', onTriggerClose, true);
                    targetShadowRoot.removeEventListener('contextmenu', onTriggerClose, true);
                }
            };
        }
    }, [
        clickToHide,
        targetEle,
        popupEle,
        mask,
        maskClosable
    ]);
    function onPopupPointerDown() {
        popupPointerDownRef.current = true;
    }
    return onPopupPointerDown;
}




var $5E6i4 = parcelRequire("5E6i4");







var $5E6i4 = parcelRequire("5E6i4");

function $90e5120b28407ee5$export$2e2bcd8739ae039() {
    const [options, setOptions] = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useState(null);
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useState(false);
    const [isAnimating, setIsAnimating] = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useState(false);
    const pendingOptionsRef = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useRef(null);
    const trigger = (0, $68990f4402d2f009$export$2e2bcd8739ae039)((nextOptions)=>{
        if (nextOptions === false) {
            // Clear pending options when hiding
            pendingOptionsRef.current = null;
            setOpen(false);
        } else if (isAnimating && open) // If animating (appear or enter), cache new options
        pendingOptionsRef.current = nextOptions;
        else {
            setOpen(true);
            // Set new options
            setOptions(nextOptions);
            pendingOptionsRef.current = null;
            // Only mark as animating when transitioning from closed to open
            if (!open) setIsAnimating(true);
        }
    });
    const onVisibleChanged = (0, $68990f4402d2f009$export$2e2bcd8739ae039)((visible)=>{
        if (visible) {
            // Animation enter completed, check if there are pending options
            setIsAnimating(false);
            if (pendingOptionsRef.current) {
                // Apply pending options
                setOptions(pendingOptionsRef.current);
                pendingOptionsRef.current = null;
            }
        } else {
            // Animation leave completed
            setIsAnimating(false);
            pendingOptionsRef.current = null;
        }
    });
    return [
        trigger,
        open,
        options,
        onVisibleChanged
    ];
}



var $5E6i4 = parcelRequire("5E6i4");



function $4cc13d054cbce725$var$_extends() {
    $4cc13d054cbce725$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4cc13d054cbce725$var$_extends.apply(this, arguments);
}
const $4cc13d054cbce725$var$UniqueContainer = (props)=>{
    const { prefixCls: prefixCls, isMobile: isMobile, ready: ready, open: open, align: align, offsetR: offsetR, offsetB: offsetB, offsetX: offsetX, offsetY: offsetY, arrowPos: arrowPos, popupSize: popupSize, motion: motion, uniqueContainerClassName: uniqueContainerClassName, uniqueContainerStyle: uniqueContainerStyle } = props;
    const containerCls = `${prefixCls}-unique-container`;
    const [motionVisible, setMotionVisible] = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useState(false);
    // ========================= Styles =========================
    const offsetStyle = (0, $e8fa303303ad22da$export$2e2bcd8739ae039)(isMobile, ready, open, align, offsetR, offsetB, offsetX, offsetY);
    // Cache for offsetStyle when ready is true
    const cachedOffsetStyleRef = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useRef(offsetStyle);
    // Update cached offset style when ready is true
    if (ready) cachedOffsetStyleRef.current = offsetStyle;
    // Apply popup size if available
    const sizeStyle = {};
    if (popupSize) {
        sizeStyle.width = popupSize.width;
        sizeStyle.height = popupSize.height;
    }
    // ========================= Render =========================
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $5371a8954d0d2416$export$2e2bcd8739ae039), $4cc13d054cbce725$var$_extends({
        motionAppear: true,
        motionEnter: true,
        motionLeave: true,
        removeOnLeave: false,
        leavedClassName: `${containerCls}-hidden`
    }, motion, {
        visible: open,
        onVisibleChanged: (nextVisible)=>{
            setMotionVisible(nextVisible);
        }
    }), ({ className: motionClassName, style: motionStyle })=>{
        const cls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(containerCls, motionClassName, uniqueContainerClassName, {
            [`${containerCls}-visible`]: motionVisible
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("div", {
            className: cls,
            style: {
                '--arrow-x': `${arrowPos?.x || 0}px`,
                '--arrow-y': `${arrowPos?.y || 0}px`,
                ...cachedOffsetStyleRef.current,
                ...sizeStyle,
                ...motionStyle,
                ...uniqueContainerStyle
            }
        });
    });
};
var $4cc13d054cbce725$export$2e2bcd8739ae039 = $4cc13d054cbce725$var$UniqueContainer;




const $c4cf75225b4fa0d1$var$UniqueProvider = ({ children: children, postTriggerProps: postTriggerProps })=>{
    const [trigger, open, options, onTargetVisibleChanged] = (0, $90e5120b28407ee5$export$2e2bcd8739ae039)();
    // ========================== Options ===========================
    const mergedOptions = $5E6i4.useMemo(()=>{
        if (!options || !postTriggerProps) return options;
        return postTriggerProps(options);
    }, [
        options,
        postTriggerProps
    ]);
    // =========================== Popup ============================
    const [popupEle, setPopupEle] = $5E6i4.useState(null);
    const [popupSize, setPopupSize] = $5E6i4.useState(null);
    // Used for forwardRef popup. Not use internal
    const externalPopupRef = $5E6i4.useRef(null);
    const setPopupRef = (0, $68990f4402d2f009$export$2e2bcd8739ae039)((node)=>{
        externalPopupRef.current = node;
        if ((0, $b1bf69966442e513$export$41e30d8dd0ba7a50)(node) && popupEle !== node) setPopupEle(node);
    });
    // ========================== Register ==========================
    // Store the isOpen function from the latest show call
    const isOpenRef = $5E6i4.useRef(null);
    const delayInvoke = (0, $a181930df18db445$export$2e2bcd8739ae039)();
    const show = (0, $68990f4402d2f009$export$2e2bcd8739ae039)((showOptions, isOpen)=>{
        // Store the isOpen function for later use in hide
        isOpenRef.current = isOpen;
        delayInvoke(()=>{
            trigger(showOptions);
        }, showOptions.delay);
    });
    const hide = (delay)=>{
        delayInvoke(()=>{
            // Check if we should still hide by calling the isOpen function
            // If isOpen returns true, it means another trigger wants to keep it open
            if (isOpenRef.current?.()) return; // Don't hide if something else wants it open
            trigger(false);
        // Don't clear target, currentNode, options immediately, wait until animation completes
        }, delay);
    };
    // Callback after animation completes
    const onVisibleChanged = (0, $68990f4402d2f009$export$2e2bcd8739ae039)((visible)=>{
        // Call useTargetState callback to handle animation state
        onTargetVisibleChanged(visible);
    });
    // =========================== Align ============================
    const [ready, offsetX, offsetY, offsetR, offsetB, arrowX, arrowY, , , // scaleY - not used in UniqueProvider
    alignInfo, onAlign] = (0, $8e7d25ac7a452041$export$2e2bcd8739ae039)(open, popupEle, mergedOptions?.target, mergedOptions?.popupPlacement, mergedOptions?.builtinPlacements || {}, mergedOptions?.popupAlign, undefined, // onPopupAlign
    false // isMobile
    );
    const alignedClassName = $5E6i4.useMemo(()=>{
        if (!mergedOptions) return '';
        const baseClassName = (0, $e48d6d93b0c066c3$export$faa0aa8ed2fe6432)(mergedOptions.builtinPlacements || {}, mergedOptions.prefixCls || '', alignInfo, false // alignPoint is false for UniqueProvider
        );
        return (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(baseClassName, mergedOptions.getPopupClassNameFromAlign?.(alignInfo));
    }, [
        alignInfo,
        mergedOptions?.getPopupClassNameFromAlign,
        mergedOptions?.builtinPlacements,
        mergedOptions?.prefixCls
    ]);
    const contextValue = $5E6i4.useMemo(()=>({
            show: show,
            hide: hide
        }), []);
    // =========================== Align ============================
    $5E6i4.useEffect(()=>{
        onAlign();
    }, [
        mergedOptions?.target
    ]);
    // =========================== Motion ===========================
    const onPrepare = (0, $68990f4402d2f009$export$2e2bcd8739ae039)(()=>{
        onAlign();
        return Promise.resolve();
    });
    // ======================== Trigger Context =====================
    const subPopupElements = $5E6i4.useRef({});
    const parentContext = $5E6i4.useContext((0, $4ac507189a225ce1$export$2e2bcd8739ae039));
    const triggerContextValue = $5E6i4.useMemo(()=>({
            registerSubPopup: (id, subPopupEle)=>{
                subPopupElements.current[id] = subPopupEle;
                parentContext?.registerSubPopup(id, subPopupEle);
            }
        }), [
        parentContext
    ]);
    // =========================== Render ===========================
    const prefixCls = mergedOptions?.prefixCls;
    return /*#__PURE__*/ $5E6i4.createElement((0, $4ac507189a225ce1$export$14cc6d12cdc906c).Provider, {
        value: contextValue
    }, children, mergedOptions && /*#__PURE__*/ $5E6i4.createElement((0, $4ac507189a225ce1$export$2e2bcd8739ae039).Provider, {
        value: triggerContextValue
    }, /*#__PURE__*/ $5E6i4.createElement((0, $b9b091a0924a2fd9$export$2e2bcd8739ae039), {
        ref: setPopupRef,
        portal: (0, $bd882e1916f36420$export$2e2bcd8739ae039),
        onEsc: mergedOptions.onEsc,
        prefixCls: prefixCls,
        popup: mergedOptions.popup,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(mergedOptions.popupClassName, alignedClassName, `${prefixCls}-unique-controlled`),
        style: mergedOptions.popupStyle,
        target: mergedOptions.target,
        open: open,
        keepDom: true,
        fresh: true,
        autoDestroy: false,
        onVisibleChanged: onVisibleChanged,
        ready: ready,
        offsetX: offsetX,
        offsetY: offsetY,
        offsetR: offsetR,
        offsetB: offsetB,
        onAlign: onAlign,
        onPrepare: onPrepare,
        onResize: (size)=>setPopupSize({
                width: size.offsetWidth,
                height: size.offsetHeight
            }),
        arrowPos: {
            x: arrowX,
            y: arrowY
        },
        align: alignInfo,
        zIndex: mergedOptions.zIndex,
        mask: mergedOptions.mask,
        arrow: mergedOptions.arrow,
        motion: mergedOptions.popupMotion,
        maskMotion: mergedOptions.maskMotion,
        getPopupContainer: mergedOptions.getPopupContainer
    }, /*#__PURE__*/ $5E6i4.createElement((0, $4cc13d054cbce725$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        isMobile: false,
        ready: ready,
        open: open,
        align: alignInfo,
        offsetR: offsetR,
        offsetB: offsetB,
        offsetX: offsetX,
        offsetY: offsetY,
        arrowPos: {
            x: arrowX,
            y: arrowY
        },
        popupSize: popupSize,
        motion: mergedOptions.popupMotion,
        uniqueContainerClassName: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(mergedOptions.uniqueContainerClassName, alignedClassName),
        uniqueContainerStyle: mergedOptions.uniqueContainerStyle
    }))));
};
var $c4cf75225b4fa0d1$export$2e2bcd8739ae039 = $c4cf75225b4fa0d1$var$UniqueProvider;



var $ibUU1 = parcelRequire("ibUU1");
function $5ff8ad2f21affc17$export$55e99723d7f71b47(PortalComponent = (0, $bd882e1916f36420$export$2e2bcd8739ae039)) {
    const Trigger = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
        const { prefixCls: prefixCls = 'rc-trigger-popup', children: children, action: // Action
        action = 'hover', showAction: showAction, hideAction: hideAction, disabled: disabled = false, popupVisible: // Open
        popupVisible, defaultPopupVisible: defaultPopupVisible, onOpenChange: onOpenChange, afterOpenChange: afterOpenChange, onPopupVisibleChange: onPopupVisibleChange, afterPopupVisibleChange: afterPopupVisibleChange, mouseEnterDelay: // Delay
        mouseEnterDelay, mouseLeaveDelay: mouseLeaveDelay = 0.1, focusDelay: focusDelay, blurDelay: blurDelay, mask: // Mask
        mask, maskClosable: maskClosable = true, getPopupContainer: // Portal
        getPopupContainer, forceRender: forceRender, autoDestroy: autoDestroy, popup: // Popup
        popup, popupClassName: popupClassName, uniqueContainerClassName: uniqueContainerClassName, uniqueContainerStyle: uniqueContainerStyle, popupStyle: popupStyle, popupPlacement: popupPlacement, builtinPlacements: builtinPlacements = {}, popupAlign: popupAlign, zIndex: zIndex, stretch: stretch, getPopupClassNameFromAlign: getPopupClassNameFromAlign, fresh: fresh, unique: unique, alignPoint: alignPoint, onPopupClick: onPopupClick, onPopupAlign: onPopupAlign, arrow: // Arrow
        arrow, popupMotion: // Motion
        popupMotion, maskMotion: maskMotion, mobile: // Private
        mobile, ...restProps } = props;
        const mergedAutoDestroy = autoDestroy || false;
        const openUncontrolled = popupVisible === undefined;
        // =========================== Mobile ===========================
        const isMobile = !!mobile;
        // ========================== Context ===========================
        const subPopupElements = $5E6i4.useRef({});
        const parentContext = $5E6i4.useContext((0, $4ac507189a225ce1$export$2e2bcd8739ae039));
        const context = $5E6i4.useMemo(()=>{
            return {
                registerSubPopup: (id, subPopupEle)=>{
                    subPopupElements.current[id] = subPopupEle;
                    parentContext?.registerSubPopup(id, subPopupEle);
                }
            };
        }, [
            parentContext
        ]);
        // ======================== UniqueContext =========================
        const uniqueContext = $5E6i4.useContext((0, $4ac507189a225ce1$export$14cc6d12cdc906c));
        // =========================== Popup ============================
        const id = (0, $378d6dcdebc6b864$export$2e2bcd8739ae039)();
        const [popupEle, setPopupEle] = $5E6i4.useState(null);
        // Used for forwardRef popup. Not use internal
        const externalPopupRef = $5E6i4.useRef(null);
        const setPopupRef = (0, $68990f4402d2f009$export$2e2bcd8739ae039)((node)=>{
            externalPopupRef.current = node;
            if ((0, $b1bf69966442e513$export$41e30d8dd0ba7a50)(node) && popupEle !== node) setPopupEle(node);
            parentContext?.registerSubPopup(id, node);
        });
        // =========================== Target ===========================
        // Use state to control here since `useRef` update not trigger render
        const [targetEle, setTargetEle] = $5E6i4.useState(null);
        // Used for forwardRef target. Not use internal
        const externalForwardRef = $5E6i4.useRef(null);
        const setTargetRef = (0, $68990f4402d2f009$export$2e2bcd8739ae039)((node)=>{
            const domNode = (0, $b1bf69966442e513$export$9aa546fdc20ae5b3)(node);
            if ((0, $b1bf69966442e513$export$41e30d8dd0ba7a50)(domNode) && targetEle !== domNode) {
                setTargetEle(domNode);
                externalForwardRef.current = domNode;
            }
        });
        const cloneProps = {};
        const inPopupOrChild = (0, $68990f4402d2f009$export$2e2bcd8739ae039)((ele)=>{
            const childDOM = targetEle;
            return childDOM?.contains(ele) || (0, $dc7bf2dd018fbbed$export$70e8259662bb498b)(childDOM)?.host === ele || ele === childDOM || popupEle?.contains(ele) || (0, $dc7bf2dd018fbbed$export$70e8259662bb498b)(popupEle)?.host === ele || ele === popupEle || Object.values(subPopupElements.current).some((subPopupEle)=>subPopupEle?.contains(ele) || ele === subPopupEle);
        });
        // =========================== Arrow ============================
        const innerArrow = arrow ? {
            // true and Object likely
            ...arrow !== true ? arrow : {}
        } : null;
        // ============================ Open ============================
        const [internalOpen, setInternalOpen] = (0, $e18df22f16a16360$export$2e2bcd8739ae039)(defaultPopupVisible || false, popupVisible);
        const rawOpen = internalOpen || false;
        const mergedOpen = rawOpen && !disabled;
        // ========================== Children ==========================
        const child = $5E6i4.useMemo(()=>{
            const nextChild = typeof children === 'function' ? children({
                open: mergedOpen
            }) : children;
            return $5E6i4.Children.only(nextChild);
        }, [
            children,
            mergedOpen
        ]);
        const originChildProps = child?.props || {};
        // Support ref
        const isOpen = (0, $68990f4402d2f009$export$2e2bcd8739ae039)(()=>mergedOpen);
        // Extract common options for UniqueProvider
        const getUniqueOptions = (0, $68990f4402d2f009$export$2e2bcd8739ae039)((delay = 0)=>({
                popup: popup,
                target: targetEle,
                delay: delay,
                prefixCls: prefixCls,
                popupClassName: popupClassName,
                uniqueContainerClassName: uniqueContainerClassName,
                uniqueContainerStyle: uniqueContainerStyle,
                popupStyle: popupStyle,
                popupPlacement: popupPlacement,
                builtinPlacements: builtinPlacements,
                popupAlign: popupAlign,
                zIndex: zIndex,
                mask: mask,
                maskClosable: maskClosable,
                popupMotion: popupMotion,
                maskMotion: maskMotion,
                arrow: innerArrow,
                getPopupContainer: getPopupContainer,
                getPopupClassNameFromAlign: getPopupClassNameFromAlign,
                id: id,
                onEsc: onEsc
            }));
        // Handle controlled state changes for UniqueProvider
        // Only sync to UniqueProvider when it's controlled mode
        // If there is a parentContext, don't call uniqueContext methods
        (0, $518ae471aa4f03a7$export$2e2bcd8739ae039)(()=>{
            if (uniqueContext && unique && targetEle && !openUncontrolled && !parentContext) {
                if (mergedOpen) uniqueContext.show(getUniqueOptions(mouseEnterDelay), isOpen);
                else uniqueContext.hide(mouseLeaveDelay);
            }
        }, [
            mergedOpen,
            targetEle
        ]);
        const openRef = $5E6i4.useRef(mergedOpen);
        openRef.current = mergedOpen;
        const internalTriggerOpen = (0, $68990f4402d2f009$export$2e2bcd8739ae039)((nextOpen)=>{
            (0, $ibUU1.flushSync)(()=>{
                if (rawOpen !== nextOpen) {
                    setInternalOpen(nextOpen);
                    onOpenChange?.(nextOpen);
                    onPopupVisibleChange?.(nextOpen);
                }
            });
        });
        // Trigger for delay
        const delayInvoke = (0, $a181930df18db445$export$2e2bcd8739ae039)();
        const triggerOpen = (nextOpen, delay = 0)=>{
            // If it's controlled mode, always use internal trigger logic
            // UniqueProvider will be synced through useLayoutEffect
            if (popupVisible !== undefined) {
                delayInvoke(()=>{
                    internalTriggerOpen(nextOpen);
                }, delay);
                return;
            }
            // If UniqueContext exists and not controlled, pass delay to Provider instead of handling it internally
            // If there is a parentContext, don't call uniqueContext methods
            if (uniqueContext && unique && openUncontrolled && !parentContext) {
                if (nextOpen) uniqueContext.show(getUniqueOptions(delay), isOpen);
                else uniqueContext.hide(delay);
                return;
            }
            delayInvoke(()=>{
                internalTriggerOpen(nextOpen);
            }, delay);
        };
        function onEsc({ top: top }) {
            if (top) triggerOpen(false);
        }
        // ========================== Motion ============================
        const [inMotion, setInMotion] = $5E6i4.useState(false);
        (0, $518ae471aa4f03a7$export$2e2bcd8739ae039)((firstMount)=>{
            if (!firstMount || mergedOpen) setInMotion(true);
        }, [
            mergedOpen
        ]);
        const [motionPrepareResolve, setMotionPrepareResolve] = $5E6i4.useState(null);
        // =========================== Align ============================
        const [mousePos, setMousePos] = $5E6i4.useState(null);
        const setMousePosByEvent = (event)=>{
            setMousePos([
                event.clientX,
                event.clientY
            ]);
        };
        const [ready, offsetX, offsetY, offsetR, offsetB, arrowX, arrowY, scaleX, scaleY, alignInfo, onAlign] = (0, $8e7d25ac7a452041$export$2e2bcd8739ae039)(mergedOpen, popupEle, alignPoint && mousePos !== null ? mousePos : targetEle, popupPlacement, builtinPlacements, popupAlign, onPopupAlign, isMobile);
        const [showActions, hideActions] = (0, $fc1d846a4d3b0b81$export$2e2bcd8739ae039)(action, showAction, hideAction);
        const clickToShow = showActions.has('click');
        const clickToHide = hideActions.has('click') || hideActions.has('contextMenu');
        const triggerAlign = (0, $68990f4402d2f009$export$2e2bcd8739ae039)(()=>{
            if (!inMotion) onAlign();
        });
        const onScroll = ()=>{
            if (openRef.current && alignPoint && clickToHide) triggerOpen(false);
        };
        (0, $2acd4d9905f7e353$export$2e2bcd8739ae039)(mergedOpen, targetEle, popupEle, triggerAlign, onScroll);
        (0, $518ae471aa4f03a7$export$2e2bcd8739ae039)(()=>{
            triggerAlign();
        }, [
            mousePos,
            popupPlacement
        ]);
        // When no builtinPlacements and popupAlign changed
        (0, $518ae471aa4f03a7$export$2e2bcd8739ae039)(()=>{
            if (mergedOpen && !builtinPlacements?.[popupPlacement]) triggerAlign();
        }, [
            JSON.stringify(popupAlign)
        ]);
        const alignedClassName = $5E6i4.useMemo(()=>{
            const baseClassName = (0, $e48d6d93b0c066c3$export$faa0aa8ed2fe6432)(builtinPlacements, prefixCls, alignInfo, alignPoint);
            return (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(baseClassName, getPopupClassNameFromAlign?.(alignInfo));
        }, [
            alignInfo,
            getPopupClassNameFromAlign,
            builtinPlacements,
            prefixCls,
            alignPoint
        ]);
        // ============================ Refs ============================
        $5E6i4.useImperativeHandle(ref, ()=>({
                nativeElement: externalForwardRef.current,
                popupElement: externalPopupRef.current,
                forceAlign: triggerAlign
            }));
        // ========================== Stretch ===========================
        const [targetWidth, setTargetWidth] = $5E6i4.useState(0);
        const [targetHeight, setTargetHeight] = $5E6i4.useState(0);
        const syncTargetSize = ()=>{
            if (stretch && targetEle) {
                const rect = targetEle.getBoundingClientRect();
                setTargetWidth(rect.width);
                setTargetHeight(rect.height);
            }
        };
        const onTargetResize = ()=>{
            syncTargetSize();
            triggerAlign();
        };
        // ========================== Motion ============================
        const onVisibleChanged = (visible)=>{
            setInMotion(false);
            onAlign();
            afterOpenChange?.(visible);
            afterPopupVisibleChange?.(visible);
        };
        // We will trigger align when motion is in prepare
        const onPrepare = ()=>new Promise((resolve)=>{
                syncTargetSize();
                setMotionPrepareResolve(()=>resolve);
            });
        (0, $518ae471aa4f03a7$export$2e2bcd8739ae039)(()=>{
            if (motionPrepareResolve) {
                onAlign();
                motionPrepareResolve();
                setMotionPrepareResolve(null);
            }
        }, [
            motionPrepareResolve
        ]);
        // =========================== Action ===========================
        /**
     * Util wrapper for trigger action
     * @param eventName  Listen event name
     * @param nextOpen  Next open state after trigger
     * @param delay Delay to trigger open change
     * @param callback Callback if current event need additional action
     * @param ignoreCheck  Ignore current event if check return true
     */ function wrapperAction(eventName, nextOpen, delay, callback, ignoreCheck) {
            cloneProps[eventName] = (event, ...args)=>{
                if (!ignoreCheck || !ignoreCheck()) {
                    callback?.(event);
                    triggerOpen(nextOpen, delay);
                }
                // Pass to origin
                originChildProps[eventName]?.(event, ...args);
            };
        }
        // ======================= Action: Touch ========================
        const touchToShow = showActions.has('touch');
        const touchToHide = hideActions.has('touch');
        /** Used for prevent `hover` event conflict with mobile env */ const touchedRef = $5E6i4.useRef(false);
        if (touchToShow || touchToHide) cloneProps.onTouchStart = (...args)=>{
            touchedRef.current = true;
            if (openRef.current && touchToHide) triggerOpen(false);
            else if (!openRef.current && touchToShow) triggerOpen(true);
            // Pass to origin
            originChildProps.onTouchStart?.(...args);
        };
        // ======================= Action: Click ========================
        if (clickToShow || clickToHide) cloneProps.onClick = (event, ...args)=>{
            if (openRef.current && clickToHide) triggerOpen(false);
            else if (!openRef.current && clickToShow) {
                setMousePosByEvent(event);
                triggerOpen(true);
            }
            // Pass to origin
            originChildProps.onClick?.(event, ...args);
            touchedRef.current = false;
        };
        // Click to hide is special action since click popup element should not hide
        const onPopupPointerDown = (0, $242375f1e62616ff$export$2e2bcd8739ae039)(mergedOpen, clickToHide || touchToHide, targetEle, popupEle, mask, maskClosable, inPopupOrChild, triggerOpen);
        // ======================= Action: Hover ========================
        const hoverToShow = showActions.has('hover');
        const hoverToHide = hideActions.has('hover');
        let onPopupMouseEnter;
        let onPopupMouseLeave;
        const ignoreMouseTrigger = ()=>{
            return touchedRef.current;
        };
        if (hoverToShow) {
            const onMouseEnterCallback = (event)=>{
                setMousePosByEvent(event);
            };
            // Compatible with old browser which not support pointer event
            wrapperAction('onMouseEnter', true, mouseEnterDelay, onMouseEnterCallback, ignoreMouseTrigger);
            wrapperAction('onPointerEnter', true, mouseEnterDelay, onMouseEnterCallback, ignoreMouseTrigger);
            onPopupMouseEnter = (event)=>{
                // Only trigger re-open when popup is visible
                if ((mergedOpen || inMotion) && popupEle?.contains(event.target)) triggerOpen(true, mouseEnterDelay);
            };
            // Align Point
            if (alignPoint) cloneProps.onMouseMove = (event)=>{
                originChildProps.onMouseMove?.(event);
            };
        }
        if (hoverToHide) {
            wrapperAction('onMouseLeave', false, mouseLeaveDelay, undefined, ignoreMouseTrigger);
            wrapperAction('onPointerLeave', false, mouseLeaveDelay, undefined, ignoreMouseTrigger);
            onPopupMouseLeave = ()=>{
                triggerOpen(false, mouseLeaveDelay);
            };
        }
        // ======================= Action: Focus ========================
        if (showActions.has('focus')) wrapperAction('onFocus', true, focusDelay);
        if (hideActions.has('focus')) wrapperAction('onBlur', false, blurDelay);
        // ==================== Action: ContextMenu =====================
        if (showActions.has('contextMenu')) cloneProps.onContextMenu = (event, ...args)=>{
            if (openRef.current && hideActions.has('contextMenu')) triggerOpen(false);
            else {
                setMousePosByEvent(event);
                triggerOpen(true);
            }
            event.preventDefault();
            // Pass to origin
            originChildProps.onContextMenu?.(event, ...args);
        };
        // ============================ Perf ============================
        const rendedRef = $5E6i4.useRef(false);
        rendedRef.current ||= forceRender || mergedOpen || inMotion;
        // =========================== Render ===========================
        const mergedChildrenProps = {
            ...originChildProps,
            ...cloneProps
        };
        // Pass props into cloneProps for nest usage
        const passedProps = {};
        const passedEventList = [
            'onContextMenu',
            'onClick',
            'onMouseDown',
            'onTouchStart',
            'onMouseEnter',
            'onMouseLeave',
            'onFocus',
            'onBlur'
        ];
        passedEventList.forEach((eventName)=>{
            if (restProps[eventName]) passedProps[eventName] = (...args)=>{
                mergedChildrenProps[eventName]?.(...args);
                restProps[eventName](...args);
            };
        });
        const arrowPos = {
            x: arrowX,
            y: arrowY
        };
        // =================== Resize Observer ===================
        // Use hook to observe target element resize
        // Pass targetEle directly instead of a function so the hook will re-observe when target changes
        (0, $a22daecb6ba47e50$export$2e2bcd8739ae039)(mergedOpen, targetEle, onTargetResize);
        // Compose refs
        const mergedRef = (0, $92c8c75386168ffc$export$1d1c999670a1285d)(setTargetRef, (0, $92c8c75386168ffc$export$7465e5c0bf44f19a)(child));
        // Child Node
        const triggerNode = /*#__PURE__*/ $5E6i4.cloneElement(child, {
            ...mergedChildrenProps,
            ...passedProps,
            ref: mergedRef
        });
        // Render
        return /*#__PURE__*/ $5E6i4.createElement($5E6i4.Fragment, null, triggerNode, rendedRef.current && (!uniqueContext || !unique) && /*#__PURE__*/ $5E6i4.createElement((0, $4ac507189a225ce1$export$2e2bcd8739ae039).Provider, {
            value: context
        }, /*#__PURE__*/ $5E6i4.createElement((0, $b9b091a0924a2fd9$export$2e2bcd8739ae039), {
            portal: PortalComponent,
            ref: setPopupRef,
            prefixCls: prefixCls,
            popup: popup,
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(popupClassName, !isMobile && alignedClassName),
            style: popupStyle,
            target: targetEle,
            onMouseEnter: onPopupMouseEnter,
            onMouseLeave: onPopupMouseLeave,
            onPointerEnter: onPopupMouseEnter,
            zIndex: zIndex,
            open: mergedOpen,
            keepDom: inMotion,
            fresh: fresh,
            onClick: onPopupClick,
            onPointerDownCapture: onPopupPointerDown,
            mask: mask,
            motion: popupMotion,
            maskMotion: maskMotion,
            onVisibleChanged: onVisibleChanged,
            onPrepare: onPrepare,
            forceRender: forceRender,
            autoDestroy: mergedAutoDestroy,
            getPopupContainer: getPopupContainer,
            onEsc: onEsc,
            align: alignInfo,
            arrow: innerArrow,
            arrowPos: arrowPos,
            ready: ready,
            offsetX: offsetX,
            offsetY: offsetY,
            offsetR: offsetR,
            offsetB: offsetB,
            onAlign: triggerAlign,
            stretch: stretch,
            targetWidth: targetWidth / scaleX,
            targetHeight: targetHeight / scaleY,
            mobile: mobile
        })));
    });
    return Trigger;
}
var $5ff8ad2f21affc17$export$2e2bcd8739ae039 = $5ff8ad2f21affc17$export$55e99723d7f71b47((0, $bd882e1916f36420$export$2e2bcd8739ae039));




var $5E6i4 = parcelRequire("5E6i4");



var $5E6i4 = parcelRequire("5E6i4");

function $552e20b6ec4e63a6$export$9522e17588c12572(child) {
    return child && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).isValidElement(child) && child.type === (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).Fragment;
}
const $552e20b6ec4e63a6$export$2dfe578f95754f6a = (element, replacement, props)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).isValidElement(element)) return replacement;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).cloneElement(element, (0, $addbc2fddcbb77a9$export$f6e2535fb5126e54)(props) ? props(element.props || {}) : props);
};
function $552e20b6ec4e63a6$export$e530037191fcd5d7(element, props) {
    return $552e20b6ec4e63a6$export$2dfe578f95754f6a(element, element, props);
}



var $5E6i4 = parcelRequire("5E6i4");
const $519f2fad435b3034$export$e4ec87ea71f29b41 = 'ant';
const $519f2fad435b3034$export$eaca8ee5ed21b4e9 = 'anticon';
const $519f2fad435b3034$export$fa216ce2679a073b = [
    'outlined',
    'borderless',
    'filled',
    'underlined'
];
const $519f2fad435b3034$var$defaultGetPrefixCls = (suffixCls, customizePrefixCls)=>{
    if (customizePrefixCls) return customizePrefixCls;
    return suffixCls ? `${$519f2fad435b3034$export$e4ec87ea71f29b41}-${suffixCls}` : $519f2fad435b3034$export$e4ec87ea71f29b41;
};
const $519f2fad435b3034$export$a92f85ab3e9ad68b = /*#__PURE__*/ $5E6i4.createContext({
    // We provide a default function for Context without provider
    getPrefixCls: $519f2fad435b3034$var$defaultGetPrefixCls,
    iconPrefixCls: $519f2fad435b3034$export$eaca8ee5ed21b4e9
});
const { Consumer: $519f2fad435b3034$export$cd5442f2b8da7663 } = $519f2fad435b3034$export$a92f85ab3e9ad68b;
const $519f2fad435b3034$var$EMPTY_OBJECT = {};
function $519f2fad435b3034$export$46f4bd6436a25a31(propName) {
    const context = $5E6i4.useContext($519f2fad435b3034$export$a92f85ab3e9ad68b);
    const { getPrefixCls: getPrefixCls, direction: direction, getPopupContainer: getPopupContainer, renderEmpty: renderEmpty } = context;
    const propValue = context[propName];
    return {
        classNames: $519f2fad435b3034$var$EMPTY_OBJECT,
        styles: $519f2fad435b3034$var$EMPTY_OBJECT,
        ...propValue,
        getPrefixCls: getPrefixCls,
        direction: direction,
        getPopupContainer: getPopupContainer,
        renderEmpty: renderEmpty
    };
}


"use client";
const $edb41acd35107a24$var$MotionContent = ({ children: children })=>{
    const { getPrefixCls: getPrefixCls } = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useContext((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
    const rootPrefixCls = getPrefixCls();
    // This will never reach since we will not render this when no children
    /* istanbul ignore next */ if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).isValidElement(children)) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $5371a8954d0d2416$export$2e2bcd8739ae039), {
        visible: true,
        motionName: `${rootPrefixCls}-fade`,
        motionAppear: true,
        motionEnter: true,
        motionLeave: false,
        removeOnLeave: false
    }, ({ style: motionStyle, className: motionClassName })=>{
        return (0, $552e20b6ec4e63a6$export$e530037191fcd5d7)(children, (oriProps)=>({
                className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(oriProps.className, motionClassName),
                style: {
                    ...oriProps.style,
                    ...motionStyle
                }
            }));
    });
};
var $edb41acd35107a24$export$2e2bcd8739ae039 = $edb41acd35107a24$var$MotionContent;


"use client";
const $be5cd9936299e16c$var$cachedPlacements = [
    null,
    null
];
function $be5cd9936299e16c$var$uniqueBuiltinPlacements(ori) {
    if ($be5cd9936299e16c$var$cachedPlacements[0] !== ori) {
        const target = {};
        Object.keys(ori).forEach((placement)=>{
            target[placement] = {
                ...ori[placement],
                dynamicInset: false
            };
        });
        $be5cd9936299e16c$var$cachedPlacements[0] = ori;
        $be5cd9936299e16c$var$cachedPlacements[1] = target;
    }
    return $be5cd9936299e16c$var$cachedPlacements[1];
}
const $be5cd9936299e16c$var$UniqueProvider = ({ children: children })=>{
    const renderPopup = (options)=>{
        const { id: id, builtinPlacements: builtinPlacements, popup: popup } = options;
        const popupEle = (0, $addbc2fddcbb77a9$export$f6e2535fb5126e54)(popup) ? popup() : popup;
        const parsedPlacements = $be5cd9936299e16c$var$uniqueBuiltinPlacements(builtinPlacements);
        return {
            ...options,
            getPopupContainer: null,
            arrow: false,
            popup: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $edb41acd35107a24$export$2e2bcd8739ae039), {
                key: id
            }, popupEle),
            builtinPlacements: parsedPlacements
        };
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $c4cf75225b4fa0d1$export$2e2bcd8739ae039), {
        postTriggerProps: renderPopup
    }, children);
};
var $be5cd9936299e16c$export$2e2bcd8739ae039 = $be5cd9936299e16c$var$UniqueProvider;




var $5E6i4 = parcelRequire("5E6i4");
"use client";
const $2ab14018ea5b2d79$var$DisabledContext = /*#__PURE__*/ $5E6i4.createContext(false);
const $2ab14018ea5b2d79$export$6adb5f3b918b11bb = ({ children: children, disabled: disabled })=>{
    const originDisabled = $5E6i4.useContext($2ab14018ea5b2d79$var$DisabledContext);
    return /*#__PURE__*/ $5E6i4.createElement($2ab14018ea5b2d79$var$DisabledContext.Provider, {
        value: disabled ?? originDisabled
    }, children);
};
var $2ab14018ea5b2d79$export$2e2bcd8739ae039 = $2ab14018ea5b2d79$var$DisabledContext;



var $5E6i4 = parcelRequire("5E6i4");


var $5E6i4 = parcelRequire("5E6i4");
"use client";
const $d7f139cecf1d3086$var$SizeContext = /*#__PURE__*/ $5E6i4.createContext(undefined);
const $d7f139cecf1d3086$export$dbc92d89fabc8ebe = ({ children: children, size: size })=>{
    const originSize = $5E6i4.useContext($d7f139cecf1d3086$var$SizeContext);
    return /*#__PURE__*/ $5E6i4.createElement($d7f139cecf1d3086$var$SizeContext.Provider, {
        value: size || originSize
    }, children);
};
var $d7f139cecf1d3086$export$2e2bcd8739ae039 = $d7f139cecf1d3086$var$SizeContext;


function $2e78e819266d9b04$var$useConfig() {
    const componentDisabled = (0, $5E6i4.useContext)((0, $2ab14018ea5b2d79$export$2e2bcd8739ae039));
    const componentSize = (0, $5E6i4.useContext)((0, $d7f139cecf1d3086$export$2e2bcd8739ae039));
    return {
        componentDisabled: componentDisabled,
        componentSize: componentSize
    };
}
var $2e78e819266d9b04$export$2e2bcd8739ae039 = $2e78e819266d9b04$var$useConfig;



var $5E6i4 = parcelRequire("5E6i4");




function $66d8fb8c9a595ded$export$2e2bcd8739ae039(theme, parentTheme, config) {
    const warning = (0, $bedf93c14dee83a9$export$cf977aa92c751e61)('ConfigProvider');
    const themeConfig = theme || {};
    const parentThemeConfig = themeConfig.inherit === false || !parentTheme ? {
        ...(0, $dbf47bce378e6980$export$f84bd70098573c5c),
        hashed: parentTheme?.hashed ?? (0, $dbf47bce378e6980$export$f84bd70098573c5c).hashed,
        cssVar: parentTheme?.cssVar,
        zeroRuntime: parentTheme?.zeroRuntime
    } : parentTheme;
    // Generate a unique key for cssVar
    const themeKey = (0, $5E6i4.useId)();
    return (0, $8ae08502d6a327d3$export$2e2bcd8739ae039)(()=>{
        if (!theme) return parentTheme;
        // Override
        const mergedComponents = {
            ...parentThemeConfig.components
        };
        Object.keys(theme.components || {}).forEach((componentName)=>{
            mergedComponents[componentName] = {
                ...mergedComponents[componentName],
                ...theme.components[componentName]
            };
        });
        const cssVarKey = `css-var-${themeKey.replace(/:/g, '')}`;
        const mergedCssVar = {
            prefix: config?.prefixCls,
            // Same as prefixCls by default
            ...parentThemeConfig.cssVar,
            ...themeConfig.cssVar,
            key: themeConfig.cssVar?.key || cssVarKey
        };
        // Base token
        return {
            ...parentThemeConfig,
            ...themeConfig,
            token: {
                ...parentThemeConfig.token,
                ...themeConfig.token
            },
            components: mergedComponents,
            cssVar: mergedCssVar
        };
    }, [
        themeConfig,
        parentThemeConfig,
        config?.prefixCls,
        themeKey
    ], (prev, next)=>prev.some((prevTheme, index)=>{
            const nextTheme = next[index];
            return !(0, $f9cb347037ae4280$export$2e2bcd8739ae039)(prevTheme, nextTheme, true);
        }));
}



var $5E6i4 = parcelRequire("5E6i4");


var $5E6i4 = parcelRequire("5E6i4");


var $0dc172da20c6ad1b$export$2e2bcd8739ae039 = '6.6.6';


"use client";
var $67979f997f90aec6$export$2e2bcd8739ae039 = (0, $0dc172da20c6ad1b$export$2e2bcd8739ae039);







function $6d752234234de387$var$isStableColor(color) {
    return color >= 0 && color <= 255;
}
function $6d752234234de387$var$getAlphaColor(frontColor, backgroundColor) {
    const { r: fR, g: fG, b: fB, a: originAlpha } = new (0, $1b0a692e36565107$export$2c4f38d6c0ecc25a)(frontColor).toRgb();
    if (originAlpha < 1) return frontColor;
    const { r: bR, g: bG, b: bB } = new (0, $1b0a692e36565107$export$2c4f38d6c0ecc25a)(backgroundColor).toRgb();
    for(let fA = 0.01; fA <= 1; fA += 0.01){
        const r = Math.round((fR - bR * (1 - fA)) / fA);
        const g = Math.round((fG - bG * (1 - fA)) / fA);
        const b = Math.round((fB - bB * (1 - fA)) / fA);
        if ($6d752234234de387$var$isStableColor(r) && $6d752234234de387$var$isStableColor(g) && $6d752234234de387$var$isStableColor(b)) return new (0, $1b0a692e36565107$export$2c4f38d6c0ecc25a)({
            r: r,
            g: g,
            b: b,
            a: Math.round(fA * 100) / 100
        }).toRgbString();
    }
    // fallback
    /* istanbul ignore next */ return new (0, $1b0a692e36565107$export$2c4f38d6c0ecc25a)({
        r: fR,
        g: fG,
        b: fB,
        a: 1
    }).toRgbString();
}
var $6d752234234de387$export$2e2bcd8739ae039 = $6d752234234de387$var$getAlphaColor;


function $190911d5dd7c73ce$export$2e2bcd8739ae039(derivativeToken) {
    const { override: override, ...restToken } = derivativeToken;
    const overrideTokens = {
        ...override
    };
    Object.keys((0, $cafc407c84851727$export$2e2bcd8739ae039)).forEach((token)=>{
        delete overrideTokens[token];
    });
    const mergedToken = {
        ...restToken,
        ...overrideTokens
    };
    const shadowBaseColor = new (0, $1b0a692e36565107$export$2c4f38d6c0ecc25a)(mergedToken.colorShadow);
    const shadowBaseAlpha = shadowBaseColor.a;
    const getShadowColor = (alpha)=>shadowBaseColor.clone().setA(shadowBaseAlpha * alpha).toRgbString();
    const screenXS = 480;
    const screenSM = 576;
    const screenMD = 768;
    const screenLG = 992;
    const screenXL = 1200;
    const screenXXL = 1600;
    const screenXXXL = 1920;
    // Motion
    if (mergedToken.motion === false) {
        const fastDuration = '0s';
        mergedToken.motionDurationFast = fastDuration;
        mergedToken.motionDurationMid = fastDuration;
        mergedToken.motionDurationSlow = fastDuration;
    }
    // Generate alias token
    const aliasToken = {
        ...mergedToken,
        // ============== Background ============== //
        colorFillContent: mergedToken.colorFillSecondary,
        colorFillContentHover: mergedToken.colorFill,
        colorFillAlter: mergedToken.colorFillQuaternary,
        colorBgContainerDisabled: mergedToken.colorFillTertiary,
        // ============== Split ============== //
        colorBorderBg: mergedToken.colorBgContainer,
        colorSplit: (0, $6d752234234de387$export$2e2bcd8739ae039)(mergedToken.colorBorderSecondary, mergedToken.colorBgContainer),
        // ============== Text ============== //
        colorTextPlaceholder: mergedToken.colorTextQuaternary,
        colorTextDisabled: mergedToken.colorTextQuaternary,
        colorTextHeading: mergedToken.colorText,
        colorTextLabel: mergedToken.colorTextSecondary,
        colorTextDescription: mergedToken.colorTextTertiary,
        colorTextLightSolid: mergedToken.colorWhite,
        colorHighlight: mergedToken.colorError,
        colorBgTextHover: mergedToken.colorFillSecondary,
        colorBgTextActive: mergedToken.colorFill,
        colorIcon: mergedToken.colorTextTertiary,
        colorIconHover: mergedToken.colorText,
        colorErrorOutline: (0, $6d752234234de387$export$2e2bcd8739ae039)(mergedToken.colorErrorBg, mergedToken.colorBgContainer),
        colorWarningOutline: (0, $6d752234234de387$export$2e2bcd8739ae039)(mergedToken.colorWarningBg, mergedToken.colorBgContainer),
        colorErrorAffix: mergedToken.colorError,
        colorWarningAffix: mergedToken.colorWarning,
        // Font
        fontHeight: Math.round(mergedToken.fontSize * mergedToken.lineHeight),
        fontHeightSM: Math.round(mergedToken.fontSizeSM * mergedToken.lineHeightSM),
        fontHeightLG: Math.round(mergedToken.fontSizeLG * mergedToken.lineHeightLG),
        fontSizeIcon: mergedToken.fontSizeSM,
        // Line
        lineWidthFocus: mergedToken.focusOutline === false ? 0 : mergedToken.lineWidth * 3,
        // Control
        lineWidth: mergedToken.lineWidth,
        controlOutlineWidth: mergedToken.lineWidth * 2,
        // Checkbox size and expand icon size
        controlInteractiveSize: mergedToken.controlHeight / 2,
        controlItemBgHover: mergedToken.colorFillTertiary,
        controlItemBgActive: mergedToken.colorPrimaryBg,
        controlItemBgActiveHover: mergedToken.colorPrimaryBgHover,
        controlItemBgActiveDisabled: mergedToken.colorFill,
        controlTmpOutline: mergedToken.colorFillQuaternary,
        controlOutline: (0, $6d752234234de387$export$2e2bcd8739ae039)(mergedToken.colorPrimaryBg, mergedToken.colorBgContainer),
        lineType: mergedToken.lineType,
        borderRadius: mergedToken.borderRadius,
        borderRadiusXS: mergedToken.borderRadiusXS,
        borderRadiusSM: mergedToken.borderRadiusSM,
        borderRadiusLG: mergedToken.borderRadiusLG,
        fontWeightStrong: 600,
        opacityLoading: 0.65,
        linkDecoration: 'none',
        linkHoverDecoration: 'none',
        linkFocusDecoration: 'none',
        controlPaddingHorizontal: 12,
        controlPaddingHorizontalSM: 8,
        paddingXXS: mergedToken.sizeXXS,
        paddingXS: mergedToken.sizeXS,
        paddingSM: mergedToken.sizeSM,
        padding: mergedToken.size,
        paddingMD: mergedToken.sizeMD,
        paddingLG: mergedToken.sizeLG,
        paddingXL: mergedToken.sizeXL,
        paddingContentHorizontalLG: mergedToken.sizeLG,
        paddingContentVerticalLG: mergedToken.sizeMS,
        paddingContentHorizontal: mergedToken.sizeMS,
        paddingContentVertical: mergedToken.sizeSM,
        paddingContentHorizontalSM: mergedToken.size,
        paddingContentVerticalSM: mergedToken.sizeXS,
        marginXXS: mergedToken.sizeXXS,
        marginXS: mergedToken.sizeXS,
        marginSM: mergedToken.sizeSM,
        margin: mergedToken.size,
        marginMD: mergedToken.sizeMD,
        marginLG: mergedToken.sizeLG,
        marginXL: mergedToken.sizeXL,
        marginXXL: mergedToken.sizeXXL,
        boxShadow: `
      0 6px 16px 0 ${getShadowColor(0.08)},
      0 3px 6px -4px ${getShadowColor(0.12)},
      0 9px 28px 8px ${getShadowColor(0.05)}
    `,
        boxShadowSecondary: `
      0 6px 16px 0 ${getShadowColor(0.08)},
      0 3px 6px -4px ${getShadowColor(0.12)},
      0 9px 28px 8px ${getShadowColor(0.05)}
    `,
        boxShadowTertiary: `
      0 1px 2px 0 ${getShadowColor(0.05)},
      0 1px 6px -1px ${getShadowColor(0.03)},
      0 2px 4px 0 ${getShadowColor(0.03)}
    `,
        screenXS: screenXS,
        screenXSMin: screenXS,
        screenXSMax: screenSM - 1,
        screenSM: screenSM,
        screenSMMin: screenSM,
        screenSMMax: screenMD - 1,
        screenMD: screenMD,
        screenMDMin: screenMD,
        screenMDMax: screenLG - 1,
        screenLG: screenLG,
        screenLGMin: screenLG,
        screenLGMax: screenXL - 1,
        screenXL: screenXL,
        screenXLMin: screenXL,
        screenXLMax: screenXXL - 1,
        screenXXL: screenXXL,
        screenXXLMin: screenXXL,
        screenXXLMax: screenXXXL - 1,
        screenXXXL: screenXXXL,
        screenXXXLMin: screenXXXL,
        boxShadowPopoverArrow: `2px 2px 5px ${getShadowColor(0.05)}`,
        dropShadowPopover: `drop-shadow(0 6px 16px ${getShadowColor(0.08)}) drop-shadow(0 3px 6px ${getShadowColor(0.12)}) drop-shadow(0 9px 28px ${getShadowColor(0.05)})`,
        boxShadowCard: `
      0 1px 2px -2px ${getShadowColor(0.16)},
      0 3px 6px 0 ${getShadowColor(0.12)},
      0 5px 12px 4px ${getShadowColor(0.09)}
    `,
        boxShadowDrawerRight: `
      -6px 0 16px 0 ${getShadowColor(0.08)},
      -3px 0 6px -4px ${getShadowColor(0.12)},
      -9px 0 28px 8px ${getShadowColor(0.05)}
    `,
        boxShadowDrawerLeft: `
      6px 0 16px 0 ${getShadowColor(0.08)},
      3px 0 6px -4px ${getShadowColor(0.12)},
      9px 0 28px 8px ${getShadowColor(0.05)}
    `,
        boxShadowDrawerUp: `
      0 6px 16px 0 ${getShadowColor(0.08)},
      0 3px 6px -4px ${getShadowColor(0.12)},
      0 9px 28px 8px ${getShadowColor(0.05)}
    `,
        boxShadowDrawerDown: `
      0 -6px 16px 0 ${getShadowColor(0.08)},
      0 -3px 6px -4px ${getShadowColor(0.12)},
      0 -9px 28px 8px ${getShadowColor(0.05)}
    `,
        boxShadowTabsOverflowLeft: `inset 10px 0 8px -8px ${getShadowColor(0.08)}`,
        boxShadowTabsOverflowRight: `inset -10px 0 8px -8px ${getShadowColor(0.08)}`,
        boxShadowTabsOverflowTop: `inset 0 10px 8px -8px ${getShadowColor(0.08)}`,
        boxShadowTabsOverflowBottom: `inset 0 -10px 8px -8px ${getShadowColor(0.08)}`,
        // Override AliasToken
        ...overrideTokens
    };
    return aliasToken;
}


const $cb3a44f4e76623bb$export$c6b9faa6b723d31a = {
    lineHeight: true,
    lineHeightSM: true,
    lineHeightLG: true,
    lineHeightHeading1: true,
    lineHeightHeading2: true,
    lineHeightHeading3: true,
    lineHeightHeading4: true,
    lineHeightHeading5: true,
    opacityLoading: true,
    fontWeightStrong: true,
    zIndexPopupBase: true,
    zIndexBase: true,
    opacityImage: true
};
const $cb3a44f4e76623bb$export$738b109e247a462c = {
    motionBase: true,
    motionUnit: true
};
const $cb3a44f4e76623bb$var$preserve = {
    screenXS: true,
    screenXSMin: true,
    screenXSMax: true,
    screenSM: true,
    screenSMMin: true,
    screenSMMax: true,
    screenMD: true,
    screenMDMin: true,
    screenMDMax: true,
    screenLG: true,
    screenLGMin: true,
    screenLGMax: true,
    screenXL: true,
    screenXLMin: true,
    screenXLMax: true,
    screenXXL: true,
    screenXXLMin: true,
    screenXXLMax: true,
    screenXXXL: true,
    screenXXXLMin: true
};
const $cb3a44f4e76623bb$export$18602cb46ae80b62 = (originToken, overrideToken, theme)=>{
    const derivativeToken = theme.getDerivativeToken(originToken);
    const { override: override, ...components } = overrideToken;
    // Merge with override
    let mergedDerivativeToken = {
        ...derivativeToken,
        override: override
    };
    // Format if needed
    mergedDerivativeToken = (0, $190911d5dd7c73ce$export$2e2bcd8739ae039)(mergedDerivativeToken);
    if (components) Object.entries(components).forEach(([key, value])=>{
        const { theme: componentTheme, ...componentTokens } = value;
        let mergedComponentToken = componentTokens;
        if (componentTheme) mergedComponentToken = $cb3a44f4e76623bb$export$18602cb46ae80b62({
            ...mergedDerivativeToken,
            ...componentTokens
        }, {
            override: componentTokens
        }, componentTheme);
        mergedDerivativeToken[key] = mergedComponentToken;
    });
    return mergedDerivativeToken;
};
function $cb3a44f4e76623bb$export$2e2bcd8739ae039() {
    const { token: rootDesignToken, hashed: hashed, theme: theme, override: override, cssVar: ctxCssVar, zeroRuntime: zeroRuntime } = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useContext((0, $dbf47bce378e6980$export$69b0ebb9efcddb30));
    const { csp: csp, getPrefixCls: getPrefixCls } = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useContext((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
    const cssVar = {
        prefix: ctxCssVar?.prefix ?? getPrefixCls(),
        key: ctxCssVar?.key ?? 'css-var-root'
    };
    const salt = `${(0, $67979f997f90aec6$export$2e2bcd8739ae039)}-${hashed || ''}`;
    const mergedTheme = theme || (0, $53f2aff062e85359$export$2e2bcd8739ae039);
    const [token, hashId, realToken] = (0, $efddb89bf789bd65$export$2e2bcd8739ae039)(mergedTheme, [
        (0, $cafc407c84851727$export$2e2bcd8739ae039),
        rootDesignToken
    ], {
        salt: salt,
        override: override,
        getComputedToken: $cb3a44f4e76623bb$export$18602cb46ae80b62,
        cssVar: {
            ...cssVar,
            unitless: $cb3a44f4e76623bb$export$c6b9faa6b723d31a,
            ignore: $cb3a44f4e76623bb$export$738b109e247a462c,
            preserve: $cb3a44f4e76623bb$var$preserve
        },
        nonce: csp?.nonce
    });
    return [
        mergedTheme,
        realToken,
        hashed ? hashId : '',
        token,
        cssVar,
        !!zeroRuntime
    ];
}


"use client";
const $cc50b3ded4a0a42f$var$MotionCacheContext = /*#__PURE__*/ $5E6i4.createContext(true);
function $cc50b3ded4a0a42f$export$2e2bcd8739ae039(props) {
    const parentMotion = $5E6i4.useContext($cc50b3ded4a0a42f$var$MotionCacheContext);
    const { children: children } = props;
    const [, token] = (0, $cb3a44f4e76623bb$export$2e2bcd8739ae039)();
    const { motion: motion } = token;
    const needWrapMotionProviderRef = $5E6i4.useRef(false);
    needWrapMotionProviderRef.current || (needWrapMotionProviderRef.current = parentMotion !== motion);
    if (needWrapMotionProviderRef.current) return /*#__PURE__*/ $5E6i4.createElement($cc50b3ded4a0a42f$var$MotionCacheContext.Provider, {
        value: motion
    }, /*#__PURE__*/ $5E6i4.createElement((0, $e0e68dd7bf0b9181$export$2e2bcd8739ae039), {
        motion: motion
    }, children));
    return children;
}



var $5E6i4 = parcelRequire("5E6i4");

"use client";
/**
 * Warning for ConfigProviderProps.
 * This will be empty function in production.
 */ const $d23ed37c99176551$var$PropWarning = /*#__PURE__*/ $5E6i4.memo((props)=>{
    const { dropdownMatchSelectWidth: dropdownMatchSelectWidth } = props;
    const warning = (0, $bedf93c14dee83a9$export$cf977aa92c751e61)('ConfigProvider');
    warning.deprecated(dropdownMatchSelectWidth === undefined, 'dropdownMatchSelectWidth', 'popupMatchSelectWidth');
    return null;
});
var $d23ed37c99176551$export$2e2bcd8739ae039 = ()=>null;





"use client";
const $cd5a520fee8002b4$export$b2b65df0d0824629 = {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
};
const $cd5a520fee8002b4$export$23997c3e44cc1c59 = (token, needInheritFontFamily = false)=>({
        boxSizing: 'border-box',
        margin: 0,
        padding: 0,
        color: token.colorText,
        fontSize: token.fontSize,
        // font-variant: @font-variant-base;
        lineHeight: token.lineHeight,
        listStyle: 'none',
        // font-feature-settings: @font-feature-settings-base;
        fontFamily: needInheritFontFamily ? 'inherit' : token.fontFamily
    });
const $cd5a520fee8002b4$export$171ccda7bc085e59 = ()=>({
        display: 'inline-flex',
        alignItems: 'center',
        color: 'inherit',
        fontStyle: 'normal',
        lineHeight: 0,
        textAlign: 'center',
        textTransform: 'none',
        // for SVG icon, see https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
        verticalAlign: '-0.125em',
        textRendering: 'optimizeLegibility',
        '-webkit-font-smoothing': 'antialiased',
        '-moz-osx-font-smoothing': 'grayscale',
        '> *': {
            lineHeight: 1
        },
        svg: {
            display: 'inline-block',
            verticalAlign: 'inherit'
        }
    });
const $cd5a520fee8002b4$var$loadingCircle = new (0, $14544cbeb8c8473b$export$2e2bcd8739ae039)('loadingCircle', {
    '100%': {
        transform: 'rotate(360deg)'
    }
});
const $cd5a520fee8002b4$export$8c467e8859fdef13 = ()=>({
        // https://github.com/ant-design/ant-design/issues/21301#issuecomment-583955229
        '&::before': {
            display: 'table',
            content: '""'
        },
        '&::after': {
            // https://github.com/ant-design/ant-design/issues/21864
            display: 'table',
            clear: 'both',
            content: '""'
        }
    });
const $cd5a520fee8002b4$export$6539948f0a737e39 = (token, offset)=>({
        outline: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.lineWidthFocus)} solid ${token.colorPrimaryBorder}`,
        outlineOffset: offset ?? 1,
        transition: [
            `outline-offset`,
            `outline`
        ].map((prop)=>`${prop} 0s`).join(', ')
    });
const $cd5a520fee8002b4$export$a44db842bcb28231 = (token, offset)=>({
        '&:focus-visible': $cd5a520fee8002b4$export$6539948f0a737e39(token, offset)
    });
const $cd5a520fee8002b4$export$905d771977096614 = (token)=>({
        a: {
            color: token.colorLink,
            textDecoration: token.linkDecoration,
            backgroundColor: 'transparent',
            // remove the gray background on active links in IE 10.
            outline: 'none',
            cursor: 'pointer',
            transition: `color ${token.motionDurationSlow}`,
            '-webkit-text-decoration-skip': 'objects',
            // remove gaps in links underline in iOS 8+ and Safari 8+.
            '&:hover': {
                color: token.colorLinkHover
            },
            '&:active': {
                color: token.colorLinkActive
            },
            '&:active, &:hover': {
                textDecoration: token.linkHoverDecoration,
                outline: 0
            },
            // https://github.com/ant-design/ant-design/issues/22503
            '&:focus': {
                textDecoration: token.linkFocusDecoration,
                outline: 0
            },
            ...$cd5a520fee8002b4$export$a44db842bcb28231(token),
            '&[disabled]': {
                color: token.colorTextDisabled,
                cursor: 'not-allowed'
            }
        }
    });
const $cd5a520fee8002b4$export$689382c111559cd9 = (token, componentPrefixCls, rootCls, resetFont)=>{
    const prefixSelector = `[class^="${componentPrefixCls}"], [class*=" ${componentPrefixCls}"]`;
    const rootPrefixSelector = rootCls ? `.${rootCls}` : prefixSelector;
    const resetStyle = {
        boxSizing: 'border-box',
        '&::before, &::after': {
            boxSizing: 'border-box'
        }
    };
    let resetFontStyle = {};
    if (resetFont !== false) resetFontStyle = {
        fontFamily: token.fontFamily,
        fontSize: token.fontSize
    };
    return {
        [rootPrefixSelector]: {
            ...resetFontStyle,
            ...resetStyle,
            [prefixSelector]: resetStyle
        }
    };
};
const $cd5a520fee8002b4$export$f1a0b31dfb234e7e = (iconPrefixCls)=>({
        [`.${iconPrefixCls}`]: {
            ...$cd5a520fee8002b4$export$171ccda7bc085e59(),
            '&::before': {
                display: 'none'
            },
            '&[tabindex]': {
                cursor: 'pointer'
            }
        },
        [`.${iconPrefixCls} .${iconPrefixCls}-icon`]: {
            display: 'block'
        },
        [`.${iconPrefixCls}-spin`]: {
            animationName: $cd5a520fee8002b4$var$loadingCircle,
            animationDuration: '1s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear'
        }
    });
const $cd5a520fee8002b4$export$9a16e7694a707ab4 = (token)=>({
        // FIXME: This use link but is a operation unit. Seems should be a colorPrimary.
        // And Typography use this to generate link style which should not do this.
        color: token.colorLink,
        textDecoration: token.linkDecoration,
        outline: 'none',
        cursor: 'pointer',
        transition: `all ${token.motionDurationSlow}`,
        border: 0,
        padding: 0,
        background: 'none',
        userSelect: 'none',
        ...$cd5a520fee8002b4$export$a44db842bcb28231(token),
        '&:hover': {
            color: token.colorLinkHover,
            textDecoration: token.linkHoverDecoration
        },
        '&:focus': {
            color: token.colorLinkHover,
            textDecoration: token.linkFocusDecoration
        },
        '&:active': {
            color: token.colorLinkActive,
            textDecoration: token.linkHoverDecoration
        }
    });



const $89b67f36d1eb52eb$var$useResetIconStyle = (iconPrefixCls, csp)=>{
    const [theme, token] = (0, $cb3a44f4e76623bb$export$2e2bcd8739ae039)();
    // Generate style for icons
    return (0, $4f1ffbb71c2e9fc2$export$2e2bcd8739ae039)({
        theme: theme,
        token: token,
        hashId: '',
        path: [
            'ant-design-icons',
            iconPrefixCls
        ],
        nonce: ()=>csp?.nonce,
        layer: {
            name: 'antd'
        }
    }, ()=>(0, $cd5a520fee8002b4$export$f1a0b31dfb234e7e)(iconPrefixCls));
};
var $89b67f36d1eb52eb$export$2e2bcd8739ae039 = $89b67f36d1eb52eb$var$useResetIconStyle;


"use client";
/**
 * This component registers icon styles inside the DesignTokenContext.Provider
 * so that CSS variables use the correct cssVar key from the theme config.
 */ const $58662003e62ec648$var$IconStyle = ({ iconPrefixCls: iconPrefixCls, csp: csp })=>{
    (0, $89b67f36d1eb52eb$export$2e2bcd8739ae039)(iconPrefixCls, csp);
    return null;
};
/**
 * Since too many feedback using static method like `Modal.confirm` not getting theme, we record the
 * theme register info here to help developer get warning info.
 */ let $58662003e62ec648$var$existThemeConfig = false;
const $58662003e62ec648$export$7c4f6da0f9434a77 = /* istanbul ignore next */ null;
const $58662003e62ec648$export$e7f14a745e5c386a = [
    'getTargetContainer',
    'getPopupContainer',
    'rootPrefixCls',
    'getPrefixCls',
    'renderEmpty',
    'csp',
    'autoInsertSpaceInButton',
    'locale'
];
// These props is used by `useContext` directly in sub component
const $58662003e62ec648$var$PASSED_PROPS = [
    'getTargetContainer',
    'getPopupContainer',
    'renderEmpty',
    'input',
    'pagination',
    'form',
    'select',
    'button'
];
let $58662003e62ec648$var$globalPrefixCls;
let $58662003e62ec648$var$globalIconPrefixCls;
let $58662003e62ec648$var$globalTheme;
let $58662003e62ec648$var$globalHolderRender;
function $58662003e62ec648$var$getGlobalPrefixCls() {
    return $58662003e62ec648$var$globalPrefixCls || (0, $519f2fad435b3034$export$e4ec87ea71f29b41);
}
function $58662003e62ec648$var$getGlobalIconPrefixCls() {
    return $58662003e62ec648$var$globalIconPrefixCls || (0, $519f2fad435b3034$export$eaca8ee5ed21b4e9);
}
const $58662003e62ec648$var$setGlobalConfig = (props)=>{
    const { prefixCls: prefixCls, iconPrefixCls: iconPrefixCls, theme: theme, holderRender: holderRender } = props;
    if (prefixCls !== undefined) $58662003e62ec648$var$globalPrefixCls = prefixCls;
    if (iconPrefixCls !== undefined) $58662003e62ec648$var$globalIconPrefixCls = iconPrefixCls;
    if ('holderRender' in props) $58662003e62ec648$var$globalHolderRender = holderRender;
    if (theme) $58662003e62ec648$var$globalTheme = theme;
};
const $58662003e62ec648$export$f9cd1e43211d8a4a = ()=>({
        getPrefixCls: (suffixCls, customizePrefixCls)=>{
            if (customizePrefixCls) return customizePrefixCls;
            return suffixCls ? `${$58662003e62ec648$var$getGlobalPrefixCls()}-${suffixCls}` : $58662003e62ec648$var$getGlobalPrefixCls();
        },
        getIconPrefixCls: $58662003e62ec648$var$getGlobalIconPrefixCls,
        getRootPrefixCls: ()=>{
            // If Global prefixCls provided, use this
            if ($58662003e62ec648$var$globalPrefixCls) return $58662003e62ec648$var$globalPrefixCls;
            // Fallback to default prefixCls
            return $58662003e62ec648$var$getGlobalPrefixCls();
        },
        getTheme: ()=>$58662003e62ec648$var$globalTheme,
        holderRender: $58662003e62ec648$var$globalHolderRender
    });
const $58662003e62ec648$var$ProviderChildren = (props)=>{
    const { children: children, csp: customCsp, autoInsertSpaceInButton: autoInsertSpaceInButton, alert: alert, affix: affix, anchor: anchor, app: app, form: form, locale: rawLocale, componentSize: componentSize, direction: direction, space: space, splitter: splitter, virtual: virtual, dropdownMatchSelectWidth: dropdownMatchSelectWidth, popupMatchSelectWidth: popupMatchSelectWidth, popupOverflow: popupOverflow, legacyLocale: legacyLocale, parentContext: parentContext, iconPrefixCls: customIconPrefixCls, theme: theme, componentDisabled: componentDisabled, segmented: segmented, statistic: statistic, spin: spin, calendar: calendar, carousel: carousel, cascader: cascader, collapse: collapse, typography: typography, checkbox: checkbox, descriptions: descriptions, divider: divider, drawer: drawer, skeleton: skeleton, steps: steps, image: image, layout: layout, list: list, listy: listy, mentions: mentions, modal: modal, progress: progress, result: result, slider: slider, breadcrumb: breadcrumb, masonry: masonry, menu: menu, pagination: pagination, input: input, inputPassword: inputPassword, inputSearch: inputSearch, textArea: textArea, otp: otp, empty: empty, badge: badge, borderBeam: borderBeam, radio: radio, rate: rate, ribbon: ribbon, switch: SWITCH, transfer: transfer, avatar: avatar, message: message, tag: tag, table: table, card: card, cardMeta: cardMeta, tabs: tabs, timeline: timeline, timePicker: timePicker, upload: upload, notification: notification, tree: tree, colorPicker: colorPicker, datePicker: datePicker, rangePicker: rangePicker, flex: flex, wave: wave, dropdown: dropdown, warning: warningConfig, tour: tour, tooltip: tooltip, popover: popover, popconfirm: popconfirm, qrcode: qrcode, floatButton: floatButton, floatButtonGroup: floatButtonGroup, variant: variant, inputNumber: inputNumber, treeSelect: treeSelect, watermark: watermark } = props;
    // https://github.com/ant-design/ant-design/issues/57295
    const locale = $5E6i4.useMemo(()=>{
        if ((0, $addbc2fddcbb77a9$export$53b83ca8eaab0383)(rawLocale) && Object.prototype.hasOwnProperty.call(rawLocale, 'default') && rawLocale.default?.locale) return rawLocale.default;
        return rawLocale;
    }, [
        rawLocale
    ]);
    // =================================== Context ===================================
    const getPrefixCls = $5E6i4.useCallback((suffixCls, customizePrefixCls)=>{
        const { prefixCls: prefixCls } = props;
        if (customizePrefixCls) return customizePrefixCls;
        const mergedPrefixCls = prefixCls || parentContext.getPrefixCls('');
        return suffixCls ? `${mergedPrefixCls}-${suffixCls}` : mergedPrefixCls;
    }, [
        parentContext.getPrefixCls,
        props.prefixCls
    ]);
    const iconPrefixCls = customIconPrefixCls || parentContext.iconPrefixCls || (0, $519f2fad435b3034$export$eaca8ee5ed21b4e9);
    const csp = customCsp || parentContext.csp;
    const mergedTheme = (0, $66d8fb8c9a595ded$export$2e2bcd8739ae039)(theme, parentContext.theme, {
        prefixCls: getPrefixCls('')
    });
    const baseConfig = {
        csp: csp,
        autoInsertSpaceInButton: autoInsertSpaceInButton,
        alert: alert,
        affix: affix,
        anchor: anchor,
        app: app,
        locale: locale || legacyLocale,
        direction: direction,
        space: space,
        splitter: splitter,
        virtual: virtual,
        popupMatchSelectWidth: popupMatchSelectWidth ?? dropdownMatchSelectWidth,
        popupOverflow: popupOverflow,
        getPrefixCls: getPrefixCls,
        iconPrefixCls: iconPrefixCls,
        theme: mergedTheme,
        segmented: segmented,
        statistic: statistic,
        spin: spin,
        calendar: calendar,
        carousel: carousel,
        cascader: cascader,
        collapse: collapse,
        typography: typography,
        checkbox: checkbox,
        descriptions: descriptions,
        divider: divider,
        drawer: drawer,
        skeleton: skeleton,
        steps: steps,
        image: image,
        input: input,
        inputPassword: inputPassword,
        inputSearch: inputSearch,
        textArea: textArea,
        otp: otp,
        layout: layout,
        list: list,
        listy: listy,
        mentions: mentions,
        modal: modal,
        progress: progress,
        result: result,
        slider: slider,
        breadcrumb: breadcrumb,
        masonry: masonry,
        menu: menu,
        pagination: pagination,
        empty: empty,
        badge: badge,
        borderBeam: borderBeam,
        radio: radio,
        rate: rate,
        ribbon: ribbon,
        switch: SWITCH,
        transfer: transfer,
        avatar: avatar,
        message: message,
        tag: tag,
        table: table,
        card: card,
        cardMeta: cardMeta,
        tabs: tabs,
        timeline: timeline,
        timePicker: timePicker,
        upload: upload,
        notification: notification,
        tree: tree,
        colorPicker: colorPicker,
        datePicker: datePicker,
        rangePicker: rangePicker,
        flex: flex,
        wave: wave,
        dropdown: dropdown,
        warning: warningConfig,
        tour: tour,
        tooltip: tooltip,
        popover: popover,
        popconfirm: popconfirm,
        qrcode: qrcode,
        floatButton: floatButton,
        floatButtonGroup: floatButtonGroup,
        variant: variant,
        inputNumber: inputNumber,
        treeSelect: treeSelect,
        watermark: watermark
    };
    const config = {
        ...parentContext
    };
    Object.keys(baseConfig).forEach((key)=>{
        if (baseConfig[key] !== undefined) config[key] = baseConfig[key];
    });
    // Pass the props used by `useContext` directly with child component.
    // These props should merged into `config`.
    $58662003e62ec648$var$PASSED_PROPS.forEach((propName)=>{
        const propValue = props[propName];
        if (propValue) config[propName] = propValue;
    });
    if (typeof autoInsertSpaceInButton !== 'undefined') // merge deprecated api
    config.button = {
        autoInsertSpace: autoInsertSpaceInButton,
        ...config.button
    };
    // https://github.com/ant-design/ant-design/issues/27617
    const memoedConfig = (0, $8ae08502d6a327d3$export$2e2bcd8739ae039)(()=>config, config, (prevConfig, currentConfig)=>{
        const prevKeys = Object.keys(prevConfig);
        const currentKeys = Object.keys(currentConfig);
        return prevKeys.length !== currentKeys.length || prevKeys.some((key)=>prevConfig[key] !== currentConfig[key]);
    });
    const { layer: layer } = $5E6i4.useContext((0, $6c29e14c4abe80bf$export$2e2bcd8739ae039));
    const memoIconContextValue = $5E6i4.useMemo(()=>({
            prefixCls: iconPrefixCls,
            csp: csp,
            layer: layer ? 'antd' : undefined,
            zeroRuntime: !!layer || mergedTheme?.zeroRuntime
        }), [
        iconPrefixCls,
        csp,
        layer,
        mergedTheme?.zeroRuntime
    ]);
    let childNode = /*#__PURE__*/ $5E6i4.createElement($5E6i4.Fragment, null, /*#__PURE__*/ $5E6i4.createElement($58662003e62ec648$var$IconStyle, {
        iconPrefixCls: iconPrefixCls,
        csp: csp
    }), /*#__PURE__*/ $5E6i4.createElement((0, $d23ed37c99176551$export$2e2bcd8739ae039), {
        dropdownMatchSelectWidth: dropdownMatchSelectWidth
    }), children);
    const validateMessages = $5E6i4.useMemo(()=>(0, $4eb3db67adf477c8$export$4950aa0f605343fb)((0, $7a40da28675d08a9$export$2e2bcd8739ae039).Form?.defaultValidateMessages || {}, memoedConfig.locale?.Form?.defaultValidateMessages || {}, memoedConfig.form?.validateMessages || {}, form?.validateMessages || {}), [
        memoedConfig,
        form?.validateMessages
    ]);
    if (Object.keys(validateMessages).length > 0) childNode = /*#__PURE__*/ $5E6i4.createElement((0, $0b2e649db3b80700$export$2e2bcd8739ae039).Provider, {
        value: validateMessages
    }, childNode);
    if (locale) childNode = /*#__PURE__*/ $5E6i4.createElement((0, $f2b9e4961cc759b1$export$2e2bcd8739ae039), {
        locale: locale,
        _ANT_MARK__: (0, $f2b9e4961cc759b1$export$b2f162cd5c15ea3e)
    }, childNode);
    if (iconPrefixCls || csp) childNode = /*#__PURE__*/ $5E6i4.createElement((0, $2a60f785f1b30e7d$export$2e2bcd8739ae039).Provider, {
        value: memoIconContextValue
    }, childNode);
    if (componentSize) childNode = /*#__PURE__*/ $5E6i4.createElement((0, $d7f139cecf1d3086$export$dbc92d89fabc8ebe), {
        size: componentSize
    }, childNode);
    // =================================== Motion ===================================
    childNode = /*#__PURE__*/ $5E6i4.createElement((0, $cc50b3ded4a0a42f$export$2e2bcd8739ae039), null, childNode);
    // ================================ Tooltip Unique ===============================
    if (tooltip?.unique) childNode = /*#__PURE__*/ $5E6i4.createElement((0, $be5cd9936299e16c$export$2e2bcd8739ae039), null, childNode);
    // ================================ Dynamic theme ================================
    const memoTheme = $5E6i4.useMemo(()=>{
        const { algorithm: algorithm, token: token, components: components, cssVar: cssVar, ...rest } = mergedTheme || {};
        const themeObj = algorithm && (!Array.isArray(algorithm) || algorithm.length > 0) ? (0, $e0015b07082714af$export$2e2bcd8739ae039)(algorithm) : (0, $53f2aff062e85359$export$2e2bcd8739ae039);
        const parsedComponents = {};
        Object.entries(components || {}).forEach(([componentName, componentToken])=>{
            const parsedToken = {
                ...componentToken
            };
            if ('algorithm' in parsedToken) {
                if (parsedToken.algorithm === true) parsedToken.theme = themeObj;
                else if (Array.isArray(parsedToken.algorithm) || (0, $addbc2fddcbb77a9$export$f6e2535fb5126e54)(parsedToken.algorithm)) parsedToken.theme = (0, $e0015b07082714af$export$2e2bcd8739ae039)(parsedToken.algorithm);
                delete parsedToken.algorithm;
            }
            parsedComponents[componentName] = parsedToken;
        });
        const mergedToken = {
            ...(0, $cafc407c84851727$export$2e2bcd8739ae039),
            ...token
        };
        return {
            ...rest,
            theme: themeObj,
            token: mergedToken,
            components: parsedComponents,
            override: {
                override: mergedToken,
                ...parsedComponents
            },
            cssVar: cssVar
        };
    }, [
        mergedTheme
    ]);
    if (theme) childNode = /*#__PURE__*/ $5E6i4.createElement((0, $dbf47bce378e6980$export$69b0ebb9efcddb30).Provider, {
        value: memoTheme
    }, childNode);
    // ================================== Warning ===================================
    if (memoedConfig.warning) childNode = /*#__PURE__*/ $5E6i4.createElement((0, $bedf93c14dee83a9$export$11b88c75b33aa1fd).Provider, {
        value: memoedConfig.warning
    }, childNode);
    // =================================== Render ===================================
    if (componentDisabled !== undefined) childNode = /*#__PURE__*/ $5E6i4.createElement((0, $2ab14018ea5b2d79$export$6adb5f3b918b11bb), {
        disabled: componentDisabled
    }, childNode);
    return /*#__PURE__*/ $5E6i4.createElement((0, $519f2fad435b3034$export$a92f85ab3e9ad68b).Provider, {
        value: memoedConfig
    }, childNode);
};
const $58662003e62ec648$var$ConfigProvider = (props)=>{
    const context = $5E6i4.useContext((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
    const antLocale = $5E6i4.useContext((0, $8ffe7a84927cd2b0$export$2e2bcd8739ae039));
    return /*#__PURE__*/ $5E6i4.createElement($58662003e62ec648$var$ProviderChildren, {
        parentContext: context,
        legacyLocale: antLocale,
        ...props
    });
};
$58662003e62ec648$var$ConfigProvider.ConfigContext = (0, $519f2fad435b3034$export$a92f85ab3e9ad68b);
$58662003e62ec648$var$ConfigProvider.SizeContext = (0, $d7f139cecf1d3086$export$2e2bcd8739ae039);
$58662003e62ec648$var$ConfigProvider.config = $58662003e62ec648$var$setGlobalConfig;
$58662003e62ec648$var$ConfigProvider.useConfig = (0, $2e78e819266d9b04$export$2e2bcd8739ae039);
Object.defineProperty($58662003e62ec648$var$ConfigProvider, 'SizeContext', {
    get: ()=>{
        return 0, $d7f139cecf1d3086$export$2e2bcd8739ae039;
    }
});
var $58662003e62ec648$export$2e2bcd8739ae039 = $58662003e62ec648$var$ConfigProvider;




var $5E6i4 = parcelRequire("5E6i4");
function $7696f11ad0f62bf4$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $7696f11ad0f62bf4$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7696f11ad0f62bf4$export$2e2bcd8739ae039(o);
}


function $a595a4a6f335b549$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $96a598eb9c6f7b29$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}



function $defc74be5e248ca5$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $9f30dc2f29991165$export$2e2bcd8739ae039(r, e) {
    return (0, $a595a4a6f335b549$export$2e2bcd8739ae039)(r) || (0, $96a598eb9c6f7b29$export$2e2bcd8739ae039)(r, e) || (0, $d52f659237d99996$export$2e2bcd8739ae039)(r, e) || (0, $defc74be5e248ca5$export$2e2bcd8739ae039)();
}





function $e3d606cfe35b5b03$export$2e2bcd8739ae039(t, e) {
    if ("object" != (0, $7696f11ad0f62bf4$export$2e2bcd8739ae039)(t) || !t) return t;
    var r;
    if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) {
        var i = r.call(t, e || "default");
        if ("object" != (0, $7696f11ad0f62bf4$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === e ? String : Number)(t);
}


function $4b0913867851b6f1$export$2e2bcd8739ae039(t) {
    var i = (0, $e3d606cfe35b5b03$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $7696f11ad0f62bf4$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $80456ca0b72106f4$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $4b0913867851b6f1$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}



function $d31dd3f095a39781$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d31dd3f095a39781$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d31dd3f095a39781$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $80456ca0b72106f4$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d31dd3f095a39781$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}



var $5E6i4 = parcelRequire("5E6i4");


function $dbd531af97203a2f$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}



function $bffd9344780d0102$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $4b0913867851b6f1$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $bffd9344780d0102$export$2e2bcd8739ae039(e, r, t) {
    return r && $bffd9344780d0102$var$_defineProperties(e.prototype, r), t && $bffd9344780d0102$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}


function $79edb141786a9eb2$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $bd3cfbd7cb3737e3$export$2e2bcd8739ae039(t, e) {
    return $bd3cfbd7cb3737e3$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $bd3cfbd7cb3737e3$export$2e2bcd8739ae039(t, e);
}


function $a2290346d2002902$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $bd3cfbd7cb3737e3$export$2e2bcd8739ae039)(t, e);
}


function $58ea1d70f13cdd7b$export$2e2bcd8739ae039(t) {
    return $58ea1d70f13cdd7b$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $58ea1d70f13cdd7b$export$2e2bcd8739ae039(t);
}


function $61187a84a3929b6d$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($61187a84a3929b6d$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}




function $0d7092e07e4d94a7$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $7696f11ad0f62bf4$export$2e2bcd8739ae039)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $79edb141786a9eb2$export$2e2bcd8739ae039)(t);
}


function $2d7685868a992c15$export$2e2bcd8739ae039(t) {
    var r = (0, $61187a84a3929b6d$export$2e2bcd8739ae039)();
    return function() {
        var e, o = (0, $58ea1d70f13cdd7b$export$2e2bcd8739ae039)(t);
        if (r) {
            var s = (0, $58ea1d70f13cdd7b$export$2e2bcd8739ae039)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $0d7092e07e4d94a7$export$2e2bcd8739ae039)(this, e);
    };
}





var $a502855b675de36d$var$AbstractCalculator = /*#__PURE__*/ (0, $bffd9344780d0102$export$2e2bcd8739ae039)(function AbstractCalculator() {
    (0, $dbd531af97203a2f$export$2e2bcd8739ae039)(this, AbstractCalculator);
});
var $a502855b675de36d$export$2e2bcd8739ae039 = $a502855b675de36d$var$AbstractCalculator;


var $8a9e718c0e4c0b2f$var$CALC_UNIT = 'CALC_UNIT';
var $8a9e718c0e4c0b2f$var$regexp = new RegExp($8a9e718c0e4c0b2f$var$CALC_UNIT, 'g');
function $8a9e718c0e4c0b2f$var$unit(value) {
    if (typeof value === 'number') return "".concat(value).concat($8a9e718c0e4c0b2f$var$CALC_UNIT);
    return value;
}
var $8a9e718c0e4c0b2f$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AbstractCalculator) {
    (0, $a2290346d2002902$export$2e2bcd8739ae039)(CSSCalculator, _AbstractCalculator);
    var _super = (0, $2d7685868a992c15$export$2e2bcd8739ae039)(CSSCalculator);
    function CSSCalculator(num, unitlessCssVar) {
        var _this;
        (0, $dbd531af97203a2f$export$2e2bcd8739ae039)(this, CSSCalculator);
        _this = _super.call(this);
        (0, $80456ca0b72106f4$export$2e2bcd8739ae039)((0, $79edb141786a9eb2$export$2e2bcd8739ae039)(_this), "result", '');
        (0, $80456ca0b72106f4$export$2e2bcd8739ae039)((0, $79edb141786a9eb2$export$2e2bcd8739ae039)(_this), "unitlessCssVar", void 0);
        (0, $80456ca0b72106f4$export$2e2bcd8739ae039)((0, $79edb141786a9eb2$export$2e2bcd8739ae039)(_this), "lowPriority", void 0);
        var numType = (0, $7696f11ad0f62bf4$export$2e2bcd8739ae039)(num);
        _this.unitlessCssVar = unitlessCssVar;
        if (num instanceof CSSCalculator) _this.result = "(".concat(num.result, ")");
        else if (numType === 'number') _this.result = $8a9e718c0e4c0b2f$var$unit(num);
        else if (numType === 'string') _this.result = num;
        return _this;
    }
    (0, $bffd9344780d0102$export$2e2bcd8739ae039)(CSSCalculator, [
        {
            key: "add",
            value: function add(num) {
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " + ").concat(num.getResult());
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " + ").concat($8a9e718c0e4c0b2f$var$unit(num));
                this.lowPriority = true;
                return this;
            }
        },
        {
            key: "sub",
            value: function sub(num) {
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " - ").concat(num.getResult());
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " - ").concat($8a9e718c0e4c0b2f$var$unit(num));
                this.lowPriority = true;
                return this;
            }
        },
        {
            key: "mul",
            value: function mul(num) {
                if (this.lowPriority) this.result = "(".concat(this.result, ")");
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " * ").concat(num.getResult(true));
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " * ").concat(num);
                this.lowPriority = false;
                return this;
            }
        },
        {
            key: "div",
            value: function div(num) {
                if (this.lowPriority) this.result = "(".concat(this.result, ")");
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " / ").concat(num.getResult(true));
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " / ").concat(num);
                this.lowPriority = false;
                return this;
            }
        },
        {
            key: "getResult",
            value: function getResult(force) {
                return this.lowPriority || force ? "(".concat(this.result, ")") : this.result;
            }
        },
        {
            key: "equal",
            value: function equal(options) {
                var _this2 = this;
                var _ref = options || {}, cssUnit = _ref.unit;
                var mergedUnit = true;
                if (typeof cssUnit === 'boolean') mergedUnit = cssUnit;
                else if (Array.from(this.unitlessCssVar).some(function(cssVar) {
                    return _this2.result.includes(cssVar);
                })) mergedUnit = false;
                this.result = this.result.replace($8a9e718c0e4c0b2f$var$regexp, mergedUnit ? 'px' : '');
                if (typeof this.lowPriority !== 'undefined') return "calc(".concat(this.result, ")");
                return this.result;
            }
        }
    ]);
    return CSSCalculator;
}((0, $a502855b675de36d$export$2e2bcd8739ae039));









var $00533edce40193da$var$NumCalculator = /*#__PURE__*/ function(_AbstractCalculator) {
    (0, $a2290346d2002902$export$2e2bcd8739ae039)(NumCalculator, _AbstractCalculator);
    var _super = (0, $2d7685868a992c15$export$2e2bcd8739ae039)(NumCalculator);
    function NumCalculator(num) {
        var _this;
        (0, $dbd531af97203a2f$export$2e2bcd8739ae039)(this, NumCalculator);
        _this = _super.call(this);
        (0, $80456ca0b72106f4$export$2e2bcd8739ae039)((0, $79edb141786a9eb2$export$2e2bcd8739ae039)(_this), "result", 0);
        if (num instanceof NumCalculator) _this.result = num.result;
        else if (typeof num === 'number') _this.result = num;
        return _this;
    }
    (0, $bffd9344780d0102$export$2e2bcd8739ae039)(NumCalculator, [
        {
            key: "add",
            value: function add(num) {
                if (num instanceof NumCalculator) this.result += num.result;
                else if (typeof num === 'number') this.result += num;
                return this;
            }
        },
        {
            key: "sub",
            value: function sub(num) {
                if (num instanceof NumCalculator) this.result -= num.result;
                else if (typeof num === 'number') this.result -= num;
                return this;
            }
        },
        {
            key: "mul",
            value: function mul(num) {
                if (num instanceof NumCalculator) this.result *= num.result;
                else if (typeof num === 'number') this.result *= num;
                return this;
            }
        },
        {
            key: "div",
            value: function div(num) {
                if (num instanceof NumCalculator) this.result /= num.result;
                else if (typeof num === 'number') this.result /= num;
                return this;
            }
        },
        {
            key: "equal",
            value: function equal() {
                return this.result;
            }
        }
    ]);
    return NumCalculator;
}((0, $a502855b675de36d$export$2e2bcd8739ae039));
var $00533edce40193da$export$2e2bcd8739ae039 = $00533edce40193da$var$NumCalculator;


var $586127cbc24697c5$var$genCalc = function genCalc(type, unitlessCssVar) {
    var Calculator = type === 'css' ? (0, $8a9e718c0e4c0b2f$export$2e2bcd8739ae039) : (0, $00533edce40193da$export$2e2bcd8739ae039);
    return function(num) {
        return new Calculator(num, unitlessCssVar);
    };
};
var $586127cbc24697c5$export$2e2bcd8739ae039 = $586127cbc24697c5$var$genCalc;


var $37f6284134079ea9$var$getCompVarPrefix = function getCompVarPrefix(component, prefix) {
    return "".concat([
        prefix,
        component.replace(/([A-Z]+)([A-Z][a-z]+)/g, '$1-$2').replace(/([a-z])([A-Z])/g, '$1-$2')
    ].filter(Boolean).join('-'));
};
var $37f6284134079ea9$export$2e2bcd8739ae039 = $37f6284134079ea9$var$getCompVarPrefix;





function $5c3b81bd115de9fd$var$getComponentToken(component, token, defaultToken, options) {
    var customToken = (0, $d31dd3f095a39781$export$2e2bcd8739ae039)({}, token[component]);
    if (options !== null && options !== void 0 && options.deprecatedTokens) {
        var deprecatedTokens = options.deprecatedTokens;
        deprecatedTokens.forEach(function(_ref) {
            var _ref2 = (0, $9f30dc2f29991165$export$2e2bcd8739ae039)(_ref, 2), oldTokenKey = _ref2[0], newTokenKey = _ref2[1];
            // Should wrap with `if` clause, or there will be `undefined` in object.
            if (customToken !== null && customToken !== void 0 && customToken[oldTokenKey] || customToken !== null && customToken !== void 0 && customToken[newTokenKey]) {
                var _customToken$newToken;
                (_customToken$newToken = customToken[newTokenKey]) !== null && _customToken$newToken !== void 0 ? _customToken$newToken : customToken[newTokenKey] = customToken === null || customToken === void 0 ? void 0 : customToken[oldTokenKey];
            }
        });
    }
    var mergedToken = (0, $d31dd3f095a39781$export$2e2bcd8739ae039)((0, $d31dd3f095a39781$export$2e2bcd8739ae039)({}, defaultToken), customToken);
    // Remove same value as global token to minimize size
    Object.keys(mergedToken).forEach(function(key) {
        if (mergedToken[key] === token[key]) delete mergedToken[key];
    });
    return mergedToken;
}
var $5c3b81bd115de9fd$export$2e2bcd8739ae039 = $5c3b81bd115de9fd$var$getComponentToken;




var $f564548c7b6877d5$var$enableStatistic = typeof CSSINJS_STATISTIC !== 'undefined';
var $f564548c7b6877d5$var$recording = true;
function $f564548c7b6877d5$export$4950aa0f605343fb() {
    for(var _len = arguments.length, objs = new Array(_len), _key = 0; _key < _len; _key++)objs[_key] = arguments[_key];
    /* istanbul ignore next */ if (!$f564548c7b6877d5$var$enableStatistic) return Object.assign.apply(Object, [
        {}
    ].concat(objs));
    $f564548c7b6877d5$var$recording = false;
    var ret = {};
    objs.forEach(function(obj) {
        if ((0, $7696f11ad0f62bf4$export$2e2bcd8739ae039)(obj) !== 'object') return;
        var keys = Object.keys(obj);
        keys.forEach(function(key) {
            Object.defineProperty(ret, key, {
                configurable: true,
                enumerable: true,
                get: function get() {
                    return obj[key];
                }
            });
        });
    });
    $f564548c7b6877d5$var$recording = true;
    return ret;
}
var $f564548c7b6877d5$export$754a5e2d36c5fa7a = {};
var $f564548c7b6877d5$export$36157caab8bf9cbd = {};
/* istanbul ignore next */ function $f564548c7b6877d5$var$noop() {}
/** Statistic token usage case. Should use `merge` function if you do not want spread record. */ var $f564548c7b6877d5$var$statisticToken = function statisticToken(token) {
    var tokenKeys;
    var proxy = token;
    var flush = $f564548c7b6877d5$var$noop;
    if ($f564548c7b6877d5$var$enableStatistic && typeof Proxy !== 'undefined') {
        tokenKeys = new Set();
        proxy = new Proxy(token, {
            get: function get(obj, prop) {
                if ($f564548c7b6877d5$var$recording) {
                    var _tokenKeys;
                    (_tokenKeys = tokenKeys) === null || _tokenKeys === void 0 || _tokenKeys.add(prop);
                }
                return obj[prop];
            }
        });
        flush = function flush(componentName, componentToken) {
            var _statistic$componentN;
            $f564548c7b6877d5$export$754a5e2d36c5fa7a[componentName] = {
                global: Array.from(tokenKeys),
                component: (0, $d31dd3f095a39781$export$2e2bcd8739ae039)((0, $d31dd3f095a39781$export$2e2bcd8739ae039)({}, (_statistic$componentN = $f564548c7b6877d5$export$754a5e2d36c5fa7a[componentName]) === null || _statistic$componentN === void 0 ? void 0 : _statistic$componentN.component), componentToken)
            };
        };
    }
    return {
        token: proxy,
        keys: tokenKeys,
        flush: flush
    };
};
var $f564548c7b6877d5$export$2e2bcd8739ae039 = $f564548c7b6877d5$var$statisticToken;


function $f70ecd8dbc400853$var$getDefaultComponentToken(component, token, getDefaultToken) {
    if (typeof getDefaultToken === 'function') {
        var _token$component;
        return getDefaultToken((0, $f564548c7b6877d5$export$4950aa0f605343fb)(token, (_token$component = token[component]) !== null && _token$component !== void 0 ? _token$component : {}));
    }
    return getDefaultToken !== null && getDefaultToken !== void 0 ? getDefaultToken : {};
}
var $f70ecd8dbc400853$export$2e2bcd8739ae039 = $f70ecd8dbc400853$var$getDefaultComponentToken;



function $e46552670fbbd1a1$var$genMaxMin(type) {
    if (type === 'js') return {
        max: Math.max,
        min: Math.min
    };
    return {
        max: function max() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return "max(".concat(args.map(function(value) {
                return (0, $56bae8a99c3cba6e$export$523c0b569236b342)(value);
            }).join(','), ")");
        },
        min: function min() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return "min(".concat(args.map(function(value) {
                return (0, $56bae8a99c3cba6e$export$523c0b569236b342)(value);
            }).join(','), ")");
        }
    };
}
var $e46552670fbbd1a1$export$2e2bcd8739ae039 = $e46552670fbbd1a1$var$genMaxMin;








var $5E6i4 = parcelRequire("5E6i4");
var $55eb642f00f6f7e5$var$BEAT_LIMIT = 600000;
/**
 * A helper class to map keys to values.
 * It supports both primitive keys and object keys.
 */ var $55eb642f00f6f7e5$var$ArrayKeyMap = /*#__PURE__*/ function() {
    function ArrayKeyMap() {
        (0, $dbd531af97203a2f$export$2e2bcd8739ae039)(this, ArrayKeyMap);
        (0, $80456ca0b72106f4$export$2e2bcd8739ae039)(this, "map", new Map());
        // Use WeakMap to avoid memory leak
        (0, $80456ca0b72106f4$export$2e2bcd8739ae039)(this, "objectIDMap", new WeakMap());
        (0, $80456ca0b72106f4$export$2e2bcd8739ae039)(this, "nextID", 0);
        (0, $80456ca0b72106f4$export$2e2bcd8739ae039)(this, "lastAccessBeat", new Map());
        // We will clean up the cache when reach the limit
        (0, $80456ca0b72106f4$export$2e2bcd8739ae039)(this, "accessBeat", 0);
    }
    (0, $bffd9344780d0102$export$2e2bcd8739ae039)(ArrayKeyMap, [
        {
            key: "set",
            value: function set(keys, value) {
                // New set will trigger clear
                this.clear();
                // Set logic
                var compositeKey = this.getCompositeKey(keys);
                this.map.set(compositeKey, value);
                this.lastAccessBeat.set(compositeKey, Date.now());
            }
        },
        {
            key: "get",
            value: function get(keys) {
                var compositeKey = this.getCompositeKey(keys);
                var cache = this.map.get(compositeKey);
                this.lastAccessBeat.set(compositeKey, Date.now());
                this.accessBeat += 1;
                return cache;
            }
        },
        {
            key: "getCompositeKey",
            value: function getCompositeKey(keys) {
                var _this = this;
                var ids = keys.map(function(key) {
                    if (key && (0, $7696f11ad0f62bf4$export$2e2bcd8739ae039)(key) === 'object') return "obj_".concat(_this.getObjectID(key));
                    return "".concat((0, $7696f11ad0f62bf4$export$2e2bcd8739ae039)(key), "_").concat(key);
                });
                return ids.join('|');
            }
        },
        {
            key: "getObjectID",
            value: function getObjectID(obj) {
                if (this.objectIDMap.has(obj)) return this.objectIDMap.get(obj);
                var id = this.nextID;
                this.objectIDMap.set(obj, id);
                this.nextID += 1;
                return id;
            }
        },
        {
            key: "clear",
            value: function clear() {
                var _this2 = this;
                if (this.accessBeat > 10000) {
                    var now = Date.now();
                    this.lastAccessBeat.forEach(function(beat, key) {
                        if (now - beat > $55eb642f00f6f7e5$var$BEAT_LIMIT) {
                            _this2.map.delete(key);
                            _this2.lastAccessBeat.delete(key);
                        }
                    });
                    this.accessBeat = 0;
                }
            }
        }
    ]);
    return ArrayKeyMap;
}();
var $55eb642f00f6f7e5$var$uniqueMap = new $55eb642f00f6f7e5$var$ArrayKeyMap();
/**
 * Like `useMemo`, but this hook result will be shared across all instances.
 */ function $55eb642f00f6f7e5$var$useUniqueMemo(memoFn, deps) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useMemo(function() {
        var cachedValue = $55eb642f00f6f7e5$var$uniqueMap.get(deps);
        if (cachedValue) return cachedValue;
        var newValue = memoFn();
        $55eb642f00f6f7e5$var$uniqueMap.set(deps, newValue);
        return newValue;
    }, deps);
}
var $55eb642f00f6f7e5$export$2e2bcd8739ae039 = $55eb642f00f6f7e5$var$useUniqueMemo;


/**
 * Provide a default hook since not everyone needs to config this.
 */ var $bb386a78848d1b87$var$useDefaultCSP = function useDefaultCSP() {
    return {};
};
var $bb386a78848d1b87$export$2e2bcd8739ae039 = $bb386a78848d1b87$var$useDefaultCSP;


function $519343bcf6943d9f$var$genStyleUtils(config) {
    // Dependency inversion for preparing basic config.
    var _config$useCSP = config.useCSP, useCSP = _config$useCSP === void 0 ? (0, $bb386a78848d1b87$export$2e2bcd8739ae039) : _config$useCSP, useToken = config.useToken, usePrefix = config.usePrefix, getResetStyles = config.getResetStyles, getCommonStyle = config.getCommonStyle, getCompUnitless = config.getCompUnitless;
    function genStyleHooks(component, styleFn, getDefaultToken, options) {
        var componentName = Array.isArray(component) ? component[0] : component;
        function prefixToken(key) {
            return "".concat(String(componentName)).concat(key.slice(0, 1).toUpperCase()).concat(key.slice(1));
        }
        // Fill unitless
        var originUnitless = (options === null || options === void 0 ? void 0 : options.unitless) || {};
        var originCompUnitless = typeof getCompUnitless === 'function' ? getCompUnitless(component) : {};
        var compUnitless = (0, $d31dd3f095a39781$export$2e2bcd8739ae039)((0, $d31dd3f095a39781$export$2e2bcd8739ae039)({}, originCompUnitless), {}, (0, $80456ca0b72106f4$export$2e2bcd8739ae039)({}, prefixToken('zIndexPopup'), true));
        Object.keys(originUnitless).forEach(function(key) {
            compUnitless[prefixToken(key)] = originUnitless[key];
        });
        // Options
        var mergedOptions = (0, $d31dd3f095a39781$export$2e2bcd8739ae039)((0, $d31dd3f095a39781$export$2e2bcd8739ae039)({}, options), {}, {
            unitless: compUnitless,
            prefixToken: prefixToken
        });
        // Hooks
        var useStyle = genComponentStyleHook(component, styleFn, getDefaultToken, mergedOptions);
        var useCSSVar = genCSSVarRegister(componentName, getDefaultToken, mergedOptions);
        return function(prefixCls) {
            var rootCls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : prefixCls;
            var hashId = useStyle(prefixCls, rootCls);
            // Resolve function type to get dynamic extra prefix
            var extraPrefixCls = options === null || options === void 0 ? void 0 : options.extraCssVarPrefixCls;
            var resolvedExtraPrefixCls = typeof extraPrefixCls === 'function' ? extraPrefixCls({
                prefixCls: prefixCls,
                rootCls: rootCls
            }) : extraPrefixCls;
            var cssVarCls = useCSSVar(resolvedExtraPrefixCls !== null && resolvedExtraPrefixCls !== void 0 && resolvedExtraPrefixCls.length ? [
                rootCls
            ].concat((0, $0acfae8147afe964$export$2e2bcd8739ae039)(resolvedExtraPrefixCls)) : rootCls);
            return [
                hashId,
                cssVarCls
            ];
        };
    }
    function genCSSVarRegister(component, getDefaultToken, options) {
        var compUnitless = options.unitless, prefixToken = options.prefixToken, ignore = options.ignore;
        return function(rootCls) {
            var _useToken = useToken(), cssVar = _useToken.cssVar, realToken = _useToken.realToken;
            var csp = useCSP();
            (0, $a5bf63096405ab5f$export$2e2bcd8739ae039)({
                path: [
                    component
                ],
                prefix: cssVar.prefix,
                key: cssVar.key,
                unitless: compUnitless,
                ignore: ignore,
                token: realToken,
                scope: rootCls,
                nonce: function nonce() {
                    return csp.nonce;
                }
            }, function() {
                var defaultToken = (0, $f70ecd8dbc400853$export$2e2bcd8739ae039)(component, realToken, getDefaultToken);
                var componentToken = (0, $5c3b81bd115de9fd$export$2e2bcd8739ae039)(component, realToken, defaultToken, {
                    deprecatedTokens: options === null || options === void 0 ? void 0 : options.deprecatedTokens
                });
                if (defaultToken) Object.keys(defaultToken).forEach(function(key) {
                    componentToken[prefixToken(key)] = componentToken[key];
                    delete componentToken[key];
                });
                return componentToken;
            });
            return cssVar === null || cssVar === void 0 ? void 0 : cssVar.key;
        };
    }
    function genComponentStyleHook(componentName, styleFn, getDefaultToken) {
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var cells = Array.isArray(componentName) ? componentName : [
            componentName,
            componentName
        ];
        var _cells = (0, $9f30dc2f29991165$export$2e2bcd8739ae039)(cells, 1), component = _cells[0];
        var concatComponent = cells.join('-');
        var mergedLayer = config.layer || {
            name: 'antd'
        };
        // Return new style hook
        return function(prefixCls) {
            var rootCls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : prefixCls;
            var _useToken2 = useToken(), theme = _useToken2.theme, realToken = _useToken2.realToken, hashId = _useToken2.hashId, token = _useToken2.token, cssVar = _useToken2.cssVar, zeroRuntime = _useToken2.zeroRuntime;
            // Update of `disabledRuntimeStyle` would cause React hook error, so memoized it and never update.
            var memoizedZeroRuntime = (0, $5E6i4.useMemo)(function() {
                return zeroRuntime;
            }, []);
            if (memoizedZeroRuntime) return hashId;
            var _usePrefix = usePrefix(), rootPrefixCls = _usePrefix.rootPrefixCls, iconPrefixCls = _usePrefix.iconPrefixCls;
            var csp = useCSP();
            var type = 'css';
            // Use unique memo to share the result across all instances
            var calc = (0, $55eb642f00f6f7e5$export$2e2bcd8739ae039)(function() {
                var unitlessCssVar = new Set();
                Object.keys(options.unitless || {}).forEach(function(key) {
                    // Some component proxy the AliasToken (e.g. Image) and some not (e.g. Modal)
                    // We should both pass in `unitlessCssVar` to make sure the CSSVar can be unitless.
                    unitlessCssVar.add((0, $c0aeb8a4ecafde61$export$309b3b095f0c7662)(key, cssVar.prefix));
                    unitlessCssVar.add((0, $c0aeb8a4ecafde61$export$309b3b095f0c7662)(key, (0, $37f6284134079ea9$export$2e2bcd8739ae039)(component, cssVar.prefix)));
                });
                return (0, $586127cbc24697c5$export$2e2bcd8739ae039)(type, unitlessCssVar);
            }, [
                type,
                component,
                cssVar === null || cssVar === void 0 ? void 0 : cssVar.prefix
            ]);
            var _genMaxMin = (0, $e46552670fbbd1a1$export$2e2bcd8739ae039)(type), max = _genMaxMin.max, min = _genMaxMin.min;
            // Shared config
            var sharedConfig = {
                theme: theme,
                token: token,
                hashId: hashId,
                nonce: function nonce() {
                    return csp.nonce;
                },
                clientOnly: options.clientOnly,
                layer: mergedLayer,
                // antd is always at top of styles
                order: options.order || -999
            };
            // This if statement is safe, as it will only be used if the generator has the function. It's not dynamic.
            if (typeof getResetStyles === 'function') // Generate style for all need reset tags.
            (0, $4f1ffbb71c2e9fc2$export$2e2bcd8739ae039)((0, $d31dd3f095a39781$export$2e2bcd8739ae039)((0, $d31dd3f095a39781$export$2e2bcd8739ae039)({}, sharedConfig), {}, {
                clientOnly: false,
                path: [
                    'Shared',
                    rootPrefixCls
                ]
            }), function() {
                return getResetStyles(token, {
                    prefix: {
                        rootPrefixCls: rootPrefixCls,
                        iconPrefixCls: iconPrefixCls
                    },
                    csp: csp
                });
            });
            (0, $4f1ffbb71c2e9fc2$export$2e2bcd8739ae039)((0, $d31dd3f095a39781$export$2e2bcd8739ae039)((0, $d31dd3f095a39781$export$2e2bcd8739ae039)({}, sharedConfig), {}, {
                path: [
                    concatComponent,
                    prefixCls,
                    iconPrefixCls
                ]
            }), function() {
                if (options.injectStyle === false) return [];
                var _statisticToken = (0, $f564548c7b6877d5$export$2e2bcd8739ae039)(token), proxyToken = _statisticToken.token, flush = _statisticToken.flush;
                var defaultComponentToken = (0, $f70ecd8dbc400853$export$2e2bcd8739ae039)(component, realToken, getDefaultToken);
                var componentCls = ".".concat(prefixCls);
                var componentToken = (0, $5c3b81bd115de9fd$export$2e2bcd8739ae039)(component, realToken, defaultComponentToken, {
                    deprecatedTokens: options.deprecatedTokens
                });
                if (defaultComponentToken && (0, $7696f11ad0f62bf4$export$2e2bcd8739ae039)(defaultComponentToken) === 'object') Object.keys(defaultComponentToken).forEach(function(key) {
                    defaultComponentToken[key] = "var(".concat((0, $c0aeb8a4ecafde61$export$309b3b095f0c7662)(key, (0, $37f6284134079ea9$export$2e2bcd8739ae039)(component, cssVar.prefix)), ")");
                });
                var mergedToken = (0, $f564548c7b6877d5$export$4950aa0f605343fb)(proxyToken, {
                    componentCls: componentCls,
                    prefixCls: prefixCls,
                    iconCls: ".".concat(iconPrefixCls),
                    antCls: ".".concat(rootPrefixCls),
                    calc: calc,
                    max: max,
                    min: min
                }, defaultComponentToken);
                var styleInterpolation = styleFn(mergedToken, {
                    hashId: hashId,
                    prefixCls: prefixCls,
                    rootPrefixCls: rootPrefixCls,
                    iconPrefixCls: iconPrefixCls
                });
                flush(component, componentToken);
                var commonStyle = typeof getCommonStyle === 'function' ? getCommonStyle(mergedToken, prefixCls, rootCls, options.resetFont) : null;
                return [
                    options.resetStyle === false ? null : commonStyle,
                    styleInterpolation
                ];
            });
            return hashId;
        };
    }
    function genSubStyleComponent(componentName, styleFn, getDefaultToken) {
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var useStyle = genComponentStyleHook(componentName, styleFn, getDefaultToken, (0, $d31dd3f095a39781$export$2e2bcd8739ae039)({
            resetStyle: false,
            // Sub Style should default after root one
            order: -998
        }, options));
        var StyledComponent = function StyledComponent(_ref) {
            var prefixCls = _ref.prefixCls, _ref$rootCls = _ref.rootCls, rootCls = _ref$rootCls === void 0 ? prefixCls : _ref$rootCls;
            useStyle(prefixCls, rootCls);
            return null;
        };
        return StyledComponent;
    }
    return {
        genStyleHooks: genStyleHooks,
        genSubStyleComponent: genSubStyleComponent,
        genComponentStyleHook: genComponentStyleHook
    };
}
var $519343bcf6943d9f$export$2e2bcd8739ae039 = $519343bcf6943d9f$var$genStyleUtils;









const { genStyleHooks: $761caadb5301aee1$export$51ec95de45185b42, genComponentStyleHook: $761caadb5301aee1$export$b8cc4ee2ee8cfbc8, genSubStyleComponent: $761caadb5301aee1$export$1537386bc155ea56 } = (0, $519343bcf6943d9f$export$2e2bcd8739ae039)({
    usePrefix: ()=>{
        const { getPrefixCls: getPrefixCls, iconPrefixCls: iconPrefixCls } = (0, $5E6i4.useContext)((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
        const rootPrefixCls = getPrefixCls();
        return {
            rootPrefixCls: rootPrefixCls,
            iconPrefixCls: iconPrefixCls
        };
    },
    useToken: ()=>{
        const [theme, realToken, hashId, token, cssVar, zeroRuntime] = (0, $cb3a44f4e76623bb$export$2e2bcd8739ae039)();
        return {
            theme: theme,
            realToken: realToken,
            hashId: hashId,
            token: token,
            cssVar: cssVar,
            zeroRuntime: zeroRuntime
        };
    },
    useCSP: ()=>{
        const { csp: csp } = (0, $5E6i4.useContext)((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
        return csp ?? {};
    },
    getResetStyles: (token, config)=>{
        const linkStyle = (0, $cd5a520fee8002b4$export$905d771977096614)(token);
        return [
            linkStyle,
            {
                '&': linkStyle
            },
            (0, $cd5a520fee8002b4$export$f1a0b31dfb234e7e)(config?.prefix.iconPrefixCls ?? (0, $519f2fad435b3034$export$eaca8ee5ed21b4e9))
        ];
    },
    getCommonStyle: (0, $cd5a520fee8002b4$export$689382c111559cd9),
    getCompUnitless: ()=>(0, $cb3a44f4e76623bb$export$c6b9faa6b723d31a)
});
const $761caadb5301aee1$export$d82b8f66c5649e14 = (antCls, component)=>{
    const cssPrefix = `--${antCls.replace(/\./g, '')}-${component}-`;
    const varName = (name)=>{
        return `${cssPrefix}${name}`;
    };
    const varRef = (name, fallback)=>{
        return fallback ? `var(${cssPrefix}${name}, ${fallback})` : `var(${cssPrefix}${name})`;
    };
    return [
        varName,
        varRef
    ];
};



const $2ae04a4b84d557a2$var$genWaveStyle = (token)=>{
    const { componentCls: componentCls, colorPrimary: colorPrimary, motionDurationSlow: motionDurationSlow, motionEaseInOut: motionEaseInOut, motionEaseOutCirc: motionEaseOutCirc, antCls: antCls } = token;
    const [, varRef] = (0, $761caadb5301aee1$export$d82b8f66c5649e14)(antCls, 'wave');
    return {
        [componentCls]: {
            position: 'absolute',
            background: 'transparent',
            pointerEvents: 'none',
            boxSizing: 'border-box',
            color: varRef('color', colorPrimary),
            boxShadow: `0 0 0 0 currentcolor`,
            opacity: 0.2,
            // =================== Motion ===================
            '&.wave-motion-appear': {
                transition: [
                    `box-shadow 0.4s`,
                    `opacity 2s`
                ].map((prop)=>`${prop} ${motionEaseOutCirc}`).join(','),
                '&-active': {
                    boxShadow: `0 0 0 6px currentcolor`,
                    opacity: 0
                },
                '&.wave-quick': {
                    transition: [
                        `box-shadow`,
                        `opacity`
                    ].map((prop)=>`${prop} ${motionDurationSlow} ${motionEaseInOut}`).join(',')
                }
            }
        }
    };
};
var $2ae04a4b84d557a2$export$2e2bcd8739ae039 = (0, $761caadb5301aee1$export$b8cc4ee2ee8cfbc8)('Wave', $2ae04a4b84d557a2$var$genWaveStyle);



var $5E6i4 = parcelRequire("5E6i4");




const $fb5e646f63645964$export$23466a5792b7a5d3 = `${(0, $519f2fad435b3034$export$e4ec87ea71f29b41)}-wave-target`;



var $5E6i4 = parcelRequire("5E6i4");








const $0a54ab730c367751$export$9d61ea039e87eb91 = (color)=>{
    if (!color) return false;
    return (0, $addbc2fddcbb77a9$export$844ec244b1367d54)(color) && color !== '#fff' && color !== '#ffffff' && color !== 'rgb(255, 255, 255)' && color !== 'rgba(255, 255, 255, 1)' && !/rgba\((?:\d*, ){3}0\)/i.test(color) && // any transparent rgba color
    !/^#(?:[0-9a-f]{3}0|[0-9a-f]{6}00)$/i.test(color) && // any transparent hex color
    color !== 'transparent' && color !== 'canvastext';
};
function $0a54ab730c367751$export$651d8e9c80304fc8(node, colorSource = null) {
    const style = getComputedStyle(node);
    const { borderTopColor: borderTopColor, borderColor: borderColor, backgroundColor: backgroundColor } = style;
    if (colorSource && $0a54ab730c367751$export$9d61ea039e87eb91(style[colorSource])) return style[colorSource];
    return [
        borderTopColor,
        borderColor,
        backgroundColor
    ].find($0a54ab730c367751$export$9d61ea039e87eb91) ?? null;
}


"use client";
function $e61e4fbaa15a1a13$var$validateNum(value) {
    return Number.isNaN(value) ? 0 : value;
}
const $e61e4fbaa15a1a13$var$WaveEffect = (props)=>{
    const { className: className, target: target, component: component, colorSource: colorSource } = props;
    const divRef = $5E6i4.useRef(null);
    const { getPrefixCls: getPrefixCls } = $5E6i4.useContext((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
    const rootPrefixCls = getPrefixCls();
    const [varName] = (0, $761caadb5301aee1$export$d82b8f66c5649e14)(rootPrefixCls, 'wave');
    // ===================== Effect =====================
    const [waveColor, setWaveColor] = $5E6i4.useState(null);
    const [borderRadius, setBorderRadius] = $5E6i4.useState([]);
    const [left, setLeft] = $5E6i4.useState(0);
    const [top, setTop] = $5E6i4.useState(0);
    const [width, setWidth] = $5E6i4.useState(0);
    const [height, setHeight] = $5E6i4.useState(0);
    const [enabled, setEnabled] = $5E6i4.useState(false);
    const waveStyle = {
        left: left,
        top: top,
        width: width,
        height: height,
        borderRadius: borderRadius.map((radius)=>`${radius}px`).join(' ')
    };
    if (waveColor) waveStyle[varName('color')] = waveColor;
    function syncPos() {
        const nodeStyle = getComputedStyle(target);
        // Get wave color from target
        setWaveColor((0, $0a54ab730c367751$export$651d8e9c80304fc8)(target, colorSource));
        const isStatic = nodeStyle.position === 'static';
        // Rect
        const { borderLeftWidth: borderLeftWidth, borderTopWidth: borderTopWidth } = nodeStyle;
        setLeft(isStatic ? target.offsetLeft : $e61e4fbaa15a1a13$var$validateNum(-Number.parseFloat(borderLeftWidth)));
        setTop(isStatic ? target.offsetTop : $e61e4fbaa15a1a13$var$validateNum(-Number.parseFloat(borderTopWidth)));
        setWidth(target.offsetWidth);
        setHeight(target.offsetHeight);
        // Get border radius
        const { borderTopLeftRadius: borderTopLeftRadius, borderTopRightRadius: borderTopRightRadius, borderBottomLeftRadius: borderBottomLeftRadius, borderBottomRightRadius: borderBottomRightRadius } = nodeStyle;
        setBorderRadius([
            borderTopLeftRadius,
            borderTopRightRadius,
            borderBottomRightRadius,
            borderBottomLeftRadius
        ].map((radius)=>$e61e4fbaa15a1a13$var$validateNum(Number.parseFloat(radius))));
    }
    $5E6i4.useEffect(()=>{
        if (target) {
            // We need delay to check position here
            // since UI may change after click
            const id = (0, $1d949665862f071a$export$2e2bcd8739ae039)(()=>{
                syncPos();
                setEnabled(true);
            });
            // Add resize observer to follow size
            let resizeObserver;
            if (typeof ResizeObserver !== 'undefined') {
                resizeObserver = new ResizeObserver(syncPos);
                resizeObserver.observe(target);
            }
            return ()=>{
                (0, $1d949665862f071a$export$2e2bcd8739ae039).cancel(id);
                resizeObserver?.disconnect();
            };
        }
    }, [
        target
    ]);
    if (!enabled) return null;
    const isSmallComponent = (component === 'Checkbox' || component === 'Radio') && target?.classList.contains((0, $fb5e646f63645964$export$23466a5792b7a5d3));
    return /*#__PURE__*/ $5E6i4.createElement((0, $5371a8954d0d2416$export$2e2bcd8739ae039), {
        visible: true,
        motionAppear: true,
        motionName: "wave-motion",
        motionDeadline: 5000,
        onAppearEnd: (_, event)=>{
            if (event.deadline || (0, $addbc2fddcbb77a9$export$9e6f93c2a213a96b)(event) && event.propertyName === 'opacity') {
                const holder = divRef.current?.parentElement;
                (0, $ffa1d788dcb0dd15$export$121e2d597d222bad)(holder).then(()=>{
                    holder?.remove();
                });
            }
            return false;
        }
    }, ({ className: motionClassName }, ref)=>/*#__PURE__*/ $5E6i4.createElement("div", {
            ref: (0, $92c8c75386168ffc$export$ab452c34e8e05029)(divRef, ref),
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(className, motionClassName, {
                'wave-quick': isSmallComponent
            }),
            style: waveStyle
        }));
};
const $e61e4fbaa15a1a13$var$showWaveEffect = (target, info)=>{
    const { component: component } = info;
    // Skip for unchecked checkbox
    if (component === 'Checkbox' && !target.querySelector('input')?.checked) return;
    // Create holder
    const holder = document.createElement('div');
    holder.style.position = 'absolute';
    holder.style.left = '0px';
    holder.style.top = '0px';
    target?.insertBefore(holder, target?.firstChild);
    (0, $ffa1d788dcb0dd15$export$b3890eb0ae9dca99)(/*#__PURE__*/ $5E6i4.createElement($e61e4fbaa15a1a13$var$WaveEffect, {
        ...info,
        target: target
    }), holder);
};
var $e61e4fbaa15a1a13$export$2e2bcd8739ae039 = $e61e4fbaa15a1a13$var$showWaveEffect;


const $9d5163625454e586$var$useWave = (nodeRef, className, component, colorSource)=>{
    const { wave: wave } = $5E6i4.useContext((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
    const [, token, hashId] = (0, $cb3a44f4e76623bb$export$2e2bcd8739ae039)();
    const showWave = (0, $68990f4402d2f009$export$2e2bcd8739ae039)((event)=>{
        const node = nodeRef.current;
        if (wave?.disabled || !node) return;
        const targetNode = node.querySelector(`.${(0, $fb5e646f63645964$export$23466a5792b7a5d3)}`) || node;
        const { showEffect: showEffect } = wave || {};
        // Customize wave effect
        (showEffect || (0, $e61e4fbaa15a1a13$export$2e2bcd8739ae039))(targetNode, {
            className: className,
            token: token,
            component: component,
            event: event,
            hashId: hashId,
            colorSource: colorSource
        });
    });
    const rafIdRef = $5E6i4.useRef(null);
    // Clean up RAF on unmount to prevent memory leaks and stale callbacks
    $5E6i4.useEffect(()=>()=>{
            (0, $1d949665862f071a$export$2e2bcd8739ae039).cancel(rafIdRef.current);
        }, []);
    // Merge trigger event into one for each frame
    const showDebounceWave = (event)=>{
        (0, $1d949665862f071a$export$2e2bcd8739ae039).cancel(rafIdRef.current);
        rafIdRef.current = (0, $1d949665862f071a$export$2e2bcd8739ae039)(()=>{
            showWave(event);
        });
    };
    return showDebounceWave;
};
var $9d5163625454e586$export$2e2bcd8739ae039 = $9d5163625454e586$var$useWave;


const $fac597d347ed38a8$var$TRIGGER_TYPE_TO_EVENT_MAP = {
    click: 'click',
    mousedown: 'mousedown',
    mouseup: 'mouseup',
    pointerdown: 'pointerdown',
    pointerup: 'pointerup'
};
const $fac597d347ed38a8$var$Wave = (props)=>{
    const { children: children, disabled: disabled, component: component, colorSource: colorSource } = props;
    const { getPrefixCls: getPrefixCls, wave: wave } = (0, $5E6i4.useContext)((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
    const containerRef = (0, $5E6i4.useRef)(null);
    // ============================== Style ===============================
    const prefixCls = getPrefixCls('wave');
    const hashId = (0, $2ae04a4b84d557a2$export$2e2bcd8739ae039)(prefixCls);
    // =============================== Wave ===============================
    const showWave = (0, $9d5163625454e586$export$2e2bcd8739ae039)(containerRef, (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, hashId), component, colorSource);
    // ============================== Effect ==============================
    (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useEffect(()=>{
        const node = containerRef.current;
        if (!node || node.nodeType !== window.Node.ELEMENT_NODE || disabled) return;
        const onClick = (e)=>{
            // Fix radio button click twice
            if (!(0, $8fba40dfe94c55fb$export$2e2bcd8739ae039)(e.target) || !node.getAttribute || node.getAttribute('disabled') || node.disabled || node.className.includes('disabled') && !node.className.includes('disabled:') || node.getAttribute('aria-disabled') === 'true' || node.className.includes('-leave')) return;
            showWave(e);
        };
        const triggerType = wave?.triggerType;
        const eventName = triggerType && triggerType in $fac597d347ed38a8$var$TRIGGER_TYPE_TO_EVENT_MAP ? $fac597d347ed38a8$var$TRIGGER_TYPE_TO_EVENT_MAP[triggerType] : 'click';
        node.addEventListener(eventName, onClick, true);
        return ()=>{
            node.removeEventListener(eventName, onClick, true);
        };
    }, [
        disabled,
        wave?.triggerType
    ]);
    // ============================== Render ==============================
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).isValidElement(children)) return children ?? null;
    const ref = (0, $92c8c75386168ffc$export$c1cec34af06bcf7)(children) ? (0, $92c8c75386168ffc$export$ab452c34e8e05029)((0, $92c8c75386168ffc$export$7465e5c0bf44f19a)(children), containerRef) : containerRef;
    return (0, $552e20b6ec4e63a6$export$e530037191fcd5d7)(children, {
        ref: ref
    });
};
var $fac597d347ed38a8$export$2e2bcd8739ae039 = $fac597d347ed38a8$var$Wave;





var $5E6i4 = parcelRequire("5E6i4");


const $4bfc7567df2a969e$var$useSize = (customSize)=>{
    const size = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useContext((0, $d7f139cecf1d3086$export$2e2bcd8739ae039));
    const mergedSize = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useMemo(()=>{
        if (!customSize) return size;
        if ((0, $addbc2fddcbb77a9$export$844ec244b1367d54)(customSize)) return customSize ?? size;
        if ((0, $addbc2fddcbb77a9$export$f6e2535fb5126e54)(customSize)) return customSize(size);
        return size;
    }, [
        customSize,
        size
    ]);
    return mergedSize;
};
var $4bfc7567df2a969e$export$2e2bcd8739ae039 = $4bfc7567df2a969e$var$useSize;



var $5E6i4 = parcelRequire("5E6i4");



var $5E6i4 = parcelRequire("5E6i4");
const $a77e455e2dd6afec$var$isValidOrientation = (orientation)=>{
    return orientation === 'horizontal' || orientation === 'vertical';
};
const $a77e455e2dd6afec$export$550084c67147f6c4 = (orientation, vertical, legacyDirection)=>{
    return (0, $5E6i4.useMemo)(()=>{
        const validOrientation = $a77e455e2dd6afec$var$isValidOrientation(orientation);
        let mergedOrientation;
        if (validOrientation) mergedOrientation = orientation;
        else if (typeof vertical === 'boolean') mergedOrientation = vertical ? 'vertical' : 'horizontal';
        else {
            const validLegacyDirection = $a77e455e2dd6afec$var$isValidOrientation(legacyDirection);
            mergedOrientation = validLegacyDirection ? legacyDirection : 'horizontal';
        }
        return [
            mergedOrientation,
            mergedOrientation === 'vertical'
        ];
    }, [
        legacyDirection,
        orientation,
        vertical
    ]);
};






const $a0942a2fc5220a28$var$genSpaceCompactStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            display: 'inline-flex',
            '&-block': {
                display: 'flex',
                width: '100%'
            },
            '&-vertical': {
                flexDirection: 'column'
            },
            '&-rtl': {
                direction: 'rtl'
            }
        }
    };
};
var // ============================== Export ==============================
$a0942a2fc5220a28$export$2e2bcd8739ae039 = (0, $761caadb5301aee1$export$51ec95de45185b42)([
    'Space',
    'Compact'
], $a0942a2fc5220a28$var$genSpaceCompactStyle, ()=>({}), {
    // Space component don't apply extra font style
    // https://github.com/ant-design/ant-design/issues/40315
    resetStyle: false
});


"use client";
const $3ee2444c5d59b36b$export$8d1c486ac0db0a7d = /*#__PURE__*/ $5E6i4.createContext(null);
const $3ee2444c5d59b36b$export$cd8cf9d7bab8dd4 = (prefixCls, direction)=>{
    const compactItemContext = $5E6i4.useContext($3ee2444c5d59b36b$export$8d1c486ac0db0a7d);
    const compactItemClassnames = $5E6i4.useMemo(()=>{
        if (!compactItemContext) return '';
        const { compactDirection: compactDirection, isFirstItem: isFirstItem, isLastItem: isLastItem } = compactItemContext;
        const separator = compactDirection === 'vertical' ? '-vertical-' : '-';
        return (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-compact${separator}item`, {
            [`${prefixCls}-compact${separator}first-item`]: isFirstItem,
            [`${prefixCls}-compact${separator}last-item`]: isLastItem,
            [`${prefixCls}-compact${separator}item-rtl`]: direction === 'rtl'
        });
    }, [
        prefixCls,
        direction,
        compactItemContext
    ]);
    return {
        compactSize: compactItemContext?.compactSize,
        compactDirection: compactItemContext?.compactDirection,
        compactItemClassnames: compactItemClassnames
    };
};
const $3ee2444c5d59b36b$export$5f56e610a4afb685 = (props)=>{
    const { children: children } = props;
    return /*#__PURE__*/ $5E6i4.createElement($3ee2444c5d59b36b$export$8d1c486ac0db0a7d.Provider, {
        value: null
    }, children);
};
const $3ee2444c5d59b36b$var$CompactItem = (props)=>{
    const { children: children, ...others } = props;
    return /*#__PURE__*/ $5E6i4.createElement($3ee2444c5d59b36b$export$8d1c486ac0db0a7d.Provider, {
        value: $5E6i4.useMemo(()=>others, [
            others
        ])
    }, children);
};
const $3ee2444c5d59b36b$var$Compact = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { getPrefixCls: getPrefixCls, direction: directionConfig } = $5E6i4.useContext((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
    const { size: size, direction: direction, orientation: orientation, block: block, prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, children: children, vertical: vertical, ...restProps } = props;
    const [mergedOrientation, mergedVertical] = (0, $a77e455e2dd6afec$export$550084c67147f6c4)(orientation, vertical, direction);
    const mergedSize = (0, $4bfc7567df2a969e$export$2e2bcd8739ae039)((ctx)=>size ?? ctx);
    const prefixCls = getPrefixCls('space-compact', customizePrefixCls);
    const [hashId] = (0, $a0942a2fc5220a28$export$2e2bcd8739ae039)(prefixCls);
    const clx = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, hashId, {
        [`${prefixCls}-rtl`]: directionConfig === 'rtl',
        [`${prefixCls}-block`]: block,
        [`${prefixCls}-vertical`]: mergedVertical
    }, className, rootClassName);
    const compactItemContext = $5E6i4.useContext($3ee2444c5d59b36b$export$8d1c486ac0db0a7d);
    const nativeElementRef = $5E6i4.useRef(null);
    $5E6i4.useImperativeHandle(ref, ()=>({
            nativeElement: nativeElementRef.current
        }));
    const childNodes = (0, $2ec1a2166f2295ea$export$2e2bcd8739ae039)(children);
    const nodes = $5E6i4.useMemo(()=>childNodes.map((child, i)=>{
            const key = child?.key || `${prefixCls}-item-${i}`;
            return /*#__PURE__*/ $5E6i4.createElement($3ee2444c5d59b36b$var$CompactItem, {
                key: key,
                compactSize: mergedSize,
                compactDirection: mergedOrientation,
                isFirstItem: i === 0 && (!compactItemContext || compactItemContext?.isFirstItem),
                isLastItem: i === childNodes.length - 1 && (!compactItemContext || compactItemContext?.isLastItem)
            }, child);
        }), [
        childNodes,
        compactItemContext,
        mergedOrientation,
        mergedSize,
        prefixCls
    ]);
    // =========================== Render ===========================
    if (childNodes.length === 0) return null;
    return /*#__PURE__*/ $5E6i4.createElement("div", {
        ref: nativeElementRef,
        className: clx,
        ...restProps
    }, nodes);
});
var $3ee2444c5d59b36b$export$2e2bcd8739ae039 = $3ee2444c5d59b36b$var$Compact;



var $5E6i4 = parcelRequire("5E6i4");




"use client";
const $655f74bac8d466a0$export$ed0cc8bd1f617d6d = /*#__PURE__*/ $5E6i4.createContext(undefined);
const $655f74bac8d466a0$var$ButtonGroup = (props)=>{
    const { getPrefixCls: getPrefixCls, direction: direction } = $5E6i4.useContext((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, size: size, className: className, ...others } = props;
    const prefixCls = getPrefixCls('btn-group', customizePrefixCls);
    const [, , hashId] = (0, $cb3a44f4e76623bb$export$2e2bcd8739ae039)();
    const sizeCls = $5E6i4.useMemo(()=>{
        switch(size){
            case 'large':
                return 'lg';
            case 'small':
                return 'sm';
            default:
                return '';
        }
    }, [
        size
    ]);
    const classes = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, {
        [`${prefixCls}-${sizeCls}`]: sizeCls,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, className, hashId);
    return /*#__PURE__*/ $5E6i4.createElement($655f74bac8d466a0$export$ed0cc8bd1f617d6d.Provider, {
        value: size
    }, /*#__PURE__*/ $5E6i4.createElement("div", {
        ...others,
        className: classes
    }));
};
var $655f74bac8d466a0$export$2e2bcd8739ae039 = $655f74bac8d466a0$var$ButtonGroup;




var $5E6i4 = parcelRequire("5E6i4");





"use client";
const $0ceddc1355cab302$var$rxTwoCNChar = /^[\u4E00-\u9FA5]{2}$/;
const $0ceddc1355cab302$export$c5dca2bf412dea0d = $0ceddc1355cab302$var$rxTwoCNChar.test.bind($0ceddc1355cab302$var$rxTwoCNChar);
function $0ceddc1355cab302$export$19bc9a290855952(type) {
    if (type === 'danger') return {
        danger: true
    };
    return {
        type: type
    };
}
function $0ceddc1355cab302$export$b120bc11c0d9c214(type) {
    return type === 'text' || type === 'link';
}
function $0ceddc1355cab302$var$splitCNCharsBySpace(child, needInserted, style, className) {
    if (!(0, $b63de2b9864a5d1a$export$72280d5f896dac9a)(child)) return;
    const SPACE = needInserted ? ' ' : '';
    if (!(0, $addbc2fddcbb77a9$export$844ec244b1367d54)(child) && !(0, $addbc2fddcbb77a9$export$7e4aa119212bc614)(child) && (0, $addbc2fddcbb77a9$export$844ec244b1367d54)(child.type) && $0ceddc1355cab302$export$c5dca2bf412dea0d(child.props.children)) return (0, $552e20b6ec4e63a6$export$e530037191fcd5d7)(child, (oriProps)=>{
        const mergedCls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(oriProps.className, className) || undefined;
        const mergedStyle = {
            ...style,
            ...oriProps.style
        };
        return {
            ...oriProps,
            children: oriProps.children.split('').join(SPACE),
            className: mergedCls,
            style: mergedStyle
        };
    });
    if ((0, $addbc2fddcbb77a9$export$844ec244b1367d54)(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("span", {
        className: className,
        style: style
    }, $0ceddc1355cab302$export$c5dca2bf412dea0d(child) ? child.split('').join(SPACE) : child);
    if ((0, $552e20b6ec4e63a6$export$9522e17588c12572)(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("span", {
        className: className,
        style: style
    }, child);
    return (0, $552e20b6ec4e63a6$export$e530037191fcd5d7)(child, (oriProps)=>({
            ...oriProps,
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(oriProps.className, className) || undefined,
            style: {
                ...oriProps.style,
                ...style
            }
        }));
}
function $0ceddc1355cab302$export$b6ee00a7e7908bc(children, needInserted, style, className) {
    let isPrevChildPure = false;
    const childList = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).Children.forEach(children, (child)=>{
        const isCurrentChildPure = (0, $addbc2fddcbb77a9$export$844ec244b1367d54)(child) || (0, $addbc2fddcbb77a9$export$7e4aa119212bc614)(child);
        if (isPrevChildPure && isCurrentChildPure) {
            const lastIndex = childList.length - 1;
            const lastChild = childList[lastIndex];
            childList[lastIndex] = `${lastChild}${child}`;
        } else childList.push(child);
        isPrevChildPure = isCurrentChildPure;
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).Children.map(childList, (child)=>$0ceddc1355cab302$var$splitCNCharsBySpace(child, needInserted, style, className));
}
const $0ceddc1355cab302$var$_ButtonTypes = [
    'default',
    'primary',
    'dashed',
    'link',
    'text'
];
const $0ceddc1355cab302$var$_ButtonShapes = [
    'default',
    'circle',
    'round',
    'square'
];
const $0ceddc1355cab302$var$_ButtonHTMLTypes = [
    'submit',
    'button',
    'reset'
];
const $0ceddc1355cab302$export$9870b52452f51da5 = [
    'outlined',
    'dashed',
    'solid',
    'filled',
    'text',
    'link'
];
const $0ceddc1355cab302$export$760f16d96e091fc5 = [
    'default',
    'primary',
    'danger'
].concat((0, $0acfae8147afe964$export$2e2bcd8739ae039)((0, $2535cf92607464fc$export$6d4fe3a00a1811ad)));



var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $c905b28ae1aafbff$var$LoadingOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"
                }
            }
        ]
    },
    "name": "loading",
    "theme": "outlined"
};
var $c905b28ae1aafbff$export$2e2bcd8739ae039 = $c905b28ae1aafbff$var$LoadingOutlined;



function $6e3183dc0ea574da$var$_extends() {
    $6e3183dc0ea574da$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6e3183dc0ea574da$var$_extends.apply(this, arguments);
}
const $6e3183dc0ea574da$var$LoadingOutlined = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $6e3183dc0ea574da$var$_extends({}, props, {
        ref: ref,
        icon: (0, $c905b28ae1aafbff$export$2e2bcd8739ae039)
    }));
/**![loading](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk4OCA1NDhjLTE5LjkgMC0zNi0xNi4xLTM2LTM2IDAtNTkuNC0xMS42LTExNy0zNC42LTE3MS4zYTQ0MC40NSA0NDAuNDUgMCAwMC05NC4zLTEzOS45IDQzNy43MSA0MzcuNzEgMCAwMC0xMzkuOS05NC4zQzYyOSA4My42IDU3MS40IDcyIDUxMiA3MmMtMTkuOSAwLTM2LTE2LjEtMzYtMzZzMTYuMS0zNiAzNi0zNmM2OS4xIDAgMTM2LjIgMTMuNSAxOTkuMyA0MC4zQzc3Mi4zIDY2IDgyNyAxMDMgODc0IDE1MGM0NyA0NyA4My45IDEwMS44IDEwOS43IDE2Mi43IDI2LjcgNjMuMSA0MC4yIDEzMC4yIDQwLjIgMTk5LjMuMSAxOS45LTE2IDM2LTM1LjkgMzZ6IiAvPjwvc3ZnPg==) */ const $6e3183dc0ea574da$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($6e3183dc0ea574da$var$LoadingOutlined);
var $6e3183dc0ea574da$export$2e2bcd8739ae039 = $6e3183dc0ea574da$var$RefIcon;





var $5E6i4 = parcelRequire("5E6i4");

"use client";
const $c298a5de1fa72642$var$IconWrapper = /*#__PURE__*/ (0, $5E6i4.forwardRef)((props, ref)=>{
    const { className: className, style: style, children: children, prefixCls: prefixCls } = props;
    const iconWrapperCls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-icon`, className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("span", {
        ref: ref,
        className: iconWrapperCls,
        style: style
    }, children);
});
var $c298a5de1fa72642$export$2e2bcd8739ae039 = $c298a5de1fa72642$var$IconWrapper;


"use client";
const $6679be160185d5d2$var$InnerLoadingIcon = /*#__PURE__*/ (0, $5E6i4.forwardRef)((props, ref)=>{
    const { prefixCls: prefixCls, className: className, style: style, iconClassName: iconClassName } = props;
    const mergedIconCls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-loading-icon`, className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $c298a5de1fa72642$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        className: mergedIconCls,
        style: style,
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $6e3183dc0ea574da$export$2e2bcd8739ae039), {
        className: iconClassName
    }));
});
const $6679be160185d5d2$var$getCollapsedWidth = ()=>({
        width: 0,
        opacity: 0,
        transform: 'scale(0)'
    });
const $6679be160185d5d2$var$getRealWidth = (node)=>({
        width: node.scrollWidth,
        opacity: 1,
        transform: 'scale(1)'
    });
const $6679be160185d5d2$var$DefaultLoadingIcon = (props)=>{
    const { prefixCls: prefixCls, loading: loading, existIcon: existIcon, className: className, style: style, mount: mount } = props;
    const visible = !!loading;
    if (existIcon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement($6679be160185d5d2$var$InnerLoadingIcon, {
        prefixCls: prefixCls,
        className: className,
        style: style
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $5371a8954d0d2416$export$2e2bcd8739ae039), {
        visible: visible,
        // Used for minus flex gap style only
        motionName: `${prefixCls}-loading-icon-motion`,
        motionAppear: !mount,
        motionEnter: !mount,
        motionLeave: !mount,
        removeOnLeave: true,
        onAppearStart: $6679be160185d5d2$var$getCollapsedWidth,
        onAppearActive: $6679be160185d5d2$var$getRealWidth,
        onEnterStart: $6679be160185d5d2$var$getCollapsedWidth,
        onEnterActive: $6679be160185d5d2$var$getRealWidth,
        onLeaveStart: $6679be160185d5d2$var$getRealWidth,
        onLeaveActive: $6679be160185d5d2$var$getCollapsedWidth
    }, ({ className: motionCls, style: motionStyle }, ref)=>{
        const mergedStyle = {
            ...style,
            ...motionStyle
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement($6679be160185d5d2$var$InnerLoadingIcon, {
            prefixCls: prefixCls,
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(className, motionCls),
            style: mergedStyle,
            ref: ref
        });
    });
};
var $6679be160185d5d2$export$2e2bcd8739ae039 = $6679be160185d5d2$var$DefaultLoadingIcon;





const $3c4103d4365d19b7$export$c5b4e7cabb00fc99 = ()=>{
    return {
        '@media (prefers-reduced-motion: reduce)': {
            '&, &::before, &::after': {
                transition: 'none',
                animation: 'none'
            }
        }
    };
};
const $3c4103d4365d19b7$export$a2e3d2d19d960234 = ()=>{
    return {
        '@media (prefers-reduced-motion: reduce)': {
            transition: 'none',
            animation: 'none'
        }
    };
};



const $e80920bfeccccb6e$var$genButtonBorderStyle = (buttonTypeCls, borderColor)=>({
        // Border
        [`> span, > ${buttonTypeCls}`]: {
            '&:not(:last-child)': {
                [`&, & > ${buttonTypeCls}`]: {
                    '&:not(:disabled)': {
                        borderInlineEndColor: borderColor
                    }
                }
            },
            '&:not(:first-child)': {
                [`&, & > ${buttonTypeCls}`]: {
                    '&:not(:disabled)': {
                        borderInlineStartColor: borderColor
                    }
                }
            }
        }
    });
const $e80920bfeccccb6e$var$genGroupStyle = (token)=>{
    const { componentCls: componentCls, fontSize: fontSize, lineWidth: lineWidth, groupBorderColor: groupBorderColor, colorErrorHover: colorErrorHover } = token;
    return {
        [`${componentCls}-group`]: [
            {
                position: 'relative',
                display: 'inline-flex',
                // Border
                [`> span, > ${componentCls}`]: {
                    '&:not(:last-child)': {
                        [`&, & > ${componentCls}`]: {
                            borderStartEndRadius: 0,
                            borderEndEndRadius: 0
                        }
                    },
                    '&:not(:first-child)': {
                        marginInlineStart: token.calc(lineWidth).mul(-1).equal(),
                        [`&, & > ${componentCls}`]: {
                            borderStartStartRadius: 0,
                            borderEndStartRadius: 0
                        }
                    }
                },
                [componentCls]: {
                    position: 'relative',
                    zIndex: 1,
                    '&:hover, &:focus, &:active': {
                        zIndex: 2
                    },
                    '&[disabled]': {
                        zIndex: 0
                    }
                },
                [`${componentCls}-icon-only`]: {
                    fontSize: fontSize
                }
            },
            // Border Color
            $e80920bfeccccb6e$var$genButtonBorderStyle(`${componentCls}-primary`, groupBorderColor),
            $e80920bfeccccb6e$var$genButtonBorderStyle(`${componentCls}-danger`, colorErrorHover)
        ]
    };
};
var $e80920bfeccccb6e$export$2e2bcd8739ae039 = $e80920bfeccccb6e$var$genGroupStyle;






var $5E6i4 = parcelRequire("5E6i4");

const $7d4443f868094485$export$8d6531175688484b = (value)=>Math.round(Number(value || 0));
const $7d4443f868094485$var$convertHsb2Hsv = (color)=>{
    if (color instanceof (0, $1b0a692e36565107$export$2c4f38d6c0ecc25a)) return color;
    if (color && typeof color === 'object' && 'h' in color && 'b' in color) {
        const { b: b, ...resets } = color;
        return {
            ...resets,
            v: b
        };
    }
    if (typeof color === 'string' && /hsb/.test(color)) return color.replace(/hsb/, 'hsv');
    return color;
};
class $7d4443f868094485$export$892596cec99bc70e extends (0, $1b0a692e36565107$export$2c4f38d6c0ecc25a) {
    constructor(color){
        super($7d4443f868094485$var$convertHsb2Hsv(color));
    }
    toHsbString() {
        const hsb = this.toHsb();
        const saturation = $7d4443f868094485$export$8d6531175688484b(hsb.s * 100);
        const lightness = $7d4443f868094485$export$8d6531175688484b(hsb.b * 100);
        const hue = $7d4443f868094485$export$8d6531175688484b(hsb.h);
        const alpha = hsb.a;
        const hsbString = `hsb(${hue}, ${saturation}%, ${lightness}%)`;
        const hsbaString = `hsba(${hue}, ${saturation}%, ${lightness}%, ${alpha.toFixed(alpha === 0 ? 0 : 2)})`;
        return alpha === 1 ? hsbString : hsbaString;
    }
    toHsb() {
        const { v: v, ...resets } = this.toHsv();
        return {
            ...resets,
            b: v,
            a: this.a
        };
    }
}


const $189d00b65785a77b$export$90004e2badfbdf1f = 'rc-color-picker';
const $189d00b65785a77b$export$c844f5d21427d1ab = (color)=>{
    if (color instanceof (0, $7d4443f868094485$export$892596cec99bc70e)) return color;
    return new (0, $7d4443f868094485$export$892596cec99bc70e)(color);
};
const $189d00b65785a77b$export$f705f0fde43a55a = $189d00b65785a77b$export$c844f5d21427d1ab('#1677ff');
const $189d00b65785a77b$export$3a7095e9fd85a71d = (props)=>{
    const { offset: offset, targetRef: targetRef, containerRef: containerRef, color: color, type: type } = props;
    const { width: width, height: height } = containerRef.current.getBoundingClientRect();
    const { width: targetWidth, height: targetHeight } = targetRef.current.getBoundingClientRect();
    const centerOffsetX = targetWidth / 2;
    const centerOffsetY = targetHeight / 2;
    const saturation = (offset.x + centerOffsetX) / width;
    const bright = 1 - (offset.y + centerOffsetY) / height;
    const hsb = color.toHsb();
    const alphaOffset = saturation;
    const hueOffset = (offset.x + centerOffsetX) / width * 360;
    if (type) switch(type){
        case 'hue':
            return $189d00b65785a77b$export$c844f5d21427d1ab({
                ...hsb,
                h: hueOffset <= 0 ? 0 : hueOffset
            });
        case 'alpha':
            return $189d00b65785a77b$export$c844f5d21427d1ab({
                ...hsb,
                a: alphaOffset <= 0 ? 0 : alphaOffset
            });
    }
    return $189d00b65785a77b$export$c844f5d21427d1ab({
        h: hsb.h,
        s: saturation <= 0 ? 0 : saturation,
        b: bright >= 1 ? 1 : bright,
        a: hsb.a
    });
};
const $189d00b65785a77b$export$20165527867cbf14 = (color, type)=>{
    const hsb = color.toHsb();
    switch(type){
        case 'hue':
            return {
                x: hsb.h / 360 * 100,
                y: 50
            };
        case 'alpha':
            return {
                x: color.a * 100,
                y: 50
            };
        // Picker panel
        default:
            return {
                x: hsb.s * 100,
                y: (1 - hsb.b) * 100
            };
    }
};






var $5E6i4 = parcelRequire("5E6i4");
const $f4363a266513f6eb$var$ColorBlock = ({ color: color, prefixCls: prefixCls, className: className, style: style, innerClassName: innerClassName, innerStyle: innerStyle, onClick: onClick })=>{
    const colorBlockCls = `${prefixCls}-color-block`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(colorBlockCls, className),
        style: style,
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${colorBlockCls}-inner`, innerClassName),
        style: {
            background: color,
            ...innerStyle
        }
    }));
};
var $f4363a266513f6eb$export$2e2bcd8739ae039 = $f4363a266513f6eb$var$ColorBlock;



var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");
function $2abb289935aa66f2$var$getPosition(e) {
    const obj = 'touches' in e ? e.touches[0] : e;
    const scrollXOffset = document.documentElement.scrollLeft || document.body.scrollLeft || window.pageXOffset;
    const scrollYOffset = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
    return {
        pageX: obj.pageX - scrollXOffset,
        pageY: obj.pageY - scrollYOffset
    };
}
function $2abb289935aa66f2$var$useColorDrag(props) {
    const { targetRef: targetRef, containerRef: containerRef, direction: direction, onDragChange: onDragChange, onDragChangeComplete: onDragChangeComplete, calculate: calculate, color: color, disabledDrag: disabledDrag } = props;
    const [offsetValue, setOffsetValue] = (0, $5E6i4.useState)({
        x: 0,
        y: 0
    });
    const mouseMoveRef = (0, $5E6i4.useRef)(null);
    const mouseUpRef = (0, $5E6i4.useRef)(null);
    // Always get position from `color`
    (0, $5E6i4.useEffect)(()=>{
        setOffsetValue(calculate());
    }, [
        color
    ]);
    (0, $5E6i4.useEffect)(()=>()=>{
            document.removeEventListener('mousemove', mouseMoveRef.current);
            document.removeEventListener('mouseup', mouseUpRef.current);
            document.removeEventListener('touchmove', mouseMoveRef.current);
            document.removeEventListener('touchend', mouseUpRef.current);
            mouseMoveRef.current = null;
            mouseUpRef.current = null;
        }, []);
    const updateOffset = (e)=>{
        const { pageX: pageX, pageY: pageY } = $2abb289935aa66f2$var$getPosition(e);
        const { x: rectX, y: rectY, width: width, height: height } = containerRef.current.getBoundingClientRect();
        const { width: targetWidth, height: targetHeight } = targetRef.current.getBoundingClientRect();
        const centerOffsetX = targetWidth / 2;
        const centerOffsetY = targetHeight / 2;
        const offsetX = Math.max(0, Math.min(pageX - rectX, width)) - centerOffsetX;
        const offsetY = Math.max(0, Math.min(pageY - rectY, height)) - centerOffsetY;
        const calcOffset = {
            x: offsetX,
            y: direction === 'x' ? offsetValue.y : offsetY
        };
        // Exclusion of boundary cases
        if (targetWidth === 0 && targetHeight === 0 || targetWidth !== targetHeight) return false;
        onDragChange?.(calcOffset);
    };
    const onDragMove = (e)=>{
        e.preventDefault();
        updateOffset(e);
    };
    const onDragStop = (e)=>{
        e.preventDefault();
        document.removeEventListener('mousemove', mouseMoveRef.current);
        document.removeEventListener('mouseup', mouseUpRef.current);
        document.removeEventListener('touchmove', mouseMoveRef.current);
        document.removeEventListener('touchend', mouseUpRef.current);
        mouseMoveRef.current = null;
        mouseUpRef.current = null;
        onDragChangeComplete?.();
    };
    const onDragStart = (e)=>{
        // https://github.com/ant-design/ant-design/issues/43529
        document.removeEventListener('mousemove', mouseMoveRef.current);
        document.removeEventListener('mouseup', mouseUpRef.current);
        if (disabledDrag) return;
        updateOffset(e);
        document.addEventListener('mousemove', onDragMove);
        document.addEventListener('mouseup', onDragStop);
        document.addEventListener('touchmove', onDragMove);
        document.addEventListener('touchend', onDragStop);
        mouseMoveRef.current = onDragMove;
        mouseUpRef.current = onDragStop;
    };
    return [
        offsetValue,
        onDragStart
    ];
}
var $2abb289935aa66f2$export$2e2bcd8739ae039 = $2abb289935aa66f2$var$useColorDrag;






var $5E6i4 = parcelRequire("5E6i4");
const $819800cb34067995$var$Handler = ({ size: size = 'default', color: color, prefixCls: prefixCls })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-handler`, {
            [`${prefixCls}-handler-sm`]: size === 'small'
        }),
        style: {
            backgroundColor: color
        }
    });
};
var $819800cb34067995$export$2e2bcd8739ae039 = $819800cb34067995$var$Handler;



var $5E6i4 = parcelRequire("5E6i4");
const $169f55b970fcd437$var$Palette = ({ children: children, style: style, prefixCls: prefixCls })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("div", {
        className: `${prefixCls}-palette`,
        style: {
            position: 'relative',
            ...style
        }
    }, children);
};
var $169f55b970fcd437$export$2e2bcd8739ae039 = $169f55b970fcd437$var$Palette;



var $5E6i4 = parcelRequire("5E6i4");
const $84e2f60bc5bffca4$var$Transform = /*#__PURE__*/ (0, $5E6i4.forwardRef)((props, ref)=>{
    const { children: children, x: x, y: y } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("div", {
        ref: ref,
        style: {
            position: 'absolute',
            left: `${x}%`,
            top: `${y}%`,
            zIndex: 1,
            transform: 'translate(-50%, -50%)'
        }
    }, children);
});
var $84e2f60bc5bffca4$export$2e2bcd8739ae039 = $84e2f60bc5bffca4$var$Transform;


const $8ce57558c97a414a$var$Picker = ({ color: color, onChange: onChange, prefixCls: prefixCls, onChangeComplete: onChangeComplete, disabled: disabled })=>{
    const pickerRef = (0, $5E6i4.useRef)();
    const transformRef = (0, $5E6i4.useRef)();
    const colorRef = (0, $5E6i4.useRef)(color);
    const onDragChange = (0, $68990f4402d2f009$export$2e2bcd8739ae039)((offsetValue)=>{
        const calcColor = (0, $189d00b65785a77b$export$3a7095e9fd85a71d)({
            offset: offsetValue,
            targetRef: transformRef,
            containerRef: pickerRef,
            color: color
        });
        colorRef.current = calcColor;
        onChange(calcColor);
    });
    const [offset, dragStartHandle] = (0, $2abb289935aa66f2$export$2e2bcd8739ae039)({
        color: color,
        containerRef: pickerRef,
        targetRef: transformRef,
        calculate: ()=>(0, $189d00b65785a77b$export$20165527867cbf14)(color),
        onDragChange: onDragChange,
        onDragChangeComplete: ()=>onChangeComplete?.(colorRef.current),
        disabledDrag: disabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("div", {
        ref: pickerRef,
        className: `${prefixCls}-select`,
        onMouseDown: dragStartHandle,
        onTouchStart: dragStartHandle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $169f55b970fcd437$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $84e2f60bc5bffca4$export$2e2bcd8739ae039), {
        x: offset.x,
        y: offset.y,
        ref: transformRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $819800cb34067995$export$2e2bcd8739ae039), {
        color: color.toRgbString(),
        prefixCls: prefixCls
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("div", {
        className: `${prefixCls}-saturation`,
        style: {
            backgroundColor: `hsl(${color.toHsb().h},100%, 50%)`,
            backgroundImage: 'linear-gradient(0deg, #000, transparent),linear-gradient(90deg, #fff, hsla(0, 0%, 100%, 0))'
        }
    })));
};
var $8ce57558c97a414a$export$2e2bcd8739ae039 = $8ce57558c97a414a$var$Picker;




var $5E6i4 = parcelRequire("5E6i4");

const $f1367c2af637eb33$var$useColorState = (defaultValue, value)=>{
    const [mergedValue, setValue] = (0, $e18df22f16a16360$export$2e2bcd8739ae039)(defaultValue, value);
    const color = (0, $5E6i4.useMemo)(()=>(0, $189d00b65785a77b$export$c844f5d21427d1ab)(mergedValue), [
        mergedValue
    ]);
    return [
        color,
        setValue
    ];
};
var $f1367c2af637eb33$export$2e2bcd8739ae039 = $f1367c2af637eb33$var$useColorState;



var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");







var $5E6i4 = parcelRequire("5E6i4");


const $d368f16bd1a9e8d6$var$Gradient = ({ colors: colors, children: children, direction: direction = 'to right', type: type, prefixCls: prefixCls })=>{
    const gradientColors = (0, $5E6i4.useMemo)(()=>colors.map((color, idx)=>{
            let result = (0, $189d00b65785a77b$export$c844f5d21427d1ab)(color);
            if (type === 'alpha' && idx === colors.length - 1) result = new (0, $7d4443f868094485$export$892596cec99bc70e)(result.setA(1));
            return result.toRgbString();
        }).join(','), [
        colors,
        type
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("div", {
        className: `${prefixCls}-gradient`,
        style: {
            position: 'absolute',
            inset: 0,
            background: `linear-gradient(${direction}, ${gradientColors})`
        }
    }, children);
};
var $d368f16bd1a9e8d6$export$2e2bcd8739ae039 = $d368f16bd1a9e8d6$var$Gradient;




const $3efcd30085de7bd2$var$Slider = (props)=>{
    const { prefixCls: prefixCls, colors: colors, disabled: disabled, onChange: onChange, onChangeComplete: onChangeComplete, color: color, type: type } = props;
    const sliderRef = (0, $5E6i4.useRef)(null);
    const transformRef = (0, $5E6i4.useRef)(null);
    const colorRef = (0, $5E6i4.useRef)(color);
    const getValue = (c)=>{
        return type === 'hue' ? c.getHue() : c.a * 100;
    };
    const onDragChange = (0, $68990f4402d2f009$export$2e2bcd8739ae039)((offsetValue)=>{
        const calcColor = (0, $189d00b65785a77b$export$3a7095e9fd85a71d)({
            offset: offsetValue,
            targetRef: transformRef,
            containerRef: sliderRef,
            color: color,
            type: type
        });
        colorRef.current = calcColor;
        onChange(getValue(calcColor));
    });
    const [offset, dragStartHandle] = (0, $2abb289935aa66f2$export$2e2bcd8739ae039)({
        color: color,
        targetRef: transformRef,
        containerRef: sliderRef,
        calculate: ()=>(0, $189d00b65785a77b$export$20165527867cbf14)(color, type),
        onDragChange: onDragChange,
        onDragChangeComplete () {
            onChangeComplete(getValue(colorRef.current));
        },
        direction: 'x',
        disabledDrag: disabled
    });
    const handleColor = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useMemo(()=>{
        if (type === 'hue') {
            const hsb = color.toHsb();
            hsb.s = 1;
            hsb.b = 1;
            hsb.a = 1;
            const lightColor = new (0, $7d4443f868094485$export$892596cec99bc70e)(hsb);
            return lightColor;
        }
        return color;
    }, [
        color,
        type
    ]);
    // ========================= Gradient =========================
    const gradientList = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useMemo(()=>colors.map((info)=>`${info.color} ${info.percent}%`), [
        colors
    ]);
    // ========================== Render ==========================
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("div", {
        ref: sliderRef,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-slider`, `${prefixCls}-slider-${type}`),
        onMouseDown: dragStartHandle,
        onTouchStart: dragStartHandle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $169f55b970fcd437$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $84e2f60bc5bffca4$export$2e2bcd8739ae039), {
        x: offset.x,
        y: offset.y,
        ref: transformRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $819800cb34067995$export$2e2bcd8739ae039), {
        size: "small",
        color: handleColor.toHexString(),
        prefixCls: prefixCls
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $d368f16bd1a9e8d6$export$2e2bcd8739ae039), {
        colors: gradientList,
        type: type,
        prefixCls: prefixCls
    })));
};
var $3efcd30085de7bd2$export$2e2bcd8739ae039 = $3efcd30085de7bd2$var$Slider;


function $0874b13c1c8a1c0a$export$2e2bcd8739ae039(components) {
    return $5E6i4.useMemo(()=>{
        const { slider: slider } = components || {};
        return [
            slider || (0, $3efcd30085de7bd2$export$2e2bcd8739ae039)
        ];
    }, [
        components
    ]);
}


function $8770e78cf45c97a1$var$_extends() {
    $8770e78cf45c97a1$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8770e78cf45c97a1$var$_extends.apply(this, arguments);
}
const $8770e78cf45c97a1$var$HUE_COLORS = [
    {
        color: 'rgb(255, 0, 0)',
        percent: 0
    },
    {
        color: 'rgb(255, 255, 0)',
        percent: 17
    },
    {
        color: 'rgb(0, 255, 0)',
        percent: 33
    },
    {
        color: 'rgb(0, 255, 255)',
        percent: 50
    },
    {
        color: 'rgb(0, 0, 255)',
        percent: 67
    },
    {
        color: 'rgb(255, 0, 255)',
        percent: 83
    },
    {
        color: 'rgb(255, 0, 0)',
        percent: 100
    }
];
const $8770e78cf45c97a1$var$ColorPicker = /*#__PURE__*/ (0, $5E6i4.forwardRef)((props, ref)=>{
    const { value: value, defaultValue: defaultValue, prefixCls: prefixCls = (0, $189d00b65785a77b$export$90004e2badfbdf1f), onChange: onChange, onChangeComplete: onChangeComplete, className: className, style: style, panelRender: panelRender, disabledAlpha: disabledAlpha = false, disabled: disabled = false, components: components } = props;
    // ========================== Components ==========================
    const [Slider] = (0, $0874b13c1c8a1c0a$export$2e2bcd8739ae039)(components);
    // ============================ Color =============================
    const [colorValue, setColorValue] = (0, $f1367c2af637eb33$export$2e2bcd8739ae039)(defaultValue || (0, $189d00b65785a77b$export$f705f0fde43a55a), value);
    const alphaColor = (0, $5E6i4.useMemo)(()=>colorValue.setA(1).toRgbString(), [
        colorValue
    ]);
    // ============================ Events ============================
    const handleChange = (data, type)=>{
        if (!value) setColorValue(data);
        onChange?.(data, type);
    };
    // Convert
    const getHueColor = (hue)=>new (0, $7d4443f868094485$export$892596cec99bc70e)(colorValue.setHue(hue));
    const getAlphaColor = (alpha)=>new (0, $7d4443f868094485$export$892596cec99bc70e)(colorValue.setA(alpha / 100));
    // Slider change
    const onHueChange = (hue)=>{
        handleChange(getHueColor(hue), {
            type: 'hue',
            value: hue
        });
    };
    const onAlphaChange = (alpha)=>{
        handleChange(getAlphaColor(alpha), {
            type: 'alpha',
            value: alpha
        });
    };
    // Complete
    const onHueChangeComplete = (hue)=>{
        if (onChangeComplete) onChangeComplete(getHueColor(hue));
    };
    const onAlphaChangeComplete = (alpha)=>{
        if (onChangeComplete) onChangeComplete(getAlphaColor(alpha));
    };
    // ============================ Render ============================
    const mergeCls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-panel`, className, {
        [`${prefixCls}-panel-disabled`]: disabled
    });
    const sharedSliderProps = {
        prefixCls: prefixCls,
        disabled: disabled,
        color: colorValue
    };
    const defaultPanel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $8ce57558c97a414a$export$2e2bcd8739ae039), $8770e78cf45c97a1$var$_extends({
        onChange: handleChange
    }, sharedSliderProps, {
        onChangeComplete: onChangeComplete
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("div", {
        className: `${prefixCls}-slider-container`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-slider-group`, {
            [`${prefixCls}-slider-group-disabled-alpha`]: disabledAlpha
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement(Slider, $8770e78cf45c97a1$var$_extends({}, sharedSliderProps, {
        type: "hue",
        colors: $8770e78cf45c97a1$var$HUE_COLORS,
        min: 0,
        max: 359,
        value: colorValue.getHue(),
        onChange: onHueChange,
        onChangeComplete: onHueChangeComplete
    })), !disabledAlpha && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement(Slider, $8770e78cf45c97a1$var$_extends({}, sharedSliderProps, {
        type: "alpha",
        colors: [
            {
                percent: 0,
                color: 'rgba(255, 0, 4, 0)'
            },
            {
                percent: 100,
                color: alphaColor
            }
        ],
        min: 0,
        max: 100,
        value: colorValue.a * 100,
        onChange: onAlphaChange,
        onChangeComplete: onAlphaChangeComplete
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $f4363a266513f6eb$export$2e2bcd8739ae039), {
        color: colorValue.toRgbString(),
        prefixCls: prefixCls
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("div", {
        className: mergeCls,
        style: style,
        ref: ref
    }, typeof panelRender === 'function' ? panelRender(defaultPanel) : defaultPanel);
});
var $8770e78cf45c97a1$export$2e2bcd8739ae039 = $8770e78cf45c97a1$var$ColorPicker;






var $946e3a4eb9ad349f$export$2e2bcd8739ae039 = (0, $8770e78cf45c97a1$export$2e2bcd8739ae039);


const $a3fe15cc837afc75$export$d0aa8b5e56c9af06 = (value, alpha)=>value?.replace(/[^0-9a-f]/gi, '').slice(0, alpha ? 8 : 6) || '';
const $a3fe15cc837afc75$export$6c90ef703dcfba25 = (value, alpha)=>value ? $a3fe15cc837afc75$export$d0aa8b5e56c9af06(value, alpha) : '';
let $a3fe15cc837afc75$export$e8cc8a2e87e145b4 = /*#__PURE__*/ function() {
    function AggregationColor(color) {
        (0, $dbd531af97203a2f$export$2e2bcd8739ae039)(this, AggregationColor);
        this.cleared = false;
        // Clone from another AggregationColor
        if (color instanceof AggregationColor) {
            this.metaColor = color.metaColor.clone();
            this.colors = color.colors?.map((info)=>({
                    color: new AggregationColor(info.color),
                    percent: info.percent
                }));
            this.cleared = color.cleared;
            return;
        }
        const isArray = Array.isArray(color);
        if (isArray && color.length) {
            this.colors = color.map(({ color: c, percent: percent })=>({
                    color: new AggregationColor(c),
                    percent: percent
                }));
            this.metaColor = new (0, $7d4443f868094485$export$892596cec99bc70e)(this.colors[0].color.metaColor);
        } else this.metaColor = new (0, $7d4443f868094485$export$892596cec99bc70e)(isArray ? '' : color);
        if (!color || isArray && !this.colors) {
            this.metaColor = this.metaColor.setA(0);
            this.cleared = true;
        }
    }
    return (0, $bffd9344780d0102$export$2e2bcd8739ae039)(AggregationColor, [
        {
            key: "toHsb",
            value: function toHsb() {
                return this.metaColor.toHsb();
            }
        },
        {
            key: "toHsbString",
            value: function toHsbString() {
                return this.metaColor.toHsbString();
            }
        },
        {
            key: "toHex",
            value: function toHex() {
                return $a3fe15cc837afc75$export$6c90ef703dcfba25(this.toHexString(), this.metaColor.a < 1);
            }
        },
        {
            key: "toHexString",
            value: function toHexString() {
                return this.metaColor.toHexString();
            }
        },
        {
            key: "toRgb",
            value: function toRgb() {
                return this.metaColor.toRgb();
            }
        },
        {
            key: "toRgbString",
            value: function toRgbString() {
                return this.metaColor.toRgbString();
            }
        },
        {
            key: "isGradient",
            value: function isGradient() {
                return !!this.colors && !this.cleared;
            }
        },
        {
            key: "getColors",
            value: function getColors() {
                return this.colors || [
                    {
                        color: this,
                        percent: 0
                    }
                ];
            }
        },
        {
            key: "toCssString",
            value: function toCssString() {
                const { colors: colors } = this;
                // CSS line-gradient
                if (colors) {
                    const colorsStr = colors.map((c)=>`${c.color.toRgbString()} ${c.percent}%`).join(', ');
                    return `linear-gradient(90deg, ${colorsStr})`;
                }
                return this.metaColor.toRgbString();
            }
        },
        {
            key: "equals",
            value: function equals(color) {
                if (!color || this.isGradient() !== color.isGradient()) return false;
                if (!this.isGradient()) return this.toHexString() === color.toHexString();
                return this.colors.length === color.colors.length && this.colors.every((c, i)=>{
                    const target = color.colors[i];
                    return c.percent === target.percent && c.color.equals(target.color);
                });
            }
        }
    ]);
}();



var $5E6i4 = parcelRequire("5E6i4");



var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $79e9008b22e35d50$var$RightOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z"
                }
            }
        ]
    },
    "name": "right",
    "theme": "outlined"
};
var $79e9008b22e35d50$export$2e2bcd8739ae039 = $79e9008b22e35d50$var$RightOutlined;



function $adbdeb3aab803740$var$_extends() {
    $adbdeb3aab803740$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $adbdeb3aab803740$var$_extends.apply(this, arguments);
}
const $adbdeb3aab803740$var$RightOutlined = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $adbdeb3aab803740$var$_extends({}, props, {
        ref: ref,
        icon: (0, $79e9008b22e35d50$export$2e2bcd8739ae039)
    }));
/**![right](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTc2NS43IDQ4Ni44TDMxNC45IDEzNC43QTcuOTcgNy45NyAwIDAwMzAyIDE0MXY3Ny4zYzAgNC45IDIuMyA5LjYgNi4xIDEyLjZsMzYwIDI4MS4xLTM2MCAyODEuMWMtMy45IDMtNi4xIDcuNy02LjEgMTIuNlY4ODNjMCA2LjcgNy43IDEwLjQgMTIuOSA2LjNsNDUwLjgtMzUyLjFhMzEuOTYgMzEuOTYgMCAwMDAtNTAuNHoiIC8+PC9zdmc+) */ const $adbdeb3aab803740$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($adbdeb3aab803740$var$RightOutlined);
var $adbdeb3aab803740$export$2e2bcd8739ae039 = $adbdeb3aab803740$var$RefIcon;


function $149d2f1aa8ebe3ec$export$2e2bcd8739ae039() {
    return $149d2f1aa8ebe3ec$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $149d2f1aa8ebe3ec$export$2e2bcd8739ae039.apply(null, arguments);
}






var $5E6i4 = parcelRequire("5E6i4");



var $5E6i4 = parcelRequire("5E6i4");





var $5E6i4 = parcelRequire("5E6i4");


var $5E6i4 = parcelRequire("5E6i4");
const $960336852064c9d0$var$PanelContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, forceRender: forceRender, className: className, style: style, children: children, isActive: isActive, role: role, classNames: customizeClassNames, styles: styles } = props;
    const [rendered, setRendered] = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useState(isActive || forceRender);
    (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useEffect(()=>{
        if (forceRender || isActive) setRendered(true);
    }, [
        forceRender,
        isActive
    ]);
    if (!rendered) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("div", {
        ref: ref,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-panel`, {
            [`${prefixCls}-panel-active`]: isActive,
            [`${prefixCls}-panel-inactive`]: !isActive
        }, className),
        style: style,
        role: role
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-body`, customizeClassNames?.body),
        style: styles?.body
    }, children));
});
var $960336852064c9d0$export$2e2bcd8739ae039 = $960336852064c9d0$var$PanelContent;


const $7c3cdab2e64d1d81$var$CollapsePanel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).forwardRef((props, ref)=>{
    const { showArrow: showArrow = true, headerClass: headerClass, isActive: isActive, onItemClick: onItemClick, forceRender: forceRender, className: className, classNames: customizeClassNames = {}, styles: styles = {}, prefixCls: prefixCls, collapsible: collapsible, accordion: accordion, panelKey: panelKey, extra: extra, header: header, expandIcon: expandIcon, openMotion: openMotion, destroyOnHidden: destroyOnHidden, children: children, ...resetProps } = props;
    const disabled = collapsible === 'disabled';
    const ifExtraExist = extra !== null && extra !== undefined && typeof extra !== 'boolean';
    const collapsibleProps = {
        onClick: ()=>{
            onItemClick?.(panelKey);
        },
        onKeyDown: (e)=>{
            if (e.key === 'Enter' || e.keyCode === (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).ENTER || e.which === (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).ENTER) onItemClick?.(panelKey);
        },
        role: accordion ? 'tab' : 'button',
        ['aria-expanded']: isActive,
        ['aria-disabled']: disabled,
        tabIndex: disabled ? -1 : 0
    };
    // ======================== Icon ========================
    const iconNodeInner = typeof expandIcon === 'function' ? expandIcon(props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("i", {
        className: "arrow"
    });
    const iconNode = iconNodeInner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("div", (0, $149d2f1aa8ebe3ec$export$2e2bcd8739ae039)({
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-expand-icon`, customizeClassNames?.icon),
        style: styles?.icon
    }, [
        'header',
        'icon'
    ].includes(collapsible) ? collapsibleProps : {}), iconNodeInner);
    const collapsePanelClassNames = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-item`, {
        [`${prefixCls}-item-active`]: isActive,
        [`${prefixCls}-item-disabled`]: disabled
    }, className);
    const headerClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(headerClass, `${prefixCls}-header`, {
        [`${prefixCls}-collapsible-${collapsible}`]: !!collapsible
    }, customizeClassNames?.header);
    // ======================== HeaderProps ========================
    const headerProps = {
        className: headerClassName,
        style: styles?.header,
        ...[
            'header',
            'icon'
        ].includes(collapsible) ? {} : collapsibleProps
    };
    // ======================== Render ========================
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("div", (0, $149d2f1aa8ebe3ec$export$2e2bcd8739ae039)({}, resetProps, {
        ref: ref,
        className: collapsePanelClassNames
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("div", headerProps, showArrow && iconNode, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("span", (0, $149d2f1aa8ebe3ec$export$2e2bcd8739ae039)({
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-title`, customizeClassNames?.title),
        style: styles?.title
    }, collapsible === 'header' ? collapsibleProps : {}), header), ifExtraExist && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("div", {
        className: `${prefixCls}-extra`
    }, extra)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $5371a8954d0d2416$export$2e2bcd8739ae039), (0, $149d2f1aa8ebe3ec$export$2e2bcd8739ae039)({
        visible: isActive,
        leavedClassName: `${prefixCls}-panel-hidden`
    }, openMotion, {
        forceRender: forceRender,
        removeOnLeave: destroyOnHidden
    }), ({ className: motionClassName, style: motionStyle }, motionRef)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $960336852064c9d0$export$2e2bcd8739ae039), {
            ref: motionRef,
            prefixCls: prefixCls,
            className: motionClassName,
            classNames: customizeClassNames,
            style: motionStyle,
            styles: styles,
            isActive: isActive,
            forceRender: forceRender,
            role: accordion ? 'tabpanel' : undefined
        }, children);
    }));
});
var $7c3cdab2e64d1d81$export$2e2bcd8739ae039 = $7c3cdab2e64d1d81$var$CollapsePanel;



function $4f7fcee2d045380a$var$mergeSemantic(src, tgt, mergeFn) {
    if (!src || !tgt) return src || tgt;
    const keys = Array.from(new Set([
        ...Object.keys(src),
        ...Object.keys(tgt)
    ]));
    const result = {};
    keys.forEach((key)=>{
        result[key] = mergeFn(src[key], tgt[key]);
    });
    return result;
}
function $4f7fcee2d045380a$var$mergeSemanticClassNames(src, tgt) {
    return $4f7fcee2d045380a$var$mergeSemantic(src, tgt, (a, b)=>(0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)(a, b));
}
function $4f7fcee2d045380a$var$mergeSemanticStyles(src, tgt) {
    return $4f7fcee2d045380a$var$mergeSemantic(src, tgt, (a, b)=>({
            ...a,
            ...b
        }));
}
const $4f7fcee2d045380a$var$convertItemsToNodes = (items, props)=>{
    const { prefixCls: prefixCls, accordion: accordion, collapsible: collapsible, destroyOnHidden: destroyOnHidden, onItemClick: onItemClick, activeKey: activeKey, openMotion: openMotion, expandIcon: expandIcon, classNames: collapseClassNames, styles: collapseStyles } = props;
    return items.map((item, index)=>{
        const { children: children, label: label, key: rawKey, collapsible: rawCollapsible, onItemClick: rawOnItemClick, destroyOnHidden: rawDestroyOnHidden, classNames: classNames, styles: styles, ...restProps } = item;
        // You may be puzzled why you want to convert them all into strings, me too.
        // Maybe: https://github.com/react-component/collapse/blob/aac303a8b6ff30e35060b4f8fecde6f4556fcbe2/src/Collapse.tsx#L15
        const key = String(rawKey ?? index);
        const mergeCollapsible = rawCollapsible ?? collapsible;
        const mergedDestroyOnHidden = rawDestroyOnHidden ?? destroyOnHidden;
        const handleItemClick = (value)=>{
            if (mergeCollapsible === 'disabled') return;
            onItemClick(value);
            rawOnItemClick?.(value);
        };
        let isActive = false;
        if (accordion) isActive = activeKey[0] === key;
        else isActive = activeKey.indexOf(key) > -1;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $7c3cdab2e64d1d81$export$2e2bcd8739ae039), (0, $149d2f1aa8ebe3ec$export$2e2bcd8739ae039)({}, restProps, {
            classNames: $4f7fcee2d045380a$var$mergeSemanticClassNames(collapseClassNames, classNames),
            styles: $4f7fcee2d045380a$var$mergeSemanticStyles(collapseStyles, styles),
            prefixCls: prefixCls,
            key: key,
            panelKey: key,
            isActive: isActive,
            accordion: accordion,
            openMotion: openMotion,
            expandIcon: expandIcon,
            header: label,
            collapsible: mergeCollapsible,
            onItemClick: handleItemClick,
            destroyOnHidden: mergedDestroyOnHidden
        }), children);
    });
};
/**
 * @deprecated The next major version will be removed
 */ const $4f7fcee2d045380a$var$getNewChild = (child, index, props)=>{
    if (!child) return null;
    const { prefixCls: prefixCls, accordion: accordion, collapsible: collapsible, destroyOnHidden: destroyOnHidden, onItemClick: onItemClick, activeKey: activeKey, openMotion: openMotion, expandIcon: expandIcon, classNames: collapseClassNames, styles: styles } = props;
    const key = child.key || String(index);
    const { header: header, headerClass: headerClass, destroyOnHidden: childDestroyOnHidden, collapsible: childCollapsible, onItemClick: childOnItemClick } = child.props;
    let isActive = false;
    if (accordion) isActive = activeKey[0] === key;
    else isActive = activeKey.indexOf(key) > -1;
    const mergeCollapsible = childCollapsible ?? collapsible;
    const handleItemClick = (value)=>{
        if (mergeCollapsible === 'disabled') return;
        onItemClick(value);
        childOnItemClick?.(value);
    };
    const childProps = {
        key: key,
        panelKey: key,
        header: header,
        headerClass: headerClass,
        classNames: collapseClassNames,
        styles: styles,
        isActive: isActive,
        prefixCls: prefixCls,
        destroyOnHidden: childDestroyOnHidden ?? destroyOnHidden,
        openMotion: openMotion,
        accordion: accordion,
        children: child.props.children,
        onItemClick: handleItemClick,
        expandIcon: expandIcon,
        collapsible: mergeCollapsible
    };
    // https://github.com/ant-design/ant-design/issues/20479
    if (typeof child.type === 'string') return child;
    Object.keys(childProps).forEach((propName)=>{
        if (typeof childProps[propName] === 'undefined') delete childProps[propName];
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).cloneElement(child, childProps);
};
function $4f7fcee2d045380a$var$useItems(items, rawChildren, props) {
    if (Array.isArray(items)) return $4f7fcee2d045380a$var$convertItemsToNodes(items, props);
    return (0, $2ec1a2166f2295ea$export$2e2bcd8739ae039)(rawChildren).map((child, index)=>$4f7fcee2d045380a$var$getNewChild(child, index, props));
}
var $4f7fcee2d045380a$export$2e2bcd8739ae039 = $4f7fcee2d045380a$var$useItems;




function $2d534c5221f3692d$var$getActiveKeysArray(activeKey) {
    let currentActiveKey = activeKey;
    if (!Array.isArray(currentActiveKey)) {
        const activeKeyType = typeof currentActiveKey;
        currentActiveKey = activeKeyType === 'number' || activeKeyType === 'string' ? [
            currentActiveKey
        ] : [];
    }
    return currentActiveKey.map((key)=>String(key));
}
const $2d534c5221f3692d$var$Collapse = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).forwardRef((props, ref)=>{
    const { prefixCls: prefixCls = 'rc-collapse', destroyOnHidden: destroyOnHidden = false, style: style, accordion: accordion, className: className, children: children, collapsible: collapsible, openMotion: openMotion, expandIcon: expandIcon, activeKey: rawActiveKey, defaultActiveKey: defaultActiveKey, onChange: onChange, items: items, classNames: customizeClassNames, styles: styles } = props;
    const collapseClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, className);
    const [internalActiveKey, setActiveKey] = (0, $e18df22f16a16360$export$2e2bcd8739ae039)(defaultActiveKey, rawActiveKey);
    const activeKey = $2d534c5221f3692d$var$getActiveKeysArray(internalActiveKey);
    const triggerActiveKey = (0, $68990f4402d2f009$export$2e2bcd8739ae039)((next)=>{
        const nextKeys = $2d534c5221f3692d$var$getActiveKeysArray(next);
        setActiveKey(nextKeys);
        onChange?.(nextKeys);
    });
    const onItemClick = (key)=>{
        if (accordion) triggerActiveKey(activeKey[0] === key ? [] : [
            key
        ]);
        else triggerActiveKey(activeKey.includes(key) ? activeKey.filter((item)=>item !== key) : [
            ...activeKey,
            key
        ]);
    };
    // ======================== Children ========================
    (0, $f757b9ac02fa080d$export$2e2bcd8739ae039)(!children, '[rc-collapse] `children` will be removed in next major version. Please use `items` instead.');
    const mergedChildren = (0, $4f7fcee2d045380a$export$2e2bcd8739ae039)(items, children, {
        prefixCls: prefixCls,
        accordion: accordion,
        openMotion: openMotion,
        expandIcon: expandIcon,
        collapsible: collapsible,
        destroyOnHidden: destroyOnHidden,
        onItemClick: onItemClick,
        activeKey: activeKey,
        classNames: customizeClassNames,
        styles: styles
    });
    // ======================== Render ========================
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("div", (0, $149d2f1aa8ebe3ec$export$2e2bcd8739ae039)({
        ref: ref,
        className: collapseClassName,
        style: style,
        role: accordion ? 'tablist' : undefined
    }, (0, $78cde6532419ffca$export$2e2bcd8739ae039)(props, {
        aria: true,
        data: true
    })), mergedChildren);
});
var $2d534c5221f3692d$export$2e2bcd8739ae039 = Object.assign($2d534c5221f3692d$var$Collapse, {
    /**
   * @deprecated use `items` instead, will be removed in `v4.0.0`
   */ Panel: (0, $7c3cdab2e64d1d81$export$2e2bcd8739ae039)
});


var $081354452b9aa732$export$2e2bcd8739ae039 = (0, $2d534c5221f3692d$export$2e2bcd8739ae039);
const { Panel: $081354452b9aa732$export$2ddb90ad54e5f587 } = (0, $2d534c5221f3692d$export$2e2bcd8739ae039);








// ================== Collapse Motion ==================
const $c2c363b881b49d51$var$getCollapsedHeight = ()=>({
        height: 0,
        opacity: 0
    });
const $c2c363b881b49d51$var$getRealHeight = (node)=>({
        height: node?.scrollHeight ?? 0,
        opacity: node ? 1 : 0
    });
const $c2c363b881b49d51$var$getCurrentHeight = (node)=>({
        height: node?.offsetHeight ?? 0
    });
const $c2c363b881b49d51$var$skipOpacityTransition = (_, event)=>{
    return event?.deadline === true || (0, $addbc2fddcbb77a9$export$9e6f93c2a213a96b)(event) && event.propertyName === 'height';
};
const $c2c363b881b49d51$var$initCollapseMotion = (rootCls = (0, $519f2fad435b3034$export$e4ec87ea71f29b41))=>({
        motionName: `${rootCls}-motion-collapse`,
        onAppearStart: $c2c363b881b49d51$var$getCollapsedHeight,
        onEnterStart: $c2c363b881b49d51$var$getCollapsedHeight,
        onAppearActive: $c2c363b881b49d51$var$getRealHeight,
        onEnterActive: $c2c363b881b49d51$var$getRealHeight,
        onLeaveStart: $c2c363b881b49d51$var$getCurrentHeight,
        onLeaveActive: $c2c363b881b49d51$var$getCollapsedHeight,
        onAppearEnd: $c2c363b881b49d51$var$skipOpacityTransition,
        onEnterEnd: $c2c363b881b49d51$var$skipOpacityTransition,
        onLeaveEnd: $c2c363b881b49d51$var$skipOpacityTransition,
        motionDeadline: 500
    });
const $c2c363b881b49d51$var$_SelectPlacements = [
    'bottomLeft',
    'bottomRight',
    'topLeft',
    'topRight'
];
const $c2c363b881b49d51$export$27c72201b1d09951 = (rootPrefixCls, motion, transitionName)=>{
    if (transitionName !== undefined) return transitionName;
    return `${rootPrefixCls}-${motion}`;
};
var $c2c363b881b49d51$export$2e2bcd8739ae039 = $c2c363b881b49d51$var$initCollapseMotion;







var $5E6i4 = parcelRequire("5E6i4");




"use client";
const $206603efe0843f39$var$CollapsePanel = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { getPrefixCls: getPrefixCls } = $5E6i4.useContext((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, className: className, showArrow: showArrow = true } = props;
    const prefixCls = getPrefixCls('collapse', customizePrefixCls);
    const collapsePanelClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)({
        [`${prefixCls}-no-arrow`]: !showArrow
    }, className);
    return /*#__PURE__*/ $5E6i4.createElement((0, $081354452b9aa732$export$2e2bcd8739ae039).Panel, {
        ref: ref,
        ...props,
        prefixCls: prefixCls,
        className: collapsePanelClassName
    });
});
var $206603efe0843f39$export$2e2bcd8739ae039 = $206603efe0843f39$var$CollapsePanel;




const $5f07542305776ab3$var$genCollapseMotion = (token)=>{
    const { componentCls: componentCls, antCls: antCls, motionDurationMid: motionDurationMid, motionEaseInOut: motionEaseInOut } = token;
    return {
        [componentCls]: {
            // For common/openAnimation
            [`${antCls}-motion-collapse-legacy`]: {
                overflow: 'hidden',
                '&-active': {
                    transition: `${[
                        'height',
                        'opacity'
                    ].map((prop)=>`${prop} ${motionDurationMid} ${motionEaseInOut}`).join(', ')} !important`
                }
            },
            [`${antCls}-motion-collapse`]: {
                overflow: 'hidden',
                transition: `${[
                    'height',
                    'opacity'
                ].map((prop)=>`${prop} ${motionDurationMid} ${motionEaseInOut}`).join(', ')} !important`
            }
        }
    };
};
var $5f07542305776ab3$export$2e2bcd8739ae039 = $5f07542305776ab3$var$genCollapseMotion;



const $e369c4ae9f172685$export$5ca74f7be820a85 = (token)=>{
    const { componentCls: componentCls, contentBg: contentBg, padding: padding, headerBg: headerBg, headerPadding: headerPadding, headerPaddingSM: headerPaddingSM, headerPaddingLG: headerPaddingLG, collapsePanelBorderRadius: collapsePanelBorderRadius, lineWidth: lineWidth, lineType: lineType, colorBorder: colorBorder, colorText: colorText, colorTextHeading: colorTextHeading, colorTextDisabled: colorTextDisabled, fontSizeLG: fontSizeLG, lineHeight: lineHeight, lineHeightLG: lineHeightLG, marginSM: marginSM, paddingSM: paddingSM, paddingLG: paddingLG, paddingXS: paddingXS, motionDurationSlow: motionDurationSlow, fontSizeIcon: fontSizeIcon, contentPadding: contentPadding, contentPaddingSM: contentPaddingSM, contentPaddingLG: contentPaddingLG, fontHeight: fontHeight, fontHeightLG: fontHeightLG } = token;
    const borderBase = `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(lineWidth)} ${lineType} ${colorBorder}`;
    return {
        [componentCls]: {
            ...(0, $cd5a520fee8002b4$export$23997c3e44cc1c59)(token),
            backgroundColor: headerBg,
            border: borderBase,
            borderRadius: collapsePanelBorderRadius,
            '&-rtl': {
                direction: 'rtl'
            },
            [`& > ${componentCls}-item`]: {
                borderBottom: borderBase,
                '&:first-child': {
                    [`
            &,
            & > ${componentCls}-header`]: {
                        borderRadius: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(collapsePanelBorderRadius)} ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(collapsePanelBorderRadius)} 0 0`
                    }
                },
                '&:last-child': {
                    [`
            &,
            & > ${componentCls}-header`]: {
                        borderRadius: `0 0 ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(collapsePanelBorderRadius)} ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(collapsePanelBorderRadius)}`
                    }
                },
                [`> ${componentCls}-header`]: {
                    position: 'relative',
                    // Compatible with old version of antd, should remove in next version
                    display: 'flex',
                    flexWrap: 'nowrap',
                    alignItems: 'flex-start',
                    padding: headerPadding,
                    color: colorTextHeading,
                    lineHeight: lineHeight,
                    cursor: 'pointer',
                    transition: `all ${motionDurationSlow}, visibility 0s`,
                    ...(0, $cd5a520fee8002b4$export$a44db842bcb28231)(token),
                    [`> ${componentCls}-title`]: {
                        flex: 'auto'
                    },
                    // >>>>> Arrow
                    [`${componentCls}-expand-icon`]: {
                        height: fontHeight,
                        display: 'flex',
                        alignItems: 'center',
                        marginInlineEnd: marginSM
                    },
                    [`${componentCls}-arrow`]: {
                        ...(0, $cd5a520fee8002b4$export$171ccda7bc085e59)(),
                        fontSize: fontSizeIcon,
                        // when `transform: rotate()` is applied to icon's root element
                        transition: `transform ${motionDurationSlow}`,
                        // when `transform: rotate()` is applied to icon's child element
                        svg: {
                            transition: `transform ${motionDurationSlow}`
                        }
                    },
                    // >>>>> Text
                    [`${componentCls}-title`]: {
                        marginInlineEnd: 'auto',
                        // Icons from third-party libraries render as a bare `<svg>`, which the `.anticon`
                        // reset never reaches. An `<svg>` has no baseline of its own, so it is aligned by its
                        // bottom margin edge (CSS 2.1 §10.8.1) and rides above the title text.
                        // `display: inline-block` keeps it an atomic inline box so `vertical-align` still applies
                        // even under a CSS reset that forces `svg { display: block }` (e.g. Tailwind Preflight),
                        // which would otherwise drop the icon onto its own line. `vertical-align: middle` centres
                        // its margin box on the x-height line; `margin-block-end` then lifts it by half its own
                        // value onto the cap-height centre (capHeight − xHeight ≈ 0.2em across typical fonts),
                        // keeping it centred at any icon size.
                        // Only matches a bare `<svg>`: an `.anticon` keeps its `<svg>` one level deeper.
                        '> svg': {
                            display: 'inline-block',
                            verticalAlign: 'middle',
                            marginBlockEnd: '0.2em'
                        }
                    }
                },
                [`${componentCls}-collapsible-header`]: {
                    cursor: 'default',
                    [`${componentCls}-title`]: {
                        flex: 'none',
                        cursor: 'pointer'
                    },
                    [`${componentCls}-expand-icon`]: {
                        cursor: 'pointer'
                    }
                },
                [`${componentCls}-collapsible-icon`]: {
                    cursor: 'unset',
                    [`${componentCls}-expand-icon`]: {
                        cursor: 'pointer'
                    }
                }
            },
            [`${componentCls}-panel`]: {
                color: colorText,
                backgroundColor: contentBg,
                borderTop: borderBase,
                [`& > ${componentCls}-body`]: {
                    padding: contentPadding
                },
                '&-hidden': {
                    display: 'none'
                }
            },
            '&-small': {
                [`> ${componentCls}-item`]: {
                    [`> ${componentCls}-header`]: {
                        padding: headerPaddingSM,
                        [`> ${componentCls}-expand-icon`]: {
                            // Arrow offset
                            marginInlineStart: token.calc(paddingSM).sub(paddingXS).equal()
                        }
                    },
                    [`> ${componentCls}-panel > ${componentCls}-body`]: {
                        padding: contentPaddingSM
                    }
                }
            },
            '&-large': {
                [`> ${componentCls}-item`]: {
                    fontSize: fontSizeLG,
                    lineHeight: lineHeightLG,
                    [`> ${componentCls}-header`]: {
                        padding: headerPaddingLG,
                        [`> ${componentCls}-expand-icon`]: {
                            height: fontHeightLG,
                            // Arrow offset
                            marginInlineStart: token.calc(paddingLG).sub(padding).equal()
                        }
                    },
                    [`> ${componentCls}-panel > ${componentCls}-body`]: {
                        padding: contentPaddingLG
                    }
                }
            },
            [`${componentCls}-item:last-child`]: {
                borderBottom: 0,
                [`> ${componentCls}-panel`]: {
                    borderRadius: `0 0 ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(collapsePanelBorderRadius)} ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(collapsePanelBorderRadius)}`
                }
            },
            [`& ${componentCls}-item-disabled > ${componentCls}-header`]: {
                '&, & > .arrow': {
                    color: colorTextDisabled,
                    cursor: 'not-allowed'
                }
            },
            // ========================== Icon Placement ==========================
            [`&${componentCls}-icon-placement-end`]: {
                [`& > ${componentCls}-item`]: {
                    [`> ${componentCls}-header`]: {
                        [`${componentCls}-expand-icon`]: {
                            order: 1,
                            marginInlineEnd: 0,
                            marginInlineStart: marginSM
                        }
                    }
                }
            }
        }
    };
};
const $e369c4ae9f172685$var$genArrowStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const fixedSelector = `> ${componentCls}-item > ${componentCls}-header ${componentCls}-arrow`;
    return {
        [`${componentCls}-rtl`]: {
            [fixedSelector]: {
                transform: `rotate(180deg)`
            }
        }
    };
};
const $e369c4ae9f172685$var$genBorderlessStyle = (token)=>{
    const { componentCls: componentCls, headerBg: headerBg, borderlessContentPadding: borderlessContentPadding, borderlessContentBg: borderlessContentBg, colorBorder: colorBorder } = token;
    return {
        [`${componentCls}-borderless`]: {
            backgroundColor: headerBg,
            border: 0,
            [`> ${componentCls}-item`]: {
                borderBottom: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${colorBorder}`
            },
            [`
        > ${componentCls}-item:last-child,
        > ${componentCls}-item:last-child ${componentCls}-header
      `]: {
                borderRadius: 0
            },
            [`> ${componentCls}-item:last-child`]: {
                borderBottom: 0
            },
            [`> ${componentCls}-item > ${componentCls}-panel`]: {
                backgroundColor: borderlessContentBg,
                borderTop: 0
            },
            [`> ${componentCls}-item > ${componentCls}-panel > ${componentCls}-body`]: {
                padding: borderlessContentPadding
            }
        }
    };
};
const $e369c4ae9f172685$var$genGhostStyle = (token)=>{
    const { componentCls: componentCls, paddingSM: paddingSM } = token;
    return {
        [`${componentCls}-ghost`]: {
            backgroundColor: 'transparent',
            border: 0,
            [`> ${componentCls}-item`]: {
                borderBottom: 0,
                [`> ${componentCls}-panel`]: {
                    backgroundColor: 'transparent',
                    border: 0,
                    [`> ${componentCls}-body`]: {
                        paddingBlock: paddingSM
                    }
                }
            }
        }
    };
};
const $e369c4ae9f172685$export$9ca1be8807fe0675 = (token)=>{
    const componentToken = {
        headerPadding: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.paddingSM)} ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.padding)}`,
        headerPaddingSM: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.paddingXS)} ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.paddingSM)} ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.paddingXS)} ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.paddingXS)}`,
        headerPaddingLG: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.padding)} ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.paddingLG)} ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.padding)} ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.padding)}`,
        headerBg: token.colorFillAlter,
        contentPadding: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.padding)} ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(16)}`,
        // Fixed Value
        contentPaddingSM: token.paddingSM,
        contentPaddingLG: token.paddingLG,
        contentBg: token.colorBgContainer,
        borderlessContentPadding: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.paddingXXS)} ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(16)} ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.padding)}`,
        borderlessContentBg: 'transparent'
    };
    return componentToken;
};
var $e369c4ae9f172685$export$2e2bcd8739ae039 = (0, $761caadb5301aee1$export$51ec95de45185b42)('Collapse', (token)=>{
    const collapseToken = (0, $f564548c7b6877d5$export$4950aa0f605343fb)(token, {
        collapsePanelBorderRadius: token.borderRadiusLG
    });
    return [
        $e369c4ae9f172685$export$5ca74f7be820a85(collapseToken),
        $e369c4ae9f172685$var$genBorderlessStyle(collapseToken),
        $e369c4ae9f172685$var$genGhostStyle(collapseToken),
        $e369c4ae9f172685$var$genArrowStyle(collapseToken),
        (0, $5f07542305776ab3$export$2e2bcd8739ae039)(collapseToken)
    ];
}, $e369c4ae9f172685$export$9ca1be8807fe0675);


"use client";
const $58aea8b1dc8a1468$var$Collapse = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { getPrefixCls: getPrefixCls, direction: direction, expandIcon: contextExpandIcon, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $519f2fad435b3034$export$46f4bd6436a25a31)('collapse');
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, bordered: bordered = true, ghost: ghost, size: customizeSize, expandIconPlacement: expandIconPlacement, expandIconPosition: expandIconPosition, children: children, destroyInactivePanel: destroyInactivePanel, destroyOnHidden: destroyOnHidden, expandIcon: expandIcon, classNames: classNames, styles: styles } = props;
    const mergedSize = (0, $4bfc7567df2a969e$export$2e2bcd8739ae039)((ctx)=>customizeSize ?? ctx ?? 'middle');
    const prefixCls = getPrefixCls('collapse', customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const [hashId, cssVarCls] = (0, $e369c4ae9f172685$export$2e2bcd8739ae039)(prefixCls);
    const mergedPlacement = expandIconPlacement ?? expandIconPosition ?? 'start';
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        size: mergedSize,
        bordered: bordered,
        expandIconPlacement: mergedPlacement
    };
    const contextStyleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $722c8632ba7bdb89$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    });
    const mergedExpandIcon = expandIcon ?? contextExpandIcon;
    var deprecatedName, newName;
    const renderExpandIcon = $5E6i4.useCallback((panelProps = {})=>{
        const iconIsInteractive = panelProps.collapsible === 'header' || panelProps.collapsible === 'icon';
        const icon = (0, $addbc2fddcbb77a9$export$f6e2535fb5126e54)(mergedExpandIcon) ? mergedExpandIcon(panelProps) : /*#__PURE__*/ $5E6i4.createElement((0, $adbdeb3aab803740$export$2e2bcd8739ae039), {
            rotate: panelProps.isActive ? direction === 'rtl' ? -90 : 90 : undefined,
            ...iconIsInteractive ? {
                'aria-label': panelProps.isActive ? 'expanded' : 'collapsed'
            } : {
                'aria-hidden': true
            }
        });
        return (0, $552e20b6ec4e63a6$export$e530037191fcd5d7)(icon, (oriProps)=>({
                className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(oriProps.className, `${prefixCls}-arrow`)
            }));
    }, [
        mergedExpandIcon,
        prefixCls,
        direction
    ]);
    const collapseClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-icon-placement-${mergedPlacement}`, {
        [`${prefixCls}-borderless`]: !bordered,
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-ghost`]: !!ghost,
        [`${prefixCls}-large`]: mergedSize === 'large',
        [`${prefixCls}-small`]: mergedSize === 'small'
    }, contextClassName, className, rootClassName, hashId, cssVarCls, mergedClassNames.root);
    const openMotion = $5E6i4.useMemo(()=>({
            ...(0, $c2c363b881b49d51$export$2e2bcd8739ae039)(rootPrefixCls),
            motionAppear: false,
            leavedClassName: `${prefixCls}-panel-hidden`
        }), [
        rootPrefixCls,
        prefixCls
    ]);
    const items = $5E6i4.useMemo(()=>{
        if (children) return (0, $2ec1a2166f2295ea$export$2e2bcd8739ae039)(children).map((child)=>child);
        return null;
    }, [
        children
    ]);
    return /*#__PURE__*/ $5E6i4.createElement((0, $081354452b9aa732$export$2e2bcd8739ae039), {
        ref: ref,
        openMotion: openMotion,
        ...(0, $48bd91d9f828de66$export$2e2bcd8739ae039)(props, [
            'rootClassName'
        ]),
        expandIcon: renderExpandIcon,
        prefixCls: prefixCls,
        className: collapseClassName,
        style: mergedStyles.root,
        classNames: mergedClassNames,
        styles: mergedStyles,
        destroyOnHidden: destroyOnHidden ?? destroyInactivePanel
    }, items);
});
var $58aea8b1dc8a1468$export$2e2bcd8739ae039 = Object.assign($58aea8b1dc8a1468$var$Collapse, {
    Panel: (0, $206603efe0843f39$export$2e2bcd8739ae039)
});


"use client";
var $859d0b026288565b$export$2e2bcd8739ae039 = (0, $58aea8b1dc8a1468$export$2e2bcd8739ae039);







const $b950d390fb09f5de$export$c844f5d21427d1ab = (color)=>{
    if (color instanceof (0, $a3fe15cc837afc75$export$e8cc8a2e87e145b4)) return color;
    return new (0, $a3fe15cc837afc75$export$e8cc8a2e87e145b4)(color);
};
const $b950d390fb09f5de$export$8d6531175688484b = (value)=>Math.round(Number(value || 0));
const $b950d390fb09f5de$export$3c8ae3c73ab0e52a = (color)=>$b950d390fb09f5de$export$8d6531175688484b(color.toHsb().a * 100);
const $b950d390fb09f5de$export$f04e5f54cfbb466c = (color, alpha)=>{
    const rgba = color.toRgb();
    // Color from hsb input may get `rgb` is (0/0/0) when `hsb.b` is 0
    // So if rgb is empty, we should get from hsb
    if (!rgba.r && !rgba.g && !rgba.b) {
        const hsba = color.toHsb();
        hsba.a = alpha || 1;
        return $b950d390fb09f5de$export$c844f5d21427d1ab(hsba);
    }
    rgba.a = alpha || 1;
    return $b950d390fb09f5de$export$c844f5d21427d1ab(rgba);
};
const $b950d390fb09f5de$export$9dd6bfe648e14e97 = (colors, percent)=>{
    const filledColors = [
        {
            percent: 0,
            color: colors[0].color
        }
    ].concat((0, $0acfae8147afe964$export$2e2bcd8739ae039)(colors), [
        {
            percent: 100,
            color: colors[colors.length - 1].color
        }
    ]);
    for(let i = 0; i < filledColors.length - 1; i += 1){
        const startPtg = filledColors[i].percent;
        const endPtg = filledColors[i + 1].percent;
        const startColor = filledColors[i].color;
        const endColor = filledColors[i + 1].color;
        if (startPtg <= percent && percent <= endPtg) {
            const dist = endPtg - startPtg;
            if (dist === 0) return startColor;
            const ratio = (percent - startPtg) / dist * 100;
            const startRcColor = new (0, $7d4443f868094485$export$892596cec99bc70e)(startColor);
            const endRcColor = new (0, $7d4443f868094485$export$892596cec99bc70e)(endColor);
            return startRcColor.mix(endRcColor, ratio).toRgbString();
        }
    }
    // This will never reach
    /* istanbul ignore next */ return '';
};


"use client";
const $44905ec240f468f5$var$genPresetColor = (list)=>list.map((value)=>({
            ...value,
            colors: value.colors.map((0, $b950d390fb09f5de$export$c844f5d21427d1ab))
        }));
const $44905ec240f468f5$export$6341b37cb79161da = (value, bgColorToken)=>{
    const { r: r, g: g, b: b, a: a } = value.toRgb();
    const hsv = new (0, $7d4443f868094485$export$892596cec99bc70e)(value.toRgbString()).onBackground(bgColorToken).toHsv();
    if (a <= 0.5) // Adapted to dark mode
    return hsv.v > 0.5;
    return r * 0.299 + g * 0.587 + b * 0.114 > 192;
};
const $44905ec240f468f5$var$genCollapsePanelKey = (preset, index)=>{
    const mergedKey = preset.key ?? index;
    return `panel-${mergedKey}`;
};
const $44905ec240f468f5$var$ColorPresets = ({ prefixCls: prefixCls, presets: presets, value: color, onChange: onChange })=>{
    const [locale] = (0, $a2f3e1f88973a5e2$export$2e2bcd8739ae039)('ColorPicker');
    const [, token] = (0, $cb3a44f4e76623bb$export$2e2bcd8739ae039)();
    const presetsValue = (0, $5E6i4.useMemo)(()=>$44905ec240f468f5$var$genPresetColor(presets), [
        presets
    ]);
    const colorPresetsPrefixCls = `${prefixCls}-presets`;
    const activeKeys = (0, $5E6i4.useMemo)(()=>presetsValue.reduce((acc, preset, index)=>{
            const { defaultOpen: defaultOpen = true } = preset;
            if (defaultOpen) acc.push($44905ec240f468f5$var$genCollapsePanelKey(preset, index));
            return acc;
        }, []), [
        presetsValue
    ]);
    const handleClick = (colorValue)=>{
        onChange?.(colorValue);
    };
    const items = presetsValue.map((preset, index)=>({
            key: $44905ec240f468f5$var$genCollapsePanelKey(preset, index),
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("div", {
                className: `${colorPresetsPrefixCls}-label`
            }, preset?.label),
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("div", {
                className: `${colorPresetsPrefixCls}-items`
            }, Array.isArray(preset?.colors) && preset.colors?.length > 0 ? preset.colors.map((presetColor, index)=>{
                const colorInst = (0, $b950d390fb09f5de$export$c844f5d21427d1ab)(presetColor);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $f4363a266513f6eb$export$2e2bcd8739ae039), {
                    // eslint-disable-next-line react/no-array-index-key
                    key: `preset-${index}-${presetColor.toHexString()}`,
                    color: colorInst.toCssString(),
                    prefixCls: prefixCls,
                    className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${colorPresetsPrefixCls}-color`, {
                        [`${colorPresetsPrefixCls}-color-checked`]: presetColor.toCssString() === color?.toCssString(),
                        [`${colorPresetsPrefixCls}-color-bright`]: $44905ec240f468f5$export$6341b37cb79161da(presetColor, token.colorBgElevated)
                    }),
                    onClick: ()=>handleClick(presetColor)
                });
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("span", {
                className: `${colorPresetsPrefixCls}-empty`
            }, locale.presetEmpty))
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("div", {
        className: colorPresetsPrefixCls
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $859d0b026288565b$export$2e2bcd8739ae039), {
        defaultActiveKey: activeKeys,
        ghost: true,
        items: items
    }));
};
var $44905ec240f468f5$export$2e2bcd8739ae039 = $44905ec240f468f5$var$ColorPresets;





const $e71dd45d14e933d8$export$362fb92a8f81bbf9 = (token)=>{
    const { paddingInline: paddingInline, onlyIconSize: onlyIconSize, borderColorDisabled: borderColorDisabled } = token;
    const buttonToken = (0, $f564548c7b6877d5$export$4950aa0f605343fb)(token, {
        buttonPaddingHorizontal: paddingInline,
        buttonPaddingVertical: 0,
        buttonIconOnlyFontSize: onlyIconSize,
        colorBorderDisabled: borderColorDisabled
    });
    return buttonToken;
};
const $e71dd45d14e933d8$export$9ca1be8807fe0675 = (token)=>{
    const contentFontSize = token.contentFontSize ?? token.fontSize;
    const contentFontSizeSM = token.contentFontSizeSM ?? token.fontSize;
    const contentFontSizeLG = token.contentFontSizeLG ?? token.fontSizeLG;
    const contentLineHeight = token.contentLineHeight ?? (0, $16a2b44eea7795a7$export$56204a27a2958a55)(contentFontSize);
    const contentLineHeightSM = token.contentLineHeightSM ?? (0, $16a2b44eea7795a7$export$56204a27a2958a55)(contentFontSizeSM);
    const contentLineHeightLG = token.contentLineHeightLG ?? (0, $16a2b44eea7795a7$export$56204a27a2958a55)(contentFontSizeLG);
    const solidTextColor = (0, $44905ec240f468f5$export$6341b37cb79161da)(new (0, $a3fe15cc837afc75$export$e8cc8a2e87e145b4)(token.colorBgSolid), '#fff') ? '#000' : '#fff';
    const shadowColorTokens = (0, $2535cf92607464fc$export$6d4fe3a00a1811ad).reduce((prev, colorKey)=>({
            ...prev,
            [`${colorKey}ShadowColor`]: `0 ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.controlOutlineWidth)} 0 ${(0, $6d752234234de387$export$2e2bcd8739ae039)(token[`${colorKey}1`], token.colorBgContainer)}`
        }), {});
    const defaultBgDisabled = token.colorBgContainerDisabled;
    const dashedBgDisabled = token.colorBgContainerDisabled;
    return {
        ...shadowColorTokens,
        fontWeight: 400,
        iconGap: token.marginXS,
        defaultShadow: `0 ${token.controlOutlineWidth}px 0 ${token.controlTmpOutline}`,
        primaryShadow: `0 ${token.controlOutlineWidth}px 0 ${token.controlOutline}`,
        dangerShadow: `0 ${token.controlOutlineWidth}px 0 ${token.colorErrorOutline}`,
        primaryColor: token.colorTextLightSolid,
        dangerColor: token.colorTextLightSolid,
        borderColorDisabled: token.colorBorderDisabled,
        defaultGhostColor: token.colorBgContainer,
        ghostBg: 'transparent',
        defaultGhostBorderColor: token.colorBgContainer,
        paddingInline: token.paddingContentHorizontal - token.lineWidth,
        paddingInlineLG: token.paddingContentHorizontal - token.lineWidth,
        paddingInlineSM: 8 - token.lineWidth,
        onlyIconSize: 'inherit',
        onlyIconSizeSM: 'inherit',
        onlyIconSizeLG: 'inherit',
        groupBorderColor: token.colorPrimaryHover,
        linkHoverBg: 'transparent',
        textTextColor: token.colorText,
        textTextHoverColor: token.colorText,
        textTextActiveColor: token.colorText,
        textHoverBg: token.colorFillTertiary,
        defaultColor: token.colorText,
        defaultBg: token.colorBgContainer,
        defaultBorderColor: token.colorBorder,
        defaultBorderColorDisabled: token.colorBorder,
        defaultHoverBg: token.colorBgContainer,
        defaultHoverColor: token.colorPrimaryHover,
        defaultHoverBorderColor: token.colorPrimaryHover,
        defaultActiveBg: token.colorBgContainer,
        defaultActiveColor: token.colorPrimaryActive,
        defaultActiveBorderColor: token.colorPrimaryActive,
        solidTextColor: solidTextColor,
        contentFontSize: contentFontSize,
        contentFontSizeSM: contentFontSizeSM,
        contentFontSizeLG: contentFontSizeLG,
        contentLineHeight: contentLineHeight,
        contentLineHeightSM: contentLineHeightSM,
        contentLineHeightLG: contentLineHeightLG,
        paddingBlock: Math.max((token.controlHeight - contentFontSize * contentLineHeight) / 2 - token.lineWidth, 0),
        paddingBlockSM: Math.max((token.controlHeightSM - contentFontSizeSM * contentLineHeightSM) / 2 - token.lineWidth, 0),
        paddingBlockLG: Math.max((token.controlHeightLG - contentFontSizeLG * contentLineHeightLG) / 2 - token.lineWidth, 0),
        defaultBgDisabled: defaultBgDisabled,
        dashedBgDisabled: dashedBgDisabled
    };
};




const $c9ba4ad0f6d93110$var$genVariantStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls, lineWidth: lineWidth, lineType: lineType } = token;
    const [varName, varRef] = (0, $761caadb5301aee1$export$d82b8f66c5649e14)(antCls, 'btn');
    return {
        [componentCls]: [
            // ==============================================================
            // ==                         Variable                         ==
            // ==============================================================
            {
                // Border
                [varName('border-width')]: lineWidth,
                [varName('border-color')]: '#000',
                [varName('border-color-hover')]: varRef('border-color'),
                [varName('border-color-active')]: varRef('border-color'),
                [varName('border-color-disabled')]: varRef('border-color'),
                [varName('border-style')]: lineType,
                // Text
                [varName('text-color')]: '#000',
                [varName('text-color-hover')]: varRef('text-color'),
                [varName('text-color-active')]: varRef('text-color'),
                [varName('text-color-disabled')]: varRef('text-color'),
                // Background
                [varName('bg-color')]: '#ddd',
                [varName('bg-color-hover')]: varRef('bg-color'),
                [varName('bg-color-active')]: varRef('bg-color'),
                [varName('bg-color-disabled')]: token.colorBgContainerDisabled,
                [varName('bg-color-container')]: token.colorBgContainer,
                // Shadow
                [varName('shadow')]: 'none'
            },
            // ==============================================================
            // ==                         Template                         ==
            // ==============================================================
            {
                // Basic
                border: [
                    varRef('border-width'),
                    varRef('border-style'),
                    varRef('border-color')
                ].join(' '),
                color: varRef('text-color'),
                backgroundColor: varRef('bg-color'),
                // Status
                [`&:not(:disabled):not(${componentCls}-disabled)`]: {
                    // Hover
                    '&:hover': {
                        border: [
                            varRef('border-width'),
                            varRef('border-style'),
                            varRef('border-color-hover')
                        ].join(' '),
                        color: varRef('text-color-hover'),
                        backgroundColor: varRef('bg-color-hover')
                    },
                    // Active
                    '&:active': {
                        border: [
                            varRef('border-width'),
                            varRef('border-style'),
                            varRef('border-color-active')
                        ].join(' '),
                        color: varRef('text-color-active'),
                        backgroundColor: varRef('bg-color-active')
                    }
                }
            },
            // ==============================================================
            // ==                         Variants                         ==
            // ==============================================================
            {
                // >>>>> Solid
                [`&${componentCls}-variant-solid`]: {
                    // Solid Variables
                    [varName('solid-bg-color')]: varRef('color-base'),
                    [varName('solid-bg-color-hover')]: varRef('color-hover'),
                    [varName('solid-bg-color-active')]: varRef('color-active'),
                    // Variables
                    [varName('border-color')]: 'transparent',
                    [varName('text-color')]: token.colorTextLightSolid,
                    [varName('bg-color')]: varRef('solid-bg-color'),
                    [varName('bg-color-hover')]: varRef('solid-bg-color-hover'),
                    [varName('bg-color-active')]: varRef('solid-bg-color-active'),
                    // Box Shadow
                    boxShadow: varRef('shadow')
                },
                // >>>>> Outlined & Dashed
                [`&${componentCls}-variant-outlined, &${componentCls}-variant-dashed`]: {
                    [varName('border-color')]: varRef('color-base'),
                    [varName('border-color-hover')]: varRef('color-hover'),
                    [varName('border-color-active')]: varRef('color-active'),
                    [varName('bg-color')]: varRef('bg-color-container'),
                    [varName('text-color')]: varRef('color-base'),
                    [varName('text-color-hover')]: varRef('color-hover'),
                    [varName('text-color-active')]: varRef('color-active'),
                    // Box Shadow
                    boxShadow: varRef('shadow')
                },
                // >>>>> Dashed
                [`&${componentCls}-variant-dashed`]: {
                    [varName('border-style')]: 'dashed',
                    [varName('bg-color-disabled')]: token.dashedBgDisabled
                },
                // >>>>> Filled
                [`&${componentCls}-variant-filled`]: {
                    [varName('border-color')]: 'transparent',
                    [varName('text-color')]: varRef('color-base'),
                    [varName('bg-color')]: varRef('color-light'),
                    [varName('bg-color-hover')]: varRef('color-light-hover'),
                    [varName('bg-color-active')]: varRef('color-light-active')
                },
                // >>>>> Text & Link
                [`&${componentCls}-variant-text, &${componentCls}-variant-link`]: {
                    [varName('border-color')]: 'transparent',
                    [varName('text-color')]: varRef('color-base'),
                    [varName('text-color-hover')]: varRef('color-hover'),
                    [varName('text-color-active')]: varRef('color-active'),
                    [varName('bg-color')]: 'transparent',
                    [varName('bg-color-hover')]: 'transparent',
                    [varName('bg-color-active')]: 'transparent',
                    [`&:disabled, &${token.componentCls}-disabled`]: {
                        background: 'transparent',
                        borderColor: 'transparent'
                    }
                },
                // >>>>> Text
                [`&${componentCls}-variant-text`]: {
                    [varName('bg-color-hover')]: varRef('color-light'),
                    [varName('bg-color-active')]: varRef('color-light-active')
                }
            },
            // ==============================================================
            // ==                          Colors                          ==
            // ==============================================================
            {
                // ======================== By Default ========================
                // >>>>> Link
                [`&${componentCls}-variant-link`]: {
                    [varName('color-base')]: token.colorLink,
                    [varName('color-hover')]: token.colorLinkHover,
                    [varName('color-active')]: token.colorLinkActive,
                    [varName('bg-color-hover')]: token.linkHoverBg
                },
                // ======================== Compatible ========================
                // >>>>> Primary
                [`&${componentCls}-color-primary`]: {
                    [varName('color-base')]: token.colorPrimary,
                    [varName('color-hover')]: token.colorPrimaryHover,
                    [varName('color-active')]: token.colorPrimaryActive,
                    [varName('color-light')]: token.colorPrimaryBg,
                    [varName('color-light-hover')]: token.colorPrimaryBgHover,
                    [varName('color-light-active')]: token.colorPrimaryBorder,
                    [varName('shadow')]: token.primaryShadow,
                    [`&${componentCls}-variant-solid`]: {
                        [varName('text-color')]: token.primaryColor,
                        [varName('text-color-hover')]: varRef('text-color'),
                        [varName('text-color-active')]: varRef('text-color')
                    }
                },
                // >>>>> Danger
                [`&${componentCls}-color-dangerous`]: {
                    [varName('color-base')]: token.colorError,
                    [varName('color-hover')]: token.colorErrorHover,
                    [varName('color-active')]: token.colorErrorActive,
                    [varName('color-light')]: token.colorErrorBg,
                    [varName('color-light-hover')]: token.colorErrorBgFilledHover,
                    [varName('color-light-active')]: token.colorErrorBgActive,
                    [varName('shadow')]: token.dangerShadow,
                    [`&${componentCls}-variant-solid`]: {
                        [varName('text-color')]: token.dangerColor,
                        [varName('text-color-hover')]: varRef('text-color'),
                        [varName('text-color-active')]: varRef('text-color')
                    }
                },
                // >>>>> Default
                [`&${componentCls}-color-default`]: {
                    [varName('solid-bg-color')]: token.colorBgSolid,
                    [varName('solid-bg-color-hover')]: token.colorBgSolidHover,
                    [varName('solid-bg-color-active')]: token.colorBgSolidActive,
                    [varName('color-base')]: token.defaultBorderColor,
                    [varName('color-hover')]: token.defaultHoverBorderColor,
                    [varName('color-active')]: token.defaultActiveBorderColor,
                    [varName('color-light')]: token.colorFillTertiary,
                    [varName('color-light-hover')]: token.colorFillSecondary,
                    [varName('color-light-active')]: token.colorFill,
                    [varName('text-color')]: token.defaultColor,
                    [varName('text-color-hover')]: token.defaultHoverColor,
                    [varName('text-color-active')]: token.defaultActiveColor,
                    [varName('shadow')]: token.defaultShadow,
                    [`&${componentCls}-variant-outlined`]: {
                        [varName('bg-color-disabled')]: token.defaultBgDisabled
                    },
                    [`&${componentCls}-variant-solid`]: {
                        [varName('text-color')]: token.solidTextColor,
                        [varName('text-color-hover')]: varRef('text-color'),
                        [varName('text-color-active')]: varRef('text-color')
                    },
                    [`&${componentCls}-variant-filled, &${componentCls}-variant-text`]: {
                        [varName('text-color-hover')]: varRef('text-color'),
                        [varName('text-color-active')]: varRef('text-color')
                    },
                    [`&${componentCls}-variant-outlined, &${componentCls}-variant-dashed`]: {
                        [varName('text-color')]: token.defaultColor,
                        [varName('text-color-hover')]: token.defaultHoverColor,
                        [varName('text-color-active')]: token.defaultActiveColor,
                        [varName('bg-color-container')]: token.defaultBg,
                        [varName('bg-color-hover')]: token.defaultHoverBg,
                        [varName('bg-color-active')]: token.defaultActiveBg
                    },
                    [`&${componentCls}-variant-text`]: {
                        [varName('text-color')]: token.textTextColor,
                        [varName('text-color-hover')]: token.textTextHoverColor,
                        [varName('text-color-active')]: token.textTextActiveColor,
                        [varName('bg-color-hover')]: token.textHoverBg
                    },
                    [`&${componentCls}-background-ghost`]: {
                        [`&${componentCls}-variant-outlined, &${componentCls}-variant-dashed`]: {
                            [varName('text-color')]: token.defaultGhostColor,
                            [varName('border-color')]: token.defaultGhostBorderColor
                        }
                    }
                }
            },
            // >>>>> Preset Colors
            (0, $2535cf92607464fc$export$6d4fe3a00a1811ad).map((colorKey)=>{
                const darkColor = token[`${colorKey}6`];
                const lightColor = token[`${colorKey}1`];
                const hoverColor = token[`${colorKey}Hover`];
                const lightHoverColor = token[`${colorKey}2`];
                const lightActiveColor = token[`${colorKey}3`];
                const activeColor = token[`${colorKey}Active`];
                const shadowColor = token[`${colorKey}ShadowColor`];
                return {
                    [`&${componentCls}-color-${colorKey}`]: {
                        [varName('color-base')]: darkColor,
                        [varName('color-hover')]: hoverColor,
                        [varName('color-active')]: activeColor,
                        [varName('color-light')]: lightColor,
                        [varName('color-light-hover')]: lightHoverColor,
                        [varName('color-light-active')]: lightActiveColor,
                        [varName('shadow')]: shadowColor
                    }
                };
            }),
            // ==============================================================
            // ==                         Disabled                         ==
            // ==============================================================
            {
                // Disabled
                [`&:disabled, &${token.componentCls}-disabled`]: {
                    cursor: 'not-allowed',
                    borderColor: token.colorBorderDisabled,
                    background: varRef('bg-color-disabled'),
                    color: token.colorTextDisabled,
                    boxShadow: 'none'
                }
            },
            // ==============================================================
            // ==                          Ghost                           ==
            // ==============================================================
            {
                // Ghost
                [`&${componentCls}-background-ghost`]: {
                    [varName('bg-color')]: token.ghostBg,
                    [varName('bg-color-hover')]: token.ghostBg,
                    [varName('bg-color-active')]: token.ghostBg,
                    [varName('shadow')]: 'none',
                    [`&${componentCls}-variant-outlined, &${componentCls}-variant-dashed`]: {
                        [varName('bg-color-hover')]: token.ghostBg,
                        [varName('bg-color-active')]: token.ghostBg
                    }
                }
            }
        ]
    };
};
var $c9ba4ad0f6d93110$export$2e2bcd8739ae039 = $c9ba4ad0f6d93110$var$genVariantStyle;


// ============================== Shared ==============================
const $0074faf5ed5c91ab$var$genSharedButtonStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, fontWeight: fontWeight, opacityLoading: opacityLoading, motionDurationSlow: motionDurationSlow, motionEaseInOut: motionEaseInOut, iconGap: iconGap, calc: calc } = token;
    return {
        [componentCls]: {
            outline: 'none',
            position: 'relative',
            display: 'inline-flex',
            gap: iconGap,
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: fontWeight,
            whiteSpace: 'nowrap',
            textAlign: 'center',
            backgroundImage: 'none',
            cursor: 'pointer',
            transition: `all ${token.motionDurationMid} ${token.motionEaseInOut}`,
            userSelect: 'none',
            touchAction: 'manipulation',
            ...(0, $3c4103d4365d19b7$export$c5b4e7cabb00fc99)(),
            '&:disabled > *': {
                pointerEvents: 'none'
            },
            // https://github.com/ant-design/ant-design/issues/51380
            [`${componentCls}-icon > svg`]: (0, $cd5a520fee8002b4$export$171ccda7bc085e59)(),
            // https://github.com/ant-design/ant-design/issues/57727
            [`${componentCls}-icon`]: {
                display: 'inline-flex',
                alignItems: 'center',
                [iconCls]: {
                    verticalAlign: 'middle',
                    // Baseline will align the first element.
                    // So the Button with SVG will make the baseline to be the bottom of the SVG.
                    // Let's use `:before` to add a space to make the baseline to be the center of the Button.
                    // https://github.com/ant-design/ant-design/issues/58428
                    '&:before': {
                        content: '"\\a0"',
                        display: 'inline-block',
                        width: 0
                    }
                }
            },
            '> a': {
                color: 'currentColor'
            },
            '&:not(:disabled)': (0, $cd5a520fee8002b4$export$a44db842bcb28231)(token),
            [`&${componentCls}-two-chinese-chars::first-letter`]: {
                letterSpacing: '0.34em'
            },
            [`&${componentCls}-two-chinese-chars > *:not(${iconCls})`]: {
                marginInlineEnd: '-0.34em',
                letterSpacing: '0.34em'
            },
            [`&${componentCls}-icon-only`]: {
                paddingInline: 0,
                // make `btn-icon-only` not too narrow
                [`&${componentCls}-compact-item`]: {
                    flex: 'none'
                }
            },
            // Loading
            [`&${componentCls}-loading`]: {
                opacity: opacityLoading,
                cursor: 'default'
            },
            [`${componentCls}-loading-icon`]: {
                transition: [
                    'width',
                    'opacity',
                    'margin'
                ].map((prop)=>`${prop} ${motionDurationSlow} ${motionEaseInOut}`).join(',')
            },
            // iconPlacement
            [`&:not(${componentCls}-icon-end)`]: {
                [`${componentCls}-loading-icon-motion`]: {
                    '&-appear-start, &-enter-start, &-appear-prepare, &-enter-prepare': {
                        marginInlineEnd: calc(iconGap).mul(-1).equal(),
                        opacity: 0
                    },
                    '&-appear-active, &-enter-active': {
                        marginInlineEnd: 0
                    },
                    '&-leave-start': {
                        marginInlineEnd: 0
                    },
                    '&-leave-active': {
                        marginInlineEnd: calc(iconGap).mul(-1).equal()
                    }
                }
            },
            '&-icon-end': {
                flexDirection: 'row-reverse',
                [`${componentCls}-loading-icon-motion`]: {
                    '&-appear-start, &-enter-start, &-appear-prepare, &-enter-prepare': {
                        marginInlineStart: calc(iconGap).mul(-1).equal(),
                        opacity: 0
                    },
                    '&-appear-active, &-enter-active': {
                        marginInlineStart: 0
                    },
                    '&-leave-start': {
                        marginInlineStart: 0
                    },
                    '&-leave-active': {
                        marginInlineStart: calc(iconGap).mul(-1).equal()
                    }
                }
            }
        }
    };
};
// ============================== Shape ===============================
const $0074faf5ed5c91ab$var$genCircleButtonStyle = (token)=>({
        minWidth: token.controlHeight,
        paddingInline: 0,
        borderRadius: '50%'
    });
// =============================== Size ===============================
const $0074faf5ed5c91ab$var$genButtonStyle = (token, prefixCls = '')=>{
    const { componentCls: componentCls, controlHeight: controlHeight, fontSize: fontSize, borderRadius: borderRadius, buttonPaddingHorizontal: buttonPaddingHorizontal, iconCls: iconCls, buttonPaddingVertical: buttonPaddingVertical, buttonIconOnlyFontSize: buttonIconOnlyFontSize } = token;
    return [
        {
            [prefixCls]: {
                fontSize: fontSize,
                height: controlHeight,
                padding: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(buttonPaddingVertical)} ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(buttonPaddingHorizontal)}`,
                borderRadius: borderRadius,
                [`&${componentCls}-icon-only`]: {
                    width: controlHeight,
                    [iconCls]: {
                        fontSize: buttonIconOnlyFontSize
                    }
                }
            }
        },
        // Shape - patch prefixCls again to override solid border radius style
        {
            [`${componentCls}${componentCls}-circle${prefixCls}`]: $0074faf5ed5c91ab$var$genCircleButtonStyle(token)
        },
        {
            [`${componentCls}${componentCls}-round${prefixCls}`]: {
                borderRadius: token.controlHeight,
                [`&:not(${componentCls}-icon-only)`]: {
                    paddingInline: token.buttonPaddingHorizontal
                }
            }
        }
    ];
};
const $0074faf5ed5c91ab$var$genSizeBaseButtonStyle = (token)=>{
    const baseToken = (0, $f564548c7b6877d5$export$4950aa0f605343fb)(token, {
        fontSize: token.contentFontSize
    });
    return $0074faf5ed5c91ab$var$genButtonStyle(baseToken, token.componentCls);
};
const $0074faf5ed5c91ab$var$genSizeSmallButtonStyle = (token)=>{
    const smallToken = (0, $f564548c7b6877d5$export$4950aa0f605343fb)(token, {
        controlHeight: token.controlHeightSM,
        fontSize: token.contentFontSizeSM,
        padding: token.paddingXS,
        buttonPaddingHorizontal: token.paddingInlineSM,
        buttonPaddingVertical: 0,
        borderRadius: token.borderRadiusSM,
        buttonIconOnlyFontSize: token.onlyIconSizeSM
    });
    return $0074faf5ed5c91ab$var$genButtonStyle(smallToken, `${token.componentCls}-sm`);
};
const $0074faf5ed5c91ab$var$genSizeLargeButtonStyle = (token)=>{
    const largeToken = (0, $f564548c7b6877d5$export$4950aa0f605343fb)(token, {
        controlHeight: token.controlHeightLG,
        fontSize: token.contentFontSizeLG,
        buttonPaddingHorizontal: token.paddingInlineLG,
        buttonPaddingVertical: 0,
        borderRadius: token.borderRadiusLG,
        buttonIconOnlyFontSize: token.onlyIconSizeLG
    });
    return $0074faf5ed5c91ab$var$genButtonStyle(largeToken, `${token.componentCls}-lg`);
};
const $0074faf5ed5c91ab$var$genBlockButtonStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            [`&${componentCls}-block`]: {
                width: '100%'
            }
        }
    };
};
var // ============================== Export ==============================
$0074faf5ed5c91ab$export$2e2bcd8739ae039 = (0, $761caadb5301aee1$export$51ec95de45185b42)('Button', (token)=>{
    const buttonToken = (0, $e71dd45d14e933d8$export$362fb92a8f81bbf9)(token);
    return [
        // Shared
        $0074faf5ed5c91ab$var$genSharedButtonStyle(buttonToken),
        // Size
        $0074faf5ed5c91ab$var$genSizeBaseButtonStyle(buttonToken),
        $0074faf5ed5c91ab$var$genSizeSmallButtonStyle(buttonToken),
        $0074faf5ed5c91ab$var$genSizeLargeButtonStyle(buttonToken),
        // Block
        $0074faf5ed5c91ab$var$genBlockButtonStyle(buttonToken),
        // Variant
        (0, $c9ba4ad0f6d93110$export$2e2bcd8739ae039)(buttonToken),
        // Button Group
        (0, $e80920bfeccccb6e$export$2e2bcd8739ae039)(buttonToken)
    ];
}, (0, $e71dd45d14e933d8$export$9ca1be8807fe0675), {
    unitless: {
        fontWeight: true,
        contentLineHeight: true,
        contentLineHeightSM: true,
        contentLineHeightLG: true
    }
});


// handle border collapse
function $1829499b88c32c7f$var$compactItemBorder(token, parentCls, options, prefixCls) {
    const { focusElCls: focusElCls, focus: focus, borderElCls: borderElCls } = options;
    const childCombinator = borderElCls ? '> *' : '';
    const suffix = childCombinator ? ` ${childCombinator}` : '';
    const genEffects = (effects)=>effects.filter(Boolean).map((n)=>`&:${n}${suffix}`).join(',');
    const hoverEffects = genEffects([
        'hover',
        focusElCls ? `hover${focusElCls}` : null
    ]);
    const focusEffects = genEffects([
        focus ? 'focus' : null,
        'active'
    ]);
    return {
        [`&-item:not(${parentCls}-last-item)`]: {
            marginInlineEnd: token.calc(token.lineWidth).mul(-1).equal()
        },
        [`&-item:not(${prefixCls}-status-success)`]: {
            zIndex: 2
        },
        '&-item': {
            [focusEffects]: {
                zIndex: 3
            },
            [hoverEffects]: {
                zIndex: 4
            },
            ...focusElCls ? {
                [`&${focusElCls}`]: {
                    zIndex: 3
                }
            } : {},
            [`&[disabled] ${childCombinator}`]: {
                zIndex: 0
            }
        }
    };
}
// handle border-radius
function $1829499b88c32c7f$var$compactItemBorderRadius(prefixCls, parentCls, options) {
    const { borderElCls: borderElCls } = options;
    const childCombinator = borderElCls ? `> ${borderElCls}` : '';
    return {
        [`&-item:not(${parentCls}-first-item):not(${parentCls}-last-item) ${childCombinator}`]: {
            borderRadius: 0
        },
        [`&-item:not(${parentCls}-last-item)${parentCls}-first-item`]: {
            [`& ${childCombinator}, &${prefixCls}-sm ${childCombinator}, &${prefixCls}-lg ${childCombinator}`]: {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
            }
        },
        [`&-item:not(${parentCls}-first-item)${parentCls}-last-item`]: {
            [`& ${childCombinator}, &${prefixCls}-sm ${childCombinator}, &${prefixCls}-lg ${childCombinator}`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            }
        }
    };
}
function $1829499b88c32c7f$export$b1208b23589b4b73(token, options = {
    focus: true
}) {
    const { componentCls: componentCls } = token;
    const { componentCls: customizePrefixCls } = options;
    const mergedComponentCls = customizePrefixCls || componentCls;
    const compactCls = `${mergedComponentCls}-compact`;
    return {
        [compactCls]: {
            ...$1829499b88c32c7f$var$compactItemBorder(token, compactCls, options, mergedComponentCls),
            ...$1829499b88c32c7f$var$compactItemBorderRadius(mergedComponentCls, compactCls, options)
        }
    };
}


function $4874145cd572d35a$var$compactItemVerticalBorder(token, parentCls, prefixCls) {
    return {
        // border collapse
        [`&-item:not(${parentCls}-last-item)`]: {
            marginBottom: token.calc(token.lineWidth).mul(-1).equal()
        },
        [`&-item:not(${prefixCls}-status-success)`]: {
            zIndex: 2
        },
        '&-item': {
            '&:focus,&:active': {
                zIndex: 3
            },
            '&:hover': {
                zIndex: 4
            },
            '&[disabled]': {
                zIndex: 0
            }
        }
    };
}
function $4874145cd572d35a$var$compactItemBorderVerticalRadius(prefixCls, parentCls) {
    return {
        [`&-item:not(${parentCls}-first-item):not(${parentCls}-last-item)`]: {
            borderRadius: 0
        },
        [`&-item${parentCls}-first-item:not(${parentCls}-last-item)`]: {
            [`&, &${prefixCls}-sm, &${prefixCls}-lg`]: {
                borderEndEndRadius: 0,
                borderEndStartRadius: 0
            }
        },
        [`&-item${parentCls}-last-item:not(${parentCls}-first-item)`]: {
            [`&, &${prefixCls}-sm, &${prefixCls}-lg`]: {
                borderStartStartRadius: 0,
                borderStartEndRadius: 0
            }
        }
    };
}
function $4874145cd572d35a$export$4dc87cb8ebf78ac6(token) {
    const compactCls = `${token.componentCls}-compact-vertical`;
    return {
        [compactCls]: {
            ...$4874145cd572d35a$var$compactItemVerticalBorder(token, compactCls, token.componentCls),
            ...$4874145cd572d35a$var$compactItemBorderVerticalRadius(token.componentCls, compactCls)
        }
    };
}





const $8dca363bb40bf00f$var$genButtonCompactStyle = (token)=>{
    const { antCls: antCls, componentCls: componentCls, lineWidth: lineWidth, calc: calc, colorBgContainer: colorBgContainer } = token;
    const solidSelector = `${componentCls}-variant-solid:not([disabled])`;
    const insetOffset = calc(lineWidth).mul(-1).equal();
    const [varName, varRef] = (0, $761caadb5301aee1$export$d82b8f66c5649e14)(antCls, 'btn');
    const getCompactBorderStyle = (vertical)=>{
        const itemCls = `${componentCls}-compact${vertical ? '-vertical' : ''}-item`;
        return {
            // TODO: Border color transition should be not cover when has color.
            [itemCls]: {
                [varName('compact-connect-border-color')]: varRef('bg-color-hover'),
                [`&${solidSelector}`]: {
                    transition: `none`,
                    [`& + ${solidSelector}:before`]: [
                        {
                            position: 'absolute',
                            backgroundColor: varRef('compact-connect-border-color'),
                            content: '""'
                        },
                        vertical ? {
                            top: insetOffset,
                            insetInline: insetOffset,
                            height: lineWidth
                        } : {
                            insetBlock: insetOffset,
                            insetInlineStart: insetOffset,
                            width: lineWidth
                        }
                    ],
                    '&:hover:before': {
                        display: 'none'
                    }
                }
            }
        };
    };
    // Special styles for solid Button
    return [
        getCompactBorderStyle(),
        getCompactBorderStyle(true),
        {
            [`${solidSelector}${componentCls}-color-default`]: {
                [varName('compact-connect-border-color')]: `color-mix(in srgb, ${varRef('bg-color-hover')} 75%, ${colorBgContainer})`
            }
        }
    ];
};
var // ============================== Export ==============================
$8dca363bb40bf00f$export$2e2bcd8739ae039 = (0, $761caadb5301aee1$export$1537386bc155ea56)([
    'Button',
    'compact'
], (token)=>{
    const buttonToken = (0, $e71dd45d14e933d8$export$362fb92a8f81bbf9)(token);
    return [
        // Space Compact
        (0, $1829499b88c32c7f$export$b1208b23589b4b73)(buttonToken),
        (0, $4874145cd572d35a$export$4dc87cb8ebf78ac6)(buttonToken),
        $8dca363bb40bf00f$var$genButtonCompactStyle(buttonToken)
    ];
}, (0, $e71dd45d14e933d8$export$9ca1be8807fe0675));


"use client";
function $17f39e4db74a8975$var$getLoadingConfig(loading) {
    if ((0, $addbc2fddcbb77a9$export$53b83ca8eaab0383)(loading)) {
        let delay = loading?.delay;
        delay = (0, $addbc2fddcbb77a9$export$7e4aa119212bc614)(delay) ? delay : 0;
        return {
            loading: delay <= 0,
            delay: delay
        };
    }
    return {
        loading: !!loading,
        delay: 0
    };
}
const $17f39e4db74a8975$var$ButtonTypeMap = {
    default: [
        'default',
        'outlined'
    ],
    primary: [
        'primary',
        'solid'
    ],
    dashed: [
        'default',
        'dashed'
    ],
    // `link` is not a real color but we should compatible with it
    link: [
        'link',
        'link'
    ],
    text: [
        'default',
        'text'
    ]
};
const $17f39e4db74a8975$var$InternalCompoundedButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).forwardRef((props, ref)=>{
    const { _skipSemantic: _skipSemantic, loading: loading = false, prefixCls: customizePrefixCls, color: color, variant: variant, type: type, danger: danger = false, shape: customizeShape, size: customizeSize, disabled: customDisabled, className: className, rootClassName: rootClassName, children: children, icon: icon, iconPosition: iconPosition, iconPlacement: iconPlacement, ghost: ghost = false, block: block = false, htmlType: // React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.
    htmlType = 'button', classNames: classNames, styles: styles, style: style, autoInsertSpace: autoInsertSpace, autoFocus: autoFocus, ...rest } = props;
    const childNodes = (0, $2ec1a2166f2295ea$export$2e2bcd8739ae039)(children);
    // https://github.com/ant-design/ant-design/issues/47605
    // Compatible with original `type` behavior
    const mergedType = type || 'default';
    const { getPrefixCls: getPrefixCls, direction: direction, autoInsertSpace: contextAutoInsertSpace, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles, loadingIcon: contextLoadingIcon, shape: contextShape, color: contextColor, variant: contextVariant } = (0, $519f2fad435b3034$export$46f4bd6436a25a31)('button');
    const mergedShape = customizeShape || contextShape || 'default';
    const [parsedColor, parsedVariant] = (0, $5E6i4.useMemo)(()=>{
        // >>>>> Local
        // Color & Variant
        if (color && variant) return [
            color,
            variant
        ];
        // Sugar syntax
        if (type || danger) {
            const colorVariantPair = $17f39e4db74a8975$var$ButtonTypeMap[mergedType] || [];
            if (danger) return [
                'danger',
                colorVariantPair[1]
            ];
            return colorVariantPair;
        }
        if (variant === 'solid') return [
            'primary',
            variant
        ];
        // >>> Context fallback
        if (contextColor && contextVariant) return [
            contextColor,
            contextVariant
        ];
        if (contextVariant === 'solid') return [
            'primary',
            contextVariant
        ];
        return [
            'default',
            'outlined'
        ];
    }, [
        color,
        variant,
        type,
        danger,
        contextColor,
        contextVariant,
        mergedType
    ]);
    const [mergedColor, mergedVariant] = (0, $5E6i4.useMemo)(()=>{
        if (ghost && parsedVariant === 'solid') return [
            parsedColor,
            'outlined'
        ];
        return [
            parsedColor,
            parsedVariant
        ];
    }, [
        parsedColor,
        parsedVariant,
        ghost
    ]);
    const isDanger = mergedColor === 'danger';
    const mergedColorText = isDanger ? 'dangerous' : mergedColor;
    const mergedInsertSpace = autoInsertSpace ?? contextAutoInsertSpace ?? true;
    const prefixCls = getPrefixCls('btn', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $0074faf5ed5c91ab$export$2e2bcd8739ae039)(prefixCls);
    const disabled = (0, $5E6i4.useContext)((0, $2ab14018ea5b2d79$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled ?? disabled;
    const groupSize = (0, $5E6i4.useContext)((0, $655f74bac8d466a0$export$ed0cc8bd1f617d6d));
    const loadingOrDelay = (0, $5E6i4.useMemo)(()=>$17f39e4db74a8975$var$getLoadingConfig(loading), [
        loading
    ]);
    const [innerLoading, setInnerLoading] = (0, $2114fb66f76f632e$export$2e2bcd8739ae039)(loadingOrDelay.loading);
    const [hasTwoCNChar, setHasTwoCNChar] = (0, $5E6i4.useState)(false);
    const buttonRef = (0, $5E6i4.useRef)(null);
    const mergedRef = (0, $92c8c75386168ffc$export$1d1c999670a1285d)(ref, buttonRef);
    const needInserted = childNodes.length === 1 && !icon && !(0, $0ceddc1355cab302$export$b120bc11c0d9c214)(mergedVariant);
    // ========================= Mount ==========================
    // Record for mount status.
    // This will help to no to show the animation of loading on the first mount.
    const isMountRef = (0, $5E6i4.useRef)(true);
    (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useEffect(()=>{
        isMountRef.current = false;
        return ()=>{
            isMountRef.current = true;
        };
    }, []);
    // ========================= Effect =========================
    // Loading. Should use `useLayoutEffect` to avoid low perf multiple click issue.
    // https://github.com/ant-design/ant-design/issues/51325
    (0, $518ae471aa4f03a7$export$2e2bcd8739ae039)(()=>{
        if (loadingOrDelay.delay > 0) setInnerLoading(true, {
            ms: loadingOrDelay.delay
        });
        else setInnerLoading(loadingOrDelay.loading, true);
    }, [
        loadingOrDelay.delay,
        loadingOrDelay.loading
    ]);
    // Two chinese characters check
    (0, $5E6i4.useEffect)(()=>{
        // FIXME: for HOC usage like <FormatMessage />
        if (!buttonRef.current || !mergedInsertSpace) return;
        const buttonText = buttonRef.current.textContent || '';
        if (needInserted && (0, $0ceddc1355cab302$export$c5dca2bf412dea0d)(buttonText)) {
            if (!hasTwoCNChar) setHasTwoCNChar(true);
        } else if (hasTwoCNChar) setHasTwoCNChar(false);
    }); // 这里不需要依赖数组
    // Auto focus
    (0, $5E6i4.useEffect)(()=>{
        if (autoFocus) buttonRef.current?.focus();
    }, []); // 这里不需要依赖 autoFocus 变量，只需要在第一次 mount 时生效
    // ========================= Events =========================
    const handleClick = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useCallback((e)=>{
        // FIXME: https://github.com/ant-design/ant-design/issues/30207
        if (innerLoading || mergedDisabled) {
            e.preventDefault();
            return;
        }
        props.onClick?.('href' in props ? e : e);
    }, [
        props.onClick,
        innerLoading,
        mergedDisabled
    ]);
    // ========================== Size ==========================
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $3ee2444c5d59b36b$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    const sizeFullName = (0, $4bfc7567df2a969e$export$2e2bcd8739ae039)((ctxSize)=>customizeSize ?? compactSize ?? groupSize ?? ctxSize);
    const iconType = innerLoading ? 'loading' : icon;
    const mergedIconPlacement = iconPlacement ?? iconPosition ?? 'start';
    const linkButtonRestProps = (0, $48bd91d9f828de66$export$2e2bcd8739ae039)(rest, [
        'navigate'
    ]);
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        type: mergedType,
        color: mergedColor,
        variant: mergedVariant,
        danger: isDanger,
        shape: mergedShape,
        size: sizeFullName,
        disabled: mergedDisabled,
        loading: innerLoading,
        iconPlacement: mergedIconPlacement
    };
    // ========================= Style ==========================
    const contextStyleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $722c8632ba7bdb89$export$648566b068f28737)([
        _skipSemantic ? undefined : contextClassNames,
        classNames
    ], [
        _skipSemantic ? undefined : contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    });
    // ========================= Render =========================
    const classes = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, hashId, cssVarCls, {
        [`${prefixCls}-${mergedShape}`]: mergedShape !== 'default' && mergedShape !== 'square' && mergedShape,
        // Compatible with versions earlier than 5.21.0
        [`${prefixCls}-${mergedType}`]: mergedType,
        [`${prefixCls}-dangerous`]: danger,
        [`${prefixCls}-color-${mergedColorText}`]: mergedColorText,
        [`${prefixCls}-variant-${mergedVariant}`]: mergedVariant,
        [`${prefixCls}-lg`]: sizeFullName === 'large',
        [`${prefixCls}-sm`]: sizeFullName === 'small',
        [`${prefixCls}-icon-only`]: !children && children !== 0 && !!iconType,
        [`${prefixCls}-background-ghost`]: ghost && !(0, $0ceddc1355cab302$export$b120bc11c0d9c214)(mergedVariant),
        [`${prefixCls}-loading`]: innerLoading,
        [`${prefixCls}-two-chinese-chars`]: hasTwoCNChar && mergedInsertSpace && !innerLoading,
        [`${prefixCls}-block`]: block,
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-icon-end`]: mergedIconPlacement === 'end'
    }, compactItemClassnames, className, rootClassName, contextClassName, mergedClassNames.root);
    const iconSharedProps = {
        className: mergedClassNames.icon,
        style: mergedStyles.icon
    };
    /**
   * Extract icon node
   * If there is a custom icon and not in loading state: show custom icon
   */ const iconWrapperElement = (child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $c298a5de1fa72642$export$2e2bcd8739ae039), {
            prefixCls: prefixCls,
            ...iconSharedProps
        }, child);
    const defaultLoadingIconElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $6679be160185d5d2$export$2e2bcd8739ae039), {
        existIcon: !!icon,
        prefixCls: prefixCls,
        loading: innerLoading,
        mount: isMountRef.current,
        ...iconSharedProps
    });
    const mergedLoadingIcon = (0, $addbc2fddcbb77a9$export$53b83ca8eaab0383)(loading) ? loading.icon || contextLoadingIcon : contextLoadingIcon;
    /**
   * Using if-else statements can improve code readability without affecting future expansion.
   */ let iconNode;
    if (icon && !innerLoading) iconNode = iconWrapperElement(icon);
    else if (innerLoading && mergedLoadingIcon) iconNode = iconWrapperElement(mergedLoadingIcon);
    else iconNode = defaultLoadingIconElement;
    const contentNode = (0, $b63de2b9864a5d1a$export$72280d5f896dac9a)(children) ? (0, $0ceddc1355cab302$export$b6ee00a7e7908bc)(children, needInserted && mergedInsertSpace, mergedStyles.content, mergedClassNames.content) : null;
    if (linkButtonRestProps.href !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("a", {
        ...linkButtonRestProps,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(classes, {
            [`${prefixCls}-disabled`]: mergedDisabled
        }),
        href: mergedDisabled ? undefined : linkButtonRestProps.href,
        style: mergedStyles.root,
        onClick: handleClick,
        ref: mergedRef,
        tabIndex: mergedDisabled ? -1 : 0,
        "aria-disabled": mergedDisabled
    }, iconNode, contentNode);
    let buttonNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("button", {
        ...rest,
        type: htmlType,
        className: classes,
        style: mergedStyles.root,
        onClick: handleClick,
        disabled: mergedDisabled,
        ref: mergedRef
    }, iconNode, contentNode, compactItemClassnames && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $8dca363bb40bf00f$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }));
    if (!(0, $0ceddc1355cab302$export$b120bc11c0d9c214)(mergedVariant)) buttonNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $fac597d347ed38a8$export$2e2bcd8739ae039), {
        component: "Button",
        disabled: innerLoading
    }, buttonNode);
    return buttonNode;
});
const $17f39e4db74a8975$var$Button = $17f39e4db74a8975$var$InternalCompoundedButton;
$17f39e4db74a8975$var$Button.Group = (0, $655f74bac8d466a0$export$2e2bcd8739ae039);
$17f39e4db74a8975$var$Button.__ANT_BUTTON = true;
var $17f39e4db74a8975$export$2e2bcd8739ae039 = $17f39e4db74a8975$var$Button;



"use client";
var $67d71c16fdfc3a0e$export$2e2bcd8739ae039 = (0, $17f39e4db74a8975$export$2e2bcd8739ae039);


var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $a3678ff6dea95411$var$LeftOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z"
                }
            }
        ]
    },
    "name": "left",
    "theme": "outlined"
};
var $a3678ff6dea95411$export$2e2bcd8739ae039 = $a3678ff6dea95411$var$LeftOutlined;



function $2abf808b8f2c53a3$var$_extends() {
    $2abf808b8f2c53a3$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2abf808b8f2c53a3$var$_extends.apply(this, arguments);
}
const $2abf808b8f2c53a3$var$LeftOutlined = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $2abf808b8f2c53a3$var$_extends({}, props, {
        ref: ref,
        icon: (0, $a3678ff6dea95411$export$2e2bcd8739ae039)
    }));
/**![left](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTcyNCAyMTguM1YxNDFjMC02LjctNy43LTEwLjQtMTIuOS02LjNMMjYwLjMgNDg2LjhhMzEuODYgMzEuODYgMCAwMDAgNTAuM2w0NTAuOCAzNTIuMWM1LjMgNC4xIDEyLjkuNCAxMi45LTYuM3YtNzcuM2MwLTQuOS0yLjMtOS42LTYuMS0xMi42bC0zNjAtMjgxIDM2MC0yODEuMWMzLjgtMyA2LjEtNy43IDYuMS0xMi42eiIgLz48L3N2Zz4=) */ const $2abf808b8f2c53a3$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($2abf808b8f2c53a3$var$LeftOutlined);
var $2abf808b8f2c53a3$export$2e2bcd8739ae039 = $2abf808b8f2c53a3$var$RefIcon;







var $5E6i4 = parcelRequire("5E6i4");


var $5E6i4 = parcelRequire("5E6i4");
const { ESC: $04b66a5dbcbdbe0d$var$ESC, TAB: $04b66a5dbcbdbe0d$var$TAB } = (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039);
function $04b66a5dbcbdbe0d$export$2e2bcd8739ae039({ visible: visible, triggerRef: triggerRef, onVisibleChange: onVisibleChange, autoFocus: autoFocus, overlayRef: overlayRef }) {
    const focusMenuRef = $5E6i4.useRef(false);
    const handleCloseMenuAndReturnFocus = ()=>{
        if (visible) {
            triggerRef.current?.focus?.();
            onVisibleChange?.(false);
        }
    };
    const focusMenu = ()=>{
        if (overlayRef.current?.focus) {
            overlayRef.current.focus();
            focusMenuRef.current = true;
            return true;
        }
        return false;
    };
    const handleKeyDown = (event)=>{
        switch(event.keyCode){
            case $04b66a5dbcbdbe0d$var$ESC:
                handleCloseMenuAndReturnFocus();
                break;
            case $04b66a5dbcbdbe0d$var$TAB:
                {
                    let focusResult = false;
                    if (!focusMenuRef.current) focusResult = focusMenu();
                    if (focusResult) event.preventDefault();
                    else handleCloseMenuAndReturnFocus();
                    break;
                }
        }
    };
    $5E6i4.useEffect(()=>{
        if (visible) {
            window.addEventListener('keydown', handleKeyDown);
            if (autoFocus) // FIXME: hack with raf
            (0, $1d949665862f071a$export$2e2bcd8739ae039)(focusMenu, 3);
            return ()=>{
                window.removeEventListener('keydown', handleKeyDown);
                focusMenuRef.current = false;
            };
        }
        return ()=>{
            focusMenuRef.current = false;
        };
    }, [
        visible
    ]); // eslint-disable-line react-hooks/exhaustive-deps
}




var $5E6i4 = parcelRequire("5E6i4");
const $0cde598ea978e5bf$var$Overlay = /*#__PURE__*/ (0, $5E6i4.forwardRef)((props, ref)=>{
    const { overlay: overlay, arrow: arrow, prefixCls: prefixCls } = props;
    const overlayNode = (0, $5E6i4.useMemo)(()=>{
        let overlayElement;
        if (typeof overlay === 'function') overlayElement = overlay();
        else overlayElement = overlay;
        return overlayElement;
    }, [
        overlay
    ]);
    const composedRef = (0, $92c8c75386168ffc$export$ab452c34e8e05029)(ref, (0, $92c8c75386168ffc$export$7465e5c0bf44f19a)(overlayNode));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).Fragment, null, arrow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("div", {
        className: `${prefixCls}-arrow`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).cloneElement(overlayNode, {
        ref: (0, $92c8c75386168ffc$export$c1cec34af06bcf7)(overlayNode) ? composedRef : undefined
    }));
});
var $0cde598ea978e5bf$export$2e2bcd8739ae039 = $0cde598ea978e5bf$var$Overlay;


const $a09940c0cb827bf3$var$autoAdjustOverflow = {
    adjustX: 1,
    adjustY: 1
};
const $a09940c0cb827bf3$var$targetOffset = [
    0,
    0
];
const $a09940c0cb827bf3$var$placements = {
    topLeft: {
        points: [
            'bl',
            'tl'
        ],
        overflow: $a09940c0cb827bf3$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $a09940c0cb827bf3$var$targetOffset
    },
    top: {
        points: [
            'bc',
            'tc'
        ],
        overflow: $a09940c0cb827bf3$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $a09940c0cb827bf3$var$targetOffset
    },
    topRight: {
        points: [
            'br',
            'tr'
        ],
        overflow: $a09940c0cb827bf3$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $a09940c0cb827bf3$var$targetOffset
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ],
        overflow: $a09940c0cb827bf3$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $a09940c0cb827bf3$var$targetOffset
    },
    bottom: {
        points: [
            'tc',
            'bc'
        ],
        overflow: $a09940c0cb827bf3$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $a09940c0cb827bf3$var$targetOffset
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ],
        overflow: $a09940c0cb827bf3$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $a09940c0cb827bf3$var$targetOffset
    }
};
var $a09940c0cb827bf3$export$2e2bcd8739ae039 = $a09940c0cb827bf3$var$placements;


function $38185c27591080bf$var$_extends() {
    $38185c27591080bf$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $38185c27591080bf$var$_extends.apply(this, arguments);
}
const $38185c27591080bf$var$Dropdown = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).forwardRef((props, ref)=>{
    const { arrow: arrow = false, prefixCls: prefixCls = 'rc-dropdown', transitionName: transitionName, animation: animation, align: align, placement: placement = 'bottomLeft', placements: placements = (0, $a09940c0cb827bf3$export$2e2bcd8739ae039), getPopupContainer: getPopupContainer, showAction: showAction, hideAction: hideAction, overlayClassName: overlayClassName, overlayStyle: overlayStyle, visible: visible, trigger: trigger = [
        'hover'
    ], autoFocus: autoFocus, overlay: overlay, children: children, onVisibleChange: onVisibleChange, disabled: disabled, ...otherProps } = props;
    const [triggerVisible, setTriggerVisible] = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useState();
    const mergedVisible = 'visible' in props ? visible : triggerVisible;
    const mergedMotionName = animation ? `${prefixCls}-${animation}` : transitionName;
    const triggerRef = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useRef(null);
    const overlayRef = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useRef(null);
    const childRef = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useImperativeHandle(ref, ()=>triggerRef.current);
    const handleVisibleChange = (newVisible)=>{
        setTriggerVisible(newVisible);
        onVisibleChange?.(newVisible);
    };
    (0, $04b66a5dbcbdbe0d$export$2e2bcd8739ae039)({
        visible: mergedVisible,
        triggerRef: childRef,
        onVisibleChange: handleVisibleChange,
        autoFocus: autoFocus,
        overlayRef: overlayRef
    });
    const onClick = (e)=>{
        const { onOverlayClick: onOverlayClick } = props;
        setTriggerVisible(false);
        if (onOverlayClick) onOverlayClick(e);
    };
    const getMenuElement = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $0cde598ea978e5bf$export$2e2bcd8739ae039), {
            ref: overlayRef,
            overlay: overlay,
            prefixCls: prefixCls,
            arrow: arrow
        });
    const getMenuElementOrLambda = ()=>{
        if (typeof overlay === 'function') return getMenuElement;
        return getMenuElement();
    };
    const getMinOverlayWidthMatchTrigger = ()=>{
        const { minOverlayWidthMatchTrigger: minOverlayWidthMatchTrigger, alignPoint: alignPoint } = props;
        if ('minOverlayWidthMatchTrigger' in props) return minOverlayWidthMatchTrigger;
        return !alignPoint;
    };
    const getOpenClassName = ()=>{
        const { openClassName: openClassName } = props;
        if (openClassName !== undefined) return openClassName;
        return `${prefixCls}-open`;
    };
    const elementChild = children;
    const childClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(elementChild.props?.className, mergedVisible && getOpenClassName());
    const triggerChildProps = {
        className: childClassName,
        ref: (0, $92c8c75386168ffc$export$ab452c34e8e05029)(childRef, (0, $92c8c75386168ffc$export$7465e5c0bf44f19a)(elementChild))
    };
    const childrenNode = (0, $92c8c75386168ffc$export$c1cec34af06bcf7)(elementChild) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).cloneElement(elementChild, triggerChildProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("span", {
        className: childClassName,
        ref: childRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).cloneElement(elementChild, {
        className: childClassName
    }));
    let triggerHideAction = hideAction;
    if (!triggerHideAction && trigger.indexOf('contextMenu') !== -1) triggerHideAction = [
        'click'
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $5ff8ad2f21affc17$export$2e2bcd8739ae039), $38185c27591080bf$var$_extends({
        builtinPlacements: placements
    }, otherProps, {
        prefixCls: prefixCls,
        ref: triggerRef,
        popupClassName: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(overlayClassName, {
            [`${prefixCls}-show-arrow`]: arrow
        }),
        popupStyle: overlayStyle,
        action: trigger,
        showAction: showAction,
        hideAction: triggerHideAction,
        popupPlacement: placement,
        popupAlign: align,
        popupMotion: {
            motionName: mergedMotionName
        },
        popupVisible: mergedVisible,
        stretch: getMinOverlayWidthMatchTrigger() ? 'minWidth' : '',
        popup: getMenuElementOrLambda(),
        onOpenChange: handleVisibleChange,
        onPopupClick: onClick,
        getPopupContainer: getPopupContainer
    }), childrenNode);
});
var $38185c27591080bf$export$2e2bcd8739ae039 = $38185c27591080bf$var$Dropdown;


var $3b318c9105776b14$export$2e2bcd8739ae039 = (0, $38185c27591080bf$export$2e2bcd8739ae039);





var $5E6i4 = parcelRequire("5E6i4");



var $5E6i4 = parcelRequire("5E6i4");
const $c8c4739fe508f3df$var$ZIndexContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createContext(undefined);
var $c8c4739fe508f3df$export$2e2bcd8739ae039 = $c8c4739fe508f3df$var$ZIndexContext;


// Z-Index control range
// Container: 1000 + offset 100 (max base + 10 * offset = 2000)
// Popover: offset 50
// Notification: Container Max zIndex + componentOffset
const $09c5eb33e460ecef$var$CONTAINER_OFFSET = 100;
const $09c5eb33e460ecef$var$CONTAINER_OFFSET_MAX_COUNT = 10;
const $09c5eb33e460ecef$export$33ada7d8845f7e5 = $09c5eb33e460ecef$var$CONTAINER_OFFSET * $09c5eb33e460ecef$var$CONTAINER_OFFSET_MAX_COUNT;
/**
 * Static function will default be the `CONTAINER_MAX_OFFSET`.
 * But it still may have children component like Select, Dropdown.
 * So the warning zIndex should exceed the `CONTAINER_MAX_OFFSET`.
 */ const $09c5eb33e460ecef$var$CONTAINER_MAX_OFFSET_WITH_CHILDREN = $09c5eb33e460ecef$export$33ada7d8845f7e5 + $09c5eb33e460ecef$var$CONTAINER_OFFSET;
const $09c5eb33e460ecef$export$1658852af8bb2a55 = {
    Modal: $09c5eb33e460ecef$var$CONTAINER_OFFSET,
    Drawer: $09c5eb33e460ecef$var$CONTAINER_OFFSET,
    Popover: $09c5eb33e460ecef$var$CONTAINER_OFFSET,
    Popconfirm: $09c5eb33e460ecef$var$CONTAINER_OFFSET,
    Tooltip: $09c5eb33e460ecef$var$CONTAINER_OFFSET,
    Tour: $09c5eb33e460ecef$var$CONTAINER_OFFSET,
    FloatButton: $09c5eb33e460ecef$var$CONTAINER_OFFSET
};
const $09c5eb33e460ecef$export$3f7a364c708f940b = {
    SelectLike: 50,
    Dropdown: 50,
    DatePicker: 50,
    Menu: 50,
    ImagePreview: 1
};
const $09c5eb33e460ecef$var$isContainerType = (type)=>{
    return type in $09c5eb33e460ecef$export$1658852af8bb2a55;
};
const $09c5eb33e460ecef$export$3e7906d4075187a4 = (componentType, customZIndex)=>{
    const [, token] = (0, $cb3a44f4e76623bb$export$2e2bcd8739ae039)();
    const parentZIndex = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useContext((0, $c8c4739fe508f3df$export$2e2bcd8739ae039));
    const isContainer = $09c5eb33e460ecef$var$isContainerType(componentType);
    let result;
    if (customZIndex !== undefined) result = [
        customZIndex,
        customZIndex
    ];
    else {
        let zIndex = parentZIndex ?? 0;
        if (isContainer) zIndex += // Use preset token zIndex by default but not stack when has parent container
        (parentZIndex ? 0 : token.zIndexPopupBase) + // Container offset
        $09c5eb33e460ecef$export$1658852af8bb2a55[componentType];
        else zIndex += $09c5eb33e460ecef$export$3f7a364c708f940b[componentType];
        result = [
            parentZIndex === undefined ? customZIndex : zIndex,
            zIndex
        ];
    }
    return result;
};







function $0c98a14a5d55f8de$export$87e38ee403661ccc(token) {
    const { sizePopupArrow: sizePopupArrow, borderRadiusXS: borderRadiusXS, borderRadiusOuter: borderRadiusOuter } = token;
    const unitWidth = sizePopupArrow / 2;
    const ax = 0;
    const ay = unitWidth;
    const bx = borderRadiusOuter * 1 / Math.sqrt(2);
    const by = unitWidth - borderRadiusOuter * (1 - 1 / Math.sqrt(2));
    const cx = unitWidth - borderRadiusXS * (1 / Math.sqrt(2));
    const cy = borderRadiusOuter * (Math.sqrt(2) - 1) + borderRadiusXS * (1 / Math.sqrt(2));
    const dx = 2 * unitWidth - cx;
    const dy = cy;
    const ex = 2 * unitWidth - bx;
    const ey = by;
    const fx = 2 * unitWidth - ax;
    const fy = ay;
    const shadowWidth = unitWidth * Math.sqrt(2) + borderRadiusOuter * (Math.sqrt(2) - 2);
    const polygonOffset = borderRadiusOuter * (Math.sqrt(2) - 1);
    const arrowPolygon = `polygon(${polygonOffset}px 100%, 50% ${polygonOffset}px, ${2 * unitWidth - polygonOffset}px 100%, ${polygonOffset}px 100%)`;
    const arrowPath = `path('M ${ax} ${ay} A ${borderRadiusOuter} ${borderRadiusOuter} 0 0 0 ${bx} ${by} L ${cx} ${cy} A ${borderRadiusXS} ${borderRadiusXS} 0 0 1 ${dx} ${dy} L ${ex} ${ey} A ${borderRadiusOuter} ${borderRadiusOuter} 0 0 0 ${fx} ${fy} Z')`;
    return {
        arrowShadowWidth: shadowWidth,
        arrowPath: arrowPath,
        arrowPolygon: arrowPolygon
    };
}
const $0c98a14a5d55f8de$export$601fa0375eb80eec = (token, bgColor, boxShadow)=>{
    const { sizePopupArrow: sizePopupArrow, arrowPolygon: arrowPolygon, arrowPath: arrowPath, arrowShadowWidth: arrowShadowWidth, borderRadiusXS: borderRadiusXS, calc: calc } = token;
    const afterStyle = {
        content: '""',
        position: 'absolute',
        width: arrowShadowWidth,
        height: arrowShadowWidth,
        bottom: 0,
        insetInline: 0,
        margin: 'auto',
        borderRadius: {
            _skip_check_: true,
            value: `0 0 ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(borderRadiusXS)} 0`
        },
        transform: 'translateY(50%) rotate(-135deg)',
        zIndex: 0,
        background: 'transparent'
    };
    if (boxShadow) afterStyle.boxShadow = boxShadow;
    return {
        pointerEvents: 'none',
        width: sizePopupArrow,
        height: sizePopupArrow,
        overflow: 'hidden',
        '&::before': {
            position: 'absolute',
            bottom: 0,
            insetInlineStart: 0,
            width: sizePopupArrow,
            height: calc(sizePopupArrow).div(2).equal(),
            background: bgColor,
            clipPath: {
                _multi_value_: true,
                value: [
                    arrowPolygon,
                    arrowPath
                ]
            },
            content: '""'
        },
        '&::after': afterStyle
    };
};


const $2540b05188c79e49$export$de6e4ffc9ec3c089 = 8;
function $2540b05188c79e49$export$bddc192327bb9823(options) {
    const { contentRadius: contentRadius, limitVerticalRadius: limitVerticalRadius } = options;
    const arrowOffset = contentRadius > 12 ? contentRadius + 2 : 12;
    const arrowOffsetVertical = limitVerticalRadius ? $2540b05188c79e49$export$de6e4ffc9ec3c089 : arrowOffset;
    return {
        arrowOffsetHorizontal: arrowOffset,
        arrowOffsetVertical: arrowOffsetVertical
    };
}
const $2540b05188c79e49$var$getArrowStyle = (token, colorBg, options)=>{
    const { componentCls: componentCls, boxShadowPopoverArrow: boxShadowPopoverArrow, arrowOffsetVertical: arrowOffsetVertical, arrowOffsetHorizontal: arrowOffsetHorizontal, antCls: antCls } = token;
    const [varName] = (0, $761caadb5301aee1$export$d82b8f66c5649e14)(antCls, 'tooltip');
    const { arrowDistance: arrowDistance = 0, arrowShadow: arrowShadow = true } = options || {};
    return {
        [componentCls]: {
            // ============================ Basic ============================
            [`${componentCls}-arrow`]: [
                {
                    position: 'absolute',
                    zIndex: 1,
                    // lift it up so the menu wouldn't cask shadow on it
                    display: 'block',
                    ...(0, $0c98a14a5d55f8de$export$601fa0375eb80eec)(token, colorBg, arrowShadow ? boxShadowPopoverArrow : false),
                    '&:before': {
                        background: colorBg
                    }
                }
            ],
            // ========================== Placement ==========================
            // Here handle the arrow position and rotate stuff
            // >>>>> Top
            [[
                `&-placement-top > ${componentCls}-arrow`,
                `&-placement-topLeft > ${componentCls}-arrow`,
                `&-placement-topRight > ${componentCls}-arrow`
            ].join(',')]: {
                bottom: arrowDistance,
                transform: 'translateY(100%) rotate(180deg)'
            },
            [`&-placement-top > ${componentCls}-arrow`]: {
                left: {
                    _skip_check_: true,
                    value: '50%'
                },
                transform: 'translateX(-50%) translateY(100%) rotate(180deg)'
            },
            '&-placement-topLeft': {
                [varName('arrow-offset-x')]: arrowOffsetHorizontal,
                [`> ${componentCls}-arrow`]: {
                    left: {
                        _skip_check_: true,
                        value: arrowOffsetHorizontal
                    }
                }
            },
            '&-placement-topRight': {
                [varName('arrow-offset-x')]: `calc(100% - ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(arrowOffsetHorizontal)})`,
                [`> ${componentCls}-arrow`]: {
                    right: {
                        _skip_check_: true,
                        value: arrowOffsetHorizontal
                    }
                }
            },
            // >>>>> Bottom
            [[
                `&-placement-bottom > ${componentCls}-arrow`,
                `&-placement-bottomLeft > ${componentCls}-arrow`,
                `&-placement-bottomRight > ${componentCls}-arrow`
            ].join(',')]: {
                top: arrowDistance,
                transform: `translateY(-100%)`
            },
            [`&-placement-bottom > ${componentCls}-arrow`]: {
                left: {
                    _skip_check_: true,
                    value: '50%'
                },
                transform: `translateX(-50%) translateY(-100%)`
            },
            '&-placement-bottomLeft': {
                [varName('arrow-offset-x')]: arrowOffsetHorizontal,
                [`> ${componentCls}-arrow`]: {
                    left: {
                        _skip_check_: true,
                        value: arrowOffsetHorizontal
                    }
                }
            },
            '&-placement-bottomRight': {
                [varName('arrow-offset-x')]: `calc(100% - ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(arrowOffsetHorizontal)})`,
                [`> ${componentCls}-arrow`]: {
                    right: {
                        _skip_check_: true,
                        value: arrowOffsetHorizontal
                    }
                }
            },
            // >>>>> Left
            [[
                `&-placement-left > ${componentCls}-arrow`,
                `&-placement-leftTop > ${componentCls}-arrow`,
                `&-placement-leftBottom > ${componentCls}-arrow`
            ].join(',')]: {
                right: {
                    _skip_check_: true,
                    value: arrowDistance
                },
                transform: 'translateX(100%) rotate(90deg)'
            },
            [`&-placement-left > ${componentCls}-arrow`]: {
                top: {
                    _skip_check_: true,
                    value: '50%'
                },
                transform: 'translateY(-50%) translateX(100%) rotate(90deg)'
            },
            [`&-placement-leftTop > ${componentCls}-arrow`]: {
                top: arrowOffsetVertical
            },
            [`&-placement-leftBottom > ${componentCls}-arrow`]: {
                bottom: arrowOffsetVertical
            },
            // >>>>> Right
            [[
                `&-placement-right > ${componentCls}-arrow`,
                `&-placement-rightTop > ${componentCls}-arrow`,
                `&-placement-rightBottom > ${componentCls}-arrow`
            ].join(',')]: {
                left: {
                    _skip_check_: true,
                    value: arrowDistance
                },
                transform: 'translateX(-100%) rotate(-90deg)'
            },
            [`&-placement-right > ${componentCls}-arrow`]: {
                top: {
                    _skip_check_: true,
                    value: '50%'
                },
                transform: 'translateY(-50%) translateX(-100%) rotate(-90deg)'
            },
            [`&-placement-rightTop > ${componentCls}-arrow`]: {
                top: arrowOffsetVertical
            },
            [`&-placement-rightBottom > ${componentCls}-arrow`]: {
                bottom: arrowOffsetVertical
            }
        }
    };
};
var $2540b05188c79e49$export$2e2bcd8739ae039 = $2540b05188c79e49$var$getArrowStyle;



function $08f8f8640738851c$export$fde75e5b410c093f(placement, arrowOffset, arrowWidth, autoAdjustOverflow) {
    if (autoAdjustOverflow === false) return {
        adjustX: false,
        adjustY: false
    };
    const overflow = (0, $addbc2fddcbb77a9$export$53b83ca8eaab0383)(autoAdjustOverflow) ? autoAdjustOverflow : {};
    const baseOverflow = {};
    switch(placement){
        case 'top':
        case 'bottom':
            baseOverflow.shiftX = arrowOffset.arrowOffsetHorizontal * 2 + arrowWidth;
            baseOverflow.shiftY = true;
            baseOverflow.adjustY = true;
            break;
        case 'left':
        case 'right':
            baseOverflow.shiftY = arrowOffset.arrowOffsetVertical * 2 + arrowWidth;
            baseOverflow.shiftX = true;
            baseOverflow.adjustX = true;
            break;
    }
    const mergedOverflow = {
        ...baseOverflow,
        ...overflow
    };
    // Support auto shift
    if (!mergedOverflow.shiftX) mergedOverflow.adjustX = true;
    if (!mergedOverflow.shiftY) mergedOverflow.adjustY = true;
    return mergedOverflow;
}
const $08f8f8640738851c$var$PlacementAlignMap = {
    left: {
        points: [
            'cr',
            'cl'
        ]
    },
    right: {
        points: [
            'cl',
            'cr'
        ]
    },
    top: {
        points: [
            'bc',
            'tc'
        ]
    },
    bottom: {
        points: [
            'tc',
            'bc'
        ]
    },
    topLeft: {
        points: [
            'bl',
            'tl'
        ]
    },
    leftTop: {
        points: [
            'tr',
            'tl'
        ]
    },
    topRight: {
        points: [
            'br',
            'tr'
        ]
    },
    rightTop: {
        points: [
            'tl',
            'tr'
        ]
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ]
    },
    rightBottom: {
        points: [
            'bl',
            'br'
        ]
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ]
    },
    leftBottom: {
        points: [
            'br',
            'bl'
        ]
    }
};
const $08f8f8640738851c$var$ArrowCenterPlacementAlignMap = {
    topLeft: {
        points: [
            'bl',
            'tc'
        ]
    },
    leftTop: {
        points: [
            'tr',
            'cl'
        ]
    },
    topRight: {
        points: [
            'br',
            'tc'
        ]
    },
    rightTop: {
        points: [
            'tl',
            'cr'
        ]
    },
    bottomRight: {
        points: [
            'tr',
            'bc'
        ]
    },
    rightBottom: {
        points: [
            'bl',
            'cr'
        ]
    },
    bottomLeft: {
        points: [
            'tl',
            'bc'
        ]
    },
    leftBottom: {
        points: [
            'br',
            'cl'
        ]
    }
};
const $08f8f8640738851c$var$DisableAutoArrowList = new Set([
    'topLeft',
    'topRight',
    'bottomLeft',
    'bottomRight',
    'leftTop',
    'leftBottom',
    'rightTop',
    'rightBottom'
]);
function $08f8f8640738851c$export$2e2bcd8739ae039(config) {
    const { arrowWidth: arrowWidth, autoAdjustOverflow: autoAdjustOverflow, arrowPointAtCenter: arrowPointAtCenter, offset: offset, borderRadius: borderRadius, visibleFirst: visibleFirst } = config;
    const halfArrowWidth = arrowWidth / 2;
    const placementMap = {};
    // Dynamic offset
    const arrowOffset = (0, $2540b05188c79e49$export$bddc192327bb9823)({
        contentRadius: borderRadius,
        limitVerticalRadius: true
    });
    Object.keys($08f8f8640738851c$var$PlacementAlignMap).forEach((key)=>{
        const template = arrowPointAtCenter && $08f8f8640738851c$var$ArrowCenterPlacementAlignMap[key] || $08f8f8640738851c$var$PlacementAlignMap[key];
        const placementInfo = {
            ...template,
            offset: [
                0,
                0
            ],
            dynamicInset: true
        };
        placementMap[key] = placementInfo;
        // Disable autoArrow since design is fixed position
        if ($08f8f8640738851c$var$DisableAutoArrowList.has(key)) placementInfo.autoArrow = false;
        // Static offset
        switch(key){
            case 'top':
            case 'topLeft':
            case 'topRight':
                placementInfo.offset[1] = -halfArrowWidth - offset;
                break;
            case 'bottom':
            case 'bottomLeft':
            case 'bottomRight':
                placementInfo.offset[1] = halfArrowWidth + offset;
                break;
            case 'left':
            case 'leftTop':
            case 'leftBottom':
                placementInfo.offset[0] = -halfArrowWidth - offset;
                break;
            case 'right':
            case 'rightTop':
            case 'rightBottom':
                placementInfo.offset[0] = halfArrowWidth + offset;
                break;
        }
        if (arrowPointAtCenter) switch(key){
            case 'topLeft':
            case 'bottomLeft':
                placementInfo.offset[0] = -arrowOffset.arrowOffsetHorizontal - halfArrowWidth;
                break;
            case 'topRight':
            case 'bottomRight':
                placementInfo.offset[0] = arrowOffset.arrowOffsetHorizontal + halfArrowWidth;
                break;
            case 'leftTop':
            case 'rightTop':
                placementInfo.offset[1] = -arrowOffset.arrowOffsetHorizontal * 2 + halfArrowWidth;
                break;
            case 'leftBottom':
            case 'rightBottom':
                placementInfo.offset[1] = arrowOffset.arrowOffsetHorizontal * 2 - halfArrowWidth;
                break;
        }
        // Overflow
        placementInfo.overflow = $08f8f8640738851c$export$fde75e5b410c093f(key, arrowOffset, arrowWidth, autoAdjustOverflow);
        // VisibleFirst
        if (visibleFirst) placementInfo.htmlRegion = 'visibleFirst';
    });
    return placementMap;
}



var $5E6i4 = parcelRequire("5E6i4");


"use client";
function $f49bb770731dacb5$export$29e2a8c3cdb34b03(Component) {
    return (props)=>/*#__PURE__*/ $5E6i4.createElement((0, $58662003e62ec648$export$2e2bcd8739ae039), {
            theme: {
                token: {
                    motion: false,
                    zIndexPopupBase: 0
                }
            }
        }, /*#__PURE__*/ $5E6i4.createElement(Component, {
            ...props
        }));
}
/* istanbul ignore next */ const $f49bb770731dacb5$var$genPurePanel = (Component, alignPropName, postProps, defaultPrefixCls, getDropdownCls)=>{
    const PurePanel = (props)=>{
        const { prefixCls: customizePrefixCls, style: style } = props;
        const holderRef = $5E6i4.useRef(null);
        const [popupHeight, setPopupHeight] = $5E6i4.useState(0);
        const [popupWidth, setPopupWidth] = $5E6i4.useState(0);
        const [open, setOpen] = (0, $e18df22f16a16360$export$2e2bcd8739ae039)(false, props.open);
        const { getPrefixCls: getPrefixCls } = $5E6i4.useContext((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
        const prefixCls = getPrefixCls(defaultPrefixCls || 'select', customizePrefixCls);
        $5E6i4.useEffect(()=>{
            // We do not care about ssr
            setOpen(true);
            if (typeof ResizeObserver !== 'undefined') {
                const resizeObserver = new ResizeObserver((entries)=>{
                    const element = entries[0].target;
                    setPopupHeight(element.offsetHeight + 8);
                    setPopupWidth(element.offsetWidth);
                });
                const interval = setInterval(()=>{
                    const dropdownCls = getDropdownCls ? `.${getDropdownCls(prefixCls)}` : `.${prefixCls}-dropdown`;
                    const popup = holderRef.current?.querySelector(dropdownCls);
                    if (popup) {
                        clearInterval(interval);
                        resizeObserver.observe(popup);
                    }
                }, 10);
                return ()=>{
                    clearInterval(interval);
                    resizeObserver.disconnect();
                };
            }
        }, [
            prefixCls
        ]);
        let mergedProps = {
            ...props,
            style: {
                ...style,
                margin: 0
            },
            open: open,
            getPopupContainer: ()=>holderRef.current
        };
        if (postProps) mergedProps = postProps(mergedProps);
        if (alignPropName) mergedProps = {
            ...mergedProps,
            [alignPropName]: {
                overflow: {
                    adjustX: false,
                    adjustY: false
                }
            }
        };
        const mergedStyle = {
            paddingBottom: popupHeight,
            position: 'relative',
            minWidth: popupWidth
        };
        return /*#__PURE__*/ $5E6i4.createElement("div", {
            ref: holderRef,
            style: mergedStyle
        }, /*#__PURE__*/ $5E6i4.createElement(Component, {
            ...mergedProps
        }));
    };
    return $f49bb770731dacb5$export$29e2a8c3cdb34b03(PurePanel);
};
var $f49bb770731dacb5$export$2e2bcd8739ae039 = $f49bb770731dacb5$var$genPurePanel;






/**
 * This hook is only for cssVar to add root className for components.
 * If root ClassName is needed, this hook could be refactored with `-root`
 * @param prefixCls
 */ const $d104ec5f99ed66d7$var$useCSSVarCls = (prefixCls)=>`${prefixCls}-css-var`;
var $d104ec5f99ed66d7$export$2e2bcd8739ae039 = $d104ec5f99ed66d7$var$useCSSVarCls;



var $5E6i4 = parcelRequire("5E6i4");



var $5E6i4 = parcelRequire("5E6i4");





var $5E6i4 = parcelRequire("5E6i4");


// Use shared variable to save bundle size
const $539c0befc971443e$var$UNDEFINED = undefined;
function $539c0befc971443e$var$InternalItem(props, ref) {
    const { prefixCls: prefixCls, invalidate: invalidate, item: item, renderItem: renderItem, responsive: responsive, responsiveDisabled: responsiveDisabled, registerSize: registerSize, itemKey: itemKey, className: className, style: style, children: children, display: display, order: order, component: Component = 'div', ...restProps } = props;
    const mergedHidden = responsive && !display;
    // ================================ Effect ================================
    function internalRegisterSize(width) {
        registerSize(itemKey, width);
    }
    $5E6i4.useEffect(()=>()=>{
            internalRegisterSize(null);
        }, []);
    // ================================ Render ================================
    const childNode = renderItem && item !== $539c0befc971443e$var$UNDEFINED ? renderItem(item, {
        index: order
    }) : children;
    let overflowStyle;
    if (!invalidate) overflowStyle = {
        opacity: mergedHidden ? 0 : 1,
        height: mergedHidden ? 0 : $539c0befc971443e$var$UNDEFINED,
        overflowY: mergedHidden ? 'hidden' : $539c0befc971443e$var$UNDEFINED,
        order: responsive ? order : $539c0befc971443e$var$UNDEFINED,
        pointerEvents: mergedHidden ? 'none' : $539c0befc971443e$var$UNDEFINED,
        position: mergedHidden ? 'absolute' : $539c0befc971443e$var$UNDEFINED
    };
    const overflowProps = {};
    if (mergedHidden) overflowProps['aria-hidden'] = true;
    let itemNode = /*#__PURE__*/ $5E6i4.createElement(Component, (0, $149d2f1aa8ebe3ec$export$2e2bcd8739ae039)({
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(!invalidate && prefixCls, className),
        style: {
            ...overflowStyle,
            ...style
        }
    }, overflowProps, restProps, {
        ref: ref
    }), childNode);
    if (responsive) itemNode = /*#__PURE__*/ $5E6i4.createElement((0, $3a396118caae8741$export$2e2bcd8739ae039), {
        onResize: ({ offsetWidth: offsetWidth })=>{
            internalRegisterSize(offsetWidth);
        },
        disabled: responsiveDisabled
    }, itemNode);
    return itemNode;
}
const $539c0befc971443e$var$Item = /*#__PURE__*/ $5E6i4.forwardRef($539c0befc971443e$var$InternalItem);
var $539c0befc971443e$export$2e2bcd8739ae039 = $539c0befc971443e$var$Item;




var $5E6i4 = parcelRequire("5E6i4");

var $ibUU1 = parcelRequire("ibUU1");

function $f709b47a3ebf091d$export$2e2bcd8739ae039(callback) {
    if (typeof MessageChannel === 'undefined') (0, $1d949665862f071a$export$2e2bcd8739ae039)(callback);
    else {
        const channel = new MessageChannel();
        channel.port1.onmessage = ()=>callback();
        channel.port2.postMessage(undefined);
    }
}


function $000cce6bc324ead5$export$eedf51fe9d751c7a() {
    // Updater Trigger
    const updateFuncRef = $5E6i4.useRef(null);
    // Notify update
    const notifyEffectUpdate = (callback)=>{
        if (!updateFuncRef.current) {
            updateFuncRef.current = [];
            (0, $f709b47a3ebf091d$export$2e2bcd8739ae039)(()=>{
                (0, $ibUU1.unstable_batchedUpdates)(()=>{
                    updateFuncRef.current.forEach((fn)=>{
                        fn();
                    });
                    updateFuncRef.current = null;
                });
            });
        }
        updateFuncRef.current.push(callback);
    };
    return notifyEffectUpdate;
}
function $000cce6bc324ead5$export$2e2bcd8739ae039(notifyEffectUpdate, defaultValue) {
    // Value
    const [stateValue, setStateValue] = $5E6i4.useState(defaultValue);
    // Set State
    const setEffectVal = (0, $68990f4402d2f009$export$2e2bcd8739ae039)((nextValue)=>{
        notifyEffectUpdate(()=>{
            setStateValue(nextValue);
        });
    });
    return [
        stateValue,
        setEffectVal
    ];
}




var $5E6i4 = parcelRequire("5E6i4");



var $5E6i4 = parcelRequire("5E6i4");
const $00281b8e6d3b91e5$export$79f16dd643143c25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createContext(null);


const $e3f318eef994a79a$var$InternalRawItem = (props, ref)=>{
    const context = $5E6i4.useContext((0, $00281b8e6d3b91e5$export$79f16dd643143c25));
    // Render directly when context not provided
    if (!context) {
        const { component: Component = 'div', ...restProps } = props;
        return /*#__PURE__*/ $5E6i4.createElement(Component, (0, $149d2f1aa8ebe3ec$export$2e2bcd8739ae039)({}, restProps, {
            ref: ref
        }));
    }
    const { className: contextClassName, ...restContext } = context;
    const { className: className, ...restProps } = props;
    // Do not pass context to sub item to avoid multiple measure
    return /*#__PURE__*/ $5E6i4.createElement((0, $00281b8e6d3b91e5$export$79f16dd643143c25).Provider, {
        value: null
    }, /*#__PURE__*/ $5E6i4.createElement((0, $539c0befc971443e$export$2e2bcd8739ae039), (0, $149d2f1aa8ebe3ec$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(contextClassName, className)
    }, restContext, restProps)));
};
const $e3f318eef994a79a$var$RawItem = /*#__PURE__*/ $5E6i4.forwardRef($e3f318eef994a79a$var$InternalRawItem);
var $e3f318eef994a79a$export$2e2bcd8739ae039 = $e3f318eef994a79a$var$RawItem;



const $28747df157434af4$var$RESPONSIVE = 'responsive';
const $28747df157434af4$var$INVALIDATE = 'invalidate';
function $28747df157434af4$var$defaultRenderRest(omittedItems) {
    return `+ ${omittedItems.length} ...`;
}
function $28747df157434af4$var$Overflow(props, ref) {
    const { prefixCls: prefixCls = 'rc-overflow', data: data = [], renderItem: renderItem, renderRawItem: renderRawItem, itemKey: itemKey, itemWidth: itemWidth = 10, ssr: ssr, style: style, className: className, maxCount: maxCount, renderRest: renderRest, renderRawRest: renderRawRest, prefix: prefix, suffix: suffix, component: Component = 'div', itemComponent: itemComponent, onVisibleChange: onVisibleChange, ...restProps } = props;
    const fullySSR = ssr === 'full';
    const notifyEffectUpdate = (0, $000cce6bc324ead5$export$eedf51fe9d751c7a)();
    const [containerWidth, setContainerWidth] = (0, $000cce6bc324ead5$export$2e2bcd8739ae039)(notifyEffectUpdate, null);
    const mergedContainerWidth = containerWidth || 0;
    const [itemWidths, setItemWidths] = (0, $000cce6bc324ead5$export$2e2bcd8739ae039)(notifyEffectUpdate, new Map());
    const [prevRestWidth, setPrevRestWidth] = (0, $000cce6bc324ead5$export$2e2bcd8739ae039)(notifyEffectUpdate, 0);
    const [restWidth, setRestWidth] = (0, $000cce6bc324ead5$export$2e2bcd8739ae039)(notifyEffectUpdate, 0);
    const [prefixWidth, setPrefixWidth] = (0, $000cce6bc324ead5$export$2e2bcd8739ae039)(notifyEffectUpdate, 0);
    const [suffixWidth, setSuffixWidth] = (0, $000cce6bc324ead5$export$2e2bcd8739ae039)(notifyEffectUpdate, 0);
    const [suffixFixedStart, setSuffixFixedStart] = (0, $5E6i4.useState)(null);
    const [displayCount, setDisplayCount] = (0, $5E6i4.useState)(null);
    const mergedDisplayCount = $5E6i4.useMemo(()=>{
        if (displayCount === null && fullySSR) return Number.MAX_SAFE_INTEGER;
        return displayCount || 0;
    }, [
        displayCount,
        containerWidth
    ]);
    const [restReady, setRestReady] = (0, $5E6i4.useState)(false);
    const itemPrefixCls = `${prefixCls}-item`;
    // Always use the max width to avoid blink
    const mergedRestWidth = Math.max(prevRestWidth, restWidth);
    // ================================= Data =================================
    const isResponsive = maxCount === $28747df157434af4$var$RESPONSIVE;
    const shouldResponsive = data.length && isResponsive;
    const invalidate = maxCount === $28747df157434af4$var$INVALIDATE;
    /**
   * When is `responsive`, we will always render rest node to get the real width of it for calculation
   */ const showRest = shouldResponsive || typeof maxCount === 'number' && data.length > maxCount;
    const mergedData = (0, $5E6i4.useMemo)(()=>{
        let items = data;
        if (shouldResponsive) {
            if (containerWidth === null && fullySSR) items = data;
            else items = data.slice(0, Math.min(data.length, mergedContainerWidth / itemWidth));
        } else if (typeof maxCount === 'number') items = data.slice(0, maxCount);
        return items;
    }, [
        data,
        itemWidth,
        containerWidth,
        maxCount,
        shouldResponsive
    ]);
    const omittedItems = (0, $5E6i4.useMemo)(()=>{
        if (shouldResponsive) return data.slice(mergedDisplayCount + 1);
        return data.slice(mergedData.length);
    }, [
        data,
        mergedData,
        shouldResponsive,
        mergedDisplayCount
    ]);
    // ================================= Item =================================
    const getKey = (0, $5E6i4.useCallback)((item, index)=>{
        if (typeof itemKey === 'function') return itemKey(item);
        return (itemKey && item?.[itemKey]) ?? index;
    }, [
        itemKey
    ]);
    const mergedRenderItem = (0, $5E6i4.useCallback)(renderItem || ((item)=>item), [
        renderItem
    ]);
    function updateDisplayCount(count, suffixFixedStartVal, notReady) {
        // React 18 will sync render even when the value is same in some case.
        // We take `mergedData` as deps which may cause dead loop if it's dynamic generate.
        // ref: https://github.com/ant-design/ant-design/issues/36559
        if (displayCount === count && (suffixFixedStartVal === undefined || suffixFixedStartVal === suffixFixedStart)) return;
        setDisplayCount(count);
        if (!notReady) {
            setRestReady(count < data.length - 1);
            onVisibleChange?.(count);
        }
        if (suffixFixedStartVal !== undefined) setSuffixFixedStart(suffixFixedStartVal);
    }
    // ================================= Size =================================
    function onOverflowResize(_, element) {
        setContainerWidth(element.clientWidth);
    }
    function registerSize(key, width) {
        setItemWidths((origin)=>{
            const clone = new Map(origin);
            if (width === null) clone.delete(key);
            else clone.set(key, width);
            return clone;
        });
    }
    function registerOverflowSize(_, width) {
        setRestWidth(width);
        setPrevRestWidth(restWidth);
    }
    function registerPrefixSize(_, width) {
        setPrefixWidth(width);
    }
    function registerSuffixSize(_, width) {
        setSuffixWidth(width);
    }
    // ================================ Effect ================================
    function getItemWidth(index) {
        return itemWidths.get(getKey(mergedData[index], index));
    }
    (0, $518ae471aa4f03a7$export$2e2bcd8739ae039)(()=>{
        if (mergedContainerWidth && typeof mergedRestWidth === 'number' && mergedData) {
            let totalWidth = prefixWidth + suffixWidth;
            const len = mergedData.length;
            const lastIndex = len - 1;
            // When data count change to 0, reset this since not loop will reach
            if (!len) {
                updateDisplayCount(0, null);
                return;
            }
            for(let i = 0; i < len; i += 1){
                let currentItemWidth = getItemWidth(i);
                // Fully will always render
                if (fullySSR) currentItemWidth = currentItemWidth || 0;
                // Break since data not ready
                if (currentItemWidth === undefined) {
                    updateDisplayCount(i - 1, undefined, true);
                    break;
                }
                // Find best match
                totalWidth += currentItemWidth;
                if (// Only one means `totalWidth` is the final width
                lastIndex === 0 && totalWidth <= mergedContainerWidth || // Last two width will be the final width
                i === lastIndex - 1 && totalWidth + getItemWidth(lastIndex) <= mergedContainerWidth) {
                    // Additional check if match the end
                    updateDisplayCount(lastIndex, null);
                    break;
                } else if (totalWidth + mergedRestWidth > mergedContainerWidth) {
                    // Can not hold all the content to show rest
                    updateDisplayCount(i - 1, totalWidth - currentItemWidth - suffixWidth + restWidth);
                    break;
                }
            }
            if (suffix && getItemWidth(0) + suffixWidth > mergedContainerWidth) setSuffixFixedStart(null);
        }
    }, [
        mergedContainerWidth,
        itemWidths,
        restWidth,
        prefixWidth,
        suffixWidth,
        getKey,
        mergedData
    ]);
    // ================================ Render ================================
    const displayRest = restReady && !!omittedItems.length;
    let suffixStyle = {};
    if (suffixFixedStart !== null && shouldResponsive) suffixStyle = {
        position: 'absolute',
        top: 0,
        insetInlineStart: suffixFixedStart
    };
    const itemSharedProps = {
        prefixCls: itemPrefixCls,
        responsive: shouldResponsive,
        component: itemComponent,
        invalidate: invalidate
    };
    // >>>>> Choice render fun by `renderRawItem`
    const internalRenderItemNode = renderRawItem ? (item, index)=>{
        const key = getKey(item, index);
        return /*#__PURE__*/ $5E6i4.createElement((0, $00281b8e6d3b91e5$export$79f16dd643143c25).Provider, {
            key: key,
            value: {
                ...itemSharedProps,
                order: index,
                item: item,
                itemKey: key,
                registerSize: registerSize,
                display: index <= mergedDisplayCount
            }
        }, renderRawItem(item, index));
    } : (item, index)=>{
        const key = getKey(item, index);
        return /*#__PURE__*/ $5E6i4.createElement((0, $539c0befc971443e$export$2e2bcd8739ae039), (0, $149d2f1aa8ebe3ec$export$2e2bcd8739ae039)({}, itemSharedProps, {
            order: index,
            key: key,
            item: item,
            renderItem: mergedRenderItem,
            itemKey: key,
            registerSize: registerSize,
            display: index <= mergedDisplayCount
        }));
    };
    // >>>>> Rest node
    const restContextProps = {
        order: displayRest ? mergedDisplayCount : Number.MAX_SAFE_INTEGER,
        className: `${itemPrefixCls}-rest`,
        registerSize: registerOverflowSize,
        display: displayRest
    };
    const mergedRenderRest = renderRest || $28747df157434af4$var$defaultRenderRest;
    const restNode = renderRawRest ? /*#__PURE__*/ $5E6i4.createElement((0, $00281b8e6d3b91e5$export$79f16dd643143c25).Provider, {
        value: {
            ...itemSharedProps,
            ...restContextProps
        }
    }, renderRawRest(omittedItems)) : /*#__PURE__*/ $5E6i4.createElement((0, $539c0befc971443e$export$2e2bcd8739ae039), (0, $149d2f1aa8ebe3ec$export$2e2bcd8739ae039)({}, itemSharedProps, restContextProps), typeof mergedRenderRest === 'function' ? mergedRenderRest(omittedItems) : mergedRenderRest);
    const overflowNode = /*#__PURE__*/ $5E6i4.createElement(Component, (0, $149d2f1aa8ebe3ec$export$2e2bcd8739ae039)({
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(!invalidate && prefixCls, className),
        style: style,
        ref: ref
    }, restProps), prefix && /*#__PURE__*/ $5E6i4.createElement((0, $539c0befc971443e$export$2e2bcd8739ae039), (0, $149d2f1aa8ebe3ec$export$2e2bcd8739ae039)({}, itemSharedProps, {
        responsive: isResponsive,
        responsiveDisabled: !shouldResponsive,
        order: -1,
        className: `${itemPrefixCls}-prefix`,
        registerSize: registerPrefixSize,
        display: true
    }), prefix), mergedData.map(internalRenderItemNode), showRest ? restNode : null, suffix && /*#__PURE__*/ $5E6i4.createElement((0, $539c0befc971443e$export$2e2bcd8739ae039), (0, $149d2f1aa8ebe3ec$export$2e2bcd8739ae039)({}, itemSharedProps, {
        responsive: isResponsive,
        responsiveDisabled: !shouldResponsive,
        order: mergedDisplayCount,
        className: `${itemPrefixCls}-suffix`,
        registerSize: registerSuffixSize,
        display: true,
        style: suffixStyle
    }), suffix));
    return isResponsive ? /*#__PURE__*/ $5E6i4.createElement((0, $3a396118caae8741$export$2e2bcd8739ae039), {
        onResize: onOverflowResize,
        disabled: !shouldResponsive
    }, overflowNode) : overflowNode;
}
const $28747df157434af4$var$ForwardOverflow = /*#__PURE__*/ $5E6i4.forwardRef($28747df157434af4$var$Overflow);
$28747df157434af4$var$ForwardOverflow.Item = (0, $e3f318eef994a79a$export$2e2bcd8739ae039);
$28747df157434af4$var$ForwardOverflow.RESPONSIVE = $28747df157434af4$var$RESPONSIVE;
$28747df157434af4$var$ForwardOverflow.INVALIDATE = $28747df157434af4$var$INVALIDATE;
var // Convert to generic type
$28747df157434af4$export$2e2bcd8739ae039 = $28747df157434af4$var$ForwardOverflow;


var $5dd265eef1cc92c5$export$2e2bcd8739ae039 = (0, $28747df157434af4$export$2e2bcd8739ae039);




var $5E6i4 = parcelRequire("5E6i4");

var $ibUU1 = parcelRequire("ibUU1");

var $5E6i4 = parcelRequire("5E6i4");
const $01ff66b135b92d38$export$26537912ea160acd = /*#__PURE__*/ $5E6i4.createContext(null);
function $01ff66b135b92d38$export$80c871fe8d6b896(uuid, eventKey) {
    return `${uuid}-${eventKey}`;
}
function $01ff66b135b92d38$export$a276eb4e9be640f8(eventKey) {
    const id = $5E6i4.useContext($01ff66b135b92d38$export$26537912ea160acd);
    return $01ff66b135b92d38$export$80c871fe8d6b896(id, eventKey);
}



var $5E6i4 = parcelRequire("5E6i4");

const $7ff2ff8245b7677a$export$c7e742effb1c51e2 = /*#__PURE__*/ $5E6i4.createContext(null);
function $7ff2ff8245b7677a$var$mergeProps(origin, target) {
    const clone = {
        ...origin
    };
    Object.keys(target).forEach((key)=>{
        const value = target[key];
        if (value !== undefined) clone[key] = value;
    });
    return clone;
}
function $7ff2ff8245b7677a$export$2e2bcd8739ae039({ children: children, locked: locked, ...restProps }) {
    const context = $5E6i4.useContext($7ff2ff8245b7677a$export$c7e742effb1c51e2);
    const inheritableContext = (0, $8ae08502d6a327d3$export$2e2bcd8739ae039)(()=>$7ff2ff8245b7677a$var$mergeProps(context, restProps), [
        context,
        restProps
    ], (prev, next)=>!locked && (prev[0] !== next[0] || !(0, $f9cb347037ae4280$export$2e2bcd8739ae039)(prev[1], next[1], true)));
    return /*#__PURE__*/ $5E6i4.createElement($7ff2ff8245b7677a$export$c7e742effb1c51e2.Provider, {
        value: inheritableContext
    }, children);
}



var $5E6i4 = parcelRequire("5E6i4");
const $2c9ab7fc64c929ec$var$EmptyList = [];
const $2c9ab7fc64c929ec$export$d9ffb5bfd108b003 = /*#__PURE__*/ $5E6i4.createContext(null);
function $2c9ab7fc64c929ec$export$e295b0c537d32d7d() {
    return $5E6i4.useContext($2c9ab7fc64c929ec$export$d9ffb5bfd108b003);
}
const $2c9ab7fc64c929ec$export$54d9e16aa4c8a7fa = /*#__PURE__*/ $5E6i4.createContext($2c9ab7fc64c929ec$var$EmptyList);
function $2c9ab7fc64c929ec$export$d3d2d0a05677870a(eventKey) {
    const parentKeyPath = $5E6i4.useContext($2c9ab7fc64c929ec$export$54d9e16aa4c8a7fa);
    return $5E6i4.useMemo(()=>eventKey !== undefined ? [
            ...parentKeyPath,
            eventKey
        ] : parentKeyPath, [
        parentKeyPath,
        eventKey
    ]);
}
const $2c9ab7fc64c929ec$export$f0b9e0db98edfa53 = /*#__PURE__*/ $5E6i4.createContext(null);



var $5E6i4 = parcelRequire("5E6i4");
const $fd3a7f84dab04235$var$PrivateContext = /*#__PURE__*/ $5E6i4.createContext({});
var $fd3a7f84dab04235$export$2e2bcd8739ae039 = $fd3a7f84dab04235$var$PrivateContext;




var $5E6i4 = parcelRequire("5E6i4");

// destruct to reduce minify size
const { LEFT: $60108062c45071c4$var$LEFT, RIGHT: $60108062c45071c4$var$RIGHT, UP: $60108062c45071c4$var$UP, DOWN: $60108062c45071c4$var$DOWN, ENTER: $60108062c45071c4$var$ENTER, ESC: $60108062c45071c4$var$ESC, HOME: $60108062c45071c4$var$HOME, END: $60108062c45071c4$var$END } = (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039);
const $60108062c45071c4$var$ArrowKeys = [
    $60108062c45071c4$var$UP,
    $60108062c45071c4$var$DOWN,
    $60108062c45071c4$var$LEFT,
    $60108062c45071c4$var$RIGHT
];
function $60108062c45071c4$var$getOffset(mode, isRootLevel, isRtl, which) {
    const prev = 'prev';
    const next = 'next';
    const children = 'children';
    const parent = 'parent';
    // Inline enter is special that we use unique operation
    if (mode === 'inline' && which === $60108062c45071c4$var$ENTER) return {
        inlineTrigger: true
    };
    const inline = {
        [$60108062c45071c4$var$UP]: prev,
        [$60108062c45071c4$var$DOWN]: next
    };
    const horizontal = {
        [$60108062c45071c4$var$LEFT]: isRtl ? next : prev,
        [$60108062c45071c4$var$RIGHT]: isRtl ? prev : next,
        [$60108062c45071c4$var$DOWN]: children,
        [$60108062c45071c4$var$ENTER]: children
    };
    const vertical = {
        [$60108062c45071c4$var$UP]: prev,
        [$60108062c45071c4$var$DOWN]: next,
        [$60108062c45071c4$var$ENTER]: children,
        [$60108062c45071c4$var$ESC]: parent,
        [$60108062c45071c4$var$LEFT]: isRtl ? children : parent,
        [$60108062c45071c4$var$RIGHT]: isRtl ? parent : children
    };
    const offsets = {
        inline: inline,
        horizontal: horizontal,
        vertical: vertical,
        inlineSub: inline,
        horizontalSub: vertical,
        verticalSub: vertical
    };
    const type = offsets[`${mode}${isRootLevel ? '' : 'Sub'}`]?.[which];
    switch(type){
        case prev:
            return {
                offset: -1,
                sibling: true
            };
        case next:
            return {
                offset: 1,
                sibling: true
            };
        case parent:
            return {
                offset: -1,
                sibling: false
            };
        case children:
            return {
                offset: 1,
                sibling: false
            };
        default:
            return null;
    }
}
function $60108062c45071c4$var$findContainerUL(element) {
    let current = element;
    while(current){
        if (current.getAttribute('data-menu-list')) return current;
        current = current.parentElement;
    }
    // Normally should not reach this line
    /* istanbul ignore next */ return null;
}
/**
 * Find focused element within element set provided
 */ function $60108062c45071c4$var$getFocusElement(activeElement, elements) {
    let current = activeElement || document.activeElement;
    while(current){
        if (elements.has(current)) return current;
        current = current.parentElement;
    }
    return null;
}
function $60108062c45071c4$export$433aaa1f216cf32d(container, elements) {
    const list = (0, $806ab00ed04609c6$export$bbc7b5f11aba534b)(container, true);
    return list.filter((ele)=>elements.has(ele));
}
function $60108062c45071c4$var$getNextFocusElement(parentQueryContainer, elements, focusMenuElement, offset = 1) {
    // Key on the menu item will not get validate parent container
    if (!parentQueryContainer) return null;
    // List current level menu item elements
    const sameLevelFocusableMenuElementList = $60108062c45071c4$export$433aaa1f216cf32d(parentQueryContainer, elements);
    // Find next focus index
    const count = sameLevelFocusableMenuElementList.length;
    let focusIndex = sameLevelFocusableMenuElementList.findIndex((ele)=>focusMenuElement === ele);
    if (offset < 0) {
        if (focusIndex === -1) focusIndex = count - 1;
        else focusIndex -= 1;
    } else if (offset > 0) focusIndex += 1;
    focusIndex = (focusIndex + count) % count;
    // Focus menu item
    return sameLevelFocusableMenuElementList[focusIndex];
}
const $60108062c45071c4$export$20827b68c762d23 = (keys, id)=>{
    const elements = new Set();
    const key2element = new Map();
    const element2key = new Map();
    keys.forEach((key)=>{
        const element = document.querySelector(`[data-menu-id='${(0, $01ff66b135b92d38$export$80c871fe8d6b896)(id, key)}']`);
        if (element) {
            elements.add(element);
            element2key.set(element, key);
            key2element.set(key, element);
        }
    });
    return {
        elements: elements,
        key2element: key2element,
        element2key: element2key
    };
};
function $60108062c45071c4$export$aa6de64279d64603(mode, activeKey, isRtl, id, containerRef, getKeys, getKeyPath, triggerActiveKey, triggerAccessibilityOpen, originOnKeyDown) {
    const rafRef = $5E6i4.useRef(undefined);
    const activeRef = $5E6i4.useRef(undefined);
    activeRef.current = activeKey;
    const cleanRaf = ()=>{
        (0, $1d949665862f071a$export$2e2bcd8739ae039).cancel(rafRef.current);
    };
    $5E6i4.useEffect(()=>()=>{
            cleanRaf();
        }, []);
    return (e)=>{
        const { which: which } = e;
        if ([
            ...$60108062c45071c4$var$ArrowKeys,
            $60108062c45071c4$var$ENTER,
            $60108062c45071c4$var$ESC,
            $60108062c45071c4$var$HOME,
            $60108062c45071c4$var$END
        ].includes(which)) {
            const keys = getKeys();
            let refreshedElements = $60108062c45071c4$export$20827b68c762d23(keys, id);
            const { elements: elements, key2element: key2element, element2key: element2key } = refreshedElements;
            // First we should find current focused MenuItem/SubMenu element
            const activeElement = key2element.get(activeKey);
            const focusMenuElement = $60108062c45071c4$var$getFocusElement(activeElement, elements);
            const focusMenuKey = element2key.get(focusMenuElement);
            const offsetObj = $60108062c45071c4$var$getOffset(mode, getKeyPath(focusMenuKey, true).length === 1, isRtl, which);
            // Some mode do not have fully arrow operation like inline
            if (!offsetObj && which !== $60108062c45071c4$var$HOME && which !== $60108062c45071c4$var$END) return;
            // Arrow prevent default to avoid page scroll
            if ($60108062c45071c4$var$ArrowKeys.includes(which) || [
                $60108062c45071c4$var$HOME,
                $60108062c45071c4$var$END
            ].includes(which)) e.preventDefault();
            const tryFocus = (menuElement)=>{
                if (menuElement) {
                    let focusTargetElement = menuElement;
                    // Focus to link instead of menu item if possible
                    const link = menuElement.querySelector('a');
                    if (link?.getAttribute('href')) focusTargetElement = link;
                    const targetKey = element2key.get(menuElement);
                    triggerActiveKey(targetKey);
                    /**
           * Do not `useEffect` here since `tryFocus` may trigger async
           * which makes React sync update the `activeKey`
           * that force render before `useRef` set the next activeKey
           */ cleanRaf();
                    rafRef.current = (0, $1d949665862f071a$export$2e2bcd8739ae039)(()=>{
                        if (activeRef.current === targetKey) focusTargetElement.focus();
                    });
                }
            };
            if ([
                $60108062c45071c4$var$HOME,
                $60108062c45071c4$var$END
            ].includes(which) || offsetObj.sibling || !focusMenuElement) {
                // ========================== Sibling ==========================
                // Find walkable focus menu element container
                let parentQueryContainer;
                if (!focusMenuElement || mode === 'inline') parentQueryContainer = containerRef.current;
                else parentQueryContainer = $60108062c45071c4$var$findContainerUL(focusMenuElement);
                // Get next focus element
                let targetElement;
                const focusableElements = $60108062c45071c4$export$433aaa1f216cf32d(parentQueryContainer, elements);
                if (which === $60108062c45071c4$var$HOME) targetElement = focusableElements[0];
                else if (which === $60108062c45071c4$var$END) targetElement = focusableElements[focusableElements.length - 1];
                else targetElement = $60108062c45071c4$var$getNextFocusElement(parentQueryContainer, elements, focusMenuElement, offsetObj.offset);
                // Focus menu item
                tryFocus(targetElement);
            // ======================= InlineTrigger =======================
            } else if (offsetObj.inlineTrigger) // Inline trigger no need switch to sub menu item
            triggerAccessibilityOpen(focusMenuKey);
            else if (offsetObj.offset > 0) {
                triggerAccessibilityOpen(focusMenuKey, true);
                cleanRaf();
                rafRef.current = (0, $1d949665862f071a$export$2e2bcd8739ae039)(()=>{
                    // Async should resync elements
                    refreshedElements = $60108062c45071c4$export$20827b68c762d23(keys, id);
                    const controlId = focusMenuElement.getAttribute('aria-controls');
                    const subQueryContainer = document.getElementById(controlId);
                    // Get sub focusable menu item
                    const targetElement = $60108062c45071c4$var$getNextFocusElement(subQueryContainer, refreshedElements.elements);
                    // Focus menu item
                    tryFocus(targetElement);
                }, 5);
            } else if (offsetObj.offset < 0) {
                const keyPath = getKeyPath(focusMenuKey, true);
                const parentKey = keyPath[keyPath.length - 2];
                const parentMenuElement = key2element.get(parentKey);
                // Focus menu item
                triggerAccessibilityOpen(parentKey, false);
                tryFocus(parentMenuElement);
            }
        }
        // Pass origin key down event
        originOnKeyDown?.(e);
    };
}



var $5E6i4 = parcelRequire("5E6i4");

function $a08f2b16675f0285$export$7693db51ef834b40(callback) {
    /* istanbul ignore next */ Promise.resolve().then(callback);
}


const $409890fe1cfd3e67$var$PATH_SPLIT = '__RC_UTIL_PATH_SPLIT__';
const $409890fe1cfd3e67$var$getPathStr = (keyPath)=>keyPath.join($409890fe1cfd3e67$var$PATH_SPLIT);
const $409890fe1cfd3e67$var$getPathKeys = (keyPathStr)=>keyPathStr.split($409890fe1cfd3e67$var$PATH_SPLIT);
const $409890fe1cfd3e67$export$20a0132c46ce5b04 = 'rc-menu-more';
function $409890fe1cfd3e67$export$2e2bcd8739ae039() {
    const [, internalForceUpdate] = $5E6i4.useState({});
    const key2pathRef = (0, $5E6i4.useRef)(new Map());
    const path2keyRef = (0, $5E6i4.useRef)(new Map());
    const [overflowKeys, setOverflowKeys] = $5E6i4.useState([]);
    const updateRef = (0, $5E6i4.useRef)(0);
    const destroyRef = (0, $5E6i4.useRef)(false);
    const forceUpdate = ()=>{
        if (!destroyRef.current) internalForceUpdate({});
    };
    const registerPath = (0, $5E6i4.useCallback)((key, keyPath)=>{
        // Fill map
        const connectedPath = $409890fe1cfd3e67$var$getPathStr(keyPath);
        path2keyRef.current.set(connectedPath, key);
        key2pathRef.current.set(key, connectedPath);
        updateRef.current += 1;
        const id = updateRef.current;
        (0, $a08f2b16675f0285$export$7693db51ef834b40)(()=>{
            if (id === updateRef.current) forceUpdate();
        });
    }, []);
    const unregisterPath = (0, $5E6i4.useCallback)((key, keyPath)=>{
        const connectedPath = $409890fe1cfd3e67$var$getPathStr(keyPath);
        path2keyRef.current.delete(connectedPath);
        key2pathRef.current.delete(key);
    }, []);
    const refreshOverflowKeys = (0, $5E6i4.useCallback)((keys)=>{
        setOverflowKeys(keys);
    }, []);
    const getKeyPath = (0, $5E6i4.useCallback)((eventKey, includeOverflow)=>{
        const fullPath = key2pathRef.current.get(eventKey) || '';
        const keys = $409890fe1cfd3e67$var$getPathKeys(fullPath);
        if (includeOverflow && overflowKeys.includes(keys[0])) keys.unshift($409890fe1cfd3e67$export$20a0132c46ce5b04);
        return keys;
    }, [
        overflowKeys
    ]);
    const isSubPathKey = (0, $5E6i4.useCallback)((pathKeys, eventKey)=>pathKeys.filter((item)=>item !== undefined).some((pathKey)=>{
            const pathKeyList = getKeyPath(pathKey, true);
            return pathKeyList.includes(eventKey);
        }), [
        getKeyPath
    ]);
    const getKeys = ()=>{
        const keys = [
            ...key2pathRef.current.keys()
        ];
        if (overflowKeys.length) keys.push($409890fe1cfd3e67$export$20a0132c46ce5b04);
        return keys;
    };
    /**
   * Find current key related child path keys
   */ const getSubPathKeys = (0, $5E6i4.useCallback)((key)=>{
        const connectedPath = `${key2pathRef.current.get(key)}${$409890fe1cfd3e67$var$PATH_SPLIT}`;
        const pathKeys = new Set();
        [
            ...path2keyRef.current.keys()
        ].forEach((pathKey)=>{
            if (pathKey.startsWith(connectedPath)) pathKeys.add(path2keyRef.current.get(pathKey));
        });
        return pathKeys;
    }, []);
    $5E6i4.useEffect(()=>()=>{
            destroyRef.current = true;
        }, []);
    return {
        registerPath: // Register
        registerPath,
        unregisterPath: unregisterPath,
        refreshOverflowKeys: refreshOverflowKeys,
        isSubPathKey: // Util
        isSubPathKey,
        getKeyPath: getKeyPath,
        getKeys: getKeys,
        getSubPathKeys: getSubPathKeys
    };
}



var $5E6i4 = parcelRequire("5E6i4");
function $a9c758d52e31d8d4$export$2e2bcd8739ae039(func) {
    const funRef = $5E6i4.useRef(func);
    funRef.current = func;
    const callback = $5E6i4.useCallback((...args)=>funRef.current?.(...args), []);
    return func ? callback : undefined;
}






var $5E6i4 = parcelRequire("5E6i4");





var $5E6i4 = parcelRequire("5E6i4");

function $ee1f3f944a357762$export$2e2bcd8739ae039(eventKey, disabled, onMouseEnter, onMouseLeave) {
    const { activeKey: // Active
    activeKey, onActive: onActive, onInactive: onInactive } = $5E6i4.useContext((0, $7ff2ff8245b7677a$export$c7e742effb1c51e2));
    const ret = {
        active: activeKey === eventKey
    };
    // Skip when disabled
    if (!disabled) {
        ret.onMouseEnter = (domEvent)=>{
            onMouseEnter?.({
                key: eventKey,
                domEvent: domEvent
            });
            onActive(eventKey);
        };
        ret.onMouseLeave = (domEvent)=>{
            onMouseLeave?.({
                key: eventKey,
                domEvent: domEvent
            });
            onInactive(eventKey);
        };
    }
    return ret;
}



var $5E6i4 = parcelRequire("5E6i4");

function $a9b8f3f81b2d429e$export$2e2bcd8739ae039(level) {
    const { mode: mode, rtl: rtl, inlineIndent: inlineIndent } = $5E6i4.useContext((0, $7ff2ff8245b7677a$export$c7e742effb1c51e2));
    if (mode !== 'inline') return null;
    const len = level;
    return rtl ? {
        paddingRight: len * inlineIndent
    } : {
        paddingLeft: len * inlineIndent
    };
}



var $5E6i4 = parcelRequire("5E6i4");
function $c503a40307a464b0$export$2e2bcd8739ae039({ icon: icon, props: props, children: children }) {
    let iconNode;
    if (icon === null || icon === false) return null;
    if (typeof icon === 'function') iconNode = /*#__PURE__*/ $5E6i4.createElement(icon, {
        ...props
    });
    else if (typeof icon !== "boolean") // Compatible for origin definition
    iconNode = icon;
    return iconNode || children || null;
}



function $317c4237f8df2c9e$export$e189bcd94b66c1db({ item: item, ...restInfo }) {
    Object.defineProperty(restInfo, 'item', {
        get: ()=>{
            (0, $f757b9ac02fa080d$export$2e2bcd8739ae039)(false, '`info.item` is deprecated since we will move to function component that not provides React Node instance in future.');
            return item;
        }
    });
    return restInfo;
}


function $57699299a59a5ce1$var$_extends() {
    $57699299a59a5ce1$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $57699299a59a5ce1$var$_extends.apply(this, arguments);
}
// Since Menu event provide the `info.item` which point to the MenuItem node instance.
// We have to use class component here.
// This should be removed from doc & api in future.
class $57699299a59a5ce1$var$LegacyMenuItem extends $5E6i4.Component {
    render() {
        const { title: title, attribute: attribute, elementRef: elementRef, ...restProps } = this.props;
        // Here the props are eventually passed to the DOM element.
        // React does not recognize non-standard attributes.
        // Therefore, remove the props that is not used here.
        // ref: https://github.com/ant-design/ant-design/issues/41395
        const passedProps = (0, $48bd91d9f828de66$export$2e2bcd8739ae039)(restProps, [
            'eventKey',
            'popupClassName',
            'popupOffset',
            'onTitleClick'
        ]);
        (0, $f757b9ac02fa080d$export$2e2bcd8739ae039)(!attribute, '`attribute` of Menu.Item is deprecated. Please pass attribute directly.');
        return /*#__PURE__*/ $5E6i4.createElement((0, $5dd265eef1cc92c5$export$2e2bcd8739ae039).Item, $57699299a59a5ce1$var$_extends({}, attribute, {
            title: typeof title === 'string' ? title : undefined
        }, passedProps, {
            ref: elementRef
        }));
    }
}
/**
 * Real Menu Item component
 */ const $57699299a59a5ce1$var$InternalMenuItem = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { style: style, className: className, eventKey: eventKey, warnKey: warnKey, disabled: disabled, itemIcon: itemIcon, children: children, itemData: propsItemData, role: // Aria
    role, onMouseEnter: // Active
    onMouseEnter, onMouseLeave: onMouseLeave, onClick: onClick, onKeyDown: onKeyDown, onFocus: onFocus, ...restProps } = props;
    const domDataId = (0, $01ff66b135b92d38$export$a276eb4e9be640f8)(eventKey);
    const { prefixCls: prefixCls, onItemClick: onItemClick, disabled: contextDisabled, overflowDisabled: overflowDisabled, // Icon
    itemIcon: contextItemIcon, selectedKeys: // Select
    selectedKeys, onActive: // Active
    onActive } = $5E6i4.useContext((0, $7ff2ff8245b7677a$export$c7e742effb1c51e2));
    const { _internalRenderMenuItem: _internalRenderMenuItem } = $5E6i4.useContext((0, $fd3a7f84dab04235$export$2e2bcd8739ae039));
    const itemCls = `${prefixCls}-item`;
    const legacyMenuItemRef = $5E6i4.useRef(null);
    const elementRef = $5E6i4.useRef(null);
    const mergedDisabled = contextDisabled || disabled;
    const mergedEleRef = (0, $92c8c75386168ffc$export$1d1c999670a1285d)(ref, elementRef);
    const connectedKeys = (0, $2c9ab7fc64c929ec$export$d3d2d0a05677870a)(eventKey);
    // ============================= Info =============================
    const getEventInfo = (e)=>{
        // If propsInfo exists (items mode), use it; otherwise build from props (children mode)
        const itemData = propsItemData || {
            key: eventKey || '',
            label: children,
            itemIcon: itemIcon,
            extra: props.extra,
            title: props.title
        };
        return {
            key: eventKey,
            // Note: For legacy code is reversed which not like other antd component
            keyPath: [
                ...connectedKeys
            ].reverse(),
            item: legacyMenuItemRef.current,
            domEvent: e,
            itemData: propsItemData || itemData
        };
    };
    // ============================= Icon =============================
    const mergedItemIcon = itemIcon || contextItemIcon;
    // ============================ Active ============================
    const { active: active, ...activeProps } = (0, $ee1f3f944a357762$export$2e2bcd8739ae039)(eventKey, mergedDisabled, onMouseEnter, onMouseLeave);
    // ============================ Select ============================
    const selected = selectedKeys.includes(eventKey);
    // ======================== DirectionStyle ========================
    const directionStyle = (0, $a9b8f3f81b2d429e$export$2e2bcd8739ae039)(connectedKeys.length);
    // ============================ Events ============================
    const onInternalClick = (e)=>{
        if (mergedDisabled) return;
        const info = getEventInfo(e);
        onClick?.((0, $317c4237f8df2c9e$export$e189bcd94b66c1db)(info));
        onItemClick(info);
    };
    const onInternalKeyDown = (e)=>{
        onKeyDown?.(e);
        if (e.which === (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).ENTER) {
            const info = getEventInfo(e);
            // Legacy. Key will also trigger click event
            onClick?.((0, $317c4237f8df2c9e$export$e189bcd94b66c1db)(info));
            onItemClick(info);
        }
    };
    /**
   * Used for accessibility. Helper will focus element without key board.
   * We should manually trigger an active
   */ const onInternalFocus = (e)=>{
        onActive(eventKey);
        onFocus?.(e);
    };
    // ============================ Render ============================
    const optionRoleProps = {};
    if (props.role === 'option') optionRoleProps['aria-selected'] = selected;
    let renderNode = /*#__PURE__*/ $5E6i4.createElement($57699299a59a5ce1$var$LegacyMenuItem, $57699299a59a5ce1$var$_extends({
        ref: legacyMenuItemRef,
        elementRef: mergedEleRef,
        role: role === null ? 'none' : role || 'menuitem',
        tabIndex: disabled ? null : -1,
        "data-menu-id": overflowDisabled && domDataId ? null : domDataId
    }, (0, $48bd91d9f828de66$export$2e2bcd8739ae039)(restProps, [
        'extra'
    ]), activeProps, optionRoleProps, {
        component: "li",
        "aria-disabled": disabled,
        style: {
            ...directionStyle,
            ...style
        },
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(itemCls, {
            [`${itemCls}-active`]: active,
            [`${itemCls}-selected`]: selected,
            [`${itemCls}-disabled`]: mergedDisabled
        }, className),
        onClick: onInternalClick,
        onKeyDown: onInternalKeyDown,
        onFocus: onInternalFocus
    }), children, /*#__PURE__*/ $5E6i4.createElement((0, $c503a40307a464b0$export$2e2bcd8739ae039), {
        props: {
            ...props,
            isSelected: selected
        },
        icon: mergedItemIcon
    }));
    if (_internalRenderMenuItem) renderNode = _internalRenderMenuItem(renderNode, props, {
        selected: selected
    });
    return renderNode;
});
function $57699299a59a5ce1$var$MenuItem(props, ref) {
    const { eventKey: eventKey } = props;
    // ==================== Record KeyPath ====================
    const measure = (0, $2c9ab7fc64c929ec$export$e295b0c537d32d7d)();
    const connectedKeyPath = (0, $2c9ab7fc64c929ec$export$d3d2d0a05677870a)(eventKey);
    // eslint-disable-next-line consistent-return
    $5E6i4.useEffect(()=>{
        if (measure) {
            measure.registerPath(eventKey, connectedKeyPath);
            return ()=>{
                measure.unregisterPath(eventKey, connectedKeyPath);
            };
        }
    }, [
        connectedKeyPath
    ]);
    if (measure) return null;
    // ======================== Render ========================
    return /*#__PURE__*/ $5E6i4.createElement($57699299a59a5ce1$var$InternalMenuItem, $57699299a59a5ce1$var$_extends({}, props, {
        ref: ref
    }));
}
var $57699299a59a5ce1$export$2e2bcd8739ae039 = /*#__PURE__*/ $5E6i4.forwardRef($57699299a59a5ce1$var$MenuItem);



var $5E6i4 = parcelRequire("5E6i4");




var $5E6i4 = parcelRequire("5E6i4");


function $c16ed7c022f1ce09$var$_extends() {
    $c16ed7c022f1ce09$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c16ed7c022f1ce09$var$_extends.apply(this, arguments);
}
const $c16ed7c022f1ce09$var$InternalSubMenuList = ({ className: className, children: children, ...restProps }, ref)=>{
    const { prefixCls: prefixCls, mode: mode, rtl: rtl } = $5E6i4.useContext((0, $7ff2ff8245b7677a$export$c7e742effb1c51e2));
    return /*#__PURE__*/ $5E6i4.createElement("ul", $c16ed7c022f1ce09$var$_extends({
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, rtl && `${prefixCls}-rtl`, `${prefixCls}-sub`, `${prefixCls}-${mode === 'inline' ? 'inline' : 'vertical'}`, className),
        role: "menu"
    }, restProps, {
        "data-menu-list": true,
        ref: ref
    }), children);
};
const $c16ed7c022f1ce09$var$SubMenuList = /*#__PURE__*/ $5E6i4.forwardRef($c16ed7c022f1ce09$var$InternalSubMenuList);
var $c16ed7c022f1ce09$export$2e2bcd8739ae039 = $c16ed7c022f1ce09$var$SubMenuList;




var $5E6i4 = parcelRequire("5E6i4");
function $66111e5b02e68f6d$export$cd230e97e668be9(children, keyPath) {
    return (0, $2ec1a2166f2295ea$export$2e2bcd8739ae039)(children).map((child, index)=>{
        if (/*#__PURE__*/ $5E6i4.isValidElement(child)) {
            const { key: key } = child;
            let eventKey = child.props?.eventKey ?? key;
            const emptyKey = eventKey === null || eventKey === undefined;
            if (emptyKey) eventKey = `tmp_key-${[
                ...keyPath,
                index
            ].join('-')}`;
            const cloneProps = {
                key: eventKey,
                eventKey: eventKey
            };
            return /*#__PURE__*/ $5E6i4.cloneElement(child, cloneProps);
        }
        return child;
    });
}





var $5E6i4 = parcelRequire("5E6i4");




const $ea81dfee55099490$var$autoAdjustOverflow = {
    adjustX: 1,
    adjustY: 1
};
const $ea81dfee55099490$export$803cd8101b6c182b = {
    topLeft: {
        points: [
            'bl',
            'tl'
        ],
        overflow: $ea81dfee55099490$var$autoAdjustOverflow
    },
    topRight: {
        points: [
            'br',
            'tr'
        ],
        overflow: $ea81dfee55099490$var$autoAdjustOverflow
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ],
        overflow: $ea81dfee55099490$var$autoAdjustOverflow
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ],
        overflow: $ea81dfee55099490$var$autoAdjustOverflow
    },
    leftTop: {
        points: [
            'tr',
            'tl'
        ],
        overflow: $ea81dfee55099490$var$autoAdjustOverflow
    },
    leftBottom: {
        points: [
            'br',
            'bl'
        ],
        overflow: $ea81dfee55099490$var$autoAdjustOverflow
    },
    rightTop: {
        points: [
            'tl',
            'tr'
        ],
        overflow: $ea81dfee55099490$var$autoAdjustOverflow
    },
    rightBottom: {
        points: [
            'bl',
            'br'
        ],
        overflow: $ea81dfee55099490$var$autoAdjustOverflow
    }
};
const $ea81dfee55099490$export$e2b3f69b0a16e1f = {
    topLeft: {
        points: [
            'bl',
            'tl'
        ],
        overflow: $ea81dfee55099490$var$autoAdjustOverflow
    },
    topRight: {
        points: [
            'br',
            'tr'
        ],
        overflow: $ea81dfee55099490$var$autoAdjustOverflow
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ],
        overflow: $ea81dfee55099490$var$autoAdjustOverflow
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ],
        overflow: $ea81dfee55099490$var$autoAdjustOverflow
    },
    rightTop: {
        points: [
            'tr',
            'tl'
        ],
        overflow: $ea81dfee55099490$var$autoAdjustOverflow
    },
    rightBottom: {
        points: [
            'br',
            'bl'
        ],
        overflow: $ea81dfee55099490$var$autoAdjustOverflow
    },
    leftTop: {
        points: [
            'tl',
            'tr'
        ],
        overflow: $ea81dfee55099490$var$autoAdjustOverflow
    },
    leftBottom: {
        points: [
            'bl',
            'br'
        ],
        overflow: $ea81dfee55099490$var$autoAdjustOverflow
    }
};
var $ea81dfee55099490$export$2e2bcd8739ae039 = $ea81dfee55099490$export$803cd8101b6c182b;


function $8b3c773ab5cd048e$export$7b8936ddc277a29a(mode, motion, defaultMotions) {
    if (motion) return motion;
    if (defaultMotions) return defaultMotions[mode] || defaultMotions.other;
    return undefined;
}


const $2099853613e17fe7$var$popupPlacementMap = {
    horizontal: 'bottomLeft',
    vertical: 'rightTop',
    'vertical-left': 'rightTop',
    'vertical-right': 'leftTop'
};
function $2099853613e17fe7$export$2e2bcd8739ae039({ prefixCls: prefixCls, visible: visible, children: children, popup: popup, popupStyle: popupStyle, popupClassName: popupClassName, popupOffset: popupOffset, disabled: disabled, mode: mode, onVisibleChange: onVisibleChange }) {
    const { getPopupContainer: getPopupContainer, rtl: rtl, subMenuOpenDelay: subMenuOpenDelay, subMenuCloseDelay: subMenuCloseDelay, builtinPlacements: builtinPlacements, triggerSubMenuAction: triggerSubMenuAction, forceSubMenuRender: forceSubMenuRender, rootClassName: rootClassName, motion: // Motion
    motion, defaultMotions: defaultMotions } = $5E6i4.useContext((0, $7ff2ff8245b7677a$export$c7e742effb1c51e2));
    const [innerVisible, setInnerVisible] = $5E6i4.useState(false);
    const placement = rtl ? {
        ...(0, $ea81dfee55099490$export$e2b3f69b0a16e1f),
        ...builtinPlacements
    } : {
        ...(0, $ea81dfee55099490$export$803cd8101b6c182b),
        ...builtinPlacements
    };
    const popupPlacement = $2099853613e17fe7$var$popupPlacementMap[mode];
    const targetMotion = (0, $8b3c773ab5cd048e$export$7b8936ddc277a29a)(mode, motion, defaultMotions);
    const targetMotionRef = $5E6i4.useRef(targetMotion);
    if (mode !== 'inline') /**
     * PopupTrigger is only used for vertical and horizontal types.
     * When collapsed is unfolded, the inline animation will destroy the vertical animation.
     */ targetMotionRef.current = targetMotion;
    const mergedMotion = {
        ...targetMotionRef.current,
        leavedClassName: `${prefixCls}-hidden`,
        removeOnLeave: false,
        motionAppear: true
    };
    // Delay to change visible
    const visibleRef = $5E6i4.useRef(undefined);
    $5E6i4.useEffect(()=>{
        visibleRef.current = (0, $1d949665862f071a$export$2e2bcd8739ae039)(()=>{
            setInnerVisible(visible);
        });
        return ()=>{
            (0, $1d949665862f071a$export$2e2bcd8739ae039).cancel(visibleRef.current);
        };
    }, [
        visible
    ]);
    return /*#__PURE__*/ $5E6i4.createElement((0, $5ff8ad2f21affc17$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        popupClassName: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-popup`, {
            [`${prefixCls}-rtl`]: rtl
        }, popupClassName, rootClassName),
        stretch: mode === 'horizontal' ? 'minWidth' : null,
        getPopupContainer: getPopupContainer,
        builtinPlacements: placement,
        popupPlacement: popupPlacement,
        popupVisible: innerVisible,
        popup: popup,
        popupStyle: popupStyle,
        popupAlign: popupOffset && {
            offset: popupOffset
        },
        action: disabled ? [] : [
            triggerSubMenuAction
        ],
        mouseEnterDelay: subMenuOpenDelay,
        mouseLeaveDelay: subMenuCloseDelay,
        onPopupVisibleChange: onVisibleChange,
        forceRender: forceSubMenuRender,
        popupMotion: mergedMotion,
        fresh: true
    }, children);
}







var $5E6i4 = parcelRequire("5E6i4");




function $c75f4df7f433ca53$var$_extends() {
    $c75f4df7f433ca53$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c75f4df7f433ca53$var$_extends.apply(this, arguments);
}
function $c75f4df7f433ca53$export$2e2bcd8739ae039({ id: id, open: open, keyPath: keyPath, children: children }) {
    const fixedMode = 'inline';
    const { prefixCls: prefixCls, forceSubMenuRender: forceSubMenuRender, motion: motion, defaultMotions: defaultMotions, mode: mode } = $5E6i4.useContext((0, $7ff2ff8245b7677a$export$c7e742effb1c51e2));
    // Always use latest mode check
    const sameModeRef = $5E6i4.useRef(false);
    sameModeRef.current = mode === fixedMode;
    // We record `destroy` mark here since when mode change from `inline` to others.
    // The inline list should remove when motion end.
    const [destroy, setDestroy] = $5E6i4.useState(!sameModeRef.current);
    const mergedOpen = sameModeRef.current ? open : false;
    // ================================= Effect =================================
    // Reset destroy state when mode change back
    $5E6i4.useEffect(()=>{
        if (sameModeRef.current) setDestroy(false);
    }, [
        mode
    ]);
    // ================================= Render =================================
    const mergedMotion = {
        ...(0, $8b3c773ab5cd048e$export$7b8936ddc277a29a)(fixedMode, motion, defaultMotions)
    };
    // No need appear since nest inlineCollapse changed
    if (keyPath.length > 1) mergedMotion.motionAppear = false;
    // Hide inline list when mode changed and motion end
    const originOnVisibleChanged = mergedMotion.onVisibleChanged;
    mergedMotion.onVisibleChanged = (newVisible)=>{
        if (!sameModeRef.current && !newVisible) setDestroy(true);
        return originOnVisibleChanged?.(newVisible);
    };
    if (destroy) return null;
    return /*#__PURE__*/ $5E6i4.createElement((0, $7ff2ff8245b7677a$export$2e2bcd8739ae039), {
        mode: fixedMode,
        locked: !sameModeRef.current
    }, /*#__PURE__*/ $5E6i4.createElement((0, $5371a8954d0d2416$export$2e2bcd8739ae039), $c75f4df7f433ca53$var$_extends({
        visible: mergedOpen
    }, mergedMotion, {
        forceRender: forceSubMenuRender,
        removeOnLeave: false,
        leavedClassName: `${prefixCls}-hidden`
    }), ({ className: motionClassName, style: motionStyle })=>{
        return /*#__PURE__*/ $5E6i4.createElement((0, $c16ed7c022f1ce09$export$2e2bcd8739ae039), {
            id: id,
            className: motionClassName,
            style: motionStyle
        }, children);
    }));
}





function $7d47f4296876f42f$var$_extends() {
    $7d47f4296876f42f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7d47f4296876f42f$var$_extends.apply(this, arguments);
}
const $7d47f4296876f42f$var$InternalSubMenu = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { style: style, className: className, styles: styles, classNames: menuClassNames, title: title, itemTitle: itemTitle, eventKey: eventKey, warnKey: warnKey, disabled: disabled, internalPopupClose: internalPopupClose, children: children, itemIcon: // Icons
    itemIcon, expandIcon: expandIcon, popupClassName: // Popup
    popupClassName, popupOffset: popupOffset, popupStyle: popupStyle, onClick: // Events
    onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTitleClick: onTitleClick, onTitleMouseEnter: onTitleMouseEnter, onTitleMouseLeave: onTitleMouseLeave, popupRender: propsPopupRender, ...restProps } = props;
    const domDataId = (0, $01ff66b135b92d38$export$a276eb4e9be640f8)(eventKey);
    const { prefixCls: prefixCls, mode: mode, openKeys: openKeys, // Disabled
    disabled: contextDisabled, overflowDisabled: overflowDisabled, activeKey: // ActiveKey
    activeKey, selectedKeys: // SelectKey
    selectedKeys, // Icon
    itemIcon: contextItemIcon, expandIcon: contextExpandIcon, onItemClick: // Events
    onItemClick, onOpenChange: onOpenChange, onActive: onActive, popupRender: contextPopupRender } = $5E6i4.useContext((0, $7ff2ff8245b7677a$export$c7e742effb1c51e2));
    const { _internalRenderSubMenuItem: _internalRenderSubMenuItem } = $5E6i4.useContext((0, $fd3a7f84dab04235$export$2e2bcd8739ae039));
    const { isSubPathKey: isSubPathKey } = $5E6i4.useContext((0, $2c9ab7fc64c929ec$export$f0b9e0db98edfa53));
    const connectedPath = (0, $2c9ab7fc64c929ec$export$d3d2d0a05677870a)();
    const subMenuPrefixCls = `${prefixCls}-submenu`;
    const mergedDisabled = contextDisabled || disabled;
    const elementRef = $5E6i4.useRef(null);
    const popupRef = $5E6i4.useRef(null);
    // ================================ Icon ================================
    const mergedItemIcon = itemIcon ?? contextItemIcon;
    const mergedExpandIcon = expandIcon ?? contextExpandIcon;
    // ================================ Open ================================
    const originOpen = openKeys.includes(eventKey);
    const open = !overflowDisabled && originOpen;
    // =============================== Select ===============================
    const childrenSelected = isSubPathKey(selectedKeys, eventKey);
    // =============================== Active ===============================
    const { active: active, ...activeProps } = (0, $ee1f3f944a357762$export$2e2bcd8739ae039)(eventKey, mergedDisabled, onTitleMouseEnter, onTitleMouseLeave);
    // Fallback of active check to avoid hover on menu title or disabled item
    const [childrenActive, setChildrenActive] = $5E6i4.useState(false);
    const triggerChildrenActive = (newActive)=>{
        if (!mergedDisabled) setChildrenActive(newActive);
    };
    const onInternalMouseEnter = (domEvent)=>{
        triggerChildrenActive(true);
        onMouseEnter?.({
            key: eventKey,
            domEvent: domEvent
        });
    };
    const onInternalMouseLeave = (domEvent)=>{
        triggerChildrenActive(false);
        onMouseLeave?.({
            key: eventKey,
            domEvent: domEvent
        });
    };
    const mergedActive = $5E6i4.useMemo(()=>{
        if (active) return active;
        if (mode !== 'inline') return childrenActive || isSubPathKey([
            activeKey
        ], eventKey);
        return false;
    }, [
        mode,
        active,
        activeKey,
        childrenActive,
        eventKey,
        isSubPathKey
    ]);
    // ========================== DirectionStyle ==========================
    const directionStyle = (0, $a9b8f3f81b2d429e$export$2e2bcd8739ae039)(connectedPath.length);
    // =============================== Events ===============================
    // >>>> Title click
    const onInternalTitleClick = (e)=>{
        // Skip if disabled
        if (mergedDisabled) return;
        onTitleClick?.({
            key: eventKey,
            domEvent: e
        });
        // Trigger open by click when mode is `inline`
        if (mode === 'inline') onOpenChange(eventKey, !originOpen);
    };
    // >>>> Context for children click
    const onMergedItemClick = (0, $a9c758d52e31d8d4$export$2e2bcd8739ae039)((info)=>{
        onClick?.((0, $317c4237f8df2c9e$export$e189bcd94b66c1db)(info));
        onItemClick(info);
    });
    // >>>>> Visible change
    const onPopupVisibleChange = (newVisible)=>{
        if (mode !== 'inline') onOpenChange(eventKey, newVisible);
    };
    /**
   * Used for accessibility. Helper will focus element without key board.
   * We should manually trigger an active
   */ const onInternalFocus = ()=>{
        onActive(eventKey);
    };
    // =============================== Render ===============================
    const popupId = domDataId && `${domDataId}-popup`;
    const expandIconNode = $5E6i4.useMemo(()=>/*#__PURE__*/ $5E6i4.createElement((0, $c503a40307a464b0$export$2e2bcd8739ae039), {
            icon: mode !== 'horizontal' ? mergedExpandIcon : undefined,
            props: {
                ...props,
                isOpen: open,
                // [Legacy] Not sure why need this mark
                isSubMenu: true
            }
        }, /*#__PURE__*/ $5E6i4.createElement("i", {
            className: `${subMenuPrefixCls}-arrow`
        })), [
        mode,
        mergedExpandIcon,
        props,
        open,
        subMenuPrefixCls
    ]);
    // >>>>> Title
    let titleNode = /*#__PURE__*/ $5E6i4.createElement("div", $7d47f4296876f42f$var$_extends({
        role: "menuitem",
        style: directionStyle,
        className: `${subMenuPrefixCls}-title`,
        tabIndex: mergedDisabled ? null : -1,
        ref: elementRef,
        title: itemTitle ?? (typeof title === 'string' ? title : null),
        "data-menu-id": overflowDisabled && domDataId ? null : domDataId,
        "aria-expanded": open,
        "aria-haspopup": true,
        "aria-controls": popupId,
        "aria-disabled": mergedDisabled,
        onClick: onInternalTitleClick,
        onFocus: onInternalFocus
    }, activeProps), title, expandIconNode);
    // Cache mode if it change to `inline` which do not have popup motion
    const triggerModeRef = $5E6i4.useRef(mode);
    if (mode !== 'inline' && connectedPath.length > 1) triggerModeRef.current = 'vertical';
    else triggerModeRef.current = mode;
    const popupContentTriggerMode = triggerModeRef.current;
    const renderPopupContent = $5E6i4.useMemo(()=>{
        const originNode = /*#__PURE__*/ $5E6i4.createElement((0, $7ff2ff8245b7677a$export$2e2bcd8739ae039), {
            classNames: menuClassNames,
            styles: styles,
            mode: popupContentTriggerMode === 'horizontal' ? 'vertical' : popupContentTriggerMode
        }, /*#__PURE__*/ $5E6i4.createElement((0, $c16ed7c022f1ce09$export$2e2bcd8739ae039), {
            id: popupId,
            ref: popupRef
        }, children));
        const mergedPopupRender = propsPopupRender || contextPopupRender;
        if (mergedPopupRender) {
            const node = mergedPopupRender(originNode, {
                item: props,
                keys: connectedPath
            });
            return node;
        }
        return originNode;
    }, [
        propsPopupRender,
        contextPopupRender,
        connectedPath,
        popupId,
        children,
        props,
        popupContentTriggerMode
    ]);
    if (!overflowDisabled) {
        const triggerMode = triggerModeRef.current;
        // Still wrap with Trigger here since we need avoid react re-mount dom node
        // Which makes motion failed
        titleNode = /*#__PURE__*/ $5E6i4.createElement((0, $2099853613e17fe7$export$2e2bcd8739ae039), {
            mode: triggerMode,
            prefixCls: subMenuPrefixCls,
            visible: !internalPopupClose && open && mode !== 'inline',
            popupClassName: popupClassName,
            popupOffset: popupOffset,
            popupStyle: popupStyle,
            popup: renderPopupContent,
            disabled: mergedDisabled,
            onVisibleChange: onPopupVisibleChange
        }, titleNode);
    }
    // >>>>> List node
    let listNode = /*#__PURE__*/ $5E6i4.createElement((0, $5dd265eef1cc92c5$export$2e2bcd8739ae039).Item, $7d47f4296876f42f$var$_extends({
        ref: ref,
        role: "none"
    }, restProps, {
        component: "li",
        style: style,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(subMenuPrefixCls, `${subMenuPrefixCls}-${mode}`, className, {
            [`${subMenuPrefixCls}-open`]: open,
            [`${subMenuPrefixCls}-active`]: mergedActive,
            [`${subMenuPrefixCls}-selected`]: childrenSelected,
            [`${subMenuPrefixCls}-disabled`]: mergedDisabled
        }),
        onMouseEnter: onInternalMouseEnter,
        onMouseLeave: onInternalMouseLeave
    }), titleNode, !overflowDisabled && /*#__PURE__*/ $5E6i4.createElement((0, $c75f4df7f433ca53$export$2e2bcd8739ae039), {
        id: popupId,
        open: open,
        keyPath: connectedPath
    }, children));
    if (_internalRenderSubMenuItem) listNode = _internalRenderSubMenuItem(listNode, props, {
        selected: childrenSelected,
        active: mergedActive,
        open: open,
        disabled: mergedDisabled
    });
    // >>>>> Render
    return /*#__PURE__*/ $5E6i4.createElement((0, $7ff2ff8245b7677a$export$2e2bcd8739ae039), {
        classNames: menuClassNames,
        styles: styles,
        onItemClick: onMergedItemClick,
        mode: mode === 'horizontal' ? 'vertical' : mode,
        itemIcon: mergedItemIcon,
        expandIcon: mergedExpandIcon
    }, listNode);
});
const $7d47f4296876f42f$var$SubMenu = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { eventKey: eventKey, children: children } = props;
    const connectedKeyPath = (0, $2c9ab7fc64c929ec$export$d3d2d0a05677870a)(eventKey);
    const childList = (0, $66111e5b02e68f6d$export$cd230e97e668be9)(children, connectedKeyPath);
    // ==================== Record KeyPath ====================
    const measure = (0, $2c9ab7fc64c929ec$export$e295b0c537d32d7d)();
    // eslint-disable-next-line consistent-return
    $5E6i4.useEffect(()=>{
        if (measure) {
            measure.registerPath(eventKey, connectedKeyPath);
            return ()=>{
                measure.unregisterPath(eventKey, connectedKeyPath);
            };
        }
    }, [
        connectedKeyPath
    ]);
    let renderNode;
    // ======================== Render ========================
    if (measure) renderNode = childList;
    else renderNode = /*#__PURE__*/ $5E6i4.createElement($7d47f4296876f42f$var$InternalSubMenu, $7d47f4296876f42f$var$_extends({
        ref: ref
    }, props), childList);
    return /*#__PURE__*/ $5E6i4.createElement((0, $2c9ab7fc64c929ec$export$54d9e16aa4c8a7fa).Provider, {
        value: connectedKeyPath
    }, renderNode);
});
var $7d47f4296876f42f$export$2e2bcd8739ae039 = $7d47f4296876f42f$var$SubMenu;



var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");



function $878a9836f27455e1$export$2e2bcd8739ae039({ className: className, style: style }) {
    const { prefixCls: prefixCls } = $5E6i4.useContext((0, $7ff2ff8245b7677a$export$c7e742effb1c51e2));
    const measure = (0, $2c9ab7fc64c929ec$export$e295b0c537d32d7d)();
    if (measure) return null;
    return /*#__PURE__*/ $5E6i4.createElement("li", {
        role: "separator",
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-item-divider`, className),
        style: style
    });
}






var $5E6i4 = parcelRequire("5E6i4");



function $89189bb0a1de610b$var$_extends() {
    $89189bb0a1de610b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $89189bb0a1de610b$var$_extends.apply(this, arguments);
}
const $89189bb0a1de610b$var$InternalMenuItemGroup = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { className: className, title: title, eventKey: eventKey, children: children, ...restProps } = props;
    const { prefixCls: prefixCls, classNames: menuClassNames, styles: styles } = $5E6i4.useContext((0, $7ff2ff8245b7677a$export$c7e742effb1c51e2));
    const groupPrefixCls = `${prefixCls}-item-group`;
    return /*#__PURE__*/ $5E6i4.createElement("li", $89189bb0a1de610b$var$_extends({
        ref: ref,
        role: "presentation"
    }, restProps, {
        onClick: (e)=>e.stopPropagation(),
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(groupPrefixCls, className)
    }), /*#__PURE__*/ $5E6i4.createElement("div", {
        role: "presentation",
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${groupPrefixCls}-title`, menuClassNames?.listTitle),
        style: styles?.listTitle,
        title: typeof title === 'string' ? title : undefined
    }, title), /*#__PURE__*/ $5E6i4.createElement("ul", {
        role: "group",
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${groupPrefixCls}-list`, menuClassNames?.list),
        style: styles?.list
    }, children));
});
const $89189bb0a1de610b$var$MenuItemGroup = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { eventKey: eventKey, children: children } = props;
    const connectedKeyPath = (0, $2c9ab7fc64c929ec$export$d3d2d0a05677870a)(eventKey);
    const childList = (0, $66111e5b02e68f6d$export$cd230e97e668be9)(children, connectedKeyPath);
    const measure = (0, $2c9ab7fc64c929ec$export$e295b0c537d32d7d)();
    if (measure) return childList;
    return /*#__PURE__*/ $5E6i4.createElement($89189bb0a1de610b$var$InternalMenuItemGroup, $89189bb0a1de610b$var$_extends({
        ref: ref
    }, (0, $48bd91d9f828de66$export$2e2bcd8739ae039)(props, [
        'warnKey'
    ])), childList);
});
var $89189bb0a1de610b$export$2e2bcd8739ae039 = $89189bb0a1de610b$var$MenuItemGroup;




function $a14a5db86cfdf2f9$var$_extends() {
    $a14a5db86cfdf2f9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a14a5db86cfdf2f9$var$_extends.apply(this, arguments);
}
function $a14a5db86cfdf2f9$var$convertItemsToNodes(list, components, prefixCls) {
    const { item: MergedMenuItem, group: MergedMenuItemGroup, submenu: MergedSubMenu, divider: MergedDivider } = components;
    return (list || []).map((opt, index)=>{
        if (opt && typeof opt === 'object') {
            const { label: label, children: children, key: key, type: type, extra: extra, ...restProps } = opt;
            const mergedKey = key ?? `tmp-${index}`;
            // MenuItemGroup & SubMenuItem
            if (children || type === 'group') {
                if (type === 'group') // Group
                return /*#__PURE__*/ $5E6i4.createElement(MergedMenuItemGroup, $a14a5db86cfdf2f9$var$_extends({
                    key: mergedKey
                }, restProps, {
                    title: label
                }), $a14a5db86cfdf2f9$var$convertItemsToNodes(children, components, prefixCls));
                // Sub Menu
                const { title: itemTitle, ...subMenuRestProps } = restProps;
                return /*#__PURE__*/ $5E6i4.createElement(MergedSubMenu, $a14a5db86cfdf2f9$var$_extends({
                    key: mergedKey
                }, subMenuRestProps, {
                    title: label,
                    itemTitle: typeof itemTitle === 'string' ? itemTitle : undefined
                }), $a14a5db86cfdf2f9$var$convertItemsToNodes(children, components, prefixCls));
            }
            // MenuItem & Divider
            if (type === 'divider') return /*#__PURE__*/ $5E6i4.createElement(MergedDivider, $a14a5db86cfdf2f9$var$_extends({
                key: mergedKey
            }, restProps));
            const hasExtra = !!extra || extra === 0;
            return /*#__PURE__*/ $5E6i4.createElement(MergedMenuItem, $a14a5db86cfdf2f9$var$_extends({
                key: mergedKey
            }, restProps, {
                extra: extra,
                itemData: {
                    ...opt,
                    key: mergedKey
                }
            }), hasExtra ? /*#__PURE__*/ $5E6i4.createElement($5E6i4.Fragment, null, /*#__PURE__*/ $5E6i4.createElement("span", {
                className: `${prefixCls}-item-label`
            }, label), /*#__PURE__*/ $5E6i4.createElement("span", {
                className: `${prefixCls}-item-extra`
            }, extra)) : label);
        }
        return null;
    }).filter((opt)=>opt);
}
function $a14a5db86cfdf2f9$export$50458dc1a9a0f894(children, items, keyPath, components, prefixCls) {
    let childNodes = children;
    const mergedComponents = {
        divider: (0, $878a9836f27455e1$export$2e2bcd8739ae039),
        item: (0, $57699299a59a5ce1$export$2e2bcd8739ae039),
        group: (0, $89189bb0a1de610b$export$2e2bcd8739ae039),
        submenu: (0, $7d47f4296876f42f$export$2e2bcd8739ae039),
        ...components
    };
    if (items) childNodes = $a14a5db86cfdf2f9$var$convertItemsToNodes(items, mergedComponents, prefixCls);
    return (0, $66111e5b02e68f6d$export$cd230e97e668be9)(childNodes, keyPath);
}



function $6ef731bec7572fd9$var$_extends() {
    $6ef731bec7572fd9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6ef731bec7572fd9$var$_extends.apply(this, arguments);
}
/**
 * Menu modify after refactor:
 * ## Add
 * - disabled
 *
 * ## Remove
 * - openTransitionName
 * - openAnimation
 * - onDestroy
 * - siderCollapsed: Seems antd do not use this prop (Need test in antd)
 * - collapsedWidth: Seems this logic should be handle by antd Layout.Sider
 */ // optimize for render
const $6ef731bec7572fd9$var$EMPTY_LIST = [];
const $6ef731bec7572fd9$var$Menu = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls = 'rc-menu', rootClassName: rootClassName, style: style, className: className, styles: styles, classNames: menuClassNames, tabIndex: tabIndex = 0, items: items, children: children, direction: direction, id: id, mode: // Mode
    mode = 'vertical', inlineCollapsed: inlineCollapsed, disabled: // Disabled
    disabled, disabledOverflow: disabledOverflow, subMenuOpenDelay: // Open
    subMenuOpenDelay = 0.1, subMenuCloseDelay: subMenuCloseDelay = 0.1, forceSubMenuRender: forceSubMenuRender, defaultOpenKeys: defaultOpenKeys, openKeys: openKeys, activeKey: // Active
    activeKey, defaultActiveFirst: defaultActiveFirst, selectable: // Selection
    selectable = true, multiple: multiple = false, defaultSelectedKeys: defaultSelectedKeys, selectedKeys: selectedKeys, onSelect: onSelect, onDeselect: onDeselect, inlineIndent: // Level
    inlineIndent = 24, motion: // Motion
    motion, defaultMotions: defaultMotions, triggerSubMenuAction: // Popup
    triggerSubMenuAction = 'hover', builtinPlacements: builtinPlacements, itemIcon: // Icon
    itemIcon, expandIcon: expandIcon, overflowedIndicator: overflowedIndicator = '...', overflowedIndicatorPopupClassName: overflowedIndicatorPopupClassName, getPopupContainer: // Function
    getPopupContainer, onClick: // Events
    onClick, onOpenChange: onOpenChange, onKeyDown: onKeyDown, openAnimation: // Deprecated
    openAnimation, openTransitionName: openTransitionName, _internalRenderMenuItem: // Internal
    _internalRenderMenuItem, _internalRenderSubMenuItem: _internalRenderSubMenuItem, _internalComponents: _internalComponents, popupRender: popupRender, ...restProps } = props;
    const [childList, measureChildList] = $5E6i4.useMemo(()=>[
            (0, $a14a5db86cfdf2f9$export$50458dc1a9a0f894)(children, items, $6ef731bec7572fd9$var$EMPTY_LIST, _internalComponents, prefixCls),
            (0, $a14a5db86cfdf2f9$export$50458dc1a9a0f894)(children, items, $6ef731bec7572fd9$var$EMPTY_LIST, {}, prefixCls)
        ], [
        children,
        items,
        _internalComponents
    ]);
    const [mounted, setMounted] = $5E6i4.useState(false);
    const containerRef = $5E6i4.useRef(null);
    const mergedId = (0, $378d6dcdebc6b864$export$2e2bcd8739ae039)();
    const uuid = id ?? `rc-menu-uuid-${mergedId}`;
    const isRtl = direction === 'rtl';
    // ========================= Open =========================
    const [innerOpenKeys, setMergedOpenKeys] = (0, $e18df22f16a16360$export$2e2bcd8739ae039)(defaultOpenKeys, openKeys);
    const mergedOpenKeys = innerOpenKeys || $6ef731bec7572fd9$var$EMPTY_LIST;
    // React 18 will merge mouse event which means we open key will not sync
    // ref: https://github.com/ant-design/ant-design/issues/38818
    const triggerOpenKeys = (keys, forceFlush = false)=>{
        function doUpdate() {
            setMergedOpenKeys(keys);
            onOpenChange?.(keys);
        }
        if (forceFlush) (0, $ibUU1.flushSync)(doUpdate);
        else doUpdate();
    };
    // >>>>> Cache & Reset open keys when inlineCollapsed changed
    const [inlineCacheOpenKeys, setInlineCacheOpenKeys] = $5E6i4.useState(mergedOpenKeys);
    const mountRef = $5E6i4.useRef(false);
    // ========================= Mode =========================
    const [mergedMode, mergedInlineCollapsed] = $5E6i4.useMemo(()=>{
        if ((mode === 'inline' || mode === 'vertical') && inlineCollapsed) return [
            'vertical',
            inlineCollapsed
        ];
        return [
            mode,
            false
        ];
    }, [
        mode,
        inlineCollapsed
    ]);
    const isInlineMode = mergedMode === 'inline';
    const [internalMode, setInternalMode] = $5E6i4.useState(mergedMode);
    const [internalInlineCollapsed, setInternalInlineCollapsed] = $5E6i4.useState(mergedInlineCollapsed);
    $5E6i4.useEffect(()=>{
        setInternalMode(mergedMode);
        setInternalInlineCollapsed(mergedInlineCollapsed);
        if (!mountRef.current) return;
        // Synchronously update MergedOpenKeys
        if (isInlineMode) setMergedOpenKeys(inlineCacheOpenKeys);
        else // Trigger open event in case its in control
        triggerOpenKeys($6ef731bec7572fd9$var$EMPTY_LIST);
    }, [
        mergedMode,
        mergedInlineCollapsed
    ]);
    // ====================== Responsive ======================
    const [lastVisibleIndex, setLastVisibleIndex] = $5E6i4.useState(0);
    const allVisible = lastVisibleIndex >= childList.length - 1 || internalMode !== 'horizontal' || disabledOverflow;
    // Cache
    $5E6i4.useEffect(()=>{
        if (isInlineMode) setInlineCacheOpenKeys(mergedOpenKeys);
    }, [
        mergedOpenKeys
    ]);
    $5E6i4.useEffect(()=>{
        mountRef.current = true;
        return ()=>{
            mountRef.current = false;
        };
    }, []);
    // ========================= Path =========================
    const { registerPath: registerPath, unregisterPath: unregisterPath, refreshOverflowKeys: refreshOverflowKeys, isSubPathKey: isSubPathKey, getKeyPath: getKeyPath, getKeys: getKeys, getSubPathKeys: getSubPathKeys } = (0, $409890fe1cfd3e67$export$2e2bcd8739ae039)();
    const registerPathContext = $5E6i4.useMemo(()=>({
            registerPath: registerPath,
            unregisterPath: unregisterPath
        }), [
        registerPath,
        unregisterPath
    ]);
    const pathUserContext = $5E6i4.useMemo(()=>({
            isSubPathKey: isSubPathKey
        }), [
        isSubPathKey
    ]);
    $5E6i4.useEffect(()=>{
        refreshOverflowKeys(allVisible ? $6ef731bec7572fd9$var$EMPTY_LIST : childList.slice(lastVisibleIndex + 1).map((child)=>child.key));
    }, [
        lastVisibleIndex,
        allVisible
    ]);
    // ======================== Active ========================
    const [mergedActiveKey, setMergedActiveKey] = (0, $e18df22f16a16360$export$2e2bcd8739ae039)(activeKey || defaultActiveFirst && childList[0]?.key, activeKey);
    const onActive = (0, $a9c758d52e31d8d4$export$2e2bcd8739ae039)((key)=>{
        setMergedActiveKey(key);
    });
    const onInactive = (0, $a9c758d52e31d8d4$export$2e2bcd8739ae039)(()=>{
        setMergedActiveKey(undefined);
    });
    (0, $5E6i4.useImperativeHandle)(ref, ()=>{
        return {
            list: containerRef.current,
            focus: (options)=>{
                const keys = getKeys();
                const { elements: elements, key2element: key2element, element2key: element2key } = (0, $60108062c45071c4$export$20827b68c762d23)(keys, uuid);
                const focusableElements = (0, $60108062c45071c4$export$433aaa1f216cf32d)(containerRef.current, elements);
                let shouldFocusKey;
                if (mergedActiveKey && keys.includes(mergedActiveKey)) shouldFocusKey = mergedActiveKey;
                else shouldFocusKey = focusableElements[0] ? element2key.get(focusableElements[0]) : childList.find((node)=>!node.props.disabled)?.key;
                const elementToFocus = key2element.get(shouldFocusKey);
                if (shouldFocusKey && elementToFocus) elementToFocus?.focus?.(options);
            },
            findItem: ({ key: itemKey })=>{
                const keys = getKeys();
                const { key2element: key2element } = (0, $60108062c45071c4$export$20827b68c762d23)(keys, uuid);
                return key2element.get(itemKey) || null;
            }
        };
    });
    // ======================== Select ========================
    // >>>>> Select keys
    const [internalSelectKeys, setMergedSelectKeys] = (0, $e18df22f16a16360$export$2e2bcd8739ae039)(defaultSelectedKeys || [], selectedKeys);
    const mergedSelectKeys = $5E6i4.useMemo(()=>{
        if (Array.isArray(internalSelectKeys)) return internalSelectKeys;
        if (internalSelectKeys === null || internalSelectKeys === undefined) return $6ef731bec7572fd9$var$EMPTY_LIST;
        return [
            internalSelectKeys
        ];
    }, [
        internalSelectKeys
    ]);
    // >>>>> Trigger select
    const triggerSelection = (info)=>{
        if (selectable) {
            // Insert or Remove
            const { key: targetKey } = info;
            const exist = mergedSelectKeys.includes(targetKey);
            let newSelectKeys;
            if (multiple) {
                if (exist) newSelectKeys = mergedSelectKeys.filter((key)=>key !== targetKey);
                else newSelectKeys = [
                    ...mergedSelectKeys,
                    targetKey
                ];
            } else newSelectKeys = [
                targetKey
            ];
            setMergedSelectKeys(newSelectKeys);
            // Trigger event
            const selectInfo = {
                ...info,
                selectedKeys: newSelectKeys
            };
            if (exist) onDeselect?.(selectInfo);
            else onSelect?.(selectInfo);
        }
        // Whatever selectable, always close it
        if (!multiple && mergedOpenKeys.length && internalMode !== 'inline') triggerOpenKeys($6ef731bec7572fd9$var$EMPTY_LIST);
    };
    // ========================= Open =========================
    /**
   * Click for item. SubMenu do not have selection status
   */ const onInternalClick = (0, $a9c758d52e31d8d4$export$2e2bcd8739ae039)((info)=>{
        onClick?.((0, $317c4237f8df2c9e$export$e189bcd94b66c1db)(info));
        triggerSelection(info);
    });
    const onInternalOpenChange = (0, $a9c758d52e31d8d4$export$2e2bcd8739ae039)((key, open)=>{
        let newOpenKeys = mergedOpenKeys.filter((k)=>k !== key);
        if (open) newOpenKeys.push(key);
        else if (internalMode !== 'inline') {
            // We need find all related popup to close
            const subPathKeys = getSubPathKeys(key);
            newOpenKeys = newOpenKeys.filter((k)=>!subPathKeys.has(k));
        }
        if (!(0, $f9cb347037ae4280$export$2e2bcd8739ae039)(mergedOpenKeys, newOpenKeys, true)) triggerOpenKeys(newOpenKeys, true);
    });
    // ==================== Accessibility =====================
    const triggerAccessibilityOpen = (key, open)=>{
        const nextOpen = open ?? !mergedOpenKeys.includes(key);
        onInternalOpenChange(key, nextOpen);
    };
    const onInternalKeyDown = (0, $60108062c45071c4$export$aa6de64279d64603)(internalMode, mergedActiveKey, isRtl, uuid, containerRef, getKeys, getKeyPath, setMergedActiveKey, triggerAccessibilityOpen, onKeyDown);
    // ======================== Effect ========================
    $5E6i4.useEffect(()=>{
        setMounted(true);
    }, []);
    // ======================= Context ========================
    const privateContext = $5E6i4.useMemo(()=>({
            _internalRenderMenuItem: _internalRenderMenuItem,
            _internalRenderSubMenuItem: _internalRenderSubMenuItem
        }), [
        _internalRenderMenuItem,
        _internalRenderSubMenuItem
    ]);
    // ======================== Render ========================
    // >>>>> Children
    const wrappedChildList = internalMode !== 'horizontal' || disabledOverflow ? childList : // Need wrap for overflow dropdown that do not response for open
    childList.map((child, index)=>/*#__PURE__*/ // Always wrap provider to avoid sub node re-mount
        $5E6i4.createElement((0, $7ff2ff8245b7677a$export$2e2bcd8739ae039), {
            key: child.key,
            overflowDisabled: index > lastVisibleIndex,
            classNames: menuClassNames,
            styles: styles
        }, child));
    // >>>>> Container
    const container = /*#__PURE__*/ $5E6i4.createElement((0, $5dd265eef1cc92c5$export$2e2bcd8739ae039), $6ef731bec7572fd9$var$_extends({
        id: id,
        ref: containerRef,
        prefixCls: `${prefixCls}-overflow`,
        component: "ul",
        itemComponent: (0, $57699299a59a5ce1$export$2e2bcd8739ae039),
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-root`, `${prefixCls}-${internalMode}`, className, {
            [`${prefixCls}-inline-collapsed`]: internalInlineCollapsed,
            [`${prefixCls}-rtl`]: isRtl
        }, rootClassName),
        dir: direction,
        style: style,
        role: "menu",
        tabIndex: tabIndex,
        data: wrappedChildList,
        renderRawItem: (node)=>node,
        renderRawRest: (omitItems)=>{
            // We use origin list since wrapped list use context to prevent open
            const len = omitItems.length;
            const originOmitItems = len ? childList.slice(-len) : null;
            return /*#__PURE__*/ $5E6i4.createElement((0, $7d47f4296876f42f$export$2e2bcd8739ae039), {
                eventKey: (0, $409890fe1cfd3e67$export$20a0132c46ce5b04),
                title: overflowedIndicator,
                disabled: allVisible,
                internalPopupClose: len === 0,
                popupClassName: overflowedIndicatorPopupClassName
            }, originOmitItems);
        },
        maxCount: internalMode !== 'horizontal' || disabledOverflow ? (0, $5dd265eef1cc92c5$export$2e2bcd8739ae039).INVALIDATE : (0, $5dd265eef1cc92c5$export$2e2bcd8739ae039).RESPONSIVE,
        ssr: "full",
        "data-menu-list": true,
        onVisibleChange: (newLastIndex)=>{
            setLastVisibleIndex(newLastIndex);
        },
        onKeyDown: onInternalKeyDown
    }, restProps));
    // >>>>> Render
    return /*#__PURE__*/ $5E6i4.createElement((0, $fd3a7f84dab04235$export$2e2bcd8739ae039).Provider, {
        value: privateContext
    }, /*#__PURE__*/ $5E6i4.createElement((0, $01ff66b135b92d38$export$26537912ea160acd).Provider, {
        value: uuid
    }, /*#__PURE__*/ $5E6i4.createElement((0, $7ff2ff8245b7677a$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        rootClassName: rootClassName,
        classNames: menuClassNames,
        styles: styles,
        mode: internalMode,
        openKeys: mergedOpenKeys,
        rtl: isRtl,
        disabled: disabled,
        motion: mounted ? motion : null,
        defaultMotions: mounted ? defaultMotions : null,
        activeKey: mergedActiveKey,
        onActive: onActive,
        onInactive: onInactive,
        selectedKeys: mergedSelectKeys,
        inlineIndent: inlineIndent,
        subMenuOpenDelay: subMenuOpenDelay,
        subMenuCloseDelay: subMenuCloseDelay,
        forceSubMenuRender: forceSubMenuRender,
        builtinPlacements: builtinPlacements,
        triggerSubMenuAction: triggerSubMenuAction,
        getPopupContainer: getPopupContainer,
        itemIcon: itemIcon,
        expandIcon: expandIcon,
        onItemClick: onInternalClick,
        onOpenChange: onInternalOpenChange,
        popupRender: popupRender
    }, /*#__PURE__*/ $5E6i4.createElement((0, $2c9ab7fc64c929ec$export$f0b9e0db98edfa53).Provider, {
        value: pathUserContext
    }, container), /*#__PURE__*/ $5E6i4.createElement("div", {
        style: {
            display: 'none'
        },
        "aria-hidden": true
    }, /*#__PURE__*/ $5E6i4.createElement((0, $2c9ab7fc64c929ec$export$d9ffb5bfd108b003).Provider, {
        value: registerPathContext
    }, measureChildList)))));
});
var $6ef731bec7572fd9$export$2e2bcd8739ae039 = $6ef731bec7572fd9$var$Menu;







const $e823adc24933414e$var$ExportMenu = (0, $6ef731bec7572fd9$export$2e2bcd8739ae039);
$e823adc24933414e$var$ExportMenu.Item = (0, $57699299a59a5ce1$export$2e2bcd8739ae039);
$e823adc24933414e$var$ExportMenu.SubMenu = (0, $7d47f4296876f42f$export$2e2bcd8739ae039);
$e823adc24933414e$var$ExportMenu.ItemGroup = (0, $89189bb0a1de610b$export$2e2bcd8739ae039);
$e823adc24933414e$var$ExportMenu.Divider = (0, $878a9836f27455e1$export$2e2bcd8739ae039);
var $e823adc24933414e$export$2e2bcd8739ae039 = $e823adc24933414e$var$ExportMenu;



var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $00c2790950368f9e$var$BarsOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0z"
                }
            }
        ]
    },
    "name": "bars",
    "theme": "outlined"
};
var $00c2790950368f9e$export$2e2bcd8739ae039 = $00c2790950368f9e$var$BarsOutlined;



function $b0ff4076559b6cfb$var$_extends() {
    $b0ff4076559b6cfb$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b0ff4076559b6cfb$var$_extends.apply(this, arguments);
}
const $b0ff4076559b6cfb$var$BarsOutlined = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $b0ff4076559b6cfb$var$_extends({}, props, {
        ref: ref,
        icon: (0, $00c2790950368f9e$export$2e2bcd8739ae039)
    }));
/**![bars](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkxMiAxOTJIMzI4Yy00LjQgMC04IDMuNi04IDh2NTZjMCA0LjQgMy42IDggOCA4aDU4NGM0LjQgMCA4LTMuNiA4LTh2LTU2YzAtNC40LTMuNi04LTgtOHptMCAyODRIMzI4Yy00LjQgMC04IDMuNi04IDh2NTZjMCA0LjQgMy42IDggOCA4aDU4NGM0LjQgMCA4LTMuNiA4LTh2LTU2YzAtNC40LTMuNi04LTgtOHptMCAyODRIMzI4Yy00LjQgMC04IDMuNi04IDh2NTZjMCA0LjQgMy42IDggOCA4aDU4NGM0LjQgMCA4LTMuNiA4LTh2LTU2YzAtNC40LTMuNi04LTgtOHpNMTA0IDIyOGE1NiA1NiAwIDEwMTEyIDAgNTYgNTYgMCAxMC0xMTIgMHptMCAyODRhNTYgNTYgMCAxMDExMiAwIDU2IDU2IDAgMTAtMTEyIDB6bTAgMjg0YTU2IDU2IDAgMTAxMTIgMCA1NiA1NiAwIDEwLTExMiAweiIgLz48L3N2Zz4=) */ const $b0ff4076559b6cfb$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($b0ff4076559b6cfb$var$BarsOutlined);
var $b0ff4076559b6cfb$export$2e2bcd8739ae039 = $b0ff4076559b6cfb$var$RefIcon;










var $5E6i4 = parcelRequire("5E6i4");
const $0a263b6875575b1e$export$964282a2c3979546 = /*#__PURE__*/ $5E6i4.createContext({
    siderHook: {
        addSider: ()=>null,
        removeSider: ()=>null
    }
});





const $79da6f68f93f41b6$var$genLayoutStyle = (token)=>{
    const { antCls: antCls, componentCls: // .ant
    componentCls, colorText: // .ant-layout
    colorText, footerBg: footerBg, headerHeight: headerHeight, headerPadding: headerPadding, headerColor: headerColor, footerPadding: footerPadding, fontSize: fontSize, bodyBg: bodyBg, headerBg: headerBg } = token;
    return {
        [componentCls]: {
            display: 'flex',
            flex: 'auto',
            flexDirection: 'column',
            /* fix firefox can't set height smaller than content on flex item */ minHeight: 0,
            background: bodyBg,
            '&, *': {
                boxSizing: 'border-box'
            },
            [`&${componentCls}-has-sider`]: {
                flexDirection: 'row',
                [`> ${componentCls}, > ${componentCls}-content`]: {
                    // https://segmentfault.com/a/1190000019498300
                    width: 0
                }
            },
            [`${componentCls}-header, &${componentCls}-footer`]: {
                flex: '0 0 auto'
            },
            // RTL
            '&-rtl': {
                direction: 'rtl'
            }
        },
        // ==================== Header ====================
        [`${componentCls}-header`]: {
            height: headerHeight,
            padding: headerPadding,
            color: headerColor,
            lineHeight: (0, $56bae8a99c3cba6e$export$523c0b569236b342)(headerHeight),
            background: headerBg,
            // Other components/menu/style/index.less line:686
            // Integration with header element so menu items have the same height
            [`${antCls}-menu`]: {
                lineHeight: 'inherit'
            }
        },
        // ==================== Footer ====================
        [`${componentCls}-footer`]: {
            padding: footerPadding,
            color: colorText,
            fontSize: fontSize,
            background: footerBg
        },
        // =================== Content ====================
        [`${componentCls}-content`]: {
            flex: 'auto',
            color: colorText,
            // fix firefox can't set height smaller than content on flex item
            minHeight: 0
        }
    };
};
const $79da6f68f93f41b6$export$9ca1be8807fe0675 = (token)=>{
    const { colorBgLayout: colorBgLayout, controlHeight: controlHeight, controlHeightLG: controlHeightLG, colorText: colorText, controlHeightSM: controlHeightSM, marginXXS: marginXXS, colorTextLightSolid: colorTextLightSolid, colorBgContainer: colorBgContainer } = token;
    const paddingInline = controlHeightLG * 1.25;
    return {
        // Deprecated
        colorBgHeader: '#001529',
        colorBgBody: colorBgLayout,
        colorBgTrigger: '#002140',
        bodyBg: colorBgLayout,
        headerBg: '#001529',
        headerHeight: controlHeight * 2,
        headerPadding: `0 ${paddingInline}px`,
        headerColor: colorText,
        footerPadding: `${controlHeightSM}px ${paddingInline}px`,
        footerBg: colorBgLayout,
        siderBg: '#001529',
        triggerHeight: controlHeightLG + marginXXS * 2,
        triggerBg: '#002140',
        triggerColor: colorTextLightSolid,
        zeroTriggerWidth: controlHeightLG,
        zeroTriggerHeight: controlHeightLG,
        lightSiderBg: colorBgContainer,
        lightTriggerBg: colorBgContainer,
        lightTriggerColor: colorText
    };
};
const $79da6f68f93f41b6$export$da0be9ab56e785fc = [
    [
        'colorBgBody',
        'bodyBg'
    ],
    [
        'colorBgHeader',
        'headerBg'
    ],
    [
        'colorBgTrigger',
        'triggerBg'
    ]
];
var $79da6f68f93f41b6$export$2e2bcd8739ae039 = (0, $761caadb5301aee1$export$51ec95de45185b42)('Layout', $79da6f68f93f41b6$var$genLayoutStyle, $79da6f68f93f41b6$export$9ca1be8807fe0675, {
    deprecatedTokens: $79da6f68f93f41b6$export$da0be9ab56e785fc
});



const $0d781ebe9f7e04ce$var$genSiderStyle = (token)=>{
    const { componentCls: componentCls, siderBg: siderBg, motionDurationMid: motionDurationMid, motionDurationSlow: motionDurationSlow, antCls: antCls, triggerHeight: triggerHeight, triggerColor: triggerColor, triggerBg: triggerBg, headerHeight: headerHeight, zeroTriggerWidth: zeroTriggerWidth, zeroTriggerHeight: zeroTriggerHeight, borderRadiusLG: borderRadiusLG, lightSiderBg: lightSiderBg, lightTriggerColor: lightTriggerColor, lightTriggerBg: lightTriggerBg, bodyBg: bodyBg } = token;
    return {
        [componentCls]: {
            position: 'relative',
            // fix firefox can't set width smaller than content on flex item
            minWidth: 0,
            background: siderBg,
            transition: `all ${motionDurationMid}, background 0s`,
            '&-has-trigger': {
                paddingBottom: triggerHeight
            },
            '&-right': {
                order: 1
            },
            [`${componentCls}-children`]: {
                height: '100%',
                // Hack for fixing margin collapse bug
                // https://github.com/ant-design/ant-design/issues/7967
                // solution from https://stackoverflow.com/a/33132624/3040605
                marginTop: -0.1,
                paddingTop: 0.1,
                [`${antCls}-menu${antCls}-menu-inline-collapsed`]: {
                    width: 'auto'
                }
            },
            [`&-zero-width ${componentCls}-children`]: {
                overflow: 'hidden'
            },
            [`${componentCls}-trigger`]: {
                position: 'fixed',
                bottom: 0,
                zIndex: 1,
                height: triggerHeight,
                color: triggerColor,
                lineHeight: (0, $56bae8a99c3cba6e$export$523c0b569236b342)(triggerHeight),
                textAlign: 'center',
                background: triggerBg,
                cursor: 'pointer',
                transition: `all ${motionDurationMid}`
            },
            [`${componentCls}-zero-width-trigger`]: {
                position: 'absolute',
                top: headerHeight,
                insetInlineEnd: token.calc(zeroTriggerWidth).mul(-1).equal(),
                zIndex: 1,
                width: zeroTriggerWidth,
                height: zeroTriggerHeight,
                color: triggerColor,
                fontSize: token.fontSizeXL,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: siderBg,
                borderRadius: `0 ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(borderRadiusLG)} ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(borderRadiusLG)} 0`,
                cursor: 'pointer',
                transition: `background-color ${motionDurationSlow} ease`,
                '&::after': {
                    position: 'absolute',
                    inset: 0,
                    background: 'transparent',
                    transition: `all ${motionDurationSlow}`,
                    content: '""'
                },
                '&:hover::after': {
                    background: `rgba(255, 255, 255, 0.2)`
                },
                '&-right': {
                    insetInlineStart: token.calc(zeroTriggerWidth).mul(-1).equal(),
                    borderRadius: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(borderRadiusLG)} 0 0 ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(borderRadiusLG)}`
                }
            },
            // Light
            '&-light': {
                background: lightSiderBg,
                [`${componentCls}-trigger`]: {
                    color: lightTriggerColor,
                    background: lightTriggerBg
                },
                [`${componentCls}-zero-width-trigger`]: {
                    color: lightTriggerColor,
                    background: lightTriggerBg,
                    border: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${bodyBg}`,
                    // Safe to modify to any other color
                    borderInlineStart: 0
                }
            }
        }
    };
};
var $0d781ebe9f7e04ce$export$2e2bcd8739ae039 = (0, $761caadb5301aee1$export$51ec95de45185b42)([
    'Layout',
    'Sider'
], $0d781ebe9f7e04ce$var$genSiderStyle, (0, $79da6f68f93f41b6$export$9ca1be8807fe0675), {
    deprecatedTokens: (0, $79da6f68f93f41b6$export$da0be9ab56e785fc)
});


"use client";
const $21140119f2dfebfc$var$dimensionMaxMap = {
    xs: '479.98px',
    sm: '575.98px',
    md: '767.98px',
    lg: '991.98px',
    xl: '1199.98px',
    xxl: '1599.98px',
    xxxl: `1839.98px`
};
const $21140119f2dfebfc$var$isNumeric = (val)=>!Number.isNaN(Number.parseFloat(val)) && Number.isFinite(Number(val));
const $21140119f2dfebfc$export$63554aebd2a6d54c = /*#__PURE__*/ $5E6i4.createContext({});
const $21140119f2dfebfc$var$generateId = (()=>{
    let i = 0;
    return (prefix = '')=>{
        i += 1;
        return `${prefix}${i}`;
    };
})();
const $21140119f2dfebfc$var$Sider = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, className: className, trigger: trigger, children: children, defaultCollapsed: defaultCollapsed = false, theme: theme = 'dark', style: style = {}, collapsible: collapsible = false, reverseArrow: reverseArrow = false, width: width = 200, collapsedWidth: collapsedWidth = 80, zeroWidthTriggerStyle: zeroWidthTriggerStyle, breakpoint: breakpoint, onCollapse: onCollapse, onBreakpoint: onBreakpoint, classNames: classNames, styles: styles, ...otherProps } = props;
    const { siderHook: siderHook } = (0, $5E6i4.useContext)((0, $0a263b6875575b1e$export$964282a2c3979546));
    const [collapsed, setCollapsed] = (0, $e18df22f16a16360$export$2e2bcd8739ae039)(defaultCollapsed, props.collapsed);
    const [below, setBelow] = (0, $5E6i4.useState)(false);
    const handleSetCollapsed = (value, type)=>{
        setCollapsed(value);
        onCollapse?.(value, type);
    };
    const semanticProps = {
        ...props,
        collapsed: collapsed,
        defaultCollapsed: defaultCollapsed,
        theme: theme,
        style: style,
        collapsible: collapsible,
        reverseArrow: reverseArrow,
        width: width,
        collapsedWidth: collapsedWidth,
        zeroWidthTriggerStyle: zeroWidthTriggerStyle,
        breakpoint: breakpoint,
        onCollapse: onCollapse,
        onBreakpoint: onBreakpoint
    };
    const [mergedClassNames, mergedStyles] = (0, $722c8632ba7bdb89$export$648566b068f28737)([
        classNames
    ], [
        styles
    ], {
        props: semanticProps
    });
    // =========================== Prefix ===========================
    const { getPrefixCls: getPrefixCls, direction: direction } = (0, $5E6i4.useContext)((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('layout-sider', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $0d781ebe9f7e04ce$export$2e2bcd8739ae039)(prefixCls);
    // ========================= Responsive =========================
    const responsiveHandlerRef = (0, $5E6i4.useRef)(null);
    responsiveHandlerRef.current = (mql)=>{
        setBelow(mql.matches);
        onBreakpoint?.(mql.matches);
        if (collapsed !== mql.matches) handleSetCollapsed(mql.matches, 'responsive');
    };
    (0, $5E6i4.useEffect)(()=>{
        function responsiveHandler(mql) {
            return responsiveHandlerRef.current?.(mql);
        }
        let mql;
        if (typeof window?.matchMedia !== 'undefined' && breakpoint && breakpoint in $21140119f2dfebfc$var$dimensionMaxMap) {
            mql = window.matchMedia(`screen and (max-width: ${$21140119f2dfebfc$var$dimensionMaxMap[breakpoint]})`);
            if ((0, $addbc2fddcbb77a9$export$f6e2535fb5126e54)(mql?.addEventListener)) mql.addEventListener('change', responsiveHandler);
            responsiveHandler(mql);
        }
        return ()=>{
            if ((0, $addbc2fddcbb77a9$export$f6e2535fb5126e54)(mql?.removeEventListener)) mql.removeEventListener('change', responsiveHandler);
        };
    }, [
        breakpoint
    ]); // in order to accept dynamic 'breakpoint' property, we need to add 'breakpoint' into dependency array.
    (0, $5E6i4.useEffect)(()=>{
        const uniqueId = $21140119f2dfebfc$var$generateId('ant-sider-');
        siderHook.addSider(uniqueId);
        return ()=>siderHook.removeSider(uniqueId);
    }, []);
    const toggle = ()=>{
        handleSetCollapsed(!collapsed, 'clickTrigger');
    };
    const divProps = (0, $48bd91d9f828de66$export$2e2bcd8739ae039)(otherProps, [
        'collapsed'
    ]);
    const rawWidth = collapsed ? collapsedWidth : width;
    // use "px" as fallback unit for width
    const siderWidth = $21140119f2dfebfc$var$isNumeric(rawWidth) ? `${rawWidth}px` : String(rawWidth);
    // special trigger when collapsedWidth == 0
    const zeroWidthTrigger = Number.parseFloat(String(collapsedWidth || 0)) === 0 ? /*#__PURE__*/ $5E6i4.createElement("span", {
        onClick: toggle,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-zero-width-trigger`, `${prefixCls}-zero-width-trigger-${reverseArrow ? 'right' : 'left'}`),
        style: zeroWidthTriggerStyle
    }, trigger || /*#__PURE__*/ $5E6i4.createElement((0, $b0ff4076559b6cfb$export$2e2bcd8739ae039), null)) : null;
    const reverseIcon = direction === 'rtl' === !reverseArrow;
    const iconObj = {
        expanded: reverseIcon ? /*#__PURE__*/ $5E6i4.createElement((0, $adbdeb3aab803740$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $5E6i4.createElement((0, $2abf808b8f2c53a3$export$2e2bcd8739ae039), null),
        collapsed: reverseIcon ? /*#__PURE__*/ $5E6i4.createElement((0, $2abf808b8f2c53a3$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $5E6i4.createElement((0, $adbdeb3aab803740$export$2e2bcd8739ae039), null)
    };
    const status = collapsed ? 'collapsed' : 'expanded';
    const defaultTrigger = iconObj[status];
    const triggerDom = trigger !== null ? zeroWidthTrigger || /*#__PURE__*/ $5E6i4.createElement("div", {
        className: `${prefixCls}-trigger`,
        onClick: toggle,
        style: {
            width: siderWidth
        }
    }, trigger || defaultTrigger) : null;
    const divStyle = {
        ...style,
        flex: `0 0 ${siderWidth}`,
        maxWidth: siderWidth,
        // Fix width transition bug in IE11
        minWidth: siderWidth,
        // https://github.com/ant-design/ant-design/issues/6349
        width: siderWidth
    };
    const siderCls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-${theme}`, {
        [`${prefixCls}-collapsed`]: !!collapsed,
        [`${prefixCls}-has-trigger`]: collapsible && trigger !== null && !zeroWidthTrigger,
        [`${prefixCls}-below`]: !!below,
        [`${prefixCls}-zero-width`]: Number.parseFloat(siderWidth) === 0
    }, className, mergedClassNames.root, hashId, cssVarCls);
    const contextValue = $5E6i4.useMemo(()=>({
            siderCollapsed: collapsed
        }), [
        collapsed
    ]);
    return /*#__PURE__*/ $5E6i4.createElement($21140119f2dfebfc$export$63554aebd2a6d54c.Provider, {
        value: contextValue
    }, /*#__PURE__*/ $5E6i4.createElement("aside", {
        className: siderCls,
        ...divProps,
        style: {
            ...mergedStyles.root,
            ...divStyle
        },
        ref: ref
    }, /*#__PURE__*/ $5E6i4.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-children`, mergedClassNames.body),
        style: mergedStyles.body
    }, children), collapsible || below && zeroWidthTrigger ? triggerDom : null));
});
var $21140119f2dfebfc$export$2e2bcd8739ae039 = $21140119f2dfebfc$var$Sider;



var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $d3c5d190e5c60f34$var$EllipsisOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z"
                }
            }
        ]
    },
    "name": "ellipsis",
    "theme": "outlined"
};
var $d3c5d190e5c60f34$export$2e2bcd8739ae039 = $d3c5d190e5c60f34$var$EllipsisOutlined;



function $bc99f102364e8dbf$var$_extends() {
    $bc99f102364e8dbf$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bc99f102364e8dbf$var$_extends.apply(this, arguments);
}
const $bc99f102364e8dbf$var$EllipsisOutlined = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $bc99f102364e8dbf$var$_extends({}, props, {
        ref: ref,
        icon: (0, $d3c5d190e5c60f34$export$2e2bcd8739ae039)
    }));
/**![ellipsis](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTE3NiA1MTFhNTYgNTYgMCAxMDExMiAwIDU2IDU2IDAgMTAtMTEyIDB6bTI4MCAwYTU2IDU2IDAgMTAxMTIgMCA1NiA1NiAwIDEwLTExMiAwem0yODAgMGE1NiA1NiAwIDEwMTEyIDAgNTYgNTYgMCAxMC0xMTIgMHoiIC8+PC9zdmc+) */ const $bc99f102364e8dbf$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($bc99f102364e8dbf$var$EllipsisOutlined);
var $bc99f102364e8dbf$export$2e2bcd8739ae039 = $bc99f102364e8dbf$var$RefIcon;














var $5E6i4 = parcelRequire("5E6i4");
"use client";
const $2e8debe7211a1585$var$MenuContext = /*#__PURE__*/ (0, $5E6i4.createContext)({
    prefixCls: '',
    firstLevel: true,
    inlineCollapsed: false,
    styles: null,
    classNames: null
});
var $2e8debe7211a1585$export$2e2bcd8739ae039 = $2e8debe7211a1585$var$MenuContext;



var $5E6i4 = parcelRequire("5E6i4");



"use client";
const $a04b622e194e2138$var$MenuDivider = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, dashed: dashed, ...restProps } = props;
    const { getPrefixCls: getPrefixCls } = $5E6i4.useContext((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('menu', customizePrefixCls);
    const classString = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)({
        [`${prefixCls}-item-divider-dashed`]: !!dashed
    }, className);
    return /*#__PURE__*/ $5E6i4.createElement((0, $878a9836f27455e1$export$2e2bcd8739ae039), {
        className: classString,
        ...restProps
    });
};
var $a04b622e194e2138$export$2e2bcd8739ae039 = $a04b622e194e2138$var$MenuDivider;



var $5E6i4 = parcelRequire("5E6i4");







var $5E6i4 = parcelRequire("5E6i4");


var $5E6i4 = parcelRequire("5E6i4");
const $405f5aaf9af8ea26$var$Popup = (props)=>{
    const { children: children, prefixCls: prefixCls, id: id, classNames: classNames, styles: styles, className: className, style: style } = props;
    return /*#__PURE__*/ $5E6i4.createElement("div", {
        id: id,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-container`, classNames?.container, className),
        style: {
            ...styles?.container,
            ...style
        },
        role: "tooltip"
    }, typeof children === 'function' ? children() : children);
};
var $405f5aaf9af8ea26$export$2e2bcd8739ae039 = $405f5aaf9af8ea26$var$Popup;






var $5E6i4 = parcelRequire("5E6i4");
const $c7d1fedd5e4e2daf$var$autoAdjustOverflowTopBottom = {
    shiftX: 64,
    adjustY: 1
};
const $c7d1fedd5e4e2daf$var$autoAdjustOverflowLeftRight = {
    adjustX: 1,
    shiftY: true
};
const $c7d1fedd5e4e2daf$var$targetOffset = [
    0,
    0
];
const $c7d1fedd5e4e2daf$export$803cd8101b6c182b = {
    left: {
        points: [
            'cr',
            'cl'
        ],
        overflow: $c7d1fedd5e4e2daf$var$autoAdjustOverflowLeftRight,
        offset: [
            -4,
            0
        ],
        targetOffset: $c7d1fedd5e4e2daf$var$targetOffset
    },
    right: {
        points: [
            'cl',
            'cr'
        ],
        overflow: $c7d1fedd5e4e2daf$var$autoAdjustOverflowLeftRight,
        offset: [
            4,
            0
        ],
        targetOffset: $c7d1fedd5e4e2daf$var$targetOffset
    },
    top: {
        points: [
            'bc',
            'tc'
        ],
        overflow: $c7d1fedd5e4e2daf$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            -4
        ],
        targetOffset: $c7d1fedd5e4e2daf$var$targetOffset
    },
    bottom: {
        points: [
            'tc',
            'bc'
        ],
        overflow: $c7d1fedd5e4e2daf$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            4
        ],
        targetOffset: $c7d1fedd5e4e2daf$var$targetOffset
    },
    topLeft: {
        points: [
            'bl',
            'tl'
        ],
        overflow: $c7d1fedd5e4e2daf$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            -4
        ],
        targetOffset: $c7d1fedd5e4e2daf$var$targetOffset
    },
    leftTop: {
        points: [
            'tr',
            'tl'
        ],
        overflow: $c7d1fedd5e4e2daf$var$autoAdjustOverflowLeftRight,
        offset: [
            -4,
            0
        ],
        targetOffset: $c7d1fedd5e4e2daf$var$targetOffset
    },
    topRight: {
        points: [
            'br',
            'tr'
        ],
        overflow: $c7d1fedd5e4e2daf$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            -4
        ],
        targetOffset: $c7d1fedd5e4e2daf$var$targetOffset
    },
    rightTop: {
        points: [
            'tl',
            'tr'
        ],
        overflow: $c7d1fedd5e4e2daf$var$autoAdjustOverflowLeftRight,
        offset: [
            4,
            0
        ],
        targetOffset: $c7d1fedd5e4e2daf$var$targetOffset
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ],
        overflow: $c7d1fedd5e4e2daf$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            4
        ],
        targetOffset: $c7d1fedd5e4e2daf$var$targetOffset
    },
    rightBottom: {
        points: [
            'bl',
            'br'
        ],
        overflow: $c7d1fedd5e4e2daf$var$autoAdjustOverflowLeftRight,
        offset: [
            4,
            0
        ],
        targetOffset: $c7d1fedd5e4e2daf$var$targetOffset
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ],
        overflow: $c7d1fedd5e4e2daf$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            4
        ],
        targetOffset: $c7d1fedd5e4e2daf$var$targetOffset
    },
    leftBottom: {
        points: [
            'br',
            'bl'
        ],
        overflow: $c7d1fedd5e4e2daf$var$autoAdjustOverflowLeftRight,
        offset: [
            -4,
            0
        ],
        targetOffset: $c7d1fedd5e4e2daf$var$targetOffset
    }
};
var $c7d1fedd5e4e2daf$export$2e2bcd8739ae039 = $c7d1fedd5e4e2daf$export$803cd8101b6c182b;



function $a5cd52183c48efdf$var$_extends() {
    $a5cd52183c48efdf$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a5cd52183c48efdf$var$_extends.apply(this, arguments);
}
const $a5cd52183c48efdf$var$Tooltip = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { trigger: trigger = [
        'hover',
        'focus'
    ], mouseEnterDelay: mouseEnterDelay = 0, mouseLeaveDelay: mouseLeaveDelay = 0.1, prefixCls: prefixCls = 'rc-tooltip', children: children, onVisibleChange: onVisibleChange, afterVisibleChange: afterVisibleChange, motion: motion, placement: placement = 'right', align: align = {}, destroyOnHidden: destroyOnHidden = false, defaultVisible: defaultVisible, getTooltipContainer: getTooltipContainer, arrowContent: arrowContent, overlay: overlay, id: id, showArrow: showArrow = true, classNames: classNames, styles: styles, ...restProps } = props;
    const mergedId = (0, $378d6dcdebc6b864$export$2e2bcd8739ae039)(id);
    const triggerRef = (0, $5E6i4.useRef)(null);
    (0, $5E6i4.useImperativeHandle)(ref, ()=>triggerRef.current);
    const extraProps = {
        ...restProps
    };
    if ('visible' in props) extraProps.popupVisible = props.visible;
    // ========================= Arrow ==========================
    // Process arrow configuration
    const mergedArrow = $5E6i4.useMemo(()=>{
        if (!showArrow) return false;
        // Convert true to object for unified processing
        const arrowConfig = showArrow === true ? {} : showArrow;
        // Apply semantic styles with unified logic
        return {
            ...arrowConfig,
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(arrowConfig.className, classNames?.arrow),
            style: {
                ...arrowConfig.style,
                ...styles?.arrow
            },
            content: arrowConfig.content ?? arrowContent
        };
    }, [
        showArrow,
        classNames?.arrow,
        styles?.arrow,
        arrowContent
    ]);
    // ======================== Children ========================
    const getChildren = ({ open: open })=>{
        const child = $5E6i4.Children.only(children);
        const childAriaDescribedBy = child.props['aria-describedby'];
        const ariaDescribedBy = [
            childAriaDescribedBy,
            overlay && open ? mergedId : undefined
        ].filter(Boolean).join(' ');
        const ariaProps = {
            'aria-describedby': ariaDescribedBy || undefined
        };
        return /*#__PURE__*/ $5E6i4.cloneElement(child, ariaProps);
    };
    // ========================= Render =========================
    return /*#__PURE__*/ $5E6i4.createElement((0, $5ff8ad2f21affc17$export$2e2bcd8739ae039), $a5cd52183c48efdf$var$_extends({
        popupClassName: classNames?.root,
        prefixCls: prefixCls,
        popup: /*#__PURE__*/ $5E6i4.createElement((0, $405f5aaf9af8ea26$export$2e2bcd8739ae039), {
            key: "content",
            prefixCls: prefixCls,
            id: mergedId,
            classNames: classNames,
            styles: styles
        }, overlay),
        action: trigger,
        builtinPlacements: (0, $c7d1fedd5e4e2daf$export$803cd8101b6c182b),
        popupPlacement: placement,
        ref: triggerRef,
        popupAlign: align,
        getPopupContainer: getTooltipContainer,
        onOpenChange: onVisibleChange,
        afterOpenChange: afterVisibleChange,
        popupMotion: motion,
        defaultPopupVisible: defaultVisible,
        autoDestroy: destroyOnHidden,
        mouseLeaveDelay: mouseLeaveDelay,
        popupStyle: styles?.root,
        mouseEnterDelay: mouseEnterDelay,
        arrow: mergedArrow,
        uniqueContainerClassName: classNames?.uniqueContainer,
        uniqueContainerStyle: styles?.uniqueContainer
    }, extraProps), getChildren);
});
var $a5cd52183c48efdf$export$2e2bcd8739ae039 = $a5cd52183c48efdf$var$Tooltip;


var $d826a5797bc4bca3$export$2e2bcd8739ae039 = (0, $a5cd52183c48efdf$export$2e2bcd8739ae039);





var $5E6i4 = parcelRequire("5E6i4");


var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");


var $5E6i4 = parcelRequire("5E6i4");


var $5E6i4 = parcelRequire("5E6i4");
const $4eb49d26951fd5b1$export$24829b7c0e49e9f7 = 'RC_FORM_INTERNAL_HOOKS';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4eb49d26951fd5b1$var$warningFunc = ()=>{
    (0, $f757b9ac02fa080d$export$2e2bcd8739ae039)(false, 'Can not find FormContext. Please make sure you wrap Field under Form.');
};
const $4eb49d26951fd5b1$var$Context = /*#__PURE__*/ $5E6i4.createContext({
    getFieldValue: $4eb49d26951fd5b1$var$warningFunc,
    getFieldsValue: $4eb49d26951fd5b1$var$warningFunc,
    getFieldError: $4eb49d26951fd5b1$var$warningFunc,
    getFieldWarning: $4eb49d26951fd5b1$var$warningFunc,
    getFieldsError: $4eb49d26951fd5b1$var$warningFunc,
    isFieldsTouched: $4eb49d26951fd5b1$var$warningFunc,
    isFieldTouched: $4eb49d26951fd5b1$var$warningFunc,
    isFieldValidating: $4eb49d26951fd5b1$var$warningFunc,
    isFieldsValidating: $4eb49d26951fd5b1$var$warningFunc,
    resetFields: $4eb49d26951fd5b1$var$warningFunc,
    setFields: $4eb49d26951fd5b1$var$warningFunc,
    setFieldValue: $4eb49d26951fd5b1$var$warningFunc,
    setFieldsValue: $4eb49d26951fd5b1$var$warningFunc,
    validateFields: $4eb49d26951fd5b1$var$warningFunc,
    submit: $4eb49d26951fd5b1$var$warningFunc,
    getInternalHooks: ()=>{
        $4eb49d26951fd5b1$var$warningFunc();
        return {
            dispatch: $4eb49d26951fd5b1$var$warningFunc,
            initEntityValue: $4eb49d26951fd5b1$var$warningFunc,
            registerField: $4eb49d26951fd5b1$var$warningFunc,
            useSubscribe: $4eb49d26951fd5b1$var$warningFunc,
            setInitialValues: $4eb49d26951fd5b1$var$warningFunc,
            destroyForm: $4eb49d26951fd5b1$var$warningFunc,
            setCallbacks: $4eb49d26951fd5b1$var$warningFunc,
            registerWatch: $4eb49d26951fd5b1$var$warningFunc,
            getFields: $4eb49d26951fd5b1$var$warningFunc,
            setValidateMessages: $4eb49d26951fd5b1$var$warningFunc,
            setPreserve: $4eb49d26951fd5b1$var$warningFunc,
            getInitialValue: $4eb49d26951fd5b1$var$warningFunc
        };
    }
});
var $4eb49d26951fd5b1$export$2e2bcd8739ae039 = $4eb49d26951fd5b1$var$Context;



var $5E6i4 = parcelRequire("5E6i4");
const $3befa91cc1f10543$var$ListContext = /*#__PURE__*/ $5E6i4.createContext(null);
var $3befa91cc1f10543$export$2e2bcd8739ae039 = $3befa91cc1f10543$var$ListContext;


function $58b11f9f2fc16504$export$45b10814cc054894(value) {
    if (value === undefined || value === null) return [];
    return Array.isArray(value) ? value : [
        value
    ];
}
function $58b11f9f2fc16504$export$717b316e73068e8d(form) {
    return form && !!form._init;
}


function $a37acea3f5a2ba07$export$f77fd0c3b25d8534() {
    return {
        default: 'Validation error on field %s',
        required: '%s is required',
        enum: '%s must be one of %s',
        whitespace: '%s cannot be empty',
        date: {
            format: '%s date %s is invalid for format %s',
            parse: '%s date could not be parsed, %s is invalid ',
            invalid: '%s date %s is invalid'
        },
        types: {
            string: '%s is not a %s',
            method: '%s is not a %s (function)',
            array: '%s is not an %s',
            object: '%s is not an %s',
            number: '%s is not a %s',
            date: '%s is not a %s',
            boolean: '%s is not a %s',
            integer: '%s is not an %s',
            float: '%s is not a %s',
            regexp: '%s is not a valid %s',
            email: '%s is not a valid %s',
            tel: '%s is not a valid %s',
            url: '%s is not a valid %s',
            hex: '%s is not a valid %s'
        },
        string: {
            len: '%s must be exactly %s characters',
            min: '%s must be at least %s characters',
            max: '%s cannot be longer than %s characters',
            range: '%s must be between %s and %s characters'
        },
        number: {
            len: '%s must equal %s',
            min: '%s cannot be less than %s',
            max: '%s cannot be greater than %s',
            range: '%s must be between %s and %s'
        },
        array: {
            len: '%s must be exactly %s in length',
            min: '%s cannot be less than %s in length',
            max: '%s cannot be greater than %s in length',
            range: '%s must be between %s and %s in length'
        },
        pattern: {
            mismatch: '%s value %s does not match pattern %s'
        },
        clone () {
            const cloned = JSON.parse(JSON.stringify(this));
            cloned.clone = this.clone;
            return cloned;
        }
    };
}
const $a37acea3f5a2ba07$export$defe85febe8b728c = $a37acea3f5a2ba07$export$f77fd0c3b25d8534();


/* eslint no-console:0 */ const $3ee57d6ab1950ea9$var$formatRegExp = /%[sdj%]/g;
let $3ee57d6ab1950ea9$export$491112666e282270 = ()=>{};
var $3ee57d6ab1950ea9$var$type, $3ee57d6ab1950ea9$var$errors, $3ee57d6ab1950ea9$var$e;
function $3ee57d6ab1950ea9$export$e85887f5ceeacced(errors) {
    if (!errors || !errors.length) return null;
    const fields = {};
    errors.forEach((error)=>{
        const field = error.field;
        fields[field] = fields[field] || [];
        fields[field].push(error);
    });
    return fields;
}
function $3ee57d6ab1950ea9$export$d9468344d3651243(template, ...args) {
    let i = 0;
    const len = args.length;
    if (typeof template === 'function') // eslint-disable-next-line prefer-spread
    return template.apply(null, args);
    if (typeof template === 'string') {
        const str = template.replace($3ee57d6ab1950ea9$var$formatRegExp, (x)=>{
            if (x === '%%') return '%';
            if (i >= len) return x;
            switch(x){
                case '%s':
                    return String(args[i++]);
                case '%d':
                    return Number(args[i++]);
                case '%j':
                    try {
                        return JSON.stringify(args[i++]);
                    } catch (_) {
                        return '[Circular]';
                    }
                    break;
                default:
                    return x;
            }
        });
        return str;
    }
    return template;
}
function $3ee57d6ab1950ea9$var$isNativeStringType(type) {
    return type === 'string' || type === 'url' || type === 'hex' || type === 'email' || type === 'date' || type === 'pattern' || type === 'tel';
}
function $3ee57d6ab1950ea9$export$141eca273a04dc3e(value, type) {
    if (value === undefined || value === null) return true;
    if (type === 'array' && Array.isArray(value) && !value.length) return true;
    if ($3ee57d6ab1950ea9$var$isNativeStringType(type) && typeof value === 'string' && !value) return true;
    return false;
}
function $3ee57d6ab1950ea9$export$83b788b1a3698c03(obj) {
    return Object.keys(obj).length === 0;
}
function $3ee57d6ab1950ea9$var$asyncParallelArray(arr, func, callback) {
    const results = [];
    let total = 0;
    const arrLength = arr.length;
    function count(errors) {
        results.push(...errors || []);
        total++;
        if (total === arrLength) callback(results);
    }
    arr.forEach((a)=>{
        func(a, count);
    });
}
function $3ee57d6ab1950ea9$var$asyncSerialArray(arr, func, callback) {
    let index = 0;
    const arrLength = arr.length;
    function next(errors) {
        if (errors && errors.length) {
            callback(errors);
            return;
        }
        const original = index;
        index = index + 1;
        if (original < arrLength) func(arr[original], next);
        else callback([]);
    }
    next([]);
}
function $3ee57d6ab1950ea9$var$flattenObjArr(objArr) {
    const ret = [];
    Object.keys(objArr).forEach((k)=>{
        ret.push(...objArr[k] || []);
    });
    return ret;
}
class $3ee57d6ab1950ea9$export$188f48b73534b6f0 extends Error {
    errors;
    fields;
    constructor(errors, fields){
        super('Async Validation Error');
        this.errors = errors;
        this.fields = fields;
    }
}
function $3ee57d6ab1950ea9$export$707ee4c4c95d39e3(objArr, option, func, callback, source) {
    if (option.first) {
        const pending = new Promise((resolve, reject)=>{
            const next = (errors)=>{
                callback(errors);
                return errors.length ? reject(new $3ee57d6ab1950ea9$export$188f48b73534b6f0(errors, $3ee57d6ab1950ea9$export$e85887f5ceeacced(errors))) : resolve(source);
            };
            const flattenArr = $3ee57d6ab1950ea9$var$flattenObjArr(objArr);
            $3ee57d6ab1950ea9$var$asyncSerialArray(flattenArr, func, next);
        });
        pending.catch((e)=>e);
        return pending;
    }
    const firstFields = option.firstFields === true ? Object.keys(objArr) : option.firstFields || [];
    const objArrKeys = Object.keys(objArr);
    const objArrLength = objArrKeys.length;
    let total = 0;
    const results = [];
    const pending = new Promise((resolve, reject)=>{
        const next = (errors)=>{
            // eslint-disable-next-line prefer-spread
            results.push.apply(results, errors);
            total++;
            if (total === objArrLength) {
                callback(results);
                return results.length ? reject(new $3ee57d6ab1950ea9$export$188f48b73534b6f0(results, $3ee57d6ab1950ea9$export$e85887f5ceeacced(results))) : resolve(source);
            }
        };
        if (!objArrKeys.length) {
            callback(results);
            resolve(source);
        }
        objArrKeys.forEach((key)=>{
            const arr = objArr[key];
            if (firstFields.indexOf(key) !== -1) $3ee57d6ab1950ea9$var$asyncSerialArray(arr, func, next);
            else $3ee57d6ab1950ea9$var$asyncParallelArray(arr, func, next);
        });
    });
    pending.catch((e)=>e);
    return pending;
}
function $3ee57d6ab1950ea9$var$isErrorObj(obj) {
    return !!(obj && obj.message !== undefined);
}
function $3ee57d6ab1950ea9$var$getValue(value, path) {
    let v = value;
    for(let i = 0; i < path.length; i++){
        if (v == undefined) return v;
        v = v[path[i]];
    }
    return v;
}
function $3ee57d6ab1950ea9$export$34d5fe50d2616cee(rule, source) {
    return (oe)=>{
        let fieldValue;
        if (rule.fullFields) fieldValue = $3ee57d6ab1950ea9$var$getValue(source, rule.fullFields);
        else fieldValue = source[oe.field || rule.fullField];
        if ($3ee57d6ab1950ea9$var$isErrorObj(oe)) {
            oe.field = oe.field || rule.fullField;
            oe.fieldValue = fieldValue;
            return oe;
        }
        return {
            message: typeof oe === 'function' ? oe() : oe,
            fieldValue: fieldValue,
            field: oe.field || rule.fullField
        };
    };
}
function $3ee57d6ab1950ea9$export$6969335ea1e4e77c(target, source) {
    if (source) {
        for(const s in source)if (source.hasOwnProperty(s)) {
            const value = source[s];
            if (typeof value === 'object' && typeof target[s] === 'object') target[s] = {
                ...target[s],
                ...value
            };
            else target[s] = value;
        }
    }
    return target;
}



const $a2701ff1691ff83e$var$ENUM = 'enum';
const $a2701ff1691ff83e$var$enumerable = (rule, value, source, errors, options)=>{
    rule[$a2701ff1691ff83e$var$ENUM] = Array.isArray(rule[$a2701ff1691ff83e$var$ENUM]) ? rule[$a2701ff1691ff83e$var$ENUM] : [];
    if (rule[$a2701ff1691ff83e$var$ENUM].indexOf(value) === -1) errors.push((0, $3ee57d6ab1950ea9$export$d9468344d3651243)(options.messages[$a2701ff1691ff83e$var$ENUM], rule.fullField, rule[$a2701ff1691ff83e$var$ENUM].join(', ')));
};
var $a2701ff1691ff83e$export$2e2bcd8739ae039 = $a2701ff1691ff83e$var$enumerable;



const $e2cae3b2a2b742fd$var$pattern = (rule, value, source, errors, options)=>{
    if (rule.pattern) {
        if (rule.pattern instanceof RegExp) {
            // if a RegExp instance is passed, reset `lastIndex` in case its `global`
            // flag is accidentally set to `true`, which in a validation scenario
            // is not necessary and the result might be misleading
            rule.pattern.lastIndex = 0;
            if (!rule.pattern.test(value)) errors.push((0, $3ee57d6ab1950ea9$export$d9468344d3651243)(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
        } else if (typeof rule.pattern === 'string') {
            const _pattern = new RegExp(rule.pattern);
            if (!_pattern.test(value)) errors.push((0, $3ee57d6ab1950ea9$export$d9468344d3651243)(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
        }
    }
};
var $e2cae3b2a2b742fd$export$2e2bcd8739ae039 = $e2cae3b2a2b742fd$var$pattern;



const $5605a5aaf6438bdb$var$range = (rule, value, source, errors, options)=>{
    const len = typeof rule.len === 'number';
    const min = typeof rule.min === 'number';
    const max = typeof rule.max === 'number';
    // 正则匹配码点范围从U+010000一直到U+10FFFF的文字（补充平面Supplementary Plane）
    const spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
    let val = value;
    let key = null;
    const num = typeof value === 'number';
    const str = typeof value === 'string';
    const arr = Array.isArray(value);
    if (num) key = 'number';
    else if (str) key = 'string';
    else if (arr) key = 'array';
    // if the value is not of a supported type for range validation
    // the validation rule rule should use the
    // type property to also test for a particular type
    if (!key) return false;
    if (arr) val = value.length;
    if (str) // 处理码点大于U+010000的文字length属性不准确的bug，如"𠮷𠮷𠮷".length !== 3
    val = value.replace(spRegexp, '_').length;
    if (len) {
        if (val !== rule.len) errors.push((0, $3ee57d6ab1950ea9$export$d9468344d3651243)(options.messages[key].len, rule.fullField, rule.len));
    } else if (min && !max && val < rule.min) errors.push((0, $3ee57d6ab1950ea9$export$d9468344d3651243)(options.messages[key].min, rule.fullField, rule.min));
    else if (max && !min && val > rule.max) errors.push((0, $3ee57d6ab1950ea9$export$d9468344d3651243)(options.messages[key].max, rule.fullField, rule.max));
    else if (min && max && (val < rule.min || val > rule.max)) errors.push((0, $3ee57d6ab1950ea9$export$d9468344d3651243)(options.messages[key].range, rule.fullField, rule.min, rule.max));
};
var $5605a5aaf6438bdb$export$2e2bcd8739ae039 = $5605a5aaf6438bdb$var$range;



const $3561da74183cd5a6$var$required = (rule, value, source, errors, options, type)=>{
    if (rule.required && (!source.hasOwnProperty(rule.field) || (0, $3ee57d6ab1950ea9$export$141eca273a04dc3e)(value, type || rule.type))) errors.push((0, $3ee57d6ab1950ea9$export$d9468344d3651243)(options.messages.required, rule.fullField));
};
var $3561da74183cd5a6$export$2e2bcd8739ae039 = $3561da74183cd5a6$var$required;




// https://github.com/kevva/url-regex/blob/master/index.js
let $4cf375f862205295$var$urlReg;
var $4cf375f862205295$export$2e2bcd8739ae039 = ()=>{
    if ($4cf375f862205295$var$urlReg) return $4cf375f862205295$var$urlReg;
    const word = '[a-fA-F\\d:]';
    const b = (options)=>options && options.includeBoundaries ? `(?:(?<=\\s|^)(?=${word})|(?<=${word})(?=\\s|$))` : '';
    const v4 = '(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}';
    const v6seg = '[a-fA-F\\d]{1,4}';
    const v6List = [
        `(?:${v6seg}:){7}(?:${v6seg}|:)`,
        // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8
        `(?:${v6seg}:){6}(?:${v4}|:${v6seg}|:)`,
        // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::
        `(?:${v6seg}:){5}(?::${v4}|(?::${v6seg}){1,2}|:)`,
        // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::
        `(?:${v6seg}:){4}(?:(?::${v6seg}){0,1}:${v4}|(?::${v6seg}){1,3}|:)`,
        // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::
        `(?:${v6seg}:){3}(?:(?::${v6seg}){0,2}:${v4}|(?::${v6seg}){1,4}|:)`,
        // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::
        `(?:${v6seg}:){2}(?:(?::${v6seg}){0,3}:${v4}|(?::${v6seg}){1,5}|:)`,
        // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::
        `(?:${v6seg}:){1}(?:(?::${v6seg}){0,4}:${v4}|(?::${v6seg}){1,6}|:)`,
        // 1::              1::3:4:5:6:7:8   1::8            1::
        `(?::(?:(?::${v6seg}){0,5}:${v4}|(?::${v6seg}){1,7}|:))` // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::
    ];
    const v6Eth0 = `(?:%[0-9a-zA-Z]{1,})?`; // %eth0            %1
    const v6 = `(?:${v6List.join('|')})${v6Eth0}`;
    // Pre-compile only the exact regexes because adding a global flag make regexes stateful
    const v46Exact = new RegExp(`(?:^${v4}$)|(?:^${v6}$)`);
    const v4exact = new RegExp(`^${v4}$`);
    const v6exact = new RegExp(`^${v6}$`);
    const ip = (options)=>options && options.exact ? v46Exact : new RegExp(`(?:${b(options)}${v4}${b(options)})|(?:${b(options)}${v6}${b(options)})`, 'g');
    ip.v4 = (options)=>options && options.exact ? v4exact : new RegExp(`${b(options)}${v4}${b(options)}`, 'g');
    ip.v6 = (options)=>options && options.exact ? v6exact : new RegExp(`${b(options)}${v6}${b(options)}`, 'g');
    const protocol = `(?:(?:[a-z]+:)?//)`;
    const auth = '(?:\\S+(?::\\S*)?@)?';
    const ipv4 = ip.v4().source;
    const ipv6 = ip.v6().source;
    const host = '(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)';
    const domain = '(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*';
    const tld = `(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))`;
    const port = '(?::\\d{2,5})?';
    const path = '(?:[/?#][^\\s"]*)?';
    const regex = `(?:${protocol}|www\\.)${auth}(?:localhost|${ipv4}|${ipv6}|${host}${domain}${tld})${port}${path}`;
    $4cf375f862205295$var$urlReg = new RegExp(`(?:^${regex}$)`, 'i');
    return $4cf375f862205295$var$urlReg;
};


/* eslint max-len:0 */ const $572622b0818a1f3e$var$pattern = {
    // http://emailregex.com/
    email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
    // url: new RegExp(
    //   '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
    //   'i',
    // ),
    /**
   * Phone number regex, support country code, brackets, spaces, and dashes (or non-breaking hyphen \u2011).
   * @see https://regexr.com/3c53v
   * @see https://ihateregex.io/expr/phone/
   * @see https://developers.google.com/style/phone-numbers using non-breaking hyphen \u2011
   */ tel: /^(\+[0-9]{1,3}[-\s\u2011]?)?(\([0-9]{1,4}\)[-\s\u2011]?)?([0-9]+[-\s\u2011]?)*[0-9]+$/,
    hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
};
const $572622b0818a1f3e$var$types = {
    integer (value) {
        return $572622b0818a1f3e$var$types.number(value) && parseInt(value, 10) === value;
    },
    float (value) {
        return $572622b0818a1f3e$var$types.number(value) && !$572622b0818a1f3e$var$types.integer(value);
    },
    array (value) {
        return Array.isArray(value);
    },
    regexp (value) {
        if (value instanceof RegExp) return true;
        try {
            return new RegExp(value), true;
        } catch (e) {
            return false;
        }
    },
    date (value) {
        return typeof value.getTime === 'function' && typeof value.getMonth === 'function' && typeof value.getYear === 'function' && !isNaN(value.getTime());
    },
    number (value) {
        if (isNaN(value)) return false;
        return typeof value === 'number';
    },
    object (value) {
        return typeof value === 'object' && !$572622b0818a1f3e$var$types.array(value);
    },
    method (value) {
        return typeof value === 'function';
    },
    email (value) {
        return typeof value === 'string' && value.length <= 320 && !!value.match($572622b0818a1f3e$var$pattern.email);
    },
    tel (value) {
        return typeof value === 'string' && value.length <= 32 && !!value.match($572622b0818a1f3e$var$pattern.tel);
    },
    url (value) {
        return typeof value === 'string' && value.length <= 2048 && !!value.match((0, $4cf375f862205295$export$2e2bcd8739ae039)());
    },
    hex (value) {
        return typeof value === 'string' && !!value.match($572622b0818a1f3e$var$pattern.hex);
    }
};
const $572622b0818a1f3e$var$type = (rule, value, source, errors, options)=>{
    if (rule.required && value === undefined) {
        (0, $3561da74183cd5a6$export$2e2bcd8739ae039)(rule, value, source, errors, options);
        return;
    }
    const custom = [
        'integer',
        'float',
        'array',
        'regexp',
        'object',
        'method',
        'email',
        'tel',
        'number',
        'date',
        'url',
        'hex'
    ];
    const ruleType = rule.type;
    if (custom.indexOf(ruleType) > -1) {
        if (!$572622b0818a1f3e$var$types[ruleType](value)) errors.push((0, $3ee57d6ab1950ea9$export$d9468344d3651243)(options.messages.types[ruleType], rule.fullField, rule.type));
    } else if (ruleType && typeof value !== rule.type) errors.push((0, $3ee57d6ab1950ea9$export$d9468344d3651243)(options.messages.types[ruleType], rule.fullField, rule.type));
};
var $572622b0818a1f3e$export$2e2bcd8739ae039 = $572622b0818a1f3e$var$type;



/**
 *  Rule for validating whitespace.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */ const $eb54994677313d7a$var$whitespace = (rule, value, source, errors, options)=>{
    if (/^\s+$/.test(value) || value === '') errors.push((0, $3ee57d6ab1950ea9$export$d9468344d3651243)(options.messages.whitespace, rule.fullField));
};
var $eb54994677313d7a$export$2e2bcd8739ae039 = $eb54994677313d7a$var$whitespace;


var $87dda735138d51c9$export$2e2bcd8739ae039 = {
    required: $3561da74183cd5a6$export$2e2bcd8739ae039,
    whitespace: $eb54994677313d7a$export$2e2bcd8739ae039,
    type: $572622b0818a1f3e$export$2e2bcd8739ae039,
    range: $5605a5aaf6438bdb$export$2e2bcd8739ae039,
    enum: (0, $a2701ff1691ff83e$export$2e2bcd8739ae039),
    pattern: $e2cae3b2a2b742fd$export$2e2bcd8739ae039
};



const $595861c369ee0d41$var$any = (rule, value, callback, source, options)=>{
    const errors = [];
    const validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $3ee57d6ab1950ea9$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $87dda735138d51c9$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
    }
    callback(errors);
};
var $595861c369ee0d41$export$2e2bcd8739ae039 = $595861c369ee0d41$var$any;



const $7dd3e9755676b90b$var$array = (rule, value, callback, source, options)=>{
    const errors = [];
    const validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((value === undefined || value === null) && !rule.required) return callback();
        (0, $87dda735138d51c9$export$2e2bcd8739ae039).required(rule, value, source, errors, options, 'array');
        if (value !== undefined && value !== null) {
            (0, $87dda735138d51c9$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
            (0, $87dda735138d51c9$export$2e2bcd8739ae039).range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $7dd3e9755676b90b$export$2e2bcd8739ae039 = $7dd3e9755676b90b$var$array;




const $604f63074623a301$var$boolean = (rule, value, callback, source, options)=>{
    const errors = [];
    const validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $3ee57d6ab1950ea9$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $87dda735138d51c9$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) (0, $87dda735138d51c9$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $604f63074623a301$export$2e2bcd8739ae039 = $604f63074623a301$var$boolean;




const $febdc25fc2c33adc$var$date = (rule, value, callback, source, options)=>{
    // console.log('integer rule called %j', rule);
    const errors = [];
    const validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    // console.log('validate on %s value', value);
    if (validate) {
        if ((0, $3ee57d6ab1950ea9$export$141eca273a04dc3e)(value, 'date') && !rule.required) return callback();
        (0, $87dda735138d51c9$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (!(0, $3ee57d6ab1950ea9$export$141eca273a04dc3e)(value, 'date')) {
            let dateObject;
            if (value instanceof Date) dateObject = value;
            else dateObject = new Date(value);
            (0, $87dda735138d51c9$export$2e2bcd8739ae039).type(rule, dateObject, source, errors, options);
            if (dateObject) (0, $87dda735138d51c9$export$2e2bcd8739ae039).range(rule, dateObject.getTime(), source, errors, options);
        }
    }
    callback(errors);
};
var $febdc25fc2c33adc$export$2e2bcd8739ae039 = $febdc25fc2c33adc$var$date;




const $73f66904ca70aabb$var$ENUM = 'enum';
const $73f66904ca70aabb$var$enumerable = (rule, value, callback, source, options)=>{
    const errors = [];
    const validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $3ee57d6ab1950ea9$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $87dda735138d51c9$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) (0, $87dda735138d51c9$export$2e2bcd8739ae039)[$73f66904ca70aabb$var$ENUM](rule, value, source, errors, options);
    }
    callback(errors);
};
var $73f66904ca70aabb$export$2e2bcd8739ae039 = $73f66904ca70aabb$var$enumerable;




const $df969071ee497b17$var$floatFn = (rule, value, callback, source, options)=>{
    const errors = [];
    const validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $3ee57d6ab1950ea9$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $87dda735138d51c9$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) {
            (0, $87dda735138d51c9$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
            (0, $87dda735138d51c9$export$2e2bcd8739ae039).range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $df969071ee497b17$export$2e2bcd8739ae039 = $df969071ee497b17$var$floatFn;




const $6f34290e2d4459cf$var$integer = (rule, value, callback, source, options)=>{
    const errors = [];
    const validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $3ee57d6ab1950ea9$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $87dda735138d51c9$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) {
            (0, $87dda735138d51c9$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
            (0, $87dda735138d51c9$export$2e2bcd8739ae039).range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $6f34290e2d4459cf$export$2e2bcd8739ae039 = $6f34290e2d4459cf$var$integer;




const $89542d830f99c4e6$var$method = (rule, value, callback, source, options)=>{
    const errors = [];
    const validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $3ee57d6ab1950ea9$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $87dda735138d51c9$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) (0, $87dda735138d51c9$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $89542d830f99c4e6$export$2e2bcd8739ae039 = $89542d830f99c4e6$var$method;




const $c297f95702a72be0$var$number = (rule, value, callback, source, options)=>{
    const errors = [];
    const validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if (value === '') // eslint-disable-next-line no-param-reassign
        value = undefined;
        if ((0, $3ee57d6ab1950ea9$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $87dda735138d51c9$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) {
            (0, $87dda735138d51c9$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
            (0, $87dda735138d51c9$export$2e2bcd8739ae039).range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $c297f95702a72be0$export$2e2bcd8739ae039 = $c297f95702a72be0$var$number;




const $9f5bf961bf7ee63b$var$object = (rule, value, callback, source, options)=>{
    const errors = [];
    const validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $3ee57d6ab1950ea9$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $87dda735138d51c9$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) (0, $87dda735138d51c9$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $9f5bf961bf7ee63b$export$2e2bcd8739ae039 = $9f5bf961bf7ee63b$var$object;




const $1736d1f32617b626$var$pattern = (rule, value, callback, source, options)=>{
    const errors = [];
    const validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $3ee57d6ab1950ea9$export$141eca273a04dc3e)(value, 'string') && !rule.required) return callback();
        (0, $87dda735138d51c9$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (!(0, $3ee57d6ab1950ea9$export$141eca273a04dc3e)(value, 'string')) (0, $87dda735138d51c9$export$2e2bcd8739ae039).pattern(rule, value, source, errors, options);
    }
    callback(errors);
};
var $1736d1f32617b626$export$2e2bcd8739ae039 = $1736d1f32617b626$var$pattern;




const $9398dfaa97884dd3$var$regexp = (rule, value, callback, source, options)=>{
    const errors = [];
    const validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $3ee57d6ab1950ea9$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $87dda735138d51c9$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (!(0, $3ee57d6ab1950ea9$export$141eca273a04dc3e)(value)) (0, $87dda735138d51c9$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $9398dfaa97884dd3$export$2e2bcd8739ae039 = $9398dfaa97884dd3$var$regexp;



const $cc499037e3cf3a3b$var$required = (rule, value, callback, source, options)=>{
    const errors = [];
    const type = Array.isArray(value) ? 'array' : typeof value;
    (0, $87dda735138d51c9$export$2e2bcd8739ae039).required(rule, value, source, errors, options, type);
    callback(errors);
};
var $cc499037e3cf3a3b$export$2e2bcd8739ae039 = $cc499037e3cf3a3b$var$required;




const $a88dbef5d09ea1b5$var$string = (rule, value, callback, source, options)=>{
    const errors = [];
    const validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $3ee57d6ab1950ea9$export$141eca273a04dc3e)(value, 'string') && !rule.required) return callback();
        (0, $87dda735138d51c9$export$2e2bcd8739ae039).required(rule, value, source, errors, options, 'string');
        if (!(0, $3ee57d6ab1950ea9$export$141eca273a04dc3e)(value, 'string')) {
            (0, $87dda735138d51c9$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
            (0, $87dda735138d51c9$export$2e2bcd8739ae039).range(rule, value, source, errors, options);
            (0, $87dda735138d51c9$export$2e2bcd8739ae039).pattern(rule, value, source, errors, options);
            if (rule.whitespace === true) (0, $87dda735138d51c9$export$2e2bcd8739ae039).whitespace(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $a88dbef5d09ea1b5$export$2e2bcd8739ae039 = $a88dbef5d09ea1b5$var$string;




const $913fb598c2c07da4$var$type = (rule, value, callback, source, options)=>{
    const ruleType = rule.type;
    const errors = [];
    const validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $3ee57d6ab1950ea9$export$141eca273a04dc3e)(value, ruleType) && !rule.required) return callback();
        (0, $87dda735138d51c9$export$2e2bcd8739ae039).required(rule, value, source, errors, options, ruleType);
        if (!(0, $3ee57d6ab1950ea9$export$141eca273a04dc3e)(value, ruleType)) (0, $87dda735138d51c9$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $913fb598c2c07da4$export$2e2bcd8739ae039 = $913fb598c2c07da4$var$type;


var $1e4cf57dfe23aacd$export$2e2bcd8739ae039 = {
    string: $a88dbef5d09ea1b5$export$2e2bcd8739ae039,
    method: $89542d830f99c4e6$export$2e2bcd8739ae039,
    number: $c297f95702a72be0$export$2e2bcd8739ae039,
    boolean: $604f63074623a301$export$2e2bcd8739ae039,
    regexp: $9398dfaa97884dd3$export$2e2bcd8739ae039,
    integer: $6f34290e2d4459cf$export$2e2bcd8739ae039,
    float: $df969071ee497b17$export$2e2bcd8739ae039,
    array: $7dd3e9755676b90b$export$2e2bcd8739ae039,
    object: $9f5bf961bf7ee63b$export$2e2bcd8739ae039,
    enum: (0, $73f66904ca70aabb$export$2e2bcd8739ae039),
    pattern: $1736d1f32617b626$export$2e2bcd8739ae039,
    date: $febdc25fc2c33adc$export$2e2bcd8739ae039,
    url: (0, $913fb598c2c07da4$export$2e2bcd8739ae039),
    hex: (0, $913fb598c2c07da4$export$2e2bcd8739ae039),
    email: (0, $913fb598c2c07da4$export$2e2bcd8739ae039),
    tel: (0, $913fb598c2c07da4$export$2e2bcd8739ae039),
    required: $cc499037e3cf3a3b$export$2e2bcd8739ae039,
    any: $595861c369ee0d41$export$2e2bcd8739ae039
};




/**
 *  Encapsulates a validation schema.
 *
 *  @param descriptor An object declaring validation rules
 *  for this schema.
 */ class $565eff6657686fbe$var$Schema {
    // ========================= Static =========================
    static register = function register(type, validator) {
        if (typeof validator !== 'function') throw new Error('Cannot register a validator by type, validator is not a function');
        (0, $1e4cf57dfe23aacd$export$2e2bcd8739ae039)[type] = validator;
    };
    static warning = (0, $3ee57d6ab1950ea9$export$491112666e282270);
    static messages = (0, $a37acea3f5a2ba07$export$defe85febe8b728c);
    static validators = (0, $1e4cf57dfe23aacd$export$2e2bcd8739ae039);
    // ======================== Instance ========================
    rules = null;
    _messages = (0, $a37acea3f5a2ba07$export$defe85febe8b728c);
    constructor(descriptor){
        this.define(descriptor);
    }
    define(rules) {
        if (!rules) throw new Error('Cannot configure a schema with no rules');
        if (typeof rules !== 'object' || Array.isArray(rules)) throw new Error('Rules must be an object');
        this.rules = {};
        Object.keys(rules).forEach((name)=>{
            const item = rules[name];
            this.rules[name] = Array.isArray(item) ? item : [
                item
            ];
        });
    }
    messages(messages) {
        if (messages) this._messages = (0, $3ee57d6ab1950ea9$export$6969335ea1e4e77c)((0, $a37acea3f5a2ba07$export$f77fd0c3b25d8534)(), messages);
        return this._messages;
    }
    // eslint-disable-next-line @typescript-eslint/unified-signatures
    validate(source_, o = {}, oc = ()=>{}) {
        let source = source_;
        let options = o;
        let callback = oc;
        if (typeof options === 'function') {
            callback = options;
            options = {};
        }
        if (!this.rules || Object.keys(this.rules).length === 0) {
            if (callback) callback(null, source);
            return Promise.resolve(source);
        }
        function complete(results) {
            let errors = [];
            let fields = {};
            function add(e) {
                if (Array.isArray(e)) errors = errors.concat(...e);
                else errors.push(e);
            }
            for(let i = 0; i < results.length; i++)add(results[i]);
            if (!errors.length) callback(null, source);
            else {
                fields = (0, $3ee57d6ab1950ea9$export$e85887f5ceeacced)(errors);
                callback(errors, fields);
            }
        }
        if (options.messages) {
            let messages = this.messages();
            if (messages === (0, $a37acea3f5a2ba07$export$defe85febe8b728c)) messages = (0, $a37acea3f5a2ba07$export$f77fd0c3b25d8534)();
            (0, $3ee57d6ab1950ea9$export$6969335ea1e4e77c)(messages, options.messages);
            options.messages = messages;
        } else options.messages = this.messages();
        const series = {};
        const keys = options.keys || Object.keys(this.rules);
        keys.forEach((z)=>{
            const arr = this.rules[z];
            let value = source[z];
            arr.forEach((r)=>{
                let rule = r;
                if (typeof rule.transform === 'function') {
                    if (source === source_) source = {
                        ...source
                    };
                    value = source[z] = rule.transform(value);
                    if (value !== undefined && value !== null) rule.type = rule.type || (Array.isArray(value) ? 'array' : typeof value);
                }
                if (typeof rule === 'function') rule = {
                    validator: rule
                };
                else rule = {
                    ...rule
                };
                // Fill validator. Skip if nothing need to validate
                rule.validator = this.getValidationMethod(rule);
                if (!rule.validator) return;
                rule.field = z;
                rule.fullField = rule.fullField || z;
                rule.type = this.getType(rule);
                series[z] = series[z] || [];
                series[z].push({
                    rule: rule,
                    value: value,
                    source: source,
                    field: z
                });
            });
        });
        const errorFields = {};
        return (0, $3ee57d6ab1950ea9$export$707ee4c4c95d39e3)(series, options, (data, doIt)=>{
            const rule = data.rule;
            let deep = (rule.type === 'object' || rule.type === 'array') && (typeof rule.fields === 'object' || typeof rule.defaultField === 'object');
            deep = deep && (rule.required || !rule.required && data.value);
            rule.field = data.field;
            function addFullField(key, schema) {
                return {
                    ...schema,
                    fullField: `${rule.fullField}.${key}`,
                    fullFields: rule.fullFields ? [
                        ...rule.fullFields,
                        key
                    ] : [
                        key
                    ]
                };
            }
            function cb(e = []) {
                let errorList = Array.isArray(e) ? e : [
                    e
                ];
                if (!options.suppressWarning && errorList.length) $565eff6657686fbe$var$Schema.warning('async-validator:', errorList);
                if (errorList.length && rule.message !== undefined && rule.message !== null) errorList = [].concat(rule.message);
                // Fill error info
                let filledErrors = errorList.map((0, $3ee57d6ab1950ea9$export$34d5fe50d2616cee)(rule, source));
                if (options.first && filledErrors.length) {
                    errorFields[rule.field] = 1;
                    return doIt(filledErrors);
                }
                if (!deep) doIt(filledErrors);
                else {
                    // if rule is required but the target object
                    // does not exist fail at the rule level and don't
                    // go deeper
                    if (rule.required && !data.value) {
                        if (rule.message !== undefined) filledErrors = [].concat(rule.message).map((0, $3ee57d6ab1950ea9$export$34d5fe50d2616cee)(rule, source));
                        else if (options.error) filledErrors = [
                            options.error(rule, (0, $3ee57d6ab1950ea9$export$d9468344d3651243)(options.messages.required, rule.field))
                        ];
                        return doIt(filledErrors);
                    }
                    let fieldsSchema = {};
                    if (rule.defaultField) Object.keys(data.value).map((key)=>{
                        fieldsSchema[key] = rule.defaultField;
                    });
                    fieldsSchema = {
                        ...fieldsSchema,
                        ...data.rule.fields
                    };
                    const paredFieldsSchema = {};
                    Object.keys(fieldsSchema).forEach((field)=>{
                        const fieldSchema = fieldsSchema[field];
                        const fieldSchemaList = Array.isArray(fieldSchema) ? fieldSchema : [
                            fieldSchema
                        ];
                        paredFieldsSchema[field] = fieldSchemaList.map(addFullField.bind(null, field));
                    });
                    const schema = new $565eff6657686fbe$var$Schema(paredFieldsSchema);
                    schema.messages(options.messages);
                    if (data.rule.options) {
                        data.rule.options.messages = options.messages;
                        data.rule.options.error = options.error;
                    }
                    schema.validate(data.value, data.rule.options || options, (errs)=>{
                        const finalErrors = [];
                        if (filledErrors && filledErrors.length) finalErrors.push(...filledErrors);
                        if (errs && errs.length) finalErrors.push(...errs);
                        doIt(finalErrors.length ? finalErrors : null);
                    });
                }
            }
            let res;
            if (rule.asyncValidator) res = rule.asyncValidator(rule, data.value, cb, data.source, options);
            else if (rule.validator) {
                try {
                    res = rule.validator(rule, data.value, cb, data.source, options);
                } catch (error) {
                    console.error?.(error);
                    // rethrow to report error
                    if (!options.suppressValidatorError) setTimeout(()=>{
                        throw error;
                    }, 0);
                    cb(error.message);
                }
                if (res === true) cb();
                else if (res === false) cb(typeof rule.message === 'function' ? rule.message(rule.fullField || rule.field) : rule.message || `${rule.fullField || rule.field} fails`);
                else if (res instanceof Array) cb(res);
                else if (res instanceof Error) cb(res.message);
            }
            if (res && res.then) res.then(()=>cb(), (e)=>cb(e));
        }, (results)=>{
            complete(results);
        }, source);
    }
    getType(rule) {
        if (rule.type === undefined && rule.pattern instanceof RegExp) rule.type = 'pattern';
        if (typeof rule.validator !== 'function' && rule.type && !(0, $1e4cf57dfe23aacd$export$2e2bcd8739ae039).hasOwnProperty(rule.type)) throw new Error((0, $3ee57d6ab1950ea9$export$d9468344d3651243)('Unknown rule type %s', rule.type));
        return rule.type || 'string';
    }
    getValidationMethod(rule) {
        if (typeof rule.validator === 'function') return rule.validator;
        const keys = Object.keys(rule);
        const messageIndex = keys.indexOf('message');
        if (messageIndex !== -1) keys.splice(messageIndex, 1);
        if (keys.length === 1 && keys[0] === 'required') return (0, $1e4cf57dfe23aacd$export$2e2bcd8739ae039).required;
        return (0, $1e4cf57dfe23aacd$export$2e2bcd8739ae039)[this.getType(rule)] || undefined;
    }
}
var $565eff6657686fbe$export$2e2bcd8739ae039 = $565eff6657686fbe$var$Schema;



var $5E6i4 = parcelRequire("5E6i4");

const $a84d583b00e416f4$var$typeTemplate = "'${name}' is not a valid ${type}";
const $a84d583b00e416f4$export$c86b939816b8fbf8 = {
    default: "Validation error on field '${name}'",
    required: "'${name}' is required",
    enum: "'${name}' must be one of [${enum}]",
    whitespace: "'${name}' cannot be empty",
    date: {
        format: "'${name}' is invalid for format date",
        parse: "'${name}' could not be parsed as date",
        invalid: "'${name}' is invalid date"
    },
    types: {
        string: $a84d583b00e416f4$var$typeTemplate,
        method: $a84d583b00e416f4$var$typeTemplate,
        array: $a84d583b00e416f4$var$typeTemplate,
        object: $a84d583b00e416f4$var$typeTemplate,
        number: $a84d583b00e416f4$var$typeTemplate,
        date: $a84d583b00e416f4$var$typeTemplate,
        boolean: $a84d583b00e416f4$var$typeTemplate,
        integer: $a84d583b00e416f4$var$typeTemplate,
        float: $a84d583b00e416f4$var$typeTemplate,
        regexp: $a84d583b00e416f4$var$typeTemplate,
        email: $a84d583b00e416f4$var$typeTemplate,
        tel: $a84d583b00e416f4$var$typeTemplate,
        url: $a84d583b00e416f4$var$typeTemplate,
        hex: $a84d583b00e416f4$var$typeTemplate
    },
    string: {
        len: "'${name}' must be exactly ${len} characters",
        min: "'${name}' must be at least ${min} characters",
        max: "'${name}' cannot be longer than ${max} characters",
        range: "'${name}' must be between ${min} and ${max} characters"
    },
    number: {
        len: "'${name}' must equal ${len}",
        min: "'${name}' cannot be less than ${min}",
        max: "'${name}' cannot be greater than ${max}",
        range: "'${name}' must be between ${min} and ${max}"
    },
    array: {
        len: "'${name}' must be exactly ${len} in length",
        min: "'${name}' cannot be less than ${min} in length",
        max: "'${name}' cannot be greater than ${max} in length",
        range: "'${name}' must be between ${min} and ${max} in length"
    },
    pattern: {
        mismatch: "'${name}' does not match pattern ${pattern}"
    }
};


// Remove incorrect original ts define
const $d7656c601da1467d$var$AsyncValidator = (0, $565eff6657686fbe$export$2e2bcd8739ae039);
/**
 * Replace with template.
 *   `I'm ${name}` + { name: 'bamboo' } = I'm bamboo
 */ function $d7656c601da1467d$var$replaceMessage(template, kv) {
    return template.replace(/\\?\$\{\w+\}/g, (str)=>{
        if (str.startsWith('\\')) return str.slice(1);
        const key = str.slice(2, -1);
        return kv[key];
    });
}
const $d7656c601da1467d$var$CODE_LOGIC_ERROR = 'CODE_LOGIC_ERROR';
async function $d7656c601da1467d$var$validateRule(name, value, rule, options, messageVariables) {
    const cloneRule = {
        ...rule
    };
    // Bug of `async-validator`
    // https://github.com/react-component/field-form/issues/316
    // https://github.com/react-component/field-form/issues/313
    delete cloneRule.ruleIndex;
    // https://github.com/ant-design/ant-design/issues/40497#issuecomment-1422282378
    $d7656c601da1467d$var$AsyncValidator.warning = ()=>void 0;
    if (cloneRule.validator) {
        const originValidator = cloneRule.validator;
        cloneRule.validator = (...args)=>{
            try {
                return originValidator(...args);
            } catch (error) {
                console.error(error);
                return Promise.reject($d7656c601da1467d$var$CODE_LOGIC_ERROR);
            }
        };
    }
    // We should special handle array validate
    let subRuleField = null;
    if (cloneRule && cloneRule.type === 'array' && cloneRule.defaultField) {
        subRuleField = cloneRule.defaultField;
        delete cloneRule.defaultField;
    }
    const validator = new $d7656c601da1467d$var$AsyncValidator({
        [name]: [
            cloneRule
        ]
    });
    const messages = (0, $4eb3db67adf477c8$export$4950aa0f605343fb)((0, $a84d583b00e416f4$export$c86b939816b8fbf8), options.validateMessages);
    validator.messages(messages);
    let result = [];
    try {
        await Promise.resolve(validator.validate({
            [name]: value
        }, {
            ...options
        }));
    } catch (errObj) {
        if (errObj.errors) result = errObj.errors.map(({ message: message }, index)=>{
            const mergedMessage = message === $d7656c601da1467d$var$CODE_LOGIC_ERROR ? messages.default : message;
            return /*#__PURE__*/ $5E6i4.isValidElement(mergedMessage) ? /*#__PURE__*/ // Wrap ReactNode with `key`
            $5E6i4.cloneElement(mergedMessage, {
                key: `error_${index}`
            }) : mergedMessage;
        });
    }
    if (!result.length && subRuleField && Array.isArray(value) && value.length > 0) {
        const subResults = await Promise.all(value.map((subValue, i)=>$d7656c601da1467d$var$validateRule(`${name}.${i}`, subValue, subRuleField, options, messageVariables)));
        return subResults.reduce((prev, errors)=>[
                ...prev,
                ...errors
            ], []);
    }
    // Replace message with variables
    const kv = {
        ...rule,
        name: name,
        enum: (rule.enum || []).join(', '),
        ...messageVariables
    };
    const fillVariableResult = result.map((error)=>{
        if (typeof error === 'string') return $d7656c601da1467d$var$replaceMessage(error, kv);
        return error;
    });
    return fillVariableResult;
}
function $d7656c601da1467d$export$e1fc4b442d0297dd(namePath, value, rules, options, validateFirst, messageVariables) {
    const name = namePath.join('.');
    // Fill rule with context
    const filledRules = rules.map((currentRule, ruleIndex)=>{
        const originValidatorFunc = currentRule.validator;
        const cloneRule = {
            ...currentRule,
            ruleIndex: ruleIndex
        };
        // Replace validator if needed
        if (originValidatorFunc) cloneRule.validator = (rule, val, callback)=>{
            let hasPromise = false;
            // Wrap callback only accept when promise not provided
            const wrappedCallback = (...args)=>{
                // Wait a tick to make sure return type is a promise
                Promise.resolve().then(()=>{
                    (0, $f757b9ac02fa080d$export$2e2bcd8739ae039)(!hasPromise, 'Your validator function has already return a promise. `callback` will be ignored.');
                    if (!hasPromise) callback(...args);
                });
            };
            // Get promise
            const promise = originValidatorFunc(rule, val, wrappedCallback);
            hasPromise = promise && typeof promise.then === 'function' && typeof promise.catch === 'function';
            /**
         * 1. Use promise as the first priority.
         * 2. If promise not exist, use callback with warning instead
         */ (0, $f757b9ac02fa080d$export$2e2bcd8739ae039)(hasPromise, '`callback` is deprecated. Please return a promise instead.');
            if (hasPromise) promise.then(()=>{
                callback();
            }).catch((err)=>{
                callback(err || ' ');
            });
        };
        return cloneRule;
    }).sort(({ warningOnly: w1, ruleIndex: i1 }, { warningOnly: w2, ruleIndex: i2 })=>{
        if (!!w1 === !!w2) // Let keep origin order
        return i1 - i2;
        if (w1) return 1;
        return -1;
    });
    // Do validate rules
    let summaryPromise;
    if (validateFirst === true) // >>>>> Validate by serialization
    summaryPromise = new Promise(async (resolve, reject)=>{
        /* eslint-disable no-await-in-loop */ for(let i = 0; i < filledRules.length; i += 1){
            const rule = filledRules[i];
            const errors = await $d7656c601da1467d$var$validateRule(name, value, rule, options, messageVariables);
            if (errors.length) {
                reject([
                    {
                        errors: errors,
                        rule: rule
                    }
                ]);
                return;
            }
        }
        /* eslint-enable */ resolve([]);
    });
    else {
        // >>>>> Validate by parallel
        const rulePromises = filledRules.map((rule)=>$d7656c601da1467d$var$validateRule(name, value, rule, options, messageVariables).then((errors)=>({
                    errors: errors,
                    rule: rule
                })));
        summaryPromise = (validateFirst ? $d7656c601da1467d$var$finishOnFirstFailed(rulePromises) : $d7656c601da1467d$var$finishOnAllFailed(rulePromises)).then((errors)=>{
            // Always change to rejection for Field to catch
            return Promise.reject(errors);
        });
    }
    // Internal catch error to avoid console error log.
    summaryPromise.catch((e)=>e);
    return summaryPromise;
}
async function $d7656c601da1467d$var$finishOnAllFailed(rulePromises) {
    return Promise.all(rulePromises).then((errorsList)=>{
        const errors = [].concat(...errorsList);
        return errors;
    });
}
async function $d7656c601da1467d$var$finishOnFirstFailed(rulePromises) {
    let count = 0;
    return new Promise((resolve)=>{
        rulePromises.forEach((promise)=>{
            promise.then((ruleError)=>{
                if (ruleError.errors.length) resolve([
                    ruleError
                ]);
                count += 1;
                if (count === rulePromises.length) resolve([]);
            });
        });
    });
}




function $f4f7b0392d72085e$export$f877b3cb4cb4ccf9(path) {
    return (0, $58b11f9f2fc16504$export$45b10814cc054894)(path);
}
function $f4f7b0392d72085e$export$f5be6dfb30403c59(store, namePathList) {
    let newStore = {};
    namePathList.forEach((namePath)=>{
        const value = (0, $0dd37614b50139aa$export$2e2bcd8739ae039)(store, namePath);
        newStore = (0, $4eb3db67adf477c8$export$2e2bcd8739ae039)(newStore, namePath, value);
    });
    return newStore;
}
function $f4f7b0392d72085e$export$646d5504364ae55b(namePathList, namePath, partialMatch = false) {
    return namePathList && namePathList.some((path)=>$f4f7b0392d72085e$export$325a4bd0e71bdc3a(namePath, path, partialMatch));
}
function $f4f7b0392d72085e$export$325a4bd0e71bdc3a(namePath, subNamePath, partialMatch = false) {
    if (!namePath || !subNamePath) return false;
    if (!partialMatch && namePath.length !== subNamePath.length) return false;
    return subNamePath.every((nameUnit, i)=>namePath[i] === nameUnit);
}
function $f4f7b0392d72085e$export$dfcec05bb7372a54(source, target) {
    if (source === target) return true;
    if (!source && target || source && !target) return false;
    if (!source || !target || typeof source !== 'object' || typeof target !== 'object') return false;
    const sourceKeys = Object.keys(source);
    const targetKeys = Object.keys(target);
    const keys = new Set([
        ...sourceKeys,
        ...targetKeys
    ]);
    return [
        ...keys
    ].every((key)=>{
        const sourceValue = source[key];
        const targetValue = target[key];
        if (typeof sourceValue === 'function' && typeof targetValue === 'function') return true;
        return sourceValue === targetValue;
    });
}
function $f4f7b0392d72085e$export$6eeac3c5b406fb30(valuePropName, ...args) {
    const event = args[0];
    if (event && event.target && typeof event.target === 'object' && valuePropName in event.target) return event.target[valuePropName];
    return event;
}
function $f4f7b0392d72085e$export$d947e5f4f4c48d48(array, moveIndex, toIndex) {
    const { length: length } = array;
    if (moveIndex < 0 || moveIndex >= length || toIndex < 0 || toIndex >= length) return array;
    const item = array[moveIndex];
    const diff = moveIndex - toIndex;
    if (diff > 0) // move left
    return [
        ...array.slice(0, toIndex),
        item,
        ...array.slice(toIndex, moveIndex),
        ...array.slice(moveIndex + 1, length)
    ];
    if (diff < 0) // move right
    return [
        ...array.slice(0, moveIndex),
        ...array.slice(moveIndex + 1, toIndex + 1),
        item,
        ...array.slice(toIndex + 1, length)
    ];
    return array;
}



const $57a2072567c2ac68$export$f1309b2412c6fa89 = (fn)=>{
    const channel = new MessageChannel();
    channel.port1.onmessage = fn;
    channel.port2.postMessage(null);
};
class $57a2072567c2ac68$export$2e2bcd8739ae039 {
    namePathList = [];
    taskId = 0;
    watcherList = new Set();
    form;
    constructor(form){
        this.form = form;
    }
    register(callback) {
        this.watcherList.add(callback);
        return ()=>{
            this.watcherList.delete(callback);
        };
    }
    notify(namePath) {
        // Insert with deduplication
        namePath.forEach((path)=>{
            if (this.namePathList.every((exist)=>!(0, $f4f7b0392d72085e$export$325a4bd0e71bdc3a)(exist, path))) this.namePathList.push(path);
        });
        this.doBatch();
    }
    doBatch() {
        this.taskId += 1;
        const currentId = this.taskId;
        $57a2072567c2ac68$export$f1309b2412c6fa89(()=>{
            if (currentId === this.taskId && this.watcherList.size) {
                const formInst = this.form.getForm();
                const values = formInst.getFieldsValue();
                const allValues = formInst.getFieldsValue(true);
                this.watcherList.forEach((callback)=>{
                    callback(values, allValues, this.namePathList);
                });
                this.namePathList = [];
            }
        });
    }
}



async function $3637e26f84f689a5$export$2e2bcd8739ae039() {
    return new Promise((resolve)=>{
        (0, $57a2072567c2ac68$export$f1309b2412c6fa89)(()=>{
            (0, $1d949665862f071a$export$2e2bcd8739ae039)(()=>{
                resolve();
            });
        });
    });
}


function $a17e0c124d87e81c$var$_extends() {
    $a17e0c124d87e81c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a17e0c124d87e81c$var$_extends.apply(this, arguments);
}
const $a17e0c124d87e81c$var$EMPTY_ERRORS = [];
const $a17e0c124d87e81c$var$EMPTY_WARNINGS = [];
function $a17e0c124d87e81c$var$requireUpdate(shouldUpdate, prev, next, prevValue, nextValue, info) {
    if (typeof shouldUpdate === 'function') return shouldUpdate(prev, next, 'source' in info ? {
        source: info.source
    } : {});
    return prevValue !== nextValue;
}
// eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
// We use Class instead of Hooks here since it will cost much code by using Hooks.
class $a17e0c124d87e81c$var$Field extends $5E6i4.PureComponent {
    static contextType = (0, $4eb49d26951fd5b1$export$2e2bcd8739ae039);
    state = {
        resetCount: 0
    };
    cancelRegisterFunc = null;
    mounted = false;
    /**
   * Follow state should not management in State since it will async update by React.
   * This makes first render of form can not get correct state value.
   */ touched = false;
    /**
   * Mark when touched & validated. Currently only used for `dependencies`.
   * Note that we do not think field with `initialValue` is dirty
   * but this will be by `isFieldDirty` func.
   */ dirty = false;
    validatePromise;
    prevValidating;
    errors = $a17e0c124d87e81c$var$EMPTY_ERRORS;
    warnings = $a17e0c124d87e81c$var$EMPTY_WARNINGS;
    // ============================== Subscriptions ==============================
    constructor(props){
        super(props);
        // Register on init
        if (props.fieldContext) {
            const { getInternalHooks: getInternalHooks } = props.fieldContext;
            const { initEntityValue: initEntityValue } = getInternalHooks((0, $4eb49d26951fd5b1$export$24829b7c0e49e9f7));
            initEntityValue(this);
        }
    }
    componentDidMount() {
        const { shouldUpdate: shouldUpdate, fieldContext: fieldContext } = this.props;
        this.mounted = true;
        // Register on init
        if (fieldContext) {
            const { getInternalHooks: getInternalHooks } = fieldContext;
            const { registerField: registerField } = getInternalHooks((0, $4eb49d26951fd5b1$export$24829b7c0e49e9f7));
            this.cancelRegisterFunc = registerField(this);
        }
        // One more render for component in case fields not ready
        if (shouldUpdate === true) this.reRender();
    }
    componentWillUnmount() {
        this.cancelRegister();
        this.triggerMetaEvent(true);
        this.mounted = false;
    }
    cancelRegister = ()=>{
        const { preserve: preserve, isListField: isListField, name: name } = this.props;
        if (this.cancelRegisterFunc) this.cancelRegisterFunc(isListField, preserve, (0, $f4f7b0392d72085e$export$f877b3cb4cb4ccf9)(name));
        this.cancelRegisterFunc = null;
    };
    // ================================== Utils ==================================
    getNamePath = ()=>{
        const { name: name, fieldContext: fieldContext } = this.props;
        const { prefixName: prefixName = [] } = fieldContext;
        return name !== undefined ? [
            ...prefixName,
            ...name
        ] : [];
    };
    getRules = ()=>{
        const { rules: rules = [], fieldContext: fieldContext } = this.props;
        return rules.map((rule)=>{
            if (typeof rule === 'function') return rule(fieldContext);
            return rule;
        });
    };
    reRender() {
        if (!this.mounted) return;
        this.forceUpdate();
    }
    refresh = ()=>{
        if (!this.mounted) return;
        /**
     * Clean up current node.
     */ this.setState(({ resetCount: resetCount })=>({
                resetCount: resetCount + 1
            }));
    };
    // Event should only trigger when meta changed
    metaCache = null;
    triggerMetaEvent = (destroy)=>{
        const { onMetaChange: onMetaChange } = this.props;
        if (onMetaChange) {
            const meta = {
                ...this.getMeta(),
                destroy: destroy
            };
            if (!(0, $f9cb347037ae4280$export$2e2bcd8739ae039)(this.metaCache, meta)) onMetaChange(meta);
            this.metaCache = meta;
        } else this.metaCache = null;
    };
    // ========================= Field Entity Interfaces =========================
    // Trigger by store update. Check if need update the component
    onStoreChange = (prevStore, namePathList, info)=>{
        const { shouldUpdate: shouldUpdate, dependencies: dependencies = [], onReset: onReset } = this.props;
        const { store: store } = info;
        const namePath = this.getNamePath();
        const prevValue = this.getValue(prevStore);
        const curValue = this.getValue(store);
        const namePathMatch = namePathList && (0, $f4f7b0392d72085e$export$646d5504364ae55b)(namePathList, namePath);
        // `setFieldsValue` is a quick access to update related status
        if (info.type === 'valueUpdate' && info.source === 'external' && !(0, $f9cb347037ae4280$export$2e2bcd8739ae039)(prevValue, curValue)) {
            this.touched = true;
            this.dirty = true;
            this.validatePromise = null;
            this.errors = $a17e0c124d87e81c$var$EMPTY_ERRORS;
            this.warnings = $a17e0c124d87e81c$var$EMPTY_WARNINGS;
            this.triggerMetaEvent();
        }
        switch(info.type){
            case 'reset':
                if (!namePathList || namePathMatch) {
                    // Clean up state
                    this.touched = false;
                    this.dirty = false;
                    this.validatePromise = undefined;
                    this.errors = $a17e0c124d87e81c$var$EMPTY_ERRORS;
                    this.warnings = $a17e0c124d87e81c$var$EMPTY_WARNINGS;
                    this.triggerMetaEvent();
                    onReset?.();
                    this.refresh();
                    return;
                }
                break;
            /**
       * In case field with `preserve = false` nest deps like:
       * - A = 1 => show B
       * - B = 1 => show C
       * - Reset A, need clean B, C
       */ case 'remove':
                if (shouldUpdate && $a17e0c124d87e81c$var$requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
                    this.reRender();
                    return;
                }
                break;
            case 'setField':
                {
                    const { data: data } = info;
                    if (namePathMatch) {
                        if ('touched' in data) this.touched = data.touched;
                        if ('validating' in data && !('originRCField' in data)) this.validatePromise = data.validating ? Promise.resolve([]) : null;
                        if ('errors' in data) this.errors = data.errors || $a17e0c124d87e81c$var$EMPTY_ERRORS;
                        if ('warnings' in data) this.warnings = data.warnings || $a17e0c124d87e81c$var$EMPTY_WARNINGS;
                        this.dirty = true;
                        this.triggerMetaEvent();
                        this.reRender();
                        return;
                    } else if ('value' in data && (0, $f4f7b0392d72085e$export$646d5504364ae55b)(namePathList, namePath, true)) {
                        // Contains path with value should also check
                        this.reRender();
                        return;
                    }
                    // Handle update by `setField` with `shouldUpdate`
                    if (shouldUpdate && !namePath.length && $a17e0c124d87e81c$var$requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
                        this.reRender();
                        return;
                    }
                    break;
                }
            case 'dependenciesUpdate':
                {
                    /**
           * Trigger when marked `dependencies` updated. Related fields will all update
           */ const dependencyList = dependencies.map((0, $f4f7b0392d72085e$export$f877b3cb4cb4ccf9));
                    // No need for `namePathMath` check and `shouldUpdate` check, since `valueUpdate` will be
                    // emitted earlier and they will work there
                    // If set it may cause unnecessary twice rerendering
                    if (dependencyList.some((dependency)=>(0, $f4f7b0392d72085e$export$646d5504364ae55b)(info.relatedFields, dependency))) {
                        this.reRender();
                        return;
                    }
                    break;
                }
            default:
                // 1. If `namePath` exists in `namePathList`, means it's related value and should update
                //      For example <List name="list"><Field name={['list', 0]}></List>
                //      If `namePathList` is [['list']] (List value update), Field should be updated
                //      If `namePathList` is [['list', 0]] (Field value update), List shouldn't be updated
                // 2.
                //   2.1 If `dependencies` is set, `name` is not set and `shouldUpdate` is not set,
                //       don't use `shouldUpdate`. `dependencies` is view as a shortcut if `shouldUpdate`
                //       is not provided
                //   2.2 If `shouldUpdate` provided, use customize logic to update the field
                //       else to check if value changed
                if (namePathMatch || (!dependencies.length || namePath.length || shouldUpdate) && $a17e0c124d87e81c$var$requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
                    this.reRender();
                    return;
                }
                break;
        }
        if (shouldUpdate === true) this.reRender();
    };
    validateRules = (options)=>{
        // We should fixed namePath & value to avoid developer change then by form function
        const namePath = this.getNamePath();
        const currentValue = this.getValue();
        const { triggerName: triggerName, validateOnly: validateOnly = false, delayFrame: showDelayFrame } = options || {};
        // Force change to async to avoid rule OOD under renderProps field
        const rootPromise = Promise.resolve().then(async ()=>{
            if (!this.mounted) return [];
            const { validateFirst: validateFirst = false, messageVariables: messageVariables, validateDebounce: validateDebounce } = this.props;
            // Should wait for the frame render,
            // since developer may `useWatch` value in the rules.
            if (showDelayFrame) await (0, $3637e26f84f689a5$export$2e2bcd8739ae039)();
            // Start validate
            let filteredRules = this.getRules();
            if (triggerName) filteredRules = filteredRules.filter((rule)=>rule).filter((rule)=>{
                const { validateTrigger: validateTrigger } = rule;
                if (!validateTrigger) return true;
                const triggerList = (0, $58b11f9f2fc16504$export$45b10814cc054894)(validateTrigger);
                return triggerList.includes(triggerName);
            });
            // Wait for debounce. Skip if no `triggerName` since its from `validateFields / submit`
            if (validateDebounce && triggerName) {
                await new Promise((resolve)=>{
                    setTimeout(resolve, validateDebounce);
                });
                // Skip since out of date
                if (this.validatePromise !== rootPromise) return [];
            }
            const promise = (0, $d7656c601da1467d$export$e1fc4b442d0297dd)(namePath, currentValue, filteredRules, options, validateFirst, messageVariables);
            promise.catch((e)=>e).then((ruleErrors = $a17e0c124d87e81c$var$EMPTY_ERRORS)=>{
                if (this.validatePromise === rootPromise) {
                    this.validatePromise = null;
                    // Get errors & warnings
                    const nextErrors = [];
                    const nextWarnings = [];
                    ruleErrors.forEach?.(({ rule: { warningOnly: warningOnly }, errors: errors = $a17e0c124d87e81c$var$EMPTY_ERRORS })=>{
                        if (warningOnly) nextWarnings.push(...errors);
                        else nextErrors.push(...errors);
                    });
                    this.errors = nextErrors;
                    this.warnings = nextWarnings;
                    this.triggerMetaEvent();
                    this.reRender();
                }
            });
            return promise;
        });
        if (validateOnly) return rootPromise;
        this.validatePromise = rootPromise;
        this.dirty = true;
        this.errors = $a17e0c124d87e81c$var$EMPTY_ERRORS;
        this.warnings = $a17e0c124d87e81c$var$EMPTY_WARNINGS;
        this.triggerMetaEvent();
        // Force trigger re-render since we need sync renderProps with new meta
        this.reRender();
        return rootPromise;
    };
    isFieldValidating = ()=>!!this.validatePromise;
    isFieldTouched = ()=>this.touched;
    isFieldDirty = ()=>{
        // Touched or validate or has initialValue
        if (this.dirty || this.props.initialValue !== undefined) return true;
        // Form set initialValue
        const { fieldContext: fieldContext } = this.props;
        const { getInitialValue: getInitialValue } = fieldContext.getInternalHooks((0, $4eb49d26951fd5b1$export$24829b7c0e49e9f7));
        if (getInitialValue(this.getNamePath()) !== undefined) return true;
        return false;
    };
    getErrors = ()=>this.errors;
    getWarnings = ()=>this.warnings;
    isListField = ()=>this.props.isListField;
    isList = ()=>this.props.isList;
    isPreserve = ()=>this.props.preserve;
    // ============================= Child Component =============================
    getMeta = ()=>{
        // Make error & validating in cache to save perf
        this.prevValidating = this.isFieldValidating();
        const meta = {
            touched: this.isFieldTouched(),
            validating: this.prevValidating,
            errors: this.errors,
            warnings: this.warnings,
            name: this.getNamePath(),
            validated: this.validatePromise === null
        };
        return meta;
    };
    // Only return validate child node. If invalidate, will do nothing about field.
    getOnlyChild = (children)=>{
        // Support render props
        if (typeof children === 'function') {
            const meta = this.getMeta();
            return {
                ...this.getOnlyChild(children(this.getControlled(), meta, this.props.fieldContext)),
                isFunction: true
            };
        }
        // Filed element only
        const childList = (0, $2ec1a2166f2295ea$export$2e2bcd8739ae039)(children);
        if (childList.length !== 1 || !/*#__PURE__*/ $5E6i4.isValidElement(childList[0])) return {
            child: childList,
            isFunction: false
        };
        return {
            child: childList[0],
            isFunction: false
        };
    };
    // ============================== Field Control ==============================
    getValue = (store)=>{
        const { getFieldsValue: getFieldsValue } = this.props.fieldContext;
        const namePath = this.getNamePath();
        return (0, $0dd37614b50139aa$export$2e2bcd8739ae039)(store || getFieldsValue(true), namePath);
    };
    getControlled = (childProps = {})=>{
        const { name: name, trigger: trigger = 'onChange', validateTrigger: validateTrigger, getValueFromEvent: getValueFromEvent, normalize: normalize, valuePropName: valuePropName = 'value', getValueProps: getValueProps, fieldContext: fieldContext } = this.props;
        const mergedValidateTrigger = validateTrigger !== undefined ? validateTrigger : fieldContext.validateTrigger;
        const namePath = this.getNamePath();
        const { getInternalHooks: getInternalHooks, getFieldsValue: getFieldsValue } = fieldContext;
        const { dispatch: dispatch } = getInternalHooks((0, $4eb49d26951fd5b1$export$24829b7c0e49e9f7));
        const value = this.getValue();
        const mergedGetValueProps = getValueProps || ((val)=>({
                [valuePropName]: val
            }));
        const originTriggerFunc = childProps[trigger];
        const valueProps = name !== undefined ? mergedGetValueProps(value) : {};
        var key;
        const control = {
            ...childProps,
            ...valueProps
        };
        // Add trigger
        control[trigger] = (...args)=>{
            // Mark as touched
            this.touched = true;
            this.dirty = true;
            this.triggerMetaEvent();
            const curValue = this.getValue();
            let newValue;
            if (getValueFromEvent) newValue = getValueFromEvent(...args);
            else newValue = (0, $f4f7b0392d72085e$export$6eeac3c5b406fb30)(valuePropName, ...args);
            if (normalize) newValue = normalize(newValue, curValue, getFieldsValue(true));
            if (newValue !== curValue) dispatch({
                type: 'updateValue',
                namePath: namePath,
                value: newValue
            });
            if (originTriggerFunc) originTriggerFunc(...args);
        };
        // Add validateTrigger
        const validateTriggerList = (0, $58b11f9f2fc16504$export$45b10814cc054894)(mergedValidateTrigger || []);
        validateTriggerList.forEach((triggerName)=>{
            // Wrap additional function of component, so that we can get latest value from store
            const originTrigger = control[triggerName];
            control[triggerName] = (...args)=>{
                if (originTrigger) originTrigger(...args);
                // Always use latest rules
                const { rules: rules } = this.props;
                if (rules && rules.length) // We dispatch validate to root,
                // since it will update related data with other field with same name
                dispatch({
                    type: 'validateField',
                    namePath: namePath,
                    triggerName: triggerName
                });
            };
        });
        return control;
    };
    render() {
        const { resetCount: resetCount } = this.state;
        const { children: children } = this.props;
        const { child: child, isFunction: isFunction } = this.getOnlyChild(children);
        // Not need to `cloneElement` since user can handle this in render function self
        let returnChildNode;
        if (isFunction) returnChildNode = child;
        else if (/*#__PURE__*/ $5E6i4.isValidElement(child)) returnChildNode = /*#__PURE__*/ $5E6i4.cloneElement(child, this.getControlled(child.props));
        else {
            (0, $f757b9ac02fa080d$export$2e2bcd8739ae039)(!child, '`children` of Field is not validate ReactElement.');
            returnChildNode = child;
        }
        return /*#__PURE__*/ $5E6i4.createElement($5E6i4.Fragment, {
            key: resetCount
        }, returnChildNode);
    }
}
function $a17e0c124d87e81c$var$WrapperField({ name: name, ...restProps }) {
    const fieldContext = $5E6i4.useContext((0, $4eb49d26951fd5b1$export$2e2bcd8739ae039));
    const listContext = $5E6i4.useContext((0, $3befa91cc1f10543$export$2e2bcd8739ae039));
    const namePath = name !== undefined ? (0, $f4f7b0392d72085e$export$f877b3cb4cb4ccf9)(name) : undefined;
    const isMergedListField = restProps.isListField ?? !!listContext;
    let key = 'keep';
    if (!isMergedListField) key = `_${(namePath || []).join('_')}`;
    return /*#__PURE__*/ $5E6i4.createElement($a17e0c124d87e81c$var$Field, $a17e0c124d87e81c$var$_extends({
        key: key,
        name: namePath,
        isListField: isMergedListField
    }, restProps, {
        fieldContext: fieldContext
    }));
}
var $a17e0c124d87e81c$export$2e2bcd8739ae039 = $a17e0c124d87e81c$var$WrapperField;



var $5E6i4 = parcelRequire("5E6i4");





function $5564230e782827e0$var$List({ name: name, initialValue: initialValue, children: children, rules: rules, validateTrigger: validateTrigger, isListField: isListField }) {
    const context = $5E6i4.useContext((0, $4eb49d26951fd5b1$export$2e2bcd8739ae039));
    const wrapperListContext = $5E6i4.useContext((0, $3befa91cc1f10543$export$2e2bcd8739ae039));
    const keyRef = $5E6i4.useRef({
        keys: [],
        id: 0
    });
    const keyManager = keyRef.current;
    const prefixName = $5E6i4.useMemo(()=>{
        const parentPrefixName = (0, $f4f7b0392d72085e$export$f877b3cb4cb4ccf9)(context.prefixName) || [];
        return [
            ...parentPrefixName,
            ...(0, $f4f7b0392d72085e$export$f877b3cb4cb4ccf9)(name)
        ];
    }, [
        context.prefixName,
        name
    ]);
    const fieldContext = $5E6i4.useMemo(()=>({
            ...context,
            prefixName: prefixName
        }), [
        context,
        prefixName
    ]);
    // List context
    const listContext = $5E6i4.useMemo(()=>({
            getKey: (namePath)=>{
                const len = prefixName.length;
                const pathName = namePath[len];
                return [
                    keyManager.keys[pathName],
                    namePath.slice(len + 1)
                ];
            }
        }), [
        keyManager,
        prefixName
    ]);
    // User should not pass `children` as other type.
    if (typeof children !== 'function') {
        (0, $f757b9ac02fa080d$export$2e2bcd8739ae039)(false, 'Form.List only accepts function as children.');
        return null;
    }
    const shouldUpdate = (prevValue, nextValue, { source: source })=>{
        if (source === 'internal') return false;
        return prevValue !== nextValue;
    };
    return /*#__PURE__*/ $5E6i4.createElement((0, $3befa91cc1f10543$export$2e2bcd8739ae039).Provider, {
        value: listContext
    }, /*#__PURE__*/ $5E6i4.createElement((0, $4eb49d26951fd5b1$export$2e2bcd8739ae039).Provider, {
        value: fieldContext
    }, /*#__PURE__*/ $5E6i4.createElement((0, $a17e0c124d87e81c$export$2e2bcd8739ae039), {
        name: [],
        shouldUpdate: shouldUpdate,
        rules: rules,
        validateTrigger: validateTrigger,
        initialValue: initialValue,
        isList: true,
        isListField: isListField ?? !!wrapperListContext
    }, ({ value: value = [], onChange: onChange }, meta)=>{
        const { getFieldValue: getFieldValue } = context;
        const getNewValue = ()=>{
            const values = getFieldValue(prefixName || []);
            return values || [];
        };
        /**
     * Always get latest value in case user update fields by `form` api.
     */ const operations = {
            add: (defaultValue, index)=>{
                // Mapping keys
                const newValue = getNewValue();
                if (index >= 0 && index <= newValue.length) {
                    keyManager.keys = [
                        ...keyManager.keys.slice(0, index),
                        keyManager.id,
                        ...keyManager.keys.slice(index)
                    ];
                    onChange([
                        ...newValue.slice(0, index),
                        defaultValue,
                        ...newValue.slice(index)
                    ]);
                } else {
                    keyManager.keys = [
                        ...keyManager.keys,
                        keyManager.id
                    ];
                    onChange([
                        ...newValue,
                        defaultValue
                    ]);
                }
                keyManager.id += 1;
            },
            remove: (index)=>{
                const newValue = getNewValue();
                const indexSet = new Set(Array.isArray(index) ? index : [
                    index
                ]);
                if (indexSet.size <= 0) return;
                keyManager.keys = keyManager.keys.filter((_, keysIndex)=>!indexSet.has(keysIndex));
                // Trigger store change
                onChange(newValue.filter((_, valueIndex)=>!indexSet.has(valueIndex)));
            },
            move (from, to) {
                if (from === to) return;
                const newValue = getNewValue();
                // Do not handle out of range
                if (from < 0 || from >= newValue.length || to < 0 || to >= newValue.length) return;
                keyManager.keys = (0, $f4f7b0392d72085e$export$d947e5f4f4c48d48)(keyManager.keys, from, to);
                // Trigger store change
                onChange((0, $f4f7b0392d72085e$export$d947e5f4f4c48d48)(newValue, from, to));
            }
        };
        let listValue = value || [];
        if (!Array.isArray(listValue)) listValue = [];
        return children(listValue.map((__, index)=>{
            let key = keyManager.keys[index];
            if (key === undefined) {
                keyManager.keys[index] = keyManager.id;
                key = keyManager.keys[index];
                keyManager.id += 1;
            }
            return {
                name: index,
                key: key,
                isListField: true
            };
        }), operations, meta);
    })));
}
var $5564230e782827e0$export$2e2bcd8739ae039 = $5564230e782827e0$var$List;




var $5E6i4 = parcelRequire("5E6i4");

function $20b9222429017483$export$6152adfdcc6be2b5(promiseList) {
    let hasError = false;
    let count = promiseList.length;
    const results = [];
    if (!promiseList.length) return Promise.resolve([]);
    return new Promise((resolve, reject)=>{
        promiseList.forEach((promise, index)=>{
            promise.catch((e)=>{
                hasError = true;
                return e;
            }).then((result)=>{
                count -= 1;
                results[index] = result;
                if (count > 0) return;
                if (hasError) reject(results);
                resolve(results);
            });
        });
    });
}



const $688545f1363ddf5f$var$SPLIT = '__@field_split__';
/**
 * Convert name path into string to fast the fetch speed of Map.
 */ function $688545f1363ddf5f$var$normalize(namePath) {
    return namePath.map((cell)=>`${typeof cell}:${cell}`)// Magic split
    .join($688545f1363ddf5f$var$SPLIT);
}
/**
 * NameMap like a `Map` but accepts `string[]` as key.
 */ class $688545f1363ddf5f$var$NameMap {
    kvs = new Map();
    set(key, value) {
        this.kvs.set($688545f1363ddf5f$var$normalize(key), value);
    }
    get(key) {
        return this.kvs.get($688545f1363ddf5f$var$normalize(key));
    }
    getAsPrefix(key) {
        const normalizedKey = $688545f1363ddf5f$var$normalize(key);
        const normalizedPrefix = normalizedKey + $688545f1363ddf5f$var$SPLIT;
        const results = [];
        const current = this.kvs.get(normalizedKey);
        if (current !== undefined) results.push(current);
        this.kvs.forEach((value, itemNormalizedKey)=>{
            if (itemNormalizedKey.startsWith(normalizedPrefix)) results.push(value);
        });
        return results;
    }
    update(key, updater) {
        const origin = this.get(key);
        const next = updater(origin);
        if (!next) this.delete(key);
        else this.set(key, next);
    }
    delete(key) {
        this.kvs.delete($688545f1363ddf5f$var$normalize(key));
    }
    // Since we only use this in test, let simply realize this
    map(callback) {
        return [
            ...this.kvs.entries()
        ].map(([key, value])=>{
            const cells = key.split($688545f1363ddf5f$var$SPLIT);
            return callback({
                key: cells.map((cell)=>{
                    const [, type, unit] = cell.match(/^([^:]*):(.*)$/);
                    return type === 'number' ? Number(unit) : unit;
                }),
                value: value
            });
        });
    }
    toJSON() {
        const json = {};
        this.map(({ key: key, value: value })=>{
            json[key.join('.')] = value;
            return null;
        });
        return json;
    }
}
var $688545f1363ddf5f$export$2e2bcd8739ae039 = $688545f1363ddf5f$var$NameMap;




class $371286eaaac67666$export$75ff1ab1187e691 {
    formHooked = false;
    forceRootUpdate;
    subscribable = true;
    store = {};
    fieldEntities = [];
    initialValues = {};
    callbacks = {};
    validateMessages = null;
    preserve = null;
    lastValidatePromise = null;
    watcherCenter = new (0, $57a2072567c2ac68$export$2e2bcd8739ae039)(this);
    constructor(forceRootUpdate){
        this.forceRootUpdate = forceRootUpdate;
    }
    getForm = ()=>({
            getFieldValue: this.getFieldValue,
            getFieldsValue: this.getFieldsValue,
            getFieldError: this.getFieldError,
            getFieldWarning: this.getFieldWarning,
            getFieldsError: this.getFieldsError,
            isFieldsTouched: this.isFieldsTouched,
            isFieldTouched: this.isFieldTouched,
            isFieldValidating: this.isFieldValidating,
            isFieldsValidating: this.isFieldsValidating,
            resetFields: this.resetFields,
            setFields: this.setFields,
            setFieldValue: this.setFieldValue,
            setFieldsValue: this.setFieldsValue,
            validateFields: this.validateFields,
            submit: this.submit,
            _init: true,
            getInternalHooks: this.getInternalHooks
        });
    // ======================== Internal Hooks ========================
    getInternalHooks = (key)=>{
        if (key === (0, $4eb49d26951fd5b1$export$24829b7c0e49e9f7)) {
            this.formHooked = true;
            return {
                dispatch: this.dispatch,
                initEntityValue: this.initEntityValue,
                registerField: this.registerField,
                useSubscribe: this.useSubscribe,
                setInitialValues: this.setInitialValues,
                destroyForm: this.destroyForm,
                setCallbacks: this.setCallbacks,
                setValidateMessages: this.setValidateMessages,
                getFields: this.getFields,
                setPreserve: this.setPreserve,
                getInitialValue: this.getInitialValue,
                registerWatch: this.registerWatch
            };
        }
        (0, $f757b9ac02fa080d$export$2e2bcd8739ae039)(false, '`getInternalHooks` is internal usage. Should not call directly.');
        return null;
    };
    useSubscribe = (subscribable)=>{
        this.subscribable = subscribable;
    };
    /**
   * Record prev Form unmount fieldEntities which config preserve false.
   * This need to be refill with initialValues instead of store value.
   */ prevWithoutPreserves = null;
    /**
   * First time `setInitialValues` should update store with initial value
   */ setInitialValues = (initialValues, init)=>{
        this.initialValues = initialValues || {};
        if (init) {
            let nextStore = (0, $4eb3db67adf477c8$export$4950aa0f605343fb)(initialValues, this.store);
            // We will take consider prev form unmount fields.
            // When the field is not `preserve`, we need fill this with initialValues instead of store.
            // eslint-disable-next-line array-callback-return
            this.prevWithoutPreserves?.map(({ key: namePath })=>{
                nextStore = (0, $4eb3db67adf477c8$export$2e2bcd8739ae039)(nextStore, namePath, (0, $0dd37614b50139aa$export$2e2bcd8739ae039)(initialValues, namePath));
            });
            this.prevWithoutPreserves = null;
            this.updateStore(nextStore);
        }
    };
    destroyForm = (clearOnDestroy)=>{
        if (clearOnDestroy) // destroy form reset store
        this.updateStore({});
        else {
            // Fill preserve fields
            const prevWithoutPreserves = new (0, $688545f1363ddf5f$export$2e2bcd8739ae039)();
            this.getFieldEntities(true).forEach((entity)=>{
                if (!this.isMergedPreserve(entity.isPreserve())) prevWithoutPreserves.set(entity.getNamePath(), true);
            });
            this.prevWithoutPreserves = prevWithoutPreserves;
        }
    };
    getInitialValue = (namePath)=>{
        const initValue = (0, $0dd37614b50139aa$export$2e2bcd8739ae039)(this.initialValues, namePath);
        // Not cloneDeep when without `namePath`
        return namePath.length ? (0, $4eb3db67adf477c8$export$4950aa0f605343fb)(initValue) : initValue;
    };
    setCallbacks = (callbacks)=>{
        this.callbacks = callbacks;
    };
    setValidateMessages = (validateMessages)=>{
        this.validateMessages = validateMessages;
    };
    setPreserve = (preserve)=>{
        this.preserve = preserve;
    };
    // ============================= Watch ============================
    registerWatch = (callback)=>{
        return this.watcherCenter.register(callback);
    };
    notifyWatch = (namePath = [])=>{
        this.watcherCenter.notify(namePath);
    };
    // ========================== Dev Warning =========================
    timeoutId = null;
    warningUnhooked = ()=>{};
    // ============================ Store =============================
    updateStore = (nextStore)=>{
        this.store = nextStore;
    };
    // ============================ Fields ============================
    /**
   * Get registered field entities.
   * @param pure Only return field which has a `name`. Default: false
   */ getFieldEntities = (pure = false)=>{
        if (!pure) return this.fieldEntities;
        return this.fieldEntities.filter((field)=>field.getNamePath().length);
    };
    /**
   * Get a map of registered field entities with their name path as the key.
   * @param pure Only include fields which have a `name`. Default: false
   * @returns A NameMap containing field entities indexed by their name paths
   */ getFieldsMap = (pure = false)=>{
        const cache = new (0, $688545f1363ddf5f$export$2e2bcd8739ae039)();
        this.getFieldEntities(pure).forEach((field)=>{
            const namePath = field.getNamePath();
            cache.set(namePath, field);
        });
        return cache;
    };
    /**
   * Get field entities based on a list of name paths.
   * @param nameList - Array of name paths to search for. If not provided, returns all field entities with names.
   * @param includesSubNamePath - Whether to include fields that have the given name path as a prefix.
   */ getFieldEntitiesForNamePathList = (nameList, includesSubNamePath = false)=>{
        if (!nameList) return this.getFieldEntities(true);
        const cache = this.getFieldsMap(true);
        if (!includesSubNamePath) return nameList.map((name)=>{
            const namePath = (0, $f4f7b0392d72085e$export$f877b3cb4cb4ccf9)(name);
            return cache.get(namePath) || {
                INVALIDATE_NAME_PATH: (0, $f4f7b0392d72085e$export$f877b3cb4cb4ccf9)(name)
            };
        });
        return nameList.flatMap((name)=>{
            const namePath = (0, $f4f7b0392d72085e$export$f877b3cb4cb4ccf9)(name);
            const fields = cache.getAsPrefix(namePath);
            if (fields.length) return fields;
            return [
                {
                    INVALIDATE_NAME_PATH: namePath
                }
            ];
        });
    };
    getFieldsValue = (nameList, filterFunc)=>{
        this.warningUnhooked();
        // Fill args
        let mergedNameList;
        let mergedFilterFunc;
        if (nameList === true || Array.isArray(nameList)) {
            mergedNameList = nameList;
            mergedFilterFunc = filterFunc;
        } else if (nameList && typeof nameList === 'object') mergedFilterFunc = nameList.filter;
        if (mergedNameList === true && !mergedFilterFunc) return this.store;
        const fieldEntities = this.getFieldEntitiesForNamePathList(Array.isArray(mergedNameList) ? mergedNameList : null, true);
        const filteredNameList = [];
        const listNamePaths = [];
        fieldEntities.forEach((entity)=>{
            const namePath = entity.INVALIDATE_NAME_PATH || entity.getNamePath();
            // Ignore when it's a list item and not specific the namePath,
            // since parent field is already take in count
            if (entity.isList?.()) {
                listNamePaths.push(namePath);
                return;
            }
            if (!mergedFilterFunc) filteredNameList.push(namePath);
            else {
                const meta = 'getMeta' in entity ? entity.getMeta() : null;
                if (mergedFilterFunc(meta)) filteredNameList.push(namePath);
            }
        });
        let mergedValues = (0, $f4f7b0392d72085e$export$f5be6dfb30403c59)(this.store, filteredNameList.map((0, $f4f7b0392d72085e$export$f877b3cb4cb4ccf9)));
        // We need fill the list as [] if Form.List is empty
        listNamePaths.forEach((namePath)=>{
            if (!(0, $0dd37614b50139aa$export$2e2bcd8739ae039)(mergedValues, namePath)) mergedValues = (0, $4eb3db67adf477c8$export$2e2bcd8739ae039)(mergedValues, namePath, []);
        });
        return mergedValues;
    };
    getFieldValue = (name)=>{
        this.warningUnhooked();
        const namePath = (0, $f4f7b0392d72085e$export$f877b3cb4cb4ccf9)(name);
        return (0, $0dd37614b50139aa$export$2e2bcd8739ae039)(this.store, namePath);
    };
    getFieldsError = (nameList)=>{
        this.warningUnhooked();
        const fieldEntities = this.getFieldEntitiesForNamePathList(nameList);
        return fieldEntities.map((entity, index)=>{
            if (entity && !entity.INVALIDATE_NAME_PATH) return {
                name: entity.getNamePath(),
                errors: entity.getErrors(),
                warnings: entity.getWarnings()
            };
            return {
                name: (0, $f4f7b0392d72085e$export$f877b3cb4cb4ccf9)(nameList[index]),
                errors: [],
                warnings: []
            };
        });
    };
    getFieldError = (name)=>{
        this.warningUnhooked();
        const namePath = (0, $f4f7b0392d72085e$export$f877b3cb4cb4ccf9)(name);
        const fieldError = this.getFieldsError([
            namePath
        ])[0];
        return fieldError.errors;
    };
    getFieldWarning = (name)=>{
        this.warningUnhooked();
        const namePath = (0, $f4f7b0392d72085e$export$f877b3cb4cb4ccf9)(name);
        const fieldError = this.getFieldsError([
            namePath
        ])[0];
        return fieldError.warnings;
    };
    isFieldsTouched = (...args)=>{
        this.warningUnhooked();
        const [arg0, arg1] = args;
        let namePathList;
        let isAllFieldsTouched = false;
        if (args.length === 0) namePathList = null;
        else if (args.length === 1) {
            if (Array.isArray(arg0)) {
                namePathList = arg0.map((0, $f4f7b0392d72085e$export$f877b3cb4cb4ccf9));
                isAllFieldsTouched = false;
            } else {
                namePathList = null;
                isAllFieldsTouched = arg0;
            }
        } else {
            namePathList = arg0.map((0, $f4f7b0392d72085e$export$f877b3cb4cb4ccf9));
            isAllFieldsTouched = arg1;
        }
        const fieldEntities = this.getFieldEntities(true);
        const isFieldTouched = (field)=>field.isFieldTouched();
        // ===== Will get fully compare when not config namePathList =====
        if (!namePathList) return isAllFieldsTouched ? fieldEntities.every((entity)=>isFieldTouched(entity) || entity.isList()) : fieldEntities.some(isFieldTouched);
        // Generate a nest tree for validate
        const map = new (0, $688545f1363ddf5f$export$2e2bcd8739ae039)();
        namePathList.forEach((shortNamePath)=>{
            map.set(shortNamePath, []);
        });
        fieldEntities.forEach((field)=>{
            const fieldNamePath = field.getNamePath();
            // Find matched entity and put into list
            namePathList.forEach((shortNamePath)=>{
                if (shortNamePath.every((nameUnit, i)=>fieldNamePath[i] === nameUnit)) map.update(shortNamePath, (list)=>[
                        ...list,
                        field
                    ]);
            });
        });
        // Check if NameMap value is touched
        const isNamePathListTouched = (entities)=>entities.some(isFieldTouched);
        const namePathListEntities = map.map(({ value: value })=>value);
        return isAllFieldsTouched ? namePathListEntities.every(isNamePathListTouched) : namePathListEntities.some(isNamePathListTouched);
    };
    isFieldTouched = (name)=>{
        this.warningUnhooked();
        return this.isFieldsTouched([
            name
        ]);
    };
    isFieldsValidating = (nameList)=>{
        this.warningUnhooked();
        const fieldEntities = this.getFieldEntities();
        if (!nameList) return fieldEntities.some((testField)=>testField.isFieldValidating());
        const namePathList = nameList.map((0, $f4f7b0392d72085e$export$f877b3cb4cb4ccf9));
        return fieldEntities.some((testField)=>{
            const fieldNamePath = testField.getNamePath();
            return (0, $f4f7b0392d72085e$export$646d5504364ae55b)(namePathList, fieldNamePath) && testField.isFieldValidating();
        });
    };
    isFieldValidating = (name)=>{
        this.warningUnhooked();
        return this.isFieldsValidating([
            name
        ]);
    };
    /**
   * Reset Field with field `initialValue` prop.
   * Can pass `entities` or `namePathList` or just nothing.
   */ resetWithFieldInitialValue = (info = {})=>{
        // Create cache
        const cache = new (0, $688545f1363ddf5f$export$2e2bcd8739ae039)();
        const fieldEntities = this.getFieldEntities(true);
        fieldEntities.forEach((field)=>{
            const { initialValue: initialValue } = field.props;
            const namePath = field.getNamePath();
            // Record only if has `initialValue`
            if (initialValue !== undefined) {
                const records = cache.get(namePath) || new Set();
                records.add({
                    entity: field,
                    value: initialValue
                });
                cache.set(namePath, records);
            }
        });
        // Reset
        const resetWithFields = (entities)=>{
            entities.forEach((field)=>{
                const { initialValue: initialValue } = field.props;
                if (initialValue !== undefined) {
                    const namePath = field.getNamePath();
                    const formInitialValue = this.getInitialValue(namePath);
                    if (formInitialValue !== undefined) // Warning if conflict with form initialValues and do not modify value
                    (0, $f757b9ac02fa080d$export$2e2bcd8739ae039)(false, `Form already set 'initialValues' with path '${namePath.join('.')}'. Field can not overwrite it.`);
                    else {
                        const records = cache.get(namePath);
                        if (records && records.size > 1) // Warning if multiple field set `initialValue`and do not modify value
                        (0, $f757b9ac02fa080d$export$2e2bcd8739ae039)(false, `Multiple Field with path '${namePath.join('.')}' set 'initialValue'. Can not decide which one to pick.`);
                        else if (records) {
                            const originValue = this.getFieldValue(namePath);
                            const isListField = field.isListField();
                            // Set `initialValue`
                            if (!isListField && (!info.skipExist || originValue === undefined)) this.updateStore((0, $4eb3db67adf477c8$export$2e2bcd8739ae039)(this.store, namePath, [
                                ...records
                            ][0].value));
                        }
                    }
                }
            });
        };
        let requiredFieldEntities;
        if (info.entities) requiredFieldEntities = info.entities;
        else if (info.namePathList) {
            requiredFieldEntities = [];
            info.namePathList.forEach((namePath)=>{
                const records = cache.get(namePath);
                if (records) requiredFieldEntities.push(...[
                    ...records
                ].map((r)=>r.entity));
            });
        } else requiredFieldEntities = fieldEntities;
        resetWithFields(requiredFieldEntities);
    };
    resetFields = (nameList)=>{
        this.warningUnhooked();
        const prevStore = this.store;
        if (!nameList) {
            this.updateStore((0, $4eb3db67adf477c8$export$4950aa0f605343fb)(this.initialValues));
            this.resetWithFieldInitialValue();
            this.notifyObservers(prevStore, null, {
                type: 'reset'
            });
            this.notifyWatch();
            return;
        }
        // Reset by `nameList`
        const namePathList = nameList.map((0, $f4f7b0392d72085e$export$f877b3cb4cb4ccf9));
        namePathList.forEach((namePath)=>{
            const initialValue = this.getInitialValue(namePath);
            this.updateStore((0, $4eb3db67adf477c8$export$2e2bcd8739ae039)(this.store, namePath, initialValue));
        });
        this.resetWithFieldInitialValue({
            namePathList: namePathList
        });
        this.notifyObservers(prevStore, namePathList, {
            type: 'reset'
        });
        this.notifyWatch(namePathList);
    };
    setFields = (fields)=>{
        this.warningUnhooked();
        const prevStore = this.store;
        const namePathList = [];
        fields.forEach((fieldData)=>{
            const { name: name, ...data } = fieldData;
            const namePath = (0, $f4f7b0392d72085e$export$f877b3cb4cb4ccf9)(name);
            namePathList.push(namePath);
            // Value
            if ('value' in data) this.updateStore((0, $4eb3db67adf477c8$export$2e2bcd8739ae039)(this.store, namePath, data.value));
            this.notifyObservers(prevStore, [
                namePath
            ], {
                type: 'setField',
                data: fieldData
            });
        });
        this.notifyWatch(namePathList);
    };
    getFields = ()=>{
        const entities = this.getFieldEntities(true);
        const fields = entities.map((field)=>{
            const namePath = field.getNamePath();
            const meta = field.getMeta();
            const fieldData = {
                ...meta,
                name: namePath,
                value: this.getFieldValue(namePath)
            };
            Object.defineProperty(fieldData, 'originRCField', {
                value: true
            });
            return fieldData;
        });
        return fields;
    };
    // =========================== Observer ===========================
    /**
   * This only trigger when a field is on constructor to avoid we get initialValue too late
   */ initEntityValue = (entity)=>{
        const { initialValue: initialValue } = entity.props;
        if (initialValue !== undefined) {
            const namePath = entity.getNamePath();
            const prevValue = (0, $0dd37614b50139aa$export$2e2bcd8739ae039)(this.store, namePath);
            if (prevValue === undefined) this.updateStore((0, $4eb3db67adf477c8$export$2e2bcd8739ae039)(this.store, namePath, initialValue));
        }
    };
    isMergedPreserve = (fieldPreserve)=>{
        const mergedPreserve = fieldPreserve !== undefined ? fieldPreserve : this.preserve;
        return mergedPreserve ?? true;
    };
    registerField = (entity)=>{
        this.fieldEntities.push(entity);
        const namePath = entity.getNamePath();
        this.notifyWatch([
            namePath
        ]);
        // Set initial values
        if (entity.props.initialValue !== undefined) {
            const prevStore = this.store;
            this.resetWithFieldInitialValue({
                entities: [
                    entity
                ],
                skipExist: true
            });
            this.notifyObservers(prevStore, [
                entity.getNamePath()
            ], {
                type: 'valueUpdate',
                source: 'internal'
            });
        }
        // un-register field callback
        return (isListField, preserve, subNamePath = [])=>{
            this.fieldEntities = this.fieldEntities.filter((item)=>item !== entity);
            // Clean up store value if not preserve
            if (!this.isMergedPreserve(preserve) && (!isListField || subNamePath.length > 1)) {
                const defaultValue = isListField ? undefined : this.getInitialValue(namePath);
                if (namePath.length && this.getFieldValue(namePath) !== defaultValue && this.fieldEntities.every((field)=>// Only reset when no namePath exist
                    !(0, $f4f7b0392d72085e$export$325a4bd0e71bdc3a)(field.getNamePath(), namePath))) {
                    const prevStore = this.store;
                    this.updateStore((0, $4eb3db67adf477c8$export$2e2bcd8739ae039)(prevStore, namePath, defaultValue, true));
                    // Notify that field is unmount
                    this.notifyObservers(prevStore, [
                        namePath
                    ], {
                        type: 'remove'
                    });
                    // Dependencies update
                    this.triggerDependenciesUpdate(prevStore, namePath);
                }
            }
            this.notifyWatch([
                namePath
            ]);
        };
    };
    dispatch = (action)=>{
        switch(action.type){
            case 'updateValue':
                {
                    const { namePath: namePath, value: value } = action;
                    this.updateValue(namePath, value);
                    break;
                }
            case 'validateField':
                {
                    const { namePath: namePath, triggerName: triggerName } = action;
                    this.validateFields([
                        namePath
                    ], {
                        triggerName: triggerName
                    });
                    break;
                }
            default:
        }
    };
    notifyObservers = (prevStore, namePathList, info)=>{
        if (this.subscribable) {
            const mergedInfo = {
                ...info,
                store: this.getFieldsValue(true)
            };
            this.getFieldEntities().forEach(({ onStoreChange: onStoreChange })=>{
                onStoreChange(prevStore, namePathList, mergedInfo);
            });
        } else this.forceRootUpdate();
    };
    /**
   * Notify dependencies children with parent update
   * We need delay to trigger validate in case Field is under render props
   */ triggerDependenciesUpdate = (prevStore, namePath)=>{
        const childrenFields = this.getDependencyChildrenFields(namePath);
        if (childrenFields.length) this.validateFields(childrenFields, {
            // Delay to avoid `useWatch` dynamic adjust rules that deps not get latest one
            delayFrame: true
        });
        this.notifyObservers(prevStore, childrenFields, {
            type: 'dependenciesUpdate',
            relatedFields: [
                namePath,
                ...childrenFields
            ]
        });
        return childrenFields;
    };
    updateValue = (name, value)=>{
        const namePath = (0, $f4f7b0392d72085e$export$f877b3cb4cb4ccf9)(name);
        const prevStore = this.store;
        this.updateStore((0, $4eb3db67adf477c8$export$2e2bcd8739ae039)(this.store, namePath, value));
        this.notifyObservers(prevStore, [
            namePath
        ], {
            type: 'valueUpdate',
            source: 'internal'
        });
        this.notifyWatch([
            namePath
        ]);
        // Dependencies update
        const childrenFields = this.triggerDependenciesUpdate(prevStore, namePath);
        // trigger callback function
        const { onValuesChange: onValuesChange } = this.callbacks;
        if (onValuesChange) {
            const changedValues = (0, $f4f7b0392d72085e$export$f5be6dfb30403c59)(this.store, [
                namePath
            ]);
            const allValues = this.getFieldsValue();
            const mergedAllValues = (0, $4eb3db67adf477c8$export$2e2bcd8739ae039)(allValues, namePath, (0, $0dd37614b50139aa$export$2e2bcd8739ae039)(changedValues, namePath));
            onValuesChange(changedValues, mergedAllValues);
        }
        this.triggerOnFieldsChange([
            namePath,
            ...childrenFields
        ]);
    };
    // Let all child Field get update.
    setFieldsValue = (store)=>{
        this.warningUnhooked();
        const prevStore = this.store;
        if (store) {
            const nextStore = (0, $4eb3db67adf477c8$export$4950aa0f605343fb)(this.store, store);
            this.updateStore(nextStore);
        }
        this.notifyObservers(prevStore, null, {
            type: 'valueUpdate',
            source: 'external'
        });
        this.notifyWatch();
    };
    setFieldValue = (name, value)=>{
        this.setFields([
            {
                name: name,
                value: value,
                errors: [],
                warnings: [],
                touched: true
            }
        ]);
    };
    getDependencyChildrenFields = (rootNamePath)=>{
        const children = new Set();
        const childrenFields = [];
        const dependencies2fields = new (0, $688545f1363ddf5f$export$2e2bcd8739ae039)();
        /**
     * Generate maps
     * Can use cache to save perf if user report performance issue with this
     */ this.getFieldEntities().forEach((field)=>{
            const { dependencies: dependencies } = field.props;
            (dependencies || []).forEach((dependency)=>{
                const dependencyNamePath = (0, $f4f7b0392d72085e$export$f877b3cb4cb4ccf9)(dependency);
                dependencies2fields.update(dependencyNamePath, (fields = new Set())=>{
                    fields.add(field);
                    return fields;
                });
            });
        });
        const fillChildren = (namePath)=>{
            const fields = dependencies2fields.get(namePath) || new Set();
            fields.forEach((field)=>{
                if (!children.has(field)) {
                    children.add(field);
                    const fieldNamePath = field.getNamePath();
                    if (field.isFieldDirty() && fieldNamePath.length) {
                        childrenFields.push(fieldNamePath);
                        fillChildren(fieldNamePath);
                    }
                }
            });
        };
        fillChildren(rootNamePath);
        return childrenFields;
    };
    triggerOnFieldsChange = (namePathList, filedErrors)=>{
        const { onFieldsChange: onFieldsChange } = this.callbacks;
        if (onFieldsChange) {
            const fields = this.getFields();
            /**
       * Fill errors since `fields` may be replaced by controlled fields
       */ if (filedErrors) {
                const cache = new (0, $688545f1363ddf5f$export$2e2bcd8739ae039)();
                filedErrors.forEach(({ name: name, errors: errors })=>{
                    cache.set(name, errors);
                });
                fields.forEach((field)=>{
                    // eslint-disable-next-line no-param-reassign
                    field.errors = cache.get(field.name) || field.errors;
                });
            }
            const changedFields = fields.filter(({ name: fieldName })=>(0, $f4f7b0392d72085e$export$646d5504364ae55b)(namePathList, fieldName));
            if (changedFields.length) onFieldsChange(changedFields, fields);
        }
    };
    // =========================== Validate ===========================
    validateFields = (arg1, arg2)=>{
        this.warningUnhooked();
        let nameList;
        let options;
        if (Array.isArray(arg1) || typeof arg1 === 'string' || typeof arg2 === 'string') {
            nameList = arg1;
            options = arg2;
        } else options = arg1;
        const provideNameList = !!nameList;
        const namePathList = provideNameList ? nameList.map((0, $f4f7b0392d72085e$export$f877b3cb4cb4ccf9)) : [];
        // Same namePathList, but does not include Form.List name
        const finalValueNamePathList = [
            ...namePathList
        ];
        // Collect result in promise list
        const promiseList = [];
        // We temp save the path which need trigger for `onFieldsChange`
        const TMP_SPLIT = String(Date.now());
        const validateNamePathList = new Set();
        const { recursive: recursive, dirty: dirty } = options || {};
        this.getFieldEntities(true).forEach((field)=>{
            const fieldNamePath = field.getNamePath();
            // Add field if not provide `nameList`
            if (!provideNameList) {
                if (// If is field, pass directly
                !field.isList() || // If is list, do not add if already exist sub field in the namePathList
                !namePathList.some((name)=>(0, $f4f7b0392d72085e$export$325a4bd0e71bdc3a)(name, fieldNamePath, true))) finalValueNamePathList.push(fieldNamePath);
                namePathList.push(fieldNamePath);
            }
            // Skip if without rule
            if (!field.props.rules || !field.props.rules.length) return;
            // Skip if only validate dirty field
            if (dirty && !field.isFieldDirty()) return;
            validateNamePathList.add(fieldNamePath.join(TMP_SPLIT));
            // Add field validate rule in to promise list
            if (!provideNameList || (0, $f4f7b0392d72085e$export$646d5504364ae55b)(namePathList, fieldNamePath, recursive)) {
                const promise = field.validateRules({
                    validateMessages: {
                        ...(0, $a84d583b00e416f4$export$c86b939816b8fbf8),
                        ...this.validateMessages
                    },
                    ...options
                });
                // Wrap promise with field
                promiseList.push(promise.then(()=>({
                        name: fieldNamePath,
                        errors: [],
                        warnings: []
                    })).catch((ruleErrors)=>{
                    const mergedErrors = [];
                    const mergedWarnings = [];
                    ruleErrors.forEach?.(({ rule: { warningOnly: warningOnly }, errors: errors })=>{
                        if (warningOnly) mergedWarnings.push(...errors);
                        else mergedErrors.push(...errors);
                    });
                    if (mergedErrors.length) return Promise.reject({
                        name: fieldNamePath,
                        errors: mergedErrors,
                        warnings: mergedWarnings
                    });
                    return {
                        name: fieldNamePath,
                        errors: mergedErrors,
                        warnings: mergedWarnings
                    };
                }));
            }
        });
        const summaryPromise = (0, $20b9222429017483$export$6152adfdcc6be2b5)(promiseList);
        this.lastValidatePromise = summaryPromise;
        // Notify fields with rule that validate has finished and need update
        summaryPromise.catch((results)=>results).then((results)=>{
            const resultNamePathList = results.map(({ name: name })=>name);
            this.notifyObservers(this.store, resultNamePathList, {
                type: 'validateFinish'
            });
            this.triggerOnFieldsChange(resultNamePathList, results);
        });
        const returnPromise = summaryPromise.then(()=>{
            if (this.lastValidatePromise === summaryPromise) return Promise.resolve(this.getFieldsValue(finalValueNamePathList));
            return Promise.reject([]);
        }).catch((results)=>{
            const errorList = results.filter((result)=>result && result.errors.length);
            const errorMessage = errorList[0]?.errors?.[0];
            return Promise.reject({
                message: errorMessage,
                values: this.getFieldsValue(namePathList),
                errorFields: errorList,
                outOfDate: this.lastValidatePromise !== summaryPromise
            });
        });
        // Do not throw in console
        returnPromise.catch((e)=>e);
        // `validating` changed. Trigger `onFieldsChange`
        const triggerNamePathList = namePathList.filter((namePath)=>validateNamePathList.has(namePath.join(TMP_SPLIT)));
        this.triggerOnFieldsChange(triggerNamePathList);
        return returnPromise;
    };
    // ============================ Submit ============================
    submit = ()=>{
        this.warningUnhooked();
        this.validateFields().then((values)=>{
            const { onFinish: onFinish } = this.callbacks;
            if (onFinish) try {
                onFinish(values);
            } catch (err) {
                // Should print error if user `onFinish` callback failed
                console.error(err);
            }
        }).catch((e)=>{
            const { onFinishFailed: onFinishFailed } = this.callbacks;
            if (onFinishFailed) onFinishFailed(e);
        });
    };
}
function $371286eaaac67666$var$useForm(form) {
    const formRef = $5E6i4.useRef(null);
    const [, forceUpdate] = $5E6i4.useState({});
    // Create singleton FormStore
    if (!formRef.current) {
        if (form) formRef.current = form;
        else {
            // Create a new FormStore if not provided
            const forceReRender = ()=>{
                forceUpdate({});
            };
            const formStore = new $371286eaaac67666$export$75ff1ab1187e691(forceReRender);
            formRef.current = formStore.getForm();
        }
    }
    return [
        formRef.current
    ];
}
var $371286eaaac67666$export$2e2bcd8739ae039 = $371286eaaac67666$var$useForm;



var $5E6i4 = parcelRequire("5E6i4");



var $5E6i4 = parcelRequire("5E6i4");
const $47d92fee4be15ec2$var$FormContext = /*#__PURE__*/ $5E6i4.createContext({
    triggerFormChange: ()=>{},
    triggerFormFinish: ()=>{},
    registerForm: ()=>{},
    unregisterForm: ()=>{}
});
const $47d92fee4be15ec2$export$8ce1ff4f94d08846 = ({ validateMessages: validateMessages, onFormChange: onFormChange, onFormFinish: onFormFinish, children: children })=>{
    const formContext = $5E6i4.useContext($47d92fee4be15ec2$var$FormContext);
    const formsRef = $5E6i4.useRef({});
    return /*#__PURE__*/ $5E6i4.createElement($47d92fee4be15ec2$var$FormContext.Provider, {
        value: {
            ...formContext,
            validateMessages: {
                ...formContext.validateMessages,
                ...validateMessages
            },
            // =========================================================
            // =                  Global Form Control                  =
            // =========================================================
            triggerFormChange: (name, changedFields)=>{
                if (onFormChange) onFormChange(name, {
                    changedFields: changedFields,
                    forms: formsRef.current
                });
                formContext.triggerFormChange(name, changedFields);
            },
            triggerFormFinish: (name, values)=>{
                if (onFormFinish) onFormFinish(name, {
                    values: values,
                    forms: formsRef.current
                });
                formContext.triggerFormFinish(name, values);
            },
            registerForm: (name, form)=>{
                if (name) formsRef.current = {
                    ...formsRef.current,
                    [name]: form
                };
                formContext.registerForm(name, form);
            },
            unregisterForm: (name)=>{
                const newForms = {
                    ...formsRef.current
                };
                delete newForms[name];
                formsRef.current = newForms;
                formContext.unregisterForm(name);
            }
        }
    }, children);
};
var $47d92fee4be15ec2$export$2e2bcd8739ae039 = $47d92fee4be15ec2$var$FormContext;




function $7eaef06f57431f60$var$_extends() {
    $7eaef06f57431f60$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7eaef06f57431f60$var$_extends.apply(this, arguments);
}
const $7eaef06f57431f60$var$Form = (props, ref)=>{
    const { name: name, initialValues: initialValues, fields: fields, form: form, preserve: preserve, children: children, component: Component = 'form', validateMessages: validateMessages, validateTrigger: validateTrigger = 'onChange', onValuesChange: onValuesChange, onFieldsChange: onFieldsChange, onFinish: onFinish, onFinishFailed: onFinishFailed, clearOnDestroy: clearOnDestroy, ...restProps } = props;
    const nativeElementRef = $5E6i4.useRef(null);
    const formContext = $5E6i4.useContext((0, $47d92fee4be15ec2$export$2e2bcd8739ae039));
    // We customize handle event since Context will makes all the consumer re-render:
    // https://reactjs.org/docs/context.html#contextprovider
    const [formInstance] = (0, $371286eaaac67666$export$2e2bcd8739ae039)(form);
    const { useSubscribe: useSubscribe, setInitialValues: setInitialValues, setCallbacks: setCallbacks, setValidateMessages: setValidateMessages, setPreserve: setPreserve, destroyForm: destroyForm } = formInstance.getInternalHooks((0, $4eb49d26951fd5b1$export$24829b7c0e49e9f7));
    // Pass ref with form instance
    $5E6i4.useImperativeHandle(ref, ()=>({
            ...formInstance,
            nativeElement: nativeElementRef.current
        }));
    // Register form into Context
    $5E6i4.useEffect(()=>{
        formContext.registerForm(name, formInstance);
        return ()=>{
            formContext.unregisterForm(name);
        };
    }, [
        formContext,
        formInstance,
        name
    ]);
    // Pass props to store
    setValidateMessages({
        ...formContext.validateMessages,
        ...validateMessages
    });
    setCallbacks({
        onValuesChange: onValuesChange,
        onFieldsChange: (changedFields, ...rest)=>{
            formContext.triggerFormChange(name, changedFields);
            if (onFieldsChange) onFieldsChange(changedFields, ...rest);
        },
        onFinish: (values)=>{
            formContext.triggerFormFinish(name, values);
            if (onFinish) onFinish(values);
        },
        onFinishFailed: onFinishFailed
    });
    setPreserve(preserve);
    // Set initial value, init store value when first mount
    const mountRef = $5E6i4.useRef(null);
    setInitialValues(initialValues, !mountRef.current);
    if (!mountRef.current) mountRef.current = true;
    // ========================== Unmount ===========================
    $5E6i4.useEffect(()=>()=>destroyForm(clearOnDestroy), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // Prepare children by `children` type
    let childrenNode;
    const childrenRenderProps = typeof children === 'function';
    if (childrenRenderProps) {
        const values = formInstance.getFieldsValue(true);
        childrenNode = children(values, formInstance);
    } else childrenNode = children;
    // Not use subscribe when using render props
    useSubscribe(!childrenRenderProps);
    // Listen if fields provided. We use ref to save prev data here to avoid additional render
    const prevFieldsRef = $5E6i4.useRef(null);
    $5E6i4.useEffect(()=>{
        if (!(0, $f4f7b0392d72085e$export$dfcec05bb7372a54)(prevFieldsRef.current || [], fields || [])) formInstance.setFields(fields || []);
        prevFieldsRef.current = fields;
    }, [
        fields,
        formInstance
    ]);
    // =========================== Render ===========================
    const formContextValue = $5E6i4.useMemo(()=>({
            ...formInstance,
            validateTrigger: validateTrigger
        }), [
        formInstance,
        validateTrigger
    ]);
    const wrapperNode = /*#__PURE__*/ $5E6i4.createElement((0, $3befa91cc1f10543$export$2e2bcd8739ae039).Provider, {
        value: null
    }, /*#__PURE__*/ $5E6i4.createElement((0, $4eb49d26951fd5b1$export$2e2bcd8739ae039).Provider, {
        value: formContextValue
    }, childrenNode));
    if (Component === false) return wrapperNode;
    return /*#__PURE__*/ $5E6i4.createElement(Component, $7eaef06f57431f60$var$_extends({}, restProps, {
        ref: nativeElementRef,
        onSubmit: (event)=>{
            event.preventDefault();
            event.stopPropagation();
            formInstance.submit();
        },
        onReset: (event)=>{
            event.preventDefault();
            formInstance.resetFields();
            restProps.onReset?.(event);
        }
    }), wrapperNode);
};
var $7eaef06f57431f60$export$2e2bcd8739ae039 = $7eaef06f57431f60$var$Form;







var $5E6i4 = parcelRequire("5E6i4");



function $879990ccad36e4bf$export$fac44ee5b035f737(value) {
    try {
        return JSON.stringify(value);
    } catch  {
        return Math.random();
    }
}
// ------- selector type -------
// ------- selector type end -------
function $879990ccad36e4bf$var$useWatch(...args) {
    const [dependencies, _form = {}] = args;
    const options = (0, $58b11f9f2fc16504$export$717b316e73068e8d)(_form) ? {
        form: _form
    } : _form;
    const form = options.form;
    const [value, setValue] = (0, $5E6i4.useState)(()=>typeof dependencies === 'function' ? dependencies({}) : undefined);
    const valueStr = (0, $5E6i4.useMemo)(()=>$879990ccad36e4bf$export$fac44ee5b035f737(value), [
        value
    ]);
    const valueStrRef = (0, $5E6i4.useRef)(valueStr);
    valueStrRef.current = valueStr;
    const fieldContext = (0, $5E6i4.useContext)((0, $4eb49d26951fd5b1$export$2e2bcd8739ae039));
    const formInstance = form || fieldContext;
    const isValidForm = formInstance && formInstance._init;
    // ============================== Form ==============================
    const { getFieldsValue: getFieldsValue, getInternalHooks: getInternalHooks } = formInstance;
    const { registerWatch: registerWatch } = getInternalHooks((0, $4eb49d26951fd5b1$export$24829b7c0e49e9f7));
    // ============================= Update =============================
    const triggerUpdate = (0, $68990f4402d2f009$export$2e2bcd8739ae039)((values, allValues)=>{
        const watchValue = options.preserve ? allValues ?? getFieldsValue(true) : values ?? getFieldsValue();
        const nextValue = typeof dependencies === 'function' ? dependencies(watchValue) : (0, $0dd37614b50139aa$export$2e2bcd8739ae039)(watchValue, (0, $f4f7b0392d72085e$export$f877b3cb4cb4ccf9)(dependencies));
        if ($879990ccad36e4bf$export$fac44ee5b035f737(value) !== $879990ccad36e4bf$export$fac44ee5b035f737(nextValue)) setValue(nextValue);
    });
    // ============================= Effect =============================
    const flattenDeps = typeof dependencies === 'function' ? dependencies : JSON.stringify(dependencies);
    // Deps changed
    (0, $5E6i4.useEffect)(()=>{
        // Skip if not exist form instance
        if (!isValidForm) return;
        triggerUpdate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isValidForm,
        flattenDeps
    ]);
    // Value changed
    (0, $5E6i4.useEffect)(()=>{
        // Skip if not exist form instance
        if (!isValidForm) return;
        const cancelRegister = registerWatch((values, allValues)=>{
            triggerUpdate(values, allValues);
        });
        return cancelRegister;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isValidForm
    ]);
    return value;
}
var $879990ccad36e4bf$export$2e2bcd8739ae039 = $879990ccad36e4bf$var$useWatch;


const $5119e48acb9487c1$var$InternalForm = /*#__PURE__*/ $5E6i4.forwardRef((0, $7eaef06f57431f60$export$2e2bcd8739ae039));
const $5119e48acb9487c1$var$RefForm = $5119e48acb9487c1$var$InternalForm;
$5119e48acb9487c1$var$RefForm.FormProvider = (0, $47d92fee4be15ec2$export$8ce1ff4f94d08846);
$5119e48acb9487c1$var$RefForm.Field = (0, $a17e0c124d87e81c$export$2e2bcd8739ae039);
$5119e48acb9487c1$var$RefForm.List = (0, $5564230e782827e0$export$2e2bcd8739ae039);
$5119e48acb9487c1$var$RefForm.useForm = (0, $371286eaaac67666$export$2e2bcd8739ae039);
$5119e48acb9487c1$var$RefForm.useWatch = (0, $879990ccad36e4bf$export$2e2bcd8739ae039);
var $5119e48acb9487c1$export$2e2bcd8739ae039 = $5119e48acb9487c1$var$RefForm;



"use client";
const $e785311f53d64def$export$c24727297075ec6a = /*#__PURE__*/ $5E6i4.createContext({
    labelAlign: 'right',
    layout: 'horizontal',
    itemRef: ()=>{}
});
const $e785311f53d64def$export$d718247e9f9b0b9e = /*#__PURE__*/ $5E6i4.createContext(null);
const $e785311f53d64def$export$8ce1ff4f94d08846 = (props)=>{
    const providerProps = (0, $48bd91d9f828de66$export$2e2bcd8739ae039)(props, [
        'prefixCls'
    ]);
    return /*#__PURE__*/ $5E6i4.createElement((0, $47d92fee4be15ec2$export$8ce1ff4f94d08846), {
        ...providerProps
    });
};
const $e785311f53d64def$export$fb6582d3042cc879 = /*#__PURE__*/ $5E6i4.createContext({
    prefixCls: ''
});
const $e785311f53d64def$export$bbb5553c6c7a14ed = /*#__PURE__*/ $5E6i4.createContext({});
const $e785311f53d64def$export$80e4c53cb85dcab1 = ({ children: children, status: status, override: override })=>{
    const formItemInputContext = $5E6i4.useContext($e785311f53d64def$export$bbb5553c6c7a14ed);
    const newFormItemInputContext = $5E6i4.useMemo(()=>{
        const newContext = {
            ...formItemInputContext
        };
        if (override) delete newContext.isFormItemInput;
        if (status) {
            delete newContext.status;
            delete newContext.hasFeedback;
            delete newContext.feedbackIcon;
        }
        return newContext;
    }, [
        status,
        override,
        formItemInputContext
    ]);
    return /*#__PURE__*/ $5E6i4.createElement($e785311f53d64def$export$bbb5553c6c7a14ed.Provider, {
        value: newFormItemInputContext
    }, children);
};
const $e785311f53d64def$export$6f0555dad42725fb = /*#__PURE__*/ $5E6i4.createContext(undefined);



"use client";
const $33ed3a59b63447d5$var$ContextIsolator = (props)=>{
    const { space: space, form: form, children: children } = props;
    if (!(0, $b63de2b9864a5d1a$export$72280d5f896dac9a)(children)) return null;
    let result = children;
    if (form) result = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $e785311f53d64def$export$80e4c53cb85dcab1), {
        override: true,
        status: true
    }, result);
    if (space) result = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $3ee2444c5d59b36b$export$5f56e610a4afb685), null, result);
    return result;
};
var $33ed3a59b63447d5$export$2e2bcd8739ae039 = $33ed3a59b63447d5$var$ContextIsolator;













var $5E6i4 = parcelRequire("5E6i4");
const $f125ca3026bb6a93$var$TableMeasureRowContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createContext(false);
var $f125ca3026bb6a93$export$2e2bcd8739ae039 = $f125ca3026bb6a93$var$TableMeasureRowContext;




var $5E6i4 = parcelRequire("5E6i4");
const $fc11ff6780dcb007$var$useMergedArrow = (providedArrow, providedContextArrow)=>{
    const toConfig = (arrow)=>typeof arrow === 'boolean' ? {
            show: arrow
        } : arrow || {};
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useMemo(()=>{
        const arrowConfig = toConfig(providedArrow);
        const contextArrowConfig = toConfig(providedContextArrow);
        return {
            ...contextArrowConfig,
            ...arrowConfig,
            show: arrowConfig.show ?? contextArrowConfig.show ?? true
        };
    }, [
        providedArrow,
        providedContextArrow
    ]);
};
var $fc11ff6780dcb007$export$2e2bcd8739ae039 = $fc11ff6780dcb007$var$useMergedArrow;



var $5E6i4 = parcelRequire("5E6i4");








const $f5d3e1fa38ed952b$var$initMotionCommon = (duration)=>({
        animationDuration: duration,
        animationFillMode: 'both'
    });
const $f5d3e1fa38ed952b$export$83e1da9e09ec9112 = (motionCls, inKeyframes, outKeyframes, duration, sameLevel = false)=>{
    const sameLevelPrefix = sameLevel ? '&' : '';
    return {
        [`
      ${sameLevelPrefix}${motionCls}-enter,
      ${sameLevelPrefix}${motionCls}-appear
    `]: {
            ...$f5d3e1fa38ed952b$var$initMotionCommon(duration),
            animationPlayState: 'paused'
        },
        [`${sameLevelPrefix}${motionCls}-leave`]: {
            ...$f5d3e1fa38ed952b$var$initMotionCommon(duration),
            animationPlayState: 'paused'
        },
        [`
      ${sameLevelPrefix}${motionCls}-enter${motionCls}-enter-active,
      ${sameLevelPrefix}${motionCls}-appear${motionCls}-appear-active
    `]: {
            animationName: inKeyframes,
            animationPlayState: 'running'
        },
        [`${sameLevelPrefix}${motionCls}-leave${motionCls}-leave-active`]: {
            animationName: outKeyframes,
            animationPlayState: 'running',
            pointerEvents: 'none'
        }
    };
};


const $74fc3232bfd7dcd0$export$82e6205b15e6c637 = new (0, $14544cbeb8c8473b$export$2e2bcd8739ae039)('antFadeIn', {
    '0%': {
        opacity: 0
    },
    '100%': {
        opacity: 1
    }
});
const $74fc3232bfd7dcd0$export$c091916f1530334c = new (0, $14544cbeb8c8473b$export$2e2bcd8739ae039)('antFadeOut', {
    '0%': {
        opacity: 1
    },
    '100%': {
        opacity: 0
    }
});
const $74fc3232bfd7dcd0$export$2909268c8354a12 = (token, sameLevel = false)=>{
    const { antCls: antCls } = token;
    const motionCls = `${antCls}-fade`;
    const sameLevelPrefix = sameLevel ? '&' : '';
    return [
        (0, $f5d3e1fa38ed952b$export$83e1da9e09ec9112)(motionCls, $74fc3232bfd7dcd0$export$82e6205b15e6c637, $74fc3232bfd7dcd0$export$c091916f1530334c, token.motionDurationMid, sameLevel),
        {
            [`
        ${sameLevelPrefix}${motionCls}-enter,
        ${sameLevelPrefix}${motionCls}-appear
      `]: {
                opacity: 0,
                animationTimingFunction: 'linear'
            },
            [`${sameLevelPrefix}${motionCls}-leave`]: {
                animationTimingFunction: 'linear'
            }
        }
    ];
};



const $67ba63c38ba87091$export$3b71758b3ed5255f = new (0, $14544cbeb8c8473b$export$2e2bcd8739ae039)('antZoomIn', {
    '0%': {
        transform: 'scale(0.2)',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        opacity: 1
    }
});
const $67ba63c38ba87091$export$9fdb0a49c6b4b521 = new (0, $14544cbeb8c8473b$export$2e2bcd8739ae039)('antZoomOut', {
    '0%': {
        transform: 'scale(1)'
    },
    '100%': {
        transform: 'scale(0.2)',
        opacity: 0
    }
});
const $67ba63c38ba87091$export$be061d573c42e33a = new (0, $14544cbeb8c8473b$export$2e2bcd8739ae039)('antZoomBigIn', {
    '0%': {
        transform: 'scale(0.8)',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        opacity: 1
    }
});
const $67ba63c38ba87091$export$582d93d613303da3 = new (0, $14544cbeb8c8473b$export$2e2bcd8739ae039)('antZoomBigOut', {
    '0%': {
        transform: 'scale(1)'
    },
    '100%': {
        transform: 'scale(0.8)',
        opacity: 0
    }
});
const $67ba63c38ba87091$export$45eddd18c599b827 = new (0, $14544cbeb8c8473b$export$2e2bcd8739ae039)('antZoomUpIn', {
    '0%': {
        transform: 'scale(0.8)',
        transformOrigin: '50% 0%',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        transformOrigin: '50% 0%'
    }
});
const $67ba63c38ba87091$export$a85c97750adaa37a = new (0, $14544cbeb8c8473b$export$2e2bcd8739ae039)('antZoomUpOut', {
    '0%': {
        transform: 'scale(1)',
        transformOrigin: '50% 0%'
    },
    '100%': {
        transform: 'scale(0.8)',
        transformOrigin: '50% 0%',
        opacity: 0
    }
});
const $67ba63c38ba87091$export$bd2378f7814f5f1a = new (0, $14544cbeb8c8473b$export$2e2bcd8739ae039)('antZoomLeftIn', {
    '0%': {
        transform: 'scale(0.8)',
        transformOrigin: '0% 50%',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        transformOrigin: '0% 50%'
    }
});
const $67ba63c38ba87091$export$e58f88c751c4f04e = new (0, $14544cbeb8c8473b$export$2e2bcd8739ae039)('antZoomLeftOut', {
    '0%': {
        transform: 'scale(1)',
        transformOrigin: '0% 50%'
    },
    '100%': {
        transform: 'scale(0.8)',
        transformOrigin: '0% 50%',
        opacity: 0
    }
});
const $67ba63c38ba87091$export$fee1456954aef331 = new (0, $14544cbeb8c8473b$export$2e2bcd8739ae039)('antZoomRightIn', {
    '0%': {
        transform: 'scale(0.8)',
        transformOrigin: '100% 50%',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        transformOrigin: '100% 50%'
    }
});
const $67ba63c38ba87091$export$811ba6d3e2adb730 = new (0, $14544cbeb8c8473b$export$2e2bcd8739ae039)('antZoomRightOut', {
    '0%': {
        transform: 'scale(1)',
        transformOrigin: '100% 50%'
    },
    '100%': {
        transform: 'scale(0.8)',
        transformOrigin: '100% 50%',
        opacity: 0
    }
});
const $67ba63c38ba87091$export$633a68aa72dec21c = new (0, $14544cbeb8c8473b$export$2e2bcd8739ae039)('antZoomDownIn', {
    '0%': {
        transform: 'scale(0.8)',
        transformOrigin: '50% 100%',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        transformOrigin: '50% 100%'
    }
});
const $67ba63c38ba87091$export$1cf46a906e8dede4 = new (0, $14544cbeb8c8473b$export$2e2bcd8739ae039)('antZoomDownOut', {
    '0%': {
        transform: 'scale(1)',
        transformOrigin: '50% 100%'
    },
    '100%': {
        transform: 'scale(0.8)',
        transformOrigin: '50% 100%',
        opacity: 0
    }
});
const $67ba63c38ba87091$var$zoomMotion = {
    zoom: {
        inKeyframes: $67ba63c38ba87091$export$3b71758b3ed5255f,
        outKeyframes: $67ba63c38ba87091$export$9fdb0a49c6b4b521
    },
    'zoom-big': {
        inKeyframes: $67ba63c38ba87091$export$be061d573c42e33a,
        outKeyframes: $67ba63c38ba87091$export$582d93d613303da3
    },
    'zoom-big-fast': {
        inKeyframes: $67ba63c38ba87091$export$be061d573c42e33a,
        outKeyframes: $67ba63c38ba87091$export$582d93d613303da3
    },
    'zoom-left': {
        inKeyframes: $67ba63c38ba87091$export$bd2378f7814f5f1a,
        outKeyframes: $67ba63c38ba87091$export$e58f88c751c4f04e
    },
    'zoom-right': {
        inKeyframes: $67ba63c38ba87091$export$fee1456954aef331,
        outKeyframes: $67ba63c38ba87091$export$811ba6d3e2adb730
    },
    'zoom-up': {
        inKeyframes: $67ba63c38ba87091$export$45eddd18c599b827,
        outKeyframes: $67ba63c38ba87091$export$a85c97750adaa37a
    },
    'zoom-down': {
        inKeyframes: $67ba63c38ba87091$export$633a68aa72dec21c,
        outKeyframes: $67ba63c38ba87091$export$1cf46a906e8dede4
    }
};
const $67ba63c38ba87091$export$f5d123412490d9dc = (token, motionName)=>{
    const { antCls: antCls } = token;
    const motionCls = `${antCls}-${motionName}`;
    const { inKeyframes: inKeyframes, outKeyframes: outKeyframes } = $67ba63c38ba87091$var$zoomMotion[motionName];
    return [
        (0, $f5d3e1fa38ed952b$export$83e1da9e09ec9112)(motionCls, inKeyframes, outKeyframes, motionName === 'zoom-big-fast' ? token.motionDurationFast : token.motionDurationMid),
        {
            [`
        ${motionCls}-enter,
        ${motionCls}-appear
      `]: {
                transform: 'scale(0)',
                opacity: 0,
                animationTimingFunction: token.motionEaseOutCirc,
                '&-prepare': {
                    transform: 'none'
                }
            },
            [`${motionCls}-leave`]: {
                animationTimingFunction: token.motionEaseInOutCirc
            }
        }
    ];
};





function $eeb2a6150e6f408f$export$2e2bcd8739ae039(token, genCss) {
    return (0, $2535cf92607464fc$export$6d4fe3a00a1811ad).reduce((prev, colorKey)=>{
        const lightColor = token[`${colorKey}1`];
        const lightBorderColor = token[`${colorKey}3`];
        const darkColor = token[`${colorKey}6`];
        const textColor = token[`${colorKey}7`];
        return {
            ...prev,
            ...genCss(colorKey, {
                lightColor: lightColor,
                lightBorderColor: lightBorderColor,
                darkColor: darkColor,
                textColor: textColor
            })
        };
    }, {});
}



const $db434a0e6075eea4$var$FALL_BACK_ORIGIN = '50%';
const $db434a0e6075eea4$var$genTooltipStyle = (token)=>{
    const { calc: calc, componentCls: componentCls, tooltipMaxWidth: // ant-tooltip
    tooltipMaxWidth, tooltipColor: tooltipColor, tooltipBg: tooltipBg, tooltipBorderRadius: tooltipBorderRadius, zIndexPopup: zIndexPopup, controlHeight: controlHeight, dropShadowPopover: dropShadowPopover, paddingSM: paddingSM, paddingXS: paddingXS, arrowOffsetHorizontal: arrowOffsetHorizontal, sizePopupArrow: sizePopupArrow, antCls: antCls } = token;
    const [varName, varRef] = (0, $761caadb5301aee1$export$d82b8f66c5649e14)(antCls, 'tooltip');
    // arrowOffsetHorizontal + arrowWidth + borderRadius
    const edgeAlignMinWidth = calc(tooltipBorderRadius).add(sizePopupArrow).add(arrowOffsetHorizontal).equal();
    // borderRadius * 2 + arrowWidth
    const centerAlignMinWidth = calc(tooltipBorderRadius).mul(2).add(sizePopupArrow).equal();
    const sharedBodyStyle = {
        minWidth: centerAlignMinWidth,
        minHeight: controlHeight,
        padding: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.calc(paddingSM).div(2).equal())} ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(paddingXS)}`,
        color: varRef('overlay-color', tooltipColor),
        textAlign: 'start',
        textDecoration: 'none',
        wordWrap: 'break-word',
        backgroundColor: tooltipBg,
        borderRadius: tooltipBorderRadius,
        boxSizing: 'border-box'
    };
    const sharedTransformOrigin = {
        // When use `autoArrow`, origin will follow the arrow position
        [varName('valid-offset-x')]: varRef('arrow-offset-x', 'var(--arrow-x)'),
        transformOrigin: [
            varRef('valid-offset-x', $db434a0e6075eea4$var$FALL_BACK_ORIGIN),
            `var(--arrow-y, ${$db434a0e6075eea4$var$FALL_BACK_ORIGIN})`
        ].join(' ')
    };
    return [
        {
            [componentCls]: {
                ...(0, $cd5a520fee8002b4$export$23997c3e44cc1c59)(token),
                position: 'absolute',
                zIndex: zIndexPopup,
                display: 'block',
                width: 'max-content',
                maxWidth: tooltipMaxWidth,
                visibility: 'visible',
                filter: dropShadowPopover,
                ...sharedTransformOrigin,
                '&-hidden': {
                    display: 'none'
                },
                [varName('arrow-background-color')]: tooltipBg,
                // Wrapper for the tooltip content
                [`${componentCls}-container`]: [
                    sharedBodyStyle,
                    (0, $74fc3232bfd7dcd0$export$2909268c8354a12)(token, true)
                ],
                [`&:has(~ ${componentCls}-unique-container)`]: {
                    [`${componentCls}-container`]: {
                        border: 'none',
                        background: 'transparent'
                    }
                },
                // Align placement should have another min width
                [[
                    `&-placement-topLeft`,
                    `&-placement-topRight`,
                    `&-placement-bottomLeft`,
                    `&-placement-bottomRight`
                ].join(',')]: {
                    minWidth: edgeAlignMinWidth
                },
                // Limit left and right placement radius
                [[
                    `&-placement-left`,
                    `&-placement-leftTop`,
                    `&-placement-leftBottom`,
                    `&-placement-right`,
                    `&-placement-rightTop`,
                    `&-placement-rightBottom`
                ].join(',')]: {
                    [`${componentCls}-inner`]: {
                        borderRadius: token.min(tooltipBorderRadius, (0, $2540b05188c79e49$export$de6e4ffc9ec3c089))
                    }
                },
                [`${componentCls}-content`]: {
                    position: 'relative'
                },
                // generator for preset color
                ...(0, $eeb2a6150e6f408f$export$2e2bcd8739ae039)(token, (colorKey, { darkColor: darkColor })=>({
                        [`&${componentCls}-${colorKey}`]: {
                            [`${componentCls}-container`]: {
                                backgroundColor: darkColor
                            },
                            [`${componentCls}-arrow`]: {
                                [varName('arrow-background-color')]: darkColor
                            }
                        }
                    })),
                // RTL
                '&-rtl': {
                    direction: 'rtl'
                }
            }
        },
        // Arrow Style
        (0, $2540b05188c79e49$export$2e2bcd8739ae039)(token, varRef('arrow-background-color'), {
            arrowShadow: false
        }),
        // Pure Render
        {
            [`${componentCls}-pure`]: {
                position: 'relative',
                maxWidth: 'none',
                margin: token.sizePopupArrow
            }
        },
        // Unique Body
        {
            [`${componentCls}-unique-container`]: {
                ...sharedBodyStyle,
                ...sharedTransformOrigin,
                position: 'absolute',
                zIndex: calc(zIndexPopup).sub(1).equal(),
                filter: dropShadowPopover,
                '&-hidden': {
                    display: 'none'
                },
                '&-visible': {
                    transition: `all ${token.motionDurationSlow}`
                }
            }
        }
    ];
};
const $db434a0e6075eea4$export$9ca1be8807fe0675 = (token)=>({
        zIndexPopup: token.zIndexPopupBase + 70,
        maxWidth: 250,
        ...(0, $2540b05188c79e49$export$bddc192327bb9823)({
            contentRadius: token.borderRadius,
            limitVerticalRadius: true
        }),
        ...(0, $0c98a14a5d55f8de$export$87e38ee403661ccc)((0, $f564548c7b6877d5$export$4950aa0f605343fb)(token, {
            borderRadiusOuter: Math.min(token.borderRadiusOuter, 4)
        }))
    });
var $db434a0e6075eea4$export$2e2bcd8739ae039 = (prefixCls, rootCls, injectStyle = true)=>{
    const useStyle = (0, $761caadb5301aee1$export$51ec95de45185b42)('Tooltip', (token)=>{
        const { borderRadius: borderRadius, colorTextLightSolid: colorTextLightSolid, colorBgSpotlight: colorBgSpotlight, maxWidth: maxWidth } = token;
        const TooltipToken = (0, $f564548c7b6877d5$export$4950aa0f605343fb)(token, {
            // default variables
            tooltipMaxWidth: maxWidth,
            tooltipColor: colorTextLightSolid,
            tooltipBorderRadius: borderRadius,
            tooltipBg: colorBgSpotlight
        });
        return [
            $db434a0e6075eea4$var$genTooltipStyle(TooltipToken),
            (0, $67ba63c38ba87091$export$f5d123412490d9dc)(token, 'zoom-big-fast')
        ];
    }, $db434a0e6075eea4$export$9ca1be8807fe0675, {
        resetStyle: false,
        injectStyle: // Popover use Tooltip as internal component. We do not need to handle this.
        injectStyle
    });
    return useStyle(prefixCls, rootCls);
};





const $34c0f54ad93821fb$var$inverseColors = (0, $2535cf92607464fc$export$6d4fe3a00a1811ad).map((color)=>`${color}-inverse`);
const $34c0f54ad93821fb$export$2c43cb57a48fae33 = [
    'success',
    'processing',
    'error',
    'default',
    'warning'
];
function $34c0f54ad93821fb$export$ee62ebd6a58c4884(color, includeInverse = true) {
    if (includeInverse) return [].concat((0, $0acfae8147afe964$export$2e2bcd8739ae039)($34c0f54ad93821fb$var$inverseColors), (0, $0acfae8147afe964$export$2e2bcd8739ae039)((0, $2535cf92607464fc$export$6d4fe3a00a1811ad))).includes(color);
    return (0, $2535cf92607464fc$export$6d4fe3a00a1811ad).includes(color);
}
function $34c0f54ad93821fb$export$88a0ba1f7d1ea40e(color) {
    return $34c0f54ad93821fb$export$2c43cb57a48fae33.includes(color);
}




const $81d1230c72a5702e$export$6e865ea70d7724f = (rootPrefixCls, prefixCls, color)=>{
    const isInternalColor = (0, $34c0f54ad93821fb$export$ee62ebd6a58c4884)(color);
    const [varName] = (0, $761caadb5301aee1$export$d82b8f66c5649e14)(rootPrefixCls, 'tooltip');
    const className = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)({
        [`${prefixCls}-${color}`]: color && isInternalColor
    });
    const overlayStyle = {};
    const arrowStyle = {};
    const rgb = (0, $b950d390fb09f5de$export$c844f5d21427d1ab)(color).toRgb();
    const luminance = (0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b) / 255;
    const textColor = luminance < 0.5 ? '#FFF' : '#000';
    if (color && !isInternalColor) {
        overlayStyle.background = color;
        overlayStyle[varName('overlay-color')] = textColor;
        arrowStyle[varName('arrow-background-color')] = color;
    }
    return {
        className: className,
        overlayStyle: overlayStyle,
        arrowStyle: arrowStyle
    };
};


"use client";
/** @private Internal Component. Do not use in your production. */ const $0c818a89b2b0ef97$var$PurePanel = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, placement: placement = 'top', title: title, color: color, overlayInnerStyle: overlayInnerStyle, classNames: classNames, styles: styles } = props;
    const { getPrefixCls: getPrefixCls } = $5E6i4.useContext((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('tooltip', customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const rootCls = (0, $d104ec5f99ed66d7$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $db434a0e6075eea4$export$2e2bcd8739ae039)(prefixCls, rootCls);
    // Color
    const colorInfo = (0, $81d1230c72a5702e$export$6e865ea70d7724f)(rootPrefixCls, prefixCls, color);
    const arrowContentStyle = colorInfo.arrowStyle;
    const innerStyles = $5E6i4.useMemo(()=>{
        const mergedStyle = {
            ...overlayInnerStyle,
            ...colorInfo.overlayStyle
        };
        return {
            container: mergedStyle
        };
    }, [
        overlayInnerStyle,
        colorInfo.overlayStyle
    ]);
    const mergedProps = {
        ...props,
        placement: placement
    };
    const [mergedClassNames, mergedStyles] = (0, $722c8632ba7bdb89$export$648566b068f28737)([
        classNames
    ], [
        innerStyles,
        styles
    ], {
        props: mergedProps
    });
    const rootClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(rootCls, hashId, cssVarCls, prefixCls, `${prefixCls}-pure`, `${prefixCls}-placement-${placement}`, className, colorInfo.className);
    return /*#__PURE__*/ $5E6i4.createElement("div", {
        className: rootClassName,
        style: arrowContentStyle
    }, /*#__PURE__*/ $5E6i4.createElement("div", {
        className: `${prefixCls}-arrow`
    }), /*#__PURE__*/ $5E6i4.createElement((0, $405f5aaf9af8ea26$export$2e2bcd8739ae039), {
        ...props,
        className: hashId,
        prefixCls: prefixCls,
        classNames: mergedClassNames,
        styles: mergedStyles
    }, title));
};
var $0c818a89b2b0ef97$export$2e2bcd8739ae039 = $0c818a89b2b0ef97$var$PurePanel;





"use client";
const $1bb718ecb5669b36$var$InternalTooltip = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, openClassName: openClassName, getTooltipContainer: getTooltipContainer, color: color, children: children, afterOpenChange: afterOpenChange, arrow: tooltipArrow, destroyTooltipOnHide: destroyTooltipOnHide, destroyOnHidden: destroyOnHidden, title: title, overlay: overlay, trigger: trigger, builtinPlacements: builtinPlacements, autoAdjustOverflow: autoAdjustOverflow = true, motion: motion, getPopupContainer: getPopupContainer, placement: placement = 'top', mouseEnterDelay: mouseEnterDelay, mouseLeaveDelay: mouseLeaveDelay, rootClassName: rootClassName, styles: styles, classNames: classNames, onOpenChange: onOpenChange, overlayInnerStyle: // Legacy
    overlayInnerStyle, overlayStyle: overlayStyle, overlayClassName: overlayClassName, ...restProps } = props;
    const [, token] = (0, $cb3a44f4e76623bb$export$2e2bcd8739ae039)();
    const injectFromPopover = props['data-popover-inject'];
    const { getPopupContainer: getContextPopupContainer, getPrefixCls: getPrefixCls, direction: direction, ...semanticConfig } = (0, $519f2fad435b3034$export$46f4bd6436a25a31)('tooltip');
    // When injected from Popover/Popconfirm, skip tooltip-specific semantic config
    // to prevent ConfigProvider tooltip config from leaking into those components
    const { className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles, arrow: contextArrow, trigger: contextTrigger, mouseEnterDelay: contextMouseEnterDelay, mouseLeaveDelay: contextMouseLeaveDelay } = injectFromPopover ? {} : semanticConfig;
    const mergedMouseEnterDelay = mouseEnterDelay ?? contextMouseEnterDelay ?? 0.1;
    const mergedMouseLeaveDelay = mouseLeaveDelay ?? contextMouseLeaveDelay ?? 0.1;
    const mergedArrow = (0, $fc11ff6780dcb007$export$2e2bcd8739ae039)(tooltipArrow, contextArrow);
    const mergedShowArrow = mergedArrow.show;
    const mergedTrigger = trigger || contextTrigger || 'hover';
    const mergedGetPopupContainer = getPopupContainer || getTooltipContainer || getContextPopupContainer;
    const mergedDestroyOnHidden = destroyOnHidden ?? !!destroyTooltipOnHide;
    const inTableMeasureRow = $5E6i4.useContext((0, $f125ca3026bb6a93$export$2e2bcd8739ae039));
    // ============================== Ref ===============================
    const warning = (0, $bedf93c14dee83a9$export$cf977aa92c751e61)('Tooltip');
    const tooltipRef = $5E6i4.useRef(null);
    const forceAlign = ()=>{
        tooltipRef.current?.forceAlign();
    };
    $5E6i4.useImperativeHandle(ref, ()=>({
            forceAlign: forceAlign,
            nativeElement: tooltipRef.current?.nativeElement,
            popupElement: tooltipRef.current?.popupElement
        }));
    var deprecatedName, newName;
    // ============================== Open ==============================
    const [open, setOpen] = (0, $e18df22f16a16360$export$2e2bcd8739ae039)(props.defaultOpen ?? false, props.open);
    const noTitle = !title && !overlay && title !== 0; // overlay for old version compatibility
    const onInternalOpenChange = (nextOpen)=>{
        setOpen(noTitle ? false : nextOpen);
        if (!noTitle && onOpenChange) onOpenChange(nextOpen);
    };
    const tooltipPlacements = $5E6i4.useMemo(()=>{
        return builtinPlacements || (0, $08f8f8640738851c$export$2e2bcd8739ae039)({
            arrowPointAtCenter: mergedArrow?.pointAtCenter ?? false,
            autoAdjustOverflow: autoAdjustOverflow,
            arrowWidth: mergedShowArrow ? token.sizePopupArrow : 0,
            borderRadius: token.borderRadius,
            offset: token.marginXXS,
            visibleFirst: true
        });
    }, [
        mergedArrow,
        builtinPlacements,
        token,
        mergedShowArrow,
        autoAdjustOverflow
    ]);
    const memoOverlay = $5E6i4.useMemo(()=>{
        if (title === 0) return title;
        return overlay || title || '';
    }, [
        overlay,
        title
    ]);
    const memoOverlayWrapper = /*#__PURE__*/ $5E6i4.createElement((0, $33ed3a59b63447d5$export$2e2bcd8739ae039), {
        space: true,
        form: true
    }, (0, $addbc2fddcbb77a9$export$f6e2535fb5126e54)(memoOverlay) ? memoOverlay() : memoOverlay);
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        trigger: mergedTrigger,
        builtinPlacements: tooltipPlacements,
        getPopupContainer: mergedGetPopupContainer,
        destroyOnHidden: mergedDestroyOnHidden,
        mouseEnterDelay: mergedMouseEnterDelay,
        mouseLeaveDelay: mergedMouseLeaveDelay
    };
    const contextStyleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(contextStyle);
    const overlayStyleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(overlayStyle);
    const [mergedClassNames, mergedStyles] = (0, $722c8632ba7bdb89$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        overlayStyleRoot
    ], {
        props: mergedProps
    });
    const prefixCls = getPrefixCls('tooltip', customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    let tempOpen = open;
    // Hide tooltip when there is no title or in table measure row
    if (!('open' in props) && noTitle || inTableMeasureRow) tempOpen = false;
    // ============================= Render =============================
    const child = /*#__PURE__*/ $5E6i4.isValidElement(children) && !(0, $552e20b6ec4e63a6$export$9522e17588c12572)(children) ? children : /*#__PURE__*/ $5E6i4.createElement("span", null, children);
    const childProps = child.props;
    const childCls = !childProps.className || typeof childProps.className === 'string' ? (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(childProps.className, openClassName || `${prefixCls}-open`) : childProps.className;
    // Style
    const rootCls = (0, $d104ec5f99ed66d7$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $db434a0e6075eea4$export$2e2bcd8739ae039)(prefixCls, rootCls, !injectFromPopover);
    // Color
    const colorInfo = (0, $81d1230c72a5702e$export$6e865ea70d7724f)(rootPrefixCls, prefixCls, color);
    const arrowContentStyle = colorInfo.arrowStyle;
    const themeCls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(rootCls, hashId, cssVarCls);
    const rootClassNames = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(overlayClassName, {
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, colorInfo.className, rootClassName, themeCls, contextClassName, mergedClassNames.root);
    // ============================ zIndex ============================
    const [zIndex, contextZIndex] = (0, $09c5eb33e460ecef$export$3e7906d4075187a4)('Tooltip', restProps.zIndex);
    const containerStyle = {
        ...mergedStyles.container,
        ...overlayInnerStyle,
        ...colorInfo.overlayStyle
    };
    const content = /*#__PURE__*/ $5E6i4.createElement((0, $d826a5797bc4bca3$export$2e2bcd8739ae039), {
        unique: true,
        ...restProps,
        zIndex: zIndex,
        showArrow: mergedShowArrow,
        placement: placement,
        mouseEnterDelay: mergedMouseEnterDelay,
        mouseLeaveDelay: mergedMouseLeaveDelay,
        prefixCls: prefixCls,
        classNames: {
            root: rootClassNames,
            container: mergedClassNames.container,
            arrow: mergedClassNames.arrow,
            uniqueContainer: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(themeCls, mergedClassNames.container)
        },
        styles: {
            root: {
                ...arrowContentStyle,
                ...mergedStyles.root
            },
            container: containerStyle,
            uniqueContainer: containerStyle,
            arrow: mergedStyles.arrow
        },
        ref: tooltipRef,
        overlay: memoOverlayWrapper,
        visible: tempOpen,
        onVisibleChange: onInternalOpenChange,
        afterVisibleChange: afterOpenChange,
        arrowContent: /*#__PURE__*/ $5E6i4.createElement("span", {
            className: `${prefixCls}-arrow-content`
        }),
        motion: {
            motionName: (0, $c2c363b881b49d51$export$27c72201b1d09951)(rootPrefixCls, 'zoom-big-fast', typeof motion?.motionName === 'string' ? motion?.motionName : undefined),
            motionDeadline: 1000
        },
        trigger: mergedTrigger,
        builtinPlacements: tooltipPlacements,
        getTooltipContainer: mergedGetPopupContainer,
        destroyOnHidden: mergedDestroyOnHidden
    }, tempOpen && !restProps.disabled ? (0, $552e20b6ec4e63a6$export$e530037191fcd5d7)(child, {
        className: childCls
    }) : child);
    return /*#__PURE__*/ $5E6i4.createElement((0, $c8c4739fe508f3df$export$2e2bcd8739ae039).Provider, {
        value: contextZIndex
    }, content);
});
const $1bb718ecb5669b36$var$Tooltip = $1bb718ecb5669b36$var$InternalTooltip;
$1bb718ecb5669b36$var$Tooltip._InternalPanelDoNotUseOrYouWillBeFired = (0, $0c818a89b2b0ef97$export$2e2bcd8739ae039);
$1bb718ecb5669b36$var$Tooltip.UniqueProvider = (0, $be5cd9936299e16c$export$2e2bcd8739ae039);
var $1bb718ecb5669b36$export$2e2bcd8739ae039 = $1bb718ecb5669b36$var$Tooltip;



"use client";
const $d1495f60998c4281$var$MenuItem = (props)=>{
    const { className: className, children: children, icon: icon, title: title, danger: danger, extra: extra } = props;
    const { prefixCls: prefixCls, firstLevel: firstLevel, direction: direction, disableMenuItemTitleTooltip: disableMenuItemTitleTooltip, tooltip: tooltip, inlineCollapsed: isInlineCollapsed, styles: styles, classNames: classNames } = $5E6i4.useContext((0, $2e8debe7211a1585$export$2e2bcd8739ae039));
    const { siderCollapsed: siderCollapsed } = $5E6i4.useContext((0, $21140119f2dfebfc$export$63554aebd2a6d54c));
    const mergedCollapsed = !!(siderCollapsed || isInlineCollapsed);
    // Controlled tooltip state to prevent flash during collapse/expand transitions
    // ref: https://github.com/ant-design/ant-design/issues/56528
    const [tooltipOpen, setTooltipOpen] = $5E6i4.useState(false);
    $5E6i4.useEffect(()=>{
        setTooltipOpen(false);
    }, [
        mergedCollapsed
    ]);
    const renderItemChildren = (inlineCollapsed)=>{
        const label = children?.[0];
        const wrapNode = /*#__PURE__*/ $5E6i4.createElement("span", {
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-title-content`, firstLevel ? classNames?.itemContent : classNames?.subMenu?.itemContent, {
                [`${prefixCls}-title-content-with-extra`]: !!extra || extra === 0
            }),
            style: firstLevel ? styles?.itemContent : styles?.subMenu?.itemContent
        }, children);
        // inline-collapsed.md demo 依赖 span 来隐藏文字,有 icon 属性，则内部包裹一个 span
        // ref: https://github.com/ant-design/ant-design/pull/23456
        if (!icon || /*#__PURE__*/ $5E6i4.isValidElement(children) && children.type === 'span') {
            if (children && inlineCollapsed && firstLevel && typeof label === 'string') return /*#__PURE__*/ $5E6i4.createElement("div", {
                className: `${prefixCls}-inline-collapsed-noicon`
            }, label.charAt(0));
        }
        return wrapNode;
    };
    let tooltipTitle = title;
    if (typeof title === 'undefined') tooltipTitle = firstLevel ? children : '';
    else if (title === false) tooltipTitle = '';
    const tooltipConfig = tooltip === false ? undefined : tooltip;
    const mergedTooltipTitle = tooltipConfig && tooltipConfig.title !== undefined ? tooltipConfig.title : tooltipTitle;
    const tooltipProps = {
        ...tooltipConfig ?? null,
        title: mergedTooltipTitle
    };
    if (!mergedCollapsed) {
        tooltipProps.title = null;
        // Reset `open` to fix control mode tooltip display not correct
        // ref: https://github.com/ant-design/ant-design/issues/16742
        tooltipProps.open = false;
    } else {
        // When collapsed, use controlled state to prevent flash during transitions
        // ref: https://github.com/ant-design/ant-design/issues/56528
        tooltipProps.open = tooltipConfig?.open ?? tooltipOpen;
        tooltipProps.onOpenChange = (open)=>{
            setTooltipOpen(open);
            tooltipConfig?.onOpenChange?.(open);
        };
    }
    const childrenLength = (0, $2ec1a2166f2295ea$export$2e2bcd8739ae039)(children).length;
    let returnNode = /*#__PURE__*/ $5E6i4.createElement((0, $57699299a59a5ce1$export$2e2bcd8739ae039), {
        ...(0, $48bd91d9f828de66$export$2e2bcd8739ae039)(props, [
            'title',
            'icon',
            'danger'
        ]),
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(firstLevel ? classNames?.item : classNames?.subMenu?.item, {
            [`${prefixCls}-item-danger`]: danger,
            [`${prefixCls}-item-only-child`]: (icon ? childrenLength + 1 : childrenLength) === 1
        }, className),
        style: {
            ...firstLevel ? styles?.item : styles?.subMenu?.item,
            ...props.style
        },
        title: typeof title === 'string' ? title : undefined,
        itemData: props?.itemData ?? {
            ...props,
            key: props.eventKey
        }
    }, (0, $552e20b6ec4e63a6$export$e530037191fcd5d7)(icon, (oriProps)=>({
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-item-icon`, firstLevel ? classNames?.itemIcon : classNames?.subMenu?.itemIcon, oriProps.className),
            style: {
                ...firstLevel ? styles?.itemIcon : styles?.subMenu?.itemIcon,
                ...oriProps.style
            }
        })), renderItemChildren(isInlineCollapsed));
    if (!disableMenuItemTitleTooltip && tooltip !== false) {
        const mergedTooltipPlacement = tooltipConfig && tooltipConfig.placement ? tooltipConfig.placement : direction === 'rtl' ? 'left' : 'right';
        const baseTooltipClassName = `${prefixCls}-inline-collapsed-tooltip`;
        const mergeTooltipRootClassName = (classNames)=>({
                ...classNames,
                root: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(baseTooltipClassName, classNames?.root)
            });
        const mergedTooltipClassNames = (0, $addbc2fddcbb77a9$export$f6e2535fb5126e54)(tooltipConfig?.classNames) ? (info)=>{
            const resolvedClassNames = tooltipConfig.classNames(info);
            return mergeTooltipRootClassName(resolvedClassNames);
        } : mergeTooltipRootClassName(tooltipConfig?.classNames);
        returnNode = /*#__PURE__*/ $5E6i4.createElement((0, $1bb718ecb5669b36$export$2e2bcd8739ae039), {
            ...tooltipProps,
            placement: mergedTooltipPlacement,
            classNames: mergedTooltipClassNames
        }, returnNode);
    }
    return returnNode;
};
var $d1495f60998c4281$export$2e2bcd8739ae039 = $d1495f60998c4281$var$MenuItem;



var $5E6i4 = parcelRequire("5E6i4");


"use client";
const $b83dcf2c28e9b9a5$var$OverrideContext = /*#__PURE__*/ $5E6i4.createContext(null);
const $b83dcf2c28e9b9a5$export$9bd434816b0530d0 = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { children: children, ...restProps } = props;
    const override = $5E6i4.useContext($b83dcf2c28e9b9a5$var$OverrideContext);
    const context = $5E6i4.useMemo(()=>({
            ...override,
            ...restProps
        }), [
        override,
        restProps.prefixCls,
        // restProps.expandIcon, Not mark as deps since this is a ReactNode
        restProps.mode,
        restProps.selectable,
        restProps.rootClassName
    ]);
    const canRef = (0, $92c8c75386168ffc$export$b51ae67c7882a242)(children);
    const mergedRef = (0, $92c8c75386168ffc$export$1d1c999670a1285d)(ref, canRef ? (0, $92c8c75386168ffc$export$7465e5c0bf44f19a)(children) : null);
    return /*#__PURE__*/ $5E6i4.createElement($b83dcf2c28e9b9a5$var$OverrideContext.Provider, {
        value: context
    }, /*#__PURE__*/ $5E6i4.createElement((0, $33ed3a59b63447d5$export$2e2bcd8739ae039), {
        space: true
    }, canRef ? /*#__PURE__*/ $5E6i4.cloneElement(children, {
        ref: mergedRef
    }) : children));
});
var /** @internal Only used for Dropdown component. Do not use this in your production. */ $b83dcf2c28e9b9a5$export$2e2bcd8739ae039 = $b83dcf2c28e9b9a5$var$OverrideContext;







const $8c07f7e527e50277$export$e801b802b037de6a = new (0, $14544cbeb8c8473b$export$2e2bcd8739ae039)('antSlideUpIn', {
    '0%': {
        transform: 'scaleY(0.8)',
        transformOrigin: '0% 0%',
        opacity: 0
    },
    '100%': {
        transform: 'scaleY(1)',
        transformOrigin: '0% 0%',
        opacity: 1
    }
});
const $8c07f7e527e50277$export$f40f41df328ebc38 = new (0, $14544cbeb8c8473b$export$2e2bcd8739ae039)('antSlideUpOut', {
    '0%': {
        transform: 'scaleY(1)',
        transformOrigin: '0% 0%',
        opacity: 1
    },
    '100%': {
        transform: 'scaleY(0.8)',
        transformOrigin: '0% 0%',
        opacity: 0
    }
});
const $8c07f7e527e50277$export$dd9f089fa5e819fe = new (0, $14544cbeb8c8473b$export$2e2bcd8739ae039)('antSlideDownIn', {
    '0%': {
        transform: 'scaleY(0.8)',
        transformOrigin: '100% 100%',
        opacity: 0
    },
    '100%': {
        transform: 'scaleY(1)',
        transformOrigin: '100% 100%',
        opacity: 1
    }
});
const $8c07f7e527e50277$export$f7243fdb9c27c3b7 = new (0, $14544cbeb8c8473b$export$2e2bcd8739ae039)('antSlideDownOut', {
    '0%': {
        transform: 'scaleY(1)',
        transformOrigin: '100% 100%',
        opacity: 1
    },
    '100%': {
        transform: 'scaleY(0.8)',
        transformOrigin: '100% 100%',
        opacity: 0
    }
});
const $8c07f7e527e50277$export$2ad3a07c3513a54 = new (0, $14544cbeb8c8473b$export$2e2bcd8739ae039)('antSlideLeftIn', {
    '0%': {
        transform: 'scaleX(0.8)',
        transformOrigin: '0% 0%',
        opacity: 0
    },
    '100%': {
        transform: 'scaleX(1)',
        transformOrigin: '0% 0%',
        opacity: 1
    }
});
const $8c07f7e527e50277$export$486fbda27512d5a9 = new (0, $14544cbeb8c8473b$export$2e2bcd8739ae039)('antSlideLeftOut', {
    '0%': {
        transform: 'scaleX(1)',
        transformOrigin: '0% 0%',
        opacity: 1
    },
    '100%': {
        transform: 'scaleX(0.8)',
        transformOrigin: '0% 0%',
        opacity: 0
    }
});
const $8c07f7e527e50277$export$dd03ad46dbbcd7e0 = new (0, $14544cbeb8c8473b$export$2e2bcd8739ae039)('antSlideRightIn', {
    '0%': {
        transform: 'scaleX(0.8)',
        transformOrigin: '100% 0%',
        opacity: 0
    },
    '100%': {
        transform: 'scaleX(1)',
        transformOrigin: '100% 0%',
        opacity: 1
    }
});
const $8c07f7e527e50277$export$db8e3c9b93664f34 = new (0, $14544cbeb8c8473b$export$2e2bcd8739ae039)('antSlideRightOut', {
    '0%': {
        transform: 'scaleX(1)',
        transformOrigin: '100% 0%',
        opacity: 1
    },
    '100%': {
        transform: 'scaleX(0.8)',
        transformOrigin: '100% 0%',
        opacity: 0
    }
});
const $8c07f7e527e50277$var$slideMotion = {
    'slide-up': {
        inKeyframes: $8c07f7e527e50277$export$e801b802b037de6a,
        outKeyframes: $8c07f7e527e50277$export$f40f41df328ebc38
    },
    'slide-down': {
        inKeyframes: $8c07f7e527e50277$export$dd9f089fa5e819fe,
        outKeyframes: $8c07f7e527e50277$export$f7243fdb9c27c3b7
    },
    'slide-left': {
        inKeyframes: $8c07f7e527e50277$export$2ad3a07c3513a54,
        outKeyframes: $8c07f7e527e50277$export$486fbda27512d5a9
    },
    'slide-right': {
        inKeyframes: $8c07f7e527e50277$export$dd03ad46dbbcd7e0,
        outKeyframes: $8c07f7e527e50277$export$db8e3c9b93664f34
    }
};
const $8c07f7e527e50277$export$9018e60daecf7a6c = (token, motionName)=>{
    const { antCls: antCls } = token;
    const motionCls = `${antCls}-${motionName}`;
    const { inKeyframes: inKeyframes, outKeyframes: outKeyframes } = $8c07f7e527e50277$var$slideMotion[motionName];
    return [
        (0, $f5d3e1fa38ed952b$export$83e1da9e09ec9112)(motionCls, inKeyframes, outKeyframes, token.motionDurationMid),
        {
            [`
      ${motionCls}-enter,
      ${motionCls}-appear
    `]: {
                transform: 'scale(0)',
                transformOrigin: '0% 0%',
                opacity: 0,
                animationTimingFunction: token.motionEaseOutQuint,
                '&-prepare': {
                    transform: 'scale(1)'
                }
            },
            [`${motionCls}-leave`]: {
                animationTimingFunction: token.motionEaseInQuint
            }
        }
    ];
};




const $81a06afed39a661f$var$getHorizontalStyle = (token)=>{
    const { componentCls: componentCls, motionDurationSlow: motionDurationSlow, horizontalLineHeight: horizontalLineHeight, colorSplit: colorSplit, lineWidth: lineWidth, lineType: lineType, itemPaddingInline: itemPaddingInline } = token;
    return {
        [`${componentCls}-horizontal`]: {
            lineHeight: horizontalLineHeight,
            border: 0,
            borderBottom: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(lineWidth)} ${lineType} ${colorSplit}`,
            boxShadow: 'none',
            '&::after': {
                display: 'block',
                clear: 'both',
                height: 0,
                content: '"\\20"'
            },
            // ======================= Item =======================
            [`${componentCls}-item, ${componentCls}-submenu`]: {
                position: 'relative',
                display: 'inline-block',
                verticalAlign: 'bottom',
                paddingInline: itemPaddingInline
            },
            [`> ${componentCls}-item:hover,
        > ${componentCls}-item-active,
        > ${componentCls}-submenu ${componentCls}-submenu-title:hover`]: {
                backgroundColor: 'transparent'
            },
            [`${componentCls}-item, ${componentCls}-submenu-title`]: {
                transition: [
                    `border-color`,
                    `background-color`
                ].map((prop)=>`${prop} ${motionDurationSlow}`).join(',')
            },
            // ===================== Sub Menu =====================
            [`${componentCls}-submenu-arrow`]: {
                display: 'none'
            }
        }
    };
};
var $81a06afed39a661f$export$2e2bcd8739ae039 = $81a06afed39a661f$var$getHorizontalStyle;



const $dcb374f4df46ed72$var$getRTLStyle = ({ componentCls: componentCls, menuArrowOffset: menuArrowOffset, calc: calc })=>({
        [`${componentCls}-rtl`]: {
            direction: 'rtl'
        },
        [`${componentCls}-submenu-rtl`]: {
            transformOrigin: '100% 0'
        },
        // Vertical Arrow
        [`${componentCls}-rtl${componentCls}-vertical,
    ${componentCls}-submenu-rtl ${componentCls}-vertical`]: {
            [`${componentCls}-submenu-arrow`]: {
                '&::before': {
                    transform: `rotate(-45deg) translateY(${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(calc(menuArrowOffset).mul(-1).equal())})`
                },
                '&::after': {
                    transform: `rotate(45deg) translateY(${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(menuArrowOffset)})`
                }
            }
        }
    });
var $dcb374f4df46ed72$export$2e2bcd8739ae039 = $dcb374f4df46ed72$var$getRTLStyle;




const $c5b0ddbac5016464$var$accessibilityFocus = (token)=>(0, $cd5a520fee8002b4$export$6539948f0a737e39)(token);
const $c5b0ddbac5016464$var$getThemeStyle = (token, themeSuffix)=>{
    const { componentCls: componentCls, itemColor: itemColor, itemSelectedColor: itemSelectedColor, subMenuItemSelectedColor: subMenuItemSelectedColor, groupTitleColor: groupTitleColor, itemBg: itemBg, subMenuItemBg: subMenuItemBg, itemSelectedBg: itemSelectedBg, activeBarHeight: activeBarHeight, activeBarWidth: activeBarWidth, activeBarBorderWidth: activeBarBorderWidth, motionDurationSlow: motionDurationSlow, motionEaseInOut: motionEaseInOut, motionEaseOut: motionEaseOut, itemPaddingInline: itemPaddingInline, motionDurationMid: motionDurationMid, itemHoverColor: itemHoverColor, lineType: lineType, colorSplit: colorSplit, itemDisabledColor: // Disabled
    itemDisabledColor, dangerItemColor: // Danger
    dangerItemColor, dangerItemHoverColor: dangerItemHoverColor, dangerItemSelectedColor: dangerItemSelectedColor, dangerItemActiveBg: dangerItemActiveBg, dangerItemSelectedBg: dangerItemSelectedBg, popupBg: // Bg
    popupBg, itemHoverBg: itemHoverBg, itemActiveBg: itemActiveBg, menuSubMenuBg: menuSubMenuBg, horizontalItemSelectedColor: // Horizontal
    horizontalItemSelectedColor, horizontalItemSelectedBg: horizontalItemSelectedBg, horizontalItemBorderRadius: horizontalItemBorderRadius, horizontalItemHoverBg: horizontalItemHoverBg } = token;
    return {
        [`${componentCls}-${themeSuffix}, ${componentCls}-${themeSuffix} > ${componentCls}`]: {
            color: itemColor,
            background: itemBg,
            [`&${componentCls}-root:focus-visible`]: {
                ...$c5b0ddbac5016464$var$accessibilityFocus(token)
            },
            // ======================== Item ========================
            [`${componentCls}-item`]: {
                '&-group-title, &-extra': {
                    color: groupTitleColor
                }
            },
            [`${componentCls}-submenu-selected > ${componentCls}-submenu-title`]: {
                color: subMenuItemSelectedColor
            },
            [`${componentCls}-item, ${componentCls}-submenu-title`]: {
                color: itemColor,
                [`&:not(${componentCls}-item-disabled):focus-visible`]: {
                    ...$c5b0ddbac5016464$var$accessibilityFocus(token)
                }
            },
            // Disabled
            [`${componentCls}-item-disabled, ${componentCls}-submenu-disabled`]: {
                color: `${itemDisabledColor} !important`
            },
            // Hover
            [`${componentCls}-item:not(${componentCls}-item-selected):not(${componentCls}-submenu-selected)`]: {
                [`&:hover, > ${componentCls}-submenu-title:hover`]: {
                    color: itemHoverColor
                }
            },
            // SubMenu active (when hover on parent menu item)
            [`${componentCls}-submenu:not(${componentCls}-submenu-selected)`]: {
                [`> ${componentCls}-submenu-title:hover`]: {
                    color: itemHoverColor
                }
            },
            [`&:not(${componentCls}-horizontal)`]: {
                [`${componentCls}-item:not(${componentCls}-item-selected)`]: {
                    '&:hover': {
                        backgroundColor: itemHoverBg
                    },
                    '&:active': {
                        backgroundColor: itemActiveBg
                    }
                },
                [`${componentCls}-submenu-title`]: {
                    '&:hover': {
                        backgroundColor: itemHoverBg
                    },
                    '&:active': {
                        backgroundColor: itemActiveBg
                    }
                }
            },
            // Danger - only Item has
            [`${componentCls}-item-danger`]: {
                color: dangerItemColor,
                [`&${componentCls}-item:hover`]: {
                    [`&:not(${componentCls}-item-selected):not(${componentCls}-submenu-selected)`]: {
                        color: dangerItemHoverColor
                    }
                },
                [`&${componentCls}-item:active`]: {
                    background: dangerItemActiveBg
                }
            },
            [`${componentCls}-item a`]: {
                '&, &:hover': {
                    color: 'inherit'
                }
            },
            [`${componentCls}-item-selected`]: {
                color: itemSelectedColor,
                // Danger
                [`&${componentCls}-item-danger`]: {
                    color: dangerItemSelectedColor
                },
                'a, a:hover': {
                    color: 'inherit'
                }
            },
            [`& ${componentCls}-item-selected`]: {
                backgroundColor: itemSelectedBg,
                // Danger
                [`&${componentCls}-item-danger`]: {
                    backgroundColor: dangerItemSelectedBg
                }
            },
            [`&${componentCls}-submenu > ${componentCls}`]: {
                backgroundColor: menuSubMenuBg
            },
            // ===== 设置浮层的颜色 =======
            // ！dark 模式会被popupBg 会被rest 为 darkPopupBg
            [`&${componentCls}-popup > ${componentCls}`]: {
                backgroundColor: popupBg
            },
            [`&${componentCls}-submenu-popup > ${componentCls}`]: {
                backgroundColor: popupBg
            },
            // ===== 设置浮层的颜色 end =======
            // ====================== Horizontal ======================
            [`&${componentCls}-horizontal`]: {
                ...themeSuffix === 'dark' ? {
                    borderBottom: 0
                } : {},
                [`> ${componentCls}-item, > ${componentCls}-submenu`]: {
                    top: activeBarBorderWidth,
                    marginTop: token.calc(activeBarBorderWidth).mul(-1).equal(),
                    marginBottom: 0,
                    borderRadius: horizontalItemBorderRadius,
                    '&::after': {
                        position: 'absolute',
                        insetInline: itemPaddingInline,
                        bottom: 0,
                        pointerEvents: 'none',
                        borderBottom: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(activeBarHeight)} solid transparent`,
                        transition: `border-color ${motionDurationSlow} ${motionEaseInOut}`,
                        content: '""'
                    },
                    '&:hover, &-active, &-open': {
                        background: horizontalItemHoverBg,
                        '&::after': {
                            borderBottomWidth: activeBarHeight,
                            borderBottomColor: horizontalItemSelectedColor
                        }
                    },
                    '&-selected': {
                        color: horizontalItemSelectedColor,
                        backgroundColor: horizontalItemSelectedBg,
                        '&:hover': {
                            backgroundColor: horizontalItemSelectedBg
                        },
                        '&::after': {
                            borderBottomWidth: activeBarHeight,
                            borderBottomColor: horizontalItemSelectedColor
                        }
                    }
                }
            },
            // ================== Inline & Vertical ===================
            //
            [`&${componentCls}-root`]: {
                [`&${componentCls}-inline, &${componentCls}-vertical`]: {
                    borderInlineEnd: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(activeBarBorderWidth)} ${lineType} ${colorSplit}`
                }
            },
            // ======================== Inline ========================
            [`&${componentCls}-inline`]: {
                // Sub
                [`${componentCls}-sub${componentCls}-inline`]: {
                    background: subMenuItemBg
                },
                [`${componentCls}-item`]: {
                    position: 'relative',
                    '&::after': {
                        position: 'absolute',
                        insetBlock: 0,
                        insetInlineEnd: 0,
                        borderInlineEnd: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(activeBarWidth)} solid ${itemSelectedColor}`,
                        transform: 'scaleY(0.0001)',
                        opacity: 0,
                        transition: [
                            `transform`,
                            `opacity`
                        ].map((prop)=>`${prop} ${motionDurationMid} ${motionEaseOut}`).join(','),
                        content: '""'
                    },
                    // Danger
                    [`&${componentCls}-item-danger`]: {
                        '&::after': {
                            borderInlineEndColor: dangerItemSelectedColor
                        }
                    }
                },
                [`${componentCls}-selected, ${componentCls}-item-selected`]: {
                    '&::after': {
                        transform: 'scaleY(1)',
                        opacity: 1,
                        transition: [
                            `transform`,
                            `opacity`
                        ].map((prop)=>`${prop} ${motionDurationMid} ${motionEaseInOut}`).join(',')
                    }
                }
            }
        }
    };
};
var $c5b0ddbac5016464$export$2e2bcd8739ae039 = $c5b0ddbac5016464$var$getThemeStyle;




const $77fa9f87ae192d77$var$getVerticalInlineStyle = (token)=>{
    const { componentCls: componentCls, itemHeight: itemHeight, itemMarginInline: itemMarginInline, padding: padding, menuArrowSize: menuArrowSize, marginXS: marginXS, itemMarginBlock: itemMarginBlock, itemWidth: itemWidth, itemPaddingInline: itemPaddingInline } = token;
    const paddingWithArrow = token.calc(menuArrowSize).add(padding).add(marginXS).equal();
    return {
        [`${componentCls}-item`]: {
            position: 'relative',
            overflow: 'hidden'
        },
        [`${componentCls}-item, ${componentCls}-submenu-title`]: {
            height: itemHeight,
            lineHeight: (0, $56bae8a99c3cba6e$export$523c0b569236b342)(itemHeight),
            paddingInline: itemPaddingInline,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            marginInline: itemMarginInline,
            marginBlock: itemMarginBlock,
            width: itemWidth
        },
        [`> ${componentCls}-item,
            > ${componentCls}-submenu > ${componentCls}-submenu-title`]: {
            height: itemHeight,
            lineHeight: (0, $56bae8a99c3cba6e$export$523c0b569236b342)(itemHeight)
        },
        [`${componentCls}-item-group-list ${componentCls}-submenu-title,
            ${componentCls}-submenu-title`]: {
            paddingInlineEnd: paddingWithArrow
        }
    };
};
const $77fa9f87ae192d77$var$getVerticalStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, itemHeight: itemHeight, colorTextLightSolid: colorTextLightSolid, dropdownWidth: dropdownWidth, controlHeightLG: controlHeightLG, padding: padding, paddingXL: paddingXL, itemMarginInline: itemMarginInline, fontSizeLG: fontSizeLG, motionDurationSlow: motionDurationSlow, paddingXS: paddingXS, boxShadowSecondary: boxShadowSecondary, collapsedWidth: collapsedWidth, collapsedIconSize: collapsedIconSize } = token;
    const inlineItemStyle = {
        height: itemHeight,
        lineHeight: (0, $56bae8a99c3cba6e$export$523c0b569236b342)(itemHeight),
        listStylePosition: 'inside',
        listStyleType: 'disc'
    };
    return [
        {
            [componentCls]: {
                '&-inline, &-vertical': {
                    [`&${componentCls}-root`]: {
                        boxShadow: 'none'
                    },
                    ...$77fa9f87ae192d77$var$getVerticalInlineStyle(token)
                }
            },
            [`${componentCls}-submenu-popup`]: {
                [`${componentCls}-vertical`]: {
                    ...$77fa9f87ae192d77$var$getVerticalInlineStyle(token),
                    boxShadow: boxShadowSecondary
                }
            }
        },
        // Vertical only
        {
            [`${componentCls}-submenu-popup ${componentCls}-vertical${componentCls}-sub`]: {
                minWidth: dropdownWidth,
                maxHeight: `calc(100vh - ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.calc(controlHeightLG).mul(2.5).equal())})`,
                padding: '0',
                overflow: 'hidden',
                borderInlineEnd: 0,
                // https://github.com/ant-design/ant-design/issues/22244
                // https://github.com/ant-design/ant-design/issues/26812
                "&:not([class*='-active'])": {
                    overflowX: 'hidden',
                    overflowY: 'auto'
                }
            }
        },
        // Inline Only
        {
            [`${componentCls}-inline`]: {
                width: '100%',
                // Motion enhance for first level
                [`&${componentCls}-root`]: {
                    [`${componentCls}-item, ${componentCls}-submenu-title`]: {
                        display: 'flex',
                        alignItems: 'center',
                        transition: [
                            `border-color ${motionDurationSlow}`,
                            `background-color ${motionDurationSlow}`
                        ].join(','),
                        [`> ${componentCls}-title-content`]: {
                            flex: 'auto',
                            minWidth: 0,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        },
                        '> *': {
                            flex: 'none'
                        }
                    }
                },
                // >>>>> Sub
                [`${componentCls}-sub${componentCls}-inline`]: {
                    padding: 0,
                    border: 0,
                    borderRadius: 0,
                    boxShadow: 'none',
                    [`& > ${componentCls}-submenu > ${componentCls}-submenu-title`]: inlineItemStyle,
                    [`& ${componentCls}-item-group-title`]: {
                        paddingInlineStart: paddingXL
                    }
                },
                // >>>>> Item
                [`${componentCls}-item`]: inlineItemStyle
            }
        },
        // Inline Collapse Only
        {
            [`${componentCls}-inline-collapsed`]: {
                width: collapsedWidth,
                [`&${componentCls}-root`]: {
                    [`${componentCls}-item, ${componentCls}-submenu ${componentCls}-submenu-title`]: {
                        transition: [
                            `border-color`,
                            `background-color`
                        ].map((prop)=>`${prop} ${motionDurationSlow}`).join(','),
                        [`> ${componentCls}-inline-collapsed-noicon`]: {
                            fontSize: fontSizeLG,
                            textAlign: 'center',
                            width: '100%'
                        }
                    }
                },
                [`> ${componentCls}-item,
          > ${componentCls}-item-group > ${componentCls}-item-group-list > ${componentCls}-item,
          > ${componentCls}-item-group > ${componentCls}-item-group-list > ${componentCls}-submenu > ${componentCls}-submenu-title,
          > ${componentCls}-submenu > ${componentCls}-submenu-title`]: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    insetInlineStart: 0,
                    paddingInline: `calc(50% - ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.calc(collapsedIconSize).div(2).equal())} - ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(itemMarginInline)})`,
                    textOverflow: 'clip',
                    [`
            ${componentCls}-submenu-arrow,
            ${componentCls}-submenu-expand-icon
          `]: {
                        opacity: 0
                    },
                    [`> ${componentCls}-title-content`]: {
                        width: 0,
                        opacity: 0,
                        overflow: 'hidden'
                    },
                    [`${componentCls}-item-icon, ${iconCls}`]: {
                        margin: 0,
                        fontSize: collapsedIconSize,
                        lineHeight: (0, $56bae8a99c3cba6e$export$523c0b569236b342)(itemHeight),
                        '+ span': {
                            display: 'inline-block',
                            width: 0,
                            opacity: 0,
                            overflow: 'hidden',
                            marginInlineStart: 0
                        }
                    }
                },
                [`${componentCls}-item-icon, ${iconCls}`]: {
                    display: 'inline-block'
                },
                '&-tooltip': {
                    pointerEvents: 'none',
                    [`${componentCls}-item-icon, ${iconCls}`]: {
                        display: 'none'
                    },
                    [`${componentCls}-item-extra`]: {
                        paddingInlineStart: padding
                    },
                    'a, a:hover': {
                        color: colorTextLightSolid
                    }
                },
                [`${componentCls}-item-group-title`]: {
                    ...(0, $cd5a520fee8002b4$export$b2b65df0d0824629),
                    paddingInline: paddingXS
                }
            }
        }
    ];
};
var $77fa9f87ae192d77$export$2e2bcd8739ae039 = $77fa9f87ae192d77$var$getVerticalStyle;


const $f7314fffdd747baf$var$genMenuItemStyle = (token)=>{
    const { componentCls: componentCls, motionDurationSlow: motionDurationSlow, motionDurationMid: motionDurationMid, motionEaseInOut: motionEaseInOut, motionEaseOut: motionEaseOut, iconCls: iconCls, iconSize: iconSize, iconMarginInlineEnd: iconMarginInlineEnd } = token;
    return {
        // >>>>> Item
        [`${componentCls}-item, ${componentCls}-submenu-title`]: {
            position: 'relative',
            display: 'block',
            margin: 0,
            whiteSpace: 'nowrap',
            cursor: 'pointer',
            transition: [
                `border-color ${motionDurationSlow}`,
                `background-color ${motionDurationSlow}`,
                `padding calc(${motionDurationSlow} + 0.1s) ${motionEaseInOut}`
            ].join(','),
            [`${componentCls}-item-icon, ${iconCls}`]: {
                minWidth: iconSize,
                fontSize: iconSize,
                transition: [
                    `font-size ${motionDurationMid} ${motionEaseOut}`,
                    `margin ${motionDurationSlow} ${motionEaseInOut}`,
                    `color ${motionDurationSlow}`
                ].join(','),
                '+ span': {
                    marginInlineStart: iconMarginInlineEnd,
                    opacity: 1,
                    transition: [
                        `opacity ${motionDurationSlow} ${motionEaseInOut}`,
                        `margin ${motionDurationSlow}`,
                        `color ${motionDurationSlow}`
                    ].join(',')
                }
            },
            [`${componentCls}-item-icon`]: {
                ...(0, $cd5a520fee8002b4$export$171ccda7bc085e59)()
            },
            [`&${componentCls}-item-only-child`]: {
                [`> ${iconCls}, > ${componentCls}-item-icon`]: {
                    marginInlineEnd: 0
                }
            }
        },
        // Disabled state sets text to gray and nukes hover/tab effects
        [`${componentCls}-item-disabled, ${componentCls}-submenu-disabled`]: {
            background: 'none !important',
            cursor: 'not-allowed',
            '&::after': {
                borderColor: 'transparent !important'
            },
            a: {
                color: 'inherit !important',
                cursor: 'not-allowed',
                pointerEvents: 'none'
            },
            [`> ${componentCls}-submenu-title`]: {
                color: 'inherit !important',
                cursor: 'not-allowed'
            }
        }
    };
};
const $f7314fffdd747baf$var$genSubMenuArrowStyle = (token)=>{
    const { componentCls: componentCls, motionDurationSlow: motionDurationSlow, motionEaseInOut: motionEaseInOut, borderRadius: borderRadius, menuArrowSize: menuArrowSize, menuArrowOffset: menuArrowOffset } = token;
    return {
        [`${componentCls}-submenu`]: {
            '&-expand-icon, &-arrow': {
                position: 'absolute',
                top: '50%',
                insetInlineEnd: token.margin,
                width: menuArrowSize,
                color: 'currentcolor',
                transform: 'translateY(-50%)',
                transition: [
                    'transform',
                    'opacity'
                ].map((prop)=>`${prop} ${motionDurationSlow}`).join(',')
            },
            '&-arrow': {
                // →
                '&::before, &::after': {
                    position: 'absolute',
                    width: token.calc(menuArrowSize).mul(0.6).equal(),
                    height: token.calc(menuArrowSize).mul(0.15).equal(),
                    backgroundColor: 'currentcolor',
                    borderRadius: borderRadius,
                    transition: [
                        `background-color`,
                        `transform`,
                        `top`,
                        `color`
                    ].map((prop)=>`${prop} ${motionDurationSlow} ${motionEaseInOut}`).join(','),
                    content: '""'
                },
                '&::before': {
                    transform: `rotate(45deg) translateY(${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.calc(menuArrowOffset).mul(-1).equal())})`
                },
                '&::after': {
                    transform: `rotate(-45deg) translateY(${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(menuArrowOffset)})`
                }
            }
        }
    };
};
// =============================== Base ===============================
const $f7314fffdd747baf$var$getBaseStyle = (token)=>{
    const { antCls: antCls, componentCls: componentCls, fontSize: fontSize, motionDurationSlow: motionDurationSlow, motionDurationMid: motionDurationMid, motionEaseInOut: motionEaseInOut, paddingXS: paddingXS, padding: padding, colorSplit: colorSplit, lineWidth: lineWidth, zIndexPopup: zIndexPopup, borderRadiusLG: borderRadiusLG, subMenuItemBorderRadius: subMenuItemBorderRadius, menuArrowSize: menuArrowSize, menuArrowOffset: menuArrowOffset, lineType: lineType, groupTitleLineHeight: groupTitleLineHeight, groupTitleFontSize: groupTitleFontSize, iconSize: iconSize, iconMarginInlineEnd: iconMarginInlineEnd } = token;
    const titleContentTypographyEllipsisSelector = [
        `> ${antCls}-typography-ellipsis-single-line`,
        `> ${componentCls}-item-label > ${antCls}-typography-ellipsis-single-line`
    ].join(',');
    return [
        // Misc
        {
            '': {
                [componentCls]: {
                    ...(0, $cd5a520fee8002b4$export$8c467e8859fdef13)(),
                    // Hidden
                    '&-hidden': {
                        display: 'none'
                    }
                }
            },
            [`${componentCls}-submenu-hidden`]: {
                display: 'none'
            }
        },
        {
            [componentCls]: {
                ...(0, $cd5a520fee8002b4$export$23997c3e44cc1c59)(token),
                ...(0, $cd5a520fee8002b4$export$8c467e8859fdef13)(),
                marginBottom: 0,
                paddingInlineStart: 0,
                fontSize: // Override default ul/ol
                fontSize,
                lineHeight: 0,
                // Fix display inline-block gap
                listStyle: 'none',
                outline: 'none',
                // Magic cubic here but smooth transition
                transition: `width ${motionDurationSlow} cubic-bezier(0.2, 0, 0, 1) 0s`,
                'ul, ol': {
                    margin: 0,
                    padding: 0,
                    listStyle: 'none'
                },
                // Overflow ellipsis
                '&-overflow': {
                    display: 'flex',
                    [`${componentCls}-item`]: {
                        flex: 'none'
                    }
                },
                [`${componentCls}-item, ${componentCls}-submenu, ${componentCls}-submenu-title`]: {
                    borderRadius: token.itemBorderRadius
                },
                [`${componentCls}-item-group-title`]: {
                    padding: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(paddingXS)} ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(padding)}`,
                    fontSize: groupTitleFontSize,
                    lineHeight: groupTitleLineHeight,
                    transition: `all ${motionDurationSlow}`
                },
                [`&-horizontal ${componentCls}-submenu`]: {
                    transition: [
                        `border-color`,
                        `background-color`
                    ].map((prop)=>`${prop} ${motionDurationSlow} ${motionEaseInOut}`).join(',')
                },
                [`${componentCls}-submenu, ${componentCls}-submenu-inline`]: {
                    transition: [
                        `border-color ${motionDurationSlow}`,
                        `background-color ${motionDurationSlow}`,
                        `padding ${motionDurationMid}`
                    ].map((prop)=>`${prop} ${motionEaseInOut}`).join(',')
                },
                [`${componentCls}-submenu ${componentCls}-sub`]: {
                    cursor: 'initial',
                    transition: [
                        `background-color`,
                        `padding`
                    ].map((prop)=>`${prop} ${motionDurationSlow} ${motionEaseInOut}`).join(',')
                },
                [`${componentCls}-title-content`]: {
                    transition: `color ${motionDurationSlow}`,
                    '&-with-extra': {
                        display: 'inline-flex',
                        alignItems: 'center',
                        width: '100%',
                        minWidth: 0
                    },
                    [`${componentCls}-item-label`]: {
                        flex: 'auto',
                        minWidth: 0,
                        ...(0, $cd5a520fee8002b4$export$b2b65df0d0824629)
                    },
                    // https://github.com/ant-design/ant-design/issues/41143
                    [titleContentTypographyEllipsisSelector]: {
                        display: 'inline',
                        verticalAlign: 'unset'
                    },
                    [`${componentCls}-item-extra`]: {
                        flex: 'none',
                        marginInlineStart: 'auto',
                        paddingInlineStart: token.padding
                    }
                },
                [`${componentCls}-item-icon + ${componentCls}-title-content-with-extra`]: {
                    width: `calc(100% - ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.calc(iconSize).add(iconMarginInlineEnd ?? 0).equal())})`
                },
                [`${componentCls}-item a`]: {
                    '&::before': {
                        position: 'absolute',
                        inset: 0,
                        backgroundColor: 'transparent',
                        content: '""'
                    }
                },
                // Removed a Badge related style seems it's safe
                // https://github.com/ant-design/ant-design/issues/19809
                // >>>>> Divider
                [`${componentCls}-item-divider`]: {
                    overflow: 'hidden',
                    lineHeight: 0,
                    borderColor: colorSplit,
                    borderStyle: lineType,
                    borderWidth: 0,
                    borderTopWidth: lineWidth,
                    marginBlock: lineWidth,
                    padding: 0,
                    '&-dashed': {
                        borderStyle: 'dashed'
                    }
                },
                // Item
                ...$f7314fffdd747baf$var$genMenuItemStyle(token),
                [`${componentCls}-item-group`]: {
                    [`${componentCls}-item-group-list`]: {
                        margin: 0,
                        padding: 0,
                        [`${componentCls}-item, ${componentCls}-submenu-title`]: {
                            paddingInline: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.calc(fontSize).mul(2).equal())} ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(padding)}`
                        }
                    }
                },
                // ======================= Sub Menu =======================
                '&-submenu': {
                    '&-popup': {
                        position: 'absolute',
                        zIndex: zIndexPopup,
                        borderRadius: borderRadiusLG,
                        boxShadow: 'none',
                        transformOrigin: '0 0',
                        [`&${componentCls}-submenu`]: {
                            background: 'transparent'
                        },
                        // https://github.com/ant-design/ant-design/issues/13955
                        '&::before': {
                            position: 'absolute',
                            inset: 0,
                            zIndex: -1,
                            width: '100%',
                            height: '100%',
                            opacity: 0,
                            content: '""'
                        },
                        [`> ${componentCls}`]: {
                            borderRadius: borderRadiusLG,
                            ...$f7314fffdd747baf$var$genMenuItemStyle(token),
                            ...$f7314fffdd747baf$var$genSubMenuArrowStyle(token),
                            [`${componentCls}-item, ${componentCls}-submenu > ${componentCls}-submenu-title`]: {
                                borderRadius: subMenuItemBorderRadius
                            },
                            [`${componentCls}-submenu-title::after`]: {
                                transition: `transform ${motionDurationSlow} ${motionEaseInOut}`
                            }
                        }
                    },
                    '&-placement-leftTop, &-placement-bottomRight': {
                        transformOrigin: '100% 0'
                    },
                    '&-placement-leftBottom, &-placement-topRight': {
                        transformOrigin: '100% 100%'
                    },
                    '&-placement-rightBottom, &-placement-topLeft': {
                        transformOrigin: '0 100%'
                    },
                    '&-placement-bottomLeft, &-placement-rightTop': {
                        transformOrigin: '0 0'
                    },
                    '&-placement-leftTop, &-placement-leftBottom': {
                        paddingInlineEnd: token.paddingXS
                    },
                    '&-placement-rightTop, &-placement-rightBottom': {
                        paddingInlineStart: token.paddingXS
                    },
                    '&-placement-topRight, &-placement-topLeft': {
                        paddingBottom: token.paddingXS
                    },
                    '&-placement-bottomRight, &-placement-bottomLeft': {
                        paddingTop: token.paddingXS
                    }
                },
                ...$f7314fffdd747baf$var$genSubMenuArrowStyle(token),
                [`&-inline-collapsed ${componentCls}-submenu-arrow,
        &-inline ${componentCls}-submenu-arrow`]: {
                    // ↓
                    '&::before': {
                        transform: `rotate(-45deg) translateX(${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(menuArrowOffset)})`
                    },
                    '&::after': {
                        transform: `rotate(45deg) translateX(${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.calc(menuArrowOffset).mul(-1).equal())})`
                    }
                },
                [`${componentCls}-submenu-open${componentCls}-submenu-inline > ${componentCls}-submenu-title > ${componentCls}-submenu-arrow`]: {
                    // ↑
                    transform: `translateY(${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.calc(menuArrowSize).mul(0.2).mul(-1).equal())})`,
                    '&::after': {
                        transform: `rotate(-45deg) translateX(${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.calc(menuArrowOffset).mul(-1).equal())})`
                    },
                    '&::before': {
                        transform: `rotate(45deg) translateX(${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(menuArrowOffset)})`
                    }
                }
            }
        },
        // Integration with header element so menu items have the same height
        {
            [`${antCls}-layout-header`]: {
                [componentCls]: {
                    lineHeight: 'inherit'
                }
            }
        }
    ];
};
const $f7314fffdd747baf$export$9ca1be8807fe0675 = (token)=>{
    const { colorPrimary: colorPrimary, colorError: colorError, colorTextDisabled: colorTextDisabled, colorErrorBg: colorErrorBg, colorText: colorText, colorTextDescription: colorTextDescription, colorBgContainer: colorBgContainer, colorFillAlter: colorFillAlter, colorFillContent: colorFillContent, lineWidth: lineWidth, lineWidthBold: lineWidthBold, controlItemBgActive: controlItemBgActive, colorBgTextHover: colorBgTextHover, controlHeightLG: controlHeightLG, lineHeight: lineHeight, colorBgElevated: colorBgElevated, marginXXS: marginXXS, padding: padding, fontSize: fontSize, controlHeightSM: controlHeightSM, fontSizeLG: fontSizeLG, colorTextLightSolid: colorTextLightSolid, colorErrorHover: colorErrorHover } = token;
    const activeBarWidth = token.activeBarWidth ?? 0;
    const activeBarBorderWidth = token.activeBarBorderWidth ?? lineWidth;
    const itemMarginInline = token.itemMarginInline ?? token.marginXXS;
    const colorTextDark = new (0, $1b0a692e36565107$export$2c4f38d6c0ecc25a)(colorTextLightSolid).setA(0.65).toRgbString();
    return {
        dropdownWidth: 160,
        zIndexPopup: token.zIndexPopupBase + 50,
        radiusItem: token.borderRadiusLG,
        itemBorderRadius: token.borderRadiusLG,
        radiusSubMenuItem: token.borderRadiusSM,
        subMenuItemBorderRadius: token.borderRadiusSM,
        colorItemText: colorText,
        itemColor: colorText,
        colorItemTextHover: colorText,
        itemHoverColor: colorText,
        colorItemTextHoverHorizontal: colorPrimary,
        horizontalItemHoverColor: colorPrimary,
        colorGroupTitle: colorTextDescription,
        groupTitleColor: colorTextDescription,
        colorItemTextSelected: colorPrimary,
        itemSelectedColor: colorPrimary,
        subMenuItemSelectedColor: colorPrimary,
        colorItemTextSelectedHorizontal: colorPrimary,
        horizontalItemSelectedColor: colorPrimary,
        colorItemBg: colorBgContainer,
        itemBg: colorBgContainer,
        colorItemBgHover: colorBgTextHover,
        itemHoverBg: colorBgTextHover,
        colorItemBgActive: colorFillContent,
        itemActiveBg: controlItemBgActive,
        colorSubItemBg: colorFillAlter,
        subMenuItemBg: colorFillAlter,
        colorItemBgSelected: controlItemBgActive,
        itemSelectedBg: controlItemBgActive,
        colorItemBgSelectedHorizontal: 'transparent',
        horizontalItemSelectedBg: 'transparent',
        colorActiveBarWidth: 0,
        activeBarWidth: activeBarWidth,
        colorActiveBarHeight: lineWidthBold,
        activeBarHeight: lineWidthBold,
        colorActiveBarBorderSize: lineWidth,
        activeBarBorderWidth: activeBarBorderWidth,
        // Disabled
        colorItemTextDisabled: colorTextDisabled,
        itemDisabledColor: colorTextDisabled,
        // Danger
        colorDangerItemText: colorError,
        dangerItemColor: colorError,
        colorDangerItemTextHover: colorError,
        dangerItemHoverColor: colorError,
        colorDangerItemTextSelected: colorError,
        dangerItemSelectedColor: colorError,
        colorDangerItemBgActive: colorErrorBg,
        dangerItemActiveBg: colorErrorBg,
        colorDangerItemBgSelected: colorErrorBg,
        dangerItemSelectedBg: colorErrorBg,
        itemMarginInline: itemMarginInline,
        horizontalItemBorderRadius: 0,
        horizontalItemHoverBg: 'transparent',
        itemHeight: controlHeightLG,
        groupTitleLineHeight: lineHeight,
        collapsedWidth: controlHeightLG * 2,
        popupBg: colorBgElevated,
        itemMarginBlock: marginXXS,
        itemPaddingInline: padding,
        horizontalLineHeight: `${controlHeightLG * 1.15}px`,
        iconSize: fontSize,
        iconMarginInlineEnd: controlHeightSM - fontSize,
        collapsedIconSize: fontSizeLG,
        groupTitleFontSize: fontSize,
        // Disabled
        darkItemDisabledColor: new (0, $1b0a692e36565107$export$2c4f38d6c0ecc25a)(colorTextLightSolid).setA(0.25).toRgbString(),
        // Dark
        darkItemColor: colorTextDark,
        darkDangerItemColor: colorError,
        darkItemBg: '#001529',
        darkPopupBg: '#001529',
        darkSubMenuItemBg: '#000c17',
        darkItemSelectedColor: colorTextLightSolid,
        darkItemSelectedBg: colorPrimary,
        darkDangerItemSelectedBg: colorError,
        darkItemHoverBg: 'transparent',
        darkGroupTitleColor: colorTextDark,
        darkItemHoverColor: colorTextLightSolid,
        darkDangerItemHoverColor: colorErrorHover,
        darkDangerItemSelectedColor: colorTextLightSolid,
        darkDangerItemActiveBg: colorError,
        // internal
        itemWidth: activeBarWidth ? `calc(100% + ${activeBarBorderWidth}px)` : `calc(100% - ${itemMarginInline * 2}px)`
    };
};
var // ============================== Export ==============================
$f7314fffdd747baf$export$2e2bcd8739ae039 = (prefixCls, rootCls = prefixCls, injectStyle = true)=>{
    const useStyle = (0, $761caadb5301aee1$export$51ec95de45185b42)('Menu', (token)=>{
        const { colorBgElevated: colorBgElevated, controlHeightLG: controlHeightLG, fontSize: fontSize, darkItemColor: darkItemColor, darkDangerItemColor: darkDangerItemColor, darkItemBg: darkItemBg, darkSubMenuItemBg: darkSubMenuItemBg, darkItemSelectedColor: darkItemSelectedColor, darkItemSelectedBg: darkItemSelectedBg, darkDangerItemSelectedBg: darkDangerItemSelectedBg, darkItemHoverBg: darkItemHoverBg, darkGroupTitleColor: darkGroupTitleColor, darkItemHoverColor: darkItemHoverColor, darkItemDisabledColor: darkItemDisabledColor, darkDangerItemHoverColor: darkDangerItemHoverColor, darkDangerItemSelectedColor: darkDangerItemSelectedColor, darkDangerItemActiveBg: darkDangerItemActiveBg, popupBg: popupBg, darkPopupBg: darkPopupBg } = token;
        const menuArrowSize = token.calc(fontSize).div(7).mul(5).equal();
        // Menu Token
        const menuToken = (0, $f564548c7b6877d5$export$4950aa0f605343fb)(token, {
            menuArrowSize: menuArrowSize,
            menuHorizontalHeight: token.calc(controlHeightLG).mul(1.15).equal(),
            menuArrowOffset: token.calc(menuArrowSize).mul(0.25).equal(),
            menuSubMenuBg: colorBgElevated,
            calc: token.calc,
            popupBg: popupBg
        });
        const menuDarkToken = (0, $f564548c7b6877d5$export$4950aa0f605343fb)(menuToken, {
            itemColor: darkItemColor,
            itemHoverColor: darkItemHoverColor,
            groupTitleColor: darkGroupTitleColor,
            itemSelectedColor: darkItemSelectedColor,
            subMenuItemSelectedColor: darkItemSelectedColor,
            itemBg: darkItemBg,
            popupBg: darkPopupBg,
            subMenuItemBg: darkSubMenuItemBg,
            itemActiveBg: 'transparent',
            itemSelectedBg: darkItemSelectedBg,
            activeBarHeight: 0,
            activeBarBorderWidth: 0,
            itemHoverBg: darkItemHoverBg,
            // Disabled
            itemDisabledColor: darkItemDisabledColor,
            // Danger
            dangerItemColor: darkDangerItemColor,
            dangerItemHoverColor: darkDangerItemHoverColor,
            dangerItemSelectedColor: darkDangerItemSelectedColor,
            dangerItemActiveBg: darkDangerItemActiveBg,
            dangerItemSelectedBg: darkDangerItemSelectedBg,
            menuSubMenuBg: darkSubMenuItemBg,
            // Horizontal
            horizontalItemSelectedColor: darkItemSelectedColor,
            horizontalItemSelectedBg: darkItemSelectedBg
        });
        return [
            // Basic
            $f7314fffdd747baf$var$getBaseStyle(menuToken),
            // Horizontal
            (0, $81a06afed39a661f$export$2e2bcd8739ae039)(menuToken),
            // Hard code for some light style
            // Vertical
            (0, $77fa9f87ae192d77$export$2e2bcd8739ae039)(menuToken),
            // Hard code for some light style
            // Theme
            (0, $c5b0ddbac5016464$export$2e2bcd8739ae039)(menuToken, 'light'),
            (0, $c5b0ddbac5016464$export$2e2bcd8739ae039)(menuDarkToken, 'dark'),
            // RTL
            (0, $dcb374f4df46ed72$export$2e2bcd8739ae039)(menuToken),
            // Motion
            (0, $5f07542305776ab3$export$2e2bcd8739ae039)(menuToken),
            (0, $8c07f7e527e50277$export$9018e60daecf7a6c)(menuToken, 'slide-up'),
            (0, $8c07f7e527e50277$export$9018e60daecf7a6c)(menuToken, 'slide-down'),
            (0, $67ba63c38ba87091$export$f5d123412490d9dc)(menuToken, 'zoom-big')
        ];
    }, $f7314fffdd747baf$export$9ca1be8807fe0675, {
        deprecatedTokens: [
            [
                'colorGroupTitle',
                'groupTitleColor'
            ],
            [
                'radiusItem',
                'itemBorderRadius'
            ],
            [
                'radiusSubMenuItem',
                'subMenuItemBorderRadius'
            ],
            [
                'colorItemText',
                'itemColor'
            ],
            [
                'colorItemTextHover',
                'itemHoverColor'
            ],
            [
                'colorItemTextHoverHorizontal',
                'horizontalItemHoverColor'
            ],
            [
                'colorItemTextSelected',
                'itemSelectedColor'
            ],
            [
                'colorItemTextSelectedHorizontal',
                'horizontalItemSelectedColor'
            ],
            [
                'colorItemTextDisabled',
                'itemDisabledColor'
            ],
            [
                'colorDangerItemText',
                'dangerItemColor'
            ],
            [
                'colorDangerItemTextHover',
                'dangerItemHoverColor'
            ],
            [
                'colorDangerItemTextSelected',
                'dangerItemSelectedColor'
            ],
            [
                'colorDangerItemBgActive',
                'dangerItemActiveBg'
            ],
            [
                'colorDangerItemBgSelected',
                'dangerItemSelectedBg'
            ],
            [
                'colorItemBg',
                'itemBg'
            ],
            [
                'colorItemBgHover',
                'itemHoverBg'
            ],
            [
                'colorSubItemBg',
                'subMenuItemBg'
            ],
            [
                'colorItemBgActive',
                'itemActiveBg'
            ],
            [
                'colorItemBgSelectedHorizontal',
                'horizontalItemSelectedBg'
            ],
            [
                'colorActiveBarWidth',
                'activeBarWidth'
            ],
            [
                'colorActiveBarHeight',
                'activeBarHeight'
            ],
            [
                'colorActiveBarBorderSize',
                'activeBarBorderWidth'
            ],
            [
                'colorItemBgSelected',
                'itemSelectedBg'
            ]
        ],
        injectStyle: // Dropdown will handle menu style self. We do not need to handle this.
        injectStyle,
        unitless: {
            groupTitleLineHeight: true
        }
    });
    return useStyle(prefixCls, rootCls);
};



var $5E6i4 = parcelRequire("5E6i4");






"use client";
const $1f4c1591d0b39931$var$SubMenu = (props)=>{
    const { popupClassName: popupClassName, icon: icon, title: title, theme: customTheme } = props;
    const context = $5E6i4.useContext((0, $2e8debe7211a1585$export$2e2bcd8739ae039));
    const { prefixCls: prefixCls, inlineCollapsed: inlineCollapsed, theme: contextTheme, classNames: classNames, styles: styles } = context;
    const parentPath = (0, $2c9ab7fc64c929ec$export$d3d2d0a05677870a)();
    let titleNode;
    if (!icon) titleNode = inlineCollapsed && !parentPath.length && title && typeof title === 'string' ? /*#__PURE__*/ $5E6i4.createElement("div", {
        className: `${prefixCls}-inline-collapsed-noicon`
    }, title.charAt(0)) : /*#__PURE__*/ $5E6i4.createElement("span", {
        className: `${prefixCls}-title-content`
    }, title);
    else {
        // inline-collapsed.md demo 依赖 span 来隐藏文字,有 icon 属性，则内部包裹一个 span
        // ref: https://github.com/ant-design/ant-design/pull/23456
        const titleIsSpan = /*#__PURE__*/ $5E6i4.isValidElement(title) && title.type === 'span';
        titleNode = /*#__PURE__*/ $5E6i4.createElement($5E6i4.Fragment, null, (0, $552e20b6ec4e63a6$export$e530037191fcd5d7)(icon, (oriProps)=>({
                className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(oriProps.className, `${prefixCls}-item-icon`, classNames?.itemIcon),
                style: {
                    ...oriProps.style,
                    ...styles?.itemIcon
                }
            })), titleIsSpan ? title : /*#__PURE__*/ $5E6i4.createElement("span", {
            className: `${prefixCls}-title-content`
        }, title));
    }
    const contextValue = $5E6i4.useMemo(()=>({
            ...context,
            firstLevel: false
        }), [
        context
    ]);
    // ============================ zIndex ============================
    const [zIndex] = (0, $09c5eb33e460ecef$export$3e7906d4075187a4)('Menu');
    return /*#__PURE__*/ $5E6i4.createElement((0, $2e8debe7211a1585$export$2e2bcd8739ae039).Provider, {
        value: contextValue
    }, /*#__PURE__*/ $5E6i4.createElement((0, $7d47f4296876f42f$export$2e2bcd8739ae039), {
        ...(0, $48bd91d9f828de66$export$2e2bcd8739ae039)(props, [
            'icon'
        ]),
        title: titleNode,
        classNames: {
            list: classNames?.subMenu?.list,
            listTitle: classNames?.subMenu?.itemTitle
        },
        styles: {
            list: styles?.subMenu?.list,
            listTitle: styles?.subMenu?.itemTitle
        },
        popupClassName: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, popupClassName, classNames?.popup?.root, `${prefixCls}-${customTheme || contextTheme}`),
        popupStyle: {
            zIndex: zIndex,
            // fix: https://github.com/ant-design/ant-design/issues/47826#issuecomment-2360737237
            ...props.popupStyle,
            ...styles?.popup?.root
        }
    }));
};
var $1f4c1591d0b39931$export$2e2bcd8739ae039 = $1f4c1591d0b39931$var$SubMenu;


"use client";
function $4e4b159685cb78a9$var$isEmptyIcon(icon) {
    return icon === null || icon === false;
}
const $4e4b159685cb78a9$var$MENU_COMPONENTS = {
    item: (0, $d1495f60998c4281$export$2e2bcd8739ae039),
    submenu: (0, $1f4c1591d0b39931$export$2e2bcd8739ae039),
    divider: (0, $a04b622e194e2138$export$2e2bcd8739ae039)
};
const $4e4b159685cb78a9$var$InternalMenu = /*#__PURE__*/ (0, $5E6i4.forwardRef)((props, ref)=>{
    const override = $5E6i4.useContext((0, $b83dcf2c28e9b9a5$export$2e2bcd8739ae039));
    const overrideObj = override || {};
    const { prefixCls: customizePrefixCls, className: className, style: style, theme: theme = 'light', expandIcon: expandIcon, _internalDisableMenuItemTitleTooltip: _internalDisableMenuItemTitleTooltip, tooltip: tooltip, inlineCollapsed: inlineCollapsed, siderCollapsed: siderCollapsed, rootClassName: rootClassName, mode: mode, selectable: selectable, onClick: onClick, overflowedIndicatorPopupClassName: overflowedIndicatorPopupClassName, classNames: classNames, styles: styles, ...restProps } = props;
    const { menu: menu } = $5E6i4.useContext((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
    const { getPrefixCls: getPrefixCls, getPopupContainer: getPopupContainer, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $519f2fad435b3034$export$46f4bd6436a25a31)('menu');
    const rootPrefixCls = getPrefixCls();
    const passedProps = (0, $48bd91d9f828de66$export$2e2bcd8739ae039)(restProps, [
        'collapsedWidth'
    ]);
    overrideObj.validator?.({
        mode: mode
    });
    // ========================== Click ==========================
    // Tell dropdown that item clicked
    const onItemClick = (0, $68990f4402d2f009$export$2e2bcd8739ae039)((...args)=>{
        onClick?.(...args);
        overrideObj.onClick?.();
    });
    // ========================== Mode ===========================
    const mergedMode = overrideObj.mode || mode;
    // ======================= Selectable ========================
    const mergedSelectable = selectable ?? overrideObj.selectable;
    // ======================== Collapsed ========================
    // Inline Collapsed
    const mergedInlineCollapsed = inlineCollapsed ?? siderCollapsed;
    // ================ Merged Props for Semantic ================
    const mergedProps = {
        ...props,
        mode: mergedMode,
        inlineCollapsed: mergedInlineCollapsed,
        selectable: mergedSelectable,
        theme: theme
    };
    const contextStyleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $722c8632ba7bdb89$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    }, {
        popup: {
            _default: 'root'
        },
        subMenu: {
            _default: 'item'
        }
    });
    const defaultMotions = {
        horizontal: {
            motionName: `${rootPrefixCls}-slide-up`
        },
        inline: (0, $c2c363b881b49d51$export$2e2bcd8739ae039)(rootPrefixCls),
        other: {
            motionName: `${rootPrefixCls}-zoom-big`
        }
    };
    const prefixCls = getPrefixCls('menu', customizePrefixCls || overrideObj.prefixCls);
    const rootCls = (0, $d104ec5f99ed66d7$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $f7314fffdd747baf$export$2e2bcd8739ae039)(prefixCls, rootCls, !override);
    const menuClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-${theme}`, contextClassName, className);
    // ====================== ExpandIcon ========================
    const mergedExpandIcon = $5E6i4.useMemo(()=>{
        if ((0, $addbc2fddcbb77a9$export$f6e2535fb5126e54)(expandIcon) || $4e4b159685cb78a9$var$isEmptyIcon(expandIcon)) return expandIcon || null;
        if ((0, $addbc2fddcbb77a9$export$f6e2535fb5126e54)(overrideObj.expandIcon) || $4e4b159685cb78a9$var$isEmptyIcon(overrideObj.expandIcon)) return overrideObj.expandIcon || null;
        if ((0, $addbc2fddcbb77a9$export$f6e2535fb5126e54)(menu?.expandIcon) || $4e4b159685cb78a9$var$isEmptyIcon(menu?.expandIcon)) return menu?.expandIcon || null;
        const mergedIcon = expandIcon ?? overrideObj?.expandIcon ?? menu?.expandIcon;
        return (0, $552e20b6ec4e63a6$export$e530037191fcd5d7)(mergedIcon, {
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-submenu-expand-icon`, /*#__PURE__*/ $5E6i4.isValidElement(mergedIcon) ? mergedIcon.props?.className : undefined)
        });
    }, [
        expandIcon,
        overrideObj?.expandIcon,
        menu?.expandIcon,
        prefixCls
    ]);
    // ======================== Context ==========================
    const contextValue = $5E6i4.useMemo(()=>({
            prefixCls: prefixCls,
            inlineCollapsed: mergedInlineCollapsed || false,
            direction: direction,
            firstLevel: true,
            theme: theme,
            mode: mergedMode,
            disableMenuItemTitleTooltip: _internalDisableMenuItemTitleTooltip,
            tooltip: tooltip,
            classNames: mergedClassNames,
            styles: mergedStyles
        }), [
        prefixCls,
        mergedInlineCollapsed,
        direction,
        _internalDisableMenuItemTitleTooltip,
        theme,
        mergedMode,
        mergedClassNames,
        mergedStyles,
        tooltip
    ]);
    // ========================= Render ==========================
    return /*#__PURE__*/ $5E6i4.createElement((0, $b83dcf2c28e9b9a5$export$2e2bcd8739ae039).Provider, {
        value: null
    }, /*#__PURE__*/ $5E6i4.createElement((0, $2e8debe7211a1585$export$2e2bcd8739ae039).Provider, {
        value: contextValue
    }, /*#__PURE__*/ $5E6i4.createElement((0, $e823adc24933414e$export$2e2bcd8739ae039), {
        getPopupContainer: getPopupContainer,
        overflowedIndicator: /*#__PURE__*/ $5E6i4.createElement((0, $bc99f102364e8dbf$export$2e2bcd8739ae039), null),
        overflowedIndicatorPopupClassName: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-${theme}`, overflowedIndicatorPopupClassName),
        classNames: {
            list: mergedClassNames.list,
            listTitle: mergedClassNames.itemTitle
        },
        styles: {
            list: mergedStyles.list,
            listTitle: mergedStyles.itemTitle
        },
        mode: mergedMode,
        selectable: mergedSelectable,
        onClick: onItemClick,
        ...passedProps,
        inlineCollapsed: mergedInlineCollapsed,
        style: mergedStyles.root,
        className: menuClassName,
        prefixCls: prefixCls,
        direction: direction,
        defaultMotions: defaultMotions,
        expandIcon: mergedExpandIcon,
        ref: ref,
        rootClassName: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(rootClassName, hashId, overrideObj.rootClassName, cssVarCls, rootCls, mergedClassNames.root),
        _internalComponents: $4e4b159685cb78a9$var$MENU_COMPONENTS
    })));
});
var $4e4b159685cb78a9$export$2e2bcd8739ae039 = $4e4b159685cb78a9$var$InternalMenu;





"use client";
const $1484b8ab934a06cc$var$Menu = /*#__PURE__*/ (0, $5E6i4.forwardRef)((props, ref)=>{
    const menuRef = (0, $5E6i4.useRef)(null);
    const context = $5E6i4.useContext((0, $21140119f2dfebfc$export$63554aebd2a6d54c));
    (0, $5E6i4.useImperativeHandle)(ref, ()=>({
            menu: menuRef.current,
            focus: (options)=>{
                menuRef.current?.focus(options);
            }
        }));
    return /*#__PURE__*/ $5E6i4.createElement((0, $4e4b159685cb78a9$export$2e2bcd8739ae039), {
        ref: menuRef,
        ...props,
        ...context
    });
});
$1484b8ab934a06cc$var$Menu.Item = (0, $d1495f60998c4281$export$2e2bcd8739ae039);
$1484b8ab934a06cc$var$Menu.SubMenu = (0, $1f4c1591d0b39931$export$2e2bcd8739ae039);
$1484b8ab934a06cc$var$Menu.Divider = (0, $a04b622e194e2138$export$2e2bcd8739ae039);
$1484b8ab934a06cc$var$Menu.ItemGroup = (0, $89189bb0a1de610b$export$2e2bcd8739ae039);
var $1484b8ab934a06cc$export$2e2bcd8739ae039 = $1484b8ab934a06cc$var$Menu;








const $87a972ff193f83db$export$c81b62e088da1305 = new (0, $14544cbeb8c8473b$export$2e2bcd8739ae039)('antMoveDownIn', {
    '0%': {
        transform: 'translate3d(0, 100%, 0)',
        transformOrigin: '0 0',
        opacity: 0
    },
    '100%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    }
});
const $87a972ff193f83db$export$6c1eca72ac4f6672 = new (0, $14544cbeb8c8473b$export$2e2bcd8739ae039)('antMoveDownOut', {
    '0%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    },
    '100%': {
        transform: 'translate3d(0, 100%, 0)',
        transformOrigin: '0 0',
        opacity: 0
    }
});
const $87a972ff193f83db$export$8dd54688d033571 = new (0, $14544cbeb8c8473b$export$2e2bcd8739ae039)('antMoveLeftIn', {
    '0%': {
        transform: 'translate3d(-100%, 0, 0)',
        transformOrigin: '0 0',
        opacity: 0
    },
    '100%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    }
});
const $87a972ff193f83db$export$be161c4e647bea9b = new (0, $14544cbeb8c8473b$export$2e2bcd8739ae039)('antMoveLeftOut', {
    '0%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    },
    '100%': {
        transform: 'translate3d(-100%, 0, 0)',
        transformOrigin: '0 0',
        opacity: 0
    }
});
const $87a972ff193f83db$export$a984c43131c7d145 = new (0, $14544cbeb8c8473b$export$2e2bcd8739ae039)('antMoveRightIn', {
    '0%': {
        transform: 'translate3d(100%, 0, 0)',
        transformOrigin: '0 0',
        opacity: 0
    },
    '100%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    }
});
const $87a972ff193f83db$export$e141ac6798b476df = new (0, $14544cbeb8c8473b$export$2e2bcd8739ae039)('antMoveRightOut', {
    '0%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    },
    '100%': {
        transform: 'translate3d(100%, 0, 0)',
        transformOrigin: '0 0',
        opacity: 0
    }
});
const $87a972ff193f83db$export$ab676201eaaca05 = new (0, $14544cbeb8c8473b$export$2e2bcd8739ae039)('antMoveUpIn', {
    '0%': {
        transform: 'translate3d(0, -100%, 0)',
        transformOrigin: '0 0',
        opacity: 0
    },
    '100%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    }
});
const $87a972ff193f83db$export$ec1b91b8ec2f6331 = new (0, $14544cbeb8c8473b$export$2e2bcd8739ae039)('antMoveUpOut', {
    '0%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    },
    '100%': {
        transform: 'translate3d(0, -100%, 0)',
        transformOrigin: '0 0',
        opacity: 0
    }
});
const $87a972ff193f83db$var$moveMotion = {
    'move-up': {
        inKeyframes: $87a972ff193f83db$export$ab676201eaaca05,
        outKeyframes: $87a972ff193f83db$export$ec1b91b8ec2f6331
    },
    'move-down': {
        inKeyframes: $87a972ff193f83db$export$c81b62e088da1305,
        outKeyframes: $87a972ff193f83db$export$6c1eca72ac4f6672
    },
    'move-left': {
        inKeyframes: $87a972ff193f83db$export$8dd54688d033571,
        outKeyframes: $87a972ff193f83db$export$be161c4e647bea9b
    },
    'move-right': {
        inKeyframes: $87a972ff193f83db$export$a984c43131c7d145,
        outKeyframes: $87a972ff193f83db$export$e141ac6798b476df
    }
};
const $87a972ff193f83db$export$913b1b7e3288c319 = (token, motionName)=>{
    const { antCls: antCls } = token;
    const motionCls = `${antCls}-${motionName}`;
    const { inKeyframes: inKeyframes, outKeyframes: outKeyframes } = $87a972ff193f83db$var$moveMotion[motionName];
    return [
        (0, $f5d3e1fa38ed952b$export$83e1da9e09ec9112)(motionCls, inKeyframes, outKeyframes, token.motionDurationMid),
        {
            [`
        ${motionCls}-enter,
        ${motionCls}-appear
      `]: {
                opacity: 0,
                animationTimingFunction: token.motionEaseOutCirc
            },
            [`${motionCls}-leave`]: {
                animationTimingFunction: token.motionEaseInOutCirc
            }
        }
    ];
};





const $66c5ba076ed71439$var$genStatusStyle = (token)=>{
    const { componentCls: componentCls, menuCls: menuCls, colorError: colorError, colorTextLightSolid: colorTextLightSolid } = token;
    const itemCls = `${menuCls}-item`;
    return {
        [`${componentCls}, ${componentCls}-menu-submenu`]: {
            [`${menuCls} ${itemCls}`]: {
                [`&${itemCls}-danger:not(${itemCls}-disabled)`]: {
                    color: colorError,
                    '&:hover': {
                        color: colorTextLightSolid,
                        backgroundColor: colorError
                    }
                }
            }
        }
    };
};
var $66c5ba076ed71439$export$2e2bcd8739ae039 = $66c5ba076ed71439$var$genStatusStyle;


// =============================== Base ===============================
const $20f075b77f81743f$var$genBaseStyle = (token)=>{
    const { componentCls: componentCls, menuCls: menuCls, zIndexPopup: zIndexPopup, dropdownArrowDistance: dropdownArrowDistance, sizePopupArrow: sizePopupArrow, antCls: antCls, iconCls: iconCls, motionDurationMid: motionDurationMid, paddingBlock: paddingBlock, fontSize: fontSize, dropdownEdgeChildPadding: dropdownEdgeChildPadding, colorTextDisabled: colorTextDisabled, fontSizeIcon: fontSizeIcon, controlPaddingHorizontal: controlPaddingHorizontal, colorBgElevated: colorBgElevated, controlHeightLG: controlHeightLG } = token;
    return [
        {
            [componentCls]: {
                position: 'absolute',
                top: -9999,
                left: {
                    _skip_check_: true,
                    value: -9999
                },
                zIndex: zIndexPopup,
                display: 'block',
                // A placeholder out of dropdown visible range to avoid close when user moving
                '&::before': {
                    position: 'absolute',
                    insetBlock: token.calc(sizePopupArrow).div(2).sub(dropdownArrowDistance).equal(),
                    // insetInlineStart: -7, // FIXME: Seems not work for hidden element
                    zIndex: -9999,
                    opacity: 0.0001,
                    content: '""'
                },
                // Makes vertical dropdowns have a scrollbar once they become taller than the viewport.
                // Leave some viewport spacing so the menu stays on-screen when the trigger is centered.
                // https://github.com/ant-design/ant-design/issues/56044
                '&-menu-vertical': {
                    maxHeight: `calc(100vh - ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.calc(controlHeightLG).mul(2.5).equal())})`,
                    overflowY: 'auto'
                },
                [`&-trigger${antCls}-btn`]: {
                    [`& > ${iconCls}-down, & > ${antCls}-btn-icon > ${iconCls}-down`]: {
                        fontSize: fontSizeIcon
                    }
                },
                [`${componentCls}-wrap`]: {
                    position: 'relative',
                    [`${antCls}-btn > ${iconCls}-down`]: {
                        fontSize: fontSizeIcon
                    },
                    [`${iconCls}-down::before`]: {
                        transition: `transform ${motionDurationMid}`
                    }
                },
                [`${componentCls}-wrap-open`]: {
                    [`${iconCls}-down::before`]: {
                        transform: `rotate(180deg)`
                    }
                },
                '&-hidden, &-menu-hidden, &-menu-submenu-hidden': {
                    display: 'none'
                },
                // =============================================================
                // ==                         Motion                          ==
                // =============================================================
                // When position is not enough for dropdown, the placement will revert.
                // We will handle this with revert motion name.
                [`&${antCls}-slide-down-enter${antCls}-slide-down-enter-active${componentCls}-placement-bottomLeft,
          &${antCls}-slide-down-appear${antCls}-slide-down-appear-active${componentCls}-placement-bottomLeft,
          &${antCls}-slide-down-enter${antCls}-slide-down-enter-active${componentCls}-placement-bottom,
          &${antCls}-slide-down-appear${antCls}-slide-down-appear-active${componentCls}-placement-bottom,
          &${antCls}-slide-down-enter${antCls}-slide-down-enter-active${componentCls}-placement-bottomRight,
          &${antCls}-slide-down-appear${antCls}-slide-down-appear-active${componentCls}-placement-bottomRight`]: {
                    animationName: (0, $8c07f7e527e50277$export$e801b802b037de6a)
                },
                [`&${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-placement-topLeft,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-placement-topLeft,
          &${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-placement-top,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-placement-top,
          &${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-placement-topRight,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-placement-topRight`]: {
                    animationName: (0, $8c07f7e527e50277$export$dd9f089fa5e819fe)
                },
                [`&${antCls}-slide-down-leave${antCls}-slide-down-leave-active${componentCls}-placement-bottomLeft,
          &${antCls}-slide-down-leave${antCls}-slide-down-leave-active${componentCls}-placement-bottom,
          &${antCls}-slide-down-leave${antCls}-slide-down-leave-active${componentCls}-placement-bottomRight`]: {
                    animationName: (0, $8c07f7e527e50277$export$f40f41df328ebc38)
                },
                [`&${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-placement-topLeft,
          &${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-placement-top,
          &${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-placement-topRight`]: {
                    animationName: (0, $8c07f7e527e50277$export$f7243fdb9c27c3b7)
                },
                [`&${antCls}-slide-right-enter${antCls}-slide-right-enter-active${componentCls}-placement-right,
          &${antCls}-slide-right-appear${antCls}-slide-right-appear-active${componentCls}-placement-right,
          &${antCls}-slide-right-enter${antCls}-slide-right-enter-active${componentCls}-placement-rightTop,
          &${antCls}-slide-right-appear${antCls}-slide-right-appear-active${componentCls}-placement-rightTop,
          &${antCls}-slide-right-enter${antCls}-slide-right-enter-active${componentCls}-placement-rightBottom,
          &${antCls}-slide-right-appear${antCls}-slide-right-appear-active${componentCls}-placement-rightBottom`]: {
                    animationName: (0, $8c07f7e527e50277$export$2ad3a07c3513a54)
                },
                [`&${antCls}-slide-left-enter${antCls}-slide-left-enter-active${componentCls}-placement-left,
          &${antCls}-slide-left-appear${antCls}-slide-left-appear-active${componentCls}-placement-left,
          &${antCls}-slide-left-enter${antCls}-slide-left-enter-active${componentCls}-placement-leftTop,
          &${antCls}-slide-left-appear${antCls}-slide-left-appear-active${componentCls}-placement-leftTop,
          &${antCls}-slide-left-enter${antCls}-slide-left-enter-active${componentCls}-placement-leftBottom,
          &${antCls}-slide-left-appear${antCls}-slide-left-appear-active${componentCls}-placement-leftBottom`]: {
                    animationName: (0, $8c07f7e527e50277$export$dd03ad46dbbcd7e0)
                },
                [`&${antCls}-slide-right-leave${antCls}-slide-right-leave-active${componentCls}-placement-right,
          &${antCls}-slide-right-leave${antCls}-slide-right-leave-active${componentCls}-placement-rightTop,
          &${antCls}-slide-right-leave${antCls}-slide-right-leave-active${componentCls}-placement-rightBottom`]: {
                    animationName: (0, $8c07f7e527e50277$export$486fbda27512d5a9)
                },
                [`&${antCls}-slide-left-leave${antCls}-slide-left-leave-active${componentCls}-placement-left,
          &${antCls}-slide-left-leave${antCls}-slide-left-leave-active${componentCls}-placement-leftTop,
          &${antCls}-slide-left-leave${antCls}-slide-left-leave-active${componentCls}-placement-leftBottom`]: {
                    animationName: (0, $8c07f7e527e50277$export$db8e3c9b93664f34)
                }
            }
        },
        // =============================================================
        // ==                        Arrow style                      ==
        // =============================================================
        (0, $2540b05188c79e49$export$2e2bcd8739ae039)(token, colorBgElevated),
        {
            // =============================================================
            // ==                          Menu                           ==
            // =============================================================
            [`${componentCls} ${menuCls}`]: {
                position: 'relative',
                margin: 0
            },
            [`${menuCls}-submenu-popup`]: {
                position: 'absolute',
                zIndex: zIndexPopup,
                background: 'transparent',
                boxShadow: 'none',
                transformOrigin: '0 0',
                'ul, li': {
                    listStyle: 'none',
                    margin: 0
                }
            },
            [`${componentCls}, ${componentCls}-menu-submenu`]: {
                ...(0, $cd5a520fee8002b4$export$23997c3e44cc1c59)(token),
                [menuCls]: {
                    padding: dropdownEdgeChildPadding,
                    listStyleType: 'none',
                    backgroundColor: colorBgElevated,
                    backgroundClip: 'padding-box',
                    borderRadius: token.borderRadiusLG,
                    outline: 'none',
                    boxShadow: token.boxShadowSecondary,
                    ...(0, $cd5a520fee8002b4$export$a44db842bcb28231)(token),
                    '&:empty': {
                        padding: 0,
                        boxShadow: 'none'
                    },
                    [`${menuCls}-item-group-title`]: {
                        padding: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(paddingBlock)} ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(controlPaddingHorizontal)}`,
                        color: token.colorTextDescription,
                        transition: `all ${motionDurationMid}`
                    },
                    // ======================= Item Content =======================
                    [`${menuCls}-item`]: {
                        position: 'relative',
                        display: 'flex',
                        alignItems: 'center'
                    },
                    [`${menuCls}-item-icon`]: {
                        minWidth: fontSize,
                        marginInlineEnd: token.marginXS,
                        fontSize: token.fontSizeSM
                    },
                    [`${menuCls}-title-content`]: {
                        flex: 'auto',
                        '&-with-extra': {
                            display: 'inline-flex',
                            alignItems: 'center',
                            width: '100%'
                        },
                        [`> a, > ${menuCls}-item-label > a`]: {
                            color: 'inherit',
                            transition: `all ${motionDurationMid}`,
                            '&:hover': {
                                color: 'inherit'
                            },
                            '&::after': {
                                position: 'absolute',
                                inset: 0,
                                content: '""'
                            }
                        },
                        [`${menuCls}-item-extra`]: {
                            paddingInlineStart: token.padding,
                            marginInlineStart: 'auto',
                            fontSize: token.fontSizeSM,
                            color: token.colorTextDescription
                        }
                    },
                    // =========================== Item ===========================
                    [`${menuCls}-item, ${menuCls}-submenu-title`]: {
                        display: 'flex',
                        margin: 0,
                        padding: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(paddingBlock)} ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(controlPaddingHorizontal)}`,
                        color: token.colorText,
                        fontWeight: 400,
                        fontSize: fontSize,
                        lineHeight: token.lineHeight,
                        cursor: 'pointer',
                        transition: `all ${motionDurationMid}`,
                        borderRadius: token.borderRadiusSM,
                        '&:hover, &-active': {
                            backgroundColor: token.controlItemBgHover
                        },
                        ...(0, $cd5a520fee8002b4$export$a44db842bcb28231)(token),
                        '&-selected': {
                            color: token.colorPrimary,
                            backgroundColor: token.controlItemBgActive,
                            '&:hover, &-active': {
                                backgroundColor: token.controlItemBgActiveHover
                            }
                        },
                        '&-disabled': {
                            color: colorTextDisabled,
                            cursor: 'not-allowed',
                            '&:hover': {
                                color: colorTextDisabled,
                                backgroundColor: colorBgElevated,
                                cursor: 'not-allowed'
                            },
                            a: {
                                pointerEvents: 'none'
                            }
                        },
                        '&-divider': {
                            height: 1,
                            // By design
                            margin: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.marginXXS)} 0`,
                            overflow: 'hidden',
                            lineHeight: 0,
                            backgroundColor: token.colorSplit
                        },
                        [`${componentCls}-menu-submenu-expand-icon`]: {
                            position: 'absolute',
                            insetInlineEnd: token.paddingXS,
                            [`${componentCls}-menu-submenu-arrow-icon`]: {
                                marginInlineEnd: '0 !important',
                                color: token.colorIcon,
                                fontSize: fontSizeIcon,
                                fontStyle: 'normal'
                            }
                        }
                    },
                    [`${menuCls}-item-group-list`]: {
                        margin: `0 ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.marginXS)}`,
                        padding: 0,
                        listStyle: 'none'
                    },
                    [`${menuCls}-submenu-title`]: {
                        paddingInlineEnd: token.calc(controlPaddingHorizontal).add(token.fontSizeSM).equal()
                    },
                    [`${menuCls}-submenu-vertical`]: {
                        position: 'relative'
                    },
                    [`${menuCls}-submenu${menuCls}-submenu-disabled ${componentCls}-menu-submenu-title`]: {
                        [`&, ${componentCls}-menu-submenu-arrow-icon`]: {
                            color: colorTextDisabled,
                            backgroundColor: colorBgElevated,
                            cursor: 'not-allowed'
                        }
                    },
                    // https://github.com/ant-design/ant-design/issues/19264
                    [`${menuCls}-submenu-selected ${componentCls}-menu-submenu-title`]: {
                        color: token.colorPrimary
                    }
                }
            }
        },
        // Follow code may reuse in other components
        [
            (0, $8c07f7e527e50277$export$9018e60daecf7a6c)(token, 'slide-up'),
            (0, $8c07f7e527e50277$export$9018e60daecf7a6c)(token, 'slide-down'),
            (0, $8c07f7e527e50277$export$9018e60daecf7a6c)(token, 'slide-left'),
            (0, $8c07f7e527e50277$export$9018e60daecf7a6c)(token, 'slide-right'),
            (0, $87a972ff193f83db$export$913b1b7e3288c319)(token, 'move-up'),
            (0, $87a972ff193f83db$export$913b1b7e3288c319)(token, 'move-down'),
            (0, $67ba63c38ba87091$export$f5d123412490d9dc)(token, 'zoom-big')
        ]
    ];
};
const $20f075b77f81743f$export$9ca1be8807fe0675 = (token)=>({
        zIndexPopup: token.zIndexPopupBase + 50,
        paddingBlock: (token.controlHeight - token.fontSize * token.lineHeight) / 2,
        ...(0, $2540b05188c79e49$export$bddc192327bb9823)({
            contentRadius: token.borderRadiusLG,
            limitVerticalRadius: true
        }),
        ...(0, $0c98a14a5d55f8de$export$87e38ee403661ccc)(token)
    });
var $20f075b77f81743f$export$2e2bcd8739ae039 = (0, $761caadb5301aee1$export$51ec95de45185b42)('Dropdown', (token)=>{
    const { marginXXS: marginXXS, sizePopupArrow: sizePopupArrow, paddingXXS: paddingXXS, componentCls: componentCls } = token;
    const dropdownToken = (0, $f564548c7b6877d5$export$4950aa0f605343fb)(token, {
        menuCls: `${componentCls}-menu`,
        dropdownArrowDistance: token.calc(sizePopupArrow).div(2).add(marginXXS).equal(),
        dropdownEdgeChildPadding: paddingXXS
    });
    return [
        $20f075b77f81743f$var$genBaseStyle(dropdownToken),
        (0, $66c5ba076ed71439$export$2e2bcd8739ae039)(dropdownToken)
    ];
}, $20f075b77f81743f$export$9ca1be8807fe0675, {
    resetStyle: false
});


"use client";
const $48aadfccbf606fc4$var$_Placements = [
    'topLeft',
    'topCenter',
    'topRight',
    'bottomLeft',
    'bottomCenter',
    'bottomRight',
    'top',
    'bottom',
    'left',
    'leftTop',
    'leftBottom',
    'right',
    'rightTop',
    'rightBottom'
];
const $48aadfccbf606fc4$var$Dropdown = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { menu: menu, arrow: arrow, prefixCls: customizePrefixCls, children: children, trigger: trigger, disabled: disabled, dropdownRender: dropdownRender, popupRender: popupRender, getPopupContainer: getPopupContainer, overlayClassName: overlayClassName, rootClassName: rootClassName, overlayStyle: overlayStyle, open: open, onOpenChange: onOpenChange, mouseEnterDelay: mouseEnterDelay = 0.15, mouseLeaveDelay: mouseLeaveDelay = 0.1, autoAdjustOverflow: autoAdjustOverflow = true, placement: placement = '', transitionName: transitionName, classNames: classNames, styles: styles, destroyPopupOnHide: destroyPopupOnHide, destroyOnHidden: destroyOnHidden } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, getPopupContainer: getContextPopupContainer, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $519f2fad435b3034$export$46f4bd6436a25a31)('dropdown');
    const mergedProps = {
        ...props,
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        autoAdjustOverflow: autoAdjustOverflow
    };
    const contextStyleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(contextStyle);
    const overlayStyleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(overlayStyle);
    const [mergedClassNames, mergedStyles] = (0, $722c8632ba7bdb89$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        overlayStyleRoot
    ], {
        props: mergedProps
    });
    const mergedRootStyles = {
        ...mergedStyles.root
    };
    const mergedPopupRender = popupRender || dropdownRender;
    // =================== Warning =====================
    const warning = (0, $bedf93c14dee83a9$export$cf977aa92c751e61)('Dropdown');
    var deprecatedName, newName;
    const memoTransitionName = $5E6i4.useMemo(()=>{
        const rootPrefixCls = getPrefixCls();
        if (transitionName !== undefined) return transitionName;
        if (placement.startsWith('top')) return `${rootPrefixCls}-slide-down`;
        if (placement.startsWith('left')) return `${rootPrefixCls}-slide-right`;
        if (placement.startsWith('right')) return `${rootPrefixCls}-slide-left`;
        return `${rootPrefixCls}-slide-up`;
    }, [
        getPrefixCls,
        placement,
        transitionName
    ]);
    const memoPlacement = $5E6i4.useMemo(()=>{
        if (!placement) return direction === 'rtl' ? 'bottomRight' : 'bottomLeft';
        if (placement.includes('Center')) return placement.slice(0, placement.indexOf('Center'));
        return placement;
    }, [
        placement,
        direction
    ]);
    const prefixCls = getPrefixCls('dropdown', customizePrefixCls);
    const rootCls = (0, $d104ec5f99ed66d7$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $20f075b77f81743f$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const [, token] = (0, $cb3a44f4e76623bb$export$2e2bcd8739ae039)();
    const child = $5E6i4.Children.only((0, $addbc2fddcbb77a9$export$c3825b437cbdea5c)(children) ? /*#__PURE__*/ $5E6i4.createElement("span", null, children) : children);
    const composedRef = (0, $92c8c75386168ffc$export$1d1c999670a1285d)(ref, (0, $92c8c75386168ffc$export$7465e5c0bf44f19a)(child));
    const popupTrigger = (0, $552e20b6ec4e63a6$export$e530037191fcd5d7)(child, {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-trigger`, {
            [`${prefixCls}-rtl`]: direction === 'rtl'
        }, child.props.className),
        disabled: child.props.disabled ?? disabled,
        ref: composedRef
    });
    const triggerActions = disabled ? [] : trigger;
    const alignPoint = !!triggerActions?.includes('contextMenu');
    // =========================== Open ============================
    const [mergedOpen, setOpen] = (0, $e18df22f16a16360$export$2e2bcd8739ae039)(false, open);
    const onInnerOpenChange = (0, $68990f4402d2f009$export$2e2bcd8739ae039)((nextOpen)=>{
        onOpenChange?.(nextOpen, {
            source: 'trigger'
        });
        setOpen(nextOpen);
    });
    // =========================== Overlay ============================
    const overlayClassNameCustomized = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(overlayClassName, rootClassName, hashId, cssVarCls, rootCls, contextClassName, mergedClassNames.root, {
        [`${prefixCls}-rtl`]: direction === 'rtl'
    });
    const builtinPlacements = (0, $08f8f8640738851c$export$2e2bcd8739ae039)({
        arrowPointAtCenter: (0, $addbc2fddcbb77a9$export$53b83ca8eaab0383)(arrow) && arrow.pointAtCenter,
        autoAdjustOverflow: autoAdjustOverflow,
        offset: token.marginXXS,
        arrowWidth: arrow ? token.sizePopupArrow : 0,
        borderRadius: token.borderRadius
    });
    const onMenuClick = (0, $68990f4402d2f009$export$2e2bcd8739ae039)(()=>{
        if (menu?.selectable && menu?.multiple) return;
        onOpenChange?.(false, {
            source: 'menu'
        });
        setOpen(false);
    });
    const renderOverlay = ()=>{
        // @rc-component/dropdown already can process the function of overlay, but we have check logic here.
        // So we need render the element to check and pass back to @rc-component/dropdown.
        const menuClassNames = (0, $48bd91d9f828de66$export$2e2bcd8739ae039)(mergedClassNames, [
            'root'
        ]);
        const menuStyles = (0, $48bd91d9f828de66$export$2e2bcd8739ae039)(mergedStyles, [
            'root'
        ]);
        let overlayNode;
        if (menu?.items) overlayNode = /*#__PURE__*/ $5E6i4.createElement((0, $1484b8ab934a06cc$export$2e2bcd8739ae039), {
            ...menu,
            classNames: {
                ...menuClassNames,
                subMenu: {
                    ...menuClassNames
                }
            },
            styles: {
                ...menuStyles,
                subMenu: {
                    ...menuStyles
                }
            }
        });
        if (mergedPopupRender) overlayNode = mergedPopupRender(overlayNode);
        if ((0, $addbc2fddcbb77a9$export$844ec244b1367d54)(overlayNode)) overlayNode = /*#__PURE__*/ $5E6i4.createElement("span", null, overlayNode);
        else if (!/*#__PURE__*/ $5E6i4.isValidElement(overlayNode)) overlayNode = /*#__PURE__*/ $5E6i4.createElement($5E6i4.Fragment, null, overlayNode);
        return /*#__PURE__*/ $5E6i4.createElement((0, $b83dcf2c28e9b9a5$export$9bd434816b0530d0), {
            prefixCls: `${prefixCls}-menu`,
            rootClassName: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(cssVarCls, rootCls),
            expandIcon: /*#__PURE__*/ $5E6i4.createElement("span", {
                className: `${prefixCls}-menu-submenu-arrow`
            }, direction === 'rtl' ? /*#__PURE__*/ $5E6i4.createElement((0, $2abf808b8f2c53a3$export$2e2bcd8739ae039), {
                className: `${prefixCls}-menu-submenu-arrow-icon`
            }) : /*#__PURE__*/ $5E6i4.createElement((0, $adbdeb3aab803740$export$2e2bcd8739ae039), {
                className: `${prefixCls}-menu-submenu-arrow-icon`
            })),
            mode: "vertical",
            selectable: false,
            onClick: onMenuClick,
            validator: ({ mode: mode })=>{}
        }, overlayNode);
    };
    // =========================== zIndex ============================
    const [zIndex, contextZIndex] = (0, $09c5eb33e460ecef$export$3e7906d4075187a4)('Dropdown', mergedRootStyles.zIndex);
    // ============================ Render ============================
    let renderNode = /*#__PURE__*/ $5E6i4.createElement((0, $3b318c9105776b14$export$2e2bcd8739ae039), {
        alignPoint: alignPoint,
        ...(0, $48bd91d9f828de66$export$2e2bcd8739ae039)(props, [
            'rootClassName',
            'onOpenChange'
        ]),
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        visible: mergedOpen,
        builtinPlacements: builtinPlacements,
        arrow: !!arrow,
        overlayClassName: overlayClassNameCustomized,
        prefixCls: prefixCls,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        transitionName: memoTransitionName,
        trigger: triggerActions,
        overlay: renderOverlay,
        placement: memoPlacement,
        onVisibleChange: onInnerOpenChange,
        overlayStyle: {
            ...mergedRootStyles,
            zIndex: zIndex
        },
        autoDestroy: destroyOnHidden ?? destroyPopupOnHide
    }, popupTrigger);
    if (zIndex) renderNode = /*#__PURE__*/ $5E6i4.createElement((0, $c8c4739fe508f3df$export$2e2bcd8739ae039).Provider, {
        value: contextZIndex
    }, renderNode);
    return renderNode;
});
// We don't care debug panel
const $48aadfccbf606fc4$var$PurePanel = (0, $f49bb770731dacb5$export$2e2bcd8739ae039)($48aadfccbf606fc4$var$Dropdown, 'align', undefined, 'dropdown', (prefixCls)=>prefixCls);
/* istanbul ignore next */ const $48aadfccbf606fc4$var$WrapPurePanel = (props)=>/*#__PURE__*/ $5E6i4.createElement($48aadfccbf606fc4$var$PurePanel, {
        ...props
    }, /*#__PURE__*/ $5E6i4.createElement("span", null));
$48aadfccbf606fc4$var$Dropdown._InternalPanelDoNotUseOrYouWillBeFired = $48aadfccbf606fc4$var$WrapPurePanel;
var $48aadfccbf606fc4$export$2e2bcd8739ae039 = $48aadfccbf606fc4$var$Dropdown;



var $5E6i4 = parcelRequire("5E6i4");






var $5E6i4 = parcelRequire("5E6i4");



function $2a93086f522f4afc$export$f5153c3888a6824e(size) {
    return [
        'small',
        'middle',
        'medium',
        'large'
    ].includes(size);
}
function $2a93086f522f4afc$export$1b502d0a9135d42b(size) {
    if (!size) // The case of size = 0 is deliberately excluded here, because the default value of the gap attribute in CSS is 0, so if the user passes 0 in, we can directly ignore it.
    return false;
    return (0, $addbc2fddcbb77a9$export$7e4aa119212bc614)(size);
}







var $5E6i4 = parcelRequire("5E6i4");


const $842ff74e676bf26d$var$_InputStatuses = [
    'warning',
    'error',
    '',
    'success',
    'validating'
];
const $842ff74e676bf26d$export$b08e7b47149942a2 = (prefixCls, status, hasFeedback)=>{
    return (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)({
        [`${prefixCls}-status-success`]: status === 'success',
        [`${prefixCls}-status-warning`]: status === 'warning',
        [`${prefixCls}-status-error`]: status === 'error',
        [`${prefixCls}-status-validating`]: status === 'validating',
        [`${prefixCls}-has-feedback`]: hasFeedback
    });
};
const $842ff74e676bf26d$export$314e193082d7ba49 = (contextStatus, customStatus)=>customStatus || contextStatus;








const $688c572bd35bcabd$var$genSpaceAddonStyle = (token)=>{
    const { componentCls: componentCls, borderRadius: borderRadius, paddingSM: paddingSM, colorBorder: colorBorder, paddingXS: paddingXS, fontSizeLG: fontSizeLG, fontSizeSM: fontSizeSM, borderRadiusLG: borderRadiusLG, borderRadiusSM: borderRadiusSM, colorBgContainerDisabled: colorBgContainerDisabled, lineWidth: lineWidth, lineType: lineType, antCls: antCls } = token;
    const [varName, varRef] = (0, $761caadb5301aee1$export$d82b8f66c5649e14)(antCls, 'space-addon');
    return {
        [componentCls]: [
            // ==========================================================
            // ==                         Base                         ==
            // ==========================================================
            {
                ...(0, $cd5a520fee8002b4$export$23997c3e44cc1c59)(token),
                display: 'inline-flex',
                alignItems: 'center',
                gap: 0,
                whiteSpace: 'nowrap',
                paddingInline: paddingSM,
                margin: 0,
                borderWidth: lineWidth,
                borderStyle: lineType,
                borderRadius: borderRadius,
                '&:hover': {
                    zIndex: 0
                },
                [`&${componentCls}-disabled`]: {
                    color: token.colorTextDisabled
                },
                '&-large': {
                    fontSize: fontSizeLG,
                    borderRadius: borderRadiusLG
                },
                '&-small': {
                    paddingInline: paddingXS,
                    borderRadius: borderRadiusSM,
                    fontSize: fontSizeSM
                },
                '&-compact-last-item': {
                    borderEndStartRadius: 0,
                    borderStartStartRadius: 0
                },
                '&-compact-first-item': {
                    borderEndEndRadius: 0,
                    borderStartEndRadius: 0
                },
                '&-compact-item:not(:first-child):not(:last-child)': {
                    borderRadius: 0
                },
                '&-compact-item:not(:last-child)': {
                    borderInlineEndWidth: 0
                },
                '&-compact-item:not(:first-child)': {
                    borderInlineStartWidth: 0
                }
            },
            // ==========================================================
            // ==                       Variants                       ==
            // ==========================================================
            {
                [varName('addon-border-color')]: colorBorder,
                [varName('addon-background')]: colorBgContainerDisabled,
                // Filled
                [varName('addon-border-color-outlined')]: colorBorder,
                [varName('addon-background-filled')]: colorBgContainerDisabled,
                borderColor: varRef('addon-border-color'),
                background: varRef('addon-background'),
                // ======================= Outlined =======================
                '&-variant-outlined': {
                    [varName('addon-border-color')]: varRef('addon-border-color-outlined')
                },
                // ======================== Filled ========================
                '&-variant-filled': {
                    [varName('addon-border-color')]: 'transparent',
                    [varName('addon-background')]: varRef('addon-background-filled'),
                    // Disabled
                    [`&${componentCls}-disabled`]: {
                        [varName('addon-border-color')]: colorBorder,
                        [varName('addon-background')]: colorBgContainerDisabled
                    }
                },
                // ====================== Borderless ======================
                '&-variant-borderless': {
                    border: 'none',
                    background: 'transparent'
                },
                // ====================== Underlined ======================
                '&-variant-underlined': {
                    border: 'none',
                    background: 'transparent'
                }
            },
            // ==========================================================
            // ==                        Status                        ==
            // ==========================================================
            {
                '&-status-error': {
                    [varName('addon-border-color-outlined')]: token.colorError,
                    [varName('addon-background-filled')]: token.colorErrorBg,
                    color: token.colorError
                },
                '&-status-warning': {
                    [varName('addon-border-color-outlined')]: token.colorWarning,
                    [varName('addon-background-filled')]: token.colorWarningBg,
                    color: token.colorWarning
                }
            }
        ]
    };
};
var // ============================== Export ==============================
$688c572bd35bcabd$export$2e2bcd8739ae039 = (0, $761caadb5301aee1$export$51ec95de45185b42)('Addon', (token)=>[
        $688c572bd35bcabd$var$genSpaceAddonStyle(token),
        (0, $1829499b88c32c7f$export$b1208b23589b4b73)(token, {
            focus: false
        })
    ]);


"use client";
const $ed27646e7d1d36cb$var$SpaceAddon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).forwardRef((props, ref)=>{
    const { className: className, children: children, style: style, prefixCls: customizePrefixCls, variant: variant = 'outlined', disabled: disabled, status: status, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, direction: directionConfig } = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useContext((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('space-addon', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $688c572bd35bcabd$export$2e2bcd8739ae039)(prefixCls);
    const { compactItemClassnames: compactItemClassnames, compactSize: compactSize } = (0, $3ee2444c5d59b36b$export$cd8cf9d7bab8dd4)(prefixCls, directionConfig);
    const statusCls = (0, $842ff74e676bf26d$export$b08e7b47149942a2)(prefixCls, status);
    const classes = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, hashId, compactItemClassnames, cssVarCls, `${prefixCls}-variant-${variant}`, statusCls, {
        [`${prefixCls}-${compactSize}`]: compactSize,
        [`${prefixCls}-disabled`]: disabled
    }, className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("div", {
        ref: ref,
        className: classes,
        style: style,
        ...restProps
    }, children);
});
var $ed27646e7d1d36cb$export$2e2bcd8739ae039 = $ed27646e7d1d36cb$var$SpaceAddon;




var $5E6i4 = parcelRequire("5E6i4");
const $e4e17868e2a9921a$export$853f607fd5cc208b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createContext({
    latestIndex: 0
});
const $e4e17868e2a9921a$export$2bbf36e6e96e17f9 = $e4e17868e2a9921a$export$853f607fd5cc208b.Provider;



var $5E6i4 = parcelRequire("5E6i4");



"use client";
const $6158362c5471d371$var$Item = (props)=>{
    const { className: className, prefix: prefix, index: index, children: children, separator: separator, style: style, classNames: classNames, styles: styles } = props;
    const { latestIndex: latestIndex } = $5E6i4.useContext((0, $e4e17868e2a9921a$export$853f607fd5cc208b));
    if (!(0, $b63de2b9864a5d1a$export$72280d5f896dac9a)(children)) return null;
    return /*#__PURE__*/ $5E6i4.createElement($5E6i4.Fragment, null, /*#__PURE__*/ $5E6i4.createElement("div", {
        className: className,
        style: style
    }, children), index < latestIndex && separator && /*#__PURE__*/ $5E6i4.createElement("span", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefix}-item-separator`, classNames?.separator),
        style: styles?.separator
    }, separator));
};
var $6158362c5471d371$export$2e2bcd8739ae039 = $6158362c5471d371$var$Item;



const $ab8d4558013926e9$var$genSpaceStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    return {
        [componentCls]: {
            display: 'inline-flex',
            '&-rtl': {
                direction: 'rtl'
            },
            '&-vertical': {
                flexDirection: 'column'
            },
            '&-align': {
                flexDirection: 'column',
                '&-center': {
                    alignItems: 'center'
                },
                '&-start': {
                    alignItems: 'flex-start'
                },
                '&-end': {
                    alignItems: 'flex-end'
                },
                '&-baseline': {
                    alignItems: 'baseline'
                }
            },
            [`${componentCls}-item:empty`]: {
                display: 'none'
            },
            // https://github.com/ant-design/ant-design/issues/47875
            [`${componentCls}-item > ${antCls}-badge-not-a-wrapper:only-child`]: {
                display: 'block'
            }
        }
    };
};
const $ab8d4558013926e9$var$genSpaceGapStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            '&-gap-row-small': {
                rowGap: token.spaceGapSmallSize
            },
            '&-gap-row-medium, &-gap-row-middle': {
                rowGap: token.spaceGapMiddleSize
            },
            '&-gap-row-large': {
                rowGap: token.spaceGapLargeSize
            },
            '&-gap-col-small': {
                columnGap: token.spaceGapSmallSize
            },
            '&-gap-col-medium, &-gap-col-middle': {
                columnGap: token.spaceGapMiddleSize
            },
            '&-gap-col-large': {
                columnGap: token.spaceGapLargeSize
            }
        }
    };
};
const $ab8d4558013926e9$export$9ca1be8807fe0675 = ()=>({});
var $ab8d4558013926e9$export$2e2bcd8739ae039 = (0, $761caadb5301aee1$export$51ec95de45185b42)('Space', (token)=>{
    const spaceToken = (0, $f564548c7b6877d5$export$4950aa0f605343fb)(token, {
        spaceGapSmallSize: token.paddingXS,
        spaceGapMiddleSize: token.padding,
        spaceGapLargeSize: token.paddingLG
    });
    return [
        $ab8d4558013926e9$var$genSpaceStyle(spaceToken),
        $ab8d4558013926e9$var$genSpaceGapStyle(spaceToken)
    ];
}, ()=>({}), {
    // Space component don't apply extra font style
    // https://github.com/ant-design/ant-design/issues/40315
    resetStyle: false
});


"use client";
const $600e3c8417a6a15e$var$InternalSpace = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { getPrefixCls: getPrefixCls, direction: directionConfig, size: contextSize, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $519f2fad435b3034$export$46f4bd6436a25a31)('space');
    const { size: size = contextSize ?? 'small', align: align, className: className, rootClassName: rootClassName, children: children, direction: direction, orientation: orientation, prefixCls: customizePrefixCls, split: split, separator: separator, style: style, vertical: vertical, wrap: wrap = false, classNames: classNames, styles: styles, ...restProps } = props;
    const [horizontalSize, verticalSize] = Array.isArray(size) ? size : [
        size,
        size
    ];
    const isPresetVerticalSize = (0, $2a93086f522f4afc$export$f5153c3888a6824e)(verticalSize);
    const isPresetHorizontalSize = (0, $2a93086f522f4afc$export$f5153c3888a6824e)(horizontalSize);
    const isValidVerticalSize = (0, $2a93086f522f4afc$export$1b502d0a9135d42b)(verticalSize);
    const isValidHorizontalSize = (0, $2a93086f522f4afc$export$1b502d0a9135d42b)(horizontalSize);
    const childNodes = (0, $2ec1a2166f2295ea$export$2e2bcd8739ae039)(children, {
        keepEmpty: true
    });
    const [mergedOrientation, mergedVertical] = (0, $a77e455e2dd6afec$export$550084c67147f6c4)(orientation, vertical, direction);
    const mergedAlign = align === undefined && !mergedVertical ? 'center' : align;
    const mergedSeparator = separator ?? split;
    const prefixCls = getPrefixCls('space', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $ab8d4558013926e9$export$2e2bcd8739ae039)(prefixCls);
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        size: size,
        orientation: mergedOrientation,
        align: mergedAlign
    };
    const contextStyleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $722c8632ba7bdb89$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    });
    const rootClassNames = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, contextClassName, hashId, `${prefixCls}-${mergedOrientation}`, {
        [`${prefixCls}-rtl`]: directionConfig === 'rtl',
        [`${prefixCls}-align-${mergedAlign}`]: mergedAlign,
        [`${prefixCls}-gap-row-${verticalSize}`]: isPresetVerticalSize,
        [`${prefixCls}-gap-col-${horizontalSize}`]: isPresetHorizontalSize
    }, className, rootClassName, cssVarCls, mergedClassNames.root);
    const itemClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-item`, mergedClassNames.item);
    // Calculate latest one
    const renderedItems = childNodes.map((child, i)=>{
        const key = child?.key || `${itemClassName}-${i}`;
        return /*#__PURE__*/ $5E6i4.createElement((0, $6158362c5471d371$export$2e2bcd8739ae039), {
            prefix: prefixCls,
            classNames: mergedClassNames,
            styles: mergedStyles,
            className: itemClassName,
            key: key,
            index: i,
            separator: mergedSeparator,
            style: mergedStyles.item
        }, child);
    });
    var deprecatedName, newName;
    const memoizedSpaceContext = $5E6i4.useMemo(()=>{
        const calcLatestIndex = childNodes.reduce((latest, child, i)=>(0, $b63de2b9864a5d1a$export$72280d5f896dac9a)(child) ? i : latest, 0);
        return {
            latestIndex: calcLatestIndex
        };
    }, [
        childNodes
    ]);
    // =========================== Render ===========================
    if (childNodes.length === 0) return null;
    const gapStyle = {};
    if (wrap) gapStyle.flexWrap = 'wrap';
    if (!isPresetHorizontalSize && isValidHorizontalSize) gapStyle.columnGap = horizontalSize;
    if (!isPresetVerticalSize && isValidVerticalSize) gapStyle.rowGap = verticalSize;
    return /*#__PURE__*/ $5E6i4.createElement("div", {
        ref: ref,
        className: rootClassNames,
        style: {
            ...gapStyle,
            ...mergedStyles.root
        },
        ...restProps
    }, /*#__PURE__*/ $5E6i4.createElement((0, $e4e17868e2a9921a$export$2bbf36e6e96e17f9), {
        value: memoizedSpaceContext
    }, renderedItems));
});
const $600e3c8417a6a15e$var$Space = $600e3c8417a6a15e$var$InternalSpace;
$600e3c8417a6a15e$var$Space.Compact = (0, $3ee2444c5d59b36b$export$2e2bcd8739ae039);
$600e3c8417a6a15e$var$Space.Addon = (0, $ed27646e7d1d36cb$export$2e2bcd8739ae039);
var $600e3c8417a6a15e$export$2e2bcd8739ae039 = $600e3c8417a6a15e$var$Space;




"use client";
/** @deprecated Please use Space.Compact + Dropdown + Button instead */ const $8f3eadf279bdf10e$var$DropdownButton = (props)=>{
    const { getPopupContainer: getContextPopupContainer, getPrefixCls: getPrefixCls, direction: direction } = $5E6i4.useContext((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, type: type = 'default', danger: danger, disabled: disabled, loading: loading, onClick: onClick, htmlType: htmlType, children: children, className: className, menu: menu, arrow: arrow, autoFocus: autoFocus, trigger: trigger, align: align, open: open, onOpenChange: onOpenChange, placement: placement, getPopupContainer: getPopupContainer, href: href, icon: icon = /*#__PURE__*/ $5E6i4.createElement((0, $bc99f102364e8dbf$export$2e2bcd8739ae039), null), title: title, buttonsRender: buttonsRender = (buttons)=>buttons, mouseEnterDelay: mouseEnterDelay, mouseLeaveDelay: mouseLeaveDelay, overlayClassName: overlayClassName, overlayStyle: overlayStyle, destroyOnHidden: destroyOnHidden, destroyPopupOnHide: destroyPopupOnHide, dropdownRender: dropdownRender, popupRender: popupRender, ...restProps } = props;
    const prefixCls = getPrefixCls('dropdown', customizePrefixCls);
    const buttonPrefixCls = `${prefixCls}-button`;
    const mergedPopupRender = popupRender || dropdownRender;
    const dropdownProps = {
        menu: menu,
        arrow: arrow,
        autoFocus: autoFocus,
        align: align,
        disabled: disabled,
        trigger: disabled ? [] : trigger,
        onOpenChange: onOpenChange,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        classNames: {
            root: overlayClassName
        },
        styles: {
            root: overlayStyle
        },
        destroyOnHidden: destroyOnHidden,
        popupRender: mergedPopupRender
    };
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $3ee2444c5d59b36b$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    const classes = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(buttonPrefixCls, compactItemClassnames, className);
    if ('destroyPopupOnHide' in props) dropdownProps.destroyPopupOnHide = destroyPopupOnHide;
    if ('open' in props) dropdownProps.open = open;
    if ('placement' in props) dropdownProps.placement = placement;
    else dropdownProps.placement = direction === 'rtl' ? 'bottomLeft' : 'bottomRight';
    const leftButton = /*#__PURE__*/ $5E6i4.createElement((0, $67d71c16fdfc3a0e$export$2e2bcd8739ae039), {
        type: type,
        danger: danger,
        disabled: disabled,
        loading: loading,
        onClick: onClick,
        htmlType: htmlType,
        href: href,
        title: title
    }, children);
    const rightButton = /*#__PURE__*/ $5E6i4.createElement((0, $67d71c16fdfc3a0e$export$2e2bcd8739ae039), {
        type: type,
        danger: danger,
        icon: icon
    });
    const [leftButtonToRender, rightButtonToRender] = buttonsRender([
        leftButton,
        rightButton
    ]);
    return /*#__PURE__*/ $5E6i4.createElement((0, $600e3c8417a6a15e$export$2e2bcd8739ae039).Compact, {
        className: classes,
        size: compactSize,
        block: true,
        ...restProps
    }, leftButtonToRender, /*#__PURE__*/ $5E6i4.createElement((0, $48aadfccbf606fc4$export$2e2bcd8739ae039), {
        ...dropdownProps
    }, rightButtonToRender));
};
$8f3eadf279bdf10e$var$DropdownButton.__ANT_BUTTON = true;
var $8f3eadf279bdf10e$export$2e2bcd8739ae039 = $8f3eadf279bdf10e$var$DropdownButton;


"use client";
const $c89b7140c7bc4e1c$var$Dropdown = (0, $48aadfccbf606fc4$export$2e2bcd8739ae039);
/** @deprecated Please use Space.Compact + Dropdown + Button instead */ $c89b7140c7bc4e1c$var$Dropdown.Button = (0, $8f3eadf279bdf10e$export$2e2bcd8739ae039);
var $c89b7140c7bc4e1c$export$2e2bcd8739ae039 = $c89b7140c7bc4e1c$var$Dropdown;



var $5E6i4 = parcelRequire("5E6i4");







function $73ff02dfd36c3bf1$export$2e2bcd8739ae039(siders, children, hasSider) {
    if (typeof hasSider === 'boolean') return hasSider;
    if (siders.length) return true;
    const childNodes = (0, $2ec1a2166f2295ea$export$2e2bcd8739ae039)(children);
    return childNodes.some((node)=>node.type === (0, $21140119f2dfebfc$export$2e2bcd8739ae039));
}



"use client";
const $2949b49e9d7ed968$var$generator = ({ suffixCls: suffixCls, tagName: tagName, displayName: displayName })=>{
    return (Component)=>{
        const Adapter = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>/*#__PURE__*/ $5E6i4.createElement(Component, {
                ref: ref,
                suffixCls: suffixCls,
                tagName: tagName,
                ...props
            }));
        return Adapter;
    };
};
const $2949b49e9d7ed968$var$Basic = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, suffixCls: suffixCls, className: className, tagName: TagName, ...others } = props;
    const { getPrefixCls: getPrefixCls } = $5E6i4.useContext((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('layout', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $79da6f68f93f41b6$export$2e2bcd8739ae039)(prefixCls);
    const prefixWithSuffixCls = suffixCls ? `${prefixCls}-${suffixCls}` : prefixCls;
    return /*#__PURE__*/ $5E6i4.createElement(TagName, {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(customizePrefixCls || prefixWithSuffixCls, className, hashId, cssVarCls),
        ref: ref,
        ...others
    });
});
const $2949b49e9d7ed968$var$BasicLayout = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { direction: direction } = $5E6i4.useContext((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
    const [siders, setSiders] = $5E6i4.useState([]);
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, children: children, hasSider: hasSider, tagName: Tag, style: style, ...others } = props;
    const passedProps = (0, $48bd91d9f828de66$export$2e2bcd8739ae039)(others, [
        'suffixCls'
    ]);
    const { getPrefixCls: getPrefixCls, className: contextClassName, style: contextStyle } = (0, $519f2fad435b3034$export$46f4bd6436a25a31)('layout');
    const prefixCls = getPrefixCls('layout', customizePrefixCls);
    const mergedHasSider = (0, $73ff02dfd36c3bf1$export$2e2bcd8739ae039)(siders, children, hasSider);
    const [hashId, cssVarCls] = (0, $79da6f68f93f41b6$export$2e2bcd8739ae039)(prefixCls);
    const classString = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, {
        [`${prefixCls}-has-sider`]: mergedHasSider,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, contextClassName, className, rootClassName, hashId, cssVarCls);
    const contextValue = $5E6i4.useMemo(()=>({
            siderHook: {
                addSider: (id)=>{
                    setSiders((prev)=>[].concat((0, $0acfae8147afe964$export$2e2bcd8739ae039)(prev), [
                            id
                        ]));
                },
                removeSider: (id)=>{
                    setSiders((prev)=>prev.filter((currentId)=>currentId !== id));
                }
            }
        }), []);
    return /*#__PURE__*/ $5E6i4.createElement((0, $0a263b6875575b1e$export$964282a2c3979546).Provider, {
        value: contextValue
    }, /*#__PURE__*/ $5E6i4.createElement(Tag, {
        ref: ref,
        className: classString,
        style: {
            ...contextStyle,
            ...style
        },
        ...passedProps
    }, children));
});
const $2949b49e9d7ed968$var$Layout = $2949b49e9d7ed968$var$generator({
    tagName: 'div',
    displayName: 'Layout'
})($2949b49e9d7ed968$var$BasicLayout);
const $2949b49e9d7ed968$export$8b251419efc915eb = $2949b49e9d7ed968$var$generator({
    suffixCls: 'header',
    tagName: 'header',
    displayName: 'Header'
})($2949b49e9d7ed968$var$Basic);
const $2949b49e9d7ed968$export$a06f1c675e846f6f = $2949b49e9d7ed968$var$generator({
    suffixCls: 'footer',
    tagName: 'footer',
    displayName: 'Footer'
})($2949b49e9d7ed968$var$Basic);
const $2949b49e9d7ed968$export$7c6e2c02157bb7d2 = $2949b49e9d7ed968$var$generator({
    suffixCls: 'content',
    tagName: 'main',
    displayName: 'Content'
})($2949b49e9d7ed968$var$Basic);
var $2949b49e9d7ed968$export$2e2bcd8739ae039 = $2949b49e9d7ed968$var$Layout;



"use client";
const $0d4ee2ac959080b7$var$Layout = (0, $2949b49e9d7ed968$export$2e2bcd8739ae039);
$0d4ee2ac959080b7$var$Layout.Header = (0, $2949b49e9d7ed968$export$8b251419efc915eb);
$0d4ee2ac959080b7$var$Layout.Footer = (0, $2949b49e9d7ed968$export$a06f1c675e846f6f);
$0d4ee2ac959080b7$var$Layout.Content = (0, $2949b49e9d7ed968$export$7c6e2c02157bb7d2);
$0d4ee2ac959080b7$var$Layout.Sider = (0, $21140119f2dfebfc$export$2e2bcd8739ae039);
$0d4ee2ac959080b7$var$Layout._InternalSiderContext = (0, $21140119f2dfebfc$export$63554aebd2a6d54c);
var $0d4ee2ac959080b7$export$2e2bcd8739ae039 = $0d4ee2ac959080b7$var$Layout;



var $5E6i4 = parcelRequire("5E6i4");


var $5E6i4 = parcelRequire("5E6i4");
const $cbccb1f5ff19b737$export$264c6064649f9206 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createContext({});
const $cbccb1f5ff19b737$var$AppContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createContext({
    message: {},
    notification: {},
    modal: {}
});
var $cbccb1f5ff19b737$export$2e2bcd8739ae039 = $cbccb1f5ff19b737$var$AppContext;




var $5E6i4 = parcelRequire("5E6i4");


var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");

var $ibUU1 = parcelRequire("ibUU1");





var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");
function $3370bb1a953355bc$export$2e2bcd8739ae039() {
    const [sizeMap, setSizeMap] = $5E6i4.useState({});
    const setNodeSize = $5E6i4.useCallback((key, node)=>{
        if (!node) {
            setSizeMap((prevSizeMap)=>{
                if (!(key in prevSizeMap)) return prevSizeMap;
                const nextSizeMap = {
                    ...prevSizeMap
                };
                delete nextSizeMap[key];
                return nextSizeMap;
            });
            return;
        }
        const nextSize = {
            width: node.offsetWidth,
            height: node.offsetHeight
        };
        setSizeMap((prevSizeMap)=>{
            const prevSize = prevSizeMap[key];
            if (prevSize && prevSize.width === nextSize.width && prevSize.height === nextSize.height) return prevSizeMap;
            return {
                ...prevSizeMap,
                [key]: nextSize
            };
        });
    }, []);
    return [
        sizeMap,
        setNodeSize
    ];
}


function $cb9a7291304f48d8$export$2e2bcd8739ae039(configList, stack, gap = 0) {
    const [sizeMap, setNodeSize] = (0, $3370bb1a953355bc$export$2e2bcd8739ae039)();
    const [notificationPosition, totalHeight, topNoticeHeight, topNoticeWidth] = $5E6i4.useMemo(()=>{
        let offsetY = 0;
        let nextTotalHeight = 0;
        const stackThreshold = stack?.threshold ?? 0;
        const nextNotificationPosition = new Map();
        let nextTopNoticeHeight;
        let nextTopNoticeWidth;
        configList.slice().reverse().forEach((config, index)=>{
            // Walk from newest to oldest so each notice can be positioned after the ones below it.
            const key = String(config.key);
            const height = sizeMap[key]?.height ?? 0;
            const y = stack && index > 0 ? offsetY + (stack.offset ?? 0) - height : offsetY;
            nextNotificationPosition.set(key, y);
            if (index === 0) {
                nextTopNoticeHeight = height;
                nextTopNoticeWidth = sizeMap[key]?.width ?? 0;
            }
            if (!stack || index < stackThreshold) nextTotalHeight = Math.max(nextTotalHeight, y + height);
            if (stack) offsetY = y + height;
            else offsetY += height + gap;
        });
        return [
            nextNotificationPosition,
            nextTotalHeight,
            nextTopNoticeHeight,
            nextTopNoticeWidth
        ];
    }, [
        configList,
        gap,
        sizeMap,
        stack
    ]);
    return [
        notificationPosition,
        setNodeSize,
        totalHeight,
        topNoticeHeight,
        topNoticeWidth
    ];
}


const $dae05e4b904ac6a8$var$DEFAULT_OFFSET = 8;
const $dae05e4b904ac6a8$var$DEFAULT_THRESHOLD = 3;
/**
 * Resolves the stack setting into an enabled flag and normalized stack params.
 */ const $dae05e4b904ac6a8$var$useStack = (config)=>{
    const result = {
        offset: $dae05e4b904ac6a8$var$DEFAULT_OFFSET,
        threshold: $dae05e4b904ac6a8$var$DEFAULT_THRESHOLD
    };
    if (config && typeof config === 'object') {
        result.offset = config.offset ?? $dae05e4b904ac6a8$var$DEFAULT_OFFSET;
        result.threshold = config.threshold ?? $dae05e4b904ac6a8$var$DEFAULT_THRESHOLD;
    }
    return [
        !!config,
        result
    ];
};
var $dae05e4b904ac6a8$export$2e2bcd8739ae039 = $dae05e4b904ac6a8$var$useStack;



var $5E6i4 = parcelRequire("5E6i4");


var $5E6i4 = parcelRequire("5E6i4");

function $4e5d3d03dc6fbdca$export$2e2bcd8739ae039(duration, onClose, onUpdate) {
    const mergedDuration = typeof duration === 'number' ? duration : 0;
    const durationMs = Math.max(mergedDuration, 0) * 1000;
    const onEventClose = (0, $68990f4402d2f009$export$2e2bcd8739ae039)(onClose);
    const onEventUpdate = (0, $68990f4402d2f009$export$2e2bcd8739ae039)(onUpdate);
    const [walking, setWalking] = $5E6i4.useState(durationMs > 0);
    const passTimeRef = $5E6i4.useRef(0);
    const lastRafTimeRef = $5E6i4.useRef(null);
    function syncPassTime() {
        const now = Date.now();
        const lastRafTime = lastRafTimeRef.current;
        if (lastRafTime !== null) passTimeRef.current += now - lastRafTime;
        lastRafTimeRef.current = now;
    }
    const onPause = $5E6i4.useCallback(()=>{
        syncPassTime();
        lastRafTimeRef.current = null;
        setWalking(false);
    }, []);
    const onResume = $5E6i4.useCallback(()=>{
        if (durationMs > 0) {
            lastRafTimeRef.current = Date.now();
            setWalking(true);
        } else onEventUpdate(0);
    }, [
        durationMs
    ]);
    // Reset when durationMs changed.
    $5E6i4.useEffect(()=>{
        passTimeRef.current = 0;
        setWalking(durationMs > 0);
    }, [
        durationMs
    ]);
    // Trigger update when walking changed.
    $5E6i4.useEffect(()=>{
        if (!walking) return;
        let rafId = null;
        function step() {
            syncPassTime();
            if (passTimeRef.current >= durationMs) {
                onEventUpdate(1);
                onEventClose();
            } else {
                onEventUpdate(Math.min(passTimeRef.current / durationMs, 1));
                rafId = (0, $1d949665862f071a$export$2e2bcd8739ae039)(step);
            }
        }
        step();
        return ()=>{
            (0, $1d949665862f071a$export$2e2bcd8739ae039).cancel(rafId);
        };
    }, [
        durationMs,
        walking
    ]);
    return [
        onResume,
        onPause
    ];
}





var $5E6i4 = parcelRequire("5E6i4");
function $7d2bfdb8e30062c8$export$2e2bcd8739ae039(closable) {
    // Convert boolean shorthand into the object shape used by render logic.
    const closableObj = $5E6i4.useMemo(()=>{
        if (closable === false) return {
            closeIcon: null,
            disabled: true
        };
        if (typeof closable === 'object' && closable !== null) return closable;
        return {};
    }, [
        closable
    ]);
    // Fill defaults so callers can read closeIcon and disabled without extra guards.
    const closableConfig = $5E6i4.useMemo(()=>({
            ...closableObj,
            closeIcon: 'closeIcon' in closableObj ? closableObj.closeIcon : "\xd7",
            disabled: closableObj.disabled ?? false
        }), [
        closableObj
    ]);
    // Forward aria-* props from the closable config to the close button.
    const closableAriaProps = $5E6i4.useMemo(()=>(0, $78cde6532419ffca$export$2e2bcd8739ae039)(closableConfig, true), [
        closableConfig
    ]);
    return [
        !!closable,
        closableConfig,
        closableAriaProps
    ];
}



var $5E6i4 = parcelRequire("5E6i4");
const $e73128e61b0dcbe3$var$Progress = ({ className: className, style: style, percent: percent })=>/*#__PURE__*/ $5E6i4.createElement("progress", {
        className: className,
        max: "100",
        value: percent,
        style: style
    });
var $e73128e61b0dcbe3$export$2e2bcd8739ae039 = $e73128e61b0dcbe3$var$Progress;


function $047ae74c4e01bbbb$var$_extends() {
    $047ae74c4e01bbbb$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $047ae74c4e01bbbb$var$_extends.apply(this, arguments);
}
const $047ae74c4e01bbbb$var$Notification = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { prefixCls: // Style
    prefixCls, className: className, style: style, classNames: classNames, styles: styles, components: components, title: // UI
    title, description: description, icon: icon, actions: actions, role: role, closable: closable, offset: offset, notificationIndex: notificationIndex, stackInThreshold: stackInThreshold, props: rootProps, duration: // Behavior
    duration = 4.5, showProgress: showProgress, hovering: forcedHovering, pauseOnHover: pauseOnHover = true, onClick: // Function
    onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onClose: onClose } = props;
    const [percent, setPercent] = $5E6i4.useState(0);
    const noticePrefixCls = `${prefixCls}-notice`;
    // ========================= Close ==========================
    const [mergedClosable, closableConfig, closeBtnAriaProps] = (0, $7d2bfdb8e30062c8$export$2e2bcd8739ae039)(closable);
    const onInternalClose = (0, $68990f4402d2f009$export$2e2bcd8739ae039)(()=>{
        closableConfig.onClose?.();
        onClose?.();
    });
    // ======================== Duration ========================
    const [hovering, setHovering] = $5E6i4.useState(false);
    const [onResume, onPause] = (0, $4e5d3d03dc6fbdca$export$2e2bcd8739ae039)(duration, onInternalClose, setPercent);
    const validPercent = 100 - Math.min(Math.max(percent * 100, 0), 100);
    const Progress = components?.progress || (0, $e73128e61b0dcbe3$export$2e2bcd8739ae039);
    $5E6i4.useEffect(()=>{
        if (!pauseOnHover) return;
        if (forcedHovering) onPause();
        else if (!hovering) onResume();
    }, [
        forcedHovering,
        hovering,
        onPause,
        onResume,
        pauseOnHover
    ]);
    // ========================= Hover ==========================
    function onInternalMouseEnter(event) {
        setHovering(true);
        if (pauseOnHover) onPause();
        onMouseEnter?.(event);
    }
    function onInternalMouseLeave(event) {
        setHovering(false);
        if (pauseOnHover && !forcedHovering) onResume();
        onMouseLeave?.(event);
    }
    function onInternalCloseClick(event) {
        event.preventDefault();
        event.stopPropagation();
        onInternalClose();
    }
    const destroy = (0, $68990f4402d2f009$export$2e2bcd8739ae039)(()=>{
        if (hovering) onInternalMouseLeave();
    });
    $5E6i4.useEffect(()=>destroy, [
        destroy
    ]);
    // ======================== Position ========================
    const offsetRef = $5E6i4.useRef(offset);
    if (offset !== undefined) offsetRef.current = offset;
    const notificationIndexRef = $5E6i4.useRef(notificationIndex);
    if (notificationIndex !== undefined) notificationIndexRef.current = notificationIndex;
    const mergedOffset = offset ?? offsetRef.current;
    const mergedNotificationIndex = notificationIndex ?? notificationIndexRef.current ?? 0;
    // ======================== Content =========================
    const titleNode = (0, $b63de2b9864a5d1a$export$826fff653a329e83)(title) ? /*#__PURE__*/ $5E6i4.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${noticePrefixCls}-title`, classNames?.title),
        style: styles?.title
    }, title) : null;
    const descNode = (0, $b63de2b9864a5d1a$export$826fff653a329e83)(description) ? /*#__PURE__*/ $5E6i4.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${noticePrefixCls}-description`, classNames?.description),
        style: styles?.description
    }, description) : null;
    const hasTitle = titleNode !== null;
    const hasDescription = descNode !== null;
    let contentNode;
    if (hasTitle && hasDescription) contentNode = /*#__PURE__*/ $5E6i4.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${noticePrefixCls}-section`, classNames?.section),
        style: styles?.section
    }, titleNode, descNode);
    else contentNode = titleNode || descNode;
    if ((0, $b63de2b9864a5d1a$export$826fff653a329e83)(icon)) contentNode = /*#__PURE__*/ $5E6i4.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${noticePrefixCls}-wrapper`, classNames?.wrapper),
        style: styles?.wrapper
    }, /*#__PURE__*/ $5E6i4.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${noticePrefixCls}-icon`, classNames?.icon),
        style: styles?.icon
    }, icon), contentNode);
    const actionsNode = (0, $b63de2b9864a5d1a$export$72280d5f896dac9a)(actions) ? /*#__PURE__*/ $5E6i4.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${noticePrefixCls}-actions`, classNames?.actions),
        style: styles?.actions
    }, actions) : null;
    // ========================= Render =========================
    const mergedStyle = {
        '--notification-index': mergedNotificationIndex,
        ...styles?.root,
        ...style
    };
    if (mergedOffset !== undefined) mergedStyle['--notification-y'] = `${mergedOffset}px`;
    const mergedRole = role ?? rootProps?.role ?? 'alert';
    return /*#__PURE__*/ $5E6i4.createElement("div", $047ae74c4e01bbbb$var$_extends({}, rootProps, {
        ref: ref,
        role: mergedRole,
        "data-notification-index": mergedNotificationIndex,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(noticePrefixCls, className, classNames?.root, {
            [`${noticePrefixCls}-closable`]: mergedClosable,
            [`${noticePrefixCls}-stack-in-threshold`]: stackInThreshold
        }),
        style: mergedStyle,
        onClick: onClick,
        onMouseEnter: onInternalMouseEnter,
        onMouseLeave: onInternalMouseLeave
    }), contentNode, actionsNode, mergedClosable && /*#__PURE__*/ $5E6i4.createElement("button", $047ae74c4e01bbbb$var$_extends({
        type: "button",
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${noticePrefixCls}-close`, classNames?.close),
        "aria-label": "Close"
    }, closeBtnAriaProps, {
        style: styles?.close,
        onClick: onInternalCloseClick
    }), closableConfig.closeIcon), showProgress && typeof duration === 'number' && duration > 0 && /*#__PURE__*/ $5E6i4.createElement(Progress, {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${noticePrefixCls}-progress`, classNames?.progress),
        percent: validPercent,
        style: styles?.progress
    }));
});
var $047ae74c4e01bbbb$export$2e2bcd8739ae039 = $047ae74c4e01bbbb$var$Notification;



var $5E6i4 = parcelRequire("5E6i4");
const $0d25818a64481fb8$export$a6e93d8cb5d50678 = /*#__PURE__*/ $5E6i4.createContext({});
const $0d25818a64481fb8$var$NotificationProvider = ({ children: children, classNames: classNames })=>{
    const context = $5E6i4.useMemo(()=>({
            classNames: classNames
        }), [
        classNames
    ]);
    return /*#__PURE__*/ $5E6i4.createElement($0d25818a64481fb8$export$a6e93d8cb5d50678.Provider, {
        value: context
    }, children);
};
var $0d25818a64481fb8$export$2e2bcd8739ae039 = $0d25818a64481fb8$var$NotificationProvider;




var $5E6i4 = parcelRequire("5E6i4");
function $94d77353fb02e719$var$_extends() {
    $94d77353fb02e719$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $94d77353fb02e719$var$_extends.apply(this, arguments);
}
const $94d77353fb02e719$var$Content = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { listPrefixCls: listPrefixCls, height: height, topNoticeHeight: topNoticeHeight = 0, topNoticeWidth: topNoticeWidth = 0, className: className, style: style, ...restProps } = props;
    const contentPrefixCls = `${listPrefixCls}-content`;
    // ========================= Height =========================
    const prevHeightRef = $5E6i4.useRef(height);
    const prevHeight = prevHeightRef.current;
    const heightStatus = height < prevHeight ? 'decrease' : 'increase';
    prevHeightRef.current = height;
    // ========================= Style ==========================
    const contentStyle = {
        ...style,
        height: height,
        '--top-notificiation-height': `${topNoticeHeight}px`,
        '--top-notificiation-width': `${topNoticeWidth}px`
    };
    // ========================= Render =========================
    return /*#__PURE__*/ $5E6i4.createElement("div", $94d77353fb02e719$var$_extends({}, restProps, {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(contentPrefixCls, `${contentPrefixCls}-${heightStatus}`, className),
        style: contentStyle,
        ref: ref
    }));
});
var $94d77353fb02e719$export$2e2bcd8739ae039 = $94d77353fb02e719$var$Content;


function $8d0340406e9f50c0$var$_extends() {
    $8d0340406e9f50c0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8d0340406e9f50c0$var$_extends.apply(this, arguments);
}
const $8d0340406e9f50c0$var$noticeSlotKeys = [
    'wrapper',
    'root',
    'icon',
    'section',
    'title',
    'description',
    'actions',
    'close',
    'progress'
];
function $8d0340406e9f50c0$var$fillClassNames(classNamesList) {
    return $8d0340406e9f50c0$var$noticeSlotKeys.reduce((mergedClassNames, key)=>{
        mergedClassNames[key] = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(...classNamesList.map((classNames)=>classNames?.[key]));
        return mergedClassNames;
    }, {});
}
function $8d0340406e9f50c0$var$fillStyles(stylesList) {
    return $8d0340406e9f50c0$var$noticeSlotKeys.reduce((mergedStyles, key)=>{
        mergedStyles[key] = Object.assign({}, ...stylesList.map((styles)=>styles?.[key]));
        return mergedStyles;
    }, {});
}
function $8d0340406e9f50c0$var$getIndex(keys, key) {
    const strKey = String(key);
    const index = keys.findIndex((item)=>item.key === strKey);
    if (index === -1) return undefined;
    return keys.length - index - 1;
}
const $8d0340406e9f50c0$var$NotificationListItem = (props)=>{
    const { config: config, components: components, contextClassNames: contextClassNames, classNames: classNames, styles: styles, className: className, style: style, nodeRef: nodeRef, listHovering: listHovering, stackEnabled: stackEnabled, pauseOnHover: pauseOnHover, setNodeSize: setNodeSize, onNoticeClose: onNoticeClose, ...restProps } = props;
    const { key: key, placement: itemPlacement, ...notificationConfig } = config;
    const strKey = String(key);
    const setItemRef = $5E6i4.useCallback((node)=>{
        setNodeSize(strKey, node);
    }, [
        setNodeSize,
        strKey
    ]);
    const ref = (0, $92c8c75386168ffc$export$1d1c999670a1285d)(nodeRef, setItemRef);
    return /*#__PURE__*/ $5E6i4.createElement((0, $047ae74c4e01bbbb$export$2e2bcd8739ae039), $8d0340406e9f50c0$var$_extends({}, notificationConfig, restProps, {
        ref: ref,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(contextClassNames?.notice, config.className, className),
        style: {
            ...style,
            ...config.style
        },
        classNames: $8d0340406e9f50c0$var$fillClassNames([
            classNames,
            config.classNames
        ]),
        styles: $8d0340406e9f50c0$var$fillStyles([
            styles,
            config.styles
        ]),
        components: {
            ...components,
            ...config.components
        },
        hovering: stackEnabled && listHovering,
        pauseOnHover: config.pauseOnHover ?? pauseOnHover,
        onClose: ()=>{
            config.onClose?.();
            onNoticeClose?.(key);
        }
    }));
};
const $8d0340406e9f50c0$var$NotificationList = (props)=>{
    const { configList: configList = [], prefixCls: prefixCls = 'rc-notification', pauseOnHover: pauseOnHover, classNames: classNames, styles: styles, components: components, stack: stackConfig, motion: motion, placement: placement, className: className, style: style, onNoticeClose: onNoticeClose, onAllRemoved: onAllRemoved } = props;
    const { classNames: contextClassNames } = $5E6i4.useContext((0, $0d25818a64481fb8$export$a6e93d8cb5d50678));
    // ========================== Data ==========================
    const keys = $5E6i4.useMemo(()=>configList.map((config)=>({
                config: config,
                key: String(config.key)
            })), [
        configList
    ]);
    // ===================== Motion Config ======================
    const placementMotion = typeof motion === 'function' ? motion(placement) : motion;
    // ====================== Stack State =======================
    const [stackEnabled, { offset: offset, threshold: threshold }] = (0, $dae05e4b904ac6a8$export$2e2bcd8739ae039)(stackConfig);
    const [listHovering, setListHovering] = $5E6i4.useState(false);
    const expanded = stackEnabled && (listHovering || keys.length <= threshold);
    // ====================== Stack Layout ======================
    const stackPosition = $5E6i4.useMemo(()=>{
        if (!stackEnabled || expanded) return undefined;
        return {
            offset: offset,
            threshold: threshold
        };
    }, [
        expanded,
        offset,
        stackEnabled,
        threshold
    ]);
    // ====================== List Measure ======================
    const [gap, setGap] = $5E6i4.useState(0);
    const contentRef = $5E6i4.useRef(null);
    const [notificationPosition, setNodeSize, totalHeight, topNoticeHeight, topNoticeWidth] = (0, $cb9a7291304f48d8$export$2e2bcd8739ae039)(configList, stackPosition, gap);
    const hasConfigList = !!configList.length;
    $5E6i4.useEffect(()=>{
        const listNode = contentRef.current;
        if (!listNode) return;
        // CSS gap impacts stack offset and total list height calculation.
        const { gap: cssGap, rowGap: rowGap } = window.getComputedStyle(listNode);
        const nextGap = parseFloat(rowGap || cssGap) || 0;
        setGap((prevGap)=>prevGap === nextGap ? prevGap : nextGap);
    }, [
        hasConfigList
    ]);
    // ========================= Render =========================
    const listPrefixCls = `${prefixCls}-list`;
    return /*#__PURE__*/ $5E6i4.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, listPrefixCls, `${prefixCls}-${placement}`, contextClassNames?.list, className, classNames?.list, {
            [`${prefixCls}-stack`]: stackEnabled,
            [`${prefixCls}-stack-expanded`]: expanded,
            [`${listPrefixCls}-hovered`]: listHovering
        }),
        style: {
            ...styles?.list,
            ...style
        }
    }, /*#__PURE__*/ $5E6i4.createElement((0, $94d77353fb02e719$export$2e2bcd8739ae039), {
        listPrefixCls: listPrefixCls,
        height: totalHeight,
        topNoticeHeight: topNoticeHeight,
        topNoticeWidth: topNoticeWidth,
        className: classNames?.listContent,
        style: styles?.listContent,
        ref: contentRef,
        onMouseEnter: ()=>{
            setListHovering(true);
        },
        onMouseLeave: ()=>{
            setListHovering(false);
        }
    }, /*#__PURE__*/ $5E6i4.createElement((0, $f8bf6ab12693d160$export$2e2bcd8739ae039), $8d0340406e9f50c0$var$_extends({
        component: false,
        keys: keys,
        motionAppear: true
    }, placementMotion, {
        onAllRemoved: ()=>{
            if (placement) onAllRemoved?.(placement);
        }
    }), ({ config: config, className: motionClassName, style: motionStyle }, nodeRef)=>{
        const { key: key } = config;
        const strKey = String(key);
        const notificationIndex = $8d0340406e9f50c0$var$getIndex(keys, key);
        const stackInThreshold = stackEnabled && notificationIndex !== undefined && notificationIndex < threshold;
        return /*#__PURE__*/ $5E6i4.createElement($8d0340406e9f50c0$var$NotificationListItem, {
            key: key,
            config: config,
            components: components,
            contextClassNames: contextClassNames,
            classNames: classNames,
            styles: styles,
            className: motionClassName,
            style: motionStyle,
            nodeRef: nodeRef,
            prefixCls: prefixCls,
            offset: notificationPosition.get(strKey),
            notificationIndex: notificationIndex,
            stackInThreshold: stackInThreshold,
            listHovering: listHovering,
            stackEnabled: stackEnabled,
            pauseOnHover: pauseOnHover,
            setNodeSize: setNodeSize,
            onNoticeClose: onNoticeClose
        });
    })));
};
var $8d0340406e9f50c0$export$2e2bcd8739ae039 = $8d0340406e9f50c0$var$NotificationList;


// ========================= Types ==========================
const $6cd62c021c7dca39$var$Notifications = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    // ========================= Props ==========================
    const { prefixCls: prefixCls = 'rc-notification', container: container, motion: motion, maxCount: maxCount, pauseOnHover: pauseOnHover, classNames: classNames, styles: styles, components: components, className: className, style: style, onAllRemoved: onAllRemoved, stack: stack, renderNotifications: renderNotifications } = props;
    // ========================= State ==========================
    const [configList, setConfigList] = $5E6i4.useState([]);
    const [placements, setPlacements] = $5E6i4.useState({});
    const emptyRef = $5E6i4.useRef(false);
    // ========================== Ref ===========================
    $5E6i4.useImperativeHandle(ref, ()=>({
            open: (config)=>{
                setConfigList((list)=>{
                    let clone = [
                        ...list
                    ];
                    const index = clone.findIndex((item)=>item.key === config.key);
                    const innerConfig = {
                        ...config
                    };
                    if (index >= 0) {
                        innerConfig.times = (list[index]?.times ?? 0) + 1;
                        clone[index] = innerConfig;
                    } else {
                        innerConfig.times = 0;
                        clone.push(innerConfig);
                    }
                    if (maxCount && maxCount > 0 && clone.length > maxCount) clone = clone.slice(-maxCount);
                    return clone;
                });
            },
            close: (key)=>{
                setConfigList((list)=>list.filter((item)=>item.key !== key));
            },
            destroy: ()=>{
                setConfigList([]);
            }
        }));
    // ======================== Effect =========================
    $5E6i4.useEffect(()=>{
        const nextPlacements = {};
        configList.forEach((config)=>{
            const placement = config.placement ?? 'topRight';
            nextPlacements[placement] = nextPlacements[placement] || [];
            nextPlacements[placement].push(config);
        });
        Object.keys(placements).forEach((placement)=>{
            nextPlacements[placement] = nextPlacements[placement] || [];
        });
        setPlacements(nextPlacements);
    }, [
        configList
    ]);
    // ======================== Callback =======================
    const onAllNoticeRemoved = (0, $68990f4402d2f009$export$2e2bcd8739ae039)((placement)=>{
        setPlacements((originPlacements)=>{
            const clone = {
                ...originPlacements
            };
            if (!(clone[placement] || []).length) delete clone[placement];
            return clone;
        });
    });
    // ======================== Effect =========================
    $5E6i4.useEffect(()=>{
        if (Object.keys(placements).length > 0) emptyRef.current = true;
        else if (emptyRef.current) {
            onAllRemoved?.();
            emptyRef.current = false;
        }
    }, [
        placements,
        onAllRemoved
    ]);
    // ======================== Render =========================
    if (!container) return null;
    const placementList = Object.keys(placements);
    return /*#__PURE__*/ (0, $ibUU1.createPortal)(/*#__PURE__*/ $5E6i4.createElement($5E6i4.Fragment, null, placementList.map((placement)=>{
        const list = /*#__PURE__*/ $5E6i4.createElement((0, $8d0340406e9f50c0$export$2e2bcd8739ae039), {
            key: placement,
            configList: placements[placement],
            placement: placement,
            prefixCls: prefixCls,
            pauseOnHover: pauseOnHover,
            classNames: classNames,
            styles: styles,
            components: components,
            className: className?.(placement),
            style: style?.(placement),
            motion: motion,
            stack: stack,
            onNoticeClose: (key)=>{
                setConfigList((oriList)=>oriList.filter((item)=>item.key !== key));
            },
            onAllRemoved: onAllNoticeRemoved
        });
        return renderNotifications ? /*#__PURE__*/ $5E6i4.cloneElement(renderNotifications(list, {
            prefixCls: prefixCls,
            key: placement
        }), {
            key: placement
        }) : list;
    })), container);
});
var $6cd62c021c7dca39$export$2e2bcd8739ae039 = $6cd62c021c7dca39$var$Notifications;


const $b626ec7a92ea27ca$var$defaultGetContainer = ()=>document.body;
// ========================= Types ==========================
// ======================== Helper ==========================
let $b626ec7a92ea27ca$var$uniqueKey = 0;
function $b626ec7a92ea27ca$var$mergeConfig(...objList) {
    const clone = {};
    objList.forEach((obj)=>{
        if (obj) Object.keys(obj).forEach((key)=>{
            const value = obj[key];
            if (value !== undefined) clone[key] = value;
        });
    });
    return clone;
}
function $b626ec7a92ea27ca$export$2e2bcd8739ae039(rootConfig = {}) {
    // ========================= Config =========================
    const { getContainer: getContainer = $b626ec7a92ea27ca$var$defaultGetContainer, motion: motion, prefixCls: prefixCls, placement: placement, closable: closable, duration: duration, showProgress: showProgress, pauseOnHover: pauseOnHover, classNames: classNames, styles: styles, components: components, maxCount: maxCount, className: className, style: style, onAllRemoved: onAllRemoved, stack: stack, renderNotifications: renderNotifications } = rootConfig;
    const shareConfig = {
        placement: placement,
        closable: closable,
        duration: duration,
        showProgress: showProgress
    };
    // ========================= Holder =========================
    const [container, setContainer] = $5E6i4.useState();
    const notificationsRef = $5E6i4.useRef(null);
    const [taskQueue, setTaskQueue] = $5E6i4.useState([]);
    const contextHolder = /*#__PURE__*/ $5E6i4.createElement((0, $6cd62c021c7dca39$export$2e2bcd8739ae039), {
        container: container,
        ref: notificationsRef,
        prefixCls: prefixCls,
        motion: motion,
        maxCount: maxCount,
        pauseOnHover: pauseOnHover,
        classNames: classNames,
        styles: styles,
        components: components,
        className: className,
        style: style,
        onAllRemoved: onAllRemoved,
        stack: stack,
        renderNotifications: renderNotifications
    });
    // ========================== API ==========================
    const open = (0, $68990f4402d2f009$export$2e2bcd8739ae039)((config)=>{
        const mergedConfig = $b626ec7a92ea27ca$var$mergeConfig(shareConfig, config);
        if (mergedConfig.key === null || mergedConfig.key === undefined) {
            mergedConfig.key = `rc-notification-${$b626ec7a92ea27ca$var$uniqueKey}`;
            $b626ec7a92ea27ca$var$uniqueKey += 1;
        }
        setTaskQueue((queue)=>[
                ...queue,
                {
                    type: 'open',
                    config: mergedConfig
                }
            ]);
    });
    const api = $5E6i4.useMemo(()=>({
            open: open,
            close: (key)=>{
                setTaskQueue((queue)=>[
                        ...queue,
                        {
                            type: 'close',
                            key: key
                        }
                    ]);
            },
            destroy: ()=>{
                setTaskQueue((queue)=>[
                        ...queue,
                        {
                            type: 'destroy'
                        }
                    ]);
            }
        }), []);
    // ======================== Effect =========================
    // React 18 should all in effect that we will check container in each render
    // Which means getContainer should be stable.
    $5E6i4.useEffect(()=>{
        setContainer(getContainer());
    });
    $5E6i4.useEffect(()=>{
        // Flush task when node ready
        if (notificationsRef.current && taskQueue.length) {
            taskQueue.forEach((task)=>{
                switch(task.type){
                    case 'open':
                        notificationsRef.current?.open(task.config);
                        break;
                    case 'close':
                        notificationsRef.current?.close(task.key);
                        break;
                    case 'destroy':
                        notificationsRef.current?.destroy();
                        break;
                }
            });
            setTaskQueue((originQueue)=>{
                const targetTaskQueue = originQueue.filter((task)=>!taskQueue.includes(task));
                return targetTaskQueue.length === originQueue.length ? originQueue : targetTaskQueue;
            });
        }
    }, [
        taskQueue
    ]);
    // ======================== Return =========================
    return [
        api,
        contextHolder
    ];
}












var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $a83244697c255493$var$CheckCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z"
                }
            }
        ]
    },
    "name": "check-circle",
    "theme": "filled"
};
var $a83244697c255493$export$2e2bcd8739ae039 = $a83244697c255493$var$CheckCircleFilled;



function $b89ac8aaffc055f4$var$_extends() {
    $b89ac8aaffc055f4$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b89ac8aaffc055f4$var$_extends.apply(this, arguments);
}
const $b89ac8aaffc055f4$var$CheckCircleFilled = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $b89ac8aaffc055f4$var$_extends({}, props, {
        ref: ref,
        icon: (0, $a83244697c255493$export$2e2bcd8739ae039)
    }));
/**![check-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0xOTMuNSAzMDEuN2wtMjEwLjYgMjkyYTMxLjggMzEuOCAwIDAxLTUxLjcgMEwzMTguNSA0ODQuOWMtMy44LTUuMyAwLTEyLjcgNi41LTEyLjdoNDYuOWMxMC4yIDAgMTkuOSA0LjkgMjUuOSAxMy4zbDcxLjIgOTguOCAxNTcuMi0yMThjNi04LjMgMTUuNi0xMy4zIDI1LjktMTMuM0g2OTljNi41IDAgMTAuMyA3LjQgNi41IDEyLjd6IiAvPjwvc3ZnPg==) */ const $b89ac8aaffc055f4$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($b89ac8aaffc055f4$var$CheckCircleFilled);
var $b89ac8aaffc055f4$export$2e2bcd8739ae039 = $b89ac8aaffc055f4$var$RefIcon;



var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $a2dfaba8d24901d8$var$CloseCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "fill-rule": "evenodd",
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z"
                }
            }
        ]
    },
    "name": "close-circle",
    "theme": "filled"
};
var $a2dfaba8d24901d8$export$2e2bcd8739ae039 = $a2dfaba8d24901d8$var$CloseCircleFilled;



function $18493f15518cd625$var$_extends() {
    $18493f15518cd625$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $18493f15518cd625$var$_extends.apply(this, arguments);
}
const $18493f15518cd625$var$CloseCircleFilled = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $18493f15518cd625$var$_extends({}, props, {
        ref: ref,
        icon: (0, $a2dfaba8d24901d8$export$2e2bcd8739ae039)
    }));
/**![close-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdmlld0JveD0iNjQgNjQgODk2IDg5NiIgZm9jdXNhYmxlPSJmYWxzZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNTEyIDY0YzI0Ny40IDAgNDQ4IDIwMC42IDQ0OCA0NDhTNzU5LjQgOTYwIDUxMiA5NjAgNjQgNzU5LjQgNjQgNTEyIDI2NC42IDY0IDUxMiA2NHptMTI3Ljk4IDI3NC44MmgtLjA0bC0uMDguMDZMNTEyIDQ2Ni43NSAzODQuMTQgMzM4Ljg4Yy0uMDQtLjA1LS4wNi0uMDYtLjA4LS4wNmEuMTIuMTIgMCAwMC0uMDcgMGMtLjAzIDAtLjA1LjAxLS4wOS4wNWwtNDUuMDIgNDUuMDJhLjIuMiAwIDAwLS4wNS4wOS4xMi4xMiAwIDAwMCAuMDd2LjAyYS4yNy4yNyAwIDAwLjA2LjA2TDQ2Ni43NSA1MTIgMzM4Ljg4IDYzOS44NmMtLjA1LjA0LS4wNi4wNi0uMDYuMDhhLjEyLjEyIDAgMDAwIC4wN2MwIC4wMy4wMS4wNS4wNS4wOWw0NS4wMiA0NS4wMmEuMi4yIDAgMDAuMDkuMDUuMTIuMTIgMCAwMC4wNyAwYy4wMiAwIC4wNC0uMDEuMDgtLjA1TDUxMiA1NTcuMjVsMTI3Ljg2IDEyNy44N2MuMDQuMDQuMDYuMDUuMDguMDVhLjEyLjEyIDAgMDAuMDcgMGMuMDMgMCAuMDUtLjAxLjA5LS4wNWw0NS4wMi00NS4wMmEuMi4yIDAgMDAuMDUtLjA5LjEyLjEyIDAgMDAwLS4wN3YtLjAyYS4yNy4yNyAwIDAwLS4wNS0uMDZMNTU3LjI1IDUxMmwxMjcuODctMTI3Ljg2Yy4wNC0uMDQuMDUtLjA2LjA1LS4wOGEuMTIuMTIgMCAwMDAtLjA3YzAtLjAzLS4wMS0uMDUtLjA1LS4wOWwtNDUuMDItNDUuMDJhLjIuMiAwIDAwLS4wOS0uMDUuMTIuMTIgMCAwMC0uMDcgMHoiIC8+PC9zdmc+) */ const $18493f15518cd625$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($18493f15518cd625$var$CloseCircleFilled);
var $18493f15518cd625$export$2e2bcd8739ae039 = $18493f15518cd625$var$RefIcon;



var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $ac2b545290e237ac$var$ExclamationCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"
                }
            }
        ]
    },
    "name": "exclamation-circle",
    "theme": "filled"
};
var $ac2b545290e237ac$export$2e2bcd8739ae039 = $ac2b545290e237ac$var$ExclamationCircleFilled;



function $02cacf707e93d6b4$var$_extends() {
    $02cacf707e93d6b4$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $02cacf707e93d6b4$var$_extends.apply(this, arguments);
}
const $02cacf707e93d6b4$var$ExclamationCircleFilled = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $02cacf707e93d6b4$var$_extends({}, props, {
        ref: ref,
        icon: (0, $ac2b545290e237ac$export$2e2bcd8739ae039)
    }));
/**![exclamation-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0tMzIgMjMyYzAtNC40IDMuNi04IDgtOGg0OGM0LjQgMCA4IDMuNiA4IDh2MjcyYzAgNC40LTMuNiA4LTggOGgtNDhjLTQuNCAwLTgtMy42LTgtOFYyOTZ6bTMyIDQ0MGE0OC4wMSA0OC4wMSAwIDAxMC05NiA0OC4wMSA0OC4wMSAwIDAxMCA5NnoiIC8+PC9zdmc+) */ const $02cacf707e93d6b4$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($02cacf707e93d6b4$var$ExclamationCircleFilled);
var $02cacf707e93d6b4$export$2e2bcd8739ae039 = $02cacf707e93d6b4$var$RefIcon;



var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $c86723b251f21a5f$var$InfoCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"
                }
            }
        ]
    },
    "name": "info-circle",
    "theme": "filled"
};
var $c86723b251f21a5f$export$2e2bcd8739ae039 = $c86723b251f21a5f$var$InfoCircleFilled;



function $dc185fbb803a7cae$var$_extends() {
    $dc185fbb803a7cae$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dc185fbb803a7cae$var$_extends.apply(this, arguments);
}
const $dc185fbb803a7cae$var$InfoCircleFilled = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $dc185fbb803a7cae$var$_extends({}, props, {
        ref: ref,
        icon: (0, $c86723b251f21a5f$export$2e2bcd8739ae039)
    }));
/**![info-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0zMiA2NjRjMCA0LjQtMy42IDgtOCA4aC00OGMtNC40IDAtOC0zLjYtOC04VjQ1NmMwLTQuNCAzLjYtOCA4LThoNDhjNC40IDAgOCAzLjYgOCA4djI3MnptLTMyLTM0NGE0OC4wMSA0OC4wMSAwIDAxMC05NiA0OC4wMSA0OC4wMSAwIDAxMCA5NnoiIC8+PC9zdmc+) */ const $dc185fbb803a7cae$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($dc185fbb803a7cae$var$InfoCircleFilled);
var $dc185fbb803a7cae$export$2e2bcd8739ae039 = $dc185fbb803a7cae$var$RefIcon;


















// ============================== Shared ==============================
/** Generate motion transitions shared by notification-like notice cards. */ const $b286b96e6d3a2300$var$genNotificationItemMotionStyle = (token)=>{
    const { motionDurationMid: motionDurationMid, motionEaseInOut: motionEaseInOut } = token;
    const transition = `${motionDurationMid} ${motionEaseInOut}`;
    return {
        transform: 'scale(var(--notification-scale, 1))',
        transition: [
            'transform',
            'inset',
            'clip-path',
            'opacity'
        ].map((property)=>`${property} ${transition}`).join(', ')
    };
};
const $b286b96e6d3a2300$export$2ef18ef18abb83d6 = (token, config)=>{
    const { componentCls: componentCls, antCls: antCls, colorSuccess: colorSuccess, colorInfo: colorInfo, colorWarning: colorWarning, colorError: colorError, colorTextHeading: colorTextHeading, colorText: colorText, boxShadow: boxShadow, borderRadiusLG: borderRadiusLG, fontSize: fontSize, lineHeight: lineHeight, notificationBg: notificationBg, notificationPadding: notificationPadding, notificationMarginEdge: notificationMarginEdge, margin: margin, calc: calc } = token;
    const noticeCls = `${componentCls}-notice`;
    const [varName, varRef] = (0, $761caadb5301aee1$export$d82b8f66c5649e14)(antCls, 'notification');
    return {
        [noticeCls]: {
            // ============================== Base ==============================
            position: 'absolute',
            width: config.width,
            maxWidth: `calc(100vw - ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(calc(notificationMarginEdge).mul(2).equal())})`,
            padding: notificationPadding,
            pointerEvents: 'auto',
            [varName('icon-font-size')]: config.iconFontSize,
            [varName('title-font-size')]: config.titleFontSize,
            [varName('title-line-height')]: config.titleLineHeight,
            boxSizing: 'border-box',
            color: colorText,
            background: notificationBg,
            borderRadius: borderRadiusLG,
            boxShadow: boxShadow,
            fontSize: fontSize,
            lineHeight: lineHeight,
            wordWrap: 'break-word',
            overflow: 'visible',
            ...$b286b96e6d3a2300$var$genNotificationItemMotionStyle(token),
            ...config.noticeStyle,
            '&::after': {
                position: 'absolute',
                insetInline: 0,
                top: calc(margin).mul(-1).equal(),
                height: margin,
                content: '""'
            },
            // ============================== Type ==============================
            ...config.typeStyle && {
                '&-success': {
                    background: varRef('color-success-bg', notificationBg)
                },
                '&-error': {
                    background: varRef('color-error-bg', notificationBg)
                },
                '&-info': {
                    background: varRef('color-info-bg', notificationBg)
                },
                '&-warning': {
                    background: varRef('color-warning-bg', notificationBg)
                }
            }
        },
        // ============================ Wrapper ============================
        [`${noticeCls}-wrapper`]: {
            display: 'flex',
            ...config.contentStyle
        },
        [`${noticeCls}-title`]: {
            color: colorTextHeading,
            fontSize: varRef('title-font-size'),
            lineHeight: varRef('title-line-height')
        },
        // ============================= Icon =============================
        // Icon & color style in different selector level
        // https://github.com/ant-design/ant-design/issues/16503
        // https://github.com/ant-design/ant-design/issues/15512
        [`${noticeCls}-icon`]: {
            flex: 'none',
            fontSize: varRef('icon-font-size'),
            lineHeight: 1,
            [`&${noticeCls}-icon-success`]: {
                color: colorSuccess
            },
            [`&${noticeCls}-icon-info, &${noticeCls}-icon-loading`]: {
                color: colorInfo
            },
            [`&${noticeCls}-icon-warning`]: {
                color: colorWarning
            },
            [`&${noticeCls}-icon-error`]: {
                color: colorError
            }
        }
    };
};
// =========================== Notification ===========================
/** Generate the complete notice item styles for Notification. */ const $b286b96e6d3a2300$var$genNotificationItemStyle = (token)=>{
    const { componentCls: componentCls, progressBg: progressBg, notificationProgressHeight: notificationProgressHeight, fontSize: fontSize, borderRadiusLG: borderRadiusLG, width: width, notificationIconSize: notificationIconSize, colorText: colorText, motionDurationMid: motionDurationMid, fontSizeLG: fontSizeLG, lineHeightLG: lineHeightLG, marginSM: marginSM, marginXS: marginXS, paddingLG: paddingLG, notificationPaddingVertical: notificationPaddingVertical, notificationPaddingHorizontal: notificationPaddingHorizontal, notificationCloseButtonSize: notificationCloseButtonSize, colorIcon: colorIcon, borderRadiusSM: borderRadiusSM, colorIconHover: colorIconHover, colorBgTextHover: colorBgTextHover, colorBgTextActive: colorBgTextActive } = token;
    const noticeCls = `${componentCls}-notice`;
    return {
        ...$b286b96e6d3a2300$export$2ef18ef18abb83d6(token, {
            width: width,
            iconFontSize: notificationIconSize,
            titleFontSize: fontSizeLG,
            titleLineHeight: lineHeightLG,
            contentStyle: {
                alignItems: 'flex-start',
                gap: marginSM
            },
            typeStyle: true
        }),
        [`${noticeCls}-section`]: {
            display: 'flex',
            flexDirection: 'column',
            flex: 'auto',
            gap: marginXS,
            minWidth: 0
        },
        [`${noticeCls}-description`]: {
            color: colorText,
            fontSize: fontSize
        },
        [`${noticeCls}-closable`]: {
            [`${noticeCls}-title, ${noticeCls}-description`]: {
                paddingInlineEnd: paddingLG
            },
            [`${noticeCls}-title + ${noticeCls}-description`]: {
                paddingInlineEnd: 0
            }
        },
        // ============================ Close =============================
        [`${noticeCls}-close`]: {
            position: 'absolute',
            top: notificationPaddingVertical,
            insetInlineEnd: notificationPaddingHorizontal,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: notificationCloseButtonSize,
            height: notificationCloseButtonSize,
            color: colorIcon,
            background: 'none',
            border: 'none',
            borderRadius: borderRadiusSM,
            outline: 'none',
            transition: [
                'color',
                'background-color'
            ].map((prop)=>`${prop} ${motionDurationMid}`).join(', '),
            '&:hover': {
                color: colorIconHover,
                backgroundColor: colorBgTextHover
            },
            '&:active': {
                backgroundColor: colorBgTextActive
            },
            ...(0, $cd5a520fee8002b4$export$a44db842bcb28231)(token)
        },
        // =========================== Progress ===========================
        [`${noticeCls}-progress`]: {
            position: 'absolute',
            bottom: 0,
            display: 'block',
            appearance: 'none',
            inlineSize: `calc(100% - ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(borderRadiusLG)} * 2)`,
            blockSize: notificationProgressHeight,
            border: 0,
            left: {
                _skip_check_: true,
                value: borderRadiusLG
            },
            right: {
                _skip_check_: true,
                value: borderRadiusLG
            },
            '&, &::-webkit-progress-bar': {
                borderRadius: borderRadiusLG,
                backgroundColor: 'rgba(0, 0, 0, 0.04)'
            },
            '&::-moz-progress-bar': {
                background: progressBg
            },
            '&::-webkit-progress-value': {
                borderRadius: borderRadiusLG,
                background: progressBg
            }
        },
        // ============================ Action ============================
        [`${noticeCls}-actions`]: {
            float: 'right',
            marginTop: marginSM
        }
    };
};
const $b286b96e6d3a2300$export$aa31f1ca7e17098f = (token)=>{
    const { componentCls: componentCls, width: width } = token;
    const noticeCls = `${componentCls}-notice`;
    const actionsCls = `${noticeCls}-actions`;
    const notificationItemStyle = $b286b96e6d3a2300$var$genNotificationItemStyle(token);
    return {
        [`${noticeCls}-pure-panel`]: {
            width: width,
            maxWidth: '100%',
            ...notificationItemStyle,
            [noticeCls]: {
                ...notificationItemStyle[noticeCls],
                position: 'relative',
                width: '100%',
                maxWidth: '100%'
            },
            [actionsCls]: {
                ...notificationItemStyle[actionsCls],
                float: 'none',
                textAlign: 'end'
            }
        }
    };
};
// ============================== Export ==============================
/** Wrap Notification item styles under the component root selector. */ const $b286b96e6d3a2300$var$genNotificationStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: $b286b96e6d3a2300$var$genNotificationItemStyle(token)
    };
};
var $b286b96e6d3a2300$export$2e2bcd8739ae039 = $b286b96e6d3a2300$var$genNotificationStyle;



const $ce1c57214a2ec850$export$617a29b5d3b30216 = [
    'top',
    'topLeft',
    'topRight',
    'bottom',
    'bottomLeft',
    'bottomRight'
];


const $10aac0a9fef0b4e1$var$notificationMarginEdgeVar = '--notification-margin-edge';
// ============================== Shared ==============================
/** Resolve the opposite block and inline edges for a placement. */ const $10aac0a9fef0b4e1$var$getPlacementOffset = (vertical, horizontal)=>({
        blockEnd: vertical === 'top' ? 'bottom' : 'top',
        inlineEnd: horizontal === 'left' ? 'right' : 'left'
    });
/** Convert placement offsets into the transform used by notice motion. */ const $10aac0a9fef0b4e1$var$getMotionTransform = (motionOffset)=>{
    const x = motionOffset?.x ?? '0';
    const y = motionOffset?.y ?? '0';
    return `translate3d(${x}, ${y}, 0) scale(var(--notification-scale, 1))`;
};
/** Build the placement metadata used by position and motion styles. */ const $10aac0a9fef0b4e1$var$getPlacementStyleConfig = (placement, motionOffset)=>{
    const vertical = placement.startsWith('bottom') ? 'bottom' : 'top';
    const horizontal = placement.endsWith('Right') ? 'right' : 'left';
    const { blockEnd: blockEnd, inlineEnd: inlineEnd } = $10aac0a9fef0b4e1$var$getPlacementOffset(vertical, horizontal);
    const isCenterPlacement = placement === 'top' || placement === 'bottom';
    const offset = placement === 'top' || placement.endsWith('Left') ? `-${motionOffset}` : motionOffset;
    return {
        placement: placement,
        vertical: vertical,
        blockEnd: blockEnd,
        horizontal: horizontal,
        inlineEnd: inlineEnd,
        motionOffset: isCenterPlacement ? {
            x: '-50%',
            y: offset
        } : {
            x: offset
        },
        baseMotionOffset: isCenterPlacement ? {
            x: '-50%'
        } : undefined,
        isCenterPlacement: isCenterPlacement
    };
};
/** Get the list direction for a vertical placement. */ const $10aac0a9fef0b4e1$var$getPlacementFlexDirection = (vertical)=>vertical === 'bottom' ? 'column-reverse' : 'column';
/** Keep configured top/bottom as the visible notice edge while list padding preserves shadows. */ const $10aac0a9fef0b4e1$var$getPlacementInset = (vertical)=>{
    const marginEdge = `var(${$10aac0a9fef0b4e1$var$notificationMarginEdgeVar}, 0px)`;
    return `calc(var(--notification-${vertical}, ${marginEdge}) - ${marginEdge})`;
};
/** Get the transform origin used by stacked notice scaling. */ const $10aac0a9fef0b4e1$var$getPlacementTransformOrigin = (vertical)=>vertical === 'bottom' ? 'center top' : 'center bottom';
/** Calculate the clip offset that preserves stack shadows. */ const $10aac0a9fef0b4e1$var$getStackShadowClipOffset = (token)=>(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.calc(token.marginXXL).mul(-1).equal());
/** Build the default stack clip-path for a visible notice. */ const $10aac0a9fef0b4e1$var$getStackNoticeClipPath = (token)=>{
    const offset = $10aac0a9fef0b4e1$var$getStackShadowClipOffset(token);
    return `inset(${offset} ${offset} ${offset} ${offset})`;
};
/** Build the collapsed stack clip-path for a placement. */ const $10aac0a9fef0b4e1$var$getPlacementStackClipPath = (token, vertical)=>{
    const offset = $10aac0a9fef0b4e1$var$getStackShadowClipOffset(token);
    return vertical === 'bottom' ? `inset(${offset} ${offset} 50% ${offset})` : `inset(50% ${offset} ${offset} ${offset})`;
};
// ============================= Placement =============================
/** Generate styles for a single notification placement. */ const $10aac0a9fef0b4e1$var$genPlacementStyle = (token, config)=>{
    const { componentCls: componentCls } = token;
    const { placement: placement, vertical: vertical, blockEnd: blockEnd, horizontal: horizontal, inlineEnd: inlineEnd, isCenterPlacement: // Horizontal centered
    isCenterPlacement } = config;
    const noticeCls = `${componentCls}-notice`;
    const noticeMotionCls = `${noticeCls}${componentCls}-fade`;
    // Transform used for enter start and leave end states.
    const enterTransform = $10aac0a9fef0b4e1$var$getMotionTransform(config.motionOffset);
    // Transform used when fully visible; top/bottom keep translateX(-50%) for centering.
    const baseTransform = $10aac0a9fef0b4e1$var$getMotionTransform(config.baseMotionOffset);
    const transformOrigin = $10aac0a9fef0b4e1$var$getPlacementTransformOrigin(vertical);
    return {
        [`&${componentCls}-${placement}`]: {
            [vertical]: $10aac0a9fef0b4e1$var$getPlacementInset(vertical),
            [blockEnd]: 'auto',
            display: 'flex',
            flexDirection: $10aac0a9fef0b4e1$var$getPlacementFlexDirection(vertical),
            ...isCenterPlacement ? {
                marginInline: 0,
                left: '50%',
                right: 'auto',
                transform: 'translateX(-50%)'
            } : {
                [horizontal]: 0,
                [inlineEnd]: 'auto'
            },
            [noticeCls]: {
                [vertical]: 'var(--notification-y, 0)',
                ...isCenterPlacement ? {
                    left: '50%',
                    transform: baseTransform
                } : {
                    [horizontal]: 'var(--notification-x, 0)'
                },
                transformOrigin: transformOrigin
            },
            [`${noticeMotionCls}-appear-prepare, ${noticeMotionCls}-enter-prepare`]: {
                opacity: 0,
                transform: enterTransform,
                transition: 'none'
            },
            [`${noticeMotionCls}-appear-start, ${noticeMotionCls}-enter-start`]: {
                opacity: 0,
                transform: enterTransform
            },
            [`${noticeMotionCls}-appear-active, ${noticeMotionCls}-enter-active`]: {
                opacity: 1,
                transform: baseTransform
            },
            [`${noticeMotionCls}-leave`]: {
                pointerEvents: 'none',
                '&-start': {
                    opacity: 1,
                    transform: baseTransform
                },
                '&-active': {
                    opacity: 0,
                    transform: enterTransform
                }
            },
            [`&${componentCls}-stack:not(${componentCls}-stack-expanded)`]: {
                [noticeCls]: {
                    clipPath: $10aac0a9fef0b4e1$var$getPlacementStackClipPath(token, vertical)
                },
                [`${noticeCls}[data-notification-index='0']`]: {
                    clipPath: $10aac0a9fef0b4e1$var$getStackNoticeClipPath(token)
                }
            }
        }
    };
};
/** Generate placement styles for all enabled notification placements. */ const $10aac0a9fef0b4e1$var$genNotificationPlacementRootStyle = (token, placements = (0, $ce1c57214a2ec850$export$617a29b5d3b30216))=>{
    const { notificationMotionOffset: notificationMotionOffset } = token;
    const motionOffset = (0, $56bae8a99c3cba6e$export$523c0b569236b342)(notificationMotionOffset);
    return {
        ...placements.reduce((styles, placement)=>({
                ...styles,
                ...$10aac0a9fef0b4e1$var$genPlacementStyle(token, $10aac0a9fef0b4e1$var$getPlacementStyleConfig(placement, motionOffset))
            }), {})
    };
};
// ============================== Export ==============================
/** Wrap placement styles under the component root selector. */ const $10aac0a9fef0b4e1$var$genNotificationPlacementStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: $10aac0a9fef0b4e1$var$genNotificationPlacementRootStyle(token)
    };
};
var $10aac0a9fef0b4e1$export$2e2bcd8739ae039 = $10aac0a9fef0b4e1$var$genNotificationPlacementStyle;


const $fd09c8db0475e994$var$DEFAULT_COLLAPSED_STACK_VISIBLE_COUNT = 3;
// =============================== Token ===============================
/** Provide default public ComponentToken values for Notification. */ const $fd09c8db0475e994$var$prepareComponentToken = (token)=>({
        zIndexPopup: token.zIndexPopupBase + (0, $09c5eb33e460ecef$export$33ada7d8845f7e5) + 50,
        width: 384,
        progressBg: `linear-gradient(90deg, ${token.colorPrimaryBorderHover}, ${token.colorPrimary})`,
        // Fix notification background color issue
        // https://github.com/ant-design/ant-design/issues/55649
        // https://github.com/ant-design/ant-design/issues/56055
        colorSuccessBg: undefined,
        colorErrorBg: undefined,
        colorInfoBg: undefined,
        colorWarningBg: undefined
    });
const $fd09c8db0475e994$export$9e25a4f60ca05a04 = (token)=>{
    const notificationPaddingVertical = token.paddingMD;
    const notificationPaddingHorizontal = token.paddingLG;
    const notificationToken = (0, $f564548c7b6877d5$export$4950aa0f605343fb)(token, {
        notificationBg: token.colorBgElevated,
        notificationPaddingVertical: notificationPaddingVertical,
        notificationPaddingHorizontal: notificationPaddingHorizontal,
        notificationIconSize: token.calc(token.fontSizeLG).mul(token.lineHeightLG).equal(),
        notificationCloseButtonSize: token.calc(token.controlHeightLG).mul(0.55).equal(),
        notificationMarginBottom: token.margin,
        notificationPadding: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.paddingMD)} ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.paddingContentHorizontalLG)}`,
        notificationMarginEdge: token.marginLG,
        notificationProgressHeight: 2,
        notificationMotionOffset: 64
    });
    return notificationToken;
};
// =============================== List ================================
/** Build a clip-path inset that keeps stack shadows visible. */ const $fd09c8db0475e994$var$getStackNoticeClipPath = (offset)=>`inset(${offset} ${offset} ${offset} ${offset})`;
/** Generate shared list content and motion base styles. */ const $fd09c8db0475e994$var$genNotificationListContentStyle = (token)=>{
    const { componentCls: componentCls, motionDurationMid: motionDurationMid, motionDurationSlow: motionDurationSlow, motionEaseInOut: motionEaseInOut } = token;
    const listCls = `${componentCls}-list`;
    const listContentCls = `${listCls}-content`;
    return {
        [listContentCls]: {
            position: 'relative',
            display: 'flex',
            flexShrink: 0,
            flexDirection: 'column',
            gap: token.notificationMarginBottom,
            width: '100%',
            willChange: 'height, transform',
            transition: 'none',
            pointerEvents: 'auto',
            [`&${listContentCls}-decrease`]: {
                transition: `height calc(${motionDurationSlow} * 2) ${motionEaseInOut} ${motionDurationMid}`
            }
        },
        // ============================ Motion ============================
        [`${componentCls}-fade`]: {
            backfaceVisibility: 'hidden',
            willChange: 'transform, opacity'
        }
    };
};
/** Generate the root holder, list, stack, and RTL styles for notifications. */ const $fd09c8db0475e994$var$genNotificationListStyle = (token, config)=>{
    const { componentCls: componentCls, notificationMarginEdge: notificationMarginEdge } = token;
    const notificationMarginEdgeVar = '--notification-margin-edge';
    const noticeCls = `${componentCls}-notice`;
    const listCls = `${componentCls}-list`;
    const listWidth = config.listWidthKey ? token.calc(token[config.listWidthKey]).add(token.calc(notificationMarginEdge).mul(2)).equal() : '100%';
    const stackVisibleCount = config.stackVisibleCount ?? $fd09c8db0475e994$var$DEFAULT_COLLAPSED_STACK_VISIBLE_COUNT;
    const noticeBeyondStackVisibleCountCls = `${noticeCls}:nth-last-child(n + ${stackVisibleCount + 1})`;
    const stackShadowClipOffset = (0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.calc(token.marginXXL).mul(-1).equal());
    const stackNoticeClipPath = $fd09c8db0475e994$var$getStackNoticeClipPath(stackShadowClipOffset);
    return {
        [componentCls]: {
            ...(0, $cd5a520fee8002b4$export$23997c3e44cc1c59)(token),
            [notificationMarginEdgeVar]: (0, $56bae8a99c3cba6e$export$523c0b569236b342)(notificationMarginEdge),
            // ============================ Holder ============================
            position: 'fixed',
            zIndex: token.zIndexPopup,
            width: listWidth,
            maxWidth: '100vw',
            height: '100vh',
            overflow: 'hidden',
            overscrollBehavior: 'contain',
            [`${componentCls}-hook-holder`]: {
                position: 'relative'
            },
            // ============================= List =============================
            [`&${listCls}`]: {
                maxHeight: '100vh',
                padding: `var(${notificationMarginEdgeVar})`,
                overflowX: 'hidden',
                overflowY: 'auto',
                overscrollBehavior: 'contain',
                scrollbarWidth: 'none',
                pointerEvents: 'none',
                '&::-webkit-scrollbar': {
                    display: 'none',
                    width: 0,
                    height: 0
                }
            },
            ...$fd09c8db0475e994$var$genNotificationListContentStyle(token),
            // ============================ Stack ============================
            [`&${componentCls}-stack`]: {
                [noticeCls]: {
                    clipPath: stackNoticeClipPath
                },
                [`&:not(${componentCls}-stack-expanded)`]: {
                    [noticeCls]: {
                        '--notification-scale': 'calc(1 - min(var(--notification-index, 0), 2) * 0.06)'
                    },
                    [`${noticeCls}:not(${noticeCls}-stack-in-threshold)`]: {
                        opacity: 0,
                        pointerEvents: 'none'
                    },
                    [noticeBeyondStackVisibleCountCls]: {
                        opacity: 0,
                        pointerEvents: 'none'
                    }
                }
            },
            // ============================== RTL =============================
            '&-rtl': {
                direction: 'rtl',
                [`${noticeCls}-actions`]: {
                    float: 'left'
                }
            }
        }
    };
};
const $fd09c8db0475e994$export$773d92576fc40e5 = (0, $761caadb5301aee1$export$1537386bc155ea56)([
    'Notification',
    'PurePanel'
], (token)=>(0, $b286b96e6d3a2300$export$aa31f1ca7e17098f)($fd09c8db0475e994$export$9e25a4f60ca05a04(token)), $fd09c8db0475e994$var$prepareComponentToken);
const $fd09c8db0475e994$export$40038ad09e3efb66 = (token, config)=>{
    const itemStyle = config.itemStyle ?? (0, $b286b96e6d3a2300$export$2e2bcd8739ae039);
    return [
        $fd09c8db0475e994$var$genNotificationListStyle(token, config),
        itemStyle(token),
        (0, $10aac0a9fef0b4e1$export$2e2bcd8739ae039)(token)
    ];
};
var /** Register the main style hook for Notification. */ $fd09c8db0475e994$export$2e2bcd8739ae039 = (0, $761caadb5301aee1$export$51ec95de45185b42)('Notification', (token)=>{
    const notificationToken = $fd09c8db0475e994$export$9e25a4f60ca05a04(token);
    return $fd09c8db0475e994$export$40038ad09e3efb66(notificationToken, {
        listWidthKey: 'width'
    });
}, $fd09c8db0475e994$var$prepareComponentToken);




// =============================== Token ===============================
/** Map Message component tokens onto the shared Notification token shape. */ const $20dbc47c3bf6c1b5$var$prepareMessageToken = (token)=>{
    const messagePaddingVertical = token.calc(token.controlHeightLG).sub(token.calc(token.fontSize).mul(token.lineHeight)).div(2).equal();
    const messagePaddingHorizontal = token.paddingSM;
    return (0, $f564548c7b6877d5$export$4950aa0f605343fb)((0, $fd09c8db0475e994$export$9e25a4f60ca05a04)(token), {
        notificationBg: token.contentBg,
        notificationPadding: token.contentPadding,
        notificationPaddingVertical: messagePaddingVertical,
        notificationPaddingHorizontal: messagePaddingHorizontal
    });
};
/** Provide default public ComponentToken values for Message. */ const $20dbc47c3bf6c1b5$var$prepareComponentToken = (token)=>({
        zIndexPopup: token.zIndexPopupBase + (0, $09c5eb33e460ecef$export$33ada7d8845f7e5) + 10,
        contentBg: token.colorBgElevated,
        contentPadding: `${(token.controlHeightLG - token.fontSize * token.lineHeight) / 2}px ${token.paddingSM}px`
    });
// =============================== Base ===============================
/** Generate the shared item card styles for Message notices. */ const $20dbc47c3bf6c1b5$var$genMessageItemStyle = (token)=>{
    const { fontSize: fontSize, fontSizeLG: fontSizeLG, lineHeight: lineHeight } = token;
    return (0, $b286b96e6d3a2300$export$2ef18ef18abb83d6)(token, {
        // Adjust card style since Message is not same as Notification.
        // Message needs horizontal center and not fix width.
        width: 'max-content',
        iconFontSize: fontSizeLG,
        titleFontSize: fontSize,
        titleLineHeight: lineHeight,
        contentStyle: {
            alignItems: 'center',
            gap: token.marginXS
        },
        noticeStyle: {
            zIndex: 1
        }
    });
};
// =============================== Stack ===============================
/** Generate the collapsed stack placeholder styles for Message notices. */ const $20dbc47c3bf6c1b5$var$generateMessageStackStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const noticeCls = `${componentCls}-notice`;
    const listContentCls = `${componentCls}-list-content`;
    const messageItemStyle = $20dbc47c3bf6c1b5$var$genMessageItemStyle(token);
    const { '&::after': _hoverAfterStyle, ...messageNoticeStyle } = messageItemStyle[noticeCls];
    const placeholderStyle = {
        ...messageNoticeStyle,
        position: 'absolute',
        zIndex: -1,
        left: '50%',
        height: token.calc(token.marginXS).mul(2).equal(),
        padding: 0,
        boxShadow: token.boxShadowTertiary,
        opacity: 0,
        pointerEvents: 'none',
        transform: 'translateX(-50%) translateY(100%)',
        transition: [
            `opacity ${token.motionDurationFast} ${token.motionEaseInOut}`,
            `transform ${token.motionDurationFast} ${token.motionEaseInOut}`,
            `width ${token.motionDurationSlow} ${token.motionEaseInOut}`
        ].join(', '),
        content: '""'
    };
    return {
        [componentCls]: {
            [`&${componentCls}-stack`]: {
                [listContentCls]: {
                    isolation: 'isolate',
                    '&::before': {
                        ...placeholderStyle,
                        top: `calc(var(--top-notificiation-height) - ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.marginXS)})`,
                        width: `calc(var(--top-notificiation-width) - ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.margin)})`
                    },
                    '&::after': {
                        ...placeholderStyle,
                        zIndex: -2,
                        top: 'var(--top-notificiation-height)',
                        width: `calc(var(--top-notificiation-width) - ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.calc(token.margin).mul(2).equal())})`
                    }
                },
                [`&:not(${componentCls}-stack-expanded)`]: {
                    [listContentCls]: {
                        '&::before, &::after': {
                            opacity: 1,
                            transform: 'translateX(-50%) translateY(0)'
                        }
                    }
                }
            }
        }
    };
};
// ============================= PurePanel =============================
/** Generate standalone PurePanel styles for Message. */ const $20dbc47c3bf6c1b5$var$generateMessagePurePanelStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const noticeCls = `${componentCls}-notice`;
    const messageItemStyle = $20dbc47c3bf6c1b5$var$genMessageItemStyle(token);
    return {
        [`${noticeCls}-pure-panel`]: {
            width: 'max-content',
            maxWidth: '100%',
            ...messageItemStyle,
            [noticeCls]: {
                ...messageItemStyle[noticeCls],
                position: 'relative',
                width: 'max-content',
                maxWidth: '100%'
            }
        }
    };
};
const $20dbc47c3bf6c1b5$export$773d92576fc40e5 = (0, $761caadb5301aee1$export$1537386bc155ea56)([
    'Message',
    'PurePanel'
], (token)=>$20dbc47c3bf6c1b5$var$generateMessagePurePanelStyle($20dbc47c3bf6c1b5$var$prepareMessageToken(token)), $20dbc47c3bf6c1b5$var$prepareComponentToken);
// ============================== Export ==============================
/** Wrap Message item styles under the component root selector. */ const $20dbc47c3bf6c1b5$var$generateMessageStyle = (token)=>({
        [token.componentCls]: $20dbc47c3bf6c1b5$var$genMessageItemStyle(token)
    });
var /** Register the main style hook for Message. */ $20dbc47c3bf6c1b5$export$2e2bcd8739ae039 = (0, $761caadb5301aee1$export$51ec95de45185b42)('Message', (token)=>{
    const messageToken = $20dbc47c3bf6c1b5$var$prepareMessageToken(token);
    return [
        (0, $fd09c8db0475e994$export$40038ad09e3efb66)(messageToken, {
            stackVisibleCount: 1,
            itemStyle: $20dbc47c3bf6c1b5$var$generateMessageStyle
        }),
        $20dbc47c3bf6c1b5$var$generateMessageStackStyle(messageToken)
    ];
}, $20dbc47c3bf6c1b5$var$prepareComponentToken);


"use client";
const $a6fb7dcac6398412$export$ad8f8fc3bcd61b4a = {
    info: /*#__PURE__*/ $5E6i4.createElement((0, $dc185fbb803a7cae$export$2e2bcd8739ae039), null),
    success: /*#__PURE__*/ $5E6i4.createElement((0, $b89ac8aaffc055f4$export$2e2bcd8739ae039), null),
    error: /*#__PURE__*/ $5E6i4.createElement((0, $18493f15518cd625$export$2e2bcd8739ae039), null),
    warning: /*#__PURE__*/ $5E6i4.createElement((0, $02cacf707e93d6b4$export$2e2bcd8739ae039), null),
    loading: /*#__PURE__*/ $5E6i4.createElement((0, $6e3183dc0ea574da$export$2e2bcd8739ae039), null)
};
const $a6fb7dcac6398412$export$4a6a5b2f2e753cf3 = (type, icon)=>(0, $b63de2b9864a5d1a$export$72280d5f896dac9a)(icon) ? icon : type && $a6fb7dcac6398412$export$ad8f8fc3bcd61b4a[type] || null;
/** @private Internal Component. Do not use in your production. */ const $a6fb7dcac6398412$var$PurePanel = (props)=>{
    const { prefixCls: staticPrefixCls, className: className, style: style, type: type, icon: icon, content: content, classNames: messageClassNames, styles: styles, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $519f2fad435b3034$export$46f4bd6436a25a31)('message');
    const prefixCls = staticPrefixCls || getPrefixCls('message');
    const noticePrefixCls = `${prefixCls}-notice`;
    const rootCls = (0, $d104ec5f99ed66d7$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $20dbc47c3bf6c1b5$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const [mergedClassNames, mergedStyles] = (0, $722c8632ba7bdb89$export$648566b068f28737)([
        contextClassNames,
        messageClassNames
    ], [
        contextStyles,
        styles
    ], {
        props: props
    });
    const iconNode = $a6fb7dcac6398412$export$4a6a5b2f2e753cf3(type, icon);
    const typeIconCls = type ? `${noticePrefixCls}-icon-${type}` : undefined;
    const rcClassNames = {
        wrapper: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(type && `${prefixCls}-${type}`, mergedClassNames.wrapper),
        icon: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(typeIconCls, mergedClassNames.icon),
        title: mergedClassNames.title
    };
    const rcStyles = {
        wrapper: mergedStyles.wrapper,
        icon: mergedStyles.icon,
        title: mergedStyles.title
    };
    return /*#__PURE__*/ $5E6i4.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${noticePrefixCls}-pure-panel`, hashId, className, cssVarCls, rootCls, mergedClassNames.root),
        style: mergedStyles.root
    }, /*#__PURE__*/ $5E6i4.createElement((0, $20dbc47c3bf6c1b5$export$773d92576fc40e5), {
        prefixCls: prefixCls
    }), /*#__PURE__*/ $5E6i4.createElement((0, $047ae74c4e01bbbb$export$2e2bcd8739ae039), {
        ...restProps,
        prefixCls: prefixCls,
        className: contextClassName,
        style: {
            ...contextStyle,
            ...style
        },
        duration: null,
        icon: iconNode,
        title: content,
        classNames: rcClassNames,
        styles: rcStyles
    }));
};
var $a6fb7dcac6398412$export$2e2bcd8739ae039 = $a6fb7dcac6398412$var$PurePanel;



"use client";
/** @private Internal Component. Do not use in your production. */ const $428f3276186e0d99$var$PureList = (props)=>{
    const { items: items, classNames: classNames, style: style } = props;
    const { getPrefixCls: getPrefixCls } = (0, $519f2fad435b3034$export$46f4bd6436a25a31)('message');
    const prefixCls = getPrefixCls('message');
    const rootCls = (0, $d104ec5f99ed66d7$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $20dbc47c3bf6c1b5$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const noticePrefixCls = `${prefixCls}-notice`;
    const configList = items.map((item)=>{
        const { content: content, duration: duration, key: key, type: type } = item;
        const typeIconCls = type ? `${noticePrefixCls}-icon-${type}` : undefined;
        return {
            key: key,
            duration: duration,
            icon: (0, $a6fb7dcac6398412$export$4a6a5b2f2e753cf3)(type),
            title: content,
            className: `${noticePrefixCls}-${type}`,
            classNames: {
                wrapper: `${prefixCls}-${type}`,
                icon: typeIconCls
            }
        };
    });
    return /*#__PURE__*/ $5E6i4.createElement((0, $8d0340406e9f50c0$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        placement: "top",
        configList: configList,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(hashId, cssVarCls, rootCls),
        classNames: {
            ...classNames,
            wrapper: classNames?.wrapper,
            title: classNames?.title
        },
        style: style,
        stack: false
    });
};
var $428f3276186e0d99$export$2e2bcd8739ae039 = $428f3276186e0d99$var$PureList;




var $5E6i4 = parcelRequire("5E6i4");










var $5E6i4 = parcelRequire("5E6i4");

const $0df8216ff8ba4d6a$var$useStackConfig = (stackConfig, defaultStackConfig)=>$5E6i4.useMemo(()=>{
        const mergedStackConfig = stackConfig ?? defaultStackConfig;
        if (!mergedStackConfig) return false;
        return {
            ...(0, $addbc2fddcbb77a9$export$53b83ca8eaab0383)(defaultStackConfig) ? defaultStackConfig : {},
            ...(0, $addbc2fddcbb77a9$export$53b83ca8eaab0383)(mergedStackConfig) ? mergedStackConfig : {}
        };
    }, [
        stackConfig,
        defaultStackConfig
    ]);
var $0df8216ff8ba4d6a$export$2e2bcd8739ae039 = $0df8216ff8ba4d6a$var$useStackConfig;




function $a347f15151ee4b53$export$28dc077a1256af6f(top, bottom) {
    return {
        ...(0, $b63de2b9864a5d1a$export$826fff653a329e83)(top) && {
            '--notification-top': (0, $56bae8a99c3cba6e$export$523c0b569236b342)(top)
        },
        ...(0, $b63de2b9864a5d1a$export$826fff653a329e83)(bottom) && {
            '--notification-bottom': (0, $56bae8a99c3cba6e$export$523c0b569236b342)(bottom)
        }
    };
}
function $a347f15151ee4b53$export$7b8936ddc277a29a(prefixCls) {
    return {
        motionName: `${prefixCls}-fade`
    };
}
function $a347f15151ee4b53$export$2c2219e7042654(closeIcon, notificationConfig, notification) {
    if (typeof closeIcon !== 'undefined') return closeIcon;
    if (typeof notificationConfig?.closeIcon !== 'undefined') return notificationConfig.closeIcon;
    return notification?.closeIcon;
}




function $79c4e923992b1857$export$7b8936ddc277a29a(prefixCls, transitionName) {
    return {
        motionName: transitionName ?? `${prefixCls}-fade`
    };
}
function $79c4e923992b1857$export$52ce770daa307a45(openFn) {
    let closeFn;
    const closePromise = new Promise((resolve)=>{
        closeFn = openFn(()=>{
            resolve(true);
        });
    });
    const result = ()=>{
        closeFn?.();
    };
    result.then = (filled, rejected)=>closePromise.then(filled, rejected);
    result.promise = closePromise;
    return result;
}


"use client";
const $7b308b22dda95c5a$var$DEFAULT_OFFSET = 8;
const $7b308b22dda95c5a$var$DEFAULT_DURATION = 3;
const $7b308b22dda95c5a$var$DEFAULT_STACK_CONFIG = false;
const $7b308b22dda95c5a$var$Wrapper = ({ children: children, prefixCls: prefixCls })=>{
    const rootCls = (0, $d104ec5f99ed66d7$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $20dbc47c3bf6c1b5$export$2e2bcd8739ae039)(prefixCls, rootCls);
    return /*#__PURE__*/ $5E6i4.createElement((0, $0d25818a64481fb8$export$2e2bcd8739ae039), {
        classNames: {
            list: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(hashId, cssVarCls, rootCls)
        }
    }, children);
};
const $7b308b22dda95c5a$var$renderNotifications = (node, { prefixCls: prefixCls, key: key })=>/*#__PURE__*/ $5E6i4.createElement($7b308b22dda95c5a$var$Wrapper, {
        prefixCls: prefixCls,
        key: key
    }, node);
const $7b308b22dda95c5a$var$Holder = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { top: // Placement
    top, // Config
    prefixCls: staticPrefixCls, getContainer: staticGetContainer, maxCount: maxCount, duration: duration = $7b308b22dda95c5a$var$DEFAULT_DURATION, rtl: // Style
    rtl, classNames: classNames, styles: styles, transitionName: // Motion
    transitionName, pauseOnHover: // UI
    pauseOnHover = true, stack: stack, onAllRemoved: // Life Cycle
    onAllRemoved } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, getPopupContainer: getPopupContainer } = (0, $519f2fad435b3034$export$46f4bd6436a25a31)('message');
    const { message: message } = $5E6i4.useContext((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
    const prefixCls = staticPrefixCls || getPrefixCls('message');
    // Use useMergeSemantic to merge classNames and styles
    const contextStyleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(message?.style);
    const [mergedClassNames, mergedStyles] = (0, $722c8632ba7bdb89$export$648566b068f28737)([
        message?.classNames,
        classNames
    ], [
        message?.styles,
        contextStyleRoot,
        styles
    ], {
        props: props
    });
    // =============================== Style ===============================
    const getStyle = ()=>(0, $a347f15151ee4b53$export$28dc077a1256af6f)(top ?? $7b308b22dda95c5a$var$DEFAULT_OFFSET);
    const getClassName = ()=>(0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)({
            [`${prefixCls}-rtl`]: rtl ?? direction === 'rtl'
        });
    // ============================== Motion ===============================
    const getNotificationMotion = ()=>(0, $79c4e923992b1857$export$7b8936ddc277a29a)(prefixCls, transitionName);
    // =============================== Stack ===============================
    const stackConfig = (0, $0df8216ff8ba4d6a$export$2e2bcd8739ae039)(stack, $7b308b22dda95c5a$var$DEFAULT_STACK_CONFIG);
    // ============================== Origin ===============================
    const [api, holder] = (0, $b626ec7a92ea27ca$export$2e2bcd8739ae039)({
        prefixCls: prefixCls,
        style: getStyle,
        className: getClassName,
        motion: getNotificationMotion,
        // closable=false requires-no closeIcon
        closable: false,
        duration: duration,
        getContainer: ()=>staticGetContainer?.() || getPopupContainer?.() || document.body,
        maxCount: maxCount,
        onAllRemoved: onAllRemoved,
        classNames: mergedClassNames,
        styles: mergedStyles,
        renderNotifications: $7b308b22dda95c5a$var$renderNotifications,
        pauseOnHover: pauseOnHover,
        stack: stackConfig
    });
    // ================================ Ref ================================
    $5E6i4.useImperativeHandle(ref, ()=>({
            ...api,
            prefixCls: prefixCls,
            message: message
        }));
    return holder;
});
// ==============================================================================
// ==                                   Hook                                   ==
// ==============================================================================
let $7b308b22dda95c5a$var$keyIndex = 0;
function $7b308b22dda95c5a$export$1689db33b6c27d9e(messageConfig) {
    const holderRef = $5E6i4.useRef(null);
    const warning = (0, $bedf93c14dee83a9$export$cf977aa92c751e61)('Message');
    // ================================ API ================================
    const wrapAPI = $5E6i4.useMemo(()=>{
        // Wrap with notification content
        // >>> close
        const close = (key)=>{
            holderRef.current?.close(key);
        };
        // >>> Open
        const open = (config)=>{
            if (!holderRef.current) {
                const fakeResult = ()=>{};
                fakeResult.then = ()=>{};
                return fakeResult;
            }
            const { open: originOpen, prefixCls: prefixCls, message: message } = holderRef.current;
            const contextClassName = message?.className || {};
            const noticePrefixCls = `${prefixCls}-notice`;
            const { content: content, icon: icon, type: type, key: key, className: className, style: style, onClose: onClose, classNames: configClassNames = {}, styles: styles = {}, ...restConfig } = config;
            let mergedKey = key;
            if (!(0, $b63de2b9864a5d1a$export$826fff653a329e83)(mergedKey)) {
                $7b308b22dda95c5a$var$keyIndex += 1;
                mergedKey = `antd-message-${$7b308b22dda95c5a$var$keyIndex}`;
            }
            const contextConfig = {
                ...messageConfig,
                ...config
            };
            const semanticClassNames = (0, $722c8632ba7bdb89$export$ccd424010a24474f)(configClassNames, {
                props: contextConfig
            });
            const semanticStyles = (0, $722c8632ba7bdb89$export$ccd424010a24474f)(styles, {
                props: contextConfig
            });
            const iconNode = (0, $a6fb7dcac6398412$export$4a6a5b2f2e753cf3)(type, icon);
            const typeIconCls = type ? `${noticePrefixCls}-icon-${type}` : undefined;
            return (0, $79c4e923992b1857$export$52ce770daa307a45)((resolve)=>{
                originOpen({
                    ...restConfig,
                    key: mergedKey,
                    icon: iconNode,
                    title: content,
                    classNames: {
                        ...semanticClassNames,
                        wrapper: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(type && `${prefixCls}-${type}`, semanticClassNames?.wrapper),
                        icon: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(typeIconCls, semanticClassNames?.icon)
                    },
                    styles: semanticStyles,
                    placement: 'top',
                    className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)({
                        [`${noticePrefixCls}-${type}`]: type
                    }, className, contextClassName),
                    style: style,
                    onClose: ()=>{
                        onClose?.();
                        resolve();
                    }
                });
                // Return close function
                return ()=>{
                    close(mergedKey);
                };
            });
        };
        // >>> destroy
        const destroy = (key)=>{
            if (key !== undefined) close(key);
            else holderRef.current?.destroy();
        };
        const clone = {
            open: open,
            destroy: destroy
        };
        const keys = [
            'info',
            'success',
            'warning',
            'error',
            'loading'
        ];
        keys.forEach((type)=>{
            const typeOpen = (jointContent, duration, onClose)=>{
                let config;
                if ((0, $addbc2fddcbb77a9$export$53b83ca8eaab0383)(jointContent) && 'content' in jointContent) config = jointContent;
                else config = {
                    content: jointContent
                };
                // Params
                let mergedDuration;
                let mergedOnClose;
                if ((0, $addbc2fddcbb77a9$export$f6e2535fb5126e54)(duration)) mergedOnClose = duration;
                else {
                    mergedDuration = duration;
                    mergedOnClose = onClose;
                }
                const mergedConfig = {
                    onClose: mergedOnClose,
                    duration: mergedDuration,
                    ...config,
                    type: type
                };
                return open(mergedConfig);
            };
            clone[type] = typeOpen;
        });
        return clone;
    }, []);
    // ============================== Return ===============================
    return [
        wrapAPI,
        /*#__PURE__*/ $5E6i4.createElement($7b308b22dda95c5a$var$Holder, {
            key: "message-holder",
            ...messageConfig,
            ref: holderRef
        })
    ];
}
function $7b308b22dda95c5a$export$2e2bcd8739ae039(messageConfig) {
    return $7b308b22dda95c5a$export$1689db33b6c27d9e(messageConfig);
}



"use client";
let $f7b22aa7c8982991$var$message = null;
let $f7b22aa7c8982991$var$act = (callback)=>callback();
let $f7b22aa7c8982991$var$taskQueue = [];
let $f7b22aa7c8982991$var$defaultGlobalConfig = {};
function $f7b22aa7c8982991$var$getGlobalContext() {
    const { getContainer: getContainer, duration: duration, rtl: rtl, maxCount: maxCount, top: top, stack: stack } = $f7b22aa7c8982991$var$defaultGlobalConfig;
    const mergedContainer = getContainer?.() || document.body;
    return {
        getContainer: ()=>mergedContainer,
        duration: duration,
        rtl: rtl,
        maxCount: maxCount,
        top: top,
        stack: stack
    };
}
const $f7b22aa7c8982991$var$GlobalHolder = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).forwardRef((props, ref)=>{
    const { messageConfig: messageConfig, sync: sync } = props;
    const { getPrefixCls: getPrefixCls } = (0, $5E6i4.useContext)((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
    const prefixCls = $f7b22aa7c8982991$var$defaultGlobalConfig.prefixCls || getPrefixCls('message');
    const appConfig = (0, $5E6i4.useContext)((0, $cbccb1f5ff19b737$export$264c6064649f9206));
    const [api, holder] = (0, $7b308b22dda95c5a$export$1689db33b6c27d9e)({
        ...messageConfig,
        prefixCls: prefixCls,
        ...appConfig.message
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useImperativeHandle(ref, ()=>{
        const instance = {
            ...api
        };
        Object.keys(instance).forEach((method)=>{
            instance[method] = (...args)=>{
                sync();
                return api[method].apply(api, args);
            };
        });
        return {
            instance: instance,
            sync: sync
        };
    });
    return holder;
});
const $f7b22aa7c8982991$var$GlobalHolderWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).forwardRef((_, ref)=>{
    const [messageConfig, setMessageConfig] = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useState($f7b22aa7c8982991$var$getGlobalContext);
    const sync = ()=>{
        setMessageConfig($f7b22aa7c8982991$var$getGlobalContext);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useEffect(sync, []);
    const global = (0, $58662003e62ec648$export$f9cd1e43211d8a4a)();
    const rootPrefixCls = global.getRootPrefixCls();
    const rootIconPrefixCls = global.getIconPrefixCls();
    const theme = global.getTheme();
    const dom = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement($f7b22aa7c8982991$var$GlobalHolder, {
        ref: ref,
        sync: sync,
        messageConfig: messageConfig
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $58662003e62ec648$export$2e2bcd8739ae039), {
        prefixCls: rootPrefixCls,
        iconPrefixCls: rootIconPrefixCls,
        theme: theme
    }, global.holderRender ? global.holderRender(dom) : dom);
});
const $f7b22aa7c8982991$var$flushMessageQueue = ()=>{
    if (!$f7b22aa7c8982991$var$message) {
        const holderFragment = document.createDocumentFragment();
        const newMessage = {
            fragment: holderFragment
        };
        $f7b22aa7c8982991$var$message = newMessage;
        // Delay render to avoid sync issue
        $f7b22aa7c8982991$var$act(()=>{
            (0, $ffa1d788dcb0dd15$export$b3890eb0ae9dca99)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement($f7b22aa7c8982991$var$GlobalHolderWrapper, {
                ref: (node)=>{
                    const { instance: instance, sync: sync } = node || {};
                    // React 18 test env will throw if call immediately in ref
                    Promise.resolve().then(()=>{
                        if (!newMessage.instance && instance) {
                            newMessage.instance = instance;
                            newMessage.sync = sync;
                            $f7b22aa7c8982991$var$flushMessageQueue();
                        }
                    });
                }
            }), holderFragment);
        });
        return;
    }
    // Notification not ready
    if (!$f7b22aa7c8982991$var$message.instance) return;
    // >>> Execute task
    $f7b22aa7c8982991$var$taskQueue.forEach((task)=>{
        const { type: type, skipped: skipped } = task;
        // Only `skipped` when user call notice but cancel it immediately
        // and instance not ready
        if (!skipped) switch(type){
            case 'open':
                $f7b22aa7c8982991$var$act(()=>{
                    const closeFn = $f7b22aa7c8982991$var$message.instance.open({
                        ...$f7b22aa7c8982991$var$defaultGlobalConfig,
                        ...task.config
                    });
                    closeFn?.then(task.resolve);
                    task.setCloseFn(closeFn);
                });
                break;
            case 'destroy':
                $f7b22aa7c8982991$var$act(()=>{
                    $f7b22aa7c8982991$var$message?.instance.destroy(task.key);
                });
                break;
            // Other type open
            default:
                $f7b22aa7c8982991$var$act(()=>{
                    var _message$instance;
                    const closeFn = (_message$instance = $f7b22aa7c8982991$var$message.instance)[type].apply(_message$instance, (0, $0acfae8147afe964$export$2e2bcd8739ae039)(task.args));
                    closeFn?.then(task.resolve);
                    task.setCloseFn(closeFn);
                });
        }
    });
    // Clean up
    $f7b22aa7c8982991$var$taskQueue = [];
};
// ==============================================================================
// ==                                  Export                                  ==
// ==============================================================================
function $f7b22aa7c8982991$var$setMessageGlobalConfig(config) {
    $f7b22aa7c8982991$var$defaultGlobalConfig = {
        ...$f7b22aa7c8982991$var$defaultGlobalConfig,
        ...config
    };
    // Trigger sync for it
    $f7b22aa7c8982991$var$act(()=>{
        $f7b22aa7c8982991$var$message?.sync?.();
    });
}
function $f7b22aa7c8982991$var$open(config) {
    const result = (0, $79c4e923992b1857$export$52ce770daa307a45)((resolve)=>{
        let closeFn;
        const task = {
            type: 'open',
            config: config,
            resolve: resolve,
            setCloseFn: (fn)=>{
                closeFn = fn;
            }
        };
        $f7b22aa7c8982991$var$taskQueue.push(task);
        return ()=>{
            if (closeFn) $f7b22aa7c8982991$var$act(()=>{
                closeFn();
            });
            else task.skipped = true;
        };
    });
    $f7b22aa7c8982991$var$flushMessageQueue();
    return result;
}
function $f7b22aa7c8982991$var$typeOpen(type, args) {
    const global = (0, $58662003e62ec648$export$f9cd1e43211d8a4a)();
    const result = (0, $79c4e923992b1857$export$52ce770daa307a45)((resolve)=>{
        let closeFn;
        const task = {
            type: type,
            args: args,
            resolve: resolve,
            setCloseFn: (fn)=>{
                closeFn = fn;
            }
        };
        $f7b22aa7c8982991$var$taskQueue.push(task);
        return ()=>{
            if (closeFn) $f7b22aa7c8982991$var$act(()=>{
                closeFn();
            });
            else task.skipped = true;
        };
    });
    $f7b22aa7c8982991$var$flushMessageQueue();
    return result;
}
const $f7b22aa7c8982991$var$destroy = (key)=>{
    $f7b22aa7c8982991$var$taskQueue.push({
        type: 'destroy',
        key: key
    });
    $f7b22aa7c8982991$var$flushMessageQueue();
};
const $f7b22aa7c8982991$var$methods = [
    'success',
    'info',
    'warning',
    'error',
    'loading'
];
const $f7b22aa7c8982991$var$baseStaticMethods = {
    open: $f7b22aa7c8982991$var$open,
    destroy: $f7b22aa7c8982991$var$destroy,
    config: $f7b22aa7c8982991$var$setMessageGlobalConfig,
    useMessage: $7b308b22dda95c5a$export$2e2bcd8739ae039,
    _InternalPanelDoNotUseOrYouWillBeFired: (0, $a6fb7dcac6398412$export$2e2bcd8739ae039),
    _InternalListDoNotUseOrYouWillBeFired: (0, $428f3276186e0d99$export$2e2bcd8739ae039)
};
const $f7b22aa7c8982991$var$staticMethods = $f7b22aa7c8982991$var$baseStaticMethods;
$f7b22aa7c8982991$var$methods.forEach((type)=>{
    $f7b22aa7c8982991$var$staticMethods[type] = (...args)=>$f7b22aa7c8982991$var$typeOpen(type, args);
});
// ==============================================================================
// ==                                   Test                                   ==
// ==============================================================================
const $f7b22aa7c8982991$var$noop = ()=>{};
let $f7b22aa7c8982991$var$_actWrapper = $f7b22aa7c8982991$var$noop;
var $f7b22aa7c8982991$var$wrapper;
const $f7b22aa7c8982991$export$71ceb3dabb09f455 = $f7b22aa7c8982991$var$_actWrapper;
let $f7b22aa7c8982991$var$_actDestroy = $f7b22aa7c8982991$var$noop;
const $f7b22aa7c8982991$export$43de32c50edff050 = $f7b22aa7c8982991$var$_actDestroy;
var $f7b22aa7c8982991$export$2e2bcd8739ae039 = $f7b22aa7c8982991$var$staticMethods;


var $5E6i4 = parcelRequire("5E6i4");




var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $f65baf7b9d8919f3$var$WarningFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zM480 416c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V416zm32 352a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"
                }
            }
        ]
    },
    "name": "warning",
    "theme": "filled"
};
var $f65baf7b9d8919f3$export$2e2bcd8739ae039 = $f65baf7b9d8919f3$var$WarningFilled;



function $71c5a546a32d7376$var$_extends() {
    $71c5a546a32d7376$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $71c5a546a32d7376$var$_extends.apply(this, arguments);
}
const $71c5a546a32d7376$var$WarningFilled = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $71c5a546a32d7376$var$_extends({}, props, {
        ref: ref,
        icon: (0, $f65baf7b9d8919f3$export$2e2bcd8739ae039)
    }));
/**![warning](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk1NS43IDg1NmwtNDE2LTcyMGMtNi4yLTEwLjctMTYuOS0xNi0yNy43LTE2cy0yMS42IDUuMy0yNy43IDE2bC00MTYgNzIwQzU2IDg3Ny40IDcxLjQgOTA0IDk2IDkwNGg4MzJjMjQuNiAwIDQwLTI2LjYgMjcuNy00OHpNNDgwIDQxNmMwLTQuNCAzLjYtOCA4LThoNDhjNC40IDAgOCAzLjYgOCA4djE4NGMwIDQuNC0zLjYgOC04IDhoLTQ4Yy00LjQgMC04LTMuNi04LThWNDE2em0zMiAzNTJhNDguMDEgNDguMDEgMCAwMTAtOTYgNDguMDEgNDguMDEgMCAwMTAgOTZ6IiAvPjwvc3ZnPg==) */ const $71c5a546a32d7376$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($71c5a546a32d7376$var$WarningFilled);
var $71c5a546a32d7376$export$2e2bcd8739ae039 = $71c5a546a32d7376$var$RefIcon;








var $5E6i4 = parcelRequire("5E6i4");
"use client";
const $cf7bc50fbce40d0a$var$NoFound = ()=>/*#__PURE__*/ $5E6i4.createElement("svg", {
        width: "252",
        height: "294"
    }, /*#__PURE__*/ $5E6i4.createElement("title", null, "No Found"), /*#__PURE__*/ $5E6i4.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $5E6i4.createElement("circle", {
        cx: "126.75",
        cy: "128.1",
        r: "126",
        fill: "#E4EBF7"
    }), /*#__PURE__*/ $5E6i4.createElement("circle", {
        cx: "31.55",
        cy: "130.8",
        r: "8.3",
        fill: "#FFF"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#FFF",
        d: "m37 134.3 10.5 6m.9 6.2-12.7 10.8",
        strokeWidth: "2"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#FFF",
        d: "M39.9 159.4a5.7 5.7 0 1 1-11.3-1.2 5.7 5.7 0 0 1 11.3 1.2m17.7-16.2a5.7 5.7 0 1 1-11.4-1.1 5.7 5.7 0 0 1 11.4 1.1M99 27h29.8a4.6 4.6 0 1 0 0-9.2H99a4.6 4.6 0 1 0 0 9.2m11.4 18.3h29.8a4.6 4.6 0 0 0 0-9.2h-29.8a4.6 4.6 0 1 0 0 9.2"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#FFF",
        d: "M112.8 26.9h15.8a4.6 4.6 0 1 0 0 9.1h-15.8a4.6 4.6 0 0 0 0-9.1m71.7 108.8a10 10 0 1 1-19.8-2 10 10 0 0 1 19.8 2"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#FFF",
        d: "m179.3 141.8 12.6 7.1m1.1 7.6-15.2 13",
        strokeWidth: "2"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#FFF",
        d: "M184.7 170a6.8 6.8 0 1 1-13.6-1.3 6.8 6.8 0 0 1 13.6 1.4m18.6-16.8a6.9 6.9 0 1 1-13.7-1.4 6.9 6.9 0 0 1 13.7 1.4"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#FFF",
        d: "M152 192.3a2.2 2.2 0 1 1-4.5 0 2.2 2.2 0 0 1 4.4 0zm73.3-76.2a2.2 2.2 0 1 1-4.5 0 2.2 2.2 0 0 1 4.5 0zm-9 35a2.2 2.2 0 1 1-4.4 0 2.2 2.2 0 0 1 4.5 0zM177 107.6a2.2 2.2 0 1 1-4.4 0 2.2 2.2 0 0 1 4.4 0zm18.4-15.4a2.2 2.2 0 1 1-4.5 0 2.2 2.2 0 0 1 4.5 0zm6.8 88.5a2.2 2.2 0 1 1-4.5 0 2.2 2.2 0 0 1 4.5 0z",
        strokeWidth: "2"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#FFF",
        d: "m214.4 153.3-2 20.2-10.8 6m-28-4.7-6.3 9.8H156l-4.5 6.5m23.5-66v-15.7m46 7.8-13 8-15.2-8V94.4",
        strokeWidth: "2"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#FFF",
        d: "M166.6 66h-4a4.8 4.8 0 0 1-4.7-4.8 4.8 4.8 0 0 1 4.7-4.7h4a4.8 4.8 0 0 1 4.7 4.7 4.8 4.8 0 0 1-4.7 4.7"
    }), /*#__PURE__*/ $5E6i4.createElement("circle", {
        cx: "204.3",
        cy: "30",
        r: "29.5",
        fill: "#1677ff"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#FFF",
        d: "M206 38.4c.5.5.7 1.1.7 2s-.2 1.4-.7 1.9a3 3 0 0 1-2 .7c-.8 0-1.5-.3-2-.8s-.8-1.1-.8-1.9.3-1.4.8-2c.5-.4 1.2-.7 2-.7.7 0 1.4.3 2 .8m4.2-19.5c1.5 1.3 2.2 3 2.2 5.2a7.2 7.2 0 0 1-1.5 4.5l-3 2.7a5 5 0 0 0-1.3 1.7 5.2 5.2 0 0 0-.6 2.4v.5h-4v-.5c0-1.4.1-2.5.6-3.5s1.9-2.5 4.2-4.5l.4-.5a4 4 0 0 0 1-2.6c0-1.2-.4-2-1-2.8-.7-.6-1.6-1-2.9-1-1.5 0-2.6.5-3.3 1.5-.4.5-.6 1-.8 1.9a2 2 0 0 1-2 1.6 2 2 0 0 1-2-2.4c.4-1.6 1-2.8 2.1-3.8a8.5 8.5 0 0 1 6.3-2.3c2.3 0 4.2.6 5.6 2"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#FFB594",
        d: "M52 76.1s21.8 5.4 27.3 16c5.6 10.7-6.3 9.2-15.7 5C52.8 92 39 85 52 76"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#FFC6A0",
        d: "m90.5 67.5-.5 2.9c-.7.5-4.7-2.7-4.7-2.7l-1.7.8-1.3-5.7s6.8-4.6 9-5c2.4-.5 9.8 1 10.6 2.3 0 0 1.3.4-2.2.6-3.6.3-5 .5-6.8 3.2l-2.4 3.6"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#FFF",
        d: "M128 111.4a36.7 36.7 0 0 0-8.9-15.5c-3.5-3-9.3-2.2-11.3-4.2-1.3-1.2-3.2-1.2-3.2-1.2L87.7 87c-2.3-.4-2.1-.7-6-1.4-1.6-1.9-3-1.1-3-1.1l-7-1.4c-1-1.5-2.5-1-2.5-1l-2.4-.9C65 91.2 59 95 59 95c1.8 1.1 15.7 8.3 15.7 8.3l5.1 37.1s-3.3 5.7 1.4 9.1c0 0 19.9-3.7 34.9-.3 0 0 3-2.6 1-8.8.5-3 1.4-8.3 1.7-11.6.4.7 2 1.9 3.1 3.4 0 0 9.4-7.3 11-14a17 17 0 0 1-2.2-2.4c-.5-.8-.3-2-.7-2.8-.7-1-1.8-1.3-2-1.6"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#CBD1D1",
        d: "M101 290s4.4 2 7.4 1c2.9-1 4.6.7 7.1 1.2 2.6.5 6.9 1.1 11.7-1.3 0-5.5-6.9-4-12-6.7-2.5-1.4-3.7-4.7-3.5-8.8h-9.5s-1.2 10.6-1 14.6"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#2B0849",
        d: "M101 289.8s2.5 1.3 6.8.7c3-.5 3.7.5 7.4 1 3.8.6 10.8 0 11.9-.9.4 1.1-.4 2-.4 2s-1.5.7-4.8.9c-2 .1-5.8.3-7.6-.5-1.8-1.4-5.2-1.9-5.7-.2-4 1-7.4-.3-7.4-.3l-.1-2.7z"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#A4AABA",
        d: "M108.3 276h3.1s0 6.7 4.6 8.6c-4.7.6-8.6-2.3-7.7-8.6"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#CBD1D1",
        d: "M57.5 272.4s-2 7.4-4.4 12.3c-1.8 3.7-4.3 7.5 5.4 7.5 6.7 0 9-.5 7.4-6.6-1.5-6.1.3-13.2.3-13.2h-8.7z"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#2B0849",
        d: "M51.5 289.8s2 1.2 6.6 1.2c6 0 8.3-1.7 8.3-1.7s.6 1.1-.7 2.2c-1 .8-3.6 1.6-7.4 1.5-4.1 0-5.8-.5-6.7-1.1-.8-.6-.7-1.6-.1-2.1"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#A4AABA",
        d: "M58.4 274.3s0 1.5-.3 3c-.3 1.4-1 3-1.1 4 0 1.2 4.5 1.7 5.1.1.6-1.5 1.3-6.4 2-7.2.6-.9-5-2.2-5.7.1"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#7BB2F9",
        d: "m99.7 278.5 13.3.1s1.3-54.5 1.9-64.4c.5-9.9 3.8-43.4 1-63.1l-12.6-.7-22.8.8-1.2 10c0 .5-.7.8-.7 1.4-.1.5.4 1.3.3 2-2.4 14-6.4 33-8.8 46.6 0 .7-1.2 1-1.4 2.7 0 .3.2 1.5 0 1.8-6.8 18.7-10.9 47.8-14.2 61.9h14.6s2.2-8.6 4-17c2.9-12.9 23.2-85 23.2-85l3-.5 1 46.3s-.2 1.2.4 2c.5.8-.6 1.1-.4 2.3l.4 1.8-1 11.8c-.4 4.8 0 39.2 0 39.2"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#648BD8",
        d: "M76 221.6c1.2.1 4.1-2 7-5m23.4 8.5s2.7-1 6-3.8",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#648BD8",
        d: "M107.3 222.1s2.7-1.1 6-3.9",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#648BD8",
        d: "M74.7 224.8s2.7-.6 6.5-3.4m4.8-69.8c-.2 3.1.3 8.6-4.3 9.2m22-11s0 14-1.4 15.1a15 15 0 0 1-3 2m.5-16.5s0 13-1.2 24.4m-5 1.1s7.3-1.7 9.5-1.7M74.3 206a212 212 0 0 1-1 4.5s-1.4 1.9-1 3.8c.5 2-1 2-5 15.4A353 353 0 0 0 61 257l-.2 1.2m14.9-60.5a321 321 0 0 1-.9 4.8m7.8-50.4-1.2 10.5s-1.1.1-.5 2.2c.1 1.4-2.7 15.8-5.2 30.5m-19.6 79h13.3",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#192064",
        d: "M116.2 148.2s-17-3-35.9.2c.2 2.5 0 4.2 0 4.2s14.7-2.8 35.7-.3c.3-2.4.2-4 .2-4"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#FFF",
        d: "M106.3 151.2v-5a.8.8 0 0 0-.8-.8h-7.8a.8.8 0 0 0-.8.8v5a.8.8 0 0 0 .8.8h7.8a.8.8 0 0 0 .8-.8"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#192064",
        d: "M105.2 150.2v-3a.6.6 0 0 0-.6-.7 94.3 94.3 0 0 0-5.9 0 .7.7 0 0 0-.6.6v3.1a.6.6 0 0 0 .6.7 121.1 121.1 0 0 1 5.8 0c.4 0 .7-.3.7-.7"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#648BD8",
        d: "M100.3 275.4h12.3m-11.2-4.9.1 6.5m0-12.5a915.8 915.8 0 0 0 0 4.4m-.5-94 .9 44.7s.7 1.6-.2 2.7c-1 1.1 2.4.7.9 2.2-1.6 1.6.9 1.2 0 3.4-.6 1.5-1 21.1-1.1 35.2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#FFC6A0",
        d: "M46.9 83.4s-.5 6 7.2 5.6c11.2-.7 9.2-9.4 31.5-21.7-.7-2.7-2.4-4.7-2.4-4.7s-11 3-22.6 8c-6.8 3-13.4 6.4-13.7 12.8m57.6 7.7.9-5.4-8.9-11.4-5 5.3-1.8 7.9a.3.3 0 0 0 .1.3c1 .8 6.5 5 14.4 3.5a.3.3 0 0 0 .3-.2"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#FFC6A0",
        d: "M94 79.4s-4.6-2.9-2.5-6.9c1.6-3 4.5 1.2 4.5 1.2s.5-3.7 3.1-3.7c.6-1 1.6-4.1 1.6-4.1l13.5 3c0 5.3-2.3 19.5-7.8 20-8.9.6-12.5-9.5-12.5-9.5"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#520038",
        d: "M113.9 73.4c2.6-2 3.4-9.7 3.4-9.7s-2.4-.5-6.6-2c-4.7-2.1-12.8-4.8-17.5 1-9.6 3.2-2 19.8-2 19.8l2.7-3s-4-3.3-2-6.3c2-3.5 3.8 1 3.8 1s.7-2.3 3.6-3.3c.4-.7 1-2.6 1.4-3.8a1 1 0 0 1 1.3-.7l11.4 2.6c.5.2.8.7.8 1.2l-.3 3.2z"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#552950",
        d: "M105 76c-.1.7-.6 1.1-1 1-.6 0-.9-.6-.8-1.2.1-.6.6-1 1-1 .6 0 .9.7.8 1.3m7.1 1.6c0 .6-.5 1-1 1-.5-.1-.8-.7-.7-1.3 0-.6.5-1 1-1 .5.1.8.7.7 1.3"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#DB836E",
        d: "m110.1 74.8-.9 1.7-.3 4.3h-2.2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#5C2552",
        d: "M110.8 74.5s1.8-.7 2.6.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#DB836E",
        d: "M92.4 74.3s.5-1.1 1.1-.7c.6.4 1.3 1.4.6 2-.8.5.1 1.6.1 1.6",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#5C2552",
        d: "M103.3 73s1.8 1 4.1.9",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#DB836E",
        d: "M103.7 81.8s2.2 1.2 4.4 1.2m-3.5 1.3s1 .4 1.6.3m-11.5-3.4s2.3 7.4 10.4 7.6",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#E4EBF7",
        d: "M81.5 89.4s.4 5.6-5 12.8M69 82.7s-.7 9.2-8.2 14.2m68.6 26s-5.3 7.4-9.4 10.7m-.7-26.3s.5 4.4-2.1 32",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#F2D7AD",
        d: "M150 151.2h-49.8a1 1 0 0 1-1-1v-31.7c0-.5.4-1 1-1H150c.6 0 1 .5 1 1v31.7a1 1 0 0 1-1 1"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#F4D19D",
        d: "M150.3 151.2h-19.9v-33.7h20.8v32.8a1 1 0 0 1-1 1"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#F2D7AD",
        d: "M123.6 127.9H92.9a.5.5 0 0 1-.4-.8l6.4-9.1c.2-.3.5-.5.8-.5h31.1l-7.2 10.4z"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#CC9B6E",
        d: "M123.7 128.4H99.2v-.5h24.2l7.2-10.2.4.3z"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#F4D19D",
        d: "M158.3 127.9h-18.7a2 2 0 0 1-1.6-.8l-7.2-9.6h20c.5 0 1 .3 1.2.6l6.7 9a.5.5 0 0 1-.4.8"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#CC9B6E",
        d: "M157.8 128.5h-19.3l-7.9-10.5.4-.3 7.7 10.3h19.1zm-27.2 22.2v-8.2h.4v8.2zm-.1-10.9v-21.4h.4l.1 21.4zm-18.6 1.1-.5-.1 1.5-5.2.5.2zm-3.5.2-2.6-3 2.6-3.4.4.3-2.4 3.1 2.4 2.6zm8.2 0-.4-.4 2.4-2.6-2.4-3 .4-.4 2.7 3.4z"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#FFC6A0",
        d: "m154.3 131.9-3.1-2v3.5l-1 .1a85 85 0 0 1-4.8.3c-1.9 0-2.7 2.2 2.2 2.6l-2.6-.6s-2.2 1.3.5 2.3c0 0-1.6 1.2.6 2.6-.6 3.5 5.2 4 7 3.6a6.1 6.1 0 0 0 4.6-5.2 8 8 0 0 0-3.4-7.2"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#DB836E",
        d: "M153.7 133.6s-6.5.4-8.4.3c-1.8 0-1.9 2.2 2.4 2.3 3.7.2 5.4 0 5.4 0",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#DB836E",
        d: "M145.2 135.9c-1.9 1.3.5 2.3.5 2.3s3.5 1 6.8.6m-.6 2.9s-6.3.1-6.7-2.1c-.3-1.4.4-1.4.4-1.4m.5 2.7s-1 3.1 5.5 3.5m-.4-14.5v3.5M52.8 89.3a18 18 0 0 0 13.6-7.8",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#5BA02E",
        d: "M168.6 248.3a6.6 6.6 0 0 1-6.7-6.6v-66.5a6.6 6.6 0 1 1 13.3 0v66.5a6.6 6.6 0 0 1-6.6 6.6"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#92C110",
        d: "M176.5 247.7a6.6 6.6 0 0 1-6.6-6.7v-33.2a6.6 6.6 0 1 1 13.3 0V241a6.6 6.6 0 0 1-6.7 6.7"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#F2D7AD",
        d: "M186.4 293.6H159a3.2 3.2 0 0 1-3.2-3.2v-46.1a3.2 3.2 0 0 1 3.2-3.2h27.5a3.2 3.2 0 0 1 3.2 3.2v46.1a3.2 3.2 0 0 1-3.2 3.2"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#E4EBF7",
        d: "M89 89.5s7.8 5.4 16.6 2.8",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    })));
var $cf7bc50fbce40d0a$export$2e2bcd8739ae039 = $cf7bc50fbce40d0a$var$NoFound;



var $5E6i4 = parcelRequire("5E6i4");
"use client";
const $74a3537ae1308591$var$ServerError = ()=>/*#__PURE__*/ $5E6i4.createElement("svg", {
        width: "254",
        height: "294"
    }, /*#__PURE__*/ $5E6i4.createElement("title", null, "Server Error"), /*#__PURE__*/ $5E6i4.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#E4EBF7",
        d: "M0 128.1v-2C0 56.5 56.3.2 125.7.2h2.1C197.2.3 253.5 56.6 253.5 126v2.1c0 69.5-56.3 125.7-125.7 125.7h-2.1A125.7 125.7 0 0 1 0 128.1"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#FFF",
        d: "M40 132.1a8.3 8.3 0 1 1-16.6-1.7 8.3 8.3 0 0 1 16.6 1.7"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#FFF",
        d: "m37.2 135.6 10.5 6m1 6.3-12.8 10.8",
        strokeWidth: "2"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#FFF",
        d: "M40.1 160.8a5.7 5.7 0 1 1-11.3-1.1 5.7 5.7 0 0 1 11.3 1.1M58 144.6a5.7 5.7 0 1 1-11.4-1.2 5.7 5.7 0 0 1 11.4 1.2M99.7 27.4h30a4.6 4.6 0 1 0 0-9.2h-30a4.6 4.6 0 0 0 0 9.2M111 46h30a4.6 4.6 0 1 0 0-9.3h-30a4.6 4.6 0 1 0 0 9.3m2.5-18.6h16a4.6 4.6 0 1 0 0 9.3h-16a4.6 4.6 0 0 0 0-9.3m36.7 42.7h-4a4.8 4.8 0 0 1-4.8-4.8 4.8 4.8 0 0 1 4.8-4.8h4a4.8 4.8 0 0 1 4.7 4.8 4.8 4.8 0 0 1-4.7 4.8"
    }), /*#__PURE__*/ $5E6i4.createElement("circle", {
        cx: "201.35",
        cy: "30.2",
        r: "29.7",
        fill: "#FF603B"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#FFF",
        d: "m203.6 19.4-.7 15a1.5 1.5 0 0 1-3 0l-.7-15a2.2 2.2 0 1 1 4.4 0m-.3 19.4c.5.5.8 1.1.8 1.9s-.3 1.4-.8 1.9a3 3 0 0 1-2 .7 2.5 2.5 0 0 1-1.8-.7c-.6-.6-.8-1.2-.8-2 0-.7.2-1.3.8-1.8.5-.5 1.1-.7 1.8-.7.8 0 1.5.2 2 .7"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#FFB594",
        d: "M119.3 133.3c4.4-.6 3.6-1.2 4-4.8.8-5.2-3-17-8.2-25.1-1-10.7-12.6-11.3-12.6-11.3s4.3 5 4.2 16.2c1.4 5.3.8 14.5.8 14.5s5.3 11.4 11.8 10.5"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#FFF",
        d: "M101 91.6s1.4-.6 3.2.6c8 1.4 10.3 6.7 11.3 11.4 1.8 1.2 1.8 2.3 1.8 3.5l1.5 3s-7.2 1.7-11 6.7c-1.3-6.4-6.9-25.2-6.9-25.2"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#FFB594",
        d: "m94 90.5 1-5.8-9.2-11.9-5.2 5.6-2.6 9.9s8.4 5 16 2.2"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#FFC6A0",
        d: "M83 78.2s-4.6-2.9-2.5-6.9c1.6-3 4.5 1.2 4.5 1.2s.5-3.7 3.2-3.7c.5-1 1.5-4.2 1.5-4.2l13.6 3.2c0 5.2-2.3 19.5-7.9 20-8.9.6-12.5-9.6-12.5-9.6"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#520038",
        d: "M103 72.2c2.6-2 3.5-9.7 3.5-9.7s-2.5-.5-6.7-2c-4.7-2.2-12.9-4.9-17.6.9-9.5 4.4-2 20-2 20l2.7-3.1s-4-3.3-2.1-6.3c2.2-3.5 4 1 4 1s.6-2.3 3.5-3.3c.4-.7 1-2.7 1.5-3.8A1 1 0 0 1 91 65l11.5 2.7c.5.1.8.6.8 1.2l-.3 3.2z"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#552950",
        d: "M101.2 76.5c0 .6-.6 1-1 1-.5-.1-.9-.7-.8-1.3.1-.6.6-1 1.1-1 .5.1.8.7.7 1.3m-7-1.4c0 .6-.5 1-1 1-.5-.1-.8-.7-.7-1.3 0-.6.6-1 1-1 .5.1.9.7.8 1.3"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#DB836E",
        d: "m99.2 73.6-.9 1.7-.3 4.3h-2.2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#5C2552",
        d: "M100 73.3s1.7-.7 2.4.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#DB836E",
        d: "M81.4 73s.4-1 1-.6c.7.4 1.4 1.4.6 2s.2 1.6.2 1.6",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#5C2552",
        d: "M92.3 71.7s1.9 1.1 4.2 1",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#DB836E",
        d: "M92.7 80.6s2.3 1.2 4.4 1.2m-3.4 1.4s1 .4 1.5.3M83.7 80s1.8 6.6 9.2 8",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#E4EBF7",
        d: "M95.5 91.7s-1 2.8-8.2 2c-7.3-.6-10.3-5-10.3-5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#FFF",
        d: "M78.1 87.5s6.6 5 16.5 2.5c0 0 9.6 1 11.5 5.3 5.4 11.8.6 36.8 0 40 3.5 4-.4 8.4-.4 8.4-15.7-3.5-35.8-.6-35.8-.6-4.9-3.5-1.3-9-1.3-9l-6.2-23.8c-2.5-15.2.8-19.8 3.5-20.7 3-1 8-1.3 8-1.3.6 0 1.1 0 1.4-.2 2.4-1.3 2.8-.6 2.8-.6"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#FFC6A0",
        d: "M65.8 89.8s-6.8.5-7.6 8.2c-.4 8.8 3 11 3 11s6.1 22 16.9 22.9c8.4-2.2 4.7-6.7 4.6-11.4-.2-11.3-7-17-7-17s-4.3-13.7-9.9-13.7"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#FFC6A0",
        d: "M71.7 124.2s.9 11.3 9.8 6.5c4.8-2.5 7.6-13.8 9.8-22.6A201 201 0 0 0 94 96l-5-1.7s-2.4 5.6-7.7 12.3c-4.4 5.5-9.2 11.1-9.5 17.7"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#E4EBF7",
        d: "M108.5 105.2s1.7 2.7-2.4 30.5c2.4 2.2 1 6-.2 7.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#FFC6A0",
        d: "M123.3 131.5s-.5 2.8-11.8 2c-15.2-1-25.3-3.2-25.3-3.2l.9-5.8s.7.2 9.7-.1c11.9-.4 18.7-6 25-1 4 3.2 1.5 8.1 1.5 8.1"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#FFF",
        d: "M70.2 91s-5.6-4.8-11 2.7c-3.3 7.2.5 15.2 2.6 19.5-.3 3.8 2.4 4.3 2.4 4.3s0 1 1.5 2.7c4-7 6.7-9.1 13.7-12.5-.3-.7-1.9-3.3-1.8-3.8.2-1.7-1.3-2.6-1.3-2.6s-.3-.2-1.2-2.8c-.8-2.3-2-5.1-4.9-7.5"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#CBD1D1",
        d: "M90.2 288s4.9 2.3 8.3 1.2c3.2-1 5.2.7 8 1.3a20 20 0 0 0 13.3-1.4c-.2-6.2-7.8-4.5-13.6-7.6-2.9-1.6-4.2-5.3-4-10H91.5s-1.5 12-1.3 16.5"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#2B0849",
        d: "M90.2 287.8s2.8 1.5 7.6.8c3.5-.5 3.3.6 7.5 1.3 4.2.6 13-.2 14.3-1.2.5 1.3-.4 2.4-.4 2.4s-1.7.6-5.4.9c-2.3.1-8.1.3-10.2-.6-2-1.6-4.9-1.5-6-.3-4.5 1.1-7.2-.3-7.2-.3l-.2-3z"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#A4AABA",
        d: "M98.4 272.3h3.5s0 7.5 5.2 9.6c-5.3.7-9.7-2.6-8.7-9.6"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#CBD1D1",
        d: "M44.4 272s-2.2 7.8-4.7 13c-1.9 3.8-4.4 7.8 5.8 7.8 7 0 9.3-.5 7.7-7-1.6-6.3.3-13.8.3-13.8h-9z"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#2B0849",
        d: "M38 290.3s2.3 1.2 7 1.2c6.4 0 8.7-1.7 8.7-1.7s.6 1.1-.7 2.2c-1 1-3.8 1.7-7.7 1.7-4.4 0-6.1-.6-7-1.3-1-.5-.8-1.6-.2-2.1"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#A4AABA",
        d: "M45.3 274s0 1.6-.3 3.1-1.1 3.3-1.2 4.4c0 1.2 4.8 1.6 5.4 0 .7-1.6 1.4-6.8 2-7.6.7-.9-5.1-2.2-5.9.1"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#7BB2F9",
        d: "M89.5 277.6h13.9s1.3-56.6 1.9-66.8c.6-10.3 4-45.1 1-65.6l-13-.7-23.7.8-1.3 10.4c0 .5-.7.9-.8 1.4 0 .6.5 1.4.4 2L59.6 206c-.1.7-1.3 1-1.5 2.8 0 .3.2 1.6.1 1.8-7.1 19.5-12.2 52.6-15.6 67.2h15.1L62 259c3-13.3 24-88.3 24-88.3l3.2-1-.2 48.6s-.2 1.3.4 2.1c.5.8-.6 1.2-.4 2.4l.4 1.8-1 12.4c-.4 4.9 1.2 40.7 1.2 40.7"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#648BD8",
        d: "M64.6 218.9c1.2 0 4.2-2.1 7.2-5.1m24.2 8.7s3-1.1 6.4-4",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#648BD8",
        d: "M97 219.4s2.9-1.2 6.3-4",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#648BD8",
        d: "M63.2 222.1s2.7-.6 6.7-3.5m5-72.4c-.3 3.2.3 8.8-4.5 9.4m22.8-11.3s.1 14.6-1.4 15.7c-2.3 1.7-3 2-3 2m.4-17s.3 13-1 25m-4.7.7s6.8-1 9.1-1M46 270l-.9 4.6m1.8-11.3-.8 4.1m16.6-64.9c-.3 1.6 0 2-.4 3.4 0 0-2.8 2-2.3 4s-.3 3.4-4.5 17.2c-1.8 5.8-4.3 19-6.2 28.3l-1.1 5.8m16-67-1 4.9m8.1-52.3-1.2 10.9s-1.2.1-.5 2.3c0 1.4-2.8 16.4-5.4 31.6m-20 82.1h13.9",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#192064",
        d: "M106.2 142.1c-3-.5-18.8-2.7-36.2.2a.6.6 0 0 0-.6.7v3a.6.6 0 0 0 .8.6c3.3-.5 17-2.4 35.6-.3.4 0 .7-.2.7-.5.2-1.4.2-2.5.2-3a.6.6 0 0 0-.5-.7"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#FFF",
        d: "M96.4 145.3v-5.1a.8.8 0 0 0-.8-.9 114.1 114.1 0 0 0-8.1 0 .8.8 0 0 0-.9.8v5.1c0 .5.4.9.9.9h8a.8.8 0 0 0 .9-.8"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#192064",
        d: "M95.2 144.3v-3.2a.7.7 0 0 0-.6-.7h-6.1a.7.7 0 0 0-.6.7v3.2c0 .4.3.7.6.7h6c.4 0 .7-.3.7-.7"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#648BD8",
        d: "M90.1 273.5h12.8m-11.7-3.7v6.3m-.3-12.6v4.5m-.5-97.6 1 46.4s.7 1.6-.3 2.8c-.9 1.1 2.6.7 1 2.3-1.7 1.6.9 1.2 0 3.5-.6 1.6-1 22-1.2 36.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#E4EBF7",
        d: "M73.7 98.7 76 103s2 .8 1.8 2.7l.8 2.2m-14.3 8.7c.2-1 2.2-7.1 12.6-10.5m.7-16s7.7 6 16.5 2.7",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#FFC6A0",
        d: "M92 87s5.5-.9 7.5-4.6c1.3-.3.8 2.2-.3 3.7l-1 1.5s.2.3.2.9c0 .6-.2.6-.3 1v1l-.4 1c-.1.2 0 .6-.2.9-.2.4-1.6 1.8-2.6 2.8-3.8 3.6-5 1.7-6-.4-1-1.8-.7-5.1-.9-6.9-.3-2.9-2.6-3-2-4.4.4-.7 3 .7 3.4 1.8.7 2 2.9 1.8 2.6 1.7"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#DB836E",
        d: "M99.8 82.4c-.5.1-.3.3-1 1.3-.6 1-4.8 2.9-6.4 3.2-2.5.5-2.2-1.6-4.2-2.9-1.7-1-3.6-.6-1.4 1.4 1 1 1 1.1 1.4 3.2.3 1.5-.7 3.7.7 5.6",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: ".8"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#E59788",
        d: "M79.5 108.7c-2 2.9-4.2 6.1-5.5 8.7",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: ".8"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#FFC6A0",
        d: "M87.7 124.8s-2-2-5.1-2.8c-3-.7-3.6-.1-5.5.1-2 .3-4-.9-3.7.7.3 1.7 5 1 5.2 2.1.2 1.1-6.3 2.8-8.3 2.2-.8.8.5 1.9 2 2.2.3 1.5 2.3 1.5 2.3 1.5s.7 1 2.6 1.1c2.5 1.3 9-.7 11-1.5 2-.9-.5-5.6-.5-5.6"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#E59788",
        d: "M73.4 122.8s.7 1.2 3.2 1.4c2.3.3 2.6.6 2.6.6s-2.6 3-9.1 2.3m2.3 2.2s3.8 0 5-.7m-2.4 2.2s2 0 3.3-.6m-1 1.7s1.7 0 2.8-.5m-6.8-9s-.6-1.1 1.3-.5c1.7.5 2.8 0 5.1.1 1.4.1 3-.2 4 .2 1.6.8 3.6 2.2 3.6 2.2s10.6 1.2 19-1.1M79 108s-8.4 2.8-13.2 12.1",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: ".8"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#E4EBF7",
        d: "M109.3 112.5s3.4-3.6 7.6-4.6",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#E59788",
        d: "M107.4 123s9.7-2.7 11.4-.9",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: ".8"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#BFCDDD",
        d: "m194.6 83.7 4-4M187.2 91l3.7-3.6m.9-3-4.5-4.7m11.2 11.5-4.2-4.3m-65 76.3 3.7-3.7M122.3 170l3.5-3.5m.8-2.9-4.3-4.2M133 170l-4-4",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#A3B4C6",
        d: "M190.2 211.8h-1.6a4 4 0 0 1-4-4v-32.1a4 4 0 0 1 4-4h1.6a4 4 0 0 1 4 4v32a4 4 0 0 1-4 4"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#A3B4C6",
        d: "M237.8 213a4.8 4.8 0 0 1-4.8 4.8h-86.6a4.8 4.8 0 0 1 0-9.6H233a4.8 4.8 0 0 1 4.8 4.8"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#A3B4C6",
        d: "M154.1 190.1h70.5v-84.6h-70.5z"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#BFCDDD",
        d: "M225 190.1h-71.2a3.2 3.2 0 0 1-3.2-3.2v-19a3.2 3.2 0 0 1 3.2-3.2h71.1a3.2 3.2 0 0 1 3.2 3.2v19a3.2 3.2 0 0 1-3.2 3.2m0-59.3h-71.1a3.2 3.2 0 0 1-3.2-3.2v-19a3.2 3.2 0 0 1 3.2-3.2h71.1a3.2 3.2 0 0 1 3.2 3.3v19a3.2 3.2 0 0 1-3.2 3.1"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#FFF",
        d: "M159.6 120.5a2.4 2.4 0 1 1 0-4.8 2.4 2.4 0 0 1 0 4.8m7.4 0a2.4 2.4 0 1 1 0-4.8 2.4 2.4 0 0 1 0 4.8m7.4 0a2.4 2.4 0 1 1 0-4.8 2.4 2.4 0 0 1 0 4.8m48.1 0h-22.4a.8.8 0 0 1-.8-.8v-3.2c0-.4.3-.8.8-.8h22.4c.5 0 .8.4.8.8v3.2c0 .5-.3.8-.8.8"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#BFCDDD",
        d: "M225 160.5h-71.2a3.2 3.2 0 0 1-3.2-3.2v-19a3.2 3.2 0 0 1 3.2-3.2h71.1a3.2 3.2 0 0 1 3.2 3.2v19a3.2 3.2 0 0 1-3.2 3.2"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#7C90A5",
        d: "M173.5 130.8h49.3m-57.8 0h6m-15 0h6.7m11.1 29.8h49.3m-57.7 0h6m-15.8 0h6.7",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#FFF",
        d: "M159.6 151a2.4 2.4 0 1 1 0-4.8 2.4 2.4 0 0 1 0 4.8m7.4 0a2.4 2.4 0 1 1 0-4.8 2.4 2.4 0 0 1 0 4.8m7.4 0a2.4 2.4 0 1 1 0-4.8 2.4 2.4 0 0 1 0 4.8m48.1 0h-22.4a.8.8 0 0 1-.8-.8V147c0-.4.3-.8.8-.8h22.4c.5 0 .8.4.8.8v3.2c0 .5-.3.8-.8.8m-63 29a2.4 2.4 0 1 1 0-4.8 2.4 2.4 0 0 1 0 4.8m7.5 0a2.4 2.4 0 1 1 0-4.8 2.4 2.4 0 0 1 0 4.8m7.4 0a2.4 2.4 0 1 1 0-4.8 2.4 2.4 0 0 1 0 4.8m48.1 0h-22.4a.8.8 0 0 1-.8-.8V176c0-.5.3-.8.8-.8h22.4c.5 0 .8.3.8.8v3.2c0 .4-.3.8-.8.8"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#BFCDDD",
        d: "M203 221.1h-27.3a2.4 2.4 0 0 1-2.4-2.4v-11.4a2.4 2.4 0 0 1 2.4-2.5H203a2.4 2.4 0 0 1 2.4 2.5v11.4a2.4 2.4 0 0 1-2.4 2.4"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#A3B4C6",
        d: "M177.3 207.2v11.5m23.8-11.5v11.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#5BA02E",
        d: "M162.9 267.9a9.4 9.4 0 0 1-9.4-9.4v-14.8a9.4 9.4 0 0 1 18.8 0v14.8a9.4 9.4 0 0 1-9.4 9.4"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#92C110",
        d: "M171.2 267.8a9.4 9.4 0 0 1-9.4-9.4V255a9.4 9.4 0 0 1 18.8 0v3.4a9.4 9.4 0 0 1-9.4 9.4"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#F2D7AD",
        d: "M181.3 293.7h-27.7a3.2 3.2 0 0 1-3.2-3.2v-20.7a3.2 3.2 0 0 1 3.2-3.2h27.7a3.2 3.2 0 0 1 3.2 3.2v20.7a3.2 3.2 0 0 1-3.2 3.2"
    })));
var $74a3537ae1308591$export$2e2bcd8739ae039 = $74a3537ae1308591$var$ServerError;





// ============================== Styles ==============================
const $4cb8740c3ab4904b$var$genBaseStyle = (token)=>{
    const { componentCls: componentCls, lineHeightHeading3: lineHeightHeading3, iconCls: iconCls, padding: padding, paddingXL: paddingXL, paddingXS: paddingXS, paddingLG: paddingLG, marginXS: marginXS, lineHeight: lineHeight } = token;
    return {
        // Result
        [componentCls]: {
            padding: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.calc(paddingLG).mul(2).equal())} ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(paddingXL)}`,
            // RTL
            '&-rtl': {
                direction: 'rtl'
            }
        },
        // Exception Status image
        [`${componentCls} ${componentCls}-image`]: {
            width: token.imageWidth,
            height: token.imageHeight,
            margin: 'auto'
        },
        [`${componentCls} ${componentCls}-icon`]: {
            marginBottom: paddingLG,
            textAlign: 'center',
            [`& > ${iconCls}`]: {
                fontSize: token.iconFontSize
            }
        },
        [`${componentCls} ${componentCls}-title`]: {
            color: token.colorTextHeading,
            fontSize: token.titleFontSize,
            lineHeight: lineHeightHeading3,
            marginBlock: marginXS,
            textAlign: 'center'
        },
        [`${componentCls} ${componentCls}-subtitle`]: {
            color: token.colorTextDescription,
            fontSize: token.subtitleFontSize,
            lineHeight: lineHeight,
            textAlign: 'center'
        },
        [`${componentCls} ${componentCls}-body`]: {
            marginTop: paddingLG,
            padding: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(paddingLG)} ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.calc(padding).mul(2.5).equal())}`,
            backgroundColor: token.colorFillAlter
        },
        [`${componentCls} ${componentCls}-extra`]: {
            margin: token.extraMargin,
            textAlign: 'center',
            '& > *': {
                marginInlineEnd: paddingXS,
                '&:last-child': {
                    marginInlineEnd: 0
                }
            }
        }
    };
};
const $4cb8740c3ab4904b$var$genStatusIconStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-success ${componentCls}-icon`]: {
            color: token.resultSuccessIconColor
        },
        [`${componentCls}-error ${componentCls}-icon`]: {
            color: token.resultErrorIconColor
        },
        [`${componentCls}-info ${componentCls}-icon`]: {
            color: token.resultInfoIconColor
        },
        [`${componentCls}-warning ${componentCls}-icon`]: {
            color: token.resultWarningIconColor
        }
    };
};
const $4cb8740c3ab4904b$var$genResultStyle = (token)=>[
        $4cb8740c3ab4904b$var$genBaseStyle(token),
        $4cb8740c3ab4904b$var$genStatusIconStyle(token)
    ];
const $4cb8740c3ab4904b$export$9ca1be8807fe0675 = (token)=>{
    const { fontSizeHeading3: fontSizeHeading3, fontSize: fontSize, paddingLG: paddingLG } = token;
    return {
        titleFontSize: fontSizeHeading3,
        subtitleFontSize: fontSize,
        iconFontSize: (0, $addbc2fddcbb77a9$export$7e4aa119212bc614)(fontSizeHeading3) ? fontSizeHeading3 * 3 : `calc(${fontSizeHeading3} * 3)`,
        extraMargin: `${paddingLG}px 0 0 0`
    };
};
var $4cb8740c3ab4904b$export$2e2bcd8739ae039 = (0, $761caadb5301aee1$export$51ec95de45185b42)('Result', (token)=>{
    const resultInfoIconColor = token.colorInfo;
    const resultErrorIconColor = token.colorError;
    const resultSuccessIconColor = token.colorSuccess;
    const resultWarningIconColor = token.colorWarning;
    const resultToken = (0, $f564548c7b6877d5$export$4950aa0f605343fb)(token, {
        resultInfoIconColor: resultInfoIconColor,
        resultErrorIconColor: resultErrorIconColor,
        resultSuccessIconColor: resultSuccessIconColor,
        resultWarningIconColor: resultWarningIconColor,
        imageWidth: 250,
        imageHeight: 295
    });
    return $4cb8740c3ab4904b$var$genResultStyle(resultToken);
}, $4cb8740c3ab4904b$export$9ca1be8807fe0675);



var $5E6i4 = parcelRequire("5E6i4");
"use client";
const $13aa2b1146e1039e$var$Unauthorized = ()=>/*#__PURE__*/ $5E6i4.createElement("svg", {
        width: "251",
        height: "294"
    }, /*#__PURE__*/ $5E6i4.createElement("title", null, "Unauthorized"), /*#__PURE__*/ $5E6i4.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#E4EBF7",
        d: "M0 129v-2C0 58.3 55.6 2.7 124.2 2.7h2c68.6 0 124.2 55.6 124.2 124.1v2.1c0 68.6-55.6 124.2-124.1 124.2h-2.1A124.2 124.2 0 0 1 0 129"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#FFF",
        d: "M41.4 133a8.2 8.2 0 1 1-16.4-1.7 8.2 8.2 0 0 1 16.4 1.6"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#FFF",
        d: "m38.7 136.4 10.4 5.9m.9 6.2-12.6 10.7",
        strokeWidth: "2"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#FFF",
        d: "M41.5 161.3a5.6 5.6 0 1 1-11.2-1.2 5.6 5.6 0 0 1 11.2 1.2m17.7-16a5.7 5.7 0 1 1-11.3-1.2 5.7 5.7 0 0 1 11.3 1.2m41.2-115.8H130a4.6 4.6 0 1 0 0-9.1h-29.6a4.6 4.6 0 0 0 0 9.1m11.3 18.3h29.7a4.6 4.6 0 1 0 0-9.2h-29.7a4.6 4.6 0 1 0 0 9.2"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#FFF",
        d: "M114 29.5h15.8a4.6 4.6 0 1 0 0 9.1H114a4.6 4.6 0 0 0 0-9.1m71.3 108.2a10 10 0 1 1-19.8-2 10 10 0 0 1 19.8 2"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#FFF",
        d: "m180.2 143.8 12.5 7.1m1.1 7.5-15.1 13",
        strokeWidth: "2"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#FFF",
        d: "M185.6 172a6.8 6.8 0 1 1-13.6-1.4 6.8 6.8 0 0 1 13.5 1.3m18.6-16.6a6.8 6.8 0 1 1-13.6-1.4 6.8 6.8 0 0 1 13.6 1.4"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#FFF",
        d: "M153 194a2.2 2.2 0 1 1-4.4 0 2.2 2.2 0 0 1 4.4 0zm73-75.8a2.2 2.2 0 1 1-4.5 0 2.2 2.2 0 0 1 4.4 0zm-9 34.9a2.2 2.2 0 1 1-4.3 0 2.2 2.2 0 0 1 4.4 0zm-39.2-43.3a2.2 2.2 0 1 1-4.4 0 2.2 2.2 0 0 1 4.4 0zm18.3-15.3a2.2 2.2 0 1 1-4.4 0 2.2 2.2 0 0 1 4.4 0zm6.7 88a2.2 2.2 0 1 1-4.4 0 2.2 2.2 0 0 1 4.4 0z",
        strokeWidth: "2"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#FFF",
        d: "m215.1 155.3-1.9 20-10.8 6m-27.8-4.7-6.3 9.8H157l-4.5 6.4m23.4-65.5v-15.7m45.6 7.8-12.8 7.9-15.2-7.9V96.7",
        strokeWidth: "2"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#A26EF4",
        d: "M180.7 29.3a29.3 29.3 0 1 1 58.6 0 29.3 29.3 0 0 1-58.6 0"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#FFF",
        d: "m221.4 41.7-21.5-.1a1.7 1.7 0 0 1-1.7-1.8V27.6a1.7 1.7 0 0 1 1.8-1.7h21.5c1 0 1.8.9 1.8 1.8l-.1 12.3a1.7 1.7 0 0 1-1.7 1.7"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#FFF",
        d: "M215.1 29.2c0 2.6-2 4.6-4.5 4.6a4.6 4.6 0 0 1-4.5-4.7v-6.9c0-2.6 2-4.6 4.6-4.6 2.5 0 4.5 2 4.4 4.7v6.9zm-4.5-14a6.9 6.9 0 0 0-7 6.8v7.3a6.9 6.9 0 0 0 13.8.1V22a6.9 6.9 0 0 0-6.8-6.9zm-43 53.2h-4a4.7 4.7 0 0 1-4.7-4.8 4.7 4.7 0 0 1 4.7-4.7h4a4.7 4.7 0 0 1 4.7 4.8 4.7 4.7 0 0 1-4.7 4.7"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#5BA02E",
        d: "M168.2 248.8a6.6 6.6 0 0 1-6.6-6.6v-66a6.6 6.6 0 0 1 13.2 0v66a6.6 6.6 0 0 1-6.6 6.6"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#92C110",
        d: "M176.1 248.2a6.6 6.6 0 0 1-6.6-6.6v-33a6.6 6.6 0 1 1 13.3 0v33a6.6 6.6 0 0 1-6.7 6.6"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#F2D7AD",
        d: "M186 293.9h-27.4a3.2 3.2 0 0 1-3.2-3.2v-45.9a3.2 3.2 0 0 1 3.2-3.1H186a3.2 3.2 0 0 1 3.2 3.1v46a3.2 3.2 0 0 1-3.2 3"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#FFF",
        d: "M82 147.7s6.3-1 17.5-1.3c11.8-.4 17.6 1 17.6 1s3.7-3.8 1-8.3c1.3-12.1 6-32.9.3-48.3-1.1-1.4-3.7-1.5-7.5-.6-1.4.3-7.2-.2-8-.1l-15.3-.4-8-.5c-1.6-.1-4.3-1.7-5.5-.3-.4.4-2.4 5.6-2 16l8.7 35.7s-3.2 3.6 1.2 7"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#FFC6A0",
        d: "m75.8 73.3-1-6.4 12-6.5s7.4-.1 8 1.2c.8 1.3-5.5 1-5.5 1s-1.9 1.4-2.6 2.5c-1.7 2.4-1 6.5-8.4 6-1.7.3-2.5 2.2-2.5 2.2"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#FFB594",
        d: "M52.4 77.7S66.7 87 77.4 92c1 .5-2 16.2-11.9 11.8-7.4-3.3-20.1-8.4-21.5-14.5-.7-3.2 2.6-7.6 8.4-11.7M142 80s-6.7 3-13.9 6.9c-3.9 2.1-10.1 4.7-12.3 8-6.2 9.3 3.5 11.2 13 7.5 6.6-2.7 29-12.1 13.2-22.4"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#FFC6A0",
        d: "m76.2 66.4 3 3.8S76.4 73 73 76c-7 6.2-12.8 14.3-16 16.4-4 2.7-9.7 3.3-12.2 0-3.5-5.1.5-14.7 31.5-26"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#FFF",
        d: "M64.7 85.1s-2.4 8.4-9 14.5c.7.5 18.6 10.5 22.2 10 5.2-.6 6.4-19 1.2-20.5-.8-.2-6-1.3-8.9-2.2-.9-.2-1.6-1.7-3.5-1l-2-.8zm63.7.7s5.3 2 7.3 13.8c-.6.2-17.6 12.3-21.8 7.8-6.6-7-.8-17.4 4.2-18.6 4.7-1.2 5-1.4 10.3-3"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#E4EBF7",
        d: "M78.2 94.7s.9 7.4-5 13",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#E4EBF7",
        d: "M87.4 94.7s3.1 2.6 10.3 2.6c7.1 0 9-3.5 9-3.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: ".9"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#FFC6A0",
        d: "m117.2 68.6-6.8-6.1s-5.4-4.4-9.2-1c-3.9 3.5 4.4 2.2 5.6 4.2 1.2 2.1.9 1.2-2 .5-5.7-1.4-2.1.9 3 5.3 2 1.9 7 1 7 1l2.4-3.9z"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#FFB594",
        d: "m105.3 91.3-.3-11H89l-.5 10.5c0 .4.2.8.6 1 2 1.3 9.3 5 15.8.4.2-.2.4-.5.4-.9"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#5C2552",
        d: "M107.6 74.2c.8-1.1 1-9 1-11.9a1 1 0 0 0-1-1l-4.6-.4c-7.7-1-17 .6-18.3 6.3-5.4 5.9-.4 13.3-.4 13.3s2 3.5 4.3 6.8c.8 1 .4-3.8 3-6a47.9 47.9 0 0 1 16-7"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#FFC6A0",
        d: "M88.4 83.2s2.7 6.2 11.6 6.5c7.8.3 9-7 7.5-17.5l-1-5.5c-6-2.9-15.4.6-15.4.6s-.6 2-.2 5.5c-2.3 2-1.8 5.6-1.8 5.6s-1-2-2-2.3c-.9-.3-2 0-2.3 2-1 4.6 3.6 5.1 3.6 5.1"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#DB836E",
        d: "m100.8 77.1 1.7-1-1-4.3.7-1.4",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#552950",
        d: "M105.5 74c0 .8-.4 1.4-1 1.4-.4 0-.8-.7-.8-1.4s.5-1.2 1-1.2.9.6.8 1.3m-8 .2c0 .8-.4 1.3-.9 1.3s-.9-.6-.9-1.3c0-.7.5-1.3 1-1.3s1 .6.9 1.3"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#DB836E",
        d: "M91.1 86.8s5.3 5 12.7 2.3",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#DB836E",
        d: "M99.8 81.9s-3.6.2-1.5-2.8c1.6-1.5 5-.4 5-.4s1 3.9-3.5 3.2"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#5C2552",
        d: "M102.9 70.6s2.5.8 3.4.7m-12.4.7s2.5-1.2 4.8-1.1",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.5"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#DB836E",
        d: "M86.3 77.4s1 .9 1.5 2c-.4.6-1 1.2-.3 1.9m11.8 2.4s2 .2 2.5-.2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#E4EBF7",
        d: "m87.8 115.8 15.7-3m-3.3 3 10-2m-43.7-27s-1.6 8.8-6.7 14M128.3 88s3 4 4 11.7",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#DB836E",
        d: "M64 84.8s-6 10-13.5 10",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: ".8"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#FFC6A0",
        d: "m112.4 66-.2 5.2 12 9.2c4.5 3.6 8.9 7.5 11 8.7 4.8 2.8 8.9 3.3 11 1.8 4.1-2.9 4.4-9.9-8.1-15.3-4.3-1.8-16.1-6.3-25.7-9.7"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#DB836E",
        d: "M130.5 85.5s4.6 5.7 11.7 6.2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: ".8"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#E4EBF7",
        d: "M121.7 105.7s-.4 8.6-1.3 13.6",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#648BD8",
        d: "M115.8 161.5s-3.6-1.5-2.7-7.1",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#CBD1D1",
        d: "M101.5 290.2s4.3 2.1 7.4 1c2.9-.9 4.6.7 7.2 1.3 2.5.5 6.9 1 11.7-1.3 0-5.6-7-4-12-6.8-2.6-1.4-3.8-4.7-3.6-8.8h-9.5s-1.4 10.6-1.2 14.6"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#2B0849",
        d: "M101.5 290s2.4 1.4 6.8.7c3-.4 3.7.5 7.5 1 3.7.6 10.8 0 11.9-.8.4 1-.4 2-.4 2s-1.5.7-4.8.9c-2 .1-5.8.3-7.7-.5-1.8-1.4-5.2-2-5.7-.3-4 1-7.4-.3-7.4-.3l-.2-2.6z"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#A4AABA",
        d: "M108.8 276.2h3.1s0 6.7 4.6 8.6c-4.7.6-8.6-2.3-7.7-8.6"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#CBD1D1",
        d: "M57.6 272.5s-2 7.5-4.5 12.4c-1.8 3.7-4.2 7.6 5.5 7.6 6.7 0 9-.5 7.5-6.7-1.5-6.1.3-13.3.3-13.3h-8.8z"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#2B0849",
        d: "M51.5 290s2.2 1.2 6.7 1.2c6.1 0 8.3-1.6 8.3-1.6s.6 1-.6 2.1c-1 .9-3.6 1.6-7.4 1.6-4.2 0-6-.6-6.8-1.2-.9-.5-.7-1.6-.2-2"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#A4AABA",
        d: "M58.5 274.4s0 1.6-.3 3-1 3.1-1.1 4.2c0 1.1 4.5 1.5 5.2 0 .6-1.6 1.3-6.5 1.9-7.3.6-.8-5-2.1-5.7.1"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#7BB2F9",
        d: "m100.9 277 13.3.1s1.3-54.2 1.8-64c.6-9.9 3.8-43.2 1-62.8l-12.4-.7-22.8.8-1.2 10c0 .4-.6.8-.7 1.3 0 .6.4 1.3.3 2-2.3 14-6.3 32.9-8.7 46.4-.1.6-1.2 1-1.4 2.6 0 .3.2 1.6 0 1.8-6.8 18.7-10.8 47.6-14.1 61.6h14.5s2.2-8.6 4-17a3984 3984 0 0 1 23-84.5l3-.5 1 46.1s-.2 1.2.4 2c.5.8-.6 1.1-.4 2.3l.4 1.7-1 11.9c-.4 4.6 0 39 0 39"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#648BD8",
        d: "M77.4 220.4c1.2.1 4-2 7-4.9m23.1 8.4s2.8-1 6.1-3.8",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#648BD8",
        d: "M108.5 221s2.7-1.2 6-4",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#648BD8",
        d: "M76.1 223.6s2.6-.6 6.5-3.4m4.7-69.4c-.2 3.1.3 8.5-4.3 9m21.8-10.7s.1 14-1.3 15c-2.2 1.6-3 1.9-3 1.9m.5-16.4s0 12.8-1.2 24.3m-4.9 1s7.2-1.6 9.4-1.6m-28.6 31.5-1 4.5s-1.5 1.8-1 3.7c.4 2-1 2-5 15.3-1.7 5.6-4.4 18.5-6.3 27.5l-4 18.4M77 196.7a313.3 313.3 0 0 1-.8 4.8m7.7-50-1.2 10.3s-1 .2-.5 2.3c.1 1.3-2.6 15.6-5.1 30.2M57.6 273h13.2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#192064",
        d: "M117.4 147.4s-17-3-35.7.2v4.2s14.6-2.9 35.5-.4l.2-4"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#FFF",
        d: "M107.5 150.4v-5a.8.8 0 0 0-.8-.7H99a.8.8 0 0 0-.7.8v4.8c0 .5.3.9.8.8a140.8 140.8 0 0 1 7.7 0 .8.8 0 0 0 .8-.7"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: "#192064",
        d: "M106.4 149.4v-3a.6.6 0 0 0-.6-.7 94.1 94.1 0 0 0-5.8 0 .6.6 0 0 0-.7.7v3c0 .4.3.7.7.7h5.7c.4 0 .7-.3.7-.7"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        stroke: "#648BD8",
        d: "M101.5 274h12.3m-11.1-5v6.5m0-12.4v4.3m-.5-93.4.9 44.4s.7 1.6-.2 2.7c-1 1.1 2.4.7.9 2.2-1.6 1.6.9 1.1 0 3.4-.6 1.5-1 21-1.1 35",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.1"
    })));
var $13aa2b1146e1039e$export$2e2bcd8739ae039 = $13aa2b1146e1039e$var$Unauthorized;


"use client";
const $31b03c1d2148500a$export$e75cf43d5d0a9444 = {
    success: (0, $b89ac8aaffc055f4$export$2e2bcd8739ae039),
    error: (0, $18493f15518cd625$export$2e2bcd8739ae039),
    info: (0, $02cacf707e93d6b4$export$2e2bcd8739ae039),
    warning: (0, $71c5a546a32d7376$export$2e2bcd8739ae039)
};
const $31b03c1d2148500a$export$14ba5e3dd65c935a = {
    '404': (0, $cf7bc50fbce40d0a$export$2e2bcd8739ae039),
    '500': (0, $74a3537ae1308591$export$2e2bcd8739ae039),
    '403': (0, $13aa2b1146e1039e$export$2e2bcd8739ae039)
};
// ExceptionImageMap keys
const $31b03c1d2148500a$var$ExceptionStatus = Object.keys($31b03c1d2148500a$export$14ba5e3dd65c935a);
const $31b03c1d2148500a$var$Icon = ({ icon: icon, status: status, className: className, style: style })=>{
    if ($31b03c1d2148500a$var$ExceptionStatus.includes(`${status}`)) {
        const SVGComponent = $31b03c1d2148500a$export$14ba5e3dd65c935a[status];
        return /*#__PURE__*/ $5E6i4.createElement("div", {
            className: className,
            style: style
        }, /*#__PURE__*/ $5E6i4.createElement(SVGComponent, null));
    }
    const iconNode = /*#__PURE__*/ $5E6i4.createElement($31b03c1d2148500a$export$e75cf43d5d0a9444[status]);
    if (icon === null || icon === false) return null;
    return /*#__PURE__*/ $5E6i4.createElement("div", {
        className: className,
        style: style
    }, (0, $b63de2b9864a5d1a$export$72280d5f896dac9a)(icon) ? icon : iconNode);
};
const $31b03c1d2148500a$var$Extra = ({ className: className, extra: extra, style: style })=>{
    if (!(0, $b63de2b9864a5d1a$export$72280d5f896dac9a)(extra)) return null;
    return /*#__PURE__*/ $5E6i4.createElement("div", {
        className: className,
        style: style
    }, extra);
};
const $31b03c1d2148500a$var$Result = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, className: customizeClassName, rootClassName: rootClassName, subTitle: subTitle, title: title, style: style, children: children, status: status = 'info', icon: icon, extra: extra, styles: styles, classNames: classNames, ...rest } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $519f2fad435b3034$export$46f4bd6436a25a31)('result');
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        status: status
    };
    const contextStyleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $722c8632ba7bdb89$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    });
    const prefixCls = getPrefixCls('result', customizePrefixCls);
    // Style
    const [hashId, cssVarCls] = (0, $4cb8740c3ab4904b$export$2e2bcd8739ae039)(prefixCls);
    const rootClassNames = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-${status}`, customizeClassName, contextClassName, rootClassName, {
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, hashId, cssVarCls, mergedClassNames.root);
    const titleClassNames = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-title`, mergedClassNames.title);
    const subTitleClassNames = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-subtitle`, mergedClassNames.subTitle);
    const extraClassNames = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-extra`, mergedClassNames.extra);
    const bodyClassNames = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-body`, mergedClassNames.body);
    const iconClassNames = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-icon`, {
        [`${prefixCls}-image`]: $31b03c1d2148500a$var$ExceptionStatus.includes(`${status}`)
    }, mergedClassNames.icon);
    const rootStyles = {
        ...mergedStyles.root
    };
    const restProps = (0, $78cde6532419ffca$export$2e2bcd8739ae039)(rest, {
        aria: true,
        data: true
    });
    const nativeElementRef = $5E6i4.useRef(null);
    $5E6i4.useImperativeHandle(ref, ()=>({
            nativeElement: nativeElementRef.current
        }));
    return /*#__PURE__*/ $5E6i4.createElement("div", {
        ref: nativeElementRef,
        ...restProps,
        className: rootClassNames,
        style: rootStyles
    }, /*#__PURE__*/ $5E6i4.createElement($31b03c1d2148500a$var$Icon, {
        className: iconClassNames,
        style: mergedStyles.icon,
        status: status,
        icon: icon
    }), (0, $b63de2b9864a5d1a$export$72280d5f896dac9a)(title) && /*#__PURE__*/ $5E6i4.createElement("div", {
        className: titleClassNames,
        style: mergedStyles.title
    }, title), (0, $b63de2b9864a5d1a$export$72280d5f896dac9a)(subTitle) && /*#__PURE__*/ $5E6i4.createElement("div", {
        className: subTitleClassNames,
        style: mergedStyles.subTitle
    }, subTitle), /*#__PURE__*/ $5E6i4.createElement($31b03c1d2148500a$var$Extra, {
        className: extraClassNames,
        extra: extra,
        style: mergedStyles.extra
    }), (0, $b63de2b9864a5d1a$export$72280d5f896dac9a)(children) && /*#__PURE__*/ $5E6i4.createElement("div", {
        className: bodyClassNames,
        style: mergedStyles.body
    }, children));
});
$31b03c1d2148500a$var$Result.PRESENTED_IMAGE_403 = $31b03c1d2148500a$export$14ba5e3dd65c935a['403'];
$31b03c1d2148500a$var$Result.PRESENTED_IMAGE_404 = $31b03c1d2148500a$export$14ba5e3dd65c935a['404'];
$31b03c1d2148500a$var$Result.PRESENTED_IMAGE_500 = $31b03c1d2148500a$export$14ba5e3dd65c935a['500'];
var $31b03c1d2148500a$export$2e2bcd8739ae039 = $31b03c1d2148500a$var$Result;


var $5E6i4 = parcelRequire("5E6i4");



var $5E6i4 = parcelRequire("5E6i4");




var $5E6i4 = parcelRequire("5E6i4");
const $a45768d1e49f13ce$var$calcThumbStyle = (targetElement, vertical)=>{
    if (!targetElement) return null;
    const style = {
        left: targetElement.offsetLeft,
        right: targetElement.parentElement.clientWidth - targetElement.clientWidth - targetElement.offsetLeft,
        width: targetElement.clientWidth,
        top: targetElement.offsetTop,
        bottom: targetElement.parentElement.clientHeight - targetElement.clientHeight - targetElement.offsetTop,
        height: targetElement.clientHeight
    };
    if (vertical) // Adjusts positioning and size for vertical layout by setting horizontal properties to 0 and using vertical properties from the style object.
    return {
        left: 0,
        right: 0,
        width: 0,
        top: style.top,
        bottom: style.bottom,
        height: style.height
    };
    return {
        left: style.left,
        right: style.right,
        width: style.width,
        top: 0,
        bottom: 0,
        height: 0
    };
};
const $a45768d1e49f13ce$var$toPX = (value)=>value !== undefined ? `${value}px` : undefined;
function $a45768d1e49f13ce$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, containerRef: containerRef, value: value, getValueIndex: getValueIndex, motionName: motionName, onMotionStart: onMotionStart, onMotionEnd: onMotionEnd, direction: direction, vertical: vertical = false } = props;
    const thumbRef = $5E6i4.useRef(null);
    const [prevValue, setPrevValue] = $5E6i4.useState(value);
    // =========================== Effect ===========================
    const findValueElement = (val)=>{
        const index = getValueIndex(val);
        const ele = containerRef.current?.querySelectorAll(`.${prefixCls}-item`)[index];
        return ele?.offsetParent && ele;
    };
    const [prevStyle, setPrevStyle] = $5E6i4.useState(null);
    const [nextStyle, setNextStyle] = $5E6i4.useState(null);
    (0, $518ae471aa4f03a7$export$2e2bcd8739ae039)(()=>{
        if (prevValue !== value) {
            const prev = findValueElement(prevValue);
            const next = findValueElement(value);
            const calcPrevStyle = $a45768d1e49f13ce$var$calcThumbStyle(prev, vertical);
            const calcNextStyle = $a45768d1e49f13ce$var$calcThumbStyle(next, vertical);
            setPrevValue(value);
            setPrevStyle(calcPrevStyle);
            setNextStyle(calcNextStyle);
            if (prev && next) onMotionStart();
            else onMotionEnd();
        }
    }, [
        value
    ]);
    const thumbStart = $5E6i4.useMemo(()=>{
        if (vertical) return $a45768d1e49f13ce$var$toPX(prevStyle?.top ?? 0);
        if (direction === 'rtl') return $a45768d1e49f13ce$var$toPX(-prevStyle?.right);
        return $a45768d1e49f13ce$var$toPX(prevStyle?.left);
    }, [
        vertical,
        direction,
        prevStyle
    ]);
    const thumbActive = $5E6i4.useMemo(()=>{
        if (vertical) return $a45768d1e49f13ce$var$toPX(nextStyle?.top ?? 0);
        if (direction === 'rtl') return $a45768d1e49f13ce$var$toPX(-nextStyle?.right);
        return $a45768d1e49f13ce$var$toPX(nextStyle?.left);
    }, [
        vertical,
        direction,
        nextStyle
    ]);
    // =========================== Motion ===========================
    const onAppearStart = ()=>{
        if (vertical) return {
            transform: 'translateY(var(--thumb-start-top))',
            height: 'var(--thumb-start-height)'
        };
        return {
            transform: 'translateX(var(--thumb-start-left))',
            width: 'var(--thumb-start-width)'
        };
    };
    const onAppearActive = ()=>{
        if (vertical) return {
            transform: 'translateY(var(--thumb-active-top))',
            height: 'var(--thumb-active-height)'
        };
        return {
            transform: 'translateX(var(--thumb-active-left))',
            width: 'var(--thumb-active-width)'
        };
    };
    const onVisibleChanged = ()=>{
        setPrevStyle(null);
        setNextStyle(null);
        onMotionEnd();
    };
    // =========================== Render ===========================
    // No need motion when nothing exist in queue
    if (!prevStyle || !nextStyle) return null;
    return /*#__PURE__*/ $5E6i4.createElement((0, $5371a8954d0d2416$export$2e2bcd8739ae039), {
        visible: true,
        motionName: motionName,
        motionAppear: true,
        onAppearStart: onAppearStart,
        onAppearActive: onAppearActive,
        onVisibleChanged: onVisibleChanged
    }, ({ className: motionClassName, style: motionStyle }, ref)=>{
        const mergedStyle = {
            ...motionStyle,
            '--thumb-start-left': thumbStart,
            '--thumb-start-width': $a45768d1e49f13ce$var$toPX(prevStyle?.width),
            '--thumb-active-left': thumbActive,
            '--thumb-active-width': $a45768d1e49f13ce$var$toPX(nextStyle?.width),
            '--thumb-start-top': thumbStart,
            '--thumb-start-height': $a45768d1e49f13ce$var$toPX(prevStyle?.height),
            '--thumb-active-top': thumbActive,
            '--thumb-active-height': $a45768d1e49f13ce$var$toPX(nextStyle?.height)
        };
        // It's little ugly which should be refactor when @umi/test update to latest jsdom
        const motionProps = {
            ref: (0, $92c8c75386168ffc$export$ab452c34e8e05029)(thumbRef, ref),
            style: mergedStyle,
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-thumb`, motionClassName)
        };
        return /*#__PURE__*/ $5E6i4.createElement("div", motionProps);
    });
}


function $51273f5df3473ed3$var$_extends() {
    $51273f5df3473ed3$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $51273f5df3473ed3$var$_extends.apply(this, arguments);
}
function $51273f5df3473ed3$var$getValidTitle(option) {
    if (typeof option.title !== 'undefined') return option.title;
    // read `label` when title is `undefined`
    if (typeof option.label !== 'object') return option.label?.toString();
}
function $51273f5df3473ed3$var$normalizeOptions(options) {
    return options.map((option)=>{
        if (typeof option === 'object' && option !== null) {
            const validTitle = $51273f5df3473ed3$var$getValidTitle(option);
            return {
                ...option,
                value: option.value,
                title: validTitle
            };
        }
        return {
            label: option?.toString(),
            title: option?.toString(),
            value: option
        };
    });
}
const $51273f5df3473ed3$var$InternalSegmentedOption = ({ prefixCls: prefixCls, className: className, style: style, styles: styles, classNames: segmentedClassNames, data: data, disabled: disabled, checked: checked, label: label, title: title, value: value, name: name, onChange: onChange, onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, itemRender: itemRender = (node)=>node })=>{
    const handleChange = (event)=>{
        if (disabled) return;
        onChange(event, value);
    };
    const itemContent = /*#__PURE__*/ $5E6i4.createElement("label", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(className, {
            [`${prefixCls}-item-disabled`]: disabled
        }),
        style: style,
        onMouseDown: onMouseDown
    }, /*#__PURE__*/ $5E6i4.createElement("input", {
        name: name,
        className: `${prefixCls}-item-input`,
        type: "radio",
        disabled: disabled,
        checked: checked,
        onChange: handleChange,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp
    }), /*#__PURE__*/ $5E6i4.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-item-label`, segmentedClassNames?.label),
        title: title,
        style: styles?.label
    }, label));
    return itemRender(itemContent, {
        item: data
    });
};
const $51273f5df3473ed3$var$Segmented = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls = 'rc-segmented', direction: direction, vertical: vertical, options: options = [], disabled: disabled, defaultValue: defaultValue, value: value, name: name, onChange: onChange, className: className = '', style: style, styles: styles, classNames: segmentedClassNames, motionName: motionName = 'thumb-motion', itemRender: itemRender, ...restProps } = props;
    const containerRef = $5E6i4.useRef(null);
    const mergedRef = $5E6i4.useMemo(()=>(0, $92c8c75386168ffc$export$ab452c34e8e05029)(containerRef, ref), [
        containerRef,
        ref
    ]);
    const segmentedOptions = $5E6i4.useMemo(()=>{
        return $51273f5df3473ed3$var$normalizeOptions(options);
    }, [
        options
    ]);
    // Note: We should not auto switch value when value not exist in options
    // which may break single source of truth.
    const [rawValue, setRawValue] = (0, $e18df22f16a16360$export$2e2bcd8739ae039)(defaultValue ?? segmentedOptions[0]?.value, value);
    // ======================= Change ========================
    const [thumbShow, setThumbShow] = $5E6i4.useState(false);
    const handleChange = (event, val)=>{
        setRawValue(val);
        onChange?.(val);
    };
    const divProps = (0, $48bd91d9f828de66$export$2e2bcd8739ae039)(restProps, [
        'children'
    ]);
    // ======================= Focus ========================
    const [isKeyboard, setIsKeyboard] = $5E6i4.useState(false);
    const [isFocused, setIsFocused] = $5E6i4.useState(false);
    const handleFocus = ()=>{
        setIsFocused(true);
    };
    const handleBlur = ()=>{
        setIsFocused(false);
    };
    const handleMouseDown = ()=>{
        setIsKeyboard(false);
    };
    // capture keyboard tab interaction for correct focus style
    const handleKeyUp = (event)=>{
        if (event.key === 'Tab') setIsKeyboard(true);
    };
    // ======================= Keyboard ========================
    const onOffset = (offset)=>{
        // keep the current option and not disabled options
        const validOptions = segmentedOptions.filter((option)=>option.value === rawValue || !option.disabled);
        const currentIndex = validOptions.findIndex((option)=>option.value === rawValue);
        const total = validOptions.length;
        const nextIndex = (currentIndex + offset + total) % total;
        const nextOption = validOptions[nextIndex];
        if (nextOption && nextOption.value !== rawValue) {
            setRawValue(nextOption.value);
            onChange?.(nextOption.value);
        }
    };
    const handleKeyDown = (event)=>{
        switch(event.key){
            case 'ArrowLeft':
            case 'ArrowUp':
                onOffset(-1);
                break;
            case 'ArrowRight':
            case 'ArrowDown':
                onOffset(1);
                break;
        }
    };
    const renderOption = (segmentedOption)=>{
        const { value: optionValue, disabled: optionDisabled } = segmentedOption;
        return /*#__PURE__*/ $5E6i4.createElement($51273f5df3473ed3$var$InternalSegmentedOption, $51273f5df3473ed3$var$_extends({}, segmentedOption, {
            name: name,
            data: segmentedOption,
            itemRender: itemRender,
            key: optionValue,
            prefixCls: prefixCls,
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(segmentedOption.className, `${prefixCls}-item`, segmentedClassNames?.item, {
                [`${prefixCls}-item-selected`]: optionValue === rawValue && !thumbShow,
                [`${prefixCls}-item-selected-text`]: optionValue === rawValue,
                [`${prefixCls}-item-focused`]: isFocused && isKeyboard && optionValue === rawValue
            }),
            style: styles?.item,
            classNames: segmentedClassNames,
            styles: styles,
            checked: optionValue === rawValue,
            onChange: handleChange,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onKeyDown: handleKeyDown,
            onKeyUp: handleKeyUp,
            onMouseDown: handleMouseDown,
            disabled: !!disabled || !!optionDisabled
        }));
    };
    return /*#__PURE__*/ $5E6i4.createElement("div", $51273f5df3473ed3$var$_extends({
        role: "radiogroup",
        "aria-label": "segmented control",
        tabIndex: disabled ? undefined : 0,
        "aria-orientation": vertical ? 'vertical' : 'horizontal',
        style: style
    }, divProps, {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, {
            [`${prefixCls}-rtl`]: direction === 'rtl',
            [`${prefixCls}-disabled`]: disabled,
            [`${prefixCls}-vertical`]: vertical
        }, className),
        ref: mergedRef
    }), /*#__PURE__*/ $5E6i4.createElement("div", {
        className: `${prefixCls}-group`
    }, /*#__PURE__*/ $5E6i4.createElement((0, $a45768d1e49f13ce$export$2e2bcd8739ae039), {
        vertical: vertical,
        prefixCls: prefixCls,
        value: rawValue,
        containerRef: containerRef,
        motionName: `${prefixCls}-${motionName}`,
        direction: direction,
        getValueIndex: (val)=>segmentedOptions.findIndex((n)=>n.value === val),
        onMotionStart: ()=>{
            setThumbShow(true);
        },
        onMotionEnd: ()=>{
            setThumbShow(false);
        }
    }), segmentedOptions.map(renderOption)));
});
const $51273f5df3473ed3$var$TypedSegmented = $51273f5df3473ed3$var$Segmented;
var $51273f5df3473ed3$export$2e2bcd8739ae039 = $51273f5df3473ed3$var$TypedSegmented;













// ============================== Mixins ==============================
function $22ed0951055e2434$var$getItemDisabledStyle(cls, token) {
    return {
        [`${cls}, ${cls}:hover, ${cls}:focus`]: {
            color: token.colorTextDisabled,
            cursor: 'not-allowed'
        }
    };
}
const $22ed0951055e2434$var$getItemSelectedStyle = (token)=>{
    return {
        background: token.itemSelectedBg,
        boxShadow: token.boxShadowTertiary
    };
};
const $22ed0951055e2434$var$segmentedTextEllipsisCss = {
    overflow: 'hidden',
    // handle text ellipsis
    ...(0, $cd5a520fee8002b4$export$b2b65df0d0824629)
};
// ============================== Styles ==============================
const $22ed0951055e2434$var$genSegmentedStyle = (token)=>{
    const { componentCls: componentCls, motionDurationSlow: motionDurationSlow, motionEaseInOut: motionEaseInOut, motionDurationMid: motionDurationMid } = token;
    const labelHeight = token.calc(token.controlHeight).sub(token.calc(token.trackPadding).mul(2)).equal();
    const labelHeightLG = token.calc(token.controlHeightLG).sub(token.calc(token.trackPadding).mul(2)).equal();
    const labelHeightSM = token.calc(token.controlHeightSM).sub(token.calc(token.trackPadding).mul(2)).equal();
    return {
        [componentCls]: {
            ...(0, $cd5a520fee8002b4$export$23997c3e44cc1c59)(token),
            display: 'inline-block',
            padding: token.trackPadding,
            color: token.itemColor,
            background: token.trackBg,
            borderRadius: token.borderRadius,
            transition: `all ${motionDurationMid}`,
            ...(0, $cd5a520fee8002b4$export$a44db842bcb28231)(token),
            [`${componentCls}-group`]: {
                position: 'relative',
                display: 'flex',
                alignItems: 'stretch',
                justifyItems: 'flex-start',
                flexDirection: 'row',
                width: '100%'
            },
            // RTL styles
            [`&${componentCls}-rtl`]: {
                direction: 'rtl'
            },
            [`&${componentCls}-vertical`]: {
                [`${componentCls}-group`]: {
                    flexDirection: 'column'
                },
                [`${componentCls}-thumb`]: {
                    width: '100%',
                    height: 0,
                    padding: `0 ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.paddingXXS)}`
                }
            },
            // block styles
            [`&${componentCls}-block`]: {
                display: 'flex'
            },
            [`&${componentCls}-block ${componentCls}-item`]: {
                flex: 1,
                minWidth: 0
            },
            // item styles
            [`${componentCls}-item`]: {
                position: 'relative',
                textAlign: 'center',
                cursor: 'pointer',
                transition: `color ${motionDurationMid}`,
                borderRadius: token.borderRadiusSM,
                // Fix Safari render bug
                // https://github.com/ant-design/ant-design/issues/45250
                transform: 'translateZ(0)',
                '&-selected': {
                    ...$22ed0951055e2434$var$getItemSelectedStyle(token),
                    color: token.itemSelectedColor
                },
                '&-selected-text': {
                    color: token.itemSelectedColor,
                    transition: `color ${motionDurationMid}`
                },
                '&-focused': (0, $cd5a520fee8002b4$export$6539948f0a737e39)(token),
                '&::after': {
                    content: '""',
                    position: 'absolute',
                    zIndex: -1,
                    width: '100%',
                    height: '100%',
                    top: 0,
                    insetInlineStart: 0,
                    borderRadius: 'inherit',
                    opacity: 0,
                    // This is mandatory to make it not clickable or hoverable
                    // Ref: https://github.com/ant-design/ant-design/issues/40888
                    pointerEvents: 'none',
                    transition: [
                        'opacity',
                        'background-color'
                    ].map((prop)=>`${prop} ${motionDurationMid}`).join(', ')
                },
                [`&:not(${componentCls}-item-selected):not(${componentCls}-item-selected-text):not(${componentCls}-item-disabled)`]: {
                    '&:hover, &:active': {
                        color: token.itemHoverColor
                    },
                    '&:hover::after': {
                        opacity: 1,
                        backgroundColor: token.itemHoverBg
                    },
                    '&:active::after': {
                        opacity: 1,
                        backgroundColor: token.itemActiveBg
                    }
                },
                '&-label': {
                    minHeight: labelHeight,
                    lineHeight: (0, $56bae8a99c3cba6e$export$523c0b569236b342)(labelHeight),
                    padding: `0 ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.segmentedPaddingHorizontal)}`,
                    ...$22ed0951055e2434$var$segmentedTextEllipsisCss
                },
                // syntactic sugar to add `icon` for Segmented Item
                '&-icon + *': {
                    marginInlineStart: token.calc(token.marginSM).div(2).equal()
                },
                // Icons from third-party libraries render as a bare `<svg>` inside the icon wrapper,
                // which the `.anticon` reset never reaches. An `<svg>` has no baseline of its own, so it
                // is aligned by its bottom margin edge (CSS 2.1 §10.8.1) and rides above the label.
                // `display: inline-block` keeps it an atomic inline box so `vertical-align` still applies
                // even under a CSS reset that forces `svg { display: block }` (e.g. Tailwind Preflight),
                // which would otherwise drop the icon onto its own line. `vertical-align: middle` centres its
                // margin box on the x-height line; `margin-block-end` then lifts it by half its own value onto
                // the cap-height centre (capHeight − xHeight ≈ 0.2em across typical fonts), keeping it centred
                // at any icon size.
                // Only matches a bare `<svg>`: an `.anticon` keeps its `<svg>` one level deeper.
                '&-icon > svg': {
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    marginBlockEnd: '0.2em'
                },
                '&-input': {
                    position: 'absolute',
                    insetBlockStart: 0,
                    insetInlineStart: 0,
                    width: 0,
                    height: 0,
                    opacity: 0,
                    pointerEvents: 'none'
                }
            },
            // thumb styles
            [`${componentCls}-thumb`]: {
                ...$22ed0951055e2434$var$getItemSelectedStyle(token),
                position: 'absolute',
                insetBlockStart: 0,
                insetInlineStart: 0,
                width: 0,
                height: '100%',
                padding: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.paddingXXS)} 0`,
                borderRadius: token.borderRadiusSM,
                [`& ~ ${componentCls}-item:not(${componentCls}-item-selected):not(${componentCls}-item-disabled)::after`]: {
                    backgroundColor: 'transparent'
                }
            },
            // size styles
            [`&${componentCls}-lg`]: {
                borderRadius: token.borderRadiusLG,
                [`${componentCls}-item-label`]: {
                    minHeight: labelHeightLG,
                    lineHeight: (0, $56bae8a99c3cba6e$export$523c0b569236b342)(labelHeightLG),
                    padding: `0 ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.segmentedPaddingHorizontal)}`,
                    fontSize: token.fontSizeLG
                },
                [`${componentCls}-item, ${componentCls}-thumb`]: {
                    borderRadius: token.borderRadius
                }
            },
            [`&${componentCls}-sm`]: {
                borderRadius: token.borderRadiusSM,
                [`${componentCls}-item-label`]: {
                    minHeight: labelHeightSM,
                    lineHeight: (0, $56bae8a99c3cba6e$export$523c0b569236b342)(labelHeightSM),
                    padding: `0 ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.segmentedPaddingHorizontalSM)}`
                },
                [`${componentCls}-item, ${componentCls}-thumb`]: {
                    borderRadius: token.borderRadiusXS
                }
            },
            // disabled styles
            ...$22ed0951055e2434$var$getItemDisabledStyle(`&-disabled ${componentCls}-item`, token),
            ...$22ed0951055e2434$var$getItemDisabledStyle(`${componentCls}-item-disabled`, token),
            // transition effect when `appear-active`
            [`${componentCls}-thumb-motion-appear-active`]: {
                willChange: 'transform, width',
                transition: [
                    `transform`,
                    `width`
                ].map((prop)=>`${prop} ${motionDurationSlow} ${motionEaseInOut}`).join(', ')
            },
            [`&${componentCls}-shape-round`]: {
                borderRadius: 9999,
                [`${componentCls}-item, ${componentCls}-thumb`]: {
                    borderRadius: 9999
                }
            }
        }
    };
};
const $22ed0951055e2434$export$9ca1be8807fe0675 = (token)=>{
    const { colorTextLabel: colorTextLabel, colorText: colorText, colorFillSecondary: colorFillSecondary, colorBgElevated: colorBgElevated, colorFill: colorFill, lineWidthBold: lineWidthBold, colorBgLayout: colorBgLayout } = token;
    return {
        trackPadding: lineWidthBold,
        trackBg: colorBgLayout,
        itemColor: colorTextLabel,
        itemHoverColor: colorText,
        itemHoverBg: colorFillSecondary,
        itemSelectedBg: colorBgElevated,
        itemActiveBg: colorFill,
        itemSelectedColor: colorText
    };
};
var $22ed0951055e2434$export$2e2bcd8739ae039 = (0, $761caadb5301aee1$export$51ec95de45185b42)('Segmented', (token)=>{
    const { lineWidth: lineWidth, calc: calc } = token;
    const segmentedToken = (0, $f564548c7b6877d5$export$4950aa0f605343fb)(token, {
        segmentedPaddingHorizontal: calc(token.controlPaddingHorizontal).sub(lineWidth).equal(),
        segmentedPaddingHorizontalSM: calc(token.controlPaddingHorizontalSM).sub(lineWidth).equal()
    });
    return $22ed0951055e2434$var$genSegmentedStyle(segmentedToken);
}, $22ed0951055e2434$export$9ca1be8807fe0675);


"use client";
function $c5c464a2c0131554$var$isSegmentedLabeledOptionWithIcon(option) {
    return (0, $addbc2fddcbb77a9$export$53b83ca8eaab0383)(option) && !!option?.icon;
}
const $c5c464a2c0131554$var$InternalSegmented = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const defaultName = (0, $378d6dcdebc6b864$export$2e2bcd8739ae039)();
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, block: block, options: options = [], size: customSize, style: style, vertical: vertical, orientation: orientation, shape: shape = 'default', name: name = defaultName, styles: styles, classNames: classNames, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $519f2fad435b3034$export$46f4bd6436a25a31)('segmented');
    const mergedProps = {
        ...props,
        options: options,
        size: customSize,
        shape: shape
    };
    const contextStyleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $722c8632ba7bdb89$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    });
    const prefixCls = getPrefixCls('segmented', customizePrefixCls);
    // Style
    const [hashId, cssVarCls] = (0, $22ed0951055e2434$export$2e2bcd8739ae039)(prefixCls);
    // ===================== Size =====================
    const mergedSize = (0, $4bfc7567df2a969e$export$2e2bcd8739ae039)(customSize);
    // syntactic sugar to support `icon` for Segmented Item
    const extendedOptions = $5E6i4.useMemo(()=>options.map((option)=>{
            if ($c5c464a2c0131554$var$isSegmentedLabeledOptionWithIcon(option)) {
                const { icon: icon, label: label, ...restOption } = option;
                return {
                    ...restOption,
                    label: /*#__PURE__*/ $5E6i4.createElement($5E6i4.Fragment, null, /*#__PURE__*/ $5E6i4.createElement("span", {
                        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-item-icon`, mergedClassNames.icon),
                        style: mergedStyles.icon
                    }, icon), (0, $b63de2b9864a5d1a$export$72280d5f896dac9a)(label) && /*#__PURE__*/ $5E6i4.createElement("span", null, label))
                };
            }
            return option;
        }), [
        options,
        prefixCls,
        mergedClassNames.icon,
        mergedStyles.icon
    ]);
    const [, mergedVertical] = (0, $a77e455e2dd6afec$export$550084c67147f6c4)(orientation, vertical);
    const cls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(className, rootClassName, contextClassName, mergedClassNames.root, {
        [`${prefixCls}-block`]: block,
        [`${prefixCls}-sm`]: mergedSize === 'small',
        [`${prefixCls}-lg`]: mergedSize === 'large',
        [`${prefixCls}-vertical`]: mergedVertical,
        [`${prefixCls}-shape-${shape}`]: shape === 'round'
    }, hashId, cssVarCls);
    const itemRender = (node, { item: item })=>{
        if (!item.tooltip) return node;
        const tooltipProps = (0, $addbc2fddcbb77a9$export$53b83ca8eaab0383)(item.tooltip) ? item.tooltip : {
            title: item.tooltip
        };
        return /*#__PURE__*/ $5E6i4.createElement((0, $1bb718ecb5669b36$export$2e2bcd8739ae039), {
            ...tooltipProps
        }, node);
    };
    return /*#__PURE__*/ $5E6i4.createElement((0, $51273f5df3473ed3$export$2e2bcd8739ae039), {
        ...restProps,
        name: name,
        className: cls,
        style: mergedStyles.root,
        classNames: mergedClassNames,
        styles: mergedStyles,
        itemRender: itemRender,
        options: extendedOptions,
        ref: ref,
        prefixCls: prefixCls,
        direction: direction,
        vertical: mergedVertical
    });
});
const $c5c464a2c0131554$var$Segmented = $c5c464a2c0131554$var$InternalSegmented;
var $c5c464a2c0131554$export$2e2bcd8739ae039 = $c5c464a2c0131554$var$Segmented;


var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $b4bb06d52881bcc0$var$CloseOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "fill-rule": "evenodd",
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z"
                }
            }
        ]
    },
    "name": "close",
    "theme": "outlined"
};
var $b4bb06d52881bcc0$export$2e2bcd8739ae039 = $b4bb06d52881bcc0$var$CloseOutlined;



function $80d24bc031ad50e3$var$_extends() {
    $80d24bc031ad50e3$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $80d24bc031ad50e3$var$_extends.apply(this, arguments);
}
const $80d24bc031ad50e3$var$CloseOutlined = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $80d24bc031ad50e3$var$_extends({}, props, {
        ref: ref,
        icon: (0, $b4bb06d52881bcc0$export$2e2bcd8739ae039)
    }));
/**![close](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdmlld0JveD0iNjQgNjQgODk2IDg5NiIgZm9jdXNhYmxlPSJmYWxzZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNzk5Ljg2IDE2Ni4zMWMuMDIgMCAuMDQuMDIuMDguMDZsNTcuNjkgNTcuN2MuMDQuMDMuMDUuMDUuMDYuMDhhLjEyLjEyIDAgMDEwIC4wNmMwIC4wMy0uMDIuMDUtLjA2LjA5TDU2OS45MyA1MTJsMjg3LjcgMjg3LjdjLjA0LjA0LjA1LjA2LjA2LjA5YS4xMi4xMiAwIDAxMCAuMDdjMCAuMDItLjAyLjA0LS4wNi4wOGwtNTcuNyA1Ny42OWMtLjAzLjA0LS4wNS4wNS0uMDcuMDZhLjEyLjEyIDAgMDEtLjA3IDBjLS4wMyAwLS4wNS0uMDItLjA5LS4wNkw1MTIgNTY5LjkzbC0yODcuNyAyODcuN2MtLjA0LjA0LS4wNi4wNS0uMDkuMDZhLjEyLjEyIDAgMDEtLjA3IDBjLS4wMiAwLS4wNC0uMDItLjA4LS4wNmwtNTcuNjktNTcuN2MtLjA0LS4wMy0uMDUtLjA1LS4wNi0uMDdhLjEyLjEyIDAgMDEwLS4wN2MwLS4wMy4wMi0uMDUuMDYtLjA5TDQ1NC4wNyA1MTJsLTI4Ny43LTI4Ny43Yy0uMDQtLjA0LS4wNS0uMDYtLjA2LS4wOWEuMTIuMTIgMCAwMTAtLjA3YzAtLjAyLjAyLS4wNC4wNi0uMDhsNTcuNy01Ny42OWMuMDMtLjA0LjA1LS4wNS4wNy0uMDZhLjEyLjEyIDAgMDEuMDcgMGMuMDMgMCAuMDUuMDIuMDkuMDZMNTEyIDQ1NC4wN2wyODcuNy0yODcuN2MuMDQtLjA0LjA2LS4wNS4wOS0uMDZhLjEyLjEyIDAgMDEuMDcgMHoiIC8+PC9zdmc+) */ const $80d24bc031ad50e3$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($80d24bc031ad50e3$var$CloseOutlined);
var $80d24bc031ad50e3$export$2e2bcd8739ae039 = $80d24bc031ad50e3$var$RefIcon;




var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $2311502fe61f05d2$var$PlusOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8z"
                }
            }
        ]
    },
    "name": "plus",
    "theme": "outlined"
};
var $2311502fe61f05d2$export$2e2bcd8739ae039 = $2311502fe61f05d2$var$PlusOutlined;



function $9a6c2ad1f374ce69$var$_extends() {
    $9a6c2ad1f374ce69$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9a6c2ad1f374ce69$var$_extends.apply(this, arguments);
}
const $9a6c2ad1f374ce69$var$PlusOutlined = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $9a6c2ad1f374ce69$var$_extends({}, props, {
        ref: ref,
        icon: (0, $2311502fe61f05d2$export$2e2bcd8739ae039)
    }));
/**![plus](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTQ4MiAxNTJoNjBxOCAwIDggOHY3MDRxMCA4LTggOGgtNjBxLTggMC04LThWMTYwcTAtOCA4LTh6IiAvPjxwYXRoIGQ9Ik0xOTIgNDc0aDY3MnE4IDAgOCA4djYwcTAgOC04IDhIMTYwcS04IDAtOC04di02MHEwLTggOC04eiIgLz48L3N2Zz4=) */ const $9a6c2ad1f374ce69$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($9a6c2ad1f374ce69$var$PlusOutlined);
var $9a6c2ad1f374ce69$export$2e2bcd8739ae039 = $9a6c2ad1f374ce69$var$RefIcon;





var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");
var $e78195c86f2d256b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5E6i4.createContext)(null);


// zombieJ: To compatible with `renderTabBar` usage.

var $5E6i4 = parcelRequire("5E6i4");




var $5E6i4 = parcelRequire("5E6i4");



var $5E6i4 = parcelRequire("5E6i4");
const $8f178612625aafaf$var$useIndicator = (options)=>{
    const { activeTabOffset: activeTabOffset, horizontal: horizontal, rtl: rtl, indicator: indicator = {} } = options;
    const { size: size, align: align = 'center' } = indicator;
    const [inkStyle, setInkStyle] = (0, $5E6i4.useState)();
    const inkBarRafRef = (0, $5E6i4.useRef)(undefined);
    const getLength = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useCallback((origin)=>{
        if (typeof size === 'function') return size(origin);
        if (typeof size === 'number') return size;
        return origin;
    }, [
        size
    ]);
    // Delay set ink style to avoid remove tab blink
    function cleanInkBarRaf() {
        (0, $1d949665862f071a$export$2e2bcd8739ae039).cancel(inkBarRafRef.current);
    }
    (0, $5E6i4.useEffect)(()=>{
        const newInkStyle = {};
        if (activeTabOffset) {
            if (horizontal) {
                newInkStyle.width = getLength(activeTabOffset.width);
                const key = rtl ? 'right' : 'left';
                if (align === 'start') newInkStyle[key] = activeTabOffset[key];
                if (align === 'center') {
                    newInkStyle[key] = activeTabOffset[key] + activeTabOffset.width / 2;
                    newInkStyle.transform = rtl ? 'translateX(50%)' : 'translateX(-50%)';
                }
                if (align === 'end') {
                    newInkStyle[key] = activeTabOffset[key] + activeTabOffset.width;
                    newInkStyle.transform = 'translateX(-100%)';
                }
            } else {
                newInkStyle.height = getLength(activeTabOffset.height);
                if (align === 'start') newInkStyle.top = activeTabOffset.top;
                if (align === 'center') {
                    newInkStyle.top = activeTabOffset.top + activeTabOffset.height / 2;
                    newInkStyle.transform = 'translateY(-50%)';
                }
                if (align === 'end') {
                    newInkStyle.top = activeTabOffset.top + activeTabOffset.height;
                    newInkStyle.transform = 'translateY(-100%)';
                }
            }
        }
        cleanInkBarRaf();
        inkBarRafRef.current = (0, $1d949665862f071a$export$2e2bcd8739ae039)(()=>{
            // Avoid jitter caused by tiny numerical differences
            // fix https://github.com/ant-design/ant-design/issues/53378
            const isEqual = inkStyle && newInkStyle && Object.keys(newInkStyle).every((key)=>{
                const newValue = newInkStyle[key];
                const oldValue = inkStyle[key];
                return typeof newValue === 'number' && typeof oldValue === 'number' ? Math.round(newValue) === Math.round(oldValue) : newValue === oldValue;
            });
            if (!isEqual) setInkStyle(newInkStyle);
        });
        return cleanInkBarRaf;
    }, [
        JSON.stringify(activeTabOffset),
        horizontal,
        rtl,
        align,
        getLength
    ]);
    return {
        style: inkStyle
    };
};
var $8f178612625aafaf$export$2e2bcd8739ae039 = $8f178612625aafaf$var$useIndicator;



var $5E6i4 = parcelRequire("5E6i4");
const $7b9c03f9a0d6c2aa$var$DEFAULT_SIZE = {
    width: 0,
    height: 0,
    left: 0,
    top: 0
};
function $7b9c03f9a0d6c2aa$export$2e2bcd8739ae039(tabs, tabSizes, holderScrollWidth) {
    return (0, $5E6i4.useMemo)(()=>{
        const map = new Map();
        const lastOffset = tabSizes.get(tabs[0]?.key) || $7b9c03f9a0d6c2aa$var$DEFAULT_SIZE;
        const rightOffset = lastOffset.left + lastOffset.width;
        for(let i = 0; i < tabs.length; i += 1){
            const { key: key } = tabs[i];
            let data = tabSizes.get(key);
            // Reuse last one when not exist yet
            if (!data) data = tabSizes.get(tabs[i - 1]?.key) || $7b9c03f9a0d6c2aa$var$DEFAULT_SIZE;
            const entity = map.get(key) || {
                ...data
            };
            // Right
            entity.right = rightOffset - entity.left - entity.width;
            // Update entity
            map.set(key, entity);
        }
        return map;
    }, [
        tabs.map((tab)=>tab.key).join('_'),
        tabSizes,
        holderScrollWidth
    ]);
}



var $5E6i4 = parcelRequire("5E6i4");
function $281a048496b8859f$export$2e2bcd8739ae039(defaultState, onChange) {
    const stateRef = $5E6i4.useRef(defaultState);
    const [, forceUpdate] = $5E6i4.useState({});
    function setState(updater) {
        const newValue = typeof updater === 'function' ? updater(stateRef.current) : updater;
        if (newValue !== stateRef.current) onChange(newValue, stateRef.current);
        stateRef.current = newValue;
        forceUpdate({});
    }
    return [
        stateRef.current,
        setState
    ];
}



var $5E6i4 = parcelRequire("5E6i4");
const $df3a36b81cc0419f$var$MIN_SWIPE_DISTANCE = 0.1;
const $df3a36b81cc0419f$var$STOP_SWIPE_DISTANCE = 0.01;
const $df3a36b81cc0419f$var$REFRESH_INTERVAL = 20;
const $df3a36b81cc0419f$var$SPEED_OFF_MULTIPLE = 0.995 ** $df3a36b81cc0419f$var$REFRESH_INTERVAL;
function $df3a36b81cc0419f$export$2e2bcd8739ae039(ref, onOffset) {
    const [touchPosition, setTouchPosition] = (0, $5E6i4.useState)();
    const [lastTimestamp, setLastTimestamp] = (0, $5E6i4.useState)(0);
    const [lastTimeDiff, setLastTimeDiff] = (0, $5E6i4.useState)(0);
    const [lastOffset, setLastOffset] = (0, $5E6i4.useState)();
    const motionRef = (0, $5E6i4.useRef)(undefined);
    // ========================= Events =========================
    // >>> Touch events
    function onTouchStart(e) {
        const { screenX: screenX, screenY: screenY } = e.touches[0];
        setTouchPosition({
            x: screenX,
            y: screenY
        });
        window.clearInterval(motionRef.current);
    }
    function onTouchMove(e) {
        if (!touchPosition) return;
        // e.preventDefault();
        const { screenX: screenX, screenY: screenY } = e.touches[0];
        setTouchPosition({
            x: screenX,
            y: screenY
        });
        const offsetX = screenX - touchPosition.x;
        const offsetY = screenY - touchPosition.y;
        onOffset(offsetX, offsetY);
        const now = Date.now();
        setLastTimestamp(now);
        setLastTimeDiff(now - lastTimestamp);
        setLastOffset({
            x: offsetX,
            y: offsetY
        });
    }
    function onTouchEnd() {
        if (!touchPosition) return;
        setTouchPosition(null);
        setLastOffset(null);
        // Swipe if needed
        if (lastOffset) {
            const distanceX = lastOffset.x / lastTimeDiff;
            const distanceY = lastOffset.y / lastTimeDiff;
            const absX = Math.abs(distanceX);
            const absY = Math.abs(distanceY);
            // Skip swipe if low distance
            if (Math.max(absX, absY) < $df3a36b81cc0419f$var$MIN_SWIPE_DISTANCE) return;
            let currentX = distanceX;
            let currentY = distanceY;
            motionRef.current = window.setInterval(()=>{
                if (Math.abs(currentX) < $df3a36b81cc0419f$var$STOP_SWIPE_DISTANCE && Math.abs(currentY) < $df3a36b81cc0419f$var$STOP_SWIPE_DISTANCE) {
                    window.clearInterval(motionRef.current);
                    return;
                }
                currentX *= $df3a36b81cc0419f$var$SPEED_OFF_MULTIPLE;
                currentY *= $df3a36b81cc0419f$var$SPEED_OFF_MULTIPLE;
                onOffset(currentX * $df3a36b81cc0419f$var$REFRESH_INTERVAL, currentY * $df3a36b81cc0419f$var$REFRESH_INTERVAL);
            }, $df3a36b81cc0419f$var$REFRESH_INTERVAL);
        }
    }
    // >>> Wheel event
    const lastWheelDirectionRef = (0, $5E6i4.useRef)(undefined);
    function onWheel(e) {
        const { deltaX: deltaX, deltaY: deltaY } = e;
        // Convert both to x & y since wheel only happened on PC
        let mixed;
        const absX = Math.abs(deltaX);
        const absY = Math.abs(deltaY);
        if (absX === absY) mixed = lastWheelDirectionRef.current === 'x' ? deltaX : deltaY;
        else if (absX > absY) {
            mixed = deltaX;
            lastWheelDirectionRef.current = 'x';
        } else {
            mixed = deltaY;
            lastWheelDirectionRef.current = 'y';
        }
        if (onOffset(-mixed, -mixed)) e.preventDefault();
    }
    // ========================= Effect =========================
    const touchEventsRef = (0, $5E6i4.useRef)(null);
    touchEventsRef.current = {
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd,
        onWheel: onWheel
    };
    $5E6i4.useEffect(()=>{
        function onProxyTouchStart(e) {
            touchEventsRef.current.onTouchStart(e);
        }
        function onProxyTouchMove(e) {
            touchEventsRef.current.onTouchMove(e);
        }
        function onProxyTouchEnd(e) {
            touchEventsRef.current.onTouchEnd(e);
        }
        function onProxyWheel(e) {
            touchEventsRef.current.onWheel(e);
        }
        document.addEventListener('touchmove', onProxyTouchMove, {
            passive: false
        });
        document.addEventListener('touchend', onProxyTouchEnd, {
            passive: true
        });
        // No need to clean up since element removed
        ref.current.addEventListener('touchstart', onProxyTouchStart, {
            passive: true
        });
        ref.current.addEventListener('wheel', onProxyWheel, {
            passive: false
        });
        return ()=>{
            document.removeEventListener('touchmove', onProxyTouchMove);
            document.removeEventListener('touchend', onProxyTouchEnd);
        };
    }, []);
}




var $5E6i4 = parcelRequire("5E6i4");
function $ad7aec859c5acf5c$export$2e2bcd8739ae039(callback) {
    const [count, setCount] = (0, $5E6i4.useState)(0);
    const effectRef = (0, $5E6i4.useRef)(0);
    const callbackRef = (0, $5E6i4.useRef)(undefined);
    callbackRef.current = callback;
    // Trigger on `useLayoutEffect`
    (0, $518ae471aa4f03a7$export$9283e56bae2f7b0f)(()=>{
        callbackRef.current?.();
    }, [
        count
    ]);
    // Trigger to update count
    return ()=>{
        if (effectRef.current !== count) return;
        effectRef.current += 1;
        setCount(effectRef.current);
    };
}
function $ad7aec859c5acf5c$export$aefd2a30eb6d999e(defaultState) {
    const batchRef = (0, $5E6i4.useRef)([]);
    const [, forceUpdate] = (0, $5E6i4.useState)({});
    const state = (0, $5E6i4.useRef)(typeof defaultState === 'function' ? defaultState() : defaultState);
    const flushUpdate = $ad7aec859c5acf5c$export$2e2bcd8739ae039(()=>{
        let current = state.current;
        batchRef.current.forEach((callback)=>{
            current = callback(current);
        });
        batchRef.current = [];
        state.current = current;
        forceUpdate({});
    });
    function updater(callback) {
        batchRef.current.push(callback);
        flushUpdate();
    }
    return [
        state.current,
        updater
    ];
}



var $5E6i4 = parcelRequire("5E6i4");
const $6c61c3d3570143a2$var$DEFAULT_SIZE = {
    width: 0,
    height: 0,
    left: 0,
    top: 0,
    right: 0
};
function $6c61c3d3570143a2$export$2e2bcd8739ae039(tabOffsets, visibleTabContentValue, transform, tabContentSizeValue, addNodeSizeValue, operationNodeSizeValue, { tabs: tabs, tabPosition: tabPosition, rtl: rtl }) {
    let charUnit;
    let position;
    let transformSize;
    if ([
        'top',
        'bottom'
    ].includes(tabPosition)) {
        charUnit = 'width';
        position = rtl ? 'right' : 'left';
        transformSize = Math.abs(transform);
    } else {
        charUnit = 'height';
        position = 'top';
        transformSize = -transform;
    }
    return (0, $5E6i4.useMemo)(()=>{
        if (!tabs.length) return [
            0,
            0
        ];
        const len = tabs.length;
        let endIndex = len;
        for(let i = 0; i < len; i += 1){
            const offset = tabOffsets.get(tabs[i].key) || $6c61c3d3570143a2$var$DEFAULT_SIZE;
            if (Math.floor(offset[position] + offset[charUnit]) > Math.floor(transformSize + visibleTabContentValue)) {
                endIndex = i - 1;
                break;
            }
        }
        let startIndex = 0;
        for(let i = len - 1; i >= 0; i -= 1){
            const offset = tabOffsets.get(tabs[i].key) || $6c61c3d3570143a2$var$DEFAULT_SIZE;
            if (offset[position] < transformSize) {
                startIndex = i + 1;
                break;
            }
        }
        return startIndex > endIndex ? [
            0,
            -1
        ] : [
            startIndex,
            endIndex
        ];
    }, [
        tabOffsets,
        visibleTabContentValue,
        tabContentSizeValue,
        addNodeSizeValue,
        operationNodeSizeValue,
        transformSize,
        tabPosition,
        tabs.map((tab)=>tab.key).join('_'),
        rtl
    ]);
}


/**
 * We trade Map as deps which may change with same value but different ref object.
 * We should make it as hash for deps
 * */ function $ef63254ed4c073de$export$fac44ee5b035f737(obj) {
    let tgt;
    if (obj instanceof Map) {
        tgt = {};
        obj.forEach((v, k)=>{
            tgt[k] = v;
        });
    } else tgt = obj;
    return JSON.stringify(tgt);
}
const $ef63254ed4c073de$var$RC_TABS_DOUBLE_QUOTE = 'TABS_DQ';
function $ef63254ed4c073de$export$c55417729a96230c(key) {
    return String(key).replace(/"/g, $ef63254ed4c073de$var$RC_TABS_DOUBLE_QUOTE);
}
function $ef63254ed4c073de$export$eab31ca11b8b073(closable, closeIcon, editable, disabled) {
    if (// Only editable tabs can be removed
    !editable || // Tabs cannot be removed when disabled
    disabled || // closable is false
    closable === false || // If closable is undefined, the remove button should be hidden when closeIcon is null or false
    closable === undefined && (closeIcon === false || closeIcon === null)) return false;
    return true;
}



var $5E6i4 = parcelRequire("5E6i4");
const $53f39a909c012fcc$var$AddButton = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, editable: editable, locale: locale, style: style } = props;
    if (!editable || editable.showAdd === false) return null;
    return /*#__PURE__*/ $5E6i4.createElement("button", {
        ref: ref,
        type: "button",
        className: `${prefixCls}-nav-add`,
        style: style,
        "aria-label": locale?.addAriaLabel || 'Add tab',
        onClick: (event)=>{
            editable.onEdit('add', {
                event: event
            });
        }
    }, editable.addIcon || '+');
});
var $53f39a909c012fcc$export$2e2bcd8739ae039 = $53f39a909c012fcc$var$AddButton;



var $5E6i4 = parcelRequire("5E6i4");
const $22294141c0194179$var$ExtraContent = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { position: position, prefixCls: prefixCls, extra: extra } = props;
    if (!extra) return null;
    let content;
    // Parse extra
    let assertExtra = {};
    if (typeof extra === 'object' && !/*#__PURE__*/ $5E6i4.isValidElement(extra)) assertExtra = extra;
    else assertExtra.right = extra;
    if (position === 'right') content = assertExtra.right;
    if (position === 'left') content = assertExtra.left;
    return content ? /*#__PURE__*/ $5E6i4.createElement("div", {
        className: `${prefixCls}-extra-content`,
        ref: ref
    }, content) : null;
});
var $22294141c0194179$export$2e2bcd8739ae039 = $22294141c0194179$var$ExtraContent;







var $5E6i4 = parcelRequire("5E6i4");


function $f0406f1607e76583$var$_extends() {
    $f0406f1607e76583$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f0406f1607e76583$var$_extends.apply(this, arguments);
}
const $f0406f1607e76583$var$OperationNode = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, id: id, tabs: tabs, locale: locale, mobile: mobile, more: moreProps = {}, style: style, className: className, editable: editable, tabBarGutter: tabBarGutter, rtl: rtl, removeAriaLabel: removeAriaLabel, onTabClick: onTabClick, getPopupContainer: getPopupContainer, popupClassName: popupClassName, popupStyle: popupStyle, classNames: classNames, styles: styles } = props;
    // ======================== Dropdown ========================
    const [open, setOpen] = (0, $5E6i4.useState)(false);
    const [selectedKey, setSelectedKey] = (0, $5E6i4.useState)(null);
    const { icon: moreIcon = 'More', popupRender: popupRender } = moreProps;
    const popupId = `${id}-more-popup`;
    const dropdownPrefix = `${prefixCls}-dropdown`;
    const selectedItemId = selectedKey !== null ? `${popupId}-${selectedKey}` : null;
    const dropdownAriaLabel = locale?.dropdownAriaLabel;
    function onRemoveTab(event, key) {
        event.preventDefault();
        event.stopPropagation();
        editable.onEdit('remove', {
            key: key,
            event: event
        });
    }
    const menu = /*#__PURE__*/ $5E6i4.createElement((0, $e823adc24933414e$export$2e2bcd8739ae039), {
        onClick: ({ key: key, domEvent: domEvent })=>{
            onTabClick(key, domEvent);
            setOpen(false);
        },
        prefixCls: `${dropdownPrefix}-menu`,
        id: popupId,
        tabIndex: -1,
        role: "listbox",
        "aria-activedescendant": selectedItemId,
        selectedKeys: [
            selectedKey
        ],
        "aria-label": dropdownAriaLabel !== undefined ? dropdownAriaLabel : 'expanded dropdown'
    }, tabs.map((tab)=>{
        const { closable: closable, disabled: disabled, closeIcon: closeIcon, key: key, label: label } = tab;
        const removable = (0, $ef63254ed4c073de$export$eab31ca11b8b073)(closable, closeIcon, editable, disabled);
        return /*#__PURE__*/ $5E6i4.createElement((0, $57699299a59a5ce1$export$2e2bcd8739ae039), {
            key: key,
            id: `${popupId}-${key}`,
            role: "option",
            "aria-controls": id && `${id}-panel-${key}`,
            disabled: disabled
        }, /*#__PURE__*/ $5E6i4.createElement("span", null, label), removable && /*#__PURE__*/ $5E6i4.createElement("button", {
            type: "button",
            "aria-label": removeAriaLabel || 'remove',
            tabIndex: 0,
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${dropdownPrefix}-menu-item-remove`, classNames?.remove),
            style: styles?.remove,
            onClick: (e)=>{
                e.stopPropagation();
                onRemoveTab(e, key);
            }
        }, closeIcon || editable.removeIcon || "\xd7"));
    }));
    const overlay = popupRender ? popupRender(menu, {
        restTabs: tabs,
        onClose: ()=>setOpen(false)
    }) : menu;
    function selectOffset(offset) {
        const enabledTabs = tabs.filter((tab)=>!tab.disabled);
        let selectedIndex = enabledTabs.findIndex((tab)=>tab.key === selectedKey) || 0;
        const len = enabledTabs.length;
        for(let i = 0; i < len; i += 1){
            selectedIndex = (selectedIndex + offset + len) % len;
            const tab = enabledTabs[selectedIndex];
            if (!tab.disabled) {
                setSelectedKey(tab.key);
                return;
            }
        }
    }
    function onKeyDown(e) {
        const { which: which } = e;
        if (!open) {
            if ([
                (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).DOWN,
                (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).SPACE,
                (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).ENTER
            ].includes(which)) {
                setOpen(true);
                e.preventDefault();
            }
            return;
        }
        switch(which){
            case (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).UP:
                selectOffset(-1);
                e.preventDefault();
                break;
            case (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).DOWN:
                selectOffset(1);
                e.preventDefault();
                break;
            case (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).ESC:
                setOpen(false);
                break;
            case (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).SPACE:
            case (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).ENTER:
                if (selectedKey !== null) onTabClick(selectedKey, e);
                break;
        }
    }
    // ========================= Effect =========================
    (0, $5E6i4.useEffect)(()=>{
        // We use query element here to avoid React strict warning
        const ele = document.getElementById(selectedItemId);
        if (ele?.scrollIntoView) ele.scrollIntoView(false);
    }, [
        selectedItemId,
        selectedKey
    ]);
    (0, $5E6i4.useEffect)(()=>{
        if (!open) setSelectedKey(null);
    }, [
        open
    ]);
    // ========================= Render =========================
    const moreStyle = {
        marginInlineStart: tabBarGutter
    };
    if (!tabs.length) {
        moreStyle.visibility = 'hidden';
        moreStyle.order = 1;
    }
    const overlayClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(popupClassName, {
        [`${dropdownPrefix}-rtl`]: rtl
    });
    const moreNode = mobile ? null : /*#__PURE__*/ $5E6i4.createElement((0, $3b318c9105776b14$export$2e2bcd8739ae039), $f0406f1607e76583$var$_extends({
        prefixCls: dropdownPrefix,
        overlay: overlay,
        visible: tabs.length ? open : false,
        onVisibleChange: setOpen,
        overlayClassName: overlayClassName,
        overlayStyle: popupStyle,
        mouseEnterDelay: 0.1,
        mouseLeaveDelay: 0.1,
        getPopupContainer: getPopupContainer
    }, moreProps), /*#__PURE__*/ $5E6i4.createElement("button", {
        type: "button",
        className: `${prefixCls}-nav-more`,
        style: moreStyle,
        "aria-haspopup": "listbox",
        "aria-controls": popupId,
        id: `${id}-more`,
        "aria-expanded": open,
        onKeyDown: onKeyDown
    }, moreIcon));
    return /*#__PURE__*/ $5E6i4.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-nav-operations`, className),
        style: style,
        ref: ref
    }, moreNode, /*#__PURE__*/ $5E6i4.createElement((0, $53f39a909c012fcc$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        locale: locale,
        editable: editable
    }));
});
var $f0406f1607e76583$export$2e2bcd8739ae039 = /*#__PURE__*/ $5E6i4.memo($f0406f1607e76583$var$OperationNode, (_, next)=>// https://github.com/ant-design/ant-design/issues/32544
    // We'd better remove syntactic sugar in `rc-menu` since this has perf issue
    next.tabMoving);




var $5E6i4 = parcelRequire("5E6i4");

const $e98b95980e2ab827$var$TabNode = (props)=>{
    const { prefixCls: prefixCls, id: id, active: active, focus: focus, tab: { key: key, label: label, disabled: disabled, closeIcon: closeIcon, icon: icon }, closable: closable, renderWrapper: renderWrapper, removeAriaLabel: removeAriaLabel, editable: editable, onClick: onClick, onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, onMouseDown: onMouseDown, onMouseUp: onMouseUp, styles: styles, classNames: tabNodeClassNames, tabCount: tabCount, currentPosition: currentPosition } = props;
    const tabPrefix = `${prefixCls}-tab`;
    const removable = (0, $ef63254ed4c073de$export$eab31ca11b8b073)(closable, closeIcon, editable, disabled);
    function onInternalClick(e) {
        if (disabled) return;
        onClick(e);
    }
    function onRemoveTab(event) {
        event.preventDefault();
        event.stopPropagation();
        editable.onEdit('remove', {
            key: key,
            event: event
        });
    }
    const labelNode = $5E6i4.useMemo(()=>icon && typeof label === 'string' ? /*#__PURE__*/ $5E6i4.createElement("span", null, label) : label, [
        label,
        icon
    ]);
    const btnRef = $5E6i4.useRef(null);
    $5E6i4.useEffect(()=>{
        if (focus && btnRef.current) btnRef.current.focus();
    }, [
        focus
    ]);
    const node = /*#__PURE__*/ $5E6i4.createElement("div", {
        key: key,
        "data-node-key": (0, $ef63254ed4c073de$export$c55417729a96230c)(key),
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(tabPrefix, tabNodeClassNames?.item, {
            [`${tabPrefix}-with-remove`]: removable,
            [`${tabPrefix}-active`]: active,
            [`${tabPrefix}-disabled`]: disabled,
            [`${tabPrefix}-focus`]: focus
        }),
        style: styles?.item,
        onClick: onInternalClick
    }, /*#__PURE__*/ $5E6i4.createElement("div", {
        ref: btnRef,
        role: "tab",
        "aria-selected": active,
        id: id && `${id}-tab-${key}`,
        className: `${tabPrefix}-btn`,
        "aria-controls": id && `${id}-panel-${key}`,
        "aria-disabled": disabled,
        tabIndex: disabled ? null : active ? 0 : -1,
        onClick: (e)=>{
            e.stopPropagation();
            onInternalClick(e);
        },
        onKeyDown: onKeyDown,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onFocus: onFocus,
        onBlur: onBlur
    }, focus && /*#__PURE__*/ $5E6i4.createElement("div", {
        "aria-live": "polite",
        style: {
            width: 0,
            height: 0,
            position: 'absolute',
            overflow: 'hidden',
            opacity: 0
        }
    }, `Tab ${currentPosition} of ${tabCount}`), icon && /*#__PURE__*/ $5E6i4.createElement("span", {
        className: `${tabPrefix}-icon`
    }, icon), label && labelNode), removable && /*#__PURE__*/ $5E6i4.createElement("button", {
        type: "button",
        "aria-label": removeAriaLabel || 'remove',
        tabIndex: active ? 0 : -1,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${tabPrefix}-remove`, tabNodeClassNames?.remove),
        style: styles?.remove,
        onClick: (e)=>{
            e.stopPropagation();
            onRemoveTab(e);
        }
    }, closeIcon || editable.removeIcon || "\xd7"));
    return renderWrapper ? renderWrapper(node) : node;
};
var $e98b95980e2ab827$export$2e2bcd8739ae039 = $e98b95980e2ab827$var$TabNode;


function $01584ad900cfaeea$var$_extends() {
    $01584ad900cfaeea$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $01584ad900cfaeea$var$_extends.apply(this, arguments);
}
const $01584ad900cfaeea$var$getTabSize = (tab, containerRect)=>{
    // tabListRef
    const { offsetWidth: offsetWidth, offsetHeight: offsetHeight, offsetTop: offsetTop, offsetLeft: offsetLeft } = tab;
    const { width: width, height: height, left: left, top: top } = tab.getBoundingClientRect();
    // Use getBoundingClientRect to avoid decimal inaccuracy
    if (Math.abs(width - offsetWidth) < 1) return [
        width,
        height,
        left - containerRect.left,
        top - containerRect.top
    ];
    return [
        offsetWidth,
        offsetHeight,
        offsetLeft,
        offsetTop
    ];
};
const $01584ad900cfaeea$var$getSize = (refObj)=>{
    const { offsetWidth: offsetWidth = 0, offsetHeight: offsetHeight = 0 } = refObj.current || {};
    // Use getBoundingClientRect to avoid decimal inaccuracy
    if (refObj.current) {
        const { width: width, height: height } = refObj.current.getBoundingClientRect();
        if (Math.abs(width - offsetWidth) < 1) return [
            width,
            height
        ];
    }
    return [
        offsetWidth,
        offsetHeight
    ];
};
/**
 * Convert `SizeInfo` to unit value. Such as [123, 456] with `top` position get `123`
 */ const $01584ad900cfaeea$var$getUnitValue = (size, tabPositionTopOrBottom)=>{
    return size[tabPositionTopOrBottom ? 0 : 1];
};
const $01584ad900cfaeea$var$TabNavList = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { className: className, style: style, id: id, animated: animated, activeKey: activeKey, rtl: rtl, extra: extra, editable: editable, locale: locale, tabPosition: tabPosition, tabBarGutter: tabBarGutter, children: children, onTabClick: onTabClick, onTabScroll: onTabScroll, indicator: indicator, classNames: tabsClassNames, styles: styles } = props;
    const { prefixCls: prefixCls, tabs: tabs } = $5E6i4.useContext((0, $e78195c86f2d256b$export$2e2bcd8739ae039));
    const containerRef = (0, $5E6i4.useRef)(null);
    const extraLeftRef = (0, $5E6i4.useRef)(null);
    const extraRightRef = (0, $5E6i4.useRef)(null);
    const tabsWrapperRef = (0, $5E6i4.useRef)(null);
    const tabListRef = (0, $5E6i4.useRef)(null);
    const operationsRef = (0, $5E6i4.useRef)(null);
    const innerAddButtonRef = (0, $5E6i4.useRef)(null);
    const tabPositionTopOrBottom = tabPosition === 'top' || tabPosition === 'bottom';
    const [transformLeft, setTransformLeft] = (0, $281a048496b8859f$export$2e2bcd8739ae039)(0, (next, prev)=>{
        if (tabPositionTopOrBottom && onTabScroll) onTabScroll({
            direction: next > prev ? 'left' : 'right'
        });
    });
    const [transformTop, setTransformTop] = (0, $281a048496b8859f$export$2e2bcd8739ae039)(0, (next, prev)=>{
        if (!tabPositionTopOrBottom && onTabScroll) onTabScroll({
            direction: next > prev ? 'top' : 'bottom'
        });
    });
    const [containerExcludeExtraSize, setContainerExcludeExtraSize] = (0, $5E6i4.useState)([
        0,
        0
    ]);
    const [tabContentSize, setTabContentSize] = (0, $5E6i4.useState)([
        0,
        0
    ]);
    const [addSize, setAddSize] = (0, $5E6i4.useState)([
        0,
        0
    ]);
    const [operationSize, setOperationSize] = (0, $5E6i4.useState)([
        0,
        0
    ]);
    const [tabSizes, setTabSizes] = (0, $ad7aec859c5acf5c$export$aefd2a30eb6d999e)(new Map());
    const tabOffsets = (0, $7b9c03f9a0d6c2aa$export$2e2bcd8739ae039)(tabs, tabSizes, tabContentSize[0]);
    // ========================== Unit =========================
    const containerExcludeExtraSizeValue = $01584ad900cfaeea$var$getUnitValue(containerExcludeExtraSize, tabPositionTopOrBottom);
    const tabContentSizeValue = $01584ad900cfaeea$var$getUnitValue(tabContentSize, tabPositionTopOrBottom);
    const addSizeValue = $01584ad900cfaeea$var$getUnitValue(addSize, tabPositionTopOrBottom);
    const operationSizeValue = $01584ad900cfaeea$var$getUnitValue(operationSize, tabPositionTopOrBottom);
    const needScroll = Math.floor(containerExcludeExtraSizeValue) < Math.floor(tabContentSizeValue + addSizeValue);
    const visibleTabContentValue = needScroll ? containerExcludeExtraSizeValue - operationSizeValue : containerExcludeExtraSizeValue - addSizeValue;
    // ========================== Util =========================
    const operationsHiddenClassName = `${prefixCls}-nav-operations-hidden`;
    let transformMin = 0;
    let transformMax = 0;
    if (!tabPositionTopOrBottom) {
        transformMin = Math.min(0, visibleTabContentValue - tabContentSizeValue);
        transformMax = 0;
    } else if (rtl) {
        transformMin = 0;
        transformMax = Math.max(0, tabContentSizeValue - visibleTabContentValue);
    } else {
        transformMin = Math.min(0, visibleTabContentValue - tabContentSizeValue);
        transformMax = 0;
    }
    function alignInRange(value) {
        if (value < transformMin) return transformMin;
        if (value > transformMax) return transformMax;
        return value;
    }
    // ========================= Mobile ========================
    const touchMovingRef = (0, $5E6i4.useRef)(null);
    const [lockAnimation, setLockAnimation] = (0, $5E6i4.useState)();
    function doLockAnimation() {
        setLockAnimation(Date.now());
    }
    function clearTouchMoving() {
        if (touchMovingRef.current) clearTimeout(touchMovingRef.current);
    }
    (0, $df3a36b81cc0419f$export$2e2bcd8739ae039)(tabsWrapperRef, (offsetX, offsetY)=>{
        function doMove(setState, offset) {
            setState((value)=>{
                const newValue = alignInRange(value + offset);
                return newValue;
            });
        }
        // Skip scroll if place is enough
        if (!needScroll) return false;
        if (tabPositionTopOrBottom) doMove(setTransformLeft, offsetX);
        else doMove(setTransformTop, offsetY);
        clearTouchMoving();
        doLockAnimation();
        return true;
    });
    (0, $5E6i4.useEffect)(()=>{
        clearTouchMoving();
        if (lockAnimation) touchMovingRef.current = setTimeout(()=>{
            setLockAnimation(0);
        }, 100);
        return clearTouchMoving;
    }, [
        lockAnimation
    ]);
    // ===================== Visible Range =====================
    // Render tab node & collect tab offset
    const [visibleStart, visibleEnd] = (0, $6c61c3d3570143a2$export$2e2bcd8739ae039)(tabOffsets, // Container
    visibleTabContentValue, // Transform
    tabPositionTopOrBottom ? transformLeft : transformTop, // Tabs
    tabContentSizeValue, // Add
    addSizeValue, // Operation
    operationSizeValue, {
        ...props,
        tabs: tabs
    });
    // ========================= Scroll ========================
    const scrollToTab = (0, $68990f4402d2f009$export$2e2bcd8739ae039)((key = activeKey)=>{
        const tabOffset = tabOffsets.get(key) || {
            width: 0,
            height: 0,
            left: 0,
            right: 0,
            top: 0
        };
        if (tabPositionTopOrBottom) {
            // ============ Align with top & bottom ============
            let newTransform = transformLeft;
            // RTL
            if (rtl) {
                if (tabOffset.right < transformLeft) newTransform = tabOffset.right;
                else if (tabOffset.right + tabOffset.width > transformLeft + visibleTabContentValue) newTransform = tabOffset.right + tabOffset.width - visibleTabContentValue;
            } else if (tabOffset.left < -transformLeft) newTransform = -tabOffset.left;
            else if (tabOffset.left + tabOffset.width > -transformLeft + visibleTabContentValue) newTransform = -(tabOffset.left + tabOffset.width - visibleTabContentValue);
            setTransformTop(0);
            setTransformLeft(alignInRange(newTransform));
        } else {
            // ============ Align with left & right ============
            let newTransform = transformTop;
            if (tabOffset.top < -transformTop) newTransform = -tabOffset.top;
            else if (tabOffset.top + tabOffset.height > -transformTop + visibleTabContentValue) newTransform = -(tabOffset.top + tabOffset.height - visibleTabContentValue);
            setTransformLeft(0);
            setTransformTop(alignInRange(newTransform));
        }
    });
    // ========================= Focus =========================
    const [focusKey, setFocusKey] = (0, $5E6i4.useState)();
    const [isMouse, setIsMouse] = (0, $5E6i4.useState)(false);
    const enabledTabs = tabs.filter((tab)=>!tab.disabled).map((tab)=>tab.key);
    const onOffset = (offset)=>{
        const currentIndex = enabledTabs.indexOf(focusKey || activeKey);
        const len = enabledTabs.length;
        const nextIndex = (currentIndex + offset + len) % len;
        const newKey = enabledTabs[nextIndex];
        setFocusKey(newKey);
    };
    const handleRemoveTab = (removalTabKey, e)=>{
        const removeIndex = enabledTabs.indexOf(removalTabKey);
        const removeTab = tabs.find((tab)=>tab.key === removalTabKey);
        const removable = (0, $ef63254ed4c073de$export$eab31ca11b8b073)(removeTab?.closable, removeTab?.closeIcon, editable, removeTab?.disabled);
        if (removable) {
            e.preventDefault();
            e.stopPropagation();
            editable.onEdit('remove', {
                key: removalTabKey,
                event: e
            });
            // when remove last tab, focus previous tab
            if (removeIndex === enabledTabs.length - 1) onOffset(-1);
            else onOffset(1);
        }
    };
    const handleMouseDown = (key, e)=>{
        setIsMouse(true);
        // Middle mouse button
        if (e.button === 1) handleRemoveTab(key, e);
    };
    const handleKeyDown = (e)=>{
        const { code: code } = e;
        const isRTL = rtl && tabPositionTopOrBottom;
        const firstEnabledTab = enabledTabs[0];
        const lastEnabledTab = enabledTabs[enabledTabs.length - 1];
        switch(code){
            // LEFT
            case 'ArrowLeft':
                if (tabPositionTopOrBottom) onOffset(isRTL ? 1 : -1);
                break;
            // RIGHT
            case 'ArrowRight':
                if (tabPositionTopOrBottom) onOffset(isRTL ? -1 : 1);
                break;
            // UP
            case 'ArrowUp':
                e.preventDefault();
                if (!tabPositionTopOrBottom) onOffset(-1);
                break;
            // DOWN
            case 'ArrowDown':
                e.preventDefault();
                if (!tabPositionTopOrBottom) onOffset(1);
                break;
            // HOME
            case 'Home':
                e.preventDefault();
                setFocusKey(firstEnabledTab);
                break;
            // END
            case 'End':
                e.preventDefault();
                setFocusKey(lastEnabledTab);
                break;
            // Enter & Space
            case 'Enter':
            case 'Space':
                e.preventDefault();
                onTabClick(focusKey ?? activeKey, e);
                break;
            // Backspace
            case 'Backspace':
            case 'Delete':
                handleRemoveTab(focusKey, e);
                break;
        }
    };
    // ========================== Tab ==========================
    const tabNodeStyle = {};
    if (tabPositionTopOrBottom) tabNodeStyle.marginInlineStart = tabBarGutter;
    else tabNodeStyle.marginTop = tabBarGutter;
    const tabNodes = tabs.map((tab, i)=>{
        const { key: key } = tab;
        return /*#__PURE__*/ $5E6i4.createElement((0, $e98b95980e2ab827$export$2e2bcd8739ae039), {
            id: id,
            prefixCls: prefixCls,
            key: key,
            tab: tab,
            classNames: {
                item: tabsClassNames?.item,
                remove: tabsClassNames?.remove
            },
            styles: {
                /* first node should not have margin left */ item: i === 0 ? styles?.item : {
                    ...tabNodeStyle,
                    ...styles?.item
                },
                remove: styles?.remove
            },
            closable: tab.closable,
            editable: editable,
            active: key === activeKey,
            focus: key === focusKey,
            renderWrapper: children,
            removeAriaLabel: locale?.removeAriaLabel,
            tabCount: enabledTabs.length,
            currentPosition: i + 1,
            onClick: (e)=>{
                onTabClick(key, e);
            },
            onKeyDown: handleKeyDown,
            onFocus: ()=>{
                if (!isMouse) setFocusKey(key);
                scrollToTab(key);
                doLockAnimation();
                if (!tabsWrapperRef.current) return;
                // Focus element will make scrollLeft change which we should reset back
                if (!rtl) tabsWrapperRef.current.scrollLeft = 0;
                tabsWrapperRef.current.scrollTop = 0;
            },
            onBlur: ()=>{
                setFocusKey(undefined);
            },
            onMouseDown: (e)=>handleMouseDown(key, e),
            onMouseUp: ()=>{
                setIsMouse(false);
            }
        });
    });
    // Update buttons records
    const updateTabSizes = ()=>setTabSizes(()=>{
            const newSizes = new Map();
            const listRect = tabListRef.current?.getBoundingClientRect();
            tabs.forEach(({ key: key })=>{
                const btnNode = tabListRef.current?.querySelector(`[data-node-key="${(0, $ef63254ed4c073de$export$c55417729a96230c)(key)}"]`);
                if (btnNode) {
                    const [width, height, left, top] = $01584ad900cfaeea$var$getTabSize(btnNode, listRect);
                    newSizes.set(key, {
                        width: width,
                        height: height,
                        left: left,
                        top: top
                    });
                }
            });
            return newSizes;
        });
    (0, $5E6i4.useEffect)(()=>{
        updateTabSizes();
    }, [
        tabs.map((tab)=>tab.key).join('_')
    ]);
    const onListHolderResize = (0, $ad7aec859c5acf5c$export$2e2bcd8739ae039)(()=>{
        // Update wrapper records
        const containerSize = $01584ad900cfaeea$var$getSize(containerRef);
        const extraLeftSize = $01584ad900cfaeea$var$getSize(extraLeftRef);
        const extraRightSize = $01584ad900cfaeea$var$getSize(extraRightRef);
        setContainerExcludeExtraSize([
            containerSize[0] - extraLeftSize[0] - extraRightSize[0],
            containerSize[1] - extraLeftSize[1] - extraRightSize[1]
        ]);
        const newAddSize = $01584ad900cfaeea$var$getSize(innerAddButtonRef);
        setAddSize(newAddSize);
        const newOperationSize = $01584ad900cfaeea$var$getSize(operationsRef);
        setOperationSize(newOperationSize);
        // Which includes add button size
        const tabContentFullSize = $01584ad900cfaeea$var$getSize(tabListRef);
        setTabContentSize([
            tabContentFullSize[0] - newAddSize[0],
            tabContentFullSize[1] - newAddSize[1]
        ]);
        // Update buttons records
        updateTabSizes();
    });
    // ======================== Dropdown =======================
    const startHiddenTabs = tabs.slice(0, visibleStart);
    const endHiddenTabs = tabs.slice(visibleEnd + 1);
    const hiddenTabs = [
        ...startHiddenTabs,
        ...endHiddenTabs
    ];
    // =================== Link & Operations ===================
    const activeTabOffset = tabOffsets.get(activeKey);
    const { style: indicatorStyle } = (0, $8f178612625aafaf$export$2e2bcd8739ae039)({
        activeTabOffset: activeTabOffset,
        horizontal: tabPositionTopOrBottom,
        indicator: indicator,
        rtl: rtl
    });
    // ========================= Effect ========================
    (0, $5E6i4.useEffect)(()=>{
        scrollToTab();
    }, [
        activeKey,
        transformMin,
        transformMax,
        (0, $ef63254ed4c073de$export$fac44ee5b035f737)(activeTabOffset),
        (0, $ef63254ed4c073de$export$fac44ee5b035f737)(tabOffsets),
        tabPositionTopOrBottom
    ]);
    // Should recalculate when rtl changed
    (0, $5E6i4.useEffect)(()=>{
        onListHolderResize();
    // eslint-disable-next-line
    }, [
        rtl
    ]);
    // ========================= Render ========================
    const hasDropdown = !!hiddenTabs.length;
    const wrapPrefix = `${prefixCls}-nav-wrap`;
    let pingLeft;
    let pingRight;
    let pingTop;
    let pingBottom;
    if (tabPositionTopOrBottom) {
        if (rtl) {
            pingRight = transformLeft > 0;
            pingLeft = transformLeft !== transformMax;
        } else {
            pingLeft = transformLeft < 0;
            pingRight = transformLeft !== transformMin;
        }
    } else {
        pingTop = transformTop < 0;
        pingBottom = transformTop !== transformMin;
    }
    return /*#__PURE__*/ $5E6i4.createElement((0, $3a396118caae8741$export$2e2bcd8739ae039), {
        onResize: onListHolderResize
    }, /*#__PURE__*/ $5E6i4.createElement("div", {
        ref: (0, $92c8c75386168ffc$export$1d1c999670a1285d)(ref, containerRef),
        role: "tablist",
        "aria-orientation": tabPositionTopOrBottom ? 'horizontal' : 'vertical',
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-nav`, className, tabsClassNames?.header),
        style: {
            ...styles?.header,
            ...style
        },
        onKeyDown: ()=>{
            // No need animation when use keyboard
            doLockAnimation();
        }
    }, /*#__PURE__*/ $5E6i4.createElement((0, $22294141c0194179$export$2e2bcd8739ae039), {
        ref: extraLeftRef,
        position: "left",
        extra: extra,
        prefixCls: prefixCls
    }), /*#__PURE__*/ $5E6i4.createElement((0, $3a396118caae8741$export$2e2bcd8739ae039), {
        onResize: onListHolderResize
    }, /*#__PURE__*/ $5E6i4.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(wrapPrefix, {
            [`${wrapPrefix}-ping-left`]: pingLeft,
            [`${wrapPrefix}-ping-right`]: pingRight,
            [`${wrapPrefix}-ping-top`]: pingTop,
            [`${wrapPrefix}-ping-bottom`]: pingBottom
        }),
        ref: tabsWrapperRef
    }, /*#__PURE__*/ $5E6i4.createElement((0, $3a396118caae8741$export$2e2bcd8739ae039), {
        onResize: onListHolderResize
    }, /*#__PURE__*/ $5E6i4.createElement("div", {
        ref: tabListRef,
        className: `${prefixCls}-nav-list`,
        style: {
            transform: `translate(${transformLeft}px, ${transformTop}px)`,
            transition: lockAnimation ? 'none' : undefined
        }
    }, tabNodes, /*#__PURE__*/ $5E6i4.createElement((0, $53f39a909c012fcc$export$2e2bcd8739ae039), {
        ref: innerAddButtonRef,
        prefixCls: prefixCls,
        locale: locale,
        editable: editable,
        style: {
            ...tabNodes.length === 0 ? undefined : tabNodeStyle,
            visibility: hasDropdown ? 'hidden' : null
        }
    }), /*#__PURE__*/ $5E6i4.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-ink-bar`, tabsClassNames?.indicator, {
            [`${prefixCls}-ink-bar-animated`]: animated.inkBar
        }),
        style: {
            ...indicatorStyle,
            ...styles?.indicator
        }
    }))))), /*#__PURE__*/ $5E6i4.createElement((0, $f0406f1607e76583$export$2e2bcd8739ae039), $01584ad900cfaeea$var$_extends({}, props, {
        removeAriaLabel: locale?.removeAriaLabel,
        ref: operationsRef,
        prefixCls: prefixCls,
        tabs: hiddenTabs,
        className: !hasDropdown && operationsHiddenClassName,
        popupStyle: styles?.popup,
        tabMoving: !!lockAnimation
    })), /*#__PURE__*/ $5E6i4.createElement((0, $22294141c0194179$export$2e2bcd8739ae039), {
        ref: extraRightRef,
        position: "right",
        extra: extra,
        prefixCls: prefixCls
    })));
/* eslint-enable */ });
var $01584ad900cfaeea$export$2e2bcd8739ae039 = $01584ad900cfaeea$var$TabNavList;


// We have to create a TabNavList components.
const $8fd8e030ec6a63bc$var$TabNavListWrapper = ({ renderTabBar: renderTabBar, ...restProps })=>{
    if (renderTabBar) return renderTabBar(restProps, (0, $01584ad900cfaeea$export$2e2bcd8739ae039));
    return /*#__PURE__*/ $5E6i4.createElement((0, $01584ad900cfaeea$export$2e2bcd8739ae039), restProps);
};
var $8fd8e030ec6a63bc$export$2e2bcd8739ae039 = $8fd8e030ec6a63bc$var$TabNavListWrapper;





var $5E6i4 = parcelRequire("5E6i4");



var $5E6i4 = parcelRequire("5E6i4");
const $7d79c7c0d2439cca$var$TabPane = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, className: className, style: style, id: id, active: active, tabKey: tabKey, children: children } = props;
    const hasContent = $5E6i4.Children.count(children) > 0;
    return /*#__PURE__*/ $5E6i4.createElement("div", {
        id: id && `${id}-panel-${tabKey}`,
        role: "tabpanel",
        tabIndex: active && hasContent ? 0 : -1,
        "aria-labelledby": id && `${id}-tab-${tabKey}`,
        "aria-hidden": !active,
        style: style,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, active && `${prefixCls}-active`, className),
        ref: ref
    }, children);
});
var $7d79c7c0d2439cca$export$2e2bcd8739ae039 = $7d79c7c0d2439cca$var$TabPane;


function $60fb82252450399d$var$_extends() {
    $60fb82252450399d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $60fb82252450399d$var$_extends.apply(this, arguments);
}
const $60fb82252450399d$var$TabPanelList = (props)=>{
    const { id: id, activeKey: activeKey, animated: animated, tabPosition: tabPosition, destroyOnHidden: destroyOnHidden, bodyStyle: bodyStyle, bodyClassName: bodyClassName, contentStyle: contentStyle, contentClassName: contentClassName } = props;
    const { prefixCls: prefixCls, tabs: tabs } = $5E6i4.useContext((0, $e78195c86f2d256b$export$2e2bcd8739ae039));
    const tabPaneAnimated = animated.tabPane;
    const bodyPrefixCls = `${prefixCls}-body`;
    const contentPrefixCls = `${prefixCls}-content`;
    return /*#__PURE__*/ $5E6i4.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${bodyPrefixCls}-holder`)
    }, /*#__PURE__*/ $5E6i4.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(bodyPrefixCls, `${bodyPrefixCls}-${tabPosition}`, {
            [`${bodyPrefixCls}-animated`]: tabPaneAnimated
        }, bodyClassName),
        style: bodyStyle
    }, tabs.map((item)=>{
        const { key: key, forceRender: forceRender, style: paneStyle, className: paneClassName, destroyOnHidden: itemDestroyOnHidden, ...restTabProps } = item;
        const active = key === activeKey;
        return /*#__PURE__*/ $5E6i4.createElement((0, $5371a8954d0d2416$export$2e2bcd8739ae039), $60fb82252450399d$var$_extends({
            key: key,
            visible: active,
            forceRender: forceRender,
            removeOnLeave: !!(destroyOnHidden ?? itemDestroyOnHidden),
            leavedClassName: `${contentPrefixCls}-hidden`
        }, animated.tabPaneMotion), ({ style: motionStyle, className: motionClassName }, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $7d79c7c0d2439cca$export$2e2bcd8739ae039), $60fb82252450399d$var$_extends({}, restTabProps, {
                prefixCls: contentPrefixCls,
                id: id,
                tabKey: key,
                animated: tabPaneAnimated,
                active: active,
                style: {
                    ...contentStyle,
                    ...paneStyle,
                    ...motionStyle
                },
                className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(contentClassName, paneClassName, motionClassName),
                ref: ref
            })));
    })));
};
var $60fb82252450399d$export$2e2bcd8739ae039 = $60fb82252450399d$var$TabPanelList;



function $c8e8b88361e842b1$export$2e2bcd8739ae039(animated = {
    inkBar: true,
    tabPane: false
}) {
    let mergedAnimated;
    if (animated === false) mergedAnimated = {
        inkBar: false,
        tabPane: false
    };
    else if (animated === true) mergedAnimated = {
        inkBar: true,
        tabPane: false
    };
    else mergedAnimated = {
        inkBar: true,
        ...typeof animated === 'object' ? animated : {}
    };
    // Enable tabPane animation if provide motion
    if (mergedAnimated.tabPaneMotion && mergedAnimated.tabPane === undefined) mergedAnimated.tabPane = true;
    if (!mergedAnimated.tabPaneMotion && mergedAnimated.tabPane) mergedAnimated.tabPane = false;
    return mergedAnimated;
}


function $01b81e05a919b5d2$var$_extends() {
    $01b81e05a919b5d2$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $01b81e05a919b5d2$var$_extends.apply(this, arguments);
}
/**
 * Should added antd:
 * - type
 *
 * Removed:
 * - onNextClick
 * - onPrevClick
 * - keyboard
 */ // Used for accessibility
let $01b81e05a919b5d2$var$uuid = 0;
const $01b81e05a919b5d2$var$Tabs = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { id: id, prefixCls: prefixCls = 'rc-tabs', className: className, items: items, direction: direction, activeKey: activeKey, defaultActiveKey: defaultActiveKey, editable: editable, animated: animated, tabPosition: tabPosition = 'top', tabBarGutter: tabBarGutter, tabBarStyle: tabBarStyle, tabBarExtraContent: tabBarExtraContent, locale: locale, more: more, destroyOnHidden: destroyOnHidden, renderTabBar: renderTabBar, onChange: onChange, onTabClick: onTabClick, onTabScroll: onTabScroll, getPopupContainer: getPopupContainer, popupClassName: popupClassName, indicator: indicator, classNames: tabsClassNames, styles: styles, ...restProps } = props;
    const tabs = $5E6i4.useMemo(()=>(items || []).filter((item)=>item && typeof item === 'object' && 'key' in item), [
        items
    ]);
    const rtl = direction === 'rtl';
    const mergedAnimated = (0, $c8e8b88361e842b1$export$2e2bcd8739ae039)(animated);
    // ======================== Mobile ========================
    const [mobile, setMobile] = (0, $5E6i4.useState)(false);
    (0, $5E6i4.useEffect)(()=>{
        // Only update on the client side
        setMobile((0, $55735df4f86352cc$export$2e2bcd8739ae039)());
    }, []);
    // ====================== Active Key ======================
    const [mergedActiveKey, setMergedActiveKey] = (0, $e18df22f16a16360$export$2e2bcd8739ae039)(defaultActiveKey ?? tabs[0]?.key, activeKey);
    const [activeIndex, setActiveIndex] = (0, $5E6i4.useState)(()=>tabs.findIndex((tab)=>tab.key === mergedActiveKey));
    // Reset active key if not exist anymore
    (0, $5E6i4.useEffect)(()=>{
        let newActiveIndex = tabs.findIndex((tab)=>tab.key === mergedActiveKey);
        if (newActiveIndex === -1) {
            newActiveIndex = Math.max(0, Math.min(activeIndex, tabs.length - 1));
            setMergedActiveKey(tabs[newActiveIndex]?.key);
        }
        setActiveIndex(newActiveIndex);
    }, [
        tabs.map((tab)=>tab.key).join('_'),
        mergedActiveKey,
        activeIndex
    ]);
    // ===================== Accessibility ====================
    const [mergedId, setMergedId] = (0, $e18df22f16a16360$export$2e2bcd8739ae039)(null, id);
    // Async generate id to avoid ssr mapping failed
    (0, $5E6i4.useEffect)(()=>{
        if (!id) {
            setMergedId(`rc-tabs-${$01b81e05a919b5d2$var$uuid}`);
            $01b81e05a919b5d2$var$uuid += 1;
        }
    }, []);
    // ======================== Events ========================
    function onInternalTabClick(key, e) {
        onTabClick?.(key, e);
        const isActiveChanged = key !== mergedActiveKey;
        setMergedActiveKey(key);
        if (isActiveChanged) onChange?.(key);
    }
    // ======================== Render ========================
    const sharedProps = {
        id: mergedId,
        activeKey: mergedActiveKey,
        animated: mergedAnimated,
        tabPosition: tabPosition,
        rtl: rtl,
        mobile: mobile
    };
    const tabNavBarProps = {
        ...sharedProps,
        editable: editable,
        locale: locale,
        more: more,
        tabBarGutter: tabBarGutter,
        onTabClick: onInternalTabClick,
        onTabScroll: onTabScroll,
        extra: tabBarExtraContent,
        style: tabBarStyle,
        getPopupContainer: getPopupContainer,
        popupClassName: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(popupClassName, tabsClassNames?.popup),
        indicator: indicator,
        styles: styles,
        classNames: tabsClassNames
    };
    const memoizedValue = $5E6i4.useMemo(()=>{
        return {
            tabs: tabs,
            prefixCls: prefixCls
        };
    }, [
        tabs,
        prefixCls
    ]);
    return /*#__PURE__*/ $5E6i4.createElement((0, $e78195c86f2d256b$export$2e2bcd8739ae039).Provider, {
        value: memoizedValue
    }, /*#__PURE__*/ $5E6i4.createElement("div", $01b81e05a919b5d2$var$_extends({
        ref: ref,
        id: id,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-${tabPosition}`, {
            [`${prefixCls}-mobile`]: mobile,
            [`${prefixCls}-editable`]: editable,
            [`${prefixCls}-rtl`]: rtl
        }, className)
    }, restProps), /*#__PURE__*/ $5E6i4.createElement((0, $8fd8e030ec6a63bc$export$2e2bcd8739ae039), $01b81e05a919b5d2$var$_extends({}, tabNavBarProps, {
        renderTabBar: renderTabBar
    })), /*#__PURE__*/ $5E6i4.createElement((0, $60fb82252450399d$export$2e2bcd8739ae039), $01b81e05a919b5d2$var$_extends({
        destroyOnHidden: destroyOnHidden
    }, sharedProps, {
        bodyStyle: styles?.body,
        bodyClassName: tabsClassNames?.body,
        contentStyle: styles?.content,
        contentClassName: tabsClassNames?.content,
        animated: mergedAnimated
    }))));
});
var $01b81e05a919b5d2$export$2e2bcd8739ae039 = $01b81e05a919b5d2$var$Tabs;


var $f90c6223288e536c$export$2e2bcd8739ae039 = (0, $01b81e05a919b5d2$export$2e2bcd8739ae039);











const $326ab66b0be31370$var$motion = {
    motionAppear: false,
    motionEnter: true,
    motionLeave: true
};
function $326ab66b0be31370$export$2e2bcd8739ae039(prefixCls, animated = {
    inkBar: true,
    tabPane: false
}) {
    let mergedAnimated;
    if (animated === false) mergedAnimated = {
        inkBar: false,
        tabPane: false
    };
    else if (animated === true) mergedAnimated = {
        inkBar: true,
        tabPane: true
    };
    else mergedAnimated = {
        inkBar: true,
        ...(0, $addbc2fddcbb77a9$export$53b83ca8eaab0383)(animated) ? animated : {}
    };
    if (mergedAnimated.tabPane) mergedAnimated.tabPaneMotion = {
        ...$326ab66b0be31370$var$motion,
        motionName: (0, $c2c363b881b49d51$export$27c72201b1d09951)(prefixCls, 'switch')
    };
    return mergedAnimated;
}



var $5E6i4 = parcelRequire("5E6i4");


function $203e54ec80556eb3$var$filter(items) {
    return items.filter((item)=>item);
}
function $203e54ec80556eb3$var$useLegacyItems(items, children) {
    if (items) return items.map((item)=>({
            ...item,
            destroyOnHidden: item.destroyOnHidden ?? item.destroyInactiveTabPane
        }));
    const childrenItems = (0, $2ec1a2166f2295ea$export$2e2bcd8739ae039)(children).map((node)=>{
        if (/*#__PURE__*/ $5E6i4.isValidElement(node)) {
            const { key: key, props: props } = node;
            const { tab: tab, ...restProps } = props || {};
            const item = {
                key: String(key),
                ...restProps,
                label: tab
            };
            return item;
        }
        return null;
    });
    return $203e54ec80556eb3$var$filter(childrenItems);
}
var $203e54ec80556eb3$export$2e2bcd8739ae039 = $203e54ec80556eb3$var$useLegacyItems;







const $0f539d877fccd977$var$genMotionStyle = (token)=>{
    const { componentCls: componentCls, motionDurationSlow: motionDurationSlow } = token;
    return [
        {
            [componentCls]: {
                [`${componentCls}-switch`]: {
                    '&-appear, &-enter': {
                        transition: 'none',
                        '&-start': {
                            opacity: 0
                        },
                        '&-active': {
                            opacity: 1,
                            transition: `opacity ${motionDurationSlow}`
                        }
                    },
                    '&-leave': {
                        position: 'absolute',
                        transition: 'none',
                        inset: 0,
                        '&-start': {
                            opacity: 1
                        },
                        '&-active': {
                            opacity: 0,
                            transition: `opacity ${motionDurationSlow}`
                        }
                    }
                }
            }
        },
        // Follow code may reuse in other components
        [
            (0, $8c07f7e527e50277$export$9018e60daecf7a6c)(token, 'slide-up'),
            (0, $8c07f7e527e50277$export$9018e60daecf7a6c)(token, 'slide-down')
        ]
    ];
};
var $0f539d877fccd977$export$2e2bcd8739ae039 = $0f539d877fccd977$var$genMotionStyle;


const $e942c7afef44b507$var$genCardStyle = (token)=>{
    const { componentCls: componentCls, tabsCardPadding: tabsCardPadding, cardBg: cardBg, cardGutter: cardGutter, colorBorderSecondary: colorBorderSecondary, itemSelectedColor: itemSelectedColor } = token;
    return {
        [`${componentCls}-card`]: {
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                [`${componentCls}-tab`]: {
                    margin: 0,
                    padding: tabsCardPadding,
                    background: cardBg,
                    border: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${colorBorderSecondary}`,
                    transition: `all ${token.motionDurationSlow} ${token.motionEaseInOut}`
                },
                [`${componentCls}-tab-active`]: {
                    color: itemSelectedColor,
                    background: token.colorBgContainer
                },
                [`${componentCls}-tab-focus:has(${componentCls}-tab-btn:focus-visible)`]: (0, $cd5a520fee8002b4$export$6539948f0a737e39)(token, -3),
                [`& ${componentCls}-tab${componentCls}-tab-focus ${componentCls}-tab-btn:focus-visible`]: {
                    outline: 'none'
                },
                [`${componentCls}-ink-bar`]: {
                    visibility: 'hidden'
                }
            },
            // ========================== Top & Bottom ==========================
            [`&${componentCls}-top, &${componentCls}-bottom`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab + ${componentCls}-tab`]: {
                        marginLeft: {
                            _skip_check_: true,
                            value: (0, $56bae8a99c3cba6e$export$523c0b569236b342)(cardGutter)
                        }
                    }
                }
            },
            [`&${componentCls}-top`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        borderRadius: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.borderRadiusLG)} 0 0`
                    },
                    [`${componentCls}-tab-active`]: {
                        borderBottomColor: token.colorBgContainer
                    }
                }
            },
            [`&${componentCls}-bottom`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        borderRadius: `0 0 ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.borderRadiusLG)}`
                    },
                    [`${componentCls}-tab-active`]: {
                        borderTopColor: token.colorBgContainer
                    }
                }
            },
            // ========================== Left & Right ==========================
            [`&${componentCls}-left, &${componentCls}-right`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab + ${componentCls}-tab`]: {
                        marginTop: (0, $56bae8a99c3cba6e$export$523c0b569236b342)(cardGutter)
                    }
                }
            },
            [`&${componentCls}-left`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        borderRadius: {
                            _skip_check_: true,
                            value: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.borderRadiusLG)} 0 0 ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.borderRadiusLG)}`
                        }
                    },
                    [`${componentCls}-tab-active`]: {
                        borderRightColor: {
                            _skip_check_: true,
                            value: token.colorBgContainer
                        }
                    }
                }
            },
            [`&${componentCls}-right`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        borderRadius: {
                            _skip_check_: true,
                            value: `0 ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.borderRadiusLG)} 0`
                        }
                    },
                    [`${componentCls}-tab-active`]: {
                        borderLeftColor: {
                            _skip_check_: true,
                            value: token.colorBgContainer
                        }
                    }
                }
            }
        }
    };
};
const $e942c7afef44b507$var$genDropdownStyle = (token)=>{
    const { antCls: antCls, componentCls: componentCls, itemHoverColor: itemHoverColor, dropdownEdgeChildVerticalPadding: dropdownEdgeChildVerticalPadding } = token;
    return {
        [`${componentCls}-dropdown`]: {
            ...(0, $cd5a520fee8002b4$export$23997c3e44cc1c59)(token),
            position: 'absolute',
            top: -9999,
            left: {
                _skip_check_: true,
                value: -9999
            },
            zIndex: token.zIndexPopup,
            display: 'block',
            '&-hidden': {
                display: 'none'
            },
            // When position is not enough for tabs dropdown, the placement will revert.
            // We will handle this with revert motion name.
            [`&${antCls}-slide-down-enter${antCls}-slide-down-enter-active${componentCls}-dropdown-placement-bottomLeft,
        &${antCls}-slide-down-appear${antCls}-slide-down-appear-active${componentCls}-dropdown-placement-bottomLeft,
        &${antCls}-slide-down-enter${antCls}-slide-down-enter-active${componentCls}-dropdown-placement-bottom,
        &${antCls}-slide-down-appear${antCls}-slide-down-appear-active${componentCls}-dropdown-placement-bottom,
        &${antCls}-slide-down-enter${antCls}-slide-down-enter-active${componentCls}-dropdown-placement-bottomRight,
        &${antCls}-slide-down-appear${antCls}-slide-down-appear-active${componentCls}-dropdown-placement-bottomRight`]: {
                animationName: (0, $8c07f7e527e50277$export$e801b802b037de6a)
            },
            [`&${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-dropdown-placement-topLeft,
        &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-dropdown-placement-topLeft,
        &${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-dropdown-placement-top,
        &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-dropdown-placement-top,
        &${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-dropdown-placement-topRight,
        &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-dropdown-placement-topRight`]: {
                animationName: (0, $8c07f7e527e50277$export$dd9f089fa5e819fe)
            },
            [`&${antCls}-slide-down-leave${antCls}-slide-down-leave-active${componentCls}-dropdown-placement-bottomLeft,
        &${antCls}-slide-down-leave${antCls}-slide-down-leave-active${componentCls}-dropdown-placement-bottom,
        &${antCls}-slide-down-leave${antCls}-slide-down-leave-active${componentCls}-dropdown-placement-bottomRight`]: {
                animationName: (0, $8c07f7e527e50277$export$f40f41df328ebc38)
            },
            [`&${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-dropdown-placement-topLeft,
        &${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-dropdown-placement-top,
        &${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-dropdown-placement-topRight`]: {
                animationName: (0, $8c07f7e527e50277$export$f7243fdb9c27c3b7)
            },
            [`${componentCls}-dropdown-menu`]: {
                maxHeight: token.tabsDropdownHeight,
                margin: 0,
                padding: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(dropdownEdgeChildVerticalPadding)} 0`,
                overflowX: 'hidden',
                overflowY: 'auto',
                textAlign: {
                    _skip_check_: true,
                    value: 'left'
                },
                listStyleType: 'none',
                backgroundColor: token.colorBgContainer,
                backgroundClip: 'padding-box',
                borderRadius: token.borderRadiusLG,
                outline: 'none',
                boxShadow: token.boxShadowSecondary,
                '&-item': {
                    ...(0, $cd5a520fee8002b4$export$b2b65df0d0824629),
                    display: 'flex',
                    alignItems: 'center',
                    minWidth: token.tabsDropdownWidth,
                    margin: 0,
                    padding: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.paddingXXS)} ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.paddingSM)}`,
                    color: token.colorText,
                    fontWeight: 400,
                    fontSize: token.fontSize,
                    lineHeight: token.lineHeight,
                    cursor: 'pointer',
                    transition: `all ${token.motionDurationSlow}`,
                    '> span': {
                        flex: 1,
                        whiteSpace: 'nowrap'
                    },
                    '&-remove': {
                        flex: 'none',
                        marginLeft: {
                            _skip_check_: true,
                            value: token.marginSM
                        },
                        color: token.colorIcon,
                        fontSize: token.fontSizeSM,
                        background: 'transparent',
                        border: 0,
                        cursor: 'pointer',
                        '&:hover': {
                            color: itemHoverColor
                        }
                    },
                    '&:hover': {
                        background: token.controlItemBgHover
                    },
                    '&-disabled': {
                        '&, &:hover': {
                            color: token.colorTextDisabled,
                            background: 'transparent',
                            cursor: 'not-allowed'
                        }
                    }
                }
            }
        }
    };
};
const $e942c7afef44b507$var$genPositionStyle = (token)=>{
    const { componentCls: componentCls, margin: margin, colorBorderSecondary: colorBorderSecondary, horizontalMargin: horizontalMargin, verticalItemPadding: verticalItemPadding, verticalItemMargin: verticalItemMargin, motionDurationSlow: motionDurationSlow, calc: calc } = token;
    return {
        // ========================== Top & Bottom ==========================
        [`${componentCls}-top, ${componentCls}-bottom`]: {
            flexDirection: 'column',
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                margin: horizontalMargin,
                '&::before': {
                    position: 'absolute',
                    right: {
                        _skip_check_: true,
                        value: 0
                    },
                    left: {
                        _skip_check_: true,
                        value: 0
                    },
                    borderBottom: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${colorBorderSecondary}`,
                    content: "''"
                },
                [`${componentCls}-ink-bar`]: {
                    height: token.lineWidthBold,
                    '&-animated': {
                        transition: [
                            'width',
                            'left',
                            'right'
                        ].map((prop)=>`${prop} ${motionDurationSlow}`).join(', ')
                    }
                },
                [`${componentCls}-nav-wrap`]: {
                    '&::before, &::after': {
                        top: 0,
                        bottom: 0,
                        width: token.controlHeight
                    },
                    '&::before': {
                        left: {
                            _skip_check_: true,
                            value: 0
                        },
                        boxShadow: token.boxShadowTabsOverflowLeft
                    },
                    '&::after': {
                        right: {
                            _skip_check_: true,
                            value: 0
                        },
                        boxShadow: token.boxShadowTabsOverflowRight
                    },
                    [`&${componentCls}-nav-wrap-ping-left::before`]: {
                        opacity: 1
                    },
                    [`&${componentCls}-nav-wrap-ping-right::after`]: {
                        opacity: 1
                    }
                }
            }
        },
        [`${componentCls}-top`]: {
            [`> ${componentCls}-nav,
        > div > ${componentCls}-nav`]: {
                '&::before': {
                    bottom: 0
                },
                [`${componentCls}-ink-bar`]: {
                    bottom: 0
                }
            }
        },
        [`${componentCls}-bottom`]: {
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                order: 1,
                marginTop: margin,
                marginBottom: 0,
                '&::before': {
                    top: 0
                },
                [`${componentCls}-ink-bar`]: {
                    top: 0
                }
            },
            [`> ${componentCls}-body-holder, > div > ${componentCls}-body-holder`]: {
                order: 0
            }
        },
        // ========================== Left & Right ==========================
        [`${componentCls}-left, ${componentCls}-right`]: {
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                flexDirection: 'column',
                minWidth: calc(token.controlHeight).mul(1.25).equal(),
                // >>>>>>>>>>> Tab
                [`${componentCls}-tab`]: {
                    padding: verticalItemPadding,
                    textAlign: 'center'
                },
                [`${componentCls}-tab + ${componentCls}-tab`]: {
                    margin: verticalItemMargin
                },
                // >>>>>>>>>>> Nav
                [`${componentCls}-nav-wrap`]: {
                    flexDirection: 'column',
                    '&::before, &::after': {
                        right: {
                            _skip_check_: true,
                            value: 0
                        },
                        left: {
                            _skip_check_: true,
                            value: 0
                        },
                        height: token.controlHeight
                    },
                    '&::before': {
                        top: 0,
                        boxShadow: token.boxShadowTabsOverflowTop
                    },
                    '&::after': {
                        bottom: 0,
                        boxShadow: token.boxShadowTabsOverflowBottom
                    },
                    [`&${componentCls}-nav-wrap-ping-top::before`]: {
                        opacity: 1
                    },
                    [`&${componentCls}-nav-wrap-ping-bottom::after`]: {
                        opacity: 1
                    }
                },
                // >>>>>>>>>>> Ink Bar
                [`${componentCls}-ink-bar`]: {
                    width: token.lineWidthBold,
                    '&-animated': {
                        transition: [
                            'height',
                            'top'
                        ].map((prop)=>`${prop} ${motionDurationSlow}`).join(', ')
                    }
                },
                [`${componentCls}-nav-list, ${componentCls}-nav-operations`]: {
                    flex: '1 0 auto',
                    // fix safari scroll problem
                    flexDirection: 'column'
                }
            }
        },
        [`${componentCls}-left`]: {
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                [`${componentCls}-ink-bar`]: {
                    right: {
                        _skip_check_: true,
                        value: 0
                    }
                }
            },
            [`> ${componentCls}-body-holder, > div > ${componentCls}-body-holder`]: {
                marginLeft: {
                    _skip_check_: true,
                    value: (0, $56bae8a99c3cba6e$export$523c0b569236b342)(calc(token.lineWidth).mul(-1).equal())
                },
                borderLeft: {
                    _skip_check_: true,
                    value: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
                },
                [`> ${componentCls}-body > ${componentCls}-content`]: {
                    paddingLeft: {
                        _skip_check_: true,
                        value: token.paddingLG
                    }
                }
            }
        },
        [`${componentCls}-right`]: {
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                order: 1,
                [`${componentCls}-ink-bar`]: {
                    left: {
                        _skip_check_: true,
                        value: 0
                    }
                }
            },
            [`> ${componentCls}-body-holder, > div > ${componentCls}-body-holder`]: {
                order: 0,
                marginRight: {
                    _skip_check_: true,
                    value: calc(token.lineWidth).mul(-1).equal()
                },
                borderRight: {
                    _skip_check_: true,
                    value: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
                },
                [`> ${componentCls}-body > ${componentCls}-content`]: {
                    paddingRight: {
                        _skip_check_: true,
                        value: token.paddingLG
                    }
                }
            }
        }
    };
};
const $e942c7afef44b507$var$genSizeStyle = (token)=>{
    const { componentCls: componentCls, cardPaddingSM: cardPaddingSM, cardPaddingLG: cardPaddingLG, cardHeightSM: cardHeightSM, cardHeightLG: cardHeightLG, horizontalItemPaddingSM: horizontalItemPaddingSM, horizontalItemPaddingLG: horizontalItemPaddingLG } = token;
    return {
        // >>>>> shared
        [componentCls]: {
            '&-small': {
                [`> ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        padding: horizontalItemPaddingSM,
                        fontSize: token.titleFontSizeSM
                    }
                }
            },
            '&-large': {
                [`> ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        padding: horizontalItemPaddingLG,
                        fontSize: token.titleFontSizeLG,
                        lineHeight: token.lineHeightLG
                    }
                }
            }
        },
        // >>>>> card
        [`${componentCls}-card`]: {
            // Small
            [`&${componentCls}-small`]: {
                [`> ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        padding: cardPaddingSM
                    },
                    [`${componentCls}-nav-add`]: {
                        minWidth: cardHeightSM,
                        minHeight: cardHeightSM
                    }
                },
                [`&${componentCls}-bottom`]: {
                    [`> ${componentCls}-nav ${componentCls}-tab`]: {
                        borderRadius: `0 0 ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.borderRadius)} ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.borderRadius)}`
                    }
                },
                [`&${componentCls}-top`]: {
                    [`> ${componentCls}-nav ${componentCls}-tab`]: {
                        borderRadius: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.borderRadius)} ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.borderRadius)} 0 0`
                    }
                },
                [`&${componentCls}-right`]: {
                    [`> ${componentCls}-nav ${componentCls}-tab`]: {
                        borderRadius: {
                            _skip_check_: true,
                            value: `0 ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.borderRadius)} ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.borderRadius)} 0`
                        }
                    }
                },
                [`&${componentCls}-left`]: {
                    [`> ${componentCls}-nav ${componentCls}-tab`]: {
                        borderRadius: {
                            _skip_check_: true,
                            value: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.borderRadius)} 0 0 ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.borderRadius)}`
                        }
                    }
                }
            },
            // Large
            [`&${componentCls}-large`]: {
                [`> ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        padding: cardPaddingLG
                    },
                    [`${componentCls}-nav-add`]: {
                        minWidth: cardHeightLG,
                        minHeight: cardHeightLG
                    }
                }
            }
        }
    };
};
const $e942c7afef44b507$var$genTabStyle = (token)=>{
    const { componentCls: componentCls, itemActiveColor: itemActiveColor, itemHoverColor: itemHoverColor, iconCls: iconCls, tabsHorizontalItemMargin: tabsHorizontalItemMargin, horizontalItemPadding: horizontalItemPadding, itemSelectedColor: itemSelectedColor, itemColor: itemColor } = token;
    const tabCls = `${componentCls}-tab`;
    return {
        [tabCls]: {
            position: 'relative',
            WebkitTouchCallout: 'none',
            WebkitTapHighlightColor: 'transparent',
            display: 'inline-flex',
            alignItems: 'center',
            padding: horizontalItemPadding,
            fontSize: token.titleFontSize,
            background: 'transparent',
            border: 0,
            outline: 'none',
            cursor: 'pointer',
            color: itemColor,
            '&-btn, &-remove': {
                '&:focus:not(:focus-visible), &:active': {
                    color: itemActiveColor
                }
            },
            '&-btn': {
                outline: 'none',
                transition: `all ${token.motionDurationSlow}`,
                [`${tabCls}-icon:not(:last-child)`]: {
                    marginInlineEnd: token.marginSM
                },
                // Icons from third-party libraries render as a bare `<svg>` inside the icon wrapper,
                // which the `.anticon` reset never reaches. An `<svg>` has no baseline of its own, so it
                // is aligned by its bottom margin edge (CSS 2.1 §10.8.1) and rides above the label.
                // `display: inline-block` keeps it an atomic inline box so `vertical-align` still applies
                // even under a CSS reset that forces `svg { display: block }` (e.g. Tailwind Preflight),
                // which would otherwise drop the icon onto its own line. `vertical-align: middle` centres its
                // margin box on the x-height line; `margin-block-end` then lifts it by half its own value onto
                // the cap-height centre (capHeight − xHeight ≈ 0.2em across typical fonts), keeping it centred
                // at any icon size.
                // Only matches a bare `<svg>`: an `.anticon` keeps its `<svg>` one level deeper.
                [`${tabCls}-icon > svg`]: {
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    marginBlockEnd: '0.2em'
                }
            },
            '&-remove': {
                flex: 'none',
                lineHeight: 1,
                marginRight: {
                    _skip_check_: true,
                    value: token.calc(token.marginXXS).mul(-1).equal()
                },
                marginLeft: {
                    _skip_check_: true,
                    value: token.marginXS
                },
                color: token.colorIcon,
                fontSize: token.fontSizeSM,
                background: 'transparent',
                border: 'none',
                outline: 'none',
                cursor: 'pointer',
                transition: `all ${token.motionDurationSlow}`,
                '&:hover': {
                    color: token.colorTextHeading
                },
                ...(0, $cd5a520fee8002b4$export$a44db842bcb28231)(token)
            },
            '&:hover': {
                color: itemHoverColor
            },
            [`&${tabCls}-active ${tabCls}-btn`]: {
                color: itemSelectedColor
            },
            [`&${tabCls}-focus ${tabCls}-btn:focus-visible`]: (0, $cd5a520fee8002b4$export$6539948f0a737e39)(token),
            [`&${tabCls}-disabled`]: {
                color: token.colorTextDisabled,
                cursor: 'not-allowed'
            },
            [`&${tabCls}-disabled ${tabCls}-btn, &${tabCls}-disabled ${componentCls}-remove`]: {
                '&:focus, &:active': {
                    color: token.colorTextDisabled
                }
            },
            [`& ${tabCls}-remove ${iconCls}`]: {
                margin: 0,
                verticalAlign: 'middle'
            },
            [`${iconCls}:not(:last-child)`]: {
                marginRight: {
                    _skip_check_: true,
                    value: token.marginSM
                }
            }
        },
        [`${tabCls} + ${tabCls}`]: {
            margin: {
                _skip_check_: true,
                value: tabsHorizontalItemMargin
            }
        }
    };
};
const $e942c7afef44b507$var$genRtlStyle = (token)=>{
    const { componentCls: componentCls, tabsHorizontalItemMarginRTL: tabsHorizontalItemMarginRTL, iconCls: iconCls, cardGutter: cardGutter, calc: calc } = token;
    const rtlCls = `${componentCls}-rtl`;
    return {
        [rtlCls]: {
            direction: 'rtl',
            [`${componentCls}-nav`]: {
                [`${componentCls}-tab`]: {
                    margin: {
                        _skip_check_: true,
                        value: tabsHorizontalItemMarginRTL
                    },
                    [`${componentCls}-tab:last-of-type`]: {
                        marginLeft: {
                            _skip_check_: true,
                            value: 0
                        }
                    },
                    [iconCls]: {
                        marginRight: {
                            _skip_check_: true,
                            value: 0
                        },
                        marginLeft: {
                            _skip_check_: true,
                            value: token.marginSM
                        }
                    },
                    [`${componentCls}-tab-remove`]: {
                        marginRight: {
                            _skip_check_: true,
                            value: token.marginXS
                        },
                        marginLeft: {
                            _skip_check_: true,
                            value: calc(token.marginXXS).mul(-1).equal()
                        },
                        [iconCls]: {
                            margin: 0
                        }
                    }
                }
            },
            [`&${componentCls}-left`]: {
                [`> ${componentCls}-nav`]: {
                    order: 1
                },
                [`> ${componentCls}-body-holder`]: {
                    order: 0
                }
            },
            [`&${componentCls}-right`]: {
                [`> ${componentCls}-nav`]: {
                    order: 0
                },
                [`> ${componentCls}-body-holder`]: {
                    order: 1
                }
            },
            // ====================== Card ======================
            [`&${componentCls}-card${componentCls}-top, &${componentCls}-card${componentCls}-bottom`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab + ${componentCls}-tab`]: {
                        marginRight: {
                            _skip_check_: true,
                            value: cardGutter
                        },
                        marginLeft: {
                            _skip_check_: true,
                            value: 0
                        }
                    }
                }
            }
        },
        [`${componentCls}-dropdown-rtl`]: {
            direction: 'rtl'
        },
        [`${componentCls}-menu-item`]: {
            [`${componentCls}-dropdown-rtl`]: {
                textAlign: {
                    _skip_check_: true,
                    value: 'right'
                }
            }
        }
    };
};
const $e942c7afef44b507$var$genTabsStyle = (token)=>{
    const { componentCls: componentCls, tabsCardPadding: tabsCardPadding, cardHeight: cardHeight, cardGutter: cardGutter, itemHoverColor: itemHoverColor, itemActiveColor: itemActiveColor, colorBorderSecondary: colorBorderSecondary } = token;
    return {
        [componentCls]: {
            ...(0, $cd5a520fee8002b4$export$23997c3e44cc1c59)(token),
            display: 'flex',
            // ========================== Navigation ==========================
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                position: 'relative',
                display: 'flex',
                flex: 'none',
                alignItems: 'center',
                [`${componentCls}-nav-wrap`]: {
                    position: 'relative',
                    display: 'flex',
                    flex: 'auto',
                    alignSelf: 'stretch',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    transform: 'translate(0)',
                    // Fix chrome render bug
                    // >>>>> Ping shadow
                    '&::before, &::after': {
                        position: 'absolute',
                        zIndex: 1,
                        opacity: 0,
                        transition: `opacity ${token.motionDurationSlow}`,
                        content: "''",
                        pointerEvents: 'none'
                    }
                },
                [`${componentCls}-nav-list`]: {
                    position: 'relative',
                    display: 'flex',
                    transition: `opacity ${token.motionDurationSlow}`
                },
                // >>>>>>>> Operations
                [`${componentCls}-nav-operations`]: {
                    display: 'flex',
                    alignSelf: 'stretch'
                },
                [`${componentCls}-nav-operations-hidden`]: {
                    position: 'absolute',
                    visibility: 'hidden',
                    pointerEvents: 'none'
                },
                [`${componentCls}-nav-more`]: {
                    position: 'relative',
                    padding: tabsCardPadding,
                    background: 'transparent',
                    border: 0,
                    color: token.colorText,
                    '&::after': {
                        position: 'absolute',
                        right: {
                            _skip_check_: true,
                            value: 0
                        },
                        bottom: 0,
                        left: {
                            _skip_check_: true,
                            value: 0
                        },
                        height: token.calc(token.controlHeightLG).div(8).equal(),
                        transform: 'translateY(100%)',
                        content: "''"
                    }
                },
                [`${componentCls}-nav-add`]: {
                    minWidth: cardHeight,
                    minHeight: cardHeight,
                    marginLeft: {
                        _skip_check_: true,
                        value: cardGutter
                    },
                    background: 'transparent',
                    border: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${colorBorderSecondary}`,
                    borderRadius: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.borderRadiusLG)} 0 0`,
                    outline: 'none',
                    cursor: 'pointer',
                    color: token.colorText,
                    transition: `all ${token.motionDurationSlow} ${token.motionEaseInOut}`,
                    '&:hover': {
                        color: itemHoverColor
                    },
                    '&:active, &:focus:not(:focus-visible)': {
                        color: itemActiveColor
                    },
                    ...(0, $cd5a520fee8002b4$export$a44db842bcb28231)(token, -3)
                }
            },
            [`${componentCls}-extra-content`]: {
                flex: 'none'
            },
            // ============================ InkBar ============================
            [`${componentCls}-ink-bar`]: {
                position: 'absolute',
                background: token.inkBarColor,
                pointerEvents: 'none'
            },
            // ============================= Tabs =============================
            ...$e942c7afef44b507$var$genTabStyle(token),
            // =========================== TabPanes ===========================
            [`${componentCls}-body`]: {
                position: 'relative',
                width: '100%'
            },
            [`${componentCls}-body-holder`]: {
                flex: 'auto',
                minWidth: 0,
                minHeight: 0
            },
            [`${componentCls}-content`]: {
                ...(0, $cd5a520fee8002b4$export$a44db842bcb28231)(token),
                '&-hidden': {
                    display: 'none'
                }
            }
        },
        [`${componentCls}-centered`]: {
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                [`${componentCls}-nav-wrap`]: {
                    [`&:not([class*='${componentCls}-nav-wrap-ping']) > ${componentCls}-nav-list`]: {
                        margin: 'auto'
                    }
                }
            }
        }
    };
};
const $e942c7afef44b507$export$9ca1be8807fe0675 = (token)=>{
    const { cardHeight: cardHeight, cardHeightSM: cardHeightSM, cardHeightLG: cardHeightLG, controlHeight: controlHeight, controlHeightLG: controlHeightLG } = token;
    const mergedCardHeight = cardHeight || controlHeightLG;
    const mergedCardHeightSM = cardHeightSM || controlHeight;
    // `controlHeight` missing XL variable, so we directly write it here:
    const mergedCardHeightLG = cardHeightLG || controlHeightLG + 8;
    return {
        zIndexPopup: token.zIndexPopupBase + 50,
        cardBg: token.colorFillAlter,
        // We can not pass this as valid value,
        // Since `cardHeight` will lock nav add button height.
        cardHeight: mergedCardHeight,
        cardHeightSM: mergedCardHeightSM,
        cardHeightLG: mergedCardHeightLG,
        // Initialize with empty string, because cardPadding will be calculated with cardHeight by default.
        cardPadding: `${(mergedCardHeight - token.fontHeight) / 2 - token.lineWidth}px ${token.padding}px`,
        cardPaddingSM: `${(mergedCardHeightSM - token.fontHeight) / 2 - token.lineWidth}px ${token.paddingXS}px`,
        cardPaddingLG: `${(mergedCardHeightLG - token.fontHeightLG) / 2 - token.lineWidth}px ${token.padding}px`,
        titleFontSize: token.fontSize,
        titleFontSizeLG: token.fontSizeLG,
        titleFontSizeSM: token.fontSize,
        inkBarColor: token.colorPrimary,
        horizontalMargin: `0 0 ${token.margin}px 0`,
        horizontalItemGutter: 32,
        // Fixed Value
        // Initialize with empty string, because horizontalItemMargin will be calculated with horizontalItemGutter by default.
        horizontalItemMargin: ``,
        horizontalItemMarginRTL: ``,
        horizontalItemPadding: `${token.paddingSM}px 0`,
        horizontalItemPaddingSM: `${token.paddingXS}px 0`,
        horizontalItemPaddingLG: `${token.padding}px 0`,
        verticalItemPadding: `${token.paddingXS}px ${token.paddingLG}px`,
        verticalItemMargin: `${token.margin}px 0 0 0`,
        itemColor: token.colorText,
        itemSelectedColor: token.colorPrimary,
        itemHoverColor: token.colorPrimaryHover,
        itemActiveColor: token.colorPrimaryActive,
        cardGutter: token.marginXXS / 2
    };
};
var // ============================== Export ==============================
$e942c7afef44b507$export$2e2bcd8739ae039 = (0, $761caadb5301aee1$export$51ec95de45185b42)('Tabs', (token)=>{
    const tabsToken = (0, $f564548c7b6877d5$export$4950aa0f605343fb)(token, {
        // `cardPadding` is empty by default, so we could calculate with dynamic `cardHeight`
        tabsCardPadding: token.cardPadding,
        dropdownEdgeChildVerticalPadding: token.paddingXXS,
        tabsDropdownHeight: 200,
        tabsDropdownWidth: 120,
        tabsHorizontalItemMargin: `0 0 0 ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.horizontalItemGutter)}`,
        tabsHorizontalItemMarginRTL: `0 0 0 ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.horizontalItemGutter)}`
    });
    return [
        $e942c7afef44b507$var$genSizeStyle(tabsToken),
        $e942c7afef44b507$var$genRtlStyle(tabsToken),
        $e942c7afef44b507$var$genPositionStyle(tabsToken),
        $e942c7afef44b507$var$genDropdownStyle(tabsToken),
        $e942c7afef44b507$var$genCardStyle(tabsToken),
        $e942c7afef44b507$var$genTabsStyle(tabsToken),
        (0, $0f539d877fccd977$export$2e2bcd8739ae039)(tabsToken)
    ];
}, $e942c7afef44b507$export$9ca1be8807fe0675);


const $2a624106e760bd51$var$TabPane = ()=>null;
var $2a624106e760bd51$export$2e2bcd8739ae039 = $2a624106e760bd51$var$TabPane;


"use client";
const $c7fd5f6d0100ca71$var$InternalTabs = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { type: type, className: className, rootClassName: rootClassName, size: customSize, onEdit: onEdit, hideAdd: hideAdd, centered: centered, addIcon: addIcon, removeIcon: removeIcon, moreIcon: moreIcon, more: more, popupClassName: popupClassName, children: children, items: items, animated: animated, style: style, indicatorSize: indicatorSize, indicator: indicator, classNames: classNames, styles: styles, destroyInactiveTabPane: destroyInactiveTabPane, destroyOnHidden: destroyOnHidden, tabPlacement: tabPlacement, tabPosition: tabPosition, ...restProps } = props;
    const { prefixCls: customizePrefixCls } = restProps;
    const { getPrefixCls: getPrefixCls, direction: direction, getPopupContainer: getPopupContainer, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $519f2fad435b3034$export$46f4bd6436a25a31)('tabs');
    const { tabs: tabs } = $5E6i4.useContext((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('tabs', customizePrefixCls);
    const rootCls = (0, $d104ec5f99ed66d7$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $e942c7afef44b507$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const tabsRef = $5E6i4.useRef(null);
    $5E6i4.useImperativeHandle(ref, ()=>({
            nativeElement: tabsRef.current
        }));
    let editable;
    if (type === 'editable-card') editable = {
        onEdit: (editType, { key: key, event: event })=>{
            onEdit?.(editType === 'add' ? event : key, editType);
        },
        removeIcon: removeIcon ?? tabs?.removeIcon ?? /*#__PURE__*/ $5E6i4.createElement((0, $80d24bc031ad50e3$export$2e2bcd8739ae039), null),
        addIcon: (addIcon ?? tabs?.addIcon) || /*#__PURE__*/ $5E6i4.createElement((0, $9a6c2ad1f374ce69$export$2e2bcd8739ae039), null),
        showAdd: hideAdd !== true
    };
    const rootPrefixCls = getPrefixCls();
    var deprecatedName, newName, item;
    const size = (0, $4bfc7567df2a969e$export$2e2bcd8739ae039)(customSize);
    const mergedItems = (0, $203e54ec80556eb3$export$2e2bcd8739ae039)(items, children);
    const mergedAnimated = (0, $326ab66b0be31370$export$2e2bcd8739ae039)(prefixCls, animated);
    const mergedIndicator = {
        align: indicator?.align ?? tabs?.indicator?.align,
        size: indicator?.size ?? indicatorSize ?? tabs?.indicator?.size ?? tabs?.indicatorSize
    };
    const mergedPlacement = $5E6i4.useMemo(()=>{
        const placement = tabPlacement ?? tabPosition ?? undefined;
        const isRTL = direction === 'rtl';
        switch(placement){
            case 'start':
                return isRTL ? 'right' : 'left';
            case 'end':
                return isRTL ? 'left' : 'right';
            default:
                return placement;
        }
    }, [
        tabPlacement,
        tabPosition,
        direction
    ]);
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        size: size,
        tabPlacement: mergedPlacement,
        items: mergedItems
    };
    // ========================= Style ==========================
    const contextStyleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $722c8632ba7bdb89$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    }, {
        popup: {
            _default: 'root'
        }
    });
    return /*#__PURE__*/ $5E6i4.createElement((0, $f90c6223288e536c$export$2e2bcd8739ae039), {
        ref: tabsRef,
        direction: direction,
        getPopupContainer: getPopupContainer,
        ...restProps,
        items: mergedItems,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)({
            [`${prefixCls}-large`]: size === 'large',
            [`${prefixCls}-small`]: size === 'small',
            [`${prefixCls}-card`]: [
                'card',
                'editable-card'
            ].includes(type),
            [`${prefixCls}-editable-card`]: type === 'editable-card',
            [`${prefixCls}-centered`]: centered
        }, contextClassName, className, rootClassName, mergedClassNames.root, hashId, cssVarCls, rootCls),
        classNames: {
            ...mergedClassNames,
            popup: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(popupClassName, hashId, cssVarCls, rootCls, mergedClassNames.popup?.root)
        },
        // `popup` is nested as `{ root }` in antd but flat in rc-tabs, same as `classNames` above
        styles: {
            ...mergedStyles,
            popup: mergedStyles.popup?.root
        },
        style: mergedStyles.root,
        editable: editable,
        more: {
            icon: tabs?.more?.icon ?? tabs?.moreIcon ?? moreIcon ?? /*#__PURE__*/ $5E6i4.createElement((0, $bc99f102364e8dbf$export$2e2bcd8739ae039), null),
            transitionName: `${rootPrefixCls}-slide-up`,
            ...more
        },
        prefixCls: prefixCls,
        animated: mergedAnimated,
        indicator: mergedIndicator,
        destroyOnHidden: destroyOnHidden ?? destroyInactiveTabPane,
        tabPosition: mergedPlacement
    });
});
const $c7fd5f6d0100ca71$var$Tabs = $c7fd5f6d0100ca71$var$InternalTabs;
$c7fd5f6d0100ca71$var$Tabs.TabPane = (0, $2a624106e760bd51$export$2e2bcd8739ae039);
var $c7fd5f6d0100ca71$export$2e2bcd8739ae039 = $c7fd5f6d0100ca71$var$Tabs;


'use strict';
function $f6b6e4df564f06e6$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $37e88c15ceea9261$var$toString } = Object.prototype;
const { getPrototypeOf: $37e88c15ceea9261$var$getPrototypeOf } = Object;
const { iterator: $37e88c15ceea9261$var$iterator, toStringTag: $37e88c15ceea9261$var$toStringTag } = Symbol;
/* Creating a function that will check if an object has a property. */ const $37e88c15ceea9261$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
const $37e88c15ceea9261$var$isUnsafeObjectKey = (prop)=>typeof prop === 'string' && (prop === '__proto__' || prop === 'constructor' || prop === 'prototype');
/**
 * Determine whether an inherited object must be treated as a shared-prototype
 * boundary. Cross-realm Object.prototype objects cannot be distinguished
 * reliably from application-created null-prototype objects because their
 * properties are mutable, so all inherited terminal prototypes are excluded
 * as a fail-closed boundary. A null-prototype source still keeps its own
 * properties, as produced by mergeConfig and other safe materialization paths.
 *
 * @param {*} obj The object to inspect
 * @param {*} prototype The object's prototype
 * @param {boolean} source Whether obj is the original traversal source
 *
 * @returns {boolean} True when obj is a safe prototype traversal boundary
 */ const $37e88c15ceea9261$var$isPrototypeBoundary = (obj, prototype, source)=>obj === Object.prototype || !source && prototype === null;
/**
 * Determine whether an object can retain its identity through code paths that
 * add, replace, and remove config properties without bypassing unsafe-key
 * filtering. Immutable objects, unsafe-key-bearing objects, and objects with
 * accessor or restricted data properties must be materialized instead.
 *
 * @param {*} obj The object to inspect
 *
 * @returns {boolean} True when every own property is safe and fully mutable
 */ const $37e88c15ceea9261$var$isSafeAndFullyMutable = (obj)=>{
    if (!Object.isExtensible(obj)) return false;
    const props = Object.getOwnPropertyNames(obj);
    if (Object.getOwnPropertySymbols) props.push(...Object.getOwnPropertySymbols(obj));
    return props.every((prop)=>{
        if ($37e88c15ceea9261$var$isUnsafeObjectKey(prop)) return false;
        const descriptor = Object.getOwnPropertyDescriptor(obj, prop);
        return !!descriptor && descriptor.configurable && descriptor.writable === true;
    });
};
/**
 * Walk the prototype chain (excluding the source realm's Object.prototype)
 * looking for an own `prop`. This distinguishes genuine own/inherited members
 * — including class accessors and template prototypes — from members injected
 * via Object.prototype pollution (e.g. `Object.prototype.username = '...'`),
 * which live on Object.prototype itself and are therefore never matched.
 *
 * @param {*} thing The value whose chain to inspect
 * @param {string|symbol} prop The property key to look for
 *
 * @returns {boolean} True when `prop` is owned below Object.prototype
 */ const $37e88c15ceea9261$var$hasOwnInPrototypeChain = (thing, prop)=>{
    let obj = thing;
    const seen = [];
    while(obj != null){
        if (seen.indexOf(obj) !== -1) return false;
        seen.push(obj);
        const prototype = $37e88c15ceea9261$var$getPrototypeOf(obj);
        if ($37e88c15ceea9261$var$isPrototypeBoundary(obj, prototype, obj === thing)) return false;
        if ($37e88c15ceea9261$var$hasOwnProperty(obj, prop)) return true;
        obj = prototype;
    }
    return false;
};
/**
 * Read `obj[prop]` only when it is safe from Object.prototype pollution. Own
 * properties and members inherited from a non-Object.prototype source (a class
 * instance or template object) are honored; a value reachable only through a
 * polluted Object.prototype is ignored and `undefined` is returned.
 *
 * @param {*} obj The source object
 * @param {string|symbol} prop The property key to read
 *
 * @returns {*} The resolved value, or undefined when unsafe/absent
 */ const $37e88c15ceea9261$var$getSafeProp = (obj, prop)=>obj != null && $37e88c15ceea9261$var$hasOwnInPrototypeChain(obj, prop) ? obj[prop] : undefined;
/**
 * Flatten an object and its application-defined prototype chain into a
 * null-prototype object. Members inherited only from the source realm's
 * Object.prototype are deliberately excluded, while class/template members
 * below that boundary are preserved.
 *
 * @param {*} thing The value to flatten
 *
 * @returns {*} A null-prototype copy, or the original value when it is already
 * structurally safe or is not an object
 */ const $37e88c15ceea9261$var$toSafeFlatObject = (thing)=>{
    if (thing == null || typeof thing !== 'object' && typeof thing !== 'function') return thing;
    const sourcePrototype = $37e88c15ceea9261$var$getPrototypeOf(thing);
    if (sourcePrototype === null && $37e88c15ceea9261$var$isSafeAndFullyMutable(thing)) return thing;
    const result = Object.create(null);
    const merged = Object.create(null);
    const seen = [];
    let current = thing;
    while(current != null){
        if (seen.indexOf(current) !== -1) break;
        seen.push(current);
        const prototype = current === thing ? sourcePrototype : $37e88c15ceea9261$var$getPrototypeOf(current);
        if ($37e88c15ceea9261$var$isPrototypeBoundary(current, prototype, current === thing)) break;
        const props = Object.getOwnPropertyNames(current);
        if (Object.getOwnPropertySymbols) props.push(...Object.getOwnPropertySymbols(current));
        for (const prop of props){
            if ($37e88c15ceea9261$var$isUnsafeObjectKey(prop)) continue;
            if (!$37e88c15ceea9261$var$hasOwnProperty(merged, prop)) {
                result[prop] = thing[prop];
                merged[prop] = true;
            }
        }
        current = prototype;
    }
    return result;
};
const $37e88c15ceea9261$var$kindOf = ((cache)=>(thing)=>{
        const str = $37e88c15ceea9261$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $37e88c15ceea9261$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$37e88c15ceea9261$var$kindOf(thing) === type;
};
const $37e88c15ceea9261$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $37e88c15ceea9261$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $37e88c15ceea9261$var$isUndefined = $37e88c15ceea9261$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $37e88c15ceea9261$var$isBuffer(val) {
    return val !== null && !$37e88c15ceea9261$var$isUndefined(val) && val.constructor !== null && !$37e88c15ceea9261$var$isUndefined(val.constructor) && $37e88c15ceea9261$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $37e88c15ceea9261$var$isArrayBuffer = $37e88c15ceea9261$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $37e88c15ceea9261$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $37e88c15ceea9261$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $37e88c15ceea9261$var$isString = $37e88c15ceea9261$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $37e88c15ceea9261$var$isFunction = $37e88c15ceea9261$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $37e88c15ceea9261$var$isNumber = $37e88c15ceea9261$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $37e88c15ceea9261$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $37e88c15ceea9261$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $37e88c15ceea9261$var$isPlainObject = (val)=>{
    if (!$37e88c15ceea9261$var$isObject(val)) return false;
    const prototype = $37e88c15ceea9261$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || $37e88c15ceea9261$var$getPrototypeOf(prototype) === null) && // Treat safe own/inherited Symbol.toStringTag or Symbol.iterator members as
    // evidence the value is tagged/iterable, while ignoring members reachable
    // only through shared or terminal prototype boundaries.
    !$37e88c15ceea9261$var$hasOwnInPrototypeChain(val, $37e88c15ceea9261$var$toStringTag) && !$37e88c15ceea9261$var$hasOwnInPrototypeChain(val, $37e88c15ceea9261$var$iterator);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $37e88c15ceea9261$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$37e88c15ceea9261$var$isObject(val) || $37e88c15ceea9261$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $37e88c15ceea9261$var$isDate = $37e88c15ceea9261$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $37e88c15ceea9261$var$isFile = $37e88c15ceea9261$var$kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 *
 * @param {*} value The value to test
 *
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const $37e88c15ceea9261$var$isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 *
 * @param {*} formData The formData to test
 *
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const $37e88c15ceea9261$var$isReactNative = (formData)=>formData && typeof formData.getParts !== 'undefined';
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $37e88c15ceea9261$var$isBlob = $37e88c15ceea9261$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a FileList, otherwise false
 */ const $37e88c15ceea9261$var$isFileList = $37e88c15ceea9261$var$kindOfTest('FileList');
const $37e88c15ceea9261$var$isSet = $37e88c15ceea9261$var$kindOfTest('Set');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $37e88c15ceea9261$var$isStream = (val)=>$37e88c15ceea9261$var$isObject(val) && $37e88c15ceea9261$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $37e88c15ceea9261$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
}
const $37e88c15ceea9261$var$G = $37e88c15ceea9261$var$getGlobal();
const $37e88c15ceea9261$var$FormDataCtor = typeof $37e88c15ceea9261$var$G.FormData !== 'undefined' ? $37e88c15ceea9261$var$G.FormData : undefined;
const $37e88c15ceea9261$var$isFormData = (thing)=>{
    if (!thing) return false;
    if ($37e88c15ceea9261$var$FormDataCtor && thing instanceof $37e88c15ceea9261$var$FormDataCtor) return true;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData.
    const proto = $37e88c15ceea9261$var$getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!$37e88c15ceea9261$var$isFunction(thing.append)) return false;
    const kind = $37e88c15ceea9261$var$kindOf(thing);
    return kind === 'formdata' || // detect form-data instance
    kind === 'object' && $37e88c15ceea9261$var$isFunction(thing.toString) && thing.toString() === '[object FormData]';
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $37e88c15ceea9261$var$isURLSearchParams = $37e88c15ceea9261$var$kindOfTest('URLSearchParams');
const [$37e88c15ceea9261$var$isReadableStream, $37e88c15ceea9261$var$isRequest, $37e88c15ceea9261$var$isResponse, $37e88c15ceea9261$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($37e88c15ceea9261$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $37e88c15ceea9261$var$trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $37e88c15ceea9261$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($37e88c15ceea9261$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($37e88c15ceea9261$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $37e88c15ceea9261$var$findKey(obj, key) {
    if ($37e88c15ceea9261$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $37e88c15ceea9261$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $37e88c15ceea9261$var$isContextDefined = (context)=>!$37e88c15ceea9261$var$isUndefined(context) && context !== $37e88c15ceea9261$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $37e88c15ceea9261$var$merge(...objs) {
    const { caseless: caseless, skipUndefined: skipUndefined } = $37e88c15ceea9261$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        // findKey lowercases the key, so caseless lookup only applies to strings —
        // symbol keys are identity-matched.
        const targetKey = caseless && typeof key === 'string' && $37e88c15ceea9261$var$findKey(result, key) || key;
        // Read via own-prop only — a bare `result[targetKey]` walks the prototype
        // chain, so a polluted Object.prototype value could surface here and get
        // copied into the merged result.
        const existing = $37e88c15ceea9261$var$hasOwnProperty(result, targetKey) ? result[targetKey] : undefined;
        if ($37e88c15ceea9261$var$isPlainObject(existing) && $37e88c15ceea9261$var$isPlainObject(val)) result[targetKey] = $37e88c15ceea9261$var$merge(existing, val);
        else if ($37e88c15ceea9261$var$isPlainObject(val)) result[targetKey] = $37e88c15ceea9261$var$merge({}, val);
        else if ($37e88c15ceea9261$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$37e88c15ceea9261$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = objs.length; i < l; i++){
        const source = objs[i];
        if (!source || $37e88c15ceea9261$var$isBuffer(source)) continue;
        $37e88c15ceea9261$var$forEach(source, assignValue);
        if (typeof source !== 'object' || $37e88c15ceea9261$var$isArray(source)) continue;
        const symbols = Object.getOwnPropertySymbols(source);
        for(let j = 0; j < symbols.length; j++){
            const symbol = symbols[j];
            if ($37e88c15ceea9261$var$propertyIsEnumerable.call(source, symbol)) assignValue(source[symbol], symbol);
        }
    }
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $37e88c15ceea9261$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $37e88c15ceea9261$var$forEach(b, (val, key)=>{
        if (thisArg && $37e88c15ceea9261$var$isFunction(val)) Object.defineProperty(a, key, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot
            // hijack defineProperty's accessor-vs-data resolution.
            __proto__: null,
            value: (0, $f6b6e4df564f06e6$export$2e2bcd8739ae039)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            __proto__: null,
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $37e88c15ceea9261$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $37e88c15ceea9261$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        __proto__: null,
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        __proto__: null,
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $37e88c15ceea9261$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $37e88c15ceea9261$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $37e88c15ceea9261$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $37e88c15ceea9261$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($37e88c15ceea9261$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$37e88c15ceea9261$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $37e88c15ceea9261$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $37e88c15ceea9261$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $37e88c15ceea9261$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$37e88c15ceea9261$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $37e88c15ceea9261$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $37e88c15ceea9261$var$isHTMLForm = $37e88c15ceea9261$var$kindOfTest('HTMLFormElement');
const $37e88c15ceea9261$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
const { propertyIsEnumerable: $37e88c15ceea9261$var$propertyIsEnumerable } = Object.prototype;
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $37e88c15ceea9261$var$isRegExp = $37e88c15ceea9261$var$kindOfTest('RegExp');
const $37e88c15ceea9261$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $37e88c15ceea9261$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $37e88c15ceea9261$var$freezeMethods = (obj)=>{
    $37e88c15ceea9261$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($37e88c15ceea9261$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].includes(name)) return false;
        const value = obj[name];
        if (!$37e88c15ceea9261$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const $37e88c15ceea9261$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $37e88c15ceea9261$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $37e88c15ceea9261$var$noop = ()=>{};
const $37e88c15ceea9261$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $37e88c15ceea9261$var$isSpecCompliantForm(thing) {
    return !!(thing && $37e88c15ceea9261$var$isFunction(thing.append) && thing[$37e88c15ceea9261$var$toStringTag] === 'FormData' && thing[$37e88c15ceea9261$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const $37e88c15ceea9261$var$toJSONObject = (obj)=>{
    const visited = new WeakSet();
    const visit = (source)=>{
        if ($37e88c15ceea9261$var$isObject(source)) {
            if (visited.has(source)) return;
            //Buffer check
            if ($37e88c15ceea9261$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                // add-on descent / delete-on-ascent: preserves path semantics, so DAG nodes serialise at every occurrence (see #7230).
                visited.add(source);
                let target;
                if ($37e88c15ceea9261$var$isSet(source)) {
                    target = [];
                    for (const value of source){
                        const reducedValue = visit(value);
                        !$37e88c15ceea9261$var$isUndefined(reducedValue) && target.push(reducedValue);
                    }
                } else {
                    target = $37e88c15ceea9261$var$isArray(source) ? [] : {};
                    $37e88c15ceea9261$var$forEach(source, (value, key)=>{
                        const reducedValue = visit(value);
                        !$37e88c15ceea9261$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                    });
                }
                visited.delete(source);
                return target;
            }
        }
        return source;
    };
    return visit(obj);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const $37e88c15ceea9261$var$isAsyncFn = $37e88c15ceea9261$var$kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const $37e88c15ceea9261$var$isThenable = (thing)=>thing && ($37e88c15ceea9261$var$isObject(thing) || $37e88c15ceea9261$var$isFunction(thing)) && $37e88c15ceea9261$var$isFunction(thing.then) && $37e88c15ceea9261$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const $37e88c15ceea9261$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $37e88c15ceea9261$var$_global.addEventListener('message', ({ source: source, data: data })=>{
            if (source === $37e88c15ceea9261$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $37e88c15ceea9261$var$_global.postMessage(token, '*');
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $37e88c15ceea9261$var$isFunction($37e88c15ceea9261$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const $37e88c15ceea9261$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($37e88c15ceea9261$var$_global) : $37e88c15ceea9261$var$_setImmediate;
// *********************
const $37e88c15ceea9261$var$isIterable = (thing)=>thing != null && $37e88c15ceea9261$var$isFunction(thing[$37e88c15ceea9261$var$iterator]);
/**
 * Determine if a value is iterable via an iterator that is NOT sourced solely
 * from a polluted Object.prototype. Use this instead of `isIterable` whenever
 * the iterable comes from untrusted input (e.g. user-supplied header sources),
 * so `Object.prototype[Symbol.iterator] = ...` cannot turn an ordinary object
 * into an attacker-controlled entries iterator.
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value has a non-polluted iterator
 */ const $37e88c15ceea9261$var$isSafeIterable = (thing)=>thing != null && $37e88c15ceea9261$var$hasOwnInPrototypeChain(thing, $37e88c15ceea9261$var$iterator) && $37e88c15ceea9261$var$isIterable(thing);
var $37e88c15ceea9261$export$2e2bcd8739ae039 = {
    isArray: $37e88c15ceea9261$var$isArray,
    isArrayBuffer: $37e88c15ceea9261$var$isArrayBuffer,
    isBuffer: $37e88c15ceea9261$var$isBuffer,
    isFormData: $37e88c15ceea9261$var$isFormData,
    isArrayBufferView: $37e88c15ceea9261$var$isArrayBufferView,
    isString: $37e88c15ceea9261$var$isString,
    isNumber: $37e88c15ceea9261$var$isNumber,
    isBoolean: $37e88c15ceea9261$var$isBoolean,
    isObject: $37e88c15ceea9261$var$isObject,
    isPlainObject: $37e88c15ceea9261$var$isPlainObject,
    isEmptyObject: $37e88c15ceea9261$var$isEmptyObject,
    isReadableStream: $37e88c15ceea9261$var$isReadableStream,
    isRequest: $37e88c15ceea9261$var$isRequest,
    isResponse: $37e88c15ceea9261$var$isResponse,
    isHeaders: $37e88c15ceea9261$var$isHeaders,
    isUndefined: $37e88c15ceea9261$var$isUndefined,
    isDate: $37e88c15ceea9261$var$isDate,
    isFile: $37e88c15ceea9261$var$isFile,
    isReactNativeBlob: $37e88c15ceea9261$var$isReactNativeBlob,
    isReactNative: $37e88c15ceea9261$var$isReactNative,
    isBlob: $37e88c15ceea9261$var$isBlob,
    isRegExp: $37e88c15ceea9261$var$isRegExp,
    isFunction: $37e88c15ceea9261$var$isFunction,
    isStream: $37e88c15ceea9261$var$isStream,
    isURLSearchParams: $37e88c15ceea9261$var$isURLSearchParams,
    isTypedArray: $37e88c15ceea9261$var$isTypedArray,
    isFileList: $37e88c15ceea9261$var$isFileList,
    forEach: $37e88c15ceea9261$var$forEach,
    merge: $37e88c15ceea9261$var$merge,
    extend: $37e88c15ceea9261$var$extend,
    trim: $37e88c15ceea9261$var$trim,
    stripBOM: $37e88c15ceea9261$var$stripBOM,
    inherits: $37e88c15ceea9261$var$inherits,
    toFlatObject: $37e88c15ceea9261$var$toFlatObject,
    kindOf: $37e88c15ceea9261$var$kindOf,
    kindOfTest: $37e88c15ceea9261$var$kindOfTest,
    endsWith: $37e88c15ceea9261$var$endsWith,
    toArray: $37e88c15ceea9261$var$toArray,
    forEachEntry: $37e88c15ceea9261$var$forEachEntry,
    matchAll: $37e88c15ceea9261$var$matchAll,
    isHTMLForm: $37e88c15ceea9261$var$isHTMLForm,
    hasOwnProperty: $37e88c15ceea9261$var$hasOwnProperty,
    hasOwnProp: $37e88c15ceea9261$var$hasOwnProperty,
    hasOwnInPrototypeChain: $37e88c15ceea9261$var$hasOwnInPrototypeChain,
    getSafeProp: $37e88c15ceea9261$var$getSafeProp,
    toSafeFlatObject: $37e88c15ceea9261$var$toSafeFlatObject,
    reduceDescriptors: $37e88c15ceea9261$var$reduceDescriptors,
    freezeMethods: $37e88c15ceea9261$var$freezeMethods,
    toObjectSet: $37e88c15ceea9261$var$toObjectSet,
    toCamelCase: $37e88c15ceea9261$var$toCamelCase,
    noop: $37e88c15ceea9261$var$noop,
    toFiniteNumber: $37e88c15ceea9261$var$toFiniteNumber,
    findKey: $37e88c15ceea9261$var$findKey,
    global: $37e88c15ceea9261$var$_global,
    isContextDefined: $37e88c15ceea9261$var$isContextDefined,
    isSpecCompliantForm: $37e88c15ceea9261$var$isSpecCompliantForm,
    toJSONObject: $37e88c15ceea9261$var$toJSONObject,
    isAsyncFn: $37e88c15ceea9261$var$isAsyncFn,
    isThenable: $37e88c15ceea9261$var$isThenable,
    setImmediate: $37e88c15ceea9261$var$_setImmediate,
    asap: $37e88c15ceea9261$var$asap,
    isIterable: $37e88c15ceea9261$var$isIterable,
    isSafeIterable: $37e88c15ceea9261$var$isSafeIterable
};









'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $5eeb69bfb8f24992$var$ignoreDuplicateOf = (0, $37e88c15ceea9261$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $5eeb69bfb8f24992$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        const hasKey = (0, $37e88c15ceea9261$export$2e2bcd8739ae039).hasOwnProp(parsed, key);
        if (!key || hasKey && (0, $37e88c15ceea9261$export$2e2bcd8739ae039).hasOwnProp($5eeb69bfb8f24992$var$ignoreDuplicateOf, key)) return;
        if (key === 'set-cookie') {
            if (hasKey) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = hasKey ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};



'use strict';
function $e80639e44d32ecd1$var$trimSPorHTAB(str) {
    let start = 0;
    let end = str.length;
    while(start < end){
        const code = str.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === str.length ? str : str.slice(start, end);
}
// The control-code ranges are intentional: header sanitization strips C0/DEL bytes.
// eslint-disable-next-line no-control-regex
const $e80639e44d32ecd1$var$INVALID_UNICODE_HEADER_VALUE_CHARS = new RegExp('[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+', 'g');
// eslint-disable-next-line no-control-regex
const $e80639e44d32ecd1$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS = new RegExp('[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+', 'g');
function $e80639e44d32ecd1$var$sanitizeValue(value, invalidChars) {
    if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isArray(value)) return value.map((item)=>$e80639e44d32ecd1$var$sanitizeValue(item, invalidChars));
    return $e80639e44d32ecd1$var$trimSPorHTAB(String(value).replace(invalidChars, ''));
}
const $e80639e44d32ecd1$export$9e344cffce061a22 = (value)=>$e80639e44d32ecd1$var$sanitizeValue(value, $e80639e44d32ecd1$var$INVALID_UNICODE_HEADER_VALUE_CHARS);
const $e80639e44d32ecd1$export$59dd66c2a12d8f62 = (value)=>$e80639e44d32ecd1$var$sanitizeValue(value, $e80639e44d32ecd1$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS);
function $e80639e44d32ecd1$export$c30c72bb7e677d54(headers) {
    const byteStringHeaders = Object.create(null);
    (0, $37e88c15ceea9261$export$2e2bcd8739ae039).forEach(headers.toJSON(), (value, header)=>{
        byteStringHeaders[header] = $e80639e44d32ecd1$export$59dd66c2a12d8f62(value);
    });
    return byteStringHeaders;
}


'use strict';
const $6450fcf4641e8103$var$$internals = Symbol('internals');
function $6450fcf4641e8103$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $6450fcf4641e8103$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $37e88c15ceea9261$export$2e2bcd8739ae039).isArray(value) ? value.map($6450fcf4641e8103$var$normalizeValue) : (0, $e80639e44d32ecd1$export$9e344cffce061a22)(String(value));
}
function $6450fcf4641e8103$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $6450fcf4641e8103$var$parameterNameRE = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/;
function $6450fcf4641e8103$var$trimOWS(value) {
    let start = 0;
    let end = value.length;
    while(start < end){
        const code = value.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = value.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === value.length ? value : value.slice(start, end);
}
function $6450fcf4641e8103$var$decodeQuotedString(value) {
    const last = value.length - 1;
    if (last < 1 || value.charCodeAt(0) !== 0x22 || value.charCodeAt(last) !== 0x22) return value;
    let decoded = '';
    for(let i = 1; i < last; i++){
        const code = value.charCodeAt(i);
        if (code === 0x22) return value;
        if (code === 0x5c) {
            i += 1;
            if (i >= last) return value;
        }
        decoded += value[i];
    }
    return decoded;
}
function $6450fcf4641e8103$var$parseParameters(value) {
    const parameters = Object.create(null);
    const str = String(value);
    let start = 0;
    let quoted = false;
    let escaped = false;
    function parseParameter(end) {
        const part = $6450fcf4641e8103$var$trimOWS(str.slice(start, end));
        const equals = part.indexOf('=');
        if (equals < 1) return;
        const name = $6450fcf4641e8103$var$trimOWS(part.slice(0, equals));
        if (!$6450fcf4641e8103$var$parameterNameRE.test(name)) return;
        const normalizedName = name.toLowerCase();
        if (normalizedName === '__proto__' || normalizedName === 'constructor' || normalizedName === 'prototype') return;
        const parameterValue = $6450fcf4641e8103$var$trimOWS(part.slice(equals + 1));
        parameters[normalizedName] = $6450fcf4641e8103$var$decodeQuotedString(parameterValue);
    }
    for(let i = 0; i < str.length; i++){
        const code = str.charCodeAt(i);
        if (quoted) {
            if (escaped) escaped = false;
            else if (code === 0x5c) escaped = true;
            else if (code === 0x22) quoted = false;
        } else if (code === 0x22) quoted = true;
        else if (code === 0x2c || code === 0x3b) {
            parseParameter(i);
            start = i + 1;
        }
    }
    parseParameter(str.length);
    return parameters;
}
const $6450fcf4641e8103$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $6450fcf4641e8103$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $37e88c15ceea9261$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $6450fcf4641e8103$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $6450fcf4641e8103$var$buildAccessors(obj, header) {
    const accessorName = (0, $37e88c15ceea9261$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $6450fcf4641e8103$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $6450fcf4641e8103$var$normalizeHeader(_header);
            if (!lHeader) return;
            const key = (0, $37e88c15ceea9261$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $6450fcf4641e8103$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $37e88c15ceea9261$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$6450fcf4641e8103$var$isValidHeaderName(header)) setHeaders((0, $5eeb69bfb8f24992$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isObject(header) && (0, $37e88c15ceea9261$export$2e2bcd8739ae039).isSafeIterable(header)) {
            let obj = Object.create(null), dest, key;
            for (const entry of header){
                if (!(0, $37e88c15ceea9261$export$2e2bcd8739ae039).isArray(entry)) throw new TypeError('Object iterator must return a key-value pair');
                key = entry[0];
                if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).hasOwnProp(obj, key)) {
                    dest = obj[key];
                    obj[key] = (0, $37e88c15ceea9261$export$2e2bcd8739ae039).isArray(dest) ? [
                        ...dest,
                        entry[1]
                    ] : [
                        dest,
                        entry[1]
                    ];
                } else obj[key] = entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $6450fcf4641e8103$var$normalizeHeader(header);
        if (header) {
            const key = (0, $37e88c15ceea9261$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $6450fcf4641e8103$var$parseTokens(value);
                if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $6450fcf4641e8103$var$normalizeHeader(header);
        if (header) {
            const key = (0, $37e88c15ceea9261$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $6450fcf4641e8103$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $6450fcf4641e8103$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $37e88c15ceea9261$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $6450fcf4641e8103$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $6450fcf4641e8103$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $37e88c15ceea9261$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $37e88c15ceea9261$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $6450fcf4641e8103$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $6450fcf4641e8103$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $6450fcf4641e8103$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $37e88c15ceea9261$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $37e88c15ceea9261$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        const value = this.get('set-cookie');
        return (0, $37e88c15ceea9261$export$2e2bcd8739ae039).isArray(value) ? value : value == null || value === false ? [] : [
            value
        ];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static parseParameters(value) {
        return $6450fcf4641e8103$var$parseParameters(value);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$6450fcf4641e8103$var$$internals] = this[$6450fcf4641e8103$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $6450fcf4641e8103$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $6450fcf4641e8103$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $37e88c15ceea9261$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$6450fcf4641e8103$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $37e88c15ceea9261$export$2e2bcd8739ae039).reduceDescriptors($6450fcf4641e8103$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $37e88c15ceea9261$export$2e2bcd8739ae039).freezeMethods($6450fcf4641e8103$var$AxiosHeaders);
var $6450fcf4641e8103$export$2e2bcd8739ae039 = $6450fcf4641e8103$var$AxiosHeaders;


'use strict';
const $914052063804fa69$export$6acd2efa8ac62a1b = '[REDACTED ****]';
function $914052063804fa69$var$hasOwnOrPrototypeToJSON(source) {
    if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).hasOwnProp(source, 'toJSON')) return true;
    let prototype = Object.getPrototypeOf(source);
    while(prototype && prototype !== Object.prototype){
        if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).hasOwnProp(prototype, 'toJSON')) return true;
        prototype = Object.getPrototypeOf(prototype);
    }
    return false;
}
// Build a plain-object snapshot of `config` and replace the value of any key
// (case-insensitive) listed in `redactKeys` with REDACTED. Walks through arrays
// and AxiosHeaders, and short-circuits on circular references.
function $914052063804fa69$var$redactConfig(config, redactKeys) {
    const lowerKeys = new Set(redactKeys.map((k)=>String(k).toLowerCase()));
    const seen = [];
    const visit = (source)=>{
        if (source === null || typeof source !== 'object') return source;
        if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isBuffer(source)) return source;
        if (seen.indexOf(source) !== -1) return undefined;
        if (source instanceof (0, $6450fcf4641e8103$export$2e2bcd8739ae039)) source = source.toJSON();
        seen.push(source);
        let result;
        if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isArray(source)) {
            result = [];
            source.forEach((v, i)=>{
                const reducedValue = visit(v);
                if (!(0, $37e88c15ceea9261$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[i] = reducedValue;
            });
        } else {
            if (!(0, $37e88c15ceea9261$export$2e2bcd8739ae039).isPlainObject(source) && $914052063804fa69$var$hasOwnOrPrototypeToJSON(source)) {
                seen.pop();
                return source;
            }
            result = Object.create(null);
            for (const [key, value] of Object.entries(source)){
                const reducedValue = lowerKeys.has(key.toLowerCase()) ? $914052063804fa69$export$6acd2efa8ac62a1b : visit(value);
                if (!(0, $37e88c15ceea9261$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[key] = reducedValue;
            }
        }
        seen.pop();
        return result;
    };
    return visit(config);
}
function $914052063804fa69$var$stringifySafely(value) {
    try {
        return String(value);
    } catch (err) {
        return '';
    }
}
function $914052063804fa69$var$aggregateErrorMessage(error) {
    const message = error.errors.map((entry)=>{
        try {
            return entry && entry.message ? $914052063804fa69$var$stringifySafely(entry.message) : $914052063804fa69$var$stringifySafely(entry);
        } catch (err) {
            return '';
        }
    }).filter(Boolean).join('; ');
    return message || error.name || 'AggregateError';
}
class $914052063804fa69$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        // `AggregateError` (thrown by Node on dual-stack/Happy-Eyeballs connection
        // failures) has an empty `message`; its detail lives in `errors[]`. Without
        // this, the wrapped error surfaces with a blank message (see #6721).
        let message = error.message;
        if (!message && (0, $37e88c15ceea9261$export$2e2bcd8739ae039).isArray(error.errors) && error.errors.length) message = $914052063804fa69$var$aggregateErrorMessage(error);
        const axiosError = new $914052063804fa69$var$AxiosError(message, code || error.code, config, request, response);
        // Match native `Error` `cause` semantics: non-enumerable. The wrapped
        // error often carries circular internals (sockets, requests, agents), so
        // an enumerable `cause` makes structured loggers (pino/winston) and any
        // own-property walk throw "Converting circular structure to JSON".
        // Regression from #6982; see #7205. `__proto__: null` mirrors the
        // `message` descriptor below (prototype-pollution-safe descriptor).
        Object.defineProperty(axiosError, 'cause', {
            __proto__: null,
            value: error,
            writable: true,
            enumerable: false,
            configurable: true
        });
        axiosError.name = error.name;
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, 'message', {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
    toJSON() {
        // Opt-in redaction: when the request config carries a `redact` array, the
        // value of any matching key (case-insensitive, at any depth) is replaced
        // with REDACTED in the serialized snapshot. Undefined or empty leaves the
        // existing serialization behavior unchanged.
        const config = this.config;
        const redactKeys = config && (0, $37e88c15ceea9261$export$2e2bcd8739ae039).hasOwnProp(config, 'redact') ? config.redact : undefined;
        const serializedConfig = (0, $37e88c15ceea9261$export$2e2bcd8739ae039).isArray(redactKeys) && redactKeys.length > 0 ? $914052063804fa69$var$redactConfig(config, redactKeys) : (0, $37e88c15ceea9261$export$2e2bcd8739ae039).toJSONObject(config);
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: serializedConfig,
            code: this.code,
            status: this.status
        };
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$914052063804fa69$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$914052063804fa69$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$914052063804fa69$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$914052063804fa69$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$914052063804fa69$var$AxiosError.ECONNREFUSED = 'ECONNREFUSED';
$914052063804fa69$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$914052063804fa69$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$914052063804fa69$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$914052063804fa69$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$914052063804fa69$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$914052063804fa69$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$914052063804fa69$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$914052063804fa69$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
$914052063804fa69$var$AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED = 'ERR_FORM_DATA_DEPTH_EXCEEDED';
var $914052063804fa69$export$2e2bcd8739ae039 = $914052063804fa69$var$AxiosError;


// eslint-disable-next-line strict
var $b0df307601dbab4c$export$2e2bcd8739ae039 = null;



'use strict';
const $5176de0e7036a0db$export$659081b45d03227d = 100;
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $5176de0e7036a0db$var$isVisitable(thing) {
    return (0, $37e88c15ceea9261$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $37e88c15ceea9261$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $5176de0e7036a0db$var$removeBrackets(key) {
    return (0, $37e88c15ceea9261$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $5176de0e7036a0db$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $5176de0e7036a0db$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $5176de0e7036a0db$var$isFlatArray(arr) {
    return (0, $37e88c15ceea9261$export$2e2bcd8739ae039).isArray(arr) && !arr.some($5176de0e7036a0db$var$isVisitable);
}
const $5176de0e7036a0db$var$predicates = (0, $37e88c15ceea9261$export$2e2bcd8739ae039).toFlatObject((0, $37e88c15ceea9261$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $5176de0e7036a0db$var$toFormData(obj, formData, options) {
    if (!(0, $37e88c15ceea9261$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $b0df307601dbab4c$export$2e2bcd8739ae039) || FormData)();
    const option = (name, fallback)=>{
        const value = (0, $37e88c15ceea9261$export$2e2bcd8739ae039).getSafeProp(options, name);
        return (0, $37e88c15ceea9261$export$2e2bcd8739ae039).isUndefined(value) ? fallback : value;
    };
    const metaTokens = option('metaTokens', true);
    // eslint-disable-next-line no-use-before-define
    const visitor = option('visitor') || defaultVisitor;
    const dots = option('dots', false);
    const indexes = option('indexes', false);
    const _Blob = option('Blob') || typeof Blob !== 'undefined' && Blob;
    const maxDepth = option('maxDepth', $5176de0e7036a0db$export$659081b45d03227d);
    const useBlob = _Blob && (0, $37e88c15ceea9261$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    const stack = [];
    if (!(0, $37e88c15ceea9261$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $37e88c15ceea9261$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $914052063804fa69$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $37e88c15ceea9261$export$2e2bcd8739ae039).isTypedArray(value)) {
            if (useBlob && typeof _Blob === 'function') return new _Blob([
                value
            ]);
            if ((0, $b0df307601dbab4c$export$2e2bcd8739ae039) && (0, $b0df307601dbab4c$export$2e2bcd8739ae039).isBufferAvailable()) return (0, $b0df307601dbab4c$export$2e2bcd8739ae039).from(value);
            throw new (0, $914052063804fa69$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.', (0, $914052063804fa69$export$2e2bcd8739ae039).ERR_NOT_SUPPORT);
        }
        return value;
    }
    function throwIfMaxDepthExceeded(depth) {
        if (depth > maxDepth) throw new (0, $914052063804fa69$export$2e2bcd8739ae039)('Object is too deeply nested (' + depth + ' levels). Max depth: ' + maxDepth, (0, $914052063804fa69$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
    }
    function stringifyWithDepthLimit(value, depth) {
        if (maxDepth === Infinity) return JSON.stringify(value);
        const ancestors = [];
        return JSON.stringify(value, function limitDepth(_key, currentValue) {
            if (!(0, $37e88c15ceea9261$export$2e2bcd8739ae039).isObject(currentValue)) return currentValue;
            while(ancestors.length && ancestors[ancestors.length - 1] !== this)ancestors.pop();
            ancestors.push(currentValue);
            throwIfMaxDepthExceeded(depth + ancestors.length - 1);
            return currentValue;
        });
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isReactNative(formData) && (0, $37e88c15ceea9261$export$2e2bcd8739ae039).isReactNativeBlob(value)) {
            formData.append($5176de0e7036a0db$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === 'object') {
            if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = stringifyWithDepthLimit(value, 1);
            } else if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isArray(value) && $5176de0e7036a0db$var$isFlatArray(value) || ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isFileList(value) || (0, $37e88c15ceea9261$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $37e88c15ceea9261$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $5176de0e7036a0db$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $5176de0e7036a0db$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($5176de0e7036a0db$var$isVisitable(value)) return true;
        formData.append($5176de0e7036a0db$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const exposedHelpers = Object.assign($5176de0e7036a0db$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $5176de0e7036a0db$var$isVisitable
    });
    function build(value, path, depth = 0) {
        if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isUndefined(value)) return;
        throwIfMaxDepthExceeded(depth);
        if (stack.indexOf(value) !== -1) throw new Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $37e88c15ceea9261$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $37e88c15ceea9261$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ], depth + 1);
        });
        stack.pop();
    }
    if (!(0, $37e88c15ceea9261$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $5176de0e7036a0db$export$2e2bcd8739ae039 = $5176de0e7036a0db$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $d694f543d509e9a4$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $d694f543d509e9a4$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $5176de0e7036a0db$export$2e2bcd8739ae039)(params, this, options);
}
const $d694f543d509e9a4$var$prototype = $d694f543d509e9a4$var$AxiosURLSearchParams.prototype;
$d694f543d509e9a4$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$d694f543d509e9a4$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? (value)=>encoder.call(this, value, $d694f543d509e9a4$var$encode) : $d694f543d509e9a4$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $d694f543d509e9a4$export$2e2bcd8739ae039 = $d694f543d509e9a4$var$AxiosURLSearchParams;


'use strict';
function $cd87bd104fdb775a$export$c564cdbbe6da493(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $cd87bd104fdb775a$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    url = url || '';
    const _options = (0, $37e88c15ceea9261$export$2e2bcd8739ae039).isFunction(options) ? {
        serialize: options
    } : options;
    // Read serializer options pollution-safely: own properties and methods on a
    // class/template prototype are honored, but values injected onto a polluted
    // Object.prototype are ignored.
    const _encode = (0, $37e88c15ceea9261$export$2e2bcd8739ae039).getSafeProp(_options, 'encode') || $cd87bd104fdb775a$export$c564cdbbe6da493;
    const serializeFn = (0, $37e88c15ceea9261$export$2e2bcd8739ae039).getSafeProp(_options, 'serialize');
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $37e88c15ceea9261$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $d694f543d509e9a4$export$2e2bcd8739ae039)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
const $4835baaf88872551$var$$internals = Symbol('internals');
// `handlers` is public and may be replaced with a nullish value by user code;
// `clear()` has always tolerated that. Treat it as an empty stack rather than
// dereferencing it.
function $4835baaf88872551$var$countHandlers(handlers) {
    return handlers ? handlers.length : 0;
}
function $4835baaf88872551$var$trimHandlers(handlers) {
    if (!handlers) return;
    while(handlers.length && handlers[handlers.length - 1] === null)handlers.pop();
}
function $4835baaf88872551$var$syncHandlerEntries(manager, internals) {
    const handlers = manager.handlers;
    const length = $4835baaf88872551$var$countHandlers(handlers);
    if (handlers !== internals.handlersRef) {
        internals.handlersRef = handlers;
        internals.handlerEntries.clear();
    } else if (length !== internals.handlersLength) {
        if (!length) internals.handlerEntries.clear();
        else internals.handlerEntries.forEach(function removeStaleEntry(entry, id) {
            if (handlers[entry.index] !== entry.handler) internals.handlerEntries.delete(id);
        });
    }
    internals.handlersLength = length;
}
class $4835baaf88872551$var$InterceptorManager {
    constructor(){
        this.handlers = [];
        this[$4835baaf88872551$var$$internals] = {
            handlersRef: this.handlers,
            handlersLength: this.handlers.length,
            handlerEntries: new Map(),
            iterationDepth: 0,
            nextId: 0
        };
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        const handler = {
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        };
        const internals = this[$4835baaf88872551$var$$internals];
        if (this.handlers == null) this.handlers = [];
        $4835baaf88872551$var$syncHandlerEntries(this, internals);
        const id = internals.nextId++;
        this.handlers.push(handler);
        internals.handlerEntries.set(id, {
            handler: handler,
            index: this.handlers.length - 1
        });
        internals.handlersLength = this.handlers.length;
        return id;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        const internals = this[$4835baaf88872551$var$$internals];
        $4835baaf88872551$var$syncHandlerEntries(this, internals);
        const entry = internals.handlerEntries.get(id);
        if (entry) {
            internals.handlerEntries.delete(id);
            // Ignore IDs invalidated by clear or direct replacement of handlers.
            if (this.handlers[entry.index] !== entry.handler) return;
            this.handlers[entry.index] = null;
            // Do not reuse an index while forEach is walking its length snapshot.
            if (!internals.iterationDepth) {
                $4835baaf88872551$var$trimHandlers(this.handlers);
                internals.handlersLength = this.handlers.length;
            }
        }
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) {
            this.handlers = [];
            $4835baaf88872551$var$syncHandlerEntries(this, this[$4835baaf88872551$var$$internals]);
        }
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        const internals = this[$4835baaf88872551$var$$internals];
        $4835baaf88872551$var$syncHandlerEntries(this, internals);
        internals.iterationDepth++;
        try {
            (0, $37e88c15ceea9261$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
                if (h !== null) fn(h);
            });
        } finally{
            if (!--internals.iterationDepth) {
                $4835baaf88872551$var$syncHandlerEntries(this, internals);
                $4835baaf88872551$var$trimHandlers(this.handlers);
                internals.handlersLength = $4835baaf88872551$var$countHandlers(this.handlers);
            }
        }
    }
}
var $4835baaf88872551$export$2e2bcd8739ae039 = $4835baaf88872551$var$InterceptorManager;





'use strict';
var $8580892c96adaf9d$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true,
    advertiseZstdAcceptEncoding: false,
    validateStatusUndefinedResolves: true
};






'use strict';
var $eb451249c0ef855e$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $d694f543d509e9a4$export$2e2bcd8739ae039);


'use strict';
var $bf6b18a5fa354c1b$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $5f1ed0c600b50aff$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $c232d5e6d0edb84a$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $eb451249c0ef855e$export$2e2bcd8739ae039,
        FormData: $bf6b18a5fa354c1b$export$2e2bcd8739ae039,
        Blob: $5f1ed0c600b50aff$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $e9e12caff7760e43$exports = {};

$parcel$export($e9e12caff7760e43$exports, "hasBrowserEnv", () => $e9e12caff7760e43$export$c4996c4b7b93b0bf);
$parcel$export($e9e12caff7760e43$exports, "navigator", () => $e9e12caff7760e43$export$ec7c8efa7f5790ae);
$parcel$export($e9e12caff7760e43$exports, "hasStandardBrowserEnv", () => $e9e12caff7760e43$export$c0bcc9250309d66);
$parcel$export($e9e12caff7760e43$exports, "hasStandardBrowserWebWorkerEnv", () => $e9e12caff7760e43$export$c81692cf5af97dac);
$parcel$export($e9e12caff7760e43$exports, "origin", () => $e9e12caff7760e43$export$f710a83a91838a36);
const $e9e12caff7760e43$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $e9e12caff7760e43$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $e9e12caff7760e43$export$c0bcc9250309d66 = $e9e12caff7760e43$export$c4996c4b7b93b0bf && (!$e9e12caff7760e43$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($e9e12caff7760e43$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $e9e12caff7760e43$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $e9e12caff7760e43$export$f710a83a91838a36 = $e9e12caff7760e43$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $31ef68bc78b43ea6$export$2e2bcd8739ae039 = {
    ...$e9e12caff7760e43$exports,
    ...(0, $c232d5e6d0edb84a$export$2e2bcd8739ae039)
};


'use strict';
function $d56800ff7ebeb133$export$2e2bcd8739ae039(data, options) {
    return (0, $5176de0e7036a0db$export$2e2bcd8739ae039)(data, new (0, $31ef68bc78b43ea6$export$2e2bcd8739ae039).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $31ef68bc78b43ea6$export$2e2bcd8739ae039).isNode && (0, $37e88c15ceea9261$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}






'use strict';
const $273c8c7c7b37d447$var$MAX_DEPTH = (0, $5176de0e7036a0db$export$659081b45d03227d);
function $273c8c7c7b37d447$var$throwIfDepthExceeded(index) {
    if (index > $273c8c7c7b37d447$var$MAX_DEPTH) throw new (0, $914052063804fa69$export$2e2bcd8739ae039)('FormData field is too deeply nested (' + index + ' levels). Max depth: ' + $273c8c7c7b37d447$var$MAX_DEPTH, (0, $914052063804fa69$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
}
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $273c8c7c7b37d447$var$parsePropPath(name) {
    // foo[x][y][z] -> ['foo', 'x', 'y', 'z']
    // foo.x.y.z    -> ['foo', 'x', 'y', 'z']
    // A path is split on `.` and on `[...]` groups. A segment — whether written
    // in dot notation or captured inside brackets — may contain any character
    // except `.`, `[` and `]`, so a key like `user-name` or `user name` is kept
    // literal instead of being split (#5402). `.`, `[` and `]` keep their existing
    // meaning, e.g. `foo[bar.baz]` -> ['foo', 'bar', 'baz'] and `[]` is an array push.
    // Excluding `[` from the bracket group also makes the match fail fast at the
    // next `[`, so a malformed name cannot rescan to the end of the string from
    // every unmatched `[` — parsing stays linear in the length of the name.
    const path = [];
    const pattern = /[^.[\]]+|\[([^.[\]]*)]/g;
    let match;
    while((match = pattern.exec(name)) !== null){
        $273c8c7c7b37d447$var$throwIfDepthExceeded(path.length);
        path.push(match[0] === '[]' ? '' : match[1] || match[0]);
    }
    return path;
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $273c8c7c7b37d447$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $273c8c7c7b37d447$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        $273c8c7c7b37d447$var$throwIfDepthExceeded(index);
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $37e88c15ceea9261$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = (0, $37e88c15ceea9261$export$2e2bcd8739ae039).isArray(target[name]) ? target[name].concat(value) : [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!(0, $37e88c15ceea9261$export$2e2bcd8739ae039).hasOwnProp(target, name) || !(0, $37e88c15ceea9261$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $37e88c15ceea9261$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $273c8c7c7b37d447$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isFormData(formData) && (0, $37e88c15ceea9261$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $37e88c15ceea9261$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($273c8c7c7b37d447$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $273c8c7c7b37d447$export$2e2bcd8739ae039 = $273c8c7c7b37d447$var$formDataToJSON;


'use strict';
const $55a8dd1c06168658$var$methodList = Object.freeze([
    'get',
    'delete',
    'head',
    'options',
    'post',
    'put',
    'patch',
    'purge',
    'link',
    'unlink',
    'query'
]);
var $55a8dd1c06168658$export$2e2bcd8739ae039 = $55a8dd1c06168658$var$methodList;


'use strict';
const $89e9ad5e98e61be2$var$own = (obj, key)=>obj != null && (0, $37e88c15ceea9261$export$2e2bcd8739ae039).hasOwnProp(obj, key) ? obj[key] : undefined;
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $89e9ad5e98e61be2$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $37e88c15ceea9261$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $89e9ad5e98e61be2$var$defaults = {
    transitional: (0, $8580892c96adaf9d$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $37e88c15ceea9261$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $37e88c15ceea9261$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $37e88c15ceea9261$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $273c8c7c7b37d447$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $37e88c15ceea9261$export$2e2bcd8739ae039).isBuffer(data) || (0, $37e88c15ceea9261$export$2e2bcd8739ae039).isStream(data) || (0, $37e88c15ceea9261$export$2e2bcd8739ae039).isFile(data) || (0, $37e88c15ceea9261$export$2e2bcd8739ae039).isBlob(data) || (0, $37e88c15ceea9261$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                const formSerializer = $89e9ad5e98e61be2$var$own(this, 'formSerializer');
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $d56800ff7ebeb133$export$2e2bcd8739ae039)(data, formSerializer).toString();
                if ((isFileList = (0, $37e88c15ceea9261$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const env = $89e9ad5e98e61be2$var$own(this, 'env');
                    const _FormData = env && env.FormData;
                    return (0, $5176de0e7036a0db$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $89e9ad5e98e61be2$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = $89e9ad5e98e61be2$var$own(this, 'transitional') || $89e9ad5e98e61be2$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const responseType = $89e9ad5e98e61be2$var$own(this, 'responseType');
            const JSONRequested = responseType === 'json';
            if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isResponse(data) || (0, $37e88c15ceea9261$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $37e88c15ceea9261$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, $89e9ad5e98e61be2$var$own(this, 'parseReviver'));
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $914052063804fa69$export$2e2bcd8739ae039).from(e, (0, $914052063804fa69$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, $89e9ad5e98e61be2$var$own(this, 'response'));
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $31ef68bc78b43ea6$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $31ef68bc78b43ea6$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $37e88c15ceea9261$export$2e2bcd8739ae039).forEach((0, $55a8dd1c06168658$export$2e2bcd8739ae039), (method)=>{
    $89e9ad5e98e61be2$var$defaults.headers[method] = {};
});
var $89e9ad5e98e61be2$export$2e2bcd8739ae039 = $89e9ad5e98e61be2$var$defaults;



'use strict';
function $bae8766bee727377$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $89e9ad5e98e61be2$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $6450fcf4641e8103$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $37e88c15ceea9261$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $4770b47c1119b9a2$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}




'use strict';
class $1a943e5048e7ffb9$var$CanceledError extends (0, $914052063804fa69$export$2e2bcd8739ae039) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, (0, $914052063804fa69$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
var $1a943e5048e7ffb9$export$2e2bcd8739ae039 = $1a943e5048e7ffb9$var$CanceledError;







'use strict';
function $fd7658c72cb668a1$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $914052063804fa69$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, response.status >= 400 && response.status < 500 ? (0, $914052063804fa69$export$2e2bcd8739ae039).ERR_BAD_REQUEST : (0, $914052063804fa69$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, response.config, response.request, response));
}





'use strict';
const $ed38d5ef9b811df0$var$urlParserControlCharacters = /[\t\n\r]/g;
function $ed38d5ef9b811df0$export$2e2bcd8739ae039(url) {
    if (typeof url !== 'string') return url;
    let start = 0;
    while(start < url.length && url.charCodeAt(start) <= 0x20)start++;
    return url.slice(start).replace($ed38d5ef9b811df0$var$urlParserControlCharacters, '');
}


'use strict';
function $80399759ab16dd33$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25}):(?:\/\/)?/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $4f506b395f3cb1a5$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $4f506b395f3cb1a5$export$2e2bcd8739ae039 = $4f506b395f3cb1a5$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Array<Function>}
 */ function $da5465855534619f$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    const flushWith = (...args)=>invoke(args);
    return [
        throttled,
        flush,
        flushWith
    ];
}
var $da5465855534619f$export$2e2bcd8739ae039 = $da5465855534619f$var$throttle;



const $c9a0507500d3dd40$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $4f506b395f3cb1a5$export$2e2bcd8739ae039)(50, 250);
    return (0, $da5465855534619f$export$2e2bcd8739ae039)((e)=>{
        if (!e || !(0, $37e88c15ceea9261$export$2e2bcd8739ae039).isNumber(e.loaded)) return;
        const rawLoaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const loaded = Math.max(0, total != null ? Math.min(rawLoaded, total) : rawLoaded);
        const progressBytes = Math.max(0, loaded - bytesNotified);
        const rate = _speedometer(progressBytes);
        bytesNotified = Math.max(bytesNotified, loaded);
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $c9a0507500d3dd40$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $c9a0507500d3dd40$export$5d35863c355a22a9 = (fn, scheduler = (0, $37e88c15ceea9261$export$2e2bcd8739ae039).asap)=>(...args)=>scheduler(()=>fn(...args));






var $bfbf576c7ce96576$export$2e2bcd8739ae039 = (0, $31ef68bc78b43ea6$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $31ef68bc78b43ea6$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $31ef68bc78b43ea6$export$2e2bcd8739ae039).origin), (0, $31ef68bc78b43ea6$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $31ef68bc78b43ea6$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $f25d63d13e75eaf1$export$2e2bcd8739ae039 = (0, $31ef68bc78b43ea6$export$2e2bcd8739ae039).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isString(path)) cookie.push(`path=${path}`);
        if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        // Match name=value by splitting on the semicolon separator instead of building a
        // RegExp from `name` — interpolating an unescaped string into a RegExp would let
        // metacharacters (e.g. `.+?` in an attacker-influenced cookie name) cause ReDoS or
        // match the wrong cookie. Browsers may serialize cookie pairs as either ";" or
        // "; ", so ignore optional whitespace before each cookie name.
        const cookies = document.cookie.split(';');
        for(let i = 0; i < cookies.length; i++){
            const cookie = cookies[i].replace(/^\s+/, '');
            const eq = cookie.indexOf('=');
            if (eq !== -1 && cookie.slice(0, eq) === name) try {
                return decodeURIComponent(cookie.slice(eq + 1));
            } catch (e) {
                return cookie.slice(eq + 1);
            }
        }
        return null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write () {},
    read () {
        return null;
    },
    remove () {}
};



'use strict';
function $3a093dc16c2da479$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $8efadabe53d13fdb$export$2e2bcd8739ae039(baseURL, relativeURL) {
    if (!relativeURL) return baseURL;
    let end = baseURL.length;
    while(end > 0 && baseURL.charCodeAt(end - 1) === 47)end--;
    return baseURL.slice(0, end) + '/' + relativeURL.replace(/^\/+/, '');
}



'use strict';
const $c1d890a0664bfdaf$var$malformedHttpProtocol = /^https?:(?!\/\/)/i;
// Redact the parts of a URL that can carry secrets before it is embedded in an
// error message. AxiosError.toJSON() serializes `message` verbatim and errors
// are commonly logged, while the opt-in `config.redact` model only cleans
// config keys — it cannot reach the message. Redact only the genuinely
// sensitive substrings — userinfo (credentials), query parameter values and
// fragment contents — with the same REDACTED marker the config redaction uses,
// while keeping the scheme, host, path and parameter names so the offending
// request stays accurately identifiable.
function $c1d890a0664bfdaf$var$redactFragment(fragment) {
    if (!fragment) return fragment;
    return fragment.replace(/(^|&)([^=&]*=)?[^&]+/g, (match, separator, parameterName = '')=>{
        return `${separator}${parameterName}${0, $914052063804fa69$export$6acd2efa8ac62a1b}`;
    });
}
function $c1d890a0664bfdaf$var$redactSensitiveURLParts(url) {
    const redactedURL = url.replace(/^(https?:\/{0,2})[^/?#]*@/i, `$1${(0, $914052063804fa69$export$6acd2efa8ac62a1b)}@`);
    const fragmentIndex = redactedURL.indexOf('#');
    const urlWithoutFragment = fragmentIndex === -1 ? redactedURL : redactedURL.slice(0, fragmentIndex);
    const redactedURLWithoutFragment = urlWithoutFragment.replace(/([?&][^=&#]*=)[^&#]*/g, `$1${(0, $914052063804fa69$export$6acd2efa8ac62a1b)}`);
    if (fragmentIndex === -1) return redactedURLWithoutFragment;
    return `${redactedURLWithoutFragment}#${$c1d890a0664bfdaf$var$redactFragment(redactedURL.slice(fragmentIndex + 1))}`;
}
function $c1d890a0664bfdaf$var$assertValidHttpProtocolURL(url, config) {
    if (typeof url === 'string') {
        const normalizedURL = (0, $ed38d5ef9b811df0$export$2e2bcd8739ae039)(url);
        if ($c1d890a0664bfdaf$var$malformedHttpProtocol.test(normalizedURL)) throw new (0, $914052063804fa69$export$2e2bcd8739ae039)(`Invalid URL ${JSON.stringify($c1d890a0664bfdaf$var$redactSensitiveURLParts(normalizedURL))}: missing "//" after protocol`, (0, $914052063804fa69$export$2e2bcd8739ae039).ERR_INVALID_URL, config);
    }
}
function $c1d890a0664bfdaf$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls, config) {
    $c1d890a0664bfdaf$var$assertValidHttpProtocolURL(requestedURL, config);
    let isRelativeUrl = !(0, $3a093dc16c2da479$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) {
        $c1d890a0664bfdaf$var$assertValidHttpProtocolURL(baseURL, config);
        return (0, $8efadabe53d13fdb$export$2e2bcd8739ae039)(baseURL, requestedURL);
    }
    return requestedURL;
}




'use strict';
const $7a64e9a12bd58681$var$headersToObject = (thing)=>thing instanceof (0, $6450fcf4641e8103$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
const $7a64e9a12bd58681$var$ownEnumerableKeys = (thing)=>{
    if (Object.getOwnPropertySymbols && Object.getOwnPropertyDescriptor) return Object.keys(thing).concat(Object.getOwnPropertySymbols(thing).filter((symbol)=>Object.getOwnPropertyDescriptor(thing, symbol).enumerable));
    return Object.keys(thing);
};
function $7a64e9a12bd58681$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config1 = config1 || {};
    config2 = config2 || {};
    // Use a null-prototype object so that downstream reads such as `config.auth`
    // or `config.baseURL` cannot inherit polluted values from Object.prototype.
    // `hasOwnProperty` is restored as a non-enumerable own slot to preserve
    // ergonomics for user code that relies on it.
    const config = Object.create(null);
    Object.defineProperty(config, 'hasOwnProperty', {
        // Null-proto descriptor so a polluted Object.prototype.get cannot turn
        // this data descriptor into an accessor descriptor on the way in.
        __proto__: null,
        value: Object.prototype.hasOwnProperty,
        enumerable: false,
        writable: true,
        configurable: true
    });
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isPlainObject(target) && (0, $37e88c15ceea9261$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $37e88c15ceea9261$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $37e88c15ceea9261$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $37e88c15ceea9261$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $37e88c15ceea9261$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $37e88c15ceea9261$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $37e88c15ceea9261$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $37e88c15ceea9261$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    function getMergedTransitionalOption(prop) {
        const transitional2 = (0, $37e88c15ceea9261$export$2e2bcd8739ae039).hasOwnProp(config2, 'transitional') ? config2.transitional : undefined;
        if (!(0, $37e88c15ceea9261$export$2e2bcd8739ae039).isUndefined(transitional2)) {
            if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isPlainObject(transitional2)) {
                if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).hasOwnProp(transitional2, prop)) return transitional2[prop];
            } else return undefined;
        }
        const transitional1 = (0, $37e88c15ceea9261$export$2e2bcd8739ae039).hasOwnProp(config1, 'transitional') ? config1.transitional : undefined;
        if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isPlainObject(transitional1) && (0, $37e88c15ceea9261$export$2e2bcd8739ae039).hasOwnProp(transitional1, prop)) return transitional1[prop];
        return undefined;
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).hasOwnProp(config2, prop)) return getMergedValue(a, b);
        else if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).hasOwnProp(config1, prop)) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutErrorMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        allowedSocketPaths: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($7a64e9a12bd58681$var$headersToObject(a), $7a64e9a12bd58681$var$headersToObject(b), prop, true)
    };
    (0, $37e88c15ceea9261$export$2e2bcd8739ae039).forEach($7a64e9a12bd58681$var$ownEnumerableKeys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        const merge = (0, $37e88c15ceea9261$export$2e2bcd8739ae039).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const a = (0, $37e88c15ceea9261$export$2e2bcd8739ae039).hasOwnProp(config1, prop) ? config1[prop] : undefined;
        const b = (0, $37e88c15ceea9261$export$2e2bcd8739ae039).hasOwnProp(config2, prop) ? config2[prop] : undefined;
        const configValue = merge(a, b, prop);
        (0, $37e88c15ceea9261$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).hasOwnProp(config2, 'validateStatus') && (0, $37e88c15ceea9261$export$2e2bcd8739ae039).isUndefined(config2.validateStatus) && getMergedTransitionalOption('validateStatusUndefinedResolves') === false) {
        if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).hasOwnProp(config1, 'validateStatus')) config.validateStatus = getMergedValue(undefined, config1.validateStatus);
        else delete config.validateStatus;
    }
    return config;
}



'use strict';
const $8418bb05bb004a59$var$FORM_DATA_CONTENT_HEADERS = [
    'content-type',
    'content-length'
];
function $8418bb05bb004a59$export$2e2bcd8739ae039(headers, formHeaders, policy) {
    if (policy !== 'content-only') {
        headers.set(formHeaders);
        return;
    }
    Object.entries(formHeaders || {}).forEach(([key, val])=>{
        if ($8418bb05bb004a59$var$FORM_DATA_CONTENT_HEADERS.includes(key.toLowerCase())) headers.set(key, val);
    });
}



/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $e259b59714380b01$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
function $e259b59714380b01$var$resolveConfig(config) {
    const newConfig = (0, $7a64e9a12bd58681$export$2e2bcd8739ae039)({}, config);
    // Read only own properties to prevent prototype pollution gadgets
    // (e.g. Object.prototype.baseURL = 'https://evil.com').
    const own = (key)=>(0, $37e88c15ceea9261$export$2e2bcd8739ae039).hasOwnProp(newConfig, key) ? newConfig[key] : undefined;
    const data = own('data');
    let withXSRFToken = own('withXSRFToken');
    const xsrfHeaderName = own('xsrfHeaderName');
    const xsrfCookieName = own('xsrfCookieName');
    let headers = own('headers');
    const auth = own('auth');
    const baseURL = own('baseURL');
    const allowAbsoluteUrls = own('allowAbsoluteUrls');
    const url = own('url');
    newConfig.headers = headers = (0, $6450fcf4641e8103$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $cd87bd104fdb775a$export$2e2bcd8739ae039)((0, $c1d890a0664bfdaf$export$2e2bcd8739ae039)(baseURL, url, allowAbsoluteUrls, newConfig), own('params'), own('paramsSerializer'));
    // HTTP basic authentication
    if (auth) {
        const username = (0, $37e88c15ceea9261$export$2e2bcd8739ae039).getSafeProp(auth, 'username') || '';
        const password = (0, $37e88c15ceea9261$export$2e2bcd8739ae039).getSafeProp(auth, 'password') || '';
        try {
            headers.set('Authorization', 'Basic ' + btoa(username + ':' + (password ? $e259b59714380b01$var$encodeUTF8(password) : '')));
        } catch (e) {
            throw (0, $914052063804fa69$export$2e2bcd8739ae039).from(e, (0, $914052063804fa69$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE, config);
        }
    }
    if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isFormData(data)) {
        const getHeaders = (0, $37e88c15ceea9261$export$2e2bcd8739ae039).getSafeProp(data, 'getHeaders');
        if ((0, $31ef68bc78b43ea6$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $31ef68bc78b43ea6$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv || (0, $37e88c15ceea9261$export$2e2bcd8739ae039).isReactNative(data)) headers.setContentType(undefined); // browser/web worker/RN handles it
        else if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isFunction(getHeaders)) // Node.js FormData (like form-data package)
        (0, $8418bb05bb004a59$export$2e2bcd8739ae039)(headers, getHeaders.call(data), own('formDataHeaderPolicy'));
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $31ef68bc78b43ea6$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isFunction(withXSRFToken)) withXSRFToken = withXSRFToken(newConfig);
        // Strict boolean check — prevents proto-pollution gadgets (e.g. Object.prototype.withXSRFToken = 1)
        // and misconfigurations (e.g. "false") from short-circuiting the same-origin check and leaking
        // the XSRF token cross-origin.
        const shouldSendXSRF = withXSRFToken === true || withXSRFToken == null && (0, $bfbf576c7ce96576$export$2e2bcd8739ae039)(newConfig.url);
        if (shouldSendXSRF) {
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $f25d63d13e75eaf1$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
}
var $e259b59714380b01$export$2e2bcd8739ae039 = $e259b59714380b01$var$resolveConfig;



const $b2cf3e2bae7d8390$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $b2cf3e2bae7d8390$export$2e2bcd8739ae039 = $b2cf3e2bae7d8390$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $e259b59714380b01$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $6450fcf4641e8103$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload, flushDownloadWithEvent;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend(event) {
            if (!request) return;
            // Status 0 means no response was received, which onerror and onabort normally
            // reject before this runs. Firefox 152 fires only readystatechange and loadend for
            // navigation-canceled requests (https://bugzilla.mozilla.org/show_bug.cgi?id=1505389),
            // leaving settle() to resolve them as an empty success. ECONNABORTED is the error
            // onabort raised on Firefox 151. Reads over file:, which some environments report as
            // status 0 on success, are excluded by the request URL's scheme after browser-style
            // preprocessing, by the page origin's scheme for relative URLs (which inherit it), or
            // by responseURL where implemented.
            if (request.status === 0 && ((0, $80399759ab16dd33$export$2e2bcd8739ae039)((0, $ed38d5ef9b811df0$export$2e2bcd8739ae039)(_config.url)) || (0, $80399759ab16dd33$export$2e2bcd8739ae039)((0, $31ef68bc78b43ea6$export$2e2bcd8739ae039).origin)) !== 'file' && !(request.responseURL && request.responseURL.startsWith('file:'))) {
                reject(new (0, $914052063804fa69$export$2e2bcd8739ae039)('Request aborted', (0, $914052063804fa69$export$2e2bcd8739ae039).ECONNABORTED, config, request));
                done();
                // Clean up request
                request = null;
                return;
            }
            // When loadend is still dispatching, flushing with it gives progress
            // listeners a final delivery whose event has a live target. The legacy
            // ready-state fallback has no event, so replay its pending progress.
            // A throwing listener must not block settlement; rethrow asynchronously,
            // matching how listener errors surface on the throttle timer path.
            try {
                if (event) flushDownloadWithEvent && flushDownloadWithEvent(event);
                else flushDownload && flushDownload();
            } catch (err) {
                setTimeout(()=>{
                    throw err;
                });
            }
            // A final progress callback can cancel the request synchronously.
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $6450fcf4641e8103$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $fd7658c72cb668a1$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.startsWith('file:'))) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $914052063804fa69$export$2e2bcd8739ae039)('Request aborted', (0, $914052063804fa69$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $914052063804fa69$export$2e2bcd8739ae039)(msg, (0, $914052063804fa69$export$2e2bcd8739ae039).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            done();
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $8580892c96adaf9d$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $914052063804fa69$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $914052063804fa69$export$2e2bcd8739ae039).ETIMEDOUT : (0, $914052063804fa69$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $37e88c15ceea9261$export$2e2bcd8739ae039).forEach((0, $e80639e44d32ecd1$export$c30c72bb7e677d54)(requestHeaders), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $37e88c15ceea9261$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload, flushDownloadWithEvent] = (0, $c9a0507500d3dd40$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $c9a0507500d3dd40$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $1a943e5048e7ffb9$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                done();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $80399759ab16dd33$export$2e2bcd8739ae039)(_config.url);
        if (protocol && !(0, $31ef68bc78b43ea6$export$2e2bcd8739ae039).protocols.includes(protocol)) {
            reject(new (0, $914052063804fa69$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $914052063804fa69$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            done();
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $a6e18b49ae7de66c$var$composeSignals = (signals, timeout)=>{
    signals = signals ? signals.filter(Boolean) : [];
    if (!timeout && !signals.length) return;
    const controller = new AbortController();
    let aborted = false;
    const onabort = function(reason) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            const err = reason instanceof Error ? reason : this.reason;
            controller.abort(err instanceof (0, $914052063804fa69$export$2e2bcd8739ae039) ? err : new (0, $1a943e5048e7ffb9$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
        }
    };
    let timer = timeout && setTimeout(()=>{
        timer = null;
        onabort(new (0, $914052063804fa69$export$2e2bcd8739ae039)(`timeout of ${timeout}ms exceeded`, (0, $914052063804fa69$export$2e2bcd8739ae039).ETIMEDOUT));
    }, timeout);
    const unsubscribe = ()=>{
        if (!signals) return;
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach((signal)=>{
            signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
        });
        signals = null;
    };
    signals.forEach((signal)=>{
        if (aborted) return;
        if (signal.aborted) {
            onabort.call(signal);
            return;
        }
        signal.addEventListener('abort', onabort, {
            once: true
        });
    });
    const { signal: signal } = controller;
    signal.unsubscribe = ()=>(0, $37e88c15ceea9261$export$2e2bcd8739ae039).asap(unsubscribe);
    return signal;
};
var $a6e18b49ae7de66c$export$2e2bcd8739ae039 = $a6e18b49ae7de66c$var$composeSignals;


const $995970ca7f581076$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $995970ca7f581076$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $995970ca7f581076$var$readStream(iterable))yield* $995970ca7f581076$export$71b051935044bd5d(chunk, chunkSize);
};
const $995970ca7f581076$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $995970ca7f581076$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $995970ca7f581076$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






/**
 * Estimate data: URL byte lengths *without* allocating large buffers.
 * - Fetch percent-decodes a base64 body before decoding it.
 * - Node's Buffer.from(body, 'base64') sizes its backing allocation from the
 *   raw body, including ignored characters and content after padding.
 * - Non-base64 data is percent-decoded and then encoded as UTF-8.
 */ const $bcff7b1079a23354$var$isHexDigit = (charCode)=>charCode >= 48 && charCode <= 57 || charCode >= 65 && charCode <= 70 || charCode >= 97 && charCode <= 102;
const $bcff7b1079a23354$var$isPercentEncodedByte = (str, i, len)=>i + 2 < len && $bcff7b1079a23354$var$isHexDigit(str.charCodeAt(i + 1)) && $bcff7b1079a23354$var$isHexDigit(str.charCodeAt(i + 2));
const $bcff7b1079a23354$var$hexValue = (charCode)=>charCode <= 57 ? charCode - 48 : (charCode & 0xdf) - 55;
const $bcff7b1079a23354$var$isBase64Char = (charCode)=>charCode >= 65 && charCode <= 90 || // A-Z
    charCode >= 97 && charCode <= 122 || // a-z
    charCode >= 48 && charCode <= 57 || // 0-9
    charCode === 43 || // +
    charCode === 47 || // /
    charCode === 45 || // - (base64url)
    charCode === 95; // _ (base64url)
const $bcff7b1079a23354$var$isBase64Whitespace = (charCode)=>charCode === 9 || charCode === 10 || charCode === 12 || charCode === 13 || charCode === 32;
const $bcff7b1079a23354$var$base64Bytes = (significant)=>{
    const groups = Math.floor(significant / 4);
    const remainder = significant % 4;
    return groups * 3 + (remainder === 2 ? 1 : remainder === 3 ? 2 : 0);
};
// Buffer.byteLength(body, 'base64') uses the raw string length as an allocation
// upper bound even when Buffer.from later ignores characters or stops at '='.
const $bcff7b1079a23354$var$estimateBase64BufferAllocation = (body)=>{
    const len = body.length;
    let padding = 0;
    if (len > 0 && body.charCodeAt(len - 1) === 61 /* '=' */ ) {
        padding++;
        if (len > 1 && body.charCodeAt(len - 2) === 61 /* '=' */ ) padding++;
    }
    return Math.floor((len - padding) * 3 / 4);
};
const $bcff7b1079a23354$var$estimatePercentDecodedBase64Bytes = (body)=>{
    const len = body.length;
    let significant = 0;
    let padding = 0;
    let invalid = false;
    for(let i = 0; i < len; i++){
        let code = body.charCodeAt(i);
        if (code === 37 /* '%' */  && $bcff7b1079a23354$var$isPercentEncodedByte(body, i, len)) {
            code = $bcff7b1079a23354$var$hexValue(body.charCodeAt(i + 1)) * 16 + $bcff7b1079a23354$var$hexValue(body.charCodeAt(i + 2));
            i += 2;
        }
        if ($bcff7b1079a23354$var$isBase64Whitespace(code)) continue;
        if (code === 61 /* '=' */ ) {
            padding++;
            continue;
        }
        if (!$bcff7b1079a23354$var$isBase64Char(code) || padding > 0) {
            invalid = true;
            continue;
        }
        significant++;
    }
    // Fetch rejects malformed forgiving-base64 input. Returning the raw-size
    // allocation bound keeps that invalid input from becoming a pre-check bypass.
    if (invalid || padding > 2 || padding > 0 && (significant + padding) % 4 !== 0 || significant % 4 === 1) return $bcff7b1079a23354$var$estimateBase64BufferAllocation(body);
    return $bcff7b1079a23354$var$base64Bytes(significant);
};
const $bcff7b1079a23354$var$estimateDataURLBytes = (url, estimateBase64)=>{
    if (!url || typeof url !== 'string') return 0;
    if (!url.startsWith('data:')) return 0;
    const comma = url.indexOf(',');
    if (comma < 0) return 0;
    const meta = url.slice(5, comma);
    const body = url.slice(comma + 1);
    const isBase64 = /;base64/i.test(meta);
    if (isBase64) return estimateBase64(body);
    // Compute UTF-8 byte length directly from UTF-16 code units without allocating
    // a byte buffer (TextEncoder.encode would defeat the DoS guard on large bodies).
    // Valid %XX triplets count as one decoded byte; this matches the bytes that
    // decodeURIComponent(body) would produce before Buffer re-encodes the string.
    let bytes = 0;
    for(let i = 0, len = body.length; i < len; i++){
        const c = body.charCodeAt(i);
        if (c === 37 /* '%' */  && $bcff7b1079a23354$var$isPercentEncodedByte(body, i, len)) {
            bytes += 1;
            i += 2;
        } else if (c < 0x80) bytes += 1;
        else if (c < 0x800) bytes += 2;
        else if (c >= 0xd800 && c <= 0xdbff && i + 1 < len) {
            const next = body.charCodeAt(i + 1);
            if (next >= 0xdc00 && next <= 0xdfff) {
                bytes += 4;
                i++;
            } else bytes += 3;
        } else bytes += 3;
    }
    return bytes;
};
function $bcff7b1079a23354$export$2e2bcd8739ae039(url) {
    // Fetch removes URL fragments before processing a data: URL.
    const fragmentIndex = typeof url === 'string' ? url.indexOf('#') : -1;
    return $bcff7b1079a23354$var$estimateDataURLBytes(fragmentIndex === -1 ? url : url.slice(0, fragmentIndex), $bcff7b1079a23354$var$estimatePercentDecodedBase64Bytes);
}
function $bcff7b1079a23354$export$1f39e64b554a246f(url) {
    return $bcff7b1079a23354$var$estimateDataURLBytes(url, $bcff7b1079a23354$var$estimateBase64BufferAllocation);
}


const $0b05d13853352663$export$a4ad2735b021c132 = "1.20.0";



const $cb2e05a01fc1ac94$var$DEFAULT_CHUNK_SIZE = 65536;
const $cb2e05a01fc1ac94$var$DEFAULT_REQUEST_OPTIONS = {
    cache: 'default',
    redirect: 'follow',
    referrer: 'about:client',
    referrerPolicy: '',
    mode: 'cors',
    integrity: '',
    keepalive: false,
    priority: 'auto',
    window: null
};
const { isFunction: $cb2e05a01fc1ac94$var$isFunction } = (0, $37e88c15ceea9261$export$2e2bcd8739ae039);
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $cb2e05a01fc1ac94$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
// Node's WHATWG URL parser returns `username` and `password` percent-encoded.
// Decode before composing the `auth` option so credentials such as
// `my%40email.com:pass` are sent as `my@email.com:pass`. Falls back to the
// original value for malformed input so a bad encoding never throws.
const $cb2e05a01fc1ac94$var$decodeURIComponentSafe = (value)=>{
    if (!(0, $37e88c15ceea9261$export$2e2bcd8739ae039).isString(value)) return value;
    try {
        return decodeURIComponent(value);
    } catch (error) {
        return value;
    }
};
const $cb2e05a01fc1ac94$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $cb2e05a01fc1ac94$var$maybeWithAuthCredentials = (url)=>{
    const protocolIndex = url.indexOf('://');
    let urlToCheck = url;
    if (protocolIndex !== -1) urlToCheck = urlToCheck.slice(protocolIndex + 3);
    return urlToCheck.includes('@') || urlToCheck.includes(':');
};
const $cb2e05a01fc1ac94$var$factory = (env)=>{
    const globalObject = (0, $37e88c15ceea9261$export$2e2bcd8739ae039).global !== undefined && (0, $37e88c15ceea9261$export$2e2bcd8739ae039).global !== null ? (0, $37e88c15ceea9261$export$2e2bcd8739ae039).global : globalThis;
    const { ReadableStream: ReadableStream, TextEncoder: TextEncoder } = globalObject;
    env = (0, $37e88c15ceea9261$export$2e2bcd8739ae039).merge.call({
        skipUndefined: true
    }, {
        Request: globalObject.Request,
        Response: globalObject.Response
    }, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $cb2e05a01fc1ac94$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $cb2e05a01fc1ac94$var$isFunction(Request);
    const isResponseSupported = $cb2e05a01fc1ac94$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $cb2e05a01fc1ac94$var$isFunction(ReadableStream);
    const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $cb2e05a01fc1ac94$var$test(()=>{
        let duplexAccessed = false;
        const request = new Request((0, $31ef68bc78b43ea6$export$2e2bcd8739ae039).origin, {
            body: new ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        });
        const hasContentType = request.headers.has('Content-Type');
        if (request.body != null) request.body.cancel();
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $cb2e05a01fc1ac94$var$test(()=>(0, $37e88c15ceea9261$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $914052063804fa69$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $914052063804fa69$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isBlob(body)) return body.size;
        if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
            const _request = new Request((0, $31ef68bc78b43ea6$export$2e2bcd8739ae039).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $37e88c15ceea9261$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
        if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
        if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $37e88c15ceea9261$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions, maxContentLength: maxContentLength, maxBodyLength: maxBodyLength, maxRedirects: maxRedirects } = (0, $e259b59714380b01$export$2e2bcd8739ae039)(config);
        const hasMaxContentLength = (0, $37e88c15ceea9261$export$2e2bcd8739ae039).isNumber(maxContentLength) && maxContentLength > -1;
        const hasMaxBodyLength = (0, $37e88c15ceea9261$export$2e2bcd8739ae039).isNumber(maxBodyLength) && maxBodyLength > -1;
        const own = (key)=>(0, $37e88c15ceea9261$export$2e2bcd8739ae039).hasOwnProp(config, key) ? config[key] : undefined;
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $a6e18b49ae7de66c$export$2e2bcd8739ae039)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        // AxiosError we raise while the request body is being streamed. Captured
        // by identity so the catch block can surface it directly, regardless of
        // how the runtime wraps the resulting fetch rejection (undici exposes it
        // as `err.cause`; some browsers drop the original error entirely).
        let pendingBodyError = null;
        const maxBodyLengthError = ()=>new (0, $914052063804fa69$export$2e2bcd8739ae039)('Request body larger than maxBodyLength limit', (0, $914052063804fa69$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config, request);
        try {
            // HTTP basic authentication
            let auth = undefined;
            const configAuth = own('auth');
            if (configAuth) {
                const username = (0, $37e88c15ceea9261$export$2e2bcd8739ae039).getSafeProp(configAuth, 'username') || '';
                const password = (0, $37e88c15ceea9261$export$2e2bcd8739ae039).getSafeProp(configAuth, 'password') || '';
                auth = {
                    username: username,
                    password: password
                };
            }
            if ($cb2e05a01fc1ac94$var$maybeWithAuthCredentials(url)) {
                const parsedURL = new URL(url, (0, $31ef68bc78b43ea6$export$2e2bcd8739ae039).origin);
                if (!auth && (parsedURL.username || parsedURL.password)) {
                    const urlUsername = $cb2e05a01fc1ac94$var$decodeURIComponentSafe(parsedURL.username);
                    const urlPassword = $cb2e05a01fc1ac94$var$decodeURIComponentSafe(parsedURL.password);
                    auth = {
                        username: urlUsername,
                        password: urlPassword
                    };
                }
                if (parsedURL.username || parsedURL.password) {
                    parsedURL.username = '';
                    parsedURL.password = '';
                    url = parsedURL.href;
                }
            }
            if (auth) {
                headers.delete('authorization');
                headers.set('Authorization', 'Basic ' + btoa($cb2e05a01fc1ac94$var$encodeUTF8((auth.username || '') + ':' + (auth.password || ''))));
            }
            // Enforce maxContentLength for data: URLs up-front so we never materialize
            // an oversized payload. The HTTP adapter applies the same check (see http.js
            // "if (protocol === 'data:')" branch).
            if (hasMaxContentLength && typeof url === 'string' && url.startsWith('data:')) {
                const estimated = (0, $bcff7b1079a23354$export$2e2bcd8739ae039)(url);
                if (estimated > maxContentLength) throw new (0, $914052063804fa69$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $914052063804fa69$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            // Enforce maxBodyLength against known-size bodies before dispatch using
            // the body's *actual* size — never a caller-declared Content-Length,
            // which could under-report to slip an oversized body past the check.
            // Unknown-size streams return undefined here and are counted per-chunk
            // below as fetch consumes them.
            if (hasMaxBodyLength && method !== 'get' && method !== 'head') {
                const outboundLength = await getBodyLength(data);
                if (typeof outboundLength === 'number' && isFinite(outboundLength)) {
                    requestContentLength = outboundLength;
                    if (outboundLength > maxBodyLength) throw maxBodyLengthError();
                }
            }
            // A streamed body under maxBodyLength must be counted as fetch consumes
            // it; its size is never trusted from a caller-declared Content-Length.
            const mustEnforceStreamBody = hasMaxBodyLength && ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isReadableStream(data) || (0, $37e88c15ceea9261$export$2e2bcd8739ae039).isStream(data));
            const trackRequestStream = (stream, onProgress, flush)=>(0, $995970ca7f581076$export$b0119225647bd83)(stream, $cb2e05a01fc1ac94$var$DEFAULT_CHUNK_SIZE, (loadedBytes)=>{
                    if (hasMaxBodyLength && loadedBytes > maxBodyLength) throw pendingBodyError = maxBodyLengthError();
                    onProgress && onProgress(loadedBytes);
                }, flush);
            if (supportsRequestStream && method !== 'get' && method !== 'head' && (onUploadProgress || mustEnforceStreamBody)) {
                requestContentLength = requestContentLength == null ? await resolveBodyLength(headers, data) : requestContentLength;
                // A declared length of 0 is only trusted to skip the wrap when we are
                // not enforcing a stream limit (which must not rely on that header).
                if (requestContentLength !== 0 || mustEnforceStreamBody) {
                    let _request = new Request(url, {
                        method: 'POST',
                        body: data,
                        duplex: 'half'
                    });
                    let contentTypeHeader;
                    if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                    if (_request.body) {
                        const [onProgress, flush] = onUploadProgress && (0, $c9a0507500d3dd40$export$d9fadd12586c18d6)(requestContentLength, (0, $c9a0507500d3dd40$export$c1b28109d46c3592)((0, $c9a0507500d3dd40$export$5d35863c355a22a9)(onUploadProgress))) || [];
                        data = trackRequestStream(_request.body, onProgress, flush);
                    }
                }
            } else if (mustEnforceStreamBody && !isRequestSupported && isReadableStreamSupported && method !== 'get' && method !== 'head') data = trackRequestStream(data);
            else if (mustEnforceStreamBody && isRequestSupported && !supportsRequestStream && method !== 'get' && method !== 'head') throw new (0, $914052063804fa69$export$2e2bcd8739ae039)('Stream request bodies are not supported by the current fetch implementation', (0, $914052063804fa69$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config, request);
            if (!(0, $37e88c15ceea9261$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
            // If data is FormData and Content-Type is multipart/form-data without boundary,
            // delete it so fetch can set it correctly with the boundary
            if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isFormData(data)) {
                const contentType = headers.getContentType();
                if (contentType && /^multipart\/form-data/i.test(contentType) && !/boundary=/i.test(contentType)) headers.delete('content-type');
            }
            // Set User-Agent header if not already set (fetch defaults to 'node' in Node.js)
            headers.set('User-Agent', 'axios/' + (0, $0b05d13853352663$export$a4ad2735b021c132), false);
            const safeFetchOptions = fetchOptions == null ? fetchOptions : Object.assign(Object.create(null), fetchOptions);
            if (safeFetchOptions) {
                // These options are owned by Axios and are already reflected in the
                // resolved Request passed to fetch.
                delete safeFetchOptions.body;
                delete safeFetchOptions.headers;
                delete safeFetchOptions.method;
                delete safeFetchOptions.signal;
                delete safeFetchOptions.duplex;
                delete safeFetchOptions.credentials;
            }
            const resolvedOptions = Object.assign(Object.create(null), safeFetchOptions, {
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: (0, $e80639e44d32ecd1$export$c30c72bb7e677d54)(headers.normalize()),
                body: data,
                duplex: 'half',
                credentials: isCredentialsSupported ? withCredentials : undefined
            });
            if (isRequestSupported) {
                (0, $37e88c15ceea9261$export$2e2bcd8739ae039).forEach($cb2e05a01fc1ac94$var$DEFAULT_REQUEST_OPTIONS, (value, key)=>{
                    if (resolvedOptions[key] === undefined) resolvedOptions[key] = value;
                });
                if (resolvedOptions.signal === undefined) resolvedOptions.signal = null;
                if (resolvedOptions.body === undefined) resolvedOptions.body = null;
            }
            if (maxRedirects === 0) {
                resolvedOptions.redirect = 'manual';
                if (safeFetchOptions) safeFetchOptions.redirect = 'manual';
            }
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, safeFetchOptions) : _fetch(url, resolvedOptions));
            const responseHeaders = (0, $6450fcf4641e8103$export$2e2bcd8739ae039).from(response.headers);
            // Cheap pre-check: if the server honestly declares a content-length that
            // already exceeds the cap, reject before we start streaming.
            if (hasMaxContentLength) {
                const declaredLength = (0, $37e88c15ceea9261$export$2e2bcd8739ae039).toFiniteNumber(responseHeaders.getContentLength());
                if (declaredLength != null && declaredLength > maxContentLength) throw new (0, $914052063804fa69$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $914052063804fa69$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && response.body && (onDownloadProgress || hasMaxContentLength || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $37e88c15ceea9261$export$2e2bcd8739ae039).toFiniteNumber(responseHeaders.getContentLength());
                const [onProgress, flush] = onDownloadProgress && (0, $c9a0507500d3dd40$export$d9fadd12586c18d6)(responseContentLength, (0, $c9a0507500d3dd40$export$c1b28109d46c3592)((0, $c9a0507500d3dd40$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
                let bytesRead = 0;
                const onChunkProgress = (loadedBytes)=>{
                    if (hasMaxContentLength) {
                        bytesRead = loadedBytes;
                        if (bytesRead > maxContentLength) throw new (0, $914052063804fa69$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $914052063804fa69$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
                    }
                    onProgress && onProgress(loadedBytes);
                };
                response = new Response((0, $995970ca7f581076$export$b0119225647bd83)(response.body, $cb2e05a01fc1ac94$var$DEFAULT_CHUNK_SIZE, onChunkProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $37e88c15ceea9261$export$2e2bcd8739ae039).findKey(resolvers, responseType) || 'text'](response, config);
            // Fallback enforcement for environments without ReadableStream support
            // (legacy runtimes). Detect materialized size from typed output; skip
            // streams/Response passthrough since the user will read those themselves.
            if (hasMaxContentLength && !supportsResponseStream && !isStreamResponse) {
                let materializedSize;
                if (responseData != null) {
                    if (typeof responseData.byteLength === 'number') materializedSize = responseData.byteLength;
                    else if (typeof responseData.size === 'number') materializedSize = responseData.size;
                    else if (typeof responseData === 'string') materializedSize = typeof TextEncoder === 'function' ? new TextEncoder().encode(responseData).byteLength : responseData.length;
                }
                if (typeof materializedSize === 'number' && materializedSize > maxContentLength) throw new (0, $914052063804fa69$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $914052063804fa69$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $fd7658c72cb668a1$export$2e2bcd8739ae039)(resolve, reject, {
                    data: responseData,
                    headers: (0, $6450fcf4641e8103$export$2e2bcd8739ae039).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            // Safari can surface fetch aborts as a DOMException-like object whose
            // branded getters throw. Prefer our composed signal reason before reading
            // the caught error, preserving timeout vs cancellation semantics.
            if (composedSignal && composedSignal.aborted && composedSignal.reason instanceof (0, $914052063804fa69$export$2e2bcd8739ae039)) {
                const canceledError = composedSignal.reason;
                canceledError.config = config;
                request && (canceledError.request = request);
                if (err !== canceledError) // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(canceledError, 'cause', {
                    __proto__: null,
                    value: err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw canceledError;
            }
            // Surface a maxBodyLength violation we raised while the request body was
            // being streamed. Matching by identity (rather than reading
            // `err.cause.isAxiosError`) keeps the error deterministic across runtimes
            // and avoids both prototype-pollution reads and mis-attributing a foreign
            // AxiosError that merely happened to land in `err.cause`.
            if (pendingBodyError) {
                request && !pendingBodyError.request && (pendingBodyError.request = request);
                throw pendingBodyError;
            }
            // Re-throw AxiosErrors we raised synchronously (data: URL / content-length
            // pre-checks, response size enforcement) without re-wrapping them.
            if (err instanceof (0, $914052063804fa69$export$2e2bcd8739ae039)) {
                request && !err.request && (err.request = request);
                throw err;
            }
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) {
                const networkError = new (0, $914052063804fa69$export$2e2bcd8739ae039)('Network Error', (0, $914052063804fa69$export$2e2bcd8739ae039).ERR_NETWORK, config, request, err && err.response);
                // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(networkError, 'cause', {
                    __proto__: null,
                    value: err.cause || err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw networkError;
            }
            throw (0, $914052063804fa69$export$2e2bcd8739ae039).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $cb2e05a01fc1ac94$var$seedCache = new Map();
const $cb2e05a01fc1ac94$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $cb2e05a01fc1ac94$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $cb2e05a01fc1ac94$var$factory(env));
        map = target;
    }
    return target;
};
const $cb2e05a01fc1ac94$var$adapter = $cb2e05a01fc1ac94$export$3105c6651375d4fa();
var $cb2e05a01fc1ac94$export$2e2bcd8739ae039 = $cb2e05a01fc1ac94$var$adapter;



/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const $6744717d9856c505$var$knownAdapters = {
    http: (0, $b0df307601dbab4c$export$2e2bcd8739ae039),
    xhr: (0, $b2cf3e2bae7d8390$export$2e2bcd8739ae039),
    fetch: {
        get: $cb2e05a01fc1ac94$export$3105c6651375d4fa
    }
};
// Assign adapter names for easier debugging and identification
(0, $37e88c15ceea9261$export$2e2bcd8739ae039).forEach($6744717d9856c505$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            // Null-proto descriptors so a polluted Object.prototype.get cannot turn
            // these data descriptors into accessor descriptors on the way in.
            Object.defineProperty(fn, 'name', {
                __proto__: null,
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            __proto__: null,
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const $6744717d9856c505$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $6744717d9856c505$var$isResolvedHandle = (adapter)=>(0, $37e88c15ceea9261$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $6744717d9856c505$var$getAdapter(adapters, config) {
    adapters = (0, $37e88c15ceea9261$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$6744717d9856c505$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $6744717d9856c505$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $914052063804fa69$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($6744717d9856c505$var$renderReason).join('\n') : ' ' + $6744717d9856c505$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $914052063804fa69$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, (0, $914052063804fa69$export$2e2bcd8739ae039).ERR_NOT_SUPPORT);
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $6744717d9856c505$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $6744717d9856c505$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $6744717d9856c505$var$knownAdapters
};



'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $27bf88165417ad86$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $1a943e5048e7ffb9$export$2e2bcd8739ae039)(null, config);
}
function $27bf88165417ad86$export$2e2bcd8739ae039(_config) {
    // Interceptors may replace the merged config with an ordinary object. Flatten
    // it at the dispatch boundary so shared prototype members cannot become
    // request behavior, while preserving intentional template/class members.
    const config = (0, $37e88c15ceea9261$export$2e2bcd8739ae039).toSafeFlatObject(_config);
    $27bf88165417ad86$var$throwIfCancellationRequested(config);
    config.headers = (0, $6450fcf4641e8103$export$2e2bcd8739ae039).from((0, $37e88c15ceea9261$export$2e2bcd8739ae039).getSafeProp(config, 'headers'));
    // Transform request data
    config.data = (0, $bae8766bee727377$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $6744717d9856c505$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $89e9ad5e98e61be2$export$2e2bcd8739ae039).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $27bf88165417ad86$var$throwIfCancellationRequested(config);
        // Expose the current response on config so that transformResponse can
        // attach it to any AxiosError it throws (e.g. on JSON parse failure).
        // We clean it up afterwards to avoid polluting the config object.
        config.response = response;
        try {
            response.data = (0, $bae8766bee727377$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        } finally{
            delete config.response;
        }
        response.headers = (0, $6450fcf4641e8103$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $4770b47c1119b9a2$export$2e2bcd8739ae039)(reason)) {
            $27bf88165417ad86$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                config.response = reason.response;
                try {
                    reason.response.data = (0, $bae8766bee727377$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                } finally{
                    delete config.response;
                }
                reason.response.headers = (0, $6450fcf4641e8103$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}







'use strict';
const $629cad5aa7caae70$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $629cad5aa7caae70$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $629cad5aa7caae70$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $629cad5aa7caae70$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $0b05d13853352663$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $914052063804fa69$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $914052063804fa69$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$629cad5aa7caae70$var$deprecatedWarnings[opt]) {
            $629cad5aa7caae70$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$629cad5aa7caae70$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $629cad5aa7caae70$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object' || options === null) throw new (0, $914052063804fa69$export$2e2bcd8739ae039)('options must be an object', (0, $914052063804fa69$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        // Use hasOwnProperty so a polluted Object.prototype.<opt> cannot supply
        // a non-function validator and cause a TypeError.
        const validator = Object.prototype.hasOwnProperty.call(schema, opt) ? schema[opt] : undefined;
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $914052063804fa69$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $914052063804fa69$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $914052063804fa69$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $914052063804fa69$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $629cad5aa7caae70$export$2e2bcd8739ae039 = {
    assertOptions: $629cad5aa7caae70$var$assertOptions,
    validators: $629cad5aa7caae70$var$validators
};




'use strict';
const $3e329e59d25c42df$var$validators = (0, $629cad5aa7caae70$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $3e329e59d25c42df$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $4835baaf88872551$export$2e2bcd8739ae039)(),
            response: new (0, $4835baaf88872551$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) try {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                const dummyStack = dummy.stack;
                let stack = '';
                // slice off the Error: ... line
                if (typeof dummyStack === 'string') {
                    const firstNewlineIndex = dummyStack.indexOf('\n');
                    stack = firstNewlineIndex === -1 ? '' : dummyStack.slice(firstNewlineIndex + 1);
                }
                if (!err.stack) err.stack = stack;
                else if (stack) {
                    const firstNewlineIndex = stack.indexOf('\n');
                    const secondNewlineIndex = firstNewlineIndex === -1 ? -1 : stack.indexOf('\n', firstNewlineIndex + 1);
                    const stackWithoutTwoTopLines = secondNewlineIndex === -1 ? '' : stack.slice(secondNewlineIndex + 1);
                    if (!String(err.stack).endsWith(stackWithoutTwoTopLines)) err.stack += '\n' + stack;
                }
            } catch (e) {
            // Ignore failures from custom stack hooks or un-writable stack properties.
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $7a64e9a12bd58681$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $629cad5aa7caae70$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $3e329e59d25c42df$var$validators.transitional($3e329e59d25c42df$var$validators.boolean),
            forcedJSONParsing: $3e329e59d25c42df$var$validators.transitional($3e329e59d25c42df$var$validators.boolean),
            clarifyTimeoutError: $3e329e59d25c42df$var$validators.transitional($3e329e59d25c42df$var$validators.boolean),
            legacyInterceptorReqResOrdering: $3e329e59d25c42df$var$validators.transitional($3e329e59d25c42df$var$validators.boolean),
            advertiseZstdAcceptEncoding: $3e329e59d25c42df$var$validators.transitional($3e329e59d25c42df$var$validators.boolean),
            validateStatusUndefinedResolves: $3e329e59d25c42df$var$validators.transitional($3e329e59d25c42df$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $629cad5aa7caae70$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $3e329e59d25c42df$var$validators.function,
                serialize: $3e329e59d25c42df$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $629cad5aa7caae70$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $3e329e59d25c42df$var$validators.spelling('baseURL'),
            withXsrfToken: $3e329e59d25c42df$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).getSafeProp(config, 'method') || (0, $37e88c15ceea9261$export$2e2bcd8739ae039).getSafeProp(this.defaults, 'method') || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $37e88c15ceea9261$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $37e88c15ceea9261$export$2e2bcd8739ae039).forEach((0, $55a8dd1c06168658$export$2e2bcd8739ae039).concat('common'), (method)=>{
            delete headers[method];
        });
        config.headers = (0, $6450fcf4641e8103$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $8580892c96adaf9d$export$2e2bcd8739ae039);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $27bf88165417ad86$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled ? onFulfilled(newConfig) : newConfig;
            } catch (error) {
                if (!onRejected) {
                    promise = Promise.reject(error);
                    break;
                }
                try {
                    const rejectedResult = onRejected.call(this, error);
                    if ((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isThenable(rejectedResult)) promise = Promise.resolve(rejectedResult).then(()=>(0, $27bf88165417ad86$export$2e2bcd8739ae039).call(this, newConfig));
                } catch (rejectedError) {
                    promise = Promise.reject(rejectedError);
                }
                break;
            }
        }
        if (!promise) try {
            promise = (0, $27bf88165417ad86$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            promise = Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $7a64e9a12bd58681$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $c1d890a0664bfdaf$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls, config);
        return (0, $cd87bd104fdb775a$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $37e88c15ceea9261$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $3e329e59d25c42df$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $7a64e9a12bd58681$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: config && (0, $37e88c15ceea9261$export$2e2bcd8739ae039).hasOwnProp(config, 'data') ? config.data : undefined
        }));
    };
});
(0, $37e88c15ceea9261$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch',
    'query'
], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $7a64e9a12bd58681$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $3e329e59d25c42df$var$Axios.prototype[method] = generateHTTPMethod();
    // QUERY is a safe/idempotent read method; multipart form bodies don't fit
    // its semantics, so no queryForm shorthand is generated.
    if (method !== 'query') $3e329e59d25c42df$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $3e329e59d25c42df$export$2e2bcd8739ae039 = $3e329e59d25c42df$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $c2f8a01f49077351$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $1a943e5048e7ffb9$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $c2f8a01f49077351$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $c2f8a01f49077351$export$2e2bcd8739ae039 = $c2f8a01f49077351$var$CancelToken;






'use strict';
function $694e2202394aa572$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $595bd555d1189636$export$2e2bcd8739ae039(payload) {
    return (0, $37e88c15ceea9261$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $50c5fd989a9f91f2$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    /**
   * @deprecated Use `ContentTooLarge` instead.
   */ PayloadTooLarge: 413,
    ContentTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    /**
   * @deprecated Use `UnprocessableContent` instead.
   */ UnprocessableEntity: 422,
    UnprocessableContent: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerReturnsAnUnknownError: 520,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($50c5fd989a9f91f2$var$HttpStatusCode).forEach(([key, value])=>{
    if ($50c5fd989a9f91f2$var$HttpStatusCode[value] === undefined) $50c5fd989a9f91f2$var$HttpStatusCode[value] = key;
});
var $50c5fd989a9f91f2$export$2e2bcd8739ae039 = $50c5fd989a9f91f2$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $0d16547caa56a13b$var$createInstance(defaultConfig) {
    const context = new (0, $3e329e59d25c42df$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $f6b6e4df564f06e6$export$2e2bcd8739ae039)((0, $3e329e59d25c42df$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $37e88c15ceea9261$export$2e2bcd8739ae039).extend(instance, (0, $3e329e59d25c42df$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $37e88c15ceea9261$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $0d16547caa56a13b$var$createInstance((0, $7a64e9a12bd58681$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $0d16547caa56a13b$var$axios = $0d16547caa56a13b$var$createInstance((0, $89e9ad5e98e61be2$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$0d16547caa56a13b$var$axios.Axios = (0, $3e329e59d25c42df$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$0d16547caa56a13b$var$axios.CanceledError = (0, $1a943e5048e7ffb9$export$2e2bcd8739ae039);
$0d16547caa56a13b$var$axios.CancelToken = (0, $c2f8a01f49077351$export$2e2bcd8739ae039);
$0d16547caa56a13b$var$axios.isCancel = (0, $4770b47c1119b9a2$export$2e2bcd8739ae039);
$0d16547caa56a13b$var$axios.VERSION = (0, $0b05d13853352663$export$a4ad2735b021c132);
$0d16547caa56a13b$var$axios.toFormData = (0, $5176de0e7036a0db$export$2e2bcd8739ae039);
// Expose AxiosError class
$0d16547caa56a13b$var$axios.AxiosError = (0, $914052063804fa69$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$0d16547caa56a13b$var$axios.Cancel = $0d16547caa56a13b$var$axios.CanceledError;
// Expose all/spread
$0d16547caa56a13b$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$0d16547caa56a13b$var$axios.spread = (0, $694e2202394aa572$export$2e2bcd8739ae039);
// Expose isAxiosError
$0d16547caa56a13b$var$axios.isAxiosError = (0, $595bd555d1189636$export$2e2bcd8739ae039);
// Expose mergeConfig
$0d16547caa56a13b$var$axios.mergeConfig = (0, $7a64e9a12bd58681$export$2e2bcd8739ae039);
$0d16547caa56a13b$var$axios.AxiosHeaders = (0, $6450fcf4641e8103$export$2e2bcd8739ae039);
$0d16547caa56a13b$var$axios.formToJSON = (thing)=>(0, $273c8c7c7b37d447$export$2e2bcd8739ae039)((0, $37e88c15ceea9261$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$0d16547caa56a13b$var$axios.getAdapter = (0, $6744717d9856c505$export$2e2bcd8739ae039).getAdapter;
$0d16547caa56a13b$var$axios.HttpStatusCode = (0, $50c5fd989a9f91f2$export$2e2bcd8739ae039);
$0d16547caa56a13b$var$axios.default = $0d16547caa56a13b$var$axios;
var // this module should only have a default export
$0d16547caa56a13b$export$2e2bcd8739ae039 = $0d16547caa56a13b$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $7b6ce2ad7642daeb$export$1c00760e9e5a4e95, AxiosError: $7b6ce2ad7642daeb$export$c1fbed17c2f6a328, CanceledError: $7b6ce2ad7642daeb$export$1ab0c6b20d94fa14, isCancel: $7b6ce2ad7642daeb$export$3b22524397b493c6, CancelToken: $7b6ce2ad7642daeb$export$fd08e3cb425f0d61, VERSION: $7b6ce2ad7642daeb$export$a4ad2735b021c132, all: $7b6ce2ad7642daeb$export$84bf76cd7afc7469, Cancel: $7b6ce2ad7642daeb$export$848c9b7ead0df967, isAxiosError: $7b6ce2ad7642daeb$export$fbafdbe06a5b5a9a, spread: $7b6ce2ad7642daeb$export$3ae0fd4797ed47c8, toFormData: $7b6ce2ad7642daeb$export$10ae0d317ea97f8b, AxiosHeaders: $7b6ce2ad7642daeb$export$4e7d6ff0f3e6520, HttpStatusCode: $7b6ce2ad7642daeb$export$a972f69c851492b3, formToJSON: $7b6ce2ad7642daeb$export$86d7c59254d6a2c9, getAdapter: $7b6ce2ad7642daeb$export$17ddc20a97d669e2, mergeConfig: $7b6ce2ad7642daeb$export$7ec1ebcfa9d8bd6a, create: $7b6ce2ad7642daeb$export$185802fd694ee1f5 } = (0, $0d16547caa56a13b$export$2e2bcd8739ae039);


var $ed2b12aa71a74467$exports = {};
(function(a, b) {
    if ("function" == typeof define && define.amd) define([], b);
    else b();
})($ed2b12aa71a74467$exports, function() {
    "use strict";
    function b(a, b) {
        return "undefined" == typeof b ? b = {
            autoBom: !1
        } : "object" != typeof b && (console.warn("Deprecated: Expected third argument to be a object"), b = {
            autoBom: !b
        }), b.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type) ? new Blob([
            "\uFEFF",
            a
        ], {
            type: a.type
        }) : a;
    }
    function c(a, b, c) {
        var d = new XMLHttpRequest;
        d.open("GET", a), d.responseType = "blob", d.onload = function() {
            g(d.response, b, c);
        }, d.onerror = function() {
            console.error("could not download file");
        }, d.send();
    }
    function d(a) {
        var b = new XMLHttpRequest;
        b.open("HEAD", a, !1);
        try {
            b.send();
        } catch (a) {}
        return 200 <= b.status && 299 >= b.status;
    }
    function e(a) {
        try {
            a.dispatchEvent(new MouseEvent("click"));
        } catch (c) {
            var b = document.createEvent("MouseEvents");
            b.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), a.dispatchEvent(b);
        }
    }
    var f = "object" == typeof window && window.window === window ? window : "object" == typeof self && self.self === self ? self : "object" == typeof $parcel$global && $parcel$global.global === $parcel$global ? $parcel$global : void 0, a = f.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), g = f.saveAs || ("object" != typeof window || window !== f ? function() {} : "download" in HTMLAnchorElement.prototype && !a ? function(b, g, h) {
        var i = f.URL || f.webkitURL, j = document.createElement("a");
        g = g || b.name || "download", j.download = g, j.rel = "noopener", "string" == typeof b ? (j.href = b, j.origin === location.origin ? e(j) : d(j.href) ? c(b, g, h) : e(j, j.target = "_blank")) : (j.href = i.createObjectURL(b), setTimeout(function() {
            i.revokeObjectURL(j.href);
        }, 4E4), setTimeout(function() {
            e(j);
        }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function(f, g, h) {
        if (g = g || f.name || "download", "string" != typeof f) navigator.msSaveOrOpenBlob(b(f, h), g);
        else if (d(f)) c(f, g, h);
        else {
            var i = document.createElement("a");
            i.href = f, i.target = "_blank", setTimeout(function() {
                e(i);
            });
        }
    } : function(b, d, e, g) {
        if (g = g || open("", "_blank"), g && (g.document.title = g.document.body.innerText = "downloading..."), "string" == typeof b) return c(b, d, e);
        var h = "application/octet-stream" === b.type, i = /constructor/i.test(f.HTMLElement) || f.safari, j = /CriOS\/[\d]+/.test(navigator.userAgent);
        if ((j || h && i || a) && "undefined" != typeof FileReader) {
            var k = new FileReader;
            k.onloadend = function() {
                var a = k.result;
                a = j ? a : a.replace(/^data:[^;]*;/, "data:attachment/file;"), g ? g.location.href = a : location = a, g = null;
            }, k.readAsDataURL(b);
        } else {
            var l = f.URL || f.webkitURL, m = l.createObjectURL(b);
            g ? g.location = m : location.href = m, g = null, setTimeout(function() {
                l.revokeObjectURL(m);
            }, 4E4);
        }
    });
    f.saveAs = g.saveAs = g, $ed2b12aa71a74467$exports = g;
});



var $5pSp9 = parcelRequire("5pSp9");

var $5E6i4 = parcelRequire("5E6i4");

function $e015ec02b8c36601$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


// eslint-disable-next-line no-undef
var $e58312245c719150$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $e58312245c719150$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $e015ec02b8c36601$export$2e2bcd8739ae039)(function(prop) {
    return $e58312245c719150$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});



var $5E6i4 = parcelRequire("5E6i4");
var $14f7c1b46e1d219f$export$71ad59f2e432cfe8 = '-ms-';
var $14f7c1b46e1d219f$export$2c0f367103c8d01c = '-moz-';
var $14f7c1b46e1d219f$export$39dfd62a25e0fe93 = '-webkit-';
var $14f7c1b46e1d219f$export$a29989082612d0d9 = 'comm';
var $14f7c1b46e1d219f$export$aa3a2e812ca8570d = 'rule';
var $14f7c1b46e1d219f$export$527d108ccf083c2b = 'decl';
var $14f7c1b46e1d219f$export$d3d35020fa5b54f0 = '@page';
var $14f7c1b46e1d219f$export$500415a86c544f73 = '@media';
var $14f7c1b46e1d219f$export$a763edbf796b780a = '@import';
var $14f7c1b46e1d219f$export$2790aeb8b4e5c826 = '@charset';
var $14f7c1b46e1d219f$export$1cc683e23b84b133 = '@viewport';
var $14f7c1b46e1d219f$export$9447a5efea57e862 = '@supports';
var $14f7c1b46e1d219f$export$ef011b4e114b1fba = '@document';
var $14f7c1b46e1d219f$export$6aad947bda0f3f46 = '@namespace';
var $14f7c1b46e1d219f$export$b44a8529a35fcb60 = '@keyframes';
var $14f7c1b46e1d219f$export$2c16de31893252e6 = '@font-face';
var $14f7c1b46e1d219f$export$3d846dd52e150c6f = '@counter-style';
var $14f7c1b46e1d219f$export$22314bfbb57653fe = '@font-feature-values';
var $14f7c1b46e1d219f$export$d773506282b3cfe6 = '@layer';
var $14f7c1b46e1d219f$export$1c5a554c78c0cd12 = '@scope';


/**
 * @param {number}
 * @return {number}
 */ var $a4dba62487c0087b$export$2335f513bbd82c6d = Math.abs;
var $a4dba62487c0087b$export$6788812c4e6611e6 = String.fromCharCode;
var $a4dba62487c0087b$export$e6e34fd1f2686227 = Object.assign;
function $a4dba62487c0087b$export$d6af199866bfb566(value, length) {
    return $a4dba62487c0087b$export$a9db5e087081082d(value, 0) ^ 45 ? (((length << 2 ^ $a4dba62487c0087b$export$a9db5e087081082d(value, 0)) << 2 ^ $a4dba62487c0087b$export$a9db5e087081082d(value, 1)) << 2 ^ $a4dba62487c0087b$export$a9db5e087081082d(value, 2)) << 2 ^ $a4dba62487c0087b$export$a9db5e087081082d(value, 3) : 0;
}
function $a4dba62487c0087b$export$87c2784dc9fc4ab(value) {
    return value.trim();
}
function $a4dba62487c0087b$export$4659b591c19bdf3d(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
}
function $a4dba62487c0087b$export$77ad94ebf1c2b9ed(value, pattern, replacement) {
    return value.replace(pattern, replacement);
}
function $a4dba62487c0087b$export$f8e21b1e77979a08(value, search, position) {
    return value.indexOf(search, position);
}
function $a4dba62487c0087b$export$a9db5e087081082d(value, index) {
    return value.charCodeAt(index) | 0;
}
function $a4dba62487c0087b$export$2f35ab04d2335697(value, begin, end) {
    return value.slice(begin, end);
}
function $a4dba62487c0087b$export$36776f635604f274(value) {
    return value.length;
}
function $a4dba62487c0087b$export$f9084667e487ed46(value) {
    return value.length;
}
function $a4dba62487c0087b$export$10d8903dec122b9d(value, array) {
    return array.push(value), value;
}
function $a4dba62487c0087b$export$1be1fc439b849fdf(array, callback) {
    return array.map(callback).join('');
}
function $a4dba62487c0087b$export$3dea766d36a8935f(array, pattern) {
    return array.filter(function(value) {
        return !$a4dba62487c0087b$export$4659b591c19bdf3d(value, pattern);
    });
}



var $091f67372881bac3$export$53f1d5ea8de3d7c = 1;
var $091f67372881bac3$export$4e0c71f277ca26b3 = 1;
var $091f67372881bac3$export$f24224f1c91d8156 = 0;
var $091f67372881bac3$export$5880b8b5730aff45 = 0;
var $091f67372881bac3$export$c0306caf338ac095 = 0;
var $091f67372881bac3$export$30a86d91af8ff6e6 = '';
function $091f67372881bac3$export$35059013cd4a06db(value, root, parent, type, props, children, length, siblings) {
    return {
        value: value,
        root: root,
        parent: parent,
        type: type,
        props: props,
        children: children,
        line: $091f67372881bac3$export$53f1d5ea8de3d7c,
        column: $091f67372881bac3$export$4e0c71f277ca26b3,
        length: length,
        return: '',
        siblings: siblings
    };
}
function $091f67372881bac3$export$784d13d8ee351f07(root, props) {
    return (0, $a4dba62487c0087b$export$e6e34fd1f2686227)($091f67372881bac3$export$35059013cd4a06db('', null, null, '', null, null, 0, root.siblings), root, {
        length: -root.length
    }, props);
}
function $091f67372881bac3$export$590e8b2c435046d9(root) {
    while(root.root)root = $091f67372881bac3$export$784d13d8ee351f07(root.root, {
        children: [
            root
        ]
    });
    (0, $a4dba62487c0087b$export$10d8903dec122b9d)(root, root.siblings);
}
function $091f67372881bac3$export$eba6f6f03b0a92e7() {
    return $091f67372881bac3$export$c0306caf338ac095;
}
function $091f67372881bac3$export$232faf9add678146() {
    $091f67372881bac3$export$c0306caf338ac095 = $091f67372881bac3$export$5880b8b5730aff45 > 0 ? (0, $a4dba62487c0087b$export$a9db5e087081082d)($091f67372881bac3$export$30a86d91af8ff6e6, --$091f67372881bac3$export$5880b8b5730aff45) : 0;
    if ($091f67372881bac3$export$4e0c71f277ca26b3--, $091f67372881bac3$export$c0306caf338ac095 === 10) $091f67372881bac3$export$4e0c71f277ca26b3 = 1, $091f67372881bac3$export$53f1d5ea8de3d7c--;
    return $091f67372881bac3$export$c0306caf338ac095;
}
function $091f67372881bac3$export$48cfd1e771a65c4f() {
    $091f67372881bac3$export$c0306caf338ac095 = $091f67372881bac3$export$5880b8b5730aff45 < $091f67372881bac3$export$f24224f1c91d8156 ? (0, $a4dba62487c0087b$export$a9db5e087081082d)($091f67372881bac3$export$30a86d91af8ff6e6, $091f67372881bac3$export$5880b8b5730aff45++) : 0;
    if ($091f67372881bac3$export$4e0c71f277ca26b3++, $091f67372881bac3$export$c0306caf338ac095 === 10) $091f67372881bac3$export$4e0c71f277ca26b3 = 1, $091f67372881bac3$export$53f1d5ea8de3d7c++;
    return $091f67372881bac3$export$c0306caf338ac095;
}
function $091f67372881bac3$export$4d3fb11e950abb9e() {
    return (0, $a4dba62487c0087b$export$a9db5e087081082d)($091f67372881bac3$export$30a86d91af8ff6e6, $091f67372881bac3$export$5880b8b5730aff45);
}
function $091f67372881bac3$export$e88cb2efb12ae807() {
    return $091f67372881bac3$export$5880b8b5730aff45;
}
function $091f67372881bac3$export$58adb3bec8346d0f(begin, end) {
    return (0, $a4dba62487c0087b$export$2f35ab04d2335697)($091f67372881bac3$export$30a86d91af8ff6e6, begin, end);
}
function $091f67372881bac3$export$9e1725a4cfeada27(type) {
    switch(type){
        // \0 \t \n \r \s whitespace token
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        // ! + , / > @ ~ isolate token
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        // ; { } breakpoint token
        case 59:
        case 123:
        case 125:
            return 4;
        // : accompanied token
        case 58:
            return 3;
        // " ' ( [ opening delimit token
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        // ) ] closing delimit token
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $091f67372881bac3$export$2de70f21292aac9e(value) {
    return $091f67372881bac3$export$53f1d5ea8de3d7c = $091f67372881bac3$export$4e0c71f277ca26b3 = 1, $091f67372881bac3$export$f24224f1c91d8156 = (0, $a4dba62487c0087b$export$36776f635604f274)($091f67372881bac3$export$30a86d91af8ff6e6 = value), $091f67372881bac3$export$5880b8b5730aff45 = 0, [];
}
function $091f67372881bac3$export$45918ac1574455b1(value) {
    return $091f67372881bac3$export$30a86d91af8ff6e6 = '', value;
}
function $091f67372881bac3$export$410ac95b9ec204b8(type) {
    return (0, $a4dba62487c0087b$export$87c2784dc9fc4ab)($091f67372881bac3$export$58adb3bec8346d0f($091f67372881bac3$export$5880b8b5730aff45 - 1, $091f67372881bac3$export$c889f2fcc19dbf12(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function $091f67372881bac3$export$660b2ee2d4fb4eff(value) {
    return $091f67372881bac3$export$45918ac1574455b1($091f67372881bac3$export$5f8c09e3ae6f64e1($091f67372881bac3$export$2de70f21292aac9e(value)));
}
function $091f67372881bac3$export$7af1228ff777d175(type) {
    while($091f67372881bac3$export$c0306caf338ac095 = $091f67372881bac3$export$4d3fb11e950abb9e())if ($091f67372881bac3$export$c0306caf338ac095 < 33) $091f67372881bac3$export$48cfd1e771a65c4f();
    else break;
    return $091f67372881bac3$export$9e1725a4cfeada27(type) > 2 || $091f67372881bac3$export$9e1725a4cfeada27($091f67372881bac3$export$c0306caf338ac095) > 3 ? '' : ' ';
}
function $091f67372881bac3$export$5f8c09e3ae6f64e1(children) {
    while($091f67372881bac3$export$48cfd1e771a65c4f())switch($091f67372881bac3$export$9e1725a4cfeada27($091f67372881bac3$export$c0306caf338ac095)){
        case 0:
            (0, $a4dba62487c0087b$export$10d8903dec122b9d)($091f67372881bac3$export$c2ab62c7bf24634($091f67372881bac3$export$5880b8b5730aff45 - 1), children);
            break;
        case 2:
            (0, $a4dba62487c0087b$export$10d8903dec122b9d)($091f67372881bac3$export$410ac95b9ec204b8($091f67372881bac3$export$c0306caf338ac095), children);
            break;
        default:
            (0, $a4dba62487c0087b$export$10d8903dec122b9d)((0, $a4dba62487c0087b$export$6788812c4e6611e6)($091f67372881bac3$export$c0306caf338ac095), children);
    }
    return children;
}
function $091f67372881bac3$export$955ba06d119e085e(index, count) {
    while(--count && $091f67372881bac3$export$48cfd1e771a65c4f())// not 0-9 A-F a-f
    if ($091f67372881bac3$export$c0306caf338ac095 < 48 || $091f67372881bac3$export$c0306caf338ac095 > 102 || $091f67372881bac3$export$c0306caf338ac095 > 57 && $091f67372881bac3$export$c0306caf338ac095 < 65 || $091f67372881bac3$export$c0306caf338ac095 > 70 && $091f67372881bac3$export$c0306caf338ac095 < 97) break;
    return $091f67372881bac3$export$58adb3bec8346d0f(index, $091f67372881bac3$export$e88cb2efb12ae807() + (count < 6 && $091f67372881bac3$export$4d3fb11e950abb9e() == 32 && $091f67372881bac3$export$48cfd1e771a65c4f() == 32));
}
function $091f67372881bac3$export$c889f2fcc19dbf12(type) {
    while($091f67372881bac3$export$48cfd1e771a65c4f())switch($091f67372881bac3$export$c0306caf338ac095){
        // ] ) " '
        case type:
            return $091f67372881bac3$export$5880b8b5730aff45;
        // " '
        case 34:
        case 39:
            if (type !== 34 && type !== 39) $091f67372881bac3$export$c889f2fcc19dbf12($091f67372881bac3$export$c0306caf338ac095);
            break;
        // (
        case 40:
            if (type === 41) $091f67372881bac3$export$c889f2fcc19dbf12(type);
            break;
        // \
        case 92:
            $091f67372881bac3$export$48cfd1e771a65c4f();
            break;
    }
    return $091f67372881bac3$export$5880b8b5730aff45;
}
function $091f67372881bac3$export$4254d4e2b3745c4c(type, index) {
    while($091f67372881bac3$export$48cfd1e771a65c4f())// //
    if (type + $091f67372881bac3$export$c0306caf338ac095 === 57) break;
    else if (type + $091f67372881bac3$export$c0306caf338ac095 === 84 && $091f67372881bac3$export$4d3fb11e950abb9e() === 47) break;
    return '/*' + $091f67372881bac3$export$58adb3bec8346d0f(index, $091f67372881bac3$export$5880b8b5730aff45 - 1) + '*' + (0, $a4dba62487c0087b$export$6788812c4e6611e6)(type === 47 ? type : $091f67372881bac3$export$48cfd1e771a65c4f());
}
function $091f67372881bac3$export$c2ab62c7bf24634(index) {
    while(!$091f67372881bac3$export$9e1725a4cfeada27($091f67372881bac3$export$4d3fb11e950abb9e()))$091f67372881bac3$export$48cfd1e771a65c4f();
    return $091f67372881bac3$export$58adb3bec8346d0f(index, $091f67372881bac3$export$5880b8b5730aff45);
}


function $0da293b81cdc2df3$export$ef7acd7185315e22(value) {
    return (0, $091f67372881bac3$export$45918ac1574455b1)($0da293b81cdc2df3$export$98e6a39c04603d36('', null, null, null, [
        ''
    ], value = (0, $091f67372881bac3$export$2de70f21292aac9e)(value), 0, [
        0
    ], value));
}
function $0da293b81cdc2df3$export$98e6a39c04603d36(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    var index = 0;
    var offset = 0;
    var length = pseudo;
    var atrule = 0;
    var property = 0;
    var previous = 0;
    var variable = 1;
    var scanning = 1;
    var ampersand = 1;
    var character = 0;
    var type = '';
    var props = rules;
    var children = rulesets;
    var reference = rule;
    var characters = type;
    while(scanning)switch(previous = character, character = (0, $091f67372881bac3$export$48cfd1e771a65c4f)()){
        // (
        case 40:
            if (previous != 108 && (0, $a4dba62487c0087b$export$a9db5e087081082d)(characters, length - 1) == 58) {
                if ((0, $a4dba62487c0087b$export$f8e21b1e77979a08)(characters += (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)((0, $091f67372881bac3$export$410ac95b9ec204b8)(character), '&', '&\f'), '&\f', (0, $a4dba62487c0087b$export$2335f513bbd82c6d)(index ? points[index - 1] : 0)) != -1) ampersand = -1;
                break;
            }
        // " ' [
        case 34:
        case 39:
        case 91:
            characters += (0, $091f67372881bac3$export$410ac95b9ec204b8)(character);
            break;
        // \t \n \r \s
        case 9:
        case 10:
        case 13:
        case 32:
            characters += (0, $091f67372881bac3$export$7af1228ff777d175)(previous);
            break;
        // \
        case 92:
            characters += (0, $091f67372881bac3$export$955ba06d119e085e)((0, $091f67372881bac3$export$e88cb2efb12ae807)() - 1, 7);
            continue;
        // /
        case 47:
            switch((0, $091f67372881bac3$export$4d3fb11e950abb9e)()){
                case 42:
                case 47:
                    (0, $a4dba62487c0087b$export$10d8903dec122b9d)($0da293b81cdc2df3$export$4a34f930e789283c((0, $091f67372881bac3$export$4254d4e2b3745c4c)((0, $091f67372881bac3$export$48cfd1e771a65c4f)(), (0, $091f67372881bac3$export$e88cb2efb12ae807)()), root, parent, declarations), declarations);
                    if (((0, $091f67372881bac3$export$9e1725a4cfeada27)(previous || 1) == 5 || (0, $091f67372881bac3$export$9e1725a4cfeada27)((0, $091f67372881bac3$export$4d3fb11e950abb9e)() || 1) == 5) && (0, $a4dba62487c0087b$export$36776f635604f274)(characters) && (0, $a4dba62487c0087b$export$2f35ab04d2335697)(characters, -1, void 0) !== ' ') characters += ' ';
                    break;
                default:
                    characters += '/';
            }
            break;
        // {
        case 123 * variable:
            points[index++] = (0, $a4dba62487c0087b$export$36776f635604f274)(characters) * ampersand;
        // } ; \0
        case 125 * variable:
        case 59:
        case 0:
            switch(character){
                // \0 }
                case 0:
                case 125:
                    scanning = 0;
                // ;
                case 59 + offset:
                    if (ampersand == -1) characters = (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(characters, /\f/g, '');
                    if (property > 0 && ((0, $a4dba62487c0087b$export$36776f635604f274)(characters) - length || variable === 0 && previous === 47)) (0, $a4dba62487c0087b$export$10d8903dec122b9d)(property > 32 ? $0da293b81cdc2df3$export$f8483753829ec8f3(characters + ';', rule, parent, length - 1, declarations) : $0da293b81cdc2df3$export$f8483753829ec8f3((0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(characters, ' ', '') + ';', rule, parent, length - 2, declarations), declarations);
                    break;
                // @ ;
                case 59:
                    characters += ';';
                // { rule/at-rule
                default:
                    (0, $a4dba62487c0087b$export$10d8903dec122b9d)(reference = $0da293b81cdc2df3$export$3307ffa7023ede1e(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length, rulesets), rulesets);
                    if (character === 123) {
                        if (offset === 0) $0da293b81cdc2df3$export$98e6a39c04603d36(characters, root, reference, reference, props, rulesets, length, points, children);
                        else {
                            switch(atrule){
                                // c(ontainer)
                                case 99:
                                    if ((0, $a4dba62487c0087b$export$a9db5e087081082d)(characters, 3) === 110) break;
                                // l(ayer)
                                case 108:
                                    if ((0, $a4dba62487c0087b$export$a9db5e087081082d)(characters, 2) === 97) break;
                                default:
                                    offset = 0;
                                // d(ocument) m(edia) s(upports)
                                case 100:
                                case 109:
                                case 115:
                            }
                            if (offset) $0da293b81cdc2df3$export$98e6a39c04603d36(value, reference, reference, rule && (0, $a4dba62487c0087b$export$10d8903dec122b9d)($0da293b81cdc2df3$export$3307ffa7023ede1e(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length, children), children), rules, children, length, points, rule ? props : children);
                            else $0da293b81cdc2df3$export$98e6a39c04603d36(characters, reference, reference, reference, [
                                ''
                            ], children, 0, points, children);
                        }
                    }
            }
            index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
            break;
        // :
        case 58:
            length = 1 + (0, $a4dba62487c0087b$export$36776f635604f274)(characters), property = previous;
        default:
            if (variable < 1) {
                if (character == 123) --variable;
                else if (character == 125 && variable++ == 0 && (0, $091f67372881bac3$export$232faf9add678146)() == 125) continue;
            }
            switch(characters += (0, $a4dba62487c0087b$export$6788812c4e6611e6)(character), character * variable){
                // &
                case 38:
                    ampersand = offset > 0 ? 1 : (characters += '\f', -1);
                    break;
                // ,
                case 44:
                    points[index++] = ((0, $a4dba62487c0087b$export$36776f635604f274)(characters) - 1) * ampersand, ampersand = 1;
                    break;
                // @
                case 64:
                    // -
                    if ((0, $091f67372881bac3$export$4d3fb11e950abb9e)() === 45) characters += (0, $091f67372881bac3$export$410ac95b9ec204b8)((0, $091f67372881bac3$export$48cfd1e771a65c4f)());
                    atrule = (0, $091f67372881bac3$export$4d3fb11e950abb9e)(), offset = length = (0, $a4dba62487c0087b$export$36776f635604f274)(type = characters += (0, $091f67372881bac3$export$c2ab62c7bf24634)((0, $091f67372881bac3$export$e88cb2efb12ae807)())), character++;
                    break;
                // -
                case 45:
                    if (previous === 45 && (0, $a4dba62487c0087b$export$36776f635604f274)(characters) == 2) variable = 0;
            }
    }
    return rulesets;
}
function $0da293b81cdc2df3$export$3307ffa7023ede1e(value, root, parent, index, offset, rules, points, type, props, children, length, siblings) {
    var post = offset - 1;
    var rule = offset === 0 ? rules : [
        ''
    ];
    var size = (0, $a4dba62487c0087b$export$f9084667e487ed46)(rule);
    for(var i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = (0, $a4dba62487c0087b$export$2f35ab04d2335697)(value, post + 1, post = (0, $a4dba62487c0087b$export$2335f513bbd82c6d)(j = points[i])), z = value; x < size; ++x)if (z = (0, $a4dba62487c0087b$export$87c2784dc9fc4ab)(j > 0 ? rule[x] + ' ' + y : (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(y, /&\f/g, rule[x]))) props[k++] = z;
    return (0, $091f67372881bac3$export$35059013cd4a06db)(value, root, parent, offset === 0 ? (0, $14f7c1b46e1d219f$export$aa3a2e812ca8570d) : type, props, children, length, siblings);
}
function $0da293b81cdc2df3$export$4a34f930e789283c(value, root, parent, siblings) {
    return (0, $091f67372881bac3$export$35059013cd4a06db)(value, root, parent, (0, $14f7c1b46e1d219f$export$a29989082612d0d9), (0, $a4dba62487c0087b$export$6788812c4e6611e6)((0, $091f67372881bac3$export$eba6f6f03b0a92e7)()), (0, $a4dba62487c0087b$export$2f35ab04d2335697)(value, 2, -2), 0, siblings);
}
function $0da293b81cdc2df3$export$f8483753829ec8f3(value, root, parent, length, siblings) {
    return (0, $091f67372881bac3$export$35059013cd4a06db)(value, root, parent, (0, $14f7c1b46e1d219f$export$527d108ccf083c2b), (0, $a4dba62487c0087b$export$2f35ab04d2335697)(value, 0, length), (0, $a4dba62487c0087b$export$2f35ab04d2335697)(value, length + 1, -1), length, siblings);
}






function $4f9dba64a0f6480c$export$dfdc1655ccc5b9cb(children, callback) {
    var output = '';
    for(var i = 0; i < children.length; i++)output += callback(children[i], i, children, callback) || '';
    return output;
}
function $4f9dba64a0f6480c$export$fac44ee5b035f737(element, index, children, callback) {
    switch(element.type){
        case 0, $14f7c1b46e1d219f$export$d773506282b3cfe6:
            if (element.children.length) break;
        case 0, $14f7c1b46e1d219f$export$a763edbf796b780a:
        case 0, $14f7c1b46e1d219f$export$6aad947bda0f3f46:
        case 0, $14f7c1b46e1d219f$export$527d108ccf083c2b:
            return element.return = element.return || element.value;
        case 0, $14f7c1b46e1d219f$export$a29989082612d0d9:
            return '';
        case 0, $14f7c1b46e1d219f$export$b44a8529a35fcb60:
            return element.return = element.value + '{' + $4f9dba64a0f6480c$export$dfdc1655ccc5b9cb(element.children, callback) + '}';
        case 0, $14f7c1b46e1d219f$export$aa3a2e812ca8570d:
            if (!(0, $a4dba62487c0087b$export$36776f635604f274)(element.value = element.props.join(','))) return '';
    }
    return (0, $a4dba62487c0087b$export$36776f635604f274)(children = $4f9dba64a0f6480c$export$dfdc1655ccc5b9cb(element.children, callback)) ? element.return = element.value + '{' + children + '}' : '';
}




function $55dc12b39f43b779$export$82e9f45cca5ba907(value, length, children) {
    switch((0, $a4dba62487c0087b$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
        // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
            return (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + value + value;
        // mask-composite
        case 4855:
            return (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + value.replace('add', 'source-over').replace('substract', 'source-out').replace('intersect', 'source-in').replace('exclude', 'xor') + value;
        // tab-size
        case 4789:
            return (0, $14f7c1b46e1d219f$export$2c0f367103c8d01c) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + value + (0, $14f7c1b46e1d219f$export$2c0f367103c8d01c) + value + (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8) + value + value;
        // writing-mode
        case 5936:
            switch((0, $a4dba62487c0087b$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + value + (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8) + (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + value + (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8) + (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + value + (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8) + (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
        // flex, flex-direction, scroll-snap-type, writing-mode
        case 6828:
        case 4268:
        case 2903:
            return (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + value + (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + value + (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + value + (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + 'box-$1$2' + (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + value + (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8) + 'flex-item-' + (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, /flex-|-self/g, '') + (!(0, $a4dba62487c0087b$export$4659b591c19bdf3d)(value, /flex-|baseline/) ? (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8) + 'grid-row-' + (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, /flex-|-self/g, '') : '') + value;
        // align-content
        case 4675:
            return (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + value + (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8) + 'flex-line-pack' + (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/g, '') + value;
        // flex-shrink
        case 5548:
            return (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + value + (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8) + (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + value + (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8) + (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + 'box-' + (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, '-grow', '') + (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + value + (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8) + (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, '$1' + (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + '$2') + value;
        // cursor
        case 6187:
            return (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)((0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)((0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)((0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + 'box-pack:$3' + (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8) + 'flex-pack:$3'), /space-between/, 'justify') + (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + value + value;
        // justify-self
        case 4200:
            if (!(0, $a4dba62487c0087b$export$4659b591c19bdf3d)(value, /flex-|baseline/)) return (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8) + 'grid-column-align' + (0, $a4dba62487c0087b$export$2f35ab04d2335697)(value, length) + value;
            break;
        // grid-template-(columns|rows)
        case 2592:
        case 3360:
            return (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8) + (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, 'template-', '') + value;
        // grid-(row|column)-start
        case 4384:
        case 3616:
            if (children && children.some(function(element, index) {
                return length = index, (0, $a4dba62487c0087b$export$4659b591c19bdf3d)(element.props, /grid-\w+-end/);
            })) return ~(0, $a4dba62487c0087b$export$f8e21b1e77979a08)(value + (children = children[length].value), 'span', 0) ? value : (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8) + (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, '-start', '') + value + (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8) + 'grid-row-span:' + (~(0, $a4dba62487c0087b$export$f8e21b1e77979a08)(children, 'span', 0) ? (0, $a4dba62487c0087b$export$4659b591c19bdf3d)(children, /\d+/) : +(0, $a4dba62487c0087b$export$4659b591c19bdf3d)(children, /\d+/) - +(0, $a4dba62487c0087b$export$4659b591c19bdf3d)(value, /\d+/)) + ';';
            return (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8) + (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, '-start', '') + value;
        // grid-(row|column)-end
        case 4896:
        case 4128:
            return children && children.some(function(element) {
                return (0, $a4dba62487c0087b$export$4659b591c19bdf3d)(element.props, /grid-\w+-start/);
            }) ? value : (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8) + (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)((0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, '-end', '-span'), 'span ', '') + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $a4dba62487c0087b$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $a4dba62487c0087b$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $a4dba62487c0087b$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $14f7c1b46e1d219f$export$2c0f367103c8d01c) + ((0, $a4dba62487c0087b$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $a4dba62487c0087b$export$f8e21b1e77979a08)(value, 'stretch', 0) ? $55dc12b39f43b779$export$82e9f45cca5ba907((0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length, children) + value : value;
            }
            break;
        // grid-(column|row)
        case 5152:
        case 5920:
            return (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(_, a, b, c, d, e, f) {
                return (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8) + a + ':' + b + f + (c ? (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8) + a + '-span:' + (d ? e : +e - +b) + f : '') + value;
            });
        // position: sticky
        case 4949:
            // stick(y)?
            if ((0, $a4dba62487c0087b$export$a9db5e087081082d)(value, length + 6) === 121) return (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93)) + value;
            break;
        // display: (flex|inline-flex|grid|inline-grid)
        case 6444:
            switch((0, $a4dba62487c0087b$export$a9db5e087081082d)(value, (0, $a4dba62487c0087b$export$a9db5e087081082d)(value, 14) === 45 ? 18 : 11)){
                // (inline-)?fle(x)
                case 120:
                    return (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, '$1' + (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + ((0, $a4dba62487c0087b$export$a9db5e087081082d)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + '$2$3' + '$1' + (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8) + '$2box$3') + value;
                // (inline-)?gri(d)
                case 100:
                    return (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8)) + value;
            }
            break;
        // scroll-margin, scroll-margin-(top|right|bottom|left)
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, 'scroll-', 'scroll-snap-') + value;
    }
    return value;
}


function $66e69a28cf94fb87$export$5a7767152ae0305f(collection) {
    var length = (0, $a4dba62487c0087b$export$f9084667e487ed46)(collection);
    return function(element, index, children, callback) {
        var output = '';
        for(var i = 0; i < length; i++)output += collection[i](element, index, children, callback) || '';
        return output;
    };
}
function $66e69a28cf94fb87$export$38bcb760f1d4871c(callback) {
    return function(element) {
        if (!element.root) {
            if (element = element.return) callback(element);
        }
    };
}
function $66e69a28cf94fb87$export$e08c7d021b829b7a(element, index, children, callback) {
    if (element.length > -1) {
        if (!element.return) switch(element.type){
            case 0, $14f7c1b46e1d219f$export$527d108ccf083c2b:
                element.return = (0, $55dc12b39f43b779$export$82e9f45cca5ba907)(element.value, element.length, children);
                return;
            case 0, $14f7c1b46e1d219f$export$b44a8529a35fcb60:
                return (0, $4f9dba64a0f6480c$export$dfdc1655ccc5b9cb)([
                    (0, $091f67372881bac3$export$784d13d8ee351f07)(element, {
                        value: (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(element.value, '@', '@' + (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $14f7c1b46e1d219f$export$aa3a2e812ca8570d:
                if (element.length) return (0, $a4dba62487c0087b$export$1be1fc439b849fdf)(children = element.props, function(value) {
                    switch((0, $a4dba62487c0087b$export$4659b591c19bdf3d)(value, callback = /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            (0, $091f67372881bac3$export$590e8b2c435046d9)((0, $091f67372881bac3$export$784d13d8ee351f07)(element, {
                                props: [
                                    (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $14f7c1b46e1d219f$export$2c0f367103c8d01c) + '$1')
                                ]
                            }));
                            (0, $091f67372881bac3$export$590e8b2c435046d9)((0, $091f67372881bac3$export$784d13d8ee351f07)(element, {
                                props: [
                                    value
                                ]
                            }));
                            (0, $a4dba62487c0087b$export$e6e34fd1f2686227)(element, {
                                props: (0, $a4dba62487c0087b$export$3dea766d36a8935f)(children, callback)
                            });
                            break;
                        // :placeholder
                        case '::placeholder':
                            (0, $091f67372881bac3$export$590e8b2c435046d9)((0, $091f67372881bac3$export$784d13d8ee351f07)(element, {
                                props: [
                                    (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $14f7c1b46e1d219f$export$39dfd62a25e0fe93) + 'input-$1')
                                ]
                            }));
                            (0, $091f67372881bac3$export$590e8b2c435046d9)((0, $091f67372881bac3$export$784d13d8ee351f07)(element, {
                                props: [
                                    (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $14f7c1b46e1d219f$export$2c0f367103c8d01c) + '$1')
                                ]
                            }));
                            (0, $091f67372881bac3$export$590e8b2c435046d9)((0, $091f67372881bac3$export$784d13d8ee351f07)(element, {
                                props: [
                                    (0, $a4dba62487c0087b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $14f7c1b46e1d219f$export$71ad59f2e432cfe8) + 'input-$1')
                                ]
                            }));
                            (0, $091f67372881bac3$export$590e8b2c435046d9)((0, $091f67372881bac3$export$784d13d8ee351f07)(element, {
                                props: [
                                    value
                                ]
                            }));
                            (0, $a4dba62487c0087b$export$e6e34fd1f2686227)(element, {
                                props: (0, $a4dba62487c0087b$export$3dea766d36a8935f)(children, callback)
                            });
                            break;
                    }
                    return '';
                });
        }
    }
}
function $66e69a28cf94fb87$export$76a88f7de6507443(element) {
    switch(element.type){
        case 0, $14f7c1b46e1d219f$export$aa3a2e812ca8570d:
            element.props = element.props.map(function(value) {
                return (0, $a4dba62487c0087b$export$1be1fc439b849fdf)((0, $091f67372881bac3$export$660b2ee2d4fb4eff)(value), function(value, index, children) {
                    switch((0, $a4dba62487c0087b$export$a9db5e087081082d)(value, 0)){
                        // \f
                        case 12:
                            return (0, $a4dba62487c0087b$export$2f35ab04d2335697)(value, 1, (0, $a4dba62487c0087b$export$36776f635604f274)(value));
                        // \0 ( + > ~
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return value;
                        // :
                        case 58:
                            if (children[++index] === 'global') children[index] = '', children[++index] = '\f' + (0, $a4dba62487c0087b$export$2f35ab04d2335697)(children[index], index = 1, -1);
                        // \s
                        case 32:
                            return index === 1 ? '' : value;
                        default:
                            switch(index){
                                case 0:
                                    element = value;
                                    return (0, $a4dba62487c0087b$export$f9084667e487ed46)(children) > 1 ? '' : value;
                                case index = (0, $a4dba62487c0087b$export$f9084667e487ed46)(children) - 1:
                                case 2:
                                    return index === 2 ? value + element + element : value + element;
                                default:
                                    return value;
                            }
                    }
                });
            });
    }
}


const $07090e743135ae89$var$r = {};
function $07090e743135ae89$var$i(e, ...t) {
    return new Error(`An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#${e} for more information.${t.length > 0 ? ` Args: ${t.join(", ")}` : ""}`);
}
var $07090e743135ae89$var$a, $07090e743135ae89$var$c;
const $07090e743135ae89$var$l = "data-styled", $07090e743135ae89$var$u = "active", $07090e743135ae89$var$d = "data-styled-version", $07090e743135ae89$export$83d89fbfd8236492 = "6.6.0", $07090e743135ae89$var$p = "/*!sc*/\n", $07090e743135ae89$var$f = "undefined" != typeof window && "undefined" != typeof document;
if (!(0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createContext) throw $07090e743135ae89$var$i(19);
function $07090e743135ae89$var$m(e) {}
const $07090e743135ae89$var$y = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : null !== ($07090e743135ae89$var$c = null !== ($07090e743135ae89$var$a = $07090e743135ae89$var$m("REACT_APP_SC_DISABLE_SPEEDY")) && void 0 !== $07090e743135ae89$var$a ? $07090e743135ae89$var$a : $07090e743135ae89$var$m("SC_DISABLE_SPEEDY")) && void 0 !== $07090e743135ae89$var$c ? $07090e743135ae89$var$c : false), $07090e743135ae89$var$g = "sc-keyframes-", $07090e743135ae89$var$v = {}, $07090e743135ae89$var$S = 1073741824;
let $07090e743135ae89$var$b = new Map, $07090e743135ae89$var$w = new Map, $07090e743135ae89$var$N = 1;
const $07090e743135ae89$var$C = (e)=>{
    if ($07090e743135ae89$var$b.has(e)) return $07090e743135ae89$var$b.get(e);
    for(; $07090e743135ae89$var$w.has($07090e743135ae89$var$N);)$07090e743135ae89$var$N++;
    const t = $07090e743135ae89$var$N++;
    return $07090e743135ae89$var$b.set(e, t), $07090e743135ae89$var$w.set(t, e), t;
}, $07090e743135ae89$var$O = (e)=>$07090e743135ae89$var$w.get(e), $07090e743135ae89$var$E = (e, t)=>{
    $07090e743135ae89$var$N = t + 1, $07090e743135ae89$var$b.set(e, t), $07090e743135ae89$var$w.set(t, e);
}, $07090e743135ae89$var$A = /invalid hook call/i, $07090e743135ae89$var$P = new Set, $07090e743135ae89$var$_ = (e, n)=>{
    var t, n1, e1;
}, $07090e743135ae89$var$$ = Object.freeze([]), $07090e743135ae89$var$I = Object.freeze({});
function $07090e743135ae89$var$x(e, t, n = $07090e743135ae89$var$I) {
    return e.theme !== n.theme && e.theme || t || n.theme;
}
const $07090e743135ae89$var$R = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $07090e743135ae89$var$j = /(^-|-$)/g;
function $07090e743135ae89$var$k(e) {
    return e.replace($07090e743135ae89$var$R, "-").replace($07090e743135ae89$var$j, "");
}
const $07090e743135ae89$var$T = /(a)(d)/gi, $07090e743135ae89$var$D = (e)=>String.fromCharCode(e + (e > 25 ? 39 : 97));
function $07090e743135ae89$var$V(e) {
    let t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $07090e743135ae89$var$D(t % 52) + n;
    return ($07090e743135ae89$var$D(t % 52) + n).replace($07090e743135ae89$var$T, "$1-$2");
}
const $07090e743135ae89$var$M = 5381, $07090e743135ae89$var$G = (e, t)=>{
    let n = t.length;
    for(; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $07090e743135ae89$var$F = (e)=>$07090e743135ae89$var$G($07090e743135ae89$var$M, e);
function $07090e743135ae89$var$z(e) {
    return $07090e743135ae89$var$V($07090e743135ae89$var$F(e) >>> 0);
}
function $07090e743135ae89$var$W(e) {
    return e.displayName || e.name || "Component";
}
function $07090e743135ae89$var$L(e) {
    return "string" == typeof e && true;
}
function $07090e743135ae89$var$B(e) {
    return $07090e743135ae89$var$L(e) ? `styled.${e}` : `Styled(${$07090e743135ae89$var$W(e)})`;
}
const $07090e743135ae89$var$q = Symbol.for("react.memo"), $07090e743135ae89$var$H = Symbol.for("react.forward_ref"), $07090e743135ae89$var$Y = {
    contextType: !0,
    defaultProps: !0,
    displayName: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    propTypes: !0,
    type: !0
}, $07090e743135ae89$var$U = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $07090e743135ae89$var$J = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $07090e743135ae89$var$X = {
    [$07090e743135ae89$var$H]: {
        $$typeof: !0,
        render: !0,
        defaultProps: !0,
        displayName: !0,
        propTypes: !0
    },
    [$07090e743135ae89$var$q]: $07090e743135ae89$var$J
};
function $07090e743135ae89$var$K(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === $07090e743135ae89$var$q ? $07090e743135ae89$var$J : "$$typeof" in e ? $07090e743135ae89$var$X[e.$$typeof] : $07090e743135ae89$var$Y;
}
const $07090e743135ae89$var$Q = Object.defineProperty, $07090e743135ae89$var$Z = Object.getOwnPropertyNames, $07090e743135ae89$var$ee = Object.getOwnPropertySymbols, $07090e743135ae89$var$te = Object.getOwnPropertyDescriptor, $07090e743135ae89$var$ne = Object.getPrototypeOf, $07090e743135ae89$var$oe = Object.prototype;
function $07090e743135ae89$var$se(e, t, n) {
    if ("string" != typeof t) {
        const o = $07090e743135ae89$var$ne(t);
        o && o !== $07090e743135ae89$var$oe && $07090e743135ae89$var$se(e, o, n);
        const s = $07090e743135ae89$var$Z(t).concat($07090e743135ae89$var$ee(t)), r = $07090e743135ae89$var$K(e), i = $07090e743135ae89$var$K(t);
        for(let o = 0; o < s.length; ++o){
            const a = s[o];
            if (!(a in $07090e743135ae89$var$U || n && n[a] || i && a in i || r && a in r)) {
                const n = $07090e743135ae89$var$te(t, a);
                try {
                    $07090e743135ae89$var$Q(e, a, n);
                } catch (e) {}
            }
        }
    }
    return e;
}
function $07090e743135ae89$var$re(e) {
    return "function" == typeof e;
}
const $07090e743135ae89$var$ie = Symbol.for("react.forward_ref");
function $07090e743135ae89$export$7ba318d8d2f06c76(e) {
    return null != e && ("object" == typeof e || "function" == typeof e) && e.$$typeof === $07090e743135ae89$var$ie && "styledComponentId" in e;
}
function $07090e743135ae89$var$ce(e, t) {
    return e && t ? e + " " + t : e || t || "";
}
function $07090e743135ae89$var$le(e, t) {
    return e.join(t || "");
}
function $07090e743135ae89$var$ue(e) {
    return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function $07090e743135ae89$var$de(e, t, n = !1) {
    if (!n && !$07090e743135ae89$var$ue(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(let n = 0; n < t.length; n++)e[n] = $07090e743135ae89$var$de(e[n], t[n]);
    else if ($07090e743135ae89$var$ue(t)) for(const n in t)e[n] = $07090e743135ae89$var$de(e[n], t[n]);
    return e;
}
function $07090e743135ae89$var$he(e, t) {
    Object.defineProperty(e, "toString", {
        value: t
    });
}
const $07090e743135ae89$var$pe = class {
    constructor(e){
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e, this._cGroup = 0, this._cIndex = 0;
    }
    indexOfGroup(e) {
        if (e === this._cGroup) return this._cIndex;
        let t = this._cIndex;
        if (e > this._cGroup) for(let n = this._cGroup; n < e; n++)t += this.groupSizes[n];
        else for(let n = this._cGroup - 1; n >= e; n--)t -= this.groupSizes[n];
        return this._cGroup = e, this._cIndex = t, t;
    }
    insertRules(e, t) {
        if (e >= this.groupSizes.length) {
            const t = this.groupSizes, n = t.length;
            let o = n;
            for(; e >= o;)if (o <<= 1, o < 0) throw $07090e743135ae89$var$i(16, `${e}`);
            this.groupSizes = new Uint32Array(o), this.groupSizes.set(t), this.length = o;
            for(let e = n; e < o; e++)this.groupSizes[e] = 0;
        }
        let n = this.indexOfGroup(e + 1), o = 0;
        for(let s = 0, r = t.length; s < r; s++)this.tag.insertRule(n, t[s]) && (this.groupSizes[e]++, n++, o++);
        o > 0 && this._cGroup > e && (this._cIndex += o);
    }
    clearGroup(e) {
        if (e < this.length) {
            const t = this.groupSizes[e], n = this.indexOfGroup(e), o = n + t;
            this.groupSizes[e] = 0;
            for(let e = n; e < o; e++)this.tag.deleteRule(n);
            t > 0 && this._cGroup > e && (this._cIndex -= t);
        }
    }
    getGroup(e) {
        let t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        const n = this.groupSizes[e], o = this.indexOfGroup(e), s = o + n;
        for(let e = o; e < s; e++)t += this.tag.getRule(e) + $07090e743135ae89$var$p;
        return t;
    }
}, $07090e743135ae89$var$fe = `style[${$07090e743135ae89$var$l}][${$07090e743135ae89$var$d}="${$07090e743135ae89$export$83d89fbfd8236492}"]`, $07090e743135ae89$var$me = new RegExp(`^${$07090e743135ae89$var$l}\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)`);
let $07090e743135ae89$var$ye = !1;
const $07090e743135ae89$var$ge = (e)=>"undefined" != typeof ShadowRoot && e instanceof ShadowRoot || "host" in e && 11 === e.nodeType, $07090e743135ae89$var$ve = (e)=>{
    if (!e) return document;
    if ($07090e743135ae89$var$ge(e)) return e;
    if ("getRootNode" in e) {
        const t = e.getRootNode();
        if ($07090e743135ae89$var$ge(t)) return t;
    }
    return document;
}, $07090e743135ae89$var$Se = (e, t, n)=>{
    const o = n.split(",");
    let s;
    for(let n = 0, r = o.length; n < r; n++)(s = o[n]) && e.registerName(t, s);
}, $07090e743135ae89$var$be = (e, t)=>{
    var n;
    const o = (null !== (n = t.textContent) && void 0 !== n ? n : "").split($07090e743135ae89$var$p), s = [];
    for(let t = 0, n = o.length; t < n; t++){
        const n = o[t].trim();
        if (!n) continue;
        const r = n.match($07090e743135ae89$var$me);
        if (r) {
            const t = 0 | parseInt(r[1], 10), n = r[2];
            0 !== t && ($07090e743135ae89$var$E(n, t), $07090e743135ae89$var$Se(e, n, r[3]), e.getTag().insertRules(t, s)), s.length = 0;
        } else s.push(n);
    }
}, $07090e743135ae89$var$we = (e)=>{
    const t = $07090e743135ae89$var$ve(e.options.target);
    ((e)=>{})(t);
    const n = t.querySelectorAll($07090e743135ae89$var$fe);
    for(let t = 0, o = n.length; t < o; t++){
        const o = n[t];
        o && o.getAttribute($07090e743135ae89$var$l) !== $07090e743135ae89$var$u && ($07090e743135ae89$var$be(e, o), o.parentNode && o.parentNode.removeChild(o));
    }
};
let $07090e743135ae89$var$Ne = !1;
function $07090e743135ae89$var$Ce() {
    if (!1 !== $07090e743135ae89$var$Ne) return $07090e743135ae89$var$Ne;
    if ("undefined" != typeof document) {
        const e = document.head.querySelector('meta[property="csp-nonce"]');
        if (e) return $07090e743135ae89$var$Ne = e.nonce || e.getAttribute("content") || void 0;
        const t = document.head.querySelector('meta[name="sc-nonce"]');
        if (t) return $07090e743135ae89$var$Ne = t.getAttribute("content") || void 0;
    }
    return $07090e743135ae89$var$Ne = "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : void 0;
}
const $07090e743135ae89$var$Oe = (e, t)=>{
    if ("undefined" == typeof document) throw $07090e743135ae89$var$i(20);
    const n = document.head, o = e || n, s = document.createElement("style"), r = ((e)=>{
        const t = Array.from(e.querySelectorAll(`style[${$07090e743135ae89$var$l}]`));
        return t[t.length - 1];
    })(o), a = void 0 !== r ? r.nextSibling : null;
    s.setAttribute($07090e743135ae89$var$l, $07090e743135ae89$var$u), s.setAttribute($07090e743135ae89$var$d, $07090e743135ae89$export$83d89fbfd8236492);
    const c = t || $07090e743135ae89$var$Ce();
    return c && s.setAttribute("nonce", c), o.insertBefore(s, a), s;
}, $07090e743135ae89$var$Ee = class {
    constructor(e, t){
        this.element = $07090e743135ae89$var$Oe(e, t), this.element.appendChild(document.createTextNode("")), this.sheet = ((e)=>{
            var t;
            if (e.sheet) return e.sheet;
            const n = null !== (t = e.getRootNode().styleSheets) && void 0 !== t ? t : document.styleSheets;
            for(let t = 0, o = n.length; t < o; t++){
                const o = n[t];
                if (o.ownerNode === e) return o;
            }
            throw $07090e743135ae89$var$i(17);
        })(this.element), this.length = 0;
    }
    insertRule(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }
    deleteRule(e) {
        this.sheet.deleteRule(e), this.length--;
    }
    getRule(e) {
        const t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }
}, $07090e743135ae89$var$Ae = class {
    constructor(e, t){
        this.element = $07090e743135ae89$var$Oe(e, t), this.nodes = this.element.childNodes, this.length = 0;
    }
    insertRule(e, t) {
        if (e <= this.length && e >= 0) {
            const n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }
    deleteRule(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }
    getRule(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }
};
let $07090e743135ae89$var$Pe = $07090e743135ae89$var$f;
const $07090e743135ae89$var$_e = {
    isServer: !$07090e743135ae89$var$f,
    useCSSOMInjection: !$07090e743135ae89$var$y
};
class $07090e743135ae89$var$$e {
    static registerId(e) {
        return $07090e743135ae89$var$C(e);
    }
    constructor(e = $07090e743135ae89$var$I, t = {}, n){
        this.options = Object.assign(Object.assign({}, $07090e743135ae89$var$_e), e), this.gs = t, this.keyframeIds = new Set, this.names = new Map(n), this.server = !!e.isServer, !this.server && $07090e743135ae89$var$f && $07090e743135ae89$var$Pe && ($07090e743135ae89$var$Pe = !1, $07090e743135ae89$var$we(this)), $07090e743135ae89$var$he(this, ()=>((e)=>{
                const t = e.getTag(), { length: n } = t;
                let o = "";
                for(let s = 0; s < n; s++){
                    const n = $07090e743135ae89$var$O(s);
                    if (void 0 === n) continue;
                    const r = e.names.get(n);
                    if (void 0 === r || !r.size) continue;
                    const i = t.getGroup(s);
                    if (0 === i.length) continue;
                    const a = $07090e743135ae89$var$l + ".g" + s + '[id="' + n + '"]';
                    let c = "";
                    for (const e of r)e.length > 0 && (c += e + ",");
                    o += i + a + '{content:"' + c + '"}' + $07090e743135ae89$var$p;
                }
                return o;
            })(this));
    }
    rehydrate() {
        !this.server && $07090e743135ae89$var$f && $07090e743135ae89$var$we(this);
    }
    reconstructWithOptions(e, t = !0) {
        const n = new $07090e743135ae89$var$$e(Object.assign(Object.assign({}, this.options), e), this.gs, t && this.names || void 0);
        return n.keyframeIds = new Set(this.keyframeIds), !this.server && $07090e743135ae89$var$f && e.target !== this.options.target && $07090e743135ae89$var$ve(this.options.target) !== $07090e743135ae89$var$ve(e.target) && $07090e743135ae89$var$we(n), n;
    }
    allocateGSInstance(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }
    getTag() {
        var e;
        return this.tag || (this.tag = (e = (({ useCSSOMInjection: e, target: t, nonce: n })=>e ? new $07090e743135ae89$var$Ee(t, n) : new $07090e743135ae89$var$Ae(t, n))(this.options), new $07090e743135ae89$var$pe(e)));
    }
    hasNameForId(e, t) {
        var n, o;
        return null !== (o = null === (n = this.names.get(e)) || void 0 === n ? void 0 : n.has(t)) && void 0 !== o && o;
    }
    registerName(e, t) {
        $07090e743135ae89$var$C(e), e.startsWith($07090e743135ae89$var$g) && this.keyframeIds.add(e);
        const n = this.names.get(e);
        n ? n.add(t) : this.names.set(e, new Set([
            t
        ]));
    }
    insertRules(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($07090e743135ae89$var$C(e), n);
    }
    clearNames(e) {
        this.names.has(e) && this.names.get(e).clear();
    }
    clearRules(e) {
        this.getTag().clearGroup($07090e743135ae89$var$C(e)), this.clearNames(e);
    }
    clearTag() {
        this.tag = void 0;
    }
}
const $07090e743135ae89$var$Ie = new WeakSet, $07090e743135ae89$var$xe = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexShrink: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
function $07090e743135ae89$var$Re(e, t) {
    return null == t || "boolean" == typeof t || "" === t ? "" : "number" != typeof t || 0 === t || e in $07090e743135ae89$var$xe || e.startsWith("--") ? String(t).trim() : t + "px";
}
const $07090e743135ae89$var$je = 47;
function $07090e743135ae89$var$ke(e) {
    if (45 === e.charCodeAt(0) && 45 === e.charCodeAt(1)) return e;
    let t = "";
    for(let n = 0; n < e.length; n++){
        const o = e.charCodeAt(n);
        t += o >= 65 && o <= 90 ? "-" + String.fromCharCode(o + 32) : e[n];
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
const $07090e743135ae89$var$Te = Symbol.for("sc-keyframes");
function $07090e743135ae89$var$De(e) {
    return "object" == typeof e && null !== e && $07090e743135ae89$var$Te in e;
}
function $07090e743135ae89$var$Ve(e) {
    return $07090e743135ae89$var$re(e) && !(e.prototype && e.prototype.isReactComponent);
}
const $07090e743135ae89$var$Me = (e)=>null == e || !1 === e || "" === e, $07090e743135ae89$var$Ge = Symbol.for("react.client.reference");
function $07090e743135ae89$var$Fe(e) {
    return e.$$typeof === $07090e743135ae89$var$Ge;
}
function $07090e743135ae89$var$ze(e) {
    const t = e.$$id, n = (t && t.includes("#") ? t.split("#").pop() : t) || e.name || "unknown";
    console.warn(`Interpolating a client component (${n}) as a selector is not supported in server components. The component selector pattern requires access to the component's internal class name, which is not available across the server/client boundary. Use a plain CSS class selector instead.`);
}
function $07090e743135ae89$var$We(e, t) {
    for(const n in e){
        const o = e[n];
        e.hasOwnProperty(n) && !$07090e743135ae89$var$Me(o) && (Array.isArray(o) && $07090e743135ae89$var$Ie.has(o) || $07090e743135ae89$var$re(o) ? t.push($07090e743135ae89$var$ke(n) + ":", o, ";") : $07090e743135ae89$var$ue(o) ? (t.push(n + " {"), $07090e743135ae89$var$We(o, t), t.push("}")) : t.push($07090e743135ae89$var$ke(n) + ": " + $07090e743135ae89$var$Re(n, o) + ";"));
    }
}
function $07090e743135ae89$var$Le(e, t, n, o, s = []) {
    if ($07090e743135ae89$var$Me(e)) return s;
    const r = typeof e;
    if ("string" === r) return s.push(e), s;
    if ("function" === r) {
        if ($07090e743135ae89$var$Fe(e)) return s;
        if ($07090e743135ae89$var$Ve(e) && t) {
            const r = e(t);
            return $07090e743135ae89$var$Le(r, t, n, o, s);
        }
        return s.push(e), s;
    }
    if (Array.isArray(e)) {
        for(let r = 0; r < e.length; r++)$07090e743135ae89$var$Le(e[r], t, n, o, s);
        return s;
    }
    return $07090e743135ae89$export$7ba318d8d2f06c76(e) ? (s.push(`.${e.styledComponentId}`), s) : $07090e743135ae89$var$De(e) ? (n ? (e.inject(n, o), s.push(e.getName(o))) : s.push(e), s) : $07090e743135ae89$var$Fe(e) ? s : $07090e743135ae89$var$ue(e) ? e.toString !== Object.prototype.toString ? (s.push(e.toString()), s) : ($07090e743135ae89$var$We(e, s), s) : (s.push(e.toString()), s);
}
const $07090e743135ae89$var$Be = $07090e743135ae89$var$F($07090e743135ae89$export$83d89fbfd8236492);
class $07090e743135ae89$var$qe {
    constructor(e, t, n){
        this.rules = e, this.componentId = t, this.baseHash = $07090e743135ae89$var$G($07090e743135ae89$var$Be, t), this.baseStyle = n, $07090e743135ae89$var$$e.registerId(t);
    }
    generateAndInjectStyles(e, t, n) {
        let o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
        {
            let s = "";
            for(let o = 0; o < this.rules.length; o++){
                const r = this.rules[o];
                if ("string" == typeof r) s += r;
                else if (r) {
                    if ($07090e743135ae89$var$Ve(r)) {
                        const o = r(e);
                        "string" == typeof o ? s += o : null != o && !1 !== o && (s += $07090e743135ae89$var$le($07090e743135ae89$var$Le(o, e, t, n)));
                    } else s += $07090e743135ae89$var$le($07090e743135ae89$var$Le(r, e, t, n));
                }
            }
            if (s) {
                this.dynamicNameCache || (this.dynamicNameCache = new Map);
                const e = n.hash ? n.hash + s : s;
                let r = this.dynamicNameCache.get(e);
                if (!r) {
                    if (r = $07090e743135ae89$var$V($07090e743135ae89$var$G($07090e743135ae89$var$G(this.baseHash, n.hash), s) >>> 0), this.dynamicNameCache.size >= 200) {
                        const e = this.dynamicNameCache.keys().next().value;
                        void 0 !== e && this.dynamicNameCache.delete(e);
                    }
                    this.dynamicNameCache.set(e, r);
                }
                if (!t.hasNameForId(this.componentId, r)) {
                    const e = n(s, "." + r, void 0, this.componentId);
                    t.insertRules(this.componentId, r, e);
                }
                o = $07090e743135ae89$var$ce(o, r);
            }
        }
        return o;
    }
}
const $07090e743135ae89$var$He = /&/g;
function $07090e743135ae89$var$Ye(e, t) {
    let n = 0;
    for(; --t >= 0 && 92 === e.charCodeAt(t);)n++;
    return !(1 & ~n);
}
function $07090e743135ae89$var$Ue(e) {
    const t = e.length;
    let n = "", o = 0, s = 0, r = 0, i = !1, a = !1;
    for(let c = 0; c < t; c++){
        const l = e.charCodeAt(c);
        if (0 !== r || i || l !== $07090e743135ae89$var$je || 42 !== e.charCodeAt(c + 1)) {
            if (i) 42 === l && e.charCodeAt(c + 1) === $07090e743135ae89$var$je && (i = !1, c++);
            else if (34 !== l && 39 !== l || $07090e743135ae89$var$Ye(e, c)) {
                if (0 === r) {
                    if (123 === l) s++;
                    else if (125 === l) {
                        if (s--, s < 0) {
                            a = !0;
                            let n = c + 1;
                            for(; n < t;){
                                const t = e.charCodeAt(n);
                                if (59 === t || 10 === t) break;
                                n++;
                            }
                            n < t && 59 === e.charCodeAt(n) && n++, s = 0, c = n - 1, o = n;
                            continue;
                        }
                        0 === s && (n += e.substring(o, c + 1), o = c + 1);
                    } else 59 === l && 0 === s && (n += e.substring(o, c + 1), o = c + 1);
                }
            } else 0 === r ? r = l : r === l && (r = 0);
        } else i = !0, c++;
    }
    return a || 0 !== s || 0 !== r ? (o < t && 0 === s && 0 === r && (n += e.substring(o)), n) : e;
}
function $07090e743135ae89$var$Je(e, t) {
    const n = t + " ", o = "," + n;
    for(let s = 0; s < e.length; s++){
        const r = e[s];
        if ("rule" === r.type) {
            r.value = (n + r.value).replaceAll(",", o);
            const e = r.props, t = [];
            for(let o = 0; o < e.length; o++)t[o] = n + e[o];
            r.props = t;
        }
        Array.isArray(r.children) && "@keyframes" !== r.type && $07090e743135ae89$var$Je(r.children, t);
    }
    return e;
}
function $07090e743135ae89$var$Xe({ options: e = $07090e743135ae89$var$I, plugins: t = $07090e743135ae89$var$$ } = $07090e743135ae89$var$I) {
    let n, s, r;
    const a = (e, t, o)=>o.startsWith(s) && o.endsWith(s) && o.replaceAll(s, "").length > 0 ? `.${n}` : e, c = t.slice();
    c.push((e)=>{
        e.type === $14f7c1b46e1d219f$export$aa3a2e812ca8570d && e.value.includes("&") && (r || (r = new RegExp(`\\${s}\\b`, "g")), e.props[0] = e.props[0].replace($07090e743135ae89$var$He, s).replace(r, a));
    }), e.prefix && c.push($66e69a28cf94fb87$export$e08c7d021b829b7a), c.push($4f9dba64a0f6480c$export$fac44ee5b035f737);
    let l = [];
    const u = $66e69a28cf94fb87$export$5a7767152ae0305f(c.concat($66e69a28cf94fb87$export$38bcb760f1d4871c((e)=>l.push(e)))), d = (t, i = "", a = "", c = "&")=>{
        n = c, s = i, r = void 0;
        const d = function(e) {
            const t = -1 !== e.indexOf("//"), n = -1 !== e.indexOf("}");
            if (!t && !n) return e;
            if (!t) return $07090e743135ae89$var$Ue(e);
            const o = e.length;
            let s = "", r = 0, i = 0, a = 0, c = 0, l = 0, u = !1;
            for(; i < o;){
                const t = e.charCodeAt(i);
                if (34 !== t && 39 !== t || $07090e743135ae89$var$Ye(e, i)) {
                    if (0 === a) {
                        if (t === $07090e743135ae89$var$je && i + 1 < o && 42 === e.charCodeAt(i + 1)) {
                            for(i += 2; i + 1 < o && (42 !== e.charCodeAt(i) || e.charCodeAt(i + 1) !== $07090e743135ae89$var$je);)i++;
                            i += 2;
                        } else if (40 !== t) {
                            if (41 !== t) {
                                if (c > 0) i++;
                                else if (42 === t && i + 1 < o && e.charCodeAt(i + 1) === $07090e743135ae89$var$je) s += e.substring(r, i), i += 2, r = i, u = !0;
                                else if (t === $07090e743135ae89$var$je && i + 1 < o && e.charCodeAt(i + 1) === $07090e743135ae89$var$je) {
                                    for(s += e.substring(r, i); i < o && 10 !== e.charCodeAt(i);)i++;
                                    r = i, u = !0;
                                } else 123 === t ? l++ : 125 === t && l--, i++;
                            } else c > 0 && c--, i++;
                        } else c++, i++;
                    } else i++;
                } else 0 === a ? a = t : a === t && (a = 0), i++;
            }
            return u ? (r < o && (s += e.substring(r)), 0 === l ? s : $07090e743135ae89$var$Ue(s)) : 0 === l ? e : $07090e743135ae89$var$Ue(e);
        }(t);
        let h = $0da293b81cdc2df3$export$ef7acd7185315e22(a || i ? a + " " + i + " { " + d + " }" : d);
        return e.namespace && (h = $07090e743135ae89$var$Je(h, e.namespace)), l = [], $4f9dba64a0f6480c$export$dfdc1655ccc5b9cb(h, u), l;
    }, h = e;
    let p = $07090e743135ae89$var$M;
    for(let e = 0; e < t.length; e++)t[e].name || $07090e743135ae89$var$i(15), p = $07090e743135ae89$var$G(p, t[e].name);
    return (null == h ? void 0 : h.namespace) && (p = $07090e743135ae89$var$G(p, h.namespace)), (null == h ? void 0 : h.prefix) && (p = $07090e743135ae89$var$G(p, "p")), d.hash = p !== $07090e743135ae89$var$M ? p.toString() : "", d;
}
const $07090e743135ae89$var$Ke = new $07090e743135ae89$var$$e, $07090e743135ae89$var$Qe = $07090e743135ae89$var$Xe(), $07090e743135ae89$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createContext({
    shouldForwardProp: void 0,
    styleSheet: $07090e743135ae89$var$Ke,
    stylis: $07090e743135ae89$var$Qe,
    stylisPlugins: void 0
}), $07090e743135ae89$export$91317688fc694efa = $07090e743135ae89$export$8c190ef828af4c86.Consumer;
function $07090e743135ae89$var$tt() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useContext($07090e743135ae89$export$8c190ef828af4c86);
}
function $07090e743135ae89$export$a473771da2f0ff7c(e) {
    var n;
    const o = $07090e743135ae89$var$tt(), { styleSheet: s } = o, r = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useMemo(()=>{
        let t = s;
        return e.sheet ? t = e.sheet : e.target ? t = t.reconstructWithOptions(void 0 !== e.nonce ? {
            target: e.target,
            nonce: e.nonce
        } : {
            target: e.target
        }, !1) : void 0 !== e.nonce && (t = t.reconstructWithOptions({
            nonce: e.nonce
        })), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.nonce,
        e.sheet,
        e.target,
        s
    ]), i = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useMemo(()=>{
        var t;
        return void 0 === e.stylisPlugins && void 0 === e.namespace && void 0 === e.enableVendorPrefixes ? o.stylis : $07090e743135ae89$var$Xe({
            options: {
                namespace: e.namespace,
                prefix: e.enableVendorPrefixes
            },
            plugins: null !== (t = e.stylisPlugins) && void 0 !== t ? t : o.stylisPlugins
        });
    }, [
        e.enableVendorPrefixes,
        e.namespace,
        e.stylisPlugins,
        o.stylis,
        o.stylisPlugins
    ]), a = "shouldForwardProp" in e ? e.shouldForwardProp : o.shouldForwardProp, c = null !== (n = e.stylisPlugins) && void 0 !== n ? n : o.stylisPlugins, l = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useMemo(()=>({
            shouldForwardProp: a,
            styleSheet: r,
            stylis: i,
            stylisPlugins: c
        }), [
        a,
        r,
        i,
        c
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement($07090e743135ae89$export$8c190ef828af4c86.Provider, {
        value: l
    }, e.children);
}
const $07090e743135ae89$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createContext(void 0), $07090e743135ae89$export$b631efc24e9d5e2f = $07090e743135ae89$export$2c657da244d00bd6.Consumer;
function $07090e743135ae89$export$93d4e7f90805808f() {
    const e = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useContext($07090e743135ae89$export$2c657da244d00bd6);
    if (!e) throw $07090e743135ae89$var$i(18);
    return e;
}
function $07090e743135ae89$export$d8964aec282183a3(e) {
    const n = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useContext($07090e743135ae89$export$2c657da244d00bd6), o = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useMemo(()=>(function(e, t) {
            if (!e) throw $07090e743135ae89$var$i(14);
            if ($07090e743135ae89$var$re(e)) {
                const n = e(t);
                return n;
            }
            if (Array.isArray(e) || "object" != typeof e) throw $07090e743135ae89$var$i(8);
            return t ? Object.assign(Object.assign({}, t), e) : e;
        })(e.theme, n), [
        e.theme,
        n
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement($07090e743135ae89$export$2c657da244d00bd6.Provider, {
        value: o
    }, e.children) : null;
}
const $07090e743135ae89$var$at = {};
function $07090e743135ae89$var$ct(e, t) {
    const n = "string" != typeof e ? "sc" : $07090e743135ae89$var$k(e);
    $07090e743135ae89$var$at[n] = ($07090e743135ae89$var$at[n] || 0) + 1;
    const o = n + "-" + $07090e743135ae89$var$z($07090e743135ae89$export$83d89fbfd8236492 + n + $07090e743135ae89$var$at[n]);
    return t ? t + "-" + o : o;
}
let $07090e743135ae89$var$lt;
function $07090e743135ae89$var$ut(o, s, r) {
    const i = $07090e743135ae89$export$7ba318d8d2f06c76(o), a = o, c = !$07090e743135ae89$var$L(o), { attrs: l = $07090e743135ae89$var$$, componentId: u = $07090e743135ae89$var$ct(s.displayName, s.parentComponentId), displayName: d = $07090e743135ae89$var$B(o) } = s, h = s.displayName && s.componentId ? $07090e743135ae89$var$k(s.displayName) + "-" + s.componentId : s.componentId || u, p = i && a.attrs ? a.attrs.concat(l).filter(Boolean) : l;
    let { shouldForwardProp: f } = s;
    if (i && a.shouldForwardProp) {
        const e = a.shouldForwardProp;
        if (s.shouldForwardProp) {
            const t = s.shouldForwardProp;
            f = (n, o)=>e(n, o) && t(n, o);
        } else f = e;
    }
    const m = new $07090e743135ae89$var$qe(r, h, i ? a.componentStyle : void 0);
    function y(o, s) {
        return function(o, s, r) {
            const { attrs: i, componentStyle: a, defaultProps: c, foldedComponentIds: l, styledComponentId: u, target: d } = o, h = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useContext($07090e743135ae89$export$2c657da244d00bd6), p = $07090e743135ae89$var$tt(), f = o.shouldForwardProp || p.shouldForwardProp;
            const m = $07090e743135ae89$var$x(s, h, c) || $07090e743135ae89$var$I, [y, g] = function(e, t, n) {
                const o = Object.assign(Object.assign({}, t), {
                    className: void 0,
                    theme: n
                });
                let s = null;
                const r = e.length > 1;
                for(let t = 0; t < e.length; t++){
                    const n = e[t], i = $07090e743135ae89$var$re(n) ? n(r ? Object.assign({}, o) : o) : n;
                    for(const e in i)"className" === e ? o.className = $07090e743135ae89$var$ce(o.className, i[e]) : "style" === e ? o.style = Object.assign(Object.assign({}, o.style), i[e]) : void 0 === i[e] ? e in o && (void 0 !== o[e] && (s || (s = [])).push(e), o[e] = void 0) : o[e] = i[e];
                }
                return "className" in t && "string" == typeof t.className && (o.className = $07090e743135ae89$var$ce(o.className, t.className)), [
                    o,
                    s
                ];
            }(i, s, m), v = a.generateAndInjectStyles(y, p.styleSheet, p.stylis);
            const S = y.as || d, b = $07090e743135ae89$var$L(S), w = function(t, n, o, s, r, i) {
                const a = {};
                for(const c in t)"$" === c[0] || "as" === c || "theme" === c && t.theme === o || ("forwardedAs" === c ? void 0 !== t.forwardedAs && (a.as = t.forwardedAs) : void 0 === t[c] ? "className" === c || r || null !== i && -1 !== i.indexOf(c) || s && !s(c, n) || (a[c] = void 0) : s && !s(c, n) || (a[c] = t[c], s));
                return a;
            }(y, S, m, f, b, g);
            let N = $07090e743135ae89$var$ce(l, u);
            return v && (N += " " + v), y.className && (N += " " + y.className), w[b && S.includes("-") ? "class" : "className"] = N, r && (w.ref = r), (0, $5E6i4.createElement)(S, w);
        }(g, o, s);
    }
    y.displayName = d;
    let g = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).forwardRef(y);
    return g.attrs = p, g.componentStyle = m, g.displayName = d, g.shouldForwardProp = f, g.foldedComponentIds = i ? $07090e743135ae89$var$ce(a.foldedComponentIds, a.styledComponentId) : "", g.styledComponentId = h, g.target = i ? a.target : o, Object.defineProperty(g, "defaultProps", {
        get () {
            return this._foldedDefaultProps;
        },
        set (e) {
            this._foldedDefaultProps = i ? function(e, ...t) {
                for (const n of t)$07090e743135ae89$var$de(e, n, !0);
                return e;
            }({}, a.defaultProps, e) : e;
        }
    }), $07090e743135ae89$var$he(g, ()=>`.${g.styledComponentId}`), c && $07090e743135ae89$var$se(g, o, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), g;
}
var $07090e743135ae89$var$dt = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "bdi",
    "bdo",
    "blockquote",
    "body",
    "button",
    "br",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "label",
    "legend",
    "li",
    "main",
    "map",
    "mark",
    "menu",
    "meter",
    "nav",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "search",
    "section",
    "select",
    "slot",
    "small",
    "span",
    "strong",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "template",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "filter",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "switch",
    "symbol",
    "text",
    "textPath",
    "tspan",
    "use"
]);
function $07090e743135ae89$var$ht(e, t) {
    const n = [
        e[0]
    ];
    for(let o = 0, s = t.length; o < s; o += 1)n.push(t[o], e[o + 1]);
    return n;
}
const $07090e743135ae89$var$pt = (e)=>($07090e743135ae89$var$Ie.add(e), e);
function $07090e743135ae89$export$dbf350e5966cf602(e, ...t) {
    if ($07090e743135ae89$var$re(e) || $07090e743135ae89$var$ue(e)) return $07090e743135ae89$var$pt($07090e743135ae89$var$Le($07090e743135ae89$var$ht($07090e743135ae89$var$$, [
        e,
        ...t
    ])));
    const n = e;
    return 0 === t.length && 1 === n.length && "string" == typeof n[0] ? $07090e743135ae89$var$Le(n) : $07090e743135ae89$var$pt($07090e743135ae89$var$Le($07090e743135ae89$var$ht(n, t)));
}
function $07090e743135ae89$var$mt(e, t, n = $07090e743135ae89$var$I) {
    if (!t) throw $07090e743135ae89$var$i(1, t);
    const o = (o, ...s)=>e(t, n, $07090e743135ae89$export$dbf350e5966cf602(o, ...s));
    return o.attrs = (o)=>$07090e743135ae89$var$mt(e, t, Object.assign(Object.assign({}, n), {
            attrs: Array.prototype.concat(n.attrs, o).filter(Boolean)
        })), o.withConfig = (o)=>$07090e743135ae89$var$mt(e, t, Object.assign(Object.assign({}, n), o)), o;
}
const $07090e743135ae89$var$yt = (e)=>$07090e743135ae89$var$mt($07090e743135ae89$var$ut, e), $07090e743135ae89$export$2e2bcd8739ae039 = $07090e743135ae89$var$yt;
$07090e743135ae89$var$dt.forEach((e)=>{
    $07090e743135ae89$export$2e2bcd8739ae039[e] = $07090e743135ae89$var$yt(e);
});
class $07090e743135ae89$var$vt {
    constructor(e, t){
        this.instanceRules = new Map, this.rules = e, this.componentId = t, this.isStatic = function(e) {
            for(let t = 0; t < e.length; t += 1){
                const n = e[t];
                if ($07090e743135ae89$var$re(n) && !$07090e743135ae89$export$7ba318d8d2f06c76(n)) return !1;
            }
            return !0;
        }(e), $07090e743135ae89$var$$e.registerId(this.componentId);
    }
    removeStyles(e, t) {
        this.instanceRules.delete(e), this.rebuildGroup(t);
    }
    renderStyles(e, t, n, o) {
        const s = this.componentId;
        if (this.isStatic) {
            if (n.hasNameForId(s, s + e)) this.instanceRules.has(e) || this.computeRules(e, t, n, o);
            else {
                const r = this.computeRules(e, t, n, o);
                n.insertRules(s, r.name, r.rules);
            }
            return;
        }
        const r = this.instanceRules.get(e);
        if (this.computeRules(e, t, n, o), !n.server && r) {
            const t = r.rules, n = this.instanceRules.get(e).rules;
            if (t.length === n.length) {
                let e = !0;
                for(let o = 0; o < t.length; o++)if (t[o] !== n[o]) {
                    e = !1;
                    break;
                }
                if (e) return;
            }
        }
        this.rebuildGroup(n);
    }
    computeRules(e, t, n, o) {
        const s = $07090e743135ae89$var$le($07090e743135ae89$var$Le(this.rules, t, n, o)), r = {
            name: this.componentId + e,
            rules: o(s, "")
        };
        return this.instanceRules.set(e, r), r;
    }
    rebuildGroup(e) {
        const t = this.componentId;
        e.clearRules(t);
        for (const n of this.instanceRules.values())e.insertRules(t, n.name, n.rules);
    }
}
function $07090e743135ae89$export$f0f03736edb61697(e, ...n) {
    const o = $07090e743135ae89$export$dbf350e5966cf602(e, ...n), s = `sc-global-${$07090e743135ae89$var$z(JSON.stringify(o))}`, r = new $07090e743135ae89$var$vt(o, s);
    const i = (e)=>{
        const n = $07090e743135ae89$var$tt(), i = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useContext($07090e743135ae89$export$2c657da244d00bd6);
        let c;
        {
            const e = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useRef(null);
            null === e.current && (e.current = n.styleSheet.allocateGSInstance(s)), c = e.current;
        }
        n.styleSheet.server && a(c, e, n.styleSheet, i, n.stylis);
        {
            const o = r.isStatic ? [
                c,
                n.styleSheet,
                r
            ] : [
                c,
                e,
                n.styleSheet,
                i,
                n.stylis,
                r
            ], l = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useRef(r);
            (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useLayoutEffect(()=>{
                n.styleSheet.server || (l.current !== r && (n.styleSheet.clearRules(s), l.current = r), a(c, e, n.styleSheet, i, n.stylis));
            }, o), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useLayoutEffect(()=>()=>{
                    n.styleSheet.server || r.removeStyles(c, n.styleSheet);
                }, [
                c,
                n.styleSheet,
                r
            ]);
        }
        return n.styleSheet.server && r.instanceRules.delete(c), null;
    };
    function a(e, t, n, o, s) {
        if (r.isStatic) r.renderStyles(e, $07090e743135ae89$var$v, n, s);
        else {
            const a = Object.assign(Object.assign({}, t), {
                theme: $07090e743135ae89$var$x(t, o, i.defaultProps)
            });
            r.renderStyles(e, a, n, s);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).memo(i);
}
function $07090e743135ae89$var$bt(e, t, n, o, s) {
    for(const r in e){
        const i = e[r], a = s ? s + "-" + r : r;
        if ("object" == typeof i && null !== i) {
            const e = {};
            $07090e743135ae89$var$bt(i, t, e, o, a), n[r] = e;
        } else n[r] = o(a, i, r);
    }
}
function $07090e743135ae89$var$wt(e, t, n, o) {
    let s = "";
    for(const r in e){
        const i = e[r], a = t[r], c = o ? o + "-" + r : r;
        "object" == typeof i && null !== i ? "object" == typeof a && null !== a && (s += $07090e743135ae89$var$wt(i, a, n, c)) : void 0 !== a && "function" != typeof a && (s += "--" + n + c + ":" + a + ";");
    }
    return s;
}
function $07090e743135ae89$export$25d302a5b900a763(e, t) {
    var n, o;
    const s = (null !== (n = null == t ? void 0 : t.prefix) && void 0 !== n ? n : "sc") + "-", r = null !== (o = null == t ? void 0 : t.selector) && void 0 !== o ? o : ":root", i = function(e, t) {
        const n = {};
        return $07090e743135ae89$var$bt(e, t, n, (e)=>"--" + t + e), n;
    }(e, s), a = function(e, t) {
        const n = {};
        return $07090e743135ae89$var$bt(e, t, n, (e, n)=>{
            return "var(--" + t + e + ", " + n + ")";
        }), n;
    }(e, s), c = $07090e743135ae89$export$f0f03736edb61697`
    ${r} {
      ${(t)=>$07090e743135ae89$var$wt(e, t.theme, s)}
    }
  `;
    return Object.assign(a, {
        GlobalStyle: c,
        raw: e,
        vars: i,
        resolve (t) {
            if (!$07090e743135ae89$var$f) throw new Error("createTheme.resolve() is client-only");
            const n = null != t ? t : document.documentElement;
            return function(e, t, n) {
                const o = {};
                return $07090e743135ae89$var$bt(e, t, o, (e, o)=>n.getPropertyValue("--" + t + e).trim() || o), o;
            }(e, s, getComputedStyle(n));
        }
    });
}
var $07090e743135ae89$var$Ct;
class $07090e743135ae89$var$Ot {
    constructor(e, t){
        this[$07090e743135ae89$var$Ct] = !0, this.inject = (e, t = $07090e743135ae89$var$Qe)=>{
            const n = this.getName(t);
            if (!e.hasNameForId(this.id, n)) {
                const o = t(this.rules, n, "@keyframes");
                e.insertRules(this.id, n, o);
            }
        }, this.name = e, this.id = $07090e743135ae89$var$g + e, this.rules = t, $07090e743135ae89$var$C(this.id), $07090e743135ae89$var$he(this, ()=>{
            throw $07090e743135ae89$var$i(12, String(this.name));
        });
    }
    getName(e = $07090e743135ae89$var$Qe) {
        return e.hash ? this.name + $07090e743135ae89$var$V(+e.hash >>> 0) : this.name;
    }
}
function $07090e743135ae89$export$d25ddfdf17c3ad3e(e, ...t) {
    const n = $07090e743135ae89$var$le($07090e743135ae89$export$dbf350e5966cf602(e, ...t)), o = $07090e743135ae89$var$z(n);
    return new $07090e743135ae89$var$Ot(o, n);
}
function $07090e743135ae89$export$e8748c6a27b910dc(e) {
    const n = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).forwardRef((n, o)=>{
        const s = $07090e743135ae89$var$x(n, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useContext($07090e743135ae89$export$2c657da244d00bd6), e.defaultProps);
        return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement(e, Object.assign(Object.assign({}, n), {
            theme: s,
            ref: o
        }));
    });
    return n.displayName = `WithTheme(${$07090e743135ae89$var$W(e)})`, $07090e743135ae89$var$se(n, e);
}
$07090e743135ae89$var$Ct = $07090e743135ae89$var$Te;
class $07090e743135ae89$export$ae8c7d15c8b89a20 {
    constructor({ nonce: e } = {}){
        this._emitSheetCSS = ()=>{
            const e = this.instance.toString();
            if (!e) return "";
            const t = this.instance.options.nonce || $07090e743135ae89$var$Ce();
            return `<style ${$07090e743135ae89$var$le([
                t && `nonce="${t}"`,
                `${$07090e743135ae89$var$l}="true"`,
                `${$07090e743135ae89$var$d}="${$07090e743135ae89$export$83d89fbfd8236492}"`
            ].filter(Boolean), " ")}>${e}</style>`;
        }, this.getStyleTags = ()=>{
            if (this.sealed) throw $07090e743135ae89$var$i(2);
            return this._emitSheetCSS();
        }, this.getStyleElement = ()=>{
            if (this.sealed) throw $07090e743135ae89$var$i(2);
            const e = this.instance.toString();
            if (!e) return [];
            const n = {
                [$07090e743135ae89$var$l]: "",
                [$07090e743135ae89$var$d]: $07090e743135ae89$export$83d89fbfd8236492,
                dangerouslySetInnerHTML: {
                    __html: e
                }
            }, o = this.instance.options.nonce || $07090e743135ae89$var$Ce();
            return o && (n.nonce = o), [
                (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("style", Object.assign({}, n, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = ()=>{
            this.sealed = !0;
        }, this.instance = new $07090e743135ae89$var$$e({
            isServer: !0,
            nonce: e
        }), this.sealed = !1;
    }
    collectStyles(e) {
        if (this.sealed) throw $07090e743135ae89$var$i(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement($07090e743135ae89$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }
    interleaveWithNodeStream(e) {
        throw $07090e743135ae89$var$i(3);
    }
}
const $07090e743135ae89$export$5c87cfe6c475f500 = {
    StyleSheet: $07090e743135ae89$var$$e,
    mainSheet: $07090e743135ae89$var$Ke
};
const $07090e743135ae89$var$$t = `__sc-${$07090e743135ae89$var$l}__`;
const $07090e743135ae89$var$It = /:(?:(first)-child|(last)-child|(only)-child|(nth-child)\(([^()]+)\)|(nth-last-child)\(([^()]+)\))/g, $07090e743135ae89$var$xt = `:not(style[${$07090e743135ae89$var$l}])`, $07090e743135ae89$var$Rt = `style[${$07090e743135ae89$var$l}]`;
function $07090e743135ae89$var$jt(e) {
    return -1 === e.indexOf("-child") ? e : ($07090e743135ae89$var$It.lastIndex = 0, e.replace($07090e743135ae89$var$It, (e, t, n, o, s, r, i, a)=>t ? `:nth-child(1 of ${$07090e743135ae89$var$xt})` : n ? `:nth-last-child(1 of ${$07090e743135ae89$var$xt})` : o ? `:nth-child(1 of ${$07090e743135ae89$var$xt}):nth-last-child(1 of ${$07090e743135ae89$var$xt})` : s ? -1 !== r.indexOf(" of ") ? e : `:nth-child(${r} of ${$07090e743135ae89$var$xt})` : -1 !== a.indexOf(" of ") ? e : `:nth-last-child(${a} of ${$07090e743135ae89$var$xt})`));
}
function $07090e743135ae89$var$kt(e, t) {
    if (-1 === e.indexOf("+")) return;
    let n = 0, o = 0;
    for(let s = 0; s < e.length; s++){
        const r = e.charCodeAt(s);
        if (40 === r) n++;
        else if (41 === r) n--;
        else if (91 === r) o++;
        else if (93 === r) o--;
        else if (43 === r && 0 === n && 0 === o && !$07090e743135ae89$var$Ye(e, s)) {
            const n = e.substring(0, s), o = e.substring(s + 1);
            t.push(n + "+" + $07090e743135ae89$var$Rt + "+" + o), t.push(n + "+" + $07090e743135ae89$var$Rt + "+" + $07090e743135ae89$var$Rt + "+" + o);
        }
    }
}
function $07090e743135ae89$export$337461d98bd2ad54(e) {
    if (e.type === (0, $14f7c1b46e1d219f$export$aa3a2e812ca8570d)) {
        const t = e.props, n = [];
        for(let e = 0; e < t.length; e++){
            const o = $07090e743135ae89$var$jt(t[e]);
            n.push(o), $07090e743135ae89$var$kt(o, n);
        }
        e.props = n;
    }
}


var $785b271c4db4a8c1$exports = {};
$785b271c4db4a8c1$exports = import.meta.resolve("h7ZwA");


var $ee66faefadc56a3e$exports = {};
$ee66faefadc56a3e$exports = import.meta.resolve("jqrXt");


// This file is autogenerated. It's used to publish ESM to npm.
function $a9ceb34ac62682a2$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $a9ceb34ac62682a2$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $a9ceb34ac62682a2$var$_typeof(obj);
}
// https://github.com/bgrins/TinyColor
// Brian Grinstead, MIT License
var $a9ceb34ac62682a2$var$trimLeft = /^\s+/;
var $a9ceb34ac62682a2$var$trimRight = /\s+$/;
function $a9ceb34ac62682a2$export$2e2bcd8739ae039(color, opts) {
    color = color ? color : "";
    opts = opts || {};
    // If input is already a tinycolor, return itself
    if (color instanceof $a9ceb34ac62682a2$export$2e2bcd8739ae039) return color;
    // If we are called as a function, call using new instead
    if (!(this instanceof $a9ceb34ac62682a2$export$2e2bcd8739ae039)) return new $a9ceb34ac62682a2$export$2e2bcd8739ae039(color, opts);
    var rgb = $a9ceb34ac62682a2$var$inputToRGB(color);
    this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb.format;
    this._gradientType = opts.gradientType;
    // Don't let the range of [0,255] come back in [0,1].
    // Potentially lose a little bit of precision here, but will fix issues where
    // .5 gets interpreted as half of the total, instead of half of 1
    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
    if (this._r < 1) this._r = Math.round(this._r);
    if (this._g < 1) this._g = Math.round(this._g);
    if (this._b < 1) this._b = Math.round(this._b);
    this._ok = rgb.ok;
}
$a9ceb34ac62682a2$export$2e2bcd8739ae039.prototype = {
    isDark: function isDark() {
        return this.getBrightness() < 128;
    },
    isLight: function isLight() {
        return !this.isDark();
    },
    isValid: function isValid() {
        return this._ok;
    },
    getOriginalInput: function getOriginalInput() {
        return this._originalInput;
    },
    getFormat: function getFormat() {
        return this._format;
    },
    getAlpha: function getAlpha() {
        return this._a;
    },
    getBrightness: function getBrightness() {
        //http://www.w3.org/TR/AERT#color-contrast
        var rgb = this.toRgb();
        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    },
    getLuminance: function getLuminance() {
        //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        var rgb = this.toRgb();
        var RsRGB, GsRGB, BsRGB, R, G, B;
        RsRGB = rgb.r / 255;
        GsRGB = rgb.g / 255;
        BsRGB = rgb.b / 255;
        if (RsRGB <= 0.03928) R = RsRGB / 12.92;
        else R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
        if (GsRGB <= 0.03928) G = GsRGB / 12.92;
        else G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
        if (BsRGB <= 0.03928) B = BsRGB / 12.92;
        else B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
        return 0.2126 * R + 0.7152 * G + 0.0722 * B;
    },
    setAlpha: function setAlpha(value) {
        this._a = $a9ceb34ac62682a2$var$boundAlpha(value);
        this._roundA = Math.round(100 * this._a) / 100;
        return this;
    },
    toHsv: function toHsv() {
        var hsv = $a9ceb34ac62682a2$var$rgbToHsv(this._r, this._g, this._b);
        return {
            h: hsv.h * 360,
            s: hsv.s,
            v: hsv.v,
            a: this._a
        };
    },
    toHsvString: function toHsvString() {
        var hsv = $a9ceb34ac62682a2$var$rgbToHsv(this._r, this._g, this._b);
        var h = Math.round(hsv.h * 360), s = Math.round(hsv.s * 100), v = Math.round(hsv.v * 100);
        return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
    },
    toHsl: function toHsl() {
        var hsl = $a9ceb34ac62682a2$var$rgbToHsl(this._r, this._g, this._b);
        return {
            h: hsl.h * 360,
            s: hsl.s,
            l: hsl.l,
            a: this._a
        };
    },
    toHslString: function toHslString() {
        var hsl = $a9ceb34ac62682a2$var$rgbToHsl(this._r, this._g, this._b);
        var h = Math.round(hsl.h * 360), s = Math.round(hsl.s * 100), l = Math.round(hsl.l * 100);
        return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
    },
    toHex: function toHex(allow3Char) {
        return $a9ceb34ac62682a2$var$rgbToHex(this._r, this._g, this._b, allow3Char);
    },
    toHexString: function toHexString(allow3Char) {
        return "#" + this.toHex(allow3Char);
    },
    toHex8: function toHex8(allow4Char) {
        return $a9ceb34ac62682a2$var$rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
    },
    toHex8String: function toHex8String(allow4Char) {
        return "#" + this.toHex8(allow4Char);
    },
    toRgb: function toRgb() {
        return {
            r: Math.round(this._r),
            g: Math.round(this._g),
            b: Math.round(this._b),
            a: this._a
        };
    },
    toRgbString: function toRgbString() {
        return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
    },
    toPercentageRgb: function toPercentageRgb() {
        return {
            r: Math.round($a9ceb34ac62682a2$var$bound01(this._r, 255) * 100) + "%",
            g: Math.round($a9ceb34ac62682a2$var$bound01(this._g, 255) * 100) + "%",
            b: Math.round($a9ceb34ac62682a2$var$bound01(this._b, 255) * 100) + "%",
            a: this._a
        };
    },
    toPercentageRgbString: function toPercentageRgbString() {
        return this._a == 1 ? "rgb(" + Math.round($a9ceb34ac62682a2$var$bound01(this._r, 255) * 100) + "%, " + Math.round($a9ceb34ac62682a2$var$bound01(this._g, 255) * 100) + "%, " + Math.round($a9ceb34ac62682a2$var$bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round($a9ceb34ac62682a2$var$bound01(this._r, 255) * 100) + "%, " + Math.round($a9ceb34ac62682a2$var$bound01(this._g, 255) * 100) + "%, " + Math.round($a9ceb34ac62682a2$var$bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
    },
    toName: function toName() {
        if (this._a === 0) return "transparent";
        if (this._a < 1) return false;
        return $a9ceb34ac62682a2$var$hexNames[$a9ceb34ac62682a2$var$rgbToHex(this._r, this._g, this._b, true)] || false;
    },
    toFilter: function toFilter(secondColor) {
        var hex8String = "#" + $a9ceb34ac62682a2$var$rgbaToArgbHex(this._r, this._g, this._b, this._a);
        var secondHex8String = hex8String;
        var gradientType = this._gradientType ? "GradientType = 1, " : "";
        if (secondColor) {
            var s = $a9ceb34ac62682a2$export$2e2bcd8739ae039(secondColor);
            secondHex8String = "#" + $a9ceb34ac62682a2$var$rgbaToArgbHex(s._r, s._g, s._b, s._a);
        }
        return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
    },
    toString: function toString(format) {
        var formatSet = !!format;
        format = format || this._format;
        var formattedString = false;
        var hasAlpha = this._a < 1 && this._a >= 0;
        var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
        if (needsAlphaFormat) {
            // Special case for "transparent", all other non-alpha formats
            // will return rgba when there is transparency.
            if (format === "name" && this._a === 0) return this.toName();
            return this.toRgbString();
        }
        if (format === "rgb") formattedString = this.toRgbString();
        if (format === "prgb") formattedString = this.toPercentageRgbString();
        if (format === "hex" || format === "hex6") formattedString = this.toHexString();
        if (format === "hex3") formattedString = this.toHexString(true);
        if (format === "hex4") formattedString = this.toHex8String(true);
        if (format === "hex8") formattedString = this.toHex8String();
        if (format === "name") formattedString = this.toName();
        if (format === "hsl") formattedString = this.toHslString();
        if (format === "hsv") formattedString = this.toHsvString();
        return formattedString || this.toHexString();
    },
    clone: function clone() {
        return $a9ceb34ac62682a2$export$2e2bcd8739ae039(this.toString());
    },
    _applyModification: function _applyModification(fn, args) {
        var color = fn.apply(null, [
            this
        ].concat([].slice.call(args)));
        this._r = color._r;
        this._g = color._g;
        this._b = color._b;
        this.setAlpha(color._a);
        return this;
    },
    lighten: function lighten() {
        return this._applyModification($a9ceb34ac62682a2$var$_lighten, arguments);
    },
    brighten: function brighten() {
        return this._applyModification($a9ceb34ac62682a2$var$_brighten, arguments);
    },
    darken: function darken() {
        return this._applyModification($a9ceb34ac62682a2$var$_darken, arguments);
    },
    desaturate: function desaturate() {
        return this._applyModification($a9ceb34ac62682a2$var$_desaturate, arguments);
    },
    saturate: function saturate() {
        return this._applyModification($a9ceb34ac62682a2$var$_saturate, arguments);
    },
    greyscale: function greyscale() {
        return this._applyModification($a9ceb34ac62682a2$var$_greyscale, arguments);
    },
    spin: function spin() {
        return this._applyModification($a9ceb34ac62682a2$var$_spin, arguments);
    },
    _applyCombination: function _applyCombination(fn, args) {
        return fn.apply(null, [
            this
        ].concat([].slice.call(args)));
    },
    analogous: function analogous() {
        return this._applyCombination($a9ceb34ac62682a2$var$_analogous, arguments);
    },
    complement: function complement() {
        return this._applyCombination($a9ceb34ac62682a2$var$_complement, arguments);
    },
    monochromatic: function monochromatic() {
        return this._applyCombination($a9ceb34ac62682a2$var$_monochromatic, arguments);
    },
    splitcomplement: function splitcomplement() {
        return this._applyCombination($a9ceb34ac62682a2$var$_splitcomplement, arguments);
    },
    // Disabled until https://github.com/bgrins/TinyColor/issues/254
    // polyad: function (number) {
    //   return this._applyCombination(polyad, [number]);
    // },
    triad: function triad() {
        return this._applyCombination($a9ceb34ac62682a2$var$polyad, [
            3
        ]);
    },
    tetrad: function tetrad() {
        return this._applyCombination($a9ceb34ac62682a2$var$polyad, [
            4
        ]);
    }
};
// If input is an object, force 1 into "1.0" to handle ratios properly
// String input requires "1.0" as input, so 1 will be treated as 1
$a9ceb34ac62682a2$export$2e2bcd8739ae039.fromRatio = function(color, opts) {
    if ($a9ceb34ac62682a2$var$_typeof(color) == "object") {
        var newColor = {};
        for(var i in color)if (color.hasOwnProperty(i)) {
            if (i === "a") newColor[i] = color[i];
            else newColor[i] = $a9ceb34ac62682a2$var$convertToPercentage(color[i]);
        }
        color = newColor;
    }
    return $a9ceb34ac62682a2$export$2e2bcd8739ae039(color, opts);
};
// Given a string or object, convert that input to RGB
// Possible string inputs:
//
//     "red"
//     "#f00" or "f00"
//     "#ff0000" or "ff0000"
//     "#ff000000" or "ff000000"
//     "rgb 255 0 0" or "rgb (255, 0, 0)"
//     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
//     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
//     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
//     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
//     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
//     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
//
function $a9ceb34ac62682a2$var$inputToRGB(color) {
    var rgb = {
        r: 0,
        g: 0,
        b: 0
    };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;
    if (typeof color == "string") color = $a9ceb34ac62682a2$var$stringInputToObject(color);
    if ($a9ceb34ac62682a2$var$_typeof(color) == "object") {
        if ($a9ceb34ac62682a2$var$isValidCSSUnit(color.r) && $a9ceb34ac62682a2$var$isValidCSSUnit(color.g) && $a9ceb34ac62682a2$var$isValidCSSUnit(color.b)) {
            rgb = $a9ceb34ac62682a2$var$rgbToRgb(color.r, color.g, color.b);
            ok = true;
            format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
        } else if ($a9ceb34ac62682a2$var$isValidCSSUnit(color.h) && $a9ceb34ac62682a2$var$isValidCSSUnit(color.s) && $a9ceb34ac62682a2$var$isValidCSSUnit(color.v)) {
            s = $a9ceb34ac62682a2$var$convertToPercentage(color.s);
            v = $a9ceb34ac62682a2$var$convertToPercentage(color.v);
            rgb = $a9ceb34ac62682a2$var$hsvToRgb(color.h, s, v);
            ok = true;
            format = "hsv";
        } else if ($a9ceb34ac62682a2$var$isValidCSSUnit(color.h) && $a9ceb34ac62682a2$var$isValidCSSUnit(color.s) && $a9ceb34ac62682a2$var$isValidCSSUnit(color.l)) {
            s = $a9ceb34ac62682a2$var$convertToPercentage(color.s);
            l = $a9ceb34ac62682a2$var$convertToPercentage(color.l);
            rgb = $a9ceb34ac62682a2$var$hslToRgb(color.h, s, l);
            ok = true;
            format = "hsl";
        }
        if (color.hasOwnProperty("a")) a = color.a;
    }
    a = $a9ceb34ac62682a2$var$boundAlpha(a);
    return {
        ok: ok,
        format: color.format || format,
        r: Math.min(255, Math.max(rgb.r, 0)),
        g: Math.min(255, Math.max(rgb.g, 0)),
        b: Math.min(255, Math.max(rgb.b, 0)),
        a: a
    };
}
// Conversion Functions
// --------------------
// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
// `rgbToRgb`
// Handle bounds / percentage checking to conform to CSS color spec
// <http://www.w3.org/TR/css3-color/>
// *Assumes:* r, g, b in [0, 255] or [0, 1]
// *Returns:* { r, g, b } in [0, 255]
function $a9ceb34ac62682a2$var$rgbToRgb(r, g, b) {
    return {
        r: $a9ceb34ac62682a2$var$bound01(r, 255) * 255,
        g: $a9ceb34ac62682a2$var$bound01(g, 255) * 255,
        b: $a9ceb34ac62682a2$var$bound01(b, 255) * 255
    };
}
// `rgbToHsl`
// Converts an RGB color value to HSL.
// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
// *Returns:* { h, s, l } in [0,1]
function $a9ceb34ac62682a2$var$rgbToHsl(r, g, b) {
    r = $a9ceb34ac62682a2$var$bound01(r, 255);
    g = $a9ceb34ac62682a2$var$bound01(g, 255);
    b = $a9ceb34ac62682a2$var$bound01(b, 255);
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h, s, l = (max + min) / 2;
    if (max == min) h = s = 0; // achromatic
    else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }
        h /= 6;
    }
    return {
        h: h,
        s: s,
        l: l
    };
}
// `hslToRgb`
// Converts an HSL color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function $a9ceb34ac62682a2$var$hslToRgb(h, s, l) {
    var r, g, b;
    h = $a9ceb34ac62682a2$var$bound01(h, 360);
    s = $a9ceb34ac62682a2$var$bound01(s, 100);
    l = $a9ceb34ac62682a2$var$bound01(l, 100);
    function hue2rgb(p, q, t) {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 0.5) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
    }
    if (s === 0) r = g = b = l; // achromatic
    else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
    }
    return {
        r: r * 255,
        g: g * 255,
        b: b * 255
    };
}
// `rgbToHsv`
// Converts an RGB color value to HSV
// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
// *Returns:* { h, s, v } in [0,1]
function $a9ceb34ac62682a2$var$rgbToHsv(r, g, b) {
    r = $a9ceb34ac62682a2$var$bound01(r, 255);
    g = $a9ceb34ac62682a2$var$bound01(g, 255);
    b = $a9ceb34ac62682a2$var$bound01(b, 255);
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h, s, v = max;
    var d = max - min;
    s = max === 0 ? 0 : d / max;
    if (max == min) h = 0; // achromatic
    else {
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }
        h /= 6;
    }
    return {
        h: h,
        s: s,
        v: v
    };
}
// `hsvToRgb`
// Converts an HSV color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function $a9ceb34ac62682a2$var$hsvToRgb(h, s, v) {
    h = $a9ceb34ac62682a2$var$bound01(h, 360) * 6;
    s = $a9ceb34ac62682a2$var$bound01(s, 100);
    v = $a9ceb34ac62682a2$var$bound01(v, 100);
    var i = Math.floor(h), f = h - i, p = v * (1 - s), q = v * (1 - f * s), t = v * (1 - (1 - f) * s), mod = i % 6, r = [
        v,
        q,
        p,
        p,
        t,
        v
    ][mod], g = [
        t,
        v,
        v,
        q,
        p,
        p
    ][mod], b = [
        p,
        p,
        t,
        v,
        v,
        q
    ][mod];
    return {
        r: r * 255,
        g: g * 255,
        b: b * 255
    };
}
// `rgbToHex`
// Converts an RGB color to hex
// Assumes r, g, and b are contained in the set [0, 255]
// Returns a 3 or 6 character hex
function $a9ceb34ac62682a2$var$rgbToHex(r, g, b, allow3Char) {
    var hex = [
        $a9ceb34ac62682a2$var$pad2(Math.round(r).toString(16)),
        $a9ceb34ac62682a2$var$pad2(Math.round(g).toString(16)),
        $a9ceb34ac62682a2$var$pad2(Math.round(b).toString(16))
    ];
    // Return a 3 character hex if possible
    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    return hex.join("");
}
// `rgbaToHex`
// Converts an RGBA color plus alpha transparency to hex
// Assumes r, g, b are contained in the set [0, 255] and
// a in [0, 1]. Returns a 4 or 8 character rgba hex
function $a9ceb34ac62682a2$var$rgbaToHex(r, g, b, a, allow4Char) {
    var hex = [
        $a9ceb34ac62682a2$var$pad2(Math.round(r).toString(16)),
        $a9ceb34ac62682a2$var$pad2(Math.round(g).toString(16)),
        $a9ceb34ac62682a2$var$pad2(Math.round(b).toString(16)),
        $a9ceb34ac62682a2$var$pad2($a9ceb34ac62682a2$var$convertDecimalToHex(a))
    ];
    // Return a 4 character hex if possible
    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    return hex.join("");
}
// `rgbaToArgbHex`
// Converts an RGBA color to an ARGB Hex8 string
// Rarely used, but required for "toFilter()"
function $a9ceb34ac62682a2$var$rgbaToArgbHex(r, g, b, a) {
    var hex = [
        $a9ceb34ac62682a2$var$pad2($a9ceb34ac62682a2$var$convertDecimalToHex(a)),
        $a9ceb34ac62682a2$var$pad2(Math.round(r).toString(16)),
        $a9ceb34ac62682a2$var$pad2(Math.round(g).toString(16)),
        $a9ceb34ac62682a2$var$pad2(Math.round(b).toString(16))
    ];
    return hex.join("");
}
// `equals`
// Can be called with any tinycolor input
$a9ceb34ac62682a2$export$2e2bcd8739ae039.equals = function(color1, color2) {
    if (!color1 || !color2) return false;
    return $a9ceb34ac62682a2$export$2e2bcd8739ae039(color1).toRgbString() == $a9ceb34ac62682a2$export$2e2bcd8739ae039(color2).toRgbString();
};
$a9ceb34ac62682a2$export$2e2bcd8739ae039.random = function() {
    return $a9ceb34ac62682a2$export$2e2bcd8739ae039.fromRatio({
        r: Math.random(),
        g: Math.random(),
        b: Math.random()
    });
};
// Modification Functions
// ----------------------
// Thanks to less.js for some of the basics here
// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>
function $a9ceb34ac62682a2$var$_desaturate(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = $a9ceb34ac62682a2$export$2e2bcd8739ae039(color).toHsl();
    hsl.s -= amount / 100;
    hsl.s = $a9ceb34ac62682a2$var$clamp01(hsl.s);
    return $a9ceb34ac62682a2$export$2e2bcd8739ae039(hsl);
}
function $a9ceb34ac62682a2$var$_saturate(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = $a9ceb34ac62682a2$export$2e2bcd8739ae039(color).toHsl();
    hsl.s += amount / 100;
    hsl.s = $a9ceb34ac62682a2$var$clamp01(hsl.s);
    return $a9ceb34ac62682a2$export$2e2bcd8739ae039(hsl);
}
function $a9ceb34ac62682a2$var$_greyscale(color) {
    return $a9ceb34ac62682a2$export$2e2bcd8739ae039(color).desaturate(100);
}
function $a9ceb34ac62682a2$var$_lighten(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = $a9ceb34ac62682a2$export$2e2bcd8739ae039(color).toHsl();
    hsl.l += amount / 100;
    hsl.l = $a9ceb34ac62682a2$var$clamp01(hsl.l);
    return $a9ceb34ac62682a2$export$2e2bcd8739ae039(hsl);
}
function $a9ceb34ac62682a2$var$_brighten(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var rgb = $a9ceb34ac62682a2$export$2e2bcd8739ae039(color).toRgb();
    rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
    rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
    rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
    return $a9ceb34ac62682a2$export$2e2bcd8739ae039(rgb);
}
function $a9ceb34ac62682a2$var$_darken(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = $a9ceb34ac62682a2$export$2e2bcd8739ae039(color).toHsl();
    hsl.l -= amount / 100;
    hsl.l = $a9ceb34ac62682a2$var$clamp01(hsl.l);
    return $a9ceb34ac62682a2$export$2e2bcd8739ae039(hsl);
}
// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
// Values outside of this range will be wrapped into this range.
function $a9ceb34ac62682a2$var$_spin(color, amount) {
    var hsl = $a9ceb34ac62682a2$export$2e2bcd8739ae039(color).toHsl();
    var hue = (hsl.h + amount) % 360;
    hsl.h = hue < 0 ? 360 + hue : hue;
    return $a9ceb34ac62682a2$export$2e2bcd8739ae039(hsl);
}
// Combination Functions
// ---------------------
// Thanks to jQuery xColor for some of the ideas behind these
// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>
function $a9ceb34ac62682a2$var$_complement(color) {
    var hsl = $a9ceb34ac62682a2$export$2e2bcd8739ae039(color).toHsl();
    hsl.h = (hsl.h + 180) % 360;
    return $a9ceb34ac62682a2$export$2e2bcd8739ae039(hsl);
}
function $a9ceb34ac62682a2$var$polyad(color, number) {
    if (isNaN(number) || number <= 0) throw new Error("Argument to polyad must be a positive number");
    var hsl = $a9ceb34ac62682a2$export$2e2bcd8739ae039(color).toHsl();
    var result = [
        $a9ceb34ac62682a2$export$2e2bcd8739ae039(color)
    ];
    var step = 360 / number;
    for(var i = 1; i < number; i++)result.push($a9ceb34ac62682a2$export$2e2bcd8739ae039({
        h: (hsl.h + i * step) % 360,
        s: hsl.s,
        l: hsl.l
    }));
    return result;
}
function $a9ceb34ac62682a2$var$_splitcomplement(color) {
    var hsl = $a9ceb34ac62682a2$export$2e2bcd8739ae039(color).toHsl();
    var h = hsl.h;
    return [
        $a9ceb34ac62682a2$export$2e2bcd8739ae039(color),
        $a9ceb34ac62682a2$export$2e2bcd8739ae039({
            h: (h + 72) % 360,
            s: hsl.s,
            l: hsl.l
        }),
        $a9ceb34ac62682a2$export$2e2bcd8739ae039({
            h: (h + 216) % 360,
            s: hsl.s,
            l: hsl.l
        })
    ];
}
function $a9ceb34ac62682a2$var$_analogous(color, results, slices) {
    results = results || 6;
    slices = slices || 30;
    var hsl = $a9ceb34ac62682a2$export$2e2bcd8739ae039(color).toHsl();
    var part = 360 / slices;
    var ret = [
        $a9ceb34ac62682a2$export$2e2bcd8739ae039(color)
    ];
    for(hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;){
        hsl.h = (hsl.h + part) % 360;
        ret.push($a9ceb34ac62682a2$export$2e2bcd8739ae039(hsl));
    }
    return ret;
}
function $a9ceb34ac62682a2$var$_monochromatic(color, results) {
    results = results || 6;
    var hsv = $a9ceb34ac62682a2$export$2e2bcd8739ae039(color).toHsv();
    var h = hsv.h, s = hsv.s, v = hsv.v;
    var ret = [];
    var modification = 1 / results;
    while(results--){
        ret.push($a9ceb34ac62682a2$export$2e2bcd8739ae039({
            h: h,
            s: s,
            v: v
        }));
        v = (v + modification) % 1;
    }
    return ret;
}
// Utility Functions
// ---------------------
$a9ceb34ac62682a2$export$2e2bcd8739ae039.mix = function(color1, color2, amount) {
    amount = amount === 0 ? 0 : amount || 50;
    var rgb1 = $a9ceb34ac62682a2$export$2e2bcd8739ae039(color1).toRgb();
    var rgb2 = $a9ceb34ac62682a2$export$2e2bcd8739ae039(color2).toRgb();
    var p = amount / 100;
    var rgba = {
        r: (rgb2.r - rgb1.r) * p + rgb1.r,
        g: (rgb2.g - rgb1.g) * p + rgb1.g,
        b: (rgb2.b - rgb1.b) * p + rgb1.b,
        a: (rgb2.a - rgb1.a) * p + rgb1.a
    };
    return $a9ceb34ac62682a2$export$2e2bcd8739ae039(rgba);
};
// Readability Functions
// ---------------------
// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
// `contrast`
// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
$a9ceb34ac62682a2$export$2e2bcd8739ae039.readability = function(color1, color2) {
    var c1 = $a9ceb34ac62682a2$export$2e2bcd8739ae039(color1);
    var c2 = $a9ceb34ac62682a2$export$2e2bcd8739ae039(color2);
    return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
};
// `isReadable`
// Ensure that foreground and background color combinations meet WCAG2 guidelines.
// The third argument is an optional Object.
//      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
//      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
// *Example*
//    tinycolor.isReadable("#000", "#111") => false
//    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
$a9ceb34ac62682a2$export$2e2bcd8739ae039.isReadable = function(color1, color2, wcag2) {
    var readability = $a9ceb34ac62682a2$export$2e2bcd8739ae039.readability(color1, color2);
    var wcag2Parms, out;
    out = false;
    wcag2Parms = $a9ceb34ac62682a2$var$validateWCAG2Parms(wcag2);
    switch(wcag2Parms.level + wcag2Parms.size){
        case "AAsmall":
        case "AAAlarge":
            out = readability >= 4.5;
            break;
        case "AAlarge":
            out = readability >= 3;
            break;
        case "AAAsmall":
            out = readability >= 7;
            break;
    }
    return out;
};
// `mostReadable`
// Given a base color and a list of possible foreground or background
// colors for that base, returns the most readable color.
// Optionally returns Black or White if the most readable color is unreadable.
// *Example*
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
$a9ceb34ac62682a2$export$2e2bcd8739ae039.mostReadable = function(baseColor, colorList, args) {
    var bestColor = null;
    var bestScore = 0;
    var readability;
    var includeFallbackColors, level, size;
    args = args || {};
    includeFallbackColors = args.includeFallbackColors;
    level = args.level;
    size = args.size;
    for(var i = 0; i < colorList.length; i++){
        readability = $a9ceb34ac62682a2$export$2e2bcd8739ae039.readability(baseColor, colorList[i]);
        if (readability > bestScore) {
            bestScore = readability;
            bestColor = $a9ceb34ac62682a2$export$2e2bcd8739ae039(colorList[i]);
        }
    }
    if ($a9ceb34ac62682a2$export$2e2bcd8739ae039.isReadable(baseColor, bestColor, {
        level: level,
        size: size
    }) || !includeFallbackColors) return bestColor;
    else {
        args.includeFallbackColors = false;
        return $a9ceb34ac62682a2$export$2e2bcd8739ae039.mostReadable(baseColor, [
            "#fff",
            "#000"
        ], args);
    }
};
// Big List of Colors
// ------------------
// <https://www.w3.org/TR/css-color-4/#named-colors>
var $a9ceb34ac62682a2$var$names = $a9ceb34ac62682a2$export$2e2bcd8739ae039.names = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "0ff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "00f",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    burntsienna: "ea7e5d",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "0ff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "f0f",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "663399",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
};
// Make it easy to access colors via `hexNames[hex]`
var $a9ceb34ac62682a2$var$hexNames = $a9ceb34ac62682a2$export$2e2bcd8739ae039.hexNames = $a9ceb34ac62682a2$var$flip($a9ceb34ac62682a2$var$names);
// Utilities
// ---------
// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
function $a9ceb34ac62682a2$var$flip(o) {
    var flipped = {};
    for(var i in o)if (o.hasOwnProperty(i)) flipped[o[i]] = i;
    return flipped;
}
// Return a valid alpha value [0,1] with all invalid values being set to 1
function $a9ceb34ac62682a2$var$boundAlpha(a) {
    a = parseFloat(a);
    if (isNaN(a) || a < 0 || a > 1) a = 1;
    return a;
}
// Take input from [0, n] and return it as [0, 1]
function $a9ceb34ac62682a2$var$bound01(n, max) {
    if ($a9ceb34ac62682a2$var$isOnePointZero(n)) n = "100%";
    var processPercent = $a9ceb34ac62682a2$var$isPercentage(n);
    n = Math.min(max, Math.max(0, parseFloat(n)));
    // Automatically convert percentage into number
    if (processPercent) n = parseInt(n * max, 10) / 100;
    // Handle floating point rounding errors
    if (Math.abs(n - max) < 0.000001) return 1;
    // Convert into [0, 1] range if it isn't already
    return n % max / parseFloat(max);
}
// Force a number between 0 and 1
function $a9ceb34ac62682a2$var$clamp01(val) {
    return Math.min(1, Math.max(0, val));
}
// Parse a base-16 hex value into a base-10 integer
function $a9ceb34ac62682a2$var$parseIntFromHex(val) {
    return parseInt(val, 16);
}
// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
function $a9ceb34ac62682a2$var$isOnePointZero(n) {
    return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
}
// Check to see if string passed in is a percentage
function $a9ceb34ac62682a2$var$isPercentage(n) {
    return typeof n === "string" && n.indexOf("%") != -1;
}
// Force a hex value to have 2 characters
function $a9ceb34ac62682a2$var$pad2(c) {
    return c.length == 1 ? "0" + c : "" + c;
}
// Replace a decimal with it's percentage value
function $a9ceb34ac62682a2$var$convertToPercentage(n) {
    if (n <= 1) n = n * 100 + "%";
    return n;
}
// Converts a decimal to a hex value
function $a9ceb34ac62682a2$var$convertDecimalToHex(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
}
// Converts a hex value to a decimal
function $a9ceb34ac62682a2$var$convertHexToDecimal(h) {
    return $a9ceb34ac62682a2$var$parseIntFromHex(h) / 255;
}
var $a9ceb34ac62682a2$var$matchers = function() {
    // <http://www.w3.org/TR/css3-values/#integers>
    var CSS_INTEGER = "[-\\+]?\\d+%?";
    // <http://www.w3.org/TR/css3-values/#number-value>
    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
    // Actual matching.
    // Parentheses and commas are optional, but not required.
    // Whitespace can take the place of commas or opening paren
    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    return {
        CSS_UNIT: new RegExp(CSS_UNIT),
        rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
        rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
        hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
        hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
        hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
        hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
    };
}();
// `isValidCSSUnit`
// Take in a single string / number and check to see if it looks like a CSS unit
// (see `matchers` above for definition).
function $a9ceb34ac62682a2$var$isValidCSSUnit(color) {
    return !!$a9ceb34ac62682a2$var$matchers.CSS_UNIT.exec(color);
}
// `stringInputToObject`
// Permissive string parsing.  Take in a number of formats, and output an object
// based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
function $a9ceb34ac62682a2$var$stringInputToObject(color) {
    color = color.replace($a9ceb34ac62682a2$var$trimLeft, "").replace($a9ceb34ac62682a2$var$trimRight, "").toLowerCase();
    var named = false;
    if ($a9ceb34ac62682a2$var$names[color]) {
        color = $a9ceb34ac62682a2$var$names[color];
        named = true;
    } else if (color == "transparent") return {
        r: 0,
        g: 0,
        b: 0,
        a: 0,
        format: "name"
    };
    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match;
    if (match = $a9ceb34ac62682a2$var$matchers.rgb.exec(color)) return {
        r: match[1],
        g: match[2],
        b: match[3]
    };
    if (match = $a9ceb34ac62682a2$var$matchers.rgba.exec(color)) return {
        r: match[1],
        g: match[2],
        b: match[3],
        a: match[4]
    };
    if (match = $a9ceb34ac62682a2$var$matchers.hsl.exec(color)) return {
        h: match[1],
        s: match[2],
        l: match[3]
    };
    if (match = $a9ceb34ac62682a2$var$matchers.hsla.exec(color)) return {
        h: match[1],
        s: match[2],
        l: match[3],
        a: match[4]
    };
    if (match = $a9ceb34ac62682a2$var$matchers.hsv.exec(color)) return {
        h: match[1],
        s: match[2],
        v: match[3]
    };
    if (match = $a9ceb34ac62682a2$var$matchers.hsva.exec(color)) return {
        h: match[1],
        s: match[2],
        v: match[3],
        a: match[4]
    };
    if (match = $a9ceb34ac62682a2$var$matchers.hex8.exec(color)) return {
        r: $a9ceb34ac62682a2$var$parseIntFromHex(match[1]),
        g: $a9ceb34ac62682a2$var$parseIntFromHex(match[2]),
        b: $a9ceb34ac62682a2$var$parseIntFromHex(match[3]),
        a: $a9ceb34ac62682a2$var$convertHexToDecimal(match[4]),
        format: named ? "name" : "hex8"
    };
    if (match = $a9ceb34ac62682a2$var$matchers.hex6.exec(color)) return {
        r: $a9ceb34ac62682a2$var$parseIntFromHex(match[1]),
        g: $a9ceb34ac62682a2$var$parseIntFromHex(match[2]),
        b: $a9ceb34ac62682a2$var$parseIntFromHex(match[3]),
        format: named ? "name" : "hex"
    };
    if (match = $a9ceb34ac62682a2$var$matchers.hex4.exec(color)) return {
        r: $a9ceb34ac62682a2$var$parseIntFromHex(match[1] + "" + match[1]),
        g: $a9ceb34ac62682a2$var$parseIntFromHex(match[2] + "" + match[2]),
        b: $a9ceb34ac62682a2$var$parseIntFromHex(match[3] + "" + match[3]),
        a: $a9ceb34ac62682a2$var$convertHexToDecimal(match[4] + "" + match[4]),
        format: named ? "name" : "hex8"
    };
    if (match = $a9ceb34ac62682a2$var$matchers.hex3.exec(color)) return {
        r: $a9ceb34ac62682a2$var$parseIntFromHex(match[1] + "" + match[1]),
        g: $a9ceb34ac62682a2$var$parseIntFromHex(match[2] + "" + match[2]),
        b: $a9ceb34ac62682a2$var$parseIntFromHex(match[3] + "" + match[3]),
        format: named ? "name" : "hex"
    };
    return false;
}
function $a9ceb34ac62682a2$var$validateWCAG2Parms(parms) {
    // return valid WCAG2 parms for isReadable.
    // If input parms are invalid, return {"level":"AA", "size":"small"}
    var level, size;
    parms = parms || {
        level: "AA",
        size: "small"
    };
    level = (parms.level || "AA").toUpperCase();
    size = (parms.size || "small").toLowerCase();
    if (level !== "AA" && level !== "AAA") level = "AA";
    if (size !== "small" && size !== "large") size = "small";
    return {
        level: level,
        size: size
    };
}


const $49db07fe7d01393c$export$1537643e85439bf5 = {
    subject: '#f8f868',
    firstCountersubject: '#78c8f8',
    secondCountersubject: '#e468d0',
    canon: '#f09018',
    sequence: '#b80010',
    firstMotif: '#008f8a',
    secondMotif: '#6a5acd'
};
const $49db07fe7d01393c$export$88d57a8d3a22066c = '#898781';
const $49db07fe7d01393c$export$4c74adcc907c297e = [
    $49db07fe7d01393c$export$1537643e85439bf5.subject,
    $49db07fe7d01393c$export$1537643e85439bf5.firstCountersubject,
    $49db07fe7d01393c$export$1537643e85439bf5.secondCountersubject,
    $49db07fe7d01393c$export$1537643e85439bf5.canon,
    $49db07fe7d01393c$export$1537643e85439bf5.sequence,
    $49db07fe7d01393c$export$1537643e85439bf5.firstMotif,
    $49db07fe7d01393c$export$1537643e85439bf5.secondMotif
];
const $49db07fe7d01393c$export$3e32adda0df4ef5d = (color, steps = 1)=>{
    const base = (0, $a9ceb34ac62682a2$export$2e2bcd8739ae039)(color);
    return (base.isLight() ? base.darken(14 * steps) : base.lighten(12 * steps)).toHexString();
};
/**
 * The categorical palette before the Figure 2 colours (until 2026-10-02). Analyses saved with it are migrated: each
 * automatic colour (a slot, or a variant of it, lightened by 12 per derivation) maps to the Figure 2 colour of its slot
 * and as many shades; the eighth slot folds into grey like any pattern beyond the palette.
 */ const $49db07fe7d01393c$var$legacyPalette = [
    '#2a78d6',
    '#eb6834',
    '#1baf7a',
    '#eda100',
    '#e87ba4',
    '#008300',
    '#4a3aa7',
    '#e34948'
];
const $49db07fe7d01393c$var$legacyColors = new Map();
[
    ...$49db07fe7d01393c$var$legacyPalette,
    $49db07fe7d01393c$export$88d57a8d3a22066c
].forEach((legacy, slot)=>{
    const current = slot < $49db07fe7d01393c$export$4c74adcc907c297e.length ? $49db07fe7d01393c$export$4c74adcc907c297e[slot] : $49db07fe7d01393c$export$88d57a8d3a22066c;
    let variant = legacy;
    for(let steps = 0; steps <= 3; steps += 1){
        // Lightened three times, the lightest slots reach white, which no automatic colour of today's palette is.
        if (variant !== '#ffffff') $49db07fe7d01393c$var$legacyColors.set(variant, $49db07fe7d01393c$export$3e32adda0df4ef5d(current, steps));
        variant = (0, $a9ceb34ac62682a2$export$2e2bcd8739ae039)(variant).lighten(12).toHexString();
    }
});
const $49db07fe7d01393c$export$932d21e2ddb1af9d = (color)=>$49db07fe7d01393c$var$legacyColors.has((0, $a9ceb34ac62682a2$export$2e2bcd8739ae039)(color).toHexString());
const $49db07fe7d01393c$export$deda40e70098a692 = (color)=>$49db07fe7d01393c$var$legacyColors.get((0, $a9ceb34ac62682a2$export$2e2bcd8739ae039)(color).toHexString()) ?? color;
const $49db07fe7d01393c$export$ec9fff20a24a368 = (color)=>(0, $a9ceb34ac62682a2$export$2e2bcd8739ae039)(color).isLight() ? (0, $a9ceb34ac62682a2$export$2e2bcd8739ae039)(color).darken(25).toHexString() : color;


const $7964b3472f9be00d$export$b869dd214721594c = 'figure2';
const $7964b3472f9be00d$export$efc1b22afdb7650d = (analysis)=>analysis.palette === $7964b3472f9be00d$export$b869dd214721594c ? analysis : {
        ...analysis,
        palette: $7964b3472f9be00d$export$b869dd214721594c,
        patterns: analysis.patterns.map((pattern)=>pattern.id.startsWith('family-') ? pattern : {
                ...pattern,
                color: (0, $49db07fe7d01393c$export$deda40e70098a692)(pattern.color)
            })
    };
const $7964b3472f9be00d$var$keyFor = (sheet)=>`melodyvis.analysis.v1:${sheet.title}|${sheet.composer}`;
const $7964b3472f9be00d$export$b1a8c52f0d825e19 = (sheet)=>{
    try {
        const stored = window.localStorage.getItem($7964b3472f9be00d$var$keyFor(sheet));
        return stored ? $7964b3472f9be00d$export$b04f786813930233(stored) : undefined;
    } catch  {
        return undefined;
    }
};
const $7964b3472f9be00d$export$d412665dc8645c41 = (analysis)=>{
    try {
        const hasNames = Object.keys(analysis.names ?? {}).length > 0;
        if (analysis.patterns.length === 0 && !hasNames) window.localStorage.removeItem($7964b3472f9be00d$var$keyFor(analysis.sheet));
        else window.localStorage.setItem($7964b3472f9be00d$var$keyFor(analysis.sheet), JSON.stringify(analysis));
    } catch (error) {
        // Storage can be full or blocked (private windows); the analysis then lives in memory as before.
        console.warn('MelodyVis: the analysis could not be saved in the browser.', error);
    }
};
const $7964b3472f9be00d$var$isOccurrence = (value)=>typeof value === 'object' && value !== null && [
        'firstOffset',
        'lastOffset',
        'voiceNumber'
    ].every((key)=>typeof value[key] === 'number');
const $7964b3472f9be00d$var$isPattern = (value)=>{
    const pattern = value;
    return typeof pattern === 'object' && pattern !== null && typeof pattern.id === 'string' && typeof pattern.label === 'string' && Array.isArray(pattern.occurrences) && pattern.occurrences.every($7964b3472f9be00d$var$isOccurrence) && Array.isArray(pattern.connectedToByOperator) && Array.isArray(pattern.connectedToByOccurrences);
};
const $7964b3472f9be00d$export$b04f786813930233 = (text)=>{
    const data = JSON.parse(text);
    if (data?.app !== 'MelodyVis' || data?.version !== 1) throw new Error('This is not a MelodyVis analysis file.');
    if (!Array.isArray(data.patterns) || !data.patterns.every($7964b3472f9be00d$var$isPattern)) throw new Error('The analysis file contains no valid patterns.');
    // Names are optional; anything but text is left out.
    const names = Object.fromEntries(Object.entries(typeof data.names === 'object' && data.names !== null ? data.names : {}).filter(([, name])=>typeof name === 'string'));
    return {
        ...data,
        names: names
    };
};
const $7964b3472f9be00d$export$9065fc7c63285a7c = (sheet)=>`${sheet.title.replace(/[\\/:*?"<>|]+/g, '_')} - MelodyVis analysis.json`;



const $d65ba47825fbd282$export$d78e6d61b3e1e377 = (error)=>{
    if (!(0, $0d16547caa56a13b$export$2e2bcd8739ae039).isAxiosError(error)) return String(error);
    const data = error.response?.data;
    return typeof data?.detail === 'string' ? data.detail : error.message;
};


/**
 * Audio playback of melodic patterns and of whole pieces (paper, 7.2: "the addition of audio playback could enhance
 * the user experience"; study feedback P19: no auditory reference). A grand piano: recordings of the Salamander Grand
 * Piano (Yamaha C5, Alexander Holm, CC BY 3.0) sampled every minor third and shifted to the notes between, a
 * damper-like release at the end of each written note and a little room around it. Only the recordings a phrase needs
 * are loaded, once.
 */ // Recordings of the Salamander Grand Piano (Yamaha C5) by Alexander Holm, CC BY 3.0, every minor third from A0
// to C8 (see piano/LICENSE.md). Parcel emits them with a content hash in their names.
var $5140c87a41c53606$exports = {};
$5140c87a41c53606$exports = import.meta.resolve("aOx1B");


var $a0c05997c814c90c$exports = {};
$a0c05997c814c90c$exports = import.meta.resolve("ir3se");


var $a4c0bf40c06198e8$exports = {};
$a4c0bf40c06198e8$exports = import.meta.resolve("du7G9");


var $1955d3652a42300c$exports = {};
$1955d3652a42300c$exports = import.meta.resolve("bRo2n");


var $44ce41177b4bc556$exports = {};
$44ce41177b4bc556$exports = import.meta.resolve("6k0K3");


var $d96187ac7003a559$exports = {};
$d96187ac7003a559$exports = import.meta.resolve("gNc0Z");


var $9d58cb9f83534f6c$exports = {};
$9d58cb9f83534f6c$exports = import.meta.resolve("6EaFE");


var $5be6626fa232fc94$exports = {};
$5be6626fa232fc94$exports = import.meta.resolve("3WTgN");


var $a81be02880136828$exports = {};
$a81be02880136828$exports = import.meta.resolve("bShh6");


var $c98f9cd994214be3$exports = {};
$c98f9cd994214be3$exports = import.meta.resolve("ci8PY");


var $d85a338992fdcd25$exports = {};
$d85a338992fdcd25$exports = import.meta.resolve("jFfU2");


var $e9a007fed1f9c553$exports = {};
$e9a007fed1f9c553$exports = import.meta.resolve("6WtBD");


var $64757077f1b5201f$exports = {};
$64757077f1b5201f$exports = import.meta.resolve("aFDdz");


var $0e718e7969b70337$exports = {};
$0e718e7969b70337$exports = import.meta.resolve("l65MM");


var $034712997d2182d3$exports = {};
$034712997d2182d3$exports = import.meta.resolve("lGIvd");


var $d973a55a1cf819e4$exports = {};
$d973a55a1cf819e4$exports = import.meta.resolve("1vyPR");


var $dd2092467b655a0d$exports = {};
$dd2092467b655a0d$exports = import.meta.resolve("cHwKA");


var $d78240a28fef8fd7$exports = {};
$d78240a28fef8fd7$exports = import.meta.resolve("hQ1g3");


var $23c8abd6fe04fae5$exports = {};
$23c8abd6fe04fae5$exports = import.meta.resolve("3NwhK");


var $549091bb9f0c90cb$exports = {};
$549091bb9f0c90cb$exports = import.meta.resolve("grLeC");


var $f59bddbc3f2e18ea$exports = {};
$f59bddbc3f2e18ea$exports = import.meta.resolve("4KoOg");


var $91de4ff27e8673e4$exports = {};
$91de4ff27e8673e4$exports = import.meta.resolve("zfuY3");


var $4af0afb3f983c7c2$exports = {};
$4af0afb3f983c7c2$exports = import.meta.resolve("eFH5H");


var $9c34e5f62a95fb5d$exports = {};
$9c34e5f62a95fb5d$exports = import.meta.resolve("1j69V");


var $e90dc3ad2ef150be$exports = {};
$e90dc3ad2ef150be$exports = import.meta.resolve("eK7t2");


var $9d87bda27c351209$exports = {};
$9d87bda27c351209$exports = import.meta.resolve("faDV7");


var $5baaffd36a23ae01$exports = {};
$5baaffd36a23ae01$exports = import.meta.resolve("lXYVz");


var $c1477580d95813f3$exports = {};
$c1477580d95813f3$exports = import.meta.resolve("b3cDT");


var $aef248126908abc4$exports = {};
$aef248126908abc4$exports = import.meta.resolve("WImGP");


var $32261822371582ff$exports = {};
$32261822371582ff$exports = import.meta.resolve("9x48o");


const $479b2de0fe2b706a$export$13dcefce6f5c7871 = {
    21: (0, (/*@__PURE__*/$parcel$interopDefault($5140c87a41c53606$exports))),
    24: (0, (/*@__PURE__*/$parcel$interopDefault($a0c05997c814c90c$exports))),
    27: (0, (/*@__PURE__*/$parcel$interopDefault($a4c0bf40c06198e8$exports))),
    30: (0, (/*@__PURE__*/$parcel$interopDefault($1955d3652a42300c$exports))),
    33: (0, (/*@__PURE__*/$parcel$interopDefault($44ce41177b4bc556$exports))),
    36: (0, (/*@__PURE__*/$parcel$interopDefault($d96187ac7003a559$exports))),
    39: (0, (/*@__PURE__*/$parcel$interopDefault($9d58cb9f83534f6c$exports))),
    42: (0, (/*@__PURE__*/$parcel$interopDefault($5be6626fa232fc94$exports))),
    45: (0, (/*@__PURE__*/$parcel$interopDefault($a81be02880136828$exports))),
    48: (0, (/*@__PURE__*/$parcel$interopDefault($c98f9cd994214be3$exports))),
    51: (0, (/*@__PURE__*/$parcel$interopDefault($d85a338992fdcd25$exports))),
    54: (0, (/*@__PURE__*/$parcel$interopDefault($e9a007fed1f9c553$exports))),
    57: (0, (/*@__PURE__*/$parcel$interopDefault($64757077f1b5201f$exports))),
    60: (0, (/*@__PURE__*/$parcel$interopDefault($0e718e7969b70337$exports))),
    63: (0, (/*@__PURE__*/$parcel$interopDefault($034712997d2182d3$exports))),
    66: (0, (/*@__PURE__*/$parcel$interopDefault($d973a55a1cf819e4$exports))),
    69: (0, (/*@__PURE__*/$parcel$interopDefault($dd2092467b655a0d$exports))),
    72: (0, (/*@__PURE__*/$parcel$interopDefault($d78240a28fef8fd7$exports))),
    75: (0, (/*@__PURE__*/$parcel$interopDefault($23c8abd6fe04fae5$exports))),
    78: (0, (/*@__PURE__*/$parcel$interopDefault($549091bb9f0c90cb$exports))),
    81: (0, (/*@__PURE__*/$parcel$interopDefault($f59bddbc3f2e18ea$exports))),
    84: (0, (/*@__PURE__*/$parcel$interopDefault($91de4ff27e8673e4$exports))),
    87: (0, (/*@__PURE__*/$parcel$interopDefault($4af0afb3f983c7c2$exports))),
    90: (0, (/*@__PURE__*/$parcel$interopDefault($9c34e5f62a95fb5d$exports))),
    93: (0, (/*@__PURE__*/$parcel$interopDefault($e90dc3ad2ef150be$exports))),
    96: (0, (/*@__PURE__*/$parcel$interopDefault($9d87bda27c351209$exports))),
    99: (0, (/*@__PURE__*/$parcel$interopDefault($5baaffd36a23ae01$exports))),
    102: (0, (/*@__PURE__*/$parcel$interopDefault($c1477580d95813f3$exports))),
    105: (0, (/*@__PURE__*/$parcel$interopDefault($aef248126908abc4$exports))),
    108: (0, (/*@__PURE__*/$parcel$interopDefault($32261822371582ff$exports)))
};


const $358762616e4a14c0$var$letterSemitones = {
    C: 0,
    D: 2,
    E: 4,
    F: 5,
    G: 7,
    A: 9,
    B: 11
};
const $358762616e4a14c0$export$4059236bd5acc6d = (name)=>{
    const match = /^([A-G])(#{1,2}|-{1,2})?(-?\d+)$/.exec(name);
    if (!match) return undefined;
    const [, letter, accidental = '', octave] = match;
    const alteration = accidental.startsWith('#') ? accidental.length : -accidental.length;
    return (Number(octave) + 1) * 12 + $358762616e4a14c0$var$letterSemitones[letter] + alteration;
};
const $358762616e4a14c0$var$sampledNotes = Object.keys((0, $479b2de0fe2b706a$export$13dcefce6f5c7871)).map(Number);
/** The recording closest to the note; it is at most one and a half semitones away. */ const $358762616e4a14c0$var$nearestSample = (midi)=>$358762616e4a14c0$var$sampledNotes.reduce((best, sampled)=>Math.abs(sampled - midi) < Math.abs(best - midi) ? sampled : best);
// Time constant of the release when a key is let go (the dampers stop the strings within about half a second).
const $358762616e4a14c0$var$release = 0.12;
// How long a released note may ring before its source is stopped.
const $358762616e4a14c0$var$releaseTail = 1;
// A whole piece is scheduled this many seconds ahead, every `schedulingInterval` milliseconds: Web Audio keeps the
// time, the main thread only has to keep up (a tab that plays audio is not throttled).
const $358762616e4a14c0$var$lookahead = 1.5;
const $358762616e4a14c0$var$schedulingInterval = 200;
let $358762616e4a14c0$var$context;
let $358762616e4a14c0$var$output;
let $358762616e4a14c0$var$current;
const $358762616e4a14c0$var$recordings = new Map();
const $358762616e4a14c0$var$recording = (audio, sampled)=>{
    if (!$358762616e4a14c0$var$recordings.has(sampled)) {
        const loaded = fetch((0, $479b2de0fe2b706a$export$13dcefce6f5c7871)[sampled]).then((response)=>response.arrayBuffer()).then((data)=>audio.decodeAudioData(data));
        // A failed download may be retried with the next phrase.
        loaded.catch(()=>$358762616e4a14c0$var$recordings.delete(sampled));
        $358762616e4a14c0$var$recordings.set(sampled, loaded);
    }
    return $358762616e4a14c0$var$recordings.get(sampled);
};
/** The recordings for the MIDI notes, by sampled note. */ const $358762616e4a14c0$var$recordingsFor = (audio, midi)=>Promise.all([
        ...new Set(midi.map($358762616e4a14c0$var$nearestSample))
    ].map((sampled)=>$358762616e4a14c0$var$recording(audio, sampled).then((buffer)=>[
                sampled,
                buffer
            ]))).then((loaded)=>new Map(loaded));
/** A short, diffuse room: decaying noise as impulse response, a little later on the right than on the left. */ const $358762616e4a14c0$var$room = (audio)=>{
    const seconds = 1.6;
    const impulse = audio.createBuffer(2, Math.round(audio.sampleRate * seconds), audio.sampleRate);
    for(let channel = 0; channel < 2; channel += 1){
        const samples = impulse.getChannelData(channel);
        const delay = Math.round(audio.sampleRate * (0.012 + 0.006 * channel));
        for(let index = delay; index < samples.length; index += 1){
            const time = (index - delay) / audio.sampleRate;
            samples[index] = (Math.random() * 2 - 1) * Math.exp(-time / 0.35);
        }
    }
    const reverb = audio.createConvolver();
    reverb.buffer = impulse;
    return reverb;
};
/** Piano bus: dry signal and some room, through a limiter that only catches the peaks of chords. */ const $358762616e4a14c0$var$outputOf = (audio)=>{
    if ($358762616e4a14c0$var$output) return $358762616e4a14c0$var$output;
    const input = audio.createGain();
    // A hard knee high up: single notes keep their dynamics (the default soft knee of 30 dB would squash them).
    const limiter = audio.createDynamicsCompressor();
    limiter.threshold.value = -3;
    limiter.knee.value = 3;
    limiter.ratio.value = 12;
    limiter.attack.value = 0.002;
    limiter.release.value = 0.2;
    const dry = audio.createGain();
    dry.gain.value = 0.9;
    const wet = audio.createGain();
    wet.gain.value = 0.18;
    const reverb = $358762616e4a14c0$var$room(audio);
    input.connect(dry).connect(limiter);
    input.connect(reverb).connect(wet).connect(limiter);
    limiter.connect(audio.destination);
    $358762616e4a14c0$var$output = input;
    return $358762616e4a14c0$var$output;
};
/** A playback on a bus of its own; it stops the previous one. Stopping fades the bus out and ends its sources. */ const $358762616e4a14c0$var$startSession = ()=>{
    $358762616e4a14c0$var$current?.stop();
    $358762616e4a14c0$var$context = $358762616e4a14c0$var$context ?? new AudioContext();
    const audio = $358762616e4a14c0$var$context;
    // Browsers create the context suspended until a user gesture; playing is always started by a click.
    audio.resume();
    const bus = audio.createGain();
    bus.connect($358762616e4a14c0$var$outputOf(audio));
    const sources = new Set();
    const cleanups = [];
    let isStopped = false;
    let resolveFinished = ()=>undefined;
    const finished = new Promise((resolve)=>resolveFinished = resolve);
    const stop = ()=>{
        if (isStopped) return;
        isStopped = true;
        cleanups.forEach((cleanup)=>cleanup());
        bus.gain.cancelScheduledValues(audio.currentTime);
        bus.gain.setTargetAtTime(0, audio.currentTime, 0.04);
        window.setTimeout(()=>{
            sources.forEach((source)=>source.stop());
            bus.disconnect();
        }, 400);
        if ($358762616e4a14c0$var$current === playback) $358762616e4a14c0$var$current = undefined;
        resolveFinished();
    };
    const playback = {
        finished: finished,
        stop: stop
    };
    $358762616e4a14c0$var$current = playback;
    const strike = (buffers, midi, start, end, velocity)=>{
        const sampled = $358762616e4a14c0$var$nearestSample(midi);
        const source = audio.createBufferSource();
        source.buffer = buffers.get(sampled) ?? null;
        source.playbackRate.value = 2 ** ((midi - sampled) / 12);
        const key = audio.createGain();
        key.gain.setValueAtTime(velocity, start);
        key.gain.setValueAtTime(velocity, end);
        key.gain.setTargetAtTime(0, end, $358762616e4a14c0$var$release);
        source.connect(key).connect(bus);
        source.start(start);
        source.stop(end + $358762616e4a14c0$var$releaseTail);
        sources.add(source);
        // A piece strikes thousands of keys: each leaves the graph when it has rung out.
        source.onended = ()=>{
            sources.delete(source);
            key.disconnect();
        };
    };
    return {
        audio: audio,
        isStopped: ()=>isStopped,
        onStop: (cleanup)=>cleanups.push(cleanup),
        playback: playback,
        strike: strike
    };
};
const $358762616e4a14c0$export$899fbdb5fa08b653 = (notes, bpm = 80)=>{
    const session = $358762616e4a14c0$var$startSession();
    const { audio: audio, playback: playback } = session;
    const secondsPerQuarter = 60 / bpm;
    let start;
    let timer;
    session.onStop(()=>window.clearTimeout(timer));
    let resolveStarted = ()=>undefined;
    const started = new Promise((resolve)=>resolveStarted = resolve);
    playback.finished.then(resolveStarted);
    $358762616e4a14c0$var$recordingsFor(audio, notes.flatMap((note)=>note.midi)).then((buffers)=>{
        if (session.isStopped()) return;
        const startTime = audio.currentTime + 0.06;
        start = startTime;
        let end = startTime;
        notes.forEach((note)=>{
            const noteStart = startTime + note.onset * secondsPerQuarter;
            const noteEnd = noteStart + Math.max(note.duration * secondsPerQuarter, 0.08);
            // Chords keep the loudness of a single note.
            const velocity = 0.75 / Math.sqrt(Math.max(note.midi.length, 1));
            note.midi.forEach((midi)=>session.strike(buffers, midi, noteStart, noteEnd, velocity));
            end = Math.max(end, noteEnd + 5 * $358762616e4a14c0$var$release);
        });
        timer = window.setTimeout(playback.stop, (end - audio.currentTime) * 1000);
        resolveStarted();
    }).catch(playback.stop);
    return {
        ...playback,
        position: ()=>start === undefined ? 0 : Math.max(0, audio.currentTime - start) / secondsPerQuarter,
        started: started
    };
};
const $358762616e4a14c0$export$751dc8e9fbdf4292 = (notes, bpm, from = 0)=>{
    const session = $358762616e4a14c0$var$startSession();
    const { audio: audio, playback: playback } = session;
    const secondsPerQuarter = 60 / bpm;
    const remaining = notes.filter((note)=>note.onset >= from - 1e-6);
    const end = remaining.reduce((latest, note)=>Math.max(latest, note.onset + note.duration), from);
    // Notes struck together share the loudness of one, like a chord: the voices entering do not add up.
    const together = new Map();
    remaining.forEach((note)=>together.set(note.onset, (together.get(note.onset) ?? 0) + 1));
    let start;
    let next = 0;
    let interval;
    session.onStop(()=>window.clearInterval(interval));
    let resolveStarted = ()=>undefined;
    const started = new Promise((resolve)=>resolveStarted = resolve);
    playback.finished.then(resolveStarted);
    const schedule = (buffers, startTime)=>{
        const horizon = audio.currentTime + $358762616e4a14c0$var$lookahead;
        while(next < remaining.length){
            const note = remaining[next];
            const noteStart = startTime + (note.onset - from) * secondsPerQuarter;
            if (noteStart > horizon) break;
            const noteEnd = noteStart + Math.max(note.duration * secondsPerQuarter, 0.08);
            session.strike(buffers, note.midi, noteStart, noteEnd, 0.6 / Math.sqrt(together.get(note.onset)));
            next += 1;
        }
        if (audio.currentTime > startTime + (end - from) * secondsPerQuarter + 5 * $358762616e4a14c0$var$release) playback.stop();
    };
    $358762616e4a14c0$var$recordingsFor(audio, remaining.map((note)=>note.midi)).then((buffers)=>{
        if (session.isStopped()) return;
        const startTime = audio.currentTime + 0.1;
        start = startTime;
        schedule(buffers, startTime);
        interval = window.setInterval(()=>schedule(buffers, startTime), $358762616e4a14c0$var$schedulingInterval);
        resolveStarted();
    }).catch(playback.stop);
    return {
        ...playback,
        position: ()=>start === undefined ? from : from + Math.max(0, audio.currentTime - start) / secondsPerQuarter,
        started: started
    };
};
const $358762616e4a14c0$export$1fdcd79d502f9726 = ()=>$358762616e4a14c0$var$current?.stop();




var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $632c6f3a3bd7664f$var$CaretRightOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M715.8 493.5L335 165.1c-14.2-12.2-35-1.2-35 18.5v656.8c0 19.7 20.8 30.7 35 18.5l380.8-328.4c10.9-9.4 10.9-27.6 0-37z"
                }
            }
        ]
    },
    "name": "caret-right",
    "theme": "outlined"
};
var $632c6f3a3bd7664f$export$2e2bcd8739ae039 = $632c6f3a3bd7664f$var$CaretRightOutlined;



function $39b91140dd0153e5$var$_extends() {
    $39b91140dd0153e5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $39b91140dd0153e5$var$_extends.apply(this, arguments);
}
const $39b91140dd0153e5$var$CaretRightOutlined = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $39b91140dd0153e5$var$_extends({}, props, {
        ref: ref,
        icon: (0, $632c6f3a3bd7664f$export$2e2bcd8739ae039)
    }));
/**![caret-right](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTcxNS44IDQ5My41TDMzNSAxNjUuMWMtMTQuMi0xMi4yLTM1LTEuMi0zNSAxOC41djY1Ni44YzAgMTkuNyAyMC44IDMwLjcgMzUgMTguNWwzODAuOC0zMjguNGMxMC45LTkuNCAxMC45LTI3LjYgMC0zN3oiIC8+PC9zdmc+) */ const $39b91140dd0153e5$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($39b91140dd0153e5$var$CaretRightOutlined);
var $39b91140dd0153e5$export$2e2bcd8739ae039 = $39b91140dd0153e5$var$RefIcon;


var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $f696a9337ebc7e5d$var$EditOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    },
    "name": "edit",
    "theme": "outlined"
};
var $f696a9337ebc7e5d$export$2e2bcd8739ae039 = $f696a9337ebc7e5d$var$EditOutlined;



function $a5a7c3d0277b871b$var$_extends() {
    $a5a7c3d0277b871b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a5a7c3d0277b871b$var$_extends.apply(this, arguments);
}
const $a5a7c3d0277b871b$var$EditOutlined = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $a5a7c3d0277b871b$var$_extends({}, props, {
        ref: ref,
        icon: (0, $f696a9337ebc7e5d$export$2e2bcd8739ae039)
    }));
/**![edit](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI1Ny43IDc1MmMyIDAgNC0uMiA2LS41TDQzMS45IDcyMmMyLS40IDMuOS0xLjMgNS4zLTIuOGw0MjMuOS00MjMuOWE5Ljk2IDkuOTYgMCAwMDAtMTQuMUw2OTQuOSAxMTQuOWMtMS45LTEuOS00LjQtMi45LTcuMS0yLjlzLTUuMiAxLTcuMSAyLjlMMjU2LjggNTM4LjhjLTEuNSAxLjUtMi40IDMuMy0yLjggNS4zbC0yOS41IDE2OC4yYTMzLjUgMzMuNSAwIDAwOS40IDI5LjhjNi42IDYuNCAxNC45IDkuOSAyMy44IDkuOXptNjcuNC0xNzQuNEw2ODcuOCAyMTVsNzMuMyA3My4zLTM2Mi43IDM2Mi42LTg4LjkgMTUuNyAxNS42LTg5ek04ODAgODM2SDE0NGMtMTcuNyAwLTMyIDE0LjMtMzIgMzJ2MzZjMCA0LjQgMy42IDggOCA4aDc4NGM0LjQgMCA4LTMuNiA4LTh2LTM2YzAtMTcuNy0xNC4zLTMyLTMyLTMyeiIgLz48L3N2Zz4=) */ const $a5a7c3d0277b871b$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($a5a7c3d0277b871b$var$EditOutlined);
var $a5a7c3d0277b871b$export$2e2bcd8739ae039 = $a5a7c3d0277b871b$var$RefIcon;


var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $3961e759bc0c1b52$var$EyeInvisibleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zm-63.57-320.64L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z"
                }
            }
        ]
    },
    "name": "eye-invisible",
    "theme": "outlined"
};
var $3961e759bc0c1b52$export$2e2bcd8739ae039 = $3961e759bc0c1b52$var$EyeInvisibleOutlined;



function $4068c0b99705ad33$var$_extends() {
    $4068c0b99705ad33$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4068c0b99705ad33$var$_extends.apply(this, arguments);
}
const $4068c0b99705ad33$var$EyeInvisibleOutlined = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $4068c0b99705ad33$var$_extends({}, props, {
        ref: ref,
        icon: (0, $3961e759bc0c1b52$export$2e2bcd8739ae039)
    }));
/**![eye-invisible](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk0Mi4yIDQ4Ni4yUTg4OS40NyAzNzUuMTEgODE2LjcgMzA1bC01MC44OCA1MC44OEM4MDcuMzEgMzk1LjUzIDg0My40NSA0NDcuNCA4NzQuNyA1MTIgNzkxLjUgNjg0LjIgNjczLjQgNzY2IDUxMiA3NjZxLTcyLjY3IDAtMTMzLjg3LTIyLjM4TDMyMyA3OTguNzVRNDA4IDgzOCA1MTIgODM4cTI4OC4zIDAgNDMwLjItMzAwLjNhNjAuMjkgNjAuMjkgMCAwMDAtNTEuNXptLTYzLjU3LTMyMC42NEw4MzYgMTIyLjg4YTggOCAwIDAwLTExLjMyIDBMNzE1LjMxIDIzMi4yUTYyNC44NiAxODYgNTEyIDE4NnEtMjg4LjMgMC00MzAuMiAzMDAuM2E2MC4zIDYwLjMgMCAwMDAgNTEuNXE1Ni42OSAxMTkuNCAxMzYuNSAxOTEuNDFMMTEyLjQ4IDgzNWE4IDggMCAwMDAgMTEuMzFMMTU1LjE3IDg4OWE4IDggMCAwMDExLjMxIDBsNzEyLjE1LTcxMi4xMmE4IDggMCAwMDAtMTEuMzJ6TTE0OS4zIDUxMkMyMzIuNiAzMzkuOCAzNTAuNyAyNTggNTEyIDI1OGM1NC41NCAwIDEwNC4xMyA5LjM2IDE0OS4xMiAyOC4zOWwtNzAuMyA3MC4zYTE3NiAxNzYgMCAwMC0yMzguMTMgMjM4LjEzbC04My40MiA4My40MkMyMjMuMSA2MzcuNDkgMTgzLjMgNTgyLjI4IDE0OS4zIDUxMnptMjQ2LjcgMGExMTIuMTEgMTEyLjExIDAgMDExNDYuMi0xMDYuNjlMNDAxLjMxIDU0Ni4yQTExMiAxMTIgMCAwMTM5NiA1MTJ6IiAvPjxwYXRoIGQ9Ik01MDggNjI0Yy0zLjQ2IDAtNi44Ny0uMTYtMTAuMjUtLjQ3bC01Mi44MiA1Mi44MmExNzYuMDkgMTc2LjA5IDAgMDAyMjcuNDItMjI3LjQybC01Mi44MiA1Mi44MmMuMzEgMy4zOC40NyA2Ljc5LjQ3IDEwLjI1YTExMS45NCAxMTEuOTQgMCAwMS0xMTIgMTEyeiIgLz48L3N2Zz4=) */ const $4068c0b99705ad33$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($4068c0b99705ad33$var$EyeInvisibleOutlined);
var $4068c0b99705ad33$export$2e2bcd8739ae039 = $4068c0b99705ad33$var$RefIcon;


var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $ef243e4adf62a9f8$var$EyeOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z"
                }
            }
        ]
    },
    "name": "eye",
    "theme": "outlined"
};
var $ef243e4adf62a9f8$export$2e2bcd8739ae039 = $ef243e4adf62a9f8$var$EyeOutlined;



function $21b283b110732d66$var$_extends() {
    $21b283b110732d66$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $21b283b110732d66$var$_extends.apply(this, arguments);
}
const $21b283b110732d66$var$EyeOutlined = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $21b283b110732d66$var$_extends({}, props, {
        ref: ref,
        icon: (0, $ef243e4adf62a9f8$export$2e2bcd8739ae039)
    }));
/**![eye](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk0Mi4yIDQ4Ni4yQzg0Ny40IDI4Ni41IDcwNC4xIDE4NiA1MTIgMTg2Yy0xOTIuMiAwLTMzNS40IDEwMC41LTQzMC4yIDMwMC4zYTYwLjMgNjAuMyAwIDAwMCA1MS41QzE3Ni42IDczNy41IDMxOS45IDgzOCA1MTIgODM4YzE5Mi4yIDAgMzM1LjQtMTAwLjUgNDMwLjItMzAwLjMgNy43LTE2LjIgNy43LTM1IDAtNTEuNXpNNTEyIDc2NmMtMTYxLjMgMC0yNzkuNC04MS44LTM2Mi43LTI1NEMyMzIuNiAzMzkuOCAzNTAuNyAyNTggNTEyIDI1OGMxNjEuMyAwIDI3OS40IDgxLjggMzYyLjcgMjU0Qzc5MS41IDY4NC4yIDY3My40IDc2NiA1MTIgNzY2em0tNC00MzBjLTk3LjIgMC0xNzYgNzguOC0xNzYgMTc2czc4LjggMTc2IDE3NiAxNzYgMTc2LTc4LjggMTc2LTE3Ni03OC44LTE3Ni0xNzYtMTc2em0wIDI4OGMtNjEuOSAwLTExMi01MC4xLTExMi0xMTJzNTAuMS0xMTIgMTEyLTExMiAxMTIgNTAuMSAxMTIgMTEyLTUwLjEgMTEyLTExMiAxMTJ6IiAvPjwvc3ZnPg==) */ const $21b283b110732d66$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($21b283b110732d66$var$EyeOutlined);
var $21b283b110732d66$export$2e2bcd8739ae039 = $21b283b110732d66$var$RefIcon;


var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $449f5ff69fa697cc$var$PauseOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M304 176h80v672h-80zm408 0h-64c-4.4 0-8 3.6-8 8v656c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V184c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "pause",
    "theme": "outlined"
};
var $449f5ff69fa697cc$export$2e2bcd8739ae039 = $449f5ff69fa697cc$var$PauseOutlined;



function $c28cb742fc860797$var$_extends() {
    $c28cb742fc860797$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c28cb742fc860797$var$_extends.apply(this, arguments);
}
const $c28cb742fc860797$var$PauseOutlined = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $c28cb742fc860797$var$_extends({}, props, {
        ref: ref,
        icon: (0, $449f5ff69fa697cc$export$2e2bcd8739ae039)
    }));
/**![pause](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTMwNCAxNzZoODB2NjcyaC04MHptNDA4IDBoLTY0Yy00LjQgMC04IDMuNi04IDh2NjU2YzAgNC40IDMuNiA4IDggOGg2NGM0LjQgMCA4LTMuNiA4LThWMTg0YzAtNC40LTMuNi04LTgtOHoiIC8+PC9zdmc+) */ const $c28cb742fc860797$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($c28cb742fc860797$var$PauseOutlined);
var $c28cb742fc860797$export$2e2bcd8739ae039 = $c28cb742fc860797$var$RefIcon;



var $5E6i4 = parcelRequire("5E6i4");







var $5E6i4 = parcelRequire("5E6i4");



const $1000b37345f579c3$export$2ee4fbe37e2c4285 = (color, background)=>{
    if (color?.startsWith('var(') || background?.startsWith('var(')) return color;
    return new (0, $1b0a692e36565107$export$2c4f38d6c0ecc25a)(color).onBackground(background).toHexString();
};


"use client";
const $3a05e707730a4dad$var$Empty = ()=>{
    const [, token] = (0, $cb3a44f4e76623bb$export$2e2bcd8739ae039)();
    const [locale] = (0, $a2f3e1f88973a5e2$export$2e2bcd8739ae039)('Empty');
    const { colorBgContainer: colorBgContainer, colorFill: colorFill, colorFillSecondary: colorFillSecondary, colorFillTertiary: colorFillTertiary, colorTextQuaternary: colorTextQuaternary } = token;
    const { panelBgColor: panelBgColor, borderColor: borderColor, detailColor: detailColor, shadowColor: shadowColor, iconColor: iconColor } = (0, $5E6i4.useMemo)(()=>({
            panelBgColor: (0, $1000b37345f579c3$export$2ee4fbe37e2c4285)(colorFillTertiary, colorBgContainer),
            borderColor: (0, $1000b37345f579c3$export$2ee4fbe37e2c4285)(colorTextQuaternary, colorBgContainer),
            detailColor: (0, $1000b37345f579c3$export$2ee4fbe37e2c4285)(colorFill, colorBgContainer),
            shadowColor: (0, $1000b37345f579c3$export$2ee4fbe37e2c4285)(colorFillSecondary, colorBgContainer),
            iconColor: colorBgContainer
        }), [
        colorBgContainer,
        colorFill,
        colorFillSecondary,
        colorFillTertiary,
        colorTextQuaternary
    ]);
    return /*#__PURE__*/ $5E6i4.createElement("svg", {
        width: "184",
        height: "152",
        viewBox: "0 0 184 152",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $5E6i4.createElement("title", null, locale?.description || 'Empty'), /*#__PURE__*/ $5E6i4.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $5E6i4.createElement("g", {
        transform: "translate(24 31.7)"
    }, /*#__PURE__*/ $5E6i4.createElement("ellipse", {
        fillOpacity: ".8",
        fill: shadowColor,
        cx: "67.8",
        cy: "106.9",
        rx: "67.8",
        ry: "12.7"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: borderColor,
        d: "M122 69.7 98.1 40.2a6 6 0 0 0-4.6-2.2H42.1a6 6 0 0 0-4.6 2.2l-24 29.5V85H122z"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: panelBgColor,
        d: "M33.8 0h68a4 4 0 0 1 4 4v93.3a4 4 0 0 1-4 4h-68a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: detailColor,
        d: "M42.7 10h50.2a2 2 0 0 1 2 2v25a2 2 0 0 1-2 2H42.7a2 2 0 0 1-2-2V12a2 2 0 0 1 2-2m.2 39.8h49.8a2.3 2.3 0 1 1 0 4.5H42.9a2.3 2.3 0 0 1 0-4.5m0 11.7h49.8a2.3 2.3 0 1 1 0 4.6H42.9a2.3 2.3 0 0 1 0-4.6m79 43.5a7 7 0 0 1-6.8 5.4H20.5a7 7 0 0 1-6.7-5.4l-.2-1.8V69.7h26.3c2.9 0 5.2 2.4 5.2 5.4s2.4 5.4 5.3 5.4h34.8c2.9 0 5.3-2.4 5.3-5.4s2.3-5.4 5.2-5.4H122v33.5q0 1-.2 1.8"
    })), /*#__PURE__*/ $5E6i4.createElement("path", {
        fill: detailColor,
        d: "m149.1 33.3-6.8 2.6a1 1 0 0 1-1.3-1.2l2-6.2q-4.1-4.5-4.2-10.4c0-10 10.1-18.1 22.6-18.1S184 8.1 184 18.1s-10.1 18-22.6 18q-6.8 0-12.3-2.8"
    }), /*#__PURE__*/ $5E6i4.createElement("g", {
        fill: iconColor,
        transform: "translate(149.7 15.4)"
    }, /*#__PURE__*/ $5E6i4.createElement("circle", {
        cx: "20.7",
        cy: "3.2",
        r: "2.8"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        d: "M5.7 5.6H0L2.9.7zM9.3.7h5v5h-5z"
    }))));
};
var $3a05e707730a4dad$export$2e2bcd8739ae039 = $3a05e707730a4dad$var$Empty;



var $5E6i4 = parcelRequire("5E6i4");



"use client";
const $f60ba1e6891db413$var$Simple = ()=>{
    const [, token] = (0, $cb3a44f4e76623bb$export$2e2bcd8739ae039)();
    const [locale] = (0, $a2f3e1f88973a5e2$export$2e2bcd8739ae039)('Empty');
    const { colorFill: colorFill, colorFillTertiary: colorFillTertiary, colorFillQuaternary: colorFillQuaternary, colorBgContainer: colorBgContainer } = token;
    const { borderColor: borderColor, shadowColor: shadowColor, contentColor: contentColor } = (0, $5E6i4.useMemo)(()=>({
            borderColor: (0, $1000b37345f579c3$export$2ee4fbe37e2c4285)(colorFill, colorBgContainer),
            shadowColor: (0, $1000b37345f579c3$export$2ee4fbe37e2c4285)(colorFillTertiary, colorBgContainer),
            contentColor: (0, $1000b37345f579c3$export$2ee4fbe37e2c4285)(colorFillQuaternary, colorBgContainer)
        }), [
        colorFill,
        colorFillTertiary,
        colorFillQuaternary,
        colorBgContainer
    ]);
    return /*#__PURE__*/ $5E6i4.createElement("svg", {
        width: "64",
        height: "41",
        viewBox: "0 0 64 41",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $5E6i4.createElement("title", null, locale?.description || 'Empty'), /*#__PURE__*/ $5E6i4.createElement("g", {
        transform: "translate(0 1)",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $5E6i4.createElement("ellipse", {
        fill: shadowColor,
        cx: "32",
        cy: "33",
        rx: "32",
        ry: "7"
    }), /*#__PURE__*/ $5E6i4.createElement("g", {
        fillRule: "nonzero",
        stroke: borderColor
    }, /*#__PURE__*/ $5E6i4.createElement("path", {
        d: "M55 12.8 44.9 1.3Q44 0 42.9 0H21.1q-1.2 0-2 1.3L9 12.8V22h46z"
    }), /*#__PURE__*/ $5E6i4.createElement("path", {
        d: "M41.6 16c0-1.7 1-3 2.2-3H55v18.1c0 2.2-1.3 3.9-3 3.9H12c-1.7 0-3-1.7-3-3.9V13h11.2c1.2 0 2.2 1.3 2.2 3s1 2.9 2.2 2.9h14.8c1.2 0 2.2-1.4 2.2-3",
        fill: contentColor
    }))));
};
var $f60ba1e6891db413$export$2e2bcd8739ae039 = $f60ba1e6891db413$var$Simple;



// ============================== Shared ==============================
const $78e62810fec9e7e9$var$genSharedEmptyStyle = (token)=>{
    const { componentCls: componentCls, margin: margin, marginXS: marginXS, marginXL: marginXL, fontSize: fontSize, lineHeight: lineHeight } = token;
    return {
        [componentCls]: {
            marginInline: marginXS,
            fontSize: fontSize,
            lineHeight: lineHeight,
            textAlign: 'center',
            // 原来 &-image 没有父子结构，现在为了外层承担我们的 hashId，改成父子结构
            [`${componentCls}-image`]: {
                height: token.emptyImgHeight,
                marginBottom: marginXS,
                opacity: token.opacityImage,
                img: {
                    height: '100%'
                },
                svg: {
                    maxWidth: '100%',
                    height: '100%',
                    margin: 'auto'
                }
            },
            [`${componentCls}-description`]: {
                color: token.colorTextDescription
            },
            // 原来 &-footer 没有父子结构，现在为了外层承担我们的 hashId，改成父子结构
            [`${componentCls}-footer`]: {
                marginTop: margin
            },
            '&-normal': {
                marginBlock: marginXL,
                color: token.colorTextDescription,
                [`${componentCls}-description`]: {
                    color: token.colorTextDescription
                },
                [`${componentCls}-image`]: {
                    height: token.emptyImgHeightMD
                }
            },
            '&-small': {
                marginBlock: marginXS,
                color: token.colorTextDescription,
                [`${componentCls}-image`]: {
                    height: token.emptyImgHeightSM
                }
            }
        }
    };
};
var // ============================== Export ==============================
$78e62810fec9e7e9$export$2e2bcd8739ae039 = (0, $761caadb5301aee1$export$51ec95de45185b42)('Empty', (token)=>{
    const { componentCls: componentCls, controlHeightLG: controlHeightLG, calc: calc } = token;
    const emptyToken = (0, $f564548c7b6877d5$export$4950aa0f605343fb)(token, {
        emptyImgCls: `${componentCls}-img`,
        emptyImgHeight: calc(controlHeightLG).mul(2.5).equal(),
        emptyImgHeightMD: controlHeightLG,
        emptyImgHeightSM: calc(controlHeightLG).mul(0.875).equal()
    });
    return $78e62810fec9e7e9$var$genSharedEmptyStyle(emptyToken);
});


"use client";
const $3a3a0d3a83db59d1$var$defaultEmptyImg = /*#__PURE__*/ $5E6i4.createElement((0, $3a05e707730a4dad$export$2e2bcd8739ae039), null);
const $3a3a0d3a83db59d1$var$simpleEmptyImg = /*#__PURE__*/ $5E6i4.createElement((0, $f60ba1e6891db413$export$2e2bcd8739ae039), null);
const $3a3a0d3a83db59d1$var$Empty = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { className: className, rootClassName: rootClassName, prefixCls: customizePrefixCls, image: image, description: description, children: children, imageStyle: imageStyle, style: style, classNames: classNames, styles: styles, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles, image: contextImage } = (0, $519f2fad435b3034$export$46f4bd6436a25a31)('empty');
    const prefixCls = getPrefixCls('empty', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $78e62810fec9e7e9$export$2e2bcd8739ae039)(prefixCls);
    const contextStyleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $722c8632ba7bdb89$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: props
    });
    const [locale] = (0, $a2f3e1f88973a5e2$export$2e2bcd8739ae039)('Empty');
    const des = typeof description !== 'undefined' ? description : locale?.description;
    const alt = typeof des === 'string' ? des : 'empty';
    const mergedImage = image ?? contextImage ?? $3a3a0d3a83db59d1$var$defaultEmptyImg;
    let imageNode = null;
    if (typeof mergedImage === 'string') imageNode = /*#__PURE__*/ $5E6i4.createElement("img", {
        draggable: false,
        alt: alt,
        src: mergedImage
    });
    else imageNode = mergedImage;
    var deprecatedName, newName;
    const nativeElementRef = $5E6i4.useRef(null);
    $5E6i4.useImperativeHandle(ref, ()=>({
            nativeElement: nativeElementRef.current
        }));
    return /*#__PURE__*/ $5E6i4.createElement("div", {
        ref: nativeElementRef,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(hashId, cssVarCls, prefixCls, contextClassName, {
            [`${prefixCls}-normal`]: mergedImage === $3a3a0d3a83db59d1$var$simpleEmptyImg,
            [`${prefixCls}-rtl`]: direction === 'rtl'
        }, className, rootClassName, mergedClassNames.root),
        style: mergedStyles.root,
        ...restProps
    }, /*#__PURE__*/ $5E6i4.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-image`, mergedClassNames.image),
        style: {
            ...imageStyle,
            ...mergedStyles.image
        }
    }, imageNode), (0, $b63de2b9864a5d1a$export$72280d5f896dac9a)(des) && /*#__PURE__*/ $5E6i4.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-description`, mergedClassNames.description),
        style: mergedStyles.description
    }, des), (0, $b63de2b9864a5d1a$export$72280d5f896dac9a)(children) && /*#__PURE__*/ $5E6i4.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-footer`, mergedClassNames.footer),
        style: mergedStyles.footer
    }, children));
});
$3a3a0d3a83db59d1$var$Empty.PRESENTED_IMAGE_DEFAULT = $3a3a0d3a83db59d1$var$defaultEmptyImg;
$3a3a0d3a83db59d1$var$Empty.PRESENTED_IMAGE_SIMPLE = $3a3a0d3a83db59d1$var$simpleEmptyImg;
var $3a3a0d3a83db59d1$export$2e2bcd8739ae039 = $3a3a0d3a83db59d1$var$Empty;


var $5E6i4 = parcelRequire("5E6i4");










function $9d8327093d1cc6a4$export$a157d95850191a12(token) {
    return (0, $f564548c7b6877d5$export$4950aa0f605343fb)(token, {
        inputAffixPadding: token.paddingXXS
    });
}
const $9d8327093d1cc6a4$export$bd8b682992bc9781 = (token)=>{
    const { controlHeight: controlHeight, fontSize: fontSize, lineHeight: lineHeight, lineWidth: lineWidth, lineWidthFocus: lineWidthFocus, controlHeightSM: controlHeightSM, controlHeightLG: controlHeightLG, fontSizeLG: fontSizeLG, lineHeightLG: lineHeightLG, paddingSM: paddingSM, controlPaddingHorizontalSM: controlPaddingHorizontalSM, controlPaddingHorizontal: controlPaddingHorizontal, colorFillAlter: colorFillAlter, colorPrimaryHover: colorPrimaryHover, colorPrimary: colorPrimary, controlOutlineWidth: controlOutlineWidth, controlOutline: controlOutline, colorErrorOutline: colorErrorOutline, colorWarningOutline: colorWarningOutline, colorBgContainer: colorBgContainer, inputFontSize: inputFontSize, inputFontSizeLG: inputFontSizeLG, inputFontSizeSM: inputFontSizeSM } = token;
    const mergedFontSize = inputFontSize || fontSize;
    const mergedFontSizeSM = inputFontSizeSM || mergedFontSize;
    const mergedFontSizeLG = inputFontSizeLG || fontSizeLG;
    const paddingBlock = Math.round((controlHeight - mergedFontSize * lineHeight) / 2 * 10) / 10 - lineWidth;
    const paddingBlockSM = Math.round((controlHeightSM - mergedFontSizeSM * lineHeight) / 2 * 10) / 10 - lineWidth;
    const paddingBlockLG = Math.ceil((controlHeightLG - mergedFontSizeLG * lineHeightLG) / 2 * 10) / 10 - lineWidth;
    const componentToken = {
        lineWidthFocus: lineWidthFocus === 0 ? 0 : lineWidth,
        paddingBlock: Math.max(paddingBlock, 0),
        paddingBlockSM: Math.max(paddingBlockSM, 0),
        paddingBlockLG: Math.max(paddingBlockLG, 0),
        paddingInline: paddingSM - lineWidth,
        paddingInlineSM: controlPaddingHorizontalSM - lineWidth,
        paddingInlineLG: controlPaddingHorizontal - lineWidth,
        addonBg: colorFillAlter,
        activeBorderColor: colorPrimary,
        hoverBorderColor: colorPrimaryHover,
        activeShadow: `0 0 0 ${controlOutlineWidth}px ${controlOutline}`,
        errorActiveShadow: `0 0 0 ${controlOutlineWidth}px ${colorErrorOutline}`,
        warningActiveShadow: `0 0 0 ${controlOutlineWidth}px ${colorWarningOutline}`,
        hoverBg: colorBgContainer,
        activeBg: colorBgContainer,
        inputFontSize: mergedFontSize,
        inputFontSizeLG: mergedFontSizeLG,
        inputFontSizeSM: mergedFontSizeSM
    };
    return componentToken;
};




const $abfb65067786f0b7$export$bf820fba296f2fd8 = (token)=>({
        borderColor: token.hoverBorderColor,
        backgroundColor: token.hoverBg
    });
const $abfb65067786f0b7$export$12789f962d420a93 = (token)=>({
        color: token.colorTextDisabled,
        backgroundColor: token.colorBgContainerDisabled,
        borderColor: token.colorBorderDisabled,
        boxShadow: 'none',
        cursor: 'not-allowed',
        opacity: 1,
        'input[disabled], textarea[disabled]': {
            cursor: 'not-allowed'
        },
        '&:hover:not([disabled])': {
            ...$abfb65067786f0b7$export$bf820fba296f2fd8((0, $f564548c7b6877d5$export$4950aa0f605343fb)(token, {
                hoverBorderColor: token.colorBorderDisabled,
                hoverBg: token.colorBgContainerDisabled
            }))
        }
    });
const $abfb65067786f0b7$export$8c569e4cc3fd115f = (token, options)=>({
        background: token.colorBgContainer,
        borderWidth: token.lineWidth,
        borderStyle: token.lineType,
        borderColor: options.borderColor,
        '&:hover': {
            borderColor: options.hoverBorderColor,
            backgroundColor: token.hoverBg
        },
        '&:focus, &:focus-within': {
            borderColor: options.activeBorderColor,
            boxShadow: options.activeShadow,
            outline: 0,
            backgroundColor: token.activeBg
        }
    });
const $abfb65067786f0b7$var$genOutlinedStatusStyle = (token, options)=>({
        [`&${token.componentCls}-status-${options.status}:not(${token.componentCls}-disabled)`]: {
            ...$abfb65067786f0b7$export$8c569e4cc3fd115f(token, options),
            [`${token.componentCls}-prefix, ${token.componentCls}-suffix`]: {
                color: options.affixColor
            }
        },
        [`&${token.componentCls}-status-${options.status}${token.componentCls}-disabled`]: {
            borderColor: options.borderColor
        }
    });
const $abfb65067786f0b7$export$53795bafd774ce02 = (token, extraStyles)=>({
        '&-outlined': {
            ...$abfb65067786f0b7$export$8c569e4cc3fd115f(token, {
                borderColor: token.colorBorder,
                hoverBorderColor: token.hoverBorderColor,
                activeBorderColor: token.activeBorderColor,
                activeShadow: token.activeShadow
            }),
            [`&${token.componentCls}-disabled, &[disabled]`]: {
                ...$abfb65067786f0b7$export$12789f962d420a93(token)
            },
            ...$abfb65067786f0b7$var$genOutlinedStatusStyle(token, {
                status: 'error',
                borderColor: token.colorError,
                hoverBorderColor: token.colorErrorBorderHover,
                activeBorderColor: token.colorError,
                activeShadow: token.errorActiveShadow,
                affixColor: token.colorErrorAffix
            }),
            ...$abfb65067786f0b7$var$genOutlinedStatusStyle(token, {
                status: 'warning',
                borderColor: token.colorWarning,
                hoverBorderColor: token.colorWarningBorderHover,
                activeBorderColor: token.colorWarning,
                activeShadow: token.warningActiveShadow,
                affixColor: token.colorWarningAffix
            }),
            ...extraStyles
        }
    });
const $abfb65067786f0b7$var$genOutlinedGroupStatusStyle = (token, options)=>({
        [`&${token.componentCls}-group-wrapper-status-${options.status}`]: {
            [`${token.componentCls}-group-addon`]: {
                borderColor: options.addonBorderColor,
                color: options.addonColor
            }
        }
    });
const $abfb65067786f0b7$export$8f88f32c046ff727 = (token)=>({
        '&-outlined': {
            [`${token.componentCls}-group`]: {
                '&-addon': {
                    background: token.addonBg,
                    border: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
                },
                '&-addon:first-child': {
                    borderInlineEnd: 0
                },
                '&-addon:last-child': {
                    borderInlineStart: 0
                }
            },
            ...$abfb65067786f0b7$var$genOutlinedGroupStatusStyle(token, {
                status: 'error',
                addonBorderColor: token.colorError,
                addonColor: token.colorErrorText
            }),
            ...$abfb65067786f0b7$var$genOutlinedGroupStatusStyle(token, {
                status: 'warning',
                addonBorderColor: token.colorWarning,
                addonColor: token.colorWarningText
            }),
            [`&${token.componentCls}-group-wrapper-disabled`]: {
                [`${token.componentCls}-group-addon`]: {
                    ...$abfb65067786f0b7$export$12789f962d420a93(token)
                }
            }
        }
    });
/* ============ Borderless ============ */ const $abfb65067786f0b7$var$borderlessFocusVisibleSelector = '&:focus-visible, &:has(input:focus-visible), &:has(textarea:focus-visible)';
const $abfb65067786f0b7$var$genBorderlessFocusVisibleStyle = (token, outlineColor)=>({
        outline: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.lineWidthFocus)} ${token.lineType} ${outlineColor}`,
        outlineOffset: (0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.calc(token.lineWidth).mul(-1).equal()),
        transition: [
            `outline-offset`,
            `outline`
        ].map((prop)=>`${prop} 0s`).join(', ')
    });
const $abfb65067786f0b7$var$genBorderlessStatusStyle = (token, options)=>({
        '&, & input, & textarea': {
            color: options.color
        },
        [$abfb65067786f0b7$var$borderlessFocusVisibleSelector]: $abfb65067786f0b7$var$genBorderlessFocusVisibleStyle(token, options.color),
        [`${token.componentCls}-prefix, ${token.componentCls}-suffix`]: {
            color: options.affixColor
        }
    });
const $abfb65067786f0b7$export$b6de5da7f39edfcb = (token, extraStyles)=>{
    const { componentCls: componentCls } = token;
    return {
        '&-borderless': {
            background: 'transparent',
            border: 'none',
            // Compensate for the removed border to maintain consistent height with other components
            // (e.g. Select borderless) that keep a transparent border.
            paddingBlock: token.calc(token.paddingBlock).add(token.lineWidth).equal(),
            [`&${componentCls}-sm, &${componentCls}-affix-wrapper-sm`]: {
                paddingBlock: token.calc(token.paddingBlockSM).add(token.lineWidth).equal()
            },
            [`&${componentCls}-lg, &${componentCls}-affix-wrapper-lg`]: {
                paddingBlock: token.calc(token.paddingBlockLG).add(token.lineWidth).equal()
            },
            '&:focus, &:focus-within': {
                outline: 'none'
            },
            [$abfb65067786f0b7$var$borderlessFocusVisibleSelector]: $abfb65067786f0b7$var$genBorderlessFocusVisibleStyle(token, token.activeBorderColor),
            // >>>>> Disabled
            [`&${componentCls}-disabled, &[disabled]`]: {
                color: token.colorTextDisabled,
                cursor: 'not-allowed'
            },
            // >>>>> Status
            [`&${componentCls}-status-error`]: $abfb65067786f0b7$var$genBorderlessStatusStyle(token, {
                color: token.colorError,
                affixColor: token.colorErrorAffix
            }),
            [`&${componentCls}-status-warning`]: $abfb65067786f0b7$var$genBorderlessStatusStyle(token, {
                color: token.colorWarning,
                affixColor: token.colorWarningAffix
            }),
            ...extraStyles
        }
    };
};
/* ============== Filled ============== */ const $abfb65067786f0b7$var$genBaseFilledStyle = (token, options)=>({
        background: options.bg,
        borderWidth: token.lineWidth,
        borderStyle: token.lineType,
        borderColor: 'transparent',
        'input&, & input, textarea&, & textarea': {
            color: options?.inputColor ?? 'unset'
        },
        '&:hover': {
            background: options.hoverBg
        },
        '&:focus, &:focus-within': {
            outline: 0,
            borderColor: options.activeBorderColor,
            backgroundColor: token.activeBg
        }
    });
const $abfb65067786f0b7$var$genFilledStatusStyle = (token, options)=>({
        [`&${token.componentCls}-status-${options.status}:not(${token.componentCls}-disabled)`]: {
            ...$abfb65067786f0b7$var$genBaseFilledStyle(token, options),
            [`${token.componentCls}-prefix, ${token.componentCls}-suffix`]: {
                color: options.affixColor
            }
        }
    });
const $abfb65067786f0b7$export$b8365cd7e6671d79 = (token, extraStyles)=>({
        '&-filled': {
            ...$abfb65067786f0b7$var$genBaseFilledStyle(token, {
                bg: token.colorFillTertiary,
                hoverBg: token.colorFillSecondary,
                activeBorderColor: token.activeBorderColor,
                inputColor: token.colorText
            }),
            [`&${token.componentCls}-disabled, &[disabled]`]: {
                ...$abfb65067786f0b7$export$12789f962d420a93(token)
            },
            ...$abfb65067786f0b7$var$genFilledStatusStyle(token, {
                status: 'error',
                bg: token.colorErrorBg,
                hoverBg: token.colorErrorBgHover,
                activeBorderColor: token.colorError,
                inputColor: token.colorErrorText,
                affixColor: token.colorErrorAffix
            }),
            ...$abfb65067786f0b7$var$genFilledStatusStyle(token, {
                status: 'warning',
                bg: token.colorWarningBg,
                hoverBg: token.colorWarningBgHover,
                activeBorderColor: token.colorWarning,
                inputColor: token.colorWarningText,
                affixColor: token.colorWarningAffix
            }),
            ...extraStyles
        }
    });
const $abfb65067786f0b7$var$genFilledGroupStatusStyle = (token, options)=>({
        [`&${token.componentCls}-group-wrapper-status-${options.status}`]: {
            [`${token.componentCls}-group-addon`]: {
                background: options.addonBg,
                color: options.addonColor
            }
        }
    });
const $abfb65067786f0b7$export$542c0fce51b1d515 = (token)=>({
        '&-filled': {
            [`${token.componentCls}-group-addon`]: {
                background: token.colorFillTertiary,
                '&:last-child': {
                    position: 'static'
                }
            },
            ...$abfb65067786f0b7$var$genFilledGroupStatusStyle(token, {
                status: 'error',
                addonBg: token.colorErrorBg,
                addonColor: token.colorErrorText
            }),
            ...$abfb65067786f0b7$var$genFilledGroupStatusStyle(token, {
                status: 'warning',
                addonBg: token.colorWarningBg,
                addonColor: token.colorWarningText
            }),
            [`&${token.componentCls}-group-wrapper-disabled`]: {
                [`${token.componentCls}-group`]: {
                    '&-addon': {
                        background: token.colorFillTertiary,
                        color: token.colorTextDisabled
                    },
                    '&-addon:first-child': {
                        borderInlineStart: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                        borderTop: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                        borderBottom: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
                    },
                    '&-addon:last-child': {
                        borderInlineEnd: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                        borderTop: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                        borderBottom: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
                    }
                }
            }
        }
    });
const $abfb65067786f0b7$export$7617a11352d704b9 = (token, options)=>({
        background: token.colorBgContainer,
        borderWidth: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.lineWidth)} 0`,
        borderStyle: `${token.lineType} none`,
        borderColor: `transparent transparent ${options.borderColor} transparent`,
        borderRadius: 0,
        '&:hover': {
            borderColor: `transparent transparent ${options.hoverBorderColor} transparent`,
            backgroundColor: token.hoverBg
        },
        '&:focus, &:focus-within': {
            borderColor: `transparent transparent ${options.activeBorderColor} transparent`,
            outline: 0,
            backgroundColor: token.activeBg
        }
    });
const $abfb65067786f0b7$var$genUnderlinedStatusStyle = (token, options)=>({
        [`&${token.componentCls}-status-${options.status}:not(${token.componentCls}-disabled)`]: {
            ...$abfb65067786f0b7$export$7617a11352d704b9(token, options),
            [`${token.componentCls}-prefix, ${token.componentCls}-suffix`]: {
                color: options.affixColor
            }
        },
        [`&${token.componentCls}-status-${options.status}${token.componentCls}-disabled`]: {
            borderColor: `transparent transparent ${options.borderColor} transparent`
        }
    });
const $abfb65067786f0b7$export$34771e60e0439351 = (token, extraStyles)=>({
        '&-underlined': {
            ...$abfb65067786f0b7$export$7617a11352d704b9(token, {
                borderColor: token.colorBorder,
                hoverBorderColor: token.hoverBorderColor,
                activeBorderColor: token.activeBorderColor,
                activeShadow: token.activeShadow
            }),
            // >>>>> Disabled
            [`&${token.componentCls}-disabled, &[disabled]`]: {
                color: token.colorTextDisabled,
                boxShadow: 'none',
                cursor: 'not-allowed',
                '&:hover': {
                    borderColor: `transparent transparent ${token.colorBorder} transparent`
                }
            },
            'input[disabled], textarea[disabled]': {
                cursor: 'not-allowed'
            },
            ...$abfb65067786f0b7$var$genUnderlinedStatusStyle(token, {
                status: 'error',
                borderColor: token.colorError,
                hoverBorderColor: token.colorErrorBorderHover,
                activeBorderColor: token.colorError,
                activeShadow: token.errorActiveShadow,
                affixColor: token.colorErrorAffix
            }),
            ...$abfb65067786f0b7$var$genUnderlinedStatusStyle(token, {
                status: 'warning',
                borderColor: token.colorWarning,
                hoverBorderColor: token.colorWarningBorderHover,
                activeBorderColor: token.colorWarning,
                activeShadow: token.warningActiveShadow,
                affixColor: token.colorWarningAffix
            }),
            ...extraStyles
        }
    });


const $2a8a1036c9d4d150$export$92095d0f4c77bd56 = (color)=>({
        // Firefox
        '&::-moz-placeholder': {
            opacity: 1
        },
        '&::placeholder': {
            color: color,
            userSelect: 'none' // https://github.com/ant-design/ant-design/pull/32639
        },
        '&:placeholder-shown': {
            textOverflow: 'ellipsis'
        }
    });
const $2a8a1036c9d4d150$export$3fe86db3643510f9 = (token)=>({
        borderColor: token.activeBorderColor,
        boxShadow: token.activeShadow,
        outline: 0,
        backgroundColor: token.activeBg
    });
const $2a8a1036c9d4d150$export$88e04420bb2dc003 = (token)=>{
    const { paddingBlockLG: paddingBlockLG, lineHeightLG: lineHeightLG, borderRadiusLG: borderRadiusLG, paddingInlineLG: paddingInlineLG } = token;
    return {
        padding: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(paddingBlockLG)} ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(paddingInlineLG)}`,
        fontSize: token.inputFontSizeLG,
        lineHeight: lineHeightLG,
        borderRadius: borderRadiusLG
    };
};
const $2a8a1036c9d4d150$export$bb047f62c5a56f90 = (token)=>({
        padding: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.paddingBlockSM)} ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.paddingInlineSM)}`,
        fontSize: token.inputFontSizeSM,
        borderRadius: token.borderRadiusSM
    });
const $2a8a1036c9d4d150$export$8c9a381315f3ebcd = (token, option = {})=>({
        position: 'relative',
        display: 'inline-block',
        width: '100%',
        minWidth: 0,
        padding: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.paddingBlock)} ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.paddingInline)}`,
        color: token.colorText,
        fontSize: token.inputFontSize,
        lineHeight: token.lineHeight,
        borderRadius: token.borderRadius,
        transition: `all ${token.motionDurationMid}`,
        ...$2a8a1036c9d4d150$export$92095d0f4c77bd56(token.colorTextPlaceholder),
        // Size
        '&-lg': {
            ...$2a8a1036c9d4d150$export$88e04420bb2dc003(token),
            ...option.largeStyle
        },
        '&-sm': {
            ...$2a8a1036c9d4d150$export$bb047f62c5a56f90(token),
            ...option.smallStyle
        },
        // RTL
        '&-rtl, &-textarea-rtl': {
            direction: 'rtl'
        }
    });
const $2a8a1036c9d4d150$export$ffe8b2a9bd2e5cfe = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    return {
        position: 'relative',
        display: 'table',
        width: '100%',
        borderCollapse: 'separate',
        borderSpacing: 0,
        // Undo padding and float of grid classes
        "&[class*='col-']": {
            paddingInlineEnd: token.paddingXS,
            '&:last-child': {
                paddingInlineEnd: 0
            }
        },
        // Sizing options
        [`&-lg ${componentCls}, &-lg > ${componentCls}-group-addon`]: {
            ...$2a8a1036c9d4d150$export$88e04420bb2dc003(token)
        },
        [`&-sm ${componentCls}, &-sm > ${componentCls}-group-addon`]: {
            ...$2a8a1036c9d4d150$export$bb047f62c5a56f90(token)
        },
        // Fix https://github.com/ant-design/ant-design/issues/5754
        [`&-lg ${antCls}-select-single`]: {
            height: token.controlHeightLG
        },
        [`&-sm ${antCls}-select-single`]: {
            height: token.controlHeightSM
        },
        [`> ${componentCls}`]: {
            display: 'table-cell',
            '&:not(:first-child):not(:last-child)': {
                borderRadius: 0
            }
        },
        [`${componentCls}-group`]: {
            '&-addon, &-wrap': {
                display: 'table-cell',
                width: 1,
                whiteSpace: 'nowrap',
                verticalAlign: 'middle',
                '&:not(:first-child):not(:last-child)': {
                    borderRadius: 0
                }
            },
            '&-wrap > *': {
                display: 'block !important'
            },
            '&-addon': {
                position: 'relative',
                padding: `0 ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.paddingInline)}`,
                color: token.colorText,
                fontWeight: 400,
                fontSize: token.inputFontSize,
                textAlign: 'center',
                borderRadius: token.borderRadius,
                transition: `all ${token.motionDurationSlow}`,
                lineHeight: 1,
                // Reset Select's style in addon
                [`${antCls}-select`]: {
                    margin: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.calc(token.paddingBlock).add(1).mul(-1).equal())} ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.calc(token.paddingInline).mul(-1).equal())}`,
                    [`&${antCls}-select-single:not(${antCls}-select-customize-input):not(${antCls}-pagination-size-changer)`]: {
                        backgroundColor: 'inherit',
                        border: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} transparent`,
                        boxShadow: 'none'
                    }
                },
                // https://github.com/ant-design/ant-design/issues/31333
                [`${antCls}-cascader-picker`]: {
                    margin: `-9px ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.calc(token.paddingInline).mul(-1).equal())}`,
                    backgroundColor: 'transparent',
                    [`${antCls}-cascader-input`]: {
                        textAlign: 'start',
                        border: 0,
                        boxShadow: 'none'
                    }
                }
            }
        },
        [componentCls]: {
            width: '100%',
            marginBottom: 0,
            textAlign: 'inherit',
            '&:focus': {
                zIndex: 1,
                // Fix https://gw.alipayobjects.com/zos/rmsportal/DHNpoqfMXSfrSnlZvhsJ.png
                borderInlineEndWidth: 1
            },
            '&:hover': {
                zIndex: 1,
                borderInlineEndWidth: 1
            }
        },
        // Reset rounded corners
        [`> ${componentCls}:first-child, ${componentCls}-group-addon:first-child`]: {
            borderStartEndRadius: 0,
            borderEndEndRadius: 0,
            // Reset Select's style in addon
            [`${antCls}-select`]: {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
            }
        },
        [`> ${componentCls}-affix-wrapper`]: {
            [`&:not(:first-child) ${componentCls}`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            },
            [`&:not(:last-child) ${componentCls}`]: {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
            }
        },
        [`> ${componentCls}:last-child, ${componentCls}-group-addon:last-child`]: {
            borderStartStartRadius: 0,
            borderEndStartRadius: 0,
            // Reset Select's style in addon
            [`${antCls}-select`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            }
        },
        [`${componentCls}-affix-wrapper`]: {
            '&:not(:last-child)': {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
            },
            '&:not(:first-child)': {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            }
        },
        [`&${componentCls}-group-compact`]: {
            display: 'block',
            ...(0, $cd5a520fee8002b4$export$8c467e8859fdef13)(),
            [`${componentCls}-group-addon, ${componentCls}-group-wrap, > ${componentCls}`]: {
                '&:not(:first-child):not(:last-child)': {
                    borderInlineEndWidth: token.lineWidth,
                    '&:hover, &:focus': {
                        zIndex: 1
                    }
                }
            },
            '& > *': {
                display: 'inline-flex',
                float: 'none',
                verticalAlign: 'top',
                // https://github.com/ant-design/ant-design-pro/issues/139
                borderRadius: 0
            },
            [`
        & > ${componentCls}-affix-wrapper,
        & > ${componentCls}-number-affix-wrapper,
        & > ${antCls}-picker-range
      `]: {
                display: 'inline-flex'
            },
            '& > *:not(:last-child)': {
                marginInlineEnd: token.calc(token.lineWidth).mul(-1).equal(),
                borderInlineEndWidth: token.lineWidth
            },
            // Undo float for .ant-input-group .ant-input
            [componentCls]: {
                float: 'none'
            },
            // reset border for Select, DatePicker, AutoComplete, Cascader, Mention, TimePicker, Input
            [`& > ${antCls}-select,
      & > ${antCls}-select-auto-complete ${componentCls},
      & > ${antCls}-cascader-picker ${componentCls},
      & > ${componentCls}-group-wrapper ${componentCls}`]: {
                borderInlineEndWidth: token.lineWidth,
                borderRadius: 0,
                '&:hover, &:focus': {
                    zIndex: 1
                }
            },
            [`& > ${antCls}-select-focused`]: {
                zIndex: 1
            },
            // update z-index for arrow icon
            [`& > ${antCls}-select > ${antCls}-select-arrow`]: {
                zIndex: 1 // https://github.com/ant-design/ant-design/issues/20371
            },
            [`& > *:first-child,
      & > ${antCls}-select:first-child,
      & > ${antCls}-select-auto-complete:first-child ${componentCls},
      & > ${antCls}-cascader-picker:first-child ${componentCls}`]: {
                borderStartStartRadius: token.borderRadius,
                borderEndStartRadius: token.borderRadius
            },
            [`& > *:last-child,
      & > ${antCls}-select:last-child,
      & > ${antCls}-cascader-picker:last-child ${componentCls},
      & > ${antCls}-cascader-picker-focused:last-child ${componentCls}`]: {
                borderInlineEndWidth: token.lineWidth,
                borderStartEndRadius: token.borderRadius,
                borderEndEndRadius: token.borderRadius
            },
            // https://github.com/ant-design/ant-design/issues/12493
            [`& > ${antCls}-select-auto-complete ${componentCls}`]: {
                verticalAlign: 'top'
            },
            [`${componentCls}-group-wrapper + ${componentCls}-group-wrapper`]: {
                marginInlineStart: token.calc(token.lineWidth).mul(-1).equal(),
                [`${componentCls}-affix-wrapper`]: {
                }
            }
        }
    };
};
const $2a8a1036c9d4d150$export$9a752c3888370836 = (token)=>{
    const { componentCls: componentCls, controlHeightSM: controlHeightSM, lineWidth: lineWidth, calc: calc } = token;
    const FIXED_CHROME_COLOR_HEIGHT = 16;
    const colorSmallPadding = calc(controlHeightSM).sub(calc(lineWidth).mul(2)).sub(FIXED_CHROME_COLOR_HEIGHT).div(2).equal();
    return {
        [componentCls]: {
            ...(0, $cd5a520fee8002b4$export$23997c3e44cc1c59)(token),
            ...$2a8a1036c9d4d150$export$8c9a381315f3ebcd(token),
            // Variants
            ...(0, $abfb65067786f0b7$export$53795bafd774ce02)(token),
            ...(0, $abfb65067786f0b7$export$b8365cd7e6671d79)(token),
            ...(0, $abfb65067786f0b7$export$b6de5da7f39edfcb)(token),
            ...(0, $abfb65067786f0b7$export$34771e60e0439351)(token),
            '&[type="color"]': {
                height: token.controlHeight,
                [`&${componentCls}-lg`]: {
                    height: token.controlHeightLG
                },
                [`&${componentCls}-sm`]: {
                    height: controlHeightSM,
                    paddingTop: colorSmallPadding,
                    paddingBottom: colorSmallPadding
                }
            },
            '&[type="search"]::-webkit-search-cancel-button, &[type="search"]::-webkit-search-decoration': {
                appearance: 'none'
            }
        }
    };
};
const $2a8a1036c9d4d150$var$genAllowClearStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        // ========================= Input =========================
        [`${componentCls}-clear-icon`]: {
            margin: 0,
            padding: 0,
            lineHeight: 0,
            color: token.colorTextQuaternary,
            fontSize: token.fontSizeIcon,
            verticalAlign: -1,
            // https://github.com/ant-design/ant-design/pull/18151
            // https://codesandbox.io/s/wizardly-sun-u10br
            cursor: 'pointer',
            transition: `color ${token.motionDurationSlow}`,
            border: 'none',
            outline: 'none',
            backgroundColor: 'transparent',
            '&:hover': {
                color: token.colorIcon
            },
            '&:focus-visible': {
                color: token.colorIcon,
                borderRadius: token.borderRadiusSM,
                ...(0, $cd5a520fee8002b4$export$6539948f0a737e39)(token)
            },
            '&:active': {
                color: token.colorText
            },
            '&-hidden': {
                visibility: 'hidden'
            },
            '&-has-suffix': {
                margin: `0 ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.inputAffixPadding)}`
            }
        }
    };
};
const $2a8a1036c9d4d150$export$77a75da75a374eb9 = (token)=>{
    const { componentCls: componentCls, inputAffixPadding: inputAffixPadding, colorTextDescription: colorTextDescription, motionDurationSlow: motionDurationSlow, colorIcon: colorIcon, colorIconHover: colorIconHover } = token;
    const affixCls = `${componentCls}-affix-wrapper`;
    const affixClsDisabled = `${componentCls}-affix-wrapper-disabled`;
    return {
        [affixCls]: {
            ...$2a8a1036c9d4d150$export$8c9a381315f3ebcd(token),
            display: 'inline-flex',
            '&-focused, &:focus': {
                zIndex: 1
            },
            [`> input${componentCls}`]: {
                padding: 0
            },
            [`> input${componentCls}, > textarea${componentCls}`]: {
                fontSize: 'inherit',
                border: 'none',
                borderRadius: 0,
                outline: 'none',
                background: 'transparent',
                color: 'inherit',
                '&::-ms-reveal': {
                    display: 'none'
                },
                '&:focus': {
                    boxShadow: 'none !important'
                }
            },
            '&::before': {
                display: 'inline-block',
                width: 0,
                visibility: 'hidden',
                content: '"\\a0"'
            },
            [componentCls]: {
                '&-prefix, &-suffix': {
                    display: 'flex',
                    flex: 'none',
                    alignItems: 'center',
                    '> *:not(:last-child)': {
                        marginInlineEnd: token.paddingXS
                    }
                },
                '&-show-count-suffix': {
                    color: colorTextDescription,
                    direction: 'ltr'
                },
                '&-show-count-has-suffix': {
                    marginInlineEnd: token.paddingXXS
                },
                '&-prefix': {
                    marginInlineEnd: inputAffixPadding
                },
                '&-suffix': {
                    marginInlineStart: inputAffixPadding
                },
                // password
                '&-password-icon': {
                    display: 'inline-flex',
                    color: colorIcon,
                    cursor: 'pointer',
                    transition: `all ${motionDurationSlow}`,
                    '&:hover': {
                        color: colorIconHover
                    }
                }
            },
            ...$2a8a1036c9d4d150$var$genAllowClearStyle(token)
        },
        // 覆盖 affix-wrapper borderRadius！
        [`${componentCls}-underlined`]: {
            borderRadius: 0
        },
        [affixClsDisabled]: {
            // password disabled
            [`${componentCls}-password-icon`]: {
                color: colorIcon,
                cursor: 'not-allowed',
                '&:hover': {
                    color: colorIcon
                }
            }
        }
    };
};
const $2a8a1036c9d4d150$var$genGroupStyle = (token)=>{
    const { componentCls: componentCls, borderRadiusLG: borderRadiusLG, borderRadiusSM: borderRadiusSM } = token;
    return {
        [`${componentCls}-group`]: {
            // Style for input-group: input with label, with button or dropdown...
            ...(0, $cd5a520fee8002b4$export$23997c3e44cc1c59)(token),
            ...$2a8a1036c9d4d150$export$ffe8b2a9bd2e5cfe(token),
            '&-rtl': {
                direction: 'rtl'
            },
            '&-wrapper': {
                display: 'inline-block',
                width: '100%',
                textAlign: 'start',
                verticalAlign: 'top',
                // https://github.com/ant-design/ant-design/issues/6403
                '&-rtl': {
                    direction: 'rtl'
                },
                // Size
                '&-lg': {
                    [`${componentCls}-group-addon`]: {
                        borderRadius: borderRadiusLG,
                        fontSize: token.inputFontSizeLG
                    }
                },
                '&-sm': {
                    [`${componentCls}-group-addon`]: {
                        borderRadius: borderRadiusSM
                    }
                },
                // Variants
                ...(0, $abfb65067786f0b7$export$8f88f32c046ff727)(token),
                ...(0, $abfb65067786f0b7$export$542c0fce51b1d515)(token),
                // '&-disabled': {
                //   [`${componentCls}-group-addon`]: {
                //     ...genDisabledStyle(token),
                //   },
                // },
                // Fix the issue of using icons in Space Compact mode
                // https://github.com/ant-design/ant-design/issues/42122
                [`&:not(${componentCls}-compact-first-item):not(${componentCls}-compact-last-item)${componentCls}-compact-item`]: {
                    [`${componentCls}, ${componentCls}-group-addon`]: {
                        borderRadius: 0
                    }
                },
                [`&:not(${componentCls}-compact-last-item)${componentCls}-compact-first-item`]: {
                    [`${componentCls}, ${componentCls}-group-addon`]: {
                        borderStartEndRadius: 0,
                        borderEndEndRadius: 0
                    }
                },
                [`&:not(${componentCls}-compact-first-item)${componentCls}-compact-last-item`]: {
                    [`${componentCls}, ${componentCls}-group-addon`]: {
                        borderStartStartRadius: 0,
                        borderEndStartRadius: 0
                    }
                },
                // Fix the issue of input use show-count param in space compact mode
                // https://github.com/ant-design/ant-design/issues/46872
                [`&:not(${componentCls}-compact-last-item)${componentCls}-compact-item`]: {
                    [`${componentCls}-affix-wrapper`]: {
                        borderStartEndRadius: 0,
                        borderEndEndRadius: 0
                    }
                },
                // Fix the issue of input use `addonAfter` param in space compact mode
                // https://github.com/ant-design/ant-design/issues/52483
                [`&:not(${componentCls}-compact-first-item)${componentCls}-compact-item`]: {
                    [`${componentCls}-affix-wrapper`]: {
                        borderStartStartRadius: 0,
                        borderEndStartRadius: 0
                    }
                }
            }
        }
    };
};
// ============================== Range ===============================
const $2a8a1036c9d4d150$var$genRangeStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-out-of-range`]: {
            [`&, & input, & textarea, ${componentCls}-show-count-suffix, ${componentCls}-data-count`]: {
                color: token.colorError
            }
        }
    };
};
const $2a8a1036c9d4d150$export$de732caeaad5f68e = (0, $761caadb5301aee1$export$51ec95de45185b42)([
    'Input',
    'Shared'
], (token)=>{
    const inputToken = (0, $f564548c7b6877d5$export$4950aa0f605343fb)(token, (0, $9d8327093d1cc6a4$export$a157d95850191a12)(token));
    return [
        $2a8a1036c9d4d150$export$9a752c3888370836(inputToken),
        $2a8a1036c9d4d150$export$77a75da75a374eb9(inputToken)
    ];
}, (0, $9d8327093d1cc6a4$export$bd8b682992bc9781), {
    resetFont: false
});
var $2a8a1036c9d4d150$export$2e2bcd8739ae039 = (0, $761caadb5301aee1$export$51ec95de45185b42)([
    'Input',
    'Component'
], (token)=>{
    const inputToken = (0, $f564548c7b6877d5$export$4950aa0f605343fb)(token, (0, $9d8327093d1cc6a4$export$a157d95850191a12)(token));
    return [
        $2a8a1036c9d4d150$var$genGroupStyle(inputToken),
        $2a8a1036c9d4d150$var$genRangeStyle(inputToken),
        // =====================================================
        // ==             Space Compact                       ==
        // =====================================================
        (0, $1829499b88c32c7f$export$b1208b23589b4b73)(inputToken, {
            focus: true,
            focusElCls: `${inputToken.componentCls}-affix-wrapper-focused`
        })
    ];
}, (0, $9d8327093d1cc6a4$export$bd8b682992bc9781), {
    resetFont: false
});


"use client";
/** @deprecated Please use `Space.Compact` */ const $fd4eb4376c8bb1ac$var$Group = (props)=>{
    const { getPrefixCls: getPrefixCls, direction: direction } = (0, $5E6i4.useContext)((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, className: className } = props;
    const prefixCls = getPrefixCls('input-group', customizePrefixCls);
    const inputPrefixCls = getPrefixCls('input');
    const [hashId, cssVarCls] = (0, $2a8a1036c9d4d150$export$2e2bcd8739ae039)(inputPrefixCls);
    const cls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, cssVarCls, {
        [`${prefixCls}-lg`]: props.size === 'large',
        [`${prefixCls}-sm`]: props.size === 'small',
        [`${prefixCls}-compact`]: props.compact,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, hashId, className);
    const formItemContext = (0, $5E6i4.useContext)((0, $e785311f53d64def$export$bbb5553c6c7a14ed));
    const groupFormItemContext = (0, $5E6i4.useMemo)(()=>({
            ...formItemContext,
            isFormItemInput: false
        }), [
        formItemContext
    ]);
    return /*#__PURE__*/ $5E6i4.createElement((0, $e785311f53d64def$export$bbb5553c6c7a14ed).Provider, {
        value: groupFormItemContext
    }, /*#__PURE__*/ $5E6i4.createElement((0, $600e3c8417a6a15e$export$2e2bcd8739ae039).Compact, {
        className: cls,
        style: props.style,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        onFocus: props.onFocus,
        onBlur: props.onBlur
    }, props.children));
};
var $fd4eb4376c8bb1ac$export$2e2bcd8739ae039 = $fd4eb4376c8bb1ac$var$Group;



var $5E6i4 = parcelRequire("5E6i4");


var $5E6i4 = parcelRequire("5E6i4");
function $5478d455389f25dc$export$ae6255aa850a31d1(props) {
    return !!(props.addonBefore || props.addonAfter);
}
function $5478d455389f25dc$export$a19010aeeaa0c7a(props) {
    return !!(props.prefix || props.suffix || props.allowClear);
}
// TODO: It's better to use `Proxy` replace the `element.value`. But we still need support IE11.
function $5478d455389f25dc$var$cloneEvent(event, target, value) {
    // A bug report filed on WebKit's Bugzilla tracker, dating back to 2009, specifically addresses the issue of cloneNode() not copying files of <input type="file"> elements.
    // As of the last update, this bug was still marked as "NEW," indicating that it might not have been resolved yet​​.
    // https://bugs.webkit.org/show_bug.cgi?id=28123
    const currentTarget = target.cloneNode(true);
    // click clear icon
    const newEvent = Object.create(event, {
        target: {
            value: currentTarget
        },
        currentTarget: {
            value: currentTarget
        }
    });
    // Fill data
    currentTarget.value = value;
    // Fill selection. Some type like `email` not support selection
    // https://github.com/ant-design/ant-design/issues/47833
    if (typeof target.selectionStart === 'number' && typeof target.selectionEnd === 'number') {
        currentTarget.selectionStart = target.selectionStart;
        currentTarget.selectionEnd = target.selectionEnd;
    }
    currentTarget.setSelectionRange = (...args)=>{
        target.setSelectionRange(...args);
    };
    return newEvent;
}
function $5478d455389f25dc$export$c28984794956ddc0(target, e, onChange, targetValue) {
    if (!onChange) return;
    let event = e;
    if (e.type === 'click') {
        // Clone a new target for event.
        // Avoid the following usage, the setQuery method gets the original value.
        //
        // const [query, setQuery] = React.useState('');
        // <Input
        //   allowClear
        //   value={query}
        //   onChange={(e)=> {
        //     setQuery((prevStatus) => e.target.value);
        //   }}
        // />
        event = $5478d455389f25dc$var$cloneEvent(e, target, '');
        onChange(event);
        return;
    }
    // Trigger by composition event, this means we need force change the input value
    // https://github.com/ant-design/ant-design/issues/45737
    // https://github.com/ant-design/ant-design/issues/46598
    if (target.type !== 'file' && targetValue !== undefined) {
        event = $5478d455389f25dc$var$cloneEvent(e, target, targetValue);
        onChange(event);
        return;
    }
    onChange(event);
}


function $dbc240af94f4abfb$var$_extends() {
    $dbc240af94f4abfb$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dbc240af94f4abfb$var$_extends.apply(this, arguments);
}
const $dbc240af94f4abfb$var$BaseInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).forwardRef((props, ref)=>{
    const { inputElement: inputEl, children: children, prefixCls: prefixCls, prefix: prefix, suffix: suffix, addonBefore: addonBefore, addonAfter: addonAfter, className: className, style: style, disabled: disabled, readOnly: readOnly, focused: focused, triggerFocus: triggerFocus, allowClear: allowClear, value: value, handleReset: handleReset, hidden: hidden, classes: classes, classNames: classNames, dataAttrs: dataAttrs, styles: styles, components: components, onClear: onClear } = props;
    const inputElement = children ?? inputEl;
    const AffixWrapperComponent = components?.affixWrapper || 'span';
    const GroupWrapperComponent = components?.groupWrapper || 'span';
    const WrapperComponent = components?.wrapper || 'span';
    const GroupAddonComponent = components?.groupAddon || 'span';
    const containerRef = (0, $5E6i4.useRef)(null);
    const onInputClick = (e)=>{
        if (containerRef.current?.contains(e.target)) triggerFocus?.();
    };
    const hasAffix = (0, $5478d455389f25dc$export$a19010aeeaa0c7a)(props);
    let element = /*#__PURE__*/ (0, $5E6i4.cloneElement)(inputElement, {
        value: value,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(inputElement.props?.className, !hasAffix && classNames?.variant) || null
    });
    // ======================== Ref ======================== //
    const groupRef = (0, $5E6i4.useRef)(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useImperativeHandle(ref, ()=>({
            nativeElement: groupRef.current || containerRef.current
        }));
    // ================== Prefix & Suffix ================== //
    if (hasAffix) {
        // ================== Clear Icon ================== //
        let clearIcon = null;
        if (allowClear) {
            const needClear = !disabled && !readOnly && value && !(typeof allowClear === 'object' && allowClear.disabled);
            const clearIconCls = `${prefixCls}-clear-icon`;
            const iconNode = typeof allowClear === 'object' && allowClear?.clearIcon ? allowClear.clearIcon : "\u2716";
            clearIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("button", {
                type: "button",
                onClick: (event)=>{
                    handleReset?.(event);
                    onClear?.();
                },
                onMouseDown: (e)=>e.preventDefault(),
                className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(clearIconCls, {
                    [`${clearIconCls}-hidden`]: !needClear,
                    [`${clearIconCls}-has-suffix`]: !!suffix
                }, classNames?.clear),
                style: styles?.clear
            }, iconNode);
        }
        const affixWrapperPrefixCls = `${prefixCls}-affix-wrapper`;
        const affixWrapperCls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(affixWrapperPrefixCls, {
            [`${prefixCls}-disabled`]: disabled,
            [`${affixWrapperPrefixCls}-disabled`]: disabled,
            // Not used, but keep it
            [`${affixWrapperPrefixCls}-focused`]: focused,
            // Not used, but keep it
            [`${affixWrapperPrefixCls}-readonly`]: readOnly,
            [`${affixWrapperPrefixCls}-input-with-clear-btn`]: suffix && allowClear && value
        }, classes?.affixWrapper, classNames?.affixWrapper, classNames?.variant);
        const suffixNode = (suffix || allowClear) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("span", {
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-suffix`, classNames?.suffix),
            style: styles?.suffix
        }, clearIcon, suffix);
        element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement(AffixWrapperComponent, $dbc240af94f4abfb$var$_extends({
            className: affixWrapperCls,
            style: styles?.affixWrapper,
            onClick: onInputClick
        }, dataAttrs?.affixWrapper, {
            ref: containerRef
        }), prefix && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("span", {
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-prefix`, classNames?.prefix),
            style: styles?.prefix
        }, prefix), element, suffixNode);
    }
    // ================== Addon ================== //
    if ((0, $5478d455389f25dc$export$ae6255aa850a31d1)(props)) {
        const wrapperCls = `${prefixCls}-group`;
        const addonCls = `${wrapperCls}-addon`;
        const groupWrapperCls = `${wrapperCls}-wrapper`;
        const mergedWrapperClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-wrapper`, wrapperCls, classes?.wrapper, classNames?.wrapper);
        const mergedGroupClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(groupWrapperCls, {
            [`${groupWrapperCls}-disabled`]: disabled
        }, classes?.group, classNames?.groupWrapper);
        // Need another wrapper for changing display:table to display:inline-block
        // and put style prop in wrapper
        element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement(GroupWrapperComponent, {
            className: mergedGroupClassName,
            ref: groupRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement(WrapperComponent, {
            className: mergedWrapperClassName
        }, addonBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement(GroupAddonComponent, {
            className: addonCls
        }, addonBefore), element, addonAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement(GroupAddonComponent, {
            className: addonCls
        }, addonAfter)));
    }
    // `className` and `style` are always on the root element
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).cloneElement(element, {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(element.props?.className, className) || null,
        style: {
            ...element.props?.style,
            ...style
        },
        hidden: hidden
    });
});
var $dbc240af94f4abfb$export$2e2bcd8739ae039 = $dbc240af94f4abfb$var$BaseInput;





var $5E6i4 = parcelRequire("5E6i4");


var $5E6i4 = parcelRequire("5E6i4");
function $74a06fb7f78067fc$export$7a29f0d5cac613ba(value, countConfig) {
    if (!countConfig.max) return true;
    const count = countConfig.strategy(value);
    return count <= countConfig.max;
}
function $74a06fb7f78067fc$export$2e2bcd8739ae039(count, showCount) {
    return $5E6i4.useMemo(()=>{
        let mergedConfig = {};
        if (showCount) mergedConfig.show = typeof showCount === 'object' && showCount.formatter ? showCount.formatter : !!showCount;
        mergedConfig = {
            ...mergedConfig,
            ...count
        };
        const { show: show, ...rest } = mergedConfig;
        return {
            ...rest,
            show: !!show,
            showFormatter: typeof show === 'function' ? show : undefined,
            strategy: rest.strategy || ((value)=>value.length)
        };
    }, [
        count,
        showCount
    ]);
}



var $5E6i4 = parcelRequire("5E6i4");
function $19bf16aee110a72a$export$2e2bcd8739ae039({ countConfig: countConfig, value: value, maxLength: maxLength }) {
    return $5E6i4.useMemo(()=>{
        const mergedMax = countConfig.max ?? maxLength;
        const valueLength = countConfig.strategy(value);
        const isOutOfRange = !!mergedMax && valueLength > mergedMax;
        const hasMaxLength = Number(mergedMax) > 0;
        const dataCount = countConfig.show ? countConfig.showFormatter ? countConfig.showFormatter({
            value: value,
            count: valueLength,
            maxLength: mergedMax
        }) : `${valueLength}${hasMaxLength ? ` / ${mergedMax}` : ''}` : undefined;
        return {
            mergedMax: mergedMax,
            isOutOfRange: isOutOfRange,
            dataCount: dataCount
        };
    }, [
        countConfig,
        maxLength,
        value
    ]);
}



var $5E6i4 = parcelRequire("5E6i4");
function $263cf1d7574af36f$export$2e2bcd8739ae039({ countConfig: countConfig, getTarget: getTarget }) {
    const [selection, setSelection] = $5E6i4.useState(null);
    const getTargetRef = $5E6i4.useRef(getTarget);
    $5E6i4.useEffect(()=>{
        getTargetRef.current = getTarget;
    }, [
        getTarget
    ]);
    $5E6i4.useEffect(()=>{
        if (selection) {
            getTargetRef.current()?.setSelectionRange(...selection);
            setSelection(null);
        }
    }, [
        selection
    ]);
    const getExceedValue = $5E6i4.useCallback((currentValue, isComposing)=>{
        let nextValue = currentValue;
        if (!isComposing && countConfig.exceedFormatter && countConfig.max && countConfig.strategy(currentValue) > countConfig.max) {
            nextValue = countConfig.exceedFormatter(currentValue, {
                max: countConfig.max
            });
            if (currentValue !== nextValue) setSelection([
                getTargetRef.current()?.selectionStart || 0,
                getTargetRef.current()?.selectionEnd || 0
            ]);
        }
        return nextValue;
    }, [
        countConfig
    ]);
    return getExceedValue;
}



function $f2090889b6057bb9$export$2e2bcd8739ae039(defaultValue, controlledValue) {
    const [value, setValue] = (0, $e18df22f16a16360$export$2e2bcd8739ae039)(defaultValue, controlledValue);
    const formatValue = value === undefined || value === null ? '' : String(value);
    return {
        value: value,
        setValue: setValue,
        formatValue: formatValue
    };
}



function $6570676465ccd19e$var$_extends() {
    $6570676465ccd19e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6570676465ccd19e$var$_extends.apply(this, arguments);
}
const $6570676465ccd19e$var$Input = /*#__PURE__*/ (0, $5E6i4.forwardRef)((props, ref)=>{
    const { autoComplete: autoComplete, onChange: onChange, onFocus: onFocus, onBlur: onBlur, onPressEnter: onPressEnter, onKeyDown: onKeyDown, onKeyUp: onKeyUp, prefixCls: prefixCls = 'rc-input', disabled: disabled, htmlSize: htmlSize, className: className, maxLength: maxLength, suffix: suffix, showCount: showCount, count: count, type: type = 'text', classes: classes, classNames: classNames, styles: styles, onCompositionStart: onCompositionStart, onCompositionEnd: onCompositionEnd, ...rest } = props;
    const [focused, setFocused] = (0, $5E6i4.useState)(false);
    const compositionRef = (0, $5E6i4.useRef)(false);
    const keyLockRef = (0, $5E6i4.useRef)(false);
    const inputRef = (0, $5E6i4.useRef)(null);
    const holderRef = (0, $5E6i4.useRef)(null);
    const focus = (option)=>{
        if (inputRef.current) (0, $806ab00ed04609c6$export$2b92016deb0b7aad)(inputRef.current, option);
    };
    // ====================== Value =======================
    const { setValue: setValue, formatValue: formatValue } = (0, $f2090889b6057bb9$export$2e2bcd8739ae039)(props.defaultValue, props.value);
    const countConfig = (0, $74a06fb7f78067fc$export$2e2bcd8739ae039)(count, showCount);
    const { isOutOfRange: isOutOfRange, dataCount: dataCount } = (0, $19bf16aee110a72a$export$2e2bcd8739ae039)({
        countConfig: countConfig,
        value: formatValue,
        maxLength: maxLength
    });
    const getExceedValue = (0, $263cf1d7574af36f$export$2e2bcd8739ae039)({
        countConfig: countConfig,
        getTarget: ()=>inputRef.current
    });
    // ======================= Ref ========================
    (0, $5E6i4.useImperativeHandle)(ref, ()=>({
            focus: focus,
            blur: ()=>{
                inputRef.current?.blur();
            },
            setSelectionRange: (start, end, direction)=>{
                inputRef.current?.setSelectionRange(start, end, direction);
            },
            select: ()=>{
                inputRef.current?.select();
            },
            input: inputRef.current,
            nativeElement: holderRef.current?.nativeElement || inputRef.current
        }));
    (0, $5E6i4.useEffect)(()=>{
        if (keyLockRef.current) keyLockRef.current = false;
        setFocused((prev)=>prev && disabled ? false : prev);
    }, [
        disabled
    ]);
    const triggerChange = (e, currentValue, info)=>{
        const cutValue = getExceedValue(currentValue, compositionRef.current);
        if (info.source === 'compositionEnd' && currentValue === cutValue) // Avoid triggering twice
        // https://github.com/ant-design/ant-design/issues/46587
        return;
        setValue(cutValue);
        if (inputRef.current) (0, $5478d455389f25dc$export$c28984794956ddc0)(inputRef.current, e, onChange, cutValue);
    };
    const onInternalChange = (e)=>{
        triggerChange(e, e.target.value, {
            source: 'change'
        });
    };
    const onInternalCompositionEnd = (e)=>{
        compositionRef.current = false;
        triggerChange(e, e.currentTarget.value, {
            source: 'compositionEnd'
        });
        onCompositionEnd?.(e);
    };
    const handleKeyDown = (e)=>{
        if (onPressEnter && e.key === 'Enter' && !keyLockRef.current && !e.nativeEvent.isComposing) {
            keyLockRef.current = true;
            onPressEnter(e);
        }
        onKeyDown?.(e);
    };
    const handleKeyUp = (e)=>{
        if (e.key === 'Enter') keyLockRef.current = false;
        onKeyUp?.(e);
    };
    const handleFocus = (e)=>{
        setFocused(true);
        onFocus?.(e);
    };
    const handleBlur = (e)=>{
        if (keyLockRef.current) keyLockRef.current = false;
        setFocused(false);
        onBlur?.(e);
    };
    const handleReset = (e)=>{
        setValue('');
        focus();
        if (inputRef.current) (0, $5478d455389f25dc$export$c28984794956ddc0)(inputRef.current, e, onChange);
    };
    // ====================== Input =======================
    const outOfRangeCls = isOutOfRange && `${prefixCls}-out-of-range`;
    const getInputElement = ()=>{
        // Fix https://fb.me/react-unknown-prop
        const otherProps = (0, $48bd91d9f828de66$export$2e2bcd8739ae039)(props, [
            'prefixCls',
            'onPressEnter',
            'addonBefore',
            'addonAfter',
            'prefix',
            'suffix',
            'allowClear',
            // Input elements must be either controlled or uncontrolled,
            // specify either the value prop, or the defaultValue prop, but not both.
            'defaultValue',
            'showCount',
            'count',
            'classes',
            'htmlSize',
            'styles',
            'classNames',
            'onClear'
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("input", $6570676465ccd19e$var$_extends({
            autoComplete: autoComplete
        }, otherProps, {
            onChange: onInternalChange,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onKeyDown: handleKeyDown,
            onKeyUp: handleKeyUp,
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, {
                [`${prefixCls}-disabled`]: disabled
            }, classNames?.input),
            style: styles?.input,
            ref: inputRef,
            size: htmlSize,
            type: type,
            onCompositionStart: (e)=>{
                compositionRef.current = true;
                onCompositionStart?.(e);
            },
            onCompositionEnd: onInternalCompositionEnd
        }));
    };
    const getSuffix = ()=>{
        // Max length value
        if (suffix || countConfig.show) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).Fragment, null, countConfig.show && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("span", {
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-show-count-suffix`, {
                [`${prefixCls}-show-count-has-suffix`]: !!suffix
            }, classNames?.count),
            style: {
                ...styles?.count
            }
        }, dataCount), suffix);
        return null;
    };
    // ====================== Render ======================
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $dbc240af94f4abfb$export$2e2bcd8739ae039), $6570676465ccd19e$var$_extends({}, rest, {
        prefixCls: prefixCls,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(className, outOfRangeCls),
        handleReset: handleReset,
        value: formatValue,
        focused: focused,
        triggerFocus: focus,
        suffix: getSuffix(),
        disabled: disabled,
        classes: classes,
        classNames: classNames,
        styles: styles,
        ref: holderRef
    }), getInputElement());
});
var $6570676465ccd19e$export$2e2bcd8739ae039 = $6570676465ccd19e$var$Input;




var $5E6i4 = parcelRequire("5E6i4");









var $5E6i4 = parcelRequire("5E6i4");
// Thanks to https://github.com/andreypopp/react-textarea-autosize/
/**
 * calculateNodeHeight(uiTextNode, useCache = false)
 */ const $82a608927857a831$var$HIDDEN_TEXTAREA_STYLE = `
  min-height:0 !important;
  max-height:none !important;
  height:0 !important;
  visibility:hidden !important;
  overflow:hidden !important;
  position:absolute !important;
  z-index:-1000 !important;
  top:0 !important;
  right:0 !important;
  pointer-events: none !important;
`;
const $82a608927857a831$var$SIZING_STYLE = [
    'letter-spacing',
    'line-height',
    'padding-top',
    'padding-bottom',
    'font-family',
    'font-weight',
    'font-size',
    'font-variant',
    'text-rendering',
    'text-transform',
    'width',
    'text-indent',
    'padding-left',
    'padding-right',
    'border-width',
    'box-sizing',
    'word-break',
    'white-space'
];
const $82a608927857a831$var$computedStyleCache = {};
let $82a608927857a831$var$hiddenTextarea;
function $82a608927857a831$export$1a56dc6a39385a18(node, useCache = false) {
    const nodeRef = node.getAttribute('id') || node.getAttribute('data-reactid') || node.getAttribute('name');
    if (useCache && $82a608927857a831$var$computedStyleCache[nodeRef]) return $82a608927857a831$var$computedStyleCache[nodeRef];
    const style = window.getComputedStyle(node);
    const boxSizing = style.getPropertyValue('box-sizing') || style.getPropertyValue('-moz-box-sizing') || style.getPropertyValue('-webkit-box-sizing');
    const paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));
    const borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));
    const sizingStyle = $82a608927857a831$var$SIZING_STYLE.map((name)=>`${name}:${style.getPropertyValue(name)}`).join(';');
    const nodeInfo = {
        sizingStyle: sizingStyle,
        paddingSize: paddingSize,
        borderSize: borderSize,
        boxSizing: boxSizing
    };
    if (useCache && nodeRef) $82a608927857a831$var$computedStyleCache[nodeRef] = nodeInfo;
    return nodeInfo;
}
function $82a608927857a831$export$2e2bcd8739ae039(uiTextNode, useCache = false, minRows = null, maxRows = null) {
    if (!$82a608927857a831$var$hiddenTextarea) {
        $82a608927857a831$var$hiddenTextarea = document.createElement('textarea');
        $82a608927857a831$var$hiddenTextarea.setAttribute('tab-index', '-1');
        $82a608927857a831$var$hiddenTextarea.setAttribute('aria-hidden', 'true');
        // fix: A form field element should have an id or name attribute
        // A form field element has neither an id nor a name attribute. This might prevent the browser from correctly autofilling the form.
        // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/textarea
        $82a608927857a831$var$hiddenTextarea.setAttribute('name', 'hiddenTextarea');
        document.body.appendChild($82a608927857a831$var$hiddenTextarea);
    }
    // Fix wrap="off" issue
    // https://github.com/ant-design/ant-design/issues/6577
    if (uiTextNode.getAttribute('wrap')) $82a608927857a831$var$hiddenTextarea.setAttribute('wrap', uiTextNode.getAttribute('wrap'));
    else $82a608927857a831$var$hiddenTextarea.removeAttribute('wrap');
    // Copy all CSS properties that have an impact on the height of the content in
    // the textbox
    const { paddingSize: paddingSize, borderSize: borderSize, boxSizing: boxSizing, sizingStyle: sizingStyle } = $82a608927857a831$export$1a56dc6a39385a18(uiTextNode, useCache);
    // Need to have the overflow attribute to hide the scrollbar otherwise
    // text-lines will not calculated properly as the shadow will technically be
    // narrower for content
    $82a608927857a831$var$hiddenTextarea.setAttribute('style', `${sizingStyle};${$82a608927857a831$var$HIDDEN_TEXTAREA_STYLE}`);
    $82a608927857a831$var$hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || '';
    let minHeight;
    let maxHeight;
    let overflowY;
    let height = $82a608927857a831$var$hiddenTextarea.scrollHeight;
    if (boxSizing === 'border-box') // border-box: add border, since height = content + padding + border
    height += borderSize;
    else if (boxSizing === 'content-box') // remove padding, since height = content
    height -= paddingSize;
    if (minRows !== null || maxRows !== null) {
        // measure height of a textarea with a single row
        $82a608927857a831$var$hiddenTextarea.value = ' ';
        const singleRowHeight = $82a608927857a831$var$hiddenTextarea.scrollHeight - paddingSize;
        if (minRows !== null) {
            minHeight = singleRowHeight * minRows;
            if (boxSizing === 'border-box') minHeight = minHeight + paddingSize + borderSize;
            height = Math.max(minHeight, height);
        }
        if (maxRows !== null) {
            maxHeight = singleRowHeight * maxRows;
            if (boxSizing === 'border-box') maxHeight = maxHeight + paddingSize + borderSize;
            overflowY = height > maxHeight ? undefined : 'hidden';
            height = Math.min(maxHeight, height);
        }
    }
    const style = {
        height: height,
        overflowY: overflowY,
        resize: 'none'
    };
    if (minHeight) style.minHeight = minHeight;
    if (maxHeight) style.maxHeight = maxHeight;
    return style;
}


function $f9f33a34f03527cf$var$_extends() {
    $f9f33a34f03527cf$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f9f33a34f03527cf$var$_extends.apply(this, arguments);
}
const $f9f33a34f03527cf$var$RESIZE_START = 0;
const $f9f33a34f03527cf$var$RESIZE_MEASURING = 1;
const $f9f33a34f03527cf$var$RESIZE_STABLE = 2;
const $f9f33a34f03527cf$var$ResizableTextArea = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, defaultValue: defaultValue, value: value, autoSize: autoSize, onResize: onResize, className: className, style: style, disabled: disabled, onChange: onChange, onInternalAutoSize: // Test only
    onInternalAutoSize, ...restProps } = props;
    // =============================== Value ================================
    const [internalValue, setMergedValue] = (0, $e18df22f16a16360$export$2e2bcd8739ae039)(defaultValue, value);
    const mergedValue = internalValue ?? '';
    const onInternalChange = (event)=>{
        setMergedValue(event.target.value);
        onChange?.(event);
    };
    // ================================ Ref =================================
    const textareaRef = $5E6i4.useRef(null);
    $5E6i4.useImperativeHandle(ref, ()=>({
            textArea: textareaRef.current
        }));
    // ============================== AutoSize ==============================
    const [minRows, maxRows] = $5E6i4.useMemo(()=>{
        if (autoSize && typeof autoSize === 'object') return [
            autoSize.minRows,
            autoSize.maxRows
        ];
        return [];
    }, [
        autoSize
    ]);
    const needAutoSize = !!autoSize;
    // =============================== Resize ===============================
    const [resizeState, setResizeState] = $5E6i4.useState($f9f33a34f03527cf$var$RESIZE_STABLE);
    const [autoSizeStyle, setAutoSizeStyle] = $5E6i4.useState();
    const startResize = ()=>{
        setResizeState($f9f33a34f03527cf$var$RESIZE_START);
    };
    // Change to trigger resize measure
    (0, $518ae471aa4f03a7$export$2e2bcd8739ae039)(()=>{
        if (needAutoSize) startResize();
    }, [
        value,
        minRows,
        maxRows,
        needAutoSize
    ]);
    (0, $518ae471aa4f03a7$export$2e2bcd8739ae039)(()=>{
        if (resizeState === $f9f33a34f03527cf$var$RESIZE_START) setResizeState($f9f33a34f03527cf$var$RESIZE_MEASURING);
        else if (resizeState === $f9f33a34f03527cf$var$RESIZE_MEASURING) {
            const textareaStyles = (0, $82a608927857a831$export$2e2bcd8739ae039)(textareaRef.current, false, minRows, maxRows);
            setResizeState($f9f33a34f03527cf$var$RESIZE_STABLE);
            setAutoSizeStyle(textareaStyles);
        }
    }, [
        resizeState
    ]);
    // We lock resize trigger by raf to avoid Safari warning
    const resizeRafRef = $5E6i4.useRef(undefined);
    const cleanRaf = ()=>{
        if (resizeRafRef.current !== undefined) (0, $1d949665862f071a$export$2e2bcd8739ae039).cancel(resizeRafRef.current);
    };
    const onInternalResize = (size)=>{
        if (resizeState === $f9f33a34f03527cf$var$RESIZE_STABLE) {
            onResize?.(size);
            if (autoSize) {
                cleanRaf();
                resizeRafRef.current = (0, $1d949665862f071a$export$2e2bcd8739ae039)(()=>{
                    startResize();
                });
            }
        }
    };
    $5E6i4.useEffect(()=>cleanRaf, []);
    // =============================== Render ===============================
    const mergedAutoSizeStyle = needAutoSize ? autoSizeStyle : null;
    const mergedStyle = {
        ...style,
        ...mergedAutoSizeStyle
    };
    if (resizeState === $f9f33a34f03527cf$var$RESIZE_START || resizeState === $f9f33a34f03527cf$var$RESIZE_MEASURING) {
        mergedStyle.overflowY = 'hidden';
        mergedStyle.overflowX = 'hidden';
    }
    return /*#__PURE__*/ $5E6i4.createElement((0, $3a396118caae8741$export$2e2bcd8739ae039), {
        onResize: onInternalResize,
        disabled: !(autoSize || onResize)
    }, /*#__PURE__*/ $5E6i4.createElement("textarea", $f9f33a34f03527cf$var$_extends({}, restProps, {
        ref: textareaRef,
        style: mergedStyle,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, className, {
            [`${prefixCls}-disabled`]: disabled
        }),
        disabled: disabled,
        value: mergedValue,
        onChange: onInternalChange
    })));
});
var $f9f33a34f03527cf$export$2e2bcd8739ae039 = $f9f33a34f03527cf$var$ResizableTextArea;



function $86aa7e4fa077f7e5$var$_extends() {
    $86aa7e4fa077f7e5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $86aa7e4fa077f7e5$var$_extends.apply(this, arguments);
}
const $86aa7e4fa077f7e5$var$TextArea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).forwardRef(({ defaultValue: defaultValue, value: customValue, onFocus: onFocus, onBlur: onBlur, onChange: onChange, allowClear: allowClear, maxLength: maxLength, onCompositionStart: onCompositionStart, onCompositionEnd: onCompositionEnd, suffix: suffix, prefixCls: prefixCls = 'rc-textarea', showCount: showCount, count: count, className: className, style: style, disabled: disabled, hidden: hidden, classNames: classNames, styles: styles, onResize: onResize, onClear: onClear, onPressEnter: onPressEnter, readOnly: readOnly, autoSize: autoSize, onKeyDown: onKeyDown, ...rest }, ref)=>{
    const [focused, setFocused] = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useState(false);
    const compositionRef = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useRef(false);
    const [textareaResized, setTextareaResized] = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useState(null);
    // =============================== Ref ================================
    const holderRef = (0, $5E6i4.useRef)(null);
    const resizableTextAreaRef = (0, $5E6i4.useRef)(null);
    const getTextArea = ()=>resizableTextAreaRef.current?.textArea || null;
    const { setValue: setValue, formatValue: formatValue } = (0, $f2090889b6057bb9$export$2e2bcd8739ae039)(defaultValue, customValue);
    const countConfig = (0, $74a06fb7f78067fc$export$2e2bcd8739ae039)(count, showCount);
    const { isOutOfRange: isOutOfRange, dataCount: dataCount } = (0, $19bf16aee110a72a$export$2e2bcd8739ae039)({
        countConfig: countConfig,
        value: formatValue,
        maxLength: maxLength
    });
    const getExceedValue = (0, $263cf1d7574af36f$export$2e2bcd8739ae039)({
        countConfig: countConfig,
        getTarget: ()=>resizableTextAreaRef.current?.textArea || null
    });
    const focus = ()=>{
        getTextArea()?.focus();
    };
    (0, $5E6i4.useImperativeHandle)(ref, ()=>({
            resizableTextArea: resizableTextAreaRef.current,
            focus: focus,
            blur: ()=>{
                getTextArea()?.blur();
            },
            nativeElement: holderRef.current?.nativeElement || getTextArea()
        }));
    (0, $5E6i4.useEffect)(()=>{
        setFocused((prev)=>!disabled && prev);
    }, [
        disabled
    ]);
    // ============================== Count ===============================
    // ============================== Change ==============================
    const triggerChange = (e, currentValue)=>{
        const cutValue = getExceedValue(currentValue, compositionRef.current);
        setValue(cutValue);
        (0, $5478d455389f25dc$export$c28984794956ddc0)(e.currentTarget, e, onChange, cutValue);
    };
    // =========================== Value Update ===========================
    const onInternalCompositionStart = (e)=>{
        compositionRef.current = true;
        onCompositionStart?.(e);
    };
    const onInternalCompositionEnd = (e)=>{
        compositionRef.current = false;
        triggerChange(e, e.currentTarget.value);
        onCompositionEnd?.(e);
    };
    const onInternalChange = (e)=>{
        triggerChange(e, e.target.value);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && onPressEnter && !e.nativeEvent.isComposing) onPressEnter(e);
        onKeyDown?.(e);
    };
    const handleFocus = (e)=>{
        setFocused(true);
        onFocus?.(e);
    };
    const handleBlur = (e)=>{
        setFocused(false);
        onBlur?.(e);
    };
    // ============================== Reset ===============================
    const handleReset = (e)=>{
        setValue('');
        focus();
        const textarea = getTextArea();
        if (textarea) (0, $5478d455389f25dc$export$c28984794956ddc0)(textarea, e, onChange);
    };
    let suffixNode = suffix;
    if (countConfig.show) suffixNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).Fragment, null, suffixNode, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("span", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-data-count`, classNames?.count),
        style: styles?.count
    }, dataCount));
    const handleResize = (size)=>{
        onResize?.(size);
        if (getTextArea()?.style.height) setTextareaResized(true);
    };
    const isPureTextArea = !autoSize && !showCount && !allowClear;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $dbc240af94f4abfb$export$2e2bcd8739ae039), {
        ref: holderRef,
        value: formatValue,
        allowClear: allowClear,
        handleReset: handleReset,
        suffix: suffixNode,
        prefixCls: prefixCls,
        classNames: {
            ...classNames,
            affixWrapper: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(classNames?.affixWrapper, {
                [`${prefixCls}-show-count`]: showCount,
                [`${prefixCls}-textarea-allow-clear`]: allowClear
            })
        },
        disabled: disabled,
        focused: focused,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(className, isOutOfRange && `${prefixCls}-out-of-range`),
        style: {
            ...style,
            ...textareaResized && !isPureTextArea ? {
                height: 'auto'
            } : {}
        },
        dataAttrs: typeof dataCount === 'string' ? {
            affixWrapper: {
                'data-count': dataCount
            }
        } : undefined,
        styles: styles,
        hidden: hidden,
        readOnly: readOnly,
        onClear: onClear
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $f9f33a34f03527cf$export$2e2bcd8739ae039), $86aa7e4fa077f7e5$var$_extends({}, rest, {
        autoSize: autoSize,
        maxLength: maxLength,
        onKeyDown: handleKeyDown,
        onChange: onInternalChange,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onCompositionStart: onInternalCompositionStart,
        onCompositionEnd: onInternalCompositionEnd,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(classNames?.textarea),
        style: {
            resize: style?.resize,
            ...styles?.textarea
        },
        disabled: disabled,
        prefixCls: prefixCls,
        onResize: handleResize,
        ref: resizableTextAreaRef,
        readOnly: readOnly
    })));
});
var $86aa7e4fa077f7e5$export$2e2bcd8739ae039 = $86aa7e4fa077f7e5$var$TextArea;



var $d9fe748be8eece41$export$2e2bcd8739ae039 = (0, $6570676465ccd19e$export$2e2bcd8739ae039);






var $5E6i4 = parcelRequire("5E6i4");

/**
 * Search for the first non-undefined value in the arguments and return it.
 *
 * ```js
 * const mergedIcon = fallbackProp(propIcon, contextIcon, defaultIcon);
 * ```
 *
 * Note: it is different from `??` operator which skips null
 */ function $c3b60ef18d99af24$export$2e2bcd8739ae039(...args) {
    return args.find((arg)=>arg !== undefined);
}




"use client";
const $70f4ddf6024eb372$export$9ea6397a890aa3e5 = (options)=>{
    const { allowClear: allowClear, clearIcon: clearIcon, contextAllowClear: contextAllowClear, contextClearIcon: contextClearIcon, defaultAllowClear: defaultAllowClear, componentName: componentName } = options;
    return (0, $5E6i4.useMemo)(()=>{
        const mergedAllowClear = allowClear ?? contextAllowClear ?? defaultAllowClear;
        if (!mergedAllowClear) return false;
        return {
            clearIcon: (0, $c3b60ef18d99af24$export$2e2bcd8739ae039)((0, $addbc2fddcbb77a9$export$53b83ca8eaab0383)(allowClear) ? allowClear?.clearIcon : clearIcon, (0, $addbc2fddcbb77a9$export$53b83ca8eaab0383)(contextAllowClear) ? contextAllowClear?.clearIcon : contextClearIcon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $18493f15518cd625$export$2e2bcd8739ae039), null)),
            disabled: ((0, $addbc2fddcbb77a9$export$53b83ca8eaab0383)(allowClear) ? allowClear?.disabled : undefined) ?? ((0, $addbc2fddcbb77a9$export$53b83ca8eaab0383)(contextAllowClear) ? contextAllowClear?.disabled : undefined)
        };
    }, [
        allowClear,
        clearIcon,
        contextAllowClear,
        contextClearIcon,
        defaultAllowClear
    ]);
};











var $5E6i4 = parcelRequire("5E6i4");


/**
 * Compatible for legacy `bordered` prop.
 */ const $23d5b57d8a25ce6e$var$useVariant = (component, variant, legacyBordered, fallbackComponent)=>{
    const config = $5E6i4.useContext((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
    const { variant: configVariant, [component]: componentConfig } = config;
    const ctxVariant = $5E6i4.useContext((0, $e785311f53d64def$export$6f0555dad42725fb));
    const fallbackComponentConfig = fallbackComponent ? config[fallbackComponent] : undefined;
    const configComponentVariant = componentConfig?.variant ?? fallbackComponentConfig?.variant;
    const isVariantConfigured = typeof variant !== 'undefined' || legacyBordered === false || typeof ctxVariant !== 'undefined' || typeof configComponentVariant !== 'undefined' || typeof configVariant !== 'undefined';
    let mergedVariant;
    if (typeof variant !== 'undefined') mergedVariant = variant;
    else if (legacyBordered === false) mergedVariant = 'borderless';
    else // form variant > component global variant > fallback component global variant > global variant
    mergedVariant = ctxVariant ?? configComponentVariant ?? configVariant ?? 'outlined';
    const enableVariantCls = (0, $519f2fad435b3034$export$fa216ce2679a073b).includes(mergedVariant);
    return [
        mergedVariant,
        enableVariantCls,
        isVariantConfigured
    ];
};
var $23d5b57d8a25ce6e$export$2e2bcd8739ae039 = $23d5b57d8a25ce6e$var$useVariant;




var $5E6i4 = parcelRequire("5E6i4");
function $925e96010da7940b$export$2e2bcd8739ae039(inputRef, triggerOnMount) {
    const removePasswordTimeoutRef = (0, $5E6i4.useRef)([]);
    const removePasswordTimeout = ()=>{
        removePasswordTimeoutRef.current.push(setTimeout(()=>{
            if (inputRef.current?.input && inputRef.current?.input.getAttribute('type') === 'password' && inputRef.current?.input.hasAttribute('value')) inputRef.current?.input.removeAttribute('value');
        }));
    };
    (0, $5E6i4.useEffect)(()=>{
        if (triggerOnMount) removePasswordTimeout();
        return ()=>removePasswordTimeoutRef.current.forEach((timer)=>{
                if (timer) clearTimeout(timer);
            });
    }, [
        triggerOnMount
    ]);
    return removePasswordTimeout;
}



function $46a4d0ed079cb451$export$a19010aeeaa0c7a(props) {
    return !!(props.prefix || props.suffix || props.allowClear || props.showCount);
}


"use client";
const $b011605874c91f78$var$Input = /*#__PURE__*/ (0, $5E6i4.forwardRef)((props, ref)=>{
    const { prefixCls: customizePrefixCls, bordered: bordered = true, status: customStatus, size: customSize, disabled: customDisabled, onBlur: onBlur, onFocus: onFocus, suffix: suffix, allowClear: allowClear, addonAfter: addonAfter, addonBefore: addonBefore, className: className, style: style, styles: styles, rootClassName: rootClassName, onChange: onChange, classNames: classNames, variant: customVariant, ...rest } = props;
    var prop, newProp;
    const { getPrefixCls: getPrefixCls, direction: direction, allowClear: contextAllowClear, autoComplete: contextAutoComplete, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $519f2fad435b3034$export$46f4bd6436a25a31)('input');
    const prefixCls = getPrefixCls('input', customizePrefixCls);
    const inputRef = (0, $5E6i4.useRef)(null);
    // Style
    const rootCls = (0, $d104ec5f99ed66d7$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $2a8a1036c9d4d150$export$de732caeaad5f68e)(prefixCls, rootClassName);
    (0, $2a8a1036c9d4d150$export$2e2bcd8739ae039)(prefixCls, rootCls);
    // ===================== Compact Item =====================
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $3ee2444c5d59b36b$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    // ===================== Size =====================
    const mergedSize = (0, $4bfc7567df2a969e$export$2e2bcd8739ae039)((ctx)=>customSize ?? compactSize ?? ctx);
    // ===================== Disabled =====================
    const disabled = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useContext((0, $2ab14018ea5b2d79$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled ?? disabled;
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        size: mergedSize,
        disabled: mergedDisabled
    };
    const contextStyleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $722c8632ba7bdb89$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    });
    // ===================== Status =====================
    const { status: contextStatus, hasFeedback: hasFeedback, feedbackIcon: feedbackIcon } = (0, $5E6i4.useContext)((0, $e785311f53d64def$export$bbb5553c6c7a14ed));
    const mergedStatus = (0, $842ff74e676bf26d$export$314e193082d7ba49)(contextStatus, customStatus);
    // ===================== Focus warning =====================
    const inputHasPrefixSuffix = (0, $46a4d0ed079cb451$export$a19010aeeaa0c7a)(props) || !!hasFeedback;
    const prevHasPrefixSuffixRef = (0, $5E6i4.useRef)(inputHasPrefixSuffix);
    // ===================== Remove Password value =====================
    const removePasswordTimeout = (0, $925e96010da7940b$export$2e2bcd8739ae039)(inputRef, true);
    const handleBlur = (e)=>{
        removePasswordTimeout();
        onBlur?.(e);
    };
    const handleFocus = (e)=>{
        removePasswordTimeout();
        onFocus?.(e);
    };
    const handleChange = (e)=>{
        removePasswordTimeout();
        onChange?.(e);
    };
    const suffixNode = (hasFeedback || suffix) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).Fragment, null, suffix, hasFeedback && feedbackIcon);
    const mergedAllowClear = (0, $70f4ddf6024eb372$export$9ea6397a890aa3e5)({
        allowClear: allowClear,
        contextAllowClear: contextAllowClear,
        componentName: 'Input'
    });
    const [variant, enableVariantCls] = (0, $23d5b57d8a25ce6e$export$2e2bcd8739ae039)('input', customVariant, bordered);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $d9fe748be8eece41$export$2e2bcd8739ae039), {
        ref: (0, $92c8c75386168ffc$export$ab452c34e8e05029)(ref, inputRef),
        prefixCls: prefixCls,
        autoComplete: contextAutoComplete,
        ...rest,
        disabled: mergedDisabled,
        onBlur: handleBlur,
        onFocus: handleFocus,
        style: mergedStyles.root,
        styles: mergedStyles,
        suffix: suffixNode,
        allowClear: mergedAllowClear,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(className, rootClassName, cssVarCls, rootCls, compactItemClassnames, contextClassName, mergedClassNames.root),
        onChange: handleChange,
        addonBefore: addonBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $33ed3a59b63447d5$export$2e2bcd8739ae039), {
            form: true,
            space: true
        }, addonBefore),
        addonAfter: addonAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $33ed3a59b63447d5$export$2e2bcd8739ae039), {
            form: true,
            space: true
        }, addonAfter),
        classNames: {
            ...mergedClassNames,
            input: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)({
                [`${prefixCls}-sm`]: mergedSize === 'small',
                [`${prefixCls}-lg`]: mergedSize === 'large',
                [`${prefixCls}-rtl`]: direction === 'rtl'
            }, mergedClassNames.input, hashId),
            variant: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)({
                [`${prefixCls}-${variant}`]: enableVariantCls
            }, (0, $842ff74e676bf26d$export$b08e7b47149942a2)(prefixCls, mergedStatus)),
            affixWrapper: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)({
                [`${prefixCls}-affix-wrapper-sm`]: mergedSize === 'small',
                [`${prefixCls}-affix-wrapper-lg`]: mergedSize === 'large',
                [`${prefixCls}-affix-wrapper-rtl`]: direction === 'rtl'
            }, hashId),
            wrapper: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)({
                [`${prefixCls}-group-rtl`]: direction === 'rtl'
            }, hashId),
            groupWrapper: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)({
                [`${prefixCls}-group-wrapper-sm`]: mergedSize === 'small',
                [`${prefixCls}-group-wrapper-lg`]: mergedSize === 'large',
                [`${prefixCls}-group-wrapper-rtl`]: direction === 'rtl',
                [`${prefixCls}-group-wrapper-${variant}`]: enableVariantCls
            }, (0, $842ff74e676bf26d$export$b08e7b47149942a2)(`${prefixCls}-group-wrapper`, mergedStatus, hasFeedback), hashId)
        }
    });
});
var $b011605874c91f78$export$2e2bcd8739ae039 = $b011605874c91f78$var$Input;




var $5E6i4 = parcelRequire("5E6i4");




var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");
const $150b7c5d4f292a06$export$91db9bc4f8ac944a = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useReducer((ori)=>ori + 1, 0);
};


const $5dbb32223d9a515b$export$bd58d1a153fd4998 = (initialValue)=>{
    const ref = $5E6i4.useRef(initialValue);
    const [, forceUpdate] = (0, $150b7c5d4f292a06$export$91db9bc4f8ac944a)();
    return [
        ()=>ref.current,
        (newValue)=>{
            ref.current = newValue;
            forceUpdate();
        }
    ];
};











// =============================== OTP ================================
const $cb4b5b711d330658$var$genOTPStyle = (token)=>{
    const { componentCls: componentCls, paddingXS: paddingXS } = token;
    return {
        [componentCls]: {
            display: 'inline-flex',
            alignItems: 'center',
            flexWrap: 'nowrap',
            columnGap: paddingXS,
            [`${componentCls}-input-wrapper`]: {
                position: 'relative',
                [`${componentCls}-mask-icon`]: {
                    position: 'absolute',
                    zIndex: '1',
                    top: '50%',
                    right: '50%',
                    transform: 'translate(50%, -50%)',
                    pointerEvents: 'none'
                },
                [`${componentCls}-mask-input`]: {
                    color: 'transparent',
                    caretColor: token.colorText,
                    '&::selection': {
                        color: 'transparent'
                    }
                },
                [`${componentCls}-mask-input[type=number]::-webkit-inner-spin-button`]: {
                    '-webkit-appearance': 'none',
                    margin: 0
                },
                [`${componentCls}-mask-input[type=number]`]: {
                    '-moz-appearance': 'textfield'
                }
            },
            '&-rtl': {
                direction: 'rtl'
            },
            [`${componentCls}-input`]: {
                textAlign: 'center',
                paddingInline: token.paddingXXS
            },
            // ================= Size =================
            [`&${componentCls}-sm ${componentCls}-input`]: {
                paddingInline: token.calc(token.paddingXXS).div(2).equal()
            },
            [`&${componentCls}-lg ${componentCls}-input`]: {
                paddingInline: token.paddingXS
            }
        }
    };
};
var // ============================== Export ==============================
$cb4b5b711d330658$export$2e2bcd8739ae039 = (0, $761caadb5301aee1$export$51ec95de45185b42)([
    'Input',
    'OTP'
], (token)=>{
    const inputToken = (0, $f564548c7b6877d5$export$4950aa0f605343fb)(token, (0, $9d8327093d1cc6a4$export$a157d95850191a12)(token));
    return $cb4b5b711d330658$var$genOTPStyle(inputToken);
}, (0, $9d8327093d1cc6a4$export$bd8b682992bc9781));



var $5E6i4 = parcelRequire("5E6i4");




"use client";
const $740c1d31768180e7$var$DEFAULT_MASK_VALUE = "\u2022";
const $740c1d31768180e7$var$OTPInput = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { className: className, value: value, onChange: onChange, onActiveChange: onActiveChange, index: index, mask: mask, onFocus: onFocus, type: type, ...restProps } = props;
    const { getPrefixCls: getPrefixCls } = $5E6i4.useContext((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('otp');
    const maskValue = typeof mask === 'string' ? mask : $740c1d31768180e7$var$DEFAULT_MASK_VALUE;
    // ========================== Ref ===========================
    const inputRef = $5E6i4.useRef(null);
    $5E6i4.useImperativeHandle(ref, ()=>inputRef.current);
    // ========================= Input ==========================
    const onInternalChange = (e)=>{
        onChange(index, e.target.value);
    };
    // ========================= Focus ==========================
    const syncSelection = ()=>{
        (0, $1d949665862f071a$export$2e2bcd8739ae039)(()=>{
            const inputEle = inputRef.current?.input;
            if (document.activeElement === inputEle && inputEle) inputEle.select();
        });
    };
    const onInternalFocus = (e)=>{
        onFocus?.(e);
        syncSelection();
    };
    // ======================== Keyboard ========================
    const onInternalKeyDown = (event)=>{
        const { key: key, ctrlKey: ctrlKey, metaKey: metaKey } = event;
        if (key === 'ArrowLeft') onActiveChange(index - 1);
        else if (key === 'ArrowRight') onActiveChange(index + 1);
        else if (key === 'z' && (ctrlKey || metaKey)) event.preventDefault();
        else if (key === 'Backspace' && !value) onActiveChange(index - 1);
        syncSelection();
    };
    // ========================= Render =========================
    return /*#__PURE__*/ $5E6i4.createElement("span", {
        className: `${prefixCls}-input-wrapper`,
        role: "presentation"
    }, mask && value !== '' && value !== undefined && /*#__PURE__*/ $5E6i4.createElement("span", {
        className: `${prefixCls}-mask-icon`,
        "aria-hidden": "true"
    }, maskValue), /*#__PURE__*/ $5E6i4.createElement((0, $b011605874c91f78$export$2e2bcd8739ae039), {
        "aria-label": `OTP Input ${index + 1}`,
        ...restProps,
        type: type ?? (mask ? 'password' : 'text'),
        ref: inputRef,
        value: value,
        onInput: onInternalChange,
        onFocus: onInternalFocus,
        onKeyDown: onInternalKeyDown,
        onMouseDown: syncSelection,
        onMouseUp: syncSelection,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(className, {
            [`${prefixCls}-mask-input`]: mask
        })
    }));
});
var $740c1d31768180e7$export$2e2bcd8739ae039 = $740c1d31768180e7$var$OTPInput;


"use client";
function $236babaf689a5aea$var$strToArr(str) {
    return (str || '').split('');
}
const $236babaf689a5aea$var$Separator = (props)=>{
    const { index: index, prefixCls: prefixCls, separator: separator, className: semanticClassName, style: semanticStyle } = props;
    const separatorNode = (0, $addbc2fddcbb77a9$export$f6e2535fb5126e54)(separator) ? separator(index) : separator;
    if (!separatorNode) return null;
    return /*#__PURE__*/ $5E6i4.createElement("span", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-separator`, semanticClassName),
        style: semanticStyle
    }, separatorNode);
};
const $236babaf689a5aea$var$OTP = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, length: length = 6, size: customSize, defaultValue: defaultValue, value: value, onChange: onChange, formatter: formatter, separator: separator, variant: customizeVariant, disabled: disabled, status: customStatus, autoFocus: autoFocus, mask: mask, type: type, autoComplete: autoComplete, onInput: onInput, onFocus: onFocus, inputMode: inputMode, classNames: classNames, styles: styles, className: className, style: style, ...restProps } = props;
    const { classNames: contextClassNames, styles: contextStyles, getPrefixCls: getPrefixCls, direction: direction, style: contextStyle, className: contextClassName } = (0, $519f2fad435b3034$export$46f4bd6436a25a31)('otp');
    const prefixCls = getPrefixCls('otp', customizePrefixCls);
    const [variant] = (0, $23d5b57d8a25ce6e$export$2e2bcd8739ae039)('otp', customizeVariant, undefined, 'input');
    const mergedProps = {
        ...props,
        length: length,
        variant: variant
    };
    const contextStyleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $722c8632ba7bdb89$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    });
    const domAttrs = (0, $78cde6532419ffca$export$2e2bcd8739ae039)(restProps, {
        aria: true,
        data: true,
        attr: true
    });
    // ========================= Root =========================
    // Style
    const [hashId, cssVarCls] = (0, $cb4b5b711d330658$export$2e2bcd8739ae039)(prefixCls);
    // ========================= Size =========================
    const mergedSize = (0, $4bfc7567df2a969e$export$2e2bcd8739ae039)((ctx)=>customSize ?? ctx);
    // ======================== Status ========================
    const formContext = $5E6i4.useContext((0, $e785311f53d64def$export$bbb5553c6c7a14ed));
    const mergedStatus = (0, $842ff74e676bf26d$export$314e193082d7ba49)(formContext.status, customStatus);
    const proxyFormContext = $5E6i4.useMemo(()=>({
            ...formContext,
            status: mergedStatus,
            hasFeedback: false,
            feedbackIcon: null
        }), [
        formContext,
        mergedStatus
    ]);
    // ========================= Refs =========================
    const containerRef = $5E6i4.useRef(null);
    const inputsRef = $5E6i4.useRef({});
    $5E6i4.useImperativeHandle(ref, ()=>({
            focus: ()=>{
                inputsRef.current[0]?.focus();
            },
            blur: ()=>{
                for(let i = 0; i < length; i += 1)inputsRef.current[i]?.blur();
            },
            nativeElement: containerRef.current
        }));
    // ======================= Formatter ======================
    const internalFormatter = (txt)=>formatter ? formatter(txt) : txt;
    // ======================== Values ========================
    const [getValueCells, setValueCells] = (0, $5dbb32223d9a515b$export$bd58d1a153fd4998)($236babaf689a5aea$var$strToArr(internalFormatter(defaultValue || '')));
    const valueCells = getValueCells();
    $5E6i4.useEffect(()=>{
        if (value !== undefined) setValueCells($236babaf689a5aea$var$strToArr(value));
    }, [
        value
    ]);
    const triggerValueCellsChange = (0, $68990f4402d2f009$export$2e2bcd8739ae039)((nextValueCells)=>{
        const prevCells = getValueCells();
        setValueCells(nextValueCells);
        if (onInput) onInput(nextValueCells);
        // Trigger if all cells are filled
        if (onChange && nextValueCells.length === length && nextValueCells.every((c)=>c) && nextValueCells.some((c, index)=>prevCells[index] !== c)) onChange(nextValueCells.join(''));
    });
    const patchValue = (0, $68990f4402d2f009$export$2e2bcd8739ae039)((index, txt)=>{
        let nextCells = (0, $0acfae8147afe964$export$2e2bcd8739ae039)(valueCells);
        // Fill cells till index
        for(let i = 0; i < index; i += 1)if (!nextCells[i]) nextCells[i] = '';
        if (txt.length <= 1) nextCells[index] = txt;
        else nextCells = nextCells.slice(0, index).concat($236babaf689a5aea$var$strToArr(txt));
        nextCells = nextCells.slice(0, length);
        // Clean the last empty cell
        for(let i = nextCells.length - 1; i >= 0; i -= 1){
            if (nextCells[i]) break;
            nextCells.pop();
        }
        // Format if needed
        const formattedValue = internalFormatter(nextCells.map((c)=>c || ' ').join(''));
        nextCells = $236babaf689a5aea$var$strToArr(formattedValue).map((c, i)=>{
            if (c === ' ' && !nextCells[i]) return nextCells[i];
            return c;
        });
        return nextCells;
    });
    // ======================== Change ========================
    const onInputChange = (index, txt)=>{
        const nextCells = patchValue(index, txt);
        const nextIndex = Math.min(index + txt.length, length - 1);
        // Update cells before moving focus so that the focus guard reads fresh values.
        triggerValueCellsChange(nextCells);
        if (nextIndex !== index && nextCells[index] !== undefined) inputsRef.current[nextIndex]?.focus();
    };
    const onInputActiveChange = (nextIndex)=>{
        inputsRef.current[nextIndex]?.focus();
    };
    // ======================== Focus ========================
    const onInputFocus = (event, index)=>{
        // keep focus on the first empty cell
        for(let i = 0; i < index; i += 1)if (!getValueCells()[i]) {
            inputsRef.current[i]?.focus();
            break;
        }
        onFocus?.(event);
    };
    // ======================== Render ========================
    const inputSharedProps = {
        variant: variant,
        disabled: disabled,
        status: mergedStatus,
        mask: mask,
        type: type,
        inputMode: inputMode,
        autoComplete: autoComplete
    };
    return /*#__PURE__*/ $5E6i4.createElement("div", {
        ...domAttrs,
        ref: containerRef,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(className, prefixCls, {
            [`${prefixCls}-sm`]: mergedSize === 'small',
            [`${prefixCls}-lg`]: mergedSize === 'large',
            [`${prefixCls}-rtl`]: direction === 'rtl'
        }, cssVarCls, hashId, contextClassName, mergedClassNames.root),
        style: mergedStyles.root,
        role: "group"
    }, /*#__PURE__*/ $5E6i4.createElement((0, $e785311f53d64def$export$bbb5553c6c7a14ed).Provider, {
        value: proxyFormContext
    }, Array.from({
        length: length
    }).map((_, index)=>{
        const key = `otp-${index}`;
        const singleValue = valueCells[index] || '';
        return /*#__PURE__*/ $5E6i4.createElement($5E6i4.Fragment, {
            key: key
        }, /*#__PURE__*/ $5E6i4.createElement((0, $740c1d31768180e7$export$2e2bcd8739ae039), {
            ref: (inputEle)=>{
                inputsRef.current[index] = inputEle;
            },
            index: index,
            size: mergedSize,
            htmlSize: 1,
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(mergedClassNames.input, `${prefixCls}-input`),
            style: mergedStyles.input,
            onChange: onInputChange,
            value: singleValue,
            onActiveChange: onInputActiveChange,
            autoFocus: index === 0 && autoFocus,
            onFocus: (event)=>onInputFocus(event, index),
            ...inputSharedProps
        }), index < length - 1 && /*#__PURE__*/ $5E6i4.createElement($236babaf689a5aea$var$Separator, {
            separator: separator,
            index: index,
            prefixCls: prefixCls,
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(mergedClassNames.separator),
            style: mergedStyles.separator
        }));
    })));
});
var $236babaf689a5aea$export$2e2bcd8739ae039 = $236babaf689a5aea$var$OTP;



var $5E6i4 = parcelRequire("5E6i4");












"use client";
const $ccf7be40e275500f$var$defaultIconRender = (visible)=>visible ? /*#__PURE__*/ $5E6i4.createElement((0, $21b283b110732d66$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $5E6i4.createElement((0, $4068c0b99705ad33$export$2e2bcd8739ae039), null);
const $ccf7be40e275500f$var$actionMap = {
    click: 'onClick',
    hover: 'onMouseOver'
};
const $ccf7be40e275500f$var$Password = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { disabled: customDisabled, action: action = 'click', visibilityToggle: visibilityToggle = true, iconRender: iconRender, prefixCls: customizePrefixCls, inputPrefixCls: customizeInputPrefixCls, suffix: suffix, className: className, style: style, classNames: classNames, styles: styles, variant: customizeVariant, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles, iconRender: contextIconRender } = (0, $519f2fad435b3034$export$46f4bd6436a25a31)('inputPassword');
    const [variant] = (0, $23d5b57d8a25ce6e$export$2e2bcd8739ae039)('inputPassword', customizeVariant, props.bordered, 'input');
    const [locale] = (0, $a2f3e1f88973a5e2$export$2e2bcd8739ae039)('global');
    // ===================== Disabled =====================
    const disabled = $5E6i4.useContext((0, $2ab14018ea5b2d79$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled ?? disabled;
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        disabled: mergedDisabled,
        variant: variant
    };
    const contextStyleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $722c8632ba7bdb89$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    });
    const visibilityControlled = (0, $addbc2fddcbb77a9$export$53b83ca8eaab0383)(visibilityToggle) && visibilityToggle.visible !== undefined;
    const [visible, setVisible] = (0, $5E6i4.useState)(()=>visibilityControlled ? visibilityToggle.visible : false);
    const inputRef = (0, $5E6i4.useRef)(null);
    $5E6i4.useEffect(()=>{
        if (visibilityControlled) setVisible(visibilityToggle.visible);
    }, [
        visibilityControlled,
        visibilityToggle
    ]);
    // Remove Password value
    const removePasswordTimeout = (0, $925e96010da7940b$export$2e2bcd8739ae039)(inputRef);
    const onVisibleChange = ()=>{
        if (mergedDisabled) return;
        if (visible) removePasswordTimeout();
        const nextVisible = !visible;
        if (!visibilityControlled) setVisible(nextVisible);
        if ((0, $addbc2fddcbb77a9$export$53b83ca8eaab0383)(visibilityToggle)) visibilityToggle.onVisibleChange?.(nextVisible);
    };
    const getIcon = (prefixCls)=>{
        const iconTrigger = $ccf7be40e275500f$var$actionMap[action] || '';
        const iconRenderer = iconRender || contextIconRender || $ccf7be40e275500f$var$defaultIconRender;
        const icon = iconRenderer(visible);
        const iconTabIndex = (0, $addbc2fddcbb77a9$export$53b83ca8eaab0383)(visibilityToggle) ? visibilityToggle.tabIndex : undefined;
        return /*#__PURE__*/ $5E6i4.createElement("span", {
            key: "passwordIcon",
            role: "button",
            tabIndex: mergedDisabled ? -1 : iconTabIndex ?? 0,
            className: `${prefixCls}-icon`,
            "aria-disabled": mergedDisabled,
            "aria-pressed": visible,
            "aria-label": visible ? locale.hide : locale.show,
            onMouseDown: (e)=>{
                // Prevent focused state lost
                // https://github.com/ant-design/ant-design/issues/15173
                e.preventDefault();
            },
            onMouseUp: (e)=>{
                // Prevent caret position change
                // https://github.com/ant-design/ant-design/issues/23524
                e.preventDefault();
            },
            onKeyDown: (e)=>{
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    if (!e.repeat) onVisibleChange();
                }
            },
            [iconTrigger]: onVisibleChange
        }, icon);
    };
    const inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
    const prefixCls = getPrefixCls('input-password', customizePrefixCls);
    const suffixIcon = visibilityToggle && getIcon(prefixCls);
    const inputClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, contextClassName, className, {
        [`${prefixCls}-${props.size}`]: !!props.size
    });
    const inputProps = {
        ...restProps,
        type: visible ? 'text' : 'password',
        prefixCls: inputPrefixCls,
        suffix: /*#__PURE__*/ $5E6i4.createElement($5E6i4.Fragment, null, suffixIcon, suffix),
        disabled: mergedDisabled,
        className: inputClassName,
        classNames: mergedClassNames,
        styles: mergedStyles,
        variant: variant
    };
    return /*#__PURE__*/ $5E6i4.createElement((0, $b011605874c91f78$export$2e2bcd8739ae039), {
        ref: (0, $92c8c75386168ffc$export$ab452c34e8e05029)(ref, inputRef),
        ...inputProps
    });
});
var $ccf7be40e275500f$export$2e2bcd8739ae039 = $ccf7be40e275500f$var$Password;



var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $2bc2d49fd10e70fb$var$SearchOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"
                }
            }
        ]
    },
    "name": "search",
    "theme": "outlined"
};
var $2bc2d49fd10e70fb$export$2e2bcd8739ae039 = $2bc2d49fd10e70fb$var$SearchOutlined;



function $f9679d6a5def8308$var$_extends() {
    $f9679d6a5def8308$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f9679d6a5def8308$var$_extends.apply(this, arguments);
}
const $f9679d6a5def8308$var$SearchOutlined = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $f9679d6a5def8308$var$_extends({}, props, {
        ref: ref,
        icon: (0, $2bc2d49fd10e70fb$export$2e2bcd8739ae039)
    }));
/**![search](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkwOS42IDg1NC41TDY0OS45IDU5NC44QzY5MC4yIDU0Mi43IDcxMiA0NzkgNzEyIDQxMmMwLTgwLjItMzEuMy0xNTUuNC04Ny45LTIxMi4xLTU2LjYtNTYuNy0xMzItODcuOS0yMTIuMS04Ny45cy0xNTUuNSAzMS4zLTIxMi4xIDg3LjlDMTQzLjIgMjU2LjUgMTEyIDMzMS44IDExMiA0MTJjMCA4MC4xIDMxLjMgMTU1LjUgODcuOSAyMTIuMUMyNTYuNSA2ODAuOCAzMzEuOCA3MTIgNDEyIDcxMmM2NyAwIDEzMC42LTIxLjggMTgyLjctNjJsMjU5LjcgMjU5LjZhOC4yIDguMiAwIDAwMTEuNiAwbDQzLjYtNDMuNWE4LjIgOC4yIDAgMDAwLTExLjZ6TTU3MC40IDU3MC40QzUyOCA2MTIuNyA0NzEuOCA2MzYgNDEyIDYzNnMtMTE2LTIzLjMtMTU4LjQtNjUuNkMyMTEuMyA1MjggMTg4IDQ3MS44IDE4OCA0MTJzMjMuMy0xMTYuMSA2NS42LTE1OC40QzI5NiAyMTEuMyAzNTIuMiAxODggNDEyIDE4OHMxMTYuMSAyMy4yIDE1OC40IDY1LjZTNjM2IDM1Mi4yIDYzNiA0MTJzLTIzLjMgMTE2LjEtNjUuNiAxNTguNHoiIC8+PC9zdmc+) */ const $f9679d6a5def8308$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($f9679d6a5def8308$var$SearchOutlined);
var $f9679d6a5def8308$export$2e2bcd8739ae039 = $f9679d6a5def8308$var$RefIcon;


















const $a0944a02e5019539$var$genSearchStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls, calc: calc, max: max } = token;
    const btnCls = `${componentCls}-btn`;
    const [varName, varRef] = (0, $761caadb5301aee1$export$d82b8f66c5649e14)(antCls, 'input-search');
    const inputFontSizeSM = token.inputFontSizeSM ?? token.fontSize;
    const smallButtonHeight = max(token.controlHeightSM, calc(inputFontSizeSM).mul(token.lineHeight).add(calc(token.paddingBlockSM).mul(2)).add(calc(token.lineWidth).mul(2)).equal());
    return {
        [componentCls]: {
            [varName('btn-height')]: (0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.controlHeight),
            width: '100%',
            // =========================== Button ===========================
            [btnCls]: {
                height: varRef('btn-height'),
                '&:focus-visible': {
                    zIndex: 5
                },
                [`&${antCls}-btn-icon-only`]: {
                    width: varRef('btn-height')
                },
                '&-filled': {
                    background: token.colorFillTertiary,
                    '&:not(:disabled)': {
                        '&:hover': {
                            background: token.colorFillSecondary
                        },
                        '&:active': {
                            background: token.colorFill
                        }
                    }
                }
            },
            [`&${componentCls}-large`]: {
                [varName('btn-height')]: (0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.controlHeightLG)
            },
            [`&${componentCls}-small`]: {
                [varName('btn-height')]: (0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.controlHeightSM)
            },
            [`&${componentCls}-small ${btnCls}`]: {
                minHeight: smallButtonHeight,
                [`&${token.antCls}-btn-icon-only`]: {
                    minWidth: smallButtonHeight
                }
            }
        }
    };
};
var $a0944a02e5019539$export$2e2bcd8739ae039 = (0, $761caadb5301aee1$export$51ec95de45185b42)([
    'Input',
    'Search'
], (token)=>{
    const inputToken = (0, $f564548c7b6877d5$export$4950aa0f605343fb)(token, (0, $9d8327093d1cc6a4$export$a157d95850191a12)(token));
    return $a0944a02e5019539$var$genSearchStyle(inputToken);
}, (0, $9d8327093d1cc6a4$export$bd8b682992bc9781));


"use client";
const $963db1b8714a9100$var$Search = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, inputPrefixCls: customizeInputPrefixCls, className: className, size: customizeSize, style: style, enterButton: enterButton = false, searchIcon: customizeSearchIcon, addonAfter: addonAfter, loading: loading, disabled: disabled, onSearch: customOnSearch, onChange: customOnChange, onCompositionStart: onCompositionStart, onCompositionEnd: onCompositionEnd, variant: customizeVariant, onPressEnter: customOnPressEnter, classNames: classNames, styles: styles, hidden: hidden, ...restProps } = props;
    const { direction: direction, getPrefixCls: getPrefixCls, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles, searchIcon: contextSearchIcon } = (0, $519f2fad435b3034$export$46f4bd6436a25a31)('inputSearch');
    const contextDisabled = $5E6i4.useContext((0, $2ab14018ea5b2d79$export$2e2bcd8739ae039));
    const mergedDisabled = disabled ?? contextDisabled;
    const [mergedVariant, , isVariantConfigured] = (0, $23d5b57d8a25ce6e$export$2e2bcd8739ae039)('inputSearch', customizeVariant, props.bordered);
    const variant = isVariantConfigured ? mergedVariant : undefined;
    const [inputVariant] = (0, $23d5b57d8a25ce6e$export$2e2bcd8739ae039)('inputSearch', customizeVariant, props.bordered, 'input');
    const mergedProps = {
        ...props,
        enterButton: enterButton,
        variant: variant
    };
    const contextStyleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $722c8632ba7bdb89$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    }, {
        button: {
            _default: 'root'
        }
    });
    const composedRef = $5E6i4.useRef(false);
    const prefixCls = getPrefixCls('input-search', customizePrefixCls);
    const inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
    const [hashId, cssVarCls] = (0, $a0944a02e5019539$export$2e2bcd8739ae039)(prefixCls);
    const { compactSize: compactSize } = (0, $3ee2444c5d59b36b$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    const size = (0, $4bfc7567df2a969e$export$2e2bcd8739ae039)((ctx)=>customizeSize ?? compactSize ?? ctx);
    const inputRef = $5E6i4.useRef(null);
    const onChange = (e)=>{
        if (e?.target && e.type === 'click' && customOnSearch) customOnSearch(e.target.value, e, {
            source: 'clear'
        });
        customOnChange?.(e);
    };
    const onMouseDown = (e)=>{
        if (document.activeElement === inputRef.current?.input) e.preventDefault();
    };
    const onSearch = (e)=>{
        if (customOnSearch) customOnSearch(inputRef.current?.input?.value, e, {
            source: 'input'
        });
    };
    const onPressEnter = (e)=>{
        if (composedRef.current || loading) return;
        customOnPressEnter?.(e);
        onSearch(e);
    };
    const searchIcon = typeof enterButton === 'boolean' ? (0, $c3b60ef18d99af24$export$2e2bcd8739ae039)(customizeSearchIcon, contextSearchIcon, /*#__PURE__*/ $5E6i4.createElement((0, $f9679d6a5def8308$export$2e2bcd8739ae039), null)) : null;
    const btnPrefixCls = `${prefixCls}-btn`;
    const btnClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(btnPrefixCls, {
        [`${btnPrefixCls}-${variant}`]: variant
    });
    let button;
    const enterButtonAsElement = enterButton || {};
    const isAntdButton = enterButtonAsElement.type && enterButtonAsElement.type.__ANT_BUTTON === true;
    if (isAntdButton || enterButtonAsElement.type === 'button') {
        const enterButtonProps = enterButtonAsElement.props;
        button = (0, $552e20b6ec4e63a6$export$e530037191fcd5d7)(enterButtonAsElement, {
            disabled: mergedDisabled || enterButtonProps.disabled || !isAntdButton && loading,
            onMouseDown: (e)=>{
                enterButtonProps.onMouseDown?.(e);
                onMouseDown(e);
            },
            onClick: (e)=>{
                enterButtonAsElement?.props?.onClick?.(e);
                onSearch(e);
            },
            key: 'enterButton',
            ...isAntdButton ? {
                className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(btnClassName, enterButtonProps.className),
                loading: loading || enterButtonProps.loading,
                size: size
            } : {}
        });
    } else button = /*#__PURE__*/ $5E6i4.createElement((0, $17f39e4db74a8975$export$2e2bcd8739ae039), {
        classNames: mergedClassNames.button,
        styles: mergedStyles.button,
        className: btnClassName,
        color: enterButton ? 'primary' : 'default',
        size: size,
        disabled: disabled,
        key: "enterButton",
        onMouseDown: onMouseDown,
        onClick: onSearch,
        loading: loading,
        icon: searchIcon,
        variant: variant === 'borderless' || variant === 'filled' || variant === 'underlined' ? 'text' : enterButton ? 'solid' : undefined
    }, enterButton);
    if (addonAfter) button = [
        button,
        (0, $552e20b6ec4e63a6$export$e530037191fcd5d7)(addonAfter, {
            key: 'addonAfter'
        })
    ];
    const mergedClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, cssVarCls, {
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-${size}`]: !!size,
        [`${prefixCls}-with-button`]: !!enterButton
    }, className, contextClassName, hashId, mergedClassNames.root);
    const handleOnCompositionStart = (e)=>{
        composedRef.current = true;
        onCompositionStart?.(e);
    };
    const handleOnCompositionEnd = (e)=>{
        composedRef.current = false;
        onCompositionEnd?.(e);
    };
    // ========================== Render ==========================
    // >>> Root Props
    const rootProps = (0, $78cde6532419ffca$export$2e2bcd8739ae039)(restProps, {
        data: true
    });
    const inputProps = (0, $48bd91d9f828de66$export$2e2bcd8739ae039)({
        ...restProps,
        classNames: (0, $48bd91d9f828de66$export$2e2bcd8739ae039)(mergedClassNames, [
            'button',
            'root'
        ]),
        styles: (0, $48bd91d9f828de66$export$2e2bcd8739ae039)(mergedStyles, [
            'button',
            'root'
        ]),
        prefixCls: inputPrefixCls,
        type: 'search',
        size: size,
        variant: inputVariant,
        onPressEnter: onPressEnter,
        onCompositionStart: handleOnCompositionStart,
        onCompositionEnd: handleOnCompositionEnd,
        onChange: onChange,
        disabled: disabled
    }, Object.keys(rootProps));
    return /*#__PURE__*/ $5E6i4.createElement((0, $3ee2444c5d59b36b$export$2e2bcd8739ae039), {
        className: mergedClassName,
        style: mergedStyles.root,
        ...rootProps,
        hidden: hidden
    }, /*#__PURE__*/ $5E6i4.createElement((0, $b011605874c91f78$export$2e2bcd8739ae039), {
        ref: (0, $92c8c75386168ffc$export$ab452c34e8e05029)(inputRef, ref),
        ...inputProps
    }), button);
});
var $963db1b8714a9100$export$2e2bcd8739ae039 = $963db1b8714a9100$var$Search;



var $5E6i4 = parcelRequire("5E6i4");


















const $3ae4eca9939a3962$var$genTextAreaStyle = (token)=>{
    const { componentCls: componentCls, paddingLG: paddingLG } = token;
    const textareaPrefixCls = `${componentCls}-textarea`;
    return {
        // Raw Textarea
        [`textarea${componentCls}`]: {
            maxWidth: '100%',
            // prevent textarea resize from coming out of its container
            height: 'auto',
            minHeight: token.controlHeight,
            lineHeight: token.lineHeight,
            verticalAlign: 'bottom',
            transition: `all ${token.motionDurationSlow}`,
            resize: 'vertical',
            '@media (hover: none) and (pointer: coarse)': {
                resize: 'none'
            },
            [`&${componentCls}-mouse-active`]: {
                transition: `all ${token.motionDurationSlow}, height 0s, width 0s`
            }
        },
        // Wrapper for resize
        [`${componentCls}-textarea-affix-wrapper-resize-dirty`]: {
            width: 'auto'
        },
        [textareaPrefixCls]: {
            position: 'relative',
            '&-show-count': {
                [`${componentCls}-data-count`]: {
                    position: 'absolute',
                    bottom: token.calc(token.fontSize).mul(token.lineHeight).mul(-1).equal(),
                    insetInlineEnd: 0,
                    color: token.colorTextDescription,
                    whiteSpace: 'nowrap',
                    pointerEvents: 'none'
                }
            },
            [`
        &-allow-clear > ${componentCls},
        &-affix-wrapper${textareaPrefixCls}-has-feedback ${componentCls}
      `]: {
                paddingInlineEnd: paddingLG
            },
            [`&-affix-wrapper${componentCls}-affix-wrapper`]: {
                padding: 0,
                [`> textarea${componentCls}`]: {
                    fontSize: 'inherit',
                    border: 'none',
                    outline: 'none',
                    background: 'transparent',
                    minHeight: token.calc(token.controlHeight).sub(token.calc(token.lineWidth).mul(2)).equal(),
                    '&:focus': {
                        boxShadow: 'none !important'
                    }
                },
                [`${componentCls}-suffix`]: {
                    margin: 0,
                    '> *:not(:last-child)': {
                        marginInline: 0
                    },
                    // Clear Icon
                    [`${componentCls}-clear-icon`]: {
                        position: 'absolute',
                        insetInlineEnd: token.paddingInline,
                        insetBlockStart: token.paddingXS
                    },
                    // Feedback Icon
                    [`${textareaPrefixCls}-suffix`]: {
                        position: 'absolute',
                        top: 0,
                        insetInlineEnd: token.paddingInline,
                        bottom: 0,
                        zIndex: 1,
                        display: 'inline-flex',
                        alignItems: 'center',
                        margin: 'auto',
                        pointerEvents: 'none'
                    }
                }
            },
            [`&-affix-wrapper${componentCls}-affix-wrapper-rtl`]: {
                [`${componentCls}-suffix`]: {
                    [`${componentCls}-data-count`]: {
                        direction: 'ltr',
                        insetInlineStart: 0
                    }
                }
            },
            [`&-affix-wrapper${componentCls}-affix-wrapper-sm`]: {
                [`${componentCls}-suffix`]: {
                    [`${componentCls}-clear-icon`]: {
                        insetInlineEnd: token.paddingInlineSM
                    }
                }
            }
        }
    };
};
var // ============================== Export ==============================
$3ae4eca9939a3962$export$2e2bcd8739ae039 = (0, $761caadb5301aee1$export$51ec95de45185b42)([
    'Input',
    'TextArea'
], (token)=>{
    const inputToken = (0, $f564548c7b6877d5$export$4950aa0f605343fb)(token, (0, $9d8327093d1cc6a4$export$a157d95850191a12)(token));
    return $3ae4eca9939a3962$var$genTextAreaStyle(inputToken);
}, (0, $9d8327093d1cc6a4$export$bd8b682992bc9781), {
    resetFont: false
});


"use client";
const $5f40ac6a13c531df$var$TextArea = /*#__PURE__*/ (0, $5E6i4.forwardRef)((props, ref)=>{
    const { prefixCls: customizePrefixCls, bordered: bordered = true, size: customizeSize, disabled: customDisabled, status: customStatus, allowClear: allowClear, classNames: classNames, rootClassName: rootClassName, className: className, style: style, styles: styles, variant: customVariant, showCount: showCount, onMouseDown: onMouseDown, onResize: onResize, ...rest } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, allowClear: contextAllowClear, autoComplete: contextAutoComplete, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $519f2fad435b3034$export$46f4bd6436a25a31)('textArea');
    // =================== Disabled ===================
    const disabled = $5E6i4.useContext((0, $2ab14018ea5b2d79$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled ?? disabled;
    // ==================== Status ====================
    const { status: contextStatus, hasFeedback: hasFeedback, feedbackIcon: feedbackIcon } = $5E6i4.useContext((0, $e785311f53d64def$export$bbb5553c6c7a14ed));
    const mergedStatus = (0, $842ff74e676bf26d$export$314e193082d7ba49)(contextStatus, customStatus);
    const contextStyleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $722c8632ba7bdb89$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: props
    });
    // ===================== Ref ======================
    const innerRef = $5E6i4.useRef(null);
    $5E6i4.useImperativeHandle(ref, ()=>({
            resizableTextArea: innerRef.current?.resizableTextArea,
            focus: (option)=>{
                (0, $806ab00ed04609c6$export$2b92016deb0b7aad)(innerRef.current?.resizableTextArea?.textArea, option);
            },
            blur: ()=>innerRef.current?.blur(),
            nativeElement: innerRef.current?.nativeElement || null
        }));
    const prefixCls = getPrefixCls('input', customizePrefixCls);
    // ==================== Style =====================
    const rootCls = (0, $d104ec5f99ed66d7$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $2a8a1036c9d4d150$export$de732caeaad5f68e)(prefixCls, rootClassName);
    (0, $3ae4eca9939a3962$export$2e2bcd8739ae039)(prefixCls, rootCls);
    // ================= Compact Item =================
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $3ee2444c5d59b36b$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    // ===================== Size =====================
    const mergedSize = (0, $4bfc7567df2a969e$export$2e2bcd8739ae039)((ctx)=>customizeSize ?? compactSize ?? ctx);
    const [variant, enableVariantCls] = (0, $23d5b57d8a25ce6e$export$2e2bcd8739ae039)('textArea', customVariant, bordered);
    const mergedAllowClear = (0, $70f4ddf6024eb372$export$9ea6397a890aa3e5)({
        allowClear: allowClear,
        contextAllowClear: contextAllowClear,
        componentName: 'TextArea'
    });
    // ==================== Resize ====================
    // https://github.com/ant-design/ant-design/issues/51594
    const [isMouseDown, setIsMouseDown] = $5E6i4.useState(false);
    // When has wrapper, resize will make as dirty for `resize: both` style
    const [resizeDirty, setResizeDirty] = $5E6i4.useState(false);
    const onInternalMouseDown = (e)=>{
        setIsMouseDown(true);
        onMouseDown?.(e);
        const onMouseUp = ()=>{
            setIsMouseDown(false);
            document.removeEventListener('mouseup', onMouseUp);
        };
        document.addEventListener('mouseup', onMouseUp);
    };
    const onInternalResize = (size)=>{
        onResize?.(size);
        // Change to dirty since this maybe from the `resize: both` style
        if (isMouseDown && (0, $addbc2fddcbb77a9$export$f6e2535fb5126e54)(getComputedStyle)) {
            const ele = innerRef.current?.nativeElement?.querySelector('textarea');
            if (ele && getComputedStyle(ele).resize === 'both') setResizeDirty(true);
        }
    };
    // ==================== Render ====================
    return /*#__PURE__*/ $5E6i4.createElement((0, $86aa7e4fa077f7e5$export$2e2bcd8739ae039), {
        autoComplete: contextAutoComplete,
        ...rest,
        style: mergedStyles.root,
        styles: mergedStyles,
        disabled: mergedDisabled,
        allowClear: mergedAllowClear,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(cssVarCls, rootCls, className, rootClassName, compactItemClassnames, contextClassName, mergedClassNames.root, // Only for wrapper
        {
            [`${prefixCls}-textarea-affix-wrapper-resize-dirty`]: resizeDirty
        }),
        classNames: {
            ...mergedClassNames,
            textarea: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)({
                [`${prefixCls}-sm`]: mergedSize === 'small',
                [`${prefixCls}-lg`]: mergedSize === 'large'
            }, hashId, mergedClassNames.textarea, isMouseDown && `${prefixCls}-mouse-active`),
            variant: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)({
                [`${prefixCls}-${variant}`]: enableVariantCls
            }, (0, $842ff74e676bf26d$export$b08e7b47149942a2)(prefixCls, mergedStatus)),
            affixWrapper: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-textarea-affix-wrapper`, {
                [`${prefixCls}-affix-wrapper-rtl`]: direction === 'rtl',
                [`${prefixCls}-affix-wrapper-sm`]: mergedSize === 'small',
                [`${prefixCls}-affix-wrapper-lg`]: mergedSize === 'large',
                [`${prefixCls}-textarea-show-count`]: showCount || props.count?.show
            }, hashId)
        },
        prefixCls: prefixCls,
        suffix: hasFeedback && /*#__PURE__*/ $5E6i4.createElement("span", {
            className: `${prefixCls}-textarea-suffix`
        }, feedbackIcon),
        showCount: showCount,
        ref: innerRef,
        onResize: onInternalResize,
        onMouseDown: onInternalMouseDown
    });
});
var $5f40ac6a13c531df$export$2e2bcd8739ae039 = $5f40ac6a13c531df$var$TextArea;


"use client";
const $8951186c565e4005$var$Input = (0, $b011605874c91f78$export$2e2bcd8739ae039);
$8951186c565e4005$var$Input.Group = (0, $fd4eb4376c8bb1ac$export$2e2bcd8739ae039);
$8951186c565e4005$var$Input.Search = (0, $963db1b8714a9100$export$2e2bcd8739ae039);
$8951186c565e4005$var$Input.TextArea = (0, $5f40ac6a13c531df$export$2e2bcd8739ae039);
$8951186c565e4005$var$Input.Password = (0, $ccf7be40e275500f$export$2e2bcd8739ae039);
$8951186c565e4005$var$Input.OTP = (0, $236babaf689a5aea$export$2e2bcd8739ae039);
var $8951186c565e4005$export$2e2bcd8739ae039 = $8951186c565e4005$var$Input;


var $5E6i4 = parcelRequire("5E6i4");





var $5E6i4 = parcelRequire("5E6i4");




var $5E6i4 = parcelRequire("5E6i4");



"use client";
const $15a8acd98867ae74$var$Element = (props)=>{
    const { prefixCls: prefixCls, className: className, style: style, size: size, shape: shape } = props;
    const sizeCls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)({
        [`${prefixCls}-lg`]: size === 'large',
        [`${prefixCls}-sm`]: size === 'small'
    });
    const shapeCls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)({
        [`${prefixCls}-circle`]: shape === 'circle',
        [`${prefixCls}-square`]: shape === 'square',
        [`${prefixCls}-round`]: shape === 'round'
    });
    const sizeStyle = $5E6i4.useMemo(()=>(0, $addbc2fddcbb77a9$export$7e4aa119212bc614)(size) ? {
            width: size,
            height: size,
            lineHeight: `${size}px`
        } : {}, [
        size
    ]);
    return /*#__PURE__*/ $5E6i4.createElement("span", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, sizeCls, shapeCls, className),
        style: {
            ...sizeStyle,
            ...style
        }
    });
};
var $15a8acd98867ae74$export$2e2bcd8739ae039 = $15a8acd98867ae74$var$Element;




const $2fb9dcd512102fea$var$skeletonClsLoading = new (0, $14544cbeb8c8473b$export$2e2bcd8739ae039)(`ant-skeleton-loading`, {
    '0%': {
        backgroundPosition: '100% 50%'
    },
    '100%': {
        backgroundPosition: '0 50%'
    }
});
const $2fb9dcd512102fea$var$genSkeletonElementCommonSize = (size)=>({
        height: size,
        lineHeight: (0, $56bae8a99c3cba6e$export$523c0b569236b342)(size)
    });
const $2fb9dcd512102fea$var$genSkeletonElementSize = (size)=>({
        width: size,
        ...$2fb9dcd512102fea$var$genSkeletonElementCommonSize(size)
    });
const $2fb9dcd512102fea$var$genSkeletonColor = (token)=>({
        background: token.skeletonLoadingBackground,
        backgroundSize: '400% 100%',
        animationName: $2fb9dcd512102fea$var$skeletonClsLoading,
        animationDuration: token.skeletonLoadingMotionDuration,
        animationTimingFunction: 'ease',
        animationIterationCount: 'infinite'
    });
const $2fb9dcd512102fea$var$genSkeletonElementInputSize = (size, calc)=>({
        width: calc(size).mul(5).equal(),
        minWidth: calc(size).mul(5).equal(),
        ...$2fb9dcd512102fea$var$genSkeletonElementCommonSize(size)
    });
const $2fb9dcd512102fea$var$genSkeletonElementAvatar = (token)=>{
    const { skeletonAvatarCls: skeletonAvatarCls, gradientFromColor: gradientFromColor, controlHeight: controlHeight, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM } = token;
    return {
        [skeletonAvatarCls]: {
            display: 'inline-block',
            verticalAlign: 'top',
            background: gradientFromColor,
            ...$2fb9dcd512102fea$var$genSkeletonElementSize(controlHeight)
        },
        [`${skeletonAvatarCls}${skeletonAvatarCls}-circle`]: {
            borderRadius: '50%'
        },
        [`${skeletonAvatarCls}${skeletonAvatarCls}-lg`]: {
            ...$2fb9dcd512102fea$var$genSkeletonElementSize(controlHeightLG)
        },
        [`${skeletonAvatarCls}${skeletonAvatarCls}-sm`]: {
            ...$2fb9dcd512102fea$var$genSkeletonElementSize(controlHeightSM)
        }
    };
};
const $2fb9dcd512102fea$var$genSkeletonElementInput = (token)=>{
    const { controlHeight: controlHeight, borderRadiusSM: borderRadiusSM, skeletonInputCls: skeletonInputCls, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM, gradientFromColor: gradientFromColor, calc: calc } = token;
    return {
        [skeletonInputCls]: {
            display: 'inline-block',
            verticalAlign: 'top',
            background: gradientFromColor,
            borderRadius: borderRadiusSM,
            ...$2fb9dcd512102fea$var$genSkeletonElementInputSize(controlHeight, calc)
        },
        [`${skeletonInputCls}-lg`]: {
            ...$2fb9dcd512102fea$var$genSkeletonElementInputSize(controlHeightLG, calc)
        },
        [`${skeletonInputCls}-sm`]: {
            ...$2fb9dcd512102fea$var$genSkeletonElementInputSize(controlHeightSM, calc)
        }
    };
};
const $2fb9dcd512102fea$var$genSkeletonElementShape = (token)=>{
    const { gradientFromColor: gradientFromColor, borderRadiusSM: borderRadiusSM, imageSizeBase: imageSizeBase, calc: calc } = token;
    return {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        verticalAlign: 'middle',
        background: gradientFromColor,
        borderRadius: borderRadiusSM,
        ...$2fb9dcd512102fea$var$genSkeletonElementSize(calc(imageSizeBase).mul(2).equal())
    };
};
const $2fb9dcd512102fea$var$genSkeletonElementNode = (token)=>{
    return {
        [token.skeletonNodeCls]: {
            ...$2fb9dcd512102fea$var$genSkeletonElementShape(token)
        }
    };
};
const $2fb9dcd512102fea$var$genSkeletonElementImage = (token)=>{
    const { skeletonImageCls: skeletonImageCls, imageSizeBase: imageSizeBase, calc: calc } = token;
    return {
        [skeletonImageCls]: {
            ...$2fb9dcd512102fea$var$genSkeletonElementShape(token),
            [`${skeletonImageCls}-path`]: {
                fill: '#bfbfbf'
            },
            [`${skeletonImageCls}-svg`]: {
                ...$2fb9dcd512102fea$var$genSkeletonElementSize(imageSizeBase),
                maxWidth: calc(imageSizeBase).mul(4).equal(),
                maxHeight: calc(imageSizeBase).mul(4).equal()
            },
            [`${skeletonImageCls}-svg${skeletonImageCls}-svg-circle`]: {
                borderRadius: '50%'
            }
        },
        [`${skeletonImageCls}${skeletonImageCls}-circle`]: {
            borderRadius: '50%'
        }
    };
};
const $2fb9dcd512102fea$var$genSkeletonElementButtonShape = (token, size, buttonCls)=>{
    const { skeletonButtonCls: skeletonButtonCls } = token;
    return {
        [`${buttonCls}${skeletonButtonCls}-circle`]: {
            width: size,
            minWidth: size,
            borderRadius: '50%'
        },
        [`${buttonCls}${skeletonButtonCls}-round`]: {
            borderRadius: size
        }
    };
};
const $2fb9dcd512102fea$var$genSkeletonElementButtonSize = (size, calc)=>({
        width: calc(size).mul(2).equal(),
        minWidth: calc(size).mul(2).equal(),
        ...$2fb9dcd512102fea$var$genSkeletonElementCommonSize(size)
    });
const $2fb9dcd512102fea$var$genSkeletonElementButton = (token)=>{
    const { borderRadiusSM: borderRadiusSM, skeletonButtonCls: skeletonButtonCls, controlHeight: controlHeight, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM, gradientFromColor: gradientFromColor, calc: calc } = token;
    return {
        [skeletonButtonCls]: {
            display: 'inline-block',
            verticalAlign: 'top',
            background: gradientFromColor,
            borderRadius: borderRadiusSM,
            width: calc(controlHeight).mul(2).equal(),
            minWidth: calc(controlHeight).mul(2).equal(),
            ...$2fb9dcd512102fea$var$genSkeletonElementButtonSize(controlHeight, calc)
        },
        ...$2fb9dcd512102fea$var$genSkeletonElementButtonShape(token, controlHeight, skeletonButtonCls),
        [`${skeletonButtonCls}-lg`]: {
            ...$2fb9dcd512102fea$var$genSkeletonElementButtonSize(controlHeightLG, calc)
        },
        ...$2fb9dcd512102fea$var$genSkeletonElementButtonShape(token, controlHeightLG, `${skeletonButtonCls}-lg`),
        [`${skeletonButtonCls}-sm`]: {
            ...$2fb9dcd512102fea$var$genSkeletonElementButtonSize(controlHeightSM, calc)
        },
        ...$2fb9dcd512102fea$var$genSkeletonElementButtonShape(token, controlHeightSM, `${skeletonButtonCls}-sm`)
    };
};
// =============================== Base ===============================
const $2fb9dcd512102fea$var$genBaseStyle = (token)=>{
    const { componentCls: componentCls, skeletonAvatarCls: skeletonAvatarCls, skeletonTitleCls: skeletonTitleCls, skeletonParagraphCls: skeletonParagraphCls, skeletonButtonCls: skeletonButtonCls, skeletonInputCls: skeletonInputCls, skeletonNodeCls: skeletonNodeCls, skeletonImageCls: skeletonImageCls, controlHeight: controlHeight, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM, gradientFromColor: gradientFromColor, padding: padding, marginSM: marginSM, borderRadius: borderRadius, titleHeight: titleHeight, blockRadius: blockRadius, paragraphLiHeight: paragraphLiHeight, controlHeightXS: controlHeightXS, paragraphMarginTop: paragraphMarginTop } = token;
    return {
        [componentCls]: {
            display: 'table',
            width: '100%',
            [`${componentCls}-header`]: {
                display: 'table-cell',
                paddingInlineEnd: padding,
                verticalAlign: 'top',
                // Avatar
                [skeletonAvatarCls]: {
                    display: 'inline-block',
                    verticalAlign: 'top',
                    background: gradientFromColor,
                    ...$2fb9dcd512102fea$var$genSkeletonElementSize(controlHeight)
                },
                [`${skeletonAvatarCls}-circle`]: {
                    borderRadius: '50%'
                },
                [`${skeletonAvatarCls}-lg`]: {
                    ...$2fb9dcd512102fea$var$genSkeletonElementSize(controlHeightLG)
                },
                [`${skeletonAvatarCls}-sm`]: {
                    ...$2fb9dcd512102fea$var$genSkeletonElementSize(controlHeightSM)
                }
            },
            [`${componentCls}-section`]: {
                display: 'table-cell',
                width: '100%',
                verticalAlign: 'top',
                // Title
                [skeletonTitleCls]: {
                    width: '100%',
                    height: titleHeight,
                    background: gradientFromColor,
                    borderRadius: blockRadius,
                    [`+ ${skeletonParagraphCls}`]: {
                        marginBlockStart: controlHeightSM
                    }
                },
                // paragraph
                [skeletonParagraphCls]: {
                    padding: 0,
                    '> li': {
                        width: '100%',
                        height: paragraphLiHeight,
                        listStyle: 'none',
                        background: gradientFromColor,
                        borderRadius: blockRadius,
                        '+ li': {
                            marginBlockStart: controlHeightXS
                        }
                    }
                },
                [`${skeletonParagraphCls}> li:last-child:not(:first-child):not(:nth-child(2))`]: {
                    width: '61%'
                }
            },
            [`&-round ${componentCls}-section`]: {
                [`${skeletonTitleCls}, ${skeletonParagraphCls} > li`]: {
                    borderRadius: borderRadius
                }
            }
        },
        [`${componentCls}-with-avatar ${componentCls}-section`]: {
            // Title
            [skeletonTitleCls]: {
                marginBlockStart: marginSM,
                [`+ ${skeletonParagraphCls}`]: {
                    marginBlockStart: paragraphMarginTop
                }
            }
        },
        // Skeleton with element
        [`${componentCls}${componentCls}-element`]: {
            display: 'inline-block',
            width: 'auto',
            ...$2fb9dcd512102fea$var$genSkeletonElementButton(token),
            ...$2fb9dcd512102fea$var$genSkeletonElementAvatar(token),
            ...$2fb9dcd512102fea$var$genSkeletonElementInput(token),
            ...$2fb9dcd512102fea$var$genSkeletonElementNode(token),
            ...$2fb9dcd512102fea$var$genSkeletonElementImage(token)
        },
        // Skeleton Block Button, Input
        [`${componentCls}${componentCls}-block`]: {
            width: '100%',
            [skeletonButtonCls]: {
                width: '100%'
            },
            [skeletonInputCls]: {
                width: '100%'
            }
        },
        // With active animation
        [`${componentCls}${componentCls}-active`]: {
            [`
        ${skeletonTitleCls},
        ${skeletonParagraphCls} > li,
        ${skeletonAvatarCls},
        ${skeletonButtonCls},
        ${skeletonInputCls},
        ${skeletonNodeCls},
        ${skeletonImageCls}
      `]: {
                ...$2fb9dcd512102fea$var$genSkeletonColor(token)
            }
        }
    };
};
const $2fb9dcd512102fea$export$9ca1be8807fe0675 = (token)=>{
    const { colorFillContent: colorFillContent, colorFill: colorFill } = token;
    const gradientFromColor = colorFillContent;
    const gradientToColor = colorFill;
    return {
        color: gradientFromColor,
        colorGradientEnd: gradientToColor,
        gradientFromColor: gradientFromColor,
        gradientToColor: gradientToColor,
        titleHeight: token.controlHeight / 2,
        blockRadius: token.borderRadiusSM,
        paragraphMarginTop: token.marginLG + token.marginXXS,
        paragraphLiHeight: token.controlHeight / 2
    };
};
var $2fb9dcd512102fea$export$2e2bcd8739ae039 = (0, $761caadb5301aee1$export$51ec95de45185b42)('Skeleton', (token)=>{
    const { componentCls: componentCls, calc: calc } = token;
    const skeletonToken = (0, $f564548c7b6877d5$export$4950aa0f605343fb)(token, {
        skeletonAvatarCls: `${componentCls}-avatar`,
        skeletonTitleCls: `${componentCls}-title`,
        skeletonParagraphCls: `${componentCls}-paragraph`,
        skeletonButtonCls: `${componentCls}-button`,
        skeletonInputCls: `${componentCls}-input`,
        skeletonNodeCls: `${componentCls}-node`,
        skeletonImageCls: `${componentCls}-image`,
        imageSizeBase: calc(token.controlHeight).mul(1.5).equal(),
        borderRadius: 100,
        // Large number to make capsule shape
        skeletonLoadingBackground: `linear-gradient(90deg, ${token.gradientFromColor} 25%, ${token.gradientToColor} 37%, ${token.gradientFromColor} 63%)`,
        skeletonLoadingMotionDuration: '1.4s'
    });
    return $2fb9dcd512102fea$var$genBaseStyle(skeletonToken);
}, $2fb9dcd512102fea$export$9ca1be8807fe0675, {
    deprecatedTokens: [
        [
            'color',
            'gradientFromColor'
        ],
        [
            'colorGradientEnd',
            'gradientToColor'
        ]
    ]
});


"use client";
const $db83ec587b86bb54$var$SkeletonAvatar = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, classNames: classNames, rootClassName: rootClassName, active: active, style: style, styles: styles, shape: shape = 'circle', size: customSize, ...rest } = props;
    const { getPrefixCls: getPrefixCls } = $5E6i4.useContext((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $2fb9dcd512102fea$export$2e2bcd8739ae039)(prefixCls);
    const mergedSize = (0, $4bfc7567df2a969e$export$2e2bcd8739ae039)((ctx)=>customSize ?? ctx);
    const cls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active
    }, classNames?.root, className, rootClassName, hashId, cssVarCls);
    return /*#__PURE__*/ $5E6i4.createElement("div", {
        className: cls,
        style: styles?.root
    }, /*#__PURE__*/ $5E6i4.createElement((0, $15a8acd98867ae74$export$2e2bcd8739ae039), {
        prefixCls: `${prefixCls}-avatar`,
        className: classNames?.content,
        style: {
            ...styles?.content,
            ...style
        },
        shape: shape,
        size: mergedSize,
        ...rest
    }));
};
var $db83ec587b86bb54$export$2e2bcd8739ae039 = $db83ec587b86bb54$var$SkeletonAvatar;



var $5E6i4 = parcelRequire("5E6i4");





"use client";
const $8f91c427c0bfc434$var$SkeletonButton = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, classNames: classNames, active: active, style: style, styles: styles, block: block = false, size: customSize, ...rest } = props;
    const { getPrefixCls: getPrefixCls } = $5E6i4.useContext((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $2fb9dcd512102fea$export$2e2bcd8739ae039)(prefixCls);
    const mergedSize = (0, $4bfc7567df2a969e$export$2e2bcd8739ae039)((ctx)=>customSize ?? ctx);
    const cls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active,
        [`${prefixCls}-block`]: block
    }, classNames?.root, className, rootClassName, hashId, cssVarCls);
    return /*#__PURE__*/ $5E6i4.createElement("div", {
        className: cls,
        style: styles?.root
    }, /*#__PURE__*/ $5E6i4.createElement((0, $15a8acd98867ae74$export$2e2bcd8739ae039), {
        prefixCls: `${prefixCls}-button`,
        className: classNames?.content,
        style: {
            ...styles?.content,
            ...style
        },
        size: mergedSize,
        ...rest
    }));
};
var $8f91c427c0bfc434$export$2e2bcd8739ae039 = $8f91c427c0bfc434$var$SkeletonButton;




var $5E6i4 = parcelRequire("5E6i4");


var $5E6i4 = parcelRequire("5E6i4");



"use client";
const $e05ddd07bccbd751$var$SkeletonNode = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, classNames: classNames, rootClassName: rootClassName, internalClassName: internalClassName, style: style, styles: styles, active: active, children: children } = props;
    const { getPrefixCls: getPrefixCls } = $5E6i4.useContext((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $2fb9dcd512102fea$export$2e2bcd8739ae039)(prefixCls);
    const cls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active
    }, hashId, classNames?.root, className, rootClassName, cssVarCls);
    return /*#__PURE__*/ $5E6i4.createElement("div", {
        className: cls,
        style: styles?.root
    }, /*#__PURE__*/ $5E6i4.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(classNames?.content, internalClassName || `${prefixCls}-node`),
        style: {
            ...styles?.content,
            ...style
        }
    }, children));
};
var $e05ddd07bccbd751$export$2e2bcd8739ae039 = $e05ddd07bccbd751$var$SkeletonNode;


"use client";
const $4be22b6e4525fabc$var$SkeletonImage = (props)=>{
    const { getPrefixCls: getPrefixCls } = $5E6i4.useContext((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('skeleton', props.prefixCls);
    return /*#__PURE__*/ $5E6i4.createElement((0, $e05ddd07bccbd751$export$2e2bcd8739ae039), {
        ...props,
        internalClassName: `${prefixCls}-image`
    }, /*#__PURE__*/ $5E6i4.createElement("svg", {
        viewBox: "0 0 1098 1024",
        xmlns: "http://www.w3.org/2000/svg",
        className: `${prefixCls}-image-svg`,
        "aria-hidden": "true",
        focusable: "false"
    }, /*#__PURE__*/ $5E6i4.createElement("title", null, "Image placeholder"), /*#__PURE__*/ $5E6i4.createElement("path", {
        d: "M365.7 329.1q0 45.8-32 77.7t-77.7 32-77.7-32-32-77.7 32-77.6 77.7-32 77.7 32 32 77.6M951 548.6v256H146.3V694.9L329 512l91.5 91.4L713 311zm54.8-402.3H91.4q-7.4 0-12.8 5.4T73 164.6v694.8q0 7.5 5.5 12.9t12.8 5.4h914.3q7.5 0 12.9-5.4t5.4-12.9V164.6q0-7.5-5.4-12.9t-12.9-5.4m91.4 18.3v694.8q0 37.8-26.8 64.6t-64.6 26.9H91.4q-37.7 0-64.6-26.9T0 859.4V164.6q0-37.8 26.8-64.6T91.4 73h914.3q37.8 0 64.6 26.9t26.8 64.6",
        className: `${prefixCls}-image-path`
    })));
};
var $4be22b6e4525fabc$export$2e2bcd8739ae039 = $4be22b6e4525fabc$var$SkeletonImage;



var $5E6i4 = parcelRequire("5E6i4");





"use client";
const $1b28ccbfa41096c6$var$SkeletonInput = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, classNames: classNames, rootClassName: rootClassName, active: active, block: block, style: style, styles: styles, size: customSize, ...rest } = props;
    const { getPrefixCls: getPrefixCls } = $5E6i4.useContext((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $2fb9dcd512102fea$export$2e2bcd8739ae039)(prefixCls);
    const mergedSize = (0, $4bfc7567df2a969e$export$2e2bcd8739ae039)((ctx)=>customSize ?? ctx);
    const cls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active,
        [`${prefixCls}-block`]: block
    }, classNames?.root, className, rootClassName, hashId, cssVarCls);
    return /*#__PURE__*/ $5E6i4.createElement("div", {
        className: cls,
        style: styles?.root
    }, /*#__PURE__*/ $5E6i4.createElement((0, $15a8acd98867ae74$export$2e2bcd8739ae039), {
        prefixCls: `${prefixCls}-input`,
        className: classNames?.content,
        style: {
            ...styles?.content,
            ...style
        },
        size: mergedSize,
        ...rest
    }));
};
var $1b28ccbfa41096c6$export$2e2bcd8739ae039 = $1b28ccbfa41096c6$var$SkeletonInput;




var $5E6i4 = parcelRequire("5E6i4");

"use client";
const $2a7b82eaf742acd4$var$getWidth = (index, props)=>{
    const { width: width, rows: rows = 2 } = props;
    if (Array.isArray(width)) return width[index];
    // last paragraph
    if (rows - 1 === index) return width;
    return undefined;
};
const $2a7b82eaf742acd4$var$Paragraph = (props)=>{
    const { prefixCls: prefixCls, className: className, style: style, rows: rows = 0 } = props;
    const rowList = Array.from({
        length: rows
    }).map((_, index)=>/*#__PURE__*/ $5E6i4.createElement("li", {
            key: index,
            style: {
                width: $2a7b82eaf742acd4$var$getWidth(index, props)
            }
        }));
    return /*#__PURE__*/ $5E6i4.createElement("ul", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, className),
        style: style
    }, rowList);
};
var $2a7b82eaf742acd4$export$2e2bcd8739ae039 = $2a7b82eaf742acd4$var$Paragraph;




var $5E6i4 = parcelRequire("5E6i4");

"use client";
const $f6eaeebcd9ab8cb7$var$Title = ({ prefixCls: prefixCls, className: className, width: width, style: style })=>/*#__PURE__*/ $5E6i4.createElement("h3", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, className),
        style: {
            width: width,
            ...style
        }
    });
var $f6eaeebcd9ab8cb7$export$2e2bcd8739ae039 = $f6eaeebcd9ab8cb7$var$Title;


"use client";
function $722896780e1adae6$var$getComponentProps(prop) {
    if ((0, $addbc2fddcbb77a9$export$53b83ca8eaab0383)(prop)) return prop;
    return {};
}
function $722896780e1adae6$var$getAvatarBasicProps(hasTitle, hasParagraph) {
    if (hasTitle && !hasParagraph) // Square avatar
    return {
        size: 'large',
        shape: 'square'
    };
    return {
        size: 'large',
        shape: 'circle'
    };
}
function $722896780e1adae6$var$getTitleBasicProps(hasAvatar, hasParagraph) {
    if (!hasAvatar && hasParagraph) return {
        width: '38%'
    };
    if (hasAvatar && hasParagraph) return {
        width: '50%'
    };
    return {};
}
function $722896780e1adae6$var$getParagraphBasicProps(hasAvatar, hasTitle) {
    const basicProps = {};
    // Width
    if (!hasAvatar || !hasTitle) basicProps.width = '61%';
    // Rows
    if (!hasAvatar && hasTitle) basicProps.rows = 3;
    else basicProps.rows = 2;
    return basicProps;
}
// Tips: ctx.classNames.root < ctx.className < cpns.classNames.root < cpns.className < rootClassName
const $722896780e1adae6$var$Skeleton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, loading: loading, className: className, rootClassName: rootClassName, classNames: classNames, style: style, styles: styles, children: children, avatar: avatar = false, title: title = true, paragraph: paragraph = true, active: active, round: round } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $519f2fad435b3034$export$46f4bd6436a25a31)('skeleton');
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $2fb9dcd512102fea$export$2e2bcd8739ae039)(prefixCls);
    const mergedProps = {
        ...props,
        avatar: avatar,
        title: title,
        paragraph: paragraph
    };
    const contextStyleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $722c8632ba7bdb89$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    });
    const nativeElementRef = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useImperativeHandle(ref, ()=>({
            nativeElement: nativeElementRef.current
        }));
    if (loading || !('loading' in props)) {
        const hasAvatar = !!avatar;
        const hasTitle = !!title;
        const hasParagraph = !!paragraph;
        // Avatar
        let avatarNode;
        if (hasAvatar) {
            const avatarProps = {
                className: mergedClassNames.avatar,
                prefixCls: `${prefixCls}-avatar`,
                ...$722896780e1adae6$var$getAvatarBasicProps(hasTitle, hasParagraph),
                ...$722896780e1adae6$var$getComponentProps(avatar),
                style: mergedStyles.avatar
            };
            // We direct use SkeletonElement as avatar in skeleton internal.
            avatarNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("div", {
                className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(mergedClassNames.header, `${prefixCls}-header`),
                style: mergedStyles.header
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $15a8acd98867ae74$export$2e2bcd8739ae039), {
                ...avatarProps
            }));
        }
        let contentNode;
        if (hasTitle || hasParagraph) {
            // Title
            let $title;
            if (hasTitle) {
                const titleProps = {
                    className: mergedClassNames.title,
                    prefixCls: `${prefixCls}-title`,
                    ...$722896780e1adae6$var$getTitleBasicProps(hasAvatar, hasParagraph),
                    ...$722896780e1adae6$var$getComponentProps(title),
                    style: mergedStyles.title
                };
                $title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $f6eaeebcd9ab8cb7$export$2e2bcd8739ae039), {
                    ...titleProps
                });
            }
            // Paragraph
            let paragraphNode;
            if (hasParagraph) {
                const paragraphProps = {
                    className: mergedClassNames.paragraph,
                    prefixCls: `${prefixCls}-paragraph`,
                    ...$722896780e1adae6$var$getParagraphBasicProps(hasAvatar, hasTitle),
                    ...$722896780e1adae6$var$getComponentProps(paragraph),
                    style: mergedStyles.paragraph
                };
                paragraphNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $2a7b82eaf742acd4$export$2e2bcd8739ae039), {
                    ...paragraphProps
                });
            }
            contentNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("div", {
                className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(mergedClassNames.section, `${prefixCls}-section`),
                style: mergedStyles.section
            }, $title, paragraphNode);
        }
        const cls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, {
            [`${prefixCls}-with-avatar`]: hasAvatar,
            [`${prefixCls}-active`]: active,
            [`${prefixCls}-rtl`]: direction === 'rtl',
            [`${prefixCls}-round`]: round
        }, mergedClassNames.root, contextClassName, className, rootClassName, hashId, cssVarCls);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("div", {
            ref: nativeElementRef,
            className: cls,
            style: mergedStyles.root
        }, avatarNode, contentNode);
    }
    return children ?? null;
});
$722896780e1adae6$var$Skeleton.Button = (0, $8f91c427c0bfc434$export$2e2bcd8739ae039);
$722896780e1adae6$var$Skeleton.Avatar = (0, $db83ec587b86bb54$export$2e2bcd8739ae039);
$722896780e1adae6$var$Skeleton.Input = (0, $1b28ccbfa41096c6$export$2e2bcd8739ae039);
$722896780e1adae6$var$Skeleton.Image = (0, $4be22b6e4525fabc$export$2e2bcd8739ae039);
$722896780e1adae6$var$Skeleton.Node = (0, $e05ddd07bccbd751$export$2e2bcd8739ae039);
var $722896780e1adae6$export$2e2bcd8739ae039 = $722896780e1adae6$var$Skeleton;


"use client";
var $55f3a1bd00c2d717$export$2e2bcd8739ae039 = (0, $722896780e1adae6$export$2e2bcd8739ae039);



var $5E6i4 = parcelRequire("5E6i4");



var $dbdd0c211ae1c1d4$exports = {};
$dbdd0c211ae1c1d4$exports = import.meta.resolve("3P8Ry");


var $19cac3984d1610c6$exports = {};
$19cac3984d1610c6$exports = import.meta.resolve("8pKRD");


var $3b8f6c141d7db454$exports = {};
$3b8f6c141d7db454$exports = import.meta.resolve("89kT9");


var $d6a013cecc4472e7$exports = {};
$d6a013cecc4472e7$exports = import.meta.resolve("a4q2m");


var $d704f8cdc0975170$exports = {};
$d704f8cdc0975170$exports = import.meta.resolve("892Y5");


var $f3a1ccf96e6414f7$exports = {};
$f3a1ccf96e6414f7$exports = import.meta.resolve("cpYbp");


var $3afcabf4ad377ab9$exports = {};
$3afcabf4ad377ab9$exports = import.meta.resolve("ooaMu");


var $ca40866548909df5$exports = {};
$ca40866548909df5$exports = import.meta.resolve("lGBDZ");


var $8321ebaf0a8716cb$exports = {};
$8321ebaf0a8716cb$exports = import.meta.resolve("aHVJb");


const $e5b6a001e5093ab5$export$90f4947a2fe01997 = (occurrence)=>`occurrence-${occurrence.voiceNumber}-${occurrence.firstOffset}`;
const $e5b6a001e5093ab5$export$973cb4c224e2e27b = (first, second)=>{
    return first.firstOffset === second.firstOffset && first.lastOffset === second.lastOffset && first.voiceNumber === second.voiceNumber;
};
var $e5b6a001e5093ab5$export$fa5f90bfb4dbdbcd = /*#__PURE__*/ function(Operator) {
    Operator["AUGMENTATION"] = "augmentation";
    Operator["DEVIATION"] = "deviation";
    Operator["DIMINUTION"] = "diminution";
    Operator["MIRROR_X"] = "mirror_x";
    // Inversion and retrograde combined (paper, Section 3.2).
    Operator["MIRROR_XY"] = "mirror_xy";
    Operator["MIRROR_Y"] = "mirror_y";
    Operator["REDUCTION_TO_PITCH"] = "reduction_to_pitch";
    Operator["REDUCTION_TO_RHYTHM"] = "reduction_to_rhythm";
    Operator["TRANSPOSITION"] = "transposition";
    return Operator;
}({});
const $e5b6a001e5093ab5$export$6adedf16424adf7b = [
    "transposition",
    "mirror_x",
    "mirror_y",
    "mirror_xy",
    "diminution",
    "augmentation",
    "reduction_to_pitch",
    "reduction_to_rhythm",
    "deviation"
];
const $e5b6a001e5093ab5$export$95535b6ba8828fcd = (operator)=>{
    switch(operator){
        case "augmentation":
            return 0, (/*@__PURE__*/$parcel$interopDefault($dbdd0c211ae1c1d4$exports));
        case "deviation":
            return 0, (/*@__PURE__*/$parcel$interopDefault($19cac3984d1610c6$exports));
        case "diminution":
            return 0, (/*@__PURE__*/$parcel$interopDefault($3b8f6c141d7db454$exports));
        case "mirror_x":
            return 0, (/*@__PURE__*/$parcel$interopDefault($d6a013cecc4472e7$exports));
        case "mirror_xy":
            return 0, (/*@__PURE__*/$parcel$interopDefault($d704f8cdc0975170$exports));
        case "mirror_y":
            return 0, (/*@__PURE__*/$parcel$interopDefault($f3a1ccf96e6414f7$exports));
        case "reduction_to_pitch":
            return 0, (/*@__PURE__*/$parcel$interopDefault($3afcabf4ad377ab9$exports));
        case "reduction_to_rhythm":
            return 0, (/*@__PURE__*/$parcel$interopDefault($ca40866548909df5$exports));
        case "transposition":
            return 0, (/*@__PURE__*/$parcel$interopDefault($8321ebaf0a8716cb$exports));
    }
};
const $e5b6a001e5093ab5$export$2ffb6bdccc8a5ed0 = (operator)=>{
    switch(operator){
        case "deviation":
        case "reduction_to_pitch":
        case "reduction_to_rhythm":
            return false;
        default:
            return true;
    }
};
class $e5b6a001e5093ab5$export$6be52bf1a7712494 {
    static labels = [
        'Z',
        'Y',
        'X',
        'W',
        'V',
        'U',
        'T',
        'S',
        'R',
        'Q',
        'P',
        'O',
        'N',
        'M',
        'L',
        'K',
        'J',
        'I',
        'H',
        'G',
        'F',
        'E',
        'D',
        'C',
        'B',
        'A'
    ];
    static usedLabels = [];
    static add = (label)=>{
        const usedLabelIndex = $e5b6a001e5093ab5$export$6be52bf1a7712494.usedLabels.findIndex((usedLabel)=>usedLabel === label);
        $e5b6a001e5093ab5$export$6be52bf1a7712494.usedLabels.splice(usedLabelIndex, 1);
        $e5b6a001e5093ab5$export$6be52bf1a7712494.labels.push(label);
        $e5b6a001e5093ab5$export$6be52bf1a7712494.labels.sort().reverse();
    };
    static next = ()=>{
        if ($e5b6a001e5093ab5$export$6be52bf1a7712494.labels.length === 0) $e5b6a001e5093ab5$export$6be52bf1a7712494.reset();
        const label = $e5b6a001e5093ab5$export$6be52bf1a7712494.labels.pop();
        $e5b6a001e5093ab5$export$6be52bf1a7712494.usedLabels.splice(0, 0, label);
        return label;
    };
    /** Marks a label as used, e.g. for patterns restored from a saved analysis. */ static take = (label)=>{
        const index = $e5b6a001e5093ab5$export$6be52bf1a7712494.labels.indexOf(label);
        if (index === -1) return;
        $e5b6a001e5093ab5$export$6be52bf1a7712494.labels.splice(index, 1);
        $e5b6a001e5093ab5$export$6be52bf1a7712494.usedLabels.splice(0, 0, label);
    };
    static reset = ()=>{
        $e5b6a001e5093ab5$export$6be52bf1a7712494.labels.push(...$e5b6a001e5093ab5$export$6be52bf1a7712494.usedLabels);
        $e5b6a001e5093ab5$export$6be52bf1a7712494.usedLabels = [];
    };
}


const $e1cb3d9aadafb6a6$export$af094ef85befd6db = [
    'theme',
    'countersubject',
    'imitation',
    'sequence',
    'motif'
];
/**
 * The operator of the Suggestions panel that relates an entry to the first entry of its family (backend
 * discovery.RELATIONS); the first entry and exact repetitions are the pattern itself (no operator).
 */ const $e1cb3d9aadafb6a6$var$operatorByRelation = {
    augmentation: (0, $e5b6a001e5093ab5$export$fa5f90bfb4dbdbcd).AUGMENTATION,
    diminution: (0, $e5b6a001e5093ab5$export$fa5f90bfb4dbdbcd).DIMINUTION,
    inversion: (0, $e5b6a001e5093ab5$export$fa5f90bfb4dbdbcd).MIRROR_X,
    retrograde: (0, $e5b6a001e5093ab5$export$fa5f90bfb4dbdbcd).MIRROR_Y,
    // Not discovered (yet); mapped should the backend ever label entries so.
    retrograde_inversion: (0, $e5b6a001e5093ab5$export$fa5f90bfb4dbdbcd).MIRROR_XY,
    transposition: (0, $e5b6a001e5093ab5$export$fa5f90bfb4dbdbcd).TRANSPOSITION,
    variant: (0, $e5b6a001e5093ab5$export$fa5f90bfb4dbdbcd).DEVIATION
};
const $e1cb3d9aadafb6a6$export$a7dac0142870f4ff = (relation)=>$e1cb3d9aadafb6a6$var$operatorByRelation[relation];
const $e1cb3d9aadafb6a6$export$65a30acd6eb445c4 = Object.values($e1cb3d9aadafb6a6$var$operatorByRelation).filter((operator)=>operator !== (0, $e5b6a001e5093ab5$export$fa5f90bfb4dbdbcd).MIRROR_XY);
const $e1cb3d9aadafb6a6$export$9417d65afd591d85 = (entry, hiddenOperators)=>{
    const operator = $e1cb3d9aadafb6a6$export$a7dac0142870f4ff(entry.relation);
    return operator === undefined || !hiddenOperators.includes(operator);
};
const $e1cb3d9aadafb6a6$export$143875a47b2f2313 = (family, id, color, description, label = family.label, /** Entries related by these operators are not highlighted (Suggestions panel). */ hiddenOperators = [])=>({
        color: color,
        connectedToByOccurrences: [],
        connectedToByOperator: [],
        description: description,
        // Its occurrences are complete already: no operator search is started for it.
        hasBeenQueried: true,
        id: id,
        isLocked: false,
        isUserDefined: false,
        isVisible: true,
        label: label,
        length: family.length,
        occurrences: family.occurrences.filter((entry)=>$e1cb3d9aadafb6a6$export$9417d65afd591d85(entry, hiddenOperators)).map(({ firstOffset: firstOffset, lastOffset: lastOffset, voiceNumber: voiceNumber })=>({
                firstOffset: firstOffset,
                lastOffset: lastOffset,
                voiceNumber: voiceNumber
            })),
        uniqueOccurrencesCount: family.occurrences.filter((entry)=>$e1cb3d9aadafb6a6$export$9417d65afd591d85(entry, hiddenOperators)).length,
        voiceNumber: family.prototype.voiceNumber
    });
/**
 * Colours per role as in the manual analysis of Figure 2: the theme yellow, the first and second countersubject light
 * blue and pink, imitations (canon) orange, sequences red. A further family of a role takes a shade of its role's
 * colour, so similar roles look similar; motifs take teal and indigo, then grey (palette.ts).
 */ const $e1cb3d9aadafb6a6$var$roleColors = {
    theme: [
        (0, $49db07fe7d01393c$export$1537643e85439bf5).subject
    ],
    countersubject: [
        (0, $49db07fe7d01393c$export$1537643e85439bf5).firstCountersubject,
        (0, $49db07fe7d01393c$export$1537643e85439bf5).secondCountersubject
    ],
    imitation: [
        (0, $49db07fe7d01393c$export$1537643e85439bf5).canon
    ],
    sequence: [
        (0, $49db07fe7d01393c$export$1537643e85439bf5).sequence
    ],
    motif: [
        (0, $49db07fe7d01393c$export$1537643e85439bf5).firstMotif,
        (0, $49db07fe7d01393c$export$1537643e85439bf5).secondMotif
    ]
};
const $e1cb3d9aadafb6a6$var$rolePrefix = {
    theme: 'T',
    countersubject: 'CS',
    imitation: 'I',
    sequence: 'S',
    motif: 'M'
};
const $e1cb3d9aadafb6a6$export$afc5c1f6cc18fe38 = (families)=>[
        ...families
    ].sort((first, second)=>$e1cb3d9aadafb6a6$export$af094ef85befd6db.indexOf(first.role) - $e1cb3d9aadafb6a6$export$af094ef85befd6db.indexOf(second.role) || first.prototype.firstOffset - second.prototype.firstOffset);
const $e1cb3d9aadafb6a6$export$6afe0ab465872e57 = (families)=>{
    const counts = {};
    const totals = {};
    families.forEach((family)=>totals[family.role] = (totals[family.role] ?? 0) + 1);
    return Object.fromEntries($e1cb3d9aadafb6a6$export$afc5c1f6cc18fe38(families).map((family)=>{
        counts[family.role] = (counts[family.role] ?? 0) + 1;
        const needsNumber = family.role !== 'theme' || (totals.theme ?? 0) > 1;
        return [
            family.label,
            `${$e1cb3d9aadafb6a6$var$rolePrefix[family.role]}${needsNumber ? counts[family.role] : ''}`
        ];
    }));
};
const $e1cb3d9aadafb6a6$export$9acc1e2b46fd8bf0 = (families)=>{
    const counts = {};
    return Object.fromEntries($e1cb3d9aadafb6a6$export$afc5c1f6cc18fe38(families).map((family)=>{
        const index = counts[family.role] ?? 0;
        counts[family.role] = index + 1;
        const colors = $e1cb3d9aadafb6a6$var$roleColors[family.role];
        if (index < colors.length) return [
            family.label,
            colors[index]
        ];
        // Motifs beyond the coloured ones are grey; further families of the other roles shade their role's colour.
        return [
            family.label,
            family.role === 'motif' ? (0, $49db07fe7d01393c$export$88d57a8d3a22066c) : (0, $49db07fe7d01393c$export$3e32adda0df4ef5d)(colors[colors.length - 1], index - colors.length + 1)
        ];
    }));
};
const $e1cb3d9aadafb6a6$export$2744a1649c52e395 = (family)=>`family-${family.label}`;
const $e1cb3d9aadafb6a6$var$directed = [
    'chromatic',
    'scale',
    'tirata',
    'arpeggio',
    'neighbour',
    'leap',
    'sequence'
];
const $e1cb3d9aadafb6a6$export$4fc16528823cd7fe = (family, labels, translate)=>{
    const figure = family.figure;
    if (!figure || figure.key === 'sequence' && !figure.direction) return translate(`discovery.roles.${family.role}`);
    const variant = figure.key === 'scale' && figure.fast ? 'tirata' : figure.key;
    const key = variant === 'contour' ? `contour_${figure.shape ?? 'level'}` : figure.direction && $e1cb3d9aadafb6a6$var$directed.includes(variant) ? `${variant}_${figure.direction}` : variant;
    let name = translate(`discovery.figures.${key}`, {
        interval: figure.interval ? translate(`discovery.${variant === 'sequence' ? 'sequenceIntervals' : 'leapIntervals'}.${figure.interval}`) : '',
        source: figure.source ? labels[figure.source] ?? figure.source : ''
    });
    if (figure.inverted) name = translate('discovery.figures.inverted', {
        name: name
    });
    if (figure.exclamatio) name = translate('discovery.figures.exclamatio', {
        name: name
    });
    if (figure.rhythm) name = translate(`discovery.figures.rhythm_${figure.rhythm}`, {
        name: name
    });
    return name;
};
const $e1cb3d9aadafb6a6$export$a4c5785abc7a1dc3 = (family, labels, translate, names = {})=>names[family.label]?.trim() || $e1cb3d9aadafb6a6$export$4fc16528823cd7fe(family, labels, translate);
const $e1cb3d9aadafb6a6$var$overlaps = (first, second)=>first.firstOffset <= second.lastOffset && second.firstOffset <= first.lastOffset;
const $e1cb3d9aadafb6a6$export$3fe853e13e85c15c = (families, shownIDs)=>{
    const shown = families.filter((family)=>shownIDs.includes($e1cb3d9aadafb6a6$export$2744a1649c52e395(family)));
    const connections = new Map(shown.map((family)=>[
            $e1cb3d9aadafb6a6$export$2744a1649c52e395(family),
            []
        ]));
    shown.forEach((family, index)=>shown.slice(index + 1).forEach((other)=>{
            const accompanies = family.accompanies === other.label || other.accompanies === family.label;
            const shared = family.occurrences.filter((occurrence)=>other.occurrences.some((candidate)=>$e1cb3d9aadafb6a6$var$overlaps(occurrence, candidate) && (accompanies || candidate.voiceNumber === occurrence.voiceNumber)));
            if (shared.length === 0) return;
            const occurrences = shared.map(({ firstOffset: firstOffset, lastOffset: lastOffset, voiceNumber: voiceNumber })=>({
                    firstOffset: firstOffset,
                    lastOffset: lastOffset,
                    voiceNumber: voiceNumber
                }));
            connections.get($e1cb3d9aadafb6a6$export$2744a1649c52e395(family)).push({
                id: $e1cb3d9aadafb6a6$export$2744a1649c52e395(other),
                occurrences: occurrences
            });
            connections.get($e1cb3d9aadafb6a6$export$2744a1649c52e395(other)).push({
                id: $e1cb3d9aadafb6a6$export$2744a1649c52e395(family),
                occurrences: occurrences
            });
        }));
    return connections;
};
const $e1cb3d9aadafb6a6$export$f4d0e6dd0d97d17a = (families, patterns)=>{
    const own = patterns.filter((pattern)=>pattern.isUserDefined);
    const overlaps = (entry, occurrence)=>{
        if (entry.voiceNumber !== occurrence.voiceNumber) return false;
        const shared = Math.min(entry.lastOffset, occurrence.lastOffset) - Math.max(entry.firstOffset, occurrence.firstOffset);
        const shorter = Math.min(entry.lastOffset - entry.firstOffset, occurrence.lastOffset - occurrence.firstOffset);
        return shared >= 0 && shared >= shorter / 2;
    };
    return Object.fromEntries(families.map((family)=>[
            family.label,
            own.filter((pattern)=>pattern.occurrences.some((occurrence)=>family.occurrences.some((entry)=>overlaps(entry, occurrence)))).map((pattern)=>pattern.label)
        ]));
};



/**
 * The automatically discovered pattern families of the sheet (backend/api/analysis/discovery.py): the analysis that
 * the paper's users had to do by hand. Each family can be shown in the sheet, played and inspected.
 */ const $824a58fb00160520$var$Contour = ({ contour: contour, rhythm: rhythm, color: color })=>{
    const width = 72;
    const height = 24;
    if (contour.length < 2) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("svg", {
        "aria-hidden": true,
        height: height,
        width: width
    });
    const low = Math.min(...contour);
    const high = Math.max(...contour);
    const total = rhythm.reduce((sum, duration)=>sum + duration, 0) || contour.length;
    let onset = 0;
    const points = contour.map((step, index)=>{
        const point = `${2 + onset / total * (width - 4)},${height - 3 - (step - low) / Math.max(high - low, 1) * (height - 6)}`;
        onset += rhythm[index] ?? 1;
        return point;
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("svg", {
        "aria-hidden": true,
        className: "shrink-0",
        height: height,
        width: width,
        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("polyline", {
            fill: "none",
            points: points.join(' '),
            // Light highlighter colours (the theme's yellow) would vanish as a thin line on white.
            stroke: (0, $49db07fe7d01393c$export$ec9fff20a24a368)(color),
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2
        })
    });
};
const $824a58fb00160520$export$7ad4c67c1e638f8e = 'discovery-panel';
const $824a58fb00160520$var$roleKey = (role)=>`discovery.roles.${role}`;
const $824a58fb00160520$var$DiscoveryPanel = ({ colors: colors, discovery: discovery, error: error, isLoading: isLoading, labels: labels, names: names, onPlay: onPlay, onRename: onRename, onSelect: onSelect, onToggle: onToggle, onToggleAll: onToggleAll, ownPatterns: ownPatterns, playingLabel: playingLabel, selectedLabel: selectedLabel, visibleLabels: visibleLabels })=>{
    const { t: translate } = (0, $705ab703c44be5bc$export$9fc83ad70ead8663)();
    // The family whose name is being edited, and whether Escape cancelled the edit (the field then loses the focus).
    const [editingLabel, setEditingLabel] = (0, $5E6i4.useState)();
    const cancelled = (0, $5E6i4.useRef)(false);
    if (isLoading) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $55f3a1bd00c2d717$export$2e2bcd8739ae039), {
        active: true,
        paragraph: {
            rows: 6
        },
        title: false
    });
    if (error) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $3a3a0d3a83db59d1$export$2e2bcd8739ae039), {
        description: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("span", {
            className: "text-slate-600",
            children: translate('discovery.failed', {
                error: error
            })
        })
    });
    if (!discovery || discovery.families.length === 0) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $3a3a0d3a83db59d1$export$2e2bcd8739ae039), {
        description: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("span", {
            className: "text-slate-600",
            children: translate('discovery.none')
        })
    });
    const families = (0, $e1cb3d9aadafb6a6$export$afc5c1f6cc18fe38)(discovery.families);
    const share = Math.round(100 * discovery.coverage.notes / Math.max(discovery.coverage.total, 1));
    const allVisible = families.every((family)=>visibleLabels.includes(family.label));
    // Once the user has patterns of their own: the first families none of them touches, as a hint where to look next.
    const hasOwnPatterns = Object.values(ownPatterns).some((own)=>own.length > 0);
    const notYetAnalysed = hasOwnPatterns ? families.filter((family)=>(ownPatterns[family.label] ?? []).length === 0).slice(0, 4) : [];
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("section", {
        "aria-label": translate('discovery.title'),
        className: "flex min-h-0 flex-col gap-2",
        children: [
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
                className: "flex items-center justify-between gap-2",
                children: [
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("p", {
                        className: "m-0 text-xs text-slate-600",
                        id: "discovery-summary",
                        children: translate('discovery.summary', {
                            count: families.length,
                            share: share
                        })
                    }),
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $67d71c16fdfc3a0e$export$2e2bcd8739ae039), {
                        onClick: ()=>onToggleAll(!allVisible),
                        size: "small",
                        children: allVisible ? translate('discovery.hideAll') : translate('discovery.showAll')
                    })
                ]
            }),
            notYetAnalysed.length > 0 && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("p", {
                className: "m-0 text-xs text-slate-600",
                id: "discovery-next",
                children: translate('discovery.next', {
                    labels: notYetAnalysed.map((family)=>labels[family.label] ?? family.label).join(', ')
                })
            }),
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("ul", {
                "aria-describedby": "discovery-summary",
                className: "m-0 flex min-h-0 flex-col gap-1 overflow-y-auto p-0",
                style: {
                    listStyle: 'none'
                },
                children: families.map((family)=>{
                    const isVisible = visibleLabels.includes(family.label);
                    const isSelected = selectedLabel === family.label;
                    const voices = Object.keys(family.distributions.byVoice).length;
                    const color = colors[family.label] ?? (0, $49db07fe7d01393c$export$88d57a8d3a22066c);
                    const name = (0, $e1cb3d9aadafb6a6$export$a4c5785abc7a1dc3)(family, labels, translate, names);
                    const role = translate($824a58fb00160520$var$roleKey(family.role));
                    const finishEditing = (value)=>{
                        if (!cancelled.current) onRename(family, value);
                        cancelled.current = false;
                        setEditingLabel(undefined);
                    };
                    const badge = /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("span", {
                        className: "flex h-6 min-w-6 shrink-0 items-center justify-center rounded-full px-1 text-xs font-bold",
                        style: {
                            background: color,
                            color: (0, $a9ceb34ac62682a2$export$2e2bcd8739ae039).mostReadable(color, [
                                '#ffffff',
                                '#0b0b0b'
                            ]).toHexString()
                        },
                        children: labels[family.label]
                    });
                    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
                            className: `flex items-center gap-2 rounded-md border border-solid px-2 py-1.5 ${isSelected ? 'border-blue-500 bg-blue-50' : 'border-slate-200 hover:border-slate-400'}`,
                            children: [
                                editingLabel === family.label ? /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
                                    className: "flex min-w-0 flex-1 items-center gap-2",
                                    children: [
                                        badge,
                                        /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $8951186c565e4005$export$2e2bcd8739ae039), {
                                            "aria-label": translate('discovery.renameField', {
                                                label: labels[family.label]
                                            }),
                                            autoFocus: true,
                                            defaultValue: name,
                                            onBlur: (event)=>finishEditing(event.currentTarget.value),
                                            onFocus: (event)=>event.currentTarget.select(),
                                            onKeyDown: (event)=>{
                                                if (event.key === 'Escape') {
                                                    cancelled.current = true;
                                                    event.currentTarget.blur();
                                                }
                                            },
                                            onPressEnter: (event)=>event.currentTarget.blur(),
                                            placeholder: translate('discovery.renamePlaceholder'),
                                            size: "small"
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("button", {
                                    "aria-pressed": isSelected,
                                    className: "flex min-w-0 flex-1 cursor-pointer items-center gap-2 text-left",
                                    onClick: ()=>onSelect(family),
                                    style: {
                                        background: 'transparent',
                                        border: 0,
                                        color: 'inherit',
                                        font: 'inherit',
                                        padding: 0
                                    },
                                    type: "button",
                                    children: [
                                        badge,
                                        /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("span", {
                                            className: "min-w-0 flex-1",
                                            children: [
                                                /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("span", {
                                                    className: "flex items-center gap-1.5 text-sm font-semibold text-slate-900",
                                                    children: [
                                                        name,
                                                        family.accompanies && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("span", {
                                                            className: "font-normal text-slate-600",
                                                            children: translate('discovery.accompanies', {
                                                                label: labels[family.accompanies] ?? family.accompanies
                                                            })
                                                        }),
                                                        (ownPatterns[family.label] ?? []).length > 0 && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("span", {
                                                            className: "rounded bg-slate-100 px-1.5 text-xs font-normal text-slate-700",
                                                            title: translate('discovery.yoursTooltip'),
                                                            children: translate('discovery.yours', {
                                                                count: ownPatterns[family.label].length,
                                                                labels: ownPatterns[family.label].join(', ')
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("span", {
                                                    className: "block text-xs text-slate-600",
                                                    children: [
                                                        // The role, where the name does not say it.
                                                        ...name === role ? [] : [
                                                            role
                                                        ],
                                                        translate('family.entries', {
                                                            count: family.occurrences.length
                                                        }),
                                                        translate('discovery.notes', {
                                                            count: family.length
                                                        }),
                                                        translate('family.voices', {
                                                            count: voices
                                                        })
                                                    ].join(" \xb7 ")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($824a58fb00160520$var$Contour, {
                                            color: color,
                                            contour: family.contour,
                                            rhythm: family.rhythm
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $1bb718ecb5669b36$export$2e2bcd8739ae039), {
                                    title: translate('discovery.rename'),
                                    children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $67d71c16fdfc3a0e$export$2e2bcd8739ae039), {
                                        "aria-label": translate('discovery.renameField', {
                                            label: labels[family.label]
                                        }),
                                        icon: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $a5a7c3d0277b871b$export$2e2bcd8739ae039), {}),
                                        onClick: (event)=>{
                                            event.stopPropagation();
                                            cancelled.current = false;
                                            setEditingLabel(family.label);
                                        },
                                        shape: "circle",
                                        size: "small",
                                        type: "text"
                                    })
                                }),
                                /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $1bb718ecb5669b36$export$2e2bcd8739ae039), {
                                    title: translate(playingLabel === family.label ? 'discovery.stop' : 'discovery.play'),
                                    children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $67d71c16fdfc3a0e$export$2e2bcd8739ae039), {
                                        "aria-label": translate(playingLabel === family.label ? 'discovery.stop' : 'discovery.play'),
                                        icon: playingLabel === family.label ? /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $c28cb742fc860797$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $39b91140dd0153e5$export$2e2bcd8739ae039), {}),
                                        onClick: (event)=>{
                                            event.stopPropagation();
                                            onPlay(family);
                                        },
                                        shape: "circle",
                                        size: "small"
                                    })
                                }),
                                /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $1bb718ecb5669b36$export$2e2bcd8739ae039), {
                                    title: translate(isVisible ? 'discovery.hide' : 'discovery.show'),
                                    children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $67d71c16fdfc3a0e$export$2e2bcd8739ae039), {
                                        "aria-label": translate(isVisible ? 'discovery.hide' : 'discovery.show'),
                                        "aria-pressed": isVisible,
                                        icon: isVisible ? /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $21b283b110732d66$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $4068c0b99705ad33$export$2e2bcd8739ae039), {}),
                                        onClick: (event)=>{
                                            event.stopPropagation();
                                            onToggle(family);
                                        },
                                        shape: "circle",
                                        size: "small",
                                        type: isVisible ? 'primary' : 'default'
                                    })
                                })
                            ]
                        })
                    }, family.label);
                })
            }),
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("p", {
                className: "m-0 text-xs text-slate-600",
                children: [
                    translate('audio.credit'),
                    ' ',
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("a", {
                        href: "http://creativecommons.org/licenses/by/3.0/",
                        rel: "noreferrer",
                        target: "_blank",
                        children: "CC BY 3.0"
                    })
                ]
            })
        ]
    });
};
var $824a58fb00160520$export$2e2bcd8739ae039 = $824a58fb00160520$var$DiscoveryPanel;




var $5E6i4 = parcelRequire("5E6i4");















const $fbac0cb20ae80c2e$var$genAlertTypeStyle = (bgColor, iconColor, alertCls)=>({
        background: bgColor,
        [`${alertCls}-icon`]: {
            color: iconColor
        }
    });
const $fbac0cb20ae80c2e$export$5ca74f7be820a85 = (token)=>{
    const { componentCls: componentCls, motionDurationSlow: duration, marginXS: marginXS, marginSM: marginSM, fontSize: fontSize, fontSizeLG: fontSizeLG, lineHeight: lineHeight, motionEaseInOutCirc: motionEaseInOutCirc, borderRadius: borderRadius, withDescriptionIconSize: withDescriptionIconSize, colorText: colorText, colorTextHeading: colorTextHeading, withDescriptionPadding: withDescriptionPadding, defaultPadding: defaultPadding, lineWidth: lineWidth, lineType: lineType, colorSuccessBorder: colorSuccessBorder, colorWarningBorder: colorWarningBorder, colorErrorBorder: colorErrorBorder, colorInfoBorder: colorInfoBorder } = token;
    return {
        [componentCls]: {
            ...(0, $cd5a520fee8002b4$export$23997c3e44cc1c59)(token),
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            padding: defaultPadding,
            wordWrap: 'break-word',
            borderRadius: borderRadius,
            borderWidth: (0, $56bae8a99c3cba6e$export$523c0b569236b342)(lineWidth),
            borderStyle: lineType,
            [`&${componentCls}-success`]: {
                borderColor: colorSuccessBorder
            },
            [`&${componentCls}-info`]: {
                borderColor: colorInfoBorder
            },
            [`&${componentCls}-warning`]: {
                borderColor: colorWarningBorder
            },
            [`&${componentCls}-error`]: {
                borderColor: colorErrorBorder
            },
            [`&${componentCls}-filled`]: {
                borderColor: 'transparent'
            },
            [`&${componentCls}-rtl`]: {
                direction: 'rtl'
            },
            [`${componentCls}-section`]: {
                flex: 1,
                minWidth: 0
            },
            [`${componentCls}-icon`]: {
                marginInlineEnd: marginXS,
                lineHeight: 0
            },
            '&-description': {
                display: 'none',
                fontSize: fontSize,
                lineHeight: lineHeight
            },
            '&-title': {
                color: colorTextHeading
            },
            [`&${componentCls}-motion-leave`]: {
                overflow: 'hidden',
                opacity: 1,
                transition: [
                    `max-height`,
                    `opacity`,
                    `padding-top`,
                    `padding-bottom`,
                    `margin-bottom`
                ].map((prop)=>`${prop} ${duration} ${motionEaseInOutCirc}`).join(', ')
            },
            [`&${componentCls}-motion-leave-active`]: {
                maxHeight: 0,
                marginBottom: '0 !important',
                paddingTop: 0,
                paddingBottom: 0,
                opacity: 0
            },
            [`&${componentCls}-with-description`]: {
                alignItems: 'flex-start',
                padding: withDescriptionPadding,
                [`${componentCls}-icon`]: {
                    marginInlineEnd: marginSM,
                    fontSize: withDescriptionIconSize,
                    lineHeight: 0
                },
                [`${componentCls}-title`]: {
                    display: 'block',
                    marginBottom: marginXS,
                    color: colorTextHeading,
                    fontSize: fontSizeLG
                },
                [`${componentCls}-description`]: {
                    display: 'block',
                    color: colorText
                }
            },
            [`&${componentCls}-banner`]: {
                marginBottom: 0,
                border: '0 !important',
                borderRadius: 0
            }
        }
    };
};
const $fbac0cb20ae80c2e$export$289eb6d482898146 = (token)=>{
    const { componentCls: componentCls, colorSuccess: colorSuccess, colorSuccessBg: colorSuccessBg, colorWarning: colorWarning, colorWarningBg: colorWarningBg, colorError: colorError, colorErrorBg: colorErrorBg, colorInfo: colorInfo, colorInfoBg: colorInfoBg } = token;
    return {
        [componentCls]: {
            '&-success': $fbac0cb20ae80c2e$var$genAlertTypeStyle(colorSuccessBg, colorSuccess, componentCls),
            '&-info': $fbac0cb20ae80c2e$var$genAlertTypeStyle(colorInfoBg, colorInfo, componentCls),
            '&-warning': $fbac0cb20ae80c2e$var$genAlertTypeStyle(colorWarningBg, colorWarning, componentCls),
            '&-error': {
                ...$fbac0cb20ae80c2e$var$genAlertTypeStyle(colorErrorBg, colorError, componentCls),
                [`${componentCls}-description > pre`]: {
                    margin: 0,
                    padding: 0
                }
            }
        }
    };
};
const $fbac0cb20ae80c2e$export$5ecc051c674d512 = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, motionDurationMid: motionDurationMid, marginXS: marginXS, fontSizeIcon: fontSizeIcon, colorIcon: colorIcon, colorIconHover: colorIconHover, colorTextDisabled: colorTextDisabled } = token;
    return {
        [componentCls]: {
            [`${componentCls}-actions`]: {
                marginInlineStart: marginXS
            },
            [`${componentCls}-close-icon`]: {
                marginInlineStart: marginXS,
                padding: 0,
                overflow: 'hidden',
                fontSize: fontSizeIcon,
                lineHeight: (0, $56bae8a99c3cba6e$export$523c0b569236b342)(fontSizeIcon),
                backgroundColor: 'transparent',
                border: 'none',
                cursor: 'pointer',
                ...(0, $cd5a520fee8002b4$export$a44db842bcb28231)(token),
                [`${iconCls}-close`]: {
                    color: colorIcon,
                    transition: `color ${motionDurationMid}`,
                    '&:hover': {
                        color: colorIconHover
                    }
                },
                '&:disabled': {
                    cursor: 'not-allowed',
                    color: colorTextDisabled,
                    [`${iconCls}-close`]: {
                        color: 'inherit',
                        pointerEvents: 'none'
                    }
                }
            }
        }
    };
};
const $fbac0cb20ae80c2e$export$9ca1be8807fe0675 = (token)=>{
    const paddingHorizontal = 12; // Fixed value here.
    return {
        borderRadius: token.borderRadiusLG,
        withDescriptionIconSize: token.fontSizeHeading3,
        defaultPadding: `${token.paddingContentVerticalSM}px ${paddingHorizontal}px`,
        withDescriptionPadding: `${token.paddingMD}px ${token.paddingContentHorizontalLG}px`
    };
};
var $fbac0cb20ae80c2e$export$2e2bcd8739ae039 = (0, $761caadb5301aee1$export$51ec95de45185b42)('Alert', (token)=>[
        $fbac0cb20ae80c2e$export$5ca74f7be820a85(token),
        $fbac0cb20ae80c2e$export$289eb6d482898146(token),
        $fbac0cb20ae80c2e$export$5ecc051c674d512(token)
    ], $fbac0cb20ae80c2e$export$9ca1be8807fe0675);


"use client";
const $f4cae2aa4e44b256$var$IconNode = (props)=>{
    const { icon: icon, type: type, className: className, style: style, successIcon: successIcon, infoIcon: infoIcon, warningIcon: warningIcon, errorIcon: errorIcon } = props;
    const iconMapFilled = {
        success: successIcon ?? /*#__PURE__*/ $5E6i4.createElement((0, $b89ac8aaffc055f4$export$2e2bcd8739ae039), null),
        info: infoIcon ?? /*#__PURE__*/ $5E6i4.createElement((0, $dc185fbb803a7cae$export$2e2bcd8739ae039), null),
        error: errorIcon ?? /*#__PURE__*/ $5E6i4.createElement((0, $18493f15518cd625$export$2e2bcd8739ae039), null),
        warning: warningIcon ?? /*#__PURE__*/ $5E6i4.createElement((0, $02cacf707e93d6b4$export$2e2bcd8739ae039), null)
    };
    return /*#__PURE__*/ $5E6i4.createElement("span", {
        className: className,
        style: style
    }, icon ?? iconMapFilled[type]);
};
const $f4cae2aa4e44b256$var$CloseIconNode = (props)=>{
    const { isClosable: isClosable, disabled: disabled, prefixCls: prefixCls, closeIcon: closeIcon, handleClose: handleClose, ariaProps: ariaProps, className: className, style: style } = props;
    const mergedCloseIcon = closeIcon === true || closeIcon === undefined ? /*#__PURE__*/ $5E6i4.createElement((0, $80d24bc031ad50e3$export$2e2bcd8739ae039), null) : closeIcon;
    return isClosable ? /*#__PURE__*/ $5E6i4.createElement("button", {
        type: "button",
        disabled: disabled,
        onClick: handleClose,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-close-icon`, className),
        style: style,
        ...ariaProps
    }, mergedCloseIcon) : null;
};
const $f4cae2aa4e44b256$var$Alert = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { description: description, prefixCls: customizePrefixCls, message: message, title: title, banner: banner, className: className, rootClassName: rootClassName, style: style, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onClick: onClick, afterClose: afterClose, showIcon: showIcon, closable: closable, closeText: closeText, closeIcon: closeIcon, action: action, id: id, styles: styles, classNames: classNames, ...otherProps } = props;
    const mergedTitle = title ?? message;
    const [closed, setClosed] = $5E6i4.useState(false);
    var deprecatedName, newName;
    const internalRef = $5E6i4.useRef(null);
    $5E6i4.useImperativeHandle(ref, ()=>({
            nativeElement: internalRef.current
        }));
    const { getPrefixCls: getPrefixCls, direction: direction, variant: contextVariant, closable: contextClosable, closeIcon: contextCloseIcon, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles, successIcon: successIcon, infoIcon: infoIcon, warningIcon: warningIcon, errorIcon: errorIcon } = (0, $519f2fad435b3034$export$46f4bd6436a25a31)('alert');
    const prefixCls = getPrefixCls('alert', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $fbac0cb20ae80c2e$export$2e2bcd8739ae039)(prefixCls);
    const { onClose: closableOnClose, afterClose: closableAfterClose, disabled: closeBtnIsDisabled } = (0, $addbc2fddcbb77a9$export$53b83ca8eaab0383)(closable) ? closable : {};
    const handleClose = (e)=>{
        setClosed(true);
        (closableOnClose ?? props.onClose)?.(e);
    };
    const type = $5E6i4.useMemo(()=>{
        if (props.type !== undefined) return props.type;
        // banner mode defaults to 'warning'
        return banner ? 'warning' : 'info';
    }, [
        props.type,
        banner
    ]);
    const mergedVariant = props.variant ?? contextVariant ?? 'outlined';
    // closeable when closeText or closeIcon is assigned
    const isClosable = $5E6i4.useMemo(()=>{
        if ((0, $addbc2fddcbb77a9$export$53b83ca8eaab0383)(closable)) return true;
        if (closeText) return true;
        if (typeof closable === 'boolean') return closable;
        // should be true when closeIcon is 0 or ''
        if (closeIcon !== false && (0, $b63de2b9864a5d1a$export$826fff653a329e83)(closeIcon)) return true;
        return !!contextClosable;
    }, [
        closeText,
        closeIcon,
        closable,
        contextClosable
    ]);
    // banner mode defaults to Icon
    const isShowIcon = banner && showIcon === undefined ? true : showIcon;
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        prefixCls: prefixCls,
        variant: mergedVariant,
        type: type,
        showIcon: isShowIcon,
        closable: isClosable
    };
    const contextStyleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $722c8632ba7bdb89$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    });
    const alertCls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-${type}`, `${prefixCls}-${mergedVariant}`, {
        [`${prefixCls}-with-description`]: (0, $b63de2b9864a5d1a$export$72280d5f896dac9a)(description),
        [`${prefixCls}-no-icon`]: !isShowIcon,
        [`${prefixCls}-banner`]: !!banner,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, contextClassName, className, rootClassName, mergedClassNames.root, cssVarCls, hashId);
    const restProps = (0, $78cde6532419ffca$export$2e2bcd8739ae039)(otherProps, {
        aria: true,
        data: true
    });
    const mergedCloseIcon = $5E6i4.useMemo(()=>{
        if ((0, $addbc2fddcbb77a9$export$53b83ca8eaab0383)(closable) && closable.closeIcon) return closable.closeIcon;
        if (closeText) return closeText;
        if (closeIcon !== undefined) return closeIcon;
        if ((0, $addbc2fddcbb77a9$export$53b83ca8eaab0383)(contextClosable) && contextClosable.closeIcon) return contextClosable.closeIcon;
        return contextCloseIcon;
    }, [
        closeIcon,
        closable,
        contextClosable,
        closeText,
        contextCloseIcon
    ]);
    const mergedAriaProps = $5E6i4.useMemo(()=>{
        const merged = closable ?? contextClosable;
        if ((0, $addbc2fddcbb77a9$export$53b83ca8eaab0383)(merged)) return (0, $78cde6532419ffca$export$2e2bcd8739ae039)(merged, {
            data: true,
            aria: true
        });
        return {};
    }, [
        closable,
        contextClosable
    ]);
    return /*#__PURE__*/ $5E6i4.createElement((0, $5371a8954d0d2416$export$2e2bcd8739ae039), {
        visible: !closed,
        motionName: `${prefixCls}-motion`,
        motionAppear: false,
        motionEnter: false,
        onLeaveStart: (node)=>({
                maxHeight: node.offsetHeight
            }),
        onLeaveEnd: closableAfterClose ?? afterClose
    }, ({ className: motionClassName, style: motionStyle }, setRef)=>/*#__PURE__*/ $5E6i4.createElement("div", {
            id: id,
            ref: (0, $92c8c75386168ffc$export$ab452c34e8e05029)(internalRef, setRef),
            "data-show": !closed,
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(alertCls, motionClassName),
            style: {
                ...mergedStyles.root,
                ...motionStyle
            },
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onClick: onClick,
            role: "alert",
            ...restProps
        }, isShowIcon ? /*#__PURE__*/ $5E6i4.createElement($f4cae2aa4e44b256$var$IconNode, {
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-icon`, mergedClassNames.icon),
            style: mergedStyles.icon,
            icon: props.icon,
            type: type,
            successIcon: successIcon,
            infoIcon: infoIcon,
            warningIcon: warningIcon,
            errorIcon: errorIcon
        }) : null, /*#__PURE__*/ $5E6i4.createElement("div", {
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-section`, mergedClassNames.section),
            style: mergedStyles.section
        }, (0, $b63de2b9864a5d1a$export$72280d5f896dac9a)(mergedTitle) ? /*#__PURE__*/ $5E6i4.createElement("div", {
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-title`, mergedClassNames.title),
            style: mergedStyles.title
        }, mergedTitle) : null, (0, $b63de2b9864a5d1a$export$72280d5f896dac9a)(description) ? /*#__PURE__*/ $5E6i4.createElement("div", {
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-description`, mergedClassNames.description),
            style: mergedStyles.description
        }, description) : null), (0, $b63de2b9864a5d1a$export$72280d5f896dac9a)(action) ? /*#__PURE__*/ $5E6i4.createElement("div", {
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-actions`, mergedClassNames.actions),
            style: mergedStyles.actions
        }, action) : null, /*#__PURE__*/ $5E6i4.createElement($f4cae2aa4e44b256$var$CloseIconNode, {
            className: mergedClassNames.close,
            style: mergedStyles.close,
            isClosable: isClosable,
            disabled: closeBtnIsDisabled,
            prefixCls: prefixCls,
            closeIcon: mergedCloseIcon,
            handleClose: handleClose,
            ariaProps: mergedAriaProps
        })));
});
var $f4cae2aa4e44b256$export$2e2bcd8739ae039 = $f4cae2aa4e44b256$var$Alert;







function $27966f774cecb5b6$export$2e2bcd8739ae039(t, o, e) {
    return o = (0, $58ea1d70f13cdd7b$export$2e2bcd8739ae039)(o), (0, $0d7092e07e4d94a7$export$2e2bcd8739ae039)(t, (0, $61187a84a3929b6d$export$2e2bcd8739ae039)() ? Reflect.construct(o, e || [], (0, $58ea1d70f13cdd7b$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}




var $5E6i4 = parcelRequire("5E6i4");


"use client";
let $b77e6ab155fb7035$var$ErrorBoundary = /*#__PURE__*/ function(_React$PureComponent) {
    function ErrorBoundary() {
        var _this;
        (0, $dbd531af97203a2f$export$2e2bcd8739ae039)(this, ErrorBoundary);
        _this = (0, $27966f774cecb5b6$export$2e2bcd8739ae039)(this, ErrorBoundary, arguments);
        _this.state = {
            error: undefined,
            info: {}
        };
        return _this;
    }
    (0, $a2290346d2002902$export$2e2bcd8739ae039)(ErrorBoundary, _React$PureComponent);
    return (0, $bffd9344780d0102$export$2e2bcd8739ae039)(ErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, info) {
                this.setState({
                    error: error,
                    info: info
                });
            }
        },
        {
            key: "render",
            value: function render() {
                const { message: message, title: title, description: description, id: id, children: children } = this.props;
                const { error: error, info: info } = this.state;
                const mergedTitle = title ?? message;
                const componentStack = info?.componentStack || null;
                const errorMessage = (0, $b63de2b9864a5d1a$export$826fff653a329e83)(mergedTitle) ? mergedTitle : error?.toString();
                const errorDescription = (0, $b63de2b9864a5d1a$export$826fff653a329e83)(description) ? description : componentStack;
                if (error) return /*#__PURE__*/ $5E6i4.createElement((0, $f4cae2aa4e44b256$export$2e2bcd8739ae039), {
                    id: id,
                    type: "error",
                    title: errorMessage,
                    description: /*#__PURE__*/ $5E6i4.createElement("pre", {
                        style: {
                            fontSize: '0.9em',
                            overflowX: 'auto'
                        }
                    }, errorDescription)
                });
                return children;
            }
        }
    ]);
}($5E6i4.PureComponent);
var $b77e6ab155fb7035$export$2e2bcd8739ae039 = $b77e6ab155fb7035$var$ErrorBoundary;


"use client";
const $4d1605d50bf1d84b$var$Alert = (0, $f4cae2aa4e44b256$export$2e2bcd8739ae039);
$4d1605d50bf1d84b$var$Alert.ErrorBoundary = (0, $b77e6ab155fb7035$export$2e2bcd8739ae039);
var $4d1605d50bf1d84b$export$2e2bcd8739ae039 = $4d1605d50bf1d84b$var$Alert;




var $5E6i4 = parcelRequire("5E6i4");
class $e241e8c3cc886a95$export$2e2bcd8739ae039 extends (0, $5E6i4.Component) {
    state = {
        error: undefined
    };
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, info) {
        console.error(`${this.props.name} failed`, error, info.componentStack);
    }
    componentDidUpdate(previous) {
        // A different piece is a fresh start for the view.
        if (this.state.error && previous.resetKey !== this.props.resetKey) this.setState({
            error: undefined
        });
    }
    render() {
        if (!this.state.error) return this.props.children;
        return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $4d1605d50bf1d84b$export$2e2bcd8739ae039), {
            action: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $67d71c16fdfc3a0e$export$2e2bcd8739ae039), {
                onClick: ()=>this.setState({
                        error: undefined
                    }),
                size: "small",
                children: (0, $f5efe749b20fa0f3$export$2e2bcd8739ae039).t('errorBoundary.retry')
            }),
            description: this.state.error.message,
            title: (0, $f5efe749b20fa0f3$export$2e2bcd8739ae039).t('errorBoundary.title', {
                name: this.props.name
            }),
            showIcon: true,
            type: "error"
        });
    }
}





var $f22df01f36f3bbc5$var$noop = {
    value: ()=>{}
};
function $f22df01f36f3bbc5$var$dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new $f22df01f36f3bbc5$var$Dispatch(_);
}
function $f22df01f36f3bbc5$var$Dispatch(_) {
    this._ = _;
}
function $f22df01f36f3bbc5$var$parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
$f22df01f36f3bbc5$var$Dispatch.prototype = $f22df01f36f3bbc5$var$dispatch.prototype = {
    constructor: $f22df01f36f3bbc5$var$Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = $f22df01f36f3bbc5$var$parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = $f22df01f36f3bbc5$var$get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = $f22df01f36f3bbc5$var$set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = $f22df01f36f3bbc5$var$set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new $f22df01f36f3bbc5$var$Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function $f22df01f36f3bbc5$var$get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function $f22df01f36f3bbc5$var$set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = $f22df01f36f3bbc5$var$noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
var $f22df01f36f3bbc5$export$2e2bcd8739ae039 = $f22df01f36f3bbc5$var$dispatch;



function $a696f7efe74d657f$var$none() {}
function $a696f7efe74d657f$export$2e2bcd8739ae039(selector) {
    return selector == null ? $a696f7efe74d657f$var$none : function() {
        return this.querySelector(selector);
    };
}


function $fe3e8a5771c356f3$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $a696f7efe74d657f$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
        }
    }
    return new (0, $3fa3bddc94b4f8a8$export$52baac22726c72bf)(subgroups, this._parents);
}



// Given something array like (or null), returns something that is strictly an
// array. This is used to ensure that array-like objects passed to d3.selectAll
// or selection.selectAll are converted into proper arrays when creating a
// selection; we don’t ever want to create a selection backed by a live
// HTMLCollection or NodeList. However, note that selection.selectAll will use a
// static NodeList as a group, since it safely derived from querySelectorAll.
function $6100a2c8d9353abb$export$2e2bcd8739ae039(x) {
    return x == null ? [] : Array.isArray(x) ? x : Array.from(x);
}


function $a251e86126c3c196$var$empty() {
    return [];
}
function $a251e86126c3c196$export$2e2bcd8739ae039(selector) {
    return selector == null ? $a251e86126c3c196$var$empty : function() {
        return this.querySelectorAll(selector);
    };
}


function $c3afa9f57c3c6584$var$arrayAll(select) {
    return function() {
        return (0, $6100a2c8d9353abb$export$2e2bcd8739ae039)(select.apply(this, arguments));
    };
}
function $c3afa9f57c3c6584$export$2e2bcd8739ae039(select) {
    if (typeof select === "function") select = $c3afa9f57c3c6584$var$arrayAll(select);
    else select = (0, $a251e86126c3c196$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            subgroups.push(select.call(node, node.__data__, i, group));
            parents.push(node);
        }
    }
    return new (0, $3fa3bddc94b4f8a8$export$52baac22726c72bf)(subgroups, parents);
}


function $9217c1f6bb2d2b85$export$2e2bcd8739ae039(selector) {
    return function() {
        return this.matches(selector);
    };
}
function $9217c1f6bb2d2b85$export$90c2759c036528(selector) {
    return function(node) {
        return node.matches(selector);
    };
}


var $b34141b01ced0a61$var$find = Array.prototype.find;
function $b34141b01ced0a61$var$childFind(match) {
    return function() {
        return $b34141b01ced0a61$var$find.call(this.children, match);
    };
}
function $b34141b01ced0a61$var$childFirst() {
    return this.firstElementChild;
}
function $b34141b01ced0a61$export$2e2bcd8739ae039(match) {
    return this.select(match == null ? $b34141b01ced0a61$var$childFirst : $b34141b01ced0a61$var$childFind(typeof match === "function" ? match : (0, $9217c1f6bb2d2b85$export$90c2759c036528)(match)));
}



var $437727374f9902ec$var$filter = Array.prototype.filter;
function $437727374f9902ec$var$children() {
    return Array.from(this.children);
}
function $437727374f9902ec$var$childrenFilter(match) {
    return function() {
        return $437727374f9902ec$var$filter.call(this.children, match);
    };
}
function $437727374f9902ec$export$2e2bcd8739ae039(match) {
    return this.selectAll(match == null ? $437727374f9902ec$var$children : $437727374f9902ec$var$childrenFilter(typeof match === "function" ? match : (0, $9217c1f6bb2d2b85$export$90c2759c036528)(match)));
}




function $417eb06912872de0$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $9217c1f6bb2d2b85$export$2e2bcd8739ae039)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $3fa3bddc94b4f8a8$export$52baac22726c72bf)(subgroups, this._parents);
}



function $16e10e18a783a307$export$2e2bcd8739ae039(update) {
    return new Array(update.length);
}



function $b2f4aac14f806d3c$export$2e2bcd8739ae039() {
    return new (0, $3fa3bddc94b4f8a8$export$52baac22726c72bf)(this._enter || this._groups.map((0, $16e10e18a783a307$export$2e2bcd8739ae039)), this._parents);
}
function $b2f4aac14f806d3c$export$67b01759a14cf6a4(parent, datum) {
    this.ownerDocument = parent.ownerDocument;
    this.namespaceURI = parent.namespaceURI;
    this._next = null;
    this._parent = parent;
    this.__data__ = datum;
}
$b2f4aac14f806d3c$export$67b01759a14cf6a4.prototype = {
    constructor: $b2f4aac14f806d3c$export$67b01759a14cf6a4,
    appendChild: function(child) {
        return this._parent.insertBefore(child, this._next);
    },
    insertBefore: function(child, next) {
        return this._parent.insertBefore(child, next);
    },
    querySelector: function(selector) {
        return this._parent.querySelector(selector);
    },
    querySelectorAll: function(selector) {
        return this._parent.querySelectorAll(selector);
    }
};


function $75c268d1af54dd4d$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $052a9a1821040aa9$var$bindIndex(parent, group, enter, update, exit, data) {
    var i = 0, node, groupLength = group.length, dataLength = data.length;
    // Put any non-null nodes that fit into update.
    // Put any null nodes into enter.
    // Put any remaining data into enter.
    for(; i < dataLength; ++i)if (node = group[i]) {
        node.__data__ = data[i];
        update[i] = node;
    } else enter[i] = new (0, $b2f4aac14f806d3c$export$67b01759a14cf6a4)(parent, data[i]);
    // Put any non-null nodes that don’t fit into exit.
    for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
}
function $052a9a1821040aa9$var$bindKey(parent, group, enter, update, exit, data, key) {
    var i, node, nodeByKeyValue = new Map, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for(i = 0; i < groupLength; ++i)if (node = group[i]) {
        keyValues[i] = keyValue = key.call(node, node.__data__, i, group) + "";
        if (nodeByKeyValue.has(keyValue)) exit[i] = node;
        else nodeByKeyValue.set(keyValue, node);
    }
    // Compute the key for each datum.
    // If there a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for(i = 0; i < dataLength; ++i){
        keyValue = key.call(parent, data[i], i, data) + "";
        if (node = nodeByKeyValue.get(keyValue)) {
            update[i] = node;
            node.__data__ = data[i];
            nodeByKeyValue.delete(keyValue);
        } else enter[i] = new (0, $b2f4aac14f806d3c$export$67b01759a14cf6a4)(parent, data[i]);
    }
    // Add any remaining nodes that were not bound to data to exit.
    for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue.get(keyValues[i]) === node) exit[i] = node;
}
function $052a9a1821040aa9$var$datum(node) {
    return node.__data__;
}
function $052a9a1821040aa9$export$2e2bcd8739ae039(value, key) {
    if (!arguments.length) return Array.from(this, $052a9a1821040aa9$var$datum);
    var bind = key ? $052a9a1821040aa9$var$bindKey : $052a9a1821040aa9$var$bindIndex, parents = this._parents, groups = this._groups;
    if (typeof value !== "function") value = (0, $75c268d1af54dd4d$export$2e2bcd8739ae039)(value);
    for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
        var parent = parents[j], group = groups[j], groupLength = group.length, data = $052a9a1821040aa9$var$arraylike(value.call(parent, parent && parent.__data__, j, parents)), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
        bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
        // Now connect the enter nodes to their following update node, such that
        // appendChild can insert the materialized enter node before this node,
        // rather than at the end of the parent node.
        for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
            if (i0 >= i1) i1 = i0 + 1;
            while(!(next = updateGroup[i1]) && ++i1 < dataLength);
            previous._next = next || null;
        }
    }
    update = new (0, $3fa3bddc94b4f8a8$export$52baac22726c72bf)(update, parents);
    update._enter = enter;
    update._exit = exit;
    return update;
}
// Given some data, this returns an array-like view of it: an object that
// exposes a length property and allows numeric indexing. Note that unlike
// selectAll, this isn’t worried about “live” collections because the resulting
// array will only be used briefly while data is being bound. (It is possible to
// cause the data to change while iterating by using a key function, but please
// don’t; we’d rather avoid a gratuitous copy.)
function $052a9a1821040aa9$var$arraylike(data) {
    return typeof data === "object" && "length" in data ? data // Array, TypedArray, NodeList, array-like
     : Array.from(data); // Map, Set, iterable, string, or anything else
}





function $0e815177caeed21b$export$2e2bcd8739ae039() {
    return new (0, $3fa3bddc94b4f8a8$export$52baac22726c72bf)(this._exit || this._groups.map((0, $16e10e18a783a307$export$2e2bcd8739ae039)), this._parents);
}


function $63f586900c2b4b42$export$2e2bcd8739ae039(onenter, onupdate, onexit) {
    var enter = this.enter(), update = this, exit = this.exit();
    if (typeof onenter === "function") {
        enter = onenter(enter);
        if (enter) enter = enter.selection();
    } else enter = enter.append(onenter + "");
    if (onupdate != null) {
        update = onupdate(update);
        if (update) update = update.selection();
    }
    if (onexit == null) exit.remove();
    else onexit(exit);
    return enter && update ? enter.merge(update).order() : update;
}



function $7a412a9de8021db3$export$2e2bcd8739ae039(context) {
    var selection = context.selection ? context.selection() : context;
    for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $3fa3bddc94b4f8a8$export$52baac22726c72bf)(merges, this._parents);
}


function $e17552b51cfac160$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
        for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
            if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
            next = node;
        }
    }
    return this;
}



function $6d597722efeda79a$export$2e2bcd8739ae039(compare) {
    if (!compare) compare = $6d597722efeda79a$var$ascending;
    function compareNode(a, b) {
        return a && b ? compare(a.__data__, b.__data__) : !a - !b;
    }
    for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
        sortgroup.sort(compareNode);
    }
    return new (0, $3fa3bddc94b4f8a8$export$52baac22726c72bf)(sortgroups, this._parents).order();
}
function $6d597722efeda79a$var$ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}


function $ae070bcd7d1235fe$export$2e2bcd8739ae039() {
    var callback = arguments[0];
    arguments[0] = this;
    callback.apply(null, arguments);
    return this;
}


function $c6e4ab7976218275$export$2e2bcd8739ae039() {
    return Array.from(this);
}


function $055d135910c13cd5$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
        var node = group[i];
        if (node) return node;
    }
    return null;
}


function $f897b6f378fcb9fc$export$2e2bcd8739ae039() {
    let size = 0;
    for (const node of this)++size; // eslint-disable-line no-unused-vars
    return size;
}


function $889880c4b5f21a22$export$2e2bcd8739ae039() {
    return !this.node();
}


function $b879b1474342de48$export$2e2bcd8739ae039(callback) {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
    return this;
}


var $a95bc3014beac1d3$export$201a3f7520ccc326 = "http://www.w3.org/1999/xhtml";
var $a95bc3014beac1d3$export$2e2bcd8739ae039 = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: $a95bc3014beac1d3$export$201a3f7520ccc326,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};


function $58b58edfe5dae49c$export$2e2bcd8739ae039(name) {
    var prefix = name += "", i = prefix.indexOf(":");
    if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
    return (0, $a95bc3014beac1d3$export$2e2bcd8739ae039).hasOwnProperty(prefix) ? {
        space: (0, $a95bc3014beac1d3$export$2e2bcd8739ae039)[prefix],
        local: name
    } : name; // eslint-disable-line no-prototype-builtins
}


function $d206eec3d2c8e9d1$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $d206eec3d2c8e9d1$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $d206eec3d2c8e9d1$var$attrConstant(name, value) {
    return function() {
        this.setAttribute(name, value);
    };
}
function $d206eec3d2c8e9d1$var$attrConstantNS(fullname, value) {
    return function() {
        this.setAttributeNS(fullname.space, fullname.local, value);
    };
}
function $d206eec3d2c8e9d1$var$attrFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttribute(name);
        else this.setAttribute(name, v);
    };
}
function $d206eec3d2c8e9d1$var$attrFunctionNS(fullname, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
        else this.setAttributeNS(fullname.space, fullname.local, v);
    };
}
function $d206eec3d2c8e9d1$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $58b58edfe5dae49c$export$2e2bcd8739ae039)(name);
    if (arguments.length < 2) {
        var node = this.node();
        return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
    }
    return this.each((value == null ? fullname.local ? $d206eec3d2c8e9d1$var$attrRemoveNS : $d206eec3d2c8e9d1$var$attrRemove : typeof value === "function" ? fullname.local ? $d206eec3d2c8e9d1$var$attrFunctionNS : $d206eec3d2c8e9d1$var$attrFunction : fullname.local ? $d206eec3d2c8e9d1$var$attrConstantNS : $d206eec3d2c8e9d1$var$attrConstant)(fullname, value));
}


function $a802501d7f7ae391$export$2e2bcd8739ae039(node) {
    return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
     || node.document && node // node is a Window
     || node.defaultView; // node is a Document
}


function $df9d8f43b4be6d4b$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $df9d8f43b4be6d4b$var$styleConstant(name, value, priority) {
    return function() {
        this.style.setProperty(name, value, priority);
    };
}
function $df9d8f43b4be6d4b$var$styleFunction(name, value, priority) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.style.removeProperty(name);
        else this.style.setProperty(name, v, priority);
    };
}
function $df9d8f43b4be6d4b$export$2e2bcd8739ae039(name, value, priority) {
    return arguments.length > 1 ? this.each((value == null ? $df9d8f43b4be6d4b$var$styleRemove : typeof value === "function" ? $df9d8f43b4be6d4b$var$styleFunction : $df9d8f43b4be6d4b$var$styleConstant)(name, value, priority == null ? "" : priority)) : $df9d8f43b4be6d4b$export$5e3cec964f0b5efd(this.node(), name);
}
function $df9d8f43b4be6d4b$export$5e3cec964f0b5efd(node, name) {
    return node.style.getPropertyValue(name) || (0, $a802501d7f7ae391$export$2e2bcd8739ae039)(node).getComputedStyle(node, null).getPropertyValue(name);
}


function $f99b3adab0522f33$var$propertyRemove(name) {
    return function() {
        delete this[name];
    };
}
function $f99b3adab0522f33$var$propertyConstant(name, value) {
    return function() {
        this[name] = value;
    };
}
function $f99b3adab0522f33$var$propertyFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) delete this[name];
        else this[name] = v;
    };
}
function $f99b3adab0522f33$export$2e2bcd8739ae039(name, value) {
    return arguments.length > 1 ? this.each((value == null ? $f99b3adab0522f33$var$propertyRemove : typeof value === "function" ? $f99b3adab0522f33$var$propertyFunction : $f99b3adab0522f33$var$propertyConstant)(name, value)) : this.node()[name];
}


function $d06e661034a45406$var$classArray(string) {
    return string.trim().split(/^|\s+/);
}
function $d06e661034a45406$var$classList(node) {
    return node.classList || new $d06e661034a45406$var$ClassList(node);
}
function $d06e661034a45406$var$ClassList(node) {
    this._node = node;
    this._names = $d06e661034a45406$var$classArray(node.getAttribute("class") || "");
}
$d06e661034a45406$var$ClassList.prototype = {
    add: function(name) {
        var i = this._names.indexOf(name);
        if (i < 0) {
            this._names.push(name);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    remove: function(name) {
        var i = this._names.indexOf(name);
        if (i >= 0) {
            this._names.splice(i, 1);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    contains: function(name) {
        return this._names.indexOf(name) >= 0;
    }
};
function $d06e661034a45406$var$classedAdd(node, names) {
    var list = $d06e661034a45406$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.add(names[i]);
}
function $d06e661034a45406$var$classedRemove(node, names) {
    var list = $d06e661034a45406$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.remove(names[i]);
}
function $d06e661034a45406$var$classedTrue(names) {
    return function() {
        $d06e661034a45406$var$classedAdd(this, names);
    };
}
function $d06e661034a45406$var$classedFalse(names) {
    return function() {
        $d06e661034a45406$var$classedRemove(this, names);
    };
}
function $d06e661034a45406$var$classedFunction(names, value) {
    return function() {
        (value.apply(this, arguments) ? $d06e661034a45406$var$classedAdd : $d06e661034a45406$var$classedRemove)(this, names);
    };
}
function $d06e661034a45406$export$2e2bcd8739ae039(name, value) {
    var names = $d06e661034a45406$var$classArray(name + "");
    if (arguments.length < 2) {
        var list = $d06e661034a45406$var$classList(this.node()), i = -1, n = names.length;
        while(++i < n)if (!list.contains(names[i])) return false;
        return true;
    }
    return this.each((typeof value === "function" ? $d06e661034a45406$var$classedFunction : value ? $d06e661034a45406$var$classedTrue : $d06e661034a45406$var$classedFalse)(names, value));
}


function $039cad3e6b62ef93$var$textRemove() {
    this.textContent = "";
}
function $039cad3e6b62ef93$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $039cad3e6b62ef93$var$textFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
    };
}
function $039cad3e6b62ef93$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $039cad3e6b62ef93$var$textRemove : (typeof value === "function" ? $039cad3e6b62ef93$var$textFunction : $039cad3e6b62ef93$var$textConstant)(value)) : this.node().textContent;
}


function $c8e884507bcbc0d6$var$htmlRemove() {
    this.innerHTML = "";
}
function $c8e884507bcbc0d6$var$htmlConstant(value) {
    return function() {
        this.innerHTML = value;
    };
}
function $c8e884507bcbc0d6$var$htmlFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.innerHTML = v == null ? "" : v;
    };
}
function $c8e884507bcbc0d6$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $c8e884507bcbc0d6$var$htmlRemove : (typeof value === "function" ? $c8e884507bcbc0d6$var$htmlFunction : $c8e884507bcbc0d6$var$htmlConstant)(value)) : this.node().innerHTML;
}


function $d32582798f21257c$var$raise() {
    if (this.nextSibling) this.parentNode.appendChild(this);
}
function $d32582798f21257c$export$2e2bcd8739ae039() {
    return this.each($d32582798f21257c$var$raise);
}


function $81fa89a3cf707281$var$lower() {
    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function $81fa89a3cf707281$export$2e2bcd8739ae039() {
    return this.each($81fa89a3cf707281$var$lower);
}




function $9eff7b5d7c009c96$var$creatorInherit(name) {
    return function() {
        var document = this.ownerDocument, uri = this.namespaceURI;
        return uri === (0, $a95bc3014beac1d3$export$201a3f7520ccc326) && document.documentElement.namespaceURI === (0, $a95bc3014beac1d3$export$201a3f7520ccc326) ? document.createElement(name) : document.createElementNS(uri, name);
    };
}
function $9eff7b5d7c009c96$var$creatorFixed(fullname) {
    return function() {
        return this.ownerDocument.createElementNS(fullname.space, fullname.local);
    };
}
function $9eff7b5d7c009c96$export$2e2bcd8739ae039(name) {
    var fullname = (0, $58b58edfe5dae49c$export$2e2bcd8739ae039)(name);
    return (fullname.local ? $9eff7b5d7c009c96$var$creatorFixed : $9eff7b5d7c009c96$var$creatorInherit)(fullname);
}


function $e7e5728b38923688$export$2e2bcd8739ae039(name) {
    var create = typeof name === "function" ? name : (0, $9eff7b5d7c009c96$export$2e2bcd8739ae039)(name);
    return this.select(function() {
        return this.appendChild(create.apply(this, arguments));
    });
}




function $92828970e51f2858$var$constantNull() {
    return null;
}
function $92828970e51f2858$export$2e2bcd8739ae039(name, before) {
    var create = typeof name === "function" ? name : (0, $9eff7b5d7c009c96$export$2e2bcd8739ae039)(name), select = before == null ? $92828970e51f2858$var$constantNull : typeof before === "function" ? before : (0, $a696f7efe74d657f$export$2e2bcd8739ae039)(before);
    return this.select(function() {
        return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
    });
}


function $3fba60665c09da9b$var$remove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
}
function $3fba60665c09da9b$export$2e2bcd8739ae039() {
    return this.each($3fba60665c09da9b$var$remove);
}


function $f8ba4680beaf3292$var$selection_cloneShallow() {
    var clone = this.cloneNode(false), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $f8ba4680beaf3292$var$selection_cloneDeep() {
    var clone = this.cloneNode(true), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $f8ba4680beaf3292$export$2e2bcd8739ae039(deep) {
    return this.select(deep ? $f8ba4680beaf3292$var$selection_cloneDeep : $f8ba4680beaf3292$var$selection_cloneShallow);
}


function $d5e7be624eaf3e5d$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.property("__data__", value) : this.node().__data__;
}


function $f620cfb2b91d85e5$var$contextListener(listener) {
    return function(event) {
        listener.call(this, event, this.__data__);
    };
}
function $f620cfb2b91d85e5$var$parseTypenames(typenames) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        return {
            type: t,
            name: name
        };
    });
}
function $f620cfb2b91d85e5$var$onRemove(typename) {
    return function() {
        var on = this.__on;
        if (!on) return;
        for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.options);
        else on[++i] = o;
        if (++i) on.length = i;
        else delete this.__on;
    };
}
function $f620cfb2b91d85e5$var$onAdd(typename, value, options) {
    return function() {
        var on = this.__on, o, listener = $f620cfb2b91d85e5$var$contextListener(value);
        if (on) {
            for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.options);
                this.addEventListener(o.type, o.listener = listener, o.options = options);
                o.value = value;
                return;
            }
        }
        this.addEventListener(typename.type, listener, options);
        o = {
            type: typename.type,
            name: typename.name,
            value: value,
            listener: listener,
            options: options
        };
        if (!on) this.__on = [
            o
        ];
        else on.push(o);
    };
}
function $f620cfb2b91d85e5$export$2e2bcd8739ae039(typename, value, options) {
    var typenames = $f620cfb2b91d85e5$var$parseTypenames(typename + ""), i, n = typenames.length, t;
    if (arguments.length < 2) {
        var on = this.node().__on;
        if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
            if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
        }
        return;
    }
    on = value ? $f620cfb2b91d85e5$var$onAdd : $f620cfb2b91d85e5$var$onRemove;
    for(i = 0; i < n; ++i)this.each(on(typenames[i], value, options));
    return this;
}



function $049280ac271fdabe$var$dispatchEvent(node, type, params) {
    var window = (0, $a802501d7f7ae391$export$2e2bcd8739ae039)(node), event = window.CustomEvent;
    if (typeof event === "function") event = new event(type, params);
    else {
        event = window.document.createEvent("Event");
        if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
        else event.initEvent(type, false, false);
    }
    node.dispatchEvent(event);
}
function $049280ac271fdabe$var$dispatchConstant(type, params) {
    return function() {
        return $049280ac271fdabe$var$dispatchEvent(this, type, params);
    };
}
function $049280ac271fdabe$var$dispatchFunction(type, params) {
    return function() {
        return $049280ac271fdabe$var$dispatchEvent(this, type, params.apply(this, arguments));
    };
}
function $049280ac271fdabe$export$2e2bcd8739ae039(type, params) {
    return this.each((typeof params === "function" ? $049280ac271fdabe$var$dispatchFunction : $049280ac271fdabe$var$dispatchConstant)(type, params));
}


function* $c0c33d07b05cd299$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) yield node;
    }
}


var $3fa3bddc94b4f8a8$export$e8e78c978b129247 = [
    null
];
function $3fa3bddc94b4f8a8$export$52baac22726c72bf(groups, parents) {
    this._groups = groups;
    this._parents = parents;
}
function $3fa3bddc94b4f8a8$var$selection() {
    return new $3fa3bddc94b4f8a8$export$52baac22726c72bf([
        [
            document.documentElement
        ]
    ], $3fa3bddc94b4f8a8$export$e8e78c978b129247);
}
function $3fa3bddc94b4f8a8$var$selection_selection() {
    return this;
}
$3fa3bddc94b4f8a8$export$52baac22726c72bf.prototype = $3fa3bddc94b4f8a8$var$selection.prototype = {
    constructor: $3fa3bddc94b4f8a8$export$52baac22726c72bf,
    select: (0, $fe3e8a5771c356f3$export$2e2bcd8739ae039),
    selectAll: (0, $c3afa9f57c3c6584$export$2e2bcd8739ae039),
    selectChild: (0, $b34141b01ced0a61$export$2e2bcd8739ae039),
    selectChildren: (0, $437727374f9902ec$export$2e2bcd8739ae039),
    filter: (0, $417eb06912872de0$export$2e2bcd8739ae039),
    data: (0, $052a9a1821040aa9$export$2e2bcd8739ae039),
    enter: (0, $b2f4aac14f806d3c$export$2e2bcd8739ae039),
    exit: (0, $0e815177caeed21b$export$2e2bcd8739ae039),
    join: (0, $63f586900c2b4b42$export$2e2bcd8739ae039),
    merge: (0, $7a412a9de8021db3$export$2e2bcd8739ae039),
    selection: $3fa3bddc94b4f8a8$var$selection_selection,
    order: (0, $e17552b51cfac160$export$2e2bcd8739ae039),
    sort: (0, $6d597722efeda79a$export$2e2bcd8739ae039),
    call: (0, $ae070bcd7d1235fe$export$2e2bcd8739ae039),
    nodes: (0, $c6e4ab7976218275$export$2e2bcd8739ae039),
    node: (0, $055d135910c13cd5$export$2e2bcd8739ae039),
    size: (0, $f897b6f378fcb9fc$export$2e2bcd8739ae039),
    empty: (0, $889880c4b5f21a22$export$2e2bcd8739ae039),
    each: (0, $b879b1474342de48$export$2e2bcd8739ae039),
    attr: (0, $d206eec3d2c8e9d1$export$2e2bcd8739ae039),
    style: (0, $df9d8f43b4be6d4b$export$2e2bcd8739ae039),
    property: (0, $f99b3adab0522f33$export$2e2bcd8739ae039),
    classed: (0, $d06e661034a45406$export$2e2bcd8739ae039),
    text: (0, $039cad3e6b62ef93$export$2e2bcd8739ae039),
    html: (0, $c8e884507bcbc0d6$export$2e2bcd8739ae039),
    raise: (0, $d32582798f21257c$export$2e2bcd8739ae039),
    lower: (0, $81fa89a3cf707281$export$2e2bcd8739ae039),
    append: (0, $e7e5728b38923688$export$2e2bcd8739ae039),
    insert: (0, $92828970e51f2858$export$2e2bcd8739ae039),
    remove: (0, $3fba60665c09da9b$export$2e2bcd8739ae039),
    clone: (0, $f8ba4680beaf3292$export$2e2bcd8739ae039),
    datum: (0, $d5e7be624eaf3e5d$export$2e2bcd8739ae039),
    on: (0, $f620cfb2b91d85e5$export$2e2bcd8739ae039),
    dispatch: (0, $049280ac271fdabe$export$2e2bcd8739ae039),
    [Symbol.iterator]: (0, $c0c33d07b05cd299$export$2e2bcd8739ae039)
};
var $3fa3bddc94b4f8a8$export$2e2bcd8739ae039 = $3fa3bddc94b4f8a8$var$selection;


function $4506c173c1ba6b79$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $3fa3bddc94b4f8a8$export$52baac22726c72bf)([
        [
            document.querySelector(selector)
        ]
    ], [
        document.documentElement
    ]) : new (0, $3fa3bddc94b4f8a8$export$52baac22726c72bf)([
        [
            selector
        ]
    ], (0, $3fa3bddc94b4f8a8$export$e8e78c978b129247));
}


// These are typically used in conjunction with noevent to ensure that we can
// preventDefault on the event.
const $19c289642832a009$export$524615cd03e458cc = {
    passive: false
};
const $19c289642832a009$export$35431a0e47022de1 = {
    capture: true,
    passive: false
};
function $19c289642832a009$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $19c289642832a009$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}


function $ae3cd07c3e922ae3$export$2e2bcd8739ae039(view) {
    var root = view.document.documentElement, selection = (0, $4506c173c1ba6b79$export$2e2bcd8739ae039)(view).on("dragstart.drag", (0, $19c289642832a009$export$2e2bcd8739ae039), (0, $19c289642832a009$export$35431a0e47022de1));
    if ("onselectstart" in root) selection.on("selectstart.drag", (0, $19c289642832a009$export$2e2bcd8739ae039), (0, $19c289642832a009$export$35431a0e47022de1));
    else {
        root.__noselect = root.style.MozUserSelect;
        root.style.MozUserSelect = "none";
    }
}
function $ae3cd07c3e922ae3$export$833237748009e1e1(view, noclick) {
    var root = view.document.documentElement, selection = (0, $4506c173c1ba6b79$export$2e2bcd8739ae039)(view).on("dragstart.drag", null);
    if (noclick) {
        selection.on("click.drag", (0, $19c289642832a009$export$2e2bcd8739ae039), (0, $19c289642832a009$export$35431a0e47022de1));
        setTimeout(function() {
            selection.on("click.drag", null);
        }, 0);
    }
    if ("onselectstart" in root) selection.on("selectstart.drag", null);
    else {
        root.style.MozUserSelect = root.__noselect;
        delete root.__noselect;
    }
}



var $9eF39 = parcelRequire("9eF39");

var $9eF39 = parcelRequire("9eF39");
function $881d0702247da37d$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $881d0702247da37d$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $881d0702247da37d$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}



function $d875b83ab5863578$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $881d0702247da37d$export$4e41033bfeec1a4c)((t - i / n) * n, v0, v1, v2, v3);
    };
}


var $32a1f36c13df06e0$export$2e2bcd8739ae039 = (x)=>()=>x;


function $8dfce0561889250e$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $8dfce0561889250e$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $8dfce0561889250e$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $8dfce0561889250e$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $32a1f36c13df06e0$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}
function $8dfce0561889250e$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $8dfce0561889250e$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $8dfce0561889250e$var$exponential(a, b, y) : (0, $32a1f36c13df06e0$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
    };
}
function $8dfce0561889250e$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $8dfce0561889250e$var$linear(a, d) : (0, $32a1f36c13df06e0$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}


var $c99ed0dd240dae7d$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $8dfce0561889250e$export$a7ebe8cc6aaf8d37)(y);
    function rgb(start, end) {
        var r = color((start = (0, $9eF39.rgb)(start)).r, (end = (0, $9eF39.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $8dfce0561889250e$export$2e2bcd8739ae039)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $c99ed0dd240dae7d$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $9eF39.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $c99ed0dd240dae7d$export$2c0e28f2e2852d3f = $c99ed0dd240dae7d$var$rgbSpline((0, $881d0702247da37d$export$2e2bcd8739ae039));
var $c99ed0dd240dae7d$export$53d5214f625ccd4c = $c99ed0dd240dae7d$var$rgbSpline((0, $d875b83ab5863578$export$2e2bcd8739ae039));



function $910b5323d0705334$export$2e2bcd8739ae039(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $910b5323d0705334$export$5cd576d1827d40c8(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}


function $66ad23a6bb88ccc7$export$2e2bcd8739ae039(a, b) {
    return ((0, $910b5323d0705334$export$5cd576d1827d40c8)(b) ? (0, $910b5323d0705334$export$2e2bcd8739ae039) : $66ad23a6bb88ccc7$export$15d09067c6a5ee49)(a, b);
}
function $66ad23a6bb88ccc7$export$15d09067c6a5ee49(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $0a6b21d627aa3b76$export$2e2bcd8739ae039)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}


function $3133c9670a94856a$export$2e2bcd8739ae039(a, b) {
    var d = new Date;
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}


function $4a087d8646486986$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}



function $83516c74d826a95f$export$2e2bcd8739ae039(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $0a6b21d627aa3b76$export$2e2bcd8739ae039)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}



var $256699786eb44963$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $256699786eb44963$var$reB = new RegExp($256699786eb44963$var$reA.source, "g");
function $256699786eb44963$var$zero(b) {
    return function() {
        return b;
    };
}
function $256699786eb44963$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $256699786eb44963$export$2e2bcd8739ae039(a, b) {
    var bi = $256699786eb44963$var$reA.lastIndex = $256699786eb44963$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $256699786eb44963$var$reA.exec(a)) && (bm = $256699786eb44963$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $4a087d8646486986$export$2e2bcd8739ae039)(am, bm)
            });
        }
        bi = $256699786eb44963$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $256699786eb44963$var$one(q[0].x) : $256699786eb44963$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}




function $0a6b21d627aa3b76$export$2e2bcd8739ae039(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $32a1f36c13df06e0$export$2e2bcd8739ae039)(b) : (t === "number" ? (0, $4a087d8646486986$export$2e2bcd8739ae039) : t === "string" ? (c = (0, $9eF39.default)(b)) ? (b = c, $c99ed0dd240dae7d$export$2e2bcd8739ae039) : (0, $256699786eb44963$export$2e2bcd8739ae039) : b instanceof (0, $9eF39.default) ? (0, $c99ed0dd240dae7d$export$2e2bcd8739ae039) : b instanceof Date ? (0, $3133c9670a94856a$export$2e2bcd8739ae039) : (0, $910b5323d0705334$export$5cd576d1827d40c8)(b) ? (0, $910b5323d0705334$export$2e2bcd8739ae039) : Array.isArray(b) ? (0, $66ad23a6bb88ccc7$export$15d09067c6a5ee49) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, $83516c74d826a95f$export$2e2bcd8739ae039) : (0, $4a087d8646486986$export$2e2bcd8739ae039))(a, b);
}


function $39821514e2bb6c34$export$2e2bcd8739ae039(event) {
    let sourceEvent;
    while(sourceEvent = event.sourceEvent)event = sourceEvent;
    return event;
}


function $7edc954089de14ac$export$2e2bcd8739ae039(event, node) {
    event = (0, $39821514e2bb6c34$export$2e2bcd8739ae039)(event);
    if (node === undefined) node = event.currentTarget;
    if (node) {
        var svg = node.ownerSVGElement || node;
        if (svg.createSVGPoint) {
            var point = svg.createSVGPoint();
            point.x = event.clientX, point.y = event.clientY;
            point = point.matrixTransform(node.getScreenCTM().inverse());
            return [
                point.x,
                point.y
            ];
        }
        if (node.getBoundingClientRect) {
            var rect = node.getBoundingClientRect();
            return [
                event.clientX - rect.left - node.clientLeft,
                event.clientY - rect.top - node.clientTop
            ];
        }
    }
    return [
        event.pageX,
        event.pageY
    ];
}




var $0830f34b180fabe6$var$frame = 0, $0830f34b180fabe6$var$timeout = 0, $0830f34b180fabe6$var$interval = 0, $0830f34b180fabe6$var$pokeDelay = 1000, $0830f34b180fabe6$var$taskHead, $0830f34b180fabe6$var$taskTail, $0830f34b180fabe6$var$clockLast = 0, $0830f34b180fabe6$var$clockNow = 0, $0830f34b180fabe6$var$clockSkew = 0, $0830f34b180fabe6$var$clock = typeof performance === "object" && performance.now ? performance : Date, $0830f34b180fabe6$var$setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
    setTimeout(f, 17);
};
function $0830f34b180fabe6$export$461939dd4422153() {
    return $0830f34b180fabe6$var$clockNow || ($0830f34b180fabe6$var$setFrame($0830f34b180fabe6$var$clearNow), $0830f34b180fabe6$var$clockNow = $0830f34b180fabe6$var$clock.now() + $0830f34b180fabe6$var$clockSkew);
}
function $0830f34b180fabe6$var$clearNow() {
    $0830f34b180fabe6$var$clockNow = 0;
}
function $0830f34b180fabe6$export$c57e9b2d8b9e4de() {
    this._call = this._time = this._next = null;
}
$0830f34b180fabe6$export$c57e9b2d8b9e4de.prototype = $0830f34b180fabe6$export$9dc4ecf953986f04.prototype = {
    constructor: $0830f34b180fabe6$export$c57e9b2d8b9e4de,
    restart: function(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? $0830f34b180fabe6$export$461939dd4422153() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && $0830f34b180fabe6$var$taskTail !== this) {
            if ($0830f34b180fabe6$var$taskTail) $0830f34b180fabe6$var$taskTail._next = this;
            else $0830f34b180fabe6$var$taskHead = this;
            $0830f34b180fabe6$var$taskTail = this;
        }
        this._call = callback;
        this._time = time;
        $0830f34b180fabe6$var$sleep();
    },
    stop: function() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            $0830f34b180fabe6$var$sleep();
        }
    }
};
function $0830f34b180fabe6$export$9dc4ecf953986f04(callback, delay, time) {
    var t = new $0830f34b180fabe6$export$c57e9b2d8b9e4de;
    t.restart(callback, delay, time);
    return t;
}
function $0830f34b180fabe6$export$d60154c1d7f3990e() {
    $0830f34b180fabe6$export$461939dd4422153(); // Get the current time, if not already set.
    ++$0830f34b180fabe6$var$frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = $0830f34b180fabe6$var$taskHead, e;
    while(t){
        if ((e = $0830f34b180fabe6$var$clockNow - t._time) >= 0) t._call.call(undefined, e);
        t = t._next;
    }
    --$0830f34b180fabe6$var$frame;
}
function $0830f34b180fabe6$var$wake() {
    $0830f34b180fabe6$var$clockNow = ($0830f34b180fabe6$var$clockLast = $0830f34b180fabe6$var$clock.now()) + $0830f34b180fabe6$var$clockSkew;
    $0830f34b180fabe6$var$frame = $0830f34b180fabe6$var$timeout = 0;
    try {
        $0830f34b180fabe6$export$d60154c1d7f3990e();
    } finally{
        $0830f34b180fabe6$var$frame = 0;
        $0830f34b180fabe6$var$nap();
        $0830f34b180fabe6$var$clockNow = 0;
    }
}
function $0830f34b180fabe6$var$poke() {
    var now = $0830f34b180fabe6$var$clock.now(), delay = now - $0830f34b180fabe6$var$clockLast;
    if (delay > $0830f34b180fabe6$var$pokeDelay) $0830f34b180fabe6$var$clockSkew -= delay, $0830f34b180fabe6$var$clockLast = now;
}
function $0830f34b180fabe6$var$nap() {
    var t0, t1 = $0830f34b180fabe6$var$taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : $0830f34b180fabe6$var$taskHead = t2;
    }
    $0830f34b180fabe6$var$taskTail = t0;
    $0830f34b180fabe6$var$sleep(time);
}
function $0830f34b180fabe6$var$sleep(time) {
    if ($0830f34b180fabe6$var$frame) return; // Soonest alarm already set, or will be.
    if ($0830f34b180fabe6$var$timeout) $0830f34b180fabe6$var$timeout = clearTimeout($0830f34b180fabe6$var$timeout);
    var delay = time - $0830f34b180fabe6$var$clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) $0830f34b180fabe6$var$timeout = setTimeout($0830f34b180fabe6$var$wake, time - $0830f34b180fabe6$var$clock.now() - $0830f34b180fabe6$var$clockSkew);
        if ($0830f34b180fabe6$var$interval) $0830f34b180fabe6$var$interval = clearInterval($0830f34b180fabe6$var$interval);
    } else {
        if (!$0830f34b180fabe6$var$interval) $0830f34b180fabe6$var$clockLast = $0830f34b180fabe6$var$clock.now(), $0830f34b180fabe6$var$interval = setInterval($0830f34b180fabe6$var$poke, $0830f34b180fabe6$var$pokeDelay);
        $0830f34b180fabe6$var$frame = 1, $0830f34b180fabe6$var$setFrame($0830f34b180fabe6$var$wake);
    }
}


function $761d5cee6e823ef5$export$2e2bcd8739ae039(callback, delay, time) {
    var t = new (0, $0830f34b180fabe6$export$c57e9b2d8b9e4de);
    delay = delay == null ? 0 : +delay;
    t.restart((elapsed)=>{
        t.stop();
        callback(elapsed + delay);
    }, delay, time);
    return t;
}


var $b5673d202c1a718d$var$emptyOn = (0, $f22df01f36f3bbc5$export$2e2bcd8739ae039)("start", "end", "cancel", "interrupt");
var $b5673d202c1a718d$var$emptyTween = [];
var $b5673d202c1a718d$export$ff39ebd4bb12b718 = 0;
var $b5673d202c1a718d$export$584530fe98d14a84 = 1;
var $b5673d202c1a718d$export$a5d151aee16efd42 = 2;
var $b5673d202c1a718d$export$fb935ab5849a0db9 = 3;
var $b5673d202c1a718d$export$1573e22b087389af = 4;
var $b5673d202c1a718d$export$a2e792214ded83b2 = 5;
var $b5673d202c1a718d$export$9d38167254403955 = 6;
function $b5673d202c1a718d$export$2e2bcd8739ae039(node, name, id, index, group, timing) {
    var schedules = node.__transition;
    if (!schedules) node.__transition = {};
    else if (id in schedules) return;
    $b5673d202c1a718d$var$create(node, id, {
        name: name,
        index: index,
        group: group,
        on: $b5673d202c1a718d$var$emptyOn,
        tween: $b5673d202c1a718d$var$emptyTween,
        time: timing.time,
        delay: timing.delay,
        duration: timing.duration,
        ease: timing.ease,
        timer: null,
        state: $b5673d202c1a718d$export$ff39ebd4bb12b718
    });
}
function $b5673d202c1a718d$export$2cd8252107eb640b(node, id) {
    var schedule = $b5673d202c1a718d$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $b5673d202c1a718d$export$ff39ebd4bb12b718) throw new Error("too late; already scheduled");
    return schedule;
}
function $b5673d202c1a718d$export$adaa4cf7ef1b65be(node, id) {
    var schedule = $b5673d202c1a718d$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $b5673d202c1a718d$export$fb935ab5849a0db9) throw new Error("too late; already running");
    return schedule;
}
function $b5673d202c1a718d$export$3988ae62b71be9a3(node, id) {
    var schedule = node.__transition;
    if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
    return schedule;
}
function $b5673d202c1a718d$var$create(node, id, self) {
    var schedules = node.__transition, tween;
    // Initialize the self timer when the transition is created.
    // Note the actual delay is not known until the first callback!
    schedules[id] = self;
    self.timer = (0, $0830f34b180fabe6$export$9dc4ecf953986f04)(schedule, 0, self.time);
    function schedule(elapsed) {
        self.state = $b5673d202c1a718d$export$584530fe98d14a84;
        self.timer.restart(start, self.delay, self.time);
        // If the elapsed delay is less than our first sleep, start immediately.
        if (self.delay <= elapsed) start(elapsed - self.delay);
    }
    function start(elapsed) {
        var i, j, n, o;
        // If the state is not SCHEDULED, then we previously errored on start.
        if (self.state !== $b5673d202c1a718d$export$584530fe98d14a84) return stop();
        for(i in schedules){
            o = schedules[i];
            if (o.name !== self.name) continue;
            // While this element already has a starting transition during this frame,
            // defer starting an interrupting transition until that transition has a
            // chance to tick (and possibly end); see d3/d3-transition#54!
            if (o.state === $b5673d202c1a718d$export$fb935ab5849a0db9) return (0, $761d5cee6e823ef5$export$2e2bcd8739ae039)(start);
            // Interrupt the active transition, if any.
            if (o.state === $b5673d202c1a718d$export$1573e22b087389af) {
                o.state = $b5673d202c1a718d$export$9d38167254403955;
                o.timer.stop();
                o.on.call("interrupt", node, node.__data__, o.index, o.group);
                delete schedules[i];
            } else if (+i < id) {
                o.state = $b5673d202c1a718d$export$9d38167254403955;
                o.timer.stop();
                o.on.call("cancel", node, node.__data__, o.index, o.group);
                delete schedules[i];
            }
        }
        // Defer the first tick to end of the current frame; see d3/d3#1576.
        // Note the transition may be canceled after start and before the first tick!
        // Note this must be scheduled before the start event; see d3/d3-transition#16!
        // Assuming this is successful, subsequent callbacks go straight to tick.
        (0, $761d5cee6e823ef5$export$2e2bcd8739ae039)(function() {
            if (self.state === $b5673d202c1a718d$export$fb935ab5849a0db9) {
                self.state = $b5673d202c1a718d$export$1573e22b087389af;
                self.timer.restart(tick, self.delay, self.time);
                tick(elapsed);
            }
        });
        // Dispatch the start event.
        // Note this must be done before the tween are initialized.
        self.state = $b5673d202c1a718d$export$a5d151aee16efd42;
        self.on.call("start", node, node.__data__, self.index, self.group);
        if (self.state !== $b5673d202c1a718d$export$a5d151aee16efd42) return; // interrupted
        self.state = $b5673d202c1a718d$export$fb935ab5849a0db9;
        // Initialize the tween, deleting null tween.
        tween = new Array(n = self.tween.length);
        for(i = 0, j = -1; i < n; ++i)if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) tween[++j] = o;
        tween.length = j + 1;
    }
    function tick(elapsed) {
        var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = $b5673d202c1a718d$export$a2e792214ded83b2, 1), i = -1, n = tween.length;
        while(++i < n)tween[i].call(node, t);
        // Dispatch the end event.
        if (self.state === $b5673d202c1a718d$export$a2e792214ded83b2) {
            self.on.call("end", node, node.__data__, self.index, self.group);
            stop();
        }
    }
    function stop() {
        self.state = $b5673d202c1a718d$export$9d38167254403955;
        self.timer.stop();
        delete schedules[id];
        for(var i in schedules)return; // eslint-disable-line no-unused-vars
        delete node.__transition;
    }
}


function $a9f60c0c7972321a$export$2e2bcd8739ae039(node, name) {
    var schedules = node.__transition, schedule, active, empty = true, i;
    if (!schedules) return;
    name = name == null ? null : name + "";
    for(i in schedules){
        if ((schedule = schedules[i]).name !== name) {
            empty = false;
            continue;
        }
        active = schedule.state > (0, $b5673d202c1a718d$export$a5d151aee16efd42) && schedule.state < (0, $b5673d202c1a718d$export$a2e792214ded83b2);
        schedule.state = (0, $b5673d202c1a718d$export$9d38167254403955);
        schedule.timer.stop();
        schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
        delete schedules[i];
    }
    if (empty) delete node.__transition;
}


function $1edbe92636db4b14$export$2e2bcd8739ae039(name) {
    return this.each(function() {
        (0, $a9f60c0c7972321a$export$2e2bcd8739ae039)(this, name);
    });
}




var $5e622cc4ee5dcd58$var$degrees = 180 / Math.PI;
var $5e622cc4ee5dcd58$export$f0954fd7d5368655 = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
function $5e622cc4ee5dcd58$export$2e2bcd8739ae039(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $5e622cc4ee5dcd58$var$degrees,
        skewX: Math.atan(skewX) * $5e622cc4ee5dcd58$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}


var $2336aa7b25388556$var$svgNode;
function $2336aa7b25388556$export$59ad369bf4938177(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? (0, $5e622cc4ee5dcd58$export$f0954fd7d5368655) : (0, $5e622cc4ee5dcd58$export$2e2bcd8739ae039)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function $2336aa7b25388556$export$f9ef43f9a1d89a18(value) {
    if (value == null) return 0, $5e622cc4ee5dcd58$export$f0954fd7d5368655;
    if (!$2336aa7b25388556$var$svgNode) $2336aa7b25388556$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $2336aa7b25388556$var$svgNode.setAttribute("transform", value);
    if (!(value = $2336aa7b25388556$var$svgNode.transform.baseVal.consolidate())) return 0, $5e622cc4ee5dcd58$export$f0954fd7d5368655;
    value = value.matrix;
    return (0, $5e622cc4ee5dcd58$export$2e2bcd8739ae039)(value.a, value.b, value.c, value.d, value.e, value.f);
}


function $58d4bff51a6cd97b$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $4a087d8646486986$export$2e2bcd8739ae039)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $4a087d8646486986$export$2e2bcd8739ae039)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $4a087d8646486986$export$2e2bcd8739ae039)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $4a087d8646486986$export$2e2bcd8739ae039)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $4a087d8646486986$export$2e2bcd8739ae039)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $4a087d8646486986$export$2e2bcd8739ae039)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $58d4bff51a6cd97b$export$56bec7123bb3589a = $58d4bff51a6cd97b$var$interpolateTransform((0, $2336aa7b25388556$export$59ad369bf4938177), "px, ", "px)", "deg)");
var $58d4bff51a6cd97b$export$da8cba906d64c082 = $58d4bff51a6cd97b$var$interpolateTransform((0, $2336aa7b25388556$export$f9ef43f9a1d89a18), ", ", ")", ")");




function $2b846766134b1951$var$tweenRemove(id, name) {
    var tween0, tween1;
    return function() {
        var schedule = (0, $b5673d202c1a718d$export$adaa4cf7ef1b65be)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = tween0 = tween;
            for(var i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1 = tween1.slice();
                tween1.splice(i, 1);
                break;
            }
        }
        schedule.tween = tween1;
    };
}
function $2b846766134b1951$var$tweenFunction(id, name, value) {
    var tween0, tween1;
    if (typeof value !== "function") throw new Error;
    return function() {
        var schedule = (0, $b5673d202c1a718d$export$adaa4cf7ef1b65be)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = (tween0 = tween).slice();
            for(var t = {
                name: name,
                value: value
            }, i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1[i] = t;
                break;
            }
            if (i === n) tween1.push(t);
        }
        schedule.tween = tween1;
    };
}
function $2b846766134b1951$export$2e2bcd8739ae039(name, value) {
    var id = this._id;
    name += "";
    if (arguments.length < 2) {
        var tween = (0, $b5673d202c1a718d$export$3988ae62b71be9a3)(this.node(), id).tween;
        for(var i = 0, n = tween.length, t; i < n; ++i){
            if ((t = tween[i]).name === name) return t.value;
        }
        return null;
    }
    return this.each((value == null ? $2b846766134b1951$var$tweenRemove : $2b846766134b1951$var$tweenFunction)(id, name, value));
}
function $2b846766134b1951$export$f78ce6ab10405d82(transition, name, value) {
    var id = transition._id;
    transition.each(function() {
        var schedule = (0, $b5673d202c1a718d$export$adaa4cf7ef1b65be)(this, id);
        (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
    });
    return function(node) {
        return (0, $b5673d202c1a718d$export$3988ae62b71be9a3)(node, id).value[name];
    };
}



var $9eF39 = parcelRequire("9eF39");

function $1d03f40d2ee03a56$export$2e2bcd8739ae039(a, b) {
    var c;
    return (typeof b === "number" ? (0, $4a087d8646486986$export$2e2bcd8739ae039) : b instanceof (0, $9eF39.default) ? (0, $c99ed0dd240dae7d$export$2e2bcd8739ae039) : (c = (0, $9eF39.default)(b)) ? (b = c, $c99ed0dd240dae7d$export$2e2bcd8739ae039) : (0, $256699786eb44963$export$2e2bcd8739ae039))(a, b);
}


function $fa11014bc225ccbd$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $fa11014bc225ccbd$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $fa11014bc225ccbd$var$attrConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttribute(name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $fa11014bc225ccbd$var$attrConstantNS(fullname, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttributeNS(fullname.space, fullname.local);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $fa11014bc225ccbd$var$attrFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttribute(name);
        string0 = this.getAttribute(name);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $fa11014bc225ccbd$var$attrFunctionNS(fullname, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
        string0 = this.getAttributeNS(fullname.space, fullname.local);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $fa11014bc225ccbd$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $58b58edfe5dae49c$export$2e2bcd8739ae039)(name), i = fullname === "transform" ? (0, $58d4bff51a6cd97b$export$da8cba906d64c082) : (0, $1d03f40d2ee03a56$export$2e2bcd8739ae039);
    return this.attrTween(name, typeof value === "function" ? (fullname.local ? $fa11014bc225ccbd$var$attrFunctionNS : $fa11014bc225ccbd$var$attrFunction)(fullname, i, (0, $2b846766134b1951$export$f78ce6ab10405d82)(this, "attr." + name, value)) : value == null ? (fullname.local ? $fa11014bc225ccbd$var$attrRemoveNS : $fa11014bc225ccbd$var$attrRemove)(fullname) : (fullname.local ? $fa11014bc225ccbd$var$attrConstantNS : $fa11014bc225ccbd$var$attrConstant)(fullname, i, value));
}



function $89c852aaf0ffbd98$var$attrInterpolate(name, i) {
    return function(t) {
        this.setAttribute(name, i.call(this, t));
    };
}
function $89c852aaf0ffbd98$var$attrInterpolateNS(fullname, i) {
    return function(t) {
        this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
    };
}
function $89c852aaf0ffbd98$var$attrTweenNS(fullname, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $89c852aaf0ffbd98$var$attrInterpolateNS(fullname, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $89c852aaf0ffbd98$var$attrTween(name, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $89c852aaf0ffbd98$var$attrInterpolate(name, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $89c852aaf0ffbd98$export$2e2bcd8739ae039(name, value) {
    var key = "attr." + name;
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    var fullname = (0, $58b58edfe5dae49c$export$2e2bcd8739ae039)(name);
    return this.tween(key, (fullname.local ? $89c852aaf0ffbd98$var$attrTweenNS : $89c852aaf0ffbd98$var$attrTween)(fullname, value));
}



function $998317f5aa574ea5$var$delayFunction(id, value) {
    return function() {
        (0, $b5673d202c1a718d$export$2cd8252107eb640b)(this, id).delay = +value.apply(this, arguments);
    };
}
function $998317f5aa574ea5$var$delayConstant(id, value) {
    return value = +value, function() {
        (0, $b5673d202c1a718d$export$2cd8252107eb640b)(this, id).delay = value;
    };
}
function $998317f5aa574ea5$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $998317f5aa574ea5$var$delayFunction : $998317f5aa574ea5$var$delayConstant)(id, value)) : (0, $b5673d202c1a718d$export$3988ae62b71be9a3)(this.node(), id).delay;
}



function $fb064aa40c04a3a9$var$durationFunction(id, value) {
    return function() {
        (0, $b5673d202c1a718d$export$adaa4cf7ef1b65be)(this, id).duration = +value.apply(this, arguments);
    };
}
function $fb064aa40c04a3a9$var$durationConstant(id, value) {
    return value = +value, function() {
        (0, $b5673d202c1a718d$export$adaa4cf7ef1b65be)(this, id).duration = value;
    };
}
function $fb064aa40c04a3a9$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $fb064aa40c04a3a9$var$durationFunction : $fb064aa40c04a3a9$var$durationConstant)(id, value)) : (0, $b5673d202c1a718d$export$3988ae62b71be9a3)(this.node(), id).duration;
}



function $3b84501e3f09c967$var$easeConstant(id, value) {
    if (typeof value !== "function") throw new Error;
    return function() {
        (0, $b5673d202c1a718d$export$adaa4cf7ef1b65be)(this, id).ease = value;
    };
}
function $3b84501e3f09c967$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each($3b84501e3f09c967$var$easeConstant(id, value)) : (0, $b5673d202c1a718d$export$3988ae62b71be9a3)(this.node(), id).ease;
}



function $5d52f5c2bc33bebb$var$easeVarying(id, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (typeof v !== "function") throw new Error;
        (0, $b5673d202c1a718d$export$adaa4cf7ef1b65be)(this, id).ease = v;
    };
}
function $5d52f5c2bc33bebb$export$2e2bcd8739ae039(value) {
    if (typeof value !== "function") throw new Error;
    return this.each($5d52f5c2bc33bebb$var$easeVarying(this._id, value));
}




function $be9cef0700338389$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $9217c1f6bb2d2b85$export$2e2bcd8739ae039)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $f4875d2c4bb511a9$export$be58926105124dd4)(subgroups, this._parents, this._name, this._id);
}



function $612e64afad319e12$export$2e2bcd8739ae039(transition) {
    if (transition._id !== this._id) throw new Error;
    for(var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $f4875d2c4bb511a9$export$be58926105124dd4)(merges, this._parents, this._name, this._id);
}



function $43adaf0311e82f05$var$start(name) {
    return (name + "").trim().split(/^|\s+/).every(function(t) {
        var i = t.indexOf(".");
        if (i >= 0) t = t.slice(0, i);
        return !t || t === "start";
    });
}
function $43adaf0311e82f05$var$onFunction(id, name, listener) {
    var on0, on1, sit = $43adaf0311e82f05$var$start(name) ? (0, $b5673d202c1a718d$export$2cd8252107eb640b) : (0, $b5673d202c1a718d$export$adaa4cf7ef1b65be);
    return function() {
        var schedule = sit(this, id), on = schedule.on;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
        schedule.on = on1;
    };
}
function $43adaf0311e82f05$export$2e2bcd8739ae039(name, listener) {
    var id = this._id;
    return arguments.length < 2 ? (0, $b5673d202c1a718d$export$3988ae62b71be9a3)(this.node(), id).on.on(name) : this.each($43adaf0311e82f05$var$onFunction(id, name, listener));
}


function $d081c5c9ee67d011$var$removeFunction(id) {
    return function() {
        var parent = this.parentNode;
        for(var i in this.__transition)if (+i !== id) return;
        if (parent) parent.removeChild(this);
    };
}
function $d081c5c9ee67d011$export$2e2bcd8739ae039() {
    return this.on("end.remove", $d081c5c9ee67d011$var$removeFunction(this._id));
}





function $33c939ab69fb50d4$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $a696f7efe74d657f$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
            (0, $b5673d202c1a718d$export$2e2bcd8739ae039)(subgroup[i], name, id, i, subgroup, (0, $b5673d202c1a718d$export$3988ae62b71be9a3)(node, id));
        }
    }
    return new (0, $f4875d2c4bb511a9$export$be58926105124dd4)(subgroups, this._parents, name, id);
}





function $5accf6381f758c01$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $a251e86126c3c196$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            for(var children = select.call(node, node.__data__, i, group), child, inherit = (0, $b5673d202c1a718d$export$3988ae62b71be9a3)(node, id), k = 0, l = children.length; k < l; ++k)if (child = children[k]) (0, $b5673d202c1a718d$export$2e2bcd8739ae039)(child, name, id, k, children, inherit);
            subgroups.push(children);
            parents.push(node);
        }
    }
    return new (0, $f4875d2c4bb511a9$export$be58926105124dd4)(subgroups, parents, name, id);
}



var $7a60ab3f6361005a$var$Selection = (0, $3fa3bddc94b4f8a8$export$2e2bcd8739ae039).prototype.constructor;
function $7a60ab3f6361005a$export$2e2bcd8739ae039() {
    return new $7a60ab3f6361005a$var$Selection(this._groups, this._parents);
}







function $406987af83016736$var$styleNull(name, interpolate) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $df9d8f43b4be6d4b$export$5e3cec964f0b5efd)(this, name), string1 = (this.style.removeProperty(name), (0, $df9d8f43b4be6d4b$export$5e3cec964f0b5efd)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate(string00 = string0, string10 = string1);
    };
}
function $406987af83016736$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $406987af83016736$var$styleConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = (0, $df9d8f43b4be6d4b$export$5e3cec964f0b5efd)(this, name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $406987af83016736$var$styleFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $df9d8f43b4be6d4b$export$5e3cec964f0b5efd)(this, name), value1 = value(this), string1 = value1 + "";
        if (value1 == null) string1 = value1 = (this.style.removeProperty(name), (0, $df9d8f43b4be6d4b$export$5e3cec964f0b5efd)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $406987af83016736$var$styleMaybeRemove(id, name) {
    var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
    return function() {
        var schedule = (0, $b5673d202c1a718d$export$adaa4cf7ef1b65be)(this, id), on = schedule.on, listener = schedule.value[key] == null ? remove || (remove = $406987af83016736$var$styleRemove(name)) : undefined;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);
        schedule.on = on1;
    };
}
function $406987af83016736$export$2e2bcd8739ae039(name, value, priority) {
    var i = (name += "") === "transform" ? (0, $58d4bff51a6cd97b$export$56bec7123bb3589a) : (0, $1d03f40d2ee03a56$export$2e2bcd8739ae039);
    return value == null ? this.styleTween(name, $406987af83016736$var$styleNull(name, i)).on("end.style." + name, $406987af83016736$var$styleRemove(name)) : typeof value === "function" ? this.styleTween(name, $406987af83016736$var$styleFunction(name, i, (0, $2b846766134b1951$export$f78ce6ab10405d82)(this, "style." + name, value))).each($406987af83016736$var$styleMaybeRemove(this._id, name)) : this.styleTween(name, $406987af83016736$var$styleConstant(name, i, value), priority).on("end.style." + name, null);
}


function $084d18b0ed660f1f$var$styleInterpolate(name, i, priority) {
    return function(t) {
        this.style.setProperty(name, i.call(this, t), priority);
    };
}
function $084d18b0ed660f1f$var$styleTween(name, value, priority) {
    var t, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t = (i0 = i) && $084d18b0ed660f1f$var$styleInterpolate(name, i, priority);
        return t;
    }
    tween._value = value;
    return tween;
}
function $084d18b0ed660f1f$export$2e2bcd8739ae039(name, value, priority) {
    var key = "style." + (name += "");
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $084d18b0ed660f1f$var$styleTween(name, value, priority == null ? "" : priority));
}



function $77d3177f82afb684$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $77d3177f82afb684$var$textFunction(value) {
    return function() {
        var value1 = value(this);
        this.textContent = value1 == null ? "" : value1;
    };
}
function $77d3177f82afb684$export$2e2bcd8739ae039(value) {
    return this.tween("text", typeof value === "function" ? $77d3177f82afb684$var$textFunction((0, $2b846766134b1951$export$f78ce6ab10405d82)(this, "text", value)) : $77d3177f82afb684$var$textConstant(value == null ? "" : value + ""));
}


function $2281728614db71a0$var$textInterpolate(i) {
    return function(t) {
        this.textContent = i.call(this, t);
    };
}
function $2281728614db71a0$var$textTween(value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $2281728614db71a0$var$textInterpolate(i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $2281728614db71a0$export$2e2bcd8739ae039(value) {
    var key = "text";
    if (arguments.length < 1) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $2281728614db71a0$var$textTween(value));
}




function $5075f917ce7577c6$export$2e2bcd8739ae039() {
    var name = this._name, id0 = this._id, id1 = (0, $f4875d2c4bb511a9$export$9ffd10a3fbdc175b)();
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            var inherit = (0, $b5673d202c1a718d$export$3988ae62b71be9a3)(node, id0);
            (0, $b5673d202c1a718d$export$2e2bcd8739ae039)(node, name, id1, i, group, {
                time: inherit.time + inherit.delay + inherit.duration,
                delay: 0,
                duration: inherit.duration,
                ease: inherit.ease
            });
        }
    }
    return new (0, $f4875d2c4bb511a9$export$be58926105124dd4)(groups, this._parents, name, id1);
}




function $3a3e51e88d3fd2e7$export$2e2bcd8739ae039() {
    var on0, on1, that = this, id = that._id, size = that.size();
    return new Promise(function(resolve, reject) {
        var cancel = {
            value: reject
        }, end = {
            value: function() {
                if (--size === 0) resolve();
            }
        };
        that.each(function() {
            var schedule = (0, $b5673d202c1a718d$export$adaa4cf7ef1b65be)(this, id), on = schedule.on;
            // If this node shared a dispatch with the previous node,
            // just assign the updated shared dispatch and we’re done!
            // Otherwise, copy-on-write.
            if (on !== on0) {
                on1 = (on0 = on).copy();
                on1._.cancel.push(cancel);
                on1._.interrupt.push(cancel);
                on1._.end.push(end);
            }
            schedule.on = on1;
        });
        // The selection was empty, resolve end immediately
        if (size === 0) resolve();
    });
}


var $f4875d2c4bb511a9$var$id = 0;
function $f4875d2c4bb511a9$export$be58926105124dd4(groups, parents, name, id) {
    this._groups = groups;
    this._parents = parents;
    this._name = name;
    this._id = id;
}
function $f4875d2c4bb511a9$export$2e2bcd8739ae039(name) {
    return (0, $3fa3bddc94b4f8a8$export$2e2bcd8739ae039)().transition(name);
}
function $f4875d2c4bb511a9$export$9ffd10a3fbdc175b() {
    return ++$f4875d2c4bb511a9$var$id;
}
var $f4875d2c4bb511a9$var$selection_prototype = (0, $3fa3bddc94b4f8a8$export$2e2bcd8739ae039).prototype;
$f4875d2c4bb511a9$export$be58926105124dd4.prototype = $f4875d2c4bb511a9$export$2e2bcd8739ae039.prototype = {
    constructor: $f4875d2c4bb511a9$export$be58926105124dd4,
    select: (0, $33c939ab69fb50d4$export$2e2bcd8739ae039),
    selectAll: (0, $5accf6381f758c01$export$2e2bcd8739ae039),
    selectChild: $f4875d2c4bb511a9$var$selection_prototype.selectChild,
    selectChildren: $f4875d2c4bb511a9$var$selection_prototype.selectChildren,
    filter: (0, $be9cef0700338389$export$2e2bcd8739ae039),
    merge: (0, $612e64afad319e12$export$2e2bcd8739ae039),
    selection: (0, $7a60ab3f6361005a$export$2e2bcd8739ae039),
    transition: (0, $5075f917ce7577c6$export$2e2bcd8739ae039),
    call: $f4875d2c4bb511a9$var$selection_prototype.call,
    nodes: $f4875d2c4bb511a9$var$selection_prototype.nodes,
    node: $f4875d2c4bb511a9$var$selection_prototype.node,
    size: $f4875d2c4bb511a9$var$selection_prototype.size,
    empty: $f4875d2c4bb511a9$var$selection_prototype.empty,
    each: $f4875d2c4bb511a9$var$selection_prototype.each,
    on: (0, $43adaf0311e82f05$export$2e2bcd8739ae039),
    attr: (0, $fa11014bc225ccbd$export$2e2bcd8739ae039),
    attrTween: (0, $89c852aaf0ffbd98$export$2e2bcd8739ae039),
    style: (0, $406987af83016736$export$2e2bcd8739ae039),
    styleTween: (0, $084d18b0ed660f1f$export$2e2bcd8739ae039),
    text: (0, $77d3177f82afb684$export$2e2bcd8739ae039),
    textTween: (0, $2281728614db71a0$export$2e2bcd8739ae039),
    remove: (0, $d081c5c9ee67d011$export$2e2bcd8739ae039),
    tween: (0, $2b846766134b1951$export$2e2bcd8739ae039),
    delay: (0, $998317f5aa574ea5$export$2e2bcd8739ae039),
    duration: (0, $fb064aa40c04a3a9$export$2e2bcd8739ae039),
    ease: (0, $3b84501e3f09c967$export$2e2bcd8739ae039),
    easeVarying: (0, $5d52f5c2bc33bebb$export$2e2bcd8739ae039),
    end: (0, $3a3e51e88d3fd2e7$export$2e2bcd8739ae039),
    [Symbol.iterator]: $f4875d2c4bb511a9$var$selection_prototype[Symbol.iterator]
};



function $9b730ba464200928$export$b1a09cb1b71f86aa(t) {
    return t * t * t;
}
function $9b730ba464200928$export$68d528839c701b6(t) {
    return --t * t * t + 1;
}
function $9b730ba464200928$export$89238d3bc79d3ada(t) {
    return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}



var $091a2eb19c9bc49f$var$defaultTiming = {
    time: null,
    delay: 0,
    duration: 250,
    ease: (0, $9b730ba464200928$export$89238d3bc79d3ada)
};
function $091a2eb19c9bc49f$var$inherit(node, id) {
    var timing;
    while(!(timing = node.__transition) || !(timing = timing[id])){
        if (!(node = node.parentNode)) throw new Error(`transition ${id} not found`);
    }
    return timing;
}
function $091a2eb19c9bc49f$export$2e2bcd8739ae039(name) {
    var id, timing;
    if (name instanceof (0, $f4875d2c4bb511a9$export$be58926105124dd4)) id = name._id, name = name._name;
    else id = (0, $f4875d2c4bb511a9$export$9ffd10a3fbdc175b)(), (timing = $091a2eb19c9bc49f$var$defaultTiming).time = (0, $0830f34b180fabe6$export$461939dd4422153)(), name = name == null ? null : name + "";
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) (0, $b5673d202c1a718d$export$2e2bcd8739ae039)(node, name, id, i, group, timing || $091a2eb19c9bc49f$var$inherit(node, id));
    }
    return new (0, $f4875d2c4bb511a9$export$be58926105124dd4)(groups, this._parents, name, id);
}


(0, $3fa3bddc94b4f8a8$export$2e2bcd8739ae039).prototype.interrupt = (0, $1edbe92636db4b14$export$2e2bcd8739ae039);
(0, $3fa3bddc94b4f8a8$export$2e2bcd8739ae039).prototype.transition = (0, $091a2eb19c9bc49f$export$2e2bcd8739ae039);







var $778de0494e50ca37$export$2e2bcd8739ae039 = (x)=>()=>x;


function $6364eea05eaaf9a1$export$2e2bcd8739ae039(type, { sourceEvent: sourceEvent, target: target, selection: selection, mode: mode, dispatch: dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        selection: {
            value: selection,
            enumerable: true,
            configurable: true
        },
        mode: {
            value: mode,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}


function $f663d3f9720c3b93$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $f663d3f9720c3b93$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}


var $08836f1eb7bc5d70$var$MODE_DRAG = {
    name: "drag"
}, $08836f1eb7bc5d70$var$MODE_SPACE = {
    name: "space"
}, $08836f1eb7bc5d70$var$MODE_HANDLE = {
    name: "handle"
}, $08836f1eb7bc5d70$var$MODE_CENTER = {
    name: "center"
};
const { abs: $08836f1eb7bc5d70$var$abs, max: $08836f1eb7bc5d70$var$max, min: $08836f1eb7bc5d70$var$min } = Math;
function $08836f1eb7bc5d70$var$number1(e) {
    return [
        +e[0],
        +e[1]
    ];
}
function $08836f1eb7bc5d70$var$number2(e) {
    return [
        $08836f1eb7bc5d70$var$number1(e[0]),
        $08836f1eb7bc5d70$var$number1(e[1])
    ];
}
var $08836f1eb7bc5d70$var$X = {
    name: "x",
    handles: [
        "w",
        "e"
    ].map($08836f1eb7bc5d70$var$type),
    input: function(x, e) {
        return x == null ? null : [
            [
                +x[0],
                e[0][1]
            ],
            [
                +x[1],
                e[1][1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][0],
            xy[1][0]
        ];
    }
};
var $08836f1eb7bc5d70$var$Y = {
    name: "y",
    handles: [
        "n",
        "s"
    ].map($08836f1eb7bc5d70$var$type),
    input: function(y, e) {
        return y == null ? null : [
            [
                e[0][0],
                +y[0]
            ],
            [
                e[1][0],
                +y[1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][1],
            xy[1][1]
        ];
    }
};
var $08836f1eb7bc5d70$var$XY = {
    name: "xy",
    handles: [
        "n",
        "w",
        "e",
        "s",
        "nw",
        "ne",
        "sw",
        "se"
    ].map($08836f1eb7bc5d70$var$type),
    input: function(xy) {
        return xy == null ? null : $08836f1eb7bc5d70$var$number2(xy);
    },
    output: function(xy) {
        return xy;
    }
};
var $08836f1eb7bc5d70$var$cursors = {
    overlay: "crosshair",
    selection: "move",
    n: "ns-resize",
    e: "ew-resize",
    s: "ns-resize",
    w: "ew-resize",
    nw: "nwse-resize",
    ne: "nesw-resize",
    se: "nwse-resize",
    sw: "nesw-resize"
};
var $08836f1eb7bc5d70$var$flipX = {
    e: "w",
    w: "e",
    nw: "ne",
    ne: "nw",
    se: "sw",
    sw: "se"
};
var $08836f1eb7bc5d70$var$flipY = {
    n: "s",
    s: "n",
    nw: "sw",
    ne: "se",
    se: "ne",
    sw: "nw"
};
var $08836f1eb7bc5d70$var$signsX = {
    overlay: 1,
    selection: 1,
    n: null,
    e: 1,
    s: null,
    w: -1,
    nw: -1,
    ne: 1,
    se: 1,
    sw: -1
};
var $08836f1eb7bc5d70$var$signsY = {
    overlay: 1,
    selection: 1,
    n: -1,
    e: null,
    s: 1,
    w: null,
    nw: -1,
    ne: -1,
    se: 1,
    sw: 1
};
function $08836f1eb7bc5d70$var$type(t) {
    return {
        type: t
    };
}
// Ignore right-click, since that should open the context menu.
function $08836f1eb7bc5d70$var$defaultFilter(event) {
    return !event.ctrlKey && !event.button;
}
function $08836f1eb7bc5d70$var$defaultExtent() {
    var svg = this.ownerSVGElement || this;
    if (svg.hasAttribute("viewBox")) {
        svg = svg.viewBox.baseVal;
        return [
            [
                svg.x,
                svg.y
            ],
            [
                svg.x + svg.width,
                svg.y + svg.height
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            svg.width.baseVal.value,
            svg.height.baseVal.value
        ]
    ];
}
function $08836f1eb7bc5d70$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
// Like d3.local, but with the name “__brush” rather than auto-generated.
function $08836f1eb7bc5d70$var$local(node) {
    while(!node.__brush)if (!(node = node.parentNode)) return;
    return node.__brush;
}
function $08836f1eb7bc5d70$var$empty(extent) {
    return extent[0][0] === extent[1][0] || extent[0][1] === extent[1][1];
}
function $08836f1eb7bc5d70$export$69760394fc76f689(node) {
    var state = node.__brush;
    return state ? state.dim.output(state.selection) : null;
}
function $08836f1eb7bc5d70$export$979ace6c88860aa8() {
    return $08836f1eb7bc5d70$var$brush($08836f1eb7bc5d70$var$X);
}
function $08836f1eb7bc5d70$export$468748b530991c54() {
    return $08836f1eb7bc5d70$var$brush($08836f1eb7bc5d70$var$Y);
}
function $08836f1eb7bc5d70$export$2e2bcd8739ae039() {
    return $08836f1eb7bc5d70$var$brush($08836f1eb7bc5d70$var$XY);
}
function $08836f1eb7bc5d70$var$brush(dim) {
    var extent = $08836f1eb7bc5d70$var$defaultExtent, filter = $08836f1eb7bc5d70$var$defaultFilter, touchable = $08836f1eb7bc5d70$var$defaultTouchable, keys = true, listeners = (0, $f22df01f36f3bbc5$export$2e2bcd8739ae039)("start", "brush", "end"), handleSize = 6, touchending;
    function brush(group) {
        var overlay = group.property("__brush", initialize).selectAll(".overlay").data([
            $08836f1eb7bc5d70$var$type("overlay")
        ]);
        overlay.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", $08836f1eb7bc5d70$var$cursors.overlay).merge(overlay).each(function() {
            var extent = $08836f1eb7bc5d70$var$local(this).extent;
            (0, $4506c173c1ba6b79$export$2e2bcd8739ae039)(this).attr("x", extent[0][0]).attr("y", extent[0][1]).attr("width", extent[1][0] - extent[0][0]).attr("height", extent[1][1] - extent[0][1]);
        });
        group.selectAll(".selection").data([
            $08836f1eb7bc5d70$var$type("selection")
        ]).enter().append("rect").attr("class", "selection").attr("cursor", $08836f1eb7bc5d70$var$cursors.selection).attr("fill", "#777").attr("fill-opacity", 0.3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
        var handle = group.selectAll(".handle").data(dim.handles, function(d) {
            return d.type;
        });
        handle.exit().remove();
        handle.enter().append("rect").attr("class", function(d) {
            return "handle handle--" + d.type;
        }).attr("cursor", function(d) {
            return $08836f1eb7bc5d70$var$cursors[d.type];
        });
        group.each(redraw).attr("fill", "none").attr("pointer-events", "all").on("mousedown.brush", started).filter(touchable).on("touchstart.brush", started).on("touchmove.brush", touchmoved).on("touchend.brush touchcancel.brush", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    brush.move = function(group, selection, event) {
        if (group.tween) group.on("start.brush", function(event) {
            emitter(this, arguments).beforestart().start(event);
        }).on("interrupt.brush end.brush", function(event) {
            emitter(this, arguments).end(event);
        }).tween("brush", function() {
            var that = this, state = that.__brush, emit = emitter(that, arguments), selection0 = state.selection, selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent), i = (0, $0a6b21d627aa3b76$export$2e2bcd8739ae039)(selection0, selection1);
            function tween(t) {
                state.selection = t === 1 && selection1 === null ? null : i(t);
                redraw.call(that);
                emit.brush();
            }
            return selection0 !== null && selection1 !== null ? tween : tween(1);
        });
        else group.each(function() {
            var that = this, args = arguments, state = that.__brush, selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent), emit = emitter(that, args).beforestart();
            (0, $a9f60c0c7972321a$export$2e2bcd8739ae039)(that);
            state.selection = selection1 === null ? null : selection1;
            redraw.call(that);
            emit.start(event).brush(event).end(event);
        });
    };
    brush.clear = function(group, event) {
        brush.move(group, null, event);
    };
    function redraw() {
        var group = (0, $4506c173c1ba6b79$export$2e2bcd8739ae039)(this), selection = $08836f1eb7bc5d70$var$local(this).selection;
        if (selection) {
            group.selectAll(".selection").style("display", null).attr("x", selection[0][0]).attr("y", selection[0][1]).attr("width", selection[1][0] - selection[0][0]).attr("height", selection[1][1] - selection[0][1]);
            group.selectAll(".handle").style("display", null).attr("x", function(d) {
                return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2;
            }).attr("y", function(d) {
                return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2;
            }).attr("width", function(d) {
                return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize;
            }).attr("height", function(d) {
                return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize;
            });
        } else group.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
    }
    function emitter(that, args, clean) {
        var emit = that.__brush.emitter;
        return emit && (!clean || !emit.clean) ? emit : new Emitter(that, args, clean);
    }
    function Emitter(that, args, clean) {
        this.that = that;
        this.args = args;
        this.state = that.__brush;
        this.active = 0;
        this.clean = clean;
    }
    Emitter.prototype = {
        beforestart: function() {
            if (++this.active === 1) this.state.emitter = this, this.starting = true;
            return this;
        },
        start: function(event, mode) {
            if (this.starting) this.starting = false, this.emit("start", event, mode);
            else this.emit("brush", event);
            return this;
        },
        brush: function(event, mode) {
            this.emit("brush", event, mode);
            return this;
        },
        end: function(event, mode) {
            if (--this.active === 0) delete this.state.emitter, this.emit("end", event, mode);
            return this;
        },
        emit: function(type, event, mode) {
            var d = (0, $4506c173c1ba6b79$export$2e2bcd8739ae039)(this.that).datum();
            listeners.call(type, this.that, new (0, $6364eea05eaaf9a1$export$2e2bcd8739ae039)(type, {
                sourceEvent: event,
                target: brush,
                selection: dim.output(this.state.selection),
                mode: mode,
                dispatch: listeners
            }), d);
        }
    };
    function started(event) {
        if (touchending && !event.touches) return;
        if (!filter.apply(this, arguments)) return;
        var that = this, type = event.target.__data__.type, mode = (keys && event.metaKey ? type = "overlay" : type) === "selection" ? $08836f1eb7bc5d70$var$MODE_DRAG : keys && event.altKey ? $08836f1eb7bc5d70$var$MODE_CENTER : $08836f1eb7bc5d70$var$MODE_HANDLE, signX = dim === $08836f1eb7bc5d70$var$Y ? null : $08836f1eb7bc5d70$var$signsX[type], signY = dim === $08836f1eb7bc5d70$var$X ? null : $08836f1eb7bc5d70$var$signsY[type], state = $08836f1eb7bc5d70$var$local(that), extent = state.extent, selection = state.selection, W = extent[0][0], w0, w1, N = extent[0][1], n0, n1, E = extent[1][0], e0, e1, S = extent[1][1], s0, s1, dx = 0, dy = 0, moving, shifting = signX && signY && keys && event.shiftKey, lockX, lockY, points = Array.from(event.touches || [
            event
        ], (t)=>{
            const i = t.identifier;
            t = (0, $7edc954089de14ac$export$2e2bcd8739ae039)(t, that);
            t.point0 = t.slice();
            t.identifier = i;
            return t;
        });
        (0, $a9f60c0c7972321a$export$2e2bcd8739ae039)(that);
        var emit = emitter(that, arguments, true).beforestart();
        if (type === "overlay") {
            if (selection) moving = true;
            const pts = [
                points[0],
                points[1] || points[0]
            ];
            state.selection = selection = [
                [
                    w0 = dim === $08836f1eb7bc5d70$var$Y ? W : $08836f1eb7bc5d70$var$min(pts[0][0], pts[1][0]),
                    n0 = dim === $08836f1eb7bc5d70$var$X ? N : $08836f1eb7bc5d70$var$min(pts[0][1], pts[1][1])
                ],
                [
                    e0 = dim === $08836f1eb7bc5d70$var$Y ? E : $08836f1eb7bc5d70$var$max(pts[0][0], pts[1][0]),
                    s0 = dim === $08836f1eb7bc5d70$var$X ? S : $08836f1eb7bc5d70$var$max(pts[0][1], pts[1][1])
                ]
            ];
            if (points.length > 1) move(event);
        } else {
            w0 = selection[0][0];
            n0 = selection[0][1];
            e0 = selection[1][0];
            s0 = selection[1][1];
        }
        w1 = w0;
        n1 = n0;
        e1 = e0;
        s1 = s0;
        var group = (0, $4506c173c1ba6b79$export$2e2bcd8739ae039)(that).attr("pointer-events", "none");
        var overlay = group.selectAll(".overlay").attr("cursor", $08836f1eb7bc5d70$var$cursors[type]);
        if (event.touches) {
            emit.moved = moved;
            emit.ended = ended;
        } else {
            var view = (0, $4506c173c1ba6b79$export$2e2bcd8739ae039)(event.view).on("mousemove.brush", moved, true).on("mouseup.brush", ended, true);
            if (keys) view.on("keydown.brush", keydowned, true).on("keyup.brush", keyupped, true);
            (0, $ae3cd07c3e922ae3$export$2e2bcd8739ae039)(event.view);
        }
        redraw.call(that);
        emit.start(event, mode.name);
        function moved(event) {
            for (const p of event.changedTouches || [
                event
            ]){
                for (const d of points)if (d.identifier === p.identifier) d.cur = (0, $7edc954089de14ac$export$2e2bcd8739ae039)(p, that);
            }
            if (shifting && !lockX && !lockY && points.length === 1) {
                const point = points[0];
                if ($08836f1eb7bc5d70$var$abs(point.cur[0] - point[0]) > $08836f1eb7bc5d70$var$abs(point.cur[1] - point[1])) lockY = true;
                else lockX = true;
            }
            for (const point of points)if (point.cur) point[0] = point.cur[0], point[1] = point.cur[1];
            moving = true;
            (0, $f663d3f9720c3b93$export$2e2bcd8739ae039)(event);
            move(event);
        }
        function move(event) {
            const point = points[0], point0 = point.point0;
            var t;
            dx = point[0] - point0[0];
            dy = point[1] - point0[1];
            switch(mode){
                case $08836f1eb7bc5d70$var$MODE_SPACE:
                case $08836f1eb7bc5d70$var$MODE_DRAG:
                    if (signX) dx = $08836f1eb7bc5d70$var$max(W - w0, $08836f1eb7bc5d70$var$min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
                    if (signY) dy = $08836f1eb7bc5d70$var$max(N - n0, $08836f1eb7bc5d70$var$min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
                    break;
                case $08836f1eb7bc5d70$var$MODE_HANDLE:
                    if (points[1]) {
                        if (signX) w1 = $08836f1eb7bc5d70$var$max(W, $08836f1eb7bc5d70$var$min(E, points[0][0])), e1 = $08836f1eb7bc5d70$var$max(W, $08836f1eb7bc5d70$var$min(E, points[1][0])), signX = 1;
                        if (signY) n1 = $08836f1eb7bc5d70$var$max(N, $08836f1eb7bc5d70$var$min(S, points[0][1])), s1 = $08836f1eb7bc5d70$var$max(N, $08836f1eb7bc5d70$var$min(S, points[1][1])), signY = 1;
                    } else {
                        if (signX < 0) dx = $08836f1eb7bc5d70$var$max(W - w0, $08836f1eb7bc5d70$var$min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
                        else if (signX > 0) dx = $08836f1eb7bc5d70$var$max(W - e0, $08836f1eb7bc5d70$var$min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
                        if (signY < 0) dy = $08836f1eb7bc5d70$var$max(N - n0, $08836f1eb7bc5d70$var$min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
                        else if (signY > 0) dy = $08836f1eb7bc5d70$var$max(N - s0, $08836f1eb7bc5d70$var$min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
                    }
                    break;
                case $08836f1eb7bc5d70$var$MODE_CENTER:
                    if (signX) w1 = $08836f1eb7bc5d70$var$max(W, $08836f1eb7bc5d70$var$min(E, w0 - dx * signX)), e1 = $08836f1eb7bc5d70$var$max(W, $08836f1eb7bc5d70$var$min(E, e0 + dx * signX));
                    if (signY) n1 = $08836f1eb7bc5d70$var$max(N, $08836f1eb7bc5d70$var$min(S, n0 - dy * signY)), s1 = $08836f1eb7bc5d70$var$max(N, $08836f1eb7bc5d70$var$min(S, s0 + dy * signY));
                    break;
            }
            if (e1 < w1) {
                signX *= -1;
                t = w0, w0 = e0, e0 = t;
                t = w1, w1 = e1, e1 = t;
                if (type in $08836f1eb7bc5d70$var$flipX) overlay.attr("cursor", $08836f1eb7bc5d70$var$cursors[type = $08836f1eb7bc5d70$var$flipX[type]]);
            }
            if (s1 < n1) {
                signY *= -1;
                t = n0, n0 = s0, s0 = t;
                t = n1, n1 = s1, s1 = t;
                if (type in $08836f1eb7bc5d70$var$flipY) overlay.attr("cursor", $08836f1eb7bc5d70$var$cursors[type = $08836f1eb7bc5d70$var$flipY[type]]);
            }
            if (state.selection) selection = state.selection; // May be set by brush.move!
            if (lockX) w1 = selection[0][0], e1 = selection[1][0];
            if (lockY) n1 = selection[0][1], s1 = selection[1][1];
            if (selection[0][0] !== w1 || selection[0][1] !== n1 || selection[1][0] !== e1 || selection[1][1] !== s1) {
                state.selection = [
                    [
                        w1,
                        n1
                    ],
                    [
                        e1,
                        s1
                    ]
                ];
                redraw.call(that);
                emit.brush(event, mode.name);
            }
        }
        function ended(event) {
            (0, $f663d3f9720c3b93$export$2e2561858db9bf47)(event);
            if (event.touches) {
                if (event.touches.length) return;
                if (touchending) clearTimeout(touchending);
                touchending = setTimeout(function() {
                    touchending = null;
                }, 500); // Ghost clicks are delayed!
            } else {
                (0, $ae3cd07c3e922ae3$export$833237748009e1e1)(event.view, moving);
                view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
            }
            group.attr("pointer-events", "all");
            overlay.attr("cursor", $08836f1eb7bc5d70$var$cursors.overlay);
            if (state.selection) selection = state.selection; // May be set by brush.move (on start)!
            if ($08836f1eb7bc5d70$var$empty(selection)) state.selection = null, redraw.call(that);
            emit.end(event, mode.name);
        }
        function keydowned(event) {
            switch(event.keyCode){
                case 16:
                    shifting = signX && signY;
                    break;
                case 18:
                    if (mode === $08836f1eb7bc5d70$var$MODE_HANDLE) {
                        if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                        if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                        mode = $08836f1eb7bc5d70$var$MODE_CENTER;
                        move(event);
                    }
                    break;
                case 32:
                    if (mode === $08836f1eb7bc5d70$var$MODE_HANDLE || mode === $08836f1eb7bc5d70$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1 - dx;
                        else if (signX > 0) w0 = w1 - dx;
                        if (signY < 0) s0 = s1 - dy;
                        else if (signY > 0) n0 = n1 - dy;
                        mode = $08836f1eb7bc5d70$var$MODE_SPACE;
                        overlay.attr("cursor", $08836f1eb7bc5d70$var$cursors.selection);
                        move(event);
                    }
                    break;
                default:
                    return;
            }
            (0, $f663d3f9720c3b93$export$2e2bcd8739ae039)(event);
        }
        function keyupped(event) {
            switch(event.keyCode){
                case 16:
                    if (shifting) {
                        lockX = lockY = shifting = false;
                        move(event);
                    }
                    break;
                case 18:
                    if (mode === $08836f1eb7bc5d70$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1;
                        else if (signX > 0) w0 = w1;
                        if (signY < 0) s0 = s1;
                        else if (signY > 0) n0 = n1;
                        mode = $08836f1eb7bc5d70$var$MODE_HANDLE;
                        move(event);
                    }
                    break;
                case 32:
                    if (mode === $08836f1eb7bc5d70$var$MODE_SPACE) {
                        if (event.altKey) {
                            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                            mode = $08836f1eb7bc5d70$var$MODE_CENTER;
                        } else {
                            if (signX < 0) e0 = e1;
                            else if (signX > 0) w0 = w1;
                            if (signY < 0) s0 = s1;
                            else if (signY > 0) n0 = n1;
                            mode = $08836f1eb7bc5d70$var$MODE_HANDLE;
                        }
                        overlay.attr("cursor", $08836f1eb7bc5d70$var$cursors[type]);
                        move(event);
                    }
                    break;
                default:
                    return;
            }
            (0, $f663d3f9720c3b93$export$2e2bcd8739ae039)(event);
        }
    }
    function touchmoved(event) {
        emitter(this, arguments).moved(event);
    }
    function touchended(event) {
        emitter(this, arguments).ended(event);
    }
    function initialize() {
        var state = this.__brush || {
            selection: null
        };
        state.extent = $08836f1eb7bc5d70$var$number2(extent.apply(this, arguments));
        state.dim = dim;
        return state;
    }
    brush.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $778de0494e50ca37$export$2e2bcd8739ae039)($08836f1eb7bc5d70$var$number2(_)), brush) : extent;
    };
    brush.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $778de0494e50ca37$export$2e2bcd8739ae039)(!!_), brush) : filter;
    };
    brush.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $778de0494e50ca37$export$2e2bcd8739ae039)(!!_), brush) : touchable;
    };
    brush.handleSize = function(_) {
        return arguments.length ? (handleSize = +_, brush) : handleSize;
    };
    brush.keyModifiers = function(_) {
        return arguments.length ? (keys = !!_, brush) : keys;
    };
    brush.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? brush : value;
    };
    return brush;
}













var $3fe12b6f2dbbfcf4$export$2e2bcd8739ae039 = (x)=>()=>x;


function $9c40054296ced1ac$export$2e2bcd8739ae039(type, { sourceEvent: sourceEvent, subject: subject, target: target, identifier: identifier, active: active, x: x, y: y, dx: dx, dy: dy, dispatch: dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        subject: {
            value: subject,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        identifier: {
            value: identifier,
            enumerable: true,
            configurable: true
        },
        active: {
            value: active,
            enumerable: true,
            configurable: true
        },
        x: {
            value: x,
            enumerable: true,
            configurable: true
        },
        y: {
            value: y,
            enumerable: true,
            configurable: true
        },
        dx: {
            value: dx,
            enumerable: true,
            configurable: true
        },
        dy: {
            value: dy,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}
$9c40054296ced1ac$export$2e2bcd8739ae039.prototype.on = function() {
    var value = this._.on.apply(this._, arguments);
    return value === this._ ? this : value;
};


// Ignore right-click, since that should open the context menu.
function $c21609f852d50cdc$var$defaultFilter(event) {
    return !event.ctrlKey && !event.button;
}
function $c21609f852d50cdc$var$defaultContainer() {
    return this.parentNode;
}
function $c21609f852d50cdc$var$defaultSubject(event, d) {
    return d == null ? {
        x: event.x,
        y: event.y
    } : d;
}
function $c21609f852d50cdc$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
function $c21609f852d50cdc$export$2e2bcd8739ae039() {
    var filter = $c21609f852d50cdc$var$defaultFilter, container = $c21609f852d50cdc$var$defaultContainer, subject = $c21609f852d50cdc$var$defaultSubject, touchable = $c21609f852d50cdc$var$defaultTouchable, gestures = {}, listeners = (0, $f22df01f36f3bbc5$export$2e2bcd8739ae039)("start", "drag", "end"), active = 0, mousedownx, mousedowny, mousemoving, touchending, clickDistance2 = 0;
    function drag(selection) {
        selection.on("mousedown.drag", mousedowned).filter(touchable).on("touchstart.drag", touchstarted).on("touchmove.drag", touchmoved, (0, $19c289642832a009$export$524615cd03e458cc)).on("touchend.drag touchcancel.drag", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    function mousedowned(event, d) {
        if (touchending || !filter.call(this, event, d)) return;
        var gesture = beforestart(this, container.call(this, event, d), event, d, "mouse");
        if (!gesture) return;
        (0, $4506c173c1ba6b79$export$2e2bcd8739ae039)(event.view).on("mousemove.drag", mousemoved, (0, $19c289642832a009$export$35431a0e47022de1)).on("mouseup.drag", mouseupped, (0, $19c289642832a009$export$35431a0e47022de1));
        (0, $ae3cd07c3e922ae3$export$2e2bcd8739ae039)(event.view);
        (0, $19c289642832a009$export$2e2561858db9bf47)(event);
        mousemoving = false;
        mousedownx = event.clientX;
        mousedowny = event.clientY;
        gesture("start", event);
    }
    function mousemoved(event) {
        (0, $19c289642832a009$export$2e2bcd8739ae039)(event);
        if (!mousemoving) {
            var dx = event.clientX - mousedownx, dy = event.clientY - mousedowny;
            mousemoving = dx * dx + dy * dy > clickDistance2;
        }
        gestures.mouse("drag", event);
    }
    function mouseupped(event) {
        (0, $4506c173c1ba6b79$export$2e2bcd8739ae039)(event.view).on("mousemove.drag mouseup.drag", null);
        (0, $ae3cd07c3e922ae3$export$833237748009e1e1)(event.view, mousemoving);
        (0, $19c289642832a009$export$2e2bcd8739ae039)(event);
        gestures.mouse("end", event);
    }
    function touchstarted(event, d) {
        if (!filter.call(this, event, d)) return;
        var touches = event.changedTouches, c = container.call(this, event, d), n = touches.length, i, gesture;
        for(i = 0; i < n; ++i)if (gesture = beforestart(this, c, event, d, touches[i].identifier, touches[i])) {
            (0, $19c289642832a009$export$2e2561858db9bf47)(event);
            gesture("start", event, touches[i]);
        }
    }
    function touchmoved(event) {
        var touches = event.changedTouches, n = touches.length, i, gesture;
        for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
            (0, $19c289642832a009$export$2e2bcd8739ae039)(event);
            gesture("drag", event, touches[i]);
        }
    }
    function touchended(event) {
        var touches = event.changedTouches, n = touches.length, i, gesture;
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() {
            touchending = null;
        }, 500); // Ghost clicks are delayed!
        for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
            (0, $19c289642832a009$export$2e2561858db9bf47)(event);
            gesture("end", event, touches[i]);
        }
    }
    function beforestart(that, container, event, d, identifier, touch) {
        var dispatch = listeners.copy(), p = (0, $7edc954089de14ac$export$2e2bcd8739ae039)(touch || event, container), dx, dy, s;
        if ((s = subject.call(that, new (0, $9c40054296ced1ac$export$2e2bcd8739ae039)("beforestart", {
            sourceEvent: event,
            target: drag,
            identifier: identifier,
            active: active,
            x: p[0],
            y: p[1],
            dx: 0,
            dy: 0,
            dispatch: dispatch
        }), d)) == null) return;
        dx = s.x - p[0] || 0;
        dy = s.y - p[1] || 0;
        return function gesture(type, event, touch) {
            var p0 = p, n;
            switch(type){
                case "start":
                    gestures[identifier] = gesture, n = active++;
                    break;
                case "end":
                    delete gestures[identifier], --active; // falls through
                case "drag":
                    p = (0, $7edc954089de14ac$export$2e2bcd8739ae039)(touch || event, container), n = active;
                    break;
            }
            dispatch.call(type, that, new (0, $9c40054296ced1ac$export$2e2bcd8739ae039)(type, {
                sourceEvent: event,
                subject: s,
                target: drag,
                identifier: identifier,
                active: n,
                x: p[0] + dx,
                y: p[1] + dy,
                dx: p[0] - p0[0],
                dy: p[1] - p0[1],
                dispatch: dispatch
            }), d);
        };
    }
    drag.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $3fe12b6f2dbbfcf4$export$2e2bcd8739ae039)(!!_), drag) : filter;
    };
    drag.container = function(_) {
        return arguments.length ? (container = typeof _ === "function" ? _ : (0, $3fe12b6f2dbbfcf4$export$2e2bcd8739ae039)(_), drag) : container;
    };
    drag.subject = function(_) {
        return arguments.length ? (subject = typeof _ === "function" ? _ : (0, $3fe12b6f2dbbfcf4$export$2e2bcd8739ae039)(_), drag) : subject;
    };
    drag.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $3fe12b6f2dbbfcf4$export$2e2bcd8739ae039)(!!_), drag) : touchable;
    };
    drag.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? drag : value;
    };
    drag.clickDistance = function(_) {
        return arguments.length ? (clickDistance2 = (_ = +_) * _, drag) : Math.sqrt(clickDistance2);
    };
    return drag;
}





function $a494753a42444945$export$2e2bcd8739ae039(d) {
    const x = +this._x.call(null, d), y = +this._y.call(null, d);
    return $a494753a42444945$var$add(this.cover(x, y), x, y, d);
}
function $a494753a42444945$var$add(tree, x, y, d) {
    if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points
    var parent, node = tree._root, leaf = {
        data: d
    }, x0 = tree._x0, y0 = tree._y0, x1 = tree._x1, y1 = tree._y1, xm, ym, xp, yp, right, bottom, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return tree._root = leaf, tree;
    // Find the existing leaf for the new point, or add it.
    while(node.length){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
    }
    // Is the new point is exactly coincident with the existing point?
    xp = +tree._x.call(null, node.data);
    yp = +tree._y.call(null, node.data);
    if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;
    // Otherwise, split the leaf node until the old and new point are separated.
    do {
        parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
    }while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | xp >= xm));
    return parent[j] = node, parent[i] = leaf, tree;
}
function $a494753a42444945$export$32ed0561867ec8a1(data) {
    var d, i, n = data.length, x, y, xz = new Array(n), yz = new Array(n), x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
    // Compute the points and their extent.
    for(i = 0; i < n; ++i){
        if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
        xz[i] = x;
        yz[i] = y;
        if (x < x0) x0 = x;
        if (x > x1) x1 = x;
        if (y < y0) y0 = y;
        if (y > y1) y1 = y;
    }
    // If there were no (valid) points, abort.
    if (x0 > x1 || y0 > y1) return this;
    // Expand the tree to cover the new points.
    this.cover(x0, y0).cover(x1, y1);
    // Add the new points.
    for(i = 0; i < n; ++i)$a494753a42444945$var$add(this, xz[i], yz[i], data[i]);
    return this;
}


function $39832ed6192df662$export$2e2bcd8739ae039(x, y) {
    if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points
    var x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1;
    // If the quadtree has no extent, initialize them.
    // Integer extent are necessary so that if we later double the extent,
    // the existing quadrant boundaries don’t change due to floating point error!
    if (isNaN(x0)) {
        x1 = (x0 = Math.floor(x)) + 1;
        y1 = (y0 = Math.floor(y)) + 1;
    } else {
        var z = x1 - x0 || 1, node = this._root, parent, i;
        while(x0 > x || x >= x1 || y0 > y || y >= y1){
            i = (y < y0) << 1 | x < x0;
            parent = new Array(4), parent[i] = node, node = parent, z *= 2;
            switch(i){
                case 0:
                    x1 = x0 + z, y1 = y0 + z;
                    break;
                case 1:
                    x0 = x1 - z, y1 = y0 + z;
                    break;
                case 2:
                    x1 = x0 + z, y0 = y1 - z;
                    break;
                case 3:
                    x0 = x1 - z, y0 = y1 - z;
                    break;
            }
        }
        if (this._root && this._root.length) this._root = node;
    }
    this._x0 = x0;
    this._y0 = y0;
    this._x1 = x1;
    this._y1 = y1;
    return this;
}


function $4f0e9d835c71a246$export$2e2bcd8739ae039() {
    var data = [];
    this.visit(function(node) {
        if (!node.length) do data.push(node.data);
        while (node = node.next);
    });
    return data;
}


function $917e47add07162ba$export$2e2bcd8739ae039(_) {
    return arguments.length ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1]) : isNaN(this._x0) ? undefined : [
        [
            this._x0,
            this._y0
        ],
        [
            this._x1,
            this._y1
        ]
    ];
}


function $02f6e9c0f7d871a9$export$2e2bcd8739ae039(node, x0, y0, x1, y1) {
    this.node = node;
    this.x0 = x0;
    this.y0 = y0;
    this.x1 = x1;
    this.y1 = y1;
}


function $414fc249ffcd1194$export$2e2bcd8739ae039(x, y, radius) {
    var data, x0 = this._x0, y0 = this._y0, x1, y1, x2, y2, x3 = this._x1, y3 = this._y1, quads = [], node = this._root, q, i;
    if (node) quads.push(new (0, $02f6e9c0f7d871a9$export$2e2bcd8739ae039)(node, x0, y0, x3, y3));
    if (radius == null) radius = Infinity;
    else {
        x0 = x - radius, y0 = y - radius;
        x3 = x + radius, y3 = y + radius;
        radius *= radius;
    }
    while(q = quads.pop()){
        // Stop searching if this quadrant can’t contain a closer node.
        if (!(node = q.node) || (x1 = q.x0) > x3 || (y1 = q.y0) > y3 || (x2 = q.x1) < x0 || (y2 = q.y1) < y0) continue;
        // Bisect the current quadrant.
        if (node.length) {
            var xm = (x1 + x2) / 2, ym = (y1 + y2) / 2;
            quads.push(new (0, $02f6e9c0f7d871a9$export$2e2bcd8739ae039)(node[3], xm, ym, x2, y2), new (0, $02f6e9c0f7d871a9$export$2e2bcd8739ae039)(node[2], x1, ym, xm, y2), new (0, $02f6e9c0f7d871a9$export$2e2bcd8739ae039)(node[1], xm, y1, x2, ym), new (0, $02f6e9c0f7d871a9$export$2e2bcd8739ae039)(node[0], x1, y1, xm, ym));
            // Visit the closest quadrant first.
            if (i = (y >= ym) << 1 | x >= xm) {
                q = quads[quads.length - 1];
                quads[quads.length - 1] = quads[quads.length - 1 - i];
                quads[quads.length - 1 - i] = q;
            }
        } else {
            var dx = x - +this._x.call(null, node.data), dy = y - +this._y.call(null, node.data), d2 = dx * dx + dy * dy;
            if (d2 < radius) {
                var d = Math.sqrt(radius = d2);
                x0 = x - d, y0 = y - d;
                x3 = x + d, y3 = y + d;
                data = node.data;
            }
        }
    }
    return data;
}


function $ff8d2511ab9318a7$export$2e2bcd8739ae039(d) {
    if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points
    var parent, node = this._root, retainer, previous, next, x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1, x, y, xm, ym, right, bottom, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return this;
    // Find the leaf node for the point.
    // While descending, also retain the deepest parent with a non-removed sibling.
    if (node.length) while(true){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
        if (!node.length) break;
        if (parent[i + 1 & 3] || parent[i + 2 & 3] || parent[i + 3 & 3]) retainer = parent, j = i;
    }
    // Find the point to remove.
    while(node.data !== d)if (!(previous = node, node = node.next)) return this;
    if (next = node.next) delete node.next;
    // If there are multiple coincident points, remove just the point.
    if (previous) return next ? previous.next = next : delete previous.next, this;
    // If this is the root point, remove it.
    if (!parent) return this._root = next, this;
    // Remove this leaf.
    next ? parent[i] = next : delete parent[i];
    // If the parent now contains exactly one leaf, collapse superfluous parents.
    if ((node = parent[0] || parent[1] || parent[2] || parent[3]) && node === (parent[3] || parent[2] || parent[1] || parent[0]) && !node.length) {
        if (retainer) retainer[j] = node;
        else this._root = node;
    }
    return this;
}
function $ff8d2511ab9318a7$export$1cfc7aad5cb1833b(data) {
    for(var i = 0, n = data.length; i < n; ++i)this.remove(data[i]);
    return this;
}


function $492df790f9ebecc4$export$2e2bcd8739ae039() {
    return this._root;
}


function $a9b71a6aeb572333$export$2e2bcd8739ae039() {
    var size = 0;
    this.visit(function(node) {
        if (!node.length) do ++size;
        while (node = node.next);
    });
    return size;
}



function $9fddc6d6cfebc160$export$2e2bcd8739ae039(callback) {
    var quads = [], q, node = this._root, child, x0, y0, x1, y1;
    if (node) quads.push(new (0, $02f6e9c0f7d871a9$export$2e2bcd8739ae039)(node, this._x0, this._y0, this._x1, this._y1));
    while(q = quads.pop())if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
        var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
        if (child = node[3]) quads.push(new (0, $02f6e9c0f7d871a9$export$2e2bcd8739ae039)(child, xm, ym, x1, y1));
        if (child = node[2]) quads.push(new (0, $02f6e9c0f7d871a9$export$2e2bcd8739ae039)(child, x0, ym, xm, y1));
        if (child = node[1]) quads.push(new (0, $02f6e9c0f7d871a9$export$2e2bcd8739ae039)(child, xm, y0, x1, ym));
        if (child = node[0]) quads.push(new (0, $02f6e9c0f7d871a9$export$2e2bcd8739ae039)(child, x0, y0, xm, ym));
    }
    return this;
}



function $eab37f80a4afb995$export$2e2bcd8739ae039(callback) {
    var quads = [], next = [], q;
    if (this._root) quads.push(new (0, $02f6e9c0f7d871a9$export$2e2bcd8739ae039)(this._root, this._x0, this._y0, this._x1, this._y1));
    while(q = quads.pop()){
        var node = q.node;
        if (node.length) {
            var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
            if (child = node[0]) quads.push(new (0, $02f6e9c0f7d871a9$export$2e2bcd8739ae039)(child, x0, y0, xm, ym));
            if (child = node[1]) quads.push(new (0, $02f6e9c0f7d871a9$export$2e2bcd8739ae039)(child, xm, y0, x1, ym));
            if (child = node[2]) quads.push(new (0, $02f6e9c0f7d871a9$export$2e2bcd8739ae039)(child, x0, ym, xm, y1));
            if (child = node[3]) quads.push(new (0, $02f6e9c0f7d871a9$export$2e2bcd8739ae039)(child, xm, ym, x1, y1));
        }
        next.push(q);
    }
    while(q = next.pop())callback(q.node, q.x0, q.y0, q.x1, q.y1);
    return this;
}


function $12ada2e5df9a9159$export$e6fafc98131d2a44(d) {
    return d[0];
}
function $12ada2e5df9a9159$export$2e2bcd8739ae039(_) {
    return arguments.length ? (this._x = _, this) : this._x;
}


function $05cdee4e8edddd05$export$6f0a21aeb844a64c(d) {
    return d[1];
}
function $05cdee4e8edddd05$export$2e2bcd8739ae039(_) {
    return arguments.length ? (this._y = _, this) : this._y;
}


function $3ac6d1630036c464$export$2e2bcd8739ae039(nodes, x, y) {
    var tree = new $3ac6d1630036c464$var$Quadtree(x == null ? (0, $12ada2e5df9a9159$export$e6fafc98131d2a44) : x, y == null ? (0, $05cdee4e8edddd05$export$6f0a21aeb844a64c) : y, NaN, NaN, NaN, NaN);
    return nodes == null ? tree : tree.addAll(nodes);
}
function $3ac6d1630036c464$var$Quadtree(x, y, x0, y0, x1, y1) {
    this._x = x;
    this._y = y;
    this._x0 = x0;
    this._y0 = y0;
    this._x1 = x1;
    this._y1 = y1;
    this._root = undefined;
}
function $3ac6d1630036c464$var$leaf_copy(leaf) {
    var copy = {
        data: leaf.data
    }, next = copy;
    while(leaf = leaf.next)next = next.next = {
        data: leaf.data
    };
    return copy;
}
var $3ac6d1630036c464$var$treeProto = $3ac6d1630036c464$export$2e2bcd8739ae039.prototype = $3ac6d1630036c464$var$Quadtree.prototype;
$3ac6d1630036c464$var$treeProto.copy = function() {
    var copy = new $3ac6d1630036c464$var$Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1), node = this._root, nodes, child;
    if (!node) return copy;
    if (!node.length) return copy._root = $3ac6d1630036c464$var$leaf_copy(node), copy;
    nodes = [
        {
            source: node,
            target: copy._root = new Array(4)
        }
    ];
    while(node = nodes.pop()){
        for(var i = 0; i < 4; ++i)if (child = node.source[i]) {
            if (child.length) nodes.push({
                source: child,
                target: node.target[i] = new Array(4)
            });
            else node.target[i] = $3ac6d1630036c464$var$leaf_copy(child);
        }
    }
    return copy;
};
$3ac6d1630036c464$var$treeProto.add = (0, $a494753a42444945$export$2e2bcd8739ae039);
$3ac6d1630036c464$var$treeProto.addAll = (0, $a494753a42444945$export$32ed0561867ec8a1);
$3ac6d1630036c464$var$treeProto.cover = (0, $39832ed6192df662$export$2e2bcd8739ae039);
$3ac6d1630036c464$var$treeProto.data = (0, $4f0e9d835c71a246$export$2e2bcd8739ae039);
$3ac6d1630036c464$var$treeProto.extent = (0, $917e47add07162ba$export$2e2bcd8739ae039);
$3ac6d1630036c464$var$treeProto.find = (0, $414fc249ffcd1194$export$2e2bcd8739ae039);
$3ac6d1630036c464$var$treeProto.remove = (0, $ff8d2511ab9318a7$export$2e2bcd8739ae039);
$3ac6d1630036c464$var$treeProto.removeAll = (0, $ff8d2511ab9318a7$export$1cfc7aad5cb1833b);
$3ac6d1630036c464$var$treeProto.root = (0, $492df790f9ebecc4$export$2e2bcd8739ae039);
$3ac6d1630036c464$var$treeProto.size = (0, $a9b71a6aeb572333$export$2e2bcd8739ae039);
$3ac6d1630036c464$var$treeProto.visit = (0, $9fddc6d6cfebc160$export$2e2bcd8739ae039);
$3ac6d1630036c464$var$treeProto.visitAfter = (0, $eab37f80a4afb995$export$2e2bcd8739ae039);
$3ac6d1630036c464$var$treeProto.x = (0, $12ada2e5df9a9159$export$2e2bcd8739ae039);
$3ac6d1630036c464$var$treeProto.y = (0, $05cdee4e8edddd05$export$2e2bcd8739ae039);


function $bf1313b94d8e4b03$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $36b51fc72a0e636c$export$2e2bcd8739ae039(random) {
    return (random() - 0.5) * 1e-6;
}


function $53e4a88a69e53efa$var$x(d) {
    return d.x + d.vx;
}
function $53e4a88a69e53efa$var$y(d) {
    return d.y + d.vy;
}
function $53e4a88a69e53efa$export$2e2bcd8739ae039(radius) {
    var nodes, radii, random, strength = 1, iterations = 1;
    if (typeof radius !== "function") radius = (0, $bf1313b94d8e4b03$export$2e2bcd8739ae039)(radius == null ? 1 : +radius);
    function force() {
        var i, n = nodes.length, tree, node, xi, yi, ri, ri2;
        for(var k = 0; k < iterations; ++k){
            tree = (0, $3ac6d1630036c464$export$2e2bcd8739ae039)(nodes, $53e4a88a69e53efa$var$x, $53e4a88a69e53efa$var$y).visitAfter(prepare);
            for(i = 0; i < n; ++i){
                node = nodes[i];
                ri = radii[node.index], ri2 = ri * ri;
                xi = node.x + node.vx;
                yi = node.y + node.vy;
                tree.visit(apply);
            }
        }
        function apply(quad, x0, y0, x1, y1) {
            var data = quad.data, rj = quad.r, r = ri + rj;
            if (data) {
                if (data.index > node.index) {
                    var x = xi - data.x - data.vx, y = yi - data.y - data.vy, l = x * x + y * y;
                    if (l < r * r) {
                        if (x === 0) x = (0, $36b51fc72a0e636c$export$2e2bcd8739ae039)(random), l += x * x;
                        if (y === 0) y = (0, $36b51fc72a0e636c$export$2e2bcd8739ae039)(random), l += y * y;
                        l = (r - (l = Math.sqrt(l))) / l * strength;
                        node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
                        node.vy += (y *= l) * r;
                        data.vx -= x * (r = 1 - r);
                        data.vy -= y * r;
                    }
                }
                return;
            }
            return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
        }
    }
    function prepare(quad) {
        if (quad.data) return quad.r = radii[quad.data.index];
        for(var i = quad.r = 0; i < 4; ++i)if (quad[i] && quad[i].r > quad.r) quad.r = quad[i].r;
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length, node;
        radii = new Array(n);
        for(i = 0; i < n; ++i)node = nodes[i], radii[node.index] = +radius(node, i, nodes);
    }
    force.initialize = function(_nodes, _random) {
        nodes = _nodes;
        random = _random;
        initialize();
    };
    force.iterations = function(_) {
        return arguments.length ? (iterations = +_, force) : iterations;
    };
    force.strength = function(_) {
        return arguments.length ? (strength = +_, force) : strength;
    };
    force.radius = function(_) {
        return arguments.length ? (radius = typeof _ === "function" ? _ : (0, $bf1313b94d8e4b03$export$2e2bcd8739ae039)(+_), initialize(), force) : radius;
    };
    return force;
}



function $9fd4d9b47239ceb4$var$index(d) {
    return d.index;
}
function $9fd4d9b47239ceb4$var$find(nodeById, nodeId) {
    var node = nodeById.get(nodeId);
    if (!node) throw new Error("node not found: " + nodeId);
    return node;
}
function $9fd4d9b47239ceb4$export$2e2bcd8739ae039(links) {
    var id = $9fd4d9b47239ceb4$var$index, strength = defaultStrength, strengths, distance = (0, $bf1313b94d8e4b03$export$2e2bcd8739ae039)(30), distances, nodes, count, bias, random, iterations = 1;
    if (links == null) links = [];
    function defaultStrength(link) {
        return 1 / Math.min(count[link.source.index], count[link.target.index]);
    }
    function force(alpha) {
        for(var k = 0, n = links.length; k < iterations; ++k)for(var i = 0, link, source, target, x, y, l, b; i < n; ++i){
            link = links[i], source = link.source, target = link.target;
            x = target.x + target.vx - source.x - source.vx || (0, $36b51fc72a0e636c$export$2e2bcd8739ae039)(random);
            y = target.y + target.vy - source.y - source.vy || (0, $36b51fc72a0e636c$export$2e2bcd8739ae039)(random);
            l = Math.sqrt(x * x + y * y);
            l = (l - distances[i]) / l * alpha * strengths[i];
            x *= l, y *= l;
            target.vx -= x * (b = bias[i]);
            target.vy -= y * b;
            source.vx += x * (b = 1 - b);
            source.vy += y * b;
        }
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length, m = links.length, nodeById = new Map(nodes.map((d, i)=>[
                id(d, i, nodes),
                d
            ])), link;
        for(i = 0, count = new Array(n); i < m; ++i){
            link = links[i], link.index = i;
            if (typeof link.source !== "object") link.source = $9fd4d9b47239ceb4$var$find(nodeById, link.source);
            if (typeof link.target !== "object") link.target = $9fd4d9b47239ceb4$var$find(nodeById, link.target);
            count[link.source.index] = (count[link.source.index] || 0) + 1;
            count[link.target.index] = (count[link.target.index] || 0) + 1;
        }
        for(i = 0, bias = new Array(m); i < m; ++i)link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
        strengths = new Array(m), initializeStrength();
        distances = new Array(m), initializeDistance();
    }
    function initializeStrength() {
        if (!nodes) return;
        for(var i = 0, n = links.length; i < n; ++i)strengths[i] = +strength(links[i], i, links);
    }
    function initializeDistance() {
        if (!nodes) return;
        for(var i = 0, n = links.length; i < n; ++i)distances[i] = +distance(links[i], i, links);
    }
    force.initialize = function(_nodes, _random) {
        nodes = _nodes;
        random = _random;
        initialize();
    };
    force.links = function(_) {
        return arguments.length ? (links = _, initialize(), force) : links;
    };
    force.id = function(_) {
        return arguments.length ? (id = _, force) : id;
    };
    force.iterations = function(_) {
        return arguments.length ? (iterations = +_, force) : iterations;
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $bf1313b94d8e4b03$export$2e2bcd8739ae039)(+_), initializeStrength(), force) : strength;
    };
    force.distance = function(_) {
        return arguments.length ? (distance = typeof _ === "function" ? _ : (0, $bf1313b94d8e4b03$export$2e2bcd8739ae039)(+_), initializeDistance(), force) : distance;
    };
    return force;
}



// https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
const $6fd0a190a438c8a4$var$a = 1664525;
const $6fd0a190a438c8a4$var$c = 1013904223;
const $6fd0a190a438c8a4$var$m = 4294967296; // 2^32
function $6fd0a190a438c8a4$export$2e2bcd8739ae039() {
    let s = 1;
    return ()=>(s = ($6fd0a190a438c8a4$var$a * s + $6fd0a190a438c8a4$var$c) % $6fd0a190a438c8a4$var$m) / $6fd0a190a438c8a4$var$m;
}


function $c1d4a37d6d45ae13$export$d141bba7fdc215a3(d) {
    return d.x;
}
function $c1d4a37d6d45ae13$export$4a5767248b18ef41(d) {
    return d.y;
}
var $c1d4a37d6d45ae13$var$initialRadius = 10, $c1d4a37d6d45ae13$var$initialAngle = Math.PI * (3 - Math.sqrt(5));
function $c1d4a37d6d45ae13$export$2e2bcd8739ae039(nodes) {
    var simulation, alpha = 1, alphaMin = 0.001, alphaDecay = 1 - Math.pow(alphaMin, 1 / 300), alphaTarget = 0, velocityDecay = 0.6, forces = new Map(), stepper = (0, $0830f34b180fabe6$export$9dc4ecf953986f04)(step), event = (0, $f22df01f36f3bbc5$export$2e2bcd8739ae039)("tick", "end"), random = (0, $6fd0a190a438c8a4$export$2e2bcd8739ae039)();
    if (nodes == null) nodes = [];
    function step() {
        tick();
        event.call("tick", simulation);
        if (alpha < alphaMin) {
            stepper.stop();
            event.call("end", simulation);
        }
    }
    function tick(iterations) {
        var i, n = nodes.length, node;
        if (iterations === undefined) iterations = 1;
        for(var k = 0; k < iterations; ++k){
            alpha += (alphaTarget - alpha) * alphaDecay;
            forces.forEach(function(force) {
                force(alpha);
            });
            for(i = 0; i < n; ++i){
                node = nodes[i];
                if (node.fx == null) node.x += node.vx *= velocityDecay;
                else node.x = node.fx, node.vx = 0;
                if (node.fy == null) node.y += node.vy *= velocityDecay;
                else node.y = node.fy, node.vy = 0;
            }
        }
        return simulation;
    }
    function initializeNodes() {
        for(var i = 0, n = nodes.length, node; i < n; ++i){
            node = nodes[i], node.index = i;
            if (node.fx != null) node.x = node.fx;
            if (node.fy != null) node.y = node.fy;
            if (isNaN(node.x) || isNaN(node.y)) {
                var radius = $c1d4a37d6d45ae13$var$initialRadius * Math.sqrt(0.5 + i), angle = i * $c1d4a37d6d45ae13$var$initialAngle;
                node.x = radius * Math.cos(angle);
                node.y = radius * Math.sin(angle);
            }
            if (isNaN(node.vx) || isNaN(node.vy)) node.vx = node.vy = 0;
        }
    }
    function initializeForce(force) {
        if (force.initialize) force.initialize(nodes, random);
        return force;
    }
    initializeNodes();
    return simulation = {
        tick: tick,
        restart: function() {
            return stepper.restart(step), simulation;
        },
        stop: function() {
            return stepper.stop(), simulation;
        },
        nodes: function(_) {
            return arguments.length ? (nodes = _, initializeNodes(), forces.forEach(initializeForce), simulation) : nodes;
        },
        alpha: function(_) {
            return arguments.length ? (alpha = +_, simulation) : alpha;
        },
        alphaMin: function(_) {
            return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
        },
        alphaDecay: function(_) {
            return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
        },
        alphaTarget: function(_) {
            return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
        },
        velocityDecay: function(_) {
            return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
        },
        randomSource: function(_) {
            return arguments.length ? (random = _, forces.forEach(initializeForce), simulation) : random;
        },
        force: function(name, _) {
            return arguments.length > 1 ? (_ == null ? forces.delete(name) : forces.set(name, initializeForce(_)), simulation) : forces.get(name);
        },
        find: function(x, y, radius) {
            var i = 0, n = nodes.length, dx, dy, d2, node, closest;
            if (radius == null) radius = Infinity;
            else radius *= radius;
            for(i = 0; i < n; ++i){
                node = nodes[i];
                dx = x - node.x;
                dy = y - node.y;
                d2 = dx * dx + dy * dy;
                if (d2 < radius) closest = node, radius = d2;
            }
            return closest;
        },
        on: function(name, _) {
            return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
        }
    };
}


function $ba7b4235e1775cec$export$2e2bcd8739ae039(x) {
    var strength = (0, $bf1313b94d8e4b03$export$2e2bcd8739ae039)(0.1), nodes, strengths, xz;
    if (typeof x !== "function") x = (0, $bf1313b94d8e4b03$export$2e2bcd8739ae039)(x == null ? 0 : +x);
    function force(alpha) {
        for(var i = 0, n = nodes.length, node; i < n; ++i)node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length;
        strengths = new Array(n);
        xz = new Array(n);
        for(i = 0; i < n; ++i)strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
    force.initialize = function(_) {
        nodes = _;
        initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $bf1313b94d8e4b03$export$2e2bcd8739ae039)(+_), initialize(), force) : strength;
    };
    force.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $bf1313b94d8e4b03$export$2e2bcd8739ae039)(+_), initialize(), force) : x;
    };
    return force;
}


function $399269a1232ff250$export$2e2bcd8739ae039(y) {
    var strength = (0, $bf1313b94d8e4b03$export$2e2bcd8739ae039)(0.1), nodes, strengths, yz;
    if (typeof y !== "function") y = (0, $bf1313b94d8e4b03$export$2e2bcd8739ae039)(y == null ? 0 : +y);
    function force(alpha) {
        for(var i = 0, n = nodes.length, node; i < n; ++i)node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length;
        strengths = new Array(n);
        yz = new Array(n);
        for(i = 0; i < n; ++i)strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
    force.initialize = function(_) {
        nodes = _;
        initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $bf1313b94d8e4b03$export$2e2bcd8739ae039)(+_), initialize(), force) : strength;
    };
    force.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $bf1313b94d8e4b03$export$2e2bcd8739ae039)(+_), initialize(), force) : y;
    };
    return force;
}










function $2dbcbc8f113460d5$export$2e2bcd8739ae039(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}


function $9d977ca9c6671195$export$23c7bb9e6558da2a(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $9d977ca9c6671195$export$7d6b419e59e83f3d(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}


class $2411ed8c712c6f7c$export$dcc6fb7d82b5bc7b extends Map {
    constructor(entries, key = $2411ed8c712c6f7c$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get($2411ed8c712c6f7c$var$intern_get(this, key));
    }
    has(key) {
        return super.has($2411ed8c712c6f7c$var$intern_get(this, key));
    }
    set(key, value) {
        return super.set($2411ed8c712c6f7c$var$intern_set(this, key), value);
    }
    delete(key) {
        return super.delete($2411ed8c712c6f7c$var$intern_delete(this, key));
    }
}
class $2411ed8c712c6f7c$export$55278c3294239828 extends Set {
    constructor(values, key = $2411ed8c712c6f7c$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has($2411ed8c712c6f7c$var$intern_get(this, value));
    }
    add(value) {
        return super.add($2411ed8c712c6f7c$var$intern_set(this, value));
    }
    delete(value) {
        return super.delete($2411ed8c712c6f7c$var$intern_delete(this, value));
    }
}
function $2411ed8c712c6f7c$var$intern_get({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function $2411ed8c712c6f7c$var$intern_set({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function $2411ed8c712c6f7c$var$intern_delete({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function $2411ed8c712c6f7c$var$keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}



const $33dac692c189562a$export$e4f898ab14d9d460 = Symbol("implicit");
function $33dac692c189562a$export$2e2bcd8739ae039() {
    var index = new (0, $2411ed8c712c6f7c$export$dcc6fb7d82b5bc7b)(), domain = [], range = [], unknown = $33dac692c189562a$export$e4f898ab14d9d460;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== $33dac692c189562a$export$e4f898ab14d9d460) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new (0, $2411ed8c712c6f7c$export$dcc6fb7d82b5bc7b)();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $33dac692c189562a$export$2e2bcd8739ae039(domain, range).unknown(unknown);
    };
    (0, $9d977ca9c6671195$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}


function $b1f3e4f79b270385$export$2e2bcd8739ae039() {
    var scale = (0, $33dac692c189562a$export$2e2bcd8739ae039)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $2dbcbc8f113460d5$export$2e2bcd8739ae039)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $b1f3e4f79b270385$export$2e2bcd8739ae039(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return (0, $9d977ca9c6671195$export$23c7bb9e6558da2a).apply(rescale(), arguments);
}
function $b1f3e4f79b270385$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $b1f3e4f79b270385$var$pointish(copy());
    };
    return scale;
}
function $b1f3e4f79b270385$export$105684a3041cb6f3() {
    return $b1f3e4f79b270385$var$pointish($b1f3e4f79b270385$export$2e2bcd8739ae039.apply(null, arguments).paddingInner(1));
}

const $9db2f87bc4be21a0$var$e10 = Math.sqrt(50), $9db2f87bc4be21a0$var$e5 = Math.sqrt(10), $9db2f87bc4be21a0$var$e2 = Math.sqrt(2);
function $9db2f87bc4be21a0$var$tickSpec(start, stop, count) {
    const step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log10(step)), error = step / Math.pow(10, power), factor = error >= $9db2f87bc4be21a0$var$e10 ? 10 : error >= $9db2f87bc4be21a0$var$e5 ? 5 : error >= $9db2f87bc4be21a0$var$e2 ? 2 : 1;
    let i1, i2, inc;
    if (power < 0) {
        inc = Math.pow(10, -power) / factor;
        i1 = Math.round(start * inc);
        i2 = Math.round(stop * inc);
        if (i1 / inc < start) ++i1;
        if (i2 / inc > stop) --i2;
        inc = -inc;
    } else {
        inc = Math.pow(10, power) * factor;
        i1 = Math.round(start / inc);
        i2 = Math.round(stop / inc);
        if (i1 * inc < start) ++i1;
        if (i2 * inc > stop) --i2;
    }
    if (i2 < i1 && 0.5 <= count && count < 2) return $9db2f87bc4be21a0$var$tickSpec(start, stop, count * 2);
    return [
        i1,
        i2,
        inc
    ];
}
function $9db2f87bc4be21a0$export$2e2bcd8739ae039(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    if (!(count > 0)) return [];
    if (start === stop) return [
        start
    ];
    const reverse = stop < start, [i1, i2, inc] = reverse ? $9db2f87bc4be21a0$var$tickSpec(stop, start, count) : $9db2f87bc4be21a0$var$tickSpec(start, stop, count);
    if (!(i2 >= i1)) return [];
    const n = i2 - i1 + 1, ticks = new Array(n);
    if (reverse) {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) * inc;
    } else {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) * inc;
    }
    return ticks;
}
function $9db2f87bc4be21a0$export$bc64d00cc98e7e95(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    return $9db2f87bc4be21a0$var$tickSpec(start, stop, count)[2];
}
function $9db2f87bc4be21a0$export$81087d9b915d4ede(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    const reverse = stop < start, inc = reverse ? $9db2f87bc4be21a0$export$bc64d00cc98e7e95(stop, start, count) : $9db2f87bc4be21a0$export$bc64d00cc98e7e95(start, stop, count);
    return (reverse ? -1 : 1) * (inc < 0 ? 1 / -inc : inc);
}


function $d281dc4bedcaa4bb$export$2e2bcd8739ae039(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}



function $66d3a017ba11c809$export$2e2bcd8739ae039(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}


function $2e786e1650447282$export$2e2bcd8739ae039(f) {
    let compare1, compare2, delta;
    // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = (0, $d281dc4bedcaa4bb$export$2e2bcd8739ae039);
        compare2 = (d, x)=>(0, $d281dc4bedcaa4bb$export$2e2bcd8739ae039)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === (0, $d281dc4bedcaa4bb$export$2e2bcd8739ae039) || f === (0, $66d3a017ba11c809$export$2e2bcd8739ae039) ? f : $2e786e1650447282$var$zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $2e786e1650447282$var$zero() {
    return 0;
}


function $7fd7fc20c5d99156$export$2e2bcd8739ae039(x) {
    return x === null ? NaN : +x;
}
function* $7fd7fc20c5d99156$export$1f6c9cc012ebacae(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}


const $cc44a5a8212c170d$var$ascendingBisect = (0, $2e786e1650447282$export$2e2bcd8739ae039)((0, $d281dc4bedcaa4bb$export$2e2bcd8739ae039));
const $cc44a5a8212c170d$export$4d945ad3ad5751b0 = $cc44a5a8212c170d$var$ascendingBisect.right;
const $cc44a5a8212c170d$export$df7d25c84ebd12a5 = $cc44a5a8212c170d$var$ascendingBisect.left;
const $cc44a5a8212c170d$export$c1cb828b1117c77b = (0, $2e786e1650447282$export$2e2bcd8739ae039)((0, $7fd7fc20c5d99156$export$2e2bcd8739ae039)).center;
var $cc44a5a8212c170d$export$2e2bcd8739ae039 = $cc44a5a8212c170d$export$4d945ad3ad5751b0;


function $a7eb384d18622265$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}


function $92141dad1564853d$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $7c3585a41f9f1074$export$2e2bcd8739ae039(x) {
    return +x;
}


var $ca897062bcd43aee$var$unit = [
    0,
    1
];
function $ca897062bcd43aee$export$f0954fd7d5368655(x) {
    return x;
}
function $ca897062bcd43aee$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $92141dad1564853d$export$2e2bcd8739ae039)(isNaN(b) ? NaN : 0.5);
}
function $ca897062bcd43aee$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $ca897062bcd43aee$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $ca897062bcd43aee$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $ca897062bcd43aee$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $ca897062bcd43aee$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $ca897062bcd43aee$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $cc44a5a8212c170d$export$2e2bcd8739ae039)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $ca897062bcd43aee$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $ca897062bcd43aee$export$6b468dcfb64c653c() {
    var domain = $ca897062bcd43aee$var$unit, range = $ca897062bcd43aee$var$unit, interpolate = (0, $0a6b21d627aa3b76$export$2e2bcd8739ae039), transform, untransform, unknown, clamp = $ca897062bcd43aee$export$f0954fd7d5368655, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $ca897062bcd43aee$export$f0954fd7d5368655) clamp = $ca897062bcd43aee$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $ca897062bcd43aee$var$polymap : $ca897062bcd43aee$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), (0, $4a087d8646486986$export$2e2bcd8739ae039))))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, $7c3585a41f9f1074$export$2e2bcd8739ae039)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = (0, $a7eb384d18622265$export$2e2bcd8739ae039), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $ca897062bcd43aee$export$f0954fd7d5368655, rescale()) : clamp !== $ca897062bcd43aee$export$f0954fd7d5368655;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $ca897062bcd43aee$export$2e2bcd8739ae039() {
    return $ca897062bcd43aee$export$6b468dcfb64c653c()($ca897062bcd43aee$export$f0954fd7d5368655, $ca897062bcd43aee$export$f0954fd7d5368655);
}




function $a5d46b5f3c884056$export$2e2bcd8739ae039(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
function $a5d46b5f3c884056$export$8f8e23dd27dc19f5(x, p) {
    if (!isFinite(x) || x === 0) return null; // NaN, ±Infinity, ±0
    var i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e"), coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}


function $e9bc2c183c8beeb1$export$2e2bcd8739ae039(x) {
    return x = (0, $a5d46b5f3c884056$export$8f8e23dd27dc19f5)(Math.abs(x)), x ? x[1] : NaN;
}


function $d868e31ec0b96872$export$2e2bcd8739ae039(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}


function $798f5d7050e9002b$export$2e2bcd8739ae039(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}


// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $5f29b13e3a196c8e$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $5f29b13e3a196c8e$export$2e2bcd8739ae039(specifier) {
    if (!(match = $5f29b13e3a196c8e$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $5f29b13e3a196c8e$export$963aac351db36ed4({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$5f29b13e3a196c8e$export$2e2bcd8739ae039.prototype = $5f29b13e3a196c8e$export$963aac351db36ed4.prototype; // instanceof
function $5f29b13e3a196c8e$export$963aac351db36ed4(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$5f29b13e3a196c8e$export$963aac351db36ed4.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};


// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $2cb7441c9c442571$export$2e2bcd8739ae039(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}




var $8ff722c7852d4647$export$6863724d9a42263;
function $8ff722c7852d4647$export$2e2bcd8739ae039(x, p) {
    var d = (0, $a5d46b5f3c884056$export$8f8e23dd27dc19f5)(x, p);
    if (!d) return $8ff722c7852d4647$export$6863724d9a42263 = undefined, x.toPrecision(p);
    var coefficient = d[0], exponent = d[1], i = exponent - ($8ff722c7852d4647$export$6863724d9a42263 = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $a5d46b5f3c884056$export$8f8e23dd27dc19f5)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}



function $af70927a1c6aceab$export$2e2bcd8739ae039(x, p) {
    var d = (0, $a5d46b5f3c884056$export$8f8e23dd27dc19f5)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}


var $b6d0aa6cc2ec8647$export$2e2bcd8739ae039 = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": (0, $a5d46b5f3c884056$export$2e2bcd8739ae039),
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $af70927a1c6aceab$export$2e2bcd8739ae039)(x * 100, p),
    "r": (0, $af70927a1c6aceab$export$2e2bcd8739ae039),
    "s": (0, $8ff722c7852d4647$export$2e2bcd8739ae039),
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};



function $26664c9765990809$export$2e2bcd8739ae039(x) {
    return x;
}


var $c998d661c292df00$var$map = Array.prototype.map, $c998d661c292df00$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $c998d661c292df00$export$2e2bcd8739ae039(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? (0, $26664c9765990809$export$2e2bcd8739ae039) : (0, $d868e31ec0b96872$export$2e2bcd8739ae039)($c998d661c292df00$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, $26664c9765990809$export$2e2bcd8739ae039) : (0, $798f5d7050e9002b$export$2e2bcd8739ae039)($c998d661c292df00$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier, options) {
        specifier = (0, $5f29b13e3a196c8e$export$2e2bcd8739ae039)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
        // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g";
        else if (!(0, $b6d0aa6cc2ec8647$export$2e2bcd8739ae039)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
        // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
        // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = (options && options.prefix !== undefined ? options.prefix : "") + (symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : ""), suffix = (symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "") + (options && options.suffix !== undefined ? options.suffix : "");
        // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = (0, $b6d0aa6cc2ec8647$export$2e2bcd8739ae039)[type], maybeSuffix = /[defgprs%]/.test(type);
        // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value;
                // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0;
                // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                // Trim insignificant zeros.
                if (trim) value = (0, $2cb7441c9c442571$export$2e2bcd8739ae039)(value);
                // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" && !isNaN(value) && (0, $8ff722c7852d4647$export$6863724d9a42263) !== undefined ? $c998d661c292df00$var$prefixes[8 + (0, $8ff722c7852d4647$export$6863724d9a42263) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            }
            // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity);
            // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
            // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
            // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var e = Math.max(-8, Math.min(8, Math.floor((0, $e9bc2c183c8beeb1$export$2e2bcd8739ae039)(value) / 3))) * 3, k = Math.pow(10, -e), f = newFormat((specifier = (0, $5f29b13e3a196c8e$export$2e2bcd8739ae039)(specifier), specifier.type = "f", specifier), {
            suffix: $c998d661c292df00$var$prefixes[8 + e / 3]
        });
        return function(value) {
            return f(k * value);
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}


var $170ab7dc5db36a3a$var$locale;
var $170ab7dc5db36a3a$export$d9468344d3651243;
var $170ab7dc5db36a3a$export$8d85692a469dde6f;
$170ab7dc5db36a3a$export$2e2bcd8739ae039({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $170ab7dc5db36a3a$export$2e2bcd8739ae039(definition) {
    $170ab7dc5db36a3a$var$locale = (0, $c998d661c292df00$export$2e2bcd8739ae039)(definition);
    $170ab7dc5db36a3a$export$d9468344d3651243 = $170ab7dc5db36a3a$var$locale.format;
    $170ab7dc5db36a3a$export$8d85692a469dde6f = $170ab7dc5db36a3a$var$locale.formatPrefix;
    return $170ab7dc5db36a3a$var$locale;
}


function $e44e43143c11eec4$export$2e2bcd8739ae039(step) {
    return Math.max(0, -(0, $e9bc2c183c8beeb1$export$2e2bcd8739ae039)(Math.abs(step)));
}


function $4f34dbb5e221d7e1$export$2e2bcd8739ae039(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $e9bc2c183c8beeb1$export$2e2bcd8739ae039)(value) / 3))) * 3 - (0, $e9bc2c183c8beeb1$export$2e2bcd8739ae039)(Math.abs(step)));
}


function $26a2946b7d090407$export$2e2bcd8739ae039(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $e9bc2c183c8beeb1$export$2e2bcd8739ae039)(max) - (0, $e9bc2c183c8beeb1$export$2e2bcd8739ae039)(step)) + 1;
}


function $36618bdb29fe134f$export$2e2bcd8739ae039(start, stop, count, specifier) {
    var step = (0, $9db2f87bc4be21a0$export$81087d9b915d4ede)(start, stop, count), precision;
    specifier = (0, $5f29b13e3a196c8e$export$2e2bcd8739ae039)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $4f34dbb5e221d7e1$export$2e2bcd8739ae039)(step, value))) specifier.precision = precision;
            return (0, $170ab7dc5db36a3a$export$8d85692a469dde6f)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $26a2946b7d090407$export$2e2bcd8739ae039)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $e44e43143c11eec4$export$2e2bcd8739ae039)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $170ab7dc5db36a3a$export$d9468344d3651243)(specifier);
}


function $9d892af289cba166$export$16a5d4b4a61a274d(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $9db2f87bc4be21a0$export$2e2bcd8739ae039)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $36618bdb29fe134f$export$2e2bcd8739ae039)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $9db2f87bc4be21a0$export$bc64d00cc98e7e95)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $9d892af289cba166$export$2e2bcd8739ae039() {
    var scale = (0, $ca897062bcd43aee$export$2e2bcd8739ae039)();
    scale.copy = function() {
        return (0, $ca897062bcd43aee$export$784d13d8ee351f07)(scale, $9d892af289cba166$export$2e2bcd8739ae039());
    };
    (0, $9d977ca9c6671195$export$23c7bb9e6558da2a).apply(scale, arguments);
    return $9d892af289cba166$export$16a5d4b4a61a274d(scale);
}





function $a85203b65095458d$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $3fa3bddc94b4f8a8$export$52baac22726c72bf)([
        document.querySelectorAll(selector)
    ], [
        document.documentElement
    ]) : new (0, $3fa3bddc94b4f8a8$export$52baac22726c72bf)([
        (0, $6100a2c8d9353abb$export$2e2bcd8739ae039)(selector)
    ], (0, $3fa3bddc94b4f8a8$export$e8e78c978b129247));
}









var $ab1b56f08da5f0f8$var$epsilon2 = 1e-12;
function $ab1b56f08da5f0f8$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $ab1b56f08da5f0f8$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $ab1b56f08da5f0f8$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var $ab1b56f08da5f0f8$export$2e2bcd8739ae039 = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
        // Special case for u0 ≅ u1.
        if (d2 < $ab1b56f08da5f0f8$var$epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = $ab1b56f08da5f0f8$var$cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * $ab1b56f08da5f0f8$var$tanh(rho * s + r0) - $ab1b56f08da5f0f8$var$sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / $ab1b56f08da5f0f8$var$cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);




var $855f7c13dc5c8800$export$2e2bcd8739ae039 = (x)=>()=>x;


function $f8b8ac12d46296b4$export$2e2bcd8739ae039(type, { sourceEvent: sourceEvent, target: target, transform: transform, dispatch: dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        transform: {
            value: transform,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}


function $2aeeefb9d4aa62cb$export$563a914cafbdc389(k, x, y) {
    this.k = k;
    this.x = x;
    this.y = y;
}
$2aeeefb9d4aa62cb$export$563a914cafbdc389.prototype = {
    constructor: $2aeeefb9d4aa62cb$export$563a914cafbdc389,
    scale: function(k) {
        return k === 1 ? this : new $2aeeefb9d4aa62cb$export$563a914cafbdc389(this.k * k, this.x, this.y);
    },
    translate: function(x, y) {
        return x === 0 & y === 0 ? this : new $2aeeefb9d4aa62cb$export$563a914cafbdc389(this.k, this.x + this.k * x, this.y + this.k * y);
    },
    apply: function(point) {
        return [
            point[0] * this.k + this.x,
            point[1] * this.k + this.y
        ];
    },
    applyX: function(x) {
        return x * this.k + this.x;
    },
    applyY: function(y) {
        return y * this.k + this.y;
    },
    invert: function(location) {
        return [
            (location[0] - this.x) / this.k,
            (location[1] - this.y) / this.k
        ];
    },
    invertX: function(x) {
        return (x - this.x) / this.k;
    },
    invertY: function(y) {
        return (y - this.y) / this.k;
    },
    rescaleX: function(x) {
        return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
    },
    rescaleY: function(y) {
        return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
    },
    toString: function() {
        return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
    }
};
var $2aeeefb9d4aa62cb$export$f0954fd7d5368655 = new $2aeeefb9d4aa62cb$export$563a914cafbdc389(1, 0, 0);
$2aeeefb9d4aa62cb$export$2e2bcd8739ae039.prototype = $2aeeefb9d4aa62cb$export$563a914cafbdc389.prototype;
function $2aeeefb9d4aa62cb$export$2e2bcd8739ae039(node) {
    while(!node.__zoom)if (!(node = node.parentNode)) return $2aeeefb9d4aa62cb$export$f0954fd7d5368655;
    return node.__zoom;
}


function $4c382e9682a58de3$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $4c382e9682a58de3$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}


// Ignore right-click, since that should open the context menu.
// except for pinch-to-zoom, which is sent as a wheel+ctrlKey event
function $2e3210259ae866af$var$defaultFilter(event) {
    return (!event.ctrlKey || event.type === 'wheel') && !event.button;
}
function $2e3210259ae866af$var$defaultExtent() {
    var e = this;
    if (e instanceof SVGElement) {
        e = e.ownerSVGElement || e;
        if (e.hasAttribute("viewBox")) {
            e = e.viewBox.baseVal;
            return [
                [
                    e.x,
                    e.y
                ],
                [
                    e.x + e.width,
                    e.y + e.height
                ]
            ];
        }
        return [
            [
                0,
                0
            ],
            [
                e.width.baseVal.value,
                e.height.baseVal.value
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            e.clientWidth,
            e.clientHeight
        ]
    ];
}
function $2e3210259ae866af$var$defaultTransform() {
    return this.__zoom || (0, $2aeeefb9d4aa62cb$export$f0954fd7d5368655);
}
function $2e3210259ae866af$var$defaultWheelDelta(event) {
    return -event.deltaY * (event.deltaMode === 1 ? 0.05 : event.deltaMode ? 1 : 0.002) * (event.ctrlKey ? 10 : 1);
}
function $2e3210259ae866af$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
function $2e3210259ae866af$var$defaultConstrain(transform, extent, translateExtent) {
    var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0], dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0], dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1], dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
    return transform.translate(dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1), dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1));
}
function $2e3210259ae866af$export$2e2bcd8739ae039() {
    var filter = $2e3210259ae866af$var$defaultFilter, extent = $2e3210259ae866af$var$defaultExtent, constrain = $2e3210259ae866af$var$defaultConstrain, wheelDelta = $2e3210259ae866af$var$defaultWheelDelta, touchable = $2e3210259ae866af$var$defaultTouchable, scaleExtent = [
        0,
        Infinity
    ], translateExtent = [
        [
            -Infinity,
            -Infinity
        ],
        [
            Infinity,
            Infinity
        ]
    ], duration = 250, interpolate = (0, $ab1b56f08da5f0f8$export$2e2bcd8739ae039), listeners = (0, $f22df01f36f3bbc5$export$2e2bcd8739ae039)("start", "zoom", "end"), touchstarting, touchfirst, touchending, touchDelay = 500, wheelDelay = 150, clickDistance2 = 0, tapDistance = 10;
    function zoom(selection) {
        selection.property("__zoom", $2e3210259ae866af$var$defaultTransform).on("wheel.zoom", wheeled, {
            passive: false
        }).on("mousedown.zoom", mousedowned).on("dblclick.zoom", dblclicked).filter(touchable).on("touchstart.zoom", touchstarted).on("touchmove.zoom", touchmoved).on("touchend.zoom touchcancel.zoom", touchended).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    zoom.transform = function(collection, transform, point, event) {
        var selection = collection.selection ? collection.selection() : collection;
        selection.property("__zoom", $2e3210259ae866af$var$defaultTransform);
        if (collection !== selection) schedule(collection, transform, point, event);
        else selection.interrupt().each(function() {
            gesture(this, arguments).event(event).start().zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform).end();
        });
    };
    zoom.scaleBy = function(selection, k, p, event) {
        zoom.scaleTo(selection, function() {
            var k0 = this.__zoom.k, k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return k0 * k1;
        }, p, event);
    };
    zoom.scaleTo = function(selection, k, p, event) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t0 = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p, p1 = t0.invert(p0), k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
        }, p, event);
    };
    zoom.translateBy = function(selection, x, y, event) {
        zoom.transform(selection, function() {
            return constrain(this.__zoom.translate(typeof x === "function" ? x.apply(this, arguments) : x, typeof y === "function" ? y.apply(this, arguments) : y), extent.apply(this, arguments), translateExtent);
        }, null, event);
    };
    zoom.translateTo = function(selection, x, y, p, event) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p;
            return constrain((0, $2aeeefb9d4aa62cb$export$f0954fd7d5368655).translate(p0[0], p0[1]).scale(t.k).translate(typeof x === "function" ? -x.apply(this, arguments) : -x, typeof y === "function" ? -y.apply(this, arguments) : -y), e, translateExtent);
        }, p, event);
    };
    function scale(transform, k) {
        k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
        return k === transform.k ? transform : new (0, $2aeeefb9d4aa62cb$export$563a914cafbdc389)(k, transform.x, transform.y);
    }
    function translate(transform, p0, p1) {
        var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
        return x === transform.x && y === transform.y ? transform : new (0, $2aeeefb9d4aa62cb$export$563a914cafbdc389)(transform.k, x, y);
    }
    function centroid(extent) {
        return [
            (+extent[0][0] + +extent[1][0]) / 2,
            (+extent[0][1] + +extent[1][1]) / 2
        ];
    }
    function schedule(transition, transform, point, event) {
        transition.on("start.zoom", function() {
            gesture(this, arguments).event(event).start();
        }).on("interrupt.zoom end.zoom", function() {
            gesture(this, arguments).event(event).end();
        }).tween("zoom", function() {
            var that = this, args = arguments, g = gesture(that, args).event(event), e = extent.apply(that, args), p = point == null ? centroid(e) : typeof point === "function" ? point.apply(that, args) : point, w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]), a = that.__zoom, b = typeof transform === "function" ? transform.apply(that, args) : transform, i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
            return function(t) {
                if (t === 1) t = b; // Avoid rounding error on end.
                else {
                    var l = i(t), k = w / l[2];
                    t = new (0, $2aeeefb9d4aa62cb$export$563a914cafbdc389)(k, p[0] - l[0] * k, p[1] - l[1] * k);
                }
                g.zoom(null, t);
            };
        });
    }
    function gesture(that, args, clean) {
        return !clean && that.__zooming || new Gesture(that, args);
    }
    function Gesture(that, args) {
        this.that = that;
        this.args = args;
        this.active = 0;
        this.sourceEvent = null;
        this.extent = extent.apply(that, args);
        this.taps = 0;
    }
    Gesture.prototype = {
        event: function(event) {
            if (event) this.sourceEvent = event;
            return this;
        },
        start: function() {
            if (++this.active === 1) {
                this.that.__zooming = this;
                this.emit("start");
            }
            return this;
        },
        zoom: function(key, transform) {
            if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
            if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
            if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
            this.that.__zoom = transform;
            this.emit("zoom");
            return this;
        },
        end: function() {
            if (--this.active === 0) {
                delete this.that.__zooming;
                this.emit("end");
            }
            return this;
        },
        emit: function(type) {
            var d = (0, $4506c173c1ba6b79$export$2e2bcd8739ae039)(this.that).datum();
            listeners.call(type, this.that, new (0, $f8b8ac12d46296b4$export$2e2bcd8739ae039)(type, {
                sourceEvent: this.sourceEvent,
                target: zoom,
                type: type,
                transform: this.that.__zoom,
                dispatch: listeners
            }), d);
        }
    };
    function wheeled(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var g = gesture(this, args).event(event), t = this.__zoom, k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))), p = (0, $7edc954089de14ac$export$2e2bcd8739ae039)(event);
        // If the mouse is in the same location as before, reuse it.
        // If there were recent wheel events, reset the wheel idle timeout.
        if (g.wheel) {
            if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) g.mouse[1] = t.invert(g.mouse[0] = p);
            clearTimeout(g.wheel);
        } else if (t.k === k) return;
        else {
            g.mouse = [
                p,
                t.invert(p)
            ];
            (0, $a9f60c0c7972321a$export$2e2bcd8739ae039)(this);
            g.start();
        }
        (0, $4c382e9682a58de3$export$2e2bcd8739ae039)(event);
        g.wheel = setTimeout(wheelidled, wheelDelay);
        g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));
        function wheelidled() {
            g.wheel = null;
            g.end();
        }
    }
    function mousedowned(event, ...args) {
        if (touchending || !filter.apply(this, arguments)) return;
        var currentTarget = event.currentTarget, g = gesture(this, args, true).event(event), v = (0, $4506c173c1ba6b79$export$2e2bcd8739ae039)(event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true), p = (0, $7edc954089de14ac$export$2e2bcd8739ae039)(event, currentTarget), x0 = event.clientX, y0 = event.clientY;
        (0, $ae3cd07c3e922ae3$export$2e2bcd8739ae039)(event.view);
        (0, $4c382e9682a58de3$export$2e2561858db9bf47)(event);
        g.mouse = [
            p,
            this.__zoom.invert(p)
        ];
        (0, $a9f60c0c7972321a$export$2e2bcd8739ae039)(this);
        g.start();
        function mousemoved(event) {
            (0, $4c382e9682a58de3$export$2e2bcd8739ae039)(event);
            if (!g.moved) {
                var dx = event.clientX - x0, dy = event.clientY - y0;
                g.moved = dx * dx + dy * dy > clickDistance2;
            }
            g.event(event).zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = (0, $7edc954089de14ac$export$2e2bcd8739ae039)(event, currentTarget), g.mouse[1]), g.extent, translateExtent));
        }
        function mouseupped(event) {
            v.on("mousemove.zoom mouseup.zoom", null);
            (0, $ae3cd07c3e922ae3$export$833237748009e1e1)(event.view, g.moved);
            (0, $4c382e9682a58de3$export$2e2bcd8739ae039)(event);
            g.event(event).end();
        }
    }
    function dblclicked(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var t0 = this.__zoom, p0 = (0, $7edc954089de14ac$export$2e2bcd8739ae039)(event.changedTouches ? event.changedTouches[0] : event, this), p1 = t0.invert(p0), k1 = t0.k * (event.shiftKey ? 0.5 : 2), t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, args), translateExtent);
        (0, $4c382e9682a58de3$export$2e2bcd8739ae039)(event);
        if (duration > 0) (0, $4506c173c1ba6b79$export$2e2bcd8739ae039)(this).transition().duration(duration).call(schedule, t1, p0, event);
        else (0, $4506c173c1ba6b79$export$2e2bcd8739ae039)(this).call(zoom.transform, t1, p0, event);
    }
    function touchstarted(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var touches = event.touches, n = touches.length, g = gesture(this, args, event.changedTouches.length === n).event(event), started, i, t, p;
        (0, $4c382e9682a58de3$export$2e2561858db9bf47)(event);
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $7edc954089de14ac$export$2e2bcd8739ae039)(t, this);
            p = [
                p,
                this.__zoom.invert(p),
                t.identifier
            ];
            if (!g.touch0) g.touch0 = p, started = true, g.taps = 1 + !!touchstarting;
            else if (!g.touch1 && g.touch0[2] !== p[2]) g.touch1 = p, g.taps = 0;
        }
        if (touchstarting) touchstarting = clearTimeout(touchstarting);
        if (started) {
            if (g.taps < 2) touchfirst = p[0], touchstarting = setTimeout(function() {
                touchstarting = null;
            }, touchDelay);
            (0, $a9f60c0c7972321a$export$2e2bcd8739ae039)(this);
            g.start();
        }
    }
    function touchmoved(event, ...args) {
        if (!this.__zooming) return;
        var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t, p, l;
        (0, $4c382e9682a58de3$export$2e2bcd8739ae039)(event);
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $7edc954089de14ac$export$2e2bcd8739ae039)(t, this);
            if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
            else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
        }
        t = g.that.__zoom;
        if (g.touch1) {
            var p0 = g.touch0[0], l0 = g.touch0[1], p1 = g.touch1[0], l1 = g.touch1[1], dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp, dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
            t = scale(t, Math.sqrt(dp / dl));
            p = [
                (p0[0] + p1[0]) / 2,
                (p0[1] + p1[1]) / 2
            ];
            l = [
                (l0[0] + l1[0]) / 2,
                (l0[1] + l1[1]) / 2
            ];
        } else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
        else return;
        g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
    }
    function touchended(event, ...args) {
        if (!this.__zooming) return;
        var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t;
        (0, $4c382e9682a58de3$export$2e2561858db9bf47)(event);
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() {
            touchending = null;
        }, touchDelay);
        for(i = 0; i < n; ++i){
            t = touches[i];
            if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
            else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
        }
        if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
        if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
        else {
            g.end();
            // If this was a dbltap, reroute to the (optional) dblclick.zoom handler.
            if (g.taps === 2) {
                t = (0, $7edc954089de14ac$export$2e2bcd8739ae039)(t, this);
                if (Math.hypot(touchfirst[0] - t[0], touchfirst[1] - t[1]) < tapDistance) {
                    var p = (0, $4506c173c1ba6b79$export$2e2bcd8739ae039)(this).on("dblclick.zoom");
                    if (p) p.apply(this, arguments);
                }
            }
        }
    }
    zoom.wheelDelta = function(_) {
        return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : (0, $855f7c13dc5c8800$export$2e2bcd8739ae039)(+_), zoom) : wheelDelta;
    };
    zoom.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $855f7c13dc5c8800$export$2e2bcd8739ae039)(!!_), zoom) : filter;
    };
    zoom.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $855f7c13dc5c8800$export$2e2bcd8739ae039)(!!_), zoom) : touchable;
    };
    zoom.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $855f7c13dc5c8800$export$2e2bcd8739ae039)([
            [
                +_[0][0],
                +_[0][1]
            ],
            [
                +_[1][0],
                +_[1][1]
            ]
        ]), zoom) : extent;
    };
    zoom.scaleExtent = function(_) {
        return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [
            scaleExtent[0],
            scaleExtent[1]
        ];
    };
    zoom.translateExtent = function(_) {
        return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [
            [
                translateExtent[0][0],
                translateExtent[0][1]
            ],
            [
                translateExtent[1][0],
                translateExtent[1][1]
            ]
        ];
    };
    zoom.constrain = function(_) {
        return arguments.length ? (constrain = _, zoom) : constrain;
    };
    zoom.duration = function(_) {
        return arguments.length ? (duration = +_, zoom) : duration;
    };
    zoom.interpolate = function(_) {
        return arguments.length ? (interpolate = _, zoom) : interpolate;
    };
    zoom.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? zoom : value;
    };
    zoom.clickDistance = function(_) {
        return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
    };
    zoom.tapDistance = function(_) {
        return arguments.length ? (tapDistance = +_, zoom) : tapDistance;
    };
    return zoom;
}








var $5E6i4 = parcelRequire("5E6i4");


var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");
var $7c82df226e6db626$export$8793edee2d425525 = function() {};
function $7c82df226e6db626$export$af631764ddc44097(obj) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (obj && obj.addEventListener) obj.addEventListener.apply(obj, args);
}
function $7c82df226e6db626$export$8c8705df4a2dcec9(obj) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (obj && obj.removeEventListener) obj.removeEventListener.apply(obj, args);
}
var $7c82df226e6db626$export$4e09c449d6c407f7 = typeof window !== 'undefined';
var $7c82df226e6db626$export$42e7ac6120dd324e = typeof navigator !== 'undefined';


var $638d3707f277956f$var$useIsomorphicLayoutEffect = (0, $7c82df226e6db626$export$4e09c449d6c407f7) ? (0, $5E6i4.useLayoutEffect) : (0, $5E6i4.useEffect);
var $638d3707f277956f$export$2e2bcd8739ae039 = $638d3707f277956f$var$useIsomorphicLayoutEffect;



var $5da09a61d0d65faf$var$defaultState = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
};
function $5da09a61d0d65faf$var$useMeasure() {
    var _a = (0, $5E6i4.useState)(null), element = _a[0], ref = _a[1];
    var _b = (0, $5E6i4.useState)($5da09a61d0d65faf$var$defaultState), rect = _b[0], setRect = _b[1];
    var observer = (0, $5E6i4.useMemo)(function() {
        return new window.ResizeObserver(function(entries) {
            if (entries[0]) {
                var _a = entries[0].contentRect, x = _a.x, y = _a.y, width = _a.width, height = _a.height, top_1 = _a.top, left = _a.left, bottom = _a.bottom, right = _a.right;
                setRect({
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    top: top_1,
                    left: left,
                    bottom: bottom,
                    right: right
                });
            }
        });
    }, []);
    (0, $638d3707f277956f$export$2e2bcd8739ae039)(function() {
        if (!element) return;
        observer.observe(element);
        return function() {
            observer.disconnect();
        };
    }, [
        element
    ]);
    return [
        ref,
        rect
    ];
}
var $5da09a61d0d65faf$export$2e2bcd8739ae039 = (0, $7c82df226e6db626$export$4e09c449d6c407f7) && typeof window.ResizeObserver !== 'undefined' ? $5da09a61d0d65faf$var$useMeasure : function() {
    return [
        (0, $7c82df226e6db626$export$8793edee2d425525),
        $5da09a61d0d65faf$var$defaultState
    ];
};



const $bda569642168ffcb$var$relationClasses = [
    'same',
    'transposed',
    'changed'
];
const $bda569642168ffcb$var$classOf = (relation)=>relation === 'prototype' || relation === 'exact' ? 'same' : relation === 'transposition' ? 'transposed' : 'changed';
const $bda569642168ffcb$var$signed = (value)=>value === null || value === undefined ? '' : value > 0 ? `+${value}` : value < 0 ? `\u{2212}${-value}` : "\xb10";
const $bda569642168ffcb$var$factorGlyph = (factor)=>{
    if (!factor) return '';
    const [numerator, denominator] = factor.split('/').map(Number);
    if (denominator === 2 && numerator === 1) return "\xd7\xbd";
    return denominator ? `\xd7${numerator}/${denominator}` : `\xd7${numerator}`;
};
const $bda569642168ffcb$var$readablePitch = (pitch)=>pitch.replace('-', "\u266D").replace('#', "\u266F");
const $bda569642168ffcb$export$f1f5ddeb20d14f = (occurrence, translate)=>{
    switch(occurrence.relation){
        case 'prototype':
            return translate('family.glyphs.prototype');
        case 'exact':
            return occurrence.semitones ? `= ${$bda569642168ffcb$var$signed(occurrence.semitones)}` : '=';
        case 'transposition':
            return `${$bda569642168ffcb$var$signed(occurrence.semitones)}${occurrence.tonal ? ` ${translate('family.glyphs.tonal')}` : ''}`;
        case 'variant':
            return `\u{2248} ${$bda569642168ffcb$var$signed(occurrence.semitones)}`;
        case 'inversion':
            return `${translate('family.glyphs.inversion')} ${$bda569642168ffcb$var$signed(occurrence.semitones)}`;
        case 'retrograde':
            return `${translate('family.glyphs.retrograde')} ${$bda569642168ffcb$var$signed(occurrence.semitones)}`;
        case 'augmentation':
        case 'diminution':
            return $bda569642168ffcb$var$factorGlyph(occurrence.factor);
    }
};
const $bda569642168ffcb$export$c916a26769d2200c = (occurrence, translate)=>{
    const shift = occurrence.semitones ? `, ${translate('family.semitones', {
        shift: $bda569642168ffcb$var$signed(occurrence.semitones)
    })}` : '';
    switch(occurrence.relation){
        case 'prototype':
            return translate('family.relations.prototype');
        case 'exact':
            return translate('family.relations.exact') + shift;
        case 'transposition':
            return translate(occurrence.tonal ? 'family.relations.tonal' : 'family.relations.real') + shift;
        case 'variant':
            return translate('family.relations.variant', {
                count: occurrence.mismatches
            }) + shift;
        case 'inversion':
            return translate('family.relations.inversion') + shift;
        case 'retrograde':
            return translate('family.relations.retrograde') + shift;
        case 'augmentation':
        case 'diminution':
            return `${translate(`family.relations.${occurrence.relation}`)} ${$bda569642168ffcb$var$factorGlyph(occurrence.factor)}`;
    }
};
const $bda569642168ffcb$export$cd5450f3a47e3789 = (occurrence, translate)=>`${translate('family.where', {
        bars: occurrence.endMeasure !== occurrence.measure ? `${occurrence.measure}\u{2013}${occurrence.endMeasure}` : `${occurrence.measure}`,
        pitch: occurrence.startPitch ? $bda569642168ffcb$var$readablePitch(occurrence.startPitch) : translate('family.rest'),
        voice: occurrence.voiceNumber
    })}: ${$bda569642168ffcb$export$c916a26769d2200c(occurrence, translate)}`;
const $bda569642168ffcb$var$laneHeight = 28;
const $bda569642168ffcb$var$markHeight = 18;
const $bda569642168ffcb$var$labelWidth = 64;
const $bda569642168ffcb$var$arcSpace = 26;
const $bda569642168ffcb$var$TransitionStrip = ({ family: family, hoveredIndex: hoveredIndex, lastOffset: lastOffset, onHover: onHover, onSelect: onSelect, voices: voices })=>{
    const { t: translate } = (0, $705ab703c44be5bc$export$9fc83ad70ead8663)();
    const [reference, { width: width }] = (0, $5da09a61d0d65faf$export$2e2bcd8739ae039)();
    const plotWidth = Math.max(width - $bda569642168ffcb$var$labelWidth - 8, 120);
    const x = (0, $9d892af289cba166$export$2e2bcd8739ae039)().domain([
        0,
        lastOffset
    ]).range([
        $bda569642168ffcb$var$labelWidth,
        $bda569642168ffcb$var$labelWidth + plotWidth
    ]);
    const lane = (0, $b1f3e4f79b270385$export$2e2bcd8739ae039)().domain(voices).range([
        $bda569642168ffcb$var$arcSpace,
        $bda569642168ffcb$var$arcSpace + voices.length * $bda569642168ffcb$var$laneHeight
    ]);
    const height = $bda569642168ffcb$var$arcSpace + voices.length * $bda569642168ffcb$var$laneHeight + 22;
    const showTransitionLabels = family.transitions.length <= 12;
    const centre = (occurrence)=>({
            x: x(occurrence.firstOffset),
            y: (lane(occurrence.voiceNumber) ?? 0) + $bda569642168ffcb$var$laneHeight / 2
        });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
        className: "w-full",
        ref: reference,
        children: [
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("svg", {
                "aria-label": translate('family.strip', {
                    label: family.label
                }),
                className: "block",
                height: height,
                role: "img",
                width: width || 400,
                children: [
                    voices.map((voice)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("g", {
                            children: [
                                /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("line", {
                                    stroke: "var(--viz-grid)",
                                    strokeWidth: 1,
                                    x1: $bda569642168ffcb$var$labelWidth,
                                    x2: $bda569642168ffcb$var$labelWidth + plotWidth,
                                    y1: (lane(voice) ?? 0) + $bda569642168ffcb$var$laneHeight / 2,
                                    y2: (lane(voice) ?? 0) + $bda569642168ffcb$var$laneHeight / 2
                                }),
                                /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("text", {
                                    dominantBaseline: "middle",
                                    fill: "var(--viz-text-secondary)",
                                    fontSize: 12,
                                    x: 0,
                                    y: (lane(voice) ?? 0) + $bda569642168ffcb$var$laneHeight / 2,
                                    children: translate('family.voice', {
                                        voice: voice
                                    })
                                })
                            ]
                        }, voice)),
                    family.transitions.map((transition)=>{
                        const from = centre(family.occurrences[transition.from]);
                        const to = centre(family.occurrences[transition.to]);
                        const top = Math.min(from.y, to.y) - $bda569642168ffcb$var$laneHeight / 2 - 8;
                        const isActive = hoveredIndex === transition.from || hoveredIndex === transition.to;
                        return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("g", {
                            children: [
                                /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("path", {
                                    d: `M ${from.x} ${from.y - $bda569642168ffcb$var$markHeight / 2} C ${from.x} ${top}, ${to.x} ${top}, ${to.x} ${to.y - $bda569642168ffcb$var$markHeight / 2}`,
                                    fill: "none",
                                    stroke: isActive ? 'var(--viz-text-primary)' : 'var(--viz-axis)',
                                    strokeLinecap: "round",
                                    strokeWidth: isActive ? 2 : 1.5
                                }),
                                (showTransitionLabels || isActive) && transition.semitones !== null && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("text", {
                                    fill: "var(--viz-text-secondary)",
                                    fontSize: 11,
                                    textAnchor: "middle",
                                    x: (from.x + to.x) / 2,
                                    y: top + 2,
                                    children: $bda569642168ffcb$var$signed(transition.semitones)
                                })
                            ]
                        }, `${transition.from}-${transition.to}`);
                    }),
                    family.occurrences.map((occurrence, index)=>{
                        const start = x(occurrence.firstOffset);
                        const markWidth = Math.max(x(occurrence.endOffset) - start, 6);
                        const y = (lane(occurrence.voiceNumber) ?? 0) + ($bda569642168ffcb$var$laneHeight - $bda569642168ffcb$var$markHeight) / 2;
                        const text = $bda569642168ffcb$export$f1f5ddeb20d14f(occurrence, translate);
                        const fitsText = markWidth >= text.length * 6.5 + 8;
                        const isHovered = hoveredIndex === index;
                        return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("g", {
                            className: "cursor-pointer",
                            onClick: ()=>onSelect(index),
                            onFocus: ()=>onHover(index),
                            onBlur: ()=>onHover(undefined),
                            onKeyDown: (event)=>(event.key === 'Enter' || event.key === ' ') && onSelect(index),
                            onPointerEnter: ()=>onHover(index),
                            onPointerLeave: ()=>onHover(undefined),
                            tabIndex: 0,
                            children: [
                                /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("title", {
                                    children: $bda569642168ffcb$export$cd5450f3a47e3789(occurrence, translate)
                                }),
                                /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("rect", {
                                    fill: "transparent",
                                    height: $bda569642168ffcb$var$laneHeight,
                                    width: markWidth + 4,
                                    x: start - 2,
                                    y: y - 5
                                }),
                                /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("rect", {
                                    fill: `var(--viz-relation-${$bda569642168ffcb$var$classOf(occurrence.relation)})`,
                                    height: $bda569642168ffcb$var$markHeight,
                                    opacity: hoveredIndex === undefined || isHovered ? 1 : 0.45,
                                    rx: 4,
                                    stroke: isHovered ? 'var(--viz-text-primary)' : 'var(--viz-surface)',
                                    strokeWidth: 2,
                                    width: markWidth,
                                    x: start,
                                    y: y
                                }),
                                fitsText && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("text", {
                                    dominantBaseline: "middle",
                                    fill: `var(--viz-on-relation-${$bda569642168ffcb$var$classOf(occurrence.relation)})`,
                                    fontSize: 11,
                                    fontWeight: 600,
                                    pointerEvents: "none",
                                    x: start + 4,
                                    y: y + $bda569642168ffcb$var$markHeight / 2 + 0.5,
                                    children: text
                                }),
                                /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("text", {
                                    fill: "var(--viz-text-muted)",
                                    fontSize: 10,
                                    pointerEvents: "none",
                                    x: start,
                                    y: $bda569642168ffcb$var$arcSpace + voices.length * $bda569642168ffcb$var$laneHeight + 14,
                                    children: index === 0 || family.occurrences[index - 1].measure !== occurrence.measure ? occurrence.measure : ''
                                })
                            ]
                        }, index);
                    })
                ]
            }),
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("ul", {
                className: "m-0 mt-1 flex flex-wrap gap-x-4 gap-y-1 p-0 text-xs",
                style: {
                    listStyle: 'none'
                },
                children: $bda569642168ffcb$var$relationClasses.map((relationClass)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("li", {
                        className: "flex items-center gap-1.5",
                        style: {
                            color: 'var(--viz-text-secondary)'
                        },
                        children: [
                            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("span", {
                                "aria-hidden": true,
                                className: "inline-block h-2.5 w-3.5 rounded-sm",
                                style: {
                                    background: `var(--viz-relation-${relationClass})`
                                }
                            }),
                            translate(`family.classes.${relationClass}`)
                        ]
                    }, relationClass))
            })
        ]
    });
};
/** A small single-series bar chart; the title names the series, so there is no legend. */ const $bda569642168ffcb$var$Distribution = ({ entries: entries, title: title })=>{
    const [reference, { width: width }] = (0, $5da09a61d0d65faf$export$2e2bcd8739ae039)();
    const chartHeight = 72;
    const maximum = Math.max(...entries.map(([, value])=>value), 1);
    const band = (0, $b1f3e4f79b270385$export$2e2bcd8739ae039)().domain(entries.map(([key])=>key)).range([
        0,
        width || 160
    ]).paddingInner(0.25);
    const barWidth = Math.min(band.bandwidth(), 24);
    const y = (0, $9d892af289cba166$export$2e2bcd8739ae039)().domain([
        0,
        maximum
    ]).range([
        0,
        chartHeight - 16
    ]);
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("figure", {
        className: "m-0 min-w-0",
        ref: reference,
        children: [
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("figcaption", {
                className: "mb-1 text-xs font-semibold",
                style: {
                    color: 'var(--viz-text-primary)'
                },
                children: title
            }),
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("svg", {
                "aria-label": title,
                height: chartHeight + 16,
                role: "img",
                width: width || 160,
                children: [
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("line", {
                        stroke: "var(--viz-axis)",
                        strokeWidth: 1,
                        x1: 0,
                        x2: width || 160,
                        y1: chartHeight,
                        y2: chartHeight
                    }),
                    entries.map(([key, value])=>{
                        const barHeight = y(value);
                        const left = (band(key) ?? 0) + (band.bandwidth() - barWidth) / 2;
                        return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("g", {
                            children: [
                                /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("title", {
                                    children: `${key}: ${value}`
                                }),
                                /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("path", {
                                    d: `M ${left} ${chartHeight} v ${-barHeight + 4} q 0 -4 4 -4 h ${barWidth - 8} q 4 0 4 4 v ${barHeight - 4} z`,
                                    fill: "var(--viz-series-1)"
                                }),
                                /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("text", {
                                    fill: "var(--viz-text-secondary)",
                                    fontSize: 10,
                                    textAnchor: "middle",
                                    x: left + barWidth / 2,
                                    y: chartHeight - barHeight - 3,
                                    children: value
                                }),
                                /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("text", {
                                    fill: "var(--viz-text-muted)",
                                    fontSize: 10,
                                    textAnchor: "middle",
                                    x: left + barWidth / 2,
                                    y: chartHeight + 12,
                                    children: key
                                })
                            ]
                        }, key);
                    })
                ]
            })
        ]
    });
};
const $bda569642168ffcb$var$pitchClassOrder = [
    'C',
    'C#',
    'D',
    'E-',
    'E',
    'F',
    'F#',
    'G',
    'A-',
    'A',
    'B-',
    'B'
];
const $bda569642168ffcb$var$FamilyDetail = ({ family: family, lastOffset: lastOffset, onHoverOccurrence: onHoverOccurrence, onPlayOccurrence: onPlayOccurrence, onSelectOccurrence: onSelectOccurrence, voices: voices })=>{
    const { t: translate } = (0, $705ab703c44be5bc$export$9fc83ad70ead8663)();
    const [hoveredIndex, setHoveredIndex] = (0, $5E6i4.useState)();
    const hover = (index)=>{
        setHoveredIndex(index);
        onHoverOccurrence(index === undefined ? undefined : family.occurrences[index]);
    };
    const counts = (0, $5E6i4.useMemo)(()=>{
        const byClass = {
            same: 0,
            transposed: 0,
            changed: 0
        };
        family.occurrences.forEach((occurrence)=>byClass[$bda569642168ffcb$var$classOf(occurrence.relation)] += 1);
        return byClass;
    }, [
        family
    ]);
    const voicesUsed = Object.keys(family.distributions.byVoice).length;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("section", {
        "aria-label": translate('family.section', {
            label: family.label
        }),
        className: "melodyvis-viz flex flex-col gap-3",
        children: [
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("p", {
                className: "m-0 text-sm",
                style: {
                    color: 'var(--viz-text-secondary)'
                },
                children: [
                    translate('family.summary', {
                        changed: counts.changed,
                        entries: translate('family.entries', {
                            count: family.occurrences.length
                        }),
                        first: family.occurrences[0]?.measure,
                        last: family.occurrences[family.occurrences.length - 1]?.endMeasure,
                        same: counts.same,
                        transposed: counts.transposed,
                        voices: translate('family.voices', {
                            count: voicesUsed
                        })
                    }),
                    family.sequences.length > 0 && ` ${translate('family.sequences', {
                        count: family.sequences.length
                    })}`,
                    family.imitations.length > 0 && ` ${translate('family.imitations', {
                        count: family.imitations.length
                    })}`
                ]
            }),
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($bda569642168ffcb$var$TransitionStrip, {
                family: family,
                hoveredIndex: hoveredIndex,
                lastOffset: lastOffset,
                onHover: hover,
                onSelect: (index)=>onSelectOccurrence(family.occurrences[index]),
                voices: voices
            }),
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
                className: "grid items-end gap-4",
                style: {
                    gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))'
                },
                children: [
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($bda569642168ffcb$var$Distribution, {
                        entries: voices.map((voice)=>[
                                translate('family.voiceShort', {
                                    voice: voice
                                }),
                                family.distributions.byVoice[voice] ?? 0
                            ]),
                        title: translate('family.byVoice')
                    }),
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($bda569642168ffcb$var$Distribution, {
                        entries: Object.entries(family.distributions.bySemitones).map(([semitones, count])=>[
                                Number(semitones),
                                count
                            ]).sort(([first], [second])=>first - second).map(([semitones, count])=>[
                                $bda569642168ffcb$var$signed(semitones),
                                count
                            ]),
                        title: translate('family.bySemitones')
                    }),
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($bda569642168ffcb$var$Distribution, {
                        entries: $bda569642168ffcb$var$pitchClassOrder.filter((pitchClass)=>family.distributions.byStartPitchClass[pitchClass]).map((pitchClass)=>[
                                $bda569642168ffcb$var$readablePitch(pitchClass),
                                family.distributions.byStartPitchClass[pitchClass]
                            ]),
                        title: translate('family.byStart')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("table", {
                className: "w-full border-collapse text-xs",
                style: {
                    color: 'var(--viz-text-primary)'
                },
                children: [
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("caption", {
                        className: "sr-only",
                        children: translate('family.table', {
                            label: family.label
                        })
                    }),
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("tr", {
                            style: {
                                color: 'var(--viz-text-muted)'
                            },
                            children: [
                                /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("th", {
                                    className: "whitespace-nowrap py-1 pr-2 text-left font-normal",
                                    children: "#"
                                }),
                                /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("th", {
                                    className: "whitespace-nowrap py-1 pr-2 text-left font-normal",
                                    children: translate('family.columns.voice')
                                }),
                                /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("th", {
                                    className: "whitespace-nowrap py-1 pr-2 text-left font-normal",
                                    children: translate('family.columns.bars')
                                }),
                                /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("th", {
                                    className: "whitespace-nowrap py-1 pr-2 text-left font-normal",
                                    children: translate('family.columns.start')
                                }),
                                /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("th", {
                                    className: "whitespace-nowrap py-1 pr-2 text-left font-normal",
                                    children: translate('family.columns.relation')
                                }),
                                onPlayOccurrence && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("th", {
                                    className: "py-1 font-normal",
                                    children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("span", {
                                        className: "sr-only",
                                        children: translate('family.columns.play')
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("tbody", {
                        children: family.occurrences.map((occurrence, index)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("tr", {
                                className: "cursor-pointer",
                                onClick: ()=>onSelectOccurrence(occurrence),
                                onPointerEnter: ()=>hover(index),
                                onPointerLeave: ()=>hover(undefined),
                                style: {
                                    background: hoveredIndex === index ? 'var(--viz-hover)' : undefined
                                },
                                children: [
                                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("td", {
                                        className: "whitespace-nowrap py-0.5 pr-2 align-top",
                                        style: {
                                            fontVariantNumeric: 'tabular-nums'
                                        },
                                        children: index + 1
                                    }),
                                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("td", {
                                        className: "whitespace-nowrap py-0.5 pr-2 align-top",
                                        children: occurrence.voiceNumber
                                    }),
                                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("td", {
                                        className: "whitespace-nowrap py-0.5 pr-2 align-top",
                                        style: {
                                            fontVariantNumeric: 'tabular-nums'
                                        },
                                        children: [
                                            occurrence.measure,
                                            occurrence.endMeasure !== occurrence.measure ? `\u{2013}${occurrence.endMeasure}` : ''
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("td", {
                                        className: "whitespace-nowrap py-0.5 pr-2 align-top",
                                        children: occurrence.startPitch ? $bda569642168ffcb$var$readablePitch(occurrence.startPitch) : "\u2013"
                                    }),
                                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("td", {
                                        className: "py-0.5 pr-2 align-top",
                                        children: [
                                            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("span", {
                                                "aria-hidden": true,
                                                className: "mr-1.5 inline-block h-2 w-2.5 rounded-sm align-middle",
                                                style: {
                                                    background: `var(--viz-relation-${$bda569642168ffcb$var$classOf(occurrence.relation)})`
                                                }
                                            }),
                                            $bda569642168ffcb$export$c916a26769d2200c(occurrence, translate)
                                        ]
                                    }),
                                    onPlayOccurrence && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("td", {
                                        className: "py-0.5 text-right",
                                        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("button", {
                                            "aria-label": translate('family.playEntry', {
                                                index: index + 1
                                            }),
                                            className: "cursor-pointer rounded border border-solid border-slate-300 bg-white px-1.5 text-xs leading-5 hover:border-slate-500",
                                            onClick: (event)=>{
                                                event.stopPropagation();
                                                onPlayOccurrence(occurrence);
                                            },
                                            type: "button",
                                            children: "\u25B6"
                                        })
                                    })
                                ]
                            }, index))
                    })
                ]
            }),
            onPlayOccurrence && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("p", {
                className: "m-0 text-xs text-slate-600",
                children: [
                    translate('audio.credit'),
                    ' ',
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("a", {
                        href: "http://creativecommons.org/licenses/by/3.0/",
                        rel: "noreferrer",
                        target: "_blank",
                        children: "CC BY 3.0"
                    })
                ]
            })
        ]
    });
};
var $bda569642168ffcb$export$2e2bcd8739ae039 = $bda569642168ffcb$var$FamilyDetail;


// The API is served under /api on the same origin as the app (see deploy/local/nginx.conf).
// For `parcel` development against a separately started backend, set API_URL, e.g. API_URL=http://localhost:5000/api.
const $f3690857a25f275e$export$959cc5b93fe4d66 = (isWebsocket = false)=>{
    const apiURL = `${window.location.origin}/api`;
    return isWebsocket ? apiURL.replace(/^http/, 'ws') : apiURL;
};




var $5E6i4 = parcelRequire("5E6i4");


const $17f5ed32910eebd4$var$load = async (url, params)=>(await (0, $0d16547caa56a13b$export$2e2bcd8739ae039).get(url, {
        params: params
    })).data;
const $17f5ed32910eebd4$export$481489d69a51404e = (musicSheetID)=>{
    const [state, setState] = (0, $5E6i4.useState)({
        data: undefined,
        error: undefined,
        isLoading: false
    });
    (0, $5E6i4.useEffect)(()=>{
        if (!musicSheetID) return;
        let isCurrent = true;
        setState({
            data: undefined,
            error: undefined,
            isLoading: true
        });
        $17f5ed32910eebd4$var$load(`${(0, $f3690857a25f275e$export$959cc5b93fe4d66)()}/discovery/${musicSheetID}`).then((data)=>isCurrent && setState({
                data: data,
                error: undefined,
                isLoading: false
            })).catch((error)=>isCurrent && setState({
                data: undefined,
                error: (0, $d65ba47825fbd282$export$d78e6d61b3e1e377)(error),
                isLoading: false
            }));
        return ()=>{
            isCurrent = false;
        };
    }, [
        musicSheetID
    ]);
    return state;
};
const $17f5ed32910eebd4$export$228b4754f835d468 = (musicSheetID, occurrence)=>{
    const [state, setState] = (0, $5E6i4.useState)({
        data: undefined,
        error: undefined,
        isLoading: false
    });
    (0, $5E6i4.useEffect)(()=>{
        if (!musicSheetID || !occurrence) {
            setState({
                data: undefined,
                error: undefined,
                isLoading: false
            });
            return;
        }
        let isCurrent = true;
        setState({
            data: undefined,
            error: undefined,
            isLoading: true
        });
        $17f5ed32910eebd4$var$load(`${(0, $f3690857a25f275e$export$959cc5b93fe4d66)()}/family/${musicSheetID}`, occurrence).then((data)=>isCurrent && setState({
                data: data,
                error: undefined,
                isLoading: false
            })).catch((error)=>isCurrent && setState({
                data: undefined,
                error: (0, $d65ba47825fbd282$export$d78e6d61b3e1e377)(error),
                isLoading: false
            }));
        return ()=>{
            isCurrent = false;
        };
    }, [
        musicSheetID,
        occurrence?.voiceNumber,
        occurrence?.firstOffset,
        occurrence?.lastOffset
    ]);
    return state;
};




var $5E6i4 = parcelRequire("5E6i4");


/**
 * Represent a music sheet as JSON.
 */ class $b586c45ed2ac7900$export$2e2bcd8739ae039 {
    id;
    musicXML;
    numberOfMeasures;
    lastOffset;
    title;
    composer;
    category;
    /**
   * Represent a music sheet.
   *
   * @param id The ID of the music sheet in the database.
   * @param musicXML The music sheet in [MusicXML](https://www.musicxml.com/).
   * @param numberOfMeasures The number of measures that this music sheet comprises.
   * @param lastOffset The offset of the last note in the music sheet.
   * @param title The title of the music sheet.
   * @param composer The composer of the music sheet.
   * @param category The category of the music sheet.
   */ constructor(id, musicXML, numberOfMeasures, lastOffset, title, composer, category){
        this.id = id;
        this.musicXML = musicXML;
        this.numberOfMeasures = numberOfMeasures;
        this.lastOffset = lastOffset;
        this.title = title;
        this.composer = composer;
        this.category = category;
    }
}


/**
 * The selected sheet with its MusicXML. A failed request is reported instead of leaving the sheet loading forever
 * (audit F09), and a slower answer for an earlier selection never replaces the current one.
 */ const $d4f658ebaa5fa4e2$var$useMusicSheet = (musicSheetID)=>{
    const [musicSheet, setMusicSheet] = (0, $5E6i4.useState)();
    const [error, setError] = (0, $5E6i4.useState)();
    const [attempt, setAttempt] = (0, $5E6i4.useState)(0);
    (0, $5E6i4.useEffect)(()=>{
        if (!musicSheetID) return;
        let isCurrent = true;
        setError(undefined);
        (0, $0d16547caa56a13b$export$2e2bcd8739ae039).get(`${(0, $f3690857a25f275e$export$959cc5b93fe4d66)()}/music-sheets/${musicSheetID}`).then(({ data: data })=>isCurrent && setMusicSheet(new (0, $b586c45ed2ac7900$export$2e2bcd8739ae039)(data.id, data.fileContents, data.numberOfMeasures, data.lastOffset, data.title, data.composer, data.category))).catch((reason)=>isCurrent && setError((0, $d65ba47825fbd282$export$d78e6d61b3e1e377)(reason)));
        return ()=>{
            isCurrent = false;
        };
    }, [
        musicSheetID,
        attempt
    ]);
    return {
        error: error,
        musicSheet: musicSheet,
        retry: ()=>setAttempt((count)=>count + 1)
    };
};
var $d4f658ebaa5fa4e2$export$2e2bcd8739ae039 = $d4f658ebaa5fa4e2$var$useMusicSheet;




var $5E6i4 = parcelRequire("5E6i4");


const $c7fcea0757360e52$export$e3b13643eee5e428 = (musicSheetAsJSON)=>new (0, $b586c45ed2ac7900$export$2e2bcd8739ae039)(musicSheetAsJSON.id, musicSheetAsJSON.fileContents, musicSheetAsJSON.numberOfMeasures, musicSheetAsJSON.lastOffset, musicSheetAsJSON.title, musicSheetAsJSON.composer, musicSheetAsJSON.category);
/** The catalogue of sheets; `reload` fetches it again, e.g. after a sheet was imported. */ const $c7fcea0757360e52$var$useMusicSheets = ()=>{
    const [musicSheets, setMusicSheets] = (0, $5E6i4.useState)([]);
    const reload = (0, $5E6i4.useCallback)(async ()=>{
        const response = await (0, $0d16547caa56a13b$export$2e2bcd8739ae039).get(`${(0, $f3690857a25f275e$export$959cc5b93fe4d66)()}/music-sheets`);
        setMusicSheets(response.data.map($c7fcea0757360e52$export$e3b13643eee5e428));
    }, []);
    (0, $5E6i4.useEffect)(()=>{
        reload();
    }, [
        reload
    ]);
    return [
        musicSheets,
        reload
    ];
};
var $c7fcea0757360e52$export$2e2bcd8739ae039 = $c7fcea0757360e52$var$useMusicSheets;



var $5pSp9 = parcelRequire("5pSp9");

var $5E6i4 = parcelRequire("5E6i4");
var $feea5e2a23e1c45a$exports = {};
"use strict";
Object.defineProperty($feea5e2a23e1c45a$exports, "__esModule", {
    value: true
});
$feea5e2a23e1c45a$exports.resetGlobalState = $feea5e2a23e1c45a$exports.useEventSource = $feea5e2a23e1c45a$exports.ReadyState = $feea5e2a23e1c45a$exports.useSocketIO = $feea5e2a23e1c45a$exports.default = void 0;
var $17bda632513311c8$exports = {};
"use strict";
var $17bda632513311c8$var$__assign = $17bda632513311c8$exports && $17bda632513311c8$exports.__assign || function() {
    $17bda632513311c8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $17bda632513311c8$var$__assign.apply(this, arguments);
};
var $17bda632513311c8$var$__awaiter = $17bda632513311c8$exports && $17bda632513311c8$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $17bda632513311c8$var$__generator = $17bda632513311c8$exports && $17bda632513311c8$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $17bda632513311c8$var$__importDefault = $17bda632513311c8$exports && $17bda632513311c8$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($17bda632513311c8$exports, "__esModule", {
    value: true
});
$17bda632513311c8$exports.useWebSocket = void 0;

var $5E6i4 = parcelRequire("5E6i4");

var $ibUU1 = parcelRequire("ibUU1");
var $82ab36eb7f4f59e0$exports = {};
"use strict";
Object.defineProperty($82ab36eb7f4f59e0$exports, "__esModule", {
    value: true
});
$82ab36eb7f4f59e0$exports.isEventSourceSupported = $82ab36eb7f4f59e0$exports.isReactNative = $82ab36eb7f4f59e0$exports.ReadyState = $82ab36eb7f4f59e0$exports.DEFAULT_HEARTBEAT = $82ab36eb7f4f59e0$exports.UNPARSABLE_JSON_OBJECT = $82ab36eb7f4f59e0$exports.DEFAULT_RECONNECT_INTERVAL_MS = $82ab36eb7f4f59e0$exports.DEFAULT_RECONNECT_LIMIT = $82ab36eb7f4f59e0$exports.SOCKET_IO_PING_CODE = $82ab36eb7f4f59e0$exports.SOCKET_IO_PATH = $82ab36eb7f4f59e0$exports.SOCKET_IO_PING_INTERVAL = $82ab36eb7f4f59e0$exports.DEFAULT_EVENT_SOURCE_OPTIONS = $82ab36eb7f4f59e0$exports.EMPTY_EVENT_HANDLERS = $82ab36eb7f4f59e0$exports.DEFAULT_OPTIONS = void 0;
var $82ab36eb7f4f59e0$var$MILLISECONDS = 1;
var $82ab36eb7f4f59e0$var$SECONDS = 1000 * $82ab36eb7f4f59e0$var$MILLISECONDS;
$82ab36eb7f4f59e0$exports.DEFAULT_OPTIONS = {};
$82ab36eb7f4f59e0$exports.EMPTY_EVENT_HANDLERS = {};
$82ab36eb7f4f59e0$exports.DEFAULT_EVENT_SOURCE_OPTIONS = {
    withCredentials: false,
    events: $82ab36eb7f4f59e0$exports.EMPTY_EVENT_HANDLERS
};
$82ab36eb7f4f59e0$exports.SOCKET_IO_PING_INTERVAL = 25 * $82ab36eb7f4f59e0$var$SECONDS;
$82ab36eb7f4f59e0$exports.SOCKET_IO_PATH = '/socket.io/?EIO=3&transport=websocket';
$82ab36eb7f4f59e0$exports.SOCKET_IO_PING_CODE = '2';
$82ab36eb7f4f59e0$exports.DEFAULT_RECONNECT_LIMIT = 20;
$82ab36eb7f4f59e0$exports.DEFAULT_RECONNECT_INTERVAL_MS = 5000;
$82ab36eb7f4f59e0$exports.UNPARSABLE_JSON_OBJECT = {};
$82ab36eb7f4f59e0$exports.DEFAULT_HEARTBEAT = {
    message: 'ping',
    timeout: 60000,
    interval: 25000
};
var $82ab36eb7f4f59e0$var$ReadyState;
(function(ReadyState) {
    ReadyState[ReadyState["UNINSTANTIATED"] = -1] = "UNINSTANTIATED";
    ReadyState[ReadyState["CONNECTING"] = 0] = "CONNECTING";
    ReadyState[ReadyState["OPEN"] = 1] = "OPEN";
    ReadyState[ReadyState["CLOSING"] = 2] = "CLOSING";
    ReadyState[ReadyState["CLOSED"] = 3] = "CLOSED";
})($82ab36eb7f4f59e0$var$ReadyState || ($82ab36eb7f4f59e0$exports.ReadyState = $82ab36eb7f4f59e0$var$ReadyState = {}));
var $82ab36eb7f4f59e0$var$eventSourceSupported = function() {
    try {
        return 'EventSource' in globalThis;
    } catch (e) {
        return false;
    }
};
$82ab36eb7f4f59e0$exports.isReactNative = typeof navigator !== 'undefined' && navigator.product === 'ReactNative';
$82ab36eb7f4f59e0$exports.isEventSourceSupported = !$82ab36eb7f4f59e0$exports.isReactNative && $82ab36eb7f4f59e0$var$eventSourceSupported();


var $52614030881c4083$exports = {};
"use strict";
Object.defineProperty($52614030881c4083$exports, "__esModule", {
    value: true
});
$52614030881c4083$exports.createOrJoinSocket = void 0;
var $8bc0c26a35afbd15$exports = {};
"use strict";
Object.defineProperty($8bc0c26a35afbd15$exports, "__esModule", {
    value: true
});
$8bc0c26a35afbd15$exports.resetWebSockets = $8bc0c26a35afbd15$exports.sharedWebSockets = void 0;
$8bc0c26a35afbd15$exports.sharedWebSockets = {};
var $8bc0c26a35afbd15$var$resetWebSockets = function(url) {
    if (url && $8bc0c26a35afbd15$exports.sharedWebSockets.hasOwnProperty(url)) delete $8bc0c26a35afbd15$exports.sharedWebSockets[url];
    else {
        for(var url_1 in $8bc0c26a35afbd15$exports.sharedWebSockets)if ($8bc0c26a35afbd15$exports.sharedWebSockets.hasOwnProperty(url_1)) delete $8bc0c26a35afbd15$exports.sharedWebSockets[url_1];
    }
};
$8bc0c26a35afbd15$exports.resetWebSockets = $8bc0c26a35afbd15$var$resetWebSockets;



var $8325a44677ee2483$exports = {};
"use strict";
var $8325a44677ee2483$var$__assign = $8325a44677ee2483$exports && $8325a44677ee2483$exports.__assign || function() {
    $8325a44677ee2483$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8325a44677ee2483$var$__assign.apply(this, arguments);
};
Object.defineProperty($8325a44677ee2483$exports, "__esModule", {
    value: true
});
$8325a44677ee2483$exports.attachListeners = void 0;
var $0589d1ab450cdbeb$exports = {};
"use strict";
Object.defineProperty($0589d1ab450cdbeb$exports, "__esModule", {
    value: true
});
$0589d1ab450cdbeb$exports.setUpSocketIOPing = $0589d1ab450cdbeb$exports.appendQueryParams = $0589d1ab450cdbeb$exports.parseSocketIOUrl = void 0;

var $0589d1ab450cdbeb$var$parseSocketIOUrl = function(url) {
    if (url) {
        var isSecure = /^https|wss/.test(url);
        var strippedProtocol = url.replace(/^(https?|wss?)(:\/\/)?/, '');
        var removedFinalBackSlack = strippedProtocol.replace(/\/$/, '');
        var protocol = isSecure ? 'wss' : 'ws';
        return "".concat(protocol, "://").concat(removedFinalBackSlack).concat($82ab36eb7f4f59e0$exports.SOCKET_IO_PATH);
    } else if (url === '') {
        var isSecure = /^https/.test(window.location.protocol);
        var protocol = isSecure ? 'wss' : 'ws';
        var port = window.location.port ? ":".concat(window.location.port) : '';
        return "".concat(protocol, "://").concat(window.location.hostname).concat(port).concat($82ab36eb7f4f59e0$exports.SOCKET_IO_PATH);
    }
    return url;
};
$0589d1ab450cdbeb$exports.parseSocketIOUrl = $0589d1ab450cdbeb$var$parseSocketIOUrl;
var $0589d1ab450cdbeb$var$appendQueryParams = function(url, params) {
    if (params === void 0) params = {};
    var hasParamsRegex = /\?([\w]+=[\w]+)/;
    var alreadyHasParams = hasParamsRegex.test(url);
    var stringified = "".concat(Object.entries(params).reduce(function(next, _a) {
        var key = _a[0], value = _a[1];
        return next + "".concat(key, "=").concat(value, "&");
    }, '').slice(0, -1));
    return "".concat(url).concat(alreadyHasParams ? '&' : '?').concat(stringified);
};
$0589d1ab450cdbeb$exports.appendQueryParams = $0589d1ab450cdbeb$var$appendQueryParams;
var $0589d1ab450cdbeb$var$setUpSocketIOPing = function(sendMessage, interval) {
    if (interval === void 0) interval = $82ab36eb7f4f59e0$exports.SOCKET_IO_PING_INTERVAL;
    var ping = function() {
        return sendMessage($82ab36eb7f4f59e0$exports.SOCKET_IO_PING_CODE);
    };
    return window.setInterval(ping, interval);
};
$0589d1ab450cdbeb$exports.setUpSocketIOPing = $0589d1ab450cdbeb$var$setUpSocketIOPing;


var $e11c90386a0d4857$exports = {};
"use strict";
Object.defineProperty($e11c90386a0d4857$exports, "__esModule", {
    value: true
});
$e11c90386a0d4857$exports.heartbeat = $e11c90386a0d4857$var$heartbeat;

function $e11c90386a0d4857$var$getLastMessageTime(lastMessageTime) {
    if (Array.isArray(lastMessageTime)) return lastMessageTime.reduce(function(p, c) {
        return p.current > c.current ? p : c;
    }).current;
    return lastMessageTime.current;
}
function $e11c90386a0d4857$var$heartbeat(ws, lastMessageTime, options) {
    var _a = options || {}, _b = _a.interval, interval = _b === void 0 ? $82ab36eb7f4f59e0$exports.DEFAULT_HEARTBEAT.interval : _b, _c = _a.timeout, timeout = _c === void 0 ? $82ab36eb7f4f59e0$exports.DEFAULT_HEARTBEAT.timeout : _c, _d = _a.message, message = _d === void 0 ? $82ab36eb7f4f59e0$exports.DEFAULT_HEARTBEAT.message : _d;
    // how often check interval between ping messages
    // minimum is 100ms
    // maximum is ${interval / 10}ms
    var intervalCheck = Math.max(100, interval / 10);
    var lastPingSentAt = Date.now();
    var heartbeatInterval = setInterval(function() {
        var timeNow = Date.now();
        var lastMessageReceivedAt = $e11c90386a0d4857$var$getLastMessageTime(lastMessageTime);
        if (lastMessageReceivedAt + timeout <= timeNow) {
            console.warn("Heartbeat timed out, closing connection, last message received ".concat(timeNow - lastMessageReceivedAt, "ms ago, last ping sent ").concat(timeNow - lastPingSentAt, "ms ago"));
            ws.close();
        } else {
            if (lastMessageReceivedAt + interval <= timeNow && lastPingSentAt + interval <= timeNow) try {
                if (typeof message === 'function') ws.send(message());
                else ws.send(message);
                lastPingSentAt = timeNow;
            } catch (err) {
                console.error("Heartbeat failed, closing connection", err instanceof Error ? err.message : err);
                ws.close();
            }
        }
    }, intervalCheck);
    ws.addEventListener("close", function() {
        clearInterval(heartbeatInterval);
    });
    return function() {};
}



var $e2a1024834c5021f$exports = {};
"use strict";
Object.defineProperty($e2a1024834c5021f$exports, "__esModule", {
    value: true
});
$e2a1024834c5021f$exports.assertIsWebSocket = $e2a1024834c5021f$var$assertIsWebSocket;
$e2a1024834c5021f$exports.resetGlobalState = $e2a1024834c5021f$var$resetGlobalState;

var $a9ac8f005bb37b91$exports = {};
"use strict";
Object.defineProperty($a9ac8f005bb37b91$exports, "__esModule", {
    value: true
});
$a9ac8f005bb37b91$exports.resetSubscribers = $a9ac8f005bb37b91$exports.removeSubscriber = $a9ac8f005bb37b91$exports.addSubscriber = $a9ac8f005bb37b91$exports.hasSubscribers = $a9ac8f005bb37b91$exports.getSubscribers = void 0;
var $a9ac8f005bb37b91$var$subscribers = {};
var $a9ac8f005bb37b91$var$EMPTY_LIST = [];
var $a9ac8f005bb37b91$var$getSubscribers = function(url) {
    if ((0, $a9ac8f005bb37b91$exports.hasSubscribers)(url)) return Array.from($a9ac8f005bb37b91$var$subscribers[url]);
    return $a9ac8f005bb37b91$var$EMPTY_LIST;
};
$a9ac8f005bb37b91$exports.getSubscribers = $a9ac8f005bb37b91$var$getSubscribers;
var $a9ac8f005bb37b91$var$hasSubscribers = function(url) {
    var _a;
    return ((_a = $a9ac8f005bb37b91$var$subscribers[url]) === null || _a === void 0 ? void 0 : _a.size) > 0;
};
$a9ac8f005bb37b91$exports.hasSubscribers = $a9ac8f005bb37b91$var$hasSubscribers;
var $a9ac8f005bb37b91$var$addSubscriber = function(url, subscriber) {
    $a9ac8f005bb37b91$var$subscribers[url] = $a9ac8f005bb37b91$var$subscribers[url] || new Set();
    $a9ac8f005bb37b91$var$subscribers[url].add(subscriber);
};
$a9ac8f005bb37b91$exports.addSubscriber = $a9ac8f005bb37b91$var$addSubscriber;
var $a9ac8f005bb37b91$var$removeSubscriber = function(url, subscriber) {
    $a9ac8f005bb37b91$var$subscribers[url].delete(subscriber);
};
$a9ac8f005bb37b91$exports.removeSubscriber = $a9ac8f005bb37b91$var$removeSubscriber;
var $a9ac8f005bb37b91$var$resetSubscribers = function(url) {
    if (url && $a9ac8f005bb37b91$var$subscribers.hasOwnProperty(url)) delete $a9ac8f005bb37b91$var$subscribers[url];
    else {
        for(var url_1 in $a9ac8f005bb37b91$var$subscribers)if ($a9ac8f005bb37b91$var$subscribers.hasOwnProperty(url_1)) delete $a9ac8f005bb37b91$var$subscribers[url_1];
    }
};
$a9ac8f005bb37b91$exports.resetSubscribers = $a9ac8f005bb37b91$var$resetSubscribers;


function $e2a1024834c5021f$var$assertIsWebSocket(webSocketInstance, skip) {
    if (!skip && webSocketInstance instanceof WebSocket === false) throw new Error('');
}
function $e2a1024834c5021f$var$resetGlobalState(url) {
    (0, $a9ac8f005bb37b91$exports.resetSubscribers)(url);
    (0, $8bc0c26a35afbd15$exports.resetWebSockets)(url);
}


var $8325a44677ee2483$var$bindMessageHandler = function(webSocketInstance, optionsRef, setLastMessage, lastMessageTime) {
    webSocketInstance.onmessage = function(message) {
        var _a;
        optionsRef.current.onMessage && optionsRef.current.onMessage(message);
        if (typeof (lastMessageTime === null || lastMessageTime === void 0 ? void 0 : lastMessageTime.current) === 'number') lastMessageTime.current = Date.now();
        if (typeof optionsRef.current.filter === 'function' && optionsRef.current.filter(message) !== true) return;
        if (optionsRef.current.heartbeat && typeof optionsRef.current.heartbeat !== "boolean" && ((_a = optionsRef.current.heartbeat) === null || _a === void 0 ? void 0 : _a.returnMessage) === message.data) return;
        setLastMessage(message);
    };
};
var $8325a44677ee2483$var$bindOpenHandler = function(webSocketInstance, optionsRef, setReadyState, reconnectCount, lastMessageTime) {
    webSocketInstance.onopen = function(event) {
        optionsRef.current.onOpen && optionsRef.current.onOpen(event);
        reconnectCount.current = 0;
        setReadyState($82ab36eb7f4f59e0$exports.ReadyState.OPEN);
        //start heart beat here
        if (optionsRef.current.heartbeat && webSocketInstance instanceof WebSocket) {
            var heartbeatOptions = typeof optionsRef.current.heartbeat === "boolean" ? undefined : optionsRef.current.heartbeat;
            lastMessageTime.current = Date.now();
            (0, $e11c90386a0d4857$exports.heartbeat)(webSocketInstance, lastMessageTime, heartbeatOptions);
        }
    };
};
var $8325a44677ee2483$var$bindCloseHandler = function(webSocketInstance, optionsRef, setReadyState, reconnect, reconnectCount) {
    if ($82ab36eb7f4f59e0$exports.isEventSourceSupported && webSocketInstance instanceof EventSource) return function() {};
    (0, $e2a1024834c5021f$exports.assertIsWebSocket)(webSocketInstance, optionsRef.current.skipAssert);
    var reconnectTimeout;
    webSocketInstance.onclose = function(event) {
        var _a;
        optionsRef.current.onClose && optionsRef.current.onClose(event);
        setReadyState($82ab36eb7f4f59e0$exports.ReadyState.CLOSED);
        if (optionsRef.current.shouldReconnect && optionsRef.current.shouldReconnect(event)) {
            var reconnectAttempts = (_a = optionsRef.current.reconnectAttempts) !== null && _a !== void 0 ? _a : $82ab36eb7f4f59e0$exports.DEFAULT_RECONNECT_LIMIT;
            if (reconnectCount.current < reconnectAttempts) {
                var nextReconnectInterval = typeof optionsRef.current.reconnectInterval === 'function' ? optionsRef.current.reconnectInterval(reconnectCount.current) : optionsRef.current.reconnectInterval;
                reconnectTimeout = window.setTimeout(function() {
                    reconnectCount.current++;
                    reconnect();
                }, nextReconnectInterval !== null && nextReconnectInterval !== void 0 ? nextReconnectInterval : $82ab36eb7f4f59e0$exports.DEFAULT_RECONNECT_INTERVAL_MS);
            } else {
                optionsRef.current.onReconnectStop && optionsRef.current.onReconnectStop(reconnectAttempts);
                console.warn("Max reconnect attempts of ".concat(reconnectAttempts, " exceeded"));
            }
        }
    };
    return function() {
        return reconnectTimeout && window.clearTimeout(reconnectTimeout);
    };
};
var $8325a44677ee2483$var$bindErrorHandler = function(webSocketInstance, optionsRef, setReadyState, reconnect, reconnectCount) {
    var reconnectTimeout;
    webSocketInstance.onerror = function(error) {
        var _a;
        optionsRef.current.onError && optionsRef.current.onError(error);
        if ($82ab36eb7f4f59e0$exports.isEventSourceSupported && webSocketInstance instanceof EventSource) {
            optionsRef.current.onClose && optionsRef.current.onClose($8325a44677ee2483$var$__assign($8325a44677ee2483$var$__assign({}, error), {
                code: 1006,
                reason: "An error occurred with the EventSource: ".concat(error),
                wasClean: false
            }));
            setReadyState($82ab36eb7f4f59e0$exports.ReadyState.CLOSED);
            webSocketInstance.close();
        }
        if (optionsRef.current.retryOnError) {
            if (reconnectCount.current < ((_a = optionsRef.current.reconnectAttempts) !== null && _a !== void 0 ? _a : $82ab36eb7f4f59e0$exports.DEFAULT_RECONNECT_LIMIT)) {
                var nextReconnectInterval = typeof optionsRef.current.reconnectInterval === 'function' ? optionsRef.current.reconnectInterval(reconnectCount.current) : optionsRef.current.reconnectInterval;
                reconnectTimeout = window.setTimeout(function() {
                    reconnectCount.current++;
                    reconnect();
                }, nextReconnectInterval !== null && nextReconnectInterval !== void 0 ? nextReconnectInterval : $82ab36eb7f4f59e0$exports.DEFAULT_RECONNECT_INTERVAL_MS);
            } else {
                optionsRef.current.onReconnectStop && optionsRef.current.onReconnectStop(optionsRef.current.reconnectAttempts);
                console.warn("Max reconnect attempts of ".concat(optionsRef.current.reconnectAttempts, " exceeded"));
            }
        }
    };
    return function() {
        return reconnectTimeout && window.clearTimeout(reconnectTimeout);
    };
};
var $8325a44677ee2483$var$attachListeners = function(webSocketInstance, setters, optionsRef, reconnect, reconnectCount, lastMessageTime, sendMessage) {
    var setLastMessage = setters.setLastMessage, setReadyState = setters.setReadyState;
    var interval;
    var cancelReconnectOnClose;
    var cancelReconnectOnError;
    if (optionsRef.current.fromSocketIO) interval = (0, $0589d1ab450cdbeb$exports.setUpSocketIOPing)(sendMessage);
    $8325a44677ee2483$var$bindMessageHandler(webSocketInstance, optionsRef, setLastMessage, lastMessageTime);
    $8325a44677ee2483$var$bindOpenHandler(webSocketInstance, optionsRef, setReadyState, reconnectCount, lastMessageTime);
    cancelReconnectOnClose = $8325a44677ee2483$var$bindCloseHandler(webSocketInstance, optionsRef, setReadyState, reconnect, reconnectCount);
    cancelReconnectOnError = $8325a44677ee2483$var$bindErrorHandler(webSocketInstance, optionsRef, setReadyState, reconnect, reconnectCount);
    return function() {
        setReadyState($82ab36eb7f4f59e0$exports.ReadyState.CLOSING);
        cancelReconnectOnClose();
        cancelReconnectOnError();
        webSocketInstance.close();
        if (interval) clearInterval(interval);
    };
};
$8325a44677ee2483$exports.attachListeners = $8325a44677ee2483$var$attachListeners;


var $b813532ae5e45850$exports = {};
"use strict";
var $b813532ae5e45850$var$__assign = $b813532ae5e45850$exports && $b813532ae5e45850$exports.__assign || function() {
    $b813532ae5e45850$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b813532ae5e45850$var$__assign.apply(this, arguments);
};
Object.defineProperty($b813532ae5e45850$exports, "__esModule", {
    value: true
});
$b813532ae5e45850$exports.attachSharedListeners = void 0;





var $b813532ae5e45850$var$bindMessageHandler = function(webSocketInstance, url, heartbeatOptions) {
    webSocketInstance.onmessage = function(message) {
        (0, $a9ac8f005bb37b91$exports.getSubscribers)(url).forEach(function(subscriber) {
            var _a;
            if (subscriber.optionsRef.current.onMessage) subscriber.optionsRef.current.onMessage(message);
            if (typeof ((_a = subscriber === null || subscriber === void 0 ? void 0 : subscriber.lastMessageTime) === null || _a === void 0 ? void 0 : _a.current) === 'number') subscriber.lastMessageTime.current = Date.now();
            if (typeof subscriber.optionsRef.current.filter === 'function' && subscriber.optionsRef.current.filter(message) !== true) return;
            if (heartbeatOptions && typeof heartbeatOptions !== "boolean" && (heartbeatOptions === null || heartbeatOptions === void 0 ? void 0 : heartbeatOptions.returnMessage) === message.data) return;
            subscriber.setLastMessage(message);
        });
    };
};
var $b813532ae5e45850$var$bindOpenHandler = function(webSocketInstance, url, heartbeatOptions) {
    webSocketInstance.onopen = function(event) {
        var subscribers = (0, $a9ac8f005bb37b91$exports.getSubscribers)(url);
        subscribers.forEach(function(subscriber) {
            subscriber.reconnectCount.current = 0;
            if (subscriber.optionsRef.current.onOpen) subscriber.optionsRef.current.onOpen(event);
            subscriber.setReadyState($82ab36eb7f4f59e0$exports.ReadyState.OPEN);
            var onMessageCb;
            if (heartbeatOptions && webSocketInstance instanceof WebSocket) subscriber.lastMessageTime.current = Date.now();
        });
        if (heartbeatOptions && webSocketInstance instanceof WebSocket) (0, $e11c90386a0d4857$exports.heartbeat)(webSocketInstance, subscribers.map(function(subscriber) {
            return subscriber.lastMessageTime;
        }), typeof heartbeatOptions === 'boolean' ? undefined : heartbeatOptions);
    };
};
var $b813532ae5e45850$var$bindCloseHandler = function(webSocketInstance, url) {
    if (webSocketInstance instanceof WebSocket) webSocketInstance.onclose = function(event) {
        (0, $a9ac8f005bb37b91$exports.getSubscribers)(url).forEach(function(subscriber) {
            if (subscriber.optionsRef.current.onClose) subscriber.optionsRef.current.onClose(event);
            subscriber.setReadyState($82ab36eb7f4f59e0$exports.ReadyState.CLOSED);
        });
        delete $8bc0c26a35afbd15$exports.sharedWebSockets[url];
        (0, $a9ac8f005bb37b91$exports.getSubscribers)(url).forEach(function(subscriber) {
            var _a;
            if (subscriber.optionsRef.current.shouldReconnect && subscriber.optionsRef.current.shouldReconnect(event)) {
                var reconnectAttempts = (_a = subscriber.optionsRef.current.reconnectAttempts) !== null && _a !== void 0 ? _a : $82ab36eb7f4f59e0$exports.DEFAULT_RECONNECT_LIMIT;
                if (subscriber.reconnectCount.current < reconnectAttempts) {
                    var nextReconnectInterval = typeof subscriber.optionsRef.current.reconnectInterval === 'function' ? subscriber.optionsRef.current.reconnectInterval(subscriber.reconnectCount.current) : subscriber.optionsRef.current.reconnectInterval;
                    setTimeout(function() {
                        subscriber.reconnectCount.current++;
                        subscriber.reconnect.current();
                    }, nextReconnectInterval !== null && nextReconnectInterval !== void 0 ? nextReconnectInterval : $82ab36eb7f4f59e0$exports.DEFAULT_RECONNECT_INTERVAL_MS);
                } else {
                    subscriber.optionsRef.current.onReconnectStop && subscriber.optionsRef.current.onReconnectStop(subscriber.optionsRef.current.reconnectAttempts);
                    console.warn("Max reconnect attempts of ".concat(reconnectAttempts, " exceeded"));
                }
            }
        });
    };
};
var $b813532ae5e45850$var$bindErrorHandler = function(webSocketInstance, url) {
    webSocketInstance.onerror = function(error) {
        (0, $a9ac8f005bb37b91$exports.getSubscribers)(url).forEach(function(subscriber) {
            if (subscriber.optionsRef.current.onError) subscriber.optionsRef.current.onError(error);
            if ($82ab36eb7f4f59e0$exports.isEventSourceSupported && webSocketInstance instanceof EventSource) {
                subscriber.optionsRef.current.onClose && subscriber.optionsRef.current.onClose($b813532ae5e45850$var$__assign($b813532ae5e45850$var$__assign({}, error), {
                    code: 1006,
                    reason: "An error occurred with the EventSource: ".concat(error),
                    wasClean: false
                }));
                subscriber.setReadyState($82ab36eb7f4f59e0$exports.ReadyState.CLOSED);
            }
        });
        if ($82ab36eb7f4f59e0$exports.isEventSourceSupported && webSocketInstance instanceof EventSource) webSocketInstance.close();
    };
};
var $b813532ae5e45850$var$attachSharedListeners = function(webSocketInstance, url, optionsRef, sendMessage) {
    var interval;
    if (optionsRef.current.fromSocketIO) interval = (0, $0589d1ab450cdbeb$exports.setUpSocketIOPing)(sendMessage);
    $b813532ae5e45850$var$bindMessageHandler(webSocketInstance, url, optionsRef.current.heartbeat);
    $b813532ae5e45850$var$bindCloseHandler(webSocketInstance, url);
    $b813532ae5e45850$var$bindOpenHandler(webSocketInstance, url, optionsRef.current.heartbeat);
    $b813532ae5e45850$var$bindErrorHandler(webSocketInstance, url);
    return function() {
        if (interval) clearInterval(interval);
    };
};
$b813532ae5e45850$exports.attachSharedListeners = $b813532ae5e45850$var$attachSharedListeners;



//TODO ensure that all onClose callbacks are called
var $52614030881c4083$var$cleanSubscribers = function(url, subscriber, optionsRef, setReadyState, clearSocketIoPingInterval) {
    return function() {
        (0, $a9ac8f005bb37b91$exports.removeSubscriber)(url, subscriber);
        if (!(0, $a9ac8f005bb37b91$exports.hasSubscribers)(url)) {
            try {
                var socketLike = $8bc0c26a35afbd15$exports.sharedWebSockets[url];
                if (socketLike instanceof WebSocket) socketLike.onclose = function(event) {
                    if (optionsRef.current.onClose) optionsRef.current.onClose(event);
                    setReadyState($82ab36eb7f4f59e0$exports.ReadyState.CLOSED);
                };
                socketLike.close();
            } catch (e) {}
            if (clearSocketIoPingInterval) clearSocketIoPingInterval();
            delete $8bc0c26a35afbd15$exports.sharedWebSockets[url];
        }
    };
};
var $52614030881c4083$var$createOrJoinSocket = function(webSocketRef, url, setReadyState, optionsRef, setLastMessage, startRef, reconnectCount, lastMessageTime, sendMessage) {
    if (!$82ab36eb7f4f59e0$exports.isEventSourceSupported && optionsRef.current.eventSourceOptions) {
        if ($82ab36eb7f4f59e0$exports.isReactNative) throw new Error('EventSource is not supported in ReactNative');
        else throw new Error('EventSource is not supported');
    }
    if (optionsRef.current.share) {
        var clearSocketIoPingInterval = null;
        if ($8bc0c26a35afbd15$exports.sharedWebSockets[url] === undefined) {
            $8bc0c26a35afbd15$exports.sharedWebSockets[url] = optionsRef.current.eventSourceOptions ? new EventSource(url, optionsRef.current.eventSourceOptions) : new WebSocket(url, optionsRef.current.protocols);
            webSocketRef.current = $8bc0c26a35afbd15$exports.sharedWebSockets[url];
            setReadyState($82ab36eb7f4f59e0$exports.ReadyState.CONNECTING);
            clearSocketIoPingInterval = (0, $b813532ae5e45850$exports.attachSharedListeners)($8bc0c26a35afbd15$exports.sharedWebSockets[url], url, optionsRef, sendMessage);
        } else {
            webSocketRef.current = $8bc0c26a35afbd15$exports.sharedWebSockets[url];
            setReadyState($8bc0c26a35afbd15$exports.sharedWebSockets[url].readyState);
        }
        var subscriber = {
            setLastMessage: setLastMessage,
            setReadyState: setReadyState,
            optionsRef: optionsRef,
            reconnectCount: reconnectCount,
            lastMessageTime: lastMessageTime,
            reconnect: startRef
        };
        (0, $a9ac8f005bb37b91$exports.addSubscriber)(url, subscriber);
        return $52614030881c4083$var$cleanSubscribers(url, subscriber, optionsRef, setReadyState, clearSocketIoPingInterval);
    } else {
        webSocketRef.current = optionsRef.current.eventSourceOptions ? new EventSource(url, optionsRef.current.eventSourceOptions) : new WebSocket(url, optionsRef.current.protocols);
        setReadyState($82ab36eb7f4f59e0$exports.ReadyState.CONNECTING);
        if (!webSocketRef.current) throw new Error('WebSocket failed to be created');
        return (0, $8325a44677ee2483$exports.attachListeners)(webSocketRef.current, {
            setLastMessage: setLastMessage,
            setReadyState: setReadyState
        }, optionsRef, startRef.current, reconnectCount, lastMessageTime, sendMessage);
    }
};
$52614030881c4083$exports.createOrJoinSocket = $52614030881c4083$var$createOrJoinSocket;


var $e534744cdedd9071$exports = {};
"use strict";
var $e534744cdedd9071$var$__awaiter = $e534744cdedd9071$exports && $e534744cdedd9071$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $e534744cdedd9071$var$__generator = $e534744cdedd9071$exports && $e534744cdedd9071$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $e534744cdedd9071$var$__spreadArray = $e534744cdedd9071$exports && $e534744cdedd9071$exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty($e534744cdedd9071$exports, "__esModule", {
    value: true
});
$e534744cdedd9071$exports.getUrl = void 0;


var $e534744cdedd9071$var$waitFor = function(duration) {
    return new Promise(function(resolve) {
        return window.setTimeout(resolve, duration);
    });
};
var $e534744cdedd9071$var$getUrl = function(url_1, optionsRef_1) {
    var args_1 = [];
    for(var _i = 2; _i < arguments.length; _i++)args_1[_i - 2] = arguments[_i];
    return $e534744cdedd9071$var$__awaiter(void 0, $e534744cdedd9071$var$__spreadArray([
        url_1,
        optionsRef_1
    ], args_1, true), void 0, function(url, optionsRef, retriedAttempts) {
        var convertedUrl, e_1, reconnectLimit, nextReconnectInterval, parsedUrl, parsedWithQueryParams;
        var _a, _b, _c;
        if (retriedAttempts === void 0) retriedAttempts = 0;
        return $e534744cdedd9071$var$__generator(this, function(_d) {
            switch(_d.label){
                case 0:
                    if (!(typeof url === 'function')) return [
                        3 /*break*/ ,
                        10
                    ];
                    _d.label = 1;
                case 1:
                    _d.trys.push([
                        1,
                        3,
                        ,
                        9
                    ]);
                    return [
                        4 /*yield*/ ,
                        url()
                    ];
                case 2:
                    convertedUrl = _d.sent();
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 3:
                    e_1 = _d.sent();
                    if (!optionsRef.current.retryOnError) return [
                        3 /*break*/ ,
                        7
                    ];
                    reconnectLimit = (_a = optionsRef.current.reconnectAttempts) !== null && _a !== void 0 ? _a : $82ab36eb7f4f59e0$exports.DEFAULT_RECONNECT_LIMIT;
                    if (!(retriedAttempts < reconnectLimit)) return [
                        3 /*break*/ ,
                        5
                    ];
                    nextReconnectInterval = typeof optionsRef.current.reconnectInterval === 'function' ? optionsRef.current.reconnectInterval(retriedAttempts) : optionsRef.current.reconnectInterval;
                    return [
                        4 /*yield*/ ,
                        $e534744cdedd9071$var$waitFor(nextReconnectInterval !== null && nextReconnectInterval !== void 0 ? nextReconnectInterval : $82ab36eb7f4f59e0$exports.DEFAULT_RECONNECT_INTERVAL_MS)
                    ];
                case 4:
                    _d.sent();
                    return [
                        2 /*return*/ ,
                        (0, $e534744cdedd9071$exports.getUrl)(url, optionsRef, retriedAttempts + 1)
                    ];
                case 5:
                    (_c = (_b = optionsRef.current).onReconnectStop) === null || _c === void 0 || _c.call(_b, retriedAttempts);
                    return [
                        2 /*return*/ ,
                        null
                    ];
                case 6:
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 7:
                    return [
                        2 /*return*/ ,
                        null
                    ];
                case 8:
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 9:
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    convertedUrl = url;
                    _d.label = 11;
                case 11:
                    parsedUrl = optionsRef.current.fromSocketIO ? (0, $0589d1ab450cdbeb$exports.parseSocketIOUrl)(convertedUrl) : convertedUrl;
                    parsedWithQueryParams = optionsRef.current.queryParams ? (0, $0589d1ab450cdbeb$exports.appendQueryParams)(parsedUrl, optionsRef.current.queryParams) : parsedUrl;
                    return [
                        2 /*return*/ ,
                        parsedWithQueryParams
                    ];
            }
        });
    });
};
$e534744cdedd9071$exports.getUrl = $e534744cdedd9071$var$getUrl;



var $17bda632513311c8$var$proxy_1 = $17bda632513311c8$var$__importDefault((parcelRequire("bARIT")));

var $17bda632513311c8$var$useWebSocket = function(url, options, connect) {
    if (options === void 0) options = $82ab36eb7f4f59e0$exports.DEFAULT_OPTIONS;
    if (connect === void 0) connect = true;
    var _a = (0, $5E6i4.useState)(null), lastMessage = _a[0], setLastMessage = _a[1];
    var _b = (0, $5E6i4.useState)({}), readyState = _b[0], setReadyState = _b[1];
    var lastJsonMessage = (0, $5E6i4.useMemo)(function() {
        if (!options.disableJson && lastMessage) try {
            return JSON.parse(lastMessage.data);
        } catch (e) {
            return $82ab36eb7f4f59e0$exports.UNPARSABLE_JSON_OBJECT;
        }
        return null;
    }, [
        lastMessage,
        options.disableJson
    ]);
    var convertedUrl = (0, $5E6i4.useRef)(null);
    var webSocketRef = (0, $5E6i4.useRef)(null);
    var startRef = (0, $5E6i4.useRef)(function() {
        return void 0;
    });
    var reconnectCount = (0, $5E6i4.useRef)(0);
    var lastMessageTime = (0, $5E6i4.useRef)(Date.now());
    var messageQueue = (0, $5E6i4.useRef)([]);
    var webSocketProxy = (0, $5E6i4.useRef)(null);
    var optionsCache = (0, $5E6i4.useRef)(options);
    optionsCache.current = options;
    var readyStateFromUrl = convertedUrl.current && readyState[convertedUrl.current] !== undefined ? readyState[convertedUrl.current] : url !== null && connect === true ? $82ab36eb7f4f59e0$exports.ReadyState.CONNECTING : $82ab36eb7f4f59e0$exports.ReadyState.UNINSTANTIATED;
    var stringifiedQueryParams = options.queryParams ? JSON.stringify(options.queryParams) : null;
    var sendMessage = (0, $5E6i4.useCallback)(function(message, keep) {
        var _a;
        if (keep === void 0) keep = true;
        if ($82ab36eb7f4f59e0$exports.isEventSourceSupported && webSocketRef.current instanceof EventSource) {
            console.warn('Unable to send a message from an eventSource');
            return;
        }
        if (((_a = webSocketRef.current) === null || _a === void 0 ? void 0 : _a.readyState) === $82ab36eb7f4f59e0$exports.ReadyState.OPEN) {
            (0, $e2a1024834c5021f$exports.assertIsWebSocket)(webSocketRef.current, optionsCache.current.skipAssert);
            webSocketRef.current.send(message);
        } else if (keep) messageQueue.current.push(message);
    }, []);
    var sendJsonMessage = (0, $5E6i4.useCallback)(function(message, keep) {
        if (keep === void 0) keep = true;
        sendMessage(JSON.stringify(message), keep);
    }, [
        sendMessage
    ]);
    var getWebSocket = (0, $5E6i4.useCallback)(function() {
        if (optionsCache.current.share !== true || $82ab36eb7f4f59e0$exports.isEventSourceSupported && webSocketRef.current instanceof EventSource) return webSocketRef.current;
        if (webSocketProxy.current === null && webSocketRef.current) {
            (0, $e2a1024834c5021f$exports.assertIsWebSocket)(webSocketRef.current, optionsCache.current.skipAssert);
            webSocketProxy.current = (0, $17bda632513311c8$var$proxy_1.default)(webSocketRef.current, startRef);
        }
        return webSocketProxy.current;
    }, []);
    (0, $5E6i4.useEffect)(function() {
        if (url !== null && connect === true) {
            var removeListeners_1;
            var expectClose_1 = false;
            var createOrJoin_1 = true;
            var start_1 = function() {
                return $17bda632513311c8$var$__awaiter(void 0, void 0, void 0, function() {
                    var _a, protectedSetLastMessage, protectedSetReadyState;
                    return $17bda632513311c8$var$__generator(this, function(_b) {
                        switch(_b.label){
                            case 0:
                                _a = convertedUrl;
                                return [
                                    4 /*yield*/ ,
                                    (0, $e534744cdedd9071$exports.getUrl)(url, optionsCache)
                                ];
                            case 1:
                                _a.current = _b.sent();
                                if (convertedUrl.current === null) {
                                    console.error('Failed to get a valid URL. WebSocket connection aborted.');
                                    convertedUrl.current = 'ABORTED';
                                    (0, $ibUU1.flushSync)(function() {
                                        return setReadyState(function(prev) {
                                            return $17bda632513311c8$var$__assign($17bda632513311c8$var$__assign({}, prev), {
                                                ABORTED: $82ab36eb7f4f59e0$exports.ReadyState.CLOSED
                                            });
                                        });
                                    });
                                    return [
                                        2 /*return*/ 
                                    ];
                                }
                                protectedSetLastMessage = function(message) {
                                    if (!expectClose_1) (0, $ibUU1.flushSync)(function() {
                                        return setLastMessage(message);
                                    });
                                };
                                protectedSetReadyState = function(state) {
                                    if (!expectClose_1) (0, $ibUU1.flushSync)(function() {
                                        return setReadyState(function(prev) {
                                            var _a;
                                            return $17bda632513311c8$var$__assign($17bda632513311c8$var$__assign({}, prev), convertedUrl.current && (_a = {}, _a[convertedUrl.current] = state, _a));
                                        });
                                    });
                                };
                                if (createOrJoin_1) removeListeners_1 = (0, $52614030881c4083$exports.createOrJoinSocket)(webSocketRef, convertedUrl.current, protectedSetReadyState, optionsCache, protectedSetLastMessage, startRef, reconnectCount, lastMessageTime, sendMessage);
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            };
            startRef.current = function() {
                if (!expectClose_1) {
                    if (webSocketProxy.current) webSocketProxy.current = null;
                    removeListeners_1 === null || removeListeners_1 === void 0 || removeListeners_1();
                    start_1();
                }
            };
            start_1();
            return function() {
                expectClose_1 = true;
                createOrJoin_1 = false;
                if (webSocketProxy.current) webSocketProxy.current = null;
                removeListeners_1 === null || removeListeners_1 === void 0 || removeListeners_1();
                setLastMessage(null);
            };
        } else if (url === null || connect === false) {
            reconnectCount.current = 0; // reset reconnection attempts
            setReadyState(function(prev) {
                var _a;
                return $17bda632513311c8$var$__assign($17bda632513311c8$var$__assign({}, prev), convertedUrl.current && (_a = {}, _a[convertedUrl.current] = $82ab36eb7f4f59e0$exports.ReadyState.CLOSED, _a));
            });
        }
    }, [
        url,
        connect,
        stringifiedQueryParams,
        sendMessage
    ]);
    (0, $5E6i4.useEffect)(function() {
        if (readyStateFromUrl === $82ab36eb7f4f59e0$exports.ReadyState.OPEN) messageQueue.current.splice(0).forEach(function(message) {
            sendMessage(message);
        });
    }, [
        readyStateFromUrl
    ]);
    return {
        sendMessage: sendMessage,
        sendJsonMessage: sendJsonMessage,
        lastMessage: lastMessage,
        lastJsonMessage: lastJsonMessage,
        readyState: readyStateFromUrl,
        getWebSocket: getWebSocket
    };
};
$17bda632513311c8$exports.useWebSocket = $17bda632513311c8$var$useWebSocket;


Object.defineProperty($feea5e2a23e1c45a$exports, "default", {
    enumerable: true,
    get: function() {
        return $17bda632513311c8$exports.useWebSocket;
    }
});
var $4538eb68d905ca1c$exports = {};
"use strict";
var $4538eb68d905ca1c$var$__assign = $4538eb68d905ca1c$exports && $4538eb68d905ca1c$exports.__assign || function() {
    $4538eb68d905ca1c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4538eb68d905ca1c$var$__assign.apply(this, arguments);
};
Object.defineProperty($4538eb68d905ca1c$exports, "__esModule", {
    value: true
});
$4538eb68d905ca1c$exports.useSocketIO = void 0;

var $5E6i4 = parcelRequire("5E6i4");


var $4538eb68d905ca1c$var$emptyEvent = {
    type: 'empty',
    payload: null
};
var $4538eb68d905ca1c$var$getSocketData = function(event) {
    if (!event || !event.data) return $4538eb68d905ca1c$var$emptyEvent;
    var match = event.data.match(/\[.*]/);
    if (!match) return $4538eb68d905ca1c$var$emptyEvent;
    var data = JSON.parse(match);
    if (!Array.isArray(data) || !data[1]) return $4538eb68d905ca1c$var$emptyEvent;
    return {
        type: data[0],
        payload: data[1]
    };
};
var $4538eb68d905ca1c$var$useSocketIO = function(url, options, connect) {
    if (options === void 0) options = $82ab36eb7f4f59e0$exports.DEFAULT_OPTIONS;
    if (connect === void 0) connect = true;
    var optionsWithSocketIO = (0, $5E6i4.useMemo)(function() {
        return $4538eb68d905ca1c$var$__assign($4538eb68d905ca1c$var$__assign({}, options), {
            fromSocketIO: true
        });
    }, []);
    var _a = (0, $17bda632513311c8$exports.useWebSocket)(url, optionsWithSocketIO, connect), sendMessage = _a.sendMessage, sendJsonMessage = _a.sendJsonMessage, lastMessage = _a.lastMessage, readyState = _a.readyState, getWebSocket = _a.getWebSocket;
    var socketIOLastMessage = (0, $5E6i4.useMemo)(function() {
        return $4538eb68d905ca1c$var$getSocketData(lastMessage);
    }, [
        lastMessage
    ]);
    return {
        sendMessage: sendMessage,
        sendJsonMessage: sendJsonMessage,
        lastMessage: socketIOLastMessage,
        lastJsonMessage: socketIOLastMessage,
        readyState: readyState,
        getWebSocket: getWebSocket
    };
};
$4538eb68d905ca1c$exports.useSocketIO = $4538eb68d905ca1c$var$useSocketIO;


Object.defineProperty($feea5e2a23e1c45a$exports, "useSocketIO", {
    enumerable: true,
    get: function() {
        return $4538eb68d905ca1c$exports.useSocketIO;
    }
});

Object.defineProperty($feea5e2a23e1c45a$exports, "ReadyState", {
    enumerable: true,
    get: function() {
        return $82ab36eb7f4f59e0$exports.ReadyState;
    }
});
var $d7609d83006db1e0$exports = {};
"use strict";
var $d7609d83006db1e0$var$__assign = $d7609d83006db1e0$exports && $d7609d83006db1e0$exports.__assign || function() {
    $d7609d83006db1e0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d7609d83006db1e0$var$__assign.apply(this, arguments);
};
var $d7609d83006db1e0$var$__rest = $d7609d83006db1e0$exports && $d7609d83006db1e0$exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
Object.defineProperty($d7609d83006db1e0$exports, "__esModule", {
    value: true
});
$d7609d83006db1e0$exports.useEventSource = void 0;

var $5E6i4 = parcelRequire("5E6i4");


var $d7609d83006db1e0$var$useEventSource = function(url, _a, connect) {
    if (_a === void 0) _a = $82ab36eb7f4f59e0$exports.DEFAULT_EVENT_SOURCE_OPTIONS;
    var withCredentials = _a.withCredentials, events = _a.events, options = $d7609d83006db1e0$var$__rest(_a, [
        "withCredentials",
        "events"
    ]);
    if (connect === void 0) connect = true;
    var optionsWithEventSource = $d7609d83006db1e0$var$__assign($d7609d83006db1e0$var$__assign({}, options), {
        eventSourceOptions: {
            withCredentials: withCredentials
        }
    });
    var eventsRef = (0, $5E6i4.useRef)($82ab36eb7f4f59e0$exports.EMPTY_EVENT_HANDLERS);
    if (events) eventsRef.current = events;
    var _b = (0, $17bda632513311c8$exports.useWebSocket)(url, optionsWithEventSource, connect), lastMessage = _b.lastMessage, readyState = _b.readyState, getWebSocket = _b.getWebSocket;
    (0, $5E6i4.useEffect)(function() {
        if (lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.type) Object.entries(eventsRef.current).forEach(function(_a) {
            var type = _a[0], handler = _a[1];
            if (type === lastMessage.type) handler(lastMessage);
        });
    }, [
        lastMessage
    ]);
    return {
        lastEvent: lastMessage,
        readyState: readyState,
        getEventSource: getWebSocket
    };
};
$d7609d83006db1e0$exports.useEventSource = $d7609d83006db1e0$var$useEventSource;


Object.defineProperty($feea5e2a23e1c45a$exports, "useEventSource", {
    enumerable: true,
    get: function() {
        return $d7609d83006db1e0$exports.useEventSource;
    }
});

Object.defineProperty($feea5e2a23e1c45a$exports, "resetGlobalState", {
    enumerable: true,
    get: function() {
        return $e2a1024834c5021f$exports.resetGlobalState;
    }
});



var $4c574b2b3c7bfc41$exports = {};
/*! For license information please see opensheetmusicdisplay.min.js.LICENSE.txt */ 
var $cbQCu = parcelRequire("cbQCu");
var $4c574b2b3c7bfc41$require$Buffer = $cbQCu.Buffer;

var $4Jj9n = parcelRequire("4Jj9n");
!function(t, e) {
    $4c574b2b3c7bfc41$exports = e();
}($4c574b2b3c7bfc41$exports, ()=>(()=>{
        var t = {
            1710 (t, e, i) {
                t.exports = (function t(e, i, s) {
                    function n(o, a) {
                        if (!i[o]) {
                            if (!e[o]) {
                                if (r) return r(o, !0);
                                var l = new Error("Cannot find module '" + o + "'");
                                throw l.code = "MODULE_NOT_FOUND", l;
                            }
                            var h = i[o] = {
                                exports: {}
                            };
                            e[o][0].call(h.exports, function(t) {
                                return n(e[o][1][t] || t);
                            }, h, h.exports, t, e, i, s);
                        }
                        return i[o].exports;
                    }
                    for(var r = void 0, o = 0; o < s.length; o++)n(s[o]);
                    return n;
                })({
                    1: [
                        function(t, e, i) {
                            "use strict";
                            var s = t("./utils"), n = t("./support"), r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                            i.encode = function(t) {
                                for(var e, i, n, o, a, l, h, c = [], u = 0, d = t.length, f = d, m = "string" !== s.getTypeOf(t); u < t.length;)f = d - u, n = m ? (e = t[u++], i = u < d ? t[u++] : 0, u < d ? t[u++] : 0) : (e = t.charCodeAt(u++), i = u < d ? t.charCodeAt(u++) : 0, u < d ? t.charCodeAt(u++) : 0), o = e >> 2, a = (3 & e) << 4 | i >> 4, l = 1 < f ? (15 & i) << 2 | n >> 6 : 64, h = 2 < f ? 63 & n : 64, c.push(r.charAt(o) + r.charAt(a) + r.charAt(l) + r.charAt(h));
                                return c.join("");
                            }, i.decode = function(t) {
                                var e, i, s, o, a, l, h = 0, c = 0, u = "data:";
                                if (t.substr(0, 5) === u) throw new Error("Invalid base64 input, it looks like a data url.");
                                var d, f = 3 * (t = t.replace(/[^A-Za-z0-9+/=]/g, "")).length / 4;
                                if (t.charAt(t.length - 1) === r.charAt(64) && f--, t.charAt(t.length - 2) === r.charAt(64) && f--, f % 1 != 0) throw new Error("Invalid base64 input, bad content length.");
                                for(d = n.uint8array ? new Uint8Array(0 | f) : new Array(0 | f); h < t.length;)e = r.indexOf(t.charAt(h++)) << 2 | (o = r.indexOf(t.charAt(h++))) >> 4, i = (15 & o) << 4 | (a = r.indexOf(t.charAt(h++))) >> 2, s = (3 & a) << 6 | (l = r.indexOf(t.charAt(h++))), d[c++] = e, 64 !== a && (d[c++] = i), 64 !== l && (d[c++] = s);
                                return d;
                            };
                        },
                        {
                            "./support": 30,
                            "./utils": 32
                        }
                    ],
                    2: [
                        function(t, e, i) {
                            "use strict";
                            var s = t("./external"), n = t("./stream/DataWorker"), r = t("./stream/Crc32Probe"), o = t("./stream/DataLengthProbe");
                            function a(t, e, i, s, n) {
                                this.compressedSize = t, this.uncompressedSize = e, this.crc32 = i, this.compression = s, this.compressedContent = n;
                            }
                            a.prototype = {
                                getContentWorker: function() {
                                    var t = new n(s.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new o("data_length")), e = this;
                                    return t.on("end", function() {
                                        if (this.streamInfo.data_length !== e.uncompressedSize) throw new Error("Bug : uncompressed data size mismatch");
                                    }), t;
                                },
                                getCompressedWorker: function() {
                                    return new n(s.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
                                }
                            }, a.createWorkerFrom = function(t, e, i) {
                                return t.pipe(new r).pipe(new o("uncompressedSize")).pipe(e.compressWorker(i)).pipe(new o("compressedSize")).withStreamInfo("compression", e);
                            }, e.exports = a;
                        },
                        {
                            "./external": 6,
                            "./stream/Crc32Probe": 25,
                            "./stream/DataLengthProbe": 26,
                            "./stream/DataWorker": 27
                        }
                    ],
                    3: [
                        function(t, e, i) {
                            "use strict";
                            var s = t("./stream/GenericWorker");
                            i.STORE = {
                                magic: "\0\0",
                                compressWorker: function() {
                                    return new s("STORE compression");
                                },
                                uncompressWorker: function() {
                                    return new s("STORE decompression");
                                }
                            }, i.DEFLATE = t("./flate");
                        },
                        {
                            "./flate": 7,
                            "./stream/GenericWorker": 28
                        }
                    ],
                    4: [
                        function(t, e, i) {
                            "use strict";
                            var s = t("./utils"), n = function() {
                                for(var t, e = [], i = 0; i < 256; i++){
                                    t = i;
                                    for(var s = 0; s < 8; s++)t = 1 & t ? 3988292384 ^ t >>> 1 : t >>> 1;
                                    e[i] = t;
                                }
                                return e;
                            }();
                            e.exports = function(t, e) {
                                return void 0 !== t && t.length ? "string" !== s.getTypeOf(t) ? function(t, e, i) {
                                    var s = n, r = 0 + i;
                                    t ^= -1;
                                    for(var o = 0; o < r; o++)t = t >>> 8 ^ s[255 & (t ^ e[o])];
                                    return -1 ^ t;
                                }(0 | e, t, t.length) : function(t, e, i) {
                                    var s = n, r = 0 + i;
                                    t ^= -1;
                                    for(var o = 0; o < r; o++)t = t >>> 8 ^ s[255 & (t ^ e.charCodeAt(o))];
                                    return -1 ^ t;
                                }(0 | e, t, t.length) : 0;
                            };
                        },
                        {
                            "./utils": 32
                        }
                    ],
                    5: [
                        function(t, e, i) {
                            "use strict";
                            i.base64 = !1, i.binary = !1, i.dir = !1, i.createFolders = !0, i.date = null, i.compression = null, i.compressionOptions = null, i.comment = null, i.unixPermissions = null, i.dosPermissions = null;
                        },
                        {}
                    ],
                    6: [
                        function(t, e, i) {
                            "use strict";
                            var s;
                            s = "undefined" != typeof Promise ? Promise : t("lie"), e.exports = {
                                Promise: s
                            };
                        },
                        {
                            lie: 37
                        }
                    ],
                    7: [
                        function(t, e, i) {
                            "use strict";
                            var s = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Uint32Array, n = t("pako"), r = t("./utils"), o = t("./stream/GenericWorker"), a = s ? "uint8array" : "array";
                            function l(t, e) {
                                o.call(this, "FlateWorker/" + t), this._pako = null, this._pakoAction = t, this._pakoOptions = e, this.meta = {};
                            }
                            i.magic = "\b\0", r.inherits(l, o), l.prototype.processChunk = function(t) {
                                this.meta = t.meta, null === this._pako && this._createPako(), this._pako.push(r.transformTo(a, t.data), !1);
                            }, l.prototype.flush = function() {
                                o.prototype.flush.call(this), null === this._pako && this._createPako(), this._pako.push([], !0);
                            }, l.prototype.cleanUp = function() {
                                o.prototype.cleanUp.call(this), this._pako = null;
                            }, l.prototype._createPako = function() {
                                this._pako = new n[this._pakoAction]({
                                    raw: !0,
                                    level: this._pakoOptions.level || -1
                                });
                                var t = this;
                                this._pako.onData = function(e) {
                                    t.push({
                                        data: e,
                                        meta: t.meta
                                    });
                                };
                            }, i.compressWorker = function(t) {
                                return new l("Deflate", t);
                            }, i.uncompressWorker = function() {
                                return new l("Inflate", {});
                            };
                        },
                        {
                            "./stream/GenericWorker": 28,
                            "./utils": 32,
                            pako: 38
                        }
                    ],
                    8: [
                        function(t, e, i) {
                            "use strict";
                            function s(t, e) {
                                var i, s = "";
                                for(i = 0; i < e; i++)s += String.fromCharCode(255 & t), t >>>= 8;
                                return s;
                            }
                            function n(t, e, i, n, o, c) {
                                var u, d, f = t.file, m = t.compression, p = c !== a.utf8encode, g = r.transformTo("string", c(f.name)), b = r.transformTo("string", a.utf8encode(f.name)), S = f.comment, y = r.transformTo("string", c(S)), E = r.transformTo("string", a.utf8encode(S)), x = b.length !== f.name.length, v = E.length !== S.length, T = "", _ = "", M = "", P = f.dir, L = f.date, w = {
                                    crc32: 0,
                                    compressedSize: 0,
                                    uncompressedSize: 0
                                };
                                e && !i || (w.crc32 = t.crc32, w.compressedSize = t.compressedSize, w.uncompressedSize = t.uncompressedSize);
                                var A = 0;
                                e && (A |= 8), p || !x && !v || (A |= 2048);
                                var I = 0, R = 0;
                                P && (I |= 16), "UNIX" === o ? (R = 798, I |= function(t, e) {
                                    var i = t;
                                    return t || (i = e ? 16893 : 33204), (65535 & i) << 16;
                                }(f.unixPermissions, P)) : (R = 20, I |= function(t) {
                                    return 63 & (t || 0);
                                }(f.dosPermissions)), u = L.getUTCHours(), u <<= 6, u |= L.getUTCMinutes(), u <<= 5, u |= L.getUTCSeconds() / 2, d = L.getUTCFullYear() - 1980, d <<= 4, d |= L.getUTCMonth() + 1, d <<= 5, d |= L.getUTCDate(), x && (_ = s(1, 1) + s(l(g), 4) + b, T += "up" + s(_.length, 2) + _), v && (M = s(1, 1) + s(l(y), 4) + E, T += "uc" + s(M.length, 2) + M);
                                var N = "";
                                return N += "\n\0", N += s(A, 2), N += m.magic, N += s(u, 2), N += s(d, 2), N += s(w.crc32, 4), N += s(w.compressedSize, 4), N += s(w.uncompressedSize, 4), N += s(g.length, 2), N += s(T.length, 2), {
                                    fileRecord: h.LOCAL_FILE_HEADER + N + g + T,
                                    dirRecord: h.CENTRAL_FILE_HEADER + s(R, 2) + N + s(y.length, 2) + "\0\0\0\0" + s(I, 4) + s(n, 4) + g + T + y
                                };
                            }
                            var r = t("../utils"), o = t("../stream/GenericWorker"), a = t("../utf8"), l = t("../crc32"), h = t("../signature");
                            function c(t, e, i, s) {
                                o.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = e, this.zipPlatform = i, this.encodeFileName = s, this.streamFiles = t, this.accumulate = !1, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
                            }
                            r.inherits(c, o), c.prototype.push = function(t) {
                                var e = t.meta.percent || 0, i = this.entriesCount, s = this._sources.length;
                                this.accumulate ? this.contentBuffer.push(t) : (this.bytesWritten += t.data.length, o.prototype.push.call(this, {
                                    data: t.data,
                                    meta: {
                                        currentFile: this.currentFile,
                                        percent: i ? (e + 100 * (i - s - 1)) / i : 100
                                    }
                                }));
                            }, c.prototype.openedSource = function(t) {
                                this.currentSourceOffset = this.bytesWritten, this.currentFile = t.file.name;
                                var e = this.streamFiles && !t.file.dir;
                                if (e) {
                                    var i = n(t, e, !1, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                                    this.push({
                                        data: i.fileRecord,
                                        meta: {
                                            percent: 0
                                        }
                                    });
                                } else this.accumulate = !0;
                            }, c.prototype.closedSource = function(t) {
                                this.accumulate = !1;
                                var e = this.streamFiles && !t.file.dir, i = n(t, e, !0, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                                if (this.dirRecords.push(i.dirRecord), e) this.push({
                                    data: function(t) {
                                        return h.DATA_DESCRIPTOR + s(t.crc32, 4) + s(t.compressedSize, 4) + s(t.uncompressedSize, 4);
                                    }(t),
                                    meta: {
                                        percent: 100
                                    }
                                });
                                else for(this.push({
                                    data: i.fileRecord,
                                    meta: {
                                        percent: 0
                                    }
                                }); this.contentBuffer.length;)this.push(this.contentBuffer.shift());
                                this.currentFile = null;
                            }, c.prototype.flush = function() {
                                for(var t = this.bytesWritten, e = 0; e < this.dirRecords.length; e++)this.push({
                                    data: this.dirRecords[e],
                                    meta: {
                                        percent: 100
                                    }
                                });
                                var i = this.bytesWritten - t, n = function(t, e, i, n, o) {
                                    var a = r.transformTo("string", o(n));
                                    return h.CENTRAL_DIRECTORY_END + "\0\0\0\0" + s(t, 2) + s(t, 2) + s(e, 4) + s(i, 4) + s(a.length, 2) + a;
                                }(this.dirRecords.length, i, t, this.zipComment, this.encodeFileName);
                                this.push({
                                    data: n,
                                    meta: {
                                        percent: 100
                                    }
                                });
                            }, c.prototype.prepareNextSource = function() {
                                this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
                            }, c.prototype.registerPrevious = function(t) {
                                this._sources.push(t);
                                var e = this;
                                return t.on("data", function(t) {
                                    e.processChunk(t);
                                }), t.on("end", function() {
                                    e.closedSource(e.previous.streamInfo), e._sources.length ? e.prepareNextSource() : e.end();
                                }), t.on("error", function(t) {
                                    e.error(t);
                                }), this;
                            }, c.prototype.resume = function() {
                                return !!o.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), !0) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), !0));
                            }, c.prototype.error = function(t) {
                                var e = this._sources;
                                if (!o.prototype.error.call(this, t)) return !1;
                                for(var i = 0; i < e.length; i++)try {
                                    e[i].error(t);
                                } catch (t) {}
                                return !0;
                            }, c.prototype.lock = function() {
                                o.prototype.lock.call(this);
                                for(var t = this._sources, e = 0; e < t.length; e++)t[e].lock();
                            }, e.exports = c;
                        },
                        {
                            "../crc32": 4,
                            "../signature": 23,
                            "../stream/GenericWorker": 28,
                            "../utf8": 31,
                            "../utils": 32
                        }
                    ],
                    9: [
                        function(t, e, i) {
                            "use strict";
                            var s = t("../compressions"), n = t("./ZipFileWorker");
                            i.generateWorker = function(t, e, i) {
                                var r = new n(e.streamFiles, i, e.platform, e.encodeFileName), o = 0;
                                try {
                                    t.forEach(function(t, i) {
                                        o++;
                                        var n = function(t, e) {
                                            var i = t || e, n = s[i];
                                            if (!n) throw new Error(i + " is not a valid compression method !");
                                            return n;
                                        }(i.options.compression, e.compression), a = i.options.compressionOptions || e.compressionOptions || {}, l = i.dir, h = i.date;
                                        i._compressWorker(n, a).withStreamInfo("file", {
                                            name: t,
                                            dir: l,
                                            date: h,
                                            comment: i.comment || "",
                                            unixPermissions: i.unixPermissions,
                                            dosPermissions: i.dosPermissions
                                        }).pipe(r);
                                    }), r.entriesCount = o;
                                } catch (t) {
                                    r.error(t);
                                }
                                return r;
                            };
                        },
                        {
                            "../compressions": 3,
                            "./ZipFileWorker": 8
                        }
                    ],
                    10: [
                        function(t, e, i) {
                            "use strict";
                            function s() {
                                if (!(this instanceof s)) return new s;
                                if (arguments.length) throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
                                this.files = Object.create(null), this.comment = null, this.root = "", this.clone = function() {
                                    var t = new s;
                                    for(var e in this)"function" != typeof this[e] && (t[e] = this[e]);
                                    return t;
                                };
                            }
                            (s.prototype = t("./object")).loadAsync = t("./load"), s.support = t("./support"), s.defaults = t("./defaults"), s.version = "3.10.1", s.loadAsync = function(t, e) {
                                return (new s).loadAsync(t, e);
                            }, s.external = t("./external"), e.exports = s;
                        },
                        {
                            "./defaults": 5,
                            "./external": 6,
                            "./load": 11,
                            "./object": 15,
                            "./support": 30
                        }
                    ],
                    11: [
                        function(t, e, i) {
                            "use strict";
                            var s = t("./utils"), n = t("./external"), r = t("./utf8"), o = t("./zipEntries"), a = t("./stream/Crc32Probe"), l = t("./nodejsUtils");
                            function h(t) {
                                return new n.Promise(function(e, i) {
                                    var s = t.decompressed.getContentWorker().pipe(new a);
                                    s.on("error", function(t) {
                                        i(t);
                                    }).on("end", function() {
                                        s.streamInfo.crc32 !== t.decompressed.crc32 ? i(new Error("Corrupted zip : CRC32 mismatch")) : e();
                                    }).resume();
                                });
                            }
                            e.exports = function(t, e) {
                                var i = this;
                                return e = s.extend(e || {}, {
                                    base64: !1,
                                    checkCRC32: !1,
                                    optimizedBinaryString: !1,
                                    createFolders: !1,
                                    decodeFileName: r.utf8decode
                                }), l.isNode && l.isStream(t) ? n.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : s.prepareContent("the loaded zip file", t, !0, e.optimizedBinaryString, e.base64).then(function(t) {
                                    var i = new o(e);
                                    return i.load(t), i;
                                }).then(function(t) {
                                    var i = [
                                        n.Promise.resolve(t)
                                    ], s = t.files;
                                    if (e.checkCRC32) for(var r = 0; r < s.length; r++)i.push(h(s[r]));
                                    return n.Promise.all(i);
                                }).then(function(t) {
                                    for(var n = t.shift(), r = n.files, o = 0; o < r.length; o++){
                                        var a = r[o], l = a.fileNameStr, h = s.resolve(a.fileNameStr);
                                        i.file(h, a.decompressed, {
                                            binary: !0,
                                            optimizedBinaryString: !0,
                                            date: a.date,
                                            dir: a.dir,
                                            comment: a.fileCommentStr.length ? a.fileCommentStr : null,
                                            unixPermissions: a.unixPermissions,
                                            dosPermissions: a.dosPermissions,
                                            createFolders: e.createFolders
                                        }), a.dir || (i.file(h).unsafeOriginalName = l);
                                    }
                                    return n.zipComment.length && (i.comment = n.zipComment), i;
                                });
                            };
                        },
                        {
                            "./external": 6,
                            "./nodejsUtils": 14,
                            "./stream/Crc32Probe": 25,
                            "./utf8": 31,
                            "./utils": 32,
                            "./zipEntries": 33
                        }
                    ],
                    12: [
                        function(t, e, i) {
                            "use strict";
                            var s = t("../utils"), n = t("../stream/GenericWorker");
                            function r(t, e) {
                                n.call(this, "Nodejs stream input adapter for " + t), this._upstreamEnded = !1, this._bindStream(e);
                            }
                            s.inherits(r, n), r.prototype._bindStream = function(t) {
                                var e = this;
                                (this._stream = t).pause(), t.on("data", function(t) {
                                    e.push({
                                        data: t,
                                        meta: {
                                            percent: 0
                                        }
                                    });
                                }).on("error", function(t) {
                                    e.isPaused ? this.generatedError = t : e.error(t);
                                }).on("end", function() {
                                    e.isPaused ? e._upstreamEnded = !0 : e.end();
                                });
                            }, r.prototype.pause = function() {
                                return !!n.prototype.pause.call(this) && (this._stream.pause(), !0);
                            }, r.prototype.resume = function() {
                                return !!n.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), !0);
                            }, e.exports = r;
                        },
                        {
                            "../stream/GenericWorker": 28,
                            "../utils": 32
                        }
                    ],
                    13: [
                        function(t, e, i) {
                            "use strict";
                            var s = t("readable-stream").Readable;
                            function n(t, e, i) {
                                s.call(this, e), this._helper = t;
                                var n = this;
                                t.on("data", function(t, e) {
                                    n.push(t) || n._helper.pause(), i && i(e);
                                }).on("error", function(t) {
                                    n.emit("error", t);
                                }).on("end", function() {
                                    n.push(null);
                                });
                            }
                            t("../utils").inherits(n, s), n.prototype._read = function() {
                                this._helper.resume();
                            }, e.exports = n;
                        },
                        {
                            "../utils": 32,
                            "readable-stream": 16
                        }
                    ],
                    14: [
                        function(t, e, i) {
                            "use strict";
                            e.exports = {
                                isNode: "undefined" != typeof $4c574b2b3c7bfc41$require$Buffer,
                                newBufferFrom: function(t, e) {
                                    if ($4c574b2b3c7bfc41$require$Buffer.from && $4c574b2b3c7bfc41$require$Buffer.from !== Uint8Array.from) return $4c574b2b3c7bfc41$require$Buffer.from(t, e);
                                    if ("number" == typeof t) throw new Error('The "data" argument must not be a number');
                                    return new $4c574b2b3c7bfc41$require$Buffer(t, e);
                                },
                                allocBuffer: function(t) {
                                    if ($4c574b2b3c7bfc41$require$Buffer.alloc) return $4c574b2b3c7bfc41$require$Buffer.alloc(t);
                                    var e = new $4c574b2b3c7bfc41$require$Buffer(t);
                                    return e.fill(0), e;
                                },
                                isBuffer: function(t) {
                                    return $4c574b2b3c7bfc41$require$Buffer.isBuffer(t);
                                },
                                isStream: function(t) {
                                    return t && "function" == typeof t.on && "function" == typeof t.pause && "function" == typeof t.resume;
                                }
                            };
                        },
                        {}
                    ],
                    15: [
                        function(t, e, i) {
                            "use strict";
                            function s(t, e, i) {
                                var s, n = r.getTypeOf(e), a = r.extend(i || {}, l);
                                a.date = a.date || new Date, null !== a.compression && (a.compression = a.compression.toUpperCase()), "string" == typeof a.unixPermissions && (a.unixPermissions = parseInt(a.unixPermissions, 8)), a.unixPermissions && 16384 & a.unixPermissions && (a.dir = !0), a.dosPermissions && 16 & a.dosPermissions && (a.dir = !0), a.dir && (t = p(t)), a.createFolders && (s = m(t)) && g.call(this, s, !0);
                                var u = "string" === n && !1 === a.binary && !1 === a.base64;
                                i && void 0 !== i.binary || (a.binary = !u), (e instanceof h && 0 === e.uncompressedSize || a.dir || !e || 0 === e.length) && (a.base64 = !1, a.binary = !0, e = "", a.compression = "STORE", n = "string");
                                var b;
                                b = e instanceof h || e instanceof o ? e : d.isNode && d.isStream(e) ? new f(t, e) : r.prepareContent(t, e, a.binary, a.optimizedBinaryString, a.base64);
                                var S = new c(t, b, a);
                                this.files[t] = S;
                            }
                            var n = t("./utf8"), r = t("./utils"), o = t("./stream/GenericWorker"), a = t("./stream/StreamHelper"), l = t("./defaults"), h = t("./compressedObject"), c = t("./zipObject"), u = t("./generate"), d = t("./nodejsUtils"), f = t("./nodejs/NodejsStreamInputAdapter"), m = function(t) {
                                "/" === t.slice(-1) && (t = t.substring(0, t.length - 1));
                                var e = t.lastIndexOf("/");
                                return 0 < e ? t.substring(0, e) : "";
                            }, p = function(t) {
                                return "/" !== t.slice(-1) && (t += "/"), t;
                            }, g = function(t, e) {
                                return e = void 0 !== e ? e : l.createFolders, t = p(t), this.files[t] || s.call(this, t, null, {
                                    dir: !0,
                                    createFolders: e
                                }), this.files[t];
                            };
                            function b(t) {
                                return "[object RegExp]" === Object.prototype.toString.call(t);
                            }
                            var S = {
                                load: function() {
                                    throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                                },
                                forEach: function(t) {
                                    var e, i, s;
                                    for(e in this.files)s = this.files[e], (i = e.slice(this.root.length, e.length)) && e.slice(0, this.root.length) === this.root && t(i, s);
                                },
                                filter: function(t) {
                                    var e = [];
                                    return this.forEach(function(i, s) {
                                        t(i, s) && e.push(s);
                                    }), e;
                                },
                                file: function(t, e, i) {
                                    if (1 !== arguments.length) return t = this.root + t, s.call(this, t, e, i), this;
                                    if (b(t)) {
                                        var n = t;
                                        return this.filter(function(t, e) {
                                            return !e.dir && n.test(t);
                                        });
                                    }
                                    var r = this.files[this.root + t];
                                    return r && !r.dir ? r : null;
                                },
                                folder: function(t) {
                                    if (!t) return this;
                                    if (b(t)) return this.filter(function(e, i) {
                                        return i.dir && t.test(e);
                                    });
                                    var e = this.root + t, i = g.call(this, e), s = this.clone();
                                    return s.root = i.name, s;
                                },
                                remove: function(t) {
                                    t = this.root + t;
                                    var e = this.files[t];
                                    if (e || ("/" !== t.slice(-1) && (t += "/"), e = this.files[t]), e && !e.dir) delete this.files[t];
                                    else for(var i = this.filter(function(e, i) {
                                        return i.name.slice(0, t.length) === t;
                                    }), s = 0; s < i.length; s++)delete this.files[i[s].name];
                                    return this;
                                },
                                generate: function() {
                                    throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                                },
                                generateInternalStream: function(t) {
                                    var e, i = {};
                                    try {
                                        if ((i = r.extend(t || {}, {
                                            streamFiles: !1,
                                            compression: "STORE",
                                            compressionOptions: null,
                                            type: "",
                                            platform: "DOS",
                                            comment: null,
                                            mimeType: "application/zip",
                                            encodeFileName: n.utf8encode
                                        })).type = i.type.toLowerCase(), i.compression = i.compression.toUpperCase(), "binarystring" === i.type && (i.type = "string"), !i.type) throw new Error("No output type specified.");
                                        r.checkSupport(i.type), "darwin" !== i.platform && "freebsd" !== i.platform && "linux" !== i.platform && "sunos" !== i.platform || (i.platform = "UNIX"), "win32" === i.platform && (i.platform = "DOS");
                                        var s = i.comment || this.comment || "";
                                        e = u.generateWorker(this, i, s);
                                    } catch (t) {
                                        (e = new o("error")).error(t);
                                    }
                                    return new a(e, i.type || "string", i.mimeType);
                                },
                                generateAsync: function(t, e) {
                                    return this.generateInternalStream(t).accumulate(e);
                                },
                                generateNodeStream: function(t, e) {
                                    return (t = t || {}).type || (t.type = "nodebuffer"), this.generateInternalStream(t).toNodejsStream(e);
                                }
                            };
                            e.exports = S;
                        },
                        {
                            "./compressedObject": 2,
                            "./defaults": 5,
                            "./generate": 9,
                            "./nodejs/NodejsStreamInputAdapter": 12,
                            "./nodejsUtils": 14,
                            "./stream/GenericWorker": 28,
                            "./stream/StreamHelper": 29,
                            "./utf8": 31,
                            "./utils": 32,
                            "./zipObject": 35
                        }
                    ],
                    16: [
                        function(t, e, i) {
                            "use strict";
                            e.exports = t("stream");
                        },
                        {
                            stream: void 0
                        }
                    ],
                    17: [
                        function(t, e, i) {
                            "use strict";
                            var s = t("./DataReader");
                            function n(t) {
                                s.call(this, t);
                                for(var e = 0; e < this.data.length; e++)t[e] = 255 & t[e];
                            }
                            t("../utils").inherits(n, s), n.prototype.byteAt = function(t) {
                                return this.data[this.zero + t];
                            }, n.prototype.lastIndexOfSignature = function(t) {
                                for(var e = t.charCodeAt(0), i = t.charCodeAt(1), s = t.charCodeAt(2), n = t.charCodeAt(3), r = this.length - 4; 0 <= r; --r)if (this.data[r] === e && this.data[r + 1] === i && this.data[r + 2] === s && this.data[r + 3] === n) return r - this.zero;
                                return -1;
                            }, n.prototype.readAndCheckSignature = function(t) {
                                var e = t.charCodeAt(0), i = t.charCodeAt(1), s = t.charCodeAt(2), n = t.charCodeAt(3), r = this.readData(4);
                                return e === r[0] && i === r[1] && s === r[2] && n === r[3];
                            }, n.prototype.readData = function(t) {
                                if (this.checkOffset(t), 0 === t) return [];
                                var e = this.data.slice(this.zero + this.index, this.zero + this.index + t);
                                return this.index += t, e;
                            }, e.exports = n;
                        },
                        {
                            "../utils": 32,
                            "./DataReader": 18
                        }
                    ],
                    18: [
                        function(t, e, i) {
                            "use strict";
                            var s = t("../utils");
                            function n(t) {
                                this.data = t, this.length = t.length, this.index = 0, this.zero = 0;
                            }
                            n.prototype = {
                                checkOffset: function(t) {
                                    this.checkIndex(this.index + t);
                                },
                                checkIndex: function(t) {
                                    if (this.length < this.zero + t || t < 0) throw new Error("End of data reached (data length = " + this.length + ", asked index = " + t + "). Corrupted zip ?");
                                },
                                setIndex: function(t) {
                                    this.checkIndex(t), this.index = t;
                                },
                                skip: function(t) {
                                    this.setIndex(this.index + t);
                                },
                                byteAt: function() {},
                                readInt: function(t) {
                                    var e, i = 0;
                                    for(this.checkOffset(t), e = this.index + t - 1; e >= this.index; e--)i = (i << 8) + this.byteAt(e);
                                    return this.index += t, i;
                                },
                                readString: function(t) {
                                    return s.transformTo("string", this.readData(t));
                                },
                                readData: function() {},
                                lastIndexOfSignature: function() {},
                                readAndCheckSignature: function() {},
                                readDate: function() {
                                    var t = this.readInt(4);
                                    return new Date(Date.UTC(1980 + (t >> 25 & 127), (t >> 21 & 15) - 1, t >> 16 & 31, t >> 11 & 31, t >> 5 & 63, (31 & t) << 1));
                                }
                            }, e.exports = n;
                        },
                        {
                            "../utils": 32
                        }
                    ],
                    19: [
                        function(t, e, i) {
                            "use strict";
                            var s = t("./Uint8ArrayReader");
                            function n(t) {
                                s.call(this, t);
                            }
                            t("../utils").inherits(n, s), n.prototype.readData = function(t) {
                                this.checkOffset(t);
                                var e = this.data.slice(this.zero + this.index, this.zero + this.index + t);
                                return this.index += t, e;
                            }, e.exports = n;
                        },
                        {
                            "../utils": 32,
                            "./Uint8ArrayReader": 21
                        }
                    ],
                    20: [
                        function(t, e, i) {
                            "use strict";
                            var s = t("./DataReader");
                            function n(t) {
                                s.call(this, t);
                            }
                            t("../utils").inherits(n, s), n.prototype.byteAt = function(t) {
                                return this.data.charCodeAt(this.zero + t);
                            }, n.prototype.lastIndexOfSignature = function(t) {
                                return this.data.lastIndexOf(t) - this.zero;
                            }, n.prototype.readAndCheckSignature = function(t) {
                                return t === this.readData(4);
                            }, n.prototype.readData = function(t) {
                                this.checkOffset(t);
                                var e = this.data.slice(this.zero + this.index, this.zero + this.index + t);
                                return this.index += t, e;
                            }, e.exports = n;
                        },
                        {
                            "../utils": 32,
                            "./DataReader": 18
                        }
                    ],
                    21: [
                        function(t, e, i) {
                            "use strict";
                            var s = t("./ArrayReader");
                            function n(t) {
                                s.call(this, t);
                            }
                            t("../utils").inherits(n, s), n.prototype.readData = function(t) {
                                if (this.checkOffset(t), 0 === t) return new Uint8Array(0);
                                var e = this.data.subarray(this.zero + this.index, this.zero + this.index + t);
                                return this.index += t, e;
                            }, e.exports = n;
                        },
                        {
                            "../utils": 32,
                            "./ArrayReader": 17
                        }
                    ],
                    22: [
                        function(t, e, i) {
                            "use strict";
                            var s = t("../utils"), n = t("../support"), r = t("./ArrayReader"), o = t("./StringReader"), a = t("./NodeBufferReader"), l = t("./Uint8ArrayReader");
                            e.exports = function(t) {
                                var e = s.getTypeOf(t);
                                return s.checkSupport(e), "string" !== e || n.uint8array ? "nodebuffer" === e ? new a(t) : n.uint8array ? new l(s.transformTo("uint8array", t)) : new r(s.transformTo("array", t)) : new o(t);
                            };
                        },
                        {
                            "../support": 30,
                            "../utils": 32,
                            "./ArrayReader": 17,
                            "./NodeBufferReader": 19,
                            "./StringReader": 20,
                            "./Uint8ArrayReader": 21
                        }
                    ],
                    23: [
                        function(t, e, i) {
                            "use strict";
                            i.LOCAL_FILE_HEADER = "PK", i.CENTRAL_FILE_HEADER = "PK", i.CENTRAL_DIRECTORY_END = "PK", i.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK", i.ZIP64_CENTRAL_DIRECTORY_END = "PK", i.DATA_DESCRIPTOR = "PK\b";
                        },
                        {}
                    ],
                    24: [
                        function(t, e, i) {
                            "use strict";
                            var s = t("./GenericWorker"), n = t("../utils");
                            function r(t) {
                                s.call(this, "ConvertWorker to " + t), this.destType = t;
                            }
                            n.inherits(r, s), r.prototype.processChunk = function(t) {
                                this.push({
                                    data: n.transformTo(this.destType, t.data),
                                    meta: t.meta
                                });
                            }, e.exports = r;
                        },
                        {
                            "../utils": 32,
                            "./GenericWorker": 28
                        }
                    ],
                    25: [
                        function(t, e, i) {
                            "use strict";
                            var s = t("./GenericWorker"), n = t("../crc32");
                            function r() {
                                s.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
                            }
                            t("../utils").inherits(r, s), r.prototype.processChunk = function(t) {
                                this.streamInfo.crc32 = n(t.data, this.streamInfo.crc32 || 0), this.push(t);
                            }, e.exports = r;
                        },
                        {
                            "../crc32": 4,
                            "../utils": 32,
                            "./GenericWorker": 28
                        }
                    ],
                    26: [
                        function(t, e, i) {
                            "use strict";
                            var s = t("../utils"), n = t("./GenericWorker");
                            function r(t) {
                                n.call(this, "DataLengthProbe for " + t), this.propName = t, this.withStreamInfo(t, 0);
                            }
                            s.inherits(r, n), r.prototype.processChunk = function(t) {
                                if (t) {
                                    var e = this.streamInfo[this.propName] || 0;
                                    this.streamInfo[this.propName] = e + t.data.length;
                                }
                                n.prototype.processChunk.call(this, t);
                            }, e.exports = r;
                        },
                        {
                            "../utils": 32,
                            "./GenericWorker": 28
                        }
                    ],
                    27: [
                        function(t, e, i) {
                            "use strict";
                            var s = t("../utils"), n = t("./GenericWorker");
                            function r(t) {
                                n.call(this, "DataWorker");
                                var e = this;
                                this.dataIsReady = !1, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = !1, t.then(function(t) {
                                    e.dataIsReady = !0, e.data = t, e.max = t && t.length || 0, e.type = s.getTypeOf(t), e.isPaused || e._tickAndRepeat();
                                }, function(t) {
                                    e.error(t);
                                });
                            }
                            s.inherits(r, n), r.prototype.cleanUp = function() {
                                n.prototype.cleanUp.call(this), this.data = null;
                            }, r.prototype.resume = function() {
                                return !!n.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = !0, s.delay(this._tickAndRepeat, [], this)), !0);
                            }, r.prototype._tickAndRepeat = function() {
                                this._tickScheduled = !1, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (s.delay(this._tickAndRepeat, [], this), this._tickScheduled = !0));
                            }, r.prototype._tick = function() {
                                if (this.isPaused || this.isFinished) return !1;
                                var t = null, e = Math.min(this.max, this.index + 16384);
                                if (this.index >= this.max) return this.end();
                                switch(this.type){
                                    case "string":
                                        t = this.data.substring(this.index, e);
                                        break;
                                    case "uint8array":
                                        t = this.data.subarray(this.index, e);
                                        break;
                                    case "array":
                                    case "nodebuffer":
                                        t = this.data.slice(this.index, e);
                                }
                                return this.index = e, this.push({
                                    data: t,
                                    meta: {
                                        percent: this.max ? this.index / this.max * 100 : 0
                                    }
                                });
                            }, e.exports = r;
                        },
                        {
                            "../utils": 32,
                            "./GenericWorker": 28
                        }
                    ],
                    28: [
                        function(t, e, i) {
                            "use strict";
                            function s(t) {
                                this.name = t || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = !0, this.isFinished = !1, this.isLocked = !1, this._listeners = {
                                    data: [],
                                    end: [],
                                    error: []
                                }, this.previous = null;
                            }
                            s.prototype = {
                                push: function(t) {
                                    this.emit("data", t);
                                },
                                end: function() {
                                    if (this.isFinished) return !1;
                                    this.flush();
                                    try {
                                        this.emit("end"), this.cleanUp(), this.isFinished = !0;
                                    } catch (t) {
                                        this.emit("error", t);
                                    }
                                    return !0;
                                },
                                error: function(t) {
                                    return !this.isFinished && (this.isPaused ? this.generatedError = t : (this.isFinished = !0, this.emit("error", t), this.previous && this.previous.error(t), this.cleanUp()), !0);
                                },
                                on: function(t, e) {
                                    return this._listeners[t].push(e), this;
                                },
                                cleanUp: function() {
                                    this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
                                },
                                emit: function(t, e) {
                                    if (this._listeners[t]) for(var i = 0; i < this._listeners[t].length; i++)this._listeners[t][i].call(this, e);
                                },
                                pipe: function(t) {
                                    return t.registerPrevious(this);
                                },
                                registerPrevious: function(t) {
                                    if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                                    this.streamInfo = t.streamInfo, this.mergeStreamInfo(), this.previous = t;
                                    var e = this;
                                    return t.on("data", function(t) {
                                        e.processChunk(t);
                                    }), t.on("end", function() {
                                        e.end();
                                    }), t.on("error", function(t) {
                                        e.error(t);
                                    }), this;
                                },
                                pause: function() {
                                    return !this.isPaused && !this.isFinished && (this.isPaused = !0, this.previous && this.previous.pause(), !0);
                                },
                                resume: function() {
                                    if (!this.isPaused || this.isFinished) return !1;
                                    var t = this.isPaused = !1;
                                    return this.generatedError && (this.error(this.generatedError), t = !0), this.previous && this.previous.resume(), !t;
                                },
                                flush: function() {},
                                processChunk: function(t) {
                                    this.push(t);
                                },
                                withStreamInfo: function(t, e) {
                                    return this.extraStreamInfo[t] = e, this.mergeStreamInfo(), this;
                                },
                                mergeStreamInfo: function() {
                                    for(var t in this.extraStreamInfo)Object.prototype.hasOwnProperty.call(this.extraStreamInfo, t) && (this.streamInfo[t] = this.extraStreamInfo[t]);
                                },
                                lock: function() {
                                    if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                                    this.isLocked = !0, this.previous && this.previous.lock();
                                },
                                toString: function() {
                                    var t = "Worker " + this.name;
                                    return this.previous ? this.previous + " -> " + t : t;
                                }
                            }, e.exports = s;
                        },
                        {}
                    ],
                    29: [
                        function(t, e, i) {
                            "use strict";
                            var s = t("../utils"), n = t("./ConvertWorker"), r = t("./GenericWorker"), o = t("../base64"), a = t("../support"), l = t("../external"), h = null;
                            if (a.nodestream) try {
                                h = t("../nodejs/NodejsStreamOutputAdapter");
                            } catch (t) {}
                            function c(t, e, i) {
                                var o = e;
                                switch(e){
                                    case "blob":
                                    case "arraybuffer":
                                        o = "uint8array";
                                        break;
                                    case "base64":
                                        o = "string";
                                }
                                try {
                                    this._internalType = o, this._outputType = e, this._mimeType = i, s.checkSupport(o), this._worker = t.pipe(new n(o)), t.lock();
                                } catch (t) {
                                    this._worker = new r("error"), this._worker.error(t);
                                }
                            }
                            c.prototype = {
                                accumulate: function(t) {
                                    return function(t, e) {
                                        return new l.Promise(function(i, n) {
                                            var r = [], a = t._internalType, l = t._outputType, h = t._mimeType;
                                            t.on("data", function(t, i) {
                                                r.push(t), e && e(i);
                                            }).on("error", function(t) {
                                                r = [], n(t);
                                            }).on("end", function() {
                                                try {
                                                    var t = function(t, e, i) {
                                                        switch(t){
                                                            case "blob":
                                                                return s.newBlob(s.transformTo("arraybuffer", e), i);
                                                            case "base64":
                                                                return o.encode(e);
                                                            default:
                                                                return s.transformTo(t, e);
                                                        }
                                                    }(l, function(t, e) {
                                                        var i, s = 0, n = null, r = 0;
                                                        for(i = 0; i < e.length; i++)r += e[i].length;
                                                        switch(t){
                                                            case "string":
                                                                return e.join("");
                                                            case "array":
                                                                return Array.prototype.concat.apply([], e);
                                                            case "uint8array":
                                                                for(n = new Uint8Array(r), i = 0; i < e.length; i++)n.set(e[i], s), s += e[i].length;
                                                                return n;
                                                            case "nodebuffer":
                                                                return $4c574b2b3c7bfc41$require$Buffer.concat(e);
                                                            default:
                                                                throw new Error("concat : unsupported type '" + t + "'");
                                                        }
                                                    }(a, r), h);
                                                    i(t);
                                                } catch (t) {
                                                    n(t);
                                                }
                                                r = [];
                                            }).resume();
                                        });
                                    }(this, t);
                                },
                                on: function(t, e) {
                                    var i = this;
                                    return "data" === t ? this._worker.on(t, function(t) {
                                        e.call(i, t.data, t.meta);
                                    }) : this._worker.on(t, function() {
                                        s.delay(e, arguments, i);
                                    }), this;
                                },
                                resume: function() {
                                    return s.delay(this._worker.resume, [], this._worker), this;
                                },
                                pause: function() {
                                    return this._worker.pause(), this;
                                },
                                toNodejsStream: function(t) {
                                    if (s.checkSupport("nodestream"), "nodebuffer" !== this._outputType) throw new Error(this._outputType + " is not supported by this method");
                                    return new h(this, {
                                        objectMode: "nodebuffer" !== this._outputType
                                    }, t);
                                }
                            }, e.exports = c;
                        },
                        {
                            "../base64": 1,
                            "../external": 6,
                            "../nodejs/NodejsStreamOutputAdapter": 13,
                            "../support": 30,
                            "../utils": 32,
                            "./ConvertWorker": 24,
                            "./GenericWorker": 28
                        }
                    ],
                    30: [
                        function(t, e, i) {
                            "use strict";
                            if (i.base64 = !0, i.array = !0, i.string = !0, i.arraybuffer = "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array, i.nodebuffer = "undefined" != typeof $4c574b2b3c7bfc41$require$Buffer, i.uint8array = "undefined" != typeof Uint8Array, "undefined" == typeof ArrayBuffer) i.blob = !1;
                            else {
                                var s = new ArrayBuffer(0);
                                try {
                                    i.blob = 0 === new Blob([
                                        s
                                    ], {
                                        type: "application/zip"
                                    }).size;
                                } catch (t) {
                                    try {
                                        var n = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                                        n.append(s), i.blob = 0 === n.getBlob("application/zip").size;
                                    } catch (t) {
                                        i.blob = !1;
                                    }
                                }
                            }
                            try {
                                i.nodestream = !!t("readable-stream").Readable;
                            } catch (t) {
                                i.nodestream = !1;
                            }
                        },
                        {
                            "readable-stream": 16
                        }
                    ],
                    31: [
                        function(t, e, i) {
                            "use strict";
                            for(var s = t("./utils"), n = t("./support"), r = t("./nodejsUtils"), o = t("./stream/GenericWorker"), a = new Array(256), l = 0; l < 256; l++)a[l] = 252 <= l ? 6 : 248 <= l ? 5 : 240 <= l ? 4 : 224 <= l ? 3 : 192 <= l ? 2 : 1;
                            function h() {
                                o.call(this, "utf-8 decode"), this.leftOver = null;
                            }
                            function c() {
                                o.call(this, "utf-8 encode");
                            }
                            a[254] = a[254] = 1, i.utf8encode = function(t) {
                                return n.nodebuffer ? r.newBufferFrom(t, "utf-8") : function(t) {
                                    var e, i, s, r, o, a = t.length, l = 0;
                                    for(r = 0; r < a; r++)55296 == (64512 & (i = t.charCodeAt(r))) && r + 1 < a && 56320 == (64512 & (s = t.charCodeAt(r + 1))) && (i = 65536 + (i - 55296 << 10) + (s - 56320), r++), l += i < 128 ? 1 : i < 2048 ? 2 : i < 65536 ? 3 : 4;
                                    for(e = n.uint8array ? new Uint8Array(l) : new Array(l), r = o = 0; o < l; r++)55296 == (64512 & (i = t.charCodeAt(r))) && r + 1 < a && 56320 == (64512 & (s = t.charCodeAt(r + 1))) && (i = 65536 + (i - 55296 << 10) + (s - 56320), r++), i < 128 ? e[o++] = i : (i < 2048 ? e[o++] = 192 | i >>> 6 : (i < 65536 ? e[o++] = 224 | i >>> 12 : (e[o++] = 240 | i >>> 18, e[o++] = 128 | i >>> 12 & 63), e[o++] = 128 | i >>> 6 & 63), e[o++] = 128 | 63 & i);
                                    return e;
                                }(t);
                            }, i.utf8decode = function(t) {
                                return n.nodebuffer ? s.transformTo("nodebuffer", t).toString("utf-8") : function(t) {
                                    var e, i, n, r, o = t.length, l = new Array(2 * o);
                                    for(e = i = 0; e < o;)if ((n = t[e++]) < 128) l[i++] = n;
                                    else if (4 < (r = a[n])) l[i++] = 65533, e += r - 1;
                                    else {
                                        for(n &= 2 === r ? 31 : 3 === r ? 15 : 7; 1 < r && e < o;)n = n << 6 | 63 & t[e++], r--;
                                        1 < r ? l[i++] = 65533 : n < 65536 ? l[i++] = n : (n -= 65536, l[i++] = 55296 | n >> 10 & 1023, l[i++] = 56320 | 1023 & n);
                                    }
                                    return l.length !== i && (l.subarray ? l = l.subarray(0, i) : l.length = i), s.applyFromCharCode(l);
                                }(t = s.transformTo(n.uint8array ? "uint8array" : "array", t));
                            }, s.inherits(h, o), h.prototype.processChunk = function(t) {
                                var e = s.transformTo(n.uint8array ? "uint8array" : "array", t.data);
                                if (this.leftOver && this.leftOver.length) {
                                    if (n.uint8array) {
                                        var r = e;
                                        (e = new Uint8Array(r.length + this.leftOver.length)).set(this.leftOver, 0), e.set(r, this.leftOver.length);
                                    } else e = this.leftOver.concat(e);
                                    this.leftOver = null;
                                }
                                var o = function(t, e) {
                                    var i;
                                    for((e = e || t.length) > t.length && (e = t.length), i = e - 1; 0 <= i && 128 == (192 & t[i]);)i--;
                                    return i < 0 || 0 === i ? e : i + a[t[i]] > e ? i : e;
                                }(e), l = e;
                                o !== e.length && (n.uint8array ? (l = e.subarray(0, o), this.leftOver = e.subarray(o, e.length)) : (l = e.slice(0, o), this.leftOver = e.slice(o, e.length))), this.push({
                                    data: i.utf8decode(l),
                                    meta: t.meta
                                });
                            }, h.prototype.flush = function() {
                                this.leftOver && this.leftOver.length && (this.push({
                                    data: i.utf8decode(this.leftOver),
                                    meta: {}
                                }), this.leftOver = null);
                            }, i.Utf8DecodeWorker = h, s.inherits(c, o), c.prototype.processChunk = function(t) {
                                this.push({
                                    data: i.utf8encode(t.data),
                                    meta: t.meta
                                });
                            }, i.Utf8EncodeWorker = c;
                        },
                        {
                            "./nodejsUtils": 14,
                            "./stream/GenericWorker": 28,
                            "./support": 30,
                            "./utils": 32
                        }
                    ],
                    32: [
                        function(t, e, i) {
                            "use strict";
                            var s = t("./support"), n = t("./base64"), r = t("./nodejsUtils"), o = t("./external");
                            function a(t) {
                                return t;
                            }
                            function l(t, e) {
                                for(var i = 0; i < t.length; ++i)e[i] = 255 & t.charCodeAt(i);
                                return e;
                            }
                            t("setimmediate"), i.newBlob = function(t, e) {
                                i.checkSupport("blob");
                                try {
                                    return new Blob([
                                        t
                                    ], {
                                        type: e
                                    });
                                } catch (i) {
                                    try {
                                        var s = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                                        return s.append(t), s.getBlob(e);
                                    } catch (t) {
                                        throw new Error("Bug : can't construct the Blob.");
                                    }
                                }
                            };
                            var h = {
                                stringifyByChunk: function(t, e, i) {
                                    var s = [], n = 0, r = t.length;
                                    if (r <= i) return String.fromCharCode.apply(null, t);
                                    for(; n < r;)"array" === e || "nodebuffer" === e ? s.push(String.fromCharCode.apply(null, t.slice(n, Math.min(n + i, r)))) : s.push(String.fromCharCode.apply(null, t.subarray(n, Math.min(n + i, r)))), n += i;
                                    return s.join("");
                                },
                                stringifyByChar: function(t) {
                                    for(var e = "", i = 0; i < t.length; i++)e += String.fromCharCode(t[i]);
                                    return e;
                                },
                                applyCanBeUsed: {
                                    uint8array: function() {
                                        try {
                                            return s.uint8array && 1 === String.fromCharCode.apply(null, new Uint8Array(1)).length;
                                        } catch (t) {
                                            return !1;
                                        }
                                    }(),
                                    nodebuffer: function() {
                                        try {
                                            return s.nodebuffer && 1 === String.fromCharCode.apply(null, r.allocBuffer(1)).length;
                                        } catch (t) {
                                            return !1;
                                        }
                                    }()
                                }
                            };
                            function c(t) {
                                var e = 65536, s = i.getTypeOf(t), n = !0;
                                if ("uint8array" === s ? n = h.applyCanBeUsed.uint8array : "nodebuffer" === s && (n = h.applyCanBeUsed.nodebuffer), n) for(; 1 < e;)try {
                                    return h.stringifyByChunk(t, s, e);
                                } catch (t) {
                                    e = Math.floor(e / 2);
                                }
                                return h.stringifyByChar(t);
                            }
                            function u(t, e) {
                                for(var i = 0; i < t.length; i++)e[i] = t[i];
                                return e;
                            }
                            i.applyFromCharCode = c;
                            var d = {};
                            d.string = {
                                string: a,
                                array: function(t) {
                                    return l(t, new Array(t.length));
                                },
                                arraybuffer: function(t) {
                                    return d.string.uint8array(t).buffer;
                                },
                                uint8array: function(t) {
                                    return l(t, new Uint8Array(t.length));
                                },
                                nodebuffer: function(t) {
                                    return l(t, r.allocBuffer(t.length));
                                }
                            }, d.array = {
                                string: c,
                                array: a,
                                arraybuffer: function(t) {
                                    return new Uint8Array(t).buffer;
                                },
                                uint8array: function(t) {
                                    return new Uint8Array(t);
                                },
                                nodebuffer: function(t) {
                                    return r.newBufferFrom(t);
                                }
                            }, d.arraybuffer = {
                                string: function(t) {
                                    return c(new Uint8Array(t));
                                },
                                array: function(t) {
                                    return u(new Uint8Array(t), new Array(t.byteLength));
                                },
                                arraybuffer: a,
                                uint8array: function(t) {
                                    return new Uint8Array(t);
                                },
                                nodebuffer: function(t) {
                                    return r.newBufferFrom(new Uint8Array(t));
                                }
                            }, d.uint8array = {
                                string: c,
                                array: function(t) {
                                    return u(t, new Array(t.length));
                                },
                                arraybuffer: function(t) {
                                    return t.buffer;
                                },
                                uint8array: a,
                                nodebuffer: function(t) {
                                    return r.newBufferFrom(t);
                                }
                            }, d.nodebuffer = {
                                string: c,
                                array: function(t) {
                                    return u(t, new Array(t.length));
                                },
                                arraybuffer: function(t) {
                                    return d.nodebuffer.uint8array(t).buffer;
                                },
                                uint8array: function(t) {
                                    return u(t, new Uint8Array(t.length));
                                },
                                nodebuffer: a
                            }, i.transformTo = function(t, e) {
                                if (e = e || "", !t) return e;
                                i.checkSupport(t);
                                var s = i.getTypeOf(e);
                                return d[s][t](e);
                            }, i.resolve = function(t) {
                                for(var e = t.split("/"), i = [], s = 0; s < e.length; s++){
                                    var n = e[s];
                                    "." === n || "" === n && 0 !== s && s !== e.length - 1 || (".." === n ? i.pop() : i.push(n));
                                }
                                return i.join("/");
                            }, i.getTypeOf = function(t) {
                                return "string" == typeof t ? "string" : "[object Array]" === Object.prototype.toString.call(t) ? "array" : s.nodebuffer && r.isBuffer(t) ? "nodebuffer" : s.uint8array && t instanceof Uint8Array ? "uint8array" : s.arraybuffer && t instanceof ArrayBuffer ? "arraybuffer" : void 0;
                            }, i.checkSupport = function(t) {
                                if (!s[t.toLowerCase()]) throw new Error(t + " is not supported by this platform");
                            }, i.MAX_VALUE_16BITS = 65535, i.MAX_VALUE_32BITS = -1, i.pretty = function(t) {
                                var e, i, s = "";
                                for(i = 0; i < (t || "").length; i++)s += "\\x" + ((e = t.charCodeAt(i)) < 16 ? "0" : "") + e.toString(16).toUpperCase();
                                return s;
                            }, i.delay = function(t, e, i) {
                                setImmediate(function() {
                                    t.apply(i || null, e || []);
                                });
                            }, i.inherits = function(t, e) {
                                function i() {}
                                i.prototype = e.prototype, t.prototype = new i;
                            }, i.extend = function() {
                                var t, e, i = {};
                                for(t = 0; t < arguments.length; t++)for(e in arguments[t])Object.prototype.hasOwnProperty.call(arguments[t], e) && void 0 === i[e] && (i[e] = arguments[t][e]);
                                return i;
                            }, i.prepareContent = function(t, e, r, a, h) {
                                return o.Promise.resolve(e).then(function(t) {
                                    return s.blob && (t instanceof Blob || -1 !== [
                                        "[object File]",
                                        "[object Blob]"
                                    ].indexOf(Object.prototype.toString.call(t))) && "undefined" != typeof FileReader ? new o.Promise(function(e, i) {
                                        var s = new FileReader;
                                        s.onload = function(t) {
                                            e(t.target.result);
                                        }, s.onerror = function(t) {
                                            i(t.target.error);
                                        }, s.readAsArrayBuffer(t);
                                    }) : t;
                                }).then(function(e) {
                                    var c = i.getTypeOf(e);
                                    return c ? ("arraybuffer" === c ? e = i.transformTo("uint8array", e) : "string" === c && (h ? e = n.decode(e) : r && !0 !== a && (e = function(t) {
                                        return l(t, s.uint8array ? new Uint8Array(t.length) : new Array(t.length));
                                    }(e))), e) : o.Promise.reject(new Error("Can't read the data of '" + t + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
                                });
                            };
                        },
                        {
                            "./base64": 1,
                            "./external": 6,
                            "./nodejsUtils": 14,
                            "./support": 30,
                            setimmediate: 54
                        }
                    ],
                    33: [
                        function(t, e, i) {
                            "use strict";
                            var s = t("./reader/readerFor"), n = t("./utils"), r = t("./signature"), o = t("./zipEntry"), a = t("./support");
                            function l(t) {
                                this.files = [], this.loadOptions = t;
                            }
                            l.prototype = {
                                checkSignature: function(t) {
                                    if (!this.reader.readAndCheckSignature(t)) {
                                        this.reader.index -= 4;
                                        var e = this.reader.readString(4);
                                        throw new Error("Corrupted zip or bug: unexpected signature (" + n.pretty(e) + ", expected " + n.pretty(t) + ")");
                                    }
                                },
                                isSignature: function(t, e) {
                                    var i = this.reader.index;
                                    this.reader.setIndex(t);
                                    var s = this.reader.readString(4) === e;
                                    return this.reader.setIndex(i), s;
                                },
                                readBlockEndOfCentral: function() {
                                    this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
                                    var t = this.reader.readData(this.zipCommentLength), e = a.uint8array ? "uint8array" : "array", i = n.transformTo(e, t);
                                    this.zipComment = this.loadOptions.decodeFileName(i);
                                },
                                readBlockZip64EndOfCentral: function() {
                                    this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
                                    for(var t, e, i, s = this.zip64EndOfCentralSize - 44; 0 < s;)t = this.reader.readInt(2), e = this.reader.readInt(4), i = this.reader.readData(e), this.zip64ExtensibleData[t] = {
                                        id: t,
                                        length: e,
                                        value: i
                                    };
                                },
                                readBlockZip64EndOfCentralLocator: function() {
                                    if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount) throw new Error("Multi-volumes zip are not supported");
                                },
                                readLocalFiles: function() {
                                    var t, e;
                                    for(t = 0; t < this.files.length; t++)e = this.files[t], this.reader.setIndex(e.localHeaderOffset), this.checkSignature(r.LOCAL_FILE_HEADER), e.readLocalPart(this.reader), e.handleUTF8(), e.processAttributes();
                                },
                                readCentralDir: function() {
                                    var t;
                                    for(this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(r.CENTRAL_FILE_HEADER);)(t = new o({
                                        zip64: this.zip64
                                    }, this.loadOptions)).readCentralPart(this.reader), this.files.push(t);
                                    if (this.centralDirRecords !== this.files.length && 0 !== this.centralDirRecords && 0 === this.files.length) throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
                                },
                                readEndOfCentral: function() {
                                    var t = this.reader.lastIndexOfSignature(r.CENTRAL_DIRECTORY_END);
                                    if (t < 0) throw this.isSignature(0, r.LOCAL_FILE_HEADER) ? new Error("Corrupted zip: can't find end of central directory") : new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html");
                                    this.reader.setIndex(t);
                                    var e = t;
                                    if (this.checkSignature(r.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === n.MAX_VALUE_16BITS || this.diskWithCentralDirStart === n.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === n.MAX_VALUE_16BITS || this.centralDirRecords === n.MAX_VALUE_16BITS || this.centralDirSize === n.MAX_VALUE_32BITS || this.centralDirOffset === n.MAX_VALUE_32BITS) {
                                        if (this.zip64 = !0, (t = this.reader.lastIndexOfSignature(r.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
                                        if (this.reader.setIndex(t), this.checkSignature(r.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, r.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(r.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0)) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
                                        this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(r.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
                                    }
                                    var i = this.centralDirOffset + this.centralDirSize;
                                    this.zip64 && (i += 20, i += 12 + this.zip64EndOfCentralSize);
                                    var s = e - i;
                                    if (0 < s) this.isSignature(e, r.CENTRAL_FILE_HEADER) || (this.reader.zero = s);
                                    else if (s < 0) throw new Error("Corrupted zip: missing " + Math.abs(s) + " bytes.");
                                },
                                prepareReader: function(t) {
                                    this.reader = s(t);
                                },
                                load: function(t) {
                                    this.prepareReader(t), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
                                }
                            }, e.exports = l;
                        },
                        {
                            "./reader/readerFor": 22,
                            "./signature": 23,
                            "./support": 30,
                            "./utils": 32,
                            "./zipEntry": 34
                        }
                    ],
                    34: [
                        function(t, e, i) {
                            "use strict";
                            var s = t("./reader/readerFor"), n = t("./utils"), r = t("./compressedObject"), o = t("./crc32"), a = t("./utf8"), l = t("./compressions"), h = t("./support");
                            function c(t, e) {
                                this.options = t, this.loadOptions = e;
                            }
                            c.prototype = {
                                isEncrypted: function() {
                                    return !(1 & ~this.bitFlag);
                                },
                                useUTF8: function() {
                                    return !(2048 & ~this.bitFlag);
                                },
                                readLocalPart: function(t) {
                                    var e, i;
                                    if (t.skip(22), this.fileNameLength = t.readInt(2), i = t.readInt(2), this.fileName = t.readData(this.fileNameLength), t.skip(i), -1 === this.compressedSize || -1 === this.uncompressedSize) throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
                                    if (null === (e = function(t) {
                                        for(var e in l)if (Object.prototype.hasOwnProperty.call(l, e) && l[e].magic === t) return l[e];
                                        return null;
                                    }(this.compressionMethod))) throw new Error("Corrupted zip : compression " + n.pretty(this.compressionMethod) + " unknown (inner file : " + n.transformTo("string", this.fileName) + ")");
                                    this.decompressed = new r(this.compressedSize, this.uncompressedSize, this.crc32, e, t.readData(this.compressedSize));
                                },
                                readCentralPart: function(t) {
                                    this.versionMadeBy = t.readInt(2), t.skip(2), this.bitFlag = t.readInt(2), this.compressionMethod = t.readString(2), this.date = t.readDate(), this.crc32 = t.readInt(4), this.compressedSize = t.readInt(4), this.uncompressedSize = t.readInt(4);
                                    var e = t.readInt(2);
                                    if (this.extraFieldsLength = t.readInt(2), this.fileCommentLength = t.readInt(2), this.diskNumberStart = t.readInt(2), this.internalFileAttributes = t.readInt(2), this.externalFileAttributes = t.readInt(4), this.localHeaderOffset = t.readInt(4), this.isEncrypted()) throw new Error("Encrypted zip are not supported");
                                    t.skip(e), this.readExtraFields(t), this.parseZIP64ExtraField(t), this.fileComment = t.readData(this.fileCommentLength);
                                },
                                processAttributes: function() {
                                    this.unixPermissions = null, this.dosPermissions = null;
                                    var t = this.versionMadeBy >> 8;
                                    this.dir = !!(16 & this.externalFileAttributes), 0 == t && (this.dosPermissions = 63 & this.externalFileAttributes), 3 == t && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || "/" !== this.fileNameStr.slice(-1) || (this.dir = !0);
                                },
                                parseZIP64ExtraField: function() {
                                    if (this.extraFields[1]) {
                                        var t = s(this.extraFields[1].value);
                                        this.uncompressedSize === n.MAX_VALUE_32BITS && (this.uncompressedSize = t.readInt(8)), this.compressedSize === n.MAX_VALUE_32BITS && (this.compressedSize = t.readInt(8)), this.localHeaderOffset === n.MAX_VALUE_32BITS && (this.localHeaderOffset = t.readInt(8)), this.diskNumberStart === n.MAX_VALUE_32BITS && (this.diskNumberStart = t.readInt(4));
                                    }
                                },
                                readExtraFields: function(t) {
                                    var e, i, s, n = t.index + this.extraFieldsLength;
                                    for(this.extraFields || (this.extraFields = {}); t.index + 4 < n;)e = t.readInt(2), i = t.readInt(2), s = t.readData(i), this.extraFields[e] = {
                                        id: e,
                                        length: i,
                                        value: s
                                    };
                                    t.setIndex(n);
                                },
                                handleUTF8: function() {
                                    var t = h.uint8array ? "uint8array" : "array";
                                    if (this.useUTF8()) this.fileNameStr = a.utf8decode(this.fileName), this.fileCommentStr = a.utf8decode(this.fileComment);
                                    else {
                                        var e = this.findExtraFieldUnicodePath();
                                        if (null !== e) this.fileNameStr = e;
                                        else {
                                            var i = n.transformTo(t, this.fileName);
                                            this.fileNameStr = this.loadOptions.decodeFileName(i);
                                        }
                                        var s = this.findExtraFieldUnicodeComment();
                                        if (null !== s) this.fileCommentStr = s;
                                        else {
                                            var r = n.transformTo(t, this.fileComment);
                                            this.fileCommentStr = this.loadOptions.decodeFileName(r);
                                        }
                                    }
                                },
                                findExtraFieldUnicodePath: function() {
                                    var t = this.extraFields[28789];
                                    if (t) {
                                        var e = s(t.value);
                                        return 1 !== e.readInt(1) || o(this.fileName) !== e.readInt(4) ? null : a.utf8decode(e.readData(t.length - 5));
                                    }
                                    return null;
                                },
                                findExtraFieldUnicodeComment: function() {
                                    var t = this.extraFields[25461];
                                    if (t) {
                                        var e = s(t.value);
                                        return 1 !== e.readInt(1) || o(this.fileComment) !== e.readInt(4) ? null : a.utf8decode(e.readData(t.length - 5));
                                    }
                                    return null;
                                }
                            }, e.exports = c;
                        },
                        {
                            "./compressedObject": 2,
                            "./compressions": 3,
                            "./crc32": 4,
                            "./reader/readerFor": 22,
                            "./support": 30,
                            "./utf8": 31,
                            "./utils": 32
                        }
                    ],
                    35: [
                        function(t, e, i) {
                            "use strict";
                            function s(t, e, i) {
                                this.name = t, this.dir = i.dir, this.date = i.date, this.comment = i.comment, this.unixPermissions = i.unixPermissions, this.dosPermissions = i.dosPermissions, this._data = e, this._dataBinary = i.binary, this.options = {
                                    compression: i.compression,
                                    compressionOptions: i.compressionOptions
                                };
                            }
                            var n = t("./stream/StreamHelper"), r = t("./stream/DataWorker"), o = t("./utf8"), a = t("./compressedObject"), l = t("./stream/GenericWorker");
                            s.prototype = {
                                internalStream: function(t) {
                                    var e = null, i = "string";
                                    try {
                                        if (!t) throw new Error("No output type specified.");
                                        var s = "string" === (i = t.toLowerCase()) || "text" === i;
                                        "binarystring" !== i && "text" !== i || (i = "string"), e = this._decompressWorker();
                                        var r = !this._dataBinary;
                                        r && !s && (e = e.pipe(new o.Utf8EncodeWorker)), !r && s && (e = e.pipe(new o.Utf8DecodeWorker));
                                    } catch (t) {
                                        (e = new l("error")).error(t);
                                    }
                                    return new n(e, i, "");
                                },
                                async: function(t, e) {
                                    return this.internalStream(t).accumulate(e);
                                },
                                nodeStream: function(t, e) {
                                    return this.internalStream(t || "nodebuffer").toNodejsStream(e);
                                },
                                _compressWorker: function(t, e) {
                                    if (this._data instanceof a && this._data.compression.magic === t.magic) return this._data.getCompressedWorker();
                                    var i = this._decompressWorker();
                                    return this._dataBinary || (i = i.pipe(new o.Utf8EncodeWorker)), a.createWorkerFrom(i, t, e);
                                },
                                _decompressWorker: function() {
                                    return this._data instanceof a ? this._data.getContentWorker() : this._data instanceof l ? this._data : new r(this._data);
                                }
                            };
                            for(var h = [
                                "asText",
                                "asBinary",
                                "asNodeBuffer",
                                "asUint8Array",
                                "asArrayBuffer"
                            ], c = function() {
                                throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                            }, u = 0; u < h.length; u++)s.prototype[h[u]] = c;
                            e.exports = s;
                        },
                        {
                            "./compressedObject": 2,
                            "./stream/DataWorker": 27,
                            "./stream/GenericWorker": 28,
                            "./stream/StreamHelper": 29,
                            "./utf8": 31
                        }
                    ],
                    36: [
                        function(t, e, s) {
                            (function(t) {
                                "use strict";
                                var i, s, n = t.MutationObserver || t.WebKitMutationObserver;
                                if (n) {
                                    var r = 0, o = new n(c), a = t.document.createTextNode("");
                                    o.observe(a, {
                                        characterData: !0
                                    }), i = function() {
                                        a.data = r = ++r % 2;
                                    };
                                } else if (t.setImmediate || void 0 === t.MessageChannel) i = "document" in t && "onreadystatechange" in t.document.createElement("script") ? function() {
                                    var e = t.document.createElement("script");
                                    e.onreadystatechange = function() {
                                        c(), e.onreadystatechange = null, e.parentNode.removeChild(e), e = null;
                                    }, t.document.documentElement.appendChild(e);
                                } : function() {
                                    setTimeout(c, 0);
                                };
                                else {
                                    var l = new t.MessageChannel;
                                    l.port1.onmessage = c, i = function() {
                                        l.port2.postMessage(0);
                                    };
                                }
                                var h = [];
                                function c() {
                                    var t, e;
                                    s = !0;
                                    for(var i = h.length; i;){
                                        for(e = h, h = [], t = -1; ++t < i;)e[t]();
                                        i = h.length;
                                    }
                                    s = !1;
                                }
                                e.exports = function(t) {
                                    1 !== h.push(t) || s || i();
                                };
                            }).call(this, void 0 !== i.g ? i.g : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
                        },
                        {}
                    ],
                    37: [
                        function(t, e, i) {
                            "use strict";
                            var s = t("immediate");
                            function n() {}
                            var r = {}, o = [
                                "REJECTED"
                            ], a = [
                                "FULFILLED"
                            ], l = [
                                "PENDING"
                            ];
                            function h(t) {
                                if ("function" != typeof t) throw new TypeError("resolver must be a function");
                                this.state = l, this.queue = [], this.outcome = void 0, t !== n && f(this, t);
                            }
                            function c(t, e, i) {
                                this.promise = t, "function" == typeof e && (this.onFulfilled = e, this.callFulfilled = this.otherCallFulfilled), "function" == typeof i && (this.onRejected = i, this.callRejected = this.otherCallRejected);
                            }
                            function u(t, e, i) {
                                s(function() {
                                    var s;
                                    try {
                                        s = e(i);
                                    } catch (s) {
                                        return r.reject(t, s);
                                    }
                                    s === t ? r.reject(t, new TypeError("Cannot resolve promise with itself")) : r.resolve(t, s);
                                });
                            }
                            function d(t) {
                                var e = t && t.then;
                                if (t && ("object" == typeof t || "function" == typeof t) && "function" == typeof e) return function() {
                                    e.apply(t, arguments);
                                };
                            }
                            function f(t, e) {
                                var i = !1;
                                function s(e) {
                                    i || (i = !0, r.reject(t, e));
                                }
                                function n(e) {
                                    i || (i = !0, r.resolve(t, e));
                                }
                                var o = m(function() {
                                    e(n, s);
                                });
                                "error" === o.status && s(o.value);
                            }
                            function m(t, e) {
                                var i = {};
                                try {
                                    i.value = t(e), i.status = "success";
                                } catch (t) {
                                    i.status = "error", i.value = t;
                                }
                                return i;
                            }
                            (e.exports = h).prototype.finally = function(t) {
                                if ("function" != typeof t) return this;
                                var e = this.constructor;
                                return this.then(function(i) {
                                    return e.resolve(t()).then(function() {
                                        return i;
                                    });
                                }, function(i) {
                                    return e.resolve(t()).then(function() {
                                        throw i;
                                    });
                                });
                            }, h.prototype.catch = function(t) {
                                return this.then(null, t);
                            }, h.prototype.then = function(t, e) {
                                if ("function" != typeof t && this.state === a || "function" != typeof e && this.state === o) return this;
                                var i = new this.constructor(n);
                                return this.state !== l ? u(i, this.state === a ? t : e, this.outcome) : this.queue.push(new c(i, t, e)), i;
                            }, c.prototype.callFulfilled = function(t) {
                                r.resolve(this.promise, t);
                            }, c.prototype.otherCallFulfilled = function(t) {
                                u(this.promise, this.onFulfilled, t);
                            }, c.prototype.callRejected = function(t) {
                                r.reject(this.promise, t);
                            }, c.prototype.otherCallRejected = function(t) {
                                u(this.promise, this.onRejected, t);
                            }, r.resolve = function(t, e) {
                                var i = m(d, e);
                                if ("error" === i.status) return r.reject(t, i.value);
                                var s = i.value;
                                if (s) f(t, s);
                                else {
                                    t.state = a, t.outcome = e;
                                    for(var n = -1, o = t.queue.length; ++n < o;)t.queue[n].callFulfilled(e);
                                }
                                return t;
                            }, r.reject = function(t, e) {
                                t.state = o, t.outcome = e;
                                for(var i = -1, s = t.queue.length; ++i < s;)t.queue[i].callRejected(e);
                                return t;
                            }, h.resolve = function(t) {
                                return t instanceof this ? t : r.resolve(new this(n), t);
                            }, h.reject = function(t) {
                                var e = new this(n);
                                return r.reject(e, t);
                            }, h.all = function(t) {
                                var e = this;
                                if ("[object Array]" !== Object.prototype.toString.call(t)) return this.reject(new TypeError("must be an array"));
                                var i = t.length, s = !1;
                                if (!i) return this.resolve([]);
                                for(var o = new Array(i), a = 0, l = -1, h = new this(n); ++l < i;)c(t[l], l);
                                return h;
                                function c(t, n) {
                                    e.resolve(t).then(function(t) {
                                        o[n] = t, ++a !== i || s || (s = !0, r.resolve(h, o));
                                    }, function(t) {
                                        s || (s = !0, r.reject(h, t));
                                    });
                                }
                            }, h.race = function(t) {
                                if ("[object Array]" !== Object.prototype.toString.call(t)) return this.reject(new TypeError("must be an array"));
                                var e = t.length, i = !1;
                                if (!e) return this.resolve([]);
                                for(var s, o = -1, a = new this(n); ++o < e;)s = t[o], this.resolve(s).then(function(t) {
                                    i || (i = !0, r.resolve(a, t));
                                }, function(t) {
                                    i || (i = !0, r.reject(a, t));
                                });
                                return a;
                            };
                        },
                        {
                            immediate: 36
                        }
                    ],
                    38: [
                        function(t, e, i) {
                            "use strict";
                            var s = {};
                            (0, t("./lib/utils/common").assign)(s, t("./lib/deflate"), t("./lib/inflate"), t("./lib/zlib/constants")), e.exports = s;
                        },
                        {
                            "./lib/deflate": 39,
                            "./lib/inflate": 40,
                            "./lib/utils/common": 41,
                            "./lib/zlib/constants": 44
                        }
                    ],
                    39: [
                        function(t, e, i) {
                            "use strict";
                            var s = t("./zlib/deflate"), n = t("./utils/common"), r = t("./utils/strings"), o = t("./zlib/messages"), a = t("./zlib/zstream"), l = Object.prototype.toString;
                            function h(t) {
                                if (!(this instanceof h)) return new h(t);
                                this.options = n.assign({
                                    level: -1,
                                    method: 8,
                                    chunkSize: 16384,
                                    windowBits: 15,
                                    memLevel: 8,
                                    strategy: 0,
                                    to: ""
                                }, t || {});
                                var e = this.options;
                                e.raw && 0 < e.windowBits ? e.windowBits = -e.windowBits : e.gzip && 0 < e.windowBits && e.windowBits < 16 && (e.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new a, this.strm.avail_out = 0;
                                var i = s.deflateInit2(this.strm, e.level, e.method, e.windowBits, e.memLevel, e.strategy);
                                if (0 !== i) throw new Error(o[i]);
                                if (e.header && s.deflateSetHeader(this.strm, e.header), e.dictionary) {
                                    var c;
                                    if (c = "string" == typeof e.dictionary ? r.string2buf(e.dictionary) : "[object ArrayBuffer]" === l.call(e.dictionary) ? new Uint8Array(e.dictionary) : e.dictionary, 0 !== (i = s.deflateSetDictionary(this.strm, c))) throw new Error(o[i]);
                                    this._dict_set = !0;
                                }
                            }
                            function c(t, e) {
                                var i = new h(e);
                                if (i.push(t, !0), i.err) throw i.msg || o[i.err];
                                return i.result;
                            }
                            h.prototype.push = function(t, e) {
                                var i, o, a = this.strm, h = this.options.chunkSize;
                                if (this.ended) return !1;
                                o = e === ~~e ? e : !0 === e ? 4 : 0, "string" == typeof t ? a.input = r.string2buf(t) : "[object ArrayBuffer]" === l.call(t) ? a.input = new Uint8Array(t) : a.input = t, a.next_in = 0, a.avail_in = a.input.length;
                                do {
                                    if (0 === a.avail_out && (a.output = new n.Buf8(h), a.next_out = 0, a.avail_out = h), 1 !== (i = s.deflate(a, o)) && 0 !== i) return this.onEnd(i), this.ended = !0, false;
                                    0 !== a.avail_out && (0 !== a.avail_in || 4 !== o && 2 !== o) || ("string" === this.options.to ? this.onData(r.buf2binstring(n.shrinkBuf(a.output, a.next_out))) : this.onData(n.shrinkBuf(a.output, a.next_out)));
                                }while ((0 < a.avail_in || 0 === a.avail_out) && 1 !== i);
                                return 4 === o ? (i = s.deflateEnd(this.strm), this.onEnd(i), this.ended = !0, 0 === i) : 2 !== o || (this.onEnd(0), a.avail_out = 0, true);
                            }, h.prototype.onData = function(t) {
                                this.chunks.push(t);
                            }, h.prototype.onEnd = function(t) {
                                0 === t && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = n.flattenChunks(this.chunks)), this.chunks = [], this.err = t, this.msg = this.strm.msg;
                            }, i.Deflate = h, i.deflate = c, i.deflateRaw = function(t, e) {
                                return (e = e || {}).raw = !0, c(t, e);
                            }, i.gzip = function(t, e) {
                                return (e = e || {}).gzip = !0, c(t, e);
                            };
                        },
                        {
                            "./utils/common": 41,
                            "./utils/strings": 42,
                            "./zlib/deflate": 46,
                            "./zlib/messages": 51,
                            "./zlib/zstream": 53
                        }
                    ],
                    40: [
                        function(t, e, i) {
                            "use strict";
                            var s = t("./zlib/inflate"), n = t("./utils/common"), r = t("./utils/strings"), o = t("./zlib/constants"), a = t("./zlib/messages"), l = t("./zlib/zstream"), h = t("./zlib/gzheader"), c = Object.prototype.toString;
                            function u(t) {
                                if (!(this instanceof u)) return new u(t);
                                this.options = n.assign({
                                    chunkSize: 16384,
                                    windowBits: 0,
                                    to: ""
                                }, t || {});
                                var e = this.options;
                                e.raw && 0 <= e.windowBits && e.windowBits < 16 && (e.windowBits = -e.windowBits, 0 === e.windowBits && (e.windowBits = -15)), !(0 <= e.windowBits && e.windowBits < 16) || t && t.windowBits || (e.windowBits += 32), 15 < e.windowBits && e.windowBits < 48 && !(15 & e.windowBits) && (e.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new l, this.strm.avail_out = 0;
                                var i = s.inflateInit2(this.strm, e.windowBits);
                                if (i !== o.Z_OK) throw new Error(a[i]);
                                this.header = new h, s.inflateGetHeader(this.strm, this.header);
                            }
                            function d(t, e) {
                                var i = new u(e);
                                if (i.push(t, !0), i.err) throw i.msg || a[i.err];
                                return i.result;
                            }
                            u.prototype.push = function(t, e) {
                                var i, a, l, h, u, d, f = this.strm, m = this.options.chunkSize, p = this.options.dictionary, g = !1;
                                if (this.ended) return !1;
                                a = e === ~~e ? e : !0 === e ? o.Z_FINISH : o.Z_NO_FLUSH, "string" == typeof t ? f.input = r.binstring2buf(t) : "[object ArrayBuffer]" === c.call(t) ? f.input = new Uint8Array(t) : f.input = t, f.next_in = 0, f.avail_in = f.input.length;
                                do {
                                    if (0 === f.avail_out && (f.output = new n.Buf8(m), f.next_out = 0, f.avail_out = m), (i = s.inflate(f, o.Z_NO_FLUSH)) === o.Z_NEED_DICT && p && (d = "string" == typeof p ? r.string2buf(p) : "[object ArrayBuffer]" === c.call(p) ? new Uint8Array(p) : p, i = s.inflateSetDictionary(this.strm, d)), i === o.Z_BUF_ERROR && !0 === g && (i = o.Z_OK, g = !1), i !== o.Z_STREAM_END && i !== o.Z_OK) return this.onEnd(i), this.ended = !0, false;
                                    f.next_out && (0 !== f.avail_out && i !== o.Z_STREAM_END && (0 !== f.avail_in || a !== o.Z_FINISH && a !== o.Z_SYNC_FLUSH) || ("string" === this.options.to ? (l = r.utf8border(f.output, f.next_out), h = f.next_out - l, u = r.buf2string(f.output, l), f.next_out = h, f.avail_out = m - h, h && n.arraySet(f.output, f.output, l, h, 0), this.onData(u)) : this.onData(n.shrinkBuf(f.output, f.next_out)))), 0 === f.avail_in && 0 === f.avail_out && (g = !0);
                                }while ((0 < f.avail_in || 0 === f.avail_out) && i !== o.Z_STREAM_END);
                                return i === o.Z_STREAM_END && (a = o.Z_FINISH), a === o.Z_FINISH ? (i = s.inflateEnd(this.strm), this.onEnd(i), this.ended = !0, i === o.Z_OK) : a !== o.Z_SYNC_FLUSH || (this.onEnd(o.Z_OK), f.avail_out = 0, true);
                            }, u.prototype.onData = function(t) {
                                this.chunks.push(t);
                            }, u.prototype.onEnd = function(t) {
                                t === o.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = n.flattenChunks(this.chunks)), this.chunks = [], this.err = t, this.msg = this.strm.msg;
                            }, i.Inflate = u, i.inflate = d, i.inflateRaw = function(t, e) {
                                return (e = e || {}).raw = !0, d(t, e);
                            }, i.ungzip = d;
                        },
                        {
                            "./utils/common": 41,
                            "./utils/strings": 42,
                            "./zlib/constants": 44,
                            "./zlib/gzheader": 47,
                            "./zlib/inflate": 49,
                            "./zlib/messages": 51,
                            "./zlib/zstream": 53
                        }
                    ],
                    41: [
                        function(t, e, i) {
                            "use strict";
                            var s = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;
                            i.assign = function(t) {
                                for(var e = Array.prototype.slice.call(arguments, 1); e.length;){
                                    var i = e.shift();
                                    if (i) {
                                        if ("object" != typeof i) throw new TypeError(i + "must be non-object");
                                        for(var s in i)i.hasOwnProperty(s) && (t[s] = i[s]);
                                    }
                                }
                                return t;
                            }, i.shrinkBuf = function(t, e) {
                                return t.length === e ? t : t.subarray ? t.subarray(0, e) : (t.length = e, t);
                            };
                            var n = {
                                arraySet: function(t, e, i, s, n) {
                                    if (e.subarray && t.subarray) t.set(e.subarray(i, i + s), n);
                                    else for(var r = 0; r < s; r++)t[n + r] = e[i + r];
                                },
                                flattenChunks: function(t) {
                                    var e, i, s, n, r, o;
                                    for(e = s = 0, i = t.length; e < i; e++)s += t[e].length;
                                    for(o = new Uint8Array(s), e = n = 0, i = t.length; e < i; e++)r = t[e], o.set(r, n), n += r.length;
                                    return o;
                                }
                            }, r = {
                                arraySet: function(t, e, i, s, n) {
                                    for(var r = 0; r < s; r++)t[n + r] = e[i + r];
                                },
                                flattenChunks: function(t) {
                                    return [].concat.apply([], t);
                                }
                            };
                            i.setTyped = function(t) {
                                t ? (i.Buf8 = Uint8Array, i.Buf16 = Uint16Array, i.Buf32 = Int32Array, i.assign(i, n)) : (i.Buf8 = Array, i.Buf16 = Array, i.Buf32 = Array, i.assign(i, r));
                            }, i.setTyped(s);
                        },
                        {}
                    ],
                    42: [
                        function(t, e, i) {
                            "use strict";
                            var s = t("./common"), n = !0, r = !0;
                            try {
                                String.fromCharCode.apply(null, [
                                    0
                                ]);
                            } catch (t) {
                                n = !1;
                            }
                            try {
                                String.fromCharCode.apply(null, new Uint8Array(1));
                            } catch (t) {
                                r = !1;
                            }
                            for(var o = new s.Buf8(256), a = 0; a < 256; a++)o[a] = 252 <= a ? 6 : 248 <= a ? 5 : 240 <= a ? 4 : 224 <= a ? 3 : 192 <= a ? 2 : 1;
                            function l(t, e) {
                                if (e < 65537 && (t.subarray && r || !t.subarray && n)) return String.fromCharCode.apply(null, s.shrinkBuf(t, e));
                                for(var i = "", o = 0; o < e; o++)i += String.fromCharCode(t[o]);
                                return i;
                            }
                            o[254] = o[254] = 1, i.string2buf = function(t) {
                                var e, i, n, r, o, a = t.length, l = 0;
                                for(r = 0; r < a; r++)55296 == (64512 & (i = t.charCodeAt(r))) && r + 1 < a && 56320 == (64512 & (n = t.charCodeAt(r + 1))) && (i = 65536 + (i - 55296 << 10) + (n - 56320), r++), l += i < 128 ? 1 : i < 2048 ? 2 : i < 65536 ? 3 : 4;
                                for(e = new s.Buf8(l), r = o = 0; o < l; r++)55296 == (64512 & (i = t.charCodeAt(r))) && r + 1 < a && 56320 == (64512 & (n = t.charCodeAt(r + 1))) && (i = 65536 + (i - 55296 << 10) + (n - 56320), r++), i < 128 ? e[o++] = i : (i < 2048 ? e[o++] = 192 | i >>> 6 : (i < 65536 ? e[o++] = 224 | i >>> 12 : (e[o++] = 240 | i >>> 18, e[o++] = 128 | i >>> 12 & 63), e[o++] = 128 | i >>> 6 & 63), e[o++] = 128 | 63 & i);
                                return e;
                            }, i.buf2binstring = function(t) {
                                return l(t, t.length);
                            }, i.binstring2buf = function(t) {
                                for(var e = new s.Buf8(t.length), i = 0, n = e.length; i < n; i++)e[i] = t.charCodeAt(i);
                                return e;
                            }, i.buf2string = function(t, e) {
                                var i, s, n, r, a = e || t.length, h = new Array(2 * a);
                                for(i = s = 0; i < a;)if ((n = t[i++]) < 128) h[s++] = n;
                                else if (4 < (r = o[n])) h[s++] = 65533, i += r - 1;
                                else {
                                    for(n &= 2 === r ? 31 : 3 === r ? 15 : 7; 1 < r && i < a;)n = n << 6 | 63 & t[i++], r--;
                                    1 < r ? h[s++] = 65533 : n < 65536 ? h[s++] = n : (n -= 65536, h[s++] = 55296 | n >> 10 & 1023, h[s++] = 56320 | 1023 & n);
                                }
                                return l(h, s);
                            }, i.utf8border = function(t, e) {
                                var i;
                                for((e = e || t.length) > t.length && (e = t.length), i = e - 1; 0 <= i && 128 == (192 & t[i]);)i--;
                                return i < 0 || 0 === i ? e : i + o[t[i]] > e ? i : e;
                            };
                        },
                        {
                            "./common": 41
                        }
                    ],
                    43: [
                        function(t, e, i) {
                            "use strict";
                            e.exports = function(t, e, i, s) {
                                for(var n = 65535 & t, r = t >>> 16 & 65535, o = 0; 0 !== i;){
                                    for(i -= o = 2e3 < i ? 2e3 : i; r = r + (n = n + e[s++] | 0) | 0, --o;);
                                    n %= 65521, r %= 65521;
                                }
                                return n | r << 16;
                            };
                        },
                        {}
                    ],
                    44: [
                        function(t, e, i) {
                            "use strict";
                            e.exports = {
                                Z_NO_FLUSH: 0,
                                Z_PARTIAL_FLUSH: 1,
                                Z_SYNC_FLUSH: 2,
                                Z_FULL_FLUSH: 3,
                                Z_FINISH: 4,
                                Z_BLOCK: 5,
                                Z_TREES: 6,
                                Z_OK: 0,
                                Z_STREAM_END: 1,
                                Z_NEED_DICT: 2,
                                Z_ERRNO: -1,
                                Z_STREAM_ERROR: -2,
                                Z_DATA_ERROR: -3,
                                Z_BUF_ERROR: -5,
                                Z_NO_COMPRESSION: 0,
                                Z_BEST_SPEED: 1,
                                Z_BEST_COMPRESSION: 9,
                                Z_DEFAULT_COMPRESSION: -1,
                                Z_FILTERED: 1,
                                Z_HUFFMAN_ONLY: 2,
                                Z_RLE: 3,
                                Z_FIXED: 4,
                                Z_DEFAULT_STRATEGY: 0,
                                Z_BINARY: 0,
                                Z_TEXT: 1,
                                Z_UNKNOWN: 2,
                                Z_DEFLATED: 8
                            };
                        },
                        {}
                    ],
                    45: [
                        function(t, e, i) {
                            "use strict";
                            var s = function() {
                                for(var t, e = [], i = 0; i < 256; i++){
                                    t = i;
                                    for(var s = 0; s < 8; s++)t = 1 & t ? 3988292384 ^ t >>> 1 : t >>> 1;
                                    e[i] = t;
                                }
                                return e;
                            }();
                            e.exports = function(t, e, i, n) {
                                var r = s, o = n + i;
                                t ^= -1;
                                for(var a = n; a < o; a++)t = t >>> 8 ^ r[255 & (t ^ e[a])];
                                return -1 ^ t;
                            };
                        },
                        {}
                    ],
                    46: [
                        function(t, e, i) {
                            "use strict";
                            var s, n = t("../utils/common"), r = t("./trees"), o = t("./adler32"), a = t("./crc32"), l = t("./messages"), h = -2, c = 258, u = 262, d = 113;
                            function f(t, e) {
                                return t.msg = l[e], e;
                            }
                            function m(t) {
                                return (t << 1) - (4 < t ? 9 : 0);
                            }
                            function p(t) {
                                for(var e = t.length; 0 <= --e;)t[e] = 0;
                            }
                            function g(t) {
                                var e = t.state, i = e.pending;
                                i > t.avail_out && (i = t.avail_out), 0 !== i && (n.arraySet(t.output, e.pending_buf, e.pending_out, i, t.next_out), t.next_out += i, e.pending_out += i, t.total_out += i, t.avail_out -= i, e.pending -= i, 0 === e.pending && (e.pending_out = 0));
                            }
                            function b(t, e) {
                                r._tr_flush_block(t, 0 <= t.block_start ? t.block_start : -1, t.strstart - t.block_start, e), t.block_start = t.strstart, g(t.strm);
                            }
                            function S(t, e) {
                                t.pending_buf[t.pending++] = e;
                            }
                            function y(t, e) {
                                t.pending_buf[t.pending++] = e >>> 8 & 255, t.pending_buf[t.pending++] = 255 & e;
                            }
                            function E(t, e) {
                                var i, s, n = t.max_chain_length, r = t.strstart, o = t.prev_length, a = t.nice_match, l = t.strstart > t.w_size - u ? t.strstart - (t.w_size - u) : 0, h = t.window, d = t.w_mask, f = t.prev, m = t.strstart + c, p = h[r + o - 1], g = h[r + o];
                                t.prev_length >= t.good_match && (n >>= 2), a > t.lookahead && (a = t.lookahead);
                                do if (h[(i = e) + o] === g && h[i + o - 1] === p && h[i] === h[r] && h[++i] === h[r + 1]) {
                                    r += 2, i++;
                                    do ;
                                    while (h[++r] === h[++i] && h[++r] === h[++i] && h[++r] === h[++i] && h[++r] === h[++i] && h[++r] === h[++i] && h[++r] === h[++i] && h[++r] === h[++i] && h[++r] === h[++i] && r < m);
                                    if (s = c - (m - r), r = m - c, o < s) {
                                        if (t.match_start = e, a <= (o = s)) break;
                                        p = h[r + o - 1], g = h[r + o];
                                    }
                                }
                                while ((e = f[e & d]) > l && 0 != --n);
                                return o <= t.lookahead ? o : t.lookahead;
                            }
                            function x(t) {
                                var e, i, s, r, l, h, c, d, f, m, p = t.w_size;
                                do {
                                    if (r = t.window_size - t.lookahead - t.strstart, t.strstart >= p + (p - u)) {
                                        for(n.arraySet(t.window, t.window, p, p, 0), t.match_start -= p, t.strstart -= p, t.block_start -= p, e = i = t.hash_size; s = t.head[--e], t.head[e] = p <= s ? s - p : 0, --i;);
                                        for(e = i = p; s = t.prev[--e], t.prev[e] = p <= s ? s - p : 0, --i;);
                                        r += p;
                                    }
                                    if (0 === t.strm.avail_in) break;
                                    if (h = t.strm, c = t.window, d = t.strstart + t.lookahead, m = void 0, (f = r) < (m = h.avail_in) && (m = f), i = 0 === m ? 0 : (h.avail_in -= m, n.arraySet(c, h.input, h.next_in, m, d), 1 === h.state.wrap ? h.adler = o(h.adler, c, m, d) : 2 === h.state.wrap && (h.adler = a(h.adler, c, m, d)), h.next_in += m, h.total_in += m, m), t.lookahead += i, t.lookahead + t.insert >= 3) for(l = t.strstart - t.insert, t.ins_h = t.window[l], t.ins_h = (t.ins_h << t.hash_shift ^ t.window[l + 1]) & t.hash_mask; t.insert && (t.ins_h = (t.ins_h << t.hash_shift ^ t.window[l + 3 - 1]) & t.hash_mask, t.prev[l & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = l, l++, t.insert--, !(t.lookahead + t.insert < 3)););
                                }while (t.lookahead < u && 0 !== t.strm.avail_in);
                            }
                            function v(t, e) {
                                for(var i, s;;){
                                    if (t.lookahead < u) {
                                        if (x(t), t.lookahead < u && 0 === e) return 1;
                                        if (0 === t.lookahead) break;
                                    }
                                    if (i = 0, t.lookahead >= 3 && (t.ins_h = (t.ins_h << t.hash_shift ^ t.window[t.strstart + 3 - 1]) & t.hash_mask, i = t.prev[t.strstart & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = t.strstart), 0 !== i && t.strstart - i <= t.w_size - u && (t.match_length = E(t, i)), t.match_length >= 3) {
                                        if (s = r._tr_tally(t, t.strstart - t.match_start, t.match_length - 3), t.lookahead -= t.match_length, t.match_length <= t.max_lazy_match && t.lookahead >= 3) {
                                            for(t.match_length--; t.strstart++, t.ins_h = (t.ins_h << t.hash_shift ^ t.window[t.strstart + 3 - 1]) & t.hash_mask, i = t.prev[t.strstart & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = t.strstart, 0 != --t.match_length;);
                                            t.strstart++;
                                        } else t.strstart += t.match_length, t.match_length = 0, t.ins_h = t.window[t.strstart], t.ins_h = (t.ins_h << t.hash_shift ^ t.window[t.strstart + 1]) & t.hash_mask;
                                    } else s = r._tr_tally(t, 0, t.window[t.strstart]), t.lookahead--, t.strstart++;
                                    if (s && (b(t, !1), 0 === t.strm.avail_out)) return 1;
                                }
                                return t.insert = t.strstart < 2 ? t.strstart : 2, 4 === e ? (b(t, !0), 0 === t.strm.avail_out ? 3 : 4) : t.last_lit && (b(t, !1), 0 === t.strm.avail_out) ? 1 : 2;
                            }
                            function T(t, e) {
                                for(var i, s, n;;){
                                    if (t.lookahead < u) {
                                        if (x(t), t.lookahead < u && 0 === e) return 1;
                                        if (0 === t.lookahead) break;
                                    }
                                    if (i = 0, t.lookahead >= 3 && (t.ins_h = (t.ins_h << t.hash_shift ^ t.window[t.strstart + 3 - 1]) & t.hash_mask, i = t.prev[t.strstart & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = t.strstart), t.prev_length = t.match_length, t.prev_match = t.match_start, t.match_length = 2, 0 !== i && t.prev_length < t.max_lazy_match && t.strstart - i <= t.w_size - u && (t.match_length = E(t, i), t.match_length <= 5 && (1 === t.strategy || 3 === t.match_length && 4096 < t.strstart - t.match_start) && (t.match_length = 2)), t.prev_length >= 3 && t.match_length <= t.prev_length) {
                                        for(n = t.strstart + t.lookahead - 3, s = r._tr_tally(t, t.strstart - 1 - t.prev_match, t.prev_length - 3), t.lookahead -= t.prev_length - 1, t.prev_length -= 2; ++t.strstart <= n && (t.ins_h = (t.ins_h << t.hash_shift ^ t.window[t.strstart + 3 - 1]) & t.hash_mask, i = t.prev[t.strstart & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = t.strstart), 0 != --t.prev_length;);
                                        if (t.match_available = 0, t.match_length = 2, t.strstart++, s && (b(t, !1), 0 === t.strm.avail_out)) return 1;
                                    } else if (t.match_available) {
                                        if ((s = r._tr_tally(t, 0, t.window[t.strstart - 1])) && b(t, !1), t.strstart++, t.lookahead--, 0 === t.strm.avail_out) return 1;
                                    } else t.match_available = 1, t.strstart++, t.lookahead--;
                                }
                                return t.match_available && (s = r._tr_tally(t, 0, t.window[t.strstart - 1]), t.match_available = 0), t.insert = t.strstart < 2 ? t.strstart : 2, 4 === e ? (b(t, !0), 0 === t.strm.avail_out ? 3 : 4) : t.last_lit && (b(t, !1), 0 === t.strm.avail_out) ? 1 : 2;
                            }
                            function _(t, e, i, s, n) {
                                this.good_length = t, this.max_lazy = e, this.nice_length = i, this.max_chain = s, this.func = n;
                            }
                            function M() {
                                this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = 8, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new n.Buf16(1146), this.dyn_dtree = new n.Buf16(122), this.bl_tree = new n.Buf16(78), p(this.dyn_ltree), p(this.dyn_dtree), p(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new n.Buf16(16), this.heap = new n.Buf16(573), p(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new n.Buf16(573), p(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
                            }
                            function P(t) {
                                var e;
                                return t && t.state ? (t.total_in = t.total_out = 0, t.data_type = 2, (e = t.state).pending = 0, e.pending_out = 0, e.wrap < 0 && (e.wrap = -e.wrap), e.status = e.wrap ? 42 : d, t.adler = 2 === e.wrap ? 0 : 1, e.last_flush = 0, r._tr_init(e), 0) : f(t, h);
                            }
                            function L(t) {
                                var e = P(t);
                                return 0 === e && function(t) {
                                    t.window_size = 2 * t.w_size, p(t.head), t.max_lazy_match = s[t.level].max_lazy, t.good_match = s[t.level].good_length, t.nice_match = s[t.level].nice_length, t.max_chain_length = s[t.level].max_chain, t.strstart = 0, t.block_start = 0, t.lookahead = 0, t.insert = 0, t.match_length = t.prev_length = 2, t.match_available = 0, t.ins_h = 0;
                                }(t.state), e;
                            }
                            function w(t, e, i, s, r, o) {
                                if (!t) return h;
                                var a = 1;
                                if (-1 === e && (e = 6), s < 0 ? (a = 0, s = -s) : 15 < s && (a = 2, s -= 16), r < 1 || 9 < r || 8 !== i || s < 8 || 15 < s || e < 0 || 9 < e || o < 0 || 4 < o) return f(t, h);
                                8 === s && (s = 9);
                                var l = new M;
                                return (t.state = l).strm = t, l.wrap = a, l.gzhead = null, l.w_bits = s, l.w_size = 1 << l.w_bits, l.w_mask = l.w_size - 1, l.hash_bits = r + 7, l.hash_size = 1 << l.hash_bits, l.hash_mask = l.hash_size - 1, l.hash_shift = ~~((l.hash_bits + 3 - 1) / 3), l.window = new n.Buf8(2 * l.w_size), l.head = new n.Buf16(l.hash_size), l.prev = new n.Buf16(l.w_size), l.lit_bufsize = 1 << r + 6, l.pending_buf_size = 4 * l.lit_bufsize, l.pending_buf = new n.Buf8(l.pending_buf_size), l.d_buf = 1 * l.lit_bufsize, l.l_buf = 3 * l.lit_bufsize, l.level = e, l.strategy = o, l.method = i, L(t);
                            }
                            s = [
                                new _(0, 0, 0, 0, function(t, e) {
                                    var i = 65535;
                                    for(i > t.pending_buf_size - 5 && (i = t.pending_buf_size - 5);;){
                                        if (t.lookahead <= 1) {
                                            if (x(t), 0 === t.lookahead && 0 === e) return 1;
                                            if (0 === t.lookahead) break;
                                        }
                                        t.strstart += t.lookahead, t.lookahead = 0;
                                        var s = t.block_start + i;
                                        if ((0 === t.strstart || t.strstart >= s) && (t.lookahead = t.strstart - s, t.strstart = s, b(t, !1), 0 === t.strm.avail_out)) return 1;
                                        if (t.strstart - t.block_start >= t.w_size - u && (b(t, !1), 0 === t.strm.avail_out)) return 1;
                                    }
                                    return t.insert = 0, 4 === e ? (b(t, !0), 0 === t.strm.avail_out ? 3 : 4) : (t.strstart > t.block_start && (b(t, !1), t.strm.avail_out), 1);
                                }),
                                new _(4, 4, 8, 4, v),
                                new _(4, 5, 16, 8, v),
                                new _(4, 6, 32, 32, v),
                                new _(4, 4, 16, 16, T),
                                new _(8, 16, 32, 32, T),
                                new _(8, 16, 128, 128, T),
                                new _(8, 32, 128, 256, T),
                                new _(32, 128, 258, 1024, T),
                                new _(32, 258, 258, 4096, T)
                            ], i.deflateInit = function(t, e) {
                                return w(t, e, 8, 15, 8, 0);
                            }, i.deflateInit2 = w, i.deflateReset = L, i.deflateResetKeep = P, i.deflateSetHeader = function(t, e) {
                                return t && t.state ? 2 !== t.state.wrap ? h : (t.state.gzhead = e, 0) : h;
                            }, i.deflate = function(t, e) {
                                var i, n, o, l;
                                if (!t || !t.state || 5 < e || e < 0) return t ? f(t, h) : h;
                                if (n = t.state, !t.output || !t.input && 0 !== t.avail_in || 666 === n.status && 4 !== e) return f(t, 0 === t.avail_out ? -5 : h);
                                if (n.strm = t, i = n.last_flush, n.last_flush = e, 42 === n.status) {
                                    if (2 === n.wrap) t.adler = 0, S(n, 31), S(n, 139), S(n, 8), n.gzhead ? (S(n, (n.gzhead.text ? 1 : 0) + (n.gzhead.hcrc ? 2 : 0) + (n.gzhead.extra ? 4 : 0) + (n.gzhead.name ? 8 : 0) + (n.gzhead.comment ? 16 : 0)), S(n, 255 & n.gzhead.time), S(n, n.gzhead.time >> 8 & 255), S(n, n.gzhead.time >> 16 & 255), S(n, n.gzhead.time >> 24 & 255), S(n, 9 === n.level ? 2 : 2 <= n.strategy || n.level < 2 ? 4 : 0), S(n, 255 & n.gzhead.os), n.gzhead.extra && n.gzhead.extra.length && (S(n, 255 & n.gzhead.extra.length), S(n, n.gzhead.extra.length >> 8 & 255)), n.gzhead.hcrc && (t.adler = a(t.adler, n.pending_buf, n.pending, 0)), n.gzindex = 0, n.status = 69) : (S(n, 0), S(n, 0), S(n, 0), S(n, 0), S(n, 0), S(n, 9 === n.level ? 2 : 2 <= n.strategy || n.level < 2 ? 4 : 0), S(n, 3), n.status = d);
                                    else {
                                        var u = 8 + (n.w_bits - 8 << 4) << 8;
                                        u |= (2 <= n.strategy || n.level < 2 ? 0 : n.level < 6 ? 1 : 6 === n.level ? 2 : 3) << 6, 0 !== n.strstart && (u |= 32), u += 31 - u % 31, n.status = d, y(n, u), 0 !== n.strstart && (y(n, t.adler >>> 16), y(n, 65535 & t.adler)), t.adler = 1;
                                    }
                                }
                                if (69 === n.status) {
                                    if (n.gzhead.extra) {
                                        for(o = n.pending; n.gzindex < (65535 & n.gzhead.extra.length) && (n.pending !== n.pending_buf_size || (n.gzhead.hcrc && n.pending > o && (t.adler = a(t.adler, n.pending_buf, n.pending - o, o)), g(t), o = n.pending, n.pending !== n.pending_buf_size));)S(n, 255 & n.gzhead.extra[n.gzindex]), n.gzindex++;
                                        n.gzhead.hcrc && n.pending > o && (t.adler = a(t.adler, n.pending_buf, n.pending - o, o)), n.gzindex === n.gzhead.extra.length && (n.gzindex = 0, n.status = 73);
                                    } else n.status = 73;
                                }
                                if (73 === n.status) {
                                    if (n.gzhead.name) {
                                        o = n.pending;
                                        do {
                                            if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > o && (t.adler = a(t.adler, n.pending_buf, n.pending - o, o)), g(t), o = n.pending, n.pending === n.pending_buf_size)) {
                                                l = 1;
                                                break;
                                            }
                                            l = n.gzindex < n.gzhead.name.length ? 255 & n.gzhead.name.charCodeAt(n.gzindex++) : 0, S(n, l);
                                        }while (0 !== l);
                                        n.gzhead.hcrc && n.pending > o && (t.adler = a(t.adler, n.pending_buf, n.pending - o, o)), 0 === l && (n.gzindex = 0, n.status = 91);
                                    } else n.status = 91;
                                }
                                if (91 === n.status) {
                                    if (n.gzhead.comment) {
                                        o = n.pending;
                                        do {
                                            if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > o && (t.adler = a(t.adler, n.pending_buf, n.pending - o, o)), g(t), o = n.pending, n.pending === n.pending_buf_size)) {
                                                l = 1;
                                                break;
                                            }
                                            l = n.gzindex < n.gzhead.comment.length ? 255 & n.gzhead.comment.charCodeAt(n.gzindex++) : 0, S(n, l);
                                        }while (0 !== l);
                                        n.gzhead.hcrc && n.pending > o && (t.adler = a(t.adler, n.pending_buf, n.pending - o, o)), 0 === l && (n.status = 103);
                                    } else n.status = 103;
                                }
                                if (103 === n.status && (n.gzhead.hcrc ? (n.pending + 2 > n.pending_buf_size && g(t), n.pending + 2 <= n.pending_buf_size && (S(n, 255 & t.adler), S(n, t.adler >> 8 & 255), t.adler = 0, n.status = d)) : n.status = d), 0 !== n.pending) {
                                    if (g(t), 0 === t.avail_out) return n.last_flush = -1, 0;
                                } else if (0 === t.avail_in && m(e) <= m(i) && 4 !== e) return f(t, -5);
                                if (666 === n.status && 0 !== t.avail_in) return f(t, -5);
                                if (0 !== t.avail_in || 0 !== n.lookahead || 0 !== e && 666 !== n.status) {
                                    var E = 2 === n.strategy ? function(t, e) {
                                        for(var i;;){
                                            if (0 === t.lookahead && (x(t), 0 === t.lookahead)) {
                                                if (0 === e) return 1;
                                                break;
                                            }
                                            if (t.match_length = 0, i = r._tr_tally(t, 0, t.window[t.strstart]), t.lookahead--, t.strstart++, i && (b(t, !1), 0 === t.strm.avail_out)) return 1;
                                        }
                                        return t.insert = 0, 4 === e ? (b(t, !0), 0 === t.strm.avail_out ? 3 : 4) : t.last_lit && (b(t, !1), 0 === t.strm.avail_out) ? 1 : 2;
                                    }(n, e) : 3 === n.strategy ? function(t, e) {
                                        for(var i, s, n, o, a = t.window;;){
                                            if (t.lookahead <= c) {
                                                if (x(t), t.lookahead <= c && 0 === e) return 1;
                                                if (0 === t.lookahead) break;
                                            }
                                            if (t.match_length = 0, t.lookahead >= 3 && 0 < t.strstart && (s = a[n = t.strstart - 1]) === a[++n] && s === a[++n] && s === a[++n]) {
                                                o = t.strstart + c;
                                                do ;
                                                while (s === a[++n] && s === a[++n] && s === a[++n] && s === a[++n] && s === a[++n] && s === a[++n] && s === a[++n] && s === a[++n] && n < o);
                                                t.match_length = c - (o - n), t.match_length > t.lookahead && (t.match_length = t.lookahead);
                                            }
                                            if (t.match_length >= 3 ? (i = r._tr_tally(t, 1, t.match_length - 3), t.lookahead -= t.match_length, t.strstart += t.match_length, t.match_length = 0) : (i = r._tr_tally(t, 0, t.window[t.strstart]), t.lookahead--, t.strstart++), i && (b(t, !1), 0 === t.strm.avail_out)) return 1;
                                        }
                                        return t.insert = 0, 4 === e ? (b(t, !0), 0 === t.strm.avail_out ? 3 : 4) : t.last_lit && (b(t, !1), 0 === t.strm.avail_out) ? 1 : 2;
                                    }(n, e) : s[n.level].func(n, e);
                                    if (3 !== E && 4 !== E || (n.status = 666), 1 === E || 3 === E) return 0 === t.avail_out && (n.last_flush = -1), 0;
                                    if (2 === E && (1 === e ? r._tr_align(n) : 5 !== e && (r._tr_stored_block(n, 0, 0, !1), 3 === e && (p(n.head), 0 === n.lookahead && (n.strstart = 0, n.block_start = 0, n.insert = 0))), g(t), 0 === t.avail_out)) return n.last_flush = -1, 0;
                                }
                                return 4 !== e ? 0 : n.wrap <= 0 ? 1 : (2 === n.wrap ? (S(n, 255 & t.adler), S(n, t.adler >> 8 & 255), S(n, t.adler >> 16 & 255), S(n, t.adler >> 24 & 255), S(n, 255 & t.total_in), S(n, t.total_in >> 8 & 255), S(n, t.total_in >> 16 & 255), S(n, t.total_in >> 24 & 255)) : (y(n, t.adler >>> 16), y(n, 65535 & t.adler)), g(t), 0 < n.wrap && (n.wrap = -n.wrap), 0 !== n.pending ? 0 : 1);
                            }, i.deflateEnd = function(t) {
                                var e;
                                return t && t.state ? 42 !== (e = t.state.status) && 69 !== e && 73 !== e && 91 !== e && 103 !== e && e !== d && 666 !== e ? f(t, h) : (t.state = null, e === d ? f(t, -3) : 0) : h;
                            }, i.deflateSetDictionary = function(t, e) {
                                var i, s, r, a, l, c, u, d, f = e.length;
                                if (!t || !t.state) return h;
                                if (2 === (a = (i = t.state).wrap) || 1 === a && 42 !== i.status || i.lookahead) return h;
                                for(1 === a && (t.adler = o(t.adler, e, f, 0)), i.wrap = 0, f >= i.w_size && (0 === a && (p(i.head), i.strstart = 0, i.block_start = 0, i.insert = 0), d = new n.Buf8(i.w_size), n.arraySet(d, e, f - i.w_size, i.w_size, 0), e = d, f = i.w_size), l = t.avail_in, c = t.next_in, u = t.input, t.avail_in = f, t.next_in = 0, t.input = e, x(i); i.lookahead >= 3;){
                                    for(s = i.strstart, r = i.lookahead - 2; i.ins_h = (i.ins_h << i.hash_shift ^ i.window[s + 3 - 1]) & i.hash_mask, i.prev[s & i.w_mask] = i.head[i.ins_h], i.head[i.ins_h] = s, s++, --r;);
                                    i.strstart = s, i.lookahead = 2, x(i);
                                }
                                return i.strstart += i.lookahead, i.block_start = i.strstart, i.insert = i.lookahead, i.lookahead = 0, i.match_length = i.prev_length = 2, i.match_available = 0, t.next_in = c, t.input = u, t.avail_in = l, i.wrap = a, 0;
                            }, i.deflateInfo = "pako deflate (from Nodeca project)";
                        },
                        {
                            "../utils/common": 41,
                            "./adler32": 43,
                            "./crc32": 45,
                            "./messages": 51,
                            "./trees": 52
                        }
                    ],
                    47: [
                        function(t, e, i) {
                            "use strict";
                            e.exports = function() {
                                this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
                            };
                        },
                        {}
                    ],
                    48: [
                        function(t, e, i) {
                            "use strict";
                            e.exports = function(t, e) {
                                var i, s, n, r, o, a, l, h, c, u, d, f, m, p, g, b, S, y, E, x, v, T, _, M, P;
                                i = t.state, s = t.next_in, M = t.input, n = s + (t.avail_in - 5), r = t.next_out, P = t.output, o = r - (e - t.avail_out), a = r + (t.avail_out - 257), l = i.dmax, h = i.wsize, c = i.whave, u = i.wnext, d = i.window, f = i.hold, m = i.bits, p = i.lencode, g = i.distcode, b = (1 << i.lenbits) - 1, S = (1 << i.distbits) - 1;
                                t: do {
                                    m < 15 && (f += M[s++] << m, m += 8, f += M[s++] << m, m += 8), y = p[f & b];
                                    e: for(;;){
                                        if (f >>>= E = y >>> 24, m -= E, 0 == (E = y >>> 16 & 255)) P[r++] = 65535 & y;
                                        else {
                                            if (!(16 & E)) {
                                                if (!(64 & E)) {
                                                    y = p[(65535 & y) + (f & (1 << E) - 1)];
                                                    continue e;
                                                }
                                                if (32 & E) {
                                                    i.mode = 12;
                                                    break t;
                                                }
                                                t.msg = "invalid literal/length code", i.mode = 30;
                                                break t;
                                            }
                                            x = 65535 & y, (E &= 15) && (m < E && (f += M[s++] << m, m += 8), x += f & (1 << E) - 1, f >>>= E, m -= E), m < 15 && (f += M[s++] << m, m += 8, f += M[s++] << m, m += 8), y = g[f & S];
                                            i: for(;;){
                                                if (f >>>= E = y >>> 24, m -= E, !(16 & (E = y >>> 16 & 255))) {
                                                    if (!(64 & E)) {
                                                        y = g[(65535 & y) + (f & (1 << E) - 1)];
                                                        continue i;
                                                    }
                                                    t.msg = "invalid distance code", i.mode = 30;
                                                    break t;
                                                }
                                                if (v = 65535 & y, m < (E &= 15) && (f += M[s++] << m, (m += 8) < E && (f += M[s++] << m, m += 8)), l < (v += f & (1 << E) - 1)) {
                                                    t.msg = "invalid distance too far back", i.mode = 30;
                                                    break t;
                                                }
                                                if (f >>>= E, m -= E, (E = r - o) < v) {
                                                    if (c < (E = v - E) && i.sane) {
                                                        t.msg = "invalid distance too far back", i.mode = 30;
                                                        break t;
                                                    }
                                                    if (_ = d, (T = 0) === u) {
                                                        if (T += h - E, E < x) {
                                                            for(x -= E; P[r++] = d[T++], --E;);
                                                            T = r - v, _ = P;
                                                        }
                                                    } else if (u < E) {
                                                        if (T += h + u - E, (E -= u) < x) {
                                                            for(x -= E; P[r++] = d[T++], --E;);
                                                            if (T = 0, u < x) {
                                                                for(x -= E = u; P[r++] = d[T++], --E;);
                                                                T = r - v, _ = P;
                                                            }
                                                        }
                                                    } else if (T += u - E, E < x) {
                                                        for(x -= E; P[r++] = d[T++], --E;);
                                                        T = r - v, _ = P;
                                                    }
                                                    for(; 2 < x;)P[r++] = _[T++], P[r++] = _[T++], P[r++] = _[T++], x -= 3;
                                                    x && (P[r++] = _[T++], 1 < x && (P[r++] = _[T++]));
                                                } else {
                                                    for(T = r - v; P[r++] = P[T++], P[r++] = P[T++], P[r++] = P[T++], 2 < (x -= 3););
                                                    x && (P[r++] = P[T++], 1 < x && (P[r++] = P[T++]));
                                                }
                                                break;
                                            }
                                        }
                                        break;
                                    }
                                }while (s < n && r < a);
                                s -= x = m >> 3, f &= (1 << (m -= x << 3)) - 1, t.next_in = s, t.next_out = r, t.avail_in = s < n ? n - s + 5 : 5 - (s - n), t.avail_out = r < a ? a - r + 257 : 257 - (r - a), i.hold = f, i.bits = m;
                            };
                        },
                        {}
                    ],
                    49: [
                        function(t, e, i) {
                            "use strict";
                            var s = t("../utils/common"), n = t("./adler32"), r = t("./crc32"), o = t("./inffast"), a = t("./inftrees"), l = -2;
                            function h(t) {
                                return (t >>> 24 & 255) + (t >>> 8 & 65280) + ((65280 & t) << 8) + ((255 & t) << 24);
                            }
                            function c() {
                                this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new s.Buf16(320), this.work = new s.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
                            }
                            function u(t) {
                                var e;
                                return t && t.state ? (e = t.state, t.total_in = t.total_out = e.total = 0, t.msg = "", e.wrap && (t.adler = 1 & e.wrap), e.mode = 1, e.last = 0, e.havedict = 0, e.dmax = 32768, e.head = null, e.hold = 0, e.bits = 0, e.lencode = e.lendyn = new s.Buf32(852), e.distcode = e.distdyn = new s.Buf32(592), e.sane = 1, e.back = -1, 0) : l;
                            }
                            function d(t) {
                                var e;
                                return t && t.state ? ((e = t.state).wsize = 0, e.whave = 0, e.wnext = 0, u(t)) : l;
                            }
                            function f(t, e) {
                                var i, s;
                                return t && t.state ? (s = t.state, e < 0 ? (i = 0, e = -e) : (i = 1 + (e >> 4), e < 48 && (e &= 15)), e && (e < 8 || 15 < e) ? l : (null !== s.window && s.wbits !== e && (s.window = null), s.wrap = i, s.wbits = e, d(t))) : l;
                            }
                            function m(t, e) {
                                var i, s;
                                return t ? (s = new c, (t.state = s).window = null, 0 !== (i = f(t, e)) && (t.state = null), i) : l;
                            }
                            var p, g, b = !0;
                            function S(t) {
                                if (b) {
                                    var e;
                                    for(p = new s.Buf32(512), g = new s.Buf32(32), e = 0; e < 144;)t.lens[e++] = 8;
                                    for(; e < 256;)t.lens[e++] = 9;
                                    for(; e < 280;)t.lens[e++] = 7;
                                    for(; e < 288;)t.lens[e++] = 8;
                                    for(a(1, t.lens, 0, 288, p, 0, t.work, {
                                        bits: 9
                                    }), e = 0; e < 32;)t.lens[e++] = 5;
                                    a(2, t.lens, 0, 32, g, 0, t.work, {
                                        bits: 5
                                    }), b = !1;
                                }
                                t.lencode = p, t.lenbits = 9, t.distcode = g, t.distbits = 5;
                            }
                            function y(t, e, i, n) {
                                var r, o = t.state;
                                return null === o.window && (o.wsize = 1 << o.wbits, o.wnext = 0, o.whave = 0, o.window = new s.Buf8(o.wsize)), n >= o.wsize ? (s.arraySet(o.window, e, i - o.wsize, o.wsize, 0), o.wnext = 0, o.whave = o.wsize) : (n < (r = o.wsize - o.wnext) && (r = n), s.arraySet(o.window, e, i - n, r, o.wnext), (n -= r) ? (s.arraySet(o.window, e, i - n, n, 0), o.wnext = n, o.whave = o.wsize) : (o.wnext += r, o.wnext === o.wsize && (o.wnext = 0), o.whave < o.wsize && (o.whave += r))), 0;
                            }
                            i.inflateReset = d, i.inflateReset2 = f, i.inflateResetKeep = u, i.inflateInit = function(t) {
                                return m(t, 15);
                            }, i.inflateInit2 = m, i.inflate = function(t, e) {
                                var i, c, u, d, f, m, p, g, b, E, x, v, T, _, M, P, L, w, A, I, R, N, C, B, D = 0, O = new s.Buf8(4), F = [
                                    16,
                                    17,
                                    18,
                                    0,
                                    8,
                                    7,
                                    9,
                                    6,
                                    10,
                                    5,
                                    11,
                                    4,
                                    12,
                                    3,
                                    13,
                                    2,
                                    14,
                                    1,
                                    15
                                ];
                                if (!t || !t.state || !t.output || !t.input && 0 !== t.avail_in) return l;
                                12 === (i = t.state).mode && (i.mode = 13), f = t.next_out, u = t.output, p = t.avail_out, d = t.next_in, c = t.input, m = t.avail_in, g = i.hold, b = i.bits, E = m, x = p, N = 0;
                                t: for(;;)switch(i.mode){
                                    case 1:
                                        if (0 === i.wrap) {
                                            i.mode = 13;
                                            break;
                                        }
                                        for(; b < 16;){
                                            if (0 === m) break t;
                                            m--, g += c[d++] << b, b += 8;
                                        }
                                        if (2 & i.wrap && 35615 === g) {
                                            O[i.check = 0] = 255 & g, O[1] = g >>> 8 & 255, i.check = r(i.check, O, 2, 0), b = g = 0, i.mode = 2;
                                            break;
                                        }
                                        if (i.flags = 0, i.head && (i.head.done = !1), !(1 & i.wrap) || (((255 & g) << 8) + (g >> 8)) % 31) {
                                            t.msg = "incorrect header check", i.mode = 30;
                                            break;
                                        }
                                        if (8 != (15 & g)) {
                                            t.msg = "unknown compression method", i.mode = 30;
                                            break;
                                        }
                                        if (b -= 4, R = 8 + (15 & (g >>>= 4)), 0 === i.wbits) i.wbits = R;
                                        else if (R > i.wbits) {
                                            t.msg = "invalid window size", i.mode = 30;
                                            break;
                                        }
                                        i.dmax = 1 << R, t.adler = i.check = 1, i.mode = 512 & g ? 10 : 12, b = g = 0;
                                        break;
                                    case 2:
                                        for(; b < 16;){
                                            if (0 === m) break t;
                                            m--, g += c[d++] << b, b += 8;
                                        }
                                        if (i.flags = g, 8 != (255 & i.flags)) {
                                            t.msg = "unknown compression method", i.mode = 30;
                                            break;
                                        }
                                        if (57344 & i.flags) {
                                            t.msg = "unknown header flags set", i.mode = 30;
                                            break;
                                        }
                                        i.head && (i.head.text = g >> 8 & 1), 512 & i.flags && (O[0] = 255 & g, O[1] = g >>> 8 & 255, i.check = r(i.check, O, 2, 0)), b = g = 0, i.mode = 3;
                                    case 3:
                                        for(; b < 32;){
                                            if (0 === m) break t;
                                            m--, g += c[d++] << b, b += 8;
                                        }
                                        i.head && (i.head.time = g), 512 & i.flags && (O[0] = 255 & g, O[1] = g >>> 8 & 255, O[2] = g >>> 16 & 255, O[3] = g >>> 24 & 255, i.check = r(i.check, O, 4, 0)), b = g = 0, i.mode = 4;
                                    case 4:
                                        for(; b < 16;){
                                            if (0 === m) break t;
                                            m--, g += c[d++] << b, b += 8;
                                        }
                                        i.head && (i.head.xflags = 255 & g, i.head.os = g >> 8), 512 & i.flags && (O[0] = 255 & g, O[1] = g >>> 8 & 255, i.check = r(i.check, O, 2, 0)), b = g = 0, i.mode = 5;
                                    case 5:
                                        if (1024 & i.flags) {
                                            for(; b < 16;){
                                                if (0 === m) break t;
                                                m--, g += c[d++] << b, b += 8;
                                            }
                                            i.length = g, i.head && (i.head.extra_len = g), 512 & i.flags && (O[0] = 255 & g, O[1] = g >>> 8 & 255, i.check = r(i.check, O, 2, 0)), b = g = 0;
                                        } else i.head && (i.head.extra = null);
                                        i.mode = 6;
                                    case 6:
                                        if (1024 & i.flags && (m < (v = i.length) && (v = m), v && (i.head && (R = i.head.extra_len - i.length, i.head.extra || (i.head.extra = new Array(i.head.extra_len)), s.arraySet(i.head.extra, c, d, v, R)), 512 & i.flags && (i.check = r(i.check, c, v, d)), m -= v, d += v, i.length -= v), i.length)) break t;
                                        i.length = 0, i.mode = 7;
                                    case 7:
                                        if (2048 & i.flags) {
                                            if (0 === m) break t;
                                            for(v = 0; R = c[d + v++], i.head && R && i.length < 65536 && (i.head.name += String.fromCharCode(R)), R && v < m;);
                                            if (512 & i.flags && (i.check = r(i.check, c, v, d)), m -= v, d += v, R) break t;
                                        } else i.head && (i.head.name = null);
                                        i.length = 0, i.mode = 8;
                                    case 8:
                                        if (4096 & i.flags) {
                                            if (0 === m) break t;
                                            for(v = 0; R = c[d + v++], i.head && R && i.length < 65536 && (i.head.comment += String.fromCharCode(R)), R && v < m;);
                                            if (512 & i.flags && (i.check = r(i.check, c, v, d)), m -= v, d += v, R) break t;
                                        } else i.head && (i.head.comment = null);
                                        i.mode = 9;
                                    case 9:
                                        if (512 & i.flags) {
                                            for(; b < 16;){
                                                if (0 === m) break t;
                                                m--, g += c[d++] << b, b += 8;
                                            }
                                            if (g !== (65535 & i.check)) {
                                                t.msg = "header crc mismatch", i.mode = 30;
                                                break;
                                            }
                                            b = g = 0;
                                        }
                                        i.head && (i.head.hcrc = i.flags >> 9 & 1, i.head.done = !0), t.adler = i.check = 0, i.mode = 12;
                                        break;
                                    case 10:
                                        for(; b < 32;){
                                            if (0 === m) break t;
                                            m--, g += c[d++] << b, b += 8;
                                        }
                                        t.adler = i.check = h(g), b = g = 0, i.mode = 11;
                                    case 11:
                                        if (0 === i.havedict) return t.next_out = f, t.avail_out = p, t.next_in = d, t.avail_in = m, i.hold = g, i.bits = b, 2;
                                        t.adler = i.check = 1, i.mode = 12;
                                    case 12:
                                        if (5 === e || 6 === e) break t;
                                    case 13:
                                        if (i.last) {
                                            g >>>= 7 & b, b -= 7 & b, i.mode = 27;
                                            break;
                                        }
                                        for(; b < 3;){
                                            if (0 === m) break t;
                                            m--, g += c[d++] << b, b += 8;
                                        }
                                        switch(i.last = 1 & g, b -= 1, 3 & (g >>>= 1)){
                                            case 0:
                                                i.mode = 14;
                                                break;
                                            case 1:
                                                if (S(i), i.mode = 20, 6 !== e) break;
                                                g >>>= 2, b -= 2;
                                                break t;
                                            case 2:
                                                i.mode = 17;
                                                break;
                                            case 3:
                                                t.msg = "invalid block type", i.mode = 30;
                                        }
                                        g >>>= 2, b -= 2;
                                        break;
                                    case 14:
                                        for(g >>>= 7 & b, b -= 7 & b; b < 32;){
                                            if (0 === m) break t;
                                            m--, g += c[d++] << b, b += 8;
                                        }
                                        if ((65535 & g) != (g >>> 16 ^ 65535)) {
                                            t.msg = "invalid stored block lengths", i.mode = 30;
                                            break;
                                        }
                                        if (i.length = 65535 & g, b = g = 0, i.mode = 15, 6 === e) break t;
                                    case 15:
                                        i.mode = 16;
                                    case 16:
                                        if (v = i.length) {
                                            if (m < v && (v = m), p < v && (v = p), 0 === v) break t;
                                            s.arraySet(u, c, d, v, f), m -= v, d += v, p -= v, f += v, i.length -= v;
                                            break;
                                        }
                                        i.mode = 12;
                                        break;
                                    case 17:
                                        for(; b < 14;){
                                            if (0 === m) break t;
                                            m--, g += c[d++] << b, b += 8;
                                        }
                                        if (i.nlen = 257 + (31 & g), g >>>= 5, b -= 5, i.ndist = 1 + (31 & g), g >>>= 5, b -= 5, i.ncode = 4 + (15 & g), g >>>= 4, b -= 4, 286 < i.nlen || 30 < i.ndist) {
                                            t.msg = "too many length or distance symbols", i.mode = 30;
                                            break;
                                        }
                                        i.have = 0, i.mode = 18;
                                    case 18:
                                        for(; i.have < i.ncode;){
                                            for(; b < 3;){
                                                if (0 === m) break t;
                                                m--, g += c[d++] << b, b += 8;
                                            }
                                            i.lens[F[i.have++]] = 7 & g, g >>>= 3, b -= 3;
                                        }
                                        for(; i.have < 19;)i.lens[F[i.have++]] = 0;
                                        if (i.lencode = i.lendyn, i.lenbits = 7, C = {
                                            bits: i.lenbits
                                        }, N = a(0, i.lens, 0, 19, i.lencode, 0, i.work, C), i.lenbits = C.bits, N) {
                                            t.msg = "invalid code lengths set", i.mode = 30;
                                            break;
                                        }
                                        i.have = 0, i.mode = 19;
                                    case 19:
                                        for(; i.have < i.nlen + i.ndist;){
                                            for(; P = (D = i.lencode[g & (1 << i.lenbits) - 1]) >>> 16 & 255, L = 65535 & D, !((M = D >>> 24) <= b);){
                                                if (0 === m) break t;
                                                m--, g += c[d++] << b, b += 8;
                                            }
                                            if (L < 16) g >>>= M, b -= M, i.lens[i.have++] = L;
                                            else {
                                                if (16 === L) {
                                                    for(B = M + 2; b < B;){
                                                        if (0 === m) break t;
                                                        m--, g += c[d++] << b, b += 8;
                                                    }
                                                    if (g >>>= M, b -= M, 0 === i.have) {
                                                        t.msg = "invalid bit length repeat", i.mode = 30;
                                                        break;
                                                    }
                                                    R = i.lens[i.have - 1], v = 3 + (3 & g), g >>>= 2, b -= 2;
                                                } else if (17 === L) {
                                                    for(B = M + 3; b < B;){
                                                        if (0 === m) break t;
                                                        m--, g += c[d++] << b, b += 8;
                                                    }
                                                    b -= M, R = 0, v = 3 + (7 & (g >>>= M)), g >>>= 3, b -= 3;
                                                } else {
                                                    for(B = M + 7; b < B;){
                                                        if (0 === m) break t;
                                                        m--, g += c[d++] << b, b += 8;
                                                    }
                                                    b -= M, R = 0, v = 11 + (127 & (g >>>= M)), g >>>= 7, b -= 7;
                                                }
                                                if (i.have + v > i.nlen + i.ndist) {
                                                    t.msg = "invalid bit length repeat", i.mode = 30;
                                                    break;
                                                }
                                                for(; v--;)i.lens[i.have++] = R;
                                            }
                                        }
                                        if (30 === i.mode) break;
                                        if (0 === i.lens[256]) {
                                            t.msg = "invalid code -- missing end-of-block", i.mode = 30;
                                            break;
                                        }
                                        if (i.lenbits = 9, C = {
                                            bits: i.lenbits
                                        }, N = a(1, i.lens, 0, i.nlen, i.lencode, 0, i.work, C), i.lenbits = C.bits, N) {
                                            t.msg = "invalid literal/lengths set", i.mode = 30;
                                            break;
                                        }
                                        if (i.distbits = 6, i.distcode = i.distdyn, C = {
                                            bits: i.distbits
                                        }, N = a(2, i.lens, i.nlen, i.ndist, i.distcode, 0, i.work, C), i.distbits = C.bits, N) {
                                            t.msg = "invalid distances set", i.mode = 30;
                                            break;
                                        }
                                        if (i.mode = 20, 6 === e) break t;
                                    case 20:
                                        i.mode = 21;
                                    case 21:
                                        if (6 <= m && 258 <= p) {
                                            t.next_out = f, t.avail_out = p, t.next_in = d, t.avail_in = m, i.hold = g, i.bits = b, o(t, x), f = t.next_out, u = t.output, p = t.avail_out, d = t.next_in, c = t.input, m = t.avail_in, g = i.hold, b = i.bits, 12 === i.mode && (i.back = -1);
                                            break;
                                        }
                                        for(i.back = 0; P = (D = i.lencode[g & (1 << i.lenbits) - 1]) >>> 16 & 255, L = 65535 & D, !((M = D >>> 24) <= b);){
                                            if (0 === m) break t;
                                            m--, g += c[d++] << b, b += 8;
                                        }
                                        if (P && !(240 & P)) {
                                            for(w = M, A = P, I = L; P = (D = i.lencode[I + ((g & (1 << w + A) - 1) >> w)]) >>> 16 & 255, L = 65535 & D, !(w + (M = D >>> 24) <= b);){
                                                if (0 === m) break t;
                                                m--, g += c[d++] << b, b += 8;
                                            }
                                            g >>>= w, b -= w, i.back += w;
                                        }
                                        if (g >>>= M, b -= M, i.back += M, i.length = L, 0 === P) {
                                            i.mode = 26;
                                            break;
                                        }
                                        if (32 & P) {
                                            i.back = -1, i.mode = 12;
                                            break;
                                        }
                                        if (64 & P) {
                                            t.msg = "invalid literal/length code", i.mode = 30;
                                            break;
                                        }
                                        i.extra = 15 & P, i.mode = 22;
                                    case 22:
                                        if (i.extra) {
                                            for(B = i.extra; b < B;){
                                                if (0 === m) break t;
                                                m--, g += c[d++] << b, b += 8;
                                            }
                                            i.length += g & (1 << i.extra) - 1, g >>>= i.extra, b -= i.extra, i.back += i.extra;
                                        }
                                        i.was = i.length, i.mode = 23;
                                    case 23:
                                        for(; P = (D = i.distcode[g & (1 << i.distbits) - 1]) >>> 16 & 255, L = 65535 & D, !((M = D >>> 24) <= b);){
                                            if (0 === m) break t;
                                            m--, g += c[d++] << b, b += 8;
                                        }
                                        if (!(240 & P)) {
                                            for(w = M, A = P, I = L; P = (D = i.distcode[I + ((g & (1 << w + A) - 1) >> w)]) >>> 16 & 255, L = 65535 & D, !(w + (M = D >>> 24) <= b);){
                                                if (0 === m) break t;
                                                m--, g += c[d++] << b, b += 8;
                                            }
                                            g >>>= w, b -= w, i.back += w;
                                        }
                                        if (g >>>= M, b -= M, i.back += M, 64 & P) {
                                            t.msg = "invalid distance code", i.mode = 30;
                                            break;
                                        }
                                        i.offset = L, i.extra = 15 & P, i.mode = 24;
                                    case 24:
                                        if (i.extra) {
                                            for(B = i.extra; b < B;){
                                                if (0 === m) break t;
                                                m--, g += c[d++] << b, b += 8;
                                            }
                                            i.offset += g & (1 << i.extra) - 1, g >>>= i.extra, b -= i.extra, i.back += i.extra;
                                        }
                                        if (i.offset > i.dmax) {
                                            t.msg = "invalid distance too far back", i.mode = 30;
                                            break;
                                        }
                                        i.mode = 25;
                                    case 25:
                                        if (0 === p) break t;
                                        if (v = x - p, i.offset > v) {
                                            if ((v = i.offset - v) > i.whave && i.sane) {
                                                t.msg = "invalid distance too far back", i.mode = 30;
                                                break;
                                            }
                                            T = v > i.wnext ? (v -= i.wnext, i.wsize - v) : i.wnext - v, v > i.length && (v = i.length), _ = i.window;
                                        } else _ = u, T = f - i.offset, v = i.length;
                                        for(p < v && (v = p), p -= v, i.length -= v; u[f++] = _[T++], --v;);
                                        0 === i.length && (i.mode = 21);
                                        break;
                                    case 26:
                                        if (0 === p) break t;
                                        u[f++] = i.length, p--, i.mode = 21;
                                        break;
                                    case 27:
                                        if (i.wrap) {
                                            for(; b < 32;){
                                                if (0 === m) break t;
                                                m--, g |= c[d++] << b, b += 8;
                                            }
                                            if (x -= p, t.total_out += x, i.total += x, x && (t.adler = i.check = i.flags ? r(i.check, u, x, f - x) : n(i.check, u, x, f - x)), x = p, (i.flags ? g : h(g)) !== i.check) {
                                                t.msg = "incorrect data check", i.mode = 30;
                                                break;
                                            }
                                            b = g = 0;
                                        }
                                        i.mode = 28;
                                    case 28:
                                        if (i.wrap && i.flags) {
                                            for(; b < 32;){
                                                if (0 === m) break t;
                                                m--, g += c[d++] << b, b += 8;
                                            }
                                            if (g !== (4294967295 & i.total)) {
                                                t.msg = "incorrect length check", i.mode = 30;
                                                break;
                                            }
                                            b = g = 0;
                                        }
                                        i.mode = 29;
                                    case 29:
                                        N = 1;
                                        break t;
                                    case 30:
                                        N = -3;
                                        break t;
                                    case 31:
                                        return -4;
                                    default:
                                        return l;
                                }
                                return t.next_out = f, t.avail_out = p, t.next_in = d, t.avail_in = m, i.hold = g, i.bits = b, (i.wsize || x !== t.avail_out && i.mode < 30 && (i.mode < 27 || 4 !== e)) && y(t, t.output, t.next_out, x - t.avail_out) ? (i.mode = 31, -4) : (E -= t.avail_in, x -= t.avail_out, t.total_in += E, t.total_out += x, i.total += x, i.wrap && x && (t.adler = i.check = i.flags ? r(i.check, u, x, t.next_out - x) : n(i.check, u, x, t.next_out - x)), t.data_type = i.bits + (i.last ? 64 : 0) + (12 === i.mode ? 128 : 0) + (20 === i.mode || 15 === i.mode ? 256 : 0), (0 == E && 0 === x || 4 === e) && 0 === N && (N = -5), N);
                            }, i.inflateEnd = function(t) {
                                if (!t || !t.state) return l;
                                var e = t.state;
                                return e.window && (e.window = null), t.state = null, 0;
                            }, i.inflateGetHeader = function(t, e) {
                                var i;
                                return t && t.state && 2 & (i = t.state).wrap ? ((i.head = e).done = !1, 0) : l;
                            }, i.inflateSetDictionary = function(t, e) {
                                var i, s = e.length;
                                return t && t.state ? 0 !== (i = t.state).wrap && 11 !== i.mode ? l : 11 === i.mode && n(1, e, s, 0) !== i.check ? -3 : y(t, e, s, s) ? (i.mode = 31, -4) : (i.havedict = 1, 0) : l;
                            }, i.inflateInfo = "pako inflate (from Nodeca project)";
                        },
                        {
                            "../utils/common": 41,
                            "./adler32": 43,
                            "./crc32": 45,
                            "./inffast": 48,
                            "./inftrees": 50
                        }
                    ],
                    50: [
                        function(t, e, i) {
                            "use strict";
                            var s = t("../utils/common"), n = [
                                3,
                                4,
                                5,
                                6,
                                7,
                                8,
                                9,
                                10,
                                11,
                                13,
                                15,
                                17,
                                19,
                                23,
                                27,
                                31,
                                35,
                                43,
                                51,
                                59,
                                67,
                                83,
                                99,
                                115,
                                131,
                                163,
                                195,
                                227,
                                258,
                                0,
                                0
                            ], r = [
                                16,
                                16,
                                16,
                                16,
                                16,
                                16,
                                16,
                                16,
                                17,
                                17,
                                17,
                                17,
                                18,
                                18,
                                18,
                                18,
                                19,
                                19,
                                19,
                                19,
                                20,
                                20,
                                20,
                                20,
                                21,
                                21,
                                21,
                                21,
                                16,
                                72,
                                78
                            ], o = [
                                1,
                                2,
                                3,
                                4,
                                5,
                                7,
                                9,
                                13,
                                17,
                                25,
                                33,
                                49,
                                65,
                                97,
                                129,
                                193,
                                257,
                                385,
                                513,
                                769,
                                1025,
                                1537,
                                2049,
                                3073,
                                4097,
                                6145,
                                8193,
                                12289,
                                16385,
                                24577,
                                0,
                                0
                            ], a = [
                                16,
                                16,
                                16,
                                16,
                                17,
                                17,
                                18,
                                18,
                                19,
                                19,
                                20,
                                20,
                                21,
                                21,
                                22,
                                22,
                                23,
                                23,
                                24,
                                24,
                                25,
                                25,
                                26,
                                26,
                                27,
                                27,
                                28,
                                28,
                                29,
                                29,
                                64,
                                64
                            ];
                            e.exports = function(t, e, i, l, h, c, u, d) {
                                var f, m, p, g, b, S, y, E, x, v = d.bits, T = 0, _ = 0, M = 0, P = 0, L = 0, w = 0, A = 0, I = 0, R = 0, N = 0, C = null, B = 0, D = new s.Buf16(16), O = new s.Buf16(16), F = null, k = 0;
                                for(T = 0; T <= 15; T++)D[T] = 0;
                                for(_ = 0; _ < l; _++)D[e[i + _]]++;
                                for(L = v, P = 15; 1 <= P && 0 === D[P]; P--);
                                if (P < L && (L = P), 0 === P) return h[c++] = 20971520, h[c++] = 20971520, d.bits = 1, 0;
                                for(M = 1; M < P && 0 === D[M]; M++);
                                for(L < M && (L = M), T = I = 1; T <= 15; T++)if (I <<= 1, (I -= D[T]) < 0) return -1;
                                if (0 < I && (0 === t || 1 !== P)) return -1;
                                for(O[1] = 0, T = 1; T < 15; T++)O[T + 1] = O[T] + D[T];
                                for(_ = 0; _ < l; _++)0 !== e[i + _] && (u[O[e[i + _]]++] = _);
                                if (S = 0 === t ? (C = F = u, 19) : 1 === t ? (C = n, B -= 257, F = r, k -= 257, 256) : (C = o, F = a, -1), T = M, b = c, A = _ = N = 0, p = -1, g = (R = 1 << (w = L)) - 1, 1 === t && 852 < R || 2 === t && 592 < R) return 1;
                                for(;;){
                                    for(y = T - A, x = u[_] < S ? (E = 0, u[_]) : u[_] > S ? (E = F[k + u[_]], C[B + u[_]]) : (E = 96, 0), f = 1 << T - A, M = m = 1 << w; h[b + (N >> A) + (m -= f)] = y << 24 | E << 16 | x, 0 !== m;);
                                    for(f = 1 << T - 1; N & f;)f >>= 1;
                                    if (0 !== f ? (N &= f - 1, N += f) : N = 0, _++, 0 == --D[T]) {
                                        if (T === P) break;
                                        T = e[i + u[_]];
                                    }
                                    if (L < T && (N & g) !== p) {
                                        for(0 === A && (A = L), b += M, I = 1 << (w = T - A); w + A < P && !((I -= D[w + A]) <= 0);)w++, I <<= 1;
                                        if (R += 1 << w, 1 === t && 852 < R || 2 === t && 592 < R) return 1;
                                        h[p = N & g] = L << 24 | w << 16 | b - c;
                                    }
                                }
                                return 0 !== N && (h[b + N] = T - A << 24 | 4194304), d.bits = L, 0;
                            };
                        },
                        {
                            "../utils/common": 41
                        }
                    ],
                    51: [
                        function(t, e, i) {
                            "use strict";
                            e.exports = {
                                2: "need dictionary",
                                1: "stream end",
                                0: "",
                                "-1": "file error",
                                "-2": "stream error",
                                "-3": "data error",
                                "-4": "insufficient memory",
                                "-5": "buffer error",
                                "-6": "incompatible version"
                            };
                        },
                        {}
                    ],
                    52: [
                        function(t, e, i) {
                            "use strict";
                            var s = t("../utils/common");
                            function n(t) {
                                for(var e = t.length; 0 <= --e;)t[e] = 0;
                            }
                            var r = 256, o = 286, a = 30, l = 15, h = [
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                1,
                                1,
                                1,
                                1,
                                2,
                                2,
                                2,
                                2,
                                3,
                                3,
                                3,
                                3,
                                4,
                                4,
                                4,
                                4,
                                5,
                                5,
                                5,
                                5,
                                0
                            ], c = [
                                0,
                                0,
                                0,
                                0,
                                1,
                                1,
                                2,
                                2,
                                3,
                                3,
                                4,
                                4,
                                5,
                                5,
                                6,
                                6,
                                7,
                                7,
                                8,
                                8,
                                9,
                                9,
                                10,
                                10,
                                11,
                                11,
                                12,
                                12,
                                13,
                                13
                            ], u = [
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                2,
                                3,
                                7
                            ], d = [
                                16,
                                17,
                                18,
                                0,
                                8,
                                7,
                                9,
                                6,
                                10,
                                5,
                                11,
                                4,
                                12,
                                3,
                                13,
                                2,
                                14,
                                1,
                                15
                            ], f = new Array(576);
                            n(f);
                            var m = new Array(60);
                            n(m);
                            var p = new Array(512);
                            n(p);
                            var g = new Array(256);
                            n(g);
                            var b = new Array(29);
                            n(b);
                            var S, y, E, x = new Array(a);
                            function v(t, e, i, s, n) {
                                this.static_tree = t, this.extra_bits = e, this.extra_base = i, this.elems = s, this.max_length = n, this.has_stree = t && t.length;
                            }
                            function T(t, e) {
                                this.dyn_tree = t, this.max_code = 0, this.stat_desc = e;
                            }
                            function _(t) {
                                return t < 256 ? p[t] : p[256 + (t >>> 7)];
                            }
                            function M(t, e) {
                                t.pending_buf[t.pending++] = 255 & e, t.pending_buf[t.pending++] = e >>> 8 & 255;
                            }
                            function P(t, e, i) {
                                t.bi_valid > 16 - i ? (t.bi_buf |= e << t.bi_valid & 65535, M(t, t.bi_buf), t.bi_buf = e >> 16 - t.bi_valid, t.bi_valid += i - 16) : (t.bi_buf |= e << t.bi_valid & 65535, t.bi_valid += i);
                            }
                            function L(t, e, i) {
                                P(t, i[2 * e], i[2 * e + 1]);
                            }
                            function w(t, e) {
                                for(var i = 0; i |= 1 & t, t >>>= 1, i <<= 1, 0 < --e;);
                                return i >>> 1;
                            }
                            function A(t, e, i) {
                                var s, n, r = new Array(16), o = 0;
                                for(s = 1; s <= l; s++)r[s] = o = o + i[s - 1] << 1;
                                for(n = 0; n <= e; n++){
                                    var a = t[2 * n + 1];
                                    0 !== a && (t[2 * n] = w(r[a]++, a));
                                }
                            }
                            function I(t) {
                                var e;
                                for(e = 0; e < o; e++)t.dyn_ltree[2 * e] = 0;
                                for(e = 0; e < a; e++)t.dyn_dtree[2 * e] = 0;
                                for(e = 0; e < 19; e++)t.bl_tree[2 * e] = 0;
                                t.dyn_ltree[512] = 1, t.opt_len = t.static_len = 0, t.last_lit = t.matches = 0;
                            }
                            function R(t) {
                                8 < t.bi_valid ? M(t, t.bi_buf) : 0 < t.bi_valid && (t.pending_buf[t.pending++] = t.bi_buf), t.bi_buf = 0, t.bi_valid = 0;
                            }
                            function N(t, e, i, s) {
                                var n = 2 * e, r = 2 * i;
                                return t[n] < t[r] || t[n] === t[r] && s[e] <= s[i];
                            }
                            function C(t, e, i) {
                                for(var s = t.heap[i], n = i << 1; n <= t.heap_len && (n < t.heap_len && N(e, t.heap[n + 1], t.heap[n], t.depth) && n++, !N(e, s, t.heap[n], t.depth));)t.heap[i] = t.heap[n], i = n, n <<= 1;
                                t.heap[i] = s;
                            }
                            function B(t, e, i) {
                                var s, n, o, a, l = 0;
                                if (0 !== t.last_lit) for(; s = t.pending_buf[t.d_buf + 2 * l] << 8 | t.pending_buf[t.d_buf + 2 * l + 1], n = t.pending_buf[t.l_buf + l], l++, 0 === s ? L(t, n, e) : (L(t, (o = g[n]) + r + 1, e), 0 !== (a = h[o]) && P(t, n -= b[o], a), L(t, o = _(--s), i), 0 !== (a = c[o]) && P(t, s -= x[o], a)), l < t.last_lit;);
                                L(t, 256, e);
                            }
                            function D(t, e) {
                                var i, s, n, r = e.dyn_tree, o = e.stat_desc.static_tree, a = e.stat_desc.has_stree, h = e.stat_desc.elems, c = -1;
                                for(t.heap_len = 0, t.heap_max = 573, i = 0; i < h; i++)0 !== r[2 * i] ? (t.heap[++t.heap_len] = c = i, t.depth[i] = 0) : r[2 * i + 1] = 0;
                                for(; t.heap_len < 2;)r[2 * (n = t.heap[++t.heap_len] = c < 2 ? ++c : 0)] = 1, t.depth[n] = 0, t.opt_len--, a && (t.static_len -= o[2 * n + 1]);
                                for(e.max_code = c, i = t.heap_len >> 1; 1 <= i; i--)C(t, r, i);
                                for(n = h; i = t.heap[1], t.heap[1] = t.heap[t.heap_len--], C(t, r, 1), s = t.heap[1], t.heap[--t.heap_max] = i, t.heap[--t.heap_max] = s, r[2 * n] = r[2 * i] + r[2 * s], t.depth[n] = (t.depth[i] >= t.depth[s] ? t.depth[i] : t.depth[s]) + 1, r[2 * i + 1] = r[2 * s + 1] = n, t.heap[1] = n++, C(t, r, 1), 2 <= t.heap_len;);
                                t.heap[--t.heap_max] = t.heap[1], function(t, e) {
                                    var i, s, n, r, o, a, h = e.dyn_tree, c = e.max_code, u = e.stat_desc.static_tree, d = e.stat_desc.has_stree, f = e.stat_desc.extra_bits, m = e.stat_desc.extra_base, p = e.stat_desc.max_length, g = 0;
                                    for(r = 0; r <= l; r++)t.bl_count[r] = 0;
                                    for(h[2 * t.heap[t.heap_max] + 1] = 0, i = t.heap_max + 1; i < 573; i++)p < (r = h[2 * h[2 * (s = t.heap[i]) + 1] + 1] + 1) && (r = p, g++), h[2 * s + 1] = r, c < s || (t.bl_count[r]++, o = 0, m <= s && (o = f[s - m]), a = h[2 * s], t.opt_len += a * (r + o), d && (t.static_len += a * (u[2 * s + 1] + o)));
                                    if (0 !== g) {
                                        do {
                                            for(r = p - 1; 0 === t.bl_count[r];)r--;
                                            t.bl_count[r]--, t.bl_count[r + 1] += 2, t.bl_count[p]--, g -= 2;
                                        }while (0 < g);
                                        for(r = p; 0 !== r; r--)for(s = t.bl_count[r]; 0 !== s;)c < (n = t.heap[--i]) || (h[2 * n + 1] !== r && (t.opt_len += (r - h[2 * n + 1]) * h[2 * n], h[2 * n + 1] = r), s--);
                                    }
                                }(t, e), A(r, c, t.bl_count);
                            }
                            function O(t, e, i) {
                                var s, n, r = -1, o = e[1], a = 0, l = 7, h = 4;
                                for(0 === o && (l = 138, h = 3), e[2 * (i + 1) + 1] = 65535, s = 0; s <= i; s++)n = o, o = e[2 * (s + 1) + 1], ++a < l && n === o || (a < h ? t.bl_tree[2 * n] += a : 0 !== n ? (n !== r && t.bl_tree[2 * n]++, t.bl_tree[32]++) : a <= 10 ? t.bl_tree[34]++ : t.bl_tree[36]++, r = n, h = (a = 0) === o ? (l = 138, 3) : n === o ? (l = 6, 3) : (l = 7, 4));
                            }
                            function F(t, e, i) {
                                var s, n, r = -1, o = e[1], a = 0, l = 7, h = 4;
                                for(0 === o && (l = 138, h = 3), s = 0; s <= i; s++)if (n = o, o = e[2 * (s + 1) + 1], !(++a < l && n === o)) {
                                    if (a < h) for(; L(t, n, t.bl_tree), 0 != --a;);
                                    else 0 !== n ? (n !== r && (L(t, n, t.bl_tree), a--), L(t, 16, t.bl_tree), P(t, a - 3, 2)) : a <= 10 ? (L(t, 17, t.bl_tree), P(t, a - 3, 3)) : (L(t, 18, t.bl_tree), P(t, a - 11, 7));
                                    r = n, h = (a = 0) === o ? (l = 138, 3) : n === o ? (l = 6, 3) : (l = 7, 4);
                                }
                            }
                            n(x);
                            var k = !1;
                            function V(t, e, i, n) {
                                P(t, 0 + (n ? 1 : 0), 3), function(t, e, i) {
                                    R(t), M(t, i), M(t, ~i), s.arraySet(t.pending_buf, t.window, e, i, t.pending), t.pending += i;
                                }(t, e, i);
                            }
                            i._tr_init = function(t) {
                                k || (function() {
                                    var t, e, i, s, n, r = new Array(16);
                                    for(s = i = 0; s < 28; s++)for(b[s] = i, t = 0; t < 1 << h[s]; t++)g[i++] = s;
                                    for(g[i - 1] = s, s = n = 0; s < 16; s++)for(x[s] = n, t = 0; t < 1 << c[s]; t++)p[n++] = s;
                                    for(n >>= 7; s < a; s++)for(x[s] = n << 7, t = 0; t < 1 << c[s] - 7; t++)p[256 + n++] = s;
                                    for(e = 0; e <= l; e++)r[e] = 0;
                                    for(t = 0; t <= 143;)f[2 * t + 1] = 8, t++, r[8]++;
                                    for(; t <= 255;)f[2 * t + 1] = 9, t++, r[9]++;
                                    for(; t <= 279;)f[2 * t + 1] = 7, t++, r[7]++;
                                    for(; t <= 287;)f[2 * t + 1] = 8, t++, r[8]++;
                                    for(A(f, 287, r), t = 0; t < a; t++)m[2 * t + 1] = 5, m[2 * t] = w(t, 5);
                                    S = new v(f, h, 257, o, l), y = new v(m, c, 0, a, l), E = new v(new Array(0), u, 0, 19, 7);
                                }(), k = !0), t.l_desc = new T(t.dyn_ltree, S), t.d_desc = new T(t.dyn_dtree, y), t.bl_desc = new T(t.bl_tree, E), t.bi_buf = 0, t.bi_valid = 0, I(t);
                            }, i._tr_stored_block = V, i._tr_flush_block = function(t, e, i, s) {
                                var n, o, a = 0;
                                0 < t.level ? (2 === t.strm.data_type && (t.strm.data_type = function(t) {
                                    var e, i = 4093624447;
                                    for(e = 0; e <= 31; e++, i >>>= 1)if (1 & i && 0 !== t.dyn_ltree[2 * e]) return 0;
                                    if (0 !== t.dyn_ltree[18] || 0 !== t.dyn_ltree[20] || 0 !== t.dyn_ltree[26]) return 1;
                                    for(e = 32; e < r; e++)if (0 !== t.dyn_ltree[2 * e]) return 1;
                                    return 0;
                                }(t)), D(t, t.l_desc), D(t, t.d_desc), a = function(t) {
                                    var e;
                                    for(O(t, t.dyn_ltree, t.l_desc.max_code), O(t, t.dyn_dtree, t.d_desc.max_code), D(t, t.bl_desc), e = 18; 3 <= e && 0 === t.bl_tree[2 * d[e] + 1]; e--);
                                    return t.opt_len += 3 * (e + 1) + 5 + 5 + 4, e;
                                }(t), n = t.opt_len + 3 + 7 >>> 3, (o = t.static_len + 3 + 7 >>> 3) <= n && (n = o)) : n = o = i + 5, i + 4 <= n && -1 !== e ? V(t, e, i, s) : 4 === t.strategy || o === n ? (P(t, 2 + (s ? 1 : 0), 3), B(t, f, m)) : (P(t, 4 + (s ? 1 : 0), 3), function(t, e, i, s) {
                                    var n;
                                    for(P(t, e - 257, 5), P(t, i - 1, 5), P(t, s - 4, 4), n = 0; n < s; n++)P(t, t.bl_tree[2 * d[n] + 1], 3);
                                    F(t, t.dyn_ltree, e - 1), F(t, t.dyn_dtree, i - 1);
                                }(t, t.l_desc.max_code + 1, t.d_desc.max_code + 1, a + 1), B(t, t.dyn_ltree, t.dyn_dtree)), I(t), s && R(t);
                            }, i._tr_tally = function(t, e, i) {
                                return t.pending_buf[t.d_buf + 2 * t.last_lit] = e >>> 8 & 255, t.pending_buf[t.d_buf + 2 * t.last_lit + 1] = 255 & e, t.pending_buf[t.l_buf + t.last_lit] = 255 & i, t.last_lit++, 0 === e ? t.dyn_ltree[2 * i]++ : (t.matches++, e--, t.dyn_ltree[2 * (g[i] + r + 1)]++, t.dyn_dtree[2 * _(e)]++), t.last_lit === t.lit_bufsize - 1;
                            }, i._tr_align = function(t) {
                                P(t, 2, 3), L(t, 256, f), function(t) {
                                    16 === t.bi_valid ? (M(t, t.bi_buf), t.bi_buf = 0, t.bi_valid = 0) : 8 <= t.bi_valid && (t.pending_buf[t.pending++] = 255 & t.bi_buf, t.bi_buf >>= 8, t.bi_valid -= 8);
                                }(t);
                            };
                        },
                        {
                            "../utils/common": 41
                        }
                    ],
                    53: [
                        function(t, e, i) {
                            "use strict";
                            e.exports = function() {
                                this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
                            };
                        },
                        {}
                    ],
                    54: [
                        function(t, e, s) {
                            (function(t) {
                                !function(t) {
                                    "use strict";
                                    if (!t.setImmediate) {
                                        var e, i, s, n, r = 1, o = {}, a = !1, l = t.document, h = Object.getPrototypeOf && Object.getPrototypeOf(t);
                                        h = h && h.setTimeout ? h : t, e = "[object process]" === ({}).toString.call(t.process) ? function(t) {
                                            $4Jj9n.nextTick(function() {
                                                u(t);
                                            });
                                        } : function() {
                                            if (t.postMessage && !t.importScripts) {
                                                var e = !0, i = t.onmessage;
                                                return t.onmessage = function() {
                                                    e = !1;
                                                }, t.postMessage("", "*"), t.onmessage = i, e;
                                            }
                                        }() ? (n = "setImmediate$" + Math.random() + "$", t.addEventListener ? t.addEventListener("message", d, !1) : t.attachEvent("onmessage", d), function(e) {
                                            t.postMessage(n + e, "*");
                                        }) : t.MessageChannel ? ((s = new MessageChannel).port1.onmessage = function(t) {
                                            u(t.data);
                                        }, function(t) {
                                            s.port2.postMessage(t);
                                        }) : l && "onreadystatechange" in l.createElement("script") ? (i = l.documentElement, function(t) {
                                            var e = l.createElement("script");
                                            e.onreadystatechange = function() {
                                                u(t), e.onreadystatechange = null, i.removeChild(e), e = null;
                                            }, i.appendChild(e);
                                        }) : function(t) {
                                            setTimeout(u, 0, t);
                                        }, h.setImmediate = function(t) {
                                            "function" != typeof t && (t = new Function("" + t));
                                            for(var i = new Array(arguments.length - 1), s = 0; s < i.length; s++)i[s] = arguments[s + 1];
                                            var n = {
                                                callback: t,
                                                args: i
                                            };
                                            return o[r] = n, e(r), r++;
                                        }, h.clearImmediate = c;
                                    }
                                    function c(t) {
                                        delete o[t];
                                    }
                                    function u(t) {
                                        if (a) setTimeout(u, 0, t);
                                        else {
                                            var e = o[t];
                                            if (e) {
                                                a = !0;
                                                try {
                                                    !function(t) {
                                                        var e = t.callback, i = t.args;
                                                        switch(i.length){
                                                            case 0:
                                                                e();
                                                                break;
                                                            case 1:
                                                                e(i[0]);
                                                                break;
                                                            case 2:
                                                                e(i[0], i[1]);
                                                                break;
                                                            case 3:
                                                                e(i[0], i[1], i[2]);
                                                                break;
                                                            default:
                                                                e.apply(void 0, i);
                                                        }
                                                    }(e);
                                                } finally{
                                                    c(t), a = !1;
                                                }
                                            }
                                        }
                                    }
                                    function d(e) {
                                        e.source === t && "string" == typeof e.data && 0 === e.data.indexOf(n) && u(+e.data.slice(n.length));
                                    }
                                }("undefined" == typeof self ? void 0 === t ? this : t : self);
                            }).call(this, void 0 !== i.g ? i.g : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
                        },
                        {}
                    ]
                }, {}, [
                    10
                ])(10);
            },
            3065 (t, e, i) {
                var s, n;
                !function() {
                    "use strict";
                    s = function() {
                        var t = function() {}, e = "undefined", i = typeof window !== e && typeof window.navigator !== e && /Trident\/|MSIE /.test(window.navigator.userAgent), s = [
                            "trace",
                            "debug",
                            "info",
                            "warn",
                            "error"
                        ], n = {}, r = null;
                        function o(t, e) {
                            var i = t[e];
                            if ("function" == typeof i.bind) return i.bind(t);
                            try {
                                return Function.prototype.bind.call(i, t);
                            } catch (e) {
                                return function() {
                                    return Function.prototype.apply.apply(i, [
                                        t,
                                        arguments
                                    ]);
                                };
                            }
                        }
                        function a() {
                            console.log && (console.log.apply ? console.log.apply(console, arguments) : Function.prototype.apply.apply(console.log, [
                                console,
                                arguments
                            ])), console.trace && console.trace();
                        }
                        function l() {
                            for(var i = this.getLevel(), n = 0; n < s.length; n++){
                                var r = s[n];
                                this[r] = n < i ? t : this.methodFactory(r, i, this.name);
                            }
                            if (this.log = this.debug, typeof console === e && i < this.levels.SILENT) return "No console available for logging";
                        }
                        function h(t) {
                            return function() {
                                typeof console !== e && (l.call(this), this[t].apply(this, arguments));
                            };
                        }
                        function c(s, n, r) {
                            return function(s) {
                                return "debug" === s && (s = "log"), typeof console !== e && ("trace" === s && i ? a : void 0 !== console[s] ? o(console, s) : void 0 !== console.log ? o(console, "log") : t);
                            }(s) || h.apply(this, arguments);
                        }
                        function u(t, i) {
                            var o, a, h, u = this, d = "loglevel";
                            function f() {
                                var t;
                                if (typeof window !== e && d) {
                                    try {
                                        t = window.localStorage[d];
                                    } catch (t) {}
                                    if (typeof t === e) try {
                                        var i = window.document.cookie, s = encodeURIComponent(d), n = i.indexOf(s + "=");
                                        -1 !== n && (t = /^([^;]+)/.exec(i.slice(n + s.length + 1))[1]);
                                    } catch (t) {}
                                    return void 0 === u.levels[t] && (t = void 0), t;
                                }
                            }
                            function m(t) {
                                var e = t;
                                if ("string" == typeof e && void 0 !== u.levels[e.toUpperCase()] && (e = u.levels[e.toUpperCase()]), "number" == typeof e && e >= 0 && e <= u.levels.SILENT) return e;
                                throw new TypeError("log.setLevel() called with invalid level: " + t);
                            }
                            "string" == typeof t ? d += ":" + t : "symbol" == typeof t && (d = void 0), u.name = t, u.levels = {
                                TRACE: 0,
                                DEBUG: 1,
                                INFO: 2,
                                WARN: 3,
                                ERROR: 4,
                                SILENT: 5
                            }, u.methodFactory = i || c, u.getLevel = function() {
                                return null != h ? h : null != a ? a : o;
                            }, u.setLevel = function(t, i) {
                                return h = m(t), !1 !== i && function(t) {
                                    var i = (s[t] || "silent").toUpperCase();
                                    if (typeof window !== e && d) {
                                        try {
                                            return void (window.localStorage[d] = i);
                                        } catch (t) {}
                                        try {
                                            window.document.cookie = encodeURIComponent(d) + "=" + i + ";";
                                        } catch (t) {}
                                    }
                                }(h), l.call(u);
                            }, u.setDefaultLevel = function(t) {
                                a = m(t), f() || u.setLevel(t, !1);
                            }, u.resetLevel = function() {
                                h = null, function() {
                                    if (typeof window !== e && d) {
                                        try {
                                            window.localStorage.removeItem(d);
                                        } catch (t) {}
                                        try {
                                            window.document.cookie = encodeURIComponent(d) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
                                        } catch (t) {}
                                    }
                                }(), l.call(u);
                            }, u.enableAll = function(t) {
                                u.setLevel(u.levels.TRACE, t);
                            }, u.disableAll = function(t) {
                                u.setLevel(u.levels.SILENT, t);
                            }, u.rebuild = function() {
                                if (r !== u && (o = m(r.getLevel())), l.call(u), r === u) for(var t in n)n[t].rebuild();
                            }, o = m(r ? r.getLevel() : "WARN");
                            var p = f();
                            null != p && (h = m(p)), l.call(u);
                        }
                        (r = new u).getLogger = function(t) {
                            if ("symbol" != typeof t && "string" != typeof t || "" === t) throw new TypeError("You must supply a name when creating a logger.");
                            var e = n[t];
                            return e || (e = n[t] = new u(t, r.methodFactory)), e;
                        };
                        var d = typeof window !== e ? window.log : void 0;
                        return r.noConflict = function() {
                            return typeof window !== e && window.log === r && (window.log = d), r;
                        }, r.getLoggers = function() {
                            return n;
                        }, r.default = r, r;
                    }, void 0 === (n = s.call(e, i, e, t)) || (t.exports = n);
                }();
            },
            2561 (t, e) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.Fraction = void 0;
                class i {
                    static max(t, e) {
                        return t.RealValue > e.RealValue ? t : e;
                    }
                    static Equal(t, e) {
                        return t.wholeValue === e.wholeValue && t.Denominator === e.Denominator && t.Numerator === e.Numerator;
                    }
                    static createFromFraction(t) {
                        return new i(t.numerator, t.denominator, t.wholeValue, !1);
                    }
                    static plus(t, e) {
                        const i = t.clone();
                        return i.Add(e), i;
                    }
                    static minus(t, e) {
                        const i = t.clone();
                        return i.Sub(e), i;
                    }
                    static multiply(t, e) {
                        return new i((t.wholeValue * t.denominator + t.numerator) * (e.wholeValue * e.denominator + e.numerator), t.denominator * e.denominator);
                    }
                    static greatestCommonDenominator(t, e) {
                        if (0 === t) return e;
                        if (1 === e) return 1;
                        if (Number.isInteger(t) && Number.isInteger(e)) {
                            for(; 0 !== e;){
                                const i = t % e;
                                t = e, e = i;
                            }
                            return t;
                        }
                        for(; Math.abs(e) >= 1 && Math.abs(t) >= 1;)t > e ? t -= e : e -= t;
                        const i = Math.round(t);
                        return Math.max(i, 1);
                    }
                    constructor(t = 0, e = 1, i = 0, s = !0){
                        this.numerator = 0, this.denominator = 1, this.wholeValue = 0, this.numerator = t, this.denominator = e, this.wholeValue = i, s && this.simplify(), this.setRealValue();
                    }
                    toString() {
                        let t = this.numerator + "/" + this.denominator;
                        return 0 !== this.wholeValue && (t = this.wholeValue + " " + t), t;
                    }
                    clone() {
                        return new i(this.numerator, this.denominator, this.wholeValue, !1);
                    }
                    get Numerator() {
                        return this.numerator;
                    }
                    set Numerator(t) {
                        this.numerator !== t && (this.numerator = t, this.simplify(), this.setRealValue());
                    }
                    get Denominator() {
                        return this.denominator;
                    }
                    set Denominator(t) {
                        this.denominator !== t && (this.denominator = t, 0 !== this.numerator && this.simplify(), this.setRealValue());
                    }
                    get WholeValue() {
                        return this.wholeValue;
                    }
                    set WholeValue(t) {
                        this.wholeValue !== t && (this.wholeValue = t, this.setRealValue());
                    }
                    GetExpandedNumerator() {
                        return this.wholeValue * this.denominator + this.numerator;
                    }
                    calculateNumberOfNeededDots() {
                        let t = 1, e = 2;
                        const i = this.GetExpandedNumerator();
                        for(; e < i;)t++, e = Math.pow(2, t);
                        return Math.min(3, t - 1);
                    }
                    IsNegative() {
                        return this.realValue < 0;
                    }
                    get RealValue() {
                        return this.realValue;
                    }
                    expand(t) {
                        this.numerator *= t, this.denominator *= t, 0 !== this.wholeValue && (this.numerator += this.wholeValue * this.denominator, this.wholeValue = 0);
                    }
                    Add(t) {
                        return this.numerator = (this.wholeValue * this.denominator + this.numerator) * t.denominator + (t.wholeValue * t.denominator + t.numerator) * this.denominator, this.denominator = this.denominator * t.denominator, this.wholeValue = 0, this.simplify(), this.setRealValue(), this;
                    }
                    Sub(t) {
                        return this.numerator = (this.wholeValue * this.denominator + this.numerator) * t.denominator - (t.wholeValue * t.denominator + t.numerator) * this.denominator, this.denominator = this.denominator * t.denominator, this.wholeValue = 0, this.simplify(), this.setRealValue(), this;
                    }
                    Quantize(t) {
                        if (this.denominator <= t) return this;
                        const e = new i(this.numerator + 1, this.denominator, this.wholeValue);
                        for(; e.Denominator > t;)e.Numerator++;
                        if (this.numerator > this.denominator) {
                            const s = new i(this.numerator - 1, this.denominator, this.wholeValue);
                            for(; s.Denominator > t;)s.Numerator--;
                            if (s.Denominator < e.Denominator) return s;
                        }
                        return e;
                    }
                    Equals(t) {
                        return this.realValue === t?.realValue;
                    }
                    CompareTo(t) {
                        const e = this.realValue - t.realValue;
                        return e ? e < 0 ? -1 : 1 : 0;
                    }
                    lt(t) {
                        return this.realValue < t.realValue;
                    }
                    lte(t) {
                        return this.realValue <= t.realValue;
                    }
                    gt(t) {
                        return !this.lte(t);
                    }
                    gte(t) {
                        return !this.lt(t);
                    }
                    setRealValue() {
                        this.realValue = this.wholeValue + this.numerator / this.denominator;
                    }
                    simplify() {
                        if (0 === this.numerator) return void (this.denominator = 1);
                        const t = i.greatestCommonDenominator(Math.abs(this.numerator), Math.abs(this.denominator));
                        this.numerator /= t, this.denominator /= t;
                        const e = Math.floor(this.numerator / this.denominator);
                        if (0 !== e && (this.wholeValue += e, this.numerator -= e * this.denominator, 0 === this.numerator && (this.denominator = 1)), this.denominator > i.maximumAllowedNumber) {
                            const t = this.denominator / i.maximumAllowedNumber;
                            this.numerator = Math.round(this.numerator / t), this.denominator = Math.round(this.denominator / t);
                        }
                        if (this.numerator > i.maximumAllowedNumber) {
                            const t = this.numerator / i.maximumAllowedNumber;
                            this.numerator = Math.round(this.numerator / t), this.denominator = Math.round(this.denominator / t);
                        }
                    }
                    isOnBeat(t) {
                        const e = this.distanceFromBeat(t);
                        return Math.abs(e) < i.FloatInaccuracyTolerance;
                    }
                    distanceFromBeat(t) {
                        const e = new i(1, t.Denominator);
                        return this.RealValue % e.RealValue;
                    }
                }
                e.Fraction = i, i.maximumAllowedNumber = 46340, i.FloatInaccuracyTolerance = 1e-4;
            },
            6904 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.Matrix2D = void 0;
                const s = i(9409);
                class n {
                    constructor(){
                        this.matrix = [];
                        for(let t = 0; t < 2; t++){
                            this.matrix[t] = [];
                            for(let e = 0; e < 2; e++)this.matrix[t][e] = 0;
                        }
                    }
                    static getRotationMatrix(t) {
                        const e = new n, i = Math.cos(t), s = Math.sin(t);
                        return e.matrix[0][0] = i, e.matrix[0][1] = -s, e.matrix[1][0] = s, e.matrix[1][1] = i, e;
                    }
                    scalarMultiplication(t) {
                        for(let e = 0; e < 2; e++)for(let i = 0; i < 2; i++)this.matrix[e][i] *= t;
                    }
                    getTransposeMatrix() {
                        const t = new n;
                        for(let e = 0; e < 2; e++)for(let i = 0; i < 2; i++)t.matrix[e][i] = this.matrix[i][e];
                        return t;
                    }
                    vectorMultiplication(t) {
                        const e = new s.PointF2D;
                        return e.x = t.x * this.matrix[0][0] + t.y * this.matrix[0][1], e.y = t.x * this.matrix[1][0] + t.y * this.matrix[1][1], e;
                    }
                }
                e.Matrix2D = n;
            },
            8786 (t, e) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.MusicSheetErrors = void 0, e.MusicSheetErrors = class {
                    constructor(){
                        this.measureErrors = {}, this.errors = [], this.tempErrors = [];
                    }
                    finalizeMeasure(t) {
                        let e = this.measureErrors[t];
                        e || (e = []), this.measureErrors[t] = e.concat(this.tempErrors), this.tempErrors = [];
                    }
                    pushMeasureError(t) {
                        this.tempErrors.push(t);
                    }
                    push(t) {
                        this.errors.push(t);
                    }
                };
            },
            8705 (t, e) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.OSMDColor = void 0;
                class i {
                    constructor(t, e, i){
                        this.alpha = 255, this.red = t, this.green = e, this.blue = i;
                    }
                    static get Black() {
                        return new i(0, 0, 0);
                    }
                    static get DeepSkyBlue() {
                        return new i(0, 191, 255);
                    }
                    static get Green() {
                        return new i(20, 160, 20);
                    }
                    static get Magenta() {
                        return new i(255, 0, 255);
                    }
                    static get Orange() {
                        return new i(255, 128, 0);
                    }
                    static get Red() {
                        return new i(240, 20, 20);
                    }
                    static get Disabled() {
                        return new i(225, 225, 225);
                    }
                    static get DarkBlue() {
                        return new i(0, 0, 140);
                    }
                    static get Debug1() {
                        return new i(200, 0, 140);
                    }
                    static get Debug2() {
                        return new i(100, 100, 200);
                    }
                    static get Debug3() {
                        return new i(0, 50, 140);
                    }
                    toString() {
                        return "rgb(" + this.red + "," + this.green + "," + this.blue + "," + this.alpha + ")";
                    }
                }
                e.OSMDColor = i;
            },
            8233 (t, e) {
                "use strict";
                var i, s;
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.Pitch = e.AccidentalEnum = e.NoteEnum = void 0, function(t) {
                    t[t.C = 0] = "C", t[t.D = 2] = "D", t[t.E = 4] = "E", t[t.F = 5] = "F", t[t.G = 7] = "G", t[t.A = 9] = "A", t[t.B = 11] = "B";
                }(i || (e.NoteEnum = i = {})), function(t) {
                    t[t.SHARP = 0] = "SHARP", t[t.FLAT = 1] = "FLAT", t[t.NONE = 2] = "NONE", t[t.NATURAL = 3] = "NATURAL", t[t.DOUBLESHARP = 4] = "DOUBLESHARP", t[t.DOUBLEFLAT = 5] = "DOUBLEFLAT", t[t.TRIPLESHARP = 6] = "TRIPLESHARP", t[t.TRIPLEFLAT = 7] = "TRIPLEFLAT", t[t.QUARTERTONESHARP = 8] = "QUARTERTONESHARP", t[t.QUARTERTONEFLAT = 9] = "QUARTERTONEFLAT", t[t.SLASHFLAT = 10] = "SLASHFLAT", t[t.THREEQUARTERSSHARP = 11] = "THREEQUARTERSSHARP", t[t.THREEQUARTERSFLAT = 12] = "THREEQUARTERSFLAT", t[t.SLASHQUARTERSHARP = 13] = "SLASHQUARTERSHARP", t[t.SLASHSHARP = 14] = "SLASHSHARP", t[t.DOUBLESLASHFLAT = 15] = "DOUBLESLASHFLAT", t[t.SORI = 16] = "SORI", t[t.KORON = 17] = "KORON";
                }(s || (e.AccidentalEnum = s = {}));
                class n {
                    static getNoteEnumString(t) {
                        switch(t){
                            case i.C:
                                return "C";
                            case i.D:
                                return "D";
                            case i.E:
                                return "E";
                            case i.F:
                                return "F";
                            case i.G:
                                return "G";
                            case i.A:
                                return "A";
                            case i.B:
                                return "B";
                            default:
                                return "";
                        }
                    }
                    static lineShiftFromNoteEnum(t, e) {
                        if (0 === e) return [
                            t,
                            0
                        ];
                        const i = n.pitchEnumValues, s = i.indexOf(t);
                        let r = 0, o = (s + e) % i.length;
                        return s + e > i.length - 1 && (r = 1), o < 0 && (o = i.length + o, r = -1), [
                            i[o],
                            r
                        ];
                    }
                    static CalculateTransposedHalfTone(t, e) {
                        const i = t.fundamentalNote + t.AccidentalHalfTones + e;
                        return n.WrapAroundCheck(i, 12);
                    }
                    static WrapAroundCheck(t, e) {
                        let i = 0;
                        for(; t < 0;)t += e, i--;
                        for(; t >= e;)t -= e, i++;
                        return {
                            overflow: i,
                            halftone: t
                        };
                    }
                    static calcFrequency(t) {
                        let e, s = 0;
                        if (t instanceof n) {
                            const n = t;
                            s = n.octave - 1, e = n.fundamentalNote - i.A + n.AccidentalHalfTones;
                        } else "number" == typeof t && (e = t - 57);
                        return 440 * Math.pow(2, s) * Math.pow(2, e / 12);
                    }
                    static calcFractionalKey(t) {
                        return Math.log(t / 440) / Math.LN10 * n.halftoneFactor + 57;
                    }
                    static fromFrequency(t) {
                        const e = n.calcFractionalKey(t) + .5, i = Math.floor(e / 12) - n.octXmlDiff, r = Math.floor(e) % 12;
                        let o = r, a = s.NONE;
                        return -1 === this.pitchEnumValues.indexOf(o) && (o = r - 1, a = s.SHARP), new n(o, i, a);
                    }
                    static fromHalftone(t) {
                        const e = Math.floor(t / 12) - n.octXmlDiff, i = t % 12;
                        let r = i, o = s.NONE;
                        return -1 === this.pitchEnumValues.indexOf(r) && (r = i - 1, o = s.SHARP), new n(r, e, o);
                    }
                    static ceiling(t) {
                        let e = t %= 12;
                        return -1 === this.pitchEnumValues.indexOf(e) && (e = t + 1), e;
                    }
                    static floor(t) {
                        let e = t %= 12;
                        return -1 === this.pitchEnumValues.indexOf(e) && (e = t - 1), e;
                    }
                    constructor(t, e, i, r, o = !1, a){
                        this.accidental = s.NONE, this.fundamentalNote = t, this.octave = e, this.accidental = i, this.accidentalXml = r, this.halfTone = t + 12 * (e + n.octXmlDiff) + n.HalfTonesFromAccidental(i), o || (this.frequency = n.calcFrequency(this)), this.OctaveShiftApplied = a;
                    }
                    static HalfTonesFromAccidental(t) {
                        switch(t){
                            case s.NONE:
                                return 0;
                            case s.SHARP:
                                return 1;
                            case s.FLAT:
                                return -1;
                            case s.NATURAL:
                                return 0;
                            case s.DOUBLESHARP:
                                return 2;
                            case s.DOUBLEFLAT:
                                return -2;
                            case s.TRIPLESHARP:
                                return 3;
                            case s.TRIPLEFLAT:
                                return -3;
                            case s.QUARTERTONESHARP:
                                return .5;
                            case s.QUARTERTONEFLAT:
                                return -0.5;
                            case s.SLASHFLAT:
                                return -0.51;
                            case s.THREEQUARTERSSHARP:
                                return 1.5;
                            case s.THREEQUARTERSFLAT:
                                return -1.5;
                            case s.SLASHQUARTERSHARP:
                                return .0013;
                            case s.SLASHSHARP:
                                return .0014;
                            case s.DOUBLESLASHFLAT:
                                return -0.0015;
                            case s.SORI:
                                return .0016;
                            case s.KORON:
                                return .0017;
                            default:
                                throw new Error("Unhandled AccidentalEnum value");
                        }
                    }
                    static AccidentalFromHalfTones(t) {
                        switch(t){
                            case 0:
                                return s.NONE;
                            case 1:
                                return s.SHARP;
                            case -1:
                                return s.FLAT;
                            case 2:
                                return s.DOUBLESHARP;
                            case -2:
                                return s.DOUBLEFLAT;
                            case 3:
                                return s.TRIPLESHARP;
                            case -3:
                                return s.TRIPLEFLAT;
                            case .5:
                                return s.QUARTERTONESHARP;
                            case -0.5:
                                return s.QUARTERTONEFLAT;
                            case 1.5:
                                return s.THREEQUARTERSSHARP;
                            case -1.5:
                                return s.THREEQUARTERSFLAT;
                            default:
                                return t > 0 && t < 1 ? s.QUARTERTONESHARP : t < 0 && t > -1 ? s.QUARTERTONEFLAT : s.QUARTERTONESHARP;
                        }
                    }
                    static accidentalVexflow(t) {
                        let e;
                        switch(t){
                            case s.NATURAL:
                                e = "n";
                                break;
                            case s.FLAT:
                                e = "b";
                                break;
                            case s.SHARP:
                                e = "#";
                                break;
                            case s.DOUBLESHARP:
                                e = "##";
                                break;
                            case s.TRIPLESHARP:
                                e = "###";
                                break;
                            case s.DOUBLEFLAT:
                                e = "bb";
                                break;
                            case s.TRIPLEFLAT:
                                e = "bbs";
                                break;
                            case s.QUARTERTONESHARP:
                                e = "+";
                                break;
                            case s.QUARTERTONEFLAT:
                                e = "d";
                                break;
                            case s.SLASHFLAT:
                                e = "bs";
                                break;
                            case s.THREEQUARTERSSHARP:
                                e = "++";
                                break;
                            case s.THREEQUARTERSFLAT:
                                e = "db";
                                break;
                            case s.SLASHQUARTERSHARP:
                                e = "+-";
                                break;
                            case s.SLASHSHARP:
                                e = "++-";
                                break;
                            case s.DOUBLESLASHFLAT:
                                e = "bss";
                                break;
                            case s.SORI:
                                e = "o";
                                break;
                            case s.KORON:
                                e = "k";
                        }
                        return e;
                    }
                    get AccidentalHalfTones() {
                        return n.HalfTonesFromAccidental(this.accidental);
                    }
                    get Octave() {
                        return this.octave;
                    }
                    get FundamentalNote() {
                        return this.fundamentalNote;
                    }
                    get Accidental() {
                        return this.accidental;
                    }
                    get AccidentalXml() {
                        return this.accidentalXml;
                    }
                    get Frequency() {
                        return this.frequency;
                    }
                    static get OctaveXmlDifference() {
                        return n.octXmlDiff;
                    }
                    getHalfTone() {
                        return this.halfTone;
                    }
                    getTransposedPitch(t) {
                        if (t > 12) throw new Error("rewrite this method to handle bigger octave changes or don't use is with bigger octave changes!");
                        return t > 0 ? this.getHigherPitchByTransposeFactor(t) : t < 0 ? this.getLowerPitchByTransposeFactor(-t) : this;
                    }
                    DoEnharmonicChange() {
                        switch(this.accidental){
                            case s.FLAT:
                            case s.DOUBLEFLAT:
                                this.fundamentalNote = this.getPreviousFundamentalNote(this.fundamentalNote), this.accidental = n.AccidentalFromHalfTones(this.halfTone - (this.fundamentalNote + 12 * (this.octave + n.octXmlDiff)));
                                break;
                            case s.SHARP:
                            case s.DOUBLESHARP:
                                this.fundamentalNote = this.getNextFundamentalNote(this.fundamentalNote), this.accidental = n.AccidentalFromHalfTones(this.halfTone - (this.fundamentalNote + 12 * (this.octave + n.octXmlDiff)));
                                break;
                            default:
                                return;
                        }
                    }
                    ToString() {
                        let t = n.accidentalVexflow(this.accidental);
                        return t || (t = ""), "Key: " + n.getNoteEnumString(this.fundamentalNote) + t + ", Note: " + this.fundamentalNote + ", octave: " + this.octave.toString();
                    }
                    ToStringShort(t = 0) {
                        let e = n.accidentalVexflow(this.accidental);
                        e || (e = "");
                        const i = this.octave + t;
                        return n.getNoteEnumString(this.fundamentalNote) + e + i;
                    }
                    get ToStringShortGet() {
                        return this.ToStringShort(0);
                    }
                    OperatorEquals(t) {
                        const e = this;
                        return !(!e || !t) && e.FundamentalNote === t.FundamentalNote && e.Octave === t.Octave && e.Accidental === t.Accidental;
                    }
                    OperatorNotEqual(t) {
                        return !(this === t);
                    }
                    OperatorFundamentalGreaterThan(t) {
                        const e = this;
                        return e.Octave === t.Octave ? e.FundamentalNote > t.FundamentalNote : e.Octave > t.Octave;
                    }
                    OperatorFundamentalLessThan(t) {
                        const e = this;
                        return e.Octave === t.Octave ? e.FundamentalNote < t.FundamentalNote : e.Octave < t.Octave;
                    }
                    getHigherPitchByTransposeFactor(t) {
                        const e = n.pitchEnumValues.indexOf(this.fundamentalNote);
                        let i, r = this.octave;
                        return e + t > n.pitchEnumValues.length - 1 ? (i = n.pitchEnumValues[e + t - n.pitchEnumValues.length], r++) : i = n.pitchEnumValues[e + t], new n(i, r, s.NONE);
                    }
                    getLowerPitchByTransposeFactor(t) {
                        const e = n.pitchEnumValues.indexOf(this.fundamentalNote);
                        let i, r = this.octave;
                        return e - t < 0 ? (i = n.pitchEnumValues[n.pitchEnumValues.length + e - t], r--) : i = n.pitchEnumValues[e - t], new n(i, r, s.NONE);
                    }
                    getNextFundamentalNote(t) {
                        let e = n.pitchEnumValues.indexOf(t);
                        return e = (e + 1) % n.pitchEnumValues.length, n.pitchEnumValues[e];
                    }
                    getPreviousFundamentalNote(t) {
                        const e = n.pitchEnumValues.indexOf(t);
                        return e > 0 ? n.pitchEnumValues[e - 1] : n.pitchEnumValues[n.pitchEnumValues.length - 1];
                    }
                }
                e.Pitch = n, n.pitchEnumValues = [
                    i.C,
                    i.D,
                    i.E,
                    i.F,
                    i.G,
                    i.A,
                    i.B
                ], n.halftoneFactor = 12 / (Math.LN2 / Math.LN10), n.octXmlDiff = 3;
            },
            283 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.PlaybackSettings = void 0;
                const s = i(2561);
                class n {
                    constructor(t = new s.Fraction, e = 100){
                        this.rhythm = t, this.beatsPerMinute = e, this.beatLengthInMilliseconds = 6e4 / e, this.beatRealValue = 1 / 4;
                    }
                    static createFrom(t) {
                        return new n(t.Rhythm, t.BeatsPerMinute);
                    }
                    get BeatsPerMinute() {
                        return this.beatsPerMinute;
                    }
                    set BeatsPerMinute(t) {
                        this.beatsPerMinute = t, this.beatLengthInMilliseconds = 6e4 / this.beatsPerMinute;
                    }
                    get Rhythm() {
                        return this.rhythm;
                    }
                    set Rhythm(t) {
                        this.rhythm = t;
                    }
                    get BeatRealValue() {
                        return this.beatRealValue;
                    }
                    get BeatLengthInMilliseconds() {
                        return this.beatLengthInMilliseconds;
                    }
                    getDurationInMilliseconds(t) {
                        return ("number" == typeof t ? t : t.RealValue) * this.BeatLengthInMilliseconds / this.beatRealValue;
                    }
                    getDurationAsNoteDuration(t, e = 1024) {
                        const i = t / this.BeatLengthInMilliseconds;
                        let n = Math.floor(i);
                        const r = new s.Fraction(n, 4), o = i - n;
                        return n = Math.round(o / (1 / e) / 4), 0 !== o && 0 === n && t > 0 && (n = 1), r.Add(new s.Fraction(n, e)), r;
                    }
                }
                e.PlaybackSettings = n;
            },
            9409 (t, e) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.PointF2D = void 0;
                class i {
                    constructor(t = 0, e = 0){
                        this.x = 0, this.y = 0, this.x = t, this.y = e;
                    }
                    static get Empty() {
                        return new i;
                    }
                    static pointsAreEqual(t, e) {
                        return t.x === e.x && t.y === e.y;
                    }
                    ToString() {
                        return "[" + this.x + ", " + this.y + "]";
                    }
                }
                e.PointF2D = i;
            },
            200 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.RectangleF2D = void 0;
                const s = i(6864), n = i(9409);
                class r {
                    constructor(t, e, i, s){
                        this.x = 0, this.y = 0, this.width = 0, this.height = 0, this.x = t, this.y = e, this.width = i, this.height = s;
                    }
                    static createFromLocationAndSize(t, e) {
                        return new r(t.x, t.y, e.width, e.height);
                    }
                    get Location() {
                        return new n.PointF2D(this.x, this.y);
                    }
                    get Size() {
                        return new s.SizeF2D(this.width, this.height);
                    }
                }
                e.RectangleF2D = r;
            },
            6864 (t, e) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.SizeF2D = void 0, e.SizeF2D = class {
                    constructor(t = 0, e = 0){
                        this.width = t, this.height = e;
                    }
                };
            },
            9735 (t, e, i) {
                "use strict";
                var s = this && this.__createBinding || (Object.create ? function(t, e, i, s) {
                    void 0 === s && (s = i);
                    var n = Object.getOwnPropertyDescriptor(e, i);
                    n && !("get" in n ? !e.__esModule : n.writable || n.configurable) || (n = {
                        enumerable: !0,
                        get: function() {
                            return e[i];
                        }
                    }), Object.defineProperty(t, s, n);
                } : function(t, e, i, s) {
                    void 0 === s && (s = i), t[s] = e[i];
                }), n = this && this.__exportStar || function(t, e) {
                    for(var i in t)"default" === i || Object.prototype.hasOwnProperty.call(e, i) || s(e, t, i);
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), n(i(2561), e), n(i(6904), e), n(i(8786), e), n(i(8705), e), n(i(8233), e), n(i(9409), e), n(i(200), e), n(i(6864), e);
            },
            4434 (t, e) {
                "use strict";
                var i;
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.ColoringModes = void 0, function(t) {
                    t[t.XML = 0] = "XML", t[t.AutoColoring = 1] = "AutoColoring", t[t.CustomColorSet = 2] = "CustomColorSet";
                }(i || (e.ColoringModes = i = {}));
            },
            4146 (t, e) {
                "use strict";
                var i;
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.DrawingParametersEnum = void 0, function(t) {
                    t.allon = "allon", t.compact = "compact", t.compacttight = "compacttight", t.default = "default", t.leadsheet = "leadsheet", t.preview = "preview", t.thumbnail = "thumbnail";
                }(i || (e.DrawingParametersEnum = i = {}));
            },
            2570 (t, e) {
                "use strict";
                var i;
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.FontStyles = void 0, function(t) {
                    t[t.Regular = 0] = "Regular", t[t.Bold = 1] = "Bold", t[t.Italic = 2] = "Italic", t[t.BoldItalic = 3] = "BoldItalic", t[t.Underlined = 4] = "Underlined";
                }(i || (e.FontStyles = i = {}));
            },
            5951 (t, e) {
                "use strict";
                var i;
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.Fonts = void 0, function(t) {
                    t[t.TimesNewRoman = 0] = "TimesNewRoman", t[t.Kokila = 1] = "Kokila";
                }(i || (e.Fonts = i = {}));
            },
            7533 (t, e) {
                "use strict";
                var i;
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.TextAlignment = e.TextAlignmentEnum = void 0, function(t) {
                    t[t.LeftTop = 0] = "LeftTop", t[t.LeftCenter = 1] = "LeftCenter", t[t.LeftBottom = 2] = "LeftBottom", t[t.CenterTop = 3] = "CenterTop", t[t.CenterCenter = 4] = "CenterCenter", t[t.CenterBottom = 5] = "CenterBottom", t[t.RightTop = 6] = "RightTop", t[t.RightCenter = 7] = "RightCenter", t[t.RightBottom = 8] = "RightBottom";
                }(i || (e.TextAlignmentEnum = i = {})), e.TextAlignment = class {
                    static IsLeft(t) {
                        return t === i.LeftTop || t === i.LeftCenter || t === i.LeftBottom;
                    }
                    static IsCenterAligned(t) {
                        return t === i.CenterTop || t === i.CenterCenter || t === i.CenterBottom;
                    }
                    static IsRight(t) {
                        return t === i.RightTop || t === i.RightCenter || t === i.RightBottom;
                    }
                };
            },
            2514 (t, e) {
                "use strict";
                var i;
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.TieTypes = void 0, function(t) {
                    t.SIMPLE = "", t.HAMMERON = "H", t.PULLOFF = "P", t.SLIDE = "S", t.TAPPING = "T";
                }(i || (e.TieTypes = i = {}));
            },
            2257 (t, e, i) {
                "use strict";
                var s = this && this.__createBinding || (Object.create ? function(t, e, i, s) {
                    void 0 === s && (s = i);
                    var n = Object.getOwnPropertyDescriptor(e, i);
                    n && !("get" in n ? !e.__esModule : n.writable || n.configurable) || (n = {
                        enumerable: !0,
                        get: function() {
                            return e[i];
                        }
                    }), Object.defineProperty(t, s, n);
                } : function(t, e, i, s) {
                    void 0 === s && (s = i), t[s] = e[i];
                }), n = this && this.__exportStar || function(t, e) {
                    for(var i in t)"default" === i || Object.prototype.hasOwnProperty.call(e, i) || s(e, t, i);
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), n(i(4434), e), n(i(4146), e), n(i(2570), e), n(i(5951), e), n(i(7533), e), n(i(2514), e);
            },
            6888 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.MXLHelper = e.MXLFile = void 0;
                const n = i(3902), r = s(i(1710)), o = s(i(3065));
                e.MXLFile = class {
                    constructor(t){
                        this.unzipSuccessful = !1, this.blob = t;
                    }
                    async tryUnzip() {
                        this.zipFile = new r.default;
                        try {
                            return this.unzipSuccessful = !0, await this.zipFile.loadAsync(this.blob), !0;
                        } catch (t) {
                            return this.unzipSuccessful = !1, !1;
                        }
                    }
                    getXmlString() {
                        return a.jszipToXMLstring(this.zipFile);
                    }
                };
                class a {
                    static MXLtoIXmlElement(t) {
                        return this.MXLtoXMLstring(t).then((t)=>{
                            const e = (new DOMParser).parseFromString(t, "text/xml"), i = new n.IXmlElement(e.documentElement);
                            return Promise.resolve(i);
                        }, (t)=>{
                            throw new Error("extractSheetFromMxl: " + t.message);
                        });
                    }
                    static async jszipToXMLstring(t) {
                        let e = await t.file("META-INF/container.xml").async("text");
                        if (!e.startsWith("<")) {
                            const i = await t.file("META-INF/container.xml").async("uint8array");
                            e = new TextDecoder("utf-8").decode(i);
                        }
                        if (!e.startsWith("<")) {
                            const i = await t.file("META-INF/container.xml").async("uint8array");
                            e = new TextDecoder("utf-16").decode(i);
                        }
                        const i = (new DOMParser).parseFromString(e, "text/xml").getElementsByTagName("rootfile")[0].getAttribute("full-path"), s = await t.file(i).async("text");
                        if (!s.substring(0, 1).startsWith("<")) {
                            const e = await t.file(i).async("uint8array");
                            return new TextDecoder("utf-16").decode(e);
                        }
                        return s;
                    }
                    static MXLtoXMLstring(t) {
                        const e = new r.default;
                        return e.loadAsync(t).then(async (t)=>this.jszipToXMLstring(e), (t)=>{
                            throw o.default.error(t), t;
                        });
                    }
                }
                e.MXLHelper = a;
            },
            3902 (t, e) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.IXmlElement = void 0;
                class i {
                    constructor(t, e){
                        if (this.attrs = void 0, this.valueOfElement = void 0, this.valueKnown = !1, this.hasAttributesOfElement = !1, this.firstAttributeOfElement = void 0, this.attributeFieldsKnown = !1, this.hasElementsOfElement = !1, this.hasElementsKnown = !1, this.childElements = void 0, this.childNames = void 0, this.childLookups = 0, !t) throw new Error("IXmlElement: expected Element, got undefined");
                        this.elem = t, this.name = void 0 !== e ? e : t.nodeName.toLowerCase();
                    }
                    get value() {
                        if (!this.valueKnown) {
                            const t = this.elem.firstChild;
                            this.valueOfElement = t && !t.nextSibling && t.nodeType === Node.TEXT_NODE ? t.nodeValue : "", this.valueKnown = !0;
                        }
                        return this.valueOfElement;
                    }
                    set value(t) {
                        this.valueOfElement = t, this.valueKnown = !0;
                    }
                    get hasAttributes() {
                        return this.readAttributeFields(), this.hasAttributesOfElement;
                    }
                    set hasAttributes(t) {
                        this.readAttributeFields(), this.hasAttributesOfElement = t;
                    }
                    get firstAttribute() {
                        return this.readAttributeFields(), this.firstAttributeOfElement;
                    }
                    set firstAttribute(t) {
                        this.readAttributeFields(), this.firstAttributeOfElement = t;
                    }
                    get hasElements() {
                        return this.hasElementsKnown || (this.hasElementsOfElement = this.elem.hasChildNodes(), this.hasElementsKnown = !0), this.hasElementsOfElement;
                    }
                    set hasElements(t) {
                        this.hasElementsOfElement = t, this.hasElementsKnown = !0;
                    }
                    readAttributeFields() {
                        this.attributeFieldsKnown || (this.attributeFieldsKnown = !0, this.hasAttributesOfElement = !1, this.elem.hasAttributes() && (this.hasAttributesOfElement = !0, this.firstAttributeOfElement = this.elem.attributes[0]));
                    }
                    attribute(t) {
                        return this.elem.getAttributeNode(t);
                    }
                    attributes() {
                        if (!this.attrs) {
                            const t = this.elem.attributes, e = [];
                            for(let i = 0; i < t.length; i += 1)e.push(t[i]);
                            this.attrs = e;
                        }
                        return this.attrs;
                    }
                    element(t) {
                        const e = this.childList();
                        if (e) {
                            const s = this.childNames;
                            for(let n = 0; n < s.length; n++)if (s[n] === t) return new i(e[n], t);
                            return;
                        }
                        for(let e = this.elem.firstElementChild; e; e = e.nextElementSibling)if (e.nodeName.toLowerCase() === t) return new i(e, t);
                    }
                    elements(t) {
                        const e = [], s = !t;
                        s || (t = t.toLowerCase());
                        const n = this.childList();
                        if (n) {
                            const r = this.childNames;
                            for(let o = 0; o < n.length; o++)s ? e.push(new i(n[o], r[o])) : r[o] === t && e.push(new i(n[o], t));
                            return e;
                        }
                        for(let n = this.elem.firstElementChild; n; n = n.nextElementSibling)s ? e.push(new i(n)) : n.nodeName.toLowerCase() === t && e.push(new i(n, t));
                        return e;
                    }
                    combinedElement(t) {
                        let e;
                        const s = (t)=>{
                            if (!e) return void (e = t);
                            const i = t.childNodes;
                            for(let t = 0, s = i.length; t < s; t += 1){
                                const s = i[t];
                                e.appendChild(s.cloneNode(!0));
                            }
                        }, n = this.childList();
                        if (n) {
                            const e = this.childNames;
                            for(let i = 0; i < n.length; i++)e[i] === t && s(n[i]);
                        } else for(let e = this.elem.firstElementChild; e; e = e.nextElementSibling)e.nodeName.toLowerCase() === t && s(e);
                        if (e) return new i(e, t);
                    }
                    childList() {
                        if (this.childElements) {
                            const t = this.childElements.length > 0 ? this.childElements[this.childElements.length - 1] : null;
                            if (this.elem.lastElementChild === t) return this.childElements;
                        } else if (++this.childLookups < 2) return;
                        const t = [], e = [];
                        for(let i = this.elem.firstElementChild; i; i = i.nextElementSibling)t.push(i), e.push(i.nodeName.toLowerCase());
                        return this.childElements = t, this.childNames = e, t;
                    }
                }
                e.IXmlElement = i;
            },
            599 (t, e, i) {
                "use strict";
                var s = this && this.__createBinding || (Object.create ? function(t, e, i, s) {
                    void 0 === s && (s = i);
                    var n = Object.getOwnPropertyDescriptor(e, i);
                    n && !("get" in n ? !e.__esModule : n.writable || n.configurable) || (n = {
                        enumerable: !0,
                        get: function() {
                            return e[i];
                        }
                    }), Object.defineProperty(t, s, n);
                } : function(t, e, i, s) {
                    void 0 === s && (s = i), t[s] = e[i];
                }), n = this && this.__exportStar || function(t, e) {
                    for(var i in t)"default" === i || Object.prototype.hasOwnProperty.call(e, i) || s(e, t, i);
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), n(i(6888), e), n(i(3902), e);
            },
            4356 (t, e) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.StringUtil = void 0, e.StringUtil = class {
                    static StringContainsSeparatedWord(t, e, i = !1) {
                        return new RegExp("( |^)" + e + "([ .]|$)", i ? "i" : void 0).test(t);
                    }
                    static StringIsWord(t, e, i = !1) {
                        return new RegExp("^(" + e + ")[ .]*$", i ? "i" : void 0).test(t);
                    }
                };
            },
            2552 (t, e, i) {
                "use strict";
                var s = this && this.__createBinding || (Object.create ? function(t, e, i, s) {
                    void 0 === s && (s = i);
                    var n = Object.getOwnPropertyDescriptor(e, i);
                    n && !("get" in n ? !e.__esModule : n.writable || n.configurable) || (n = {
                        enumerable: !0,
                        get: function() {
                            return e[i];
                        }
                    }), Object.defineProperty(t, s, n);
                } : function(t, e, i, s) {
                    void 0 === s && (s = i), t[s] = e[i];
                }), n = this && this.__exportStar || function(t, e) {
                    for(var i in t)"default" === i || Object.prototype.hasOwnProperty.call(e, i) || s(e, t, i);
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), n(i(9735), e), n(i(2257), e), n(i(599), e);
            },
            7307 (t, e) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.InvalidEnumArgumentException = e.ArgumentOutOfRangeException = e.MusicSheetReadingException = void 0, e.MusicSheetReadingException = class {
                    constructor(t, e){
                        this.message = t, e && (this.message += " " + e.toString());
                    }
                }, e.ArgumentOutOfRangeException = class {
                    constructor(t){
                        this.message = t;
                    }
                }, e.InvalidEnumArgumentException = class {
                    constructor(t){
                        this.message = t;
                    }
                };
            },
            9490 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.AbstractGraphicalExpression = void 0;
                const s = i(7741), n = i(6438);
                class r extends s.GraphicalObject {
                    constructor(t, e, i){
                        super(), this.expression = e, this.parentMeasure = i, this.boundingBox = new n.BoundingBox(this, t.PositionAndShape), this.parentStaffLine = t, this.parentStaffLine.AbstractExpressions.push(this), this.rules = t.ParentMusicSystem.rules;
                    }
                    get Label() {
                        return this.label;
                    }
                    get ParentStaffLine() {
                        return this.parentStaffLine;
                    }
                    get SourceExpression() {
                        return this.expression;
                    }
                    get Placement() {
                        return this.expression.Placement;
                    }
                }
                e.AbstractGraphicalExpression = r;
            },
            1974 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.AbstractGraphicalInstruction = void 0;
                const s = i(7741);
                class n extends s.GraphicalObject {
                    constructor(t){
                        super(), this.parent = t;
                    }
                    get Parent() {
                        return this.parent;
                    }
                    set Parent(t) {
                        this.parent = t;
                    }
                }
                e.AbstractGraphicalInstruction = n;
            },
            8927 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.AccidentalCalculator = void 0;
                const s = i(8233), n = i(8233), r = i(3263), o = i(7921);
                e.AccidentalCalculator = class {
                    constructor(){
                        this.keySignatureNoteAlterationsDict = new r.Dictionary, this.currentInMeasureNoteAlterationsDict = new r.Dictionary, this.lastNoteWithAccidentalDict = new r.Dictionary;
                    }
                    get ActiveKeyInstruction() {
                        return this.activeKeyInstruction;
                    }
                    set ActiveKeyInstruction(t) {
                        this.activeKeyInstruction = t, this.reactOnKeyInstructionChange();
                    }
                    doCalculationsAtEndOfMeasure() {
                        this.currentInMeasureNoteAlterationsDict.clear(), this.lastNoteWithAccidentalDict.clear();
                        for (const t of this.keySignatureNoteAlterationsDict.keys())this.currentInMeasureNoteAlterationsDict.setValue(t, this.keySignatureNoteAlterationsDict.getValue(t));
                    }
                    checkAccidental(t, e) {
                        if (!e) return;
                        const i = e.FundamentalNote + 12 * e.Octave, r = t.sourceNote.NoteTie;
                        if (r && t.sourceNote !== r.StartNote) {
                            const t = r.StartNote.Pitch;
                            if (void 0 !== t && t.FundamentalNote === e.FundamentalNote) return;
                        }
                        if (this.currentInMeasureNoteAlterationsDict.containsKey(i)) {
                            if (this.currentInMeasureNoteAlterationsDict.getValue(i) !== e.AccidentalHalfTones) {
                                this.keySignatureNoteAlterationsDict.containsKey(i) && this.keySignatureNoteAlterationsDict.getValue(i) !== e.AccidentalHalfTones ? this.currentInMeasureNoteAlterationsDict.setValue(i, e.AccidentalHalfTones) : e.Accidental !== s.AccidentalEnum.NONE ? this.keySignatureNoteAlterationsDict.containsKey(i) ? this.currentInMeasureNoteAlterationsDict.setValue(i, this.keySignatureNoteAlterationsDict.getValue(i)) : 0 === e.AccidentalHalfTones ? this.currentInMeasureNoteAlterationsDict.remove(i) : this.currentInMeasureNoteAlterationsDict.setValue(i, e.AccidentalHalfTones) : this.currentInMeasureNoteAlterationsDict.setValue(i, e.AccidentalHalfTones);
                                const r = this.currentInMeasureNoteAlterationsDict.getValue(i);
                                if (e.Accidental === s.AccidentalEnum.NONE && (e = .5 === Math.abs(r) ? new n.Pitch(e.FundamentalNote, e.Octave, s.AccidentalEnum.NONE, void 0, !1, e.OctaveShiftApplied) : new n.Pitch(e.FundamentalNote, e.Octave, s.AccidentalEnum.NATURAL, void 0, !1, e.OctaveShiftApplied)), this.isAlterAmbiguousAccidental(e.Accidental) && !e.AccidentalXml) return;
                                this.addAccidental(t, e, i);
                            } else e.AccidentalXml && 0 === this.Transpose && !this.isAccidentalDrawnAtSameTime(t, e, i) && this.addAccidental(t, e, i);
                        } else if (e.Accidental !== s.AccidentalEnum.NONE) {
                            if (this.currentInMeasureNoteAlterationsDict.setValue(i, e.AccidentalHalfTones), this.isAlterAmbiguousAccidental(e.Accidental) && !e.AccidentalXml) return;
                            this.addAccidental(t, e, i);
                        }
                    }
                    addAccidental(t, e, i) {
                        o.MusicSheetCalculator.symbolFactory.addGraphicalAccidental(t, e), t.parentVoiceEntry.parentVoiceEntry.IsGrace || this.lastNoteWithAccidentalDict.setValue(i, t);
                    }
                    isAccidentalDrawnAtSameTime(t, e, i) {
                        const s = this.lastNoteWithAccidentalDict.getValue(i);
                        return void 0 !== s && !t.parentVoiceEntry.parentVoiceEntry.IsGrace && s.parentVoiceEntry.parentStaffEntry === t.parentVoiceEntry.parentStaffEntry && s.DrawnAccidental === e.Accidental;
                    }
                    isAlterAmbiguousAccidental(t) {
                        return t === s.AccidentalEnum.SLASHFLAT || t === s.AccidentalEnum.QUARTERTONEFLAT;
                    }
                    reactOnKeyInstructionChange() {
                        const t = this.activeKeyInstruction.AlteratedNotes;
                        let e;
                        e = this.activeKeyInstruction.Key > 0 ? s.AccidentalEnum.SHARP : s.AccidentalEnum.FLAT, this.keySignatureNoteAlterationsDict.clear();
                        for(let i = -9; i < 9; i++)for(let s = 0; s < t.length; s++)this.keySignatureNoteAlterationsDict.setValue(t[s] + 12 * i, n.Pitch.HalfTonesFromAccidental(e));
                        this.doCalculationsAtEndOfMeasure();
                    }
                };
            },
            6438 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.ColDirEnum = e.BoundingBox = void 0;
                const n = s(i(3065)), r = i(7307), o = i(9409), a = i(6864), l = i(200), h = i(7741);
                var c;
                e.BoundingBox = class {
                    constructor(t, e, i = !1){
                        this.isSymbol = !1, this.relativePositionHasBeenSet = !1, this.xBordersHaveBeenSet = !1, this.yBordersHaveBeenSet = !1, this.absolutePosition = new o.PointF2D, this.relativePosition = new o.PointF2D, this.size = new a.SizeF2D, this.marginSize = new a.SizeF2D, this.upperLeftCorner = new o.PointF2D, this.upperLeftMarginCorner = new o.PointF2D, this.borderLeft = 0, this.borderRight = 0, this.borderTop = 0, this.borderBottom = 0, this.borderMarginLeft = 0, this.borderMarginRight = 0, this.borderMarginTop = 0, this.borderMarginBottom = 0, this.childElements = [], this.parent = e, this.dataObject = t, this.isSymbol = i, this.xBordersHaveBeenSet = !1, this.yBordersHaveBeenSet = !1, e && (this.Parent = e);
                    }
                    get RelativePositionHasBeenSet() {
                        return this.relativePositionHasBeenSet;
                    }
                    get XBordersHaveBeenSet() {
                        return this.xBordersHaveBeenSet;
                    }
                    set XBordersHaveBeenSet(t) {
                        this.xBordersHaveBeenSet = t;
                    }
                    get YBordersHaveBeenSet() {
                        return this.yBordersHaveBeenSet;
                    }
                    set YBordersHaveBeenSet(t) {
                        this.yBordersHaveBeenSet = t;
                    }
                    get AbsolutePosition() {
                        return this.absolutePosition;
                    }
                    set AbsolutePosition(t) {
                        this.absolutePosition = t;
                    }
                    get RelativePosition() {
                        return this.relativePosition;
                    }
                    set RelativePosition(t) {
                        this.relativePosition = t, this.relativePositionHasBeenSet = !0;
                    }
                    get Size() {
                        return this.size;
                    }
                    set Size(t) {
                        this.size = t;
                    }
                    get MarginSize() {
                        return this.marginSize;
                    }
                    get UpperLeftCorner() {
                        return this.upperLeftCorner;
                    }
                    get UpperLeftMarginCorner() {
                        return this.upperLeftMarginCorner;
                    }
                    get BorderLeft() {
                        return this.borderLeft;
                    }
                    set BorderLeft(t) {
                        this.borderLeft = t, this.calculateRectangle();
                    }
                    get BorderRight() {
                        return this.borderRight;
                    }
                    set BorderRight(t) {
                        this.borderRight = t, this.calculateRectangle();
                    }
                    get BorderTop() {
                        return this.borderTop;
                    }
                    set BorderTop(t) {
                        this.borderTop = t, this.calculateRectangle();
                    }
                    get BorderBottom() {
                        return this.borderBottom;
                    }
                    set BorderBottom(t) {
                        this.borderBottom = t, this.calculateRectangle();
                    }
                    get BorderMarginLeft() {
                        return this.borderMarginLeft > this.borderLeft ? this.borderLeft : this.borderMarginLeft;
                    }
                    set BorderMarginLeft(t) {
                        this.borderMarginLeft = t, this.calculateMarginRectangle();
                    }
                    get BorderMarginRight() {
                        return this.borderMarginRight < this.borderRight ? this.borderRight : this.borderMarginRight;
                    }
                    set BorderMarginRight(t) {
                        this.borderMarginRight = t, this.calculateMarginRectangle();
                    }
                    get BorderMarginTop() {
                        return this.borderMarginTop > this.borderTop ? this.borderTop : this.borderMarginTop;
                    }
                    set BorderMarginTop(t) {
                        this.borderMarginTop = t, this.calculateMarginRectangle();
                    }
                    get BorderMarginBottom() {
                        return this.borderMarginBottom < this.borderBottom ? this.borderBottom : this.borderMarginBottom;
                    }
                    set BorderMarginBottom(t) {
                        this.borderMarginBottom = t, this.calculateMarginRectangle();
                    }
                    get BoundingRectangle() {
                        return this.boundingRectangle;
                    }
                    get BoundingMarginRectangle() {
                        return this.boundingMarginRectangle;
                    }
                    get ChildElements() {
                        return this.childElements;
                    }
                    set ChildElements(t) {
                        this.childElements = t;
                    }
                    get Parent() {
                        return this.parent;
                    }
                    set Parent(t) {
                        if (this.parent) {
                            const t = this.parent.ChildElements.indexOf(this, 0);
                            t > -1 && this.parent.ChildElements.splice(t, 1);
                        }
                        this.parent = t, this.parent.ChildElements.indexOf(this) > -1 ? n.default.error("BoundingBox of " + this.dataObject.constructor.name + " already in children list of " + this.parent.dataObject.constructor.name + "'s BoundingBox") : this.parent.ChildElements.push(this);
                    }
                    get DataObject() {
                        return this.dataObject;
                    }
                    get Center() {
                        return new o.PointF2D(this.RelativePosition.x + (this.BorderMarginRight + this.BorderMarginLeft), this.RelativePosition.y + (this.BorderMarginBottom + this.BorderMarginTop));
                    }
                    setAbsolutePositionFromParent() {
                        this.parent ? (this.absolutePosition.x = this.parent.AbsolutePosition.x + this.relativePosition.x, this.absolutePosition.y = this.parent.AbsolutePosition.y + this.relativePosition.y) : this.absolutePosition = this.relativePosition;
                    }
                    calculateAbsolutePosition() {
                        this.absolutePosition.x = this.relativePosition.x, this.absolutePosition.y = this.relativePosition.y;
                        let t = this.parent;
                        for(; t;)this.absolutePosition.x += t.relativePosition.x, this.absolutePosition.y += t.relativePosition.y, t = t.parent;
                    }
                    calculateAbsolutePositionsRecursiveWithoutTopelement() {
                        this.absolutePosition.x = 0, this.absolutePosition.y = 0;
                        for(let t = 0, e = this.ChildElements.length; t < e; ++t)this.ChildElements[t].calculateAbsolutePositionsRecursive(this.absolutePosition.x, this.absolutePosition.y);
                    }
                    calculateAbsolutePositionsRecursive(t, e) {
                        this.absolutePosition.x = this.relativePosition.x + t, this.absolutePosition.y = this.relativePosition.y + e;
                        for(let t = 0, e = this.ChildElements.length; t < e; ++t)this.ChildElements[t].calculateAbsolutePositionsRecursive(this.absolutePosition.x, this.absolutePosition.y);
                    }
                    calculateAbsolutePositionsOfChildren() {
                        for(let t = 0, e = this.ChildElements.length; t < e; ++t)this.ChildElements[t].calculateAbsolutePositionsRecursive(this.absolutePosition.x, this.absolutePosition.y);
                    }
                    calculateBoundingBox(t = []) {
                        if (0 === this.childElements.length) return;
                        for(let e = 0, i = this.ChildElements.length; e < i; ++e){
                            const i = this.ChildElements[e];
                            let s = !0;
                            for (const e of t){
                                const t = i.DataObject;
                                if (t.isInstanceOfClass && t.isInstanceOfClass(e)) {
                                    s = !1;
                                    break;
                                }
                            }
                            s && i.calculateBoundingBox(t);
                        }
                        let e = Number.MAX_VALUE, i = Number.MIN_VALUE, s = Number.MAX_VALUE, n = Number.MIN_VALUE, r = Number.MAX_VALUE, o = Number.MIN_VALUE, a = Number.MAX_VALUE, l = Number.MIN_VALUE;
                        this.isSymbol && (e = this.borderLeft, i = this.borderRight, s = this.borderTop, n = this.borderBottom, r = this.borderMarginLeft, o = this.borderMarginRight, a = this.borderMarginTop, l = this.borderMarginBottom);
                        for(let t = 0, h = this.ChildElements.length; t < h; ++t){
                            const h = this.ChildElements[t];
                            e = Math.min(e, h.relativePosition.x + h.borderLeft), i = Math.max(i, h.relativePosition.x + h.borderRight), s = Math.min(s, h.relativePosition.y + h.borderTop), n = Math.max(n, h.relativePosition.y + h.borderBottom), r = Math.min(r, h.relativePosition.x + h.borderMarginLeft), o = Math.max(o, h.relativePosition.x + h.borderMarginRight), a = Math.min(a, h.relativePosition.y + h.borderMarginTop), l = Math.max(l, h.relativePosition.y + h.borderMarginBottom);
                        }
                        this.borderLeft = e, this.borderRight = i, this.borderTop = s, this.borderBottom = n, this.borderMarginLeft = r, this.borderMarginRight = o, this.borderMarginTop = a, this.borderMarginBottom = l, this.calculateRectangle(), this.calculateMarginRectangle(), this.xBordersHaveBeenSet = !0, this.yBordersHaveBeenSet = !0;
                    }
                    calculateTopBottomBorders(t = !0) {
                        if (0 === this.childElements.length) return;
                        if (t) for(let t = 0, e = this.ChildElements.length; t < e; ++t)this.ChildElements[t].calculateTopBottomBorders();
                        let e = Number.MAX_VALUE, i = Number.MIN_VALUE, s = Number.MAX_VALUE, n = Number.MIN_VALUE;
                        this.yBordersHaveBeenSet && (e = this.borderTop, i = this.borderBottom, s = this.borderMarginTop, n = this.borderMarginBottom);
                        for(let t = 0, r = this.ChildElements.length; t < r; ++t){
                            const r = this.ChildElements[t];
                            e = Math.min(e, r.relativePosition.y + r.borderTop), i = Math.max(i, r.relativePosition.y + r.borderBottom), s = Math.min(s, r.relativePosition.y + r.borderMarginTop), n = Math.max(n, r.relativePosition.y + r.borderMarginBottom);
                        }
                        this.borderTop = e, this.borderBottom = i, this.borderMarginTop = s, this.borderMarginBottom = n, this.calculateRectangle(), this.calculateMarginRectangle();
                    }
                    computeNonOverlappingPositionWithMargin(t, e, i) {
                        this.RelativePosition = new o.PointF2D(i.x, i.y), this.setAbsolutePositionFromParent();
                        let s = 0, n = !1;
                        do switch(e){
                            case c.Left:
                            case c.Right:
                                s = this.relativePosition.x, t.calculateMarginPositionAlongDirection(this, e), n = Math.abs(s - this.relativePosition.x) > .001;
                                break;
                            case c.Up:
                            case c.Down:
                                s = this.relativePosition.y, t.calculateMarginPositionAlongDirection(this, e), n = Math.abs(s - this.relativePosition.y) > .001;
                                break;
                            default:
                                throw new r.ArgumentOutOfRangeException("direction");
                        }
                        while (n);
                    }
                    collisionDetection(t) {
                        const e = Math.min(this.AbsolutePosition.x + this.borderRight, t.absolutePosition.x + t.borderRight) - Math.max(this.AbsolutePosition.x + this.borderLeft, t.absolutePosition.x + t.borderLeft), i = Math.min(this.AbsolutePosition.y + this.borderBottom, t.absolutePosition.y + t.borderBottom) - Math.max(this.AbsolutePosition.y + this.borderTop, t.absolutePosition.y + t.borderTop);
                        return e >= 0 && i >= 0;
                    }
                    liesInsideBorders(t) {
                        const e = this.AbsolutePosition.x + this.borderLeft <= t.absolutePosition.x + t.borderLeft && t.absolutePosition.x + t.borderLeft <= this.AbsolutePosition.x + this.borderRight, i = this.AbsolutePosition.x + this.borderLeft <= t.absolutePosition.x + t.borderRight && t.absolutePosition.x + t.borderRight <= this.AbsolutePosition.x + this.borderRight;
                        if (e && i) {
                            const e = this.AbsolutePosition.y + this.borderTop <= t.absolutePosition.y + t.borderTop && t.absolutePosition.y + t.borderTop <= this.AbsolutePosition.y + this.borderBottom, i = this.AbsolutePosition.y + this.borderTop <= t.absolutePosition.y + t.borderBottom && t.absolutePosition.y + t.borderBottom <= this.AbsolutePosition.y + this.borderBottom;
                            if (e && i) return !0;
                        }
                        return !1;
                    }
                    pointLiesInsideBorders(t) {
                        return this.AbsolutePosition.x + this.borderLeft <= t.x && t.x <= this.AbsolutePosition.x + this.borderRight && this.AbsolutePosition.y + this.borderTop <= t.y && t.y <= this.AbsolutePosition.y + this.borderBottom;
                    }
                    marginCollisionDetection(t) {
                        const e = Math.min(this.AbsolutePosition.x + this.borderMarginRight, t.absolutePosition.x + t.borderMarginRight) - Math.max(this.AbsolutePosition.x + this.borderMarginLeft, t.absolutePosition.x + t.borderMarginLeft), i = Math.min(this.AbsolutePosition.y + this.borderMarginBottom, t.absolutePosition.y + t.borderMarginBottom) - Math.max(this.AbsolutePosition.y + this.borderMarginTop, t.absolutePosition.y + t.borderMarginTop);
                        return e > 0 && i > 0;
                    }
                    liesInsideMargins(t) {
                        const e = this.AbsolutePosition.x + this.borderMarginLeft <= t.absolutePosition.x + t.borderMarginLeft && t.absolutePosition.x + t.borderMarginLeft <= this.AbsolutePosition.x + this.borderMarginRight, i = this.AbsolutePosition.x + this.borderMarginLeft <= t.absolutePosition.x + t.borderMarginRight && t.absolutePosition.x + t.borderMarginRight <= this.AbsolutePosition.x + this.borderMarginRight;
                        if (e && i) {
                            const e = this.AbsolutePosition.y + this.borderMarginTop <= t.absolutePosition.y + t.borderMarginTop && t.absolutePosition.y + t.borderMarginTop <= this.AbsolutePosition.y + this.borderMarginBottom, i = this.AbsolutePosition.y + this.borderMarginTop <= t.absolutePosition.y + t.borderMarginBottom && t.absolutePosition.y + t.borderMarginBottom <= this.AbsolutePosition.y + this.borderMarginBottom;
                            if (e && i) return !0;
                        }
                        return !1;
                    }
                    pointLiesInsideMargins(t) {
                        return this.AbsolutePosition.x + this.borderMarginLeft <= t.x && t.x <= this.AbsolutePosition.x + this.borderMarginRight && this.AbsolutePosition.y + this.borderMarginTop <= t.y && t.y <= this.AbsolutePosition.y + this.borderMarginBottom;
                    }
                    computeNonOverlappingPosition(t, e, i) {
                        this.RelativePosition = new o.PointF2D(i.x, i.y), this.setAbsolutePositionFromParent();
                        let s = 0, n = !1;
                        do switch(e){
                            case c.Left:
                            case c.Right:
                                s = this.relativePosition.x, t.calculatePositionAlongDirection(this, e), n = Math.abs(s - this.relativePosition.x) > 1e-4;
                                break;
                            case c.Up:
                            case c.Down:
                                s = this.relativePosition.y, t.calculatePositionAlongDirection(this, e), n = Math.abs(s - this.relativePosition.y) > 1e-4;
                                break;
                            default:
                                throw new r.ArgumentOutOfRangeException("direction");
                        }
                        while (n);
                    }
                    getClickedObjectOfType(t) {
                        const e = this.dataObject;
                        if (this.pointLiesInsideBorders(t) && e) return e;
                        for(let e = 0, i = this.childElements.length; e < i; ++e){
                            const i = this.childElements[e].getClickedObjectOfType(t);
                            if (i) return i;
                        }
                    }
                    getObjectsInRegion(t, e = !0, i = h.GraphicalObject) {
                        let s = [];
                        for (const n of this.childElements)s = s.concat(n.getObjectsInRegion(t, e, i));
                        return this.dataObject && this.dataObject.isInstanceOfClass(i) && (e ? t.liesInsideBorders(this) && s.push(this.dataObject) : t.collisionDetection(this) && s.push(this.dataObject)), s;
                    }
                    calculateRectangle() {
                        this.upperLeftCorner = new o.PointF2D(this.BorderLeft, this.BorderTop), this.size = new a.SizeF2D(this.BorderRight - this.BorderLeft, this.BorderBottom - this.BorderTop), this.boundingRectangle = l.RectangleF2D.createFromLocationAndSize(this.upperLeftCorner, this.size);
                    }
                    calculateMarginRectangle() {
                        this.upperLeftMarginCorner = new o.PointF2D(this.BorderMarginLeft, this.BorderMarginTop), this.marginSize = new a.SizeF2D(this.BorderMarginRight - this.BorderMarginLeft, this.BorderMarginBottom - this.BorderMarginTop), this.boundingMarginRectangle = l.RectangleF2D.createFromLocationAndSize(this.upperLeftMarginCorner, this.marginSize);
                    }
                    calculateMarginPositionAlongDirection(t, e) {
                        if (this !== t) {
                            if (this.isSymbol && this.marginCollisionDetection(t)) {
                                let i = 0;
                                switch(e){
                                    case c.Left:
                                        return i = this.absolutePosition.x + this.borderMarginLeft - (t.absolutePosition.x + t.borderMarginRight), t.relativePosition.x += i, void (t.absolutePosition.x += i);
                                    case c.Right:
                                        return i = this.absolutePosition.x + this.borderMarginRight - (t.absolutePosition.x + t.borderMarginLeft), t.relativePosition.x += i, void (t.absolutePosition.x += i);
                                    case c.Up:
                                        return i = this.absolutePosition.y + this.borderMarginTop - (t.absolutePosition.y + t.borderMarginBottom), t.relativePosition.y += i, void (t.absolutePosition.y += i);
                                    case c.Down:
                                        return i = this.absolutePosition.y + this.borderMarginBottom - (t.absolutePosition.y + t.borderMarginTop), t.relativePosition.y += i, void (t.absolutePosition.y += i);
                                    default:
                                        throw new r.ArgumentOutOfRangeException("direction");
                                }
                            }
                            for(let i = 0, s = this.ChildElements.length; i < s; ++i)this.ChildElements[i].calculateMarginPositionAlongDirection(t, e);
                        }
                    }
                    calculatePositionAlongDirection(t, e) {
                        if (this !== t) {
                            if (this.isSymbol && this.collisionDetection(t)) {
                                let i;
                                switch(e){
                                    case c.Left:
                                        return i = this.absolutePosition.x + this.borderLeft - (t.absolutePosition.x + t.borderRight), t.relativePosition.x += i, void (t.absolutePosition.x += i);
                                    case c.Right:
                                        return i = this.absolutePosition.x + this.borderRight - (t.absolutePosition.x + t.borderLeft), t.relativePosition.x += i, void (t.absolutePosition.x += i);
                                    case c.Up:
                                        return i = this.absolutePosition.y + this.borderTop - (t.absolutePosition.y + t.borderBottom), t.relativePosition.y += i, void (t.absolutePosition.y += i);
                                    case c.Down:
                                        return i = this.absolutePosition.y + this.borderBottom - (t.absolutePosition.y + t.borderTop), t.relativePosition.y += i, void (t.absolutePosition.y += i);
                                    default:
                                        throw new r.ArgumentOutOfRangeException("direction");
                                }
                            }
                            for(let i = 0, s = this.ChildElements.length; i < s; ++i)this.ChildElements[i].calculatePositionAlongDirection(t, e);
                        }
                    }
                }, function(t) {
                    t[t.Left = 0] = "Left", t[t.Right = 1] = "Right", t[t.Up = 2] = "Up", t[t.Down = 3] = "Down", t[t.NotYetDefined = 4] = "NotYetDefined";
                }(c || (e.ColDirEnum = c = {}));
            },
            995 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.Clickable = void 0;
                const s = i(7741);
                class n extends s.GraphicalObject {
                }
                e.Clickable = n;
            },
            2683 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.AutoColorSet = e.NoteState = e.GraphicalLayers = e.StyleSets = e.OUTLINE_AND_FILL_STYLE_DICT = e.OutlineAndFillStyleEnum = void 0;
                const s = i(3263);
                var n, r, o, a, l;
                !function(t) {
                    t[t.BaseWritingColor = 0] = "BaseWritingColor", t[t.FollowingCursor = 1] = "FollowingCursor", t[t.AlternativeFollowingCursor = 2] = "AlternativeFollowingCursor", t[t.PlaybackCursor = 3] = "PlaybackCursor", t[t.Highlighted = 4] = "Highlighted", t[t.ErrorUnderlay = 5] = "ErrorUnderlay", t[t.Selected = 6] = "Selected", t[t.SelectionSymbol = 7] = "SelectionSymbol", t[t.DebugColor1 = 8] = "DebugColor1", t[t.DebugColor2 = 9] = "DebugColor2", t[t.DebugColor3 = 10] = "DebugColor3", t[t.SplitScreenDivision = 11] = "SplitScreenDivision", t[t.GreyTransparentOverlay = 12] = "GreyTransparentOverlay", t[t.MarkedArea1 = 13] = "MarkedArea1", t[t.MarkedArea2 = 14] = "MarkedArea2", t[t.MarkedArea3 = 15] = "MarkedArea3", t[t.MarkedArea4 = 16] = "MarkedArea4", t[t.MarkedArea5 = 17] = "MarkedArea5", t[t.MarkedArea6 = 18] = "MarkedArea6", t[t.MarkedArea7 = 19] = "MarkedArea7", t[t.MarkedArea8 = 20] = "MarkedArea8", t[t.MarkedArea9 = 21] = "MarkedArea9", t[t.MarkedArea10 = 22] = "MarkedArea10", t[t.Comment1 = 23] = "Comment1", t[t.Comment2 = 24] = "Comment2", t[t.Comment3 = 25] = "Comment3", t[t.Comment4 = 26] = "Comment4", t[t.Comment5 = 27] = "Comment5", t[t.Comment6 = 28] = "Comment6", t[t.Comment7 = 29] = "Comment7", t[t.Comment8 = 30] = "Comment8", t[t.Comment9 = 31] = "Comment9", t[t.Comment10 = 32] = "Comment10";
                }(n || (e.OutlineAndFillStyleEnum = n = {})), e.OUTLINE_AND_FILL_STYLE_DICT = new s.Dictionary, e.OUTLINE_AND_FILL_STYLE_DICT.setValue(n.BaseWritingColor, "Thistle"), e.OUTLINE_AND_FILL_STYLE_DICT.setValue(n.FollowingCursor, "Aqua"), e.OUTLINE_AND_FILL_STYLE_DICT.setValue(n.AlternativeFollowingCursor, "Azure"), e.OUTLINE_AND_FILL_STYLE_DICT.setValue(n.PlaybackCursor, "Bisque"), e.OUTLINE_AND_FILL_STYLE_DICT.setValue(n.Highlighted, "CadetBlue"), e.OUTLINE_AND_FILL_STYLE_DICT.setValue(n.ErrorUnderlay, "DarkBlue"), e.OUTLINE_AND_FILL_STYLE_DICT.setValue(n.Selected, "DarkGoldenRod"), e.OUTLINE_AND_FILL_STYLE_DICT.setValue(n.SelectionSymbol, "BlanchedAlmond"), e.OUTLINE_AND_FILL_STYLE_DICT.setValue(n.DebugColor1, "Chartreuse"), e.OUTLINE_AND_FILL_STYLE_DICT.setValue(n.DebugColor2, "DarkGreen"), e.OUTLINE_AND_FILL_STYLE_DICT.setValue(n.DebugColor3, "DarkOrange"), e.OUTLINE_AND_FILL_STYLE_DICT.setValue(n.SplitScreenDivision, "FireBrick"), e.OUTLINE_AND_FILL_STYLE_DICT.setValue(n.GreyTransparentOverlay, "DarkSalmon"), e.OUTLINE_AND_FILL_STYLE_DICT.setValue(n.MarkedArea1, "DarkSeaGreen"), e.OUTLINE_AND_FILL_STYLE_DICT.setValue(n.MarkedArea2, "DarkOrchid"), e.OUTLINE_AND_FILL_STYLE_DICT.setValue(n.MarkedArea3, "Aquamarine"), e.OUTLINE_AND_FILL_STYLE_DICT.setValue(n.MarkedArea4, "DarkKhaki"), e.OUTLINE_AND_FILL_STYLE_DICT.setValue(n.MarkedArea5, "ForestGreen"), e.OUTLINE_AND_FILL_STYLE_DICT.setValue(n.MarkedArea6, "AliceBlue"), e.OUTLINE_AND_FILL_STYLE_DICT.setValue(n.MarkedArea7, "DeepPink"), e.OUTLINE_AND_FILL_STYLE_DICT.setValue(n.MarkedArea8, "Coral"), e.OUTLINE_AND_FILL_STYLE_DICT.setValue(n.MarkedArea9, "DarkOliveGreen"), e.OUTLINE_AND_FILL_STYLE_DICT.setValue(n.MarkedArea10, "Chocolate"), e.OUTLINE_AND_FILL_STYLE_DICT.setValue(n.Comment1, "DodgerBlue"), e.OUTLINE_AND_FILL_STYLE_DICT.setValue(n.Comment2, "Blue"), e.OUTLINE_AND_FILL_STYLE_DICT.setValue(n.Comment3, "Beige"), e.OUTLINE_AND_FILL_STYLE_DICT.setValue(n.Comment4, "Crimson"), e.OUTLINE_AND_FILL_STYLE_DICT.setValue(n.Comment5, "Fuchsia"), e.OUTLINE_AND_FILL_STYLE_DICT.setValue(n.Comment6, "Brown"), e.OUTLINE_AND_FILL_STYLE_DICT.setValue(n.Comment7, "BlanchedAlmond"), e.OUTLINE_AND_FILL_STYLE_DICT.setValue(n.Comment8, "CornflowerBlue"), e.OUTLINE_AND_FILL_STYLE_DICT.setValue(n.Comment9, "Cornsilk"), e.OUTLINE_AND_FILL_STYLE_DICT.setValue(n.Comment10, "DarkGrey"), function(t) {
                    t[t.MarkedArea = 0] = "MarkedArea", t[t.Comment = 1] = "Comment";
                }(r || (e.StyleSets = r = {})), function(t) {
                    t[t.Background = 0] = "Background", t[t.Highlight = 1] = "Highlight", t[t.MeasureError = 2] = "MeasureError", t[t.SelectionSymbol = 3] = "SelectionSymbol", t[t.Cursor = 4] = "Cursor", t[t.PSI_Debug = 5] = "PSI_Debug", t[t.Notes = 6] = "Notes", t[t.Comment = 7] = "Comment", t[t.Debug_above = 8] = "Debug_above";
                }(o || (e.GraphicalLayers = o = {})), function(t) {
                    t[t.Normal = 0] = "Normal", t[t.Selected = 1] = "Selected", t[t.Follow_Confirmed = 2] = "Follow_Confirmed", t[t.QFeedback_NotFound = 3] = "QFeedback_NotFound", t[t.QFeedback_OK = 4] = "QFeedback_OK", t[t.QFeedback_Perfect = 5] = "QFeedback_Perfect", t[t.Debug1 = 6] = "Debug1", t[t.Debug2 = 7] = "Debug2", t[t.Debug3 = 8] = "Debug3";
                }(a || (e.NoteState = a = {})), function(t) {
                    t.C = "#d82c6b", t.D = "#F89D15", t.E = "#FFE21A", t.F = "#4dbd5c", t.G = "#009D96", t.A = "#43469d", t.B = "#76429c", t.Rest = "#000000";
                }(l || (e.AutoColorSet = l = {}));
            },
            242 (t, e) {
                "use strict";
                var i, s, n;
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.PhonicScoreModes = e.MusicSymbolDrawingStyle = e.DrawingMode = void 0, function(t) {
                    t[t.All = 0] = "All", t[t.NoOverlays = 1] = "NoOverlays", t[t.Leadsheet = 2] = "Leadsheet";
                }(i || (e.DrawingMode = i = {})), function(t) {
                    t[t.Normal = 0] = "Normal", t[t.Disabled = 1] = "Disabled", t[t.Selected = 2] = "Selected", t[t.Clickable = 3] = "Clickable", t[t.PlaybackSymbols = 4] = "PlaybackSymbols", t[t.FollowSymbols = 5] = "FollowSymbols", t[t.QFeedbackNotFound = 6] = "QFeedbackNotFound", t[t.QFeedbackOk = 7] = "QFeedbackOk", t[t.QFeedbackPerfect = 8] = "QFeedbackPerfect", t[t.Debug1 = 9] = "Debug1", t[t.Debug2 = 10] = "Debug2", t[t.Debug3 = 11] = "Debug3";
                }(s || (e.MusicSymbolDrawingStyle = s = {})), function(t) {
                    t[t.Following = 0] = "Following", t[t.Midi = 1] = "Midi", t[t.Manual = 2] = "Manual";
                }(n || (e.PhonicScoreModes = n = {}));
            },
            3661 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.DrawingParameters = void 0;
                const s = i(9713), n = i(6362), r = i(4146);
                e.DrawingParameters = class {
                    constructor(t = r.DrawingParametersEnum.default, e){
                        this.drawCursors = !0, this.drawTitle = !0, this.drawSubtitle = !0, this.drawLyricist = !0, this.drawComposer = !0, this.drawCopyright = !1, this.drawCredits = !0, this.drawPartNames = !0, this.fingeringPosition = n.PlacementEnum.Left, this.drawHiddenNotes = !1, this.rules = e, this.rules || (this.rules = new s.EngravingRules), this.DrawingParametersEnum = t;
                    }
                    set DrawingParametersEnum(t) {
                        switch(this.drawingParametersEnum = t, t){
                            case r.DrawingParametersEnum.allon:
                                this.setForAllOn();
                                break;
                            case r.DrawingParametersEnum.thumbnail:
                                this.setForThumbnail();
                                break;
                            case r.DrawingParametersEnum.leadsheet:
                                this.setForLeadsheet();
                                break;
                            case r.DrawingParametersEnum.compact:
                                this.setForCompactMode();
                                break;
                            case r.DrawingParametersEnum.compacttight:
                                this.setForCompactTightMode();
                                break;
                            case r.DrawingParametersEnum.default:
                            default:
                                this.setForDefault();
                        }
                    }
                    get DrawingParametersEnum() {
                        return this.drawingParametersEnum;
                    }
                    setForAllOn() {
                        this.drawHighlights = !0, this.drawErrors = !0, this.drawSelectionStartSymbol = !0, this.drawSelectionEndSymbol = !0, this.drawCursors = !0, this.drawActivitySymbols = !0, this.drawScrollIndicator = !0, this.drawComments = !0, this.drawMarkedAreas = !0, this.DrawTitle = !0, this.DrawSubtitle = !0, this.DrawComposer = !0, this.DrawLyricist = !0, this.drawCredits = !0, this.rules.RenderFirstPageCreditWords = !0, this.DrawPartNames = !0, this.drawHiddenNotes = !0, this.rules.CompactMode = !1;
                    }
                    setForDefault() {
                        this.rules.loadDefaultValues(), this.setForAllOn(), this.drawHiddenNotes = !1;
                    }
                    setForThumbnail() {
                        this.drawHighlights = !1, this.drawErrors = !1, this.drawSelectionStartSymbol = !1, this.drawSelectionStartSymbol = !1, this.drawCursors = !1, this.drawActivitySymbols = !1, this.drawScrollIndicator = !1, this.drawComments = !0, this.drawMarkedAreas = !0, this.drawHiddenNotes = !1;
                    }
                    setForCompactMode() {
                        this.rules.CompactMode = !0, this.DrawCredits = !1, this.drawHiddenNotes = !1;
                    }
                    setForCompactTightMode() {
                        this.setForCompactMode(), this.DrawPartNames = !1, this.rules.VoiceSpacingMultiplierVexflow = .65, this.rules.VoiceSpacingAddendVexflow = 2, this.rules.MinSkyBottomDistBetweenStaves = 1, this.rules.MinSkyBottomDistBetweenSystems = 1, this.rules.BetweenStaffDistance = 2.5, this.rules.StaffDistance = 3.5, this.rules.MinimumDistanceBetweenSystems = 1, this.rules.PageBottomMargin = 0, this.rules.PageLeftMargin = 2, this.rules.PageRightMargin = 2;
                    }
                    setForLeadsheet() {
                        this.drawHighlights = !1, this.drawErrors = !1, this.drawSelectionStartSymbol = !0, this.drawSelectionEndSymbol = !0, this.drawCursors = !0, this.drawActivitySymbols = !1, this.drawScrollIndicator = !0, this.drawComments = !0, this.drawMarkedAreas = !0;
                    }
                    get DrawCredits() {
                        return this.drawCredits;
                    }
                    set DrawCredits(t) {
                        this.drawCredits = t, this.rules.RenderFirstPageCreditWords = t, this.DrawComposer = t, this.DrawTitle = t, this.DrawSubtitle = t, this.DrawLyricist = t, this.DrawCopyright = t;
                    }
                    get DrawTitle() {
                        return this.drawTitle;
                    }
                    set DrawTitle(t) {
                        this.drawTitle = t, this.rules.RenderTitle = t, t || (this.DrawSubtitle = !1);
                    }
                    get DrawSubtitle() {
                        return this.drawSubtitle;
                    }
                    set DrawSubtitle(t) {
                        this.drawSubtitle = t, this.rules.RenderSubtitle = t, t && (this.DrawTitle = !0);
                    }
                    get DrawComposer() {
                        return this.drawComposer;
                    }
                    set DrawComposer(t) {
                        this.drawComposer = t, this.rules.RenderComposer = t;
                    }
                    get DrawLyricist() {
                        return this.drawLyricist;
                    }
                    set DrawLyricist(t) {
                        this.drawLyricist = t, this.rules.RenderLyricist = t;
                    }
                    get DrawCopyright() {
                        return this.drawCopyright;
                    }
                    set DrawCopyright(t) {
                        this.drawCopyright = t, this.rules.RenderCopyright = t;
                    }
                    get DrawPartNames() {
                        return this.drawPartNames;
                    }
                    set DrawPartNames(t) {
                        this.drawPartNames = t, this.rules.RenderPartNames = t, this.rules.RenderPartNames || (this.rules.RenderPartAbbreviations = !1);
                    }
                    get FingeringPosition() {
                        return this.fingeringPosition;
                    }
                    set FingeringPosition(t) {
                        this.fingeringPosition = t, this.rules.FingeringPosition = t;
                    }
                    get Rules() {
                        return this.rules;
                    }
                    set Rules(t) {
                        this.rules = t;
                    }
                };
            },
            9713 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.PageFormat = e.EngravingRules = void 0;
                const n = i(1888), r = s(i(3065)), o = i(7533), a = i(6362), l = i(624), h = i(4434), c = i(3263), u = i(2257), d = i(8233), f = i(9719), m = i(3729), p = i(3430);
                class g {
                    constructor(){
                        this.NoteDistances = [
                            1,
                            1,
                            1.3,
                            1.6,
                            2,
                            2.5,
                            3,
                            4
                        ], this.NoteDistancesScalingFactors = [
                            1,
                            2,
                            4,
                            8,
                            16,
                            32,
                            64,
                            128
                        ], this.DurationDistanceDict = {}, this.DurationScalingDistanceDict = {}, this.NoteToGraphicalNoteMapObjectCount = 0, this.RenderCount = 0, this.loadDefaultValues();
                    }
                    loadDefaultValues() {
                        this.SamplingUnit = 3 * g.unit, this.SheetTitleHeight = 4, this.SheetSubtitleHeight = 2, this.SheetMinimumDistanceBetweenTitleAndSubtitle = 1, this.SheetComposerHeight = 2, this.SheetAuthorHeight = 2, this.SheetCopyrightHeight = 1.5, this.SheetCopyrightMargin = 2, this.SheetComposerSubtitleUseLegacyParsing = !1, this.CompactMode = !1, this.PagePlacementEnum = n.PagePlacementEnum.Down, this.PageHeight = 100001, this.PageTopMargin = 5, this.PageTopMarginNarrow = 0, this.PageBottomMargin = 5, this.PageLeftMargin = 5, this.PageRightMargin = 5, this.TitleTopDistance = 5, this.TitleBottomDistance = 1, this.StaffDistance = 7, this.BetweenStaffDistance = 5, this.MinimumStaffLineDistance = 4, this.MinSkyBottomDistBetweenStaves = 1, this.SnapStafflinesToCrispPixels = !0, this.StaffHeight = 4, this.TabStaffInterlineHeight = 1.1111, this.TabStaffInterlineHeightForBboxes = 1.3, this.BetweenStaffLinesDistance = g.unit, this.SystemLeftMargin = 0, this.SystemRightMargin = 0, this.SystemLabelsRightMargin = 2, this.SystemComposerDistance = 2, this.SystemLyricistDistance = 2, this.InstrumentLabelTextHeight = 2, this.MinimumDistanceBetweenSystems = 7, this.MinSkyBottomDistBetweenSystems = 5, this.LastSystemMaxScalingFactor = 1.4, this.AutoBeamNotes = !1, this.AutoBeamOptions = {
                            beam_middle_rests_only: !1,
                            beam_rests: !1,
                            maintain_stem_directions: !1
                        }, this.AutoBeamTabs = !1, this.BeamWidth = g.unit / 2, this.BeamSpaceWidth = g.unit / 3, this.BeamForwardLength = 1.25 * g.unit, this.FlatBeams = !1, this.FlatBeamOffset = 20, this.FlatBeamOffsetPerBeam = 10, this.OptimizeExtremeLedgerBeams = !1, this.ClefLeftMargin = .5, this.ClefRightMargin = .75, this.PercussionOneLineCutoff = 3, this.PercussionKeepXMLStafflineCount = !0, this.PercussionForceVoicesOneLineCutoff = 1, this.PercussionUseXMLDisplayStep = !0, this.PercussionXMLDisplayStepNoteValueShift = 0, this.PercussionOneLineXMLDisplayStepOctaveOffset = 0, this.PercussionUseCajon2NoteSystem = !1, this.BetweenKeySymbolsDistance = .2, this.KeyRightMargin = .75, this.RhythmRightMargin = 1.25, this.ShowRhythmAgainAfterPartEndOrFinalBarline = !0, this.NewPartAndSystemAfterFinalBarline = !1, this.InStaffClefScalingFactor = .8, this.DistanceBetweenNaturalAndSymbolWhenCancelling = .4, this.NoteHelperLinesOffset = .25, this.MeasureLeftMargin = .7, this.MeasureRightMargin = 0, this.DistanceBetweenLastInstructionAndRepetitionBarline = 1, this.ArpeggioDistance = .6, this.StaccatoShorteningFactor = 2, this.IdealStemLength = 3, this.StemNoteHeadBorderYOffset = .2, this.StemMargin = .2, this.StemMinLength = 2.5, this.StemMaxLength = 4.5, this.BeamSlopeMaxAngle = 10, this.StemMinAllowedDistanceBetweenNoteHeadAndBeamLine = 1, this.SetWantedStemDirectionByXml = !0, this.AutoStemSecondaryVoicesWhenAloneInMeasure = !1, this.GraceNoteScalingFactor = .6, this.GraceNoteXOffset = .2, this.GraceNoteGroupXMargin = 0, this.WedgeOpeningLength = 1.2, this.WedgeMeasureEndOpeningLength = .75, this.WedgeMeasureBeginOpeningLength = .75, this.WedgePlacementAboveY = -1.5, this.WedgePlacementBelowY = 1.5, this.WedgeHorizontalMargin = .6, this.WedgeVerticalMargin = .5, this.DistanceOffsetBetweenTwoHorizontallyCrossedWedges = .3, this.WedgeMinLength = 2, this.WedgeEndDistanceBetweenTimestampsFactor = 1.75, this.ArticulationAboveNoteForStemUp = !1, this.SoftAccentWedgePadding = .4, this.SoftAccentSizeFactor = .6, this.DistanceBetweenAdjacentDynamics = .75, this.TempoChangeMeasureValidity = 4, this.TempoContinousFactor = .7, this.StaccatoScalingFactor = .8, this.BetweenDotsDistance = .8, this.OrnamentAccidentalScalingFactor = .65, this.ChordSymbolTextHeight = 2, this.ChordSymbolTextAlignmentTop = o.TextAlignmentEnum.LeftBottom, this.ChordSymbolTextAlignmentBottom = o.TextAlignmentEnum.LeftTop, this.ChordSymbolBottomMargin = .6, this.ChordSymbolRelativeXOffset = -1, this.ChordSymbolExtraXShiftForShortChordSymbols = .3, this.ChordSymbolExtraXShiftWidthThreshold = 2, this.ChordSymbolXSpacing = 1, this.ChordOverlapAllowedIntoNextMeasure = 0, this.ChordSymbolYOffset = .1, this.ChordSymbolYPadding = 0, this.ChordSymbolYAlignment = !0, this.ChordSymbolYAlignmentScope = "staffline", this.ChordSymbolWholeMeasureRestXOffset = 0, this.ChordSymbolWholeMeasureRestXOffsetMeasure1 = -2, this.ChordAccidentalTexts = new c.Dictionary, this.resetChordAccidentalTexts(this.ChordAccidentalTexts, !1), this.ChordSymbolLabelTexts = new c.Dictionary, this.resetChordSymbolLabelTexts(this.ChordSymbolLabelTexts), this.CustomChords = [], this.resetChordNames(), this.RepetitionSymbolsYOffset = 0, this.RepetitionEndInstructionXShiftAsPercentOfStaveWidth = .4, this.RehearsalMarkXOffsetDefault = 10, this.RehearsalMarkXOffset = 0, this.RehearsalMarkXOffsetSystemStartMeasure = -20, this.RehearsalMarkYOffsetDefault = -15, this.RehearsalMarkYOffsetAddedForRehearsalMarks = -12, this.RehearsalMarkYOffset = 0, this.RehearsalMarkFontSize = 10, this.RehearsalMarkAboveChordSymbol = !0, this.MeasureNumberLabelHeight = 1.5 * g.unit, this.MeasureNumberLabelOffset = 2, this.MeasureNumberLabelXOffset = -0.5, this.TupletsRatioed = !1, this.TupletsRatioedUseXMLValue = !0, this.TupletsBracketed = !1, this.TripletsBracketed = !1, this.TupletsBracketedUseXMLValue = !0, this.TupletNumberLabelHeight = 1.5 * g.unit, this.TupletNumberYOffset = .5, this.TupletNumberLimitConsecutiveRepetitions = !0, this.TupletNumberMaxConsecutiveRepetitions = 2, this.TupletNumberAlwaysDisableAfterFirstMax = !0, this.TupletNumberUseShowNoneXMLValue = !0, this.LabelMarginBorderFactor = .1, this.TupletVerticalLineLength = .5, this.TupletNumbersInTabs = !0, this.TabTupletYOffsetBottom = 1, this.TabTupletYOffsetTop = -3.5, this.TabTupletYOffsetEffects = 1.5, this.TabTupletsBracketed = !0, this.TabBeamsRendered = !0, this.TabKeySignatureRendered = !1, this.TabKeySignatureSpacingAdded = !0, this.TabTimeSignatureRendered = !1, this.TabTimeSignatureSpacingAdded = !0, this.TabFingeringsRendered = !1, this.TabUseXNoteheadShapeForTabNote = !0, this.TabUseXNoteheadAlternativeGlyph = !0, this.TabXNoteheadScale = .9, this.SlurPlacementFromXML = !0, this.SlurPlacementAtStems = !1, this.SlurPlacementUseSkyBottomLine = !1, this.BezierCurveStepSize = 1e3, this.calculateCurveParametersArrays(), this.TieGhostObjectWidth = .75, this.TieYPositionOffsetFactor = .3, this.MinimumNeededXspaceForTieGhostObject = 1, this.TieHeightMinimum = .28, this.TieHeightMaximum = 1.2, this.TieHeightInterpolationK = .0288, this.TieHeightInterpolationD = .136, this.SlurNoteHeadYOffset = .5, this.SlurEndArticulationYOffset = .8, this.SlurStartArticulationYOffsetOfArticulation = .5, this.SlurStemXOffset = .3, this.SlurSlopeMaxAngle = 15, this.SlurTangentMinAngle = 30, this.SlurTangentMaxAngle = 80, this.SlurHeightFactor = 1, this.SlurHeightFlattenLongSlursFactorByWidth = .24, this.SlurHeightFlattenLongSlursFactorByAngle = .36, this.SlurHeightFlattenLongSlursCutoffAngle = 47, this.SlurHeightFlattenLongSlursCutoffWidth = 16, this.SlurFlattenToObstacle = !0, this.SlurFlattenToObstacleMargin = 2, this.SlurFlattenMinArcWidthFactor = .38, this.SlurFlattenMaxMinArcHeight = 4, this.SlursStartingAtSameStaffEntryYOffset = .8, this.SlurMaximumYControlPointDistance = void 0, this.SlurCrossStaffBowFactor = .12, this.SlurCrossStaffMinBow = .8, this.SlurCrossStaffMaxBow = 2.5, this.GlissandoNoteOffset = .5, this.GlissandoStafflineStartMinimumWidth = 1, this.GlissandoStafflineStartYDistanceToNote = .8, this.GlissandoStafflineEndOffset = 1, this.GlissandoDefaultWidth = .1, this.RepetitionAllowFirstMeasureBeginningRepeatBarline = !0, this.RepetitionEndingLabelHeight = 2, this.RepetitionEndingLabelXOffset = .5, this.RepetitionEndingLabelYOffset = .3, this.RepetitionEndingLineYLowerOffset = .5, this.RepetitionEndingLineYUpperOffset = .3, this.CursorIgnoreRepetitions = !1, this.VoltaOffset = 2.5, this.LabelXOffsetForStafflineLeftOverflowCheck = -1.2, this.TempoExpressionTextAlignment = o.TextAlignmentEnum.CenterBottom, this.UnknownExpressionTextAlignment = o.TextAlignmentEnum.CenterBottom, this.LyricsAlignmentStandard = o.TextAlignmentEnum.LeftBottom, this.LyricsHeight = 2, this.RelinkLyricWordsAcrossVoices = !0, this.LyricsVerseNumberLeftOfLyric = !0, this.LyricsYOffsetToStaffHeight = 0, this.LyricsYMarginToBottomLine = .2, this.LyricsExtraXShiftForShortLyrics = .5, this.LyricsExtraXShiftForShortLyricsWidthThreshold = 1.4, this.LyricsUseXPaddingForLongLyrics = !0, this.LyricsXPaddingFactorForLongLyrics = 1, this.LyricsXPaddingWidthThreshold = 1.7, this.LyricsXPaddingReductionForLongNotes = .7, this.LyricsXPaddingReductionForLastNoteInMeasure = 1.2, this.LyricsXPaddingForLastNoteInMeasure = !0, this.LyricsXPaddingReductionForLastNoteInMeasureCrossMeasureMidWord = 1, this.VerticalBetweenLyricsDistance = .5, this.HorizontalBetweenLyricsDistance = .2, this.BetweenSyllableMaximumDistance = 10, this.BetweenSyllableMinimumDistance = .5, this.LyricOverlapAllowedIntoNextMeasure = 3.4, this.MinimumDistanceBetweenDashes = 10, this.MaximumLyricsElongationFactor = 2.5, this.TempoYSpacing = .5, this.InstantaneousTempoTextHeight = 2.3, this.ContinuousDynamicTextHeight = 2.3, this.UseEndOffsetForExpressions = !0, this.MoodTextHeight = 2.3, this.UnknownTextHeight = 2, this.ContinuousTempoTextHeight = 2.3, this.DynamicExpressionMaxDistance = 2, this.DynamicExpressionSpacer = .5, this.IgnoreRepeatedDynamics = !1, this.ExpressionsUseXMLColor = !0, this.VexFlowDefaultNotationFontScale = 39, this.VexFlowDefaultTabFontScale = 39, this.TremoloStrokeScale = 1, this.TremoloYSpacingScale = 1, this.TremoloBuzzRollThickness = .25, this.TremoloBetweenNotesStrokeThickness = .4, this.TremoloBetweenNotesStrokeGap = .4, this.TremoloBetweenNotesXPadding = .55, this.TremoloBetweenNotesMaxLengthFactor = .667, this.TremoloBetweenNotesMaxSlant = 1, this.TremoloBetweenNotesYPadding = .45, this.StemWidth = .15, this.StaffLineWidth = .1, this.StaffLineColor = void 0, this.LedgerLineWidth = 1, this.LedgerLineStrokeStyle = void 0, this.LedgerLineColorDefault = "#000000", this.WedgeLineWidth = .12, this.TupletLineWidth = .12, this.LyricUnderscoreLineWidth = .12, this.SystemThinLineWidth = .12, this.SystemBoldLineWidth = g.unit / 2, this.SystemRepetitionEndingLineWidth = .12, this.SystemDotWidth = g.unit / 2, this.DistanceBetweenVerticalSystemLines = .35, this.DistanceBetweenDotAndLine = .7, this.RepeatEndStartPadding = 2, this.OctaveShiftLineWidth = .12, this.OctaveShiftVerticalLineLength = g.unit, this.OctaveShiftOnWholeMeasureNoteUntilEndOfMeasure = !1, this.GraceLineWidth = this.StaffLineWidth * this.GraceNoteScalingFactor, this.MultipleRestMeasureDefaultWidth = 4, this.MultipleRestMeasureAddKeySignature = !0, this.FixedMeasureWidth = !1, this.FixedMeasureWidthFixedValue = void 0, this.FixedMeasureWidthUseForPickupMeasures = !1, this.MinimumCrossedBeamDifferenceMargin = 1e-4, this.SheetMaximumWidth = 32767, this.VoiceSpacingMultiplierVexflow = .85, this.VoiceSpacingAddendVexflow = 3, this.PickupMeasureWidthMultiplier = 1, this.PickupMeasureRepetitionSpacing = .8, this.PickupMeasureSpacingSingleNoteAddend = 1.6, this.DisplacedNoteMargin = .1, this.MinNoteDistance = 2, this.SubMeasureXSpacingThreshold = 35, this.MeasureDynamicsMaxScalingFactor = 2.5, this.WholeRestXShiftVexflow = -1.5, this.MetronomeMarksDrawn = !0, this.MetronomeMarkXShift = -6, this.MetronomeMarkYShift = -1, this.SoftmaxFactorVexFlow = 15, this.StaggerSameWholeNotes = !0, this.AlignRests = l.AlignRestOption.Never, this.RestCollisionYPadding = 0, this.FillEmptyMeasuresWithWholeRest = l.FillEmptyMeasuresWithWholeRests.No, this.ArpeggiosGoAcrossVoices = !1, this.RenderArpeggios = !0, this.RenderSlurs = !0, this.RenderSlursAcrossStaves = !0, this.RenderGlissandi = !0, this.ColoringMode = h.ColoringModes.XML, this.ColoringEnabled = !0, this.ColorStemsLikeNoteheads = !1, this.ColorBeams = !0, this.ColorFlags = !0, this.applyDefaultColorMusic("#000000"), this.DefaultColorCursor = "#33e02f", this.DefaultFontFamily = "Times New Roman", this.VexFlowTextFontFamily = void 0, this.DefaultFontStyle = u.FontStyles.Regular, this.DefaultVexFlowNoteFont = "gonville", this.MaxMeasureToDrawIndex = Number.MAX_VALUE, this.MaxMeasureToDrawNumber = Number.MAX_VALUE, this.MinMeasureToDrawIndex = 0, this.MinMeasureToDrawNumber = 0, this.MaxSystemToDrawNumber = Number.MAX_VALUE, this.MaxPageToDrawNumber = Number.MAX_VALUE, this.RenderComposer = !0, this.ReadFirstPageCreditWords = !1, this.RenderFirstPageCreditWords = !0, this.RenderTitle = !0, this.RenderSubtitle = !0, this.RenderLyricist = !0, this.RenderCopyright = !1, this.RenderPartNames = !0, this.RenderPartGroupNames = !0, this.RenderPartAbbreviations = !0, this.RenderPartAbbreviationsForSingleStaff = !1, this.LazyConsistentGraphic = !1, this.RenderSystemLabelsAfterFirstPage = !0, this.RenderFingerings = !0, this.RenderMeasureNumbers = !0, this.RenderMeasureNumbersOnlyAtSystemStart = !1, this.RenderMeasureNumbersForImplicitMeasures = !1, this.UseXMLMeasureNumbers = !0, this.RenderLyrics = !0, this.RenderChordSymbols = !0, this.RenderMultipleRestMeasures = !0, this.AutoGenerateMultipleRestMeasuresFromRestMeasures = !0, this.RenderMeasureRepeats = !0, this.RenderRehearsalMarks = !0, this.RenderClefsAtBeginningOfStaffline = !0, this.RenderKeySignatures = !0, this.RenderTimeSignatures = !0, this.RenderTimeSignaturesForSamplesWithoutTimeSignature = !1, this.RenderFirstTempoExpression = !0, this.RenderPedals = !0, this.RenderWavyLines = !0, this.ArticulationPlacementFromXML = !0, this.BreathMarkDistance = .8, this.FingeringPosition = a.PlacementEnum.AboveOrBelow, this.FingeringPositionFromXML = !0, this.FingeringPositionGrace = a.PlacementEnum.Left, this.FingeringInsideStafflines = !1, this.FingeringLabelFontHeight = 1.7, this.FingeringOffsetX = 0, this.FingeringOffsetY = 0, this.FingeringPaddingY = -0.2, this.FingeringTextSize = 1.5, this.RenderStringNumbersClassical = !0, this.StringNumberOffsetY = 0, this.NewSystemAtXMLNewSystemAttribute = !1, this.NewPageAtXMLNewPageAttribute = !1, this.NewSystemAtXMLNewPageAttribute = !1, this.RenderXMeasuresPerLineAkaSystem = 0, this.RestoreCursorAfterRerender = !0, this.StretchLastSystemLine = !1, this.IgnoreBracketsWords = !0, this.RenderCautionaryAccidentalsInParentheses = !1, this.PlaceWordsInsideStafflineFromXml = !1, this.PlaceWordsInsideStafflineYOffset = .9, this.PageFormat = b.UndefinedPageFormat, this.PageBackgroundColor = void 0, this.DarkModeEnabled = !1, this.UsePageBackgroundColorForTabNotes = !0, this.RenderSingleHorizontalStaffline = !1, this.SpacingBetweenTextLines = 0, this.NoteToGraphicalNoteMap = new c.Dictionary, this.NoteToGraphicalNoteMapObjectCount = 0, this.UseGeometricSkyBottomLineCalculation = !0, this.GeometricSkyBottomLineCaches = new m.GeometricSkyBottomLineCaches, this.SkyBottomLineBatchMinMeasures = 5, this.SkyBottomLineWebGLMinMeasures = 80, this.AlwaysSetPreferredSkyBottomLineBackendAutomatically = !0, this.DisableWebGLInFirefox = !0, this.DisableWebGLInSafariAndIOS = !0, this.setPreferredSkyBottomLineBackendAutomatically(), this.UseInterpolatedTempoForAccelerandoEtc = !1;
                        try {
                            this.MaxInstructionsConstValue = this.ClefLeftMargin + this.ClefRightMargin + this.KeyRightMargin + this.RhythmRightMargin + 11;
                        } catch (t) {
                            r.default.info("EngravingRules()", t);
                        }
                    }
                    setPreferredSkyBottomLineBackendAutomatically(t = -1) {
                        let e = "", i = "";
                        "object" == typeof globalThis && (e = globalThis.navigator?.vendor ?? "", i = globalThis.navigator?.userAgent ?? "");
                        let s = !1;
                        (this.DisableWebGLInSafariAndIOS && /apple/i.test(e) || this.DisableWebGLInFirefox && i.includes("Firefox")) && (s = !0), this.PreferredSkyBottomLineBatchCalculatorBackend = l.SkyBottomLineBatchCalculatorBackendType.Plain, s || t >= this.SkyBottomLineWebGLMinMeasures && (this.PreferredSkyBottomLineBatchCalculatorBackend = l.SkyBottomLineBatchCalculatorBackendType.WebGL);
                    }
                    applyDefaultColorMusic(t) {
                        this.DefaultColorMusic = t, this.DefaultColorNotehead = t, this.DefaultColorRest = t, this.DefaultColorStem = t, this.DefaultColorLabel = t, this.DefaultColorLyrics = t, this.DefaultColorTitle = t, this.LedgerLineColorDefault = t;
                    }
                    addGraphicalNoteToNoteMap(t, e) {
                        t.NoteToGraphicalNoteObjectId = this.NoteToGraphicalNoteMapObjectCount, this.NoteToGraphicalNoteMap.setValue(t.NoteToGraphicalNoteObjectId, e), this.NoteToGraphicalNoteMapObjectCount++;
                    }
                    GNote(t) {
                        return p.GraphicalNote.FromNote(t, this);
                    }
                    clearMusicSheetObjects() {
                        this.NoteToGraphicalNoteMap = new c.Dictionary, this.NoteToGraphicalNoteMapObjectCount = 0;
                    }
                    resetChordAccidentalTexts(t, e) {
                        t.setValue(d.AccidentalEnum.SHARP, e ? "\u266F" : "#"), t.setValue(d.AccidentalEnum.FLAT, e ? "\u266D" : "b"), t.setValue(d.AccidentalEnum.DOUBLEFLAT, e ? "\uD834\uDD2B" : "bb"), t.setValue(d.AccidentalEnum.DOUBLESHARP, e ? "\uD834\uDD2A" : "x");
                    }
                    setChordSymbolLabelText(t, e) {
                        this.ChordSymbolLabelTexts.setValue(t, e);
                    }
                    resetChordSymbolLabelTexts(t) {
                        return t.setValue(f.ChordSymbolEnum.minor, "m"), t.setValue(f.ChordSymbolEnum.augmented, "aug"), t.setValue(f.ChordSymbolEnum.diminished, "dim"), t.setValue(f.ChordSymbolEnum.dominant, "7"), t.setValue(f.ChordSymbolEnum.majorseventh, "maj7"), t.setValue(f.ChordSymbolEnum.minorseventh, "m7"), t.setValue(f.ChordSymbolEnum.diminishedseventh, "dim7"), t.setValue(f.ChordSymbolEnum.augmentedseventh, "aug7"), t.setValue(f.ChordSymbolEnum.halfdiminished, `m7${this.ChordAccidentalTexts.getValue(d.AccidentalEnum.FLAT)}5`), t.setValue(f.ChordSymbolEnum.majorminor, "m(maj7)"), t.setValue(f.ChordSymbolEnum.majorsixth, "maj6"), t.setValue(f.ChordSymbolEnum.minorsixth, "m6"), t.setValue(f.ChordSymbolEnum.dominantninth, "9"), t.setValue(f.ChordSymbolEnum.majorninth, "maj9"), t.setValue(f.ChordSymbolEnum.minorninth, "m9"), t.setValue(f.ChordSymbolEnum.dominant11th, "11"), t.setValue(f.ChordSymbolEnum.major11th, "maj11"), t.setValue(f.ChordSymbolEnum.minor11th, "m11"), t.setValue(f.ChordSymbolEnum.dominant13th, "13"), t.setValue(f.ChordSymbolEnum.major13th, "maj13"), t.setValue(f.ChordSymbolEnum.minor13th, "m13"), t.setValue(f.ChordSymbolEnum.suspendedsecond, "sus2"), t.setValue(f.ChordSymbolEnum.suspendedfourth, "sus4"), t.setValue(f.ChordSymbolEnum.power, "5"), t.setValue(f.ChordSymbolEnum.none, "N.C."), t;
                    }
                    addChordName(t, e, i, s, n) {
                        if (void 0 !== f.ChordSymbolEnum[e]) {
                            const r = {
                                adds: i,
                                alts: s,
                                subs: n
                            };
                            this.CustomChords.push(f.CustomChord.createCustomChord(t, f.ChordSymbolEnum[e], r));
                        }
                    }
                    renameChord(t, e) {
                        f.CustomChord.renameCustomChord(t, e, this.CustomChords);
                    }
                    resetChordNames() {
                        const t = this.ChordAccidentalTexts.getValue(d.AccidentalEnum.SHARP), e = this.ChordAccidentalTexts.getValue(d.AccidentalEnum.FLAT);
                        this.addChordName("alt", "major", [
                            `${t}5`,
                            `${e}9`,
                            `${t}9`
                        ], [
                            `${e}5`
                        ], []), this.addChordName("7alt", "dominant", [
                            `${t}5`,
                            `${e}9`,
                            `${t}9`
                        ], [
                            `${e}5`
                        ], []), this.addChordName("7sus4", "dominant", [
                            "4"
                        ], [], [
                            "3"
                        ]), this.addChordName("7sus4", "suspendedfourth", [
                            "7"
                        ], [], []), this.addChordName("9sus4", "dominantninth", [
                            "4"
                        ], [], [
                            "3"
                        ]), this.addChordName("9sus4", "suspendedfourth", [
                            "9"
                        ], [], []), this.addChordName("11sus4", "dominant11th", [
                            "4"
                        ], [], [
                            "3"
                        ]), this.addChordName("11sus4", "suspendedfourth", [
                            "11"
                        ], [], []), this.addChordName("13sus4", "dominant13th", [
                            "4"
                        ], [], [
                            "3"
                        ]), this.addChordName("13sus4", "suspendedfourth", [
                            "13"
                        ], [], []), this.addChordName("7sus2", "dominant", [
                            "2"
                        ], [], [
                            "3"
                        ]), this.addChordName("7sus2", "suspendedsecond", [
                            "7"
                        ], [], []), this.addChordName(`m7${e}5`, "minorseventh", [], [
                            `${e}5`
                        ], []), this.addChordName("9sus2", "dominantninth", [
                            "2"
                        ], [], [
                            "3"
                        ]), this.addChordName("9sus2", "suspendedsecond", [
                            "9"
                        ], [], []), this.addChordName("11sus2", "dominant11th", [
                            "2"
                        ], [], [
                            "3"
                        ]), this.addChordName("11sus2", "suspendedsecond", [
                            "11"
                        ], [], []), this.addChordName("13sus2", "dominant13th", [
                            "2"
                        ], [], [
                            "3"
                        ]), this.addChordName("13sus2", "suspendedsecond", [
                            "13"
                        ], [], []), this.addChordName("m(maj9)", "majorminor", [
                            "9"
                        ], [], []), this.addChordName("m(maj11)", "majorminor", [
                            "11"
                        ], [], []), this.addChordName("m(maj13)", "majorminor", [
                            "13"
                        ], [], []), this.addChordName("69", "majorsixth", [
                            "9"
                        ], [], []), this.addChordName("mi69", "minorsixth", [
                            "9"
                        ], [], []);
                    }
                    calculateCurveParametersArrays() {
                        this.TPower3 = new Array(this.BezierCurveStepSize), this.OneMinusTPower3 = new Array(this.BezierCurveStepSize), this.FactorOne = new Array(this.BezierCurveStepSize), this.FactorTwo = new Array(this.BezierCurveStepSize);
                        for(let t = 0; t < this.BezierCurveStepSize; t++){
                            const e = t / this.BezierCurveStepSize;
                            this.TPower3[t] = Math.pow(e, 3), this.OneMinusTPower3[t] = Math.pow(1 - e, 3), this.FactorOne[t] = 3 * Math.pow(1 - e, 2) * e, this.FactorTwo[t] = 3 * (1 - e) * Math.pow(e, 2);
                        }
                    }
                }
                e.EngravingRules = g, g.unit = 1;
                class b {
                    constructor(t, e, i = "noIdStringGiven"){
                        this.width = t, this.height = e, this.idString = i;
                    }
                    get aspectRatio() {
                        return this.IsUndefined ? 0 : this.width / this.height;
                    }
                    get IsUndefined() {
                        return void 0 === this.width || void 0 === this.height || 0 === this.height || 0 === this.width;
                    }
                    static get UndefinedPageFormat() {
                        return new b(0, 0);
                    }
                    Equals(t) {
                        return !!t && t.width === this.width && t.height === this.height;
                    }
                }
                e.PageFormat = b;
            },
            3729 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.GeometricSkyBottomLineCaches = e.GeometricSkyBottomLineContext = void 0;
                const n = s(i(3065));
                class r {
                    constructor(t = 0, e = 300, i){
                        this.PT_TO_PX = 4 / 3, this.FALLBACK_FONT_ASCENT = .9, this.FALLBACK_FONT_DESCENT = .25, this.FALLBACK_CHAR_WIDTH = .6, this.MAX_FLATTENING_SEGMENTS = 64, this.FLATTENING_SEGMENT_LENGTH = 3, this.minY = new Float64Array(0), this.maxY = new Float64Array(0), this.fullWidthMinY = Number.POSITIVE_INFINITY, this.fullWidthMaxY = Number.NEGATIVE_INFINITY, this.coveredBandTop = Number.POSITIVE_INFINITY, this.coveredBandBottom = Number.NEGATIVE_INFINITY, this.coveredBandUpdated = !1, this.width = 0, this.translateX = 0, this.translateY = 0, this.scaleX = 1, this.scaleY = 1, this.currentLineWidth = 1, this.currentFillStyle = "#000000", this.fillTransparent = !1, this.currentStrokeStyle = "#000000", this.strokeTransparent = !1, this.currentFont = "10pt Arial", this.stateStack = [], this.pathSegments = [], this.hasCurrentPoint = !1, this.currentX = 0, this.currentY = 0, this.subpathStartX = 0, this.subpathStartY = 0, this.vexFlowCanvasContext = this, this.canvas = {
                            width: 0,
                            height: 0
                        }, this.caches = i ?? new a, this.initialize(t, e);
                    }
                    initialize(t, e = 300) {
                        this.width = Math.max(0, Math.floor(t)), this.minY.length < this.width && (this.minY = new Float64Array(this.width), this.maxY = new Float64Array(this.width)), this.minY.fill(Number.POSITIVE_INFINITY, 0, this.width), this.maxY.fill(Number.NEGATIVE_INFINITY, 0, this.width), this.fullWidthMinY = Number.POSITIVE_INFINITY, this.fullWidthMaxY = Number.NEGATIVE_INFINITY, this.resetCoveredBand(), this.canvas.width = this.width, this.canvas.height = e, this.translateX = 0, this.translateY = 0, this.scaleX = 1, this.scaleY = 1, this.currentLineWidth = 1, this.setFillStyle("#000000"), this.setStrokeStyle("#000000"), this.currentFont = "10pt Arial", this.stateStack.length = 0, this.beginPath();
                    }
                    copyExtentsInto(t, e) {
                        const i = this.fullWidthMinY, s = this.fullWidthMaxY;
                        for(let n = 0; n < this.width; n++){
                            const r = this.minY[n] < i ? this.minY[n] : i;
                            r !== Number.POSITIVE_INFINITY && (t[n] = r, e[n] = this.maxY[n] > s ? this.maxY[n] : s);
                        }
                    }
                    copyExtentsIntoBuffers(t, e, i) {
                        const s = this.fullWidthMinY, n = this.fullWidthMaxY;
                        for(let r = 0; r < this.width; r++){
                            const o = this.minY[r] < s ? this.minY[r] : s;
                            o !== Number.POSITIVE_INFINITY && (t[i + r] = o, e[i + r] = this.maxY[r] > n ? this.maxY[r] : n);
                        }
                    }
                    getDrawnLength() {
                        if (this.fullWidthMinY !== Number.POSITIVE_INFINITY) return this.width;
                        for(let t = this.width - 1; t >= 0; t--)if (this.minY[t] !== Number.POSITIVE_INFINITY) return t + 1;
                        return 0;
                    }
                    beginPath() {
                        this.pathSegments.length = 0, this.hasCurrentPoint = !1;
                    }
                    moveTo(t, e) {
                        const i = this.deviceX(t), s = this.deviceY(e);
                        isFinite(i) && isFinite(s) && (this.currentX = i, this.currentY = s, this.subpathStartX = i, this.subpathStartY = s, this.hasCurrentPoint = !0);
                    }
                    lineTo(t, e) {
                        const i = this.deviceX(t), s = this.deviceY(e);
                        isFinite(i) && isFinite(s) && (this.hasCurrentPoint ? (this.pathSegments.push(this.currentX, this.currentY, i, s), this.currentX = i, this.currentY = s) : this.moveTo(t, e));
                    }
                    quadraticCurveTo(t, e, i, s) {
                        const n = this.deviceX(t), r = this.deviceY(e), o = this.deviceX(i), a = this.deviceY(s);
                        if (!(isFinite(n) && isFinite(r) && isFinite(o) && isFinite(a))) return;
                        this.hasCurrentPoint || this.moveTo(t, e);
                        const l = this.currentX, h = this.currentY, c = this.flatteningSegments(Math.abs(n - l) + Math.abs(o - n) + Math.abs(r - h) + Math.abs(a - r));
                        let u = l, d = h;
                        for(let t = 1; t <= c; t++){
                            const e = t / c, i = 1 - e, s = i * i * l + 2 * i * e * n + e * e * o, f = i * i * h + 2 * i * e * r + e * e * a;
                            this.pathSegments.push(u, d, s, f), u = s, d = f;
                        }
                        this.currentX = o, this.currentY = a;
                    }
                    bezierCurveTo(t, e, i, s, n, r) {
                        const o = this.deviceX(t), a = this.deviceY(e), l = this.deviceX(i), h = this.deviceY(s), c = this.deviceX(n), u = this.deviceY(r);
                        if (!(isFinite(o) && isFinite(a) && isFinite(l) && isFinite(h) && isFinite(c) && isFinite(u))) return;
                        this.hasCurrentPoint || this.moveTo(t, e);
                        const d = this.currentX, f = this.currentY, m = this.flatteningSegments(Math.abs(o - d) + Math.abs(l - o) + Math.abs(c - l) + Math.abs(a - f) + Math.abs(h - a) + Math.abs(u - h));
                        let p = d, g = f;
                        for(let t = 1; t <= m; t++){
                            const e = t / m, i = 1 - e, s = i * i * i, n = 3 * i * i * e, r = 3 * i * e * e, b = e * e * e, S = s * d + n * o + r * l + b * c, y = s * f + n * a + r * h + b * u;
                            this.pathSegments.push(p, g, S, y), p = S, g = y;
                        }
                        this.currentX = c, this.currentY = u;
                    }
                    arc(t, e, i, s, n, r = !1) {
                        const o = this.deviceX(t), a = this.deviceY(e), l = i * (Math.abs(this.scaleX) + Math.abs(this.scaleY)) / 2;
                        if (!isFinite(o) || !isFinite(a) || !isFinite(l) || l < 0 || !isFinite(s) || !isFinite(n)) return;
                        let h = n - s;
                        r ? (h <= -2 * Math.PI || h > 0) && (h %= 2 * Math.PI, h > 0 && (h -= 2 * Math.PI), 0 === h && n !== s && (h = -2 * Math.PI)) : (h >= 2 * Math.PI || h < 0) && (h %= 2 * Math.PI, h < 0 && (h += 2 * Math.PI), 0 === h && n !== s && (h = 2 * Math.PI));
                        const c = Math.min(this.MAX_FLATTENING_SEGMENTS, Math.max(4, Math.ceil(l * Math.abs(h) / 2))), u = o + l * Math.cos(s), d = a + l * Math.sin(s);
                        this.hasCurrentPoint ? this.pathSegments.push(this.currentX, this.currentY, u, d) : (this.subpathStartX = u, this.subpathStartY = d, this.hasCurrentPoint = !0);
                        let f = u, m = d;
                        for(let t = 1; t <= c; t++){
                            const e = s + h * (t / c), i = o + l * Math.cos(e), n = a + l * Math.sin(e);
                            this.pathSegments.push(f, m, i, n), f = i, m = n;
                        }
                        this.currentX = f, this.currentY = m;
                    }
                    rect(t, e, i, s) {
                        this.moveTo(t, e), this.lineTo(t + i, e), this.lineTo(t + i, e + s), this.lineTo(t, e + s), this.closePath(), this.moveTo(t, e);
                    }
                    closePath() {
                        !this.hasCurrentPoint || this.currentX === this.subpathStartX && this.currentY === this.subpathStartY || (this.pathSegments.push(this.currentX, this.currentY, this.subpathStartX, this.subpathStartY), this.currentX = this.subpathStartX, this.currentY = this.subpathStartY);
                    }
                    fill() {
                        if (this.fillTransparent) return;
                        this.coveredBandUpdated || this.updateCoveredBand();
                        const t = this.coveredBandTop, e = this.coveredBandBottom, i = this.pathSegments;
                        for(let s = 0; s < i.length; s += 4){
                            const n = i[s + 1], r = i[s + 3];
                            n >= t && r >= t && n <= e && r <= e || this.mergeSegment(i[s], n, i[s + 2], r);
                        }
                    }
                    stroke() {
                        if (this.strokeTransparent || !(this.currentLineWidth > 0)) return;
                        const t = this.currentLineWidth * (Math.abs(this.scaleX) + Math.abs(this.scaleY)) / 4, e = this.coveredBandTop, i = this.coveredBandBottom, s = this.pathSegments;
                        for(let n = 0; n < s.length; n += 4){
                            const r = s[n + 1], o = s[n + 3];
                            r - t >= e && o - t >= e && r + t <= i && o + t <= i || this.mergeStrokedSegment(s[n], r, s[n + 2], o, t);
                        }
                    }
                    fillRect(t, e, i, s) {
                        if (this.fillTransparent) return;
                        this.coveredBandUpdated || this.updateCoveredBand();
                        let n = this.deviceX(t), r = this.deviceY(e), o = this.deviceX(t + i), a = this.deviceY(e + s);
                        if (isFinite(n) && isFinite(r) && isFinite(o) && isFinite(a)) {
                            if (o < n) {
                                const t = n;
                                n = o, o = t;
                            }
                            if (a < r) {
                                const t = r;
                                r = a, a = t;
                            }
                            this.mergeColumns(n, o, r, a);
                        }
                    }
                    clearRect(t, e, i, s) {}
                    fillText(t, e, i) {
                        if (this.fillTransparent || !t) return;
                        this.coveredBandUpdated || this.updateCoveredBand();
                        let s = this.deviceX(e);
                        const n = this.deviceY(i);
                        if (!isFinite(s) || !isFinite(n)) return;
                        const r = Math.abs(this.scaleX), o = Math.abs(this.scaleY);
                        for (const e of t){
                            const t = this.measureCharacter(e), i = s + t.inkLeft * r, a = s + t.inkRight * r;
                            a > i && this.mergeColumns(i, a, n - t.ascent * o, n + t.descent * o), s += t.advance * r;
                        }
                    }
                    measureText(t) {
                        return this.measureTextInternal(t) || (this.caches.measureTextWarningLogged || (this.caches.measureTextWarningLogged = !0, n.default.info("GeometricSkyBottomLineContext: no 2D context available for measureText, using estimates.")), {
                            width: this.fontSizeInPixels() * this.FALLBACK_CHAR_WIDTH * t.length
                        });
                    }
                    drawCachedGlyphOutline(t, e, i, s) {
                        if (1 !== this.scaleX || 1 !== this.scaleY) return !1;
                        if (this.fillTransparent) return !0;
                        const n = this.deviceX(i), r = this.deviceY(s);
                        if (!isFinite(n) || !isFinite(r) || !isFinite(e)) return !0;
                        this.coveredBandUpdated || this.updateCoveredBand();
                        const o = this.coveredBandTop, a = this.coveredBandBottom, l = this.getGlyphSegments(t, e);
                        if (!(l.minY + r >= o && l.maxY + r <= a)) {
                            const t = l.segments;
                            for(let e = 0; e < t.length; e += 4){
                                const i = t[e + 1] + r, s = t[e + 3] + r;
                                i >= o && s >= o && i <= a && s <= a || this.mergeSegment(t[e] + n, i, t[e + 2] + n, s);
                            }
                        }
                        return this.beginPath(), !0;
                    }
                    save() {
                        this.stateStack.push({
                            translateX: this.translateX,
                            translateY: this.translateY,
                            scaleX: this.scaleX,
                            scaleY: this.scaleY,
                            lineWidth: this.currentLineWidth,
                            fillStyle: this.currentFillStyle,
                            fillTransparent: this.fillTransparent,
                            strokeStyle: this.currentStrokeStyle,
                            strokeTransparent: this.strokeTransparent,
                            font: this.currentFont
                        });
                    }
                    restore() {
                        const t = this.stateStack.pop();
                        t && (this.translateX = t.translateX, this.translateY = t.translateY, this.scaleX = t.scaleX, this.scaleY = t.scaleY, this.currentLineWidth = t.lineWidth, this.currentFillStyle = t.fillStyle, this.fillTransparent = t.fillTransparent, this.currentStrokeStyle = t.strokeStyle, this.strokeTransparent = t.strokeTransparent, this.currentFont = t.font);
                    }
                    scale(t, e) {
                        this.scaleX *= t, this.scaleY *= e;
                    }
                    translate(t, e) {
                        this.translateX += t * this.scaleX, this.translateY += e * this.scaleY;
                    }
                    setFillStyle(t) {
                        return this.currentFillStyle = t, this.fillTransparent = o(t), this;
                    }
                    get fillStyle() {
                        return this.currentFillStyle;
                    }
                    set fillStyle(t) {
                        this.setFillStyle(t);
                    }
                    setStrokeStyle(t) {
                        return this.currentStrokeStyle = t, this.strokeTransparent = o(t), this;
                    }
                    get strokeStyle() {
                        return this.currentStrokeStyle;
                    }
                    set strokeStyle(t) {
                        this.setStrokeStyle(t);
                    }
                    setLineWidth(t) {
                        return this.currentLineWidth = t, this;
                    }
                    get lineWidth() {
                        return this.currentLineWidth;
                    }
                    set lineWidth(t) {
                        this.currentLineWidth = t;
                    }
                    setFont(t, e, i) {
                        return this.currentFont = (i || "") + " " + e + "pt " + t, this;
                    }
                    setRawFont(t) {
                        return this.currentFont = t, this;
                    }
                    get font() {
                        return this.currentFont;
                    }
                    set font(t) {
                        this.currentFont = t;
                    }
                    clear() {
                        this.minY.fill(Number.POSITIVE_INFINITY, 0, this.width), this.maxY.fill(Number.NEGATIVE_INFINITY, 0, this.width), this.fullWidthMinY = Number.POSITIVE_INFINITY, this.fullWidthMaxY = Number.NEGATIVE_INFINITY, this.resetCoveredBand();
                    }
                    openGroup(t, e, i) {}
                    closeGroup() {}
                    getGroup() {}
                    add() {}
                    setBackgroundFillStyle(t) {
                        return this;
                    }
                    setShadowColor(t) {
                        return this;
                    }
                    setShadowBlur(t) {
                        return this;
                    }
                    setLineCap(t) {
                        return this;
                    }
                    setLineDash(t) {
                        return this;
                    }
                    set lineCap(t) {}
                    set lineDash(t) {}
                    glow() {
                        return this;
                    }
                    deviceX(t) {
                        return t * this.scaleX + this.translateX;
                    }
                    deviceY(t) {
                        return t * this.scaleY + this.translateY;
                    }
                    resetCoveredBand() {
                        this.coveredBandTop = Number.POSITIVE_INFINITY, this.coveredBandBottom = Number.NEGATIVE_INFINITY, this.coveredBandUpdated = !1;
                    }
                    updateCoveredBand() {
                        if (this.coveredBandUpdated = !0, 0 === this.width) return;
                        let t = Number.NEGATIVE_INFINITY, e = Number.POSITIVE_INFINITY;
                        for(let i = 0; i < this.width; i++){
                            const s = this.minY[i] < this.fullWidthMinY ? this.minY[i] : this.fullWidthMinY;
                            if (s === Number.POSITIVE_INFINITY) return;
                            s > t && (t = s);
                            const n = this.maxY[i] > this.fullWidthMaxY ? this.maxY[i] : this.fullWidthMaxY;
                            n < e && (e = n);
                        }
                        const i = 1e-9 * (1 + Math.abs(t) + Math.abs(e));
                        this.coveredBandTop = t + i, this.coveredBandBottom = e - i;
                    }
                    flatteningSegments(t) {
                        return Math.min(this.MAX_FLATTENING_SEGMENTS, Math.max(2, Math.ceil(t / this.FLATTENING_SEGMENT_LENGTH)));
                    }
                    mergeSegment(t, e, i, s) {
                        if (i < t) {
                            let n = t;
                            t = i, i = n, n = e, e = s, s = n;
                        }
                        if (i - t < 1e-7) {
                            if (t === Math.trunc(t)) return;
                            const i = Math.floor(t);
                            if (i < 0 || i >= this.width) return;
                            const n = Math.min(e, s), r = Math.max(e, s);
                            return n < this.minY[i] && (this.minY[i] = n), void (r > this.maxY[i] && (this.maxY[i] = r));
                        }
                        const n = Math.max(0, Math.floor(t)), r = Math.min(this.width - 1, Math.floor(i - 1e-9));
                        if (r < n) return;
                        const o = (s - e) / (i - t);
                        for(let s = n; s <= r; s++){
                            let n = e + (Math.max(t, s) - t) * o, r = e + (Math.min(i, s + 1) - t) * o;
                            if (n > r) {
                                const t = n;
                                n = r, r = t;
                            }
                            n < this.minY[s] && (this.minY[s] = n), r > this.maxY[s] && (this.maxY[s] = r);
                        }
                    }
                    mergeStrokedSegment(t, e, i, s, n) {
                        const r = i - t, o = s - e, a = Math.sqrt(r * r + o * o);
                        if (a < 1e-7) return void this.mergeColumns(t - n, t + n, e - n, e + n);
                        const l = -o / a * n, h = r / a * n;
                        0 !== o ? (this.mergeSegment(t + l, e + h, i + l, s + h), this.mergeSegment(i + l, s + h, i - l, s - h), this.mergeSegment(i - l, s - h, t - l, e - h), this.mergeSegment(t - l, e - h, t + l, e + h)) : this.mergeHorizontalStroke(t, i, e + h, e - h);
                    }
                    mergeHorizontalStroke(t, e, i, s) {
                        const n = Math.min(t, e), r = Math.max(t, e), o = Math.min(i, s), a = Math.max(i, s);
                        if (Math.floor(n) <= 0 && Math.ceil(r) - 1 >= this.width - 1) return o < this.fullWidthMinY && (this.fullWidthMinY = o), void (a > this.fullWidthMaxY && (this.fullWidthMaxY = a));
                        this.mergeColumns(n, r, o, a);
                    }
                    mergeColumns(t, e, i, s) {
                        if (!(e > t)) return;
                        if (i >= this.coveredBandTop && s <= this.coveredBandBottom) return;
                        const n = Math.max(0, Math.floor(t)), r = Math.min(this.width - 1, Math.ceil(e) - 1);
                        for(let t = n; t <= r; t++)i < this.minY[t] && (this.minY[t] = i), s > this.maxY[t] && (this.maxY[t] = s);
                    }
                    fontSizeInPixels() {
                        const t = this.currentFont?.match(/([0-9.]+)\s*(pt|px)/);
                        if (!t) return 10 * this.PT_TO_PX;
                        const e = parseFloat(t[1]);
                        return "pt" === t[2] ? e * this.PT_TO_PX : e;
                    }
                    getGlyphSegments(t, e) {
                        let i = this.caches.glyphSegments.get(t);
                        i || (i = new Map, this.caches.glyphSegments.set(t, i));
                        let s = i.get(e);
                        if (!s) {
                            const n = this.computeGlyphSegments(t, e);
                            let r = Number.POSITIVE_INFINITY, o = Number.NEGATIVE_INFINITY;
                            for(let t = 1; t < n.length; t += 2)r = Math.min(r, n[t]), o = Math.max(o, n[t]);
                            s = {
                                segments: n,
                                minY: r,
                                maxY: o
                            }, i.set(e, s);
                        }
                        return s;
                    }
                    computeGlyphSegments(t, e) {
                        this.caches.glyphSegmentsScratch || (this.caches.glyphSegmentsScratch = new r(0, 300, this.caches));
                        const i = this.caches.glyphSegmentsScratch;
                        i.initialize(0);
                        let s = 0;
                        for(; s < t.length;)switch(t[s++]){
                            case "m":
                                i.moveTo(Number(t[s++]) * e, Number(t[s++]) * -e);
                                break;
                            case "l":
                                i.lineTo(Number(t[s++]) * e, Number(t[s++]) * -e);
                                break;
                            case "q":
                                {
                                    const n = Number(t[s++]) * e, r = Number(t[s++]) * -e;
                                    i.quadraticCurveTo(Number(t[s++]) * e, Number(t[s++]) * -e, n, r);
                                    break;
                                }
                            case "b":
                                {
                                    const n = Number(t[s++]) * e, r = Number(t[s++]) * -e;
                                    i.bezierCurveTo(Number(t[s++]) * e, Number(t[s++]) * -e, Number(t[s++]) * e, Number(t[s++]) * -e, n, r);
                                    break;
                                }
                        }
                        return Float64Array.from(i.pathSegments);
                    }
                    measureCharacter(t) {
                        const e = this.currentFont + "\0" + t;
                        let i = this.caches.characterExtents.get(e);
                        if (i) return i;
                        const s = this.fontSizeInPixels(), n = this.measureTextInternal(t);
                        if (n) {
                            const e = n.width;
                            i = this.probeCharacterInk(t, e, s), i || void 0 === n.actualBoundingBoxAscent || (i = {
                                advance: e,
                                ascent: n.actualBoundingBoxAscent,
                                descent: n.actualBoundingBoxDescent,
                                inkLeft: Math.max(0, -n.actualBoundingBoxLeft),
                                inkRight: Math.min(e, n.actualBoundingBoxRight)
                            }), i || (i = {
                                advance: e,
                                ascent: s * this.FALLBACK_FONT_ASCENT,
                                descent: s * this.FALLBACK_FONT_DESCENT,
                                inkLeft: 0,
                                inkRight: 0 === t.trim().length ? 0 : e
                            });
                        } else {
                            const e = s * this.FALLBACK_CHAR_WIDTH;
                            i = {
                                advance: e,
                                ascent: s * this.FALLBACK_FONT_ASCENT,
                                descent: s * this.FALLBACK_FONT_DESCENT,
                                inkLeft: 0,
                                inkRight: 0 === t.trim().length ? 0 : e
                            };
                        }
                        return this.caches.characterExtents.set(e, i), i;
                    }
                    probeCharacterInk(t, e, i) {
                        const s = this.caches;
                        if (!s.characterProbeContext && !s.characterProbeCreationFailed) {
                            try {
                                s.characterProbeCanvas = document.createElement("canvas"), s.characterProbeContext = s.characterProbeCanvas.getContext("2d", {
                                    willReadFrequently: !0
                                });
                            } catch (t) {}
                            s.characterProbeContext || (s.characterProbeCreationFailed = !0);
                        }
                        const n = s.characterProbeContext;
                        if (!n) return;
                        const r = Math.ceil(i), o = Math.ceil(e) + 2 * r, a = Math.ceil(3 * i) + 2, l = r, h = Math.ceil(2 * i);
                        try {
                            const i = s.characterProbeCanvas;
                            i.width < o && (i.width = o), i.height < a && (i.height = a), n.clearRect(0, 0, i.width, i.height), n.font = this.currentFont, n.fillStyle = "#000000", n.fillText(t, l, h);
                            const r = n.getImageData(0, 0, o, a).data;
                            let c = Number.MAX_SAFE_INTEGER, u = -1, d = Number.MAX_SAFE_INTEGER, f = -1;
                            for(let t = 0; t < a; t++){
                                const e = t * o * 4;
                                for(let i = 0; i < o; i++)r[e + 4 * i + 3] > 0 && (i < c && (c = i), i > u && (u = i), t < d && (d = t), t > f && (f = t));
                            }
                            return u < 0 ? {
                                advance: e,
                                ascent: 0,
                                descent: 0,
                                inkLeft: 0,
                                inkRight: 0
                            } : {
                                advance: e,
                                ascent: h - d,
                                descent: f + 1 - h,
                                inkLeft: c - l,
                                inkRight: u + 1 - l
                            };
                        } catch (t) {
                            return void (s.characterProbeCreationFailed = !0);
                        }
                    }
                    measureTextInternal(t) {
                        const e = this.caches;
                        if (!e.textMeasureContext && !e.textMeasureContextCreationFailed) {
                            try {
                                const t = document.createElement("canvas");
                                e.textMeasureContext = t.getContext("2d");
                            } catch (t) {}
                            e.textMeasureContext || (e.textMeasureContextCreationFailed = !0);
                        }
                        const i = e.textMeasureContext;
                        if (i) return i.font !== this.currentFont && (i.font = this.currentFont), i.measureText(t);
                    }
                }
                function o(t) {
                    if (!t || "string" != typeof t) return !1;
                    if ("none" === t || "transparent" === t) return !0;
                    if ("#" === t[0]) return 9 === t.length ? "0" === t[7] && "0" === t[8] : 5 === t.length && "0" === t[4];
                    const e = t.match(/^rgba\s*\([^,]+,[^,]+,[^,]+,\s*([0-9.]+)\s*\)/i);
                    return !!e && 0 === parseFloat(e[1]);
                }
                e.GeometricSkyBottomLineContext = r;
                class a {
                    constructor(){
                        this.textMeasureContextCreationFailed = !1, this.measureTextWarningLogged = !1, this.characterExtents = new Map, this.glyphSegments = new WeakMap, this.characterProbeCreationFailed = !1, this.skyLineBuffer = new Float64Array(0), this.bottomLineBuffer = new Float64Array(0);
                    }
                }
                e.GeometricSkyBottomLineCaches = a;
            },
            6659 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.GraphicalChordSymbolContainer = void 0;
                const s = i(7435), n = i(8254), r = i(9719), o = i(6438), a = i(7741), l = i(9409), h = i(4980);
                class c extends a.GraphicalObject {
                    constructor(t, e, i, s, n, r){
                        super(), this.chordSymbolContainer = t, this.boundingBox = new o.BoundingBox(this, e), this.rules = r, this.calculateLabel(i, n, s);
                    }
                    get GetChordSymbolContainer() {
                        return this.chordSymbolContainer;
                    }
                    get GraphicalLabel() {
                        return this.graphicalLabel;
                    }
                    resetPosition() {
                        const t = this.PositionAndShape, e = this.graphicalLabel.PositionAndShape.RelativePosition;
                        if (!this.initialParent) return this.initialParent = t.Parent, this.initialRelativePosition = new l.PointF2D(t.RelativePosition.x, t.RelativePosition.y), void (this.initialLabelRelativePosition = new l.PointF2D(e.x, e.y));
                        t.Parent !== this.initialParent && (t.Parent = this.initialParent), t.RelativePosition.x = this.initialRelativePosition.x, t.RelativePosition.y = this.initialRelativePosition.y, e.x = this.initialLabelRelativePosition.x, e.y = this.initialLabelRelativePosition.y, t.calculateBoundingBox();
                    }
                    calculateLabel(t, e, i) {
                        const o = r.ChordSymbolContainer.calculateChordText(this.chordSymbolContainer, e, i), a = this.GetChordSymbolContainer.Placement === h.PlacementEnum.Above ? this.rules.ChordSymbolTextAlignmentTop : this.rules.ChordSymbolTextAlignmentBottom;
                        this.graphicalLabel = new n.GraphicalLabel(new s.Label(o), t, a, this.rules, this.boundingBox), this.graphicalLabel.PositionAndShape.RelativePosition = new l.PointF2D(this.rules.ChordSymbolRelativeXOffset, 0), this.graphicalLabel.Label.colorDefault = this.rules.DefaultColorChordSymbol;
                    }
                }
                e.GraphicalChordSymbolContainer = c;
            },
            953 (t, e) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.GraphicalComment = void 0, e.GraphicalComment = class {
                    constructor(t, e){
                        this.label = t, this.settings = e;
                    }
                };
            },
            1066 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.GraphicalContinuousDynamicExpression = void 0;
                const n = i(6452), r = i(5875), o = i(9409), a = i(9490), l = i(6362), h = s(i(3065));
                class c extends a.AbstractGraphicalExpression {
                    constructor(t, e, i){
                        super(e, t, i), this.lines = [], this.isSplittedPart = !1, this.notToBeRemoved = !1;
                    }
                    get StartMeasure() {
                        return this.startMeasure;
                    }
                    set StartMeasure(t) {
                        this.startMeasure = t;
                    }
                    get EndMeasure() {
                        return this.endMeasure;
                    }
                    set EndMeasure(t) {
                        this.endMeasure = t;
                    }
                    get EndStaffLine() {
                        return this.endMeasure ? this.endMeasure.ParentStaffLine : void 0;
                    }
                    get IsSplittedPart() {
                        return this.isSplittedPart;
                    }
                    set IsSplittedPart(t) {
                        this.isSplittedPart = t;
                    }
                    get IsVerbal() {
                        return this.ContinuousDynamic.Label && this.ContinuousDynamic.Label.length > 0;
                    }
                    get NotToBeRemoved() {
                        return this.notToBeRemoved;
                    }
                    set NotToBeRemoved(t) {
                        this.notToBeRemoved = t;
                    }
                    get Lines() {
                        return this.lines;
                    }
                    get ContinuousDynamic() {
                        return this.SourceExpression;
                    }
                    updateSkyBottomLine() {
                        const t = this.parentStaffLine.SkyBottomLineCalculator, e = this.PositionAndShape, i = this.IsVerbal ? e.RelativePosition.x + e.BorderMarginLeft : 0, s = this.IsVerbal ? e.RelativePosition.x + e.BorderMarginRight : 0;
                        switch(!this.IsSoftAccent && !this.IsVerbal && this.lines.length < 2 && h.default.warn("Not enough lines for SkyBottomLine calculation"), this.IsVerbal || this.ContinuousDynamic.DynamicType !== r.ContDynamicEnum.crescendo && this.ContinuousDynamic.DynamicType !== r.ContDynamicEnum.diminuendo && h.default.warn("GraphicalContinuousDynamicExpression.updateSkyBottomLine(): unhandled continuous dynamic type. start measure: " + this.startMeasure?.MeasureNumber), this.Placement){
                            case l.PlacementEnum.Above:
                                if (this.IsSoftAccent) t.updateSkyLineWithWedge(this.lines[0].Start, this.lines[0].End), t.updateSkyLineWithWedge(this.lines[2].End, this.lines[2].Start), t.updateSkyLineWithLine(this.lines[0].End, this.lines[2].End, this.lines[0].End.y);
                                else if (this.IsVerbal) {
                                    const n = e.BorderMarginTop + e.RelativePosition.y;
                                    t.updateSkyLineWithLabel(i, s, n);
                                } else this.ContinuousDynamic.DynamicType === r.ContDynamicEnum.crescendo ? t.updateSkyLineWithWedge(this.lines[0].Start, this.lines[0].End) : this.ContinuousDynamic.DynamicType === r.ContDynamicEnum.diminuendo && t.updateSkyLineWithWedge(this.lines[0].End, this.lines[0].Start);
                                break;
                            case l.PlacementEnum.Below:
                                if (this.IsVerbal) {
                                    const n = e.BorderMarginBottom + e.RelativePosition.y;
                                    t.updateBottomLineWithLabel(i, s, n);
                                } else this.ContinuousDynamic.DynamicType === r.ContDynamicEnum.crescendo ? t.updateBottomLineWithWedge(this.lines[1].Start, this.lines[1].End) : this.ContinuousDynamic.DynamicType === r.ContDynamicEnum.diminuendo && t.updateBottomLineWithWedge(this.lines[1].End, this.lines[1].Start);
                                break;
                            default:
                                h.default.error("Placement for GraphicalContinuousDynamicExpression is unknown");
                        }
                    }
                    createCrescendoLines(t, e, i, s = this.rules.WedgeOpeningLength, n = this.rules.WedgeLineWidth) {
                        const r = new o.PointF2D(t, i), a = new o.PointF2D(e, i - s / 2), l = new o.PointF2D(e, i + s / 2);
                        this.addWedgeLines(r, a, l, n);
                    }
                    createFirstHalfCrescendoLines(t, e, i, s = this.rules.WedgeMeasureEndOpeningLength, n = this.rules.WedgeLineWidth) {
                        const r = new o.PointF2D(t, i), a = new o.PointF2D(e, i - s / 2), l = new o.PointF2D(e, i + s / 2);
                        this.addWedgeLines(r, a, l, n);
                    }
                    createSecondHalfCrescendoLines(t, e, i, s = this.rules.WedgeMeasureBeginOpeningLength, n = this.rules.WedgeOpeningLength, r = this.rules.WedgeLineWidth) {
                        const a = new o.PointF2D(t, i - s / 2), l = new o.PointF2D(t, i + s / 2), h = new o.PointF2D(e, i - n / 2), c = new o.PointF2D(e, i + n / 2);
                        this.addDoubleLines(a, h, l, c, r);
                    }
                    recalculateCrescendoLines(t, e, i) {
                        const s = Math.abs(this.lines[0].Start.y - this.lines[1].Start.y) > 1e-4;
                        this.lines.clear(), s ? this.createSecondHalfCrescendoLines(t, e, i) : this.isSplittedPart ? this.createFirstHalfCrescendoLines(t, e, i) : this.createCrescendoLines(t, e, i);
                    }
                    createDiminuendoLines(t, e, i, s = this.rules.WedgeOpeningLength, n = this.rules.WedgeLineWidth) {
                        const r = new o.PointF2D(t, i - s / 2), a = new o.PointF2D(t, i + s / 2), l = new o.PointF2D(e, i);
                        this.addWedgeLines(l, r, a, n);
                    }
                    createFirstHalfDiminuendoLines(t, e, i, s = this.rules.WedgeOpeningLength, n = this.rules.WedgeMeasureEndOpeningLength, r = this.rules.WedgeLineWidth) {
                        const a = new o.PointF2D(t, i - s / 2), l = new o.PointF2D(t, i + s / 2), h = new o.PointF2D(e, i - n / 2), c = new o.PointF2D(e, i + n / 2);
                        this.addDoubleLines(a, h, l, c, r);
                    }
                    createSecondHalfDiminuendoLines(t, e, i, s = this.rules.WedgeMeasureBeginOpeningLength, n = this.rules.WedgeLineWidth) {
                        const r = new o.PointF2D(t, i - s / 2), a = new o.PointF2D(t, i + s / 2), l = new o.PointF2D(e, i);
                        this.addWedgeLines(l, r, a, n);
                    }
                    recalculateDiminuendoLines(t, e, i) {
                        const s = Math.abs(this.lines[0].End.y - this.lines[1].End.y) > 1e-4;
                        this.lines.clear(), s ? this.createFirstHalfDiminuendoLines(t, e, i) : this.isSplittedPart ? this.createSecondHalfDiminuendoLines(t, e, i) : this.createDiminuendoLines(t, e, i);
                    }
                    createFirstHalfLines(t, e, i, s = this.rules.WedgeOpeningLength, n = this.rules.WedgeMeasureEndOpeningLength, o = this.rules.WedgeLineWidth) {
                        this.ContinuousDynamic.DynamicType === r.ContDynamicEnum.crescendo ? this.createFirstHalfCrescendoLines(t, e, i, n, o) : this.ContinuousDynamic.DynamicType === r.ContDynamicEnum.diminuendo && this.createFirstHalfDiminuendoLines(t, e, i, s, n, o);
                    }
                    createSecondHalfLines(t, e, i, s = this.rules.WedgeMeasureBeginOpeningLength, n = this.rules.WedgeOpeningLength, o = this.rules.WedgeLineWidth) {
                        this.ContinuousDynamic.DynamicType === r.ContDynamicEnum.crescendo ? this.createSecondHalfCrescendoLines(t, e, i, s, n, o) : this.ContinuousDynamic.DynamicType === r.ContDynamicEnum.diminuendo && this.createSecondHalfDiminuendoLines(t, e, i, s, o);
                    }
                    createLines(t, e, i, s = this.rules.WedgeOpeningLength, n = this.rules.WedgeLineWidth) {
                        this.ContinuousDynamic.DynamicType === r.ContDynamicEnum.crescendo ? this.createCrescendoLines(t, e, i, s, n) : this.ContinuousDynamic.DynamicType === r.ContDynamicEnum.diminuendo && this.createDiminuendoLines(t, e, i, s, n);
                    }
                    calcPsi() {
                        this.IsVerbal ? this.PositionAndShape.calculateBoundingBox() : (this.PositionAndShape.RelativePosition = this.lines[0].Start, this.PositionAndShape.BorderMarginTop = this.lines[0].End.y - this.lines[0].Start.y, this.PositionAndShape.BorderMarginBottom = this.lines[1].End.y - this.lines[1].Start.y, this.PositionAndShape.Center.y = (this.PositionAndShape.BorderMarginTop + this.PositionAndShape.BorderMarginBottom) / 2, this.IsSoftAccent ? (this.PositionAndShape.BorderMarginLeft = 0, this.PositionAndShape.BorderMarginRight = this.lines[3].Start.x - this.lines[0].Start.x) : this.ContinuousDynamic.DynamicType === r.ContDynamicEnum.crescendo ? (this.PositionAndShape.BorderMarginLeft = 0, this.PositionAndShape.BorderMarginRight = this.lines[0].End.x - this.lines[0].Start.x) : (this.PositionAndShape.BorderMarginLeft = this.lines[0].End.x - this.lines[0].Start.x, this.PositionAndShape.BorderMarginRight = 0));
                    }
                    cleanUp() {
                        this.lines.clear();
                    }
                    shiftYPosition(t) {
                        this.IsVerbal ? (this.PositionAndShape.RelativePosition.y += t, this.PositionAndShape.calculateBoundingBox()) : (this.lines[0].Start.y += t, this.lines[0].End.y += t, this.lines[1].End.y += t);
                    }
                    squeeze(t) {
                        this.IsVerbal || Math.abs(this.lines[0].End.x - this.lines[0].Start.x) < Math.abs(t) || (this.ContinuousDynamic.DynamicType === r.ContDynamicEnum.crescendo ? t > 0 ? this.lines[0].Start.x += t : (this.lines[0].End.x += t, this.lines[1].End.x += t) : t < 0 ? this.lines[0].Start.x += t : (this.lines[0].End.x += t, this.lines[1].End.x += t), this.calcPsi());
                    }
                    addWedgeLines(t, e, i, s) {
                        const r = new n.GraphicalLine(t, e, s), o = new n.GraphicalLine(t, i, s);
                        this.rules.DefaultColorMusic && (r.colorHex = this.rules.DefaultColorMusic, o.colorHex = this.rules.DefaultColorMusic), this.lines.push(r), this.lines.push(o);
                    }
                    addDoubleLines(t, e, i, s, r) {
                        const o = new n.GraphicalLine(t, e, r), a = new n.GraphicalLine(i, s, r);
                        this.rules.DefaultColorMusic && (o.colorHex = this.rules.DefaultColorMusic, a.colorHex = this.rules.DefaultColorMusic), this.lines.push(o), this.lines.push(a);
                    }
                }
                e.GraphicalContinuousDynamicExpression = c;
            },
            6711 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.GraphicalCurve = void 0;
                const s = i(9409);
                class n {
                    static calculateBezierFactors(t) {
                        const e = new Array(n.bezierCurveStepSize);
                        for(let i = 0; i < n.bezierCurveStepSize; i++)e[i] = t(i / n.bezierCurveStepSize);
                        return e;
                    }
                    calculateCurvePointAtIndex(t) {
                        const e = Math.round(t * n.bezierCurveStepSize);
                        return e < 0 || e >= n.bezierCurveStepSize ? new s.PointF2D : new s.PointF2D(n.oneMinusTPow3[e] * this.bezierStartPt.x + n.bezierFactorOne[e] * this.bezierStartControlPt.x + n.bezierFactorTwo[e] * this.bezierEndControlPt.x + n.tPow3[e] * this.bezierEndPt.x, n.oneMinusTPow3[e] * this.bezierStartPt.y + n.bezierFactorOne[e] * this.bezierStartControlPt.y + n.bezierFactorTwo[e] * this.bezierEndControlPt.y + n.tPow3[e] * this.bezierEndPt.y);
                    }
                }
                e.GraphicalCurve = n, n.bezierCurveStepSize = 1e3, n.tPow3 = n.calculateBezierFactors((t)=>Math.pow(t, 3)), n.oneMinusTPow3 = n.calculateBezierFactors((t)=>Math.pow(1 - t, 3)), n.bezierFactorOne = n.calculateBezierFactors((t)=>3 * Math.pow(1 - t, 2) * t), n.bezierFactorTwo = n.calculateBezierFactors((t)=>3 * (1 - t) * Math.pow(t, 2));
            },
            98 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.GraphicalGlissando = void 0;
                const s = i(9409), n = i(6438), r = i(6452);
                e.GraphicalGlissando = class {
                    constructor(t){
                        this.Glissando = t, this.staffEntries = [];
                    }
                    calculateLine(t) {
                        const e = this.staffEntries[0], i = this.staffEntries[this.staffEntries.length - 1], o = e.findGraphicalNoteFromNote(this.Glissando.StartNote), a = i.findGraphicalNoteFromNote(this.Glissando.EndNote);
                        if (!o && !a) return;
                        const l = e.parentMeasure.ParentStaffLine;
                        let h, c, u, d;
                        if (o && e.parentMeasure.ParentStaffLine === this.StaffLine) h = o.PositionAndShape.RelativePosition.x + o.parentVoiceEntry.parentStaffEntry.PositionAndShape.RelativePosition.x + o.parentVoiceEntry.parentStaffEntry.parentMeasure.PositionAndShape.RelativePosition.x + .5 + t.GlissandoNoteOffset, u = o.PositionAndShape.AbsolutePosition.y;
                        else {
                            h = i.parentMeasure.beginInstructionsWidth - .4;
                            const e = this.Glissando.Direction === n.ColDirEnum.Down ? -1 : 1;
                            u = a.PositionAndShape.AbsolutePosition.y + e * t.GlissandoStafflineStartYDistanceToNote;
                        }
                        if (a && i.parentMeasure.ParentStaffLine === this.StaffLine) c = a.PositionAndShape.RelativePosition.x + a.parentVoiceEntry.parentStaffEntry.PositionAndShape.RelativePosition.x + a.parentVoiceEntry.parentStaffEntry.parentMeasure.PositionAndShape.RelativePosition.x - .5 - t.GlissandoNoteOffset, h > c && (h = c - t.GlissandoStafflineStartMinimumWidth), d = a.PositionAndShape.AbsolutePosition.y;
                        else {
                            let e = l.Measures.last();
                            if (e.IsExtraGraphicalMeasure && (e = e.ExtraGraphicalMeasurePreviousMeasure), e.parentSourceMeasure.HasEndLine) return;
                            c = e.PositionAndShape.RelativePosition.x + e.PositionAndShape.Size.width, c - h > t.GlissandoStafflineEndOffset && (h = c - t.GlissandoStafflineEndOffset);
                            const i = this.Glissando.Direction === n.ColDirEnum.Down ? 1 : -1;
                            d = o.PositionAndShape.AbsolutePosition.y + i * t.GlissandoStafflineStartYDistanceToNote;
                        }
                        const f = new s.PointF2D(h, u), m = new s.PointF2D(c, d);
                        void 0 === this.Width && (this.Width = t.GlissandoDefaultWidth), this.Line = new r.GraphicalLine(f, m, this.Width);
                    }
                };
            },
            5023 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.GraphicalInstantaneousDynamicExpression = void 0;
                const n = i(9490), r = i(6362), o = s(i(3065));
                class a extends n.AbstractGraphicalExpression {
                    constructor(t, e, i){
                        super(e, t, i.parentSourceMeasure), this.mInstantaneousDynamicExpression = t, this.mMeasure = i;
                    }
                    updateSkyBottomLine() {
                        const t = this.parentStaffLine.SkyBottomLineCalculator, e = this.PositionAndShape.RelativePosition.x + this.PositionAndShape.BorderMarginLeft, i = this.PositionAndShape.RelativePosition.x + this.PositionAndShape.BorderMarginRight;
                        let s = 0;
                        switch(this.Placement){
                            case r.PlacementEnum.Above:
                                s = this.PositionAndShape.RelativePosition.y + this.PositionAndShape.BorderMarginTop, t.updateSkyLineWithLabel(e, i, s);
                                break;
                            case r.PlacementEnum.Below:
                                s = this.PositionAndShape.RelativePosition.y + this.PositionAndShape.BorderMarginBottom, t.updateBottomLineWithLabel(e, i, s);
                                break;
                            default:
                                o.default.error("Placement for GraphicalInstantaneousDynamicExpression is unknown");
                        }
                    }
                }
                e.GraphicalInstantaneousDynamicExpression = a;
            },
            3361 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.GraphicalInstantaneousTempoExpression = void 0;
                const s = i(9490);
                class n extends s.AbstractGraphicalExpression {
                    constructor(t, e){
                        super(e.PositionAndShape.Parent.DataObject, t, t.parentMeasure), this.label = e;
                    }
                    get GraphicalLabel() {
                        return this.label;
                    }
                    updateSkyBottomLine() {}
                }
                e.GraphicalInstantaneousTempoExpression = n;
            },
            8254 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.GraphicalLabel = void 0;
                const s = i(7533), n = i(6438), r = i(995), o = i(7921);
                class a extends r.Clickable {
                    constructor(t, e, i, s, r){
                        super(), this.CenteringXShift = 0, this.AnchoredToPageBottom = !1, this.label = t, this.boundingBox = new n.BoundingBox(this, r), this.label.fontHeight = e, this.label.textAlignment = i, this.rules = s;
                    }
                    get Label() {
                        return this.label;
                    }
                    toString() {
                        return `${this.label.text} (${this.boundingBox.RelativePosition.x},${this.boundingBox.RelativePosition.y})`;
                    }
                    setLabelPositionAndShapeBorders() {
                        if ("" === this.Label.text.trim()) return;
                        this.TextLines = [];
                        const t = this.rules?.LabelMarginBorderFactor ?? .1, e = this.Label.text.split(/[\n\r]+/g), i = e.length;
                        let n = 0;
                        for(let t = 0; t < i; t++){
                            const i = e[t].trim(), s = o.MusicSheetCalculator.TextMeasurer.computeTextWidthToHeightRatio(i, this.Label.font, this.Label.fontStyle, this.label.fontFamily), r = this.Label.fontHeight * s;
                            n = Math.max(n, r), this.TextLines.push({
                                text: i,
                                xOffset: 0,
                                width: r
                            });
                        }
                        for (const t of this.TextLines){
                            let e = 0;
                            switch(this.Label.textAlignment){
                                case s.TextAlignmentEnum.RightBottom:
                                case s.TextAlignmentEnum.RightCenter:
                                case s.TextAlignmentEnum.RightTop:
                                    e = n - t.width;
                                    break;
                                case s.TextAlignmentEnum.CenterBottom:
                                case s.TextAlignmentEnum.CenterCenter:
                                case s.TextAlignmentEnum.CenterTop:
                                    e = (n - t.width) / 2;
                            }
                            t.xOffset = e;
                        }
                        let r = this.Label.fontHeight * i;
                        this.rules.SpacingBetweenTextLines > 0 && this.TextLines.length > 1 && (r += this.rules.SpacingBetweenTextLines * i / 10);
                        const a = this.PositionAndShape;
                        switch(this.Label.textAlignment){
                            case s.TextAlignmentEnum.CenterBottom:
                                a.BorderTop = -r, a.BorderLeft = -n / 2, a.BorderBottom = 0, a.BorderRight = n / 2;
                                break;
                            case s.TextAlignmentEnum.CenterCenter:
                                a.BorderTop = -r / 2, a.BorderLeft = -n / 2, a.BorderBottom = r / 2, a.BorderRight = n / 2;
                                break;
                            case s.TextAlignmentEnum.CenterTop:
                                a.BorderTop = 0, a.BorderLeft = -n / 2, a.BorderBottom = r, a.BorderRight = n / 2;
                                break;
                            case s.TextAlignmentEnum.LeftBottom:
                                a.BorderTop = -r, a.BorderLeft = 0, a.BorderBottom = 0, a.BorderRight = n;
                                break;
                            case s.TextAlignmentEnum.LeftCenter:
                                a.BorderTop = -r / 2, a.BorderLeft = 0, a.BorderBottom = r / 2, a.BorderRight = n;
                                break;
                            case s.TextAlignmentEnum.LeftTop:
                                a.BorderTop = 0, a.BorderLeft = 0, a.BorderBottom = r, a.BorderRight = n;
                                break;
                            case s.TextAlignmentEnum.RightBottom:
                                a.BorderTop = -r, a.BorderLeft = -n, a.BorderBottom = 0, a.BorderRight = 0;
                                break;
                            case s.TextAlignmentEnum.RightCenter:
                                a.BorderTop = -r / 2, a.BorderLeft = -n, a.BorderBottom = r / 2, a.BorderRight = 0;
                                break;
                            case s.TextAlignmentEnum.RightTop:
                                a.BorderTop = 0, a.BorderLeft = -n, a.BorderBottom = r, a.BorderRight = 0;
                        }
                        a.BorderMarginTop = a.BorderTop - r * t, a.BorderMarginLeft = a.BorderLeft - r * t, a.BorderMarginBottom = a.BorderBottom + r * t, a.BorderMarginRight = a.BorderRight + r * t;
                    }
                }
                e.GraphicalLabel = a;
            },
            6452 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.GraphicalLine = void 0;
                const s = i(2683);
                e.GraphicalLine = class {
                    constructor(t, e, i = 0, n = s.OutlineAndFillStyleEnum.BaseWritingColor, r){
                        this.start = t, this.end = e, this.width = i, this.styleId = n, this.colorHex = r;
                    }
                    get Start() {
                        return this.start;
                    }
                    set Start(t) {
                        this.start = t;
                    }
                    get End() {
                        return this.end;
                    }
                    set End(t) {
                        this.end = t;
                    }
                    get Width() {
                        return this.width;
                    }
                    set Width(t) {
                        this.width = t;
                    }
                };
            },
            2395 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.GraphicalLyricEntry = void 0;
                const s = i(8254), n = i(7435), r = i(9409), o = i(7533), a = i(7921);
                class l {
                    constructor(t, e, i, a){
                        this.lyricsEntry = t, this.graphicalStaffEntry = e;
                        const l = e.parentMeasure.parentSourceMeasure.Rules.LyricsAlignmentStandard;
                        t.Text.length >= 4 && t.Parent.Notes[0].Length.Denominator > 4 && o.TextAlignmentEnum.LeftBottom;
                        const h = new n.Label(t.Text);
                        h.language = t.language;
                        const c = this.graphicalStaffEntry.parentMeasure.parentSourceMeasure.Rules;
                        this.graphicalLabel = new s.GraphicalLabel(h, i, l, c, e.PositionAndShape), this.graphicalLabel.Label.colorDefault = c.DefaultColorLyrics, this.graphicalLabel.PositionAndShape.RelativePosition = new r.PointF2D(0, a), this.graphicalLabel.setLabelPositionAndShapeBorders(), this.moveLeadingNumberLeftOfLyric(c), this.graphicalLabel.PositionAndShape.Size.width < c.LyricsExtraXShiftForShortLyricsWidthThreshold && (this.graphicalLabel.PositionAndShape.RelativePosition.x += c.LyricsExtraXShiftForShortLyrics, this.graphicalLabel.CenteringXShift = c.LyricsExtraXShiftForShortLyrics), l === o.TextAlignmentEnum.LeftBottom && (this.graphicalLabel.PositionAndShape.RelativePosition.x -= 1);
                    }
                    moveLeadingNumberLeftOfLyric(t) {
                        const e = this.graphicalLabel.Label;
                        if (!t.LyricsVerseNumberLeftOfLyric || !o.TextAlignment.IsLeft(e.textAlignment)) return;
                        const i = l.leadingNumber.exec(this.graphicalLabel.TextLines?.[0].text ?? "")?.[0];
                        if (!i || !this.numbersStartTheirVerses()) return;
                        const s = e.fontHeight * a.MusicSheetCalculator.TextMeasurer.computeTextWidthToHeightRatio(i, e.font, e.fontStyle, e.fontFamily), n = this.graphicalLabel.PositionAndShape;
                        n.BorderRight -= s, n.BorderMarginRight -= s, n.BorderMarginLeft -= s;
                        for (const t of this.graphicalLabel.TextLines)t.xOffset -= s;
                    }
                    numbersStartTheirVerses() {
                        for (const t of this.lyricsEntry.Parent.ParentSourceStaffEntry.VoiceEntries)for (const e of t.LyricsEntries.values())if (l.leadingNumber.test(e.Text.trim()) && !this.isFirstOfVerseInStaff(e.VerseNumber)) return !1;
                        return !0;
                    }
                    isFirstOfVerseInStaff(t) {
                        const e = this.lyricsEntry.Parent.ParentSourceStaffEntry, i = e.ParentStaff;
                        for (const s of i.ParentInstrument.GetMusicSheet.SourceMeasures){
                            for (const n of s.VerticalSourceStaffEntryContainers){
                                const s = n.StaffEntries[i.idInMusicSheet];
                                if (s?.AbsoluteTimestamp.lt(e.AbsoluteTimestamp) && s.VoiceEntries.some((e)=>e.LyricsEntries.containsKey(t))) return !1;
                            }
                            if (s === e.VerticalContainerParent.ParentMeasure) break;
                        }
                        return !0;
                    }
                    resetPosition() {
                        const t = this.graphicalLabel.PositionAndShape.RelativePosition;
                        this.initialLabelRelativePosition ? (t.x = this.initialLabelRelativePosition.x, t.y = this.initialLabelRelativePosition.y) : this.initialLabelRelativePosition = new r.PointF2D(t.x, t.y);
                    }
                    get HeightBelowVerseLine() {
                        return ((this.graphicalLabel.TextLines?.length ?? 1) - 1) * this.graphicalLabel.Label.fontHeight;
                    }
                    get VerseLineY() {
                        return this.graphicalLabel.PositionAndShape.RelativePosition.y - this.HeightBelowVerseLine;
                    }
                    hasDashFromLyricWord() {
                        if (!this.ParentLyricWord) return !1;
                        const t = this.ParentLyricWord.GraphicalLyricsEntries.indexOf(this);
                        return this.ParentLyricWord.GraphicalLyricsEntries.length > 1 && t < this.ParentLyricWord.GraphicalLyricsEntries.length - 1;
                    }
                    get LyricsEntry() {
                        return this.lyricsEntry;
                    }
                    get ParentLyricWord() {
                        return this.graphicalLyricWord;
                    }
                    set ParentLyricWord(t) {
                        this.graphicalLyricWord = t;
                    }
                    get GraphicalLabel() {
                        return this.graphicalLabel;
                    }
                    set GraphicalLabel(t) {
                        this.graphicalLabel = t;
                    }
                    get StaffEntryParent() {
                        return this.graphicalStaffEntry;
                    }
                    set StaffEntryParent(t) {
                        this.graphicalStaffEntry = t;
                    }
                }
                e.GraphicalLyricEntry = l, l.leadingNumber = /^(?:\p{Nd}+\p{P}[^\p{Nd}\p{L}]*)+(?=\p{L})/u;
            },
            7751 (t, e) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.GraphicalLyricWord = void 0, e.GraphicalLyricWord = class {
                    constructor(t){
                        this.graphicalLyricsEntries = [], this.lyricWord = t, this.initialize();
                    }
                    get GetLyricWord() {
                        return this.lyricWord;
                    }
                    get GraphicalLyricsEntries() {
                        return this.graphicalLyricsEntries;
                    }
                    set GraphicalLyricsEntries(t) {
                        this.graphicalLyricsEntries = t;
                    }
                    isFilled() {
                        for(let t = 0; t < this.graphicalLyricsEntries.length; t++)if (!this.graphicalLyricsEntries[t]) return !1;
                        return !0;
                    }
                    initialize() {
                        for(let t = 0; t < this.lyricWord.Syllables.length; t++)this.graphicalLyricsEntries.push(void 0);
                    }
                };
            },
            1519 (t, e) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.GraphicalMarkedArea = void 0, e.GraphicalMarkedArea = class {
                    constructor(t, e, i, s){
                        this.systemRectangle = t, this.labelRectangle = e, this.label = i, this.settings = s;
                    }
                };
            },
            5748 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.GraphicalMeasure = void 0;
                const s = i(7741), n = i(2561), r = i(6438), o = i(9409);
                class a extends s.GraphicalObject {
                    constructor(t, e, i){
                        super(), this.hasOnlyRests = !1, this.measureNumber = -1, this.ShowTimeSignature = !0, this.ShowKeySignature = !0, this.isTabMeasure = !1, this.parentStaff = t, this.parentSourceMeasure = e, this.parentStaffLine = i, i ? (this.parentStaff = i.ParentStaff, this.PositionAndShape = new r.BoundingBox(this, i.PositionAndShape)) : this.PositionAndShape = new r.BoundingBox(this), this.PositionAndShape.BorderBottom = 4, this.parentSourceMeasure && (this.measureNumber = this.parentSourceMeasure.MeasureNumber), this.staffEntries = [];
                    }
                    get NotesAreAbbreviated() {
                        return !1;
                    }
                    get ParentStaff() {
                        return this.parentStaff;
                    }
                    get ParentMusicSystem() {
                        return this.parentMusicSystem;
                    }
                    set ParentMusicSystem(t) {
                        this.parentMusicSystem = t;
                    }
                    get MeasureNumber() {
                        return this.measureNumber;
                    }
                    get FirstInstructionStaffEntry() {
                        return this.firstInstructionStaffEntry;
                    }
                    set FirstInstructionStaffEntry(t) {
                        this.firstInstructionStaffEntry = t;
                    }
                    get LastInstructionStaffEntry() {
                        return this.lastInstructionStaffEntry;
                    }
                    set LastInstructionStaffEntry(t) {
                        this.lastInstructionStaffEntry = t;
                    }
                    get ParentStaffLine() {
                        return this.parentStaffLine;
                    }
                    set ParentStaffLine(t) {
                        this.parentStaffLine = t, this.parentStaffLine && (this.PositionAndShape.Parent = this.parentStaffLine.PositionAndShape);
                    }
                    resetLayout() {
                        throw new Error("not implemented");
                    }
                    getLineWidth(t) {
                        throw new Error("not implemented");
                    }
                    addClefAtBegin(t) {
                        throw new Error("not implemented");
                    }
                    addKeyAtBegin(t, e, i) {
                        throw new Error("not implemented");
                    }
                    addRhythmAtBegin(t) {
                        throw new Error("not implemented");
                    }
                    addClefAtEnd(t, e = !0) {
                        throw new Error("not implemented");
                    }
                    setPositionInStaffline(t) {
                        this.PositionAndShape.RelativePosition = new o.PointF2D(t, 0);
                    }
                    setWidth(t) {
                        this.PositionAndShape.BorderRight = t;
                    }
                    layoutSymbols() {
                        throw new Error("not implemented");
                    }
                    findGraphicalStaffEntryFromTimestamp(t) {
                        for(let e = 0, i = this.staffEntries.length; e < i; ++e){
                            const i = this.staffEntries[e];
                            if (i.relInMeasureTimestamp?.Equals(t)) return i;
                        }
                    }
                    findGraphicalStaffEntryFromVerticalContainerTimestamp(t) {
                        for(let e = 0, i = this.staffEntries.length; e < i; ++e){
                            const i = this.staffEntries[e];
                            if (i.sourceStaffEntry.VerticalContainerParent.getAbsoluteTimestamp().Equals(t)) return i;
                        }
                    }
                    hasSameDurationWithSourceMeasureParent() {
                        const t = new n.Fraction(0, 1);
                        for(let e = 0, i = this.staffEntries.length; e < i; ++e){
                            const i = this.staffEntries[e];
                            t.Add(i.findStaffEntryMinNoteLength());
                        }
                        return t.Equals(this.parentSourceMeasure.Duration);
                    }
                    hasMultipleVoices() {
                        if (0 === this.staffEntries.length) return !1;
                        const t = [];
                        for(let e = 0, i = this.staffEntries.length; e < i; ++e){
                            const i = this.staffEntries[e];
                            for(let e = 0, s = i.sourceStaffEntry.VoiceEntries.length; e < s; ++e){
                                const s = i.sourceStaffEntry.VoiceEntries[e];
                                t.indexOf(s.ParentVoice) < 0 && t.push(s.ParentVoice);
                            }
                        }
                        return t.length > 1;
                    }
                    isVisible() {
                        return this.ParentStaff.isVisible();
                    }
                    isMultiRestMeasure() {
                        return void 0 !== this.multiRestElement;
                    }
                    getGraphicalMeasureDurationFromStaffEntries() {
                        let t = new n.Fraction(0, 1);
                        const e = [];
                        for(let t = 0, i = this.staffEntries.length; t < i; ++t){
                            const i = this.staffEntries[t];
                            for(let t = 0, s = i.sourceStaffEntry.VoiceEntries.length; t < s; ++t){
                                const s = i.sourceStaffEntry.VoiceEntries[t];
                                e.indexOf(s.ParentVoice) < 0 && e.push(s.ParentVoice);
                            }
                        }
                        for(let i = 0, s = e.length; i < s; ++i){
                            const s = e[i], r = new n.Fraction(0, 1);
                            for (const t of this.staffEntries)for (const e of t.graphicalVoiceEntries)e.parentVoiceEntry.ParentVoice === s && e.notes.length > 0 && r.Add(e.notes[0].graphicalNoteLength);
                            t.lt(r) && (t = n.Fraction.createFromFraction(r));
                        }
                        return t;
                    }
                    addGraphicalStaffEntry(t) {
                        this.staffEntries.push(t);
                    }
                    addGraphicalStaffEntryAtTimestamp(t) {
                        if (t) {
                            if (0 === this.staffEntries.length || this.staffEntries[this.staffEntries.length - 1].relInMeasureTimestamp.lt(t.relInMeasureTimestamp)) this.staffEntries.push(t);
                            else for(let e = this.staffEntries.length - 1; e >= 0; e--){
                                if (this.staffEntries[e].relInMeasureTimestamp.lt(t.relInMeasureTimestamp)) {
                                    this.staffEntries.splice(e + 1, 0, t);
                                    break;
                                }
                                0 === e && this.staffEntries.splice(e, 0, t);
                            }
                        }
                    }
                    isPianoRightHand() {
                        return this.isUpperStaffOfInstrument();
                    }
                    isPianoLeftHand() {
                        return this.isLowerStaffOfInstrument();
                    }
                    isUpperStaffOfInstrument() {
                        return 1 === this.parentStaff.ParentInstrument.Staves.length || this.ParentStaff === this.parentStaff.ParentInstrument.Staves[0];
                    }
                    isLowerStaffOfInstrument() {
                        return 1 !== this.parentStaff.ParentInstrument.Staves.length && this.ParentStaff === this.ParentStaff.ParentInstrument.Staves.last();
                    }
                    beginsWithLineRepetition() {
                        const t = this.parentSourceMeasure;
                        return !!t && t.beginsWithLineRepetition();
                    }
                    endsWithLineRepetition() {
                        const t = this.parentSourceMeasure;
                        return !!t && t.endsWithLineRepetition();
                    }
                    beginsWithWordRepetition() {
                        const t = this.parentSourceMeasure;
                        return !!t && t.beginsWithWordRepetition();
                    }
                    endsWithWordRepetition() {
                        const t = this.parentSourceMeasure;
                        return !!t && t.endsWithWordRepetition();
                    }
                    getTransposedHalftones() {
                        return this.parentStaff.ParentInstrument.GetMusicSheet.Transpose + this.parentStaff.ParentInstrument.Transpose;
                    }
                }
                e.GraphicalMeasure = a;
            },
            1888 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.PagePlacementEnum = e.GraphicalMusicPage = void 0;
                const s = i(6438), n = i(7741), r = i(9409);
                class o extends n.GraphicalObject {
                    constructor(t){
                        super(), this.musicSystems = [], this.labels = [], this.parent = t, this.boundingBox = new s.BoundingBox(this, void 0);
                    }
                    get MusicSystems() {
                        return this.musicSystems;
                    }
                    set MusicSystems(t) {
                        this.musicSystems = t;
                    }
                    get Labels() {
                        return this.labels;
                    }
                    set Labels(t) {
                        this.labels = t;
                    }
                    get Parent() {
                        return this.parent;
                    }
                    set Parent(t) {
                        this.parent = t;
                    }
                    get PageNumber() {
                        return this.pageNumber;
                    }
                    set PageNumber(t) {
                        this.pageNumber = t;
                    }
                    setMusicPageAbsolutePosition(t, e) {
                        return new r.PointF2D(0, 0);
                    }
                }
                var a;
                e.GraphicalMusicPage = o, function(t) {
                    t[t.Down = 0] = "Down", t[t.Right = 1] = "Right", t[t.RightDown = 2] = "RightDown";
                }(a || (e.PagePlacementEnum = a = {}));
            },
            8724 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.SystemImageProperties = e.GraphicalMusicSheet = void 0;
                const n = i(6723), r = i(6452), o = i(348), a = i(9409), l = i(164), h = i(4543), c = i(2561), u = i(6438), d = s(i(3065)), f = i(813), m = i(4548), p = i(7741);
                class g {
                    constructor(t, e){
                        this.musicPages = [], this.measureList = [], this.verticalGraphicalStaffEntryContainers = [], this.firstPageCreditWords = [], this.cursors = [], this.leadSheet = !1, this.musicSheet = t, this.numberOfStaves = this.musicSheet.Staves.length, this.calculator = e, this.calculator.initialize(this);
                    }
                    get ParentMusicSheet() {
                        return this.musicSheet;
                    }
                    get GetCalculator() {
                        return this.calculator;
                    }
                    get MusicPages() {
                        return this.musicPages;
                    }
                    set MusicPages(t) {
                        this.musicPages = t;
                    }
                    get MeasureList() {
                        return this.measureList;
                    }
                    set MeasureList(t) {
                        this.measureList = t;
                    }
                    get VerticalGraphicalStaffEntryContainers() {
                        return this.verticalGraphicalStaffEntryContainers;
                    }
                    set VerticalGraphicalStaffEntryContainers(t) {
                        this.verticalGraphicalStaffEntryContainers = t;
                    }
                    get Title() {
                        return this.title;
                    }
                    set Title(t) {
                        this.title = t;
                    }
                    get Subtitle() {
                        return this.subtitle;
                    }
                    set Subtitle(t) {
                        this.subtitle = t;
                    }
                    get Composer() {
                        return this.composer;
                    }
                    set Composer(t) {
                        this.composer = t;
                    }
                    get FirstPageCreditWords() {
                        return this.firstPageCreditWords;
                    }
                    set FirstPageCreditWords(t) {
                        this.firstPageCreditWords = t;
                    }
                    get Lyricist() {
                        return this.lyricist;
                    }
                    set Lyricist(t) {
                        this.lyricist = t;
                    }
                    get Copyright() {
                        return this.copyright;
                    }
                    set Copyright(t) {
                        this.copyright = t;
                    }
                    get Cursors() {
                        return this.cursors;
                    }
                    get SelectionStartSymbol() {
                        return this.selectionStartSymbol;
                    }
                    get SelectionEndSymbol() {
                        return this.selectionEndSymbol;
                    }
                    get MinAllowedSystemWidth() {
                        return this.minAllowedSystemWidth;
                    }
                    set MinAllowedSystemWidth(t) {
                        this.minAllowedSystemWidth = t;
                    }
                    get NumberOfStaves() {
                        return this.numberOfStaves;
                    }
                    get LeadSheet() {
                        return this.leadSheet;
                    }
                    set LeadSheet(t) {
                        this.leadSheet = t;
                    }
                    static transformRelativeToAbsolutePosition(t) {
                        for(let e = 0; e < t.MusicPages.length; e++){
                            const i = t.MusicPages[e].setMusicPageAbsolutePosition(e, t.ParentMusicSheet.Rules);
                            t.MusicPages[e].PositionAndShape.calculateAbsolutePositionsRecursive(i.x, i.y);
                        }
                    }
                    Initialize() {
                        this.verticalGraphicalStaffEntryContainers = [], this.musicPages = [], this.measureList = [];
                    }
                    reCalculate() {
                        this.calculator.calculate();
                    }
                    EnforceRedrawOfMusicSystems() {
                        for(let t = 0, e = this.musicPages.length; t < e; ++t){
                            const e = this.musicPages[t];
                            for(let t = 0, i = e.MusicSystems.length; t < i; ++t)e.MusicSystems[t].needsToBeRedrawn = !0;
                        }
                    }
                    getClickedObject(t) {
                        for(let e = 0, i = this.MusicPages.length; e < i; ++e)return this.MusicPages[e].PositionAndShape.getClickedObjectOfType(t);
                    }
                    findGraphicalMeasure(t, e) {
                        for(let i = t; i >= 0; i--){
                            const t = this.measureList[i]?.[e];
                            if (t) return t;
                        }
                    }
                    findGraphicalMeasureByMeasureNumber(t, e) {
                        for(let i = t; i >= 0; i--)if (this.MeasureList[i]) {
                            const s = this.MeasureList[i][e];
                            if (s?.MeasureNumber === t) return s;
                        }
                    }
                    findGraphicalStaffEntryFromMeasureList(t, e, i) {
                        for(let s = e; s < this.measureList.length; s++){
                            const e = this.measureList[s][t];
                            if (e) for(let t = 0, s = e.staffEntries.length; t < s; ++t){
                                const s = e.staffEntries[t];
                                if (s.sourceStaffEntry === i) return s;
                            }
                        }
                    }
                    findNextGraphicalStaffEntry(t, e, i) {
                        const s = i.parentMeasure, n = s.staffEntries.indexOf(i);
                        if (n < s.staffEntries.length - 1) return s.staffEntries[n + 1];
                        if (e < this.measureList.length - 1) {
                            const i = this.measureList[e + 1][t];
                            if (i.staffEntries.length > 0) return i.staffEntries[0];
                        }
                    }
                    getFirstVisibleMeasuresListFromIndices(t, e) {
                        const i = [], s = this.measureList[0].length;
                        for(let n = t; n <= e; n++)for(let t = 0; t < s; t++)if (this.measureList[n][t].isVisible()) {
                            i.push(this.measureList[n][t]);
                            break;
                        }
                        return i;
                    }
                    orderMeasuresByStaffLine(t) {
                        const e = [];
                        let i = [];
                        e.push(i);
                        for(let s = 0; s < t.length; s++)0 === s ? i.push(t[0]) : (t[s].ParentStaffLine === t[s - 1].ParentStaffLine || (-1 === e.indexOf(i) && e.push(i), i = [], e.push(i)), i.push(t[s]));
                        return e;
                    }
                    initializeActiveClefs() {
                        const t = [], e = this.musicSheet.getFirstSourceMeasure();
                        if (e) for(let i = 0; i < e.CompleteNumberOfStaves; i++){
                            let s = new l.ClefInstruction;
                            if (e.FirstInstructionsStaffEntries[i]) for(let t = 0, n = e.FirstInstructionsStaffEntries[i].Instructions.length; t < n; ++t){
                                const n = e.FirstInstructionsStaffEntries[i].Instructions[t];
                                n instanceof l.ClefInstruction && (s = n);
                            }
                            t.push(s);
                        }
                        return t;
                    }
                    GetMainKey() {
                        const t = this.musicSheet.getFirstSourceMeasure();
                        if (t) for(let e = 0; e < t.CompleteNumberOfStaves; e++)for(let i = 0, s = t.FirstInstructionsStaffEntries[e].Instructions.length; i < s; ++i){
                            const s = t.FirstInstructionsStaffEntries[e].Instructions[i];
                            if (s instanceof h.KeyInstruction) return s;
                        }
                    }
                    getOrCreateVerticalContainer(t) {
                        if (0 === this.verticalGraphicalStaffEntryContainers.length || f.CollectionUtil.getLastElement(this.verticalGraphicalStaffEntryContainers).AbsoluteTimestamp.lt(t)) {
                            const e = new n.VerticalGraphicalStaffEntryContainer(this.numberOfStaves, t);
                            return this.verticalGraphicalStaffEntryContainers.push(e), e;
                        }
                        for(let e = this.verticalGraphicalStaffEntryContainers.length - 1; e >= 0; e--){
                            if (this.verticalGraphicalStaffEntryContainers[e].AbsoluteTimestamp.lt(t)) {
                                const i = new n.VerticalGraphicalStaffEntryContainer(this.numberOfStaves, t);
                                return this.verticalGraphicalStaffEntryContainers.splice(e + 1, 0, i), i;
                            }
                            if (this.verticalGraphicalStaffEntryContainers[e].AbsoluteTimestamp.Equals(t)) return this.verticalGraphicalStaffEntryContainers[e];
                        }
                    }
                    GetVerticalContainerFromTimestamp(t, e = 0) {
                        const i = f.CollectionUtil.binarySearch(this.verticalGraphicalStaffEntryContainers, new n.VerticalGraphicalStaffEntryContainer(0, t), n.VerticalGraphicalStaffEntryContainer.compareByTimestamp, e);
                        if (i >= 0) return this.verticalGraphicalStaffEntryContainers[i];
                    }
                    GetInterpolatedIndexInVerticalContainers(t) {
                        const e = this.verticalGraphicalStaffEntryContainers;
                        if (1 === e.length) return 0;
                        let i, s, n = 0, r = e.length - 1;
                        if (t.lte(e[e.length - 1].AbsoluteTimestamp)) {
                            for(; r - n > 1;){
                                const i = Math.floor((r + n) / 2);
                                if (e[n].AbsoluteTimestamp.Equals(t)) {
                                    r = n;
                                    break;
                                }
                                if (e[r].AbsoluteTimestamp.Equals(t)) {
                                    n = r;
                                    break;
                                }
                                if (e[i].AbsoluteTimestamp.Equals(t)) return this.verticalGraphicalStaffEntryContainers.indexOf(e[i]);
                                t.lt(e[i].AbsoluteTimestamp) ? r = i : n = i;
                            }
                            if (n === r) return this.verticalGraphicalStaffEntryContainers.indexOf(e[n]);
                            i = e[n].AbsoluteTimestamp, s = e[r].AbsoluteTimestamp;
                        } else i = e[e.length - 1].AbsoluteTimestamp, s = c.Fraction.plus(this.getLongestStaffEntryDuration(e.length - 1), i), r = e.length;
                        const o = s.RealValue - i.RealValue, a = r - (s.RealValue - t.RealValue) / o;
                        return Math.min(a, this.verticalGraphicalStaffEntryContainers.length - 1);
                    }
                    getVisibleStavesIndicesFromSourceMeasure(t) {
                        const e = [], i = [];
                        for(let i = 0, s = t.length; i < s; ++i){
                            const s = t[i].ParentStaff.ParentInstrument;
                            -1 === e.indexOf(s) && e.push(s);
                        }
                        for(let t = 0, s = e.length; t < s; ++t){
                            const s = e[t], n = this.musicSheet.getGlobalStaffIndexOfFirstStaff(s);
                            for(let t = 0; t < s.Staves.length; t++)i.push(n + t);
                        }
                        return i;
                    }
                    getGraphicalMeasureFromSourceMeasureAndIndex(t, e) {
                        for(let i = 0; i < this.measureList.length; i++)if (this.measureList[i][0]?.parentSourceMeasure === t) return this.measureList[i][e];
                    }
                    getLastGraphicalMeasureFromIndex(t, e = !0) {
                        let i = this.measureList.length - 1;
                        e && (i = Math.min(i, this.musicSheet.Rules.MaxMeasureToDrawIndex));
                        let s = this.measureList[i][t];
                        for(; !s && i >= 0;)s = this.measureList[--i][t];
                        return this.measureList[i][t];
                    }
                    getMeasureIndex(t, e, i) {
                        for(e = 0; e < this.measureList.length; e++)for(let i = 0, s = this.measureList[e].length; i < s; ++i)if (this.measureList[e][i] === t) return !0;
                        return !1;
                    }
                    GetNearestGraphicalObject(t, e = p.GraphicalObject, i = 5, s = 20, n = 5, r, o = (e)=>this.CalculateDistance(e.PositionAndShape.AbsolutePosition, t), l) {
                        const h = [], c = this.pagesToSearch(l);
                        for(; 0 === h.length && i <= s;){
                            const s = new u.BoundingBox(void 0);
                            s.BorderLeft = t.x - i, s.BorderTop = t.y - i, s.BorderRight = t.x + i, s.BorderBottom = t.y + i, s.AbsolutePosition = new a.PointF2D(t.x, t.y), s.calculateAbsolutePosition();
                            for(let t = 0, i = c.length; t < i; ++t){
                                const i = c[t].PositionAndShape.getObjectsInRegion(s, !1, e);
                                if (i && 0 !== i.length) for(let t = 0, e = i.length; t < e; ++t)r ? r(i[t]) && h.push(i[t]) : h.push(i[t]);
                            }
                            i += n;
                        }
                        let d;
                        for(let t = 0, e = h.length; t < e; ++t){
                            const e = h[t];
                            (void 0 === d || o(e) < o(d)) && (d = e);
                        }
                        if (d) return d;
                    }
                    pagesToSearch(t) {
                        return t ? [
                            t
                        ] : this.MusicPages;
                    }
                    GetNearestVoiceEntry(t, e = !1, i) {
                        return this.GetNearestGraphicalObject(t, m.GraphicalVoiceEntry, 5, 20, 5, function(t) {
                            if (!t.parentStaffEntry?.relInMeasureTimestamp || g.isUndrawnTabRest(t)) return !1;
                            if (e) {
                                let e = !0;
                                for (const i of t.notes)if (!i.sourceNote.IsGraceNote) {
                                    e = !1;
                                    break;
                                }
                                if (e) return !1;
                            }
                            return !0;
                        }, (e)=>this.distanceToNearestNote(e, t), i);
                    }
                    static isUndrawnTabRest(t) {
                        return !0 === t.parentStaffEntry?.parentMeasure?.isTabMeasure && t.notes.every((t)=>t.sourceNote.isRest());
                    }
                    distanceToNearestNote(t, e) {
                        let i = 1 / 0;
                        for (const s of t.notes)i = Math.min(i, this.CalculateDistance(s.PositionAndShape.AbsolutePosition, e));
                        return i;
                    }
                    GetNearestNote(t, e, i) {
                        const s = this.GetNearestVoiceEntry(t, !1, i);
                        if (!s) return;
                        let n, r = Number.MAX_SAFE_INTEGER;
                        for (const e of s.notes){
                            const i = e.PositionAndShape.AbsolutePosition.y, s = Math.abs(e.PositionAndShape.AbsolutePosition.x - t.x), o = Math.abs(i - t.y);
                            s + o < r && (n = e, r = s + o);
                        }
                        return n;
                    }
                    domToSvg(t) {
                        return this.domToSvgTransform(t, !0);
                    }
                    svgToDom(t) {
                        return this.domToSvgTransform(t, !1);
                    }
                    svgToOsmd(t) {
                        const e = new a.PointF2D(t.x, t.y);
                        return e.x /= 10, e.y /= 10, e;
                    }
                    domToSvgTransform(t, e) {
                        const i = this.drawer.Backends[0].getSvgElement(), s = i.createSVGPoint();
                        s.x = t.x, s.y = t.y;
                        let n = i.getScreenCTM();
                        e && (n = n.inverse());
                        const r = s.matrixTransform(n);
                        return new a.PointF2D(r.x, r.y);
                    }
                    GetClickableLabel(t) {
                        const e = new u.BoundingBox;
                        e.BorderLeft = t.x - 4, e.BorderTop = t.y - 4, e.BorderRight = t.x + 4, e.BorderBottom = t.y + 4, e.AbsolutePosition = new a.PointF2D(0, 0);
                        for(let t = 0, i = this.MusicPages.length; t < i; ++t){
                            const i = this.MusicPages[t].PositionAndShape.getObjectsInRegion(e);
                            if (1 === i.length) for(let t = 0, e = i.length; t < e; ++t)return i[t];
                        }
                    }
                    GetNearestStaffEntry(t, e) {
                        const i = [], s = new u.BoundingBox(void 0);
                        s.BorderLeft = t.x - 10, s.BorderTop = t.y - 10, s.BorderRight = t.x + 10, s.BorderBottom = t.y + 10, s.AbsolutePosition = new a.PointF2D(0, 0);
                        const n = this.pagesToSearch(e);
                        for(let t = 0, e = n.length; t < e; ++t){
                            const e = n[t].PositionAndShape.getObjectsInRegion(s, !1, o.GraphicalStaffEntry);
                            if (e && 0 !== e.length) for(let t = 0, s = e.length; t < s; ++t){
                                const s = e[t];
                                i.push(s);
                            }
                        }
                        let r;
                        for(let e = 0, s = i.length; e < s; ++e){
                            const s = i[e];
                            if (void 0 === r) r = s;
                            else {
                                if (!s.relInMeasureTimestamp) continue;
                                this.CalculateDistance(s.PositionAndShape.AbsolutePosition, t) < this.CalculateDistance(r.PositionAndShape.AbsolutePosition, t) && (r = s);
                            }
                        }
                        if (r) return r;
                    }
                    GetNearestObject(t, e, i) {
                        const s = [], n = new u.BoundingBox(void 0);
                        n.BorderLeft = t.x - 10, n.BorderTop = t.y - 10, n.BorderRight = t.x + 10, n.BorderBottom = t.y + 10, n.AbsolutePosition = new a.PointF2D(0, 0);
                        const r = this.pagesToSearch(i);
                        for(let t = 0, i = r.length; t < i; ++t){
                            const i = r[t].PositionAndShape.getObjectsInRegion(n, !1, e);
                            if (i && 0 !== i.length) for(let t = 0, e = i.length; t < e; ++t){
                                const e = i[t];
                                s.push(e);
                            }
                        }
                        let o;
                        for(let e = 0, i = s.length; e < i; ++e){
                            const i = s[e];
                            (void 0 === o || this.CalculateDistance(i.PositionAndShape.AbsolutePosition, t) < this.CalculateDistance(o.PositionAndShape.AbsolutePosition, t)) && (o = i);
                        }
                        if (o) return o;
                    }
                    GetPossibleCommentAnchor(t) {
                        const e = this.GetNearestStaffEntry(t);
                        if (e) return e.sourceStaffEntry;
                    }
                    getClickedObjectOfType(t) {
                        for(let e = 0, i = this.musicPages.length; e < i; ++e){
                            const i = this.musicPages[e].PositionAndShape.getClickedObjectOfType(t);
                            if (i) return i;
                        }
                    }
                    tryGetTimestampFromPosition(t) {
                        const e = this.getClickedObjectOfType(t);
                        if (e) return e.getAbsoluteTimestamp();
                    }
                    tryGetClickableLabel(t) {
                        try {
                            return this.GetClickableLabel(t);
                        } catch (e) {
                            d.default.info("GraphicalMusicSheet.tryGetClickableObject", "positionOnMusicSheet: " + t, e);
                        }
                    }
                    tryGetTimeStampFromPosition(t) {
                        try {
                            const e = this.GetNearestStaffEntry(t);
                            if (!e) return;
                            return e.getAbsoluteTimestamp();
                        } catch (e) {
                            d.default.info("GraphicalMusicSheet.tryGetTimeStampFromPosition", "positionOnMusicSheet: " + t, e);
                        }
                    }
                    getStaffEntry(t, e = !1) {
                        const i = this.VerticalGraphicalStaffEntryContainers[t];
                        let s;
                        try {
                            for(let t = 0, n = i.StaffEntries.length; t < n; ++t){
                                const n = i.StaffEntries[t];
                                n && n.sourceStaffEntry.ParentStaff.isVisible() && (e && !this.isReliableCursorXAnchor(n) || (s ? n.PositionAndShape && s.PositionAndShape && s.PositionAndShape.RelativePosition.x > n.PositionAndShape.RelativePosition.x && (s = n) : s = n));
                            }
                        } catch (t) {
                            d.default.info("GraphicalMusicSheet.getStaffEntry", t);
                        }
                        return s;
                    }
                    isReliableCursorXAnchor(t) {
                        let e = !1;
                        for (const i of t.graphicalVoiceEntries)if (i.notes.length > 0) {
                            e = !0;
                            break;
                        }
                        if (!e) return !1;
                        const i = t.PositionAndShape?.RelativePosition?.x;
                        if (void 0 === i) return !1;
                        const s = t.parentMeasure?.PositionAndShape?.Size?.width;
                        return !(s > 0 && (i < -4 || i > s + 4));
                    }
                    GetPreviousVisibleContainerIndex(t) {
                        for(let e = t - 1; e >= 0; e--){
                            const t = this.verticalGraphicalStaffEntryContainers[e].StaffEntries;
                            for(let i = 0, s = t.length; i < s; ++i){
                                const s = t[i];
                                if (s && s.sourceStaffEntry.ParentStaff.isVisible()) return e;
                            }
                        }
                        return -1;
                    }
                    GetNextVisibleContainerIndex(t) {
                        for(let e = t + 1; e < this.verticalGraphicalStaffEntryContainers.length; ++e){
                            const t = this.verticalGraphicalStaffEntryContainers[e].StaffEntries;
                            for(let i = 0, s = t.length; i < s; ++i){
                                const s = t[i];
                                if (s && s.sourceStaffEntry.ParentStaff.isVisible()) return e;
                            }
                        }
                        return -1;
                    }
                    findClosestLeftStaffEntry(t, e, i = !1) {
                        let s, n = Math.floor(t);
                        n = Math.min(this.VerticalGraphicalStaffEntryContainers.length - 1, n);
                        for(let t = n; t >= 0; t--)if (s = this.getStaffEntry(t, i), s) {
                            if (!e) return s;
                            if (s.sourceStaffEntry.ParentStaff.isVisible()) return s;
                        }
                    }
                    findClosestRightStaffEntry(t, e, i = !1) {
                        let s;
                        for(let n = Math.max(0, Math.ceil(t)); n < this.VerticalGraphicalStaffEntryContainers.length; n++)if (s = this.getStaffEntry(n, i), s) {
                            if (!e) return s;
                            if (s.sourceStaffEntry.ParentStaff.isVisible()) return s;
                        }
                    }
                    calculateCursorLineAtTimestamp(t, e) {
                        const i = this.calculateXPositionFromTimestamp(t), s = i[0], n = i[1];
                        if (!n || 0 === n.StaffLines.length) return;
                        const o = n.PositionAndShape.AbsolutePosition.y, l = f.CollectionUtil.last(n.StaffLines).PositionAndShape.RelativePosition.y + 4;
                        return new r.GraphicalLine(new a.PointF2D(s, o), new a.PointF2D(s, o + l), 3, e);
                    }
                    calculateXPositionFromTimestamp(t) {
                        let e;
                        const i = this.GetInterpolatedIndexInVerticalContainers(t), s = this.findClosestLeftStaffEntry(i, !0, !0), n = this.findClosestRightStaffEntry(i, !0, !0), r = t.RealValue;
                        if (!s && !n) return [
                            0,
                            void 0
                        ];
                        let o, a;
                        if (o = s ? s.parentMeasure.ParentStaffLine?.ParentMusicSystem : n.parentMeasure.ParentStaffLine?.ParentMusicSystem, a = n ? n.parentMeasure.ParentStaffLine?.ParentMusicSystem : s.parentMeasure.ParentStaffLine?.ParentMusicSystem, o === a) {
                            let t, i, a;
                            if (e = o, s) {
                                if (n) i = s.PositionAndShape.AbsolutePosition.x, a = n.PositionAndShape.AbsolutePosition.x, t = s === n ? 0 : (r - s.getAbsoluteTimestamp().RealValue) / (n.getAbsoluteTimestamp().RealValue - s.getAbsoluteTimestamp().RealValue);
                                else {
                                    i = s.PositionAndShape.AbsolutePosition.x, a = e.GetRightBorderAbsoluteXPosition();
                                    const n = s.parentMeasure.parentSourceMeasure;
                                    t = (r - s.getAbsoluteTimestamp().RealValue) / (c.Fraction.plus(n.AbsoluteTimestamp, n.Duration).RealValue - s.getAbsoluteTimestamp().RealValue);
                                }
                            } else i = a = n.PositionAndShape.AbsolutePosition.x, t = 0;
                            t = Math.min(1, Math.max(0, t));
                            let l = a;
                            return l = Math.max(l, i), [
                                i + t * (l - i),
                                e
                            ];
                        }
                        {
                            const t = n.parentMeasure.parentSourceMeasure.AbsoluteTimestamp.RealValue;
                            let i, l;
                            if ((r < t || !a.StaffLines[0]) && o.StaffLines[0]) {
                                e = o;
                                const n = s.PositionAndShape.AbsolutePosition.x, a = Math.max(e.GetRightBorderAbsoluteXPosition(), n);
                                i = (r - s.getAbsoluteTimestamp().RealValue) / (t - s.getAbsoluteTimestamp().RealValue), i = Math.min(1, Math.max(0, i)), l = n + i * (a - n);
                            } else if (a.StaffLines[0]) {
                                e = a;
                                const s = e.GetLeftBorderAbsoluteXPosition(), o = Math.max(n.PositionAndShape.AbsolutePosition.x, s);
                                i = (r - t) / (n.getAbsoluteTimestamp().RealValue - t), i = Math.min(1, Math.max(0, i)), l = s + i * (o - s);
                            } else e = o, l = s.PositionAndShape.AbsolutePosition.x;
                            return [
                                l,
                                e
                            ];
                        }
                    }
                    GetNumberOfVisibleInstruments() {
                        let t = 0;
                        for(let e = 0, i = this.musicSheet.Instruments.length; e < i; ++e)this.musicSheet.Instruments[e].isVisible() && t++;
                        return t;
                    }
                    GetNumberOfFollowedInstruments() {
                        let t = 0;
                        for(let e = 0, i = this.musicSheet.Instruments.length; e < i; ++e)!0 === this.musicSheet.Instruments[e].Following && t++;
                        return t;
                    }
                    GetGraphicalFromSourceStaffEntry(t) {
                        if (!t.VerticalContainerParent.ParentMeasure?.VerticalMeasureList) return;
                        const e = t.VerticalContainerParent.ParentMeasure.VerticalMeasureList[t.ParentStaff.idInMusicSheet];
                        return e?.findGraphicalStaffEntryFromTimestamp(t.Timestamp);
                    }
                    CalculateDistance(t, e) {
                        const i = t.x - e.x, s = t.y - e.y;
                        return i * i + s * s;
                    }
                    getLongestStaffEntryDuration(t) {
                        let e = new c.Fraction(0, 1);
                        for (const i of this.verticalGraphicalStaffEntryContainers[t].StaffEntries){
                            if (!i) continue;
                            const t = i.findStaffEntryMaxNoteLength();
                            e.lt(t) && (e = t);
                        }
                        return e;
                    }
                }
                e.GraphicalMusicSheet = g, e.SystemImageProperties = class {
                };
            },
            3430 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.GraphicalNote = void 0;
                const s = i(8233), n = i(7741), r = i(7921), o = i(6438);
                class a extends n.GraphicalObject {
                    constructor(t, e, i, n){
                        super(), this.DrawnAccidental = s.AccidentalEnum.NONE, this.lineShift = 0, this.sourceNote = t, this.parentVoiceEntry = e, this.PositionAndShape = new o.BoundingBox(this, e.PositionAndShape), this.graphicalNoteLength = n || t.Length, this.numberOfDots = this.calculateNumberOfNeededDots(this.graphicalNoteLength), this.rules = i, this.rules.addGraphicalNoteToNoteMap(t, this);
                    }
                    Transpose(t, e, i, s) {
                        let n = this.sourceNote.Pitch;
                        return r.MusicSheetCalculator.transposeCalculator && (n = r.MusicSheetCalculator.transposeCalculator.transposePitch(this.sourceNote.Pitch, t, i)), n;
                    }
                    calculateNumberOfNeededDots(t) {
                        return this.sourceNote && this.sourceNote.NoteTuplet ? 0 : t.calculateNumberOfNeededDots();
                    }
                    get ParentMusicPage() {
                        return this.parentVoiceEntry.parentStaffEntry.parentMeasure.ParentMusicSystem?.Parent;
                    }
                    static FromNote(t, e) {
                        return e.NoteToGraphicalNoteMap.getValue(t.NoteToGraphicalNoteObjectId);
                    }
                    ToStringShort(t = 0) {
                        return this.sourceNote?.ToStringShort(t);
                    }
                    get ToStringShortGet() {
                        return this.ToStringShort(0);
                    }
                    getLyricsSVGs() {
                        const t = [];
                        if (!this.parentVoiceEntry) return t;
                        for (const e of this.parentVoiceEntry.parentStaffEntry.LyricsEntries)t.push(e.GraphicalLabel?.SVGNode);
                        return t;
                    }
                    setColor(t, e) {}
                    setVisible(t, e = {}) {}
                }
                e.GraphicalNote = a;
            },
            7741 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.GraphicalObject = void 0;
                const s = i(7791);
                class n extends s.AClassHierarchyTrackable {
                    get PositionAndShape() {
                        return this.boundingBox;
                    }
                    set PositionAndShape(t) {
                        this.boundingBox = t;
                    }
                }
                e.GraphicalObject = n;
            },
            2768 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.GraphicalOctaveShift = void 0;
                const s = i(7741), n = i(437), r = i(6438), o = i(512), a = i(7307);
                class l extends s.GraphicalObject {
                    constructor(t, e){
                        super(), this.getOctaveShift = t, this.setSymbol(), this.PositionAndShape = new r.BoundingBox(this, e);
                    }
                    setSymbol() {
                        switch(this.getOctaveShift.Type){
                            case n.OctaveEnum.VA8:
                                this.octaveSymbol = o.MusicSymbol.VA8;
                                break;
                            case n.OctaveEnum.VB8:
                                this.octaveSymbol = o.MusicSymbol.VB8;
                                break;
                            case n.OctaveEnum.MA15:
                                this.octaveSymbol = o.MusicSymbol.MA15;
                                break;
                            case n.OctaveEnum.MB15:
                                this.octaveSymbol = o.MusicSymbol.MB15;
                                break;
                            default:
                                throw new a.ArgumentOutOfRangeException("");
                        }
                    }
                }
                e.GraphicalOctaveShift = l;
            },
            7824 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.GraphicalPedal = void 0;
                const s = i(7741), n = i(6438), r = i(512);
                class o extends s.GraphicalObject {
                    constructor(t, e){
                        super(), this.getPedal = t, this.setSymbol(), this.PositionAndShape = new n.BoundingBox(this, e);
                    }
                    setSymbol() {
                        !this.getPedal.IsLine && this.getPedal.IsSign ? this.pedalSymbol = r.MusicSymbol.PEDAL_SYMBOL : this.getPedal.IsLine && this.getPedal.IsSign ? this.pedalSymbol = r.MusicSymbol.PEDAL_MIXED : this.pedalSymbol = r.MusicSymbol.PEDAL_BRACKET;
                    }
                }
                e.GraphicalPedal = o;
            },
            973 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.GraphicalRectangle = void 0;
                const s = i(6438), n = i(7741);
                class r extends n.GraphicalObject {
                    constructor(t, e, i, n){
                        super(), this.boundingBox = new s.BoundingBox(this, i), this.boundingBox.RelativePosition = t, this.boundingBox.BorderRight = e.x - t.x, this.boundingBox.BorderBottom = e.y - t.y, this.style = n;
                    }
                }
                e.GraphicalRectangle = r;
            },
            4022 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.GraphicalSlur = void 0;
                const n = i(9409), r = i(6711), o = i(6362), a = i(6904), l = i(4249), h = i(2561), c = i(1336), u = i(7499);
                var d = s(i(3206)).default.Flow;
                class f extends r.GraphicalCurve {
                    constructor(t, e){
                        super(), this.staffEntries = [], this.articulationCorners = [], this.articulationsOutside = [], this.labelsOutside = [], this.slur = t, this.rules = e;
                    }
                    static Compare(t, e) {
                        if (t.staffEntries.length < 1) return -1;
                        if (e.staffEntries.length < 1) return 1;
                        const i = h.Fraction.minus(t.staffEntries[t.staffEntries.length - 1].getAbsoluteTimestamp(), t.staffEntries[0].getAbsoluteTimestamp()), s = h.Fraction.minus(e.staffEntries[e.staffEntries.length - 1].getAbsoluteTimestamp(), e.staffEntries[0].getAbsoluteTimestamp());
                        return i.RealValue > s.RealValue ? 1 : s.RealValue > i.RealValue ? -1 : 0;
                    }
                    calculateCurve(t) {
                        const e = this.staffEntries[0], i = this.staffEntries[this.staffEntries.length - 1];
                        let s = e.findGraphicalNoteFromNote(this.slur.StartNote);
                        !s && this.graceStart && (s = e.findGraphicalNoteFromGraceNote(this.slur.StartNote)), s || (s = e.findEndTieGraphicalNoteFromNoteWithStartingSlur(this.slur.StartNote, this.slur));
                        let r = i.findGraphicalNoteFromNote(this.slur.EndNote);
                        !r && this.graceEnd && (r = i.findGraphicalNoteFromGraceNote(this.slur.EndNote));
                        const l = e.parentMeasure.ParentStaffLine, h = l.SkyBottomLineCalculator;
                        this.calculatePlacement(h, l);
                        const c = this.calculateStartAndEnd(s, r, l, t, h);
                        let u = c.startX, d = c.endX, f = c.startY, m = c.endY;
                        const p = 2 === this.staffEntries.length && void 0 !== s && void 0 !== r;
                        if (Math.abs(d - u) < 1e-4 && Math.abs(m - f) < 1e-4) return this.bezierStartPt = new n.PointF2D(u, f), this.bezierStartControlPt = new n.PointF2D(u, f), this.bezierEndControlPt = new n.PointF2D(d, m), void (this.bezierEndPt = new n.PointF2D(d, m));
                        const g = t.SlurTangentMinAngle, b = t.SlurTangentMaxAngle;
                        let S;
                        if (this.placement === o.PlacementEnum.Above) {
                            f -= t.SlurNoteHeadYOffset, m -= t.SlurNoteHeadYOffset;
                            const e = new n.PointF2D(this.staffEntries[0].parentMeasure.PositionAndShape.RelativePosition.x + this.staffEntries[0].PositionAndShape.RelativePosition.x, f);
                            s ? e.x += this.staffEntries[0].PositionAndShape.BorderRight : e.x = this.staffEntries[0].parentMeasure.beginInstructionsWidth, this.graceStart && (e.x += i.PositionAndShape.RelativePosition.x);
                            const o = new n.PointF2D(this.staffEntries[this.staffEntries.length - 1].parentMeasure.PositionAndShape.RelativePosition.x + this.staffEntries[this.staffEntries.length - 1].PositionAndShape.RelativePosition.x, m);
                            r ? o.x += this.staffEntries[this.staffEntries.length - 1].PositionAndShape.BorderLeft : this.slur.EndNote ? o.x = this.staffEntries[this.staffEntries.length - 1].parentMeasure.PositionAndShape.RelativePosition.x + this.staffEntries[this.staffEntries.length - 1].parentMeasure.PositionAndShape.Size.width : o.x = this.getUnattachedEndX(), this.graceEnd && (o.x += i.staffEntryParent.PositionAndShape.RelativePosition.x);
                            const c = this.placePastEndFingerings(s, !0, u, f, e.x, d, this.fingeringsRunInto?.start, p), y = this.placePastEndFingerings(r, !1, d, m, o.x, u, this.fingeringsRunInto?.end, p), E = c.x !== u || y.x !== d;
                            E && (e.x = Math.max(e.x, c.x), o.x = Math.min(o.x, y.x)), [u, f, d, m] = [
                                c.x,
                                c.y,
                                y.x,
                                y.y
                            ], e.y = f, o.y = m, S = this.calculateTopPoints(e, o, l, h);
                            const x = this.getObstacles(S, h).concat(this.articulationCorners);
                            if (0 === S.length) {
                                const t = new n.PointF2D((o.x - e.x) / 2 + e.x, (o.y - e.y) / 2 + e.y);
                                S.push(t);
                            }
                            const v = Math.atan((m - f) / (d - u)), T = new n.PointF2D(0, 0);
                            let _ = new n.PointF2D(d - u, -(m - f));
                            const M = a.Matrix2D.getRotationMatrix(v), P = M.getTransposeMatrix();
                            _ = M.vectorMultiplication(_);
                            const L = this.calculateTranslatedAndRotatedPointListAbove(S, u, f, M), w = this.calculateMaxLeftSlope(L, T, _), A = this.calculateMaxRightSlope(L, T, _), I = T.y - T.x * w, R = _.y - _.x * A, N = new n.PointF2D;
                            let C = !1;
                            Math.abs(Math.abs(w) - Math.abs(A)) < 1e-4 ? (N.x = _.x / 2, N.y = 0, C = !0) : (N.x = (R - I) / (w - A), N.y = w * N.x + I);
                            const B = this.calculateHeightWidthRatio(_.x, L), D = 0, O = 0;
                            let F = g, k = -g;
                            if (!C) {
                                const t = this.calculateAngles(g, w, A, b);
                                F = t.startAngle, k = t.endAngle;
                            }
                            const V = this.calculateControlPoints(_.x, F, k, L, B, f, m);
                            this.clearObstacles(V.startControlPoint, V.endControlPoint, _.x, this.calculateTranslatedAndRotatedPointListAbove(x, u, f, M), this.getFingeringCorners().map((t)=>this.calculateTranslatedAndRotatedPointListAbove(t, u, f, M)));
                            let G = V.startControlPoint, W = V.endControlPoint;
                            G = P.vectorMultiplication(G), G.x += u, G.y = -G.y + f, W = P.vectorMultiplication(W), W.x += u, W.y = -W.y + f, this.bezierStartPt = new n.PointF2D(u, f - D), this.bezierStartControlPt = new n.PointF2D(G.x, G.y - D), this.bezierEndControlPt = new n.PointF2D(W.x, W.y - O), this.bezierEndPt = new n.PointF2D(d, m - O);
                            const U = this.keepPassedArticulationsInside();
                            if (this.retryPastArticulationsOutside(t, U) || this.retryPastEndFingerings(t, s, r, e.x, o.x) || this.retryPastBesideFingerings(t, l, E, e.x, o.x)) return;
                            this.placeArticulationsOutside(l);
                            const z = l.SkyLine.length, H = h.getLeftIndexForPointX(this.bezierStartPt.x, z), X = h.getLeftIndexForPointX(this.bezierEndPt.x, z), Y = this.bezierEndPt.x - this.bezierStartPt.x, j = h.SamplingUnit;
                            for(let t = H; t < X; t++){
                                const e = t / j - this.bezierStartPt.x, i = this.calculateCurvePointAtIndex(Math.abs(e) / Y);
                                let s = h.getLeftIndexForPointX(i.x, z);
                                s >= H && (l.SkyLine[s] = Math.min(l.SkyLine[s], i.y)), s++, s < z && (l.SkyLine[s] = Math.min(l.SkyLine[s], i.y));
                            }
                        } else {
                            f += t.SlurNoteHeadYOffset, m += t.SlurNoteHeadYOffset;
                            const e = new n.PointF2D(this.staffEntries[0].parentMeasure.PositionAndShape.RelativePosition.x + this.staffEntries[0].PositionAndShape.RelativePosition.x, f);
                            s ? e.x += this.staffEntries[0].PositionAndShape.BorderRight : e.x = this.staffEntries[0].parentMeasure.beginInstructionsWidth, this.graceStart && (e.x += i.PositionAndShape.RelativePosition.x);
                            const o = new n.PointF2D(this.staffEntries[this.staffEntries.length - 1].parentMeasure.PositionAndShape.RelativePosition.x + this.staffEntries[this.staffEntries.length - 1].PositionAndShape.RelativePosition.x, m);
                            r ? o.x += this.staffEntries[this.staffEntries.length - 1].PositionAndShape.BorderLeft : this.slur.EndNote ? o.x = this.staffEntries[this.staffEntries.length - 1].parentMeasure.PositionAndShape.RelativePosition.x + this.staffEntries[this.staffEntries.length - 1].parentMeasure.PositionAndShape.Size.width : o.x = this.getUnattachedEndX(), this.graceEnd && (o.x += i.staffEntryParent.PositionAndShape.RelativePosition.x);
                            const c = this.placePastEndFingerings(s, !0, u, f, e.x, d, this.fingeringsRunInto?.start, p), y = this.placePastEndFingerings(r, !1, d, m, o.x, u, this.fingeringsRunInto?.end, p), E = c.x !== u || y.x !== d;
                            E && (e.x = Math.max(e.x, c.x), o.x = Math.min(o.x, y.x)), [u, f, d, m] = [
                                c.x,
                                c.y,
                                y.x,
                                y.y
                            ], e.y = f, o.y = m, S = this.calculateBottomPoints(e, o, l, h);
                            const x = this.getObstacles(S.filter((t)=>t.y !== l.BottomLineOffset), h).concat(this.articulationCorners);
                            if (0 === S.length) {
                                const t = new n.PointF2D((o.x - e.x) / 2 + e.x, (o.y - e.y) / 2 + e.y);
                                S.push(t);
                            }
                            const v = Math.atan((m - f) / (d - u)), T = new n.PointF2D(0, 0);
                            let _ = new n.PointF2D(d - u, m - f);
                            const M = a.Matrix2D.getRotationMatrix(-v), P = M.getTransposeMatrix();
                            _ = M.vectorMultiplication(_);
                            const L = this.calculateTranslatedAndRotatedPointListBelow(S, u, f, M), w = this.calculateMaxLeftSlope(L, T, _), A = this.calculateMaxRightSlope(L, T, _), I = T.y - T.x * w, R = _.y - _.x * A, N = new n.PointF2D;
                            let C = !1;
                            Math.abs(Math.abs(w) - Math.abs(A)) < 1e-4 ? (N.x = _.x / 2, N.y = 0, C = !0) : (N.x = (R - I) / (w - A), N.y = w * N.x + I);
                            const B = this.calculateHeightWidthRatio(_.x, L), D = 0, O = 0;
                            let F = g, k = -g;
                            if (!C) {
                                const t = this.calculateAngles(g, w, A, b);
                                F = t.startAngle, k = t.endAngle;
                            }
                            const V = this.calculateControlPoints(_.x, F, k, L, B, f, m);
                            this.clearObstacles(V.startControlPoint, V.endControlPoint, _.x, this.calculateTranslatedAndRotatedPointListBelow(x, u, f, M), this.getFingeringCorners().map((t)=>this.calculateTranslatedAndRotatedPointListBelow(t, u, f, M)));
                            let G = V.startControlPoint, W = V.endControlPoint;
                            G = P.vectorMultiplication(G), G.x += u, G.y += f, W = P.vectorMultiplication(W), W.x += u, W.y += f, this.bezierStartPt = new n.PointF2D(u, f + D), this.bezierStartControlPt = new n.PointF2D(G.x, G.y + D), this.bezierEndControlPt = new n.PointF2D(W.x, W.y + O), this.bezierEndPt = new n.PointF2D(d, m + O);
                            const U = this.keepPassedArticulationsInside();
                            if (this.retryPastArticulationsOutside(t, U) || this.retryPastEndFingerings(t, s, r, e.x, o.x) || this.retryPastBesideFingerings(t, l, E, e.x, o.x)) return;
                            this.placeArticulationsOutside(l);
                            const z = l.BottomLine.length, H = h.getLeftIndexForPointX(this.bezierStartPt.x, z), X = h.getLeftIndexForPointX(this.bezierEndPt.x, z), Y = this.bezierEndPt.x - this.bezierStartPt.x, j = h.SamplingUnit;
                            for(let t = H; t < X; t++){
                                const e = t / j - this.bezierStartPt.x, i = this.calculateCurvePointAtIndex(Math.abs(e) / Y);
                                let s = h.getLeftIndexForPointX(i.x, z);
                                s >= H && (l.BottomLine[s] = Math.max(l.BottomLine[s], i.y)), s++, s < z && (l.BottomLine[s] = Math.max(l.BottomLine[s], i.y));
                            }
                        }
                    }
                    calculateCurveCrossStaff(t) {
                        const e = t.GNote(this.slur.StartNote), i = t.GNote(this.slur.EndNote);
                        if (!e || !i) return !1;
                        const s = e.parentVoiceEntry?.parentStaffEntry?.parentMeasure?.ParentStaffLine, r = i.parentVoiceEntry?.parentStaffEntry?.parentMeasure?.ParentStaffLine;
                        if (!s || !r) return !1;
                        if (s.ParentMusicSystem !== r.ParentMusicSystem) return !1;
                        const a = s.ParentMusicSystem.PositionAndShape, l = this.positionRelativeToBox(e.PositionAndShape, a), h = this.positionRelativeToBox(i.PositionAndShape, a), c = s.PositionAndShape.RelativePosition, u = l.x - c.x, d = h.x - c.x, f = l.y - c.y, m = h.y - c.y, p = r.PositionAndShape.RelativePosition.y < s.PositionAndShape.RelativePosition.y, g = .5, b = t.SlurNoteHeadYOffset;
                        let S, y;
                        p ? (S = f - g - b, y = m + g + b, this.placement = o.PlacementEnum.Above) : (S = f + g + b, y = m - g - b, this.placement = o.PlacementEnum.Below);
                        const E = d - u, x = y - S, v = Math.sqrt(E * E + x * x), T = Math.max(t.SlurCrossStaffMinBow, Math.min(t.SlurCrossStaffMaxBow, v * t.SlurCrossStaffBowFactor)), _ = this.placement === o.PlacementEnum.Above ? -1 : 1;
                        return this.bezierStartPt = new n.PointF2D(u, S), this.bezierStartControlPt = new n.PointF2D(u + .25 * E, S + .25 * x + _ * T), this.bezierEndControlPt = new n.PointF2D(u + .75 * E, S + .75 * x + _ * T), this.bezierEndPt = new n.PointF2D(d, y), !0;
                    }
                    positionRelativeToBox(t, e) {
                        let i = 0, s = 0, r = t;
                        for(; r && r !== e;)i += r.RelativePosition.x, s += r.RelativePosition.y, r = r.Parent;
                        return new n.PointF2D(i, s);
                    }
                    calculateStartAndEnd(t, e, i, s, n) {
                        let r = 0, a = 0, l = 0, h = 0;
                        if (this.articulationCorners = [], this.articulationsOutside = [], this.labelsOutside = [], t) {
                            r = t.PositionAndShape.RelativePosition.x + t.parentVoiceEntry.parentStaffEntry.PositionAndShape.RelativePosition.x + t.parentVoiceEntry.parentStaffEntry.parentMeasure.PositionAndShape.RelativePosition.x, this.graceStart && (r += t.parentVoiceEntry.parentStaffEntry.staffEntryParent.PositionAndShape.RelativePosition.x);
                            const e = t.parentVoiceEntry;
                            this.placement === o.PlacementEnum.Above ? (a = e.PositionAndShape.RelativePosition.y + e.PositionAndShape.BorderTop, this.rules.SlurPlacementUseSkyBottomLine && (a = Math.min(h, e.parentStaffEntry.getSkylineMin()))) : (a = e.PositionAndShape.RelativePosition.y + e.PositionAndShape.BorderBottom, this.rules.SlurPlacementUseSkyBottomLine && (a = Math.max(h, e.parentStaffEntry.getBottomlineMax()))), a = this.getYPastArticulations(t, !0, r, a), e.parentVoiceEntry.StemDirection === c.StemDirectionType.Down && this.placement === o.PlacementEnum.Below && (r -= .5), e.parentVoiceEntry.StemDirection === c.StemDirectionType.Up && this.placement === o.PlacementEnum.Above && (r += .5);
                        } else r = 0;
                        if (e) {
                            l = e.PositionAndShape.RelativePosition.x + e.parentVoiceEntry.parentStaffEntry.PositionAndShape.RelativePosition.x + e.parentVoiceEntry.parentStaffEntry.parentMeasure.PositionAndShape.RelativePosition.x, this.graceEnd && (l += e.parentVoiceEntry.parentStaffEntry.staffEntryParent.PositionAndShape.RelativePosition.x);
                            const t = e.parentVoiceEntry;
                            this.placement === o.PlacementEnum.Above ? (h = t.PositionAndShape.RelativePosition.y + t.PositionAndShape.BorderTop, this.rules.SlurPlacementUseSkyBottomLine && (h = Math.min(h, t.parentStaffEntry.getSkylineMin()))) : (h = t.PositionAndShape.RelativePosition.y + t.PositionAndShape.BorderBottom, this.rules.SlurPlacementUseSkyBottomLine && (h = Math.max(h, t.parentStaffEntry.getBottomlineMax()))), h = this.getYPastArticulations(e, !1, l, h), t.parentVoiceEntry.StemDirection === c.StemDirectionType.Down && this.placement === o.PlacementEnum.Below && (l -= .5), t.parentVoiceEntry.StemDirection === c.StemDirectionType.Up && this.placement === o.PlacementEnum.Above && (l += .5);
                        } else l = this.slur.EndNote ? i.PositionAndShape.Size.width : this.getUnattachedEndX();
                        return t || e || (a = -1.5, h = -1.5), t || (a = this.placement === o.PlacementEnum.Above ? h - 1 : h + 1), e || (h = this.slur.EndNote ? this.placement === o.PlacementEnum.Above ? a - 1 : a + 1 : a), this.slur.startNoteHasMoreStartingSlurs() && this.slur.isSlurLonger() && (this.placement === o.PlacementEnum.Above ? a -= s.SlursStartingAtSameStaffEntryYOffset : a += s.SlursStartingAtSameStaffEntryYOffset), this.slur.endNoteHasMoreEndingSlurs() && this.slur.isSlurLonger() && (this.placement === o.PlacementEnum.Above ? h -= s.SlursStartingAtSameStaffEntryYOffset : h += s.SlursStartingAtSameStaffEntryYOffset), this.placement === o.PlacementEnum.Above ? (a = Math.min(a, 1.5), h = Math.min(h, 1.5)) : (a = Math.max(a, i.StaffHeight - 1.5), h = Math.max(h, i.StaffHeight - 1.5)), {
                            startX: r,
                            startY: a,
                            endX: l,
                            endY: h
                        };
                    }
                    getYPastArticulations(t, e, i, s) {
                        const r = t.vfnote?.[0], a = r?.getStave?.();
                        if (!a) return s;
                        const l = this.placement === o.PlacementEnum.Above, h = l ? -1 : 1, c = l ? d.Modifier.Position.ABOVE : d.Modifier.Position.BELOW, m = a.getYForLine(0), p = r.getModifiers().filter((t)=>(t.getCategory() === d.Articulation.CATEGORY && "abr" !== t.type || t.getCategory() === d.Ornament.CATEGORY) && t.getPosition() === c).map((t)=>{
                            const s = ()=>{
                                const e = t.getExtent(), [s, n] = [
                                    (e.top - m) / u.unitInPixels,
                                    (e.bottom - m) / u.unitInPixels
                                ];
                                return {
                                    left: i + e.left / u.unitInPixels,
                                    right: i + e.right / u.unitInPixels,
                                    near: l ? -n : s,
                                    far: l ? -s : n,
                                    inside: f.articulationsInsideSlur.includes(t.type)
                                };
                            };
                            return {
                                ...s(),
                                isStart: e,
                                articulation: t,
                                measure: s
                            };
                        });
                        p.sort((t, e)=>t.near - e.near);
                        const g = e ? this.clearingEveryArticulationAt?.start : this.clearingEveryArticulationAt?.end, b = p.findIndex((t)=>t.articulation.getCategory() === d.Ornament.CATEGORY);
                        let S = s * h;
                        for (const [i, s] of p.entries()){
                            const r = t.sourceNote.IsGraceNote || i < b;
                            if (!s.inside && !r && (!g || f.isFermata(s))) {
                                const s = p.slice(i);
                                this.articulationsOutside.push(...s), this.addLabelsOutside(t, e, s);
                                break;
                            }
                            S = Math.max(S, s.far), this.articulationCorners.push(new n.PointF2D(s.left, s.far * h), new n.PointF2D(s.right, s.far * h));
                        }
                        return S * h;
                    }
                    addLabelsOutside(t, e, i) {
                        const s = t.parentVoiceEntry.parentStaffEntry.parentMeasure.ParentStaffLine, n = (t.parentVoiceEntry.parentStaffEntry.FingeringEntries ?? []).map((t)=>{
                            const i = t.PositionAndShape;
                            return {
                                box: i,
                                isStart: e,
                                left: i.RelativePosition.x + i.BorderLeft,
                                right: i.RelativePosition.x + i.BorderRight,
                                isFingering: !0
                            };
                        }), r = s?.ParentMusicSystem;
                        if (this.placement === o.PlacementEnum.Above && s === r?.StaffLines[0]) for (const t of r.MeasureNumberLabels){
                            const i = t.PositionAndShape, r = i.RelativePosition.x - s.PositionAndShape.RelativePosition.x;
                            n.push({
                                box: i,
                                isStart: e,
                                left: r + i.BorderLeft,
                                right: r + i.BorderRight,
                                isFingering: !1
                            });
                        }
                        const a = Math.min(...i.map((t)=>t.left)), l = Math.max(...i.map((t)=>t.right));
                        for (const t of n)t.right > a && t.left < l && this.getOutwardExtent(t.box)[0] >= i[0].near && this.labelsOutside.push(t);
                    }
                    static isFermata(t) {
                        return t.articulation.type.startsWith("a@");
                    }
                    keepPassedArticulationsInside() {
                        const t = {
                            start: !1,
                            end: !1
                        };
                        for (const e of [
                            !0,
                            !1
                        ]){
                            const i = this.articulationsOutside.filter((t)=>t.isStart === e);
                            let s = 0;
                            for (const n of i){
                                const i = this.getDistanceBeyond(n.left, n.right, n.far);
                                if (i < 0) break;
                                i < this.rules.SlurNoteHeadYOffset - .1 && (t[e ? "start" : "end"] = !0), s++;
                            }
                            0 !== s && (this.articulationsOutside = this.articulationsOutside.filter((t)=>!i.slice(0, s).includes(t)), s === i.length && (this.labelsOutside = this.labelsOutside.filter((t)=>t.isStart !== e)));
                        }
                        return t;
                    }
                    getDistanceBeyond(t, e, i) {
                        const s = this.placement === o.PlacementEnum.Above ? -1 : 1;
                        let n = Number.POSITIVE_INFINITY;
                        for(let r = 0; r <= 200; r++){
                            const o = r < 200 ? this.calculateCurvePointAtIndex(r / 200) : this.bezierEndPt;
                            o.x >= t && o.x <= e && (n = Math.min(n, o.y * s - i));
                        }
                        return n;
                    }
                    retryPastArticulationsOutside(t, e) {
                        if (this.clearingEveryArticulationAt || this.fingeringsRunInto) return !1;
                        const i = (t)=>this.getShiftOutside(t) > 0 && this.getRiseOutside(t) > f.articulationOutsideSlurMaxRise, s = {
                            start: e.start || i(!0),
                            end: e.end || i(!1)
                        };
                        if (!s.start && !s.end) return !1;
                        this.clearingEveryArticulationAt = s;
                        try {
                            this.calculateCurve(t);
                        } finally{
                            this.clearingEveryArticulationAt = void 0;
                        }
                        return !0;
                    }
                    placeArticulationsOutside(t) {
                        const e = this.placement === o.PlacementEnum.Above ? -1 : 1;
                        for (const i of [
                            !0,
                            !1
                        ]){
                            const s = this.getShiftOutside(i);
                            if (s <= 0) continue;
                            let n, r = 0;
                            for (const o of this.articulationsOutside.filter((t)=>t.isStart === i)){
                                const i = n ? Math.max(o.near + s, n.newFar + o.near - n.far) : o.near + s;
                                let a = o.measure();
                                for(let t = 0; t < 8 && a.near < i - .001; t++){
                                    const t = Math.max(i - a.near, .1);
                                    o.articulation.setYShift((o.articulation.y_shift ?? 0) + t * e * u.unitInPixels), a = o.measure();
                                }
                                r = Math.max(r, a.near - o.near), n = {
                                    far: o.far,
                                    newFar: a.far
                                }, this.addToSkyBottomLine(t, a.left, a.right, a.far);
                            }
                            for (const s of this.labelsOutside.filter((t)=>t.isStart === i))s.box.RelativePosition.y += r * e, s.isFingering && this.addToSkyBottomLine(t, s.left, s.right, this.getOutwardExtent(s.box)[1]);
                        }
                    }
                    getShiftOutside(t) {
                        const e = this.articulationsOutside.filter((e)=>e.isStart === t);
                        for (const i of this.labelsOutside.filter((e)=>e.isStart === t))e.push({
                            left: i.left,
                            right: i.right,
                            near: this.getOutwardExtent(i.box)[0]
                        });
                        let i = 0;
                        if (e.length > 0) for (const t of this.getOuterEdge())for (const s of e)t.x >= s.left && t.x <= s.right && (i = Math.max(i, t.distance + f.articulationOutsideSlurDistance - s.near));
                        return i;
                    }
                    getRiseOutside(t) {
                        const e = this.articulationsOutside.filter((e)=>e.isStart === t && !f.isFermata(e)), i = this.getOuterEdge(), s = t ? i[0] : i[i.length - 1];
                        let n = 0;
                        for (const t of i)e.some((e)=>t.x >= e.left && t.x <= e.right) && (n = Math.max(n, t.distance - s.distance));
                        return n;
                    }
                    getOuterEdge() {
                        const t = this.placement === o.PlacementEnum.Above ? -1 : 1, [e, i, s, n] = [
                            this.bezierStartPt,
                            this.bezierStartControlPt,
                            this.bezierEndControlPt,
                            this.bezierEndPt
                        ], r = [];
                        for(let o = 0; o <= 200; o++){
                            const a = o / 200, [l, h, c, u] = [
                                (1 - a) * (1 - a) * (1 - a),
                                3 * (1 - a) * (1 - a) * a,
                                3 * (1 - a) * a * a,
                                a * a * a
                            ];
                            r.push({
                                x: l * e.x + h * i.x + c * s.x + u * n.x,
                                distance: (l * e.y + h * i.y + c * s.y + u * n.y) * t + .05 * (l + u) + .3 * (h + c)
                            });
                        }
                        return r;
                    }
                    addToSkyBottomLine(t, e, i, s) {
                        const n = this.placement === o.PlacementEnum.Above, r = n ? t.SkyLine : t.BottomLine, a = t.SkyBottomLineCalculator.SamplingUnit;
                        for(let t = Math.max(0, Math.floor(e * a)); t < Math.min(r.length, Math.ceil(i * a)); t++)r[t] = n ? Math.min(r[t], -s) : Math.max(r[t], s);
                    }
                    getUnattachedEndX() {
                        const t = this.staffEntries[this.staffEntries.length - 1].parentMeasure, e = t.PositionAndShape.RelativePosition.x + t.PositionAndShape.Size.width, i = this.staffEntries[0], s = i.parentMeasure.PositionAndShape.RelativePosition.x + i.PositionAndShape.RelativePosition.x + i.PositionAndShape.BorderRight + .8;
                        return Math.max(e - (t.endInstructionsWidth ?? 0), Math.min(s, e - .5));
                    }
                    calculatePlacement(t, e) {
                        if (this.rules.SlurPlacementFromXML && this.slur.PlacementXml !== o.PlacementEnum.NotYetDefined) return void (this.placement = this.slur.PlacementXml);
                        for(let t = 0, e = this.staffEntries.length; t < e; ++t)if (this.staffEntries[t].parentMeasure.hasMultipleVoices()) return void (this.slur.StartNote.ParentVoiceEntry.ParentVoice instanceof l.LinkedVoice || this.slur.EndNote?.ParentVoiceEntry.ParentVoice instanceof l.LinkedVoice ? this.placement = o.PlacementEnum.Below : this.placement = o.PlacementEnum.Above);
                        for(let t = 0, e = this.staffEntries.length; t < e; ++t)if (this.staffEntries[t].LyricsEntries.length > 0) return void (this.placement = o.PlacementEnum.Above);
                        const i = this.staffEntries[0], s = this.staffEntries[this.staffEntries.length - 1], n = i.graphicalVoiceEntries[0].parentVoiceEntry.StemDirection;
                        if (n === s.graphicalVoiceEntries[0].parentVoiceEntry.StemDirection) this.placement = n === c.StemDirectionType.Up ? o.PlacementEnum.Below : o.PlacementEnum.Above, this.rules.SlurPlacementAtStems && (this.placement = n === c.StemDirectionType.Up ? o.PlacementEnum.Above : o.PlacementEnum.Below);
                        else {
                            let n = i.PositionAndShape.BorderLeft + i.PositionAndShape.RelativePosition.x + i.parentMeasure.PositionAndShape.RelativePosition.x, r = s.PositionAndShape.BorderRight + s.PositionAndShape.RelativePosition.x + s.parentMeasure.PositionAndShape.RelativePosition.x;
                            this.graceStart && (n += s.PositionAndShape.RelativePosition.x), this.graceEnd && (r += s.staffEntryParent.PositionAndShape.RelativePosition.x);
                            const a = -1 * t.getSkyLineMinInRange(n, r), l = t.getBottomLineMaxInRange(n, r) - e.StaffHeight;
                            this.placement = l > a ? o.PlacementEnum.Above : o.PlacementEnum.Below;
                        }
                    }
                    retryPastEndFingerings(t, e, i, s, n) {
                        if (this.fingeringsRunInto) return !1;
                        const r = this.getFingeringsRunInto(e, this.bezierStartPt.x, s), o = this.getFingeringsRunInto(i, n, this.bezierEndPt.x);
                        if (0 === r.length && 0 === o.length) return !1;
                        this.fingeringsRunInto = {
                            start: r,
                            end: o,
                            furthestOut: this.getFurthestOut()
                        };
                        try {
                            this.calculateCurve(t);
                        } finally{
                            this.fingeringsRunInto = void 0;
                        }
                        return !0;
                    }
                    retryPastBesideFingerings(t, e, i, s, n) {
                        const r = this.fingeringsRunInto, o = void 0 === r?.notBeside;
                        if (!r || !1 === r.notBeside || o && !i) return !1;
                        const a = this.getDepthIntoEnds(e, s, n);
                        return !(o ? a <= 0 : a <= r.besideDepth - .1) && (r.besideDepth ?? (r.besideDepth = a), r.notBeside = o, this.calculateCurve(t), !0);
                    }
                    getDepthIntoEnds(t, e, i) {
                        const s = this.placement === o.PlacementEnum.Above, n = s ? -1 : 1, r = s ? t.SkyLine : t.BottomLine, a = t.SkyBottomLineCalculator.SamplingUnit, l = s ? 0 : t.StaffHeight, h = this.rules.SlurNoteHeadYOffset / 2, c = [
                            this.staffEntries[0],
                            this.staffEntries[this.staffEntries.length - 1]
                        ].flatMap((t)=>t.FingeringEntries ?? []).map(({ PositionAndShape: t })=>[
                                t.RelativePosition.x + t.BorderLeft,
                                t.RelativePosition.x + t.BorderRight
                            ]).concat(this.articulationsOutside.map((t)=>[
                                t.left,
                                t.right
                            ])).map(([t, e])=>[
                                Math.floor(t * a),
                                Math.ceil(e * a)
                            ]);
                        let u = 0;
                        for(let t = 0; t <= 100; t++){
                            const s = t < 100 ? this.calculateCurvePointAtIndex(t / 100) : this.bezierEndPt, o = Math.floor(s.x * a);
                            if (s.x > e && s.x < i || o < 0 || o >= r.length || c.some(([t, e])=>o >= t && o < e)) continue;
                            const d = r[o] * n;
                            d > l && (u = Math.max(u, d + h - s.y * n));
                        }
                        return u;
                    }
                    getFingeringsRunInto(t, e, i) {
                        const s = [];
                        for (const n of t?.parentVoiceEntry.parentStaffEntry.FingeringEntries ?? []){
                            const t = n.PositionAndShape;
                            if (this.isFingeringOutside(t)) continue;
                            const [r, o] = this.getOutwardExtent(t);
                            this.runsInto(t.RelativePosition.x + t.BorderLeft, t.RelativePosition.x + t.BorderRight, r, o, e, i, this.rules.SlurNoteHeadYOffset) && s.push(t);
                        }
                        return s;
                    }
                    isFingeringOutside(t) {
                        return this.labelsOutside.some((e)=>e.box === t);
                    }
                    runsInto(t, e, i, s, n, r, a) {
                        const l = this.placement === o.PlacementEnum.Above ? -1 : 1;
                        for(let o = 0; o <= 100; o++){
                            const h = o < 100 ? this.calculateCurvePointAtIndex(o / 100) : this.bezierEndPt;
                            if (h.x >= Math.max(n, t) && h.x <= Math.min(r, e) && h.y * l > i - a && h.y * l < s + a) return !0;
                        }
                        return !1;
                    }
                    getFurthestOut() {
                        const t = this.placement === o.PlacementEnum.Above ? -1 : 1;
                        let e = Number.NEGATIVE_INFINITY;
                        for(let i = 0; i <= 100; i++){
                            const s = i < 100 ? this.calculateCurvePointAtIndex(i / 100) : this.bezierEndPt;
                            e = Math.max(e, s.y * t);
                        }
                        return e;
                    }
                    getOutwardExtent(t) {
                        const e = t.RelativePosition.y + t.BorderTop, i = t.RelativePosition.y + t.BorderBottom;
                        return this.placement === o.PlacementEnum.Above ? [
                            -i,
                            -e
                        ] : [
                            e,
                            i
                        ];
                    }
                    placePastEndFingerings(t, e, i, s, r, a, l, h) {
                        if (!l?.length) return new n.PointF2D(i, s);
                        const u = e ? this.clearEndFingerings(t, i, r, s, l) : this.clearEndFingerings(t, r, i, s, l), d = t.parentVoiceEntry.parentVoiceEntry.StemDirection, f = this.placement === o.PlacementEnum.Above ? d !== c.StemDirectionType.Up : d !== c.StemDirectionType.Down, m = this.placement === o.PlacementEnum.Above ? -1 : 1, p = this.placement === o.PlacementEnum.Above ? 0 : t.parentVoiceEntry.parentStaffEntry.parentMeasure.ParentStaffLine.StaffHeight, g = this.staffEntries.slice(1, -1).some((t)=>(t.FingeringEntries ?? []).some((t)=>this.getOutwardExtent(t.PositionAndShape)[1] > p)), b = u * m > this.fingeringsRunInto.furthestOut && !g;
                        if (f && !this.fingeringsRunInto.notBeside && (h && Math.abs(u - s) > Math.abs(a - i) / 2 || b)) {
                            const t = .3, r = e ? Math.max(...l.map((t)=>t.RelativePosition.x + t.BorderRight)) + t : Math.min(...l.map((t)=>t.RelativePosition.x + t.BorderLeft)) - t;
                            if (Math.abs(r - i) <= 1.2 && (e ? a - r : r - a) >= 1.5) return new n.PointF2D(r, s);
                        }
                        return new n.PointF2D(i, u);
                    }
                    clearEndFingerings(t, e, i, s, n) {
                        if (!n?.length) return s;
                        const r = this.placement === o.PlacementEnum.Above ? -1 : 1, a = this.rules.SlurNoteHeadYOffset, l = (t.parentVoiceEntry.parentStaffEntry.FingeringEntries ?? []).map((t)=>t.PositionAndShape).filter((t)=>t.RelativePosition.x + t.BorderRight > e && t.RelativePosition.x + t.BorderLeft < i && !this.isFingeringOutside(t)).sort((t, e)=>this.getOutwardExtent(t)[0] - this.getOutwardExtent(e)[0]);
                        let h = s * r;
                        for (const t of l){
                            const [e, i] = this.getOutwardExtent(t);
                            (n.includes(t) || e < h + a && i > h - a) && (h = Math.max(h, i + a));
                        }
                        return h * r;
                    }
                    getObstacles(t, e) {
                        const i = .5 / e.SamplingUnit, s = [];
                        for (const e of t)s.push(new n.PointF2D(e.x - i, e.y), new n.PointF2D(e.x + i, e.y));
                        return s;
                    }
                    clearObstacles(t, e, i, s, n) {
                        const [r, o, a, l] = [
                            t.x,
                            e.x,
                            t.y,
                            e.y
                        ], h = n.map((s)=>this.getDepthIn(t, e, i, s)), c = t.y / t.x, u = e.y / (i - e.x), d = s.filter((t)=>t.x > 0 && t.x < i && t.y <= t.x * c && t.y <= (i - t.x) * u);
                        let f = this.getMisses(t, e, i, d), m = this.getRaisedControlPoints(t, e, i, f);
                        this.getCurveTop(m.startY, m.endY).height - this.getCurveTop(t.y, e.y).height > .5 && (this.steepenTangents(t, e, i, f), f = this.getMisses(t, e, i, d), m = this.getRaisedControlPoints(t, e, i, f)), t.y = m.startY, e.y = m.endY, n.some((s, n)=>this.getDepthIn(t, e, i, s) > h[n] + .05) && ([t.x, e.x, t.y, e.y] = [
                            r,
                            o,
                            a,
                            l
                        ]);
                    }
                    getFingeringCorners() {
                        const t = [];
                        for (const e of this.staffEntries.slice(1, -1))for (const i of e.FingeringEntries ?? []){
                            const e = i.PositionAndShape, [s, r] = [
                                e.RelativePosition.x + e.BorderLeft,
                                e.RelativePosition.x + e.BorderRight
                            ], [o, a] = [
                                e.RelativePosition.y + e.BorderTop,
                                e.RelativePosition.y + e.BorderBottom
                            ];
                            t.push([
                                new n.PointF2D(s, o),
                                new n.PointF2D(r, o),
                                new n.PointF2D(s, a),
                                new n.PointF2D(r, a)
                            ]);
                        }
                        return t;
                    }
                    getDepthIn(t, e, i, s) {
                        const n = s.map((t)=>t.x), r = s.map((t)=>t.y), [o, a, l, h] = [
                            Math.min(...n),
                            Math.max(...n),
                            Math.min(...r),
                            Math.max(...r)
                        ];
                        let c = 0;
                        for(let s = 1; s < 100; s++){
                            const n = s / 100, r = 3 * (1 - n) * (1 - n) * n * t.x + 3 * (1 - n) * n * n * e.x + n * n * n * i, u = 3 * (1 - n) * (1 - n) * n * t.y + 3 * (1 - n) * n * n * e.y;
                            r > o && r < a && (c = Math.max(c, Math.min(u - l, h - u)));
                        }
                        return c;
                    }
                    getMisses(t, e, i, s) {
                        const n = [];
                        for (const r of s){
                            let s = 0, o = 1;
                            for(let n = 0; n < 30; n++){
                                const n = (s + o) / 2;
                                3 * (1 - n) * (1 - n) * n * t.x + 3 * (1 - n) * n * n * e.x + n * n * n * i < r.x ? s = n : o = n;
                            }
                            const a = (s + o) / 2, l = 3 * (1 - a) * (1 - a) * a * t.y + 3 * (1 - a) * a * a * e.y, h = r.y + this.rules.SlurNoteHeadYOffset - l;
                            h > 0 && n.push({
                                t: a,
                                height: h,
                                obstacle: r
                            });
                        }
                        return n;
                    }
                    getRaisedControlPoints(t, e, i, s) {
                        let n = 0;
                        for (const t of s)t.t <= .5 && (n = Math.max(n, t.height / (3 * (1 - t.t) * (1 - t.t) * t.t)));
                        let r = 0;
                        for (const t of s)if (t.t > .5) {
                            const e = t.height - 3 * (1 - t.t) * (1 - t.t) * t.t * n;
                            r = Math.max(r, e / (3 * (1 - t.t) * t.t * t.t));
                        }
                        const o = Math.tan(this.rules.SlurTangentMaxAngle * f.degreesToRadiansFactor);
                        return {
                            startY: Math.max(t.y, Math.min(t.y + n, t.x * o)),
                            endY: Math.max(e.y, Math.min(e.y + r, (i - e.x) * o))
                        };
                    }
                    steepenTangents(t, e, i, s) {
                        const n = (t)=>3 * (1 - t) * (1 - t) * t, r = (t)=>3 * (1 - t) * t * t, o = (i)=>n(i) * t.y + r(i) * e.y, a = this.getCurveTop(t.y, e.y);
                        let l = t.x, h = e.x;
                        for (const c of s){
                            const s = c.obstacle.y + this.rules.SlurNoteHeadYOffset;
                            if (s >= a.height) continue;
                            let u = c.t <= a.t ? 0 : 1, d = a.t;
                            for(let t = 0; t < 30; t++){
                                const t = (u + d) / 2;
                                o(t) < s ? u = t : d = t;
                            }
                            const f = d;
                            c.t <= a.t ? l = Math.min(l, (c.obstacle.x - r(f) * e.x - f * f * f * i) / n(f)) : h = Math.max(h, (c.obstacle.x - n(f) * t.x - f * f * f * i) / r(f));
                        }
                        const c = Math.tan((this.rules.SlurTangentMaxAngle - 10) * f.degreesToRadiansFactor);
                        t.x = Math.min(t.x, Math.max(l, t.y / c, 0)), e.x = Math.max(e.x, Math.min(h, i - e.y / c, i));
                    }
                    getCurveTop(t, e) {
                        const i = {
                            t: .5,
                            height: 0
                        };
                        for(let s = 1; s < 100; s++){
                            const n = s / 100, r = 3 * (1 - n) * (1 - n) * n * t + 3 * (1 - n) * n * n * e;
                            r > i.height && (i.t = n, i.height = r);
                        }
                        return i;
                    }
                    calculateTopPoints(t, e, i, s) {
                        const r = [];
                        let o = s.getRightIndexForPointX(t.x, i.SkyLine.length), a = s.getLeftIndexForPointX(e.x, i.SkyLine.length);
                        o < 0 && (o = 0), a >= i.SkyLine.length && (a = i.SkyLine.length - 1);
                        for(let t = o; t < a; t++){
                            const e = i.SkyLine[t];
                            if (0 !== e) {
                                const i = new n.PointF2D((.5 + t) / s.SamplingUnit, e);
                                r.push(i);
                            }
                        }
                        return r;
                    }
                    calculateBottomPoints(t, e, i, s) {
                        const r = [];
                        let o = s.getRightIndexForPointX(t.x, i.BottomLine.length), a = s.getLeftIndexForPointX(e.x, i.BottomLine.length);
                        o < 0 && (o = 0), a >= i.BottomLine.length && (a = i.BottomLine.length - 1);
                        for(let t = o; t < a; t++){
                            const e = i.BottomLine[t];
                            if (0 !== e) {
                                const i = new n.PointF2D((.5 + t) / s.SamplingUnit, e);
                                r.push(i);
                            }
                        }
                        return r;
                    }
                    calculateMaxLeftSlope(t, e, i) {
                        let s = -Number.MAX_VALUE;
                        const n = e.x, r = e.y;
                        for(let e = 0; e < t.length; e++){
                            if (Math.abs(t[e].y - Number.MAX_VALUE) < 1e-4 || Math.abs(t[e].y - -Number.MAX_VALUE) < 1e-4) continue;
                            const i = (t[e].y - r) / (t[e].x - n);
                            Number.isNaN(i) || (s = Math.max(s, i));
                        }
                        const o = Math.abs(i.y - r) / (i.x - n);
                        return Number.isNaN(o) || (s = Math.max(s, o)), s = Math.min(s, 5.6713), s;
                    }
                    calculateMaxRightSlope(t, e, i) {
                        let s = Number.MAX_VALUE;
                        const n = i.x, r = i.y;
                        for(let e = 0; e < t.length; e++){
                            if (Math.abs(t[e].y - Number.MAX_VALUE) < 1e-4 || Math.abs(t[e].y - -Number.MAX_VALUE) < 1e-4) continue;
                            const i = (r - t[e].y) / (n - t[e].x);
                            Number.isNaN(i) || (s = Math.min(s, i));
                        }
                        const o = (r - e.y) / (n - e.x);
                        return Number.isNaN(o) || (s = Math.min(s, o)), s = Math.max(s, -5.6713), s;
                    }
                    getPointListMaxY(t) {
                        let e = -Number.MAX_VALUE;
                        for(let i = 0, s = t.length; i < s; ++i){
                            const s = t[i];
                            Math.abs(s.y - -Number.MAX_VALUE) < 1e-4 || Math.abs(s.y - Number.MAX_VALUE) < 1e-4 || (e = Math.max(e, s.y));
                        }
                        return e;
                    }
                    calculateTranslatedAndRotatedPointListAbove(t, e, i, s) {
                        const r = [];
                        for(let o = 0; o < t.length; o++){
                            if (Math.abs(t[o].y - Number.MAX_VALUE) < 1e-4 || Math.abs(t[o].y - -Number.MAX_VALUE) < 1e-4) continue;
                            let a = new n.PointF2D(t[o].x - e, -(t[o].y - i));
                            a = s.vectorMultiplication(a), r.push(a);
                        }
                        return r;
                    }
                    calculateTranslatedAndRotatedPointListBelow(t, e, i, s) {
                        const r = [];
                        for(let o = 0; o < t.length; o++){
                            if (Math.abs(t[o].y - Number.MAX_VALUE) < 1e-4 || Math.abs(t[o].y - -Number.MAX_VALUE) < 1e-4) continue;
                            let a = new n.PointF2D(t[o].x - e, t[o].y - i);
                            a = s.vectorMultiplication(a), r.push(a);
                        }
                        return r;
                    }
                    calculateHeightWidthRatio(t, e) {
                        return 0 === e.length ? 0 : Math.max(0, this.getPointListMaxY(e)) / t;
                    }
                    calculateControlPoints(t, e, i, s, r, o, a) {
                        let l = this.rules.SlurHeightFactor, h = 1;
                        const c = this.rules.SlurHeightFlattenLongSlursCutoffAngle, u = this.rules.SlurHeightFlattenLongSlursCutoffWidth;
                        e > c && t > u && (h += t / 70 * this.rules.SlurHeightFlattenLongSlursFactorByWidth, h *= 1 + e / 30 * this.rules.SlurHeightFlattenLongSlursFactorByAngle, l /= h);
                        const d = Math.min(.5, Math.max(.1, 1.7 * e / 80 * l * Math.pow(Math.max(r, .05), .4))), m = Math.min(.5, Math.max(.1, 1.7 * -i / 80 * l * Math.pow(Math.max(r, .05), .4))), p = new n.PointF2D;
                        p.x = t * d * Math.cos(e * f.degreesToRadiansFactor), p.y = t * d * Math.sin(e * f.degreesToRadiansFactor);
                        const g = new n.PointF2D;
                        if (g.x = t - t * m * Math.cos(i * f.degreesToRadiansFactor), g.y = -t * m * Math.sin(i * f.degreesToRadiansFactor), this.rules.SlurFlattenToObstacle) {
                            const e = Math.max(0, this.getPointListMaxY(s)), i = Math.min(this.rules.SlurFlattenMaxMinArcHeight, this.rules.SlurFlattenMinArcWidthFactor * Math.sqrt(t)), n = Math.max(e + this.rules.SlurFlattenToObstacleMargin, i);
                            let r = 0;
                            for(let t = .1; t <= .9; t += .1){
                                const e = 1 - t;
                                r = Math.max(r, 3 * e * e * t * p.y + 3 * e * t * t * g.y);
                            }
                            if (r > n && r > 1e-4) {
                                const e = n / r;
                                p.x *= e, p.y *= e, g.x = t - (t - g.x) * e, g.y *= e;
                            }
                        }
                        let b = p.y - g.y;
                        for(; this.rules.SlurMaximumYControlPointDistance && Math.abs(b) > this.rules.SlurMaximumYControlPointDistance;)b < 0 ? (p.y += 1, g.y -= 1) : (p.y -= 1, g.y += 1), b = p.y - g.y;
                        return {
                            startControlPoint: p,
                            endControlPoint: g
                        };
                    }
                    calculateAngles(t, e, i, s) {
                        let n = Math.atan(e) / f.degreesToRadiansFactor;
                        e > 0 ? n += 20 : n -= 20;
                        let r = Math.atan(i) / f.degreesToRadiansFactor;
                        return i < 0 ? r -= 20 : r += 20, {
                            startAngle: Math.min(Math.max(t, n), s),
                            endAngle: Math.max(Math.min(-t, r), -s)
                        };
                    }
                }
                e.GraphicalSlur = f, f.articulationsInsideSlur = [
                    "a.",
                    "av",
                    "a-"
                ], f.articulationOutsideSlurDistance = .3, f.articulationOutsideSlurMaxRise = .6, f.degreesToRadiansFactor = Math.PI / 180;
            },
            348 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.GraphicalStaffEntry = void 0;
                const s = i(6438), n = i(2561), r = i(7741), o = i(813), a = i(7921);
                class l extends r.GraphicalObject {
                    constructor(t, e, i){
                        super(), this.graphicalChordContainers = [], this.tabStaffEntry = void 0, this.MaxAccidentals = 0, this.graphicalInstructions = [], this.ties = [], this.graphicalTies = [], this.lyricsEntries = [], this.parentMeasure = t, this.graphicalVoiceEntries = [], this.sourceStaffEntry = e, i ? (this.staffEntryParent = i, this.parentVerticalContainer = i.parentVerticalContainer, this.PositionAndShape = new s.BoundingBox(this, i.PositionAndShape)) : this.PositionAndShape = new s.BoundingBox(this, t.PositionAndShape), e && (this.relInMeasureTimestamp = e.Timestamp), this.FingeringEntries = [];
                    }
                    get GraphicalInstructions() {
                        return this.graphicalInstructions;
                    }
                    get GraphicalTies() {
                        return this.graphicalTies;
                    }
                    get LyricsEntries() {
                        return this.lyricsEntries;
                    }
                    set LyricsEntries(t) {
                        this.lyricsEntries = t;
                    }
                    getAbsoluteTimestamp() {
                        const t = this.parentMeasure.parentSourceMeasure.AbsoluteTimestamp.clone();
                        return this.relInMeasureTimestamp && t.Add(this.relInMeasureTimestamp), t;
                    }
                    findTieGraphicalNoteFromNote(t) {
                        const e = !1 === t?.PrintObject ? t.visibleUnisonNoteSharingNotehead() ?? t : t, i = this.findGraphicalNoteFromNote(e);
                        if (i) return i;
                        for (const e of this.graphicalVoiceEntries)for (const i of e.notes){
                            const e = i.sourceNote;
                            if (!e.isRest() && e.Pitch.FundamentalNote === t.Pitch.FundamentalNote && e.Pitch.Octave === t.Pitch.Octave && e.getAbsoluteTimestamp().Equals(t.getAbsoluteTimestamp())) return i;
                        }
                    }
                    findEndTieGraphicalNoteFromNoteWithStartingSlur(t, e) {
                        if (t) {
                            for (const i of this.graphicalVoiceEntries)if (i.parentVoiceEntry === t.ParentVoiceEntry) for (const t of i.notes){
                                const i = t.sourceNote;
                                if (i.NoteTie && -1 !== i.NoteSlurs.indexOf(e)) return t;
                            }
                        }
                    }
                    findGraphicalNoteFromGraceNote(t) {
                        if (t) {
                            for (const e of this.graphicalVoiceEntries)if (e.parentVoiceEntry === t.ParentVoiceEntry) {
                                for (const i of e.notes)if (i.sourceNote === t) return i;
                            }
                        }
                    }
                    findGraphicalNoteFromNote(t) {
                        if (t) {
                            for (const e of this.graphicalVoiceEntries)if (e.parentVoiceEntry === t.ParentVoiceEntry) {
                                for (const i of e.notes)if (i.sourceNote === t && this.getAbsoluteTimestamp().Equals(t.getAbsoluteTimestamp())) return i;
                            }
                        }
                    }
                    getGraphicalNoteDurationFromVoice(t) {
                        for (const e of this.graphicalVoiceEntries)if (e.parentVoiceEntry.ParentVoice === t) return e.notes[0].graphicalNoteLength;
                        return new n.Fraction(0, 1);
                    }
                    findVoiceEntryGraphicalNotes(t) {
                        for (const e of this.graphicalVoiceEntries)if (e.parentVoiceEntry === t) return e.notes;
                    }
                    isVoiceEntryPartOfLinkedVoiceEntry(t) {
                        if (this.sourceStaffEntry.Link) for(let e = 0, i = this.sourceStaffEntry.Link.LinkStaffEntries.length; e < i; ++e){
                            const i = this.sourceStaffEntry.Link.LinkStaffEntries[e];
                            if (-1 !== i.VoiceEntries.indexOf(t) && i !== this.sourceStaffEntry) return !0;
                        }
                        return !1;
                    }
                    findStaffEntryMinNoteLength() {
                        let t = new n.Fraction(Number.MAX_VALUE, 1);
                        for (const e of this.graphicalVoiceEntries)for (const i of e.notes){
                            const e = i.graphicalNoteLength;
                            e.lt(t) && e.GetExpandedNumerator() > 0 && (t = e);
                        }
                        return t;
                    }
                    findStaffEntryMaxNoteLength() {
                        let t = new n.Fraction(0, 1);
                        for (const e of this.graphicalVoiceEntries)for (const i of e.notes){
                            const e = i.graphicalNoteLength;
                            t.lt(e) && e.GetExpandedNumerator() > 0 && (t = e);
                        }
                        return t;
                    }
                    findOrCreateGraphicalVoiceEntry(t) {
                        for (const e of this.graphicalVoiceEntries)if (e.parentVoiceEntry === t) return e;
                        const e = a.MusicSheetCalculator.symbolFactory.createVoiceEntry(t, this);
                        return this.graphicalVoiceEntries.push(e), e;
                    }
                    findOrCreateGraphicalVoiceEntryFromGraphicalNote(t) {
                        for (const e of this.graphicalVoiceEntries)if (e === t.parentVoiceEntry) return e;
                        const e = a.MusicSheetCalculator.symbolFactory.createVoiceEntry(t.sourceNote.ParentVoiceEntry, this);
                        return this.graphicalVoiceEntries.push(e), e;
                    }
                    addGraphicalNoteToListAtCorrectYPosition(t, e) {
                        const i = t.notes;
                        if (0 === i.length || e.PositionAndShape.RelativePosition.y < o.CollectionUtil.last(i).PositionAndShape.RelativePosition.y) i.push(e);
                        else for(let t = i.length - 1; t >= 0; t--){
                            if (i[t].PositionAndShape.RelativePosition.y > e.PositionAndShape.RelativePosition.y) {
                                i.splice(t + 1, 0, e);
                                break;
                            }
                            if (0 === t) {
                                i.splice(0, 0, e);
                                break;
                            }
                        }
                    }
                    hasOnlyRests() {
                        return this.sourceStaffEntry.hasOnlyRests;
                    }
                    getSkylineMin() {
                        const t = this.parentMeasure?.ParentStaffLine.SkyBottomLineCalculator;
                        if (!t) return;
                        const [e, i] = this.getAbsoluteStartAndEnd();
                        return t.getSkyLineMinInRange(e, i);
                    }
                    getHighestYAtEntry() {
                        return this.parentMeasure.ParentStaffLine.PositionAndShape.AbsolutePosition.y + this.getSkylineMin();
                    }
                    getLowestYAtEntry() {
                        return this.parentMeasure.ParentStaffLine.PositionAndShape.AbsolutePosition.y + this.getBottomlineMax();
                    }
                    getBottomlineMax() {
                        const t = this.parentMeasure?.ParentStaffLine.SkyBottomLineCalculator;
                        if (!t) return;
                        const [e, i] = this.getAbsoluteStartAndEnd();
                        return t.getBottomLineMaxInRange(e, i);
                    }
                    getAbsoluteStartAndEnd() {
                        let t = this.PositionAndShape.AbsolutePosition.x;
                        return t -= this.parentMeasure.ParentStaffLine.PositionAndShape.AbsolutePosition.x, [
                            t,
                            t + this.PositionAndShape.Size.width
                        ];
                    }
                }
                e.GraphicalStaffEntry = l;
            },
            9760 (t, e) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.GraphicalStaffEntryLink = void 0, e.GraphicalStaffEntryLink = class {
                    constructor(t){
                        this.graphicalLinkedStaffEntries = [], this.staffEntryLink = t, this.initialize();
                    }
                    get GetStaffEntryLink() {
                        return this.staffEntryLink;
                    }
                    get GraphicalLinkedStaffEntries() {
                        return this.graphicalLinkedStaffEntries;
                    }
                    set GraphicalLinkedStaffEntries(t) {
                        this.graphicalLinkedStaffEntries = t;
                    }
                    isFilled() {
                        for(let t = 0; t < this.graphicalLinkedStaffEntries.length; t++)if (!this.graphicalLinkedStaffEntries[t]) return !1;
                        return !0;
                    }
                    getLinkedStaffEntriesGraphicalNotes(t) {
                        if (-1 !== this.graphicalLinkedStaffEntries.indexOf(t)) {
                            const t = [];
                            for(let e = 0, i = this.graphicalLinkedStaffEntries.length; e < i; ++e){
                                const i = this.graphicalLinkedStaffEntries[e];
                                for (const e of i.graphicalVoiceEntries)for (const i of e.notes)i.sourceNote.ParentStaffEntry.Link && i.sourceNote.ParentVoiceEntry === this.staffEntryLink.GetVoiceEntry && t.push(i);
                            }
                            return t;
                        }
                    }
                    initialize() {
                        for(let t = 0, e = this.staffEntryLink.LinkStaffEntries.length; t < e; ++t)this.graphicalLinkedStaffEntries.push(void 0);
                    }
                };
            },
            5054 (t, e) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.GraphicalTie = void 0, e.GraphicalTie = class {
                    constructor(t, e, i){
                        this.vfTies = [], this.tie = t, this.startNote = e, this.endNote = i;
                    }
                    get SVGElement() {
                        return this.vfTie?.getAttribute("el");
                    }
                    get SVGElements() {
                        return this.vfTies.map((t)=>t.getAttribute("el")).filter((t)=>t);
                    }
                    get GetTie() {
                        return this.tie;
                    }
                    get StartNote() {
                        return this.startNote;
                    }
                    get Tie() {
                        return this.tie;
                    }
                    set StartNote(t) {
                        this.startNote = t;
                    }
                    get EndNote() {
                        return this.endNote;
                    }
                    set EndNote(t) {
                        this.endNote = t;
                    }
                };
            },
            5824 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.GraphicalUnknownExpression = void 0;
                const n = i(9490), r = i(6362), o = s(i(3065));
                class a extends n.AbstractGraphicalExpression {
                    constructor(t, e, i, s, n){
                        super(t, new r.AbstractExpression(i), s), this.label = e, this.sourceMultiExpression = n;
                    }
                    updateSkyBottomLine() {
                        const t = this.parentStaffLine.SkyBottomLineCalculator, e = this.label.PositionAndShape.RelativePosition.x + this.label.PositionAndShape.BorderMarginLeft, i = this.label.PositionAndShape.RelativePosition.x + this.label.PositionAndShape.BorderMarginRight;
                        switch(this.Placement){
                            case r.PlacementEnum.Above:
                                const s = this.label.PositionAndShape.BorderMarginTop + this.label.PositionAndShape.RelativePosition.y;
                                t.updateSkyLineWithLabel(e, i, s);
                                break;
                            case r.PlacementEnum.Below:
                                const n = this.label.PositionAndShape.BorderMarginBottom + this.label.PositionAndShape.RelativePosition.y;
                                t.updateBottomLineWithLabel(e, i, n);
                                break;
                            default:
                                o.default.error("Placement for GraphicalUnknownExpression is unknown");
                        }
                    }
                }
                e.GraphicalUnknownExpression = a;
            },
            4548 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.GraphicalVoiceEntry = void 0;
                const s = i(7741), n = i(6438), r = i(9713);
                class o extends s.GraphicalObject {
                    constructor(t, e, i){
                        super(), this.parentVoiceEntry = t, this.parentStaffEntry = e, this.PositionAndShape = new n.BoundingBox(this, e ? e.PositionAndShape : void 0, !0), this.notes = [], this.rules = i || (e ? e.parentMeasure.parentSourceMeasure.Rules : new r.EngravingRules);
                    }
                    sort() {
                        return this.notes.sort((t, e)=>(e.sourceNote.Pitch?.getHalfTone() ?? 0) - (t.sourceNote.Pitch?.getHalfTone() ?? 0)), this.notes;
                    }
                    sortForVexflow() {
                        return this.notes.sort((t, e)=>(t.sourceNote.Pitch?.getHalfTone() ?? 0) - (e.sourceNote.Pitch.getHalfTone() ?? 0)), this.notes;
                    }
                    applyCustomNoteheads() {}
                    color() {}
                }
                e.GraphicalVoiceEntry = o;
            },
            7753 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.GraphicalWavyLine = void 0;
                const s = i(6438), n = i(7741);
                class r extends n.GraphicalObject {
                    constructor(t, e){
                        super(), this.getWavyLine = t, this.PositionAndShape = new s.BoundingBox(this, e);
                    }
                }
                e.GraphicalWavyLine = r;
            },
            7225 (t, e) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
            },
            7921 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.MusicSheetCalculator = void 0;
                const n = i(8724), r = i(2561), o = i(1850), a = i(5748), l = i(164), h = i(437), c = i(1336), u = i(1645), d = i(7066), f = i(9409), m = i(2369), p = i(8254), g = i(7533), b = i(4543), S = i(3123), y = i(4249), E = i(6438), x = i(8033), v = i(8927), T = i(164), _ = i(4064), M = s(i(3065)), P = i(6452), L = i(7435), w = i(3236), A = i(6362), I = i(3361), R = i(9161), N = i(2221), C = i(5875), B = i(1066), D = i(624), O = i(5824), F = i(5534), k = i(9647);
                class V {
                    constructor(){
                        this.staffEntriesWithGraphicalTies = [], this.staffEntriesWithOrnaments = [], this.staffEntriesWithChordSymbols = [], this.staffLinesWithLyricWords = [], this.graphicalLyricWords = [], this.skyBottomLineCache = new Map, this.abstractNotImplementedErrorMessage = "abstract, not implemented", this.dynamicExpressionMap = new Map;
                    }
                    static get TextMeasurer() {
                        return V.textMeasurer;
                    }
                    static set TextMeasurer(t) {
                        V.textMeasurer = t;
                    }
                    get leadSheet() {
                        return this.graphicalMusicSheet.LeadSheet;
                    }
                    static setMeasuresMinStaffEntriesWidth(t, e) {
                        for(let i = 0, s = t.length; i < s; ++i){
                            const s = t[i];
                            s && (s.minimumStaffEntriesWidth = e);
                        }
                    }
                    initialize(t) {
                        this.graphicalMusicSheet = t, this.rules = t.ParentMusicSheet.Rules, this.rules.clearMusicSheetObjects(), this.prepareGraphicalMusicSheet();
                    }
                    prepareGraphicalMusicSheet() {
                        const t = this.graphicalMusicSheet.ParentMusicSheet;
                        this.staffEntriesWithGraphicalTies = [], this.staffEntriesWithOrnaments = [], this.staffEntriesWithChordSymbols = [], this.staffLinesWithLyricWords = [], this.graphicalMusicSheet.Initialize();
                        const e = this.graphicalMusicSheet.MeasureList, i = this.createAccidentalCalculators(), s = this.graphicalMusicSheet.initializeActiveClefs(), n = [], r = t.getCompleteNumberOfStaves(), o = [];
                        for(let t = 0; t < r; t++)o.push(void 0);
                        for(let r = 0, a = t.SourceMeasures.length; r < a; ++r){
                            const a = t.SourceMeasures[r], l = this.createGraphicalMeasuresForSourceMeasure(a, i, n, o, s);
                            if (e.push(l), a.multipleRestMeasures > 0 && this.rules.RenderMultipleRestMeasures) {
                                a.isReducedToMultiRest = !0, a.multipleRestMeasureNumber = 1;
                                const i = a.multipleRestMeasures - 1;
                                r += i;
                                for(let s = 1; s <= i; s++){
                                    const i = t.SourceMeasures.indexOf(a) + s;
                                    if (i >= t.SourceMeasures.length) break;
                                    const n = t.SourceMeasures[i];
                                    n.multipleRestMeasureNumber = s + 1, n.isReducedToMultiRest = !0, e.push([
                                        void 0
                                    ]);
                                }
                            }
                        }
                        if (this.rules.AutoGenerateMultipleRestMeasuresFromRestMeasures && this.rules.RenderMultipleRestMeasures) {
                            let r, a = 0;
                            for(let l = 0, h = t.SourceMeasures.length; l < h; ++l){
                                const h = t.SourceMeasures[l], c = !h.isReducedToMultiRest && h.canBeReducedToMultiRest();
                                if (a > 0 && (!c || h.hasBeginInstructions())) {
                                    if (a > 1) {
                                        r.multipleRestMeasures = a;
                                        const t = this.createGraphicalMeasuresForSourceMeasure(r, i, n, o, s);
                                        e[r.measureListIndex] = t;
                                    }
                                    a = 0, r = void 0;
                                }
                                if (c) {
                                    if (a > 0) {
                                        r.isReducedToMultiRest = !0, r.multipleRestMeasureNumber = 1, a++, h.multipleRestMeasureNumber = a, h.isReducedToMultiRest = !0;
                                        for(let t = 0; t < e[l].length; t++)e[l][t] = void 0;
                                    } else r = h, a = 1;
                                }
                            }
                            if (a > 1) {
                                r.multipleRestMeasures = a, r.isReducedToMultiRest = !0;
                                const t = this.createGraphicalMeasuresForSourceMeasure(r, i, n, o, s);
                                e[r.measureListIndex] = t, a = 0, r = void 0;
                            }
                        }
                        const a = s.map((t)=>t.ClefType === l.ClefEnum.percussion);
                        this.handleStaffEntries(a), this.calculateVerticalContainersList(), this.setIndicesToVerticalGraphicalContainers();
                    }
                    calculate() {
                        this.musicSystems = [], this.clearSystemsAndMeasures(), this.clearRecreatedObjects(), this.createGraphicalTies(), this.calculateSheetLabelBoundingBoxes(), this.calculateXLayout(this.graphicalMusicSheet, this.maxInstrNameLabelLength()), this.graphicalMusicSheet.MusicPages.length = 0, this.calculateMusicSystems(), n.GraphicalMusicSheet.transformRelativeToAbsolutePosition(this.graphicalMusicSheet);
                    }
                    clearSkyBottomLineCache() {
                        this.skyBottomLineCache.clear();
                    }
                    skyBottomLineCacheKey(t, e) {
                        const i = t.Measures, s = i[0], n = i[i.length - 1];
                        if (s && n) return s.MeasureNumber + ":" + n.MeasureNumber + ":" + e;
                    }
                    calculateXLayout(t, e) {
                        if (this.graphicalMusicSheet.MeasureList.length > 0) {
                            let t, e = 0, i = 1;
                            for(let s = 0; s < this.graphicalMusicSheet.MeasureList.length; s++){
                                t = this.graphicalMusicSheet.MeasureList[s];
                                let n = this.calculateMeasureXLayout(t);
                                n = this.calculateMeasureWidthFromStaffEntries(t, n), n > e && (e = n);
                                const r = this.graphicalMusicSheet.ParentMusicSheet.MeasureWidthFactor;
                                for (const e of t)if (e?.parentSourceMeasure.WidthFactor) {
                                    i = e.parentSourceMeasure.WidthFactor;
                                    break;
                                }
                                n *= r * i, V.setMeasuresMinStaffEntriesWidth(t, n);
                            }
                            if (this.rules.FixedMeasureWidth) {
                                let i = e;
                                this.rules.FixedMeasureWidthFixedValue && (i = this.rules.FixedMeasureWidthFixedValue);
                                for(let e = 0; e < this.graphicalMusicSheet.MeasureList.length; e++)t = this.graphicalMusicSheet.MeasureList[e], !this.rules.FixedMeasureWidthUseForPickupMeasures && t[0]?.parentSourceMeasure.ImplicitMeasure || V.setMeasuresMinStaffEntriesWidth(t, i);
                            }
                        }
                    }
                    calculateMeasureWidthFromStaffEntries(t, e) {
                        throw new Error(this.abstractNotImplementedErrorMessage);
                    }
                    formatMeasures() {
                        throw new Error(this.abstractNotImplementedErrorMessage);
                    }
                    calculateMeasureXLayout(t) {
                        throw new Error(this.abstractNotImplementedErrorMessage);
                    }
                    initGraphicalMeasuresCreation() {
                        throw new Error(this.abstractNotImplementedErrorMessage);
                    }
                    handleBeam(t, e, i) {
                        throw new Error(this.abstractNotImplementedErrorMessage);
                    }
                    handleTiedGraphicalNote(t, e, i, s, n, r, o, a) {
                        throw new Error(this.abstractNotImplementedErrorMessage);
                    }
                    handleVoiceEntryLyrics(t, e, i) {
                        throw new Error(this.abstractNotImplementedErrorMessage);
                    }
                    handleVoiceEntryOrnaments(t, e, i) {
                        throw new Error(this.abstractNotImplementedErrorMessage);
                    }
                    handleVoiceEntryArticulations(t, e, i) {
                        throw new Error(this.abstractNotImplementedErrorMessage);
                    }
                    handleVoiceEntryTechnicalInstructions(t, e, i) {
                        throw new Error(this.abstractNotImplementedErrorMessage);
                    }
                    handleTuplet(t, e, i) {
                        throw new Error(this.abstractNotImplementedErrorMessage);
                    }
                    layoutVoiceEntry(t, e, i, s) {
                        throw new Error(this.abstractNotImplementedErrorMessage);
                    }
                    layoutStaffEntry(t) {
                        throw new Error(this.abstractNotImplementedErrorMessage);
                    }
                    createGraphicalTie(t, e, i, s, n) {
                        throw new Error(this.abstractNotImplementedErrorMessage);
                    }
                    updateStaffLineBorders(t) {
                        throw new Error(this.abstractNotImplementedErrorMessage);
                    }
                    calculateMeasureNumberPlacement(t) {
                        const e = t.StaffLines[0];
                        if (!e || !e.Measures[0]) return void M.default.warn("calculateMeasureNumberPlacement: measure undefined for system.Id " + t.Id);
                        let i = e.Measures[0].MeasureNumber, s = 0, n = !1;
                        for(let r = 0; r < e.Measures.length; r++){
                            const o = e.Measures[r];
                            let a = this.rules.RenderMeasureNumbersOnlyAtSystemStart && r >= 1;
                            if (1 === r && e.Measures[0].parentSourceMeasure.ImplicitMeasure && !n && (a = !1, this.rules.RenderMeasureNumbersOnlyAtSystemStart && (i = o.MeasureNumber)), a) return;
                            0 !== o.MeasureNumber && 1 !== o.MeasureNumber || (i = o.MeasureNumber), s = o !== e.Measures[0] && this.rules.MeasureNumberLabelXOffset ? this.rules.MeasureNumberLabelXOffset : 0;
                            const l = this.rules.UseXMLMeasureNumbers && 1 === o.MeasureNumber && 1 !== o.parentSourceMeasure.getPrintedMeasureNumber(), h = o.parentSourceMeasure, c = !(void 0 !== h && (h.ImplicitMeasure || h.ImplicitMeasureFromXml)) || this.rules.RenderMeasureNumbersForImplicitMeasures;
                            (o.MeasureNumber === i || o.MeasureNumber >= i + this.rules.MeasureNumberLabelOffset || l) && c && ((1 !== o.MeasureNumber || 1 === o.MeasureNumber && o !== e.Measures[0] || l) && (this.calculateSingleMeasureNumberPlacement(o, e, t, s), n = !0), i = o.MeasureNumber);
                        }
                    }
                    calculateSingleMeasureNumberPlacement(t, e, i, s = 0) {
                        const n = t.parentSourceMeasure.getPrintedMeasureNumber().toString(), r = new L.Label(n), o = new p.GraphicalLabel(r, this.rules.MeasureNumberLabelHeight, g.TextAlignmentEnum.LeftBottom, this.rules), a = e.SkyBottomLineCalculator;
                        o.setLabelPositionAndShapeBorders(), o.PositionAndShape.Parent = i.PositionAndShape;
                        const l = e.PositionAndShape.RelativePosition.x + t.PositionAndShape.RelativePosition.x - o.PositionAndShape.BorderMarginLeft + s;
                        let h, c = l, u = l - o.PositionAndShape.BorderLeft + o.PositionAndShape.BorderRight;
                        c -= e.PositionAndShape.RelativePosition.x, u -= e.PositionAndShape.RelativePosition.x;
                        const d = c + .5, m = u - .5, b = a.getSkyLineMinInRange(d, m);
                        if (t === e.Measures[0]) {
                            let e = 0;
                            if (i.GroupBrackets.length > 0) for (const t of i.GroupBrackets)e = Math.min(e, t.PositionAndShape.BorderTop);
                            else t.ParentStaff.ParentInstrument.Parent && (e = -1);
                            h = Math.min(b, e);
                        } else h = b;
                        h = Math.min(0, h), o.PositionAndShape.RelativePosition = new f.PointF2D(l, h), i.MeasureNumberLabels.push(o);
                    }
                    calculateMeasureNumberSkyline(t) {
                        const e = t.StaffLines[0];
                        for (const i of t.MeasureNumberLabels){
                            let t = i.PositionAndShape.RelativePosition.x, s = t - i.PositionAndShape.BorderLeft + i.PositionAndShape.BorderRight;
                            t -= e.PositionAndShape.RelativePosition.x, s -= e.PositionAndShape.RelativePosition.x, e.SkyBottomLineCalculator.updateSkyLineInRange(t, s, i.PositionAndShape.RelativePosition.y + i.PositionAndShape.BorderMarginTop);
                        }
                    }
                    layoutGraphicalTie(t, e, i) {
                        throw new Error(this.abstractNotImplementedErrorMessage);
                    }
                    calculateSingleStaffLineLyricsPosition(t, e) {
                        let i = 0, s = this.rules.StaffHeight;
                        const n = new Map, r = [], o = t.SkyBottomLineCalculator;
                        let a = t.Measures.length;
                        for(let e = 0; e < a; ++e){
                            const a = t.Measures[e], l = a.PositionAndShape.RelativePosition, h = a.staffEntries.length;
                            for(let t = 0; t < h; ++t){
                                const e = a.staffEntries[t], h = e.LyricsEntries.length;
                                for(let t = 0; t < h; ++t){
                                    const i = e.LyricsEntries[t].LyricsEntry;
                                    n[i.VerseNumber] = i.IsChorus;
                                }
                                if (h > 0) {
                                    r.push(e), i = Math.max(i, e.LyricsEntries.length);
                                    const t = e.PositionAndShape.RelativePosition.x + l.x;
                                    let n = Number.MAX_VALUE, a = Number.MIN_VALUE;
                                    for(let i = 0; i < e.LyricsEntries.length; i++){
                                        const s = e.LyricsEntries[i].GraphicalLabel, r = t + s.PositionAndShape.RelativePosition.x;
                                        n = Math.min(n, r + s.PositionAndShape.BorderMarginLeft), a = Math.max(a, r + s.PositionAndShape.BorderMarginRight);
                                    }
                                    const h = o.getBottomLineMaxInRange(n, a);
                                    s = Math.max(s, h + this.rules.LyricsYMarginToBottomLine);
                                }
                            }
                        }
                        let l = 0;
                        a = r.length;
                        for (const t of r){
                            const i = [];
                            let r = !0;
                            for(let e = 0; e < t.LyricsEntries.length; e++)r && (r = t.LyricsEntries[e].LyricsEntry.IsChorus);
                            for (const t of e)n[t] === r && i.push(t);
                            for(let e = 0; e < t.LyricsEntries.length; e++){
                                const n = t.LyricsEntries[e], r = n.GraphicalLabel, o = n.LyricsEntry.VerseNumber, a = i.indexOf(o), h = s + this.rules.LyricsHeight + this.rules.VerticalBetweenLyricsDistance + this.rules.LyricsYOffsetToStaffHeight + (this.rules.VerticalBetweenLyricsDistance + this.rules.LyricsHeight) * a, c = r.PositionAndShape.RelativePosition.x, u = h + n.HeightBelowVerseLine;
                                r.PositionAndShape.RelativePosition = new f.PointF2D(c, u), r.Label.fontStyle = n.LyricsEntry.FontStyle, l = Math.max(l, u);
                            }
                        }
                        if (r.length > 0) {
                            const e = t.PositionAndShape.Size.width;
                            let i = r[0].PositionAndShape.RelativePosition.x + r[0].PositionAndShape.BorderMarginLeft + r[0].parentMeasure.PositionAndShape.RelativePosition.x;
                            i = i > e ? e : i, o.updateBottomLineInRange(i, e, l);
                        }
                        return r;
                    }
                    calculateLyricsExtendsAndDashes(t) {
                        for(let e = 0, i = t.length; e < i; ++e){
                            const i = t[e];
                            for(let t = 0; t < i.LyricsEntries.length; t++){
                                const e = i.LyricsEntries[t];
                                e.ParentLyricWord && e.ParentLyricWord.GraphicalLyricsEntries[e.ParentLyricWord.GraphicalLyricsEntries.length - 1] !== e && this.calculateSingleLyricWord(e), e.LyricsEntry.extend && this.calculateLyricExtend(e);
                            }
                        }
                    }
                    calculateSingleOctaveShift(t, e, i, s) {
                        throw new Error(this.abstractNotImplementedErrorMessage);
                    }
                    calculateWordRepetitionInstruction(t, e) {
                        throw new Error(this.abstractNotImplementedErrorMessage);
                    }
                    calculateMoodAndUnknownExpression(t, e, i) {
                        const s = t.AbsoluteTimestamp, n = this.graphicalMusicSheet.MeasureList[e];
                        let r = new f.PointF2D;
                        const o = t.UnknownList[0]?.defaultYXml;
                        if (t.MoodList.length > 0 || t.UnknownList.length > 0) {
                            let e = "";
                            for(let i = 0, s = t.EntriesList.length; i < s; ++i){
                                const s = t.EntriesList[i];
                                "" !== s.prefix && (e += "" === e ? s.prefix : " " + s.prefix), e += "" === e ? s.label : " " + s.label;
                            }
                            const a = n[i].ParentStaffLine;
                            if (!a) return void M.default.debug("MusicSheetCalculator.calculateMoodAndUnknownExpression: staffLine undefined. Returning.");
                            r = this.getRelativePositionInStaffLineFromTimestamp(s, i, a, a?.isPartOfMultiStaffInstrument()), Math.abs(r.x - 0) < 1e-4 && (r.x = n[i].beginInstructionsWidth + this.rules.RhythmRightMargin);
                            const l = this.rules.UnknownTextHeight, h = t.getPlacementOfFirstEntry(), c = this.calculateLabel(a, r, e, t.getFontstyleOfFirstEntry(), h, l), u = t.getColorXMLOfFirstEntry();
                            if (this.rules.ExpressionsUseXMLColor && u && (c.ColorXML = u), c.Label.language = t.EntriesList[0]?.expression.language, this.rules.PlaceWordsInsideStafflineFromXml && o < 0 && o > -50) {
                                let t = o / 10;
                                t += this.rules.PlaceWordsInsideStafflineYOffset, c.PositionAndShape.RelativePosition.y = t;
                            }
                            new O.GraphicalUnknownExpression(a, c, h, n[i]?.parentSourceMeasure, t);
                        }
                    }
                    clearRecreatedObjects() {
                        for(let t = 0, e = this.staffEntriesWithGraphicalTies.length; t < e; ++t)this.staffEntriesWithGraphicalTies[t].GraphicalTies.length = 0;
                        this.staffEntriesWithGraphicalTies.length = 0;
                        for (const t of this.graphicalMusicSheet.ParentMusicSheet.Instruments)for (const e of t.Voices)for (const t of e.VoiceEntries){
                            const e = t.Notes[0]?.NoteTuplet;
                            e && !e.RenderTupletNumber && (e.RenderTupletNumber = !0);
                        }
                        for (const t of this.graphicalMusicSheet.MeasureList)for (const e of t)for (const t of e?.staffEntries ?? []){
                            for (const e of t.graphicalChordContainers)e.resetPosition();
                            for (const e of t.LyricsEntries)e.resetPosition();
                        }
                    }
                    handleStaffEntryLink(t, e) {
                        M.default.debug("handleStaffEntryLink not implemented");
                    }
                    calculateMusicSystems() {
                        if (!this.graphicalMusicSheet.MeasureList) return;
                        const t = this.graphicalMusicSheet.MeasureList;
                        if (!t) return;
                        this.rules.MinMeasureToDrawIndex > t.length - 1 && (M.default.debug("minimum measure to draw index out of range. resetting min measure index to limit."), this.rules.MinMeasureToDrawIndex = t.length - 1);
                        const e = [];
                        for(let i = this.rules.MinMeasureToDrawIndex, s = t.length; i < s && i <= this.rules.MaxMeasureToDrawIndex; ++i){
                            const s = [];
                            for(let e = 0, n = t[i].length; e < n; ++e){
                                const n = t[i][e];
                                if (n?.isVisible() && (s.push(n), this.rules.ColoringEnabled)) for (const t of n.staffEntries)for (const e of t.graphicalVoiceEntries)e.applyCustomNoteheads(), e.color();
                            }
                            e.push(s);
                        }
                        let i = 0;
                        for(let t = 0, s = e.length; t < s; ++t){
                            const s = e[t];
                            i = Math.max(s.length, i);
                            break;
                        }
                        if (0 === i) return;
                        const s = new d.MusicSystemBuilder;
                        if (s.initialize(this.graphicalMusicSheet, e, i), this.musicSystems = s.buildMusicSystems(), this.formatMeasures(), this.leadSheet || (this.optimizeRestPlacement(), this.calculateStaffEntryArticulationMarks(), this.rules.RenderSlurs && this.calculateTieCurves()), this.calculateSkyBottomLines(), this.calculateTupletNumbers(), this.reserveSkylineForMeasureRepeats(), this.rules.RenderMeasureNumbers) for(let t = 0, e = this.musicSystems.length; t < e; ++t){
                            const e = this.musicSystems[t];
                            this.calculateMeasureNumberPlacement(e);
                        }
                        if (this.rules.RenderFingerings && this.calculateFingerings(), !this.leadSheet && this.rules.RenderSlurs && this.calculateSlurs(), this.calculateGlissandi(), this.rules.RenderMeasureNumbers) for(let t = 0, e = this.musicSystems.length; t < e; ++t){
                            const e = this.musicSystems[t];
                            this.calculateMeasureNumberSkyline(e);
                        }
                        this.leadSheet || (this.calculateOrnaments(), this.calculateOctaveShifts()), this.calculateChordSymbols(), this.leadSheet || (this.calculateDynamicExpressions(), this.calculateExpressionAlignements(), this.calculateMoodAndUnknownExpressions(), this.rules.RenderPedals && this.calculatePedals(), this.rules.RenderWavyLines && this.calculateWavyLines()), this.calculateRepetitionEndings(), this.leadSheet || (this.calculateTempoExpressions(), this.calculateWordRepetitionInstructions()), this.calculateRehearsalMarks(), this.calculateLyricsPosition();
                        for(let t = 0, e = this.musicSystems.length; t < e; ++t){
                            const e = this.musicSystems[t];
                            for(let t = 0, i = e.StaffLines.length; t < i; ++t){
                                const i = e.StaffLines[t];
                                this.updateStaffLineBorders(i);
                            }
                        }
                        s.calculateSystemYLayout(), this.calculateComments(), this.calculateMarkedAreas();
                        for(let t = 0, e = this.graphicalMusicSheet.MusicPages.length; t < e; ++t){
                            const e = this.graphicalMusicSheet.MusicPages[t];
                            for(let i = 0, s = e.MusicSystems.length; i < s; ++i){
                                const s = 0 === t && 0 === i, n = e.MusicSystems[i];
                                n.setMusicSystemLabelsYPosition(), this.leadSheet ? n === n.Parent.MusicSystems[0] && n.createSystemLeftLine(this.rules.SystemThinLineWidth, this.rules.SystemLabelsRightMargin, s) : (n.setYPositionsToVerticalLineObjectsAndCreateLines(this.rules), n.createSystemLeftLine(this.rules.SystemThinLineWidth, this.rules.SystemLabelsRightMargin, s), n.createInstrumentBrackets(this.graphicalMusicSheet.ParentMusicSheet.Instruments, this.rules.StaffHeight), n.createGroupBrackets(this.graphicalMusicSheet.ParentMusicSheet.InstrumentalGroups, this.rules.StaffHeight, 0), n.alignBeginInstructions()), n.calculateBorders(this.rules);
                            }
                            const i = s.pageTopBorder(e.MusicSystems[0]);
                            for(let t = 0, s = e.MusicSystems.length; t < s; ++t){
                                const s = e.MusicSystems[t];
                                s.PositionAndShape.RelativePosition = new f.PointF2D(s.PositionAndShape.RelativePosition.x, s.PositionAndShape.RelativePosition.y - i);
                            }
                            e.PositionAndShape.calculateTopBottomBorders(), e === this.graphicalMusicSheet.MusicPages[0] && this.calculatePageLabels(e), e.PositionAndShape.calculateTopBottomBorders(this.rules.RenderSingleHorizontalStaffline);
                        }
                    }
                    calculateMarkedAreas() {}
                    calculateComments() {}
                    calculateChordSymbols() {
                        for (const t of this.musicSystems)for (const e of t.StaffLines){
                            for(let i = 0; i < e.Measures.length; i++)this.calculateChordSymbolsXPositions(e.Measures[i], i, t);
                            const i = e.SkyBottomLineCalculator;
                            let s = Number.MAX_SAFE_INTEGER, n = Number.MIN_SAFE_INTEGER;
                            if (this.rules.ChordSymbolYAlignment && "staffline" === this.rules.ChordSymbolYAlignmentScope) {
                                const t = [];
                                for (const i of e.Measures)t.push(...i.staffEntries);
                                const { minOffset: r, maxOffset: o } = this.calculateAlignedChordSymbolsOffset(t, i);
                                s = r, n = o;
                            }
                            for(let t = 0; t < e.Measures.length; t++){
                                const r = e.Measures[t];
                                if (this.rules.ChordSymbolYAlignment && "measure" === this.rules.ChordSymbolYAlignmentScope) {
                                    const { minOffset: t, maxOffset: e } = this.calculateAlignedChordSymbolsOffset(r.staffEntries, i);
                                    s = t, n = e;
                                }
                                for (const t of r.staffEntries)if (t.graphicalChordContainers && 0 !== t.graphicalChordContainers.length) for(let e = 0; e < t.graphicalChordContainers.length; e++){
                                    const r = t.graphicalChordContainers[e], o = r.PositionAndShape, a = o.Parent, l = o.BorderMarginLeft + a.AbsolutePosition.x + o.RelativePosition.x, h = o.BorderMarginRight + a.AbsolutePosition.x + o.RelativePosition.x, c = r.GetChordSymbolContainer.Placement;
                                    c === A.PlacementEnum.Below ? (!this.rules.ChordSymbolYAlignment || n < 0) && (n = i.getBottomLineMaxInRange(l, h)) : c === A.PlacementEnum.Above && (!this.rules.ChordSymbolYAlignment || s > 0) && (s = i.getSkyLineMinInRange(l, h));
                                    let u = n, d = s;
                                    if (this.rules.ChordSymbolYAlignment) {
                                        const t = o.BorderLeft + a.AbsolutePosition.x + o.RelativePosition.x, e = o.BorderRight + a.AbsolutePosition.x + o.RelativePosition.x;
                                        c === A.PlacementEnum.Below ? u = Math.max(u, i.getBottomLineMaxInRange(t, e)) : d = Math.min(d, i.getSkyLineMinInRange(t, e));
                                    }
                                    let f = 0;
                                    0 === e ? (f += this.rules.ChordSymbolYOffset, f += .1) : f += this.rules.ChordSymbolYPadding, c !== A.PlacementEnum.Below && (f *= -1);
                                    const m = r.GraphicalLabel;
                                    c === A.PlacementEnum.Below ? (m.PositionAndShape.RelativePosition.y = u + f, m.setLabelPositionAndShapeBorders(), m.PositionAndShape.calculateBoundingBox(), i.updateBottomLineInRange(l, h, u + (f + m.PositionAndShape.BorderBottom) + this.rules.ChordSymbolBottomMargin)) : (m.PositionAndShape.RelativePosition.y = d + f, m.setLabelPositionAndShapeBorders(), m.PositionAndShape.calculateBoundingBox(), i.updateSkyLineInRange(l, h, d + (f + m.PositionAndShape.BorderTop)));
                                }
                            }
                        }
                    }
                    calculateChordSymbolsXPositions(t, e, i) {
                        let s;
                        for (const n of t.staffEntries)if (n.graphicalChordContainers && 0 !== n.graphicalChordContainers.length) for (const r of n.graphicalChordContainers){
                            if (0 === n.graphicalVoiceEntries.length && n.relInMeasureTimestamp.RealValue > 0) {
                                let e = 0;
                                0 === t.staffEntries[0].relInMeasureTimestamp.RealValue && (e = t.staffEntries[0].PositionAndShape.RelativePosition.x, 1 === t.MeasureNumber && (e += this.rules.ChordSymbolWholeMeasureRestXOffsetMeasure1));
                                let i = e + (t.PositionAndShape.Size.width - t.endInstructionsWidth - e) * (n.relInMeasureTimestamp.RealValue / t.parentSourceMeasure.Duration.RealValue) + r.PositionAndShape.BorderMarginLeft;
                                s && (i = Math.max(i, s.PositionAndShape.RelativePosition.x + s.GraphicalLabel.PositionAndShape.Size.width + this.rules.ChordSymbolXSpacing)), r.PositionAndShape.RelativePosition.x = i, r.PositionAndShape.Parent = t.staffEntries[0].PositionAndShape.Parent;
                            }
                            const o = r.PositionAndShape;
                            if (o.Parent.DataObject instanceof a.GraphicalMeasure && 0 === n.relInMeasureTimestamp.RealValue && (o.RelativePosition.x = Math.max(t.beginInstructionsWidth, o.RelativePosition.x), 1 === t.MeasureNumber && o.RelativePosition.x > 3 && (o.RelativePosition.x += this.rules.ChordSymbolWholeMeasureRestXOffsetMeasure1)), 0 === n.PositionAndShape.RelativePosition.x) {
                                const t = i.GraphicalMeasures[e];
                                for (const e of t){
                                    let t = !1;
                                    for (const i of e.staffEntries)if (i.relInMeasureTimestamp === n.relInMeasureTimestamp && 0 !== i.PositionAndShape.RelativePosition.x) {
                                        o.RelativePosition.x = i.PositionAndShape.RelativePosition.x, t = !0;
                                        break;
                                    }
                                    if (t) break;
                                }
                            }
                            s = r;
                        }
                    }
                    calculateAlignedChordSymbolsOffset(t, e) {
                        let i = Number.MAX_SAFE_INTEGER, s = Number.MIN_SAFE_INTEGER;
                        for (const n of t)for (const t of n.graphicalChordContainers){
                            const n = t.PositionAndShape, r = n.Parent, o = n.BorderMarginLeft + r.AbsolutePosition.x + n.RelativePosition.x, a = n.BorderMarginRight + r.AbsolutePosition.x + n.RelativePosition.x, l = t.GetChordSymbolContainer.Placement;
                            l === A.PlacementEnum.Above ? i = Math.min(i, e.getSkyLineMinInRange(o, a)) : l === A.PlacementEnum.Below && (s = Math.max(s, e.getBottomLineMaxInRange(o, a)));
                        }
                        return {
                            minOffset: i,
                            maxOffset: s
                        };
                    }
                    layoutMeasureWithWholeRest(t, e, i) {}
                    layoutBeams(t) {}
                    layoutArticulationMarks(t, e, i) {}
                    layoutOrnament(t, e, i) {}
                    calculateRestNotePlacementWithinGraphicalBeam(t, e, i, s, n) {}
                    calculateTupletNumbers() {
                        if (!this.rules.TupletNumberLimitConsecutiveRepetitions) return;
                        let t, e, i, s = -1, n = 0;
                        const r = {};
                        for (const o of this.graphicalMusicSheet.ParentMusicSheet.Instruments)for (const a of o.Voices){
                            n = 0, r[a.VoiceId] = {};
                            for (const o of a.VoiceEntries)if (o.Notes.length > 0) {
                                const l = o.Notes[0];
                                if (!l.NoteTuplet || l.NoteTuplet.shouldBeBracketed(this.rules.TupletsBracketedUseXMLValue, this.rules.TupletsBracketed, this.rules.TripletsBracketed)) {
                                    s = -1, n = 0, e = void 0, t = void 0;
                                    continue;
                                }
                                if (l.NoteTuplet === i) continue;
                                let h = l.TypeLength;
                                if (h || (M.default.warn("note missing TypeLength"), h = l.NoteTuplet.Fractions[0]), l.NoteTuplet !== e && r[a.VoiceId][l.NoteTuplet.TupletLabelNumber] && r[a.VoiceId][l.NoteTuplet.TupletLabelNumber][h.RealValue]) {
                                    l.NoteTuplet.RenderTupletNumber = !1, i = l.NoteTuplet;
                                    continue;
                                }
                                l.NoteTuplet.TupletLabelNumber === s && h.Equals(t) && !l.NoteTuplet.Bracket || (s = l.NoteTuplet.TupletLabelNumber, t = h, n = 0), e = l.NoteTuplet, n++, n <= this.rules.TupletNumberMaxConsecutiveRepetitions && (l.NoteTuplet.RenderTupletNumber = !0), n > this.rules.TupletNumberMaxConsecutiveRepetitions && (l.NoteTuplet.RenderTupletNumber = !1, this.rules.TupletNumberAlwaysDisableAfterFirstMax && (r[a.VoiceId][s] || (r[a.VoiceId][s] = {}), r[a.VoiceId][s][h.RealValue] = !0)), i = e;
                            }
                        }
                    }
                    calculateSlurs() {}
                    calculateGlissandi() {}
                    calculateDynamicExpressionsForMultiExpression(t, e, i) {}
                    calculateGraphicalVerbalContinuousDynamic(t, e) {
                        const i = t.PositionAndShape, s = e.x + i.BorderMarginLeft, n = e.x + i.BorderMarginRight, r = t.ContinuousDynamic.Placement, o = t.ParentStaffLine.SkyBottomLineCalculator;
                        let a;
                        r === A.PlacementEnum.Below ? (a = o.getBottomLineMaxForLabel(s, n), i.RelativePosition = new f.PointF2D(e.x, a - i.BorderMarginTop)) : (a = o.getSkyLineMinForLabel(s, n), i.RelativePosition = new f.PointF2D(e.x, a - i.BorderMarginBottom)), t.updateSkyBottomLine();
                    }
                    calculateGraphicalContinuousDynamic(t, e) {
                        const i = t.IsSoftAccent, s = t.ParentStaffLine.ParentStaff.idInMusicSheet, n = this.graphicalMusicSheet.getGraphicalMeasureFromSourceMeasureAndIndex(t.ContinuousDynamic.EndMultiExpression.SourceMeasureParent, s);
                        if (!n) return void M.default.warn("MusicSheetCalculator.calculateGraphicalContinuousDynamic: No endMeasure found");
                        t.EndMeasure = n;
                        const o = t.ParentStaffLine, a = n.ParentStaffLine, l = a && o === a;
                        let h = !1;
                        a ? h = a?.isPartOfMultiStaffInstrument() : o && (h = o?.isPartOfMultiStaffInstrument());
                        const c = r.Fraction.createFromFraction(t.ContinuousDynamic.EndMultiExpression.AbsoluteTimestamp), u = this.graphicalMusicSheet.GetVerticalContainerFromTimestamp(c), d = u.getFirstNonNullStaffEntry().parentMeasure, f = d.PositionAndShape.AbsolutePosition.x + d.PositionAndShape.BorderRight;
                        let m = new r.Fraction(0, 0, 0);
                        for (const t of u.StaffEntries){
                            if (t?.sourceStaffEntry.ParentStaff !== o.ParentStaff) continue;
                            const e = t?.sourceStaffEntry?.calculateMaxNoteLength(!1);
                            e?.gt(m) && (m = e);
                        }
                        const p = !i && t.ContinuousDynamic.DynamicType === C.ContDynamicEnum.diminuendo, g = this.getRelativePositionInStaffLineFromTimestamp(c, s, a, h, 0, p), b = r.Fraction.plus(c, m).clone();
                        t.ContinuousDynamic.EndMultiExpression.EndOffsetFraction && this.rules.UseEndOffsetForExpressions && b.Add(t.ContinuousDynamic.EndMultiExpression.EndOffsetFraction);
                        const S = this.getRelativePositionInStaffLineFromTimestamp(b, s, a, h, 0, t.ContinuousDynamic.DynamicType === C.ContDynamicEnum.diminuendo), y = this.rules.SoftAccentWedgePadding, E = u.getFirstNonNullStaffEntry().PositionAndShape.Size.width, x = this.rules.SoftAccentSizeFactor;
                        i ? (e.x -= E / 2 * x + y, g.x = e.x + E / 2 * x) : S.x > g.x && S.x < f ? g.x += (S.x - g.x) / this.rules.WedgeEndDistanceBetweenTimestampsFactor : g.x = f - this.rules.WedgeHorizontalMargin;
                        const v = this.dynamicExpressionMap.get(t.ContinuousDynamic.StartMultiExpression.AbsoluteTimestamp.RealValue);
                        v && v.DataObject.ParentStaffLine === o && (e.x = v.RelativePosition.x + this.rules.WedgeHorizontalMargin, e.x += v.BorderMarginRight);
                        const T = o.ParentMusicSystem, _ = T.StaffLines.indexOf(o), P = o.SkyBottomLineCalculator, L = t.ContinuousDynamic.Placement;
                        let w;
                        l && g.x - e.x < this.rules.WedgeMinLength && !i && (g.x = e.x + this.rules.WedgeMinLength);
                        const I = e.x;
                        let R = a.Measures[0].beginInstructionsWidth - this.rules.WedgeHorizontalMargin - 2, N = 0, D = 0;
                        const O = [];
                        if (l) N = g.x;
                        else {
                            N = o.PositionAndShape.Size.width, D = g.x;
                            const e = [
                                o,
                                a
                            ], i = t.StartMeasure;
                            let r = i, l = 0, h = i.parentSourceMeasure.measureListIndex;
                            for(; r !== n && l < 1e3;){
                                const i = this.graphicalMusicSheet.ParentMusicSheet.SourceMeasures[h], n = this.graphicalMusicSheet.getGraphicalMeasureFromSourceMeasureAndIndex(i, s);
                                if (n) {
                                    r = n;
                                    const i = r.ParentStaffLine;
                                    if (!e.includes(i)) {
                                        e.push(i);
                                        const s = new B.GraphicalContinuousDynamicExpression(t.ContinuousDynamic, i, i.Measures[0].parentSourceMeasure);
                                        s.IsSplittedPart = !0, O.push(s);
                                    }
                                }
                                h++, l++;
                            }
                            w = new B.GraphicalContinuousDynamicExpression(t.ContinuousDynamic, a, n.parentSourceMeasure), w.IsSplittedPart = !0, t.IsSplittedPart = !0;
                        }
                        i && (R = g.x + y, D = R + E / 2 * x);
                        let F = 0, k = 0;
                        if (L === A.PlacementEnum.Below) {
                            let e = 0;
                            if (_ < T.StaffLines.length - 1 && (e = _ + 1), e > _) {
                                const t = T.StaffLines[e].PositionAndShape.RelativePosition.y - o.PositionAndShape.RelativePosition.y - this.rules.StaffHeight;
                                F = this.rules.StaffHeight + t / 2;
                            } else F = this.rules.WedgePlacementBelowY;
                            F -= this.rules.WedgeOpeningLength / 2, l || (k = F);
                            let i = P.getBottomLineMaxInRange(I, N);
                            i > F && (F = i);
                            const s = !1;
                            if (_ < T.StaffLines.length - 1) {
                                const i = o.findClosestStaffEntry(N), n = o.findClosestStaffEntry(I);
                                if (n && i && (n.parentVerticalContainer, s)) {
                                    const i = T.StaffLines[e], s = i.SkyBottomLineCalculator.getSkyLineMinInRange(I, N), n = i.PositionAndShape.RelativePosition.y - o.PositionAndShape.RelativePosition.y + s;
                                    F = n - this.rules.WedgeOpeningLength > this.rules.StaffHeight ? n - this.rules.WedgeVerticalMargin : this.rules.StaffHeight + this.rules.WedgeOpeningLength, t.NotToBeRemoved = !0;
                                }
                            }
                            l || (i = a.SkyBottomLineCalculator.getBottomLineMaxInRange(R, D), i > k && (k = i), k += this.rules.WedgeOpeningLength / 2, k += this.rules.WedgeVerticalMargin), s || (F += this.rules.WedgeOpeningLength / 2, F += this.rules.WedgeVerticalMargin);
                        } else if (L === A.PlacementEnum.Above) {
                            if (1 === o.ParentStaff.ParentInstrument.Staves.length) F = this.rules.WedgePlacementAboveY;
                            else {
                                let t = 0;
                                _ > 0 && (t = _ - 1);
                                const e = T.StaffLines[t];
                                F = -(o.PositionAndShape.RelativePosition.y - e.PositionAndShape.RelativePosition.y - this.rules.StaffHeight) / 2;
                            }
                            F += this.rules.WedgeOpeningLength / 2, l || (k = F);
                            let t = P.getSkyLineMinInRange(I, N);
                            t < F && (F = t);
                            const e = !1;
                            if (o.ParentStaff.ParentInstrument.Staves.length > 1 && _ > 0) {
                                const t = o.findClosestStaffEntry(I), i = o.findClosestStaffEntry(N);
                                if (t && i) {
                                    t.parentVerticalContainer;
                                    const i = _ - 1;
                                    if (e) {
                                        const t = T.StaffLines[i];
                                        if (t) {
                                            const e = t.SkyBottomLineCalculator.getBottomLineMaxInRange(I, N);
                                            F = (o.PositionAndShape.RelativePosition.y - t.PositionAndShape.RelativePosition.y - e - this.rules.StaffHeight) / 2 + this.rules.StaffHeight;
                                        }
                                    }
                                }
                            }
                            l || (t = a.SkyBottomLineCalculator.getSkyLineMinInRange(R, D), t < k && (k = t), k -= this.rules.WedgeOpeningLength / 2), e || (F -= this.rules.WedgeOpeningLength / 2, F -= this.rules.WedgeVerticalMargin), l || (k -= this.rules.WedgeVerticalMargin);
                        }
                        if (t.Lines.clear(), i) t.createFirstHalfCrescendoLines(I, N, F), t.createSecondHalfDiminuendoLines(R, D, F), t.calcPsi();
                        else if (l && !i) t.createLines(I, N, F), t.calcPsi();
                        else {
                            t.createFirstHalfLines(I, N, F), t.calcPsi();
                            for(let e = 0; e < O.length; e++){
                                const i = O[e], s = i.ParentStaffLine;
                                let n = k;
                                if (L === A.PlacementEnum.Below) {
                                    const t = a.SkyBottomLineCalculator.getBottomLineMaxInRange(R, N);
                                    t > n && (n = t), n += this.rules.WedgeOpeningLength / 2, n += this.rules.WedgeVerticalMargin;
                                } else if (L === A.PlacementEnum.Above) {
                                    const t = s.SkyBottomLineCalculator.getSkyLineMinInRange(R, D);
                                    t < k && (n = t), n -= this.rules.WedgeOpeningLength / 2;
                                }
                                t.ContinuousDynamic.DynamicType === C.ContDynamicEnum.crescendo ? i.createSecondHalfCrescendoLines(0, s.PositionAndShape.Size.width, n) : i.createFirstHalfDiminuendoLines(0, s.PositionAndShape.Size.width, n), i.calcPsi();
                            }
                            w.createSecondHalfLines(R, D, k), w.calcPsi();
                        }
                        this.dynamicExpressionMap.set(c.RealValue, t.PositionAndShape);
                    }
                    calculateGraphicalInstantaneousDynamicExpression(t, e, i) {
                        const s = t.ParentStaffLine;
                        if (!s) return;
                        const n = e.x + t.PositionAndShape.BorderMarginLeft, r = e.x + t.PositionAndShape.BorderMarginRight, o = s.SkyBottomLineCalculator;
                        let a = 0;
                        if (t.Placement === A.PlacementEnum.Above) {
                            const i = o.getSkyLineMinForLabel(n, r);
                            if (s.isPartOfMultiStaffInstrument() && s.ParentStaff !== s.ParentStaff.ParentInstrument.Staves[0]) {
                                const e = s.ParentMusicSystem.StaffLines[s.ParentMusicSystem.StaffLines.indexOf(s) - 1];
                                if (e) {
                                    const n = s?.PositionAndShape.RelativePosition.y - e.PositionAndShape.RelativePosition.y - this.rules.StaffHeight;
                                    a = i > -n / 2 ? -n / 2 : i - t.PositionAndShape.BorderMarginBottom;
                                }
                            } else a = i - t.PositionAndShape.BorderMarginBottom;
                            t.PositionAndShape.RelativePosition = new f.PointF2D(e.x, a);
                        } else if (t.Placement === A.PlacementEnum.Below) {
                            const i = o.getBottomLineMaxForLabel(n, r), l = s.ParentStaff.ParentInstrument.Staves[s.ParentStaff.ParentInstrument.Staves.length - 1];
                            if (s.isPartOfMultiStaffInstrument() && s.ParentStaff !== l) {
                                const e = s.ParentMusicSystem.StaffLines[s.ParentMusicSystem.StaffLines.indexOf(s) + 1];
                                if (e) {
                                    const n = e.PositionAndShape.RelativePosition.y - s.PositionAndShape.RelativePosition.y - this.rules.StaffHeight;
                                    a = i + t.PositionAndShape.BorderMarginBottom < this.rules.StaffHeight + n / 2 ? this.rules.StaffHeight + n / 2 : i - t.PositionAndShape.BorderMarginTop;
                                }
                            } else a = i - t.PositionAndShape.BorderMarginTop;
                            t.PositionAndShape.RelativePosition = new f.PointF2D(e.x, a);
                        }
                        t.updateSkyBottomLine();
                    }
                    calcGraphicalRepetitionEndingsRecursively(t) {}
                    layoutSingleRepetitionEnding(t, e, i, s, n, r) {}
                    calculateLabel(t, e, i, s, n, r, o = g.TextAlignmentEnum.CenterBottom, a = 0) {
                        const l = new L.Label(i, o);
                        l.fontStyle = s, l.fontHeight = r;
                        const h = new p.GraphicalLabel(l, r, l.textAlignment, this.rules, t.PositionAndShape), c = 1.1;
                        n === A.PlacementEnum.Below && (h.Label.textAlignment = g.TextAlignmentEnum.LeftTop), h.setLabelPositionAndShapeBorders(), h.PositionAndShape.BorderMarginBottom *= c, h.PositionAndShape.BorderMarginTop *= c, h.PositionAndShape.BorderMarginLeft *= c, h.PositionAndShape.BorderMarginRight *= c;
                        let u, d = e.x + h.PositionAndShape.BorderMarginLeft, m = e.x + h.PositionAndShape.BorderMarginRight;
                        if (m > t.PositionAndShape.Size.width && (m = t.PositionAndShape.Size.width - this.rules.MeasureRightMargin, d = m - h.PositionAndShape.MarginSize.width, e.x = d - h.PositionAndShape.BorderMarginLeft), d < t.PositionAndShape.BorderMarginLeft) {
                            const i = t.PositionAndShape.BorderMarginLeft - d + this.rules.LabelXOffsetForStafflineLeftOverflowCheck;
                            d += i, m += i, e.x += i;
                        }
                        const b = t.SkyBottomLineCalculator;
                        return u = n === A.PlacementEnum.Below ? b.getBottomLineMaxForLabel(d, m) + a : b.getSkyLineMinForLabel(d, m) - a, h.PositionAndShape.RelativePosition = new f.PointF2D(e.x, u), n === A.PlacementEnum.Below ? b.updateBottomLineWithLabel(d, m, h.PositionAndShape.BorderMarginBottom + u) : b.updateSkyLineWithLabel(d, m, h.PositionAndShape.BorderMarginTop + u), h;
                    }
                    calculateTempoExpressionsForMultiTempoExpression(t, e, i) {
                        const s = r.Fraction.plus(t.AbsoluteTimestamp, e.Timestamp), n = this.graphicalMusicSheet.MeasureList[i];
                        let o = new f.PointF2D;
                        if (e.ContinuousTempo || e.InstantaneousTempo) {
                            if (!n[0]) return;
                            let t = n[0].ParentStaffLine, i = n[0].PositionAndShape.RelativePosition.x, r = 0;
                            for(let e = 0; e < n.length; e++)if (n[e].ParentStaffLine && 0 !== n[e].ParentStaffLine.Measures.length && n[e].ParentStaffLine.Measures.length > 0) {
                                t = n[e].ParentStaffLine, i = n[e].PositionAndShape.RelativePosition.x, r = e;
                                break;
                            }
                            if (o = this.getRelativePositionInStaffLineFromTimestamp(s, r, t, t.isPartOfMultiStaffInstrument(), i), e.EntriesList.length > 0 && e.EntriesList[0].Expression instanceof R.InstantaneousTempoExpression && (e.EntriesList[0].Expression.Placement = A.PlacementEnum.Above, t.Measures[0].staffEntries.length > 0 && 0 === Math.abs(o.x - t.Measures[0].staffEntries[0].PositionAndShape.RelativePosition.x) && t.ParentMusicSystem === this.musicSystems[0])) {
                                const e = t.Measures[0].FirstInstructionStaffEntry;
                                if (e) {
                                    const t = e.GraphicalInstructions.last();
                                    o.x = t.PositionAndShape.RelativePosition.x;
                                }
                                this.rules.CompactMode && (o.x = t.PositionAndShape.RelativePosition.x + t.Measures[0].PositionAndShape.RelativePosition.x);
                            }
                            for (const i of e.EntriesList){
                                if (i.Expression instanceof R.InstantaneousTempoExpression && !i.Expression.printObject) continue;
                                if (i.Expression instanceof R.InstantaneousTempoExpression && i.Expression.isMetronomeMark) continue;
                                if (this.isTempoMarkingAlreadyRendered(t, i.Expression, s)) continue;
                                let n = this.rules.TempoExpressionTextAlignment;
                                this.rules.CompactMode && (n = g.TextAlignmentEnum.LeftBottom);
                                const r = this.calculateLabel(t, o, i.label, e.getFontstyleOfFirstEntry(), i.Expression.Placement, this.rules.UnknownTextHeight, n, this.rules.TempoYSpacing);
                                i.Expression.ColorXML && this.rules.ExpressionsUseXMLColor && (r.ColorXML = i.Expression.ColorXML), r.Label.language = i.Expression.language, i.Expression instanceof R.InstantaneousTempoExpression ? new I.GraphicalInstantaneousTempoExpression(i.Expression, r).ParentStaffLine || M.default.warn("Adding staffline didn't work") : i.Expression instanceof N.ContinuousTempoExpression && new I.GraphicalInstantaneousTempoExpression(i.Expression, r);
                            }
                        }
                    }
                    isTempoMarkingAlreadyRendered(t, e, i) {
                        for (const s of t.AbstractExpressions){
                            if (!(s instanceof I.GraphicalInstantaneousTempoExpression)) continue;
                            const t = s.SourceExpression;
                            if (t.ParentMultiTempoExpression?.AbsoluteTimestamp.Equals(i) && (t.Label ?? "").trim() === (e.Label ?? "").trim()) return !0;
                        }
                        return !1;
                    }
                    isSameMetronomeMark(t, e) {
                        const i = !(!t.metronomeNoteGroupLeft || !t.metronomeNoteGroupRight), s = !(!e.metronomeNoteGroupLeft || !e.metronomeNoteGroupRight);
                        return i || s ? i && s && t.metronomeRelation === e.metronomeRelation && this.isSameMetronomeNoteGroup(t.metronomeNoteGroupLeft, e.metronomeNoteGroupLeft) && this.isSameMetronomeNoteGroup(t.metronomeNoteGroupRight, e.metronomeNoteGroupRight) : t.TempoInBpm === e.TempoInBpm && t.beatUnit === e.beatUnit && t.dotted === e.dotted;
                    }
                    isSameMetronomeNoteGroup(t, e) {
                        return t.notes.length === e.notes.length && t.notes.every((t, i)=>t.type === e.notes[i].type && t.dots === e.notes[i].dots && t.beam === e.notes[i].beam && !!t.tied == !!e.notes[i].tied) && t.tuplet?.actualNotes === e.tuplet?.actualNotes && t.tuplet?.normalNotes === e.tuplet?.normalNotes && t.tuplet?.bracket === e.tuplet?.bracket && t.tuplet?.showNumber === e.tuplet?.showNumber;
                    }
                    createMetronomeMark(t) {
                        throw new Error(this.abstractNotImplementedErrorMessage);
                    }
                    layoutMetronomeMarks() {}
                    graphicalMeasureCreatedCalculations(t) {}
                    clearSystemsAndMeasures() {
                        for(let t = 0, e = this.graphicalMusicSheet.MusicPages.length; t < e; ++t){
                            const e = this.graphicalMusicSheet.MusicPages[t];
                            for(let t = 0, i = e.MusicSystems.length; t < i; ++t){
                                const i = e.MusicSystems[t];
                                for(let t = 0, e = i.StaffLines.length; t < e; ++t){
                                    const e = i.StaffLines[t];
                                    e.ParentStaff.Visible || e.Measures.clear();
                                    for(let t = 0, i = e.Measures.length; t < i; ++t){
                                        const i = e.Measures[t];
                                        if (i.FirstInstructionStaffEntry) {
                                            const t = i.PositionAndShape.ChildElements.indexOf(i.FirstInstructionStaffEntry.PositionAndShape);
                                            t > -1 && i.PositionAndShape.ChildElements.splice(t, 1), i.FirstInstructionStaffEntry = void 0, i.beginInstructionsWidth = 0;
                                        }
                                        if (i.LastInstructionStaffEntry) {
                                            const t = i.PositionAndShape.ChildElements.indexOf(i.LastInstructionStaffEntry.PositionAndShape);
                                            t > -1 && i.PositionAndShape.ChildElements.splice(t, 1), i.LastInstructionStaffEntry = void 0, i.endInstructionsWidth = 0;
                                        }
                                    }
                                    e.Measures = [], e.PositionAndShape.ChildElements = [];
                                }
                                i.StaffLines.length = 0, i.PositionAndShape.ChildElements = [];
                            }
                            e.MusicSystems = [], e.PositionAndShape.ChildElements = [];
                        }
                        this.graphicalMusicSheet.MusicPages = [];
                    }
                    handleVoiceEntry(t, e, i, s, n, r, o, a, l, h, u) {
                        t.StemDirectionXml !== c.StemDirectionType.Undefined && this.rules.SetWantedStemDirectionByXml && void 0 !== t.StemDirectionXml ? t.WantedStemDirection = t.StemDirectionXml : this.calculateStemDirectionFromVoices(t);
                        const d = e.findOrCreateGraphicalVoiceEntry(t);
                        d.octaveShiftValue = a;
                        const f = e.tabStaffEntry;
                        let m;
                        f && (m = f.findOrCreateGraphicalVoiceEntry(t));
                        for(let s = 0, l = t.Notes.length; s < l; ++s){
                            const l = t.Notes[s];
                            if (!l) continue;
                            if (void 0 !== u && void 0 !== u.Link && void 0 !== h && h.indexOf(l) > -1) continue;
                            let c;
                            if (t.IsGrace ? c = V.symbolFactory.createGraceNote(l, d, n, this.rules, a) : (c = V.symbolFactory.createNote(l, d, n, a, this.rules, void 0), V.stafflineNoteCalculator.trackNote(c)), l.Pitch && this.checkNoteForAccidental(c, i, n, a), this.resetYPositionForLeadSheet(c.PositionAndShape), e.addGraphicalNoteToListAtCorrectYPosition(d, c), c.PositionAndShape.calculateBoundingBox(), !this.leadSheet && (void 0 !== l.NoteBeam && (l.PrintObject || l.sharesNoteheadWithVisibleUnisonNote()) && (l instanceof k.TabNote && !this.rules.TabBeamsRendered || this.handleBeam(c, l.NoteBeam, o)), l.NoteTuplets.length > 0 && (l.PrintObject || l.sharesNoteheadWithVisibleUnisonNote()))) for (const t of l.NoteTuplets)this.handleTuplet(c, t, r);
                            if (m) {
                                const t = V.symbolFactory.createNote(l, m, n, a, this.rules, void 0);
                                if (f.addGraphicalNoteToListAtCorrectYPosition(m, t), t.PositionAndShape.calculateBoundingBox(), !this.leadSheet) for (const e of l.NoteTuplets)this.handleTuplet(t, e, r);
                            }
                        }
                        return t.Articulations.length > 0 && this.handleVoiceEntryArticulations(t.Articulations, t, e), t.TechnicalInstructions.length > 0 && this.handleVoiceEntryTechnicalInstructions(t.TechnicalInstructions, t, e), t.LyricsEntries.size() > 0 && this.handleVoiceEntryLyrics(t, e, s), t.OrnamentContainer && this.handleVoiceEntryOrnaments(t.OrnamentContainer, t, e), a;
                    }
                    resetYPositionForLeadSheet(t) {
                        this.leadSheet && (t.RelativePosition = new f.PointF2D(t.RelativePosition.x, 0));
                    }
                    layoutVoiceEntries(t, e) {
                        if (t.PositionAndShape.RelativePosition = new f.PointF2D(0, 0), !this.leadSheet) for (const e of t.graphicalVoiceEntries){
                            const i = e.notes;
                            if (0 === i.length) continue;
                            const s = i[0].sourceNote.ParentVoiceEntry, n = void 0 !== i[0].sourceNote.Pitch;
                            this.layoutVoiceEntry(s, i, t, n);
                        }
                    }
                    maxInstrNameLabelLength() {
                        let t = 0;
                        for (const e of this.graphicalMusicSheet.ParentMusicSheet.Instruments)if (e.NameLabel?.print && e.Voices.length > 0 && e.Voices[0].Visible) {
                            let i = e.NameLabel;
                            this.rules.RenderPartNames || (i = new L.Label("", i.textAlignment, i.font));
                            const s = new p.GraphicalLabel(i, this.rules.InstrumentLabelTextHeight, g.TextAlignmentEnum.LeftCenter, this.rules);
                            s.setLabelPositionAndShapeBorders(), t = Math.max(t, s.PositionAndShape.MarginSize.width);
                        }
                        return this.rules.RenderPartNames ? t : 0;
                    }
                    calculateSheetLabelBoundingBoxes() {
                        const t = this.graphicalMusicSheet.ParentMusicSheet, e = this.rules.DefaultColorTitle;
                        if (void 0 !== t.Title && this.rules.RenderTitle) {
                            const i = new p.GraphicalLabel(t.Title, this.rules.SheetTitleHeight, g.TextAlignmentEnum.CenterBottom, this.rules);
                            i.Label.IsCreditLabel = !0, i.Label.colorDefault = e, this.graphicalMusicSheet.Title = i, i.setLabelPositionAndShapeBorders();
                        } else this.rules.RenderTitle || (this.graphicalMusicSheet.Title = void 0);
                        if (void 0 !== t.Subtitle && this.rules.RenderSubtitle) {
                            const i = new p.GraphicalLabel(t.Subtitle, this.rules.SheetSubtitleHeight, g.TextAlignmentEnum.CenterCenter, this.rules);
                            i.Label.IsCreditLabel = !0, i.Label.colorDefault = e, this.graphicalMusicSheet.Subtitle = i, i.setLabelPositionAndShapeBorders();
                        } else this.rules.RenderSubtitle || (this.graphicalMusicSheet.Subtitle = void 0);
                        if (void 0 !== t.Composer && this.rules.RenderComposer) {
                            const i = new p.GraphicalLabel(t.Composer, this.rules.SheetComposerHeight, g.TextAlignmentEnum.RightCenter, this.rules);
                            i.Label.IsCreditLabel = !0, i.Label.colorDefault = e, this.graphicalMusicSheet.Composer = i, i.setLabelPositionAndShapeBorders();
                        } else this.rules.RenderComposer || (this.graphicalMusicSheet.Composer = void 0);
                        if (void 0 !== t.Lyricist && this.rules.RenderLyricist) {
                            const i = new p.GraphicalLabel(t.Lyricist, this.rules.SheetAuthorHeight, g.TextAlignmentEnum.LeftCenter, this.rules);
                            i.Label.IsCreditLabel = !0, i.Label.colorDefault = e, this.graphicalMusicSheet.Lyricist = i, i.setLabelPositionAndShapeBorders();
                        } else this.rules.RenderLyricist || (this.graphicalMusicSheet.Lyricist = void 0);
                        if (void 0 !== t.Copyright && this.rules.RenderCopyright) {
                            const i = new p.GraphicalLabel(t.Copyright, this.rules.SheetCopyrightHeight, g.TextAlignmentEnum.CenterBottom, this.rules);
                            i.Label.IsCreditLabel = !0, i.Label.colorDefault = e, this.graphicalMusicSheet.Copyright = i, i.setLabelPositionAndShapeBorders();
                        } else this.rules.RenderCopyright || (this.graphicalMusicSheet.Copyright = void 0);
                        this.calculateFirstPageCreditWordLabels();
                    }
                    calculateFirstPageCreditWordLabels() {
                        if (this.graphicalMusicSheet.FirstPageCreditWords = [], !this.rules.ReadFirstPageCreditWords || !this.rules.RenderFirstPageCreditWords) return;
                        const t = this.graphicalMusicSheet.ParentMusicSheet, e = t.pageWidth - this.rules.PageLeftMargin - this.rules.PageRightMargin;
                        let i = this.rules.RenderTitle ? this.rules.TitleTopDistance + this.rules.SheetTitleHeight + this.rules.TitleBottomDistance + 2 : (this.rules.CompactMode ? this.rules.PageTopMarginNarrow : this.rules.PageTopMargin) + 1;
                        const s = this.graphicalMusicSheet.Subtitle;
                        s && this.rules.RenderTitle && this.rules.RenderSubtitle && (i = Math.max(i, this.subtitleRelativeY(s) + s.PositionAndShape.BorderBottom + this.rules.TitleBottomDistance + 1));
                        for (const s of t.FirstPageCreditWords){
                            const t = new L.Label(this.wrapFirstPageCreditWords(s, e), s.textAlignment, s.font, s.print);
                            t.fontFamily = s.fontFamily, t.fontStyle = s.fontStyle, t.language = s.language;
                            const n = new p.GraphicalLabel(t, this.rules.SheetSubtitleHeight, s.textAlignment, this.rules);
                            n.Label.IsCreditLabel = !0, n.Label.colorDefault = this.rules.DefaultColorTitle, n.setLabelPositionAndShapeBorders(), n.PositionAndShape.RelativePosition = new f.PointF2D(0, i), this.graphicalMusicSheet.FirstPageCreditWords.push(n), i += n.PositionAndShape.MarginSize.height + 1;
                        }
                    }
                    wrapFirstPageCreditWords(t, e) {
                        const i = (i)=>this.rules.SheetSubtitleHeight * V.TextMeasurer.computeTextWidthToHeightRatio(i, t.font, t.fontStyle, t.fontFamily) <= e, s = [];
                        for (const e of t.text.split(/\r?\n/)){
                            let t = Array.from(e);
                            for(; t.length > 0 && !i(t.join(""));){
                                let e = 1;
                                for(; e < t.length && i(t.slice(0, e + 1).join(""));)e++;
                                const n = t.lastIndexOf(" ", e), r = n > 0 ? n : e;
                                for(s.push(t.slice(0, r).join("").trimEnd()), t = t.slice(r); " " === t[0];)t.shift();
                            }
                            s.push(t.join(""));
                        }
                        return s.join("\n");
                    }
                    checkMeasuresForWholeRestNotes() {
                        for(let t = 0, e = this.musicSystems.length; t < e; ++t){
                            const e = this.musicSystems[t];
                            for(let t = 0, i = e.StaffLines.length; t < i; ++t){
                                const i = e.StaffLines[t];
                                for(let t = 0, e = i.Measures.length; t < e; ++t){
                                    const e = i.Measures[t];
                                    if (1 === e.staffEntries.length) {
                                        const t = e.staffEntries[0];
                                        if (t.graphicalVoiceEntries.length > 0 && 1 === t.graphicalVoiceEntries[0].notes.length) {
                                            const i = t.graphicalVoiceEntries[0].notes[0];
                                            !i.sourceNote.Pitch && new r.Fraction(1, 2).lt(i.sourceNote.Length) && this.layoutMeasureWithWholeRest(i, t, e);
                                        }
                                    }
                                }
                            }
                        }
                    }
                    optimizeRestNotePlacement(t, e) {
                        if (0 === t.graphicalVoiceEntries.length) return;
                        const i = t.graphicalVoiceEntries[0].notes;
                        if (0 === i.length) return;
                        const s = i[0], n = s.sourceNote.isRest();
                        if (2 === t.graphicalVoiceEntries.length) {
                            let e = !1;
                            const i = t.graphicalVoiceEntries[1].notes;
                            i.length > 0 && (e = i[0].sourceNote.isRest()), n && e ? this.calculateTwoRestNotesPlacementWithCollisionDetection(t) : (n || e) && this.calculateRestNotePlacementWithCollisionDetectionFromGraphicalNote(t);
                        } else if (n && t !== e.staffEntries[0] && t !== e.staffEntries[e.staffEntries.length - 1]) {
                            const i = e.staffEntries.indexOf(t), n = e.staffEntries[i - 1], r = e.staffEntries[i + 1];
                            if (1 === n.graphicalVoiceEntries.length) {
                                const e = n.graphicalVoiceEntries[0].notes[0];
                                if (void 0 !== e.sourceNote.NoteBeam && 1 === r.graphicalVoiceEntries.length) {
                                    const i = r.graphicalVoiceEntries[0].notes[0];
                                    void 0 !== i.sourceNote.NoteBeam && e.sourceNote.NoteBeam === i.sourceNote.NoteBeam && (this.calculateRestNotePlacementWithinGraphicalBeam(t, s, e, r, i), t.PositionAndShape.calculateBoundingBox());
                                }
                            }
                        }
                    }
                    getRelativePositionInStaffLineFromTimestamp(t, e, i, s, n = 0, o = !1) {
                        let a, l, h = new f.PointF2D;
                        const c = this.graphicalMusicSheet.VerticalGraphicalStaffEntryContainers.length, u = this.graphicalMusicSheet.GetInterpolatedIndexInVerticalContainers(t), d = Math.min(Math.floor(u), c - 1), m = Math.min(Math.ceil(u), c - 1);
                        if (d < 0 || e < 0) return h;
                        if (a = this.getFirstLeftNotNullStaffEntryFromContainer(d, e, s), l = this.getFirstRightNotNullStaffEntryFromContainer(m, e, s), a && l) {
                            let e = a.parentMeasure.PositionAndShape.RelativePosition.x;
                            n > 0 && (e = n);
                            let s = a.PositionAndShape.RelativePosition.x + e, c = l.PositionAndShape.RelativePosition.x + l.parentMeasure.PositionAndShape.RelativePosition.x;
                            const u = t.RealValue > l.getAbsoluteTimestamp().RealValue;
                            n > 0 ? c = l.PositionAndShape.RelativePosition.x + e : o && (a.getAbsoluteTimestamp().RealValue === t.RealValue || u) && (s = a.PositionAndShape.RelativePosition.x + a.PositionAndShape.BorderLeft + e, c = s);
                            let d = 0;
                            if (a !== l) {
                                const e = a.getAbsoluteTimestamp(), i = l.getAbsoluteTimestamp();
                                d = r.Fraction.minus(t, e).RealValue / r.Fraction.minus(i, e).RealValue;
                            }
                            a.parentMeasure.ParentStaffLine !== l.parentMeasure.ParentStaffLine && (a.parentMeasure.ParentStaffLine === i ? c = i.PositionAndShape.Size.width : s = i.PositionAndShape.RelativePosition.x), h = new f.PointF2D(s + (c - s) * d, 0);
                        }
                        return h;
                    }
                    getRelativeXPositionFromTimestamp(t) {
                        const e = this.graphicalMusicSheet.VerticalGraphicalStaffEntryContainers.length, i = this.graphicalMusicSheet.GetInterpolatedIndexInVerticalContainers(t), s = Math.max(0, Math.min(Math.round(i), e - 1)), n = this.graphicalMusicSheet.VerticalGraphicalStaffEntryContainers[s].getFirstNonNullStaffEntry();
                        return n.PositionAndShape.RelativePosition.x + n.parentMeasure.PositionAndShape.RelativePosition.x;
                    }
                    calculatePageLabels(t) {
                        const e = this.graphicalMusicSheet.ParentMusicSheet.pageWidth;
                        this.rules.RenderSingleHorizontalStaffline && (t.PositionAndShape.calculateBoundingBox([
                            a.GraphicalMeasure
                        ]), this.graphicalMusicSheet.ParentMusicSheet.pageWidth = t.PositionAndShape.Size.width);
                        let i = 10, s = -1;
                        if (t.MusicSystems.length > 0) {
                            const e = t.MusicSystems[0];
                            i = e.PositionAndShape.RelativePosition.y + e.PositionAndShape.BorderTop;
                            const n = t.MusicSystems[t.MusicSystems.length - 1];
                            s = n.PositionAndShape.RelativePosition.y + n.PositionAndShape.BorderBottom;
                        }
                        const n = this.graphicalMusicSheet.Title;
                        if (n && this.rules.RenderTitle) {
                            n.PositionAndShape.Parent = t.PositionAndShape;
                            const e = new f.PointF2D;
                            e.x = this.graphicalMusicSheet.ParentMusicSheet.pageWidth / 2, this.rules.RenderSingleHorizontalStaffline && (e.x = Math.max(e.x, n.PositionAndShape.Size.width)), e.y = this.rules.TitleTopDistance + this.rules.SheetTitleHeight, n.PositionAndShape.RelativePosition = e, t.Labels.push(n);
                        }
                        if (this.graphicalMusicSheet.Subtitle && this.rules.RenderTitle && this.rules.RenderSubtitle) {
                            const e = this.graphicalMusicSheet.Subtitle;
                            e.PositionAndShape.Parent = t.PositionAndShape;
                            const i = new f.PointF2D;
                            i.x = this.graphicalMusicSheet.ParentMusicSheet.pageWidth / 2, this.rules.RenderSingleHorizontalStaffline && (i.x = n.PositionAndShape.RelativePosition.x), i.y = this.subtitleRelativeY(e), e.PositionAndShape.RelativePosition = i, t.Labels.push(e);
                        }
                        for (const e of this.graphicalMusicSheet.FirstPageCreditWords){
                            e.PositionAndShape.Parent = t.PositionAndShape;
                            const i = e.Label.textAlignment;
                            let s = i === g.TextAlignmentEnum.RightTop ? this.graphicalMusicSheet.ParentMusicSheet.pageWidth - this.rules.PageRightMargin : i === g.TextAlignmentEnum.CenterTop ? this.graphicalMusicSheet.ParentMusicSheet.pageWidth / 2 : this.rules.PageLeftMargin;
                            this.rules.RenderSingleHorizontalStaffline && (s = Math.max(s, this.rules.PageLeftMargin - e.PositionAndShape.BorderLeft)), e.PositionAndShape.RelativePosition = new f.PointF2D(s, e.PositionAndShape.RelativePosition.y), t.Labels.push(e);
                        }
                        const r = this.graphicalMusicSheet.Composer;
                        let o;
                        if (r && this.rules.RenderComposer) {
                            r.PositionAndShape.Parent = t.PositionAndShape, r.setLabelPositionAndShapeBorders();
                            const e = new f.PointF2D;
                            e.x = this.graphicalMusicSheet.ParentMusicSheet.pageWidth - this.rules.PageRightMargin, e.y = i, e.y -= this.rules.SystemComposerDistance;
                            const s = r.TextLines?.length;
                            s > 1 && (e.y -= r.PositionAndShape.BorderBottom * (s - 1) / s), o = e.y, r.PositionAndShape.RelativePosition = e, t.Labels.push(r);
                        }
                        const l = this.graphicalMusicSheet.Lyricist;
                        if (l && this.rules.RenderLyricist) {
                            l.PositionAndShape.Parent = t.PositionAndShape, l.setLabelPositionAndShapeBorders();
                            const e = new f.PointF2D;
                            e.x = this.rules.PageLeftMargin, e.y = i, e.y -= this.rules.SystemLyricistDistance, e.y += l.PositionAndShape.BorderBottom, e.y = Math.min(e.y, o ?? Number.MAX_SAFE_INTEGER), l.PositionAndShape.RelativePosition = e, t.Labels.push(l);
                        }
                        const h = this.graphicalMusicSheet.Copyright;
                        if (h && this.rules.RenderCopyright) {
                            h.PositionAndShape.Parent = t.PositionAndShape, h.setLabelPositionAndShapeBorders();
                            const e = new f.PointF2D;
                            e.x = t.PositionAndShape.Size.width / 2, e.y = s + this.rules.SheetCopyrightMargin, e.y -= h.PositionAndShape.BorderTop, h.PositionAndShape.RelativePosition = e, h.AnchoredToPageBottom = !0, t.Labels.push(h);
                        }
                        this.rules.RenderSingleHorizontalStaffline && (t.PositionAndShape.calculateBoundingBox([
                            a.GraphicalMeasure
                        ]), this.graphicalMusicSheet.ParentMusicSheet.pageWidth = t.PositionAndShape.Size.width, this.graphicalMusicSheet.ParentMusicSheet.pageWidth = e);
                    }
                    subtitleRelativeY(t) {
                        let e = this.rules.TitleTopDistance + this.rules.SheetTitleHeight + this.rules.SheetMinimumDistanceBetweenTitleAndSubtitle;
                        const i = t.TextLines?.length;
                        return i > 1 && (e += t.PositionAndShape.BorderBottom * (i - 1) / i), e;
                    }
                    createGraphicalTies() {
                        for(let t = 0; t < this.graphicalMusicSheet.ParentMusicSheet.SourceMeasures.length; t++){
                            const e = this.graphicalMusicSheet.ParentMusicSheet.SourceMeasures[t];
                            for(let i = 0; i < e.CompleteNumberOfStaves; i++)for(let s = 0; s < e.VerticalSourceStaffEntryContainers.length; s++){
                                const n = e.VerticalSourceStaffEntryContainers[s].StaffEntries[i];
                                if (n) {
                                    const e = this.graphicalMusicSheet.findGraphicalStaffEntryFromMeasureList(i, t, n);
                                    e && (e.GraphicalTies.clear(), e.ties.clear());
                                    for(let s = 0, r = n.VoiceEntries.length; s < r; ++s){
                                        const r = n.VoiceEntries[s];
                                        for(let s = 0, n = r.Notes.length; s < n; ++s){
                                            const n = r.Notes[s];
                                            if (n.NoteTie) {
                                                const s = n.NoteTie;
                                                if (n === n.NoteTie.Notes.last()) continue;
                                                this.handleTie(s, e, i, t, s.Notes.indexOf(n));
                                            }
                                        }
                                    }
                                    this.setTieDirections(e);
                                }
                            }
                        }
                    }
                    handleTie(t, e, i, s, n) {
                        if (!e) return;
                        e.ties.push(t);
                        let r, o, a, l = e;
                        for(let e = n + 1; e < t.Notes.length; e++)if (r = l.findTieGraphicalNoteFromNote(t.Notes[e - 1]), o = this.graphicalMusicSheet.GetGraphicalFromSourceStaffEntry(t.Notes[e].ParentStaffEntry), o) {
                            if (a = o.findTieGraphicalNoteFromNote(t.Notes[e]), void 0 !== r && void 0 !== a && o) {
                                if (!r.sourceNote.PrintObject || !a.sourceNote.PrintObject) continue;
                                const e = r.sourceNote.NoteTie;
                                if (e && e !== t && e === a.sourceNote.NoteTie) continue;
                                const i = this.createGraphicalTie(t, l, o, r, a);
                                l.GraphicalTies.push(i), this.staffEntriesWithGraphicalTies.indexOf(l) >= 0 && this.staffEntriesWithGraphicalTies.push(l);
                            }
                            l = o;
                        }
                    }
                    setTieDirections(t) {
                        if (!t) return;
                        const e = t.ties;
                        if (1 === e.length) {
                            const t = e[0];
                            if (t.TieDirection === A.PlacementEnum.NotYetDefined) {
                                const e = t.Notes[0], i = e.ParentVoiceEntry, s = i.ParentVoice.VoiceId, n = e.TypeLength?.RealValue < 1 && i.StemDirectionXml !== c.StemDirectionType.None;
                                2 === s || 6 === s ? t.TieDirection = A.PlacementEnum.Below : n && this.otherVoicePresentInMeasure(i, !0) && (i.StemDirection === c.StemDirectionType.Up ? t.TieDirection = A.PlacementEnum.Above : i.StemDirection === c.StemDirectionType.Down && (t.TieDirection = A.PlacementEnum.Below));
                            }
                        }
                        if (e.length > 1) {
                            let t;
                            for (const i of e){
                                const e = i.Notes[0];
                                (!t || e.Pitch.getHalfTone() > t.Pitch.getHalfTone()) && (t = e);
                            }
                            for (const i of e)i.TieDirection === A.PlacementEnum.NotYetDefined && (i.Notes[0] === t ? i.TieDirection = A.PlacementEnum.Above : i.TieDirection = A.PlacementEnum.Below);
                        }
                    }
                    createAccidentalCalculators() {
                        const t = [], e = this.graphicalMusicSheet.ParentMusicSheet.getFirstSourceMeasure();
                        if (e) {
                            const i = this.graphicalMusicSheet.ParentMusicSheet.Transpose;
                            for(let s = 0; s < e.CompleteNumberOfStaves; s++){
                                const n = new v.AccidentalCalculator;
                                if (t.push(n), n.Transpose = i, e.FirstInstructionsStaffEntries[s]) for(let t = 0, r = e.FirstInstructionsStaffEntries[s].Instructions.length; t < r; ++t){
                                    const r = e.FirstInstructionsStaffEntries[s].Instructions[t];
                                    if (r instanceof b.KeyInstruction) {
                                        const t = r, e = new b.KeyInstruction(t.Parent, t.keyTypeOriginal, t.Mode), o = this.graphicalMusicSheet.ParentMusicSheet.Staves[s];
                                        0 !== i && o?.ParentInstrument?.MidiInstrumentId !== T.MidiInstrument.Percussion && V.transposeCalculator && V.transposeCalculator.transposeKey(e, i), n.ActiveKeyInstruction = e;
                                    }
                                }
                            }
                        }
                        return t;
                    }
                    calculateVerticalContainersList() {
                        const t = this.graphicalMusicSheet.MeasureList[0].length;
                        for(let e = 0; e < this.graphicalMusicSheet.MeasureList.length; e++)for(let i = 0; i < t; i++){
                            const t = this.graphicalMusicSheet.MeasureList[e][i];
                            if (t) for(let e = 0, s = t.staffEntries.length; e < s; ++e){
                                const s = t.staffEntries[e], n = this.graphicalMusicSheet.getOrCreateVerticalContainer(s.getAbsoluteTimestamp());
                                n && (n.StaffEntries[i] = s, s.parentVerticalContainer = n);
                            }
                        }
                    }
                    setIndicesToVerticalGraphicalContainers() {
                        for(let t = 0; t < this.graphicalMusicSheet.VerticalGraphicalStaffEntryContainers.length; t++)this.graphicalMusicSheet.VerticalGraphicalStaffEntryContainers[t].Index = t;
                    }
                    createGraphicalMeasuresForSourceMeasure(t, e, i, s, n) {
                        this.initGraphicalMeasuresCreation();
                        const r = [], o = [], a = [], l = [];
                        let h = !0;
                        for(let c = 0; c < t.CompleteNumberOfStaves; c++){
                            const u = this.createGraphicalMeasure(t, a, o, e[c], n, s, i, c, l);
                            h = h && u.hasOnlyRests, r.push(u);
                        }
                        return t.allRests = h, t.VerticalMeasureList = r, r;
                    }
                    getActiveOctaveShift(t, e, i) {
                        if (e && e.getAbsoluteStartTimestamp.lte(t) && t.lte(e.getAbsoluteEndTimestamp) && e.getOpenOctaveShift.Type !== h.OctaveEnum.NONE) return e.getOpenOctaveShift;
                        for (const e of i){
                            let i;
                            if (e.OctaveShiftStart ? i = e.OctaveShiftStart : e.OctaveShiftEnd && (i = e.OctaveShiftEnd), i?.ParentStartMultiExpression?.AbsoluteTimestamp.lte(t) && !i.ParentEndMultiExpression?.AbsoluteTimestamp.lt(t)) return i;
                        }
                    }
                    keyForGraphicalMeasure(t, e) {
                        const i = new b.KeyInstruction(t.Parent, t.keyTypeOriginal, t.Mode), s = e.getTransposedHalftones();
                        return 0 !== s && void 0 === V.transposeCalculator && M.default.info("[OSMD] transpose requested, but TransposeCalculator undefined. Use osmd.TransposeCalculator = new TransposeCalculator()"), 0 !== s && e.ParentStaff.ParentInstrument.MidiInstrumentId !== T.MidiInstrument.Percussion && V.transposeCalculator && V.transposeCalculator.transposeKey(i, s), i;
                    }
                    createGraphicalMeasure(t, e, i, s, n, a, u, d, f) {
                        const p = this.graphicalMusicSheet.ParentMusicSheet.getStaffFromIndex(d);
                        let g;
                        if (n[d].ClefType === l.ClefEnum.TAB || p.isTab) p.isTab = !0, g = V.symbolFactory.createTabStaffMeasure(t, p);
                        else if (t.multipleRestMeasures && this.rules.RenderMultipleRestMeasures) g = V.symbolFactory.createMultiRestMeasure(t, p);
                        else {
                            if (t.multipleRestMeasureNumber > 1) return;
                            g = V.symbolFactory.createGraphicalMeasure(t, p);
                        }
                        if (g.hasError = t.getErrorInMeasure(d), t.FirstInstructionsStaffEntries[d]) for(let e = 0, i = t.FirstInstructionsStaffEntries[d].Instructions.length; e < i; ++e){
                            const i = t.FirstInstructionsStaffEntries[d].Instructions[e];
                            i instanceof b.KeyInstruction && (s.ActiveKeyInstruction = this.keyForGraphicalMeasure(i, g));
                        }
                        const S = [];
                        for(let e = 0, i = t.StaffLinkedExpressions[d].length; e < i; ++e){
                            const i = t.StaffLinkedExpressions[d][e];
                            let s;
                            if (i.OctaveShiftStart ? s = i.OctaveShiftStart : i.OctaveShiftEnd && (s = i.OctaveShiftEnd), s) {
                                S.push(i);
                                const e = s;
                                let n = e?.ParentEndMultiExpression?.AbsoluteTimestamp;
                                e?.ParentEndMultiExpression || (n = r.Fraction.plus(t.AbsoluteTimestamp, t.Duration)), a[d] = new x.OctaveShiftParams(e, e.ParentStartMultiExpression.AbsoluteTimestamp, n);
                            }
                        }
                        const y = [];
                        for(let r = 0; r < t.VerticalSourceStaffEntryContainers.length; r++){
                            const o = t.VerticalSourceStaffEntryContainers[r].StaffEntries[d];
                            if (o) {
                                for(let t = 0, e = o.Instructions.length; t < e; ++t){
                                    const e = o.Instructions[t];
                                    e instanceof l.ClefInstruction && n[d]?.ClefType !== l.ClefEnum.TAB && (n[d] = e);
                                }
                                const t = V.symbolFactory.createStaffEntry(o, g);
                                r < g.staffEntries.length ? g.addGraphicalStaffEntryAtTimestamp(t) : g.addGraphicalStaffEntry(t);
                                const c = [];
                                o.Link && (o.findLinkedNotes(c), this.handleStaffEntryLink(t, f));
                                let m = this.getActiveOctaveShift(o.AbsoluteTimestamp, a[d], S), p = m?.Type ?? h.OctaveEnum.NONE;
                                for (const e of o.Instructions)if (e instanceof b.KeyInstruction) {
                                    const i = this.keyForGraphicalMeasure(e, g);
                                    V.symbolFactory.createInStaffKey(t, i, s.ActiveKeyInstruction, n[d]), s.ActiveKeyInstruction = i;
                                }
                                for(let r = 0, a = o.VoiceEntries.length; r < a; ++r){
                                    const a = o.VoiceEntries[r];
                                    a.GraceAfterMainNote ? y.push({
                                        voiceEntry: a,
                                        graphicalStaffEntry: t,
                                        sourceStaffEntry: o,
                                        linkedNotes: c
                                    }) : (p !== h.OctaveEnum.NONE && m && m.endVoiceEntryIndex > 0 && m.ParentEndMultiExpression?.AbsoluteTimestamp.Equals(o.AbsoluteTimestamp) && r >= m.endVoiceEntryIndex && (p = h.OctaveEnum.NONE, m = void 0), p = this.handleVoiceEntry(a, t, s, u, n[d], e, i, p, d, c, o));
                                }
                                for (const e of o.Instructions)if (e instanceof l.ClefInstruction) {
                                    V.symbolFactory.createInStaffClef(t, e);
                                    break;
                                }
                                this.rules.RenderChordSymbols && o.ChordContainers?.length > 0 && (o.ParentStaff.ParentInstrument.HasChordSymbols = !0, V.symbolFactory.createChordSymbols(o, t, s.ActiveKeyInstruction, this.graphicalMusicSheet.ParentMusicSheet.Transpose));
                            }
                        }
                        let E = 0;
                        for(let t = 0; t < y.length; t++){
                            const { voiceEntry: o, graphicalStaffEntry: l, sourceStaffEntry: c, linkedNotes: f } = y[t];
                            E = t > 0 && y[t - 1].sourceStaffEntry === c ? E + 1 : 0;
                            const m = r.Fraction.plus(c.AbsoluteTimestamp, c.calculateMaxNoteLength(!1)), p = this.getActiveOctaveShift(m, a[d], S);
                            let g = p?.Type ?? h.OctaveEnum.NONE;
                            p && p.endVoiceEntryIndex > 0 && p.ParentEndMultiExpression?.AbsoluteTimestamp.Equals(m) && E >= p.endVoiceEntryIndex && (g = h.OctaveEnum.NONE), this.handleVoiceEntry(o, l, s, u, n[d], e, i, g, d, f, c);
                        }
                        if (s.doCalculationsAtEndOfMeasure(), t.LastInstructionsStaffEntries[d]) {
                            const e = t.LastInstructionsStaffEntries[d];
                            for(let t = 0, i = e.Instructions.length; t < i; ++t){
                                const i = e.Instructions[t];
                                i instanceof l.ClefInstruction && n[d]?.ClefType !== l.ClefEnum.TAB && (n[d] = i);
                            }
                        }
                        for(let e = 0, i = t.StaffLinkedExpressions[d].length; e < i; ++e){
                            const i = t.StaffLinkedExpressions[d][e];
                            void 0 !== i.OctaveShiftEnd && void 0 !== a[d] && i.OctaveShiftEnd === a[d].getOpenOctaveShift && (a[d] = void 0);
                        }
                        for (const t of g.staffEntries)for (const e of t.graphicalVoiceEntries)this.setBeamNotesWantedStemDirections(e.parentVoiceEntry);
                        if (this.rules.FillEmptyMeasuresWithWholeRest >= 1 && 0 === g.staffEntries.length) {
                            const e = new m.SourceStaffEntry(new w.VerticalSourceStaffEntryContainer(g.parentSourceMeasure, g.parentSourceMeasure.AbsoluteTimestamp, g.parentSourceMeasure.CompleteNumberOfStaves), p);
                            if (0 === p.Voices.length) {
                                const t = new F.Voice(g.ParentStaff.ParentInstrument, -1);
                                p.Voices.push(t);
                            }
                            const i = new c.VoiceEntry(new r.Fraction(0, 1), p.Voices[0], e);
                            let s = t.Duration;
                            0 === s.RealValue && (s = t.ActiveTimeSignature.clone());
                            const n = new o.Note(i, e, s, void 0, t, !0);
                            n.IsWholeMeasureRest = !0, n.PrintObject = this.rules.FillEmptyMeasuresWithWholeRest === D.FillEmptyMeasuresWithWholeRests.YesVisible, i.Notes.push(n);
                            const a = V.symbolFactory.createStaffEntry(e, g);
                            g.addGraphicalStaffEntry(a), a.relInMeasureTimestamp = i.Timestamp;
                            const u = V.symbolFactory.createVoiceEntry(i, a);
                            a.graphicalVoiceEntries.push(u);
                            const d = V.symbolFactory.createNote(n, u, new l.ClefInstruction, h.OctaveEnum.NONE, this.rules);
                            V.stafflineNoteCalculator.trackNote(d), u.notes.push(d);
                        }
                        g.hasOnlyRests = !0;
                        for (const t of g.staffEntries)if (g.hasOnlyRests = t.hasOnlyRests(), !g.hasOnlyRests) break;
                        return g;
                    }
                    checkNoteForAccidental(t, e, i, s) {
                        let n = t.sourceNote.Pitch;
                        const r = t.parentVoiceEntry.parentStaffEntry.parentMeasure.getTransposedHalftones();
                        0 !== r && t.sourceNote.ParentStaffEntry.ParentStaff.ParentInstrument.MidiInstrumentId !== T.MidiInstrument.Percussion ? (n = t.Transpose(e.ActiveKeyInstruction, i, r, s), t.sourceNote.TransposedPitch = n) : t.sourceNote.TransposedPitch = void 0, t.sourceNote.halfTone = n.getHalfTone(), e.checkAccidental(t, n);
                    }
                    handleStaffEntries(t) {
                        for(let e = 0, i = this.graphicalMusicSheet.MeasureList.length; e < i; ++e){
                            const i = this.graphicalMusicSheet.MeasureList[e];
                            for(let e = 0, s = i.length; e < s; ++e){
                                const s = i[e];
                                if (!s) continue;
                                const n = s.ParentStaff;
                                t[e] && (n.StafflineCount = n.xmlStafflineCount ?? 5), this.rules.PercussionOneLineCutoff > 0 && !this.rules.PercussionUseCajon2NoteSystem && t[e] && (void 0 === n.xmlStafflineCount || !this.rules.PercussionKeepXMLStafflineCount) && V.stafflineNoteCalculator.getStafflineUniquePositionCount(e) < this.rules.PercussionOneLineCutoff && (n.StafflineCount = 1);
                                for (const t of s.staffEntries)void 0 !== t.parentMeasure && t.graphicalVoiceEntries.length > 0 && t.graphicalVoiceEntries[0].notes.length > 0 && (this.layoutVoiceEntries(t, e), this.layoutStaffEntry(t));
                                this.graphicalMeasureCreatedCalculations(s);
                            }
                        }
                    }
                    calculateSkyBottomLines() {}
                    reserveSkylineForMeasureRepeats() {}
                    calculateExpressionAlignements() {}
                    calculateStaffEntryArticulationMarks() {
                        for(let t = 0, e = this.musicSystems.length; t < e; ++t){
                            const e = this.musicSystems[t];
                            for(let t = 0, i = e.StaffLines.length; t < i; ++t){
                                const i = e.StaffLines[t];
                                for(let t = 0, e = i.Measures.length; t < e; ++t){
                                    const e = i.Measures[t];
                                    for(let t = 0, i = e.staffEntries.length; t < i; ++t){
                                        const i = e.staffEntries[t];
                                        for(let t = 0, e = i.sourceStaffEntry.VoiceEntries.length; t < e; ++t){
                                            const e = i.sourceStaffEntry.VoiceEntries[t];
                                            e.Articulations.length > 0 && this.layoutArticulationMarks(e.Articulations, e, i);
                                        }
                                    }
                                }
                            }
                        }
                    }
                    calculateOrnaments() {
                        for(let t = 0, e = this.musicSystems.length; t < e; ++t){
                            const e = this.musicSystems[t];
                            for(let t = 0, i = e.StaffLines.length; t < i; ++t){
                                const i = e.StaffLines[t];
                                for(let t = 0, e = i.Measures.length; t < e; ++t){
                                    const e = i.Measures[t];
                                    for(let t = 0, i = e.staffEntries.length; t < i; ++t){
                                        const i = e.staffEntries[t];
                                        for(let t = 0, e = i.sourceStaffEntry.VoiceEntries.length; t < e; ++t){
                                            const e = i.sourceStaffEntry.VoiceEntries[t];
                                            if (e.OrnamentContainer) {
                                                if (e.hasTie() && !i.relInMeasureTimestamp.Equals(e.Timestamp)) continue;
                                                this.layoutOrnament(e.OrnamentContainer, e, i), -1 === this.staffEntriesWithOrnaments.indexOf(i) && this.staffEntriesWithOrnaments.push(i);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    getFingeringPlacement(t) {
                        let e = this.rules.FingeringPosition;
                        return e !== A.PlacementEnum.NotYetDefined && e !== A.PlacementEnum.AboveOrBelow || (e = t.isUpperStaffOfInstrument() ? A.PlacementEnum.Above : A.PlacementEnum.Below), e;
                    }
                    calculateFingerings() {
                        if (this.rules.FingeringPosition !== A.PlacementEnum.Left && this.rules.FingeringPosition !== A.PlacementEnum.Right) for (const t of this.musicSystems)for (const e of t.StaffLines)for (const t of e.Measures){
                            if (t.isTabMeasure && !this.rules.TabFingeringsRendered) continue;
                            const i = this.getFingeringPlacement(t);
                            for (const s of t.staffEntries){
                                if (s.FingeringEntries = [], t.NotesAreAbbreviated) continue;
                                const n = e.SkyBottomLineCalculator, r = s.PositionAndShape.RelativePosition.x + t.PositionAndShape.RelativePosition.x, o = [], a = new Map;
                                for (const t of s.graphicalVoiceEntries){
                                    if (t.parentVoiceEntry.IsGrace) continue;
                                    const e = void 0 === t.noteHeadsCenterX ? r : r + t.PositionAndShape.RelativePosition.x + t.noteHeadsCenterX;
                                    for (const i of t.parentVoiceEntry.TechnicalInstructions)i.type === S.TechnicalInstructionType.Fingering && (o.push(i), a.set(i, e));
                                }
                                if (o.length > 1) {
                                    if (o.every((t, e)=>void 0 !== t.sourceNote?.Pitch && o.findIndex((e)=>e.sourceNote === t.sourceNote) === e)) o.sort((t, e)=>t.sourceNote.Pitch.getHalfTone() - e.sourceNote.Pitch.getHalfTone()), i === A.PlacementEnum.Below && o.reverse();
                                    else {
                                        let t;
                                        i === A.PlacementEnum.Below && o.reverse();
                                        for (const e of s.graphicalVoiceEntries)for (const i of e.notes)(!t || i.sourceNote.Pitch?.getHalfTone() > t.Pitch?.getHalfTone()) && (t = i.sourceNote);
                                        o[0].sourceNote === t && i === A.PlacementEnum.Above && o.reverse();
                                    }
                                }
                                const l = [];
                                for (const t of o){
                                    const r = a.get(t), o = i === A.PlacementEnum.Above ? g.TextAlignmentEnum.CenterBottom : g.TextAlignmentEnum.CenterTop, h = new L.Label(t.value, o), c = new p.GraphicalLabel(h, this.rules.FingeringTextSize, h.textAlignment, this.rules, e.PositionAndShape);
                                    t.fontFamily && (h.fontFamily = t.fontFamily), c.setLabelPositionAndShapeBorders();
                                    const u = r + c.PositionAndShape.BorderMarginLeft, d = r + c.PositionAndShape.BorderMarginRight;
                                    let f;
                                    f = i === A.PlacementEnum.Above ? n.getSkyLineMinInRange(u, d) : n.getBottomLineMaxInRange(u, d);
                                    let m = 0;
                                    l.includes(f) ? m += this.rules.FingeringPaddingY : (m += this.rules.FingeringOffsetY, i === A.PlacementEnum.Above && (m += .1)), i === A.PlacementEnum.Above && (m *= -1), c.PositionAndShape.RelativePosition.y += f + m, c.PositionAndShape.RelativePosition.x = r, c.PositionAndShape.calculateBoundingBox(), c.sourceNote = t.sourceNote, s.FingeringEntries.push(c);
                                    const b = c.PositionAndShape.RelativePosition.x + c.PositionAndShape.BorderLeft, S = b - c.PositionAndShape.BorderLeft + c.PositionAndShape.BorderRight;
                                    if (i === A.PlacementEnum.Above) {
                                        const t = c.PositionAndShape.RelativePosition.y + c.PositionAndShape.BorderTop;
                                        n.updateSkyLineInRange(b, S, t), l.push(t);
                                    } else if (i === A.PlacementEnum.Below) {
                                        const t = c.PositionAndShape.RelativePosition.y + c.PositionAndShape.BorderBottom;
                                        n.updateBottomLineInRange(b, S, t), l.push(t);
                                    }
                                }
                            }
                        }
                    }
                    optimizeRestPlacement() {
                        for(let t = 0, e = this.musicSystems.length; t < e; ++t){
                            const e = this.musicSystems[t];
                            for(let t = 0, i = e.StaffLines.length; t < i; ++t){
                                const i = e.StaffLines[t];
                                for(let t = 0, e = i.Measures.length; t < e; ++t){
                                    const e = i.Measures[t];
                                    for(let t = 0, i = e.staffEntries.length; t < i; ++t){
                                        const i = e.staffEntries[t];
                                        this.optimizeRestNotePlacement(i, e);
                                    }
                                }
                            }
                        }
                    }
                    calculateTwoRestNotesPlacementWithCollisionDetection(t) {
                        const e = t.graphicalVoiceEntries[0].notes[0], i = t.graphicalVoiceEntries[1].notes[0];
                        i.PositionAndShape.RelativePosition = new f.PointF2D(0, 2.5), t.PositionAndShape.calculateAbsolutePositionsRecursiveWithoutTopelement(), e.PositionAndShape.computeNonOverlappingPositionWithMargin(t.PositionAndShape, E.ColDirEnum.Up, new f.PointF2D(0, i.PositionAndShape.RelativePosition.y));
                        const s = e.PositionAndShape.RelativePosition;
                        s.y -= 1, e.PositionAndShape.RelativePosition = s, t.PositionAndShape.calculateBoundingBox();
                    }
                    calculateRestNotePlacementWithCollisionDetectionFromGraphicalNote(t) {
                        let e, i;
                        t.graphicalVoiceEntries[0].notes[0].sourceNote.isRest() ? (e = t.graphicalVoiceEntries[0].notes[0], i = t.graphicalVoiceEntries[1].notes) : (i = t.graphicalVoiceEntries[0].notes, e = t.graphicalVoiceEntries[1].notes[0]);
                        let s = !1;
                        t.PositionAndShape.calculateAbsolutePositionsRecursiveWithoutTopelement();
                        for(let t = 0, n = i.length; t < n; ++t){
                            const n = i[t];
                            if (e.PositionAndShape.marginCollisionDetection(n.PositionAndShape)) {
                                s = !0;
                                break;
                            }
                        }
                        if (s) {
                            if (e.sourceNote.ParentVoiceEntry.ParentVoice instanceof y.LinkedVoice) {
                                const t = i[0].PositionAndShape.BorderMarginBottom + i[0].PositionAndShape.RelativePosition.y;
                                e.PositionAndShape.RelativePosition = new f.PointF2D(0, t - e.PositionAndShape.BorderMarginTop + .5);
                            } else {
                                const t = i[i.length - 1], s = t.PositionAndShape.BorderMarginTop + t.PositionAndShape.RelativePosition.y;
                                if (i[0].sourceNote.ParentVoiceEntry.ParentVoice instanceof y.LinkedVoice) e.PositionAndShape.RelativePosition = new f.PointF2D(0, s - e.PositionAndShape.BorderMarginBottom - .5);
                                else {
                                    const t = i[0].PositionAndShape.BorderMarginBottom + i[0].PositionAndShape.RelativePosition.y;
                                    e.PositionAndShape.RelativePosition = t < 2 ? new f.PointF2D(0, t - e.PositionAndShape.BorderMarginTop + .5) : new f.PointF2D(0, s - e.PositionAndShape.BorderMarginBottom - 0);
                                }
                            }
                        }
                        t.PositionAndShape.calculateBoundingBox();
                    }
                    calculateTieCurves() {
                        for (const t of this.musicSystems)for (const e of t.StaffLines)for (const t of e.Measures)for (const e of t.staffEntries)for (const i of e.GraphicalTies)if (void 0 !== i.StartNote && i.StartNote.parentVoiceEntry.parentStaffEntry === e) {
                            const e = i.StartNote.parentVoiceEntry.parentStaffEntry.parentMeasure.ParentStaffLine !== i.EndNote.parentVoiceEntry.parentStaffEntry.parentMeasure.ParentStaffLine;
                            this.layoutGraphicalTie(i, e, t.ParentStaff.isTab);
                        }
                    }
                    calculateLyricsPosition() {
                        const t = new Map;
                        for(let t = 0, e = this.graphicalMusicSheet.ParentMusicSheet.Instruments.length; t < e; ++t){
                            const e = this.graphicalMusicSheet.ParentMusicSheet.Instruments[t];
                            e.HasLyrics && e.LyricVersesNumbers.length > 0 && e.LyricVersesNumbers.sort();
                        }
                        for(let e = 0, i = this.musicSystems.length; e < i; ++e){
                            const i = this.musicSystems[e];
                            for(let e = 0, s = i.StaffLines.length; e < s; ++e){
                                const s = i.StaffLines[e], n = this.calculateSingleStaffLineLyricsPosition(s, s.ParentStaff.ParentInstrument.LyricVersesNumbers);
                                t.set(s, n);
                            }
                        }
                        for (const e of t.values())this.calculateLyricsExtendsAndDashes(e);
                    }
                    calculateSingleLyricWord(t) {
                        const e = t.ParentLyricWord, i = e.GraphicalLyricsEntries.indexOf(t);
                        let s;
                        if (i >= 0 && (s = e.GraphicalLyricsEntries[i + 1]), !s) return;
                        const n = t.StaffEntryParent.parentMeasure.ParentStaffLine, r = s.StaffEntryParent.parentMeasure.ParentStaffLine, o = t.StaffEntryParent, a = s.StaffEntryParent;
                        if (t.StaffEntryParent.parentMeasure.ParentStaffLine === s.StaffEntryParent.parentMeasure.ParentStaffLine) {
                            const e = o.parentMeasure.PositionAndShape.RelativePosition.x + o.PositionAndShape.RelativePosition.x + t.GraphicalLabel.PositionAndShape.RelativePosition.x + t.GraphicalLabel.PositionAndShape.BorderMarginRight - t.GraphicalLabel.CenteringXShift, i = a.parentMeasure.PositionAndShape.RelativePosition.x + a.PositionAndShape.RelativePosition.x + t.GraphicalLabel.PositionAndShape.RelativePosition.x + s.GraphicalLabel.PositionAndShape.BorderMarginLeft, r = t.VerseLineY;
                            let l = 1;
                            i - e > 3 * this.rules.MinimumDistanceBetweenDashes && (l = Math.floor((i - e) / this.rules.MinimumDistanceBetweenDashes) - 1), 1 === l ? this.calculateSingleDashForLyricWord(n, e, i, r) : this.calculateDashes(n, e, i, r);
                        } else {
                            const e = o.parentMeasure.PositionAndShape.RelativePosition.x + o.PositionAndShape.RelativePosition.x + t.GraphicalLabel.PositionAndShape.BorderMarginRight, i = n.Measures[n.Measures.length - 1], l = i.PositionAndShape.RelativePosition.x + i.PositionAndShape.Size.width;
                            let h = t.VerseLineY;
                            if (this.calculateDashes(n, e, l, h), r && r.Measures[0] && a.parentMeasure.ParentStaffLine && (a !== a.parentMeasure.staffEntries[0] || a.parentMeasure !== a.parentMeasure.ParentStaffLine.Measures[0])) {
                                const t = r.Measures[0].staffEntries[0].PositionAndShape.RelativePosition.x, e = a.parentMeasure.PositionAndShape.RelativePosition.x + a.PositionAndShape.RelativePosition.x + s.GraphicalLabel.PositionAndShape.BorderMarginLeft;
                                h = s.VerseLineY, this.calculateDashes(r, t, e, h);
                            }
                        }
                    }
                    calculateDashes(t, e, i, s) {
                        let n = i - e;
                        if (n < 3 * this.rules.MinimumDistanceBetweenDashes) this.calculateSingleDashForLyricWord(t, e, i, s);
                        else {
                            const r = Math.floor(n / this.rules.MinimumDistanceBetweenDashes) - 1, o = n / (r + 1);
                            let a = 0;
                            for(e += o, i -= o; a <= Math.floor(r / 2) && i > e;)n = this.calculateRightAndLeftDashesForLyricWord(t, e, i, s), e += o, i -= o, a++;
                            n > 2 * o && this.calculateSingleDashForLyricWord(t, e, i, s);
                        }
                    }
                    calculateSingleDashForLyricWord(t, e, i, s) {
                        const n = new L.Label("-");
                        n.colorDefault = this.rules.DefaultColorLyrics;
                        let r = this.rules.LyricsHeight;
                        i - e < .8 && (r *= .8, s -= .1 * r);
                        const o = new p.GraphicalLabel(n, r, g.TextAlignmentEnum.CenterBottom, this.rules);
                        o.setLabelPositionAndShapeBorders(), t.LyricsDashes.push(o), -1 === this.staffLinesWithLyricWords.indexOf(t) && this.staffLinesWithLyricWords.push(t), o.PositionAndShape.Parent = t.PositionAndShape;
                        const a = new f.PointF2D(e + (i - e) / 2, s);
                        o.PositionAndShape.RelativePosition = a;
                    }
                    calculateLyricExtend(t) {
                        let e = t.VerseLineY;
                        const i = t.StaffEntryParent, s = i.parentMeasure.ParentStaffLine;
                        let n, r;
                        const o = i.parentMeasure.ParentStaff.idInMusicSheet;
                        if (!i.parentVerticalContainer) return;
                        const a = t.LyricsEntry.VerseNumber, l = t.LyricsEntry.Parent?.ParentVoice, h = this.graphicalMusicSheet.VerticalGraphicalStaffEntryContainers;
                        let c, u, d = !1, f = !1, m = i.parentMeasure, p = i.parentVerticalContainer.Index + 1;
                        for(; p < h.length; ++p){
                            const t = h[p].StaffEntries[o];
                            if (t) {
                                if (t.hasOnlyRests() || this.voiceRestsInStaffEntry(t, l)) break;
                                if (t.parentMeasure !== m && (m = t.parentMeasure, this.isSungOnlyInOtherVerses(m, a, l))) break;
                                if (this.hasLyricsOfVerse(t, a)) {
                                    f = !0;
                                    break;
                                }
                                !d && t.LyricsEntries.length > 0 && (d = !0, c = n, u = r), n = t, r = n.parentMeasure.ParentStaffLine, r || (r = i.parentMeasure.ParentStaffLine);
                            }
                        }
                        if (f || !d || this.isVerseSungFrom(p, o, a) || (n = c, r = u), n && r) {
                            if (s === r && n.parentMeasure.ParentStaffLine) {
                                const r = i.parentMeasure.PositionAndShape.RelativePosition.x + i.PositionAndShape.RelativePosition.x + t.GraphicalLabel.PositionAndShape.BorderMarginRight, o = n.parentMeasure.PositionAndShape.RelativePosition.x + n.PositionAndShape.RelativePosition.x + n.PositionAndShape.BorderMarginRight;
                                e -= t.GraphicalLabel.Label.fontHeight / 4, this.calculateSingleLyricWordWithUnderscore(s, r, o, e);
                            } else {
                                const o = s.Measures[s.Measures.length - 1].PositionAndShape, a = i.parentMeasure.PositionAndShape.RelativePosition.x + i.PositionAndShape.RelativePosition.x + t.GraphicalLabel.PositionAndShape.BorderMarginRight, l = o.RelativePosition.x + o.Size.width;
                                if (e -= t.GraphicalLabel.Label.fontHeight / 4, this.calculateSingleLyricWordWithUnderscore(s, a, l, e), !n) return;
                                if (n.parentMeasure.ParentStaffLine && n.parentMeasure.staffEntries && r.Measures[0]?.staffEntries[0] && (n !== n.parentMeasure.staffEntries[0] || n.parentMeasure !== n.parentMeasure.ParentStaffLine.Measures[0])) {
                                    const t = r.Measures[0].staffEntries[0].PositionAndShape.RelativePosition.x, i = n.parentMeasure.PositionAndShape.RelativePosition.x + n.PositionAndShape.RelativePosition.x + n.PositionAndShape.BorderMarginRight;
                                    this.calculateSingleLyricWordWithUnderscore(r, t, i, e);
                                }
                            }
                        }
                    }
                    hasLyricsOfVerse(t, e) {
                        return t.LyricsEntries.some((t)=>t.LyricsEntry.VerseNumber === e);
                    }
                    isSungOnlyInOtherVerses(t, e, i) {
                        const s = t.staffEntries.flatMap((t)=>t.LyricsEntries).filter((t)=>t.LyricsEntry.Parent?.ParentVoice === i);
                        return s.length > 0 && !s.some((t)=>t.LyricsEntry.VerseNumber === e);
                    }
                    isVerseSungFrom(t, e, i) {
                        const s = this.graphicalMusicSheet.VerticalGraphicalStaffEntryContainers;
                        for(let n = t; n < s.length; ++n){
                            const t = s[n].StaffEntries[e];
                            if (t && this.hasLyricsOfVerse(t, i)) return !0;
                        }
                        return !1;
                    }
                    voiceRestsInStaffEntry(t, e) {
                        if (!e) return !1;
                        const i = t.sourceStaffEntry.VoiceEntries.filter((t)=>t.ParentVoice === e);
                        return i.length > 0 && i.every((t)=>t.Notes.every((t)=>t.isRest()));
                    }
                    calculateSingleLyricWordWithUnderscore(t, e, i, s) {
                        const n = new f.PointF2D(e, s), r = new f.PointF2D(i, s), o = new P.GraphicalLine(n, r, this.rules.LyricUnderscoreLineWidth);
                        o.colorHex = this.rules.DefaultColorLyrics, t.LyricLines.push(o), -1 === this.staffLinesWithLyricWords.indexOf(t) && this.staffLinesWithLyricWords.push(t);
                    }
                    calculateRightAndLeftDashesForLyricWord(t, e, i, s) {
                        const n = new L.Label("-");
                        n.colorDefault = this.rules.DefaultColorLyrics;
                        const r = new p.GraphicalLabel(n, this.rules.LyricsHeight, g.TextAlignmentEnum.CenterBottom, this.rules);
                        r.setLabelPositionAndShapeBorders(), t.LyricsDashes.push(r), -1 === this.staffLinesWithLyricWords.indexOf(t) && this.staffLinesWithLyricWords.push(t), r.PositionAndShape.Parent = t.PositionAndShape;
                        const o = new f.PointF2D(e, s);
                        r.PositionAndShape.RelativePosition = o;
                        const a = new L.Label("-"), l = new p.GraphicalLabel(a, this.rules.LyricsHeight, g.TextAlignmentEnum.CenterBottom, this.rules);
                        l.setLabelPositionAndShapeBorders(), t.LyricsDashes.push(l), l.PositionAndShape.Parent = t.PositionAndShape;
                        const h = new f.PointF2D(i, s);
                        return l.PositionAndShape.RelativePosition = h, l.PositionAndShape.RelativePosition.x - r.PositionAndShape.RelativePosition.x;
                    }
                    calculateDynamicExpressions() {
                        const t = Math.min(this.graphicalMusicSheet.ParentMusicSheet.SourceMeasures.length - 1, this.rules.MaxMeasureToDrawIndex);
                        for(let e = Math.min(this.rules.MinMeasureToDrawIndex, this.graphicalMusicSheet.ParentMusicSheet.SourceMeasures.length); e <= t; e++){
                            const t = this.graphicalMusicSheet.ParentMusicSheet.SourceMeasures[e];
                            this.dynamicExpressionMap.clear();
                            for(let i = 0; i < t.StaffLinkedExpressions.length; i++)if (this.graphicalMusicSheet.MeasureList[e] && this.graphicalMusicSheet.MeasureList[e][i] && this.graphicalMusicSheet.MeasureList[e][i].ParentStaff.isVisible()) for(let s = 0; s < t.StaffLinkedExpressions[i].length; s++)(void 0 !== t.StaffLinkedExpressions[i][s].InstantaneousDynamic || void 0 !== t.StaffLinkedExpressions[i][s].StartingContinuousDynamic && t.StaffLinkedExpressions[i][s].StartingContinuousDynamic.StartMultiExpression === t.StaffLinkedExpressions[i][s] && 0 === t.StaffLinkedExpressions[i][s].UnknownList.length) && this.calculateDynamicExpressionsForMultiExpression(t.StaffLinkedExpressions[i][s], e, i);
                        }
                        this.dynamicExpressionMap.clear();
                    }
                    calculateOctaveShifts() {
                        for(let t = 0; t < this.graphicalMusicSheet.ParentMusicSheet.SourceMeasures.length; t++){
                            const e = this.graphicalMusicSheet.ParentMusicSheet.SourceMeasures[t];
                            for(let i = 0; i < e.StaffLinkedExpressions.length; i++)if (this.graphicalMusicSheet.MeasureList[t] && this.graphicalMusicSheet.MeasureList[t][i] && this.graphicalMusicSheet.MeasureList[t][i].ParentStaff.isVisible()) for(let s = 0; s < e.StaffLinkedExpressions[i].length; s++)e.StaffLinkedExpressions[i][s].OctaveShiftStart && this.calculateSingleOctaveShift(e, e.StaffLinkedExpressions[i][s], t, i);
                        }
                    }
                    calculatePedals() {
                        for(let t = 0; t < this.graphicalMusicSheet.ParentMusicSheet.SourceMeasures.length; t++){
                            const e = this.graphicalMusicSheet.ParentMusicSheet.SourceMeasures[t];
                            for(let i = 0; i < e.StaffLinkedExpressions.length; i++)if (this.graphicalMusicSheet.MeasureList[t] && this.graphicalMusicSheet.MeasureList[t][i] && this.graphicalMusicSheet.MeasureList[t][i].ParentStaff.isVisible()) for(let s = 0; s < e.StaffLinkedExpressions[i].length; s++)e.StaffLinkedExpressions[i][s].PedalStart && this.calculateSinglePedal(e, e.StaffLinkedExpressions[i][s], t, i);
                        }
                    }
                    calculateWavyLines() {
                        for(let t = 0; t < this.graphicalMusicSheet.ParentMusicSheet.SourceMeasures.length; t++){
                            const e = this.graphicalMusicSheet.ParentMusicSheet.SourceMeasures[t];
                            for(let i = 0; i < e.StaffLinkedExpressions.length; i++)if (this.graphicalMusicSheet.MeasureList[t] && this.graphicalMusicSheet.MeasureList[t][i] && this.graphicalMusicSheet.MeasureList[t][i].ParentStaff.isVisible()) for(let s = 0; s < e.StaffLinkedExpressions[i].length; s++)e.StaffLinkedExpressions[i][s].WavyLineStart && this.calculateSingleWavyLine(e, e.StaffLinkedExpressions[i][s], t, i);
                        }
                    }
                    getFirstLeftNotNullStaffEntryFromContainer(t, e, i) {
                        if (this.graphicalMusicSheet.VerticalGraphicalStaffEntryContainers[t].StaffEntries[e]) return this.graphicalMusicSheet.VerticalGraphicalStaffEntryContainers[t].StaffEntries[e];
                        for(let i = t - 1; i >= 0; i--)if (this.graphicalMusicSheet.VerticalGraphicalStaffEntryContainers[i].StaffEntries[e]) return this.graphicalMusicSheet.VerticalGraphicalStaffEntryContainers[i].StaffEntries[e];
                    }
                    getFirstRightNotNullStaffEntryFromContainer(t, e, i) {
                        if (this.graphicalMusicSheet.VerticalGraphicalStaffEntryContainers[t].StaffEntries[e]) return this.graphicalMusicSheet.VerticalGraphicalStaffEntryContainers[t].StaffEntries[e];
                        for(let i = t + 1; i < this.graphicalMusicSheet.VerticalGraphicalStaffEntryContainers.length; i++)if (this.graphicalMusicSheet.VerticalGraphicalStaffEntryContainers[i].StaffEntries[e]) return this.graphicalMusicSheet.VerticalGraphicalStaffEntryContainers[i].StaffEntries[e];
                    }
                    calculateWordRepetitionInstructions() {
                        const t = [];
                        for(let e = 0; e < this.graphicalMusicSheet.ParentMusicSheet.SourceMeasures.length; e++){
                            const i = this.graphicalMusicSheet.ParentMusicSheet.SourceMeasures[e];
                            let s, n = !1, r = !1;
                            for (const t of i.FirstRepetitionInstructions)t.type === u.RepetitionInstructionEnum.Ending && t.alignment === u.AlignmentType.Begin && (n = !0, s = t.endingIndices);
                            for (const t of i.LastRepetitionInstructions)t.type !== u.RepetitionInstructionEnum.Ending || t.alignment !== u.AlignmentType.End && t.alignment !== u.AlignmentType.Discontinue || (r = !0);
                            n && t.push({
                                startMeasure: e,
                                endingIndices: s
                            });
                            const o = [];
                            for (const t of i.FirstRepetitionInstructions.concat(i.LastRepetitionInstructions)){
                                if (t.type !== u.RepetitionInstructionEnum.Ending) {
                                    if (o.indexOf(t.type) >= 0) continue;
                                    o.push(t.type);
                                }
                                this.calculateWordRepetitionInstruction(t, e);
                            }
                            if (!n && !r && t.length > 0) {
                                const i = t[t.length - 1];
                                if (e > i.startMeasure) {
                                    const t = new u.RepetitionInstruction(e, u.RepetitionInstructionEnum.Ending, u.AlignmentType.Mid, void 0, i.endingIndices);
                                    this.calculateWordRepetitionInstruction(t, e);
                                }
                            }
                            r && t.length > 0 && t.pop();
                        }
                    }
                    calculateRepetitionEndings() {
                        const t = this.graphicalMusicSheet.ParentMusicSheet;
                        for(let e = 0, i = t.Repetitions.length; e < i; ++e){
                            const i = t.Repetitions[e];
                            this.calcGraphicalRepetitionEndingsRecursively(i);
                        }
                    }
                    calculateTempoExpressions() {
                        const t = Math.min(this.graphicalMusicSheet.ParentMusicSheet.SourceMeasures.length - 1, this.rules.MaxMeasureToDrawIndex), e = this.rules.MinMeasureToDrawIndex;
                        if (this.rules.MetronomeMarksDrawn) for(let t = 0; t < this.graphicalMusicSheet.ParentMusicSheet.SourceMeasures.length; t++)for (const e of this.graphicalMusicSheet.ParentMusicSheet.SourceMeasures[t].TempoExpressions)for (const t of e.EntriesList)t.Expression instanceof R.InstantaneousTempoExpression && t.Expression.isMetronomeMark && t.Expression.printObject && this.createMetronomeMark(t.Expression);
                        for(let i = e; i <= t; i++){
                            const t = this.graphicalMusicSheet.ParentMusicSheet.SourceMeasures[i];
                            for (const e of t.TempoExpressions)this.calculateTempoExpressionsForMultiTempoExpression(t, e, i);
                        }
                        this.layoutMetronomeMarks();
                    }
                    calculateRehearsalMarks() {
                        if (this.rules.RenderRehearsalMarks) for (const t of this.graphicalMusicSheet.ParentMusicSheet.SourceMeasures)this.calculateRehearsalMark(t);
                    }
                    calculateRehearsalMark(t) {
                        throw new Error(this.abstractNotImplementedErrorMessage);
                    }
                    calculateMoodAndUnknownExpressions() {
                        for(let t = 0; t < this.graphicalMusicSheet.ParentMusicSheet.SourceMeasures.length; t++){
                            const e = this.graphicalMusicSheet.ParentMusicSheet.SourceMeasures[t];
                            for(let i = 0; i < e.StaffLinkedExpressions.length; i++){
                                if (!this.graphicalMusicSheet.MeasureList[t] || !this.graphicalMusicSheet.MeasureList[t][i]) continue;
                                let s = i;
                                if (!this.graphicalMusicSheet.MeasureList[t][i].ParentStaff.isVisible()) {
                                    if (0 !== i) continue;
                                    {
                                        let e = !1;
                                        for(let i = 0; i < this.graphicalMusicSheet.MeasureList[t].length; i++)if (this.graphicalMusicSheet.MeasureList[t][i]?.ParentStaff.isVisible()) {
                                            s = i, e = !0;
                                            break;
                                        }
                                        if (!e) continue;
                                    }
                                }
                                for(let n = 0; n < e.StaffLinkedExpressions[i].length; n++)(e.StaffLinkedExpressions[i][n].MoodList.length > 0 || e.StaffLinkedExpressions[i][n].UnknownList.length > 0) && this.calculateMoodAndUnknownExpression(e.StaffLinkedExpressions[i][n], t, s);
                            }
                        }
                    }
                    calculateStemDirectionFromVoices(t) {
                        if (void 0 !== t.ParentSourceStaffEntry.Link) return t === t.ParentSourceStaffEntry.VoiceEntries[0] ? void (t.WantedStemDirection = c.StemDirectionType.Up) : void (t.WantedStemDirection = c.StemDirectionType.Down);
                        t.ParentVoice instanceof y.LinkedVoice ? this.rules.AutoStemSecondaryVoicesWhenAloneInMeasure && !this.otherVoicePresentInMeasure(t) || (t.WantedStemDirection = c.StemDirectionType.Down) : t.ParentSourceStaffEntry.VoiceEntries.length > 1 && (t.WantedStemDirection = c.StemDirectionType.Up);
                    }
                    otherVoicePresentInMeasure(t, e = !1) {
                        const i = t.ParentSourceStaffEntry, s = i.ParentStaff.idInMusicSheet, n = i.VerticalContainerParent.ParentMeasure;
                        for (const i of n.VerticalSourceStaffEntryContainers){
                            const r = i.StaffEntries[s];
                            if (r) {
                                for (const i of r.VoiceEntries)if (i.ParentVoice !== t.ParentVoice && (!e || i.Notes.some((t)=>t.PrintObject)) && !this.voiceMostlyOnOtherStaves(i.ParentVoice, n, s)) return !0;
                            }
                        }
                        return !1;
                    }
                    voiceMostlyOnOtherStaves(t, e, i) {
                        let s = 0, n = 0;
                        for (const r of e.VerticalSourceStaffEntryContainers)r.StaffEntries.forEach((e, r)=>{
                            e?.VoiceEntries.some((e)=>e.ParentVoice === t) && (r === i ? s++ : n++);
                        });
                        return n > s;
                    }
                    setBeamNotesWantedStemDirections(t) {
                        if (!(t.Notes.length > 0)) return;
                        const e = t.Notes[0].NoteBeam;
                        if (e) {
                            for (const i of e.Notes)if (i.Notehead?.Shape !== _.NoteHeadShape.NONE && i.ParentVoiceEntry.WantedStemDirection !== c.StemDirectionType.Undefined && i.ParentVoiceEntry.ParentSourceStaffEntry.ParentStaff.Id === t.ParentSourceStaffEntry.ParentStaff.Id) {
                                t.WantedStemDirection = i.ParentVoiceEntry.WantedStemDirection;
                                break;
                            }
                        }
                    }
                }
                e.MusicSheetCalculator = V;
            },
            1932 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.MusicSheetDrawer = void 0;
                const s = i(6438), n = i(2683), r = i(6452), o = i(200), a = i(9409), l = i(8254), h = i(7435), c = i(7533), u = i(7307), d = i(4284), f = i(512), m = i(242), p = i(7499), g = i(298);
                e.MusicSheetDrawer = class {
                    constructor(t, e){
                        this.drawableBoundingBoxElement = "None", this.skyLineVisible = !1, this.bottomLineVisible = !1, this.LazyDrawSystemsFromIndex = -1, this.LazyDrawSystemsToIndexExcl = Number.POSITIVE_INFINITY, this.LazyDrawFromXUnits = Number.NEGATIVE_INFINITY, this.LazyDrawToXUnits = Number.POSITIVE_INFINITY, this.LazyDrawSystemWindows = void 0, this.LazySkipPageLabels = !1, this.LazyForcePageLabels = !1, this.phonicScoreMode = m.PhonicScoreModes.Manual, this.textMeasurer = t, this.splitScreenLineColor = -1, this.drawingParameters = e, this.rules = e.Rules;
                    }
                    set Mode(t) {
                        this.phonicScoreMode = t;
                    }
                    drawSheet(t) {
                        if (this.graphicalMusicSheet = t, this.rules = t.ParentMusicSheet.Rules, this.drawSplitScreenLine(), this.drawingParameters.drawCursors) for (const e of t.Cursors){
                            if (!e) continue;
                            const t = new s.BoundingBox(e);
                            t.AbsolutePosition = e.Start, t.BorderBottom = e.End.y - e.Start.y, t.BorderRight = e.Width / 2, t.BorderLeft = -e.Width / 2, this.isVisible(t) && this.drawLineAsVerticalRectangle(e, n.GraphicalLayers.Cursor);
                        }
                        this.drawingParameters.drawScrollIndicator && this.drawScrollIndicator();
                        const e = Math.min(this.graphicalMusicSheet.MusicPages.length, this.rules.MaxPageToDrawNumber);
                        for(let t = 0; t < e; t++){
                            const e = this.graphicalMusicSheet.MusicPages[t];
                            this.drawPage(e);
                        }
                    }
                    drawLineAsHorizontalRectangle(t, e) {
                        let i = new o.RectangleF2D(t.Start.x, t.End.y - t.Width / 2, t.End.x - t.Start.x, t.Width);
                        i = this.applyScreenTransformationForRect(i), this.renderRectangle(i, e, t.styleId, t.colorHex);
                    }
                    drawLineAsVerticalRectangle(t, e) {
                        const i = t.Start, s = t.Width;
                        let n = new o.RectangleF2D(i.x - s / 2, i.y, s, t.End.y - i.y);
                        n = this.applyScreenTransformationForRect(n), this.renderRectangle(n, e, t.styleId);
                    }
                    drawLineAsHorizontalRectangleWithOffset(t, e, i) {
                        const s = new a.PointF2D(t.Start.x + e.x, t.Start.y + e.y), n = new a.PointF2D(t.End.x + e.x, t.End.y + e.y), r = t.Width;
                        let l = new o.RectangleF2D(s.x, n.y - r / 2, n.x - s.x, r);
                        l = this.applyScreenTransformationForRect(l), this.renderRectangle(l, i, t.styleId);
                    }
                    drawLineAsVerticalRectangleWithOffset(t, e, i) {
                        const s = new a.PointF2D(t.Start.x + e.x, t.Start.y + e.y), n = new a.PointF2D(t.End.x + e.x, t.End.y + e.y), r = t.Width;
                        let l = new o.RectangleF2D(s.x, s.y, r, n.y - s.y);
                        l = this.applyScreenTransformationForRect(l), this.renderRectangle(l, i, t.styleId);
                    }
                    drawRectangle(t, e) {
                        const i = t.PositionAndShape;
                        let s = new o.RectangleF2D(i.AbsolutePosition.x, i.AbsolutePosition.y, i.BorderRight, i.BorderBottom);
                        s = this.applyScreenTransformationForRect(s), this.renderRectangle(s, e, t.style);
                    }
                    calculatePixelDistance(t) {
                        throw new Error("not implemented");
                    }
                    lazyDrawsAtX(t) {
                        return this.LazyDrawFromXUnits === Number.NEGATIVE_INFINITY && this.LazyDrawToXUnits === Number.POSITIVE_INFINITY || t > this.LazyDrawFromXUnits && t <= this.LazyDrawToXUnits;
                    }
                    lazyDrawsObject(t) {
                        return this.lazyDrawsAtX(t.AbsolutePosition.x + t.BorderRight);
                    }
                    lazyDrawsLeftEdgeOnce() {
                        return this.LazyDrawFromXUnits === Number.NEGATIVE_INFINITY;
                    }
                    drawLabel(t, e) {
                        if (!this.LazyForcePageLabels && !this.lazyDrawsObject(t.PositionAndShape)) return;
                        if (!this.isVisible(t.PositionAndShape)) return;
                        const i = t.Label;
                        if ("" === i.text.trim()) return;
                        const s = this.applyScreenTransformation(t.PositionAndShape.AbsolutePosition), n = this.calculatePixelDistance(i.fontHeight), r = this.calculatePixelDistance(t.PositionAndShape.Size.width), o = Math.ceil(r), a = Math.ceil(n * (.2 + t.TextLines.length));
                        switch(i.textAlignment){
                            case c.TextAlignmentEnum.LeftTop:
                                break;
                            case c.TextAlignmentEnum.LeftCenter:
                                s.y -= a / 2;
                                break;
                            case c.TextAlignmentEnum.LeftBottom:
                                s.y -= a;
                                break;
                            case c.TextAlignmentEnum.CenterTop:
                                s.x -= o / 2;
                                break;
                            case c.TextAlignmentEnum.CenterCenter:
                                s.x -= o / 2, s.y -= a / 2;
                                break;
                            case c.TextAlignmentEnum.CenterBottom:
                                s.x -= o / 2, s.y -= a;
                                break;
                            case c.TextAlignmentEnum.RightTop:
                                s.x -= o;
                                break;
                            case c.TextAlignmentEnum.RightCenter:
                                s.x -= o, s.y -= a / 2;
                                break;
                            case c.TextAlignmentEnum.RightBottom:
                                s.x -= o, s.y -= a;
                                break;
                            default:
                                throw new u.ArgumentOutOfRangeException("");
                        }
                        return this.renderLabel(t, e, o, a, n, s);
                    }
                    applyScreenTransformation(t) {
                        throw new Error("not implemented");
                    }
                    applyScreenTransformations(t) {
                        const e = [];
                        for (const i of t)e.push(this.applyScreenTransformation(i));
                        return e;
                    }
                    applyScreenTransformationForRect(t) {
                        throw new Error("not implemented");
                    }
                    drawSplitScreenLine() {}
                    renderRectangle(t, e, i, s, n = 1) {
                        throw new Error("not implemented");
                    }
                    drawScrollIndicator() {}
                    drawSelectionStartSymbol(t) {}
                    drawSelectionEndSymbol(t) {}
                    renderLabel(t, e, i, s, n, r) {
                        throw new Error("not implemented");
                    }
                    renderSystemToScreen(t, e, i) {}
                    drawMeasure(t) {
                        throw new Error("not implemented");
                    }
                    drawSkyLine(t) {}
                    drawBottomLine(t) {}
                    drawInstrumentBrace(t, e) {}
                    drawGroupBracket(t, e) {}
                    isVisible(t) {
                        return !0;
                    }
                    drawMusicSystem(t) {
                        const e = this.getSystemAbsBoundingRect(t), i = this.getSytemBoundingBoxInPixels(e);
                        this.drawMusicSystemComponents(t, i, e);
                    }
                    getSytemBoundingBoxInPixels(t) {
                        const e = this.applyScreenTransformationForRect(t);
                        return e.x = Math.round(e.x), e.y = Math.round(e.y), e;
                    }
                    getSystemAbsBoundingRect(t) {
                        const e = t.PositionAndShape.BoundingRectangle;
                        return new o.RectangleF2D(t.PositionAndShape.AbsolutePosition.x + t.PositionAndShape.BorderLeft - 1, t.PositionAndShape.AbsolutePosition.y + t.PositionAndShape.BorderTop - 1, e.width + 6, e.height + 2);
                    }
                    drawMusicSystemComponents(t, e, i) {
                        const s = this.graphicalMusicSheet.SelectionStartSymbol, r = this.graphicalMusicSheet.SelectionEndSymbol;
                        this.drawingParameters.drawSelectionStartSymbol && void 0 !== s && this.isVisible(s.PositionAndShape) && this.drawSelectionStartSymbol(s), this.drawingParameters.drawSelectionEndSymbol && void 0 !== r && this.isVisible(r.PositionAndShape) && this.drawSelectionEndSymbol(r);
                        for (const e of t.StaffLines)this.drawStaffLine(e), this.rules.RenderLyrics && (e.LyricsDashes.length > 0 && this.drawDashes(e.LyricsDashes), e.LyricLines.length > 0 && this.drawLyricLines(e.LyricLines, e));
                        for (const e of t.SystemLines)this.drawSystemLineObject(e);
                        if (this.rules.RenderSystemLabelsAfterFirstPage || t.Parent === t.Parent.Parent.MusicPages[0]) for (const e of t.Labels)e.SVGNode = this.drawLabel(e, n.GraphicalLayers.Notes);
                        const o = this.graphicalMusicSheet.ParentMusicSheet.Instruments, a = o.filter((t)=>t.isVisible()).length;
                        for (const e of t.InstrumentBrackets)this.drawInstrumentBrace(e, t);
                        if (o.length > 0) {
                            if (a > 1) for (const e of t.GroupBrackets)this.drawGroupBracket(e, t);
                            else for (const e of t.GroupBrackets)e.Visible = !1;
                        }
                        if (!this.leadSheet) for (const e of t.MeasureNumberLabels)e.SVGNode = this.drawLabel(e, n.GraphicalLayers.Notes), e.SVGNode?.classList?.add("measure-number");
                        for (const e of t.StaffLines)this.drawStaffLineSymbols(e);
                        this.drawingParameters.drawMarkedAreas && this.drawMarkedAreas(t), this.drawingParameters.drawComments && this.drawComment(t);
                    }
                    activateSystemRendering(t, e, i, s) {
                        return !0;
                    }
                    drawSystemLineObject(t) {}
                    drawStaffLine(t) {
                        for (const e of t.Measures)this.drawMeasure(e), e.parentSourceMeasure && (e.parentSourceMeasure.WasRendered = !0);
                        this.drawOctaveShifts(t), this.drawPedals(t), this.drawWavyLines(t), this.drawExpressions(t), this.skyLineVisible && this.lazyDrawsLeftEdgeOnce() && this.drawSkyLine(t), this.bottomLineVisible && this.lazyDrawsLeftEdgeOnce() && this.drawBottomLine(t);
                    }
                    drawLyricLines(t, e) {
                        const i = e.PositionAndShape.AbsolutePosition;
                        for (const e of t){
                            const t = new a.PointF2D(e.Start.x + i.x, e.Start.y + i.y), s = new a.PointF2D(e.End.x + i.x, e.End.y + i.y);
                            this.lazyDrawsAtX(Math.max(t.x, s.x)) && this.drawGraphicalLine(new r.GraphicalLine(t, s, e.Width), this.rules.LyricUnderscoreLineWidth, e.colorHex);
                        }
                    }
                    drawExpressions(t) {}
                    drawGraphicalLine(t, e, i = "black") {
                        return this.drawLine(t.Start, t.End, i, e);
                    }
                    drawLine(t, e, i = "#FF0000FF", s) {}
                    drawDashes(t) {
                        t.forEach((t)=>{
                            t.SVGNode = this.drawLabel(t, n.GraphicalLayers.Notes), t.SVGNode?.classList.add("dash");
                        });
                    }
                    drawOctaveShifts(t) {}
                    drawStaffLines(t) {
                        if (t.StaffLines) {
                            const e = t.PositionAndShape.AbsolutePosition;
                            for(let i = 0; i < 5; i++)this.drawLineAsHorizontalRectangleWithOffset(t.StaffLines[i], e, n.GraphicalLayers.Notes);
                        }
                    }
                    drawInstantaneousDynamic(t) {
                        throw new Error("not implemented");
                    }
                    drawContinuousDynamic(t) {
                        throw new Error("not implemented");
                    }
                    drawSymbol(t, e, i, s = 1, r = n.GraphicalLayers.Notes) {}
                    get leadSheet() {
                        return this.graphicalMusicSheet.LeadSheet;
                    }
                    set leadSheet(t) {
                        this.graphicalMusicSheet.LeadSheet = t;
                    }
                    drawPage(t) {
                        if (!this.isVisible(t.PositionAndShape)) return;
                        const e = this.LazyDrawSystemsFromIndex >= 0, i = e ? this.systemCountBefore(t) : 0;
                        for(let e = 0; e < t.MusicSystems.length; e++){
                            if (!this.lazyDrawsSystem(i + e)) continue;
                            const s = t.MusicSystems[e];
                            if (this.LazyDrawSystemWindows) {
                                const t = this.LazyDrawSystemWindows.get(s);
                                if (!t) continue;
                                this.LazyDrawFromXUnits = t.fromX, this.LazyDrawToXUnits = t.toX;
                            }
                            this.isVisible(s.PositionAndShape) && this.drawMusicSystem(s);
                        }
                        if (this.LazyDrawSystemWindows && (this.LazyDrawFromXUnits = Number.NEGATIVE_INFINITY, this.LazyDrawToXUnits = Number.POSITIVE_INFINITY), t === t.Parent.MusicPages[0] && !this.LazySkipPageLabels) {
                            const e = this.lazyDrawsSystem(i), s = this.lazyDrawsSystem(i + t.MusicSystems.length - 1), r = this.LazyForcePageLabels;
                            this.LazyForcePageLabels = !0;
                            for (const i of t.Labels)(i.AnchoredToPageBottom ? s : e) && (i.SVGNode = this.drawLabel(i, n.GraphicalLayers.Notes));
                            this.LazyForcePageLabels = r;
                        }
                        !this.drawableBoundingBoxElement || this.LazySkipPageLabels || e && !this.lazyDrawsSystem(this.lastSystemIndex(t)) || this.drawBoundingBoxes(t.PositionAndShape, 0, this.drawableBoundingBoxElement);
                    }
                    lazyDrawsSystem(t) {
                        return this.LazyDrawSystemsFromIndex < 0 || t >= this.LazyDrawSystemsFromIndex && t < this.LazyDrawSystemsToIndexExcl;
                    }
                    systemCountBefore(t) {
                        let e = 0;
                        for (const i of t.Parent.MusicPages){
                            if (i === t) break;
                            e += i.MusicSystems.length;
                        }
                        return e;
                    }
                    lastSystemIndex(t) {
                        const e = t.Parent.MusicPages, i = e[Math.min(e.length, this.rules.MaxPageToDrawNumber) - 1];
                        return this.systemCountBefore(i) + i.MusicSystems.length - 1;
                    }
                    drawBoundingBoxes(t, e = 0, i = "all", s = !1) {
                        const n = t.DataObject.constructor.name;
                        let r = !1;
                        if ("all" === i ? r = !0 : "VexFlowStaffEntry" === i ? r = t.DataObject instanceof p.VexFlowStaffEntry : "VexFlowMeasure" === i ? r = t.DataObject instanceof p.VexFlowMeasure : "VexFlowGraphicalNote" === i ? r = t.DataObject instanceof p.VexFlowGraphicalNote : "VexFlowVoiceEntry" === i ? r = t.DataObject instanceof p.VexFlowVoiceEntry : "GraphicalLabel" === i ? r = t.DataObject instanceof l.GraphicalLabel : "VexFlowStaffLine" === i ? r = t.DataObject instanceof p.VexFlowStaffLine : "SystemLine" === i ? r = t.DataObject instanceof d.SystemLine : "StaffLineActivitySymbol" === i ? r = t.DataObject instanceof g.StaffLineActivitySymbol : "VexFlowContinuousDynamicExpression" === i && (r = t.DataObject instanceof p.VexFlowContinuousDynamicExpression), r || n === i) {
                            let i;
                            s && (i = n), this.drawBoundingBox(t, void 0, !0, i, e);
                        }
                        e++, t.ChildElements.forEach((t)=>this.drawBoundingBoxes(t, e, i));
                    }
                    drawBoundingBox(t, e, i = !1, s, u = 0) {
                        let d = new o.RectangleF2D(t.AbsolutePosition.x + t.BorderMarginLeft, t.AbsolutePosition.y + t.BorderMarginTop, t.BorderMarginRight - t.BorderMarginLeft, t.BorderMarginBottom - t.BorderMarginTop);
                        i && (this.drawLineAsHorizontalRectangle(new r.GraphicalLine(new a.PointF2D(t.AbsolutePosition.x - 1, t.AbsolutePosition.y), new a.PointF2D(t.AbsolutePosition.x + 1, t.AbsolutePosition.y), .1, n.OutlineAndFillStyleEnum.BaseWritingColor, e), u - 1), this.drawLineAsVerticalRectangle(new r.GraphicalLine(new a.PointF2D(t.AbsolutePosition.x, t.AbsolutePosition.y - 1), new a.PointF2D(t.AbsolutePosition.x, t.AbsolutePosition.y + 1), .1, n.OutlineAndFillStyleEnum.BaseWritingColor, e), u - 1)), d = this.applyScreenTransformationForRect(d);
                        const f = this.renderRectangle(d, n.GraphicalLayers.Background, u, e, .5);
                        if (s) {
                            const t = new h.Label(s), e = new l.GraphicalLabel(t, .8, c.TextAlignmentEnum.CenterCenter, this.rules);
                            e.setLabelPositionAndShapeBorders(), this.renderLabel(e, u, d.width, d.height, d.height, new a.PointF2D(d.x, d.y + 12));
                        }
                        return f;
                    }
                    drawMarkedAreas(t) {
                        for (const e of t.GraphicalMarkedAreas)e && (e.systemRectangle && this.drawRectangle(e.systemRectangle, n.GraphicalLayers.Background), e.settings && (e.settings.SVGNode = this.drawLabel(e.settings, n.GraphicalLayers.Comment)), e.labelRectangle && this.drawRectangle(e.labelRectangle, n.GraphicalLayers.Background), e.label && (e.label.SVGNode = this.drawLabel(e.label, n.GraphicalLayers.Comment)));
                    }
                    drawComment(t) {
                        for (const e of t.GraphicalComments)e && (e.settings && (e.settings.SVGNode = this.drawLabel(e.settings, n.GraphicalLayers.Comment)), e.label && (e.label.SVGNode = this.drawLabel(e.label, n.GraphicalLayers.Comment)));
                    }
                    drawStaffLineSymbols(t) {
                        const e = t.ParentStaff.ParentInstrument, i = t.PositionAndShape.AbsolutePosition.x, s = t.PositionAndShape.AbsolutePosition.y + 2, o = t.PositionAndShape.BorderRight;
                        e.highlight && this.drawingParameters.drawHighlights && this.drawLineAsHorizontalRectangle(new r.GraphicalLine(new a.PointF2D(i, s), new a.PointF2D(i + o, s), 4, n.OutlineAndFillStyleEnum.Highlighted), n.GraphicalLayers.Highlight);
                        let l = m.MusicSymbolDrawingStyle.Disabled, h = f.MusicSymbol.PLAY, c = this.drawingParameters.drawActivitySymbols;
                        switch(this.phonicScoreMode){
                            case m.PhonicScoreModes.Midi:
                                h = f.MusicSymbol.PLAY, this.midiPlaybackAvailable && t.ParentStaff.audible && (l = m.MusicSymbolDrawingStyle.PlaybackSymbols);
                                break;
                            case m.PhonicScoreModes.Following:
                                h = f.MusicSymbol.MIC, t.ParentStaff.following && (l = m.MusicSymbolDrawingStyle.FollowSymbols);
                                break;
                            default:
                                c = !1;
                        }
                        if (c) {
                            const t = new a.PointF2D(i + o + 2, s);
                            this.drawSymbol(h, l, t);
                        }
                        if (this.drawingParameters.drawErrors) for (const e of t.Measures){
                            const t = e.PositionAndShape, i = t.AbsolutePosition.x, s = t.AbsolutePosition.y + 2;
                            e.hasError && this.graphicalMusicSheet.ParentMusicSheet.DrawErroneousMeasures && this.drawLineAsHorizontalRectangle(new r.GraphicalLine(new a.PointF2D(i, s), new a.PointF2D(i + t.BorderRight, s), 4, n.OutlineAndFillStyleEnum.ErrorUnderlay), n.GraphicalLayers.MeasureError);
                        }
                    }
                };
            },
            512 (t, e) {
                "use strict";
                var i;
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.MusicSymbol = void 0, function(t) {
                    t[t.Unused_first_Symbol = 0] = "Unused_first_Symbol", t[t.BLACK_HEAD = 1] = "BLACK_HEAD", t[t.UPWARDS_TAIL = 2] = "UPWARDS_TAIL", t[t.DOWNWARDS_TAIL = 3] = "DOWNWARDS_TAIL", t[t.UPWARDS_DOUBLE_TAIL = 4] = "UPWARDS_DOUBLE_TAIL", t[t.DOWNWARDS_DOUBLE_TAIL = 5] = "DOWNWARDS_DOUBLE_TAIL", t[t.UPWARDS_TRIPLE_TAIL = 6] = "UPWARDS_TRIPLE_TAIL", t[t.DOWNWARDS_TRIPLE_TAIL = 7] = "DOWNWARDS_TRIPLE_TAIL", t[t.UPWARDS_QUAD_TAIL = 8] = "UPWARDS_QUAD_TAIL", t[t.DOWNWARDS_QUAD_TAIL = 9] = "DOWNWARDS_QUAD_TAIL", t[t.ROUND_HEAD = 10] = "ROUND_HEAD", t[t.WHITE_HEAD = 11] = "WHITE_HEAD", t[t.G_CLEF = 12] = "G_CLEF", t[t.F_CLEF = 13] = "F_CLEF", t[t.C_CLEF = 14] = "C_CLEF", t[t.BREVE = 15] = "BREVE", t[t.BREVE_REST = 16] = "BREVE_REST", t[t.COMMON_TIME = 17] = "COMMON_TIME", t[t.CUT_TIME = 18] = "CUT_TIME", t[t.WHOLE_REST = 19] = "WHOLE_REST", t[t.HALF_REST = 20] = "HALF_REST", t[t.QUARTER_REST = 21] = "QUARTER_REST", t[t.EIGHTH_REST = 22] = "EIGHTH_REST", t[t.SIXTEENTH_REST = 23] = "SIXTEENTH_REST", t[t.THIRTYSECOND_REST = 24] = "THIRTYSECOND_REST", t[t.SIXTYFOURTH_REST = 25] = "SIXTYFOURTH_REST", t[t.FLAT = 26] = "FLAT", t[t.SHARP = 27] = "SHARP", t[t.NATURAL = 28] = "NATURAL", t[t.DOUBLE_FLAT = 29] = "DOUBLE_FLAT", t[t.DOUBLE_SHARP = 30] = "DOUBLE_SHARP", t[t.ZERO = 31] = "ZERO", t[t.ONE = 32] = "ONE", t[t.TWO = 33] = "TWO", t[t.THREE = 34] = "THREE", t[t.FOUR = 35] = "FOUR", t[t.FIVE = 36] = "FIVE", t[t.SIX = 37] = "SIX", t[t.SEVEN = 38] = "SEVEN", t[t.EIGHT = 39] = "EIGHT", t[t.NINE = 40] = "NINE", t[t.DOT = 41] = "DOT", t[t.FERMATA = 42] = "FERMATA", t[t.INVERTED_FERMATA = 43] = "INVERTED_FERMATA", t[t.SPICCATO = 44] = "SPICCATO", t[t.TENUTO = 45] = "TENUTO", t[t.MARCATO = 46] = "MARCATO", t[t.MARCATISSIMO = 47] = "MARCATISSIMO", t[t.INVERTED_MARCATISSIMO = 48] = "INVERTED_MARCATISSIMO", t[t.P = 49] = "P", t[t.F = 50] = "F", t[t.S = 51] = "S", t[t.Z = 52] = "Z", t[t.M = 53] = "M", t[t.R = 54] = "R", t[t.SEGNO = 55] = "SEGNO", t[t.CODA = 56] = "CODA", t[t.DRUM_CLEF = 57] = "DRUM_CLEF", t[t.G_CLEF_SUB8 = 58] = "G_CLEF_SUB8", t[t.G_CLEF_SUPER8 = 59] = "G_CLEF_SUPER8", t[t.G_CLEF_SUB15 = 60] = "G_CLEF_SUB15", t[t.G_CLEF_SUPER15 = 61] = "G_CLEF_SUPER15", t[t.F_CLEF_SUB8 = 62] = "F_CLEF_SUB8", t[t.F_CLEF_SUPER8 = 63] = "F_CLEF_SUPER8", t[t.F_CLEF_SUB15 = 64] = "F_CLEF_SUB15", t[t.F_CLEF_SUPER15 = 65] = "F_CLEF_SUPER15", t[t.DOWN_BOW = 66] = "DOWN_BOW", t[t.MORDENT = 67] = "MORDENT", t[t.INVERTED_MORDENT = 68] = "INVERTED_MORDENT", t[t.TURN = 69] = "TURN", t[t.INVERTED_TURN = 70] = "INVERTED_TURN", t[t.LEFTHAND_PIZZICATO = 71] = "LEFTHAND_PIZZICATO", t[t.RELEASE_PED = 72] = "RELEASE_PED", t[t.ENGAGE_PED = 73] = "ENGAGE_PED", t[t.VA8 = 74] = "VA8", t[t.VB8 = 75] = "VB8", t[t.TRILL = 76] = "TRILL", t[t.MA15 = 77] = "MA15", t[t.MB15 = 78] = "MB15", t[t.HIGH = 79] = "HIGH", t[t.PLAY = 80] = "PLAY", t[t.MIC = 81] = "MIC", t[t.SNAP_PIZZICATO = 82] = "SNAP_PIZZICATO", t[t.NATURAL_HARMONIC = 83] = "NATURAL_HARMONIC", t[t.EditPen = 84] = "EditPen", t[t.PEDAL_BRACKET = 85] = "PEDAL_BRACKET", t[t.PEDAL_MIXED = 86] = "PEDAL_MIXED", t[t.PEDAL_SYMBOL = 87] = "PEDAL_SYMBOL";
                }(i || (e.MusicSymbol = i = {}));
            },
            5221 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.MusicSystem = void 0;
                const s = i(9252), n = i(6438), r = i(2561), o = i(7533), a = i(8254), l = i(7741), h = i(9409), c = i(6954), u = i(3263), d = i(67), f = i(7435);
                class m extends l.GraphicalObject {
                    constructor(t){
                        super(), this.needsToBeRedrawn = !0, this.staffLines = [], this.graphicalMeasures = [], this.labels = new u.Dictionary, this.groupLabels = new Map, this.measureNumberLabels = [], this.objectsToRedraw = [], this.instrumentBrackets = [], this.groupBrackets = [], this.graphicalMarkedAreas = [], this.graphicalComments = [], this.systemLines = [], this.breaksPage = !1, this.id = t, this.boundingBox = new n.BoundingBox(this), this.maxLabelLength = 0;
                    }
                    get Parent() {
                        return this.parent;
                    }
                    set Parent(t) {
                        if (this.parent) {
                            const t = this.parent.MusicSystems.indexOf(this, 0);
                            t > -1 && this.parent.MusicSystems.splice(t, 1);
                        }
                        this.parent = t, this.boundingBox.Parent = t.PositionAndShape;
                    }
                    get NextSystem() {
                        const t = this.Parent.MusicSystems.indexOf(this);
                        return t !== this.Parent.MusicSystems.length ? this.Parent.MusicSystems[t + 1] : void 0;
                    }
                    get StaffLines() {
                        return this.staffLines;
                    }
                    set StaffLines(t) {
                        this.staffLines = t;
                    }
                    get GraphicalMeasures() {
                        return this.graphicalMeasures;
                    }
                    get MeasureNumberLabels() {
                        return this.measureNumberLabels;
                    }
                    get Labels() {
                        return [
                            ...this.groupLabels.values(),
                            ...this.labels.values()
                        ];
                    }
                    get ObjectsToRedraw() {
                        return this.objectsToRedraw;
                    }
                    get InstrumentBrackets() {
                        return this.instrumentBrackets;
                    }
                    get GroupBrackets() {
                        return this.groupBrackets;
                    }
                    get GraphicalMarkedAreas() {
                        return this.graphicalMarkedAreas;
                    }
                    get GraphicalComments() {
                        return this.graphicalComments;
                    }
                    get SystemLines() {
                        return this.systemLines;
                    }
                    get Id() {
                        return this.id;
                    }
                    get MaxLabelLength() {
                        return this.maxLabelLength;
                    }
                    createSystemLeftLine(t, e, i) {
                        let s = -t / 2;
                        i && (s = this.maxLabelLength + e - t / 2);
                        const n = this.staffLines[0].Measures[0];
                        let r;
                        this.staffLines.length > 1 && (r = this.staffLines[this.staffLines.length - 1].Measures[0]);
                        const o = this.createSystemLine(s, t, c.SystemLinesEnum.SingleThin, d.SystemLinePosition.MeasureBegin, this, n, r);
                        this.SystemLines.push(o), o.PositionAndShape.RelativePosition = new h.PointF2D(s, 0), o.PositionAndShape.BorderLeft = 0, o.PositionAndShape.BorderRight = t, o.PositionAndShape.BorderTop = o.PositionAndShape.Parent.BorderTop, o.PositionAndShape.BorderBottom = o.PositionAndShape.Parent.BorderBottom, this.createLinesForSystemLine(o);
                    }
                    createVerticalLineForMeasure(t, e, i, s, n, r) {
                        const o = r.ParentStaffLine, a = new h.PointF2D(o.PositionAndShape.RelativePosition.x, o.PositionAndShape.RelativePosition.y), l = o.ParentStaff.ParentInstrument.Staves;
                        if (o.ParentStaff === l[0]) {
                            let c;
                            l.length > 1 && (c = this.getBottomStaffLine(o).Measures[n]);
                            const u = this.createSystemLine(t, e, i, s, this, r, c), d = a.x + t;
                            u.PositionAndShape.RelativePosition = new h.PointF2D(d, 0), u.PositionAndShape.BorderLeft = 0, u.PositionAndShape.BorderRight = e, this.SystemLines.push(u);
                        }
                    }
                    setYPositionsToVerticalLineObjectsAndCreateLines(t) {}
                    calculateBorders(t) {}
                    alignBeginInstructions() {}
                    GetLeftBorderAbsoluteXPosition() {
                        return this.StaffLines[0].PositionAndShape.AbsolutePosition.x + this.StaffLines[0].Measures[0].beginInstructionsWidth;
                    }
                    GetRightBorderAbsoluteXPosition() {
                        return this.StaffLines[0].PositionAndShape.AbsolutePosition.x + this.StaffLines[0].StaffLines[0].End.x;
                    }
                    AddGraphicalMeasures(t) {
                        for(let e = 0, i = t.length; e < i; ++e)t[e].ParentMusicSystem = this;
                        this.graphicalMeasures.push(t);
                    }
                    GetSystemsFirstTimeStamp() {
                        return this.graphicalMeasures[0][0].parentSourceMeasure.AbsoluteTimestamp;
                    }
                    GetSystemsLastTimeStamp() {
                        const t = this.graphicalMeasures[this.graphicalMeasures.length - 1][0].parentSourceMeasure;
                        return r.Fraction.plus(t.AbsoluteTimestamp, t.Duration);
                    }
                    createInstrumentBrackets(t, e) {
                        for(let e = 0, i = t.length; e < i; ++e){
                            const i = t[e];
                            if (i.Staves.length > 1) {
                                let t, e;
                                for(let s = 0, n = this.staffLines.length; s < n; ++s){
                                    const n = this.staffLines[s];
                                    n.ParentStaff === i.Staves[0] && n.ParentStaff.Visible && (t = n), n.ParentStaff === i.Staves[i.Staves.length - 1] && n.ParentStaff.Visible && (e = n);
                                }
                                t && e && this.createInstrumentBracket(t, e);
                            }
                        }
                    }
                    createGroupBrackets(t, e, i) {
                        for(let s = 0, n = t.length; s < n; ++s){
                            const n = t[s];
                            if (n.InstrumentalGroups.length < 1) continue;
                            const r = this.findFirstVisibleInstrumentInInstrumentalGroup(n), o = this.findLastVisibleInstrumentInInstrumentalGroup(n);
                            if (!r || !o) continue;
                            let a, l;
                            for(let t = 0, e = this.staffLines.length; t < e; ++t){
                                const e = this.staffLines[t];
                                e.ParentStaff === r.Staves[0] && (a = e), e.ParentStaff === o.Staves[0] && (l = e);
                            }
                            a && l && this.createGroupBracket(a, l, i), n.InstrumentalGroups.length < 1 || this.createGroupBrackets(n.InstrumentalGroups, e, i + 1);
                        }
                    }
                    createMusicSystemLabel(t, e, i, s = !1) {
                        const n = e, r = [], l = this.staffLines[0]?.ParentStaff.ParentInstrument.GetMusicSheet.InstrumentalGroups ?? [];
                        this.createGroupLabels(l, 0, s, t, r);
                        for(let i = 0, n = this.staffLines.length; i < n; ++i){
                            const n = this.staffLines[i].ParentStaff.ParentInstrument;
                            let r;
                            if (s) r = n.NameLabel, this.rules.RenderPartNames && r?.print && r.text?.trim() || (r = new f.Label("", n.NameLabel.textAlignment, n.NameLabel.font), e = 0);
                            else {
                                if (!this.rules.RenderPartAbbreviations || !this.rules.RenderPartNames || 1 === this.staffLines.length && !this.rules.RenderPartAbbreviationsForSingleStaff) return;
                                if (!n.PartAbbreviation?.trim() || !n.PartAbbreviationPrintObject) {
                                    e = 0;
                                    continue;
                                }
                                const t = n.PartAbbreviation;
                                r = new f.Label(t, n.NameLabel.textAlignment, n.NameLabel.font);
                            }
                            if (n?.NameLabel?.print) {
                                const e = new a.GraphicalLabel(r, t, o.TextAlignmentEnum.LeftCenter, this.rules, this.boundingBox);
                                e.setLabelPositionAndShapeBorders(), this.labels.setValue(n, e);
                            } else e = 0;
                        }
                        let c = 0, u = !1;
                        for (const t of r){
                            if (!t?.length) continue;
                            u && (c += n);
                            let e = 0;
                            for (const i of t)i.PositionAndShape.RelativePosition = new h.PointF2D(c, 0), e = Math.max(e, i.PositionAndShape.Size.width);
                            c += e, u = !0;
                        }
                        const d = u ? c + n : 0, m = Array.from(this.groupLabels.keys());
                        this.maxLabelLength = c, this.labels.forEach((t, e)=>{
                            if (!e.Label.print || !e.Label.text?.trim()) return;
                            const i = m.some((e)=>this.instrumentBelongsToGroup(t, e)) ? d : 0;
                            e.PositionAndShape.RelativePosition = new h.PointF2D(i, 0), this.maxLabelLength = Math.max(this.maxLabelLength, i + e.PositionAndShape.Size.width);
                        }), this.maxLabelLength > 0 && (e = n), this.updateMusicSystemStaffLineXPosition(e);
                    }
                    createGroupLabels(t, e, i, n, r) {
                        if (this.rules.RenderPartGroupNames) for (const l of t){
                            if (l instanceof s.Instrument) continue;
                            const t = i ? l.Name : l.Abbreviation;
                            if ((i ? l.PrintName && this.rules.RenderPartNames : l.PrintAbbreviation && this.rules.RenderPartNames && this.rules.RenderPartAbbreviations && (1 !== this.staffLines.length || this.rules.RenderPartAbbreviationsForSingleStaff)) && t?.trim() && this.staffLinesForGroup(l).length > 0) {
                                const i = new a.GraphicalLabel(new f.Label(t), n, o.TextAlignmentEnum.LeftCenter, this.rules, this.boundingBox);
                                i.setLabelPositionAndShapeBorders(), this.groupLabels.set(l, i), r[e] || (r[e] = []), r[e].push(i);
                            }
                            this.createGroupLabels(l.InstrumentalGroups, e + 1, i, n, r);
                        }
                    }
                    instrumentBelongsToGroup(t, e) {
                        let i = t.Parent;
                        for(; i;){
                            if (i === e) return !0;
                            i = i.Parent;
                        }
                        return !1;
                    }
                    staffLinesForGroup(t) {
                        return this.staffLines.filter((e)=>this.instrumentBelongsToGroup(e.ParentStaff.ParentInstrument, t));
                    }
                    setMusicSystemLabelsYPosition() {
                        this.groupLabels.forEach((t, e)=>{
                            const i = this.staffLinesForGroup(e);
                            if (i.length > 0) {
                                const e = i[0].PositionAndShape.RelativePosition.y, s = i[i.length - 1].PositionAndShape.RelativePosition.y;
                                t.PositionAndShape.RelativePosition = new h.PointF2D(t.PositionAndShape.RelativePosition.x, (e + s) / 2 + 2);
                            }
                        }), this.labels.forEach((t, e)=>{
                            let i = 0, s = 0;
                            for(let e = 0; e < this.staffLines.length; e++)if (this.staffLines[e].ParentStaff.ParentInstrument === t) {
                                for(let n = e; n < this.staffLines.length; n++){
                                    const e = this.staffLines[n];
                                    if (e.ParentStaff.ParentInstrument !== t) break;
                                    i += e.PositionAndShape.RelativePosition.y, s++;
                                }
                                break;
                            }
                            s > 0 && (e.PositionAndShape.RelativePosition = new h.PointF2D(e.PositionAndShape.RelativePosition.x, i / s + 2));
                        });
                    }
                    checkStaffEntriesForStaffEntryLink() {
                        let t = !1, e = !1;
                        for(let i = 0; i < this.staffLines.length - 1; i++){
                            for(let e = 0, s = this.staffLines[i].Measures.length; e < s; ++e){
                                const s = this.staffLines[i].Measures[e];
                                for(let e = 0, i = s.staffEntries.length; e < i; ++e)s.staffEntries[e].sourceStaffEntry.Link && (t = !0);
                            }
                            for(let t = 0, s = this.staffLines[i + 1].Measures.length; t < s; ++t){
                                const s = this.staffLines[i + 1].Measures[t];
                                for(let t = 0, i = s.staffEntries.length; t < i; ++t)s.staffEntries[t].sourceStaffEntry.Link && (e = !0);
                            }
                        }
                        return !(!t || !e);
                    }
                    getBottomStaffLine(t) {
                        const e = t.ParentStaff.ParentInstrument.Staves;
                        let i;
                        for(let t = e.length - 1; t >= 0; t--)if (e[t]?.Visible) {
                            i = e[t];
                            break;
                        }
                        for (const e of t.ParentMusicSystem.staffLines)if (e.ParentStaff === i) return e;
                    }
                    createSystemLine(t, e, i, s, n, r, o) {
                        throw new Error("not implemented");
                    }
                    createLinesForSystemLine(t) {}
                    calcBracketsWidth() {
                        let t = 0;
                        for(let e = 0, i = this.GroupBrackets.length; e < i; ++e){
                            const i = this.GroupBrackets[e];
                            t = Math.max(t, i.PositionAndShape.Size.width);
                        }
                        for(let e = 0, i = this.InstrumentBrackets.length; e < i; ++e){
                            const i = this.InstrumentBrackets[e];
                            t = Math.max(t, i.PositionAndShape.Size.width);
                        }
                        return t;
                    }
                    createInstrumentBracket(t, e) {}
                    createGroupBracket(t, e, i) {}
                    findFirstVisibleInstrumentInInstrumentalGroup(t) {
                        for(let e = 0, i = t.InstrumentalGroups.length; e < i; ++e){
                            const i = t.InstrumentalGroups[e];
                            if (!(i instanceof s.Instrument)) return this.findFirstVisibleInstrumentInInstrumentalGroup(i);
                            if (i.isVisible()) return i;
                        }
                    }
                    findLastVisibleInstrumentInInstrumentalGroup(t) {
                        let e;
                        for(let i = t.InstrumentalGroups.length - 1; i >= 0; i--){
                            if (e = t.InstrumentalGroups[i], !(e instanceof s.Instrument)) return this.findLastVisibleInstrumentInInstrumentalGroup(e);
                            if (e.isVisible()) return e;
                        }
                    }
                    updateMusicSystemStaffLineXPosition(t) {
                        for(let e = 0, i = this.StaffLines.length; e < i; ++e){
                            const i = this.StaffLines[e], s = i.PositionAndShape.RelativePosition;
                            s.x = this.maxLabelLength + t, i.PositionAndShape.RelativePosition = s, i.PositionAndShape.BorderRight = this.boundingBox.Size.width - this.maxLabelLength - t;
                            for(let t = 0; t < i.StaffLines.length; t++){
                                const e = new h.PointF2D(i.PositionAndShape.Size.width, i.StaffLines[t].End.y);
                                i.StaffLines[t].End = e;
                            }
                        }
                    }
                }
                e.MusicSystem = m;
            },
            7066 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.MeasureBuildParameters = e.SystemBuildParameters = e.MusicSystemBuilder = void 0;
                const s = i(1888), n = i(9288), r = i(4543), o = i(164), a = i(9409), l = i(6452), h = i(6954), c = i(7921), u = i(164), d = i(813), f = i(67);
                e.MusicSystemBuilder = class {
                    constructor(){
                        this.musicSystems = [], this.globalSystemIndex = 0, this.leadSheet = !1;
                    }
                    initialize(t, e, i) {
                        this.leadSheet = t.LeadSheet, this.graphicalMusicSheet = t, this.rules = this.graphicalMusicSheet.ParentMusicSheet.Rules, this.measureList = e, this.numberOfVisibleStaffLines = i, this.activeRhythm = new Array(this.numberOfVisibleStaffLines), this.activeKeys = new Array(this.numberOfVisibleStaffLines), this.activeClefs = new Array(this.numberOfVisibleStaffLines), this.initializeActiveInstructions(this.measureList[0]);
                    }
                    buildMusicSystems() {
                        const t = this.getFullPageSystemWidth();
                        let e = !1;
                        for(this.measureListIndex = 0, this.currentSystemParams = new m, this.currentSystemParams.currentSystem = this.initMusicSystem(), this.currentSystemParams.maxLabelLength = this.currentSystemParams.currentSystem.MaxLabelLength; this.measureListIndex < this.measureList.length;){
                            const i = this.measureList[this.measureListIndex];
                            if (!i || !i[0]) {
                                this.measureListIndex++;
                                continue;
                            }
                            for(let t = 0, e = i.length; t < e; ++t)i[t].resetLayout();
                            const s = i[0].parentSourceMeasure, n = s.HasEndLine, r = n && this.rules.NewPartAndSystemAfterFinalBarline, o = this.currentSystemParams.IsSystemStartMeasure();
                            s.IsSystemStartMeasure = o;
                            const a = s === this.graphicalMusicSheet.ParentMusicSheet.getFirstSourceMeasure();
                            let l = this.rules.MeasureLeftMargin, h = 0;
                            const c = this.getMeasureStartLine();
                            if (l += this.getLineWidth(i[0], c, o), !this.leadSheet) {
                                let t = !1;
                                e && this.rules.ShowRhythmAgainAfterPartEndOrFinalBarline && (t = !0), l += this.addBeginInstructions(i, o, a || t), h += this.addEndInstructions(i);
                            }
                            let u = 0;
                            for(let t = 0; t < this.numberOfVisibleStaffLines; t++)u = Math.max(u, i[t].minimumStaffEntriesWidth);
                            const d = this.getMeasureEndLine();
                            h += this.getLineWidth(i[0], d, o);
                            let f, m = this.rules.MeasureLeftMargin;
                            if (this.measureListIndex + 1 < this.measureList.length) {
                                const t = this.measureList[this.measureListIndex + 1];
                                f = t[0]?.parentSourceMeasure, f?.hasBeginInstructions() && (m += this.addBeginInstructions(t, !1, !1));
                            }
                            let p = l + h + u;
                            if (i[0]?.parentSourceMeasure?.multipleRestMeasures) {
                                u = this.rules.MultipleRestMeasureDefaultWidth, p = l + h + u;
                                for(let t = 0; t < this.numberOfVisibleStaffLines; t++)i[t] && (i[t].minimumStaffEntriesWidth = u);
                            }
                            const g = this.currentSystemParams.systemMeasures.length, b = this.currentSystemParams.maxLabelLength > 0 ? this.currentSystemParams.maxLabelLength + this.rules.SystemLabelsRightMargin : 0, S = this.currentSystemParams.currentWidth + p + m + b < t, y = this.rules.NewPageAtXMLNewPageAttribute && s.printNewPageXml, E = y || this.rules.NewSystemAtXMLNewPageAttribute && s.printNewPageXml || this.rules.NewSystemAtXMLNewSystemAttribute && s.printNewSystemXml || g === this.rules.RenderXMeasuresPerLineAkaSystem && g > 0;
                            if (o || S && !E) {
                                if (this.addMeasureToSystem(i, c, d, p, l, u, h), this.updateActiveClefs(s, i), this.measureListIndex++, r) {
                                    if (this.rules.MaxSystemToDrawNumber === this.musicSystems.length) return this.finalizeCurrentSystem(i, !this.rules.StretchLastSystemLine, !1), this.musicSystems;
                                    this.finalizeCurrentAndCreateNewSystem(i, !this.rules.StretchLastSystemLine, !1);
                                }
                                e = n;
                            } else {
                                if (this.rules.MaxSystemToDrawNumber === this.musicSystems.length) return this.finalizeCurrentSystem(i, !1, !0, y), this.musicSystems;
                                this.finalizeCurrentAndCreateNewSystem(i, !1, !0, y);
                            }
                        }
                        if (this.currentSystemParams.systemMeasures.length > 0) {
                            if (this.rules.MaxSystemToDrawNumber === this.musicSystems.length) return this.finalizeCurrentSystem(this.measureList[this.measureList.length - 1], !this.rules.StretchLastSystemLine, !1), this.musicSystems;
                            this.finalizeCurrentAndCreateNewSystem(this.measureList[this.measureList.length - 1], !this.rules.StretchLastSystemLine, !1);
                        }
                        return this.musicSystems;
                    }
                    calculateSystemYLayout() {
                        for (const t of this.musicSystems)this.optimizeDistanceBetweenStaffLines(t);
                        this.calculateMusicSystemsRelativePositions();
                    }
                    setMeasureWidth(t, e, i, s) {
                        for(let n = 0, r = t.length; n < r; ++n){
                            const r = t[n];
                            r.setWidth(e), i > 0 && (r.beginInstructionsWidth = i), s > 0 && (r.endInstructionsWidth = s);
                        }
                    }
                    finalizeCurrentAndCreateNewSystem(t, e = !1, i = !0, s = !1) {
                        this.finalizeCurrentSystem(t, e, i, s), this.currentSystemParams = new m, void 0 !== t && this.measureListIndex < this.measureList.length && (this.currentSystemParams.currentSystem = this.initMusicSystem(), this.currentSystemParams.maxLabelLength = this.currentSystemParams.currentSystem.MaxLabelLength);
                    }
                    finalizeCurrentSystem(t, e = !1, i = !0, s = !1) {
                        this.currentSystemParams.currentSystem.breaksPage = s, this.adaptRepetitionLineWithIfNeeded(), void 0 !== t && i && this.checkAndCreateExtraInstructionMeasure(t), this.stretchMusicSystem(e);
                    }
                    adaptRepetitionLineWithIfNeeded() {
                        const t = this.currentSystemParams.systemMeasures;
                        if (t.length >= 1) {
                            const e = this.currentSystemParams.currentSystem.GraphicalMeasures[this.currentSystemParams.currentSystem.GraphicalMeasures.length - 1];
                            let i = 0;
                            const s = t[t.length - 1];
                            s.endLine === h.SystemLinesEnum.DotsBoldBoldDots && (s.endLine = h.SystemLinesEnum.DotsThinBold, i = e[0].getLineWidth(h.SystemLinesEnum.DotsBoldBoldDots) / 2 - e[0].getLineWidth(h.SystemLinesEnum.DotsThinBold)), this.currentSystemParams.currentSystemFixWidth -= i;
                            for(let t = 0, s = e.length; t < s; ++t)e[t].endInstructionsWidth -= i;
                        }
                    }
                    addMeasureToSystem(t, e, i, s, n, r, o) {
                        this.currentSystemParams.systemMeasures.push({
                            beginLine: e,
                            endLine: i
                        }), this.setMeasureWidth(t, s, n, o), this.addStaveMeasuresToSystem(t), this.currentSystemParams.currentWidth += s, this.currentSystemParams.currentSystemFixWidth += n + o, this.currentSystemParams.currentSystemVarWidth += r, this.currentSystemParams.systemMeasureIndex++;
                    }
                    initMusicSystem() {
                        const t = c.MusicSheetCalculator.symbolFactory.createMusicSystem(this.globalSystemIndex++, this.rules);
                        return this.musicSystems.push(t), this.layoutSystemStaves(t), t.createMusicSystemLabel(this.rules.InstrumentLabelTextHeight, this.rules.SystemLabelsRightMargin, this.rules.LabelMarginBorderFactor, 1 === this.musicSystems.length), t;
                    }
                    getFullPageSystemWidth() {
                        return this.graphicalMusicSheet.ParentMusicSheet.pageWidth - this.rules.PageLeftMargin - this.rules.PageRightMargin - this.rules.SystemLeftMargin - this.rules.SystemRightMargin;
                    }
                    layoutSystemStaves(t) {
                        const e = this.getFullPageSystemWidth(), i = t.PositionAndShape;
                        i.BorderLeft = 0, i.BorderRight = e, i.BorderTop = 0;
                        const s = [], n = this.graphicalMusicSheet.ParentMusicSheet.Instruments;
                        for(let t = 0, e = n.length; t < e; ++t){
                            const e = n[t];
                            if (e.isVisible() && 0 !== e.Voices.length) for(let t = 0, i = e.Staves.length; t < i; ++t){
                                const i = e.Staves[t];
                                i?.Visible && s.push(i);
                            }
                        }
                        let r = !1;
                        if (this.leadSheet) {
                            for(let t = 0, e = s.length; t < e; ++t)if (s[t].ParentInstrument.LyricVersesNumbers.length > 1) {
                                r = !0;
                                break;
                            }
                        }
                        let o = 0;
                        for(let e = 0; e < s.length; e++)if (this.addStaffLineToMusicSystem(t, o, s[e]), o += this.rules.StaffHeight, e + 1 < s.length) {
                            let t = 0;
                            t = this.leadSheet && !r ? 2.5 : s[e].ParentInstrument === s[e + 1].ParentInstrument ? this.rules.BetweenStaffDistance : this.rules.StaffDistance, o += t;
                        }
                        i.BorderBottom = o;
                    }
                    addStaffLineToMusicSystem(t, e, i) {
                        if (t) {
                            const s = c.MusicSheetCalculator.symbolFactory.createStaffLine(t, i);
                            t.StaffLines.push(s);
                            const n = s.PositionAndShape, r = new a.PointF2D;
                            r.x = 0, n.BorderRight = t.PositionAndShape.Size.width, r.y = e, n.RelativePosition = r, n.BorderLeft = 0, n.BorderTop = 0, n.BorderBottom = this.rules.StaffHeight;
                            for(let t = 0; t < 5; t++){
                                const e = new a.PointF2D;
                                e.x = 0, e.y = t * this.rules.StaffHeight / 4;
                                const i = new a.PointF2D;
                                i.x = s.PositionAndShape.Size.width, i.y = t * this.rules.StaffHeight / 4, this.leadSheet && (e.y = i.y = 0), s.StaffLines[t] = new l.GraphicalLine(e, i, this.rules.StaffLineWidth);
                            }
                        }
                    }
                    initializeActiveInstructions(t) {
                        const e = this.graphicalMusicSheet.ParentMusicSheet.getFirstSourceMeasure();
                        if (e) {
                            this.visibleStaffIndices = this.graphicalMusicSheet.getVisibleStavesIndicesFromSourceMeasure(t);
                            for(let t = 0, i = this.visibleStaffIndices.length; t < i; t++){
                                const i = this.visibleStaffIndices[t], s = this.graphicalMusicSheet.getGraphicalMeasureFromSourceMeasureAndIndex(e, i);
                                this.activeClefs[t] = e.FirstInstructionsStaffEntries[i].Instructions[0], s.InitiallyActiveClef = this.activeClefs[t];
                                const n = e.FirstInstructionsStaffEntries[i].Instructions[1];
                                if (n) {
                                    let e = r.KeyInstruction.copy(n);
                                    e = this.transposeKeyInstruction(e, s), this.activeKeys[t] = e;
                                }
                                const o = e.FirstInstructionsStaffEntries[i].Instructions[2];
                                this.activeRhythm[t] = o;
                            }
                            const i = this.graphicalMusicSheet.ParentMusicSheet.SourceMeasures;
                            for(let t = 0; t < this.rules.MinMeasureToDrawIndex; t++){
                                const e = i[t];
                                if (e) for(let t = 0, i = this.visibleStaffIndices.length; t < i; t++){
                                    const i = this.visibleStaffIndices[t], s = e.FirstInstructionsStaffEntries[i];
                                    if (s) for(let e = 0, i = s.Instructions.length; e < i; ++e){
                                        const i = s.Instructions[e];
                                        i instanceof o.ClefInstruction ? this.activeClefs[t] = i : i instanceof r.KeyInstruction ? this.activeKeys[t] = i : i instanceof n.RhythmInstruction && (this.activeRhythm[t] = i);
                                    }
                                    const a = e.getEntriesPerStaff(i);
                                    for(let e = 0, i = a.length; e < i; ++e){
                                        const i = a[e];
                                        if (i.Instructions) for(let e = 0, s = i.Instructions.length; e < s; ++e){
                                            const s = i.Instructions[e];
                                            s instanceof o.ClefInstruction ? this.activeClefs[t] = s : s instanceof r.KeyInstruction && (this.activeKeys[t] = s);
                                        }
                                    }
                                    const l = e.LastInstructionsStaffEntries[i];
                                    if (l) for(let e = 0, i = l.Instructions.length; e < i; ++e){
                                        const i = l.Instructions[e];
                                        i instanceof o.ClefInstruction && (this.activeClefs[t] = i);
                                    }
                                }
                            }
                        }
                    }
                    transposeKeyInstruction(t, e) {
                        const i = e.getTransposedHalftones();
                        return i !== t.isTransposedBy && e.ParentStaff.ParentInstrument.MidiInstrumentId !== u.MidiInstrument.Percussion && void 0 !== c.MusicSheetCalculator.transposeCalculator && c.MusicSheetCalculator.transposeCalculator.transposeKey(t, i), t;
                    }
                    addBeginInstructions(t, e, i) {
                        const s = t.length;
                        if (0 === s) return 0;
                        let n = 0;
                        const r = t[0].parentSourceMeasure, o = [];
                        for(let a = 0; a < s; ++a){
                            const s = t[a];
                            s && o.push(s.getVFStave());
                            const l = this.visibleStaffIndices[a], h = r.FirstInstructionsStaffEntries[l], c = this.AddInstructionsAtMeasureBegin(h, s, a, i, e);
                            n = Math.max(n, c);
                        }
                        return o[0].formatBegModifiers(o), n;
                    }
                    addEndInstructions(t) {
                        const e = t.length;
                        if (0 === e) return 0;
                        let i = .5;
                        const s = t[0].parentSourceMeasure;
                        for(let n = 0; n < e; n++){
                            const e = t[n], r = this.visibleStaffIndices[n], o = s.LastInstructionsStaffEntries[r], a = this.addInstructionsAtMeasureEnd(o, e, t);
                            i = Math.max(i, a);
                        }
                        return i;
                    }
                    AddInstructionsAtMeasureBegin(t, e, i, s, a) {
                        let l, h, c, u = 0;
                        if (t) for(let e = 0, i = t.Instructions.length; e < i; ++e){
                            const i = t.Instructions[e];
                            i instanceof o.ClefInstruction ? l = i : i instanceof r.KeyInstruction ? h = i : i instanceof n.RhythmInstruction && (c = i);
                        }
                        e.InitiallyActiveClef = l ?? this.activeClefs[i], a && (l || (l = this.activeClefs[i]), h || (h = r.KeyInstruction.copy(this.activeKeys[i])), s && !c && (c = this.activeRhythm[i]));
                        let d = !1, f = !1, m = !1;
                        if (l ? (e.addClefAtBegin(l), d = !0) : l = this.activeClefs[i], h) {
                            h = this.transposeKeyInstruction(h, e);
                            const t = a ? void 0 : this.activeKeys[i];
                            e.addKeyAtBegin(h, t, l), f = !0;
                        }
                        if (void 0 !== c && c.PrintObject && this.rules.RenderTimeSignatures && (!c.SynthesizedFromNoTimeSignature || this.rules.RenderTimeSignaturesForSamplesWithoutTimeSignature)) {
                            let t = !0;
                            const i = e.MeasureNumber - 1 - this.rules.MinMeasureToDrawIndex;
                            if (e.MeasureNumber - 1 >= 0 && this.measureList[i]) {
                                const e = this.measureList[i], s = e[0]?.parentSourceMeasure;
                                s?.ImplicitMeasure && s?.RhythmPrinted && (t = !1);
                            }
                            t && (e.addRhythmAtBegin(c), e.parentSourceMeasure.RhythmPrinted = c, m = !0);
                        }
                        return (d || f || m) && (u += e.beginInstructionsWidth, m && (u += this.rules.RhythmRightMargin)), u;
                    }
                    addInstructionsAtMeasureEnd(t, e, i) {
                        if (!t || !t.Instructions || 0 === t.Instructions.length) return 0;
                        for(let s = 0, n = t.Instructions.length; s < n; ++s){
                            const n = t.Instructions[s];
                            if (n instanceof o.ClefInstruction) {
                                const t = n;
                                e.addClefAtEnd(t);
                                for (const s of i)s !== e && s.addClefAtEnd(t, !1);
                            }
                        }
                        return this.rules.MeasureRightMargin + e.endInstructionsWidth;
                    }
                    updateActiveClefs(t, e) {
                        for(let i = 0, s = e.length; i < s; i++){
                            const e = this.visibleStaffIndices[i], s = t.FirstInstructionsStaffEntries[e];
                            if (s) for(let t = 0, e = s.Instructions.length; t < e; ++t){
                                const e = s.Instructions[t];
                                e instanceof o.ClefInstruction ? this.activeClefs[i] = e : e instanceof r.KeyInstruction ? this.activeKeys[i] = e : e instanceof n.RhythmInstruction && (this.activeRhythm[i] = e);
                            }
                            const a = t.getEntriesPerStaff(e);
                            for(let t = 0, e = a.length; t < e; ++t){
                                const e = a[t];
                                if (e.Instructions) for(let t = 0, s = e.Instructions.length; t < s; ++t){
                                    const s = e.Instructions[t];
                                    s instanceof o.ClefInstruction ? this.activeClefs[i] = s : s instanceof r.KeyInstruction && (this.activeKeys[i] = s);
                                }
                            }
                            const l = t.LastInstructionsStaffEntries[e];
                            if (l) {
                                const t = l.Instructions;
                                for(let e = 0, s = t.length; e < s; ++e){
                                    const s = t[e];
                                    s instanceof o.ClefInstruction && (this.activeClefs[i] = s);
                                }
                            }
                        }
                    }
                    checkAndCreateExtraInstructionMeasure(t) {
                        const e = t[0].parentSourceMeasure.FirstInstructionsStaffEntries, i = [];
                        for(let s = 0, n = t.length; s < n; ++s){
                            const n = t[s];
                            i.push(e[n.ParentStaff.idInMusicSheet]);
                        }
                        let s = 0;
                        for(let t = 0, e = i.length; t < e; ++t){
                            const e = i[t];
                            if (!e) continue;
                            const o = e.Instructions;
                            let a, l;
                            for(let e = 0, i = o.length; e < i; ++e){
                                const i = o[e];
                                i instanceof r.KeyInstruction && i.Key !== this.activeKeys[t].Key && (a = i), i instanceof n.RhythmInstruction && i !== this.activeRhythm[t] && (l = i);
                            }
                            if (void 0 !== a || l) {
                                const e = this.addExtraInstructionMeasure(t, a, l);
                                s = Math.max(s, e);
                            }
                        }
                        s > 0 && (this.currentSystemParams.systemMeasures.push({
                            beginLine: h.SystemLinesEnum.None,
                            endLine: h.SystemLinesEnum.None
                        }), this.currentSystemParams.currentWidth += s, this.currentSystemParams.currentSystemFixWidth += s);
                    }
                    addExtraInstructionMeasure(t, e, i) {
                        const s = this.currentSystemParams.currentSystem, n = c.MusicSheetCalculator.symbolFactory.createExtraGraphicalMeasure(s.StaffLines[t]);
                        [].push(n), e && n.addKeyAtBegin(e, this.activeKeys[t], this.activeClefs[t]), void 0 !== i && i.PrintObject && n.addRhythmAtBegin(i), n.PositionAndShape.BorderLeft = 0, n.PositionAndShape.BorderTop = 0, n.PositionAndShape.BorderBottom = this.rules.StaffHeight;
                        const r = this.rules.MeasureLeftMargin + n.beginInstructionsWidth + this.rules.MeasureRightMargin;
                        return n.PositionAndShape.BorderRight = r, n.minimumStaffEntriesWidth = 0, s.StaffLines[t].Measures.push(n), r;
                    }
                    addStaveMeasuresToSystem(t) {
                        if (t[0]) {
                            const e = [];
                            for(let i = 0; i < t.length; i++)e.push(t[i]);
                            const i = this.currentSystemParams.currentSystem;
                            for(let t = 0; t < this.numberOfVisibleStaffLines; t++){
                                const s = e[t];
                                i.StaffLines[t].Measures.push(s), s.ParentStaffLine = i.StaffLines[t];
                            }
                            i.AddGraphicalMeasures(e);
                        }
                    }
                    getMeasureStartLine() {
                        if (this.thisMeasureBeginsLineRepetition()) {
                            const t = 0 === this.measureListIndex;
                            if (t && this.rules.RepetitionAllowFirstMeasureBeginningRepeatBarline) return h.SystemLinesEnum.BoldThinDots;
                            const e = this.currentSystemParams.IsSystemStartMeasure();
                            if (this.previousMeasureEndsLineRepetition() && !e) return h.SystemLinesEnum.DotsBoldBoldDots;
                            if (!t) return h.SystemLinesEnum.BoldThinDots;
                        }
                        return h.SystemLinesEnum.None;
                    }
                    getMeasureEndLine() {
                        let t;
                        if (t = this.measureList[this.measureListIndex][0].parentSourceMeasure, this.rules.RenderMultipleRestMeasures && t.multipleRestMeasures > 1) {
                            const e = Math.min(this.graphicalMusicSheet.ParentMusicSheet.SourceMeasures.length - 1, t.measureListIndex + t.multipleRestMeasures - 1);
                            t = this.graphicalMusicSheet.ParentMusicSheet.SourceMeasures[e];
                        }
                        if (this.nextMeasureBeginsLineRepetition() && this.thisMeasureEndsLineRepetition()) return h.SystemLinesEnum.DotsBoldBoldDots;
                        if (this.thisMeasureEndsLineRepetition()) return h.SystemLinesEnum.DotsThinBold;
                        const e = t?.endingBarStyleEnum, i = e === h.SystemLinesEnum.ThinBold || e === h.SystemLinesEnum.DoubleBold || e === h.SystemLinesEnum.None;
                        return this.nextMeasureHasKeyInstructionChange() && !i ? h.SystemLinesEnum.DoubleThin : t && void 0 !== t.endingBarStyleEnum ? t.endingBarStyleEnum : h.SystemLinesEnum.SingleThin;
                    }
                    getLineWidth(t, e, i) {
                        let s = t.getLineWidth(e);
                        return e === h.SystemLinesEnum.DotsBoldBoldDots && (s /= 2), i && e === h.SystemLinesEnum.BoldThinDots && (s += this.rules.DistanceBetweenLastInstructionAndRepetitionBarline), s;
                    }
                    previousMeasureEndsLineRepetition() {
                        if (0 === this.measureListIndex) return !1;
                        for(let t = 0, e = this.measureList[this.measureListIndex - 1].length; t < e; ++t)if (this.measureList[this.measureListIndex - 1][t].endsWithLineRepetition()) return !0;
                        return !1;
                    }
                    thisMeasureBeginsLineRepetition() {
                        for(let t = 0, e = this.measureList[this.measureListIndex].length; t < e; ++t)if (this.measureList[this.measureListIndex][t].beginsWithLineRepetition()) return !0;
                        return !1;
                    }
                    nextMeasureBeginsLineRepetition() {
                        const t = this.measureListIndex + 1;
                        if (t >= this.graphicalMusicSheet.ParentMusicSheet.SourceMeasures.length || !this.measureList[t]) return !1;
                        for(let e = 0, i = this.measureList[t].length; e < i; ++e)if (this.measureList[t][e].beginsWithLineRepetition()) return !0;
                        return !1;
                    }
                    thisMeasureEndsLineRepetition() {
                        for(let t = 0, e = this.measureList[this.measureListIndex].length; t < e; ++t){
                            const e = this.measureList[this.measureListIndex][t];
                            if (e.endsWithLineRepetition()) return !0;
                            if (e.parentSourceMeasure?.isReducedToMultiRest) {
                                const t = this.graphicalMusicSheet.ParentMusicSheet;
                                let i = e.parentSourceMeasure;
                                const s = t.SourceMeasures.indexOf(i);
                                let n = i.multipleRestMeasureNumber;
                                for(let e = s + 1; e < t.SourceMeasures.length; e++){
                                    const s = t.SourceMeasures[e];
                                    if (!(s.multipleRestMeasureNumber >= n)) break;
                                    i = s, n = s.multipleRestMeasureNumber;
                                }
                                return i.endsWithLineRepetition();
                            }
                        }
                        return !1;
                    }
                    nextMeasureBeginsWordRepetition() {
                        const t = this.measureListIndex + 1;
                        if (t >= this.graphicalMusicSheet.ParentMusicSheet.SourceMeasures.length || t > this.measureList.length - 1) return !1;
                        for(let e = 0, i = this.measureList[t].length; e < i; ++e)if (this.measureList[t][e].beginsWithWordRepetition()) return !0;
                        return !1;
                    }
                    thisMeasureEndsWordRepetition() {
                        for(let t = 0, e = this.measureList[this.measureListIndex].length; t < e; ++t)if (this.measureList[this.measureListIndex][t].endsWithWordRepetition()) return !0;
                        return !1;
                    }
                    nextMeasureHasKeyInstructionChange() {
                        return void 0 !== this.getNextMeasureKeyInstruction();
                    }
                    getNextMeasureKeyInstruction() {
                        if (this.measureListIndex < this.measureList.length - 1) for(let t = 0; t < this.measureList[this.measureListIndex].length; t++){
                            const e = this.measureList[this.measureListIndex + 1][t]?.parentSourceMeasure;
                            if (!e) return;
                            const i = e.getKeyInstruction(this.visibleStaffIndices[t]);
                            if (i) return i;
                        }
                    }
                    calculateXScalingFactor(t, e) {
                        return Math.abs(e - 0) < 1e-5 || Math.abs(t - 0) < 1e-5 ? 1 : (this.currentSystemParams.currentSystem.StaffLines[0].PositionAndShape.Size.width - t) / e;
                    }
                    stretchMusicSystem(t) {
                        let e = this.calculateXScalingFactor(this.currentSystemParams.currentSystemFixWidth, this.currentSystemParams.currentSystemVarWidth);
                        t && (e = Math.min(e, this.rules.LastSystemMaxScalingFactor));
                        const i = this.currentSystemParams.currentSystem;
                        for(let t = 0, s = i.StaffLines.length; t < s; ++t){
                            const s = i.StaffLines[t];
                            let n = 0;
                            for(let t = 0; t < s.Measures.length; t++){
                                const r = s.Measures[t];
                                r.setPositionInStaffline(n);
                                const o = r.beginInstructionsWidth;
                                if (r.setWidth(o + r.minimumStaffEntriesWidth * e + r.endInstructionsWidth), t < this.currentSystemParams.systemMeasures.length) {
                                    const e = this.currentSystemParams.systemMeasures[t].beginLine, s = r.getLineWidth(h.SystemLinesEnum.BoldThinDots);
                                    if (e === h.SystemLinesEnum.BoldThinDots) {
                                        let o = n;
                                        0 === t && (o = n + r.beginInstructionsWidth - s), i.createVerticalLineForMeasure(o, s, e, f.SystemLinePosition.MeasureBegin, t, r);
                                    }
                                }
                                if (r.staffEntriesScaleFactor = e, r.layoutSymbols(), !(t + 1 < this.currentSystemParams.systemMeasures.length && this.currentSystemParams.systemMeasures[t + 1].beginLine === h.SystemLinesEnum.BoldThinDots)) {
                                    let e = h.SystemLinesEnum.SingleThin;
                                    t < this.currentSystemParams.systemMeasures.length && (e = this.currentSystemParams.systemMeasures[t].endLine);
                                    const s = r.getLineWidth(e);
                                    let n = r.PositionAndShape.RelativePosition.x + r.PositionAndShape.BorderRight - s;
                                    e === h.SystemLinesEnum.DotsBoldBoldDots && (n -= s / 2), i.createVerticalLineForMeasure(n, s, e, f.SystemLinePosition.MeasureEnd, t, r);
                                }
                                n = r.PositionAndShape.RelativePosition.x + r.PositionAndShape.BorderRight;
                            }
                        }
                        t && this.decreaseMusicSystemBorders();
                    }
                    decreaseMusicSystemBorders() {
                        const t = this.currentSystemParams.currentSystem, e = d.CollectionUtil.last(t.StaffLines[0].Measures).PositionAndShape, i = e.RelativePosition.x + e.Size.width;
                        for(let e = 0, s = t.StaffLines.length; e < s; ++e){
                            const s = t.StaffLines[e];
                            s.PositionAndShape.BorderRight = i;
                            for(let t = 0, e = s.StaffLines.length; t < e; ++t){
                                const e = s.StaffLines[t];
                                e.End = new a.PointF2D(i, e.End.y);
                            }
                        }
                        t.PositionAndShape.BorderRight = i + this.currentSystemParams.maxLabelLength + this.rules.SystemLabelsRightMargin;
                    }
                    updateStaffLinesRelativePosition(t, e, i) {
                        for(let s = e; s < t.StaffLines.length; s++)t.StaffLines[s].PositionAndShape.RelativePosition.y = i;
                        t.PositionAndShape.BorderBottom += i;
                    }
                    createMusicPage() {
                        const t = new s.GraphicalMusicPage(this.graphicalMusicSheet);
                        return this.graphicalMusicSheet.MusicPages.push(t), t.PageNumber = this.graphicalMusicSheet.MusicPages.length, t.PositionAndShape.BorderLeft = 0, t.PositionAndShape.BorderRight = this.graphicalMusicSheet.ParentMusicSheet.pageWidth, t.PositionAndShape.BorderTop = 0, t.PositionAndShape.BorderBottom = this.rules.PageHeight, t.PositionAndShape.RelativePosition = new a.PointF2D(0, 0), t;
                    }
                    addSystemToPage(t, e) {
                        t.MusicSystems.push(e), e.Parent = t;
                    }
                    optimizeDistanceBetweenStaffLines(t) {
                        if (!t.checkStaffEntriesForStaffEntryLink()) for(let e = 0; e < t.StaffLines.length - 1; e++){
                            const i = t.StaffLines[e].BottomLine, s = t.StaffLines[e + 1].SkyLine;
                            let n = 0;
                            for(let t = 0; t < i.length; t++){
                                const e = i[t], r = Math.max(0, t - 6), o = Math.min(s.length - 1, t + 6);
                                let a = 0;
                                for(let t = r; t <= o; t++)a = Math.min(a, s[t]);
                                const l = e - a;
                                n = Math.max(l, n);
                            }
                            n += this.rules.MinSkyBottomDistBetweenStaves, n = Math.max(n, this.rules.StaffHeight + this.rules.MinimumStaffLineDistance), n = this.rules.SnapStafflinesToCrispPixels ? Math.round(10 * n) / 10 : Math.round(20 * n) / 20;
                            const r = n + t.StaffLines[e].PositionAndShape.RelativePosition.y;
                            this.updateStaffLinesRelativePosition(t, e + 1, r);
                        }
                        const e = t.StaffLines[0];
                        t.PositionAndShape.BorderTop = e.PositionAndShape.RelativePosition.y + e.PositionAndShape.BorderTop;
                        const i = t.StaffLines[t.StaffLines.length - 1];
                        t.PositionAndShape.BorderBottom = i.PositionAndShape.RelativePosition.y + i.PositionAndShape.BorderBottom;
                    }
                    snapSystemYToCrispStaffLines(t, e) {
                        if (!this.rules.SnapStafflinesToCrispPixels || !t.StaffLines[0]) return e;
                        const i = e + t.StaffLines[0].PositionAndShape.RelativePosition.y;
                        return e + (Math.round(10 * i - .5) + .5) / 10 - i;
                    }
                    pageTopBorder(t) {
                        const e = t.PositionAndShape.BorderTop;
                        return this.rules.SnapStafflinesToCrispPixels ? Math.round(10 * e) / 10 : Math.round(20 * e) / 20;
                    }
                    copyrightHeightBelowSystems() {
                        const t = this.graphicalMusicSheet.Copyright;
                        return t && this.rules.RenderCopyright && "" !== t.Label.text.trim() ? this.rules.SheetCopyrightMargin + t.PositionAndShape.BorderBottom - t.PositionAndShape.BorderTop : 0;
                    }
                    calculateMusicSystemsRelativePositions() {
                        let t = this.createMusicPage(), e = 0, i = 0, s = 0, n = this.musicSystems[0], r = 0;
                        for(let o = 0; o < this.musicSystems.length; o++)if (n = this.musicSystems[o], 0 === t.MusicSystems.length) {
                            if (this.addSystemToPage(t, n), i = this.pageTopBorder(n), s = 1 === this.graphicalMusicSheet.MusicPages.length ? this.copyrightHeightBelowSystems() : 0, e = this.rules.CompactMode ? this.rules.PageTopMarginNarrow : this.rules.PageTopMargin, 1 === this.graphicalMusicSheet.MusicPages.length) {
                                this.rules.RenderTitle && (e += this.rules.TitleTopDistance + this.rules.SheetTitleHeight + this.rules.TitleBottomDistance);
                                const t = this.graphicalMusicSheet.FirstPageCreditWords;
                                if (t.length > 0) {
                                    const i = t[t.length - 1], s = i.PositionAndShape.RelativePosition.y + i.PositionAndShape.BorderBottom, n = this.graphicalMusicSheet.Composer, r = this.graphicalMusicSheet.Lyricist, o = Math.max(n ? n.PositionAndShape.MarginSize.height + this.rules.SystemComposerDistance : 0, r ? r.PositionAndShape.MarginSize.height + this.rules.SystemLyricistDistance : 0);
                                    e = Math.max(e, s + o + 1);
                                }
                            }
                            e = this.snapSystemYToCrispStaffLines(n, e);
                            const o = new a.PointF2D(this.rules.PageLeftMargin + this.rules.SystemLeftMargin, e);
                            n.PositionAndShape.RelativePosition = o, e - i + n.PositionAndShape.BorderBottom + s > this.rules.PageHeight - this.rules.PageBottomMargin && (r++, r <= 4 && console.log(`warning: could not fit a single system on page ${t.PageNumber} and measure number ${n.GraphicalMeasures[0][0].MeasureNumber}.\n                            The PageFormat may be too small for this sheet."\n                            Will not give further warnings for all pages, only total.`));
                        } else {
                            const r = this.musicSystems[o - 1], l = r.StaffLines[r.StaffLines.length - 1], h = l.PositionAndShape;
                            let c = this.findRequiredDistanceWithSkyBottomLine(r, n);
                            c += this.rules.MinSkyBottomDistBetweenSystems, c = Math.max(c, this.rules.MinimumDistanceBetweenSystems + l.StaffHeight), c = Math.round(20 * c) / 20;
                            let u = e + h.RelativePosition.y + c;
                            u = this.snapSystemYToCrispStaffLines(n, u);
                            const d = u + n.PositionAndShape.BorderMarginBottom - i + s;
                            if (this.rules.NewPageAtXMLNewPageAttribute && r.breaksPage || !(d < this.rules.PageHeight - this.rules.PageBottomMargin)) {
                                t = this.createMusicPage(), o -= 1;
                                continue;
                            }
                            {
                                this.addSystemToPage(t, n), e = u;
                                const i = new a.PointF2D(this.rules.PageLeftMargin + this.rules.SystemLeftMargin, e);
                                n.PositionAndShape.RelativePosition = i;
                            }
                        }
                        r > 0 && console.log(`total amount of pages that couldn't fit a single music system: ${r} of ${t.PageNumber}`);
                    }
                    findRequiredDistanceWithSkyBottomLine(t, e) {
                        const i = t.StaffLines[t.StaffLines.length - 1], s = e.StaffLines[0], n = i.BottomLine, r = s.SkyLine, o = i.PositionAndShape, a = s.PositionAndShape, l = 1 / this.rules.SamplingUnit;
                        let h = 0;
                        for(let t = 0; t < n.length; t++){
                            const e = n[t], i = t + Math.round((o.RelativePosition.x - a.RelativePosition.x) * l);
                            if (i < 0) continue;
                            if (i >= r.length) break;
                            const s = Math.max(0, i - 6), c = Math.min(r.length - 1, i + 6);
                            let u = 0;
                            for(let t = s; t <= c; t++)u = Math.min(u, r[t]);
                            const d = e - u;
                            h = Math.max(d, h);
                        }
                        return 0 === h && (h = o.BorderBottom - a.BorderTop), h;
                    }
                };
                class m {
                    constructor(){
                        this.systemMeasures = [], this.systemMeasureIndex = 0, this.currentWidth = 0, this.currentSystemFixWidth = 0, this.currentSystemVarWidth = 0, this.maxLabelLength = 0;
                    }
                    IsSystemStartMeasure() {
                        return 0 === this.systemMeasureIndex;
                    }
                }
                e.SystemBuildParameters = m, e.MeasureBuildParameters = class {
                };
            },
            8033 (t, e) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.OctaveShiftParams = void 0, e.OctaveShiftParams = class {
                    constructor(t, e, i){
                        this.getOpenOctaveShift = t, this.getAbsoluteStartTimestamp = e, this.getAbsoluteEndTimestamp = i;
                    }
                };
            },
            735 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.PlainSkyBottomLineBatchCalculatorBackend = void 0;
                const s = i(5479), n = i(3667);
                class r extends n.SkyBottomLineBatchCalculatorBackend {
                    constructor(t, e){
                        super(t, e);
                    }
                    getPreferredRenderingConfiguration(t, e) {
                        return {
                            elementWidth: Math.ceil(t),
                            numColumns: 6,
                            numRows: 6
                        };
                    }
                    onInitialize(t) {}
                    calculateFromCanvas(t, e, i, n, r) {
                        const o = t.width, a = e.getImageData(0, 0, t.width, t.height), { elementWidth: l, elementHeight: h, numColumns: c } = r, u = [];
                        for(let t = 0; t < i.length; ++t){
                            const e = i[t], r = Math.floor(e.getVFStave().getWidth()), d = Math.max(Math.ceil(e.PositionAndShape.Size.width * n), 1), f = t % c * l, m = f + r, p = Math.floor(t / c) * h, g = p + h, b = new Array(Math.max(d, r)).fill(0), S = new Array(Math.max(d, r)).fill(0);
                            for(let t = f; t < m; ++t){
                                b[t - f] = 0;
                                for(let e = p; e < g; ++e){
                                    const i = e * o * 4 + 4 * t;
                                    if (a.data[i + 3] > 0) {
                                        b[t - f] = e - p;
                                        break;
                                    }
                                }
                                S[t - f] = h;
                                for(let e = g - 1; e >= p; e--){
                                    const i = e * o * 4 + 4 * t;
                                    if (a.data[i + 3] > 0) {
                                        S[t - f] = e - p;
                                        break;
                                    }
                                }
                            }
                            const y = Math.max(...b), E = Math.min(...S);
                            for(let t = 0; t < r; ++t)b[t] = 0 === b[t] ? y : b[t], S[t] = S[t] === h ? E : S[t];
                            u.push(new s.SkyBottomLineCalculationResult(b, S));
                        }
                        return u;
                    }
                }
                e.PlainSkyBottomLineBatchCalculatorBackend = r;
            },
            7624 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.SelectionEndSymbol = void 0;
                const s = i(7741), n = i(2683), r = i(9409), o = i(6438), a = i(6452), l = i(813);
                class h extends s.GraphicalObject {
                    constructor(t, e){
                        super();
                        const i = e, s = t.PositionAndShape.AbsolutePosition.y, h = l.CollectionUtil.last(t.StaffLines).PositionAndShape.RelativePosition.y + 4;
                        this.verticalLine = new a.GraphicalLine(new r.PointF2D(i, s), new r.PointF2D(i, s + h), .4, n.OutlineAndFillStyleEnum.SelectionSymbol);
                        for(let e = 0, n = t.StaffLines.length; e < n; ++e){
                            const n = t.StaffLines[e], o = new r.PointF2D(i, s + n.PositionAndShape.RelativePosition.y), a = new Array(3);
                            o.y -= .2, a[0].x = o.x - 3, a[0].y = o.y + 1.2, a[1].x = o.x - 2, a[1].y = o.y + .4, a[2].x = o.x - 2, a[2].y = o.y + 2, this.arrows.push(a);
                            const l = new Array(8), h = .8;
                            o.x -= .1, o.y += .3;
                            const c = .2;
                            l[0].x = o.x - 2, l[0].y = o.y + 1.5 - c, l[1].x = o.x - 1, l[1].y = o.y + 1.5 - c, l[2].x = o.x - 1, l[2].y = o.y + 2.5, l[3].x = o.x - 2, l[3].y = o.y + 2.5, l[4].x = l[0].x, l[4].y = l[0].y - h, l[5].x = l[4].x + h + 1, l[5].y = l[4].y, l[6].x = l[5].x, l[6].y = l[3].y + h, l[7].x = l[3].x, l[7].y = l[6].y, this.arrowlines.push(l);
                        }
                        this.boundingBox = new o.BoundingBox(this), this.boundingBox.AbsolutePosition = new r.PointF2D(i, s), this.boundingBox.BorderLeft = -0.4, this.boundingBox.BorderRight = 4, this.boundingBox.BorderBottom = h;
                    }
                }
                e.SelectionEndSymbol = h;
            },
            8713 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.SelectionStartSymbol = void 0;
                const s = i(9409), n = i(2683), r = i(6452), o = i(7741), a = i(6438), l = i(813);
                class h extends o.GraphicalObject {
                    constructor(t, e){
                        super();
                        const i = e, o = t.PositionAndShape.AbsolutePosition.y, h = l.CollectionUtil.last(t.StaffLines).PositionAndShape.RelativePosition.y + 4;
                        this.verticalLine = new r.GraphicalLine(new s.PointF2D(i, o), new s.PointF2D(i, o + h), .4, n.OutlineAndFillStyleEnum.SelectionSymbol);
                        for(let e = 0, n = t.StaffLines.length; e < n; ++e){
                            const n = t.StaffLines[e], r = new s.PointF2D(i, o + n.PositionAndShape.RelativePosition.y), a = new Array(7);
                            a[0].x = r.x + 4, a[0].y = r.y + 2, a[1].x = r.x + 2.5, a[1].y = r.y + .5, a[2].x = r.x + 2.5, a[2].y = r.y + 1.3, a[3].x = r.x + 1, a[3].y = r.y + 1.3, a[4].x = r.x + 1, a[4].y = r.y + 2.7, a[5].x = r.x + 2.5, a[5].y = r.y + 2.7, a[6].x = r.x + 2.5, a[6].y = r.y + 3.5, this.arrows.push(a);
                        }
                        this.boundingBox = new a.BoundingBox(this), this.boundingBox.AbsolutePosition = new s.PointF2D(i, o), this.boundingBox.BorderLeft = -0.4, this.boundingBox.BorderRight = 4, this.boundingBox.BorderBottom = h;
                    }
                }
                e.SelectionStartSymbol = h;
            },
            1327 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.SkyBottomLineBatchCalculator = void 0;
                const n = i(5955), r = i(735), o = i(3508), a = s(i(3065)), l = i(813);
                e.SkyBottomLineBatchCalculator = class {
                    constructor(t, e){
                        const i = new Map;
                        for (const e of t){
                            const t = e.ParentMusicSystem.rules;
                            (()=>{
                                if (i.has(t)) return i.get(t);
                                {
                                    const e = [];
                                    return i.set(t, e), e;
                                }
                            })().push({
                                skyBottomLineCalculator: e.SkyBottomLineCalculator,
                                measures: e.Measures
                            });
                        }
                        this.batches = new Map;
                        for (const [t, s] of i.entries()){
                            const i = l.CollectionUtil.flat(s.map((t)=>t.measures)), h = (()=>{
                                if (e === n.SkyBottomLineBatchCalculatorBackendType.Plain) return new r.PlainSkyBottomLineBatchCalculatorBackend(t, i).initialize();
                                try {
                                    return new o.WebGLSkyBottomLineBatchCalculatorBackend(t, i).initialize();
                                } catch  {
                                    return a.default.info("Couldn't create WebGLBackend for Skyline. Using fallback."), new r.PlainSkyBottomLineBatchCalculatorBackend(t, i).initialize();
                                }
                            })();
                            h.initialize(), this.batches.set(t, {
                                backend: h,
                                entries: s
                            });
                        }
                    }
                    calculateLines() {
                        for (const [, { backend: t, entries: e }] of this.batches){
                            const i = t.calculateLines();
                            let s = 0;
                            for (const { skyBottomLineCalculator: t, measures: n } of e){
                                const e = s + n.length;
                                t.updateLines(i.slice(s, e)), s = e;
                            }
                        }
                    }
                };
            },
            3667 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.SkyBottomLineBatchCalculatorBackend = void 0;
                const n = i(9834), r = s(i(3065));
                e.SkyBottomLineBatchCalculatorBackend = class {
                    constructor(t, e){
                        this.elementHeight = 300, this.canvas = new n.CanvasVexFlowBackend(t), this.measures = e, this.maxWidth = Math.max(...this.measures.map((t)=>{
                            let e = t.getVFStave().getWidth();
                            return e > 0 || t.IsExtraGraphicalMeasure || (r.default.warn("SkyBottomLineBatchCalculatorBackend: width not > 0 in measure " + t.MeasureNumber), e = 50), e;
                        })), this.samplingUnit = t.SamplingUnit;
                    }
                    initialize() {
                        if (this.tableConfiguration = {
                            ...this.getPreferredRenderingConfiguration(this.maxWidth, this.elementHeight),
                            elementHeight: this.elementHeight
                        }, this.tableConfiguration.numRows < 1 || this.tableConfiguration.numColumns < 1) throw r.default.warn("SkyBottomLineBatchCalculatorBackend: numRows or numColumns in tableConfiguration is 0"), new Error("numRows or numColumns in tableConfiguration is 0");
                        this.tableConfiguration.elementWidth < this.maxWidth && r.default.warn("SkyBottomLineBatchCalculatorBackend: elementWidth in tableConfiguration is less than the width of widest measure");
                        const t = this.tableConfiguration.elementWidth * this.tableConfiguration.numColumns, e = this.elementHeight * this.tableConfiguration.numRows;
                        return this.canvas.initializeHeadless(t, e), this.onInitialize(this.tableConfiguration), this;
                    }
                    calculateLines() {
                        const { numColumns: t, numRows: e, elementWidth: i } = this.tableConfiguration, s = this.elementHeight, n = t * e, o = this.canvas.getContext(), a = o, l = this.canvas.getCanvas(), h = [];
                        for(let e = 0; e < this.measures.length; e += n){
                            o.clear();
                            const c = this.measures.slice(e, e + n);
                            for(let e = 0; e < c.length; ++e){
                                const n = c[e], l = n.getVFStave(), h = e % t, u = Math.floor(e / t);
                                let d = l.getWidth();
                                d > 0 || n.IsExtraGraphicalMeasure || (d = 50), d = Math.floor(d), n.PositionAndShape.calculateAbsolutePositionsRecursive(0, 0);
                                const f = 0;
                                l.setX(f);
                                const m = l.y + 100;
                                l.setY(m);
                                const p = l.getWidth();
                                l.setWidth(d), n.format(), l.setWidth(p);
                                try {
                                    a.translate(h * i, u * s), n.draw(o), a.translate(-h * i, -u * s);
                                } catch (t) {
                                    r.default.warn("SkyBottomLineBatchCalculatorBackend.calculateLines.draw", t);
                                }
                            }
                            const u = this.calculateFromCanvas(l, o, c, this.samplingUnit, this.tableConfiguration);
                            h.push(...u);
                        }
                        return h;
                    }
                };
            },
            5479 (t, e) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.SkyBottomLineCalculationResult = void 0, e.SkyBottomLineCalculationResult = class {
                    constructor(t, e){
                        this.skyLine = t, this.bottomLine = e;
                    }
                };
            },
            2779 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.SkyBottomLineCalculator = void 0;
                i(9409);
                const n = i(9479), r = s(i(3065)), o = i(5479), a = i(9834), l = i(3729);
                class h {
                    constructor(t){
                        this.mStaffLineParent = t, this.mRules = t.ParentMusicSystem.rules;
                    }
                    updateLines(t) {
                        const e = this.StaffLineParent.Measures;
                        if (t.length !== e.length) {
                            if (r.default.warn("SkyBottomLineCalculator: lengths of calculation result array and measure array do not match"), t.length < e.length) for(; t.length < e.length;)t.push(new o.SkyBottomLineCalculationResult([], []));
                            else t = t.slice(0, e.length);
                        }
                        let i = 0;
                        for (const { skyLine: e } of t)i += e.length;
                        const s = new Array(i), n = new Array(i);
                        let a = 0;
                        for (const { skyLine: e, bottomLine: i } of t)for(let t = 0; t < e.length; t++)s[a] = e[t], n[a] = i[t], a++;
                        this.setLinesFromConcatenated(s, n, i);
                    }
                    setLinesFromConcatenated(t, e, i) {
                        const s = Math.max(Math.ceil(this.StaffLineParent.PositionAndShape.Size.width * this.SamplingUnit), 1), o = i / s, a = [], l = [];
                        for(let n = 0; n < i && a.length !== s; n += o){
                            const s = Math.min(i, n + o), r = Math.trunc(n);
                            let h = Math.trunc(s + 1);
                            h > i && (h = i);
                            let c = Number.POSITIVE_INFINITY, u = Number.NEGATIVE_INFINITY;
                            for(let i = r; i < h; i++)t[i] < c && (c = t[i]), e[i] > u && (u = e[i]);
                            a.push(c), l.push(u);
                        }
                        this.mSkyLine = a, this.mBottomLine = l, this.mSkyLine.length !== s && r.default.debug(`SkyLine calculation was not correct (${this.mSkyLine.length} instead of ${s})`);
                        let h = Number.NEGATIVE_INFINITY;
                        for(let t = 0; t < a.length; t++)a[t] > h && (h = a[t]);
                        const c = this.StaffLineParent.TopLineOffset;
                        for(let t = 0; t < a.length; t++)a[t] = (a[t] - h) / n.unitInPixels + c;
                        let u = Number.POSITIVE_INFINITY;
                        for(let t = 0; t < l.length; t++)l[t] < u && (u = l[t]);
                        const d = this.StaffLineParent.BottomLineOffset;
                        for(let t = 0; t < l.length; t++)l[t] = (l[t] - u) / n.unitInPixels + d;
                    }
                    calculateLines(t) {
                        if (this.mRules.UseGeometricSkyBottomLineCalculation) return void this.calculateLinesGeometric(t);
                        const e = this.mRules.SamplingUnit, i = [], s = new a.CanvasVexFlowBackend(this.mRules);
                        for (const t of this.StaffLineParent.Measures){
                            t.PositionAndShape.calculateAbsolutePositionsRecursive(0, 0);
                            const n = t.getVFStave();
                            let a = n.getWidth();
                            a > 0 || t.IsExtraGraphicalMeasure || (r.default.warn("SkyBottomLineCalculator: width not > 0 in measure " + t.MeasureNumber), a = 50), s.initializeHeadless(a);
                            const l = s.getContext(), h = s.getCanvas();
                            a = h.width;
                            const c = h.height;
                            n.setY(n.y + 100);
                            const u = n.getWidth();
                            n.setWidth(a), t.format(), n.setWidth(u);
                            try {
                                t.draw(l);
                            } catch (t) {
                                r.default.warn("SkyBottomLineCalculator.calculateLines.draw", t);
                            }
                            const d = l.getImageData(0, 0, a, c), f = 4, m = Math.max(Math.ceil(t.PositionAndShape.Size.width * e), 1), p = new Array(m), g = new Array(m);
                            for(let t = 0; t < a; t++){
                                for(let e = 0; e < c; e++){
                                    const i = e * a * f + t * f;
                                    if (d.data[i + 3] > 0) {
                                        p[t] = e;
                                        break;
                                    }
                                }
                                for(let e = c; e > 0; e--){
                                    const i = e * a * f + t * f;
                                    if (d.data[i + 3] > 0) {
                                        g[t] = e;
                                        break;
                                    }
                                }
                            }
                            for(let t = 0; t < p.length; t++)void 0 === p[t] && (p[t] = Math.max(this.findPreviousValidNumber(t, p), this.findNextValidNumber(t, p)));
                            for(let t = 0; t < g.length; t++)void 0 === g[t] && (g[t] = Math.max(this.findPreviousValidNumber(t, g), this.findNextValidNumber(t, g)));
                            i.push(new o.SkyBottomLineCalculationResult(p, g)), s.clear();
                        }
                        this.updateLines(i);
                    }
                    calculateLinesGeometric(t) {
                        const e = this.mRules.SamplingUnit, i = this.mRules.GeometricSkyBottomLineCaches, s = new l.GeometricSkyBottomLineContext(0, 300, i);
                        let n = i.skyLineBuffer, o = i.bottomLineBuffer, a = 0;
                        for (const i of this.StaffLineParent.Measures){
                            const l = this.prepareMeasureForGeometricSkyline(i, t);
                            s.initialize(l);
                            try {
                                i.draw(s);
                            } catch (t) {
                                r.default.warn("SkyBottomLineCalculator.calculateLinesGeometric.draw", t);
                            }
                            const c = Math.max(Math.ceil(i.PositionAndShape.Size.width * e), 1), u = Math.max(c, s.getDrawnLength());
                            if (a + u > n.length) {
                                const t = Math.max(a + u, 2 * n.length), e = new Float64Array(t), i = new Float64Array(t);
                                e.set(n.subarray(0, a)), i.set(o.subarray(0, a)), n = e, o = i;
                            }
                            n.fill(NaN, a, a + u), o.fill(NaN, a, a + u), s.copyExtentsIntoBuffers(n, o, a), h.fillUndrawnColumns(n, a, a + u), h.fillUndrawnColumns(o, a, a + u), a += u;
                        }
                        i.skyLineBuffer = n, i.bottomLineBuffer = o, this.setLinesFromConcatenated(n, o, a);
                    }
                    static fillUndrawnColumns(t, e, i) {
                        for(let s = e; s < i; s++){
                            if (!isNaN(t[s])) continue;
                            let n = s + 1;
                            for(; n < i && isNaN(t[n]);)n++;
                            const r = Math.max(s > e ? t[s - 1] : 0, n < i ? t[n] : 0);
                            for(; s < n; s++)t[s] = r;
                        }
                    }
                    prepareMeasureForGeometricSkyline(t, e) {
                        t.PositionAndShape.calculateAbsolutePositionsRecursive(0, 0);
                        const i = t.getVFStave();
                        let s = i.getWidth();
                        s > 0 || t.IsExtraGraphicalMeasure || (r.default.warn("SkyBottomLineCalculator: width not > 0 in measure " + t.MeasureNumber), s = 50), s = Math.trunc(s), isFinite(s) ? s < 0 && (s = 300) : s = 0, i.setY(i.y + 100);
                        const n = i.getWidth();
                        return i.setWidth(s), t.format(e), i.setWidth(n), s;
                    }
                    applyGeometricSkylineSideEffectsOnly(t) {
                        if (this.mRules.UseGeometricSkyBottomLineCalculation) for (const e of this.StaffLineParent.Measures)e && (this.prepareMeasureForGeometricSkyline(e, t), e.applyDrawSideEffects());
                    }
                    updateSkyLineWithLine(t, e, i) {
                        const s = Math.floor(t.x * this.SamplingUnit), n = Math.ceil(e.x * this.SamplingUnit);
                        for(let t = s + 1; t < Math.min(n, this.SkyLine.length); t++)this.SkyLine[t] = i;
                    }
                    updateSkyLineWithWedge(t, e) {
                        let i = Math.floor(t.x * this.SamplingUnit), s = Math.ceil(e.x * this.SamplingUnit), n = (e.y - t.y) / (e.x - t.x);
                        s - i <= 1 && (s++, n = 0), i < 0 && (i = 0), i >= this.BottomLine.length && (i = this.BottomLine.length - 1), s < 0 && (s = 0), s >= this.BottomLine.length && (s = this.BottomLine.length), this.SkyLine[i] = t.y;
                        for(let t = i + 1; t < Math.min(s, this.SkyLine.length); t++)this.SkyLine[t] = this.SkyLine[t - 1] + n / this.SamplingUnit;
                    }
                    updateBottomLineWithWedge(t, e) {
                        let i = Math.floor(t.x * this.SamplingUnit), s = Math.ceil(e.x * this.SamplingUnit), n = (e.y - t.y) / (e.x - t.x);
                        s - i <= 1 && (s++, n = 0), i < 0 && (i = 0), i >= this.BottomLine.length && (i = this.BottomLine.length - 1), s < 0 && (s = 0), s >= this.BottomLine.length && (s = this.BottomLine.length), this.BottomLine[i] = t.y;
                        for(let t = i + 1; t < s; t++)this.BottomLine[t] = this.BottomLine[t - 1] + n / this.SamplingUnit;
                    }
                    mergeSkyLineWithLine(t, e) {
                        const i = e.x - t.x;
                        if (i <= 0 || !this.SkyLine?.length) return;
                        const s = Math.max(0, Math.floor(t.x * this.SamplingUnit)), n = Math.min(this.SkyLine.length, Math.ceil(e.x * this.SamplingUnit)), r = (e.y - t.y) / i;
                        for(let e = s; e < n; e++){
                            const s = Math.min(Math.max(e / this.SamplingUnit - t.x, 0), i), n = t.y + r * s;
                            n < this.SkyLine[e] && (this.SkyLine[e] = n);
                        }
                    }
                    mergeBottomLineWithLine(t, e) {
                        const i = e.x - t.x;
                        if (i <= 0 || !this.BottomLine?.length) return;
                        const s = Math.max(0, Math.floor(t.x * this.SamplingUnit)), n = Math.min(this.BottomLine.length, Math.ceil(e.x * this.SamplingUnit)), r = (e.y - t.y) / i;
                        for(let e = s; e < n; e++){
                            const s = Math.min(Math.max(e / this.SamplingUnit - t.x, 0), i), n = t.y + r * s;
                            n > this.BottomLine[e] && (this.BottomLine[e] = n);
                        }
                    }
                    updateSkyLineInRange(t, e, i) {
                        this.updateInRange(this.mSkyLine, t, e, i);
                    }
                    updateBottomLineInRange(t, e, i) {
                        this.updateInRange(this.BottomLine, t, e, i);
                    }
                    updateSkyLineWithLabel(t, e, i) {
                        this.updateInRangeOfCoveredSamples(this.mSkyLine, t, e, i);
                    }
                    updateBottomLineWithLabel(t, e, i) {
                        this.updateInRangeOfCoveredSamples(this.mBottomLine, t, e, i);
                    }
                    getSkyLineMinForLabel(t, e) {
                        return this.getExtremeInTouchedSamples(this.mSkyLine, t, e, !0);
                    }
                    getBottomLineMaxForLabel(t, e) {
                        return this.getExtremeInTouchedSamples(this.mBottomLine, t, e, !1);
                    }
                    resetSkyLineInRange(t, e) {
                        this.updateInRange(this.SkyLine, t, e);
                    }
                    resetBottomLineInRange(t, e) {
                        this.setInRange(this.BottomLine, t, e);
                    }
                    setLinesDirectly(t, e) {
                        this.mSkyLine = t, this.mBottomLine = e;
                    }
                    setSkyLineWithValue(t) {
                        this.SkyLine.forEach((e)=>t);
                    }
                    setBottomLineWithValue(t) {
                        this.BottomLine.forEach((e)=>t);
                    }
                    getLeftIndexForPointX(t, e) {
                        const i = Math.floor(t * this.SamplingUnit);
                        return i < 0 ? 0 : i >= e ? e - 1 : i;
                    }
                    getRightIndexForPointX(t, e) {
                        const i = Math.ceil(t * this.SamplingUnit);
                        return i < 0 ? 0 : i >= e ? e - 1 : i;
                    }
                    updateStaffLineBorders() {
                        const t = this.getSkyLineMin(), e = this.getBottomLineMax();
                        this.mStaffLineParent.PositionAndShape.BorderTop = t, this.mStaffLineParent.PositionAndShape.BorderMarginTop = t, this.mStaffLineParent.PositionAndShape.BorderBottom = e, this.mStaffLineParent.PositionAndShape.BorderMarginBottom = e;
                    }
                    getSkyLineMin() {
                        const t = this.SkyLine;
                        let e = Number.POSITIVE_INFINITY;
                        for(let i = 0; i < t.length; i++)isNaN(t[i]) || (e = Math.min(e, t[i]));
                        return e;
                    }
                    getSkyLineMinAtPoint(t) {
                        const e = Math.round(t * this.SamplingUnit);
                        return this.mSkyLine[e];
                    }
                    getSkyLineMinInRange(t, e) {
                        return this.getMinInRange(this.SkyLine, t, e);
                    }
                    getBottomLineMax() {
                        const t = this.BottomLine;
                        let e = Number.NEGATIVE_INFINITY;
                        for(let i = 0; i < t.length; i++)isNaN(t[i]) || (e = Math.max(e, t[i]));
                        return e;
                    }
                    getBottomLineMaxAtPoint(t) {
                        const e = Math.round(t * this.SamplingUnit);
                        return this.mBottomLine[e];
                    }
                    getBottomLineMaxInRange(t, e) {
                        return this.getMaxInRange(this.BottomLine, t, e);
                    }
                    getBottomLineMaxInBoundingBox(t) {
                        const e = Math.floor(t.AbsolutePosition.x + t.BorderLeft), i = Math.ceil(t.AbsolutePosition.x + t.BorderRight);
                        return this.getMaxInRange(this.mBottomLine, e, i);
                    }
                    updateWithBoundingBoxRecursively(t) {
                        if (t.ChildElements && t.ChildElements.length > 0) this.updateWithBoundingBoxRecursively(t);
                        else {
                            const e = t.BorderTop + t.AbsolutePosition.y, i = t.BorderBottom + t.AbsolutePosition.y;
                            if (e < 0) {
                                const i = Math.floor(t.AbsolutePosition.x + t.BorderLeft), s = Math.ceil(t.AbsolutePosition.x + t.BorderRight);
                                this.updateInRange(this.mSkyLine, i, s, e);
                            } else if (i > this.StaffLineParent.StaffHeight) {
                                const e = Math.floor(t.AbsolutePosition.x + t.BorderLeft), s = Math.ceil(t.AbsolutePosition.x + t.BorderRight);
                                this.updateInRange(this.mBottomLine, e, s, i);
                            }
                        }
                    }
                    findPreviousValidNumber(t, e) {
                        for(let i = t; i >= 0; i--)if (!isNaN(e[i])) return e[i];
                        return 0;
                    }
                    findNextValidNumber(t, e) {
                        if (t >= e.length) return e[t - 1];
                        for(let i = t; i < e.length; i++)if (!isNaN(e[i])) return e[i];
                        return 0;
                    }
                    drawPixel(t, e, i = "#FF0000FF") {
                        const s = e.getContext(), n = s.fillStyle;
                        s.fillStyle = i, s.fillRect(t.x, t.y, 2, 2), s.fillStyle = n;
                    }
                    updateInRange(t, e = 0, i = t.length, s = 0) {
                        if (e = Math.floor(e * this.SamplingUnit), (i = Math.ceil(i * this.SamplingUnit)) < e) throw new Error("start index of line is greater than the end index");
                        e < 0 && (e = 0), i > t.length && (i = t.length);
                        for(let n = e; n < i; n++)t[n] = Math.abs(s) > Math.abs(t[n]) ? s : t[n];
                    }
                    updateInRangeOfCoveredSamples(t, e, i, s) {
                        let n = Math.ceil(e * this.SamplingUnit), r = Math.floor(i * this.SamplingUnit);
                        r <= n && (n = Math.floor((e + i) / 2 * this.SamplingUnit), r = n + 1), n = Math.max(n, 0), r = Math.min(r, t.length);
                        for(let e = n; e < r; e++)t[e] = Math.abs(s) > Math.abs(t[e]) ? s : t[e];
                    }
                    getExtremeInTouchedSamples(t, e, i, s) {
                        const n = Math.min(Math.max(Math.floor(e * this.SamplingUnit), 0), t.length - 1), r = Math.max(Math.min(Math.ceil(i * this.SamplingUnit), t.length), n + 1);
                        let o = t[n];
                        for(let e = n + 1; e < r; e++)o = s ? Math.min(o, t[e]) : Math.max(o, t[e]);
                        return o;
                    }
                    setInRange(t, e = 0, i = t.length, s = 0) {
                        if (e = Math.floor(e * this.SamplingUnit), (i = Math.ceil(i * this.SamplingUnit)) < e) throw new Error("start index of line is greater then the end index");
                        e < 0 && (e = 0), i > t.length && (i = t.length);
                        for(let n = e; n < i; n++)t[n] = s;
                    }
                    getMinInRange(t, e, i) {
                        return e = Math.floor(e * this.SamplingUnit), i = Math.ceil(i * this.SamplingUnit), t ? (e < 0 && (e = 0), e >= t.length && (e = t.length - 1), i < 0 && (i = 0), i >= t.length && (i = t.length), e >= 0 && i <= t.length ? Math.min(...t.slice(e, i + 1)) : void 0) : Number.MAX_VALUE;
                    }
                    getMaxInRange(t, e, i) {
                        return e = Math.floor(e * this.SamplingUnit), i = Math.ceil(i * this.SamplingUnit), t ? (e < 0 && (e = 0), e >= t.length && (e = t.length - 1), i < 0 && (i = 0), i >= t.length && (i = t.length), e >= 0 && i <= t.length ? Math.max(...t.slice(e, i + 1)) : void 0) : Number.MIN_VALUE;
                    }
                    get SamplingUnit() {
                        return this.mRules.SamplingUnit;
                    }
                    get StaffLineParent() {
                        return this.mStaffLineParent;
                    }
                    get SkyLine() {
                        return this.mSkyLine;
                    }
                    get BottomLine() {
                        return this.mBottomLine;
                    }
                }
                e.SkyBottomLineCalculator = h;
            },
            2919 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.StaffLine = void 0;
                const s = i(6438), n = i(7741), r = i(298), o = i(9409), a = i(2779);
                class l extends n.GraphicalObject {
                    constructor(t, e){
                        super(), this.measures = [], this.staffLines = new Array(5), this.octaveShifts = [], this.lyricLines = [], this.lyricsDashes = [], this.abstractExpressions = [], this.graphicalSlurs = [], this.graphicalGlissandi = [], this.Pedals = [], this.WavyLines = [], this.parentMusicSystem = t, this.parentStaff = e, this.boundingBox = new s.BoundingBox(this, t.PositionAndShape), this.skyBottomLine = new a.SkyBottomLineCalculator(this), this.staffHeight = this.parentMusicSystem.rules.StaffHeight, this.topLineOffset = 0, this.bottomLineOffset = 4, this.calculateStaffLineOffsets();
                    }
                    calculateStaffLineOffsets() {
                        if (this.ParentStaff.isTab) 5 === this.ParentStaff.StafflineCount ? this.staffHeight = this.bottomLineOffset = 6 * this.ParentStaff.ParentInstrument.GetMusicSheet.Rules.TabStaffInterlineHeight : this.staffHeight = this.bottomLineOffset = this.ParentStaff.ParentInstrument.GetMusicSheet.Rules.TabStaffInterlineHeight * this.ParentStaff.StafflineCount;
                        else switch(this.ParentStaff.StafflineCount){
                            case 4:
                                this.bottomLineOffset = 3;
                                break;
                            case 3:
                                this.topLineOffset = 1, this.bottomLineOffset = 3;
                                break;
                            case 2:
                                this.topLineOffset = 2, this.bottomLineOffset = 3;
                                break;
                            case 1:
                                this.topLineOffset = 2, this.bottomLineOffset = 2;
                        }
                    }
                    get Measures() {
                        return this.measures;
                    }
                    set Measures(t) {
                        this.measures = t;
                    }
                    get StaffLines() {
                        return this.staffLines;
                    }
                    set StaffLines(t) {
                        this.staffLines = t;
                    }
                    get NextStaffLine() {
                        const t = this.parentMusicSystem.StaffLines.indexOf(this);
                        return t !== this.parentMusicSystem.StaffLines.length ? this.parentMusicSystem.StaffLines[t + 1] : void 0;
                    }
                    get LyricLines() {
                        return this.lyricLines;
                    }
                    get AbstractExpressions() {
                        return this.abstractExpressions;
                    }
                    set AbstractExpressions(t) {
                        this.abstractExpressions = t;
                    }
                    set LyricLines(t) {
                        this.lyricLines = t;
                    }
                    get LyricsDashes() {
                        return this.lyricsDashes;
                    }
                    set LyricsDashes(t) {
                        this.lyricsDashes = t;
                    }
                    get ParentMusicSystem() {
                        return this.parentMusicSystem;
                    }
                    set ParentMusicSystem(t) {
                        this.parentMusicSystem = t;
                    }
                    get ParentStaff() {
                        return this.parentStaff;
                    }
                    set ParentStaff(t) {
                        this.parentStaff = t;
                    }
                    get SkyBottomLineCalculator() {
                        return this.skyBottomLine;
                    }
                    get SkyLine() {
                        return this.skyBottomLine.SkyLine;
                    }
                    get BottomLine() {
                        return this.skyBottomLine.BottomLine;
                    }
                    get OctaveShifts() {
                        return this.octaveShifts;
                    }
                    set OctaveShifts(t) {
                        this.octaveShifts = t;
                    }
                    get StaffHeight() {
                        return this.staffHeight;
                    }
                    get TopLineOffset() {
                        return this.topLineOffset;
                    }
                    get BottomLineOffset() {
                        return this.bottomLineOffset;
                    }
                    get GraphicalSlurs() {
                        return this.graphicalSlurs;
                    }
                    get GraphicalGlissandi() {
                        return this.graphicalGlissandi;
                    }
                    addSlurToStaffline(t) {
                        this.graphicalSlurs.push(t);
                    }
                    addGlissandoToStaffline(t) {
                        this.graphicalGlissandi.push(t), t.StaffLine = this;
                    }
                    addActivitySymbolClickArea() {
                        const t = new r.StaffLineActivitySymbol(this), e = this.PositionAndShape;
                        t.PositionAndShape.RelativePosition = new o.PointF2D(e.RelativePosition.x + e.BorderRight + .5, e.RelativePosition.y + .5), t.PositionAndShape.Parent = this.parentMusicSystem.PositionAndShape;
                    }
                    isPartOfMultiStaffInstrument() {
                        return this.parentStaff.ParentInstrument.Staves.length > 1;
                    }
                    findClosestStaffEntry(t) {
                        let e;
                        for(let i = 0, s = this.Measures.length; i < s; ++i){
                            const s = this.Measures[i];
                            for(let i = 0, n = s.staffEntries.length; i < n; ++i){
                                const n = s.staffEntries[i];
                                Math.abs(n.PositionAndShape.RelativePosition.x - t + s.PositionAndShape.RelativePosition.x) < 5 && (e = n);
                            }
                        }
                        return e;
                    }
                }
                e.StaffLine = l;
            },
            298 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.StaffLineActivitySymbol = void 0;
                const s = i(7741), n = i(6438);
                class r extends s.GraphicalObject {
                    constructor(t){
                        super(), this.parentStaffLine = t;
                        const e = t.PositionAndShape;
                        this.boundingBox = new n.BoundingBox(this, e), this.boundingBox.BorderRight = 6, this.boundingBox.BorderBottom = 4.5, this.boundingBox.BorderLeft = -1.5, this.boundingBox.BorderTop = -1.5;
                    }
                }
                e.StaffLineActivitySymbol = r;
            },
            4284 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.SystemLine = void 0;
                const s = i(6954), n = i(6438), r = i(7741);
                class o extends r.GraphicalObject {
                    constructor(t, e, i, s, r){
                        super(), this.lineType = t, this.linePosition = e, this.parentMusicSystem = i, this.topMeasure = s, this.bottomMeasure = r, this.parentTopStaffLine = s?.ParentStaffLine, this.boundingBox = new n.BoundingBox(this, i.PositionAndShape);
                    }
                    static getObjectWidthForLineType(t, e) {
                        switch(e){
                            case s.SystemLinesEnum.SingleThin:
                                return t.SystemThinLineWidth;
                            case s.SystemLinesEnum.DoubleThin:
                                return 2 * t.SystemThinLineWidth + t.DistanceBetweenVerticalSystemLines;
                            case s.SystemLinesEnum.ThinBold:
                                return t.SystemThinLineWidth + t.SystemBoldLineWidth + t.DistanceBetweenVerticalSystemLines;
                            case s.SystemLinesEnum.BoldThinDots:
                            case s.SystemLinesEnum.DotsThinBold:
                                return t.SystemThinLineWidth + t.SystemBoldLineWidth + t.DistanceBetweenVerticalSystemLines + t.SystemDotWidth + t.DistanceBetweenDotAndLine;
                            case s.SystemLinesEnum.DotsBoldBoldDots:
                                return 2 * t.SystemBoldLineWidth + 2 * t.SystemDotWidth + 2 * t.DistanceBetweenDotAndLine + t.DistanceBetweenVerticalSystemLines;
                            default:
                                return 0;
                        }
                    }
                }
                e.SystemLine = o;
            },
            67 (t, e) {
                "use strict";
                var i;
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.SystemLinePosition = void 0, function(t) {
                    t[t.MeasureBegin = 0] = "MeasureBegin", t[t.MeasureEnd = 1] = "MeasureEnd";
                }(i || (e.SystemLinePosition = i = {}));
            },
            6954 (t, e) {
                "use strict";
                var i;
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.SystemLinesEnumHelper = e.SystemLinesEnum = void 0, function(t) {
                    t[t.SingleThin = 0] = "SingleThin", t[t.DoubleThin = 1] = "DoubleThin", t[t.ThinBold = 2] = "ThinBold", t[t.BoldThinDots = 3] = "BoldThinDots", t[t.DotsThinBold = 4] = "DotsThinBold", t[t.DotsBoldBoldDots = 5] = "DotsBoldBoldDots", t[t.None = 6] = "None", t[t.Dotted = 7] = "Dotted", t[t.Dashed = 8] = "Dashed", t[t.Bold = 9] = "Bold", t[t.BoldThin = 10] = "BoldThin", t[t.DoubleBold = 11] = "DoubleBold", t[t.Tick = 12] = "Tick", t[t.Short = 13] = "Short";
                }(i || (e.SystemLinesEnum = i = {})), e.SystemLinesEnumHelper = class {
                    static xmlBarlineStyleToSystemLinesEnum(t) {
                        return "regular" === t ? i.SingleThin : "dotted" === t ? i.Dotted : "dashed" === t ? i.Dashed : "heavy" === t ? i.Bold : "light-light" === t ? i.DoubleThin : "light-heavy" === t ? i.ThinBold : "heavy-light" === t ? i.BoldThin : "heavy-heavy" === t ? i.DoubleBold : "tick" === t ? i.Tick : "short" === t ? i.Short : "none" === t ? i.None : i.SingleThin;
                    }
                };
            },
            6723 (t, e) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.VerticalGraphicalStaffEntryContainer = void 0, e.VerticalGraphicalStaffEntryContainer = class {
                    constructor(t, e){
                        this.staffEntries = [], this.absoluteTimestamp = e, this.staffEntries = new Array(t);
                    }
                    get Index() {
                        return this.index;
                    }
                    set Index(t) {
                        this.index = t;
                    }
                    get AbsoluteTimestamp() {
                        return this.absoluteTimestamp;
                    }
                    get StaffEntries() {
                        return this.staffEntries;
                    }
                    set StaffEntries(t) {
                        this.staffEntries = t;
                    }
                    static compareByTimestamp(t, e) {
                        const i = t.absoluteTimestamp.RealValue, s = e.absoluteTimestamp.RealValue;
                        return i < s ? -1 : i > s ? 1 : 0;
                    }
                    getFirstNonNullStaffEntry() {
                        for(let t = 0, e = this.staffEntries.length; t < e; ++t){
                            const e = this.staffEntries[t];
                            if (e) return e;
                        }
                    }
                };
            },
            1083 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.AlignmentManager = void 0;
                const s = i(2400), n = i(9409), r = i(6362), o = i(1066);
                e.AlignmentManager = class {
                    constructor(t){
                        this.parentStaffline = t, this.rules = this.parentStaffline.ParentMusicSystem.rules;
                    }
                    alignDynamicExpressions() {
                        const t = [];
                        let e = new Array;
                        for(let i = 0; i < this.parentStaffline.AbstractExpressions.length - 1; i++){
                            const s = this.parentStaffline.AbstractExpressions[i], n = this.parentStaffline.AbstractExpressions[i + 1], r = s?.SourceExpression?.Placement, o = n?.SourceExpression?.Placement;
                            if (r === o) {
                                const i = this.getDistance(s.PositionAndShape, n.PositionAndShape);
                                Math.abs(i.x) < this.rules.DynamicExpressionMaxDistance && !this.textsOverlap(s, n) ? (-1 === e.indexOf(s) && e.push(s), e.push(n)) : (t.push(e), e = new Array);
                            } else t.push(e), e = new Array;
                        }
                        t.push(e);
                        for (const e of t)if (e.length > 0) {
                            const t = e.map((t)=>this.getOpticalCenterY(t)), i = e[0].SourceExpression?.Placement === r.PlacementEnum.Above ? Math.min(...t) : Math.max(...t);
                            for(let n = 0; n < e.length; n++){
                                const r = e[n], o = t[n] - i, a = this.limitShift(r, -o, e);
                                if (r instanceof s.VexFlowContinuousDynamicExpression ? (r.shiftYPosition(a), r.calcPsi()) : (r.PositionAndShape.RelativePosition.y += a, r.PositionAndShape.calculateBoundingBox()), r.squeeze) {
                                    const t = n < e.length - 1 ? e[n + 1] : void 0, i = n > 0 ? e[n - 1] : void 0;
                                    if (t) {
                                        const e = this.getOverlap(r.PositionAndShape, t.PositionAndShape);
                                        r.squeeze(-(e.x + this.rules.DynamicExpressionSpacer));
                                    }
                                    if (i) {
                                        const t = this.getOverlap(i.PositionAndShape, r.PositionAndShape);
                                        r.squeeze(t.x + this.rules.DynamicExpressionSpacer);
                                    }
                                }
                            }
                        }
                    }
                    textsOverlap(t, e) {
                        if (this.isWedge(t) || this.isWedge(e)) return !1;
                        const i = t.PositionAndShape, s = e.PositionAndShape;
                        return i.RelativePosition.x + i.BorderLeft < s.RelativePosition.x + s.BorderRight && s.RelativePosition.x + s.BorderLeft < i.RelativePosition.x + i.BorderRight;
                    }
                    limitShift(t, e, i) {
                        const s = t.PositionAndShape, n = s.RelativePosition.x + s.BorderMarginLeft, r = s.RelativePosition.x + s.BorderMarginRight;
                        let o = e;
                        for (const t of this.parentStaffline.AbstractExpressions){
                            const a = t.PositionAndShape;
                            if (!(i.includes(t) || a.RelativePosition.x + a.BorderMarginRight <= n || a.RelativePosition.x + a.BorderMarginLeft >= r)) {
                                if (e < 0) {
                                    const t = s.RelativePosition.y + s.BorderMarginTop - (a.RelativePosition.y + a.BorderMarginBottom);
                                    t >= 0 && (o = Math.max(o, -t));
                                } else if (e > 0) {
                                    const t = a.RelativePosition.y + a.BorderMarginTop - (s.RelativePosition.y + s.BorderMarginBottom);
                                    t >= 0 && (o = Math.min(o, t));
                                }
                            }
                        }
                        return o;
                    }
                    getOpticalCenterY(t) {
                        const e = t.PositionAndShape.Center.y;
                        return this.isWedge(t) || !t.Label ? e : e + t.Label.Label.fontHeight * (.4 - .225);
                    }
                    isWedge(t) {
                        return t instanceof o.GraphicalContinuousDynamicExpression && !t.IsVerbal;
                    }
                    getDistance(t, e) {
                        const i = t.RelativePosition.x + t.BorderMarginRight, s = e.RelativePosition.x + e.BorderMarginLeft, r = t.RelativePosition.y + t.BorderMarginBottom, o = e.RelativePosition.y + e.BorderMarginTop;
                        return new n.PointF2D(s - i, o - r);
                    }
                    getOverlap(t, e) {
                        return new n.PointF2D(t.RelativePosition.x + t.BorderMarginRight - (e.RelativePosition.x + e.BorderMarginLeft), t.RelativePosition.y + t.BorderMarginBottom - (e.RelativePosition.y + e.BorderMarginTop));
                    }
                };
            },
            9834 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.CanvasVexFlowBackend = void 0;
                var n = s(i(3206)).default.Flow;
                const r = i(1902), o = i(6014), a = i(624), l = i(1888);
                class h extends r.VexFlowBackend {
                    constructor(t){
                        super(), this.rules = t;
                    }
                    getVexflowBackendType() {
                        return n.Renderer.Backends.CANVAS;
                    }
                    getOSMDBackendType() {
                        return a.BackendType.Canvas;
                    }
                    getCanvasSize() {
                        return this.inner?.offsetHeight;
                    }
                    initialize(t, e, i) {
                        this.zoom = e, this.canvas = document.createElement("canvas"), this.graphicalMusicPage || (this.graphicalMusicPage = new l.GraphicalMusicPage(void 0), this.graphicalMusicPage.PageNumber = 1), i || (i = this.graphicalMusicPage.PageNumber.toString()), this.canvas.id = "osmdCanvasVexFlowBackendCanvas" + i, this.inner = document.createElement("div"), this.inner.id = "osmdCanvasPage" + i, this.inner.style.position = "relative", this.canvas.style.zIndex = "0", this.inner.appendChild(this.canvas), t.appendChild(this.inner), this.renderer = new n.Renderer(this.canvas, this.getVexflowBackendType()), this.ctx = this.renderer.getContext();
                    }
                    initializeHeadless(t = 300, e = 300) {
                        this.graphicalMusicPage || (this.graphicalMusicPage = new l.GraphicalMusicPage(void 0), this.graphicalMusicPage.PageNumber = 1), this.canvas = document.createElement("canvas"), this.canvas.width = t, this.canvas.height = e, this.renderer = new n.Renderer(this.canvas, this.getVexflowBackendType()), this.ctx = this.renderer.getContext();
                    }
                    getContext() {
                        return this.ctx;
                    }
                    free() {
                        this.canvas && (this.canvas.width = 0, this.canvas.height = 0, this.canvas.remove(), delete this.canvas, this.canvas = null);
                    }
                    clear() {
                        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height), this.rules.PageBackgroundColor && (this.ctx.save(), this.ctx.setFillStyle(this.rules.PageBackgroundColor), this.zoom = 1, this.ctx.fillRect(0, 0, this.canvas.width / this.zoom, this.canvas.height / this.zoom), this.ctx.restore());
                    }
                    resize(t, e) {
                        const i = this.canvas;
                        let s;
                        if (i && i.width > 0 && i.height > 0 && (s = document.createElement("canvas"), s.width = i.width, s.height = i.height, s.getContext("2d").drawImage(i, 0, 0)), super.resize(t, e), s) {
                            const t = i.getContext("2d");
                            t.save(), t.setTransform(1, 0, 0, 1, 0, 0), this.rules.PageBackgroundColor && (t.fillStyle = this.rules.PageBackgroundColor, t.fillRect(0, s.height, i.width, i.height - s.height)), t.drawImage(s, 0, 0), t.restore();
                        }
                    }
                    scale(t) {
                        this.ctx.scale(t, t);
                    }
                    translate(t, e) {
                        this.CanvasRenderingCtx.translate(t, e);
                    }
                    renderText(t, e, i, s, n, r, a, l, h) {
                        const c = this.CanvasRenderingCtx.font;
                        this.CanvasRenderingCtx.save();
                        const u = this.CanvasRenderingCtx;
                        h && "lang" in u && (u.lang = h), this.CanvasRenderingCtx.font = o.VexFlowConverter.font(t, e, i, this.rules, l), this.CanvasRenderingCtx.fillStyle = a, this.CanvasRenderingCtx.strokeStyle = a, this.CanvasRenderingCtx.fillText(s, r.x, r.y + n), this.CanvasRenderingCtx.restore(), this.CanvasRenderingCtx.font = c;
                    }
                    renderRectangle(t, e, i, s = 1) {
                        const n = this.CanvasRenderingCtx.fillStyle;
                        this.CanvasRenderingCtx.fillStyle = i || o.VexFlowConverter.style(e), this.CanvasRenderingCtx.globalAlpha = s, this.ctx.fillRect(t.x, t.y, t.width, t.height), this.CanvasRenderingCtx.fillStyle = n, this.CanvasRenderingCtx.globalAlpha = 1;
                    }
                    renderLine(t, e, i = "#FF0000FF", s = 2, n) {
                        const r = this.CanvasRenderingCtx.strokeStyle;
                        this.CanvasRenderingCtx.strokeStyle = i, this.CanvasRenderingCtx.beginPath(), this.CanvasRenderingCtx.moveTo(t.x, t.y), this.CanvasRenderingCtx.lineTo(e.x, e.y), this.CanvasRenderingCtx.stroke(), this.CanvasRenderingCtx.strokeStyle = r;
                    }
                    renderCurve(t) {
                        this.ctx.beginPath(), this.ctx.moveTo(t[0].x, t[0].y), this.ctx.bezierCurveTo(t[1].x, t[1].y, t[2].x, t[2].y, t[3].x, t[3].y), this.ctx.lineTo(t[7].x, t[7].y), this.ctx.bezierCurveTo(t[6].x, t[6].y, t[5].x, t[5].y, t[4].x, t[4].y), this.ctx.lineTo(t[0].x, t[0].y), this.ctx.closePath(), this.ctx.fill();
                    }
                    renderPath(t, e = !0, i, s) {
                        const n = this.CanvasRenderingCtx.fillStyle, r = this.CanvasRenderingCtx.strokeStyle;
                        let o;
                        s && (this.CanvasRenderingCtx.fillStyle = s, this.CanvasRenderingCtx.strokeStyle = s), this.ctx.beginPath();
                        for (const e of t)o ? this.ctx.lineTo(e.x, e.y) : (this.ctx.moveTo(e.x, e.y), o = e);
                        this.ctx.closePath(), e ? this.ctx.fill() : this.ctx.stroke(), this.CanvasRenderingCtx.fillStyle = n, this.CanvasRenderingCtx.strokeStyle = r;
                    }
                    get CanvasRenderingCtx() {
                        return this.ctx.vexFlowCanvasContext;
                    }
                }
                e.CanvasVexFlowBackend = h;
            },
            9436 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.SvgVexFlowBackend = void 0;
                var n = s(i(3206)).default.Flow;
                const r = i(1902), o = i(6014), a = i(2570), l = i(624), h = s(i(3065));
                class c extends r.VexFlowBackend {
                    constructor(t){
                        super(), this.rules = t;
                    }
                    getVexflowBackendType() {
                        return n.Renderer.Backends.SVG;
                    }
                    getOSMDBackendType() {
                        return l.BackendType.SVG;
                    }
                    getCanvasSize() {
                        return this.inner?.offsetHeight;
                    }
                    initialize(t, e) {
                        this.zoom = e, this.canvas = document.createElement("div"), this.canvas.id = "osmdCanvasPage" + this.graphicalMusicPage.PageNumber, this.inner = this.canvas, this.inner.style.position = "relative", this.canvas.style.zIndex = "0", t.appendChild(this.inner), this.renderer = new n.Renderer(this.canvas, this.getVexflowBackendType()), this.ctx = this.renderer.getContext(), this.ctx.svg.id = "osmdSvgPage" + this.graphicalMusicPage.PageNumber;
                    }
                    getContext() {
                        return this.ctx;
                    }
                    getSvgElement() {
                        return this.ctx.svg;
                    }
                    removeNode(t) {
                        const e = this.ctx?.svg;
                        if (!e) return !1;
                        try {
                            e.removeChild(t);
                        } catch (t) {
                            return h.default.error(t), !1;
                        }
                        return !0;
                    }
                    free() {
                        const t = this.ctx.svg;
                        for(; t.lastChild;)t.removeChild(t.lastChild);
                    }
                    clear() {
                        this.ctx && (this.free(), this.rules.PageBackgroundColor && (this.ctx.svg.style["background-color"] = this.rules.PageBackgroundColor));
                    }
                    scale(t) {
                        this.ctx.scale(t, t);
                    }
                    translate(t, e) {}
                    renderText(t, e, i, s, n, r, l, h, c) {
                        this.ctx.save();
                        const u = this.ctx.openGroup("text");
                        c && u.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:lang", c), l && (this.ctx.attributes.fill = l, this.ctx.attributes.stroke = l);
                        let d = h;
                        h && "default" !== h || (d = this.rules.DefaultFontFamily), this.ctx.setFont(d, t, o.VexFlowConverter.fontStyle(e)), this.ctx.attributes["font-size"] = `${t}px`, this.ctx.state["font-size"] = `${t}px`;
                        let f = "normal", m = "normal";
                        switch(e){
                            case a.FontStyles.Bold:
                                f = "bold";
                                break;
                            case a.FontStyles.Italic:
                                m = "italic";
                                break;
                            case a.FontStyles.BoldItalic:
                                f = "bold", m = "italic";
                                break;
                            default:
                                f = "normal";
                        }
                        return this.ctx.attributes["font-weight"] = f, this.ctx.state["font-weight"] = f, this.ctx.attributes["font-style"] = m, this.ctx.state["font-style"] = m, this.ctx.fillText(s, r.x, r.y + n), this.ctx.closeGroup(), this.ctx.restore(), u;
                    }
                    renderRectangle(t, e, i, s = 1) {
                        this.ctx.save();
                        const n = this.ctx.openGroup("rect");
                        this.ctx.attributes.fill = i || o.VexFlowConverter.style(e);
                        const r = {
                            ...this.ctx.attributes,
                            x: t.x,
                            y: t.y,
                            width: t.width,
                            height: t.height,
                            "fill-opacity": s
                        };
                        return this.ctx.rect(t.x, t.y, t.width, t.height, r), this.ctx.restore(), this.ctx.closeGroup(), n;
                    }
                    renderLine(t, e, i = "#FF0000FF", s = 2, n) {
                        this.ctx.save();
                        const r = this.ctx.openGroup("line", n);
                        return this.ctx.beginPath(), this.ctx.moveTo(t.x, t.y), this.ctx.lineTo(e.x, e.y), this.ctx.attributes.stroke = i, this.ctx.lineWidth = s, this.ctx.stroke(), this.ctx.closeGroup(), this.ctx.restore(), r;
                    }
                    renderCurve(t, e, i) {
                        let s;
                        e && i && (s = `${i.getSVGId()}-slur`);
                        const n = this.ctx.openGroup("curve", s);
                        return this.ctx.beginPath(), this.ctx.moveTo(t[0].x, t[0].y), this.ctx.bezierCurveTo(t[1].x, t[1].y, t[2].x, t[2].y, t[3].x, t[3].y), this.ctx.lineTo(t[7].x, t[7].y), this.ctx.bezierCurveTo(t[6].x, t[6].y, t[5].x, t[5].y, t[4].x, t[4].y), this.ctx.lineTo(t[0].x, t[0].y), this.ctx.closePath(), this.ctx.fill(), this.ctx.closeGroup(), n;
                    }
                    renderPath(t, e = !0, i, s) {
                        this.ctx.save();
                        const n = this.ctx.openGroup("path", i);
                        let r;
                        s && (this.ctx.attributes.fill = s, this.ctx.attributes.stroke = s), this.ctx.beginPath();
                        for (const e of t)r ? this.ctx.lineTo(e.x, e.y) : (this.ctx.moveTo(e.x, e.y), r = e);
                        return this.ctx.closePath(), e ? this.ctx.fill() : this.ctx.stroke(), this.ctx.stroke(), this.ctx.closeGroup(), this.ctx.restore(), n;
                    }
                    export() {
                        const t = this.ctx.svg.cloneNode(!0), e = document.implementation.createDocumentType("svg", "-//W3C//DTD SVG 1.1//EN", "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"), i = document.implementation.createDocument("http://www.w3.org/2000/svg", "svg", e);
                        i.replaceChild(t, i.documentElement);
                        const s = (new XMLSerializer).serializeToString(i), n = document.createElement("a");
                        n.href = "data:image/svg+xml; charset=utf8, " + encodeURIComponent(s.replace(/></g, ">\n\r<")), n.download = "opensheetmusicdisplay_download.svg", n.innerHTML = window.location.href + "/download", document.body.appendChild(n);
                    }
                }
                e.SvgVexFlowBackend = c;
            },
            1902 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.VexFlowBackend = e.VexFlowBackends = void 0;
                var n = s(i(3206)).default.Flow;
                e.VexFlowBackends = class {
                }, e.VexFlowBackend = class {
                    getInnerElement() {
                        return this.inner;
                    }
                    getCanvas() {
                        return this.canvas;
                    }
                    getRenderElement() {
                        let t = this.canvas;
                        return this.getVexflowBackendType() === n.Renderer.Backends.CANVAS && (t = this.inner), t;
                    }
                    getRenderer() {
                        return this.renderer;
                    }
                    removeAllChildrenFromContainer(t) {
                        for(; 0 !== t.children.length;)t.removeChild(t.children.item(0));
                    }
                    removeFromContainer(t) {
                        const e = this.getRenderElement();
                        for(let i = 0; i < t.children.length; i++)if (t.children.item(i) === e) {
                            t.removeChild(e);
                            break;
                        }
                    }
                    resize(t, e) {
                        this.renderer.resize(t, e), this.width = t, this.height = e;
                    }
                };
            },
            2400 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.VexFlowContinuousDynamicExpression = void 0;
                const s = i(1066), n = i(8254), r = i(7435), o = i(7533), a = i(2570);
                class l extends s.GraphicalContinuousDynamicExpression {
                    constructor(t, e, i, s){
                        if (super(t, e, i), this.IsVerbal) {
                            const e = new r.Label(t.Label);
                            e.language = t.language, this.label = new n.GraphicalLabel(e, s || this.rules.ContinuousDynamicTextHeight, o.TextAlignmentEnum.LeftCenter, this.rules, this.PositionAndShape), this.label.Label.fontStyle = a.FontStyles.Italic, this.label.setLabelPositionAndShapeBorders(), this.PositionAndShape.calculateBoundingBox(), t.ColorXML && this.rules.ExpressionsUseXMLColor && (this.label.ColorXML = t.ColorXML);
                        }
                    }
                }
                e.VexFlowContinuousDynamicExpression = l;
            },
            6014 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.VexFlowConverter = void 0;
                var n = s(i(3206)).default.Flow;
                const r = i(164), o = i(8233), a = i(2561), l = i(9288), h = i(4543), c = i(8233), u = i(8233), d = i(6954), f = i(2570), m = i(5951), p = i(2683), g = s(i(3065)), b = i(1336), S = i(67), y = i(8215), E = i(4064), x = i(9479), v = i(4236), T = i(9647), _ = i(6362), M = i(7921);
                class P {
                    static durations(t, e) {
                        const i = [], s = t.clone();
                        for(; s.RealValue > 1e-4;){
                            const t = s.RealValue;
                            if (t >= 2) i.push("1/2"), s.Sub(new a.Fraction(2, 1));
                            else if (t >= 1) i.push("w"), s.Sub(new a.Fraction(1, 1));
                            else if (t < 1 && t >= .5) {
                                if (e && t > .5) return [
                                    "w"
                                ];
                                i.push("h"), s.Sub(new a.Fraction(1, 2));
                            } else if (t < .5 && t >= .25) {
                                if (e && t > .25) return [
                                    "h"
                                ];
                                i.push("q"), s.Sub(new a.Fraction(1, 4));
                            } else if (t < .25 && t >= .125) {
                                if (e && t > .125) return [
                                    "q"
                                ];
                                i.push("8"), s.Sub(new a.Fraction(1, 8));
                            } else if (t < .125 && t >= .0625) {
                                if (e && t > .0625) return [
                                    "8"
                                ];
                                i.push("16"), s.Sub(new a.Fraction(1, 16));
                            } else if (t < .0625 && t >= .03125) {
                                if (e && t > .03125) return [
                                    "16"
                                ];
                                i.push("32"), s.Sub(new a.Fraction(1, 32));
                            } else if (t < .03125 && t >= .015625) {
                                if (e && t > .015625) return [
                                    "32"
                                ];
                                i.push("64"), s.Sub(new a.Fraction(1, 64));
                            } else {
                                if (e) return [
                                    "64"
                                ];
                                i.push("128"), s.Sub(new a.Fraction(1, 128));
                            }
                        }
                        return i;
                    }
                    static pitch(t, e, i, s, n) {
                        let a = n;
                        void 0 === n && (a = 3), e && void 0 === n && (a = 0, i.ClefType === r.ClefEnum.F && (a = 2), i.ClefType === r.ClefEnum.C && (a = 2));
                        const l = u.NoteEnum[t.FundamentalNote].toLowerCase(), h = o.Pitch.accidentalVexflow(t.Accidental), c = t.Octave - i.OctaveOffset + a;
                        let d = "";
                        return s && (d = this.NoteHeadCode(s)), [
                            l + "n/" + c + d,
                            h,
                            i
                        ];
                    }
                    static restToNotePitch(t, e) {
                        let i = t.Octave;
                        switch(e){
                            case r.ClefEnum.C:
                            case r.ClefEnum.F:
                                i += 2;
                            case r.ClefEnum.G:
                        }
                        return new o.Pitch(t.FundamentalNote, i, c.AccidentalEnum.NONE);
                    }
                    static NoteHeadCode(t) {
                        const e = t.Filled ? "2" : "1";
                        switch(t.Shape){
                            case E.NoteHeadShape.NORMAL:
                            case E.NoteHeadShape.NONE:
                                return "";
                            case E.NoteHeadShape.DIAMOND:
                                return "/D" + e;
                            case E.NoteHeadShape.TRIANGLE:
                                return "/T" + e;
                            case E.NoteHeadShape.TRIANGLE_INVERTED:
                                return "/TI";
                            case E.NoteHeadShape.X:
                                return "/X" + e;
                            case E.NoteHeadShape.CIRCLEX:
                                return "/X3";
                            case E.NoteHeadShape.RECTANGLE:
                                return "/R" + e;
                            case E.NoteHeadShape.SQUARE:
                                return "/S" + e;
                            case E.NoteHeadShape.SLASH:
                            default:
                                return "";
                        }
                    }
                    static GhostNotes(t) {
                        const e = new n.GhostNote({
                            duration: P.durations(t, !0)[0]
                        }), i = e.getTicks();
                        return i.numerator = t.GetExpandedNumerator() * n.RESOLUTION, i.denominator = t.Denominator, i.simplify(), [
                            e
                        ];
                    }
                    static addAccidental(t, e, i, s = !1) {
                        const r = new n.Accidental(i);
                        if (s) {
                            const t = r.render_options.font_scale;
                            r.setAsCautionary(), r.render_options.font_scale = t, r.reset();
                        }
                        t.addAccidental(e, r);
                    }
                    static restMovesTowardsStaffOfVoice(t, e, i, s) {
                        const n = Math.floor((t - 1) / 4), r = Math.floor((e - 1) / 4), o = (t)=>t >= 0 && t < s;
                        return !(!o(n) || !o(r) || r === n) && r < n === i;
                    }
                    static StaveNote(t) {
                        t.sortForVexflow();
                        const e = t.notes, i = t.parentStaffEntry.parentMeasure.parentSourceMeasure.Rules, s = e[0];
                        let l = [];
                        const h = [], c = s.graphicalNoteLength, u = void 0 !== s.sourceNote.NoteTuplet;
                        let d, f = P.durations(c, u)[0];
                        void 0 !== s.sourceNote.TypeLength && s.sourceNote.TypeLength !== c && 0 !== s.sourceNote.TypeLength.RealValue && (f = P.durations(s.sourceNote.TypeLength, u)[0], s.numberOfDots = s.sourceNote.DotsXml);
                        let m, p, g = s.numberOfDots, S = !1, y = 0, v = !1;
                        for (const s of e){
                            if (g < s.numberOfDots && (g = s.numberOfDots), s.sourceNote.isRest()) {
                                if (v = !0, s.sourceNote.Pitch) {
                                    l = [
                                        s.vfpitch[0]
                                    ];
                                    break;
                                }
                                {
                                    l = [
                                        "b/4"
                                    ];
                                    const t = s.parentVoiceEntry?.parentVoiceEntry;
                                    if (t) {
                                        const e = s.parentVoiceEntry?.parentStaffEntry.parentMeasure.staffEntries;
                                        let i, n, r = -1;
                                        for(let i = 0; i < e.length; i++)if (e[i]?.graphicalVoiceEntries[0]?.parentVoiceEntry === t) {
                                            r = i;
                                            break;
                                        }
                                        if (r >= 1 && e.length - 1 >= r + 1 && (i = e[r - 1]?.graphicalVoiceEntries[0]?.parentVoiceEntry, n = e[r + 1]?.graphicalVoiceEntries[0]?.parentVoiceEntry, i && n)) {
                                            const t = i.Notes[0], e = n.Notes[0];
                                            if (t.NoteBeam?.Notes.includes(e)) {
                                                const t = i.Notes.last().Pitch, e = s.Clef();
                                                l = [
                                                    P.pitch(P.restToNotePitch(t.getTransposedPitch(-2), e.ClefType), !1, e)[0]
                                                ];
                                            }
                                        }
                                    }
                                }
                                if ((s.sourceNote.IsWholeMeasureRest || c.RealValue === s.sourceNote.SourceMeasure.ActiveTimeSignature.RealValue) && (l = [
                                    "d/5"
                                ], t.parentStaffEntry.parentMeasure.ParentStaff.StafflineCount <= 2 && (l = [
                                    "b/4"
                                ]), f = "w", g = 0, t.parentStaffEntry.parentMeasure.staffEntries.some((t)=>t.vfKeys?.length > 0) || (S = !0, y = i.WholeRestXShiftVexflow * x.unitInPixels)), s.sourceNote.ParentStaff.Voices.length > 1) {
                                    const t = s.parentVoiceEntry.parentStaffEntry.graphicalVoiceEntries, e = s.parentVoiceEntry.parentVoiceEntry.ParentVoice.VoiceId, n = 1 === e || 5 === e, a = n ? 1 : -1, h = s.sourceNote.ParentStaff.ParentInstrument.Staves.length;
                                    let c, u;
                                    for (const r of t)for (const t of r.notes){
                                        if (t === s || t.sourceNote.isRest() || !t.sourceNote.PrintObject) continue;
                                        const r = t.parentVoiceEntry.parentVoiceEntry.ParentVoice.VoiceId;
                                        if (P.restMovesTowardsStaffOfVoice(e, r, n, h)) continue;
                                        const o = t.parentVoiceEntry.parentVoiceEntry.WantedStemDirection, l = t.sourceNote.Pitch.getHalfTone();
                                        (!c || 1 === a && l > c || -1 === a && l < c) && (c = l, u = 0, n && o === b.StemDirectionType.Up ? u += 7 : n || o !== b.StemDirectionType.Down ? u += n ? 1 : 2 : u += 7, f.includes("8") || o === b.StemDirectionType.Up && -1 === a && (u += 1), t.sourceNote.NoteBeam && (u += 1), f.includes("w") && (u /= 2), u += .5 * Math.ceil(i.RestCollisionYPadding), u *= a, s.lineShift = u);
                                    }
                                    if (c > 0) {
                                        let t = 3;
                                        const e = s.Clef();
                                        switch(e.ClefType){
                                            case r.ClefEnum.F:
                                                t = 5;
                                                break;
                                            case r.ClefEnum.C:
                                                t = 4;
                                        }
                                        m = o.Pitch.fromHalftone(c), l = [
                                            P.pitch(m, !0, e, void 0, t)[0]
                                        ];
                                    }
                                }
                                break;
                            }
                            const e = s.vfpitch;
                            l.push(e[0]), h.push(e[1]), d || (d = P.Clef(e[2]).type);
                        }
                        for(let t = 0, e = g; t < e; ++t)f += "d";
                        1 === e.length && e[0].sourceNote.Notehead?.Shape === E.NoteHeadShape.SLASH && (f += "s"), v && (f += "r");
                        const T = {
                            align_center: S,
                            auto_stem: !0,
                            clef: d,
                            duration: f,
                            keys: l,
                            slash: t.GraceSlash
                        }, _ = t.notes[0].sourceNote;
                        if (_.IsCueNote && (T.glyph_font_scale = n.DEFAULT_NOTATION_FONT_SCALE * n.GraceNote.SCALE, T.stroke_px = n.GraceNote.LEDGER_LINE_OFFSET), t.parentVoiceEntry.IsGrace || t.notes[0].sourceNote.IsCueNote) p = new n.GraceNote(T);
                        else {
                            p = new n.StaveNote(T), p.stagger_same_whole_notes = i.StaggerSameWholeNotes;
                            const s = t.parentStaffEntry.LyricsEntries;
                            let r = !0, o = 0;
                            if (s.length > 0 && i.RenderLyrics && i.LyricsUseXPaddingForLongLyrics) {
                                const e = t.parentStaffEntry.parentMeasure, i = [];
                                for(let s = e.staffEntries.indexOf(t.parentStaffEntry) + 1; s < e.staffEntries.length; s++){
                                    const t = e.staffEntries[s];
                                    t.graphicalVoiceEntries[0] && i.push(t);
                                }
                                let s, n = t.parentStaffEntry.relInMeasureTimestamp.clone();
                                for (const e of i){
                                    const i = e.relInMeasureTimestamp.clone();
                                    if (s = a.Fraction.minus(i, t.parentVoiceEntry.Timestamp), s.RealValue > .25) {
                                        r = !1;
                                        break;
                                    }
                                    if (e.LyricsEntries.length > 0) break;
                                    o += 32 * a.Fraction.minus(i, n).RealValue, n = i;
                                }
                            }
                            if (i.RenderLyrics && i.LyricsUseXPaddingForLongLyrics && s.length > 0 && r) {
                                let n = !1, r = 0;
                                for (const t of e)if (t.sourceNote.Length.RealValue <= .125) {
                                    n = !0;
                                    break;
                                }
                                let a = !1;
                                const l = i.LyricsXPaddingWidthThreshold, h = t.parentStaffEntry, c = h.parentMeasure.staffEntries, u = c.indexOf(h) === c.length - 1;
                                for (const t of s){
                                    let e = t.GraphicalLabel.PositionAndShape.Size.width;
                                    if (t.hasDashFromLyricWord() && (e += .5), e > l) {
                                        let s = o;
                                        const h = u && t.hasDashFromLyricWord();
                                        u && (s += h ? i.LyricsXPaddingReductionForLastNoteInMeasureCrossMeasureMidWord : i.LyricsXPaddingReductionForLastNoteInMeasure), n || (s += i.LyricsXPaddingReductionForLongNotes), !i.LyricsXPaddingForLastNoteInMeasure && u || e > l + s && (a = !0, r = Math.max(r, e - l - s));
                                    }
                                }
                                a && (p.paddingRight = 10 * i.LyricsXPaddingFactorForLongLyrics * r);
                            }
                        }
                        const M = t.notes[0].lineShift;
                        if (0 !== M && (p.getKeyProps()[0].line += M), e.length > 1) for(let t = 0; t < e.length; t++){
                            const i = e[t];
                            i.sourceNote.Notehead?.Shape === E.NoteHeadShape.SLASH && (p.note_heads[t].note_type = "s");
                        }
                        if (p.getKeyProps().forEach(({ line: e }, i)=>t.notes[i].staffLine = e), (i.LedgerLineWidth || i.LedgerLineStrokeStyle) && (p.ledgerLineStyle || (p.ledgerLineStyle = {}), i.LedgerLineWidth && (p.ledgerLineStyle.lineWidth = i.LedgerLineWidth), i.LedgerLineStrokeStyle && (p.ledgerLineStyle.strokeStyle = i.LedgerLineStrokeStyle)), i.ColoringEnabled) {
                            const e = i.DefaultColorStem;
                            let s = t.parentVoiceEntry.StemColor;
                            !s && e && (s = e);
                            const n = {
                                fillStyle: s,
                                strokeStyle: s
                            };
                            s && (p.setStemStyle(n), p.flag && i.ColorFlags && p.setFlagStyle(n));
                        }
                        if (p.x_shift = y, t.parentVoiceEntry.IsGrace && t.notes[0].sourceNote.NoteBeam && (t.parentVoiceEntry.WantedStemDirection = t.notes[0].sourceNote.NoteBeam.Notes[0].ParentVoiceEntry.WantedStemDirection), t.parentVoiceEntry) switch(t.parentVoiceEntry.WantedStemDirection){
                            case b.StemDirectionType.Up:
                                p.setStemDirection(n.Stem.UP), t.parentVoiceEntry.StemDirection = b.StemDirectionType.Up;
                                break;
                            case b.StemDirectionType.Down:
                                p.setStemDirection(n.Stem.DOWN), t.parentVoiceEntry.StemDirection = b.StemDirectionType.Down;
                        }
                        for(let t = 0, s = e.length; t < s; t += 1){
                            if (e[t].setIndex(p, t), h[t]) {
                                const i = e[t].sourceNote, s = i.AccidentalParenthesesXml || i.AccidentalBracketXml;
                                "sharp-sharp" === h[t] ? (P.addAccidental(p, t, "#", s), P.addAccidental(p, t, "#")) : "natural-sharp" === h[t] ? (P.addAccidental(p, t, "#", s), P.addAccidental(p, t, "n")) : "natural-flat" === h[t] ? (P.addAccidental(p, t, "b", s), P.addAccidental(p, t, "n")) : "###" === h[t] ? (P.addAccidental(p, t, "##", s), P.addAccidental(p, t, "#")) : "bbs" === h[t] ? (P.addAccidental(p, t, "bb", s), P.addAccidental(p, t, "b")) : P.addAccidental(p, t, h[t], s);
                            }
                            const s = e[t].sourceNote.TremoloInfo, r = s?.tremoloStrokes;
                            if (r > 0 && !s?.tremoloBetweenNotesStart && !s?.tremoloBetweenNotesStop) {
                                const e = new n.Tremolo(r);
                                e.extra_stroke_scale = i.TremoloStrokeScale, e.y_spacing_scale = i.TremoloYSpacingScale, p.addModifier(t, e);
                            }
                        }
                        let L;
                        for (const t of e)if (t.sourceNote.TremoloInfo?.tremoloBetweenNotes) {
                            L = t.sourceNote.TremoloInfo.tremoloBetweenNotes;
                            break;
                        }
                        if (L?.strokes > 0 && !t.parentVoiceEntry.IsGrace && p.hasStem()) {
                            const t = (L.strokes * i.TremoloBetweenNotesStrokeThickness + (L.strokes - 1) * i.TremoloBetweenNotesStrokeGap + 2 * i.TremoloBetweenNotesYPadding + .5) * x.unitInPixels;
                            t > n.Stem.HEIGHT && (p.setStemLength(t), p.getStem()?.setExtension(p.getStemExtension()));
                        }
                        if (.25 === _.Length.RealValue && _.Notehead && !1 === _.Notehead.Filled) {
                            const t = p.getKeyProps();
                            for(let e = 0; e < t.length; e++)t[e].code = "v81";
                        }
                        for(let t = 0, e = g; t < e; ++t)p.addDotToAll();
                        return p;
                    }
                    static generateArticulations(t, e, i) {
                        if (!t || "GhostNote" === t.getAttribute("type")) return;
                        const s = e.sourceNote.ParentVoiceEntry.Notes[0].NoteBeam?.Notes ?? [
                            e.sourceNote
                        ], r = e.sourceNote.ParentVoiceEntry.Articulations.length > 0 && s.some((t)=>P.otherVoiceSoundsDuring(t.ParentVoiceEntry));
                        for (const s of e.sourceNote.ParentVoiceEntry.Articulations){
                            let o, a = n.Modifier.Position.ABOVE;
                            if (r) t.getStemDirection() === n.Stem.DOWN && (a = n.Modifier.Position.BELOW);
                            else if (t.getStemDirection() === n.Stem.UP && (a = n.Modifier.Position.BELOW, i.ArticulationAboveNoteForStemUp)) {
                                const t = e.parentVoiceEntry.parentStaffEntry.parentMeasure, i = t?.ParentStaff, s = i?.ParentInstrument.Staves;
                                (1 === s.length || 2 === s.length && i !== s[1]) && (a = n.Modifier.Position.ABOVE);
                            }
                            const l = s.articulationEnum;
                            switch(i.ArticulationPlacementFromXML && (s.placement === _.PlacementEnum.Above ? a = n.Modifier.Position.ABOVE : s.placement === _.PlacementEnum.Below && (a = n.Modifier.Position.BELOW)), l){
                                case b.ArticulationEnum.accent:
                                    o = new n.Articulation("a>"), o.render_options = {
                                        ...o.render_options,
                                        extra_left_px: 0,
                                        extra_right_px: 0
                                    }, o.getWidth && (o.getWidth = function() {
                                        return 0;
                                    });
                                    break;
                                case b.ArticulationEnum.breathmark:
                                    o = new n.Articulation("abr"), s.placement === _.PlacementEnum.Above && (a = n.Modifier.Position.ABOVE), o.breathMarkDistance = i.BreathMarkDistance;
                                    break;
                                case b.ArticulationEnum.downbow:
                                    o = new n.Articulation("am"), void 0 === s.placement && (a = n.Modifier.Position.ABOVE, s.placement = _.PlacementEnum.Above);
                                    break;
                                case b.ArticulationEnum.fermata:
                                    o = new n.Articulation("a@a"), a = n.Modifier.Position.ABOVE, s.placement = _.PlacementEnum.Above;
                                    break;
                                case b.ArticulationEnum.marcatodown:
                                    o = new n.Articulation("a|");
                                    break;
                                case b.ArticulationEnum.marcatoup:
                                    o = new n.Articulation("a^"), a = n.Modifier.Position.ABOVE;
                                    break;
                                case b.ArticulationEnum.invertedfermata:
                                    {
                                        const t = e.sourceNote.ParentVoiceEntry;
                                        if (t !== e.sourceNote.ParentVoiceEntry.ParentSourceStaffEntry.VoiceEntries.last()) {
                                            t.Articulations = t.Articulations.slice(t.Articulations.indexOf(s)), t.ParentSourceStaffEntry.VoiceEntries.last().Articulations.push(s);
                                            continue;
                                        }
                                        o = new n.Articulation("a@u"), a = n.Modifier.Position.BELOW, s.placement = _.PlacementEnum.Below;
                                        break;
                                    }
                                case b.ArticulationEnum.lefthandpizzicato:
                                    o = new n.Articulation("a+");
                                    break;
                                case b.ArticulationEnum.naturalharmonic:
                                    o = new n.Articulation("ah");
                                    break;
                                case b.ArticulationEnum.snappizzicato:
                                    o = new n.Articulation("ao");
                                    break;
                                case b.ArticulationEnum.staccatissimo:
                                    o = new n.Articulation("av");
                                    break;
                                case b.ArticulationEnum.staccato:
                                    o = new n.Articulation("a.");
                                    break;
                                case b.ArticulationEnum.tenuto:
                                    o = new n.Articulation("a-");
                                    break;
                                case b.ArticulationEnum.upbow:
                                    o = new n.Articulation("a|"), void 0 === s.placement && (a = n.Modifier.Position.ABOVE, s.placement = _.PlacementEnum.Above);
                                    break;
                                case b.ArticulationEnum.strongaccent:
                                    o = new n.Articulation("a^");
                            }
                            o && (o.setPosition(a), t.addModifier(0, o));
                        }
                    }
                    static otherVoiceSoundsDuring(t) {
                        const e = (t)=>Math.max(...t.Notes.map((t)=>t.Length.RealValue)), i = t.ParentSourceStaffEntry, s = i.ParentStaff.idInMusicSheet, n = i.Timestamp.RealValue, r = n + e(t);
                        for (const o of i.VerticalContainerParent.ParentMeasure.VerticalSourceStaffEntryContainers){
                            const i = o.StaffEntries[s], a = i?.Timestamp.RealValue;
                            if (i && !(a >= r)) {
                                for (const s of i.VoiceEntries)if (s.ParentVoice !== t.ParentVoice && a + e(s) > n && s.Notes.some((t)=>t.PrintObject)) return !0;
                            }
                        }
                        return !1;
                    }
                    static generateOrnaments(t, e) {
                        let i, s = n.Modifier.Position.ABOVE;
                        switch(e.placement === _.PlacementEnum.Below && (s = n.Modifier.Position.BELOW), e.GetOrnament){
                            case y.OrnamentEnum.DelayedInvertedTurn:
                                i = new n.Ornament("turn_inverted"), i.setDelayed(!0);
                                break;
                            case y.OrnamentEnum.DelayedTurn:
                                i = new n.Ornament("turn"), i.setDelayed(!0);
                                break;
                            case y.OrnamentEnum.InvertedMordent:
                                i = new n.Ornament("mordent"), i.setDelayed(!1);
                                break;
                            case y.OrnamentEnum.InvertedTurn:
                                i = new n.Ornament("turn_inverted"), i.setDelayed(!1);
                                break;
                            case y.OrnamentEnum.Mordent:
                                i = new n.Ornament("mordent_inverted"), i.setDelayed(!1);
                                break;
                            case y.OrnamentEnum.Trill:
                                i = new n.Ornament("tr"), i.setDelayed(!1);
                                break;
                            case y.OrnamentEnum.Turn:
                                i = new n.Ornament("turn"), i.setDelayed(!1);
                                break;
                            default:
                                return void g.default.warn("unhandled OrnamentEnum type: " + e.GetOrnament);
                        }
                        i && (e.AccidentalBelow !== c.AccidentalEnum.NONE && i.setLowerAccidental(P.ornamentAccidentals(e.AccidentalBelow, e.AccidentalBelowXml)), e.AccidentalAbove !== c.AccidentalEnum.NONE && i.setUpperAccidental(P.ornamentAccidentals(e.AccidentalAbove, e.AccidentalAboveXml)), i.setPosition(s), t.addModifier(0, i));
                    }
                    static ornamentAccidentals(t, e) {
                        switch(t){
                            case c.AccidentalEnum.DOUBLESHARP:
                                return "sharp-sharp" === e ? [
                                    "#",
                                    "#"
                                ] : [
                                    "##"
                                ];
                            case c.AccidentalEnum.SHARP:
                                return "natural-sharp" === e ? [
                                    "n",
                                    "#"
                                ] : [
                                    "#"
                                ];
                            case c.AccidentalEnum.FLAT:
                                return "natural-flat" === e ? [
                                    "n",
                                    "b"
                                ] : [
                                    "b"
                                ];
                            case c.AccidentalEnum.TRIPLESHARP:
                                return [
                                    "#",
                                    "##"
                                ];
                            case c.AccidentalEnum.TRIPLEFLAT:
                                return [
                                    "b",
                                    "bb"
                                ];
                            default:
                                return [
                                    o.Pitch.accidentalVexflow(t)
                                ];
                        }
                    }
                    static StrokeTypeFromArpeggioType(t) {
                        switch(t){
                            case v.ArpeggioType.ARPEGGIO_DIRECTIONLESS:
                                return n.Stroke.Type.ARPEGGIO_DIRECTIONLESS;
                            case v.ArpeggioType.BRUSH_DOWN:
                                return n.Stroke.Type.BRUSH_UP;
                            case v.ArpeggioType.BRUSH_UP:
                                return n.Stroke.Type.BRUSH_DOWN;
                            case v.ArpeggioType.RASQUEDO_DOWN:
                                return n.Stroke.Type.RASQUEDO_UP;
                            case v.ArpeggioType.RASQUEDO_UP:
                                return n.Stroke.Type.RASQUEDO_DOWN;
                            case v.ArpeggioType.ROLL_DOWN:
                                return n.Stroke.Type.ROLL_UP;
                            case v.ArpeggioType.ROLL_UP:
                                return n.Stroke.Type.ROLL_DOWN;
                            default:
                                return n.Stroke.Type.ARPEGGIO_DIRECTIONLESS;
                        }
                    }
                    static CreateTabNote(t) {
                        const e = [], i = t.notes.reverse(), s = [], r = t.notes[0].graphicalNoteLength, o = void 0 !== t.notes[0].sourceNote.NoteTuplet;
                        let a = P.durations(r, o)[0], l = 0;
                        const h = t.parentStaffEntry.parentMeasure.parentSourceMeasure.Rules;
                        let c = !1;
                        for (const i of t.notes){
                            const r = i.sourceNote;
                            let o = {
                                str: r.StringNumberTab,
                                fret: r.FretNumber
                            };
                            i.sourceNote instanceof T.TabNote || (g.default.info(`invalid tab note: ${i.sourceNote.Pitch.ToString()} in measure ${t.parentStaffEntry.parentMeasure.MeasureNumber}, likely missing XML string+fret number.`), o = {
                                str: 1,
                                fret: 0
                            }), h.TabUseXNoteheadShapeForTabNote && i.sourceNote.Notehead?.Shape === E.NoteHeadShape.X && (o.fret = "x", c = !0), e.push(o), r.BendArray && r.BendArray.forEach(function(t) {
                                let e;
                                const i = t.bendalter - o.fret;
                                e = i > 1 ? "Full" : 1 === i ? "1/2" : "1/4", "up" === t.direction ? s.push({
                                    type: n.Bend.UP,
                                    text: e,
                                    width: 10
                                }) : s.push({
                                    type: n.Bend.DOWN,
                                    text: e,
                                    width: 10
                                });
                            }), l < i.numberOfDots && (l = i.numberOfDots);
                        }
                        for(let t = 0, e = l; t < e; ++t)a += "d";
                        const u = {
                            duration: a,
                            positions: e
                        };
                        let d;
                        d = t.parentVoiceEntry?.IsGrace ? new n.GraceTabNote(u) : new n.TabNote(u), d.render_options.font = P.vexFlowTextCssFont(d.render_options.font, h), c && (d.render_options.scale = h.TabXNoteheadScale, d.render_options.TabUseXNoteheadAlternativeGlyph = h.TabUseXNoteheadAlternativeGlyph, d.updateWidth()), h.UsePageBackgroundColorForTabNotes && (d.BackgroundColor = h.PageBackgroundColor);
                        for(let t = 0, e = i.length; t < e; t += 1)i[t].setIndex(d, t);
                        return s.forEach(function(t) {
                            const e = new n.Bend(t.text, t.type !== n.Bend.UP);
                            P.setVexFlowTextFontOfBend(e, h), d.addModifier(e);
                        }), d;
                    }
                    static Clef(t, e = "default") {
                        let i, s;
                        switch("default" !== e && "small" !== e && (g.default.warn(`Invalid VexFlow clef size "${e}" specified. Using "default".`), e = "default"), t.ClefType){
                            case r.ClefEnum.G:
                                switch(t.Line){
                                    case 1:
                                        i = "french";
                                        break;
                                    case 2:
                                        i = "treble";
                                        break;
                                    default:
                                        i = "treble", g.default.error(`Clef ${r.ClefEnum[t.ClefType]} on line ${t.Line} not supported by VexFlow. Using default value "${i}".`);
                                }
                                break;
                            case r.ClefEnum.F:
                                switch(t.Line){
                                    case 4:
                                        i = "bass";
                                        break;
                                    case 3:
                                        i = "baritone-f";
                                        break;
                                    case 5:
                                        i = "subbass";
                                        break;
                                    default:
                                        i = "bass", g.default.error(`Clef ${r.ClefEnum[t.ClefType]} on line ${t.Line} not supported by VexFlow. Using default value "${i}".`);
                                }
                                break;
                            case r.ClefEnum.C:
                                switch(t.Line){
                                    case 3:
                                        i = "alto";
                                        break;
                                    case 4:
                                        i = "tenor";
                                        break;
                                    case 1:
                                        i = "soprano";
                                        break;
                                    case 2:
                                        i = "mezzo-soprano";
                                        break;
                                    default:
                                        i = "alto", g.default.error(`Clef ${r.ClefEnum[t.ClefType]} on line ${t.Line} not supported by VexFlow. Using default value "${i}".`);
                                }
                                break;
                            case r.ClefEnum.percussion:
                                i = "percussion";
                                break;
                            case r.ClefEnum.TAB:
                                i = "treble";
                                break;
                            default:
                                g.default.info("bad clef type: " + t.ClefType), i = "treble";
                        }
                        return 1 === t.OctaveOffset && "bass" !== i ? s = "8va" : -1 === t.OctaveOffset && (s = "8vb"), {
                            type: i,
                            size: e,
                            annotation: s
                        };
                    }
                    static TimeSignature(t) {
                        let e;
                        switch(t.SymbolEnum){
                            case l.RhythmSymbolEnum.NONE:
                                e = t.Rhythm.Numerator + "/" + t.Rhythm.Denominator;
                                break;
                            case l.RhythmSymbolEnum.COMMON:
                                e = "C";
                                break;
                            case l.RhythmSymbolEnum.CUT:
                                e = "C|";
                        }
                        return new n.TimeSignature(e);
                    }
                    static keySignature(t) {
                        if (!t) return;
                        let e;
                        switch(t.Mode){
                            case h.KeyEnum.minor:
                                e = P.minorMap[t.Key] + "m";
                                break;
                            case h.KeyEnum.major:
                            case h.KeyEnum.none:
                                e = P.majorMap[t.Key];
                                break;
                            default:
                                e = "C";
                        }
                        return e;
                    }
                    static line(t, e) {
                        switch(t){
                            case d.SystemLinesEnum.SingleThin:
                                return e === S.SystemLinePosition.MeasureBegin ? n.StaveConnector.type.SINGLE : n.StaveConnector.type.SINGLE_RIGHT;
                            case d.SystemLinesEnum.DoubleThin:
                                return n.StaveConnector.type.THIN_DOUBLE;
                            case d.SystemLinesEnum.ThinBold:
                                return n.StaveConnector.type.BOLD_DOUBLE_RIGHT;
                            case d.SystemLinesEnum.BoldThinDots:
                                return n.StaveConnector.type.BOLD_DOUBLE_LEFT;
                            case d.SystemLinesEnum.DotsThinBold:
                            case d.SystemLinesEnum.DotsBoldBoldDots:
                                return n.StaveConnector.type.BOLD_DOUBLE_RIGHT;
                            case d.SystemLinesEnum.None:
                                return n.StaveConnector.type.NONE;
                        }
                    }
                    static font(t, e = f.FontStyles.Regular, i = m.Fonts.TimesNewRoman, s, n) {
                        let r = "normal", o = "normal", a = `'${s.DefaultFontFamily}'`;
                        switch(e){
                            case f.FontStyles.Bold:
                                o = "bold";
                                break;
                            case f.FontStyles.Italic:
                                r = "italic";
                                break;
                            case f.FontStyles.BoldItalic:
                                r = "italic", o = "bold";
                            case f.FontStyles.Underlined:
                        }
                        return m.Fonts.Kokila, n && "default" !== n && (a = `'${n}'`), r + " " + o + " " + Math.floor(t) + "px " + a;
                    }
                    static setVexFlowTextFontFamily(t, e) {
                        e.VexFlowTextFontFamily && (t.family = e.VexFlowTextFontFamily);
                    }
                    static setVexFlowTextFontOfBend(t, e) {
                        if (!e.VexFlowTextFontFamily) return;
                        const i = P.vexFlowTextCssFont(t.font, e);
                        if (t.setFont(i), M.MusicSheetCalculator.TextMeasurer.computeTextWidthInCssFont) {
                            for (const e of t.phrase){
                                const t = M.MusicSheetCalculator.TextMeasurer.computeTextWidthInCssFont(e.text, i);
                                e.width = Math.max(e.width, t + 3), e.draw_width = e.width / 2;
                            }
                            t.updateWidth();
                        }
                    }
                    static vexFlowTextCssFont(t, e) {
                        return e.VexFlowTextFontFamily ? `${t.split(" ")[0]} ${e.VexFlowTextFontFamily}` : t;
                    }
                    static fontStyle(t) {
                        switch(t){
                            case f.FontStyles.Bold:
                                return "bold";
                            case f.FontStyles.Italic:
                                return "italic";
                            case f.FontStyles.BoldItalic:
                                return "italic bold";
                            default:
                                return "normal";
                        }
                    }
                    static style(t) {
                        return p.OUTLINE_AND_FILL_STYLE_DICT.getValue(t);
                    }
                }
                e.VexFlowConverter = P, P.majorMap = {
                    "-1": "F",
                    "-2": "Bb",
                    "-3": "Eb",
                    "-4": "Ab",
                    "-5": "Db",
                    "-6": "Gb",
                    "-7": "Cb",
                    "-8": "Fb",
                    0: "C",
                    1: "G",
                    2: "D",
                    3: "A",
                    4: "E",
                    5: "B",
                    6: "F#",
                    7: "C#",
                    8: "G#"
                }, P.minorMap = {
                    "-1": "D",
                    "-2": "G",
                    "-3": "C",
                    "-4": "F",
                    "-5": "Bb",
                    "-6": "Eb",
                    "-7": "Ab",
                    "-8": "Db",
                    0: "A",
                    1: "E",
                    2: "B",
                    3: "F#",
                    4: "C#",
                    5: "G#",
                    6: "D#",
                    7: "A#",
                    8: "E#"
                };
            },
            1216 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.VexFlowGlissando = void 0;
                const s = i(98);
                class n extends s.GraphicalGlissando {
                }
                e.VexFlowGlissando = n;
            },
            9635 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.VexFlowGraphicalNote = void 0;
                var n = s(i(3206)).default.Flow;
                const r = i(3430), o = i(6014), a = i(8233), l = i(437), h = i(3849);
                class c extends r.GraphicalNote {
                    constructor(t, e, i, s = l.OctaveEnum.NONE, n, r){
                        if (super(t, e, n, r), this.clef = i, this.octaveShift = s, t.Pitch) {
                            const e = t.isRest() ? t.Pitch : l.OctaveShift.getPitchFromOctaveShift(t.Pitch, s);
                            this.vfpitch = o.VexFlowConverter.pitch(e, t.isRest(), this.clef, this.sourceNote.Notehead), this.vfpitch[1] = void 0;
                        }
                    }
                    setAccidental(t) {
                        const e = this.drawPitch(t);
                        this.vfpitch = o.VexFlowConverter.pitch(e, this.sourceNote.isRest(), this.clef, this.sourceNote.Notehead), (t.Accidental === a.AccidentalEnum.DOUBLESHARP && "sharp-sharp" === t.AccidentalXml || t.Accidental === a.AccidentalEnum.SHARP && "natural-sharp" === t.AccidentalXml || t.Accidental === a.AccidentalEnum.FLAT && "natural-flat" === t.AccidentalXml) && (this.vfpitch[1] = t.AccidentalXml), this.DrawnAccidental = e.Accidental;
                    }
                    drawPitch(t) {
                        return l.OctaveShift.getPitchFromOctaveShift(t, this.octaveShift);
                    }
                    Transpose(t, e, i, s) {
                        const n = super.Transpose(t, e, i, s), r = l.OctaveShift.getPitchFromOctaveShift(n, this.octaveShift);
                        return this.vfpitch = o.VexFlowConverter.pitch(r, this.sourceNote.isRest(), this.clef, this.sourceNote.Notehead), this.vfpitch[1] = void 0, r;
                    }
                    setIndex(t, e) {
                        this.vfnote = [
                            t,
                            e
                        ], this.vfnoteIndex = e;
                    }
                    notehead(t) {
                        let e = t;
                        e || (e = this.vfnote[0]);
                        const i = e.note_heads;
                        return i && i.length > this.vfnoteIndex && i[this.vfnoteIndex] ? e.note_heads[this.vfnoteIndex] : {
                            line: 0
                        };
                    }
                    Clef() {
                        return this.clef;
                    }
                    getSVGId() {
                        if (this.vfnote) return this.vfnote[0].getAttribute("id");
                    }
                    setVisible(t, e = {}) {
                        const i = e.applyToBeams ?? !0, s = e.applyToGlissandi ?? !0, n = e.applyToLedgerLines ?? !0, r = e.applyToNotehead ?? !0, o = e.applyToSlurs ?? !0, a = e.applyToStem ?? !0, l = e.applyToTies ?? !0, h = "visibility", c = t ? "visible" : "hidden";
                        if (r && this.getSVGGElement()?.setAttribute(h, c), a && this.getStemSVG()?.setAttribute(h, c), i) for (const t of this.getBeamSVGs())t?.setAttribute(h, c);
                        if (n) for (const t of this.getLedgerLineSVGs())t?.setAttribute(h, c);
                        if (l) for (const t of this.getTieSVGs())t?.setAttribute(h, c);
                        if (o) for (const t of this.getSlurSVGs())t?.setAttribute(h, c);
                        if (s) for (const t of this.getGlissandoSVGs())t?.setAttribute(h, c);
                    }
                    getSVGGElement() {
                        if (this.vfnote) return this.vfnote[0].getAttribute("el");
                    }
                    getStemSVG() {
                        const t = document.getElementById("vf-" + this.getSVGId() + "-stem");
                        return t?.children.length > 0 ? t.children[0] : t;
                    }
                    getBeamSVGs() {
                        const t = [];
                        for(let e = 0;; e++){
                            const i = document.getElementById(`vf-${this.getSVGId()}-beam${e}`);
                            if (!i) break;
                            t.push(i);
                        }
                        return t;
                    }
                    getLedgerLineSVGs() {
                        const t = [], e = `vf-${this.getSVGId()}ledgers`, i = document.getElementById(e);
                        if (!i) return [];
                        for (const e of i.childNodes)t.push(e);
                        return t;
                    }
                    getTieSVGs() {
                        const t = [], e = this.getSVGId();
                        if (!e) return t;
                        const i = document.querySelectorAll(`[id='vf-${e}-tie']`);
                        for (const e of i)t.push(e);
                        return t;
                    }
                    getSlurSVGs() {
                        const t = [], e = document.querySelectorAll(`[id='vf-${this.getSVGId()}-slur']`);
                        for (const i of e)t.push(i);
                        return t;
                    }
                    getGlissandoSVGs() {
                        const t = [], e = document.querySelectorAll(`[id='vf-${this.getSVGId()}-glissando']`);
                        for (const i of e)t.push(i);
                        return t;
                    }
                    getNoteheadSVGs() {
                        if (this.isTabNote) return this.getTabNoteSVGs().frets;
                        const t = this.getVFNoteSVG(), e = [];
                        if (t?.children?.length) for (const i of t.children)i.classList.contains("vf-notehead") && e.push(i);
                        return e;
                    }
                    getFlagSVG() {
                        const t = this.getVFNoteSVG();
                        if (t?.children?.length) {
                            for (const e of t.children)if (e.classList.contains("vf-flag")) return e;
                        }
                    }
                    getVFNoteSVG() {
                        if (this.parentVoiceEntry.parentStaffEntry.parentMeasure.isMultiRestMeasure()) return this.parentVoiceEntry.parentStaffEntry.parentMeasure.multiRestElement;
                        const t = this.getSVGGElement();
                        if (t) {
                            for (const e of t.children)if (e.classList.contains("vf-note")) return e;
                        }
                    }
                    getModifierSVGs() {
                        if (this.isTabNote) return this.getTabNoteSVGs().modifiers;
                        const t = this.getSVGGElement(), e = [];
                        if (!t?.children) return e;
                        if (t.children.length) for (const i of t.children)i.classList.contains("vf-modifiers") && e.push(i);
                        return e;
                    }
                    get isTabNote() {
                        return this.vfnote?.[0] instanceof n.TabNote;
                    }
                    getTabNoteSVGs() {
                        const t = Array.from(this.getSVGGElement()?.children ?? []), e = this.vfnote[0].positions?.length ?? 0, i = [];
                        for(let s = 0; s < e; s++)"rect" === t[2 * s]?.tagName && t[2 * s + 1] && i.push(t[2 * s + 1]);
                        return {
                            frets: i,
                            modifiers: t.slice(2 * e).filter((t)=>"g" !== t.tagName)
                        };
                    }
                    static colorShapes(t, e) {
                        if (t.children.length > 0) for (const i of t.children)i.setAttribute("fill", e);
                        else "none" === t.getAttribute("fill") ? t.setAttribute("stroke", e) : t.setAttribute("fill", e);
                    }
                    setColor(t, e = {}) {
                        const i = e.applyToBeams ?? !1, s = e.applyToFlag ?? !0, n = e.applyToGlissandi ?? !1, r = e.applyToLedgerLines ?? !1, o = e.applyToLyrics ?? !1, a = e.applyToModifiers ?? !0, l = e.applyToNoteheads ?? !0, u = e.applyToSlurs ?? !1, d = e.applyToStem ?? !0, f = e.applyToTies ?? !1, m = e.applyToMultiRestMeasure ?? !0, p = e.applyToMultiRestMeasureNumber ?? !0, g = e.applyToMultiRestMeasureRestBar ?? !0;
                        if (i) {
                            const e = this.getBeamSVGs();
                            for (const i of e)for (const e of i.children)e.setAttribute("fill", t);
                        }
                        if (s) {
                            const e = this.getFlagSVG();
                            if (e) for (const i of e.children)i.setAttribute("fill", t);
                        }
                        if (n) for (const e of this.getGlissandoSVGs())for (const i of e.querySelectorAll("path, text"))c.colorShapes(i, t);
                        if (r) {
                            const e = this.getLedgerLineSVGs();
                            for (const i of e)i.setAttribute("stroke", t);
                        }
                        if (o) {
                            const e = this.getLyricsSVGs();
                            for (const i of e)for (const e of i.children)e.setAttribute("stroke", t), e.setAttribute("fill", t);
                        }
                        if (m && this.parentVoiceEntry.parentStaffEntry.parentMeasure instanceof h.VexFlowMultiRestMeasure) {
                            const e = this.parentVoiceEntry.parentStaffEntry.parentMeasure.multiRestElementSVG;
                            if (e?.children?.length) for (const i of e.children)if (i.children?.length) {
                                if (p) for (const e of i.children)e.setAttribute("fill", t);
                            } else g && i.setAttribute("fill", t);
                        }
                        if (a) {
                            const e = this.getModifierSVGs();
                            for (const i of e)c.colorShapes(i, t);
                        }
                        if (l) {
                            const e = this.getNoteheadSVGs();
                            for (const i of e)c.colorShapes(i, t);
                        }
                        if (u) {
                            const e = this.getSlurSVGs();
                            for (const i of e)for (const e of i.children)e.setAttribute("fill", t);
                        }
                        if (d) {
                            const e = this.getStemSVG();
                            e && e.setAttribute("stroke", t);
                        }
                        if (f) {
                            const e = this.getTieSVGs();
                            for (const i of e)for (const e of i.children)e.setAttribute("fill", t);
                        }
                    }
                }
                e.VexFlowGraphicalNote = c;
            },
            3753 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.VexFlowGraphicalSymbolFactory = void 0;
                var n = s(i(3206)).default.Flow;
                const r = i(4332), o = i(5246), a = i(6670), l = i(437), h = i(9635), c = i(6659), u = i(4134), d = i(6014), f = i(6173), m = i(5866), p = i(3849), g = i(6362), b = i(1123);
                e.VexFlowGraphicalSymbolFactory = class {
                    createMusicSystem(t, e) {
                        return new r.VexFlowMusicSystem(t, e);
                    }
                    createStaffLine(t, e) {
                        return new m.VexFlowStaffLine(t, e);
                    }
                    createGraphicalMeasure(t, e, i = !1) {
                        return new o.VexFlowMeasure(e, t, void 0);
                    }
                    createMultiRestMeasure(t, e, i) {
                        return new p.VexFlowMultiRestMeasure(e, t, i);
                    }
                    createTabStaffMeasure(t, e) {
                        return new f.VexFlowTabMeasure(e, t);
                    }
                    createExtraGraphicalMeasure(t) {
                        const e = new o.VexFlowMeasure(t.ParentStaff, void 0, t);
                        return e.IsExtraGraphicalMeasure = !0, e.ExtraGraphicalMeasurePreviousMeasure = t.Measures.last(), e;
                    }
                    createStaffEntry(t, e) {
                        return new a.VexFlowStaffEntry(e, t, void 0);
                    }
                    createVoiceEntry(t, e) {
                        return new u.VexFlowVoiceEntry(t, e);
                    }
                    createNote(t, e, i, s = l.OctaveEnum.NONE, n, r) {
                        return new h.VexFlowGraphicalNote(t, e, i, s, n, r);
                    }
                    createGraceNote(t, e, i, s, n = l.OctaveEnum.NONE) {
                        return new h.VexFlowGraphicalNote(t, e, i, n, s);
                    }
                    addGraphicalAccidental(t, e) {
                        t.setAccidental(e);
                    }
                    addFermataAtTiedEndNote(t, e) {}
                    createInStaffClef(t, e) {
                        const i = t, s = d.VexFlowConverter.Clef(e, "small");
                        i.vfClefBefore = new n.ClefNote(s.type, s.size, s.annotation);
                    }
                    createInStaffKey(t, e, i, s) {
                        const n = t.parentMeasure, r = n.parentSourceMeasure.Rules;
                        if (!r.RenderKeySignatures || !n.ShowKeySignature || n.isTabMeasure && !r.TabKeySignatureRendered && !r.TabKeySignatureSpacingAdded) return;
                        const o = new b.VexFlowKeySignatureNote(d.VexFlowConverter.keySignature(e), d.VexFlowConverter.keySignature(i), d.VexFlowConverter.Clef(s).type), a = r.DefaultColorMusic || "#000000";
                        o.setStyle({
                            fillStyle: a,
                            strokeStyle: a
                        }), n.isTabMeasure && !r.TabKeySignatureRendered && (o.setStyle({
                            fillStyle: "#00000000",
                            strokeStyle: "#00000000"
                        }), o.keySignature.hidden = !0), t.vfKeys.push(o);
                    }
                    createChordSymbols(t, e, i, s) {
                        const n = e.parentMeasure.parentSourceMeasure.Rules;
                        let r = 0;
                        const o = n.ChordSymbolXSpacing;
                        for (const a of t.ChordContainers){
                            if (!a) continue;
                            let t = e.PositionAndShape;
                            1 === e.graphicalVoiceEntries.length && 1 === e.graphicalVoiceEntries[0].notes.length && e.graphicalVoiceEntries[0].notes[0].sourceNote.isWholeRest() && (t = e.parentMeasure.PositionAndShape, r += e.parentMeasure.beginInstructionsWidth, r += n.ChordSymbolWholeMeasureRestXOffset);
                            const l = new c.GraphicalChordSymbolContainer(a, t, n.ChordSymbolTextHeight, i, s, n), h = l.GetChordSymbolContainer.Placement, u = l.GraphicalLabel;
                            h === g.PlacementEnum.Below ? u.PositionAndShape.RelativePosition.y = n.StaffHeight + n.ChordSymbolYOffset : u.PositionAndShape.RelativePosition.y -= n.ChordSymbolYOffset, u.setLabelPositionAndShapeBorders();
                            let d = 0;
                            u.PositionAndShape.Size.width < n.ChordSymbolExtraXShiftWidthThreshold && (d = n.ChordSymbolExtraXShiftForShortChordSymbols), u.PositionAndShape.RelativePosition.x += r + d, u.setLabelPositionAndShapeBorders(), l.PositionAndShape.calculateBoundingBox(), e.graphicalChordContainers.push(l), r += u.PositionAndShape.Size.width + o;
                        }
                    }
                    createGraphicalTechnicalInstruction(t, e) {}
                };
            },
            7809 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.VexFlowInstantaneousDynamicExpression = void 0;
                const s = i(5023), n = i(8254), r = i(7435), o = i(7533), a = i(2570);
                class l extends s.GraphicalInstantaneousDynamicExpression {
                    constructor(t, e, i){
                        super(t, e, i);
                        const s = new r.Label(this.Expression);
                        this.label = new n.GraphicalLabel(s, this.rules.ContinuousDynamicTextHeight, o.TextAlignmentEnum.CenterCenter, this.rules, this.PositionAndShape), this.label.Label.fontStyle = a.FontStyles.BoldItalic, this.label.setLabelPositionAndShapeBorders(), this.PositionAndShape.calculateBoundingBox();
                    }
                    get InstantaneousDynamic() {
                        return this.mInstantaneousDynamicExpression;
                    }
                    get Expression() {
                        return this.mInstantaneousDynamicExpression.DynamicExpression;
                    }
                }
                e.VexFlowInstantaneousDynamicExpression = l;
            },
            7098 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.VexFlowInstrumentBrace = void 0;
                var n = s(i(3206)).default.Flow;
                const r = i(3109);
                class o extends r.VexFlowInstrumentBracket {
                    constructor(t, e, i = 0){
                        super(t, e, i), this.vexflowConnector.setType(n.StaveConnector.type.BRACE);
                    }
                }
                e.VexFlowInstrumentBrace = o;
            },
            3109 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.VexFlowInstrumentBracket = void 0;
                var n = s(i(3206)).default.Flow;
                const r = i(7741), o = i(6438), a = i(9479);
                class l extends r.GraphicalObject {
                    constructor(t, e, i = 0){
                        super(), this.Visible = !0, this.PositionAndShape = new o.BoundingBox(this, t.ParentMusicSystem.PositionAndShape);
                        const s = t.Measures[0], r = e.Measures[0];
                        this.addConnector(s.getVFStave(), r.getVFStave(), n.StaveConnector.type.BRACKET, i);
                    }
                    draw(t) {
                        this.Visible && this.vexflowConnector.setContext(t).draw();
                        const e = this.vexflowConnector, i = e.top_stave.getYForLine(0), s = e.bottom_stave.getYForLine(e.bottom_stave.getNumLines() - 1) + e.thickness;
                        this.PositionAndShape.AbsolutePosition.x = (e.top_stave.getX() - 2 + e.x_shift) / a.unitInPixels, this.PositionAndShape.AbsolutePosition.y = i / a.unitInPixels, this.PositionAndShape.Size.height = (s - i) / a.unitInPixels, this.PositionAndShape.Size.width = 12 / a.unitInPixels;
                    }
                    addConnector(t, e, i, s) {
                        this.vexflowConnector = new n.StaveConnector(t, e).setType(i).setXShift(-5 * s);
                    }
                }
                e.VexFlowInstrumentBracket = l;
            },
            1123 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.VexFlowKeySignatureNote = void 0;
                var n = s(i(3206)).default.Flow;
                class r extends n.KeySigNote {
                    static createCarrier(t, e) {
                        for (const i of t)i.setStave(e);
                        const i = new n.NoteSubGroup(t);
                        i.preFormat();
                        const s = new n.GhostNote("q");
                        return s.addModifier(i, 0), s.setExtraLeftPx(i.getWidth()), s.setWidth(i.getWidth()), s;
                    }
                    constructor(t, e, i){
                        super(t, e, void 0), this.attachedToNote = !1, this.clef = i;
                    }
                    setStave(t) {
                        return super.setStave(t), this.keySignature.setStave(t), this;
                    }
                    preFormat() {
                        const t = this.getStave(), e = t.clef;
                        try {
                            t.clef = this.clef, super.preFormat();
                        } finally{
                            t.clef = e;
                        }
                        return this;
                    }
                }
                e.VexFlowKeySignatureNote = r;
            },
            5246 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.StavePositionEnum = e.VexFlowMeasure = void 0;
                var n = s(i(3206)).default.Flow;
                const r = i(5748), o = i(6954), a = i(164), l = i(6014), h = i(1123), c = i(8365);
                var u = n.NoteSubGroup;
                const d = s(i(3065)), f = i(9479), m = i(1645), p = i(67), g = i(1336), b = i(4134), S = i(2561), y = i(9713), E = i(3123), x = i(6362), v = i(5282);
                class T extends r.GraphicalMeasure {
                    constructor(t, e, i){
                        super(t, e, i), this.octaveOffset = 3, this.vfVoices = {}, this.vfTies = [], this.vfRepetitionWords = [], this.hasMetronomeMark = !1, this.connectors = [], this.beams = {}, this.autoVfBeams = [], this.autoTupletVfBeams = [], this.vfbeams = {}, this.tuplets = {}, this.vftuplets = {}, this.minimumStaffEntriesWidth = -1, this.rules = i ? i.ParentMusicSystem.rules : e ? e.Rules : new y.EngravingRules, this.resetLayout();
                    }
                    get NotesAreAbbreviated() {
                        return void 0 !== this.MeasureRepeat;
                    }
                    setAbsoluteCoordinates(t, e) {
                        this.stave.setX(t).setY(e);
                    }
                    resetLayout() {
                        this.stave = new n.Stave(0, 0, 0, {
                            fill_style: this.rules.StaffLineColor,
                            space_above_staff_ln: 0,
                            space_below_staff_ln: 0
                        }), this.InitiallyActiveClef && (this.stave.clef = l.VexFlowConverter.Clef(this.InitiallyActiveClef).type), this.stave.MeasureNumber = this.MeasureNumber, this.hasMetronomeMark = !1, this.vfRepetitionWords = [], this.ParentStaff && this.setLineNumber(this.ParentStaff.StafflineCount), this.stave.setBegBarType(n.Barline.type.NONE), this.parentSourceMeasure && this.parentSourceMeasure.endingBarStyleEnum === o.SystemLinesEnum.None && this.stave.setEndBarType(n.Barline.type.NONE), this.updateInstructionWidth();
                    }
                    clean() {
                        this.vfTies.length = 0, this.connectors = [], this.resetLayout();
                    }
                    getLineWidth(t) {
                        switch(t){
                            case o.SystemLinesEnum.BoldThinDots:
                            case o.SystemLinesEnum.DotsThinBold:
                                return 10 / f.unitInPixels;
                            case o.SystemLinesEnum.DotsBoldBoldDots:
                                return 10 / f.unitInPixels + this.rules.RepeatEndStartPadding;
                            default:
                                return 0;
                        }
                    }
                    addClefAtBegin(t) {
                        if (this.rules.RenderClefsAtBeginningOfStaffline) {
                            if (this.octaveOffset = t.OctaveOffset, t.ClefType === a.ClefEnum.TAB) this.stave.addClef("tab", void 0, void 0, void 0);
                            else {
                                const e = l.VexFlowConverter.Clef(t, "default");
                                this.stave.addClef(e.type, e.size, e.annotation, n.StaveModifier.Position.BEGIN);
                            }
                            this.updateInstructionWidth();
                        }
                    }
                    setLineNumber(t) {
                        5 !== t && (0 === t ? (this.stave.setNumLines(0), this.stave.getBottomLineY = function() {
                            return this.getYForLine(this.options.num_lines);
                        }) : 1 === t ? (this.stave.options.line_config = [
                            {
                                visible: !1
                            },
                            {
                                visible: !1
                            },
                            {
                                visible: !0
                            },
                            {
                                visible: !1
                            },
                            {
                                visible: !1
                            }
                        ], this.stave.getBottomLineY = function() {
                            return this.getYForLine(2);
                        }) : 2 === t ? (this.stave.options.line_config = [
                            {
                                visible: !1
                            },
                            {
                                visible: !1
                            },
                            {
                                visible: !0
                            },
                            {
                                visible: !0
                            },
                            {
                                visible: !1
                            }
                        ], this.stave.getBottomLineY = function() {
                            return this.getYForLine(3);
                        }) : 3 === t ? (this.stave.options.line_config = [
                            {
                                visible: !1
                            },
                            {
                                visible: !0
                            },
                            {
                                visible: !0
                            },
                            {
                                visible: !0
                            },
                            {
                                visible: !1
                            }
                        ], this.stave.getBottomLineY = function() {
                            return this.getYForLine(2);
                        }) : (this.stave.setNumLines(t), this.stave.getBottomLineY = function() {
                            return this.getYForLine(this.options.num_lines);
                        }));
                    }
                    addKeyAtBegin(t, e, i) {
                        if (this.rules.RenderKeySignatures && this.ShowKeySignature && (!this.isTabMeasure || this.rules.TabKeySignatureRendered || this.rules.TabKeySignatureSpacingAdded) && (!this.parentSourceMeasure?.isReducedToMultiRest || this.rules.MultipleRestMeasureAddKeySignature)) {
                            if (this.stave.setKeySignature(l.VexFlowConverter.keySignature(t), l.VexFlowConverter.keySignature(e), void 0), this.isTabMeasure && !this.rules.TabKeySignatureRendered) {
                                const t = this.stave.getModifiers();
                                for (const e of t)if (e instanceof n.KeySignature) {
                                    e.setStyle({
                                        fillStyle: "#00000000"
                                    }), e.hidden = !0;
                                    break;
                                }
                            }
                            this.updateInstructionWidth();
                        }
                    }
                    addRhythmAtBegin(t) {
                        if (this.isTabMeasure && !this.rules.TabTimeSignatureRendered && !this.rules.TabTimeSignatureSpacingAdded) return;
                        const e = l.VexFlowConverter.TimeSignature(t);
                        this.stave.addModifier(e, n.StaveModifier.Position.BEGIN), (!this.ShowTimeSignature || this.isTabMeasure && !this.rules.TabTimeSignatureRendered) && (e.setStyle({
                            fillStyle: "#00000000"
                        }), e.hidden = !0), this.updateInstructionWidth();
                    }
                    addClefAtEnd(t, e = !0) {
                        if (this.isTabMeasure) return;
                        const i = l.VexFlowConverter.Clef(t, "small");
                        if (e || !this.stave.endClef) {
                            this.stave.setEndClef(i.type, i.size, i.annotation);
                            for (const t of this.stave.getModifiers())if (e) {
                                const e = t.originalStrokeStyle, i = t.originalFillStyle;
                                t.getStyle() && (e && i ? (t.getStyle().strokeStyle = e, t.getStyle().fillStyle = i) : (t.getStyle().strokeStyle = null, t.getStyle().fillStyle = null));
                            } else if ("clefs" === t.getCategory() && t.getPosition() === n.StaveModifier.Position.END && t.type === i.type) {
                                const e = "#12345600", i = t.getStyle();
                                i && (t.originalStrokeStyle = i.strokeStyle, t.originalFillStyle = i.fillStyle), t.setStyle({
                                    strokeStyle: e,
                                    fillStyle: e
                                });
                            }
                            return this.parentSourceMeasure.hasEndClef = !0, this.updateInstructionWidth();
                        }
                    }
                    addMeasureLine(t, e, i = !0) {
                        switch(e){
                            case p.SystemLinePosition.MeasureBegin:
                                t === o.SystemLinesEnum.BoldThinDots && (i || (this.stave.modifiers[0].draw = function(t) {
                                    switch(t.checkContext(), this.setRendered(), this.type){
                                        case n.Barline.type.SINGLE:
                                            this.drawVerticalBar(t, this.x, !1);
                                            break;
                                        case n.Barline.type.DOUBLE:
                                            this.drawVerticalBar(t, this.x, !0);
                                            break;
                                        case n.Barline.type.END:
                                            this.drawVerticalEndBar(t, this.x);
                                            break;
                                        case n.Barline.type.REPEAT_BEGIN:
                                            this.drawRepeatBar(t, this.x, !0);
                                            break;
                                        case n.Barline.type.REPEAT_END:
                                            this.drawRepeatBar(t, this.x, !1);
                                            break;
                                        case n.Barline.type.REPEAT_BOTH:
                                            this.drawRepeatBar(t, this.x, !1), this.drawRepeatBar(t, this.x, !0);
                                    }
                                }), this.stave.setBegBarType(n.Barline.type.REPEAT_BEGIN));
                                break;
                            case p.SystemLinePosition.MeasureEnd:
                                switch(t){
                                    case o.SystemLinesEnum.DotsBoldBoldDots:
                                        this.stave.setEndBarType(n.Barline.type.REPEAT_BOTH);
                                        break;
                                    case o.SystemLinesEnum.DotsThinBold:
                                        this.stave.setEndBarType(n.Barline.type.REPEAT_END);
                                        break;
                                    case o.SystemLinesEnum.DoubleThin:
                                        this.stave.setEndBarType(n.Barline.type.DOUBLE);
                                        break;
                                    case o.SystemLinesEnum.ThinBold:
                                        this.stave.setEndBarType(n.Barline.type.END);
                                        break;
                                    case o.SystemLinesEnum.DoubleBold:
                                        this.stave.setEndBarType(8);
                                        break;
                                    case o.SystemLinesEnum.None:
                                        this.stave.setEndBarType(n.Barline.type.NONE);
                                }
                        }
                    }
                    addMeasureNumber() {
                        const t = this.MeasureNumber.toString(), e = _.ABOVE;
                        this.stave.setText(t, e, {
                            justification: 1,
                            shift_x: 0,
                            shift_y: 0
                        });
                    }
                    addWordRepetition(t) {
                        let e, i = n.StaveModifier.Position.END;
                        const s = this.beginInstructionsWidth;
                        switch(t.type){
                            case m.RepetitionInstructionEnum.Segno:
                                e = n.Repetition.type.SEGNO_LEFT, i = n.StaveModifier.Position.LEFT;
                                break;
                            case m.RepetitionInstructionEnum.Coda:
                                e = n.Repetition.type.CODA_LEFT, i = n.StaveModifier.Position.LEFT;
                                break;
                            case m.RepetitionInstructionEnum.DaCapo:
                                e = n.Repetition.type.DC;
                                break;
                            case m.RepetitionInstructionEnum.DalSegno:
                                e = n.Repetition.type.DS;
                                break;
                            case m.RepetitionInstructionEnum.Fine:
                                e = n.Repetition.type.FINE;
                                break;
                            case m.RepetitionInstructionEnum.ToCoda:
                                e = n.Repetition.type.TO_CODA;
                                break;
                            case m.RepetitionInstructionEnum.DaCapoAlFine:
                                e = n.Repetition.type.DC_AL_FINE;
                                break;
                            case m.RepetitionInstructionEnum.DaCapoAlCoda:
                                e = n.Repetition.type.DC_AL_CODA;
                                break;
                            case m.RepetitionInstructionEnum.DalSegnoAlFine:
                                e = n.Repetition.type.DS_AL_FINE;
                                break;
                            case m.RepetitionInstructionEnum.DalSegnoAlCoda:
                                e = n.Repetition.type.DS_AL_CODA;
                        }
                        if (e) {
                            const r = new n.Repetition(e, s, -this.rules.RepetitionSymbolsYOffset);
                            l.VexFlowConverter.setVexFlowTextFontFamily(r.font, this.rules), t.Words && r.setText(t.Words);
                            const o = this.ParentStaffLine?.Measures;
                            return o && o[o.length - 1] !== this || (r.xShiftAsPercentOfStaveWidth = this.rules.RepetitionEndInstructionXShiftAsPercentOfStaveWidth), this.stave.addModifier(r, i), this.vfRepetitionWords.push(r), r;
                        }
                        this.addVolta(t);
                    }
                    addVolta(t) {
                        let e = n.Volta.type.BEGIN;
                        if (t.type === m.RepetitionInstructionEnum.Ending) {
                            switch(t.alignment){
                                case m.AlignmentType.Begin:
                                    e = this.parentSourceMeasure.endsRepetitionEnding() ? n.Volta.type.BEGIN_END : n.Volta.type.BEGIN;
                                    break;
                                case m.AlignmentType.Discontinue:
                                    if (this.parentSourceMeasure.beginsRepetitionEnding()) return;
                                    e = n.Volta.type.MID;
                                    break;
                                case m.AlignmentType.End:
                                    if (this.parentSourceMeasure.beginsRepetitionEnding()) return;
                                    e = n.Volta.type.END;
                                    break;
                                case m.AlignmentType.Mid:
                                    e = n.Volta.type.MID;
                            }
                            const i = this.ParentStaffLine.SkyBottomLineCalculator, s = this.PositionAndShape.AbsolutePosition.x + this.PositionAndShape.BorderMarginLeft + .4, r = Math.max(this.PositionAndShape.AbsolutePosition.x + this.PositionAndShape.BorderMarginRight, s + .4), o = i.getSkyLineMinInRange(s, r) - 2;
                            let a, h = -6.1 + this.rules.VoltaOffset, c = this.rules.VoltaOffset;
                            o < h && (c += o - h, h = o);
                            const u = this.parentSourceMeasure.MeasureNumber;
                            for(let t = 0; t < this.ParentStaffLine.Measures.length; t++){
                                const e = this.ParentStaffLine.Measures[t];
                                e instanceof T && (e.MeasureNumber !== u - 1 && e.MeasureNumber + e.parentSourceMeasure?.multipleRestMeasures !== u || (a = e));
                            }
                            if (a) {
                                const t = a.stave.getModifiers();
                                for(let e = 0; e < t.length; e++){
                                    const i = t[e];
                                    if (i.hasOwnProperty("volta")) {
                                        const t = a.ParentStaffLine.SkyBottomLineCalculator, e = a.PositionAndShape.AbsolutePosition.x + a.PositionAndShape.BorderMarginLeft + .4, s = Math.max(a.PositionAndShape.AbsolutePosition.x + a.PositionAndShape.BorderMarginRight, e + .4), n = t.getSkyLineMinInRange(e, s);
                                        n <= h ? (c += n - h, h = n) : (i.y_shift = c * f.unitInPixels, a.ParentStaffLine.SkyBottomLineCalculator.updateSkyLineInRange(e, s, h));
                                    }
                                }
                            }
                            c *= 10, this.stave.setVoltaType(e, t.endingIndices[0], c);
                            const d = this.stave.getModifiers().last();
                            l.VexFlowConverter.setVexFlowTextFontFamily(d.font, this.rules), i.updateSkyLineInRange(s, r, h);
                        }
                    }
                    setWidth(t) {
                        super.setWidth(t), this.stave.setWidth(t * f.unitInPixels);
                    }
                    layoutSymbols() {}
                    draw(t) {
                        const e = t.openGroup();
                        e && (e.classList?.add("vf-measure"), e.id = `${this.MeasureNumber}`), this.stave.setContext(t).draw(), this.MeasureRepeat ? this.MeasureRepeat.draw(t, this) : this.drawNotes(t), t.closeGroup();
                        for (const e of this.connectors)t.openGroup("connector"), e.setContext(t).draw(), t.closeGroup();
                        this.correctNotePositions();
                    }
                    drawNotes(t) {
                        this.postFormatBeams();
                        for(const e in this.vfVoices)this.vfVoices.hasOwnProperty(e) && (t.save(), this.vfVoices[e].draw(t, this.stave), t.restore());
                        for(const e in this.vfbeams)if (this.vfbeams.hasOwnProperty(e)) for (const i of this.vfbeams[e])i.setContext(t).draw();
                        if (this.autoVfBeams) for (const e of this.autoVfBeams)e.setContext(t).draw();
                        if (!this.isTabMeasure || this.rules.TupletNumbersInTabs) {
                            if (this.autoTupletVfBeams) for (const e of this.autoTupletVfBeams)e.setContext(t).draw();
                            for(const e in this.vftuplets)if (this.vftuplets.hasOwnProperty(e)) for(let i = 0; i < this.tuplets[e].length; i++){
                                const s = this.tuplets[e][i][0], n = this.vftuplets[e][i];
                                n && (!s.RenderTupletNumber || s.ShowNumberNoneGivenInXml && this.rules.TupletNumberUseShowNoneXMLValue ? n.RenderTupletNumber = !1 : n.RenderTupletNumber = !0, n.setContext(t).draw());
                            }
                        }
                        for (const e of this.vfTies){
                            if (e instanceof n.TabSlide) continue;
                            e.setContext(t), e.draw();
                            const i = e.getAttribute("el");
                            "text" === i?.nextSibling?.nodeName && i.appendChild(i.nextSibling);
                        }
                    }
                    postFormatBeams() {
                        const t = [
                            ...this.autoVfBeams ?? []
                        ];
                        for(const e in this.vfbeams)this.vfbeams.hasOwnProperty(e) && t.push(...this.vfbeams[e]);
                        this.isTabMeasure && !this.rules.TupletNumbersInTabs || t.push(...this.autoTupletVfBeams ?? []);
                        for (const e of t)if (!e.postFormatted) {
                            for (const t of e.getNotes())t.setStave(this.stave);
                            e.postFormat();
                        }
                    }
                    applyDrawSideEffects() {
                        this.MeasureRepeat || this.postFormatBeams(), this.correctNotePositions();
                    }
                    format(t) {
                        if (this.formatVoices) {
                            if (t && this.isRepeatedFormat(t)) return;
                            this.formatVoices((this.PositionAndShape.Size.width - this.beginInstructionsWidth - this.endInstructionsWidth) * f.unitInPixels, this);
                        }
                    }
                    isRepeatedFormat(t) {
                        const e = this.parentSourceMeasure;
                        if (!e || e.VerticalMeasureList.some((t)=>t?.isTabMeasure)) return !1;
                        const i = this.getVFStave(), s = i.getNoteEndX() - i.getNoteStartX() - 10, n = t.get(e);
                        return n?.formatVoices === this.formatVoices && n.justifyWidth === s || (t.set(e, {
                            formatVoices: this.formatVoices,
                            justifyWidth: s
                        }), !1);
                    }
                    correctNotePositions() {
                        if (this.isTabMeasure) return void this.correctTabNotePositions();
                        this.updateBeamedVoiceEntryBorders();
                        const t = this.stave.getYForLine(0);
                        for (const e of this.staffEntries)for (const i of e.graphicalVoiceEntries){
                            const s = e.PositionAndShape.RelativePosition.y + i.PositionAndShape.RelativePosition.y;
                            for (const e of i.notes){
                                const i = e;
                                if (i.sourceNote.isRest()) continue;
                                if (!i.vfnote) continue;
                                const n = i.vfnote[0].note_heads?.[i.vfnoteIndex];
                                if (!n) continue;
                                const r = (this.stave.getYForNote(n.getLine()) - t) / f.unitInPixels;
                                i.PositionAndShape.RelativePosition.y = r - s;
                            }
                        }
                    }
                    updateBeamedVoiceEntryBorders() {
                        const t = this.stave.getYForLine(0);
                        for (const e of this.staffEntries)for (const i of e.graphicalVoiceEntries){
                            const e = i.vfStaveNote;
                            e?.beam && e.preFormatted && e.getNoteHeadBeginX && !i.notes[0]?.sourceNote.isRest() && i.applyVerticalBordersFromVexflow(e.getBoundingBox(), t);
                        }
                    }
                    correctTabNotePositions() {
                        const t = (t)=>(t.sourceNote.StringNumberTab - 1) * this.rules.TabStaffInterlineHeightForBboxes;
                        for (const e of this.staffEntries)for (const i of e.graphicalVoiceEntries){
                            const e = i.notes.filter((t)=>t.sourceNote.StringNumberTab >= 0);
                            if (0 === e.length) continue;
                            const s = t(e[e.length - 1]);
                            i.PositionAndShape.RelativePosition.y = s;
                            for (const i of e)i.PositionAndShape.RelativePosition.y = t(i) - s;
                            i.PositionAndShape.calculateBoundingBox();
                        }
                    }
                    getVoicesWithinMeasure() {
                        const t = [];
                        for (const e of this.staffEntries)for (const i of e.graphicalVoiceEntries)-1 === t.indexOf(i.parentVoiceEntry.ParentVoice) && t.push(i.parentVoiceEntry.ParentVoice);
                        return t;
                    }
                    getGraphicalVoiceEntriesPerVoice(t) {
                        const e = [];
                        for (const i of this.staffEntries)for (const s of i.graphicalVoiceEntries)s.parentVoiceEntry.ParentVoice === t && e.push(s);
                        return e;
                    }
                    getRestFilledVexFlowStaveNotesPerVoice(t) {
                        let e, i = this.getGraphicalVoiceEntriesPerVoice(t);
                        for(let t = 0; t < i.length; t++){
                            const s = i[t];
                            if (s.parentVoiceEntry?.IsGrace && !s.isStandAloneGrace) continue;
                            if (s.isStandAloneGrace) {
                                const r = s.notes[0].sourceNote.getAbsoluteTimestamp(), o = e ?? this.parentSourceMeasure.AbsoluteTimestamp, a = S.Fraction.minus(r, o);
                                if (a.RealValue > 0) {
                                    const e = this.createGhostGves(a);
                                    i.splice(t, 0, ...e), t += e.length;
                                }
                                let l = t;
                                for(; i[l + 1]?.isStandAloneGrace && i[l + 1].notes[0].sourceNote.getAbsoluteTimestamp().Equals(r);)l++;
                                const h = i.slice(l + 1).find((t)=>!t.parentVoiceEntry?.GraceAfterMainNote), c = S.Fraction.max(r, o);
                                let u = h ? h.notes[0].sourceNote.getAbsoluteTimestamp() : S.Fraction.plus(this.parentSourceMeasure.AbsoluteTimestamp, this.parentSourceMeasure.Duration);
                                const d = i.slice(t, l + 1).map((t)=>t.vfStaveNote);
                                this.isTabMeasure && h?.notes[0].sourceNote.isRest() && u.Equals(c) && (d.push(...h.vfGhostNotes), u = S.Fraction.plus(u, h.notes[0].sourceNote.Length));
                                const f = this.fitTicks(d, S.Fraction.minus(u, c));
                                e = S.Fraction.plus(c, new S.Fraction(f.numerator, f.denominator * n.RESOLUTION)), t = l;
                                continue;
                            }
                            const r = s.notes[0].sourceNote.getAbsoluteTimestamp();
                            let o = new S.Fraction;
                            for (const t of s.notes){
                                const e = S.Fraction.plus(t.sourceNote.getAbsoluteTimestamp(), t.sourceNote.Length);
                                o.lt(e) && (o = e);
                            }
                            if (e) {
                                const s = S.Fraction.minus(r, e);
                                if (s.RealValue > 0) {
                                    d.default.trace(`Ghost Found in between (measure ${this.MeasureNumber})`);
                                    const e = this.createGhostGves(s);
                                    i.splice(t, 0, ...e), t += e.length;
                                }
                            } else {
                                const e = S.Fraction.minus(r, this.parentSourceMeasure.AbsoluteTimestamp);
                                if (e.RealValue > 0) {
                                    d.default.trace(`Ghost Found at start (measure ${this.MeasureNumber})`);
                                    const s = this.createGhostGves(e);
                                    i.splice(0, 0, ...s), t += s.length;
                                }
                            }
                            e = o;
                        }
                        const s = S.Fraction.plus(this.parentSourceMeasure.AbsoluteTimestamp, this.parentSourceMeasure.Duration);
                        e || (e = this.parentSourceMeasure.AbsoluteTimestamp);
                        const r = S.Fraction.minus(s, e);
                        if (r.RealValue > 0) {
                            d.default.trace(`Ghost Found at end (measure ${this.MeasureNumber})`);
                            const t = this.createGhostGves(r);
                            i = i.concat(t);
                        }
                        return i;
                    }
                    fitTicks(t, e) {
                        const i = new n.Fraction(0, 1);
                        for (const e of t)0 === e.getTicks().denominator && (e.getTicks().denominator = 1), i.add(e.getTicks().numerator, e.getTicks().denominator).simplify();
                        const s = new n.Fraction(e.GetExpandedNumerator() * n.RESOLUTION, e.Denominator).simplify();
                        if (s.value() <= 0 || i.value() <= s.value()) return i;
                        for (const e of t)e.getTicks().multiply(s.numerator * i.denominator, s.denominator * i.numerator).simplify();
                        return s;
                    }
                    createGhostGves(t) {
                        const e = l.VexFlowConverter.GhostNotes(t), i = [];
                        for (const t of e){
                            const e = new b.VexFlowVoiceEntry(void 0, void 0, this.rules);
                            e.vfStaveNote = t, i.push(e);
                        }
                        return i;
                    }
                    handleBeam(t, e) {
                        const i = t.sourceNote.ParentVoiceEntry.ParentVoice.VoiceId;
                        let s, n = this.beams[i];
                        n || (n = this.beams[i] = []);
                        for (const t of n)t[0] === e && (s = t);
                        s || (s = [
                            e,
                            []
                        ], n.push(s));
                        const r = t.parentVoiceEntry;
                        s[1].indexOf(r) < 0 && s[1].push(r);
                    }
                    handleTuplet(t, e) {
                        const i = t.sourceNote.ParentVoiceEntry.ParentVoice.VoiceId;
                        let s, n = this.tuplets[i];
                        n || (n = this.tuplets[i] = []);
                        for (const t of n)t[0] === e && (s = t);
                        s || (s = [
                            e,
                            []
                        ], n.push(s));
                        const r = t.parentVoiceEntry;
                        s[1].indexOf(r) < 0 && s[1].push(r);
                    }
                    finalizeBeams() {
                        if (this.vfbeams = {}, this.isTabMeasure && !this.rules.TabBeamsRendered) return;
                        const t = [];
                        for(const e in this.beams)if (this.beams.hasOwnProperty(e)) {
                            let i = this.vfbeams[e];
                            i || (i = this.vfbeams[e] = []);
                            for (const s of this.beams[e]){
                                let e = !1;
                                for (const t of s[0].Notes)if (t.Length.RealValue >= new S.Fraction(1, 4).RealValue && (!t.TypeLength || t.TypeLength.RealValue > .125)) {
                                    e = !0;
                                    break;
                                }
                                if (e) {
                                    d.default.debug("Beam between notes >= quarter, likely a tremolo between two notes. Not creating a beam. (tremolo strokes are drawn in VexFlowMusicSheetDrawer.drawTremolosBetweenNotes instead)");
                                    continue;
                                }
                                const r = [], o = s[0], a = s[1];
                                let l = !0;
                                for (const t of a)t.parentVoiceEntry.ParentVoice === o.Notes[0].ParentVoiceEntry.ParentVoice && (l = t.parentVoiceEntry.WantedStemDirection === g.StemDirectionType.Undefined);
                                let h, c = !1;
                                const u = [];
                                for (const e of a){
                                    const i = e.vfStaveNote;
                                    i && (r.push(i), t.push(i)), e.parentVoiceEntry.IsGrace && (c = !0), e.parentVoiceEntry.StemColor && this.rules.ColoringEnabled && u.push(e.parentVoiceEntry.StemColor);
                                }
                                if (r.length > 1) {
                                    const t = new n.Beam(r, l);
                                    if (o.SecondaryBreakIndices?.length > 0 && t.breakSecondaryAt(o.SecondaryBreakIndices), c && (t.render_options.beam_width = 3, t.render_options.partial_beam_length = 4), u.length >= 2 && this.rules.ColorBeams) {
                                        h = u[0];
                                        for (const t of u)if (t !== h) {
                                            h = void 0;
                                            break;
                                        }
                                        t.setStyle({
                                            fillStyle: h,
                                            strokeStyle: h
                                        });
                                    }
                                    this.rules.FlatBeams && (t.render_options.flat_beams = !0, t.render_options.flat_beam_offset = this.rules.FlatBeamOffset, t.render_options.flat_beam_offset_per_beam = this.rules.FlatBeamOffsetPerBeam), this.applyLedgerLineEngravingRule(t), i.push(t);
                                } else d.default.debug("Warning! Beam with no notes!");
                            }
                        }
                        this.rules.AutoBeamNotes && this.autoBeamNotes(t);
                    }
                    autoBeamNotes(t) {
                        if (!this.rules.AutoBeamTabs && this.isTabMeasure) return;
                        let e, i = 60, s = [], r = [], o = [];
                        this.autoTupletVfBeams = [];
                        const a = [];
                        this.autoVfBeams = [];
                        let l = this.parentSourceMeasure.ActiveTimeSignature;
                        l || (l = this.parentSourceMeasure.Duration);
                        for (const h of this.staffEntries)for (const u of h.graphicalVoiceEntries){
                            const d = u.vfStaveNote, f = u.notes[0], m = {
                                vfStaveNote: d,
                                sourceNote: f.sourceNote
                            }, p = h.relInMeasureTimestamp.isOnBeat(l), g = r.length >= 2, b = f.sourceNote.Length.RealValue - new S.Fraction(1, 4).RealValue > -S.Fraction.FloatInaccuracyTolerance, y = u.parentVoiceEntry.IsGrace || b || t.contains(d);
                            if (y || p) {
                                if (g) {
                                    for (const t of r)s.push(t);
                                    a.push(s.slice()), s = [];
                                }
                                if (r = [], y) continue;
                            }
                            const E = u.notes[0].sourceNote.NoteTuplet;
                            if (E) {
                                let t = !1;
                                for (const e of E.Notes){
                                    for (const i of e)if (i.NoteTypeXml >= v.NoteType.QUARTER || i.ParentVoiceEntry.IsGrace || i.isRest() && !this.rules.AutoBeamOptions.beam_rests) {
                                        t = !0;
                                        break;
                                    }
                                    if (t) break;
                                }
                                if (e) {
                                    if (e !== E) {
                                        if (o.length > 1) {
                                            const t = [];
                                            for (const e of o)t.push(e.vfStaveNote);
                                            const e = new n.Beam(t, !0);
                                            this.rules.FlatBeams && (e.render_options.flat_beams = !0, e.render_options.flat_beam_offset = this.rules.FlatBeamOffset, e.render_options.flat_beam_offset_per_beam = this.rules.FlatBeamOffsetPerBeam), this.applyLedgerLineEngravingRule(e), this.autoTupletVfBeams.push(e);
                                            const s = new c.Beam(i++);
                                            s.AutoGenerated = !0;
                                            for (const t of o)s.addNoteToBeam(t.sourceNote);
                                        }
                                        o = [], e = E;
                                    }
                                } else e = E;
                                t || o.push(m);
                                continue;
                            }
                            e = void 0, r.push(m);
                        }
                        if (o.length >= 2) {
                            const t = [];
                            for (const e of o)t.push(e.vfStaveNote);
                            const e = new n.Beam(t, !0);
                            this.rules.FlatBeams && (e.render_options.flat_beams = !0, e.render_options.flat_beam_offset = this.rules.FlatBeamOffset, e.render_options.flat_beam_offset_per_beam = this.rules.FlatBeamOffsetPerBeam), this.applyLedgerLineEngravingRule(e), this.autoTupletVfBeams.push(e);
                            const s = new c.Beam(i++);
                            s.AutoGenerated = !0;
                            for (const t of o)s.addNoteToBeam(t.sourceNote);
                        }
                        if (r.length >= 2) {
                            for (const t of r)s.push(t);
                            a.push(s);
                        }
                        const h = this.rules.AutoBeamOptions, u = {
                            beam_middle_only: h.beam_middle_rests_only,
                            beam_rests: h.beam_rests,
                            maintain_stem_directions: h.maintain_stem_directions
                        };
                        if (h.groups && h.groups.length) {
                            const t = [];
                            for (const e of h.groups)t.push(new n.Fraction(e[0], e[1]));
                            u.groups = t;
                        }
                        for (const t of a){
                            const e = [];
                            for (const i of t)e.push(i.vfStaveNote);
                            const i = n.Beam.generateBeams(e, u);
                            for (const t of i)this.rules.FlatBeams && (t.render_options.flat_beams = !0, t.render_options.flat_beam_offset = this.rules.FlatBeamOffset, t.render_options.flat_beam_offset_per_beam = this.rules.FlatBeamOffsetPerBeam), this.applyLedgerLineEngravingRule(t), this.autoVfBeams.push(t);
                        }
                    }
                    applyLedgerLineEngravingRule(t) {
                        const e = this.rules, i = (t)=>function() {
                                if (t && t.call(this), !e || !e.OptimizeExtremeLedgerBeams) return;
                                if (!this.notes || 0 === this.notes.length) return;
                                const i = this.stem_direction;
                                if (-1 !== i && 1 !== i) return;
                                const s = this.notes[0].getStave();
                                if (!s) return;
                                const n = -1 === i, r = s.getYForLine(n ? -3 : 7);
                                if (!this.notes.some((t)=>t.getYs().some((t)=>n ? t <= r : t >= r))) return;
                                const o = this.notes[0].getStemX();
                                let a = this.notes[this.notes.length - 1].getStemX() - o;
                                0 === a && (a = 1);
                                const l = s.getYForLine(2), h = (t)=>n ? Math.max(...t) : Math.min(...t), c = h(this.notes[0].getYs()), u = h(this.notes[this.notes.length - 1].getYs()), d = n ? c > u : c < u, f = 6 * (n ? -1 : 1), m = l + (d ? 0 : f), p = l + (d ? f : 0);
                                this.slope = (p - m) / a;
                                let g = m;
                                for (const t of this.notes){
                                    const e = t.getYs();
                                    if (0 === e.length) continue;
                                    const i = h(e), s = t.getStemX(), r = m + (s - o) * this.slope, a = i + (n ? 28 : -28);
                                    if (n ? r < a : r > a) {
                                        const t = a - (s - o) * this.slope;
                                        g = n ? Math.max(g, t) : Math.min(g, t);
                                    }
                                }
                                const b = this.notes[0].getStemExtents ? this.notes[0].getStemExtents().topY : 0;
                                this.y_shift = g - b;
                            };
                        t.calculateSlope && (t.calculateSlope = i(t.calculateSlope)), t.calculateFlatSlope && (t.calculateFlatSlope = i(t.calculateFlatSlope));
                    }
                    finalizeTuplets() {
                        this.vftuplets = {};
                        for(const t in this.tuplets)if (this.tuplets.hasOwnProperty(t)) {
                            let e = this.vftuplets[t];
                            e || (e = this.vftuplets[t] = []);
                            for (const i of this.tuplets[t]){
                                const t = [], s = i[1];
                                for (const e of s)t.push(e.vfStaveNote);
                                if (t.length > 1) {
                                    const s = i[0], r = s.Notes[0][0].NormalNotes, o = s.shouldBeBracketed(this.rules.TupletsBracketedUseXMLValue, this.rules.TupletsBracketed, this.rules.TripletsBracketed, this.isTabMeasure, this.rules.TabTupletsBracketed);
                                    let a = n.Tuplet.LOCATION_TOP;
                                    s.tupletLabelNumberPlacement === x.PlacementEnum.Below && (a = n.Tuplet.LOCATION_BOTTOM);
                                    let l = 0;
                                    if (this.isTabMeasure && (l = 10 * this.rules.TabTupletYOffsetBottom, a === n.Tuplet.LOCATION_TOP)) {
                                        l = -10 * this.rules.TabTupletYOffsetTop;
                                        const t = s.Notes[0][0];
                                        t?.hasTabEffects() && (l -= 10 * this.rules.TabTupletYOffsetEffects);
                                    }
                                    const h = new n.Tuplet(t, {
                                        bracketed: o,
                                        location: a,
                                        notes_occupied: r,
                                        num_notes: s.TupletLabelNumber,
                                        ratioed: s.Ratioed,
                                        y_offset: l
                                    });
                                    e.push(h);
                                } else e.push(void 0);
                            }
                        }
                    }
                    layoutStaffEntry(t) {}
                    hasGraceSlash(t, e) {
                        return e && t.parentVoiceEntry.GraceNoteSlash && t.notes.some((t)=>t.sourceNote.PrintObject);
                    }
                    graphicalMeasureCreatedCalculations() {
                        let t, e = [];
                        const i = [];
                        for (const t of this.staffEntries)for (const e of t.vfKeys)e.attachedToNote = !1;
                        for (const s of this.staffEntries){
                            t = !1, e = [];
                            const r = new Set;
                            for (const o of s.graphicalVoiceEntries)if (o.parentVoiceEntry.IsGrace) {
                                if (i.push(o), o.parentVoiceEntry.GraceAfterMainNote) {
                                    o.GraceSlash = this.hasGraceSlash(o, !r.has(o.parentVoiceEntry.ParentVoice)), r.add(o.parentVoiceEntry.ParentVoice), o.vfStaveNote = l.VexFlowConverter.StaveNote(o);
                                    continue;
                                }
                                e.push(o), t || (t = o.parentVoiceEntry.GraceSlur);
                            } else if (o.vfStaveNote = l.VexFlowConverter.StaveNote(o), e.length > 0) {
                                const i = [];
                                for(let t = 0; t < e.length; t++){
                                    const n = e[t];
                                    n.GraceSlash = this.hasGraceSlash(n, 0 === t);
                                    const r = l.VexFlowConverter.StaveNote(n);
                                    n.vfStaveNote = r, this.attachInStaffKeys(s, r), i.push(r);
                                }
                                const r = new n.GraceNoteGroup(i, t);
                                let a = this.rules.GraceNoteGroupXMargin;
                                i.length > 1 && (a /= 3), r.spacing = 10 * a, o.vfStaveNote.addModifier(0, r), e = [];
                            }
                            const o = new Set;
                            for (const t of e)t.GraceSlash = this.hasGraceSlash(t, !o.has(t.parentVoiceEntry.ParentVoice)), o.add(t.parentVoiceEntry.ParentVoice), t.vfStaveNote = l.VexFlowConverter.StaveNote(t), t.isStandAloneGrace = !0;
                        }
                        this.finalizeBeams(), this.finalizeTuplets();
                        const s = this.getVoicesWithinMeasure();
                        if (this.rules.RenderFingerings || this.rules.RenderStringNumbersClassical) for (const t of this.staffEntries)t.setModifierXOffsets();
                        for (const t of s){
                            if (!t) continue;
                            this.vfVoices[t.VoiceId] = new n.Voice({
                                beat_value: this.parentSourceMeasure.ActiveTimeSignature.Denominator,
                                num_beats: this.parentSourceMeasure.ActiveTimeSignature.Numerator,
                                resolution: n.RESOLUTION
                            }).setMode(n.Voice.Mode.SOFT);
                            const e = this.getRestFilledVexFlowStaveNotesPerVoice(t);
                            let i;
                            for (const s of e){
                                if (s.parentVoiceEntry && s.parentVoiceEntry.IsGrace && !s.parentVoiceEntry.GraceAfterMainNote && !s.isStandAloneGrace) continue;
                                const e = s;
                                if (0 === e.vfStaveNote.getTicks().denominator && (e.vfStaveNote.getTicks().denominator = 1), s.notes.length > 0 && s.notes[0].sourceNote) {
                                    const t = s.notes[0].sourceNote, i = s.notes[0].graphicalNoteLength, r = e.vfStaveNote.getTicks(), o = t.IsWholeMeasureRest || i.RealValue === this.parentSourceMeasure.ActiveTimeSignature.RealValue, a = Math.abs(r.value() - i.RealValue * n.RESOLUTION) > .001;
                                    e.isStandAloneGrace || !t.NoteTuplet && (!a || o || s.parentVoiceEntry?.IsGrace) || (r.numerator = i.GetExpandedNumerator() * n.RESOLUTION, r.denominator = i.Denominator, r.simplify());
                                }
                                const r = e.parentStaffEntry;
                                if (r && !s.parentVoiceEntry?.GraceAfterMainNote && this.attachInStaffKeys(r, e.vfStaveNote), r && r.vfClefBefore && 0 === r.vfKeys.length && !s.parentVoiceEntry?.GraceAfterMainNote && r !== i) {
                                    if (i = r, s.notes[0] && !s.notes[0].sourceNote.PrintObject) {
                                        const t = this.rules.DefaultColorMusic || "#000000";
                                        r.vfClefBefore.setStyle({
                                            fillStyle: t,
                                            strokeStyle: t
                                        });
                                    }
                                    const t = new u([
                                        r.vfClefBefore
                                    ]), n = e.vfStaveNote;
                                    n && "function" == typeof n.addModifier && n.addModifier(0, t);
                                }
                                0 !== s.notes.length && s.notes[0] && s.notes[0].sourceNote.PrintObject ? (s.parentVoiceEntry?.IsGrace || (s.parentVoiceEntry && this.rules.RenderFingerings && (this.rules.FingeringPosition !== x.PlacementEnum.Left && this.rules.FingeringPosition !== x.PlacementEnum.Right || this.createFingerings(s)), s.parentVoiceEntry && this.rules.RenderStringNumbersClassical && this.createStringNumber(s), this.createArpeggio(s)), this.vfVoices[t.VoiceId].addTickable(e.vfStaveNote)) : this.vfVoices[t.VoiceId].addTickable(e.vfStaveNote);
                            }
                        }
                        this.createInStaffInstructionVoice(), this.setStemDirectionFromVexFlow();
                        for (const t of i)this.rules.RenderFingerings && this.createFingerings(t), this.rules.RenderStringNumbersClassical && this.createStringNumber(t), this.createArpeggio(t);
                        this.createArticulations(), this.createOrnaments();
                    }
                    attachInStaffKeys(t, e) {
                        const i = t.vfKeys.filter((t)=>!t.attachedToNote);
                        if (0 === i.length) return;
                        const s = t.vfClefBefore ? [
                            t.vfClefBefore,
                            ...i
                        ] : i;
                        for (const t of s)t.setStave(this.stave);
                        if (t.vfClefBefore) {
                            const e = this.rules.DefaultColorMusic || "#000000";
                            t.vfClefBefore.setStyle({
                                fillStyle: e,
                                strokeStyle: e
                            });
                        }
                        e.addModifier(0, new u(s));
                        for (const t of i)t.attachedToNote = !0;
                    }
                    createInStaffInstructionVoice() {
                        const t = this.staffEntries.filter((t)=>t.vfKeys.some((t)=>!t.attachedToNote));
                        if (0 === t.length) return;
                        const e = new n.Voice({
                            num_beats: 4,
                            beat_value: 4
                        }).setMode(n.Voice.Mode.SOFT), i = t[0].sourceStaffEntry.Timestamp;
                        i.RealValue > 0 && e.addTickables(l.VexFlowConverter.GhostNotes(i));
                        for(let i = 0; i < t.length; i++){
                            const s = t[i], r = t[i + 1]?.sourceStaffEntry.Timestamp || this.parentSourceMeasure.Duration, o = S.Fraction.minus(r, s.sourceStaffEntry.Timestamp), a = s.vfKeys.filter((t)=>!t.attachedToNote), l = s.vfClefBefore ? [
                                s.vfClefBefore,
                                ...a
                            ] : a, c = h.VexFlowKeySignatureNote.createCarrier(l, this.stave);
                            s.vfInStaffInstructionNote = c;
                            const u = c.getTicks();
                            u.numerator = o.GetExpandedNumerator() * n.RESOLUTION, u.denominator = o.Denominator, u.simplify(), e.addTickable(c);
                        }
                        const s = Math.min(0, ...Object.keys(this.vfVoices).map(Number)) - 1;
                        this.vfVoices[s] = e;
                    }
                    createArpeggio(t) {
                        if (t.parentVoiceEntry && t.parentVoiceEntry.Arpeggio) {
                            const e = t.parentVoiceEntry.Arpeggio;
                            if (t.notes && t.notes.length > 1) {
                                const i = l.VexFlowConverter.StrokeTypeFromArpeggioType(e.type), s = new n.Stroke(i, {
                                    all_voices: this.rules.ArpeggiosGoAcrossVoices
                                });
                                this.rules.RenderArpeggios && t.vfStaveNote.addStroke(0, s);
                            } else d.default.debug(`[OSMD] arpeggio in measure ${this.MeasureNumber} could not be drawn.\n                voice entry had less than two notes, arpeggio is likely between voice entries, not currently supported in Vexflow.`);
                        }
                    }
                    setStemDirectionFromVexFlow() {
                        for (const t of this.staffEntries)for (const e of t.graphicalVoiceEntries)for (const t of e.notes){
                            const i = t.vfnote;
                            if (i && i[0]) switch(i[0].getStemDirection()){
                                case n.Stem.UP:
                                    e.parentVoiceEntry.StemDirection = g.StemDirectionType.Up;
                                    break;
                                case n.Stem.DOWN:
                                    e.parentVoiceEntry.StemDirection = g.StemDirectionType.Down;
                            }
                        }
                    }
                    createArticulations() {
                        for(let t = 0, e = this.staffEntries.length; t < e; ++t){
                            const e = this.staffEntries[t].graphicalVoiceEntries;
                            for (const t of e){
                                const e = t.vfStaveNote;
                                l.VexFlowConverter.generateArticulations(e, t.notes[0], this.rules);
                            }
                        }
                    }
                    createOrnaments() {
                        for(let t = 0, e = this.staffEntries.length; t < e; ++t){
                            const e = this.staffEntries[t].graphicalVoiceEntries;
                            for(const t in e)if (e.hasOwnProperty(t)) {
                                const i = e[t].vfStaveNote, s = e[t].notes[0].sourceNote.ParentVoiceEntry.OrnamentContainer;
                                s && l.VexFlowConverter.generateOrnaments(i, s);
                            }
                        }
                    }
                    createFingerings(t) {
                        const e = t;
                        let i = 0;
                        for (const e of t.notes)e.sourceNote.Fingering && i++;
                        const s = [];
                        for (const e of t.parentVoiceEntry.TechnicalInstructions)e.type === E.TechnicalInstructionType.Fingering && s.push(e);
                        if (s.length > i) {
                            let e = 0;
                            for (const i of t.notes)if (i.sourceNote.Fingering) e++;
                            else {
                                if (e > s.length - 1) break;
                                i.sourceNote.Fingering = s[e], e++;
                            }
                        }
                        let r = -1;
                        for (const s of t.notes){
                            const o = s.sourceNote.Fingering;
                            if (!o) {
                                r++;
                                continue;
                            }
                            r++;
                            let a = this.rules.FingeringPosition;
                            this.rules.FingeringPositionGrace === x.PlacementEnum.AboveOrBelow && (this.isUpperStaffOfInstrument() ? a = x.PlacementEnum.Above : this.isLowerStaffOfInstrument() && (a = x.PlacementEnum.Below)), o.placement !== x.PlacementEnum.NotYetDefined && (a = o.placement);
                            let h, c = this.rules.FingeringOffsetX;
                            switch(a){
                                default:
                                case x.PlacementEnum.Left:
                                    h = n.StaveModifier.Position.LEFT, c -= s.baseFingeringXOffset * f.unitInPixels;
                                    break;
                                case x.PlacementEnum.Right:
                                    h = n.StaveModifier.Position.RIGHT, c += s.baseFingeringXOffset * f.unitInPixels;
                                    break;
                                case x.PlacementEnum.Above:
                                    h = n.StaveModifier.Position.ABOVE;
                                    break;
                                case x.PlacementEnum.Below:
                                    h = n.StaveModifier.Position.BELOW;
                                    break;
                                case x.PlacementEnum.NotYetDefined:
                                    const e1 = t.parentStaffEntry.sourceStaffEntry.ParentStaff;
                                    t.notes.length > 1 || t.parentStaffEntry.graphicalVoiceEntries.length > 1 ? h = n.StaveModifier.Position.LEFT : 0 === e1.idInMusicSheet ? (h = n.StaveModifier.Position.ABOVE, a = x.PlacementEnum.Above) : (h = n.StaveModifier.Position.BELOW, a = x.PlacementEnum.Below);
                            }
                            const u = new n.FretHandFinger(o.value);
                            if (l.VexFlowConverter.setVexFlowTextFontFamily(u.font, this.rules), u.setPosition(h), u.setOffsetX(c), a === x.PlacementEnum.Above || a === x.PlacementEnum.Below) {
                                const t = a === x.PlacementEnum.Above ? -1 : 1, s = a === x.PlacementEnum.Above ? r : i - 1 - r;
                                if (this.rules.FingeringInsideStafflines && i > 1) {
                                    const e = u.getWidth() / 2, n = 2.5 * i;
                                    u.setOffsetY(t * (s + n) * e);
                                } else if (!this.rules.FingeringInsideStafflines) {
                                    const i = new n.StringNumber(o.value);
                                    l.VexFlowConverter.setVexFlowTextFontFamily(i.font, this.rules), i.radius = 0, i.setPosition(h), i.setOffsetY(t * s * i.getWidth() * 2 / 3), e.vfStaveNote.addModifier(r, i);
                                    continue;
                                }
                            }
                            e.vfStaveNote.addModifier(r, u);
                        }
                    }
                    createStringNumber(t) {
                        const e = t;
                        t.notes.forEach((i, s)=>{
                            const r = i.sourceNote.StringInstruction;
                            if (r) {
                                let o = r.value;
                                switch(o){
                                    case "1":
                                        o = "I";
                                        break;
                                    case "2":
                                        o = "II";
                                        break;
                                    case "3":
                                        o = "III";
                                        break;
                                    case "4":
                                        o = "IV";
                                        break;
                                    case "5":
                                        o = "V";
                                        break;
                                    case "6":
                                        o = "VI";
                                }
                                const a = new n.StringNumber(o);
                                l.VexFlowConverter.setVexFlowTextFontFamily(a.font, this.rules), a.radius = 0;
                                const h = -this.rules.StringNumberOffsetY;
                                t.notes.length > 1 || t.parentStaffEntry.graphicalVoiceEntries.length > 1 ? (a.setOffsetX(13 * i.baseStringNumberXOffset), a.setPosition(n.Modifier.Position.RIGHT)) : a.setPosition(n.Modifier.Position.ABOVE), a.setOffsetY(h), e.vfStaveNote.addModifier(s, a);
                            }
                        });
                    }
                    lineTo(t, e, i = 0) {
                        const s = new n.StaveConnector(t.getVFStave(), this.stave);
                        s.setType(e), 0 !== i && s.setXShift(i), this.connectors.push(s);
                    }
                    getVFStave() {
                        return this.stave;
                    }
                    updateInstructionWidth() {
                        let t = 0, e = 0;
                        const i = this.stave.getModifiers();
                        for (const s of i)s.getPosition() === _.BEGIN ? t += s.getWidth() + s.getPadding(void 0) : s.getPosition() === _.END && (e += s.getWidth() + s.getPadding(void 0));
                        this.beginInstructionsWidth = (t ?? 0) / f.unitInPixels, this.endInstructionsWidth = (e ?? 0) / f.unitInPixels;
                    }
                    addStaveTie(t, e) {
                        this.vfTies.push(t), e.vfTies.push(t), e.vfTie = e.vfTies[0], t.setStartNoteId(e.StartNote?.getSVGId());
                    }
                }
                var _;
                e.VexFlowMeasure = T, function(t) {
                    t[t.LEFT = 1] = "LEFT", t[t.RIGHT = 2] = "RIGHT", t[t.ABOVE = 3] = "ABOVE", t[t.BELOW = 4] = "BELOW", t[t.BEGIN = 5] = "BEGIN", t[t.END = 6] = "END";
                }(_ || (e.StavePositionEnum = _ = {}));
            },
            1121 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.VexFlowMeasureRepeat = void 0;
                var n = s(i(3206)).default.Flow;
                const r = i(9479);
                class o {
                    constructor(t, e){
                        this.measures = t, this.slashes = Math.min(4, Math.max(1, Math.trunc(e) || 1));
                    }
                    get Measures() {
                        return this.measures;
                    }
                    draw(t, e) {
                        if (e !== this.measures[this.measures.length - 1]) return;
                        const i = e.getVFStave(), s = i.getSpacingBetweenLines(), n = i.getYForLine((i.getNumLines() - 1) / 2), r = this.centerX(e), o = t.openGroup();
                        o && o.classList?.add("vf-measure-repeat"), this.drawSign(t, r, n, s), this.measures.length > 1 && this.drawNumber(t, i, r), t.closeGroup();
                    }
                    reserveSkyline() {
                        if (this.measures.length < 2) return;
                        const t = this.measures[this.measures.length / 2 - 1], e = t.ParentStaffLine;
                        if (!e) return;
                        const i = t.PositionAndShape.RelativePosition.x + t.PositionAndShape.Size.width;
                        e.SkyBottomLineCalculator.updateSkyLineInRange(i - o.NUMBER_HALF_WIDTH, i + o.NUMBER_HALF_WIDTH, -o.NUMBER_HEIGHT);
                    }
                    centerX(t) {
                        const e = t.getVFStave();
                        if (1 === this.measures.length) return (e.getNoteStartX() + e.getNoteEndX()) / 2;
                        const i = this.measures[this.measures.length / 2 - 1], s = i.PositionAndShape.RelativePosition.x + i.PositionAndShape.Size.width - t.PositionAndShape.RelativePosition.x;
                        return e.getX() + s * r.unitInPixels;
                    }
                    drawNumber(t, e, i) {
                        const s = new n.TimeSignature(null, void 0, !1);
                        s.point = 40, s.setTimeSig("/" + this.measures.length), s.setStave(e), s.x = i - s.timeSig.glyph.getMetrics().width / 2, s.bottomLine = -0.5, s.setContext(t).draw();
                    }
                    drawSign(t, e, i, s) {
                        const n = 1.6 * s, r = 2 * s, o = .45 * s, a = .7 * s, l = i - r / 2, h = i + r / 2, c = -(this.slashes - 1) / 2 * a;
                        t.save(), t.setLineWidth(1);
                        for(let i = 0; i < this.slashes; i++){
                            const s = e + (c + i * a) - n / 2;
                            t.beginPath(), t.moveTo(s, h), t.lineTo(s + o, h), t.lineTo(s + o + n, l), t.lineTo(s + n, l), t.closePath(), t.fill();
                        }
                        const u = .24 * s, d = .5 * s, f = .9 * s, m = e + c - n / 2, p = m + n * (r / 2 + d) / r, g = m + (this.slashes - 1) * a + o + n * (r / 2 - d) / r;
                        this.drawDot(t, p - f, i - d, u), this.drawDot(t, g + f, i + d, u), t.restore();
                    }
                    drawDot(t, e, i, s) {
                        t.beginPath(), t.arc(e, i, s, 0, 2 * Math.PI, !1), t.fill();
                    }
                }
                e.VexFlowMeasureRepeat = o, o.NUMBER_HALF_WIDTH = 1.2, o.NUMBER_HEIGHT = 3.5;
            },
            3849 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.VexFlowMultiRestMeasure = void 0;
                var n = s(i(3206)).default.Flow;
                const r = i(5246);
                class o extends r.VexFlowMeasure {
                    constructor(t, e, i){
                        super(t, e, i), this.minimumStaffEntriesWidth = -1, i ? this.rules = i.ParentMusicSystem.rules : e && (this.rules = e.Rules), this.resetLayout(), this.multiRestElement = new n.MultiMeasureRest(e.multipleRestMeasures, {});
                    }
                    draw(t) {
                        const e = t.openGroup();
                        e && (e.classList?.add("vf-measure"), e.classList?.add("multi"), e.id = `${this.MeasureNumber}`), this.stave.setContext(t).draw(), this.multiRestElementSVG = t.openGroup("multirest"), this.multiRestElement.setStave(this.stave), this.multiRestElement.setContext(t), this.multiRestElement.draw(), this.multiRestElement.id = `vf-multi${this.MeasureNumber}`, t.closeGroup(), t.closeGroup();
                        for (const e of this.connectors)e.setContext(t).draw();
                    }
                    format() {
                        for (const t of this.staffEntries){
                            const e = this.PositionAndShape.Size.width - this.beginInstructionsWidth;
                            t.PositionAndShape.RelativePosition.x = this.PositionAndShape.Size.width / 2 + this.beginInstructionsWidth / 3, t.PositionAndShape.RelativePosition.y = 0;
                            const i = t.graphicalVoiceEntries[0]?.notes[0]?.PositionAndShape;
                            i.BorderLeft = -e / 3, i.BorderRight = e / 3, i.BorderTop = 1, i.BorderBottom = 3, t.PositionAndShape.calculateBoundingBox();
                        }
                    }
                    getVoicesWithinMeasure() {
                        return [];
                    }
                    getGraphicalVoiceEntriesPerVoice(t) {
                        return [];
                    }
                    getRestFilledVexFlowStaveNotesPerVoice(t) {
                        return [];
                    }
                    handleBeam(t, e) {}
                    handleTuplet(t, e) {}
                    finalizeBeams() {}
                    finalizeTuplets() {}
                    layoutStaffEntry(t) {}
                    graphicalMeasureCreatedCalculations() {}
                    createArticulations() {}
                    createOrnaments() {}
                    createFingerings(t) {}
                    getVFStave() {
                        return this.stave;
                    }
                }
                e.VexFlowMultiRestMeasure = o;
            },
            806 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.VexFlowMusicSheetCalculator = void 0;
                const n = i(7921), r = i(3753), o = i(5748), a = i(1121), l = i(8931), h = i(1327), c = i(5951), u = i(2570), d = i(5054), f = i(2561), m = i(8215), p = i(5246), g = i(7785), b = s(i(3206));
                var S = b.default.Flow;
                const y = s(i(3065)), E = i(9479), x = i(2395), v = i(7751), T = i(9310), _ = i(7809), M = i(7533), P = i(4022), L = i(2400), w = i(9161), A = i(624), I = i(7506), R = i(5282), N = i(6014), C = i(4980), B = i(6659), D = i(6954), O = i(7109), F = i(512), k = i(813), V = i(1216), G = i(2907), W = i(3729), U = i(3361);
                class z extends n.MusicSheetCalculator {
                    constructor(t){
                        super(), this.beamsNeedUpdate = !1, this.previousLyricOverflowsByStaff = new Map, this.previousChordOverflowsByStaff = new Map, this.measureRepeatUnitsPendingSkyline = [], this.metronomePlacements = [], this.placedWordRepetitionBoxes = new WeakMap, this.rules = t, n.MusicSheetCalculator.symbolFactory = new r.VexFlowGraphicalSymbolFactory, n.MusicSheetCalculator.TextMeasurer = new g.VexFlowTextMeasurer(this.rules), n.MusicSheetCalculator.stafflineNoteCalculator = new I.VexflowStafflineNoteCalculator(this.rules), "gonville" === this.rules.DefaultVexFlowNoteFont?.toLowerCase() ? b.default.Flow.DEFAULT_FONT_STACK = [
                            b.default.Flow.Fonts?.Gonville,
                            b.default.Flow.Fonts?.Bravura,
                            b.default.Flow.Fonts?.Custom
                        ] : "petaluma" === this.rules.DefaultVexFlowNoteFont?.toLowerCase() && (b.default.Flow.DEFAULT_FONT_STACK = [
                            b.default.Flow.Fonts?.Petaluma,
                            b.default.Flow.Fonts?.Gonville,
                            b.default.Flow.Fonts?.Bravura
                        ]);
                    }
                    clearRecreatedObjects() {
                        super.clearRecreatedObjects(), n.MusicSheetCalculator.stafflineNoteCalculator = new I.VexflowStafflineNoteCalculator(this.rules), this.previousLyricOverflowsByStaff.clear(), this.previousChordOverflowsByStaff.clear(), this.metronomePlacements = [], this.dashSpace = void 0;
                        for (const t of this.graphicalMusicSheet.MeasureList)for (const e of t)e?.clean();
                    }
                    formatMeasures() {
                        for (const t of this.graphicalMusicSheet.MeasureList)if (t && t[0]) {
                            t.find((t)=>t?.isVisible()).format();
                            for (const e of t){
                                for (const t of e.staffEntries)t.calculateXPosition();
                                e.finalizeBeams();
                            }
                        }
                        this.beamsNeedUpdate = !1, this.prepareMeasureRepeats();
                    }
                    prepareMeasureRepeats() {
                        this.measureRepeatUnitsPendingSkyline = [];
                        const t = new Map;
                        for (const e of this.graphicalMusicSheet.MeasureList)for (const i of e){
                            if (!(i instanceof p.VexFlowMeasure)) continue;
                            i.MeasureRepeat = void 0;
                            const e = i.ParentStaff.idInMusicSheet;
                            let s = t.get(e);
                            s || (s = new Map, t.set(e, s)), s.set(i.parentSourceMeasure, i);
                        }
                        if (!this.rules.RenderMeasureRepeats) return;
                        const e = this.graphicalMusicSheet.ParentMusicSheet.SourceMeasures, i = new Set;
                        for (const t of e)for (const e of t.MeasureRepeatInstructions.keys())i.add(e);
                        for (const s of i){
                            const i = t.get(s);
                            if (!i) continue;
                            const n = this.findWavyLineRanges(e, s);
                            for (const t of z.findMeasureRepeatUnits(e, s))this.tryCreateMeasureRepeat(e, i, s, t, n);
                        }
                    }
                    static findMeasureRepeatUnits(t, e) {
                        const i = [];
                        let s, n = 0;
                        const r = (t)=>{
                            if (s) for(let e = n; e + s.measures <= t; e += s.measures)i.push({
                                unitStart: e,
                                length: s.measures,
                                slashes: s.slashes
                            });
                        };
                        for(let i = 0; i < t.length; i++){
                            const o = t[i].MeasureRepeatInstructions.get(e);
                            o && 0 !== o.length && (r(i), s = 1 === o.length && o[0].type === l.MeasureRepeatType.Start ? o[0] : void 0, n = i);
                        }
                        return r(t.length), i;
                    }
                    tryCreateMeasureRepeat(t, e, i, s, n) {
                        if (s.unitStart < this.rules.MinMeasureToDrawIndex || s.unitStart + s.length - 1 > this.rules.MaxMeasureToDrawIndex) return;
                        const r = [];
                        for(let i = 0; i < s.length; i++){
                            const n = e.get(t[s.unitStart + i]);
                            if (!n) return;
                            r.push(n);
                        }
                        if (r.some((t)=>t.isTabMeasure)) return;
                        const o = r[0].ParentStaffLine;
                        if (!o || r.some((t)=>t.ParentStaffLine !== o)) return;
                        const l = s.unitStart - s.length;
                        if (l < 0) return;
                        if (l < this.rules.MinMeasureToDrawIndex) return;
                        for(let i = 0; i < s.length; i++)if (!e.get(t[l + i])?.ParentStaffLine) return;
                        if (!z.canAbbreviateMeasureRepeatUnit(t, i, s.unitStart, s.length, n)) return;
                        const h = new a.VexFlowMeasureRepeat(r, s.slashes);
                        s.length > 1 && this.measureRepeatUnitsPendingSkyline.push(h);
                        for (const t of r)t.MeasureRepeat = h;
                    }
                    static canAbbreviateMeasureRepeatUnit(t, e, i, s, n) {
                        const r = t[i - 1];
                        if (r?.LastInstructionsStaffEntries[e]?.Instructions.length) return !1;
                        if (z.hasIncomingLyricExtender(t, i, e)) return !1;
                        const o = t.slice(i, i + s), a = new Set(o);
                        for(let t = 0; t < o.length; t++){
                            const i = o[t];
                            if (i.isReducedToMultiRest) return !1;
                            if (i.FirstInstructionsStaffEntries[e]?.Instructions.length) return !1;
                            if (t < o.length - 1 && i.LastInstructionsStaffEntries[e]?.Instructions.length) return !1;
                            const s = i.getEntriesPerStaff(e);
                            for(let t = 0; t < s.length; t++){
                                const i = s[t];
                                if (t > 0 && i.Instructions.length) return !1;
                                for (const t of i.VoiceEntries){
                                    if (t.IsGrace || !t.LyricsEntries.isEmpty()) return !1;
                                    for (const i of t.Notes)if (z.measureRepeatNoteCrosses(i, e, a)) return !1;
                                }
                            }
                        }
                        const l = o[0].measureListIndex, h = o[o.length - 1].measureListIndex;
                        return !n.some((t)=>t.start <= h && t.end >= l);
                    }
                    static hasIncomingLyricExtender(t, e, i) {
                        for(let s = e - 1; s >= 0; s--){
                            const e = t[s].getEntriesPerStaff(i);
                            for(let t = e.length - 1; t >= 0; t--){
                                const i = e[t];
                                if (i.hasOnlyRests) return !1;
                                let s = !1, n = !1;
                                for (const t of i.VoiceEntries)t.LyricsEntries.forEach((t, e)=>{
                                    n = !0, s = s || e.extend;
                                });
                                if (n) return s;
                            }
                        }
                        return !1;
                    }
                    static measureRepeatNoteCrosses(t, e, i) {
                        const s = (t)=>!(!t || i.has(t.SourceMeasure) && t.ParentStaff?.idInMusicSheet === e);
                        if (t.NoteTie?.Notes.some(s)) return !0;
                        if (t.NoteBeam?.Notes.some(s)) return !0;
                        if (t.NoteTuplets.some((t)=>t.Notes.some((t)=>t.some(s)))) return !0;
                        if (t.Arpeggio?.notes.some(s)) return !0;
                        if (t.NoteSlurs?.some((t)=>t.HasUnattachedEnd || s(t.StartNote) || s(t.EndNote))) return !0;
                        const n = t.NoteGlissando;
                        if (n && (s(n.StartNote) || s(n.EndNote))) return !0;
                        const r = t.TremoloInfo?.tremoloBetweenNotes;
                        return !(!r || !s(r.startNote) && !s(r.stopNote));
                    }
                    findWavyLineRanges(t, e) {
                        const i = [];
                        for (const s of t){
                            const t = s.StaffLinkedExpressions[e];
                            if (t) for (const e of t){
                                const t = e.WavyLineStart;
                                if (!t) continue;
                                const n = t.ParentEndMultiExpression?.SourceMeasureParent;
                                i.push({
                                    start: n ? s.measureListIndex : 0,
                                    end: n ? n.measureListIndex : Number.MAX_SAFE_INTEGER
                                });
                            }
                        }
                        return i;
                    }
                    reserveSkylineForMeasureRepeats() {
                        for (const t of this.measureRepeatUnitsPendingSkyline)t.reserveSkyline();
                    }
                    calculateMeasureXLayout(t) {
                        const e = [];
                        for (const i of t)i?.isVisible() && e.push(i);
                        if (0 === e.length) return 0;
                        t = e;
                        const i = [], s = new S.Formatter({
                            softmaxFactor: this.rules.SoftmaxFactorVexFlow
                        });
                        let r = t[0].staffEntries.length, o = 1;
                        for (const e of t){
                            if (!e) continue;
                            let t = 0;
                            for (const i of e.staffEntries)t += i.setMaxAccidentals();
                            e.parentSourceMeasure.ImplicitMeasure && (r = Math.max(e.staffEntries.length, r), o = Math.max(e.staffEntries.length + t, o));
                            const n = e.vfVoices, a = [];
                            for(const t in n)if (n.hasOwnProperty(t)) {
                                const s = n[t];
                                e.hasOnlyRests && !s.ticksUsed.equals(s.totalTicks) && (s.ticksUsed = s.totalTicks), a.push(s), i.push(s);
                            }
                            if (0 !== a.length) {
                                for (const t of a)for (const e of t.getTickables()){
                                    const t = e;
                                    if (t.center_x_shift = 0, void 0 === t.osmdInitialXShift) {
                                        t.osmdInitialXShift = t.x_shift ?? 0;
                                        for (const e of t.modifiers ?? []){
                                            const t = e.getCategory?.();
                                            "dots" === t ? e.osmdInitialDotShiftY = e.dot_shiftY : "articulations" !== t && "ornaments" !== t || (e.osmdInitialYShift = e.y_shift);
                                        }
                                    } else {
                                        t.x_shift = t.osmdInitialXShift;
                                        for (const e of t.modifiers ?? [])"dots" === e.getCategory?.() ? (e.setYShift(0), void 0 !== e.osmdInitialDotShiftY && e.setDotShiftY(e.osmdInitialDotShiftY)) : "ornaments" === e.getCategory?.() && (e.delayXShift = void 0), void 0 !== e.osmdInitialYShift && e.setYShift(e.osmdInitialYShift);
                                    }
                                    if (void 0 === t.osmdInitialStemExtensionOverride) t.osmdInitialStemExtensionOverride = t.stemExtensionOverride ?? null, t.osmdInitialStemDirection = t.getStemDirection?.(), t.osmdInitialRenderFlag = t.renderFlag;
                                    else {
                                        if (t.stemExtensionOverride = t.osmdInitialStemExtensionOverride, void 0 !== t.osmdInitialRenderFlag && (t.renderFlag = t.osmdInitialRenderFlag), void 0 !== t.osmdInitialStemDirection && t.getStemDirection() !== t.osmdInitialStemDirection) {
                                            const e = t.beam;
                                            t.setStemDirection(t.osmdInitialStemDirection), t.beam = e;
                                        }
                                        t.isRest?.() && (t.shiftRestVerticalDisabled = !0);
                                    }
                                    t.stem && t.getStemExtension && t.stem.setExtension(t.getStemExtension()), t.updateWidth && t.glyphs && t.updateWidth();
                                }
                                for (const t of e.staffEntries)for (const e of t.graphicalVoiceEntries){
                                    const t = e.vfStaveNote;
                                    if (t && e.notes.length > 0) {
                                        const i = e.notes.reduce((t, e)=>e.staffLine < t.staffLine ? e : t);
                                        t.hiddenUnisonBaseHead = i.sourceNote.sharesNoteheadWithVisibleUnisonNote();
                                    }
                                }
                                s.joinVoices(a);
                            } else y.default.debug("Found a measure with no voices. Continuing anyway.", n);
                        }
                        let a = 12;
                        const l = t[0].parentSourceMeasure;
                        if (i.length > 0) {
                            if (a = s.preCalculateMinTotalWidth(i) / E.unitInPixels * this.rules.VoiceSpacingMultiplierVexflow + this.rules.VoiceSpacingAddendVexflow + .3 * r, l?.ImplicitMeasure) {
                                a = l.Duration.RealValue / l.ActiveTimeSignature.RealValue * a;
                                let t = 0;
                                const e = l.measureListIndex;
                                if (e > 1) for (const i of this.graphicalMusicSheet.MeasureList[e - 1]){
                                    const e = i?.parentSourceMeasure.endingBarStyleEnum;
                                    if (e === D.SystemLinesEnum.ThinBold || e === D.SystemLinesEnum.DotsThinBold) {
                                        t = this.rules.PickupMeasureRepetitionSpacing;
                                        break;
                                    }
                                }
                                a += t, r > 1 ? a += .3 * o * 1.5 : e > 1 && 1 === r && (a += this.rules.PickupMeasureSpacingSingleNoteAddend), a *= this.rules.PickupMeasureWidthMultiplier;
                            }
                            n.MusicSheetCalculator.setMeasuresMinStaffEntriesWidth(t, a);
                            const e = (t, e)=>{
                                s.formatToStave(i, e.getVFStave());
                            }, h = (t, e)=>{
                                s.formatToStave(i, e.getVFStave(), {
                                    align_rests: !0,
                                    context: void 0
                                });
                            };
                            for (const i of t){
                                if (this.rules.AlignRests === A.AlignRestOption.Never) i.formatVoices = e;
                                else if (this.rules.AlignRests === A.AlignRestOption.Always) i.formatVoices = h;
                                else if (this.rules.AlignRests === A.AlignRestOption.Auto) {
                                    let t = !1;
                                    for (const e of i.staffEntries){
                                        let i = 0, s = 0;
                                        for (const n of e.graphicalVoiceEntries)if (n.parentVoiceEntry.IsGrace || n && n.notes && n.notes[0] && n.notes[0].sourceNote && n.notes[0].sourceNote.PrintObject && i++, n && n.notes && n.notes[0] && n.notes[0].sourceNote && n.notes[0].sourceNote.isRest() && n.notes[0].sourceNote.PrintObject && s++, i > 1 && s >= 1) {
                                            t = !0;
                                            break;
                                        }
                                        if (t) break;
                                    }
                                    i.formatVoices = t ? h : e;
                                }
                                if (i === t[0]) {
                                    const t = i;
                                    t.formatVoices(a * E.unitInPixels, t);
                                }
                            }
                        }
                        for (const e of t)if (e) for (const t of e.staffEntries)t.calculateXPosition();
                        for (const e of t){
                            if (!e) continue;
                            const t = e.vfVoices, i = [];
                            for(const e in t)t.hasOwnProperty(e) && i.push(t[e]);
                            0 !== i.length ? s.joinVoices(i) : y.default.debug("Found a measure with no voices. Continuing anyway.", t);
                        }
                        return a;
                    }
                    calculateElongationFactor(t, e, i, s, n, r, a, l) {
                        let h = n, c = 0, u = !1;
                        for (const d of t){
                            const t = d.GraphicalLabel.Label.textAlignment;
                            let f = a, m = l;
                            if (u = !1, d instanceof x.GraphicalLyricEntry && d.ParentLyricWord) {
                                d.LyricsEntry.SyllableIndex > 0 && (f = this.rules.BetweenSyllableMinimumDistance, M.TextAlignment.IsCenterAligned(t) && (f += 1));
                                const e = d.ParentLyricWord.GetLyricWord.Syllables;
                                e.length > 1 && d.LyricsEntry.SyllableIndex < e.length - 1 && (u = !0, void 0 === this.dashSpace && (this.dashSpace = 1.5), m -= this.dashSpace);
                            }
                            const p = d instanceof x.GraphicalLyricEntry ? d.GraphicalLabel.PositionAndShape : d.PositionAndShape, g = p.Size.width;
                            let b, S, y, E, v = e.PositionAndShape.RelativePosition.x + p.BorderLeft;
                            d instanceof B.GraphicalChordSymbolContainer && d.PositionAndShape.Parent.DataObject instanceof o.GraphicalMeasure && (v = this.rules.ChordSymbolWholeMeasureRestXOffset + p.BorderMarginLeft + d.PositionAndShape.Parent.DataObject.beginInstructionsWidth), void 0 !== i[c] && i[c].extend, i[c] && (S = v - i[c].xPosition);
                            const T = s * n;
                            M.TextAlignment.IsCenterAligned(t) ? (m /= 4, y = T - v, E = g / 2 - m, i[c] && (b = i[c].labelWidth / 2 + g / 2 + f)) : M.TextAlignment.IsLeft(t) && (y = T - v, E = g - m, i[c] && (b = i[c].labelWidth + f));
                            let _, P = 1;
                            _ = y > 0 ? E / y : (v + E) / s;
                            let L = 1;
                            d instanceof x.GraphicalLyricEntry && d.LyricsEntry ? i[c] && (L = b / S, i[c].sourceNoteDuration.Denominator > 4 && (L *= 1.1)) : i[c] && (L = b / S), P = Math.max(_, L), h = Math.max(h, P);
                            let w = Math.max(b - S || 0, 0);
                            i[c] && (w += i[c].cumulativeOverlap), i[c] = {
                                cumulativeOverlap: w,
                                extend: d instanceof x.GraphicalLyricEntry && d.LyricsEntry.extend,
                                labelWidth: g,
                                measureNumber: r,
                                needsDashSpaceAtEnd: u,
                                sourceNoteDuration: d instanceof x.GraphicalLyricEntry && d.LyricsEntry && d.LyricsEntry.Parent.Notes[0].Length,
                                text: d instanceof x.GraphicalLyricEntry ? d.LyricsEntry.Text : d.GraphicalLabel.Label.text,
                                xPosition: v
                            }, c++;
                        }
                        return h;
                    }
                    calculateElongationFactorFromStaffEntries(t, e, i, s, n, r) {
                        let o = i;
                        const a = {}, l = {};
                        if (n) for(let t = 0; t < n.length; t++){
                            const e = n[t];
                            e > 0 && (a[t] = {
                                cumulativeOverlap: 0,
                                extend: !1,
                                labelWidth: e,
                                measureNumber: s - 1,
                                sourceNoteDuration: new f.Fraction(1, 4),
                                text: "",
                                xPosition: 0
                            });
                        }
                        if (r) for(let t = 0; t < r.length; t++){
                            const e = r[t];
                            e > 0 && (l[t] = {
                                cumulativeOverlap: 0,
                                extend: !1,
                                labelWidth: e,
                                measureNumber: s - 1,
                                sourceNoteDuration: new f.Fraction(1, 4),
                                text: "",
                                xPosition: 0
                            });
                        }
                        for (const i of t)i.LyricsEntries.length > 0 && this.rules.RenderLyrics && (o = this.calculateElongationFactor(i.LyricsEntries, i, a, e, o, s, this.rules.HorizontalBetweenLyricsDistance, this.rules.LyricOverlapAllowedIntoNextMeasure)), i.graphicalChordContainers.length > 0 && this.rules.RenderChordSymbols && (o = this.calculateElongationFactor(i.graphicalChordContainers, i, l, e, o, s, this.rules.ChordSymbolXSpacing, this.rules.ChordOverlapAllowedIntoNextMeasure));
                        return {
                            factor: o,
                            lastLyricEntryDict: a,
                            lastChordEntryDict: l
                        };
                    }
                    calculateMeasureWidthFromStaffEntries(t, e) {
                        let i = 1;
                        const s = [], n = new Set;
                        for (const r of t){
                            if (!r || 0 === r.staffEntries.length || !r.isVisible()) continue;
                            const t = r.ParentStaff;
                            n.add(t);
                            const o = this.previousLyricOverflowsByStaff.get(t), a = this.previousChordOverflowsByStaff.get(t), l = this.calculateElongationFactorFromStaffEntries(r.staffEntries, e, i, r.MeasureNumber, o, a);
                            i = l.factor, s.push({
                                staff: t,
                                lastLyricEntryDict: l.lastLyricEntryDict,
                                lastChordEntryDict: l.lastChordEntryDict
                            });
                        }
                        i = Math.min(i, this.rules.MaximumLyricsElongationFactor);
                        const r = e * i;
                        for (const t of s){
                            const e = this.computeContainerOverflows(t.lastLyricEntryDict, r), i = this.computeContainerOverflows(t.lastChordEntryDict, r);
                            this.previousLyricOverflowsByStaff.set(t.staff, e), this.previousChordOverflowsByStaff.set(t.staff, i);
                        }
                        for (const t of Array.from(this.previousLyricOverflowsByStaff.keys()))n.has(t) || this.previousLyricOverflowsByStaff.delete(t);
                        for (const t of Array.from(this.previousChordOverflowsByStaff.keys()))n.has(t) || this.previousChordOverflowsByStaff.delete(t);
                        return r;
                    }
                    computeContainerOverflows(t, e) {
                        const i = [];
                        for (const s of Object.keys(t)){
                            const n = Number(s), r = t[n];
                            if (!r) continue;
                            const o = r.xPosition + r.labelWidth;
                            let a = Math.max(0, o - e);
                            r.needsDashSpaceAtEnd && void 0 !== this.dashSpace && (a += this.dashSpace), i[n] = a;
                        }
                        return i;
                    }
                    createGraphicalTie(t, e, i, s, n) {
                        return new d.GraphicalTie(t, s, n);
                    }
                    updateStaffLineBorders(t) {
                        t.SkyBottomLineCalculator.updateStaffLineBorders();
                    }
                    graphicalMeasureCreatedCalculations(t) {
                        t.rules = this.rules, t.graphicalMeasureCreatedCalculations();
                    }
                    layoutVoiceEntry(t, e, i, s) {
                        for(let t = 0; t < e.length; t++)e[t] = n.MusicSheetCalculator.stafflineNoteCalculator.positionNote(e[t]);
                    }
                    layoutStaffEntry(t) {
                        t.parentMeasure.layoutStaffEntry(t);
                    }
                    initGraphicalMeasuresCreation() {}
                    layoutArticulationMarks(t, e, i) {}
                    layoutGraphicalTie(t, e, i) {
                        const s = t.StartNote, n = t.EndNote;
                        let r, o, a = 0;
                        s && s.vfnote && s.vfnote.length >= 2 && (r = s.vfnote[0], a = s.vfnote[1]);
                        let l = 0;
                        n && n.vfnote && n.vfnote.length >= 2 && (o = n.vfnote[0], l = n.vfnote[1]);
                        const h = t.Tie.getTieDirection(s?.sourceNote);
                        if (e) {
                            if (r) {
                                const e = {
                                    first_indices: [
                                        a
                                    ],
                                    first_note: r
                                }, n = i ? new S.TabTie(e, t.Tie.Type) : this.createStaveTie(e, h);
                                N.VexFlowConverter.setVexFlowTextFontFamily(n.font, this.rules), s.parentVoiceEntry.parentStaffEntry.parentMeasure.addStaveTie(n, t);
                            }
                            if (o) {
                                const e = {
                                    last_indices: [
                                        l
                                    ],
                                    last_note: o
                                }, s = i ? new S.TabTie(e) : this.createStaveTie(e, h);
                                n.parentVoiceEntry.parentStaffEntry.parentMeasure.addStaveTie(s, t);
                            }
                        } else if (r || o) {
                            let e;
                            if (i) {
                                if ("S" === t.Tie.Type) {
                                    const i = t.StartNote.sourceNote, s = t.EndNote.sourceNote;
                                    let n = 1;
                                    i.FretNumber > s.FretNumber && (n = -1), e = new S.TabSlide({
                                        first_indices: [
                                            a
                                        ],
                                        first_note: r,
                                        last_indices: [
                                            l
                                        ],
                                        last_note: o
                                    }, n);
                                } else e = new S.TabTie({
                                    first_indices: [
                                        a
                                    ],
                                    first_note: r,
                                    last_indices: [
                                        l
                                    ],
                                    last_note: o
                                }, t.Tie.Type);
                                N.VexFlowConverter.setVexFlowTextFontFamily(e.font, this.rules);
                            } else e = this.createStaveTie({
                                first_indices: [
                                    a
                                ],
                                first_note: r,
                                last_indices: [
                                    l
                                ],
                                last_note: o
                            }, h);
                            n.parentVoiceEntry.parentStaffEntry.parentMeasure.addStaveTie(e, t);
                        }
                    }
                    createStaveTie(t, e) {
                        const i = new S.StaveTie(t);
                        return e === C.PlacementEnum.Below ? i.setDirection(1) : e === C.PlacementEnum.Above && i.setDirection(-1), i;
                    }
                    calculateDynamicExpressionsForMultiExpression(t, e, i) {
                        if (e < this.rules.MinMeasureToDrawIndex || e > this.rules.MaxMeasureToDrawIndex) return;
                        const s = t.AbsoluteTimestamp, n = this.graphicalMusicSheet.MeasureList[e], r = n[i].ParentStaffLine, o = n[i], a = t.StartingContinuousDynamic, l = void 0 !== a && !a.IsStartOfSoftAccent, h = this.getRelativePositionInStaffLineFromTimestamp(s, i, r, r?.isPartOfMultiStaffInstrument(), void 0, l);
                        if (h.x <= 0 && (h.x = o.beginInstructionsWidth + this.rules.RhythmRightMargin), t.InstantaneousDynamic) {
                            const e = new _.VexFlowInstantaneousDynamicExpression(t.InstantaneousDynamic, r, o);
                            this.calculateGraphicalInstantaneousDynamicExpression(e, h, s), this.dynamicExpressionMap.set(s.RealValue, e.PositionAndShape);
                        }
                        if (a) {
                            const e = new L.VexFlowContinuousDynamicExpression(a, r, o.parentSourceMeasure);
                            if (e.StartMeasure = o, e.IsSoftAccent = t.StartingContinuousDynamic.IsStartOfSoftAccent, !e.IsVerbal && a.EndMultiExpression) try {
                                this.calculateGraphicalContinuousDynamic(e, h), e.updateSkyBottomLine();
                            } catch (t) {}
                            else e.IsVerbal ? this.calculateGraphicalVerbalContinuousDynamic(e, h) : y.default.warn("This continuous dynamic is not covered. measure" + t.SourceMeasureParent.MeasureNumber);
                        }
                    }
                    createMetronomeMark(t) {
                        const e = this.graphicalMusicSheet.ParentMusicSheet.SourceMeasures, i = t.ParentMultiTempoExpression.AbsoluteTimestamp;
                        let s = t.ParentMultiTempoExpression.SourceMeasureParent.measureListIndex;
                        for(; s + 1 < e.length && i.gte(e[s + 1].AbsoluteTimestamp);)s++;
                        for(; s > 0 && i.lt(e[s].AbsoluteTimestamp);)s--;
                        if (s < this.rules.MinMeasureToDrawIndex || s > this.rules.MaxMeasureToDrawIndex) return;
                        const n = this.graphicalMusicSheet.MeasureList[s]?.find((t)=>t?.ParentStaffLine && t.ParentStaff.isVisible());
                        if (!n) return;
                        const r = 0 === s, o = f.Fraction.minus(i, e[s].AbsoluteTimestamp);
                        if (this.metronomePlacements.some((e)=>e.measure === n && e.expression.ParentMultiTempoExpression.AbsoluteTimestamp.Equals(i) && this.isSameMetronomeMark(e.expression, t))) return;
                        const a = n.getVFStave();
                        let l = this.rules.MetronomeMarkYShift, h = !1;
                        for (const e of t.parentMeasure.TempoExpressions){
                            const t = e.InstantaneousTempo?.TempoType === w.TempoType.metronomeMark;
                            if (e.getPlacementOfFirstEntry() === C.PlacementEnum.Above && !t && e.AbsoluteTimestamp.Equals(i)) {
                                h = !0;
                                break;
                            }
                        }
                        h && (l -= 1.4);
                        const c = n.ParentStaffLine.SkyLine;
                        if (t.metronomeNoteGroupLeft && t.metronomeNoteGroupRight) {
                            const e = this.buildNoteEquationForVexFlow(t.metronomeNoteGroupLeft, t.metronomeNoteGroupRight);
                            a.setTempo({
                                noteEquation: e
                            }, l * E.unitInPixels);
                        } else {
                            let e = "q";
                            if (t.beatUnit) {
                                const i = R.NoteTypeHandler.getNoteDurationFromType(t.beatUnit);
                                e = N.VexFlowConverter.durations(i, !1)[0];
                            }
                            a.setTempo({
                                bpm: t.TempoInBpm,
                                dots: t.dotted,
                                duration: e
                            }, l * E.unitInPixels);
                        }
                        const u = a.getModifiers().length - 1, d = a.getModifiers()[u];
                        N.VexFlowConverter.setVexFlowTextFontFamily(d.font, this.rules);
                        let m = r ? this.rules.MetronomeMarkXShift * E.unitInPixels : 0;
                        if (o.RealValue > 0) {
                            const e = n.ParentStaffLine;
                            m = (this.getRelativePositionInStaffLineFromTimestamp(t.ParentMultiTempoExpression.AbsoluteTimestamp, this.graphicalMusicSheet.MeasureList[s].indexOf(n), e, e.isPartOfMultiStaffInstrument()).x - n.PositionAndShape.RelativePosition.x) * E.unitInPixels - a.getModifierXShift(u);
                        }
                        d.setShiftX(m), this.prepareMetronomePlacement(n, t, d, u, m, l), n.hasMetronomeMark = !0, c && o.RealValue <= 0 && (c[0] = Math.min(c[0], -4.5 + l));
                    }
                    prepareMetronomePlacement(t, e, i, s, n, r) {
                        const o = t.getVFStave(), a = t.ParentStaffLine, l = a.PositionAndShape.Size.width, h = l * E.unitInPixels, c = new W.GeometricSkyBottomLineContext(3 * h, 300, this.rules.GeometricSkyBottomLineCaches);
                        c.translate(h + t.PositionAndShape.RelativePosition.x * E.unitInPixels - o.getX(), -o.getYForLine(0));
                        const u = o.getContext();
                        try {
                            o.setContext(c), i.draw(o, o.getModifierXShift(s));
                        } finally{
                            o.setContext(u);
                        }
                        const d = [], f = [];
                        c.copyExtentsInto(d, f);
                        const m = {
                            left: 1 / 0,
                            right: -1 / 0,
                            top: 1 / 0,
                            bottom: -1 / 0
                        };
                        if (d.forEach((t, e)=>{
                            m.left = Math.min(m.left, e - h), m.right = Math.max(m.right, e + 1 - h), m.top = Math.min(m.top, t), m.bottom = Math.max(m.bottom, f[e]);
                        }), m.left > m.right) return;
                        const p = e.ParentMultiTempoExpression.AbsoluteTimestamp.lte(t.parentSourceMeasure.AbsoluteTimestamp);
                        if (!p) {
                            let t = 0;
                            m.right / E.unitInPixels > l && (t = l - this.rules.MeasureRightMargin - m.right / E.unitInPixels);
                            const e = m.left / E.unitInPixels + t;
                            e < a.PositionAndShape.BorderMarginLeft && (t += a.PositionAndShape.BorderMarginLeft - e + this.rules.LabelXOffsetForStafflineLeftOverflowCheck), i.setShiftX(n + t * E.unitInPixels), m.left += t * E.unitInPixels, m.right += t * E.unitInPixels;
                        }
                        const g = a.SkyBottomLineCalculator.getSkyLineMinInRange(m.left / E.unitInPixels, m.right / E.unitInPixels) - m.bottom / E.unitInPixels, b = g < 0 ? g - this.rules.TempoYSpacing : 0;
                        m.top += b * E.unitInPixels, m.bottom += b * E.unitInPixels, this.metronomePlacements.push({
                            measure: t,
                            expression: e,
                            mark: i,
                            bounds: m,
                            yShift: (r + b) * E.unitInPixels,
                            existingPosition: p && 0 === b
                        });
                    }
                    layoutMetronomeMarks() {
                        const t = new Map, e = this.rules.TempoYSpacing * E.unitInPixels;
                        for (const i of this.metronomePlacements){
                            const s = i.measure.ParentStaffLine;
                            let n = t.get(s);
                            if (!n) {
                                n = [];
                                for (const t of s.AbstractExpressions){
                                    if (!(t instanceof U.GraphicalInstantaneousTempoExpression && t.GraphicalLabel.Label.text)) continue;
                                    const e = t.GraphicalLabel.PositionAndShape;
                                    n.push({
                                        left: (e.RelativePosition.x + e.BorderLeft) * E.unitInPixels,
                                        right: (e.RelativePosition.x + e.BorderRight) * E.unitInPixels,
                                        top: (e.RelativePosition.y + e.BorderTop) * E.unitInPixels,
                                        bottom: (e.RelativePosition.y + e.BorderBottom) * E.unitInPixels
                                    });
                                }
                                n.sort((t, e)=>e.bottom - t.bottom), t.set(s, n);
                            }
                            const r = i.bounds;
                            let o = 0;
                            for (const t of n)r.left < t.right && r.right > t.left && r.bottom + o > t.top && r.top + o < t.bottom && (o = t.top - e - r.bottom);
                            i.mark.setShiftY(i.yShift + o), r.top += o, r.bottom += o;
                            let a = 0;
                            for(; a < n.length && n[a].bottom >= r.bottom;)a++;
                            n.splice(a, 0, r), i.existingPosition && 0 === o || s.SkyBottomLineCalculator.updateSkyLineInRange(r.left / E.unitInPixels, r.right / E.unitInPixels, r.top / E.unitInPixels);
                        }
                    }
                    buildNoteEquationForVexFlow(t, e) {
                        const i = (t)=>{
                            const e = {
                                notes: t.notes.map((t)=>{
                                    const e = R.NoteTypeHandler.getNoteDurationFromType(t.type);
                                    return {
                                        duration: N.VexFlowConverter.durations(e, !1)[0],
                                        dots: t.dots,
                                        beam: t.beam,
                                        tied: t.tied
                                    };
                                })
                            };
                            return t.tuplet && (e.tuplet = {
                                actualNotes: t.tuplet.actualNotes,
                                normalNotes: t.tuplet.normalNotes,
                                bracket: t.tuplet.bracket,
                                showNumber: t.tuplet.showNumber
                            }), e;
                        };
                        return {
                            left: i(t),
                            right: i(e)
                        };
                    }
                    calculateRehearsalMark(t) {
                        const e = t.rehearsalExpression;
                        if (!e) return;
                        const i = this.graphicalMusicSheet.MeasureList[0][0].MeasureNumber, s = Math.max(t.MeasureNumber - i, 0);
                        for (const i of this.graphicalMusicSheet.MeasureList[s]){
                            const s = i?.getVFStave();
                            if (!s || !i.isVisible()) continue;
                            let n = -this.rules.RehearsalMarkYOffsetDefault - this.rules.RehearsalMarkYOffset;
                            i.parentSourceMeasure.isReducedToMultiRest && (n += this.rules.RehearsalMarkYOffsetAddedForRehearsalMarks);
                            let r = this.rules.RehearsalMarkXOffsetDefault + this.rules.RehearsalMarkXOffset;
                            t.IsSystemStartMeasure && (r += this.rules.RehearsalMarkXOffsetSystemStartMeasure);
                            const o = this.rules.RehearsalMarkFontSize;
                            let a;
                            const l = i.ParentStaffLine;
                            if (l) {
                                let t = i.PositionAndShape.AbsolutePosition.x + (s.getModifierXShift(0) + r) / E.unitInPixels, n = t + Math.max(18, e.label.length * o * .6 + o) / E.unitInPixels;
                                const h = this.rules.RehearsalMarkAboveChordSymbol ? this.getFirstChordSymbolAbove(i) : void 0;
                                if (h) {
                                    const e = h.PositionAndShape, i = e.Parent.AbsolutePosition.x + e.RelativePosition.x;
                                    t = Math.min(t, e.BorderMarginLeft + i), n = Math.max(n, e.BorderMarginRight + i);
                                }
                                const c = l.SkyBottomLineCalculator.getSkyLineMinInRange(t, n);
                                if (c < 0) {
                                    const e = .5;
                                    a = (c - e) * E.unitInPixels;
                                    const i = o / E.unitInPixels * 1.6 + e;
                                    l.SkyBottomLineCalculator.updateSkyLineInRange(t, n, c - i);
                                }
                            }
                            s.setSection(e.label, n, r, o, a);
                            const h = s.getModifiers().last();
                            return void N.VexFlowConverter.setVexFlowTextFontFamily(h.font, this.rules);
                        }
                    }
                    getFirstChordSymbolAbove(t) {
                        let e, i = Number.MAX_VALUE;
                        for (const s of t.staffEntries)for (const t of s.graphicalChordContainers ?? []){
                            if (t.GetChordSymbolContainer.Placement !== C.PlacementEnum.Above) continue;
                            const s = t.PositionAndShape.AbsolutePosition.x;
                            s < i && (i = s, e = t);
                        }
                        return e;
                    }
                    calculateSingleOctaveShift(t, e, i, s) {
                        const n = e.OctaveShiftStart, r = n.ParentStartMultiExpression.Timestamp, o = n.ParentEndMultiExpression?.Timestamp, a = this.rules.MinMeasureToDrawIndex, l = this.rules.MaxMeasureToDrawIndex;
                        let h, c = this.graphicalMusicSheet.MeasureList[i][s].ParentStaffLine;
                        c || (c = this.graphicalMusicSheet.MeasureList[a][s].ParentStaffLine), h = n.ParentEndMultiExpression ? this.graphicalMusicSheet.getGraphicalMeasureFromSourceMeasureAndIndex(n.ParentEndMultiExpression.SourceMeasureParent, s) : this.graphicalMusicSheet.getLastGraphicalMeasureFromIndex(s, !0);
                        const u = h.MeasureNumber > l + 1;
                        let d;
                        u && (h = this.graphicalMusicSheet.getLastGraphicalMeasureFromIndex(s, !0)), d = n.ParentStartMultiExpression ? this.graphicalMusicSheet.getGraphicalMeasureFromSourceMeasureAndIndex(n.ParentStartMultiExpression.SourceMeasureParent, s) : this.graphicalMusicSheet.MeasureList[a][s];
                        const f = d.MeasureNumber < a + 1;
                        if (f && (d = this.graphicalMusicSheet.MeasureList[a][s], c = d.ParentStaffLine), d.parentSourceMeasure.measureListIndex < a || d.parentSourceMeasure.measureListIndex > l || h.parentSourceMeasure.measureListIndex < a || h.parentSourceMeasure.measureListIndex > l) return;
                        let m = h.ParentStaffLine;
                        if (m || (m = c), h && c && m) {
                            const t = f ? c.Measures : [
                                d
                            ], e = u ? m.Measures : [
                                h
                            ], i = new T.VexFlowOctaveShift(n, c.PositionAndShape);
                            if (!i.startNote) {
                                const e = this.findBoundaryNoteEntry(t);
                                if (!e) return;
                                if (i.setStartNote(e), !i.startNote) return;
                            }
                            if (!i.endNote) {
                                const t = this.findBoundaryNoteEntry(e, !0);
                                if (!t) return void (i.graphicalEndAtMeasureEnd = !0);
                                if (i.setEndNote(t), !i.endNote) return;
                            }
                            let a = d.findGraphicalStaffEntryFromTimestamp(r);
                            this.hasVexFlowNote(a) || (a = this.findBoundaryNoteEntry(t));
                            let l = h.findGraphicalStaffEntryFromTimestamp(o);
                            if (!this.hasVexFlowNote(l) && o) for(let t = h.staffEntries.length - 1; t >= 0; t--){
                                const e = h.staffEntries[t];
                                if (this.hasVexFlowNote(e) && e.relInMeasureTimestamp?.lte(o)) {
                                    l = e;
                                    break;
                                }
                            }
                            if (this.hasVexFlowNote(l) || (l = this.findBoundaryNoteEntry(e, !0)), i.setStartNote(a), m !== c) {
                                i.endsOnDifferentStaffLine = !0;
                                let t = this.findLastStafflineMeasure(c);
                                void 0 === t && (t = h);
                                const e = this.findBoundaryNoteEntry([
                                    t
                                ], !0);
                                if (i.setEndNote(e), i.graphicalEndAtMeasureEnd = !0, i.endMeasure = t, m.ParentMusicSystem.Id - c.ParentMusicSystem.Id > 0) for(let t = c.ParentMusicSystem.Id; t < m.ParentMusicSystem.Id; t++){
                                    const e = t + 1, i = this.musicSystems[e];
                                    let r;
                                    for (const t of i.StaffLines)if (t.ParentStaff.idInMusicSheet === s) {
                                        r = t;
                                        break;
                                    }
                                    if (!r) continue;
                                    const o = r.Measures[0], a = new T.VexFlowOctaveShift(n, o.PositionAndShape);
                                    let c = this.findLastStafflineMeasure(r);
                                    if (!c) continue;
                                    t < m.ParentMusicSystem.Id - 1 && (a.endsOnDifferentStaffLine = !0, a.graphicalEndAtMeasureEnd = !0, a.endMeasure = c);
                                    const u = this.findBoundaryNoteEntry(r.Measures);
                                    let d = this.findBoundaryNoteEntry([
                                        c
                                    ], !0);
                                    h.ParentStaffLine === r && (c = h, d = l), 1 === d.graphicalVoiceEntries.length && 1 === d.graphicalVoiceEntries[0].notes.length && d.graphicalVoiceEntries[0].notes[0].sourceNote.isWholeMeasureNote() && (a.graphicalEndAtMeasureEnd = !0, a.endMeasure = c);
                                    const f = "VexFlowMusicSheetCalculator.calculateSingleOctaveShift: ";
                                    u || y.default.warn(f + "no firstNote found"), d || y.default.warn(f + "no lastNote found"), a.setStartNote(u);
                                    const p = h.ParentStaffLine === r && n.endVoiceEntryIndex > 0 ? n.endVoiceEntryIndex : -1;
                                    a.setEndNote(d, p), r.OctaveShifts.push(a), this.calculateOctaveShiftSkyBottomLine(u, d, a, r);
                                }
                                this.calculateOctaveShiftSkyBottomLine(a, e, i, c);
                            } else i.setEndNote(l, n.endVoiceEntryIndex > 0 ? n.endVoiceEntryIndex : -1), this.calculateOctaveShiftSkyBottomLine(a, l, i, c);
                            c.OctaveShifts.push(i);
                        } else y.default.warn("End measure or staffLines for octave shift are undefined! This should not happen!");
                    }
                    hasVexFlowNote(t) {
                        return t?.graphicalVoiceEntries.some((t)=>!!t.vfStaveNote) ?? !1;
                    }
                    findBoundaryNoteEntry(t, e = !1) {
                        const i = e ? -1 : 1;
                        for(let s = e ? t.length - 1 : 0; s >= 0 && s < t.length; s += i){
                            const n = t[s].staffEntries;
                            for(let t = e ? n.length - 1 : 0; t >= 0 && t < n.length; t += i)if (this.hasVexFlowNote(n[t])) return n[t];
                        }
                    }
                    findLastStafflineMeasure(t) {
                        return this.findBoundaryNoteEntry(t.Measures, !0)?.parentMeasure;
                    }
                    findFirstStafflineMeasure(t) {
                        return this.findBoundaryNoteEntry(t.Measures)?.parentMeasure;
                    }
                    calculateSinglePedal(t, e, i, s) {
                        const n = e.PedalStart, r = n.ParentStartMultiExpression.Timestamp, o = n.ParentEndMultiExpression?.Timestamp, a = this.rules.MinMeasureToDrawIndex, l = this.rules.MaxMeasureToDrawIndex;
                        let h, c = this.graphicalMusicSheet.MeasureList[i][s].ParentStaffLine;
                        c || (c = this.graphicalMusicSheet.MeasureList[a][s].ParentStaffLine), h = n.ParentEndMultiExpression ? this.graphicalMusicSheet.getGraphicalMeasureFromSourceMeasureAndIndex(n.ParentEndMultiExpression.SourceMeasureParent, s) : this.graphicalMusicSheet.getLastGraphicalMeasureFromIndex(s, !0);
                        const u = h.MeasureNumber > l + 1;
                        let d;
                        u && (h = this.graphicalMusicSheet.getLastGraphicalMeasureFromIndex(s, !0)), n.ParentEndMultiExpression ? d = this.graphicalMusicSheet.getGraphicalMeasureFromSourceMeasureAndIndex(n.ParentStartMultiExpression.SourceMeasureParent, s) : (d = this.graphicalMusicSheet.getGraphicalMeasureFromSourceMeasureAndIndex(n.ParentStartMultiExpression.SourceMeasureParent, s), d || (d = this.graphicalMusicSheet.MeasureList[a][s]));
                        const f = d.MeasureNumber < a + 1;
                        if (f && (d = this.graphicalMusicSheet.MeasureList[a][s], c = d.ParentStaffLine), d.parentSourceMeasure.measureListIndex < a || d.parentSourceMeasure.measureListIndex > l || h.parentSourceMeasure.measureListIndex < a || h.parentSourceMeasure.measureListIndex > l) return;
                        let m = h.ParentStaffLine;
                        if (m || (m = c), h && c && m) {
                            let t = !1;
                            const e = f ? c.Measures : [
                                d
                            ], i = u ? m.Measures : [
                                h
                            ];
                            c !== m && (t = !0);
                            const a = new O.VexFlowPedal(n, c.PositionAndShape, !1, t);
                            a.setEndsStave(h, o);
                            let l = d.findGraphicalStaffEntryFromTimestamp(r);
                            this.hasVexFlowNote(l) || (l = this.findBoundaryNoteEntry(e));
                            let p = h.findGraphicalStaffEntryFromTimestamp(o);
                            if (this.hasVexFlowNote(p) || (p = this.findBoundaryNoteEntry(i, !0)), !a.setStartNote(l)) return;
                            if (a.setBeginsStave(a.startNote.isRest(), r), m !== c) {
                                if (a.pedalSymbol === F.MusicSymbol.PEDAL_SYMBOL) {
                                    a.setEndNote(p), a.setEndMeasure(h), a.ReleaseText = " ", a.CalculateBoundingBox(), this.calculatePedalSkyBottomLine(a.startVfVoiceEntry, a.endVfVoiceEntry, a, c);
                                    const t = m.Measures[0], e = new O.VexFlowPedal(n, t.PositionAndShape);
                                    a.setEndsStave(h, o);
                                    const i = this.findBoundaryNoteEntry(m.Measures);
                                    if (!e.setStartNote(i)) return;
                                    e.setEndNote(p), e.setEndMeasure(h), a.setEndMeasure(h), m.Pedals.push(e), e.CalculateBoundingBox(), e.DepressText = " ", this.calculatePedalSkyBottomLine(e.startVfVoiceEntry, e.endVfVoiceEntry, e, m);
                                } else {
                                    let t = this.findLastStafflineMeasure(c);
                                    void 0 === t && (t = h);
                                    const e = this.findBoundaryNoteEntry([
                                        t
                                    ], !0);
                                    a.setEndNote(e), a.setEndMeasure(h), a.ChangeEnd = !1;
                                    const i = m.ParentMusicSystem.Id - c.ParentMusicSystem.Id;
                                    if (i > 0) {
                                        let t = 1;
                                        for(let e = c.ParentMusicSystem.Id; e < m.ParentMusicSystem.Id; e++){
                                            const r = this.musicSystems[e + 1].StaffLines[s], l = r.Measures[0];
                                            let c = !1, u = !1;
                                            t < i ? c = !0 : u = !0, t++;
                                            const d = new O.VexFlowPedal(n, l.PositionAndShape, !0, c);
                                            a.setEndsStave(h, o), d.ChangeBegin = !1, d.ChangeEnd = !!u && n.ChangeEnd;
                                            let f = this.findLastStafflineMeasure(r);
                                            if (!f) continue;
                                            const m = this.findBoundaryNoteEntry(r.Measures);
                                            let g = this.findBoundaryNoteEntry([
                                                f
                                            ], !0);
                                            if (h.ParentStaffLine === r ? (f = h, d.setEndMeasure(h), g = p) : d.setEndMeasure(r.Measures.last()), !d.setStartNote(m)) break;
                                            d.setEndNote(g), a.setEndMeasure(h), r.Pedals.push(d), d.CalculateBoundingBox(), this.calculatePedalSkyBottomLine(d.startVfVoiceEntry, d.endVfVoiceEntry, d, r);
                                        }
                                    }
                                    a.CalculateBoundingBox(), this.calculatePedalSkyBottomLine(a.startVfVoiceEntry, a.endVfVoiceEntry, a, c);
                                }
                            } else a.setEndNote(p), a.setEndMeasure(h), a.CalculateBoundingBox(), this.calculatePedalSkyBottomLine(a.startVfVoiceEntry, a.endVfVoiceEntry, a, c);
                            c.Pedals.push(a);
                        } else y.default.warn("End measure or staffLines for pedal are undefined! This should not happen!");
                    }
                    calculateSingleWavyLine(t, e, i, s) {
                        const n = e.WavyLineStart, r = n.ParentStartMultiExpression.Timestamp, o = n.ParentEndMultiExpression?.Timestamp, a = this.rules.MinMeasureToDrawIndex, l = this.rules.MaxMeasureToDrawIndex;
                        let h, c = this.graphicalMusicSheet.MeasureList[i][s].ParentStaffLine;
                        c || (c = this.graphicalMusicSheet.MeasureList[a][s].ParentStaffLine), h = n.ParentEndMultiExpression ? this.graphicalMusicSheet.getGraphicalMeasureFromSourceMeasureAndIndex(n.ParentEndMultiExpression.SourceMeasureParent, s) : this.graphicalMusicSheet.getLastGraphicalMeasureFromIndex(s, !0);
                        const u = h.MeasureNumber > l + 1;
                        let d;
                        u && (h = this.graphicalMusicSheet.getLastGraphicalMeasureFromIndex(s, !0)), d = n.ParentEndMultiExpression ? this.graphicalMusicSheet.getGraphicalMeasureFromSourceMeasureAndIndex(n.ParentStartMultiExpression.SourceMeasureParent, s) : this.graphicalMusicSheet.MeasureList[a][s];
                        const f = d.MeasureNumber < a + 1;
                        if (f && (d = this.graphicalMusicSheet.MeasureList[a][s], c = d.ParentStaffLine), d.parentSourceMeasure.measureListIndex < a || d.parentSourceMeasure.measureListIndex > l || h.parentSourceMeasure.measureListIndex < a || h.parentSourceMeasure.measureListIndex > l) return;
                        let m = h.ParentStaffLine;
                        if (m || (m = c), h && c && m) {
                            const t = new G.VexFlowVibratoBracket(n, c.PositionAndShape, d.ParentStaff.isTab), e = f ? c.Measures : [
                                d
                            ], i = u ? m.Measures : [
                                h
                            ];
                            let a = d.findGraphicalStaffEntryFromTimestamp(r);
                            this.hasVexFlowNote(a) || (a = this.findBoundaryNoteEntry(e));
                            let l = h.findGraphicalStaffEntryFromTimestamp(o);
                            if (this.hasVexFlowNote(l) || (l = this.findBoundaryNoteEntry(i, !0)), !t.setStartNote(a)) return;
                            if (m !== c) {
                                let e = this.findLastStafflineMeasure(c);
                                void 0 === e && (e = h);
                                const i = this.findBoundaryNoteEntry([
                                    e
                                ], !0);
                                if (i && t.setEndNote(i), m.ParentMusicSystem.Id - c.ParentMusicSystem.Id > 0) for(let t = c.ParentMusicSystem.Id; t < m.ParentMusicSystem.Id; t++){
                                    const e = this.musicSystems[t + 1];
                                    let i;
                                    for (const t of e.StaffLines)if (t.ParentStaff.idInMusicSheet === s) {
                                        i = t;
                                        break;
                                    }
                                    if (!i) continue;
                                    const r = i.Measures[0], o = new G.VexFlowVibratoBracket(n, r.PositionAndShape, i.ParentStaff.isTab), a = this.findBoundaryNoteEntry(i.Measures);
                                    let c = this.findBoundaryNoteEntry(i.Measures, !0);
                                    h.ParentStaffLine === i && (c = l), o.setStartNote(a) && (o.setEndNote(c), i.WavyLines.push(o), o.CalculateBoundingBox(), this.calculateWavyLineSkyBottomLine(o.startVfVoiceEntry, o.endVfVoiceEntry, o, i));
                                }
                                t.CalculateBoundingBox(), this.calculateWavyLineSkyBottomLine(t.startVfVoiceEntry, t.endVfVoiceEntry, t, c);
                            } else t.setEndNote(l), n.ParentEndMultiExpression === n.ParentStartMultiExpression && t.coverEndNoteDuration(), t.CalculateBoundingBox(), this.calculateWavyLineSkyBottomLine(t.startVfVoiceEntry, t.endVfVoiceEntry, t, c);
                            c.WavyLines.push(t);
                        } else y.default.warn("End measure or staffLines for wavy line are undefined! This should not happen!");
                    }
                    calculateWavyLineSkyBottomLine(t, e, i, s) {
                        const n = i.startNote.getStave();
                        let r = i.endNote?.getStave();
                        r || (r = n, e = t);
                        const o = Math.max(n.options.top_text_position, r.options.top_text_position);
                        n.options.top_text_position = o, r.options.top_text_position = o;
                        let a, l = -o, h = 0, c = 0, u = 1 / 0, d = 1 / 0, f = t.PositionAndShape.AbsolutePosition.x + t.PositionAndShape.BorderLeft;
                        if (t.parentVoiceEntry?.OrnamentContainer?.GetOrnament === m.OrnamentEnum.Trill && (h = f, f += 2, c = f, u = s.SkyBottomLineCalculator.getSkyLineMinInRange(h, c), d = u + 1.85), i.ToEndOfStopStave) a = e.parentStaffEntry.parentMeasure.PositionAndShape.AbsolutePosition.x + e.parentStaffEntry.parentMeasure.PositionAndShape.BorderRight - 1;
                        else if (i.nextVfVoiceEntry) {
                            const t = i.nextVfVoiceEntry.PositionAndShape;
                            a = t.AbsolutePosition.x + t.BorderLeft - .5;
                        } else {
                            a = e.PositionAndShape.AbsolutePosition.x + e.PositionAndShape.BorderRight;
                            const t = e.parentStaffEntry.vfClefBefore;
                            t && (a += t.getWidth() / 10);
                        }
                        l = s.SkyBottomLineCalculator.getSkyLineMinInRange(f, a), l !== 1 / 0 && (l < u ? (n.options.top_text_position = -l, r.options.top_text_position = -l, s.SkyBottomLineCalculator.updateSkyLineInRange(h, c, l - 1.85)) : (i.line = -d, l = d), l -= i.PositionAndShape.Size.height, s.SkyBottomLineCalculator.updateSkyLineInRange(f, a, l));
                    }
                    calculatePedalSkyBottomLine(t, e, i, s) {
                        let n = e?.PositionAndShape;
                        n || (n = i.endMeasure.PositionAndShape);
                        const r = b.default.Flow.PedalMarking.Styles, o = i.getPedalMarking(), a = o.line + 3 + (s.StaffLines.length - 1), l = o.render_options.text_margin_right / 10;
                        let h, c = t.PositionAndShape.AbsolutePosition.x - l;
                        o.style !== r.MIXED && o.style !== r.MIXED_OPEN_END && o.style !== r.TEXT || (c -= 1);
                        let u = s.StaffLines.length - 1;
                        for (const t of s.Pedals){
                            const e = t.getPedalMarking().line + 3 + (s.StaffLines.length - 1);
                            u = Math.max(e, u);
                        }
                        if (i.EndSymbolPositionAndShape) {
                            const t = o.render_options.glyph_point_size / 20;
                            h = c + 3.4;
                            const e = n.AbsolutePosition.x - l, r = e + 1.5;
                            u = Math.max(s.SkyBottomLineCalculator.getBottomLineMaxInRange(c, h), u), u = Math.max(a + 2 * t, u);
                            const d = s.SkyBottomLineCalculator.getBottomLineMaxInRange(e, r);
                            i.DepressText || (u = Math.max(u, d)), i.setLine(u - 3 - (s.StaffLines.length - 1)), s.SkyBottomLineCalculator.updateBottomLineInRange(c, h, u + t), s.SkyBottomLineCalculator.updateBottomLineInRange(e, r, u + t);
                        } else {
                            const t = o.render_options.bracket_height / 10;
                            if (o.EndsStave) h = e ? e.parentStaffEntry.parentMeasure.PositionAndShape.AbsolutePosition.x + e.parentStaffEntry.parentMeasure.PositionAndShape.Size.width - l : n.AbsolutePosition.x + n.Size.width;
                            else switch(o.style){
                                case r.BRACKET_OPEN_END:
                                case r.BRACKET_OPEN_BOTH:
                                case r.MIXED_OPEN_END:
                                    h = n.AbsolutePosition.x + n.BorderRight - l;
                                    break;
                                default:
                                    h = n.AbsolutePosition.x + n.BorderLeft - l;
                            }
                            const d = e?.parentStaffEntry?.vfClefBefore;
                            if (d && (h += d.getWidth() / 10), u = Math.max(s.SkyBottomLineCalculator.getBottomLineMaxInRange(c, h), u), u === 1 / 0) return;
                            if (u = Math.max(u, a + t), i.setLine(u - 3 - (s.StaffLines.length - 1)), c > h) {
                                const t = h;
                                h = c, c = t;
                            }
                            s.SkyBottomLineCalculator.updateBottomLineInRange(c, h, u + t);
                        }
                        for (const t of s.Pedals){
                            const e = t, i = e.getPedalMarking();
                            if (u > i.line + 3 + (s.StaffLines.length - 1)) {
                                const t = i.render_options.text_margin_right / 10;
                                let n, a = e.startVfVoiceEntry.PositionAndShape.AbsolutePosition.x - t;
                                e.setLine(u - 3 - (s.StaffLines.length - 1));
                                let l = e.endVfVoiceEntry?.PositionAndShape;
                                if (l || (l = e.endMeasure.PositionAndShape), e.EndSymbolPositionAndShape) {
                                    const e = o.render_options.glyph_point_size / 20;
                                    n = a + 3.4;
                                    const i = l.AbsolutePosition.x - t, r = i + 1.5;
                                    s.SkyBottomLineCalculator.updateBottomLineInRange(a, n, u + e), s.SkyBottomLineCalculator.updateBottomLineInRange(i, r, u + e);
                                } else {
                                    const h = i.render_options.bracket_height / 10;
                                    if (i.EndsStave) n = l.AbsolutePosition.x + l.Size.width - t;
                                    else switch(o.style){
                                        case r.BRACKET_OPEN_END:
                                        case r.BRACKET_OPEN_BOTH:
                                        case r.MIXED_OPEN_END:
                                            n = l.AbsolutePosition.x + l.BorderRight - t;
                                            break;
                                        default:
                                            n = l.AbsolutePosition.x + l.BorderLeft - t;
                                    }
                                    const c = e.endVfVoiceEntry?.parentStaffEntry?.vfClefBefore;
                                    if (c && (n += c.getWidth() / 10), a > n) {
                                        const t = a;
                                        a = n, n = t;
                                    }
                                    s.SkyBottomLineCalculator.updateBottomLineInRange(a, n, u + h);
                                }
                            }
                        }
                    }
                    calculateOctaveShiftSkyBottomLine(t, e, i, s) {
                        if (!e) return void y.default.warn("octaveshift: no endStaffEntry");
                        let n = e.PositionAndShape;
                        i.graphicalEndAtMeasureEnd && (n = e.parentMeasure.PositionAndShape);
                        let r = t.PositionAndShape.Size.width, o = n.Size.width;
                        t.hasOnlyRests() ? r = -r : r /= 2, i.graphicalEndAtMeasureEnd || (e.hasOnlyRests() ? o *= 2 : o /= 2, t === e && (o *= 2));
                        let a = t.PositionAndShape.AbsolutePosition.x - r, l = n.AbsolutePosition.x + o;
                        if (a > l) {
                            const t = a;
                            a = l, l = t;
                        }
                        i.PositionAndShape.Size.width = l - a;
                        const h = i.getTextBracket(), c = h.font.size / 10;
                        if (h.position === S.TextBracket.Positions.TOP) {
                            const t = Math.ceil(s.SkyBottomLineCalculator.getSkyLineMinInRange(a, l) - .05);
                            if (t === 1 / 0) return;
                            h.start.getStave().options.top_text_position = Math.abs(t), s.SkyBottomLineCalculator.updateSkyLineInRange(a, l, t - 2 * c);
                        } else {
                            const t = s.SkyBottomLineCalculator.getBottomLineMaxInRange(a, l);
                            if (t === 1 / 0) return;
                            h.start.getStave().options.bottom_text_position = t, s.SkyBottomLineCalculator.updateBottomLineInRange(a, l, t + 1.5 * c);
                        }
                    }
                    calculateWordRepetitionInstruction(t, e) {
                        let i;
                        const s = this.graphicalMusicSheet.MeasureList[e];
                        for(let t = 0, e = s.length; t < e; ++t){
                            const e = s[t];
                            if (e && e.ParentStaffLine && e.ParentStaff.isVisible()) {
                                i = e;
                                break;
                            }
                        }
                        if (i) {
                            const e = i.addWordRepetition(t);
                            this.placeWordRepetitionInSkyline(i, e);
                        }
                    }
                    placeWordRepetitionInSkyline(t, e) {
                        const i = t.ParentStaffLine;
                        if (!e || !i) return;
                        const s = e.symbol_type, r = S.Repetition.type;
                        let o, a = !1;
                        switch(s){
                            case r.CODA_LEFT:
                                o = "Coda", a = !0;
                                break;
                            case r.TO_CODA:
                                o = "To", a = !0;
                                break;
                            case r.DC_AL_CODA:
                                o = "D.C. al", a = !0;
                                break;
                            case r.DS_AL_CODA:
                                o = "D.S. al", a = !0;
                                break;
                            case r.DC:
                                o = "D.C.";
                                break;
                            case r.DC_AL_FINE:
                                o = "D.C. al Fine";
                                break;
                            case r.DS:
                                o = "D.S.";
                                break;
                            case r.DS_AL_FINE:
                                o = "D.S. al Fine";
                                break;
                            case r.FINE:
                                o = "Fine";
                                break;
                            default:
                                o = "";
                        }
                        const l = e.text;
                        l && (o = l, a = !1);
                        let h = 0;
                        if (o.length > 0 && this.rules.VexFlowTextFontFamily && n.MusicSheetCalculator.TextMeasurer.computeTextWidthInCssFont) {
                            const t = 20;
                            h = n.MusicSheetCalculator.TextMeasurer.computeTextWidthInCssFont(o, `italic bold ${t}px ${this.rules.VexFlowTextFontFamily}`) / t * 1.6;
                        } else o.length > 0 && (h = 1.6 * n.MusicSheetCalculator.TextMeasurer.computeTextWidthToHeightRatio(o, c.Fonts.TimesNewRoman, u.FontStyles.BoldItalic, "times"));
                        const d = t.PositionAndShape.RelativePosition.x, f = t.PositionAndShape.Size.width;
                        let m, p;
                        if (s === r.SEGNO_LEFT) m = d + .7 * t.beginInstructionsWidth, p = d + 1.2 * t.beginInstructionsWidth + t.beginInstructionsWidth / E.unitInPixels + 2.4;
                        else if (s === r.CODA_LEFT) m = d + t.beginInstructionsWidth / E.unitInPixels, p = m + h + 2.4;
                        else {
                            if (m = d + f - .5 - h - 2.4, s === r.DC || s === r.DC_AL_FINE || s === r.DS || s === r.DS_AL_FINE || s === r.FINE) {
                                const t = f * (e.xShiftAsPercentOfStaveWidth ?? 0);
                                m += Math.max(0, Math.min(t, d + f - (m + h)));
                            }
                            p = m + h, a && (p += 2.4);
                        }
                        if (m = Math.max(0, m), p = Math.min(i.PositionAndShape.Size.width, p), !(p > m)) return;
                        const g = (e.y_shift ?? 0) / E.unitInPixels, b = -4.5 + g, y = -2.5 + g, x = i.SkyBottomLineCalculator;
                        let v = x.getSkyLineMinInRange(m, p);
                        v !== -1 / 0 && v !== 1 / 0 || (v = 0);
                        let T = this.placedWordRepetitionBoxes.get(i);
                        T || (T = [], this.placedWordRepetitionBoxes.set(i, T));
                        for (const t of T)t.endX > m && t.startX < p && (v = Math.min(v, t.top));
                        let _ = 0;
                        v < y && (_ = v - y, e.setShiftY(e.y_shift + _ * E.unitInPixels)), T.push({
                            startX: m,
                            endX: p,
                            top: b + _
                        }), _ < 0 && x.updateSkyLineInRange(m, p, b + _);
                    }
                    calculateSkyBottomLines() {
                        const t = k.CollectionUtil.flat(this.musicSystems.map((t)=>t.StaffLines)), e = this.rules.LazyConsistentGraphic && this.rules.UseGeometricSkyBottomLineCalculation, i = e ? [] : t, s = [], n = new Map;
                        if (e) {
                            const t = this.musicSystems.length - 1;
                            for(let e = 0; e < this.musicSystems.length; e++){
                                const r = 0 !== e && e !== t, o = this.musicSystems[e].StaffLines;
                                for(let t = 0; t < o.length; t++){
                                    const e = o[t], a = this.skyBottomLineCacheKey(e, t), l = a ? this.skyBottomLineCache.get(a) : void 0;
                                    l ? (e.SkyBottomLineCalculator.applyGeometricSkylineSideEffectsOnly(n), e.SkyBottomLineCalculator.setLinesDirectly(l.sky.slice(), l.bottom.slice())) : (i.push(e), r && a && s.push({
                                        key: a,
                                        staffLine: e
                                    }));
                                }
                            }
                        }
                        this.computeSkyBottomLinesFor(i, n);
                        for (const t of s)this.skyBottomLineCache.set(t.key, {
                            sky: t.staffLine.SkyLine.slice(),
                            bottom: t.staffLine.BottomLine.slice()
                        });
                    }
                    computeSkyBottomLinesFor(t, e) {
                        if (0 === t.length) return;
                        if (this.rules.UseGeometricSkyBottomLineCalculation) {
                            for (const i of t)i.SkyBottomLineCalculator.calculateLines(e);
                            return;
                        }
                        let i = 0;
                        for (const e of t)for (const t of e.Measures)t && i++;
                        if (this.rules.AlwaysSetPreferredSkyBottomLineBackendAutomatically && this.rules.setPreferredSkyBottomLineBackendAutomatically(i), i >= this.rules.SkyBottomLineBatchMinMeasures) new h.SkyBottomLineBatchCalculator(t, this.rules.PreferredSkyBottomLineBatchCalculatorBackend).calculateLines();
                        else for (const e of t)e.SkyBottomLineCalculator.calculateLines();
                    }
                    calculateExpressionAlignements() {
                        for (const t of this.musicSystems)for (const e of t.StaffLines)try {
                            e.AlignmentManager.alignDynamicExpressions(), e.AbstractExpressions.forEach((t)=>{
                                t.updateSkyBottomLine();
                            });
                        } catch (t) {}
                    }
                    handleTiedGraphicalNote(t, e, i, s, n, r, o, a) {}
                    handleBeam(t, e, i) {
                        t.parentVoiceEntry.parentStaffEntry.parentMeasure.handleBeam(t, e);
                    }
                    handleVoiceEntryLyrics(t, e, i) {
                        t.LyricsEntries.forEach((t, s)=>{
                            const n = new x.GraphicalLyricEntry(s, e, this.rules.LyricsHeight, this.rules.StaffHeight);
                            if (e.LyricsEntries.push(n), s.Word) {
                                const t = s.Word.Syllables.indexOf(s);
                                let e = i.indexOf(s.Word);
                                if (-1 === e && (i.push(s.Word), e = i.indexOf(s.Word)), 0 === this.graphicalLyricWords.length || e > this.graphicalLyricWords.length - 1) {
                                    const e = new v.GraphicalLyricWord(s.Word);
                                    n.ParentLyricWord = e, e.GraphicalLyricsEntries[t] = n, this.graphicalLyricWords.push(e);
                                } else {
                                    const s = this.graphicalLyricWords[e];
                                    n.ParentLyricWord = s, s.GraphicalLyricsEntries[t] = n, s.isFilled() && (i.splice(e, 1), this.graphicalLyricWords.splice(this.graphicalLyricWords.indexOf(s), 1));
                                }
                            }
                        });
                    }
                    handleVoiceEntryOrnaments(t, e, i) {}
                    handleVoiceEntryArticulations(t, e, i) {}
                    handleVoiceEntryTechnicalInstructions(t, e, i) {}
                    handleTuplet(t, e, i) {
                        t.parentVoiceEntry.parentStaffEntry.parentMeasure.handleTuplet(t, e);
                    }
                    findIndexGraphicalSlurFromSlur(t, e) {
                        for(let i = 0; i < t.length; i++)if (t[i].slur === e) return i;
                        return -1;
                    }
                    indexOfGraphicalGlissFromGliss(t, e) {
                        for(let i = 0; i < t.length; i++)if (t[i].Glissando === e) return i;
                        return -1;
                    }
                    measureRepeatHidesNote(t) {
                        const e = this.rules.GNote(t)?.parentVoiceEntry?.parentStaffEntry?.parentMeasure;
                        return !0 === e?.NotesAreAbbreviated;
                    }
                    calculateSlurs() {
                        const t = {};
                        for (const e of this.graphicalMusicSheet.MeasureList[0])t[e.ParentStaff.idInMusicSheet] = [];
                        for (const e of this.musicSystems)for (const i of e.StaffLines){
                            const e = t[i.ParentStaff.idInMusicSheet];
                            for(let t = 0; t < e.length; t++){
                                const s = e[t], n = new P.GraphicalSlur(s.slur, this.rules);
                                i.addSlurToStaffline(n), e[t] = n;
                            }
                            for (const t of i.Measures){
                                for (const s of t.staffEntries){
                                    for (const n of s.graphicalVoiceEntries)for (const r of n.notes)for (const n of r.sourceNote.NoteSlurs)if (n.StartNote && (n.EndNote || n.HasUnattachedEnd) && (n.EndNote || t.staffEntries[t.staffEntries.length - 1] === s) && (!this.measureRepeatHidesNote(n.StartNote) || !this.measureRepeatHidesNote(n.EndNote))) {
                                        if (n.StartNote === r.sourceNote) {
                                            const t = new P.GraphicalSlur(n, this.rules);
                                            i.addSlurToStaffline(t), n.isCrossed() ? t.staffEntries = [
                                                s
                                            ] : e.push(t);
                                        }
                                        if (n.EndNote === r.sourceNote) {
                                            const t = this.findIndexGraphicalSlurFromSlur(e, n);
                                            if (t >= 0) {
                                                const i = e[t];
                                                -1 === i.staffEntries.indexOf(s) && i.staffEntries.push(s), e.splice(t, 1);
                                            }
                                        }
                                    }
                                    for (const t of e)-1 === t.staffEntries.indexOf(s) && t.staffEntries.push(s);
                                }
                                for(let t = e.length - 1; t >= 0; t--)e[t].slur.EndNote || e.splice(t, 1);
                            }
                            for (const t of e)0 === t.staffEntries.length && i.GraphicalSlurs.splice(i.GraphicalSlurs.indexOf(t), 1);
                        }
                        for (const t of this.musicSystems)for (const e of t.StaffLines){
                            const t = e.GraphicalSlurs.sort(P.GraphicalSlur.Compare);
                            for (const e of t)e.slur.isCrossed() || e.calculateCurve(this.rules);
                        }
                    }
                    calculateGlissandi() {
                        const t = {};
                        for (const e of this.graphicalMusicSheet.MeasureList[0])t[e.ParentStaff.idInMusicSheet] = [];
                        for (const e of this.musicSystems)for (const i of e.StaffLines){
                            const e = t[i.ParentStaff.idInMusicSheet];
                            for(let t = 0; t < e.length; t++){
                                const s = e[t], n = new V.VexFlowGlissando(s.Glissando);
                                i.addGlissandoToStaffline(n), e[t] = n;
                            }
                            for (const t of i.Measures)for (const s of t.staffEntries){
                                for (const t of s.graphicalVoiceEntries)for (const n of t.notes){
                                    for(let t = e.length - 1; t >= 0; t--){
                                        const i = e[t];
                                        i.Glissando.EndNote === n.sourceNote && (-1 === i.staffEntries.indexOf(s) && i.staffEntries.push(s), e.splice(t, 1));
                                    }
                                    const t = n.sourceNote.NoteGlissando;
                                    if (t?.EndNote && t?.StartNote && !(this.measureRepeatHidesNote(t.StartNote) && this.measureRepeatHidesNote(t.EndNote) || t.StartNote !== n.sourceNote)) {
                                        const s = new V.VexFlowGlissando(t);
                                        e.push(s), i.addGlissandoToStaffline(s);
                                    }
                                }
                                for (const t of e)-1 === t.staffEntries.indexOf(s) && t.staffEntries.push(s);
                            }
                            for (const t of e)0 === t.staffEntries.length && i.GraphicalGlissandi.splice(i.GraphicalGlissandi.indexOf(t), 1);
                        }
                        for (const t of this.musicSystems)for (const e of t.StaffLines)for (const t of e.GraphicalGlissandi)if (e.ParentStaff.isTab) {
                            const e = t.Glissando.StartNote, i = t.Glissando.EndNote, s = t.staffEntries[0].findGraphicalNoteFromNote(e), n = t.staffEntries.last().findGraphicalNoteFromNote(i);
                            if (!s && !n) continue;
                            let r, o, a, l, h = 1;
                            e.FretNumber > i.FretNumber && (h = -1), s && s.vfnote && s.vfnote.length >= 2 && (a = s.vfnote[0], r = [
                                0
                            ]), n && n.vfnote && n.vfnote.length >= 2 && (l = n.vfnote[0], o = [
                                0
                            ]);
                            const c = new S.TabSlide({
                                first_indices: r,
                                first_note: a,
                                last_indices: o,
                                last_note: l
                            }, h);
                            N.VexFlowConverter.setVexFlowTextFontFamily(c.font, this.rules);
                            const u = s?.parentVoiceEntry.parentStaffEntry.parentMeasure;
                            u && (u.vfTies.push(c), t.vfTie = c);
                            const d = n?.parentVoiceEntry.parentStaffEntry.parentMeasure;
                            d && (d.vfTies.push(c), t.vfTie = c);
                        }
                    }
                }
                e.VexFlowMusicSheetCalculator = z;
            },
            9479 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.VexFlowMusicSheetDrawer = e.unitInPixels = void 0;
                const n = s(i(3206)), r = i(1932), o = i(200), a = i(9409), l = i(7785), h = i(2683), c = i(6362), u = i(3361), d = i(5023), f = s(i(3065)), m = i(1066), p = i(3661), g = i(5824), b = i(9436), S = i(6014);
                e.unitInPixels = 10;
                class y extends r.MusicSheetDrawer {
                    constructor(t = new p.DrawingParameters){
                        super(new l.VexFlowTextMeasurer(t.Rules), t), this.backends = [], this.zoom = 1, this.pageIdx = 0;
                    }
                    get Backends() {
                        return this.backends;
                    }
                    drawSheet(t) {
                        "gonville" === this.rules.DefaultVexFlowNoteFont && (n.default.Flow.DEFAULT_FONT_STACK = [
                            n.default.Flow.Fonts?.Gonville,
                            n.default.Flow.Fonts?.Bravura,
                            n.default.Flow.Fonts?.Custom
                        ]), n.default.Flow.STAVE_LINE_THICKNESS = this.rules.StaffLineWidth * e.unitInPixels, n.default.Flow.STEM_WIDTH = this.rules.StemWidth * e.unitInPixels, n.default.Flow.DEFAULT_NOTATION_FONT_SCALE = this.rules.VexFlowDefaultNotationFontScale, n.default.Flow.DEFAULT_TAB_FONT_SCALE = this.rules.VexFlowDefaultTabFontScale, this.pageIdx = 0;
                        for (const e of t.MusicPages){
                            if (e.PageNumber > this.rules.MaxPageToDrawNumber) break;
                            const t = this.backends[this.pageIdx];
                            t.graphicalMusicPage = e, t.scale(this.zoom), this.pageIdx += 1;
                        }
                        this.pageIdx = 0, this.backend = this.backends[0], super.drawSheet(t);
                    }
                    drawPage(t) {
                        t && (this.backend = this.backends[t.PageNumber - 1], super.drawPage(t), this.pageIdx += 1);
                    }
                    clear() {
                        for (const t of this.backends)t.clear();
                    }
                    setZoom(t) {
                        this.zoom = t;
                    }
                    calculatePixelDistance(t) {
                        return t * e.unitInPixels;
                    }
                    drawStaffLine(t) {
                        const e = this.backend.getContext(), i = e.openGroup();
                        i && (i.classList.add("staffline"), t.ParentStaff && (i.id = `${t.ParentStaff.ParentInstrument?.Name}${t.ParentStaff.ParentInstrument?.Id}-${t.ParentStaff?.Id}`)), super.drawStaffLine(t);
                        const s = t.PositionAndShape.AbsolutePosition;
                        this.rules.RenderSlurs && this.drawSlurs(t, s), this.rules.RenderGlissandi && this.drawGlissandi(t, s), e.closeGroup();
                    }
                    drawSlurs(t, e) {
                        for (const i of t.GraphicalSlurs)if (this.lazyDrawsSlur(i)) {
                            if (i.slur.isCrossed()) {
                                if (!this.rules.RenderSlursAcrossStaves) continue;
                                if (!i.calculateCurveCrossStaff(this.rules)) continue;
                            }
                            this.drawSlur(i, e);
                        }
                    }
                    lazyDrawsSlur(t) {
                        if (this.LazyDrawFromXUnits === Number.NEGATIVE_INFINITY && this.LazyDrawToXUnits === Number.POSITIVE_INFINITY) return !0;
                        let e = Number.NEGATIVE_INFINITY;
                        const i = this.rules.GNote(t.slur.StartNote), s = t.slur.EndNote ? this.rules.GNote(t.slur.EndNote) : void 0;
                        i && (e = Math.max(e, i.PositionAndShape.AbsolutePosition.x)), s && (e = Math.max(e, s.PositionAndShape.AbsolutePosition.x));
                        for (const i of t.staffEntries)e = Math.max(e, i.PositionAndShape.AbsolutePosition.x + i.PositionAndShape.BorderRight);
                        return e === Number.NEGATIVE_INFINITY || this.lazyDrawsAtX(e);
                    }
                    drawGlissandi(t, e) {
                        for (const i of t.GraphicalGlissandi)this.lazyDrawsGlissando(i) && this.drawGlissando(i, e);
                    }
                    lazyDrawsGlissando(t) {
                        let e = Number.NEGATIVE_INFINITY;
                        for (const i of t.staffEntries)e = Math.max(e, i.PositionAndShape.AbsolutePosition.x + i.PositionAndShape.BorderRight);
                        return e === Number.NEGATIVE_INFINITY || this.lazyDrawsAtX(e);
                    }
                    drawGlissando(t, e) {
                        t.StaffLine.ParentStaff.isTab || t.calculateLine(this.rules);
                        const i = t.vfTie;
                        if (!t.Line && !i) return;
                        const s = this.backend.getContext(), n = this.rules.GNote(t.Glissando.StartNote)?.getSVGId();
                        if (s.openGroup("glissando", n ? `${n}-glissando` : void 0), t.Line) {
                            const i = new a.PointF2D(t.Line.Start.x + e.x, t.Line.Start.y), s = new a.PointF2D(t.Line.End.x + e.x, t.Line.End.y);
                            t.Line.SVGElement = this.drawLine(i, s, t.Color, t.Width);
                        } else i.setContext(s), i.draw();
                        s.closeGroup();
                    }
                    drawSlur(t, e) {
                        for (const e of [
                            t.bezierStartPt,
                            t.bezierStartControlPt,
                            t.bezierEndControlPt,
                            t.bezierEndPt
                        ])if (!e || !Number.isFinite(e.x) || !Number.isFinite(e.y)) return void f.default.warn("VexFlowMusicSheetDrawer.drawSlur: skipping slur with invalid bezier points, measure " + t.staffEntries[0]?.parentMeasure?.MeasureNumber);
                        const i = [], s = new a.PointF2D(t.bezierStartPt.x + e.x, t.bezierStartPt.y + e.y), n = new a.PointF2D(t.bezierStartControlPt.x + e.x, t.bezierStartControlPt.y + e.y), r = new a.PointF2D(t.bezierEndControlPt.x + e.x, t.bezierEndControlPt.y + e.y), o = new a.PointF2D(t.bezierEndPt.x + e.x, t.bezierEndPt.y + e.y);
                        i.push(this.applyScreenTransformation(s)), i.push(this.applyScreenTransformation(n)), i.push(this.applyScreenTransformation(r)), i.push(this.applyScreenTransformation(o)), t.placement === c.PlacementEnum.Above ? (s.y -= .05, n.y -= .3, r.y -= .3, o.y -= .05) : (s.y += .05, n.y += .3, r.y += .3, o.y += .05), i.push(this.applyScreenTransformation(s)), i.push(this.applyScreenTransformation(n)), i.push(this.applyScreenTransformation(r)), i.push(this.applyScreenTransformation(o));
                        const l = this.rules.GNote(t.slur.StartNote);
                        t.SVGElement = this.backend.renderCurve(i, !0, l);
                    }
                    drawMeasure(t) {
                        if (!this.lazyDrawsObject(t.PositionAndShape)) return;
                        t.setAbsoluteCoordinates(t.PositionAndShape.AbsolutePosition.x * e.unitInPixels, t.PositionAndShape.AbsolutePosition.y * e.unitInPixels);
                        try {
                            t.draw(this.backend.getContext());
                        } catch (t) {
                            f.default.warn("VexFlowMusicSheetDrawer.drawMeasure", t);
                        }
                        let i = 0;
                        const s = this.LazyForcePageLabels;
                        this.LazyForcePageLabels = !0;
                        for (const e of t.staffEntries)this.drawStaffEntry(e), t.NotesAreAbbreviated || (i = this.drawBuzzRolls(e, i));
                        this.LazyForcePageLabels = s, t.NotesAreAbbreviated || this.drawTremolosBetweenNotes(t);
                    }
                    drawBuzzRolls(t, e) {
                        for (const i of t.graphicalVoiceEntries)for (const t of i.notes)if (t.sourceNote.TremoloInfo?.tremoloUnmeasured) {
                            const i = this.rules.TremoloBuzzRollThickness, s = .9, n = .5, r = t;
                            let o, l;
                            const h = r.vfnote[0].getStemDirection();
                            let c;
                            if (this.backend instanceof b.SvgVexFlowBackend && (c = r.getStemSVG()), void 0 !== c?.getBbox) {
                                const t = c.getBBox();
                                o = new a.PointF2D(t.x / 10, t.y / 10), l = t.height / 10;
                            } else l = r.vfnote[0].getStemLength() / 10, o = new a.PointF2D(r.vfnote[0].getStem().x_begin / 10, r.vfnote[0].getStem().y_top / 10), 1 === h && (o.y -= l);
                            let u = o.y + l / 3;
                            r.vfnote[0].getBeamCount() > 1 && (u = o.y + l / 2, -1 === h && (u -= n + .2));
                            const d = o.x - .5, f = u, m = [], p = [
                                new a.PointF2D(0, -i),
                                new a.PointF2D(s - i, 0),
                                new a.PointF2D(-s + i, -n),
                                new a.PointF2D(0, -i),
                                new a.PointF2D(s, 0),
                                new a.PointF2D(0, i),
                                new a.PointF2D(-s + i, 0),
                                new a.PointF2D(s - i, n),
                                new a.PointF2D(0, i),
                                new a.PointF2D(-s, 0)
                            ];
                            let g = new a.PointF2D(d, f);
                            m.push(g);
                            for (const t of p)g = m.last(), m.push(new a.PointF2D(g.x + t.x, g.y - t.y));
                            this.DrawPath(m, r.ParentMusicPage, !0, `buzzRoll${e}`), e++;
                        }
                        return e;
                    }
                    drawTremolosBetweenNotes(t) {
                        if (t.isTabMeasure) return;
                        let e = 0;
                        for (const i of t.staffEntries)for (const s of i.graphicalVoiceEntries)for (const i of s.notes){
                            const s = i.sourceNote.TremoloInfo?.tremoloBetweenNotes;
                            if (s && s.stopNote === i.sourceNote && s.strokes > 0) try {
                                e = this.drawTremoloBetweenTwoNotes(s, i, t, e);
                            } catch (t) {
                                f.default.warn("VexFlowMusicSheetDrawer.drawTremolosBetweenNotes", t);
                            }
                        }
                    }
                    drawTremoloBetweenTwoNotes(t, i, s, n) {
                        if (t.startNote.isRest() || t.stopNote.isRest()) return n;
                        const r = this.rules.GNote(t.startNote);
                        if (!r?.vfnote || !i.vfnote) return n;
                        const o = s.ParentStaffLine;
                        if (r.parentVoiceEntry.parentStaffEntry.parentMeasure.ParentStaffLine !== o) return f.default.debug("VexFlowMusicSheetDrawer.drawTremoloBetweenTwoNotes: start and stop note are not in the same staffline (e.g. tremolo across a system break), not drawing tremolo strokes."), n;
                        const l = r.vfnote[0], h = i.vfnote[0];
                        if ("GhostNote" === l.getAttribute("type") || "GhostNote" === h.getAttribute("type")) return n;
                        const c = this.rules.TremoloBetweenNotesStrokeThickness, u = c + this.rules.TremoloBetweenNotesStrokeGap, d = t.strokes * c + (t.strokes - 1) * this.rules.TremoloBetweenNotesStrokeGap, m = this.rules.TremoloBetweenNotesYPadding;
                        let p, g, b, S, y = -1 / 0, E = 1 / 0, x = -1 / 0, v = 1 / 0;
                        const T = l.hasStem?.() && !!l.getStem(), _ = h.hasStem?.() && !!h.getStem();
                        if (T && _ && l.getStemDirection() === h.getStemDirection()) {
                            const t = l.getStemDirection();
                            p = l.getStemX(), g = h.getStemX();
                            const i = l.getYs(), s = h.getYs(), n = 1 === t ? Math.min(...i) : Math.max(...i), r = 1 === t ? Math.min(...s) : Math.max(...s), o = .5 * t * e.unitInPixels, a = l.getStemExtents().topY / e.unitInPixels, c = h.getStemExtents().topY / e.unitInPixels, u = (n - o) / e.unitInPixels, f = (r - o) / e.unitInPixels;
                            b = (a + u) / 2 * e.unitInPixels, S = (c + f) / 2 * e.unitInPixels, 1 === t ? (y = a + d / 2, E = u - m - d / 2, x = c + d / 2, v = f - m - d / 2) : (y = u + m + d / 2, E = a - d / 2, x = f + m + d / 2, v = c - d / 2);
                        } else {
                            const t = l.getBoundingBox(), e = h.getBoundingBox();
                            p = t.getX() + t.getW(), g = e.getX();
                            const i = l.getNoteHeadBounds(), s = h.getNoteHeadBounds();
                            b = (i.y_top + i.y_bottom) / 2, S = (s.y_top + s.y_bottom) / 2;
                        }
                        const M = p / e.unitInPixels, P = g / e.unitInPixels, L = P - M;
                        let w = Math.min(L - 2 * this.rules.TremoloBetweenNotesXPadding, L * this.rules.TremoloBetweenNotesMaxLengthFactor);
                        if (w = Math.max(w, Math.min(1, L - .2)), w < .5) return f.default.debug("VexFlowMusicSheetDrawer.drawTremoloBetweenTwoNotes: not enough horizontal space to draw tremolo strokes."), n;
                        const A = (M + P) / 2, I = A - w / 2, R = A + w / 2, N = (b + S) / 2 / e.unitInPixels;
                        let C = (S - b) / e.unitInPixels;
                        const B = this.rules.TremoloBetweenNotesMaxSlant;
                        Math.abs(C) > B && (C = Math.sign(C) * B);
                        let D = N - C / 2, O = N + C / 2;
                        const F = Math.max(y - D, x - O), k = Math.min(E - D, v - O);
                        let V = 0;
                        V = F <= k ? Math.min(Math.max(0, F), k) : (F + k) / 2, D += V, O += V;
                        const G = this.rules.DefaultColorMusic;
                        for(let e = 0; e < t.strokes; e++){
                            const t = D - d / 2 + e * u, r = O - d / 2 + e * u, o = [
                                new a.PointF2D(I, t),
                                new a.PointF2D(R, r),
                                new a.PointF2D(R, r + c),
                                new a.PointF2D(I, t + c),
                                new a.PointF2D(I, t)
                            ], l = `tremoloBetweenNotes-${s.MeasureNumber}-${s.ParentStaff.Id}-${n}`;
                            this.DrawPath(o, i.ParentMusicPage, !0, l, G), n++;
                        }
                        const W = o.SkyBottomLineCalculator, U = o.PositionAndShape.AbsolutePosition;
                        return W.mergeSkyLineWithLine(new a.PointF2D(I - U.x, D - d / 2 - U.y), new a.PointF2D(R - U.x, O - d / 2 - U.y)), W.mergeBottomLineWithLine(new a.PointF2D(I - U.x, D + d / 2 - U.y), new a.PointF2D(R - U.x, O + d / 2 - U.y)), n;
                    }
                    drawLine(t, i, s = "#000000FF", n = .2) {
                        return t = this.applyScreenTransformation(t), i = this.applyScreenTransformation(i), this.backend.renderLine(t, i, s, n * e.unitInPixels);
                    }
                    DrawOverlayLine(t, i, s, n = "#FF0000FF", r = .2, o) {
                        if (!s.PageNumber || s.PageNumber > this.backends.length || s.PageNumber < 1) return void console.log("VexFlowMusicSheetDrawer.drawOverlayLine: invalid page number / music page number doesn't correspond to an existing backend.");
                        const a = s.PageNumber - 1, l = this.backends[a];
                        return t = this.applyScreenTransformation(t), i = this.applyScreenTransformation(i), o || (o = `overlayLine ${t.x}/${t.y}`), l.renderLine(t, i, n, r * e.unitInPixels, o);
                    }
                    DrawPath(t, e, i = !0, s, n) {
                        const r = e.PageNumber - 1, o = this.backends[r], a = [];
                        for (const e of t)a.push(this.applyScreenTransformation(e));
                        return o.renderPath(a, i, s, n);
                    }
                    drawSkyLine(t) {
                        const e = t.PositionAndShape.AbsolutePosition, i = t.PositionAndShape.Size.width;
                        this.drawSampledLine(t.SkyLine, e, i);
                    }
                    drawBottomLine(t) {
                        const e = new a.PointF2D(t.PositionAndShape.AbsolutePosition.x, t.PositionAndShape.AbsolutePosition.y), i = t.PositionAndShape.Size.width;
                        this.drawSampledLine(t.BottomLine, e, i, "#0000FFFF");
                    }
                    drawSampledLine(t, e, i, s = "#FF0000FF") {
                        const n = [];
                        let r = 0;
                        for(let e = 0; e < t.length; e++)t[e] !== r && (n.push(e), r = t[e]);
                        const o = e;
                        if (n.length > 0) {
                            const e = this.rules.SamplingUnit;
                            let r, l, h = new a.PointF2D(o.x, o.y), c = new a.PointF2D(n[0] / e + o.x, o.y);
                            this.drawLine(h, c, s), t[0] >= 0 && (r = new a.PointF2D(n[0] / e + o.x, o.y), l = new a.PointF2D(n[0] / e + o.x, o.y + t[n[0]]), this.drawLine(r, l, s));
                            for(let i = 1; i < n.length; i++)h = new a.PointF2D(n[i - 1] / e + o.x, o.y + t[n[i - 1]]), c = new a.PointF2D(n[i] / e + o.x, o.y + t[n[i - 1]]), this.drawLine(h, c, s), r = new a.PointF2D(n[i] / e + o.x, o.y + t[n[i - 1]]), l = new a.PointF2D(n[i] / e + o.x, o.y + t[n[i]]), this.drawLine(r, l, s);
                            n[n.length - 1] < t.length ? (h = new a.PointF2D(n[n.length - 1] / e + o.x, o.y + t[n[n.length - 1]]), c = new a.PointF2D(o.x + i, o.y + t[n[n.length - 1]]), this.drawLine(h, c, s)) : (h = new a.PointF2D(n[n.length - 1] / e + o.x, o.y), c = new a.PointF2D(o.x + i, o.y), this.drawLine(h, c, s));
                        } else {
                            const t = new a.PointF2D(o.x, o.y), e = new a.PointF2D(o.x + i, o.y);
                            this.drawLine(t, e, s);
                        }
                    }
                    drawStaffEntry(t) {
                        if (t.FingeringEntries.length > 0) for (const e of t.FingeringEntries)e.SVGNode = this.drawLabel(e, h.GraphicalLayers.Notes);
                        if (void 0 !== t.graphicalChordContainers && t.graphicalChordContainers.length > 0) for (const e of t.graphicalChordContainers){
                            const t = e.GraphicalLabel;
                            t.SVGNode = this.drawLabel(t, h.GraphicalLayers.Notes);
                        }
                        this.rules.RenderLyrics && t.LyricsEntries.length > 0 && this.drawLyrics(t.LyricsEntries, h.GraphicalLayers.Notes);
                    }
                    drawLyrics(t, e) {
                        t.forEach((t)=>{
                            const i = t.GraphicalLabel;
                            i.Label.colorDefault = this.rules.DefaultColorLyrics, i.SVGNode = this.drawLabel(i, e), i.SVGNode?.classList.add("lyrics");
                        });
                    }
                    drawInstrumentBrace(t, e) {
                        if (!this.lazyDrawsLeftEdgeOnce()) return;
                        const i = this.backend.getContext();
                        i.openGroup("brace"), t.draw(i), i.closeGroup();
                    }
                    drawGroupBracket(t, e) {
                        if (!this.lazyDrawsLeftEdgeOnce()) return;
                        const i = this.backend.getContext();
                        i.openGroup("bracket"), t.draw(i), i.closeGroup();
                    }
                    lazyDrawsSpanToMeasure(t) {
                        return this.LazyDrawFromXUnits === Number.NEGATIVE_INFINITY && this.LazyDrawToXUnits === Number.POSITIVE_INFINITY || !t || this.lazyDrawsObject(t.PositionAndShape);
                    }
                    drawOctaveShifts(t) {
                        for (const e of t.OctaveShifts)if (e) {
                            if (!this.lazyDrawsSpanToMeasure(e.endMeasure)) continue;
                            const t = e, i = this.backend.getContext(), s = t.getTextBracket();
                            this.rules.DefaultColorMusic && (s.render_options.color = this.rules.DefaultColorMusic), S.VexFlowConverter.setVexFlowTextFontFamily(s.font, this.rules), s.setContext(i);
                            try {
                                s.draw();
                            } catch (t) {
                                f.default.warn(t);
                            }
                        }
                    }
                    drawPedals(t) {
                        for (const e of t.Pedals)if (e) {
                            const t = e;
                            if (!this.lazyDrawsSpanToMeasure(t.endMeasure)) continue;
                            const i = this.backend.getContext(), s = t.getPedalMarking();
                            s.render_options.color = this.rules.DefaultColorMusic, s.setContext(i), s.draw();
                        }
                    }
                    drawWavyLines(t) {
                        for (const e of t.WavyLines)if (e) {
                            const t = e, i = t.endVfVoiceEntry?.parentStaffEntry?.parentMeasure;
                            if (!this.lazyDrawsSpanToMeasure(i)) continue;
                            const s = this.backend.getContext(), n = t.getVibratoBracket();
                            n.setContext(s), n.draw();
                        }
                    }
                    drawExpressions(t) {
                        for (const e of t.AbstractExpressions)if (e instanceof d.GraphicalInstantaneousDynamicExpression) this.drawInstantaneousDynamic(e);
                        else if (e instanceof u.GraphicalInstantaneousTempoExpression) {
                            if (e.SourceExpression.parentMeasure?.MeasureNumber <= 1 && !this.rules.RenderFirstTempoExpression) continue;
                            const t = e.GraphicalLabel;
                            t.SVGNode = this.drawLabel(t, h.GraphicalLayers.Notes);
                        } else if (e instanceof m.GraphicalContinuousDynamicExpression) this.drawContinuousDynamic(e);
                        else if (e instanceof g.GraphicalUnknownExpression) {
                            const t = e.Label;
                            t.SVGNode = this.drawLabel(t, h.GraphicalLayers.Notes);
                        } else f.default.warn("Unkown type of expression!");
                    }
                    drawInstantaneousDynamic(t) {
                        const e = t.Label;
                        e.SVGNode = this.drawLabel(e, h.GraphicalLayers.Notes);
                    }
                    drawContinuousDynamic(t) {
                        if (t.IsVerbal) {
                            const e = t.Label;
                            e.SVGNode = this.drawLabel(e, h.GraphicalLayers.Notes);
                        } else {
                            if (!this.lazyDrawsSpanToMeasure(t.EndMeasure)) return;
                            for (const e of t.Lines){
                                const i = new a.PointF2D(t.ParentStaffLine.PositionAndShape.AbsolutePosition.x + e.Start.x, t.ParentStaffLine.PositionAndShape.AbsolutePosition.y + e.Start.y), s = new a.PointF2D(t.ParentStaffLine.PositionAndShape.AbsolutePosition.x + e.End.x, t.ParentStaffLine.PositionAndShape.AbsolutePosition.y + e.End.y);
                                e.SVGElement = this.drawLine(i, s, e.colorHex ?? "#000000", e.Width);
                            }
                        }
                    }
                    renderLabel(t, i, s, n, r, o) {
                        if (!t.Label.print) return;
                        const l = t.Label.fontHeight * e.unitInPixels, { font: h } = t.Label;
                        let c;
                        this.rules.ColoringEnabled && (c = t.Label.colorDefault, t.ColorXML && (c = t.ColorXML), c || (c = this.rules.DefaultColorLabel));
                        let u, { fontStyle: d, fontFamily: f } = t.Label;
                        d || (d = this.rules.DefaultFontStyle), f || (f = this.rules.DefaultFontFamily);
                        for(let e = 0; e < t.TextLines?.length; e++){
                            const i = t.TextLines[e], s = this.calculatePixelDistance(i.xOffset), n = new a.PointF2D(o.x + s, o.y), f = this.backend.renderText(l, d, h, i.text, r, n, c, t.Label.fontFamily, t.Label.language);
                            u ? u.appendChild(f) : u = f, o.y = o.y + r, t.TextLines.length > 1 && (o.y += this.rules.SpacingBetweenTextLines);
                        }
                        return u;
                    }
                    renderRectangle(t, e, i, s, n) {
                        return this.backend.renderRectangle(t, i, s, n);
                    }
                    applyScreenTransformation(t) {
                        return new a.PointF2D(t.x * e.unitInPixels, t.y * e.unitInPixels);
                    }
                    applyScreenTransformationForRect(t) {
                        return new o.RectangleF2D(t.x * e.unitInPixels, t.y * e.unitInPixels, t.width * e.unitInPixels, t.height * e.unitInPixels);
                    }
                }
                e.VexFlowMusicSheetDrawer = y;
            },
            4332 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.VexFlowMusicSystem = void 0;
                const s = i(5221), n = i(6954), r = i(67), o = i(4284), a = i(6014), l = i(3109), h = i(7098);
                class c extends s.MusicSystem {
                    constructor(t, e){
                        super(t), this.rules = e;
                    }
                    calculateBorders(t) {
                        if (0 === this.staffLines.length) return;
                        const e = this.calcBracketsWidth();
                        this.boundingBox.BorderLeft = -e, this.boundingBox.BorderMarginLeft = -e, this.boundingBox.XBordersHaveBeenSet = !0;
                        const i = this.staffLines[0].SkyBottomLineCalculator.getSkyLineMin();
                        this.boundingBox.BorderTop = i, this.boundingBox.BorderMarginTop = i;
                        const s = this.staffLines[this.staffLines.length - 1], n = s.SkyBottomLineCalculator.getBottomLineMax() + s.PositionAndShape.RelativePosition.y;
                        this.boundingBox.BorderBottom = n, this.boundingBox.BorderMarginBottom = n, this.boundingBox.XBordersHaveBeenSet = !0, this.boundingBox.YBordersHaveBeenSet = !0;
                    }
                    createSystemLine(t, e, i, s, l, h, c) {
                        const u = h;
                        let d = !1;
                        if (c) {
                            d = !0, c.addMeasureLine(i, s), u && u.addMeasureLine(i, s, d);
                            let t = 0;
                            if (i === n.SystemLinesEnum.BoldThinDots && s === r.SystemLinePosition.MeasureBegin && h.beginInstructionsWidth > 0 && (t = u.getVFStave().getModifierXShift(0)), c.lineTo(h, a.VexFlowConverter.line(i, s), t), i === n.SystemLinesEnum.DotsBoldBoldDots) {
                                const t = c.ParentStaffLine.Measures.indexOf(c) + 1, e = c.ParentStaffLine.Measures[t], i = h.ParentStaffLine.Measures[t];
                                e && i && (e.lineTo(i, a.VexFlowConverter.line(n.SystemLinesEnum.BoldThinDots, s)), e.addMeasureLine(n.SystemLinesEnum.BoldThinDots, s));
                            }
                        } else u && u.addMeasureLine(i, s, d);
                        return new o.SystemLine(i, s, this, h, c);
                    }
                    createInstrumentBracket(t, e) {
                        const i = t, s = e, n = new h.VexFlowInstrumentBrace(i, s);
                        this.InstrumentBrackets.push(n);
                    }
                    createGroupBracket(t, e, i) {
                        const s = t, n = e;
                        if (0 === i) {
                            const t = new l.VexFlowInstrumentBracket(s, n, i);
                            this.GroupBrackets.push(t);
                        } else {
                            const t = new h.VexFlowInstrumentBrace(s, n, i);
                            this.GroupBrackets.push(t);
                        }
                    }
                }
                e.VexFlowMusicSystem = c;
            },
            9310 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.VexFlowOctaveShift = void 0;
                var n = s(i(3206)).default.Flow;
                const r = i(2768), o = i(437), a = s(i(3065));
                class l extends r.GraphicalOctaveShift {
                    constructor(t, e){
                        switch(super(t, e), t.Type){
                            case o.OctaveEnum.VA8:
                                this.position = n.TextBracket.Positions.TOP, this.supscript = "va", this.text = "8";
                                break;
                            case o.OctaveEnum.MA15:
                                this.position = n.TextBracket.Positions.TOP, this.supscript = "ma", this.text = "15";
                                break;
                            case o.OctaveEnum.VB8:
                                this.position = n.TextBracket.Positions.BOTTOM, this.supscript = "vb", this.text = "8";
                                break;
                            case o.OctaveEnum.MB15:
                                this.position = n.TextBracket.Positions.BOTTOM, this.supscript = "mb", this.text = "15";
                                break;
                            default:
                                a.default.error("Unknown or NONE octaveshift. This should not be called!");
                        }
                    }
                    setStartNote(t) {
                        for (const e of t.graphicalVoiceEntries){
                            const t = e;
                            if (t?.vfStaveNote) return this.startNote = t.vfStaveNote, !0;
                        }
                        return !1;
                    }
                    setEndNote(t, e = -1) {
                        const i = t.graphicalVoiceEntries;
                        for(let s = (e >= 0 ? Math.min(e, i.length) : i.length) - 1; s >= 0; s--){
                            const e = i[s];
                            if (e?.vfStaveNote) return this.endNote = e.vfStaveNote, this.endMeasure = t.parentMeasure, this.endMeasure?.parentSourceMeasure.Rules.OctaveShiftOnWholeMeasureNoteUntilEndOfMeasure && e.notes[0].sourceNote.isWholeMeasureNote() && (this.graphicalEndAtMeasureEnd = !0), !0;
                        }
                        return !1;
                    }
                    getTextBracket() {
                        let t, e = this.endNote;
                        const i = this;
                        this.graphicalEndAtMeasureEnd && (t = {
                            getAbsoluteX: ()=>10 * (i.endMeasure.PositionAndShape.AbsolutePosition.x + i.endMeasure.PositionAndShape.Size.width),
                            getGlyph: ()=>({
                                    getWidth: ()=>0
                                })
                        }), t && (e = t);
                        const s = new n.TextBracket({
                            position: this.position,
                            start: this.startNote,
                            stop: e,
                            superscript: this.supscript,
                            text: this.text
                        });
                        return this.endsOnDifferentStaffLine && (s.render_options.show_bracket = !1), s;
                    }
                }
                e.VexFlowOctaveShift = l;
            },
            7109 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.VexFlowPedal = void 0;
                const n = s(i(3206)), r = i(6438), o = i(7824), a = i(512);
                class l extends o.GraphicalPedal {
                    constructor(t, e, i = !1, s = !1){
                        switch(super(t, e), this.vfStyle = n.default.Flow.PedalMarking.Styles.BRACKET, this.ChangeBegin = !1, this.ChangeEnd = !1, this.line = -3, this.EndSymbolPositionAndShape = void 0, this.ChangeBegin = t.ChangeBegin, this.ChangeEnd = t.ChangeEnd, this.pedalSymbol){
                            case a.MusicSymbol.PEDAL_SYMBOL:
                                this.vfStyle = n.default.Flow.PedalMarking.Styles.TEXT, this.EndSymbolPositionAndShape = new r.BoundingBox(this, e);
                                break;
                            case a.MusicSymbol.PEDAL_MIXED:
                                this.vfStyle = i && s ? n.default.Flow.PedalMarking.Styles.BRACKET_OPEN_BOTH : i ? n.default.Flow.PedalMarking.Styles.BRACKET_OPEN_BEGIN : s ? n.default.Flow.PedalMarking.Styles.MIXED_OPEN_END : n.default.Flow.PedalMarking.Styles.MIXED;
                                break;
                            case a.MusicSymbol.PEDAL_BRACKET:
                            default:
                                this.vfStyle = i && s ? n.default.Flow.PedalMarking.Styles.BRACKET_OPEN_BOTH : i ? n.default.Flow.PedalMarking.Styles.BRACKET_OPEN_BEGIN : s ? n.default.Flow.PedalMarking.Styles.BRACKET_OPEN_END : n.default.Flow.PedalMarking.Styles.BRACKET;
                        }
                    }
                    setStartNote(t) {
                        if (!t) return !1;
                        for (const e of t.graphicalVoiceEntries){
                            const t = e;
                            if (t?.vfStaveNote) return this.startNote = t.vfStaveNote, this.startVfVoiceEntry = t, !0;
                        }
                        return !1;
                    }
                    setEndNote(t) {
                        if (!t) return !1;
                        for (const e of t.graphicalVoiceEntries){
                            const t = e;
                            if (t?.vfStaveNote) return this.endNote = t.vfStaveNote, this.endVfVoiceEntry = t, !0;
                        }
                        return !1;
                    }
                    setEndMeasure(t) {
                        this.endMeasure = t;
                    }
                    CalculateBoundingBox() {}
                    setLine(t) {
                        this.line = t;
                    }
                    getPedalMarking() {
                        const t = new n.default.Flow.PedalMarking([
                            this.startNote,
                            this.endNote
                        ]);
                        return this.endMeasure && t.setEndStave(this.endMeasure.getVFStave()), t.setStyle(this.vfStyle), t.setLine(this.line), t.setCustomText(this.DepressText, this.ReleaseText), this.endVfVoiceEntry && !this.getPedal.EndsStave || (t.EndsStave = !0), this.getPedal.BeginsStave && (t.BeginsStave = !0), t.ChangeBegin = this.ChangeBegin, t.ChangeEnd = this.ChangeEnd, t;
                    }
                    setEndsStave(t, e) {
                        e?.gte(t.parentSourceMeasure.Duration) && (this.getPedal.EndsStave = !0);
                    }
                    setBeginsStave(t, e) {
                        t && 0 === e.RealValue && (this.getPedal.BeginsStave = !0);
                    }
                }
                e.VexFlowPedal = l;
            },
            5468 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.VexFlowSlur = e.CurvePositionEnum = void 0;
                var n, r = s(i(3206)).default.Flow;
                !function(t) {
                    t[t.NEAR_HEAD = 1] = "NEAR_HEAD", t[t.NEAR_TOP = 2] = "NEAR_TOP";
                }(n || (e.CurvePositionEnum = n = {}));
                class o {
                    constructor(t){
                        this.vfStartNote = void 0, this.vfEndNote = void 0, this.parentSlur = t;
                    }
                    static createFromVexflowSlur(t) {
                        return new o(t.parentSlur);
                    }
                    get vfSlur() {
                        return this.parentSlur;
                    }
                    curve_Options() {
                        return {
                            cps: [
                                {
                                    x: 0,
                                    y: 10
                                },
                                {
                                    x: 0,
                                    y: 10
                                }
                            ],
                            invert: !1,
                            position: n.NEAR_TOP,
                            position_end: n.NEAR_TOP,
                            spacing: 2,
                            thickness: 2,
                            x_shift: 0,
                            y_shift: 10
                        };
                    }
                    createVexFlowCurve() {
                        this.vfCurve = new r.Curve(this.vfStartNote, this.vfEndNote, void 0);
                    }
                }
                e.VexFlowSlur = o;
            },
            6670 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.VexFlowStaffEntry = void 0;
                var n = s(i(3206)).default.Flow;
                const r = i(348), o = i(9479), a = i(8233);
                class l extends r.GraphicalStaffEntry {
                    constructor(t, e, i){
                        super(t, e, i), this.vfKeys = [];
                    }
                    calculateXPosition() {
                        const t = this.parentMeasure.getVFStave();
                        0 === this.graphicalVoiceEntries.length && this.vfInStaffInstructionNote && (this.PositionAndShape.RelativePosition.x = this.vfInStaffInstructionNote.getAbsoluteX() / o.unitInPixels, this.PositionAndShape.BorderLeft = -this.vfInStaffInstructionNote.getWidth() / o.unitInPixels);
                        let e = 0;
                        const i = this.graphicalVoiceEntries.every((t)=>t.parentVoiceEntry?.GraceAfterMainNote || t.isStandAloneGrace) ? this.graphicalVoiceEntries[0] : void 0, s = [];
                        for (const r of this.graphicalVoiceEntries)if (r.vfStaveNote) {
                            if (r.vfStaveNote.setStave(t), !r.vfStaveNote.preFormatted) continue;
                            if (r.parentVoiceEntry?.IsGrace && r !== i) {
                                s.push(r);
                                continue;
                            }
                            r.applyBordersFromVexflow();
                            let a = !1, l = this.PositionAndShape;
                            r.notes[0].sourceNote.isWholeRest() && !this.hasOnlyRests() && (a = !0, l = r.PositionAndShape), this.parentMeasure.ParentStaff.isTab ? l.RelativePosition.x = (r.vfStaveNote.getAbsoluteX() + r.vfStaveNote.glyph.getWidth()) / o.unitInPixels : (l.RelativePosition.x = r.vfStaveNote.getBoundingBox().getX() / o.unitInPixels, a && (l.RelativePosition.x -= t.getNoteStartX() / o.unitInPixels, l.RelativePosition.x -= 1.3));
                            const h = r.notes[0].sourceNote;
                            h.isRest() && h.Length.RealValue === this.parentMeasure.parentSourceMeasure.ActiveTimeSignature.RealValue && (r.vfStaveNote.isCenterAligned() && (l.RelativePosition.x += this.parentMeasure.parentSourceMeasure.Rules.WholeRestXShiftVexflow - .1), r.PositionAndShape.BorderLeft = -0.7, r.PositionAndShape.BorderRight = .7), !(r.vfStaveNote instanceof n.TabNote) && r.PositionAndShape.BorderLeft < e && (e = r.PositionAndShape.BorderLeft);
                        }
                        if (this.PositionAndShape.RelativePosition.x -= e, this.positionGraceEntries(s), this.positionNotesAtNoteHeads(), 0 === s.length) this.PositionAndShape.calculateBoundingBox();
                        else {
                            const t = this.PositionAndShape.ChildElements;
                            this.PositionAndShape.ChildElements = t.filter((t)=>!s.some((e)=>e.PositionAndShape === t)), this.PositionAndShape.calculateBoundingBox(), this.PositionAndShape.ChildElements = t;
                        }
                    }
                    positionGraceEntries(t) {
                        if (0 === t.length) return;
                        for (const t of this.graphicalVoiceEntries){
                            const e = t.vfStaveNote;
                            if (e?.preFormatted) for (const t of e.modifiers ?? [])t instanceof n.GraceNoteGroup && t.alignSubNotesWithNote(t.getGraceNotes(), e);
                        }
                        const e = this.parentMeasure.ParentStaff.isTab;
                        for (const i of t){
                            let t;
                            e ? t = (i.vfStaveNote.getAbsoluteX() + i.vfStaveNote.glyph.getWidth()) / o.unitInPixels : (i.applyBordersFromVexflow(), t = i.vfStaveNote.getBoundingBox().getX() / o.unitInPixels - i.PositionAndShape.BorderLeft), i.PositionAndShape.RelativePosition.x = t - this.PositionAndShape.RelativePosition.x;
                        }
                    }
                    positionNotesAtNoteHeads() {
                        const t = [];
                        for (const e of this.graphicalVoiceEntries){
                            e.noteHeadsCenterX = void 0;
                            const i = e.vfStaveNote;
                            if (!i?.preFormatted) continue;
                            const s = this.PositionAndShape.RelativePosition.x + e.PositionAndShape.RelativePosition.x;
                            let n;
                            for (const r of e.notes){
                                const a = r.sourceNote.isRest() ? void 0 : l.drawnHead(i, r);
                                void 0 !== a && (r.PositionAndShape.RelativePosition.x = (a.x + a.width / 2) / o.unitInPixels - s, i.note_heads?.[r.vfnoteIndex]?.isDisplaced() || (n || (n = {
                                    gve: e,
                                    voiceEntryX: s,
                                    left: a.x,
                                    width: a.width
                                }, t.push(n)), n.width = Math.max(n.width, a.width)));
                            }
                        }
                        for (const e of t){
                            let i = e.width;
                            for (const s of t)Math.abs(s.left - e.left) < 1 && (i = Math.max(i, s.width));
                            e.gve.noteHeadsCenterX = (e.left + i / 2) / o.unitInPixels - e.voiceEntryX;
                        }
                    }
                    static drawnHead(t, e) {
                        if (t instanceof n.TabNote) return {
                            x: t.getAbsoluteX(),
                            width: t.glyph.getWidth()
                        };
                        const i = t.note_heads?.[e.vfnoteIndex];
                        return i ? (i.setX(t.getNoteHeadBeginX()), {
                            x: i.getAbsoluteX(),
                            width: i.getWidth()
                        }) : void 0;
                    }
                    setMaxAccidentals() {
                        for (const t of this.graphicalVoiceEntries)for (const e of t.notes)if (e.DrawnAccidental !== a.AccidentalEnum.NONE) return this.MaxAccidentals = 1;
                        return this.MaxAccidentals = 0;
                    }
                    setModifierXOffsets() {
                        const t = [];
                        for (const e of this.graphicalVoiceEntries)e.parentVoiceEntry?.IsGrace ? this.applyModifierOffsets(e.notes) : t.push(...e.notes);
                        this.applyModifierOffsets(t);
                    }
                    applyModifierOffsets(t) {
                        if (0 === t.length) return;
                        const e = t.map((t)=>t.staffLine), i = this.calculateModifierXOffsets(e, .5), s = this.calculateModifierXOffsets(e, 1);
                        t.forEach((t, e)=>{
                            t.baseFingeringXOffset = i[e], t.baseStringNumberXOffset = s[e];
                        });
                    }
                    calculateModifierXOffsets(t, e) {
                        const i = [];
                        for(let s = 0; s < t.length; s++){
                            let n = 0, r = !0;
                            for(; r;)for(let o = s; o >= 0; o--){
                                if (Math.abs(t[s] - t[o]) <= e && n === i[o]) {
                                    n++, r = !0;
                                    break;
                                }
                                r = !1;
                            }
                            i.push(n);
                        }
                        return i;
                    }
                }
                e.VexFlowStaffEntry = l;
            },
            5866 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.VexFlowStaffLine = void 0;
                const s = i(2919), n = i(1083);
                class r extends s.StaffLine {
                    constructor(t, e){
                        super(t, e), this.slursInVFStaffLine = [], this.alignmentManager = new n.AlignmentManager(this);
                    }
                    get SlursInVFStaffLine() {
                        return this.slursInVFStaffLine;
                    }
                    addVFSlurToVFStaffline(t) {
                        this.slursInVFStaffLine.push(t);
                    }
                    get AlignmentManager() {
                        return this.alignmentManager;
                    }
                }
                e.VexFlowStaffLine = r;
            },
            6173 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.VexFlowTabMeasure = void 0;
                var n = s(i(3206)).default.Flow;
                const r = i(5246), o = i(6014), a = s(i(3065)), l = i(164);
                class h extends r.VexFlowMeasure {
                    constructor(t, e, i){
                        super(t, e, i), this.isTabMeasure = !0;
                    }
                    resetLayout() {
                        const t = this.ParentStaff.StafflineCount ?? 6;
                        this.stave = new n.TabStave(0, 0, 0, {
                            space_above_staff_ln: 0,
                            space_below_staff_ln: 0,
                            num_lines: t
                        }), this.updateInstructionWidth();
                    }
                    graphicalMeasureCreatedCalculations() {
                        for(let t = 0, e = this.staffEntries.length; t < e; ++t){
                            const e = this.staffEntries[t];
                            let i = [], s = !1;
                            for (const t of e.graphicalVoiceEntries){
                                const e = t.notes[0].sourceNote.isRest();
                                if (e) {
                                    const e = o.VexFlowConverter.GhostNotes(t.notes[0].sourceNote.Length);
                                    t.vfStaveNote = e[0], t.vfGhostNotes = e;
                                } else t.vfStaveNote = o.VexFlowConverter.CreateTabNote(t);
                                if (t.parentVoiceEntry.IsGrace) {
                                    if (t.parentVoiceEntry.GraceAfterMainNote) continue;
                                    i.push(t), s = s || t.parentVoiceEntry.GraceSlur;
                                } else if (i.length > 0) {
                                    if (e) for (const t of i)t.isStandAloneGrace = !0;
                                    else {
                                        const e = i.map((t)=>t.vfStaveNote), r = new n.GraceNoteGroup(e, s);
                                        t.vfStaveNote.addModifier(r, 0);
                                    }
                                    i = [], s = !1;
                                }
                            }
                            for (const t of i)t.isStandAloneGrace = !0;
                        }
                        this.finalizeTuplets();
                        const t = this.getVoicesWithinMeasure();
                        for (const e of t){
                            if (!e) continue;
                            this.vfVoices[e.VoiceId] = new n.Voice({
                                beat_value: this.parentSourceMeasure.Duration.Denominator,
                                num_beats: this.parentSourceMeasure.Duration.Numerator,
                                resolution: n.RESOLUTION
                            }).setMode(n.Voice.Mode.SOFT);
                            const t = this.getRestFilledVexFlowStaveNotesPerVoice(e);
                            for (const i of t){
                                if (i.parentVoiceEntry && i.parentVoiceEntry.IsGrace && !i.parentVoiceEntry.GraceAfterMainNote && !i.isStandAloneGrace) continue;
                                const t = i;
                                if (0 !== i.notes.length && i.notes[0] && i.notes[0].sourceNote.PrintObject) {
                                    if (i.parentVoiceEntry && i.parentVoiceEntry.Arpeggio) {
                                        const e = i.parentVoiceEntry.Arpeggio;
                                        if (i.notes && i.notes.length > 1) {
                                            const i = o.VexFlowConverter.StrokeTypeFromArpeggioType(e.type), s = new n.Stroke(i, {
                                                all_voices: this.rules.ArpeggiosGoAcrossVoices
                                            });
                                            this.rules.RenderArpeggios && t.vfStaveNote.addStroke(0, s);
                                        } else a.default.debug(`[OSMD] arpeggio in measure ${this.MeasureNumber} could not be drawn.\n                        voice entry had less than two notes, arpeggio is likely between voice entries, not currently supported in Vexflow.`);
                                    }
                                    if (t.vfGhostNotes) for (const i of t.vfGhostNotes)this.vfVoices[e.VoiceId].addTickable(i);
                                    else this.vfVoices[e.VoiceId].addTickable(t.vfStaveNote);
                                } else if (t.vfGhostNotes) for (const i of t.vfGhostNotes)this.vfVoices[e.VoiceId].addTickable(i);
                                else this.vfVoices[e.VoiceId].addTickable(t.vfStaveNote);
                            }
                        }
                        this.createInStaffInstructionVoice();
                    }
                    addClefAtBegin(t) {
                        t.ClefType === l.ClefEnum.TAB && super.addClefAtBegin(t);
                    }
                    draw(t) {
                        super.draw(t);
                        const e = this.parentSourceMeasure;
                        e.multipleRestMeasures && this.rules.RenderMultipleRestMeasures && (this.multiRestElement = new n.MultiMeasureRest(e.multipleRestMeasures, {}), this.multiRestElement.setStave(this.stave), this.multiRestElement.setContext(t), this.multiRestElement.draw());
                    }
                }
                e.VexFlowTabMeasure = h;
            },
            7785 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.VexFlowTextMeasurer = void 0;
                const s = i(6014);
                e.VexFlowTextMeasurer = class {
                    constructor(t){
                        this.fontSize = 20, this.fontSizeStandard = this.fontSize;
                        const e = document.createElement("canvas");
                        this.context = e.getContext("2d"), this.rules = t;
                    }
                    computeTextWidthToHeightRatio(t, e, i, n, r = this.fontSize) {
                        return this.context.font = s.VexFlowConverter.font(r, i, e, this.rules, n), this.context.measureText(t).width / r;
                    }
                    computeTextWidthInCssFont(t, e) {
                        return this.context.font = e, this.context.measureText(t).width;
                    }
                    setFontSize(t = this.fontSizeStandard) {
                        return this.fontSize = t, t;
                    }
                };
            },
            2907 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.VexFlowVibratoBracket = void 0;
                const n = i(7753), r = s(i(3206));
                class o extends n.GraphicalWavyLine {
                    get ToEndOfStopStave() {
                        return this.toEndOfStopStave;
                    }
                    constructor(t, e, i = !1){
                        super(t, e), this.line = 1, this.isVibrato = !1, this.toEndOfStopStave = !1, this.isVibrato = i;
                    }
                    setStartNote(t) {
                        const e = this.findNoteVoiceEntry(t);
                        return !!e && (this.startNote = e.vfStaveNote, this.startVfVoiceEntry = e, !0);
                    }
                    setEndNote(t) {
                        const e = this.findNoteVoiceEntry(t);
                        if (!e) return !1;
                        this.endNote = e.vfStaveNote, this.endVfVoiceEntry = e;
                        const i = e.parentStaffEntry.parentMeasure.staffEntries, s = i[i.length - 1];
                        return this.toEndOfStopStave = s === e.parentStaffEntry, !0;
                    }
                    coverEndNoteDuration() {
                        this.nextVfVoiceEntry = this.findNextVoiceEntryInVoice(this.endVfVoiceEntry), this.toEndOfStopStave = !this.nextVfVoiceEntry;
                    }
                    findNextVoiceEntryInVoice(t) {
                        const e = t.parentStaffEntry.parentMeasure.staffEntries;
                        let i = !1;
                        for(let s = e.indexOf(t.parentStaffEntry); s < e.length; s++)for (const n of e[s].graphicalVoiceEntries){
                            if (n === t) {
                                i = !0;
                                continue;
                            }
                            const e = n.parentVoiceEntry.IsGrace && !n.parentVoiceEntry.GraceAfterMainNote && !n.isStandAloneGrace;
                            if (i && n.vfStaveNote && !e && n.parentVoiceEntry.ParentVoice === t.parentVoiceEntry.ParentVoice) return n;
                        }
                    }
                    findNoteVoiceEntry(t) {
                        if (!t) return;
                        let e;
                        for (const i of t.graphicalVoiceEntries){
                            const t = i;
                            if (t?.vfStaveNote) {
                                if (!t.parentVoiceEntry.IsGrace) return t;
                                e ?? (e = t);
                            }
                        }
                        return e;
                    }
                    CalculateBoundingBox() {
                        const t = this.getVibratoBracket();
                        this.boundingBox.Size.height = .2 * t.render_options.wave_height;
                    }
                    getVibratoBracket() {
                        const t = new r.default.Flow.VibratoBracket({
                            start: this.startNote,
                            stop: this.endNote,
                            toEndOfStopStave: this.toEndOfStopStave,
                            stopBeforeNote: this.nextVfVoiceEntry?.vfStaveNote
                        });
                        return t.setLine(this.line), this.isVibrato ? t.render_options.vibrato_width = 20 : t.render_options.wave_girth = 4, t;
                    }
                }
                e.VexFlowVibratoBracket = o;
            },
            4134 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.VexFlowVoiceEntry = void 0;
                const s = i(4548), n = i(9479), r = i(4434), o = i(4064);
                class a extends s.GraphicalVoiceEntry {
                    constructor(t, e, i){
                        super(t, e, i), this.isStandAloneGrace = !1;
                    }
                    applyBordersFromVexflow() {
                        const t = this.vfStaveNote;
                        if (!t.getNoteHeadBeginX) return;
                        const e = t.getBoundingBox(), i = t.getNoteHeadBeginX() - e.x;
                        this.PositionAndShape.RelativePosition.y = e.y / n.unitInPixels, this.applyVerticalBordersFromVexflow(e);
                        const s = (t.width - (t.paddingRight ?? 0)) / 2;
                        this.PositionAndShape.BorderLeft = -(i + s) / n.unitInPixels, this.PositionAndShape.BorderRight = (e.w - i) / n.unitInPixels;
                    }
                    applyVerticalBordersFromVexflow(t, e = 0) {
                        const i = (t.y - e) / n.unitInPixels - this.PositionAndShape.RelativePosition.y;
                        this.PositionAndShape.BorderTop = i, this.PositionAndShape.BorderBottom = i + t.h / n.unitInPixels;
                    }
                    set vfStaveNote(t) {
                        this.mVexFlowStaveNote = t;
                    }
                    get vfStaveNote() {
                        return this.mVexFlowStaveNote;
                    }
                    applyCustomNoteheads() {
                        const t = this.vfStaveNote;
                        if (t) for(let e = 0; e < this.notes.length; e++){
                            const i = this.notes[e].sourceNote;
                            t.note_heads && i.CustomNoteheadVFCode && (t.note_heads[e].glyph_code = i.CustomNoteheadVFCode);
                        }
                    }
                    drawnAsSharedUnisonNote(t) {
                        return this.inDrawnBeam && t.sharesNoteheadWithVisibleUnisonNote();
                    }
                    get inDrawnBeam() {
                        return Boolean(this.vfStaveNote?.beam);
                    }
                    overprintsSharedHeadOfOtherShape(t, e) {
                        const i = this.vfStaveNote, s = this.rules.GNote(e), n = s?.parentVoiceEntry?.vfStaveNote, r = i?.note_heads?.[t], o = n?.note_heads?.[s.parentVoiceEntry.notes.indexOf(s)];
                        return !(!r || !o) && i.getXShift() === n.getXShift() && r.isDisplaced() === o.isDisplaced() && r.glyph_code !== o.glyph_code;
                    }
                    color() {
                        const t = this.rules.DefaultColorNotehead, e = this.rules.DefaultColorRest, i = this.rules.DefaultColorStem, s = "#00000000";
                        let n, a;
                        const l = this.vfStaveNote;
                        for(let i = 0; i < this.notes.length; i++){
                            const h = this.notes[i], c = this.inDrawnBeam ? h.sourceNote.visibleUnisonNoteSharingNotehead() : void 0, u = h.sourceNote.Notehead?.Shape !== o.NoteHeadShape.NONE && (h.sourceNote.PrintObject || void 0 !== c && !this.overprintsSharedHeadOfOtherShape(i, c));
                            if (a = (c ?? h.sourceNote).NoteheadColor, n = a, this.rules.ColoringMode === r.ColoringModes.AutoColoring || this.rules.ColoringMode === r.ColoringModes.CustomColorSet) {
                                if (h.sourceNote.isRest()) n = this.rules.ColoringSetCurrent.getValue(-1);
                                else {
                                    const t = h.sourceNote.Pitch.FundamentalNote;
                                    n = this.rules.ColoringSetCurrent.getValue(t);
                                }
                            }
                            if (u ? n && "#000000" !== n || (n = this.rules.DefaultColorNotehead) : n = s, !a && this.rules.ColoringMode === r.ColoringModes.XML && u && (!h.sourceNote.isRest() && t ? n = t : h.sourceNote.isRest() && e && (n = e)), n && u) h.sourceNote.NoteheadColorCurrentlyRendered = n;
                            else if (!n) continue;
                            if (this.rules.ColoringEnabled && h.sourceNote.NoteBeam && this.rules.ColorBeams) {
                                const t = h.sourceNote.NoteBeam.Notes;
                                let e = !0;
                                for(let i = 0; i < t.length; i++)t[i].NoteheadColorCurrentlyRendered !== n && (e = !1);
                                e && l?.beam?.setStyle && l.beam.setStyle({
                                    fillStyle: n,
                                    strokeStyle: n
                                });
                            }
                            if (l) {
                                if (l.note_heads) {
                                    const t = l.note_heads[i];
                                    t && t.setStyle({
                                        fillStyle: n,
                                        strokeStyle: n
                                    });
                                }
                                l.setLedgerLineStyle && (n === s ? l.setLedgerLineStyle({
                                    fillStyle: n,
                                    strokeStyle: n,
                                    lineWidth: this.rules.LedgerLineWidth
                                }) : l.setLedgerLineStyle({
                                    fillStyle: this.rules.LedgerLineColorDefault,
                                    lineWidth: this.rules.LedgerLineWidth,
                                    strokeStyle: this.rules.LedgerLineColorDefault
                                }));
                            }
                        }
                        let h = i, c = !1;
                        this.rules.ColoringEnabled && (h = this.parentVoiceEntry.StemColor, h && "#000000" !== h || (h = i), this.rules.ColorStemsLikeNoteheads && n && (h = n, c = !0));
                        let u = !0;
                        for (const t of this.parentVoiceEntry.Notes){
                            if (t.PrintObject && t.Notehead?.Shape !== o.NoteHeadShape.NONE) {
                                u = !1;
                                break;
                            }
                            if (this.drawnAsSharedUnisonNote(t)) {
                                u = !1;
                                break;
                            }
                        }
                        u && (h = s);
                        const d = {
                            fillStyle: h,
                            strokeStyle: h
                        };
                        l && l.setStemStyle && (!u && c && (this.parentVoiceEntry.StemColor = h), l.setStemStyle(d), l.flag && l.setFlagStyle && this.rules.ColorFlags && l.setFlagStyle(d));
                    }
                }
                e.VexFlowVoiceEntry = a;
            },
            7506 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.VexflowStafflineNoteCalculator = void 0;
                const s = i(8233), n = i(9635), r = i(3263), o = i(164), a = i(1336);
                class l {
                    constructor(t){
                        this.staffPitchListMapping = new r.Dictionary, this.baseLineNote = s.NoteEnum.B, this.baseLineOctave = 1, this.rules = t;
                    }
                    trackNote(t) {
                        if (!(t instanceof n.VexFlowGraphicalNote) || t.Clef().ClefType !== o.ClefEnum.percussion || t.sourceNote.isRest() || 0 === this.rules.PercussionOneLineCutoff || -1 === this.rules.PercussionForceVoicesOneLineCutoff) return;
                        const e = t.parentVoiceEntry.parentStaffEntry.sourceStaffEntry.ParentStaff.idInMusicSheet;
                        let i;
                        this.staffPitchListMapping.containsKey(e) || this.staffPitchListMapping.setValue(e, new Array), i = this.staffPitchListMapping.getValue(e);
                        const s = t.sourceNote.Pitch;
                        l.findOrInsert(i, s);
                    }
                    static PitchIndexOf(t, e, i = 0) {
                        if (i > t.length - 1) return -1;
                        for(let s = i; s < t.length; s++){
                            const i = t[s];
                            if (e.OperatorEquals(i)) return s;
                        }
                        return -1;
                    }
                    static findOrInsert(t, e) {
                        for(let i = 0; i < t.length; i++){
                            const s = t[i];
                            if (e.OperatorEquals(s)) return i;
                            if (e.OperatorFundamentalLessThan(s)) return t.splice(i, 0, e), i;
                        }
                        return t.push(e), t.length - 1;
                    }
                    positionNote(t) {
                        const e = t.parentVoiceEntry.parentStaffEntry.sourceStaffEntry.ParentStaff.idInMusicSheet;
                        if (!(t instanceof n.VexFlowGraphicalNote) || t.Clef().ClefType !== o.ClefEnum.percussion || t.sourceNote.isRest() || !this.staffPitchListMapping.containsKey(e)) return t;
                        const i = this.staffPitchListMapping.getValue(e), r = this.rules.PercussionUseXMLDisplayStep && void 0 !== t.sourceNote.displayStepUnpitched;
                        if (i.length > this.rules.PercussionOneLineCutoff && !r && !this.rules.PercussionUseCajon2NoteSystem) return t;
                        const h = t, c = t.sourceNote.Pitch;
                        let u = this.baseLineNote, d = this.baseLineOctave;
                        if (this.rules.PercussionUseCajon2NoteSystem ? c.FundamentalNote === s.NoteEnum.C && (u = s.NoteEnum.G, d = 1) : this.rules.PercussionUseXMLDisplayStep && void 0 !== t.sourceNote.displayStepUnpitched && (u = t.sourceNote.displayStepUnpitched, d = t.sourceNote.displayOctaveUnpitched + this.rules.PercussionOneLineXMLDisplayStepOctaveOffset), i.length <= this.rules.PercussionForceVoicesOneLineCutoff) h.setAccidental(new s.Pitch(u, d, c.Accidental));
                        else {
                            const t = l.PitchIndexOf(i, c);
                            if (t > -1) {
                                const e = Math.ceil(i.length / 2);
                                if (!this.rules.PercussionUseXMLDisplayStep) {
                                    if (t >= e) switch(d = 2, (t - e) % 5){
                                        case 1:
                                            u = s.NoteEnum.E;
                                            break;
                                        case 2:
                                            u = s.NoteEnum.G;
                                            break;
                                        case 3:
                                            u = s.NoteEnum.B;
                                            break;
                                        case 4:
                                            u = s.NoteEnum.D, d = 3;
                                            break;
                                        default:
                                            u = s.NoteEnum.C;
                                    }
                                    else switch(t % 5){
                                        case 1:
                                            u = s.NoteEnum.F;
                                            break;
                                        case 2:
                                            u = s.NoteEnum.D;
                                            break;
                                        case 3:
                                            u = s.NoteEnum.B, d = 0;
                                            break;
                                        case 4:
                                            u = s.NoteEnum.G, d = 0;
                                            break;
                                        default:
                                            u = s.NoteEnum.A;
                                    }
                                }
                                const n = new s.Pitch(u, d, c.Accidental);
                                h.setAccidental(n);
                                const r = h.parentVoiceEntry.parentVoiceEntry;
                                !this.rules.SetWantedStemDirectionByXml && r.Notes.length < 2 && (n.Octave > this.baseLineOctave || n.FundamentalNote === this.baseLineNote && n.Octave === this.baseLineOctave ? h.parentVoiceEntry.parentVoiceEntry.WantedStemDirection = a.StemDirectionType.Up : h.parentVoiceEntry.parentVoiceEntry.WantedStemDirection = a.StemDirectionType.Down);
                            }
                        }
                        return h;
                    }
                    getStafflineUniquePositionCount(t) {
                        return this.staffPitchListMapping.containsKey(t) ? this.staffPitchListMapping.getValue(t).length : 0;
                    }
                }
                e.VexflowStafflineNoteCalculator = l;
            },
            7499 (t, e, i) {
                "use strict";
                var s = this && this.__createBinding || (Object.create ? function(t, e, i, s) {
                    void 0 === s && (s = i);
                    var n = Object.getOwnPropertyDescriptor(e, i);
                    n && !("get" in n ? !e.__esModule : n.writable || n.configurable) || (n = {
                        enumerable: !0,
                        get: function() {
                            return e[i];
                        }
                    }), Object.defineProperty(t, s, n);
                } : function(t, e, i, s) {
                    void 0 === s && (s = i), t[s] = e[i];
                }), n = this && this.__exportStar || function(t, e) {
                    for(var i in t)"default" === i || Object.prototype.hasOwnProperty.call(e, i) || s(e, t, i);
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), n(i(1083), e), n(i(9834), e), n(i(9436), e), n(i(1902), e), n(i(2400), e), n(i(6014), e), n(i(1216), e), n(i(9635), e), n(i(3753), e), n(i(7809), e), n(i(7098), e), n(i(3109), e), n(i(5246), e), n(i(3849), e), n(i(806), e), n(i(9479), e), n(i(4332), e), n(i(9310), e), n(i(5468), e), n(i(6670), e), n(i(5866), e), n(i(7506), e), n(i(6173), e), n(i(7785), e), n(i(4134), e);
            },
            3508 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.WebGLSkyBottomLineBatchCalculatorBackend = void 0;
                const n = i(5479), r = i(3667), o = s(i(5340)), a = s(i(5166)), l = s(i(3065)), h = i(813);
                function c(t, e, i) {
                    const s = t.createShader(e);
                    if (!s) throw l.default.warn("WebGLSkyBottomLineCalculatorBackend: Could not create a WebGL shader"), new Error("Could not create a WebGL shader");
                    if (t.shaderSource(s, i), t.compileShader(s), !t.getShaderParameter(s, t.COMPILE_STATUS)) throw l.default.warn("Shader compilation failed\n" + t.getShaderInfoLog(s)), t.deleteShader(s), new Error("WebGL shader compilation failed");
                    return s;
                }
                class u extends r.SkyBottomLineBatchCalculatorBackend {
                    constructor(t, e){
                        super(t, e);
                    }
                    getPreferredRenderingConfiguration(t, e) {
                        const i = Math.min(4096, function() {
                            const t = document.createElement("canvas").getContext("webgl");
                            return t.getParameter(t.MAX_TEXTURE_SIZE);
                        }()), s = Math.ceil(t);
                        return {
                            elementWidth: s,
                            numColumns: Math.min(5, Math.floor(i / s)),
                            numRows: Math.min(5, Math.floor(i / e))
                        };
                    }
                    onInitialize(t) {
                        const { elementWidth: e, elementHeight: i, numColumns: s, numRows: n } = t, r = document.createElement("canvas");
                        r.width = e * s, r.height = n;
                        const u = r.getContext("webgl");
                        if (!u) throw l.default.warn("WebGLSkyBottomLineCalculatorBackend: No WebGL support"), new Error("No WebGL support");
                        this.gl = u;
                        const d = function(t, e, i) {
                            const s = t.createProgram();
                            if (!s) throw l.default.warn("WebGLSkyBottomLineCalculatorBackend: Could not create a WebGL program"), new Error("Could not create a WebGL program");
                            if (t.attachShader(s, e), t.attachShader(s, i), t.linkProgram(s), !t.getProgramParameter(s, t.LINK_STATUS)) throw l.default.warn("WebGLSkyBottomLineCalculatorBackend: WebGL program link failed\n" + t.getProgramInfoLog(s)), t.deleteProgram(s), new Error("WebGL program link failed");
                            return s;
                        }(u, c(u, u.VERTEX_SHADER, o.default), c(u, u.FRAGMENT_SHADER, function(t, e) {
                            let i = t;
                            for (const [t, s] of Object.entries(e)){
                                const e = new RegExp(`#define ${t} .*`);
                                i = i.replace(e, `#define ${t} ${s}`);
                            }
                            return i;
                        }(a.default, {
                            NUM_ROWS: n,
                            ELEMENT_HEIGHT: i
                        })));
                        !function(t, e) {
                            const i = t.createBuffer();
                            if (!i) throw l.default.warn("WebGLSkyBottomLineCalculatorBackend: WebGL buffer creation failed"), new Error("WebGL buffer creation failed");
                            t.bindBuffer(t.ARRAY_BUFFER, i), t.bufferData(t.ARRAY_BUFFER, new Float32Array(h.CollectionUtil.flat([
                                [
                                    -1,
                                    -1
                                ],
                                [
                                    1,
                                    -1
                                ],
                                [
                                    1,
                                    1
                                ],
                                [
                                    -1,
                                    -1
                                ],
                                [
                                    1,
                                    1
                                ],
                                [
                                    -1,
                                    1
                                ]
                            ])), t.STATIC_DRAW), t.useProgram(e);
                            const s = t.getAttribLocation(e, "a_position");
                            t.enableVertexAttribArray(s), t.vertexAttribPointer(s, 2, t.FLOAT, !1, 0, 0);
                        }(u, d), this.texture = function(t, e) {
                            const i = t.createTexture();
                            if (!i) throw l.default.warn("WebGLSkyBottomLineCalculatorBackend: WebGL texture creation failed"), new Error("WebGL texture creation failed");
                            t.activeTexture(t.TEXTURE0 + 0), t.bindTexture(t.TEXTURE_2D, i), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_S, t.CLAMP_TO_EDGE), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_T, t.CLAMP_TO_EDGE), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MIN_FILTER, t.NEAREST), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MAG_FILTER, t.NEAREST);
                            const s = t.getUniformLocation(e, "u_image");
                            if (!s) throw l.default.warn("WebGLSkyBottomLineCalculatorBackend: WebGL invalid uniform name"), new Error("WebGL invalid uniform name");
                            return t.uniform1i(s, 0), i;
                        }(u, d);
                    }
                    calculateFromCanvas(t, e, i, s, r) {
                        const o = this.gl, { elementWidth: a, elementHeight: l, numColumns: h } = r;
                        o.viewport(0, 0, o.canvas.width, o.canvas.height), o.bindTexture(o.TEXTURE_2D, this.texture), o.texImage2D(o.TEXTURE_2D, 0, o.RGBA, o.RGBA, o.UNSIGNED_BYTE, t), o.drawArrays(o.TRIANGLES, 0, 6);
                        const c = new Uint8Array(o.canvas.width * o.canvas.height * 4);
                        o.readPixels(0, 0, o.canvas.width, o.canvas.height, o.RGBA, o.UNSIGNED_BYTE, c);
                        const u = [];
                        for(let t = 0; t < i.length; ++t){
                            const e = i[t], r = Math.floor(e.getVFStave().getWidth()), o = Math.max(Math.ceil(e.PositionAndShape.Size.width * s), 1), d = t % h * a * 4, f = Math.floor(t / h) * a * h * 4, m = new Array(Math.max(o, r)).fill(0), p = new Array(Math.max(o, r)).fill(0);
                            for(let t = 0; t < r; ++t){
                                const e = c[4 * t + d + f], i = c[4 * t + d + f + 1], s = c[4 * t + d + f + 2], n = e + 256 * Math.floor(s / 16), r = i + s % 16 * 256;
                                m[t] = n, p[t] = r;
                            }
                            const g = Math.max(...m), b = Math.min(...p);
                            for(let t = 0; t < r; ++t)m[t] = 0 === m[t] ? g : m[t], p[t] = p[t] === l ? b : p[t];
                            u.push(new n.SkyBottomLineCalculationResult(m, p));
                        }
                        return u;
                    }
                }
                e.WebGLSkyBottomLineBatchCalculatorBackend = u;
            },
            899 (t, e, i) {
                "use strict";
                var s = this && this.__createBinding || (Object.create ? function(t, e, i, s) {
                    void 0 === s && (s = i);
                    var n = Object.getOwnPropertyDescriptor(e, i);
                    n && !("get" in n ? !e.__esModule : n.writable || n.configurable) || (n = {
                        enumerable: !0,
                        get: function() {
                            return e[i];
                        }
                    }), Object.defineProperty(t, s, n);
                } : function(t, e, i, s) {
                    void 0 === s && (s = i), t[s] = e[i];
                }), n = this && this.__exportStar || function(t, e) {
                    for(var i in t)"default" === i || Object.prototype.hasOwnProperty.call(e, i) || s(e, t, i);
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), n(i(9490), e), n(i(1974), e), n(i(8927), e), n(i(1083), e), n(i(6438), e), n(i(995), e), n(i(2683), e), n(i(242), e), n(i(3661), e), n(i(9713), e), n(i(3729), e), n(i(6659), e), n(i(953), e), n(i(1066), e), n(i(6711), e), n(i(98), e), n(i(5023), e), n(i(3361), e), n(i(8254), e), n(i(6452), e), n(i(2395), e), n(i(7751), e), n(i(1519), e), n(i(5748), e), n(i(1888), e), n(i(8724), e), n(i(3430), e), n(i(7741), e), n(i(2768), e), n(i(973), e), n(i(4022), e), n(i(348), e), n(i(9760), e), n(i(5054), e), n(i(4548), e), n(i(7225), e), n(i(7921), e), n(i(1932), e), n(i(512), e), n(i(5221), e), n(i(7066), e), n(i(8033), e), n(i(7624), e), n(i(8713), e), n(i(2779), e), n(i(2919), e), n(i(298), e), n(i(4284), e), n(i(67), e), n(i(6954), e), n(i(6723), e), n(i(7499), e);
            },
            9252 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.Instrument = void 0;
                const s = i(7586), n = i(7435), r = i(1910);
                class o extends s.InstrumentalGroup {
                    constructor(t, e, i, s){
                        super(void 0, i, s), this.Transpose = 0, this.voices = [], this.staves = [], this.hasLyrics = !1, this.hasChordSymbols = !1, this.lyricVersesNumbers = [], this.subInstruments = [], this.partAbbreviationPrintObject = !0, this.id = t, this.idString = e, this.nameLabel = new n.Label(e);
                    }
                    get Voices() {
                        return this.voices;
                    }
                    get Staves() {
                        return this.staves;
                    }
                    get NameLabel() {
                        return this.nameLabel;
                    }
                    get HasLyrics() {
                        return this.hasLyrics;
                    }
                    set HasLyrics(t) {
                        this.hasLyrics = t;
                    }
                    get HasChordSymbols() {
                        return this.hasChordSymbols;
                    }
                    set HasChordSymbols(t) {
                        this.hasChordSymbols = t;
                    }
                    get LyricVersesNumbers() {
                        return this.lyricVersesNumbers;
                    }
                    set LyricVersesNumbers(t) {
                        this.lyricVersesNumbers = t;
                    }
                    get Name() {
                        return this.nameLabel.text;
                    }
                    set Name(t) {
                        this.nameLabel.text = t;
                    }
                    get IdString() {
                        return this.idString;
                    }
                    get Id() {
                        return this.id;
                    }
                    get MidiInstrumentId() {
                        return this.subInstruments[0].midiInstrumentID;
                    }
                    set MidiInstrumentId(t) {
                        this.subInstruments[0].midiInstrumentID = t;
                    }
                    get Volume() {
                        return this.subInstruments[0].volume;
                    }
                    set Volume(t) {
                        for(let e = 0, i = this.subInstruments.length; e < i; ++e)this.subInstruments[e].volume = t;
                    }
                    get PlaybackTranspose() {
                        return this.playbackTranspose;
                    }
                    set PlaybackTranspose(t) {
                        this.playbackTranspose = t;
                    }
                    get SubInstruments() {
                        return this.subInstruments;
                    }
                    getSubInstrument(t) {
                        for(let e = 0, i = this.subInstruments.length; e < i; ++e){
                            const i = this.subInstruments[e];
                            if (i.idString === t) return i;
                        }
                    }
                    get PartAbbreviation() {
                        return this.partAbbreviation;
                    }
                    set PartAbbreviation(t) {
                        this.partAbbreviation = t;
                    }
                    get PartAbbreviationPrintObject() {
                        return this.partAbbreviationPrintObject;
                    }
                    set PartAbbreviationPrintObject(t) {
                        this.partAbbreviationPrintObject = t;
                    }
                    get Visible() {
                        return this.voices.length > 0 && this.Voices[0].Visible;
                    }
                    isVisible() {
                        if (!this.Visible) return !1;
                        for (const t of this.Staves)if (t.Visible) return !0;
                        return !1;
                    }
                    set Visible(t) {
                        for(let e = 0, i = this.Voices.length; e < i; ++e)this.Voices[e].Visible = t;
                    }
                    get Audible() {
                        let t = !1;
                        for(let e = 0, i = this.Voices.length; e < i; ++e){
                            const i = this.Voices[e];
                            t = t || i.Audible;
                        }
                        return t;
                    }
                    set Audible(t) {
                        for(let e = 0, i = this.Voices.length; e < i; ++e)this.Voices[e].Audible = t;
                        for(let e = 0, i = this.staves.length; e < i; ++e)this.staves[e].audible = t;
                    }
                    get Following() {
                        let t = !1;
                        for(let e = 0, i = this.Voices.length; e < i; ++e){
                            const i = this.Voices[e];
                            t = t || i.Following;
                        }
                        return t;
                    }
                    set Following(t) {
                        for(let e = 0, i = this.Voices.length; e < i; ++e)this.Voices[e].Following = t;
                        for(let e = 0, i = this.staves.length; e < i; ++e)this.staves[e].following = t;
                    }
                    SetVoiceAudible(t, e) {
                        for(let i = 0, s = this.Voices.length; i < s; ++i){
                            const s = this.Voices[i];
                            if (s.VoiceId === t) {
                                s.Audible = e;
                                break;
                            }
                        }
                    }
                    SetVoiceFollowing(t, e) {
                        for(let i = 0, s = this.Voices.length; i < s; ++i){
                            const s = this.Voices[i];
                            if (s.VoiceId === t) {
                                s.Following = e;
                                break;
                            }
                        }
                    }
                    SetStaffAudible(t, e) {
                        const i = this.staves[t - 1];
                        if (i.audible = e, e) for(let t = 0, e = i.Voices.length; t < e; ++t)i.Voices[t].Audible = !0;
                        else for(let e = 0, s = i.Voices.length; e < s; ++e){
                            const s = i.Voices[e];
                            let n = !1;
                            for(let e = 0, i = this.Staves.length; e < i; ++e){
                                const i = this.Staves[e];
                                if (i.Id !== t && i.audible) for(let t = 0, e = i.Voices.length; t < e; ++t)i.Voices[t] === s && (n = !0);
                            }
                            n || (s.Audible = !1);
                        }
                    }
                    SetStaffFollow(t, e) {
                        const i = this.staves[t - 1];
                        if (i.following = e, e) for(let t = 0, e = i.Voices.length; t < e; ++t)i.Voices[t].Following = !0;
                        else for(let e = 0, s = i.Voices.length; e < s; ++e){
                            const s = i.Voices[e];
                            let n = !1;
                            for(let e = 0, i = this.Staves.length; e < i; ++e){
                                const i = this.Staves[e];
                                if (i.Id !== t && i.following) for(let t = 0, e = i.Voices.length; t < e; ++t)i.Voices[t] === s && (n = !0);
                            }
                            n || (s.Following = !1);
                        }
                    }
                    areAllVoiceVisible() {
                        for (const t of this.Voices)if (!t.Visible) return !1;
                        return !0;
                    }
                    createStaves(t) {
                        for(let e = 0; e < t; e++)this.staves.push(new r.Staff(this, e + 1));
                    }
                    toString() {
                        return `${this.Name} , id: ${this.id}, idstring: ${this.idString}`;
                    }
                }
                e.Instrument = o;
            },
            7586 (t, e) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.InstrumentalGroup = void 0, e.InstrumentalGroup = class {
                    constructor(t, e, i){
                        this.printName = !0, this.printAbbreviation = !0, this.instrumentalGroups = [], this.name = t, this.musicSheet = e, this.parent = i;
                    }
                    get InstrumentalGroups() {
                        return this.instrumentalGroups;
                    }
                    get Parent() {
                        return this.parent;
                    }
                    get Name() {
                        return this.name;
                    }
                    set Name(t) {
                        this.name = t;
                    }
                    get Abbreviation() {
                        return this.abbreviation;
                    }
                    set Abbreviation(t) {
                        this.abbreviation = t;
                    }
                    get PrintName() {
                        return this.printName;
                    }
                    set PrintName(t) {
                        this.printName = t;
                    }
                    get PrintAbbreviation() {
                        return this.printAbbreviation;
                    }
                    set PrintAbbreviation(t) {
                        this.printAbbreviation = t;
                    }
                    get GetMusicSheet() {
                        return this.musicSheet;
                    }
                };
            },
            7791 (t, e) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.AClassHierarchyTrackable = void 0, e.AClassHierarchyTrackable = class {
                    isInstanceOfClass(t) {
                        if ("string" != typeof t) return this instanceof t;
                        let e = this.constructor.prototype;
                        for(; e;){
                            if (t === e.constructor.name) return !0;
                            e = e.__proto__;
                        }
                        return !1;
                    }
                };
            },
            5678 (t, e) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
            },
            8900 (t, e) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
            },
            6703 (t, e) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
            },
            5377 (t, e) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
            },
            6332 (t, e) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
            },
            9767 (t, e) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.ITextTranslation = void 0, e.ITextTranslation = class {
                    static translateText(t, e) {
                        if (!this.defaultTextTranslation) return e;
                    }
                };
            },
            9990 (t, e) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
            },
            4864 (t, e) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
            },
            2870 (t, e, i) {
                "use strict";
                var s = this && this.__createBinding || (Object.create ? function(t, e, i, s) {
                    void 0 === s && (s = i);
                    var n = Object.getOwnPropertyDescriptor(e, i);
                    n && !("get" in n ? !e.__esModule : n.writable || n.configurable) || (n = {
                        enumerable: !0,
                        get: function() {
                            return e[i];
                        }
                    }), Object.defineProperty(t, s, n);
                } : function(t, e, i, s) {
                    void 0 === s && (s = i), t[s] = e[i];
                }), n = this && this.__exportStar || function(t, e) {
                    for(var i in t)"default" === i || Object.prototype.hasOwnProperty.call(e, i) || s(e, t, i);
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), n(i(5678), e), n(i(8900), e), n(i(6703), e), n(i(6332), e), n(i(9767), e), n(i(9990), e), n(i(4864), e), n(i(7791), e), n(i(5377), e);
            },
            7435 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.Label = void 0;
                const s = i(7533);
                e.Label = class {
                    constructor(t = "", e = s.TextAlignmentEnum.CenterBottom, i, n = !0){
                        this.IsCreditLabel = !1, this.text = t, this.print = n, this.textAlignment = e, this.font = i, this.fontFamily = void 0;
                    }
                    ToString() {
                        return this.text;
                    }
                };
            },
            9024 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.TimestampTransform = e.MusicPartManager = void 0;
                const s = i(2561), n = i(474);
                e.MusicPartManager = class {
                    constructor(t){
                        this.musicSheet = t;
                    }
                    reInit() {
                        this.init();
                    }
                    init() {
                        this.parts = this.musicSheet.Repetitions.slice(), this.sheetStart = this.musicSheet.SelectionStart = new s.Fraction(0, 1), this.sheetEnd = this.musicSheet.SelectionEnd = this.musicSheet.SheetEndTimestamp, this.calcMapping();
                    }
                    getCurrentRepetitionTimestampTransform(t) {
                        let e;
                        for(let i = this.timestamps.length - 1; i >= 0; i--)if (e = this.timestamps[i], t.gte(e.$from)) return e;
                        return this.timestamps[0];
                    }
                    absoluteEnrolledToSheetTimestamp(t) {
                        if (0 === this.timestamps.length) return t;
                        const e = this.getCurrentRepetitionTimestampTransform(t);
                        return s.Fraction.plus(t, s.Fraction.minus(e.to, e.$from));
                    }
                    get Parts() {
                        return this.parts;
                    }
                    get MusicSheet() {
                        return this.musicSheet;
                    }
                    getIterator(t) {
                        return t ? new n.MusicPartManagerIterator(this.musicSheet, t, void 0) : new n.MusicPartManagerIterator(this.musicSheet, this.musicSheet.SelectionStart, this.musicSheet.SelectionEnd);
                    }
                    setSelectionStart(t) {
                        this.musicSheet.SelectionStart = t, this.musicSheet.SelectionEnd = void 0;
                    }
                    setSelectionRange(t, e) {
                        this.musicSheet.SelectionStart = t ?? this.sheetStart, this.musicSheet.SelectionEnd = e ?? this.sheetEnd;
                    }
                    calcMapping() {
                        const t = [], e = this.getIterator();
                        let i = e.CurrentRepetition, s = new r(e.CurrentEnrolledTimestamp.clone(), e.CurrentSourceTimestamp.clone(), void 0, 0);
                        for(t.push(s); !e.EndReached;){
                            if (e.JumpOccurred || i !== e.CurrentRepetition) {
                                if (i = e.CurrentRepetition, e.backJumpOccurred) {
                                    const i = e.JumpResponsibleRepetition;
                                    s.nextBackJump = e.CurrentEnrolledTimestamp, s.curRepetition = i, s.curRepetitionIteration = e.CurrentJumpResponsibleRepetitionIterationBeforeJump;
                                    for(let e = t.length - 2; e >= 0 && !t[e].to.lt(i.AbsoluteTimestamp) && !t[e].curRepetition; e--)t[e].nextBackJump = s.nextBackJump, t[e].curRepetition = i, t[e].curRepetitionIteration = s.curRepetitionIteration;
                                }
                                s = new r(e.CurrentEnrolledTimestamp.clone(), e.CurrentSourceTimestamp.clone(), void 0, 0), t.push(s);
                            }
                            e.moveToNext();
                        }
                        this.timestamps = t;
                    }
                };
                class r {
                    constructor(t, e, i, s){
                        this.$from = t, this.to = e, this.curRepetition = i, this.curRepetitionIteration = s, this.nextBackJump = void 0, this.nextForwardJump = void 0;
                    }
                }
                e.TimestampTransform = r;
            },
            474 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.MusicPartManagerIterator = void 0;
                const n = i(2561), r = i(1110), o = i(9288), a = i(5875), l = s(i(3065)), h = i(4064);
                class c {
                    constructor(t, e, i){
                        this.currentMeasureIndex = 0, this.currentPartIndex = 0, this.currentVoiceEntryIndex = -1, this.currentDynamicEntryIndex = 0, this.currentTempoEntryIndex = 0, this.currentDynamicChangingExpressions = [], this.repetitionIterationCountDictKeys = [], this.repetitionIterationCountDictValues = [], this.currentRepetition = void 0, this.endReached = !1, this.frontReached = !1, this.currentTimeStamp = new n.Fraction(0, 1), this.currentEnrolledMeasureTimestamp = new n.Fraction(0, 1), this.currentRelativeInMeasureTimestamp = new n.Fraction(0, 1), this.currentVerticalContainerInMeasureTimestamp = new n.Fraction(0, 1), this.jumpResponsibleRepetition = void 0, this.replayedRepetitionFromWords = void 0, this.activeDynamicExpressions = [], this.SkipInvisibleNotes = !0;
                        try {
                            this.frontReached = !0, this.musicSheet = t, this.currentBpm = t.userStartTempoInBPM, this.currentVoiceEntries = void 0, this.frontReached = !1;
                            for (const t of this.musicSheet.Repetitions)this.setRepetitionIterationCount(t, 1);
                            for(let e = 0; e < t.getCompleteNumberOfStaves(); e++)this.ActiveDynamicExpressions.push(void 0);
                            this.currentMeasure = this.musicSheet.SourceMeasures[0], e || (e = new n.Fraction);
                            do this.moveToNext();
                            while ((!this.currentVoiceEntries || this.currentTimeStamp.lt(e)) && !this.endReached);
                            this.currentDynamicChangingExpressions.length = 0;
                            for(let t = 0; t < this.activeDynamicExpressions.length; t++)if (this.activeDynamicExpressions[t]) {
                                if (this.activeDynamicExpressions[t] instanceof a.ContinuousDynamicExpression) {
                                    const e = this.activeDynamicExpressions[t];
                                    this.currentDynamicChangingExpressions.push(new r.DynamicsContainer(e, t));
                                } else {
                                    const e = this.activeDynamicExpressions[t];
                                    this.currentDynamicChangingExpressions.push(new r.DynamicsContainer(e, t));
                                }
                            }
                            this.currentTempoChangingExpression = this.activeTempoExpression;
                        } catch (t) {
                            l.default.info("MusicPartManagerIterator: " + t);
                        }
                    }
                    get EndReached() {
                        return this.endReached;
                    }
                    get FrontReached() {
                        return this.frontReached;
                    }
                    get CurrentMeasure() {
                        return this.currentMeasure;
                    }
                    get CurrentRepetition() {
                        return this.currentRepetition;
                    }
                    get CurrentRepetitionIteration() {
                        return this.CurrentRepetition ? this.getRepetitionIterationCount(this.CurrentRepetition) : 0;
                    }
                    get CurrentJumpResponsibleRepetitionIterationBeforeJump() {
                        return this.jumpResponsibleRepetition ? this.getRepetitionIterationCount(this.jumpResponsibleRepetition) - 1 : 0;
                    }
                    get CurrentBpm() {
                        return this.currentBpm;
                    }
                    set CurrentBpm(t) {
                        this.currentBpm = t;
                    }
                    get CurrentVoiceEntries() {
                        return this.currentVoiceEntries;
                    }
                    get CurrentMeasureIndex() {
                        return this.currentMeasureIndex;
                    }
                    get CurrentEnrolledTimestamp() {
                        return n.Fraction.plus(this.currentEnrolledMeasureTimestamp, this.currentVerticalContainerInMeasureTimestamp);
                    }
                    get CurrentSourceTimestamp() {
                        return this.currentTimeStamp;
                    }
                    get CurrentRelativeInMeasureTimestamp() {
                        return this.currentRelativeInMeasureTimestamp;
                    }
                    get JumpOccurred() {
                        return this.backJumpOccurred || this.forwardJumpOccurred;
                    }
                    get ActiveTempoExpression() {
                        return this.activeTempoExpression;
                    }
                    get ActiveDynamicExpressions() {
                        return this.activeDynamicExpressions;
                    }
                    get CurrentTempoChangingExpression() {
                        return this.currentTempoChangingExpression;
                    }
                    get JumpResponsibleRepetition() {
                        return this.jumpResponsibleRepetition;
                    }
                    clone(t, e) {
                        const i = new c(this.musicSheet, t ?? this.currentTimeStamp, e);
                        return i.currentVoiceEntryIndex = this.currentVoiceEntryIndex, i.currentMappingPart = this.currentMappingPart, i.currentPartIndex = this.currentPartIndex, i.currentVoiceEntries = this.currentVoiceEntries?.slice() ?? void 0, i.endReached = this.endReached, i.frontReached = this.frontReached, i;
                    }
                    CurrentVisibleVoiceEntries(t) {
                        const e = [];
                        if (!this.currentVoiceEntries) return e;
                        if (t) {
                            for (const i of this.currentVoiceEntries)i.ParentVoice.Parent.IdString === t.IdString && this.getVisibleEntries(i, e);
                            return e;
                        }
                        for (const t of this.currentVoiceEntries)this.getVisibleEntries(t, e);
                        return e;
                    }
                    CurrentAudibleVoiceEntries(t) {
                        const e = [];
                        if (this.currentVoiceEntries) {
                            if (t) {
                                for (const i of this.currentVoiceEntries)if (i.ParentVoice.Parent.IdString === t.IdString) return this.getAudibleEntries(i, e), e;
                            } else for (const t of this.currentVoiceEntries)this.getAudibleEntries(t, e);
                        }
                        return e;
                    }
                    getCurrentDynamicChangingExpressions() {
                        return this.currentDynamicChangingExpressions;
                    }
                    CurrentScoreFollowingVoiceEntries(t) {
                        const e = [];
                        if (!this.currentVoiceEntries) return e;
                        if (t) {
                            for (const i of this.currentVoiceEntries)if (i.ParentVoice.Parent.IdString === t.IdString) return this.getScoreFollowingEntries(i, e), e;
                        } else for (const t of this.currentVoiceEntries)this.getScoreFollowingEntries(t, e);
                        return e;
                    }
                    currentPlaybackSettings() {
                        return this.musicSheet.SheetPlaybackSetting;
                    }
                    moveToPrevious() {
                        this.frontReached || (this.currentVoiceEntries && (this.currentVoiceEntries = []), this.recursiveMoveBack(), this.updateCurrentBpm());
                    }
                    moveToPreviousVisibleVoiceEntry(t) {
                        for(; !this.frontReached;)if (this.moveToPrevious(), this.checkEntries(t)) return;
                    }
                    moveToNext() {
                        this.forwardJumpOccurred = this.backJumpOccurred = !1, this.endReached || (this.frontReached && (this.frontReached = !1, this.currentVoiceEntryIndex = -1), this.currentVoiceEntries && (this.currentVoiceEntries.length = 0), this.recursiveMove(), this.currentMeasure || (this.currentTimeStamp = new n.Fraction(99999, 1), this.currentMeasure = this.musicSheet.SourceMeasures.last()), this.updateCurrentBpm());
                    }
                    updateCurrentBpm() {
                        if (this.musicSheet.IgnoreTempoInstructions) return;
                        const t = this.CurrentTempoChangingExpression;
                        if (t) {
                            if (void 0 !== t.ContinuousTempo && this.currentMeasure.Rules.UseInterpolatedTempoForAccelerandoEtc) {
                                const e = t.ContinuousTempo.getInterpolatedTempo(this.CurrentSourceTimestamp);
                                e > 0 && (this.currentBpm = e);
                            } else t.PlaybackTempoInBpm || t.InstantaneousTempo?.TempoInBpm ? this.currentBpm = t.PlaybackTempoInBpm ?? t.InstantaneousTempo.TempoInBpm : t.ContinuousTempo?.StartTempo > 0 && (this.currentBpm = t.ContinuousTempo.StartTempo);
                        } else this.currentBpm = this.musicSheet.userStartTempoInBPM;
                    }
                    moveToNextVisibleVoiceEntry(t) {
                        for(; !this.endReached;)if (this.moveToNext(), this.checkEntries(t)) return;
                    }
                    resetRepetitionIterationCount(t) {
                        return this.setRepetitionIterationCount(t, 1), 1;
                    }
                    incrementRepetitionIterationCount(t) {
                        return -1 === this.repetitionIterationCountDictKeys.indexOf(t) ? this.setRepetitionIterationCount(t, 1) : this.setRepetitionIterationCount(t, this.getRepetitionIterationCount(t) + 1);
                    }
                    setRepetitionIterationCount(t, e) {
                        const i = this.repetitionIterationCountDictKeys.indexOf(t);
                        return -1 === i ? (this.repetitionIterationCountDictKeys.push(t), this.repetitionIterationCountDictValues.push(e)) : this.repetitionIterationCountDictValues[i] = e, e;
                    }
                    getRepetitionIterationCount(t) {
                        const e = this.repetitionIterationCountDictKeys.indexOf(t);
                        if (-1 !== e) return this.repetitionIterationCountDictValues[e];
                    }
                    handleRepetitionsAtMeasureBegin() {
                        for(let t = 0, e = this.currentMeasure.FirstRepetitionInstructions.length; t < e; ++t){
                            const e = this.currentMeasure.FirstRepetitionInstructions[t];
                            if (!e.parentRepetition) continue;
                            const i = e.parentRepetition;
                            this.currentRepetition = i, i.StartIndex === this.currentMeasureIndex && void 0 !== this.JumpResponsibleRepetition && i !== this.JumpResponsibleRepetition && i.StartIndex >= this.JumpResponsibleRepetition.StartIndex && i.EndIndex <= this.JumpResponsibleRepetition.EndIndex && this.restartNestedRepetition(i);
                        }
                    }
                    restartNestedRepetition(t) {
                        this.replayedRepetitionFromWords ? this.setRepetitionIterationCount(t, t.UserNumberOfRepetitions) : this.resetRepetitionIterationCount(t);
                    }
                    handleRepetitionsAtMeasureEnd() {
                        for(let t = 0, e = this.currentMeasure.LastRepetitionInstructions.length; t < e; ++t){
                            const e = this.currentMeasure.LastRepetitionInstructions[t], i = e.parentRepetition;
                            if (i) {
                                if (i.BackwardJumpInstructions.indexOf(e) > -1 && this.getRepetitionIterationCount(i) < i.UserNumberOfRepetitions && !i.SkipRepetition && !this.musicSheet.Rules.CursorIgnoreRepetitions) return void this.doBackJump(i);
                                if (e === i.forwardJumpInstruction && (void 0 !== this.JumpResponsibleRepetition && i !== this.JumpResponsibleRepetition && i.StartIndex >= this.JumpResponsibleRepetition.StartIndex && i.EndIndex <= this.JumpResponsibleRepetition.EndIndex && this.restartNestedRepetition(i), this.repetitionIterationCountDictKeys.contains(i))) {
                                    const t = i.getForwardJumpTargetForIteration(this.getRepetitionIterationCount(i));
                                    if (t > this.currentMeasureIndex) return this.currentMeasureIndex = t, this.currentMeasure = this.musicSheet.SourceMeasures[this.currentMeasureIndex], this.currentVoiceEntryIndex = -1, this.jumpResponsibleRepetition = i, this.forwardJumpOccurred = !0, void (i === this.replayedRepetitionFromWords && (this.replayedRepetitionFromWords = void 0));
                                    -2 === t && (this.endReached = !0);
                                }
                            }
                        }
                        this.currentMeasureIndex++, void 0 !== this.JumpResponsibleRepetition && this.currentMeasureIndex > this.JumpResponsibleRepetition.EndIndex && (this.jumpResponsibleRepetition = void 0), this.replayedRepetitionFromWords && this.currentMeasureIndex > this.replayedRepetitionFromWords.EndIndex && (this.replayedRepetitionFromWords = void 0);
                    }
                    doBackJump(t) {
                        t.SkipRepetition || this.musicSheet.Rules.CursorIgnoreRepetitions || (this.currentMeasureIndex = t.getBackwardJumpTarget(), this.currentMeasure = this.musicSheet.SourceMeasures[this.currentMeasureIndex], this.currentVoiceEntryIndex = -1, this.incrementRepetitionIterationCount(t), this.jumpResponsibleRepetition = t, this.backJumpOccurred = !0, t.FromWords && (this.replayedRepetitionFromWords = t));
                    }
                    activateCurrentRhythmInstructions() {
                        if (void 0 !== this.currentMeasure && this.currentMeasure.FirstInstructionsStaffEntries.length > 0 && void 0 !== this.currentMeasure.FirstInstructionsStaffEntries[0]) {
                            const t = this.currentMeasure.FirstInstructionsStaffEntries[0].Instructions;
                            for(let e = 0, i = t.length; e < i; ++e){
                                const i = t[e];
                                i instanceof o.RhythmInstruction && (this.musicSheet.SheetPlaybackSetting.rhythm = i.Rhythm);
                            }
                        }
                    }
                    activateCurrentDynamicOrTempoInstructions() {
                        const t = this.musicSheet.TimestampSortedDynamicExpressionsList;
                        this.currentDynamicEntryIndex > 0 && t[this.currentDynamicEntryIndex - 1].parMultiExpression().AbsolutePlaybackTimestamp.gt(this.CurrentSourceTimestamp) && (this.currentDynamicEntryIndex = 0, this.activeDynamicExpressions.fill(void 0));
                        const e = new Set;
                        for(; this.currentDynamicEntryIndex < t.length && t[this.currentDynamicEntryIndex].parMultiExpression().AbsolutePlaybackTimestamp.lte(this.CurrentSourceTimestamp);){
                            const i = t[this.currentDynamicEntryIndex], s = i.staffNumber;
                            this.activeDynamicExpressions[s] = i.continuousDynamicExpression ?? i.instantaneousDynamicExpression, e.add(s), this.currentDynamicEntryIndex++;
                        }
                        this.currentDynamicChangingExpressions.length = 0;
                        for(let t = 0; t < this.activeDynamicExpressions.length; t++)if (this.activeDynamicExpressions[t]) {
                            let i, s;
                            if (this.activeDynamicExpressions[t] instanceof a.ContinuousDynamicExpression) {
                                const e = this.activeDynamicExpressions[t];
                                i = e.StartMultiExpression.AbsolutePlaybackTimestamp, s = e.EndMultiExpression.AbsolutePlaybackTimestamp, this.CurrentSourceTimestamp.gte(i) && this.CurrentSourceTimestamp.lte(s) && this.currentDynamicChangingExpressions.push(new r.DynamicsContainer(e, t));
                            } else {
                                const i = this.activeDynamicExpressions[t];
                                e.has(t) && this.currentDynamicChangingExpressions.push(new r.DynamicsContainer(i, t));
                            }
                        }
                        const i = this.musicSheet.TimestampSortedTempoExpressionsList;
                        for(; this.currentTempoEntryIndex > 0 && i[this.currentTempoEntryIndex - 1].AbsolutePlaybackTimestamp.gt(this.CurrentSourceTimestamp);)this.currentTempoEntryIndex--;
                        for(; this.currentTempoEntryIndex < i.length && i[this.currentTempoEntryIndex].AbsolutePlaybackTimestamp.lte(this.CurrentSourceTimestamp);)this.currentTempoEntryIndex++;
                        let s = this.currentTempoEntryIndex - 1;
                        const n = i[s]?.AbsolutePlaybackTimestamp;
                        let o = -1, l = -1;
                        for(let t = s; t >= 0 && i[t].AbsolutePlaybackTimestamp.Equals(n); t--){
                            const e = i[t];
                            o < 0 && e.PlaybackTempoInBpm > 0 && (o = t), l < 0 && e.ContinuousTempo && (l = t);
                        }
                        l >= 0 && this.currentMeasure.Rules.UseInterpolatedTempoForAccelerandoEtc ? s = l : o >= 0 && (s = o), this.activeTempoExpression = i[s], this.currentTempoChangingExpression = this.activeTempoExpression;
                    }
                    recursiveMoveBack() {
                        if (this.currentVoiceEntryIndex > 0) {
                            this.currentVoiceEntryIndex === this.currentMeasure.VerticalSourceStaffEntryContainers.length && this.currentEnrolledMeasureTimestamp.Sub(this.currentMeasure.Duration), this.currentVoiceEntryIndex--;
                            const t = this.currentMeasure.VerticalSourceStaffEntryContainers[this.currentVoiceEntryIndex];
                            this.currentVoiceEntries = this.getVoiceEntries(t), this.currentVerticalContainerInMeasureTimestamp = t.Timestamp, this.currentRelativeInMeasureTimestamp = this.currentVerticalContainerInMeasureTimestamp, this.currentTimeStamp = n.Fraction.plus(this.currentMeasure.AbsoluteTimestamp, this.currentVerticalContainerInMeasureTimestamp), this.activateCurrentDynamicOrTempoInstructions();
                            const e = this.musicSheet.SelectionEnd;
                            return e && this.currentTimeStamp.lt(e) && (this.endReached = !1), void (this.currentMeasureIndex = this.musicSheet.SourceMeasures.indexOf(this.CurrentMeasure));
                        }
                        if (0 === this.currentVoiceEntryIndex && 0 !== this.currentMeasureIndex) {
                            const t = this.musicSheet.SourceMeasures[this.currentMeasureIndex - 1];
                            this.currentEnrolledMeasureTimestamp.Sub(t.Duration), this.currentMeasureIndex--, this.currentMeasure = this.musicSheet.SourceMeasures[this.currentMeasureIndex];
                            const e = t.VerticalSourceStaffEntryContainers[t.VerticalSourceStaffEntryContainers.length - 1];
                            this.currentVoiceEntries = this.getVoiceEntries(e), this.currentVerticalContainerInMeasureTimestamp = e.Timestamp, this.currentVoiceEntryIndex = t.VerticalSourceStaffEntryContainers.length - 1, this.currentRelativeInMeasureTimestamp = this.currentVerticalContainerInMeasureTimestamp, this.currentTimeStamp = n.Fraction.plus(this.currentMeasure.AbsoluteTimestamp, e.Timestamp), this.activateCurrentDynamicOrTempoInstructions();
                            const i = this.musicSheet.SelectionEnd;
                            return void (i && this.currentTimeStamp.lt(i) && (this.endReached = !1));
                        }
                        this.frontReached = !0, this.currentTimeStamp = new n.Fraction(-1, 1);
                    }
                    recursiveMove() {
                        if (this.currentVoiceEntryIndex++, 0 === this.currentVoiceEntryIndex && (this.handleRepetitionsAtMeasureBegin(), this.activateCurrentRhythmInstructions()), this.currentVoiceEntryIndex >= 0 && this.currentVoiceEntryIndex < this.currentMeasure.VerticalSourceStaffEntryContainers.length) {
                            const t = this.currentMeasure.VerticalSourceStaffEntryContainers[this.currentVoiceEntryIndex];
                            this.currentVoiceEntries = this.getVoiceEntries(t), this.currentVerticalContainerInMeasureTimestamp = t.Timestamp, this.currentRelativeInMeasureTimestamp = this.currentVerticalContainerInMeasureTimestamp, this.currentTimeStamp = n.Fraction.plus(this.currentMeasure.AbsoluteTimestamp, this.currentVerticalContainerInMeasureTimestamp);
                            const e = this.musicSheet.SelectionEnd;
                            return e && this.currentTimeStamp.gte(e) && (this.endReached = !0), void this.activateCurrentDynamicOrTempoInstructions();
                        }
                        if (this.currentEnrolledMeasureTimestamp.Add(this.currentMeasure.Duration), this.handleRepetitionsAtMeasureEnd(), this.currentMeasureIndex >= 0 && this.currentMeasureIndex < this.musicSheet.SourceMeasures.length) return this.currentMeasure = this.musicSheet.SourceMeasures[this.currentMeasureIndex], this.currentTimeStamp = n.Fraction.plus(this.currentMeasure.AbsoluteTimestamp, this.currentVerticalContainerInMeasureTimestamp), this.currentVoiceEntryIndex = -1, void this.recursiveMove();
                        this.currentVerticalContainerInMeasureTimestamp = new n.Fraction, this.currentMeasure = void 0, this.currentVoiceEntries = void 0, this.endReached = !0;
                    }
                    checkEntries(t) {
                        const e = this.CurrentVisibleVoiceEntries();
                        if (e.length > 0) {
                            if (!t) return !0;
                            for(let t = 0, i = e.length; t < i; ++t)if (e[t].Notes[0].Pitch) return !0;
                        }
                        return !1;
                    }
                    getVisibleEntries(t, e) {
                        if (t.ParentVoice.Visible) {
                            let i = !1;
                            for (const e of t.Notes)if (e.PrintObject && e.Notehead?.Shape !== h.NoteHeadShape.NONE) {
                                i = !0;
                                break;
                            }
                            if (!i && this.SkipInvisibleNotes) return;
                            e.push(t);
                        }
                    }
                    getAudibleEntries(t, e) {
                        if (t.hasTie()) {
                            const e = t.Notes[0];
                            if (void 0 !== e.NoteTie && e.NoteTie.StartNote !== e) return;
                        }
                        t.ParentVoice.Audible && t.ParentSourceStaffEntry.ParentStaff.audible && e.push(t);
                    }
                    getScoreFollowingEntries(t, e) {
                        t.ParentVoice.Following && t.ParentVoice.Parent.Following && e.push(t);
                    }
                    getVoiceEntries(t) {
                        const e = [];
                        for (const i of t.StaffEntries)if (i) for (const t of i.VoiceEntries)e.push(t);
                        return e;
                    }
                }
                e.MusicPartManagerIterator = c;
            },
            3502 (t, e, i) {
                "use strict";
                var s = this && this.__createBinding || (Object.create ? function(t, e, i, s) {
                    void 0 === s && (s = i);
                    var n = Object.getOwnPropertyDescriptor(e, i);
                    n && !("get" in n ? !e.__esModule : n.writable || n.configurable) || (n = {
                        enumerable: !0,
                        get: function() {
                            return e[i];
                        }
                    }), Object.defineProperty(t, s, n);
                } : function(t, e, i, s) {
                    void 0 === s && (s = i), t[s] = e[i];
                }), n = this && this.__exportStar || function(t, e) {
                    for(var i in t)"default" === i || Object.prototype.hasOwnProperty.call(e, i) || s(e, t, i);
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), n(i(9024), e), n(i(474), e);
            },
            427 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.MusicSheet = void 0;
                const n = i(2561), r = i(9024), o = i(6001), a = i(7435), l = i(5534), h = i(8786), c = i(9713), u = i(2683), d = s(i(3065)), f = i(7533), m = i(283);
                class p {
                    constructor(){
                        this.idString = "uninitialized", this.sourceMeasures = [], this.repetitions = [], this.dynListStaves = [], this.timestampSortedDynamicExpressionsList = [], this.timestampSortedTempoExpressionsList = [], this.instrumentalGroups = [], this.instruments = [], this.firstPageCreditWords = [], this.musicPartManager = void 0, this.musicSheetErrors = new h.MusicSheetErrors, this.staves = [], this.transpose = 0, this.defaultStartTempoInBpm = 0, this.drawErroneousMeasures = !1, this.hasBeenOpenedForTheFirstTime = !1, this.currentEnrolledPosition = new n.Fraction(0, 1), this.MeasureWidthFactor = 1, this.IgnoreTempoInstructions = !1, this.LyricLanguages = [], this.playbackSettings = new m.PlaybackSettings, this.playbackSettings.rhythm = new n.Fraction(4, 4, 0, !1), this.userStartTempoInBPM = 100, this.pageWidth = 120, this.MusicPartManager = new r.MusicPartManager(this), this.hasBPMInfo = !1;
                    }
                    static getIndexFromStaff(t) {
                        return t.idInMusicSheet;
                    }
                    get SourceMeasures() {
                        return this.sourceMeasures;
                    }
                    set SourceMeasures(t) {
                        this.sourceMeasures = t;
                    }
                    get Repetitions() {
                        return this.repetitions;
                    }
                    set Repetitions(t) {
                        this.repetitions = t;
                    }
                    get DynListStaves() {
                        return this.dynListStaves;
                    }
                    set TimestampSortedTempoExpressionsList(t) {
                        this.timestampSortedTempoExpressionsList = t;
                    }
                    get TimestampSortedTempoExpressionsList() {
                        return this.timestampSortedTempoExpressionsList;
                    }
                    get TimestampSortedDynamicExpressionsList() {
                        return this.timestampSortedDynamicExpressionsList;
                    }
                    get InstrumentalGroups() {
                        return this.instrumentalGroups;
                    }
                    get Parts() {
                        return this.instruments;
                    }
                    get Instruments() {
                        return this.instruments;
                    }
                    get SheetPlaybackSetting() {
                        return this.playbackSettings;
                    }
                    set SheetPlaybackSetting(t) {
                        this.playbackSettings = t;
                    }
                    get DrawErroneousMeasures() {
                        return this.drawErroneousMeasures;
                    }
                    set DrawErroneousMeasures(t) {
                        this.drawErroneousMeasures = t;
                    }
                    get HasBeenOpenedForTheFirstTime() {
                        return this.hasBeenOpenedForTheFirstTime;
                    }
                    set HasBeenOpenedForTheFirstTime(t) {
                        this.hasBeenOpenedForTheFirstTime = t;
                    }
                    InitializeStartTempoInBPM(t) {
                        this.userStartTempoInBPM = t;
                    }
                    get DefaultStartTempoInBpm() {
                        return this.defaultStartTempoInBpm;
                    }
                    set DefaultStartTempoInBpm(t) {
                        this.defaultStartTempoInBpm = t, this.InitializeStartTempoInBPM(t);
                    }
                    get Path() {
                        return this.path;
                    }
                    set Path(t) {
                        this.path = t;
                    }
                    get Staves() {
                        return this.staves;
                    }
                    get TitleString() {
                        return this.title ? this.title.text : "";
                    }
                    set TitleString(t) {
                        this.Title = new a.Label(t);
                    }
                    get SubtitleString() {
                        return this.subtitle ? this.subtitle.text : "";
                    }
                    set SubtitleString(t) {
                        this.Subtitle = new a.Label(t);
                    }
                    get ComposerString() {
                        return this.composer ? this.composer.text : "";
                    }
                    set ComposerString(t) {
                        this.Composer = new a.Label(t);
                    }
                    get LyricistString() {
                        return this.lyricist ? this.lyricist.text : "";
                    }
                    set LyricistString(t) {
                        this.Lyricist = new a.Label(t);
                    }
                    get CopyrightString() {
                        return this.copyright ? this.copyright.text : "";
                    }
                    set CopyrightString(t) {
                        this.Copyright = new a.Label(t, f.TextAlignmentEnum.CenterBottom, void 0, !0);
                    }
                    get Title() {
                        return this.title;
                    }
                    set Title(t) {
                        this.title = t;
                    }
                    get Subtitle() {
                        return this.subtitle;
                    }
                    set Subtitle(t) {
                        this.subtitle = t;
                    }
                    get Composer() {
                        return this.composer;
                    }
                    set Composer(t) {
                        this.composer = t;
                    }
                    get FirstPageCreditWords() {
                        return this.firstPageCreditWords;
                    }
                    get Lyricist() {
                        return this.lyricist;
                    }
                    set Lyricist(t) {
                        this.lyricist = t;
                    }
                    get Copyright() {
                        return this.copyright;
                    }
                    set Copyright(t) {
                        this.copyright = t;
                    }
                    get Rules() {
                        return this.rules || (d.default.debug("warning: sheet.Rules was undefined. Creating new EngravingRules."), this.rules = new c.EngravingRules), this.rules;
                    }
                    set Rules(t) {
                        this.rules = t;
                    }
                    get SheetErrors() {
                        return this.musicSheetErrors;
                    }
                    get SelectionStart() {
                        return this.selectionStart;
                    }
                    set SelectionStart(t) {
                        this.selectionStart = t.clone(), this.currentEnrolledPosition = t.clone();
                    }
                    get SelectionEnd() {
                        return this.selectionEnd;
                    }
                    set SelectionEnd(t) {
                        this.selectionEnd = t;
                    }
                    set HasBPMInfo(t) {
                        this.hasBPMInfo = t;
                    }
                    get HasBPMInfo() {
                        return this.hasBPMInfo;
                    }
                    addMeasure(t) {
                        this.sourceMeasures.push(t), t.measureListIndex = this.sourceMeasures.length - 1;
                    }
                    checkForInstrumentWithNoVoice() {
                        for(let t = 0, e = this.instruments.length; t < e; ++t){
                            const e = this.instruments[t];
                            if (0 === e.Voices.length) {
                                const t = new l.Voice(e, 1);
                                e.Voices.push(t);
                            }
                        }
                    }
                    getStaffFromIndex(t) {
                        return this.staves[t];
                    }
                    fillStaffList() {
                        let t = 0;
                        for(let e = 0, i = this.instruments.length; e < i; ++e){
                            const i = this.instruments[e];
                            for(let e = 0, s = i.Staves.length; e < s; ++e){
                                const s = i.Staves[e];
                                s.idInMusicSheet = t, this.staves.push(s), t++;
                            }
                        }
                    }
                    get MusicPartManager() {
                        return this.musicPartManager;
                    }
                    set MusicPartManager(t) {
                        this.musicPartManager = t;
                    }
                    getCompleteNumberOfStaves() {
                        let t = 0;
                        for(let e = 0, i = this.instruments.length; e < i; ++e)t += this.instruments[e].Staves.length;
                        return t;
                    }
                    getListOfMeasuresFromIndeces(t, e) {
                        const i = [];
                        for(let s = t; s <= e; s++)i.push(this.sourceMeasures[s]);
                        return i;
                    }
                    getNextSourceMeasure(t) {
                        const e = this.sourceMeasures.indexOf(t);
                        return e === this.sourceMeasures.length - 1 ? t : this.sourceMeasures[e + 1];
                    }
                    getFirstSourceMeasure() {
                        return this.sourceMeasures[0];
                    }
                    getLastSourceMeasure() {
                        return this.sourceMeasures[this.sourceMeasures.length - 1];
                    }
                    resetAllNoteStates() {
                        const t = this.MusicPartManager.getIterator();
                        for(; !t.EndReached && t.CurrentVoiceEntries;){
                            for(let e = 0, i = t.CurrentVoiceEntries.length; e < i; ++e){
                                const i = t.CurrentVoiceEntries[e];
                                for(let t = 0, e = i.Notes.length; t < e; ++t)i.Notes[t].state = u.NoteState.Normal;
                            }
                            t.moveToNext();
                        }
                    }
                    getMusicSheetInstrumentIndex(t) {
                        return this.Instruments.indexOf(t);
                    }
                    getGlobalStaffIndexOfFirstStaff(t) {
                        const e = this.getMusicSheetInstrumentIndex(t);
                        let i = 0;
                        for(let t = 0; t < e; t++)i += this.Instruments[t].Staves.length;
                        return i;
                    }
                    setRepetitionNewUserNumberOfRepetitions(t, e) {
                        let i = 0;
                        for(let s = 0; s < this.repetitions.length; s++)if (this.repetitions[s] instanceof o.Repetition) {
                            if (t === i) {
                                this.repetitions[s].UserNumberOfRepetitions = e;
                                break;
                            }
                            i++;
                        }
                    }
                    getRepetitionByIndex(t) {
                        let e = 0;
                        for(let i = 0; i < this.repetitions.length; i++)if (this.repetitions[i] instanceof o.Repetition) {
                            if (t === e) return this.repetitions[i];
                            e++;
                        }
                    }
                    CompareTo(t) {
                        return this.Title.text.localeCompare(t.Title.text);
                    }
                    getExpressionsStartTempoInBPM() {
                        const t = this.TimestampSortedTempoExpressionsList;
                        let e = t[0];
                        if (!e || 0 !== e.AbsolutePlaybackTimestamp.RealValue) return this.userStartTempoInBPM;
                        for(let i = 1; i < t.length && 0 === t[i].AbsolutePlaybackTimestamp.RealValue; i++)e.PlaybackTempoInBpm > 0 && !(t[i].PlaybackTempoInBpm > 0) || (e = t[i]);
                        return e.InstantaneousTempo ? e.PlaybackTempoInBpm ?? e.InstantaneousTempo.TempoInBpm : e.ContinuousTempo ? e.ContinuousTempo.StartTempo : this.userStartTempoInBPM;
                    }
                    get Errors() {
                        return this.musicSheetErrors.measureErrors;
                    }
                    get FirstMeasureNumber() {
                        try {
                            return this.getFirstSourceMeasure().MeasureNumber;
                        } catch (t) {
                            return d.default.info("MusicSheet.FirstMeasureNumber: ", t), 0;
                        }
                    }
                    get LastMeasureNumber() {
                        try {
                            return this.getLastSourceMeasure().MeasureNumber;
                        } catch (t) {
                            return d.default.info("MusicSheet.LastMeasureNumber: ", t), 0;
                        }
                    }
                    get CurrentEnrolledPosition() {
                        return this.currentEnrolledPosition.clone();
                    }
                    set CurrentEnrolledPosition(t) {
                        this.currentEnrolledPosition = t.clone();
                    }
                    get Transpose() {
                        return this.transpose;
                    }
                    set Transpose(t) {
                        this.transpose = t;
                    }
                    get FullNameString() {
                        return this.ComposerString + " " + this.TitleString;
                    }
                    get IdString() {
                        return this.idString;
                    }
                    set IdString(t) {
                        this.idString = t;
                    }
                    getEnrolledSelectionStartTimeStampWorkaround() {
                        const t = this.MusicPartManager.getIterator(this.SelectionStart);
                        return n.Fraction.createFromFraction(t.CurrentEnrolledTimestamp);
                    }
                    get SheetEndTimestamp() {
                        const t = this.getLastSourceMeasure();
                        return n.Fraction.plus(t.AbsoluteTimestamp, t.Duration);
                    }
                    getSourceMeasureFromTimeStamp(t) {
                        for(let e = 0, i = this.sourceMeasures.length; e < i; ++e){
                            const i = this.sourceMeasures[e];
                            for(let e = 0, s = i.VerticalSourceStaffEntryContainers.length; e < s; ++e){
                                const s = i.VerticalSourceStaffEntryContainers[e];
                                if (t.Equals(s.getAbsoluteTimestamp())) return i;
                            }
                        }
                        return this.findSourceMeasureFromTimeStamp(t);
                    }
                    findSourceMeasureFromTimeStamp(t) {
                        for (const e of this.sourceMeasures)if (e.AbsoluteTimestamp.lte(t) && t.lt(n.Fraction.plus(e.AbsoluteTimestamp, e.Duration))) return e;
                    }
                    getVisibleInstruments() {
                        const t = [];
                        for(let e = 0, i = this.Instruments.length; e < i; ++e){
                            const i = this.Instruments[e];
                            i.Voices.length > 0 && i.Voices[0].Visible && t.push(i);
                        }
                        return t;
                    }
                }
                e.MusicSheet = p, p.defaultTitle = "defaultTitle";
            },
            1325 (t, e) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.MappingSourceMusicPart = void 0, e.MappingSourceMusicPart = class {
                    constructor(t, e, i, s = -1, n = !1){
                        this.repetitionRun = -1, this.sourceMusicPart = t, this.parentPartListEntry = i, this.startTimestamp = e.clone(), this.repetitionRun = s, this.parentRepetition = i, this.isEnding = n;
                    }
                    get IsRepetition() {
                        return void 0 !== this.parentRepetition;
                    }
                    get IsEnding() {
                        return this.isEnding;
                    }
                    get IsLastRepetitionRun() {
                        return this.IsRepetition && this.repetitionRun + 1 === this.parentRepetition.UserNumberOfRepetitions;
                    }
                    get RepetitionRun() {
                        return this.repetitionRun;
                    }
                    get ParentPartListEntry() {
                        return this.parentPartListEntry;
                    }
                    get SourceMusicPart() {
                        return this.sourceMusicPart;
                    }
                    get StartTimestamp() {
                        return this.startTimestamp;
                    }
                    CompareTo(t) {
                        return t ? this.startTimestamp.CompareTo(t.startTimestamp) : 1;
                    }
                };
            },
            7551 (t, e) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.PartListEntry = void 0, e.PartListEntry = class {
                    constructor(t){
                        this.enrolledTimestamps = [], this.visible = !0, this.musicSheet = t;
                    }
                    get Visible() {
                        return this.visible;
                    }
                    set Visible(t) {
                        this.visible = t;
                    }
                    getFirstSourceMeasure() {
                        return this.musicSheet.SourceMeasures[this.startIndex];
                    }
                    getLastSourceMeasure() {
                        return this.musicSheet.SourceMeasures[this.endIndex];
                    }
                };
            },
            6001 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.RepetitionEndingPart = e.Repetition = void 0;
                const n = i(3457), r = i(2561), o = i(7551), a = s(i(3065));
                class l extends o.PartListEntry {
                    constructor(t, e = !1){
                        super(t), this.SkipRepetition = !1, this.userNumberOfRepetitions = 0, this.backwardJumpInstructions = [], this.endingParts = [], this.endingIndexDict = {}, this.visibles = [], this.fromWords = !1, this.repetitonIterationOrder = [], this.numberOfEndings = 1, this.musicSheet2 = t, this.virtualOverallRepetition = e;
                    }
                    get BackwardJumpInstructions() {
                        return this.backwardJumpInstructions;
                    }
                    get EndingIndexDict() {
                        return this.endingIndexDict;
                    }
                    get EndingParts() {
                        return this.endingParts;
                    }
                    get Visibles() {
                        return this.visibles;
                    }
                    set Visibles(t) {
                        this.visibles = t;
                    }
                    get DefaultNumberOfRepetitions() {
                        let t = 2;
                        return this.virtualOverallRepetition && (t = 1), Math.max(t, Object.keys(this.endingIndexDict).length, this.checkRepetitionForMultipleLyricVerses());
                    }
                    get UserNumberOfRepetitions() {
                        return this.userNumberOfRepetitions;
                    }
                    set UserNumberOfRepetitions(t) {
                        this.userNumberOfRepetitions = t, this.repetitonIterationOrder = [];
                        const e = this.userNumberOfRepetitions - this.NumberOfEndings;
                        for(let t = 1; t <= this.userNumberOfRepetitions; t++)t <= e ? this.repetitonIterationOrder.push(1) : this.repetitonIterationOrder.push(t - e);
                    }
                    getForwardJumpTargetForIteration(t) {
                        const e = this.repetitonIterationOrder[t - 1];
                        return this.endingIndexDict[e] ? this.endingIndexDict[e].part.StartIndex : -1;
                    }
                    getBackwardJumpTarget() {
                        return this.startMarker.measureIndex;
                    }
                    setEndingsStartIndex(t, e) {
                        const i = new h(new n.SourceMusicPart(this.musicSheet2, e, e));
                        this.endingParts.push(i);
                        for (const e of t)try {
                            this.endingIndexDict[e] = i, i.endingIndices.push(e), this.numberOfEndings < e && (this.numberOfEndings = e);
                        } catch (t) {
                            a.default.error("Repetition: Exception.", t);
                        }
                    }
                    setEndingStartIndex(t, e) {
                        const i = new h(new n.SourceMusicPart(this.musicSheet2, e, e));
                        this.EndingIndexDict[t] = i, this.endingParts.push(i), i.endingIndices.push(t), this.numberOfEndings < t && (this.numberOfEndings = t);
                    }
                    setEndingEndIndex(t, e) {
                        this.endingIndexDict[t] && this.endingIndexDict[t].part.setEndIndex(e);
                    }
                    get NumberOfEndings() {
                        return this.numberOfEndings;
                    }
                    get FromWords() {
                        return this.fromWords;
                    }
                    set FromWords(t) {
                        this.fromWords = t;
                    }
                    get AbsoluteTimestamp() {
                        return r.Fraction.createFromFraction(this.musicSheet2.SourceMeasures[this.startMarker.measureIndex].AbsoluteTimestamp);
                    }
                    get StartIndex() {
                        return this.startMarker.measureIndex;
                    }
                    get EndIndex() {
                        if (0 === this.BackwardJumpInstructions.length) return this.StartIndex;
                        let t = this.backwardJumpInstructions[this.backwardJumpInstructions.length - 1].measureIndex;
                        return this.endingIndexDict[this.NumberOfEndings] && (t = Math.max(this.endingIndexDict[this.NumberOfEndings].part.EndIndex, t)), t;
                    }
                    checkRepetitionForMultipleLyricVerses() {
                        let t = 0;
                        const e = this.StartIndex, i = this.EndIndex;
                        for(let s = e; s <= i; s++){
                            const e = this.musicSheet2.SourceMeasures[s];
                            for(let i = 0; i < e.CompleteNumberOfStaves; i++)if (e.VerticalSourceStaffEntryContainers[i]) {
                                for (const s of e.VerticalSourceStaffEntryContainers[i].StaffEntries)if (s) {
                                    let e = 0;
                                    for (const t of s.VoiceEntries)e += t.LyricsEntries.keys.length;
                                    t = Math.max(t, e);
                                }
                            }
                        }
                        return t;
                    }
                    get FirstSourceMeasureNumber() {
                        return this.getFirstSourceMeasure().MeasureNumber;
                    }
                    get LastSourceMeasureNumber() {
                        return this.getLastSourceMeasure().MeasureNumber;
                    }
                    coversIdenticalMeasures(t) {
                        return this.StartIndex === t.StartIndex && this.EndIndex === t.EndIndex;
                    }
                    removeFromRepetitionInstructions() {
                        void 0 !== this.startMarker && (this.startMarker.parentRepetition = void 0), void 0 !== this.endMarker && (this.endMarker.parentRepetition = void 0);
                        for (const t of this.BackwardJumpInstructions)t.parentRepetition = void 0;
                    }
                }
                e.Repetition = l;
                class h {
                    constructor(t){
                        this.endingIndices = [], this.part = t;
                    }
                    ToString() {
                        return this.endingIndices.join(", ");
                    }
                }
                e.RepetitionEndingPart = h;
            },
            3457 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.SourceMusicPart = void 0;
                const s = i(7551), n = i(2561);
                class r extends s.PartListEntry {
                    constructor(t, e, i){
                        super(t), this.musicSheet = t, this.startIndex = e, this.endIndex = i;
                    }
                    get MeasuresCount() {
                        return this.endIndex - this.startIndex + 1;
                    }
                    get StartIndex() {
                        return this.startIndex;
                    }
                    get EndIndex() {
                        return this.endIndex;
                    }
                    get ParentRepetition() {
                        return this.parentRepetition;
                    }
                    set ParentRepetition(t) {
                        this.parentRepetition = t;
                    }
                    get AbsoluteTimestamp() {
                        return n.Fraction.createFromFraction(this.musicSheet.SourceMeasures[this.startIndex].AbsoluteTimestamp);
                    }
                    setStartIndex(t) {
                        this.startIndex = t;
                    }
                    setEndIndex(t) {
                        this.endIndex = t;
                    }
                }
                e.SourceMusicPart = r;
            },
            4076 (t, e, i) {
                "use strict";
                var s = this && this.__createBinding || (Object.create ? function(t, e, i, s) {
                    void 0 === s && (s = i);
                    var n = Object.getOwnPropertyDescriptor(e, i);
                    n && !("get" in n ? !e.__esModule : n.writable || n.configurable) || (n = {
                        enumerable: !0,
                        get: function() {
                            return e[i];
                        }
                    }), Object.defineProperty(t, s, n);
                } : function(t, e, i, s) {
                    void 0 === s && (s = i), t[s] = e[i];
                }), n = this && this.__exportStar || function(t, e) {
                    for(var i in t)"default" === i || Object.prototype.hasOwnProperty.call(e, i) || s(e, t, i);
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), n(i(1325), e), n(i(7551), e), n(i(6001), e), n(i(3457), e);
            },
            1272 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.InstrumentReader = void 0;
                const n = i(469), r = i(2369), o = i(164), a = i(4543), l = i(8931), h = i(9288), c = i(2561), u = i(9767), d = i(7307), f = i(164), m = i(9288), p = i(4543), g = s(i(3065)), b = i(164), S = i(9536), y = i(5984), E = i(3186), x = i(1336), v = i(5282), T = i(6954);
                class _ {
                    constructor(t, e, i, s){
                        this.voiceGeneratorsDict = {}, this.staffMainVoiceGeneratorDict = {}, this.divisions = 0, this.currentClefNumber = 1, this.currentXmlMeasureIndex = 0, this.pendingEndKeys = [], this.abstractInstructions = [], this.repetitionInstructionReader = e, this.xmlMeasureList = i, this.musicSheet = s.GetMusicSheet, this.instrument = s, this.activeClefs = new Array(s.Staves.length), this.activeKeys = new Array(s.Staves.length), this.activeKeysHaveBeenInitialized = new Array(s.Staves.length).fill(!1), this.activeClefsHaveBeenInitialized = new Array(s.Staves.length);
                        for(let t = 0; t < s.Staves.length; t++)this.activeClefsHaveBeenInitialized[t] = !1;
                        this.createExpressionGenerators(s.Staves.length), this.slurReader = new E.SlurReader(this.musicSheet), this.pluginManager = t;
                    }
                    get ActiveKey() {
                        return this.activeKeys[0];
                    }
                    get MaxTieNoteFraction() {
                        return this.maxTieNoteFraction;
                    }
                    get ActiveRhythm() {
                        return this.activeRhythm;
                    }
                    set ActiveRhythm(t) {
                        this.activeRhythm = t;
                    }
                    readNextXmlMeasure(t, e, i, s = !0) {
                        if (this.currentXmlMeasureIndex >= this.xmlMeasureList.length) return !1;
                        this.currentMeasure = t, this.followingMultirestMeasures = Math.max(this.followingMultirestMeasures - 1, 0), this.inSourceMeasureInstrumentIndex = this.musicSheet.getGlobalStaffIndexOfFirstStaff(this.instrument);
                        for(let e = 0; e < this.pendingEndKeys.length; e++){
                            const i = this.pendingEndKeys[e];
                            i && (this.storeInitialKeyInstruction(t, e, i), this.activeKeys[e] = i);
                        }
                        this.pendingEndKeys = [], this.keyAtMeasureStart = Array.from(this.activeKeys, (t)=>t?.Key ?? 0), this.repetitionInstructionReader && this.repetitionInstructionReader.prepareReadingMeasure(t, this.currentXmlMeasureIndex);
                        let n = new c.Fraction(0, 1), r = new c.Fraction(0, 1);
                        this.measureEndFraction = new c.Fraction(0, 1);
                        let o = !1;
                        this.maxTieNoteFraction = new c.Fraction(0, 1);
                        let a = !1;
                        try {
                            const l = this.xmlMeasureList[this.currentXmlMeasureIndex], h = l.elements();
                            let f;
                            t.Rules.UseXMLMeasureNumbers && !Number.isInteger(t.MeasureNumberXML) && (f = parseInt(l.attribute("number")?.value, 10), Number.isInteger(f) && (t.MeasureNumberXML = f)), "yes" === l.attribute("implicit")?.value && (t.ImplicitMeasureFromXml = !0);
                            const m = l.attribute("osmdWidthFactor");
                            if (m) {
                                const e = Number.parseFloat(m.value);
                                "number" != typeof e || isNaN(e) ? g.default.info(`xml parse: osmdWidthFactor invalid for measure ${f}`) : t.WidthFactor = e;
                            }
                            let p;
                            for(let l = 0; l < h.length; l++){
                                const f = h[l];
                                if (l > 0 && (p = h[l - 1]), "print" === f.name) {
                                    const e = f.attribute("new-system");
                                    "yes" === e?.value && (t.printNewSystemXml = !0);
                                    const i = f.attribute("new-page");
                                    "yes" === i?.value && (t.printNewPageXml = !0);
                                } else if ("attributes" === f.name) {
                                    const e = f.element("divisions");
                                    if (e && (this.divisions = parseInt(e.value, 10), isNaN(this.divisions))) {
                                        const t = u.ITextTranslation.translateText("ReaderErrorMessages/DivisionError", "Invalid divisions value at Instrument: ");
                                        if (g.default.debug("InstrumentReader.readNextXmlMeasure", t), this.divisions = this.readDivisionsFromNotes(), !(this.divisions > 0)) throw o = !0, new d.MusicSheetReadingException(t + this.instrument.Name);
                                        this.musicSheet.SheetErrors.push(t + this.instrument.Name);
                                    }
                                    if (!f.element("divisions") && 0 === this.divisions && 0 === this.currentXmlMeasureIndex) {
                                        const t = u.ITextTranslation.translateText("ReaderErrorMessages/DivisionError", "Invalid divisions value at Instrument: ");
                                        if (this.divisions = this.readDivisionsFromNotes(), !(this.divisions > 0)) throw o = !0, new d.MusicSheetReadingException(t + this.instrument.Name);
                                        this.musicSheet.SheetErrors.push(t + this.instrument.Name);
                                    }
                                    this.addAbstractInstruction(f, i, p, n.clone()), n.Equals(new c.Fraction(0, 1)) && this.isAttributesNodeAtBeginOfMeasure(this.xmlMeasureList[this.currentXmlMeasureIndex], f) && (this.saveAbstractInstructionList(this.instrument.Staves.length, !0), this.readMeasureRepeats(f)), this.isAttributesNodeAtEndOfMeasure(this.xmlMeasureList[this.currentXmlMeasureIndex], f, n) && this.saveClefInstructionAtEndOfMeasure();
                                    const s = f.elements("staff-details");
                                    for (const t of s){
                                        const e = t.element("staff-lines");
                                        if (e) {
                                            let i = 1;
                                            const s = t.attribute("number");
                                            s && (i = parseInt(s.value, 10));
                                            const n = this.instrument.Staves[i - 1];
                                            n.StafflineCount = parseInt(e.value, 10), n.xmlStafflineCount = isNaN(n.StafflineCount) ? void 0 : n.StafflineCount;
                                        }
                                    }
                                    const r = f.element("measure-style");
                                    if (r) {
                                        const e = r.element("multiple-rest");
                                        if (e) {
                                            const i = e.value;
                                            let s = 0;
                                            try {
                                                s = Number.parseInt(i, 10), void 0 !== t.multipleRestMeasures && s !== t.multipleRestMeasures ? t.multipleRestMeasures = 0 : (t.multipleRestMeasures = s, this.currentMultirestStartMeasure = t, this.followingMultirestMeasures = s + 1);
                                            } catch (t) {
                                                console.log("multirest parse error: " + t);
                                            }
                                        }
                                    }
                                } else if ("note" === f.name) {
                                    let t = !0;
                                    "no" === f.attribute("print-object")?.value && (t = !1);
                                    const l = this.getNoteStaff(f);
                                    this.currentStaff = this.instrument.Staves[l - 1];
                                    const h = void 0 !== f.element("chord");
                                    if (f.element("voice")) {
                                        const t = parseInt(f.element("voice").value, 10);
                                        this.currentVoiceGenerator = this.getOrCreateVoiceGenerator(t, l - 1);
                                    } else h && this.currentVoiceGenerator || (this.currentVoiceGenerator = this.getOrCreateVoiceGenerator(1, l - 1));
                                    let m, p = 0, b = new c.Fraction(0, 1), S = 2;
                                    const y = void 0 !== f.element("rest");
                                    if (f.element("duration")) {
                                        if (0 === this.divisions && 0 === this.currentXmlMeasureIndex) {
                                            if (this.divisions = this.readDivisionsFromNotes(), 0 === this.divisions) {
                                                const t = u.ITextTranslation.translateText("ReaderErrorMessages/DivisionError", "Invalid divisions value at Instrument: ");
                                                throw o = !0, new d.MusicSheetReadingException(t + this.instrument.Name);
                                            }
                                            this.musicSheet.SheetErrors.push(u.ITextTranslation.translateText("ReaderErrorMessages/DivisionError", "Invalid divisions value at Instrument: ") + this.instrument.Name);
                                        }
                                        if (p = parseInt(f.element("duration").value, 10), isNaN(p)) {
                                            const t = u.ITextTranslation.translateText("ReaderErrorMessages/NoteDurationError", "Invalid Note Duration.");
                                            this.musicSheet.SheetErrors.pushMeasureError(t), g.default.debug("InstrumentReader.readNextXmlMeasure", t);
                                            continue;
                                        }
                                        if (b = new c.Fraction(p, 4 * this.divisions), y && b.RealValue > this.ActiveRhythm?.Rhythm.RealValue && (b = this.ActiveRhythm.Rhythm.clone()), 0 === p ? b = this.getNoteDurationFromTypeNode(f) : m = this.getNoteDurationFromTypeNode(f), f.element("time-modification")) {
                                            b = this.getNoteDurationForTuplet(f);
                                            const t = f.element("time-modification");
                                            t?.element("normal-notes") && (S = parseInt(t.element("normal-notes").value, 10));
                                        }
                                    }
                                    const E = f.combinedElement("notations"), x = void 0 !== f.element("grace") || 0 === p || h && a;
                                    let v = !1, T = !1;
                                    if (x) {
                                        const t = f.element("grace");
                                        t && t.attributes() && t.attribute("slash") && "yes" === t.attribute("slash").value && (v = !0), b = this.getNoteDurationFromTypeNode(f), E && E.element("slur") && (T = !0);
                                    }
                                    const [_, M] = this.getCueNoteAndNoteTypeXml(f), [P, L, w] = this.getStemDirectionAndColors(f);
                                    let A;
                                    if (E) {
                                        const t = E.element("ornaments");
                                        t && (A = this.getTremoloInfo(t), this.getWavyLines(t, f, n, r));
                                    }
                                    const I = h ? r.clone() : n.clone();
                                    this.currentStaffEntry = this.currentMeasure.findOrCreateStaffEntry(I, this.inSourceMeasureInstrumentIndex + l - 1, this.currentStaff).staffEntry, (!this.currentVoiceGenerator.hasVoiceEntry() || !h && !x && !a || x && !a || x && !h || !x && a) && this.currentVoiceGenerator.createVoiceEntry(I, this.currentStaffEntry, !x, x, v, T), x || h || (r = n.clone(), n.Add(b)), h && void 0 !== this.currentStaffEntry && this.currentStaffEntry.ParentStaff !== this.currentStaff && (this.currentStaffEntry = this.currentVoiceGenerator.checkForStaffEntryLink(this.inSourceMeasureInstrumentIndex + l - 1, this.currentStaff, this.currentStaffEntry, this.currentMeasure));
                                    const R = void 0 !== this.currentStaffEntry && void 0 !== this.currentStaffEntry.Timestamp && this.currentStaffEntry.Timestamp.Equals(new c.Fraction(0, 1)) && !this.currentStaffEntry.hasNotes();
                                    this.saveAbstractInstructionList(this.instrument.Staves.length, R), this.activeRhythm;
                                    const N = f.elements("dot").length;
                                    if (this.currentVoiceGenerator.read(f, b, m, M, S, y, this.currentStaffEntry, this.currentMeasure, e, this.maxTieNoteFraction, h, i, t, _, x, P, A, L, w, N), s && void 0 !== E && E.element("dynamics")) {
                                        const t = this.expressionReaders[this.readExpressionStaffNumber(f) - 1];
                                        t && (t.readExpressionParameters(E.element("dynamics"), this.instrument, this.divisions, n, r, this.currentMeasure.MeasureNumber, !1), t.read(f, this.currentMeasure, I, void 0, [
                                            E
                                        ]));
                                    }
                                    a = x;
                                } else if ("forward" === f.name) {
                                    const t = parseInt(f.element("duration").value, 10);
                                    n.Add(new c.Fraction(t, 4 * this.divisions));
                                } else if ("backup" === f.name) {
                                    const t = parseInt(f.element("duration").value, 10);
                                    n.Sub(new c.Fraction(t, 4 * this.divisions)), n.IsNegative() && (n = new c.Fraction(0, 1)), r.Sub(new c.Fraction(t, 4 * this.divisions)), r.IsNegative() && (r = new c.Fraction(0, 1));
                                } else if ("direction" === f.name) {
                                    const t = f.elements("direction-type"), e = t[0];
                                    let i = Math.min(1, n.RealValue);
                                    void 0 !== this.activeRhythm && this.activeRhythm.Rhythm && (i /= this.activeRhythm.Rhythm.RealValue);
                                    let s = !1;
                                    if (this.repetitionInstructionReader && (s = this.repetitionInstructionReader.handleRepetitionInstructionsFromWordsOrSymbols(e, i, f.element("sound"))), !s || t.length > 1) {
                                        let e = this.expressionReaders[0];
                                        const i = this.readExpressionStaffNumber(f) - 1;
                                        if (i < this.expressionReaders.length && (e = this.expressionReaders[i]), e) {
                                            if (t.some((t)=>t.element("octave-shift"))) {
                                                e.readExpressionParameters(f, this.instrument, this.divisions, n, r, this.currentMeasure.MeasureNumber, !0);
                                                let t, i = 0;
                                                this.currentStaffEntry?.Timestamp?.Equals(n) ? (i = this.currentStaffEntry.VoiceEntries.length, t = n.clone()) : t = r.clone(), e.addOctaveShift(f, this.currentMeasure, t, i);
                                            }
                                            t.some((t)=>t.element("pedal")) && (e.readExpressionParameters(f, this.instrument, this.divisions, n, r, this.currentMeasure.MeasureNumber, !0), e.addPedalMarking(f, this.currentMeasure, n.clone())), e.readExpressionParameters(f, this.instrument, this.divisions, n, r, this.currentMeasure.MeasureNumber, !1), e.read(f, this.currentMeasure, n, r.clone(), s ? t.slice(1) : t);
                                        }
                                    }
                                } else if ("barline" === f.name) {
                                    this.repetitionInstructionReader && this.repetitionInstructionReader.handleLineRepetitionInstructions(f) && (this.currentMeasure.HasEndLine = !0);
                                    const t = f.attribute("location"), e = t?.value ?? "right";
                                    if (l === h.length - 1 || "right" === e) {
                                        const t = f.element("bar-style")?.value;
                                        t && (this.currentMeasure.endingBarStyleXml = t, this.currentMeasure.endingBarStyleEnum = T.SystemLinesEnumHelper.xmlBarlineStyleToSystemLinesEnum(t));
                                    }
                                } else if ("sound" === f.name) try {
                                    if (f.attribute("tempo")) {
                                        const t = parseFloat(f.attribute("tempo").value);
                                        0 === this.currentXmlMeasureIndex && (this.musicSheet.DefaultStartTempoInBpm = t, this.musicSheet.HasBPMInfo = !0);
                                    }
                                } catch (t) {
                                    g.default.debug("InstrumentReader.readTempoInstruction", t);
                                }
                                else if ("harmony" === f.name) {
                                    const t = this.getNoteStaff(f);
                                    this.currentStaff = this.instrument.Staves[t - 1];
                                    const e = n.clone();
                                    this.currentStaffEntry = this.currentMeasure.findOrCreateStaffEntry(e, this.inSourceMeasureInstrumentIndex + t - 1, this.currentStaff).staffEntry, this.currentStaffEntry.ChordContainers.push(S.ChordSymbolReader.readChordSymbol(f, this.musicSheet, this.activeKeys[t - 1]));
                                }
                                this.measureEndFraction = c.Fraction.max(this.measureEndFraction, n).clone();
                            }
                            for(const t in this.voiceGeneratorsDict)this.voiceGeneratorsDict.hasOwnProperty(t) && this.voiceGeneratorsDict[t].checkForOpenBeam();
                            if (this.attachGraceNotesAfterMainNote(), this.currentXmlMeasureIndex === this.xmlMeasureList.length - 1) {
                                for(let t = 0; t < this.instrument.Staves.length; t++)this.activeClefsHaveBeenInitialized[t] || this.createDefaultClefInstruction(this.musicSheet.getGlobalStaffIndexOfFirstStaff(this.instrument) + t);
                                for(let t = 0; t < this.instrument.Staves.length; t++)this.activeKeysHaveBeenInitialized[t] || this.createDefaultKeyInstruction(t);
                                for(let t = 0; t < this.expressionReaders.length; t++){
                                    const e = this.expressionReaders[t];
                                    e && e.closeOpenExpressions(this.currentMeasure, n);
                                }
                            }
                            this.musicSheet.HasBPMInfo ? 0 === t.TempoInBPM && this.previousMeasure && (this.currentMeasure.TempoInBPM = this.previousMeasure.TempoInBPM) : this.currentMeasure.TempoInBPM = 120;
                        } catch (t) {
                            if (o) throw new d.MusicSheetReadingException(t.Message);
                            const e = u.ITextTranslation.translateText("ReaderErrorMessages/MeasureError", "Error while reading Measure.");
                            this.musicSheet.SheetErrors.pushMeasureError(e), g.default.debug("InstrumentReader.readNextXmlMeasure", e, t);
                        }
                        return this.previousMeasure = this.currentMeasure, this.currentXmlMeasureIndex += 1, !0;
                    }
                    attachGraceNotesAfterMainNote() {
                        for(let t = 0; t < this.instrument.Staves.length; t++){
                            const e = this.inSourceMeasureInstrumentIndex + t, i = {};
                            let s = [];
                            for (const t of this.currentMeasure.VerticalSourceStaffEntryContainers){
                                const n = t.StaffEntries[e];
                                if (n) for (const t of n.VoiceEntries)t.IsGrace ? s.push(t) : (i[t.ParentVoice.VoiceId] = t, s = []);
                            }
                            for (const t of s){
                                const e = i[t.ParentVoice.VoiceId]?.ParentSourceStaffEntry;
                                if (!e) continue;
                                t.GraceAfterMainNote = !0;
                                const s = t.ParentSourceStaffEntry;
                                s !== e && (s.VoiceEntries.splice(s.VoiceEntries.indexOf(t), 1), t.ParentSourceStaffEntry = e, t.Timestamp = e.Timestamp.clone(), e.VoiceEntries.push(t));
                            }
                        }
                    }
                    getStemDirectionAndColors(t) {
                        let e, i = x.StemDirectionType.Undefined;
                        const s = t.element("stem");
                        if (s) {
                            i = this.getStemDirectionType(s);
                            const t = s.attribute("color");
                            t && (e = this.parseXmlColor(t.value));
                        }
                        let n = this.getNoteHeadColorXml(t);
                        const r = this.getNoteColorXml(t);
                        return r && !n && (n = r), r && !e && (e = r), [
                            i,
                            e,
                            n
                        ];
                    }
                    parseXmlColor(t) {
                        return t;
                    }
                    doCalculationsAfterDurationHasBeenSet() {
                        for(const t in this.voiceGeneratorsDict)this.voiceGeneratorsDict.hasOwnProperty(t) && this.voiceGeneratorsDict[t].checkOpenTies();
                    }
                    finalizeKeyInstructions() {
                        const t = c.Fraction.max(this.currentMeasure.Duration, this.measureEndFraction);
                        for(let e = 0; e < this.instrument.Staves.length; e++){
                            const i = this.inSourceMeasureInstrumentIndex + e;
                            let s = this.currentMeasure.getKeyInstruction(i)?.Key ?? this.keyAtMeasureStart[e];
                            for (const n of this.currentMeasure.getEntriesPerStaff(i))for (const i of n.Instructions.slice())if (i instanceof a.KeyInstruction) {
                                if (i.Key === s) {
                                    n.Instructions.splice(n.Instructions.indexOf(i), 1);
                                    continue;
                                }
                                s = i.Key, this.activeKeys[e] = i, n.Timestamp.Equals(t) && (this.pendingEndKeys[e] = i, n.Instructions.splice(n.Instructions.indexOf(i), 1));
                            }
                        }
                    }
                    getOrCreateVoiceGenerator(t, e) {
                        const i = this.instrument.Staves[e];
                        let s = this.voiceGeneratorsDict[t];
                        if (s) -1 === i.Voices.indexOf(s.GetVoice) && i.Voices.push(s.GetVoice);
                        else {
                            const r = this.staffMainVoiceGeneratorDict[e];
                            r ? (s = new n.VoiceGenerator(this.pluginManager, i, t, this.slurReader, r.GetVoice), i.Voices.push(s.GetVoice), this.voiceGeneratorsDict[t] = s) : (s = new n.VoiceGenerator(this.pluginManager, i, t, this.slurReader), i.Voices.push(s.GetVoice), this.voiceGeneratorsDict[t] = s, this.staffMainVoiceGeneratorDict[e] = s);
                        }
                        return s;
                    }
                    createExpressionGenerators(t) {
                        this.expressionReaders = new Array(t);
                        for(let e = 0; e < t; e++)this.expressionReaders[e] = new y.ExpressionReader(this.musicSheet, this.instrument, e + 1);
                    }
                    createDefaultClefInstruction(t) {
                        let e;
                        e = this.musicSheet.SourceMeasures.length > 0 ? this.musicSheet.SourceMeasures[0] : this.currentMeasure;
                        const i = new o.ClefInstruction(f.ClefEnum.G, 0, 2);
                        let s;
                        e.FirstInstructionsStaffEntries[t] ? (s = e.FirstInstructionsStaffEntries[t], s.removeFirstInstructionOfTypeClefInstruction()) : (s = new r.SourceStaffEntry(void 0, void 0), e.FirstInstructionsStaffEntries[t] = s), i.Parent = s, s.Instructions.splice(0, 0, i);
                    }
                    createDefaultKeyInstruction(t) {
                        let e;
                        e = this.musicSheet.SourceMeasures.length > 0 ? this.musicSheet.SourceMeasures[0] : this.currentMeasure;
                        const i = new a.KeyInstruction(void 0, 0, p.KeyEnum.major);
                        this.storeInitialKeyInstruction(e, t, i), this.activeKeys[t] = i;
                    }
                    storeInitialKeyInstruction(t, e, i) {
                        const s = this.inSourceMeasureInstrumentIndex + e;
                        let n = t.FirstInstructionsStaffEntries[s];
                        n || (n = new r.SourceStaffEntry(void 0, void 0), t.FirstInstructionsStaffEntries[s] = n), n.removeFirstInstructionOfTypeKeyInstruction(), i.Parent = n;
                        const a = n.Instructions[0] instanceof o.ClefInstruction ? 1 : 0;
                        n.Instructions.splice(a, 0, i);
                    }
                    readMeasureRepeats(t) {
                        for (const e of t.elements("measure-style")){
                            const t = e.element("measure-repeat");
                            if (!t) continue;
                            let i, s = !0;
                            const n = e.attribute("number");
                            n && (i = parseInt(n.value, 10), s = !isNaN(i) && i >= 1 && i <= this.instrument.Staves.length);
                            let r = l.MeasureRepeatType.Invalid, o = 0, a = 1;
                            const h = t.attribute("type")?.value;
                            if (s) {
                                if ("stop" === h) r = l.MeasureRepeatType.Stop;
                                else if ("start" === h) {
                                    if (o = parseInt(t.value, 10), !isNaN(o) && _.SUPPORTED_MEASURE_REPEAT_LENGTHS.includes(o)) {
                                        r = l.MeasureRepeatType.Start;
                                        const e = t.attribute("slashes");
                                        if (e) {
                                            const t = parseInt(e.value, 10);
                                            a = !isNaN(t) && t >= 1 ? t : 1;
                                        }
                                    } else o = 0;
                                }
                            }
                            const c = new l.MeasureRepeatInstruction(r, o, a);
                            for(let t = 0; t < this.instrument.Staves.length; t++){
                                if (s && void 0 !== i && t !== i - 1) continue;
                                const e = this.inSourceMeasureInstrumentIndex + t, n = this.currentMeasure.MeasureRepeatInstructions.get(e) ?? [];
                                n.push(c), this.currentMeasure.MeasureRepeatInstructions.set(e, n);
                            }
                        }
                    }
                    isAttributesNodeAtBeginOfMeasure(t, e) {
                        const i = t.elements(), s = i.indexOf(e);
                        if (s > 0 && "backup" === i[s - 1].name) return !0;
                        let n = -1;
                        for(let t = 0; t < i.length; t++)if ("note" === i[t].name) {
                            n = t;
                            break;
                        }
                        return s < n && n > 0 || n < 0;
                    }
                    isAttributesNodeAtEndOfMeasure(t, e, i) {
                        if (i.Equals(this.ActiveRhythm?.Rhythm)) return !0;
                        const s = t.elements().slice();
                        let n = 0;
                        for(let t = 0; t < s.length; t++)if (s[t] === e) {
                            n = t;
                            break;
                        }
                        let r = 0;
                        for(let t = n; t < s.length; t++)if ("note" === s[t].name) {
                            r = t;
                            break;
                        }
                        return n > r;
                    }
                    getNoteDurationFromTypeNode(t) {
                        const e = t.element("type");
                        if (e) {
                            const t = e.value;
                            return v.NoteTypeHandler.getNoteDurationFromType(t);
                        }
                        return new c.Fraction(0, 4 * this.divisions);
                    }
                    addAbstractInstruction(t, e, i, s) {
                        if (t.element("divisions") && 1 === t.elements().length) return;
                        const n = t.element("transpose");
                        if (n) {
                            const t = n.element("chromatic"), e = n.element("octave-change"), i = t ? parseInt(t.value, 10) : NaN, s = e ? parseInt(e.value, 10) : NaN;
                            isNaN(i) && isNaN(s) || (this.instrument.PlaybackTranspose = (isNaN(i) ? 0 : i) + 12 * (isNaN(s) ? 0 : s));
                        }
                        const r = t.elements("clef");
                        let l;
                        if (r.length > 0) for(let t = 0, e = r.length; t < e; ++t){
                            const e = r[t];
                            let i = f.ClefEnum.G, n = 2, a = 1, h = 0;
                            const c = e.element("line");
                            if (c) try {
                                n = parseInt(c.value, 10);
                            } catch (t) {
                                l = u.ITextTranslation.translateText("ReaderErrorMessages/ClefLineError", "Invalid clef line. Using default."), this.musicSheet.SheetErrors.pushMeasureError(l), n = 2, g.default.debug("InstrumentReader.addAbstractInstruction", l, t);
                            }
                            const d = e.element("sign");
                            if (d) try {
                                i = f.ClefEnum[d.value], o.ClefInstruction.isSupportedClef(i) || (l = u.ITextTranslation.translateText("ReaderErrorMessages/ClefError", "Unsupported clef. Using default."), this.musicSheet.SheetErrors.pushMeasureError(l), i = f.ClefEnum.G, n = 2), i === f.ClefEnum.TAB && (h = -1);
                            } catch (t) {
                                l = u.ITextTranslation.translateText("ReaderErrorMessages/ClefError", "Invalid clef. Using default."), this.musicSheet.SheetErrors.pushMeasureError(l), i = f.ClefEnum.G, n = 2, g.default.debug("InstrumentReader.addAbstractInstruction", l, t);
                            }
                            const m = e.element("clef-octave-change");
                            if (m) try {
                                h = parseInt(m.value, 10);
                            } catch (t) {
                                l = u.ITextTranslation.translateText("ReaderErrorMessages/ClefOctaveError", "Invalid clef octave. Using default."), this.musicSheet.SheetErrors.pushMeasureError(l), h = 0;
                            }
                            if (e.hasAttributes && e.attribute("number")) try {
                                a = parseInt(e.attribute("number").value, 10), a > this.currentClefNumber && (a = this.currentClefNumber), this.currentClefNumber = a + 1;
                            } catch (t) {
                                l = u.ITextTranslation.translateText("ReaderErrorMessages/ClefError", "Invalid clef. Using default."), this.musicSheet.SheetErrors.pushMeasureError(l), a = 1, this.currentClefNumber = a + 1;
                            }
                            const p = new o.ClefInstruction(i, h, n);
                            this.abstractInstructions.push([
                                a,
                                p,
                                s
                            ]);
                        }
                        for (const e of t.elements("key")){
                            if (this.instrument.MidiInstrumentId === b.MidiInstrument.Percussion) continue;
                            const t = parseInt(e.attribute("number")?.value, 10);
                            let i = 0;
                            const n = e.element("fifths");
                            if (n) try {
                                i = parseInt(n.value, 10);
                            } catch (t) {
                                l = u.ITextTranslation.translateText("ReaderErrorMessages/KeyError", "Invalid key. Set to default."), this.musicSheet.SheetErrors.pushMeasureError(l), i = 0, g.default.debug("InstrumentReader.addAbstractInstruction", l, t);
                            }
                            let r = p.KeyEnum.none;
                            const o = e.element("mode");
                            if (o) try {
                                r = p.KeyEnum[o.value];
                            } catch (t) {
                                l = u.ITextTranslation.translateText("ReaderErrorMessages/KeyError", "Invalid key/mode. Set to default."), this.musicSheet.SheetErrors.pushMeasureError(l), r = p.KeyEnum.major, g.default.debug("InstrumentReader.addAbstractInstruction", l, t);
                            }
                            for(let e = 0; e < this.instrument.Staves.length; e++){
                                if (t >= 1 && t <= this.instrument.Staves.length && t !== e + 1) continue;
                                const n = new a.KeyInstruction(void 0, i, r);
                                if (s.RealValue > 0) {
                                    this.activeKeysHaveBeenInitialized[e] || (this.createDefaultKeyInstruction(e), this.activeKeysHaveBeenInitialized[e] = !0);
                                    const t = this.currentMeasure.findOrCreateStaffEntry(s, this.inSourceMeasureInstrumentIndex + e, this.instrument.Staves[e]).staffEntry;
                                    n.Parent = t, t.Instructions.push(n);
                                } else this.abstractInstructions.push([
                                    e + 1,
                                    n,
                                    s
                                ]);
                            }
                        }
                        if (t.element("time")) {
                            const e = t.element("time");
                            let i = m.RhythmSymbolEnum.NONE, n = !0;
                            if (void 0 !== e && e.hasAttributes) {
                                const t = e.attribute("symbol");
                                t && ("common" === t.value ? i = m.RhythmSymbolEnum.COMMON : "cut" === t.value && (i = m.RhythmSymbolEnum.CUT));
                                const s = e.attribute("print-object");
                                s && "no" === s.value && (n = !1);
                            }
                            let r = 0, o = 0;
                            const a = e && void 0 !== e.element("senza-misura"), d = t.elements("time"), f = [], p = [];
                            for(let t = 0, e = d.length; t < e; ++t){
                                const e = d[t];
                                f.push(...e.elements("beats")), p.push(...e.elements("beat-type"));
                            }
                            if (a) this.abstractInstructions.push([
                                1,
                                new h.RhythmInstruction(new c.Fraction(4, 4, 0, !1), m.RhythmSymbolEnum.NONE),
                                s
                            ]);
                            else {
                                try {
                                    if (void 0 !== f && f.length > 0 && void 0 !== p && f.length === p.length) {
                                        const t = f.length, e = new Array(t);
                                        let i = 0;
                                        for(let s = 0; s < t; s++){
                                            const t = f[s].value;
                                            let n = 0, r = 0;
                                            if (-1 !== t.indexOf("+")) {
                                                const e = t.split("+");
                                                for(let t = 0, i = e.length; t < i; ++t)n += parseInt(e[t], 10);
                                            } else n = parseInt(t, 10);
                                            r = parseInt(p[s].value, 10), i = Math.max(i, r), e[s] = new c.Fraction(n, r, 0, !1);
                                        }
                                        for(let s = 0; s < t; s++)e[s].Denominator === i ? r += e[s].Numerator : r += i / e[s].Denominator * e[s].Numerator;
                                        o = i;
                                    } else r = parseInt(t.element("time").element("beats").value, 10), o = parseInt(t.element("time").element("beat-type").value, 10);
                                } catch (t) {
                                    l = u.ITextTranslation.translateText("ReaderErrorMessages/RhythmError", "Invalid rhythm. Set to default."), this.musicSheet.SheetErrors.pushMeasureError(l), r = 4, o = 4, g.default.debug("InstrumentReader.addAbstractInstruction", l, t);
                                }
                                const e = new h.RhythmInstruction(new c.Fraction(r, o, 0, !1), i);
                                e.PrintObject = n, this.abstractInstructions.push([
                                    1,
                                    e,
                                    s
                                ]);
                            }
                        }
                    }
                    saveAbstractInstructionList(t, e) {
                        for(let t = 0; t < this.abstractInstructions.length;){
                            const e = this.abstractInstructions[t];
                            if (!(e[1] instanceof a.KeyInstruction)) {
                                t++;
                                continue;
                            }
                            const i = e[0] - 1, s = e[1];
                            if (!this.activeKeys[i] || this.activeKeys[i].Key !== s.Key) {
                                this.activeKeys[i] = s;
                                let t = this.currentMeasure;
                                this.activeKeysHaveBeenInitialized[i] || (this.activeKeysHaveBeenInitialized[i] = !0, this.currentXmlMeasureIndex > 0 && (t = this.musicSheet.SourceMeasures[0])), t && this.storeInitialKeyInstruction(t, i, s);
                            }
                            this.abstractInstructions.splice(t, 1);
                        }
                        for(let i = this.abstractInstructions.length - 1; i >= 0; i--){
                            const s = this.abstractInstructions[i], n = s[0], a = s[1], l = s[2];
                            if (a instanceof o.ClefInstruction) {
                                const t = a;
                                if (0 === this.currentXmlMeasureIndex || n <= this.activeClefs.length && t !== this.activeClefs[n - 1]) {
                                    if (e || void 0 === this.currentStaffEntry || this.currentStaffEntry.hasNotes() || n - 1 !== this.instrument.Staves.indexOf(this.currentStaffEntry.ParentStaff)) {
                                        if (e) {
                                            if (0 !== l.RealValue) continue;
                                            let e;
                                            if (this.currentMeasure) {
                                                const s = t, a = this.inSourceMeasureInstrumentIndex + n - 1, l = this.currentMeasure.FirstInstructionsStaffEntries[a];
                                                if (0 === this.currentXmlMeasureIndex) {
                                                    if (l) {
                                                        if (void 0 === this.currentMeasure.FirstInstructionsStaffEntries[a] || l.Instructions[0] instanceof o.ClefInstruction) {
                                                            const t = new r.SourceStaffEntry(void 0, void 0);
                                                            this.currentMeasure.LastInstructionsStaffEntries[a] = t, s.Parent = t, t.Instructions.push(s);
                                                        } else e = l, s.Parent = e, e.removeFirstInstructionOfTypeClefInstruction(), e.Instructions.splice(0, 0, s), this.activeClefsHaveBeenInitialized[n - 1] = !0;
                                                    } else e = new r.SourceStaffEntry(void 0, void 0), this.currentMeasure.FirstInstructionsStaffEntries[a] = e, s.Parent = e, e.Instructions.push(s), this.activeClefsHaveBeenInitialized[n - 1] = !0;
                                                } else if (this.activeClefsHaveBeenInitialized[n - 1]) {
                                                    let t = this.previousMeasure;
                                                    this.followingMultirestMeasures > 0 && this.currentMeasure.Rules.RenderMultipleRestMeasures && (t = this.currentMultirestStartMeasure);
                                                    const e = new r.SourceStaffEntry(void 0, void 0);
                                                    t.LastInstructionsStaffEntries[a] = e, s.Parent = e, e.Instructions.push(s);
                                                } else {
                                                    const t = this.musicSheet.SourceMeasures[0];
                                                    t.FirstInstructionsStaffEntries[a] ? (e = t.FirstInstructionsStaffEntries[a], e.removeFirstInstructionOfTypeClefInstruction()) : e = new r.SourceStaffEntry(void 0, void 0), s.Parent = e, e.Instructions.splice(0, 0, s), this.activeClefsHaveBeenInitialized[n - 1] = !0;
                                                }
                                                this.activeClefs[n - 1] = t, this.abstractInstructions.splice(i, 1);
                                            }
                                        } else {
                                            let e;
                                            const s = this.activeRhythm.Rhythm;
                                            s.RealValue > 0 && l.RealValue / s.RealValue > .9 && s.RealValue !== l.RealValue && (this.currentMeasure.LastInstructionsStaffEntries[n - 1] || (this.currentMeasure.LastInstructionsStaffEntries[n - 1] = new r.SourceStaffEntry(void 0, this.instrument.Staves[n - 1])), e = this.currentMeasure.LastInstructionsStaffEntries[n - 1]), e && (t.Parent = e, e.Instructions.push(t), this.activeClefs[n - 1] = t, this.abstractInstructions.splice(i, 1));
                                        }
                                    } else {
                                        const e = t, s = this.currentStaffEntry;
                                        if (l && Math.abs(l.RealValue - s.Timestamp.RealValue) > .01) continue;
                                        e.Parent = s, s.removeFirstInstructionOfTypeClefInstruction(), s.Instructions.push(e), this.activeClefs[n - 1] = t, this.abstractInstructions.splice(i, 1);
                                    }
                                } else n <= this.activeClefs.length && t === this.activeClefs[n - 1] && this.abstractInstructions.splice(i, 1);
                            }
                            if (a instanceof h.RhythmInstruction) {
                                const e = a;
                                if (this.activeRhythm && this.activeRhythm === e) this.abstractInstructions.splice(i, 1);
                                else if (this.activeRhythm = e, this.abstractInstructions.splice(i, 1), this.currentMeasure) for(let i = this.inSourceMeasureInstrumentIndex; i < this.inSourceMeasureInstrumentIndex + t; i++){
                                    const t = e;
                                    let s;
                                    this.currentMeasure.FirstInstructionsStaffEntries[i] ? (s = this.currentMeasure.FirstInstructionsStaffEntries[i], s.removeFirstInstructionOfTypeRhythmInstruction()) : (s = new r.SourceStaffEntry(void 0, void 0), this.currentMeasure.FirstInstructionsStaffEntries[i] = s), t.Parent = s, s.Instructions.push(t);
                                }
                            }
                        }
                    }
                    saveClefInstructionAtEndOfMeasure() {
                        for(let t = this.abstractInstructions.length - 1; t >= 0; t--){
                            const e = this.abstractInstructions[t][0], i = this.abstractInstructions[t][1];
                            if (i instanceof o.ClefInstruction) {
                                const s = i;
                                if (!this.activeClefs[e - 1] || s.ClefType !== this.activeClefs[e - 1].ClefType || s.ClefType === this.activeClefs[e - 1].ClefType && s.Line !== this.activeClefs[e - 1].Line) {
                                    const i = new r.SourceStaffEntry(void 0, void 0);
                                    this.currentMeasure.LastInstructionsStaffEntries[this.inSourceMeasureInstrumentIndex + e - 1] = i;
                                    const n = s;
                                    n.Parent = i, i.Instructions.push(n), this.activeClefs[e - 1] = s, this.abstractInstructions.splice(t, 1);
                                }
                            }
                        }
                    }
                    getNoteDurationForTuplet(t) {
                        const e = t.element("duration"), i = Number.parseInt(e.value, 10), s = new c.Fraction(i, 4 * this.divisions), n = t.element("time-modification"), r = n?.element("actual-notes"), o = n?.element("normal-notes");
                        if (r && o) {
                            const e = parseInt(r.value, 10), i = parseInt(o.value, 10), a = this.getDottedNoteDurationFromTypeNode(t);
                            if (e > 0 && i > 0 && e !== i && a.RealValue > 0 && Math.abs(s.RealValue - a.RealValue) < 1e-6) {
                                let t = i, r = e;
                                const o = n.elements("normal-dot").length;
                                for(let e = 0; e < o; e++)t *= 3, r *= 2;
                                return c.Fraction.multiply(s, new c.Fraction(t, r));
                            }
                        }
                        return s;
                    }
                    getDottedNoteDurationFromTypeNode(t) {
                        const e = this.getNoteDurationFromTypeNode(t), i = t.elements("dot").length;
                        let s = e.clone();
                        for(let t = 0; t < i; t++)s = c.Fraction.multiply(s, new c.Fraction(1, 2)), e.Add(s);
                        return e;
                    }
                    readExpressionStaffNumber(t) {
                        let e = 1;
                        if (t.element("staff")) {
                            const i = t.element("staff");
                            if (i) try {
                                e = parseInt(i.value, 10);
                            } catch (t) {
                                const i = u.ITextTranslation.translateText("ReaderErrorMessages/ExpressionStaffError", "Invalid Expression staff number. Set to default.");
                                this.musicSheet.SheetErrors.pushMeasureError(i), e = 1, g.default.debug("InstrumentReader.readExpressionStaffNumber", i, t);
                            }
                        }
                        return e;
                    }
                    readDivisionsFromNotes() {
                        let t = 0, e = this.currentXmlMeasureIndex, i = !1;
                        for(; !i;){
                            const s = this.xmlMeasureList[e].elements();
                            for(let e = 0, n = s.length; e < n; ++e){
                                const n = s[e];
                                if ("note" === n.name && !n.element("time-modification")) {
                                    const e = n.element("duration"), i = n.element("type");
                                    if (void 0 !== e && i) {
                                        const s = i.value;
                                        let n = 0;
                                        try {
                                            n = parseInt(e.value, 10);
                                        } catch (t) {
                                            g.default.debug("InstrumentReader.readDivisionsFromNotes", t);
                                            continue;
                                        }
                                        switch(s){
                                            case "1024th":
                                                t = n / 4 * 1024;
                                                break;
                                            case "512th":
                                                t = n / 4 * 512;
                                                break;
                                            case "256th":
                                                t = n / 4 * 256;
                                                break;
                                            case "128th":
                                                t = n / 4 * 128;
                                                break;
                                            case "64th":
                                                t = n / 4 * 64;
                                                break;
                                            case "32nd":
                                                t = n / 4 * 32;
                                                break;
                                            case "16th":
                                                t = n / 4 * 16;
                                                break;
                                            case "eighth":
                                                t = n / 4 * 8;
                                                break;
                                            case "quarter":
                                                t = n / 4 * 4;
                                                break;
                                            case "half":
                                                t = n / 4 * 2;
                                                break;
                                            case "whole":
                                                t = n / 4;
                                                break;
                                            case "breve":
                                                t = n / 4 / 2;
                                                break;
                                            case "long":
                                                t = n / 4 / 4;
                                                break;
                                            case "maxima":
                                                t = n / 4 / 8;
                                        }
                                    }
                                }
                                if (t > 0) {
                                    i = !0;
                                    break;
                                }
                            }
                            if (0 === t && (e++, e === this.xmlMeasureList.length)) {
                                const t = u.ITextTranslation.translateText("ReaderErrorMEssages/DivisionsError", "Invalid divisions value at Instrument: ");
                                throw new d.MusicSheetReadingException(t + this.instrument.Name);
                            }
                        }
                        return t;
                    }
                    getCueNoteAndNoteTypeXml(t) {
                        let e = !1;
                        t.element("cue") && (e = !0);
                        const i = t.element("type");
                        let s = v.NoteType.UNDEFINED;
                        if (i) {
                            const t = i.attribute("size");
                            "cue" === t?.value && (e = !0), s = v.NoteTypeHandler.StringToNoteType(i.value);
                        }
                        return [
                            e,
                            s
                        ];
                    }
                    getStemDirectionType(t) {
                        switch(t.value){
                            case "down":
                                return x.StemDirectionType.Down;
                            case "up":
                                return x.StemDirectionType.Up;
                            case "double":
                                return x.StemDirectionType.Double;
                            case "none":
                                return x.StemDirectionType.None;
                            default:
                                return x.StemDirectionType.Undefined;
                        }
                    }
                    getNoteHeadColorXml(t) {
                        const e = t.element("notehead");
                        if (e) {
                            const t = e.attribute("color");
                            if (t) return this.parseXmlColor(t.value);
                        }
                        return null;
                    }
                    getNoteColorXml(t) {
                        const e = t.attribute("color");
                        return e ? this.parseXmlColor(e.value) : null;
                    }
                    getTremoloInfo(t) {
                        let e, i, s, n;
                        const r = t.element("tremolo");
                        if (r) {
                            let t = r.attribute("type")?.value;
                            if (t || (t = "single"), "single" === t) {
                                const t = parseInt(r.value, 10);
                                t > 0 && (e = t);
                            } else e = 0;
                            if ("unmeasured" === t) i = !0;
                            else if ("start" === t || "stop" === t) {
                                s = "start" === t, n = "stop" === t;
                                const i = parseInt(r.value, 10);
                                i > 0 && (e = i);
                            }
                        }
                        return {
                            tremoloStrokes: e,
                            tremoloUnmeasured: i,
                            tremoloBetweenNotesStart: s,
                            tremoloBetweenNotesStop: n
                        };
                    }
                    getWavyLines(t, e, i, s) {
                        const n = t.elements("wavy-line");
                        if (n) for (const t of n){
                            const n = this.expressionReaders[this.readExpressionStaffNumber(e) - 1];
                            n && (n.readExpressionParameters(t, this.instrument, this.divisions, i, s, this.currentMeasure.MeasureNumber, !1), n.addWavyLine(t, this.currentMeasure, i, s));
                        }
                    }
                    getNoteStaff(t) {
                        let e = 1;
                        return this.instrument.Staves.length > 1 && t.element("staff") && (e = parseInt(t.element("staff").value, 10), isNaN(e) && (g.default.debug("InstrumentReader.readNextXmlMeasure.get staff number"), e = 1)), e;
                    }
                }
                e.InstrumentReader = _, _.SUPPORTED_MEASURE_REPEAT_LENGTHS = [
                    1,
                    2,
                    4
                ];
            },
            9099 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.MusicSheetReader = void 0;
                const n = i(427), r = i(4387), o = i(2561), a = i(1272), l = i(9252), h = i(9767), c = i(7307), u = s(i(3065)), d = i(9288), f = i(9288), m = i(2369), p = i(649), g = i(7586), b = i(5294), S = i(164), y = i(7435), E = i(5749), x = i(9713), v = i(7503), T = i(7533);
                e.MusicSheetReader = class {
                    constructor(t, e = new x.EngravingRules){
                        this.completeNumberOfStaves = 0, this.pluginManager = new v.ReaderPluginManager, this.afterSheetReadingModules = t || [], this.repetitionInstructionReader = E.MusicSymbolModuleFactory.createRepetitionInstructionReader(), this.repetitionCalculator = E.MusicSymbolModuleFactory.createRepetitionCalculator(), this.rules = e;
                    }
                    get PluginManager() {
                        return this.pluginManager;
                    }
                    get CompleteNumberOfStaves() {
                        return this.completeNumberOfStaves;
                    }
                    static doCalculationsAfterDurationHasBeenSet(t) {
                        for (const e of t)e.doCalculationsAfterDurationHasBeenSet();
                    }
                    createMusicSheet(t, e) {
                        try {
                            return this._createMusicSheet(t, e);
                        } catch (t) {
                            return void u.default.error("MusicSheetReader.CreateMusicSheet", t);
                        }
                    }
                    _removeFromArray(t, e) {
                        const i = t.indexOf(e);
                        -1 !== i && t.splice(i, 1);
                    }
                    trimString(t) {
                        return t.replace(/^\s+|\s+$/g, "");
                    }
                    _lastElement(t) {
                        return t[t.length - 1];
                    }
                    _createMusicSheet(t, e) {
                        const i = [];
                        let s = 0;
                        this.musicSheet = new n.MusicSheet, this.musicSheet.Path = e, this.musicSheet.Rules = this.rules;
                        const a = t.attribute("osmdMeasureWidthFactor");
                        if (a) {
                            const t = Number.parseFloat(a.value);
                            "number" != typeof t || isNaN(t) ? u.default.info("xml parse: osmdMeasureWidthFactor invalid") : this.musicSheet.MeasureWidthFactor = t;
                        }
                        if (!t) throw new c.MusicSheetReadingException("Undefined root element");
                        this.pushSheetLabels(t, e), this.readLyricLanguages(t);
                        const l = t.element("part-list");
                        if (!l) throw new c.MusicSheetReadingException("Undefined partListNode");
                        const d = t.elements("part"), f = l.elements();
                        this.initializeReading(f, d, i);
                        let m = !0;
                        this.currentFraction = new o.Fraction(0, 1);
                        let p = !1, g = t.element("identification");
                        g && (g = g.element("encoding")), g && (g = g.element("software")), void 0 !== g && "Guitar Pro 5" === g.value && (p = !0);
                        const b = "Guitar Pro 5" !== g?.value;
                        for(; m;){
                            void 0 !== this.currentMeasure && this.currentMeasure.HasEndLine && this.rules.NewPartAndSystemAfterFinalBarline && (s = 0), this.currentMeasure = new r.SourceMeasure(this.completeNumberOfStaves, this.musicSheet.Rules);
                            for (const t of i)try {
                                m = m && t.readNextXmlMeasure(this.currentMeasure, this.currentFraction, p, b);
                            } catch (t) {
                                const e = h.ITextTranslation.translateText("ReaderErrorMessages/InstrumentError", "Error while reading instruments.");
                                throw new c.MusicSheetReadingException(e, t);
                            }
                            if (m) {
                                this.musicSheet.addMeasure(this.currentMeasure), this.checkIfRhythmInstructionsAreSetAndEqual(i), this.checkSourceMeasureForNullEntries(), s = this.setSourceMeasureDuration(i, s);
                                for (const t of i)t.finalizeKeyInstructions();
                                this.checkSourceMeasureForNullEntries(), this.currentMeasure.AbsoluteTimestamp = this.currentFraction.clone(), this.musicSheet.SheetErrors.finalizeMeasure(this.currentMeasure.MeasureNumber), this.currentFraction.Add(this.currentMeasure.Duration), this.previousMeasure = this.currentMeasure;
                            }
                        }
                        this.repetitionInstructionReader && (this.repetitionInstructionReader.removeRedundantInstructions(), this.repetitionCalculator && this.repetitionCalculator.calculateRepetitions(this.musicSheet, this.repetitionInstructionReader.repetitionInstructions)), this.musicSheet.checkForInstrumentWithNoVoice(), this.musicSheet.fillStaffList(), this.rules.RelinkLyricWordsAcrossVoices && this.relinkLyricWordsAcrossVoices(this.musicSheet);
                        for(let t = 0, e = this.afterSheetReadingModules.length; t < e; ++t)this.afterSheetReadingModules[t].calculate(this.musicSheet);
                        return this.musicSheet.userStartTempoInBPM = this.musicSheet.userStartTempoInBPM || this.musicSheet.DefaultStartTempoInBpm, this.musicSheet;
                    }
                    relinkLyricWordsAcrossVoices(t) {
                        const e = new Map;
                        for (const i of t.SourceMeasures)for (const t of i.VerticalSourceStaffEntryContainers)for (const i of t.StaffEntries){
                            if (!i) continue;
                            const t = i.ParentStaff;
                            for (const s of i.VoiceEntries)s.LyricsEntries.forEach((n, r)=>{
                                let o = e.get(t);
                                o || (o = new Map, e.set(t, o));
                                let a = o.get(n);
                                a || (a = [], o.set(n, a)), a.push({
                                    timestamp: i.AbsoluteTimestamp.RealValue,
                                    voiceId: s.ParentVoice.VoiceId,
                                    entry: r
                                });
                            });
                        }
                        e.forEach((t)=>{
                            t.forEach((t)=>{
                                if (!this.hasBrokenLyricWordChains(t)) return;
                                let e;
                                t.sort((t, e)=>t.timestamp - e.timestamp || t.voiceId - e.voiceId);
                                let i = Number.NEGATIVE_INFINITY;
                                for (const s of t){
                                    const t = s.entry;
                                    if (s.timestamp !== i) switch(i = s.timestamp, t.syllabic){
                                        case "begin":
                                            e = new p.LyricWord, t.Word = e, t.SyllableIndex = 0, e.Syllables.push(t);
                                            break;
                                        case "middle":
                                        case "end":
                                        case "single":
                                            e ? (t.Word = e, t.SyllableIndex = e.Syllables.length, e.Syllables.push(t), "middle" !== t.syllabic && (e = void 0)) : t.Word = void 0;
                                            break;
                                        default:
                                            t.Word = void 0, e = void 0;
                                    }
                                    else t.Word = void 0;
                                }
                            });
                        });
                    }
                    hasBrokenLyricWordChains(t) {
                        const e = new Set;
                        for (const i of t)e.add(i.voiceId);
                        if (e.size < 2) return !1;
                        const i = new Set;
                        for (const e of t){
                            const t = e.entry;
                            if (t.Word) i.add(t.Word);
                            else if ("begin" === t.syllabic || "middle" === t.syllabic || "end" === t.syllabic) return !0;
                        }
                        let s = !1;
                        return i.forEach((t)=>{
                            const e = t.Syllables, i = e[e.length - 1].syllabic;
                            (e.length < 2 || "begin" !== e[0].syllabic || "end" !== i && "single" !== i) && (s = !0);
                        }), s;
                    }
                    initializeReading(t, e, i) {
                        const s = this.createInstrumentGroups(t);
                        this.completeNumberOfStaves = this.getCompleteNumberOfStavesFromXml(e), 0 !== e.length && (this.repetitionInstructionReader.MusicSheet = this.musicSheet, this.currentFraction = new o.Fraction(0, 1), this.currentMeasure = void 0, this.previousMeasure = void 0);
                        let n = 0;
                        for (const t of e){
                            const e = t.attribute("id");
                            if (e) {
                                const r = s[e.value], o = t.elements("measure");
                                let l = 1;
                                try {
                                    l = this.getInstrumentNumberOfStavesFromXml(t);
                                } catch (t) {
                                    const e = h.ITextTranslation.translateText("ReaderErrorMessages/InstrumentStavesNumberError", "Invalid number of staves at instrument: ");
                                    this.musicSheet.SheetErrors.push(e + r.Name);
                                    continue;
                                }
                                r.createStaves(l), i.push(new a.InstrumentReader(this.pluginManager, this.repetitionInstructionReader, o, r)), this.repetitionInstructionReader && (this.repetitionInstructionReader.xmlMeasureList[n] = o), n++;
                            }
                        }
                    }
                    checkIfRhythmInstructionsAreSetAndEqual(t) {
                        const e = [];
                        for(let t = 0; t < this.completeNumberOfStaves; t++)if (this.currentMeasure.FirstInstructionsStaffEntries[t]) {
                            const i = this.currentMeasure.FirstInstructionsStaffEntries[t].Instructions[this.currentMeasure.FirstInstructionsStaffEntries[t].Instructions.length - 1];
                            i instanceof d.RhythmInstruction && e.push(i);
                        }
                        let i = 0, s = -1;
                        for(let t = 0, n = e.length; t < n; ++t){
                            const n = e[t];
                            if (n.Rhythm.RealValue > i) {
                                if (this.areRhythmInstructionsMixed(e) && n.SymbolEnum !== f.RhythmSymbolEnum.NONE) continue;
                                i = n.Rhythm.RealValue, s = e.indexOf(n);
                            }
                        }
                        if (e.length > 0 && e.length < this.completeNumberOfStaves) {
                            const i = e[s].clone();
                            for(let t = 0; t < this.completeNumberOfStaves; t++)void 0 === this.currentMeasure.FirstInstructionsStaffEntries[t] || this._lastElement(this.currentMeasure.FirstInstructionsStaffEntries[t].Instructions) instanceof d.RhythmInstruction || (this.currentMeasure.FirstInstructionsStaffEntries[t].removeAllInstructionsOfTypeRhythmInstruction(), this.currentMeasure.FirstInstructionsStaffEntries[t].Instructions.push(i.clone())), this.currentMeasure.FirstInstructionsStaffEntries[t] || (this.currentMeasure.FirstInstructionsStaffEntries[t] = new m.SourceStaffEntry(void 0, void 0), this.currentMeasure.FirstInstructionsStaffEntries[t].Instructions.push(i.clone()));
                            for(let e = 0, s = t.length; e < s; ++e)t[e].ActiveRhythm = i;
                        }
                        if (0 === e.length && this.currentMeasure === this.musicSheet.SourceMeasures[0]) {
                            const e = new d.RhythmInstruction(new o.Fraction(4, 4, 0, !1), f.RhythmSymbolEnum.NONE);
                            e.SynthesizedFromNoTimeSignature = !0;
                            for(let t = 0; t < this.completeNumberOfStaves; t++)this.currentMeasure.FirstInstructionsStaffEntries[t] ? this.currentMeasure.FirstInstructionsStaffEntries[t].removeAllInstructionsOfTypeRhythmInstruction() : this.currentMeasure.FirstInstructionsStaffEntries[t] = new m.SourceStaffEntry(void 0, void 0), this.currentMeasure.FirstInstructionsStaffEntries[t].Instructions.push(e);
                            for(let i = 0, s = t.length; i < s; ++i)t[i].ActiveRhythm = e;
                        }
                        for(let t = 0, n = e.length; t < n; ++t){
                            const n = e[t];
                            if (n.Rhythm.RealValue < i && this._lastElement(this.currentMeasure.FirstInstructionsStaffEntries[e.indexOf(n)].Instructions) instanceof d.RhythmInstruction) {
                                const t = this.currentMeasure.FirstInstructionsStaffEntries[e.indexOf(n)].Instructions;
                                t[t.length - 1] = e[s].clone();
                            }
                            Math.abs(n.Rhythm.RealValue - i) < 1e-6 && n.SymbolEnum !== f.RhythmSymbolEnum.NONE && this.areRhythmInstructionsMixed(e) && (n.SymbolEnum = f.RhythmSymbolEnum.NONE);
                        }
                    }
                    areRhythmInstructionsMixed(t) {
                        for(let e = 1; e < t.length; e++)if (Math.abs(t[e].Rhythm.RealValue - t[0].Rhythm.RealValue) < 1e-6 && t[e].SymbolEnum !== t[0].SymbolEnum) return !0;
                        return !1;
                    }
                    setSourceMeasureDuration(t, e) {
                        let i = new o.Fraction(0, 1);
                        const s = [];
                        for (const e of t){
                            s.push(e.MaxTieNoteFraction);
                            const t = e.ActiveRhythm.Rhythm;
                            i.lt(t) && (i = new o.Fraction(t.Numerator, t.Denominator, 0, !1));
                        }
                        const n = this.currentMeasure.calculateInstrumentsDuration(this.musicSheet, s);
                        let r = new o.Fraction(0, 1);
                        for (const t of n)r.lt(t) && (r = t);
                        o.Fraction.Equal(r, i) ? this.checkFractionsForEquivalence(r, i) : r.lt(i) && (r = this.currentMeasure.reverseCheck(this.musicSheet, r), this.checkFractionsForEquivalence(r, i)), this.currentMeasure.ImplicitMeasure = this.checkIfMeasureIsImplicit(r, i), (!this.currentMeasure.ImplicitMeasure || e > 0) && e++, this.currentMeasure.Duration = r, this.currentMeasure.ActiveTimeSignature = i, this.currentMeasure.MeasureNumber = e;
                        for(let t = 0; t < n.length; t++){
                            const e = n[t];
                            if (this.currentMeasure.ImplicitMeasure && e !== r || !o.Fraction.Equal(e, i) && !this.allInstrumentsHaveSameDuration(n, r)) {
                                const e = this.musicSheet.getGlobalStaffIndexOfFirstStaff(this.musicSheet.Instruments[t]);
                                for(let i = 0; i < this.musicSheet.Instruments[t].Staves.length; i++)if (!this.graphicalMeasureIsEmpty(e + i)) {
                                    this.currentMeasure.setErrorInGraphicalMeasure(e + i, !0);
                                    const t = h.ITextTranslation.translateText("ReaderErrorMessages/MissingNotesError", "Given Notes don't correspond to measure duration.");
                                    this.musicSheet.SheetErrors.pushMeasureError(t);
                                }
                            }
                        }
                        return e;
                    }
                    checkFractionsForEquivalence(t, e) {
                        if (e.Denominator > t.Denominator) {
                            const i = e.Denominator / t.Denominator;
                            t.expand(i);
                        }
                    }
                    checkIfMeasureIsImplicit(t, e) {
                        return !(this.previousMeasure || !t.lt(e)) || !!this.previousMeasure && o.Fraction.plus(this.previousMeasure.Duration, t).Equals(e);
                    }
                    allInstrumentsHaveSameDuration(t, e) {
                        let i = 0;
                        for(let s = 0, n = t.length; s < n; ++s)t[s].Equals(e) && i++;
                        return i === t.length && e !== new o.Fraction(0, 1);
                    }
                    graphicalMeasureIsEmpty(t) {
                        let e = 0;
                        for(let i = 0; i < this.currentMeasure.VerticalSourceStaffEntryContainers.length; i++)this.currentMeasure.VerticalSourceStaffEntryContainers[i].StaffEntries[t] || e++;
                        return e === this.currentMeasure.VerticalSourceStaffEntryContainers.length;
                    }
                    checkSourceMeasureForNullEntries() {
                        for(let t = this.currentMeasure.VerticalSourceStaffEntryContainers.length - 1; t >= 0; t--)for(let e = this.currentMeasure.VerticalSourceStaffEntryContainers[t].StaffEntries.length - 1; e >= 0; e--){
                            const i = this.currentMeasure.VerticalSourceStaffEntryContainers[t].StaffEntries[e];
                            if (i) for(let t = i.VoiceEntries.length - 1; t >= 0; t--){
                                const e = i.VoiceEntries[t];
                                0 === e.Notes.length && (this._removeFromArray(e.ParentVoice.VoiceEntries, e), this._removeFromArray(i.VoiceEntries, e));
                            }
                            void 0 !== i && 0 === i.VoiceEntries.length && 0 === i.ChordContainers.length && 0 === i.Instructions.length && (this.currentMeasure.VerticalSourceStaffEntryContainers[t].StaffEntries[e] = void 0);
                        }
                        for(let t = this.currentMeasure.VerticalSourceStaffEntryContainers.length - 1; t >= 0; t--){
                            let e = 0;
                            for(let i = 0, s = this.currentMeasure.VerticalSourceStaffEntryContainers[t].StaffEntries.length; i < s; ++i)this.currentMeasure.VerticalSourceStaffEntryContainers[t].StaffEntries[i] || e++;
                            e === this.currentMeasure.VerticalSourceStaffEntryContainers[t].StaffEntries.length && this._removeFromArray(this.currentMeasure.VerticalSourceStaffEntryContainers, this.currentMeasure.VerticalSourceStaffEntryContainers[t]);
                        }
                    }
                    pushSheetLabels(t, e) {
                        this.readComposer(t), this.readTitle(t), this.readCopyright(t);
                        try {
                            this.rules.ReadFirstPageCreditWords && 0 === this.computeSystemYCoordinates(t) ? this.readFirstPageCreditWords(t) : this.musicSheet.Title && this.musicSheet.Composer && this.musicSheet.Subtitle || this.readTitleAndComposerFromCredits(t);
                        } catch (t) {
                            u.default.info("MusicSheetReader.pushSheetLabels", "read credits", t);
                        }
                        try {
                            if (!this.musicSheet.Title) {
                                let t = e;
                                const i = e.match(/\.(xml|musicxml|mxl)$/i);
                                i && (t = e.substring(Math.max(e.lastIndexOf("/"), e.lastIndexOf("\\")) + 1, i.index)), this.musicSheet.Title = new y.Label(t);
                            }
                        } catch (t) {
                            u.default.info("MusicSheetReader.pushSheetLabels", "read title from file name", t);
                        }
                    }
                    readLyricLanguages(t) {
                        for (const e of t.element("defaults")?.elements("lyric-language") ?? []){
                            const t = e.attribute("xml:lang")?.value;
                            t && this.musicSheet.LyricLanguages.push({
                                number: e.attribute("number")?.value,
                                name: e.attribute("name")?.value,
                                language: t
                            });
                        }
                    }
                    readFirstPageCreditWords(t) {
                        const e = [], i = [], s = [], n = [], r = [], o = new Map;
                        for (const a of t.elements("credit")){
                            if (1 !== Number(a.attribute("page")?.value ?? "1")) continue;
                            const [t, l, h] = this.getCreditTypeTextAndLanguage(a), c = this.trimString(l ?? "");
                            if (!c) continue;
                            if ("page number" === t) continue;
                            if ("rights" === t) {
                                this.musicSheet.Copyright || (this.musicSheet.Copyright = new y.Label(c, T.TextAlignmentEnum.CenterBottom, void 0, !0), this.musicSheet.Copyright.language = h);
                                continue;
                            }
                            switch(o.has(t) || o.set(t, h), t){
                                case "title":
                                    e.push(c);
                                    continue;
                                case "subtitle":
                                    i.push(c);
                                    continue;
                                case "composer":
                                    s.push(c);
                                    continue;
                                case "lyricist":
                                    n.push(c);
                                    continue;
                            }
                            const u = a.element("credit-words"), d = u?.attribute("halign")?.value ?? u?.attribute("justify")?.value, f = "right" === d ? T.TextAlignmentEnum.RightTop : "center" === d ? T.TextAlignmentEnum.CenterTop : T.TextAlignmentEnum.LeftTop, m = new y.Label(c, f);
                            m.language = h, r.push(m);
                        }
                        e.length > 0 && (this.musicSheet.Title = new y.Label(e.join("\n")), this.musicSheet.Title.language = o.get("title")), i.length > 0 && (this.musicSheet.Subtitle = new y.Label(i.join("\n")), this.musicSheet.Subtitle.language = o.get("subtitle")), s.length > 0 && (this.musicSheet.Composer = new y.Label(s.join("\n")), this.musicSheet.Composer.language = o.get("composer")), n.length > 0 && (this.musicSheet.Lyricist = new y.Label(n.join("\n")), this.musicSheet.Lyricist.language = o.get("lyricist"));
                        const a = (t)=>t.replace(/\s+/g, " ").trim().toLowerCase(), l = [
                            this.musicSheet.Title,
                            this.musicSheet.Subtitle,
                            this.musicSheet.Composer,
                            this.musicSheet.Lyricist
                        ].filter((t)=>void 0 !== t).flatMap((t)=>t.text.split("\n").map(a));
                        for (const t of r)t.text.split("\n").every((t)=>l.includes(a(t))) || this.musicSheet.FirstPageCreditWords.push(t);
                    }
                    presentAttrsWithValue(t, e) {
                        for (const i of t.attributes())if (i.value === e) return !0;
                        return !1;
                    }
                    readComposer(t) {
                        const e = t.element("identification");
                        if (e) {
                            const t = e.elements("creator");
                            for(let e = 0, i = t.length; e < i; ++e){
                                const i = t[e];
                                if (i.hasAttributes) {
                                    if (this.presentAttrsWithValue(i, "composer")) {
                                        this.musicSheet.Composer = new y.Label(this.trimString(i.value));
                                        continue;
                                    }
                                    (this.presentAttrsWithValue(i, "lyricist") || this.presentAttrsWithValue(i, "poet")) && (this.musicSheet.Lyricist = new y.Label(this.trimString(i.value)));
                                }
                            }
                        }
                    }
                    readCopyright(t) {
                        const e = t.elements("identification");
                        if (e.length > 0) {
                            const t = e[0].elements("rights");
                            if (t.length > 0) for(let e = 0, i = t.length; e < i; ++e){
                                const i = t[e];
                                if (i.value) {
                                    this.musicSheet.Copyright = new y.Label(i.value, T.TextAlignmentEnum.CenterBottom, void 0, !0);
                                    break;
                                }
                            }
                        }
                    }
                    readTitleAndComposerFromCredits(t) {
                        if (this.rules.SheetComposerSubtitleUseLegacyParsing) return void this.readTitleAndComposerFromCreditsLegacy(t);
                        const e = this.computeSystemYCoordinates(t);
                        let i, s, n, r, o, a;
                        const l = t.elements("credit");
                        for(let t = 0, h = l.length; t < h; ++t){
                            const h = l[t];
                            if ("1" === (h.attribute("page")?.value ?? "1")) {
                                if (0 === e) {
                                    const [t, e, l] = this.getCreditTypeTextAndLanguage(h);
                                    "title" === t ? i || (i = e, r = l) : "subtitle" === t ? (o = s ? o : l, s = s ? s + "\n" + e : e) : "composer" === t ? (a = n ? a : l, n = n ? n + "\n" + e : e) : "lyricist" !== t || this.musicSheet.Lyricist ? "rights" !== t || this.musicSheet.Copyright || (this.musicSheet.Copyright = new y.Label(this.trimString(e), T.TextAlignmentEnum.CenterBottom, void 0, !0), this.musicSheet.Copyright.language = l) : (this.musicSheet.Lyricist = new y.Label(this.trimString(e)), this.musicSheet.Lyricist.language = l);
                                    continue;
                                }
                                let t;
                                if (h) {
                                    let l = !1, c = !1;
                                    const u = h.element("credit-type");
                                    "subtitle" === u?.value ? l = !0 : "composer" === u?.value && (c = !0);
                                    let d = l || c;
                                    t = h.elements("credit-words");
                                    for (const h of t){
                                        const t = h.value?.trim();
                                        if ("Copyright \xa9" === t) continue;
                                        const u = h.attribute("xml:lang")?.value, f = h.attribute("justify")?.value;
                                        "right" === f ? (c = !0, d = !0) : "center" === f && i && (l = !0, d = !0);
                                        const m = h.attribute("default-y")?.value, p = null != m, g = p ? parseFloat(m) : Number.MIN_VALUE;
                                        if (p && g > e || d) {
                                            if (i || d) {
                                                if (c || "right" === f) n ? n += "\n" + t : (n = t, a = u);
                                                else if (l || "right" !== f && "left" !== f) s ? s += "\n" + t : (s = t, o = u);
                                                else if ("left" === f) {
                                                    this.musicSheet.Lyricist || (this.musicSheet.Lyricist = new y.Label(t), this.musicSheet.Lyricist.language = u);
                                                    break;
                                                }
                                            } else i = t, r = u;
                                        }
                                    }
                                }
                            }
                        }
                        if (!this.musicSheet.Title && i && (this.musicSheet.Title = new y.Label(this.trimString(i)), this.musicSheet.Title.language = r), !this.musicSheet.Subtitle && s && (this.musicSheet.Subtitle = new y.Label(this.trimString(s)), this.musicSheet.Subtitle.language = o), n) {
                            let t = !1;
                            this.musicSheet.Composer ? (n.match("\n") ?? []).length + 1 >= (this.musicSheet.Composer.text.match("\n") ?? []).length + 1 && (t = !0) : t = !0, t && (this.musicSheet.Composer = new y.Label(this.trimString(n)), this.musicSheet.Composer.language = a);
                        }
                    }
                    getCreditTypeTextAndLanguage(t) {
                        const e = t.elements("credit-type"), i = t.elements("credit-words").map((t)=>t.value).join("");
                        return i.trim() ? [
                            1 === e.length ? e[0].value : void 0,
                            i,
                            t.element("credit-words").attribute("xml:lang")?.value
                        ] : [];
                    }
                    readTitleAndComposerFromCreditsLegacy(t) {
                        const e = this.computeSystemYCoordinates(t);
                        if (0 === e) return;
                        let i, s, n, r = 1, o = 0;
                        const a = t.elements("credit");
                        for(let t = 0, l = a.length; t < l; ++t){
                            const l = a[t];
                            if (!l.attribute("page")) return;
                            if ("1" === l.attribute("page").value) {
                                let t;
                                if (l) {
                                    if (t = l.element("credit-words"), !t.attribute("justify")) break;
                                    const a = t.attribute("justify")?.value, h = t.attribute("default-y")?.value, c = null != h, u = c ? parseFloat(h) : Number.MIN_VALUE;
                                    let d = !1;
                                    const f = l.element("credit-type");
                                    if ("subtitle" === f?.value && (d = !0), c && u > e || d) {
                                        if (!this.musicSheet.Title && !d) {
                                            const e = t.attribute("font-size")?.value;
                                            if (e) {
                                                const s = parseFloat(e);
                                                r < s && (r = s, i = t.value);
                                            }
                                        }
                                        switch(this.musicSheet.Subtitle || ("right" !== a && "left" !== a || d) && (o < u ? (o = u, n ? (s = n, n = t.value) : n = t.value) : s ? s += "\n" + t.value : s = t.value), a){
                                            case "right":
                                                this.musicSheet.Composer || (this.musicSheet.Composer = new y.Label(this.trimString(t.value)));
                                                break;
                                            case "left":
                                                this.musicSheet.Lyricist || (this.musicSheet.Lyricist = new y.Label(this.trimString(t.value)));
                                        }
                                    }
                                }
                            }
                        }
                        !this.musicSheet.Title && i && (this.musicSheet.Title = new y.Label(this.trimString(i))), !this.musicSheet.Subtitle && s && (this.musicSheet.Subtitle = new y.Label(this.trimString(s)));
                    }
                    computeSystemYCoordinates(t) {
                        if (!t.element("defaults")) return 0;
                        let e = 0, i = 0;
                        try {
                            const i = t.element("defaults")?.element("page-layout")?.element("page-height").value ?? "0";
                            e = parseFloat(i);
                        } catch (t) {
                            return u.default.info("MusicSheetReader.computeSystemYCoordinates(): couldn't find page height, not reading title/composer."), 0;
                        }
                        let s = !1;
                        const n = t.elements("part");
                        for(let t = 0, e = n.length; t < e; ++t){
                            const e = n[t].elements("measure");
                            for(let t = 0, n = e.length; t < n; ++t){
                                const n = e[t];
                                if (n.element("print")) {
                                    const t = n.element("print").elements("system-layout");
                                    for(let e = 0, n = t.length; e < n; ++e){
                                        const n = t[e];
                                        if (n.element("top-system-distance")) {
                                            const t = n.element("top-system-distance").value;
                                            i = parseFloat(t), s = !0;
                                            break;
                                        }
                                    }
                                    break;
                                }
                            }
                            if (s) break;
                        }
                        if (t.element("defaults").element("system-layout") && t.element("defaults").element("system-layout").element("top-system-distance")) {
                            const e = t.element("defaults").element("system-layout").element("top-system-distance").value;
                            i = parseFloat(e);
                        }
                        return 0 === i ? 0 : e - i;
                    }
                    readTitle(t) {
                        const e = t.element("work");
                        let i;
                        e && (i = e.element("work-title"), i && i.value && (this.musicSheet.Title = new y.Label(this.trimString(i.value))));
                        const s = t.element("movement-title");
                        let n = "";
                        if (s && (this.musicSheet.Title ? n = this.trimString(s.value) : this.musicSheet.Title = new y.Label(this.trimString(s.value))), e) {
                            const t = e.element("work-number");
                            if (t) {
                                const e = t.value;
                                e && (n = "" === n ? e : n + ", " + e);
                            }
                        }
                        n && (this.musicSheet.Subtitle = new y.Label(n));
                    }
                    createInstrumentGroups(t) {
                        let e = 0;
                        const i = {};
                        let s;
                        const n = this.orderPartGroupsByNesting(t), r = this.groupNumbersAreProperlyNested(n);
                        try {
                            for(let t = 0, o = n.length; t < o; ++t){
                                const o = n[t];
                                if ("score-part" === o.name) {
                                    const t = o.attribute("id").value, n = new l.Instrument(e, t, this.musicSheet, s);
                                    n.Name = "", e++;
                                    const r = o.elements();
                                    for(let t = 0, e = r.length; t < e; ++t){
                                        const e = r[t];
                                        try {
                                            if ("part-name" === e.name) n.Name = e.value, e.attribute("print-object") && "no" === e.attribute("print-object").value && (n.NameLabel.print = !1);
                                            else if ("part-abbreviation" === e.name) n.PartAbbreviation = e.value, "no" === e.attribute("print-object")?.value && (n.PartAbbreviationPrintObject = !1);
                                            else if ("part-abbreviation-display" === e.name) "no" === e.attribute("print-object")?.value && (n.PartAbbreviationPrintObject = !1);
                                            else if ("score-instrument" === e.name) {
                                                const t = new b.SubInstrument(n);
                                                t.idString = e.firstAttribute.value, n.SubInstruments.push(t);
                                                const i = e.element("instrument-name");
                                                i && (t.name = i.value, t.setMidiInstrument(i.value));
                                            } else if ("midi-instrument" === e.name) {
                                                let t = n.getSubInstrument(e.firstAttribute.value);
                                                for(let i = 0, s = n.SubInstruments.length; i < s; ++i){
                                                    const s = n.SubInstruments[i];
                                                    if (s.idString === e.value) {
                                                        t = s;
                                                        break;
                                                    }
                                                }
                                                const i = e.elements();
                                                for(let e = 0, s = i.length; e < s; ++e){
                                                    const s = i[e];
                                                    try {
                                                        if ("midi-channel" === s.name) 10 === parseInt(s.value, 10) && (n.MidiInstrumentId = S.MidiInstrument.Percussion);
                                                        else if ("midi-program" === s.name) n.SubInstruments.length > 0 && n.MidiInstrumentId !== S.MidiInstrument.Percussion && (t.midiInstrumentID = Math.max(0, parseInt(s.value, 10) - 1));
                                                        else if ("midi-unpitched" === s.name) t.fixedKey = Math.max(0, parseInt(s.value, 10));
                                                        else if ("volume" === s.name) try {
                                                            const e = parseFloat(s.value);
                                                            t.volume = e / 127;
                                                        } catch (t) {
                                                            u.default.debug("ExpressionReader.readExpressionParameters", "read volume", t);
                                                        }
                                                        else if ("pan" === s.name) try {
                                                            const e = parseFloat(s.value);
                                                            t.pan = e / 64;
                                                        } catch (t) {
                                                            u.default.debug("ExpressionReader.readExpressionParameters", "read pan", t);
                                                        }
                                                    } catch (t) {
                                                        u.default.info("MusicSheetReader.createInstrumentGroups midi settings: ", t);
                                                    }
                                                }
                                            }
                                        } catch (t) {
                                            u.default.info("MusicSheetReader.createInstrumentGroups: ", t);
                                        }
                                    }
                                    if (0 === n.SubInstruments.length) {
                                        const t = new b.SubInstrument(n);
                                        n.SubInstruments.push(t);
                                    }
                                    i[t] = n, s ? (s.InstrumentalGroups.push(n), this.musicSheet.Instruments.push(n)) : (this.musicSheet.InstrumentalGroups.push(n), this.musicSheet.Instruments.push(n));
                                } else if ("part-group" === o.name && "start" === o.attribute("type").value) {
                                    const t = new g.InstrumentalGroup(void 0, this.musicSheet, s), e = o.element("group-name"), i = o.element("group-abbreviation");
                                    e && (t.Name = e.value), i && (t.Abbreviation = i.value), t.PrintName = r, t.PrintAbbreviation = r;
                                    const n = o.element("group-name-display");
                                    n && (t.PrintName = t.PrintName && "no" !== n.attribute("print-object")?.value);
                                    const a = o.element("group-abbreviation-display");
                                    a && (t.PrintAbbreviation = t.PrintAbbreviation && "no" !== a.attribute("print-object")?.value), s ? s.InstrumentalGroups.push(t) : this.musicSheet.InstrumentalGroups.push(t), s = t;
                                } else if ("part-group" === o.name && "stop" === o.attribute("type").value && s) {
                                    const t = this.countInstrumentsInGroup(s) > 1;
                                    if (s.PrintName = s.PrintName && t, s.PrintAbbreviation = s.PrintAbbreviation && t, 1 === s.InstrumentalGroups.length) {
                                        const t = s.InstrumentalGroups[0];
                                        s.Parent ? (s.Parent.InstrumentalGroups.push(t), this._removeFromArray(s.Parent.InstrumentalGroups, s)) : (this.musicSheet.InstrumentalGroups.push(t), this._removeFromArray(this.musicSheet.InstrumentalGroups, s));
                                    }
                                    s = s.Parent;
                                }
                            }
                        } catch (t) {
                            const e = h.ITextTranslation.translateText("ReaderErrorMessages/InstrumentError", "Error while reading Instruments");
                            throw new c.MusicSheetReadingException(e, t);
                        }
                        return i;
                    }
                    countInstrumentsInGroup(t) {
                        let e = 0;
                        for (const i of t.InstrumentalGroups)e += i instanceof l.Instrument ? 1 : this.countInstrumentsInGroup(i);
                        return e;
                    }
                    groupNumbersAreProperlyNested(t) {
                        const e = [];
                        for (const i of t){
                            if ("part-group" !== i.name) continue;
                            const t = i.attribute("number")?.value ?? "1";
                            if ("start" === i.attribute("type")?.value) {
                                if (e.indexOf(t) >= 0) return !1;
                                e.push(t);
                            } else if ("stop" === i.attribute("type")?.value && e.pop() !== t) return !1;
                        }
                        return 0 === e.length;
                    }
                    orderPartGroupsByNesting(t) {
                        const e = [], i = [], s = [], n = {};
                        let r = 0;
                        t.forEach((t, o)=>{
                            if ("score-part" === t.name) r++;
                            else if ("part-group" === t.name) {
                                const a = t.attribute("number")?.value ?? "1", l = n[a];
                                "start" === t.attribute("type")?.value ? (n[a] = o, e[o] = r) : "stop" === t.attribute("type")?.value && void 0 !== l && (delete n[a], e[o] = e[l], i[l] = r - 1, s[o] = l);
                            }
                        });
                        const o = (e)=>"stop" === t[e].attribute("type")?.value, a = t.map((t, e)=>e);
                        for(let n = 0; n < a.length; n++){
                            let l = n;
                            for(; l < a.length && "part-group" === t[l].name;)l++;
                            const h = a.slice(n, l).sort((t, n)=>o(t) !== o(n) ? o(t) ? -1 : 1 : o(t) ? (e[n] ?? -1) - (e[t] ?? -1) || (s[n] ?? -1) - (s[t] ?? -1) : (i[n] ?? r) - (i[t] ?? r) || t - n);
                            a.splice(n, h.length, ...h), n = l;
                        }
                        return a.map((e)=>t[e]);
                    }
                    getCompleteNumberOfStavesFromXml(t) {
                        let e = 0;
                        for (const i of t){
                            const t = i.elements("measure");
                            if (t.length > 0) {
                                const i = t[0];
                                if (i) {
                                    let t = i.element("attributes");
                                    t && (t = t.element("staves")), t ? e += parseInt(t.value, 10) : e++;
                                }
                            }
                        }
                        if (isNaN(e) || e <= 0) {
                            const t = h.ITextTranslation.translateText("ReaderErrorMessages/StaffError", "Invalid number of staves.");
                            throw new c.MusicSheetReadingException(t);
                        }
                        return e;
                    }
                    getInstrumentNumberOfStavesFromXml(t) {
                        let e = 0;
                        const i = t.element("measure");
                        if (i) {
                            const t = i.element("attributes");
                            let s;
                            t && (s = t.element("staves")), e = t && s ? parseInt(s.value, 10) : 1;
                        }
                        if (isNaN(e) || e <= 0) {
                            const t = h.ITextTranslation.translateText("ReaderErrorMessages/StaffError", "Invalid number of Staves.");
                            throw new c.MusicSheetReadingException(t);
                        }
                        return e;
                    }
                };
            },
            5749 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.MusicSymbolModuleFactory = void 0;
                const s = i(7631), n = i(6302);
                e.MusicSymbolModuleFactory = class {
                    static createRepetitionInstructionReader() {
                        return new s.RepetitionInstructionReader;
                    }
                    static createRepetitionCalculator() {
                        return new n.RepetitionCalculator;
                    }
                };
            },
            4127 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.ArticulationReader = void 0;
                const n = i(1336), r = s(i(3065)), o = i(3123), a = i(8215), l = i(6362), h = i(8233), c = i(9003), u = i(9019), d = i(8045);
                e.ArticulationReader = class {
                    constructor(t){
                        this.rules = t;
                    }
                    getAccEnumFromString(t) {
                        switch(t){
                            case "sharp":
                            case "natural-sharp":
                                return h.AccidentalEnum.SHARP;
                            case "flat":
                            case "natural-flat":
                                return h.AccidentalEnum.FLAT;
                            case "natural":
                                return h.AccidentalEnum.NATURAL;
                            case "double-sharp":
                            case "sharp-sharp":
                                return h.AccidentalEnum.DOUBLESHARP;
                            case "double-flat":
                            case "flat-flat":
                                return h.AccidentalEnum.DOUBLEFLAT;
                            case "triple-sharp":
                                return h.AccidentalEnum.TRIPLESHARP;
                            case "triple-flat":
                                return h.AccidentalEnum.TRIPLEFLAT;
                            case "quarter-sharp":
                                return h.AccidentalEnum.QUARTERTONESHARP;
                            case "quarter-flat":
                                return h.AccidentalEnum.QUARTERTONEFLAT;
                            case "three-quarters-sharp":
                                return h.AccidentalEnum.THREEQUARTERSSHARP;
                            case "three-quarters-flat":
                                return h.AccidentalEnum.THREEQUARTERSFLAT;
                            case "slash-quarter-sharp":
                                return h.AccidentalEnum.SLASHQUARTERSHARP;
                            case "slash-sharp":
                                return h.AccidentalEnum.SLASHSHARP;
                            case "slash-flat":
                                return h.AccidentalEnum.SLASHFLAT;
                            case "double-slash-flat":
                                return h.AccidentalEnum.DOUBLESLASHFLAT;
                            case "sori":
                                return h.AccidentalEnum.SORI;
                            case "koron":
                                return h.AccidentalEnum.KORON;
                            default:
                                return h.AccidentalEnum.NONE;
                        }
                    }
                    addArticulationExpression(t, e) {
                        if (void 0 !== t && t.elements().length > 0) {
                            const i = t.elements();
                            for(let t = 0, s = i.length; t < s; ++t){
                                const s = i[t];
                                let o = s.name;
                                try {
                                    o = o.replace("-", "");
                                    const t = n.ArticulationEnum[o];
                                    if (n.VoiceEntry.isSupportedArticulation(t)) {
                                        let i = l.PlacementEnum.NotYetDefined;
                                        const r = s.attribute("placement")?.value;
                                        "above" === r ? i = l.PlacementEnum.Above : "below" === r && (i = l.PlacementEnum.Below);
                                        const a = new c.Articulation(t, i);
                                        if ("staccato" === o) e.Articulations.length > 0 && e.Articulations[0].articulationEnum !== n.ArticulationEnum.staccato && e.Articulations.splice(0, 0, a);
                                        else if ("breathmark" === o) i === l.PlacementEnum.NotYetDefined && (a.placement = l.PlacementEnum.Above);
                                        else if ("strongaccent" === o) {
                                            const t = s?.attribute("type")?.value;
                                            "up" === t ? a.articulationEnum = n.ArticulationEnum.marcatoup : "down" === t && (a.articulationEnum = n.ArticulationEnum.marcatodown);
                                        } else if (t === n.ArticulationEnum.softaccent) {
                                            const t = e.ParentSourceStaffEntry.ParentStaff.Id - 1;
                                            i === l.PlacementEnum.NotYetDefined && (i = l.PlacementEnum.Above, t > 0 && (i = l.PlacementEnum.Below));
                                            const s = e.ParentSourceStaffEntry.VerticalContainerParent.ParentMeasure, n = new u.MultiExpression(s, e.Timestamp);
                                            n.StartingContinuousDynamic = new d.ContinuousDynamicExpression(d.ContDynamicEnum.crescendo, i, t, s, -1), n.StartingContinuousDynamic.IsStartOfSoftAccent = !0, n.StartingContinuousDynamic.StartMultiExpression = n, n.StartingContinuousDynamic.EndMultiExpression = n, n.EndingContinuousDynamic = new d.ContinuousDynamicExpression(d.ContDynamicEnum.diminuendo, i, t, s, -1), n.EndingContinuousDynamic.StartMultiExpression = n, n.EndingContinuousDynamic.EndMultiExpression = n, s.StaffLinkedExpressions[t].push(n);
                                        }
                                        e.hasArticulation(a) || e.Articulations.push(a);
                                    }
                                } catch (t) {
                                    const e = "Invalid note articulation.";
                                    return void r.default.debug("addArticulationExpression", e, t);
                                }
                            }
                        }
                    }
                    addFermata(t, e) {
                        let i = n.ArticulationEnum.fermata;
                        t.attributes().length > 0 && t.attribute("type") && "inverted" === t.attribute("type").value && (i = n.ArticulationEnum.invertedfermata);
                        let s = l.PlacementEnum.Above;
                        "below" === t.attribute("placement")?.value && (s = l.PlacementEnum.Below), e.Articulations.push(new c.Articulation(i, s));
                    }
                    addTechnicalArticulations(t, e, i) {
                        const s = {
                            bend: n.ArticulationEnum.bend,
                            "down-bow": n.ArticulationEnum.downbow,
                            "open-string": n.ArticulationEnum.naturalharmonic,
                            "snap-pizzicato": n.ArticulationEnum.snappizzicato,
                            stopped: n.ArticulationEnum.lefthandpizzicato,
                            "up-bow": n.ArticulationEnum.upbow,
                            harmonic: n.ArticulationEnum.naturalharmonic
                        };
                        for(const i in s){
                            if (!s.hasOwnProperty(i)) continue;
                            const n = s[i], r = t.element(i);
                            if (r) {
                                let t;
                                "above" === r.attribute("placement")?.value && (t = l.PlacementEnum.Above), "below" === r.attribute("placement")?.value && (t = l.PlacementEnum.Below);
                                const i = new c.Articulation(n, t);
                                e.hasArticulation(i) || e.Articulations.push(i);
                            }
                        }
                        const r = t.elements("fingering");
                        for (const t of r){
                            const s = this.createTechnicalInstruction(t, i);
                            s.type = o.TechnicalInstructionType.Fingering, i.Fingering || (i.Fingering = s), e.TechnicalInstructions.push(s);
                        }
                        const a = t.element("string");
                        if (a) {
                            const t = this.createTechnicalInstruction(a, i);
                            t.type = o.TechnicalInstructionType.String, i.StringInstruction = t, e.TechnicalInstructions.push(t);
                        }
                    }
                    createTechnicalInstruction(t, e) {
                        const i = new o.TechnicalInstruction;
                        i.sourceNote = e, i.value = t.value;
                        const s = t.attribute("placement");
                        return this.rules.FingeringPositionFromXML && (i.placement = this.getPlacement(s)), i;
                    }
                    getPlacement(t, e = l.PlacementEnum.NotYetDefined) {
                        if (e !== l.PlacementEnum.NotYetDefined) return e;
                        if (!t) return l.PlacementEnum.NotYetDefined;
                        switch(t.value){
                            case "above":
                                return l.PlacementEnum.Above;
                            case "below":
                                return l.PlacementEnum.Below;
                            case "left":
                                return l.PlacementEnum.Left;
                            case "right":
                                return l.PlacementEnum.Right;
                            default:
                                return l.PlacementEnum.NotYetDefined;
                        }
                    }
                    addOrnament(t, e) {
                        if (t) {
                            let i;
                            const s = {
                                "delayed-inverted-turn": a.OrnamentEnum.DelayedInvertedTurn,
                                "delayed-turn": a.OrnamentEnum.DelayedTurn,
                                "inverted-mordent": a.OrnamentEnum.InvertedMordent,
                                "inverted-turn": a.OrnamentEnum.InvertedTurn,
                                mordent: a.OrnamentEnum.Mordent,
                                "trill-mark": a.OrnamentEnum.Trill,
                                turn: a.OrnamentEnum.Turn
                            };
                            for(const e in s){
                                if (!s.hasOwnProperty(e)) continue;
                                const n = t.element(e);
                                if (n) {
                                    i = new a.OrnamentContainer(s[e]);
                                    const r = n.attribute("placement");
                                    if (r) {
                                        const e = r.value, s = t.elements("wavy-line").some((t)=>"start" === t.attribute("type")?.value);
                                        "below" !== e || s || (i.placement = l.PlacementEnum.Below);
                                    }
                                }
                            }
                            if (i) {
                                const s = t.elements("accidental-mark");
                                if (s) {
                                    let t = l.PlacementEnum.Below, e = h.AccidentalEnum.NONE;
                                    const n = s;
                                    for(let s = 0, r = n.length; s < r; ++s){
                                        const r = n[s], o = r.value;
                                        let a;
                                        e = this.getAccEnumFromString(o);
                                        const h = r.attribute("placement");
                                        r.hasAttributes && h && (a = h.value, "above" === a ? t = l.PlacementEnum.Above : "below" === a && (t = l.PlacementEnum.Below)), t === l.PlacementEnum.Above ? (i.AccidentalAbove = e, i.AccidentalAboveXml = o) : t === l.PlacementEnum.Below && (i.AccidentalBelow = e, i.AccidentalBelowXml = o);
                                    }
                                }
                                e.OrnamentContainer = i;
                            }
                        }
                    }
                };
            },
            9536 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.ChordSymbolReader = void 0;
                const n = i(9719), r = i(8233), o = i(9767), a = s(i(3065)), l = i(6362);
                class h {
                    static readChordSymbol(t, e, i) {
                        const s = t.element("root"), c = t.element("kind"), u = t.element("numeral"), d = c.attribute("text");
                        if (!s && !u) return;
                        let f;
                        const m = t.element("bass");
                        if (m) {
                            const t = m.element("bass-step"), i = m.element("bass-alter");
                            let s = r.NoteEnum.C;
                            if (t) try {
                                s = r.NoteEnum[t.value.trim()];
                            } catch (t) {
                                const i = o.ITextTranslation.translateText("ReaderErrorMessages/ChordSymbolError", "Invalid chord symbol");
                                return e.SheetErrors.pushMeasureError(i), void a.default.debug("InstrumentReader.readChordSymbol", i, t);
                            }
                            let n = r.AccidentalEnum.NONE;
                            if (i) try {
                                n = r.Pitch.AccidentalFromHalfTones(parseInt(i.value, 10));
                            } catch (t) {
                                const i = o.ITextTranslation.translateText("ReaderErrorMessages/ChordSymbolError", "Invalid chord symbol");
                                e.SheetErrors.pushMeasureError(i), a.default.debug("InstrumentReader.readChordSymbol", i, t);
                            }
                            f = new r.Pitch(s, 1, n);
                        }
                        const p = [], g = t.elements("degree");
                        for (const t of g)if (t) {
                            const i = t.element("degree-value"), s = t.element("degree-alter"), l = t.element("degree-type");
                            if (!i || !s || !l) return;
                            let h, c, u;
                            try {
                                h = parseInt(i.value.trim(), 10);
                            } catch (t) {
                                const i = o.ITextTranslation.translateText("ReaderErrorMessages/ChordSymbolError", "Invalid chord symbol");
                                return e.SheetErrors.pushMeasureError(i), void a.default.debug("InstrumentReader.readChordSymbol", i, t);
                            }
                            try {
                                c = r.Pitch.AccidentalFromHalfTones(parseInt(s.value, 10));
                            } catch (t) {
                                const i = o.ITextTranslation.translateText("ReaderErrorMessages/ChordSymbolError", "Invalid chord symbol");
                                return e.SheetErrors.pushMeasureError(i), void a.default.debug("InstrumentReader.readChordSymbol", i, t);
                            }
                            try {
                                u = n.ChordDegreeText[l.value.trim().toLowerCase()];
                            } catch (t) {
                                const i = o.ITextTranslation.translateText("ReaderErrorMessages/ChordSymbolError", "Invalid chord symbol");
                                return e.SheetErrors.pushMeasureError(i), void a.default.debug("InstrumentReader.readChordSymbol", i, t);
                            }
                            p.push(new n.Degree(h, c, u));
                        }
                        let b = h.readPlacement(t);
                        if (b !== l.PlacementEnum.Below && (b = l.PlacementEnum.Above), u) {
                            const t = u.element("numeral-root"), i = t?.attribute("text")?.value, s = i ?? t?.value, r = new n.ChordSymbolContainer(void 0, n.ChordSymbolEnum.none, f, p, e.Rules, b);
                            return r.NumeralText = s, r;
                        }
                        const S = s.element("root-step"), y = s.element("root-alter");
                        if (s && !S) return;
                        let E;
                        try {
                            E = r.NoteEnum[S.value.trim()];
                        } catch (t) {
                            const i = o.ITextTranslation.translateText("ReaderErrorMessages/ChordSymbolError", "Invalid chord symbol");
                            return e.SheetErrors.pushMeasureError(i), void a.default.debug("InstrumentReader.readChordSymbol", i, t);
                        }
                        let x = r.AccidentalEnum.NONE;
                        if (y) try {
                            x = r.Pitch.AccidentalFromHalfTones(parseInt(y.value, 10));
                        } catch (t) {
                            const i = o.ITextTranslation.translateText("ReaderErrorMessages/ChordSymbolError", "Invalid chord symbol");
                            e.SheetErrors.pushMeasureError(i), a.default.debug("InstrumentReader.readChordSymbol", i, t);
                        }
                        const v = new r.Pitch(E, 1, x);
                        let T, _ = c.value.trim().replace("-", "");
                        if (d) switch(d.value){
                            case "aug":
                                _ = "augmented";
                                break;
                            case "dim":
                                _ = "diminished";
                        }
                        try {
                            T = n.ChordSymbolEnum[_];
                        } catch (t) {
                            const i = o.ITextTranslation.translateText("ReaderErrorMessages/ChordSymbolError", "Invalid chord symbol");
                            return e.SheetErrors.pushMeasureError(i), void a.default.debug("InstrumentReader.readChordSymbol", i, t);
                        }
                        return new n.ChordSymbolContainer(v, T, f, p, e.Rules, b);
                    }
                    static readPlacement(t) {
                        const e = t.attribute("placement")?.value;
                        return "above" === e ? l.PlacementEnum.Above : "below" === e ? l.PlacementEnum.Below : l.PlacementEnum.NotYetDefined;
                    }
                }
                e.ChordSymbolReader = h;
            },
            5984 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.ExpressionReader = void 0;
                const n = i(2561), r = i(5332), o = i(5875), a = i(2221), l = i(2148), h = i(437), c = i(9019), u = i(9161), d = i(9803), f = i(1112), m = i(6362), p = i(7533), g = i(9767), b = s(i(3065)), S = i(2570), y = i(9157), E = i(3253), x = i(6206);
                class v {
                    constructor(t, e, i){
                        this.openContinuousDynamicExpressions = [], this.openOctaveShifts = new Map, this.pendingOctaveShiftStops = new Map, this.musicSheet = t, this.staffNumber = i, this.globalStaffIndex = t.getGlobalStaffIndexOfFirstStaff(e) + (i - 1), this.initialize();
                    }
                    readExpressionParameters(t, e, i, s, r, o, a) {
                        this.initialize(), this.divisions = i;
                        const l = t.element("offset");
                        if (void 0 !== l && !a) try {
                            this.offsetDivisions = parseInt(l.value, 10);
                        } catch (t) {
                            const e = "ReaderErrorMessages/ExpressionOffsetError, Invalid expression offset -> set to default.";
                            b.default.debug("ExpressionReader.readExpressionParameters", e, t), this.musicSheet.SheetErrors.pushMeasureError(e), this.offsetDivisions = 0;
                        }
                        this.directionTimestamp = n.Fraction.createFromFraction(s);
                        const h = t.elements("direction-type"), c = t.attribute("placement");
                        if (c) try {
                            const t = c.value;
                            "below" === t ? this.placement = m.PlacementEnum.Below : "above" === t && (this.placement = m.PlacementEnum.Above);
                        } catch (t) {
                            const e = g.ITextTranslation.translateText("ReaderErrorMessages/ExpressionPlacementError", "Invalid expression placement -> set to default.");
                            b.default.debug("ExpressionReader.readExpressionParameters", e, t), this.musicSheet.SheetErrors.pushMeasureError(e), this.placement = m.PlacementEnum.Below;
                        }
                        try {
                            for (const t of h){
                                const e = t.element("wedge");
                                if (e) {
                                    const t = e.attribute("default-y");
                                    t && (this.WedgeYPosXml = parseInt(t.value, 10), this.placement === m.PlacementEnum.NotYetDefined && this.readExpressionPlacement(t, "read wedge y pos"));
                                }
                                if (this.placement === m.PlacementEnum.NotYetDefined) {
                                    const e = t.element("dynamics");
                                    if (e) {
                                        const t = e.attribute("default-y");
                                        t && this.readExpressionPlacement(t, "read dynamics y pos");
                                    }
                                    const i = t.element("words");
                                    if (i) {
                                        const t = i.attribute("default-y");
                                        t && this.readExpressionPlacement(t, "read words y pos");
                                    }
                                    const s = t.element("rehearsal");
                                    if (s) {
                                        const t = s.attribute("default-y");
                                        t && this.readExpressionPlacement(t, "read rehearsal pos");
                                    }
                                }
                            }
                        } catch (t) {
                            const e = g.ITextTranslation.translateText("ReaderErrorMessages/ExpressionPlacementError", "Invalid expression placement. Set to default.");
                            b.default.debug("ExpressionReader.readExpressionParameters", e, t), this.musicSheet.SheetErrors.pushMeasureError(e), this.placement = m.PlacementEnum.Below;
                        }
                        this.placement === m.PlacementEnum.NotYetDefined && (e.Staves.length > 1 ? this.placement = m.PlacementEnum.Below : e.HasLyrics ? this.placement = m.PlacementEnum.Above : this.placement = m.PlacementEnum.Below);
                    }
                    read(t, e, i, s, r = t.elements("direction-type")) {
                        let o = !1, a = !1;
                        const l = i.clone(), h = t.element("offset");
                        if (h?.value) {
                            const t = Number.parseInt(h.value, 10);
                            l.Add(new n.Fraction(t, 4 * this.divisions));
                        }
                        const c = t.element("sound");
                        if (c) {
                            const t = c.attribute("tempo"), s = c.attribute("dynamics");
                            if (t) {
                                const s = t.value.match(/^(\d+)(\.\d+)?$/);
                                s?.length > 0 ? this.soundTempo = Math.round(Number.parseFloat(t.value)) : (b.default.info("invalid xml tempo: " + t.value), this.soundTempo = 100), e.TempoInBPM = this.soundTempo, this.musicSheet.HasBPMInfo = !0, o = !0, this.explicitSoundTempo = this.soundTempo;
                                const n = c.element("offset") ?? ("yes" === h?.attribute("sound")?.value ? h : void 0);
                                this.soundTimestamp = this.readDirectionTimestamp(n, i);
                            }
                            if (s) {
                                const t = s.value.match(/\d+/);
                                this.soundDynamic = void 0 !== t ? parseInt(t[0], 10) : 100;
                                const e = c.element("offset") ?? ("yes" === h?.attribute("sound")?.value ? h : void 0);
                                this.soundDynamicTimestamp = this.readDirectionTimestamp(e, i), a = !0;
                            }
                        }
                        const d = this.directionTimestamp;
                        for (const n of r){
                            this.directionTimestamp = d;
                            let r = n.element("metronome");
                            if (r) {
                                this.directionTimestamp = this.readDirectionTimestamp(r.attribute("default-x") ? void 0 : h, i);
                                const t = r.elements("metronome-note"), s = r.element("metronome-relation");
                                if (t.length > 0 && s) this.parseComplexMetronomeMark(r, t, s, e, l);
                                else if (!r.element("per-minute") && r.elements("beat-unit").length > 1) this.parseBeatUnitNoteEquation(r, e, l);
                                else {
                                    const t = r.element("beat-unit"), i = void 0 !== r.element("beat-unit-dot"), s = r.element("per-minute");
                                    if (void 0 !== t && s) {
                                        const n = s.value.match(/(\d+\.?\d*)/), o = n ? parseFloat(n[1]) : NaN;
                                        this.createNewTempoExpressionIfNeeded(e);
                                        const a = new u.InstantaneousTempoExpression(void 0, this.placement, this.staffNumber, o, this.currentMultiTempoExpression, !0);
                                        a.parentMeasure = e, this.soundTempo = o, e.TempoInBPM = this.soundTempo * (i ? 1.5 : 1), this.musicSheet.HasBPMInfo = !0, a.dotted = i, a.beatUnit = t.value, a.printObject = "no" !== r.attribute("print-object")?.value, this.currentMultiTempoExpression.addExpression(a, ""), this.currentMultiTempoExpression.CombinedExpressionsText = "test";
                                    }
                                }
                                continue;
                            }
                            if (r = n.element("dynamics"), r) {
                                this.directionTimestamp = this.readDirectionTimestamp(h, i);
                                const s = void 0 !== t.element("notations");
                                this.interpretInstantaneousDynamics(r, e, l, s);
                                continue;
                            }
                            if (r = n.element("words"), r) {
                                const t = n.elements().map((t)=>"words" === t.name ? t.value : "symbol" === t.name ? v.noteSymbolTexts.get(t.value.trim().replace(/Down$/, "Up")) ?? "" : "").join("");
                                if (o) {
                                    this.directionTimestamp = this.readDirectionTimestamp(r.attribute("default-x") ? void 0 : h, i), this.createNewTempoExpressionIfNeeded(e), this.currentMultiTempoExpression.CombinedExpressionsText = t;
                                    const s = new u.InstantaneousTempoExpression(t, this.placement, this.staffNumber, this.soundTempo, this.currentMultiTempoExpression);
                                    s.language = r.attribute("xml:lang")?.value, this.currentMultiTempoExpression.addExpression(s, "");
                                } else a || this.interpretWords(r, t, e, l);
                                continue;
                            }
                            if (r = n.element("wedge"), r) this.directionTimestamp = this.readDirectionTimestamp(h, i), this.interpretWedge(t, r, e, s, e.MeasureNumber);
                            else if (r = n.element("rehearsal"), r) {
                                const t = n.elements("rehearsal").map((t)=>t.value).join("");
                                this.interpretRehearsalMark(t, e, i, e.MeasureNumber);
                                continue;
                            }
                        }
                    }
                    closeOpenExpressions(t, e) {
                        for (const i of this.openContinuousDynamicExpressions)this.createNewMultiExpressionIfNeeded(t, i.NumberXml, e), this.closeOpenContinuousDynamic(i, t, e);
                        this.openContinuousTempoExpression && this.closeOpenContinuousTempo(n.Fraction.plus(t.AbsoluteTimestamp, e));
                    }
                    addOctaveShift(t, e, i, s = 0) {
                        let r = 1;
                        const o = t.element("staff");
                        if (o) try {
                            r = parseInt(o.value, 10);
                        } catch (t) {
                            const e = g.ITextTranslation.translateText("ReaderErrorMessages/OctaveShiftStaffError", "Invalid octave shift staff number. Set to default");
                            this.musicSheet.SheetErrors.pushMeasureError(e), r = 1, b.default.debug("ExpressionReader.addOctaveShift", e, t);
                        }
                        const a = t.elements("direction-type"), l = this.readPlacement(t);
                        for (const t of a){
                            const o = t.element("octave-shift");
                            if (void 0 !== o && o.hasAttributes) try {
                                const t = this.readNumber(o);
                                if (o.attribute("size")) {
                                    const a = parseInt(o.attribute("size").value, 10);
                                    let c = 0;
                                    8 === a ? c = 1 : 15 === a && (c = 2);
                                    let u = o.attribute("type")?.value;
                                    if (u || (l === m.PlacementEnum.Above ? u = "down" : l === m.PlacementEnum.Below && (u = "up")), "up" === u || "down" === u) {
                                        const i = new h.OctaveShift(u, c);
                                        i.StaffNumber = r, i.numberXml = t, this.getMultiExpression = this.createNewMultiExpressionIfNeeded(e, t), this.getMultiExpression.OctaveShiftStart = i, i.ParentStartMultiExpression = this.getMultiExpression, this.openOctaveShifts.set(t, i);
                                        const s = this.pendingOctaveShiftStops.get(t);
                                        s && (this.pendingOctaveShiftStops.delete(t), this.getMultiExpression = this.createNewMultiExpressionIfNeeded(s.measure, t, s.endTimestamp), this.getMultiExpression.OctaveShiftEnd = i, i.ParentEndMultiExpression = this.getMultiExpression, this.openOctaveShifts.delete(t));
                                    } else if ("stop" === u) {
                                        const r = this.openOctaveShifts.get(t);
                                        if (r) r.endVoiceEntryIndex = s, this.getMultiExpression = this.createNewMultiExpressionIfNeeded(e, r.numberXml, i), this.getMultiExpression.OctaveShiftEnd = r, r.ParentEndMultiExpression = this.getMultiExpression, this.openOctaveShifts.delete(t);
                                        else {
                                            const i = n.Fraction.minus(this.directionTimestamp, new n.Fraction(1, 4 * this.divisions));
                                            this.pendingOctaveShiftStops.set(t, {
                                                measure: e,
                                                endTimestamp: i
                                            });
                                        }
                                    } else u || b.default.debug("octave-shift missing type in xml");
                                }
                            } catch (t) {
                                const e = g.ITextTranslation.translateText("ReaderErrorMessages/OctaveShiftError", "Error while reading octave shift.");
                                this.musicSheet.SheetErrors.pushMeasureError(e), b.default.debug("ExpressionReader.addOctaveShift", e, t);
                            }
                        }
                    }
                    addPedalMarking(t, e, i) {
                        const s = t.elements("direction-type");
                        for (const t of s){
                            const s = t.element("pedal");
                            if (s && s.hasAttributes) {
                                let t = !1, n = !1;
                                try {
                                    switch("yes" === s.attribute("line")?.value ? n = !0 : "no" === s.attribute("line")?.value ? (n = !1, t = !0) : "yes" === s.attribute("sign")?.value ? t = !0 : (t = !1, n = !0), s.attribute("type").value){
                                        case "start":
                                            this.openPedal && this.openPedal.IsLine && this.endOpenPedal(e), this.createNewMultiExpressionIfNeeded(e, -1), this.openPedal = new E.Pedal(n, t), this.getMultiExpression.PedalStart = this.openPedal, this.openPedal.ParentStartMultiExpression = this.getMultiExpression;
                                            break;
                                        case "stop":
                                            this.openPedal && this.endOpenPedal(e, i);
                                            break;
                                        case "change":
                                            this.openPedal && this.openPedal.IsLine && (this.openPedal.ChangeEnd = !0, this.createNewMultiExpressionIfNeeded(e, -1), this.getMultiExpression.PedalEnd = this.openPedal, this.openPedal.ParentEndMultiExpression = this.getMultiExpression, this.createNewMultiExpressionIfNeeded(e, -1), this.openPedal = new E.Pedal(n, t), this.openPedal.ChangeBegin = !0, this.getMultiExpression.PedalStart = this.openPedal, this.openPedal.ParentStartMultiExpression = this.getMultiExpression);
                                    }
                                } catch (t) {
                                    const e = g.ITextTranslation.translateText("ReaderErrorMessages/PedalError", "Error while reading pedal.");
                                    this.musicSheet.SheetErrors.pushMeasureError(e), b.default.debug("ExpressionReader.addPedalMarking", e, t);
                                }
                            }
                        }
                    }
                    endOpenPedal(t, e) {
                        this.createNewMultiExpressionIfNeeded(t, -1, e), this.getMultiExpression.PedalEnd = this.openPedal, this.openPedal.ParentEndMultiExpression = this.getMultiExpression, this.openPedal = void 0;
                    }
                    addWavyLine(t, e, i, s) {
                        if (t && t.hasAttributes) try {
                            switch(t.attribute("type").value){
                                case "start":
                                    this.createNewMultiExpressionIfNeeded(e, -1), this.openWavyLine = new x.WavyLine(this.placement), this.getMultiExpression.WavyLineStart = this.openWavyLine, this.openWavyLine.ParentStartMultiExpression = this.getMultiExpression;
                                    break;
                                case "stop":
                                    this.openWavyLine && (this.createNewMultiExpressionIfNeeded(e, -1, i), this.getMultiExpression.WavyLineEnd = this.openWavyLine, this.openWavyLine.ParentEndMultiExpression = this.getMultiExpression, this.openWavyLine = void 0);
                            }
                        } catch (t) {
                            const e = g.ITextTranslation.translateText("ReaderErrorMessages/WavyLineError", "Error while reading wavy-line.");
                            this.musicSheet.SheetErrors.pushMeasureError(e), b.default.debug("ExpressionReader.addWavyLine", e, t);
                        }
                    }
                    initialize() {
                        this.placement = m.PlacementEnum.NotYetDefined, this.soundTempo = 0, this.soundTimestamp = void 0, this.explicitSoundTempo = void 0, this.soundDynamic = 0, this.soundDynamicTimestamp = void 0, this.offsetDivisions = 0;
                    }
                    readPlacement(t) {
                        const e = t.attribute("placement")?.value;
                        return "above" === e ? m.PlacementEnum.Above : "below" === e ? m.PlacementEnum.Below : m.PlacementEnum.NotYetDefined;
                    }
                    readExpressionPlacement(t, e) {
                        try {
                            const e = this.readPosition(t);
                            e < 0 ? this.placement = m.PlacementEnum.Below : e > 0 && (this.placement = m.PlacementEnum.Above);
                        } catch (t) {
                            b.default.debug("ExpressionReader.readExpressionParameters", e, t);
                        }
                    }
                    readPosition(t) {
                        try {
                            const e = parseInt(t.value, 10);
                            return e < 0 ? this.placement = m.PlacementEnum.Below : e > 0 && (this.placement = m.PlacementEnum.Above), e;
                        } catch (t) {
                            b.default.debug("ExpressionReader.readExpressionParameters", t);
                        }
                    }
                    parseComplexMetronomeMark(t, e, i, s, n) {
                        const r = t.elements(), o = [], a = [];
                        let l, h, c = !1, u = !1;
                        for (const t of r){
                            if ("metronome-relation" === t.name) {
                                c = !0, u = !1;
                                continue;
                            }
                            if ("metronome-note" !== t.name) continue;
                            const e = t.element("metronome-type");
                            if (!e) continue;
                            const i = {
                                type: e.value,
                                dots: t.elements("metronome-dot").length
                            }, s = t.element("metronome-beam");
                            s && (i.beam = s.value);
                            const n = t.element("metronome-tied")?.attribute("type")?.value;
                            ("stop" === n || u) && (i.tied = !0), u = "start" === n;
                            const r = t.element("metronome-tuplet");
                            if (r && "start" === (r.hasAttributes ? r.attribute("type")?.value : void 0)) {
                                const t = r.element("actual-notes"), e = r.element("normal-notes"), i = r.attribute("bracket"), s = r.attribute("show-number"), n = {
                                    actualNotes: t ? parseInt(t.value, 10) : 3,
                                    normalNotes: e ? parseInt(e.value, 10) : 2,
                                    bracket: !i || "yes" === i.value,
                                    showNumber: s ? s.value : "actual"
                                };
                                c ? h = n : l = n;
                            }
                            c ? a.push(i) : o.push(i);
                        }
                        const d = {
                            notes: o,
                            tuplet: l
                        }, f = {
                            notes: a,
                            tuplet: h
                        };
                        this.addNoteEquation(t, d, f, i.value, s, n);
                    }
                    parseBeatUnitNoteEquation(t, e, i) {
                        const s = [], n = [];
                        let r = s;
                        for (const e of t.elements())"beat-unit" === e.name ? (s.length > 0 && (r = n), r.push({
                            type: e.value,
                            dots: 0
                        })) : "beat-unit-dot" === e.name && r.length > 0 ? r[r.length - 1].dots++ : "beat-unit-tied" === e.name && e.element("beat-unit") && r.push({
                            type: e.element("beat-unit").value,
                            dots: e.elements("beat-unit-dot").length,
                            tied: !0
                        });
                        this.addNoteEquation(t, {
                            notes: s
                        }, {
                            notes: n
                        }, "equals", e, i);
                    }
                    addNoteEquation(t, e, i, s, r, o) {
                        t.hasAttributes && void 0 !== t.attribute("default-x") && (this.directionTimestamp = n.Fraction.createFromFraction(o)), this.createNewTempoExpressionIfNeeded(r);
                        const a = new u.InstantaneousTempoExpression(void 0, this.placement, this.staffNumber, this.soundTempo, this.currentMultiTempoExpression, !0);
                        a.parentMeasure = r, a.metronomeNoteGroupLeft = e, a.metronomeNoteGroupRight = i, a.metronomeRelation = s, a.printObject = "no" !== t.attribute("print-object")?.value, this.musicSheet.HasBPMInfo = !0, this.currentMultiTempoExpression.addExpression(a, ""), this.currentMultiTempoExpression.CombinedExpressionsText = "test";
                    }
                    interpretInstantaneousDynamics(t, e, i, s) {
                        if (t.hasElements) {
                            const r = this.readNumber(t), o = t.elements().map((t)=>"other-dynamics" === t.name ? t.value : t.name).join("").trim();
                            if (o) {
                                const t = l.InstantaneousDynamicExpression.dynamicEnumFromText(o);
                                if (e.Rules?.IgnoreRepeatedDynamics && this.activeInstantaneousDynamic?.DynamicExpression?.toLowerCase() === o.toLowerCase()) return;
                                s ? this.createNewMultiExpressionIfNeeded(e, r, n.Fraction.createFromFraction(i)) : this.createNewMultiExpressionIfNeeded(e, r, void 0, this.soundDynamicTimestamp);
                                const a = this.getMultiExpression.InstantaneousDynamic;
                                let h = o, c = t;
                                a && a.StaffNumber === this.staffNumber && a.DynamicExpression.toLowerCase() !== o.toLowerCase() && (h = a.DynamicExpression + " " + o, c = a.DynEnum ?? t);
                                const u = new l.InstantaneousDynamicExpression(h, this.soundDynamic, this.placement, this.staffNumber, e, c);
                                u.InMeasureTimestamp = i.clone(), this.getMultiExpression.addExpression(u, ""), this.activeInstantaneousDynamic ? (this.activeInstantaneousDynamic.DynEnum = u.DynEnum, this.activeInstantaneousDynamic.DynamicExpression = u.DynamicExpression) : this.activeInstantaneousDynamic = new l.InstantaneousDynamicExpression(u.DynamicExpression, 0, m.PlacementEnum.NotYetDefined, 1, e, u.DynEnum);
                            }
                        }
                    }
                    interpretWords(t, e, i, s) {
                        if (i.Rules.IgnoreBracketsWords && (/^\(\s*\)$/.test(e) || /^\[\s*\]$/.test(e))) return;
                        let r;
                        const o = t.attribute("font-style");
                        let a, l, h;
                        o && (a = o.value, "italic" === a && (r = S.FontStyles.Italic));
                        const c = t.attribute("font-weight");
                        c && (l = c.value, "bold" === l && (r = S.FontStyles.Bold, "italic" === a && (r = S.FontStyles.BoldItalic)));
                        const u = t.attribute("color");
                        u && (h = u.value);
                        const d = t.attribute("xml:lang")?.value;
                        let f;
                        if (i.Rules.PlaceWordsInsideStafflineFromXml) {
                            const e = t.attribute("default-y")?.value;
                            e?.length > 0 && (f = Number.parseInt(e, 10));
                        }
                        if (e.length > 0) {
                            if (this.directionTimestamp = n.Fraction.createFromFraction(s), this.checkIfWordsNodeIsRepetitionInstruction(e)) return;
                            this.fillMultiOrTempoExpression(e, i, s, r, h, f, d);
                        }
                    }
                    readNumber(t) {
                        let e = 1;
                        const i = t.attribute("number")?.value;
                        return i && (e = Number.parseInt(i, 10)), e;
                    }
                    interpretWedge(t, e, i, s, r) {
                        const a = this.readNumber(e), l = e.attribute("type")?.value?.toLowerCase();
                        this.lastWedge && this.lastWedge.parentMeasure.MeasureNumberXML === i.MeasureNumberXML && this.lastWedge.StaffNumber === this.staffNumber && this.placement === this.lastWedge.Placement && void 0 !== this.WedgeYPosXml && this.lastWedge.YPosXml === this.WedgeYPosXml && this.lastWedge.StartMultiExpression.Timestamp.Equals(this.directionTimestamp) && (this.lastWedge.StartMultiExpression.PlaybackTimestamp ?? this.lastWedge.StartMultiExpression.Timestamp).Equals(this.soundDynamicTimestamp ?? this.directionTimestamp) && this.lastWedge.DynamicType === o.ContDynamicEnum[l] || ("stop" === l ? (this.createNewMultiExpressionIfNeeded(i, a, s), this.getMultiExpression.EndOffsetFraction = new n.Fraction(this.offsetDivisions, 4 * this.divisions)) : this.createNewMultiExpressionIfNeeded(i, a, void 0, this.soundDynamicTimestamp), this.addWedge(e, i, s));
                    }
                    interpretRehearsalMark(t, e, i, s) {
                        e.rehearsalExpression = new y.RehearsalExpression(t, this.placement);
                    }
                    createNewMultiExpressionIfNeeded(t, e, i, s) {
                        i || (i = this.directionTimestamp);
                        let r = this.getMultiExpression;
                        return r && (!r || r.SourceMeasureParent === t && r.numberXml === e && r.Timestamp.Equals(i) && (r.PlaybackTimestamp ?? r.Timestamp).Equals(s ?? i)) || (this.getMultiExpression = r = new c.MultiExpression(t, n.Fraction.createFromFraction(i)), this.getMultiExpression.numberXml = e, this.getMultiExpression.PlaybackTimestamp = s?.clone(), t.StaffLinkedExpressions[this.globalStaffIndex].push(r)), r;
                    }
                    readDirectionTimestamp(t, e) {
                        const i = e.clone();
                        if (t) {
                            const e = t.value.trim(), s = Number(e);
                            /^[+-]?(?:\d+(?:\.\d*)?|\.\d+)$/.test(e) && Number.isFinite(s) && i.Add(new n.Fraction(s, 4 * this.divisions));
                        }
                        return i;
                    }
                    createNewTempoExpressionIfNeeded(t) {
                        this.currentMultiTempoExpression && this.currentMultiTempoExpression.SourceMeasureParent === t && this.currentMultiTempoExpression.Timestamp === this.directionTimestamp || (this.currentMultiTempoExpression = new r.MultiTempoExpression(t, n.Fraction.createFromFraction(this.directionTimestamp)), this.currentMultiTempoExpression.PlaybackTimestamp = this.soundTimestamp?.clone(), this.currentMultiTempoExpression.PlaybackTempoInBpm = this.explicitSoundTempo, t.TempoExpressions.push(this.currentMultiTempoExpression));
                    }
                    addWedge(t, e, i) {
                        if (void 0 !== t && t.hasAttributes) {
                            const s = this.readNumber(t), n = t.attribute("type").value.toLowerCase();
                            try {
                                if ("crescendo" === n || "diminuendo" === n) {
                                    const t = new o.ContinuousDynamicExpression(o.ContDynamicEnum[n], this.placement, this.staffNumber, e, s);
                                    this.lastWedge = t, this.lastWedge.YPosXml = this.WedgeYPosXml, this.openContinuousDynamicExpressions.push(t);
                                    let i = this.getMultiExpression;
                                    i || (i = this.createNewMultiExpressionIfNeeded(e, s)), i.StartingContinuousDynamic = t, t.StartMultiExpression = i, void 0 !== this.activeInstantaneousDynamic && this.activeInstantaneousDynamic.StaffNumber === t.StaffNumber && (this.activeInstantaneousDynamic = void 0);
                                } else if ("stop" === n) for (const t of this.openContinuousDynamicExpressions)t.NumberXml === s && this.closeOpenContinuousDynamic(t, e, i);
                            } catch (t) {
                                const e = "ReaderErrorMessages/WedgeError, Error while reading Crescendo / Diminuendo.";
                                this.musicSheet.SheetErrors.pushMeasureError(e), b.default.debug("ExpressionReader.addWedge", e, t);
                            }
                        }
                    }
                    fillMultiOrTempoExpression(t, e, i, s, n, r, o) {
                        if (!t) return;
                        const a = t.trim();
                        this.createExpressionFromString("", a, e, i, t, s, n, r, o);
                    }
                    createExpressionFromString(t, e, i, s, n, r, l, h, c) {
                        const m = u.InstantaneousTempoExpression.isInputStringInstantaneousTempo(e), g = a.ContinuousTempoExpression.isInputStringContinuousTempo(e);
                        if (m || g) {
                            if (i.TempoExpressions.length > 0) for(let t = 0, s = i.TempoExpressions.length; t < s; ++t){
                                const s = i.TempoExpressions[t];
                                if (s.Timestamp === this.directionTimestamp && void 0 !== s.InstantaneousTempo && -1 !== s.InstantaneousTempo.Label.indexOf(e)) return !1;
                            }
                            if (this.createNewTempoExpressionIfNeeded(i), this.currentMultiTempoExpression.CombinedExpressionsText = n, m) {
                                const i = new u.InstantaneousTempoExpression(e, this.placement, this.staffNumber, this.soundTempo, this.currentMultiTempoExpression);
                                return i.ColorXML = l, i.language = c, this.currentMultiTempoExpression.addExpression(i, t), !0;
                            }
                            if (g) {
                                const i = new a.ContinuousTempoExpression(e, this.placement, this.staffNumber, this.currentMultiTempoExpression);
                                return i.ColorXML = l, i.language = c, this.currentMultiTempoExpression.addExpression(i, t), !0;
                            }
                        }
                        if (o.ContinuousDynamicExpression.isInputStringContinuousDynamic(e)) {
                            const n = new o.ContinuousDynamicExpression(void 0, this.placement, this.staffNumber, i, -1, e);
                            n.ColorXML = l, n.language = c;
                            const r = this.getMultiExpression;
                            return r && this.closeOpenContinuousDynamic(r.StartingContinuousDynamic, i, s), this.createNewMultiExpressionIfNeeded(i, -1), void 0 !== this.activeInstantaneousDynamic && this.activeInstantaneousDynamic.StaffNumber === n.StaffNumber && (this.activeInstantaneousDynamic = void 0), this.openContinuousDynamicExpressions.push(n), n.StartMultiExpression = this.getMultiExpression, this.getMultiExpression.addExpression(n, t), !0;
                        }
                        if (d.MoodExpression.isInputStringMood(e)) {
                            const s = this.createNewMultiExpressionIfNeeded(i, -1);
                            i.hasMoodExpressions = !0;
                            const n = new d.MoodExpression(e, this.placement, this.staffNumber);
                            return n.fontStyle = r, n.ColorXML = l, n.language = c, s.addExpression(n, t), !0;
                        }
                        const b = this.createNewMultiExpressionIfNeeded(i, -1, s);
                        if (i.TempoExpressions.length > 0) for(let t = 0, s = i.TempoExpressions.length; t < s; ++t){
                            const s = i.TempoExpressions[t];
                            if (s.Timestamp === this.directionTimestamp && void 0 !== s.InstantaneousTempo && s.EntriesList.length > 0 && !this.hasDigit(e) && this.globalStaffIndex > 0) {
                                if (s.EntriesList[0].label.indexOf(e) >= 0) return !1;
                                break;
                            }
                        }
                        let S = this.musicSheet.Rules.UnknownExpressionTextAlignment;
                        this.musicSheet.Rules.CompactMode && (S = p.TextAlignmentEnum.LeftBottom);
                        const y = new f.UnknownExpression(e, this.placement, S, this.staffNumber);
                        return y.fontStyle = r, y.ColorXML = l, y.language = c, y.defaultYXml = h, y.parentMeasure = i, b.addExpression(y, t), !1;
                    }
                    closeOpenContinuousDynamic(t, e, i) {
                        if (!t) return;
                        const s = t.NumberXml;
                        t.EndMultiExpression = this.createNewMultiExpressionIfNeeded(e, s, i), t.StartMultiExpression.EndingContinuousDynamic = t, this.openContinuousDynamicExpressions = this.openContinuousDynamicExpressions.filter((e)=>e !== t);
                    }
                    closeOpenContinuousTempo(t) {
                        this.openContinuousTempoExpression.AbsoluteEndTimestamp = t, this.openContinuousTempoExpression = void 0;
                    }
                    checkIfWordsNodeIsRepetitionInstruction(t) {
                        return "coda" === (t = t.trim().toLowerCase()) || "tocoda" === t || "to coda" === t || "fine" === t || "d.c." === t || "dacapo" === t || "da capo" === t || "d.s." === t || "dalsegno" === t || "dal segno" === t || "d.c. al fine" === t || "d.s. al fine" === t || "d.c. al coda" === t || "d.s. al coda" === t;
                    }
                    hasDigit(t) {
                        return /\d/.test(t);
                    }
                }
                e.ExpressionReader = v, v.noteSymbolTexts = new Map([
                    [
                        "metNoteWhole",
                        "\uD834\uDD5D"
                    ],
                    [
                        "metNoteHalfUp",
                        "\uD834\uDD5E"
                    ],
                    [
                        "metNoteQuarterUp",
                        "\u2669"
                    ],
                    [
                        "metNote8thUp",
                        "\u266A"
                    ],
                    [
                        "metNote16thUp",
                        "\uD834\uDD61"
                    ],
                    [
                        "metNote32ndUp",
                        "\uD834\uDD62"
                    ],
                    [
                        "metNote64thUp",
                        "\uD834\uDD63"
                    ],
                    [
                        "metNote128thUp",
                        "\uD834\uDD64"
                    ],
                    [
                        "metAugmentationDot",
                        "\xb7"
                    ]
                ]);
            },
            6030 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.LyricsReader = void 0;
                const s = i(649), n = i(2317), r = i(9767);
                e.LyricsReader = class {
                    constructor(t){
                        this.openLyricWords = {}, this.musicSheet = t;
                    }
                    addLyricEntry(t, e) {
                        if (t) {
                            const i = t;
                            for(let t = 0, o = i.length; t < o; ++t){
                                const o = i[t];
                                try {
                                    let t = "single";
                                    if (o.element("text")) {
                                        let i = o.element("text");
                                        if (o.element("syllabic") && (t = o.element("syllabic").value), i) {
                                            let r = "";
                                            const a = o.elements();
                                            for (const t of a)"text" !== t.name && "elision" !== t.name || (r += t.value);
                                            if (r = r.replace("  ", " "), r = r.replace(/\n+$/, ""), void 0 !== o.element("elision") && "-" === r) {
                                                const e = o.elements();
                                                let s, n, r = 0;
                                                for(let t = 0; t < e.length; t++)if ("elision" === e[t].name) {
                                                    r = t;
                                                    break;
                                                }
                                                if (r > 0) for(let t = r; t < e.length; t++){
                                                    const i = e[t];
                                                    "text" === i.name && (s = i), "syllabic" === i.name && (n = i);
                                                }
                                                void 0 !== s && n && (i = s, t = "middle");
                                            }
                                            let l, h = "1";
                                            if (void 0 !== o.attributes() && o.attribute("number") && (h = o.attribute("number").value), "single" === t || "end" === t) {
                                                if (this.openLyricWords[h]) {
                                                    this.currentLyricWord = this.openLyricWords[h];
                                                    const t = this.currentLyricWord.Syllables.length;
                                                    l = new n.LyricsEntry(r, h, this.currentLyricWord, e, t), this.currentLyricWord.Syllables.push(l), delete this.openLyricWords[h], this.currentLyricWord = void 0;
                                                } else l = new n.LyricsEntry(r, h, void 0, e);
                                                l.extend = void 0 !== o.element("extend");
                                            } else if ("begin" === t) this.openLyricWords[h] && (delete this.openLyricWords[h], this.currentLyricWord = void 0), this.currentLyricWord = new s.LyricWord, this.openLyricWords[h] = this.currentLyricWord, l = new n.LyricsEntry(r, h, this.currentLyricWord, e, 0), this.currentLyricWord.Syllables.push(l);
                                            else if ("middle" === t) {
                                                if (this.openLyricWords[h]) {
                                                    this.currentLyricWord = this.openLyricWords[h];
                                                    const t = this.currentLyricWord.Syllables.length;
                                                    l = new n.LyricsEntry(r, h, this.currentLyricWord, e, t), this.currentLyricWord.Syllables.push(l);
                                                } else l = new n.LyricsEntry(r, h, void 0, e);
                                            }
                                            l && (l.syllabic = t, l.language = this.readLanguage(o, h), e.LyricsEntries[h] || (e.LyricsEntries.setValue(h, l), e.ParentSourceStaffEntry?.VerticalContainerParent?.ParentMeasure && (e.ParentSourceStaffEntry.VerticalContainerParent.ParentMeasure.hasLyrics = !0)), e.ParentVoice.Parent.LyricVersesNumbers.includes(h) || e.ParentVoice.Parent.LyricVersesNumbers.push(h));
                                        }
                                    }
                                } catch (t) {
                                    const e = r.ITextTranslation.translateText("ReaderErrorMessages/LyricError", "Error while reading lyric entry.");
                                    this.musicSheet.SheetErrors.pushMeasureError(e);
                                    continue;
                                }
                            }
                        }
                    }
                    readLanguage(t, e) {
                        const i = t.element("text")?.attribute("xml:lang")?.value;
                        if (i) return i;
                        const s = t.attribute("name")?.value, n = this.musicSheet.LyricLanguages, r = n.find((t)=>void 0 !== t.number && t.number === e || void 0 !== t.name && t.name === s) ?? n.find((t)=>void 0 === t.number && void 0 === t.name);
                        return r?.language;
                    }
                };
            },
            6302 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.RepetitionBuildingContainer = e.RepetitionCalculator = void 0;
                const n = i(1645), r = i(1645), o = i(7307), a = i(4076), l = s(i(3065));
                class h {
                    constructor(){
                        this.repetitionInstructions = [], this.openRepetitions = [], this.drawnOnlyInstructions = [], this.lastRepetitionCommonPartStartIndex = 0, this.movementStartIndex = 0, this.movementStartIndices = [];
                    }
                    calculateRepetitions(t, e) {
                        this.musicSheet = t, this.repetitionInstructions = e, this.openRepetitions.length = 0, this.drawnOnlyInstructions = [], this.lastRepetitionCommonPartStartIndex = 0, this.movementStartIndex = 0;
                        const i = this.musicSheet.SourceMeasures;
                        this.movementStartIndices = [];
                        for(let t = 1; t < i.length; t++){
                            const e = i[t].MeasureNumberXML ?? i[t].MeasureNumber, s = i[t - 1].MeasureNumberXML ?? i[t - 1].MeasureNumber;
                            e <= 1 && s > 1 && this.movementStartIndices.push(t);
                        }
                        let s, o = 0;
                        for (const t of this.repetitionInstructions){
                            if (this.currentMeasureIndex = t.measureIndex, void 0 !== s && this.currentMeasureIndex >= s && (this.lastRepetitionCommonPartStartIndex = Math.max(this.lastRepetitionCommonPartStartIndex, s), s = void 0), this.currentMeasureIndex > o) {
                                let t;
                                for (const e of this.movementStartIndices)e > o && e <= this.currentMeasureIndex && (t = Math.max(e, t ?? e));
                                if (void 0 !== t) {
                                    for(; this.openRepetitions.length > 0;)this.finalizeRepetition(this.openRepetitions.last());
                                    this.lastRepetitionCommonPartStartIndex = t, this.movementStartIndex = t;
                                }
                            }
                            o = this.currentMeasureIndex;
                            try {
                                this.currentMeasure = i[this.currentMeasureIndex], this.handleRepetitionInstructions(t), (t.type === n.RepetitionInstructionEnum.Ending ? t.alignment !== n.AlignmentType.Begin : h.isBackwardJump(t.type)) && (s = this.currentMeasureIndex + 1);
                            } catch (t) {
                                l.default.error("RepetitionCalculator: calculateRepetitions", t);
                            }
                        }
                        for(; this.openRepetitions.length > 0;)try {
                            const t = this.openRepetitions.last();
                            if (t.RepetitonUnderConstruction.FromWords) {
                                if (t.WaitingForCoda) {
                                    let e = t.RepetitonUnderConstruction.BackwardJumpInstructions.last().measureIndex + 1;
                                    e >= this.musicSheet.SourceMeasures.length && (e = -1), t.RepetitonUnderConstruction.setEndingStartIndex(2, e);
                                } else if (0 === t.RepetitonUnderConstruction.BackwardJumpInstructions.length) {
                                    this.openRepetitions.splice(this.openRepetitions.length - 1, 1);
                                    continue;
                                }
                            } else if (0 === t.RepetitonUnderConstruction.BackwardJumpInstructions.length && t.RepetitonUnderConstruction.startMarker?.type !== n.RepetitionInstructionEnum.None) {
                                const e = i.length - 1, s = new n.RepetitionInstruction(e, n.RepetitionInstructionEnum.BackJumpLine, n.AlignmentType.End, t.RepetitonUnderConstruction);
                                t.RepetitonUnderConstruction.BackwardJumpInstructions.push(s), i[e].LastRepetitionInstructions.push(s);
                            }
                            this.finalizeRepetition(this.openRepetitions.last());
                        } catch (t) {
                            try {
                                const t = this.openRepetitions.last().RepetitonUnderConstruction;
                                for (const e of this.repetitionInstructions)e.parentRepetition === t && (e.parentRepetition = void 0);
                                this.openRepetitions.splice(this.openRepetitions.length - 1, 1);
                            } catch (t) {
                                l.default.error("RepetitionCalculator: calculateRepetitions2", t);
                            }
                        }
                        let c = !1;
                        const u = this.musicSheet.SourceMeasures.length - 1;
                        for (const t of this.musicSheet.Repetitions)if (0 === t.StartIndex && t.EndIndex === u) {
                            c = !0;
                            break;
                        }
                        if (!c) {
                            const t = new a.Repetition(this.musicSheet, !0);
                            t.FromWords = !0, t.startMarker = new n.RepetitionInstruction(0, n.RepetitionInstructionEnum.StartLine), t.startMarker.parentRepetition = t, this.musicSheet.SourceMeasures[0].FirstRepetitionInstructions.push(t.startMarker), t.endMarker = new n.RepetitionInstruction(u, n.RepetitionInstructionEnum.BackJumpLine), t.endMarker.parentRepetition = t, t.BackwardJumpInstructions.push(t.endMarker), t.UserNumberOfRepetitions = t.DefaultNumberOfRepetitions, this.musicSheet.Repetitions.push(t);
                        }
                        for(let t = 0, e = this.musicSheet.SourceMeasures.length; t < e; ++t){
                            const e = this.musicSheet.SourceMeasures[t];
                            e.FirstRepetitionInstructions.length > 1 && e.FirstRepetitionInstructions.sort(r.RepetitionInstructionComparer.Compare), e.LastRepetitionInstructions.length > 1 && e.LastRepetitionInstructions.sort(r.RepetitionInstructionComparer.Compare);
                        }
                        for (const t of this.drawnOnlyInstructions){
                            const e = this.musicSheet.SourceMeasures[t.measureIndex].LastRepetitionInstructions;
                            e.some((e)=>e.type === t.type) || e.push(t);
                        }
                    }
                    typePlayedAs(t) {
                        const e = (e, i)=>this.findInstructionInMainListBackwards(e, t.measureIndex, i) >= 0;
                        switch(t.type){
                            case n.RepetitionInstructionEnum.DaCapo:
                                return e(n.RepetitionInstructionEnum.Fine) ? n.RepetitionInstructionEnum.DaCapoAlFine : e(n.RepetitionInstructionEnum.ToCoda) ? n.RepetitionInstructionEnum.DaCapoAlCoda : t.type;
                            case n.RepetitionInstructionEnum.DalSegno:
                                {
                                    const i = this.findInstructionInMainListBackwards(n.RepetitionInstructionEnum.Segno, t.measureIndex);
                                    return i < 0 ? t.type : e(n.RepetitionInstructionEnum.Fine, i) ? n.RepetitionInstructionEnum.DalSegnoAlFine : e(n.RepetitionInstructionEnum.ToCoda, i) ? n.RepetitionInstructionEnum.DalSegnoAlCoda : t.type;
                                }
                            default:
                                return t.type;
                        }
                    }
                    handleRepetitionInstructions(t) {
                        let e;
                        switch(this.typePlayedAs(t)){
                            case n.RepetitionInstructionEnum.StartLine:
                                e = this.createNewRepetition(this.currentMeasureIndex), t.parentRepetition = e.RepetitonUnderConstruction, e.RepetitonUnderConstruction.FromWords = !1, e.RepetitonUnderConstruction.startMarker = t, this.currentMeasure.FirstRepetitionInstructions.push(t);
                                break;
                            case n.RepetitionInstructionEnum.BackJumpLine:
                                {
                                    e = this.getOrCreateCurrentRepetition2(!1), t.parentRepetition = e.RepetitonUnderConstruction, e.RepetitonUnderConstruction.BackwardJumpInstructions.push(t);
                                    const i = this.currentMeasure.LastRepetitionInstructions, s = i.findIndex((t)=>t.parentRepetition?.FromWords && t.parentRepetition.BackwardJumpInstructions.indexOf(t) >= 0);
                                    i.splice(s >= 0 ? s : i.length, 0, t), 0 === e.RepetitonUnderConstruction.EndingParts.length && this.finalizeRepetition(e);
                                    break;
                                }
                            case n.RepetitionInstructionEnum.Ending:
                                if (e = this.getOrCreateCurrentRepetition(this.lastRepetitionCommonPartStartIndex), t.parentRepetition = e.RepetitonUnderConstruction, t.endingIndices.contains(1) && t.alignment === n.AlignmentType.Begin) {
                                    if (e.RepetitonUnderConstruction.BackwardJumpInstructions.length > 0 || e.RepetitonUnderConstruction.EndingIndexDict.hasOwnProperty(1)) {
                                        e = void 0;
                                        for(let t = this.openRepetitions.length - 1; t >= 0; t--){
                                            const i = this.openRepetitions[t];
                                            if (0 === i.RepetitonUnderConstruction.BackwardJumpInstructions.length) for(e = i; this.openRepetitions.length - 1 > t;){
                                                const t = this.openRepetitions.last();
                                                this.finalizeRepetition(t);
                                            }
                                        }
                                        void 0 === e && (e = this.createNewRepetition(this.lastRepetitionCommonPartStartIndex), e.RepetitonUnderConstruction.startMarker = new n.RepetitionInstruction(this.lastRepetitionCommonPartStartIndex, n.RepetitionInstructionEnum.None));
                                    }
                                    void 0 === e.RepetitonUnderConstruction.forwardJumpInstruction && (e.RepetitonUnderConstruction.forwardJumpInstruction = new n.RepetitionInstruction(this.currentMeasureIndex - 1, n.RepetitionInstructionEnum.ForwardJump, n.AlignmentType.End, e.RepetitonUnderConstruction), this.musicSheet.SourceMeasures[this.currentMeasureIndex - 1].LastRepetitionInstructions.push(e.RepetitonUnderConstruction.forwardJumpInstruction));
                                }
                                if (t.alignment === n.AlignmentType.Begin) e.RepetitonUnderConstruction.setEndingsStartIndex(t.endingIndices, this.currentMeasureIndex), this.currentMeasure.FirstRepetitionInstructions.push(t);
                                else for(let i = 0, s = t.endingIndices.length; i < s; ++i){
                                    const s = t.endingIndices[i];
                                    e.RepetitonUnderConstruction.setEndingEndIndex(s, this.currentMeasureIndex), this.currentMeasure.LastRepetitionInstructions.push(t);
                                }
                                break;
                            case n.RepetitionInstructionEnum.Segno:
                                if (e = this.getCurrentRepetition(!0), void 0 !== e && e.SegnoFound && e.RepetitonUnderConstruction.BackwardJumpInstructions.length > 0 && Math.abs(e.RepetitonUnderConstruction.BackwardJumpInstructions.last().measureIndex - this.currentMeasureIndex) <= 1) break;
                                e = this.createNewRepetition(this.currentMeasureIndex), t.parentRepetition = e.RepetitonUnderConstruction, e.RepetitonUnderConstruction.FromWords = !0, e.SegnoFound = !0, e.RepetitonUnderConstruction.startMarker = t, this.currentMeasure.FirstRepetitionInstructions.push(t);
                                {
                                    const t = this.openRepetitions.length, i = this.openRepetitions[t - 2];
                                    i && !i.RepetitonUnderConstruction.FromWords && 0 === i.RepetitonUnderConstruction.BackwardJumpInstructions.length && i.RepetitonUnderConstruction.StartIndex === this.currentMeasureIndex && (this.openRepetitions[t - 2] = e, this.openRepetitions[t - 1] = i);
                                }
                                break;
                            case n.RepetitionInstructionEnum.Fine:
                                if (e = this.openRepetitions.length > 0 ? this.getCurrentRepetition(!0) : void 0, void 0 === e || void 0 !== e.RepetitonUnderConstruction.forwardJumpInstruction) {
                                    this.addDrawnOnlyInstruction(t);
                                    break;
                                }
                                t.parentRepetition = e.RepetitonUnderConstruction, e.RepetitonUnderConstruction.FromWords = !0, e.FineFound = !0, e.RepetitonUnderConstruction.forwardJumpInstruction = t, e.RepetitonUnderConstruction.setEndingStartIndex(2, this.getFineTarget()), this.currentMeasure.LastRepetitionInstructions.push(t);
                                break;
                            case n.RepetitionInstructionEnum.ToCoda:
                                if (e = this.openRepetitions.length > 0 ? this.getCurrentRepetition(!0) : void 0, void 0 === e || void 0 !== e.RepetitonUnderConstruction.forwardJumpInstruction) {
                                    this.addDrawnOnlyInstruction(t);
                                    break;
                                }
                                t.parentRepetition = e.RepetitonUnderConstruction, e.RepetitonUnderConstruction.FromWords = !0, e.ToCodaFound = !0, e.RepetitonUnderConstruction.forwardJumpInstruction = t, this.currentMeasure.LastRepetitionInstructions.push(t);
                                break;
                            case n.RepetitionInstructionEnum.Coda:
                                if (0 === this.openRepetitions.length) {
                                    this.addDrawnOnlyInstruction(t);
                                    break;
                                }
                                e = this.getOrCreateCurrentRepetition2(!0), t.parentRepetition = e.RepetitonUnderConstruction, e.WaitingForCoda ? (e.CodaFound = !0, e.RepetitonUnderConstruction.setEndingStartIndex(2, this.currentMeasureIndex), this.currentMeasure.LastRepetitionInstructions.push(t), this.finalizeRepetition(e), this.currentMeasureIndex > 0 && (this.musicSheet.SourceMeasures[this.currentMeasureIndex - 1].printNewSystemXml = !0)) : e.ToCodaFound ? this.addDrawnOnlyInstruction(t) : 0 === e.RepetitonUnderConstruction.BackwardJumpInstructions.length ? (e.ToCodaFound = !0, e.RepetitonUnderConstruction.forwardJumpInstruction = new n.RepetitionInstruction(this.currentMeasureIndex, n.RepetitionInstructionEnum.ToCoda, n.AlignmentType.End, e.RepetitonUnderConstruction), this.currentMeasure.LastRepetitionInstructions.push(e.RepetitonUnderConstruction.forwardJumpInstruction)) : this.addDrawnOnlyInstruction(t);
                                break;
                            case n.RepetitionInstructionEnum.DaCapo:
                                e = this.getOrCreateCurrentRepetition(this.movementStartIndex), e.RepetitonUnderConstruction.BackwardJumpInstructions.length > 0 ? (this.finalizeRepetition(e), e = this.createNewRepetition(this.movementStartIndex)) : e.RepetitonUnderConstruction.StartIndex !== this.movementStartIndex && (e = this.createNewRepetition(this.movementStartIndex)), t.parentRepetition = e.RepetitonUnderConstruction, e.RepetitonUnderConstruction.FromWords = !0, e.RepetitonUnderConstruction.startMarker = new n.RepetitionInstruction(this.movementStartIndex, n.RepetitionInstructionEnum.None, n.AlignmentType.Begin, e.RepetitonUnderConstruction), e.RepetitonUnderConstruction.BackwardJumpInstructions.push(t), this.currentMeasure.LastRepetitionInstructions.push(t), 0 === e.RepetitonUnderConstruction.EndingParts.length && this.finalizeRepetition(e);
                                break;
                            case n.RepetitionInstructionEnum.DalSegno:
                                e = this.getOrCreateCurrentRepetition2(!0), e.RepetitonUnderConstruction.BackwardJumpInstructions.length > 0 && (this.finalizeRepetition(e), e = this.createNewRepetition(this.movementStartIndex), e.RepetitonUnderConstruction.FromWords = !0, e.RepetitonUnderConstruction.startMarker = new n.RepetitionInstruction(this.movementStartIndex, n.RepetitionInstructionEnum.None, n.AlignmentType.Begin, e.RepetitonUnderConstruction)), t.parentRepetition = e.RepetitonUnderConstruction, this.startAtSegnoBackwards(e), e.RepetitonUnderConstruction.EndingIndexDict.hasOwnProperty(1) && e.RepetitonUnderConstruction.setEndingEndIndex(1, this.currentMeasureIndex), e.RepetitonUnderConstruction.BackwardJumpInstructions.push(t), this.currentMeasure.LastRepetitionInstructions.push(t);
                                break;
                            case n.RepetitionInstructionEnum.DalSegnoAlFine:
                                if (0 === this.openRepetitions.length && this.findInstructionInMainListBackwards(n.RepetitionInstructionEnum.Segno, this.currentMeasureIndex) < 0) break;
                                if (e = this.getOrCreateCurrentRepetition2(!0), t.parentRepetition = e.RepetitonUnderConstruction, this.startAtSegnoBackwards(e), !e.FineFound) {
                                    const i = this.findInstructionInMainListBackwards(n.RepetitionInstructionEnum.Fine, t.measureIndex, e.RepetitonUnderConstruction.StartIndex);
                                    i >= 0 && (e.FineFound = !0, e.RepetitonUnderConstruction.forwardJumpInstruction = this.createFoundInstruction(n.RepetitionInstructionEnum.Fine, i, e.RepetitonUnderConstruction), e.RepetitonUnderConstruction.setEndingStartIndex(2, this.getFineTarget()), this.musicSheet.SourceMeasures[i].LastRepetitionInstructions.splice(0, 0, e.RepetitonUnderConstruction.forwardJumpInstruction));
                                }
                                e.RepetitonUnderConstruction.EndingIndexDict.hasOwnProperty(1) || e.RepetitonUnderConstruction.setEndingEndIndex(1, this.currentMeasureIndex), e.RepetitonUnderConstruction.BackwardJumpInstructions.push(t), this.currentMeasure.LastRepetitionInstructions.push(t);
                                break;
                            case n.RepetitionInstructionEnum.DaCapoAlFine:
                                if (e = this.getOrCreateCurrentRepetition(this.movementStartIndex), e.RepetitonUnderConstruction.BackwardJumpInstructions.length > 0 && (this.finalizeRepetition(e), e = this.createNewRepetition(this.movementStartIndex)), void 0 !== e.RepetitonUnderConstruction.startMarker && e.RepetitonUnderConstruction.StartIndex !== this.movementStartIndex && (e = this.createNewRepetition(this.movementStartIndex)), e.RepetitonUnderConstruction.startMarker = new n.RepetitionInstruction(this.movementStartIndex, n.RepetitionInstructionEnum.None, n.AlignmentType.Begin, e.RepetitonUnderConstruction), e.RepetitonUnderConstruction.FromWords = !0, t.parentRepetition = e.RepetitonUnderConstruction, !e.FineFound) {
                                    const i = this.findInstructionInMainListBackwards(n.RepetitionInstructionEnum.Fine, t.measureIndex);
                                    i >= 0 && (e.FineFound = !0, e.RepetitonUnderConstruction.forwardJumpInstruction = this.createFoundInstruction(n.RepetitionInstructionEnum.Fine, i, e.RepetitonUnderConstruction), e.RepetitonUnderConstruction.setEndingStartIndex(2, this.getFineTarget()), this.musicSheet.SourceMeasures[i].LastRepetitionInstructions.splice(0, 0, e.RepetitonUnderConstruction.forwardJumpInstruction));
                                }
                                e.RepetitonUnderConstruction.EndingIndexDict.hasOwnProperty(1) || e.RepetitonUnderConstruction.setEndingEndIndex(1, this.currentMeasureIndex), e.RepetitonUnderConstruction.BackwardJumpInstructions.push(t), this.currentMeasure.LastRepetitionInstructions.push(t);
                                break;
                            case n.RepetitionInstructionEnum.DalSegnoAlCoda:
                                if (0 === this.openRepetitions.length && this.findInstructionInMainListBackwards(n.RepetitionInstructionEnum.Segno, this.currentMeasureIndex) < 0) break;
                                if (e = this.getOrCreateCurrentRepetition2(!0), t.parentRepetition = e.RepetitonUnderConstruction, this.startAtSegnoBackwards(e), !e.ToCodaFound) {
                                    const i = e.RepetitonUnderConstruction.StartIndex, s = this.findInstructionInMainListBackwards(n.RepetitionInstructionEnum.ToCoda, t.measureIndex, i);
                                    if (s >= 0) e.RepetitonUnderConstruction.forwardJumpInstruction = this.createFoundInstruction(n.RepetitionInstructionEnum.ToCoda, s, e.RepetitonUnderConstruction), this.musicSheet.SourceMeasures[s].LastRepetitionInstructions.splice(0, 0, e.RepetitonUnderConstruction.forwardJumpInstruction), e.ToCodaFound = !0;
                                    else {
                                        const s = this.findInstructionInMainListBackwards(n.RepetitionInstructionEnum.Coda, t.measureIndex, i);
                                        s >= 0 && (e.RepetitonUnderConstruction.forwardJumpInstruction = new n.RepetitionInstruction(s, n.RepetitionInstructionEnum.ToCoda, n.AlignmentType.Begin, e.RepetitonUnderConstruction), this.removeDrawnOnlyCoda(s), this.musicSheet.SourceMeasures[s].LastRepetitionInstructions.splice(0, 0, e.RepetitonUnderConstruction.forwardJumpInstruction), e.ToCodaFound = !0);
                                    }
                                }
                                e.ToCodaFound && (e.WaitingForCoda = !0, this.moveBelowOpenRepeats(e)), e.RepetitonUnderConstruction.EndingIndexDict.hasOwnProperty(1) || e.RepetitonUnderConstruction.setEndingEndIndex(1, this.currentMeasureIndex), e.RepetitonUnderConstruction.BackwardJumpInstructions.push(t), this.currentMeasure.LastRepetitionInstructions.push(t);
                                break;
                            case n.RepetitionInstructionEnum.DaCapoAlCoda:
                                if (e = this.getOrCreateCurrentRepetition(this.movementStartIndex), e.RepetitonUnderConstruction.BackwardJumpInstructions.length > 0 ? (this.finalizeRepetition(e), e = this.createNewRepetition(this.movementStartIndex)) : 0 === e.RepetitonUnderConstruction.EndingParts.length && (e = this.createNewRepetition(this.movementStartIndex)), void 0 !== e.RepetitonUnderConstruction.startMarker && e.RepetitonUnderConstruction.StartIndex !== this.movementStartIndex && (e = this.createNewRepetition(this.movementStartIndex)), e.RepetitonUnderConstruction.startMarker = new n.RepetitionInstruction(this.movementStartIndex, n.RepetitionInstructionEnum.None, n.AlignmentType.Begin, e.RepetitonUnderConstruction), e.RepetitonUnderConstruction.FromWords = !0, t.parentRepetition = e.RepetitonUnderConstruction, !e.ToCodaFound) {
                                    const i = this.findInstructionInMainListBackwards(n.RepetitionInstructionEnum.ToCoda, t.measureIndex);
                                    if (i >= 0) e.RepetitonUnderConstruction.forwardJumpInstruction = this.createFoundInstruction(n.RepetitionInstructionEnum.ToCoda, i, e.RepetitonUnderConstruction), this.musicSheet.SourceMeasures[i].LastRepetitionInstructions.splice(0, 0, e.RepetitonUnderConstruction.forwardJumpInstruction), e.ToCodaFound = !0;
                                    else {
                                        const i = this.findInstructionInMainListBackwards(n.RepetitionInstructionEnum.Coda, t.measureIndex);
                                        i >= 0 && (e.RepetitonUnderConstruction.forwardJumpInstruction = new n.RepetitionInstruction(i, n.RepetitionInstructionEnum.ToCoda, n.AlignmentType.Begin, e.RepetitonUnderConstruction), this.removeDrawnOnlyCoda(i), this.musicSheet.SourceMeasures[i].LastRepetitionInstructions.splice(0, 0, e.RepetitonUnderConstruction.forwardJumpInstruction), e.ToCodaFound = !0);
                                    }
                                }
                                e.ToCodaFound && (e.WaitingForCoda = !0, this.moveBelowOpenRepeats(e)), e.RepetitonUnderConstruction.EndingIndexDict.hasOwnProperty(1) || e.RepetitonUnderConstruction.setEndingEndIndex(1, this.currentMeasureIndex), e.RepetitonUnderConstruction.BackwardJumpInstructions.push(t), this.currentMeasure.LastRepetitionInstructions.push(t);
                                break;
                            case n.RepetitionInstructionEnum.None:
                                break;
                            default:
                                throw new o.ArgumentOutOfRangeException("currentRepetitionInstruction");
                        }
                        return !0;
                    }
                    findInstructionInMainListBackwards(t, e, i = this.movementStartIndex) {
                        for(let s = this.repetitionInstructions.length - 1; s >= 0; s--){
                            const n = this.repetitionInstructions[s];
                            if (n.measureIndex <= e && n.measureIndex >= i && n.type === t) return n.measureIndex;
                        }
                        return -1;
                    }
                    addDrawnOnlyInstruction(t) {
                        const e = t.type, i = new n.RepetitionInstruction(this.currentMeasureIndex, e, e === n.RepetitionInstructionEnum.Coda ? n.AlignmentType.Begin : n.AlignmentType.End, void 0);
                        i.Words = t.Words, this.drawnOnlyInstructions.push(i);
                    }
                    createFoundInstruction(t, e, i) {
                        const s = new n.RepetitionInstruction(e, t, n.AlignmentType.Begin, i);
                        return s.Words = this.repetitionInstructions.find((i)=>i.measureIndex === e && i.type === t)?.Words, s;
                    }
                    moveBelowOpenRepeats(t) {
                        let e = this.openRepetitions.indexOf(t);
                        for(; e > 0;){
                            const i = this.openRepetitions[e - 1], s = i.RepetitonUnderConstruction;
                            if (s.FromWords || s.BackwardJumpInstructions.length > 0 || void 0 === s.startMarker || s.StartIndex < t.RepetitonUnderConstruction.StartIndex) return;
                            this.openRepetitions[e - 1] = t, this.openRepetitions[e] = i, e--;
                        }
                    }
                    removeDrawnOnlyCoda(t) {
                        this.drawnOnlyInstructions = this.drawnOnlyInstructions.filter((e)=>e.type !== n.RepetitionInstructionEnum.Coda || e.measureIndex !== t);
                    }
                    startAtSegnoBackwards(t) {
                        if (t.SegnoFound) return;
                        const e = this.findInstructionInMainListBackwards(n.RepetitionInstructionEnum.Segno, this.currentMeasureIndex);
                        if (e < 0) return;
                        t.SegnoFound = !0;
                        const i = this.musicSheet.SourceMeasures[e].FirstRepetitionInstructions;
                        let s = i.find((t)=>t.type === n.RepetitionInstructionEnum.Segno);
                        s || (s = new n.RepetitionInstruction(e, n.RepetitionInstructionEnum.Segno, n.AlignmentType.Begin), i.splice(0, 0, s)), s.parentRepetition = t.RepetitonUnderConstruction, t.RepetitonUnderConstruction.startMarker = s;
                    }
                    getFineTarget() {
                        return this.movementStartIndices.find((t)=>t > this.currentMeasureIndex) ?? -2;
                    }
                    static isBackwardJump(t) {
                        switch(t){
                            case n.RepetitionInstructionEnum.BackJumpLine:
                            case n.RepetitionInstructionEnum.DaCapo:
                            case n.RepetitionInstructionEnum.DaCapoAlFine:
                            case n.RepetitionInstructionEnum.DaCapoAlCoda:
                            case n.RepetitionInstructionEnum.DalSegno:
                            case n.RepetitionInstructionEnum.DalSegnoAlFine:
                            case n.RepetitionInstructionEnum.DalSegnoAlCoda:
                                return !0;
                            default:
                                return !1;
                        }
                    }
                    isJumpAfterRepeat(t, e) {
                        const i = t.BackwardJumpInstructions.last().measureIndex, s = e.BackwardJumpInstructions.last().measureIndex;
                        if (t.FromWords && i > s) return !0;
                        if (t.FromWords === e.FromWords) return !1;
                        const n = t.FromWords ? e : t, r = t.FromWords ? t : e;
                        return this.repetitionInstructions.indexOf(n.BackwardJumpInstructions.last()) >= 0 && r.BackwardJumpInstructions.last().measureIndex >= n.BackwardJumpInstructions.last().measureIndex;
                    }
                    finalizeRepetition(t) {
                        const e = t.RepetitonUnderConstruction;
                        if (e.BackwardJumpInstructions.length > 0) {
                            if (1 === e.NumberOfEndings && e.EndingIndexDict[1]) {
                                const t = e.EndingIndexDict[1].part.EndIndex + 1;
                                e.setEndingStartIndex(2, t < this.musicSheet.SourceMeasures.length ? t : -2);
                            }
                            let t = !0;
                            const i = this.getLastFinalizedRepetition();
                            if (void 0 !== i && e.coversIdenticalMeasures(i) && !this.isJumpAfterRepeat(e, i)) {
                                if (e.NumberOfEndings > i.NumberOfEndings) {
                                    const t = this.musicSheet.Repetitions.indexOf(i, 0);
                                    t > -1 && this.musicSheet.Repetitions.splice(t, 1), i.removeFromRepetitionInstructions(), this.musicSheet.Repetitions.push(e);
                                } else t = !1, e.removeFromRepetitionInstructions();
                            } else this.musicSheet.Repetitions.push(e);
                            if (t) {
                                e.startMarker.type === n.RepetitionInstructionEnum.None && this.musicSheet.SourceMeasures[e.StartIndex].FirstRepetitionInstructions.push(e.startMarker);
                                let t = e.DefaultNumberOfRepetitions;
                                1 === e.BackwardJumpInstructions.length && e.BackwardJumpInstructions[0].Times > 0 && (t = e.BackwardJumpInstructions[0].Times), e.UserNumberOfRepetitions = t;
                            }
                        }
                        this.openRepetitions.splice(this.openRepetitions.length - 1, 1);
                    }
                    getCurrentRepetition(t) {
                        let e;
                        for(let i = this.openRepetitions.length - 1; i >= 0; i--)if (this.openRepetitions[i].RepetitonUnderConstruction.FromWords === t) {
                            for(e = this.openRepetitions[i]; i < this.openRepetitions.length - 1 && this.openRepetitions.last().RepetitonUnderConstruction.BackwardJumpInstructions.length > 0;)this.finalizeRepetition(this.openRepetitions.last());
                            return e;
                        }
                        return e;
                    }
                    getOrCreateCurrentRepetition(t) {
                        if (this.openRepetitions.length > 0) return this.openRepetitions.last();
                        const e = this.createNewRepetition(t);
                        return e.RepetitonUnderConstruction.startMarker = new n.RepetitionInstruction(t, n.RepetitionInstructionEnum.None, n.AlignmentType.Begin, e.RepetitonUnderConstruction), e;
                    }
                    getOrCreateCurrentRepetition2(t) {
                        let e;
                        for(let i = this.openRepetitions.length - 1; i >= 0; i--)if (e = this.openRepetitions[i], e.RepetitonUnderConstruction.FromWords === t) {
                            for(; i < this.openRepetitions.length - 1;)this.finalizeRepetition(this.openRepetitions.last());
                            return e;
                        }
                        const i = Math.min(this.lastRepetitionCommonPartStartIndex, this.currentMeasureIndex);
                        return e = this.createNewRepetition(i), e.RepetitonUnderConstruction.startMarker = new n.RepetitionInstruction(i, n.RepetitionInstructionEnum.None, n.AlignmentType.Begin, e.RepetitonUnderConstruction), this.lastRepetitionCommonPartStartIndex = this.currentMeasureIndex + 1, e.RepetitonUnderConstruction.FromWords = t, e;
                    }
                    createNewRepetition(t) {
                        if (this.openRepetitions.length > 0) {
                            const t = this.openRepetitions.last(), e = t.RepetitonUnderConstruction;
                            if (e.BackwardJumpInstructions.length > 0 && !t.WaitingForCoda) {
                                const i = Object.keys(e.EndingIndexDict);
                                (0 === i.length || e.EndingIndexDict[i[i.length - 1]].part.EndIndex >= 0) && this.finalizeRepetition(t);
                            }
                        }
                        const e = new c(this.musicSheet);
                        return this.lastRepetitionCommonPartStartIndex = Math.max(this.lastRepetitionCommonPartStartIndex, t), this.openRepetitions.push(e), e;
                    }
                    getLastFinalizedRepetition() {
                        if (this.musicSheet.Repetitions.length > 0) return this.musicSheet.Repetitions.last();
                    }
                }
                e.RepetitionCalculator = h;
                class c {
                    constructor(t){
                        this.RepetitonUnderConstruction = new a.Repetition(t);
                    }
                }
                e.RepetitionBuildingContainer = c;
            },
            7631 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.RepetitionInstructionReader = void 0;
                const s = i(1645), n = i(1645), r = i(4356);
                class o {
                    set MusicSheet(t) {
                        this.musicSheet = t, this.xmlMeasureList = new Array(this.musicSheet.Instruments.length), this.repetitionInstructions = [];
                    }
                    prepareReadingMeasure(t, e) {
                        this.currentMeasureIndex = e;
                    }
                    handleLineRepetitionInstructions(t) {
                        let e = !1;
                        if (t.elements().length > 0) {
                            let i = "", n = !1, r = "", o = "", a = "";
                            const l = [], h = t.element("bar-style");
                            h && (a = h.value), i = t.attributes().length > 0 && t.attribute("location") ? t.attribute("location").value : "right";
                            const c = t.elements();
                            for(let t = 0, e = c.length; t < e; ++t){
                                const e = c[t];
                                if ("repeat" === e.name && e.hasAttributes) n = !0, r = e.attribute("direction").value;
                                else if ("ending" === e.name && e.hasAttributes && void 0 !== e.attribute("type") && e.attribute("number")) {
                                    if ("no" === e.attribute("print-object")?.value) continue;
                                    o = e.attribute("type").value;
                                    let t = e.attribute("number").value;
                                    e.value && (t = e.value);
                                    const i = t.split("[,+]");
                                    for(let t = 0, e = i.length; t < e; ++t){
                                        const e = i[t], s = e.match("[0-9]");
                                        if (-1 !== e.search("-") && 2 === s.length) {
                                            const t = parseInt(s[0], 10), e = parseInt(s[1], 10);
                                            for(let i = t; i <= e; i++)l.push(i);
                                        } else for(let t = 0, e = s.length; t < e; ++t){
                                            const e = s[t];
                                            l.push(parseInt(e, 10));
                                        }
                                    }
                                }
                            }
                            if ("light-heavy" !== a || 0 !== l.length || n || (e = !0), n || l.length > 0) {
                                if ("left" === i) {
                                    if ("start" === o) {
                                        const t = new s.RepetitionInstruction(this.currentMeasureIndex, s.RepetitionInstructionEnum.Ending, s.AlignmentType.Begin, void 0, l);
                                        this.addInstruction(this.repetitionInstructions, t);
                                    }
                                    if ("forward" === r) {
                                        const t = new s.RepetitionInstruction(this.currentMeasureIndex, s.RepetitionInstructionEnum.StartLine);
                                        this.addInstruction(this.repetitionInstructions, t);
                                    }
                                } else {
                                    if ("stop" === o) {
                                        const t = new s.RepetitionInstruction(this.currentMeasureIndex, s.RepetitionInstructionEnum.Ending, s.AlignmentType.End, void 0, l);
                                        this.addInstruction(this.repetitionInstructions, t);
                                    } else if ("discontinue" === o) {
                                        const t = new s.RepetitionInstruction(this.currentMeasureIndex, s.RepetitionInstructionEnum.Ending, s.AlignmentType.Discontinue, void 0, l);
                                        this.addInstruction(this.repetitionInstructions, t);
                                    }
                                    if ("backward" === r) {
                                        const t = new s.RepetitionInstruction(this.currentMeasureIndex, s.RepetitionInstructionEnum.BackJumpLine);
                                        this.addInstruction(this.repetitionInstructions, t);
                                    }
                                }
                            }
                        }
                        return e;
                    }
                    handleRepetitionInstructionsFromWordsOrSymbols(t, e, i) {
                        const n = t.element("words"), r = this.currentMeasureIndex;
                        if (n) {
                            const n = t.elements("words").map((t)=>t.value).join("").trim();
                            let a, l = o.repetitionInstructionFromWords(n.toLowerCase());
                            if (void 0 === l) {
                                const t = n.match(/^[A-Z][a-zA-Z]*\s+(.+)$/);
                                if (l = t ? o.repetitionInstructionFromWords(t[1].toLowerCase()) : void 0, !o.isJumpFromWords(l) && (l = o.repetitionInstructionFromSound(i), void 0 === l)) return !1;
                                n.length > 0 && l !== s.RepetitionInstructionEnum.Segno && l !== s.RepetitionInstructionEnum.Coda && (a = n.replace(/\s+/g, " "));
                            }
                            const h = o.soundTypeOfJump(l), c = 0 === e && r > 0 && void 0 !== h && this.isStatedAtMeasureStart(h), u = new s.RepetitionInstruction(c ? r - 1 : r, l);
                            return u.Words = a, u.MarkedAsTarget = l === s.RepetitionInstructionEnum.Segno && !!i?.attribute("segno"), this.addInstruction(this.repetitionInstructions, u, c), !0;
                        }
                        if (t.element("segno")) {
                            const t = new s.RepetitionInstruction(r, s.RepetitionInstructionEnum.Segno);
                            return t.MarkedAsTarget = !!i?.attribute("segno"), this.addInstruction(this.repetitionInstructions, t), !0;
                        }
                        if (t.element("coda")) {
                            const t = new s.RepetitionInstruction(r, s.RepetitionInstructionEnum.Coda);
                            return this.addInstruction(this.repetitionInstructions, t), !0;
                        }
                        return !1;
                    }
                    static repetitionInstructionFromWords(t) {
                        const e = "(d\\s?\\.\\s?s\\.|dal\\s?segno)", i = "(d\\s?\\.\\s?c\\.|da\\s?capo)", n = "\\s?al\\s?", o = [
                            [
                                e + n + "fine",
                                s.RepetitionInstructionEnum.DalSegnoAlFine
                            ],
                            [
                                e + n + "coda",
                                s.RepetitionInstructionEnum.DalSegnoAlCoda
                            ],
                            [
                                e,
                                s.RepetitionInstructionEnum.DalSegno
                            ],
                            [
                                i + n + "fine",
                                s.RepetitionInstructionEnum.DaCapoAlFine
                            ],
                            [
                                i + n + "coda",
                                s.RepetitionInstructionEnum.DaCapoAlCoda
                            ],
                            [
                                i,
                                s.RepetitionInstructionEnum.DaCapo
                            ],
                            [
                                "to\\s?coda|a (la )?coda",
                                s.RepetitionInstructionEnum.ToCoda
                            ],
                            [
                                "fine",
                                s.RepetitionInstructionEnum.Fine
                            ],
                            [
                                "coda",
                                s.RepetitionInstructionEnum.Coda
                            ],
                            [
                                "segno",
                                s.RepetitionInstructionEnum.Segno
                            ]
                        ];
                        for (const [e, i] of o)if (r.StringUtil.StringIsWord(t, e, !0)) return i;
                    }
                    static repetitionInstructionFromSound(t) {
                        const e = [
                            [
                                "dacapo",
                                s.RepetitionInstructionEnum.DaCapo
                            ],
                            [
                                "dalsegno",
                                s.RepetitionInstructionEnum.DalSegno
                            ],
                            [
                                "tocoda",
                                s.RepetitionInstructionEnum.ToCoda
                            ],
                            [
                                "fine",
                                s.RepetitionInstructionEnum.Fine
                            ],
                            [
                                "segno",
                                s.RepetitionInstructionEnum.Segno
                            ],
                            [
                                "coda",
                                s.RepetitionInstructionEnum.Coda
                            ]
                        ];
                        for (const [i, s] of e){
                            const e = t?.attribute(i)?.value;
                            if ("dacapo" === i ? "yes" === e : e) return s;
                        }
                    }
                    static soundTypeOfJump(t) {
                        switch(t){
                            case s.RepetitionInstructionEnum.DaCapo:
                            case s.RepetitionInstructionEnum.DaCapoAlFine:
                            case s.RepetitionInstructionEnum.DaCapoAlCoda:
                                return s.RepetitionInstructionEnum.DaCapo;
                            case s.RepetitionInstructionEnum.DalSegno:
                            case s.RepetitionInstructionEnum.DalSegnoAlFine:
                            case s.RepetitionInstructionEnum.DalSegnoAlCoda:
                                return s.RepetitionInstructionEnum.DalSegno;
                            case s.RepetitionInstructionEnum.ToCoda:
                            case s.RepetitionInstructionEnum.Fine:
                                return t;
                            default:
                                return;
                        }
                    }
                    isStatedAtMeasureStart(t) {
                        for (const e of this.xmlMeasureList)for (const i of e?.[this.currentMeasureIndex]?.elements() ?? []){
                            if ("note" === i.name || "forward" === i.name) break;
                            const e = "direction" === i.name ? i.elements("sound") : "sound" === i.name ? [
                                i
                            ] : [], s = "direction" === i.name ? i.element("offset") : void 0;
                            if (e.some((e)=>{
                                const i = e.element("offset") ?? ("yes" === s?.attribute("sound")?.value ? s : void 0);
                                return (void 0 === i || 0 === Number(i.value)) && o.repetitionInstructionFromSound(e) === t;
                            })) return !0;
                        }
                        return !1;
                    }
                    static isJumpFromWords(t) {
                        switch(t){
                            case s.RepetitionInstructionEnum.DaCapo:
                            case s.RepetitionInstructionEnum.DaCapoAlFine:
                            case s.RepetitionInstructionEnum.DaCapoAlCoda:
                            case s.RepetitionInstructionEnum.DalSegno:
                            case s.RepetitionInstructionEnum.DalSegnoAlFine:
                            case s.RepetitionInstructionEnum.DalSegnoAlCoda:
                                return !0;
                            default:
                                return !1;
                        }
                    }
                    removeRedundantInstructions() {
                        let t = 0, e = 0, i = 0, r = 0;
                        for(let n = 0; n < this.repetitionInstructions.length; n++){
                            const o = this.repetitionInstructions[n];
                            switch(o.type){
                                case s.RepetitionInstructionEnum.Coda:
                                    i > 0 && this.findInstructionInPreviousMeasure(n, o.measureIndex, s.RepetitionInstructionEnum.ToCoda) && (o.type = s.RepetitionInstructionEnum.None);
                                    break;
                                case s.RepetitionInstructionEnum.Segno:
                                    if (t - r > 0 && !o.MarkedAsTarget) {
                                        let t = !1;
                                        for(let n = 0, r = this.repetitionInstructions.length; n < r; ++n){
                                            const r = this.repetitionInstructions[n];
                                            if (o.measureIndex - r.measureIndex === 1) switch(r.type){
                                                case s.RepetitionInstructionEnum.BackJumpLine:
                                                    r.type = i - e > 0 ? s.RepetitionInstructionEnum.DalSegnoAlCoda : s.RepetitionInstructionEnum.DalSegno, o.type = s.RepetitionInstructionEnum.None, t = !0;
                                                    break;
                                                case s.RepetitionInstructionEnum.DalSegno:
                                                case s.RepetitionInstructionEnum.DalSegnoAlFine:
                                                case s.RepetitionInstructionEnum.DalSegnoAlCoda:
                                                    o.type = s.RepetitionInstructionEnum.None, t = !0;
                                            }
                                            if (t) break;
                                        }
                                        if (t) break;
                                        o.type = i - e > 0 ? s.RepetitionInstructionEnum.DalSegnoAlCoda : s.RepetitionInstructionEnum.DalSegno, o.alignment = s.AlignmentType.End, o.measureIndex--;
                                    }
                            }
                            if (this.backwardSearchForPreviousIdenticalInstruction(n, o) || o.type === s.RepetitionInstructionEnum.None) this.repetitionInstructions.splice(n, 1), n--;
                            else switch(o.type){
                                case s.RepetitionInstructionEnum.Fine:
                                    break;
                                case s.RepetitionInstructionEnum.ToCoda:
                                    i++;
                                    break;
                                case s.RepetitionInstructionEnum.Coda:
                                    e++;
                                    break;
                                case s.RepetitionInstructionEnum.Segno:
                                    t++;
                                    break;
                                case s.RepetitionInstructionEnum.DalSegno:
                                case s.RepetitionInstructionEnum.DalSegnoAlFine:
                                case s.RepetitionInstructionEnum.DalSegnoAlCoda:
                                    r++;
                            }
                        }
                        this.repetitionInstructions.sort(n.RepetitionInstructionComparer.Compare);
                    }
                    findInstructionInPreviousMeasure(t, e, i) {
                        for(let s = t - 1; s >= 0; s--){
                            const t = this.repetitionInstructions[s];
                            if (e - t.measureIndex === 1 && t.type === i) return !0;
                        }
                        return !1;
                    }
                    backwardSearchForPreviousIdenticalInstruction(t, e) {
                        for(let i = t - 1; i >= 0; i--)if (this.repetitionInstructions[i].equals(e)) return !0;
                        return !1;
                    }
                    addInstruction(t, e, i = !1) {
                        let s = !0;
                        for(let i = 0, n = t.length; i < n; ++i){
                            const n = t[i];
                            if (e.equals(n)) {
                                s = !1;
                                break;
                            }
                        }
                        if (s) {
                            let s = t.length;
                            for(let n = 0, r = t.length; i && n < r; ++n)if (o.isAfterWordsAtMeasureEnd(t[n], e.measureIndex)) {
                                s = n;
                                break;
                            }
                            t.splice(s, 0, e);
                        }
                    }
                    static isAfterWordsAtMeasureEnd(t, e) {
                        return t.measureIndex > e || t.measureIndex === e && (t.type === s.RepetitionInstructionEnum.BackJumpLine || t.type === s.RepetitionInstructionEnum.Ending && t.alignment !== s.AlignmentType.Begin);
                    }
                }
                e.RepetitionInstructionReader = o;
            },
            3186 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.SlurReader = void 0;
                const n = i(6229), r = s(i(3065)), o = i(9767), a = i(4980), l = i(7718);
                e.SlurReader = class {
                    constructor(t){
                        this.openSlurDict = {}, this.openStopBeforeStartDict = {}, this.openGlissDicts = new Map, this.musicSheet = t;
                    }
                    addSlur(t, e) {
                        try {
                            if (t) {
                                const i = [], s = [], o = new Set, h = new Set;
                                for (const e of t){
                                    const t = e.attribute("type")?.value, n = this.readSlurNumber(e);
                                    "stop" === t ? (i.push(e), o.has(n) && h.add(n)) : (s.push(e), "start" === t && o.add(n));
                                }
                                for (const t of i.concat(s))if (t.attributes().length > 0) {
                                    const i = t.attribute("type").value, s = this.readSlurNumber(t);
                                    let o = a.PlacementEnum.NotYetDefined;
                                    const c = t.attribute("placement");
                                    c && c.value && ("above" === c.value ? o = a.PlacementEnum.Above : "below" === c.value && (o = a.PlacementEnum.Below));
                                    const u = t.attribute("orientation");
                                    if (u && u.value && ("over" === u.value ? o = a.PlacementEnum.Above : "under" === u.value && (o = a.PlacementEnum.Below)), "start" === i) {
                                        const i = "slur" === t.name, r = i ? this.openStopBeforeStartDict[s] : void 0;
                                        if (i && delete this.openStopBeforeStartDict[s], r && this.isCrossStaffSlurMatch(e, r.EndNote)) r.StartNote = e, r.PlacementXml = o, this.linkSlurToNotes(r);
                                        else {
                                            const t = i ? this.openSlurDict : this.openGlissDictOfStaff(e);
                                            let a = t[s];
                                            a && !a.HasUnattachedEnd || (a = new n.Slur, t[s] = a), a.StartNote = e, a.PlacementXml = o, i && r?.EndNote === e && (a.HasUnattachedEnd = !0, e.NoteSlurs.push(a));
                                        }
                                    } else if ("stop" === i) {
                                        const i = t.name;
                                        if ("slide" === i || "glissando" === i) {
                                            const t = this.openGlissDictOfStaff(e), i = t[s];
                                            if (i && i.StartNote !== e) {
                                                const n = i.StartNote, r = new l.Glissando(n);
                                                r.AddNote(e), r.EndNote = e, e.NoteGlissando = r, delete t[s];
                                            }
                                        } else {
                                            const t = this.openSlurDict[s], i = !0 === t?.HasUnattachedEnd && h.has(s);
                                            if (t && t.StartNote !== e && !i) t.EndNote = e, t.HasUnattachedEnd = !1, this.linkSlurToNotes(t), delete this.openSlurDict[s];
                                            else if (!t || i) {
                                                const t = new n.Slur;
                                                t.EndNote = e, this.openStopBeforeStartDict[s] = t;
                                            } else r.default.debug("SlurReader: ignoring slur stop on the same note as its start, measure " + e.SourceMeasure?.MeasureNumber);
                                        }
                                    }
                                }
                            }
                        } catch (t) {
                            const e = o.ITextTranslation.translateText("ReaderErrorMessages/SlurError", "Error while reading slur.");
                            this.musicSheet.SheetErrors.pushMeasureError(e);
                        }
                    }
                    readSlurNumber(t) {
                        let e = 1;
                        try {
                            const i = t.attribute("number");
                            i && (e = parseInt(i.value, 10));
                        } catch (t) {
                            r.default.debug("SlurReader.readSlurNumber: ", t);
                        }
                        return e;
                    }
                    openGlissDictOfStaff(t) {
                        const e = t.ParentStaffEntry?.ParentStaff;
                        let i = this.openGlissDicts.get(e);
                        return i || (i = {}, this.openGlissDicts.set(e, i)), i;
                    }
                    linkSlurToNotes(t) {
                        const e = t.EndNote, i = t.StartNote.NoteSlurs, s = i.indexOf(t);
                        e.isDuplicateSlur(t) ? -1 !== s && i.splice(s, 1) : (e.NoteSlurs.push(t), -1 === s && i.push(t));
                    }
                    isCrossStaffSlurMatch(t, e) {
                        if (!t || !e) return !1;
                        const i = t.ParentStaffEntry, s = e.ParentStaffEntry;
                        return !(!i || !s) && i.ParentStaff !== s.ParentStaff && t.SourceMeasure === e.SourceMeasure && s.Timestamp.RealValue >= i.Timestamp.RealValue;
                    }
                };
            },
            1538 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.TempoSorter = e.TemposCalculator = void 0;
                const s = i(2561), n = i(899), r = i(6362), o = i(9161);
                class a {
                    calculate(t) {
                        a.processTempoExpressions(t);
                    }
                    static processTempoExpressions(t) {
                        const e = [];
                        for(let i = 0, s = t.SourceMeasures; i < s.length; i++){
                            const t = s[i];
                            t.TempoExpressions.sort(l.Compare);
                            for(let i = 0, s = t.TempoExpressions; i < s.length; i++){
                                const t = s[i];
                                null != t.InstantaneousTempo && t.InstantaneousTempo.TempoType === o.TempoType.none && (t.InstantaneousTempo.TempoType = o.TempoType.inst), e.push(t);
                            }
                        }
                        e.sort(l.Compare);
                        const i = a.cleanExpListStartingEntry(t, e), r = [];
                        let h, c = null, u = i;
                        for(let t = 0, s = e; t < s.length; t++){
                            const e = s[t];
                            if (null === c || e.AbsoluteTimestamp !== c.AbsoluteTimestamp) {
                                if (null != e.InstantaneousTempo && 0 === e.InstantaneousTempo.TempoInBpm) {
                                    const t = e.InstantaneousTempo;
                                    if (t.isMetronomeMark) {
                                        const e = t.getNoteEquationTempoFactor();
                                        t.TempoInBpm = u * e.GetExpandedNumerator() / e.Denominator;
                                    } else t instanceof o.InstantaneousTempoExpression && t.TempoType !== o.TempoType.change && (t.TempoInBpm = o.InstantaneousTempoExpression.getDefaultValueForInstTempo(t.InstTempo));
                                    if (t.TempoType === o.TempoType.change) switch(t.ChangeSubType){
                                        case o.ChangeSubType.atempo:
                                            t.TempoInBpm = u;
                                            break;
                                        case o.ChangeSubType.doppioMovimento:
                                            t.TempoInBpm = 2 * u;
                                            break;
                                        case o.ChangeSubType.tempoprimo:
                                            t.TempoInBpm = i;
                                    }
                                }
                                e.PlaybackTempoInBpm > 0 ? (u = e.PlaybackTempoInBpm, h = e.AbsolutePlaybackTimestamp) : e.InstantaneousTempo?.TempoInBpm > 0 && !e.AbsolutePlaybackTimestamp.Equals(h) && (u = e.InstantaneousTempo.TempoInBpm);
                            } else null == c && e.AbsoluteTimestamp !== c.AbsoluteTimestamp || (null != c.InstantaneousTempo && null != e.InstantaneousTempo && e.clearInstantaneousTempo(), null != e.ContinuousTempo && (null === c.ContinuousTempo && c.addExpression(e.ContinuousTempo, ""), e.clearContinuousTempo()));
                            if (null === e.InstantaneousTempo && null === e.ContinuousTempo) {
                                const t = e.SourceMeasureParent.TempoExpressions.indexOf(e);
                                t >= 0 && e.SourceMeasureParent.TempoExpressions.splice(t, 1);
                            } else r.push(e), c = e;
                        }
                        u = i, h = void 0;
                        for(let e = 0; e < r.length; e++){
                            const i = r[e];
                            if (i.PlaybackTempoInBpm > 0 ? (u = i.PlaybackTempoInBpm, h = i.AbsolutePlaybackTimestamp) : null == i.InstantaneousTempo || i.AbsolutePlaybackTimestamp.Equals(h) || (u = i.InstantaneousTempo.TempoInBpm), null != i.ContinuousTempo) {
                                const o = i.ContinuousTempo;
                                o.StartTempo = u;
                                const a = i.SourceMeasureParent.measureListIndex;
                                let l = a;
                                const h = Math.min(a + t.Rules.TempoChangeMeasureValidity, t.SourceMeasures.length - 1);
                                for(; l <= h;){
                                    const e = t.SourceMeasures[l], i = e.endingBarStyleEnum === n.SystemLinesEnum.ThinBold;
                                    if (e.endsWithLineRepetition() || i || l === t.SourceMeasures.length - 1) break;
                                    if (l > a && e.beginsWithRepetition()) {
                                        l--;
                                        break;
                                    }
                                    l++;
                                }
                                const c = t.SourceMeasures[l];
                                let d, f = s.Fraction.plus(c.AbsoluteTimestamp, s.Fraction.minus(c.Duration, new s.Fraction(1, 64)));
                                e < r.length - 1 && (d = r[e + 1].AbsolutePlaybackTimestamp, d.RealValue < f.RealValue && (f = d)), o.AbsoluteEndTimestamp = f;
                                let m = o.StartTempo * (1 - t.Rules.TempoContinousFactor) * o.getTempoFactor();
                                m *= Math.pow(Math.max(.6, Math.min(o.AbsoluteTimeSpan, 2) / 2), 1 / 4), o.EndTempo = o.StartTempo + m;
                            }
                        }
                        t.TimestampSortedTempoExpressionsList = r, r[0]?.InstantaneousTempo && 0 === r[0].AbsolutePlaybackTimestamp.RealValue && (t.DefaultStartTempoInBpm = i);
                    }
                    static cleanExpListStartingEntry(t, e) {
                        if (0 === e.length || 0 !== e[0].AbsolutePlaybackTimestamp.RealValue) return t.DefaultStartTempoInBpm || t.userStartTempoInBPM;
                        if (!e[0].InstantaneousTempo) {
                            const t = new o.InstantaneousTempoExpression("*generated", r.PlacementEnum.Above, 1, 0, e[0], !0);
                            e[0].addExpression(t, "");
                        }
                        const i = e[0].InstantaneousTempo;
                        let s = e[0].PlaybackTempoInBpm;
                        for(let t = 1; t < e.length && 0 === e[t].AbsolutePlaybackTimestamp.RealValue; t++)e[t].PlaybackTempoInBpm > 0 && (s = e[t].PlaybackTempoInBpm);
                        return i.TempoInBpm > 0 || (s > 0 ? i.TempoInBpm = s : t.DefaultStartTempoInBpm > 0 ? i.TempoInBpm = t.DefaultStartTempoInBpm : i.TempoInBpm = o.InstantaneousTempoExpression.getDefaultValueForInstTempo(o.InstTempo.moderato)), s > 0 ? s : i.TempoInBpm;
                    }
                }
                e.TemposCalculator = a;
                class l {
                    static Compare(t, e) {
                        let i = 0;
                        if (i = l.CompareNumber(t.AbsolutePlaybackTimestamp.RealValue, e.AbsolutePlaybackTimestamp.RealValue), 0 !== i) return i;
                        const s = l.calcSortPriority(t), n = l.calcSortPriority(e);
                        return i = l.CompareNumber(s, n), i;
                    }
                    static calcSortPriority(t) {
                        if (null != t.InstantaneousTempo) {
                            switch(t.InstantaneousTempo.TempoType){
                                case o.TempoType.metronomeMark:
                                    return 1;
                                case o.TempoType.inst:
                                    return 2;
                                case o.TempoType.change:
                                    switch(t.InstantaneousTempo.ChangeSubType){
                                        case o.ChangeSubType.atempo:
                                        case o.ChangeSubType.doppioMovimento:
                                            return 3;
                                        case o.ChangeSubType.tempoprimo:
                                            return 4;
                                    }
                            }
                            return 5;
                        }
                        return 9;
                    }
                    static CompareNumber(t, e) {
                        return t < e ? -1 : t === e ? 0 : 1;
                    }
                }
                e.TempoSorter = l;
            },
            302 (t, e, i) {
                "use strict";
                var s = this && this.__createBinding || (Object.create ? function(t, e, i, s) {
                    void 0 === s && (s = i);
                    var n = Object.getOwnPropertyDescriptor(e, i);
                    n && !("get" in n ? !e.__esModule : n.writable || n.configurable) || (n = {
                        enumerable: !0,
                        get: function() {
                            return e[i];
                        }
                    }), Object.defineProperty(t, s, n);
                } : function(t, e, i, s) {
                    void 0 === s && (s = i), t[s] = e[i];
                }), n = this && this.__exportStar || function(t, e) {
                    for(var i in t)"default" === i || Object.prototype.hasOwnProperty.call(e, i) || s(e, t, i);
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), n(i(4127), e), n(i(9536), e), n(i(5984), e), n(i(6030), e), n(i(6302), e), n(i(7631), e), n(i(3186), e), n(i(1538), e);
            },
            7503 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.ReaderPluginManager = void 0;
                const n = s(i(3065));
                e.ReaderPluginManager = class {
                    constructor(){
                        this.voiceMeasureReadPlugins = [];
                    }
                    addVoiceMeasureReadPlugin(t) {
                        this.voiceMeasureReadPlugins.push(t);
                    }
                    processVoiceMeasureReadPlugins(t, e, i) {
                        for (const s of this.voiceMeasureReadPlugins)try {
                            s.measureReadCalculations(t, e, i);
                        } catch (t) {
                            n.default.info("VoiceGenerator.addSingleNote: ", t);
                        }
                    }
                };
            },
            469 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.VoiceGenerator = void 0;
                const n = i(4249), r = i(5534), o = i(1336), a = i(1850), l = i(2369), h = i(8365), c = i(5274), u = i(2257), d = i(4268), f = i(2561), m = i(9767), p = i(6030), g = i(7307), b = i(8233), S = i(8233), y = i(6644), E = s(i(3065)), x = i(8233), v = i(813), T = i(4127), _ = i(4064), M = i(4236), P = i(5282), L = i(9647), w = i(6362);
                e.VoiceGenerator = class {
                    constructor(t, e, i, s, o){
                        this.openBeams = [], this.beamNumberOffset = 0, this.currentOctaveShift = 0, this.tupletDict = {}, this.openTupletNumber = 0, this.staff = e, this.instrument = e.ParentInstrument, this.musicSheet = this.instrument.GetMusicSheet, this.slurReader = s, this.pluginManager = t, this.voice = o ? new n.LinkedVoice(this.instrument, i, o) : new r.Voice(this.instrument, i), this.instrument.Voices.push(this.voice), this.staff.Voices.push(this.voice), this.lyricsReader = new p.LyricsReader(this.musicSheet), this.articulationReader = new T.ArticulationReader(this.musicSheet.Rules);
                    }
                    get openTieDict() {
                        return this.staff.openTieDict;
                    }
                    get GetVoice() {
                        return this.voice;
                    }
                    get OctaveShift() {
                        return this.currentOctaveShift;
                    }
                    set OctaveShift(t) {
                        this.currentOctaveShift = t;
                    }
                    createVoiceEntry(t, e, i, s = !1, n = !1, r = !1) {
                        this.currentVoiceEntry = new o.VoiceEntry(t.clone(), this.voice, e, s, n, r), i && this.voice.VoiceEntries.push(this.currentVoiceEntry);
                    }
                    read(t, e, i, s, n, r, o, a, l, h, c, d, f, p, g, b, S, y, x, v) {
                        this.currentStaffEntry = o, this.currentMeasure = a;
                        try {
                            this.currentNote = r ? this.addRestNote(t.element("rest"), e, s, i, n, f, p, x) : this.addSingleNote(t, e, s, i, n, c, d, f, p, g, b, S, y, x), this.currentNote.DotsXml = v;
                            const o = t.elements("lyric");
                            void 0 !== this.lyricsReader && o.length > 0 && (this.lyricsReader.addLyricEntry(o, this.currentVoiceEntry), this.voice.Parent.HasLyrics = !0);
                            let a = !1;
                            const m = t.element("notations");
                            if (m) {
                                this.articulationReader && this.readArticulations(m, this.currentVoiceEntry, this.currentNote);
                                const e = m.elements("slur"), i = m.elements("slide"), s = m.elements("glissando");
                                void 0 !== this.slurReader && (e.length > 0 || i.length > 0 || s.length > 0) && !this.currentNote.ParentVoiceEntry.IsGrace && (this.slurReader.addSlur(e, this.currentNote), i.length > 0 && this.slurReader.addSlur(i, this.currentNote), s.length > 0 && this.slurReader.addSlur(s, this.currentNote));
                                const n = m.elements("tuplet");
                                n.length > 0 && (this.openTupletNumber = this.addTuplet(t, n), a = !0);
                                const r = m.element("arpeggiate");
                                if (void 0 !== r) {
                                    let t;
                                    if (this.currentVoiceEntry.Arpeggio) t = this.currentVoiceEntry.Arpeggio;
                                    else {
                                        let e = !1;
                                        for (const i of this.currentStaffEntry.VoiceEntries)if (i.Arpeggio) {
                                            e = !0, t = i.Arpeggio;
                                            break;
                                        }
                                        if (!e) {
                                            let e = M.ArpeggioType.ARPEGGIO_DIRECTIONLESS;
                                            const i = r.attribute("direction");
                                            if (i) switch(i.value){
                                                case "up":
                                                    e = M.ArpeggioType.ROLL_UP;
                                                    break;
                                                case "down":
                                                    e = M.ArpeggioType.ROLL_DOWN;
                                                    break;
                                                default:
                                                    e = M.ArpeggioType.ARPEGGIO_DIRECTIONLESS;
                                            }
                                            t = new M.Arpeggio(this.currentVoiceEntry, e), this.currentVoiceEntry.Arpeggio = t;
                                        }
                                    }
                                    t.addNote(this.currentNote);
                                }
                                const o = m.elements("tied");
                                o.length > 0 && this.addTie(o, l, h, u.TieTypes.SIMPLE);
                                const c = m.element("technical");
                                if (c) {
                                    const t = c.elements("hammer-on");
                                    t.length > 0 && this.addTie(t, l, h, u.TieTypes.HAMMERON);
                                    const e = c.elements("pull-off");
                                    e.length > 0 && this.addTie(e, l, h, u.TieTypes.PULLOFF);
                                }
                            }
                            void 0 === t.element("time-modification") || a || this.handleTimeModificationNode(t);
                        } catch (t) {
                            E.default.warn(t);
                            const e = m.ITextTranslation.translateText("ReaderErrorMessages/NoteError", "Ignored erroneous Note.");
                            this.musicSheet.SheetErrors.pushMeasureError(e), this.musicSheet.SheetErrors.pushMeasureError(t);
                        }
                        return this.currentNote;
                    }
                    checkForStaffEntryLink(t, e, i, s) {
                        const n = new y.StaffEntryLink(this.currentVoiceEntry);
                        n.LinkStaffEntries.push(i), i.Link = n;
                        const r = this.currentVoiceEntry.Timestamp.clone(), o = s.getVerticalContainerByTimestamp(r);
                        return (i = o.StaffEntries[t]) || (i = new l.SourceStaffEntry(o, e), o.StaffEntries[t] = i), i.VoiceEntries.push(this.currentVoiceEntry), n.LinkStaffEntries.push(i), i.Link = n, i;
                    }
                    checkForOpenBeam() {
                        this.openBeams.length > 0 && this.currentNote && this.handleOpenBeam();
                    }
                    checkOpenTies() {
                        const t = this.openTieDict;
                        for(const e in t)if (t.hasOwnProperty(e)) {
                            const i = t[e];
                            f.Fraction.plus(i.StartNote.ParentStaffEntry.Timestamp, i.Duration).lt(i.StartNote.SourceMeasure.Duration) && delete t[e];
                        }
                    }
                    hasVoiceEntry() {
                        return void 0 !== this.currentVoiceEntry;
                    }
                    readArticulations(t, e, i) {
                        const s = t.element("articulations");
                        s && this.articulationReader.addArticulationExpression(s, e);
                        const n = t.element("fermata");
                        n && this.articulationReader.addFermata(n, e);
                        const r = t.element("technical");
                        r && this.articulationReader.addTechnicalArticulations(r, e, i);
                        const o = t.element("ornaments");
                        o && this.articulationReader.addOrnament(o, e);
                    }
                    addSingleNote(t, e, i, s, n, r, l, h, c, u, d, p, y, v) {
                        let T, M, P, w, A = 0, I = !1, R = !1, N = b.AccidentalEnum.NONE, C = S.NoteEnum.C, B = S.NoteEnum.C, D = 0, O = 0;
                        const F = t.elements();
                        for(let t = 0, e = F.length; t < e; ++t){
                            const e = F[t];
                            try {
                                if ("pitch" === e.name) {
                                    const t = e.elements();
                                    for(let e = 0, i = t.length; e < i; ++e){
                                        const i = t[e];
                                        P = void 0, w = void 0;
                                        try {
                                            if ("step" === i.name) {
                                                if (C = S.NoteEnum[i.value], void 0 === C) {
                                                    const t = m.ITextTranslation.translateText("ReaderErrorMessages/NotePitchError", "Invalid pitch while reading note.");
                                                    throw this.musicSheet.SheetErrors.pushMeasureError(t), new g.MusicSheetReadingException(t, void 0);
                                                }
                                            } else if ("alter" === i.name) {
                                                if (A = parseFloat(i.value), isNaN(A)) {
                                                    const t = m.ITextTranslation.translateText("ReaderErrorMessages/NoteAlterationError", "Invalid alteration while reading note.");
                                                    throw this.musicSheet.SheetErrors.pushMeasureError(t), new g.MusicSheetReadingException(t, void 0);
                                                }
                                                N = x.Pitch.AccidentalFromHalfTones(A);
                                            } else if ("octave" === i.name && (D = parseInt(i.value, 10), isNaN(D))) {
                                                const t = m.ITextTranslation.translateText("ReaderErrorMessages/NoteOctaveError", "Invalid octave value while reading note.");
                                                throw this.musicSheet.SheetErrors.pushMeasureError(t), new g.MusicSheetReadingException(t, void 0);
                                            }
                                        } catch (t) {
                                            E.default.info("VoiceGenerator.addSingleNote read Step: ", t.message);
                                        }
                                    }
                                } else if ("accidental" === e.name) {
                                    T = e.value;
                                    const t = e.attribute("parentheses")?.value, i = e.attribute("bracket")?.value;
                                    I = "yes" === t, R = "yes" === i, void 0 === t && void 0 === i && this.musicSheet.Rules.RenderCautionaryAccidentalsInParentheses && (I = "yes" === e.attribute("cautionary")?.value), "natural" === T ? N = b.AccidentalEnum.NATURAL : "slash-flat" === T ? N = b.AccidentalEnum.SLASHFLAT : "slash-quarter-sharp" === T ? N = b.AccidentalEnum.SLASHQUARTERSHARP : "slash-sharp" === T ? N = b.AccidentalEnum.SLASHSHARP : "double-slash-flat" === T ? N = b.AccidentalEnum.DOUBLESLASHFLAT : "sori" === T ? N = b.AccidentalEnum.SORI : "koron" === T && (N = b.AccidentalEnum.KORON);
                                } else if ("unpitched" === e.name) {
                                    const t = e.element("display-step"), i = e.element("display-octave"), s = this.currentStaffEntry.ParentStaff.StafflineCount;
                                    if (i && (D = parseInt(i.value, 10), O = D - 3, l && (D += 1), 1 === s && (O += 1)), t) {
                                        C = S.NoteEnum[t.value.toUpperCase()];
                                        let e = 0, i = this.musicSheet.Rules.PercussionXMLDisplayStepNoteValueShift;
                                        1 === s ? i -= 3 : s > 1 && s < 5 && (i += 2), [B, e] = x.Pitch.lineShiftFromNoteEnum(C, i), O += e;
                                    }
                                } else "instrument" === e.name ? e.firstAttribute && (M = e.firstAttribute.value) : "notehead" === e.name && (P = e.value, e.attribute("filled") && (w = "yes" === e.attribute("filled").value));
                            } catch (t) {
                                E.default.info("VoiceGenerator.addSingleNote: ", t);
                            }
                        }
                        D -= x.Pitch.OctaveXmlDifference;
                        const k = new x.Pitch(C, D, N, T), V = f.Fraction.createFromFraction(e);
                        let G, W = -1, U = -1;
                        const z = [], H = t.element("notations");
                        if (H) {
                            const t = H.element("technical");
                            if (t) {
                                const e = t.element("string");
                                e && (W = parseInt(e.value, 10));
                                const i = t.element("fret");
                                i && (U = parseInt(i.value, 10)), t.elements("bend").forEach(function(t) {
                                    const e = t.element("bend-alter");
                                    void 0 !== t.element("release") ? z.push({
                                        bendalter: parseInt(e.value, 10),
                                        direction: "down"
                                    }) : z.push({
                                        bendalter: parseInt(e.value, 10),
                                        direction: "up"
                                    });
                                });
                            }
                        }
                        return G = W < 0 || U < 0 ? new a.Note(this.currentVoiceEntry, this.currentStaffEntry, V, k, this.currentMeasure) : new L.TabNote(this.currentVoiceEntry, this.currentStaffEntry, V, k, this.currentMeasure, W, U, z), this.addNoteInfo(G, i, h, c, n, B, O, v, v), G.TypeLength = s, G.IsGraceNote = u, G.StemDirectionXml = d, G.TremoloInfo = p, (p?.tremoloBetweenNotesStart || p?.tremoloBetweenNotesStop) && this.handleTremoloBetweenNotes(p, G), G.PlaybackInstrumentId = M, G.AccidentalParenthesesXml = I, G.AccidentalBracketXml = R, (void 0 !== P && "normal" !== P || void 0 !== w) && (G.Notehead = new _.Notehead(G, P, w)), d === o.StemDirectionType.None && (y = "#00000000"), this.currentVoiceEntry.Notes.push(G), this.currentVoiceEntry.StemDirectionXml = d, y && (this.currentVoiceEntry.StemColorXml = y, this.currentVoiceEntry.StemColor = y, G.StemColorXml = y), t.elements("beam") && !r && this.createBeam(t, G), G;
                    }
                    addRestNote(t, e, i, s, n, r, o, l) {
                        const h = f.Fraction.createFromFraction(e), c = t.element("display-step"), u = t.element("display-octave");
                        let d, m, p;
                        c && u && (d = S.NoteEnum[c.value.toUpperCase()], m = parseInt(u.value, 10), p = new x.Pitch(d, m, b.AccidentalEnum.NONE, void 0, !0));
                        const g = new a.Note(this.currentVoiceEntry, this.currentStaffEntry, h, p, this.currentMeasure, !0);
                        return this.addNoteInfo(g, i, r, o, n, d, m, l, l), g.TypeLength = s, this.currentVoiceEntry.Notes.push(g), this.openBeams.length > 0 && this.openBeams.last().ExtendedNoteList.push(g), g;
                    }
                    addNoteInfo(t, e, i, s, n, r, o, a, l) {
                        t.NoteTypeXml = e, t.PrintObject = i, t.IsCueNote = s, t.NormalNotes = n, t.displayStepUnpitched = r, t.displayOctaveUnpitched = o, t.NoteheadColorXml = a, t.NoteheadColor = a;
                    }
                    handleTremoloBetweenNotes(t, e) {
                        const i = this.openTremoloBetweenNotes;
                        if (t.tremoloBetweenNotesStart) {
                            if (i && !i.stopNote && i.startNote?.ParentVoiceEntry === e.ParentVoiceEntry) return void (t.tremoloBetweenNotes = i);
                            this.openTremoloBetweenNotes = {
                                strokes: t.tremoloStrokes,
                                startNote: e,
                                stopNote: void 0
                            }, t.tremoloBetweenNotes = this.openTremoloBetweenNotes;
                        } else t.tremoloBetweenNotesStop && (i && !i.stopNote ? (i.stopNote = e, t.tremoloBetweenNotes = i) : i?.stopNote?.ParentVoiceEntry === e.ParentVoiceEntry ? t.tremoloBetweenNotes = i : E.default.debug("VoiceGenerator.handleTremoloBetweenNotes: tremolo stop without preceding tremolo start. ignoring it."));
                    }
                    createBeam(t, e) {
                        try {
                            const i = t.element("beam");
                            let s;
                            if (void 0 !== i && i.hasAttributes && (s = i.attribute("number")), s) {
                                let i = parseInt(s.value, 10);
                                const n = t.elements("beam"), r = n[0].value;
                                n && ("begin" === r ? (i === this.openBeams.last()?.BeamNumber ? (this.beamNumberOffset++, i += this.beamNumberOffset) : this.openBeams.last() && this.handleOpenBeam(), this.openBeams.push(new h.Beam(i, this.beamNumberOffset))) : i += this.beamNumberOffset);
                                let o = !1;
                                if (!(i > 0 && i <= this.openBeams.length && this.openBeams[i - 1])) return void E.default.debug("[OSMD] invalid beamnumber");
                                for(let t = 0, e = this.openBeams[i - 1].Notes.length; t < e; ++t){
                                    const e = this.openBeams[i - 1].Notes[t];
                                    this.currentVoiceEntry === e.ParentVoiceEntry && (o = !0);
                                }
                                if (!o) {
                                    const t = this.openBeams[i - 1];
                                    if (t.addNoteToBeam(e), "continue" === r && n.length > 1) {
                                        for(let e = 1; e < n.length; e++)if ("end" === n[e].value) {
                                            const e = t.Notes.length - 1;
                                            e > 0 && t.SecondaryBreakIndices.push(e);
                                            break;
                                        }
                                    }
                                    "end" === r && this.endBeam();
                                }
                            }
                        } catch (t) {
                            const e = m.ITextTranslation.translateText("ReaderErrorMessages/BeamError", "Error while reading beam.");
                            throw this.musicSheet.SheetErrors.pushMeasureError(e), new g.MusicSheetReadingException("", t);
                        }
                    }
                    endBeam() {
                        this.openBeams.pop(), this.beamNumberOffset = Math.max(0, this.beamNumberOffset - 1);
                    }
                    handleOpenBeam() {
                        const t = this.openBeams.last();
                        if (0 !== t.Notes.length) {
                            if (1 === t.Notes.length) return t.Notes[0].NoteBeam = void 0, void this.endBeam();
                            if (this.currentNote === v.CollectionUtil.last(t.Notes)) this.endBeam();
                            else {
                                const e = v.CollectionUtil.last(t.Notes).ParentStaffEntry, i = this.currentMeasure.getVerticalContainerIndexByTimestamp(e.Timestamp), s = e.VerticalContainerParent.StaffEntries.indexOf(e);
                                if (i < this.currentMeasure.VerticalSourceStaffEntryContainers.length - 1) {
                                    const t = this.currentMeasure.VerticalSourceStaffEntryContainers[i + 1].StaffEntries[s];
                                    if (t) for(let e = 0, i = t.VoiceEntries.length; e < i; ++e){
                                        const i = t.VoiceEntries[e];
                                        if (i.ParentVoice === this.voice) {
                                            const t = i.Notes[0];
                                            t.Length.lte(new f.Fraction(1, 8)) ? (this.openBeams.last().addNoteToBeam(t), this.endBeam()) : this.endBeam();
                                        }
                                    }
                                } else this.endBeam();
                            }
                        } else this.endBeam();
                    }
                    addTuplet(t, e) {
                        let i, s = !1;
                        if (void 0 !== e && e.length > 1) {
                            let n = t.element("time-modification");
                            n && (n = n.element("actual-notes"));
                            const r = e;
                            for(let e = 0, a = r.length; e < a; ++e){
                                const a = r[e];
                                if (void 0 !== a && a.attributes()) {
                                    const e = a.attribute("bracket");
                                    e && "yes" === e.value ? (s = !0, i = !0) : e && "no" === e.value && (i = !1);
                                    let r = this.musicSheet.Rules.TupletsRatioed;
                                    const l = a.attribute("show-number");
                                    l && "both" === l.value && this.musicSheet.Rules.TupletsRatioedUseXMLValue && (r = !0);
                                    const h = this.readShowNumberNoneGiven(a), c = a.attribute("type");
                                    if (c && "start" === c.value) {
                                        let e = 1;
                                        a.attribute("number") && (e = parseInt(a.attribute("number").value, 10));
                                        let o = 0;
                                        if (n && (o = parseInt(n.value, 10), isNaN(o))) {
                                            const t = m.ITextTranslation.translateText("ReaderErrorMessages/TupletNoteDurationError", "Invalid tuplet note duration.");
                                            throw this.musicSheet.SheetErrors.pushMeasureError(t), new g.MusicSheetReadingException(t, void 0);
                                        }
                                        const l = this.readTupletActualNumber(a);
                                        l > 0 && (o = l);
                                        const c = new d.Tuplet(o, s);
                                        c.Ratioed = r, c.BracketedXmlValue = i, c.ShowNumberNoneGivenInXml = h, c.tupletLabelNumberPlacement = w.PlacementEnum.Above;
                                        const u = a.attribute("placement");
                                        u && ("below" === u.value && (c.tupletLabelNumberPlacement = w.PlacementEnum.Below), c.PlacementFromXml = !0), this.tupletDict[e] && (delete this.tupletDict[e], 0 === Object.keys(this.tupletDict).length ? this.openTupletNumber = 0 : Object.keys(this.tupletDict).length > 1 && this.openTupletNumber--), this.tupletDict[e] = c;
                                        const f = [];
                                        f.push(this.currentNote), c.Notes.push(f), c.Fractions.push(this.getTupletNoteDurationFromType(t)), this.linkNoteToTuplet(this.currentNote, c), this.openTupletNumber = e;
                                    } else if ("stop" === c.value) {
                                        let e = 1;
                                        a.attribute("number") && (e = parseInt(a.attribute("number").value, 10));
                                        const i = this.tupletDict[e];
                                        if (i) {
                                            const s = a.attribute("placement");
                                            s && ("below" === s.value ? i.tupletLabelNumberPlacement = w.PlacementEnum.Below : i.tupletLabelNumberPlacement = w.PlacementEnum.Above, i.PlacementFromXml = !0);
                                            const n = [];
                                            if (n.push(this.currentNote), i.Notes.push(n), !i.PlacementFromXml) {
                                                let t = !1;
                                                for (const e of i.Notes){
                                                    for (const s of e)if (!s.isRest()) {
                                                        s.StemDirectionXml === o.StemDirectionType.Down ? i.tupletLabelNumberPlacement = w.PlacementEnum.Below : i.tupletLabelNumberPlacement = w.PlacementEnum.Above, t = !0;
                                                        break;
                                                    }
                                                    if (t) break;
                                                }
                                            }
                                            i.Fractions.push(this.getTupletNoteDurationFromType(t)), this.linkNoteToTuplet(this.currentNote, i), delete this.tupletDict[e], 0 === Object.keys(this.tupletDict).length ? this.openTupletNumber = 0 : Object.keys(this.tupletDict).length > 1 && this.openTupletNumber--;
                                        }
                                    }
                                }
                            }
                        } else if (e[0]) {
                            const n = e[0];
                            if (n.hasAttributes) {
                                const e = n.attribute("type").value;
                                let r = 1;
                                n.attribute("number") && (r = parseInt(n.attribute("number").value, 10));
                                const a = isNaN(r), l = this.readShowNumberNoneGiven(n), h = n.attribute("bracket");
                                h && "yes" === h.value ? (s = !0, i = !0) : h && "no" === h.value && (i = !1);
                                let c = this.musicSheet.Rules.TupletsRatioed;
                                const u = n.attribute("show-number");
                                if (u && "both" === u.value && this.musicSheet.Rules.TupletsRatioedUseXMLValue && (c = !0), "start" === e) {
                                    let e = 0, o = t.element("time-modification");
                                    if (o && (o = o.element("actual-notes")), o && (e = parseInt(o.value, 10), isNaN(e))) {
                                        const t = m.ITextTranslation.translateText("ReaderErrorMessages/TupletNoteDurationError", "Invalid tuplet note duration.");
                                        throw this.musicSheet.SheetErrors.pushMeasureError(t), new g.MusicSheetReadingException(t);
                                    }
                                    const h = this.readTupletActualNumber(n);
                                    h > 0 && (e = h), a && (this.openTupletNumber++, r = this.openTupletNumber);
                                    let u = this.tupletDict[r];
                                    u || (u = this.tupletDict[r] = new d.Tuplet(e, s), u.Ratioed = c, u.BracketedXmlValue = i, u.ShowNumberNoneGivenInXml = l, u.tupletLabelNumberPlacement = w.PlacementEnum.Above);
                                    const f = n.attribute("placement");
                                    f && ("below" === f.value ? u.tupletLabelNumberPlacement = w.PlacementEnum.Below : u.tupletLabelNumberPlacement = w.PlacementEnum.Above, u.PlacementFromXml = !0);
                                    const p = [];
                                    p.push(this.currentNote), u.Notes.push(p), u.Fractions.push(this.getTupletNoteDurationFromType(t)), this.linkNoteToTuplet(this.currentNote, u), this.openTupletNumber = r;
                                } else if ("stop" === e) {
                                    a && (r = this.openTupletNumber);
                                    const e = this.tupletDict[this.openTupletNumber];
                                    if (e) {
                                        const i = n.attribute("placement");
                                        i && ("below" === i.value ? e.tupletLabelNumberPlacement = w.PlacementEnum.Below : e.tupletLabelNumberPlacement = w.PlacementEnum.Above, e.PlacementFromXml = !0);
                                        const s = [];
                                        if (s.push(this.currentNote), e.Notes.push(s), !e.PlacementFromXml) {
                                            let t = !1;
                                            for (const i of e.Notes){
                                                for (const s of i)if (!s.isRest()) {
                                                    s.StemDirectionXml === o.StemDirectionType.Down ? e.tupletLabelNumberPlacement = w.PlacementEnum.Below : e.tupletLabelNumberPlacement = w.PlacementEnum.Above, t = !0;
                                                    break;
                                                }
                                                if (t) break;
                                            }
                                        }
                                        e.Fractions.push(this.getTupletNoteDurationFromType(t)), this.linkNoteToTuplet(this.currentNote, e), 0 === Object.keys(this.tupletDict).length ? this.openTupletNumber = 0 : Object.keys(this.tupletDict).length > 1 && this.openTupletNumber--, delete this.tupletDict[r];
                                    }
                                }
                            }
                        }
                        return this.addCurrentNoteToOpenTuplets(t), this.openTupletNumber;
                    }
                    readShowNumberNoneGiven(t) {
                        const e = t.attribute("show-number");
                        return !(!e?.value || "none" !== e.value);
                    }
                    handleTimeModificationNode(t) {
                        const e = Object.keys(this.tupletDict);
                        if (e.length > 0) try {
                            for (const i of e)this.addCurrentNoteToTuplet(this.tupletDict[i], t);
                            this.tupletDict[this.openTupletNumber] && (this.currentNote.NoteTuplet = this.tupletDict[this.openTupletNumber]);
                        } catch (t) {
                            const e = m.ITextTranslation.translateText("ReaderErrorMessages/TupletNumberError", "Invalid tuplet number.");
                            throw this.musicSheet.SheetErrors.pushMeasureError(e), t;
                        }
                        else if (this.currentVoiceEntry.Notes.length > 0) {
                            const t = this.currentVoiceEntry.Notes[0];
                            if (t.NoteTuplet) {
                                const e = t.NoteTuplet;
                                v.CollectionUtil.last(e.Notes).push(this.currentNote), this.linkNoteToTuplet(this.currentNote, e);
                            }
                        }
                    }
                    linkNoteToTuplet(t, e) {
                        t.NoteTuplet = e, t.NoteTuplets.indexOf(e) < 0 && t.NoteTuplets.push(e);
                    }
                    addCurrentNoteToTuplet(t, e) {
                        const i = v.CollectionUtil.last(t.Notes);
                        let s;
                        i && i[0]?.ParentVoiceEntry.Timestamp.Equals(this.currentVoiceEntry.Timestamp) ? s = i : (s = [], t.Notes.push(s), t.Fractions.push(this.getTupletNoteDurationFromType(e))), s.indexOf(this.currentNote) < 0 && s.push(this.currentNote), this.currentNote.NoteTuplets.indexOf(t) < 0 && this.currentNote.NoteTuplets.push(t);
                    }
                    addCurrentNoteToOpenTuplets(t) {
                        for (const e of Object.keys(this.tupletDict)){
                            const i = this.tupletDict[e];
                            i && this.currentNote.NoteTuplets.indexOf(i) < 0 && this.addCurrentNoteToTuplet(i, t);
                        }
                    }
                    readTupletActualNumber(t) {
                        const e = t.element("tuplet-actual");
                        if (e) {
                            const t = e.element("tuplet-number");
                            if (t) {
                                const e = parseInt(t.value, 10);
                                if (!isNaN(e)) return e;
                            }
                        }
                        return 0;
                    }
                    addTie(t, e, i, s) {
                        if (t) {
                            if (1 === t.length) {
                                const e = t[0];
                                if (void 0 !== e && e.attributes()) {
                                    const t = this.getTieDirection(e), i = e.attribute("type").value;
                                    try {
                                        if ("start" === i) {
                                            const e = this.findCurrentNoteInTieDict(this.currentNote);
                                            e < 0 && delete this.openTieDict[e];
                                            const i = this.getNextAvailableNumberForTie(), n = new c.Tie(this.currentNote, s);
                                            this.openTieDict[i] = n, n.TieNumber = i, n.TieDirection = t;
                                        } else if ("stop" === i) {
                                            const t = this.findCurrentNoteInTieDict(this.currentNote), e = this.openTieDict[t];
                                            e && (e.AddNote(this.currentNote), delete this.openTieDict[t]);
                                        }
                                    } catch (t) {
                                        const e = m.ITextTranslation.translateText("ReaderErrorMessages/TieError", "Error while reading tie.");
                                        this.musicSheet.SheetErrors.pushMeasureError(e);
                                    }
                                }
                            } else if (2 === t.length) {
                                const e = this.findCurrentNoteInTieDict(this.currentNote);
                                if (e >= 0) {
                                    const i = this.openTieDict[e];
                                    i.AddNote(this.currentNote);
                                    for (const e of t)if ("start" === e.attribute("type").value) {
                                        const t = this.getTieDirection(e);
                                        i.NoteIndexToTieDirection[i.Notes.length - 1] = t;
                                    }
                                }
                            }
                        }
                    }
                    getTieDirection(t) {
                        let e = w.PlacementEnum.NotYetDefined;
                        const i = t.attribute("placement");
                        i && ("above" === i.value ? e = w.PlacementEnum.Above : "below" === i.value && (e = w.PlacementEnum.Below));
                        const s = t.attribute("orientation");
                        return s && ("over" === s.value ? e = w.PlacementEnum.Above : "under" === s.value && (e = w.PlacementEnum.Below)), e;
                    }
                    getNextAvailableNumberForTie() {
                        const t = Object.keys(this.openTieDict);
                        if (0 === t.length) return 1;
                        t.sort((t, e)=>+t - +e);
                        for(let e = 0; e < t.length; e++)if ("" + (e + 1) !== t[e]) return e + 1;
                        return +t[t.length - 1] + 1;
                    }
                    findCurrentNoteInTieDict(t) {
                        const e = this.openTieDict;
                        for(const i in e)if (e.hasOwnProperty(i)) {
                            const s = e[i], n = s.Notes[0], r = t;
                            if (s.Pitch.FundamentalNote === t.Pitch.FundamentalNote && s.Pitch.Octave === t.Pitch.Octave) return parseInt(i, 10);
                            if (void 0 !== n.StringNumberTab && n.StringNumberTab === r.StringNumberTab) return parseInt(i, 10);
                        }
                        for(const i in e)if (e.hasOwnProperty(i) && e[i].Pitch.getHalfTone() === t.Pitch.getHalfTone()) return parseInt(i, 10);
                        return -1;
                    }
                    getTupletNoteDurationFromType(t) {
                        if (t.element("type")) {
                            const e = t.element("type");
                            if (e) {
                                const t = e.value;
                                try {
                                    return P.NoteTypeHandler.getNoteDurationFromType(t);
                                } catch (t) {
                                    const e = m.ITextTranslation.translateText("ReaderErrorMessages/NoteDurationError", "Invalid note duration.");
                                    throw this.musicSheet.SheetErrors.pushMeasureError(e), new g.MusicSheetReadingException("", t);
                                }
                            }
                        }
                    }
                };
            },
            6352 (t, e, i) {
                "use strict";
                var s = this && this.__createBinding || (Object.create ? function(t, e, i, s) {
                    void 0 === s && (s = i);
                    var n = Object.getOwnPropertyDescriptor(e, i);
                    n && !("get" in n ? !e.__esModule : n.writable || n.configurable) || (n = {
                        enumerable: !0,
                        get: function() {
                            return e[i];
                        }
                    }), Object.defineProperty(t, s, n);
                } : function(t, e, i, s) {
                    void 0 === s && (s = i), t[s] = e[i];
                }), n = this && this.__exportStar || function(t, e) {
                    for(var i in t)"default" === i || Object.prototype.hasOwnProperty.call(e, i) || s(e, t, i);
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), n(i(1272), e), n(i(9099), e), n(i(5749), e), n(i(469), e), n(i(302), e), n(i(7503), e);
            },
            5294 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.SubInstrument = void 0;
                const n = i(164), r = s(i(3065));
                class o {
                    constructor(t){
                        this.parentInstrument = t, this.fixedKey = -1, this.name = this.parseMidiInstrument(this.parentInstrument.Name), this.midiInstrumentID = o.midiInstrument[this.name], this.volume = 1;
                    }
                    get ParentInstrument() {
                        return this.parentInstrument;
                    }
                    static isPianoInstrument(t) {
                        return t === n.MidiInstrument.Acoustic_Grand_Piano || t === n.MidiInstrument.Bright_Acoustic_Piano || t === n.MidiInstrument.Electric_Grand_Piano || t === n.MidiInstrument.Electric_Piano_1 || t === n.MidiInstrument.Electric_Piano_2;
                    }
                    setMidiInstrument(t) {
                        this.midiInstrumentID = o.midiInstrument[this.parseMidiInstrument(t)];
                    }
                    parseMidiInstrument(t) {
                        try {
                            if (t) {
                                const e = t.toLowerCase().trim();
                                for(const t in o.midiInstrument)if (-1 !== e.indexOf(t)) return t;
                            }
                            if (this.parentInstrument.Name) {
                                const t = this.parentInstrument.Name.toLowerCase().trim();
                                for(const e in o.midiInstrument)if (-1 !== t.indexOf(e)) return e;
                            }
                        } catch (t) {
                            r.default.error("Error parsing MIDI Instrument. Default to Grand Piano.");
                        }
                        return "unnamed";
                    }
                }
                e.SubInstrument = o, o.midiInstrument = {
                    alt: n.MidiInstrument.Synth_Voice,
                    alto: n.MidiInstrument.Synth_Voice,
                    banjo: n.MidiInstrument.Banjo,
                    bariton: n.MidiInstrument.Synth_Voice,
                    baritone: n.MidiInstrument.Synth_Voice,
                    bass: n.MidiInstrument.Synth_Voice,
                    blockfloete: n.MidiInstrument.Recorder,
                    brass: n.MidiInstrument.Trombone,
                    bratsche: n.MidiInstrument.Viola,
                    cello: n.MidiInstrument.Cello,
                    clarinet: n.MidiInstrument.Clarinet,
                    contrabass: n.MidiInstrument.Contrabass,
                    drums: n.MidiInstrument.Percussion,
                    flute: n.MidiInstrument.Flute,
                    floete: n.MidiInstrument.Flute,
                    frenchhorn: n.MidiInstrument.French_Horn,
                    gitarre: n.MidiInstrument.Acoustic_Guitar_nylon,
                    guitar: n.MidiInstrument.Acoustic_Guitar_nylon,
                    harfe: n.MidiInstrument.Orchestral_Harp,
                    harp: n.MidiInstrument.Orchestral_Harp,
                    klarinette: n.MidiInstrument.Clarinet,
                    klavier: n.MidiInstrument.Acoustic_Grand_Piano,
                    kontrabass: n.MidiInstrument.Contrabass,
                    oboe: n.MidiInstrument.Oboe,
                    organ: n.MidiInstrument.Church_Organ,
                    orgel: n.MidiInstrument.Church_Organ,
                    orgue: n.MidiInstrument.Church_Organ,
                    percussion: n.MidiInstrument.Percussion,
                    piano: n.MidiInstrument.Acoustic_Grand_Piano,
                    piccolo: n.MidiInstrument.Piccolo,
                    posaune: n.MidiInstrument.Trombone,
                    recorder: n.MidiInstrument.Recorder,
                    sax: n.MidiInstrument.Tenor_Sax,
                    schlagwerk: n.MidiInstrument.Percussion,
                    schlagzeug: n.MidiInstrument.Percussion,
                    sopran: n.MidiInstrument.Synth_Voice,
                    steeldrum: n.MidiInstrument.Steel_Drums,
                    streicher: n.MidiInstrument.String_Ensemble_1,
                    strings: n.MidiInstrument.String_Ensemble_1,
                    tenor: n.MidiInstrument.Synth_Voice,
                    tpt: n.MidiInstrument.Trumpet,
                    trombone: n.MidiInstrument.Trombone,
                    trompete: n.MidiInstrument.Trumpet,
                    trumpet: n.MidiInstrument.Trumpet,
                    tuba: n.MidiInstrument.Tuba,
                    unnamed: n.MidiInstrument.Acoustic_Grand_Piano,
                    viola: n.MidiInstrument.Viola,
                    violin: n.MidiInstrument.Violin,
                    "violon-c": n.MidiInstrument.Cello,
                    "violon.": n.MidiInstrument.Violin,
                    voice: n.MidiInstrument.Synth_Voice,
                    woodblock: n.MidiInstrument.Woodblock
                };
            },
            4236 (t, e) {
                "use strict";
                var i;
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.ArpeggioType = e.Arpeggio = void 0, e.Arpeggio = class {
                    constructor(t, e = i.ARPEGGIO_DIRECTIONLESS){
                        this.parentVoiceEntry = t, this.type = e, this.notes = [];
                    }
                    addNote(t) {
                        this.notes.push(t), t.Arpeggio = this;
                    }
                }, function(t) {
                    t[t.BRUSH_DOWN = 1] = "BRUSH_DOWN", t[t.BRUSH_UP = 2] = "BRUSH_UP", t[t.ROLL_DOWN = 3] = "ROLL_DOWN", t[t.ROLL_UP = 4] = "ROLL_UP", t[t.RASQUEDO_DOWN = 5] = "RASQUEDO_DOWN", t[t.RASQUEDO_UP = 6] = "RASQUEDO_UP", t[t.ARPEGGIO_DIRECTIONLESS = 7] = "ARPEGGIO_DIRECTIONLESS";
                }(i || (e.ArpeggioType = i = {}));
            },
            9003 (t, e) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.Articulation = void 0, e.Articulation = class {
                    constructor(t, e){
                        this.articulationEnum = t, this.placement = e;
                    }
                    Equals(t) {
                        return t.articulationEnum === this.articulationEnum && t.placement === this.placement;
                    }
                };
            },
            8365 (t, e) {
                "use strict";
                var i;
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.BeamEnum = e.Beam = void 0, e.Beam = class {
                    constructor(t = 1, e = 0){
                        this.notes = [], this.extendedNoteList = [], this.BeamNumberOffsetToXML = 0, this.AutoGenerated = !1, this.SecondaryBreakIndices = [], this.BeamNumber = t, this.BeamNumberOffsetToXML = e;
                    }
                    get Notes() {
                        return this.notes;
                    }
                    set Notes(t) {
                        this.notes = t;
                    }
                    get ExtendedNoteList() {
                        return this.extendedNoteList;
                    }
                    set ExtendedNoteList(t) {
                        this.extendedNoteList = t;
                    }
                    addNoteToBeam(t) {
                        t && (t.NoteBeam = this, this.notes.push(t), this.extendedNoteList.push(t));
                    }
                }, function(t) {
                    t[t.BeamNone = -1] = "BeamNone", t[t.BeamBegin = 0] = "BeamBegin", t[t.BeamContinue = 1] = "BeamContinue", t[t.BeamEnd = 2] = "BeamEnd", t[t.BeamForward = 3] = "BeamForward", t[t.BeamBackward = 4] = "BeamBackward";
                }(i || (e.BeamEnum = i = {}));
            },
            9719 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.ChordSymbolEnum = e.ChordDegreeText = e.CustomChord = e.Degree = e.ChordSymbolContainer = void 0;
                const s = i(8233), n = i(7921), r = i(8233), o = i(6362);
                e.ChordSymbolContainer = class {
                    constructor(t, e, i, s, n, r = o.PlacementEnum.Above){
                        this.rootPitch = t, this.chordKind = e, this.bassPitch = i, this.degrees = s, this.rules = n, this.Placement = r;
                    }
                    get RootPitch() {
                        return this.rootPitch;
                    }
                    get ChordKind() {
                        return this.chordKind;
                    }
                    get BassPitch() {
                        return this.bassPitch;
                    }
                    get ChordDegrees() {
                        return this.degrees;
                    }
                    static calculateChordText(t, e, i) {
                        if (void 0 !== t.NumeralText) return t.NumeralText;
                        let o = t.RootPitch;
                        if (n.MusicSheetCalculator.transposeCalculator && (o = n.MusicSheetCalculator.transposeCalculator.transposePitch(t.RootPitch, i, e, !0)), t.ChordKind === h.none) return t.getTextFromChordKindEnum(t.ChordKind);
                        let a = s.Pitch.getNoteEnumString(o.FundamentalNote);
                        o.Accidental !== r.AccidentalEnum.NONE && (a += t.getTextForAccidental(o.Accidental));
                        const c = {
                            adds: [],
                            alts: [],
                            subs: []
                        };
                        for (const e of t.ChordDegrees)if (e) {
                            let i = "";
                            switch(e.alteration !== r.AccidentalEnum.NONE && (i += t.getTextForAccidental(e.alteration)), i += e.value, e.text){
                                case l.add:
                                    c.adds.push(i);
                                    break;
                                case l.alter:
                                    c.alts.push(i);
                                    break;
                                case l.subtract:
                                    c.subs.push(i);
                            }
                        }
                        let u = t.getTextFromChordKindEnum(t.ChordKind);
                        const d = [
                            "adds",
                            "alts",
                            "subs"
                        ], f = t.rules.CustomChords;
                        for (const e of f){
                            if (e.chordKind !== t.chordKind) continue;
                            let i = !0;
                            for (const t of d){
                                for (const s of e.degrees[t] || [])if (c[t].indexOf(s) < 0) {
                                    i = !1;
                                    break;
                                }
                                if (!i) break;
                            }
                            if (i) {
                                for (const t of d)for (const i of e.degrees[t] || [])c[t].splice(c[t].indexOf(i), 1);
                                u = e.alternateName;
                            }
                        }
                        if (a += u, c.adds.length > 0 && (a += "(" + c.adds.join(",") + ")"), c.alts.length > 0 && (a += "(alt " + c.alts.join(",") + ")"), c.subs.length > 0 && (a += "(omit " + c.subs.join(",") + ")"), t.BassPitch) {
                            let r = t.BassPitch;
                            n.MusicSheetCalculator.transposeCalculator && (r = n.MusicSheetCalculator.transposeCalculator.transposePitch(t.BassPitch, i, e, !0)), a += "/", a += s.Pitch.getNoteEnumString(r.FundamentalNote), a += t.getTextForAccidental(r.Accidental);
                        }
                        return a;
                    }
                    getTextForAccidental(t) {
                        const e = this.rules.ChordAccidentalTexts.getValue(t);
                        return void 0 !== e ? e : "";
                    }
                    getTextFromChordKindEnum(t) {
                        return this.rules.ChordSymbolLabelTexts.getValue(t) ?? "";
                    }
                }, e.Degree = class {
                    constructor(t, e, i){
                        this.value = t, this.alteration = e, this.text = i;
                    }
                };
                class a {
                    constructor(t, e, i){
                        this.alternateName = t, this.chordKind = e, this.degrees = i;
                    }
                    static createCustomChord(t, e, i) {
                        return new a(t, e, i);
                    }
                    static renameCustomChord(t, e, i) {
                        for (const s of i)s.alternateName === t && (s.alternateName = e);
                    }
                }
                var l, h;
                e.CustomChord = a, function(t) {
                    t[t.add = 0] = "add", t[t.alter = 1] = "alter", t[t.subtract = 2] = "subtract";
                }(l || (e.ChordDegreeText = l = {})), function(t) {
                    t[t.major = 0] = "major", t[t.minor = 1] = "minor", t[t.augmented = 2] = "augmented", t[t.diminished = 3] = "diminished", t[t.dominant = 4] = "dominant", t[t.majorseventh = 5] = "majorseventh", t[t.minorseventh = 6] = "minorseventh", t[t.diminishedseventh = 7] = "diminishedseventh", t[t.augmentedseventh = 8] = "augmentedseventh", t[t.halfdiminished = 9] = "halfdiminished", t[t.majorminor = 10] = "majorminor", t[t.majorsixth = 11] = "majorsixth", t[t.minorsixth = 12] = "minorsixth", t[t.dominantninth = 13] = "dominantninth", t[t.majorninth = 14] = "majorninth", t[t.minorninth = 15] = "minorninth", t[t.dominant11th = 16] = "dominant11th", t[t.major11th = 17] = "major11th", t[t.minor11th = 18] = "minor11th", t[t.dominant13th = 19] = "dominant13th", t[t.major13th = 20] = "major13th", t[t.minor13th = 21] = "minor13th", t[t.suspendedsecond = 22] = "suspendedsecond", t[t.suspendedfourth = 23] = "suspendedfourth", t[t.Neapolitan = 24] = "Neapolitan", t[t.Italian = 25] = "Italian", t[t.French = 26] = "French", t[t.German = 27] = "German", t[t.pedal = 28] = "pedal", t[t.power = 29] = "power", t[t.Tristan = 30] = "Tristan", t[t.none = 31] = "none";
                }(h || (e.ChordSymbolEnum = h = {}));
            },
            6362 (t, e) {
                "use strict";
                var i;
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.PlacementEnum = e.AbstractExpression = void 0, e.AbstractExpression = class {
                    constructor(t){
                        this.placement = t;
                    }
                    static isStringInStringList(t, e) {
                        for(let i = 0, s = t.length; i < s; ++i){
                            const s = t[i];
                            if (e.toLowerCase() === s.toLowerCase().trim()) return !0;
                        }
                        return !1;
                    }
                    get Placement() {
                        return this.placement;
                    }
                    static PlacementEnumFromString(t) {
                        switch(t.toLowerCase()){
                            case "above":
                                return i.Above;
                            case "below":
                                return i.Below;
                            case "aboveorbelow":
                            case "abovebelow":
                                return i.AboveOrBelow;
                            case "left":
                                return i.Left;
                            case "right":
                                return i.Right;
                            default:
                                return i.NotYetDefined;
                        }
                    }
                }, function(t) {
                    t[t.Above = 0] = "Above", t[t.Below = 1] = "Below", t[t.Left = 2] = "Left", t[t.Right = 3] = "Right", t[t.NotYetDefined = 4] = "NotYetDefined", t[t.AboveOrBelow = 5] = "AboveOrBelow";
                }(i || (e.PlacementEnum = i = {}));
            },
            9147 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.AbstractTempoExpression = void 0;
                const s = i(6362);
                class n extends s.AbstractExpression {
                    constructor(t, e, i, s){
                        super(e), this.label = t, this.staffNumber = i, this.parentMultiTempoExpression = s;
                    }
                    get Label() {
                        return this.label;
                    }
                    set Label(t) {
                        this.label = t;
                    }
                    get Placement() {
                        return this.placement;
                    }
                    set Placement(t) {
                        this.placement = t;
                    }
                    get StaffNumber() {
                        return this.staffNumber;
                    }
                    set StaffNumber(t) {
                        this.staffNumber = t;
                    }
                    get ParentMultiTempoExpression() {
                        return this.parentMultiTempoExpression;
                    }
                    static isStringInStringList(t, e) {
                        for (const i of t)if (n.stringContainsSeparatedWord(e.toLowerCase().trim(), i.toLowerCase().trim())) return !0;
                        return !1;
                    }
                    static stringContainsSeparatedWord(t, e) {
                        return t === e || -1 !== t.indexOf(" " + e) || -1 !== t.indexOf(e + " ");
                    }
                }
                e.AbstractTempoExpression = n;
            },
            5875 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.ContDynamicEnum = e.ContinuousDynamicExpression = void 0;
                const s = i(6362), n = i(2561);
                class r extends s.AbstractExpression {
                    constructor(t, e, i, s, n, r = ""){
                        super(e), this.parentMeasure = s, this.NumberXml = n, this.dynamicType = t, this.label = r, this.staffNumber = i, this.startVolume = -1, this.endVolume = -1, "" !== r && this.setType();
                    }
                    get DynamicType() {
                        return this.dynamicType;
                    }
                    set DynamicType(t) {
                        this.dynamicType = t;
                    }
                    get StartMultiExpression() {
                        return this.startMultiExpression;
                    }
                    set StartMultiExpression(t) {
                        this.startMultiExpression = t;
                    }
                    get EndMultiExpression() {
                        return this.endMultiExpression;
                    }
                    set EndMultiExpression(t) {
                        this.endMultiExpression = t;
                    }
                    get Placement() {
                        return this.placement;
                    }
                    set Placement(t) {
                        this.placement = t;
                    }
                    get StartVolume() {
                        return this.startVolume;
                    }
                    set StartVolume(t) {
                        this.startVolume = t;
                    }
                    get EndVolume() {
                        return this.endVolume;
                    }
                    set EndVolume(t) {
                        this.endVolume = t;
                    }
                    get StaffNumber() {
                        return this.staffNumber;
                    }
                    set StaffNumber(t) {
                        this.staffNumber = t;
                    }
                    get Label() {
                        return this.label;
                    }
                    set Label(t) {
                        this.label = t, this.setType();
                    }
                    static isInputStringContinuousDynamic(t) {
                        return !!t && (r.isStringInStringList(r.listContinuousDynamicIncreasing, t) || r.isStringInStringList(r.listContinuousDynamicDecreasing, t));
                    }
                    getInterpolatedDynamic(t) {
                        const e = this.StartMultiExpression.AbsolutePlaybackTimestamp;
                        let i;
                        if (i = this.EndMultiExpression ? this.EndMultiExpression.AbsolutePlaybackTimestamp : n.Fraction.plus(this.startMultiExpression.SourceMeasureParent.AbsoluteTimestamp, this.startMultiExpression.SourceMeasureParent.Duration), t.lt(e)) return -1;
                        if (i.lt(t)) return -2;
                        const s = n.Fraction.minus(t, e).RealValue / n.Fraction.minus(i, e).RealValue;
                        return Math.max(0, Math.min(99.9, this.startVolume + (this.endVolume - this.startVolume) * s));
                    }
                    isWedge() {
                        return !this.label;
                    }
                    setType() {
                        r.isStringInStringList(r.listContinuousDynamicIncreasing, this.label) ? this.dynamicType = o.crescendo : r.isStringInStringList(r.listContinuousDynamicDecreasing, this.label) && (this.dynamicType = o.diminuendo);
                    }
                }
                var o;
                e.ContinuousDynamicExpression = r, r.listContinuousDynamicIncreasing = [
                    "crescendo",
                    "cresc",
                    "cresc.",
                    "cres."
                ], r.listContinuousDynamicDecreasing = [
                    "decrescendo",
                    "decresc",
                    "decr.",
                    "diminuendo",
                    "dim.",
                    "dim"
                ], function(t) {
                    t[t.crescendo = 0] = "crescendo", t[t.diminuendo = 1] = "diminuendo";
                }(o || (e.ContDynamicEnum = o = {}));
            },
            2221 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.ContinuousTempoType = e.ContinuousTempoExpression = void 0;
                const s = i(2561), n = i(9147);
                class r extends n.AbstractTempoExpression {
                    constructor(t, e, i, s){
                        super(t, e, i, s), this.setTempoType();
                    }
                    static isInputStringContinuousTempo(t) {
                        return !!t && (t.endsWith(".") && (t = t.substring(0, t.length - 1)), r.isStringInStringList(r.listContinuousTempoFaster, t) || r.isStringInStringList(r.listContinuousTempoSlower, t));
                    }
                    static isIncreasingTempo(t) {
                        return t <= o.piuMosso;
                    }
                    static isDecreasingTempo(t) {
                        return t >= o.allargando && t <= o.ritenuto;
                    }
                    get TempoType() {
                        return this.tempoType;
                    }
                    set TempoType(t) {
                        this.tempoType = t;
                    }
                    get StartTempo() {
                        return this.startTempo;
                    }
                    set StartTempo(t) {
                        this.startTempo = t;
                    }
                    get EndTempo() {
                        return this.endTempo;
                    }
                    set EndTempo(t) {
                        this.endTempo = t;
                    }
                    get AbsoluteStartTimestamp() {
                        return s.Fraction.plus(this.parentMultiTempoExpression.SourceMeasureParent.AbsoluteTimestamp, this.parentMultiTempoExpression.Timestamp);
                    }
                    get AbsoluteEndTimestamp() {
                        return this.absoluteEndTimestamp;
                    }
                    set AbsoluteEndTimestamp(t) {
                        this.absoluteEndTimestamp = t, this.AbsoluteTimeSpan = s.Fraction.minus(this.AbsoluteEndTimestamp, this.AbsoluteStartTimestamp).RealValue;
                    }
                    get AbsoluteTimestamp() {
                        return this.ParentMultiTempoExpression.AbsoluteTimestamp;
                    }
                    getAbsoluteFloatTimestamp() {
                        return this.ParentMultiTempoExpression.AbsoluteTimestamp.RealValue;
                    }
                    getInterpolatedTempo(t) {
                        const e = s.Fraction.plus(this.parentMultiTempoExpression.SourceMeasureParent.AbsoluteTimestamp, this.parentMultiTempoExpression.Timestamp);
                        if (t.lt(e)) return -1;
                        if (this.absoluteEndTimestamp.lt(t)) return -2;
                        const i = s.Fraction.minus(t, e).RealValue / s.Fraction.minus(this.absoluteEndTimestamp, e).RealValue;
                        return Math.max(0, Math.min(250, this.startTempo + (this.endTempo - this.startTempo) * i));
                    }
                    setTempoType() {
                        r.isStringInStringList(r.listContinuousTempoFaster, this.label) ? this.tempoType = o.accelerando : r.isStringInStringList(r.listContinuousTempoSlower, this.label) && (this.tempoType = o.ritardando);
                    }
                    getTempoFactor(t = this.Label) {
                        return 1;
                    }
                }
                var o;
                e.ContinuousTempoExpression = r, r.listContinuousTempoFaster = [
                    "accelerando",
                    "accel",
                    "piu mosso",
                    "poco piu",
                    "stretto"
                ], r.listContinuousTempoSlower = [
                    "poco meno",
                    "meno mosso",
                    "piu lento",
                    "calando",
                    "allargando",
                    "rallentando",
                    "ritardando",
                    "ritenuto",
                    "ritard.",
                    "ritard",
                    "rit.",
                    "rit",
                    "riten.",
                    "riten"
                ], function(t) {
                    t[t.accelerando = 0] = "accelerando", t[t.stretto = 1] = "stretto", t[t.stringendo = 2] = "stringendo", t[t.mosso = 3] = "mosso", t[t.piuMosso = 4] = "piuMosso", t[t.allargando = 5] = "allargando", t[t.calando = 6] = "calando", t[t.menoMosso = 7] = "menoMosso", t[t.rallentando = 8] = "rallentando", t[t.ritardando = 9] = "ritardando", t[t.ritard = 10] = "ritard", t[t.rit = 11] = "rit", t[t.ritenuto = 12] = "ritenuto", t[t.rubato = 13] = "rubato", t[t.precipitando = 14] = "precipitando";
                }(o || (e.ContinuousTempoType = o = {}));
            },
            437 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.OctaveEnum = e.OctaveShift = void 0;
                const s = i(8233);
                var n;
                e.OctaveShift = class {
                    constructor(t, e){
                        this.numberXml = 1, this.endVoiceEntryIndex = 0, this.setOctaveShiftValue(t, e);
                    }
                    get Type() {
                        return this.octaveValue;
                    }
                    set Type(t) {
                        this.octaveValue = t;
                    }
                    get StaffNumber() {
                        return this.staffNumber;
                    }
                    set StaffNumber(t) {
                        this.staffNumber = t;
                    }
                    get ParentStartMultiExpression() {
                        return this.startMultiExpression;
                    }
                    set ParentStartMultiExpression(t) {
                        this.startMultiExpression = t;
                    }
                    get ParentEndMultiExpression() {
                        return this.endMultiExpression;
                    }
                    set ParentEndMultiExpression(t) {
                        this.endMultiExpression = t;
                    }
                    setOctaveShiftValue(t, e) {
                        this.octaveValue = 1 === e && "down" === t ? n.VA8 : 1 === e && "up" === t ? n.VB8 : 2 === e && "down" === t ? n.MA15 : 2 === e && "up" === t ? n.MB15 : n.NONE;
                    }
                    static getPitchFromOctaveShift(t, e) {
                        if (!t) return;
                        if (t.OctaveShiftApplied) return t;
                        let i = t.Octave;
                        switch(e){
                            case n.VA8:
                                i -= 1;
                                break;
                            case n.VB8:
                                i += 1;
                                break;
                            case n.MA15:
                                i -= 2;
                                break;
                            case n.MB15:
                                i += 2;
                                break;
                            case n.NONE:
                            default:
                                i += 0;
                        }
                        const r = new s.Pitch(t.FundamentalNote, i, t.Accidental);
                        return r.OctaveShiftApplied = !0, r;
                    }
                }, function(t) {
                    t[t.VA8 = 0] = "VA8", t[t.VB8 = 1] = "VB8", t[t.MA15 = 2] = "MA15", t[t.MB15 = 3] = "MB15", t[t.NONE = 4] = "NONE";
                }(n || (e.OctaveEnum = n = {}));
            },
            3253 (t, e) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.Pedal = void 0, e.Pedal = class {
                    constructor(t = !1, e = !0){
                        this.ChangeEnd = !1, this.ChangeBegin = !1, this.EndsStave = !1, this.BeginsStave = !1, this.line = t, this.sign = e;
                    }
                    get IsLine() {
                        return this.line;
                    }
                    get IsSign() {
                        return this.sign;
                    }
                };
            },
            6229 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.Slur = void 0;
                const s = i(2561);
                e.Slur = class {
                    constructor(){
                        this.HasUnattachedEnd = !1;
                    }
                    get StartNote() {
                        return this.startNote;
                    }
                    set StartNote(t) {
                        this.startNote = t;
                    }
                    get EndNote() {
                        return this.endNote;
                    }
                    set EndNote(t) {
                        this.endNote = t;
                    }
                    startNoteHasMoreStartingSlurs() {
                        if (!this.startNote) return !1;
                        for(let t = 0, e = this.startNote.NoteSlurs.length; t < e; ++t){
                            const e = this.startNote.NoteSlurs[t];
                            if (e !== this && e.StartNote === this.startNote) return !0;
                        }
                        return !1;
                    }
                    endNoteHasMoreEndingSlurs() {
                        if (!this.endNote) return !1;
                        for(let t = 0, e = this.endNote.NoteSlurs.length; t < e; ++t){
                            const e = this.endNote.NoteSlurs[t];
                            if (e !== this && e.EndNote === this.endNote) return !0;
                        }
                        return !1;
                    }
                    isCrossed() {
                        return !!this.endNote && this.startNote.ParentStaffEntry.ParentStaff !== this.endNote.ParentStaffEntry.ParentStaff;
                    }
                    isSlurLonger() {
                        if (!this.endNote || !this.startNote) return !1;
                        const t = s.Fraction.minus(this.endNote.getAbsoluteTimestamp(), this.startNote.getAbsoluteTimestamp());
                        for(let e = 0, i = this.startNote.NoteSlurs.length; e < i; ++e){
                            const i = this.startNote.NoteSlurs[e];
                            if (i !== this && void 0 !== i.EndNote && void 0 !== i.StartNote && -1 === s.Fraction.minus(i.EndNote.getAbsoluteTimestamp(), i.StartNote.getAbsoluteTimestamp()).CompareTo(t)) return !0;
                        }
                        for(let e = 0, i = this.endNote.NoteSlurs.length; e < i; ++e){
                            const i = this.endNote.NoteSlurs[e];
                            if (i !== this && void 0 !== i.EndNote && void 0 !== i.StartNote && s.Fraction.minus(i.EndNote.getAbsoluteTimestamp(), i.StartNote.getAbsoluteTimestamp()).CompareTo(t)) return !0;
                        }
                        return !1;
                    }
                };
            },
            6206 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.WavyLine = void 0;
                const s = i(6362);
                class n extends s.AbstractExpression {
                    constructor(t){
                        super(t);
                    }
                }
                e.WavyLine = n;
            },
            8045 (t, e, i) {
                "use strict";
                var s = this && this.__createBinding || (Object.create ? function(t, e, i, s) {
                    void 0 === s && (s = i);
                    var n = Object.getOwnPropertyDescriptor(e, i);
                    n && !("get" in n ? !e.__esModule : n.writable || n.configurable) || (n = {
                        enumerable: !0,
                        get: function() {
                            return e[i];
                        }
                    }), Object.defineProperty(t, s, n);
                } : function(t, e, i, s) {
                    void 0 === s && (s = i), t[s] = e[i];
                }), n = this && this.__exportStar || function(t, e) {
                    for(var i in t)"default" === i || Object.prototype.hasOwnProperty.call(e, i) || s(e, t, i);
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), n(i(5875), e), n(i(2221), e), n(i(437), e), n(i(6229), e);
            },
            6990 (t, e) {
                "use strict";
                var i;
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.DynamicExpressionSymbolEnum = void 0, function(t) {
                    t[t.p = 0] = "p", t[t.f = 1] = "f", t[t.s = 2] = "s", t[t.z = 3] = "z", t[t.m = 4] = "m", t[t.r = 5] = "r";
                }(i || (e.DynamicExpressionSymbolEnum = i = {}));
            },
            2148 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.DynamicEnum = e.InstantaneousDynamicExpression = void 0;
                const n = i(6362), r = i(6990), o = i(7307), a = s(i(3065)), l = i(3263);
                class h extends n.AbstractExpression {
                    static staticConstructor() {
                        h.dynamicToRelativeVolumeDict.setValue(c.ffffff, 1), h.dynamicToRelativeVolumeDict.setValue(c.fffff, 126 / 127), h.dynamicToRelativeVolumeDict.setValue(c.ffff, 125 / 127), h.dynamicToRelativeVolumeDict.setValue(c.fff, 124 / 127), h.dynamicToRelativeVolumeDict.setValue(c.ff, 122 / 127), h.dynamicToRelativeVolumeDict.setValue(c.f, 108 / 127), h.dynamicToRelativeVolumeDict.setValue(c.mf, 76 / 127), h.dynamicToRelativeVolumeDict.setValue(c.sf, .5), h.dynamicToRelativeVolumeDict.setValue(c.sfp, .5), h.dynamicToRelativeVolumeDict.setValue(c.sfpp, .5), h.dynamicToRelativeVolumeDict.setValue(c.fp, .5), h.dynamicToRelativeVolumeDict.setValue(c.rf, .5), h.dynamicToRelativeVolumeDict.setValue(c.rfz, .5), h.dynamicToRelativeVolumeDict.setValue(c.sfz, .5), h.dynamicToRelativeVolumeDict.setValue(c.sffz, .5), h.dynamicToRelativeVolumeDict.setValue(c.fz, .5), h.dynamicToRelativeVolumeDict.setValue(c.sfzp, .5), h.dynamicToRelativeVolumeDict.setValue(c.pf, 92 / 127), h.dynamicToRelativeVolumeDict.setValue(c.mp, 60 / 127), h.dynamicToRelativeVolumeDict.setValue(c.p, 28 / 127), h.dynamicToRelativeVolumeDict.setValue(c.pp, 12 / 127), h.dynamicToRelativeVolumeDict.setValue(c.ppp, 10 / 127), h.dynamicToRelativeVolumeDict.setValue(c.pppp, 7 / 127), h.dynamicToRelativeVolumeDict.setValue(c.ppppp, 5 / 127), h.dynamicToRelativeVolumeDict.setValue(c.pppppp, 4 / 127), h.dynamicToRelativeVolumeDict.setValue(c.n, 0);
                    }
                    constructor(t, e, i, s, n, r){
                        super(i), this.parentMeasure = n, this.dynamicExpression = t, this.dynamicEnum = r ?? h.dynamicEnumFromText(t), this.soundDynamic = e, this.staffNumber = s;
                    }
                    get ParentMultiExpression() {
                        return this.multiExpression;
                    }
                    set ParentMultiExpression(t) {
                        this.multiExpression = t;
                    }
                    get DynamicExpression() {
                        return this.dynamicExpression;
                    }
                    set DynamicExpression(t) {
                        this.dynamicExpression = t;
                    }
                    get DynEnum() {
                        return this.dynamicEnum;
                    }
                    set DynEnum(t) {
                        this.dynamicEnum = t;
                    }
                    get SoundDynamic() {
                        return this.soundDynamic;
                    }
                    set SoundDynamic(t) {
                        this.soundDynamic = t;
                    }
                    get Placement() {
                        return this.placement;
                    }
                    set Placement(t) {
                        this.placement = t;
                    }
                    get StaffNumber() {
                        return this.staffNumber;
                    }
                    set StaffNumber(t) {
                        this.staffNumber = t;
                    }
                    get Length() {
                        return Math.abs(this.length) < 1e-4 && (this.length = this.calculateLength()), this.length;
                    }
                    get MidiVolume() {
                        return 127 * this.Volume;
                    }
                    get Volume() {
                        return h.dynamicToRelativeVolumeDict.getValue(this.dynamicEnum);
                    }
                    static isInputStringInstantaneousDynamic(t) {
                        return !!t && h.isStringInStringList(h.listInstantaneousDynamics, t);
                    }
                    static dynamicEnumFromText(t) {
                        const e = t?.trim().toLowerCase();
                        if (!e) return;
                        h.knownDynamicNames || (h.knownDynamicNames = Object.keys(c).filter((t)=>isNaN(Number(t)) && "other" !== t).sort((t, e)=>e.length - t.length));
                        const i = h.knownDynamicNames.find((t)=>e.startsWith(t));
                        if (!i) return;
                        const s = e.substring(i.length), n = /^[pfmsrzn]+$/.test(e);
                        return 0 === s.length || n || !/^[a-zà-ÿ]/.test(s) ? c[i] : void 0;
                    }
                    getDynamicExpressionSymbol(t) {
                        switch(t){
                            case "p":
                                return r.DynamicExpressionSymbolEnum.p;
                            case "f":
                                return r.DynamicExpressionSymbolEnum.f;
                            case "s":
                                return r.DynamicExpressionSymbolEnum.s;
                            case "z":
                                return r.DynamicExpressionSymbolEnum.z;
                            case "m":
                                return r.DynamicExpressionSymbolEnum.m;
                            case "r":
                                return r.DynamicExpressionSymbolEnum.r;
                            default:
                                throw new o.InvalidEnumArgumentException("unknown DynamicExpressionSymbolEnum: " + t);
                        }
                    }
                    calculateLength() {
                        return a.default.debug("[Andrea] instantaneousDynamicExpression: not implemented: calculateLength!"), 0;
                    }
                }
                var c;
                e.InstantaneousDynamicExpression = h, h.dynamicToRelativeVolumeDict = new l.Dictionary, h.listInstantaneousDynamics = [
                    "pppppp",
                    "ppppp",
                    "pppp",
                    "ppp",
                    "pp",
                    "p",
                    "ffffff",
                    "fffff",
                    "ffff",
                    "fff",
                    "ff",
                    "f",
                    "mf",
                    "mp",
                    "sf",
                    "sff",
                    "sp",
                    "spp",
                    "fp",
                    "rf",
                    "rfz",
                    "sfz",
                    "sffz",
                    "fz",
                    "pf",
                    "sfzp",
                    "n"
                ], function(t) {
                    t[t.pppppp = 0] = "pppppp", t[t.ppppp = 1] = "ppppp", t[t.pppp = 2] = "pppp", t[t.ppp = 3] = "ppp", t[t.pp = 4] = "pp", t[t.p = 5] = "p", t[t.mp = 6] = "mp", t[t.mf = 7] = "mf", t[t.f = 8] = "f", t[t.ff = 9] = "ff", t[t.fff = 10] = "fff", t[t.ffff = 11] = "ffff", t[t.fffff = 12] = "fffff", t[t.ffffff = 13] = "ffffff", t[t.sf = 14] = "sf", t[t.sff = 15] = "sff", t[t.sfp = 16] = "sfp", t[t.sfpp = 17] = "sfpp", t[t.fp = 18] = "fp", t[t.rf = 19] = "rf", t[t.rfz = 20] = "rfz", t[t.sfz = 21] = "sfz", t[t.sffz = 22] = "sffz", t[t.fz = 23] = "fz", t[t.other = 24] = "other", t[t.pf = 25] = "pf", t[t.sfzp = 26] = "sfzp", t[t.n = 27] = "n";
                }(c || (e.DynamicEnum = c = {})), h.staticConstructor();
            },
            9161 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.ChangeSubType = e.InstTempo = e.TempoType = e.InstantaneousTempoExpression = void 0;
                const s = i(9147), n = i(2561), r = i(5282);
                class o extends s.AbstractTempoExpression {
                    constructor(t, e, i, s, n, r = !1){
                        super(t, e, i, n), this.printObject = !0, this.parentMeasure = n.SourceMeasureParent, this.isMetronomeMark = r, this.setTempoAndTempoType(s);
                    }
                    static getDefaultValueForInstTempo(t) {
                        switch(t){
                            case l.larghissimo:
                                return 20;
                            case l.grave:
                                return 30;
                            case l.lento:
                                return 48;
                            case l.largo:
                                return 52;
                            case l.larghetto:
                                return 63;
                            case l.adagio:
                                return 70;
                            case l.adagietto:
                                return 75;
                            case l.andanteModerato:
                                return 88;
                            case l.andante:
                                return 92;
                            case l.andantino:
                                return 96;
                            case l.moderato:
                                return 106;
                            case l.allegretto:
                                return 112;
                            case l.allegroModerato:
                                return 118;
                            case l.allegro:
                                return 130;
                            case l.vivace:
                                return 140;
                            case l.vivacissimo:
                                return 155;
                            case l.allegrissimo:
                                return 170;
                            case l.presto:
                                return 184;
                            case l.prestissimo:
                                return 200;
                            default:
                                return 60;
                        }
                    }
                    getNoteEquationTempoFactor() {
                        const t = o.getMetronomeNoteGroupLength(this.metronomeNoteGroupLeft), e = o.getMetronomeNoteGroupLength(this.metronomeNoteGroupRight);
                        return t?.RealValue > 0 && e?.RealValue > 0 ? new n.Fraction(e.GetExpandedNumerator() * t.Denominator, e.Denominator * t.GetExpandedNumerator()) : new n.Fraction(1, 1);
                    }
                    static getMetronomeNoteGroupLength(t) {
                        if (!t?.notes?.length) return;
                        let e = new n.Fraction(0, 1);
                        for (const i of t.notes){
                            let t;
                            try {
                                t = r.NoteTypeHandler.getNoteDurationFromType(i.type);
                            } catch  {
                                return;
                            }
                            const s = new n.Fraction(Math.pow(2, i.dots + 1) - 1, Math.pow(2, i.dots));
                            e = n.Fraction.plus(e, n.Fraction.multiply(t, s));
                        }
                        return t.tuplet?.actualNotes > 0 && t.tuplet.normalNotes > 0 && (e = n.Fraction.multiply(e, new n.Fraction(t.tuplet.normalNotes, t.tuplet.actualNotes))), e;
                    }
                    static isInputStringInstantaneousTempo(t) {
                        return !!t && (o.isStringInStringList(o.listInstantaneousTempoLarghissimo, t) || o.isStringInStringList(o.listInstantaneousTempoGrave, t) || o.isStringInStringList(o.listInstantaneousTempoLento, t) || o.isStringInStringList(o.listInstantaneousTempoLargo, t) || o.isStringInStringList(o.listInstantaneousTempoLarghetto, t) || o.isStringInStringList(o.listInstantaneousTempoAdagio, t) || o.isStringInStringList(o.listInstantaneousTempoAdagietto, t) || o.isStringInStringList(o.listInstantaneousTempoAndanteModerato, t) || o.isStringInStringList(o.listInstantaneousTempoAndante, t) || o.isStringInStringList(o.listInstantaneousTempoAndantino, t) || o.isStringInStringList(o.listInstantaneousTempoModerato, t) || o.isStringInStringList(o.listInstantaneousTempoAllegretto, t) || o.isStringInStringList(o.listInstantaneousTempoAllegroModerato, t) || o.isStringInStringList(o.listInstantaneousTempoAllegro, t) || o.isStringInStringList(o.listInstantaneousTempoVivace, t) || o.isStringInStringList(o.listInstantaneousTempoVivacissimo, t) || o.isStringInStringList(o.listInstantaneousTempoAllegrissimo, t) || o.isStringInStringList(o.listInstantaneousTempoPresto, t) || o.isStringInStringList(o.listInstantaneousTempoPrestissimo, t) || o.isStringInStringList(o.listInstantaneousTempoChangesGeneral, t));
                    }
                    get Label() {
                        return this.label;
                    }
                    set Label(t) {
                        this.label = t;
                    }
                    get Placement() {
                        return this.placement;
                    }
                    set Placement(t) {
                        this.placement = t;
                    }
                    get StaffNumber() {
                        return this.staffNumber;
                    }
                    set StaffNumber(t) {
                        this.staffNumber = t;
                    }
                    get TempoInBpm() {
                        return this.tempoInBpm;
                    }
                    set TempoInBpm(t) {
                        this.tempoInBpm = t;
                    }
                    get ParentMultiTempoExpression() {
                        return this.parentMultiTempoExpression;
                    }
                    getAbsoluteTimestamp() {
                        return n.Fraction.plus(this.ParentMultiTempoExpression.SourceMeasureParent.AbsoluteTimestamp, this.ParentMultiTempoExpression.Timestamp);
                    }
                    getAbsoluteFloatTimestamp() {
                        return n.Fraction.plus(this.ParentMultiTempoExpression.SourceMeasureParent.AbsoluteTimestamp, this.ParentMultiTempoExpression.Timestamp).RealValue;
                    }
                    setTempoAndTempoType(t) {
                        if (!this.label) return this.tempoInBpm = t, void (this.TempoType = a.metronomeMark);
                        o.isStringInStringList(o.listInstantaneousTempoLarghissimo, this.label) ? (0 === t && (t = o.getDefaultValueForInstTempo(l.larghissimo)), this.tempoInBpm = t, this.InstTempo = l.larghissimo, this.TempoType = a.inst) : o.isStringInStringList(o.listInstantaneousTempoGrave, this.label) ? (0 === t && (t = o.getDefaultValueForInstTempo(l.grave)), this.tempoInBpm = t, this.InstTempo = l.grave, this.TempoType = a.inst) : o.isStringInStringList(o.listInstantaneousTempoLento, this.label) ? (0 === t && (t = o.getDefaultValueForInstTempo(l.lento)), this.tempoInBpm = t, this.InstTempo = l.lento, this.TempoType = a.inst) : o.isStringInStringList(o.listInstantaneousTempoLargo, this.label) ? (0 === t && (t = o.getDefaultValueForInstTempo(l.largo)), this.tempoInBpm = t, this.InstTempo = l.largo, this.TempoType = a.inst) : o.isStringInStringList(o.listInstantaneousTempoLarghetto, this.label) ? (0 === t && (t = o.getDefaultValueForInstTempo(l.larghetto)), this.tempoInBpm = t, this.InstTempo = l.larghetto, this.TempoType = a.inst) : o.isStringInStringList(o.listInstantaneousTempoAdagio, this.label) ? (0 === t && (t = o.getDefaultValueForInstTempo(l.adagio)), this.tempoInBpm = t, this.InstTempo = l.adagio, this.TempoType = a.inst) : o.isStringInStringList(o.listInstantaneousTempoAdagietto, this.label) ? (0 === t && (t = o.getDefaultValueForInstTempo(l.adagietto)), this.tempoInBpm = t, this.InstTempo = l.adagietto, this.TempoType = a.inst) : o.isStringInStringList(o.listInstantaneousTempoAndanteModerato, this.label) ? (0 === t && (t = o.getDefaultValueForInstTempo(l.andanteModerato)), this.tempoInBpm = t, this.InstTempo = l.andanteModerato, this.TempoType = a.inst) : o.isStringInStringList(o.listInstantaneousTempoAndante, this.label) ? (0 === t && (t = o.getDefaultValueForInstTempo(l.andante)), this.tempoInBpm = t, this.InstTempo = l.andante, this.TempoType = a.inst) : o.isStringInStringList(o.listInstantaneousTempoAndantino, this.label) ? (0 === t && (t = o.getDefaultValueForInstTempo(l.andantino)), this.tempoInBpm = t, this.InstTempo = l.andantino, this.TempoType = a.inst) : o.isStringInStringList(o.listInstantaneousTempoModerato, this.label) ? (0 === t && (t = o.getDefaultValueForInstTempo(l.moderato)), this.tempoInBpm = t, this.InstTempo = l.moderato, this.TempoType = a.inst) : o.isStringInStringList(o.listInstantaneousTempoAllegretto, this.label) ? (0 === t && (t = o.getDefaultValueForInstTempo(l.allegretto)), this.tempoInBpm = t, this.InstTempo = l.allegretto, this.TempoType = a.inst) : o.isStringInStringList(o.listInstantaneousTempoAllegroModerato, this.label) ? (0 === t && (t = o.getDefaultValueForInstTempo(l.allegroModerato)), this.tempoInBpm = t, this.InstTempo = l.allegroModerato, this.TempoType = a.inst) : o.isStringInStringList(o.listInstantaneousTempoAllegro, this.label) ? (0 === t && (t = o.getDefaultValueForInstTempo(l.allegro)), this.tempoInBpm = t, this.InstTempo = l.allegro, this.TempoType = a.inst) : o.isStringInStringList(o.listInstantaneousTempoVivace, this.label) ? (0 === t && (t = o.getDefaultValueForInstTempo(l.vivace)), this.tempoInBpm = t, this.InstTempo = l.vivace, this.TempoType = a.inst) : o.isStringInStringList(o.listInstantaneousTempoVivacissimo, this.label) ? (0 === t && (t = o.getDefaultValueForInstTempo(l.vivacissimo)), this.tempoInBpm = t, this.InstTempo = l.vivacissimo, this.TempoType = a.inst) : o.isStringInStringList(o.listInstantaneousTempoAllegrissimo, this.label) ? (0 === t && (t = o.getDefaultValueForInstTempo(l.allegrissimo)), this.tempoInBpm = t, this.InstTempo = l.allegrissimo, this.TempoType = a.inst) : o.isStringInStringList(o.listInstantaneousTempoPresto, this.label) ? (0 === t && (t = o.getDefaultValueForInstTempo(l.presto)), this.tempoInBpm = t, this.InstTempo = l.presto, this.TempoType = a.inst) : o.isStringInStringList(o.listInstantaneousTempoPrestissimo, this.label) ? (0 === t && (t = o.getDefaultValueForInstTempo(l.prestissimo)), this.tempoInBpm = t, this.InstTempo = l.prestissimo, this.TempoType = a.inst) : o.isStringInStringList(o.listInstantaneousTempoAddons, this.label) ? (this.tempoInBpm = 0, this.TempoType = a.addon) : o.isStringInStringList(o.listInstantaneousTempoChangesGeneral, this.label) && (this.tempoInBpm = 0, this.TempoType = a.change);
                    }
                }
                var a, l, h;
                e.InstantaneousTempoExpression = o, o.listInstantaneousTempoLarghissimo = [
                    "Larghissimo",
                    "Sehr breit",
                    "very, very slow"
                ], o.listInstantaneousTempoGrave = [
                    "Grave",
                    "Schwer",
                    "slow and solemn"
                ], o.listInstantaneousTempoLento = [
                    "Lento",
                    "Lent",
                    "Langsam",
                    "slowly"
                ], o.listInstantaneousTempoLargo = [
                    "Largo",
                    "Breit",
                    "broadly"
                ], o.listInstantaneousTempoLarghetto = [
                    "Larghetto",
                    "Etwas breit",
                    "rather broadly"
                ], o.listInstantaneousTempoAdagio = [
                    "Adagio",
                    "Langsam",
                    "Ruhig",
                    "slow and stately"
                ], o.listInstantaneousTempoAdagietto = [
                    "Adagietto",
                    "Ziemlich ruhig",
                    "Ziemlich langsam",
                    "rather slow"
                ], o.listInstantaneousTempoAndanteModerato = [
                    "Andante moderato"
                ], o.listInstantaneousTempoAndante = [
                    "Andante",
                    "Gehend",
                    "Schreitend",
                    "at a walking pace"
                ], o.listInstantaneousTempoAndantino = [
                    "Andantino",
                    "Maestoso"
                ], o.listInstantaneousTempoModerato = [
                    "Moderato",
                    "M\xe4\xdfig",
                    "Mod\xe9r\xe9",
                    "moderately"
                ], o.listInstantaneousTempoAllegretto = [
                    "Allegretto",
                    "Animato",
                    "fast"
                ], o.listInstantaneousTempoAllegroModerato = [
                    "Allegro moderato"
                ], o.listInstantaneousTempoAllegro = [
                    "Allegro",
                    "Rapide",
                    "Vite",
                    "Rasch",
                    "Schnell",
                    "Fr\xf6hlich"
                ], o.listInstantaneousTempoVivace = [
                    "Vivace",
                    "Allegro Assai",
                    "Lebhaft",
                    "Lebendig",
                    "lively and fast"
                ], o.listInstantaneousTempoVivacissimo = [
                    "Vivacissimo",
                    "Sehr lebhaft",
                    "Sehr lebendig"
                ], o.listInstantaneousTempoAllegrissimo = [
                    "Allegrissimo",
                    "very fast"
                ], o.listInstantaneousTempoPresto = [
                    "Presto",
                    "Sehr schnell",
                    "Geschwind"
                ], o.listInstantaneousTempoPrestissimo = [
                    "Prestissimo",
                    "\xe4u\xdferst schnell"
                ], o.listInstantaneousTempoChangesGeneral = [
                    "tempo primo",
                    "a tempo",
                    "tempo i",
                    "rubato",
                    "doppio movimento",
                    "rallentando",
                    "ritardando",
                    "ritard.",
                    "rit.",
                    "ritard",
                    "rall...",
                    "accelerando",
                    "accel"
                ], o.listInstantaneousTempoAddons = [
                    "assai",
                    "amoroso",
                    "cantabile",
                    "con brio",
                    "con dolore",
                    "con espressione",
                    "con fuoco",
                    "con moto",
                    "con spirito",
                    "spiritoso",
                    "espressivo",
                    "giocoso",
                    "giusto",
                    "grazioso",
                    "lesto",
                    "lugubre",
                    "maestoso",
                    "ma non troppo",
                    "marcato",
                    "molto",
                    "morendo",
                    "mosso",
                    "non tanto",
                    "piu",
                    "un poco",
                    "poco",
                    "quasi",
                    "risoluto",
                    "scherzando",
                    "sostenuto",
                    "teneramente",
                    "tempo giusto",
                    "tranquillo",
                    "sehr",
                    "lieblich",
                    "liebevoll",
                    "mit Leidenschaft",
                    "mit Liebe",
                    "amour\xf6s",
                    "gesanglich",
                    "mit Schwung",
                    "mit Feuer",
                    "mit Schmerz",
                    "mit Ausdruck",
                    "mit Bewegung",
                    "geistvoll",
                    "ausdrucksvoll",
                    "freudig",
                    "verspielt",
                    "angemessen",
                    "grazi\xf6s",
                    "mit Grazie",
                    "flink",
                    "beh\xe4nde",
                    "traurig",
                    "klagend",
                    "majest\xe4tisch",
                    "aber nicht zu sehr",
                    "markant",
                    "gem\xe4\xdfigt",
                    "viel",
                    "sehr",
                    "ersterbend",
                    "bewegt",
                    "nicht zu sehr",
                    "mehr",
                    "ein wenig",
                    "gleichsam",
                    "entschlossen",
                    "zupackend",
                    "heiter",
                    "nachdr\xfccklich",
                    "getragen",
                    "gewichtig",
                    "zart",
                    "z\xe4rtlich",
                    "im angemessenen Zeitma\xdf",
                    "ruhig",
                    "ein wenig",
                    "alla marcia",
                    "ad libitum",
                    "alla breve"
                ], function(t) {
                    t[t.none = 0] = "none", t[t.metronomeMark = 1] = "metronomeMark", t[t.inst = 2] = "inst", t[t.change = 3] = "change", t[t.addon = 4] = "addon";
                }(a || (e.TempoType = a = {})), function(t) {
                    t[t.larghissimo = 0] = "larghissimo", t[t.grave = 1] = "grave", t[t.lento = 2] = "lento", t[t.largo = 3] = "largo", t[t.larghetto = 4] = "larghetto", t[t.adagio = 5] = "adagio", t[t.adagietto = 6] = "adagietto", t[t.andanteModerato = 7] = "andanteModerato", t[t.andante = 8] = "andante", t[t.andantino = 9] = "andantino", t[t.moderato = 10] = "moderato", t[t.allegretto = 11] = "allegretto", t[t.allegroModerato = 12] = "allegroModerato", t[t.allegro = 13] = "allegro", t[t.vivace = 14] = "vivace", t[t.vivacissimo = 15] = "vivacissimo", t[t.allegrissimo = 16] = "allegrissimo", t[t.presto = 17] = "presto", t[t.prestissimo = 18] = "prestissimo", t[t.lastRealTempo = 19] = "lastRealTempo";
                }(l || (e.InstTempo = l = {})), function(t) {
                    t[t.none = 0] = "none", t[t.atempo = 1] = "atempo", t[t.doppioMovimento = 2] = "doppioMovimento", t[t.tempoprimo = 3] = "tempoprimo";
                }(h || (e.ChangeSubType = h = {}));
            },
            9803 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.MoodEnum = e.MoodExpression = void 0;
                const s = i(6362);
                class n extends s.AbstractExpression {
                    constructor(t, e, i){
                        super(e), this.label = t, this.staffNumber = i, this.setMoodType();
                    }
                    static isInputStringMood(t) {
                        return !!t && (n.isStringInStringList(n.listMoodAffettuoso, t) || n.isStringInStringList(n.listMoodAgitato, t) || n.isStringInStringList(n.listMoodAnimato, t) || n.isStringInStringList(n.listMoodAppassionato, t) || n.isStringInStringList(n.listMoodBrillante, t) || n.isStringInStringList(n.listMoodCantabile, t) || n.isStringInStringList(n.listMoodDolce, t) || n.isStringInStringList(n.listMoodEnergico, t) || n.isStringInStringList(n.listMoodEroico, t) || n.isStringInStringList(n.listMoodEspressivo, t) || n.isStringInStringList(n.listMoodFurioso, t) || n.isStringInStringList(n.listMoodGiocoso, t) || n.isStringInStringList(n.listMoodGioioso, t) || n.isStringInStringList(n.listMoodGrandioso, t) || n.isStringInStringList(n.listMoodGrazioso, t) || n.isStringInStringList(n.listMoodLacrimoso, t) || n.isStringInStringList(n.listMoodLeggiero, t) || n.isStringInStringList(n.listMoodMaestoso, t) || n.isStringInStringList(n.listMoodMalinconico, t) || n.isStringInStringList(n.listMoodMarcato, t) || n.isStringInStringList(n.listMoodMarziale, t) || n.isStringInStringList(n.listMoodMesto, t) || n.isStringInStringList(n.listMoodMorendo, t) || n.isStringInStringList(n.listMoodNobilmente, t) || n.isStringInStringList(n.listMoodPatetico, t) || n.isStringInStringList(n.listMoodPesante, t) || n.isStringInStringList(n.listMoodSaltando, t) || n.isStringInStringList(n.listMoodSautille, t) || n.isStringInStringList(n.listMoodScherzando, t) || n.isStringInStringList(n.listMoodSostenuto, t) || n.isStringInStringList(n.listMoodSpiccato, t) || n.isStringInStringList(n.listMoodTenerezza, t) || n.isStringInStringList(n.listMoodTranquillamente, t) || n.isStringInStringList(n.listMoodTrionfante, t));
                    }
                    get Label() {
                        return this.label;
                    }
                    set Label(t) {
                        this.label = t;
                    }
                    get Mood() {
                        return this.moodType;
                    }
                    set Mood(t) {
                        this.moodType = t;
                    }
                    get StaffNumber() {
                        return this.staffNumber;
                    }
                    set StaffNumber(t) {
                        this.staffNumber = t;
                    }
                    get Placement() {
                        return this.placement;
                    }
                    set Placement(t) {
                        this.placement = t;
                    }
                    setMoodType() {
                        n.isStringInStringList(n.listMoodAffettuoso, this.label) ? this.moodType = r.Affettuoso : n.isStringInStringList(n.listMoodAgitato, this.label) ? this.moodType = r.Agitato : n.isStringInStringList(n.listMoodAnimato, this.label) ? this.moodType = r.Animato : n.isStringInStringList(n.listMoodAppassionato, this.label) ? this.moodType = r.Appassionato : n.isStringInStringList(n.listMoodBrillante, this.label) ? this.moodType = r.Brillante : n.isStringInStringList(n.listMoodCantabile, this.label) ? this.moodType = r.Cantabile : n.isStringInStringList(n.listMoodDolce, this.label) ? this.moodType = r.Dolce : n.isStringInStringList(n.listMoodEnergico, this.label) ? this.moodType = r.Energico : n.isStringInStringList(n.listMoodEroico, this.label) ? this.moodType = r.Eroico : n.isStringInStringList(n.listMoodEspressivo, this.label) ? this.moodType = r.Espressivo : n.isStringInStringList(n.listMoodFurioso, this.label) ? this.moodType = r.Furioso : n.isStringInStringList(n.listMoodGiocoso, this.label) ? this.moodType = r.Giocoso : n.isStringInStringList(n.listMoodGioioso, this.label) ? this.moodType = r.Gioioso : n.isStringInStringList(n.listMoodGrandioso, this.label) ? this.moodType = r.Grandioso : n.isStringInStringList(n.listMoodGrazioso, this.label) ? this.moodType = r.Grazioso : n.isStringInStringList(n.listMoodLacrimoso, this.label) ? this.moodType = r.Lacrimoso : n.isStringInStringList(n.listMoodLeggiero, this.label) ? this.moodType = r.Leggiero : n.isStringInStringList(n.listMoodMaestoso, this.label) ? this.moodType = r.Maestoso : n.isStringInStringList(n.listMoodMalinconico, this.label) ? this.moodType = r.Malinconico : n.isStringInStringList(n.listMoodMarcato, this.label) ? this.moodType = r.Marcato : n.isStringInStringList(n.listMoodMarziale, this.label) ? this.moodType = r.Marziale : n.isStringInStringList(n.listMoodMesto, this.label) ? this.moodType = r.Mesto : n.isStringInStringList(n.listMoodMorendo, this.label) ? this.moodType = r.Morendo : n.isStringInStringList(n.listMoodNobilmente, this.label) ? this.moodType = r.Nobilmente : n.isStringInStringList(n.listMoodPatetico, this.label) ? this.moodType = r.Patetico : n.isStringInStringList(n.listMoodPesante, this.label) ? this.moodType = r.Pesante : n.isStringInStringList(n.listMoodSaltando, this.label) ? this.moodType = r.Saltando : n.isStringInStringList(n.listMoodSautille, this.label) ? this.moodType = r.Sautille : n.isStringInStringList(n.listMoodScherzando, this.label) ? this.moodType = r.Scherzando : n.isStringInStringList(n.listMoodSostenuto, this.label) ? this.moodType = r.Sostenuto : n.isStringInStringList(n.listMoodSpiccato, this.label) ? this.moodType = r.Spiccato : n.isStringInStringList(n.listMoodTenerezza, this.label) ? this.moodType = r.Tenerezza : n.isStringInStringList(n.listMoodTranquillamente, this.label) ? this.moodType = r.Tranquillamente : n.isStringInStringList(n.listMoodTrionfante, this.label) && (this.moodType = r.Trionfante);
                    }
                }
                var r;
                e.MoodExpression = n, n.listMoodAffettuoso = [
                    "affettuoso"
                ], n.listMoodAgitato = [
                    "agitato"
                ], n.listMoodAppassionato = [
                    "appassionato"
                ], n.listMoodAnimato = [
                    "animato",
                    "lively"
                ], n.listMoodBrillante = [
                    "brillante"
                ], n.listMoodCantabile = [
                    "cantabile"
                ], n.listMoodDolce = [
                    "dolce"
                ], n.listMoodEnergico = [
                    "energico"
                ], n.listMoodEroico = [
                    "eroico"
                ], n.listMoodEspressivo = [
                    "espressivo"
                ], n.listMoodFurioso = [
                    "furioso"
                ], n.listMoodGiocoso = [
                    "giocoso"
                ], n.listMoodGioioso = [
                    "gioioso"
                ], n.listMoodLacrimoso = [
                    "lacrimoso"
                ], n.listMoodGrandioso = [
                    "grandioso"
                ], n.listMoodGrazioso = [
                    "grazioso"
                ], n.listMoodLeggiero = [
                    "leggiero"
                ], n.listMoodMaestoso = [
                    "maestoso"
                ], n.listMoodMalinconico = [
                    "malinconico"
                ], n.listMoodMarcato = [
                    "marcato"
                ], n.listMoodMarziale = [
                    "marziale"
                ], n.listMoodMesto = [
                    "mesto"
                ], n.listMoodMorendo = [
                    "morendo"
                ], n.listMoodNobilmente = [
                    "nobilmente"
                ], n.listMoodPatetico = [
                    "patetico"
                ], n.listMoodPesante = [
                    "pesante"
                ], n.listMoodSautille = [
                    "sautille"
                ], n.listMoodSaltando = [
                    "saltando"
                ], n.listMoodScherzando = [
                    "scherzando"
                ], n.listMoodSostenuto = [
                    "sostenuto"
                ], n.listMoodSpiccato = [
                    "spiccato"
                ], n.listMoodTenerezza = [
                    "tenerezza"
                ], n.listMoodTranquillamente = [
                    "tranquillamente"
                ], n.listMoodTrionfante = [
                    "trionfante"
                ], function(t) {
                    t[t.Affettuoso = 0] = "Affettuoso", t[t.Agitato = 1] = "Agitato", t[t.Appassionato = 2] = "Appassionato", t[t.Animato = 3] = "Animato", t[t.Brillante = 4] = "Brillante", t[t.Cantabile = 5] = "Cantabile", t[t.Dolce = 6] = "Dolce", t[t.Energico = 7] = "Energico", t[t.Eroico = 8] = "Eroico", t[t.Espressivo = 9] = "Espressivo", t[t.Furioso = 10] = "Furioso", t[t.Giocoso = 11] = "Giocoso", t[t.Gioioso = 12] = "Gioioso", t[t.Lacrimoso = 13] = "Lacrimoso", t[t.Grandioso = 14] = "Grandioso", t[t.Grazioso = 15] = "Grazioso", t[t.Leggiero = 16] = "Leggiero", t[t.Maestoso = 17] = "Maestoso", t[t.Malinconico = 18] = "Malinconico", t[t.Marcato = 19] = "Marcato", t[t.Marziale = 20] = "Marziale", t[t.Mesto = 21] = "Mesto", t[t.Morendo = 22] = "Morendo", t[t.Nobilmente = 23] = "Nobilmente", t[t.Patetico = 24] = "Patetico", t[t.Pesante = 25] = "Pesante", t[t.Sautille = 26] = "Sautille", t[t.Saltando = 27] = "Saltando", t[t.Scherzando = 28] = "Scherzando", t[t.Sostenuto = 29] = "Sostenuto", t[t.Spiccato = 30] = "Spiccato", t[t.Tenerezza = 31] = "Tenerezza", t[t.Tranquillamente = 32] = "Tranquillamente", t[t.Trionfante = 33] = "Trionfante", t[t.Vivace = 34] = "Vivace";
                }(r || (e.MoodEnum = r = {}));
            },
            9019 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.MultiExpressionEntry = e.MultiExpression = void 0;
                const s = i(2561), n = i(2148), r = i(5875), o = i(9803), a = i(1112), l = i(6362), h = i(2570);
                e.MultiExpression = class {
                    constructor(t, e){
                        this.unknownList = [], this.moodList = [], this.expressions = [], this.sourceMeasure = t, this.timestamp = e;
                    }
                    get SourceMeasureParent() {
                        return this.sourceMeasure;
                    }
                    set SourceMeasureParent(t) {
                        this.sourceMeasure = t;
                    }
                    get StaffNumber() {
                        return this.staffNumber;
                    }
                    set StaffNumber(t) {
                        this.staffNumber = t;
                    }
                    get Timestamp() {
                        return this.timestamp;
                    }
                    set Timestamp(t) {
                        this.timestamp = t;
                    }
                    get AbsoluteTimestamp() {
                        return s.Fraction.plus(this.timestamp, this.sourceMeasure.AbsoluteTimestamp);
                    }
                    get AbsolutePlaybackTimestamp() {
                        return s.Fraction.plus(this.PlaybackTimestamp ?? this.timestamp, this.sourceMeasure.AbsoluteTimestamp);
                    }
                    get InstantaneousDynamic() {
                        return this.instantaneousDynamic;
                    }
                    set InstantaneousDynamic(t) {
                        this.instantaneousDynamic = t;
                    }
                    get EndingContinuousDynamic() {
                        return this.endingContinuousDynamic;
                    }
                    set EndingContinuousDynamic(t) {
                        this.endingContinuousDynamic = t;
                    }
                    get StartingContinuousDynamic() {
                        return this.startingContinuousDynamic;
                    }
                    set StartingContinuousDynamic(t) {
                        this.startingContinuousDynamic = t;
                    }
                    get MoodList() {
                        return this.moodList;
                    }
                    get UnknownList() {
                        return this.unknownList;
                    }
                    get EntriesList() {
                        return this.expressions;
                    }
                    get OctaveShiftStart() {
                        return this.octaveShiftStart;
                    }
                    set OctaveShiftStart(t) {
                        this.octaveShiftStart = t;
                    }
                    get OctaveShiftEnd() {
                        return this.octaveShiftEnd;
                    }
                    set OctaveShiftEnd(t) {
                        this.octaveShiftEnd = t;
                    }
                    get CombinedExpressionsText() {
                        return this.combinedExpressionsText;
                    }
                    set CombinedExpressionsText(t) {
                        this.combinedExpressionsText = t;
                    }
                    getPlacementOfFirstEntry() {
                        let t = l.PlacementEnum.Above;
                        return this.expressions.length > 0 && (this.expressions[0].expression instanceof n.InstantaneousDynamicExpression || this.expressions[0].expression instanceof r.ContinuousDynamicExpression || this.expressions[0].expression instanceof o.MoodExpression || this.expressions[0].expression instanceof a.UnknownExpression) && (t = this.expressions[0].expression.Placement), t;
                    }
                    getFontstyleOfFirstEntry() {
                        let t = h.FontStyles.Regular;
                        return this.expressions.length > 0 && (this.expressions[0].expression instanceof r.ContinuousDynamicExpression || this.expressions[0].expression instanceof o.MoodExpression ? t = h.FontStyles.Italic : this.expressions[0].expression instanceof a.UnknownExpression && (t = this.expressions[0].expression.fontStyle ?? h.FontStyles.Regular)), t;
                    }
                    getColorXMLOfFirstEntry() {
                        let t;
                        return this.expressions.length >= 1 && (t = this.expressions[0].expression.ColorXML), t;
                    }
                    addExpression(t, e) {
                        t instanceof n.InstantaneousDynamicExpression ? (this.instantaneousDynamic && this.removeExpressionFromEntryList(this.InstantaneousDynamic), this.instantaneousDynamic = t, this.instantaneousDynamic.ParentMultiExpression = this) : t instanceof r.ContinuousDynamicExpression ? this.startingContinuousDynamic = t : t instanceof o.MoodExpression ? this.moodList.push(t) : t instanceof a.UnknownExpression && this.unknownList.push(t), this.addExpressionToEntryList(t, e);
                    }
                    CompareTo(t) {
                        return this.Timestamp.RealValue > t.Timestamp.RealValue ? 1 : this.Timestamp.RealValue < t.Timestamp.RealValue ? -1 : 0;
                    }
                    addExpressionToEntryList(t, e) {
                        const i = new c;
                        i.prefix = e, i.expression = t, t instanceof r.ContinuousDynamicExpression || t instanceof o.MoodExpression || t instanceof a.UnknownExpression ? i.label = t.Label : i.label = "", this.expressions.push(i);
                    }
                    removeExpressionFromEntryList(t) {
                        for(let e = 0, i = this.expressions.length; e < i; ++e)if (this.expressions[e].expression === t) {
                            this.expressions.splice(e, 1);
                            break;
                        }
                    }
                };
                class c {
                }
                e.MultiExpressionEntry = c;
            },
            5332 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.TempoExpressionEntry = e.MultiTempoExpression = void 0;
                const s = i(2561), n = i(9161), r = i(6362), o = i(2570), a = i(2221);
                e.MultiTempoExpression = class {
                    constructor(t, e){
                        this.expressions = [], this.sourceMeasure = t, this.timestamp = e;
                    }
                    get Timestamp() {
                        return this.timestamp;
                    }
                    get AbsoluteTimestamp() {
                        return s.Fraction.plus(this.sourceMeasure.AbsoluteTimestamp, this.timestamp);
                    }
                    get AbsolutePlaybackTimestamp() {
                        return s.Fraction.plus(this.sourceMeasure.AbsoluteTimestamp, this.PlaybackTimestamp ?? this.timestamp);
                    }
                    get SourceMeasureParent() {
                        return this.sourceMeasure;
                    }
                    set SourceMeasureParent(t) {
                        this.sourceMeasure = t;
                    }
                    get InstantaneousTempo() {
                        return this.instantaneousTempo;
                    }
                    get ContinuousTempo() {
                        return this.continuousTempo;
                    }
                    get EntriesList() {
                        return this.expressions;
                    }
                    get CombinedExpressionsText() {
                        return this.combinedExpressionsText;
                    }
                    set CombinedExpressionsText(t) {
                        this.combinedExpressionsText = t;
                    }
                    getPlacementOfFirstEntry() {
                        let t = r.PlacementEnum.Above;
                        return this.expressions.length > 0 && (this.expressions[0].Expression instanceof n.InstantaneousTempoExpression || this.expressions[0].Expression instanceof a.ContinuousTempoExpression) && (t = this.expressions[0].Expression.Placement), t;
                    }
                    getFontstyleOfFirstEntry() {
                        let t = o.FontStyles.Regular;
                        return this.expressions[0].Expression instanceof n.InstantaneousTempoExpression ? t = o.FontStyles.Bold : this.expressions[0].Expression instanceof a.ContinuousTempoExpression && (t = o.FontStyles.Italic), t;
                    }
                    addExpression(t, e) {
                        if (this.checkIfAlreadyExists(t)) return;
                        t instanceof n.InstantaneousTempoExpression ? this.instantaneousTempo = t : t instanceof a.ContinuousTempoExpression && (this.continuousTempo = t);
                        const i = new l;
                        i.prefix = e, i.Expression = t, i.label = t.Label, this.expressions.push(i);
                    }
                    CompareTo(t) {
                        return this.Timestamp.RealValue > t.Timestamp.RealValue ? 1 : this.Timestamp.RealValue < t.Timestamp.RealValue ? -1 : 0;
                    }
                    checkIfAlreadyExists(t) {
                        for (const e of this.expressions)if (e.label === t.Label) return !0;
                        return !1;
                    }
                    clearInstantaneousTempo() {
                        this.instantaneousTempo = void 0;
                    }
                    clearContinuousTempo() {
                        this.continuousTempo = void 0;
                    }
                };
                class l {
                    get Expression() {
                        return this.expression;
                    }
                    set Expression(t) {
                        this.expression = t;
                    }
                }
                e.TempoExpressionEntry = l;
            },
            9157 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.RehearsalExpression = void 0;
                const s = i(6362);
                class n extends s.AbstractExpression {
                    constructor(t, e){
                        super(e), this.label = t;
                    }
                }
                e.RehearsalExpression = n;
            },
            1112 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.UnknownExpression = void 0;
                const s = i(6362), n = i(7533);
                class r extends s.AbstractExpression {
                    constructor(t, e, i, s){
                        super(e), this.label = t, this.staffNumber = s, void 0 === i && (i = n.TextAlignmentEnum.LeftBottom), this.textAlignment = i;
                    }
                    get Label() {
                        return this.label;
                    }
                    get Placement() {
                        return this.placement;
                    }
                    set Placement(t) {
                        this.placement = t;
                    }
                    get StaffNumber() {
                        return this.staffNumber;
                    }
                    set StaffNumber(t) {
                        this.staffNumber = t;
                    }
                    get TextAlignment() {
                        return this.textAlignment;
                    }
                }
                e.UnknownExpression = r;
            },
            4980 (t, e, i) {
                "use strict";
                var s = this && this.__createBinding || (Object.create ? function(t, e, i, s) {
                    void 0 === s && (s = i);
                    var n = Object.getOwnPropertyDescriptor(e, i);
                    n && !("get" in n ? !e.__esModule : n.writable || n.configurable) || (n = {
                        enumerable: !0,
                        get: function() {
                            return e[i];
                        }
                    }), Object.defineProperty(t, s, n);
                } : function(t, e, i, s) {
                    void 0 === s && (s = i), t[s] = e[i];
                }), n = this && this.__exportStar || function(t, e) {
                    for(var i in t)"default" === i || Object.prototype.hasOwnProperty.call(e, i) || s(e, t, i);
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), n(i(6362), e), n(i(9147), e), n(i(6990), e), n(i(2148), e), n(i(9161), e), n(i(9803), e), n(i(9019), e), n(i(5332), e), n(i(9157), e), n(i(1112), e);
            },
            7718 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.Glissando = void 0;
                const s = i(2561), n = i(6438);
                e.Glissando = class {
                    constructor(t){
                        this.notes = [], this.XMLNumber = 1, this.AddNote(t), this.StartNote = t, this.Direction = n.ColDirEnum.NotYetDefined;
                    }
                    get Notes() {
                        return this.notes;
                    }
                    get Duration() {
                        const t = new s.Fraction;
                        for (const e of this.notes)t.Add(e.Length);
                        return t;
                    }
                    get Pitch() {
                        return this.StartNote.Pitch;
                    }
                    AddNote(t) {
                        this.notes.push(t), t.NoteGlissando = this, 2 === this.notes.length && (this.notes[0].Pitch.getHalfTone() < this.notes[1].Pitch.getHalfTone() ? this.Direction = n.ColDirEnum.Up : this.Direction = n.ColDirEnum.Down);
                    }
                };
            },
            1110 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.DynamicsContainer = void 0;
                const s = i(5875), n = i(2148);
                e.DynamicsContainer = class {
                    constructor(t, e){
                        t instanceof s.ContinuousDynamicExpression ? this.continuousDynamicExpression = t : t instanceof n.InstantaneousDynamicExpression && (this.instantaneousDynamicExpression = t), this.staffNumber = e;
                    }
                    static Compare(t, e) {
                        return t.parMultiExpression().AbsolutePlaybackTimestamp.CompareTo(e.parMultiExpression().AbsolutePlaybackTimestamp);
                    }
                    parMultiExpression() {
                        return this.continuousDynamicExpression ? this.continuousDynamicExpression.StartMultiExpression : this.instantaneousDynamicExpression ? this.instantaneousDynamicExpression.ParentMultiExpression : void 0;
                    }
                };
            },
            5364 (t, e) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.AbstractNotationInstruction = void 0, e.AbstractNotationInstruction = class {
                    constructor(t){
                        this.printObject = !0, this.parent = t;
                    }
                    get Parent() {
                        return this.parent;
                    }
                    set Parent(t) {
                        this.parent = t;
                    }
                    get PrintObject() {
                        return this.printObject;
                    }
                    set PrintObject(t) {
                        this.printObject = t;
                    }
                };
            },
            164 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.MidiInstrument = e.ClefEnum = e.ClefInstruction = void 0;
                const s = i(8233), n = i(5364), r = i(8233), o = i(8233), a = i(7307);
                class l extends n.AbstractNotationInstruction {
                    constructor(t = h.G, e = 0, i = 2){
                        super(void 0), this.clefType = h.G, this.line = 2, this.octaveOffset = 0, this.line = i, this.clefType = t, this.octaveOffset = e, this.calcParameters();
                    }
                    static getDefaultClefFromMidiInstrument(t) {
                        switch(t){
                            case c.Acoustic_Grand_Piano:
                            case c.Electric_Bass_finger:
                            case c.Electric_Bass_pick:
                            case c.Fretless_Bass:
                            case c.Slap_Bass_1:
                            case c.Slap_Bass_2:
                            case c.Synth_Bass_1:
                            case c.Synth_Bass_2:
                            case c.Contrabass:
                                return new l(h.F, 0, 4);
                            default:
                                return new l(h.G, 0, 2);
                        }
                    }
                    static getAllPossibleClefs() {
                        const t = [];
                        for(let e = 0; e <= 2; e++){
                            const i = new l(h.G, e, 2);
                            t.push(i);
                        }
                        for(let e = -2; e <= 0; e++){
                            const i = new l(h.F, e, 4);
                            t.push(i);
                        }
                        return t;
                    }
                    static isSupportedClef(t) {
                        switch(t){
                            case h.G:
                            case h.F:
                            case h.C:
                            case h.percussion:
                            case h.TAB:
                                return !0;
                            default:
                                return !1;
                        }
                    }
                    get ClefType() {
                        return this.clefType;
                    }
                    set ClefType(t) {
                        this.clefType = t;
                    }
                    get Line() {
                        return this.line;
                    }
                    set Line(t) {
                        this.line = t;
                    }
                    get OctaveOffset() {
                        return this.octaveOffset;
                    }
                    set OctaveOffset(t) {
                        this.octaveOffset = t;
                    }
                    get ClefPitch() {
                        return this.clefPitch;
                    }
                    set ClefPitch(t) {
                        this.clefPitch = t;
                    }
                    get ReferenceCyPosition() {
                        return this.referenceCyPosition;
                    }
                    set ReferenceCyPosition(t) {
                        this.referenceCyPosition = t;
                    }
                    Equals(t) {
                        return this === t || !(!this || !t) && this.clefPitch === t.clefPitch && this.Line === t.Line;
                    }
                    NotEqual(t) {
                        return !this.Equals(t);
                    }
                    ToString() {
                        return "ClefType: " + this.clefType;
                    }
                    calcParameters() {
                        switch(this.clefType){
                            case h.G:
                                this.clefPitch = new s.Pitch(r.NoteEnum.G, 1 + this.octaveOffset, o.AccidentalEnum.NONE), this.referenceCyPosition = 5 - this.line + 2;
                                break;
                            case h.F:
                                this.clefPitch = new s.Pitch(r.NoteEnum.F, 0 + this.octaveOffset, o.AccidentalEnum.NONE), this.referenceCyPosition = 5 - this.line + 1.5;
                                break;
                            case h.C:
                                this.clefPitch = new s.Pitch(r.NoteEnum.C, 1 + this.octaveOffset, o.AccidentalEnum.NONE), this.referenceCyPosition = 5 - this.line;
                                break;
                            case h.percussion:
                                this.clefPitch = new s.Pitch(r.NoteEnum.C, 2, o.AccidentalEnum.NONE), this.referenceCyPosition = 2;
                                break;
                            case h.TAB:
                                this.clefPitch = new s.Pitch(r.NoteEnum.G, 0, o.AccidentalEnum.NONE), this.referenceCyPosition = 0;
                                break;
                            default:
                                throw new a.ArgumentOutOfRangeException("clefType");
                        }
                    }
                }
                var h, c;
                e.ClefInstruction = l, function(t) {
                    t[t.G = 0] = "G", t[t.F = 1] = "F", t[t.C = 2] = "C", t[t.percussion = 3] = "percussion", t[t.TAB = 4] = "TAB";
                }(h || (e.ClefEnum = h = {})), function(t) {
                    t[t.None = -1] = "None", t[t.Acoustic_Grand_Piano = 0] = "Acoustic_Grand_Piano", t[t.Bright_Acoustic_Piano = 1] = "Bright_Acoustic_Piano", t[t.Electric_Grand_Piano = 2] = "Electric_Grand_Piano", t[t.Honky_tonk_Piano = 3] = "Honky_tonk_Piano", t[t.Electric_Piano_1 = 4] = "Electric_Piano_1", t[t.Electric_Piano_2 = 5] = "Electric_Piano_2", t[t.Harpsichord = 6] = "Harpsichord", t[t.Clavinet = 7] = "Clavinet", t[t.Celesta = 8] = "Celesta", t[t.Glockenspiel = 9] = "Glockenspiel", t[t.Music_Box = 10] = "Music_Box", t[t.Vibraphone = 11] = "Vibraphone", t[t.Marimba = 12] = "Marimba", t[t.Xylophone = 13] = "Xylophone", t[t.Tubular_Bells = 14] = "Tubular_Bells", t[t.Dulcimer = 15] = "Dulcimer", t[t.Drawbar_Organ = 16] = "Drawbar_Organ", t[t.Percussive_Organ = 17] = "Percussive_Organ", t[t.Rock_Organ = 18] = "Rock_Organ", t[t.Church_Organ = 19] = "Church_Organ", t[t.Reed_Organ = 20] = "Reed_Organ", t[t.Accordion = 21] = "Accordion", t[t.Harmonica = 22] = "Harmonica", t[t.Tango_Accordion = 23] = "Tango_Accordion", t[t.Acoustic_Guitar_nylon = 24] = "Acoustic_Guitar_nylon", t[t.Acoustic_Guitar_steel = 25] = "Acoustic_Guitar_steel", t[t.Electric_Guitar_jazz = 26] = "Electric_Guitar_jazz", t[t.Electric_Guitar_clean = 27] = "Electric_Guitar_clean", t[t.Electric_Guitar_muted = 28] = "Electric_Guitar_muted", t[t.Overdriven_Guitar = 29] = "Overdriven_Guitar", t[t.Distortion_Guitar = 30] = "Distortion_Guitar", t[t.Guitar_harmonics = 31] = "Guitar_harmonics", t[t.Acoustic_Bass = 32] = "Acoustic_Bass", t[t.Electric_Bass_finger = 33] = "Electric_Bass_finger", t[t.Electric_Bass_pick = 34] = "Electric_Bass_pick", t[t.Fretless_Bass = 35] = "Fretless_Bass", t[t.Slap_Bass_1 = 36] = "Slap_Bass_1", t[t.Slap_Bass_2 = 37] = "Slap_Bass_2", t[t.Synth_Bass_1 = 38] = "Synth_Bass_1", t[t.Synth_Bass_2 = 39] = "Synth_Bass_2", t[t.Violin = 40] = "Violin", t[t.Viola = 41] = "Viola", t[t.Cello = 42] = "Cello", t[t.Contrabass = 43] = "Contrabass", t[t.Tremolo_Strings = 44] = "Tremolo_Strings", t[t.Pizzicato_Strings = 45] = "Pizzicato_Strings", t[t.Orchestral_Harp = 46] = "Orchestral_Harp", t[t.Timpani = 47] = "Timpani", t[t.String_Ensemble_1 = 48] = "String_Ensemble_1", t[t.String_Ensemble_2 = 49] = "String_Ensemble_2", t[t.Synth_Strings_1 = 50] = "Synth_Strings_1", t[t.Synth_Strings_2 = 51] = "Synth_Strings_2", t[t.Choir_Aahs = 52] = "Choir_Aahs", t[t.Voice_Oohs = 53] = "Voice_Oohs", t[t.Synth_Voice = 54] = "Synth_Voice", t[t.Orchestra_Hit = 55] = "Orchestra_Hit", t[t.Trumpet = 56] = "Trumpet", t[t.Trombone = 57] = "Trombone", t[t.Tuba = 58] = "Tuba", t[t.Muted_Trumpet = 59] = "Muted_Trumpet", t[t.French_Horn = 60] = "French_Horn", t[t.Brass_Section = 61] = "Brass_Section", t[t.Synth_Brass_1 = 62] = "Synth_Brass_1", t[t.Synth_Brass_2 = 63] = "Synth_Brass_2", t[t.Soprano_Sax = 64] = "Soprano_Sax", t[t.Alto_Sax = 65] = "Alto_Sax", t[t.Tenor_Sax = 66] = "Tenor_Sax", t[t.Baritone_Sax = 67] = "Baritone_Sax", t[t.Oboe = 68] = "Oboe", t[t.English_Horn = 69] = "English_Horn", t[t.Bassoon = 70] = "Bassoon", t[t.Clarinet = 71] = "Clarinet", t[t.Piccolo = 72] = "Piccolo", t[t.Flute = 73] = "Flute", t[t.Recorder = 74] = "Recorder", t[t.Pan_Flute = 75] = "Pan_Flute", t[t.Blown_Bottle = 76] = "Blown_Bottle", t[t.Shakuhachi = 77] = "Shakuhachi", t[t.Whistle = 78] = "Whistle", t[t.Ocarina = 79] = "Ocarina", t[t.Lead_1_square = 80] = "Lead_1_square", t[t.Lead_2_sawtooth = 81] = "Lead_2_sawtooth", t[t.Lead_3_calliope = 82] = "Lead_3_calliope", t[t.Lead_4_chiff = 83] = "Lead_4_chiff", t[t.Lead_5_charang = 84] = "Lead_5_charang", t[t.Lead_6_voice = 85] = "Lead_6_voice", t[t.Lead_7_fifths = 86] = "Lead_7_fifths", t[t.Lead_8_bass_lead = 87] = "Lead_8_bass_lead", t[t.Pad_1_new_age = 88] = "Pad_1_new_age", t[t.Pad_2_warm = 89] = "Pad_2_warm", t[t.Pad_3_polysynth = 90] = "Pad_3_polysynth", t[t.Pad_4_choir = 91] = "Pad_4_choir", t[t.Pad_5_bowed = 92] = "Pad_5_bowed", t[t.Pad_6_metallic = 93] = "Pad_6_metallic", t[t.Pad_7_halo = 94] = "Pad_7_halo", t[t.Pad_8_sweep = 95] = "Pad_8_sweep", t[t.FX_1_rain = 96] = "FX_1_rain", t[t.FX_2_soundtrack = 97] = "FX_2_soundtrack", t[t.FX_3_crystal = 98] = "FX_3_crystal", t[t.FX_4_atmosphere = 99] = "FX_4_atmosphere", t[t.FX_5_brightness = 100] = "FX_5_brightness", t[t.FX_6_goblins = 101] = "FX_6_goblins", t[t.FX_7_echoes = 102] = "FX_7_echoes", t[t.FX_8_scifi = 103] = "FX_8_scifi", t[t.Sitar = 104] = "Sitar", t[t.Banjo = 105] = "Banjo", t[t.Shamisen = 106] = "Shamisen", t[t.Koto = 107] = "Koto", t[t.Kalimba = 108] = "Kalimba", t[t.Bag_pipe = 109] = "Bag_pipe", t[t.Fiddle = 110] = "Fiddle", t[t.Shanai = 111] = "Shanai", t[t.Tinkle_Bell = 112] = "Tinkle_Bell", t[t.Agogo = 113] = "Agogo", t[t.Steel_Drums = 114] = "Steel_Drums", t[t.Woodblock = 115] = "Woodblock", t[t.Taiko_Drum = 116] = "Taiko_Drum", t[t.Melodic_Tom = 117] = "Melodic_Tom", t[t.Synth_Drum = 118] = "Synth_Drum", t[t.Reverse_Cymbal = 119] = "Reverse_Cymbal", t[t.Guitar_Fret_Noise = 120] = "Guitar_Fret_Noise", t[t.Breath_Noise = 121] = "Breath_Noise", t[t.Seashore = 122] = "Seashore", t[t.Bird_Tweet = 123] = "Bird_Tweet", t[t.Telephone_Ring = 124] = "Telephone_Ring", t[t.Helicopter = 125] = "Helicopter", t[t.Applause = 126] = "Applause", t[t.Gunshot = 127] = "Gunshot", t[t.Percussion = 128] = "Percussion";
                }(c || (e.MidiInstrument = c = {}));
            },
            4543 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.KeyEnum = e.NoteEnumToHalfToneLink = e.KeyInstruction = void 0;
                const s = i(5364), n = i(8233), r = i(8233);
                class o extends s.AbstractNotationInstruction {
                    constructor(t, e = 0, i = a.major){
                        super(t), this.isTransposedBy = 0, this.Key = e, this.keyTypeOriginal = e, this.mode = i, this.alteratedNotes = this.calcAlteratedNotes();
                    }
                    static copy(t) {
                        const e = new o(t.parent, t.Key, t.Mode);
                        return e.keyTypeOriginal = t.keyTypeOriginal, e;
                    }
                    static getAllPossibleMajorKeyInstructions() {
                        const t = [];
                        for(let e = -7; e < 7; e++){
                            const i = new o(void 0, e, a.major);
                            t.push(i);
                        }
                        return t;
                    }
                    get Key() {
                        return this.keyType;
                    }
                    set Key(t) {
                        this.keyType = t, this.alteratedNotes = this.calcAlteratedNotes();
                    }
                    get Mode() {
                        return this.mode;
                    }
                    set Mode(t) {
                        this.mode = t;
                    }
                    get AlteratedNotes() {
                        return this.alteratedNotes;
                    }
                    calcAlteratedNotes() {
                        const t = [];
                        if (this.keyType > 0) for(let e = 0; e < this.keyType; e++)t.push(o.sharpPositionList[e]);
                        else if (this.keyType < 0) for(let e = 0; e < -this.keyType; e++)t.push(o.flatPositionList[e]);
                        return t;
                    }
                    willAlterateNote(t) {
                        return this.alteratedNotes.indexOf(t) >= 0;
                    }
                    getAlterationForPitch(t) {
                        return this.keyType > 0 && this.alteratedNotes.indexOf(t.FundamentalNote) <= this.keyType ? r.AccidentalEnum.SHARP : this.keyType < 0 && this.alteratedNotes.indexOf(t.FundamentalNote) <= Math.abs(this.keyType) ? r.AccidentalEnum.FLAT : r.AccidentalEnum.NONE;
                    }
                    ToString() {
                        return "Key: " + this.keyType + this.mode;
                    }
                    OperatorEquals(t) {
                        const e = this;
                        return e === t || !(!e || !t) && e.Key === t.Key && e.Mode === t.Mode;
                    }
                    OperatorNotEqual(t) {
                        return !this.OperatorEquals(t);
                    }
                }
                var a;
                e.KeyInstruction = o, o.sharpPositionList = [
                    n.NoteEnum.F,
                    n.NoteEnum.C,
                    n.NoteEnum.G,
                    n.NoteEnum.D,
                    n.NoteEnum.A,
                    n.NoteEnum.E,
                    n.NoteEnum.B
                ], o.flatPositionList = [
                    n.NoteEnum.B,
                    n.NoteEnum.E,
                    n.NoteEnum.A,
                    n.NoteEnum.D,
                    n.NoteEnum.G,
                    n.NoteEnum.C,
                    n.NoteEnum.F
                ], e.NoteEnumToHalfToneLink = class {
                    constructor(t, e){
                        this.note = t, this.halfTone = e;
                    }
                }, function(t) {
                    t[t.major = 0] = "major", t[t.minor = 1] = "minor", t[t.none = 2] = "none", t[t.dorian = 3] = "dorian", t[t.phrygian = 4] = "phrygian", t[t.lydian = 5] = "lydian", t[t.mixolydian = 6] = "mixolydian", t[t.aeolian = 7] = "aeolian", t[t.ionian = 8] = "ionian", t[t.locrian = 9] = "locrian";
                }(a || (e.KeyEnum = a = {}));
            },
            8931 (t, e) {
                "use strict";
                var i;
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.MeasureRepeatInstruction = e.MeasureRepeatType = void 0, function(t) {
                    t[t.Start = 0] = "Start", t[t.Stop = 1] = "Stop", t[t.Invalid = 2] = "Invalid";
                }(i || (e.MeasureRepeatType = i = {})), e.MeasureRepeatInstruction = class {
                    constructor(t, e = 0, i = 1){
                        this.type = t, this.measures = e, this.slashes = i;
                    }
                };
            },
            1645 (t, e) {
                "use strict";
                var i, s;
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.AlignmentType = e.RepetitionInstructionEnum = e.RepetitionInstruction = e.RepetitionInstructionComparer = void 0, e.RepetitionInstructionComparer = class {
                    static Compare(t, e) {
                        if (void 0 !== t.parentRepetition && e.parentRepetition) {
                            if (t.alignment === s.End && e.alignment === s.End) {
                                const i = t.measureIndex < t.parentRepetition.StartIndex;
                                if (i !== e.measureIndex < e.parentRepetition.StartIndex) return i ? 1 : -1;
                                if (t.parentRepetition.StartIndex < e.parentRepetition.StartIndex) return 1;
                                if (t.parentRepetition.StartIndex > e.parentRepetition.StartIndex) return -1;
                            }
                            if (t.alignment === s.Begin && e.alignment === s.Begin) {
                                if (t.parentRepetition.EndIndex < e.parentRepetition.EndIndex) return 1;
                                if (t.parentRepetition.EndIndex > e.parentRepetition.EndIndex) return -1;
                            }
                        }
                        return 0;
                    }
                }, e.RepetitionInstruction = class {
                    constructor(t, e, i = s.End, n, r){
                        this.endingIndices = void 0, this.MarkedAsTarget = !1, this.measureIndex = t, r && (this.endingIndices = r.slice()), this.type = e, this.alignment = i, this.parentRepetition = n;
                    }
                    CompareTo(t) {
                        const e = t;
                        if (this.measureIndex > e.measureIndex) return 1;
                        if (this.measureIndex < e.measureIndex) return -1;
                        if (this.alignment === s.Begin) {
                            if (e.alignment === s.End) return -1;
                            switch(this.type){
                                case i.Ending:
                                    return 1;
                                case i.StartLine:
                                    return e.type === i.Ending ? -1 : 1;
                                case i.Coda:
                                case i.Segno:
                                    return e.type === i.Coda ? 1 : -1;
                            }
                        } else {
                            if (e.alignment === s.Begin) return 1;
                            switch(this.type){
                                case i.Ending:
                                    return -1;
                                case i.Fine:
                                case i.ToCoda:
                                    return e.type === i.Ending ? 1 : -1;
                                case i.ForwardJump:
                                    switch(e.type){
                                        case i.Ending:
                                        case i.Fine:
                                        case i.ToCoda:
                                            return 1;
                                    }
                                    return -1;
                                case i.DalSegnoAlFine:
                                case i.DaCapoAlFine:
                                case i.DalSegnoAlCoda:
                                case i.DaCapoAlCoda:
                                case i.DaCapo:
                                case i.DalSegno:
                                case i.BackJumpLine:
                                    return 1;
                            }
                        }
                        return 0;
                    }
                    equals(t) {
                        if (this.measureIndex !== t.measureIndex || this.type !== t.type || this.alignment !== t.alignment) return !1;
                        if (this.endingIndices === t.endingIndices) return !0;
                        if (!this.endingIndices || !t.endingIndices || this.endingIndices.length !== t.endingIndices.length) return !1;
                        for(let e = 0; e < this.endingIndices.length; e++)if (this.endingIndices[e] !== t.endingIndices[e]) return !1;
                        return !0;
                    }
                }, function(t) {
                    t[t.StartLine = 0] = "StartLine", t[t.ForwardJump = 1] = "ForwardJump", t[t.BackJumpLine = 2] = "BackJumpLine", t[t.Ending = 3] = "Ending", t[t.DaCapo = 4] = "DaCapo", t[t.DalSegno = 5] = "DalSegno", t[t.Fine = 6] = "Fine", t[t.ToCoda = 7] = "ToCoda", t[t.DalSegnoAlFine = 8] = "DalSegnoAlFine", t[t.DaCapoAlFine = 9] = "DaCapoAlFine", t[t.DalSegnoAlCoda = 10] = "DalSegnoAlCoda", t[t.DaCapoAlCoda = 11] = "DaCapoAlCoda", t[t.Coda = 12] = "Coda", t[t.Segno = 13] = "Segno", t[t.None = 14] = "None";
                }(i || (e.RepetitionInstructionEnum = i = {})), function(t) {
                    t[t.Begin = 0] = "Begin", t[t.End = 1] = "End", t[t.Mid = 2] = "Mid", t[t.Discontinue = 3] = "Discontinue";
                }(s || (e.AlignmentType = s = {}));
            },
            9288 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.RhythmSymbolEnum = e.RhythmInstruction = void 0;
                const s = i(5364);
                class n extends s.AbstractNotationInstruction {
                    constructor(t, e){
                        super(void 0), this.SynthesizedFromNoTimeSignature = !1, this.rhythm = t, this.numerator = t.Numerator, this.denominator = t.Denominator, this.symbolEnum = e;
                    }
                    get Rhythm() {
                        return this.rhythm;
                    }
                    set Rhythm(t) {
                        this.rhythm = t;
                    }
                    get SymbolEnum() {
                        return this.symbolEnum;
                    }
                    set SymbolEnum(t) {
                        this.symbolEnum = t;
                    }
                    clone() {
                        const t = new n(this.rhythm.clone(), this.symbolEnum);
                        return t.SynthesizedFromNoTimeSignature = this.SynthesizedFromNoTimeSignature, t;
                    }
                    OperatorEquals(t) {
                        const e = this;
                        return e === t || !(!e || !t) && e.numerator === t.numerator && e.denominator === t.denominator;
                    }
                    OperatorNotEqual(t) {
                        return !(this === t);
                    }
                    ToString() {
                        return "Rhythm: " + this.rhythm.toString();
                    }
                }
                var r;
                e.RhythmInstruction = n, function(t) {
                    t[t.NONE = 0] = "NONE", t[t.COMMON = 1] = "COMMON", t[t.CUT = 2] = "CUT";
                }(r || (e.RhythmSymbolEnum = r = {}));
            },
            3123 (t, e) {
                "use strict";
                var i;
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.TechnicalInstruction = e.TechnicalInstructionType = void 0, function(t) {
                    t[t.Fingering = 0] = "Fingering", t[t.String = 1] = "String";
                }(i || (e.TechnicalInstructionType = i = {})), e.TechnicalInstruction = class {
                };
            },
            9184 (t, e, i) {
                "use strict";
                var s = this && this.__createBinding || (Object.create ? function(t, e, i, s) {
                    void 0 === s && (s = i);
                    var n = Object.getOwnPropertyDescriptor(e, i);
                    n && !("get" in n ? !e.__esModule : n.writable || n.configurable) || (n = {
                        enumerable: !0,
                        get: function() {
                            return e[i];
                        }
                    }), Object.defineProperty(t, s, n);
                } : function(t, e, i, s) {
                    void 0 === s && (s = i), t[s] = e[i];
                }), n = this && this.__exportStar || function(t, e) {
                    for(var i in t)"default" === i || Object.prototype.hasOwnProperty.call(e, i) || s(e, t, i);
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), n(i(5364), e), n(i(164), e), n(i(4543), e), n(i(8931), e), n(i(1645), e), n(i(9288), e), n(i(3123), e);
            },
            4249 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.LinkedVoice = void 0;
                const s = i(5534);
                class n extends s.Voice {
                    constructor(t, e, i){
                        super(t, e), this.master = i;
                    }
                    get Master() {
                        return this.master;
                    }
                }
                e.LinkedVoice = n;
            },
            2317 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.LyricsEntry = void 0;
                const s = i(2570);
                e.LyricsEntry = class {
                    constructor(t, e, i, s, n = -1){
                        this.syllabic = "single", this.text = t, this.word = i, this.parent = s, this.verseNumber = e, n >= 0 && (this.syllableIndex = n);
                    }
                    get Text() {
                        return this.text;
                    }
                    set Text(t) {
                        this.text = t;
                    }
                    get Word() {
                        return this.word;
                    }
                    set Word(t) {
                        this.word = t;
                    }
                    get Parent() {
                        return this.parent;
                    }
                    set Parent(t) {
                        this.parent = t;
                    }
                    get VerseNumber() {
                        return this.verseNumber;
                    }
                    get SyllableIndex() {
                        return this.syllableIndex;
                    }
                    set SyllableIndex(t) {
                        this.syllableIndex = t;
                    }
                    get IsTranslation() {
                        return this.VerseNumber.endsWith("translation");
                    }
                    get IsChorus() {
                        return this.VerseNumber.startsWith("chorus");
                    }
                    get FontStyle() {
                        return this.IsChorus || this.IsTranslation ? s.FontStyles.Italic : s.FontStyles.Regular;
                    }
                };
            },
            649 (t, e) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.LyricWord = void 0, e.LyricWord = class {
                    constructor(){
                        this.syllables = [];
                    }
                    get Syllables() {
                        return this.syllables;
                    }
                    containsVoiceEntry(t) {
                        for(let e = 0, i = this.Syllables.length; e < i; ++e)if (this.Syllables[e].Parent === t) return !0;
                        return !1;
                    }
                    findLyricEntryInVoiceEntry(t) {
                        for(let e = 0, i = this.Syllables.length; e < i; ++e){
                            const i = this.Syllables[e];
                            if (i.Parent === t) return i;
                        }
                    }
                };
            },
            1850 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.Appearance = e.Note = void 0;
                const s = i(2561), n = i(4064);
                var r;
                e.Note = class {
                    constructor(t, e, i, s, n, r){
                        this.slurs = [], this.playbackInstrumentId = void 0, this.notehead = void 0, this.printObject = !0, this.NoteTuplets = [], this.voiceEntry = t, this.parentStaffEntry = e, this.length = i, this.pitch = s, this.sourceMeasure = n, this.isRestFlag = r ?? !1, this.halfTone = s ? s.getHalfTone() : 0;
                    }
                    get NoteAsString() {
                        return this.pitch.toString();
                    }
                    ToStringShort(t = 0) {
                        return !this.Pitch || this.isRest() ? "rest" : this.Pitch?.ToStringShort(t);
                    }
                    get ToStringShortGet() {
                        return this.ToStringShort(0);
                    }
                    get ParentVoiceEntry() {
                        return this.voiceEntry;
                    }
                    set ParentVoiceEntry(t) {
                        this.voiceEntry = t;
                    }
                    get ParentStaffEntry() {
                        return this.parentStaffEntry;
                    }
                    set ParentStaffEntry(t) {
                        this.parentStaffEntry = t;
                    }
                    get ParentStaff() {
                        return this.parentStaffEntry.ParentStaff;
                    }
                    get Length() {
                        return this.length;
                    }
                    set Length(t) {
                        this.length = t;
                    }
                    get SourceMeasure() {
                        return this.sourceMeasure;
                    }
                    get TypeLength() {
                        return this.typeLength;
                    }
                    set TypeLength(t) {
                        this.typeLength = t;
                    }
                    get NoteTypeXml() {
                        return this.noteTypeXml;
                    }
                    set NoteTypeXml(t) {
                        this.noteTypeXml = t;
                    }
                    get NormalNotes() {
                        return this.normalNotes;
                    }
                    set NormalNotes(t) {
                        this.normalNotes = t;
                    }
                    get Pitch() {
                        return this.pitch;
                    }
                    get NoteBeam() {
                        return this.beam;
                    }
                    set NoteBeam(t) {
                        this.beam = t;
                    }
                    set Notehead(t) {
                        this.notehead = t;
                    }
                    get Notehead() {
                        return this.notehead;
                    }
                    get NoteTuplet() {
                        return this.tuplet;
                    }
                    set NoteTuplet(t) {
                        this.tuplet = t;
                    }
                    get NoteGlissando() {
                        return this.glissando;
                    }
                    set NoteGlissando(t) {
                        this.glissando = t;
                    }
                    get NoteTie() {
                        return this.tie;
                    }
                    set NoteTie(t) {
                        this.tie = t;
                    }
                    get NoteSlurs() {
                        return this.slurs;
                    }
                    set NoteSlurs(t) {
                        this.slurs = t;
                    }
                    get PlaybackInstrumentId() {
                        return this.playbackInstrumentId;
                    }
                    set PlaybackInstrumentId(t) {
                        this.playbackInstrumentId = t;
                    }
                    get PrintObject() {
                        return this.printObject;
                    }
                    set PrintObject(t) {
                        this.printObject = t;
                    }
                    sharesNoteheadWithVisibleUnisonNote() {
                        return void 0 !== this.visibleUnisonNoteSharingNotehead();
                    }
                    visibleUnisonNoteSharingNotehead() {
                        if ((!this.printObject || this.notehead?.Shape === n.NoteHeadShape.NONE) && this.pitch && this.parentStaffEntry && !this.voiceEntry?.IsGrace) {
                            for (const t of this.parentStaffEntry.VoiceEntries)if (t !== this.voiceEntry && !t.IsGrace) {
                                for (const e of t.Notes)if (e.printObject && e.notehead?.Shape !== n.NoteHeadShape.NONE && e.pitch && e.pitch.FundamentalNote === this.pitch.FundamentalNote && e.pitch.Octave === this.pitch.Octave) return e;
                            }
                        }
                    }
                    get Arpeggio() {
                        return this.arpeggio;
                    }
                    set Arpeggio(t) {
                        this.arpeggio = t;
                    }
                    get IsCueNote() {
                        return this.isCueNote;
                    }
                    set IsCueNote(t) {
                        this.isCueNote = t;
                    }
                    get StemDirectionXml() {
                        return this.stemDirectionXml;
                    }
                    set StemDirectionXml(t) {
                        this.stemDirectionXml = t;
                    }
                    get TremoloStrokes() {
                        return this.TremoloInfo?.tremoloStrokes;
                    }
                    get StemColorXml() {
                        return this.stemColorXml;
                    }
                    set StemColorXml(t) {
                        this.stemColorXml = t;
                    }
                    get NoteheadColorXml() {
                        return this.noteheadColorXml;
                    }
                    set NoteheadColorXml(t) {
                        this.noteheadColorXml = t;
                    }
                    get NoteheadColor() {
                        return this.noteheadColor;
                    }
                    set NoteheadColor(t) {
                        this.noteheadColor = t;
                    }
                    get NoteheadColorCurrentlyRendered() {
                        return this.noteheadColorCurrentlyRendered;
                    }
                    set NoteheadColorCurrentlyRendered(t) {
                        this.noteheadColorCurrentlyRendered = t;
                    }
                    isRest() {
                        return this.isRestFlag;
                    }
                    isWholeRest() {
                        return this.isRest() && this.Length.RealValue === this.sourceMeasure.ActiveTimeSignature.RealValue;
                    }
                    isWholeMeasureNote() {
                        return this.Length.RealValue === this.sourceMeasure.ActiveTimeSignature.RealValue;
                    }
                    ToString() {
                        return this.pitch ? this.Pitch.ToString() + ", length: " + this.length.toString() : "rest note, length: " + this.length.toString();
                    }
                    getAbsoluteTimestamp() {
                        return s.Fraction.plus(this.voiceEntry.Timestamp, this.sourceMeasure.AbsoluteTimestamp);
                    }
                    isDuplicateSlur(t) {
                        for(let e = 0, i = this.slurs.length; e < i; ++e){
                            const i = this.slurs[e];
                            if (void 0 !== i.StartNote && void 0 !== i.EndNote && void 0 !== t.StartNote && t.StartNote === i.StartNote && i.EndNote === this && t.PlacementXml === i.PlacementXml) return !0;
                        }
                        return !1;
                    }
                    hasTabEffects() {
                        return !1;
                    }
                }, function(t) {
                    t[t.Normal = 0] = "Normal", t[t.Grace = 1] = "Grace", t[t.Cue = 2] = "Cue";
                }(r || (e.Appearance = r = {}));
            },
            5282 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.NoteTypeHandler = e.NoteType = void 0;
                const s = i(2561), n = i(9767), r = i(7307);
                var o;
                !function(t) {
                    t[t.UNDEFINED = 0] = "UNDEFINED", t[t._1024th = 1] = "_1024th", t[t._512th = 2] = "_512th", t[t._256th = 3] = "_256th", t[t._128th = 4] = "_128th", t[t._64th = 5] = "_64th", t[t._32nd = 6] = "_32nd", t[t._16th = 7] = "_16th", t[t.EIGTH = 8] = "EIGTH", t[t.EIGHTH = 8] = "EIGHTH", t[t.QUARTER = 9] = "QUARTER", t[t.HALF = 10] = "HALF", t[t.WHOLE = 11] = "WHOLE", t[t.BREVE = 12] = "BREVE", t[t.LONG = 13] = "LONG", t[t.MAXIMA = 14] = "MAXIMA";
                }(o || (e.NoteType = o = {}));
                class a {
                    static NoteTypeToString(t) {
                        return this.NoteTypeXmlValues[t];
                    }
                    static StringToNoteType(t) {
                        const e = this.NoteTypeXmlValues.indexOf(t);
                        return -1 !== e ? e : o.UNDEFINED;
                    }
                    static getNoteDurationFromType(t) {
                        switch(t){
                            case "1024th":
                                return new s.Fraction(1, 1024);
                            case "512th":
                                return new s.Fraction(1, 512);
                            case "256th":
                                return new s.Fraction(1, 256);
                            case "128th":
                                return new s.Fraction(1, 128);
                            case "64th":
                                return new s.Fraction(1, 64);
                            case "32th":
                            case "32nd":
                                return new s.Fraction(1, 32);
                            case "16th":
                                return new s.Fraction(1, 16);
                            case "eighth":
                                return new s.Fraction(1, 8);
                            case "quarter":
                                return new s.Fraction(1, 4);
                            case "half":
                                return new s.Fraction(1, 2);
                            case "whole":
                                return new s.Fraction(1, 1);
                            case "breve":
                                return new s.Fraction(2, 1);
                            case "long":
                                return new s.Fraction(4, 1);
                            case "maxima":
                                return new s.Fraction(8, 1);
                            default:
                                {
                                    const t = n.ITextTranslation.translateText("ReaderErrorMessages/NoteDurationError", "Invalid note duration.");
                                    throw new r.MusicSheetReadingException(t);
                                }
                        }
                    }
                }
                e.NoteTypeHandler = a, a.NoteTypeXmlValues = [
                    "",
                    "1024th",
                    "512th",
                    "256th",
                    "128th",
                    "64th",
                    "32nd",
                    "16th",
                    "eighth",
                    "quarter",
                    "half",
                    "whole",
                    "breve",
                    "long",
                    "maxima"
                ];
            },
            4064 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.NoteHeadShape = e.Notehead = void 0;
                const n = s(i(3065));
                class r {
                    constructor(t, e, i){
                        this.sourceNote = t, this.setShapeFromXml(e, i);
                    }
                    setShapeFromXml(t, e) {
                        this.shape = r.ShapeTypeXmlToShape(t);
                        let i = e;
                        void 0 === i && (this.sourceNote ? i = this.sourceNote.Length.Denominator > 2 : (n.default.warn("notehead: sourceNote and filledXmlAttribute undefined."), i = !0)), this.filled = i;
                    }
                    get SourceNote() {
                        return this.sourceNote;
                    }
                    get Shape() {
                        return this.shape;
                    }
                    get Filled() {
                        return this.filled;
                    }
                    static ShapeTypeXmlToShape(t) {
                        switch(t.toLowerCase()){
                            case "normal":
                                return o.NORMAL;
                            case "none":
                                return o.NONE;
                            case "x":
                                return o.X;
                            case "slash":
                                return o.SLASH;
                            case "diamond":
                                return o.DIAMOND;
                            case "square":
                            case "la":
                                return o.SQUARE;
                            case "do":
                            case "triangle":
                                return o.TRIANGLE;
                            case "inverted triangle":
                                return o.TRIANGLE_INVERTED;
                            case "rectangle":
                                return o.RECTANGLE;
                            case "circle-x":
                                return o.CIRCLEX;
                            default:
                                return n.default.info("unsupported/unhandled xml notehead '" + t + "'. Using normal notehead."), o.NORMAL;
                        }
                    }
                }
                var o;
                e.Notehead = r, function(t) {
                    t[t.CIRCLEX = 0] = "CIRCLEX", t[t.DIAMOND = 1] = "DIAMOND", t[t.NORMAL = 2] = "NORMAL", t[t.NONE = 3] = "NONE", t[t.RECTANGLE = 4] = "RECTANGLE", t[t.SLASH = 5] = "SLASH", t[t.SQUARE = 6] = "SQUARE", t[t.TRIANGLE = 7] = "TRIANGLE", t[t.TRIANGLE_INVERTED = 8] = "TRIANGLE_INVERTED", t[t.X = 9] = "X";
                }(o || (e.NoteHeadShape = o = {}));
            },
            8215 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.OrnamentEnum = e.OrnamentContainer = void 0;
                const s = i(8233), n = i(6362);
                var r;
                e.OrnamentContainer = class {
                    constructor(t){
                        this.placement = n.PlacementEnum.Above, this.accidentalAbove = s.AccidentalEnum.NONE, this.accidentalBelow = s.AccidentalEnum.NONE, this.ornament = t;
                    }
                    get GetOrnament() {
                        return this.ornament;
                    }
                    get AccidentalAbove() {
                        return this.accidentalAbove;
                    }
                    set AccidentalAbove(t) {
                        this.accidentalAbove = t;
                    }
                    get AccidentalBelow() {
                        return this.accidentalBelow;
                    }
                    set AccidentalBelow(t) {
                        this.accidentalBelow = t;
                    }
                }, function(t) {
                    t[t.Trill = 0] = "Trill", t[t.Turn = 1] = "Turn", t[t.InvertedTurn = 2] = "InvertedTurn", t[t.DelayedTurn = 3] = "DelayedTurn", t[t.DelayedInvertedTurn = 4] = "DelayedInvertedTurn", t[t.Mordent = 5] = "Mordent", t[t.InvertedMordent = 6] = "InvertedMordent";
                }(r || (e.OrnamentEnum = r = {}));
            },
            4387 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.SourceMeasure = void 0;
                const s = i(2561), n = i(3236), r = i(2369), o = i(1645), a = i(1336), l = i(164), h = i(4543), c = i(6954);
                e.SourceMeasure = class {
                    constructor(t, e){
                        this.printNewSystemXml = !1, this.printNewPageXml = !1, this.IsSystemStartMeasure = !1, this.WidthFactor = 1, this.ImplicitMeasureFromXml = !1, this.MeasureRepeatInstructions = new Map, this.hasLyrics = !1, this.hasMoodExpressions = !1, this.allRests = !1, this.isReducedToMultiRest = !1, this.multipleRestMeasureNumber = 0, this.staffLinkedExpressions = [], this.tempoExpressions = [], this.verticalSourceStaffEntryContainers = [], this.graphicalMeasureErrors = [], this.firstRepetitionInstructions = [], this.lastRepetitionInstructions = [], this.WasRendered = !1, this.completeNumberOfStaves = t, this.implicitMeasure = !1, this.hasEndLine = !1, this.endingBarStyleXml = "", this.endingBarStyleEnum = c.SystemLinesEnum.SingleThin, this.firstInstructionsStaffEntries = new Array(t), this.lastInstructionsStaffEntries = new Array(t), this.rules = e, this.TempoInBPM = 0;
                        for(let e = 0; e < t; e++)this.graphicalMeasureErrors.push(!1), this.staffLinkedExpressions.push([]);
                    }
                    get MeasureNumber() {
                        return this.measureNumber;
                    }
                    set MeasureNumber(t) {
                        this.measureNumber = t;
                    }
                    getPrintedMeasureNumber() {
                        return this.rules.UseXMLMeasureNumbers && Number.isInteger(this.MeasureNumberXML) ? (this.MeasureNumberPrinted = this.MeasureNumberXML, this.MeasureNumberPrinted) : (this.MeasureNumberPrinted = this.MeasureNumber, this.MeasureNumberPrinted);
                    }
                    get AbsoluteTimestamp() {
                        return this.absoluteTimestamp;
                    }
                    set AbsoluteTimestamp(t) {
                        this.absoluteTimestamp = t;
                    }
                    get CompleteNumberOfStaves() {
                        return this.completeNumberOfStaves;
                    }
                    get Duration() {
                        return this.duration;
                    }
                    set Duration(t) {
                        this.duration = t;
                    }
                    get ActiveTimeSignature() {
                        return this.activeTimeSignature;
                    }
                    set ActiveTimeSignature(t) {
                        this.activeTimeSignature = t;
                    }
                    get ImplicitMeasure() {
                        return this.implicitMeasure;
                    }
                    set ImplicitMeasure(t) {
                        this.implicitMeasure = t;
                    }
                    get HasEndLine() {
                        return this.hasEndLine;
                    }
                    set HasEndLine(t) {
                        this.hasEndLine = t;
                    }
                    get StaffLinkedExpressions() {
                        return this.staffLinkedExpressions;
                    }
                    get TempoExpressions() {
                        return this.tempoExpressions;
                    }
                    get VerticalSourceStaffEntryContainers() {
                        return this.verticalSourceStaffEntryContainers;
                    }
                    get FirstInstructionsStaffEntries() {
                        return this.firstInstructionsStaffEntries;
                    }
                    get LastInstructionsStaffEntries() {
                        return this.lastInstructionsStaffEntries;
                    }
                    get FirstRepetitionInstructions() {
                        return this.firstRepetitionInstructions;
                    }
                    get LastRepetitionInstructions() {
                        return this.lastRepetitionInstructions;
                    }
                    getErrorInMeasure(t) {
                        return this.graphicalMeasureErrors[t];
                    }
                    setErrorInGraphicalMeasure(t, e) {
                        this.graphicalMeasureErrors[t] = e;
                    }
                    getNextMeasure(t) {
                        return t[this.measureListIndex + 1];
                    }
                    getPreviousMeasure(t) {
                        if (this.measureListIndex > 1) return t[this.measureListIndex - 1];
                    }
                    get Rules() {
                        return this.rules;
                    }
                    get VerticalMeasureList() {
                        return this.verticalMeasureList;
                    }
                    set VerticalMeasureList(t) {
                        this.verticalMeasureList = t;
                    }
                    get TempoInBPM() {
                        return this.tempoInBPM;
                    }
                    set TempoInBPM(t) {
                        this.tempoInBPM = t;
                    }
                    findOrCreateStaffEntry(t, e, i) {
                        let s, o;
                        for (const e of this.verticalSourceStaffEntryContainers)if (e.Timestamp.Equals(t)) {
                            o = e;
                            break;
                        }
                        if (o) return o.StaffEntries[e] ? s = o.StaffEntries[e] : (s = new r.SourceStaffEntry(o, i), o.StaffEntries[e] = s), {
                            createdNewContainer: !1,
                            staffEntry: s
                        };
                        const a = this.verticalSourceStaffEntryContainers[this.verticalSourceStaffEntryContainers.length - 1];
                        if (0 === this.verticalSourceStaffEntryContainers.length || a.Timestamp.lt(t)) {
                            const o = new n.VerticalSourceStaffEntryContainer(this, t.clone(), this.completeNumberOfStaves);
                            this.verticalSourceStaffEntryContainers.push(o), s = new r.SourceStaffEntry(o, i), o.StaffEntries[e] = s;
                        } else for(let o = this.verticalSourceStaffEntryContainers.length - 1; o >= 0; o--){
                            if (this.verticalSourceStaffEntryContainers[o].Timestamp.lt(t)) {
                                const a = new n.VerticalSourceStaffEntryContainer(this, t.clone(), this.completeNumberOfStaves);
                                this.verticalSourceStaffEntryContainers.splice(o + 1, 0, a), s = new r.SourceStaffEntry(a, i), a.StaffEntries[e] = s;
                                break;
                            }
                            if (0 === o) {
                                const a = new n.VerticalSourceStaffEntryContainer(this, t.clone(), this.completeNumberOfStaves);
                                this.verticalSourceStaffEntryContainers.splice(o, 0, a), s = new r.SourceStaffEntry(a, i), a.StaffEntries[e] = s;
                                break;
                            }
                        }
                        return {
                            createdNewContainer: !0,
                            staffEntry: s
                        };
                    }
                    findOrCreateVoiceEntry(t, e) {
                        let i, s = !1;
                        for (const s of t.VoiceEntries)if (s.ParentVoice === e) {
                            i = s;
                            break;
                        }
                        return i || (i = new a.VoiceEntry(t.Timestamp, e, t), s = !0), {
                            createdVoiceEntry: s,
                            voiceEntry: i
                        };
                    }
                    getPreviousSourceStaffEntryFromIndex(t, e) {
                        for(let i = e - 1; i >= 0; i--)if (this.verticalSourceStaffEntryContainers[i][t]) return this.verticalSourceStaffEntryContainers[i][t];
                    }
                    getVerticalContainerIndexByTimestamp(t) {
                        for(let e = 0, i = this.VerticalSourceStaffEntryContainers.length; e < i; ++e)if (this.VerticalSourceStaffEntryContainers[e].Timestamp.Equals(t)) return e;
                        return -1;
                    }
                    getVerticalContainerByTimestamp(t) {
                        for(let e = 0, i = this.VerticalSourceStaffEntryContainers.length; e < i; ++e){
                            const i = this.VerticalSourceStaffEntryContainers[e];
                            if (i.Timestamp.Equals(t)) return i;
                        }
                    }
                    checkForEmptyVerticalContainer(t) {
                        let e = 0;
                        for(let i = 0; i < this.completeNumberOfStaves; i++)this.verticalSourceStaffEntryContainers[t][i] || e++;
                        e === this.completeNumberOfStaves && this.verticalSourceStaffEntryContainers.splice(t, 1);
                    }
                    reverseCheck(t, e) {
                        let i = new s.Fraction(0, 1);
                        const n = [];
                        for(let e = 0; e < t.Instruments.length; e++){
                            let i = new s.Fraction(0, 1);
                            const r = t.getGlobalStaffIndexOfFirstStaff(t.Instruments[e]);
                            for(let n = 0; n < t.Instruments[e].Staves.length; n++){
                                const t = this.getLastSourceStaffEntryForInstrument(r + n);
                                if (void 0 !== t && !t.hasTie()) for(let e = this.verticalSourceStaffEntryContainers.indexOf(t.VerticalContainerParent) - 1; e >= 0; e--){
                                    const t = this.verticalSourceStaffEntryContainers[e][r + n];
                                    if (void 0 !== t && t.hasTie() && i.lt(s.Fraction.plus(t.Timestamp, t.calculateMaxNoteLength()))) {
                                        i = s.Fraction.plus(t.Timestamp, t.calculateMaxNoteLength());
                                        break;
                                    }
                                }
                            }
                            n.push(i);
                        }
                        for(let t = 0, e = n.length; t < e; ++t){
                            const e = n[t];
                            i.lt(e) && (i = e);
                        }
                        return s.Fraction.max(i, e);
                    }
                    calculateInstrumentsDuration(t, e) {
                        const i = [];
                        for(let n = 0; n < t.Instruments.length; n++){
                            let r = new s.Fraction(0, 1);
                            const o = t.getGlobalStaffIndexOfFirstStaff(t.Instruments[n]);
                            for(let e = 0; e < t.Instruments[n].Staves.length; e++){
                                const t = this.getLastSourceStaffEntryForInstrument(o + e);
                                if (void 0 !== t && t.Timestamp) {
                                    const e = t.calculateMaxNoteLength(!1);
                                    r.lt(s.Fraction.plus(t.Timestamp, e)) && (r = s.Fraction.plus(t.Timestamp, e));
                                }
                            }
                            r.lt(e[n]) && (r = e[n]), i.push(r);
                        }
                        return i;
                    }
                    getEntriesPerStaff(t) {
                        const e = [];
                        for (const i of this.VerticalSourceStaffEntryContainers){
                            const s = i.StaffEntries[t];
                            s && e.push(s);
                        }
                        return e;
                    }
                    hasBeginInstructions() {
                        for(let t = 0, e = this.FirstInstructionsStaffEntries.length; t < e; t++){
                            const e = this.FirstInstructionsStaffEntries[t];
                            if (void 0 !== e && e.Instructions.length > 0) return !0;
                        }
                        return !1;
                    }
                    beginsWithRepetition() {
                        return this.beginsWithLineRepetition() || this.beginsWithWordRepetition();
                    }
                    beginsWithLineRepetition() {
                        for(let t = 0, e = this.FirstRepetitionInstructions.length; t < e; ++t){
                            const e = this.FirstRepetitionInstructions[t];
                            if (e.type === o.RepetitionInstructionEnum.StartLine) {
                                if (void 0 !== e.parentRepetition && e.parentRepetition.FromWords) continue;
                                return !0;
                            }
                            if (void 0 !== e.parentRepetition && e === e.parentRepetition.startMarker && !e.parentRepetition.FromWords && e.type !== o.RepetitionInstructionEnum.None) return !0;
                        }
                        return !1;
                    }
                    endsWithLineRepetition() {
                        for(let t = 0, e = this.LastRepetitionInstructions.length; t < e; ++t){
                            const e = this.LastRepetitionInstructions[t];
                            if (e.type === o.RepetitionInstructionEnum.BackJumpLine) return !0;
                            const i = e.parentRepetition;
                            if (i && !i.FromWords) {
                                for(let t = 0, s = i.BackwardJumpInstructions.length; t < s; ++t)if (e === i.BackwardJumpInstructions[t]) return !0;
                            }
                        }
                        return !1;
                    }
                    beginsWithWordRepetition() {
                        for(let t = 0, e = this.FirstRepetitionInstructions.length; t < e; ++t){
                            const e = this.FirstRepetitionInstructions[t];
                            if (void 0 !== e.parentRepetition && e === e.parentRepetition.startMarker && e.parentRepetition.FromWords) return !0;
                        }
                        return !1;
                    }
                    endsWithWordRepetition() {
                        for(let t = 0, e = this.LastRepetitionInstructions.length; t < e; ++t){
                            const e = this.LastRepetitionInstructions[t], i = e.parentRepetition;
                            if (i && i.FromWords) {
                                for(let t = 0, s = i.BackwardJumpInstructions.length; t < s; ++t)if (e === i.BackwardJumpInstructions[t]) return !0;
                                if (e === i.forwardJumpInstruction) return !0;
                            }
                        }
                        return !1;
                    }
                    beginsRepetitionEnding() {
                        for (const t of this.FirstRepetitionInstructions)if (t.type === o.RepetitionInstructionEnum.Ending && t.alignment === o.AlignmentType.Begin) return !0;
                        return !1;
                    }
                    endsRepetitionEnding() {
                        for (const t of this.LastRepetitionInstructions)if (t.type === o.RepetitionInstructionEnum.Ending && t.alignment === o.AlignmentType.End) return !0;
                        return !1;
                    }
                    getKeyInstruction(t) {
                        if (this.FirstInstructionsStaffEntries[t]) {
                            const e = this.FirstInstructionsStaffEntries[t];
                            for(let t = 0, i = e.Instructions.length; t < i; ++t){
                                const i = e.Instructions[t];
                                if (i instanceof h.KeyInstruction) return i;
                            }
                        }
                    }
                    getLastSourceStaffEntryForInstrument(t, e = !0) {
                        let i;
                        for(let s = this.verticalSourceStaffEntryContainers.length - 1; s >= 0; s--)if (i = this.verticalSourceStaffEntryContainers[s].StaffEntries[t], i && (!e || i.VoiceEntries.length > 0)) return i;
                    }
                    canBeReducedToMultiRest() {
                        if (this.firstRepetitionInstructions.length > 0 || this.lastRepetitionInstructions.length > 0) return !1;
                        let t = !0, e = !1;
                        for (const i of this.verticalSourceStaffEntryContainers)if (i) {
                            for (const s of i.StaffEntries)if (s && s.ParentStaff.isVisible()) {
                                if (s.ChordContainers.length > 0) return !1;
                                if (s.Instructions.some((t)=>t instanceof h.KeyInstruction)) return !1;
                                s.ParentStaff.hasLyrics && (e = !0);
                                for (const e of s.VoiceEntries){
                                    for (const i of e.Notes)if (!i.isRest()) {
                                        t = !1;
                                        break;
                                    }
                                    if (!t) break;
                                }
                            }
                        }
                        if (!t || e || this.hasMoodExpressions || this.tempoExpressions.length > 0) return !1;
                        for (const t of this.staffLinkedExpressions)if (t.length > 0) return !1;
                        for (const t of this.lastInstructionsStaffEntries)for(let e = 0, i = t?.Instructions.length; e < i; ++e)if (t.Instructions[e] instanceof l.ClefInstruction) return !1;
                        return this.Duration?.RealValue === this.ActiveTimeSignature?.RealValue;
                    }
                };
            },
            2369 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.SourceStaffEntry = void 0;
                const s = i(2561), n = i(164), r = i(4543), o = i(9288);
                e.SourceStaffEntry = class {
                    constructor(t, e){
                        this.voiceEntries = [], this.instructions = [], this.chordSymbolContainers = [], this.verticalContainerParent = t, this.parentStaff = e;
                    }
                    get ParentStaff() {
                        return this.parentStaff;
                    }
                    get VerticalContainerParent() {
                        return this.verticalContainerParent;
                    }
                    get Timestamp() {
                        if (this.VerticalContainerParent) return this.VerticalContainerParent.Timestamp;
                    }
                    get AbsoluteTimestamp() {
                        if (this.VerticalContainerParent) return s.Fraction.plus(this.VerticalContainerParent.ParentMeasure.AbsoluteTimestamp, this.VerticalContainerParent.Timestamp);
                    }
                    get VoiceEntries() {
                        return this.voiceEntries;
                    }
                    set VoiceEntries(t) {
                        this.voiceEntries = t;
                    }
                    get Link() {
                        return this.staffEntryLink;
                    }
                    set Link(t) {
                        this.staffEntryLink = t;
                    }
                    get Instructions() {
                        return this.instructions;
                    }
                    set Instructions(t) {
                        this.instructions = t;
                    }
                    get ChordContainers() {
                        return this.chordSymbolContainers;
                    }
                    set ChordContainers(t) {
                        this.chordSymbolContainers = t;
                    }
                    removeAllInstructionsOfTypeClefInstruction() {
                        let t = 0, e = 0;
                        for(; t < this.instructions.length;)this.instructions[t] instanceof n.ClefInstruction ? (this.instructions.splice(t, 1), e++) : t++;
                        return e;
                    }
                    removeFirstInstructionOfTypeClefInstruction() {
                        for(let t = 0; t < this.instructions.length; t++)if (this.instructions[t] instanceof n.ClefInstruction) return this.instructions.splice(t, 1), !0;
                        return !1;
                    }
                    removeAllInstructionsOfTypeKeyInstruction() {
                        let t = 0, e = 0;
                        for(; t < this.instructions.length;)this.instructions[t] instanceof r.KeyInstruction ? (this.instructions.splice(t, 1), e++) : t++;
                        return e;
                    }
                    removeFirstInstructionOfTypeKeyInstruction() {
                        for(let t = 0; t < this.instructions.length; t++)if (this.instructions[t] instanceof r.KeyInstruction) return this.instructions.splice(t, 1), !0;
                        return !1;
                    }
                    removeAllInstructionsOfTypeRhythmInstruction() {
                        let t = 0, e = 0;
                        for(; t < this.instructions.length;)this.instructions[t] instanceof o.RhythmInstruction ? (this.instructions.splice(t, 1), e++) : t++;
                        return e;
                    }
                    removeFirstInstructionOfTypeRhythmInstruction() {
                        for(let t = 0; t < this.instructions.length; t++)if (this.instructions[t] instanceof o.RhythmInstruction) return this.instructions.splice(t, 1), !0;
                        return !1;
                    }
                    calculateMinNoteLength() {
                        let t = new s.Fraction(Number.MAX_VALUE, 1);
                        for(let e = 0, i = this.VoiceEntries.length; e < i; ++e){
                            const i = this.VoiceEntries[e];
                            for(let e = 0, s = i.Notes.length; e < s; ++e){
                                const s = i.Notes[e];
                                s.Length.lt(t) && (t = s.Length);
                            }
                        }
                        return t;
                    }
                    calculateMaxNoteLength(t = !0) {
                        let e = new s.Fraction(0, 1);
                        for(let i = 0, n = this.VoiceEntries.length; i < n; ++i){
                            const n = this.VoiceEntries[i];
                            for(let i = 0, r = n.Notes.length; i < r; ++i){
                                const r = n.Notes[i];
                                if (t && r.NoteTie) {
                                    const t = s.Fraction.createFromFraction(r.Length);
                                    let i = !1;
                                    for (const e of r.NoteTie.Notes)e !== r ? i && t.Add(e.Length) : i = !0;
                                    e.lt(t) && (e = t);
                                } else e.lt(r.Length) && (e = r.Length);
                            }
                        }
                        return e;
                    }
                    hasNotes() {
                        for(let t = 0, e = this.VoiceEntries.length; t < e; ++t)if (this.VoiceEntries[t].Notes.length > 0) return !0;
                        return !1;
                    }
                    hasTie() {
                        for(let t = 0, e = this.VoiceEntries.length; t < e; ++t)if (this.VoiceEntries[t].hasTie()) return !0;
                        return !1;
                    }
                    findLinkedNotes(t) {
                        for(let e = 0, i = this.voiceEntries.length; e < i; ++e){
                            const i = this.voiceEntries[e];
                            for(let e = 0, s = i.Notes.length; e < s; ++e){
                                const s = i.Notes[e];
                                s.ParentStaffEntry === this && t.push(s);
                            }
                        }
                    }
                    get hasOnlyRests() {
                        for (const t of this.voiceEntries)for (const e of t.Notes)if (!e.isRest()) return !1;
                        return !0;
                    }
                };
            },
            1910 (t, e) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.Staff = void 0, e.Staff = class {
                    constructor(t, e){
                        this.isTab = !1, this.voices = [], this.volume = 1, this.stafflineCount = 5, this.hasLyrics = !1, this.openTieDict = {}, this.parentInstrument = t, this.id = e, this.audible = !0, this.Visible = !0, this.following = !0;
                    }
                    get ParentInstrument() {
                        return this.parentInstrument;
                    }
                    set ParentInstrument(t) {
                        this.parentInstrument = t;
                    }
                    get Voices() {
                        return this.voices;
                    }
                    get Id() {
                        return this.id;
                    }
                    get Volume() {
                        return this.volume;
                    }
                    set Volume(t) {
                        this.volume = t;
                    }
                    get StafflineCount() {
                        return this.stafflineCount;
                    }
                    set StafflineCount(t) {
                        this.stafflineCount = t;
                    }
                    isVisible() {
                        return this.Visible && this.ParentInstrument.Visible;
                    }
                };
            },
            6644 (t, e) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.StaffEntryLink = void 0, e.StaffEntryLink = class {
                    constructor(t){
                        this.linkStaffEntries = [], this.voiceEntry = t;
                    }
                    get GetVoiceEntry() {
                        return this.voiceEntry;
                    }
                    get LinkStaffEntries() {
                        return this.linkStaffEntries;
                    }
                    set LinkStaffEntries(t) {
                        this.linkStaffEntries = t;
                    }
                };
            },
            9647 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.TabNote = void 0;
                const s = i(1850);
                class n extends s.Note {
                    constructor(t, e, i, s, n, r, o, a){
                        super(t, e, i, s, n), this.stringNumberTab = r, this.fretNumber = o, this.bendArray = a;
                    }
                    get StringNumberTab() {
                        return this.stringNumberTab;
                    }
                    get FretNumber() {
                        return this.fretNumber;
                    }
                    get BendArray() {
                        return this.bendArray;
                    }
                    hasTabEffects() {
                        return this.bendArray?.length > 0;
                    }
                }
                e.TabNote = n;
            },
            5274 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.Tie = void 0;
                const n = i(2561), r = i(6362), o = s(i(3065));
                e.Tie = class {
                    constructor(t, e){
                        this.notes = [], this.TieNumber = 1, this.TieDirection = r.PlacementEnum.NotYetDefined, this.NoteIndexToTieDirection = {}, this.AddNote(t), this.type = e;
                    }
                    getTieDirection(t) {
                        if (!t) return this.TieDirection;
                        const e = this.Notes.indexOf(t);
                        if (e < 0) return o.default.debug("Tie.getTieDirection(): note not in tie.Notes"), this.TieDirection;
                        for(let t = e; t > 0; t--){
                            const e = this.NoteIndexToTieDirection[t];
                            if (void 0 !== e && e !== r.PlacementEnum.NotYetDefined) return e;
                        }
                        return this.TieDirection;
                    }
                    get Notes() {
                        return this.notes;
                    }
                    get Type() {
                        return this.type;
                    }
                    get StartNote() {
                        return this.notes[0];
                    }
                    get Duration() {
                        const t = new n.Fraction;
                        for (const e of this.notes)t.Add(e.Length);
                        return t;
                    }
                    get Pitch() {
                        return this.StartNote.Pitch;
                    }
                    AddNote(t) {
                        this.notes.push(t), t.NoteTie = this;
                    }
                };
            },
            4268 (t, e) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.Tuplet = void 0, e.Tuplet = class {
                    constructor(t, e = !1){
                        this.PlacementFromXml = !1, this.RenderTupletNumber = !0, this.notes = [], this.fractions = [], this.tupletLabelNumber = t, this.bracket = e;
                    }
                    shouldBeBracketed(t, e, i, s = !1, n = !1) {
                        if (s) return n;
                        if (t && void 0 !== this.BracketedXmlValue) return this.BracketedXmlValue;
                        const r = this.Notes[0][0].NoteBeam;
                        if (!r) return !0;
                        for (const t of this.Notes)if (t[0].NoteBeam !== r) return !0;
                        return this.Bracket || 3 === this.TupletLabelNumber && i || 3 !== this.TupletLabelNumber && e;
                    }
                    get TupletLabelNumber() {
                        return this.tupletLabelNumber;
                    }
                    set TupletLabelNumber(t) {
                        this.tupletLabelNumber = t;
                    }
                    get Notes() {
                        return this.notes;
                    }
                    set Notes(t) {
                        this.notes = t;
                    }
                    get Fractions() {
                        return this.fractions;
                    }
                    set Fractions(t) {
                        this.fractions = t;
                    }
                    get Bracket() {
                        return this.bracket;
                    }
                    set Bracket(t) {
                        this.bracket = t;
                    }
                    getNoteIndex(t) {
                        for(let e = this.notes.length - 1; e >= 0; e--)for(let i = 0; i < this.notes[e].length; i++)if (t === this.notes[e][i]) return e;
                        return 0;
                    }
                };
            },
            3236 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.VerticalSourceStaffEntryContainer = void 0;
                const s = i(2561);
                e.VerticalSourceStaffEntryContainer = class {
                    constructor(t, e, i){
                        this.staffEntries = [], this.comments = [], this.timestamp = e, this.staffEntries = new Array(i), this.parentMeasure = t;
                    }
                    $get$(t) {
                        return this.staffEntries[t];
                    }
                    $set$(t, e) {
                        this.staffEntries[t] = e;
                    }
                    get Timestamp() {
                        return this.timestamp;
                    }
                    set Timestamp(t) {
                        this.timestamp = t;
                    }
                    get StaffEntries() {
                        return this.staffEntries;
                    }
                    set StaffEntries(t) {
                        this.staffEntries = t;
                    }
                    get Comments() {
                        return this.comments;
                    }
                    set Comments(t) {
                        this.comments = t;
                    }
                    get ParentMeasure() {
                        return this.parentMeasure;
                    }
                    set ParentMeasure(t) {
                        this.parentMeasure = t;
                    }
                    getAbsoluteTimestamp() {
                        return s.Fraction.plus(this.timestamp, this.parentMeasure.AbsoluteTimestamp);
                    }
                };
            },
            5534 (t, e) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.Voice = void 0, e.Voice = class {
                    constructor(t, e){
                        this.voiceEntries = [], this.volume = 1, this.parent = t, this.visible = !0, this.audible = !0, this.following = !0, this.voiceId = e;
                    }
                    get VoiceEntries() {
                        return this.voiceEntries;
                    }
                    get Parent() {
                        return this.parent;
                    }
                    get Visible() {
                        return this.visible;
                    }
                    set Visible(t) {
                        this.visible = t;
                    }
                    get Audible() {
                        return this.audible;
                    }
                    set Audible(t) {
                        this.audible = t;
                    }
                    get Following() {
                        return this.following;
                    }
                    set Following(t) {
                        this.following = t;
                    }
                    get VoiceId() {
                        return this.voiceId;
                    }
                    get Volume() {
                        return this.volume;
                    }
                    set Volume(t) {
                        this.volume = t;
                    }
                };
            },
            1336 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.StemDirectionType = e.ArticulationEnum = e.VoiceEntry = void 0;
                const s = i(2561), n = i(1850), r = i(8233), o = i(8215), a = i(8233), l = i(3263);
                class h {
                    constructor(t, e, i, s = !1, n = !1, r = !1){
                        if (this.notes = [], this.articulations = [], this.technicalInstructions = [], this.lyricsEntries = new l.Dictionary, this.wantedStemDirection = u.Undefined, this.stemDirectionXml = u.Undefined, this.stemDirection = u.Undefined, this.timestamp = t, this.parentVoice = e, this.parentSourceStaffEntry = i, this.isGrace = s, this.graceAfterMainNote = !1, this.graceNoteSlash = n, this.graceSlur = r, void 0 !== i) {
                            const t = i.VoiceEntries;
                            -1 === t.indexOf(this) && t.push(this);
                        }
                    }
                    get ParentSourceStaffEntry() {
                        return this.parentSourceStaffEntry;
                    }
                    set ParentSourceStaffEntry(t) {
                        this.parentSourceStaffEntry = t;
                        for (const e of this.notes)e.ParentStaffEntry = t;
                    }
                    get ParentVoice() {
                        return this.parentVoice;
                    }
                    get Timestamp() {
                        return this.timestamp;
                    }
                    set Timestamp(t) {
                        this.timestamp = t;
                    }
                    get Notes() {
                        return this.notes;
                    }
                    get IsGrace() {
                        return this.isGrace;
                    }
                    set IsGrace(t) {
                        this.isGrace = t;
                    }
                    get GraceAfterMainNote() {
                        return this.graceAfterMainNote;
                    }
                    set GraceAfterMainNote(t) {
                        this.graceAfterMainNote = t;
                    }
                    get GraceNoteSlash() {
                        return this.graceNoteSlash;
                    }
                    set GraceNoteSlash(t) {
                        this.graceNoteSlash = t;
                    }
                    get GraceSlur() {
                        return this.graceSlur;
                    }
                    set GraceSlur(t) {
                        this.graceSlur = t;
                    }
                    get Articulations() {
                        return this.articulations;
                    }
                    set Articulations(t) {
                        this.articulations = t;
                    }
                    get TechnicalInstructions() {
                        return this.technicalInstructions;
                    }
                    get LyricsEntries() {
                        return this.lyricsEntries;
                    }
                    get Arpeggio() {
                        return this.arpeggio;
                    }
                    set Arpeggio(t) {
                        this.arpeggio = t;
                    }
                    get OrnamentContainer() {
                        return this.ornamentContainer;
                    }
                    set OrnamentContainer(t) {
                        this.ornamentContainer = t;
                    }
                    set WantedStemDirection(t) {
                        this.wantedStemDirection = t;
                    }
                    get WantedStemDirection() {
                        return this.wantedStemDirection;
                    }
                    set StemDirectionXml(t) {
                        this.stemDirectionXml = t;
                    }
                    get StemDirectionXml() {
                        return this.stemDirectionXml;
                    }
                    set StemDirection(t) {
                        this.stemDirection = t;
                    }
                    get StemDirection() {
                        return this.stemDirection;
                    }
                    get StemColorXml() {
                        return this.stemColorXml;
                    }
                    set StemColorXml(t) {
                        this.stemColorXml = t;
                    }
                    get StemColor() {
                        return this.stemColor;
                    }
                    set StemColor(t) {
                        this.stemColor = t;
                    }
                    hasArticulation(t) {
                        for (const e of this.articulations)if (e.Equals(t)) return !0;
                        return !1;
                    }
                    static isSupportedArticulation(t) {
                        switch(t){
                            case c.accent:
                            case c.strongaccent:
                            case c.softaccent:
                            case c.invertedstrongaccent:
                            case c.staccato:
                            case c.staccatissimo:
                            case c.spiccato:
                            case c.tenuto:
                            case c.fermata:
                            case c.invertedfermata:
                            case c.breathmark:
                            case c.caesura:
                            case c.lefthandpizzicato:
                            case c.naturalharmonic:
                            case c.snappizzicato:
                            case c.upbow:
                            case c.downbow:
                            case c.bend:
                                return !0;
                            default:
                                return !1;
                        }
                    }
                    hasTie() {
                        for(let t = 0, e = this.Notes.length; t < e; ++t)if (this.Notes[t].NoteTie) return !0;
                        return !1;
                    }
                    hasSlur() {
                        for(let t = 0, e = this.Notes.length; t < e; ++t)if (this.Notes[t].NoteSlurs.length > 0) return !0;
                        return !1;
                    }
                    isStaccato() {
                        for (const t of this.Articulations)if (t.articulationEnum === c.staccato) return !0;
                        return !1;
                    }
                    isAccent() {
                        for (const t of this.Articulations)if (t.articulationEnum === c.accent || t.articulationEnum === c.strongaccent) return !0;
                        return !1;
                    }
                    getVerseNumberForLyricEntry(t) {
                        let e = "1";
                        return this.lyricsEntries.forEach((i, s)=>{
                            t === s && (e = i);
                        }), e;
                    }
                    createVoiceEntriesForOrnament(t, e) {
                        t || (t = this);
                        const i = [];
                        if (!t.ornamentContainer) return;
                        const n = this.notes[0], r = n.Length, l = t.ParentVoice, h = t.Timestamp;
                        let c = s.Fraction.createFromFraction(h);
                        switch(t.ornamentContainer.GetOrnament){
                            case o.OrnamentEnum.Trill:
                                {
                                    const o = new s.Fraction(r.Numerator, 8 * r.Denominator), u = n.Pitch.getTransposedPitch(1);
                                    let d = e.getAlterationForPitch(u);
                                    t.OrnamentContainer.AccidentalAbove !== a.AccidentalEnum.NONE && (d = t.ornamentContainer.AccidentalAbove);
                                    for(let t = 0; t < 8; t++)c = s.Fraction.plus(h, new s.Fraction(t * o.Numerator, o.Denominator)), t % 2 == 0 ? this.createBaseVoiceEntry(c, o, l, n, i) : this.createAlteratedVoiceEntry(c, o, l, n.SourceMeasure, u, d, i);
                                    break;
                                }
                            case o.OrnamentEnum.Turn:
                                {
                                    const t = new s.Fraction(r.Numerator, 4 * r.Denominator), o = n.Pitch.getTransposedPitch(-1), a = e.getAlterationForPitch(o), h = n.Pitch.getTransposedPitch(1), u = e.getAlterationForPitch(h);
                                    this.createAlteratedVoiceEntry(c, t, l, n.SourceMeasure, h, u, i), c.Add(t), this.createBaseVoiceEntry(c, t, l, n, i), c.Add(t), this.createAlteratedVoiceEntry(c, t, l, n.SourceMeasure, o, a, i), c.Add(t), this.createBaseVoiceEntry(c, t, l, n, i);
                                    break;
                                }
                            case o.OrnamentEnum.InvertedTurn:
                                {
                                    const t = new s.Fraction(r.Numerator, 4 * r.Denominator), o = n.Pitch.getTransposedPitch(-1), a = e.getAlterationForPitch(o), h = n.Pitch.getTransposedPitch(1), u = e.getAlterationForPitch(h);
                                    this.createAlteratedVoiceEntry(c, t, l, n.SourceMeasure, o, a, i), c.Add(t), this.createBaseVoiceEntry(c, t, l, n, i), c.Add(t), this.createAlteratedVoiceEntry(c, t, l, n.SourceMeasure, h, u, i), c.Add(t), this.createBaseVoiceEntry(c, t, l, n, i);
                                    break;
                                }
                            case o.OrnamentEnum.DelayedTurn:
                                {
                                    const t = new s.Fraction(r.Numerator, 2 * r.Denominator), o = n.Pitch.getTransposedPitch(-1), a = e.getAlterationForPitch(o), u = n.Pitch.getTransposedPitch(1), d = e.getAlterationForPitch(u);
                                    this.createBaseVoiceEntry(c, t, l, n, i), c = s.Fraction.plus(h, t), t.Denominator = 8 * r.Denominator, this.createAlteratedVoiceEntry(c, t, l, n.SourceMeasure, u, d, i), c.Add(t), this.createBaseVoiceEntry(c, t, l, n, i), c.Add(t), this.createAlteratedVoiceEntry(c, t, l, n.SourceMeasure, o, a, i), c.Add(t), this.createBaseVoiceEntry(c, t, l, n, i);
                                    break;
                                }
                            case o.OrnamentEnum.DelayedInvertedTurn:
                                {
                                    const t = new s.Fraction(r.Numerator, 2 * r.Denominator), o = n.Pitch.getTransposedPitch(-1), a = e.getAlterationForPitch(o), u = n.Pitch.getTransposedPitch(1), d = e.getAlterationForPitch(u);
                                    this.createBaseVoiceEntry(c, t, l, n, i), c = s.Fraction.plus(h, t), t.Denominator = 8 * r.Denominator, this.createAlteratedVoiceEntry(c, t, l, n.SourceMeasure, o, a, i), c.Add(t), this.createBaseVoiceEntry(c, t, l, n, i), c.Add(t), this.createAlteratedVoiceEntry(c, t, l, n.SourceMeasure, u, d, i), c.Add(t), this.createBaseVoiceEntry(c, t, l, n, i);
                                    break;
                                }
                            case o.OrnamentEnum.Mordent:
                                {
                                    const t = new s.Fraction(r.Numerator, 4 * r.Denominator), o = n.Pitch.getTransposedPitch(1), a = e.getAlterationForPitch(o);
                                    this.createBaseVoiceEntry(c, t, l, n, i), c.Add(t), this.createAlteratedVoiceEntry(c, t, l, n.SourceMeasure, o, a, i), t.Denominator = 2 * r.Denominator, c = s.Fraction.plus(h, t), this.createBaseVoiceEntry(c, t, l, n, i);
                                    break;
                                }
                            case o.OrnamentEnum.InvertedMordent:
                                {
                                    const t = new s.Fraction(r.Numerator, 4 * r.Denominator), o = n.Pitch.getTransposedPitch(-1), a = e.getAlterationForPitch(o);
                                    this.createBaseVoiceEntry(c, t, l, n, i), c.Add(t), this.createAlteratedVoiceEntry(c, t, l, n.SourceMeasure, o, a, i), t.Denominator = 2 * r.Denominator, c = s.Fraction.plus(h, t), this.createBaseVoiceEntry(c, t, l, n, i);
                                    break;
                                }
                            default:
                                throw new RangeError;
                        }
                        return i;
                    }
                    createBaseVoiceEntry(t, e, i, s, o) {
                        const a = new h(t, i, s.ParentStaffEntry), l = new r.Pitch(s.Pitch.FundamentalNote, s.Pitch.Octave, s.Pitch.Accidental), c = new n.Note(a, void 0, e, l, s.SourceMeasure);
                        a.Notes.push(c), o.push(a);
                    }
                    createAlteratedVoiceEntry(t, e, i, s, o, a, l) {
                        const c = new h(t, i, void 0), u = new r.Pitch(o.FundamentalNote, o.Octave, a), d = new n.Note(c, void 0, e, u, s);
                        c.Notes.push(d), l.push(c);
                    }
                }
                var c, u;
                e.VoiceEntry = h, function(t) {
                    t[t.accent = 0] = "accent", t[t.strongaccent = 1] = "strongaccent", t[t.softaccent = 2] = "softaccent", t[t.marcatoup = 3] = "marcatoup", t[t.marcatodown = 4] = "marcatodown", t[t.invertedstrongaccent = 5] = "invertedstrongaccent", t[t.staccato = 6] = "staccato", t[t.staccatissimo = 7] = "staccatissimo", t[t.spiccato = 8] = "spiccato", t[t.tenuto = 9] = "tenuto", t[t.fermata = 10] = "fermata", t[t.invertedfermata = 11] = "invertedfermata", t[t.breathmark = 12] = "breathmark", t[t.caesura = 13] = "caesura", t[t.lefthandpizzicato = 14] = "lefthandpizzicato", t[t.naturalharmonic = 15] = "naturalharmonic", t[t.snappizzicato = 16] = "snappizzicato", t[t.upbow = 17] = "upbow", t[t.downbow = 18] = "downbow", t[t.scoop = 19] = "scoop", t[t.plop = 20] = "plop", t[t.doit = 21] = "doit", t[t.falloff = 22] = "falloff", t[t.stress = 23] = "stress", t[t.unstress = 24] = "unstress", t[t.detachedlegato = 25] = "detachedlegato", t[t.otherarticulation = 26] = "otherarticulation", t[t.bend = 27] = "bend";
                }(c || (e.ArticulationEnum = c = {})), function(t) {
                    t[t.Undefined = -1] = "Undefined", t[t.Up = 0] = "Up", t[t.Down = 1] = "Down", t[t.None = 2] = "None", t[t.Double = 3] = "Double";
                }(u || (e.StemDirectionType = u = {}));
            },
            7456 (t, e, i) {
                "use strict";
                var s = this && this.__createBinding || (Object.create ? function(t, e, i, s) {
                    void 0 === s && (s = i);
                    var n = Object.getOwnPropertyDescriptor(e, i);
                    n && !("get" in n ? !e.__esModule : n.writable || n.configurable) || (n = {
                        enumerable: !0,
                        get: function() {
                            return e[i];
                        }
                    }), Object.defineProperty(t, s, n);
                } : function(t, e, i, s) {
                    void 0 === s && (s = i), t[s] = e[i];
                }), n = this && this.__exportStar || function(t, e) {
                    for(var i in t)"default" === i || Object.prototype.hasOwnProperty.call(e, i) || s(e, t, i);
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), n(i(4236), e), n(i(8365), e), n(i(9719), e), n(i(7718), e), n(i(4249), e), n(i(1850), e), n(i(4064), e), n(i(5282), e), n(i(8215), e), n(i(4387), e), n(i(2369), e), n(i(1910), e), n(i(6644), e), n(i(5274), e), n(i(4268), e), n(i(3236), e), n(i(5534), e), n(i(1336), e), n(i(9184), e), n(i(1850), e), n(i(5282), e), n(i(4387), e), n(i(2369), e), n(i(3236), e), n(i(5274), e);
            },
            1745 (t, e, i) {
                "use strict";
                var s = this && this.__createBinding || (Object.create ? function(t, e, i, s) {
                    void 0 === s && (s = i);
                    var n = Object.getOwnPropertyDescriptor(e, i);
                    n && !("get" in n ? !e.__esModule : n.writable || n.configurable) || (n = {
                        enumerable: !0,
                        get: function() {
                            return e[i];
                        }
                    }), Object.defineProperty(t, s, n);
                } : function(t, e, i, s) {
                    void 0 === s && (s = i), t[s] = e[i];
                }), n = this && this.__exportStar || function(t, e) {
                    for(var i in t)"default" === i || Object.prototype.hasOwnProperty.call(e, i) || s(e, t, i);
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), n(i(7307), e), n(i(9252), e), n(i(7586), e), n(i(7435), e), n(i(427), e), n(i(5294), e), n(i(7456), e), n(i(4076), e), n(i(3502), e), n(i(6352), e), n(i(899), e), n(i(2870), e);
            },
            3173 (t, e) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.AJAX = void 0, e.AJAX = class {
                    static ajax(t, e = 9e3) {
                        let i;
                        const s = t.indexOf(".mxl") > -1 ? "text/plain; charset=x-user-defined" : "application/xml";
                        if (XMLHttpRequest) i = new XMLHttpRequest;
                        else {
                            if (!ActiveXObject) return Promise.reject(new Error("XMLHttp not supported."));
                            i = new ActiveXObject("Microsoft.XMLHTTP");
                        }
                        return i.timeout = e, new Promise((e, n)=>{
                            i.onreadystatechange = ()=>{
                                i.readyState === XMLHttpRequest.DONE && (200 === i.status || 0 === i.status && i.responseText ? e(i.responseText) : n(new Error("Could not retrieve requested URL " + i.status)));
                            }, i.ontimeout = (t)=>{
                                n(new Error("Server request Timeout"));
                            }, i.overrideMimeType(s), i.open("GET", t, !0), i.send();
                        });
                    }
                };
            },
            6597 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.Cursor = void 0;
                const s = i(2561), n = i(624);
                e.Cursor = class {
                    constructor(t, e, i){
                        this.hidden = !0, this.currentPageNumber = 1, this.skipInvisibleNotes = !0, this.container = t, this.openSheetMusicDisplay = e, this.rules = this.openSheetMusicDisplay.EngravingRules, this.cursorOptions = i;
                        let s = 0;
                        for(this.cursorElementId = "cursorImg-0"; document.getElementById(this.cursorElementId);)s++, this.cursorElementId = `cursorImg-${s}`;
                        const n = document.createElement("img");
                        n.id = this.cursorElementId, n.alt = "", n.draggable = !1, n.style.position = "absolute", !0 === this.cursorOptions.follow ? (this.wantedZIndex = "-1", n.style.zIndex = this.wantedZIndex) : (this.wantedZIndex = "-2", n.style.zIndex = this.wantedZIndex), this.cursorElement = n, this.container.appendChild(n);
                    }
                    adjustToBackgroundColor() {
                        let t;
                        t = this.rules.PageBackgroundColor ? "1" : this.wantedZIndex, this.cursorElement.style.zIndex = t;
                    }
                    init(t, e) {
                        this.manager = t, this.graphic = e, this.reset(), this.hidden = !0, this.hide();
                    }
                    show() {
                        this.hidden = !1, this.update(), this.adjustToBackgroundColor();
                    }
                    resetIterator() {
                        if (!this.openSheetMusicDisplay.Sheet || !this.openSheetMusicDisplay.Sheet.SourceMeasures) return void console.log("OSMD.Cursor.resetIterator(): sheet or measures were null/undefined.");
                        const t = this.openSheetMusicDisplay.Sheet.SourceMeasures.length - 1;
                        let e = this.rules.MinMeasureToDrawIndex;
                        e = Math.min(e, t);
                        let i = this.rules.MaxMeasureToDrawIndex;
                        if (this.rules.LazyConsistentGraphic && (i = t), i = Math.min(i, t), this.openSheetMusicDisplay.Sheet && this.openSheetMusicDisplay.Sheet.SourceMeasures.length > e && (this.openSheetMusicDisplay.Sheet.SelectionStart = this.openSheetMusicDisplay.Sheet.SourceMeasures[e].AbsoluteTimestamp), this.openSheetMusicDisplay.Sheet && this.openSheetMusicDisplay.Sheet.SourceMeasures.length > i) {
                            const t = this.openSheetMusicDisplay.Sheet.SourceMeasures[i];
                            this.openSheetMusicDisplay.Sheet.SelectionEnd = s.Fraction.plus(t.AbsoluteTimestamp, t.Duration);
                        }
                        this.iterator = this.manager.getIterator(), this.iterator.SkipInvisibleNotes = this.skipInvisibleNotes;
                    }
                    getStaffEntryFromVoiceEntry(t) {
                        const e = t.ParentSourceStaffEntry.VerticalContainerParent.ParentMeasure.measureListIndex, i = t.ParentSourceStaffEntry.ParentStaff.idInMusicSheet;
                        return this.graphic.findGraphicalStaffEntryFromMeasureList(i, e, t.ParentSourceStaffEntry);
                    }
                    update() {
                        if (this.hidden || void 0 === this.hidden || null === this.hidden) return;
                        if (this.updateCurrentPage(), !this.getPageElement(this.currentPageNumber)) return void (this.cursorElement.style.display = "none");
                        const t = this.iterator;
                        let e, i = t.CurrentVisibleVoiceEntries(), s = t.CurrentMeasureIndex, n = 0, r = 0, o = 0;
                        if (0 !== i.length || t.FrontReached || t.EndReached || (t.moveToPrevious(), i = t.CurrentVisibleVoiceEntries(), t.moveToNext()), t.FrontReached && 0 === i.length) {
                            t.moveToNext(), i = t.CurrentVisibleVoiceEntries();
                            const s = this.findVisibleGraphicalMeasure(t.CurrentMeasureIndex);
                            n = s.PositionAndShape.AbsolutePosition.x, e = s.ParentMusicSystem, t.moveToPrevious();
                        } else if (t.EndReached || !t.CurrentVoiceEntries || 0 === i.length) {
                            t.moveToPrevious(), i = t.CurrentVisibleVoiceEntries(), s = t.CurrentMeasureIndex;
                            const r = this.findVisibleGraphicalMeasure(t.CurrentMeasureIndex);
                            n = r.PositionAndShape.AbsolutePosition.x + r.PositionAndShape.Size.width, e = r.ParentMusicSystem, t.moveToNext();
                        } else if (t.CurrentMeasure.isReducedToMultiRest) {
                            const i = this.findVisibleGraphicalMeasure(t.CurrentMeasureIndex), s = i.parentSourceMeasure.multipleRestMeasures, r = t.CurrentMeasure.multipleRestMeasureNumber / (s + 1), o = i.PositionAndShape.Size.width - i.beginInstructionsWidth;
                            n = i.PositionAndShape.AbsolutePosition.x + i.beginInstructionsWidth + r * o, e = i.ParentMusicSystem;
                        } else {
                            const s = i.map((t)=>this.getStaffEntryFromVoiceEntry(t)), r = s.filter((t)=>t && this.graphic.isReliableCursorXAnchor(t)).sort((t, e)=>t?.PositionAndShape?.AbsolutePosition?.x <= e?.PositionAndShape?.AbsolutePosition?.x ? -1 : 1)[0];
                            if (r) n = r.PositionAndShape.AbsolutePosition.x, e = r.parentMeasure.ParentMusicSystem;
                            else if (s.length > 0) {
                                const [i, s] = this.graphic.calculateXPositionFromTimestamp(t.currentTimeStamp);
                                n = i, e = s;
                            }
                        }
                        if (!e?.StaffLines[0]) return;
                        r = e.PositionAndShape.AbsolutePosition.y + e.StaffLines[0].PositionAndShape.RelativePosition.y;
                        let a = e.PositionAndShape.AbsolutePosition.y;
                        const l = e.StaffLines[e.StaffLines.length - 1];
                        l && (a += l.PositionAndShape.RelativePosition.y + l.StaffHeight), o = a - r;
                        const h = this.findVisibleGraphicalMeasure(s);
                        if (!h) return;
                        const c = h.PositionAndShape;
                        if (this.updateWidthAndStyle(c, n, r, o), this.openSheetMusicDisplay.FollowCursor && this.cursorOptions.follow) {
                            if (this.openSheetMusicDisplay.EngravingRules.RenderSingleHorizontalStaffline) this.cursorElement.scrollIntoView({
                                behavior: "smooth",
                                inline: "center"
                            });
                            else {
                                const t = this.cursorElement.getBoundingClientRect().top;
                                this.cursorElement.scrollIntoView({
                                    behavior: t < 1e3 ? "smooth" : "auto",
                                    block: "center"
                                });
                            }
                        }
                        this.cursorElement.style.display = "";
                    }
                    findVisibleGraphicalMeasure(t) {
                        for(let t = 0; t < this.graphic.NumberOfStaves; t++){
                            const e = this.graphic.findGraphicalMeasure(this.iterator.CurrentMeasureIndex, t);
                            if (e?.ParentStaff.isVisible()) return e;
                        }
                    }
                    updateWidthAndStyle(t, e, i, s) {
                        const r = this.cursorElement;
                        let o = 0, a = 0;
                        switch(this.cursorOptions.type){
                            case n.CursorType.ThinLeft:
                                r.style.top = 10 * i * this.openSheetMusicDisplay.zoom + "px", r.style.left = 10 * (e - 1.5) * this.openSheetMusicDisplay.zoom + "px", a = 10 * s * this.openSheetMusicDisplay.zoom, o = 5 * this.openSheetMusicDisplay.zoom;
                                break;
                            case n.CursorType.ShortThinTopLeft:
                                r.style.top = 10 * (i - 2.5) * this.openSheetMusicDisplay.zoom + "px", r.style.left = 10 * e * this.openSheetMusicDisplay.zoom + "px", a = 15 * this.openSheetMusicDisplay.zoom, o = 5 * this.openSheetMusicDisplay.zoom;
                                break;
                            case n.CursorType.CurrentArea:
                                r.style.top = 10 * t.AbsolutePosition.y * this.openSheetMusicDisplay.zoom + "px", r.style.left = 10 * t.AbsolutePosition.x * this.openSheetMusicDisplay.zoom + "px", a = 10 * s * this.openSheetMusicDisplay.zoom, o = 10 * t.Size.width * this.openSheetMusicDisplay.zoom;
                                break;
                            case n.CursorType.CurrentAreaLeft:
                                r.style.top = 10 * t.AbsolutePosition.y * this.openSheetMusicDisplay.zoom + "px", r.style.left = 10 * t.AbsolutePosition.x * this.openSheetMusicDisplay.zoom + "px", a = 10 * s * this.openSheetMusicDisplay.zoom, o = 10 * (e - t.AbsolutePosition.x) * this.openSheetMusicDisplay.zoom;
                                break;
                            default:
                                r.style.top = 10 * i * this.openSheetMusicDisplay.zoom + "px", r.style.left = 10 * (e - 1.5) * this.openSheetMusicDisplay.zoom + "px", a = 10 * s * this.openSheetMusicDisplay.zoom, o = 30 * this.openSheetMusicDisplay.zoom;
                        }
                        r.height = a, "important" !== r.style.getPropertyPriority("height") && (r.style.height = a + "px"), r.width = o, this.cursorImageOutdated(o) && this.updateStyle(o, this.cursorOptions);
                    }
                    cursorImageOutdated(t) {
                        const e = this.cursorOptionsRendered;
                        return void 0 === e || t !== this.cursorWidthRendered && !this.hasSolidColor() || e.type !== this.cursorOptions.type || e.color !== this.cursorOptions.color || e.alpha !== this.cursorOptions.alpha;
                    }
                    hide() {
                        this.cursorElement.style.display = "none", this.hidden = !0;
                    }
                    previous() {
                        this.iterator.moveToPreviousVisibleVoiceEntry(!1), this.update();
                    }
                    next() {
                        this.iterator.moveToNextVisibleVoiceEntry(!1), this.update();
                    }
                    reset() {
                        this.resetIterator(), this.update();
                    }
                    updateStyle(t, e) {
                        void 0 !== e && (this.cursorOptions = e);
                        const i = document.createElement("canvas");
                        i.width = this.hasSolidColor() ? 1 : Math.max(1, Math.floor(t)), i.height = 1;
                        const s = i.getContext("2d");
                        if (s.globalAlpha = this.cursorOptions.alpha, s.fillStyle = this.cursorOptions.color, s.fillRect(0, 0, i.width, 1), !this.hasSolidColor()) {
                            s.globalAlpha = 1, s.globalCompositeOperation = "destination-in";
                            const t = s.createLinearGradient(0, 0, i.width, 0);
                            t.addColorStop(0, "rgba(0,0,0,0)"), t.addColorStop(.2, "rgba(0,0,0,1)"), t.addColorStop(.8, "rgba(0,0,0,1)"), t.addColorStop(1, "rgba(0,0,0,0)"), s.fillStyle = t, s.fillRect(0, 0, i.width, 1);
                        }
                        this.cursorOptionsRendered = {
                            ...this.cursorOptions
                        }, this.cursorWidthRendered = t, this.cursorElement.src = i.toDataURL("image/png");
                    }
                    hasSolidColor() {
                        switch(this.cursorOptions.type){
                            case n.CursorType.ThinLeft:
                            case n.CursorType.ShortThinTopLeft:
                            case n.CursorType.CurrentArea:
                            case n.CursorType.CurrentAreaLeft:
                                return !0;
                            default:
                                return !1;
                        }
                    }
                    get Iterator() {
                        return this.iterator;
                    }
                    get Hidden() {
                        return this.hidden;
                    }
                    VoicesUnderCursor(t) {
                        return this.iterator.CurrentVisibleVoiceEntries(t);
                    }
                    NotesUnderCursor(t) {
                        const e = this.VoicesUnderCursor(t), i = [];
                        return e.forEach((t)=>{
                            i.push(...t.Notes);
                        }), i;
                    }
                    GNotesUnderCursor(t) {
                        const e = this.VoicesUnderCursor(t), i = [];
                        return e.forEach((t)=>{
                            i.push(...t.Notes.map((t)=>this.rules.GNote(t)));
                        }), i;
                    }
                    updateCurrentPage() {
                        let t = this.iterator.currentTimeStamp;
                        t.RealValue < 0 && (t = new s.Fraction(0, 0));
                        for (const e of this.graphic.MusicPages)if (e.MusicSystems.last().GetSystemsLastTimeStamp().gt(t)) {
                            const t = e.PageNumber;
                            return t !== this.currentPageNumber && this.attachToPage(t), this.currentPageNumber = t;
                        }
                        return 1;
                    }
                    attachToPage(t) {
                        const e = this.getPageElement(t);
                        e && (this.container.removeChild(this.cursorElement), this.container = e, this.container.appendChild(this.cursorElement));
                    }
                    getPageElement(t) {
                        return this.openSheetMusicDisplay.Drawer.Backends[t - 1]?.getInnerElement();
                    }
                    get SkipInvisibleNotes() {
                        return this.skipInvisibleNotes;
                    }
                    set SkipInvisibleNotes(t) {
                        this.skipInvisibleNotes = t, this.iterator.SkipInvisibleNotes = t;
                    }
                    get CursorOptions() {
                        return this.cursorOptions;
                    }
                    set CursorOptions(t) {
                        this.cursorOptions = t;
                    }
                    Dispose() {
                        this.hide(), this.container.removeChild(this.cursorElement), this.rules = void 0, this.openSheetMusicDisplay = void 0, this.cursorOptions = void 0;
                    }
                    nextMeasure() {
                        const t = this.Iterator.CurrentMeasure;
                        let e = this.Iterator.currentTimeStamp.RealValue;
                        this.next();
                        let i = 0;
                        for(; this.Iterator.CurrentMeasure === t && this.Iterator.currentTimeStamp.RealValue !== e && i < 999;)e = this.Iterator.currentTimeStamp.RealValue, this.next(), i++;
                    }
                    previousMeasure() {
                        const t = this.Iterator.CurrentMeasure;
                        let e = this.Iterator.currentTimeStamp.RealValue;
                        this.previous();
                        let i = 0;
                        for(; this.Iterator.CurrentMeasure === t && this.Iterator.currentTimeStamp.RealValue !== e && i < 999;)e = this.Iterator.currentTimeStamp.RealValue, this.previous(), i++;
                        for(i = 0; 0 !== this.Iterator.CurrentRelativeInMeasureTimestamp.RealValue && i < 999;)this.previous(), i++;
                    }
                };
            },
            624 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.OSMDOptions = e.SkyBottomLineBatchCalculatorBackendType = e.BackendType = e.FillEmptyMeasuresWithWholeRests = e.AlignRestOption = e.CursorType = void 0;
                const s = i(4146);
                var n, r, o, a, l;
                !function(t) {
                    t[t.Standard = 0] = "Standard", t[t.ThinLeft = 1] = "ThinLeft", t[t.ShortThinTopLeft = 2] = "ShortThinTopLeft", t[t.CurrentArea = 3] = "CurrentArea", t[t.CurrentAreaLeft = 4] = "CurrentAreaLeft";
                }(n || (e.CursorType = n = {})), function(t) {
                    t[t.Never = 0] = "Never", t[t.Always = 1] = "Always", t[t.Auto = 2] = "Auto";
                }(r || (e.AlignRestOption = r = {})), function(t) {
                    t[t.No = 0] = "No", t[t.YesVisible = 1] = "YesVisible", t[t.YesInvisible = 2] = "YesInvisible";
                }(o || (e.FillEmptyMeasuresWithWholeRests = o = {})), function(t) {
                    t[t.SVG = 0] = "SVG", t[t.Canvas = 1] = "Canvas";
                }(a || (e.BackendType = a = {})), function(t) {
                    t[t.Plain = 0] = "Plain", t[t.WebGL = 1] = "WebGL";
                }(l || (e.SkyBottomLineBatchCalculatorBackendType = l = {})), e.OSMDOptions = class {
                    static OSMDOptionsStandard() {
                        return {
                            autoResize: !0,
                            backend: "svg",
                            drawingParameters: s.DrawingParametersEnum.default
                        };
                    }
                    static BackendTypeFromString(t) {
                        return t && "canvas" === t.toLowerCase() ? a.Canvas : a.SVG;
                    }
                };
            },
            7103 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.OpenSheetMusicDisplay = void 0;
                const n = i(3902), r = i(806), o = i(9099), a = i(8724), l = i(7921), h = i(9479), c = i(9436), u = i(9834), d = i(6597), f = i(6888), m = i(3173), p = s(i(3065)), g = i(3661), b = i(4146), S = i(4434), y = i(624), E = i(9713), x = i(6362), v = i(3263), T = i(2683), _ = i(8233), M = i(1538);
                class P {
                    constructor(t, e = y.OSMDOptions.OSMDOptionsStandard()){
                        if (this.version = "2.2.1-release", this.cursors = [], this.zoom = 1, this.zoomUpdated = !1, this.loadUrlTimeout = 5e3, this.OnXMLRead = (t)=>t, this.lazyDrawnSystemCount = 0, this.lazyDrawnSystemPositions = [], this.lazyDrawnHMeasureCount = 0, this.lazyIncrementalActive = !1, this.lazyNextSourceIndex = 0, this.lazyLayoutWidth = 0, this.lazySavedMinMeasureToDrawIndex = 0, this.lazySavedMaxMeasureToDrawIndex = 0, "string" == typeof t ? this.container = document.getElementById(t) : t && "appendChild" in t && (this.container = t), !this.container) throw new Error("Please pass a valid div container to OpenSheetMusicDisplay");
                        void 0 === e.autoResize && (e.autoResize = !0), this.backendType = y.BackendType.SVG, this.setOptions(e);
                    }
                    get cursor() {
                        return this.cursors[0];
                    }
                    get Cursor() {
                        return this.cursor;
                    }
                    load(t, e = "Untitled Score") {
                        this.reset();
                        const i = this;
                        if (t instanceof Blob) {
                            const s = new f.MXLFile(t);
                            return s.tryUnzip().then(()=>s.unzipSuccessful ? s.getXmlString().then((t)=>i.load(t, e)) : t instanceof Blob ? t.text().then((t)=>i.load(t, e)) : void 0);
                        }
                        if ("string" == typeof t) {
                            const s = t;
                            if (s.startsWith("PK")) return p.default.debug("[OSMD] This is a zip file, unpack it first: " + s), f.MXLHelper.MXLtoXMLstring(s).then((t)=>i.load(t, e), (t)=>{
                                throw p.default.debug(t), new Error("OpenSheetMusicDisplay: Invalid MXL file");
                            });
                            if (s.startsWith("\uF7EF\uF7BB\uF7BF")) return p.default.debug("[OSMD] UTF with BOM detected, truncate first 3 bytes and pass along: " + s), i.load(s.substring(3), e);
                            let n = s;
                            if (/^\s/.test(n) && (n = n.trim()), n.startsWith("<?xml")) {
                                const e = this.OnXMLRead(n);
                                p.default.debug("[OSMD] Finally parsing XML content, length: " + e.length);
                                const i = new DOMParser;
                                t = i.parseFromString(e, "application/xml");
                            } else {
                                if (n.length < 2083) return p.default.debug("[OSMD] Retrieve the file at the given URL: " + n), m.AJAX.ajax(n, this.loadUrlTimeout).then((t)=>i.load(t, e), (t)=>{
                                    throw t;
                                });
                                console.error("[OSMD] osmd.load(string): Could not process string. Did not find <?xml at beginning.");
                            }
                        }
                        if (!t || !t.nodeName) return Promise.reject(new Error("OpenSheetMusicDisplay: The document which was provided is invalid"));
                        const s = t, r = s.childNodes;
                        let a;
                        p.default.debug("[OSMD] load(), Document url: " + s.URL);
                        for(let t = 0, e = r.length; t < e; t += 1){
                            const e = r[t];
                            if (e.nodeType === Node.ELEMENT_NODE && "score-partwise" === e.nodeName.toLowerCase()) {
                                a = e;
                                break;
                            }
                        }
                        if (!a) return console.error("Could not parse MusicXML, no valid partwise element found"), Promise.reject(new Error("OpenSheetMusicDisplay: Document is not a valid 'partwise' MusicXML"));
                        const l = new n.IXmlElement(a), h = new M.TemposCalculator, c = new o.MusicSheetReader([
                            h
                        ], this.rules);
                        return this.sheet = c.createMusicSheet(l, e), void 0 === this.sheet ? Promise.reject(new Error("given music sheet was incomplete or could not be loaded.")) : (p.default.info(`[OSMD] Loaded sheet ${this.sheet.TitleString} successfully.`), this.needBackendUpdate = !0, this.updateGraphic(), Promise.resolve({}));
                    }
                    updateGraphic() {
                        const t = new r.VexFlowMusicSheetCalculator(this.rules);
                        this.graphic = new a.GraphicalMusicSheet(this.sheet, t), this.drawingParameters.drawCursors && this.cursors.forEach((t)=>{
                            t.init(this.sheet.MusicPartManager, this.graphic);
                        }), this.drawingParameters.DrawingParametersEnum === b.DrawingParametersEnum.leadsheet && (this.graphic.LeadSheet = !0);
                    }
                    render() {
                        if (!this.graphic) throw new Error("OSMD: load() needs to be called before render()");
                        this.resetIncrementalRendering(), this.rules.LazyConsistentGraphic = !1, this.drawer?.clear(), this.Sheet.SourceMeasures[0].ImplicitMeasure && (this.rules.MinMeasureToDrawNumber > 1 && (this.rules.MinMeasureToDrawIndex = this.rules.MinMeasureToDrawNumber), this.rules.MaxMeasureToDrawNumber > 0 && (this.rules.MaxMeasureToDrawIndex = this.rules.MaxMeasureToDrawNumber));
                        let t = this.getContainerContentWidth();
                        this.rules.RenderSingleHorizontalStaffline && (t = this.rules.SheetMaximumWidth), this.sheet.pageWidth = t / this.zoom / 10, this.rules.PageFormat && !this.rules.PageFormat.IsUndefined ? (this.rules.PageHeight = this.sheet.pageWidth / this.rules.PageFormat.aspectRatio, p.default.debug("[OSMD] PageHeight: " + this.rules.PageHeight)) : (p.default.debug("[OSMD] endless/undefined pageformat, id: " + this.rules.PageFormat.idString), this.rules.PageHeight = 100001), this.graphic.reCalculate(), this.drawingParameters.drawCursors && (this.graphic.Cursors.length = 0), this.createOrRefreshRenderBackend(), this.needBackendUpdate = !1, this.drawer.setZoom(this.zoom);
                        for (const t of this.sheet.SourceMeasures)t.WasRendered = !1;
                        this.drawer.drawSheet(this.graphic), this.enableOrDisableCursors(this.drawingParameters.drawCursors), this.drawingParameters.drawCursors && this.cursors.forEach((t)=>{
                            t.update();
                        }), this.zoomUpdated = !1, this.rules.RenderCount++;
                    }
                    renderAppend(t, e, i = !1, s) {
                        if (!this.graphic) throw new Error("OSMD: load() needs to be called before renderNext()");
                        return this.rules.RenderSingleHorizontalStaffline ? (this.rules.LazyConsistentGraphic = !1, this.renderAppendGrowingHorizontal(e, i)) : (this.rules.LazyConsistentGraphic = !0, this.renderAppendGrowing(t, e, i, s));
                    }
                    renderNext(t) {
                        if (!this.graphic) throw new Error("OSMD: load() needs to be called before renderNext()");
                        const e = Math.max(1, t?.measures ?? 8), i = t?.systems ?? 0, s = i > 0 && !this.rules.RenderSingleHorizontalStaffline ? Math.max(1, Math.floor(i)) : void 0, n = this.sheet.SourceMeasures.length - 1, r = this.visualMeasureCount(0, this.sheet.SourceMeasures.length), o = !this.lazyIncrementalActive;
                        if (o && this.beginIncrementalRendering(), this.lazyNextSourceIndex > n) return {
                            done: !0,
                            renderedMeasures: r,
                            totalMeasures: r,
                            lastRenderedMeasure: this.graphicalMeasuresAtOrBefore(n),
                            nextUnrenderedMeasure: []
                        };
                        const a = this.lazyNextSourceIndex, l = void 0 !== s ? a : this.visualBatchEndIndex(a, e);
                        this.lazyNextSourceIndex = this.renderAppend(a, l, o, s);
                        const h = this.lazyNextSourceIndex > n;
                        return {
                            done: h,
                            renderedMeasures: h ? r : this.visualMeasureCount(0, this.lazyNextSourceIndex),
                            totalMeasures: r,
                            lastRenderedMeasure: this.graphicalMeasuresAtOrBefore(this.lazyNextSourceIndex - 1),
                            nextUnrenderedMeasure: h ? [] : this.graphicalMeasuresAtOrBefore(this.lazyNextSourceIndex)
                        };
                    }
                    renderRemaining() {
                        if (!this.lazyIncrementalActive) return;
                        const t = this.sheet.SourceMeasures.length;
                        let e = 0;
                        for(; !this.IncrementalRenderingComplete && e++ < t + 2;){
                            const e = this.lazyNextSourceIndex;
                            if (this.renderNext({
                                measures: t
                            }), this.lazyNextSourceIndex <= e) break;
                        }
                    }
                    get IncrementalRenderingActive() {
                        return this.lazyIncrementalActive;
                    }
                    get IncrementalRenderingComplete() {
                        return this.lazyIncrementalActive && !!this.sheet && this.lazyNextSourceIndex > this.sheet.SourceMeasures.length - 1;
                    }
                    get IncrementalRenderProgress() {
                        const t = this.graphic ? this.visualMeasureCount(0, this.sheet.SourceMeasures.length) : 0, e = !!this.graphic && this.lazyIncrementalActive, i = this.IncrementalRenderingComplete;
                        return {
                            done: i,
                            renderedMeasures: e ? this.visualMeasureCount(0, Math.min(this.lazyNextSourceIndex, this.sheet.SourceMeasures.length)) : 0,
                            totalMeasures: t,
                            lastRenderedMeasure: e && this.lazyNextSourceIndex > 0 ? this.graphicalMeasuresAtOrBefore(this.lazyNextSourceIndex - 1) : [],
                            nextUnrenderedMeasure: e && !i ? this.graphicalMeasuresAtOrBefore(this.lazyNextSourceIndex) : []
                        };
                    }
                    graphicalMeasuresAtOrBefore(t) {
                        if (!this.graphic) return [];
                        const e = this.graphic.MeasureList;
                        let i = Math.min(t, e.length - 1);
                        for(; i >= 0 && (!e[i] || !e[i].some((t)=>!!t));)i--;
                        return i >= 0 ? e[i].filter((t)=>!!t) : [];
                    }
                    resetIncrementalRendering() {
                        this.lazyIncrementalActive && (this.disableIncrementalRenderingOnScroll(), this.lazyIncrementalActive = !1, this.lazyNextSourceIndex = 0, this.lazyDrawnSystemCount = 0, this.lazyDrawnSystemPositions = [], this.lazyDrawnHMeasureCount = 0, this.rules.MinMeasureToDrawIndex = this.lazySavedMinMeasureToDrawIndex, this.rules.MaxMeasureToDrawIndex = this.lazySavedMaxMeasureToDrawIndex);
                    }
                    enableIncrementalRenderingOnScroll(t) {
                        if ("undefined" == typeof window) return;
                        this.disableIncrementalRenderingOnScroll();
                        const e = this.rules.RenderSingleHorizontalStaffline, i = t?.scrollElement ?? (e ? this.container : window), s = {
                            measures: t?.measures
                        };
                        if (this.IncrementalRenderingActive || this.renderNext(s), this.IncrementalRenderingComplete) return;
                        let n = !1;
                        const r = ()=>{
                            if (n || !this.IncrementalRenderingActive || this.IncrementalRenderingComplete) return;
                            if (!(()=>{
                                const t = i === window ? document.scrollingElement || document.documentElement : i;
                                return e ? t.scrollLeft + t.clientWidth >= t.scrollWidth - 1.5 * t.clientWidth : i === window ? window.scrollY + window.innerHeight >= document.body.scrollHeight - 1.5 * window.innerHeight : t.scrollTop + t.clientHeight >= t.scrollHeight - 1.5 * t.clientHeight;
                            })()) return;
                            n = !0;
                            const t = i === window ? document.scrollingElement || document.documentElement : i, o = t.scrollTop, a = t.scrollLeft, l = this.renderNext(s);
                            t.scrollTop !== o && (t.scrollTop = o), t.scrollLeft !== a && (t.scrollLeft = a), n = !1, l.done ? this.disableIncrementalRenderingOnScroll() : "function" == typeof window.requestAnimationFrame && window.requestAnimationFrame(r);
                        };
                        this.lazyScrollTarget = i, this.lazyScrollHandler = r, i.addEventListener("scroll", r, {
                            passive: !0
                        }), "function" == typeof window.requestAnimationFrame && window.requestAnimationFrame(r);
                    }
                    disableIncrementalRenderingOnScroll() {
                        this.lazyScrollHandler && this.lazyScrollTarget && this.lazyScrollTarget.removeEventListener("scroll", this.lazyScrollHandler), this.lazyScrollHandler = void 0, this.lazyScrollTarget = void 0;
                    }
                    beginIncrementalRendering() {
                        this.lazySavedMinMeasureToDrawIndex = this.rules.MinMeasureToDrawIndex, this.lazySavedMaxMeasureToDrawIndex = this.rules.MaxMeasureToDrawIndex, this.lazyIncrementalActive = !0, this.lazyNextSourceIndex = 0;
                    }
                    visualMeasureCount(t, e) {
                        const i = this.sheet.SourceMeasures, s = this.rules.RenderMultipleRestMeasures;
                        let n = 0, r = t;
                        for(; r < e && r < i.length;)r += s && i[r].multipleRestMeasures > 0 ? i[r].multipleRestMeasures : 1, n++;
                        return n;
                    }
                    visualBatchEndIndex(t, e) {
                        const i = this.sheet.SourceMeasures, s = this.rules.RenderMultipleRestMeasures;
                        let n = t, r = 0;
                        for(; r < e && n < i.length;)n += s && i[n].multipleRestMeasures > 0 ? i[n].multipleRestMeasures : 1, r++;
                        return Math.min(n - 1, i.length - 1);
                    }
                    renderAppendGrowing(t, e, i, s) {
                        i && (this.lazyDrawnSystemCount = 0, this.lazyDrawnSystemPositions = [], this.graphic.GetCalculator?.clearSkyBottomLineCache(), this.lazyLayoutWidth = this.getContainerContentWidth());
                        const n = this.sheet.SourceMeasures.length - 1;
                        this.rules.MinMeasureToDrawIndex = 0, this.rules.MaxMeasureToDrawIndex = Math.min(e, n), this.sheet.pageWidth = this.lazyLayoutWidth / this.zoom / 10, this.rules.PageHeight = 100001, this.graphic.reCalculate();
                        let r = this.lazyLaidOutSystems();
                        const o = s ?? 1, a = Math.max(4, e - t + 1), l = (t)=>void 0 !== s ? Math.min(t - 1, this.lazyDrawnSystemCount + s) : t - 1;
                        let h, c = this.rules.MaxMeasureToDrawIndex;
                        for(; r.length > 0 && c < n;){
                            let t = c + a;
                            if (r.length >= this.lazyDrawnSystemCount + o + 1) {
                                void 0 === h && (h = l(r.length));
                                const e = this.lazySpannerEndInLastSystem(r, h);
                                if (e < 0) break;
                                t = Math.max(t, e + 1);
                            }
                            c = Math.min(t, n), this.rules.MaxMeasureToDrawIndex = c, this.graphic.reCalculate(), r = this.lazyLaidOutSystems();
                        }
                        if (0 === r.length) return n + 1;
                        const u = r.length, d = c >= n, f = (t)=>r[t].StaffLines[0].PositionAndShape.AbsolutePosition.y;
                        let m = !1;
                        for(let t = 0; t < this.lazyDrawnSystemCount && t < u; t++){
                            const e = this.lazyDrawnSystemPositions[t];
                            if (e && (e.pageNumber !== r[t].Parent.PageNumber || Math.abs(f(t) - e.y) > 1e-4)) {
                                m = !0;
                                break;
                            }
                        }
                        const p = i || m, g = p ? 0 : this.lazyDrawnSystemCount, b = d ? u : Math.min(l(u), h ?? u);
                        if (b <= g) return this.lazyDrawnSystemCount = Math.max(this.lazyDrawnSystemCount, b), n + 1;
                        p && this.createOrRefreshRenderBackend(this.lazyLayoutWidth);
                        const S = this.drawer.Backends[0].width;
                        let E = 0;
                        for (const t of this.graphic.MusicPages){
                            if (t.PageNumber > this.rules.MaxPageToDrawNumber) break;
                            let e = this.drawer.Backends[t.PageNumber - 1];
                            e || (e = this.createBackend(this.backendType, t), this.drawer.Backends.push(e));
                            const i = e.getOSMDBackendType() === y.BackendType.Canvas, s = Math.min(Math.max(b - E, 0), t.MusicSystems.length);
                            let n = 0;
                            if (s === t.MusicSystems.length) n = t.PositionAndShape.Size.height + this.rules.PageBottomMargin + t.PositionAndShape.BorderTop;
                            else if (s > 0) {
                                const e = t.MusicSystems[s - 1];
                                n = e.PositionAndShape.AbsolutePosition.y + e.PositionAndShape.BorderBottom + this.rules.PageBottomMargin;
                            }
                            n > 0 && (i && (n += .1), this.rules.RenderTitle && (n += this.rules.TitleTopDistance)), e.graphicalMusicPage = t, e.resize(S, 10 * n * this.zoom), E >= g && e.clear(), e.getContext().setFillStyle(this.rules.DefaultColorMusic), e.getContext().setStrokeStyle(this.rules.DefaultColorMusic), E += t.MusicSystems.length;
                        }
                        this.drawer.setZoom(this.zoom), this.drawingParameters.drawCursors && (this.graphic.Cursors.length = 0);
                        for(let t = 0; t < b; t++)for (const e of r[t].StaffLines)for (const t of e.Measures)t?.parentSourceMeasure && (t.parentSourceMeasure.WasRendered = !0);
                        this.drawer.LazyDrawSystemsFromIndex = g, this.drawer.LazyDrawSystemsToIndexExcl = b, this.drawer.drawSheet(this.graphic), this.drawer.LazyDrawSystemsFromIndex = -1, this.drawer.LazyDrawSystemsToIndexExcl = Number.POSITIVE_INFINITY, this.drawingParameters.drawCursors && (p && this.enableOrDisableCursors(this.drawingParameters.drawCursors), this.cursors.forEach((t)=>t.update()));
                        for(let t = 0; t < b; t++)this.lazyDrawnSystemPositions[t] = {
                            pageNumber: r[t].Parent.PageNumber,
                            y: f(t)
                        };
                        if (this.lazyDrawnSystemPositions.length = b, this.lazyDrawnSystemCount = b, this.rules.RenderCount++, d) return n + 1;
                        const x = r[b].StaffLines[0].Measures;
                        return this.sheet.SourceMeasures.indexOf(x[0].parentSourceMeasure);
                    }
                    lazySpannerEndInLastSystem(t, e) {
                        const i = (t)=>t.StaffLines[0].Measures[0].parentSourceMeasure.measureListIndex, s = i(t[e]);
                        let n = -1;
                        for(let t = 0; t < s; t++)for (const e of this.sheet.SourceMeasures[t].StaffLinkedExpressions)for (const t of e){
                            const e = t.StartingContinuousDynamic, i = e?.Label?.length > 0;
                            for (const s of [
                                i ? void 0 : e?.EndMultiExpression,
                                t.OctaveShiftStart?.ParentEndMultiExpression
                            ])s && (n = Math.max(n, s.SourceMeasureParent.measureListIndex));
                        }
                        return n >= i(t[t.length - 1]) ? n : -1;
                    }
                    lazyLaidOutSystems() {
                        const t = [];
                        for (const e of this.graphic.MusicPages){
                            if (e.PageNumber > this.rules.MaxPageToDrawNumber) break;
                            t.push(...e.MusicSystems);
                        }
                        return t;
                    }
                    renderAppendGrowingHorizontal(t, e) {
                        const i = this.sheet.SourceMeasures.length - 1;
                        e && (this.lazyDrawnHMeasureCount = 0, this.rules.MinMeasureToDrawIndex = 0, this.rules.MaxMeasureToDrawIndex = i, this.sheet.pageWidth = this.rules.SheetMaximumWidth / this.zoom / 10, this.rules.PageHeight = 100001, this.graphic.reCalculate(), this.createOrRefreshRenderBackend());
                        const s = this.graphic.MusicPages.filter((t)=>t.PageNumber <= this.rules.MaxPageToDrawNumber), n = [];
                        for (const t of s)for (const e of t.MusicSystems)n.push(...e.StaffLines[0]?.Measures ?? []);
                        if (0 === n.length) return i + 1;
                        const r = Math.min(this.lazyDrawnHMeasureCount, n.length);
                        let o = r;
                        for(; o < n.length;){
                            const e = n[o].parentSourceMeasure;
                            if (e && e.measureListIndex > t && o > r) break;
                            o++;
                        }
                        const a = o >= n.length, l = (t)=>t.PositionAndShape.AbsolutePosition.x + t.PositionAndShape.BorderRight, h = new Map, c = new Map;
                        let u = 0;
                        for (const t of s)for (const e of t.MusicSystems){
                            const i = e.StaffLines[0]?.Measures ?? [], s = Math.max(r - u, 0), n = Math.min(o - u, i.length);
                            if (u += i.length, n > 0) {
                                const e = l(i[n - 1]) + this.rules.PageRightMargin;
                                c.set(t, Math.max(c.get(t) ?? 0, e));
                            }
                            s < n && h.set(e, {
                                fromX: 0 === s ? Number.NEGATIVE_INFINITY : l(i[s - 1]) + 1e-4,
                                toX: n === i.length ? Number.POSITIVE_INFINITY : l(i[n - 1]) + 1e-4
                            });
                        }
                        const d = this.rules.PageLeftMargin + this.graphic.MusicPages[0].PositionAndShape.Size.width + this.rules.PageRightMargin;
                        for (const t of this.drawer.Backends){
                            const e = t.graphicalMusicPage, i = a ? d : c.get(e) ?? 0;
                            let s = e.PositionAndShape.Size.height + this.rules.PageBottomMargin + e.PositionAndShape.BorderTop;
                            t.getOSMDBackendType() === y.BackendType.Canvas && (s += .1), this.rules.RenderTitle && (s += this.rules.TitleTopDistance), t.resize(10 * i * this.zoom, 10 * s * this.zoom), t.getContext().setFillStyle(this.rules.DefaultColorMusic), t.getContext().setStrokeStyle(this.rules.DefaultColorMusic);
                        }
                        return this.drawer.setZoom(this.zoom), this.drawingParameters.drawCursors && (this.graphic.Cursors.length = 0), this.drawer.LazyDrawSystemWindows = h, this.drawer.LazySkipPageLabels = !a, this.drawer.drawSheet(this.graphic), this.drawer.LazyDrawSystemWindows = void 0, this.drawer.LazySkipPageLabels = !1, this.drawingParameters.drawCursors && (e && this.enableOrDisableCursors(this.drawingParameters.drawCursors), this.cursors.forEach((t)=>t.update())), this.lazyDrawnHMeasureCount = o, this.rules.RenderCount++, a ? i + 1 : n[o].parentSourceMeasure.measureListIndex;
                    }
                    createOrRefreshRenderBackend(t) {
                        if (this.drawer && this.drawer.Backends) {
                            this.drawer.Backends[0] && this.drawer.Backends[0].removeAllChildrenFromContainer(this.container);
                            for (const t of this.drawer.Backends)t.free();
                            this.drawer.Backends.clear();
                        }
                        this.drawingParameters.Rules = this.rules, this.drawer = new h.VexFlowMusicSheetDrawer(this.drawingParameters), this.drawer.drawableBoundingBoxElement = this.DrawBoundingBox, this.drawer.bottomLineVisible = this.drawBottomLine, this.drawer.skyLineVisible = this.drawSkyLine;
                        let e, i = t ?? this.getContainerContentWidth();
                        this.rules.RenderSingleHorizontalStaffline && (i = 10 * (this.EngravingRules.PageLeftMargin + this.graphic.MusicPages[0].PositionAndShape.Size.width + this.EngravingRules.PageRightMargin) * this.zoom);
                        const s = 32767;
                        for (const t of this.graphic.MusicPages){
                            if (t.PageNumber > this.rules.MaxPageToDrawNumber) break;
                            const n = this.createBackend(this.backendType, t), r = " exceeds CanvasBackend limit of 32767. Cutting off score.";
                            n.getOSMDBackendType() === y.BackendType.Canvas && i > s && (p.default.warn("[OSMD] Warning: width of " + i + r), i = s), this.rules.PageFormat && !this.rules.PageFormat.IsUndefined ? e = i / this.rules.PageFormat.aspectRatio : (e = t.PositionAndShape.Size.height, e += this.rules.PageBottomMargin, n.getOSMDBackendType() === y.BackendType.Canvas && (e += .1), e += t.PositionAndShape.BorderTop, this.rules.RenderTitle && (e += this.rules.TitleTopDistance), e *= 10 * this.zoom), n.getOSMDBackendType() === y.BackendType.Canvas && e > s && (p.default.warn("[OSMD] Warning: height of " + e + r), e = Math.min(e, s)), n.resize(i, e), n.clear(), n.getContext().setFillStyle(this.rules.DefaultColorMusic), n.getContext().setStrokeStyle(this.rules.DefaultColorMusic), this.drawer.Backends.push(n), this.graphic.drawer = this.drawer;
                        }
                    }
                    getContainerContentWidth() {
                        const t = window.getComputedStyle(this.container), e = (t)=>parseFloat(t) || 0, i = this.container.offsetWidth - e(t.borderLeftWidth) - e(t.borderRightWidth) - e(t.paddingLeft) - e(t.paddingRight);
                        return Math.max(0, i);
                    }
                    exportSVG() {
                        if (this.drawer) for (const t of this.drawer.Backends)t instanceof c.SvgVexFlowBackend && t.export();
                    }
                    IsReadyToRender() {
                        return void 0 !== this.graphic;
                    }
                    clear() {
                        this.drawer?.clear(), this.reset();
                    }
                    setOptions(t) {
                        if (this.rules || (this.rules = new E.EngravingRules), this.drawingParameters || t.drawingParameters ? t.drawingParameters && (this.drawingParameters ? this.drawingParameters.DrawingParametersEnum = b.DrawingParametersEnum[t.drawingParameters.toLowerCase()] : this.drawingParameters = new g.DrawingParameters(b.DrawingParametersEnum[t.drawingParameters], this.rules)) : this.drawingParameters = new g.DrawingParameters(b.DrawingParametersEnum.default, this.rules), null == t) return void p.default.warn("warning: osmd.setOptions() called without an options parameter, has no effect.\nexample usage: osmd.setOptions({drawCredits: false, drawPartNames: false})");
                        t.onXMLRead && (this.OnXMLRead = t.onXMLRead);
                        let e = !this.drawer || !this.drawer.Backends || this.drawer.Backends.length < 1;
                        if (void 0 !== t.backend) {
                            const i = y.OSMDOptions.BackendTypeFromString(t.backend);
                            e = e || this.backendType !== i, this.backendType = i;
                        }
                        this.needBackendUpdate = e, void 0 !== t.autoBeam && (this.rules.AutoBeamNotes = t.autoBeam);
                        const i = t.autoBeamOptions;
                        if (i && (void 0 === i.maintain_stem_directions && (i.maintain_stem_directions = !1), this.rules.AutoBeamOptions = i, i.groups && i.groups.length)) {
                            for (const t of i.groups)if (2 !== t.length) throw new Error("Each fraction in autoBeamOptions.groups must be of length 2, e.g. [3,4] for beaming three fourths");
                        }
                        void 0 !== t.percussionOneLineCutoff && (this.rules.PercussionOneLineCutoff = t.percussionOneLineCutoff), 0 !== this.rules.PercussionOneLineCutoff && void 0 !== t.percussionForceVoicesOneLineCutoff && (this.rules.PercussionForceVoicesOneLineCutoff = t.percussionForceVoicesOneLineCutoff), void 0 !== t.alignRests && (this.rules.AlignRests = t.alignRests), void 0 !== t.coloringMode && this.setColoringMode(t), void 0 !== t.coloringEnabled && (this.rules.ColoringEnabled = t.coloringEnabled), void 0 !== t.colorStemsLikeNoteheads && (this.rules.ColorStemsLikeNoteheads = t.colorStemsLikeNoteheads), t.disableCursor && (this.drawingParameters.drawCursors = !1), t.drawHiddenNotes && (this.drawingParameters.drawHiddenNotes = !0), void 0 !== t.drawCredits && (this.drawingParameters.DrawCredits = t.drawCredits), void 0 !== t.drawComposer && (this.drawingParameters.DrawComposer = t.drawComposer), void 0 !== t.drawTitle && (this.drawingParameters.DrawTitle = t.drawTitle), void 0 !== t.drawSubtitle && (this.drawingParameters.DrawSubtitle = t.drawSubtitle), void 0 !== t.drawLyricist && (this.drawingParameters.DrawLyricist = t.drawLyricist), void 0 !== t.drawMetronomeMarks && (this.rules.MetronomeMarksDrawn = t.drawMetronomeMarks), void 0 !== t.drawPartNames && (this.drawingParameters.DrawPartNames = t.drawPartNames, t.drawPartAbbreviations || (this.rules.RenderPartAbbreviations = t.drawPartNames)), void 0 !== t.drawPartAbbreviations && (this.rules.RenderPartAbbreviations = t.drawPartAbbreviations), !1 === t.drawFingerings && (this.rules.RenderFingerings = !1), void 0 !== t.drawMeasureNumbers && (this.rules.RenderMeasureNumbers = t.drawMeasureNumbers), void 0 !== t.drawMeasureNumbersOnlyAtSystemStart && (this.rules.RenderMeasureNumbersOnlyAtSystemStart = t.drawMeasureNumbersOnlyAtSystemStart), void 0 !== t.drawLyrics && (this.rules.RenderLyrics = t.drawLyrics), void 0 !== t.drawTimeSignatures && (this.rules.RenderTimeSignatures = t.drawTimeSignatures), void 0 !== t.drawSlurs && (this.rules.RenderSlurs = t.drawSlurs), void 0 !== t.measureNumberInterval && (this.rules.MeasureNumberLabelOffset = t.measureNumberInterval), void 0 !== t.useXMLMeasureNumbers && (this.rules.UseXMLMeasureNumbers = t.useXMLMeasureNumbers), void 0 !== t.fingeringPosition && (this.rules.FingeringPosition = x.AbstractExpression.PlacementEnumFromString(t.fingeringPosition)), void 0 !== t.fingeringInsideStafflines && (this.rules.FingeringInsideStafflines = t.fingeringInsideStafflines), void 0 !== t.newSystemFromXML && (this.rules.NewSystemAtXMLNewSystemAttribute = t.newSystemFromXML), void 0 !== t.newSystemFromNewPageInXML && (this.rules.NewSystemAtXMLNewPageAttribute = t.newSystemFromNewPageInXML), void 0 !== t.newPageFromXML && (this.rules.NewPageAtXMLNewPageAttribute = t.newPageFromXML), void 0 !== t.fillEmptyMeasuresWithWholeRest && (this.rules.FillEmptyMeasuresWithWholeRest = t.fillEmptyMeasuresWithWholeRest), void 0 !== t.followCursor && (this.FollowCursor = t.followCursor), void 0 !== t.setWantedStemDirectionByXml && (this.rules.SetWantedStemDirectionByXml = t.setWantedStemDirectionByXml), t.darkMode ? (this.rules.applyDefaultColorMusic("#FFFFFF"), this.rules.PageBackgroundColor = "#000000", this.rules.DarkModeEnabled = !0) : !1 === t.darkMode && (this.rules.applyDefaultColorMusic("#000000"), this.rules.PageBackgroundColor = void 0, this.rules.DarkModeEnabled = !1), t.defaultColorMusic && this.rules.applyDefaultColorMusic(t.defaultColorMusic), t.defaultColorNotehead && (this.rules.DefaultColorNotehead = t.defaultColorNotehead), t.defaultColorRest && (this.rules.DefaultColorRest = t.defaultColorRest), t.defaultColorStem && (this.rules.DefaultColorStem = t.defaultColorStem), t.defaultColorLabel && (this.rules.DefaultColorLabel = t.defaultColorLabel), t.defaultColorTitle && (this.rules.DefaultColorTitle = t.defaultColorTitle), t.defaultFontFamily && (this.rules.DefaultFontFamily = t.defaultFontFamily), t.defaultFontStyle && (this.rules.DefaultFontStyle = t.defaultFontStyle), t.drawUpToMeasureNumber >= 0 && (this.rules.MaxMeasureToDrawIndex = Math.max(t.drawUpToMeasureNumber - 1, 0), this.rules.MaxMeasureToDrawNumber = t.drawUpToMeasureNumber), t.drawFromMeasureNumber >= 0 && (this.rules.MinMeasureToDrawIndex = Math.max(t.drawFromMeasureNumber - 1, 0), this.rules.MinMeasureToDrawNumber = t.drawFromMeasureNumber), t.drawUpToPageNumber && (this.rules.MaxPageToDrawNumber = t.drawUpToPageNumber), t.drawUpToSystemNumber && (this.rules.MaxSystemToDrawNumber = t.drawUpToSystemNumber), void 0 !== t.tupletsRatioed && (this.rules.TupletsRatioed = t.tupletsRatioed), void 0 !== t.tupletsBracketed && (this.rules.TupletsBracketed = t.tupletsBracketed), void 0 !== t.tripletsBracketed && (this.rules.TripletsBracketed = t.tripletsBracketed), t.autoResize ? (this.resizeHandlerAttached || this.autoResize(), this.autoResizeEnabled = !0) : !1 === t.autoResize && (this.autoResizeEnabled = !1), void 0 !== t.pageFormat && this.setPageFormat(t.pageFormat), void 0 !== t.pageBackgroundColor && (this.rules.PageBackgroundColor = t.pageBackgroundColor), void 0 !== t.renderSingleHorizontalStaffline && (this.rules.RenderSingleHorizontalStaffline = t.renderSingleHorizontalStaffline), void 0 !== t.spacingFactorSoftmax && (this.rules.SoftmaxFactorVexFlow = t.spacingFactorSoftmax), void 0 !== t.spacingBetweenTextLines && (this.rules.SpacingBetweenTextLines = t.spacingBetweenTextLines), void 0 !== t.stretchLastSystemLine && (this.rules.StretchLastSystemLine = t.stretchLastSystemLine), void 0 !== t.autoGenerateMultipleRestMeasuresFromRestMeasures && (this.rules.AutoGenerateMultipleRestMeasuresFromRestMeasures = t.autoGenerateMultipleRestMeasuresFromRestMeasures), void 0 !== t.cursorsOptions ? this.cursorsOptions = t.cursorsOptions : this.cursorsOptions || (this.cursorsOptions = [
                            {
                                type: y.CursorType.Standard,
                                color: this.EngravingRules.DefaultColorCursor,
                                alpha: .5,
                                follow: !0
                            }
                        ]), void 0 !== t.useGeometricSkyBottomLineCalculation && (this.rules.UseGeometricSkyBottomLineCalculation = t.useGeometricSkyBottomLineCalculation), void 0 !== t.preferredSkyBottomLineBatchCalculatorBackend && (this.rules.PreferredSkyBottomLineBatchCalculatorBackend = t.preferredSkyBottomLineBatchCalculatorBackend), void 0 !== t.skyBottomLineBatchMinMeasures && (this.rules.SkyBottomLineBatchMinMeasures = t.skyBottomLineBatchMinMeasures);
                    }
                    setColoringMode(t) {
                        if (t.coloringMode === S.ColoringModes.XML) return void (this.rules.ColoringMode = S.ColoringModes.XML);
                        const e = [
                            _.NoteEnum.C,
                            _.NoteEnum.D,
                            _.NoteEnum.E,
                            _.NoteEnum.F,
                            _.NoteEnum.G,
                            _.NoteEnum.A,
                            _.NoteEnum.B
                        ];
                        let i;
                        if (t.coloringMode === S.ColoringModes.CustomColorSet) {
                            if (!t.coloringSetCustom || 8 !== t.coloringSetCustom.length) throw new Error("Invalid amount of colors: With coloringModes.customColorSet, you have to provide a coloringSetCustom parameter (array) with 8 strings (C to B, rest note).");
                            for (const e of t.coloringSetCustom)if (!/^#[0-9a-fA-F]{6}$/.test(e)) throw new Error("One of the color strings in options.coloringSetCustom was not a valid HTML Hex color:\n" + e);
                            i = t.coloringSetCustom;
                        } else if (t.coloringMode === S.ColoringModes.AutoColoring) {
                            i = [];
                            const t = Object.keys(T.AutoColorSet);
                            for(let e = 0; e < t.length; e++)i.push(T.AutoColorSet[t[e]]);
                        }
                        const s = new v.Dictionary;
                        for(let t = 0; t < e.length; t++)s.setValue(e[t], i[t]);
                        s.setValue(-1, i.last()), this.rules.ColoringSetCurrent = s, this.rules.ColoringMode = t.coloringMode;
                    }
                    setLogLevel(t) {
                        switch(t){
                            case "trace":
                                p.default.setLevel(p.default.levels.TRACE);
                                break;
                            case "debug":
                                p.default.setLevel(p.default.levels.DEBUG);
                                break;
                            case "info":
                                p.default.setLevel(p.default.levels.INFO);
                                break;
                            case "warn":
                                p.default.setLevel(p.default.levels.WARN);
                                break;
                            case "error":
                                p.default.setLevel(p.default.levels.ERROR);
                                break;
                            case "silent":
                                p.default.setLevel(p.default.levels.SILENT);
                                break;
                            default:
                                p.default.warn(`Could not set log level to ${t}. Using warn instead.`), p.default.setLevel(p.default.levels.WARN);
                        }
                    }
                    getLogLevel() {
                        return p.default.getLevel();
                    }
                    reset() {
                        this.resetIncrementalRendering(), this.drawingParameters.drawCursors && this.cursors.forEach((t)=>{
                            t.hide();
                        }), this.sheet = void 0, this.graphic = void 0, this.zoom = 1, this.rules.RenderCount = 0;
                    }
                    autoResize() {
                        const t = this;
                        this.handleResize(()=>{}, ()=>{
                            this.graphic?.GetCalculator instanceof r.VexFlowMusicSheetCalculator && (this.graphic.GetCalculator.beamsNeedUpdate = !0), t.IsReadyToRender() && t.renderAndScrollBack();
                        });
                    }
                    renderAndScrollBack() {
                        const t = window.scrollY / document.body.scrollHeight;
                        this.render();
                        const e = document.body.scrollHeight * t;
                        window.scrollTo({
                            top: e,
                            behavior: "instant"
                        });
                    }
                    handleResize(t, e) {
                        let i, s;
                        const n = this;
                        function r() {
                            n.AutoResizeEnabled && (i = (new Date).getTime(), s || (t(), i = (new Date).getTime(), s = window.setTimeout(o, 200)));
                        }
                        function o() {
                            s = void 0, window.clearTimeout(s), (new Date).getTime() - i < 200 ? s = window.setTimeout(o, 200) : e();
                        }
                        window.attachEvent ? window.attachEvent("onresize", r) : window.addEventListener("resize", r), this.resizeHandlerAttached = !0, this.rules.RenderCount > 0 && (window.setTimeout(t, 0), window.setTimeout(e, 1));
                    }
                    enableOrDisableCursors(t) {
                        if (this.drawingParameters.drawCursors = t, t) {
                            for(let t = 0; t < this.cursorsOptions.length; t++){
                                const e = this.cursors[t]?.Hidden ?? !0, i = this.cursors[t]?.Iterator;
                                this.cursors[t]?.hide();
                                let s = this.drawer?.Backends[0];
                                if (s && this.rules.RestoreCursorAfterRerender && this.cursors[t]) {
                                    const e = this.cursors[t].updateCurrentPage();
                                    s = this.drawer.Backends[e - 1];
                                }
                                s && s.getRenderElement() && (this.cursors[t] = new d.Cursor(s.getRenderElement(), this, this.cursorsOptions[t])), this.sheet && this.graphic && this.cursors[t] && this.cursors[t].init(this.sheet.MusicPartManager, this.graphic), this.rules.RestoreCursorAfterRerender && (this.cursors[t].hidden = e, i && (this.cursors[t].iterator = i, this.cursors[t].update()));
                            }
                            for (const t of this.cursors.splice(this.cursorsOptions.length))t?.Dispose();
                        } else this.cursors.forEach((t)=>{
                            t.hide();
                        });
                    }
                    createBackend(t, e, i) {
                        let s;
                        return s = void 0 === t || t === y.BackendType.SVG ? new c.SvgVexFlowBackend(this.rules) : new u.CanvasVexFlowBackend(this.rules), s.graphicalMusicPage = e, s.initialize(this.container, this.zoom, i), s;
                    }
                    static StringToPageFormat(t) {
                        let e = E.PageFormat.UndefinedPageFormat;
                        if (t.match("^[0-9]+x[0-9]+$")) {
                            const i = t.split("x"), s = Number.parseInt(i[0], 10), n = Number.parseInt(i[1], 10);
                            s > 0 && s < 32768 && n > 0 && n < 32768 && (e = new E.PageFormat(s, n, `customPageFormat${t}`));
                        }
                        return t = (t = (t = t.replace(" ", "_")).replace("Landscape", "L")).replace("Portrait", "P"), P.PageFormatStandards.hasOwnProperty(t) ? (e = P.PageFormatStandards[t], e) : e;
                    }
                    setPageFormat(t) {
                        const e = P.StringToPageFormat(t);
                        this.needBackendUpdate = !e.Equals(this.rules.PageFormat), this.rules.PageFormat = e;
                    }
                    setCustomPageFormat(t, e) {
                        if (t > 0 && e > 0) {
                            const i = new E.PageFormat(t, e);
                            this.rules.PageFormat = i;
                        }
                    }
                    set DrawSkyLine(t) {
                        this.drawSkyLine = t, this.drawer && (this.drawer.skyLineVisible = t);
                    }
                    get DrawSkyLine() {
                        return this.drawer.skyLineVisible;
                    }
                    set DrawBottomLine(t) {
                        this.drawBottomLine = t, this.drawer && (this.drawer.bottomLineVisible = t);
                    }
                    get DrawBottomLine() {
                        return this.drawer.bottomLineVisible;
                    }
                    set DrawBoundingBox(t) {
                        this.setDrawBoundingBox(t, !0);
                    }
                    get DrawBoundingBox() {
                        return this.drawBoundingBox;
                    }
                    setDrawBoundingBox(t, e = !1) {
                        this.drawBoundingBox = t, this.drawer && (this.drawer.drawableBoundingBoxElement = t), e && this.renderAndScrollBack();
                    }
                    get AutoResizeEnabled() {
                        return this.autoResizeEnabled;
                    }
                    set AutoResizeEnabled(t) {
                        this.autoResizeEnabled = t;
                    }
                    get Zoom() {
                        return this.zoom;
                    }
                    set Zoom(t) {
                        this.zoom = t, this.zoomUpdated = !0, this.graphic?.GetCalculator instanceof r.VexFlowMusicSheetCalculator && (this.graphic.GetCalculator.beamsNeedUpdate = this.zoomUpdated);
                    }
                    set FollowCursor(t) {
                        this.followCursor = t;
                    }
                    get FollowCursor() {
                        return this.followCursor;
                    }
                    set TransposeCalculator(t) {
                        l.MusicSheetCalculator.transposeCalculator = t;
                    }
                    get TransposeCalculator() {
                        return l.MusicSheetCalculator.transposeCalculator;
                    }
                    get Sheet() {
                        return this.sheet;
                    }
                    get Drawer() {
                        return this.drawer;
                    }
                    get GraphicSheet() {
                        return this.graphic;
                    }
                    get DrawingParameters() {
                        return this.drawingParameters;
                    }
                    get EngravingRules() {
                        return this.rules;
                    }
                    get Version() {
                        return this.version;
                    }
                }
                e.OpenSheetMusicDisplay = P, P.PageFormatStandards = {
                    A3_L: new E.PageFormat(420, 297, "A3_L"),
                    A3_P: new E.PageFormat(297, 420, "A3_P"),
                    A4_L: new E.PageFormat(297, 210, "A4_L"),
                    A4_P: new E.PageFormat(210, 297, "A4_P"),
                    A5_L: new E.PageFormat(210, 148, "A5_L"),
                    A5_P: new E.PageFormat(148, 210, "A5_P"),
                    A6_L: new E.PageFormat(148, 105, "A6_L"),
                    A6_P: new E.PageFormat(105, 148, "A6_P"),
                    Endless: E.PageFormat.UndefinedPageFormat,
                    Letter_L: new E.PageFormat(279.4, 215.9, "Letter_L"),
                    Letter_P: new E.PageFormat(215.9, 279.4, "Letter_P")
                };
            },
            5955 (t, e, i) {
                "use strict";
                var s = this && this.__createBinding || (Object.create ? function(t, e, i, s) {
                    void 0 === s && (s = i);
                    var n = Object.getOwnPropertyDescriptor(e, i);
                    n && !("get" in n ? !e.__esModule : n.writable || n.configurable) || (n = {
                        enumerable: !0,
                        get: function() {
                            return e[i];
                        }
                    }), Object.defineProperty(t, s, n);
                } : function(t, e, i, s) {
                    void 0 === s && (s = i), t[s] = e[i];
                }), n = this && this.__exportStar || function(t, e) {
                    for(var i in t)"default" === i || Object.prototype.hasOwnProperty.call(e, i) || s(e, t, i);
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), n(i(3173), e), n(i(6597), e), n(i(624), e), n(i(7103), e);
            },
            5284 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.BrailleBarOverBarLayout = void 0;
                const s = i(164), n = i(2113), r = i(746), o = i(8399), a = i(9591), l = i(8351);
                e.BrailleBarOverBarLayout = class {
                    constructor(t){
                        this.measureRenderer = t;
                    }
                    format(t, e, i, n, o) {
                        const a = t.SourceMeasures;
                        if (0 === a.length) return {
                            text: "",
                            debugEntries: []
                        };
                        const h = [], c = a[0].getKeyInstruction(0), u = a[0].ActiveTimeSignature, d = this.renderMusicHeading(c, u, e.lineWidth), f = [];
                        for(let t = 0; t < e.staffCount; t++){
                            const e = 0 === t ? s.ClefEnum.G : s.ClefEnum.F, i = o(a, t), l = {
                                octaveTracker: new r.BrailleOctaveTracker,
                                facsimile: n,
                                currentClef: e,
                                hadInAccord: !1,
                                activeSlurs: new Set,
                                slurLengths: i
                            };
                            c && (l.currentKey = c), u && (l.currentRhythm = u);
                            const h = this.preRenderMeasures(a, t, l);
                            f.push(h);
                        }
                        const m = this.groupIntoParallels(f, e), p = this.getMaxMeasureNumberWidth(f[0]), g = [];
                        d.braille.length > 0 && (g.push(d.braille), i && (h.push(...d.debugEntries), h.push({
                            braille: l.BRAILLE_LINE_BREAK,
                            meaning: "heading separator (newline)",
                            measureNumber: 0
                        })));
                        for(let t = 0; t < m.length; t++){
                            const s = m[t], n = this.formatParallel(s.startIndex, s.endIndex, f, e, p, i);
                            g.push(...n.lines), i && h.push(...n.debugEntries), t < m.length - 1 && i && h.push({
                                braille: l.BRAILLE_LINE_BREAK,
                                meaning: "parallel separator (newline)",
                                measureNumber: 0
                            });
                        }
                        return {
                            text: g.join(l.BRAILLE_LINE_BREAK),
                            debugEntries: i ? h : []
                        };
                    }
                    preRenderMeasures(t, e, i) {
                        const s = [];
                        for (const n of t){
                            i.octaveTracker.reset();
                            const t = this.measureRenderer.render(n, e, i);
                            s.push({
                                braille: t.braille,
                                cellLength: t.braille.length,
                                measureNumber: t.measureNumber,
                                debugEntries: t.debugEntries
                            });
                        }
                        return s;
                    }
                    renderMusicHeading(t, e, i) {
                        const s = [], n = [];
                        if (t) {
                            const e = (0, o.renderKeySignature)(t);
                            if (e.braille) {
                                s.push(e.braille);
                                for (const t of e.debugEntries)n.push({
                                    braille: t.braille,
                                    meaning: t.meaning,
                                    measureNumber: 0
                                });
                            }
                        }
                        if (e) {
                            const t = (0, a.renderTimeSignature)(e);
                            if (t.braille) {
                                s.push(t.braille);
                                for (const e of t.debugEntries)n.push({
                                    braille: e.braille,
                                    meaning: e.meaning,
                                    measureNumber: 0
                                });
                            }
                        }
                        const r = s.join("");
                        if (0 === r.length) return {
                            braille: "",
                            debugEntries: []
                        };
                        const h = Math.max(0, Math.floor((i - r.length) / 2));
                        return {
                            braille: l.BRAILLE_BLANK_CELL.repeat(h) + r,
                            debugEntries: n
                        };
                    }
                    groupIntoParallels(t, e) {
                        const i = t[0].length, s = [];
                        let n = 0;
                        for(; n < i;){
                            const r = t[0][n].measureNumber, o = this.measureNumberToBareDigits(r).length + 1 + l.BRAILLE_HAND_RIGHT.length + 1, a = e.lineWidth - o;
                            let h = 0, c = n;
                            for(; c < i;){
                                let i = 0;
                                for(let s = 0; s < e.staffCount; s++){
                                    const e = t[s][c].cellLength;
                                    e > i && (i = e);
                                }
                                const s = h + (c > n ? 1 : 0) + i;
                                if (s > a && c > n) break;
                                h = s, c++;
                            }
                            s.push({
                                startIndex: n,
                                endIndex: c
                            }), n = c;
                        }
                        return s;
                    }
                    formatParallel(t, e, i, s, n, r) {
                        const o = [], a = [], h = i[0][t].measureNumber, c = this.measureNumberToBareDigits(h), u = l.BRAILLE_BLANK_CELL.repeat(Math.max(0, n - c.length));
                        for(let n = 0; n < s.staffCount; n++){
                            const d = 0 === n ? l.BRAILLE_HAND_RIGHT : l.BRAILLE_HAND_LEFT, f = 0 === n ? "right hand" : "left hand", m = i[n][t].braille, p = (0, l.firstCharHasLowerDots)(m), g = p ? l.BRAILLE_AUGMENTATION_DOT : "", b = u + c + l.BRAILLE_BLANK_CELL + d + g, S = [];
                            r && (a.push({
                                braille: u + c,
                                meaning: "measure " + h,
                                measureNumber: h
                            }), a.push({
                                braille: d + g,
                                meaning: f + (p ? " (+ separator)" : ""),
                                measureNumber: h
                            }));
                            for(let o = t; o < e; o++){
                                const t = i[n][o];
                                if (S.push(t.braille), r) for (const e of t.debugEntries)a.push({
                                    braille: e.braille,
                                    meaning: e.meaning,
                                    measureNumber: t.measureNumber
                                });
                                if (o < e - 1) {
                                    let e = 0;
                                    for(let t = 0; t < s.staffCount; t++){
                                        const s = i[t][o].cellLength;
                                        s > e && (e = s);
                                    }
                                    const n = e - t.cellLength;
                                    if (n > 0) {
                                        const e = this.padWithGuideDots(n, s);
                                        if (S.push(e), r && e.length > 0) {
                                            const i = e.includes(l.BRAILLE_AUGMENTATION_DOT);
                                            a.push({
                                                braille: e,
                                                meaning: i ? "guide dots" : "alignment padding",
                                                measureNumber: t.measureNumber
                                            });
                                        }
                                    }
                                    S.push(l.BRAILLE_BLANK_CELL), r && a.push({
                                        braille: l.BRAILLE_BLANK_CELL,
                                        meaning: "barline",
                                        measureNumber: t.measureNumber
                                    });
                                }
                            }
                            const y = b + S.join(""), E = this.splitLineWithRunOver(y, b.length, s.lineWidth);
                            o.push(...E), r && E.length > 1 && a.push({
                                braille: "",
                                meaning: "run-over: line split into " + E.length + " lines (Par. 28.1.2)",
                                measureNumber: h
                            }), r && n < s.staffCount - 1 && a.push({
                                braille: l.BRAILLE_LINE_BREAK,
                                meaning: "staff separator (newline)",
                                measureNumber: h
                            });
                        }
                        return {
                            lines: o,
                            debugEntries: a
                        };
                    }
                    measureNumberToBareDigits(t) {
                        return (0, l.numberToUpperDigits)(t);
                    }
                    splitLineWithRunOver(t, e, i) {
                        if (t.length <= i) return [
                            t
                        ];
                        const s = [], n = l.BRAILLE_BLANK_CELL.repeat(e + 2);
                        let r = t, o = !0;
                        for(; r.length > i;){
                            const t = o ? e : n.length;
                            let a = -1;
                            for(let e = i; e > t; e--)if (r.charAt(e) === l.BRAILLE_BLANK_CELL) {
                                a = e;
                                break;
                            }
                            if (-1 === a) return s.push(r), s;
                            s.push(r.substring(0, a)), r = n + r.substring(a + 1), o = !1;
                        }
                        return r.length > 0 && s.push(r), s;
                    }
                    padWithGuideDots(t, e) {
                        if (t <= 0) return "";
                        const i = e.guideDotMinCount + 2;
                        if (t >= e.guideDotThreshold && t >= i) {
                            const e = t - 2;
                            return l.BRAILLE_BLANK_CELL + l.BRAILLE_AUGMENTATION_DOT.repeat(e) + l.BRAILLE_BLANK_CELL;
                        }
                        return l.BRAILLE_BLANK_CELL.repeat(t);
                    }
                    getMaxMeasureNumberWidth(t) {
                        let e = 0;
                        for (const i of t){
                            const t = this.measureNumberToBareDigits(i.measureNumber).length;
                            t > e && (e = t);
                        }
                        return e;
                    }
                    formatEnsemble(t, e, i, s, n, o, a) {
                        const h = t.SourceMeasures;
                        if (0 === h.length) return {
                            text: "",
                            debugEntries: []
                        };
                        const c = [], u = a ? void 0 : h[0].getKeyInstruction(0), d = h[0].ActiveTimeSignature, f = this.renderMusicHeading(u, d, i.lineWidth), m = [], p = [];
                        for(let t = 0; t < e.length; t++){
                            const i = e[t];
                            for (const e of i.staffIndices){
                                const s = o(h, e), l = {
                                    octaveTracker: new r.BrailleOctaveTracker,
                                    facsimile: n,
                                    currentClef: i.defaultClef,
                                    hadInAccord: !1,
                                    activeSlurs: new Set,
                                    slurLengths: s,
                                    ensembleMode: !0
                                }, c = a ? a.get(e) : h[0].getKeyInstruction(0);
                                c && (l.currentKey = c), d && (l.currentRhythm = d);
                                const u = this.preRenderMeasures(h, e, l);
                                m.push(u), p.push(t);
                            }
                        }
                        const g = {
                            ...i,
                            staffCount: m.length
                        }, b = this.groupIntoParallels(m, g), S = [];
                        for (const t of e)for(let e = 0; e < t.staffIndices.length; e++)S.push(t.brailleAbbreviation);
                        const y = [];
                        f.braille.length > 0 && (y.push(f.braille), s && (c.push(...f.debugEntries), c.push({
                            braille: l.BRAILLE_LINE_BREAK,
                            meaning: "heading separator (newline)",
                            measureNumber: 0
                        })));
                        for(let t = 0; t < b.length; t++){
                            const i = b[t], n = [];
                            for(let t = 0; t < m.length; t++){
                                const s = this.getStaffIndexForRenderIndex(t, e);
                                this.isStaffRestOnly(h, s, i.startIndex, i.endIndex) || n.push(t);
                            }
                            const r = n.length > 0 ? n : Array.from({
                                length: m.length
                            }, (t, e)=>e);
                            let o = 0;
                            for (const t of r){
                                const e = S[t].length;
                                e > o && (o = e);
                            }
                            const a = m[0][i.startIndex].measureNumber, u = this.measureNumberToBareDigits(a), d = l.BRAILLE_BLANK_CELL.repeat(o + 1);
                            y.push(d + u), s && (c.push({
                                braille: u,
                                meaning: "measure " + a,
                                measureNumber: a
                            }), c.push({
                                braille: l.BRAILLE_LINE_BREAK,
                                meaning: "measure number separator (newline)",
                                measureNumber: a
                            }));
                            const f = this.formatEnsembleParallel(i.startIndex, i.endIndex, m, S, {
                                ...g,
                                staffCount: r.length
                            }, o, s, r);
                            y.push(...f.lines), s && c.push(...f.debugEntries), t < b.length - 1 && s && c.push({
                                braille: l.BRAILLE_LINE_BREAK,
                                meaning: "parallel separator (newline)",
                                measureNumber: 0
                            });
                        }
                        return {
                            text: y.join(l.BRAILLE_LINE_BREAK),
                            debugEntries: s ? c : []
                        };
                    }
                    formatEnsembleParallel(t, e, i, s, n, r, o, a) {
                        const h = [], c = [], u = a ?? Array.from({
                            length: i.length
                        }, (t, e)=>e);
                        for(let a = 0; a < u.length; a++){
                            const d = u[a], f = s[d], m = f + l.BRAILLE_BLANK_CELL.repeat(Math.max(0, r - f.length)) + l.BRAILLE_BLANK_CELL, p = [];
                            o && c.push({
                                braille: f,
                                meaning: "instrument",
                                measureNumber: i[0][t].measureNumber
                            });
                            for(let s = t; s < e; s++){
                                const t = i[d][s];
                                if (p.push(t.braille), o) for (const e of t.debugEntries)c.push({
                                    braille: e.braille,
                                    meaning: e.meaning,
                                    measureNumber: t.measureNumber
                                });
                                if (s < e - 1) {
                                    let e = 0;
                                    for (const t of u){
                                        const n = i[t][s].cellLength;
                                        n > e && (e = n);
                                    }
                                    const r = e - t.cellLength;
                                    if (r > 0) {
                                        const e = this.padWithGuideDots(r, n);
                                        if (p.push(e), o && e.length > 0) {
                                            const i = e.includes(l.BRAILLE_AUGMENTATION_DOT);
                                            c.push({
                                                braille: e,
                                                meaning: i ? "guide dots" : "alignment padding",
                                                measureNumber: t.measureNumber
                                            });
                                        }
                                    }
                                    p.push(l.BRAILLE_BLANK_CELL), o && c.push({
                                        braille: l.BRAILLE_BLANK_CELL,
                                        meaning: "barline",
                                        measureNumber: t.measureNumber
                                    });
                                }
                            }
                            const g = m + p.join(""), b = this.splitLineWithRunOver(g, m.length, n.lineWidth);
                            h.push(...b), o && b.length > 1 && c.push({
                                braille: "",
                                meaning: "run-over: part line split into " + b.length + " lines (Par. 28.1.2)",
                                measureNumber: i[0][t].measureNumber
                            }), o && a < u.length - 1 && c.push({
                                braille: l.BRAILLE_LINE_BREAK,
                                meaning: "part separator (newline)",
                                measureNumber: i[0][t].measureNumber
                            });
                        }
                        return {
                            lines: h,
                            debugEntries: c
                        };
                    }
                    isStaffRestOnly(t, e, i, s) {
                        let r = !1;
                        for(let o = i; o < s && !r; o++)(0, n.forEachVoiceEntryInMeasure)(t[o], e, (t)=>{
                            for (const e of t)for (const t of e.Notes)if (!t.isRest()) return void (r = !0);
                        });
                        return !r;
                    }
                    renderInstrumentTable(t) {
                        const e = [];
                        let i = 0;
                        for (const e of t)e.name.length > i && (i = e.name.length);
                        const s = i + 2, n = [];
                        for (const i of t){
                            const t = s - i.name.length;
                            let r;
                            if (t >= 3) {
                                const e = t - 1;
                                r = l.BRAILLE_BLANK_CELL + "\u2810".repeat(e);
                            } else r = l.BRAILLE_BLANK_CELL.repeat(t);
                            const o = i.name + r + i.abbreviation;
                            n.push(o), e.push({
                                braille: o,
                                meaning: "instrument list entry",
                                measureNumber: 0
                            });
                        }
                        return {
                            lines: n,
                            debugEntries: e
                        };
                    }
                    getStaffIndexForRenderIndex(t, e) {
                        let i = 0;
                        for (const s of e)for (const e of s.staffIndices){
                            if (i === t) return e;
                            i++;
                        }
                        return 0;
                    }
                };
            },
            5799 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.BrailleChordRenderer = void 0;
                const s = i(8233), n = i(164), r = i(437), o = i(1535), a = i(746), l = i(8351);
                e.BrailleChordRenderer = class {
                    constructor(){
                        this.noteRenderer = new o.BrailleNoteRenderer;
                    }
                    render(t, e, i, o, h, c) {
                        const u = this.sortByPitch(t), d = c ? n.ClefEnum.F : e, f = this.getWrittenNote(u, d), m = this.getIntervalNotes(u, f, d), p = h && f.Pitch ? r.OctaveShift.getPitchFromOctaveShift(f.Pitch, h.Type) : void 0, g = this.noteRenderer.render(f, i, o, p), b = [
                            g.braille
                        ], S = [
                            ...g.debugEntries
                        ];
                        for (const t of m){
                            if (!t.Pitch || !f.Pitch) continue;
                            const e = p ?? f.Pitch, i = h ? r.OctaveShift.getPitchFromOctaveShift(t.Pitch, h.Type) : t.Pitch, n = a.BrailleOctaveTracker.calculateDiatonicInterval(e, i);
                            if (n > 8) {
                                const t = i.Octave + s.Pitch.OctaveXmlDifference, e = l.OCTAVE_MARKS.get(t);
                                e && (b.push(e), S.push({
                                    braille: e,
                                    meaning: "interval octave " + t
                                }));
                            }
                            if (void 0 !== t.Pitch.AccidentalXml && t.Pitch.Accidental !== s.AccidentalEnum.NONE) {
                                const e = (0, l.getAccidentalChar)(t.Pitch.Accidental);
                                e && (b.push(e), S.push({
                                    braille: e,
                                    meaning: (0, l.getAccidentalName)(t.Pitch.Accidental)
                                }));
                            }
                            const o = (0, l.getIntervalChar)(n);
                            o && (b.push(o), S.push({
                                braille: o,
                                meaning: (0, l.getIntervalName)(n) + " interval"
                            }));
                        }
                        return {
                            braille: b.join(""),
                            debugEntries: S
                        };
                    }
                    sortByPitch(t) {
                        return [
                            ...t
                        ].sort((t, e)=>(t.Pitch ? t.Pitch.getHalfTone() : 0) - (e.Pitch ? e.Pitch.getHalfTone() : 0));
                    }
                    getWrittenNote(t, e) {
                        return e === n.ClefEnum.F ? t[0] : t[t.length - 1];
                    }
                    getIntervalNotes(t, e, i) {
                        const s = t.filter((t)=>t !== e);
                        return i === n.ClefEnum.F ? s : s.reverse();
                    }
                };
            },
            8630 (t, e, i) {
                "use strict";
                var s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.BrailleConverter = void 0;
                const n = s(i(3065)), r = i(2113), o = i(746), a = i(164), l = i(8351), h = i(5284), c = i(8399), u = i(8351), d = i(3148);
                class f {
                    constructor(){
                        this.measureRenderer = new r.BrailleMeasureRenderer;
                    }
                    convert(t, e) {
                        const i = e?.debugMode ?? !0, s = "facsimile" === (e?.format ?? "nonfacsimile");
                        if (e?.ensemble && t.Instruments.length > 1) return this.convertEnsemble(t, i, s, e);
                        if (e?.lyrics) return this.convertWithLyrics(t, i, s, e);
                        const r = void 0 !== e?.staffIndex;
                        if (e?.multiStaff ?? (!r && t.Staves.length > 1)) return this.convertMultiStaff(t, i, s, e);
                        const l = e?.staffIndex ?? 0, h = t.SourceMeasures, c = f.computeSlurLengths(h, l), u = {
                            octaveTracker: new o.BrailleOctaveTracker,
                            facsimile: s,
                            currentClef: a.ClefEnum.G,
                            hadInAccord: !1,
                            activeSlurs: new Set,
                            slurLengths: c
                        };
                        return s && e?.graphicSheet ? this.convertFacsimile(e.graphicSheet, l, i, u) : (s && !e?.graphicSheet && n.default.warn("BrailleConverter: format 'facsimile' requested but no graphicSheet provided. Falling back to nonfacsimile. Pass graphicSheet: osmd.GraphicSheet (after render()) to enable facsimile mode."), this.convertNonfacsimile(h, i, l, u));
                    }
                    convertNonfacsimile(t, e, i, s) {
                        const n = [], r = [];
                        for (const o of t){
                            const a = this.measureRenderer.render(o, i, s);
                            if (a.braille.length > 0 && n.push(a.braille), e) {
                                for (const t of a.debugEntries)r.push({
                                    braille: t.braille,
                                    meaning: t.meaning,
                                    measureNumber: a.measureNumber
                                });
                                o !== t[t.length - 1] && r.push({
                                    braille: l.BRAILLE_MEASURE_SEPARATOR,
                                    meaning: "barline",
                                    measureNumber: a.measureNumber
                                });
                            }
                        }
                        return {
                            text: n.join(l.BRAILLE_MEASURE_SEPARATOR),
                            debugEntries: e ? r : []
                        };
                    }
                    convertMultiStaff(t, e, i, s) {
                        const n = t.SourceMeasures, r = t.Staves.length, h = Math.min(r, 2);
                        if (h < 2) return this.convertSingleStaffWithHandSign(t, 0, e, i, s);
                        if (s?.barOverBar) return this.convertBarOverBar(t, e, i, s);
                        const c = n.length > 0 ? n[0].getKeyInstruction(0) : void 0, u = n.length > 0 ? n[0].ActiveTimeSignature : void 0, d = [], m = [];
                        for(let t = 0; t < h; t++){
                            const s = 0 === t ? l.BRAILLE_HAND_RIGHT : l.BRAILLE_HAND_LEFT, r = 0 === t ? "right hand" : "left hand", p = 0 === t ? a.ClefEnum.G : a.ClefEnum.F, g = f.computeSlurLengths(n, t), b = {
                                octaveTracker: new o.BrailleOctaveTracker,
                                facsimile: i,
                                currentClef: p,
                                hadInAccord: !1,
                                activeSlurs: new Set,
                                slurLengths: g
                            };
                            t > 0 && (c && (b.currentKey = c), u && (b.currentRhythm = u));
                            const S = this.convertNonfacsimile(n, e, t, b), y = (0, l.firstCharHasLowerDots)(S.text), E = y ? l.BRAILLE_AUGMENTATION_DOT : "", x = s + E + S.text;
                            if (d.push(x), e) {
                                m.push({
                                    braille: s + E,
                                    meaning: r + (y ? " (+ separator)" : ""),
                                    measureNumber: 0
                                });
                                for (const t of S.debugEntries)m.push(t);
                                t < h - 1 && m.push({
                                    braille: l.BRAILLE_LINE_BREAK,
                                    meaning: "staff separator (newline)",
                                    measureNumber: 0
                                });
                            }
                        }
                        return {
                            text: d.join(l.BRAILLE_LINE_BREAK),
                            debugEntries: e ? m : []
                        };
                    }
                    convertSingleStaffWithHandSign(t, e, i, s, n) {
                        const r = t.SourceMeasures, h = f.computeSlurLengths(r, e), c = {
                            octaveTracker: new o.BrailleOctaveTracker,
                            facsimile: s,
                            currentClef: a.ClefEnum.G,
                            hadInAccord: !1,
                            activeSlurs: new Set,
                            slurLengths: h
                        }, u = this.convertNonfacsimile(r, i, e, c), d = (0, l.firstCharHasLowerDots)(u.text), m = d ? l.BRAILLE_AUGMENTATION_DOT : "", p = l.BRAILLE_HAND_RIGHT, g = [];
                        return i && (g.push({
                            braille: p + m,
                            meaning: "right hand" + (d ? " (+ separator)" : ""),
                            measureNumber: 0
                        }), g.push(...u.debugEntries)), {
                            text: p + m + u.text,
                            debugEntries: i ? g : []
                        };
                    }
                    convertBarOverBar(t, e, i, s) {
                        const n = Math.min(t.Staves.length, 2), r = s?.lineWidth ?? 40;
                        return new h.BrailleBarOverBarLayout(this.measureRenderer).format(t, {
                            lineWidth: r,
                            staffCount: n,
                            guideDotThreshold: 6,
                            guideDotMinCount: 5
                        }, e, i, f.computeSlurLengths);
                    }
                    convertEnsemble(t, e, i, s) {
                        const n = s?.lineWidth ?? 40, r = t.Instruments, o = t.SourceMeasures, d = o.length > 0 ? o[0] : void 0, m = new Map;
                        let p, g = !0;
                        if (d) for (const t of r)for (const e of t.Staves){
                            const t = d.getKeyInstruction(e.idInMusicSheet);
                            t && (m.set(e.idInMusicSheet, t), void 0 === p ? p = t.Key : t.Key !== p && (g = !1));
                        }
                        const b = [];
                        for (const t of r){
                            const e = t.PartAbbreviation || t.Name || "?";
                            let i = (0, u.textToBraille)(e) + u.BRAILLE_ABBREV_PERIOD;
                            if (!g && t.Staves.length > 0) {
                                const e = t.Staves[0].idInMusicSheet, s = m.get(e);
                                if (s) {
                                    const t = (0, c.renderKeySignature)(s);
                                    t.braille && (i += t.braille);
                                }
                            }
                            const s = [];
                            let n = a.ClefEnum.G;
                            for (const e of t.Staves)s.push(e.idInMusicSheet);
                            if (t.Staves.length > 0 && d) {
                                const e = t.Staves[0].idInMusicSheet, i = d.FirstInstructionsStaffEntries[e];
                                if (i) {
                                    for (const t of i.Instructions)if (t instanceof a.ClefInstruction) {
                                        n = t.ClefType;
                                        break;
                                    }
                                }
                            }
                            b.push({
                                brailleAbbreviation: i,
                                staffIndices: s,
                                defaultClef: n
                            });
                        }
                        const S = new h.BrailleBarOverBarLayout(this.measureRenderer), y = b.reduce((t, e)=>t + e.staffIndices.length, 0), E = [];
                        for (const t of r){
                            const e = (0, u.textToBraille)(t.Name || "?"), i = (0, u.textToBraille)(t.PartAbbreviation || t.Name || "?") + u.BRAILLE_ABBREV_PERIOD;
                            E.push({
                                name: e,
                                abbreviation: i
                            });
                        }
                        const x = S.renderInstrumentTable(E), v = S.formatEnsemble(t, b, {
                            lineWidth: n,
                            staffCount: y,
                            guideDotThreshold: 6,
                            guideDotMinCount: 5
                        }, e, i, f.computeSlurLengths, g ? void 0 : m), T = [
                            ...x.lines,
                            "",
                            v.text
                        ], _ = [];
                        return e && (_.push(...x.debugEntries), _.push({
                            braille: l.BRAILLE_LINE_BREAK,
                            meaning: "instrument table separator",
                            measureNumber: 0
                        }), _.push(...v.debugEntries)), {
                            text: T.join(l.BRAILLE_LINE_BREAK),
                            debugEntries: e ? _ : []
                        };
                    }
                    convertWithLyrics(t, e, i, s) {
                        const n = s?.lineWidth ?? 40, r = s?.staffIndex ?? 0, c = t.SourceMeasures, m = [], p = (0, d.collectVerseNumbers)(c, r), g = p.length > 0 ? p[0] : "1";
                        if (0 === c.length) return {
                            text: "",
                            debugEntries: []
                        };
                        const b = c[0].getKeyInstruction(r), S = c[0].ActiveTimeSignature, y = new h.BrailleBarOverBarLayout(this.measureRenderer).renderMusicHeading(b, S, n), E = (0, d.buildMelismaSlurSet)(c, r, g), x = f.computeSlurLengths(c, r), v = {
                            octaveTracker: new o.BrailleOctaveTracker,
                            facsimile: i,
                            currentClef: a.ClefEnum.G,
                            hadInAccord: !1,
                            activeSlurs: new Set,
                            slurLengths: x,
                            melismaSlurNotes: E
                        };
                        b && (v.currentKey = b), S && (v.currentRhythm = S);
                        const T = [];
                        for (const t of c){
                            v.octaveTracker.reset();
                            const e = this.measureRenderer.render(t, r, v);
                            T.push(e);
                        }
                        const _ = {
                            melismaActive: !1
                        }, M = [];
                        for (const t of c){
                            const e = (0, d.extractLyricsMeasure)(t, r, g, _);
                            M.push(e);
                        }
                        const P = n - 2, L = [];
                        let w = 0;
                        for(; w < c.length;){
                            let t = 0, e = 0, i = w;
                            for(; i < c.length;){
                                const s = i > w ? 1 : 0, n = t + s + T[i].braille.length, r = e + s + M[i].cellLength;
                                if ((n > P || r > P) && i > w) break;
                                t = n, e = r, i++;
                            }
                            L.push({
                                startIndex: w,
                                endIndex: i
                            }), w = i;
                        }
                        const A = [];
                        y.braille.length > 0 && (A.push(y.braille), e && (m.push(...y.debugEntries), m.push({
                            braille: l.BRAILLE_LINE_BREAK,
                            meaning: "heading separator (newline)",
                            measureNumber: 0
                        })));
                        for(let t = 0; t < L.length; t++){
                            const i = L[t], s = [];
                            for(let t = i.startIndex; t < i.endIndex; t++){
                                if (s.push(M[t].wordText), e) for (const e of M[t].debugEntries)m.push({
                                    braille: e.braille,
                                    meaning: e.meaning,
                                    measureNumber: T[t].measureNumber
                                });
                                t < i.endIndex - 1 && s.push(u.BRAILLE_BLANK_CELL);
                            }
                            const n = s.join(""), r = [];
                            for(let t = i.startIndex; t < i.endIndex; t++)if (r.push(T[t].braille), e) {
                                for (const e of T[t].debugEntries)m.push({
                                    braille: e.braille,
                                    meaning: e.meaning,
                                    measureNumber: T[t].measureNumber
                                });
                                t < i.endIndex - 1 && m.push({
                                    braille: u.BRAILLE_BLANK_CELL,
                                    meaning: "barline",
                                    measureNumber: T[t].measureNumber
                                });
                            }
                            const o = u.BRAILLE_BLANK_CELL.repeat(2) + r.join(u.BRAILLE_BLANK_CELL);
                            A.push(n), A.push(o), e && m.push({
                                braille: l.BRAILLE_LINE_BREAK,
                                meaning: "word/music line break",
                                measureNumber: 0
                            });
                        }
                        const I = p.filter((t)=>t !== g);
                        for (const t of I){
                            const i = (0, d.extractFullVerse)(c, r, t);
                            if (i.braille.length > 0 && (A.push(i.braille), e)) for (const t of i.debugEntries)m.push({
                                braille: t.braille,
                                meaning: t.meaning,
                                measureNumber: 0
                            });
                        }
                        return {
                            text: A.join(l.BRAILLE_LINE_BREAK),
                            debugEntries: e ? m : []
                        };
                    }
                    convertFacsimile(t, e, i, s) {
                        const n = [], r = [], o = t.MusicPages;
                        for (const t of o){
                            const o = t.MusicSystems;
                            for (const t of o){
                                s.octaveTracker.reset();
                                const o = t.StaffLines;
                                if (e >= o.length) continue;
                                const a = o[e].Measures, h = [];
                                for(let t = 0; t < a.length; t++){
                                    const n = a[t], o = n.parentSourceMeasure;
                                    if (!o) continue;
                                    const c = this.renderFacsimileClef(n, o, s), u = this.measureRenderer.render(o, e, s), d = c.braille + u.braille;
                                    if (d.length > 0 && h.push(d), i) {
                                        for (const t of c.debugEntries)r.push({
                                            braille: t.braille,
                                            meaning: t.meaning,
                                            measureNumber: u.measureNumber
                                        });
                                        for (const t of u.debugEntries)r.push({
                                            braille: t.braille,
                                            meaning: t.meaning,
                                            measureNumber: u.measureNumber
                                        });
                                        t < a.length - 1 && r.push({
                                            braille: l.BRAILLE_MEASURE_SEPARATOR,
                                            meaning: "barline",
                                            measureNumber: u.measureNumber
                                        });
                                    }
                                }
                                h.length > 0 && (n.push(h.join(l.BRAILLE_MEASURE_SEPARATOR)), i && r.push({
                                    braille: l.BRAILLE_LINE_BREAK,
                                    meaning: "system/line break (\\n)",
                                    measureNumber: 0
                                }));
                            }
                        }
                        return i && r.length > 0 && r[r.length - 1].meaning.startsWith("system/line break") && r.pop(), {
                            text: n.join(l.BRAILLE_LINE_BREAK),
                            debugEntries: i ? r : []
                        };
                    }
                    renderFacsimileClef(t, e, i) {
                        const s = t.InitiallyActiveClef;
                        if (!s) return {
                            braille: "",
                            debugEntries: []
                        };
                        const n = s.ClefType, r = s.Line, o = 1 === e.MeasureNumber, a = n !== i.currentClef;
                        if (i.currentClef = n, o || a) {
                            const t = (0, l.getClefBraille)(n, r), e = (0, l.getClefName)(n, r);
                            if (t) return i.octaveTracker.reset(), {
                                braille: t,
                                debugEntries: [
                                    {
                                        braille: t,
                                        meaning: e
                                    }
                                ]
                            };
                        }
                        return {
                            braille: "",
                            debugEntries: []
                        };
                    }
                    static computeSlurLengths(t, e) {
                        const i = new Map, s = new Map;
                        for (const n of t)(0, r.forEachVoiceEntryInMeasure)(n, e, (t)=>{
                            for (const e of t){
                                for (const [t, e] of i)i.set(t, e + 1);
                                for (const t of e.Notes)if (t.NoteSlurs) for (const e of t.NoteSlurs)e.StartNote === t && e.EndNote && !i.has(e) && i.set(e, 1);
                                for (const t of e.Notes)if (t.NoteSlurs) for (const e of t.NoteSlurs)e.EndNote === t && i.has(e) && (s.set(e, i.get(e)), i.delete(e));
                            }
                        });
                        for (const [t, e] of i)s.set(t, e);
                        return s;
                    }
                }
                e.BrailleConverter = f;
            },
            6773 (t, e) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.BrailleDOMRenderer = void 0, e.BrailleDOMRenderer = class {
                    render(t, e = !1) {
                        const i = document.createElement("div");
                        i.className = "osmd-braille-output";
                        const s = document.createElement("pre");
                        if (s.className = "osmd-braille-text", s.textContent = t.text, s.setAttribute("aria-label", "Music Braille Output"), s.style.fontSize = "24px", s.style.lineHeight = "1.5", s.style.fontFamily = "serif", i.appendChild(s), e && t.debugEntries.length > 0) {
                            const e = this.renderDebugView(t.debugEntries);
                            i.appendChild(e);
                        }
                        return i;
                    }
                    renderDebugView(t) {
                        const e = document.createElement("div");
                        e.className = "osmd-braille-debug", e.style.marginTop = "12px", e.style.fontFamily = "monospace", e.style.fontSize = "12px", e.style.color = "#666";
                        const i = document.createElement("p");
                        i.className = "osmd-braille-translation";
                        let s = -1;
                        for (const e of t){
                            if (e.measureNumber !== s) {
                                -1 !== s && i.appendChild(document.createTextNode(" | "));
                                const t = document.createElement("strong");
                                t.textContent = "m" + e.measureNumber + ": ", i.appendChild(t), s = e.measureNumber;
                            }
                            const t = document.createElement("span");
                            t.className = "osmd-braille-debug-entry", t.textContent = "[" + e.meaning + "]", t.title = "Braille: " + e.braille, t.style.marginRight = "4px", i.appendChild(t);
                        }
                        return e.appendChild(i), e;
                    }
                };
            },
            761 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.getArticulationBraille = a, e.getArticulationName = l, e.renderArticulations = function(t) {
                    const e = [], i = [], n = [
                        ...t
                    ].sort((t, e)=>h(t.articulationEnum) - h(e.articulationEnum));
                    for (const t of n){
                        if (t.articulationEnum === s.ArticulationEnum.fermata || t.articulationEnum === s.ArticulationEnum.invertedfermata) continue;
                        if (t.articulationEnum === s.ArticulationEnum.breathmark || t.articulationEnum === s.ArticulationEnum.caesura) continue;
                        const n = a(t.articulationEnum);
                        n && (e.push(n), i.push({
                            braille: n,
                            meaning: l(t.articulationEnum)
                        }));
                    }
                    return {
                        braille: e.join(""),
                        debugEntries: i
                    };
                }, e.renderFermata = function(t) {
                    for (const e of t)if (e.articulationEnum === s.ArticulationEnum.fermata || e.articulationEnum === s.ArticulationEnum.invertedfermata) return {
                        braille: o.BRAILLE_FERMATA,
                        debugEntries: [
                            {
                                braille: o.BRAILLE_FERMATA,
                                meaning: "fermata"
                            }
                        ]
                    };
                    return {
                        braille: "",
                        debugEntries: []
                    };
                }, e.getOrnamentBraille = function(t) {
                    switch(t){
                        case n.OrnamentEnum.Trill:
                            return o.BRAILLE_TRILL;
                        case n.OrnamentEnum.Turn:
                            return o.BRAILLE_TURN;
                        case n.OrnamentEnum.InvertedTurn:
                            return o.BRAILLE_INVERTED_TURN;
                        case n.OrnamentEnum.DelayedTurn:
                            return o.BRAILLE_TURN_ON_NOTE;
                        case n.OrnamentEnum.DelayedInvertedTurn:
                            return o.BRAILLE_INVERTED_TURN_ON_NOTE;
                        case n.OrnamentEnum.Mordent:
                            return o.BRAILLE_MORDENT;
                        case n.OrnamentEnum.InvertedMordent:
                            return o.BRAILLE_INVERTED_MORDENT;
                        default:
                            return "";
                    }
                }, e.getOrnamentName = function(t) {
                    switch(t){
                        case n.OrnamentEnum.Trill:
                            return "trill";
                        case n.OrnamentEnum.Turn:
                            return "turn";
                        case n.OrnamentEnum.InvertedTurn:
                            return "inverted turn";
                        case n.OrnamentEnum.DelayedTurn:
                            return "delayed turn";
                        case n.OrnamentEnum.DelayedInvertedTurn:
                            return "delayed inverted turn";
                        case n.OrnamentEnum.Mordent:
                            return "mordent";
                        case n.OrnamentEnum.InvertedMordent:
                            return "inverted mordent";
                        default:
                            return "";
                    }
                }, e.renderDynamic = function(t, e) {
                    let i = r.DynamicEnum[t];
                    const s = e?.trim().toLowerCase();
                    if (s && /^[pfmsrz]+$/.test(s) && (i = s), !i || "other" === i) return {
                        braille: "",
                        debugEntries: []
                    };
                    const n = (0, o.getDynamicBraille)(i);
                    return n ? {
                        braille: n,
                        debugEntries: [
                            {
                                braille: n,
                                meaning: i + " (dynamic)"
                            }
                        ]
                    } : {
                        braille: "",
                        debugEntries: []
                    };
                };
                const s = i(1336), n = i(8215), r = i(2148), o = i(8351);
                function a(t) {
                    switch(t){
                        case s.ArticulationEnum.staccato:
                            return o.BRAILLE_STACCATO;
                        case s.ArticulationEnum.staccatissimo:
                        case s.ArticulationEnum.spiccato:
                            return o.BRAILLE_STACCATISSIMO;
                        case s.ArticulationEnum.detachedlegato:
                            return o.BRAILLE_MEZZO_STACCATO;
                        case s.ArticulationEnum.tenuto:
                            return o.BRAILLE_TENUTO;
                        case s.ArticulationEnum.accent:
                        case s.ArticulationEnum.softaccent:
                            return o.BRAILLE_ACCENT;
                        case s.ArticulationEnum.strongaccent:
                        case s.ArticulationEnum.marcatoup:
                        case s.ArticulationEnum.marcatodown:
                        case s.ArticulationEnum.invertedstrongaccent:
                            return o.BRAILLE_MARCATO;
                        default:
                            return "";
                    }
                }
                function l(t) {
                    switch(t){
                        case s.ArticulationEnum.staccato:
                            return "staccato";
                        case s.ArticulationEnum.staccatissimo:
                            return "staccatissimo";
                        case s.ArticulationEnum.spiccato:
                            return "spiccato";
                        case s.ArticulationEnum.detachedlegato:
                            return "mezzo-staccato";
                        case s.ArticulationEnum.tenuto:
                            return "tenuto";
                        case s.ArticulationEnum.accent:
                            return "accent";
                        case s.ArticulationEnum.softaccent:
                            return "soft accent";
                        case s.ArticulationEnum.strongaccent:
                            return "strong accent";
                        case s.ArticulationEnum.marcatoup:
                        case s.ArticulationEnum.marcatodown:
                            return "marcato";
                        case s.ArticulationEnum.invertedstrongaccent:
                            return "inverted strong accent";
                        default:
                            return "";
                    }
                }
                function h(t) {
                    switch(t){
                        case s.ArticulationEnum.staccato:
                        case s.ArticulationEnum.staccatissimo:
                        case s.ArticulationEnum.spiccato:
                            return 0;
                        case s.ArticulationEnum.accent:
                        case s.ArticulationEnum.softaccent:
                        case s.ArticulationEnum.strongaccent:
                        case s.ArticulationEnum.marcatoup:
                        case s.ArticulationEnum.marcatodown:
                        case s.ArticulationEnum.invertedstrongaccent:
                            return 1;
                        case s.ArticulationEnum.tenuto:
                            return 2;
                        case s.ArticulationEnum.detachedlegato:
                            return 3;
                        default:
                            return 10;
                    }
                }
            },
            8399 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.renderKeySignature = function(t) {
                    const e = t.Key;
                    if (0 === e) return {
                        braille: "",
                        debugEntries: []
                    };
                    const i = Math.abs(e), n = e > 0, r = n ? s.BRAILLE_SHARP : s.BRAILLE_FLAT, o = n ? "sharp" : "flat", a = i <= 3 ? r.repeat(i) : s.BRAILLE_NUMBER_SIGN + (0, s.numberToUpperDigits)(i) + r;
                    return {
                        braille: a,
                        debugEntries: [
                            {
                                braille: a,
                                meaning: i + " " + o + (i > 1 ? "s" : "")
                            }
                        ]
                    };
                };
                const s = i(8351);
            },
            3148 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.isLastSyllableInWord = r, e.extractLyricsMeasure = o, e.buildMelismaSlurSet = function(t, e, i) {
                    const n = new Set;
                    let r = !1;
                    for (const o of t)(0, s.forEachVoiceEntryInMeasure)(o, e, (t)=>{
                        const e = t[0], s = e.LyricsEntries.getValue(i);
                        s ? r = s.extend : r && n.add(e);
                    });
                    return n;
                }, e.collectVerseNumbers = function(t, e) {
                    const i = new Set;
                    for (const n of t)(0, s.forEachVoiceEntryInMeasure)(n, e, (t)=>{
                        t[0].LyricsEntries.forEach((t, e)=>{
                            i.add(t);
                        });
                    });
                    return Array.from(i).sort((t, e)=>{
                        const i = parseInt(t, 10), s = parseInt(e, 10);
                        return isNaN(i) || isNaN(s) ? t.localeCompare(e) : i - s;
                    });
                }, e.extractFullVerse = function(t, e, i) {
                    const s = {
                        melismaActive: !1
                    }, r = [], a = [];
                    for (const n of t){
                        const t = o(n, e, i, s);
                        t.wordText.length > 0 && r.push(t.wordText), a.push(...t.debugEntries);
                    }
                    const l = r.join(""), h = parseInt(i, 10);
                    let c = "";
                    isNaN(h) || (c = n.BRAILLE_OPEN_PAREN + n.BRAILLE_NUMBER_SIGN + (0, n.numberToUpperDigits)(h) + n.BRAILLE_CLOSE_PAREN + n.BRAILLE_BLANK_CELL);
                    const u = c + l;
                    return a.push({
                        braille: c,
                        meaning: "verse " + i
                    }), {
                        braille: u,
                        debugEntries: a
                    };
                };
                const s = i(2113), n = i(8351);
                function r(t) {
                    const e = t.Word;
                    if (!e) return !0;
                    const i = e.Syllables;
                    return !i || 0 === i.length || t === i[i.length - 1];
                }
                function o(t, e, i, o) {
                    const a = [], l = [];
                    (0, s.forEachVoiceEntryInMeasure)(t, e, (t)=>{
                        const e = t[0].LyricsEntries.getValue(i);
                        if (e) {
                            const t = (0, n.textToBraille)(e.Text);
                            a.push(t), l.push({
                                braille: t,
                                meaning: "lyric: " + e.Text
                            }), (-1 === e.SyllableIndex || r(e)) && a.push(n.BRAILLE_BLANK_CELL), o.melismaActive = e.extend;
                        } else o.melismaActive;
                    });
                    const h = a.join("");
                    return {
                        wordText: h,
                        cellLength: h.length,
                        debugEntries: l,
                        melismaActive: o.melismaActive
                    };
                }
            },
            2113 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.BrailleMeasureRenderer = void 0, e.forEachVoiceEntryInMeasure = f;
                const s = i(437), n = i(164), r = i(1645), o = i(1535), a = i(5799), l = i(8399), h = i(9591), c = i(8351), u = i(761), d = i(5875);
                function f(t, e, i) {
                    const s = t.VerticalSourceStaffEntryContainers;
                    for (const t of s){
                        const s = t.StaffEntries;
                        if (!s || e >= s.length) continue;
                        const n = s[e];
                        if (!n) continue;
                        const r = n.VoiceEntries;
                        r && 0 !== r.length && i(r);
                    }
                }
                e.BrailleMeasureRenderer = class {
                    constructor(){
                        this.noteRenderer = new o.BrailleNoteRenderer, this.chordRenderer = new a.BrailleChordRenderer;
                    }
                    render(t, e, i) {
                        const s = [], r = [];
                        if (i.hadInAccord && (i.octaveTracker.reset(), i.hadInAccord = !1), !i.facsimile) {
                            const s = t.FirstInstructionsStaffEntries[e];
                            if (s) for (const t of s.Instructions)t instanceof n.ClefInstruction && (i.currentClef = t.ClefType);
                        }
                        const o = t.getKeyInstruction(e);
                        if (o && (!i.currentKey || i.currentKey.OperatorNotEqual(o))) {
                            i.currentKey = o;
                            const t = (0, l.renderKeySignature)(o);
                            t.braille && (s.push(t.braille), r.push(...t.debugEntries));
                        }
                        const a = t.ActiveTimeSignature;
                        if (a && (!i.currentRhythm || i.currentRhythm.Numerator !== a.Numerator || i.currentRhythm.Denominator !== a.Denominator)) {
                            i.currentRhythm = a;
                            const t = (0, h.renderTimeSignature)(a);
                            t.braille && (s.push(t.braille), r.push(...t.debugEntries));
                        }
                        const u = this.renderVoltas(t);
                        u.braille && (s.push(u.braille), r.push(...u.debugEntries), i.octaveTracker.reset());
                        const d = this.renderNavigationStart(t);
                        d.braille && (s.push(d.braille), r.push(...d.debugEntries), i.octaveTracker.reset()), this.hasForwardRepeat(t) && (s.push(c.BRAILLE_FORWARD_REPEAT), r.push({
                            braille: c.BRAILLE_FORWARD_REPEAT,
                            meaning: "forward repeat"
                        }), i.octaveTracker.reset());
                        const f = this.collectDynamicEvents(t, e), m = i.facsimile ? this.collectOctaveShiftEvents(t, e) : [], p = this.groupVoiceEntries(t, e);
                        if (p.length <= 1) {
                            const t = 1 === p.length ? p[0].entries : [], e = this.renderVoiceEntries(t, i, f, m);
                            s.push(e.braille), r.push(...e.debugEntries);
                        } else {
                            const t = this.orderVoices(p, i.currentClef);
                            for(let e = 0; e < t.length; e++){
                                i.octaveTracker.reset();
                                const n = 0 === e ? f : [], o = 0 === e ? m : [], a = this.renderVoiceEntries(t[e].entries, i, n, o);
                                e > 0 && (s.push(c.BRAILLE_FULL_MEASURE_IN_ACCORD), r.push({
                                    braille: c.BRAILLE_FULL_MEASURE_IN_ACCORD,
                                    meaning: "full-measure in-accord"
                                })), s.push(a.braille), r.push(...a.debugEntries);
                            }
                            i.hadInAccord = !0;
                        }
                        this.hasBackwardRepeat(t) && (s.push(c.BRAILLE_BACKWARD_REPEAT), r.push({
                            braille: c.BRAILLE_BACKWARD_REPEAT,
                            meaning: "backward repeat"
                        }), i.octaveTracker.reset());
                        const g = this.renderNavigationEnd(t);
                        return g.braille && (s.push(g.braille), r.push(...g.debugEntries), i.octaveTracker.reset()), {
                            braille: s.join(""),
                            debugEntries: r,
                            measureNumber: t.MeasureNumber
                        };
                    }
                    groupVoiceEntries(t, e) {
                        const i = new Map;
                        f(t, e, (t)=>{
                            for (const e of t){
                                const t = e.ParentVoice.VoiceId;
                                let s = i.get(t);
                                s || (s = {
                                    voice: e.ParentVoice,
                                    entries: []
                                }, i.set(t, s)), s.entries.push(e);
                            }
                        });
                        const s = Array.from(i.values());
                        return s.sort((t, e)=>t.voice.VoiceId - e.voice.VoiceId), s;
                    }
                    orderVoices(t, e) {
                        const i = [];
                        for (const e of t){
                            const t = this.getFirstPitchHalfTone(e);
                            i.push({
                                group: e,
                                halfTone: t
                            });
                        }
                        return e === n.ClefEnum.F ? i.sort((t, e)=>t.halfTone - e.halfTone) : i.sort((t, e)=>e.halfTone - t.halfTone), i.map((t)=>t.group);
                    }
                    getFirstPitchHalfTone(t) {
                        for (const e of t.entries)for (const t of e.Notes)if (t.Pitch) return t.Pitch.getHalfTone();
                        return 0;
                    }
                    renderVoiceEntries(t, e, i = [], s = []) {
                        const n = [], r = [];
                        let o = 0, a = 0;
                        for (const l of t){
                            const t = l.Notes, h = l.Timestamp ? l.Timestamp.RealValue : 0;
                            for(; o < i.length && i[o].timestamp <= h + 1e-4;){
                                const t = i[o];
                                n.push(t.braille), r.push(...t.debugEntries), e.octaveTracker.reset(), o++;
                            }
                            for(; a < s.length && s[a].timestamp <= h + 1e-4;){
                                const t = s[a];
                                if ("end" === t.kind) n.push(c.BRAILLE_OTTAVA_END), r.push({
                                    braille: c.BRAILLE_OTTAVA_END,
                                    meaning: "end ottava"
                                }), e.activeOctaveShift = void 0, e.octaveTracker.reset();
                                else {
                                    const i = (0, c.getOttavaBraille)(t.shift.Type), s = (0, c.getOttavaName)(t.shift.Type);
                                    i && (n.push(i), r.push({
                                        braille: i,
                                        meaning: s
                                    }), e.activeOctaveShift = t.shift, e.octaveTracker.reset());
                                }
                                a++;
                            }
                            const u = this.handleBracketSlurOpen(t, e);
                            u.braille && (n.push(u.braille), r.push(...u.debugEntries));
                            const d = this.getOttavaPitchOverride(t[0], e);
                            if (1 === t.length) {
                                const i = this.noteRenderer.render(t[0], e.octaveTracker, l, d);
                                n.push(i.braille), r.push(...i.debugEntries);
                            } else if (t.length > 1) {
                                const i = this.chordRenderer.render(t, e.currentClef, e.octaveTracker, l, e.activeOctaveShift, e.ensembleMode);
                                n.push(i.braille), r.push(...i.debugEntries);
                            }
                            e.melismaSlurNotes && e.melismaSlurNotes.has(l) && (n.push(c.BRAILLE_SYLLABIC_SLUR), r.push({
                                braille: c.BRAILLE_SYLLABIC_SLUR,
                                meaning: "syllabic slur (melisma)"
                            }));
                            const f = this.handleSlurs(t, e);
                            f.braille && (n.push(f.braille), r.push(...f.debugEntries));
                        }
                        for(; o < i.length;){
                            const t = i[o];
                            n.push(t.braille), r.push(...t.debugEntries), o++;
                        }
                        for(; a < s.length;){
                            const t = s[a];
                            if ("end" === t.kind) n.push(c.BRAILLE_OTTAVA_END), r.push({
                                braille: c.BRAILLE_OTTAVA_END,
                                meaning: "end ottava"
                            }), e.activeOctaveShift = void 0;
                            else {
                                const i = (0, c.getOttavaBraille)(t.shift.Type), s = (0, c.getOttavaName)(t.shift.Type);
                                i && (n.push(i), r.push({
                                    braille: i,
                                    meaning: s
                                }), e.activeOctaveShift = t.shift);
                            }
                            a++;
                        }
                        return {
                            braille: n.join(""),
                            debugEntries: r
                        };
                    }
                    handleSlurs(t, e) {
                        const i = [], s = [], n = t[0];
                        for (const i of t)if (i.NoteSlurs) for (const t of i.NoteSlurs)t.StartNote === i && t.EndNote && e.activeSlurs.add(t);
                        const r = [];
                        for (const i of e.activeSlurs)for (const e of t)i.EndNote === e && r.push(i);
                        const o = e.activeSlurs.size > 0, a = r.length > 0 && r.length >= e.activeSlurs.size, l = this.hasActiveShortSlur(e);
                        if (o && !a && l) {
                            const t = void 0 !== n.NoteTie && n.NoteTie.StartNote === n;
                            !e.facsimile && t || (i.push(c.BRAILLE_SLUR), s.push({
                                braille: c.BRAILLE_SLUR,
                                meaning: "slur"
                            }));
                        }
                        for (const t of r)(e.slurLengths.get(t) ?? 0) > 4 && (i.push(c.BRAILLE_BRACKET_SLUR_CLOSE), s.push({
                            braille: c.BRAILLE_BRACKET_SLUR_CLOSE,
                            meaning: "bracket slur close"
                        }));
                        for (const t of r)e.activeSlurs.delete(t);
                        return {
                            braille: i.join(""),
                            debugEntries: s
                        };
                    }
                    hasActiveShortSlur(t) {
                        for (const e of t.activeSlurs){
                            const i = t.slurLengths.get(e) ?? 0;
                            if (i <= 4 && i > 0) return !0;
                        }
                        return !1;
                    }
                    hasForwardRepeat(t) {
                        for (const e of t.FirstRepetitionInstructions)if (e.type === r.RepetitionInstructionEnum.StartLine) {
                            if (e.parentRepetition && e.parentRepetition.FromWords) continue;
                            return !0;
                        }
                        return !1;
                    }
                    hasBackwardRepeat(t) {
                        for (const e of t.LastRepetitionInstructions)if (e.type === r.RepetitionInstructionEnum.BackJumpLine) return !0;
                        return !1;
                    }
                    renderVoltas(t) {
                        const e = [], i = [];
                        for (const s of t.FirstRepetitionInstructions)if (s.type === r.RepetitionInstructionEnum.Ending && s.alignment === r.AlignmentType.Begin && s.endingIndices && s.endingIndices.length > 0) {
                            for (const t of s.endingIndices){
                                const s = (0, c.getVoltaBraille)(t);
                                s && (e.push(s), i.push({
                                    braille: s,
                                    meaning: "volta " + t
                                }));
                            }
                            e.push(c.BRAILLE_AUGMENTATION_DOT), i.push({
                                braille: c.BRAILLE_AUGMENTATION_DOT,
                                meaning: "volta separator"
                            });
                        }
                        return {
                            braille: e.join(""),
                            debugEntries: i
                        };
                    }
                    renderNavigationStart(t) {
                        const e = [], i = [], s = new Set([
                            r.RepetitionInstructionEnum.Segno,
                            r.RepetitionInstructionEnum.Coda
                        ]);
                        for (const n of t.FirstRepetitionInstructions)if (s.has(n.type)) {
                            const t = (0, c.getNavigationBraille)(n.type), s = (0, c.getNavigationName)(n.type);
                            t && (e.push(t), i.push({
                                braille: t,
                                meaning: s
                            }));
                        }
                        return {
                            braille: e.join(""),
                            debugEntries: i
                        };
                    }
                    renderNavigationEnd(t) {
                        const e = [], i = [], s = new Set([
                            r.RepetitionInstructionEnum.Fine,
                            r.RepetitionInstructionEnum.ToCoda,
                            r.RepetitionInstructionEnum.DaCapo,
                            r.RepetitionInstructionEnum.DalSegno,
                            r.RepetitionInstructionEnum.DaCapoAlFine,
                            r.RepetitionInstructionEnum.DalSegnoAlFine,
                            r.RepetitionInstructionEnum.DaCapoAlCoda,
                            r.RepetitionInstructionEnum.DalSegnoAlCoda,
                            r.RepetitionInstructionEnum.Coda,
                            r.RepetitionInstructionEnum.Segno
                        ]);
                        for (const n of t.LastRepetitionInstructions)if (s.has(n.type)) {
                            const t = (0, c.getNavigationBraille)(n.type), s = (0, c.getNavigationName)(n.type);
                            t && (e.push(t), i.push({
                                braille: t,
                                meaning: s
                            }));
                        }
                        return {
                            braille: e.join(""),
                            debugEntries: i
                        };
                    }
                    handleBracketSlurOpen(t, e) {
                        const i = [], s = [];
                        for (const n of t)if (n.NoteSlurs) for (const t of n.NoteSlurs)t.StartNote === n && t.EndNote && (e.slurLengths.get(t) ?? 0) > 4 && (i.push(c.BRAILLE_BRACKET_SLUR_OPEN), s.push({
                            braille: c.BRAILLE_BRACKET_SLUR_OPEN,
                            meaning: "bracket slur open"
                        }));
                        return {
                            braille: i.join(""),
                            debugEntries: s
                        };
                    }
                    getOttavaPitchOverride(t, e) {
                        if (e.facsimile && e.activeOctaveShift && t && t.Pitch) return s.OctaveShift.getPitchFromOctaveShift(t.Pitch, e.activeOctaveShift.Type);
                    }
                    collectDynamicEvents(t, e) {
                        const i = [], s = t.StaffLinkedExpressions;
                        if (!s || e >= s.length) return i;
                        const n = s[e];
                        if (!n) return i;
                        for (const t of n){
                            const e = t.Timestamp ? t.Timestamp.RealValue : 0;
                            if (t.InstantaneousDynamic) {
                                const s = (0, u.renderDynamic)(t.InstantaneousDynamic.DynEnum, t.InstantaneousDynamic.DynamicExpression);
                                s.braille && i.push({
                                    timestamp: e,
                                    braille: s.braille,
                                    debugEntries: s.debugEntries
                                });
                            }
                            if (t.StartingContinuousDynamic) {
                                const s = t.StartingContinuousDynamic.DynamicType, n = s === d.ContDynamicEnum.crescendo ? c.BRAILLE_CRESC_HAIRPIN : c.BRAILLE_DIM_HAIRPIN, r = s === d.ContDynamicEnum.crescendo ? "crescendo" : "diminuendo";
                                i.push({
                                    timestamp: e,
                                    braille: n,
                                    debugEntries: [
                                        {
                                            braille: n,
                                            meaning: r
                                        }
                                    ]
                                });
                            }
                        }
                        return i.sort((t, e)=>t.timestamp - e.timestamp), i;
                    }
                    collectOctaveShiftEvents(t, e) {
                        const i = [], s = t.StaffLinkedExpressions;
                        if (!s || e >= s.length) return i;
                        const n = s[e];
                        if (!n) return i;
                        for (const t of n){
                            const e = t.Timestamp ? t.Timestamp.RealValue : 0;
                            t.OctaveShiftStart && i.push({
                                timestamp: e,
                                kind: "start",
                                shift: t.OctaveShiftStart
                            }), t.OctaveShiftEnd && i.push({
                                timestamp: e,
                                kind: "end",
                                shift: t.OctaveShiftEnd
                            });
                        }
                        return i.sort((t, e)=>t.timestamp !== e.timestamp ? t.timestamp - e.timestamp : ("end" === t.kind ? 0 : 1) - ("end" === e.kind ? 0 : 1)), i;
                    }
                };
            },
            1535 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.BrailleNoteRenderer = void 0;
                const s = i(8233), n = i(5282), r = i(8351), o = i(761);
                e.BrailleNoteRenderer = class {
                    render(t, e, i, n) {
                        const a = [], l = [], h = this.getDurationGroup(t);
                        if (t.isRest()) {
                            const t = (0, r.getRestChar)(h);
                            a.push(t), l.push({
                                braille: t,
                                meaning: this.getDurationName(h) + " rest"
                            });
                        } else if (t.Pitch) {
                            const c = n ?? t.Pitch;
                            if (i && i.Articulations && i.Articulations.length > 0) {
                                const t = (0, o.renderArticulations)(i.Articulations);
                                t.braille && (a.push(t.braille), l.push(...t.debugEntries));
                            }
                            if (i && i.OrnamentContainer) {
                                const t = (0, o.getOrnamentBraille)(i.OrnamentContainer.GetOrnament);
                                t && (a.push(t), l.push({
                                    braille: t,
                                    meaning: (0, o.getOrnamentName)(i.OrnamentContainer.GetOrnament)
                                }));
                            }
                            if (void 0 !== t.Pitch.AccidentalXml && t.Pitch.Accidental !== s.AccidentalEnum.NONE) {
                                const e = (0, r.getAccidentalChar)(t.Pitch.Accidental);
                                e && (a.push(e), l.push({
                                    braille: e,
                                    meaning: (0, r.getAccidentalName)(t.Pitch.Accidental)
                                }));
                            }
                            const u = e.getOctaveMark(c);
                            if (u) {
                                const t = c.Octave + 3;
                                a.push(u), l.push({
                                    braille: u,
                                    meaning: "octave " + t
                                });
                            }
                            const d = (0, r.getNoteChar)(c.FundamentalNote, h);
                            a.push(d), l.push({
                                braille: d,
                                meaning: this.getDurationName(h) + " " + c.ToStringShort(s.Pitch.OctaveXmlDifference)
                            });
                        }
                        const c = t.DotsXml ?? 0;
                        for(let t = 0; t < c; t++)a.push(r.BRAILLE_AUGMENTATION_DOT), l.push({
                            braille: r.BRAILLE_AUGMENTATION_DOT,
                            meaning: "augmentation dot"
                        });
                        if (i && i.Articulations && i.Articulations.length > 0) {
                            const t = (0, o.renderFermata)(i.Articulations);
                            t.braille && (a.push(t.braille), l.push(...t.debugEntries));
                        }
                        if (t.NoteTie && t.NoteTie.StartNote === t) {
                            const t = void 0 !== i && i.Notes.length > 1, e = t ? r.BRAILLE_CHORD_TIE : r.BRAILLE_SINGLE_TIE, s = t ? "chord tie" : "tie";
                            a.push(e), l.push({
                                braille: e,
                                meaning: s
                            });
                        }
                        return {
                            braille: a.join(""),
                            debugEntries: l
                        };
                    }
                    getDurationGroup(t) {
                        const e = t.NoteTypeXml;
                        if (void 0 !== e && e !== n.NoteType.UNDEFINED) {
                            const t = (0, r.noteTypeToDurationGroup)(e);
                            if (void 0 !== t) return t;
                        }
                        return t.Length ? (0, r.fractionToDurationGroup)(t.Length.RealValue) : r.BrailleDurationGroup.QuarterOr64th;
                    }
                    getDurationName(t) {
                        switch(t){
                            case r.BrailleDurationGroup.WholeOr16th:
                                return "whole/16th";
                            case r.BrailleDurationGroup.HalfOr32nd:
                                return "half/32nd";
                            case r.BrailleDurationGroup.QuarterOr64th:
                                return "quarter/64th";
                            case r.BrailleDurationGroup.EighthOr128th:
                                return "eighth/128th";
                            default:
                                return "unknown";
                        }
                    }
                };
            },
            746 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.BrailleOctaveTracker = void 0;
                const s = i(8233), n = i(8351);
                class r {
                    constructor(){
                        this.isFirstNote = !0;
                    }
                    getOctaveMark(t) {
                        const e = t.Octave + s.Pitch.OctaveXmlDifference;
                        let i = !1;
                        if (this.isFirstNote) i = !0, this.isFirstNote = !1;
                        else if (this.previousPitch) {
                            const n = r.calculateDiatonicInterval(this.previousPitch, t);
                            i = !(n <= 3) && (n >= 6 || e !== this.previousPitch.Octave + s.Pitch.OctaveXmlDifference);
                        } else i = !0;
                        return this.previousPitch = t, i ? n.OCTAVE_MARKS.get(e) ?? "" : "";
                    }
                    reset() {
                        this.previousPitch = void 0, this.isFirstNote = !0;
                    }
                    static calculateDiatonicInterval(t, e) {
                        const i = r.noteEnumToDiatonicIndex(t.FundamentalNote), n = r.noteEnumToDiatonicIndex(e.FundamentalNote), o = 7 * (t.Octave + s.Pitch.OctaveXmlDifference) + i, a = 7 * (e.Octave + s.Pitch.OctaveXmlDifference) + n;
                        return Math.abs(a - o) + 1;
                    }
                    static noteEnumToDiatonicIndex(t) {
                        switch(t){
                            case s.NoteEnum.C:
                                return 0;
                            case s.NoteEnum.D:
                                return 1;
                            case s.NoteEnum.E:
                                return 2;
                            case s.NoteEnum.F:
                                return 3;
                            case s.NoteEnum.G:
                                return 4;
                            case s.NoteEnum.A:
                                return 5;
                            case s.NoteEnum.B:
                                return 6;
                            default:
                                return 0;
                        }
                    }
                }
                e.BrailleOctaveTracker = r;
            },
            8351 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.BRAILLE_CHORD_TIE = e.BRAILLE_SINGLE_TIE = e.BRAILLE_DIM_HAIRPIN = e.BRAILLE_CRESC_HAIRPIN = e.BRAILLE_CLOSE_PAREN = e.BRAILLE_OPEN_PAREN = e.BRAILLE_ABBREV_PERIOD = e.BRAILLE_WORD_SIGN = e.BRAILLE_INVERTED_MORDENT = e.BRAILLE_MORDENT = e.BRAILLE_INVERTED_TURN_ON_NOTE = e.BRAILLE_INVERTED_TURN = e.BRAILLE_TURN_ON_NOTE = e.BRAILLE_TURN = e.BRAILLE_TRILL = e.BRAILLE_FERMATA = e.BRAILLE_MARCATO = e.BRAILLE_ACCENT = e.BRAILLE_TENUTO = e.BRAILLE_MEZZO_STACCATO = e.BRAILLE_STACCATISSIMO = e.BRAILLE_STACCATO = e.BRAILLE_UPPER_DIGITS = e.BRAILLE_DIGITS = e.BRAILLE_NUMBER_SIGN = e.BRAILLE_DOUBLE_FLAT = e.BRAILLE_DOUBLE_SHARP = e.BRAILLE_NATURAL = e.BRAILLE_FLAT = e.BRAILLE_SHARP = e.BRAILLE_INTERVAL_SIGNS = e.BRAILLE_MEASURE_DIVISION = e.BRAILLE_PART_MEASURE_IN_ACCORD = e.BRAILLE_FULL_MEASURE_IN_ACCORD = e.BRAILLE_SECTIONAL_DOUBLE_BAR = e.BRAILLE_FINAL_DOUBLE_BAR = e.BRAILLE_MEASURE_SEPARATOR = e.BRAILLE_AUGMENTATION_DOT = e.OCTAVE_MARKS = e.REST_CHARS = e.PITCH_DOTS = e.DURATION_DOTS = e.BRAILLE_BASE = e.DOT6 = e.DOT5 = e.DOT4 = e.DOT3 = e.DOT2 = e.DOT1 = e.BrailleDurationGroup = void 0, e.BRAILLE_OTTAVA_END = e.BRAILLE_OTTAVA_15MB = e.BRAILLE_OTTAVA_15MA = e.BRAILLE_OTTAVA_8VB = e.BRAILLE_OTTAVA_8VA = e.BRAILLE_HAND_LEFT = e.BRAILLE_HAND_RIGHT = e.BRAILLE_LINE_BREAK = e.BRAILLE_PAGE_INDICATOR = e.BRAILLE_MUSIC_HYPHEN = e.BRAILLE_CLEF_TENOR = e.BRAILLE_CLEF_C = e.BRAILLE_CLEF_F = e.BRAILLE_CLEF_G = e.BRAILLE_BLANK_CELL = e.BRAILLE_CODA = e.BRAILLE_SEGNO = e.BRAILLE_BACKWARD_REPEAT = e.BRAILLE_FORWARD_REPEAT = e.BRAILLE_BRACKET_SLUR_CLOSE = e.BRAILLE_BRACKET_SLUR_OPEN = e.BRAILLE_SYLLABIC_SLUR = e.BRAILLE_SLUR = void 0, e.dotsToChar = h, e.getNoteChar = function(t, i) {
                    const s = e.PITCH_DOTS.get(t);
                    return void 0 === s ? "" : h(s | e.DURATION_DOTS[i]);
                }, e.getRestChar = function(t) {
                    return e.REST_CHARS.get(t) ?? "";
                }, e.getIntervalChar = function(t) {
                    let i = t;
                    return i > 8 && (i = (i - 2) % 7 + 2), e.BRAILLE_INTERVAL_SIGNS.get(i) ?? "";
                }, e.getIntervalName = function(t) {
                    return t >= 2 && t <= 8 ? [
                        "",
                        "unison",
                        "2nd",
                        "3rd",
                        "4th",
                        "5th",
                        "6th",
                        "7th",
                        "octave"
                    ][t] : t > 8 ? t + "th (compound)" : "unknown";
                }, e.numberToUpperDigits = function(t) {
                    let i = "";
                    for (const s of t.toString())i += e.BRAILLE_UPPER_DIGITS[parseInt(s, 10)];
                    return i;
                }, e.numberToLowerDigits = function(t) {
                    let i = "";
                    for (const s of t.toString())i += e.BRAILLE_DIGITS[parseInt(s, 10)];
                    return i;
                }, e.getAccidentalChar = function(t) {
                    switch(t){
                        case s.AccidentalEnum.SHARP:
                            return e.BRAILLE_SHARP;
                        case s.AccidentalEnum.FLAT:
                            return e.BRAILLE_FLAT;
                        case s.AccidentalEnum.NATURAL:
                            return e.BRAILLE_NATURAL;
                        case s.AccidentalEnum.DOUBLESHARP:
                            return e.BRAILLE_DOUBLE_SHARP;
                        case s.AccidentalEnum.DOUBLEFLAT:
                            return e.BRAILLE_DOUBLE_FLAT;
                        default:
                            return "";
                    }
                }, e.getAccidentalName = function(t) {
                    switch(t){
                        case s.AccidentalEnum.SHARP:
                            return "sharp";
                        case s.AccidentalEnum.FLAT:
                            return "flat";
                        case s.AccidentalEnum.NATURAL:
                            return "natural";
                        case s.AccidentalEnum.DOUBLESHARP:
                            return "double sharp";
                        case s.AccidentalEnum.DOUBLEFLAT:
                            return "double flat";
                        default:
                            return "";
                    }
                }, e.getDynamicBraille = function(t) {
                    let i = "";
                    for (const e of t)switch(e){
                        case "p":
                            i += m;
                            break;
                        case "f":
                            i += d;
                            break;
                        case "m":
                            i += f;
                            break;
                        case "s":
                            i += g;
                            break;
                        case "z":
                            i += b;
                            break;
                        case "r":
                            i += p;
                    }
                    return i ? e.BRAILLE_WORD_SIGN + i : "";
                }, e.getVoltaBraille = function(t) {
                    return t < 0 || t > 9 ? "" : e.BRAILLE_NUMBER_SIGN + e.BRAILLE_DIGITS[t];
                }, e.getNavigationBraille = function(t) {
                    switch(t){
                        case r.RepetitionInstructionEnum.Segno:
                            return e.BRAILLE_SEGNO;
                        case r.RepetitionInstructionEnum.Coda:
                        case r.RepetitionInstructionEnum.ToCoda:
                            return e.BRAILLE_CODA;
                        case r.RepetitionInstructionEnum.Fine:
                            return P;
                        case r.RepetitionInstructionEnum.DaCapo:
                            return _;
                        case r.RepetitionInstructionEnum.DalSegno:
                            return M;
                        case r.RepetitionInstructionEnum.DaCapoAlFine:
                            return e.BRAILLE_WORD_SIGN + u + e.BRAILLE_ABBREV_PERIOD + c + e.BRAILLE_ABBREV_PERIOD + e.BRAILLE_BLANK_CELL + L + e.BRAILLE_WORD_SIGN;
                        case r.RepetitionInstructionEnum.DalSegnoAlFine:
                            return e.BRAILLE_WORD_SIGN + u + e.BRAILLE_ABBREV_PERIOD + g + e.BRAILLE_ABBREV_PERIOD + e.BRAILLE_BLANK_CELL + L + e.BRAILLE_WORD_SIGN;
                        case r.RepetitionInstructionEnum.DaCapoAlCoda:
                            return e.BRAILLE_WORD_SIGN + u + e.BRAILLE_ABBREV_PERIOD + c + e.BRAILLE_ABBREV_PERIOD + e.BRAILLE_BLANK_CELL + w + e.BRAILLE_WORD_SIGN;
                        case r.RepetitionInstructionEnum.DalSegnoAlCoda:
                            return e.BRAILLE_WORD_SIGN + u + e.BRAILLE_ABBREV_PERIOD + g + e.BRAILLE_ABBREV_PERIOD + e.BRAILLE_BLANK_CELL + w + e.BRAILLE_WORD_SIGN;
                        default:
                            return "";
                    }
                }, e.getNavigationName = function(t) {
                    switch(t){
                        case r.RepetitionInstructionEnum.Segno:
                            return "segno";
                        case r.RepetitionInstructionEnum.Coda:
                            return "coda";
                        case r.RepetitionInstructionEnum.ToCoda:
                            return "to coda";
                        case r.RepetitionInstructionEnum.Fine:
                            return "fine";
                        case r.RepetitionInstructionEnum.DaCapo:
                            return "D.C.";
                        case r.RepetitionInstructionEnum.DalSegno:
                            return "D.S.";
                        case r.RepetitionInstructionEnum.DaCapoAlFine:
                            return "D.C. al Fine";
                        case r.RepetitionInstructionEnum.DalSegnoAlFine:
                            return "D.S. al Fine";
                        case r.RepetitionInstructionEnum.DaCapoAlCoda:
                            return "D.C. al Coda";
                        case r.RepetitionInstructionEnum.DalSegnoAlCoda:
                            return "D.S. al Coda";
                        default:
                            return "";
                    }
                }, e.getClefBraille = function(t, i) {
                    switch(t){
                        case o.ClefEnum.G:
                            return e.BRAILLE_CLEF_G;
                        case o.ClefEnum.F:
                            return e.BRAILLE_CLEF_F;
                        case o.ClefEnum.C:
                            return 4 === i ? e.BRAILLE_CLEF_TENOR : e.BRAILLE_CLEF_C;
                        default:
                            return "";
                    }
                }, e.getClefName = function(t, e) {
                    switch(t){
                        case o.ClefEnum.G:
                            return "treble clef";
                        case o.ClefEnum.F:
                            return "bass clef";
                        case o.ClefEnum.C:
                            return 4 === e ? "tenor clef" : "alto clef";
                        default:
                            return "clef";
                    }
                }, e.firstCharHasLowerDots = function(t) {
                    return !(!t || 0 === t.length) && 0 !== (t.charCodeAt(0) - e.BRAILLE_BASE & (e.DOT1 | e.DOT2 | e.DOT3));
                }, e.getOttavaBraille = function(t) {
                    switch(t){
                        case a.OctaveEnum.VA8:
                            return e.BRAILLE_OTTAVA_8VA;
                        case a.OctaveEnum.VB8:
                            return e.BRAILLE_OTTAVA_8VB;
                        case a.OctaveEnum.MA15:
                            return e.BRAILLE_OTTAVA_15MA;
                        case a.OctaveEnum.MB15:
                            return e.BRAILLE_OTTAVA_15MB;
                        default:
                            return "";
                    }
                }, e.getOttavaName = function(t) {
                    switch(t){
                        case a.OctaveEnum.VA8:
                            return "8va";
                        case a.OctaveEnum.VB8:
                            return "8vb";
                        case a.OctaveEnum.MA15:
                            return "15ma";
                        case a.OctaveEnum.MB15:
                            return "15mb";
                        default:
                            return "";
                    }
                }, e.noteTypeToDurationGroup = function(t) {
                    switch(t){
                        case n.NoteType.WHOLE:
                        case n.NoteType._16th:
                            return l.WholeOr16th;
                        case n.NoteType.HALF:
                        case n.NoteType._32nd:
                            return l.HalfOr32nd;
                        case n.NoteType.QUARTER:
                        case n.NoteType._64th:
                            return l.QuarterOr64th;
                        case n.NoteType.EIGHTH:
                        case n.NoteType._128th:
                            return l.EighthOr128th;
                        default:
                            return;
                    }
                }, e.fractionToDurationGroup = function(t) {
                    return t >= .5 ? t >= .75 ? l.WholeOr16th : l.HalfOr32nd : t >= .125 ? t >= .1875 ? l.QuarterOr64th : l.EighthOr128th : t >= .03125 ? t >= .046875 ? l.WholeOr16th : l.HalfOr32nd : t >= .01171875 ? l.QuarterOr64th : l.EighthOr128th;
                }, e.textToBraille = function(t) {
                    let i = "", s = !1;
                    for (const n of t){
                        if (n >= "0" && n <= "9") {
                            s || (i += e.BRAILLE_NUMBER_SIGN, s = !0), i += e.BRAILLE_UPPER_DIGITS[parseInt(n, 10)];
                            continue;
                        }
                        s = !1;
                        const t = n.toLowerCase(), r = K.get(t);
                        r ? i += r : " " === n ? i += e.BRAILLE_BLANK_CELL : "." === n && (i += e.BRAILLE_ABBREV_PERIOD);
                    }
                    return i;
                };
                const s = i(8233), n = i(5282), r = i(1645), o = i(164), a = i(437);
                var l;
                function h(t) {
                    return String.fromCharCode(e.BRAILLE_BASE | t);
                }
                !function(t) {
                    t[t.WholeOr16th = 0] = "WholeOr16th", t[t.HalfOr32nd = 1] = "HalfOr32nd", t[t.QuarterOr64th = 2] = "QuarterOr64th", t[t.EighthOr128th = 3] = "EighthOr128th";
                }(l || (e.BrailleDurationGroup = l = {})), e.DOT1 = 1, e.DOT2 = 2, e.DOT3 = 4, e.DOT4 = 8, e.DOT5 = 16, e.DOT6 = 32, e.BRAILLE_BASE = 10240, e.DURATION_DOTS = [
                    e.DOT3 | e.DOT6,
                    e.DOT3,
                    e.DOT6,
                    0
                ], e.PITCH_DOTS = new Map([
                    [
                        s.NoteEnum.C,
                        e.DOT1 | e.DOT4 | e.DOT5
                    ],
                    [
                        s.NoteEnum.D,
                        e.DOT1 | e.DOT5
                    ],
                    [
                        s.NoteEnum.E,
                        e.DOT1 | e.DOT2 | e.DOT4
                    ],
                    [
                        s.NoteEnum.F,
                        e.DOT1 | e.DOT2 | e.DOT4 | e.DOT5
                    ],
                    [
                        s.NoteEnum.G,
                        e.DOT1 | e.DOT2 | e.DOT5
                    ],
                    [
                        s.NoteEnum.A,
                        e.DOT2 | e.DOT4
                    ],
                    [
                        s.NoteEnum.B,
                        e.DOT2 | e.DOT4 | e.DOT5
                    ]
                ]), e.REST_CHARS = new Map([
                    [
                        l.WholeOr16th,
                        h(e.DOT1 | e.DOT3 | e.DOT4)
                    ],
                    [
                        l.HalfOr32nd,
                        h(e.DOT1 | e.DOT3 | e.DOT6)
                    ],
                    [
                        l.QuarterOr64th,
                        h(e.DOT1 | e.DOT2 | e.DOT3 | e.DOT6)
                    ],
                    [
                        l.EighthOr128th,
                        h(e.DOT1 | e.DOT3 | e.DOT4 | e.DOT6)
                    ]
                ]), e.OCTAVE_MARKS = new Map([
                    [
                        1,
                        h(e.DOT4)
                    ],
                    [
                        2,
                        h(e.DOT4 | e.DOT5)
                    ],
                    [
                        3,
                        h(e.DOT4 | e.DOT5 | e.DOT6)
                    ],
                    [
                        4,
                        h(e.DOT5)
                    ],
                    [
                        5,
                        h(e.DOT4 | e.DOT6)
                    ],
                    [
                        6,
                        h(e.DOT5 | e.DOT6)
                    ],
                    [
                        7,
                        h(e.DOT6)
                    ]
                ]), e.BRAILLE_AUGMENTATION_DOT = h(e.DOT3), e.BRAILLE_MEASURE_SEPARATOR = " ", e.BRAILLE_FINAL_DOUBLE_BAR = h(e.DOT1 | e.DOT2 | e.DOT6) + h(e.DOT1 | e.DOT3), e.BRAILLE_SECTIONAL_DOUBLE_BAR = h(e.DOT1 | e.DOT2 | e.DOT6) + h(e.DOT1 | e.DOT3) + h(e.DOT3), e.BRAILLE_FULL_MEASURE_IN_ACCORD = h(e.DOT1 | e.DOT2 | e.DOT6) + h(e.DOT3 | e.DOT4 | e.DOT5), e.BRAILLE_PART_MEASURE_IN_ACCORD = h(e.DOT5) + h(e.DOT2), e.BRAILLE_MEASURE_DIVISION = h(e.DOT4 | e.DOT6) + h(e.DOT1 | e.DOT3), e.BRAILLE_INTERVAL_SIGNS = new Map([
                    [
                        2,
                        h(e.DOT3 | e.DOT4)
                    ],
                    [
                        3,
                        h(e.DOT3 | e.DOT4 | e.DOT6)
                    ],
                    [
                        4,
                        h(e.DOT3 | e.DOT4 | e.DOT5 | e.DOT6)
                    ],
                    [
                        5,
                        h(e.DOT3 | e.DOT5)
                    ],
                    [
                        6,
                        h(e.DOT3 | e.DOT5 | e.DOT6)
                    ],
                    [
                        7,
                        h(e.DOT2 | e.DOT5)
                    ],
                    [
                        8,
                        h(e.DOT3 | e.DOT6)
                    ]
                ]), e.BRAILLE_SHARP = h(e.DOT1 | e.DOT4 | e.DOT6), e.BRAILLE_FLAT = h(e.DOT1 | e.DOT2 | e.DOT6), e.BRAILLE_NATURAL = h(e.DOT1 | e.DOT6), e.BRAILLE_DOUBLE_SHARP = e.BRAILLE_SHARP + e.BRAILLE_SHARP, e.BRAILLE_DOUBLE_FLAT = e.BRAILLE_FLAT + e.BRAILLE_FLAT, e.BRAILLE_NUMBER_SIGN = h(e.DOT3 | e.DOT4 | e.DOT5 | e.DOT6), e.BRAILLE_DIGITS = [
                    h(e.DOT3 | e.DOT5 | e.DOT6),
                    h(e.DOT2),
                    h(e.DOT2 | e.DOT3),
                    h(e.DOT2 | e.DOT5),
                    h(e.DOT2 | e.DOT5 | e.DOT6),
                    h(e.DOT2 | e.DOT6),
                    h(e.DOT2 | e.DOT3 | e.DOT5),
                    h(e.DOT2 | e.DOT3 | e.DOT5 | e.DOT6),
                    h(e.DOT2 | e.DOT3 | e.DOT6),
                    h(e.DOT3 | e.DOT5)
                ], e.BRAILLE_UPPER_DIGITS = [
                    h(e.DOT2 | e.DOT4 | e.DOT5),
                    h(e.DOT1),
                    h(e.DOT1 | e.DOT2),
                    h(e.DOT1 | e.DOT4),
                    h(e.DOT1 | e.DOT4 | e.DOT5),
                    h(e.DOT1 | e.DOT5),
                    h(e.DOT1 | e.DOT2 | e.DOT4),
                    h(e.DOT1 | e.DOT2 | e.DOT4 | e.DOT5),
                    h(e.DOT1 | e.DOT2 | e.DOT5),
                    h(e.DOT2 | e.DOT4)
                ], e.BRAILLE_STACCATO = h(e.DOT2 | e.DOT3 | e.DOT6), e.BRAILLE_STACCATISSIMO = h(e.DOT6) + h(e.DOT2 | e.DOT3 | e.DOT6), e.BRAILLE_MEZZO_STACCATO = h(e.DOT5) + h(e.DOT2 | e.DOT3 | e.DOT6), e.BRAILLE_TENUTO = h(e.DOT4 | e.DOT5 | e.DOT6) + h(e.DOT2 | e.DOT3 | e.DOT6), e.BRAILLE_ACCENT = h(e.DOT4 | e.DOT6) + h(e.DOT2 | e.DOT3 | e.DOT6), e.BRAILLE_MARCATO = h(e.DOT5 | e.DOT6) + h(e.DOT2 | e.DOT3 | e.DOT6), e.BRAILLE_FERMATA = h(e.DOT1 | e.DOT2 | e.DOT6) + h(e.DOT1 | e.DOT2 | e.DOT3), e.BRAILLE_TRILL = h(e.DOT2 | e.DOT3 | e.DOT5), e.BRAILLE_TURN = h(e.DOT2 | e.DOT5 | e.DOT6), e.BRAILLE_TURN_ON_NOTE = h(e.DOT6) + h(e.DOT2 | e.DOT5 | e.DOT6), e.BRAILLE_INVERTED_TURN = h(e.DOT2 | e.DOT5 | e.DOT6) + h(e.DOT1 | e.DOT2 | e.DOT3), e.BRAILLE_INVERTED_TURN_ON_NOTE = h(e.DOT6) + h(e.DOT2 | e.DOT5 | e.DOT6) + h(e.DOT1 | e.DOT2 | e.DOT3), e.BRAILLE_MORDENT = h(e.DOT5) + h(e.DOT2 | e.DOT3 | e.DOT5), e.BRAILLE_INVERTED_MORDENT = h(e.DOT5) + h(e.DOT2 | e.DOT3 | e.DOT5) + h(e.DOT1 | e.DOT2 | e.DOT3), e.BRAILLE_WORD_SIGN = h(e.DOT3 | e.DOT4 | e.DOT5);
                const c = h(e.DOT1 | e.DOT4), u = h(e.DOT1 | e.DOT4 | e.DOT5), d = h(e.DOT1 | e.DOT2 | e.DOT4), f = h(e.DOT1 | e.DOT3 | e.DOT4), m = h(e.DOT1 | e.DOT2 | e.DOT3 | e.DOT4), p = h(e.DOT1 | e.DOT2 | e.DOT3 | e.DOT5), g = h(e.DOT2 | e.DOT3 | e.DOT4), b = h(e.DOT1 | e.DOT3 | e.DOT5 | e.DOT6);
                e.BRAILLE_ABBREV_PERIOD = h(e.DOT3), e.BRAILLE_OPEN_PAREN = h(e.DOT1 | e.DOT2 | e.DOT3 | e.DOT5 | e.DOT6), e.BRAILLE_CLOSE_PAREN = h(e.DOT2 | e.DOT3 | e.DOT4 | e.DOT5 | e.DOT6), e.BRAILLE_CRESC_HAIRPIN = e.BRAILLE_WORD_SIGN + c, e.BRAILLE_DIM_HAIRPIN = e.BRAILLE_WORD_SIGN + u, e.BRAILLE_SINGLE_TIE = h(e.DOT4) + h(e.DOT1 | e.DOT4), e.BRAILLE_CHORD_TIE = h(e.DOT4 | e.DOT6) + h(e.DOT1 | e.DOT4), e.BRAILLE_SLUR = h(e.DOT1 | e.DOT4), e.BRAILLE_SYLLABIC_SLUR = h(e.DOT1 | e.DOT4), e.BRAILLE_BRACKET_SLUR_OPEN = h(e.DOT5 | e.DOT6) + h(e.DOT1 | e.DOT2), e.BRAILLE_BRACKET_SLUR_CLOSE = h(e.DOT4 | e.DOT5) + h(e.DOT2 | e.DOT3), e.BRAILLE_FORWARD_REPEAT = h(e.DOT1 | e.DOT2 | e.DOT6) + h(e.DOT2 | e.DOT3 | e.DOT5 | e.DOT6), e.BRAILLE_BACKWARD_REPEAT = h(e.DOT1 | e.DOT2 | e.DOT6) + h(e.DOT2 | e.DOT3), e.BRAILLE_SEGNO = h(e.DOT3 | e.DOT4 | e.DOT6), e.BRAILLE_CODA = h(e.DOT3 | e.DOT4 | e.DOT6) + h(e.DOT1 | e.DOT2 | e.DOT3);
                const S = h(e.DOT1), y = h(e.DOT1 | e.DOT5), E = h(e.DOT2 | e.DOT4), x = h(e.DOT1 | e.DOT2 | e.DOT3), v = h(e.DOT1 | e.DOT3 | e.DOT4 | e.DOT5), T = h(e.DOT1 | e.DOT3 | e.DOT5);
                e.BRAILLE_BLANK_CELL = h(0);
                const _ = e.BRAILLE_WORD_SIGN + u + e.BRAILLE_ABBREV_PERIOD + c + e.BRAILLE_ABBREV_PERIOD + e.BRAILLE_WORD_SIGN, M = e.BRAILLE_WORD_SIGN + u + e.BRAILLE_ABBREV_PERIOD + g + e.BRAILLE_ABBREV_PERIOD + e.BRAILLE_WORD_SIGN, P = e.BRAILLE_WORD_SIGN + d + E + v + y + e.BRAILLE_WORD_SIGN, L = S + x + e.BRAILLE_BLANK_CELL + d + E + v + y, w = S + x + e.BRAILLE_BLANK_CELL + c + T + u + S, A = h(e.DOT1 | e.DOT2 | e.DOT3), I = h(e.DOT3 | e.DOT4), R = h(e.DOT3 | e.DOT4 | e.DOT5 | e.DOT6), N = h(e.DOT3 | e.DOT4 | e.DOT6);
                e.BRAILLE_CLEF_G = e.BRAILLE_WORD_SIGN + I + A, e.BRAILLE_CLEF_F = e.BRAILLE_WORD_SIGN + R + A, e.BRAILLE_CLEF_C = e.BRAILLE_WORD_SIGN + N + A, e.BRAILLE_CLEF_TENOR = e.BRAILLE_WORD_SIGN + N + h(e.DOT5) + A, e.BRAILLE_MUSIC_HYPHEN = h(e.DOT5), e.BRAILLE_PAGE_INDICATOR = h(e.DOT5) + h(e.DOT2 | e.DOT5), e.BRAILLE_LINE_BREAK = "\n", e.BRAILLE_HAND_RIGHT = h(e.DOT4 | e.DOT6) + h(e.DOT3 | e.DOT4 | e.DOT5), e.BRAILLE_HAND_LEFT = h(e.DOT4 | e.DOT5 | e.DOT6) + h(e.DOT3 | e.DOT4 | e.DOT5);
                const C = h(e.DOT1 | e.DOT2), B = h(e.DOT1 | e.DOT2 | e.DOT3 | e.DOT6), D = e.BRAILLE_UPPER_DIGITS[1], O = e.BRAILLE_UPPER_DIGITS[5], F = e.BRAILLE_UPPER_DIGITS[8];
                e.BRAILLE_OTTAVA_8VA = e.BRAILLE_WORD_SIGN + e.BRAILLE_NUMBER_SIGN + F + B + S + e.BRAILLE_ABBREV_PERIOD + e.BRAILLE_ABBREV_PERIOD, e.BRAILLE_OTTAVA_8VB = e.BRAILLE_WORD_SIGN + e.BRAILLE_NUMBER_SIGN + F + B + C + e.BRAILLE_ABBREV_PERIOD + e.BRAILLE_ABBREV_PERIOD, e.BRAILLE_OTTAVA_15MA = e.BRAILLE_WORD_SIGN + e.BRAILLE_NUMBER_SIGN + D + O + f + S + e.BRAILLE_ABBREV_PERIOD + e.BRAILLE_ABBREV_PERIOD, e.BRAILLE_OTTAVA_15MB = e.BRAILLE_WORD_SIGN + e.BRAILLE_NUMBER_SIGN + D + O + f + C + e.BRAILLE_ABBREV_PERIOD + e.BRAILLE_ABBREV_PERIOD, e.BRAILLE_OTTAVA_END = e.BRAILLE_WORD_SIGN + e.BRAILLE_ABBREV_PERIOD;
                const k = h(e.DOT1 | e.DOT2 | e.DOT4 | e.DOT5), V = h(e.DOT1 | e.DOT2 | e.DOT5), G = h(e.DOT2 | e.DOT4 | e.DOT5), W = h(e.DOT1 | e.DOT3), U = h(e.DOT1 | e.DOT2 | e.DOT3 | e.DOT4 | e.DOT5), z = h(e.DOT2 | e.DOT3 | e.DOT4 | e.DOT5), H = h(e.DOT1 | e.DOT3 | e.DOT6), X = h(e.DOT2 | e.DOT4 | e.DOT5 | e.DOT6), Y = h(e.DOT1 | e.DOT3 | e.DOT4 | e.DOT6), j = h(e.DOT1 | e.DOT3 | e.DOT4 | e.DOT5 | e.DOT6), K = new Map([
                    [
                        "a",
                        S
                    ],
                    [
                        "b",
                        C
                    ],
                    [
                        "c",
                        c
                    ],
                    [
                        "d",
                        u
                    ],
                    [
                        "e",
                        y
                    ],
                    [
                        "f",
                        d
                    ],
                    [
                        "g",
                        k
                    ],
                    [
                        "h",
                        V
                    ],
                    [
                        "i",
                        E
                    ],
                    [
                        "j",
                        G
                    ],
                    [
                        "k",
                        W
                    ],
                    [
                        "l",
                        x
                    ],
                    [
                        "m",
                        f
                    ],
                    [
                        "n",
                        v
                    ],
                    [
                        "o",
                        T
                    ],
                    [
                        "p",
                        m
                    ],
                    [
                        "q",
                        U
                    ],
                    [
                        "r",
                        p
                    ],
                    [
                        "s",
                        g
                    ],
                    [
                        "t",
                        z
                    ],
                    [
                        "u",
                        H
                    ],
                    [
                        "v",
                        B
                    ],
                    [
                        "w",
                        X
                    ],
                    [
                        "x",
                        Y
                    ],
                    [
                        "y",
                        j
                    ],
                    [
                        "z",
                        b
                    ]
                ]);
            },
            9591 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.renderTimeSignature = function(t) {
                    const e = t.Numerator, i = t.Denominator, n = s.BRAILLE_NUMBER_SIGN + (0, s.numberToUpperDigits)(e) + (0, s.numberToLowerDigits)(i);
                    return {
                        braille: n,
                        debugEntries: [
                            {
                                braille: n,
                                meaning: "time " + e + "/" + i
                            }
                        ]
                    };
                };
                const s = i(8351);
            },
            9525 (t, e, i) {
                "use strict";
                var s = this && this.__createBinding || (Object.create ? function(t, e, i, s) {
                    void 0 === s && (s = i);
                    var n = Object.getOwnPropertyDescriptor(e, i);
                    n && !("get" in n ? !e.__esModule : n.writable || n.configurable) || (n = {
                        enumerable: !0,
                        get: function() {
                            return e[i];
                        }
                    }), Object.defineProperty(t, s, n);
                } : function(t, e, i, s) {
                    void 0 === s && (s = i), t[s] = e[i];
                }), n = this && this.__exportStar || function(t, e) {
                    for(var i in t)"default" === i || Object.prototype.hasOwnProperty.call(e, i) || s(e, t, i);
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), n(i(8630), e), n(i(8351), e), n(i(1535), e), n(i(746), e), n(i(2113), e), n(i(6773), e), n(i(8399), e), n(i(9591), e), n(i(5799), e), n(i(761), e), n(i(5284), e), n(i(3148), e);
            },
            6583 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.IntervalTransposeCalculator = void 0;
                const s = i(8233), n = i(4543), r = i(8628);
                class o {
                    constructor(t = new r.TransposeCalculator){
                        this.SimpleChordSymbolSpelling = !0, this.AvoidDoubleAccidentals = !1, this.fallback = t;
                    }
                    transposeKey(t, e) {
                        this.fallback.transposeKey(t, e);
                    }
                    transposePitch(t, e, i, s = !1) {
                        return s ? this.transposeByInterval(t, e, i, this.SimpleChordSymbolSpelling || this.AvoidDoubleAccidentals, this.SimpleChordSymbolSpelling) : this.transposeByInterval(t, e, i, this.AvoidDoubleAccidentals, !1);
                    }
                    transposeByInterval(t, e, i, r, a) {
                        if (0 === i) return t;
                        const l = o.letters.indexOf(t.FundamentalNote);
                        if (l < 0 || !e) return this.fallback.transposePitch(t, e, i);
                        const h = new n.KeyInstruction(void 0, e.keyTypeOriginal);
                        this.fallback.transposeKey(h, i);
                        const c = o.letterSteps(h.keyTypeOriginal, h.Key, i), u = o.spell({
                            letter: l,
                            octave: t.Octave,
                            alter: s.Pitch.HalfTonesFromAccidental(t.Accidental)
                        }, i, c);
                        return !u || r && 2 === Math.abs(u.alter) || a && 0 !== u.alter && o.isWhiteKey(u) ? this.fallback.transposePitch(t, e, i) : new s.Pitch(o.letters[u.letter], u.octave, s.Pitch.AccidentalFromHalfTones(u.alter));
                    }
                    static isWhiteKey(t) {
                        const e = ((o.letters[t.letter] + t.alter) % 12 + 12) % 12;
                        return o.letters.indexOf(e) >= 0;
                    }
                    static letterSteps(t, e, i) {
                        const s = o.tonicLetterByFifths[o.normalizeFifths(t) + 7], n = ((o.tonicLetterByFifths[o.normalizeFifths(e) + 7] - s) % 7 + 7) % 7, r = 7 * i / 12, a = 7 * Math.round((r - n) / 7) + n;
                        let l = a;
                        for (const t of [
                            a - 7,
                            a + 7
                        ])Math.abs(t - r) < Math.abs(l - r) && (l = t);
                        return l;
                    }
                    static spell(t, e, i) {
                        if (!Number.isInteger(t.alter)) return;
                        const s = 7 * t.octave + t.letter + i, n = (s % 7 + 7) % 7, r = Math.floor(s / 7), a = 12 * t.octave + o.letters[t.letter] + t.alter + e - (12 * r + o.letters[n]);
                        return a < -2 || a > 2 ? void 0 : {
                            letter: n,
                            octave: r,
                            alter: a
                        };
                    }
                    static normalizeFifths(t) {
                        let e = Math.round(t);
                        for(; e > 7;)e -= 12;
                        for(; e < -7;)e += 12;
                        return e;
                    }
                }
                e.IntervalTransposeCalculator = o, o.letters = [
                    s.NoteEnum.C,
                    s.NoteEnum.D,
                    s.NoteEnum.E,
                    s.NoteEnum.F,
                    s.NoteEnum.G,
                    s.NoteEnum.A,
                    s.NoteEnum.B
                ], o.tonicLetterByFifths = [
                    0,
                    4,
                    1,
                    5,
                    2,
                    6,
                    3,
                    0,
                    4,
                    1,
                    5,
                    2,
                    6,
                    3,
                    0
                ];
            },
            8628 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.TransposeCalculator = void 0;
                const s = i(9735), n = i(9184);
                class r {
                    transposePitch(t, e, i) {
                        if (0 === i) return t;
                        if (i % 12 == 0) return new s.Pitch(t.FundamentalNote, t.Octave + i / 12, t.Accidental);
                        let n = s.NoteEnum.C, o = 0, a = s.AccidentalEnum.NONE;
                        const l = s.Pitch.CalculateTransposedHalfTone(t, i);
                        let h = l.halftone, c = l.overflow;
                        for(let i = 0; i < r.noteEnums.length; i++){
                            const l = r.noteEnums[i];
                            if (l === h) {
                                const h = i;
                                n = r.noteEnums[h], o = t.Octave + c, a = s.AccidentalEnum.NONE;
                                const u = r.keySignatureSpelling(l, o, e);
                                return u && r.isSpelledLikeKeySignature(t, e.keyTypeOriginal) ? u : new s.Pitch(n, o, a);
                            }
                            if (l > h) break;
                        }
                        for(let i = 0; i < r.noteEnums.length; i++)if (r.noteEnums[i] > h) {
                            let l = i;
                            const u = s.Pitch.HalfTonesFromAccidental(t.Accidental), d = u > 0, f = u < 0, m = e.Key > 0, p = e.Key < 0;
                            let g = !0;
                            for(m ? g = !0 : p ? g = !1 : (d || f) && (g = d), g && l--; l < 0;)l += 7, h += 12, c--;
                            for(; l >= 7;)l -= 7, h -= 12, c++;
                            n = r.noteEnums[l], a = s.Pitch.AccidentalFromHalfTones(h - n), o = t.Octave + c;
                            break;
                        }
                        return new s.Pitch(n, o, a);
                    }
                    static keySignatureSpelling(t, e, i) {
                        if (!i) return;
                        const n = i.Key > 0 ? 1 : -1;
                        for (const r of i.AlteratedNotes){
                            const i = r + n;
                            if ((i + 12) % 12 === t) return new s.Pitch(r, e - Math.floor(i / 12), s.Pitch.AccidentalFromHalfTones(n));
                        }
                    }
                    static isSpelledLikeKeySignature(t, e) {
                        const i = new n.KeyInstruction(void 0, e).willAlterateNote(t.FundamentalNote) ? Math.sign(e) : 0;
                        return t.AccidentalHalfTones === i;
                    }
                    transposeKey(t, e) {
                        let i = 0, s = 0, n = t.keyTypeOriginal;
                        if (e % 12 == 0) return t.Key = t.keyTypeOriginal, void (t.isTransposedBy = e);
                        for(n > 6 ? n -= 12 : n <= -6 && (n += 12); i < r.keyMapping.length && (s = r.keyMapping[i], s !== n); i++);
                        let o = i + e;
                        for(; o >= 12;)o -= 12;
                        for(; o < 0;)o += 12;
                        t.Key = r.keyMapping[o], t.isTransposedBy = e;
                    }
                }
                e.TransposeCalculator = r, r.keyMapping = [
                    0,
                    -5,
                    2,
                    -3,
                    4,
                    -1,
                    6,
                    1,
                    -4,
                    3,
                    -2,
                    5
                ], r.noteEnums = [
                    s.NoteEnum.C,
                    s.NoteEnum.D,
                    s.NoteEnum.E,
                    s.NoteEnum.F,
                    s.NoteEnum.G,
                    s.NoteEnum.A,
                    s.NoteEnum.B
                ];
            },
            8659 (t, e, i) {
                "use strict";
                var s = this && this.__createBinding || (Object.create ? function(t, e, i, s) {
                    void 0 === s && (s = i);
                    var n = Object.getOwnPropertyDescriptor(e, i);
                    n && !("get" in n ? !e.__esModule : n.writable || n.configurable) || (n = {
                        enumerable: !0,
                        get: function() {
                            return e[i];
                        }
                    }), Object.defineProperty(t, s, n);
                } : function(t, e, i, s) {
                    void 0 === s && (s = i), t[s] = e[i];
                }), n = this && this.__exportStar || function(t, e) {
                    for(var i in t)"default" === i || Object.prototype.hasOwnProperty.call(e, i) || s(e, t, i);
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), n(i(8628), e), n(i(6583), e);
            },
            363 (t, e, i) {
                "use strict";
                var s = this && this.__createBinding || (Object.create ? function(t, e, i, s) {
                    void 0 === s && (s = i);
                    var n = Object.getOwnPropertyDescriptor(e, i);
                    n && !("get" in n ? !e.__esModule : n.writable || n.configurable) || (n = {
                        enumerable: !0,
                        get: function() {
                            return e[i];
                        }
                    }), Object.defineProperty(t, s, n);
                } : function(t, e, i, s) {
                    void 0 === s && (s = i), t[s] = e[i];
                }), n = this && this.__exportStar || function(t, e) {
                    for(var i in t)"default" === i || Object.prototype.hasOwnProperty.call(e, i) || s(e, t, i);
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), n(i(8659), e), n(i(9525), e);
            },
            813 (t, e) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.CollectionUtil = void 0, Array.prototype.last || Object.defineProperty(Array.prototype, "last", {
                    enumerable: !1,
                    writable: !0,
                    value: function() {
                        return this[this.length - 1];
                    }
                }), Array.prototype.clear || Object.defineProperty(Array.prototype, "clear", {
                    enumerable: !1,
                    writable: !0,
                    value: function() {
                        this.length = 0;
                    }
                }), Array.prototype.contains || Object.defineProperty(Array.prototype, "contains", {
                    enumerable: !1,
                    writable: !0,
                    value: function(t) {
                        return -1 !== this.indexOf(t);
                    }
                }), e.CollectionUtil = class {
                    static contains2(t, e) {
                        for(let i = 0; i < t.length; i++)if (t[i] === e) return !0;
                        return !1;
                    }
                    static last(t) {
                        return t[t.length - 1];
                    }
                    static flat(t) {
                        return [].concat(...t);
                    }
                    static removeDictElementIfTrue(t, e, i) {
                        const s = [];
                        e.forEach(function(e, n) {
                            i(t, e, n) && s.push(e);
                        });
                        for(let t = 0; t < s.length; t++)e.remove(s[t]);
                    }
                    static getLastElement(t) {
                        return t[t.length - 1];
                    }
                    static binarySearch(t, e, i, s = 0, n = t.length - 1) {
                        let r = 1, o = -1;
                        for(; s <= n && (r = Math.floor((s + n) / 2), r !== o);){
                            const a = i(t[r], e);
                            if (0 === a) return r;
                            a < 0 && (s = r + 1), 0 < a && (n = r), o = r;
                        }
                        return -r;
                    }
                };
            },
            2774 (t, e) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.PSMath = void 0;
                class i {
                    static log(t, e) {
                        return Math.log(e) / Math.log(t);
                    }
                    static log10(t) {
                        return i.log(10, t);
                    }
                    static meanSimple(t) {
                        let e = 0;
                        for(let i = 0; i < t.length; i++)e += t[i];
                        return e / t.length;
                    }
                    static meanWeighted(t, e) {
                        if (t.length !== e.length || 0 === t.length) return 0;
                        let i = 0, s = 0;
                        for(let n = 0; n < t.length; n++){
                            const r = e[n];
                            i += t[n] * r, s += r;
                        }
                        return i / s;
                    }
                }
                e.PSMath = i;
            },
            6873 (t, e, i) {
                "use strict";
                var s = this && this.__createBinding || (Object.create ? function(t, e, i, s) {
                    void 0 === s && (s = i);
                    var n = Object.getOwnPropertyDescriptor(e, i);
                    n && !("get" in n ? !e.__esModule : n.writable || n.configurable) || (n = {
                        enumerable: !0,
                        get: function() {
                            return e[i];
                        }
                    }), Object.defineProperty(t, s, n);
                } : function(t, e, i, s) {
                    void 0 === s && (s = i), t[s] = e[i];
                }), n = this && this.__exportStar || function(t, e) {
                    for(var i in t)"default" === i || Object.prototype.hasOwnProperty.call(e, i) || s(e, t, i);
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), n(i(813), e), n(i(2774), e);
            },
            8156 (t, e, i) {
                "use strict";
                var s = this && this.__createBinding || (Object.create ? function(t, e, i, s) {
                    void 0 === s && (s = i);
                    var n = Object.getOwnPropertyDescriptor(e, i);
                    n && !("get" in n ? !e.__esModule : n.writable || n.configurable) || (n = {
                        enumerable: !0,
                        get: function() {
                            return e[i];
                        }
                    }), Object.defineProperty(t, s, n);
                } : function(t, e, i, s) {
                    void 0 === s && (s = i), t[s] = e[i];
                }), n = this && this.__exportStar || function(t, e) {
                    for(var i in t)"default" === i || Object.prototype.hasOwnProperty.call(e, i) || s(e, t, i);
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), n(i(5955), e), n(i(1745), e), n(i(6873), e), n(i(2552), e), n(i(363), e);
            },
            9924 (t, e, i) {
                "use strict";
                var s, n = this && this.__extends || (s = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t, e) {
                    t.__proto__ = e;
                } || function(t, e) {
                    for(var i in e)e.hasOwnProperty(i) && (t[i] = e[i]);
                }, function(t, e) {
                    function i() {
                        this.constructor = t;
                    }
                    s(t, e), t.prototype = null === e ? Object.create(e) : (i.prototype = e.prototype, new i);
                });
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var r = function(t) {
                    function e() {
                        return null !== t && t.apply(this, arguments) || this;
                    }
                    return n(e, t), e;
                }(i(4041).default);
                e.default = r;
            },
            4041 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var s = i(4831), n = i(3288), r = function() {
                    function t(t) {
                        this.root = null, this.compare = t || s.defaultCompare, this.nElements = 0;
                    }
                    return t.prototype.add = function(t) {
                        return !s.isUndefined(t) && null !== this.insertNode(this.createNode(t)) && (this.nElements++, !0);
                    }, t.prototype.clear = function() {
                        this.root = null, this.nElements = 0;
                    }, t.prototype.isEmpty = function() {
                        return 0 === this.nElements;
                    }, t.prototype.size = function() {
                        return this.nElements;
                    }, t.prototype.contains = function(t) {
                        return !s.isUndefined(t) && null !== this.searchNode(this.root, t);
                    }, t.prototype.search = function(t) {
                        var e = this.searchNode(this.root, t);
                        if (null !== e) return e.element;
                    }, t.prototype.remove = function(t) {
                        var e = this.searchNode(this.root, t);
                        return null !== e && (this.removeNode(e), this.nElements--, !0);
                    }, t.prototype.inorderTraversal = function(t) {
                        this.inorderTraversalAux(this.root, t, {
                            stop: !1
                        });
                    }, t.prototype.preorderTraversal = function(t) {
                        this.preorderTraversalAux(this.root, t, {
                            stop: !1
                        });
                    }, t.prototype.postorderTraversal = function(t) {
                        this.postorderTraversalAux(this.root, t, {
                            stop: !1
                        });
                    }, t.prototype.levelTraversal = function(t) {
                        this.levelTraversalAux(this.root, t);
                    }, t.prototype.minimum = function() {
                        if (!this.isEmpty() && null !== this.root) return this.minimumAux(this.root).element;
                    }, t.prototype.maximum = function() {
                        if (!this.isEmpty() && null !== this.root) return this.maximumAux(this.root).element;
                    }, t.prototype.forEach = function(t) {
                        this.inorderTraversal(t);
                    }, t.prototype.toArray = function() {
                        var t = [];
                        return this.inorderTraversal(function(e) {
                            return t.push(e), !0;
                        }), t;
                    }, t.prototype.height = function() {
                        return this.heightAux(this.root);
                    }, t.prototype.searchNode = function(t, e) {
                        for(var i = 1; null !== t && 0 !== i;)(i = this.compare(e, t.element)) < 0 ? t = t.leftCh : i > 0 && (t = t.rightCh);
                        return t;
                    }, t.prototype.transplant = function(t, e) {
                        null === t.parent ? this.root = e : t === t.parent.leftCh ? t.parent.leftCh = e : t.parent.rightCh = e, null !== e && (e.parent = t.parent);
                    }, t.prototype.removeNode = function(t) {
                        if (null === t.leftCh) this.transplant(t, t.rightCh);
                        else if (null === t.rightCh) this.transplant(t, t.leftCh);
                        else {
                            var e = this.minimumAux(t.rightCh);
                            e.parent !== t && (this.transplant(e, e.rightCh), e.rightCh = t.rightCh, e.rightCh.parent = e), this.transplant(t, e), e.leftCh = t.leftCh, e.leftCh.parent = e;
                        }
                    }, t.prototype.inorderTraversalAux = function(t, e, i) {
                        null === t || i.stop || (this.inorderTraversalAux(t.leftCh, e, i), i.stop || (i.stop = !1 === e(t.element), i.stop || this.inorderTraversalAux(t.rightCh, e, i)));
                    }, t.prototype.levelTraversalAux = function(t, e) {
                        var i = new n.default;
                        for(null !== t && i.enqueue(t), t = i.dequeue() || null; null != t;){
                            if (!1 === e(t.element)) return;
                            null !== t.leftCh && i.enqueue(t.leftCh), null !== t.rightCh && i.enqueue(t.rightCh), t = i.dequeue() || null;
                        }
                    }, t.prototype.preorderTraversalAux = function(t, e, i) {
                        null === t || i.stop || (i.stop = !1 === e(t.element), i.stop || (this.preorderTraversalAux(t.leftCh, e, i), i.stop || this.preorderTraversalAux(t.rightCh, e, i)));
                    }, t.prototype.postorderTraversalAux = function(t, e, i) {
                        null === t || i.stop || (this.postorderTraversalAux(t.leftCh, e, i), i.stop || (this.postorderTraversalAux(t.rightCh, e, i), i.stop || (i.stop = !1 === e(t.element))));
                    }, t.prototype.minimumAux = function(t) {
                        for(; null != t && null !== t.leftCh;)t = t.leftCh;
                        return t;
                    }, t.prototype.maximumAux = function(t) {
                        for(; null != t && null !== t.rightCh;)t = t.rightCh;
                        return t;
                    }, t.prototype.heightAux = function(t) {
                        return null === t ? -1 : Math.max(this.heightAux(t.leftCh), this.heightAux(t.rightCh)) + 1;
                    }, t.prototype.insertNode = function(t) {
                        for(var e = null, i = this.root; null !== i;){
                            var s = this.compare(t.element, i.element);
                            if (0 === s) return null;
                            s < 0 ? (e = i, i = i.leftCh) : (e = i, i = i.rightCh);
                        }
                        return t.parent = e, null === e ? this.root = t : this.compare(t.element, e.element) < 0 ? e.leftCh = t : e.rightCh = t, t;
                    }, t.prototype.createNode = function(t) {
                        return {
                            element: t,
                            leftCh: null,
                            rightCh: null,
                            parent: null
                        };
                    }, t;
                }();
                e.default = r;
            },
            2909 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var s = i(4831), n = i(6119), r = i(2091), o = function() {
                    function t(t) {
                        this.toStrF = t || s.defaultToString, this.dictionary = new n.default(this.toStrF), this.nElements = 0;
                    }
                    return t.prototype.add = function(t, e) {
                        if (void 0 === e && (e = 1), s.isUndefined(t) || e <= 0) return !1;
                        if (this.contains(t)) this.dictionary.getValue(t).copies += e;
                        else {
                            var i = {
                                value: t,
                                copies: e
                            };
                            this.dictionary.setValue(t, i);
                        }
                        return this.nElements += e, !0;
                    }, t.prototype.count = function(t) {
                        return this.contains(t) ? this.dictionary.getValue(t).copies : 0;
                    }, t.prototype.contains = function(t) {
                        return this.dictionary.containsKey(t);
                    }, t.prototype.remove = function(t, e) {
                        if (void 0 === e && (e = 1), s.isUndefined(t) || e <= 0) return !1;
                        if (this.contains(t)) {
                            var i = this.dictionary.getValue(t);
                            return e > i.copies ? this.nElements -= i.copies : this.nElements -= e, i.copies -= e, i.copies <= 0 && this.dictionary.remove(t), !0;
                        }
                        return !1;
                    }, t.prototype.toArray = function() {
                        for(var t = [], e = 0, i = this.dictionary.values(); e < i.length; e++)for(var s = i[e], n = s.value, r = s.copies, o = 0; o < r; o++)t.push(n);
                        return t;
                    }, t.prototype.toSet = function() {
                        for(var t = new r.default(this.toStrF), e = 0, i = this.dictionary.values(); e < i.length; e++){
                            var s = i[e].value;
                            t.add(s);
                        }
                        return t;
                    }, t.prototype.forEach = function(t) {
                        this.dictionary.forEach(function(e, i) {
                            for(var s = i.value, n = i.copies, r = 0; r < n; r++)if (!1 === t(s)) return !1;
                            return !0;
                        });
                    }, t.prototype.size = function() {
                        return this.nElements;
                    }, t.prototype.isEmpty = function() {
                        return 0 === this.nElements;
                    }, t.prototype.clear = function() {
                        this.nElements = 0, this.dictionary.clear();
                    }, t;
                }();
                e.default = o;
            },
            6119 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var s = i(4831), n = function() {
                    function t(t) {
                        this.table = {}, this.nElements = 0, this.toStr = t || s.defaultToString;
                    }
                    return t.prototype.getValue = function(t) {
                        var e = this.table["$" + this.toStr(t)];
                        if (!s.isUndefined(e)) return e.value;
                    }, t.prototype.setValue = function(t, e) {
                        if (!s.isUndefined(t) && !s.isUndefined(e)) {
                            var i, n = "$" + this.toStr(t), r = this.table[n];
                            return s.isUndefined(r) ? (this.nElements++, i = void 0) : i = r.value, this.table[n] = {
                                key: t,
                                value: e
                            }, i;
                        }
                    }, t.prototype.remove = function(t) {
                        var e = "$" + this.toStr(t), i = this.table[e];
                        if (!s.isUndefined(i)) return delete this.table[e], this.nElements--, i.value;
                    }, t.prototype.keys = function() {
                        var t = [];
                        for(var e in this.table)if (s.has(this.table, e)) {
                            var i = this.table[e];
                            t.push(i.key);
                        }
                        return t;
                    }, t.prototype.values = function() {
                        var t = [];
                        for(var e in this.table)if (s.has(this.table, e)) {
                            var i = this.table[e];
                            t.push(i.value);
                        }
                        return t;
                    }, t.prototype.forEach = function(t) {
                        for(var e in this.table)if (s.has(this.table, e)) {
                            var i = this.table[e];
                            if (!1 === t(i.key, i.value)) return;
                        }
                    }, t.prototype.containsKey = function(t) {
                        return !s.isUndefined(this.getValue(t));
                    }, t.prototype.clear = function() {
                        this.table = {}, this.nElements = 0;
                    }, t.prototype.size = function() {
                        return this.nElements;
                    }, t.prototype.isEmpty = function() {
                        return this.nElements <= 0;
                    }, t.prototype.toString = function() {
                        var t = "{";
                        return this.forEach(function(e, i) {
                            t += "\n\t" + e + " : " + i;
                        }), t + "\n}";
                    }, t;
                }();
                e.default = n;
            },
            9281 (t, e, i) {
                "use strict";
                var s, n = this && this.__extends || (s = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t, e) {
                    t.__proto__ = e;
                } || function(t, e) {
                    for(var i in e)e.hasOwnProperty(i) && (t[i] = e[i]);
                }, function(t, e) {
                    function i() {
                        this.constructor = t;
                    }
                    s(t, e), t.prototype = null === e ? Object.create(e) : (i.prototype = e.prototype, new i);
                });
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var r = i(6119), o = i(4831), a = function(t) {
                    function e(e, i) {
                        var s = t.call(this, i) || this;
                        return s.defaultFactoryFunction = e, s;
                    }
                    return n(e, t), e.prototype.setDefault = function(e, i) {
                        var s = t.prototype.getValue.call(this, e);
                        return o.isUndefined(s) ? (this.setValue(e, i), i) : s;
                    }, e.prototype.getValue = function(t) {
                        return this.setDefault(t, this.defaultFactoryFunction());
                    }, e;
                }(r.default);
                e.default = a;
            },
            4589 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var s = i(4831), n = i(4713), r = function() {
                    function t(t) {
                        this.data = [], this.compare = t || s.defaultCompare;
                    }
                    return t.prototype.leftChildIndex = function(t) {
                        return 2 * t + 1;
                    }, t.prototype.rightChildIndex = function(t) {
                        return 2 * t + 2;
                    }, t.prototype.parentIndex = function(t) {
                        return Math.floor((t - 1) / 2);
                    }, t.prototype.minIndex = function(t, e) {
                        return e >= this.data.length ? t >= this.data.length ? -1 : t : this.compare(this.data[t], this.data[e]) <= 0 ? t : e;
                    }, t.prototype.siftUp = function(t) {
                        for(var e = this.parentIndex(t); t > 0 && this.compare(this.data[e], this.data[t]) > 0;)n.swap(this.data, e, t), t = e, e = this.parentIndex(t);
                    }, t.prototype.siftDown = function(t) {
                        for(var e = this.minIndex(this.leftChildIndex(t), this.rightChildIndex(t)); e >= 0 && this.compare(this.data[t], this.data[e]) > 0;)n.swap(this.data, e, t), t = e, e = this.minIndex(this.leftChildIndex(t), this.rightChildIndex(t));
                    }, t.prototype.peek = function() {
                        return this.data.length > 0 ? this.data[0] : void 0;
                    }, t.prototype.add = function(t) {
                        return !s.isUndefined(t) && (this.data.push(t), this.siftUp(this.data.length - 1), !0);
                    }, t.prototype.removeRoot = function() {
                        if (this.data.length > 0) {
                            var t = this.data[0];
                            return this.data[0] = this.data[this.data.length - 1], this.data.splice(this.data.length - 1, 1), this.data.length > 0 && this.siftDown(0), t;
                        }
                    }, t.prototype.contains = function(t) {
                        var e = s.compareToEquals(this.compare);
                        return n.contains(this.data, t, e);
                    }, t.prototype.size = function() {
                        return this.data.length;
                    }, t.prototype.isEmpty = function() {
                        return this.data.length <= 0;
                    }, t.prototype.clear = function() {
                        this.data.length = 0;
                    }, t.prototype.forEach = function(t) {
                        n.forEach(this.data, t);
                    }, t;
                }();
                e.default = r;
            },
            1846 (t, e, i) {
                "use strict";
                var s, n = this && this.__extends || (s = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t, e) {
                    t.__proto__ = e;
                } || function(t, e) {
                    for(var i in e)e.hasOwnProperty(i) && (t[i] = e[i]);
                }, function(t, e) {
                    function i() {
                        this.constructor = t;
                    }
                    s(t, e), t.prototype = null === e ? Object.create(e) : (i.prototype = e.prototype, new i);
                });
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var r = i(6119), o = i(4831), a = function() {
                    function t(t, e) {
                        this.key = t, this.value = e;
                    }
                    return t.prototype.unlink = function() {
                        this.prev.next = this.next, this.next.prev = this.prev;
                    }, t;
                }(), l = function() {
                    function t() {
                        this.key = null, this.value = null;
                    }
                    return t.prototype.unlink = function() {
                        this.prev.next = this.next, this.next.prev = this.prev;
                    }, t;
                }();
                function h(t) {
                    return !t.next;
                }
                var c = function(t) {
                    function e(e) {
                        var i = t.call(this, e) || this;
                        return i.head = new l, i.tail = new l, i.head.next = i.tail, i.tail.prev = i.head, i;
                    }
                    return n(e, t), e.prototype.appendToTail = function(t) {
                        var e = this.tail.prev;
                        e.next = t, t.prev = e, t.next = this.tail, this.tail.prev = t;
                    }, e.prototype.getLinkedDictionaryPair = function(t) {
                        if (!o.isUndefined(t)) {
                            var e = "$" + this.toStr(t);
                            return this.table[e];
                        }
                    }, e.prototype.getValue = function(t) {
                        var e = this.getLinkedDictionaryPair(t);
                        if (!o.isUndefined(e)) return e.value;
                    }, e.prototype.remove = function(e) {
                        var i = this.getLinkedDictionaryPair(e);
                        if (!o.isUndefined(i)) return t.prototype.remove.call(this, e), i.unlink(), i.value;
                    }, e.prototype.clear = function() {
                        t.prototype.clear.call(this), this.head.next = this.tail, this.tail.prev = this.head;
                    }, e.prototype.replace = function(t, e) {
                        var i = "$" + this.toStr(e.key);
                        e.next = t.next, e.prev = t.prev, this.remove(t.key), e.prev.next = e, e.next.prev = e, this.table[i] = e, ++this.nElements;
                    }, e.prototype.setValue = function(t, e) {
                        if (!o.isUndefined(t) && !o.isUndefined(e)) {
                            var i = this.getLinkedDictionaryPair(t), s = new a(t, e), n = "$" + this.toStr(t);
                            return o.isUndefined(i) ? (this.appendToTail(s), this.table[n] = s, void ++this.nElements) : (this.replace(i, s), i.value);
                        }
                    }, e.prototype.keys = function() {
                        var t = [];
                        return this.forEach(function(e, i) {
                            t.push(e);
                        }), t;
                    }, e.prototype.values = function() {
                        var t = [];
                        return this.forEach(function(e, i) {
                            t.push(i);
                        }), t;
                    }, e.prototype.forEach = function(t) {
                        for(var e = this.head.next; !h(e);){
                            if (!1 === t(e.key, e.value)) return;
                            e = e.next;
                        }
                    }, e;
                }(r.default);
                e.default = c;
            },
            4538 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var s = i(4831), n = i(4713), r = function() {
                    function t() {
                        this.firstNode = null, this.lastNode = null, this.nElements = 0;
                    }
                    return t.prototype.add = function(t, e) {
                        if (s.isUndefined(e) && (e = this.nElements), e < 0 || e > this.nElements || s.isUndefined(t)) return !1;
                        var i = this.createNode(t);
                        if (0 === this.nElements || null === this.lastNode) this.firstNode = i, this.lastNode = i;
                        else if (e === this.nElements) this.lastNode.next = i, this.lastNode = i;
                        else if (0 === e) i.next = this.firstNode, this.firstNode = i;
                        else {
                            var n = this.nodeAtIndex(e - 1);
                            if (null === n) return !1;
                            i.next = n.next, n.next = i;
                        }
                        return this.nElements++, !0;
                    }, t.prototype.first = function() {
                        if (null !== this.firstNode) return this.firstNode.element;
                    }, t.prototype.last = function() {
                        if (null !== this.lastNode) return this.lastNode.element;
                    }, t.prototype.elementAtIndex = function(t) {
                        var e = this.nodeAtIndex(t);
                        if (null !== e) return e.element;
                    }, t.prototype.indexOf = function(t, e) {
                        var i = e || s.defaultEquals;
                        if (s.isUndefined(t)) return -1;
                        for(var n = this.firstNode, r = 0; null !== n;){
                            if (i(n.element, t)) return r;
                            r++, n = n.next;
                        }
                        return -1;
                    }, t.prototype.contains = function(t, e) {
                        return this.indexOf(t, e) >= 0;
                    }, t.prototype.remove = function(t, e) {
                        var i = e || s.defaultEquals;
                        if (this.nElements < 1 || s.isUndefined(t)) return !1;
                        for(var n = null, r = this.firstNode; null !== r;){
                            if (i(r.element, t)) return null === n ? (this.firstNode = r.next, r === this.lastNode && (this.lastNode = null)) : r === this.lastNode ? (this.lastNode = n, n.next = r.next, r.next = null) : (n.next = r.next, r.next = null), this.nElements--, !0;
                            n = r, r = r.next;
                        }
                        return !1;
                    }, t.prototype.clear = function() {
                        this.firstNode = null, this.lastNode = null, this.nElements = 0;
                    }, t.prototype.equals = function(e, i) {
                        var n = i || s.defaultEquals;
                        return e instanceof t && this.size() === e.size() && this.equalsAux(this.firstNode, e.firstNode, n);
                    }, t.prototype.equalsAux = function(t, e, i) {
                        for(; null !== t && null !== e;){
                            if (!i(t.element, e.element)) return !1;
                            t = t.next, e = e.next;
                        }
                        return !0;
                    }, t.prototype.removeElementAtIndex = function(t) {
                        if (!(t < 0 || t >= this.nElements || null === this.firstNode || null === this.lastNode)) {
                            var e;
                            if (1 === this.nElements) e = this.firstNode.element, this.firstNode = null, this.lastNode = null;
                            else {
                                var i = this.nodeAtIndex(t - 1);
                                null === i ? (e = this.firstNode.element, this.firstNode = this.firstNode.next) : i.next === this.lastNode && (e = this.lastNode.element, this.lastNode = i), null !== i && null !== i.next && (e = i.next.element, i.next = i.next.next);
                            }
                            return this.nElements--, e;
                        }
                    }, t.prototype.forEach = function(t) {
                        for(var e = this.firstNode; null !== e && !1 !== t(e.element);)e = e.next;
                    }, t.prototype.reverse = function() {
                        for(var t = null, e = this.firstNode, i = null; null !== e;)i = e.next, e.next = t, t = e, e = i;
                        i = this.firstNode, this.firstNode = this.lastNode, this.lastNode = i;
                    }, t.prototype.toArray = function() {
                        for(var t = [], e = this.firstNode; null !== e;)t.push(e.element), e = e.next;
                        return t;
                    }, t.prototype.size = function() {
                        return this.nElements;
                    }, t.prototype.isEmpty = function() {
                        return this.nElements <= 0;
                    }, t.prototype.toString = function() {
                        return n.toString(this.toArray());
                    }, t.prototype.nodeAtIndex = function(t) {
                        if (t < 0 || t >= this.nElements) return null;
                        if (t === this.nElements - 1) return this.lastNode;
                        for(var e = this.firstNode, i = 0; i < t && null !== e; i++)e = e.next;
                        return e;
                    }, t.prototype.createNode = function(t) {
                        return {
                            element: t,
                            next: null
                        };
                    }, t;
                }();
                e.default = r;
            },
            2338 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var s = i(4831), n = i(6119), r = i(4713), o = function() {
                    function t(t, e, i) {
                        void 0 === i && (i = !1), this.dict = new n.default(t), this.equalsF = e || s.defaultEquals, this.allowDuplicate = i;
                    }
                    return t.prototype.getValue = function(t) {
                        var e = this.dict.getValue(t);
                        return s.isUndefined(e) ? [] : r.copy(e);
                    }, t.prototype.setValue = function(t, e) {
                        if (s.isUndefined(t) || s.isUndefined(e)) return !1;
                        var i = this.dict.getValue(t);
                        return s.isUndefined(i) ? (this.dict.setValue(t, [
                            e
                        ]), !0) : !(!this.allowDuplicate && r.contains(i, e, this.equalsF) || (i.push(e), 0));
                    }, t.prototype.remove = function(t, e) {
                        if (s.isUndefined(e)) {
                            var i = this.dict.remove(t);
                            return !s.isUndefined(i);
                        }
                        var n = this.dict.getValue(t);
                        return !(s.isUndefined(n) || !r.remove(n, e, this.equalsF) || (0 === n.length && this.dict.remove(t), 0));
                    }, t.prototype.keys = function() {
                        return this.dict.keys();
                    }, t.prototype.values = function() {
                        for(var t = [], e = 0, i = this.dict.values(); e < i.length; e++)for(var s = 0, n = i[e]; s < n.length; s++){
                            var r = n[s];
                            t.push(r);
                        }
                        return t;
                    }, t.prototype.containsKey = function(t) {
                        return this.dict.containsKey(t);
                    }, t.prototype.clear = function() {
                        this.dict.clear();
                    }, t.prototype.size = function() {
                        return this.dict.size();
                    }, t.prototype.isEmpty = function() {
                        return this.dict.isEmpty();
                    }, t;
                }();
                e.default = o;
            },
            2002 (t, e) {
                "use strict";
                var i;
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), function(t) {
                    t[t.BEFORE = 0] = "BEFORE", t[t.AFTER = 1] = "AFTER", t[t.INSIDE_AT_END = 2] = "INSIDE_AT_END", t[t.INSIDE_AT_START = 3] = "INSIDE_AT_START";
                }(i || (i = {}));
                var s = function() {
                    function t(t, e) {
                        void 0 === t && (t = []), void 0 === e && (e = {}), this.rootIds = t, this.nodes = e, this.initRootIds(), this.initNodes();
                    }
                    return t.prototype.initRootIds = function() {
                        for(var t = 0, e = this.rootIds; t < e.length; t++){
                            var i = e[t];
                            this.createEmptyNodeIfNotExist(i);
                        }
                    }, t.prototype.initNodes = function() {
                        for(var t in this.nodes)if (this.nodes.hasOwnProperty(t)) for(var e = 0, i = this.nodes[t]; e < i.length; e++){
                            var s = i[e];
                            this.createEmptyNodeIfNotExist(s);
                        }
                    }, t.prototype.createEmptyNodeIfNotExist = function(t) {
                        this.nodes[t] || (this.nodes[t] = []);
                    }, t.prototype.getRootIds = function() {
                        return this.rootIds.slice();
                    }, t.prototype.getNodes = function() {
                        var t = {};
                        for(var e in this.nodes)this.nodes.hasOwnProperty(e) && (t[e] = this.nodes[e].slice());
                        return t;
                    }, t.prototype.getObject = function() {
                        return {
                            rootIds: this.getRootIds(),
                            nodes: this.getNodes()
                        };
                    }, t.prototype.toObject = function() {
                        return this.getObject();
                    }, t.prototype.flatten = function() {
                        for(var t = this, e = [], i = 0; i < this.rootIds.length; i++){
                            var s = this.rootIds[i];
                            e.push({
                                id: s,
                                level: 0,
                                hasParent: !1,
                                childrenCount: 0
                            }), l(s, this.nodes, e, 0);
                        }
                        for(var n = 0, r = e; n < r.length; n++){
                            var o = r[n];
                            o.childrenCount = a(o.id);
                        }
                        return e;
                        function a(e) {
                            return t.nodes[e] ? t.nodes[e].length : 0;
                        }
                        function l(t, e, i, s) {
                            if (void 0 === s && (s = 0), t && e && i && e[t]) {
                                s++;
                                for(var n = e[t], r = 0; r < n.length; r++){
                                    var o = n[r];
                                    i.push({
                                        id: o,
                                        level: s,
                                        hasParent: !0
                                    }), l(o, e, i, s);
                                }
                                s--;
                            }
                        }
                    }, t.prototype.moveIdBeforeId = function(t, e) {
                        return this.moveId(t, e, i.BEFORE);
                    }, t.prototype.moveIdAfterId = function(t, e) {
                        return this.moveId(t, e, i.AFTER);
                    }, t.prototype.moveIdIntoId = function(t, e, s) {
                        return void 0 === s && (s = !0), s ? this.moveId(t, e, i.INSIDE_AT_START) : this.moveId(t, e, i.INSIDE_AT_END);
                    }, t.prototype.swapRootIdWithRootId = function(t, e) {
                        var i = this.findRootId(t), s = this.findRootId(e);
                        this.swapRootPositionWithRootPosition(i, s);
                    }, t.prototype.swapRootPositionWithRootPosition = function(t, e) {
                        var i = this.rootIds[e];
                        this.rootIds[e] = this.rootIds[t], this.rootIds[t] = i;
                    }, t.prototype.deleteId = function(t) {
                        this.rootDeleteId(t), this.nodeAndSubNodesDelete(t), this.nodeRefrencesDelete(t);
                    }, t.prototype.insertIdBeforeId = function(t, e) {
                        var i = this.findRootId(t);
                        for(var s in i > -1 && this.insertIdIntoRoot(e, i), this.nodes)if (this.nodes.hasOwnProperty(s)) {
                            var n = this.findNodeId(s, t);
                            n > -1 && this.insertIdIntoNode(s, e, n);
                        }
                    }, t.prototype.insertIdAfterId = function(t, e) {
                        var i = this.findRootId(t);
                        for(var s in i > -1 && this.insertIdIntoRoot(e, i + 1), this.nodes)if (this.nodes.hasOwnProperty(s)) {
                            var n = this.findNodeId(s, t);
                            n > -1 && this.insertIdIntoNode(s, e, n + 1);
                        }
                    }, t.prototype.insertIdIntoId = function(t, e) {
                        this.nodeInsertAtEnd(t, e), this.nodes[e] = [];
                    }, t.prototype.insertIdIntoRoot = function(t, e) {
                        if (void 0 === e) this.rootInsertAtEnd(t);
                        else if (e < 0) {
                            var i = this.rootIds.length;
                            this.rootIds.splice(e + i + 1, 0, t);
                        } else this.rootIds.splice(e, 0, t);
                        this.nodes[t] = this.nodes[t] || [];
                    }, t.prototype.insertIdIntoNode = function(t, e, i) {
                        if (this.nodes[t] = this.nodes[t] || [], this.nodes[e] = this.nodes[e] || [], void 0 === i) this.nodeInsertAtEnd(t, e);
                        else if (i < 0) {
                            var s = this.nodes[t].length;
                            this.nodes[t].splice(i + s + 1, 0, e);
                        } else this.nodes[t].splice(i, 0, e);
                    }, t.prototype.moveId = function(t, e, s) {
                        var n = t, r = this.findRootId(n);
                        for(var o in this.nodes[e], this.nodes)if (this.nodes.hasOwnProperty(o)) {
                            this.findNodeId(o, e);
                            break;
                        }
                        var a = e, l = this.findRootId(a);
                        for(var o in this.nodes[e], this.nodes)if (this.nodes.hasOwnProperty(o)) {
                            this.findNodeId(o, e);
                            break;
                        }
                        if (r > -1) {
                            if (l > -1) switch(this.rootDelete(r), l > r && l--, s){
                                case i.BEFORE:
                                    this.insertIdIntoRoot(n, l);
                                    break;
                                case i.AFTER:
                                    this.insertIdIntoRoot(n, l + 1);
                                    break;
                                case i.INSIDE_AT_START:
                                    this.nodeInsertAtStart(a, n);
                                    break;
                                case i.INSIDE_AT_END:
                                    this.nodeInsertAtEnd(a, n);
                            }
                            else for(var o in this.rootDelete(r), this.nodes)if (this.nodes.hasOwnProperty(o) && (h = this.findNodeId(o, a)) > -1) {
                                switch(s){
                                    case i.BEFORE:
                                        this.insertIdIntoNode(o, n, h);
                                        break;
                                    case i.AFTER:
                                        this.insertIdIntoNode(o, n, h + 1);
                                        break;
                                    case i.INSIDE_AT_START:
                                        this.nodeInsertAtStart(a, n);
                                        break;
                                    case i.INSIDE_AT_END:
                                        this.nodeInsertAtEnd(a, n);
                                }
                                break;
                            }
                        } else if (l > -1) {
                            for(var o in this.nodes)if (this.nodes.hasOwnProperty(o) && (h = this.findNodeId(o, n)) > -1) {
                                this.nodeDeleteAtIndex(o, h);
                                break;
                            }
                            switch(s){
                                case i.BEFORE:
                                    this.insertIdIntoRoot(n, l);
                                    break;
                                case i.AFTER:
                                    this.insertIdIntoRoot(n, l + 1);
                                    break;
                                case i.INSIDE_AT_START:
                                    this.nodeInsertAtStart(a, n);
                                    break;
                                case i.INSIDE_AT_END:
                                    this.nodeInsertAtEnd(a, n);
                            }
                        } else {
                            for(var o in this.nodes)if (this.nodes.hasOwnProperty(o) && (h = this.findNodeId(o, n)) > -1) {
                                this.nodeDeleteAtIndex(o, h);
                                break;
                            }
                            for(var o in this.nodes){
                                var h;
                                if (this.nodes.hasOwnProperty(o) && (h = this.findNodeId(o, a)) > -1) {
                                    switch(s){
                                        case i.BEFORE:
                                            this.insertIdIntoNode(o, n, h);
                                            break;
                                        case i.AFTER:
                                            this.insertIdIntoNode(o, n, h + 1);
                                            break;
                                        case i.INSIDE_AT_START:
                                            this.nodeInsertAtStart(a, n);
                                            break;
                                        case i.INSIDE_AT_END:
                                            this.nodeInsertAtEnd(a, n);
                                    }
                                    break;
                                }
                            }
                        }
                    }, t.prototype.swapArrayElements = function(t, e, i) {
                        var s = t[e];
                        return t[e] = t[i], t[i] = s, t;
                    }, t.prototype.rootDeleteId = function(t) {
                        var e = this.findRootId(t);
                        e > -1 && this.rootDelete(e);
                    }, t.prototype.nodeAndSubNodesDelete = function(t) {
                        for(var e = [], i = 0; i < this.nodes[t].length; i++){
                            var s = this.nodes[t][i];
                            this.nodeAndSubNodesDelete(s), e.push(t);
                        }
                        for(this.nodeDelete(t), i = 0; i < e.length; i++)this.nodeDelete(e[i]);
                    }, t.prototype.nodeRefrencesDelete = function(t) {
                        for(var e in this.nodes)if (this.nodes.hasOwnProperty(e)) for(var i = 0; i < this.nodes[e].length; i++)this.nodes[e][i] === t && this.nodeDeleteAtIndex(e, i);
                    }, t.prototype.nodeDelete = function(t) {
                        delete this.nodes[t];
                    }, t.prototype.findRootId = function(t) {
                        return this.rootIds.indexOf(t);
                    }, t.prototype.findNodeId = function(t, e) {
                        return this.nodes[t].indexOf(e);
                    }, t.prototype.findNode = function(t) {
                        return this.nodes[t];
                    }, t.prototype.nodeInsertAtStart = function(t, e) {
                        this.nodes[t].unshift(e);
                    }, t.prototype.nodeInsertAtEnd = function(t, e) {
                        this.nodes[t].push(e);
                    }, t.prototype.rootDelete = function(t) {
                        this.rootIds.splice(t, 1);
                    }, t.prototype.nodeDeleteAtIndex = function(t, e) {
                        this.nodes[t].splice(e, 1);
                    }, t.prototype.rootInsertAtStart = function(t) {
                        this.rootIds.unshift(t);
                    }, t.prototype.rootInsertAtEnd = function(t) {
                        this.rootIds.push(t);
                    }, t;
                }();
                e.default = s;
            },
            8464 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var s = i(4831), n = i(4589), r = function() {
                    function t(t) {
                        this.heap = new n.default(s.reverseCompareFunction(t));
                    }
                    return t.prototype.enqueue = function(t) {
                        return this.heap.add(t);
                    }, t.prototype.add = function(t) {
                        return this.heap.add(t);
                    }, t.prototype.dequeue = function() {
                        if (0 !== this.heap.size()) {
                            var t = this.heap.peek();
                            return this.heap.removeRoot(), t;
                        }
                    }, t.prototype.peek = function() {
                        return this.heap.peek();
                    }, t.prototype.contains = function(t) {
                        return this.heap.contains(t);
                    }, t.prototype.isEmpty = function() {
                        return this.heap.isEmpty();
                    }, t.prototype.size = function() {
                        return this.heap.size();
                    }, t.prototype.clear = function() {
                        this.heap.clear();
                    }, t.prototype.forEach = function(t) {
                        this.heap.forEach(t);
                    }, t;
                }();
                e.default = r;
            },
            3288 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var s = i(4538), n = function() {
                    function t() {
                        this.list = new s.default;
                    }
                    return t.prototype.enqueue = function(t) {
                        return this.list.add(t);
                    }, t.prototype.add = function(t) {
                        return this.list.add(t);
                    }, t.prototype.dequeue = function() {
                        if (0 !== this.list.size()) {
                            var t = this.list.first();
                            return this.list.removeElementAtIndex(0), t;
                        }
                    }, t.prototype.peek = function() {
                        if (0 !== this.list.size()) return this.list.first();
                    }, t.prototype.size = function() {
                        return this.list.size();
                    }, t.prototype.contains = function(t, e) {
                        return this.list.contains(t, e);
                    }, t.prototype.isEmpty = function() {
                        return this.list.size() <= 0;
                    }, t.prototype.clear = function() {
                        this.list.clear();
                    }, t.prototype.forEach = function(t) {
                        this.list.forEach(t);
                    }, t;
                }();
                e.default = n;
            },
            2091 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var s = i(4831), n = i(4713), r = i(6119), o = function() {
                    function t(t) {
                        this.dictionary = new r.default(t);
                    }
                    return t.prototype.contains = function(t) {
                        return this.dictionary.containsKey(t);
                    }, t.prototype.add = function(t) {
                        return !this.contains(t) && !s.isUndefined(t) && (this.dictionary.setValue(t, t), !0);
                    }, t.prototype.intersection = function(t) {
                        var e = this;
                        this.forEach(function(i) {
                            return t.contains(i) || e.remove(i), !0;
                        });
                    }, t.prototype.union = function(t) {
                        var e = this;
                        t.forEach(function(t) {
                            return e.add(t), !0;
                        });
                    }, t.prototype.difference = function(t) {
                        var e = this;
                        t.forEach(function(t) {
                            return e.remove(t), !0;
                        });
                    }, t.prototype.isSubsetOf = function(t) {
                        if (this.size() > t.size()) return !1;
                        var e = !0;
                        return this.forEach(function(i) {
                            return !!t.contains(i) || (e = !1, !1);
                        }), e;
                    }, t.prototype.remove = function(t) {
                        return !!this.contains(t) && (this.dictionary.remove(t), !0);
                    }, t.prototype.forEach = function(t) {
                        this.dictionary.forEach(function(e, i) {
                            return t(i);
                        });
                    }, t.prototype.toArray = function() {
                        return this.dictionary.values();
                    }, t.prototype.isEmpty = function() {
                        return this.dictionary.isEmpty();
                    }, t.prototype.size = function() {
                        return this.dictionary.size();
                    }, t.prototype.clear = function() {
                        this.dictionary.clear();
                    }, t.prototype.toString = function() {
                        return n.toString(this.toArray());
                    }, t;
                }();
                e.default = o;
            },
            2083 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var s = i(4538), n = function() {
                    function t() {
                        this.list = new s.default;
                    }
                    return t.prototype.push = function(t) {
                        return this.list.add(t, 0);
                    }, t.prototype.add = function(t) {
                        return this.list.add(t, 0);
                    }, t.prototype.pop = function() {
                        return this.list.removeElementAtIndex(0);
                    }, t.prototype.peek = function() {
                        return this.list.first();
                    }, t.prototype.size = function() {
                        return this.list.size();
                    }, t.prototype.contains = function(t, e) {
                        return this.list.contains(t, e);
                    }, t.prototype.isEmpty = function() {
                        return this.list.isEmpty();
                    }, t.prototype.clear = function() {
                        this.list.clear();
                    }, t.prototype.forEach = function(t) {
                        this.list.forEach(t);
                    }, t;
                }();
                e.default = n;
            },
            4713 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var s = i(4831);
                function n(t, e, i) {
                    for(var n = i || s.defaultEquals, r = t.length, o = 0; o < r; o++)if (n(t[o], e)) return o;
                    return -1;
                }
                e.indexOf = n, e.lastIndexOf = function(t, e, i) {
                    for(var n = i || s.defaultEquals, r = t.length - 1; r >= 0; r--)if (n(t[r], e)) return r;
                    return -1;
                }, e.contains = function(t, e, i) {
                    return n(t, e, i) >= 0;
                }, e.remove = function(t, e, i) {
                    var s = n(t, e, i);
                    return !(s < 0 || (t.splice(s, 1), 0));
                }, e.frequency = function(t, e, i) {
                    for(var n = i || s.defaultEquals, r = t.length, o = 0, a = 0; a < r; a++)n(t[a], e) && o++;
                    return o;
                }, e.equals = function(t, e, i) {
                    var n = i || s.defaultEquals;
                    if (t.length !== e.length) return !1;
                    for(var r = t.length, o = 0; o < r; o++)if (!n(t[o], e[o])) return !1;
                    return !0;
                }, e.copy = function(t) {
                    return t.concat();
                }, e.swap = function(t, e, i) {
                    if (e < 0 || e >= t.length || i < 0 || i >= t.length) return !1;
                    var s = t[e];
                    return t[e] = t[i], t[i] = s, !0;
                }, e.toString = function(t) {
                    return "[" + t.toString() + "]";
                }, e.forEach = function(t, e) {
                    for(var i = 0, s = t; i < s.length; i++)if (!1 === e(s[i])) return;
                };
            },
            3263 (t, e, i) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var s = i(4713);
                e.arrays = s;
                var n = i(2909);
                e.Bag = n.default;
                var r = i(9924);
                e.BSTree = r.default;
                var o = i(4041);
                e.BSTreeKV = o.default;
                var a = i(6119);
                e.Dictionary = a.default;
                var l = i(4589);
                e.Heap = l.default;
                var h = i(1846);
                e.LinkedDictionary = h.default;
                var c = i(4538);
                e.LinkedList = c.default;
                var u = i(2338);
                e.MultiDictionary = u.default;
                var d = i(9281);
                e.FactoryDictionary = d.default;
                var f = i(9281);
                e.DefaultDictionary = f.default;
                var m = i(3288);
                e.Queue = m.default;
                var p = i(8464);
                e.PriorityQueue = p.default;
                var g = i(2091);
                e.Set = g.default;
                var b = i(2083);
                e.Stack = b.default;
                var S = i(2002);
                e.MultiRootTree = S.default;
                var y = i(4831);
                e.util = y;
            },
            4831 (t, e) {
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var i = Object.prototype.hasOwnProperty;
                function s(t) {
                    return "function" == typeof t;
                }
                function n(t) {
                    return void 0 === t;
                }
                function r(t) {
                    return "[object String]" === Object.prototype.toString.call(t);
                }
                e.has = function(t, e) {
                    return i.call(t, e);
                }, e.defaultCompare = function(t, e) {
                    return t < e ? -1 : t === e ? 0 : 1;
                }, e.defaultEquals = function(t, e) {
                    return t === e;
                }, e.defaultToString = function(t) {
                    return null === t ? "COLLECTION_NULL" : n(t) ? "COLLECTION_UNDEFINED" : r(t) ? "$s" + t : "$o" + t.toString();
                }, e.makeString = function(t, i) {
                    if (void 0 === i && (i = ","), null === t) return "COLLECTION_NULL";
                    if (n(t)) return "COLLECTION_UNDEFINED";
                    if (r(t)) return t.toString();
                    var s = "{", o = !0;
                    for(var a in t)e.has(t, a) && (o ? o = !1 : s += i, s = s + a + ":" + t[a]);
                    return s + "}";
                }, e.isFunction = s, e.isUndefined = n, e.isString = r, e.reverseCompareFunction = function(t) {
                    return n(t) || !s(t) ? function(t, e) {
                        return t < e ? 1 : t === e ? 0 : -1;
                    } : function(e, i) {
                        return -1 * t(e, i);
                    };
                }, e.compareToEquals = function(t) {
                    return function(e, i) {
                        return 0 === t(e, i);
                    };
                };
            },
            3206 (t, e, i) {
                "use strict";
                i.r(e), i.d(e, {
                    default: ()=>ye
                });
                const s = ()=>{};
                s.L = (t, e)=>{
                    if (!e) return;
                    const i = Array.prototype.slice.call(e).join(" ");
                    window.console.log(t + ": " + i);
                }, s.MakeException = (t)=>class extends Error {
                        constructor(e, i){
                            super(e), this.name = t, this.message = e, this.data = i;
                        }
                    }, s.RERR = s.RuntimeError = class {
                    constructor(t, e){
                        this.code = t, this.message = e;
                    }
                    toString() {
                        return "[RuntimeError] " + this.code + ":" + this.message;
                    }
                }, s.Merge = (t, e)=>{
                    for(const i in e)t[i] = e[i];
                    return t;
                }, s.Min = Math.min, s.Max = Math.max, s.forEach = (t, e)=>{
                    for(let i = 0; i < t.length; i++)e(t[i], i);
                }, s.RoundN = (t, e)=>t % e >= e / 2 ? parseInt(t / e, 10) * e + e : parseInt(t / e, 10) * e, s.MidLine = (t, e)=>{
                    let i = e + (t - e) / 2;
                    return i % 2 > 0 && (i = s.RoundN(10 * i, 5) / 10), i;
                }, s.SortAndUnique = (t, e, i)=>{
                    if (t.length > 1) {
                        const s = [];
                        let n;
                        t.sort(e);
                        for(let e = 0; e < t.length; ++e)0 !== e && i(t[e], n) || s.push(t[e]), n = t[e];
                        return s;
                    }
                    return t;
                }, s.Contains = (t, e)=>{
                    let i = t.length;
                    for(; i--;)if (t[i] === e) return !0;
                    return !1;
                }, s.getCanvasContext = (t)=>{
                    if (!t) throw new s.RERR("BadArgument", "Invalid canvas selector: " + t);
                    const e = document.getElementById(t);
                    if (!e || !e.getContext) throw new s.RERR("UnsupportedBrowserError", "This browser does not support HTML5 Canvas");
                    return e.getContext("2d");
                }, s.drawDot = (t, e, i, s = "#55")=>{
                    t.save(), t.setFillStyle(s), t.beginPath(), t.arc(e, i, 3, 0, 2 * Math.PI, !0), t.closePath(), t.fill(), t.restore();
                }, s.BM = (t, e)=>{
                    const i = (new Date).getTime();
                    e();
                    const n = (new Date).getTime() - i;
                    s.L(t + n + "ms");
                }, s.StackTrace = ()=>(new Error).stack, s.W = (...t)=>{
                    const e = t.join(" ");
                    window.console.log("Warning: ", e, s.StackTrace());
                }, (s.Prefix = (t)=>s.Prefix.prefix + t).prefix = "vf-";
                class n {
                    static GCD(t, e) {
                        if ("number" != typeof t || "number" != typeof e) throw new s.RERR("BadArgument", `Invalid numbers: ${t}, ${e}`);
                        let i;
                        for(; 0 !== e;)i = e, e = t % e, t = i;
                        return t;
                    }
                    static LCM(t, e) {
                        return t * e / n.GCD(t, e);
                    }
                    static LCMM(t) {
                        if (0 === t.length) return 0;
                        if (1 === t.length) return t[0];
                        if (2 === t.length) return n.LCM(t[0], t[1]);
                        {
                            const e = t[0];
                            return t.shift(), n.LCM(e, n.LCMM(t));
                        }
                    }
                    constructor(t, e){
                        this.set(t, e);
                    }
                    set(t, e) {
                        return this.numerator = void 0 === t ? 1 : t, this.denominator = void 0 === e ? 1 : e, this;
                    }
                    value() {
                        return this.numerator / this.denominator;
                    }
                    simplify() {
                        let t = this.numerator, e = this.denominator;
                        const i = n.GCD(t, e);
                        return t /= i, e /= i, e < 0 && (e = -e, t = -t), this.set(t, e);
                    }
                    add(t, e) {
                        let i, s;
                        t instanceof n ? (i = t.numerator, s = t.denominator) : (i = void 0 !== t ? t : 0, s = void 0 !== e ? e : 1);
                        const r = n.LCM(this.denominator, s), o = r / this.denominator, a = r / s, l = this.numerator * o + i * a;
                        return this.set(l, r);
                    }
                    subtract(t, e) {
                        let i, s;
                        t instanceof n ? (i = t.numerator, s = t.denominator) : (i = void 0 !== t ? t : 0, s = void 0 !== e ? e : 1);
                        const r = n.LCM(this.denominator, s), o = r / this.denominator, a = r / s, l = this.numerator * o - i * a;
                        return this.set(l, r);
                    }
                    multiply(t, e) {
                        let i, s;
                        return t instanceof n ? (i = t.numerator, s = t.denominator) : (i = void 0 !== t ? t : 1, s = void 0 !== e ? e : 1), this.set(this.numerator * i, this.denominator * s);
                    }
                    divide(t, e) {
                        let i, s;
                        return t instanceof n ? (i = t.numerator, s = t.denominator) : (i = void 0 !== t ? t : 1, s = void 0 !== e ? e : 1), this.set(this.numerator * s, this.denominator * i);
                    }
                    equals(t) {
                        const e = n.__compareA.copy(t).simplify(), i = n.__compareB.copy(this).simplify();
                        return e.numerator === i.numerator && e.denominator === i.denominator;
                    }
                    greaterThan(t) {
                        const e = n.__compareB.copy(this);
                        return e.subtract(t), e.numerator > 0;
                    }
                    greaterThanEquals(t) {
                        const e = n.__compareB.copy(this);
                        return e.subtract(t), e.numerator >= 0;
                    }
                    lessThan(t) {
                        return !this.greaterThanEquals(t);
                    }
                    lessThanEquals(t) {
                        return !this.greaterThan(t);
                    }
                    clone() {
                        return new n(this.numerator, this.denominator);
                    }
                    copy(t) {
                        return "number" == typeof t ? this.set(t || 0, 1) : this.set(t.numerator, t.denominator);
                    }
                    quotient() {
                        return Math.floor(this.numerator / this.denominator);
                    }
                    fraction() {
                        return this.numerator % this.denominator;
                    }
                    abs() {
                        return this.denominator = Math.abs(this.denominator), this.numerator = Math.abs(this.numerator), this;
                    }
                    toString() {
                        return this.numerator + "/" + this.denominator;
                    }
                    toSimplifiedString() {
                        return n.__tmp.copy(this).simplify().toString();
                    }
                    toMixedString() {
                        let t = "";
                        const e = this.quotient(), i = n.__tmp.copy(this);
                        return e < 0 ? i.abs().fraction() : i.fraction(), 0 !== e ? (t += e, 0 !== i.numerator && (t += " " + i.toSimplifiedString())) : t = 0 === i.numerator ? "0" : i.toSimplifiedString(), t;
                    }
                    parse(t) {
                        const e = t.split("/"), i = parseInt(e[0], 10), s = e[1] ? parseInt(e[1], 10) : 1;
                        return this.set(i, s);
                    }
                }
                n.__compareA = new n, n.__compareB = new n, n.__tmp = new n;
                const r = s.MakeException("RegistryError");
                function o(t, e, i, s, n) {
                    t[e][i] || (t[e][i] = {}), t[e][i][s] = n;
                }
                class a {
                    static get INDEXES() {
                        return [
                            "type"
                        ];
                    }
                    constructor(){
                        this.clear();
                    }
                    static enableDefaultRegistry(t) {
                        a.defaultRegistry = t;
                    }
                    static getDefaultRegistry() {
                        return a.defaultRegistry;
                    }
                    static disableDefaultRegistry() {
                        a.defaultRegistry = null;
                    }
                    clear() {
                        return this.index = {
                            id: {},
                            type: {},
                            class: {}
                        }, this;
                    }
                    updateIndex({ id: t, name: e, value: i, oldValue: s }) {
                        const n = this.getElementById(t);
                        null !== s && this.index[e][s] && delete this.index[e][s][t], null !== i && o(this.index, e, i, n.getAttribute("id"), n);
                    }
                    register(t, e) {
                        if (!(e = e || t.getAttribute("id"))) throw new r("Can't add element without `id` attribute to registry", t);
                        return t.setAttribute("id", e), o(this.index, "id", e, e, t), a.INDEXES.forEach((i)=>{
                            this.updateIndex({
                                id: e,
                                name: i,
                                value: t.getAttribute(i),
                                oldValue: null
                            });
                        }), t.onRegister(this), this;
                    }
                    getElementById(t) {
                        return this.index.id[t] ? this.index.id[t][t] : null;
                    }
                    getElementsByAttribute(t, e) {
                        const i = this.index[t];
                        return i && i[e] ? Object.keys(i[e]).map((t)=>i[e][t]) : [];
                    }
                    getElementsByType(t) {
                        return this.getElementsByAttribute("type", t);
                    }
                    getElementsByClass(t) {
                        return this.getElementsByAttribute("class", t);
                    }
                    onUpdate({ id: t, name: e, value: i, oldValue: s }) {
                        return function(t, e) {
                            return t.filter((t)=>t === e).length > 0;
                        }(a.INDEXES.concat([
                            "id",
                            "class"
                        ]), e) ? (this.updateIndex({
                            id: t,
                            name: e,
                            value: i,
                            oldValue: s
                        }), this) : this;
                    }
                }
                a.defaultRegistry = null;
                class l {
                    static newID() {
                        return "auto" + l.ID++;
                    }
                    constructor({ type: t } = {}){
                        this.attrs = {
                            id: l.newID(),
                            el: null,
                            type: t || "Base",
                            classes: {}
                        }, this.boundingBox = null, this.context = null, this.rendered = !1, a.getDefaultRegistry() && a.getDefaultRegistry().register(this);
                    }
                    setStyle(t) {
                        return this.style = t, this;
                    }
                    getStyle() {
                        return this.style;
                    }
                    applyStyle(t = this.context, e = this.getStyle()) {
                        return e ? (t.save(), e.shadowColor && t.setShadowColor(e.shadowColor), e.shadowBlur && t.setShadowBlur(e.shadowBlur), e.fillStyle && t.setFillStyle(e.fillStyle), e.strokeStyle && t.setStrokeStyle(e.strokeStyle), e.lineWidth && t.setLineWidth(e.lineWidth), this) : this;
                    }
                    restoreStyle(t = this.context, e = this.getStyle()) {
                        return e ? (t.restore(), this) : this;
                    }
                    drawWithStyle() {
                        this.checkContext(), this.applyStyle(), this.draw(), this.restoreStyle();
                    }
                    hasClass(t) {
                        return !0 === this.attrs.classes[t];
                    }
                    addClass(t) {
                        return this.attrs.classes[t] = !0, this.registry && this.registry.onUpdate({
                            id: this.getAttribute("id"),
                            name: "class",
                            value: t,
                            oldValue: null
                        }), this;
                    }
                    removeClass(t) {
                        return delete this.attrs.classes[t], this.registry && this.registry.onUpdate({
                            id: this.getAttribute("id"),
                            name: "class",
                            value: null,
                            oldValue: t
                        }), this;
                    }
                    onRegister(t) {
                        return this.registry = t, this;
                    }
                    isRendered() {
                        return this.rendered;
                    }
                    setRendered(t = !0) {
                        return this.rendered = t, this;
                    }
                    getAttributes() {
                        return this.attrs;
                    }
                    getAttribute(t) {
                        return this.attrs[t];
                    }
                    setAttribute(t, e) {
                        const i = this.attrs.id, s = this.attrs[t];
                        return this.attrs[t] = e, this.registry && this.registry.onUpdate({
                            id: i,
                            name: t,
                            value: e,
                            oldValue: s
                        }), this;
                    }
                    getContext() {
                        return this.context;
                    }
                    setContext(t) {
                        return this.context = t, this;
                    }
                    getBoundingBox() {
                        return this.boundingBox;
                    }
                    checkContext() {
                        if (!this.context) throw new s.RERR("NoContext", "No rendering context attached to instance");
                        return this.context;
                    }
                }
                l.ID = 1e3;
                class h {
                    constructor(t, e, i, s){
                        this.x1 = Number.NaN, this.y1 = Number.NaN, this.x2 = Number.NaN, this.y2 = Number.NaN, this.addPoint(t, e), this.addPoint(i, s);
                    }
                    width() {
                        return this.x2 - this.x1;
                    }
                    height() {
                        return this.y2 - this.y1;
                    }
                    addPoint(t, e) {
                        null != t && ((isNaN(this.x1) || isNaN(this.x2)) && (this.x1 = t, this.x2 = t), t < this.x1 && (this.x1 = t), t > this.x2 && (this.x2 = t)), null != e && ((isNaN(this.y1) || isNaN(this.y2)) && (this.y1 = e, this.y2 = e), e < this.y1 && (this.y1 = e), e > this.y2 && (this.y2 = e));
                    }
                    addX(t) {
                        this.addPoint(t, null);
                    }
                    addY(t) {
                        this.addPoint(null, t);
                    }
                    addQuadraticCurve(t, e, i, s, n, r) {
                        const o = t + 2 / 3 * (i - t), a = e + 2 / 3 * (s - e), l = o + 1 / 3 * (n - t), h = a + 1 / 3 * (r - e);
                        this.addBezierCurve(t, e, o, a, l, h, n, r);
                    }
                    addBezierCurve(t, e, i, s, n, r, o, a) {
                        const l = [
                            t,
                            e
                        ], h = [
                            i,
                            s
                        ], c = [
                            n,
                            r
                        ], u = [
                            o,
                            a
                        ];
                        let d;
                        this.addPoint(l[0], l[1]), this.addPoint(u[0], u[1]);
                        const f = (t, e)=>Math.pow(1 - t, 3) * l[e] + 3 * Math.pow(1 - t, 2) * t * h[e] + 3 * (1 - t) * Math.pow(t, 2) * c[e] + Math.pow(t, 3) * u[e];
                        for(d = 0; d <= 1; d++){
                            const t = 6 * l[d] - 12 * h[d] + 6 * c[d], e = -3 * l[d] + 9 * h[d] - 9 * c[d] + 3 * u[d], i = 3 * h[d] - 3 * l[d];
                            if (0 === e) {
                                if (0 === t) continue;
                                const e = -i / t;
                                0 < e && e < 1 && (0 === d && this.addX(f(e, d)), 1 === d && this.addY(f(e, d)));
                                continue;
                            }
                            const s = Math.pow(t, 2) - 4 * i * e;
                            if (s < 0) continue;
                            const n = (-t + Math.sqrt(s)) / (2 * e);
                            0 < n && n < 1 && (0 === d && this.addX(f(n, d)), 1 === d && this.addY(f(n, d)));
                            const r = (-t - Math.sqrt(s)) / (2 * e);
                            0 < r && r < 1 && (0 === d && this.addX(f(r, d)), 1 === d && this.addY(f(r, d)));
                        }
                    }
                }
                class c {
                    static copy(t) {
                        return new c(t.x, t.y, t.w, t.h);
                    }
                    constructor(t, e, i, s){
                        this.x = t, this.y = e, this.w = i, this.h = s;
                    }
                    getX() {
                        return this.x;
                    }
                    getY() {
                        return this.y;
                    }
                    getW() {
                        return this.w;
                    }
                    getH() {
                        return this.h;
                    }
                    setX(t) {
                        return this.x = t, this;
                    }
                    setY(t) {
                        return this.y = t, this;
                    }
                    setW(t) {
                        return this.w = t, this;
                    }
                    setH(t) {
                        return this.h = t, this;
                    }
                    move(t, e) {
                        this.x += t, this.y += e;
                    }
                    clone() {
                        return c.copy(this);
                    }
                    mergeWith(t, e) {
                        const i = t, s = this.x < i.x ? this.x : i.x, n = this.y < i.y ? this.y : i.y, r = Math.max(this.x + this.w, i.x + i.w) - s, o = Math.max(this.y + this.h, i.y + i.h) - n;
                        return this.x = s, this.y = n, this.w = r, this.h = o, e && this.draw(e), this;
                    }
                    draw(t, e, i) {
                        e || (e = 0), i || (i = 0), t.rect(this.x + e, this.y + i, this.w, this.h), t.stroke();
                    }
                }
                const u = {
                    glyphs: {
                        v0: {
                            x_min: 0,
                            x_max: 514.5,
                            ha: 525,
                            o: "m 236 648 b 246 648 238 648 242 648 b 288 646 261 648 283 648 b 472 513 364 634 428 587 b 514 347 502 464 514 413 b 462 163 514 272 499 217 b 257 44 409 83 333 44 b 50 163 181 44 103 83 b 0 347 14 217 0 272 b 40 513 0 413 12 464 b 236 648 87 591 155 638 m 277 614 b 253 616 273 616 261 616 b 242 616 247 616 243 616 b 170 499 193 609 181 589 b 159 348 163 446 159 398 b 166 222 159 308 161 266 b 201 91 174 138 183 106 b 257 76 215 81 235 76 b 311 91 277 76 299 81 b 347 222 330 106 338 138 b 353 348 352 266 353 308 b 344 499 353 398 351 446 b 277 614 333 587 322 606 m 257 -1 l 258 -1 l 255 -1 l 257 -1 m 257 673 l 258 673 l 255 673 l 257 673 "
                        },
                        v1: {
                            x_min: -1.359375,
                            x_max: 344.359375,
                            ha: 351,
                            o: "m 126 637 l 129 638 l 198 638 l 266 638 l 269 635 b 274 631 272 634 273 632 l 277 627 l 277 395 b 279 156 277 230 277 161 b 329 88 281 123 295 106 b 344 69 341 81 344 79 b 337 55 344 62 343 59 l 333 54 l 197 54 l 61 54 l 58 55 b 50 69 53 59 50 62 b 65 88 50 79 53 81 b 80 97 72 91 74 93 b 117 156 103 113 112 129 b 117 345 117 161 117 222 l 117 528 l 100 503 l 38 406 b 14 383 24 384 23 383 b -1 398 5 383 -1 390 b 4 415 -1 403 1 409 b 16 437 5 416 10 426 l 72 539 l 100 596 b 121 632 119 631 119 631 b 126 637 122 634 125 635 m 171 -1 l 172 -1 l 170 -1 l 171 -1 m 171 673 l 172 673 l 170 673 l 171 673 "
                        },
                        v2: {
                            x_min: -1.359375,
                            x_max: 458.6875,
                            ha: 468,
                            o: "m 197 648 b 216 648 201 648 208 648 b 258 646 232 648 253 648 b 419 546 333 637 393 599 b 432 489 428 528 432 509 b 356 342 432 440 405 384 b 235 278 322 313 288 295 b 69 170 166 256 107 217 b 69 169 69 170 69 169 b 69 169 69 169 69 169 b 74 173 69 169 72 170 b 209 222 112 204 163 222 b 310 195 247 222 274 215 b 371 179 332 184 352 179 b 396 181 379 179 387 179 b 428 202 409 184 423 194 b 442 212 431 209 436 212 b 458 197 450 212 458 206 b 441 148 458 190 449 165 b 299 44 409 84 353 44 b 288 45 295 44 292 44 b 250 61 274 45 268 49 b 122 99 212 86 164 99 b 73 91 104 99 88 97 b 28 63 53 84 34 72 b 14 54 25 56 20 54 b 1 62 9 54 4 56 l -1 65 l -1 79 b 0 99 -1 91 0 95 b 2 113 1 102 2 108 b 164 309 20 197 81 272 b 285 470 232 341 277 398 b 287 487 287 476 287 481 b 171 595 287 551 239 595 b 155 595 166 595 160 595 b 142 592 145 594 142 594 b 145 589 142 592 142 591 b 179 527 168 576 179 551 b 132 455 179 496 163 467 b 104 451 122 452 112 451 b 27 530 62 451 27 487 b 29 555 27 538 27 546 b 197 648 44 601 115 639 m 228 -1 l 230 -1 l 227 -1 l 228 -1 m 228 673 l 230 673 l 227 673 l 228 673 "
                        },
                        v3: {
                            x_min: -1.359375,
                            x_max: 409.6875,
                            ha: 418,
                            o: "m 174 648 b 191 648 176 648 183 648 b 225 648 204 648 220 648 b 402 523 317 638 389 588 b 404 503 404 517 404 510 b 402 484 404 495 404 488 b 264 373 389 437 334 394 b 257 370 259 371 257 371 b 257 370 257 370 257 370 b 264 369 258 370 261 369 b 409 202 359 334 409 267 b 318 72 409 152 381 104 b 200 43 281 52 240 43 b 23 113 134 43 69 68 b 0 169 6 129 0 149 b 77 249 0 210 29 249 l 77 249 b 152 174 125 249 152 212 b 103 102 152 145 137 116 b 103 102 103 102 103 102 b 147 94 103 101 132 95 b 153 94 149 94 151 94 b 265 206 219 94 265 141 b 264 226 265 213 265 219 b 147 355 253 299 204 353 b 126 371 133 356 126 362 b 147 388 126 383 132 388 b 254 474 196 391 238 424 b 259 502 258 484 259 494 b 182 592 259 544 228 582 b 156 595 175 595 166 595 b 115 592 142 595 129 594 l 111 591 l 115 588 b 152 524 141 574 152 549 b 92 449 152 491 130 458 b 76 448 87 448 81 448 b -1 530 32 448 -1 488 b 20 581 -1 548 5 566 b 174 648 55 619 108 641 m 204 -1 l 205 -1 l 202 -1 l 204 -1 m 204 673 l 205 673 l 202 673 l 204 673 "
                        },
                        v4: {
                            x_min: 0,
                            x_max: 468.21875,
                            ha: 478,
                            o: "m 174 637 b 232 638 175 638 189 638 b 277 638 245 638 259 638 l 378 638 l 381 635 b 389 623 386 632 389 627 b 382 609 389 617 386 613 b 366 589 381 606 372 598 l 313 528 l 245 451 l 209 410 l 155 348 l 84 267 b 59 240 72 252 59 240 b 59 240 59 240 59 240 b 151 238 59 238 68 238 l 242 238 l 242 303 b 243 371 242 369 242 370 b 289 426 245 374 254 385 l 303 441 l 317 456 l 338 483 l 360 506 l 371 520 b 386 527 375 526 381 527 b 400 519 392 527 397 524 b 401 440 401 516 401 514 b 401 377 401 423 401 402 l 401 238 l 426 238 b 453 237 449 238 450 238 b 465 217 461 234 465 226 b 460 202 465 212 464 206 b 426 197 454 197 453 197 l 401 197 l 401 180 b 451 88 402 129 412 109 b 468 69 465 81 468 79 b 461 55 468 62 466 59 l 458 54 l 321 54 l 185 54 l 182 55 b 175 69 176 59 175 62 b 191 88 175 79 176 81 b 240 180 230 109 240 129 l 240 197 l 125 197 b 73 195 104 195 87 195 b 8 197 10 195 9 197 b 0 212 2 199 0 205 b 0 212 0 212 0 212 b 20 242 0 219 0 219 b 163 610 104 344 163 492 b 174 637 163 628 166 634 m 234 -1 l 235 -1 l 232 -1 l 234 -1 m 234 673 l 235 673 l 232 673 l 234 673 "
                        },
                        v5: {
                            x_min: 0,
                            x_max: 409.6875,
                            ha: 418,
                            o: "m 47 637 b 53 638 49 638 50 638 b 69 634 55 638 61 637 b 210 610 114 619 161 610 b 363 634 259 610 311 619 b 382 638 372 637 378 638 b 392 634 386 638 389 637 b 397 623 396 630 397 627 b 393 610 397 620 396 616 b 298 505 368 552 338 520 b 212 494 277 498 246 494 b 65 517 163 494 106 502 b 61 517 62 517 61 517 b 61 517 61 517 61 517 b 51 408 61 517 51 412 b 51 408 51 408 51 408 b 51 408 51 408 51 408 b 61 412 53 408 55 409 b 125 434 80 421 103 430 b 185 441 145 440 166 441 b 409 244 310 441 409 353 b 401 191 409 227 406 209 b 197 43 375 105 287 43 b 159 47 183 43 171 44 b 23 123 112 56 61 86 b 0 180 6 140 0 159 b 76 260 0 220 31 260 b 92 259 81 260 87 259 b 152 183 132 251 152 216 b 100 112 152 152 134 122 b 95 111 98 112 95 111 b 95 111 95 111 95 111 b 129 98 95 109 119 101 b 148 97 136 97 141 97 b 264 235 206 97 261 158 b 265 248 265 240 265 244 b 210 398 265 312 243 373 b 179 408 201 406 194 408 b 174 408 178 408 176 408 b 53 369 130 408 88 394 b 34 359 39 359 38 359 b 17 374 24 359 17 365 b 39 628 17 384 38 625 b 47 637 40 631 43 635 m 204 -1 l 205 -1 l 202 -1 l 204 -1 m 204 673 l 205 673 l 202 673 l 204 673 "
                        },
                        v6: {
                            x_min: 0,
                            x_max: 475.03125,
                            ha: 485,
                            o: "m 255 648 b 274 648 259 648 266 648 b 314 646 288 648 307 648 b 450 555 374 637 438 594 b 454 530 453 546 454 538 b 375 451 454 485 416 451 b 328 467 359 451 343 455 b 300 526 310 483 300 503 b 352 598 300 557 319 589 b 356 599 355 598 356 599 b 352 602 356 599 355 601 b 288 616 330 612 308 616 b 210 584 257 616 230 605 b 164 433 189 559 174 508 b 160 374 163 415 160 381 b 160 374 160 374 160 374 b 160 374 160 374 160 374 b 168 377 160 374 164 376 b 258 395 200 390 228 395 b 366 367 294 395 328 387 b 475 223 436 333 475 283 b 472 197 475 215 473 206 b 349 65 462 141 419 95 b 259 43 317 51 288 43 b 167 69 230 43 200 52 b 4 290 80 113 20 195 b 0 349 1 309 0 328 b 20 467 0 391 6 433 b 255 648 58 563 155 637 m 269 363 b 257 363 265 363 261 363 b 210 345 236 363 220 356 b 186 226 196 324 186 272 b 187 198 186 216 186 206 b 213 95 191 151 202 112 b 257 76 221 83 238 76 b 270 77 261 76 266 76 b 321 156 299 81 310 99 b 329 229 326 183 329 206 b 321 301 329 252 326 274 b 269 363 311 342 298 359 m 236 -1 l 238 -1 l 235 -1 l 236 -1 m 236 673 l 238 673 l 235 673 l 236 673 "
                        },
                        v7: {
                            x_min: 0,
                            x_max: 442.359375,
                            ha: 451,
                            o: "m 147 648 b 166 649 153 649 160 649 b 313 598 217 649 273 630 b 340 587 323 588 328 587 l 341 587 b 412 628 367 587 390 601 b 427 638 416 635 421 638 b 439 632 431 638 435 637 b 442 623 441 630 442 628 b 430 569 442 616 439 603 b 352 369 408 492 377 410 b 300 259 325 324 313 298 b 273 84 283 205 273 140 b 265 55 273 65 272 59 l 261 54 l 181 54 l 99 54 l 96 55 b 91 61 95 56 92 59 l 89 63 l 89 77 b 147 263 89 133 111 202 b 261 401 176 313 212 355 b 378 541 315 449 349 489 l 382 548 l 375 544 b 240 495 333 512 285 495 b 129 535 198 495 160 509 b 84 560 108 552 95 560 b 76 559 81 560 78 560 b 31 487 59 555 43 530 b 14 470 27 473 24 470 b 1 477 8 470 4 471 l 0 480 l 0 553 l 0 627 l 1 630 b 16 638 4 635 9 638 b 23 635 17 638 20 637 b 49 626 36 626 39 626 b 96 638 59 626 80 630 b 104 639 99 638 102 639 b 117 644 107 641 112 642 b 147 648 125 645 137 648 m 220 -1 l 221 -1 l 219 -1 l 220 -1 m 220 673 l 221 673 l 219 673 l 220 673 "
                        },
                        v8: {
                            x_min: 0,
                            x_max: 488.640625,
                            ha: 499,
                            o: "m 217 648 b 245 649 225 648 235 649 b 453 516 343 649 430 595 b 458 478 455 503 458 491 b 412 370 458 440 441 398 b 411 369 412 369 411 369 b 415 365 411 367 412 367 b 488 231 462 331 488 281 b 472 165 488 208 483 186 b 243 43 434 86 338 43 b 63 104 178 43 112 62 b 0 233 20 140 0 186 b 73 365 0 283 24 331 l 77 369 l 72 374 b 29 476 42 406 29 441 b 217 648 29 557 103 635 m 258 605 b 242 606 253 605 247 606 b 157 552 198 606 157 580 b 160 541 157 548 159 544 b 319 413 176 503 242 452 l 337 403 l 338 406 b 359 476 352 428 359 452 b 258 605 359 537 318 595 m 138 326 b 130 330 134 328 130 330 b 130 330 130 330 130 330 b 107 305 127 330 112 313 b 84 231 91 281 84 256 b 243 86 84 156 151 86 b 249 87 245 86 246 87 b 347 156 303 88 347 120 b 344 172 347 162 345 167 b 156 319 325 227 257 281 b 138 326 151 322 144 324 m 243 -1 l 245 -1 l 242 -1 l 243 -1 m 243 673 l 245 673 l 242 673 l 243 673 "
                        },
                        v9: {
                            x_min: 0,
                            x_max: 475.03125,
                            ha: 485,
                            o: "m 191 646 b 212 649 198 648 205 649 b 255 644 227 649 243 646 b 458 448 348 616 428 539 b 475 342 469 415 475 378 b 460 244 475 308 469 274 b 193 44 421 124 303 44 b 91 69 157 44 122 51 b 19 161 43 97 19 126 b 21 181 19 167 20 174 b 98 241 32 220 65 241 b 170 186 129 241 160 223 b 172 166 171 179 172 173 b 121 94 172 134 152 102 b 117 93 118 94 117 93 b 121 90 117 93 118 91 b 185 76 142 80 164 76 b 270 119 220 76 251 91 b 308 259 287 145 300 194 b 313 317 310 277 313 310 b 313 317 313 317 313 317 b 313 317 313 317 313 317 b 304 315 313 317 308 316 b 216 295 273 302 245 295 b 145 308 193 295 170 299 b 19 398 88 327 42 360 b 0 469 5 420 0 444 b 24 551 0 496 8 526 b 191 646 54 596 125 637 m 227 614 b 215 616 224 616 220 616 b 202 614 210 616 206 616 b 152 535 174 610 163 592 b 144 463 147 509 144 485 b 152 391 144 440 147 417 b 216 328 163 344 179 328 b 280 391 253 328 269 344 b 288 463 285 417 288 440 b 280 535 288 485 285 509 b 227 614 269 594 258 610 m 236 -1 l 238 -1 l 235 -1 l 236 -1 m 236 673 l 238 673 l 235 673 l 236 673 "
                        },
                        va: {
                            x_min: -149.71875,
                            x_max: 148.359375,
                            ha: 151,
                            o: "m -8 -1 b -1 0 -5 -1 -4 0 b 16 -11 5 0 13 -4 b 83 -186 17 -12 47 -90 l 148 -358 l 148 -363 b 127 -385 148 -376 138 -385 b 112 -378 122 -385 118 -383 b 54 -226 110 -374 114 -385 b 0 -81 24 -147 0 -81 b -55 -226 -1 -81 -25 -147 b -114 -378 -115 -385 -111 -374 b -129 -385 -119 -383 -123 -385 b -149 -363 -140 -385 -149 -376 l -149 -358 l -84 -186 b -19 -11 -49 -90 -19 -12 b -8 -1 -17 -8 -12 -4 "
                        },
                        vb: {
                            x_min: 0,
                            x_max: 428.75,
                            ha: 438,
                            o: "m 262 186 b 273 186 266 186 272 186 b 274 186 273 186 274 186 b 285 186 274 186 280 186 b 428 48 375 181 428 122 b 386 -68 428 12 416 -29 b 155 -187 329 -145 236 -187 b 12 -111 92 -187 38 -162 b 0 -51 4 -91 0 -72 b 262 186 0 58 122 179 "
                        },
                        vc: {
                            x_min: 0,
                            x_max: 447.8125,
                            ha: 457,
                            o: "m 0 86 l 0 173 l 223 173 l 447 173 l 447 86 l 447 0 l 223 0 l 0 0 l 0 86 "
                        },
                        vf: {
                            x_min: 0,
                            x_max: 370.21875,
                            ha: 378,
                            o: "m 0 0 l 0 277 l 61 277 l 122 277 l 122 0 l 122 -278 l 61 -278 l 0 -278 l 0 0 m 246 -1 l 246 277 l 308 277 l 370 277 l 370 -1 l 370 -278 l 308 -278 l 246 -278 l 246 -1 "
                        },
                        v10: {
                            x_min: 0,
                            x_max: 559.421875,
                            ha: 571,
                            o: "m 5 127 b 14 127 6 127 9 127 b 51 126 25 127 43 127 b 175 98 93 122 138 112 l 186 94 b 279 51 210 86 255 65 b 285 47 280 51 283 48 b 319 27 291 44 311 31 l 326 22 b 359 0 332 19 352 4 l 367 -6 b 371 -9 368 -6 370 -8 l 379 -15 b 387 -22 383 -18 386 -20 l 398 -30 l 411 -40 l 417 -47 l 427 -55 l 434 -61 b 441 -66 436 -62 439 -65 l 446 -72 l 453 -77 l 462 -87 b 558 -188 490 -113 549 -176 b 559 -195 559 -191 559 -194 b 548 -205 559 -201 555 -205 b 541 -204 547 -205 544 -205 b 534 -198 539 -201 536 -199 l 525 -191 b 481 -162 518 -187 490 -167 b 472 -155 477 -159 472 -156 b 468 -152 470 -155 469 -154 b 461 -149 466 -152 464 -151 b 428 -130 454 -145 441 -137 b 371 -99 413 -122 372 -99 b 363 -95 371 -99 367 -98 b 353 -91 357 -94 353 -91 b 348 -90 353 -91 352 -91 b 332 -81 343 -87 341 -86 b 27 -12 230 -37 127 -13 b 0 -5 4 -11 2 -11 b 0 58 0 -2 0 27 b 0 122 0 88 0 120 b 5 127 1 124 4 126 "
                        },
                        v11: {
                            x_min: -155.171875,
                            x_max: 153.8125,
                            ha: 157,
                            o: "m -137 353 b -130 353 -136 353 -133 353 b -112 349 -125 353 -119 352 b -100 342 -110 347 -104 344 b 0 317 -69 326 -35 317 b 111 349 38 317 76 328 b 129 353 117 352 123 353 b 153 327 142 353 153 344 b 144 302 153 320 153 317 b 27 6 93 226 50 113 b 21 -13 24 -11 24 -11 b 0 -26 17 -22 8 -26 b -24 -12 -9 -26 -19 -22 b -28 5 -24 -9 -27 -2 b -145 302 -53 117 -95 224 b -155 327 -155 317 -155 320 b -137 353 -155 340 -148 349 "
                        },
                        v18: {
                            x_min: 0,
                            x_max: 323.9375,
                            ha: 331,
                            o: "m 217 535 b 225 537 220 537 221 537 b 245 524 235 537 242 533 l 246 521 l 247 390 l 247 258 l 273 265 b 306 270 288 269 299 270 b 322 259 315 270 319 267 b 323 208 323 256 323 233 b 322 158 323 184 323 159 b 288 140 318 148 315 147 b 247 130 254 131 247 130 b 247 65 247 130 247 104 b 247 20 247 51 247 36 l 247 -88 l 273 -81 b 306 -76 289 -77 299 -76 b 318 -81 311 -76 315 -77 b 323 -123 323 -87 323 -86 l 323 -138 l 323 -154 b 318 -195 323 -191 323 -190 b 269 -210 314 -199 315 -199 b 249 -216 259 -213 250 -216 l 247 -216 l 247 -349 l 246 -483 l 245 -487 b 225 -499 242 -495 234 -499 b 206 -487 219 -499 210 -495 l 205 -483 l 205 -355 l 205 -227 l 204 -227 l 181 -233 l 138 -244 b 117 -249 127 -247 117 -249 b 115 -385 115 -249 115 -256 l 115 -523 l 114 -526 b 95 -538 110 -534 102 -538 b 74 -526 87 -538 78 -534 l 73 -523 l 73 -391 b 72 -260 73 -269 73 -260 b 72 -260 72 -260 72 -260 b 19 -273 61 -263 23 -273 b 0 -260 10 -273 4 -267 b 0 -209 0 -256 0 -256 l 0 -162 l 1 -158 b 61 -134 5 -148 5 -148 l 73 -131 l 73 -22 b 72 86 73 79 73 86 b 72 86 72 86 72 86 b 19 74 61 83 23 74 b 0 86 10 74 4 79 b 0 137 0 90 0 90 l 0 184 l 1 188 b 61 212 5 198 5 198 l 73 215 l 73 348 l 73 481 l 74 485 b 95 498 78 492 87 498 b 103 495 98 498 100 496 b 114 485 107 494 111 489 l 115 481 l 115 353 l 115 226 l 121 226 b 159 235 123 227 141 231 l 198 247 l 205 248 l 205 384 l 205 521 l 206 524 b 217 535 209 528 212 533 m 205 9 b 205 119 205 70 205 119 l 205 119 b 182 113 204 119 194 116 l 138 102 b 117 97 127 99 117 97 b 115 -12 115 97 115 91 l 115 -122 l 121 -120 b 159 -111 123 -119 141 -115 l 198 -101 l 205 -98 l 205 9 "
                        },
                        v1b: {
                            x_min: 0,
                            x_max: 559.421875,
                            ha: 571,
                            o: "m 544 204 b 548 204 545 204 547 204 b 559 194 555 204 559 199 b 559 190 559 192 559 191 b 530 156 559 188 556 184 b 462 86 510 134 481 104 b 453 76 458 81 454 77 l 446 70 l 441 65 b 434 59 439 63 436 61 l 427 54 b 409 37 426 51 416 44 b 392 23 398 29 394 26 b 387 19 389 22 387 20 b 379 13 386 19 383 16 l 371 8 l 367 5 l 359 -1 l 337 -16 b 285 -48 319 -29 298 -41 l 279 -52 b 186 -95 255 -66 210 -87 l 175 -99 b 23 -129 127 -117 68 -129 b 17 -129 20 -129 19 -129 b 1 -123 2 -129 2 -129 b 0 -49 0 -122 0 -83 b 0 4 0 -22 0 1 b 27 11 2 9 4 9 b 185 31 78 12 145 20 b 198 34 186 31 193 33 b 314 73 234 44 277 58 b 349 88 328 79 340 84 b 353 90 352 90 353 90 b 363 94 353 90 357 93 b 371 98 367 97 371 98 b 428 129 372 98 413 120 b 461 148 441 136 454 144 b 468 151 464 149 466 151 b 472 154 469 152 470 154 b 481 161 473 155 477 158 b 525 190 490 166 518 186 l 534 197 b 540 201 536 198 539 199 b 544 204 541 202 544 204 "
                        },
                        v1d: {
                            x_min: 0,
                            x_max: 619.3125,
                            ha: 632,
                            o: "m 274 184 b 307 186 285 186 296 186 b 616 22 465 186 597 116 b 619 -1 617 13 619 5 b 308 -187 619 -104 483 -187 b 0 -1 133 -187 0 -102 b 5 36 0 11 1 23 b 274 184 29 115 141 176 m 289 161 b 272 162 284 162 277 162 b 171 41 209 162 171 108 b 205 -73 171 5 182 -34 b 345 -163 243 -133 298 -163 b 436 -98 385 -163 420 -142 b 446 -43 443 -80 446 -62 b 289 161 446 47 377 147 "
                        },
                        v1e: {
                            x_min: -402.890625,
                            x_max: 401.53125,
                            ha: 410,
                            o: "m -219 173 b -213 174 -217 174 -215 174 b -202 173 -209 174 -205 173 b -114 86 -200 172 -179 151 b -28 0 -66 37 -28 0 b 40 84 -28 0 2 37 b 117 174 111 173 110 172 b 122 174 118 174 119 174 b 132 173 125 174 129 173 b 295 11 134 172 171 134 l 307 -1 l 336 34 b 374 76 366 72 368 74 b 381 77 375 77 378 77 b 401 56 392 77 401 68 b 400 48 401 54 401 51 b 223 -172 397 41 230 -166 b 210 -176 220 -174 215 -176 b 201 -174 206 -176 204 -176 b 112 -87 198 -173 178 -152 b 27 0 65 -38 27 0 b -42 -86 27 0 -4 -38 b -118 -174 -112 -174 -111 -173 b -123 -176 -119 -176 -121 -176 b -133 -174 -126 -176 -130 -174 b -296 -12 -136 -173 -172 -137 l -308 0 l -337 -34 b -375 -77 -367 -73 -370 -76 b -382 -79 -377 -79 -379 -79 b -402 -58 -393 -79 -402 -69 b -401 -49 -402 -55 -402 -52 b -224 172 -398 -43 -228 167 b -219 173 -223 172 -220 173 "
                        },
                        v1f: {
                            x_min: -340.28125,
                            x_max: 338.921875,
                            ha: 346,
                            o: "m -32 520 b -29 521 -31 520 -31 521 b -23 519 -27 521 -24 520 b -20 513 -21 517 -20 516 b -21 506 -20 512 -20 509 b -31 474 -23 502 -27 488 l -53 402 l -66 352 l -68 349 l -57 349 b -32 351 -51 349 -40 351 b 123 370 19 352 74 359 b 137 371 127 370 133 371 b 170 356 152 371 164 366 b 171 355 170 355 170 355 b 216 366 174 355 183 358 b 280 378 268 377 266 377 b 287 378 283 378 284 378 b 332 349 307 378 322 369 b 338 319 336 341 338 330 b 332 301 338 310 336 302 b 242 280 329 299 246 280 b 242 280 242 280 242 280 b 235 288 236 280 235 283 b 235 292 235 290 235 291 b 236 302 236 297 236 299 b 220 337 236 316 230 330 l 216 340 l 210 335 b 159 276 189 322 172 301 b 118 149 152 265 156 274 b 81 34 84 36 85 36 b -8 13 78 33 -4 13 b -8 13 -8 13 -8 13 b -14 20 -12 15 -14 15 b -8 44 -14 24 -12 31 b -2 66 -5 55 -2 65 b -2 66 -2 66 -2 66 l -2 66 b -43 41 -2 66 -21 55 b -114 4 -98 8 -98 8 b -144 0 -123 0 -134 0 b -242 99 -197 0 -242 43 b -242 109 -242 102 -242 105 b -212 219 -240 122 -242 116 b -185 312 -197 270 -185 312 l -185 312 b -189 312 -185 312 -186 312 b -259 312 -200 312 -227 312 b -321 310 -291 312 -310 310 b -334 312 -330 310 -334 312 b -340 319 -338 313 -340 316 b -336 326 -340 322 -338 324 b -291 337 -334 326 -314 331 l -247 347 l -210 348 b -172 348 -190 348 -172 348 b -168 363 -172 348 -171 355 b -145 442 -151 424 -145 441 b -133 452 -144 444 -140 446 l -77 489 b -32 520 -53 506 -32 520 m 57 334 b 53 335 55 335 54 335 b 44 334 50 335 49 335 b -70 316 8 326 -28 320 b -78 309 -78 316 -78 316 b -108 202 -80 305 -88 274 b -141 81 -136 112 -141 93 b -140 74 -141 79 -141 77 b -117 49 -137 59 -127 49 b -107 52 -114 49 -110 51 b 16 127 -106 54 14 126 b 42 217 16 127 42 215 b 49 241 42 222 44 229 b 73 320 53 251 73 317 b 57 334 73 327 65 333 "
                        },
                        v20: {
                            x_min: -571.671875,
                            x_max: 570.3125,
                            ha: 582,
                            o: "m -559 351 b -551 352 -556 352 -553 352 b -530 338 -543 352 -533 348 b -529 169 -530 337 -529 291 l -529 1 l -507 27 l -441 112 b -382 174 -394 169 -390 174 b -378 174 -381 174 -379 174 b -281 86 -370 174 -375 179 b -196 0 -234 37 -196 0 b -126 84 -196 0 -164 37 b -50 174 -55 173 -57 172 b -44 174 -49 174 -47 174 b -35 173 -42 174 -38 173 b 53 86 -32 172 -12 151 b 138 0 100 37 138 0 b 208 84 140 0 170 37 b 284 174 279 173 279 172 b 289 174 285 174 288 174 b 300 173 294 174 298 173 b 462 11 303 172 340 134 l 475 -1 l 503 34 b 541 76 534 72 536 74 b 548 77 544 77 545 77 b 570 56 560 77 570 68 b 567 48 570 54 568 51 b 392 -172 564 41 397 -166 b 378 -176 387 -174 382 -176 b 368 -174 375 -176 371 -176 b 280 -87 367 -173 347 -152 b 194 0 234 -38 194 0 b 126 -86 194 0 163 -38 b 49 -174 54 -174 55 -173 b 44 -176 47 -176 46 -176 b 34 -174 40 -176 36 -174 b -54 -87 31 -173 10 -152 b -140 0 -102 -38 -140 0 b -209 -86 -140 0 -171 -38 b -285 -174 -280 -174 -279 -173 b -291 -176 -287 -176 -288 -176 b -300 -174 -294 -176 -298 -174 b -464 -11 -303 -173 -374 -102 l -476 0 l -506 -37 b -539 -76 -528 -65 -537 -74 b -551 -80 -543 -79 -547 -80 b -570 -68 -558 -80 -566 -76 l -571 -65 l -571 136 b -570 340 -571 331 -571 337 b -559 351 -568 344 -564 348 "
                        },
                        v22: {
                            x_min: 0,
                            x_max: 432.828125,
                            ha: 442,
                            o: "m 209 186 b 213 187 210 187 212 187 b 216 187 215 187 216 187 b 224 174 216 186 220 180 b 420 -1 269 105 338 43 b 432 -12 431 -8 432 -9 b 421 -23 432 -15 432 -16 b 228 -180 345 -70 264 -137 b 219 -188 221 -188 221 -188 l 219 -188 b 208 -177 215 -188 215 -188 b 10 1 163 -106 93 -44 b 0 11 0 6 0 8 b 10 22 0 13 0 15 b 202 179 87 69 167 136 b 209 186 206 183 209 186 "
                        },
                        v23: {
                            x_min: 0,
                            x_max: 133.390625,
                            ha: 136,
                            o: "m 54 66 b 65 68 58 68 61 68 b 122 37 88 68 110 56 b 133 -1 130 26 133 12 b 104 -58 133 -23 123 -44 b 66 -69 92 -65 78 -69 b 10 -38 44 -69 23 -58 b 0 -1 2 -27 0 -13 b 54 66 0 30 20 61 "
                        },
                        v25: {
                            x_min: 0,
                            x_max: 318.5,
                            ha: 325,
                            o: "m 20 376 b 167 377 23 377 96 377 b 296 376 231 377 294 377 b 318 347 311 371 318 359 b 296 316 318 333 311 320 b 159 315 294 315 227 315 b 21 316 91 315 24 315 b 0 345 6 320 0 333 b 20 376 0 359 6 371 "
                        },
                        v26: {
                            x_min: -21.78125,
                            x_max: 483.1875,
                            ha: 493,
                            o: "m -8 631 b -1 632 -6 632 -4 632 b 19 620 8 632 16 628 b 20 383 20 616 20 616 l 20 148 l 21 151 b 140 199 59 183 102 199 b 206 179 164 199 187 192 l 210 176 l 210 396 l 210 617 l 212 621 b 231 632 216 628 223 632 b 250 620 239 632 247 628 b 251 383 251 616 251 616 l 251 148 l 254 151 b 370 199 291 183 332 199 b 415 191 385 199 400 197 b 483 84 458 176 483 134 b 461 0 483 58 476 29 b 332 -142 439 -40 411 -72 l 255 -215 b 231 -229 240 -229 239 -229 b 216 -223 224 -229 220 -227 b 210 -158 210 -217 210 -223 b 210 -120 210 -148 210 -136 l 210 -29 l 205 -34 b 100 -142 182 -65 159 -88 l 23 -215 b -1 -229 9 -229 6 -229 b -20 -216 -9 -229 -17 -224 l -21 -212 l -21 201 l -21 616 l -20 620 b -8 631 -17 624 -13 630 m 110 131 b 96 133 106 133 100 133 b 89 133 93 133 91 133 b 24 87 63 129 40 113 l 20 80 l 20 -37 l 20 -156 l 23 -152 b 144 81 96 -72 144 20 l 144 83 b 110 131 144 113 134 126 m 341 131 b 328 133 337 133 332 133 b 322 133 326 133 323 133 b 257 87 296 129 273 113 l 251 80 l 251 -37 l 251 -156 l 255 -152 b 375 81 328 -72 375 20 l 375 83 b 341 131 375 113 367 126 "
                        },
                        v27: {
                            x_min: 0,
                            x_max: 432.828125,
                            ha: 442,
                            o: "m 208 184 b 213 187 209 186 212 187 b 224 176 217 187 221 183 b 245 147 225 172 235 159 b 419 -1 288 90 347 38 b 431 -8 424 -4 431 -8 b 432 -12 432 -9 432 -11 b 430 -18 432 -13 432 -16 b 364 -61 424 -20 383 -47 b 225 -183 307 -102 250 -152 b 223 -187 224 -184 223 -187 b 220 -188 221 -188 220 -188 b 208 -176 216 -188 210 -184 b 187 -148 205 -173 197 -159 b 12 0 144 -90 84 -38 b 0 11 4 5 0 8 b 16 24 0 13 4 18 b 183 158 83 69 141 115 b 208 184 194 169 198 173 m 183 105 b 176 113 181 109 176 113 b 172 109 176 113 175 112 b 92 45 149 90 117 62 l 88 41 l 102 31 b 247 -105 160 -6 210 -55 l 254 -115 l 257 -112 l 269 -102 b 340 -45 287 -87 319 -61 l 344 -43 l 330 -33 b 183 105 272 6 221 54 "
                        },
                        v28: {
                            x_min: -73.5,
                            x_max: 72.140625,
                            ha: 74,
                            o: "m -72 252 l -73 254 l 0 254 l 72 254 l 70 252 b 0 -1 70 248 0 -1 b -72 252 -1 -1 -72 248 "
                        },
                        v29: {
                            x_min: -590.71875,
                            x_max: 589.359375,
                            ha: 601,
                            o: "m 175 273 b 182 274 178 273 181 274 b 202 262 190 274 198 269 b 204 158 204 259 204 259 l 204 56 l 250 112 b 303 174 296 172 298 172 b 308 174 304 174 307 174 b 318 173 313 174 317 173 b 481 11 322 172 357 134 l 494 -1 l 522 34 b 560 76 553 72 555 74 b 567 77 563 77 564 77 b 589 56 579 77 589 68 b 586 48 589 54 588 51 b 411 -172 583 41 416 -166 b 397 -176 406 -174 401 -176 b 387 -174 393 -176 390 -176 b 299 -87 386 -173 366 -152 b 213 0 253 -38 213 0 b 208 -6 213 0 210 -2 l 204 -12 l 204 -147 b 204 -210 204 -173 204 -194 b 198 -292 204 -297 204 -287 b 183 -299 194 -297 189 -299 b 164 -287 175 -299 167 -295 b 163 -174 163 -284 163 -284 l 161 -63 l 119 -117 b 65 -176 76 -170 73 -176 b 61 -176 63 -176 62 -176 b -35 -87 51 -174 57 -180 b -121 0 -83 -38 -121 0 b -190 -86 -122 0 -152 -38 b -266 -174 -261 -174 -259 -173 b -272 -176 -268 -176 -270 -176 b -281 -174 -276 -176 -280 -174 b -371 -86 -284 -173 -304 -152 b -457 0 -417 -38 -457 0 l -457 0 b -477 -26 -457 0 -470 -16 b -548 -227 -524 -88 -548 -161 b -536 -303 -548 -254 -544 -280 b -533 -317 -534 -309 -533 -313 b -553 -338 -533 -330 -541 -338 b -577 -315 -566 -338 -571 -333 b -590 -227 -586 -287 -590 -258 b -518 -9 -590 -154 -564 -77 b -465 56 -509 2 -504 8 l -402 134 b -363 174 -374 170 -371 174 b -359 174 -362 174 -360 174 b -262 86 -351 174 -356 179 b -176 0 -216 37 -176 0 b -107 84 -176 0 -145 37 b -31 174 -36 173 -38 172 b -25 174 -29 174 -28 174 b -16 173 -23 174 -19 173 b 147 11 -13 172 35 123 l 157 -1 l 160 1 l 163 4 l 163 130 b 164 260 163 256 163 258 b 175 273 166 266 170 270 "
                        },
                        v2a: {
                            x_min: -21.78125,
                            x_max: 366.140625,
                            ha: 374,
                            o: "m 276 1378 b 284 1379 279 1379 281 1379 b 306 1360 292 1379 298 1374 b 352 1247 326 1326 343 1286 b 366 1139 362 1213 366 1175 b 347 1009 366 1093 359 1049 l 344 1002 l 347 992 b 352 971 348 986 351 977 b 366 863 362 936 366 899 b 347 732 366 818 359 773 l 344 725 l 347 716 b 352 695 348 710 351 700 b 366 588 362 659 366 623 b 223 262 366 464 314 345 b 189 233 212 252 212 252 b 35 76 126 183 73 129 b -1 16 20 56 2 27 b -19 4 -4 9 -12 4 l -21 4 l -21 137 l -21 270 l -17 270 b 186 344 59 281 134 308 b 319 606 270 399 319 499 b 317 650 319 620 319 635 l 315 659 l 314 655 b 223 537 288 607 258 570 b 189 509 212 528 212 528 b 35 352 126 459 73 405 b -1 292 20 333 2 303 b -19 280 -4 285 -12 280 l -21 280 l -21 413 l -21 546 l -17 546 b 186 620 59 557 134 584 b 319 882 270 675 319 775 b 317 925 319 896 319 911 l 315 935 l 314 931 b 223 813 288 884 258 846 b 189 785 212 805 212 805 b 35 628 126 735 73 681 b -1 569 20 609 2 580 b -19 556 -4 562 -12 556 l -21 556 l -21 689 l -21 823 l -17 823 b 202 907 68 835 152 867 b 319 1157 280 968 319 1061 b 270 1338 319 1218 303 1281 b 262 1358 264 1349 262 1353 b 262 1364 262 1360 262 1363 b 276 1378 265 1371 269 1376 "
                        },
                        v2c: {
                            x_min: -597.53125,
                            x_max: 596.171875,
                            ha: 608,
                            o: "m -413 173 b -408 174 -412 174 -409 174 b -397 173 -404 174 -400 173 b -308 86 -394 172 -374 151 b -223 0 -261 37 -223 0 b -153 84 -223 0 -191 37 b -77 174 -83 173 -84 172 b -72 174 -76 174 -74 174 b -62 173 -68 174 -63 173 b 25 86 -59 172 -39 151 b 112 0 73 37 111 0 b 181 84 112 0 144 37 b 257 174 251 173 251 172 b 262 174 258 174 261 174 b 273 173 266 174 270 173 b 436 9 276 172 347 101 l 447 -1 l 477 36 b 522 79 511 79 513 79 l 522 79 b 552 51 533 79 539 73 b 596 -112 582 6 596 -51 b 567 -262 596 -161 586 -213 b 539 -322 558 -287 544 -316 b 524 -327 534 -326 529 -327 b 504 -315 515 -327 507 -323 b 503 -308 503 -312 503 -309 b 511 -285 503 -302 504 -297 b 555 -113 540 -227 555 -169 b 544 -34 555 -86 551 -59 b 522 19 540 -16 530 8 l 521 22 l 481 -26 l 405 -122 b 353 -176 366 -172 362 -176 b 349 -176 352 -176 351 -176 b 253 -87 341 -176 347 -180 b 167 0 206 -38 167 0 b 99 -86 167 0 136 -38 b 21 -174 27 -174 28 -173 b 17 -176 20 -176 19 -176 b 6 -174 13 -176 9 -174 b -81 -87 4 -173 -14 -152 b -167 0 -129 -38 -167 0 b -236 -86 -167 0 -198 -38 b -313 -174 -307 -174 -306 -173 b -318 -176 -314 -176 -315 -176 b -328 -174 -321 -176 -325 -174 b -491 -12 -330 -173 -367 -137 l -503 0 l -530 -34 b -570 -77 -562 -73 -564 -76 b -577 -79 -571 -79 -574 -79 b -597 -58 -588 -79 -597 -69 b -596 -49 -597 -55 -597 -52 b -417 172 -593 -43 -423 167 b -413 173 -417 172 -415 173 "
                        },
                        v2d: {
                            x_min: 0,
                            x_max: 438.28125,
                            ha: 447,
                            o: "m 212 190 b 219 191 213 191 216 191 b 236 176 225 191 228 190 b 419 18 277 105 341 49 b 436 5 431 13 434 11 b 438 -1 438 4 438 1 b 424 -16 438 -8 432 -13 b 356 -49 409 -20 379 -36 b 234 -180 306 -83 258 -133 b 219 -192 230 -188 224 -192 b 200 -176 213 -192 206 -187 b 9 -15 157 -102 89 -45 b 0 0 2 -12 0 -6 b 16 18 0 9 2 12 b 200 176 93 48 159 104 b 212 190 205 186 208 188 m 239 113 b 236 117 238 116 238 117 b 230 108 235 117 234 115 b 92 -15 196 58 140 8 b 88 -18 91 -16 88 -18 b 92 -20 88 -18 91 -19 b 198 -116 130 -43 166 -74 b 200 -117 200 -117 200 -117 b 201 -117 200 -117 201 -117 b 264 -43 212 -98 242 -62 b 345 15 288 -19 321 4 b 348 18 347 16 348 16 b 344 20 348 18 347 19 b 239 113 307 41 266 79 "
                        },
                        v2f: {
                            x_min: -1.359375,
                            x_max: 680.5625,
                            ha: 694,
                            o: "m 597 1042 b 604 1042 600 1042 602 1042 b 642 1002 627 1042 642 1022 b 619 966 642 988 635 974 b 439 927 574 942 503 927 l 426 927 l 426 921 b 430 838 428 893 430 866 b 345 480 430 696 398 560 b 179 391 307 423 249 391 b 156 392 171 391 164 392 b 138 394 149 394 142 394 b 103 434 115 396 103 416 b 129 471 103 451 111 466 b 141 474 133 473 137 474 b 172 459 153 474 164 469 b 181 455 175 456 176 455 b 187 456 182 455 185 455 b 253 520 212 460 234 483 b 315 836 294 605 315 714 b 311 928 315 867 314 898 b 302 945 310 943 311 942 b 245 953 283 950 262 953 b 130 891 193 953 149 931 b 84 860 119 870 102 860 b 36 905 61 860 39 877 b 36 910 36 907 36 909 b 80 970 36 931 50 949 b 249 1017 125 1000 187 1017 b 322 1009 273 1017 299 1014 l 341 1003 b 436 991 372 995 406 991 b 577 1031 495 991 545 1004 b 597 1042 583 1038 590 1041 m 416 360 b 424 360 419 360 421 360 b 481 309 454 360 479 338 b 503 145 484 280 495 199 b 585 -185 525 16 555 -106 b 630 -245 596 -213 613 -237 l 634 -247 l 638 -245 b 647 -244 641 -245 645 -244 b 680 -278 666 -244 680 -262 b 664 -308 680 -290 675 -301 b 638 -312 658 -310 650 -312 b 613 -309 631 -312 623 -310 b 477 -201 555 -303 502 -260 b 417 -2 460 -159 434 -72 b 416 5 417 1 416 5 b 416 5 416 5 416 5 b 411 -5 415 5 413 0 b 359 -97 397 -33 377 -70 b 353 -106 355 -102 353 -105 b 359 -112 353 -108 355 -109 b 409 -130 375 -123 390 -129 b 426 -134 420 -130 421 -131 b 431 -147 428 -137 431 -141 b 420 -162 431 -152 427 -159 b 382 -169 409 -166 396 -169 b 323 -155 363 -169 341 -165 l 317 -152 l 314 -155 b 62 -303 240 -240 148 -295 b 36 -305 55 -305 44 -305 b 23 -303 29 -305 24 -305 b -1 -273 6 -299 -1 -287 b 31 -240 -1 -256 10 -240 b 36 -240 32 -240 34 -240 b 42 -241 38 -241 39 -241 b 134 -204 63 -241 99 -226 b 367 288 265 -115 357 81 b 375 330 368 313 370 320 b 416 360 383 347 400 358 m 360 -359 b 379 -359 363 -359 371 -359 b 424 -360 396 -359 416 -359 b 646 -502 536 -373 624 -430 b 649 -527 649 -510 649 -519 b 530 -673 649 -578 604 -635 l 521 -677 l 529 -681 b 653 -811 592 -714 637 -762 b 660 -853 658 -827 660 -839 b 645 -911 660 -873 656 -892 b 426 -1021 608 -981 519 -1021 b 283 -989 377 -1021 328 -1011 b 235 -949 249 -972 239 -964 b 234 -936 234 -946 234 -941 b 234 -928 234 -934 234 -931 l 235 -925 l 234 -927 l 225 -934 b 87 -982 186 -966 138 -982 b 80 -982 85 -982 83 -982 b 55 -981 70 -981 58 -981 b 17 -943 32 -981 17 -964 b 54 -904 17 -921 35 -904 b 78 -914 62 -904 72 -909 l 83 -918 l 88 -918 b 190 -831 122 -918 166 -881 b 269 -506 242 -727 269 -612 b 268 -462 269 -492 269 -477 b 266 -449 266 -458 266 -452 b 265 -444 266 -445 266 -444 b 257 -446 264 -444 261 -445 b 132 -545 196 -470 152 -505 b 88 -573 122 -563 104 -573 b 39 -523 63 -573 39 -553 b 63 -476 39 -505 44 -494 b 360 -359 136 -408 235 -369 m 419 -424 b 393 -423 411 -423 406 -423 l 375 -423 l 377 -426 b 379 -439 377 -427 378 -434 b 383 -510 382 -463 383 -487 b 314 -811 383 -609 360 -710 b 266 -893 296 -850 285 -870 b 264 -898 265 -896 264 -898 l 264 -898 b 264 -898 264 -898 264 -898 b 268 -898 264 -898 266 -898 b 273 -898 270 -898 272 -898 b 300 -909 283 -898 291 -900 b 426 -957 340 -941 385 -957 b 476 -949 443 -957 460 -954 b 547 -853 522 -931 547 -893 b 485 -745 547 -816 526 -775 b 397 -707 460 -727 432 -714 b 366 -675 375 -703 366 -692 b 396 -642 366 -657 377 -645 b 530 -557 455 -637 511 -601 b 536 -527 534 -548 536 -537 b 419 -424 536 -480 490 -437 "
                        },
                        v30: {
                            x_min: -21.78125,
                            x_max: 367.5,
                            ha: 375,
                            o: "m 276 1900 b 284 1901 279 1900 281 1901 b 306 1883 291 1901 298 1896 b 367 1686 347 1825 367 1757 b 343 1558 367 1643 359 1600 l 338 1549 l 343 1537 b 367 1411 359 1497 367 1454 b 343 1282 367 1367 359 1324 l 338 1272 l 343 1261 b 367 1135 359 1221 367 1178 b 343 1007 367 1090 359 1047 l 338 996 l 343 985 b 367 859 359 945 367 902 b 343 731 367 814 359 771 l 338 720 l 343 709 b 367 582 359 667 367 626 b 289 362 367 503 340 426 b 239 312 276 345 259 330 b 29 77 152 237 76 152 b -1 18 14 54 2 30 b -19 4 -4 11 -12 4 l -21 4 l -21 133 l -20 260 l -13 262 b 98 299 17 269 62 284 b 111 305 103 302 110 305 b 167 334 123 310 156 327 b 319 595 264 391 319 491 b 313 659 319 616 318 638 b 310 667 311 664 311 667 b 307 663 310 667 308 666 b 240 588 289 637 269 614 b 16 331 141 505 62 413 b -1 294 8 316 1 302 b -19 280 -4 287 -12 280 l -21 280 l -21 408 l -20 537 l -13 538 b 98 576 17 545 62 560 b 111 581 103 578 110 581 b 167 610 123 587 156 603 b 319 871 264 667 319 767 b 313 935 319 892 318 913 b 310 942 311 941 311 942 b 307 939 310 942 308 941 b 240 864 289 913 269 889 b 16 607 141 781 62 689 b -1 570 8 592 1 578 b -19 556 -4 563 -12 556 l -21 556 l -21 684 l -20 813 l -13 814 b 98 852 17 821 62 836 b 111 857 103 855 110 857 b 167 886 123 863 156 880 b 319 1147 264 943 319 1043 b 313 1211 319 1168 318 1189 b 310 1218 311 1217 311 1218 b 307 1215 310 1218 308 1217 b 240 1140 289 1188 269 1165 b 16 884 141 1057 62 966 b -1 846 8 868 1 855 b -19 832 -4 839 -12 832 l -21 832 l -21 960 l -20 1089 l -13 1090 b 98 1128 17 1097 62 1111 b 111 1134 103 1131 110 1134 b 167 1163 123 1139 156 1156 b 319 1424 264 1220 319 1320 b 313 1486 319 1444 318 1465 b 310 1494 311 1493 311 1494 b 307 1492 310 1494 308 1493 b 240 1417 289 1464 269 1442 b 16 1160 141 1333 62 1242 b -1 1121 8 1145 1 1131 b -19 1109 -4 1115 -12 1109 l -21 1109 l -21 1236 l -20 1365 l -13 1367 b 98 1404 17 1374 62 1388 b 111 1410 103 1407 110 1410 b 250 1508 172 1437 215 1467 b 319 1701 296 1564 319 1633 b 270 1859 319 1757 303 1814 b 262 1882 265 1868 262 1875 b 276 1900 262 1890 266 1896 "
                        },
                        v31: {
                            x_min: 0,
                            x_max: 386.5625,
                            ha: 394,
                            o: "m 0 173 l 0 347 l 193 347 l 386 347 l 386 173 l 386 0 l 193 0 l 0 0 l 0 173 "
                        },
                        v33: {
                            x_min: -423.3125,
                            x_max: 421.9375,
                            ha: 431,
                            o: "m -10 276 b -2 277 -8 277 -5 277 b 17 265 5 277 13 273 b 19 163 19 260 19 260 l 19 68 l 39 45 b 277 -95 122 -34 200 -81 b 289 -97 281 -97 285 -97 b 378 0 332 -97 371 -54 b 378 11 378 4 378 6 b 302 83 378 55 345 83 b 242 66 283 83 262 77 b 208 56 231 59 219 56 b 148 120 175 56 148 81 b 200 186 148 151 164 172 b 261 198 220 194 240 198 b 420 45 341 198 411 137 b 421 22 421 37 421 29 b 257 -198 421 -86 347 -188 b 242 -198 251 -198 247 -198 b 20 -105 181 -198 95 -163 l 19 -104 l 19 -183 b 19 -216 19 -195 19 -206 b 12 -273 19 -272 17 -267 b -2 -278 8 -277 2 -278 b -21 -266 -10 -278 -19 -274 b -23 -165 -23 -263 -23 -262 l -23 -69 l -44 -47 b -250 86 -117 23 -183 66 b -295 94 -270 93 -284 94 b -315 91 -302 94 -308 94 b -381 5 -356 81 -381 43 b -355 -56 -381 -16 -372 -40 b -299 -81 -338 -73 -319 -81 b -246 -68 -283 -81 -265 -77 b -212 -58 -234 -61 -223 -58 b -168 -77 -196 -58 -179 -65 b -151 -122 -156 -90 -151 -105 b -179 -174 -151 -141 -160 -162 b -239 -195 -194 -184 -217 -192 b -257 -197 -245 -195 -250 -197 b -423 -5 -349 -197 -423 -113 b -423 0 -423 -4 -423 -1 b -277 194 -420 97 -362 173 b -247 197 -268 197 -258 197 b -24 104 -185 197 -100 162 l -23 102 l -23 181 b -21 265 -23 260 -23 260 b -10 276 -20 269 -14 274 "
                        },
                        v34: {
                            x_min: 0,
                            x_max: 622.03125,
                            ha: 635,
                            o: "m 398 417 b 406 419 401 419 404 419 b 427 398 417 419 427 409 b 427 391 427 395 427 392 b 34 -274 424 385 38 -272 b 20 -280 29 -278 25 -280 b 0 -259 9 -280 0 -270 b 0 -252 0 -256 0 -254 b 393 413 2 -247 389 410 b 398 417 394 415 397 416 m 592 417 b 600 419 594 419 597 419 b 622 398 611 419 622 409 b 620 391 622 395 620 392 b 227 -274 617 385 231 -272 b 213 -280 223 -278 219 -280 b 193 -259 202 -280 193 -270 b 194 -252 193 -256 193 -254 b 586 413 196 -247 582 410 b 592 417 588 415 590 416 "
                        },
                        v36: {
                            x_min: -1.359375,
                            x_max: 1064.390625,
                            ha: 1086,
                            o: "m 296 692 b 314 694 302 694 307 694 b 386 685 337 694 366 689 b 548 498 480 660 548 580 b 548 481 548 492 548 487 b 455 395 541 426 499 395 b 370 462 420 395 383 417 b 362 496 364 477 362 488 b 377 514 362 509 367 514 b 393 501 386 514 390 510 b 432 474 397 484 413 474 b 470 487 445 474 458 478 b 491 530 484 496 491 510 b 490 544 491 534 491 539 b 333 660 479 606 411 657 l 323 662 l 315 646 b 269 524 285 591 269 556 b 321 431 269 492 287 466 b 349 395 338 413 343 408 b 363 342 359 378 363 362 b 359 312 363 333 362 322 b 285 158 348 266 318 206 b 281 152 283 155 281 152 b 281 152 281 152 281 152 b 287 154 283 152 284 152 b 318 155 298 154 308 155 b 461 98 371 155 419 136 l 464 97 l 483 112 b 503 129 494 120 503 127 b 504 130 503 129 504 129 b 503 138 504 131 503 134 b 500 180 500 152 500 166 b 553 326 500 238 518 288 b 604 366 560 331 592 358 b 649 381 617 376 632 381 b 696 362 665 381 681 374 b 724 302 714 347 724 324 b 695 238 724 278 714 255 b 660 210 691 234 662 212 b 579 148 658 209 582 151 b 579 148 579 148 579 148 b 596 106 579 144 589 119 b 622 77 604 88 609 83 b 657 69 632 72 645 69 b 748 112 688 69 721 84 b 755 123 754 117 755 120 b 755 127 755 124 755 126 b 751 165 752 137 751 151 b 758 219 751 183 754 202 b 894 387 774 290 820 347 b 896 390 896 388 896 388 b 891 398 896 391 895 392 b 622 560 827 477 730 535 b 600 580 605 564 600 569 b 617 596 600 591 607 596 b 628 595 622 596 624 596 b 1057 248 846 552 1020 412 b 1064 191 1061 229 1064 209 b 922 0 1064 94 1005 9 b 902 -1 916 -1 909 -1 b 774 76 847 -1 800 26 b 769 83 770 81 770 83 b 769 81 769 83 769 83 b 627 -1 733 29 677 -1 b 548 27 597 -1 570 8 b 515 88 537 37 525 61 l 513 95 l 510 93 l 453 45 b 390 0 396 0 396 0 b 390 0 390 0 390 0 b 374 15 381 0 377 4 b 268 105 359 69 314 105 b 250 104 262 105 257 105 l 243 102 l 234 90 b 155 1 201 49 159 2 b 147 -1 152 0 149 -1 b 130 15 138 -1 130 6 b 132 20 130 18 132 19 b 136 31 133 22 134 27 b 220 131 149 74 178 109 b 231 137 225 134 230 136 b 302 278 280 202 302 244 b 265 335 302 299 295 309 b 209 442 234 363 213 402 b 209 455 209 446 209 451 b 279 648 209 502 232 564 l 285 659 l 283 659 b 176 627 238 653 210 645 b 57 477 111 594 66 538 b 55 459 55 471 55 464 b 72 409 55 437 61 415 b 93 403 78 405 87 403 b 152 467 123 403 151 431 b 168 488 153 483 157 488 b 185 462 181 488 185 483 l 185 460 b 137 344 183 409 168 369 b 78 322 119 328 98 322 b 13 360 50 322 25 335 b -1 426 4 380 -1 402 b 89 610 -1 488 32 559 b 296 692 147 659 210 685 m 926 348 b 921 353 924 351 922 353 b 914 348 920 353 918 351 b 823 167 857 306 823 237 b 828 124 823 154 826 138 b 890 31 837 79 862 40 b 896 31 892 31 894 31 b 956 104 916 31 940 59 b 970 191 965 129 970 159 b 966 241 970 208 969 224 b 926 348 959 277 945 313 m 627 326 b 619 326 624 326 622 326 b 598 316 611 326 604 323 b 568 215 579 288 568 255 b 568 208 568 213 568 210 b 571 183 570 195 570 184 l 571 183 b 594 201 571 183 582 191 l 634 231 b 660 259 653 247 656 248 b 664 278 662 266 664 272 b 627 326 664 299 649 320 "
                        },
                        v38: {
                            x_min: -1.359375,
                            x_max: 651.96875,
                            ha: 665,
                            o: "m 389 644 b 405 645 394 645 400 645 b 504 566 450 645 492 613 b 507 541 506 557 507 549 b 480 471 507 514 498 489 l 477 467 l 483 470 b 609 591 539 485 586 531 b 613 601 611 595 613 599 b 631 609 619 607 624 609 b 651 588 641 609 651 602 b 200 -946 651 584 204 -941 b 182 -957 197 -953 190 -957 b 163 -945 174 -957 166 -953 b 161 -939 161 -942 161 -942 b 217 -743 161 -931 170 -904 b 272 -555 247 -639 272 -555 b 272 -555 272 -555 272 -555 b 264 -560 272 -555 268 -557 b 140 -603 227 -589 182 -603 b 36 -567 102 -603 65 -592 b -1 -487 12 -548 -1 -517 b 17 -427 -1 -466 5 -445 b 103 -380 38 -395 70 -380 b 191 -433 137 -380 172 -398 b 205 -484 201 -448 205 -466 b 178 -553 205 -509 196 -535 l 175 -557 l 182 -555 b 307 -435 236 -539 284 -494 b 372 -213 308 -430 372 -215 b 372 -213 372 -213 372 -213 b 364 -219 372 -213 368 -216 b 240 -262 328 -247 283 -262 b 137 -226 202 -262 166 -249 b 99 -145 112 -206 99 -176 b 118 -84 99 -124 106 -104 b 204 -38 138 -54 171 -38 b 292 -91 238 -38 273 -56 b 306 -141 302 -106 306 -124 b 279 -212 306 -167 296 -194 l 276 -215 l 281 -213 b 408 -93 336 -198 385 -151 b 473 129 409 -88 473 127 b 473 129 473 129 473 129 b 465 122 473 129 469 126 b 341 80 428 94 383 80 b 236 115 303 80 266 91 b 200 195 213 136 200 165 b 217 256 200 217 206 238 b 304 303 239 287 272 303 b 393 249 338 303 374 285 b 406 199 402 234 406 217 b 379 129 406 173 397 148 l 377 126 l 382 127 b 509 248 436 142 485 190 b 574 470 510 254 574 469 b 574 470 574 470 574 470 b 566 464 574 470 570 467 b 442 421 529 435 484 421 b 337 458 404 421 367 433 b 300 537 313 478 300 508 b 389 644 300 585 334 635 "
                        },
                        v39: {
                            x_min: -171.5,
                            x_max: 251.8125,
                            ha: 257,
                            o: "m -8 631 b -1 632 -6 632 -4 632 b 19 620 8 632 16 628 b 20 553 20 616 20 614 b 20 491 20 503 20 491 l 20 491 b 153 535 47 501 149 535 b 174 514 167 535 174 524 b 164 496 174 508 171 501 b 92 470 164 495 132 484 l 20 445 l 20 390 b 20 363 20 378 20 370 b 20 333 20 340 20 333 l 20 333 b 153 377 47 344 149 377 b 174 356 167 377 174 367 b 164 338 174 349 171 342 b 92 312 164 338 132 326 l 20 288 l 20 219 l 20 148 l 21 151 b 137 199 59 183 99 199 b 182 191 152 199 167 197 b 251 84 227 176 251 134 b 228 0 251 58 243 29 b 100 -142 206 -40 178 -72 l 23 -215 b -1 -229 9 -229 6 -229 b -20 -216 -9 -229 -17 -224 b -21 30 -21 -212 -21 -212 b -21 273 -21 163 -21 273 b -84 252 -21 273 -50 263 b -152 230 -133 234 -145 230 b -157 231 -155 230 -156 231 b -171 252 -166 234 -171 244 b -160 270 -171 259 -167 266 b -27 316 -159 270 -93 294 l -21 319 l -21 374 b -21 431 -21 406 -21 431 b -84 409 -21 431 -50 421 b -152 388 -133 392 -145 388 b -157 390 -155 388 -156 388 b -171 409 -166 392 -171 401 b -160 428 -171 417 -167 424 b -27 474 -159 428 -93 451 l -21 476 l -21 546 b -20 620 -21 614 -21 616 b -8 631 -17 624 -13 630 m 110 131 b 96 133 106 133 100 133 b 89 133 93 133 91 133 b 24 87 63 129 40 113 l 20 80 l 20 -37 l 20 -156 l 23 -152 b 144 81 96 -72 144 20 l 144 83 b 110 131 144 113 134 126 "
                        },
                        v3b: {
                            x_min: 0,
                            x_max: 484.5625,
                            ha: 494,
                            o: "m 228 245 b 239 247 234 247 239 247 b 243 247 240 247 242 247 b 303 238 257 247 287 242 b 484 -2 417 208 484 104 b 412 -177 484 -65 461 -127 b 243 -248 363 -226 303 -248 b 6 -63 138 -248 36 -180 b 0 -1 1 -41 0 -20 b 228 245 0 127 98 240 m 255 181 b 240 183 247 183 245 183 b 232 181 238 183 235 183 b 142 152 200 180 168 170 l 138 149 l 190 97 l 242 44 l 294 97 l 345 149 l 340 152 b 255 181 315 169 284 180 m 147 -54 l 197 -1 l 147 51 l 95 104 l 91 99 b 62 -1 72 70 62 34 b 66 -43 62 -15 63 -29 b 91 -101 72 -63 80 -84 l 95 -106 l 147 -54 m 393 99 b 389 104 390 102 389 104 b 337 51 389 104 366 80 l 285 -1 l 337 -54 l 389 -106 l 393 -101 b 421 -1 412 -72 421 -36 b 393 99 421 34 412 69 m 294 -98 b 242 -45 265 -69 242 -45 b 190 -98 242 -45 219 -69 l 138 -151 l 142 -154 b 242 -184 172 -174 206 -184 b 340 -154 276 -184 311 -174 l 345 -151 l 294 -98 "
                        },
                        v3c: {
                            x_min: 0,
                            x_max: 450.53125,
                            ha: 460,
                            o: "m 189 302 b 204 303 193 302 198 303 b 303 224 250 303 292 270 b 306 199 304 216 306 208 b 279 129 306 173 296 147 l 276 126 l 281 127 b 408 249 337 142 385 190 b 412 259 409 254 412 258 b 430 267 417 265 423 267 b 450 247 441 267 450 259 b 200 -605 450 242 204 -599 b 182 -616 197 -612 190 -616 b 163 -602 174 -616 166 -610 b 161 -598 161 -601 161 -601 b 217 -402 161 -589 170 -562 b 272 -213 247 -298 272 -213 b 272 -213 272 -213 272 -213 b 264 -219 272 -213 268 -216 b 140 -262 227 -247 182 -262 b 36 -226 102 -262 65 -249 b 0 -145 12 -206 0 -176 b 17 -84 0 -124 5 -104 b 103 -38 38 -54 70 -38 b 191 -91 137 -38 172 -56 b 205 -141 201 -106 205 -124 b 178 -212 205 -167 196 -194 l 175 -215 l 182 -213 b 307 -93 236 -198 284 -151 b 372 129 308 -88 372 127 b 372 129 372 129 372 129 b 364 122 372 129 368 126 b 240 80 328 94 283 80 b 137 115 202 80 166 91 b 99 194 111 136 99 165 b 189 302 99 244 133 292 "
                        },
                        v3e: {
                            x_min: 0,
                            x_max: 406.96875,
                            ha: 415,
                            o: "m 21 183 b 28 183 24 183 25 183 b 42 181 34 183 39 183 b 127 108 47 179 47 179 b 202 41 168 72 202 41 b 279 108 204 41 238 72 b 357 177 321 145 356 176 b 375 183 363 181 370 183 b 406 151 392 183 406 169 b 404 137 406 147 405 141 b 322 62 401 131 398 129 b 251 0 284 27 251 0 b 322 -63 251 -1 284 -29 b 404 -138 398 -130 401 -133 b 406 -152 405 -142 406 -148 b 375 -184 406 -170 392 -184 b 357 -179 370 -184 363 -183 b 279 -109 356 -177 321 -147 b 202 -43 238 -73 204 -43 b 127 -109 202 -43 168 -73 b 49 -179 85 -147 50 -177 b 31 -184 43 -183 36 -184 b 0 -152 13 -184 0 -170 b 2 -138 0 -148 0 -142 b 83 -63 5 -133 8 -130 b 155 0 122 -29 155 -1 b 83 62 155 0 122 27 b 8 129 43 97 10 127 b 0 151 2 136 0 144 b 21 183 0 165 8 177 "
                        },
                        v3f: {
                            x_min: -24.5,
                            x_max: 317.140625,
                            ha: 324,
                            o: "m -24 -147 l -24 -5 l -20 -5 b -1 -19 -12 -5 -4 -11 b 58 -123 6 -43 31 -86 b 196 -278 93 -173 134 -219 b 317 -570 274 -356 317 -460 b 294 -713 317 -617 308 -666 l 289 -724 l 294 -735 b 317 -873 308 -780 317 -827 b 235 -1132 317 -963 288 -1054 b 209 -1165 228 -1140 224 -1146 b 189 -1177 204 -1172 196 -1177 b 171 -1164 182 -1177 175 -1172 b 168 -1154 170 -1161 168 -1159 b 181 -1132 168 -1149 172 -1142 b 269 -891 238 -1064 269 -975 b 269 -881 269 -886 269 -884 b 262 -814 269 -857 265 -827 b 258 -800 261 -811 259 -806 b 142 -628 240 -731 198 -667 b -8 -589 112 -606 47 -589 b -20 -589 -13 -589 -19 -589 l -24 -589 l -24 -449 l -24 -308 l -20 -308 b -1 -322 -12 -308 -4 -313 b 58 -424 6 -345 31 -388 b 194 -580 93 -476 136 -523 b 259 -660 221 -606 245 -635 b 261 -663 259 -662 261 -663 b 264 -656 262 -663 262 -660 b 269 -587 268 -632 269 -610 b 264 -521 269 -566 268 -544 b 262 -512 264 -517 262 -513 b 258 -498 261 -509 259 -503 b 142 -326 240 -428 198 -365 b -8 -287 112 -303 47 -288 b -20 -287 -13 -287 -19 -287 l -24 -287 l -24 -147 "
                        },
                        v40: {
                            x_min: -1.359375,
                            x_max: 436.921875,
                            ha: 446,
                            o: "m 213 205 b 217 205 215 205 216 205 b 234 194 224 205 234 199 b 236 187 234 194 235 190 l 245 167 l 261 129 l 270 106 b 355 -61 294 54 329 -13 b 420 -163 381 -105 402 -138 b 436 -188 435 -184 436 -184 b 436 -191 436 -190 436 -190 b 421 -206 436 -201 431 -206 l 421 -206 l 416 -206 l 405 -201 b 217 -158 347 -172 283 -158 b 31 -201 153 -158 88 -172 l 20 -206 l 14 -206 l 14 -206 b 0 -191 5 -206 0 -201 b -1 -188 0 -190 -1 -190 b 14 -163 -1 -186 0 -184 b 95 -34 36 -136 72 -77 b 166 106 119 8 148 68 l 175 129 l 183 148 l 200 188 b 213 205 205 199 208 202 "
                        },
                        v41: {
                            x_min: -1.359375,
                            x_max: 556.6875,
                            ha: 568,
                            o: "m 294 322 b 318 323 299 322 308 323 b 360 320 334 323 352 322 b 526 217 430 310 490 273 b 543 166 537 202 543 184 b 447 70 543 117 503 70 b 445 70 447 70 446 70 b 359 159 394 72 359 113 b 368 201 359 173 362 187 b 442 245 382 229 412 245 b 455 244 446 245 451 245 b 460 244 458 244 460 244 b 460 244 460 244 460 244 b 454 248 460 244 458 245 b 325 291 417 276 372 291 b 285 287 313 291 299 290 b 144 -2 183 269 144 190 b 281 -290 144 -208 179 -280 b 304 -291 289 -291 298 -291 b 524 -105 412 -291 506 -212 b 541 -84 526 -88 530 -84 b 556 -101 551 -84 556 -90 b 549 -138 556 -111 553 -122 b 334 -322 521 -237 435 -310 b 302 -324 323 -323 313 -324 b 13 -101 172 -324 54 -234 b -1 -1 4 -68 -1 -34 b 294 322 -1 161 121 303 "
                        },
                        v42: {
                            x_min: -348.4375,
                            x_max: 24.5,
                            ha: 25,
                            o: "m -330 155 b -322 156 -329 156 -326 156 b -315 156 -319 156 -317 156 b -298 147 -311 155 -308 154 b -19 30 -224 98 -122 55 l 2 26 b 24 -1 17 22 24 13 b 2 -27 24 -15 17 -23 l -19 -31 b -298 -148 -122 -56 -224 -99 b -322 -158 -313 -158 -315 -158 b -348 -131 -338 -158 -348 -145 b -344 -117 -348 -127 -347 -122 b -328 -104 -341 -112 -338 -111 b -127 -8 -269 -65 -202 -33 b -106 0 -115 -4 -106 -1 b -127 6 -106 0 -115 2 b -328 102 -202 31 -269 63 b -344 116 -338 109 -341 111 b -348 130 -347 120 -348 124 b -330 155 -348 141 -341 152 "
                        },
                        v43: {
                            x_min: -442.359375,
                            x_max: 441,
                            ha: 450,
                            o: "m -31 487 b -1 488 -21 488 -10 488 b 434 104 216 488 397 330 b 441 27 438 79 441 47 b 439 12 441 20 439 15 b 419 0 435 4 427 0 b 404 5 413 0 408 1 b 398 30 400 11 398 13 b 0 351 390 213 213 351 b -59 348 -20 351 -39 349 b -400 30 -251 324 -393 191 b -405 5 -400 13 -401 11 b -420 0 -409 1 -415 0 b -441 12 -428 0 -436 4 b -442 27 -441 15 -442 20 b -435 104 -442 47 -439 79 b -31 487 -401 316 -235 474 m -13 131 b -1 133 -9 133 -5 133 b 51 105 19 133 39 123 b 61 70 58 95 61 83 b 51 34 61 58 58 45 b -1 6 39 16 19 6 b -46 27 -17 6 -34 13 b -62 69 -57 38 -62 54 b -13 131 -62 98 -44 124 "
                        },
                        v44: {
                            x_min: -21.78125,
                            x_max: 251.8125,
                            ha: 257,
                            o: "m -8 631 b -1 632 -6 632 -4 632 b 19 620 8 632 16 628 b 20 383 20 616 20 616 l 20 148 l 21 151 b 137 199 59 183 99 199 b 182 191 152 199 167 197 b 251 84 227 176 251 134 b 228 0 251 58 243 29 b 100 -142 206 -40 178 -72 l 23 -215 b 0 -229 9 -229 6 -229 b -20 -216 -9 -229 -17 -224 l -21 -212 l -21 201 l -21 616 l -20 620 b -8 631 -17 624 -13 630 m 110 131 b 96 133 106 133 100 133 b 89 133 93 133 91 133 b 24 87 63 129 40 113 l 20 80 l 20 -37 l 20 -156 l 23 -152 b 144 81 96 -72 144 20 l 144 83 b 110 131 144 113 134 126 "
                        },
                        v45: {
                            x_min: -402.890625,
                            x_max: 401.53125,
                            ha: 410,
                            o: "m -10 273 b -4 274 -9 273 -6 274 b 16 262 4 274 12 269 b 17 158 17 259 17 259 l 17 56 l 62 112 b 117 174 110 172 110 172 b 122 174 118 174 119 174 b 132 173 125 174 129 173 b 295 11 134 172 171 134 l 307 -1 l 336 34 b 374 76 366 72 368 74 b 381 77 375 77 378 77 b 401 56 392 77 401 68 b 400 48 401 54 401 51 b 223 -172 397 41 230 -166 b 210 -176 220 -174 215 -176 b 201 -174 206 -176 204 -176 b 112 -87 198 -173 178 -152 b 27 0 65 -38 27 0 b 21 -6 27 0 24 -2 l 17 -12 l 17 -147 b 17 -210 17 -173 17 -194 b 10 -292 17 -297 16 -287 b -2 -299 6 -297 2 -299 b -21 -287 -10 -299 -19 -295 b -24 -174 -23 -284 -23 -284 l -24 -63 l -66 -117 b -121 -176 -110 -170 -114 -176 b -125 -176 -122 -176 -123 -176 b -296 -12 -134 -174 -125 -184 l -308 0 l -337 -34 b -375 -77 -367 -73 -370 -76 b -382 -79 -377 -79 -379 -79 b -402 -58 -393 -79 -402 -69 b -401 -49 -402 -55 -402 -52 b -224 170 -398 -43 -231 165 b -212 174 -221 173 -216 174 b -202 173 -208 174 -205 174 b -39 11 -200 172 -151 122 l -28 -1 l -25 1 l -24 4 l -24 130 b -23 260 -24 256 -24 258 b -10 273 -20 266 -16 270 "
                        },
                        v46: {
                            x_min: 0,
                            x_max: 627.46875,
                            ha: 640,
                            o: "m 306 190 b 314 191 308 191 311 191 b 326 184 318 191 322 190 l 336 173 b 510 52 377 127 442 80 b 515 49 513 51 515 49 b 611 16 537 40 579 24 b 627 0 624 13 627 9 b 607 -18 627 -11 624 -13 b 330 -181 490 -49 389 -109 b 314 -192 323 -190 319 -192 b 306 -191 311 -192 308 -192 b 294 -177 302 -188 302 -188 b 257 -140 287 -170 265 -148 b 19 -18 193 -84 114 -44 b 0 0 2 -13 0 -11 b 16 16 0 9 2 13 b 110 49 47 24 89 40 b 117 52 111 49 114 51 b 145 65 126 56 130 58 b 281 163 200 93 245 124 b 300 186 288 170 291 174 b 306 190 300 187 303 188 m 317 137 b 313 142 315 141 314 142 b 308 137 313 142 311 141 b 161 4 276 84 220 33 b 155 0 159 1 155 0 b 163 -4 155 0 159 -2 b 308 -138 220 -34 276 -84 b 313 -142 311 -141 313 -142 b 317 -138 314 -142 315 -141 b 464 -4 351 -84 406 -34 b 470 0 468 -2 470 0 b 464 4 470 0 468 1 b 317 137 406 33 351 84 "
                        },
                        v47: {
                            x_min: -24.5,
                            x_max: 315.78125,
                            ha: 322,
                            o: "m -24 -145 l -24 -5 l -20 -5 b 1 -26 -10 -5 -6 -9 b 175 -241 31 -86 96 -166 b 314 -548 259 -323 304 -420 b 315 -589 315 -555 315 -571 b 314 -630 315 -606 315 -623 b 298 -730 311 -664 306 -699 l 295 -742 l 296 -748 b 314 -850 304 -778 311 -813 b 315 -892 315 -857 315 -874 b 314 -932 315 -909 315 -925 b 298 -1032 311 -967 306 -1002 l 295 -1045 l 296 -1050 b 314 -1153 304 -1081 311 -1115 b 315 -1193 315 -1160 315 -1177 b 314 -1235 315 -1211 315 -1228 b 217 -1526 306 -1338 270 -1444 b 201 -1533 213 -1532 208 -1533 b 182 -1522 193 -1533 185 -1529 b 179 -1514 181 -1518 179 -1517 b 189 -1489 179 -1508 182 -1501 b 266 -1217 240 -1403 266 -1308 b 262 -1156 266 -1196 265 -1177 b 110 -907 247 -1043 190 -950 b 0 -889 87 -895 50 -889 l -1 -889 l -24 -889 l -24 -749 l -24 -610 l -20 -610 b 1 -631 -10 -610 -6 -614 b 175 -846 31 -691 96 -771 b 259 -956 213 -884 236 -914 b 265 -966 262 -961 264 -966 b 265 -966 265 -966 265 -966 b 265 -953 265 -964 265 -959 b 266 -920 266 -943 266 -932 b 262 -853 266 -898 265 -873 b 110 -605 247 -741 190 -648 b 0 -587 87 -592 50 -587 l -1 -587 l -24 -587 l -24 -448 l -24 -308 l -20 -308 b 1 -328 -10 -308 -6 -312 b 175 -544 31 -388 96 -469 b 259 -655 213 -581 236 -612 b 265 -663 262 -659 264 -663 b 265 -663 265 -663 265 -663 b 265 -650 265 -663 265 -657 b 266 -617 266 -641 266 -630 b 262 -551 266 -595 265 -570 b 110 -303 247 -438 190 -345 b 0 -284 87 -290 50 -284 l -1 -284 l -24 -284 l -24 -145 "
                        },
                        v49: {
                            x_min: 0,
                            x_max: 630.203125,
                            ha: 643,
                            o: "m 308 204 b 314 205 310 205 313 205 b 326 201 319 205 323 204 b 355 154 328 199 338 180 b 401 83 362 142 392 95 l 409 72 b 431 41 412 66 424 49 b 619 -174 498 -51 570 -134 b 630 -192 626 -180 630 -186 b 626 -202 630 -195 628 -199 b 616 -206 623 -205 620 -206 b 552 -188 608 -206 592 -202 b 310 -155 488 -169 392 -155 b 268 -156 295 -155 281 -155 b 77 -188 197 -161 126 -173 b 13 -206 35 -202 20 -206 b 9 -206 12 -206 10 -206 b 0 -191 2 -202 0 -197 b 8 -176 0 -186 2 -180 b 204 49 58 -136 138 -43 l 220 72 l 227 83 b 295 188 245 108 281 166 b 308 204 299 197 304 202 m 315 147 b 314 147 315 147 314 147 b 314 147 314 147 314 147 b 306 129 314 145 310 138 l 296 105 b 281 72 292 97 284 77 l 274 56 b 181 -123 247 -4 212 -72 l 174 -134 l 176 -133 b 314 -123 215 -127 272 -123 b 451 -133 356 -123 413 -127 l 454 -134 l 449 -123 b 353 56 417 -72 381 -4 l 347 72 b 332 105 344 77 336 97 l 322 129 b 315 147 318 138 315 145 "
                        },
                        v4a: {
                            x_min: 70.78125,
                            x_max: 378.390625,
                            ha: 315,
                            o: "m 246 373 b 254 373 249 373 251 373 b 372 324 303 373 360 351 b 378 302 377 317 378 309 b 338 251 378 278 362 255 b 328 249 334 249 332 249 b 283 294 303 249 283 270 b 288 315 283 301 284 308 b 289 319 289 317 289 319 b 289 319 289 319 289 319 b 283 320 289 320 287 320 b 270 322 279 322 274 322 b 206 288 242 322 215 308 b 206 283 206 287 206 285 b 257 223 206 267 230 238 b 284 206 272 213 277 210 b 351 90 328 173 351 130 b 340 47 351 74 348 59 b 205 -30 314 -2 264 -30 b 182 -29 198 -30 190 -30 b 84 15 147 -24 103 -5 b 70 48 74 24 70 36 b 108 99 70 70 85 94 b 121 102 112 101 117 102 b 167 56 147 102 167 80 b 159 31 167 48 164 40 l 156 26 l 157 26 b 190 20 167 22 178 20 b 220 26 201 20 212 22 b 258 65 243 34 258 51 b 257 70 258 66 258 69 b 204 126 249 94 234 109 b 114 258 148 158 114 209 b 125 302 114 273 118 288 b 246 373 147 342 193 370 "
                        },
                        v4b: {
                            x_min: 0,
                            x_max: 503.609375,
                            ha: 514,
                            o: "m 274 430 b 277 430 276 430 277 430 b 310 394 296 430 310 415 b 308 383 310 391 308 387 b 306 367 307 381 307 374 b 236 120 298 305 272 210 b 40 -273 189 -5 125 -134 b 20 -287 35 -283 27 -287 b 5 -281 14 -287 9 -285 b 0 -267 1 -277 0 -273 b 9 -242 0 -262 2 -255 b 246 395 137 -12 232 242 b 274 430 249 416 257 427 m 468 430 b 472 430 469 430 470 430 b 503 394 490 430 503 415 b 502 383 503 391 503 387 b 499 367 502 381 500 374 b 431 120 491 305 465 210 b 234 -273 382 -5 318 -134 b 213 -287 228 -283 220 -287 b 198 -281 208 -287 202 -285 b 193 -267 194 -277 193 -273 b 202 -242 193 -262 196 -255 b 439 395 330 -12 426 242 b 468 430 442 416 451 427 "
                        },
                        v4d: {
                            x_min: -311.6875,
                            x_max: 310.328125,
                            ha: 317,
                            o: "m -9 388 b -2 390 -8 390 -5 390 b 5 388 1 390 4 390 b 19 378 10 387 16 383 b 23 333 23 371 23 371 b 24 298 23 299 24 298 b 81 276 34 298 65 285 b 213 91 145 240 190 177 b 224 24 217 76 224 36 b 257 24 224 24 235 24 b 299 19 292 24 292 24 b 310 -1 306 15 310 6 b 299 -23 310 -11 306 -19 b 257 -27 292 -27 292 -27 b 224 -29 235 -27 224 -29 b 213 -95 224 -40 217 -80 b 81 -280 190 -181 145 -244 b 24 -301 65 -290 34 -301 b 23 -335 24 -301 23 -303 l 23 -340 b 17 -381 23 -374 23 -374 b -1 -391 13 -388 5 -391 b -21 -381 -9 -391 -17 -388 b -27 -340 -27 -374 -27 -374 l -27 -335 b -28 -301 -27 -303 -27 -301 b -85 -280 -38 -301 -69 -290 b -217 -95 -149 -244 -194 -181 b -228 -29 -221 -80 -228 -40 b -259 -27 -228 -29 -238 -27 b -300 -23 -294 -27 -294 -27 b -311 -2 -307 -19 -311 -11 b -294 23 -311 8 -304 19 b -259 24 -291 23 -284 24 b -228 24 -239 24 -228 24 b -217 91 -228 36 -221 76 b -85 276 -194 177 -149 240 b -28 298 -69 285 -38 298 b -27 333 -27 298 -27 299 b -27 371 -27 362 -27 369 b -9 388 -24 378 -17 385 m -27 136 b -28 247 -27 197 -28 247 b -61 216 -31 247 -53 226 b -123 33 -95 172 -121 98 l -125 24 l -76 24 l -27 24 l -27 136 m 29 242 b 24 247 27 245 24 247 b 23 136 24 247 23 197 l 23 24 l 72 24 l 121 24 l 119 33 b 29 242 115 116 77 206 m -27 -140 l -27 -27 l -76 -27 l -125 -27 l -123 -36 b -61 -220 -121 -102 -95 -176 b -28 -251 -53 -230 -31 -251 b -27 -140 -28 -251 -27 -201 m 119 -36 l 121 -27 l 72 -27 l 23 -27 l 23 -140 b 24 -251 23 -201 24 -251 b 57 -220 27 -251 49 -230 b 119 -36 91 -176 117 -102 "
                        },
                        v4e: {
                            x_min: 0,
                            x_max: 239.5625,
                            ha: 244,
                            o: "m 10 460 b 20 462 13 462 14 462 b 39 449 28 462 35 458 l 40 446 l 40 326 b 40 205 40 259 40 205 b 127 227 40 205 80 215 b 220 249 196 244 213 249 b 227 247 224 249 225 248 b 238 237 231 245 235 241 l 239 233 l 239 -106 l 239 -448 l 238 -451 b 219 -463 234 -459 225 -463 b 198 -451 210 -463 202 -459 l 197 -448 l 197 -324 b 197 -201 197 -248 197 -201 b 110 -223 196 -201 157 -210 b 17 -245 42 -240 24 -245 b 10 -242 13 -245 13 -244 b 0 -233 6 -241 2 -237 l 0 -230 l 0 108 l 0 446 l 0 449 b 10 460 2 453 6 458 m 197 22 b 197 70 197 41 197 58 b 196 116 197 113 197 116 l 196 116 b 118 97 196 116 160 106 l 40 77 l 40 -18 b 40 -112 40 -69 40 -112 l 119 -93 l 197 -73 l 197 22 "
                        },
                        v51: {
                            x_min: -1.359375,
                            x_max: 455.96875,
                            ha: 465,
                            o: "m 352 541 b 357 542 353 542 355 542 b 377 530 364 542 372 537 l 378 526 l 378 394 l 379 262 l 404 266 b 436 270 420 269 430 270 b 450 265 443 270 446 269 b 455 220 455 259 455 260 l 455 208 l 455 161 l 454 156 b 411 140 449 147 447 147 b 378 133 393 137 379 134 b 378 68 378 133 378 106 b 378 22 378 54 378 38 l 379 -87 l 404 -83 b 436 -79 420 -80 430 -79 b 450 -84 443 -79 446 -80 b 455 -129 455 -90 455 -88 l 455 -141 l 455 -188 l 454 -192 b 413 -209 449 -202 447 -202 b 382 -215 398 -212 383 -215 l 378 -215 l 378 -345 l 378 -380 b 375 -485 378 -484 378 -480 b 357 -494 371 -491 364 -494 b 340 -485 351 -494 344 -491 b 336 -383 337 -480 336 -484 l 336 -349 l 336 -223 l 334 -223 b 291 -231 334 -223 314 -227 l 247 -240 l 247 -371 l 246 -503 l 245 -506 b 225 -519 242 -514 234 -519 b 206 -506 219 -519 210 -514 l 205 -503 l 205 -376 l 205 -248 l 160 -256 l 115 -265 l 115 -396 l 115 -527 l 114 -531 b 95 -544 110 -539 102 -544 b 76 -531 87 -544 78 -539 l 73 -527 l 73 -399 b 73 -273 73 -330 73 -273 b 49 -277 73 -273 61 -274 b 17 -281 32 -280 24 -281 b 4 -276 10 -281 8 -280 b -1 -234 0 -269 -1 -272 b 0 -219 -1 -229 0 -224 l 0 -170 l 1 -167 b 10 -158 2 -163 6 -159 b 49 -149 13 -156 16 -155 l 73 -145 l 73 -34 b 73 76 73 26 73 76 b 49 72 73 76 61 74 b 17 68 32 69 24 68 b 4 73 10 68 8 69 b -1 115 0 80 -1 77 b 0 130 -1 120 0 124 l 0 179 l 1 181 b 10 191 2 186 6 190 b 49 199 13 192 16 194 l 73 204 l 73 338 b 73 374 73 352 73 365 b 77 483 73 484 73 477 b 95 492 81 489 88 492 b 111 483 100 492 107 489 b 115 378 115 477 115 483 l 115 342 b 117 212 115 223 115 212 b 204 229 117 212 200 227 l 205 229 l 205 365 l 205 502 l 206 505 b 225 517 210 513 219 517 b 245 505 234 517 242 513 l 246 502 l 247 369 l 247 237 l 249 237 b 336 254 253 238 336 254 b 337 390 336 254 337 302 l 337 526 l 338 530 b 352 541 341 535 347 539 m 336 15 b 336 126 336 102 336 126 l 336 126 b 291 117 336 126 315 122 l 247 109 l 247 -1 l 247 -112 l 249 -112 b 336 -95 253 -111 336 -95 b 336 15 336 -95 336 -56 m 205 -120 b 205 -55 205 -120 205 -93 b 205 -9 205 -41 205 -24 l 205 101 l 160 93 l 115 84 l 115 -26 b 115 -83 115 -49 115 -69 b 117 -137 115 -133 115 -137 b 205 -120 118 -137 204 -120 "
                        },
                        v52: {
                            x_min: -10.890625,
                            x_max: 298.078125,
                            ha: 294,
                            o: "m 138 473 b 142 474 140 473 141 474 b 164 459 148 474 153 470 b 191 402 183 442 191 423 b 181 353 191 388 187 371 b 178 349 179 352 178 349 b 179 348 178 348 179 348 b 185 349 181 348 182 348 b 255 376 210 355 234 363 b 272 381 264 381 266 381 b 298 355 287 381 298 370 b 288 330 298 348 298 345 b 171 34 238 254 194 141 b 166 13 168 16 168 16 b 144 1 161 5 152 1 b 121 15 134 1 125 5 b 115 33 119 18 117 24 b 0 330 91 145 49 252 b -10 355 -9 345 -10 348 b 13 381 -10 371 0 381 b 31 376 19 381 25 380 b 132 345 61 358 103 345 l 136 345 l 137 355 b 145 378 138 359 142 370 b 152 415 149 394 152 405 b 137 452 152 427 148 438 b 133 464 134 458 133 460 b 138 473 133 467 134 470 "
                        },
                        v53: {
                            x_min: 0,
                            x_max: 902.421875,
                            ha: 921,
                            o: "m 17 240 b 24 241 19 241 21 241 b 32 240 28 241 31 241 b 46 229 38 238 43 234 b 50 88 50 223 50 237 b 50 -1 50 63 50 34 b 50 -90 50 -36 50 -65 b 46 -231 50 -238 50 -224 b 25 -242 42 -238 34 -242 b 0 -224 14 -242 4 -235 b 0 2 0 -222 0 -108 b 0 223 0 112 0 220 b 17 240 2 230 9 237 m 110 240 b 118 241 111 241 114 241 b 126 240 121 241 123 241 b 142 223 133 237 140 230 b 144 123 144 220 144 205 b 144 29 144 45 144 29 b 144 29 144 29 144 29 b 393 183 166 106 264 167 b 450 186 412 184 431 186 b 756 29 600 186 732 120 b 756 29 756 29 756 29 b 758 123 758 29 758 45 b 760 227 758 226 758 223 b 784 241 766 237 774 241 b 804 229 792 241 800 237 b 809 88 808 223 809 237 l 809 -1 l 809 -90 b 804 -231 809 -238 808 -224 b 784 -242 800 -238 792 -242 b 762 -231 775 -242 766 -238 b 758 -124 756 -224 758 -231 b 756 -30 758 -47 758 -30 b 756 -30 756 -30 756 -30 b 509 -184 736 -108 637 -169 b 450 -187 488 -187 469 -187 b 144 -30 300 -187 168 -122 b 144 -30 144 -30 144 -30 b 144 -124 144 -30 144 -47 b 140 -231 144 -231 144 -224 b 118 -242 134 -238 126 -242 b 92 -224 107 -242 96 -235 b 92 2 92 -222 92 -108 b 92 223 92 112 92 220 b 110 240 95 230 102 237 m 432 161 b 413 162 426 162 420 162 b 313 41 351 162 313 109 b 347 -73 313 5 323 -34 b 487 -163 385 -133 439 -163 b 578 -97 526 -163 562 -142 b 588 -43 585 -80 588 -62 b 432 161 588 47 518 147 m 868 240 b 876 241 869 241 872 241 b 884 240 879 241 882 241 b 898 229 890 238 894 234 b 902 88 902 223 902 237 l 902 -1 l 902 -90 b 898 -231 902 -238 902 -224 b 876 -242 892 -238 884 -242 b 852 -224 865 -242 854 -235 b 850 2 850 -222 850 -108 b 852 223 850 112 850 220 b 868 240 853 230 860 237 "
                        },
                        v54: {
                            x_min: -24.5,
                            x_max: 317.140625,
                            ha: 324,
                            o: "m -24 -161 l -24 -5 l -20 -5 b 0 -24 -9 -5 -2 -12 b 171 -315 21 -124 84 -233 b 317 -660 268 -406 317 -531 b 187 -1014 317 -782 274 -909 b 161 -1034 172 -1034 171 -1034 b 141 -1013 149 -1034 141 -1025 b 152 -991 141 -1004 142 -1002 b 266 -682 228 -899 266 -788 b 174 -430 266 -588 236 -498 b -23 -317 136 -388 66 -348 b -24 -161 -23 -316 -24 -285 "
                        },
                        v55: {
                            x_min: 0,
                            x_max: 551.25,
                            ha: 563,
                            o: "m 289 644 b 304 645 294 645 299 645 b 404 566 349 645 392 613 b 406 541 405 557 406 549 b 379 471 406 514 397 489 l 377 467 l 382 470 b 509 591 438 485 485 531 b 513 601 510 595 513 599 b 530 609 518 607 524 609 b 551 588 540 609 551 602 b 200 -605 551 584 204 -599 b 182 -616 197 -612 190 -616 b 163 -602 174 -616 166 -610 b 161 -598 161 -601 161 -601 b 217 -402 161 -589 170 -562 b 272 -213 247 -298 272 -213 b 272 -213 272 -213 272 -213 b 264 -219 272 -213 268 -216 b 140 -262 227 -247 182 -262 b 36 -226 102 -262 65 -249 b 0 -145 12 -206 0 -176 b 17 -84 0 -124 5 -104 b 103 -38 38 -54 70 -38 b 191 -91 137 -38 172 -56 b 205 -141 201 -106 205 -124 b 178 -212 205 -167 196 -194 l 175 -215 l 182 -213 b 307 -93 236 -198 284 -151 b 372 129 308 -88 372 127 b 372 129 372 129 372 129 b 364 122 372 129 368 126 b 240 80 328 94 283 80 b 137 115 202 80 166 91 b 99 195 112 136 99 165 b 118 256 99 217 106 238 b 204 303 138 287 171 303 b 292 249 238 303 273 285 b 306 199 302 234 306 217 b 279 129 306 173 296 148 l 276 126 l 281 127 b 408 248 336 142 385 190 b 473 470 409 254 473 469 b 473 470 473 470 473 470 b 465 464 473 470 469 467 b 341 421 428 435 383 421 b 236 458 303 421 266 433 b 200 537 212 478 200 508 b 289 644 200 585 234 635 "
                        },
                        v58: {
                            x_min: -21.78125,
                            x_max: 367.5,
                            ha: 375,
                            o: "m 259 1553 b 265 1553 261 1553 264 1553 b 288 1540 272 1553 277 1550 b 367 1351 340 1493 367 1424 b 336 1221 367 1308 357 1263 l 332 1211 l 333 1208 b 367 1077 356 1170 367 1124 b 336 945 367 1032 357 986 l 332 935 l 333 932 b 367 800 356 893 367 848 b 336 669 367 756 357 710 l 332 659 l 333 656 b 367 523 356 617 367 571 b 345 412 367 485 360 446 b 231 273 322 356 284 310 b -1 19 121 195 27 93 b -17 4 -4 11 -10 5 l -21 4 l -21 134 l -21 265 l -17 265 b 133 291 20 265 96 278 b 318 537 245 328 318 433 b 307 603 318 559 315 582 b 303 614 304 612 304 614 b 298 609 302 614 300 613 b 231 549 281 589 258 567 b -1 295 121 471 27 369 b -17 280 -4 287 -10 281 l -21 280 l -21 410 l -21 541 l -17 541 b 133 567 20 541 96 555 b 318 813 245 605 318 709 b 307 880 318 835 315 859 b 303 891 304 888 304 891 b 298 885 302 891 300 888 b 231 825 281 866 258 843 b -1 571 121 748 27 645 b -17 556 -4 563 -10 557 l -21 556 l -21 687 l -21 817 l -17 817 b 133 843 20 817 96 830 b 318 1089 245 881 318 985 b 307 1156 318 1111 315 1134 b 303 1167 304 1164 304 1167 b 298 1161 302 1167 300 1164 b 231 1102 281 1140 258 1120 b -1 848 121 1024 27 921 b -17 832 -4 839 -10 834 l -21 832 l -21 963 l -21 1093 l -17 1093 b 114 1113 12 1093 78 1103 b 313 1314 215 1142 289 1218 b 318 1364 317 1331 318 1347 b 255 1511 318 1422 295 1478 b 243 1532 247 1519 243 1525 b 259 1553 243 1540 250 1550 "
                        },
                        v59: {
                            x_min: 0,
                            x_max: 464.140625,
                            ha: 474,
                            o: "m 0 0 l 0 347 l 76 347 l 153 347 l 153 0 l 153 -348 l 76 -348 l 0 -348 l 0 0 m 308 -1 l 308 347 l 386 347 l 464 347 l 464 -1 l 464 -348 l 386 -348 l 308 -348 l 308 -1 "
                        },
                        v5a: {
                            x_min: -171.5,
                            x_max: 170.140625,
                            ha: 174,
                            o: "m -6 566 b 0 567 -5 567 -2 567 b 14 556 6 567 12 563 b 92 285 14 555 50 433 b 170 13 166 33 170 19 b 168 13 170 13 170 13 b 161 1 168 8 167 4 l 159 0 l 122 0 l 84 0 l 81 1 b 21 195 76 5 78 -5 b -32 381 -8 297 -32 381 b -87 197 -32 381 -57 298 b -141 8 -115 94 -140 9 b -155 0 -142 2 -149 0 b -171 15 -163 0 -171 5 b -14 556 -171 18 -24 528 b -6 566 -14 560 -10 564 "
                        },
                        v5b: {
                            x_min: -441,
                            x_max: 439.640625,
                            ha: 449,
                            o: "m -428 -2 b -421 0 -427 -1 -424 0 b -406 -6 -416 0 -409 -2 b -400 -31 -401 -12 -400 -15 b -1 -352 -392 -215 -215 -352 b 58 -349 19 -352 38 -351 b 398 -31 250 -326 392 -192 b 404 -6 398 -15 400 -12 b 419 -1 408 -2 413 -1 b 439 -13 427 -1 435 -5 b 439 -29 439 -16 439 -22 b 434 -105 439 -48 438 -80 b 0 -489 397 -333 213 -489 b -68 -484 -23 -489 -44 -488 b -441 -36 -280 -452 -436 -263 b -441 -30 -441 -34 -441 -31 b -428 -2 -441 -11 -439 -5 m -13 -9 b -1 -8 -9 -8 -5 -8 b 50 -36 19 -8 39 -19 b 61 -72 57 -47 61 -59 b 50 -106 61 -84 57 -97 b -1 -134 39 -124 19 -134 b -46 -115 -17 -134 -34 -129 b -62 -72 -57 -102 -62 -87 b -13 -9 -62 -44 -44 -16 "
                        },
                        v5c: {
                            x_min: 0,
                            x_max: 447.8125,
                            ha: 457,
                            o: "m 0 -87 l 0 0 l 223 0 l 447 0 l 447 -87 l 447 -174 l 223 -174 l 0 -174 l 0 -87 "
                        },
                        v5d: {
                            x_min: -1.359375,
                            x_max: 592.078125,
                            ha: 604,
                            o: "m 280 692 b 295 694 283 692 289 694 b 310 692 300 694 307 692 b 357 630 340 684 357 657 b 336 580 357 612 351 594 b 311 538 321 566 311 549 b 352 492 311 512 330 492 b 366 495 357 492 362 492 b 397 553 390 503 397 517 b 415 603 397 576 402 591 b 460 623 427 617 443 623 b 509 599 479 623 498 614 b 522 559 518 587 522 573 b 494 506 522 538 513 519 b 451 495 481 498 473 496 b 415 488 432 495 426 494 b 394 449 404 483 394 464 b 394 448 394 448 394 448 l 394 440 l 397 433 b 428 409 404 420 413 413 b 438 408 431 408 435 408 b 479 431 450 408 462 415 b 528 455 495 448 510 455 b 548 452 534 455 541 453 b 592 391 577 442 592 416 b 549 331 592 365 577 340 b 528 327 541 328 534 327 b 479 351 510 327 495 335 b 438 374 464 367 450 374 b 417 369 431 374 424 373 b 394 333 402 360 394 348 b 400 312 394 326 396 319 b 451 287 408 294 420 288 b 513 258 484 285 499 278 b 522 223 519 247 522 234 b 461 159 522 190 496 159 b 449 161 457 159 453 159 b 397 229 416 167 397 191 b 366 288 397 265 390 278 b 352 290 362 290 357 290 b 315 262 336 290 321 280 b 311 245 313 256 311 251 b 334 204 311 233 318 220 b 355 170 348 190 351 184 b 357 152 356 166 357 159 b 355 136 357 147 356 140 b 295 88 345 104 321 88 b 232 152 264 88 232 112 b 255 204 232 174 238 186 b 279 244 273 222 279 231 l 279 245 b 238 290 279 270 259 290 b 224 288 234 290 228 290 b 193 229 200 278 193 265 b 141 161 193 191 174 167 b 129 159 137 159 133 159 b 68 223 93 159 68 190 b 77 258 68 234 70 247 b 138 287 91 278 106 285 b 185 302 166 287 175 291 b 196 333 193 312 196 323 b 174 369 196 347 187 360 b 152 374 166 373 159 374 b 111 351 140 374 126 367 b 62 327 95 335 80 327 b 51 328 58 327 54 327 b -1 391 16 334 -1 363 b 53 455 -1 420 17 449 b 62 455 57 455 59 455 b 111 431 80 455 95 448 b 152 408 127 415 140 408 b 161 409 155 408 159 408 b 193 433 176 413 186 420 l 196 440 l 196 448 b 196 451 196 449 196 449 b 190 471 196 459 194 463 b 137 495 182 489 167 495 l 134 495 l 134 495 b 68 560 95 495 68 521 b 129 623 68 596 95 623 b 144 621 134 623 138 623 b 193 553 175 614 193 589 b 224 495 193 517 200 503 b 238 492 228 492 234 492 b 279 538 259 492 279 512 b 254 580 279 549 269 566 b 232 630 239 594 232 612 b 280 692 232 657 250 684 m 307 456 b 295 458 303 458 299 458 b 230 391 258 458 230 426 b 236 360 230 381 231 371 b 295 324 249 337 272 324 b 353 360 318 324 341 337 b 360 391 357 370 360 381 b 307 456 360 421 340 451 "
                        },
                        v60: {
                            x_min: -590.71875,
                            x_max: 589.359375,
                            ha: 601,
                            o: "m -367 173 b -362 174 -366 174 -364 174 b -351 173 -357 174 -353 173 b -262 86 -348 172 -328 151 b -176 0 -216 37 -176 0 b -107 84 -176 0 -145 37 b -31 174 -36 173 -38 172 b -25 174 -29 174 -28 174 b -16 173 -23 174 -19 173 b 72 86 -13 172 6 151 b 157 0 119 37 157 0 b 227 84 159 0 189 37 b 303 174 298 173 296 172 b 308 174 304 174 307 174 b 318 173 313 174 317 173 b 481 11 322 172 357 134 l 494 -1 l 522 34 b 560 76 553 72 555 74 b 567 77 563 77 564 77 b 589 56 579 77 589 68 b 586 48 589 54 588 51 b 411 -172 583 41 416 -166 b 397 -176 406 -174 401 -176 b 387 -174 393 -176 390 -176 b 299 -87 386 -173 366 -152 b 213 0 253 -38 213 0 b 144 -86 213 0 182 -38 b 68 -174 73 -174 74 -173 b 62 -176 66 -176 65 -176 b 53 -174 59 -176 55 -174 b -35 -87 50 -173 29 -152 b -121 0 -83 -38 -121 0 b -190 -86 -122 0 -152 -38 b -266 -174 -261 -174 -259 -173 b -272 -176 -268 -176 -270 -176 b -281 -174 -276 -176 -280 -174 b -371 -86 -284 -173 -304 -152 b -457 0 -417 -38 -457 0 l -457 0 b -477 -26 -457 0 -470 -16 b -548 -227 -524 -88 -548 -161 b -536 -303 -548 -254 -544 -280 b -533 -317 -534 -309 -533 -313 b -553 -338 -533 -330 -541 -338 b -577 -315 -566 -338 -571 -333 b -590 -227 -586 -287 -590 -258 b -518 -9 -590 -154 -564 -77 b -465 56 -509 2 -504 8 l -402 134 b -367 173 -375 169 -372 172 "
                        },
                        v62: {
                            x_min: 46.28125,
                            x_max: 669.671875,
                            ha: 563,
                            o: "m 183 376 b 189 376 185 376 187 376 b 212 374 197 376 208 376 b 265 337 234 369 253 355 b 274 317 268 331 273 320 b 274 316 274 317 274 316 b 280 323 276 316 276 319 b 311 358 288 337 299 348 b 319 366 315 360 318 365 b 356 376 326 373 340 376 b 382 371 364 376 374 374 b 428 337 400 366 417 352 b 436 317 431 331 436 320 b 438 316 436 317 436 316 b 442 323 438 316 439 319 b 475 358 451 337 462 348 b 483 366 477 360 481 365 b 518 376 488 373 503 376 b 544 373 528 376 536 376 b 604 285 579 360 604 326 b 597 249 604 273 601 258 b 543 63 596 247 544 70 b 541 54 543 61 541 55 b 540 44 540 51 540 47 b 552 23 540 33 545 23 b 552 23 552 23 552 23 b 647 126 586 29 627 72 b 658 138 651 136 653 138 b 660 138 660 138 660 138 b 669 129 666 137 669 136 b 654 88 669 122 665 109 b 562 -12 631 43 602 9 l 549 -19 b 521 -27 540 -24 530 -27 b 447 30 490 -27 458 -4 b 443 58 445 38 443 48 b 450 93 443 72 446 84 b 504 278 453 97 504 272 b 507 288 506 283 506 287 b 509 298 507 292 509 295 b 491 326 509 310 502 320 b 487 327 490 327 488 327 b 479 324 484 327 483 326 b 441 270 462 316 443 288 b 435 249 441 265 436 254 b 398 127 434 248 419 195 b 362 4 379 61 362 5 b 328 -1 359 -1 362 -1 b 314 -1 323 -1 319 -1 b 302 -1 310 -1 306 -1 b 266 4 266 -1 269 -1 b 265 6 265 5 265 5 b 303 144 265 13 272 34 b 343 278 325 216 343 276 b 344 288 343 281 344 285 b 345 298 345 291 345 295 b 330 326 345 310 340 320 b 323 327 328 327 325 327 b 317 324 322 327 321 326 b 279 270 300 316 281 288 b 273 249 279 265 274 254 b 236 127 272 248 255 195 b 200 4 216 61 200 5 b 164 -1 197 -1 198 -1 b 151 -1 161 -1 156 -1 b 140 -1 147 -1 142 -1 b 103 4 104 -1 106 -1 b 103 6 103 5 103 5 b 141 144 103 13 108 34 b 181 278 161 216 179 276 b 182 288 181 281 181 285 b 183 298 182 291 183 295 b 168 324 183 310 178 320 b 160 327 166 326 163 327 b 141 320 156 327 151 324 b 69 230 112 305 85 272 b 57 215 65 217 62 215 b 55 215 57 215 55 215 b 46 224 49 215 46 217 b 59 260 46 231 50 242 b 151 363 81 306 112 341 b 161 369 155 365 160 367 b 183 376 166 371 174 374 "
                        },
                        v68: {
                            x_min: -597.53125,
                            x_max: 596.171875,
                            ha: 608,
                            o: "m -533 324 b -525 327 -530 326 -528 327 b -504 305 -514 327 -504 317 b -504 305 -504 305 -504 305 b -513 284 -504 299 -504 299 b -556 112 -541 226 -556 167 b -545 33 -556 84 -552 58 b -524 -20 -541 15 -532 -9 l -522 -23 l -491 15 l -413 111 b -355 174 -367 169 -363 174 b -351 174 -353 174 -352 174 b -254 86 -343 174 -348 179 b -168 -1 -208 37 -168 -1 b -100 84 -168 -1 -137 37 b -23 173 -28 173 -29 172 b -19 174 -21 174 -20 174 b -8 173 -14 174 -10 173 b 155 11 -5 172 43 123 l 166 -1 l 168 1 l 170 4 l 170 130 b 171 260 170 256 170 258 b 191 274 175 269 183 274 b 205 267 196 274 201 272 b 212 158 212 262 210 273 l 212 56 l 257 112 b 311 173 304 172 304 172 b 317 174 313 174 314 174 b 326 173 319 174 323 173 b 490 11 329 172 366 134 l 502 -1 l 530 34 b 568 76 560 72 563 74 b 575 77 570 77 573 77 b 596 56 586 77 596 68 b 594 48 596 54 596 51 b 417 -172 592 41 424 -166 b 405 -176 415 -174 409 -176 b 396 -174 401 -176 398 -176 b 307 -87 393 -173 372 -152 b 221 -1 259 -38 221 -1 b 216 -6 221 -1 219 -2 l 212 -12 l 212 -147 b 212 -210 212 -173 212 -194 b 205 -292 212 -297 210 -287 b 191 -299 201 -297 196 -299 b 172 -287 183 -299 175 -295 b 170 -174 171 -284 171 -284 l 170 -63 l 127 -117 b 73 -176 84 -170 80 -176 b 68 -176 72 -176 70 -176 b -27 -87 59 -174 65 -180 b -114 0 -74 -38 -112 0 b -182 -86 -114 0 -145 -38 b -258 -174 -253 -174 -253 -173 b -264 -176 -259 -176 -262 -176 b -274 -174 -268 -176 -272 -174 b -438 -11 -277 -173 -348 -102 l -449 0 l -479 -37 b -524 -80 -513 -80 -514 -80 l -524 -80 b -553 -52 -534 -80 -540 -74 b -597 109 -583 -8 -597 48 b -560 280 -597 165 -585 224 b -533 324 -548 310 -540 322 "
                        },
                        v6c: {
                            x_min: -1.359375,
                            x_max: 193.28125,
                            ha: 197,
                            o: "m 78 233 b 87 233 81 233 84 233 b 187 140 132 233 174 195 b 193 102 190 127 193 115 b 43 -113 193 22 136 -62 b 27 -119 36 -116 31 -119 b 19 -108 21 -119 19 -115 b 29 -97 19 -102 20 -101 b 102 13 73 -72 102 -27 b 92 51 102 26 98 40 l 91 54 l 84 54 b 8 104 53 54 21 74 b -1 142 1 116 -1 130 b 78 233 -1 187 31 227 "
                        },
                        v6d: {
                            x_min: -590.71875,
                            x_max: 589.359375,
                            ha: 601,
                            o: "m 544 335 b 553 337 548 337 551 337 b 575 313 563 337 570 330 b 589 226 583 285 589 256 b 517 8 589 152 563 76 b 464 -58 507 -4 503 -9 l 401 -136 b 362 -176 372 -172 370 -176 b 357 -176 360 -176 359 -176 b 261 -87 349 -174 355 -180 b 175 0 215 -38 175 0 b 106 -86 175 0 144 -38 b 29 -174 35 -174 36 -173 b 24 -176 28 -176 27 -176 b 14 -174 21 -176 17 -174 b -73 -87 12 -173 -8 -152 b -159 0 -121 -38 -159 0 b -228 -86 -160 0 -190 -38 b -304 -174 -299 -174 -298 -173 b -310 -176 -306 -176 -308 -176 b -319 -174 -314 -176 -318 -174 b -483 -12 -323 -173 -359 -137 l -495 0 l -524 -34 b -562 -77 -553 -73 -556 -76 b -568 -79 -564 -79 -566 -79 b -590 -58 -581 -79 -590 -69 b -588 -49 -590 -55 -589 -52 b -412 170 -585 -43 -417 165 b -398 174 -408 173 -402 174 b -389 173 -394 174 -392 174 b -300 86 -387 172 -366 151 b -215 -1 -254 37 -215 -1 b -145 84 -215 -1 -183 37 b -69 173 -74 173 -76 172 b -63 174 -68 174 -66 174 b -54 173 -61 174 -57 173 b 34 86 -51 172 -31 151 b 119 -1 81 37 119 -1 b 189 84 121 -1 151 37 b 265 173 259 173 258 172 b 270 174 266 174 269 174 b 280 173 274 174 279 173 b 370 84 283 172 303 151 b 455 -1 416 37 455 -1 l 455 -1 b 476 24 455 -1 469 15 b 547 226 522 87 547 159 b 534 302 547 252 543 278 b 532 317 533 308 532 313 b 544 335 532 326 536 333 "
                        },
                        v6f: {
                            x_min: -80.3125,
                            x_max: 78.9375,
                            ha: 81,
                            o: "m 63 191 b 69 192 65 192 66 192 b 77 188 72 192 76 191 b 78 183 78 187 78 186 b 74 158 78 179 77 172 l 66 115 b 9 -161 49 30 10 -158 b -10 -187 6 -172 -1 -181 b -34 -194 -17 -191 -25 -194 b -80 -147 -58 -194 -80 -174 b -80 -141 -80 -144 -80 -142 b 9 70 -80 -134 -73 -117 l 49 163 b 63 191 59 188 61 190 "
                        },
                        v70: {
                            x_min: 0,
                            x_max: 436.921875,
                            ha: 446,
                            o: "m 213 190 b 217 191 215 191 216 191 b 231 184 223 191 228 188 b 249 154 240 167 246 159 b 419 18 292 91 348 45 b 436 -1 435 11 436 8 b 424 -16 436 -9 434 -13 b 308 -87 394 -26 340 -59 b 231 -186 276 -117 257 -142 b 219 -192 228 -191 225 -192 b 198 -174 209 -192 208 -191 b 47 -33 161 -113 110 -63 b 10 -16 34 -26 17 -19 b 0 -1 2 -13 0 -9 b 17 18 0 8 1 11 b 198 173 95 48 156 101 b 213 190 206 187 208 188 "
                        },
                        v72: {
                            x_min: -423.3125,
                            x_max: 421.9375,
                            ha: 431,
                            o: "m -262 197 b -247 197 -257 197 -253 197 b -118 162 -210 197 -163 184 b 40 45 -61 134 -13 98 b 277 -95 119 -33 200 -81 b 289 -97 281 -97 285 -97 b 378 0 332 -97 371 -55 b 378 11 378 4 378 6 b 302 83 378 55 345 83 b 242 66 283 83 262 77 b 208 56 231 59 219 56 b 148 120 175 56 148 81 b 201 186 148 151 164 172 b 261 198 220 194 240 198 b 420 45 341 198 411 136 b 421 22 421 37 421 29 b 245 -199 421 -93 338 -199 b 238 -198 243 -199 240 -199 b -44 -47 148 -194 50 -141 b -250 86 -114 22 -183 66 b -295 94 -270 91 -283 94 b -315 91 -302 94 -307 94 b -381 4 -356 81 -381 43 b -355 -56 -381 -18 -372 -40 b -298 -81 -338 -73 -319 -81 b -246 -68 -283 -81 -265 -77 b -212 -58 -234 -61 -223 -58 b -178 -69 -200 -58 -189 -62 b -151 -122 -160 -81 -151 -101 b -171 -167 -151 -138 -157 -155 b -239 -195 -185 -181 -213 -192 b -257 -197 -245 -197 -250 -197 b -423 -5 -352 -197 -423 -109 b -412 65 -423 16 -419 40 b -262 197 -389 137 -329 188 "
                        },
                        v74: {
                            x_min: -206.890625,
                            x_max: 428.75,
                            ha: 438,
                            o: "m 389 -351 b 394 -351 390 -351 393 -351 b 428 -385 413 -351 428 -367 b 428 -394 428 -388 428 -391 b 394 -428 426 -406 421 -410 l 332 -473 l 269 -516 l 205 -560 l 141 -603 l 77 -648 l 13 -692 l -50 -737 l -114 -780 l -145 -802 b -171 -813 -157 -810 -163 -813 b -175 -813 -172 -813 -174 -813 b -206 -777 -194 -811 -206 -795 b -202 -760 -206 -771 -205 -766 b -87 -675 -197 -752 -206 -757 l -34 -639 l 83 -557 l 145 -514 l 209 -470 l 272 -427 b 389 -351 375 -356 381 -352 "
                        },
                        v75: {
                            x_min: -149.71875,
                            x_max: 148.359375,
                            ha: 151,
                            o: "m -137 381 b -130 383 -134 383 -133 383 b -111 371 -122 383 -114 378 b -55 224 -110 370 -85 305 b 0 80 -25 145 -1 80 b 54 224 0 80 24 145 b 112 377 114 384 110 373 b 127 384 118 381 122 384 b 148 362 138 384 148 374 l 148 356 l 83 183 b 16 9 47 88 17 11 b -1 0 12 2 5 0 b -14 5 -5 0 -10 1 b -84 183 -19 9 -13 -6 l -149 356 l -149 362 b -137 381 -149 371 -145 378 "
                        },
                        v78: {
                            x_min: 0,
                            x_max: 193.28125,
                            ha: 197,
                            o: "m 85 514 b 95 517 88 517 89 517 b 114 505 103 517 110 513 l 115 502 l 115 376 b 115 249 115 306 115 249 b 141 258 117 249 127 252 l 167 266 l 172 266 b 190 254 181 265 187 262 l 193 251 l 193 202 l 193 188 b 187 147 193 149 191 152 b 147 130 183 142 182 141 l 115 119 l 115 9 b 115 -99 115 -51 115 -99 b 141 -91 115 -99 127 -95 b 171 -81 166 -81 167 -81 l 171 -81 b 191 -94 181 -81 189 -87 b 193 -142 191 -97 193 -120 b 191 -195 193 -167 191 -194 b 125 -227 187 -205 187 -204 l 115 -230 l 115 -366 l 115 -503 l 114 -506 b 95 -519 110 -514 102 -519 b 74 -506 87 -519 78 -514 l 73 -503 l 73 -374 b 73 -245 73 -260 73 -245 b 73 -245 73 -245 73 -245 b 55 -252 72 -245 63 -249 l 32 -260 b 19 -263 27 -262 23 -263 b 4 -256 13 -263 8 -260 b 0 -215 0 -251 0 -254 b 0 -199 0 -210 0 -206 l 0 -152 l 1 -149 b 8 -140 2 -145 5 -141 b 42 -127 9 -140 24 -133 l 73 -116 l 73 -5 b 73 23 73 4 73 15 b 73 105 73 70 73 105 b 49 97 73 105 61 101 b 17 88 32 91 23 88 b 4 95 10 88 8 91 b 0 137 0 101 0 98 b 0 151 0 141 0 145 l 0 199 l 1 202 b 43 224 5 212 5 212 l 73 234 l 73 367 l 73 502 l 74 505 b 85 514 77 509 81 513 "
                        },
                        v79: {
                            x_min: -1.359375,
                            x_max: 899.703125,
                            ha: 918,
                            o: "m 307 349 b 332 351 315 351 323 351 b 443 340 367 351 408 347 b 741 47 607 306 720 195 b 744 0 743 31 744 16 b 660 -303 744 -90 713 -206 b 28 -755 534 -531 304 -695 b 14 -756 23 -755 19 -756 b -1 -741 4 -756 -1 -750 b 21 -720 -1 -731 1 -728 b 567 -56 337 -601 548 -344 b 568 -11 568 -41 568 -24 b 442 285 568 129 525 233 b 325 319 406 308 367 319 b 93 177 232 319 137 266 b 84 154 91 170 84 155 b 84 154 84 154 84 154 b 88 156 84 154 85 155 b 159 177 110 170 134 177 b 257 134 194 177 231 162 b 294 41 281 108 294 73 b 171 -97 294 -24 246 -90 b 156 -98 166 -97 161 -98 b 6 74 73 -98 6 -22 b 6 80 6 76 6 79 b 307 349 10 223 141 340 m 839 215 b 845 216 841 216 842 216 b 862 213 852 216 860 215 b 899 163 887 206 899 184 b 872 117 899 145 890 127 b 847 111 865 112 856 111 b 808 130 833 111 818 117 b 796 162 800 140 796 151 b 839 215 796 187 812 212 m 839 -112 b 845 -112 841 -112 842 -112 b 862 -115 852 -112 860 -113 b 899 -165 887 -122 899 -144 b 872 -210 899 -183 890 -201 b 847 -217 865 -215 856 -217 b 808 -198 833 -217 818 -210 b 796 -165 800 -188 796 -177 b 839 -112 796 -140 812 -116 "
                        },
                        v7a: {
                            x_min: -1.359375,
                            x_max: 386.5625,
                            ha: 394,
                            o: "m 249 535 b 257 537 251 537 253 537 b 276 524 266 537 273 533 l 277 521 l 279 419 l 279 316 l 304 323 b 337 328 319 326 330 328 b 353 316 347 328 349 324 b 355 266 355 315 355 290 b 353 215 355 241 355 217 b 319 198 349 206 347 205 b 279 187 284 190 279 188 b 279 156 279 187 279 174 b 279 136 279 151 279 144 l 279 84 l 289 87 l 330 98 b 367 105 352 102 362 105 b 378 101 372 105 375 104 b 386 61 385 95 386 94 b 386 40 386 55 386 48 l 386 -5 l 385 -8 b 374 -19 383 -12 378 -18 b 291 -40 372 -19 347 -26 b 279 -43 284 -41 279 -43 b 279 -83 279 -43 279 -59 b 279 -95 279 -87 279 -91 l 279 -145 l 304 -140 b 337 -133 321 -136 330 -133 b 349 -140 343 -133 347 -136 b 355 -181 355 -145 355 -142 l 355 -197 l 355 -210 b 349 -252 355 -249 355 -247 b 300 -269 345 -258 347 -258 b 280 -274 291 -272 281 -273 l 279 -274 l 277 -378 l 277 -483 l 276 -487 b 257 -499 273 -495 265 -499 b 238 -487 249 -499 242 -495 l 236 -483 l 236 -384 l 236 -285 l 235 -285 l 212 -291 l 170 -301 b 148 -308 159 -305 148 -306 b 147 -415 147 -308 147 -313 l 147 -523 l 145 -526 b 126 -538 141 -534 133 -538 b 106 -526 118 -538 110 -534 l 104 -523 l 104 -420 b 103 -317 104 -326 104 -317 b 103 -317 103 -317 103 -317 b 50 -330 92 -322 54 -330 b 31 -317 42 -330 35 -326 b 29 -267 29 -315 29 -315 l 29 -219 l 32 -216 b 92 -192 36 -206 36 -206 l 104 -190 l 104 -138 b 103 -87 104 -91 104 -87 b 103 -87 103 -87 103 -87 b 88 -91 103 -87 96 -88 l 49 -101 b 17 -106 32 -105 23 -106 b 6 -102 13 -106 10 -105 b -1 -62 0 -97 -1 -95 b 0 -41 -1 -56 0 -49 l 0 4 l 1 6 b 10 16 2 11 6 15 b 91 37 12 18 38 24 l 104 41 l 104 93 b 103 144 104 140 104 144 b 103 144 103 144 103 144 b 50 131 92 141 54 131 b 31 144 42 131 35 137 b 29 195 29 147 29 148 l 29 242 l 32 245 b 92 269 36 255 36 255 l 104 273 l 104 377 l 104 481 l 106 485 b 126 498 110 492 118 498 b 134 495 129 498 132 496 b 145 485 138 494 142 489 l 147 481 l 147 383 l 147 283 l 152 284 b 190 294 155 285 171 290 l 230 303 l 236 305 l 236 413 l 236 521 l 238 524 b 249 535 240 528 243 533 m 236 126 b 235 177 236 154 236 177 l 235 177 b 213 172 235 177 225 174 l 170 161 b 147 155 157 158 147 155 b 147 124 147 155 147 142 b 147 102 147 117 147 111 l 147 52 l 153 54 l 228 72 l 236 74 l 236 126 m 236 -105 b 235 -54 236 -65 236 -54 l 235 -54 b 231 -55 235 -54 234 -54 b 172 -69 227 -55 204 -62 l 149 -76 l 147 -76 l 147 -127 l 147 -179 l 152 -177 b 190 -167 155 -177 171 -173 l 230 -158 l 236 -156 l 236 -105 "
                        },
                        v7c: {
                            x_min: 0,
                            x_max: 300.8125,
                            ha: 307,
                            o: "m 49 505 b 53 506 50 505 51 506 b 70 496 58 506 62 503 b 81 485 73 492 78 488 l 96 473 l 111 459 l 122 449 l 134 438 l 182 396 l 255 330 b 292 291 292 298 292 298 l 292 290 l 292 284 l 283 270 b 209 36 234 197 209 113 b 288 -170 209 -44 235 -119 b 299 -184 295 -179 299 -181 b 300 -191 300 -187 300 -188 b 285 -206 300 -199 294 -206 b 280 -206 283 -206 281 -206 b 247 -201 270 -202 259 -201 b 176 -222 223 -201 197 -208 b 114 -340 136 -249 114 -292 b 172 -471 114 -384 134 -433 b 185 -492 182 -481 185 -487 b 181 -502 185 -496 183 -499 b 171 -508 176 -505 174 -508 b 152 -498 166 -508 160 -503 b 0 -284 65 -428 12 -352 b 0 -260 0 -278 0 -270 b 1 -238 0 -252 0 -242 b 148 -140 16 -177 73 -140 b 209 -148 167 -140 189 -142 b 215 -149 212 -148 215 -149 b 215 -149 215 -149 215 -149 l 215 -149 b 201 -136 215 -148 209 -142 l 157 -97 l 96 -41 b 17 34 21 24 17 29 b 17 37 17 36 17 36 b 17 38 17 37 17 38 b 25 56 17 44 17 44 b 110 298 81 131 110 219 b 46 474 110 367 88 431 b 38 491 40 480 38 487 b 49 505 38 498 42 502 "
                        },
                        v7d: {
                            x_min: -1.359375,
                            x_max: 436.921875,
                            ha: 446,
                            o: "m 213 205 b 217 205 215 205 216 205 b 234 194 224 205 234 199 b 236 187 234 194 235 190 l 245 167 l 261 129 l 270 106 b 355 -61 294 54 329 -13 b 420 -163 381 -105 402 -138 b 436 -188 435 -184 436 -184 b 436 -191 436 -190 436 -190 b 421 -206 436 -201 431 -206 l 421 -206 l 416 -206 l 405 -201 b 217 -158 347 -172 283 -158 b 31 -201 153 -158 88 -172 l 20 -206 l 14 -206 l 14 -206 b 0 -191 5 -206 0 -201 b -1 -188 0 -190 -1 -190 b 14 -163 -1 -186 0 -184 b 95 -34 36 -136 72 -77 b 166 106 119 8 148 68 l 175 129 l 183 148 l 200 188 b 213 205 205 199 208 202 "
                        },
                        v7f: {
                            x_min: 0,
                            x_max: 367.5,
                            ha: 375,
                            o: "m 0 124 l 0 187 l 61 187 l 122 187 l 122 138 l 122 91 l 153 61 l 183 30 l 213 61 l 243 91 l 243 138 l 243 187 l 306 187 l 367 187 l 367 124 l 367 61 l 321 61 l 274 61 l 243 30 l 213 0 l 243 -31 l 274 -62 l 321 -62 l 367 -62 l 367 -124 l 367 -188 l 306 -188 l 243 -188 l 243 -140 l 243 -93 l 213 -62 l 183 -31 l 153 -62 l 122 -93 l 122 -140 l 122 -188 l 61 -188 l 0 -188 l 0 -124 l 0 -62 l 46 -62 l 92 -62 l 123 -31 l 153 0 l 123 30 l 92 61 l 46 61 l 0 61 l 0 124 "
                        },
                        v80: {
                            x_min: 29.9375,
                            x_max: 420.578125,
                            ha: 371,
                            o: "m 115 345 b 221 347 117 345 166 347 b 411 345 306 347 409 345 b 420 330 416 342 420 335 b 415 319 420 326 419 321 b 178 118 397 303 179 118 b 178 117 178 118 178 117 b 181 117 178 117 178 117 b 189 117 182 117 185 117 b 193 117 190 117 191 117 b 247 98 215 117 232 111 b 296 75 266 83 280 76 b 302 75 299 75 300 75 b 322 91 311 75 315 79 b 322 91 322 91 322 91 b 322 91 322 91 322 91 b 319 91 322 91 321 91 b 313 90 318 90 315 90 b 283 107 300 90 288 97 b 277 126 279 114 277 121 b 319 167 277 149 295 167 b 319 167 319 167 319 167 b 362 118 347 167 362 147 b 355 82 362 108 359 96 b 311 33 349 65 340 55 b 224 1 284 12 253 1 b 194 5 213 1 204 2 b 168 18 183 8 178 11 b 110 36 151 30 130 36 b 57 15 88 36 68 29 b 47 11 54 12 51 11 b 31 20 40 11 34 13 b 29 26 31 22 29 25 b 68 66 29 36 39 45 b 285 250 73 71 281 248 b 285 250 285 250 285 250 b 231 252 285 252 261 252 b 137 250 190 252 141 250 b 93 227 122 248 110 241 b 78 220 88 222 83 220 b 66 227 74 220 70 222 b 63 234 65 229 63 231 b 85 291 63 241 69 252 b 115 345 108 342 108 344 "
                        },
                        v81: {
                            x_min: 0,
                            x_max: 428.75,
                            ha: 438,
                            o: "m 262 186 b 273 186 266 186 272 186 b 274 186 273 186 274 186 b 285 186 274 186 280 186 b 428 48 375 181 428 122 b 386 -68 428 12 416 -29 b 155 -187 329 -145 236 -187 b 12 -111 92 -187 38 -162 b 0 -51 4 -91 0 -72 b 262 186 0 58 122 179 m 366 131 b 352 134 362 133 357 134 b 219 81 321 134 269 115 b 47 -111 126 23 50 -62 b 47 -112 47 -111 47 -112 b 77 -136 47 -129 58 -136 b 264 -45 118 -136 194 -101 b 382 109 336 12 382 76 b 366 131 382 120 377 129 "
                        },
                        v83: {
                            x_min: -1.359375,
                            x_max: 847.96875,
                            ha: 865,
                            o: "m 488 1499 b 495 1500 490 1500 492 1500 b 541 1465 507 1500 521 1490 b 679 1078 622 1372 679 1210 b 677 1050 679 1068 677 1060 b 477 642 668 893 604 764 l 443 609 l 431 596 l 431 592 l 438 562 l 449 508 l 460 458 b 481 355 475 390 481 355 b 481 355 481 355 481 355 b 490 356 481 355 485 355 b 528 358 495 356 511 358 b 558 356 540 358 552 356 b 839 95 699 338 808 237 b 847 22 845 72 847 47 b 631 -303 847 -113 766 -242 b 620 -309 623 -308 620 -309 l 620 -310 b 631 -359 620 -310 626 -333 l 646 -435 l 660 -496 b 672 -588 668 -535 672 -563 b 664 -653 672 -610 669 -630 b 383 -875 630 -792 509 -875 b 201 -810 321 -875 257 -855 b 129 -680 151 -768 129 -730 b 274 -530 129 -592 200 -530 b 351 -553 300 -530 326 -538 b 412 -669 393 -582 412 -626 b 287 -805 412 -735 366 -800 l 279 -805 l 285 -809 b 383 -830 318 -823 351 -830 b 586 -718 464 -830 540 -789 b 626 -584 612 -678 626 -631 b 619 -528 626 -566 623 -548 b 612 -495 619 -526 616 -510 b 577 -324 590 -387 577 -324 b 577 -324 577 -324 577 -324 b 568 -326 575 -324 571 -324 b 528 -334 558 -328 537 -333 b 465 -338 506 -337 485 -338 b 24 -11 269 -338 87 -206 b -1 145 8 41 -1 93 b 96 442 -1 249 32 351 b 322 714 166 541 236 626 l 352 745 l 345 782 l 332 843 l 315 921 b 303 984 310 950 304 978 b 295 1082 298 1017 295 1049 b 413 1426 295 1208 336 1329 b 488 1499 436 1456 477 1496 m 549 1301 b 541 1301 547 1301 544 1301 b 411 1207 500 1301 447 1263 b 355 1004 374 1152 355 1079 b 359 942 355 984 356 963 b 371 881 362 927 363 917 l 385 818 b 392 782 389 799 392 784 l 392 782 b 434 828 393 782 424 816 b 607 1165 534 941 594 1060 b 608 1193 608 1175 608 1183 b 597 1270 608 1224 604 1254 b 549 1301 589 1286 571 1299 m 398 528 b 393 555 396 542 393 553 b 392 555 393 555 393 555 b 317 470 390 555 347 505 b 190 298 266 408 212 334 b 127 70 148 227 127 148 b 155 -77 127 19 137 -30 b 468 -303 209 -216 333 -303 b 519 -299 484 -303 502 -302 b 568 -284 541 -295 568 -287 l 568 -284 b 563 -263 568 -284 566 -274 l 534 -120 l 511 -13 l 496 61 l 480 133 b 469 187 472 176 469 187 b 468 188 469 187 469 188 b 416 162 462 188 430 172 b 337 13 364 126 337 69 b 413 -124 337 -40 363 -93 b 428 -144 424 -131 428 -137 b 428 -149 428 -145 428 -148 b 409 -166 426 -161 419 -166 b 394 -162 405 -166 400 -165 b 240 77 302 -122 240 -27 l 240 77 b 430 342 240 197 315 301 l 436 344 l 426 394 l 398 528 m 548 194 b 526 195 540 195 532 195 b 519 195 524 195 521 195 l 514 195 l 518 177 l 539 79 l 552 15 l 566 -48 l 594 -187 l 605 -240 b 612 -266 609 -254 611 -266 b 612 -266 612 -266 612 -266 b 641 -248 613 -266 630 -256 b 744 -98 692 -212 730 -156 b 751 -40 749 -79 751 -59 b 548 194 751 76 665 181 "
                        },
                        v84: {
                            x_min: 25.859375,
                            x_max: 164.6875,
                            ha: 168,
                            o: "m 34 369 b 40 370 35 370 38 370 b 59 353 49 370 50 367 b 164 40 122 254 155 158 b 164 0 164 33 164 16 b 164 -40 164 -16 164 -34 b 59 -353 155 -158 122 -254 b 40 -371 53 -366 47 -371 b 34 -370 38 -371 36 -370 b 25 -358 28 -367 25 -363 b 31 -337 25 -352 27 -347 b 92 0 72 -234 92 -117 b 31 335 92 116 72 233 b 25 356 27 345 25 352 b 34 369 25 363 28 366 "
                        },
                        v86: {
                            x_min: -571.671875,
                            x_max: 570.3125,
                            ha: 582,
                            o: "m -386 173 b -381 174 -385 174 -383 174 b -370 173 -377 174 -372 173 b -281 86 -367 172 -347 151 b -196 0 -235 37 -196 0 b -126 84 -196 0 -164 37 b -50 174 -55 173 -57 172 b -44 174 -49 174 -47 174 b -35 173 -42 174 -38 173 b 53 86 -32 172 -12 151 b 138 0 100 37 138 0 b 208 84 140 0 170 37 b 284 174 279 173 277 172 b 289 174 285 174 288 174 b 299 173 294 174 298 173 b 462 11 303 172 338 134 l 475 -1 l 503 34 b 541 76 534 72 536 74 b 548 77 544 77 545 77 b 570 56 560 77 570 68 b 567 48 570 54 568 51 b 392 -172 564 41 397 -166 b 378 -176 387 -174 382 -176 b 368 -174 374 -176 371 -176 b 280 -87 367 -173 345 -152 b 194 0 234 -38 194 0 b 125 -86 194 0 163 -38 b 49 -174 54 -174 55 -173 b 43 -176 47 -176 46 -176 b 34 -174 40 -176 36 -174 b -54 -87 31 -173 10 -152 b -140 0 -102 -38 -140 0 b -209 -86 -141 0 -171 -38 b -285 -174 -280 -174 -279 -173 b -291 -176 -287 -176 -289 -176 b -300 -174 -295 -176 -299 -174 b -464 -12 -304 -173 -340 -137 l -476 0 l -504 -34 b -543 -77 -534 -73 -537 -76 b -549 -79 -545 -79 -547 -79 b -571 -58 -562 -79 -571 -69 b -568 -49 -571 -55 -570 -52 b -392 172 -566 -43 -396 167 b -386 173 -390 172 -387 173 "
                        },
                        v8a: {
                            x_min: -170.140625,
                            x_max: 168.78125,
                            ha: 172,
                            o: "m -160 567 b -122 567 -159 567 -149 567 l -87 567 l -84 566 b -74 553 -78 563 -77 560 b -20 366 -73 551 -49 466 b 31 186 8 267 31 186 b 85 371 31 186 55 269 b 140 559 114 473 138 557 b 153 567 141 564 148 567 b 168 559 159 567 166 564 b 168 555 168 557 168 557 b 92 281 168 548 159 513 b 14 13 50 134 14 13 b 0 0 14 6 6 0 b -17 15 -8 0 -17 8 b -93 283 -17 15 -51 136 b -170 552 -166 533 -170 548 b -170 553 -170 552 -170 552 b -160 567 -170 560 -167 564 "
                        },
                        v8b: {
                            x_min: 0,
                            x_max: 319.859375,
                            ha: 326,
                            o: "m 149 508 b 159 509 152 509 155 509 b 186 494 170 509 181 503 b 190 440 190 487 190 488 l 190 430 l 190 377 l 242 377 l 251 377 b 303 373 298 377 296 377 b 319 345 314 367 319 356 b 304 319 319 335 314 324 b 250 315 296 315 299 315 l 242 315 l 190 315 l 190 262 l 190 252 b 186 198 190 204 190 205 b 159 183 179 188 170 183 b 132 198 148 183 138 188 b 127 252 127 205 127 204 l 127 262 l 127 315 l 76 315 l 68 315 b 14 319 20 315 21 315 b 0 347 4 324 0 335 b 14 373 0 356 4 367 b 68 377 21 377 20 377 l 76 377 l 127 377 l 127 430 l 127 440 b 132 494 127 488 127 487 b 149 508 136 501 142 505 "
                        },
                        v8c: {
                            x_min: -330.75,
                            x_max: 329.390625,
                            ha: 336,
                            o: "m -133 483 b -117 484 -127 484 -122 484 b 31 373 -51 484 9 440 b 35 348 34 365 35 356 b -25 285 35 313 10 285 b -87 331 -55 285 -76 302 b -167 402 -100 376 -133 402 b -191 398 -175 402 -183 401 b -227 341 -215 388 -227 369 b -225 320 -227 334 -227 327 b -13 74 -209 230 -125 133 b 6 65 -4 70 5 66 l 9 63 l 10 65 b 117 231 12 68 40 112 l 189 341 l 242 424 b 268 460 262 456 264 458 b 283 464 273 463 277 464 b 308 438 296 464 308 453 l 308 437 b 287 396 308 430 308 428 l 95 98 l 59 43 l 58 41 l 65 37 b 253 -156 151 -8 217 -77 b 281 -285 272 -199 281 -244 b 148 -481 281 -381 231 -463 b 115 -485 137 -484 126 -485 b -32 -376 51 -485 -9 -442 b -36 -349 -35 -366 -36 -358 b 25 -287 -36 -315 -12 -287 b 85 -333 54 -287 74 -302 b 166 -403 99 -377 133 -403 b 190 -399 174 -403 182 -402 b 225 -342 215 -390 225 -370 b 224 -322 225 -335 225 -328 b 12 -76 208 -231 125 -134 b -8 -66 2 -72 -6 -68 l -10 -65 l -12 -66 b -118 -231 -13 -68 -42 -113 l -190 -342 l -243 -426 b -269 -462 -264 -458 -265 -458 b -284 -466 -274 -464 -279 -466 b -310 -440 -298 -466 -310 -455 l -310 -438 b -288 -398 -310 -430 -308 -430 l -96 -99 l -59 -44 l -59 -43 l -66 -38 b -281 284 -198 33 -281 158 l -281 284 b -133 483 -281 392 -220 474 m 254 177 b 266 179 258 177 262 179 b 319 149 287 179 307 167 b 329 115 326 140 329 127 b 319 79 329 102 326 90 b 268 51 307 61 287 51 b 221 72 250 51 234 58 b 205 115 210 84 205 99 b 254 177 205 142 223 170 m -281 -54 b -269 -52 -277 -52 -273 -52 b -223 -73 -253 -52 -235 -59 b -206 -116 -212 -84 -206 -101 b -216 -151 -206 -129 -209 -141 b -269 -179 -228 -170 -249 -179 b -314 -159 -285 -179 -302 -173 b -330 -116 -325 -147 -330 -131 b -281 -54 -330 -88 -313 -61 "
                        },
                        v8d: {
                            x_min: -1.359375,
                            x_max: 255.890625,
                            ha: 261,
                            o: "m 118 514 b 127 517 121 517 122 517 b 147 505 136 517 142 513 l 148 502 l 148 403 b 148 306 148 351 148 306 b 174 315 149 306 160 310 l 200 324 l 205 323 b 223 312 213 323 220 319 l 225 308 l 225 260 b 225 245 225 255 225 249 b 220 204 225 208 224 209 b 179 188 216 199 215 199 l 148 177 l 148 124 l 148 70 l 189 84 b 236 98 219 94 230 98 b 247 94 240 98 243 97 b 255 52 254 88 255 87 b 255 33 255 47 255 40 l 254 -12 l 253 -15 b 249 -22 253 -18 250 -20 l 245 -24 l 196 -41 l 148 -58 l 148 -108 b 148 -158 148 -136 148 -158 b 174 -148 148 -158 160 -154 b 204 -140 198 -140 200 -140 l 204 -140 b 224 -152 213 -140 221 -145 b 225 -201 224 -155 225 -177 b 224 -254 225 -226 224 -251 b 157 -284 220 -262 220 -262 l 148 -288 l 148 -395 l 148 -503 l 147 -506 b 127 -519 142 -514 134 -519 b 107 -506 119 -519 111 -514 l 106 -503 l 106 -403 b 106 -303 106 -316 106 -303 b 104 -303 104 -303 104 -303 b 88 -310 104 -303 96 -306 l 63 -319 b 51 -322 59 -320 55 -322 b 36 -315 46 -322 40 -319 b 31 -273 32 -309 31 -312 b 31 -258 31 -269 31 -263 l 31 -210 l 34 -206 b 40 -198 35 -204 38 -199 b 74 -186 42 -197 57 -191 l 106 -173 l 106 -123 b 106 -97 106 -112 106 -104 b 106 -72 106 -76 106 -72 b 104 -72 106 -72 106 -72 b 20 -99 89 -79 23 -99 b 0 -84 10 -99 2 -93 b -1 -37 0 -81 -1 -59 b 0 11 -1 -15 0 9 b 58 40 4 22 2 22 l 106 56 l 106 109 b 106 123 106 115 106 119 b 106 162 106 147 106 162 b 81 155 106 162 93 159 b 50 147 65 149 55 147 b 36 152 43 147 40 148 b 31 194 32 158 31 156 b 31 209 31 198 31 204 l 31 256 l 34 260 b 76 281 38 269 38 269 l 106 292 l 106 396 l 106 502 l 107 505 b 118 514 110 509 114 513 "
                        },
                        v8f: {
                            x_min: -21.78125,
                            x_max: 362.0625,
                            ha: 369,
                            o: "m 302 1031 b 308 1032 304 1032 307 1032 b 330 1016 318 1032 325 1027 b 362 867 351 970 362 920 b 340 738 362 824 353 780 l 336 727 l 340 717 b 362 591 355 677 362 634 b 257 323 362 496 325 401 b 204 272 243 306 227 290 b 20 56 129 206 66 133 b -1 18 12 44 0 22 b -19 4 -4 9 -12 4 l -21 4 l -21 140 l -21 276 l -12 277 b 167 333 61 288 127 309 b 319 598 262 388 319 491 b 311 664 319 620 317 642 l 310 673 l 304 664 b 204 548 279 620 250 587 b 20 333 129 483 66 409 b -1 292 12 320 0 298 b -19 280 -4 285 -12 280 l -21 280 l -21 416 l -21 552 l -12 553 b 167 609 61 564 127 585 b 319 874 264 666 319 770 b 294 992 319 914 311 954 b 288 1011 288 1004 288 1007 b 302 1031 288 1021 294 1028 "
                        },
                        v90: {
                            x_min: -171.5,
                            x_max: 483.1875,
                            ha: 493,
                            o: "m -8 631 b -1 632 -6 632 -4 632 b 19 620 8 632 16 628 b 20 495 20 616 20 616 b 20 373 20 427 20 373 b 115 410 20 373 63 390 l 210 448 l 210 531 b 212 620 210 614 210 616 b 231 632 215 628 223 632 b 246 627 236 632 242 631 b 251 541 251 620 251 628 l 251 463 l 315 489 b 387 514 368 509 381 514 b 393 513 390 514 392 514 b 406 494 402 510 406 502 b 397 476 406 487 404 480 b 323 446 396 474 363 462 l 251 417 l 251 283 l 251 148 l 254 151 b 370 199 291 183 332 199 b 415 191 385 199 400 197 b 483 84 458 176 483 134 b 461 0 483 58 476 29 b 332 -142 439 -40 411 -72 l 255 -215 b 231 -229 240 -229 239 -229 b 216 -223 224 -229 220 -227 b 210 -158 210 -217 210 -223 b 210 -120 210 -148 210 -136 l 210 -29 l 205 -34 b 100 -142 182 -65 159 -88 l 23 -215 b -1 -229 9 -229 6 -229 b -19 -217 -9 -229 -16 -224 l -20 -215 l -21 48 l -21 310 l -83 287 b -152 262 -133 266 -145 262 b -157 263 -153 262 -155 262 b -171 283 -166 266 -171 274 b -161 301 -171 290 -167 297 b -91 328 -160 302 -129 315 l -21 356 l -21 487 l -20 617 l -19 621 b -8 631 -17 626 -12 630 m 210 288 b 210 401 210 351 210 401 b 114 365 209 401 167 384 l 20 327 l 20 238 l 20 148 l 21 151 b 140 199 59 183 102 199 b 206 180 164 199 187 192 l 209 177 b 209 177 209 177 209 177 b 210 288 210 177 210 199 m 110 131 b 96 133 106 133 100 133 b 89 133 93 133 91 133 b 24 87 63 129 40 113 l 20 80 l 20 -37 l 20 -156 l 23 -152 b 144 81 96 -72 144 20 l 144 83 b 110 131 144 113 134 126 m 341 131 b 328 133 337 133 332 133 b 322 133 326 133 323 133 b 257 87 296 129 273 113 l 251 80 l 251 -37 l 251 -156 l 255 -152 b 375 81 328 -72 375 20 l 375 83 b 341 131 375 113 367 126 "
                        },
                        v92: {
                            x_min: 0,
                            x_max: 598.890625,
                            ha: 611,
                            o: "m 62 181 b 77 183 66 183 72 183 b 91 181 83 183 88 183 b 202 131 100 180 106 177 l 299 87 l 394 131 b 517 183 499 181 502 183 b 519 183 517 183 518 183 b 598 104 567 183 598 144 b 577 49 598 84 592 65 b 518 15 567 38 563 37 b 484 0 499 6 484 0 b 518 -16 484 -1 499 -8 b 577 -51 563 -38 567 -40 b 598 -105 592 -66 598 -86 b 519 -184 598 -145 567 -184 b 517 -184 518 -184 517 -184 b 394 -133 502 -184 499 -183 l 299 -88 l 202 -133 b 81 -184 99 -183 95 -184 b 77 -184 80 -184 78 -184 b 0 -105 29 -184 0 -145 b 20 -51 0 -86 5 -66 b 80 -16 29 -40 34 -38 b 114 -1 98 -8 114 -1 b 80 15 114 0 98 6 b 20 49 34 37 29 38 b 0 104 6 65 0 84 b 62 181 0 140 23 174 m 88 134 b 74 136 85 134 80 136 b 68 134 72 136 69 136 b 46 104 54 130 46 117 b 55 81 46 95 49 88 b 149 34 59 76 53 80 b 224 -1 190 15 224 0 b 144 -38 224 -1 187 -18 b 54 -84 59 -79 58 -79 b 46 -105 49 -90 46 -98 b 76 -137 46 -122 58 -137 b 78 -137 77 -137 77 -137 b 194 -86 87 -137 76 -141 b 298 -36 250 -58 298 -36 b 298 -36 298 -36 298 -36 b 402 -84 299 -36 345 -58 b 518 -137 522 -141 510 -137 b 521 -137 519 -137 519 -137 b 551 -105 539 -137 551 -122 b 541 -83 551 -98 548 -90 b 447 -36 537 -77 544 -81 b 374 -1 406 -16 374 -1 b 447 34 374 0 406 15 b 541 81 544 80 537 76 b 551 104 548 88 551 97 b 521 136 551 120 539 136 b 518 136 519 136 519 136 b 517 136 518 136 517 136 l 517 136 b 402 83 511 136 511 136 b 298 34 345 56 299 34 b 298 34 298 34 298 34 b 194 84 298 34 250 56 b 88 134 137 111 89 133 "
                        },
                        v93: {
                            x_min: 0,
                            x_max: 438.28125,
                            ha: 447,
                            o: "m 212 205 b 219 205 213 205 216 205 b 239 183 228 205 231 204 b 421 -163 298 40 363 -83 b 438 -191 434 -180 438 -186 b 436 -197 438 -192 438 -195 b 424 -206 434 -204 431 -206 b 406 -201 420 -206 415 -205 b 216 -156 347 -172 281 -156 b 23 -205 148 -156 80 -173 b 14 -206 20 -206 17 -206 b 0 -191 6 -206 0 -201 b 6 -176 0 -187 1 -183 b 202 192 63 -104 142 45 b 212 205 205 199 208 202 m 264 48 l 249 81 l 243 94 l 242 91 b 89 -126 208 36 137 -66 b 81 -138 85 -133 81 -138 b 81 -138 81 -138 81 -138 b 81 -138 81 -138 81 -138 b 95 -133 81 -138 87 -136 b 280 -94 156 -108 221 -94 b 334 -98 299 -94 317 -95 b 343 -99 338 -99 343 -99 b 343 -99 343 -99 343 -99 b 338 -94 343 -99 341 -97 b 264 48 318 -58 287 1 "
                        },
                        v94: {
                            x_min: -149.71875,
                            x_max: 148.359375,
                            ha: 151,
                            o: "m -9 215 b 0 217 -6 217 -4 217 b 19 205 8 217 14 213 b 20 142 20 202 20 201 l 20 84 l 23 84 b 144 -27 81 74 129 30 b 148 -66 147 -40 148 -54 b 36 -213 148 -134 103 -197 b 0 -219 24 -217 12 -219 b -145 -104 -68 -219 -129 -173 b -149 -68 -148 -91 -149 -79 b -24 84 -149 6 -98 74 l -21 84 l -21 142 b -19 205 -20 201 -20 202 b -9 215 -17 209 -13 213 m -21 -15 b -23 41 -21 37 -21 41 b -23 41 -23 41 -23 41 b -76 11 -35 40 -62 26 b -108 -65 -98 -11 -108 -38 b -1 -176 -108 -122 -65 -176 b 107 -65 63 -176 107 -122 b 74 11 107 -38 96 -11 b 20 41 61 26 32 41 b 20 -15 20 41 20 15 b 19 -74 20 -72 20 -72 b 0 -87 14 -83 6 -87 b -19 -74 -8 -87 -16 -83 b -21 -15 -20 -72 -20 -72 "
                        },
                        v95: {
                            x_min: 0,
                            x_max: 406.96875,
                            ha: 415,
                            o: "m 55 181 b 70 183 61 183 66 183 b 111 170 85 183 99 179 b 160 130 115 167 137 149 l 202 95 l 245 130 b 319 181 299 176 302 179 b 334 183 325 183 330 183 b 406 109 375 183 406 148 b 401 81 406 99 405 91 b 348 24 394 65 390 59 b 318 -1 332 11 318 0 b 348 -26 318 -1 332 -12 b 401 -83 390 -61 394 -66 b 406 -111 405 -93 406 -101 b 334 -184 406 -149 375 -184 b 319 -183 330 -184 325 -184 b 245 -131 302 -180 299 -177 l 202 -97 l 160 -131 b 85 -183 107 -177 103 -180 b 70 -184 80 -184 76 -184 b 0 -111 31 -184 0 -149 b 4 -83 0 -101 1 -93 b 58 -26 10 -66 16 -61 b 88 -1 74 -12 88 -1 b 58 24 88 0 74 11 b 10 69 23 54 17 59 b 0 109 2 81 0 95 b 55 181 0 142 21 173 m 83 133 b 72 136 78 136 76 136 b 57 131 66 136 61 134 b 46 109 49 126 46 117 b 50 93 46 104 47 98 b 107 45 51 91 77 70 b 160 0 137 20 160 0 b 107 -47 160 -1 137 -22 b 50 -94 77 -72 51 -93 b 46 -111 47 -99 46 -105 b 59 -134 46 -120 50 -130 b 72 -137 62 -136 68 -137 b 83 -136 76 -137 80 -136 b 144 -84 84 -134 107 -116 b 202 -36 176 -58 202 -36 b 261 -84 202 -36 230 -58 b 323 -136 299 -116 321 -134 b 334 -137 326 -136 330 -137 b 345 -134 338 -137 343 -136 b 360 -111 355 -130 360 -120 b 355 -94 360 -105 359 -99 b 299 -47 353 -93 329 -72 b 245 0 269 -22 245 -1 b 299 45 245 0 269 20 b 355 93 329 70 353 91 b 360 109 359 98 360 104 b 345 133 360 119 355 129 b 334 136 343 134 338 136 b 323 134 330 136 326 134 b 261 83 321 133 299 115 b 202 34 230 56 202 34 b 144 83 202 34 176 56 b 83 133 106 115 84 133 "
                        },
                        v97: {
                            x_min: -228.671875,
                            x_max: 227.3125,
                            ha: 232,
                            o: "m -217 487 l -213 488 l 0 488 l 212 488 l 216 487 b 225 476 220 484 224 480 l 227 473 l 227 244 l 227 15 l 225 12 b 206 0 223 4 215 0 b 197 1 204 0 200 0 b 187 12 193 4 189 6 l 186 15 l 186 138 l 186 262 l -1 262 l -187 262 l -187 138 l -187 15 l -189 12 b -208 0 -193 4 -200 0 b -227 12 -216 0 -223 4 l -228 15 l -228 244 l -228 473 l -227 476 b -217 487 -225 480 -221 484 "
                        },
                        v9a: {
                            x_min: -21.78125,
                            x_max: 367.5,
                            ha: 375,
                            o: "m 230 1031 b 238 1032 232 1032 235 1032 b 259 1014 245 1032 251 1027 b 367 662 330 906 367 782 b 364 602 367 641 367 621 b 232 317 352 488 304 384 b 57 120 155 245 103 187 b -1 18 31 84 6 40 b -19 4 -4 11 -12 4 l -21 4 l -21 159 l -21 315 l -16 315 b 96 335 10 315 62 324 b 315 695 227 380 315 527 b 313 738 315 709 314 724 b 224 991 304 825 273 916 b 216 1013 219 999 216 1007 b 230 1031 216 1021 220 1028 "
                        },
                        v9b: {
                            x_min: -24.5,
                            x_max: 313.0625,
                            ha: 319,
                            o: "m -24 -133 l -24 -5 l -20 -5 b -1 -19 -12 -5 -4 -11 b 142 -213 13 -61 74 -144 b 258 -376 196 -269 230 -315 b 313 -605 295 -449 313 -528 b 292 -742 313 -652 306 -699 b 288 -752 289 -748 288 -752 b 288 -752 288 -752 288 -752 b 292 -764 289 -753 291 -757 b 313 -907 306 -811 313 -860 b 292 -1045 313 -954 306 -1002 b 288 -1054 289 -1050 288 -1054 b 288 -1054 288 -1054 288 -1054 b 292 -1067 289 -1054 291 -1060 b 313 -1210 306 -1113 313 -1161 b 292 -1346 313 -1257 306 -1304 b 288 -1357 289 -1353 288 -1357 b 288 -1357 288 -1357 288 -1357 b 292 -1368 289 -1357 291 -1363 b 313 -1512 306 -1415 313 -1464 b 292 -1648 313 -1560 306 -1605 b 288 -1660 289 -1654 288 -1660 b 288 -1660 288 -1660 288 -1660 b 292 -1671 289 -1660 291 -1665 b 313 -1814 306 -1719 313 -1766 b 250 -2040 313 -1897 291 -1977 b 232 -2062 238 -2057 236 -2059 b 221 -2065 230 -2063 225 -2065 b 200 -2045 210 -2065 201 -2057 b 200 -2043 200 -2044 200 -2044 b 208 -2026 200 -2037 202 -2034 b 269 -1826 249 -1966 269 -1897 b 153 -1544 269 -1726 230 -1625 b -9 -1472 115 -1506 58 -1481 b -21 -1471 -14 -1471 -19 -1471 l -24 -1471 l -24 -1343 l -24 -1215 l -20 -1215 b -1 -1229 -12 -1215 -4 -1221 b 142 -1424 13 -1270 74 -1353 b 257 -1582 196 -1478 228 -1524 b 264 -1594 261 -1589 264 -1594 l 264 -1594 b 265 -1582 264 -1594 264 -1589 b 270 -1525 268 -1562 270 -1544 b 153 -1243 270 -1424 228 -1321 b -9 -1170 115 -1203 58 -1178 b -21 -1168 -14 -1170 -19 -1168 l -24 -1168 l -24 -1041 l -24 -913 l -20 -913 b -1 -927 -12 -913 -4 -918 b 142 -1121 13 -967 74 -1050 b 257 -1281 196 -1175 228 -1221 b 264 -1292 261 -1286 264 -1292 l 264 -1292 b 265 -1279 264 -1292 264 -1286 b 270 -1222 268 -1261 270 -1242 b 153 -941 270 -1121 228 -1018 b -9 -867 115 -900 58 -875 b -21 -866 -14 -867 -19 -866 l -24 -866 l -24 -738 l -24 -610 l -20 -610 b -1 -624 -12 -610 -4 -616 b 142 -818 13 -664 74 -749 b 257 -978 196 -873 228 -918 b 264 -989 261 -984 264 -989 l 264 -989 b 265 -977 264 -989 264 -984 b 270 -920 268 -959 270 -939 b 153 -638 270 -818 228 -716 b -9 -564 115 -598 58 -573 b -21 -563 -14 -564 -19 -563 l -24 -563 l -24 -435 l -24 -308 l -20 -308 b -1 -322 -12 -308 -4 -313 b 142 -516 13 -363 74 -446 b 257 -675 196 -571 228 -616 b 264 -687 261 -681 264 -687 l 264 -687 b 265 -674 264 -687 264 -681 b 270 -617 268 -656 270 -637 b 153 -335 270 -516 228 -413 b -9 -262 115 -295 58 -270 b -21 -260 -14 -262 -19 -260 l -24 -260 l -24 -133 "
                        },
                        v9c: {
                            x_min: -166.0625,
                            x_max: -25.859375,
                            ha: 0,
                            o: "m -49 369 b -42 370 -46 369 -44 370 b -27 360 -36 370 -29 366 b -25 355 -27 359 -25 358 b -32 335 -25 351 -28 347 b -92 52 -66 248 -87 159 b -93 -1 -93 43 -93 20 b -92 -54 -93 -23 -93 -45 b -32 -337 -85 -162 -66 -251 b -25 -355 -27 -349 -25 -352 b -42 -371 -25 -365 -32 -371 b -61 -353 -50 -371 -51 -369 b -163 -63 -119 -262 -153 -165 b -166 -1 -166 -37 -166 -31 b -163 62 -166 30 -166 36 b -61 352 -153 163 -119 260 b -49 369 -54 365 -51 366 "
                        },
                        v9e: {
                            x_min: 0,
                            x_max: 607.0625,
                            ha: 619,
                            o: "m 243 631 b 250 632 246 632 249 632 b 270 620 259 632 268 628 l 272 616 l 272 201 l 272 -212 l 270 -216 b 251 -229 268 -224 259 -229 b 227 -215 243 -229 240 -229 l 151 -142 b 32 -16 81 -80 53 -49 b 0 84 9 18 0 52 b 111 199 0 149 42 199 b 137 197 119 199 127 198 b 228 151 168 191 197 177 l 231 148 l 231 383 b 232 620 231 616 231 616 b 243 631 234 624 238 630 m 168 131 b 152 133 163 133 157 133 b 107 102 130 133 111 120 b 106 86 107 97 106 91 b 111 41 106 73 108 56 b 227 -152 125 -13 171 -90 l 231 -156 l 231 -37 l 231 80 l 225 87 b 168 131 210 111 190 126 m 347 631 b 353 632 348 632 351 632 b 374 620 363 632 371 628 b 375 383 375 616 375 616 l 375 148 l 377 151 b 492 199 415 183 454 199 b 537 191 507 199 522 197 b 607 84 582 176 607 134 b 583 0 607 58 598 29 b 455 -142 562 -40 533 -72 l 378 -215 b 355 -229 364 -229 362 -229 b 334 -216 345 -229 337 -224 l 333 -212 l 333 201 l 333 616 l 334 620 b 347 631 337 624 341 630 m 465 131 b 451 133 461 133 455 133 b 445 133 449 133 446 133 b 379 87 419 129 396 113 l 375 80 l 375 -37 l 375 -156 l 378 -152 b 499 81 451 -72 499 20 l 499 83 b 465 131 499 113 490 126 "
                        },
                        va3: {
                            x_min: 58.53125,
                            x_max: 228.671875,
                            ha: 294,
                            o: "m 138 371 b 142 373 140 371 141 373 b 178 342 149 373 156 366 b 228 251 217 297 228 278 b 228 244 228 248 228 247 b 176 147 227 212 212 184 b 123 73 152 122 132 93 b 121 62 122 70 121 66 b 145 13 121 48 129 31 b 153 -2 151 6 153 1 b 149 -9 153 -5 152 -6 b 144 -11 148 -11 145 -11 b 129 -1 140 -11 136 -8 b 61 87 89 37 68 68 b 58 113 59 95 58 105 b 110 215 58 144 74 177 b 163 287 134 240 155 269 b 166 299 166 291 166 295 b 141 348 166 313 157 330 b 133 360 134 356 133 358 b 133 363 133 362 133 362 b 138 371 133 367 136 370 "
                        },
                        va5: {
                            x_min: 0,
                            x_max: 349.8125,
                            ha: 357,
                            o: "m 88 302 b 103 303 93 302 98 303 b 202 224 149 303 191 270 b 205 199 204 216 205 208 b 178 129 205 173 196 147 l 175 126 l 182 127 b 307 249 236 142 284 190 b 313 259 308 254 311 258 b 329 267 317 265 323 267 b 349 247 340 267 349 259 b 201 -263 349 242 204 -258 b 182 -273 197 -270 190 -273 b 163 -260 174 -273 166 -269 b 161 -256 161 -259 161 -258 b 217 -59 161 -248 170 -220 b 272 129 247 43 272 127 b 272 129 272 129 272 129 b 264 122 272 129 268 126 b 140 80 227 94 183 80 b 36 115 102 80 65 91 b 0 194 10 136 0 165 b 88 302 0 244 32 292 "
                        },
                        va9: {
                            x_min: -24.5,
                            x_max: 314.421875,
                            ha: 321,
                            o: "m -24 -145 l -24 -5 l -20 -5 b 0 -23 -9 -5 -2 -12 b 27 -87 4 -38 14 -66 b 138 -220 53 -136 88 -177 b 235 -328 179 -255 208 -288 b 314 -592 287 -409 314 -501 b 292 -732 314 -639 307 -687 l 289 -742 l 294 -756 b 314 -896 307 -802 314 -849 b 292 -1035 314 -943 307 -991 l 289 -1045 l 294 -1057 b 314 -1197 307 -1104 314 -1152 b 292 -1338 314 -1246 307 -1292 l 289 -1347 l 294 -1360 b 314 -1500 307 -1407 314 -1454 b 273 -1689 314 -1565 300 -1628 b 250 -1712 265 -1710 261 -1712 b 228 -1691 236 -1712 228 -1704 l 228 -1685 l 234 -1675 b 270 -1507 258 -1621 270 -1564 b 98 -1193 270 -1381 209 -1261 b 40 -1174 76 -1179 58 -1174 b -10 -1189 24 -1174 8 -1178 b -20 -1192 -14 -1192 -16 -1192 l -24 -1192 l -24 -1052 l -24 -913 l -20 -913 b 0 -931 -9 -913 -2 -920 b 27 -995 4 -946 14 -974 b 138 -1128 53 -1043 88 -1085 b 257 -1275 190 -1172 228 -1220 b 262 -1283 259 -1279 262 -1283 l 262 -1283 b 269 -1249 264 -1282 268 -1260 b 270 -1206 270 -1233 270 -1220 b 98 -891 270 -1075 206 -957 b 40 -871 76 -877 58 -871 b -10 -886 24 -871 8 -875 b -20 -889 -14 -889 -16 -889 l -24 -889 l -24 -749 l -24 -610 l -20 -610 b 0 -628 -9 -610 -2 -617 b 27 -692 4 -644 14 -671 b 138 -825 53 -741 88 -782 b 257 -973 190 -870 228 -917 b 262 -981 259 -977 262 -981 l 262 -981 b 269 -946 264 -979 268 -957 b 270 -903 270 -931 270 -917 b 98 -588 270 -774 206 -655 b 40 -569 76 -574 58 -569 b -10 -584 24 -569 8 -574 b -20 -587 -14 -587 -16 -587 l -24 -587 l -24 -448 l -24 -308 l -20 -308 b 0 -326 -9 -308 -2 -315 b 27 -390 4 -341 14 -369 b 138 -523 53 -438 88 -480 b 257 -670 190 -567 228 -614 b 262 -678 259 -674 262 -678 b 262 -678 262 -678 262 -678 b 269 -644 264 -677 268 -656 b 270 -601 270 -628 270 -614 b 98 -285 270 -471 206 -352 b 40 -266 76 -273 58 -266 b -10 -281 24 -266 8 -272 b -20 -284 -14 -284 -16 -284 l -24 -284 l -24 -145 "
                        },
                        vaa: {
                            x_min: -1.359375,
                            x_max: 752.703125,
                            ha: 768,
                            o: "m 490 985 b 504 986 495 986 500 986 b 604 907 551 986 593 954 b 607 884 607 900 607 892 b 581 813 607 857 597 831 l 578 810 l 583 811 b 710 932 638 827 687 873 b 714 943 711 936 713 942 b 730 952 720 949 725 952 b 752 931 741 952 752 943 b 200 -946 752 927 204 -941 b 182 -957 197 -953 190 -957 b 163 -945 174 -957 166 -953 b 161 -939 161 -942 161 -942 b 217 -743 161 -931 170 -904 b 272 -555 247 -639 272 -555 b 272 -555 272 -555 272 -555 b 264 -560 272 -555 268 -557 b 140 -603 227 -589 182 -603 b 36 -567 102 -603 65 -592 b -1 -487 12 -548 -1 -517 b 17 -427 -1 -466 5 -445 b 103 -380 38 -395 70 -380 b 191 -433 137 -380 172 -398 b 205 -484 201 -448 205 -466 b 178 -553 205 -509 196 -535 l 175 -557 l 182 -555 b 307 -435 236 -539 284 -494 b 372 -213 308 -430 372 -215 b 372 -213 372 -213 372 -213 b 364 -219 372 -213 368 -216 b 240 -262 328 -247 283 -262 b 137 -226 202 -262 166 -249 b 99 -145 112 -206 99 -176 b 118 -84 99 -124 106 -104 b 204 -38 138 -54 171 -38 b 292 -91 238 -38 273 -56 b 306 -141 302 -106 306 -124 b 279 -212 306 -167 296 -194 l 276 -215 l 281 -213 b 408 -93 336 -198 385 -151 b 473 129 409 -88 473 127 b 473 129 473 129 473 129 b 465 122 473 129 469 126 b 341 80 428 94 383 80 b 236 115 303 80 266 91 b 200 195 213 136 200 165 b 217 256 200 217 206 238 b 304 303 239 287 272 303 b 393 249 338 303 374 285 b 406 199 402 234 406 217 b 379 129 406 173 397 148 l 377 126 l 382 127 b 509 248 436 142 485 190 b 574 470 510 254 574 469 b 574 470 574 470 574 470 b 566 464 574 470 570 467 b 442 421 529 435 484 421 b 337 458 404 421 367 433 b 300 538 314 477 300 508 b 318 598 300 559 306 580 b 404 645 340 630 372 645 b 494 592 439 645 475 627 b 507 541 502 577 507 559 b 480 471 507 516 498 489 l 477 467 l 483 470 b 608 589 537 485 586 531 b 675 811 611 595 675 810 b 675 811 675 811 675 811 b 666 806 675 811 671 809 b 543 763 628 777 585 763 b 438 799 504 763 468 775 b 401 878 412 820 401 849 b 490 985 401 928 434 977 "
                        },
                        vab: {
                            x_min: 0,
                            x_max: 272.21875,
                            ha: 278,
                            o: "m 243 631 b 250 632 246 632 249 632 b 270 620 259 632 268 628 l 272 616 l 272 201 l 272 -212 l 270 -216 b 251 -229 268 -224 259 -229 b 227 -215 243 -229 240 -229 l 151 -142 b 32 -16 81 -80 53 -49 b 0 84 9 18 0 52 b 111 199 0 149 42 199 b 137 197 119 199 127 198 b 228 151 168 191 197 177 l 231 148 l 231 383 b 232 620 231 616 231 616 b 243 631 234 624 238 630 m 168 131 b 152 133 163 133 157 133 b 107 102 130 133 111 120 b 106 86 107 97 106 91 b 111 41 106 73 108 56 b 227 -152 125 -13 171 -90 l 231 -156 l 231 -37 l 231 80 l 225 87 b 168 131 210 111 190 126 "
                        },
                        vad: {
                            x_min: 0,
                            x_max: 873.828125,
                            ha: 892,
                            o: "m 0 0 l 0 703 l 81 703 l 164 703 l 164 0 l 164 -705 l 81 -705 l 0 -705 l 0 0 m 225 0 l 225 703 l 246 703 l 268 703 l 268 366 l 268 30 l 274 36 b 314 79 284 44 302 63 b 413 302 357 137 392 213 b 432 327 419 324 421 327 b 449 306 443 327 447 322 b 611 115 457 195 529 115 b 651 122 624 115 638 117 b 728 316 705 140 724 188 b 729 388 728 342 729 366 b 671 635 729 533 711 602 b 581 662 649 652 616 662 b 477 637 545 662 510 653 l 475 635 l 477 634 b 503 627 488 632 495 631 b 545 556 532 612 545 584 b 491 480 545 524 526 491 b 465 474 481 476 473 474 b 379 563 417 474 379 516 b 389 602 379 576 382 588 b 541 691 409 641 479 681 b 582 694 555 692 568 694 b 865 462 714 694 834 598 b 873 392 871 440 873 416 b 865 317 873 367 871 341 b 639 84 839 194 748 101 b 612 83 630 83 620 83 b 511 116 577 83 543 94 b 504 120 509 119 506 120 b 504 120 504 120 504 120 b 469 59 504 120 488 93 l 432 -1 l 469 -61 b 504 -122 488 -94 504 -122 b 504 -122 504 -122 504 -122 b 511 -117 506 -122 509 -120 b 612 -84 543 -95 577 -84 b 665 -91 630 -84 647 -87 b 869 -338 771 -122 850 -216 b 873 -392 872 -356 873 -374 b 798 -595 873 -469 847 -539 b 581 -695 741 -662 660 -695 b 406 -626 517 -695 454 -671 b 381 -563 389 -607 381 -585 b 465 -477 381 -519 413 -477 b 545 -559 514 -477 545 -519 b 503 -628 545 -587 532 -613 b 477 -635 495 -632 488 -634 l 475 -637 l 477 -638 b 581 -663 510 -655 545 -663 b 671 -637 616 -663 649 -653 b 729 -391 711 -603 729 -534 b 728 -317 729 -367 728 -344 b 623 -117 722 -173 698 -124 b 611 -116 619 -116 615 -116 b 449 -308 528 -116 457 -198 b 432 -328 447 -323 443 -328 b 413 -303 421 -328 419 -326 b 314 -80 392 -215 357 -138 b 274 -37 302 -65 284 -45 l 268 -31 l 268 -367 l 268 -705 l 246 -705 l 225 -705 l 225 0 "
                        },
                        vb1: {
                            x_min: 78.9375,
                            x_max: 485.921875,
                            ha: 417,
                            o: "m 362 378 b 378 380 367 380 372 380 b 472 348 415 380 453 367 b 485 315 481 338 485 327 b 462 273 485 298 477 281 b 439 267 454 269 446 267 b 398 290 424 267 409 274 b 344 319 385 309 364 319 b 281 269 315 319 289 301 b 279 262 280 266 279 262 b 276 256 279 260 277 258 b 274 249 276 254 274 251 b 238 127 273 248 257 192 b 201 4 217 61 201 5 b 166 -1 198 -1 200 -1 b 153 -1 163 -1 157 -1 b 141 -1 148 -1 144 -1 b 104 4 106 -1 107 -1 b 104 6 104 5 104 5 b 142 144 104 13 110 34 b 182 278 164 219 181 276 b 183 288 182 281 182 285 b 185 302 185 292 185 298 b 164 330 185 317 176 328 b 159 330 163 330 161 330 b 102 302 140 330 119 320 b 91 294 95 295 93 294 b 88 294 91 294 89 294 b 78 303 83 294 78 298 b 81 312 78 306 78 309 b 200 373 106 347 160 373 b 215 371 205 373 209 371 b 266 335 235 367 254 353 b 269 331 268 333 269 331 b 269 331 269 331 269 331 b 273 335 269 331 270 334 b 362 378 298 359 330 376 "
                        },
                        vb3: {
                            x_min: 0,
                            x_max: 227.3125,
                            ha: 232,
                            o: "m 91 213 b 100 215 93 215 96 215 b 227 58 167 215 224 144 b 227 52 227 56 227 54 b 61 -201 227 -43 164 -138 b 29 -216 44 -212 36 -216 b 23 -210 27 -216 24 -213 b 21 -205 21 -208 21 -206 b 34 -192 21 -201 25 -197 b 122 -55 89 -161 122 -106 b 104 6 122 -33 117 -12 l 103 9 l 96 9 b 4 79 57 9 17 38 b 0 112 1 90 0 101 b 91 213 0 163 36 209 "
                        },
                        vb4: {
                            x_min: -597.53125,
                            x_max: 596.171875,
                            ha: 608,
                            o: "m -533 324 b -525 327 -530 326 -528 327 b -504 305 -514 327 -504 317 b -504 305 -504 305 -504 305 b -513 284 -504 299 -504 299 b -556 112 -541 226 -556 167 b -545 33 -556 84 -552 58 b -524 -20 -541 15 -532 -9 l -522 -23 l -491 15 l -413 111 b -355 174 -367 169 -363 174 b -351 174 -353 174 -352 174 b -254 86 -343 174 -348 179 b -168 -1 -208 37 -168 -1 b -100 84 -168 -1 -137 37 b -23 173 -28 173 -29 172 b -19 174 -21 174 -20 174 b -8 173 -14 174 -10 173 b 80 86 -5 172 13 151 b 166 -1 127 37 166 -1 b 235 84 166 -1 197 37 b 311 173 306 173 304 172 b 317 174 313 174 314 174 b 326 173 319 174 323 173 b 490 11 329 172 366 134 l 502 -1 l 530 34 b 568 76 560 72 563 74 b 575 77 570 77 573 77 b 596 56 586 77 596 68 b 594 48 596 54 596 51 b 417 -172 592 41 424 -166 b 405 -176 415 -174 409 -176 b 396 -174 401 -176 398 -176 b 307 -87 393 -173 372 -152 b 221 -1 259 -38 221 -1 b 152 -86 221 -1 190 -38 b 76 -176 81 -174 83 -173 b 70 -176 74 -176 73 -176 b 61 -174 66 -176 62 -174 b -27 -87 58 -173 38 -152 b -114 -1 -74 -38 -112 -1 b -182 -86 -114 -1 -145 -38 b -258 -176 -253 -174 -253 -173 b -264 -176 -259 -176 -262 -176 b -274 -174 -268 -176 -272 -174 b -438 -11 -277 -173 -348 -102 l -449 0 l -479 -37 b -524 -80 -513 -80 -514 -80 l -524 -80 b -553 -52 -534 -80 -540 -74 b -597 109 -583 -8 -597 48 b -560 280 -597 165 -585 224 b -533 324 -548 310 -540 322 "
                        },
                        vb6: {
                            x_min: 0,
                            x_max: 556.6875,
                            ha: 568,
                            o: "m 289 545 b 298 546 292 545 295 546 b 318 533 306 546 315 541 b 319 428 319 530 319 528 l 319 327 l 334 327 b 526 223 412 326 485 285 b 543 172 537 206 543 190 b 447 76 543 122 503 76 b 445 76 446 76 446 76 b 359 165 394 77 359 119 b 368 205 359 179 362 192 b 441 251 382 233 412 251 b 455 249 446 251 451 251 b 460 248 458 249 460 248 b 460 248 460 248 460 248 b 454 254 460 249 458 251 b 334 295 419 280 378 294 l 319 295 l 319 4 l 319 -287 l 321 -285 b 328 -285 322 -285 325 -285 b 524 -99 424 -277 507 -198 b 541 -79 526 -84 530 -79 b 556 -97 551 -79 556 -84 b 548 -133 556 -105 553 -117 b 334 -317 521 -233 434 -306 b 322 -319 329 -317 323 -317 l 319 -319 l 319 -424 b 319 -471 319 -444 319 -459 b 313 -541 319 -544 318 -535 b 298 -548 308 -545 303 -548 b 279 -534 289 -548 281 -542 b 277 -424 277 -531 277 -530 l 277 -317 l 273 -317 b 13 -95 153 -305 51 -217 b 0 2 4 -62 0 -29 b 182 295 0 126 66 238 b 274 324 210 309 249 320 l 277 324 l 277 427 b 279 533 277 528 277 530 b 289 545 281 538 285 542 m 277 2 b 277 291 277 161 277 291 b 268 288 277 291 273 290 b 144 1 179 265 144 184 b 276 -284 144 -199 175 -267 l 277 -285 l 277 2 "
                        },
                        vb7: {
                            x_min: -176.9375,
                            x_max: 251.8125,
                            ha: 257,
                            o: "m -8 631 b -1 632 -6 632 -4 632 b 19 620 8 632 16 628 b 20 503 20 616 20 614 b 20 391 20 442 20 391 b 84 424 20 391 49 406 l 147 456 l 152 456 b 153 456 153 456 153 456 b 175 435 166 456 175 446 b 172 427 175 433 174 430 b 92 380 170 420 172 421 l 20 342 l 20 245 l 20 148 l 21 151 b 137 199 59 183 99 199 b 182 191 152 199 167 197 b 251 84 227 176 251 134 b 228 0 251 58 243 29 b 100 -142 206 -40 178 -72 l 23 -215 b 0 -229 9 -229 6 -229 b -20 -216 -9 -229 -17 -224 b -21 54 -21 -212 -21 -212 b -21 322 -21 201 -21 322 b -85 290 -21 322 -50 308 l -148 256 l -153 256 b -155 256 -155 256 -155 256 b -176 277 -167 256 -176 266 b -174 285 -176 280 -175 283 b -93 333 -171 294 -174 292 l -21 370 l -21 494 b -20 620 -21 616 -21 616 b -8 631 -17 624 -13 630 m 110 131 b 96 133 106 133 100 133 b 89 133 93 133 91 133 b 24 87 63 129 40 113 l 20 80 l 20 -37 l 20 -156 l 23 -152 b 144 81 96 -72 144 20 l 144 83 b 110 131 144 113 134 126 "
                        },
                        vb9: {
                            x_min: -122.5,
                            x_max: 121.140625,
                            ha: 124,
                            o: "m -16 145 b 0 147 -10 147 -5 147 b 121 -1 66 147 121 77 b 114 -49 121 -16 118 -33 b -1 -148 95 -112 47 -148 b -85 -106 -31 -148 -61 -134 b -122 -1 -110 -76 -122 -38 b -16 145 -122 68 -81 134 m 12 111 b 0 113 8 113 4 113 b -68 22 -29 113 -61 73 b -70 0 -69 15 -70 6 b -13 -113 -70 -49 -47 -98 b -1 -115 -9 -115 -5 -115 b 63 -40 24 -115 53 -83 b 68 -1 66 -27 68 -15 b 12 111 68 48 46 97 "
                        },
                        vba: {
                            x_min: -118.421875,
                            x_max: 597.53125,
                            ha: 381,
                            o: "m 460 574 b 464 574 461 574 462 574 b 488 574 470 574 481 574 b 500 573 491 574 498 574 b 594 503 543 570 588 538 b 597 488 596 498 597 494 b 528 417 597 449 564 417 b 502 423 519 417 510 419 b 465 481 477 434 465 458 b 488 528 465 499 472 516 b 490 530 490 530 490 530 b 490 530 490 530 490 530 b 468 517 488 530 475 523 b 349 340 419 485 377 420 b 347 330 348 334 347 330 b 383 328 347 328 363 328 b 428 326 423 328 424 328 b 442 302 438 320 442 312 b 430 281 442 294 438 285 b 385 276 424 277 426 276 l 377 276 l 332 276 l 330 269 b 178 -117 303 126 250 -9 b 1 -249 129 -194 69 -237 b -20 -251 -6 -251 -13 -251 b -114 -187 -65 -251 -100 -227 b -118 -156 -117 -177 -118 -166 b -51 -84 -118 -116 -91 -84 b -31 -87 -46 -84 -39 -86 b 16 -152 0 -95 16 -124 b -12 -205 16 -173 8 -194 b -16 -208 -14 -206 -16 -208 b -14 -208 -16 -208 -14 -208 b -9 -206 -14 -208 -12 -208 b 74 -124 23 -197 54 -166 b 172 224 98 -79 125 22 b 185 276 178 252 183 274 b 185 276 185 276 185 276 b 141 276 185 276 181 276 b 91 280 96 276 96 276 b 77 302 83 285 77 294 b 91 326 77 312 83 320 b 148 328 95 328 96 328 l 198 330 l 202 341 b 460 574 249 473 351 566 "
                        },
                        vbf: {
                            x_min: -53.078125,
                            x_max: 513.140625,
                            ha: 485,
                            o: "m 185 383 b 196 384 187 383 191 384 b 277 334 230 384 259 365 b 288 301 281 324 288 306 b 288 297 288 298 288 297 b 294 302 289 297 291 299 b 394 370 323 338 367 367 b 404 371 398 370 401 371 b 510 272 453 371 498 328 b 513 237 513 262 513 251 b 507 172 513 217 511 192 b 326 -34 487 59 412 -26 b 314 -36 322 -36 318 -36 b 274 -24 298 -36 283 -31 l 265 -16 b 224 44 246 -1 232 20 b 223 49 224 47 223 49 b 223 49 223 49 223 49 b 149 -197 221 48 149 -194 b 149 -198 149 -197 149 -198 b 170 -210 149 -202 155 -205 b 187 -215 174 -210 175 -212 b 204 -231 201 -219 204 -222 b 197 -245 204 -240 202 -242 l 194 -248 l 76 -248 l -42 -248 l -46 -245 b -53 -231 -51 -242 -53 -240 b -35 -215 -53 -222 -49 -217 b -13 -210 -21 -212 -20 -212 b -6 -208 -10 -209 -8 -208 b 0 -206 -6 -208 -2 -206 b 25 -188 13 -201 21 -195 b 163 280 28 -183 163 276 b 166 291 163 283 164 287 b 167 302 167 295 167 299 b 155 324 167 315 161 324 b 155 324 155 324 155 324 b 65 230 125 322 85 280 b 53 215 61 217 58 215 b 51 215 53 215 51 215 b 42 224 46 215 42 217 b 57 263 42 231 47 244 b 140 360 77 305 104 337 b 152 370 144 365 149 369 b 185 383 157 376 172 381 m 374 306 b 366 308 371 308 368 308 b 300 273 348 308 321 294 b 284 254 288 262 287 259 b 280 242 283 249 281 245 b 257 169 279 240 270 213 l 236 98 l 236 93 b 251 48 238 77 243 61 b 279 27 258 37 272 27 b 281 27 279 27 280 27 b 291 31 281 27 287 30 b 396 170 334 52 378 109 b 406 247 402 197 406 224 b 401 277 406 259 405 270 b 374 306 397 290 383 303 "
                        },
                        vc3: {
                            x_min: -10.890625,
                            x_max: 299.4375,
                            ha: 294,
                            o: "m 136 460 b 142 462 137 462 140 462 b 166 449 152 462 161 456 b 171 428 168 446 168 445 b 288 131 194 322 238 209 b 298 115 295 120 296 117 b 299 106 298 112 299 109 b 273 81 299 91 287 81 b 255 86 268 81 261 83 b 155 116 225 104 183 116 l 152 116 l 149 108 b 141 83 148 102 144 91 b 134 48 137 69 134 58 b 149 9 134 34 140 24 b 153 -1 152 5 153 1 b 149 -9 153 -5 152 -6 b 144 -11 148 -11 147 -11 b 122 2 138 -11 133 -6 b 95 61 104 20 95 38 b 107 108 95 74 99 90 b 108 113 107 111 108 112 b 107 113 108 113 108 113 b 102 113 106 113 104 113 b 31 86 76 108 53 98 b 14 80 24 81 20 80 b -10 106 0 80 -10 91 b 0 131 -10 115 -9 116 b 115 430 49 209 91 317 b 136 460 119 451 123 456 "
                        },
                        vd0: {
                            x_min: -10.890625,
                            x_max: 299.4375,
                            ha: 294,
                            o: "m 44 174 b 51 174 47 174 49 174 b 68 173 55 174 61 174 l 287 112 l 551 40 b 615 20 617 22 609 23 b 626 0 622 16 626 8 b 615 -22 626 -9 622 -18 b 613 -23 613 -23 613 -23 b 613 -23 613 -23 613 -23 b 287 -113 613 -24 597 -29 l 68 -174 b 53 -176 61 -176 57 -176 b 39 -172 47 -176 43 -174 b 27 -151 31 -167 27 -159 b 39 -129 27 -141 31 -133 b 230 -74 43 -124 20 -131 l 370 -36 l 468 -9 b 498 0 484 -4 498 -1 b 468 8 498 0 484 2 l 370 34 l 230 73 b 40 126 28 129 43 124 b 27 149 31 131 27 140 b 44 174 27 161 34 170 m 205 110 l 205 300 b 205 330 245 330 245 300 l 245 300 l 245 -300 b 245 -330 205 -330 205 -300 l 205 -300 l 205 110 l 345 90 m 345 90 l 345 330 b 345 360 385 360 385 330 l 385 330 l 385 -270 b 385 -300 345 -300 345 -270 l 345 -270 l 345 90 "
                        },
                        vd1: {
                            x_min: -20,
                            x_max: 320,
                            ha: 257,
                            o: "m -8 200 b -8 210 8 200 16 200 l 20 148 -199 l 23 -615 b 0 -629 9 -629 6 -629 l -21 -612 l -21 -201 l -21 216 l -20 200 m 16 200 l 310 0 l 240 0 l 16 140 l 16 -120 l 240 0 l 310 0 l 16 -200 "
                        },
                        vd2: {
                            x_min: 0,
                            x_max: 430.75,
                            ha: 386,
                            o: "m 0 200 l 0 -200 l 430 -200 l 430 200 l 0 200 "
                        },
                        vd3: {
                            x_min: 0,
                            x_max: 430.75,
                            ha: 386,
                            o: "m 0 200 l 0 -200 l 430 -200 l 430 200 l 0 200 l 50 150 l 380 150 l 380 -150 l 50 -150 l 50 150 "
                        },
                        vd4: {
                            x_min: 0,
                            x_max: 430.75,
                            ha: 360,
                            o: "m 0 150 l 0 -150 l 430 -150 l 430 150 l 0 150 "
                        },
                        vd5: {
                            x_min: 0,
                            x_max: 430.75,
                            ha: 360,
                            o: "m 0 150 l 0 -150 l 430 -150 l 430 150 l 0 150 l 50 100 l 380 100 l 380 -100 l 50 -100 l 50 100"
                        },
                        vd6: {
                            x_min: 0,
                            x_max: 430.75,
                            ha: 360,
                            o: "m -146 537 b -138 538 -143 538 -141 538 b -118 525 -129 538 -121 533 b -117 390 -117 522 -117 521 b -115 259 -117 268 -117 259 b -115 259 -115 259 -115 259 b -59 272 -104 263 -62 272 b -39 259 -50 272 -42 267 b -37 209 -38 257 -37 233 b -39 159 -37 185 -38 162 b -85 138 -43 149 -44 149 l -117 131 l -117 21 b -115 -88 -117 -80 -117 -88 b -115 -88 -115 -88 -115 -88 b -59 -75 -104 -84 -62 -75 b -44 -81 -52 -75 -48 -77 b -38 -124 -38 -87 -38 -85 b -38 -138 -38 -124 -38 -138 b -38 -152 -38 -138 -38 -152 b -44 -195 -38 -191 -38 -190 b -85 -209 -48 -200 -48 -200 l -117 -217 l -117 -349 b -118 -486 -117 -481 -117 -482 b -138 -499 -121 -494 -129 -499 b -153 -493 -143 -499 -149 -497 b -159 -415 -158 -487 -159 -496 b -159 -355 -159 -398 -159 -379 b -159 -227 -159 -284 -159 -227 b -205 -238 -159 -227 -180 -232 b -250 -249 -230 -244 -250 -249 b -251 -386 -251 -249 -251 -311 b -252 -525 -251 -521 -251 -522 b -272 -538 -255 -534 -264 -538 b -287 -532 -277 -538 -283 -536 b -293 -452 -292 -527 -293 -536 b -293 -391 -293 -436 -293 -415 b -294 -260 -293 -269 -293 -260 b -294 -260 -294 -260 -294 -260 b -348 -272 -306 -264 -345 -272 b -368 -259 -357 -272 -365 -267 b -369 -209 -369 -257 -369 -233 b -368 -159 -369 -185 -369 -162 b -323 -139 -364 -149 -362 -148 l -293 -131 l -293 -22 b -294 87 -293 80 -293 87 b -294 87 -294 87 -294 87 b -348 75 -306 84 -345 75 b -368 88 -357 75 -365 80 b -369 138 -369 91 -369 114 b -368 188 -369 162 -369 186 b -323 209 -364 198 -362 199 l -293 216 l -293 349 b -292 486 -293 481 -293 482 b -272 499 -288 494 -280 499 b -257 493 -266 499 -261 497 b -251 414 -251 487 -251 496 b -251 354 -251 398 -251 378 b -251 226 -251 284 -251 226 b -205 238 -250 226 -230 231 b -159 249 -180 244 -159 249 b -159 385 -159 249 -159 310 b -157 525 -159 521 -159 522 b -146 537 -156 530 -151 535 z m -159 11 b -159 120 -159 98 -159 120 l -159 120 b -175 116 -160 120 -167 119 b -221 105 -184 114 -204 109 l -251 98 l -251 -12 b -251 -121 -251 -72 -251 -121 b -205 -110 -250 -121 -230 -116 b -159 -99 -180 -104 -159 -99 b -159 11 -159 -99 -159 -49 z m 89 517 b 97 519 92 518 94 519 b 117 505 106 519 114 513 b 119 376 119 502 119 501 l 119 249 l 145 258 b 176 267 169 266 172 267 b 177 267 176 267 177 267 b 196 255 186 267 192 263 l 197 252 l 197 205 b 197 181 197 195 197 187 b 193 149 197 153 197 153 b 152 131 190 144 187 143 l 119 120 l 119 10 b 119 -100 119 -62 119 -100 b 145 -91 120 -100 131 -96 b 173 -82 159 -86 171 -82 b 176 -81 174 -81 175 -81 b 196 -94 185 -81 193 -87 b 198 -151 197 -97 198 -125 b 197 -194 198 -172 197 -192 b 153 -218 193 -203 192 -204 l 119 -230 l 119 -367 l 118 -504 l 117 -507 b 97 -519 113 -514 105 -519 b 82 -512 92 -519 87 -517 b 76 -434 77 -507 76 -516 b 76 -374 76 -418 76 -398 b 76 -245 76 -303 76 -245 b 52 -254 76 -245 65 -249 b 19 -263 34 -260 25 -263 b 6 -257 13 -263 10 -261 b 0 -214 0 -251 0 -253 b 0 -200 0 -210 0 -205 b 0 -188 0 -196 0 -192 b 6 -143 0 -147 0 -149 b 46 -126 10 -139 10 -139 l 76 -115 l 76 -5 b 76 106 76 56 76 106 b 51 98 76 106 64 102 b 18 89 34 92 25 89 b 6 95 13 89 10 91 b 0 139 0 101 0 99 b 0 153 0 143 0 148 b 0 179 0 163 0 172 b 44 225 0 215 3 211 l 76 236 l 76 369 b 78 505 76 501 76 502 b 89 517 80 510 85 515 z "
                        },
                        vd7: {
                            x_min: 0,
                            x_max: 430.75,
                            ha: 360,
                            o: "m 283 633 b 291 634 286 634 289 634 b 311 621 300 634 308 629 b 313 505 313 618 313 617 b 313 393 313 443 313 393 b 378 425 313 393 343 407 l 443 458 l 448 458 b 449 458 449 458 449 458 b 471 437 462 458 471 448 b 469 429 471 434 470 432 b 387 382 466 421 469 423 l 313 344 l 313 247 l 313 150 l 315 152 b 433 201 353 184 394 201 b 479 193 448 201 464 198 b 549 86 524 177 549 135 b 526 1 549 59 541 29 b 395 -143 504 -39 475 -71 b 316 -214 351 -182 341 -191 b 292 -229 302 -228 300 -229 b 272 -216 283 -229 275 -224 b 271 55 271 -212 271 -212 b 270 323 271 203 270 323 b 205 291 270 323 241 308 l 140 258 l 135 258 b 134 258 135 258 134 258 b 112 279 121 258 112 267 b 114 287 112 281 113 284 b 196 334 117 295 114 293 l 271 371 l 271 495 b 272 621 271 617 271 618 b 283 633 274 626 279 631 z m 404 133 b 391 134 400 134 395 134 b 384 134 388 134 386 134 b 318 88 358 130 335 114 l 313 81 l 313 -37 l 313 -156 l 316 -152 b 439 83 391 -71 439 22 l 439 84 b 404 133 439 115 430 128 z m -8 633 l -8 633 b 0 634 -6 634 -3 634 b 20 621 8 634 17 629 b 21 384 21 618 21 617 l 21 150 l 24 152 b 141 201 62 184 102 201 b 187 193 157 201 172 198 b 257 86 232 177 257 135 b 234 1 257 59 250 29 b 103 -143 212 -39 183 -71 b 24 -214 60 -182 49 -191 b 0 -229 10 -228 8 -229 b -20 -216 -9 -229 -17 -224 l -21 -212 l -21 203 l -21 618 l -20 621 b -8 633 -18 626 -13 631 z m 113 133 l 113 133 b 99 134 109 134 103 134 b 93 134 97 134 94 134 b 26 88 66 130 43 114 l 21 81 l 21 -37 l 21 -156 l 25 -152 b 148 83 99 -71 148 22 l 148 84 b 113 133 148 115 138 128 z "
                        },
                        rwl: {
                            x_min: 0,
                            x_max: 737.71875,
                            ha: 753,
                            o: "m 9 13 b 208 15 10 15 51 15 b 368 15 251 15 304 15 l 726 15 l 729 12 b 737 -1 735 9 737 4 b 729 -15 737 -6 735 -11 l 726 -16 l 660 -16 l 592 -16 l 592 -95 l 592 -174 l 368 -174 l 144 -174 l 144 -95 l 144 -16 l 77 -16 l 9 -16 l 6 -15 b 0 -1 1 -11 0 -6 b 9 13 0 5 2 11 "
                        },
                        rhl: {
                            x_min: 0,
                            x_max: 737.71875,
                            ha: 753,
                            o: "m 144 94 l 144 173 l 368 173 l 592 173 l 592 94 l 592 15 l 660 15 l 726 15 l 729 12 b 737 -1 735 9 737 4 b 729 -15 737 -6 735 -11 l 726 -16 l 368 -16 l 9 -16 l 6 -15 b 0 -1 1 -11 0 -6 b 6 12 0 4 1 9 l 9 15 l 77 15 l 144 15 l 144 94 "
                        }
                    },
                    cssFontWeight: "normal",
                    ascender: 1903,
                    underlinePosition: -125,
                    cssFontStyle: "normal",
                    boundingBox: {
                        yMin: -2065.375,
                        xMin: -695.53125,
                        yMax: 1901.578125,
                        xMax: 1159.671875
                    },
                    resolution: 1e3,
                    descender: -2066,
                    familyName: "VexFlow-18",
                    lineHeight: 4093,
                    underlineThickness: 50
                };
                function d(t, e, i, s, n, r) {
                    let o, a, l, h = 0;
                    function c() {
                        return e + t[h++] * s;
                    }
                    function u() {
                        return i + t[h++] * n;
                    }
                    for(; h < t.length;)switch(o = t[h++], o){
                        case "m":
                        case "l":
                            r[o](c(), u());
                            break;
                        case "q":
                            a = c(), l = u(), r.q(c(), u(), a, l);
                            break;
                        case "b":
                            a = c(), l = u(), r.b(c(), u(), c(), u(), a, l);
                    }
                }
                const f = new WeakMap;
                class m extends l {
                    static loadMetrics(t, e, i) {
                        const n = t.glyphs[e];
                        if (!n) throw new s.RERR("BadGlyph", `Glyph ${e} does not exist in font.`);
                        const r = n.x_min, o = n.x_max, a = n.ha;
                        let l;
                        if (n.o) return i ? n.cached_outline ? l = n.cached_outline : (l = n.o.split(" "), n.cached_outline = l) : (n.cached_outline && delete n.cached_outline, l = n.o.split(" ")), {
                            x_min: r,
                            x_max: o,
                            ha: a,
                            outline: l
                        };
                        throw new s.RERR("BadGlyph", `Glyph ${e} has no outline defined.`);
                    }
                    static renderGlyph(t, e, i, s, n, r) {
                        const o = 72 * s / (100 * u.resolution), a = m.loadMetrics(u, n, !r);
                        m.renderOutline(t, a.outline, o, e, i);
                    }
                    static renderOutline(t, e, i, s, n) {
                        if (t.drawCachedGlyphOutline && t.drawCachedGlyphOutline(e, i, s, n)) return;
                        t.beginPath();
                        const r = function(t, e) {
                            let i = f.get(t);
                            i || (i = new Map, f.set(t, i));
                            let s = i.get(e);
                            return s || (s = [], d(t, 0, 0, e, -e, {
                                m: (t, e)=>s.push([
                                        "m",
                                        t,
                                        e
                                    ]),
                                l: (t, e)=>s.push([
                                        "l",
                                        t,
                                        e
                                    ]),
                                q: (t, e, i, n)=>s.push([
                                        "q",
                                        t,
                                        e,
                                        i,
                                        n
                                    ]),
                                b: (t, e, i, n, r, o)=>s.push([
                                        "b",
                                        t,
                                        e,
                                        i,
                                        n,
                                        r,
                                        o
                                    ])
                            }), i.set(e, s)), s;
                        }(e, i);
                        for(let e = 0; e < r.length; e++){
                            const i = r[e];
                            switch(i[0]){
                                case "m":
                                    t.moveTo(s + i[1], n + i[2]);
                                    break;
                                case "l":
                                    t.lineTo(s + i[1], n + i[2]);
                                    break;
                                case "q":
                                    t.quadraticCurveTo(s + i[1], n + i[2], s + i[3], n + i[4]);
                                    break;
                                case "b":
                                    t.bezierCurveTo(s + i[1], n + i[2], s + i[3], n + i[4], s + i[5], n + i[6]);
                            }
                        }
                        t.fill();
                    }
                    static getOutlineBoundingBox(t, e, i, s) {
                        const n = new h;
                        return d(t, i, s, e, -e, {
                            m: n.addPoint.bind(n),
                            l: n.addPoint.bind(n),
                            q: n.addQuadraticCurve.bind(n),
                            b: n.addBezierCurve.bind(n)
                        }), new c(n.x1, n.y1, n.width(), n.height());
                    }
                    static cachedWidth(t, e) {
                        const i = u;
                        let s = i.cached_widths;
                        s || (s = Object.create(null), i.cached_widths = s);
                        let n = s[t];
                        void 0 === n && (n = Object.create(null), s[t] = n);
                        let r = n[e];
                        return void 0 === r && (r = new m(t, e).getMetrics().width, n[e] = r), r;
                    }
                    constructor(t, e, i){
                        super(), this.setAttribute("type", "Glyph"), this.code = t, this.point = e, this.options = {
                            cache: !0,
                            font: u
                        }, this.metrics = null, this.x_shift = 0, this.y_shift = 0, this.originShift = {
                            x: 0,
                            y: 0
                        }, i ? this.setOptions(i) : this.reset();
                    }
                    setOptions(t) {
                        s.Merge(this.options, t), this.reset();
                    }
                    setPoint(t) {
                        return this.point = t, this;
                    }
                    setStave(t) {
                        return this.stave = t, this;
                    }
                    setXShift(t) {
                        return this.x_shift = t, this;
                    }
                    setYShift(t) {
                        return this.y_shift = t, this;
                    }
                    reset() {
                        if (this.scale = 72 * this.point / (100 * this.options.font.resolution), this.metrics = m.loadMetrics(this.options.font, this.code, this.options.cache), this.options.cache) {
                            const t = this.code + "/" + this.scale;
                            let e = this.options.font.cached_bboxes;
                            e || (e = Object.create(null), this.options.font.cached_bboxes = e);
                            let i = e[t];
                            if (!i) {
                                const s = m.getOutlineBoundingBox(this.metrics.outline, this.scale, 0, 0);
                                i = [
                                    s.getX(),
                                    s.getY(),
                                    s.getW(),
                                    s.getH()
                                ], e[t] = i;
                            }
                            this.bbox = new c(i[0], i[1], i[2], i[3]);
                        } else this.bbox = m.getOutlineBoundingBox(this.metrics.outline, this.scale, 0, 0);
                    }
                    getMetrics() {
                        if (!this.metrics) throw new s.RuntimeError("BadGlyph", `Glyph ${this.code} is not initialized.`);
                        return {
                            x_min: this.metrics.x_min * this.scale,
                            x_max: this.metrics.x_max * this.scale,
                            width: this.bbox.getW(),
                            height: this.bbox.getH()
                        };
                    }
                    setOriginX(t) {
                        const { bbox: e } = this, i = (t - Math.abs(e.getX() / e.getW())) * e.getW();
                        this.originShift.x = -i;
                    }
                    setOriginY(t) {
                        const { bbox: e } = this, i = (t - Math.abs(e.getY() / e.getH())) * e.getH();
                        this.originShift.y = -i;
                    }
                    setOrigin(t, e) {
                        this.setOriginX(t), this.setOriginY(e);
                    }
                    render(t, e, i) {
                        if (!this.metrics) throw new s.RuntimeError("BadGlyph", `Glyph ${this.code} is not initialized.`);
                        const n = this.metrics.outline, r = this.scale;
                        this.setRendered(), this.applyStyle(t), m.renderOutline(t, n, r, e + this.originShift.x, i + this.originShift.y), this.restoreStyle(t);
                    }
                    renderToStave(t) {
                        if (this.checkContext(), !this.metrics) throw new s.RuntimeError("BadGlyph", `Glyph ${this.code} is not initialized.`);
                        if (!this.stave) throw new s.RuntimeError("GlyphError", "No valid stave");
                        const e = this.metrics.outline, i = this.scale;
                        this.setRendered(), this.applyStyle(), m.renderOutline(this.context, e, i, t + this.x_shift, this.stave.getYForGlyphs() + this.y_shift), this.restoreStyle();
                    }
                }
                const p = {
                    STEM_WIDTH: 1.5,
                    STEM_HEIGHT: 35,
                    STAVE_LINE_THICKNESS: 1,
                    RESOLUTION: 16384,
                    DEFAULT_NOTATION_FONT_SCALE: 39,
                    DEFAULT_TABLATURE_FONT_SCALE: 39,
                    SLASH_NOTEHEAD_WIDTH: 15,
                    TEXT_HEIGHT_OFFSET_HACK: 1,
                    IsKerned: !0,
                    clefProperties: (t)=>{
                        if (!t) throw new s.RERR("BadArgument", "Invalid clef: " + t);
                        const e = p.clefProperties.values[t];
                        if (!e) throw new s.RERR("BadArgument", "Invalid clef: " + t);
                        return e;
                    }
                };
                p.clefProperties.values = {
                    treble: {
                        line_shift: 0
                    },
                    bass: {
                        line_shift: 6
                    },
                    tenor: {
                        line_shift: 4
                    },
                    alto: {
                        line_shift: 3
                    },
                    soprano: {
                        line_shift: 1
                    },
                    percussion: {
                        line_shift: 0
                    },
                    "mezzo-soprano": {
                        line_shift: 2
                    },
                    "baritone-c": {
                        line_shift: 5
                    },
                    "baritone-f": {
                        line_shift: 5
                    },
                    subbass: {
                        line_shift: 7
                    },
                    french: {
                        line_shift: -1
                    }
                }, p.keyProperties = (t, e, i)=>{
                    void 0 === e && (e = "treble");
                    const n = {
                        octave_shift: 0
                    };
                    "object" == typeof i && s.Merge(n, i);
                    const r = t.split("/");
                    if (r.length < 2) throw new s.RERR("BadArguments", `Key must have note + octave and an optional glyph: ${t}`);
                    const o = r[0].toUpperCase(), a = p.keyProperties.note_values[o];
                    if (!a) throw new s.RERR("BadArguments", "Invalid key name: " + o);
                    a.octave && (r[1] = a.octave);
                    let l = parseInt(r[1], 10);
                    l -= n.octave_shift;
                    let h = (7 * l - 28 + a.index) / 2;
                    h += p.clefProperties(e).line_shift;
                    let c = 0;
                    h <= 0 && 2 * h % 2 == 0 && (c = 1), h >= 6 && 2 * h % 2 == 0 && (c = -1);
                    const u = void 0 !== a.int_val ? 12 * l + a.int_val : null, d = a.code, f = a.shift_right;
                    let m = {};
                    if (r.length > 2 && r[2]) {
                        const t = r[2].toUpperCase();
                        m = p.keyProperties.customNoteHeads[t] || {};
                    }
                    return {
                        key: o,
                        octave: l,
                        line: h,
                        int_value: u,
                        accidental: a.accidental,
                        code: d,
                        stroke: c,
                        shift_right: f,
                        displaced: !1,
                        ...m
                    };
                }, p.keyProperties.note_values = {
                    C: {
                        index: 0,
                        int_val: 0,
                        accidental: null
                    },
                    CN: {
                        index: 0,
                        int_val: 0,
                        accidental: "n"
                    },
                    "C#": {
                        index: 0,
                        int_val: 1,
                        accidental: "#"
                    },
                    "C##": {
                        index: 0,
                        int_val: 2,
                        accidental: "##"
                    },
                    CB: {
                        index: 0,
                        int_val: -1,
                        accidental: "b"
                    },
                    CBB: {
                        index: 0,
                        int_val: -2,
                        accidental: "bb"
                    },
                    D: {
                        index: 1,
                        int_val: 2,
                        accidental: null
                    },
                    DN: {
                        index: 1,
                        int_val: 2,
                        accidental: "n"
                    },
                    "D#": {
                        index: 1,
                        int_val: 3,
                        accidental: "#"
                    },
                    "D##": {
                        index: 1,
                        int_val: 4,
                        accidental: "##"
                    },
                    DB: {
                        index: 1,
                        int_val: 1,
                        accidental: "b"
                    },
                    DBB: {
                        index: 1,
                        int_val: 0,
                        accidental: "bb"
                    },
                    E: {
                        index: 2,
                        int_val: 4,
                        accidental: null
                    },
                    EN: {
                        index: 2,
                        int_val: 4,
                        accidental: "n"
                    },
                    "E#": {
                        index: 2,
                        int_val: 5,
                        accidental: "#"
                    },
                    "E##": {
                        index: 2,
                        int_val: 6,
                        accidental: "##"
                    },
                    EB: {
                        index: 2,
                        int_val: 3,
                        accidental: "b"
                    },
                    EBB: {
                        index: 2,
                        int_val: 2,
                        accidental: "bb"
                    },
                    F: {
                        index: 3,
                        int_val: 5,
                        accidental: null
                    },
                    FN: {
                        index: 3,
                        int_val: 5,
                        accidental: "n"
                    },
                    "F#": {
                        index: 3,
                        int_val: 6,
                        accidental: "#"
                    },
                    "F##": {
                        index: 3,
                        int_val: 7,
                        accidental: "##"
                    },
                    FB: {
                        index: 3,
                        int_val: 4,
                        accidental: "b"
                    },
                    FBB: {
                        index: 3,
                        int_val: 3,
                        accidental: "bb"
                    },
                    G: {
                        index: 4,
                        int_val: 7,
                        accidental: null
                    },
                    GN: {
                        index: 4,
                        int_val: 7,
                        accidental: "n"
                    },
                    "G#": {
                        index: 4,
                        int_val: 8,
                        accidental: "#"
                    },
                    "G##": {
                        index: 4,
                        int_val: 9,
                        accidental: "##"
                    },
                    GB: {
                        index: 4,
                        int_val: 6,
                        accidental: "b"
                    },
                    GBB: {
                        index: 4,
                        int_val: 5,
                        accidental: "bb"
                    },
                    A: {
                        index: 5,
                        int_val: 9,
                        accidental: null
                    },
                    AN: {
                        index: 5,
                        int_val: 9,
                        accidental: "n"
                    },
                    "A#": {
                        index: 5,
                        int_val: 10,
                        accidental: "#"
                    },
                    "A##": {
                        index: 5,
                        int_val: 11,
                        accidental: "##"
                    },
                    AB: {
                        index: 5,
                        int_val: 8,
                        accidental: "b"
                    },
                    ABB: {
                        index: 5,
                        int_val: 7,
                        accidental: "bb"
                    },
                    B: {
                        index: 6,
                        int_val: 11,
                        accidental: null
                    },
                    BN: {
                        index: 6,
                        int_val: 11,
                        accidental: "n"
                    },
                    "B#": {
                        index: 6,
                        int_val: 12,
                        accidental: "#"
                    },
                    "B##": {
                        index: 6,
                        int_val: 13,
                        accidental: "##"
                    },
                    BB: {
                        index: 6,
                        int_val: 10,
                        accidental: "b"
                    },
                    BBB: {
                        index: 6,
                        int_val: 9,
                        accidental: "bb"
                    },
                    R: {
                        index: 6,
                        int_val: 9,
                        rest: !0
                    },
                    X: {
                        index: 6,
                        accidental: "",
                        octave: 4,
                        code: "v3e",
                        shift_right: 5.5
                    }
                }, p.keyProperties.customNoteHeads = {
                    D0: {
                        code: "v27",
                        shift_right: 0,
                        stem_up_x_offset: 0,
                        stem_down_x_offset: 0,
                        stem_up_y_offset: -1,
                        stem_down_y_offset: 0
                    },
                    D1: {
                        code: "v2d",
                        shift_right: -0.5
                    },
                    D2: {
                        code: "v22",
                        shift_right: -0.5
                    },
                    D3: {
                        code: "v70",
                        shift_right: -0.5
                    },
                    T0: {
                        code: "v49",
                        shift_right: -2,
                        stem_up_y_offset: -4,
                        stem_down_y_offset: 4
                    },
                    T1: {
                        code: "v93",
                        shift_right: .5,
                        stem_up_y_offset: -4,
                        stem_down_y_offset: 4
                    },
                    T2: {
                        code: "v40",
                        shift_right: .5,
                        stem_up_y_offset: -4,
                        stem_down_y_offset: 4
                    },
                    T3: {
                        code: "v7d",
                        shift_right: .5,
                        stem_up_y_offset: -4,
                        stem_down_y_offset: 4
                    },
                    TI: {
                        code: "v11",
                        shift_right: 0,
                        stem_up_y_shift: 5,
                        stem_down_y_shift: 5,
                        stem_up_x_offset: 6,
                        stem_down_x_offset: 4
                    },
                    X0: {
                        code: "v92",
                        stem_up_x_offset: -2,
                        stem_down_x_offset: 0,
                        stem_up_y_offset: 4,
                        stem_down_y_offset: 4
                    },
                    X1: {
                        code: "v95",
                        shift_right: -0.5,
                        stem_up_y_offset: 4,
                        stem_down_y_offset: 4
                    },
                    X2: {
                        code: "v3e",
                        shift_right: .5,
                        stem_up_y_offset: 4,
                        stem_down_y_offset: 4
                    },
                    X3: {
                        code: "v3b",
                        shift_right: 0,
                        stem_up_x_offset: -1.2,
                        stem_down_x_offset: 0,
                        stem_up_y_offset: -1,
                        stem_down_y_offset: 2
                    },
                    S1: {
                        code: "vd3",
                        shift_right: 0
                    },
                    S2: {
                        code: "vd2",
                        shift_right: 0
                    },
                    R1: {
                        code: "vd5",
                        shift_right: 0
                    },
                    R2: {
                        code: "vd4",
                        shift_right: 0
                    },
                    rwl: {
                        code: "rwl",
                        shift_right: 0
                    },
                    rhl: {
                        code: "rhl",
                        shift_right: 0
                    }
                }, p.integerToNote = (t)=>{
                    if (void 0 === t) throw new s.RERR("BadArguments", "Undefined integer for integerToNote");
                    if (t < -2) throw new s.RERR("BadArguments", `integerToNote requires integer > -2: ${t}`);
                    const e = p.integerToNote.table[t];
                    if (!e) throw new s.RERR("BadArguments", `Unknown note value for integer: ${t}`);
                    return e;
                }, p.integerToNote.table = {
                    0: "C",
                    1: "C#",
                    2: "D",
                    3: "D#",
                    4: "E",
                    5: "F",
                    6: "F#",
                    7: "G",
                    8: "G#",
                    9: "A",
                    10: "A#",
                    11: "B"
                }, p.tabToGlyph = (t, e = 1, i = !1)=>{
                    let s = null, n = 0, r = 0;
                    if ("X" === t.toString().toUpperCase()) {
                        s = "v7f", i && (s = "v3e");
                        const t = new m(s, p.DEFAULT_TABLATURE_FONT_SCALE * e).getMetrics();
                        n = t.width, r = -t.height / 2;
                    } else n = p.textWidth(t.toString());
                    return {
                        text: t,
                        code: s,
                        getWidth: ()=>n * e,
                        shift_y: r
                    };
                }, p.textWidth = (t)=>7 * t.toString().length, p.articulationCodes = (t)=>p.articulationCodes.articulations[t], p.articulationCodes.articulations = {
                    "a.": {
                        code: "v23",
                        between_lines: !0
                    },
                    av: {
                        code: "v28",
                        between_lines: !0
                    },
                    "a>": {
                        code: "v42",
                        between_lines: !0
                    },
                    "a-": {
                        code: "v25",
                        between_lines: !0
                    },
                    "a^": {
                        code: "va",
                        between_lines: !1
                    },
                    "a+": {
                        code: "v8b",
                        between_lines: !1
                    },
                    ao: {
                        code: "v94",
                        between_lines: !1
                    },
                    ah: {
                        code: "vb9",
                        between_lines: !1
                    },
                    "a@a": {
                        code: "v43",
                        between_lines: !1
                    },
                    "a@u": {
                        code: "v5b",
                        between_lines: !1
                    },
                    "a|": {
                        code: "v75",
                        between_lines: !1
                    },
                    am: {
                        code: "v97",
                        between_lines: !1
                    },
                    "a,": {
                        code: "vb3",
                        between_lines: !1
                    }
                }, p.accidentalCodes = (t)=>p.accidentalCodes.accidentals[t], p.accidentalCodes.accidentals = {
                    "#": {
                        code: "v18",
                        parenRightPaddingAdjustment: -1
                    },
                    "##": {
                        code: "v7f",
                        parenRightPaddingAdjustment: -1
                    },
                    b: {
                        code: "v44",
                        parenRightPaddingAdjustment: -2
                    },
                    bb: {
                        code: "v26",
                        parenRightPaddingAdjustment: -2
                    },
                    n: {
                        code: "v4e",
                        parenRightPaddingAdjustment: -1
                    },
                    "{": {
                        code: "v9c",
                        parenRightPaddingAdjustment: -1
                    },
                    "}": {
                        code: "v84",
                        parenRightPaddingAdjustment: -1
                    },
                    db: {
                        code: "v9e",
                        parenRightPaddingAdjustment: -1
                    },
                    d: {
                        code: "vab",
                        parenRightPaddingAdjustment: 0
                    },
                    bbs: {
                        code: "v90",
                        parenRightPaddingAdjustment: -1
                    },
                    "++": {
                        code: "v51",
                        parenRightPaddingAdjustment: -1
                    },
                    "+": {
                        code: "v78",
                        parenRightPaddingAdjustment: -1
                    },
                    "+-": {
                        code: "v8d",
                        parenRightPaddingAdjustment: -1
                    },
                    "++-": {
                        code: "v7a",
                        parenRightPaddingAdjustment: -1
                    },
                    bs: {
                        code: "vb7",
                        parenRightPaddingAdjustment: -1
                    },
                    bss: {
                        code: "v39",
                        parenRightPaddingAdjustment: -1
                    },
                    o: {
                        code: "vd0",
                        parenRightPaddingAdjustment: -1
                    },
                    k: {
                        code: "vd1",
                        parenRightPaddingAdjustment: -1
                    },
                    ashs: {
                        code: "vd6",
                        parenRightPaddingAdjustment: -1
                    },
                    afhf: {
                        code: "vd7",
                        parenRightPaddingAdjustment: -1
                    }
                }, p.accidentalColumnsTable = {
                    1: {
                        a: [
                            1
                        ],
                        b: [
                            1
                        ]
                    },
                    2: {
                        a: [
                            1,
                            2
                        ]
                    },
                    3: {
                        a: [
                            1,
                            3,
                            2
                        ],
                        b: [
                            1,
                            2,
                            1
                        ],
                        second_on_bottom: [
                            1,
                            2,
                            3
                        ]
                    },
                    4: {
                        a: [
                            1,
                            3,
                            4,
                            2
                        ],
                        b: [
                            1,
                            2,
                            3,
                            1
                        ],
                        spaced_out_tetrachord: [
                            1,
                            2,
                            1,
                            2
                        ]
                    },
                    5: {
                        a: [
                            1,
                            3,
                            5,
                            4,
                            2
                        ],
                        b: [
                            1,
                            2,
                            4,
                            3,
                            1
                        ],
                        spaced_out_pentachord: [
                            1,
                            2,
                            3,
                            2,
                            1
                        ],
                        very_spaced_out_pentachord: [
                            1,
                            2,
                            1,
                            2,
                            1
                        ]
                    },
                    6: {
                        a: [
                            1,
                            3,
                            5,
                            6,
                            4,
                            2
                        ],
                        b: [
                            1,
                            2,
                            4,
                            5,
                            3,
                            1
                        ],
                        spaced_out_hexachord: [
                            1,
                            3,
                            2,
                            1,
                            3,
                            2
                        ],
                        very_spaced_out_hexachord: [
                            1,
                            2,
                            1,
                            2,
                            1,
                            2
                        ]
                    }
                }, p.ornamentCodes = (t)=>p.ornamentCodes.ornaments[t], p.ornamentCodes.ornaments = {
                    mordent: {
                        code: "v1e"
                    },
                    mordent_inverted: {
                        code: "v45"
                    },
                    turn: {
                        code: "v72"
                    },
                    turn_inverted: {
                        code: "v33"
                    },
                    tr: {
                        code: "v1f"
                    },
                    upprall: {
                        code: "v60"
                    },
                    downprall: {
                        code: "vb4"
                    },
                    prallup: {
                        code: "v6d"
                    },
                    pralldown: {
                        code: "v2c"
                    },
                    upmordent: {
                        code: "v29"
                    },
                    downmordent: {
                        code: "v68"
                    },
                    lineprall: {
                        code: "v20"
                    },
                    prallprall: {
                        code: "v86"
                    }
                }, p.keySignature = (t)=>{
                    const e = p.keySignature.keySpecs[t];
                    if (!e) throw new s.RERR("BadKeySignature", `Bad key signature spec: '${t}'`);
                    if (!e.acc) return [];
                    const i = p.keySignature.accidentalList(e.acc), n = [];
                    for(let t = 0; t < e.num; ++t){
                        const s = i[t];
                        n.push({
                            type: e.acc,
                            line: s
                        });
                    }
                    return n;
                }, p.keySignature.keySpecs = {
                    C: {
                        acc: null,
                        num: 0
                    },
                    Am: {
                        acc: null,
                        num: 0
                    },
                    F: {
                        acc: "b",
                        num: 1
                    },
                    Dm: {
                        acc: "b",
                        num: 1
                    },
                    Bb: {
                        acc: "b",
                        num: 2
                    },
                    Gm: {
                        acc: "b",
                        num: 2
                    },
                    Eb: {
                        acc: "b",
                        num: 3
                    },
                    Cm: {
                        acc: "b",
                        num: 3
                    },
                    Ab: {
                        acc: "b",
                        num: 4
                    },
                    Fm: {
                        acc: "b",
                        num: 4
                    },
                    Db: {
                        acc: "b",
                        num: 5
                    },
                    Bbm: {
                        acc: "b",
                        num: 5
                    },
                    Gb: {
                        acc: "b",
                        num: 6
                    },
                    Ebm: {
                        acc: "b",
                        num: 6
                    },
                    Cb: {
                        acc: "b",
                        num: 7
                    },
                    Abm: {
                        acc: "b",
                        num: 7
                    },
                    G: {
                        acc: "#",
                        num: 1
                    },
                    Em: {
                        acc: "#",
                        num: 1
                    },
                    D: {
                        acc: "#",
                        num: 2
                    },
                    Bm: {
                        acc: "#",
                        num: 2
                    },
                    A: {
                        acc: "#",
                        num: 3
                    },
                    "F#m": {
                        acc: "#",
                        num: 3
                    },
                    E: {
                        acc: "#",
                        num: 4
                    },
                    "C#m": {
                        acc: "#",
                        num: 4
                    },
                    B: {
                        acc: "#",
                        num: 5
                    },
                    "G#m": {
                        acc: "#",
                        num: 5
                    },
                    "F#": {
                        acc: "#",
                        num: 6
                    },
                    "D#m": {
                        acc: "#",
                        num: 6
                    },
                    "C#": {
                        acc: "#",
                        num: 7
                    },
                    "A#m": {
                        acc: "#",
                        num: 7
                    }
                }, p.unicode = {
                    sharp: String.fromCharCode(parseInt("266F", 16)),
                    flat: String.fromCharCode(parseInt("266D", 16)),
                    natural: String.fromCharCode(parseInt("266E", 16)),
                    triangle: String.fromCharCode(parseInt("25B3", 16)),
                    "o-with-slash": String.fromCharCode(parseInt("00F8", 16)),
                    degrees: String.fromCharCode(parseInt("00B0", 16)),
                    circle: String.fromCharCode(parseInt("25CB", 16))
                }, p.keySignature.accidentalList = (t)=>({
                        b: [
                            2,
                            .5,
                            2.5,
                            1,
                            3,
                            1.5,
                            3.5
                        ],
                        "#": [
                            0,
                            1.5,
                            -0.5,
                            1,
                            2.5,
                            .5,
                            2
                        ]
                    })[t], p.parseNoteDurationString = (t)=>{
                    if ("string" != typeof t) return null;
                    const e = /(\d*\/?\d+|[a-z])(d*)([nrhms]|$)/.exec(t);
                    if (!e) return null;
                    const i = e[1], s = e[2].length;
                    let n = e[3];
                    return 0 === n.length && (n = "n"), {
                        duration: i,
                        dots: s,
                        type: n
                    };
                }, p.parseNoteStruct = (t)=>{
                    const e = t.duration, i = p.parseNoteDurationString(e);
                    if (!i) return null;
                    let s = p.durationToTicks(i.duration);
                    if (null == s) return null;
                    let n = t.type;
                    const r = [];
                    if (n) {
                        if (!p.getGlyphProps.validTypes[n]) return null;
                    } else n = i.type || "n", void 0 !== t.keys && t.keys.forEach((t, e)=>{
                        const i = t.split("/");
                        i && 3 === i.length && (r[e] = i[2]);
                    });
                    const o = t.dots ? t.dots : i.dots;
                    if ("number" != typeof o) return null;
                    let a = s;
                    for(let t = 0; t < o; t++){
                        if (a <= 1) return null;
                        a /= 2, s += a;
                    }
                    return {
                        duration: i.duration,
                        type: n,
                        customTypes: r,
                        dots: o,
                        ticks: s
                    };
                }, p.sanitizeDuration = (t)=>{
                    const e = p.durationAliases[t];
                    if (void 0 !== e && (t = e), void 0 === p.durationToTicks.durations[t]) throw new s.RERR("BadArguments", `The provided duration is not valid: ${t}`);
                    return t;
                }, p.durationToFraction = (t)=>(new n).parse(p.sanitizeDuration(t)), p.durationToNumber = (t)=>p.durationToFraction(t).value(), p.durationToTicks = (t)=>{
                    t = p.sanitizeDuration(t);
                    const e = p.durationToTicks.durations[t];
                    return void 0 === e ? null : e;
                }, p.durationToTicks.durations = {
                    "1/2": 2 * p.RESOLUTION,
                    1: p.RESOLUTION / 1,
                    2: p.RESOLUTION / 2,
                    4: p.RESOLUTION / 4,
                    8: p.RESOLUTION / 8,
                    16: p.RESOLUTION / 16,
                    32: p.RESOLUTION / 32,
                    64: p.RESOLUTION / 64,
                    128: p.RESOLUTION / 128,
                    256: p.RESOLUTION / 256
                }, p.durationAliases = {
                    w: "1",
                    h: "2",
                    q: "4",
                    b: "256"
                }, p.getGlyphProps = (t, e)=>{
                    t = p.sanitizeDuration(t);
                    const i = p.getGlyphProps.duration_codes[t];
                    if (void 0 === i) return null;
                    e || (e = "n");
                    let s = i.type[e];
                    if (void 0 === s) {
                        const t = p.keyProperties.customNoteHeads[e.toUpperCase()];
                        if (void 0 === t) return null;
                        s = {
                            code_head: t.code,
                            ...t
                        };
                    }
                    return {
                        ...i.common,
                        ...s
                    };
                }, p.getGlyphProps.validTypes = {
                    n: {
                        name: "note"
                    },
                    r: {
                        name: "rest"
                    },
                    h: {
                        name: "harmonic"
                    },
                    m: {
                        name: "muted"
                    },
                    s: {
                        name: "slash"
                    }
                }, p.getGlyphProps.duration_codes = {
                    "1/2": {
                        common: {
                            getWidth (t = p.DEFAULT_NOTATION_FONT_SCALE) {
                                return m.cachedWidth(this.code_head || "v53", t);
                            },
                            stem: !1,
                            stem_offset: 0,
                            flag: !1,
                            stem_up_extension: -p.STEM_HEIGHT,
                            stem_down_extension: -p.STEM_HEIGHT,
                            tabnote_stem_up_extension: -p.STEM_HEIGHT,
                            tabnote_stem_down_extension: -p.STEM_HEIGHT,
                            dot_shiftY: 0,
                            line_above: 0,
                            line_below: 0
                        },
                        type: {
                            n: {
                                code_head: "v53"
                            },
                            h: {
                                code_head: "v59"
                            },
                            m: {
                                code_head: "vf",
                                stem_offset: 0
                            },
                            r: {
                                code_head: "v31",
                                rest: !0,
                                position: "B/5",
                                dot_shiftY: .5
                            },
                            s: {
                                getWidth: ()=>p.SLASH_NOTEHEAD_WIDTH,
                                position: "B/4"
                            }
                        }
                    },
                    1: {
                        common: {
                            getWidth (t = p.DEFAULT_NOTATION_FONT_SCALE) {
                                return m.cachedWidth(this.code_head || "v1d", t);
                            },
                            stem: !1,
                            stem_offset: 0,
                            flag: !1,
                            stem_up_extension: -p.STEM_HEIGHT,
                            stem_down_extension: -p.STEM_HEIGHT,
                            tabnote_stem_up_extension: -p.STEM_HEIGHT,
                            tabnote_stem_down_extension: -p.STEM_HEIGHT,
                            dot_shiftY: 0,
                            line_above: 0,
                            line_below: 0
                        },
                        type: {
                            n: {
                                code_head: "v1d"
                            },
                            h: {
                                code_head: "v46"
                            },
                            m: {
                                code_head: "v92",
                                stem_offset: -3
                            },
                            r: {
                                code_head: "v5c",
                                rest: !0,
                                position: "D/5",
                                dot_shiftY: .5
                            },
                            s: {
                                getWidth: ()=>p.SLASH_NOTEHEAD_WIDTH,
                                position: "B/4"
                            }
                        }
                    },
                    2: {
                        common: {
                            getWidth (t = p.DEFAULT_NOTATION_FONT_SCALE) {
                                return m.cachedWidth(this.code_head || "v81", t);
                            },
                            stem: !0,
                            stem_offset: 0,
                            flag: !1,
                            stem_up_extension: 0,
                            stem_down_extension: 0,
                            tabnote_stem_up_extension: 0,
                            tabnote_stem_down_extension: 0,
                            dot_shiftY: 0,
                            line_above: 0,
                            line_below: 0
                        },
                        type: {
                            n: {
                                code_head: "v81"
                            },
                            h: {
                                code_head: "v2d"
                            },
                            m: {
                                code_head: "v95",
                                stem_offset: -3
                            },
                            r: {
                                code_head: "vc",
                                stem: !1,
                                rest: !0,
                                position: "B/4",
                                dot_shiftY: -0.5
                            },
                            s: {
                                getWidth: ()=>p.SLASH_NOTEHEAD_WIDTH,
                                position: "B/4"
                            }
                        }
                    },
                    4: {
                        common: {
                            getWidth (t = p.DEFAULT_NOTATION_FONT_SCALE) {
                                return m.cachedWidth(this.code_head || "vb", t);
                            },
                            stem: !0,
                            stem_offset: 0,
                            flag: !1,
                            stem_up_extension: 0,
                            stem_down_extension: 0,
                            tabnote_stem_up_extension: 0,
                            tabnote_stem_down_extension: 0,
                            dot_shiftY: 0,
                            line_above: 0,
                            line_below: 0
                        },
                        type: {
                            n: {
                                code_head: "vb"
                            },
                            h: {
                                code_head: "v22"
                            },
                            m: {
                                code_head: "v3e",
                                stem_offset: -3
                            },
                            r: {
                                code_head: "v7c",
                                stem: !1,
                                rest: !0,
                                position: "B/4",
                                dot_shiftY: -0.5,
                                line_above: 1.5,
                                line_below: 1.5
                            },
                            s: {
                                getWidth: ()=>p.SLASH_NOTEHEAD_WIDTH,
                                position: "B/4"
                            }
                        }
                    },
                    8: {
                        common: {
                            getWidth (t = p.DEFAULT_NOTATION_FONT_SCALE) {
                                return m.cachedWidth(this.code_head || "vb", t);
                            },
                            stem: !0,
                            stem_offset: 0,
                            flag: !0,
                            beam_count: 1,
                            code_flag_upstem: "v54",
                            code_flag_downstem: "v9a",
                            stem_up_extension: 0,
                            stem_down_extension: 0,
                            tabnote_stem_up_extension: 0,
                            tabnote_stem_down_extension: 0,
                            dot_shiftY: 0,
                            line_above: 0,
                            line_below: 0
                        },
                        type: {
                            n: {
                                code_head: "vb"
                            },
                            h: {
                                code_head: "v22"
                            },
                            m: {
                                code_head: "v3e"
                            },
                            r: {
                                code_head: "va5",
                                stem: !1,
                                flag: !1,
                                rest: !0,
                                position: "B/4",
                                dot_shiftY: -0.5,
                                line_above: 1,
                                line_below: 1
                            },
                            s: {
                                getWidth: ()=>p.SLASH_NOTEHEAD_WIDTH,
                                position: "B/4"
                            }
                        }
                    },
                    16: {
                        common: {
                            beam_count: 2,
                            getWidth (t = p.DEFAULT_NOTATION_FONT_SCALE) {
                                return m.cachedWidth(this.code_head || "vb", t);
                            },
                            stem: !0,
                            stem_offset: 0,
                            flag: !0,
                            code_flag_upstem: "v3f",
                            code_flag_downstem: "v8f",
                            stem_up_extension: 0,
                            stem_down_extension: 0,
                            tabnote_stem_up_extension: 0,
                            tabnote_stem_down_extension: 0,
                            dot_shiftY: 0,
                            line_above: 0,
                            line_below: 0
                        },
                        type: {
                            n: {
                                code_head: "vb"
                            },
                            h: {
                                code_head: "v22"
                            },
                            m: {
                                code_head: "v3e"
                            },
                            r: {
                                code_head: "v3c",
                                stem: !1,
                                flag: !1,
                                rest: !0,
                                position: "B/4",
                                dot_shiftY: -0.5,
                                line_above: 1,
                                line_below: 2
                            },
                            s: {
                                getWidth: ()=>p.SLASH_NOTEHEAD_WIDTH,
                                position: "B/4"
                            }
                        }
                    },
                    32: {
                        common: {
                            beam_count: 3,
                            getWidth (t = p.DEFAULT_NOTATION_FONT_SCALE) {
                                return m.cachedWidth(this.code_head || "vb", t);
                            },
                            stem: !0,
                            stem_offset: 0,
                            flag: !0,
                            code_flag_upstem: "v47",
                            code_flag_downstem: "v2a",
                            stem_up_extension: 9,
                            stem_down_extension: 9,
                            tabnote_stem_up_extension: 8,
                            tabnote_stem_down_extension: 5,
                            dot_shiftY: 0,
                            line_above: 0,
                            line_below: 0
                        },
                        type: {
                            n: {
                                code_head: "vb"
                            },
                            h: {
                                code_head: "v22"
                            },
                            m: {
                                code_head: "v3e"
                            },
                            r: {
                                code_head: "v55",
                                stem: !1,
                                flag: !1,
                                rest: !0,
                                position: "B/4",
                                dot_shiftY: -1.5,
                                line_above: 2,
                                line_below: 2
                            },
                            s: {
                                getWidth: ()=>p.SLASH_NOTEHEAD_WIDTH,
                                position: "B/4"
                            }
                        }
                    },
                    64: {
                        common: {
                            beam_count: 4,
                            getWidth (t = p.DEFAULT_NOTATION_FONT_SCALE) {
                                return m.cachedWidth(this.code_head || "vb", t);
                            },
                            stem: !0,
                            stem_offset: 0,
                            flag: !0,
                            code_flag_upstem: "va9",
                            code_flag_downstem: "v58",
                            stem_up_extension: 13,
                            stem_down_extension: 13,
                            tabnote_stem_up_extension: 12,
                            tabnote_stem_down_extension: 9,
                            dot_shiftY: 0,
                            line_above: 0,
                            line_below: 0
                        },
                        type: {
                            n: {
                                code_head: "vb"
                            },
                            h: {
                                code_head: "v22"
                            },
                            m: {
                                code_head: "v3e"
                            },
                            r: {
                                code_head: "v38",
                                stem: !1,
                                flag: !1,
                                rest: !0,
                                position: "B/4",
                                dot_shiftY: -1.5,
                                line_above: 2,
                                line_below: 3
                            },
                            s: {
                                getWidth: ()=>p.SLASH_NOTEHEAD_WIDTH,
                                position: "B/4"
                            }
                        }
                    },
                    128: {
                        common: {
                            beam_count: 5,
                            getWidth (t = p.DEFAULT_NOTATION_FONT_SCALE) {
                                return m.cachedWidth(this.code_head || "vb", t);
                            },
                            stem: !0,
                            stem_offset: 0,
                            flag: !0,
                            code_flag_upstem: "v9b",
                            code_flag_downstem: "v30",
                            stem_up_extension: 22,
                            stem_down_extension: 22,
                            tabnote_stem_up_extension: 21,
                            tabnote_stem_down_extension: 18,
                            dot_shiftY: 0,
                            line_above: 0,
                            line_below: 0
                        },
                        type: {
                            n: {
                                code_head: "vb"
                            },
                            h: {
                                code_head: "v22"
                            },
                            m: {
                                code_head: "v3e"
                            },
                            r: {
                                code_head: "vaa",
                                stem: !1,
                                flag: !1,
                                rest: !0,
                                position: "B/4",
                                dot_shiftY: 1.5,
                                line_above: 3,
                                line_below: 3
                            },
                            s: {
                                getWidth: ()=>p.SLASH_NOTEHEAD_WIDTH,
                                position: "B/4"
                            }
                        }
                    }
                }, p.smufl = {}, p.smufl.to_code_points = {
                    bracketTop: "v1b",
                    bracketBottom: "v10",
                    barlineTick: "v6f",
                    segno: "v8c",
                    coda: "v4d",
                    gClef: "v83",
                    cClef: "vad",
                    fClef: "v79",
                    unpitchedPercussionClef1: "v59",
                    "6stringTabClef": "v2f",
                    timeSig0: "v0",
                    timeSig1: "v1",
                    timeSig2: "v2",
                    timeSig3: "v3",
                    timeSig4: "v4",
                    timeSig5: "v5",
                    timeSig6: "v6",
                    timeSig7: "v7",
                    timeSig8: "v8",
                    timeSig9: "v9",
                    timeSigCommon: "v41",
                    timeSigCutCommon: "vb6",
                    noteheadDoubleWhole: "v53",
                    noteheadWhole: "v1d",
                    noteheadHalf: "v81",
                    noteheadBlack: "vb",
                    noteheadXWhole: "v92",
                    noteheadXHalf: "v95",
                    noteheadXBlack: "v3e",
                    noteheadCircleX: "v3b",
                    noteheadTriangleUpWhole: "v49",
                    noteheadTriangleUpHalf: "v93",
                    noteheadTriangleUpBlack: "v40",
                    noteheadDiamondWhole: "v46",
                    noteheadDiamondHalf: "v2d",
                    noteheadDiamondBlack: "v22",
                    augmentationDot: "v23",
                    tremolo1: "v74",
                    flag8thUp: "v54",
                    flag8thDown: "v9a",
                    flag16thUp: "v3f",
                    flag16thDown: "v8f",
                    flag32ndUp: "v47",
                    flag32ndDown: "v2a",
                    flag64thUp: "va9",
                    flag64thDown: "v58",
                    flag128thUp: "v9b",
                    flag128thDown: "v30",
                    accidentalFlat: "v44",
                    accidentalNatural: "v4e",
                    accidentalSharp: "v18",
                    accidentalDoubleSharp: "v7f",
                    accidentalDoubleFlat: "v26",
                    accidentalParensLeft: "v9c",
                    accidentalParensRight: "v84",
                    accidentalQuarterToneFlatStein: "vab",
                    accidentalThreeQuarterTonesFlatZimmermann: "v9e",
                    accidentalQuarterToneSharpStein: "v78",
                    accidentalThreeQuarterTonesSharpStein: "v51",
                    accidentalBuyukMucennebFlat: "v39",
                    accidentalBakiyeFlat: "vb7",
                    accidentalKomaSharp: "v51",
                    accidentalKucukMucennebSharp: "v8d",
                    accidentalKoron: "vd1",
                    accidentalSori: "vd0",
                    articAccentAbove: "v42",
                    articAccentBelow: "v42",
                    articTenutoAbove: "v25",
                    articTenutoBelow: "v25",
                    articStaccatoAbove: "v23",
                    articStaccatoBelow: "v23",
                    articStaccatissimoAbove: "v28",
                    articMarcatoAbove: "va",
                    fermataAbove: "v43",
                    fermataBelow: "v5b",
                    breathMarkComma: "v6c",
                    breathMarkUpbow: "v8a",
                    caesura: "v34",
                    caesuraCurved: "v4b",
                    restMaxima: "v59",
                    restDoubleWhole: "v31",
                    restWhole: "v5c",
                    restHalf: "vc",
                    restQuarter: "v7c",
                    rest8th: "va5",
                    rest16th: "v3c",
                    rest32nd: "v55",
                    rest64th: "v38",
                    rest128th: "vaa",
                    dynamicPiano: "vbf",
                    dynamicMezzo: "v62",
                    dynamicForte: "vba",
                    dynamicRinforzando: "vba",
                    dynamicSforzando: "v4a",
                    dynamicZ: "v80",
                    ornamentTrill: "v1f",
                    ornamentTurn: "v72",
                    ornamentTurnSlash: "v33",
                    ornamentMordent: "v45",
                    ornamentMordentInverted: "v1e",
                    ornamentTremblement: "v86",
                    ornamentPrecompAppoggTrill: "v20",
                    ornamentPrecompSlideTrillDAnglebert: "v60",
                    ornamentPrecompSlideTrillBach: "v29",
                    ornamentPrecompTrillSuffixDandrieu: "v6d",
                    ornamentPrecompDoubleCadenceUpperPrefix: "vb4",
                    ornamentPrecompDoubleCadenceUpperPrefixTurn: "v68",
                    ornamentPrecompTrillLowerSuffix: "v2c",
                    stringsDownBow: "v94",
                    stringsUpBow: "v75",
                    stringsHarmonic: "vb9",
                    pluckedSnapPizzicatoAbove: "v94",
                    pluckedLeftHandPizzicato: "v8b",
                    keyboardPedalPed: "v36",
                    keyboardPedalUp: "v5d",
                    pictChokeCymbal: "vb3",
                    wiggleArpeggiatoUp: "va3",
                    arrowheadBlackUp: "vc3",
                    arrowheadBlackDown: "v52"
                }, p.TIME4_4 = {
                    num_beats: 4,
                    beat_value: 4,
                    resolution: p.RESOLUTION
                };
                class g {
                    static get WIDTH() {
                        return 600;
                    }
                    static get HEIGHT() {
                        return 400;
                    }
                    static get CANVAS_BROWSER_SIZE_LIMIT() {
                        return 32767;
                    }
                    static SanitizeCanvasDims(t, e) {
                        return Math.max(t, e) > this.CANVAS_BROWSER_SIZE_LIMIT && (s.W("Canvas dimensions exceed browser limit. Cropping to " + this.CANVAS_BROWSER_SIZE_LIMIT), t > this.CANVAS_BROWSER_SIZE_LIMIT && (t = this.CANVAS_BROWSER_SIZE_LIMIT), e > this.CANVAS_BROWSER_SIZE_LIMIT && (e = this.CANVAS_BROWSER_SIZE_LIMIT)), [
                            t,
                            e
                        ];
                    }
                    constructor(t){
                        this.vexFlowCanvasContext = t, t.canvas ? this.canvas = t.canvas : this.canvas = {
                            width: g.WIDTH,
                            height: g.HEIGHT
                        };
                    }
                    clear() {
                        this.vexFlowCanvasContext.clearRect(0, 0, this.canvas.width, this.canvas.height);
                    }
                    openGroup() {}
                    closeGroup() {}
                    add() {}
                    setFont(t, e, i) {
                        return this.vexFlowCanvasContext.font = (i || "") + " " + e + "pt " + t, this;
                    }
                    setRawFont(t) {
                        return this.vexFlowCanvasContext.font = t, this;
                    }
                    setFillStyle(t) {
                        return this.vexFlowCanvasContext.fillStyle = t, this;
                    }
                    setBackgroundFillStyle(t) {
                        return this.background_fillStyle = t, this;
                    }
                    setStrokeStyle(t) {
                        return this.vexFlowCanvasContext.strokeStyle = t, this;
                    }
                    setShadowColor(t) {
                        return this.vexFlowCanvasContext.shadowColor = t, this;
                    }
                    setShadowBlur(t) {
                        return this.vexFlowCanvasContext.shadowBlur = t, this;
                    }
                    setLineWidth(t) {
                        return this.vexFlowCanvasContext.lineWidth = t, this;
                    }
                    setLineCap(t) {
                        return this.vexFlowCanvasContext.lineCap = t, this;
                    }
                    setLineDash(t) {
                        return this.vexFlowCanvasContext.lineDash = t, this;
                    }
                    scale(t, e) {
                        return this.vexFlowCanvasContext.scale(parseFloat(t), parseFloat(e));
                    }
                    resize(t, e) {
                        return [t, e] = this.SanitizeCanvasDims(parseInt(t, 10), parseInt(e, 10)), this.vexFlowCanvasContext.resize(t, e);
                    }
                    rect(t, e, i, s) {
                        return this.vexFlowCanvasContext.rect(t, e, i, s);
                    }
                    fillRect(t, e, i, s) {
                        return this.vexFlowCanvasContext.fillRect(t, e, i, s);
                    }
                    clearRect(t, e, i, s) {
                        return this.vexFlowCanvasContext.clearRect(t, e, i, s);
                    }
                    beginPath() {
                        return this.vexFlowCanvasContext.beginPath();
                    }
                    moveTo(t, e) {
                        return this.vexFlowCanvasContext.moveTo(t, e);
                    }
                    lineTo(t, e) {
                        return this.vexFlowCanvasContext.lineTo(t, e);
                    }
                    bezierCurveTo(t, e, i, s, n, r) {
                        return this.vexFlowCanvasContext.bezierCurveTo(t, e, i, s, n, r);
                    }
                    quadraticCurveTo(t, e, i, s) {
                        return this.vexFlowCanvasContext.quadraticCurveTo(t, e, i, s);
                    }
                    arc(t, e, i, s, n, r) {
                        return this.vexFlowCanvasContext.arc(t, e, i, s, n, r);
                    }
                    glow() {
                        return this.vexFlowCanvasContext.glow();
                    }
                    fill() {
                        return this.vexFlowCanvasContext.fill();
                    }
                    stroke() {
                        return this.vexFlowCanvasContext.stroke();
                    }
                    closePath() {
                        return this.vexFlowCanvasContext.closePath();
                    }
                    measureText(t) {
                        return this.vexFlowCanvasContext.measureText(t);
                    }
                    fillText(t, e, i) {
                        return this.vexFlowCanvasContext.fillText(t, e, i);
                    }
                    save() {
                        return this.vexFlowCanvasContext.save();
                    }
                    restore() {
                        return this.vexFlowCanvasContext.restore();
                    }
                }
                class b {
                    constructor(t){
                        this.element = t, this.paper = Raphael(t), this.path = "", this.pen = {
                            x: 0,
                            y: 0
                        }, this.lineWidth = 1, this.state = {
                            scale: {
                                x: 1,
                                y: 1
                            },
                            font_family: "Arial",
                            font_size: 8,
                            font_weight: 800
                        }, this.attributes = {
                            "stroke-width": .3,
                            fill: "black",
                            stroke: "black",
                            font: "10pt Arial"
                        }, this.background_attributes = {
                            "stroke-width": 0,
                            fill: "white",
                            stroke: "white",
                            font: "10pt Arial"
                        }, this.shadow_attributes = {
                            width: 0,
                            color: "black"
                        }, this.state_stack = [];
                    }
                    openGroup() {}
                    closeGroup() {}
                    add() {}
                    setFont(t, e, i) {
                        return this.state.font_family = t, this.state.font_size = e, this.state.font_weight = i, this.attributes.font = (this.state.font_weight || "") + " " + this.state.font_size * this.state.scale.x + "pt " + this.state.font_family, this;
                    }
                    setRawFont(t) {
                        return this.attributes.font = t, this;
                    }
                    setFillStyle(t) {
                        return this.attributes.fill = t, this;
                    }
                    setBackgroundFillStyle(t) {
                        return this.background_attributes.fill = t, this.background_attributes.stroke = t, this;
                    }
                    setStrokeStyle(t) {
                        return this.attributes.stroke = t, this;
                    }
                    setShadowColor(t) {
                        return this.shadow_attributes.color = t, this;
                    }
                    setShadowBlur(t) {
                        return this.shadow_attributes.width = t, this;
                    }
                    setLineWidth(t) {
                        this.attributes["stroke-width"] = t, this.lineWidth = t;
                    }
                    setLineDash() {
                        return this;
                    }
                    setLineCap() {
                        return this;
                    }
                    scale(t, e) {
                        return this.state.scale = {
                            x: t,
                            y: e
                        }, this.attributes.transform = "S" + t + "," + e + ",0,0", this.attributes.scale = t + "," + e + ",0,0", this.attributes.font = this.state.font_size * this.state.scale.x + "pt " + this.state.font_family, this.background_attributes.transform = "S" + t + "," + e + ",0,0", this.background_attributes.font = this.state.font_size * this.state.scale.x + "pt " + this.state.font_family, this;
                    }
                    clear() {
                        this.paper.clear();
                    }
                    resize(t, e) {
                        return this.element.style.width = t, this.paper.setSize(t, e), this;
                    }
                    setViewBox(t) {
                        this.paper.canvas.setAttribute("viewBox", t);
                    }
                    rect(t, e, i, s) {
                        return s < 0 && (e += s, s = -s), this.paper.rect(t, e, i - .5, s - .5).attr(this.attributes).attr("fill", "none").attr("stroke-width", this.lineWidth), this;
                    }
                    fillRect(t, e, i, s) {
                        return s < 0 && (e += s, s = -s), this.paper.rect(t, e, i - .5, s - .5).attr(this.attributes), this;
                    }
                    clearRect(t, e, i, s) {
                        return s < 0 && (e += s, s = -s), this.paper.rect(t, e, i - .5, s - .5).attr(this.background_attributes), this;
                    }
                    beginPath() {
                        return this.path = "", this.pen.x = 0, this.pen.y = 0, this;
                    }
                    moveTo(t, e) {
                        return this.path += "M" + t + "," + e, this.pen.x = t, this.pen.y = e, this;
                    }
                    lineTo(t, e) {
                        return this.path += "L" + t + "," + e, this.pen.x = t, this.pen.y = e, this;
                    }
                    bezierCurveTo(t, e, i, s, n, r) {
                        return this.path += "C" + t + "," + e + "," + i + "," + s + "," + n + "," + r, this.pen.x = n, this.pen.y = r, this;
                    }
                    quadraticCurveTo(t, e, i, s) {
                        return this.path += "Q" + t + "," + e + "," + i + "," + s, this.pen.x = i, this.pen.y = s, this;
                    }
                    arc(t, e, i, s, n, r) {
                        function o(t) {
                            for(; t < 0;)t += 2 * Math.PI;
                            for(; t > 2 * Math.PI;)t -= 2 * Math.PI;
                            return t;
                        }
                        if ((s = o(s)) > (n = o(n))) {
                            const t = s;
                            s = n, n = t, r = !r;
                        }
                        const a = n - s;
                        return a > Math.PI ? (this.arcHelper(t, e, i, s, s + a / 2, r), this.arcHelper(t, e, i, s + a / 2, n, r)) : this.arcHelper(t, e, i, s, n, r), this;
                    }
                    arcHelper(t, e, i, s, n, r) {
                        const o = t + i * Math.cos(s), a = e + i * Math.sin(s), l = t + i * Math.cos(n), h = e + i * Math.sin(n);
                        let c = 0, u = 0;
                        r ? (u = 1, n - s < Math.PI && (c = 1)) : n - s > Math.PI && (c = 1), this.path += "M" + o + "," + a + ",A" + i + "," + i + ",0," + c + "," + u + "," + l + "," + h + "M" + this.pen.x + "," + this.pen.y;
                    }
                    glow() {
                        const t = this.paper.set();
                        if (this.shadow_attributes.width > 0) {
                            const e = this.shadow_attributes, i = e.width / 2;
                            for(let s = 1; s <= i; s++)t.push(this.paper.path(this.path).attr({
                                stroke: e.color,
                                "stroke-linejoin": "round",
                                "stroke-linecap": "round",
                                "stroke-width": +(e.width / i * s).toFixed(3),
                                opacity: +((e.opacity || .3) / i).toFixed(3),
                                transform: this.attributes.transform,
                                scale: this.attributes.scale
                            }));
                        }
                        return t;
                    }
                    fill() {
                        const t = this.paper.path(this.path).attr(this.attributes).attr("stroke-width", 0);
                        return this.glow(t), this;
                    }
                    stroke() {
                        const t = this.lineWidth * (this.state.scale.x + this.state.scale.y) / 2, e = this.paper.path(this.path).attr(this.attributes).attr("fill", "none").attr("stroke-width", t);
                        return this.glow(e), this;
                    }
                    closePath() {
                        return this.path += "Z", this;
                    }
                    measureText(t) {
                        const e = this.paper.text(0, 0, t).attr(this.attributes).attr("fill", "none").attr("stroke", "none"), i = e.getBBox();
                        return e.remove(), {
                            width: i.width,
                            height: i.height
                        };
                    }
                    fillText(t, e, i) {
                        return this.paper.text(e + this.measureText(t).width / 2, i - this.state.font_size / (2.25 * this.state.scale.y), t).attr(this.attributes), this;
                    }
                    save() {
                        return this.state_stack.push({
                            state: {
                                font_family: this.state.font_family
                            },
                            attributes: {
                                font: this.attributes.font,
                                fill: this.attributes.fill,
                                stroke: this.attributes.stroke,
                                "stroke-width": this.attributes["stroke-width"]
                            },
                            shadow_attributes: {
                                width: this.shadow_attributes.width,
                                color: this.shadow_attributes.color
                            }
                        }), this;
                    }
                    restore() {
                        const t = this.state_stack.pop();
                        return this.state.font_family = t.state.font_family, this.attributes.font = t.attributes.font, this.attributes.fill = t.attributes.fill, this.attributes.stroke = t.attributes.stroke, this.attributes["stroke-width"] = t.attributes["stroke-width"], this.shadow_attributes.width = t.shadow_attributes.width, this.shadow_attributes.color = t.shadow_attributes.color, this;
                    }
                }
                const S = {
                    path: {
                        x: !0,
                        y: !0,
                        width: !0,
                        height: !0
                    },
                    rect: {},
                    text: {
                        width: !0,
                        height: !0
                    }
                };
                {
                    const t = {
                        "font-family": !0,
                        "font-weight": !0,
                        "font-style": !0,
                        "font-size": !0
                    };
                    s.Merge(S.rect, t), s.Merge(S.path, t);
                }
                class y {
                    constructor(t){
                        this.element = t, this.svgNS = "http://www.w3.org/2000/svg";
                        const e = this.create("svg");
                        this.element.appendChild(e), this.svg = e, this.groups = [
                            this.svg
                        ], this.parent = this.svg, this.path = "", this.pen = {
                            x: NaN,
                            y: NaN
                        }, this.lineWidth = 1, this.state = {
                            scale: {
                                x: 1,
                                y: 1
                            },
                            "font-family": "Arial",
                            "font-size": "8pt",
                            "font-weight": "normal"
                        }, this.attributes = {
                            "stroke-width": .3,
                            fill: "black",
                            stroke: "black",
                            "stroke-dasharray": "none",
                            "font-family": "Arial",
                            "font-size": "10pt",
                            "font-weight": "normal",
                            "font-style": "normal"
                        }, this.background_attributes = {
                            "stroke-width": 0,
                            fill: "white",
                            stroke: "white",
                            "stroke-dasharray": "none",
                            "font-family": "Arial",
                            "font-size": "10pt",
                            "font-weight": "normal",
                            "font-style": "normal"
                        }, this.shadow_attributes = {
                            width: 0,
                            color: "black"
                        }, this.state_stack = [], this.iePolyfill();
                    }
                    create(t) {
                        return document.createElementNS(this.svgNS, t);
                    }
                    openGroup(t, e, i) {
                        const n = this.create("g");
                        return this.groups.push(n), this.parent.appendChild(n), this.parent = n, t && n.setAttribute("class", s.Prefix(t)), e && n.setAttribute("id", s.Prefix(e)), i && i.pointerBBox && n.setAttribute("pointer-events", "bounding-box"), n;
                    }
                    closeGroup() {
                        this.groups.pop(), this.parent = this.groups[this.groups.length - 1];
                    }
                    add(t) {
                        this.parent.appendChild(t);
                    }
                    iePolyfill() {
                        "undefined" != typeof navigator && (this.ie = /MSIE 9/i.test(navigator.userAgent) || /MSIE 10/i.test(navigator.userAgent) || /rv:11\.0/i.test(navigator.userAgent) || /Trident/i.test(navigator.userAgent));
                    }
                    setFont(t, e, i) {
                        let n = !1, r = !1, o = "normal";
                        "string" == typeof i && (-1 !== i.indexOf("italic") && (i = i.replace(/italic/g, ""), r = !0), -1 !== i.indexOf("bold") && (i = i.replace(/bold/g, ""), n = !0), i = i.replace(/ /g, "")), o = r ? "italic" : o;
                        const a = {
                            "font-family": t,
                            "font-size": e + "pt",
                            "font-weight": i = void 0 === (i = n ? "bold" : i) || "" === i ? "normal" : i,
                            "font-style": o
                        };
                        return this.fontSize = Number(e), s.Merge(this.attributes, a), s.Merge(this.state, a), this;
                    }
                    setRawFont(t) {
                        const e = (t = t.trim()).split(" "), i = e.slice(1).join(" ");
                        return this.attributes["font-family"] = i, this.state["font-family"] = i, this.attributes["font-size"] = e[0], this.state["font-size"] = e[0], this.fontSize = Number(e[0].match(/\d+/)), this;
                    }
                    setFillStyle(t) {
                        return this.attributes.fill = t, this;
                    }
                    setBackgroundFillStyle(t) {
                        return this.background_attributes.fill = t, this.background_attributes.stroke = t, this;
                    }
                    setStrokeStyle(t) {
                        return this.attributes.stroke = t, this;
                    }
                    setShadowColor(t) {
                        return this.shadow_attributes.color = t, this;
                    }
                    setShadowBlur(t) {
                        return this.shadow_attributes.width = t, this;
                    }
                    setLineWidth(t) {
                        this.attributes["stroke-width"] = t, this.lineWidth = t;
                    }
                    setLineDash(t) {
                        if ("[object Array]" === Object.prototype.toString.call(t)) return t = t.join(", "), this.attributes["stroke-dasharray"] = t, this;
                        throw new s.RERR("ArgumentError", "lineDash must be an array of integers.");
                    }
                    setLineCap(t) {
                        return this.attributes["stroke-linecap"] = t, this;
                    }
                    resize(t, e) {
                        this.width = t, this.height = e, this.element.style.width = t;
                        const i = {
                            width: t,
                            height: e
                        };
                        return this.applyAttributes(this.svg, i), this.scale(this.state.scale.x, this.state.scale.y), this;
                    }
                    scale(t, e) {
                        this.state.scale = {
                            x: t,
                            y: e
                        };
                        const i = this.width / t, s = this.height / e;
                        return this.setViewBox(0, 0, i, s), this;
                    }
                    setViewBox(...t) {
                        if (1 === t.length) {
                            const [e] = t;
                            this.svg.setAttribute("viewBox", e);
                        } else {
                            const [e, i, s, n] = t, r = e + " " + i + " " + s + " " + n;
                            this.svg.setAttribute("viewBox", r);
                        }
                    }
                    applyAttributes(t, e) {
                        const i = S[t.nodeName], s = Object.keys(e);
                        for(let n = 0; n < s.length; n++){
                            const r = s[n];
                            i && i[r] || t.setAttribute(r, e[r]);
                        }
                        return t;
                    }
                    clear() {
                        for(; this.svg.lastChild;)this.svg.removeChild(this.svg.lastChild);
                        this.scale(this.state.scale.x, this.state.scale.y);
                    }
                    rect(t, e, i, n, r) {
                        n < 0 && (e += n, n *= -1);
                        const o = this.create("rect");
                        return void 0 === r && (r = {
                            fill: "none",
                            "stroke-width": this.lineWidth,
                            stroke: this.attributes.stroke
                        }), s.Merge(r, {
                            x: t,
                            y: e,
                            width: i,
                            height: n
                        }), this.applyAttributes(o, r), this.add(o), this;
                    }
                    fillRect(t, e, i, s) {
                        return s < 0 && (e += s, s *= -1), this.rect(t, e, i, s, this.attributes), this;
                    }
                    clearRect(t, e, i, s) {
                        return this.rect(t, e, i, s, this.background_attributes), this;
                    }
                    beginPath() {
                        return this.path = "", this.pen.x = NaN, this.pen.y = NaN, this;
                    }
                    moveTo(t, e) {
                        return this.path += "M" + t + " " + e, this.pen.x = t, this.pen.y = e, this;
                    }
                    lineTo(t, e) {
                        return this.path += "L" + t + " " + e, this.pen.x = t, this.pen.y = e, this;
                    }
                    bezierCurveTo(t, e, i, s, n, r) {
                        return this.path += "C" + t + " " + e + "," + i + " " + s + "," + n + " " + r, this.pen.x = n, this.pen.y = r, this;
                    }
                    quadraticCurveTo(t, e, i, s) {
                        return this.path += "Q" + t + " " + e + "," + i + " " + s, this.pen.x = i, this.pen.y = s, this;
                    }
                    arc(t, e, i, s, n, r) {
                        function o(t) {
                            for(; t < 0;)t += 2 * Math.PI;
                            for(; t > 2 * Math.PI;)t -= 2 * Math.PI;
                            return t;
                        }
                        if ((s = o(s)) > (n = o(n))) {
                            const t = s;
                            s = n, n = t, r = !r;
                        }
                        const a = n - s;
                        return a > Math.PI ? (this.arcHelper(t, e, i, s, s + a / 2, r), this.arcHelper(t, e, i, s + a / 2, n, r)) : this.arcHelper(t, e, i, s, n, r), this;
                    }
                    arcHelper(t, e, i, s, n, r) {
                        const o = t + i * Math.cos(s), a = e + i * Math.sin(s), l = t + i * Math.cos(n), h = e + i * Math.sin(n);
                        let c = 0, u = 0;
                        r ? (u = 1, n - s < Math.PI && (c = 1)) : n - s > Math.PI && (c = 1), this.path += "M" + o + " " + a + " A" + i + " " + i + " 0 " + c + " " + u + " " + l + " " + h, isNaN(this.pen.x) || isNaN(this.pen.y) || (this.peth += "M" + this.pen.x + " " + this.pen.y);
                    }
                    closePath() {
                        return this.path += "Z", this;
                    }
                    glow() {
                        if (this.shadow_attributes.width > 0) {
                            const t = this.shadow_attributes, e = t.width / 2;
                            for(let i = 1; i <= e; i++){
                                const s = {
                                    stroke: t.color,
                                    "stroke-linejoin": "round",
                                    "stroke-linecap": "round",
                                    "stroke-width": +(.4 * t.width / e * i).toFixed(3),
                                    opacity: +((t.opacity || .3) / e).toFixed(3)
                                }, n = this.create("path");
                                s.d = this.path, this.applyAttributes(n, s), this.add(n);
                            }
                        }
                        return this;
                    }
                    fill(t) {
                        this.glow();
                        const e = this.create("path");
                        let i = t;
                        return void 0 === t ? (this.setPathAttributes(e, "stroke", "none", void 0, void 0), this.add(e), this) : (i = t, s.Merge(i, this.attributes), t.class && (i.class = t.class), t.id && (i.id = t.id), t.d = this.path, this.applyAttributes(e, t), this.add(e), this);
                    }
                    stroke(t) {
                        this.glow();
                        const e = this.create("path");
                        if (!t) return this.setPathAttributes(e, "fill", "none", "stroke-width", this.lineWidth), this.add(e), this;
                        const i = {};
                        return s.Merge(i, this.attributes), t && s.Merge(i, t), i.fill = "none", i["stroke-width"] = this.lineWidth, i.d = this.path, this.applyAttributes(e, i), this.add(e), this;
                    }
                    setPathAttributes(t, e, i, s, n) {
                        const r = S.path, o = this.attributes;
                        let a = !1, l = !1, h = !1;
                        for(const c in o){
                            let u = o[c];
                            c === e ? (a = !0, u = i) : c === s ? (l = !0, u = n) : "d" === c && (h = !0, u = this.path), r[c] || t.setAttribute(c, u);
                        }
                        a || t.setAttribute(e, i), void 0 === s || l || t.setAttribute(s, n), h || t.setAttribute("d", this.path);
                    }
                    measureText(t, e = !1) {
                        const i = this.create("text");
                        if ("function" != typeof i.getBBox) return {
                            x: 0,
                            y: 0,
                            width: 0,
                            height: 0
                        };
                        i.textContent = t, this.applyAttributes(i, this.attributes), this.svg.appendChild(i);
                        let s = i.getBBox();
                        return this.ie && "" !== t && "italic" === this.attributes["font-style"] && (s = this.ieMeasureTextFix(s, t)), e && "function" == typeof i.getComputedTextLength && (s = {
                            x: s.x,
                            y: s.y,
                            width: i.getComputedTextLength(),
                            height: s.height
                        }), this.svg.removeChild(i), s;
                    }
                    ieMeasureTextFix(t) {
                        const e = 1.196 * Number(this.fontSize) + 1.9598, i = t.width - e, s = t.height - 1.5;
                        return {
                            x: t.x,
                            y: t.y,
                            width: i,
                            height: s
                        };
                    }
                    fillText(t, e, i) {
                        if (!t || t.length <= 0) return;
                        const n = {};
                        s.Merge(n, this.attributes), n.stroke = "none", n.x = e, n.y = i;
                        const r = this.create("text");
                        r.textContent = t, this.applyAttributes(r, n), this.add(r);
                    }
                    save() {
                        return this.state_stack.push({
                            state: {
                                "font-family": this.state["font-family"],
                                "font-weight": this.state["font-weight"],
                                "font-style": this.state["font-style"],
                                "font-size": this.state["font-size"],
                                scale: this.state.scale
                            },
                            attributes: {
                                "font-family": this.attributes["font-family"],
                                "font-weight": this.attributes["font-weight"],
                                "font-style": this.attributes["font-style"],
                                "font-size": this.attributes["font-size"],
                                fill: this.attributes.fill,
                                stroke: this.attributes.stroke,
                                "stroke-width": this.attributes["stroke-width"],
                                "stroke-dasharray": this.attributes["stroke-dasharray"]
                            },
                            shadow_attributes: {
                                width: this.shadow_attributes.width,
                                color: this.shadow_attributes.color
                            },
                            lineWidth: this.lineWidth
                        }), this;
                    }
                    restore() {
                        const t = this.state_stack.pop();
                        return this.state["font-family"] = t.state["font-family"], this.state["font-weight"] = t.state["font-weight"], this.state["font-style"] = t.state["font-style"], this.state["font-size"] = t.state["font-size"], this.state.scale = t.state.scale, this.attributes["font-family"] = t.attributes["font-family"], this.attributes["font-weight"] = t.attributes["font-weight"], this.attributes["font-style"] = t.attributes["font-style"], this.attributes["font-size"] = t.attributes["font-size"], this.attributes.fill = t.attributes.fill, this.attributes.stroke = t.attributes.stroke, this.attributes["stroke-width"] = t.attributes["stroke-width"], this.attributes["stroke-dasharray"] = t.attributes["stroke-dasharray"], this.shadow_attributes.width = t.shadow_attributes.width, this.shadow_attributes.color = t.shadow_attributes.color, this.lineWidth = t.lineWidth, this;
                    }
                }
                let E = null;
                class x {
                    static get Backends() {
                        return {
                            CANVAS: 1,
                            RAPHAEL: 2,
                            SVG: 3,
                            VML: 4
                        };
                    }
                    static get LineEndType() {
                        return {
                            NONE: 1,
                            UP: 2,
                            DOWN: 3
                        };
                    }
                    static get USE_CANVAS_PROXY() {
                        return !1;
                    }
                    static get lastContext() {
                        return E;
                    }
                    static set lastContext(t) {
                        E = t;
                    }
                    static buildContext(t, e, i, s, n) {
                        const r = new x(t, e);
                        i && s && r.resize(i, s), n || (n = "#FFF");
                        const o = r.getContext();
                        return o.setBackgroundFillStyle(n), x.lastContext = o, o;
                    }
                    static getCanvasContext(t, e, i, s) {
                        return x.buildContext(t, x.Backends.CANVAS, e, i, s);
                    }
                    static getRaphaelContext(t, e, i, s) {
                        return x.buildContext(t, x.Backends.RAPHAEL, e, i, s);
                    }
                    static getSVGContext(t, e, i, s) {
                        return x.buildContext(t, x.Backends.SVG, e, i, s);
                    }
                    static bolsterCanvasContext(t) {
                        return x.USE_CANVAS_PROXY ? new g(t) : (t.vexFlowCanvasContext = t, [
                            "clear",
                            "setFont",
                            "setRawFont",
                            "setFillStyle",
                            "setBackgroundFillStyle",
                            "setStrokeStyle",
                            "setShadowColor",
                            "setShadowBlur",
                            "setLineWidth",
                            "setLineCap",
                            "setLineDash",
                            "openGroup",
                            "closeGroup",
                            "getGroup"
                        ].forEach((e)=>{
                            t[e] = t[e] || g.prototype[e];
                        }), t);
                    }
                    static drawDashedLine(t, e, i, s, n, r) {
                        t.beginPath();
                        const o = s - e, a = n - i, l = Math.atan2(a, o);
                        let h = e, c = i;
                        t.moveTo(e, i);
                        let u = 0, d = !0;
                        for(; !(o < 0 ? h <= s : h >= s) || !(a < 0 ? c <= n : c >= n);){
                            const e = r[u++ % r.length], i = h + Math.cos(l) * e;
                            h = o < 0 ? Math.max(s, i) : Math.min(s, i);
                            const f = c + Math.sin(l) * e;
                            c = a < 0 ? Math.max(n, f) : Math.min(n, f), d ? t.lineTo(h, c) : t.moveTo(h, c), d = !d;
                        }
                        t.closePath(), t.stroke();
                    }
                    constructor(t, e){
                        if (this.elementId = t, !this.elementId) throw new s.RERR("BadArgument", "Invalid id for renderer.");
                        if (this.element = document.getElementById(t), this.element || (this.element = t), this.ctx = null, this.paper = null, this.backend = e, this.backend === x.Backends.CANVAS) {
                            if (!this.element.getContext) throw new s.RERR("BadElement", `Can't get canvas context from element: ${t}`);
                            this.ctx = x.bolsterCanvasContext(this.element.getContext("2d", {
                                willReadFrequently: !0
                            }));
                        } else if (this.backend === x.Backends.RAPHAEL) this.ctx = new b(this.element);
                        else {
                            if (this.backend !== x.Backends.SVG) throw new s.RERR("InvalidBackend", `No support for backend: ${this.backend}`);
                            this.ctx = new y(this.element);
                        }
                    }
                    resize(t, e) {
                        if (this.backend === x.Backends.CANVAS) {
                            if (!this.element.getContext) throw new s.RERR("BadElement", `Can't get canvas context from element: ${this.elementId}`);
                            [t, e] = g.SanitizeCanvasDims(t, e);
                            const i = window.devicePixelRatio || 1;
                            this.element.width = t * i, this.element.height = e * i, this.element.style.width = t + "px", this.element.style.height = e + "px", this.ctx = x.bolsterCanvasContext(this.element.getContext("2d", {
                                willReadFrequently: !0
                            })), this.ctx.scale(i, i);
                        } else this.ctx.resize(t, e);
                        return this;
                    }
                    getContext() {
                        return this.ctx;
                    }
                }
                class v extends l {
                    static get CATEGORY() {
                        return "stem";
                    }
                    static get UP() {
                        return 1;
                    }
                    static get DOWN() {
                        return -1;
                    }
                    static get WIDTH() {
                        return p.STEM_WIDTH;
                    }
                    static get HEIGHT() {
                        return p.STEM_HEIGHT;
                    }
                    constructor(t = {}){
                        super(), this.setAttribute("type", "Stem"), this.x_begin = t.x_begin || 0, this.x_end = t.x_end || 0, this.y_top = t.y_top || 0, this.y_bottom = t.y_bottom || 0, this.stem_extension = t.stem_extension || 0, this.stem_direction = t.stem_direction || 0, this.hide = t.hide || !1, this.isStemlet = t.isStemlet || !1, this.stemletHeight = t.stemletHeight || 0, this.renderHeightAdjustment = 0, this.setOptions(t);
                    }
                    setOptions(t) {
                        this.stem_up_y_offset = t.stem_up_y_offset || 0, this.stem_down_y_offset = t.stem_down_y_offset || 0;
                    }
                    setNoteHeadXBounds(t, e) {
                        return this.x_begin = t, this.x_end = e, this;
                    }
                    setDirection(t) {
                        this.stem_direction = t;
                    }
                    setExtension(t) {
                        this.stem_extension = t;
                    }
                    getExtension() {
                        return this.stem_extension;
                    }
                    setYBounds(t, e) {
                        this.y_top = t, this.y_bottom = e;
                    }
                    getCategory() {
                        return v.CATEGORY;
                    }
                    getHeight() {
                        const t = this.stem_direction === v.UP ? this.stem_up_y_offset : this.stem_down_y_offset;
                        return (this.y_bottom - this.y_top) * this.stem_direction + (v.HEIGHT - t + this.stem_extension) * this.stem_direction;
                    }
                    getBoundingBox() {
                        throw new s.RERR("NotImplemented", "getBoundingBox() not implemented.");
                    }
                    getExtents() {
                        const t = this.stem_direction === v.UP, e = [
                            this.y_top,
                            this.y_bottom
                        ], i = v.HEIGHT + this.stem_extension, s = (t ? Math.min : Math.max)(...e), n = (t ? Math.max : Math.min)(...e);
                        return {
                            topY: s + i * -this.stem_direction,
                            baseY: n
                        };
                    }
                    setVisibility(t) {
                        return this.hide = !t, this;
                    }
                    setStemlet(t, e) {
                        return this.isStemlet = t, this.stemletHeight = e, this;
                    }
                    draw() {
                        if (this.setRendered(), this.hide) return;
                        const t = this.checkContext();
                        let e, i;
                        const n = this.stem_direction;
                        n === v.DOWN ? (e = this.x_begin, i = this.y_top + this.stem_down_y_offset) : (e = this.x_end, i = this.y_bottom - this.stem_up_y_offset);
                        const r = this.getHeight();
                        !function(...t) {
                            v.DEBUG && s.L("Vex.Flow.Stem", t);
                        }("Rendering stem - ", "Top Y: ", this.y_top, "Bottom Y: ", this.y_bottom);
                        const o = this.isStemlet ? r - this.stemletHeight * this.stem_direction : 0;
                        if (t.save(), this.applyStyle(t), t.beginPath(), t.setLineWidth(v.WIDTH), t.moveTo(e, i - o), t.lineTo(e, i - r - this.renderHeightAdjustment * n), t.svg) {
                            const e = {
                                class: s.Prefix("stem")
                            };
                            this.id && (e.id = this.id), t.stroke(e);
                        } else t.stroke();
                        this.restoreStyle(t), t.restore();
                    }
                }
                class T extends l {
                    static get LOCATION_TOP() {
                        return 1;
                    }
                    static get LOCATION_BOTTOM() {
                        return -1;
                    }
                    static get NESTING_OFFSET() {
                        return 15;
                    }
                    constructor(t, e){
                        if (super(), this.setAttribute("type", "Tuplet"), !t || !t.length) throw new s.RuntimeError("BadArguments", "No notes provided for tuplet.");
                        this.options = s.Merge({}, e), this.notes = t, this.num_notes = "num_notes" in this.options ? this.options.num_notes : t.length, this.options.beats_occupied && this.beatsOccupiedDeprecationWarning(), this.notes_occupied = this.options.notes_occupied || this.options.beats_occupied || 2, "bracketed" in this.options ? this.bracketed = this.options.bracketed : this.bracketed = t.some((t)=>null === t.beam), this.ratioed = "ratioed" in this.options ? this.options.ratioed : Math.abs(this.notes_occupied - this.num_notes) > 1, this.point = 28, this.y_pos = 16, this.x_pos = 100, this.width = 200, this.location = this.options.location || T.LOCATION_TOP, yt.AlignRestsToNotes(t, !0, !0), this.resolveGlyphs(), this.attach();
                    }
                    attach() {
                        for(let t = 0; t < this.notes.length; t++)this.notes[t].setTuplet(this);
                    }
                    detach() {
                        for(let t = 0; t < this.notes.length; t++)this.notes[t].resetTuplet(this);
                    }
                    setBracketed(t) {
                        return this.bracketed = !!t, this;
                    }
                    setRatioed(t) {
                        return this.ratioed = !!t, this;
                    }
                    setTupletLocation(t) {
                        if (t) {
                            if (t !== T.LOCATION_TOP && t !== T.LOCATION_BOTTOM) throw new s.RERR("BadArgument", "Invalid tuplet location: " + t);
                        } else t = T.LOCATION_TOP;
                        return this.location = t, this;
                    }
                    getNotes() {
                        return this.notes;
                    }
                    getNoteCount() {
                        return this.num_notes;
                    }
                    beatsOccupiedDeprecationWarning() {
                        const t = [
                            "beats_occupied has been deprecated as an ",
                            "option for tuplets. Please use notes_occupied ",
                            "instead. Calls to getBeatsOccupied and ",
                            "setBeatsOccupied should now be routed to ",
                            "getNotesOccupied and setNotesOccupied instead"
                        ].join("");
                        console && console.warn ? console.warn(t) : console && console.log(t);
                    }
                    getBeatsOccupied() {
                        return this.beatsOccupiedDeprecationWarning(), this.getNotesOccupied();
                    }
                    setBeatsOccupied(t) {
                        return this.beatsOccupiedDeprecationWarning(), this.setNotesOccupied(t);
                    }
                    getNotesOccupied() {
                        return this.notes_occupied;
                    }
                    setNotesOccupied(t) {
                        this.detach(), this.notes_occupied = t, this.resolveGlyphs(), this.attach();
                    }
                    resolveGlyphs() {
                        this.numerator_glyphs = [];
                        let t = this.num_notes;
                        for(; t >= 1;)this.numerator_glyphs.unshift(new m("v" + t % 10, this.point)), t = parseInt(t / 10, 10);
                        for(this.denom_glyphs = [], t = this.notes_occupied; t >= 1;)this.denom_glyphs.unshift(new m("v" + t % 10, this.point)), t = parseInt(t / 10, 10);
                    }
                    getNestedTupletCount() {
                        const t = this.location, e = this.notes[0];
                        let i = n(e, t), s = n(e, t);
                        function n(t, e) {
                            return t.tupletStack.filter((t)=>t.location === e).length;
                        }
                        return this.notes.forEach((e)=>{
                            const r = n(e, t);
                            i = r > i ? r : i, s = r < s ? r : s;
                        }), i - s;
                    }
                    getYPosition() {
                        const t = this.getNestedTupletCount() * T.NESTING_OFFSET * -this.location, e = this.options.y_offset || 0, i = this.notes[0];
                        let s;
                        if (this.location === T.LOCATION_TOP) {
                            s = i.getStave().getYForLine(0) - 15;
                            for(let t = 0; t < this.notes.length; ++t){
                                const e = this.notes[t].getStemDirection() === v.UP ? this.notes[t].getStemExtents().topY - 10 : this.notes[t].getStemExtents().baseY - 20;
                                e < s && (s = e);
                            }
                        } else {
                            s = i.getStave().getYForLine(4) + 20;
                            for(let t = 0; t < this.notes.length; ++t){
                                const e = this.notes[t].getStemDirection() === v.UP ? this.notes[t].getStemExtents().baseY + 20 : this.notes[t].getStemExtents().topY + 10;
                                e > s && (s = e);
                            }
                        }
                        return s + t + e;
                    }
                    draw() {
                        this.checkContext(), this.setRendered();
                        const t = this.notes[0], e = this.notes[this.notes.length - 1];
                        this.bracketed ? (this.x_pos = t.getTieLeftX() - 5, this.width = e.getTieRightX() - this.x_pos + 5) : (this.x_pos = t.getStemX(), this.width = e.getStemX() - this.x_pos), this.y_pos = this.getYPosition();
                        const i = (t, e)=>t + e.getMetrics().width;
                        let s = this.numerator_glyphs.reduce(i, 0);
                        this.ratioed && (s = this.denom_glyphs.reduce(i, s), s += .32 * this.point);
                        const n = this.x_pos + this.width / 2 - s / 2;
                        if (this.bracketed) {
                            const t = this.width / 2 - s / 2 - 5;
                            t > 0 && (this.context.fillRect(this.x_pos, this.y_pos, t, 1), this.context.fillRect(this.x_pos + this.width / 2 + s / 2 + 5, this.y_pos, t, 1), this.context.fillRect(this.x_pos, this.y_pos + (this.location === T.LOCATION_BOTTOM), 1, 10 * this.location), this.context.fillRect(this.x_pos + this.width, this.y_pos + (this.location === T.LOCATION_BOTTOM), 1, 10 * this.location));
                        }
                        let r = 0;
                        if (!1 !== this.RenderTupletNumber && this.numerator_glyphs.forEach((t)=>{
                            t.render(this.context, n + r, this.y_pos + this.point / 3 - 2), r += t.getMetrics().width;
                        }), this.ratioed) {
                            const t = n + r + .16 * this.point, e = .06 * this.point;
                            this.context.beginPath(), this.context.arc(t, this.y_pos - .08 * this.point, e, 0, 2 * Math.PI, !0), this.context.closePath(), this.context.fill(), this.context.beginPath(), this.context.arc(t, this.y_pos + .12 * this.point, e, 0, 2 * Math.PI, !0), this.context.closePath(), this.context.fill(), r += .32 * this.point, this.denom_glyphs.forEach((t)=>{
                                t.render(this.context, n + r, this.y_pos + this.point / 3 - 2), r += t.getMetrics().width;
                            });
                        }
                    }
                }
                function _(t) {
                    let e = 0;
                    return t.forEach((t)=>{
                        t.keyProps && t.keyProps.forEach((t)=>{
                            e += t.line - 3;
                        });
                    }), e >= 0 ? v.DOWN : v.UP;
                }
                const M = "L", P = "B";
                class L extends l {
                    static getDefaultBeamGroups(t) {
                        t && "c" !== t || (t = "4/4");
                        const e = {
                            "1/2": [
                                "1/2"
                            ],
                            "2/2": [
                                "1/2"
                            ],
                            "3/2": [
                                "1/2"
                            ],
                            "4/2": [
                                "1/2"
                            ],
                            "1/4": [
                                "1/4"
                            ],
                            "2/4": [
                                "1/4"
                            ],
                            "3/4": [
                                "1/4"
                            ],
                            "4/4": [
                                "1/4"
                            ],
                            "1/8": [
                                "1/8"
                            ],
                            "2/8": [
                                "2/8"
                            ],
                            "3/8": [
                                "3/8"
                            ],
                            "4/8": [
                                "2/8"
                            ],
                            "1/16": [
                                "1/16"
                            ],
                            "2/16": [
                                "2/16"
                            ],
                            "3/16": [
                                "3/16"
                            ],
                            "4/16": [
                                "2/16"
                            ]
                        }[t];
                        if (void 0 !== e) return e.map((t)=>(new n).parse(t));
                        {
                            const e = parseInt(t.split("/")[0], 10), i = parseInt(t.split("/")[1], 10);
                            if (e % 3 == 0) return [
                                new n(3, i)
                            ];
                            if (i > 4) return [
                                new n(2, i)
                            ];
                            if (i <= 4) return [
                                new n(1, i)
                            ];
                        }
                        return [
                            new n(1, 4)
                        ];
                    }
                    static applyAndGetBeams(t, e, i) {
                        return L.generateBeams(t.getTickables(), {
                            groups: i,
                            stem_direction: e
                        });
                    }
                    static generateBeams(t, e) {
                        e || (e = {}), e.groups && e.groups.length || (e.groups = [
                            new n(2, 8)
                        ]);
                        const i = e.groups.map((t)=>{
                            if (!t.multiply) throw new s.RuntimeError("InvalidBeamGroups", "The beam groups must be an array of Vex.Flow.Fractions");
                            return t.clone().multiply(p.RESOLUTION, 1);
                        }), r = t;
                        let o = 0, a = [], l = [];
                        function h() {
                            i.length - 1 > o ? o += 1 : o = 0;
                        }
                        !function() {
                            let t = [];
                            r.forEach((e)=>{
                                if (t = [], e.shouldIgnoreTicks()) return a.push(l), void (l = t);
                                l.push(e);
                                const s = i[o].clone(), r = l.reduce((t, e)=>e.getTicks().clone().add(t), new n(0, 1)), c = p.durationToNumber(e.duration) < 8;
                                c && e.tuplet && (s.numerator *= 2), r.greaterThan(s) ? (c || t.push(l.pop()), a.push(l), l = t, h()) : r.equals(s) && (a.push(l), l = t, h());
                            }), l.length > 0 && a.push(l);
                        }(), function() {
                            const t = [];
                            a.forEach((i)=>{
                                let s = [];
                                i.forEach((i, n, r)=>{
                                    const o = 0 === n || n === r.length - 1, a = r[n - 1], l = !e.beam_rests && i.isRest(), h = e.beam_rests && e.beam_middle_only && i.isRest() && o;
                                    let c = !1;
                                    if (e.maintain_stem_directions && a && !i.isRest() && !a.isRest()) {
                                        const t = a.getStemDirection();
                                        c = i.getStemDirection() !== t;
                                    }
                                    const u = parseInt(i.duration, 10) < 8;
                                    l || h || c || u ? (s.length > 0 && t.push(s), s = c ? [
                                        i
                                    ] : []) : s.push(i);
                                }), s.length > 0 && t.push(s);
                            }), a = t;
                        }(), a.forEach((t)=>{
                            let i;
                            if (e.maintain_stem_directions) {
                                const e = function(t) {
                                    for(let e = 0; e < t.length; e++){
                                        const i = t[e];
                                        if (!i.isRest()) return i;
                                    }
                                    return !1;
                                }(t);
                                i = e ? e.getStemDirection() : v.UP;
                            } else i = e.stem_direction ? e.stem_direction : _(t);
                            !function(t, e) {
                                t.forEach((t)=>{
                                    t.setStemDirection(e);
                                });
                            }(t, i);
                        });
                        const c = a.filter((t)=>{
                            if (t.length > 1) {
                                let e = !0;
                                return t.forEach((t)=>{
                                    t.getIntrinsicTicks() >= p.durationToTicks("4") && (e = !1);
                                }), e;
                            }
                            return !1;
                        }), u = function() {
                            const t = [];
                            return a.forEach((e)=>{
                                let i = null;
                                e.forEach((e)=>{
                                    e.tuplet && i !== e.tuplet && (i = e.tuplet, t.push(i));
                                });
                            }), t;
                        }(), d = [];
                        return c.forEach((t)=>{
                            const i = new L(t);
                            e.show_stemlets && (i.render_options.show_stemlets = !0), e.secondary_breaks && (i.render_options.secondary_break_ticks = p.durationToTicks(e.secondary_breaks)), !0 === e.flat_beams && (i.render_options.flat_beams = !0, i.render_options.flat_beam_offset = e.flat_beam_offset), d.push(i);
                        }), u.forEach((t)=>{
                            const e = t.notes[0].stem_direction === v.DOWN ? T.LOCATION_BOTTOM : T.LOCATION_TOP;
                            t.setTupletLocation(e);
                            let i = !1;
                            for(let e = 0; e < t.notes.length; e++)if (null === t.notes[e].beam) {
                                i = !0;
                                break;
                            }
                            t.setBracketed(i);
                        }), d;
                    }
                    constructor(t, e){
                        if (super(), this.setAttribute("type", "Beam"), !t || t == []) throw new s.RuntimeError("BadArguments", "No notes provided for beam.");
                        if (1 === t.length) throw new s.RuntimeError("BadArguments", "Too few notes for beam.");
                        if (this.ticks = t[0].getIntrinsicTicks(), this.ticks >= p.durationToTicks("4")) throw new s.RuntimeError("BadArguments", "Beams can only be applied to notes shorter than a quarter note.");
                        let i, n;
                        for(this.stem_direction = v.UP, i = 0; i < t.length; ++i)if (n = t[i], n.hasStem()) {
                            this.stem_direction = n.getStemDirection();
                            break;
                        }
                        let r = this.stem_direction;
                        if (e && "stavenotes" === t[0].getCategory()) r = _(t);
                        else if (e && "tabnotes" === t[0].getCategory()) {
                            const e = t.reduce((t, e)=>t + e.stem_direction, 0);
                            r = e > -1 ? v.UP : v.DOWN;
                        }
                        for(i = 0; i < t.length; ++i)n = t[i], e && (n.setStemDirection(r), this.stem_direction = r), n.setBeam(this);
                        this.postFormatted = !1, this.notes = t, this.beam_count = this.getBeamCount(), this.break_on_indices = [], this.render_options = {
                            beam_width: 5,
                            max_slope: .25,
                            min_slope: -0.25,
                            slope_iterations: 20,
                            slope_cost: 100,
                            show_stemlets: !1,
                            stemlet_extension: 7,
                            partial_beam_length: 10,
                            flat_beams: !1,
                            min_flat_beam_offset: 15
                        };
                    }
                    getNotes() {
                        return this.notes;
                    }
                    getBeamCount() {
                        return this.notes.map((t)=>t.getGlyph().beam_count).reduce((t, e)=>e > t ? e : t);
                    }
                    breakSecondaryAt(t) {
                        return this.break_on_indices = t, this;
                    }
                    getSlopeY(t, e, i, s) {
                        return i + (t - e) * s;
                    }
                    calculateSlope() {
                        const { notes: t, stem_direction: e, render_options: { max_slope: i, min_slope: s, slope_iterations: n, slope_cost: r } } = this, o = t[0], a = ((t, e)=>{
                            const i = t.getStemExtents().topY, s = t.getStemX();
                            return (e.getStemExtents().topY - i) / (e.getStemX() - s);
                        })(o, t[t.length - 1]), l = (i - s) / n;
                        let h = Number.MAX_VALUE, c = 0, u = 0;
                        for(let n = s; n <= i; n += l){
                            let i = 0, s = 0;
                            for(let r = 1; r < t.length; ++r){
                                const a = t[r], l = this.getSlopeY(a.getStemX(), o.getStemX(), o.getStemExtents().topY, n) + s, h = a.getStemExtents().topY;
                                if (h * e < l * e) {
                                    const t = Math.abs(h - l);
                                    s += t * -e, i += t * r;
                                } else i += (h - l) * e;
                            }
                            const l = a / 2, d = r * Math.abs(l - n) + Math.abs(i);
                            d < h && (h = d, c = n, u = s);
                        }
                        this.slope = c, this.y_shift = u;
                    }
                    calculateFlatSlope() {
                        const { notes: t, stem_direction: e, render_options: { beam_width: i, min_flat_beam_offset: s, flat_beam_offset: n } } = this;
                        let r = 0, o = 0, a = 0, l = 0;
                        for(let i = 0; i < t.length; i++){
                            const s = t[i], n = s.getStemExtents().topY;
                            r += n, e === v.DOWN && l < n ? (l = n, o = Math.max(...s.getYs()), a = s.getBeamCount()) : e === v.UP && (0 === l || l > n) && (l = n, o = Math.min(...s.getYs()), a = s.getBeamCount());
                        }
                        let h = r / t.length;
                        const c = s + a * (1.5 * i), u = o + c * -e;
                        e === v.DOWN && h < u ? h = o + c : e === v.UP && h > u && (h = o - c), n + this.render_options.flat_beam_offset_per_beam > 0 ? (e === v.DOWN && h > n && !this.render_options.flat_beams || e === v.UP && h < n && !this.render_options.flat_beams) && (this.render_options.flat_beam_offset = h) : this.render_options.flat_beam_offset = h, this.slope = 0, this.y_shift = 0;
                    }
                    getBeamYToDraw() {
                        let t = this.notes[0].getStemExtents().topY;
                        if (this.render_options.flat_beams && this.render_options.flat_beam_offset + this.render_options.flat_beam_offset_per_beam > 0) {
                            let e = this.render_options.flat_beam_offset;
                            this.render_options.flat_beam_offset_per_beam && (e += this.render_options.flat_beam_offset_per_beam * this.getBeamCount());
                            let i = this.notes[0].note_heads[0].y;
                            const s = this.stem_direction > 0 ? Math.min : Math.max;
                            for (const t of this.notes)for (const e of t.note_heads)i = s(i, e.y);
                            t = i + e * -this.stem_direction;
                        }
                        return t;
                    }
                    applyStemExtensions() {
                        const { notes: t, slope: e, y_shift: i, stem_direction: s, beam_count: n, render_options: { show_stemlets: r, stemlet_extension: o, beam_width: a } } = this, l = t[0], h = this.getBeamYToDraw(), c = l.getStemX();
                        for(let l = 0; l < t.length; ++l){
                            const u = t[l], d = u.getStemX(), { topY: f } = u.getStemExtents(), m = this.getSlopeY(d, c, h, e) + i, p = u.getStem().getExtension(), g = s === v.UP ? f - m : m - f;
                            if (u.stem.setExtension(p + g), u.stem.renderHeightAdjustment = -v.WIDTH / 2, u.isRest() && r) {
                                const t = (n - 1) * a * 1.5 + a;
                                u.stem.setVisibility(!0).setStemlet(!0, t + o);
                            }
                        }
                    }
                    lookupBeamDirection(t, e, i, s) {
                        if ("4" === t) return M;
                        const n = "" + p.durationToNumber(t) / 2, r = e < p.durationToTicks(n), o = s < p.durationToTicks(n), a = i < p.durationToTicks(n);
                        return r && o && a ? P : r && !o && a ? M : !r && o && a ? "R" : this.lookupBeamDirection(n, e, i, s);
                    }
                    getBeamLines(t) {
                        const e = p.durationToTicks(t), i = [];
                        let s = !1, n = null;
                        const r = this.render_options.partial_beam_length;
                        let o = !1, a = 0;
                        for(let l = 0; l < this.notes.length; ++l){
                            const h = this.notes[l];
                            a += h.ticks.value();
                            let c = !1;
                            parseInt(t, 10) >= 8 && (c = -1 !== this.break_on_indices.indexOf(l), this.render_options.secondary_break_ticks && a >= this.render_options.secondary_break_ticks && (a = 0, c = !0));
                            const u = h.getIntrinsicTicks() < e, d = h.getStemX() - v.WIDTH / 2, f = this.notes[l - 1], m = this.notes[l + 1], p = m && m.getIntrinsicTicks() < e, g = f && f.getIntrinsicTicks() < e, b = f && m && u && !g && !p;
                            if (u) {
                                if (s) n = i[i.length - 1], n.end = d, c && (s = !1, m && !p && null === n.end && (n.end = n.start - r));
                                else {
                                    if (n = {
                                        start: d,
                                        end: null,
                                        start_note: h
                                    }, s = !0, b) {
                                        const e = f.getIntrinsicTicks(), i = m.getIntrinsicTicks(), s = h.getIntrinsicTicks(), o = this.lookupBeamDirection(t, e, s, i);
                                        [
                                            M,
                                            P
                                        ].includes(o) ? n.end = n.start - r : n.end = n.start + r;
                                    } else p ? c && (n.end = n.start - r, s = !1) : n.end = (o || 0 === l) && m ? n.start + r : n.start - r;
                                    i.push(n);
                                }
                            } else s = !1;
                            o = c;
                        }
                        const l = i[i.length - 1];
                        return l && null === l.end && (l.end = l.start - r), i;
                    }
                    drawStems() {
                        this.notes.forEach((t)=>{
                            t.getStem() && (this.context.openGroup("stem", t.getAttribute("id") + "-stem"), t.getStem().setContext(this.context).draw(), this.context.closeGroup());
                        }, this);
                    }
                    drawBeamLines() {
                        this.checkContext();
                        const t = [
                            "4",
                            "8",
                            "16",
                            "32",
                            "64"
                        ], e = this.notes[0];
                        let i = this.getBeamYToDraw();
                        const s = e.getStemX(), n = this.render_options.beam_width * this.stem_direction, r = {};
                        for (const t of this.notes)r[t.getAttribute("id")] = 0;
                        for(let e = 0; e < t.length; ++e){
                            const o = t[e], a = this.getBeamLines(o);
                            for(let t = 0; t < a.length; ++t){
                                const e = a[t], o = e.start, l = e.start_note.getAttribute("id"), h = r[l];
                                r[l]++;
                                const c = this.getSlopeY(o, s, i, this.slope), u = e.end, d = this.getSlopeY(u, s, i, this.slope), f = l;
                                this.context.openGroup("beam", `${f}-beam${h}`), this.context.beginPath(), this.context.moveTo(o, c), this.context.lineTo(o, c + n), this.context.lineTo(u + v.WIDTH, d + n), this.context.lineTo(u + v.WIDTH, d), this.context.closePath(), this.context.fill(), this.context.closeGroup();
                            }
                            i += 1.5 * n;
                        }
                    }
                    preFormat() {
                        return this;
                    }
                    postFormat() {
                        if (!this.postFormatted) {
                            for (const t of this.notes)t.stem && t.getStemExtension && t.stem.setExtension(t.getStemExtension());
                            "tabnotes" === this.notes[0].getCategory() || this.render_options.flat_beams ? this.calculateFlatSlope() : this.calculateSlope(), this.applyStemExtensions(), this.postFormatted = !0;
                        }
                    }
                    draw() {
                        this.checkContext(), this.setRendered(), this.unbeamable || (this.postFormatted || this.postFormat(), this.drawStems(), this.applyStyle(), this.drawBeamLines(), this.restoreStyle());
                    }
                }
                class w extends l {
                    static get Mode() {
                        return {
                            STRICT: 1,
                            SOFT: 2,
                            FULL: 3
                        };
                    }
                    constructor(t){
                        if (super(), this.setAttribute("type", "Voice"), "string" == typeof t) {
                            const e = t.match(/(\d+)\/(\d+)/);
                            e && (t = {
                                num_beats: e[1],
                                beat_value: e[2],
                                resolution: p.RESOLUTION
                            });
                        }
                        this.time = s.Merge({
                            num_beats: 4,
                            beat_value: 4,
                            resolution: p.RESOLUTION
                        }, t), this.totalTicks = new n(this.time.num_beats * (this.time.resolution / this.time.beat_value), 1), this.resolutionMultiplier = 1, this.tickables = [], this.ticksUsed = new n(0, 1), this.smallestTickCount = this.totalTicks.clone(), this.largestTickWidth = 0, this.stave = null, this.mode = w.Mode.STRICT, this.voiceGroup = null;
                    }
                    getTotalTicks() {
                        return this.totalTicks;
                    }
                    getTicksUsed() {
                        return this.ticksUsed;
                    }
                    getLargestTickWidth() {
                        return this.largestTickWidth;
                    }
                    getSmallestTickCount() {
                        return this.smallestTickCount;
                    }
                    getTickables() {
                        return this.tickables;
                    }
                    getMode() {
                        return this.mode;
                    }
                    setMode(t) {
                        return this.mode = t, this;
                    }
                    getResolutionMultiplier() {
                        return this.resolutionMultiplier;
                    }
                    getActualResolution() {
                        return this.resolutionMultiplier * this.time.resolution;
                    }
                    setStave(t) {
                        return this.stave = t, this.boundingBox = null, this;
                    }
                    getBoundingBox() {
                        let t, e, i, n;
                        if (!this.boundingBox) {
                            if (!this.stave) throw new s.RERR("NoStave", "Can't get bounding box without stave.");
                            for(t = this.stave, e = null, n = 0; n < this.tickables.length; ++n)this.tickables[n].setStave(t), i = this.tickables[n].getBoundingBox(), i && (e = e ? e.mergeWith(i) : i);
                            this.boundingBox = e;
                        }
                        return this.boundingBox;
                    }
                    getVoiceGroup() {
                        if (!this.voiceGroup) throw new s.RERR("NoVoiceGroup", "No voice group for voice.");
                        return this.voiceGroup;
                    }
                    setVoiceGroup(t) {
                        return this.voiceGroup = t, this;
                    }
                    setStrict(t) {
                        return this.mode = t ? w.Mode.STRICT : w.Mode.SOFT, this;
                    }
                    isComplete() {
                        return this.mode !== w.Mode.STRICT && this.mode !== w.Mode.FULL || this.ticksUsed.equals(this.totalTicks);
                    }
                    addTickable(t) {
                        if (!t.shouldIgnoreTicks()) {
                            const e = t.getTicks();
                            if (this.ticksUsed.add(e), (this.mode === w.Mode.STRICT || this.mode === w.Mode.FULL) && this.ticksUsed.greaterThan(this.totalTicks)) throw this.ticksUsed.subtract(e), new s.RERR("BadArgument", "Too many ticks.");
                            e.lessThan(this.smallestTickCount) && (this.smallestTickCount = e.clone()), this.resolutionMultiplier = this.ticksUsed.denominator, this.totalTicks.add(0, this.ticksUsed.denominator);
                        }
                        return this.tickables.push(t), t.setVoice(this), this;
                    }
                    addTickables(t) {
                        for(let e = 0; e < t.length; ++e)this.addTickable(t[e]);
                        return this;
                    }
                    preFormat() {
                        return this.preFormatted || (this.tickables.forEach((t)=>{
                            t.getStave() || t.setStave(this.stave);
                        }), this.preFormatted = !0), this;
                    }
                    draw(t = this.context, e = this.stave) {
                        this.setRendered();
                        let i = null;
                        for(let n = 0; n < this.tickables.length; ++n){
                            const r = this.tickables[n];
                            if (e && r.setStave(e), !r.getStave()) throw new s.RuntimeError("MissingStave", "The voice cannot draw tickables without staves.");
                            if (0 === n && (i = r.getBoundingBox()), n > 0 && i) {
                                const t = r.getBoundingBox();
                                t && i.mergeWith(t);
                            }
                            r.setContext(t), r.drawWithStyle();
                        }
                        this.boundingBox = i;
                    }
                }
                function A(t, e, i, n, r) {
                    if (e !== I.type.BOLD_DOUBLE_LEFT && e !== I.type.BOLD_DOUBLE_RIGHT) throw new s.RERR("InvalidConnector", "A REPEAT_BEGIN or REPEAT_END type must be provided.");
                    let o = 3, a = 3.5;
                    e === I.type.BOLD_DOUBLE_RIGHT && (o = -5, a = 3), t.fillRect(i + o, n, 1, r - n), t.fillRect(i - 2, n, a, r - n);
                }
                class I extends l {
                    static get type() {
                        return {
                            SINGLE_RIGHT: 0,
                            SINGLE_LEFT: 1,
                            SINGLE: 1,
                            DOUBLE: 2,
                            BRACE: 3,
                            BRACKET: 4,
                            BOLD_DOUBLE_LEFT: 5,
                            BOLD_DOUBLE_RIGHT: 6,
                            THIN_DOUBLE: 7,
                            NONE: 8
                        };
                    }
                    static get typeString() {
                        return {
                            singleRight: I.type.SINGLE_RIGHT,
                            singleLeft: I.type.SINGLE_LEFT,
                            single: I.type.SINGLE,
                            double: I.type.DOUBLE,
                            brace: I.type.BRACE,
                            bracket: I.type.BRACKET,
                            boldDoubleLeft: I.type.BOLD_DOUBLE_LEFT,
                            boldDoubleRight: I.type.BOLD_DOUBLE_RIGHT,
                            thinDouble: I.type.THIN_DOUBLE,
                            none: I.type.NONE
                        };
                    }
                    constructor(t, e){
                        super(), this.setAttribute("type", "StaveConnector"), this.thickness = p.STAVE_LINE_THICKNESS, this.width = 3, this.top_stave = t, this.bottom_stave = e, this.type = I.type.DOUBLE, this.font = {
                            family: "times",
                            size: 16,
                            weight: "normal"
                        }, this.x_shift = 0, this.texts = [];
                    }
                    setType(t) {
                        return (t = "string" == typeof t ? I.typeString[t] : t) >= I.type.SINGLE_RIGHT && t <= I.type.NONE && (this.type = t), this;
                    }
                    setText(t, e) {
                        return this.texts.push({
                            content: t,
                            options: s.Merge({
                                shift_x: 0,
                                shift_y: 0
                            }, e)
                        }), this;
                    }
                    setFont(t) {
                        s.Merge(this.font, t);
                    }
                    setXShift(t) {
                        if ("number" != typeof t) throw s.RERR("InvalidType", "x_shift must be a Number");
                        return this.x_shift = t, this;
                    }
                    draw() {
                        const t = this.checkContext();
                        this.setRendered();
                        let e = this.top_stave.getYForLine(0), i = this.bottom_stave.getYForLine(this.bottom_stave.getNumLines() - 1) + this.thickness, n = this.width, r = this.top_stave.getX();
                        (this.type === I.type.SINGLE_RIGHT || this.type === I.type.BOLD_DOUBLE_RIGHT || this.type === I.type.THIN_DOUBLE) && (r = this.top_stave.getX() + this.top_stave.width);
                        let o = i - e;
                        switch(this.type){
                            case I.type.SINGLE:
                            case I.type.SINGLE_LEFT:
                            case I.type.SINGLE_RIGHT:
                                n = 1;
                                break;
                            case I.type.DOUBLE:
                                r -= this.width + 2;
                                break;
                            case I.type.BRACE:
                                {
                                    n = 12;
                                    const s = this.top_stave.getX() - 2 + this.x_shift, r = e, a = s, l = i, h = s - n, c = r + o / 2, u = h - .9 * n, d = r + .2 * o, f = s + 1.1 * n, m = c - .135 * o, p = f, g = c + .135 * o, b = u, S = l - .2 * o, y = h - n, E = S, x = s + .4 * n, v = c + .135 * o, T = x, _ = c - .135 * o, M = y, P = d;
                                    t.beginPath(), t.moveTo(s, r), t.bezierCurveTo(u, d, f, m, h, c), t.bezierCurveTo(p, g, b, S, a, l), t.bezierCurveTo(y, E, x, v, h, c), t.bezierCurveTo(T, _, M, P, s, r), t.fill(), t.stroke();
                                    break;
                                }
                            case I.type.BRACKET:
                                e -= 4, i += 4, o = i - e, m.renderGlyph(t, r - 5, e - 3, 40, "v1b", !0), m.renderGlyph(t, r - 5, i + 3, 40, "v10", !0), r -= this.width + 2;
                                break;
                            case I.type.BOLD_DOUBLE_LEFT:
                                A(t, this.type, r + this.x_shift, e, i);
                                break;
                            case I.type.BOLD_DOUBLE_RIGHT:
                                A(t, this.type, r, e, i);
                                break;
                            case I.type.THIN_DOUBLE:
                                n = 1;
                                break;
                            case I.type.NONE:
                                break;
                            default:
                                throw new s.RERR("InvalidType", `The provided StaveConnector.type (${this.type}) is invalid`);
                        }
                        this.type !== I.type.BRACE && this.type !== I.type.BOLD_DOUBLE_LEFT && this.type !== I.type.BOLD_DOUBLE_RIGHT && this.type !== I.type.NONE && t.fillRect(r, e, n, o), this.type === I.type.THIN_DOUBLE && t.fillRect(r - 3, e, n, o), t.save(), t.lineWidth = 2, t.setFont(this.font.family, this.font.size, this.font.weight);
                        for(let e = 0; e < this.texts.length; e++){
                            const i = this.texts[e], s = t.measureText("" + i.content).width, n = this.top_stave.getX() - s - 24 + i.options.shift_x, r = (this.top_stave.getYForLine(0) + this.bottom_stave.getBottomLineY()) / 2 + i.options.shift_y;
                            t.fillText("" + i.content, n, r + 4);
                        }
                        t.restore();
                    }
                }
                class R extends l {
                    constructor(){
                        super(), this.setAttribute("type", "Tickable"), this.ticks = new n(0, 1), this.intrinsicTicks = 0, this.tickMultiplier = new n(1, 1), this.width = 0, this.x_shift = 0, this.voice = null, this.tickContext = null, this.modifierContext = null, this.modifiers = [], this.preFormatted = !1, this.postFormatted = !1, this.tuplet = null, this.tupletStack = [], this.align_center = !1, this.center_x_shift = 0, this.ignore_ticks = !1, this.formatterMetrics = {
                            freedom: {
                                left: 0,
                                right: 0
                            },
                            duration: "",
                            iterations: 0,
                            space: {
                                used: 0,
                                mean: 0,
                                deviation: 0
                            }
                        };
                    }
                    reset() {
                        return this;
                    }
                    getTicks() {
                        return this.ticks;
                    }
                    shouldIgnoreTicks() {
                        return this.ignore_ticks;
                    }
                    getWidth() {
                        return this.width;
                    }
                    getFormatterMetrics() {
                        return this.formatterMetrics;
                    }
                    setXShift(t) {
                        this.x_shift = t;
                    }
                    getCenterXShift() {
                        return this.isCenterAligned() ? this.center_x_shift : 0;
                    }
                    isCenterAligned() {
                        return this.align_center;
                    }
                    setCenterAlignment(t) {
                        return this.align_center = t, this;
                    }
                    getVoice() {
                        if (!this.voice) throw new s.RERR("NoVoice", "Tickable has no voice.");
                        return this.voice;
                    }
                    setVoice(t) {
                        this.voice = t;
                    }
                    getTuplet() {
                        return this.tuplet;
                    }
                    resetTuplet(t) {
                        let e, i;
                        if (t) {
                            const s = this.tupletStack.indexOf(t);
                            return -1 !== s && (this.tupletStack.splice(s, 1), e = t.getNoteCount(), i = t.getNotesOccupied(), this.applyTickMultiplier(e, i)), this;
                        }
                        for(; this.tupletStack.length;)e = (t = this.tupletStack.pop()).getNoteCount(), i = t.getNotesOccupied(), this.applyTickMultiplier(e, i);
                        return this;
                    }
                    setTuplet(t) {
                        if (t) {
                            this.tupletStack.push(t);
                            const e = t.getNoteCount(), i = t.getNotesOccupied();
                            this.applyTickMultiplier(i, e);
                        }
                        return this.tuplet = t, this;
                    }
                    addToModifierContext(t) {
                        this.modifierContext = t, this.preFormatted = !1;
                    }
                    addModifier(t) {
                        return this.modifiers.push(t), this.preFormatted = !1, this;
                    }
                    getModifiers() {
                        return this.modifiers;
                    }
                    setTickContext(t) {
                        this.tickContext = t, this.preFormatted = !1;
                    }
                    preFormat() {
                        this.preFormatted || (this.width = 0, this.modifierContext && (this.modifierContext.preFormat(), this.width += this.modifierContext.getWidth()));
                    }
                    postFormat() {
                        return this.postFormatted || (this.postFormatted = !0), this;
                    }
                    getIntrinsicTicks() {
                        return this.intrinsicTicks;
                    }
                    setIntrinsicTicks(t) {
                        this.intrinsicTicks = t, this.ticks = this.tickMultiplier.clone().multiply(this.intrinsicTicks);
                    }
                    getTickMultiplier() {
                        return this.tickMultiplier;
                    }
                    applyTickMultiplier(t, e) {
                        this.tickMultiplier.multiply(t, e), this.ticks = this.tickMultiplier.clone().multiply(this.intrinsicTicks);
                    }
                    setDuration(t) {
                        const e = t.numerator * (p.RESOLUTION / t.denominator);
                        this.ticks = this.tickMultiplier.clone().multiply(e), this.intrinsicTicks = this.ticks.value();
                    }
                }
                class N extends R {
                    static get CATEGORY() {
                        return "note";
                    }
                    static get STAVEPADDING() {
                        return 12;
                    }
                    static plotMetrics(t, e, i) {
                        const n = e.getMetrics(), r = e.getAbsoluteX() - n.modLeftPx - n.extraLeftPx, o = e.getAbsoluteX() - n.extraLeftPx, a = e.getAbsoluteX(), l = e.getAbsoluteX() + n.noteWidth, h = e.getAbsoluteX() + n.noteWidth + n.extraRightPx, c = e.getAbsoluteX() + n.noteWidth + n.extraRightPx + n.modRightPx, u = c + e.getFormatterMetrics().freedom.right, d = c - r;
                        t.save(), t.setFont("Arial", 8, ""), t.fillText(Math.round(d) + "px", r + e.getXShift(), i);
                        const f = i + 7;
                        function m(i, s, n, r = f) {
                            t.beginPath(), t.setStrokeStyle(n), t.setFillStyle(n), t.setLineWidth(3), t.moveTo(i + e.getXShift(), r), t.lineTo(s + e.getXShift(), r), t.stroke();
                        }
                        m(r, o, "red"), m(o, a, "#999"), m(a, l, "green"), m(l, h, "#999"), m(h, c, "red"), m(c, u, "#DD0"), m(r - e.getXShift(), r, "#BBB"), s.drawDot(t, a + e.getXShift(), f, "blue");
                        const p = e.getFormatterMetrics();
                        if (p.iterations > 0) {
                            const s = p.space.deviation, n = s >= 0 ? "+" : "";
                            t.setFillStyle("red"), t.fillText(n + Math.round(s), a + e.getXShift(), i - 10);
                        }
                        t.restore();
                    }
                    constructor(t){
                        if (super(), this.setAttribute("type", "Note"), !t) throw new s.RuntimeError("BadArguments", "Note must have valid initialization data to identify duration and type.");
                        const e = p.parseNoteStruct(t);
                        if (!e) throw new s.RuntimeError("BadArguments", `Invalid note initialization object: ${JSON.stringify(t)}`);
                        if (this.duration = e.duration, this.dots = e.dots, this.noteType = e.type, this.customTypes = e.customTypes, t.duration_override ? this.setDuration(t.duration_override) : this.setIntrinsicTicks(e.ticks), this.modifiers = [], this.glyph = p.getGlyphProps(this.duration, this.noteType), this.customGlyphs = this.customTypes.map((t)=>p.getGlyphProps(this.duration, t)), this.positions && ("object" != typeof this.positions || !this.positions.length)) throw new s.RuntimeError("BadArguments", "Note keys must be array type.");
                        this.playNote = null, this.tickContext = null, this.modifierContext = null, this.ignore_ticks = !1, this.width = 0, this.extraLeftPx = 0, this.extraRightPx = 0, this.x_shift = 0, this.left_modPx = 0, this.right_modPx = 0, this.voice = null, this.preFormatted = !1, this.ys = [], t.align_center && this.setCenterAlignment(t.align_center), this.stave = null, this.render_options = {
                            annotation_spacing: 5,
                            stave_padding: N.STAVEPADDING
                        };
                    }
                    getPlayNote() {
                        return this.playNote;
                    }
                    setPlayNote(t) {
                        return this.playNote = t, this;
                    }
                    isRest() {
                        return !1;
                    }
                    addStroke(t, e) {
                        return e.setNote(this), e.setIndex(t), this.modifiers.push(e), this.setPreFormatted(!1), this;
                    }
                    getStave() {
                        return this.stave;
                    }
                    setStave(t) {
                        return this.stave = t, this.setYs([
                            t.getYForLine(0)
                        ]), this.context = this.stave.context, this;
                    }
                    getCategory() {
                        return N.CATEGORY;
                    }
                    setContext(t) {
                        return this.context = t, this;
                    }
                    getExtraLeftPx() {
                        return this.extraLeftPx;
                    }
                    getExtraRightPx() {
                        return this.extraRightPx;
                    }
                    setExtraLeftPx(t) {
                        return this.extraLeftPx = t, this;
                    }
                    setExtraRightPx(t) {
                        return this.extraRightPx = t, this;
                    }
                    shouldIgnoreTicks() {
                        return this.ignore_ticks;
                    }
                    getLineNumber() {
                        return 0;
                    }
                    getLineForRest() {
                        return 0;
                    }
                    getGlyph() {
                        return this.glyph;
                    }
                    getGlyphWidth() {
                        return this.glyph.getWidth(this.render_options.glyph_font_scale);
                    }
                    setYs(t) {
                        return this.ys = t, this;
                    }
                    getYs() {
                        if (0 === this.ys.length) throw new s.RERR("NoYValues", "No Y-values calculated for this note.");
                        return this.ys;
                    }
                    getYForTopText(t) {
                        if (!this.stave) throw new s.RERR("NoStave", "No stave attached to this note.");
                        return this.stave.getYForTopText(t);
                    }
                    getBoundingBox() {
                        return null;
                    }
                    getVoice() {
                        if (!this.voice) throw new s.RERR("NoVoice", "Note has no voice.");
                        return this.voice;
                    }
                    setVoice(t) {
                        return this.voice = t, this.preFormatted = !1, this;
                    }
                    getTickContext() {
                        return this.tickContext;
                    }
                    setTickContext(t) {
                        return this.tickContext = t, this.preFormatted = !1, this;
                    }
                    getDuration() {
                        return this.duration;
                    }
                    isDotted() {
                        return this.dots > 0;
                    }
                    hasStem() {
                        return !1;
                    }
                    getDots() {
                        return this.dots;
                    }
                    getNoteType() {
                        return this.noteType;
                    }
                    setBeam() {
                        return this;
                    }
                    setModifierContext(t) {
                        return this.modifierContext = t, this;
                    }
                    addModifier(t, e = 0) {
                        return t.setNote(this), t.setIndex(e), this.modifiers.push(t), this.setPreFormatted(!1), this;
                    }
                    getModifierStartXY() {
                        if (!this.preFormatted) throw new s.RERR("UnformattedNote", "Can't call GetModifierStartXY on an unformatted note");
                        return {
                            x: this.getAbsoluteX(),
                            y: this.ys[0]
                        };
                    }
                    getMetrics() {
                        if (!this.preFormatted) throw new s.RERR("UnformattedNote", "Can't call getMetrics on an unformatted note.");
                        let t = 0, e = 0;
                        null != this.modifierContext && (t = this.modifierContext.state.left_shift, e = this.modifierContext.state.right_shift);
                        const i = this.getWidth();
                        return {
                            width: i,
                            noteWidth: i - t - e - this.extraLeftPx - this.extraRightPx,
                            left_shift: this.x_shift,
                            modLeftPx: t,
                            modRightPx: e,
                            extraLeftPx: this.extraLeftPx,
                            extraRightPx: this.extraRightPx
                        };
                    }
                    setWidth(t) {
                        this.width = t;
                    }
                    getWidth() {
                        if (!this.preFormatted) throw new s.RERR("UnformattedNote", "Can't call GetWidth on an unformatted note.");
                        return this.width + (this.modifierContext ? this.modifierContext.getWidth() : 0);
                    }
                    setXShift(t) {
                        return this.x_shift = t, this;
                    }
                    getXShift() {
                        return this.x_shift;
                    }
                    getX() {
                        if (!this.tickContext) throw new s.RERR("NoTickContext", "Note needs a TickContext assigned for an X-Value");
                        return this.tickContext.getX() + this.x_shift;
                    }
                    getAbsoluteX() {
                        if (!this.tickContext) throw new s.RERR("NoTickContext", "Note needs a TickContext assigned for an X-Value");
                        let t = this.tickContext.getX();
                        return this.stave && (t += this.stave.getNoteStartX() + this.render_options.stave_padding), this.isCenterAligned() && (t += this.getCenterXShift()), t;
                    }
                    setPreFormatted(t) {
                        if (this.preFormatted = t, this.preFormatted) {
                            const t = this.tickContext.getExtraPx();
                            this.left_modPx = Math.max(this.left_modPx, t.left), this.right_modPx = Math.max(this.right_modPx, t.right);
                        }
                    }
                }
                class C extends N {
                    static get CATEGORY() {
                        return "notehead";
                    }
                    constructor(t){
                        if (super(t), this.setAttribute("type", "NoteHead"), this.index = t.index, this.x_shift = t.x_shift || 0, this.x = (t.x || 0) + this.x_shift, this.y = t.y || 0, this.note_type = t.note_type, this.duration = t.duration, this.displaced = t.displaced || !1, this.stem_direction = t.stem_direction || V.STEM_UP, this.line = t.line, this.glyph = p.getGlyphProps(this.duration, this.note_type), !this.glyph) throw new s.RuntimeError("BadArguments", `No glyph found for duration '${this.duration}' and type '${this.note_type}'`);
                        this.glyph_code = this.glyph.code_head, this.x_shift_ledger_rest = 0, this.y_shift_ledger_rest = 0, this.x_shift = t.x_shift || 0, this.glyph.rest && (this.line > 5 || this.line < 0) && (this.isLedgerLinedRest = !0, "h" === this.duration ? (t.custom_glyph_code = "rhl", this.x_shift_ledger_rest -= 4) : "w" === this.duration && (t.custom_glyph_code = "rwl", this.x_shift_ledger_rest -= 4, this.y_shift_ledger_rest = -5)), t.custom_glyph_code && (this.custom_glyph = !0, this.glyph_code = t.custom_glyph_code, this.stem_up_x_offset = t.stem_up_x_offset || 0, this.stem_down_x_offset = t.stem_down_x_offset || 0, this.stem_up_y_shift = t.stem_up_y_shift || 0, this.stem_down_y_shift = t.stem_down_y_shift || 0), this.style = t.style, this.slashed = t.slashed, s.Merge(this.render_options, {
                            glyph_font_scale: t.glyph_font_scale || p.DEFAULT_NOTATION_FONT_SCALE,
                            stroke_px: 3
                        }), this.setWidth(this.glyph.getWidth(this.render_options.glyph_font_scale));
                    }
                    getCategory() {
                        return C.CATEGORY;
                    }
                    getWidth() {
                        return this.width;
                    }
                    isDisplaced() {
                        return !0 === this.displaced;
                    }
                    getGlyph() {
                        return this.glyph;
                    }
                    setX(t) {
                        return this.x = t, this;
                    }
                    getY() {
                        return this.y;
                    }
                    setY(t) {
                        return this.y = t, this;
                    }
                    getLine() {
                        return this.line;
                    }
                    setLine(t) {
                        return this.line = t, this;
                    }
                    getAbsoluteX() {
                        const t = this.preFormatted ? super.getAbsoluteX() : this.x, e = v.WIDTH / 2;
                        return t + (this.displaced ? (this.width - e) * this.stem_direction : 0);
                    }
                    getBoundingBox() {
                        if (!this.preFormatted) throw new s.RERR("UnformattedNote", "Can't call getBoundingBox on an unformatted note.");
                        const t = this.stave.getSpacingBetweenLines(), e = t / 2, i = this.y - e;
                        return new p.BoundingBox(this.getAbsoluteX(), i, this.width, t);
                    }
                    setStave(t) {
                        const e = this.getLine();
                        return this.stave = t, this.setY(t.getYForNote(e)), this.context = this.stave.context, this;
                    }
                    preFormat() {
                        if (this.preFormatted) return this;
                        const t = this.getWidth() + this.extraLeftPx + this.extraRightPx;
                        return this.setWidth(t), this.setPreFormatted(!0), this;
                    }
                    draw() {
                        this.checkContext(), this.setRendered();
                        const t = this.context;
                        let e = this.getAbsoluteX(), i = this.y;
                        this.custom_glyph && (e += this.x_shift_ledger_rest, this.stem_direction === v.UP ? (e += this.stem_up_x_offset, i += this.stem_up_y_shift || 0) : this.stem_direction === v.DOWN && (e += this.stem_down_x_offset, i += this.stem_down_y_shift || 0), i += this.y_shift_ledger_rest), function(...t) {
                            C.DEBUG && s.L("Vex.Flow.NoteHead", t);
                        }("Drawing note head '", this.note_type, this.duration, "' at", e, i);
                        const n = this.stem_direction, r = this.render_options.glyph_font_scale;
                        if (this.style && this.applyStyle(t), "s" === this.note_type) {
                            const s = this.stave.getSpacingBetweenLines();
                            !function(t, e, i, s, n, r) {
                                const o = p.SLASH_NOTEHEAD_WIDTH;
                                t.save(), t.setLineWidth(p.STEM_WIDTH);
                                let a = !1;
                                if (p.durationToNumber(e) > 2 && (a = !0), a || (i -= p.STEM_WIDTH / 2 * n), t.beginPath(), t.moveTo(i, s + r), t.lineTo(i, s + 1), t.lineTo(i + o, s - r), t.lineTo(i + o, s), t.lineTo(i, s + r), t.closePath(), a ? t.fill() : t.stroke(), p.durationToFraction(e).equals(.5)) {
                                    const e = [
                                        -3,
                                        -1,
                                        o + 1,
                                        o + 3
                                    ];
                                    for(let n = 0; n < e.length; n++)t.beginPath(), t.moveTo(i + e[n], s - 10), t.lineTo(i + e[n], s + 11), t.stroke();
                                }
                                t.restore();
                            }(t, this.duration, e, i, n, s);
                        } else m.renderGlyph(t, e, i, r, this.glyph_code);
                        this.style && this.restoreStyle(t);
                    }
                }
                class B extends N {
                    constructor(t){
                        super(t), this.setAttribute("type", "StemmableNote"), this.stem = null, this.stemExtensionOverride = null, this.beam = null, this.renderFlag = !0;
                    }
                    getStem() {
                        return this.stem;
                    }
                    setStem(t) {
                        return this.stem = t, this;
                    }
                    buildStem() {
                        const t = new v;
                        return this.setStem(t), this;
                    }
                    buildFlag() {
                        const { glyph: t, beam: e } = this, i = null === e && this.renderFlag;
                        if (t && t.flag && i) {
                            const e = this.getStemDirection() === v.DOWN ? t.code_flag_downstem : t.code_flag_upstem;
                            this.flag = new m(e, this.render_options.glyph_font_scale);
                        }
                    }
                    getTopGlyph() {
                        return this.getStemDirection() === v.DOWN ? this.customGlyphs[this.customGlyphs.length - 1] : this.customGlyphs[0];
                    }
                    getStemLength() {
                        return v.HEIGHT + this.getStemExtension();
                    }
                    getBeamCount() {
                        const t = this.getGlyph();
                        return t ? t.beam_count : 0;
                    }
                    getStemMinumumLength() {
                        let t = p.durationToFraction(this.duration).value() <= 1 ? 0 : 20;
                        switch(this.duration){
                            case "8":
                                null == this.beam && (t = 35);
                                break;
                            case "16":
                                t = null == this.beam ? 35 : 25;
                                break;
                            case "32":
                                t = null == this.beam ? 45 : 35;
                                break;
                            case "64":
                                t = null == this.beam ? 50 : 40;
                                break;
                            case "128":
                                t = null == this.beam ? 55 : 45;
                        }
                        return t;
                    }
                    getStemDirection() {
                        return this.stem_direction;
                    }
                    setStemDirection(t) {
                        if (t || (t = v.UP), t !== v.UP && t !== v.DOWN) throw new s.RERR("BadArgument", `Invalid stem direction: ${t}`);
                        if (this.stem_direction = t, this.stem) {
                            this.stem.setDirection(t), this.stem.setExtension(this.getStemExtension());
                            const e = this.getTopGlyph() || this.getGlyph();
                            this.stem.setOptions({
                                stem_up_y_offset: e.stem_up_y_offset,
                                stem_down_y_offset: e.stem_down_y_offset
                            });
                        }
                        return this.reset(), this.flag && this.renderFlag && this.buildFlag(), this.beam = null, this.preFormatted && this.preFormat(), this;
                    }
                    getStemX() {
                        const t = this.getAbsoluteX() + this.x_shift, e = this.getAbsoluteX() + this.x_shift + this.getGlyphWidth();
                        return this.stem_direction === v.DOWN ? t : e;
                    }
                    getCenterGlyphX() {
                        return this.getAbsoluteX() + this.x_shift + this.getGlyphWidth() / 2;
                    }
                    getStemExtension() {
                        const t = this.getGlyph();
                        return null != this.stemExtensionOverride ? this.stemExtensionOverride : t ? 1 === this.getStemDirection() ? t.stem_up_extension : t.stem_down_extension : 0;
                    }
                    setStemLength(t) {
                        return this.stemExtensionOverride = t - v.HEIGHT, this;
                    }
                    getStemExtents() {
                        return this.stem.getExtents();
                    }
                    setBeam(t) {
                        return this.beam = t, this;
                    }
                    getYForTopText(t) {
                        const e = this.getStemExtents();
                        return this.hasStem() ? Math.min(this.stave.getYForTopText(t), e.topY - this.render_options.annotation_spacing * (t + 1)) : this.stave.getYForTopText(t);
                    }
                    getYForBottomText(t) {
                        const e = this.getStemExtents();
                        return this.hasStem() ? Math.max(this.stave.getYForTopText(t), e.baseY + this.render_options.annotation_spacing * t) : this.stave.getYForBottomText(t);
                    }
                    hasFlag() {
                        return this.renderFlag && p.getGlyphProps(this.duration).flag && !this.beam;
                    }
                    postFormat() {
                        return this.beam && this.beam.postFormat(), this.postFormatted = !0, this;
                    }
                    drawStem(t) {
                        this.checkContext(), this.setRendered(), this.setStem(new v(t)), this.stem.setContext(this.context).draw();
                    }
                }
                class D extends l {
                    static get CATEGORY() {
                        return "none";
                    }
                    static get Position() {
                        return {
                            LEFT: 1,
                            RIGHT: 2,
                            ABOVE: 3,
                            BELOW: 4
                        };
                    }
                    static get PositionString() {
                        return {
                            above: D.Position.ABOVE,
                            below: D.Position.BELOW,
                            left: D.Position.LEFT,
                            right: D.Position.RIGHT
                        };
                    }
                    constructor(){
                        super(), this.setAttribute("type", "Modifier"), this.width = 0, this.note = null, this.index = null, this.text_line = 0, this.position = D.Position.LEFT, this.modifier_context = null, this.x_shift = 0, this.y_shift = 0, this.spacingFromNextModifier = 0;
                    }
                    getCategory() {
                        return D.CATEGORY;
                    }
                    getWidth() {
                        return this.width;
                    }
                    setWidth(t) {
                        return this.width = t, this;
                    }
                    getNote() {
                        return this.note;
                    }
                    setNote(t) {
                        return this.note = t, this;
                    }
                    getIndex() {
                        return this.index;
                    }
                    setIndex(t) {
                        return this.index = t, this;
                    }
                    getModifierContext() {
                        return this.modifier_context;
                    }
                    setModifierContext(t) {
                        return this.modifier_context = t, this;
                    }
                    getPosition() {
                        return this.position;
                    }
                    setPosition(t) {
                        return this.position = "string" == typeof t ? D.PositionString[t] : t, this;
                    }
                    setTextLine(t) {
                        return this.text_line = t, this;
                    }
                    setYShift(t) {
                        return this.y_shift = t, this;
                    }
                    setSpacingFromNextModifier(t) {
                        this.spacingFromNextModifier = t;
                    }
                    getSpacingFromNextModifier() {
                        return this.spacingFromNextModifier;
                    }
                    setXShift(t) {
                        this.x_shift = 0, this.position === D.Position.LEFT ? this.x_shift -= t : this.x_shift += t;
                    }
                    getXShift() {
                        return this.x_shift;
                    }
                    draw() {
                        throw this.checkContext(), new s.RERR("MethodNotImplemented", "draw() not implemented for this modifier.");
                    }
                    alignSubNotesWithNote(t, e) {
                        const i = e.getTickContext(), s = i.getExtraPx(), n = i.getX() - s.left - s.extraLeft + this.getSpacingFromNextModifier();
                        t.forEach((t)=>{
                            const i = t.getTickContext();
                            t.setStave(e.stave), i.setXOffset(n);
                        });
                    }
                }
                class O extends D {
                    static get CATEGORY() {
                        return "dots";
                    }
                    static format(t, e) {
                        const i = e.right_shift;
                        if (!t || 0 === t.length) return !1;
                        const s = [], n = {};
                        for(let e = 0; e < t.length; ++e){
                            const i = t[e], r = i.getNote();
                            let o, a;
                            "function" == typeof r.getKeyProps ? (o = r.getKeyProps()[i.getIndex()], a = o.displaced ? r.getExtraRightPx() : 0) : (o = {
                                line: .5
                            }, a = 0);
                            const l = r.getAttribute("id");
                            s.push({
                                line: o.line,
                                note: r,
                                note_id: l,
                                dot: i
                            }), n[l] = Math.max(n[l] || a, a);
                        }
                        s.sort((t, e)=>e.line - t.line);
                        let r = i, o = 0, a = null, l = null, h = null, c = 0;
                        for(let t = 0; t < s.length; ++t){
                            const { dot: e, note: i, note_id: u, line: d } = s[t];
                            d === a && i === l || (r = n[u]), i.isRest() || d === a || (.5 === Math.abs(d % 1) ? c = 0 : (c = .5, null == l || l.isRest() || a - d !== .5 ? d + c === h && (c = -0.5) : c = -0.5)), i.isRest() ? e.dot_shiftY += -c : e.dot_shiftY = -c, h = d + c, e.setXShift(r), r += e.getWidth() + 1, o = r > o ? r : o, a = d, l = i;
                        }
                        return e.right_shift += o, !0;
                    }
                    constructor(){
                        super(), this.setAttribute("type", "Dot"), this.note = null, this.index = null, this.position = D.Position.RIGHT, this.radius = 2, this.setWidth(5), this.dot_shiftY = 0;
                    }
                    getCategory() {
                        return O.CATEGORY;
                    }
                    setNote(t) {
                        this.note = t, "gracenotes" === this.note.getCategory() && (this.radius *= .5, this.setWidth(3));
                    }
                    setDotShiftY(t) {
                        return this.dot_shiftY = t, this;
                    }
                    draw() {
                        if (this.checkContext(), this.setRendered(), !this.note || null === this.index) throw new s.RERR("NoAttachedNote", "Can't draw dot without a note and index.");
                        const t = this.note.stave.options.spacing_between_lines_px, e = this.note.getModifierStartXY(this.position, this.index, {
                            forceFlagRight: !0
                        });
                        "tabnotes" === this.note.getCategory() && (e.y = this.note.getStemExtents().baseY);
                        const i = e.x + this.x_shift + this.width - this.radius, n = e.y + this.y_shift + this.dot_shiftY * t, r = this.context;
                        r.beginPath(), r.arc(i, n, this.radius, 0, 2 * Math.PI, !1), r.fill();
                    }
                }
                function F(t, e, i) {
                    if (t.note.shiftRestVerticalDisabled) return;
                    const s = (e.isrest ? 0 : 1) * i;
                    t.line += s, t.maxLine += s, t.minLine += s, t.note.setKeyLine(0, t.note.getKeyLine(0) + s);
                }
                function k(t, e, i) {
                    if (t.isrest || e.isrest) return !1;
                    if (t.line !== e.line) return !1;
                    let s = 0, n = 0;
                    for (const i of [
                        t,
                        e
                    ])"h" === i.note.duration ? s++ : "w" === i.note.duration && n++;
                    return !(1 === n || !t.note.hiddenUnisonBaseHead && !e.note.hiddenUnisonBaseHead && (1 === s || i && 2 === n || t.note.dots > 0 && e.note.dots > 0 && t.note.dots !== e.note.dots));
                }
                class V extends B {
                    static get CATEGORY() {
                        return "stavenotes";
                    }
                    static get STEM_UP() {
                        return v.UP;
                    }
                    static get STEM_DOWN() {
                        return v.DOWN;
                    }
                    static get DEFAULT_LEDGER_LINE_OFFSET() {
                        return 3;
                    }
                    static format(t, e) {
                        if (!t || t.length < 2) return !1;
                        const i = [], n = t[0].stagger_same_whole_notes;
                        for(let e = 0; e < t.length; e++){
                            const s = t[e].getKeyProps(), n = s[0].line;
                            let r = s[s.length - 1].line;
                            const o = t[e].getStemDirection(), a = t[e].getStemLength() / 10, l = t[e].getStemMinumumLength() / 10;
                            let h;
                            t[e].isRest() ? (h = n + t[e].glyph.line_above, r = n - t[e].glyph.line_below) : (h = 1 === o ? s[s.length - 1].line + a : s[s.length - 1].line, r = 1 === o ? s[0].line : s[0].line - a), i.push({
                                line: s[0].line,
                                maxLine: h,
                                minLine: r,
                                isrest: t[e].isRest(),
                                stemDirection: o,
                                stemMax: a,
                                stemMin: l,
                                voice_shift: t[e].getVoiceShiftWidth(),
                                is_displaced: t[e].isDisplaced(),
                                note: t[e]
                            });
                        }
                        const r = i.length;
                        if (3 === r && !i.some((t)=>t.isrest)) {
                            const t = (t)=>{
                                const e = t.note.getKeyProps();
                                return (e[0].line + e[e.length - 1].line) / 2;
                            };
                            i.sort((e, i)=>t(i) - t(e));
                        }
                        let o = i[0];
                        const a = r > 2 ? i[1] : null;
                        let l = r > 2 ? i[2] : i[1];
                        2 !== r || -1 !== o.stemDirection || 1 !== l.stemDirection || o.isrest || l.isRest || (o = i[1], l = i[0]);
                        const h = Math.max(o.voice_shift, l.voice_shift);
                        let c, u = 0;
                        if (2 === r) {
                            const t = o.stemDirection === l.stemDirection ? 0 : .5;
                            if (o.stemDirection === l.stemDirection && o.minLine <= l.maxLine && (o.isrest || (c = Math.abs(o.line - (l.maxLine + .5)), c = Math.max(c, o.stemMin), o.minLine = o.line - c, o.note.setStemLength(10 * c))), o.minLine <= l.maxLine + t) {
                                if (o.isrest) F(o, l, 1), o.note.hasLedgerLinedRest && (o.note.shiftRestVerticalDisabled = !0);
                                else if (l.isrest) F(l, o, -1), l.note.hasLedgerLinedRest && (l.note.shiftRestVerticalDisabled = !0);
                                else {
                                    u = h;
                                    const t = Math.abs(o.line - l.line), e = (t)=>t.note.getKeyProps().slice(-1)[0].line, i = Math.max(o.line - e(l), l.line - e(o));
                                    if (0 !== t || k(o, l, n)) t < 1 && t > 0 || i < 1 && i > 0 ? (o.note.dots > 0 && (0 === l.note.dots || .5 === Math.abs(o.line % 1)) && 1 === o.stemDirection && -1 === l.stemDirection ? o : l).note.setXShift(u) : o.note.voice !== l.note.voice && o.stemDirection === l.stemDirection && (o.line > l.line ? 1 === o.stemDirection ? l.note.renderFlag = !1 : o.note.renderFlag = !1 : l.line > o.line ? 1 === l.stemDirection ? o.note.renderFlag = !1 : l.note.renderFlag = !1 : 1 === l.stemDirection && (l.stemDirection = -1, l.note.setStemDirection(-1)));
                                    else if (l.note.setXShift(u), o.note.dots > 0) {
                                        let t = 0;
                                        for (const e of o.note.modifiers)if (e instanceof O && (t++, e.setYShift(-10 * (l.maxLine - o.line + 1)), t === o.note.dots)) break;
                                    }
                                }
                            }
                            return !0;
                        }
                        if (null !== a && a.minLine < l.maxLine + .5 && (a.isrest || (c = Math.abs(a.line - (l.maxLine + .5)), c = Math.max(c, a.stemMin), a.minLine = a.line - c, a.note.setStemLength(10 * c))), a.isrest && !o.isrest && !l.isrest && (o.minLine <= a.maxLine || a.minLine <= l.maxLine)) return a.maxLine - a.minLine < o.minLine - l.maxLine ? function(t, e, i) {
                            const n = t.line - s.MidLine(e.minLine, i.maxLine);
                            t.note.setKeyLine(0, t.note.getKeyLine(0) - n), t.line -= n, t.maxLine -= n, t.minLine -= n;
                        }(a, o, l) : (u = h + 3, a.note.setXShift(u)), !0;
                        if (o.isrest && a.isrest && l.isrest) return F(o, a, 1), F(l, a, -1), !0;
                        a.isrest && o.isrest && a.minLine <= l.maxLine && F(a, l, 1), a.isrest && l.isrest && o.minLine <= a.maxLine && F(a, o, -1), o.isrest && o.minLine <= a.maxLine && F(o, a, 1), l.isrest && a.minLine <= l.maxLine && F(l, a, -1);
                        const d = !o.isrest && !a.isrest && o.minLine <= a.maxLine + .5, f = l.note.getKeyProps(), m = a.line - f[f.length - 1].line, p = !a.isrest && !l.isrest && (a.minLine <= l.maxLine || m <= .5), g = 1 === a.note.getKeyProps().length && (d && 1 === o.note.getKeyProps().length && k(o, a, n) || p && 1 === l.note.getKeyProps().length && k(a, l, n)), b = m >= 0 && m <= .5 && a.stemDirection !== o.stemDirection && 0 === a.note.dots, S = l.note.getStemStyle(), y = m > .5 && -1 === a.stemDirection && 1 === l.stemDirection && "#00000000" !== S?.strokeStyle, E = p && !d && !o.isrest && (b || y);
                        return !g && E ? l.note.setXShift(Math.max(h, a.note.getGlyphWidth())) : g || !d && !p || (u = h + 3, a.note.setXShift(u)), !0;
                    }
                    static formatByY(t, e) {
                        let i = !0;
                        for(let e = 0; e < t.length; e++)i = i && null != t[e].getStave();
                        if (!i) throw new s.RERR("Stave Missing", "All notes must have a stave - Vex.Flow.ModifierContext.formatMultiVoice!");
                        let n = 0;
                        for(let e = 0; e < t.length - 1; e++){
                            let i = t[e], s = t[e + 1];
                            i.maxLine < s.maxLine && (i = t[e + 1], s = t[e]);
                            const r = i.getKeyProps(), o = s.getKeyProps(), a = .5, l = i.getStave().getYForLine(5 - r[0].line + a);
                            s.getStave().getYForLine(5 - o[o.length - 1].line - a) - l < 0 && i.voice === s.voice && (n = i.getVoiceShiftWidth() + 2, s.setXShift(n));
                        }
                        e.right_shift += n;
                    }
                    static postFormat(t) {
                        return !!t && (t.forEach((t)=>t.postFormat()), !0);
                    }
                    constructor(t){
                        if (super(t), this.setAttribute("type", "StaveNote"), this.keys = t.keys, this.clef = t.clef, this.octave_shift = t.octave_shift, this.beam = null, this.glyph = p.getGlyphProps(this.duration, this.noteType), !this.glyph) throw new s.RuntimeError("BadArguments", `Invalid note initialization data (No glyph found): ${JSON.stringify(t)}`);
                        this.displaced = !1, this.dot_shiftY = 0, this.addDotsCount = 0, this.keyProps = [], this.use_default_head_x = !1, this.paddingRight = 0, this.note_heads = [], this.modifiers = [], s.Merge(this.render_options, {
                            glyph_font_scale: t.glyph_font_scale || p.DEFAULT_NOTATION_FONT_SCALE,
                            stroke_px: t.stroke_px || V.DEFAULT_LEDGER_LINE_OFFSET
                        }), this.calculateKeyProps(), this.buildStem(), t.auto_stem ? this.autoStem() : this.setStemDirection(t.stem_direction), this.reset(), this.buildFlag();
                    }
                    reset() {
                        super.reset();
                        const t = this.note_heads.map((t)=>t.getStyle()), e = [];
                        this.note_heads.forEach((t)=>e.push(t.note_type)), this.buildNoteHeads(), this.note_heads.forEach((i, s)=>{
                            i.setStyle(t[s]), e[s] && (i.note_type = e[s]);
                        }), this.stave && this.note_heads.forEach((t)=>t.setStave(this.stave)), this.calcExtraPx();
                    }
                    setBeam(t) {
                        return this.beam = t, this.calcExtraPx(), this;
                    }
                    getCategory() {
                        return V.CATEGORY;
                    }
                    buildStem() {
                        this.setStem(new v({
                            hide: !!this.isRest()
                        })), this.stem.id = s.Prefix(`${this.getAttribute("id")}-stem`);
                    }
                    buildNoteHeads() {
                        this.note_heads = [];
                        const t = this.getStemDirection(), e = this.getKeys();
                        let i, n, r, o = null, a = null, l = !1;
                        t === v.UP ? (i = 0, n = e.length, r = 1) : t === v.DOWN && (i = e.length - 1, n = -1, r = -1);
                        for(let e = i; e !== n; e += r){
                            const i = this.keyProps[e], n = i.line;
                            null === o ? o = n : (a = Math.abs(o - n), 0 === a || .5 === a ? l = !l : (l = !1, this.use_default_head_x = !0)), o = n;
                            const r = new C({
                                duration: this.duration,
                                note_type: this.noteType,
                                displaced: l,
                                stem_direction: t,
                                custom_glyph_code: i.code,
                                glyph_font_scale: this.render_options.glyph_font_scale,
                                x_shift: i.shift_right,
                                stem_up_x_offset: i.stem_up_x_offset,
                                stem_down_x_offset: i.stem_down_x_offset,
                                stem_up_y_shift: i.stem_up_y_shift,
                                stem_down_y_shift: i.stem_down_y_shift,
                                line: i.line
                            });
                            r.isLedgerLinedRest && (this.hasLedgerLinedRest = !0), r.id = this.stem.id = s.Prefix(`${this.getAttribute("id")}-stem${e}`), this.note_heads[e] = r;
                        }
                    }
                    autoStem() {
                        this.minLine = this.keyProps[0].line, this.maxLine = this.keyProps[this.keyProps.length - 1].line;
                        const t = (this.minLine + this.maxLine) / 2 < 3 ? v.UP : v.DOWN;
                        this.setStemDirection(t);
                    }
                    calculateKeyProps() {
                        let t = null;
                        for(let e = 0; e < this.keys.length; ++e){
                            const i = this.keys[e];
                            this.glyph.rest && (this.glyph.position = i);
                            const n = {
                                octave_shift: this.octave_shift || 0
                            }, r = p.keyProperties(i, this.clef, n);
                            if (!r) throw new s.RuntimeError("BadArguments", `Invalid key for note properties: ${i}`);
                            "R" === r.key && ("1" === this.duration || "w" === this.duration ? r.line = 4 : r.line = 3);
                            const o = r.line;
                            null === t ? t = o : Math.abs(t - o) < 1 && (this.displaced = !0, r.displaced = !0, this.keyProps.length > 0 && (this.keyProps[e - 1].displaced = !0)), t = o, this.keyProps.push(r);
                        }
                        t = -1 / 0, this.keyProps.forEach((e)=>{
                            e.line < t && s.W("Unsorted keys in note will be sorted. See https://github.com/0xfe/vexflow/issues/104 for details."), t = e.line;
                        }), this.keyProps.sort((t, e)=>t.line - e.line);
                    }
                    getBoundingBox() {
                        if (!this.preFormatted) throw new s.RERR("UnformattedNote", "Can't call getBoundingBox on an unformatted note.");
                        const { width: t, modLeftPx: e, extraLeftPx: i } = this.getMetrics(), n = this.getAbsoluteX() - e - i - this.paddingRight;
                        let r = 0, o = 0;
                        const a = this.getStave().getSpacingBetweenLines() / 2, l = 2 * a;
                        if (this.isRest()) {
                            const t = this.ys[0], e = p.durationToFraction(this.duration);
                            e.equals(1) || e.equals(2) ? (r = t - a, o = t + a) : (r = t - this.glyph.line_above * l, o = t + this.glyph.line_below * l);
                        } else if (this.glyph.stem) {
                            const t = this.getStemExtents();
                            t.baseY += a * this.stem_direction, r = Math.min(t.topY, t.baseY), o = Math.max(t.topY, t.baseY);
                        } else {
                            r = null, o = null;
                            for(let t = 0; t < this.ys.length; ++t){
                                const e = this.ys[t];
                                0 === t ? (r = e, o = e) : (r = Math.min(e, r), o = Math.max(e, o));
                            }
                            r -= a, o += a;
                        }
                        return new c(n, r, t, o - r);
                    }
                    getLineNumber(t) {
                        if (!this.keyProps.length) throw new s.RERR("NoKeyProps", "Can't get bottom note line, because note is not initialized properly.");
                        let e = this.keyProps[0].line;
                        for(let i = 0; i < this.keyProps.length; i++){
                            const s = this.keyProps[i].line;
                            t ? s > e && (e = s) : s < e && (e = s);
                        }
                        return e;
                    }
                    isRest() {
                        return this.glyph.rest;
                    }
                    isChord() {
                        return !this.isRest() && this.keys.length > 1;
                    }
                    hasStem() {
                        return this.glyph.stem;
                    }
                    hasFlag() {
                        return super.hasFlag() && !this.isRest() && this.renderFlag;
                    }
                    getStemX() {
                        return "r" === this.noteType ? this.getCenterGlyphX() : super.getStemX() + v.WIDTH / (2 * -this.getStemDirection());
                    }
                    getYForTopText(t) {
                        const e = this.getStemExtents();
                        return Math.min(this.stave.getYForTopText(t), e.topY - this.render_options.annotation_spacing * (t + 1));
                    }
                    getYForBottomText(t) {
                        const e = this.getStemExtents();
                        return Math.max(this.stave.getYForTopText(t), e.baseY + this.render_options.annotation_spacing * t);
                    }
                    setStave(t) {
                        super.setStave(t);
                        const e = this.note_heads.map((e)=>(e.setStave(t), e.getY()));
                        if (this.setYs(e), this.stem) {
                            const { y_top: t, y_bottom: e } = this.getNoteHeadBounds();
                            this.stem.setYBounds(t, e);
                        }
                        return this;
                    }
                    getKeys() {
                        return this.keys;
                    }
                    getKeyProps() {
                        return this.keyProps;
                    }
                    isDisplaced() {
                        return this.displaced;
                    }
                    setNoteDisplaced(t) {
                        return this.displaced = t, this;
                    }
                    getTieRightX() {
                        let t = this.getAbsoluteX();
                        return t += this.getGlyphWidth() + this.x_shift + this.extraRightPx, this.modifierContext && (t += this.modifierContext.getExtraRightPx()), t;
                    }
                    getTieLeftX() {
                        let t = this.getAbsoluteX();
                        return t += this.x_shift - this.extraLeftPx, t;
                    }
                    getLineForRest() {
                        let t = this.keyProps[0].line;
                        if (this.keyProps.length > 1) {
                            const e = this.keyProps[this.keyProps.length - 1].line, i = Math.max(t, e), n = Math.min(t, e);
                            t = s.MidLine(i, n);
                        }
                        return t;
                    }
                    getModifierStartXY(t, e, i) {
                        if (i = i || {}, !this.preFormatted) throw new s.RERR("UnformattedNote", "Can't call GetModifierStartXY on an unformatted note");
                        if (0 === this.ys.length) throw new s.RERR("NoYValues", "No Y-Values calculated for this note.");
                        const { ABOVE: n, BELOW: r, LEFT: o, RIGHT: a } = D.Position;
                        let l = 0;
                        return t === o ? l = -2 : t === a ? (l = this.getGlyphWidth() + this.x_shift + 2, this.stem_direction === v.UP && this.hasFlag() && (i.forceFlagRight || ((t, e)=>e === (t.getStemDirection() === v.UP ? t.keyProps.length - 1 : 0))(this, e)) && (l += this.flag.getMetrics().width)) : t !== r && t !== n || (l = this.getGlyphWidth() / 2 + this.x_shift), {
                            x: this.getAbsoluteX() + l,
                            y: this.ys[e]
                        };
                    }
                    setStyle(t) {
                        super.setStyle(t), this.note_heads.forEach((e)=>e.setStyle(t)), this.stem && this.stem.setStyle(t);
                    }
                    setStemStyle(t) {
                        this.stem && this.getStem().setStyle(t);
                    }
                    getStemStyle() {
                        return this.stem.getStyle();
                    }
                    setLedgerLineStyle(t) {
                        this.ledgerLineStyle = t;
                    }
                    getLedgerLineStyle() {
                        return this.ledgerLineStyle;
                    }
                    setFlagStyle(t) {
                        this.flagStyle = t;
                    }
                    getFlagStyle() {
                        return this.flagStyle;
                    }
                    setKeyStyle(t, e) {
                        return this.note_heads[t].setStyle(e), this;
                    }
                    setKeyLine(t, e) {
                        return this.keyProps[t].line = e, this.reset(), this;
                    }
                    getKeyLine(t) {
                        return this.keyProps[t].line;
                    }
                    addToModifierContext(t) {
                        this.setModifierContext(t);
                        for(let t = 0; t < this.modifiers.length; ++t)this.modifierContext.addModifier(this.modifiers[t]);
                        return this.modifierContext.addModifier(this), this.setPreFormatted(!1), this;
                    }
                    addModifier(t, e) {
                        return e.setNote(this), e.setIndex(t), this.modifiers.push(e), this.setPreFormatted(!1), this;
                    }
                    addAccidental(t, e) {
                        return this.addModifier(t, e);
                    }
                    addArticulation(t, e) {
                        return this.addModifier(t, e);
                    }
                    addAnnotation(t, e) {
                        return this.addModifier(t, e);
                    }
                    addDot(t) {
                        const e = new O;
                        return e.setDotShiftY(this.glyph.dot_shiftY), this.addDotsCount++, this.addModifier(t, e);
                    }
                    addDotToAll() {
                        for(let t = 0; t < this.keys.length; ++t)this.addDot(t);
                        return this;
                    }
                    getAccidentals() {
                        return this.modifierContext.getModifiers("accidentals");
                    }
                    getDots() {
                        return this.modifierContext.getModifiers("dots");
                    }
                    getVoiceShiftWidth() {
                        return this.getGlyphWidth() * (this.displaced ? 2 : 1);
                    }
                    calcExtraPx() {
                        this.setExtraLeftPx(this.displaced && this.stem_direction === v.DOWN ? this.getGlyphWidth() : 0), this.setExtraRightPx(!this.hasFlag() && this.displaced && this.stem_direction === v.UP ? this.getGlyphWidth() : 0);
                    }
                    preFormat() {
                        if (this.preFormatted) return;
                        this.modifierContext && this.modifierContext.preFormat();
                        let t = this.getGlyphWidth() + this.extraLeftPx + this.extraRightPx + this.paddingRight;
                        this.renderFlag && this.glyph.flag && null === this.beam && this.stem_direction === v.UP && (t += this.getGlyphWidth()), this.setWidth(t), this.setPreFormatted(!0);
                    }
                    getNoteHeadBounds() {
                        let t = null, e = null, i = null, s = null, n = this.stave.getNumLines(), r = 1, o = !1, a = !1, l = n, h = r;
                        return this.note_heads.forEach((c)=>{
                            const u = c.getLine(), d = c.getY();
                            (null === t || d < t) && (t = d), (null === e || d > e) && (e = d), null === s && c.isDisplaced() && (s = c.getAbsoluteX()), null !== i || c.isDisplaced() || (i = c.getAbsoluteX()), n = u > n ? u : n, r = u < r ? u : r, c.isDisplaced() ? (o = !1 === o ? u : Math.max(u, o), a = !1 === a ? u : Math.min(u, a)) : (l = Math.max(u, l), h = Math.min(u, h));
                        }, this), {
                            y_top: t,
                            y_bottom: e,
                            displaced_x: s,
                            non_displaced_x: i,
                            highest_line: n,
                            lowest_line: r,
                            highest_displaced_line: o,
                            lowest_displaced_line: a,
                            highest_non_displaced_line: l,
                            lowest_non_displaced_line: h
                        };
                    }
                    getNoteHeadBeginX() {
                        return this.getAbsoluteX() + this.x_shift;
                    }
                    getNoteHeadEndX() {
                        return this.getNoteHeadBeginX() + this.getGlyphWidth();
                    }
                    drawLedgerLines() {
                        const { stave: t, glyph: e, render_options: { stroke_px: i }, context: n } = this, r = e.getWidth() + 2 * i, o = 2 * (e.getWidth() + i) - v.WIDTH / 2;
                        if (this.isRest()) return;
                        if (!n) throw new s.RERR("NoCanvasContext", "Can't draw without a canvas context.");
                        const { highest_line: a, lowest_line: l, highest_displaced_line: h, highest_non_displaced_line: c, lowest_displaced_line: u, lowest_non_displaced_line: d, displaced_x: f, non_displaced_x: m } = this.getNoteHeadBounds(), p = Math.min(f, m), g = (t, e, s)=>{
                            let a;
                            a = s && e ? p - i : e ? m - i : f - i;
                            const l = e && s ? o : r;
                            n.beginPath(), n.moveTo(a, t), n.lineTo(a + l, t), n.stroke();
                        }, b = {
                            ...t.getStyle() || {},
                            ...this.getLedgerLineStyle() || {}
                        };
                        this.applyStyle(n, b);
                        const S = a >= 6 || l <= 0;
                        S && n.openGroup("ledgers", this.getAttribute("id") + "ledgers");
                        for(let e = 6; e <= a; ++e){
                            const i = null !== m && e <= c, s = null !== f && e <= h;
                            g(t.getYForNote(e), i, s);
                        }
                        for(let e = 0; e >= l; --e){
                            const i = null !== m && e >= d, s = null !== f && e >= u;
                            g(t.getYForNote(e), i, s);
                        }
                        S && n.closeGroup(), this.restoreStyle(n, b);
                    }
                    drawModifiers() {
                        if (!this.context) throw new s.RERR("NoCanvasContext", "Can't draw without a canvas context.");
                        const t = this.context;
                        t.openGroup("modifiers");
                        for(let e = 0; e < this.modifiers.length; e++){
                            const i = this.modifiers[e], s = this.note_heads[i.getIndex()], n = s.getStyle();
                            s.applyStyle(t, n), i.setContext(t), i.drawWithStyle(), s.restoreStyle(t, n);
                        }
                        t.closeGroup();
                    }
                    drawFlag() {
                        const { stem: t, beam: e, context: i } = this;
                        if (!i) throw new s.RERR("NoCanvasContext", "Can't draw without a canvas context.");
                        const n = null === e && this.renderFlag;
                        if (this.getGlyph().flag && n) {
                            const { y_top: e, y_bottom: s } = this.getNoteHeadBounds(), n = t.getHeight(), r = this.getStemX(), o = this.getStemDirection() === v.DOWN ? e - n + 2 : s - n - 2;
                            i.openGroup("flag", null, {
                                pointerBBox: !0
                            }), this.applyStyle(i, this.getFlagStyle() || !1), this.flag.render(i, r, o), this.restoreStyle(i, this.getFlagStyle() || !1), i.closeGroup();
                        }
                    }
                    drawNoteHeads() {
                        this.note_heads.forEach((t)=>{
                            this.context.openGroup("notehead", null, {
                                pointerBBox: !0
                            }), t.setContext(this.context).draw(), this.context.closeGroup();
                        });
                    }
                    drawStem(t) {
                        if (!this.context) throw new s.RERR("NoCanvasContext", "Can't draw without a canvas context.");
                        t && this.setStem(new v(t)), this.stem.id = s.Prefix(`${this.getAttribute("id")}-stem`), this.stem && (this.context.openGroup("stem", null, {
                            pointerBBox: !0
                        }), this.stem.setContext(this.context).draw(), this.context.closeGroup());
                    }
                    draw() {
                        if (!this.context) throw new s.RERR("NoCanvasContext", "Can't draw without a canvas context.");
                        if (!this.stave) throw new s.RERR("NoStave", "Can't draw without a stave.");
                        if (0 === this.ys.length) throw new s.RERR("NoYValues", "Can't draw note without Y values.");
                        const t = this.getNoteHeadBeginX(), e = this.hasStem() && !this.beam;
                        if (this.note_heads.forEach((e)=>e.setX(t)), this.stem) {
                            const t = this.getStemX();
                            this.stem.setNoteHeadXBounds(t, t);
                        }
                        !function(...t) {
                            V.DEBUG && s.L("Vex.Flow.StaveNote", t);
                        }("Rendering ", this.isChord() ? "chord :" : "note :", this.keys), this.drawLedgerLines(), this.applyStyle(), this.setAttribute("el", this.context.openGroup("stavenote", this.getAttribute("id"))), this.context.openGroup("note", null, {
                            pointerBBox: !0
                        }), e && this.drawStem(), this.drawNoteHeads(), this.drawFlag(), this.context.closeGroup(), this.drawModifiers(), this.context.closeGroup(), this.restoreStyle(), this.setRendered();
                    }
                }
                class G extends D {
                    static get CATEGORY() {
                        return "frethandfinger";
                    }
                    static format(t, e) {
                        const { left_shift: i, right_shift: s } = e;
                        if (!t || 0 === t.length) return !1;
                        const n = [];
                        let r = null, o = 0, a = 0;
                        for(let e = 0; e < t.length; ++e){
                            const l = t[e], h = l.getNote(), c = l.getPosition(), u = h.getKeyProps()[l.getIndex()];
                            if (h !== r) {
                                for(let t = 0; t < h.keys.length; ++t){
                                    const e = h.getKeyProps()[t];
                                    0 === i && (o = e.displaced ? h.getExtraLeftPx() : o), 0 === s && (a = e.displaced ? h.getExtraRightPx() : a);
                                }
                                r = h;
                            }
                            n.push({
                                note: h,
                                num: l,
                                pos: c,
                                line: u.line,
                                shiftL: o,
                                shiftR: a
                            });
                        }
                        n.sort((t, e)=>e.line - t.line);
                        let l = 0, h = 0, c = 0, u = 0, d = null, f = null;
                        for(let t = 0; t < n.length; ++t){
                            let e = 0;
                            const { note: r, pos: o, num: m, line: p, shiftL: g, shiftR: b } = n[t];
                            p === d && r === f || (l = i + g, h = s + b);
                            const S = m.getWidth() + 1;
                            o === D.Position.LEFT ? (m.setXShift(i + l), e = i + S, c = e > c ? e : c) : o === D.Position.RIGHT && (m.setXShift(h), e = a + S, u = e > u ? e : u), d = p, f = r;
                        }
                        return e.left_shift += c, e.right_shift += u, !0;
                    }
                    constructor(t){
                        super(), this.setAttribute("type", "FretHandFinger"), this.note = null, this.index = null, this.finger = t, this.width = 7, this.position = D.Position.LEFT, this.x_shift = 0, this.y_shift = 0, this.x_offset = 0, this.y_offset = 0, this.font = {
                            family: "sans-serif",
                            size: 9,
                            weight: "bold"
                        };
                    }
                    getCategory() {
                        return G.CATEGORY;
                    }
                    setFretHandFinger(t) {
                        return this.finger = t, this;
                    }
                    setOffsetX(t) {
                        return this.x_offset = t, this;
                    }
                    setOffsetY(t) {
                        return this.y_offset = t, this;
                    }
                    draw() {
                        if (this.checkContext(), !this.note || null == this.index) throw new s.RERR("NoAttachedNote", "Can't draw string number without a note and index.");
                        this.setRendered();
                        const t = this.context, e = this.note.getModifierStartXY(this.position, this.index);
                        let i = e.x + this.x_shift + this.x_offset, n = e.y + this.y_shift + this.y_offset + 5;
                        switch(this.position){
                            case D.Position.ABOVE:
                                i -= 4, n -= 12;
                                break;
                            case D.Position.BELOW:
                                i -= 2, n += 10;
                                break;
                            case D.Position.LEFT:
                                i -= this.width;
                                break;
                            case D.Position.RIGHT:
                                i += 1;
                                break;
                            default:
                                throw new s.RERR("InvalidPostion", `The position ${this.position} does not exist`);
                        }
                        t.save(), t.setFont(this.font.family, this.font.size, this.font.weight), t.fillText("" + this.finger, i, n), t.restore();
                    }
                }
                class W {
                    static get NUM_TONES() {
                        return 12;
                    }
                    static get roots() {
                        return [
                            "c",
                            "d",
                            "e",
                            "f",
                            "g",
                            "a",
                            "b"
                        ];
                    }
                    static get root_values() {
                        return [
                            0,
                            2,
                            4,
                            5,
                            7,
                            9,
                            11
                        ];
                    }
                    static get root_indices() {
                        return {
                            c: 0,
                            d: 1,
                            e: 2,
                            f: 3,
                            g: 4,
                            a: 5,
                            b: 6
                        };
                    }
                    static get canonical_notes() {
                        return [
                            "c",
                            "c#",
                            "d",
                            "d#",
                            "e",
                            "f",
                            "f#",
                            "g",
                            "g#",
                            "a",
                            "a#",
                            "b"
                        ];
                    }
                    static get diatonic_intervals() {
                        return [
                            "unison",
                            "m2",
                            "M2",
                            "m3",
                            "M3",
                            "p4",
                            "dim5",
                            "p5",
                            "m6",
                            "M6",
                            "b7",
                            "M7",
                            "octave"
                        ];
                    }
                    static get diatonic_accidentals() {
                        return {
                            unison: {
                                note: 0,
                                accidental: 0
                            },
                            m2: {
                                note: 1,
                                accidental: -1
                            },
                            M2: {
                                note: 1,
                                accidental: 0
                            },
                            m3: {
                                note: 2,
                                accidental: -1
                            },
                            M3: {
                                note: 2,
                                accidental: 0
                            },
                            p4: {
                                note: 3,
                                accidental: 0
                            },
                            dim5: {
                                note: 4,
                                accidental: -1
                            },
                            p5: {
                                note: 4,
                                accidental: 0
                            },
                            m6: {
                                note: 5,
                                accidental: -1
                            },
                            M6: {
                                note: 5,
                                accidental: 0
                            },
                            b7: {
                                note: 6,
                                accidental: -1
                            },
                            M7: {
                                note: 6,
                                accidental: 0
                            },
                            octave: {
                                note: 7,
                                accidental: 0
                            }
                        };
                    }
                    static get intervals() {
                        return {
                            u: 0,
                            unison: 0,
                            m2: 1,
                            b2: 1,
                            min2: 1,
                            S: 1,
                            H: 1,
                            2: 2,
                            M2: 2,
                            maj2: 2,
                            T: 2,
                            W: 2,
                            m3: 3,
                            b3: 3,
                            min3: 3,
                            M3: 4,
                            3: 4,
                            maj3: 4,
                            4: 5,
                            p4: 5,
                            "#4": 6,
                            b5: 6,
                            aug4: 6,
                            dim5: 6,
                            5: 7,
                            p5: 7,
                            "#5": 8,
                            b6: 8,
                            aug5: 8,
                            6: 9,
                            M6: 9,
                            maj6: 9,
                            b7: 10,
                            m7: 10,
                            min7: 10,
                            dom7: 10,
                            M7: 11,
                            maj7: 11,
                            8: 12,
                            octave: 12
                        };
                    }
                    static get scales() {
                        return {
                            major: [
                                2,
                                2,
                                1,
                                2,
                                2,
                                2,
                                1
                            ],
                            dorian: [
                                2,
                                1,
                                2,
                                2,
                                2,
                                1,
                                2
                            ],
                            mixolydian: [
                                2,
                                2,
                                1,
                                2,
                                2,
                                1,
                                2
                            ],
                            minor: [
                                2,
                                1,
                                2,
                                2,
                                1,
                                2,
                                2
                            ]
                        };
                    }
                    static get scaleTypes() {
                        return {
                            M: W.scales.major,
                            m: W.scales.minor
                        };
                    }
                    static get accidentals() {
                        return [
                            "bb",
                            "b",
                            "n",
                            "#",
                            "##"
                        ];
                    }
                    static get noteValues() {
                        return {
                            c: {
                                root_index: 0,
                                int_val: 0
                            },
                            cn: {
                                root_index: 0,
                                int_val: 0
                            },
                            "c#": {
                                root_index: 0,
                                int_val: 1
                            },
                            "c##": {
                                root_index: 0,
                                int_val: 2
                            },
                            cb: {
                                root_index: 0,
                                int_val: 11
                            },
                            cbb: {
                                root_index: 0,
                                int_val: 10
                            },
                            d: {
                                root_index: 1,
                                int_val: 2
                            },
                            dn: {
                                root_index: 1,
                                int_val: 2
                            },
                            "d#": {
                                root_index: 1,
                                int_val: 3
                            },
                            "d##": {
                                root_index: 1,
                                int_val: 4
                            },
                            db: {
                                root_index: 1,
                                int_val: 1
                            },
                            dbb: {
                                root_index: 1,
                                int_val: 0
                            },
                            e: {
                                root_index: 2,
                                int_val: 4
                            },
                            en: {
                                root_index: 2,
                                int_val: 4
                            },
                            "e#": {
                                root_index: 2,
                                int_val: 5
                            },
                            "e##": {
                                root_index: 2,
                                int_val: 6
                            },
                            eb: {
                                root_index: 2,
                                int_val: 3
                            },
                            ebb: {
                                root_index: 2,
                                int_val: 2
                            },
                            f: {
                                root_index: 3,
                                int_val: 5
                            },
                            fn: {
                                root_index: 3,
                                int_val: 5
                            },
                            "f#": {
                                root_index: 3,
                                int_val: 6
                            },
                            "f##": {
                                root_index: 3,
                                int_val: 7
                            },
                            fb: {
                                root_index: 3,
                                int_val: 4
                            },
                            fbb: {
                                root_index: 3,
                                int_val: 3
                            },
                            g: {
                                root_index: 4,
                                int_val: 7
                            },
                            gn: {
                                root_index: 4,
                                int_val: 7
                            },
                            "g#": {
                                root_index: 4,
                                int_val: 8
                            },
                            "g##": {
                                root_index: 4,
                                int_val: 9
                            },
                            gb: {
                                root_index: 4,
                                int_val: 6
                            },
                            gbb: {
                                root_index: 4,
                                int_val: 5
                            },
                            a: {
                                root_index: 5,
                                int_val: 9
                            },
                            an: {
                                root_index: 5,
                                int_val: 9
                            },
                            "a#": {
                                root_index: 5,
                                int_val: 10
                            },
                            "a##": {
                                root_index: 5,
                                int_val: 11
                            },
                            ab: {
                                root_index: 5,
                                int_val: 8
                            },
                            abb: {
                                root_index: 5,
                                int_val: 7
                            },
                            b: {
                                root_index: 6,
                                int_val: 11
                            },
                            bn: {
                                root_index: 6,
                                int_val: 11
                            },
                            "b#": {
                                root_index: 6,
                                int_val: 0
                            },
                            "b##": {
                                root_index: 6,
                                int_val: 1
                            },
                            bb: {
                                root_index: 6,
                                int_val: 10
                            },
                            bbb: {
                                root_index: 6,
                                int_val: 9
                            }
                        };
                    }
                    isValidNoteValue(t) {
                        return !(null == t || t < 0 || t >= W.NUM_TONES);
                    }
                    isValidIntervalValue(t) {
                        return this.isValidNoteValue(t);
                    }
                    getNoteParts(t) {
                        if (!t || t.length < 1) throw new s.RERR("BadArguments", "Invalid note name: " + t);
                        if (t.length > 3) throw new s.RERR("BadArguments", "Invalid note name: " + t);
                        const e = t.toLowerCase(), i = /^([cdefgab])(b|bb|n|#|##)?$/.exec(e);
                        if (null != i) return {
                            root: i[1],
                            accidental: i[2]
                        };
                        throw new s.RERR("BadArguments", "Invalid note name: " + t);
                    }
                    getKeyParts(t) {
                        if (!t || t.length < 1) throw new s.RERR("BadArguments", "Invalid key: " + t);
                        const e = t.toLowerCase(), i = /^([cdefgab])(b|#)?(mel|harm|m|M)?$/.exec(e);
                        if (null != i) {
                            const t = i[1], e = i[2];
                            let s = i[3];
                            return s || (s = "M"), {
                                root: t,
                                accidental: e,
                                type: s
                            };
                        }
                        throw new s.RERR("BadArguments", `Invalid key: ${t}`);
                    }
                    getNoteValue(t) {
                        const e = W.noteValues[t];
                        if (null == e) throw new s.RERR("BadArguments", `Invalid note name: ${t}`);
                        return e.int_val;
                    }
                    getIntervalValue(t) {
                        const e = W.intervals[t];
                        if (null == e) throw new s.RERR("BadArguments", `Invalid interval name: ${t}`);
                        return e;
                    }
                    getCanonicalNoteName(t) {
                        if (!this.isValidNoteValue(t)) throw new s.RERR("BadArguments", `Invalid note value: ${t}`);
                        return W.canonical_notes[t];
                    }
                    getCanonicalIntervalName(t) {
                        if (!this.isValidIntervalValue(t)) throw new s.RERR("BadArguments", `Invalid interval value: ${t}`);
                        return W.diatonic_intervals[t];
                    }
                    getRelativeNoteValue(t, e, i) {
                        if (null == i && (i = 1), 1 !== i && -1 !== i) throw new s.RERR("BadArguments", `Invalid direction: ${i}`);
                        let n = (t + i * e) % W.NUM_TONES;
                        return n < 0 && (n += W.NUM_TONES), n;
                    }
                    getRelativeNoteName(t, e) {
                        const i = this.getNoteParts(t), n = this.getNoteValue(i.root);
                        let r = e - n;
                        if (Math.abs(r) > W.NUM_TONES - 3) {
                            let i = 1;
                            r > 0 && (i = -1);
                            const o = (e + 1 + (n + 1)) % W.NUM_TONES * i;
                            if (Math.abs(o) > 2) throw new s.RERR("BadArguments", `Notes not related: ${t}, ${e})`);
                            r = o;
                        }
                        if (Math.abs(r) > 2) throw new s.RERR("BadArguments", `Notes not related: ${t}, ${e})`);
                        let o = i.root;
                        if (r > 0) for(let t = 1; t <= r; ++t)o += "#";
                        else if (r < 0) for(let t = -1; t >= r; --t)o += "b";
                        return o;
                    }
                    getScaleTones(t, e) {
                        const i = [
                            t
                        ];
                        let s = t;
                        for(let n = 0; n < e.length; n += 1)s = this.getRelativeNoteValue(s, e[n]), s !== t && i.push(s);
                        return i;
                    }
                    getIntervalBetween(t, e, i) {
                        if (null == i && (i = 1), 1 !== i && -1 !== i) throw new s.RERR("BadArguments", `Invalid direction: ${i}`);
                        if (!this.isValidNoteValue(t) || !this.isValidNoteValue(e)) throw new s.RERR("BadArguments", `Invalid notes: ${t}, ${e}`);
                        let n = 1 === i ? e - t : t - e;
                        return n < 0 && (n += W.NUM_TONES), n;
                    }
                    createScaleMap(t) {
                        const e = this.getKeyParts(t), i = W.scaleTypes[e.type];
                        let n = e.root;
                        if (e.accidental && (n += e.accidental), !i) throw new s.RERR("BadArguments", "Unsupported key type: " + t);
                        const r = this.getScaleTones(this.getNoteValue(n), i), o = W.root_indices[e.root], a = {};
                        for(let t = 0; t < W.roots.length; ++t){
                            const e = (o + t) % W.roots.length, i = W.roots[e];
                            let s = this.getRelativeNoteName(i, r[t]);
                            1 === s.length && (s += "n"), a[i] = s;
                        }
                        return a;
                    }
                }
                function U(...t) {
                    H.DEBUG && s.L("Vex.Flow.Accidental", t);
                }
                const z = (t)=>t.getMetrics().width;
                class H extends D {
                    static get CATEGORY() {
                        return "accidentals";
                    }
                    static format(t, e) {
                        const i = e.left_shift + 1;
                        if (!t || 0 === t.length) return;
                        const s = [];
                        let n, r = null, o = 0;
                        for(let e = 0; e < t.length; ++e){
                            const i = t[e], a = i.getNote(), l = a.getStave(), h = a.getKeyProps()[i.getIndex()];
                            if (a !== r) {
                                for(let t = 0; t < a.keys.length; ++t)n = a.getKeyProps()[t], o = n.displaced ? a.getExtraLeftPx() : o;
                                r = a;
                            }
                            if (null !== l) {
                                const t = l.options.spacing_between_lines_px, e = l.getYForLine(h.line), n = Math.round(e / t * 2) / 2;
                                s.push({
                                    y: e,
                                    line: n,
                                    shift: o,
                                    acc: i,
                                    lineSpace: t
                                });
                            } else s.push({
                                line: h.line,
                                shift: o,
                                acc: i
                            });
                        }
                        s.sort((t, e)=>e.line - t.line);
                        const a = [];
                        let l = 0, h = null;
                        for(let t = 0; t < s.length; t++){
                            const e = s[t];
                            null !== h && h === e.line || a.push({
                                line: e.line,
                                flatLine: !0,
                                dblSharpLine: !0,
                                numAcc: 0,
                                width: 0
                            }), "b" !== e.acc.type && "bb" !== e.acc.type && (a[a.length - 1].flatLine = !1), "##" !== e.acc.type && (a[a.length - 1].dblSharpLine = !1), a[a.length - 1].numAcc++, a[a.length - 1].width += e.acc.getWidth() + 3, l = e.shift > l ? e.shift : l, h = e.line;
                        }
                        let c = 0;
                        for(let t = 0; t < a.length; t++){
                            let e = !1;
                            const i = t;
                            let s = t;
                            for(; s + 1 < a.length && !e;)this.checkCollision(a[s], a[s + 1]) ? s++ : e = !0;
                            const n = (t)=>a[i + t], r = (t)=>t.map(n), o = (t, e)=>{
                                const [i, s] = r([
                                    t,
                                    e
                                ]).map((t)=>t.line);
                                return i - s;
                            }, l = (...t)=>t.map(r).every((t)=>!this.checkCollision(...t)), h = s - i + 1;
                            let u, d, f = this.checkCollision(a[i], a[s]) ? "a" : "b";
                            switch(h){
                                case 3:
                                    "a" === f && .5 === o(1, 2) && .5 !== o(0, 1) && (f = "second_on_bottom");
                                    break;
                                case 4:
                                    l([
                                        0,
                                        2
                                    ], [
                                        1,
                                        3
                                    ]) && (f = "spaced_out_tetrachord");
                                    break;
                                case 5:
                                    "b" === f && l([
                                        1,
                                        3
                                    ]) && (f = "spaced_out_pentachord", l([
                                        0,
                                        2
                                    ], [
                                        2,
                                        4
                                    ]) && (f = "very_spaced_out_pentachord"));
                                    break;
                                case 6:
                                    l([
                                        0,
                                        3
                                    ], [
                                        1,
                                        4
                                    ], [
                                        2,
                                        5
                                    ]) && (f = "spaced_out_hexachord"), l([
                                        0,
                                        2
                                    ], [
                                        2,
                                        4
                                    ], [
                                        1,
                                        3
                                    ], [
                                        3,
                                        5
                                    ]) && (f = "very_spaced_out_hexachord");
                            }
                            if (h >= 7) {
                                let e = 2, i = !0;
                                for(; !0 === i;){
                                    i = !1;
                                    for(let t = 0; t + e < a.length; t++)if (this.checkCollision(a[t], a[t + e])) {
                                        i = !0, e++;
                                        break;
                                    }
                                }
                                for(u = t; u <= s; u++)d = (u - t) % e + 1, a[u].column = d, c = c > d ? c : d;
                            } else for(u = t; u <= s; u++)d = p.accidentalColumnsTable[h][f][u - t], a[u].column = d, c = c > d ? c : d;
                            t = s;
                        }
                        const u = [], d = [];
                        for(let t = 0; t <= c; t++)u[t] = 0, d[t] = 0;
                        u[0] = l + i, d[0] = l + i, a.forEach((t)=>{
                            t.width > u[t.column] && (u[t.column] = t.width);
                        });
                        for(let t = 1; t < u.length; t++)d[t] = u[t] + d[t - 1];
                        const f = d[d.length - 1];
                        let m = 0;
                        a.forEach((t)=>{
                            let e = 0;
                            const i = m + t.numAcc;
                            for(; m < i; m++){
                                const i = d[t.column - 1] + e;
                                s[m].acc.setXShift(i), e += s[m].acc.getWidth() + 3, U("Line, accCount, shift: ", t.line, m, i);
                            }
                        }), e.left_shift += f;
                    }
                    static checkCollision(t, e) {
                        let i = e.line - t.line, s = 3;
                        i > 0 ? (s = e.flatLine || e.dblSharpLine ? 2.5 : 3, t.dblSharpLine && (i -= .5)) : (s = t.flatLine || t.dblSharpLine ? 2.5 : 3, e.dblSharpLine && (i -= .5));
                        const n = Math.abs(i) < s;
                        return U("Line_1, Line_2, Collision: ", t.line, e.line, n), n;
                    }
                    static applyAccidentals(t, e) {
                        const i = [], s = {};
                        t.forEach((t)=>{
                            const e = new n(0, 1);
                            t.getTickables().forEach((t)=>{
                                if (t.shouldIgnoreTicks()) return;
                                const n = s[e.value()];
                                n ? n.push(t) : (i.push(e.value()), s[e.value()] = [
                                    t
                                ]), e.add(t.getTicks());
                            });
                        });
                        const r = new W;
                        e || (e = "C");
                        const o = r.createScaleMap(e);
                        i.forEach((t)=>{
                            const e = s[t], i = [], n = (t)=>{
                                t.isRest() || t.shouldIgnoreTicks() || (t.keys.forEach((e, s)=>{
                                    const n = r.getNoteParts(e.split("/")[0]), a = n.accidental || "n", l = n.root + a, h = o[n.root] === l, c = i.indexOf(l) > -1;
                                    if (!h || h && c) {
                                        o[n.root] = l;
                                        const e = new H(a);
                                        t.addAccidental(s, e), i.push(l);
                                    }
                                }), t.getModifiers().forEach((t)=>{
                                    "gracenotegroups" === t.getCategory() && t.getGraceNotes().forEach(n);
                                }));
                            };
                            e.forEach(n);
                        });
                    }
                    constructor(t = null){
                        if (super(), this.setAttribute("type", "Accidental"), U("New accidental: ", t), this.note = null, this.index = null, this.type = t, this.position = D.Position.LEFT, this.render_options = {
                            font_scale: 38,
                            stroke_px: 3,
                            parenLeftPadding: 2,
                            parenRightPadding: 2
                        }, this.accidental = p.accidentalCodes(this.type), !this.accidental) throw new s.RERR("ArgumentError", `Unknown accidental type: ${t}`);
                        this.cautionary = !1, this.parenLeft = null, this.parenRight = null, this.reset();
                    }
                    reset() {
                        const t = this.render_options.font_scale;
                        this.glyph = new m(this.accidental.code, t), this.glyph.setOriginX(1), this.cautionary && (this.parenLeft = new m(p.accidentalCodes("{").code, t), this.parenRight = new m(p.accidentalCodes("}").code, t), this.parenLeft.setOriginX(1), this.parenRight.setOriginX(1));
                    }
                    getCategory() {
                        return H.CATEGORY;
                    }
                    getWidth() {
                        const t = this.cautionary ? z(this.parenLeft) + z(this.parenRight) + this.render_options.parenLeftPadding + this.render_options.parenRightPadding : 0;
                        return z(this.glyph) + t;
                    }
                    setNote(t) {
                        if (!t) throw new s.RERR("ArgumentError", `Bad note value: ${t}`);
                        this.note = t, "gracenotes" === this.note.getCategory() && (this.render_options.font_scale = 25, this.reset());
                    }
                    setAsCautionary() {
                        return this.cautionary = !0, this.render_options.font_scale = 28, this.reset(), this;
                    }
                    draw() {
                        const { context: t, type: e, position: i, note: n, index: r, cautionary: o, x_shift: a, y_shift: l, glyph: h, parenLeft: c, parenRight: u, render_options: { parenLeftPadding: d, parenRightPadding: f } } = this;
                        if (this.checkContext(), !n || null == r) throw new s.RERR("NoAttachedNote", "Can't draw accidental without a note and index.");
                        const m = n.getModifierStartXY(i, r);
                        let p = m.x + a;
                        const g = m.y + l;
                        U("Rendering: ", e, p, g), o ? (u.render(t, p, g), p -= z(u), p -= f, p -= this.accidental.parenRightPaddingAdjustment, h.render(t, p, g), p -= z(h), p -= d, c.render(t, p, g)) : h.render(t, p, g), this.setRendered();
                    }
                }
                class X extends D {
                    static get CATEGORY() {
                        return "notesubgroup";
                    }
                    static format(t, e) {
                        if (!t || 0 === t.length) return !1;
                        let i = 0;
                        for(let e = 0; e < t.length; ++e){
                            const s = t[e];
                            s.preFormat(), i += s.getWidth();
                        }
                        return e.left_shift += i, !0;
                    }
                    constructor(t){
                        return super(), this.setAttribute("type", "NoteSubGroup"), this.note = null, this.index = null, this.position = D.Position.LEFT, this.subNotes = t, this.subNotes.forEach((t)=>{
                            t.ignore_ticks = !1;
                        }), this.width = 0, this.preFormatted = !1, this.formatter = new yt, this.voice = new w({
                            num_beats: 4,
                            beat_value: 4,
                            resolution: p.RESOLUTION
                        }).setStrict(!1), this.voice.addTickables(this.subNotes), this;
                    }
                    getCategory() {
                        return X.CATEGORY;
                    }
                    preFormat() {
                        this.preFormatted || (this.formatter.joinVoices([
                            this.voice
                        ]).format([
                            this.voice
                        ], 0), this.setWidth(this.formatter.getMinTotalWidth()), this.preFormatted = !0);
                    }
                    setNote(t) {
                        this.note = t;
                    }
                    setWidth(t) {
                        this.width = t;
                    }
                    getWidth() {
                        return this.width;
                    }
                    draw() {
                        this.checkContext();
                        const t = this.getNote();
                        if (!t || null === this.index) throw new s.RuntimeError("NoAttachedNote", "Can't draw notes without a parent note and parent note index.");
                        this.setRendered(), this.alignSubNotesWithNote(this.subNotes, t), this.subNotes.forEach((t)=>t.setContext(this.context).drawWithStyle());
                    }
                }
                class Y extends l {
                    constructor(t, e){
                        super(), this.setAttribute("type", "StaveTie"), this.notes = t, this.context = null, this.text = e, this.direction = null, this.render_options = {
                            cp1: 8,
                            cp2: 12,
                            text_shift_x: 0,
                            first_x_shift: 0,
                            last_x_shift: 0,
                            y_shift: 7,
                            tie_spacing: 0,
                            font: {
                                family: "Arial",
                                size: 10,
                                style: ""
                            }
                        }, this.font = this.render_options.font, this.setNotes(t);
                    }
                    setFont(t) {
                        return this.font = t, this;
                    }
                    setDirection(t) {
                        return this.direction = t, this;
                    }
                    setStartNoteId(t) {
                        return this.start_note_id = t, this;
                    }
                    setNotes(t) {
                        if (!t.first_note && !t.last_note) throw new s.RuntimeError("BadArguments", "Tie needs to have either first_note or last_note set.");
                        if (t.first_indices || (t.first_indices = [
                            0
                        ]), t.last_indices || (t.last_indices = [
                            0
                        ]), t.first_indices.length !== t.last_indices.length) throw new s.RuntimeError("BadArguments", "Tied notes must have similar index sizes");
                        return this.first_note = t.first_note, this.first_indices = t.first_indices, this.last_note = t.last_note, this.last_indices = t.last_indices, this;
                    }
                    isPartial() {
                        return !this.first_note || !this.last_note;
                    }
                    renderTie(t) {
                        if (0 === t.first_ys.length || 0 === t.last_ys.length) throw new s.RERR("BadArguments", "No Y-values to render");
                        const e = this.context;
                        let i = this.render_options.cp1, n = this.render_options.cp2;
                        Math.abs(t.last_x_px - t.first_x_px) < 10 && (i = 2, n = 8);
                        const r = this.render_options.first_x_shift, o = this.render_options.last_x_shift, a = this.render_options.y_shift * t.direction;
                        for(let l = 0; l < this.first_indices.length; ++l){
                            const h = (t.last_x_px + o + (t.first_x_px + r)) / 2, c = t.first_ys[this.first_indices[l]] + a, u = t.last_ys[this.last_indices[l]] + a;
                            if (isNaN(c) || isNaN(u)) throw new s.RERR("BadArguments", "Bad indices for tie rendering.");
                            const d = (c + u) / 2 + i * t.direction, f = (c + u) / 2 + n * t.direction, m = this.start_note_id ?? this.first_note?.getAttribute("id"), p = m ? m + "-tie" : void 0;
                            this.setAttribute("el", e.openGroup("stavetie", p)), e.beginPath(), e.moveTo(t.first_x_px + r, c), e.quadraticCurveTo(h, d, t.last_x_px + o, u), e.quadraticCurveTo(h, f, t.first_x_px + r, c), e.closePath(), e.fill(), e.closeGroup();
                        }
                    }
                    renderText(t, e) {
                        if (!this.text) return;
                        this.context.save(), this.context.setFont(this.font.family, this.font.size, this.font.style);
                        let i = (t + e) / 2;
                        i -= this.context.measureText(this.text).width / 2, this.context.fillText(this.text, i + this.render_options.text_shift_x, (this.first_note || this.last_note).getStave().getYForTopText() - 1), this.context.restore();
                    }
                    draw() {
                        this.checkContext(), this.setRendered();
                        const t = this.first_note, e = this.last_note;
                        let i, s, n, r, o;
                        return t ? (i = t.getTieRightX() + this.render_options.tie_spacing, o = t.getStemDirection(), n = t.getYs()) : (i = e.getStave().getTieStartX(), n = e.getYs(), this.first_indices = this.last_indices), e ? (s = e.getTieLeftX() + this.render_options.tie_spacing, o = e.getStemDirection(), r = e.getYs()) : (s = t.getStave().getTieEndX(), r = t.getYs(), this.last_indices = this.first_indices), this.direction && (o = this.direction), this.renderTie({
                            first_x_px: i,
                            last_x_px: s,
                            first_ys: n,
                            last_ys: r,
                            direction: o
                        }), this.renderText(i, s), !0;
                    }
                }
                class j extends Y {
                    static createHammeron(t) {
                        return new j(t, "H");
                    }
                    static createPulloff(t) {
                        return new j(t, "P");
                    }
                    constructor(t, e){
                        super(t, e), this.setAttribute("type", "TabTie"), this.render_options.cp1 = 9, this.render_options.cp2 = 11, this.render_options.y_shift = 3, this.setNotes(t);
                    }
                    draw() {
                        this.checkContext(), this.setRendered();
                        const t = this.first_note, e = this.last_note;
                        let i, s, n, r;
                        return t ? (i = t.getTieRightX() + this.render_options.tie_spacing, n = t.getYs()) : (i = e.getStave().getTieStartX(), n = e.getYs(), this.first_indices = this.last_indices), e ? (s = e.getTieLeftX() + this.render_options.tie_spacing, r = e.getYs()) : (s = t.getStave().getTieEndX(), r = t.getYs(), this.last_indices = this.first_indices), this.renderTie({
                            first_x_px: i,
                            last_x_px: s,
                            first_ys: n,
                            last_ys: r,
                            direction: -1
                        }), this.renderText(i, s), !0;
                    }
                }
                class K extends D {
                    static get CATEGORY() {
                        return "gracenotegroups";
                    }
                    static format(t, e) {
                        if (!t || 0 === t.length) return !1;
                        const i = [];
                        let s = null, n = 0;
                        for(let e = 0; e < t.length; ++e){
                            const r = t[e], o = r.getNote(), a = o.getCategory() === V.CATEGORY;
                            let l = 0;
                            if (a && null !== r.spacing && void 0 !== r.spacing && (l = r.spacing), a && o !== s) {
                                for(let t = 0; t < o.keys.length; ++t)n = o.getKeyProps()[t].displaced ? o.getExtraLeftPx() : n;
                                s = o;
                            }
                            i.push({
                                shift: n,
                                gracenote_group: r,
                                spacing: l
                            });
                        }
                        let r, o = i[0].shift;
                        for(let t = 0; t < i.length; ++t){
                            const e = i[t].gracenote_group;
                            e.preFormat(), r = e.getWidth() + i[t].spacing, o = Math.max(r, o);
                        }
                        for(let t = 0; t < i.length; ++t){
                            const e = i[t].gracenote_group;
                            r = e.getWidth() + i[t].spacing, e.setSpacingFromNextModifier(o - Math.min(r, o));
                        }
                        return e.left_shift += o, !0;
                    }
                    constructor(t, e){
                        return super(), this.setAttribute("type", "GraceNoteGroup"), this.note = null, this.index = null, this.position = D.Position.LEFT, this.grace_notes = t, this.width = 0, this.preFormatted = !1, this.show_slur = e, this.slur = null, this.formatter = new yt, this.voice = new w({
                            num_beats: 4,
                            beat_value: 4,
                            resolution: p.RESOLUTION
                        }).setStrict(!1), this.render_options = {
                            slur_y_shift: 0
                        }, this.beams = [], this.voice.addTickables(this.grace_notes), this;
                    }
                    getCategory() {
                        return K.CATEGORY;
                    }
                    preFormat() {
                        this.preFormatted || (this.formatter.joinVoices([
                            this.voice
                        ]).format([
                            this.voice
                        ], 0), this.setWidth(this.formatter.getMinTotalWidth()), this.preFormatted = !0);
                    }
                    beamNotes(t) {
                        if ((t = t || this.grace_notes).length > 1) {
                            const e = new L(t);
                            e.render_options.beam_width = 3, e.render_options.partial_beam_length = 4, this.beams.push(e);
                        }
                        return this;
                    }
                    setNote(t) {
                        this.note = t;
                    }
                    setWidth(t) {
                        this.width = t;
                    }
                    getWidth() {
                        return this.width;
                    }
                    getGraceNotes() {
                        return this.grace_notes;
                    }
                    draw() {
                        this.checkContext();
                        const t = this.getNote();
                        if (function(...t) {
                            K.DEBUG && s.L("Vex.Flow.GraceNoteGroup", t);
                        }("Drawing grace note group for:", t), !t || null === this.index) throw new s.RuntimeError("NoAttachedNote", "Can't draw grace note without a parent note and parent note index.");
                        if (this.setRendered(), this.alignSubNotesWithNote(this.getGraceNotes(), t), this.grace_notes.forEach((t)=>{
                            t.setContext(this.context).draw();
                        }), this.beams.forEach((t)=>{
                            t.setContext(this.context).draw();
                        }), this.show_slur) {
                            const e = this.getNote().getCategory() === V.CATEGORY, i = e ? Y : j;
                            this.slur = new i({
                                last_note: this.grace_notes[0],
                                first_note: t,
                                first_indices: [
                                    0
                                ],
                                last_indices: [
                                    0
                                ]
                            }), this.slur.render_options.cp2 = 12, this.slur.render_options.y_shift = (e ? 7 : 5) + this.render_options.slur_y_shift, this.slur.setContext(this.context).draw();
                        }
                    }
                }
                class q extends D {
                    static get CATEGORY() {
                        return "strokes";
                    }
                    static get Type() {
                        return {
                            BRUSH_DOWN: 1,
                            BRUSH_UP: 2,
                            ROLL_DOWN: 3,
                            ROLL_UP: 4,
                            RASQUEDO_DOWN: 5,
                            RASQUEDO_UP: 6,
                            ARPEGGIO_DIRECTIONLESS: 7
                        };
                    }
                    static format(t, e) {
                        const i = e.left_shift;
                        if (!t || 0 === t.length) return this;
                        const s = t.map((t)=>{
                            const e = t.getNote();
                            if (e instanceof V) {
                                const { line: i, displaced: s } = e.getKeyProps()[t.getIndex()];
                                return {
                                    line: i,
                                    shift: s ? e.getExtraLeftPx() : 0,
                                    stroke: t
                                };
                            }
                            {
                                const { str: i } = e.getPositions()[t.getIndex()];
                                return {
                                    line: i,
                                    shift: 0,
                                    stroke: t
                                };
                            }
                        }), n = i, r = s.reduce((t, { stroke: e, shift: i })=>(e.setXShift(n + i), Math.max(e.getWidth() + 0, t)), 0);
                        return e.left_shift += r, !0;
                    }
                    constructor(t, e){
                        super(), this.setAttribute("type", "Stroke"), this.note = null, this.options = s.Merge({}, e), this.all_voices = !("all_voices" in this.options) || this.options.all_voices, this.note_end = null, this.index = null, this.type = t, this.position = D.Position.LEFT, this.render_options = {
                            font_scale: 38,
                            stroke_px: 3,
                            stroke_spacing: 10
                        }, this.font = {
                            family: "serif",
                            size: 10,
                            weight: "bold italic"
                        }, this.setXShift(0), this.setWidth(10);
                    }
                    getCategory() {
                        return q.CATEGORY;
                    }
                    getPosition() {
                        return this.position;
                    }
                    addEndNote(t) {
                        return this.note_end = t, this;
                    }
                    draw() {
                        if (this.checkContext(), this.setRendered(), !this.note || null == this.index) throw new s.RERR("NoAttachedNote", "Can't draw stroke without a note and index.");
                        const t = this.note.getModifierStartXY(this.position, this.index);
                        let e = this.note.getYs(), i = t.y, n = t.y;
                        const r = t.x - 5, o = this.note.stave.options.spacing_between_lines_px, a = this.getModifierContext().getModifiers(this.note.getCategory());
                        for(let t = 0; t < a.length; t++){
                            e = a[t].getYs();
                            for(let r = 0; r < e.length; r++)(this.note === a[t] || this.all_voices) && (i = s.Min(i, e[r]), n = s.Max(n, e[r]));
                        }
                        let l, h, c, u, d;
                        switch(this.type){
                            case q.Type.BRUSH_DOWN:
                                l = "vc3", h = -3, c = i - o / 2 + 10, n += o / 2;
                                break;
                            case q.Type.BRUSH_UP:
                                l = "v11", h = .5, c = n + o / 2, i -= o / 2;
                                break;
                            case q.Type.ROLL_DOWN:
                            case q.Type.RASQUEDO_DOWN:
                                l = "vc3", h = -3, u = this.x_shift + h - 2, this.note instanceof V ? (i += 1.5 * o, n += (n - i) % 2 != 0 ? .5 * o : o, c = i - o, d = n + o + 2) : (i += 1.5 * o, n += o, c = i - .75 * o, d = n + .25 * o);
                                break;
                            case q.Type.ROLL_UP:
                            case q.Type.RASQUEDO_UP:
                                l = "v52", h = -4, u = this.x_shift + h - 1, this.note instanceof V ? (c = o / 2, i += .5 * o, (n - i) % 2 == 0 && (n += o / 2), c = n + .5 * o, d = i - 1.25 * o) : (i += .25 * o, n += .5 * o, c = n + .25 * o, d = i - o);
                                break;
                            case q.Type.ARPEGGIO_DIRECTIONLESS:
                                i += .5 * o, n += o;
                                break;
                            default:
                                throw new s.RERR("InvalidType", `The stroke type ${this.type} does not exist`);
                        }
                        if (this.type === q.Type.BRUSH_DOWN || this.type === q.Type.BRUSH_UP) this.context.fillRect(r + this.x_shift, i, 1, n - i);
                        else if (this.note instanceof V) for(let t = i; t <= n; t += o)m.renderGlyph(this.context, r + this.x_shift - 4, t, this.render_options.font_scale, "va3");
                        else {
                            let t;
                            for(t = i; t <= n; t += 10)m.renderGlyph(this.context, r + this.x_shift - 4, t, this.render_options.font_scale, "va3");
                            this.type === q.Type.RASQUEDO_DOWN && (d = t + .25 * o);
                        }
                        this.type !== q.Type.ARPEGGIO_DIRECTIONLESS && (m.renderGlyph(this.context, r + this.x_shift + h, c, this.render_options.font_scale, l), this.type !== q.Type.RASQUEDO_DOWN && this.type !== q.Type.RASQUEDO_UP || (this.context.save(), this.context.setFont(this.font.family, this.font.size, this.font.weight), this.context.fillText("R", r + u, d), this.context.restore()));
                    }
                }
                class J extends D {
                    static get CATEGORY() {
                        return "stringnumber";
                    }
                    static format(t, e) {
                        const i = e.left_shift, s = e.right_shift;
                        if (!t || 0 === t.length) return this;
                        const n = [];
                        let r, o, a, l, h, c = null, u = 0, d = 0;
                        for(r = 0; r < t.length; ++r)for(o = t[r], a = o.getNote(), r = 0; r < t.length; ++r){
                            o = t[r], a = o.getNote(), l = o.getPosition();
                            const e = a.getKeyProps()[o.getIndex()];
                            if (a !== c) {
                                for(let t = 0; t < a.keys.length; ++t)h = a.getKeyProps()[t], 0 === i && (u = h.displaced ? a.getExtraLeftPx() : u), 0 === s && (d = h.displaced ? a.getExtraRightPx() : d);
                                c = a;
                            }
                            n.push({
                                pos: l,
                                note: a,
                                num: o,
                                line: e.line,
                                shiftL: u,
                                shiftR: d
                            });
                        }
                        n.sort((t, e)=>e.line - t.line);
                        let f = 0, m = 0, p = 0, g = 0, b = null, S = null;
                        for(r = 0; r < n.length; ++r){
                            let t = 0;
                            a = n[r].note, l = n[r].pos, o = n[r].num;
                            const e = n[r].line, h = n[r].shiftL, c = n[r].shiftR;
                            e === b && a === S || (f = i + h, m = s + c);
                            const d = o.getWidth() + 1;
                            l === D.Position.LEFT ? (o.setXShift(i), t = u + d, p = t > p ? t : p) : l === D.Position.RIGHT && (o.setXShift(m), t += d, g = t > g ? t : g), b = e, S = a;
                        }
                        return e.left_shift += p, e.right_shift += g, !0;
                    }
                    constructor(t){
                        super(), this.setAttribute("type", "StringNumber"), this.note = null, this.last_note = null, this.index = null, this.string_number = t, this.setWidth(20), this.position = D.Position.ABOVE, this.x_shift = 0, this.y_shift = 0, this.x_offset = 0, this.y_offset = 0, this.dashed = !0, this.leg = x.LineEndType.NONE, this.radius = 8, this.font = {
                            family: "sans-serif",
                            size: 10,
                            weight: "bold"
                        };
                    }
                    getCategory() {
                        return J.CATEGORY;
                    }
                    getNote() {
                        return this.note;
                    }
                    setNote(t) {
                        return this.note = t, this;
                    }
                    getIndex() {
                        return this.index;
                    }
                    setIndex(t) {
                        return this.index = t, this;
                    }
                    setLineEndType(t) {
                        return t >= x.LineEndType.NONE && t <= x.LineEndType.DOWN && (this.leg = t), this;
                    }
                    setStringNumber(t) {
                        return this.string_number = t, this;
                    }
                    setOffsetX(t) {
                        return this.x_offset = t, this;
                    }
                    setOffsetY(t) {
                        return this.y_offset = t, this;
                    }
                    setLastNote(t) {
                        return this.last_note = t, this;
                    }
                    setDashed(t) {
                        return this.dashed = t, this;
                    }
                    draw() {
                        const t = this.checkContext();
                        if (!this.note || null == this.index) throw new s.RERR("NoAttachedNote", "Can't draw string number without a note and index.");
                        this.setRendered();
                        const e = this.note.stave.options.spacing_between_lines_px, i = this.note.getModifierStartXY(this.position, this.index);
                        let n = i.x + this.x_shift + this.x_offset, r = i.y + this.y_shift + this.y_offset;
                        switch(this.position){
                            case D.Position.ABOVE:
                            case D.Position.BELOW:
                                {
                                    const t = this.note.getStemExtents();
                                    let s = t.topY, n = t.baseY + 2;
                                    this.note.stem_direction === V.STEM_DOWN && (s = t.baseY, n = t.topY - 2), r = this.position === D.Position.ABOVE ? this.note.hasStem() ? s - 1.75 * e : i.y - 1.75 * e : this.note.hasStem() ? n + 1.5 * e : i.y + 1.75 * e, r += this.y_shift + this.y_offset;
                                    break;
                                }
                            case D.Position.LEFT:
                                n -= this.radius / 2 + 5;
                                break;
                            case D.Position.RIGHT:
                                n += this.radius / 2 + 6;
                                break;
                            default:
                                throw new s.RERR("InvalidPosition", `The position ${this.position} is invalid`);
                        }
                        t.save(), t.beginPath(), t.arc(n, r, this.radius, 0, 2 * Math.PI, !1), t.lineWidth = 1.5, t.stroke(), t.setFont(this.font.family, this.font.size, this.font.weight);
                        const o = n - t.measureText(this.string_number).width / 2;
                        if (t.fillText("" + this.string_number, o, r + 4.5), null != this.last_note) {
                            const e = this.last_note.getStemX() - this.note.getX() + 5;
                            let i, s;
                            switch(t.strokeStyle = "#000000", t.lineCap = "round", t.lineWidth = .6, this.dashed ? x.drawDashedLine(t, n + 10, r, n + e, r, [
                                3,
                                3
                            ]) : x.drawDashedLine(t, n + 10, r, n + e, r, [
                                3,
                                0
                            ]), this.leg){
                                case x.LineEndType.UP:
                                    i = -10, s = this.dashed ? [
                                        3,
                                        3
                                    ] : [
                                        3,
                                        0
                                    ], x.drawDashedLine(t, n + e, r, n + e, r + i, s);
                                    break;
                                case x.LineEndType.DOWN:
                                    i = 10, s = this.dashed ? [
                                        3,
                                        3
                                    ] : [
                                        3,
                                        0
                                    ], x.drawDashedLine(t, n + e, r, n + e, r + i, s);
                            }
                        }
                        t.restore();
                    }
                }
                class $ extends R {
                    static getNextContext(t) {
                        const e = t.tContexts, i = e.indexOf(t);
                        return e[i + 1];
                    }
                    constructor(){
                        super(), this.setAttribute("type", "TickContext"), this.currentTick = new n(0, 1), this.maxTicks = new n(0, 1), this.minTicks = null, this.padding = 3, this.x = 0, this.xBase = 0, this.xOffset = 0, this.tickables = [], this.notePx = 0, this.extraLeftPx = 0, this.extraRightPx = 0, this.tContexts = [];
                    }
                    getX() {
                        return this.x;
                    }
                    setX(t) {
                        return this.x = t, this.xBase = t, this.xOffset = 0, this;
                    }
                    getXBase() {
                        return this.xBase;
                    }
                    setXBase(t) {
                        this.xBase = t, this.x = t + this.xOffset;
                    }
                    getXOffset() {
                        return this.xOffset;
                    }
                    setXOffset(t) {
                        this.xOffset = t, this.x = this.xBase + t;
                    }
                    getWidth() {
                        return this.width + 2 * this.padding;
                    }
                    setPadding(t) {
                        return this.padding = t, this;
                    }
                    getMaxTicks() {
                        return this.maxTicks;
                    }
                    getMinTicks() {
                        return this.minTicks;
                    }
                    getTickables() {
                        return this.tickables;
                    }
                    getCenterAlignedTickables() {
                        return this.tickables.filter((t)=>t.isCenterAligned());
                    }
                    getMetrics() {
                        const { width: t, notePx: e, extraLeftPx: i, extraRightPx: s } = this;
                        return {
                            width: t,
                            notePx: e,
                            extraLeftPx: i,
                            extraRightPx: s
                        };
                    }
                    getCurrentTick() {
                        return this.currentTick;
                    }
                    setCurrentTick(t) {
                        this.currentTick = t, this.preFormatted = !1;
                    }
                    getExtraPx() {
                        let t = 0, e = 0, i = 0, s = 0;
                        for(let n = 0; n < this.tickables.length; n++){
                            i = Math.max(this.tickables[n].extraLeftPx || 0, i), s = Math.max(this.tickables[n].extraRightPx || 0, s);
                            const r = this.tickables[n].modifierContext;
                            r && null != r && (t = Math.max(t, r.state.left_shift), e = Math.max(e, r.state.right_shift));
                        }
                        return {
                            left: t,
                            right: e,
                            extraLeft: i,
                            extraRight: s
                        };
                    }
                    addTickable(t) {
                        if (!t) throw new s.RERR("BadArgument", "Invalid tickable added.");
                        if (!t.shouldIgnoreTicks()) {
                            this.ignore_ticks = !1;
                            const e = t.getTicks();
                            e.greaterThan(this.maxTicks) && (this.maxTicks = e.clone()), (null == this.minTicks || e.lessThan(this.minTicks)) && (this.minTicks = e.clone());
                        }
                        return t.setTickContext(this), this.tickables.push(t), this.preFormatted = !1, this;
                    }
                    preFormat() {
                        if (this.preFormatted) return this;
                        for(let t = 0; t < this.tickables.length; ++t){
                            const e = this.tickables[t];
                            e.preFormat();
                            const i = e.getMetrics();
                            this.extraLeftPx = Math.max(this.extraLeftPx, i.extraLeftPx + i.modLeftPx);
                            const s = Math.max(0, e.x_shift);
                            this.extraRightPx = Math.max(this.extraRightPx, i.extraRightPx + i.modRightPx + s), this.notePx = Math.max(this.notePx, i.noteWidth), this.width = this.notePx + this.extraLeftPx + this.extraRightPx;
                        }
                        return this;
                    }
                    postFormat() {
                        return this.postFormatted || (this.postFormatted = !0), this;
                    }
                }
                const { ABOVE: Z, BELOW: Q } = D.Position, tt = (t, e)=>.5 * t(e / .5), et = (t, e)=>e === Z ? t <= 5 : t >= 1, it = (t, e)=>et(t, e) ? e === Z ? Math.ceil : Math.floor : Math.round, st = (t)=>{
                    const e = t.getCategory();
                    return "stavenotes" === e || "gracenotes" === e;
                }, nt = (t, e)=>{
                    const i = t.getStave(), n = t.getStemDirection(), { topY: r, baseY: o } = t.getStemExtents();
                    if (st(t)) return t.hasStem() ? n === v.UP ? r : o : Math.min(...t.getYs());
                    if ("tabnotes" === t.getCategory()) return t.hasStem() && n === v.UP ? r : i.getYForTopText(e);
                    throw new s.RERR("UnknownCategory", "Only can get the top and bottom ys of stavenotes and tabnotes");
                }, rt = (t, e)=>{
                    const i = t.getStave(), n = t.getStemDirection(), { topY: r, baseY: o } = t.getStemExtents();
                    if (st(t)) return t.hasStem() ? n === v.UP ? o : r : Math.max(...t.getYs());
                    if ("tabnotes" === t.getCategory()) return t.hasStem() ? n === v.UP ? i.getYForBottomText(e) : r : i.getYForBottomText(e);
                    throw new s.RERR("UnknownCategory", "Only can get the top and bottom ys of stavenotes and tabnotes");
                }, ot = (t, e)=>{
                    const i = e === Z && t.getStemDirection() === v.UP || e === Q && t.getStemDirection() === v.DOWN;
                    return st(t) ? t.hasStem() && i ? .5 : 1 : t.hasStem() && i ? 1 : 0;
                };
                class at extends D {
                    static get CATEGORY() {
                        return "articulations";
                    }
                    static get INITIAL_OFFSET() {
                        return -0.5;
                    }
                    static format(t, e) {
                        if (!t || 0 === t.length) return !1;
                        const i = (t, e, i)=>tt(it(e, i), t.glyph.getMetrics().height / 10 + .5);
                        t.filter((t)=>t.getPosition() === Z).forEach((t)=>{
                            t.setTextLine(e.top_text_line), e.top_text_line += i(t, e.top_text_line, Z);
                        }), t.filter((t)=>t.getPosition() === Q).forEach((t)=>{
                            t.setTextLine(e.text_line), e.text_line += i(t, e.text_line, Q);
                        });
                        const s = t.map((t)=>t.getWidth()).reduce((t, e)=>Math.max(e, t));
                        return e.left_shift += s / 2, e.right_shift += s / 2, !0;
                    }
                    static easyScoreHook({ articulations: t }, e, i) {
                        if (!t) return;
                        const s = {
                            staccato: "a.",
                            tenuto: "a-"
                        };
                        t.split(",").map((t)=>t.trim().split(".")).map(([t, e])=>{
                            const n = {
                                type: s[t]
                            };
                            return e && (n.position = D.PositionString[e]), i.getFactory().Articulation(n);
                        }).map((t)=>e.addModifier(0, t));
                    }
                    constructor(t){
                        if (super(), this.setAttribute("type", "Articulation"), this.note = null, this.index = null, this.type = t, this.position = Q, this.render_options = {
                            font_scale: 38
                        }, this.breathMarkDistance = .8, this.articulation = p.articulationCodes(this.type), "abr" === this.type && (this.articulation = {
                            code: "v6c",
                            between_lines: !1
                        }), !this.articulation) throw new s.RERR("ArgumentError", `Articulation not found: ${this.type}`);
                        this.glyph = new m(this.articulation.code, this.render_options.font_scale), this.setWidth(this.glyph.getMetrics().width);
                    }
                    getCategory() {
                        return at.CATEGORY;
                    }
                    getOtherArticulationsOnSameSide() {
                        return st(this.note) ? (this.getModifierContext()?.getModifiers(at.CATEGORY) ?? []).filter((t)=>t.getPosition() === this.position && t.note !== this.note && st(t.note)) : [];
                    }
                    getTextLineBaseY() {
                        const { note: t, position: e, text_line: i } = this, s = t.getStave(), n = s.getSpacingBetweenLines(), r = !this.articulation.between_lines || "tabnotes" === t.getCategory(), o = ot(t, e);
                        if (e === Z) {
                            const e = nt(t, i) - o * n;
                            return r ? Math.min(s.getYForTopText(at.INITIAL_OFFSET) + i * n, e) : e;
                        }
                        const a = rt(t, i) + o * n;
                        return r ? Math.max(s.getYForBottomText(at.INITIAL_OFFSET) - i * n, a) : a;
                    }
                    draw() {
                        const { note: t, index: e, position: i, glyph: n, context: r } = this;
                        if (this.checkContext(), !t || null == e) throw new s.RERR("NoAttachedNote", "Can't draw Articulation without a note and index.");
                        this.setRendered();
                        const o = t.getStave();
                        let { x: a } = t.getModifierStartXY(i, e);
                        if ("abr" === this.type) {
                            st(t) && (a -= t.getXShift());
                            let e = 0;
                            const i = t.getTickContext(), s = $.getNextContext(i), n = i.getX();
                            if (s && s.x > i.x) e = (s.getX() - n) * this.breathMarkDistance;
                            else {
                                const i = t.getStave();
                                e = (i.getX() + i.getWidth() - n + i.start_x) * this.breathMarkDistance;
                            }
                            if (a += e, a > o.end_x) {
                                const t = o.start_x + n;
                                a = t + (o.end_x - t) * this.breathMarkDistance;
                            }
                        }
                        const l = this.getXShift();
                        l && (a += l);
                        const h = this.getRenderY();
                        !function(...t) {
                            at.DEBUG && s.L("Vex.Flow.Articulation", t);
                        }(`Rendering articulation at (x: ${a}, y: ${h})`), n.render(r, a, h);
                    }
                    getExtent() {
                        const { note: t, glyph: e } = this;
                        t.setStave(t.getStave());
                        const i = this.getRenderY() + e.originShift.y + e.bbox.getY(), s = this.getXShift() + e.originShift.x + e.bbox.getX();
                        return {
                            left: s,
                            right: s + e.bbox.getW(),
                            top: i,
                            bottom: i + e.bbox.getH()
                        };
                    }
                    getRenderY() {
                        const { note: t, index: e, position: i, glyph: s, articulation: { between_lines: n }, text_line: r } = this, o = t.getStave(), a = o.getSpacingBetweenLines(), l = "tabnotes" === t.getCategory(), h = !n || l, c = ot(t, i);
                        let u = ({
                            [Z]: ()=>{
                                s.setOrigin(.5, 1);
                                const e = nt(t, r) - (r + c) * a;
                                return h ? Math.min(o.getYForTopText(at.INITIAL_OFFSET), e) : e;
                            },
                            [Q]: ()=>{
                                s.setOrigin(.5, 0);
                                const e = rt(t, r) + (r + c) * a;
                                return h ? Math.max(o.getYForBottomText(at.INITIAL_OFFSET), e) : e;
                            }
                        })[i]();
                        for (const t of this.getOtherArticulationsOnSameSide())t.note.setStave(t.note.getStave()), u = i === Z ? Math.min(u, t.getTextLineBaseY() - r * a) : Math.max(u, t.getTextLineBaseY() + r * a);
                        if (this.y_shift && (u += this.y_shift), !l) {
                            const r = i === Z ? -1 : 1, o = l ? t.positions[e].str : t.getKeyProps()[e].line, h = (t.getYs()[e] - u) / a + o, c = ((t, e, i, s)=>{
                                const n = tt(it(e, i), e);
                                return t && et(n, i) && n % 1 == 0 ? n + .5 * -s : n;
                            })(n, h, i, r);
                            et(c, i) && s.setOrigin(.5, .5), u += Math.abs(c - h) * a * r;
                        }
                        return u;
                    }
                }
                function lt(t, e, i) {
                    Array.isArray(t) || (t = [
                        t
                    ]);
                    const s = t.map((t)=>new m(p.accidentalCodes(t).code, e));
                    if (1 === s.length) return s[0].setOrigin(.5, 1), s[0];
                    let n = 1 / 0, r = -1 / 0, o = i * (s.length - 1);
                    for (const t of s)n = Math.min(n, t.bbox.getY()), r = Math.max(r, t.bbox.getY() + t.bbox.getH()), o += t.bbox.getW();
                    return {
                        glyphs: s,
                        getMetrics: ()=>({
                                width: o,
                                height: r - n
                            }),
                        render: (t, e, n)=>{
                            let a = e - o / 2;
                            for (const e of s)e.render(t, a - e.bbox.getX(), n - r), a += e.bbox.getW() + i;
                        }
                    };
                }
                function ht(t) {
                    const e = t.getStave().getSpacingBetweenLines(), i = t.getStem().getExtents();
                    return t.getStemDirection() === V.STEM_DOWN ? i.baseY - e : i.topY - e * (t.beam ? 1.5 : 1);
                }
                function ct(t) {
                    const e = t.getStave().getSpacingBetweenLines(), i = t.getStem().getExtents();
                    return Math.max(...t.getYs(), t.hasStem() ? Math.max(i.topY, i.baseY) : -1 / 0) + e * (t.getStemDirection() === V.STEM_DOWN && t.beam ? 1.5 : 1);
                }
                class ut extends D {
                    static get CATEGORY() {
                        return "ornaments";
                    }
                    static format(t, e) {
                        if (!t || 0 === t.length) return !1;
                        let i = 0;
                        for(let s = 0; s < t.length; ++s){
                            const n = t[s], r = 2 + Math.ceil(n.getAccidentalsHeight() / 10);
                            i = Math.max(n.getWidth(), i), n.getPosition() === D.Position.ABOVE ? (n.setTextLine(e.top_text_line), e.top_text_line += r) : (n.setTextLine(e.text_line), e.text_line += r);
                        }
                        return e.left_shift += i / 2, e.right_shift += i / 2, !0;
                    }
                    constructor(t){
                        if (super(), this.setAttribute("type", "Ornament"), this.note = null, this.index = null, this.type = t, this.position = D.Position.ABOVE, this.delayed = !1, this.accidentalUpper = null, this.accidentalLower = null, this.render_options = {
                            font_scale: 38,
                            accidentalLowerPadding: 3,
                            accidentalUpperPadding: 3,
                            accidentalSpacing: 3
                        }, this.ornament = p.ornamentCodes(this.type), !this.ornament) throw new s.RERR("ArgumentError", `Ornament not found: '${this.type}'`);
                        this.glyph = new m(this.ornament.code, this.render_options.font_scale), this.glyph.setOrigin(.5, 1);
                    }
                    getCategory() {
                        return ut.CATEGORY;
                    }
                    getAccidentalsHeight() {
                        let t = 0;
                        return this.accidentalLower && (t += this.accidentalLower.getMetrics().height + this.render_options.accidentalLowerPadding), this.accidentalUpper && (t += this.accidentalUpper.getMetrics().height + this.render_options.accidentalUpperPadding), t;
                    }
                    setDelayed(t) {
                        return this.delayed = t, this;
                    }
                    setUpperAccidental(t) {
                        return this.accidentalUpper = lt(t, this.render_options.font_scale / 1.3, this.render_options.accidentalSpacing / 1.3), this;
                    }
                    setLowerAccidental(t) {
                        return this.accidentalLower = lt(t, this.render_options.font_scale / 1.3, this.render_options.accidentalSpacing / 1.3), this;
                    }
                    getOtherNotesOnSameSide() {
                        const t = (t)=>"tabnotes" === t.getCategory();
                        if (t(this.note)) return [];
                        const e = this.getModifierContext();
                        return [
                            ...e?.getModifiers("articulations") ?? [],
                            ...e?.getModifiers(ut.CATEGORY) ?? []
                        ].filter((e)=>e.getPosition() === this.position && e.note !== this.note && !t(e.note)).map((t)=>t.note);
                    }
                    getExtent() {
                        this.note.setStave(this.note.getStave());
                        const { y: t } = this.getRenderXY(), e = this.delayed ? this.delayXShift : 0, i = Math.max(...[
                            this.glyph,
                            this.accidentalLower,
                            this.accidentalUpper
                        ].filter((t)=>t).map((t)=>t.getMetrics().width));
                        return {
                            left: e - i / 2,
                            right: e + i / 2,
                            top: t - (this.glyph.getMetrics().height + this.getAccidentalsHeight()),
                            bottom: t
                        };
                    }
                    draw() {
                        if (this.checkContext(), !this.note || null == this.index) throw new s.RERR("NoAttachedNote", "Can't draw Ornament without a note and index.");
                        this.setRendered();
                        const t = this.context;
                        let { x: e, y: i } = this.getRenderXY();
                        !function(...t) {
                            ut.DEBUG && s.L("Vex.Flow.Ornament", t);
                        }("Rendering ornament: ", this.ornament, e, i), this.accidentalLower && (this.accidentalLower.render(t, e, i), i -= this.accidentalLower.getMetrics().height, i -= this.render_options.accidentalLowerPadding), this.glyph.render(t, e, i), i -= this.glyph.getMetrics().height, this.accidentalUpper && (i -= this.render_options.accidentalUpperPadding, this.accidentalUpper.render(t, e, i));
                    }
                    getRenderXY() {
                        const t = this.note.getStemDirection(), e = this.note.getStave(), i = this.note.getStem().getExtents();
                        let s = t === V.STEM_DOWN ? i.baseY : i.topY;
                        "tabnotes" === this.note.getCategory() && (this.note.hasStem() ? t === V.STEM_DOWN && (s = e.getYForTopText(this.text_line)) : s = e.getYForTopText(this.text_line));
                        const n = t === V.STEM_DOWN, r = e.getSpacingBetweenLines();
                        let o = 1;
                        !n && this.note.beam && (o += .5);
                        const a = this.getOtherNotesOnSameSide();
                        for (const t of a)t.setStave(t.getStave());
                        let l = s - r * o;
                        for (const t of a)l = Math.min(l, ht(t));
                        const h = l - r * this.text_line;
                        let c = this.note.getModifierStartXY(this.position, this.index).x, u = Math.min(e.getYForTopText(this.text_line), h);
                        if (this.position === D.Position.BELOW) {
                            let t = ct(this.note);
                            for (const e of a)t = Math.max(t, ct(e));
                            const i = this.glyph.getMetrics().height + this.getAccidentalsHeight();
                            u = Math.max(e.getYForBottomText(this.text_line), t + r * this.text_line) + i;
                        }
                        if (u += this.y_shift, this.delayed) {
                            let t = 0;
                            if (void 0 !== this.delayXShift) t = this.delayXShift;
                            else {
                                t += this.glyph.getMetrics().width / 2;
                                const i = $.getNextContext(this.note.getTickContext());
                                t += i ? .5 * (i.getX() - c) : .5 * (e.x + e.width - c), this.delayXShift = t;
                            }
                            c += t;
                        }
                        return {
                            x: c,
                            y: u
                        };
                    }
                }
                class dt extends D {
                    static get CATEGORY() {
                        return "annotations";
                    }
                    static get Justify() {
                        return {
                            LEFT: 1,
                            CENTER: 2,
                            RIGHT: 3,
                            CENTER_STEM: 4
                        };
                    }
                    static get JustifyString() {
                        return {
                            left: dt.Justify.LEFT,
                            right: dt.Justify.RIGHT,
                            center: dt.Justify.CENTER,
                            centerStem: dt.Justify.CENTER_STEM
                        };
                    }
                    static get VerticalJustify() {
                        return {
                            TOP: 1,
                            CENTER: 2,
                            BOTTOM: 3,
                            CENTER_STEM: 4
                        };
                    }
                    static get VerticalJustifyString() {
                        return {
                            above: dt.VerticalJustify.TOP,
                            top: dt.VerticalJustify.TOP,
                            below: dt.VerticalJustify.BOTTOM,
                            bottom: dt.VerticalJustify.BOTTOM,
                            center: dt.VerticalJustify.CENTER,
                            centerStem: dt.VerticalJustify.CENTER_STEM
                        };
                    }
                    static format(t, e) {
                        if (!t || 0 === t.length) return !1;
                        let i = 0;
                        for(let s = 0; s < t.length; ++s){
                            const n = t[s];
                            i = Math.max(n.getWidth(), i), n.getPosition() === D.Position.ABOVE ? (n.setTextLine(e.top_text_line), e.top_text_line++) : (n.setTextLine(e.text_line), e.text_line++);
                        }
                        return e.left_shift += i / 2, e.right_shift += i / 2, !0;
                    }
                    constructor(t){
                        super(), this.setAttribute("type", "Annotation"), this.note = null, this.index = null, this.text = t, this.justification = dt.Justify.CENTER, this.vert_justification = dt.VerticalJustify.TOP, this.font = {
                            family: "Arial",
                            size: 10,
                            weight: ""
                        }, this.setWidth(p.textWidth(t));
                    }
                    getCategory() {
                        return dt.CATEGORY;
                    }
                    setFont(t, e, i) {
                        return this.font = {
                            family: t,
                            size: e,
                            weight: i
                        }, this;
                    }
                    setVerticalJustification(t) {
                        return this.vert_justification = "string" == typeof t ? dt.VerticalJustifyString[t] : t, this;
                    }
                    getJustification() {
                        return this.justification;
                    }
                    setJustification(t) {
                        return this.justification = "string" == typeof t ? dt.JustifyString[t] : t, this;
                    }
                    draw() {
                        if (this.checkContext(), !this.note) throw new s.RERR("NoNoteForAnnotation", "Can't draw text annotation without an attached note.");
                        this.setRendered();
                        const t = this.note.getModifierStartXY(D.Position.ABOVE, this.index);
                        this.context.save(), this.context.setFont(this.font.family, this.font.size, this.font.weight);
                        const e = this.context.measureText(this.text).width, i = this.context.measureText("m").width;
                        let n, r, o, a;
                        n = this.justification === dt.Justify.LEFT ? t.x : this.justification === dt.Justify.RIGHT ? t.x - e : this.justification === dt.Justify.CENTER ? t.x - e / 2 : this.note.getStemX() - e / 2;
                        const l = this.note.hasStem(), h = this.note.getStave();
                        if (l && (o = this.note.getStem().getExtents(), a = h.getSpacingBetweenLines()), this.vert_justification === dt.VerticalJustify.BOTTOM) {
                            if (r = h.getYForBottomText(this.text_line + p.TEXT_HEIGHT_OFFSET_HACK), l) {
                                const t = 1 === this.note.getStemDirection() ? o.baseY : o.topY;
                                r = Math.max(r, t + a * (this.text_line + 2));
                            }
                        } else if (this.vert_justification === dt.VerticalJustify.CENTER) {
                            const t = this.note.getYForTopText(this.text_line) - 1;
                            r = t + (h.getYForBottomText(this.text_line) - t) / 2 + i / 2;
                        } else if (this.vert_justification === dt.VerticalJustify.TOP) r = Math.min(h.getYForTopText(this.text_line), this.note.getYs()[0] - 10), l && (r = Math.min(r, o.topY - 5 - a * this.text_line));
                        else {
                            const t = this.note.getStemExtents();
                            r = t.topY + (t.baseY - t.topY) / 2 + i / 2;
                        }
                        !function(...t) {
                            dt.DEBUG && s.L("Vex.Flow.Annotation", t);
                        }("Rendering annotation: ", this.text, n, r), this.context.fillText(this.text, n, r), this.context.restore();
                    }
                }
                class ft extends D {
                    static get CATEGORY() {
                        return "bends";
                    }
                    static get UP() {
                        return 0;
                    }
                    static get DOWN() {
                        return 1;
                    }
                    static format(t, e) {
                        if (!t || 0 === t.length) return !1;
                        let i = 0;
                        const s = e.top_text_line;
                        for(let e = 0; e < t.length; ++e){
                            const n = t[e];
                            n.setXShift(i), i = n.getWidth(), n.setTextLine(s);
                        }
                        return e.right_shift += i, e.top_text_line += 1, !0;
                    }
                    constructor(t, e, i){
                        super(), this.setAttribute("type", "Bend"), this.text = t, this.x_shift = 0, this.release = e || !1, this.font = "10pt Arial", this.render_options = {
                            line_width: 1.5,
                            line_style: "#777777",
                            bend_width: 8,
                            release_width: 8
                        }, i ? this.phrase = i : (this.phrase = [
                            {
                                type: ft.UP,
                                text: this.text
                            }
                        ], this.release && this.phrase.push({
                            type: ft.DOWN,
                            text: ""
                        })), this.updateWidth();
                    }
                    getCategory() {
                        return ft.CATEGORY;
                    }
                    setXShift(t) {
                        this.x_shift = t, this.updateWidth();
                    }
                    setFont(t) {
                        return this.font = t, this;
                    }
                    getText() {
                        return this.text;
                    }
                    updateWidth() {
                        const t = this;
                        function e(e) {
                            let i;
                            return i = t.context ? t.context.measureText(e).width : p.textWidth(e), i;
                        }
                        let i = 0;
                        for(let t = 0; t < this.phrase.length; ++t){
                            const n = this.phrase[t];
                            if ("width" in n) i += n.width;
                            else {
                                const t = n.type === ft.UP ? this.render_options.bend_width : this.render_options.release_width;
                                n.width = s.Max(t, e(n.text)) + 3, n.draw_width = n.width / 2, i += n.width;
                            }
                        }
                        return this.setWidth(i + this.x_shift), this;
                    }
                    draw() {
                        if (this.checkContext(), !this.note || null == this.index) throw new s.RERR("NoNoteForBend", "Can't draw bend without a note or index.");
                        this.setRendered();
                        const t = this.note.getModifierStartXY(D.Position.RIGHT, this.index);
                        t.x += 3, t.y += .5;
                        const e = this.x_shift, i = this.context, n = this.note.getStave().getYForTopText(this.text_line) + 3, r = this.note.getStave().getYForTopText(this.text_line) - 1, o = this;
                        function a(t, e, s, n) {
                            const r = t + s, a = e;
                            i.save(), i.beginPath(), i.setLineWidth(o.render_options.line_width), i.setStrokeStyle(o.render_options.line_style), i.setFillStyle(o.render_options.line_style), i.moveTo(t, e), i.quadraticCurveTo(r, a, t + s, n), i.stroke(), i.restore();
                        }
                        function l(t, e, s, n) {
                            i.save(), i.beginPath(), i.setLineWidth(o.render_options.line_width), i.setStrokeStyle(o.render_options.line_style), i.setFillStyle(o.render_options.line_style), i.moveTo(t, n), i.quadraticCurveTo(t + s, n, t + s, e), i.stroke(), i.restore();
                        }
                        function h(t, e, s) {
                            const n = s || 1;
                            i.beginPath(), i.moveTo(t, e), i.lineTo(t - 4, e + 4 * n), i.lineTo(t + 4, e + 4 * n), i.closePath(), i.fill();
                        }
                        function c(t, e) {
                            i.save(), i.setRawFont(o.font);
                            const s = t - i.measureText(e).width / 2;
                            i.fillText(e, s, r), i.restore();
                        }
                        let u = null, d = 0;
                        for(let i = 0; i < this.phrase.length; ++i){
                            const s = this.phrase[i];
                            0 === i && (s.draw_width_unmodified = s.draw_width, s.draw_width += e), d = s.draw_width + (u ? u.draw_width : 0) - (1 === i ? e : 0), s.type === ft.UP && (u && u.type === ft.UP && h(t.x, n), a(t.x, t.y, d, n)), s.type === ft.DOWN && (u && u.type === ft.UP && l(t.x, t.y, d, n), u && u.type === ft.DOWN && (h(t.x, t.y, -1), l(t.x, t.y, d, n)), null === u && (d = s.draw_width, l(t.x, t.y, d, n))), c(t.x + d, s.text), u = s, u.x = t.x, t.x += d;
                        }
                        u.type === ft.UP ? h(u.x + d, n) : u.type === ft.DOWN && h(u.x + d, t.y, -1);
                        for(let t = 0; t < this.phrase.length; ++t){
                            const e = this.phrase[t];
                            e.draw_width_unmodified && (e.draw_width = e.draw_width_unmodified);
                        }
                    }
                }
                class mt extends D {
                    static get CATEGORY() {
                        return "vibratos";
                    }
                    static format(t, e, i) {
                        if (!t || 0 === t.length) return !1;
                        let s = e.top_text_line, n = 0, r = e.right_shift - 7;
                        const o = i.getModifiers(ft.CATEGORY);
                        o && o.length > 0 && s--;
                        for(let e = 0; e < t.length; ++e){
                            const i = t[e];
                            i.setXShift(r), i.setTextLine(s), n += i.getWidth(), r += n;
                        }
                        return e.right_shift += n, e.top_text_line += 1, !0;
                    }
                    constructor(){
                        super(), this.setAttribute("type", "Vibrato"), this.position = D.Position.RIGHT, this.render_options = {
                            harsh: !1,
                            vibrato_width: 20,
                            wave_height: 6,
                            wave_width: 4,
                            wave_girth: 2
                        }, this.setVibratoWidth(this.render_options.vibrato_width);
                    }
                    getCategory() {
                        return mt.CATEGORY;
                    }
                    setHarsh(t) {
                        return this.render_options.harsh = t, this;
                    }
                    setVibratoWidth(t) {
                        return this.render_options.vibrato_width = t, this.setWidth(t), this;
                    }
                    draw() {
                        const t = this.checkContext();
                        if (!this.note) throw new s.RERR("NoNoteForVibrato", "Can't draw vibrato without an attached note.");
                        this.setRendered();
                        const e = this.note.getModifierStartXY(D.Position.RIGHT, this.index).x + this.x_shift, i = this.note.getYForTopText(this.text_line) + 2;
                        mt.renderVibrato(t, e, i, this.render_options);
                    }
                    static renderVibrato(t, e, i, s) {
                        const { harsh: n, vibrato_width: r, wave_width: o, wave_girth: a, wave_height: l } = s, h = r / o;
                        let c;
                        if (t.beginPath(), n) {
                            for(t.moveTo(e, i + a + 1), c = 0; c < h / 2; ++c)t.lineTo(e + o, i - l / 2), e += o, t.lineTo(e + o, i + l / 2), e += o;
                            for(c = 0; c < h / 2; ++c)t.lineTo(e - o, i - l / 2 + a + 1), e -= o, t.lineTo(e - o, i + l / 2 + a + 1), e -= o;
                            t.fill();
                        } else {
                            for(t.moveTo(e, i + a), c = 0; c < h / 2; ++c)t.quadraticCurveTo(e + o / 2, i - l / 2, e + o, i), e += o, t.quadraticCurveTo(e + o / 2, i + l / 2, e + o, i), e += o;
                            for(c = 0; c < h / 2; ++c)t.quadraticCurveTo(e - o / 2, i + l / 2 + a, e - o, i + a), e -= o, t.quadraticCurveTo(e - o / 2, i - l / 2 + a, e - o, i + a), e -= o;
                            t.fill();
                        }
                    }
                }
                function pt(...t) {
                    gt.DEBUG && s.L("Vex.Flow.ModifierContext", t);
                }
                class gt {
                    constructor(){
                        this.modifiers = {}, this.preFormatted = !1, this.postFormatted = !1, this.width = 0, this.spacing = 0, this.state = {
                            left_shift: 0,
                            right_shift: 0,
                            text_line: 0,
                            top_text_line: 0
                        }, this.PREFORMAT = [
                            V,
                            O,
                            G,
                            H,
                            q,
                            K,
                            X,
                            J,
                            at,
                            ut,
                            dt,
                            ft,
                            mt
                        ], this.POSTFORMAT = [
                            V
                        ];
                    }
                    addModifier(t) {
                        const e = t.getCategory();
                        return this.modifiers[e] || (this.modifiers[e] = []), this.modifiers[e].push(t), t.setModifierContext(this), this.preFormatted = !1, this;
                    }
                    getModifiers(t) {
                        return this.modifiers[t];
                    }
                    getWidth() {
                        return this.width;
                    }
                    getExtraLeftPx() {
                        return this.state.left_shift;
                    }
                    getExtraRightPx() {
                        return this.state.right_shift;
                    }
                    getState() {
                        return this.state;
                    }
                    getMetrics() {
                        if (!this.formatted) throw new s.RERR("UnformattedModifier", "Unformatted modifier has no metrics.");
                        return {
                            width: this.state.left_shift + this.state.right_shift + this.spacing,
                            spacing: this.spacing,
                            extra_left_px: this.state.left_shift,
                            extra_right_px: this.state.right_shift
                        };
                    }
                    preFormat() {
                        this.preFormatted || (this.PREFORMAT.forEach((t)=>{
                            pt("Preformatting ModifierContext: ", t.CATEGORY), t.format(this.getModifiers(t.CATEGORY), this.state, this);
                        }), this.width = this.state.left_shift + this.state.right_shift, this.preFormatted = !0);
                    }
                    postFormat() {
                        this.postFormatted || this.POSTFORMAT.forEach((t)=>{
                            pt("Postformatting ModifierContext: ", t.CATEGORY), t.postFormat(this.getModifiers(t.CATEGORY), this);
                        });
                    }
                }
                function bt(t, e, i, n) {
                    let r = e;
                    for(i += 1; i < t.length; i += 1){
                        const e = t[i];
                        if (!e.isRest() && !e.shouldIgnoreTicks()) {
                            r = e.getLineForRest();
                            break;
                        }
                    }
                    if (n && e !== r) {
                        const t = Math.max(e, r), i = Math.min(e, r);
                        r = s.MidLine(t, i);
                    }
                    return r;
                }
                function St(t, e, i) {
                    if (!t || !t.length) throw new s.RERR("BadArgument", "No voices to format");
                    t[0].getTotalTicks();
                    const r = t.reduce((t, e)=>{
                        if (e.getMode() === w.Mode.STRICT && !e.isComplete()) throw new s.RERR("IncompleteVoice", "Voice does not have enough notes.");
                        return Math.max(t, n.LCM(t, e.getResolutionMultiplier()));
                    }, 1), o = {}, a = [], l = [];
                    return t.forEach((t)=>{
                        const s = new n(0, r);
                        t.getTickables().forEach((t)=>{
                            const n = s.numerator;
                            if (!o[n]) {
                                const t = new e;
                                l.push(t), o[n] = t;
                            }
                            i(t, o[n]), a.push(n), s.add(t.getTicks());
                        });
                    }), {
                        map: o,
                        array: l,
                        list: s.SortAndUnique(a, (t, e)=>t - e, (t, e)=>t === e),
                        resolutionMultiplier: r
                    };
                }
                class yt {
                    static SimpleFormat(t, e = 0, { paddingBetween: i = 10 } = {}) {
                        t.reduce((t, e)=>{
                            e.addToModifierContext(new gt);
                            const s = (new $).addTickable(e).preFormat(), n = s.getExtraPx();
                            return s.setX(t + n.left), t + s.getWidth() + n.right + i;
                        }, e);
                    }
                    static plotDebugging(t, e, i, s, n) {
                        const r = i + N.STAVEPADDING, o = e.contextGaps;
                        t.save(), t.setFont("Arial", 8, ""), o.gaps.forEach((e)=>{
                            var i, o, a;
                            i = r + e.x1, o = r + e.x2, a = "#aaa", t.beginPath(), t.setStrokeStyle(a), t.setFillStyle(a), t.setLineWidth(1), t.fillRect(i, s, o - i, n - s), t.fillText(Math.round(e.x2 - e.x1), r + e.x1, n + 12);
                        }), t.fillText(Math.round(o.total) + "px", r - 20, n + 12), t.setFillStyle("red"), t.fillText("Loss: " + e.lossHistory.map((t)=>Math.round(t)), r - 20, n + 22), t.restore();
                    }
                    static FormatAndDraw(t, e, i, n) {
                        const r = {
                            auto_beam: !1,
                            align_rests: !1
                        };
                        "object" == typeof n ? s.Merge(r, n) : "boolean" == typeof n && (r.auto_beam = n);
                        const o = new w(p.TIME4_4).setMode(w.Mode.SOFT).addTickables(i), a = r.auto_beam ? L.applyAndGetBeams(o) : [];
                        return (new yt).joinVoices([
                            o
                        ], {
                            align_rests: r.align_rests
                        }).formatToStave([
                            o
                        ], e, {
                            align_rests: r.align_rests,
                            stave: e
                        }), o.setStave(e).draw(t, e), a.forEach((e)=>e.setContext(t).draw()), o.getBoundingBox();
                    }
                    static FormatAndDrawTab(t, e, i, n, r, o, a) {
                        const l = {
                            auto_beam: o,
                            align_rests: !1
                        };
                        "object" == typeof a ? s.Merge(l, a) : "boolean" == typeof a && (l.auto_beam = a);
                        const h = new w(p.TIME4_4).setMode(w.Mode.SOFT).addTickables(r), c = new w(p.TIME4_4).setMode(w.Mode.SOFT).addTickables(n), u = l.auto_beam ? L.applyAndGetBeams(h) : [];
                        (new yt).joinVoices([
                            h
                        ], {
                            align_rests: l.align_rests
                        }).joinVoices([
                            c
                        ]).formatToStave([
                            h,
                            c
                        ], i, {
                            align_rests: l.align_rests
                        }), h.draw(t, i), c.draw(t, e), u.forEach((e)=>e.setContext(t).draw()), new I(i, e).setContext(t).draw();
                    }
                    static AlignRestsToNotes(t, e, i) {
                        return t.forEach((s, n)=>{
                            if (s instanceof V && s.isRest()) {
                                if (s.tuplet && !i) return;
                                const r = s.getGlyph().position.toUpperCase();
                                if ("R/4" !== r && "B/4" !== r) return;
                                if (e || null != s.beam) {
                                    const e = s.getKeyProps()[0];
                                    if (0 === n) e.line = bt(t, e.line, n, !1), s.setKeyLine(0, e.line);
                                    else if (n > 0 && n < t.length) {
                                        let i;
                                        const r = t[n - 1];
                                        r.isRest() && r.getKeyProps ? (i = r.getKeyProps()[0].line, e.line = i) : (i = r.getLineForRest(), e.line = bt(t, i, n, !0)), s.setKeyLine(0, e.line);
                                    }
                                }
                            }
                        }), this;
                    }
                    constructor(){
                        this.minTotalWidth = 0, this.hasMinTotalWidth = !1, this.totalTicks = new n(0, 1), this.tickContexts = null, this.modiferContexts = null, this.contextGaps = {
                            total: 0,
                            gaps: []
                        }, this.voices = [];
                    }
                    alignRests(t, e) {
                        if (!t || !t.length) throw new s.RERR("BadArgument", "No voices to format rests");
                        t.forEach((t)=>yt.AlignRestsToNotes(t.getTickables(), e));
                    }
                    preCalculateMinTotalWidth(t) {
                        if (this.hasMinTotalWidth) return this.minTotalWidth;
                        if (!this.tickContexts) {
                            if (!t) throw new s.RERR("BadArgument", "'voices' required to run preCalculateMinTotalWidth");
                            this.createTickContexts(t);
                        }
                        const { list: e, map: i } = this.tickContexts;
                        return this.minTotalWidth = e.map((t)=>{
                            const e = i[t];
                            return e.preFormat(), e.getWidth();
                        }).reduce((t, e)=>t + e, 0), this.hasMinTotalWidth = !0, this.minTotalWidth;
                    }
                    getMinTotalWidth() {
                        if (!this.hasMinTotalWidth) throw new s.RERR("NoMinTotalWidth", "Call 'preCalculateMinTotalWidth' or 'preFormat' before calling 'getMinTotalWidth'");
                        return this.minTotalWidth;
                    }
                    createModifierContexts(t) {
                        const e = St(t, gt, (t, e)=>t.addToModifierContext(e));
                        return this.modiferContexts = e, e;
                    }
                    createTickContexts(t) {
                        const e = St(t, $, (t, e)=>e.addTickable(t));
                        return e.array.forEach((t)=>{
                            t.tContexts = e.array;
                        }), this.totalTicks = t[0].getTicksUsed().clone(), this.tickContexts = e, e;
                    }
                    preFormat(t = 0, e, i, s) {
                        const n = this.tickContexts, { list: r, map: o, resolutionMultiplier: a } = n;
                        i && s && i.forEach((t)=>t.setStave(s).preFormat());
                        let l = 0, h = 0;
                        const c = t / 2;
                        if (this.minTotalWidth = 0, r.forEach((t)=>{
                            const i = o[t];
                            e && i.setContext(e), i.preFormat();
                            const s = i.getWidth();
                            this.minTotalWidth += s;
                            const n = i.getMetrics();
                            l = l + h + n.extraLeftPx, i.setX(l), h = s - n.extraLeftPx;
                        }), this.minTotalWidth = l + h, this.hasMinTotalWidth = !0, t <= 0) return;
                        const u = t - this.minTotalWidth;
                        let d = this.totalTicks.value();
                        0 === d && (d = 1);
                        const f = u / (d * a);
                        let m = 0;
                        r.forEach((t, e)=>{
                            const i = r[e - 1] || 0, s = o[t];
                            m += (t - i) * f, s.setX(s.getX() + m), s.getCenterAlignedTickables().forEach((t)=>{
                                t.center_x_shift = c - s.getX();
                            });
                        }), 1 !== r.length && (this.justifyWidth = t, this.lossHistory = [], this.evaluate());
                    }
                    evaluate() {
                        const t = this.justifyWidth;
                        this.contextGaps = {
                            total: 0,
                            gaps: []
                        }, this.tickContexts.list.forEach((t, e)=>{
                            if (0 === e) return;
                            const i = this.tickContexts.list[e - 1], s = this.tickContexts.map[i], n = this.tickContexts.map[t], r = s.getMetrics(), o = s.getX() + r.width, a = n.getX(), l = a - o;
                            this.contextGaps.total += l, this.contextGaps.gaps.push({
                                x1: o,
                                x2: a
                            }), n.getFormatterMetrics().freedom.left = l, s.getFormatterMetrics().freedom.right = l;
                        });
                        const e = this.durationStats = {};
                        this.voices.forEach((i)=>{
                            i.getTickables().forEach((i, s, n)=>{
                                const r = i.getTicks().clone().simplify().toString(), o = i.getMetrics(), a = i.getFormatterMetrics();
                                a.duration = r;
                                const l = i.getX() + o.noteWidth + o.modRightPx + o.extraRightPx;
                                let h = 0;
                                if (s < n.length - 1) {
                                    const t = n[s + 1], e = t.getMetrics();
                                    h = t.getX() - e.modLeftPx - e.extraLeftPx - l, a.space.used = t.getX() - i.getX(), t.getFormatterMetrics().freedom.left = h;
                                } else h = t - l, a.space.used = t - i.getX();
                                a.freedom.right = h, function(t, i) {
                                    const s = e[t];
                                    void 0 === s ? e[t] = {
                                        mean: i,
                                        count: 1
                                    } : (s.count += 1, s.mean = (s.mean + i) / 2);
                                }(r, a.space.used);
                            });
                        });
                        let i = 0;
                        return this.voices.forEach((t)=>{
                            t.getTickables().forEach((t)=>{
                                const s = t.getFormatterMetrics(), n = s.duration;
                                s.iterations += 1, s.space.deviation = s.space.used - e[n].mean, s.space.mean = e[n].mean, i += Math.pow(e[n].mean, 2);
                            });
                        }), this.totalCost = Math.sqrt(i), this.lossHistory.push(this.totalCost), this;
                    }
                    tune() {
                        let t = 0;
                        return this.tickContexts.list.forEach((e, i, s)=>{
                            const n = this.tickContexts.map[e], r = i > 0 ? this.tickContexts.map[s[i - 1]] : null, o = i < s.length - 1 ? this.tickContexts.map[s[i + 1]] : null;
                            !function(t, e, i, s) {
                                t.setX(t.getX() + s), t.getFormatterMetrics().freedom.left += s, t.getFormatterMetrics().freedom.right -= s, e && (e.getFormatterMetrics().freedom.right += s), i && (i.getFormatterMetrics().freedom.left -= s);
                            }(n, r, o, t);
                            const a = -n.getTickables().map((t)=>t.getFormatterMetrics().space.deviation).reduce((t, e)=>t + e);
                            a > 0 ? t = -Math.min(n.getFormatterMetrics().freedom.right, Math.abs(a)) : a < 0 && (t = o ? Math.min(o.getFormatterMetrics().freedom.right, Math.abs(a)) : 0);
                            const l = Math.min(5, Math.abs(t));
                            t = t > 0 ? l : -l;
                        }), this.evaluate();
                    }
                    postFormat() {
                        const t = (t)=>t.list.forEach((e)=>t.map[e].postFormat());
                        return t(this.modiferContexts), t(this.tickContexts), this;
                    }
                    joinVoices(t) {
                        return this.createModifierContexts(t), this.hasMinTotalWidth = !1, this;
                    }
                    format(t, e, i) {
                        const n = {
                            align_rests: !1,
                            context: null,
                            stave: null
                        };
                        return s.Merge(n, i), this.voices = t, this.alignRests(t, n.align_rests), this.createTickContexts(t), this.preFormat(e, n.context, t, n.stave), n.stave && this.postFormat(), this;
                    }
                    formatToStave(t, e, i) {
                        const n = e.getNoteEndX() - e.getNoteStartX() - 10;
                        !function(...t) {
                            yt.DEBUG && s.L("Vex.Flow.Formatter", t);
                        }("Formatting voices to width: ", n);
                        const r = {
                            context: e.getContext()
                        };
                        return s.Merge(r, i), this.format(t, n, r);
                    }
                }
                class Et extends l {
                    static get Position() {
                        return {
                            LEFT: 1,
                            RIGHT: 2,
                            ABOVE: 3,
                            BELOW: 4,
                            BEGIN: 5,
                            END: 6
                        };
                    }
                    constructor(){
                        super(), this.setAttribute("type", "StaveModifier"), this.padding = 10, this.position = Et.Position.ABOVE, this.layoutMetrics = null;
                    }
                    getPosition() {
                        return this.position;
                    }
                    setPosition(t) {
                        return this.position = t, this;
                    }
                    getStave() {
                        return this.stave;
                    }
                    setStave(t) {
                        return this.stave = t, this;
                    }
                    getWidth() {
                        return this.width;
                    }
                    setWidth(t) {
                        return this.width = t, this;
                    }
                    getX() {
                        return this.x;
                    }
                    setX(t) {
                        return this.x = t, this;
                    }
                    getCategory() {
                        return "";
                    }
                    makeSpacer(t) {
                        return {
                            getContext: ()=>!0,
                            setStave () {},
                            renderToStave () {},
                            getMetrics: ()=>({
                                    width: t
                                })
                        };
                    }
                    placeGlyphOnLine(t, e, i) {
                        t.setYShift(e.getYForLine(i) - e.getYForGlyphs());
                    }
                    getPadding(t) {
                        return void 0 !== t && t < 2 ? 0 : this.padding;
                    }
                    setPadding(t) {
                        return this.padding = t, this;
                    }
                    setLayoutMetrics(t) {
                        return this.layoutMetrics = t, this;
                    }
                    getLayoutMetrics() {
                        return this.layoutMetrics;
                    }
                }
                class xt extends Et {
                    static get CATEGORY() {
                        return "barlines";
                    }
                    static get type() {
                        return {
                            SINGLE: 1,
                            DOUBLE: 2,
                            END: 3,
                            REPEAT_BEGIN: 4,
                            REPEAT_END: 5,
                            REPEAT_BOTH: 6,
                            NONE: 7,
                            DOUBLE_HEAVY: 8
                        };
                    }
                    static get typeString() {
                        return {
                            single: xt.type.SINGLE,
                            double: xt.type.DOUBLE,
                            doubleheavy: xt.type.DOUBLE_HEAVY,
                            end: xt.type.END,
                            repeatBegin: xt.type.REPEAT_BEGIN,
                            repeatEnd: xt.type.REPEAT_END,
                            repeatBoth: xt.type.REPEAT_BOTH,
                            none: xt.type.NONE
                        };
                    }
                    constructor(t){
                        super(), this.setAttribute("type", "Barline"), this.thickness = p.STAVE_LINE_THICKNESS;
                        const e = xt.type;
                        this.widths = {}, this.widths[e.SINGLE] = 5, this.widths[e.DOUBLE] = 5, this.widths[e.DOUBLE_HEAVY] = 5, this.widths[e.END] = 5, this.widths[e.REPEAT_BEGIN] = 5, this.widths[e.REPEAT_END] = 5, this.widths[e.REPEAT_BOTH] = 5, this.widths[e.NONE] = 5, this.paddings = {}, this.paddings[e.SINGLE] = 0, this.paddings[e.DOUBLE] = 0, this.paddings[e.DOUBLE_HEAVY] = 0, this.paddings[e.END] = 5, this.paddings[e.REPEAT_BEGIN] = 10, this.paddings[e.REPEAT_END] = 10, this.paddings[e.REPEAT_BOTH] = 15, this.paddings[e.NONE] = 0, this.layoutMetricsMap = {}, this.layoutMetricsMap[e.SINGLE] = {
                            xMin: 0,
                            xMax: 1,
                            paddingLeft: 5,
                            paddingRight: 5
                        }, this.layoutMetricsMap[e.DOUBLE] = {
                            xMin: -3,
                            xMax: 1,
                            paddingLeft: 5,
                            paddingRight: 5
                        }, this.layoutMetricsMap[e.DOUBLE_HEAVY] = {
                            xMin: -5,
                            xMax: 4,
                            paddingLeft: 5,
                            paddingRight: 5
                        }, this.layoutMetricsMap[e.END] = {
                            xMin: -5,
                            xMax: 1,
                            paddingLeft: 5,
                            paddingRight: 5
                        }, this.layoutMetricsMap[e.REPEAT_END] = {
                            xMin: -10,
                            xMax: 1,
                            paddingLeft: 5,
                            paddingRight: 5
                        }, this.layoutMetricsMap[e.REPEAT_BEGIN] = {
                            xMin: -2,
                            xMax: 10,
                            paddingLeft: 5,
                            paddingRight: 5
                        }, this.layoutMetricsMap[e.REPEAT_BOTH] = {
                            xMin: -10,
                            xMax: 10,
                            paddingLeft: 5,
                            paddingRight: 5
                        }, this.layoutMetricsMap[e.NONE] = {
                            xMin: 0,
                            xMax: 0,
                            paddingLeft: 5,
                            paddingRight: 5
                        }, this.setPosition(Et.Position.BEGIN), this.setType(t);
                    }
                    getCategory() {
                        return xt.CATEGORY;
                    }
                    getType() {
                        return this.type;
                    }
                    setType(t) {
                        return this.type = "string" == typeof t ? xt.typeString[t] : t, this.setWidth(this.widths[this.type]), this.setPadding(this.paddings[this.type]), this.setLayoutMetrics(this.layoutMetricsMap[this.type]), this;
                    }
                    draw(t) {
                        switch(t.checkContext(), this.setRendered(), this.type){
                            case xt.type.SINGLE:
                                this.drawVerticalBar(t, this.x, !1);
                                break;
                            case xt.type.DOUBLE:
                                this.drawVerticalBar(t, this.x, !0);
                                break;
                            case xt.type.DOUBLE_HEAVY:
                                this.drawVerticalBar(t, this.x, !0, !0);
                                break;
                            case xt.type.END:
                                this.drawVerticalEndBar(t, this.x);
                                break;
                            case xt.type.REPEAT_BEGIN:
                                this.drawRepeatBar(t, this.x, !0), t.getX() !== this.x && this.drawVerticalBar(t, t.getX());
                                break;
                            case xt.type.REPEAT_END:
                                this.drawRepeatBar(t, this.x, !1);
                                break;
                            case xt.type.REPEAT_BOTH:
                                this.drawRepeatBar(t, this.x, !1), this.drawRepeatBar(t, this.x, !0);
                        }
                    }
                    drawVerticalBar(t, e, i, s) {
                        t.checkContext();
                        const n = t.getTopLineTopY(), r = t.getBottomLineBottomY();
                        let o = 1, a = 1, l = e - 3, h = e;
                        s && (o = 3, a = 3, l = e - 5, h = e), i && t.context.fillRect(l, n, o, r - n), t.context.fillRect(h, n, a, r - n);
                    }
                    drawVerticalEndBar(t, e) {
                        t.checkContext();
                        const i = t.getTopLineTopY(), s = t.getBottomLineBottomY();
                        t.context.fillRect(e - 5, i, 1, s - i), t.context.fillRect(e - 2, i, 3, s - i);
                    }
                    drawRepeatBar(t, e, i) {
                        t.checkContext();
                        const s = t.getTopLineTopY(), n = t.getBottomLineBottomY();
                        let r = 3;
                        i || (r = -5), t.context.fillRect(e + r, s, 1, n - s), t.context.fillRect(e - 2, s, 3, n - s), i ? r += 4 : r -= 4;
                        const o = e + r + 1;
                        let a = (t.getNumLines() - 1) * t.getSpacingBetweenLines();
                        a = a / 2 - t.getSpacingBetweenLines() / 2;
                        let l = s + a + 1;
                        t.context.beginPath(), t.context.arc(o, l, 2, 0, 2 * Math.PI, !1), t.context.fill(), l += t.getSpacingBetweenLines(), t.context.beginPath(), t.context.arc(o, l, 2, 0, 2 * Math.PI, !1), t.context.fill();
                    }
                }
                class vt extends Et {
                    static get CATEGORY() {
                        return "repetitions";
                    }
                    static get type() {
                        return {
                            NONE: 1,
                            CODA_LEFT: 2,
                            CODA_RIGHT: 3,
                            SEGNO_LEFT: 4,
                            SEGNO_RIGHT: 5,
                            DC: 6,
                            DC_AL_CODA: 7,
                            DC_AL_FINE: 8,
                            DS: 9,
                            DS_AL_CODA: 10,
                            DS_AL_FINE: 11,
                            FINE: 12,
                            TO_CODA: 13
                        };
                    }
                    constructor(t, e, i){
                        super(), this.setAttribute("type", "Repetition"), this.symbol_type = t, this.x = e, this.x_shift = 0, this.y_shift = i, this.font = {
                            family: "times",
                            size: 12,
                            weight: "bold italic"
                        };
                    }
                    getCategory() {
                        return vt.CATEGORY;
                    }
                    setShiftX(t) {
                        return this.x_shift = t, this;
                    }
                    setShiftY(t) {
                        return this.y_shift = t, this;
                    }
                    setText(t) {
                        return this.text = t, this;
                    }
                    setX(t) {
                        return this.x = t, this;
                    }
                    draw(t, e) {
                        switch(this.setRendered(), this.symbol_type){
                            case vt.type.CODA_RIGHT:
                                this.drawCodaFixed(t, e + t.width);
                                break;
                            case vt.type.CODA_LEFT:
                                this.drawSymbolText(t, e, "Coda", !0);
                                break;
                            case vt.type.SEGNO_LEFT:
                                this.drawSignoFixed(t, e);
                                break;
                            case vt.type.SEGNO_RIGHT:
                                this.drawSignoFixed(t, e + t.width);
                                break;
                            case vt.type.DC:
                                this.drawSymbolText(t, e, "D.C.", !1);
                                break;
                            case vt.type.DC_AL_CODA:
                                this.drawSymbolText(t, e, "D.C. al", !0);
                                break;
                            case vt.type.DC_AL_FINE:
                                this.drawSymbolText(t, e, "D.C. al Fine", !1);
                                break;
                            case vt.type.DS:
                                this.drawSymbolText(t, e, "D.S.", !1);
                                break;
                            case vt.type.DS_AL_CODA:
                                this.drawSymbolText(t, e, "D.S. al", !0);
                                break;
                            case vt.type.DS_AL_FINE:
                                this.drawSymbolText(t, e, "D.S. al Fine", !1);
                                break;
                            case vt.type.FINE:
                                this.drawSymbolText(t, e, "Fine", !1);
                                break;
                            case vt.type.TO_CODA:
                                this.drawSymbolText(t, e, "To", !0);
                        }
                        return this;
                    }
                    drawCodaFixed(t, e) {
                        const i = t.getYForTopText(t.options.num_lines) + this.y_shift;
                        return m.renderGlyph(t.context, this.x + e + this.x_shift, i + 25, 40, "v4d", !0), this;
                    }
                    drawSignoFixed(t, e) {
                        const i = t.getYForTopText(t.options.num_lines) + this.y_shift;
                        return m.renderGlyph(t.context, this.x + e + this.x_shift, i + 25, 30, "v8c", !0), this;
                    }
                    drawSymbolText(t, e, i, s) {
                        const n = t.checkContext();
                        this.text && (i = this.text, s = !1), n.save(), n.setFont(this.font.family, this.font.size, this.font.weight);
                        let r = 0 + this.x_shift, o = e + this.x_shift;
                        if (this.symbol_type === vt.type.CODA_LEFT) r = this.x + this.x_shift, o = r + n.measureText(i).width + 12;
                        else {
                            const e = -(r + n.measureText(i).width + 12 + t.options.vertical_bar_width + 12);
                            r = this.x + e + t.options.vertical_bar_width, o = r + n.measureText(i).width + 12;
                        }
                        if (this.xShiftAsPercentOfStaveWidth) {
                            const e = r + n.measureText(i).width, s = Math.max(0, Math.min(t.width * this.xShiftAsPercentOfStaveWidth, t.getX() + t.width - e));
                            this.symbol_type !== vt.type.DC_AL_FINE && this.symbol_type !== vt.type.FINE && this.symbol_type !== vt.type.DC && this.symbol_type !== vt.type.DS_AL_FINE && this.symbol_type !== vt.type.DS && this.symbol_type !== vt.type.FINE || (r += s);
                        }
                        const a = t.getYForTopText(t.options.num_lines) + this.y_shift + 25;
                        return s && m.renderGlyph(n, o, a, 40, "v4d", !0), n.fillText(i, r, a + 5), n.restore(), this;
                    }
                }
                class Tt extends Et {
                    static get CATEGORY() {
                        return "stavesection";
                    }
                    constructor(t, e, i){
                        super(), this.setAttribute("type", "StaveSection"), this.setWidth(16), this.section = t, this.x = e, this.shift_x = 0, this.shift_y = i, this.minBottomY = void 0, this.font = {
                            family: "sans-serif",
                            size: 12,
                            weight: "bold"
                        };
                    }
                    getCategory() {
                        return Tt.CATEGORY;
                    }
                    setStaveSection(t) {
                        return this.section = t, this;
                    }
                    setShiftX(t) {
                        return this.shift_x = t, this;
                    }
                    setShiftY(t) {
                        return this.shift_y = t, this;
                    }
                    draw(t, e) {
                        const i = t.checkContext();
                        this.setRendered(), i.save(), i.lineWidth = 2, i.setFont(this.font.family, this.font.size, this.font.weight);
                        const s = i.measureText("" + this.section).width, n = 1.5 * this.font.size;
                        let r = s + 6;
                        r < 18 && (r = 18);
                        const o = n + this.font.size / 10;
                        let a = t.getYForTopText(3) + 19 - 1.15 * o + this.shift_y;
                        if (void 0 !== this.minBottomY && null !== this.minBottomY) {
                            const e = t.getYForLine(0) + this.minBottomY, i = a + n / 4 + o;
                            i > e && (a -= i - e);
                        }
                        let l = this.x + e;
                        return i.beginPath(), i.lineWidth = 2, i.rect(l, a + n / 4, r, o), i.stroke(), l += (r - s) / 2, i.fillText("" + this.section, l, a + o), i.restore(), this;
                    }
                }
                class _t extends Et {
                    static get CATEGORY() {
                        return "stavetempo";
                    }
                    constructor(t, e, i){
                        super(), this.setAttribute("type", "StaveTempo"), this.tempo = t, this.position = D.Position.ABOVE, this.x = e, this.shift_x = 10, this.shift_y = i, this.font = {
                            family: "times",
                            size: 14,
                            weight: "bold"
                        }, this.render_options = {
                            glyph_font_scale: 30
                        };
                    }
                    getCategory() {
                        return _t.CATEGORY;
                    }
                    setTempo(t) {
                        return this.tempo = t, this;
                    }
                    setShiftX(t) {
                        return this.shift_x = t, this;
                    }
                    setShiftY(t) {
                        return this.shift_y = t, this;
                    }
                    draw(t, e) {
                        const i = t.checkContext();
                        this.setRendered(), i.openGroup("stavetempo");
                        const s = this.render_options, n = s.glyph_font_scale / 38, r = this.tempo.name, o = this.tempo.duration, a = this.tempo.dots, l = this.tempo.bpm, h = this.tempo.noteEquation, c = this.font;
                        let u = this.x + this.shift_x + e;
                        const d = t.getYForTopText(1) + this.shift_y;
                        if (i.save(), r && (i.setFont(c.family, c.size, c.weight), i.fillText(r, u, d), u += i.measureText(r).width), h) u = this.drawNoteEquation(i, u, d, n, h);
                        else if (o && l) {
                            i.setFont(c.family, c.size, "normal"), r && (u += i.measureText(" ").width, i.fillText("(", u, d), u += i.measureText("(").width);
                            const t = p.getGlyphProps(o);
                            if (u += 3 * n, m.renderGlyph(i, u, d, s.glyph_font_scale, t.code_head), u += t.getWidth() * n, t.stem) {
                                let e = 30;
                                t.beam_count && (e += 3 * (t.beam_count - 1)), e *= n;
                                const r = d - e;
                                i.fillRect(u - n, r, n, e), t.flag && (m.renderGlyph(i, u, r, s.glyph_font_scale, t.code_flag_upstem), a || (u += 6 * n));
                            }
                            for(let t = 0; t < a; t++)u += 6 * n, i.beginPath(), i.arc(u, d + 2 * n, 2 * n, 0, 2 * Math.PI, !1), i.fill();
                            const e = i.openGroup("bpm");
                            i.fillText(" = " + l + (r ? ")" : ""), u + 3 * n, d), e?.lastChild.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve"), i.closeGroup();
                        }
                        return i.closeGroup(), i.restore(), this;
                    }
                    drawNoteEquation(t, e, i, s, n) {
                        const r = this.font, o = 4 * s;
                        return e = this.drawNoteGroup(t, e, i, s, o, n.left), t.setFont(r.family, r.size, "bold"), e += 1.5 * o, t.fillText("=", e, i), e += t.measureText("=", !0).width + 1.5 * o, this.drawNoteGroup(t, e, i, s, o, n.right);
                    }
                    drawNoteGroup(t, e, i, s, n, r) {
                        const o = this.render_options, a = r.notes, l = r.tuplet, h = [], c = [];
                        let u = [];
                        for(let r = 0; r < a.length; r++){
                            const d = a[r], f = p.getGlyphProps(d.duration);
                            if (!f) continue;
                            const g = e += 3 * s;
                            m.renderGlyph(t, e, i, o.glyph_font_scale, f.code_head);
                            let b = i;
                            const S = e += f.getWidth() * s;
                            if (f.stem) {
                                let n = 30;
                                n *= s, b = i - n, t.fillRect(e - s, b, s, n), f.flag && !d.beam && (m.renderGlyph(t, e, b, o.glyph_font_scale, f.code_flag_upstem), d.dots || (e += 6 * s));
                            }
                            for(let n = 0; n < (d.dots || 0); n++)e += 6 * s, t.beginPath(), t.arc(e, i + 2 * s, 2 * s, 0, 2 * Math.PI, !1), t.fill();
                            const y = {
                                x: g,
                                y_top: b,
                                stemX: S,
                                code: f
                            };
                            if (d.tied && h.length > 0) {
                                const e = h[h.length - 1], n = (e.x + e.stemX) / 2 + s, r = (g + S) / 2 - s, o = (n + r) / 2, a = i + 5 * s;
                                t.openGroup("metronometie"), t.beginPath(), t.moveTo(n, a), t.quadraticCurveTo(o, a + 6 * s, r, a), t.quadraticCurveTo(o, a + 9 * s, n, a), t.closePath(), t.fill(), t.closeGroup();
                            }
                            h.push(y), "begin" === d.beam ? u = [
                                y
                            ] : "continue" === d.beam ? u.push(y) : "end" === d.beam && (u.push(y), c.push(u), u = []), r < a.length - 1 && (e += l ? 2 * n : n);
                        }
                        const d = 3 * s;
                        for (const e of c){
                            if (e.length < 2) continue;
                            const i = e[0], n = e[e.length - 1];
                            let r = 0;
                            for (const t of e)t.code.beam_count && (r = Math.max(r, t.code.beam_count));
                            for(let e = 0; e < r; e++){
                                const r = i.y_top + e * (d + 1 * s);
                                t.fillRect(i.stemX - s, r, n.stemX - i.stemX + s, d);
                            }
                        }
                        if (l && h.length > 0) {
                            const e = h[0], i = h[h.length - 1];
                            let r = e.y_top;
                            for (const t of h)r = Math.min(r, t.y_top);
                            const o = 1.25 * n, a = r - 1.5 * n, c = e.x - .5 * n, u = i.stemX + o;
                            if (l.bracket) {
                                const e = n;
                                t.beginPath(), t.moveTo(c, a + e), t.lineTo(c, a);
                                const i = (c + u) / 2, r = "both" === l.showNumber ? `${l.actualNotes}:${l.normalNotes}` : `${l.actualNotes}`;
                                t.setFont(this.font.family, this.font.size - 3, "bold");
                                const o = t.measureText(r, !0).width, h = o / 2 + 2 * s;
                                t.lineTo(i - h, a), t.stroke(), t.beginPath(), t.moveTo(i + h, a), t.lineTo(u, a), t.lineTo(u, a + e), t.stroke(), t.fillText(r, i - o / 2, a - 1 * s);
                            } else if ("none" !== l.showNumber) {
                                const e = (c + u) / 2, i = "both" === l.showNumber ? `${l.actualNotes}:${l.normalNotes}` : `${l.actualNotes}`;
                                t.setFont(this.font.family, this.font.size - 3, "bold");
                                const n = t.measureText(i, !0).width;
                                t.fillText(i, e - n / 2, a - 1 * s);
                            }
                        }
                        return e;
                    }
                }
                class Mt extends N {
                    static get Justification() {
                        return {
                            LEFT: 1,
                            CENTER: 2,
                            RIGHT: 3
                        };
                    }
                    static get GLYPHS() {
                        return {
                            segno: {
                                code: "v8c",
                                point: 40,
                                x_shift: 0,
                                y_shift: -10
                            },
                            tr: {
                                code: "v1f",
                                point: 40,
                                x_shift: 0,
                                y_shift: 0
                            },
                            mordent_upper: {
                                code: "v1e",
                                point: 40,
                                x_shift: 0,
                                y_shift: 0
                            },
                            mordent_lower: {
                                code: "v45",
                                point: 40,
                                x_shift: 0,
                                y_shift: 0
                            },
                            f: {
                                code: "vba",
                                point: 40,
                                x_shift: 0,
                                y_shift: 0
                            },
                            p: {
                                code: "vbf",
                                point: 40,
                                x_shift: 0,
                                y_shift: 0
                            },
                            m: {
                                code: "v62",
                                point: 40,
                                x_shift: 0,
                                y_shift: 0
                            },
                            s: {
                                code: "v4a",
                                point: 40,
                                x_shift: 0,
                                y_shift: 0
                            },
                            z: {
                                code: "v80",
                                point: 40,
                                x_shift: 0,
                                y_shift: 0
                            },
                            coda: {
                                code: "v4d",
                                point: 40,
                                x_shift: 0,
                                y_shift: -8
                            },
                            pedal_open: {
                                code: "v36",
                                point: 40,
                                x_shift: 0,
                                y_shift: 0
                            },
                            pedal_close: {
                                code: "v5d",
                                point: 40,
                                x_shift: 0,
                                y_shift: 3
                            },
                            caesura_straight: {
                                code: "v34",
                                point: 40,
                                x_shift: 0,
                                y_shift: 2
                            },
                            caesura_curved: {
                                code: "v4b",
                                point: 40,
                                x_shift: 0,
                                y_shift: 2
                            },
                            breath: {
                                code: "v6c",
                                point: 40,
                                x_shift: 0,
                                y_shift: 0
                            },
                            tick: {
                                code: "v6f",
                                point: 50,
                                x_shift: 0,
                                y_shift: 0
                            },
                            turn: {
                                code: "v72",
                                point: 40,
                                x_shift: 0,
                                y_shift: 0
                            },
                            turn_inverted: {
                                code: "v33",
                                point: 40,
                                x_shift: 0,
                                y_shift: 0
                            },
                            mordent: {
                                code: "v1e",
                                point: 40,
                                x_shift: 0,
                                y_shift: 0
                            }
                        };
                    }
                    constructor(t){
                        if (super(t), this.setAttribute("type", "TextNote"), this.text = t.text, this.superscript = t.superscript, this.subscript = t.subscript, this.glyph_type = t.glyph, this.glyph = null, this.font = {
                            family: "Arial",
                            size: 12,
                            weight: ""
                        }, t.font && (this.font = t.font), this.glyph_type) {
                            const t = Mt.GLYPHS[this.glyph_type];
                            if (!t) throw new s.RERR("Invalid glyph type: " + this.glyph_type);
                            this.glyph = new m(t.code, t.point, {
                                cache: !1
                            }), t.width ? this.setWidth(t.width) : this.setWidth(this.glyph.getMetrics().width), this.glyph_struct = t;
                        } else this.setWidth(p.textWidth(this.text));
                        this.line = t.line || 0, this.smooth = t.smooth || !1, this.ignore_ticks = t.ignore_ticks || !1, this.justification = Mt.Justification.LEFT;
                    }
                    setJustification(t) {
                        return this.justification = t, this;
                    }
                    setLine(t) {
                        return this.line = t, this;
                    }
                    preFormat() {
                        this.checkContext(), this.preFormatted || (this.smooth ? this.setWidth(0) : this.glyph || this.setWidth(this.context.measureText(this.text).width), this.justification === Mt.Justification.CENTER ? this.extraLeftPx = this.width / 2 : this.justification === Mt.Justification.RIGHT && (this.extraLeftPx = this.width), this.setPreFormatted(!0));
                    }
                    draw() {
                        if (this.checkContext(), !this.stave) throw new s.RERR("NoStave", "Can't draw without a stave.");
                        this.setRendered();
                        const t = this.context;
                        let e, i = this.getAbsoluteX();
                        if (this.justification === Mt.Justification.CENTER ? i -= this.getWidth() / 2 : this.justification === Mt.Justification.RIGHT && (i -= this.getWidth()), this.glyph) e = this.stave.getYForLine(this.line + -3), this.glyph.render(this.context, i + this.glyph_struct.x_shift, e + this.glyph_struct.y_shift);
                        else {
                            e = this.stave.getYForLine(this.line + -3), this.applyStyle(t), t.setFont(this.font.family, this.font.size, this.font.weight), t.fillText(this.text, i, e);
                            const s = t.measureText("M").width, n = t.measureText(this.text).width;
                            this.superscript && (t.setFont(this.font.family, this.font.size / 1.3, this.font.weight), t.fillText(this.superscript, i + n + 2, e - s / 2.2)), this.subscript && (t.setFont(this.font.family, this.font.size / 1.3, this.font.weight), t.fillText(this.subscript, i + n + 2, e + s / 2.2 - 1)), this.restoreStyle(t);
                        }
                    }
                }
                class Pt extends Et {
                    static get CATEGORY() {
                        return "stavetext";
                    }
                    constructor(t, e, i){
                        super(), this.setAttribute("type", "StaveText"), this.setWidth(16), this.text = t, this.position = e, this.options = {
                            shift_x: 0,
                            shift_y: 0,
                            justification: Mt.Justification.CENTER
                        }, s.Merge(this.options, i), this.font = {
                            family: "times",
                            size: 16,
                            weight: "normal"
                        };
                    }
                    getCategory() {
                        return Pt.CATEGORY;
                    }
                    setStaveText(t) {
                        return this.text = t, this;
                    }
                    setShiftX(t) {
                        return this.shift_x = t, this;
                    }
                    setShiftY(t) {
                        return this.shift_y = t, this;
                    }
                    setFont(t) {
                        s.Merge(this.font, t);
                    }
                    setText(t) {
                        this.text = t;
                    }
                    draw(t) {
                        const e = t.checkContext();
                        this.setRendered(), e.save(), e.lineWidth = 2, e.setFont(this.font.family, this.font.size, this.font.weight);
                        const i = e.measureText("" + this.text).width;
                        let n, r;
                        const o = Et.Position, a = Mt.Justification;
                        switch(this.position){
                            case o.LEFT:
                            case o.RIGHT:
                                r = (t.getYForLine(0) + t.getBottomLineY()) / 2 + this.options.shift_y, n = this.position === o.LEFT ? t.getX() - i - 24 + this.options.shift_x : t.getX() + t.getWidth() + 24 + this.options.shift_x;
                                break;
                            case o.ABOVE:
                            case o.BELOW:
                                n = t.getX() + this.options.shift_x, this.options.justification === a.CENTER ? n += t.getWidth() / 2 - i / 2 : this.options.justification === a.RIGHT && (n += t.getWidth() - i), r = this.position === o.ABOVE ? t.getYForTopText(2) + this.options.shift_y : t.getYForBottomText(2) + this.options.shift_y;
                                break;
                            default:
                                throw new s.RERR("InvalidPosition", "Value Must be in Modifier.Position.");
                        }
                        return e.fillText("" + this.text, n, r + 4), e.restore(), this;
                    }
                }
                class Lt extends Et {
                    static get CATEGORY() {
                        return "clefs";
                    }
                    static get types() {
                        return {
                            treble: {
                                code: "v83",
                                line: 3
                            },
                            bass: {
                                code: "v79",
                                line: 1
                            },
                            alto: {
                                code: "vad",
                                line: 2
                            },
                            tenor: {
                                code: "vad",
                                line: 1
                            },
                            percussion: {
                                code: "v59",
                                line: 2
                            },
                            soprano: {
                                code: "vad",
                                line: 4
                            },
                            "mezzo-soprano": {
                                code: "vad",
                                line: 3
                            },
                            "baritone-c": {
                                code: "vad",
                                line: 0
                            },
                            "baritone-f": {
                                code: "v79",
                                line: 2
                            },
                            subbass: {
                                code: "v79",
                                line: 0
                            },
                            french: {
                                code: "v83",
                                line: 4
                            },
                            tab: {
                                code: "v2f"
                            }
                        };
                    }
                    static get sizes() {
                        return {
                            default: {
                                point: 40,
                                width: 26
                            },
                            small: {
                                point: 32,
                                width: 20
                            }
                        };
                    }
                    static get annotations() {
                        return {
                            "8va": {
                                code: "v8",
                                sizes: {
                                    default: {
                                        point: 20,
                                        attachments: {
                                            treble: {
                                                line: -1.2,
                                                x_shift: 11
                                            }
                                        }
                                    },
                                    small: {
                                        point: 18,
                                        attachments: {
                                            treble: {
                                                line: -0.4,
                                                x_shift: 8
                                            }
                                        }
                                    }
                                }
                            },
                            "8vb": {
                                code: "v8",
                                sizes: {
                                    default: {
                                        point: 20,
                                        attachments: {
                                            treble: {
                                                line: 6.3,
                                                x_shift: 10
                                            },
                                            bass: {
                                                line: 4,
                                                x_shift: 1
                                            }
                                        }
                                    },
                                    small: {
                                        point: 18,
                                        attachments: {
                                            treble: {
                                                line: 5.8,
                                                x_shift: 6
                                            },
                                            bass: {
                                                line: 3.5,
                                                x_shift: .5
                                            }
                                        }
                                    }
                                }
                            }
                        };
                    }
                    constructor(t, e, i){
                        super(), this.setAttribute("type", "Clef"), this.setPosition(Et.Position.BEGIN), this.setType(t, e, i), this.setWidth(Lt.sizes[this.size].width), function(...t) {
                            Lt.DEBUG && s.L("Vex.Flow.Clef", t);
                        }("Creating clef:", t);
                    }
                    getCategory() {
                        return Lt.CATEGORY;
                    }
                    setType(t, e, i) {
                        if (this.type = t, this.clef = Lt.types[t], this.size = void 0 === e ? "default" : e, this.clef.point = Lt.sizes[this.size].point, this.glyph = new m(this.clef.code, this.clef.point), void 0 !== i) {
                            const t = Lt.annotations[i];
                            this.annotation = {
                                code: t.code,
                                point: t.sizes[this.size].point,
                                line: t.sizes[this.size].attachments[this.type].line,
                                x_shift: t.sizes[this.size].attachments[this.type].x_shift
                            }, this.attachment = new m(this.annotation.code, this.annotation.point), this.attachment.metrics.x_max = 0, this.attachment.setXShift(this.annotation.x_shift);
                        } else this.annotation = void 0;
                        return this;
                    }
                    getWidth() {
                        if ("tab" === this.type && !this.stave) throw new s.RERR("ClefError", "Can't get width without stave.");
                        return this.width;
                    }
                    setStave(t) {
                        if (this.stave = t, "tab" !== this.type) return this;
                        let e, i;
                        const n = this.stave.getOptions().num_lines;
                        switch(n){
                            case 8:
                                e = 55, i = 14;
                                break;
                            case 7:
                                e = 47, i = 8;
                                break;
                            case 6:
                                e = 40, i = 1;
                                break;
                            case 5:
                                e = 30, i = -6;
                                break;
                            case 4:
                                e = 23, i = -12;
                                break;
                            case 3:
                                e = 16, i = -18;
                                break;
                            default:
                                throw new s.RERR("ClefError", `Invalid number of lines: ${n}`);
                        }
                        return this.glyph.setPoint(e), this.glyph.setYShift(i), this;
                    }
                    draw() {
                        if (!this.x) throw new s.RERR("ClefError", "Can't draw clef without x.");
                        if (!this.stave) throw new s.RERR("ClefError", "Can't draw clef without stave.");
                        this.setRendered(), this.glyph.setStave(this.stave), this.glyph.setContext(this.stave.context), void 0 !== this.clef.line && this.placeGlyphOnLine(this.glyph, this.stave, this.clef.line), this.stave.context.openGroup("clef"), this.glyph.renderToStave(this.x), void 0 !== this.annotation && (this.placeGlyphOnLine(this.attachment, this.stave, this.annotation.line), this.attachment.setStave(this.stave), this.attachment.setContext(this.stave.context), this.attachment.renderToStave(this.x)), this.stave.context.closeGroup();
                    }
                }
                class wt extends Et {
                    static get CATEGORY() {
                        return "keysignatures";
                    }
                    static get accidentalSpacing() {
                        return {
                            "#": {
                                above: 6,
                                below: 4
                            },
                            b: {
                                above: 4,
                                below: 7
                            },
                            n: {
                                above: 4,
                                below: 1
                            },
                            "##": {
                                above: 6,
                                below: 4
                            },
                            bb: {
                                above: 4,
                                below: 7
                            },
                            db: {
                                above: 4,
                                below: 7
                            },
                            d: {
                                above: 4,
                                below: 7
                            },
                            bbs: {
                                above: 4,
                                below: 7
                            },
                            "++": {
                                above: 6,
                                below: 4
                            },
                            "+": {
                                above: 6,
                                below: 4
                            },
                            "+-": {
                                above: 6,
                                below: 4
                            },
                            "++-": {
                                above: 6,
                                below: 4
                            },
                            bs: {
                                above: 4,
                                below: 10
                            },
                            bss: {
                                above: 4,
                                below: 10
                            }
                        };
                    }
                    constructor(t, e, i){
                        super(), this.setAttribute("type", "KeySignature"), this.setKeySig(t, e, i), this.setPosition(Et.Position.BEGIN), this.glyphFontScale = 38, this.glyphs = [], this.xPositions = [], this.paddingForced = !1;
                    }
                    getCategory() {
                        return wt.CATEGORY;
                    }
                    convertToGlyph(t, e) {
                        const i = p.accidentalCodes(t.type), s = new m(i.code, this.glyphFontScale);
                        let n = 1;
                        if ("n" === t.type && e) {
                            const i = wt.accidentalSpacing[e.type];
                            i && (n = e.line >= t.line ? i.above : i.below);
                        }
                        this.placeGlyphOnLine(s, this.stave, t.line), this.glyphs.push(s);
                        const r = this.xPositions[this.xPositions.length - 1], o = s.getMetrics().width + n;
                        this.xPositions.push(r + o), this.width += o;
                    }
                    cancelKey(t) {
                        return this.formatted = !1, this.cancelKeySpec = t, this;
                    }
                    convertToCancelAccList(t) {
                        const e = p.keySignature(t), i = this.accList.length > 0 && e.length > 0 && e[0].type !== this.accList[0].type, s = i ? e.length : e.length - this.accList.length;
                        if (s < 1) return;
                        const n = [];
                        for(let t = 0; t < s; t++){
                            let r = t;
                            i || (r = e.length - s + t);
                            const o = e[r];
                            n.push({
                                type: "n",
                                line: o.line
                            });
                        }
                        return this.accList = n.concat(this.accList), {
                            accList: n,
                            type: e[0].type
                        };
                    }
                    addToStave(t) {
                        return this.paddingForced = !0, t.addModifier(this), this;
                    }
                    convertAccLines(t, e, i = this.accList) {
                        let s, n, r = 0;
                        switch(t){
                            case "soprano":
                                "#" === e ? s = [
                                    2.5,
                                    .5,
                                    2,
                                    0,
                                    1.5,
                                    -0.5,
                                    1
                                ] : r = -1;
                                break;
                            case "mezzo-soprano":
                                "b" === e ? s = [
                                    0,
                                    2,
                                    .5,
                                    2.5,
                                    1,
                                    3,
                                    1.5
                                ] : r = 1.5;
                                break;
                            case "alto":
                                r = .5;
                                break;
                            case "tenor":
                                "#" === e ? s = [
                                    3,
                                    1,
                                    2.5,
                                    .5,
                                    2,
                                    0,
                                    1.5
                                ] : r = -0.5;
                                break;
                            case "baritone-f":
                            case "baritone-c":
                                "b" === e ? s = [
                                    .5,
                                    2.5,
                                    1,
                                    3,
                                    1.5,
                                    3.5,
                                    2
                                ] : r = 2;
                                break;
                            case "bass":
                            case "french":
                                r = 1;
                        }
                        if (void 0 !== s) for(n = 0; n < i.length; ++n)i[n].line = s[n];
                        else if (0 !== r) for(n = 0; n < i.length; ++n)i[n].line += r;
                    }
                    getPadding(t) {
                        return this.formatted || this.format(), 0 === this.glyphs.length || !this.paddingForced && t < 2 ? 0 : this.padding;
                    }
                    getWidth() {
                        return this.formatted || this.format(), this.width;
                    }
                    setKeySig(t, e, i) {
                        return this.formatted = !1, this.keySpec = t, this.cancelKeySpec = e, this.alterKeySpec = i, this;
                    }
                    alterKey(t) {
                        return this.formatted = !1, this.alterKeySpec = t, this;
                    }
                    convertToAlterAccList(t) {
                        const e = Math.min(t.length, this.accList.length);
                        for(let i = 0; i < e; ++i)t[i] && (this.accList[i].type = t[i]);
                    }
                    format() {
                        if (!this.stave) throw new s.RERR("KeySignatureError", "Can't draw key signature without stave.");
                        this.width = 0, this.glyphs = [], this.xPositions = [
                            0
                        ], this.accList = p.keySignature(this.keySpec);
                        const t = this.accList, e = t.length > 0 ? t[0].type : null;
                        let i;
                        if (this.cancelKeySpec && (i = this.convertToCancelAccList(this.cancelKeySpec)), this.alterKeySpec && this.convertToAlterAccList(this.alterKeySpec), this.accList.length > 0) {
                            const s = (this.position === Et.Position.END ? this.stave.endClef : this.stave.clef) || this.stave.clef;
                            i && this.convertAccLines(s, i.type, i.accList), this.convertAccLines(s, e, t);
                            for(let t = 0; t < this.accList.length; ++t)this.convertToGlyph(this.accList[t], this.accList[t + 1]);
                        }
                        this.formatted = !0;
                    }
                    draw() {
                        if (!this.x) throw new s.RERR("KeySignatureError", "Can't draw key signature without x.");
                        if (!this.stave) throw new s.RERR("KeySignatureError", "Can't draw key signature without stave.");
                        if (this.formatted || this.format(), this.setRendered(), this.glyphs.length > 0) {
                            const t = this.stave.context.openGroup("keysignature");
                            for(let t = 0; t < this.glyphs.length; t++){
                                const e = this.glyphs[t], i = this.x + this.xPositions[t];
                                e.setStave(this.stave), e.setContext(this.stave.context), e.renderToStave(i);
                            }
                            this.hidden && t && t.setAttribute("visibility", "hidden"), this.stave.context.closeGroup();
                        }
                    }
                }
                class At extends Et {
                    static get CATEGORY() {
                        return "timesignatures";
                    }
                    static get glyphs() {
                        return {
                            C: {
                                code: "v41",
                                point: 40,
                                line: 2
                            },
                            "C|": {
                                code: "vb6",
                                point: 40,
                                line: 2
                            }
                        };
                    }
                    constructor(t = null, e = 15, i = !0){
                        if (super(), this.setAttribute("type", "TimeSignature"), this.validate_args = i, null === t) return;
                        const s = e;
                        this.point = 40, this.topLine = 2, this.bottomLine = 4, this.setPosition(Et.Position.BEGIN), this.setTimeSig(t), this.setWidth(this.timeSig.glyph.getMetrics().width), this.setPadding(s);
                    }
                    getCategory() {
                        return At.CATEGORY;
                    }
                    parseTimeSpec(t) {
                        if ("C" === t || "C|" === t) {
                            const { line: e, code: i, point: s } = At.glyphs[t];
                            return {
                                line: e,
                                num: !1,
                                glyph: new m(i, s)
                            };
                        }
                        this.validate_args && ((t)=>{
                            const e = t.split("/").filter((t)=>"" !== t);
                            if (2 !== e.length) throw new s.RERR("BadTimeSignature", `Invalid time spec: ${t}. Must be in the form "<numerator>/<denominator>"`);
                            e.forEach((e)=>{
                                if (isNaN(Number(e))) throw new s.RERR("BadTimeSignature", `Invalid time spec: ${t}. Must contain two valid numbers.`);
                            });
                        })(t);
                        const [e, i] = t.split("/").map((t)=>t.split(""));
                        return {
                            num: !0,
                            glyph: this.makeTimeSignatureGlyph(e, i)
                        };
                    }
                    makeTimeSignatureGlyph(t, e) {
                        const i = new m("v0", this.point);
                        i.topGlyphs = [], i.botGlyphs = [];
                        let s = 0;
                        for(let e = 0; e < t.length; ++e){
                            const n = t[e], r = new m("v" + n, this.point);
                            i.topGlyphs.push(r), s += r.getMetrics().width;
                        }
                        let n = 0;
                        for(let t = 0; t < e.length; ++t){
                            const s = e[t], r = new m("v" + s, this.point);
                            i.botGlyphs.push(r), n += r.getMetrics().width;
                        }
                        const r = s > n ? s : n, o = i.getMetrics().x_min;
                        i.getMetrics = ()=>({
                                x_min: o,
                                x_max: o + r,
                                width: r
                            });
                        const a = (r - s) / 2, l = (r - n) / 2, h = this;
                        return i.renderToStave = function(t) {
                            let e = t + a;
                            for(let t = 0; t < this.topGlyphs.length; ++t){
                                const i = this.topGlyphs[t];
                                m.renderOutline(this.context, i.metrics.outline, i.scale, e + i.x_shift, this.stave.getYForLine(h.topLine)), e += i.getMetrics().width;
                            }
                            e = t + l;
                            for(let t = 0; t < this.botGlyphs.length; ++t){
                                const i = this.botGlyphs[t];
                                h.placeGlyphOnLine(i, this.stave, i.line), m.renderOutline(this.context, i.metrics.outline, i.scale, e + i.x_shift, this.stave.getYForLine(h.bottomLine)), e += i.getMetrics().width;
                            }
                        }, i;
                    }
                    getTimeSig() {
                        return this.timeSig;
                    }
                    setTimeSig(t) {
                        return this.timeSig = this.parseTimeSpec(t), this;
                    }
                    draw() {
                        if (!this.x) throw new s.RERR("TimeSignatureError", "Can't draw time signature without x.");
                        if (!this.stave) throw new s.RERR("TimeSignatureError", "Can't draw time signature without stave.");
                        this.setRendered(), this.timeSig.glyph.setStave(this.stave), this.timeSig.glyph.setContext(this.stave.context), this.placeGlyphOnLine(this.timeSig.glyph, this.stave, this.timeSig.line);
                        const t = this.stave.context.openGroup("timesignature");
                        this.timeSig.glyph.renderToStave(this.x), this.hidden && t && t.setAttribute("visibility", "hidden"), this.stave.context.closeGroup("timesignature");
                    }
                }
                class It extends Et {
                    static get CATEGORY() {
                        return "voltas";
                    }
                    static get type() {
                        return {
                            NONE: 1,
                            BEGIN: 2,
                            MID: 3,
                            END: 4,
                            BEGIN_END: 5
                        };
                    }
                    constructor(t, e, i, s){
                        super(), this.setAttribute("type", "Volta"), this.volta = t, this.x = i, this.y_shift = s, this.number = e, this.font = {
                            family: "sans-serif",
                            size: 9,
                            weight: "bold"
                        };
                    }
                    getCategory() {
                        return It.CATEGORY;
                    }
                    setShiftY(t) {
                        return this.y_shift = t, this;
                    }
                    draw(t, e) {
                        const i = t.checkContext();
                        this.setRendered();
                        let s = t.width - e;
                        const n = t.getYForTopText(t.options.num_lines) + this.y_shift, r = 1.5 * t.options.spacing_between_lines_px;
                        switch(this.volta){
                            case It.type.BEGIN:
                                i.fillRect(this.x + e, n, 1, r);
                                break;
                            case It.type.END:
                                s -= 5, i.fillRect(this.x + e + s, n, 1, r);
                                break;
                            case It.type.BEGIN_END:
                                s -= 3, i.fillRect(this.x + e, n, 1, r), i.fillRect(this.x + e + s, n, 1, r);
                        }
                        return this.volta !== It.type.BEGIN && this.volta !== It.type.BEGIN_END || (i.save(), i.setFont(this.font.family, this.font.size, this.font.weight), i.fillText(this.number, this.x + e + 5, n + 15), i.restore()), i.fillRect(this.x + e, n, s, 1), this;
                    }
                }
                class Rt extends l {
                    constructor(t, e, i, n){
                        super(), this.setAttribute("type", "Stave"), this.x = t, this.y = e, this.width = i, this.formatted = !1, this.setStartX(t + 5), this.end_x = t + i, this.modifiers = [], this.measure = 0, this.clef = "treble", this.endClef = void 0, this.font = {
                            family: "sans-serif",
                            size: 8,
                            weight: ""
                        }, this.options = {
                            vertical_bar_width: 10,
                            glyph_spacing_px: 10,
                            num_lines: 5,
                            fill_style: "#999999",
                            left_bar: !0,
                            right_bar: !0,
                            spacing_between_lines_px: 10,
                            space_above_staff_ln: 4,
                            space_below_staff_ln: 4,
                            top_text_position: 1
                        }, this.bounds = {
                            x: this.x,
                            y: this.y,
                            w: this.width,
                            h: 0
                        }, s.Merge(this.options, n), this.resetLines();
                        const r = xt.type;
                        this.addModifier(new xt(this.options.left_bar ? r.SINGLE : r.NONE)), this.addEndModifier(new xt(this.options.right_bar ? r.SINGLE : r.NONE));
                    }
                    space(t) {
                        return this.options.spacing_between_lines_px * t;
                    }
                    resetLines() {
                        this.options.line_config = [];
                        for(let t = 0; t < this.options.num_lines; t++)this.options.line_config.push({
                            visible: !0
                        });
                        this.height = (this.options.num_lines + this.options.space_above_staff_ln) * this.options.spacing_between_lines_px, this.options.bottom_text_position = this.options.num_lines;
                    }
                    formatBegModifiers(t) {
                        let e = 0;
                        t.forEach((t)=>{
                            t.getNoteStartX() > e && (e = t.getNoteStartX());
                        }), t.forEach((t)=>{
                            t.setNoteStartX(e);
                        }), e = 0, t.forEach((t)=>{
                            t.getModifiers(Et.Position.BEGIN, xt.CATEGORY).forEach((t)=>{
                                t.getType() == xt.type.REPEAT_BEGIN && t.getX() > e && (e = t.getX());
                            });
                        }), t.forEach((t)=>{
                            t.getModifiers(Et.Position.BEGIN, xt.CATEGORY).forEach((t)=>{
                                t.getType() == xt.type.REPEAT_BEGIN && t.setX(e);
                            });
                        }), e = 0, t.forEach((t)=>{
                            t.getModifiers(Et.Position.BEGIN, At.CATEGORY).forEach((t)=>{
                                t.getX() > e && (e = t.getX());
                            });
                        }), t.forEach((t)=>{
                            t.getModifiers(Et.Position.BEGIN, At.CATEGORY).forEach((t)=>{
                                t.setX(e);
                            });
                        });
                    }
                    getOptions() {
                        return this.options;
                    }
                    setNoteStartX(t) {
                        return this.formatted || this.format(), this.setStartX(t), this;
                    }
                    setStartX(t) {
                        this.start_x = t;
                    }
                    getNoteStartX() {
                        return this.formatted || this.format(), this.start_x;
                    }
                    getNoteEndX() {
                        return this.formatted || this.format(), this.end_x;
                    }
                    getTieStartX() {
                        return this.start_x;
                    }
                    getTieEndX() {
                        return this.x + this.width;
                    }
                    getX() {
                        return this.x;
                    }
                    getNumLines() {
                        return this.options.num_lines;
                    }
                    setNumLines(t) {
                        return this.options.num_lines = parseInt(t, 10), this.resetLines(), this;
                    }
                    setY(t) {
                        return this.y = t, this;
                    }
                    getTopLineTopY() {
                        return this.getYForLine(0) - p.STAVE_LINE_THICKNESS / 2;
                    }
                    getBottomLineBottomY() {
                        return this.getYForLine(this.getNumLines() - 1) + p.STAVE_LINE_THICKNESS / 2;
                    }
                    setX(t) {
                        const e = t - this.x;
                        this.formatted = !1, this.x = t, this.start_x += e, this.end_x += e;
                        for(let t = 0; t < this.modifiers.length; t++){
                            const i = this.modifiers[t];
                            void 0 !== i.x && (i.x += e);
                        }
                        return this;
                    }
                    setWidth(t) {
                        return this.formatted = !1, this.width = t, this.end_x = this.x + t, this;
                    }
                    getWidth() {
                        return this.width;
                    }
                    getStyle() {
                        return {
                            fillStyle: this.options.fill_style,
                            strokeStyle: this.options.fill_style,
                            lineWidth: p.STAVE_LINE_THICKNESS,
                            ...this.style || {}
                        };
                    }
                    setMeasure(t) {
                        return this.measure = t, this;
                    }
                    getModifierXShift(t = 0) {
                        if ("number" != typeof t) throw new s.RERR("InvalidIndex", "Must be of number type");
                        if (this.formatted || this.format(), 1 === this.getModifiers(Et.Position.BEGIN).length) return 0;
                        let e = this.start_x - this.x;
                        const i = this.modifiers[0];
                        return i.getType() === xt.type.REPEAT_BEGIN && e > i.getWidth() && (e -= i.getWidth()), e;
                    }
                    setRepetitionTypeLeft(t, e) {
                        return this.modifiers.push(new vt(t, this.x, e)), this;
                    }
                    setRepetitionTypeRight(t, e) {
                        return this.modifiers.push(new vt(t, this.x, e)), this;
                    }
                    setVoltaType(t, e, i) {
                        return this.modifiers.push(new It(t, e, this.x, i)), this;
                    }
                    setSection(t, e, i = 0, s = 12, n) {
                        const r = new Tt(t, this.x + i, e);
                        return r.font.size = s, r.minBottomY = n, this.modifiers.push(r), this;
                    }
                    setTempo(t, e) {
                        return this.modifiers.push(new _t(t, this.x, e)), this;
                    }
                    setText(t, e, i) {
                        return this.modifiers.push(new Pt(t, e, i)), this;
                    }
                    getHeight() {
                        return this.height;
                    }
                    getSpacingBetweenLines() {
                        return this.options.spacing_between_lines_px;
                    }
                    getBoundingBox() {
                        return new c(this.x, this.y, this.width, this.getBottomY() - this.y);
                    }
                    getBottomY() {
                        const t = this.options, e = t.spacing_between_lines_px;
                        return this.getYForLine(t.num_lines) + t.space_below_staff_ln * e;
                    }
                    getBottomLineY() {
                        return this.getYForLine(this.options.num_lines);
                    }
                    getYForLine(t) {
                        const e = this.options, i = e.spacing_between_lines_px, s = e.space_above_staff_ln;
                        return this.y + t * i + s * i;
                    }
                    getLineForY(t) {
                        const e = this.options, i = e.spacing_between_lines_px, s = e.space_above_staff_ln;
                        return (t - this.y) / i - s;
                    }
                    getYForTopText(t) {
                        const e = t || 0;
                        return this.getYForLine(-e - this.options.top_text_position);
                    }
                    getYForBottomText(t) {
                        const e = t || 0;
                        return this.getYForLine(this.options.bottom_text_position + e);
                    }
                    getYForNote(t) {
                        const e = this.options, i = e.spacing_between_lines_px, s = e.space_above_staff_ln;
                        return this.y + s * i + 5 * i - t * i;
                    }
                    getYForGlyphs() {
                        return this.getYForLine(3);
                    }
                    addModifier(t, e) {
                        return void 0 !== e && t.setPosition(e), t.setStave(this), this.formatted = !1, this.modifiers.push(t), this;
                    }
                    addEndModifier(t) {
                        return this.addModifier(t, Et.Position.END), this;
                    }
                    setBegBarType(t) {
                        const { SINGLE: e, REPEAT_BEGIN: i, NONE: s } = xt.type;
                        return t !== e && t !== i && t !== s || (this.modifiers[0].setType(t), this.formatted = !1), this;
                    }
                    setEndBarType(t) {
                        return t !== xt.type.REPEAT_BEGIN && (this.modifiers[1].setType(t), this.formatted = !1), this;
                    }
                    setClef(t, e, i, s) {
                        void 0 === s && (s = Et.Position.BEGIN), s === Et.Position.END ? this.endClef = t : this.clef = t;
                        const n = this.getModifiers(s, Lt.CATEGORY);
                        return 0 === n.length ? this.addClef(t, e, i, s) : n[0].setType(t, e, i), this;
                    }
                    setEndClef(t, e, i) {
                        return this.setClef(t, e, i, Et.Position.END), this;
                    }
                    setKeySignature(t, e, i) {
                        void 0 === i && (i = Et.Position.BEGIN);
                        const s = this.getModifiers(i, wt.CATEGORY);
                        return 0 === s.length ? this.addKeySignature(t, e, i) : s[0].setKeySig(t, e), this;
                    }
                    setEndKeySignature(t, e) {
                        return this.setKeySignature(t, e, Et.Position.END), this;
                    }
                    setTimeSignature(t, e, i) {
                        void 0 === i && (i = Et.Position.BEGIN);
                        const s = this.getModifiers(i, At.CATEGORY);
                        return 0 === s.length ? this.addTimeSignature(t, e, i) : s[0].setTimeSig(t), this;
                    }
                    setEndTimeSignature(t, e) {
                        return this.setTimeSignature(t, e, Et.Position.END), this;
                    }
                    addKeySignature(t, e, i) {
                        return void 0 === i && (i = Et.Position.BEGIN), this.addModifier(new wt(t, e).setPosition(i), i), this;
                    }
                    addClef(t, e, i, s) {
                        return void 0 === s || s === Et.Position.BEGIN ? this.clef = t : s === Et.Position.END && (this.endClef = t), this.addModifier(new Lt(t, e, i), s), this;
                    }
                    addEndClef(t, e, i) {
                        return this.addClef(t, e, i, Et.Position.END), this;
                    }
                    addTimeSignature(t, e, i) {
                        return this.addModifier(new At(t, e), i), this;
                    }
                    addEndTimeSignature(t, e) {
                        return this.addTimeSignature(t, e, Et.Position.END), this;
                    }
                    addTrebleGlyph() {
                        return this.addClef("treble"), this;
                    }
                    getModifiers(t, e) {
                        return void 0 === t && void 0 === e ? this.modifiers : this.modifiers.filter((i)=>!(void 0 !== t && t !== i.getPosition() || void 0 !== e && e !== i.getCategory()));
                    }
                    sortByCategory(t, e) {
                        for(let i = t.length - 1; i >= 0; i--)for(let s = 0; s < i; s++)if (e[t[s].getCategory()] > e[t[s + 1].getCategory()]) {
                            const e = t[s];
                            t[s] = t[s + 1], t[s + 1] = e;
                        }
                    }
                    format() {
                        const t = this.modifiers[0], e = this.modifiers[1], i = this.getModifiers(Et.Position.BEGIN), s = this.getModifiers(Et.Position.END);
                        let n, r, o;
                        this.sortByCategory(i, {
                            barlines: 0,
                            clefs: 1,
                            keysignatures: 2,
                            timesignatures: 3
                        }), this.sortByCategory(s, {
                            timesignatures: 0,
                            keysignatures: 1,
                            barlines: 2,
                            clefs: 3
                        }), i.length > 1 && t.getType() === xt.type.REPEAT_BEGIN && (i.push(i.splice(0, 1)[0]), i.splice(0, 0, new xt(xt.type.SINGLE))), s.indexOf(e) > 0 && s.splice(0, 0, new xt(xt.type.NONE));
                        let a = 0, l = this.x;
                        for(let t = 0; t < i.length; t++){
                            o = i[t], r = o.getPadding(t + a), n = o.getWidth(), isNaN(n) && (o.setWidth(10), n = 10), l += r;
                            const e = o.getX();
                            e > l ? l = e : o.setX(l), l += n, r + n === 0 && a--;
                        }
                        l > this.start_x && this.setStartX(l), l = this.x + this.width;
                        const h = {
                            left: 0,
                            right: 0,
                            paddingRight: 0,
                            paddingLeft: 0
                        };
                        let c = 0;
                        for(let t = 0; t < s.length; t++){
                            o = s[t], c = "barlines" === o.getCategory() ? t : c, h.right = 0, h.left = 0, h.paddingRight = 0, h.paddingLeft = 0;
                            const e = o.getLayoutMetrics();
                            e ? (0 !== t && (h.right = e.xMax || 0, h.paddingRight = e.paddingRight || 0), h.left = -e.xMin || 0, h.paddingLeft = e.paddingLeft || 0, t === s.length - 1 && (h.paddingLeft = 0)) : (h.paddingRight = o.getPadding(t - c) || 0, 0 !== t && (h.right = o.getWidth() || 0), 0 === t && (h.left = o.getWidth() || 0)), l -= h.paddingRight, l -= h.right, o.setX(l), l -= h.left, l -= h.paddingLeft;
                        }
                        this.end_x = 1 === s.length ? this.x + this.width : l, this.formatted = !0;
                    }
                    draw() {
                        this.checkContext(), this.setRendered(), this.formatted || this.format();
                        const t = this.options.num_lines, e = this.width, i = this.x;
                        let s;
                        for(let n = 0; n < t; n++)s = this.getYForLine(n), this.applyStyle(), this.options.line_config[n].visible && (this.context.beginPath(), this.context.moveTo(i, s), this.context.lineTo(i + e, s), this.context.stroke()), this.restoreStyle();
                        for(let t = 0; t < this.modifiers.length; t++)"function" == typeof this.modifiers[t].draw && (this.modifiers[t].applyStyle(this.context), this.modifiers[t].draw(this, this.getModifierXShift(t)), this.modifiers[t].restoreStyle(this.context));
                        if (this.measure > 0) {
                            this.context.save(), this.context.setFont(this.font.family, this.font.size, this.font.weight);
                            const t = this.context.measureText("" + this.measure).width;
                            s = this.getYForTopText(0) + 3, this.context.fillText("" + this.measure, this.x - t / 2, s), this.context.restore();
                        }
                        return this;
                    }
                    drawVertical(t, e) {
                        this.drawVerticalFixed(this.x + t, e);
                    }
                    drawVerticalFixed(t, e) {
                        this.checkContext();
                        const i = this.getYForLine(0), s = this.getYForLine(this.options.num_lines - 1);
                        e && this.context.fillRect(t - 3, i, 1, s - i + 1), this.context.fillRect(t, i, 1, s - i + 1);
                    }
                    drawVerticalBar(t) {
                        this.drawVerticalBarFixed(this.x + t, !1);
                    }
                    drawVerticalBarFixed(t) {
                        this.checkContext();
                        const e = this.getYForLine(0), i = this.getYForLine(this.options.num_lines - 1);
                        this.context.fillRect(t, e, 1, i - e + 1);
                    }
                    getConfigForLines() {
                        return this.options.line_config;
                    }
                    setConfigForLine(t, e) {
                        if (t >= this.options.num_lines || t < 0) throw new s.RERR("StaveConfigError", "The line number must be within the range of the number of lines in the Stave.");
                        if (void 0 === e.visible) throw new s.RERR("StaveConfigError", "The line configuration object is missing the 'visible' property.");
                        if ("boolean" != typeof e.visible) throw new s.RERR("StaveConfigError", "The line configuration objects 'visible' property must be true or false.");
                        return this.options.line_config[t] = e, this;
                    }
                    setConfigForLines(t) {
                        if (t.length !== this.options.num_lines) throw new s.RERR("StaveConfigError", "The length of the lines configuration array must match the number of lines in the Stave");
                        for(const e in t)t[e] || (t[e] = this.options.line_config[e]), s.Merge(this.options.line_config[e], t[e]);
                        return this.options.line_config = t, this;
                    }
                }
                class Nt extends Rt {
                    constructor(t, e, i, n){
                        const r = {
                            spacing_between_lines_px: 13,
                            num_lines: 6,
                            top_text_position: 1
                        };
                        s.Merge(r, n), super(t, e, i, r), this.setAttribute("type", "TabStave");
                    }
                    getYForGlyphs() {
                        return this.getYForLine(2.5);
                    }
                    addTabGlyph() {
                        return this.addClef("tab"), this;
                    }
                }
                class Ct extends B {
                    static get CATEGORY() {
                        return "tabnotes";
                    }
                    constructor(t, e){
                        if (super(t), this.setAttribute("type", "TabNote"), this.ghost = !1, this.positions = t.positions, s.Merge(this.render_options, {
                            glyph_font_scale: p.DEFAULT_TABLATURE_FONT_SCALE,
                            draw_stem: e,
                            draw_dots: e,
                            draw_stem_through_stave: !1,
                            y_shift: 0,
                            scale: 1,
                            font: "10pt Arial"
                        }), this.glyph = p.getGlyphProps(this.duration, this.noteType), !this.glyph) throw new s.RuntimeError("BadArguments", `Invalid note initialization data (No glyph found): ${JSON.stringify(t)}`);
                        this.buildStem(), t.stem_direction ? this.setStemDirection(t.stem_direction) : this.setStemDirection(v.UP), this.ghost = !1, this.updateWidth();
                    }
                    reset() {
                        this.stave && this.setStave(this.stave);
                    }
                    getCategory() {
                        return Ct.CATEGORY;
                    }
                    setGhost(t) {
                        return this.ghost = t, this.updateWidth(), this;
                    }
                    hasStem() {
                        return this.render_options.draw_stem;
                    }
                    getStemExtension() {
                        const t = this.getGlyph();
                        return null != this.stem_extension_override ? this.stem_extension_override : t ? 1 === this.getStemDirection() ? t.tabnote_stem_up_extension : t.tabnote_stem_down_extension : 0;
                    }
                    addDot() {
                        const t = new O;
                        return this.dots += 1, this.addModifier(t, 0);
                    }
                    updateWidth() {
                        this.glyphs = [], this.width = 0;
                        for(let t = 0; t < this.positions.length; ++t){
                            let e = this.positions[t].fret;
                            this.ghost && (e = "(" + e + ")");
                            const i = this.render_options.fretScale ?? this.render_options.scale, s = p.tabToGlyph(e, i, this.render_options.TabUseXNoteheadAlternativeGlyph);
                            "x" === e && (s.isXGlyph = !0), this.glyphs.push(s), this.width = Math.max(s.getWidth(), this.width);
                        }
                        this.glyph.getWidth = ()=>this.width;
                    }
                    setStave(t) {
                        let e;
                        if (super.setStave(t), this.context = t.context, this.context) {
                            const t = this.context;
                            for(this.width = 0, e = 0; e < this.glyphs.length; ++e){
                                const i = this.glyphs[e], s = "" + i.text;
                                "X" !== s.toUpperCase() && (t.save(), t.setRawFont(this.render_options.font), i.width = t.measureText(s).width, t.restore(), i.getWidth = ()=>i.width), this.width = Math.max(i.getWidth(), this.width);
                            }
                            this.glyph.getWidth = ()=>this.width;
                        }
                        const i = this.positions.map(({ str: e })=>t.getYForLine(e - 1));
                        return this.setYs(i), this.stem && this.stem.setYBounds(this.getStemY(), this.getStemY()), this;
                    }
                    getPositions() {
                        return this.positions;
                    }
                    addToModifierContext(t) {
                        this.setModifierContext(t);
                        for(let t = 0; t < this.modifiers.length; ++t)this.modifierContext.addModifier(this.modifiers[t]);
                        return this.modifierContext.addModifier(this), this.preFormatted = !1, this;
                    }
                    getTieRightX() {
                        let t = this.getAbsoluteX();
                        return t += this.glyph.getWidth() / 2, t += -this.width / 2 + this.width + 2, t;
                    }
                    getTieLeftX() {
                        let t = this.getAbsoluteX();
                        return t += this.glyph.getWidth() / 2, t -= this.width / 2 + 2, t;
                    }
                    getModifierStartXY(t, e) {
                        if (!this.preFormatted) throw new s.RERR("UnformattedNote", "Can't call GetModifierStartXY on an unformatted note");
                        if (0 === this.ys.length) throw new s.RERR("NoYValues", "No Y-Values calculated for this note.");
                        let i = 0;
                        return t === D.Position.LEFT ? i = -2 : t === D.Position.RIGHT ? i = this.width + 2 : t !== D.Position.BELOW && t !== D.Position.ABOVE || (i = this.glyph.getWidth() / 2), {
                            x: this.getAbsoluteX() + i,
                            y: this.ys[e]
                        };
                    }
                    getLineForRest() {
                        return this.positions[0].str;
                    }
                    preFormat() {
                        this.preFormatted || (this.modifierContext && this.modifierContext.preFormat(), this.setPreFormatted(!0));
                    }
                    getStemX() {
                        return this.getCenterGlyphX();
                    }
                    getStemY() {
                        const t = this.stave.getNumLines() - .5, e = v.UP === this.stem_direction ? -0.5 : t;
                        return this.stave.getYForLine(e);
                    }
                    getStemExtents() {
                        return this.stem.getExtents();
                    }
                    drawFlag() {
                        const { beam: t, glyph: e, context: i, stem: s, stem_direction: n, render_options: { draw_stem: r, glyph_font_scale: o } } = this, a = null == t && r;
                        if (e.flag && a) {
                            const t = this.getStemX() + 1, r = this.getStemY() - s.getHeight(), a = n === v.DOWN ? e.code_flag_downstem : e.code_flag_upstem;
                            m.renderGlyph(i, t, r, o, a);
                        }
                    }
                    drawModifiers() {
                        this.modifiers.forEach((t)=>{
                            ("dots" !== t.getCategory() || this.render_options.draw_dots) && (t.setContext(this.context), t.drawWithStyle());
                        });
                    }
                    drawStemThrough() {
                        const t = this.getStemX(), e = this.getStemY(), i = this.context, s = this.render_options.draw_stem_through_stave;
                        if (this.render_options.draw_stem && s) {
                            const s = function(t, e) {
                                const i = [];
                                let s = [];
                                for(let n = 1; n <= t; n++)e.indexOf(n) > -1 ? (i.push(s), s = []) : s.push(n);
                                return s.length > 0 && i.push(s), i;
                            }(this.stave.getNumLines(), this.positions.map((t)=>t.str)), n = function(t, e, i, s) {
                                const n = 1 !== s, r = -1 !== s, o = i.getSpacingBetweenLines(), a = i.getNumLines(), l = [];
                                return e.forEach((e)=>{
                                    const h = e.indexOf(a) > -1, c = e.indexOf(1) > -1;
                                    if (n && c || r && h) return;
                                    1 === e.length && e.push(e[0]);
                                    const u = [];
                                    e.forEach((e, n, r)=>{
                                        const l = 1 === e, h = e === a;
                                        let c = i.getYForLine(e - 1);
                                        0 !== n || l ? n !== r.length - 1 || h || (c += o / 2 - 1) : c -= o / 2 - 1, u.push(c), 1 === s && l ? u.push(t - 2) : -1 === s && h && u.push(t + 2);
                                    }), l.push(u.sort((t, e)=>t - e));
                                }), l;
                            }(e, s, this.getStave(), this.getStemDirection());
                            i.save(), i.setLineWidth(v.WIDTH), n.forEach((e)=>{
                                0 !== e.length && (i.beginPath(), i.moveTo(t, e[0]), i.lineTo(t, e[e.length - 1]), i.stroke(), i.closePath());
                            }), i.restore();
                        }
                    }
                    drawPositions() {
                        const t = this.context, e = this.getAbsoluteX(), i = this.ys;
                        for(let s = 0; s < this.positions.length; ++s){
                            const n = i[s] + this.render_options.y_shift, r = this.glyphs[s];
                            let o = r.getWidth();
                            0 === o && r.text?.toString()?.length && (o = 7 * r.text.toString().length);
                            let a = this.glyph.getWidth();
                            0 === a && (a = o);
                            const l = e + a / 2 - o / 2;
                            if (this.BackgroundColor ? (t.save(), t.setFillStyle(this.BackgroundColor), t.setLineWidth(0), t.fillRect(l - 2, n - 3, o + 4, 6), t.restore()) : t.clearRect(l - 2, n - 3, o + 4, 6), r.code) m.renderGlyph(t, l, n, this.render_options.glyph_font_scale * this.render_options.scale, r.code);
                            else {
                                t.save(), t.setRawFont(this.render_options.font);
                                const e = r.text.toString();
                                t.fillText(e, l, n + 5 * this.render_options.scale), t.restore();
                            }
                        }
                    }
                    draw() {
                        if (this.checkContext(), !this.stave) throw new s.RERR("NoStave", "Can't draw without a stave.");
                        if (0 === this.ys.length) throw new s.RERR("NoYValues", "Can't draw note without Y values.");
                        this.setRendered();
                        const t = null == this.beam && this.render_options.draw_stem;
                        this.setAttribute("el", this.context.openGroup("tabnote", this.getAttribute("id"), {
                            pointerBBox: !0
                        })), this.drawPositions(), this.drawStemThrough();
                        const e = this.getStemX();
                        this.stem.setNoteHeadXBounds(e, e), t && (this.context.openGroup("stem", null, {
                            pointerBBox: !0
                        }), this.stem.setContext(this.context).draw(), this.context.closeGroup()), this.drawFlag(), this.drawModifiers(), this.context.closeGroup();
                    }
                }
                class Bt extends l {
                    constructor(t){
                        super(), this.setAttribute("type", "VibratoBracket"), this.start = t.start, this.stop = t.stop, this.toEndOfStopStave = t.toEndOfStopStave, this.stopBeforeNote = t.stopBeforeNote, this.line = 1, this.render_options = {
                            harsh: !1,
                            wave_height: 6,
                            wave_width: 4,
                            wave_girth: 2
                        };
                    }
                    setLine(t) {
                        return this.line = t, this;
                    }
                    setHarsh(t) {
                        return this.render_options.harsh = t, this;
                    }
                    draw() {
                        const t = this.context;
                        this.setRendered();
                        const e = this.start ? this.start.getStave().getYForTopText(this.line) : this.stop.getStave().getYForTopText(this.line);
                        let i = 0;
                        if (this.start) {
                            let t = 0;
                            for (const e of this.start.modifiers)if (e && "tr" === e.type) {
                                t = e.glyph.bbox.w;
                                break;
                            }
                            i = this.start.getNoteHeadBeginX ? this.start.getNoteHeadBeginX() : this.start.getAbsoluteX(), i += t;
                        } else i = this.stop.getStave().getTieStartX();
                        let n = 0;
                        if (this.stop) {
                            if (this.toEndOfStopStave) n = this.stop.getStave().getTieEndX() - 10;
                            else if (this.stopBeforeNote) {
                                const t = this.stopBeforeNote.getMetrics();
                                n = this.stopBeforeNote.getAbsoluteX() - t.modLeftPx - t.extraLeftPx - 5;
                            } else {
                                const t = this.stop.getMetrics();
                                n = this.stop.getAbsoluteX() + this.stop.getWidth() - t.modLeftPx - t.extraLeftPx;
                            }
                        } else n = this.start.getStave().getTieEndX() - 10;
                        this.render_options.vibrato_width = n - i, function(...t) {
                            Bt.DEBUG && s.L("Vex.Flow.VibratoBracket", t);
                        }("Rendering VibratoBracket: start_x:", i, "stop_x:", n, "y:", e), mt.renderVibrato(t, i, e, this.render_options);
                    }
                }
                let Dt;
                function Ot() {
                    if (!Dt) {
                        const t = new C({
                            duration: "w",
                            note_type: "r"
                        });
                        Dt = {
                            glyph_font_scale: t.render_options.glyph_font_scale,
                            glyph_code: t.glyph_code,
                            width: t.getWidth()
                        };
                    }
                    return Dt;
                }
                class Ft extends l {
                    constructor(t, e){
                        super(), this.setAttribute("type", "MultiMeasureRest"), this.render_options = {
                            show_number: !0,
                            number_line: -0.5,
                            number_glyph_point: 40,
                            padding_left: void 0,
                            padding_right: void 0,
                            line: 2,
                            spacing_between_lines_px: 10,
                            line_thickness: void 0,
                            serif_thickness: 2,
                            use_symbols: !1,
                            symbol_spacing: void 0,
                            semibrave_rest_glyph_scale: p.DEFAULT_NOTATION_FONT_SCALE
                        }, s.Merge(this.render_options, e), this.number_of_measures = t, this.xs = {
                            left: NaN,
                            right: NaN
                        };
                    }
                    getXs() {
                        return this.xs;
                    }
                    setStave(t) {
                        return this.stave = t, this;
                    }
                    getStave() {
                        return this.stave;
                    }
                    drawLine(t, e, i, s) {
                        const n = this.stave.getYForLine(this.render_options.line), r = .1 * (i - e);
                        e += r, i -= r;
                        const o = this.render_options.serif_thickness;
                        let a = .25 * s;
                        isNaN(this.render_options.line_thickness) || (a = .5 * this.render_options.line_thickness), t.save(), t.beginPath(), t.moveTo(e, n - s), t.lineTo(e + o, n - s), t.lineTo(e + o, n - a), t.lineTo(i - o, n - a), t.lineTo(i - o, n - s), t.lineTo(i, n - s), t.lineTo(i, n + s), t.lineTo(i - o, n + s), t.lineTo(i - o, n + a), t.lineTo(e + o, n + a), t.lineTo(e + o, n + s), t.lineTo(e, n + s), t.closePath(), t.fill();
                    }
                    drawSymbols(t, e, i, s) {
                        const n = Math.floor(this.number_of_measures / 4), r = this.number_of_measures % 4, o = Math.floor(r / 2), a = r % 2, l = Ot(), h = l.width * (this.render_options.semibrave_rest_glyph_scale / l.glyph_font_scale), c = {
                            2: {
                                width: .5 * h,
                                height: s
                            },
                            1: {
                                width: h
                            }
                        };
                        let u = 1.35 * h;
                        isNaN(this.render_options.symbol_spacing) || (u = this.render_options.symbol_spacing);
                        let d = e + .5 * (i - e) - .5 * (n * c[2].width + o * c[2].width + a * c[1].width + (n + o + a - 1) * u);
                        const f = this.stave.getYForLine(this.render_options.line - 1), p = this.stave.getYForLine(this.render_options.line), g = this.stave.getYForLine(this.render_options.line + 1);
                        t.save(), t.setStrokeStyle("none"), t.setLineWidth(0);
                        for(let e = 0; e < n; ++e)t.fillRect(d, p - c[2].height, c[2].width, c[2].height), t.fillRect(d, g - c[2].height, c[2].width, c[2].height), d += c[2].width + u;
                        for(let e = 0; e < o; ++e)t.fillRect(d, p - c[2].height, c[2].width, c[2].height), d += c[2].width + u;
                        for(let e = 0; e < a; ++e)m.renderGlyph(t, d, f, this.render_options.semibrave_rest_glyph_scale, l.glyph_code), d += c[1].width + u;
                        t.restore();
                    }
                    draw() {
                        this.checkContext(), this.setRendered();
                        const t = this.context, e = this.stave, i = this.render_options.spacing_between_lines_px;
                        let s = e.getNoteStartX(), n = e.getNoteEndX();
                        const r = e.getModifiers(Et.Position.BEGIN);
                        1 === r.length && "barlines" === r[0].getCategory() && (s -= r[0].getWidth());
                        const o = e.getModifiers(Et.Position.END);
                        if (o.length >= 1 && "barlines" === o[0].getCategory() && (n -= o[0].getPadding()), isNaN(this.render_options.padding_left) || (s = e.getX() + this.render_options.padding_left), isNaN(this.render_options.padding_right) || (n = e.getX() + e.getWidth() - this.render_options.padding_right), this.xs.left = s, this.xs.right = n, this.render_options.use_symbols ? this.drawSymbols(t, s, n, i) : this.drawLine(t, s, n, i), this.render_options.show_number) {
                            const i = "/" + this.number_of_measures, r = new At(null, void 0, !1);
                            r.point = this.render_options.number_glyph_point, r.setTimeSig(i), r.setStave(e), r.x = s + .5 * (n - s) - .5 * r.timeSig.glyph.getMetrics().width, r.bottomLine = this.render_options.number_line, r.setContext(t).draw();
                        }
                    }
                }
                class kt extends N {
                    static get CATEGORY() {
                        return "clefnote";
                    }
                    constructor(t, e, i){
                        super({
                            duration: "b"
                        }), this.setAttribute("type", "ClefNote"), this.setType(t, e, i), this.ignore_ticks = !0;
                    }
                    setType(t, e, i) {
                        return this.type = t, this.clef_obj = new Lt(t, e, i), this.clef = this.clef_obj.clef, this.glyph = new m(this.clef.code, this.clef.point), this.setWidth(this.glyph.getMetrics().width), this;
                    }
                    getClef() {
                        return this.clef;
                    }
                    setContext(t) {
                        return this.context = t, this.glyph.setContext(this.context), this;
                    }
                    getBoundingBox() {
                        return super.getBoundingBox();
                    }
                    addToModifierContext() {
                        return this;
                    }
                    getCategory() {
                        return kt.CATEGORY;
                    }
                    preFormat() {
                        return this.setPreFormatted(!0), this;
                    }
                    draw() {
                        if (!this.stave) throw new s.RERR("NoStave", "Can't draw without a stave.");
                        this.glyph.getContext() || this.glyph.setContext(this.context), this.setRendered();
                        const t = this.getAbsoluteX();
                        if (this.glyph.setStave(this.stave), this.glyph.setYShift(this.stave.getYForLine(this.clef.line) - this.stave.getYForGlyphs()), this.glyph.renderToStave(t), void 0 !== this.clef_obj.annotation) {
                            const e = new m(this.clef_obj.annotation.code, this.clef_obj.annotation.point);
                            e.getContext() || e.setContext(this.context), e.setStave(this.stave), e.setYShift(this.stave.getYForLine(this.clef_obj.annotation.line) - this.stave.getYForGlyphs()), e.setXShift(this.clef_obj.annotation.x_shift), e.renderToStave(t);
                        }
                    }
                }
                class Vt extends N {
                    constructor(t, e, i){
                        super({
                            duration: "b"
                        }), this.setAttribute("type", "KeySigNote"), this.keySignature = new wt(t, e, i), this.ignore_ticks = !0;
                    }
                    getBoundingBox() {
                        return super.getBoundingBox();
                    }
                    addToModifierContext() {
                        return this;
                    }
                    preFormat() {
                        return this.setPreFormatted(!0), this.keySignature.setStave(this.stave), this.keySignature.format(), this.setWidth(this.keySignature.width), this;
                    }
                    draw() {
                        this.stave.checkContext(), this.setRendered(), this.keySignature.x = this.getAbsoluteX(), this.keySignature.setContext(this.context), this.keySignature.draw();
                    }
                }
                class Gt extends N {
                    constructor(t, e){
                        super({
                            duration: "b"
                        }), this.setAttribute("type", "TimeSigNote");
                        const i = new At(t, e);
                        this.timeSig = i.getTimeSig(), this.setWidth(this.timeSig.glyph.getMetrics().width), this.ignore_ticks = !0;
                    }
                    getBoundingBox() {
                        return super.getBoundingBox();
                    }
                    addToModifierContext() {
                        return this;
                    }
                    preFormat() {
                        return this.setPreFormatted(!0), this;
                    }
                    draw() {
                        this.stave.checkContext(), this.setRendered(), this.timeSig.glyph.getContext() || this.timeSig.glyph.setContext(this.context), this.timeSig.glyph.setStave(this.stave), this.timeSig.glyph.setYShift(this.stave.getYForLine(this.timeSig.line) - this.stave.getYForGlyphs()), this.timeSig.glyph.renderToStave(this.getAbsoluteX());
                    }
                }
                class Wt extends j {
                    static get SLIDE_UP() {
                        return 1;
                    }
                    static get SLIDE_DOWN() {
                        return -1;
                    }
                    static createSlideUp(t) {
                        return new Wt(t, Wt.SLIDE_UP);
                    }
                    static createSlideDown(t) {
                        return new Wt(t, Wt.SLIDE_DOWN);
                    }
                    constructor(t, e){
                        if (super(t, "sl."), this.setAttribute("type", "TabSlide"), !e) {
                            const i = t.first_note.getPositions()[0].fret, s = t.last_note.getPositions()[0].fret;
                            e = parseInt(i, 10) > parseInt(s, 10) ? Wt.SLIDE_DOWN : Wt.SLIDE_UP;
                        }
                        this.slide_direction = e, this.render_options.cp1 = 11, this.render_options.cp2 = 14, this.render_options.y_shift = .5, this.setFont({
                            family: "Times",
                            size: 10,
                            style: "bold italic"
                        }), this.setNotes(t);
                    }
                    renderTie(t) {
                        if (0 === t.first_ys.length || 0 === t.last_ys.length) throw new s.RERR("BadArguments", "No Y-values to render");
                        const e = this.context, i = t.first_x_px, n = t.first_ys, r = t.last_x_px, o = this.slide_direction;
                        if (o !== Wt.SLIDE_UP && o !== Wt.SLIDE_DOWN) throw new s.RERR("BadSlide", "Invalid slide direction");
                        for(let t = 0; t < this.first_indices.length; ++t){
                            const a = n[this.first_indices[t]] + this.render_options.y_shift;
                            if (isNaN(a)) throw new s.RERR("BadArguments", "Bad indices for slide rendering.");
                            e.beginPath(), e.moveTo(i, a + 3 * o), e.lineTo(r, a - 3 * o), e.closePath(), e.stroke();
                        }
                        this.setRendered();
                    }
                }
                class Ut extends V {
                    static get CATEGORY() {
                        return "gracenotes";
                    }
                    static get LEDGER_LINE_OFFSET() {
                        return 2;
                    }
                    static get SCALE() {
                        return .66;
                    }
                    constructor(t){
                        super(Object.assign(t, {
                            glyph_font_scale: p.DEFAULT_NOTATION_FONT_SCALE * Ut.SCALE,
                            stroke_px: Ut.LEDGER_LINE_OFFSET
                        })), this.setAttribute("type", "GraceNote"), this.slash = t.slash, this.slur = !0, this.buildNoteHeads(), this.width = 3;
                    }
                    getStemExtension() {
                        if (null != this.stem_extension_override) return this.stem_extension_override;
                        const t = this.getGlyph();
                        if (t) {
                            let e = super.getStemExtension();
                            if (t.stem) {
                                const t = this.getStaveNoteScale();
                                e = (v.HEIGHT + e) * t - v.HEIGHT;
                            }
                            return e;
                        }
                        return 0;
                    }
                    getCategory() {
                        return Ut.CATEGORY;
                    }
                    getStaveNoteScale() {
                        return this.render_options.glyph_font_scale / p.DEFAULT_NOTATION_FONT_SCALE;
                    }
                    draw() {
                        super.draw(), this.setRendered();
                        const t = this.stem;
                        if (this.slash && t) {
                            const e = this.getStaveNoteScale(), i = e / .66;
                            let s;
                            const n = this.beam;
                            if (n) n.postFormatted || n.postFormat(), s = this.calcBeamedNotesSlashBBox(8 * i, 8 * i, {
                                stem: 6 * i,
                                beam: 5 * i
                            });
                            else {
                                const n = this.getStemDirection(), r = this.getNoteHeadBounds(), o = t.getHeight();
                                let a = this.getAbsoluteX(), l = n === p.Stem.DOWN ? r.y_top - o : r.y_bottom - o;
                                const h = n === p.Stem.DOWN ? this.glyph.stem_down_extension : this.glyph.stem_up_extension;
                                let c = p.STEM_HEIGHT;
                                c -= c / 2.8, c += h, l += c * e * n;
                                const u = n === p.Stem.UP ? {
                                    x1: 1,
                                    y1: 0,
                                    x2: 13,
                                    y2: -9
                                } : {
                                    x1: -4,
                                    y1: 1,
                                    x2: 13,
                                    y2: 9
                                };
                                a += u.x1 * i, l += u.y1 * i, s = {
                                    x1: a,
                                    y1: l,
                                    x2: a + u.x2 * i,
                                    y2: l + u.y2 * i
                                };
                            }
                            const r = this.context;
                            r.save(), r.setLineWidth(1 * i), r.beginPath(), r.moveTo(s.x1, s.y1), r.lineTo(s.x2, s.y2), r.closePath(), r.stroke(), r.restore();
                        }
                    }
                    calcBeamedNotesSlashBBox(t, e, i) {
                        const s = this.beam, n = s.slope, r = s.notes[s.notes.length - 1] === this ? -1 : 1, o = Math.atan(n * r), a = Math.cos(o) * e, l = Math.sin(o) * e;
                        t *= this.getStemDirection();
                        const h = Math.atan((l - t) / a), c = Math.cos(h) * i.stem * r, u = Math.sin(h) * i.stem, d = Math.cos(h) * i.beam * r, f = Math.sin(h) * i.beam, m = this.getStemX(), p = s.notes[0].getStemX(), g = this.beam.getBeamYToDraw() + (m - p) * n;
                        return {
                            x1: m - c,
                            y1: g + t - u,
                            x2: m + a * r + d,
                            y2: g + l + f
                        };
                    }
                }
                class zt extends Ct {
                    static get CATEGORY() {
                        return "gracetabnotes";
                    }
                    constructor(t){
                        super(t, !1), this.setAttribute("type", "GraceTabNote"), s.Merge(this.render_options, {
                            y_shift: .3,
                            scale: .6,
                            font: "7.5pt Arial"
                        }), this.updateWidth();
                    }
                    getCategory() {
                        return zt.CATEGORY;
                    }
                    draw() {
                        super.draw(), this.setRendered();
                    }
                }
                class Ht {
                    static get names() {
                        return {
                            standard: "E/5,B/4,G/4,D/4,A/3,E/3",
                            dagdad: "D/5,A/4,G/4,D/4,A/3,D/3",
                            dropd: "E/5,B/4,G/4,D/4,A/3,D/3",
                            eb: "Eb/5,Bb/4,Gb/4,Db/4,Ab/3,Db/3",
                            standardBanjo: "D/5,B/4,G/4,D/4,G/5"
                        };
                    }
                    constructor(t = "E/5,B/4,G/4,D/4,A/3,E/3,B/2,E/2"){
                        this.setTuning(t);
                    }
                    noteToInteger(t) {
                        return p.keyProperties(t).int_value;
                    }
                    setTuning(t) {
                        Ht.names[t] && (t = Ht.names[t]), this.tuningString = t, this.tuningValues = [], this.numStrings = 0;
                        const e = t.split(/\s*,\s*/);
                        if (0 === e.length) throw new s.RERR("BadArguments", "Invalid tuning string: " + t);
                        this.numStrings = e.length;
                        for(let t = 0; t < this.numStrings; ++t)this.tuningValues[t] = this.noteToInteger(e[t]);
                    }
                    getValueForString(t) {
                        const e = parseInt(t, 10);
                        if (e < 1 || e > this.numStrings) throw new s.RERR("BadArguments", `String number must be between 1 and ${this.numStrings}:${t}`);
                        return this.tuningValues[e - 1];
                    }
                    getValueForFret(t, e) {
                        const i = this.getValueForString(e), n = parseInt(t, 10);
                        if (n < 0) throw new s.RERR("BadArguments", "Fret number must be 0 or higher: " + t);
                        return i + n;
                    }
                    getNoteForFret(t, e) {
                        const i = this.getValueForFret(t, e), s = Math.floor(i / 12), n = i % 12;
                        return p.integerToNote(n) + "/" + s;
                    }
                }
                class Xt extends l {
                    static get type() {
                        return {
                            CRESC: 1,
                            DECRESC: 2
                        };
                    }
                    static FormatByTicksAndDraw(t, e, i, n, r, o) {
                        const a = e.pixelsPerTick;
                        if (null == a) throw new s.RuntimeError("BadArguments", "A valid Formatter must be provide to draw offsets by ticks.");
                        const l = a * o.left_shift_ticks, h = a * o.right_shift_ticks, c = {
                            height: o.height,
                            y_shift: o.y_shift,
                            left_shift_px: l,
                            right_shift_px: h
                        };
                        new Xt({
                            first_note: i.first_note,
                            last_note: i.last_note
                        }, n).setContext(t).setRenderOptions(c).setPosition(r).draw();
                    }
                    constructor(t, e){
                        super(), this.setAttribute("type", "StaveHairpin"), this.notes = t, this.hairpin = e, this.position = D.Position.BELOW, this.render_options = {
                            height: 10,
                            y_shift: 0,
                            left_shift_px: 0,
                            right_shift_px: 0
                        }, this.setNotes(t);
                    }
                    setPosition(t) {
                        return t !== D.Position.ABOVE && t !== D.Position.BELOW || (this.position = t), this;
                    }
                    setRenderOptions(t) {
                        return null != t.height && null != t.y_shift && null != t.left_shift_px && null != t.right_shift_px && (this.render_options = t), this;
                    }
                    setNotes(t) {
                        if (!t.first_note && !t.last_note) throw new s.RuntimeError("BadArguments", "Hairpin needs to have either first_note or last_note set.");
                        return this.first_note = t.first_note, this.last_note = t.last_note, this;
                    }
                    renderHairpin(t) {
                        const e = this.checkContext();
                        let i = this.render_options.y_shift + 20, s = t.first_y;
                        this.position === D.Position.ABOVE && (i = 30 - i, s = t.first_y - t.staff_height);
                        const n = this.render_options.left_shift_px, r = this.render_options.right_shift_px;
                        switch(e.beginPath(), this.hairpin){
                            case Xt.type.CRESC:
                                e.moveTo(t.last_x + r, s + i), e.lineTo(t.first_x + n, s + this.render_options.height / 2 + i), e.lineTo(t.last_x + r, s + this.render_options.height + i);
                                break;
                            case Xt.type.DECRESC:
                                e.moveTo(t.first_x + n, s + i), e.lineTo(t.last_x + r, s + this.render_options.height / 2 + i), e.lineTo(t.first_x + n, s + this.render_options.height + i);
                        }
                        e.stroke(), e.closePath();
                    }
                    draw() {
                        this.checkContext(), this.setRendered();
                        const t = this.first_note, e = this.last_note, i = t.getModifierStartXY(this.position, 0), s = e.getModifierStartXY(this.position, 0);
                        return this.renderHairpin({
                            first_x: i.x,
                            last_x: s.x,
                            first_y: t.getStave().y + t.getStave().height,
                            last_y: e.getStave().y + e.getStave().height,
                            staff_height: t.getStave().height
                        }), !0;
                    }
                }
                class Yt extends l {
                    static get Position() {
                        return {
                            NEAR_HEAD: 1,
                            NEAR_TOP: 2
                        };
                    }
                    static get PositionString() {
                        return {
                            nearHead: Yt.Position.NEAR_HEAD,
                            nearTop: Yt.Position.NEAR_TOP
                        };
                    }
                    constructor(t, e, i){
                        super(), this.setAttribute("type", "Curve"), this.render_options = {
                            spacing: 2,
                            thickness: 2,
                            x_shift: 0,
                            y_shift: 10,
                            position: Yt.Position.NEAR_HEAD,
                            position_end: Yt.Position.NEAR_HEAD,
                            invert: !1,
                            cps: [
                                {
                                    x: 0,
                                    y: 10
                                },
                                {
                                    x: 0,
                                    y: 10
                                }
                            ]
                        }, s.Merge(this.render_options, i), this.setNotes(t, e);
                    }
                    setNotes(t, e) {
                        if (!t && !e) throw new s.RuntimeError("BadArguments", "Curve needs to have either first_note or last_note set.");
                        return this.from = t, this.to = e, this;
                    }
                    isPartial() {
                        return !this.from || !this.to;
                    }
                    renderCurve(t) {
                        const e = this.context, i = this.render_options.cps, s = this.render_options.x_shift, n = this.render_options.y_shift * t.direction, r = t.first_x + s, o = t.first_y + n, a = t.last_x - s, l = t.last_y + n, h = this.render_options.thickness, c = (a - r) / (i.length + 2);
                        e.beginPath(), e.moveTo(r, o), e.bezierCurveTo(r + c + i[0].x, o + i[0].y * t.direction, a - c + i[1].x, l + i[1].y * t.direction, a, l), e.bezierCurveTo(a - c + i[1].x, l + (i[1].y + h) * t.direction, r + c + i[0].x, o + (i[0].y + h) * t.direction, r, o), e.stroke(), e.closePath(), e.fill();
                    }
                    draw() {
                        this.checkContext(), this.setRendered();
                        const t = this.from, e = this.to;
                        let i, s, n, r, o, a = "baseY", l = "baseY";
                        function h(t) {
                            return "string" == typeof t ? Yt.PositionString[t] : t;
                        }
                        const c = h(this.render_options.position), u = h(this.render_options.position_end);
                        return c === Yt.Position.NEAR_TOP && (a = "topY", l = "topY"), u === Yt.Position.NEAR_HEAD ? l = "baseY" : u === Yt.Position.NEAR_TOP && (l = "topY"), t ? (i = t.getTieRightX(), o = t.getStemDirection(), n = t.getStemExtents()[a]) : (i = e.getStave().getTieStartX(), n = e.getStemExtents()[a]), e ? (s = e.getTieLeftX(), o = e.getStemDirection(), r = e.getStemExtents()[l]) : (s = t.getStave().getTieEndX(), r = t.getStemExtents()[l]), this.renderCurve({
                            first_x: i,
                            last_x: s,
                            first_y: n,
                            last_y: r,
                            direction: o * (!0 === this.render_options.invert ? -1 : 1)
                        }), !0;
                    }
                }
                function jt(...t) {
                    Kt.DEBUG && s.L("Vex.Flow.TextDynamics", t);
                }
                class Kt extends N {
                    static get GLYPHS() {
                        return {
                            f: {
                                code: "vba",
                                width: 12
                            },
                            p: {
                                code: "vbf",
                                width: 14
                            },
                            m: {
                                code: "v62",
                                width: 17
                            },
                            s: {
                                code: "v4a",
                                width: 10
                            },
                            z: {
                                code: "v80",
                                width: 12
                            },
                            r: {
                                code: "vb1",
                                width: 12
                            }
                        };
                    }
                    constructor(t){
                        super(t), this.setAttribute("type", "TextDynamics"), this.sequence = t.text.toLowerCase(), this.line = t.line || 0, this.glyphs = [], s.Merge(this.render_options, {
                            glyph_font_size: 40
                        }), jt("New Dynamics Text: ", this.sequence);
                    }
                    setLine(t) {
                        return this.line = t, this;
                    }
                    preFormat() {
                        let t = 0;
                        return this.sequence.split("").forEach((e)=>{
                            const i = Kt.GLYPHS[e];
                            if (!i) throw new s.RERR("Invalid dynamics character: " + e);
                            const n = this.render_options.glyph_font_size, r = new m(i.code, n);
                            this.glyphs.push(r), t += i.width;
                        }), this.setWidth(t), this.preFormatted = !0, this;
                    }
                    draw() {
                        this.setRendered();
                        const t = this.getAbsoluteX(), e = this.stave.getYForLine(this.line + -3);
                        jt("Rendering Dynamics: ", this.sequence);
                        let i = t;
                        this.glyphs.forEach((t, s)=>{
                            const n = this.sequence[s];
                            t.render(this.context, i, e), i += Kt.GLYPHS[n].width;
                        });
                    }
                }
                function qt(t, e, i, s, n, r, o) {
                    t.beginPath(), t.moveTo(e, i), t.lineTo(s, n), t.lineTo(r, o), t.lineTo(e, i), t.closePath(), t.fill();
                }
                class Jt extends l {
                    static get TextVerticalPosition() {
                        return {
                            TOP: 1,
                            BOTTOM: 2
                        };
                    }
                    static get TextJustification() {
                        return {
                            LEFT: 1,
                            CENTER: 2,
                            RIGHT: 3
                        };
                    }
                    constructor(t){
                        super(), this.setAttribute("type", "StaveLine"), this.notes = t, this.text = "", this.font = {
                            family: "Arial",
                            size: 10,
                            weight: ""
                        }, this.render_options = {
                            padding_left: 4,
                            padding_right: 3,
                            line_width: 1,
                            line_dash: null,
                            rounded_end: !0,
                            color: null,
                            draw_start_arrow: !1,
                            draw_end_arrow: !1,
                            arrowhead_length: 10,
                            arrowhead_angle: Math.PI / 8,
                            text_position_vertical: Jt.TextVerticalPosition.TOP,
                            text_justification: Jt.TextJustification.CENTER
                        }, this.setNotes(t);
                    }
                    setFont(t) {
                        return this.font = t, this;
                    }
                    setText(t) {
                        return this.text = t, this;
                    }
                    setNotes(t) {
                        if (!t.first_note && !t.last_note) throw new s.RuntimeError("BadArguments", "Notes needs to have either first_note or last_note set.");
                        if (t.first_indices || (t.first_indices = [
                            0
                        ]), t.last_indices || (t.last_indices = [
                            0
                        ]), t.first_indices.length !== t.last_indices.length) throw new s.RuntimeError("BadArguments", "Connected notes must have similar index sizes");
                        return this.first_note = t.first_note, this.first_indices = t.first_indices, this.last_note = t.last_note, this.last_indices = t.last_indices, this;
                    }
                    applyLineStyle() {
                        const t = this.checkContext(), e = this.render_options;
                        e.line_dash && t.setLineDash(e.line_dash), e.line_width && t.setLineWidth(e.line_width), e.rounded_end ? t.setLineCap("round") : t.setLineCap("square");
                    }
                    applyFontStyle() {
                        const t = this.checkContext();
                        this.font && t.setFont(this.font.family, this.font.size, this.font.weight), this.render_options.color && (t.setStrokeStyle(this.render_options.color), t.setFillStyle(this.render_options.color));
                    }
                    draw() {
                        const t = this.checkContext();
                        this.setRendered();
                        const e = this.first_note, i = this.last_note, s = this.render_options;
                        let n, r;
                        t.save(), this.applyLineStyle(), this.first_indices.forEach((o, a)=>{
                            const l = this.last_indices[a];
                            n = e.getModifierStartXY(2, o), r = i.getModifierStartXY(1, l);
                            const h = n.y > r.y;
                            n.x += e.getMetrics().modRightPx + s.padding_left, r.x -= i.getMetrics().modLeftPx + s.padding_right;
                            const c = e.getGlyph().getWidth();
                            e.getKeyProps()[o].displaced && 1 === e.getStemDirection() && (n.x += c + s.padding_left), i.getKeyProps()[l].displaced && -1 === i.getStemDirection() && (r.x -= c + s.padding_right), n.y += h ? -3 : 1, r.y += h ? 2 : 0, function(t, e, i, s) {
                                const n = s.draw_start_arrow && s.draw_end_arrow, r = e.x, o = e.y, a = i.x, l = i.y, h = Math.sqrt((a - r) * (a - r) + (l - o) * (l - o)), c = (h - s.arrowhead_length / 3) / h;
                                let u, d, f, m;
                                s.draw_end_arrow || n ? (u = Math.round(r + (a - r) * c), d = Math.round(o + (l - o) * c)) : (u = a, d = l), s.draw_start_arrow || n ? (f = r + (a - r) * (1 - c), m = o + (l - o) * (1 - c)) : (f = r, m = o), s.color && (t.setStrokeStyle(s.color), t.setFillStyle(s.color)), t.beginPath(), t.moveTo(f, m), t.lineTo(u, d), t.stroke(), t.closePath();
                                const p = Math.atan2(l - o, a - r), g = Math.abs(s.arrowhead_length / Math.cos(s.arrowhead_angle));
                                let b, S, y, E, x, v;
                                (s.draw_end_arrow || n) && (b = p + Math.PI + s.arrowhead_angle, y = a + Math.cos(b) * g, E = l + Math.sin(b) * g, S = p + Math.PI - s.arrowhead_angle, x = a + Math.cos(S) * g, v = l + Math.sin(S) * g, qt(t, y, E, a, l, x, v)), (s.draw_start_arrow || n) && (b = p + s.arrowhead_angle, y = r + Math.cos(b) * g, E = o + Math.sin(b) * g, S = p - s.arrowhead_angle, x = r + Math.cos(S) * g, v = o + Math.sin(S) * g, qt(t, y, E, r, o, x, v));
                            }(t, n, r, this.render_options);
                        }), t.restore();
                        const o = t.measureText(this.text).width, a = s.text_justification;
                        let l, h = 0;
                        a === Jt.TextJustification.LEFT ? h = n.x : a === Jt.TextJustification.CENTER ? h = (r.x - n.x) / 2 + n.x - o / 2 : a === Jt.TextJustification.RIGHT && (h = r.x - o);
                        const c = s.text_position_vertical;
                        return c === Jt.TextVerticalPosition.TOP ? l = e.getStave().getYForTopText() : c === Jt.TextVerticalPosition.BOTTOM && (l = e.getStave().getYForBottomText(p.TEXT_HEIGHT_OFFSET_HACK)), t.save(), this.applyFontStyle(), t.fillText(this.text, h, l), t.restore(), this;
                    }
                }
                function $t(t, e, i, s, n) {
                    const r = Zt.GLYPHS[t];
                    new m(r.code, n).render(e, i + r.x_shift, s + r.y_shift);
                }
                class Zt extends l {
                    static get GLYPHS() {
                        return {
                            pedal_depress: {
                                code: "v36",
                                x_shift: -10,
                                y_shift: 0
                            },
                            pedal_release: {
                                code: "v5d",
                                x_shift: -2,
                                y_shift: 3
                            }
                        };
                    }
                    static get Styles() {
                        return {
                            TEXT: 1,
                            BRACKET: 2,
                            MIXED: 3,
                            MIXED_OPEN_END: 4,
                            BRACKET_OPEN_BEGIN: 5,
                            BRACKET_OPEN_END: 6,
                            BRACKET_OPEN_BOTH: 7
                        };
                    }
                    static get StylesString() {
                        return {
                            text: Zt.Styles.TEXT,
                            bracket: Zt.Styles.BRACKET,
                            mixed: Zt.Styles.MIXED,
                            mixed_open_end: Zt.Styles.MIXED_OPEN_END,
                            bracket_open_begin: Zt.Styles.BRACKET_OPEN_BEGIN,
                            bracket_open_end: Zt.Styles.BRACKET_OPEN_END,
                            bracket_open_both: Zt.Styles.BRACKET_OPEN_BOTH
                        };
                    }
                    static createSustain(t) {
                        return new Zt(t);
                    }
                    static createSostenuto(t) {
                        const e = new Zt(t);
                        return e.setStyle(Zt.Styles.MIXED), e.setCustomText("Sost. Ped."), e;
                    }
                    static createUnaCorda(t) {
                        const e = new Zt(t);
                        return e.setStyle(Zt.Styles.TEXT), e.setCustomText("una corda", "tre corda"), e;
                    }
                    constructor(t){
                        super(), this.setAttribute("type", "PedalMarking"), this.EndsStave = !1, this.ChangeBegin = !1, this.ChangeEnd = !1, this.notes = t, this.style = Zt.TEXT, this.line = 0, this.custom_depress_text = "", this.custom_release_text = "", this.font = {
                            family: "Times New Roman",
                            size: 12,
                            weight: "italic bold"
                        }, this.render_options = {
                            bracket_height: 10,
                            text_margin_right: 6,
                            bracket_line_width: 1,
                            glyph_point_size: 40,
                            color: "black"
                        };
                    }
                    setEndStave(t) {
                        if (this.endStave = t, this.endStaveAddedWidth = 0, this.startMargin = 0, this.endMargin = 0, Array.isArray(this.endStave.modifiers)) for(let t = 0; t < this.endStave.modifiers.length; t++){
                            let e = this.endStave.modifiers[t];
                            e && e.position === Et.Position.END && e.width && (this.endStaveAddedWidth += e.width);
                        }
                    }
                    setCustomText(t, e) {
                        return this.custom_depress_text = t || "", this.custom_release_text = e || "", this;
                    }
                    setStyle(t) {
                        if (t < 1 && t > 3) throw new s.RERR("InvalidParameter", "The style must be one found in PedalMarking.Styles");
                        return this.style = t, this;
                    }
                    setLine(t) {
                        return this.line = t, this;
                    }
                    drawBracketed() {
                        const t = this.context;
                        let e, i, s = !1;
                        const n = this;
                        this.notes.forEach((r, o, a)=>{
                            s = !s;
                            let l = 0;
                            if (r ? (l = r.getNoteHeadBeginX(), this.BeginsStave && (l = r.getStave().getNoteStartX())) : l = this.endStave.end_x + this.endStaveAddedWidth, this.EndsStave) s ? this.ChangeBegin && (l = r.getAbsoluteX()) : (l = r ? this.ChangeEnd ? r.getAbsoluteX() : r.getStave().end_x + this.endStaveAddedWidth - n.render_options.text_margin_right : this.endStave.end_x + this.endStaveAddedWidth - n.render_options.text_margin_right, this.endMargin = -n.render_options.text_margin_right);
                            else if (r) {
                                if (s) this.ChangeBegin && (l = r.getAbsoluteX());
                                else switch(n.style){
                                    case Zt.Styles.BRACKET_OPEN_END:
                                    case Zt.Styles.BRACKET_OPEN_BOTH:
                                    case Zt.Styles.MIXED_OPEN_END:
                                        l = r.getNoteHeadEndX();
                                        break;
                                    default:
                                        this.ChangeEnd ? l = r.getAbsoluteX() : (l = r.getNoteHeadBeginX() - n.render_options.text_margin_right, this.startMargin = -n.render_options.text_margin_right);
                                }
                            }
                            let h = this.endStave;
                            r && (h = r.getStave());
                            let c = h.getYForBottomText(n.line + 3);
                            i && i > c && (c = i);
                            const u = a[o + 1] === r, d = a[o - 1] === r;
                            let f = 0;
                            if (s) {
                                if (f = d ? 5 : 0, n.style !== Zt.Styles.MIXED && n.style !== Zt.Styles.MIXED_OPEN_END || d) t.beginPath(), n.style === Zt.Styles.BRACKET_OPEN_BEGIN || n.style === Zt.Styles.BRACKET_OPEN_BOTH ? t.moveTo(l + f, c) : (this.ChangeBegin && (l += 5), t.moveTo(l, c - n.render_options.bracket_height), this.ChangeBegin && (l += 5), t.lineTo(l + f, c)), t.stroke(), t.closePath();
                                else if (n.custom_depress_text) {
                                    const e = t.measureText(n.custom_depress_text).width;
                                    t.fillText(n.custom_depress_text, l - e / 2, c), f = e / 2 + n.render_options.text_margin_right;
                                } else $t("pedal_depress", t, l, c, n.render_options.glyph_point_size), f = 20 + n.render_options.text_margin_right;
                            } else f = u && !this.EndsStave ? -5 : 0, t.beginPath(), t.moveTo(e, i), t.lineTo(l + f, c), n.style !== Zt.Styles.BRACKET_OPEN_END && n.style !== Zt.Styles.MIXED_OPEN_END && n.style !== Zt.Styles.BRACKET_OPEN_BOTH && (this.ChangeEnd && (l += 5), t.lineTo(l, c - n.render_options.bracket_height)), t.stroke(), t.closePath();
                            e = l + f, i = c;
                        });
                    }
                    drawText() {
                        const t = this.context;
                        let e = !1;
                        const i = this, s = i.render_options.glyph_point_size;
                        this.notes.forEach((n)=>{
                            if (!n) return;
                            e = !e;
                            const r = n.getStave(), o = n.getAbsoluteX(), a = r.getYForBottomText(i.line + 3);
                            let l = 0;
                            e ? i.custom_depress_text ? (l = t.measureText(i.custom_depress_text).width, t.fillText(i.custom_depress_text, o - l / 2, a)) : $t("pedal_depress", t, o, a, s) : i.custom_release_text ? (l = t.measureText(i.custom_release_text).width, t.fillText(i.custom_release_text, o - l / 2, a)) : $t("pedal_release", t, o, a, s);
                        });
                    }
                    draw() {
                        const t = this.checkContext();
                        this.setRendered(), t.save(), t.setStrokeStyle(this.render_options.color), t.setFillStyle(this.render_options.color), t.setFont(this.font.family, this.font.size, this.font.weight), Zt.DEBUG && s.L("Vex.Flow.PedalMarking", [
                            "Rendering Pedal Marking"
                        ]), this.style === Zt.Styles.BRACKET || this.style === Zt.Styles.MIXED || this.style === Zt.Styles.MIXED_OPEN_END || this.style === Zt.Styles.BRACKET_OPEN_BEGIN || this.style === Zt.Styles.BRACKET_OPEN_END || this.style === Zt.Styles.BRACKET_OPEN_BOTH ? (t.setLineWidth(this.render_options.bracket_line_width), this.drawBracketed()) : this.style === Zt.Styles.TEXT && this.drawText(), t.restore();
                    }
                }
                class Qt extends l {
                    static get Positions() {
                        return {
                            TOP: 1,
                            BOTTOM: -1
                        };
                    }
                    static get PositionString() {
                        return {
                            top: Qt.Positions.TOP,
                            bottom: Qt.Positions.BOTTOM
                        };
                    }
                    constructor({ start: t, stop: e, text: i = "", superscript: s = "", position: n = Qt.Positions.TOP }){
                        super(), this.setAttribute("type", "TextBracket"), this.start = t, this.stop = e, this.text = i, this.superscript = s, this.position = "string" == typeof n ? Qt.PositionString[n] : n, this.line = 1, this.font = {
                            family: "Serif",
                            size: 15,
                            weight: "italic"
                        }, this.render_options = {
                            dashed: !0,
                            dash: [
                                5
                            ],
                            color: "black",
                            line_width: 1,
                            show_bracket: !0,
                            bracket_height: 8,
                            underline_superscript: !0
                        };
                    }
                    applyStyle(t) {
                        return t.setFont(this.font.family, this.font.size, this.font.weight), t.setStrokeStyle(this.render_options.color), t.setFillStyle(this.render_options.color), t.setLineWidth(this.render_options.line_width), this;
                    }
                    setDashed(t, e) {
                        return this.render_options.dashed = t, e && (this.render_options.dash = e), this;
                    }
                    setFont(t) {
                        return this.font = {
                            ...this.font,
                            ...t
                        }, this;
                    }
                    setLine(t) {
                        return this.line = t, this;
                    }
                    draw() {
                        const t = this.context;
                        this.setRendered();
                        let e = 0;
                        switch(this.position){
                            case Qt.Positions.TOP:
                                e = this.start.getStave().getYForTopText(this.line);
                                break;
                            case Qt.Positions.BOTTOM:
                                e = this.start.getStave().getYForBottomText(this.line + p.TEXT_HEIGHT_OFFSET_HACK);
                                break;
                            default:
                                throw new s.RERR("InvalidPosition", `The position ${this.position} is invalid`);
                        }
                        const i = {
                            x: this.start.getAbsoluteX(),
                            y: e
                        }, n = {
                            x: this.stop.getAbsoluteX(),
                            y: e
                        };
                        !function(...t) {
                            Qt.DEBUG && s.L("Vex.Flow.TextBracket", t);
                        }("Rendering TextBracket: start:", i, "stop:", n, "y:", e);
                        const r = this.render_options.bracket_height * this.position;
                        t.save(), this.applyStyle(t), t.fillText(this.text, i.x, i.y);
                        let o = t.measureText(this.text).width;
                        o > 0 || (o = 10 * this.text.length);
                        let a = t.measureText("M").width;
                        a > 0 || (a = 20);
                        const l = i.y - a / 2.5;
                        t.setFont(this.font.family, this.font.size / 1.4, this.font.weight), t.fillText(this.superscript, i.x + o + 1, l);
                        let h = t.measureText(this.superscript).width;
                        h > 0 || (h = 12, this.superscript.includes("m") && (h += 5));
                        let c = t.measureText("M").width;
                        c > 0 || (c = 10);
                        let u = i.x, d = l, f = n.x + this.stop.getGlyph().getWidth();
                        this.position === Qt.Positions.TOP ? (u += o + h + 5, d -= c / 2.7) : this.position === Qt.Positions.BOTTOM && (d += c / 2.7, u += o + 2, this.render_options.underline_superscript || (u += h)), this.render_options.dashed ? (f < u + 5 && this.position === Qt.Positions.TOP ? f = u + 5 : f < u + h && this.position === Qt.Positions.BOTTOM && (f = u + h), x.drawDashedLine(t, u, d, f, d, this.render_options.dash), this.render_options.show_bracket && x.drawDashedLine(t, f, d + 1 * this.position, f, d + r, this.render_options.dash)) : (t.beginPath(), t.moveTo(u, d), t.lineTo(f, d), this.render_options.show_bracket && t.lineTo(f, d + r), t.stroke(), t.closePath()), t.restore();
                    }
                }
                class te extends N {
                    constructor(t = xt.type.SINGLE){
                        super({
                            duration: "b"
                        }), this.setAttribute("type", "BarNote"), this.metrics = {
                            widths: {}
                        };
                        const e = xt.type;
                        this.metrics.widths = {
                            [e.SINGLE]: 8,
                            [e.DOUBLE]: 12,
                            [e.END]: 15,
                            [e.REPEAT_BEGIN]: 14,
                            [e.REPEAT_END]: 14,
                            [e.REPEAT_BOTH]: 18,
                            [e.NONE]: 0
                        }, this.ignore_ticks = !0, this.setType(t);
                    }
                    getType() {
                        return this.type;
                    }
                    setType(t) {
                        return this.type = "string" == typeof t ? xt.typeString[t] : t, this.setWidth(this.metrics.widths[this.type]), this;
                    }
                    getBoundingBox() {
                        return super.getBoundingBox();
                    }
                    addToModifierContext() {
                        return this;
                    }
                    preFormat() {
                        return this.setPreFormatted(!0), this;
                    }
                    draw() {
                        if (this.checkContext(), !this.stave) throw new s.RERR("NoStave", "Can't draw without a stave.");
                        !function(...t) {
                            te.DEBUG && s.L("Vex.Flow.BarNote", t);
                        }("Rendering bar line at: ", this.getAbsoluteX());
                        const t = new xt(this.type);
                        t.setX(this.getAbsoluteX()), t.draw(this.stave), this.setRendered();
                    }
                }
                class ee extends B {
                    constructor(t){
                        if (!t) throw new s.RuntimeError("BadArguments", "Ghost note must have valid initialization data to identify duration.");
                        let e;
                        if ("string" == typeof t) e = {
                            duration: t
                        };
                        else {
                            if ("object" != typeof t) throw new s.RuntimeError("BadArguments", "Ghost note must have valid initialization data to identify duration.");
                            e = t;
                        }
                        super(e), this.setAttribute("type", "GhostNote"), this.setWidth(0);
                    }
                    isRest() {
                        return !0;
                    }
                    setStave(t) {
                        super.setStave(t);
                    }
                    addToModifierContext() {
                        return this;
                    }
                    preFormat() {
                        return this.setPreFormatted(!0), this;
                    }
                    draw() {
                        if (!this.stave) throw new s.RERR("NoStave", "Can't draw without a stave.");
                        this.setRendered();
                        for(let t = 0; t < this.modifiers.length; ++t){
                            const e = this.modifiers[t];
                            e.setContext(this.context), e.drawWithStyle();
                        }
                    }
                }
                class ie extends D {
                    static get CATEGORY() {
                        return "tremolo";
                    }
                    static get YOFFSETSTEMUP() {
                        return -9;
                    }
                    static get YOFFSETSTEMDOWN() {
                        return -21;
                    }
                    static get XOFFSETSTEMUP() {
                        return 6;
                    }
                    static get XOFFSETSTEMDOWN() {
                        return -2;
                    }
                    constructor(t){
                        super(), this.setAttribute("type", "Tremolo"), this.num = t, this.note = null, this.index = null, this.position = D.Position.CENTER, this.code = "v74", this.y_spacing_scale = 1, this.extra_stroke_scale = 1, this.y_offset_for_beam = 5;
                    }
                    getCategory() {
                        return ie.CATEGORY;
                    }
                    draw() {
                        if (this.checkContext(), !this.note || null == this.index) throw new s.RERR("NoAttachedNote", "Can't draw Tremolo without a note and index.");
                        this.setRendered();
                        const t = this.note.getStemDirection();
                        this.y_spacing = 4 * t * this.y_spacing_scale;
                        let e = this.note.getModifierStartXY(this.position, this.index).x + this.note.getXShift(), i = this.note.stem.getExtents().topY, n = "gracenotes" === this.note.getCategory() ? Ut.SCALE : 1;
                        n *= this.extra_stroke_scale, i += t < 0 ? ie.YOFFSETSTEMDOWN * n : ie.YOFFSETSTEMUP * n, this.note.beam && (i += this.y_offset_for_beam * t), this.font = {
                            family: "Arial",
                            size: 16 * n,
                            weight: ""
                        }, this.render_options = {
                            font_scale: 35 * n,
                            stroke_px: 3,
                            stroke_spacing: 10 * n
                        }, e += t < 0 ? ie.XOFFSETSTEMDOWN : ie.XOFFSETSTEMUP;
                        for(let t = 0; t < this.num; ++t)m.renderGlyph(this.context, e, i, this.render_options.font_scale, this.code), i += this.y_spacing;
                    }
                }
                class se extends N {
                    constructor(t){
                        super(t), this.setAttribute("type", "Crescendo"), this.decrescendo = !1, this.line = t.line || 0, this.height = 15, s.Merge(this.render_options, {
                            extend_left: 0,
                            extend_right: 0,
                            y_shift: 0
                        });
                    }
                    setLine(t) {
                        return this.line = t, this;
                    }
                    setHeight(t) {
                        return this.height = t, this;
                    }
                    setDecrescendo(t) {
                        return this.decrescendo = t, this;
                    }
                    preFormat() {
                        return this.preFormatted = !0, this;
                    }
                    draw() {
                        this.checkContext(), this.setRendered();
                        const t = this.getTickContext(), e = $.getNextContext(t), i = this.getAbsoluteX(), n = e ? e.getX() : this.stave.x + this.stave.width, r = this.stave.getYForLine(this.line + -3) + 1;
                        !function(...t) {
                            se.DEBUG && s.L("Vex.Flow.Crescendo", t);
                        }("Drawing ", this.decrescendo ? "decrescendo " : "crescendo ", this.height, "x", i - n), function(t, e) {
                            const i = e.begin_x, s = e.end_x, n = e.y, r = e.height / 2;
                            t.beginPath(), e.reverse ? (t.moveTo(i, n - r), t.lineTo(s, n), t.lineTo(i, n + r)) : (t.moveTo(s, n - r), t.lineTo(i, n), t.lineTo(s, n + r)), t.stroke(), t.closePath();
                        }(this.context, {
                            begin_x: i - this.render_options.extend_left,
                            end_x: n + this.render_options.extend_right,
                            y: r + this.render_options.y_shift,
                            height: this.height,
                            reverse: this.decrescendo
                        });
                    }
                }
                const ne = s.MakeException("ParserError");
                function re(t) {
                    return void 0 !== t.matchedString ? t.matchedString : t.results ? re(t.results) : 1 === t.length ? re(t[0]) : 0 === t.length ? null : t.map(re);
                }
                class oe {
                    constructor(t){
                        this.grammar = t;
                    }
                    parse(t) {
                        this.line = t, this.pos = 0, this.errorPos = -1;
                        const e = this.expect(this.grammar.begin());
                        return e.errorPos = this.errorPos, e;
                    }
                    matchFail(t) {
                        -1 === this.errorPos && (this.errorPos = this.pos), this.pos = t;
                    }
                    matchSuccess() {
                        this.errorPos = -1;
                    }
                    matchToken(t, e = !1) {
                        const i = e ? new RegExp("^((" + t + "))") : new RegExp("^((" + t + ")\\s*)"), s = this.line.slice(this.pos).match(i);
                        return null !== s ? {
                            success: !0,
                            matchedString: s[2],
                            incrementPos: s[1].length,
                            pos: this.pos
                        } : {
                            success: !1,
                            pos: this.pos
                        };
                    }
                    expectOne(t, e = !1) {
                        const i = [], s = this.pos;
                        let n = !0, r = !1;
                        e = !0 === e || !0 === t.maybe;
                        for(let e = 0; e < t.expect.length; e++){
                            const s = t.expect[e], o = this.pos, a = this.expect(s);
                            if (a.success) {
                                if (i.push(a), r = !0, t.or) break;
                            } else if (n = !1, !t.or) {
                                this.pos = o;
                                break;
                            }
                        }
                        const o = t.or && r || n, a = o || !0 === e;
                        return e && !o && (this.pos = s), a ? this.matchSuccess() : this.matchFail(s), {
                            success: a,
                            results: i,
                            numMatches: o ? 1 : 0
                        };
                    }
                    expectOneOrMore(t, e = !1) {
                        const i = [], s = this.pos;
                        let n = 0, r = !0;
                        do {
                            const e = this.expectOne(t);
                            e.success ? (n++, i.push(e.results)) : r = !1;
                        }while (r);
                        const o = n > 0 || !0 === e;
                        return !e || n > 0 || (this.pos = s), o ? this.matchSuccess() : this.matchFail(s), {
                            success: o,
                            results: i,
                            numMatches: n
                        };
                    }
                    expectZeroOrMore(t) {
                        return this.expectOneOrMore(t, !0);
                    }
                    expect(t) {
                        let e;
                        if (function(...t) {
                            oe.DEBUG && s.L("Vex.Flow.Parser", t);
                        }("Evaluating rules:", t), !t) throw new ne("Invalid Rule: " + t, t);
                        const i = t.bind(this.grammar)();
                        if (i.token) e = this.matchToken(i.token, !0 === i.noSpace), e.success && (this.pos += e.incrementPos);
                        else {
                            if (!i.expect) throw new ne("Bad grammar! No `token` or `expect` property", i);
                            e = i.oneOrMore ? this.expectOneOrMore(i) : i.zeroOrMore ? this.expectZeroOrMore(i) : this.expectOne(i);
                        }
                        return e.matches = [], e.results && e.results.forEach((t)=>e.matches.push(re(t))), i.run && e.success && i.run(e), e;
                    }
                }
                function ae(...t) {
                    fe.DEBUG && s.L("Vex.Flow.EasyScore", t);
                }
                const le = s.MakeException("EasyScoreError");
                class he {
                    constructor(t){
                        this.builder = t;
                    }
                    begin() {
                        return this.LINE;
                    }
                    LINE() {
                        return {
                            expect: [
                                this.PIECE,
                                this.PIECES,
                                this.EOL
                            ]
                        };
                    }
                    PIECE() {
                        return {
                            expect: [
                                this.CHORDORNOTE,
                                this.PARAMS
                            ],
                            run: ()=>this.builder.commitPiece()
                        };
                    }
                    PIECES() {
                        return {
                            expect: [
                                this.COMMA,
                                this.PIECE
                            ],
                            zeroOrMore: !0
                        };
                    }
                    PARAMS() {
                        return {
                            expect: [
                                this.DURATION,
                                this.TYPE,
                                this.DOTS,
                                this.OPTS
                            ]
                        };
                    }
                    CHORDORNOTE() {
                        return {
                            expect: [
                                this.CHORD,
                                this.SINGLENOTE
                            ],
                            or: !0
                        };
                    }
                    CHORD() {
                        return {
                            expect: [
                                this.LPAREN,
                                this.NOTES,
                                this.RPAREN
                            ],
                            run: (t)=>this.builder.addChord(t.matches[1])
                        };
                    }
                    NOTES() {
                        return {
                            expect: [
                                this.NOTE
                            ],
                            oneOrMore: !0
                        };
                    }
                    NOTE() {
                        return {
                            expect: [
                                this.NOTENAME,
                                this.ACCIDENTAL,
                                this.OCTAVE
                            ]
                        };
                    }
                    SINGLENOTE() {
                        return {
                            expect: [
                                this.NOTENAME,
                                this.ACCIDENTAL,
                                this.OCTAVE
                            ],
                            run: (t)=>this.builder.addSingleNote(t.matches[0], t.matches[1], t.matches[2])
                        };
                    }
                    ACCIDENTAL() {
                        return {
                            expect: [
                                this.ACCIDENTALS
                            ],
                            maybe: !0
                        };
                    }
                    DOTS() {
                        return {
                            expect: [
                                this.DOT
                            ],
                            zeroOrMore: !0,
                            run: (t)=>this.builder.setNoteDots(t.matches[0])
                        };
                    }
                    TYPE() {
                        return {
                            expect: [
                                this.SLASH,
                                this.MAYBESLASH,
                                this.TYPES
                            ],
                            maybe: !0,
                            run: (t)=>this.builder.setNoteType(t.matches[2])
                        };
                    }
                    DURATION() {
                        return {
                            expect: [
                                this.SLASH,
                                this.DURATIONS
                            ],
                            maybe: !0,
                            run: (t)=>this.builder.setNoteDuration(t.matches[1])
                        };
                    }
                    OPTS() {
                        return {
                            expect: [
                                this.LBRACKET,
                                this.KEYVAL,
                                this.KEYVALS,
                                this.RBRACKET
                            ],
                            maybe: !0
                        };
                    }
                    KEYVALS() {
                        return {
                            expect: [
                                this.COMMA,
                                this.KEYVAL
                            ],
                            zeroOrMore: !0
                        };
                    }
                    KEYVAL() {
                        return {
                            expect: [
                                this.KEY,
                                this.EQUALS,
                                this.VAL
                            ],
                            run: (t)=>this.builder.addNoteOption(t.matches[0], t.matches[2].slice(1, -1))
                        };
                    }
                    VAL() {
                        return {
                            expect: [
                                this.SVAL,
                                this.DVAL
                            ],
                            or: !0
                        };
                    }
                    KEY() {
                        return {
                            token: "[a-zA-Z][a-zA-Z0-9]*"
                        };
                    }
                    DVAL() {
                        return {
                            token: '["][^"]*["]'
                        };
                    }
                    SVAL() {
                        return {
                            token: "['][^']*[']"
                        };
                    }
                    NOTENAME() {
                        return {
                            token: "[a-gA-G]"
                        };
                    }
                    OCTAVE() {
                        return {
                            token: "[0-9]+"
                        };
                    }
                    ACCIDENTALS() {
                        return {
                            token: "bbs|bb|bss|bs|b|db|d|##|#|n|\\+\\+-|\\+-|\\+\\+|\\+|k|o"
                        };
                    }
                    DURATIONS() {
                        return {
                            token: "[0-9whq]+"
                        };
                    }
                    TYPES() {
                        return {
                            token: "[rRsSxX]"
                        };
                    }
                    LPAREN() {
                        return {
                            token: "[(]"
                        };
                    }
                    RPAREN() {
                        return {
                            token: "[)]"
                        };
                    }
                    COMMA() {
                        return {
                            token: "[,]"
                        };
                    }
                    DOT() {
                        return {
                            token: "[.]"
                        };
                    }
                    SLASH() {
                        return {
                            token: "[/]"
                        };
                    }
                    MAYBESLASH() {
                        return {
                            token: "[/]?"
                        };
                    }
                    EQUALS() {
                        return {
                            token: "[=]"
                        };
                    }
                    LBRACKET() {
                        return {
                            token: "\\["
                        };
                    }
                    RBRACKET() {
                        return {
                            token: "\\]"
                        };
                    }
                    EOL() {
                        return {
                            token: "$"
                        };
                    }
                }
                class ce {
                    constructor(t){
                        this.factory = t, this.commitHooks = [], this.reset();
                    }
                    reset(t = {}) {
                        this.options = {
                            stem: "auto",
                            clef: "treble"
                        }, this.elements = {
                            notes: [],
                            accidentals: []
                        }, this.rollingDuration = "8", this.resetPiece(), Object.assign(this.options, t);
                    }
                    getFactory() {
                        return this.factory;
                    }
                    getElements() {
                        return this.elements;
                    }
                    addCommitHook(t) {
                        this.commitHooks.push(t);
                    }
                    resetPiece() {
                        ae("resetPiece"), this.piece = {
                            chord: [],
                            duration: this.rollingDuration,
                            dots: 0,
                            type: void 0,
                            options: {}
                        };
                    }
                    setNoteDots(t) {
                        ae("setNoteDots:", t), t && (this.piece.dots = t.length);
                    }
                    setNoteDuration(t) {
                        ae("setNoteDuration:", t), this.rollingDuration = this.piece.duration = t || this.rollingDuration;
                    }
                    setNoteType(t) {
                        ae("setNoteType:", t), t && (this.piece.type = t);
                    }
                    addNoteOption(t, e) {
                        ae("addNoteOption: key:", t, "value:", e), this.piece.options[t] = e;
                    }
                    addNote(t, e, i) {
                        ae("addNote:", t, e, i), this.piece.chord.push({
                            key: t,
                            accid: e,
                            octave: i
                        });
                    }
                    addSingleNote(t, e, i) {
                        ae("addSingleNote:", t, e, i), this.addNote(t, e, i);
                    }
                    addChord(t) {
                        ae("startChord"), "object" != typeof t[0] ? this.addSingleNote(t[0]) : t.forEach((t)=>{
                            t && this.addNote(...t);
                        }), ae("endChord");
                    }
                    commitPiece() {
                        ae("commitPiece");
                        const { factory: t } = this;
                        if (!t) return;
                        const e = {
                            ...this.options,
                            ...this.piece.options
                        }, { stem: i, clef: s } = e, n = "auto" === i.toLowerCase(), r = n || "up" !== i.toLowerCase() ? V.STEM_DOWN : V.STEM_UP, { chord: o, duration: a, dots: l, type: h } = this.piece, c = o.map((t)=>t.key + "/" + t.octave), u = t.StaveNote({
                            keys: c,
                            duration: a,
                            dots: l,
                            type: h,
                            clef: s,
                            auto_stem: n
                        });
                        n || u.setStemDirection(r);
                        const d = o.map((t)=>t.accid || null);
                        d.forEach((e, i)=>{
                            e && u.addAccidental(i, t.Accidental({
                                type: e
                            }));
                        });
                        for(let t = 0; t < l; t++)u.addDotToAll();
                        this.commitHooks.forEach((t)=>t(e, u, this)), this.elements.notes.push(u), this.elements.accidentals.concat(d), this.resetPiece();
                    }
                }
                function ue({ id: t }, e) {
                    void 0 !== t && e.setAttribute("id", t);
                }
                function de(t, e) {
                    t.class && t.class.split(/\s*,\s*/).forEach((t)=>e.addClass(t));
                }
                class fe {
                    constructor(t = {}){
                        this.setOptions(t), this.defaults = {
                            clef: "treble",
                            time: "4/4",
                            stem: "auto"
                        };
                    }
                    set(t) {
                        return Object.assign(this.defaults, t), this;
                    }
                    setOptions(t) {
                        return this.options = {
                            factory: null,
                            builder: null,
                            commitHooks: [
                                ue,
                                de,
                                at.easyScoreHook
                            ],
                            throwOnError: !1,
                            ...t
                        }, this.factory = this.options.factory, this.builder = this.options.builder || new ce(this.factory), this.grammar = new he(this.builder), this.parser = new oe(this.grammar), this.options.commitHooks.forEach((t)=>this.addCommitHook(t)), this;
                    }
                    setContext(t) {
                        return this.factory && this.factory.setContext(t), this;
                    }
                    parse(t, e = {}) {
                        this.builder.reset(e);
                        const i = this.parser.parse(t);
                        if (!i.success && this.options.throwOnError) throw new le("Error parsing line: " + t, i);
                        return i;
                    }
                    beam(t, e = {}) {
                        return this.factory.Beam({
                            notes: t,
                            options: e
                        }), t;
                    }
                    tuplet(t, e = {}) {
                        return this.factory.Tuplet({
                            notes: t,
                            options: e
                        }), t;
                    }
                    notes(t, e = {}) {
                        return e = {
                            clef: this.defaults.clef,
                            stem: this.defaults.stem,
                            ...e
                        }, this.parse(t, e), this.builder.getElements().notes;
                    }
                    voice(t, e) {
                        return e = {
                            time: this.defaults.time,
                            ...e
                        }, this.factory.Voice(e).addTickables(t);
                    }
                    addCommitHook(t) {
                        return this.builder.addCommitHook(t);
                    }
                }
                const me = s.MakeException("FactoryError");
                function pe(t = {}, e) {
                    const i = e.options;
                    return (t = Object.assign(e, t)).options = Object.assign(i, t.options), t;
                }
                class ge {
                    constructor(t){
                        !function(...t) {
                            ge.DEBUG && s.L("Vex.Flow.Factory", t);
                        }("New factory: ", t);
                        const e = {
                            stave: {
                                space: 10
                            },
                            renderer: {
                                context: null,
                                elementId: "",
                                backend: x.Backends.SVG,
                                width: 500,
                                height: 200,
                                background: "#FFF"
                            },
                            font: {
                                face: "Arial",
                                point: 10,
                                style: ""
                            }
                        };
                        this.options = e, this.setOptions(t);
                    }
                    static newFromElementId(t, e = 500, i = 200) {
                        return new ge({
                            renderer: {
                                elementId: t,
                                width: e,
                                height: i
                            }
                        });
                    }
                    reset() {
                        this.renderQ = [], this.systems = [], this.staves = [], this.voices = [], this.stave = null;
                    }
                    getOptions() {
                        return this.options;
                    }
                    setOptions(t) {
                        for (const e of [
                            "stave",
                            "renderer",
                            "font"
                        ])Object.assign(this.options[e], t[e]);
                        (null !== this.options.renderer.elementId || this.options.renderer.context) && this.initRenderer(), this.reset();
                    }
                    initRenderer() {
                        const { elementId: t, backend: e, width: i, height: s, background: n } = this.options.renderer;
                        if ("" === t) throw new me("HTML DOM element not set in Factory");
                        this.context = x.buildContext(t, e, i, s, n);
                    }
                    getContext() {
                        return this.context;
                    }
                    setContext(t) {
                        return this.context = t, this;
                    }
                    getStave() {
                        return this.stave;
                    }
                    getVoices() {
                        return this.voices;
                    }
                    space(t) {
                        return this.options.stave.space * t;
                    }
                    Stave(t) {
                        t = pe(t, {
                            x: 0,
                            y: 0,
                            width: this.options.renderer.width - this.space(1),
                            options: {
                                spacing_between_lines_px: this.options.stave.space
                            }
                        });
                        const e = new Rt(t.x, t.y, t.width, t.options);
                        return this.staves.push(e), e.setContext(this.context), this.stave = e, e;
                    }
                    TabStave(t) {
                        t = pe(t, {
                            x: 0,
                            y: 0,
                            width: this.options.renderer.width - this.space(1),
                            options: {
                                spacing_between_lines_px: 1.3 * this.options.stave.space
                            }
                        });
                        const e = new Nt(t.x, t.y, t.width, t.options);
                        return this.staves.push(e), e.setContext(this.context), this.stave = e, e;
                    }
                    StaveNote(t) {
                        const e = new V(t);
                        return this.stave && e.setStave(this.stave), e.setContext(this.context), this.renderQ.push(e), e;
                    }
                    GhostNote(t) {
                        const e = new ee(t);
                        return this.stave && e.setStave(this.stave), e.setContext(this.context), this.renderQ.push(e), e;
                    }
                    TextNote(t) {
                        const e = new Mt(t);
                        return this.stave && e.setStave(this.stave), e.setContext(this.context), this.renderQ.push(e), e;
                    }
                    BarNote(t) {
                        t = pe(t, {
                            type: "single",
                            options: {}
                        });
                        const e = new te(t.type);
                        return this.stave && e.setStave(this.stave), e.setContext(this.context), this.renderQ.push(e), e;
                    }
                    ClefNote(t) {
                        t = pe(t, {
                            type: "treble",
                            options: {
                                size: "default"
                            }
                        });
                        const e = new kt(t.type, t.options.size, t.options.annotation);
                        return this.stave && e.setStave(this.stave), e.setContext(this.context), this.renderQ.push(e), e;
                    }
                    TimeSigNote(t) {
                        t = pe(t, {
                            time: "4/4",
                            options: {}
                        });
                        const e = new Gt(t.time);
                        return this.stave && e.setStave(this.stave), e.setContext(this.context), this.renderQ.push(e), e;
                    }
                    KeySigNote(t) {
                        const e = new Vt(t.key, t.cancelKey, t.alterKey);
                        return this.stave && e.setStave(this.stave), e.setContext(this.context), this.renderQ.push(e), e;
                    }
                    TabNote(t) {
                        const e = new Ct(t);
                        return this.stave && e.setStave(this.stave), e.setContext(this.context), this.renderQ.push(e), e;
                    }
                    GraceNote(t) {
                        const e = new Ut(t);
                        return this.stave && e.setStave(this.stave), e.setContext(this.context), e;
                    }
                    GraceNoteGroup(t) {
                        const e = new K(t.notes, t.slur);
                        return e.setContext(this.context), e;
                    }
                    Accidental(t) {
                        t = pe(t, {
                            type: null,
                            options: {}
                        });
                        const e = new H(t.type);
                        return e.setContext(this.context), e;
                    }
                    Annotation(t) {
                        t = pe(t, {
                            text: "p",
                            vJustify: "below",
                            hJustify: "center",
                            fontFamily: "Times",
                            fontSize: 14,
                            fontWeight: "bold italic",
                            options: {}
                        });
                        const e = new dt(t.text);
                        return e.setJustification(t.hJustify), e.setVerticalJustification(t.vJustify), e.setFont(t.fontFamily, t.fontSize, t.fontWeight), e.setContext(this.context), e;
                    }
                    Articulation(t) {
                        t = pe(t, {
                            type: "a.",
                            position: "above",
                            options: {}
                        });
                        const e = new at(t.type);
                        return e.setPosition(t.position), e.setContext(this.context), e;
                    }
                    TextDynamics(t) {
                        t = pe(t, {
                            text: "p",
                            duration: "q",
                            dots: 0,
                            line: 0,
                            options: {}
                        });
                        const e = new Kt({
                            text: t.text,
                            line: t.line,
                            duration: t.duration,
                            dots: t.dots
                        });
                        return this.stave && e.setStave(this.stave), e.setContext(this.context), this.renderQ.push(e), e;
                    }
                    Fingering(t) {
                        t = pe(t, {
                            number: "0",
                            position: "left",
                            options: {}
                        });
                        const e = new G(t.number);
                        return e.setPosition(t.position), e.setContext(this.context), e;
                    }
                    StringNumber(t) {
                        t = pe(t, {
                            number: "0",
                            position: "left",
                            options: {}
                        });
                        const e = new J(t.number);
                        return e.setPosition(t.position), e.setContext(this.context), e;
                    }
                    TickContext() {
                        return (new $).setContext(this.context);
                    }
                    ModifierContext() {
                        return new gt;
                    }
                    MultiMeasureRest(t) {
                        const e = new Ft(t.number_of_measures, t);
                        return e.setContext(this.context), this.renderQ.push(e), e;
                    }
                    Voice(t) {
                        t = pe(t, {
                            time: "4/4",
                            options: {}
                        });
                        const e = new w(t.time);
                        return this.voices.push(e), e;
                    }
                    StaveConnector(t) {
                        t = pe(t, {
                            top_stave: null,
                            bottom_stave: null,
                            type: "double",
                            options: {}
                        });
                        const e = new I(t.top_stave, t.bottom_stave);
                        return e.setType(t.type).setContext(this.context), this.renderQ.push(e), e;
                    }
                    Formatter() {
                        return new yt;
                    }
                    Tuplet(t) {
                        t = pe(t, {
                            notes: [],
                            options: {}
                        });
                        const e = new T(t.notes, t.options).setContext(this.context);
                        return this.renderQ.push(e), e;
                    }
                    Beam(t) {
                        t = pe(t, {
                            notes: [],
                            options: {
                                autoStem: !1,
                                secondaryBeamBreaks: []
                            }
                        });
                        const e = new L(t.notes, t.options.autoStem).setContext(this.context);
                        return e.breakSecondaryAt(t.options.secondaryBeamBreaks), this.renderQ.push(e), e;
                    }
                    Curve(t) {
                        t = pe(t, {
                            from: null,
                            to: null,
                            options: {}
                        });
                        const e = new Yt(t.from, t.to, t.options).setContext(this.context);
                        return this.renderQ.push(e), e;
                    }
                    StaveTie(t) {
                        t = pe(t, {
                            from: null,
                            to: null,
                            first_indices: [
                                0
                            ],
                            last_indices: [
                                0
                            ],
                            text: null,
                            options: {
                                direction: void 0
                            }
                        });
                        const e = new Y({
                            first_note: t.from,
                            last_note: t.to,
                            first_indices: t.first_indices,
                            last_indices: t.last_indices
                        }, t.text);
                        return t.options.direction && e.setDirection(t.options.direction), e.setContext(this.context), this.renderQ.push(e), e;
                    }
                    StaveLine(t) {
                        t = pe(t, {
                            from: null,
                            to: null,
                            first_indices: [
                                0
                            ],
                            last_indices: [
                                0
                            ],
                            options: {}
                        });
                        const e = new Jt({
                            first_note: t.from,
                            last_note: t.to,
                            first_indices: t.first_indices,
                            last_indices: t.last_indices
                        });
                        return t.options.text && e.setText(t.options.text), t.options.font && e.setFont(t.options.font), e.setContext(this.context), this.renderQ.push(e), e;
                    }
                    VibratoBracket(t) {
                        t = pe(t, {
                            from: null,
                            to: null,
                            options: {
                                harsh: !1
                            }
                        });
                        const e = new Bt({
                            start: t.from,
                            stop: t.to
                        });
                        return t.options.line && e.setLine(t.options.line), t.options.harsh && e.setHarsh(t.options.harsh), e.setContext(this.context), this.renderQ.push(e), e;
                    }
                    TextBracket(t) {
                        t = pe(t, {
                            from: null,
                            to: null,
                            text: "",
                            options: {
                                superscript: "",
                                position: 1
                            }
                        });
                        const e = new Qt({
                            start: t.from,
                            stop: t.to,
                            text: t.text,
                            superscript: t.options.superscript,
                            position: t.options.position
                        });
                        return t.options.line && e.setLine(t.options.line), t.options.font && e.setFont(t.options.font), e.setContext(this.context), this.renderQ.push(e), e;
                    }
                    System(t = {}) {
                        t.factory = this;
                        const e = new Se(t).setContext(this.context);
                        return this.systems.push(e), e;
                    }
                    EasyScore(t = {}) {
                        return t.factory = this, new fe(t);
                    }
                    PedalMarking(t = {}) {
                        t = pe(t, {
                            notes: [],
                            options: {
                                style: "mixed"
                            }
                        });
                        const e = new Zt(t.notes);
                        return e.setStyle(Zt.StylesString[t.options.style]), e.setContext(this.context), this.renderQ.push(e), e;
                    }
                    NoteSubGroup(t = {}) {
                        t = pe(t, {
                            notes: [],
                            options: {}
                        });
                        const e = new X(t.notes);
                        return e.setContext(this.context), e;
                    }
                    draw() {
                        this.systems.forEach((t)=>t.setContext(this.context).format()), this.staves.forEach((t)=>t.setContext(this.context).draw()), this.voices.forEach((t)=>t.setContext(this.context).draw()), this.renderQ.forEach((t)=>{
                            t.isRendered() || t.setContext(this.context).draw();
                        }), this.systems.forEach((t)=>t.setContext(this.context).draw()), this.reset();
                    }
                }
                function be(t, e) {
                    const i = e.options;
                    return (t = Object.assign(e, t)).options = Object.assign(i, t.options), t;
                }
                class Se extends l {
                    constructor(t = {}){
                        super(), this.setAttribute("type", "System"), this.setOptions(t), this.parts = [];
                    }
                    setOptions(t = {}) {
                        this.options = be(t, {
                            x: 10,
                            y: 10,
                            width: 500,
                            connector: null,
                            spaceBetweenStaves: 12,
                            factory: null,
                            debugFormatter: !1,
                            formatIterations: 0,
                            options: {}
                        }), this.factory = this.options.factory || new ge({
                            renderer: {
                                el: null
                            }
                        });
                    }
                    setContext(t) {
                        return super.setContext(t), this.factory.setContext(t), this;
                    }
                    addConnector(t = "double") {
                        return this.connector = this.factory.StaveConnector({
                            top_stave: this.parts[0].stave,
                            bottom_stave: this.parts[this.parts.length - 1].stave,
                            type: t
                        }), this.connector;
                    }
                    addStave(t) {
                        return (t = be(t, {
                            stave: null,
                            voices: [],
                            spaceAbove: 0,
                            spaceBelow: 0,
                            debugNoteMetrics: !1,
                            options: {
                                left_bar: !1
                            }
                        })).stave || (t.stave = this.factory.Stave({
                            x: this.options.x,
                            y: this.options.y,
                            width: this.options.width,
                            options: t.options
                        })), t.voices.forEach((e)=>e.setContext(this.context).setStave(t.stave).getTickables().forEach((e)=>e.setStave(t.stave))), this.parts.push(t), t.stave;
                    }
                    format() {
                        const t = new yt;
                        this.formatter = t;
                        let e = this.options.y, i = 0, s = [];
                        const n = [];
                        this.parts.forEach((r)=>{
                            e += r.stave.space(r.spaceAbove), r.stave.setY(e), t.joinVoices(r.voices), e += r.stave.space(r.spaceBelow), e += r.stave.space(this.options.spaceBetweenStaves), r.debugNoteMetrics && (n.push({
                                y: e,
                                voice: r.voices[0]
                            }), e += 15), s = s.concat(r.voices), i = Math.max(i, r.stave.getNoteStartX());
                        }), this.parts.forEach((t)=>t.stave.setNoteStartX(i));
                        const r = this.options.width - (i - this.options.x) - N.STAVEPADDING;
                        t.format(s, r);
                        for(let e = 0; e < this.options.formatIterations; e++)t.tune();
                        this.startX = i, this.debugNoteMetricsYs = n, this.lastY = e;
                    }
                    draw() {
                        const t = this.checkContext();
                        this.setRendered(), this.options.debugFormatter && yt.plotDebugging(t, this.formatter, this.startX, this.options.y, this.lastY), this.debugNoteMetricsYs.forEach((e)=>{
                            e.voice.getTickables().forEach((i)=>N.plotMetrics(t, i, e.y));
                        });
                    }
                }
                (s.Flow = p).Element = l, s.Flow.Fraction = n, s.Flow.Renderer = x, s.Flow.Formatter = yt, s.Flow.Music = W, s.Flow.Glyph = m, s.Flow.Stave = Rt, s.Flow.StaveNote = V, s.Flow.StaveModifier = Et, s.Flow.StaveTempo = _t, s.Flow.Voice = w, s.Flow.Accidental = H, s.Flow.Beam = L, s.Flow.StaveTie = Y, s.Flow.TabStave = Nt, s.Flow.TabNote = Ct, s.Flow.Bend = ft, s.Flow.Vibrato = mt, s.Flow.VibratoBracket = Bt, s.Flow.Note = N, s.Flow.ModifierContext = gt, s.Flow.MultiMeasureRest = Ft, s.Flow.TickContext = $, s.Flow.Articulation = at, s.Flow.Annotation = dt, s.Flow.Barline = xt, s.Flow.NoteHead = C, s.Flow.StaveConnector = I, s.Flow.ClefNote = kt, s.Flow.KeySignature = wt, s.Flow.KeySigNote = Vt, s.Flow.TimeSignature = At, s.Flow.TimeSigNote = Gt, s.Flow.Stem = v, s.Flow.TabTie = j, s.Flow.Clef = Lt, s.Flow.Dot = O, s.Flow.Modifier = D, s.Flow.TabSlide = Wt, s.Flow.Tuplet = T, s.Flow.GraceNote = Ut, s.Flow.GraceTabNote = zt, s.Flow.Tuning = Ht, s.Flow.KeyManager = class {
                    constructor(t){
                        this.music = new W, this.setKey(t);
                    }
                    setKey(t) {
                        return this.key = t, this.reset(), this;
                    }
                    getKey() {
                        return this.key;
                    }
                    reset() {
                        if (this.keyParts = this.music.getKeyParts(this.key), this.keyString = this.keyParts.root, this.keyParts.accidental && (this.keyString += this.keyParts.accidental), !W.scaleTypes[this.keyParts.type]) throw new s.RERR("BadArguments", `Unsupported key type: ${this.key}`);
                        this.scale = this.music.getScaleTones(this.music.getNoteValue(this.keyString), W.scaleTypes[this.keyParts.type]), this.scaleMap = {}, this.scaleMapByValue = {}, this.originalScaleMapByValue = {};
                        const t = W.root_indices[this.keyParts.root];
                        for(let e = 0; e < W.roots.length; ++e){
                            const i = (t + e) % W.roots.length, s = W.roots[i], n = this.music.getRelativeNoteName(s, this.scale[e]);
                            this.scaleMap[s] = n, this.scaleMapByValue[this.scale[e]] = n, this.originalScaleMapByValue[this.scale[e]] = n;
                        }
                        return this;
                    }
                    getAccidental(t) {
                        const e = this.music.getKeyParts(t).root, i = this.music.getNoteParts(this.scaleMap[e]);
                        return {
                            note: this.scaleMap[e],
                            accidental: i.accidental
                        };
                    }
                    selectNote(t) {
                        t = t.toLowerCase();
                        const e = this.music.getNoteParts(t), i = this.scaleMap[e.root], s = this.music.getNoteParts(i);
                        if (i === t) return {
                            note: i,
                            accidental: e.accidental,
                            change: !1
                        };
                        const n = this.scaleMapByValue[this.music.getNoteValue(t)];
                        if (null != n) return {
                            note: n,
                            accidental: this.music.getNoteParts(n).accidental,
                            change: !1
                        };
                        const r = this.originalScaleMapByValue[this.music.getNoteValue(t)];
                        return null != r ? (this.scaleMap[s.root] = r, delete this.scaleMapByValue[this.music.getNoteValue(i)], this.scaleMapByValue[this.music.getNoteValue(t)] = r, {
                            note: r,
                            accidental: this.music.getNoteParts(r).accidental,
                            change: !0
                        }) : s.root === t ? (delete this.scaleMapByValue[this.music.getNoteValue(this.scaleMap[e.root])], this.scaleMapByValue[this.music.getNoteValue(s.root)] = s.root, this.scaleMap[s.root] = s.root, {
                            note: s.root,
                            accidental: null,
                            change: !0
                        }) : (delete this.scaleMapByValue[this.music.getNoteValue(this.scaleMap[e.root])], this.scaleMapByValue[this.music.getNoteValue(t)] = t, delete this.scaleMap[s.root], this.scaleMap[s.root] = t, {
                            note: t,
                            accidental: e.accidental,
                            change: !0
                        });
                    }
                }, s.Flow.StaveHairpin = Xt, s.Flow.BoundingBox = c, s.Flow.Stroke = q, s.Flow.TextNote = Mt, s.Flow.Curve = Yt, s.Flow.TextDynamics = Kt, s.Flow.StaveLine = Jt, s.Flow.Ornament = ut, s.Flow.PedalMarking = Zt, s.Flow.TextBracket = Qt, s.Flow.FretHandFinger = G, s.Flow.Repetition = vt, s.Flow.BarNote = te, s.Flow.GhostNote = ee, s.Flow.NoteSubGroup = X, s.Flow.GraceNoteGroup = K, s.Flow.Tremolo = ie, s.Flow.StringNumber = J, s.Flow.Crescendo = se, s.Flow.Volta = It, s.Flow.Font = u, s.Flow.System = Se, s.Flow.Factory = ge, s.Flow.Parser = oe, s.Flow.EasyScore = fe, s.Flow.Registry = a;
                const ye = s;
            },
            5166 (t) {
                "use strict";
                t.exports = "precision mediump float;\r\nuniform sampler2D u_image;\r\nvarying vec4 v_position;\r\n\r\n#define NUM_ROWS 5\r\n#define ELEMENT_HEIGHT 300\r\n\r\nvoid main() {\r\n    const float halfPixel = 1.0 / float(ELEMENT_HEIGHT * 2);\r\n\r\n    vec2 absolutePosition = (v_position.xy + vec2(1.0)) / vec2(2.0);\r\n    float absX = absolutePosition.x;\r\n    float absY = absolutePosition.y;\r\n\r\n    int skyLine = 0;\r\n    for (int i = 0; i < ELEMENT_HEIGHT; ++i) {\r\n        float ratioY = float(i) / float(ELEMENT_HEIGHT);\r\n        float relY = (ratioY - 0.5 + halfPixel) / float(NUM_ROWS);\r\n        float x = absX;\r\n        float y = absY + relY;\r\n\r\n        float currentAlpha = texture2D(u_image, vec2(x, y)).a;\r\n        if (currentAlpha > 0.0) {\r\n            skyLine = i;\r\n            break;\r\n        }\r\n    }\r\n\r\n    int bottomLine = ELEMENT_HEIGHT;\r\n    for (int i = ELEMENT_HEIGHT - 1; i >= 0; --i) {\r\n        float ratioY = float(i) / float(ELEMENT_HEIGHT);\r\n        float relY = (ratioY - 0.5 + halfPixel) / float(NUM_ROWS);\r\n        float x = absX;\r\n        float y = absY + relY;\r\n\r\n        float currentAlpha = texture2D(u_image, vec2(x, y)).a;\r\n        if (currentAlpha > 0.0) {\r\n            bottomLine = i;\r\n            break;\r\n        }\r\n    }\r\n\r\n    int r = skyLine;\r\n    if (r > 256) {\r\n        r -= 256;\r\n    }\r\n    int g = bottomLine;\r\n    if (g > 256) {\r\n        g -= 256;\r\n    }\r\n    int b = (skyLine / 256 * 16) + (bottomLine / 256);\r\n\r\n    gl_FragColor = vec4(float(r) / 255.0, float(g) / 255.0, float(b) / 255.0, 1.0);\r\n}\r\n";
            },
            5340 (t) {
                "use strict";
                t.exports = "attribute vec4 a_position;\r\nvarying vec4 v_position;\r\n\r\nvoid main() {\r\n    gl_Position = a_position;\r\n    v_position = a_position;\r\n}\r\n";
            }
        }, e = {};
        function i(s) {
            var n = e[s];
            if (void 0 !== n) return n.exports;
            var r = e[s] = {
                exports: {}
            };
            return t[s].call(r.exports, r, r.exports, i), r.exports;
        }
        return i.d = (t, e)=>{
            for(var s in e)i.o(e, s) && !i.o(t, s) && Object.defineProperty(t, s, {
                enumerable: !0,
                get: e[s]
            });
        }, i.g = function() {
            if ("object" == typeof globalThis) return globalThis;
            try {
                return this || new Function("return this")();
            } catch (t) {
                if ("object" == typeof window) return window;
            }
        }(), i.o = (t, e)=>Object.prototype.hasOwnProperty.call(t, e), i.r = (t)=>{
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(t, "__esModule", {
                value: !0
            });
        }, i(8156);
    })());


const $60078af3cede2a64$export$d66a0ac0c9083fa1 = (forNote)=>forNote.getAbsoluteTimestamp().RealValue * 4;
const $60078af3cede2a64$export$d07268e0f7e63eef = (first, second)=>Math.abs(first - second) < 1e-6;
const $60078af3cede2a64$export$7a96d400b96d7c37 = (offset, first, last)=>first - 1e-6 <= offset && offset <= last + 1e-6;
const $60078af3cede2a64$export$31e3bd67f7b73048 = (forNote)=>forNote.ParentVoiceEntry.Notes.length;
const $60078af3cede2a64$export$75bba95db5c3e753 = (forNote)=>forNote.Length.RealValue * 4;
const $60078af3cede2a64$export$622cea445a1c5b7d = (forNote)=>$60078af3cede2a64$export$d66a0ac0c9083fa1(forNote) - forNote.SourceMeasure.AbsoluteTimestamp.RealValue * 4;
const $60078af3cede2a64$export$483288ae205f46f1 = (forNote)=>forNote.Pitch ? `${$60078af3cede2a64$export$ab8457433da1bda8(forNote.Pitch.FundamentalNote)}${$60078af3cede2a64$export$af79ad9d2c33c52d(forNote.Pitch.Accidental)}${forNote.Pitch.Octave + 3}` : undefined;
const $60078af3cede2a64$export$d9e93408681959cd = (note)=>note.ParentVoiceEntry.Notes.length > 1;
const $60078af3cede2a64$export$af79ad9d2c33c52d = (accidental)=>{
    switch(accidental){
        case (0, $4c574b2b3c7bfc41$exports.AccidentalEnum).SHARP:
            return '#';
        case (0, $4c574b2b3c7bfc41$exports.AccidentalEnum).FLAT:
            return '-';
        default:
            return '';
    }
};
const $60078af3cede2a64$export$ab8457433da1bda8 = (note)=>{
    switch(note){
        case (0, $4c574b2b3c7bfc41$exports.NoteEnum).A:
            return 'A';
        case (0, $4c574b2b3c7bfc41$exports.NoteEnum).B:
            return 'B';
        case (0, $4c574b2b3c7bfc41$exports.NoteEnum).C:
            return 'C';
        case (0, $4c574b2b3c7bfc41$exports.NoteEnum).D:
            return 'D';
        case (0, $4c574b2b3c7bfc41$exports.NoteEnum).E:
            return 'E';
        case (0, $4c574b2b3c7bfc41$exports.NoteEnum).F:
            return 'F';
        case (0, $4c574b2b3c7bfc41$exports.NoteEnum).G:
            return 'G';
    }
};






var $5E6i4 = parcelRequire("5E6i4");


const $3c154bbb0fa44c80$export$786ded4a9f1f0dea = (0, $49db07fe7d01393c$export$88d57a8d3a22066c);
// `availablePatternColors` is used as a stack (pop): the first palette slot sits at the end.
const $3c154bbb0fa44c80$var$patternColors = [
    ...Array(500).fill($3c154bbb0fa44c80$export$786ded4a9f1f0dea),
    ...[
        ...(0, $49db07fe7d01393c$export$4c74adcc907c297e)
    ].reverse()
];
const $3c154bbb0fa44c80$export$93fd56124d1d45f2 = [
    '#fd7f6f',
    '#7eb0d5',
    '#b2e061',
    '#bd7ebe',
    '#ffb55a',
    '#ffee65',
    '#e5d8bd',
    '#beb9db',
    '#fdcce5',
    '#8bd3c7'
];
const $3c154bbb0fa44c80$var$defaultTheme = {
    availablePatternColors: $3c154bbb0fa44c80$var$patternColors.map((color)=>(0, $a9ceb34ac62682a2$export$2e2bcd8739ae039)(color).toHexString()),
    colorByVoice: false,
    colorVoices: false,
    getVoiceColor: (voiceNumber)=>voiceNumber <= $3c154bbb0fa44c80$export$93fd56124d1d45f2.length ? $3c154bbb0fa44c80$export$93fd56124d1d45f2[voiceNumber - 1] : undefined
};
const $3c154bbb0fa44c80$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $5E6i4.createContext)([
    $3c154bbb0fa44c80$var$defaultTheme,
    undefined
]);
const $3c154bbb0fa44c80$var$ThemeContextProvider = ({ children: children })=>{
    const [theme, setTheme] = (0, $5E6i4.useState)($3c154bbb0fa44c80$var$defaultTheme);
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($3c154bbb0fa44c80$export$2c657da244d00bd6.Provider, {
        value: [
            theme,
            setTheme
        ],
        children: children
    });
};
var $3c154bbb0fa44c80$export$2e2bcd8739ae039 = $3c154bbb0fa44c80$var$ThemeContextProvider;


var $19aaa313855abf25$var$ACTION = /*#__PURE__*/ function(ACTION) {
    ACTION["ADD_PATTERN"] = "ADD_PATTERN";
    ACTION["CONNECT_PATTERNS"] = "CONNECT_PATTERNS";
    ACTION["EXPAND_PATTERN"] = "EXPAND_PATTERN";
    ACTION["UPDATE_DEVIATION_OPERATOR"] = "UPDATE_DEVIATION_OPERATOR";
    return ACTION;
}($19aaa313855abf25$var$ACTION || {});
var $19aaa313855abf25$var$EVENT = /*#__PURE__*/ function(EVENT) {
    EVENT["CONNECTIONS_FOUND"] = "CONNECTIONS_FOUND";
    EVENT["OCCURRENCE_FOUND"] = "OCCURRENCE_FOUND";
    EVENT["PATTERN_FOUND"] = "PATTERN_FOUND";
    EVENT["PATTERN_OCCURRENCES_COUNTED"] = "PATTERN_OCCURRENCES_COUNTED";
    EVENT["SEARCH_FINISHED"] = "SEARCH_FINISHED";
    return EVENT;
}($19aaa313855abf25$var$EVENT || {});
const $19aaa313855abf25$var$usePatterns = (musicSheetID, noteElements, pattern, deviationPercentage, // Whether variants may keep the scale steps (tonal) instead of the exact intervals (real), see operators.py.
tonal, patterns, setPattern, setPatterns)=>{
    const [isOpen, setIsOpen] = (0, $5E6i4.useState)(false);
    const [loadingStatus, setLoadingStatus] = (0, $5E6i4.useState)(new Map(Object.values((0, $e5b6a001e5093ab5$export$fa5f90bfb4dbdbcd)).map((operator)=>[
            operator,
            false
        ])));
    const { lastJsonMessage: lastJsonMessage, sendJsonMessage: sendJsonMessage, readyState: readyState } = (0, (/*@__PURE__*/$parcel$interopDefault($feea5e2a23e1c45a$exports)))(`${(0, $f3690857a25f275e$export$959cc5b93fe4d66)(true)}/patterns/${musicSheetID}`, {}, isOpen);
    const [theme] = (0, $5E6i4.useContext)((0, $3c154bbb0fa44c80$export$2c657da244d00bd6));
    (0, $5E6i4.useEffect)(()=>{
        setIsOpen(musicSheetID !== undefined && pattern !== undefined);
    }, [
        musicSheetID,
        pattern
    ]);
    (0, $5E6i4.useEffect)(()=>{
        if (readyState === (0, $feea5e2a23e1c45a$exports.ReadyState).OPEN && pattern) {
            if (pattern.occurrences.length > 0) {
                const occurrence = pattern.occurrences[0];
                setLoadingStatus(new Map(Object.values((0, $e5b6a001e5093ab5$export$fa5f90bfb4dbdbcd)).map((operator)=>[
                        operator,
                        true
                    ])));
                if (pattern.isUserDefined) sendJsonMessage({
                    action: "ADD_PATTERN",
                    data: {
                        deviationPercentage: deviationPercentage,
                        firstOffset: occurrence.firstOffset,
                        lastOffset: occurrence.lastOffset,
                        length: pattern.length,
                        tonal: tonal,
                        voiceNumber: occurrence.voiceNumber
                    }
                });
                else if (!pattern.hasBeenQueried) {
                    let occurrencesToExclude = [
                        ...pattern.occurrences,
                        ...pattern.connectedToByOperator.flatMap((connection)=>{
                            const connectedPattern = patterns.find((existingPattern)=>existingPattern.id === connection.id);
                            return connectedPattern.occurrences;
                        }),
                        ...patterns.flatMap((possiblyConnectedPattern)=>{
                            const isConnectedToPattern = possiblyConnectedPattern.connectedToByOperator.some((connection)=>connection.id === pattern.id);
                            if (isConnectedToPattern) return possiblyConnectedPattern.occurrences;
                            return [];
                        })
                    ];
                    occurrencesToExclude = (0, $5pSp9.uniqWith)(occurrencesToExclude, (0, $5pSp9.isEqual));
                    sendJsonMessage({
                        action: "EXPAND_PATTERN",
                        data: {
                            deviationPercentage: deviationPercentage,
                            firstOffset: occurrence.firstOffset,
                            lastOffset: occurrence.lastOffset,
                            length: pattern.length,
                            matchesToExclude: occurrencesToExclude.map((occurrence)=>({
                                    firstOffset: occurrence.firstOffset,
                                    lastOffset: occurrence.lastOffset,
                                    voiceNumber: occurrence.voiceNumber
                                })),
                            tonal: tonal,
                            voiceNumber: occurrence.voiceNumber
                        }
                    });
                    setPatterns((oldPatterns)=>{
                        const expandedPattern = oldPatterns.find((oldPattern)=>oldPattern.id === pattern.id);
                        expandedPattern.hasBeenQueried = true;
                        return [
                            ...oldPatterns
                        ];
                    });
                }
            }
        }
    }, [
        pattern,
        readyState
    ]);
    (0, $5E6i4.useEffect)(()=>{
        if (lastJsonMessage !== null && pattern !== undefined) {
            const event = lastJsonMessage['event'];
            switch(event){
                case "OCCURRENCE_FOUND":
                    {
                        const firstOffset = lastJsonMessage['data']['firstOffset'];
                        const lastOffset = lastJsonMessage['data']['lastOffset'];
                        const voiceNumber = lastJsonMessage['data']['voiceNumber'];
                        setPatterns((oldPatterns)=>{
                            const occurrence = {
                                firstOffset: firstOffset,
                                lastOffset: lastOffset,
                                voiceNumber: voiceNumber
                            };
                            const oldPattern = oldPatterns.find((oldPattern)=>oldPattern.id === pattern.id);
                            oldPattern.occurrences.push(occurrence);
                            if (theme.colorVoices) oldPattern.color = theme.getVoiceColor($19aaa313855abf25$export$930cf99cc5aa91c0(oldPattern));
                            return [
                                ...oldPatterns
                            ];
                        });
                        break;
                    }
                case "PATTERN_FOUND":
                    {
                        const id = lastJsonMessage['data']['id'];
                        const firstOffset = lastJsonMessage['data']['firstOffset'];
                        const lastOffset = lastJsonMessage['data']['lastOffset'];
                        const operator = lastJsonMessage['data']['operator'];
                        const voiceNumber = lastJsonMessage['data']['voiceNumber'];
                        const occurrence = {
                            firstOffset: firstOffset,
                            lastOffset: lastOffset,
                            voiceNumber: voiceNumber
                        };
                        setPatterns((oldPatterns)=>{
                            const existingPattern = oldPatterns.find((oldPattern)=>oldPattern.id === id);
                            if (existingPattern === undefined) {
                                const noteContexts = noteElements.filter((noteContext)=>noteContext.voiceNumber === voiceNumber).data();
                                const firstNoteContextIndex = noteContexts.findIndex((noteContext)=>(0, $60078af3cede2a64$export$d07268e0f7e63eef)((0, $60078af3cede2a64$export$d66a0ac0c9083fa1)(noteContext.note.sourceNote), firstOffset));
                                const lastNoteContextIndex = noteContexts.findIndex((noteContext)=>(0, $60078af3cede2a64$export$d07268e0f7e63eef)((0, $60078af3cede2a64$export$d66a0ac0c9083fa1)(noteContext.note.sourceNote), lastOffset));
                                const patternLength = lastNoteContextIndex - firstNoteContextIndex + 1;
                                const labelPattern = new RegExp(`^${pattern.label}'*$`);
                                const patternWithLongestLabel = oldPatterns.filter((oldPattern)=>oldPattern.label.match(labelPattern)).sort((firstPattern, secondPattern)=>-(firstPattern.label.length - secondPattern.label.length))[0];
                                const newPattern = {
                                    // A variant shares the hue of its pattern, one shade per derivation (paper, 4.2: colouring "adapted
                                    // based on the similarity space of two patterns").
                                    color: theme.colorByVoice ? theme.getVoiceColor(voiceNumber) : $19aaa313855abf25$export$ce7158e6888ab5d6(oldPatterns, pattern),
                                    connectedToByOccurrences: [],
                                    connectedToByOperator: (0, $e5b6a001e5093ab5$export$2ffb6bdccc8a5ed0)(operator) ? [
                                        {
                                            id: pattern.id,
                                            byOperator: operator
                                        }
                                    ] : [],
                                    description: undefined,
                                    hasBeenQueried: false,
                                    id: id,
                                    isLocked: false,
                                    isUserDefined: false,
                                    isVisible: false,
                                    label: `${patternWithLongestLabel.label}'`,
                                    length: patternLength,
                                    occurrences: [
                                        occurrence
                                    ],
                                    uniqueOccurrencesCount: 1,
                                    voiceNumber: voiceNumber
                                };
                                const oldPattern = oldPatterns.find((oldPattern)=>oldPattern.id === pattern.id);
                                oldPattern.connectedToByOperator.push({
                                    id: id,
                                    byOperator: operator
                                });
                                return [
                                    ...oldPatterns,
                                    newPattern
                                ];
                            } else {
                                const oldPattern = oldPatterns.find((oldPattern)=>oldPattern.id === existingPattern.id);
                                oldPattern.occurrences.push(occurrence);
                                if (theme.colorByVoice) oldPattern.color = theme.getVoiceColor($19aaa313855abf25$export$930cf99cc5aa91c0(oldPattern));
                                return [
                                    ...oldPatterns
                                ];
                            }
                        });
                        break;
                    }
                case "PATTERN_OCCURRENCES_COUNTED":
                    {
                        const patternID = lastJsonMessage['data']['id'];
                        const uniqueOccurrencesCount = lastJsonMessage['data']['uniqueCount'];
                        setPatterns((oldPatterns)=>{
                            const oldPattern = oldPatterns.find((oldPattern)=>oldPattern.id === (patternID || pattern.id));
                            if (oldPattern === undefined) return oldPatterns;
                            oldPattern.uniqueOccurrencesCount = uniqueOccurrencesCount;
                            return [
                                ...oldPatterns
                            ];
                        });
                        break;
                    }
            }
        }
    }, [
        lastJsonMessage,
        noteElements,
        pattern
    ]);
    (0, $5E6i4.useEffect)(()=>{
        if (lastJsonMessage !== null && patterns.length > 0) {
            const event = lastJsonMessage['event'];
            switch(event){
                case "SEARCH_FINISHED":
                    {
                        const type = lastJsonMessage['data'];
                        if (type) {
                            const operator = type['operator'];
                            setLoadingStatus((previousLoadingStatus)=>{
                                previousLoadingStatus.set(operator, false);
                                return new Map(previousLoadingStatus);
                            });
                        } else {
                            setLoadingStatus(new Map(Object.values((0, $e5b6a001e5093ab5$export$fa5f90bfb4dbdbcd)).map((operator)=>[
                                    operator,
                                    false
                                ])));
                            sendJsonMessage({
                                action: "CONNECT_PATTERNS",
                                data: patterns.map((pattern)=>({
                                        id: pattern.id,
                                        occurrences: pattern.occurrences.map((occurrence)=>({
                                                firstOffset: occurrence.firstOffset,
                                                lastOffset: occurrence.lastOffset,
                                                voiceNumber: occurrence.voiceNumber
                                            }))
                                    }))
                            });
                        }
                        break;
                    }
            }
        }
    }, [
        lastJsonMessage,
        patterns
    ]);
    (0, $5E6i4.useEffect)(()=>{
        if (lastJsonMessage !== null) {
            const event = lastJsonMessage['event'];
            switch(event){
                case "CONNECTIONS_FOUND":
                    {
                        const patternConnections = lastJsonMessage['data'];
                        setPatterns((oldPatterns)=>{
                            patternConnections.forEach((patternConnection)=>{
                                const firstPattern = oldPatterns.find((pattern)=>pattern.id === patternConnection.firstPatternID);
                                const secondPattern = oldPatterns.find((pattern)=>pattern.id === patternConnection.secondPatternID);
                                // Patterns can be deleted while the connections are computed.
                                if (!firstPattern || !secondPattern) return;
                                const isFirstConnectedToSecond = firstPattern.connectedToByOperator.some((connection)=>connection.id === secondPattern.id);
                                const isSecondConnectedToFirst = secondPattern.connectedToByOperator.some((connection)=>connection.id === firstPattern.id);
                                if (firstPattern && secondPattern && !isFirstConnectedToSecond && !isSecondConnectedToFirst) {
                                    const firstPatternConnection = {
                                        id: secondPattern.id,
                                        occurrences: patternConnection.occurrences
                                    };
                                    const secondPatternConnection = {
                                        id: firstPattern.id,
                                        occurrences: patternConnection.occurrences
                                    };
                                    firstPattern.connectedToByOccurrences.push(firstPatternConnection);
                                    secondPattern.connectedToByOccurrences.push(secondPatternConnection);
                                }
                            });
                            return [
                                ...oldPatterns
                            ];
                        });
                        break;
                    }
            }
        }
    }, [
        lastJsonMessage
    ]);
    return {
        loadingStatus: loadingStatus,
        updateDeviationOperator: (configuringID, deviationPercentage)=>{
            setLoadingStatus((previousLoadingStatus)=>new Map(previousLoadingStatus).set((0, $e5b6a001e5093ab5$export$fa5f90bfb4dbdbcd).DEVIATION, true));
            setPatterns((oldPatterns)=>{
                const configuringPattern = oldPatterns.find((pattern)=>pattern.id === configuringID);
                if (configuringPattern) {
                    const patternsToDelete = configuringPattern.connectedToByOperator.filter((connection)=>connection.byOperator === (0, $e5b6a001e5093ab5$export$fa5f90bfb4dbdbcd).DEVIATION).map((connection)=>oldPatterns.find((oldPattern)=>oldPattern.id === connection.id))// Only delete the pattern if there is no other connection than the deviation to it.
                    .filter((patternToDelete)=>patternToDelete.connectedToByOperator.every((connection)=>connection.byOperator === (0, $e5b6a001e5093ab5$export$fa5f90bfb4dbdbcd).DEVIATION));
                    const occurrencesToDelete = patternsToDelete.flatMap((patternToDelete)=>patternToDelete.occurrences);
                    configuringPattern.connectedToByOperator = configuringPattern.connectedToByOperator.filter((connection)=>connection.byOperator !== (0, $e5b6a001e5093ab5$export$fa5f90bfb4dbdbcd).DEVIATION);
                    // Remove the occurrences to be deleted from the connections by occurrences.
                    configuringPattern.connectedToByOccurrences.forEach((connection)=>{
                        connection.occurrences = connection.occurrences.filter((occurrence)=>!occurrencesToDelete.some((occurrenceToDelete)=>occurrence === occurrenceToDelete));
                        // Remove the occurrences to be delete from the other pattern's connection reference as well.
                        const otherPattern = oldPatterns.find((oldPattern)=>oldPattern.id === connection.id);
                        otherPattern.connectedToByOccurrences.forEach((otherConnection)=>{
                            otherConnection.occurrences = otherConnection.occurrences.filter((occurrence)=>!occurrencesToDelete.some((occurrenceToDelete)=>occurrence === occurrenceToDelete));
                            // If no occurrences remain, also remove the connection.
                            if (otherConnection.occurrences.length === 0) otherPattern.connectedToByOccurrences = otherPattern.connectedToByOccurrences.filter((obsoleteConnection)=>obsoleteConnection.id !== otherConnection.id);
                        });
                        // If no occurrences remain, also remove the connection.
                        if (connection.occurrences.length === 0) configuringPattern.connectedToByOccurrences = configuringPattern.connectedToByOccurrences.filter((obsoleteConnection)=>obsoleteConnection.id !== connection.id);
                    });
                    oldPatterns = oldPatterns.filter((oldPattern)=>!patternsToDelete.includes(oldPattern));
                }
                return [
                    ...oldPatterns
                ];
            });
            const occurrence = pattern.occurrences[0];
            sendJsonMessage({
                action: "UPDATE_DEVIATION_OPERATOR",
                data: {
                    deviationPercentage: deviationPercentage,
                    firstOffset: occurrence.firstOffset,
                    lastOffset: occurrence.lastOffset,
                    length: pattern.length,
                    tonal: tonal,
                    voiceNumber: occurrence.voiceNumber
                }
            });
        }
    };
};
const $19aaa313855abf25$export$ce7158e6888ab5d6 = (patterns, from)=>{
    const root = patterns.find((candidate)=>candidate.label === from.label.replace(/'+$/, '')) ?? from;
    const steps = [
        0,
        1,
        2,
        3
    ].find((candidate)=>(0, $49db07fe7d01393c$export$3e32adda0df4ef5d)(root.color, candidate) === from.color);
    return steps === undefined ? (0, $49db07fe7d01393c$export$3e32adda0df4ef5d)(from.color) : (0, $49db07fe7d01393c$export$3e32adda0df4ef5d)(root.color, steps + 1);
};
const $19aaa313855abf25$export$930cf99cc5aa91c0 = (pattern)=>{
    const earliestOffset = Math.min(...pattern.occurrences.map((occurrence)=>occurrence.firstOffset));
    const firstOccurrences = pattern.occurrences.filter((occurrence)=>occurrence.firstOffset === earliestOffset);
    return Math.min(...firstOccurrences.map((occurrence)=>occurrence.voiceNumber));
};
var $19aaa313855abf25$export$2e2bcd8739ae039 = $19aaa313855abf25$var$usePatterns;




var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $04dbd055bc5edd2b$var$extendStatics = function(d, b) {
    $04dbd055bc5edd2b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $04dbd055bc5edd2b$var$extendStatics(d, b);
};
function $04dbd055bc5edd2b$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $04dbd055bc5edd2b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $04dbd055bc5edd2b$export$18ce0697a983be9b = function() {
    $04dbd055bc5edd2b$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $04dbd055bc5edd2b$export$18ce0697a983be9b.apply(this, arguments);
};
function $04dbd055bc5edd2b$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $04dbd055bc5edd2b$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $04dbd055bc5edd2b$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $04dbd055bc5edd2b$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $04dbd055bc5edd2b$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $04dbd055bc5edd2b$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $04dbd055bc5edd2b$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $04dbd055bc5edd2b$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $04dbd055bc5edd2b$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $04dbd055bc5edd2b$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $04dbd055bc5edd2b$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $04dbd055bc5edd2b$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $04dbd055bc5edd2b$export$45d3717a4c69092e(o, m, p);
}
function $04dbd055bc5edd2b$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $04dbd055bc5edd2b$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $04dbd055bc5edd2b$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($04dbd055bc5edd2b$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $04dbd055bc5edd2b$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $04dbd055bc5edd2b$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $04dbd055bc5edd2b$export$10c90e4f7922046c(v) {
    return this instanceof $04dbd055bc5edd2b$export$10c90e4f7922046c ? (this.v = v, this) : new $04dbd055bc5edd2b$export$10c90e4f7922046c(v);
}
function $04dbd055bc5edd2b$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $04dbd055bc5edd2b$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $04dbd055bc5edd2b$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $04dbd055bc5edd2b$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $04dbd055bc5edd2b$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $04dbd055bc5edd2b$export$19a8beecd37a4c45 === "function" ? $04dbd055bc5edd2b$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $04dbd055bc5edd2b$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $04dbd055bc5edd2b$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $04dbd055bc5edd2b$var$ownKeys = function(o) {
    $04dbd055bc5edd2b$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $04dbd055bc5edd2b$var$ownKeys(o);
};
function $04dbd055bc5edd2b$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $04dbd055bc5edd2b$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $04dbd055bc5edd2b$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $04dbd055bc5edd2b$var$__setModuleDefault(result, mod);
    return result;
}
function $04dbd055bc5edd2b$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $04dbd055bc5edd2b$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $04dbd055bc5edd2b$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $04dbd055bc5edd2b$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $04dbd055bc5edd2b$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $04dbd055bc5edd2b$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $04dbd055bc5edd2b$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $04dbd055bc5edd2b$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $04dbd055bc5edd2b$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $04dbd055bc5edd2b$export$2e2bcd8739ae039 = {
    __extends: $04dbd055bc5edd2b$export$a8ba968b8961cb8a,
    __assign: $04dbd055bc5edd2b$export$18ce0697a983be9b,
    __rest: $04dbd055bc5edd2b$export$3c9a16f847548506,
    __decorate: $04dbd055bc5edd2b$export$29e00dfd3077644b,
    __param: $04dbd055bc5edd2b$export$d5ad3fd78186038f,
    __esDecorate: $04dbd055bc5edd2b$export$3a84e1ae4e97e9b0,
    __runInitializers: $04dbd055bc5edd2b$export$d831c04e792af3d,
    __propKey: $04dbd055bc5edd2b$export$6a2a36740a146cb8,
    __setFunctionName: $04dbd055bc5edd2b$export$d1a06452d3489bc7,
    __metadata: $04dbd055bc5edd2b$export$f1db080c865becb9,
    __awaiter: $04dbd055bc5edd2b$export$1050f835b63b671e,
    __generator: $04dbd055bc5edd2b$export$67ebef60e6f28a6,
    __createBinding: $04dbd055bc5edd2b$export$45d3717a4c69092e,
    __exportStar: $04dbd055bc5edd2b$export$f33643c0debef087,
    __values: $04dbd055bc5edd2b$export$19a8beecd37a4c45,
    __read: $04dbd055bc5edd2b$export$8d051b38c9118094,
    __spread: $04dbd055bc5edd2b$export$afc72e2116322959,
    __spreadArrays: $04dbd055bc5edd2b$export$6388937ca91ccae8,
    __spreadArray: $04dbd055bc5edd2b$export$1216008129fb82ed,
    __await: $04dbd055bc5edd2b$export$10c90e4f7922046c,
    __asyncGenerator: $04dbd055bc5edd2b$export$e427f37a30a4de9b,
    __asyncDelegator: $04dbd055bc5edd2b$export$bbd80228419bb833,
    __asyncValues: $04dbd055bc5edd2b$export$e3b29a3d6162315f,
    __makeTemplateObject: $04dbd055bc5edd2b$export$4fb47efe1390b86f,
    __importStar: $04dbd055bc5edd2b$export$c21735bcef00d192,
    __importDefault: $04dbd055bc5edd2b$export$da59b14a69baef04,
    __classPrivateFieldGet: $04dbd055bc5edd2b$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $04dbd055bc5edd2b$export$d40a35129aaff81f,
    __classPrivateFieldIn: $04dbd055bc5edd2b$export$81fdc39f203e4e04,
    __addDisposableResource: $04dbd055bc5edd2b$export$88ac25d8e944e405,
    __disposeResources: $04dbd055bc5edd2b$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $04dbd055bc5edd2b$export$889dfb5d17574b0b
};



var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");
function $507b5f6bf58aca11$export$2e2bcd8739ae039() {
    var mountedRef = (0, $5E6i4.useRef)(false);
    var get = (0, $5E6i4.useCallback)(function() {
        return mountedRef.current;
    }, []);
    (0, $5E6i4.useEffect)(function() {
        mountedRef.current = true;
        return function() {
            mountedRef.current = false;
        };
    }, []);
    return get;
}


function $11db48c1f23978ab$export$2e2bcd8739ae039(fn, deps, initialState) {
    if (deps === void 0) deps = [];
    if (initialState === void 0) initialState = {
        loading: false
    };
    var lastCallId = (0, $5E6i4.useRef)(0);
    var isMounted = (0, $507b5f6bf58aca11$export$2e2bcd8739ae039)();
    var _a = (0, $5E6i4.useState)(initialState), state = _a[0], set = _a[1];
    var callback = (0, $5E6i4.useCallback)(function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var callId = ++lastCallId.current;
        if (!state.loading) set(function(prevState) {
            return (0, $04dbd055bc5edd2b$export$18ce0697a983be9b)((0, $04dbd055bc5edd2b$export$18ce0697a983be9b)({}, prevState), {
                loading: true
            });
        });
        return fn.apply(void 0, args).then(function(value) {
            isMounted() && callId === lastCallId.current && set({
                value: value,
                loading: false
            });
            return value;
        }, function(error) {
            isMounted() && callId === lastCallId.current && set({
                error: error,
                loading: false
            });
            return error;
        });
    }, deps);
    return [
        state,
        callback
    ];
}


function $8a614d8dd398f993$export$2e2bcd8739ae039(fn, deps) {
    if (deps === void 0) deps = [];
    var _a = (0, $11db48c1f23978ab$export$2e2bcd8739ae039)(fn, deps, {
        loading: true
    }), state = _a[0], callback = _a[1];
    (0, $5E6i4.useEffect)(function() {
        callback();
    }, [
        callback
    ]);
    return state;
}



const $5aca9bb8bf7cde88$var$useVoices = (musicSheetID)=>{
    const [voices, setVoices] = (0, $5E6i4.useState)([]);
    (0, $8a614d8dd398f993$export$2e2bcd8739ae039)(async ()=>{
        if (musicSheetID) {
            const voices = await (0, $0d16547caa56a13b$export$2e2bcd8739ae039).get(`${(0, $f3690857a25f275e$export$959cc5b93fe4d66)()}/voices/${musicSheetID}`);
            setVoices(voices.data);
        }
    }, [
        musicSheetID
    ]);
    return voices;
};
var $5aca9bb8bf7cde88$export$2e2bcd8739ae039 = $5aca9bb8bf7cde88$var$useVoices;




var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $07b6c251435559e9$var$InboxOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M885.2 446.3l-.2-.8-112.2-285.1c-5-16.1-19.9-27.2-36.8-27.2H281.2c-17 0-32.1 11.3-36.9 27.6L139.4 443l-.3.7-.2.8c-1.3 4.9-1.7 9.9-1 14.8-.1 1.6-.2 3.2-.2 4.8V830a60.9 60.9 0 0060.8 60.8h627.2c33.5 0 60.8-27.3 60.9-60.8V464.1c0-1.3 0-2.6-.1-3.7.4-4.9 0-9.6-1.3-14.1zm-295.8-43l-.3 15.7c-.8 44.9-31.8 75.1-77.1 75.1-22.1 0-41.1-7.1-54.8-20.6S436 441.2 435.6 419l-.3-15.7H229.5L309 210h399.2l81.7 193.3H589.4zm-375 76.8h157.3c24.3 57.1 76 90.8 140.4 90.8 33.7 0 65-9.4 90.3-27.2 22.2-15.6 39.5-37.4 50.7-63.6h156.5V814H214.4V480.1z"
                }
            }
        ]
    },
    "name": "inbox",
    "theme": "outlined"
};
var $07b6c251435559e9$export$2e2bcd8739ae039 = $07b6c251435559e9$var$InboxOutlined;



function $f53527c0d5d8cbe5$var$_extends() {
    $f53527c0d5d8cbe5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f53527c0d5d8cbe5$var$_extends.apply(this, arguments);
}
const $f53527c0d5d8cbe5$var$InboxOutlined = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $f53527c0d5d8cbe5$var$_extends({}, props, {
        ref: ref,
        icon: (0, $07b6c251435559e9$export$2e2bcd8739ae039)
    }));
/**![inbox](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg4NS4yIDQ0Ni4zbC0uMi0uOC0xMTIuMi0yODUuMWMtNS0xNi4xLTE5LjktMjcuMi0zNi44LTI3LjJIMjgxLjJjLTE3IDAtMzIuMSAxMS4zLTM2LjkgMjcuNkwxMzkuNCA0NDNsLS4zLjctLjIuOGMtMS4zIDQuOS0xLjcgOS45LTEgMTQuOC0uMSAxLjYtLjIgMy4yLS4yIDQuOFY4MzBhNjAuOSA2MC45IDAgMDA2MC44IDYwLjhoNjI3LjJjMzMuNSAwIDYwLjgtMjcuMyA2MC45LTYwLjhWNDY0LjFjMC0xLjMgMC0yLjYtLjEtMy43LjQtNC45IDAtOS42LTEuMy0xNC4xem0tMjk1LjgtNDNsLS4zIDE1LjdjLS44IDQ0LjktMzEuOCA3NS4xLTc3LjEgNzUuMS0yMi4xIDAtNDEuMS03LjEtNTQuOC0yMC42UzQzNiA0NDEuMiA0MzUuNiA0MTlsLS4zLTE1LjdIMjI5LjVMMzA5IDIxMGgzOTkuMmw4MS43IDE5My4zSDU4OS40em0tMzc1IDc2LjhoMTU3LjNjMjQuMyA1Ny4xIDc2IDkwLjggMTQwLjQgOTAuOCAzMy43IDAgNjUtOS40IDkwLjMtMjcuMiAyMi4yLTE1LjYgMzkuNS0zNy40IDUwLjctNjMuNmgxNTYuNVY4MTRIMjE0LjRWNDgwLjF6IiAvPjwvc3ZnPg==) */ const $f53527c0d5d8cbe5$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($f53527c0d5d8cbe5$var$InboxOutlined);
var $f53527c0d5d8cbe5$export$2e2bcd8739ae039 = $f53527c0d5d8cbe5$var$RefIcon;





var $5E6i4 = parcelRequire("5E6i4");







var $5E6i4 = parcelRequire("5E6i4");

function $9a553e4a0a469bcd$export$2e2bcd8739ae039(value) {
    const [cacheValue, setCacheValue] = (0, $2114fb66f76f632e$export$2e2bcd8739ae039)(value);
    $5E6i4.useEffect(()=>{
        setCacheValue(value, {
            ms: value.length ? 0 : 10
        });
    }, [
        value
    ]);
    return cacheValue;
}







const $30329b21e3e85ee2$var$genFormValidateMotionStyle = (token)=>{
    const { componentCls: componentCls, motionDurationFast: motionDurationFast, motionEaseInOut: motionEaseInOut } = token;
    const helpCls = `${componentCls}-show-help`;
    const helpItemCls = `${componentCls}-show-help-item`;
    return {
        [helpCls]: {
            // Explain holder
            transition: `opacity ${motionDurationFast} ${motionEaseInOut}`,
            '&-appear, &-enter': {
                opacity: 0,
                '&-active': {
                    opacity: 1
                }
            },
            '&-leave': {
                opacity: 1,
                '&-active': {
                    opacity: 0
                }
            },
            // Explain
            [helpItemCls]: {
                overflow: 'hidden',
                transition: `${[
                    'height',
                    'opacity',
                    'transform'
                ].map((prop)=>`${prop} ${motionDurationFast} ${motionEaseInOut}`).join(', ')} !important`,
                [`&${helpItemCls}-appear, &${helpItemCls}-enter`]: {
                    transform: `translateY(-5px)`,
                    opacity: 0,
                    '&-active': {
                        transform: 'translateY(0)',
                        opacity: 1
                    }
                },
                [`&${helpItemCls}-leave-active`]: {
                    transform: `translateY(-5px)`
                }
            }
        }
    };
};
var $30329b21e3e85ee2$export$2e2bcd8739ae039 = $30329b21e3e85ee2$var$genFormValidateMotionStyle;


const $5517d3ccd7b50da5$var$resetForm = (token)=>({
        legend: {
            display: 'block',
            width: '100%',
            marginBottom: token.marginLG,
            padding: 0,
            color: token.colorTextDescription,
            fontSize: token.fontSizeLG,
            lineHeight: 'inherit',
            border: 0,
            borderBottom: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
        },
        'input[type="search"]': {
            boxSizing: 'border-box'
        },
        // Position radios and checkboxes better
        'input[type="radio"], input[type="checkbox"]': {
            lineHeight: 'normal'
        },
        'input[type="file"]': {
            display: 'block'
        },
        // Make range inputs behave like textual form controls
        'input[type="range"]': {
            display: 'block',
            width: '100%'
        },
        // Make multiple select elements height not fixed
        'select[multiple], select[size]': {
            height: 'auto'
        },
        // Focus for file, radio, and checkbox
        "input[type='file']:focus, input[type='radio']:focus, input[type='checkbox']:focus": {
            outline: 0,
            boxShadow: `0 0 0 ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.controlOutlineWidth)} ${token.controlOutline}`
        },
        // Adjust output element
        output: {
            display: 'block',
            paddingTop: 15,
            color: token.colorText,
            fontSize: token.fontSize,
            lineHeight: token.lineHeight
        }
    });
const $5517d3ccd7b50da5$var$genFormSize = (token, height)=>{
    const { formItemCls: formItemCls } = token;
    return {
        [formItemCls]: {
            [`${formItemCls}-label > label`]: {
                height: height
            },
            [`${formItemCls}-control-input`]: {
                minHeight: height
            }
        }
    };
};
const $5517d3ccd7b50da5$var$genFormStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            ...(0, $cd5a520fee8002b4$export$23997c3e44cc1c59)(token),
            ...$5517d3ccd7b50da5$var$resetForm(token),
            [`${componentCls}-text`]: {
                display: 'inline-block',
                paddingInlineEnd: token.paddingSM
            },
            // ================================================================
            // =                             Size                             =
            // ================================================================
            '&-small': {
                ...$5517d3ccd7b50da5$var$genFormSize(token, token.controlHeightSM)
            },
            '&-large': {
                ...$5517d3ccd7b50da5$var$genFormSize(token, token.controlHeightLG)
            }
        }
    };
};
const $5517d3ccd7b50da5$var$genFormItemStyle = (token)=>{
    const { formItemCls: formItemCls, iconCls: iconCls, rootPrefixCls: rootPrefixCls, antCls: antCls, labelRequiredMarkColor: labelRequiredMarkColor, labelColor: labelColor, labelFontSize: labelFontSize, labelHeight: labelHeight, labelColonMarginInlineStart: labelColonMarginInlineStart, labelColonMarginInlineEnd: labelColonMarginInlineEnd, itemMarginBottom: itemMarginBottom } = token;
    const [varName] = (0, $761caadb5301aee1$export$d82b8f66c5649e14)(antCls, 'grid');
    return {
        [formItemCls]: {
            ...(0, $cd5a520fee8002b4$export$23997c3e44cc1c59)(token),
            marginBottom: itemMarginBottom,
            verticalAlign: 'top',
            '&-with-help': {
                transition: 'none'
            },
            [`&-hidden,
        &-hidden${antCls}-row`]: {
                // https://github.com/ant-design/ant-design/issues/26141
                display: 'none'
            },
            // ==============================================================
            // =                            Label                           =
            // ==============================================================
            [`${formItemCls}-label`]: {
                flexGrow: 0,
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textAlign: 'end',
                verticalAlign: 'middle',
                '&-left': {
                    textAlign: 'start'
                },
                '&-wrap': {
                    overflow: 'unset',
                    lineHeight: token.lineHeight,
                    whiteSpace: 'unset',
                    '> label': {
                        verticalAlign: 'middle',
                        textWrap: 'balance'
                    }
                },
                '> label': {
                    position: 'relative',
                    display: 'inline-flex',
                    alignItems: 'center',
                    maxWidth: '100%',
                    height: labelHeight,
                    color: labelColor,
                    fontSize: labelFontSize,
                    [`> ${iconCls}`]: {
                        fontSize: token.fontSize,
                        verticalAlign: 'top'
                    },
                    [`&${formItemCls}-required`]: {
                        '&::before': {
                            display: 'inline-block',
                            marginInlineEnd: token.marginXXS,
                            color: labelRequiredMarkColor,
                            fontSize: token.fontSize,
                            fontFamily: 'sans-serif',
                            lineHeight: 1,
                            content: '"*"'
                        },
                        [`&${formItemCls}-required-mark-hidden, &${formItemCls}-required-mark-optional`]: {
                            '&::before': {
                                display: 'none'
                            }
                        }
                    },
                    // Optional mark
                    [`${formItemCls}-optional`]: {
                        display: 'inline-block',
                        marginInlineStart: token.marginXXS,
                        color: token.colorTextDescription,
                        [`&${formItemCls}-required-mark-hidden`]: {
                            display: 'none'
                        }
                    },
                    // Optional mark
                    [`${formItemCls}-tooltip`]: {
                        color: token.colorTextDescription,
                        cursor: 'help',
                        writingMode: 'horizontal-tb',
                        marginInlineStart: token.marginXXS
                    },
                    '&::after': {
                        content: '":"',
                        position: 'relative',
                        marginBlock: 0,
                        marginInlineStart: labelColonMarginInlineStart,
                        marginInlineEnd: labelColonMarginInlineEnd
                    },
                    [`&${formItemCls}-no-colon::after`]: {
                        content: '"\\a0"'
                    }
                }
            },
            // ==============================================================
            // =                            Input                           =
            // ==============================================================
            [`${formItemCls}-control`]: {
                [varName('display')]: 'flex',
                flexDirection: 'column',
                flexGrow: 1,
                [`&:first-child:not([class^="'${rootPrefixCls}-col-'"]):not([class*="' ${rootPrefixCls}-col-'"])`]: {
                    width: '100%'
                },
                '&-input': {
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    minHeight: token.controlHeight,
                    '&-content': {
                        flex: 'auto',
                        maxWidth: '100%',
                        // Fix https://github.com/ant-design/ant-design/issues/54042
                        // Remove impact of whitespaces
                        [`&:has(> ${antCls}-switch:only-child, > ${antCls}-rate:only-child)`]: {
                            display: 'flex',
                            alignItems: 'center'
                        }
                    }
                }
            },
            // ==============================================================
            // =                           Explain                          =
            // ==============================================================
            [formItemCls]: {
                '&-additional': {
                    display: 'flex',
                    flexDirection: 'column'
                },
                '&-explain, &-extra': {
                    clear: 'both',
                    color: token.colorTextDescription,
                    fontSize: token.fontSize,
                    lineHeight: token.lineHeight
                },
                '&-explain-connected': {
                    width: '100%'
                },
                '&-extra': {
                    minHeight: token.controlHeightSM,
                    transition: `color ${token.motionDurationMid} ${token.motionEaseOut}` // sync input color transition
                },
                '&-explain': {
                    '&-error': {
                        color: token.colorError
                    },
                    '&-warning': {
                        color: token.colorWarning
                    }
                }
            },
            [`&-with-help ${formItemCls}-explain`]: {
                height: 'auto',
                opacity: 1
            },
            // ==============================================================
            // =                        Feedback Icon                       =
            // ==============================================================
            [`${formItemCls}-feedback-icon`]: {
                fontSize: token.fontSize,
                textAlign: 'center',
                visibility: 'visible',
                animationName: (0, $67ba63c38ba87091$export$3b71758b3ed5255f),
                animationDuration: token.motionDurationMid,
                animationTimingFunction: token.motionEaseOutBack,
                pointerEvents: 'none',
                '&-success': {
                    color: token.colorSuccess
                },
                '&-error': {
                    color: token.colorError
                },
                '&-warning': {
                    color: token.colorWarning
                },
                '&-validating': {
                    color: token.colorPrimary
                }
            }
        }
    };
};
const $5517d3ccd7b50da5$var$makeVerticalLayoutLabelBase = (token)=>({
        padding: token.verticalLabelPadding,
        whiteSpace: 'initial',
        textAlign: 'start',
        '> label': {
            margin: 0,
            '&::after': {
                // https://github.com/ant-design/ant-design/issues/43538
                visibility: 'hidden'
            }
        }
    });
const $5517d3ccd7b50da5$var$makeVerticalLayoutLabel = (token)=>({
        ...$5517d3ccd7b50da5$var$makeVerticalLayoutLabelBase(token),
        margin: token.verticalLabelMargin
    });
const $5517d3ccd7b50da5$var$makeVerticalLayoutLabelWithOffset = (token)=>{
    const [formVarName] = (0, $761caadb5301aee1$export$d82b8f66c5649e14)(token.antCls, 'form');
    return {
        ...$5517d3ccd7b50da5$var$makeVerticalLayoutLabelBase(token),
        [formVarName('item-label-margin')]: token.verticalLabelMargin
    };
};
const $5517d3ccd7b50da5$var$genHorizontalStyle = (token)=>{
    const { antCls: antCls, formItemCls: formItemCls } = token;
    return {
        [`${formItemCls}-horizontal`]: {
            [`${formItemCls}-label`]: {
                flexGrow: 0
            },
            [`${formItemCls}-control`]: {
                flex: '1 1 0',
                // https://github.com/ant-design/ant-design/issues/32777
                // https://github.com/ant-design/ant-design/issues/33773
                minWidth: 0
            },
            // Do not change this to `ant-col-24`! `-24` match all the responsive rules
            // https://github.com/ant-design/ant-design/issues/32980
            // https://github.com/ant-design/ant-design/issues/34903
            // https://github.com/ant-design/ant-design/issues/44538
            [`${formItemCls}-label[class$='-24'], ${formItemCls}-label[class*='-24 ']`]: {
                [`& + ${formItemCls}-control`]: {
                    minWidth: 'unset'
                }
            },
            [`> ${formItemCls}-row > ${antCls}-col-24${formItemCls}-label,
        > ${formItemCls}-row > ${antCls}-col-xl-24${formItemCls}-label`]: $5517d3ccd7b50da5$var$makeVerticalLayoutLabel(token)
        }
    };
};
const $5517d3ccd7b50da5$var$genInlineStyle = (token)=>{
    const { componentCls: componentCls, formItemCls: formItemCls, inlineItemMarginBottom: inlineItemMarginBottom } = token;
    return {
        [`${componentCls}-inline`]: {
            display: 'flex',
            flexWrap: 'wrap',
            [`${formItemCls}-inline`]: {
                flex: 'none',
                marginInlineEnd: token.margin,
                marginBottom: inlineItemMarginBottom,
                '&-row': {
                    flexWrap: 'nowrap'
                },
                [`> ${formItemCls}-label,
        > ${formItemCls}-control`]: {
                    display: 'inline-block',
                    verticalAlign: 'top'
                },
                [`> ${formItemCls}-label`]: {
                    flex: 'none'
                },
                [`${componentCls}-text`]: {
                    display: 'inline-block'
                },
                [`${formItemCls}-has-feedback`]: {
                    display: 'inline-block'
                }
            }
        }
    };
};
const $5517d3ccd7b50da5$var$makeVerticalLayout = (token)=>{
    const { componentCls: componentCls, formItemCls: formItemCls, rootPrefixCls: rootPrefixCls } = token;
    return {
        [`${formItemCls}:not(${formItemCls}-vertical) > ${formItemCls}-row > ${formItemCls}-label`]: $5517d3ccd7b50da5$var$makeVerticalLayoutLabel(token),
        // ref: https://github.com/ant-design/ant-design/issues/45122
        [`${componentCls}:not(${componentCls}-inline)`]: {
            [formItemCls]: {
                flexWrap: 'wrap',
                [`${formItemCls}-label, ${formItemCls}-control`]: {
                    // When developer pass `xs: { span }`,
                    // It should follow the `xs` screen config
                    // ref: https://github.com/ant-design/ant-design/issues/44386
                    [`&:not([class*=" ${rootPrefixCls}-col-xs"])`]: {
                        flex: '0 0 100%',
                        maxWidth: '100%'
                    }
                }
            }
        }
    };
};
const $5517d3ccd7b50da5$var$genVerticalStyle = (token)=>{
    const { componentCls: componentCls, formItemCls: formItemCls, antCls: antCls, verticalLabelHeight: verticalLabelHeight } = token;
    const [formVarName, formVarRef] = (0, $761caadb5301aee1$export$d82b8f66c5649e14)(antCls, 'form');
    return {
        [formItemCls]: {
            [formVarName('item-label-margin')]: 'initial'
        },
        [`${formItemCls}-label`]: {
            margin: formVarRef('item-label-margin')
        },
        [`${formItemCls}-vertical`]: {
            [`${formItemCls}-row`]: {
                flexDirection: 'column'
            },
            [`${formItemCls}-label > label`]: {
                height: verticalLabelHeight
            },
            [`${formItemCls}-control`]: {
                width: '100%',
                flex: 'none'
            },
            [`> ${formItemCls}-row > ${formItemCls}-label,
        > ${formItemCls}-row > ${antCls}-col-24${formItemCls}-label,
        > ${formItemCls}-row > ${antCls}-col-xl-24${formItemCls}-label`]: $5517d3ccd7b50da5$var$makeVerticalLayoutLabelWithOffset(token)
        },
        [`@media (max-width: ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.screenXSMax)})`]: [
            $5517d3ccd7b50da5$var$makeVerticalLayout(token),
            {
                [componentCls]: {
                    [`${formItemCls}:not(${formItemCls}-horizontal):not(${formItemCls}-vertical)`]: {
                        [`> ${formItemCls}-row > ${antCls}-col-xs-24${formItemCls}-label`]: $5517d3ccd7b50da5$var$makeVerticalLayoutLabel(token)
                    }
                }
            }
        ],
        [`@media (max-width: ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.screenSMMax)})`]: {
            [componentCls]: {
                [`${formItemCls}:not(${formItemCls}-horizontal):not(${formItemCls}-vertical)`]: {
                    [`> ${formItemCls}-row > ${antCls}-col-sm-24${formItemCls}-label`]: $5517d3ccd7b50da5$var$makeVerticalLayoutLabel(token)
                }
            }
        },
        [`@media (max-width: ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.screenMDMax)})`]: {
            [componentCls]: {
                [`${formItemCls}:not(${formItemCls}-horizontal):not(${formItemCls}-vertical)`]: {
                    [`> ${formItemCls}-row > ${antCls}-col-md-24${formItemCls}-label`]: $5517d3ccd7b50da5$var$makeVerticalLayoutLabel(token)
                }
            }
        },
        [`@media (max-width: ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.screenLGMax)})`]: {
            [componentCls]: {
                [`${formItemCls}:not(${formItemCls}-horizontal):not(${formItemCls}-vertical)`]: {
                    [`> ${formItemCls}-row > ${antCls}-col-lg-24${formItemCls}-label`]: $5517d3ccd7b50da5$var$makeVerticalLayoutLabel(token)
                }
            }
        }
    };
};
const $5517d3ccd7b50da5$export$9ca1be8807fe0675 = (token)=>({
        labelRequiredMarkColor: token.colorError,
        labelColor: token.colorTextHeading,
        labelFontSize: token.fontSize,
        labelHeight: token.controlHeight,
        verticalLabelHeight: token.labelHeight ?? 'auto',
        labelColonMarginInlineStart: token.marginXXS / 2,
        labelColonMarginInlineEnd: token.marginXS,
        itemMarginBottom: token.marginLG,
        verticalLabelPadding: `0 0 ${token.paddingXS}px`,
        verticalLabelMargin: 0,
        inlineItemMarginBottom: 0
    });
const $5517d3ccd7b50da5$export$362fb92a8f81bbf9 = (token, rootPrefixCls)=>{
    const formToken = (0, $f564548c7b6877d5$export$4950aa0f605343fb)(token, {
        formItemCls: `${token.componentCls}-item`,
        rootPrefixCls: rootPrefixCls
    });
    return formToken;
};
var $5517d3ccd7b50da5$export$2e2bcd8739ae039 = (0, $761caadb5301aee1$export$51ec95de45185b42)('Form', (token, { rootPrefixCls: rootPrefixCls })=>{
    const formToken = $5517d3ccd7b50da5$export$362fb92a8f81bbf9(token, rootPrefixCls);
    return [
        $5517d3ccd7b50da5$var$genFormStyle(formToken),
        $5517d3ccd7b50da5$var$genFormItemStyle(formToken),
        (0, $30329b21e3e85ee2$export$2e2bcd8739ae039)(formToken),
        $5517d3ccd7b50da5$var$genHorizontalStyle(formToken),
        $5517d3ccd7b50da5$var$genInlineStyle(formToken),
        $5517d3ccd7b50da5$var$genVerticalStyle(formToken),
        (0, $5f07542305776ab3$export$2e2bcd8739ae039)(formToken),
        (0, $67ba63c38ba87091$export$3b71758b3ed5255f)
    ];
}, $5517d3ccd7b50da5$export$9ca1be8807fe0675, {
    // Let From style before the Grid
    // ref https://github.com/ant-design/ant-design/issues/44386
    order: -1000
});


"use client";
const $31128c86bbaedc80$var$EMPTY_LIST = [];
function $31128c86bbaedc80$var$toErrorEntity(error, prefix, errorStatus, index = 0) {
    return {
        key: typeof error === 'string' ? error : `${prefix}-${index}`,
        error: error,
        errorStatus: errorStatus
    };
}
const $31128c86bbaedc80$var$ErrorList = ({ help: help, helpStatus: helpStatus, errors: errors = $31128c86bbaedc80$var$EMPTY_LIST, warnings: warnings = $31128c86bbaedc80$var$EMPTY_LIST, className: rootClassName, fieldId: fieldId, onVisibleChanged: onVisibleChanged })=>{
    const { prefixCls: prefixCls } = $5E6i4.useContext((0, $e785311f53d64def$export$fb6582d3042cc879));
    const { classNames: contextClassNames, styles: contextStyles } = $5E6i4.useContext((0, $e785311f53d64def$export$c24727297075ec6a));
    const baseClassName = `${prefixCls}-item-explain`;
    const rootCls = (0, $d104ec5f99ed66d7$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $5517d3ccd7b50da5$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const collapseMotion = $5E6i4.useMemo(()=>(0, $c2c363b881b49d51$export$2e2bcd8739ae039)(prefixCls), [
        prefixCls
    ]);
    // We have to debounce here again since somewhere use ErrorList directly still need no shaking
    // ref: https://github.com/ant-design/ant-design/issues/36336
    const debounceErrors = (0, $9a553e4a0a469bcd$export$2e2bcd8739ae039)(errors);
    const debounceWarnings = (0, $9a553e4a0a469bcd$export$2e2bcd8739ae039)(warnings);
    const hasHelp = (0, $b63de2b9864a5d1a$export$826fff653a329e83)(help);
    const fullKeyList = $5E6i4.useMemo(()=>{
        if (hasHelp) return [
            $31128c86bbaedc80$var$toErrorEntity(help, 'help', helpStatus)
        ];
        return [].concat((0, $0acfae8147afe964$export$2e2bcd8739ae039)(debounceErrors.map((error, index)=>$31128c86bbaedc80$var$toErrorEntity(error, 'error', 'error', index))), (0, $0acfae8147afe964$export$2e2bcd8739ae039)(debounceWarnings.map((warning, index)=>$31128c86bbaedc80$var$toErrorEntity(warning, 'warning', 'warning', index))));
    }, [
        help,
        helpStatus,
        hasHelp,
        debounceErrors,
        debounceWarnings
    ]);
    const filledKeyFullKeyList = $5E6i4.useMemo(()=>{
        const keysCount = {};
        fullKeyList.forEach(({ key: key })=>{
            keysCount[key] = (keysCount[key] || 0) + 1;
        });
        return fullKeyList.map((entity, index)=>({
                ...entity,
                key: keysCount[entity.key] > 1 ? `${entity.key}-fallback-${index}` : entity.key
            }));
    }, [
        fullKeyList
    ]);
    const helpProps = {};
    if (fieldId) helpProps.id = `${fieldId}_help`;
    return /*#__PURE__*/ $5E6i4.createElement((0, $5371a8954d0d2416$export$2e2bcd8739ae039), {
        motionDeadline: collapseMotion.motionDeadline,
        motionName: `${prefixCls}-show-help`,
        visible: !!filledKeyFullKeyList.length,
        onVisibleChanged: onVisibleChanged
    }, (holderProps)=>{
        const { className: holderClassName, style: holderStyle } = holderProps;
        return /*#__PURE__*/ $5E6i4.createElement("div", {
            ...helpProps,
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(baseClassName, holderClassName, contextClassNames?.help, cssVarCls, rootCls, rootClassName, hashId),
            style: {
                ...contextStyles?.help,
                ...holderStyle
            }
        }, /*#__PURE__*/ $5E6i4.createElement((0, $f8bf6ab12693d160$export$2e2bcd8739ae039), {
            keys: filledKeyFullKeyList,
            ...(0, $c2c363b881b49d51$export$2e2bcd8739ae039)(prefixCls),
            motionName: `${prefixCls}-show-help-item`,
            component: false
        }, (itemProps)=>{
            const { key: key, error: error, errorStatus: errorStatus, className: itemClassName, style: itemStyle } = itemProps;
            return /*#__PURE__*/ $5E6i4.createElement("div", {
                key: key,
                className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(itemClassName, contextClassNames?.helpItem, {
                    [`${baseClassName}-${errorStatus}`]: errorStatus
                }),
                style: {
                    ...contextStyles?.helpItem,
                    ...itemStyle
                }
            }, error);
        }));
    });
};
var $31128c86bbaedc80$export$2e2bcd8739ae039 = $31128c86bbaedc80$var$ErrorList;



var $5E6i4 = parcelRequire("5E6i4");











var $5E6i4 = parcelRequire("5E6i4");


const $84afe414f2660b16$var$t = (t)=>"object" == typeof t && null != t && 1 === t.nodeType, $84afe414f2660b16$var$e = (t, e)=>(!e || "hidden" !== t) && "visible" !== t && "clip" !== t, $84afe414f2660b16$var$n = (t, n)=>{
    if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
        const o = getComputedStyle(t, null);
        return $84afe414f2660b16$var$e(o.overflowY, n) || $84afe414f2660b16$var$e(o.overflowX, n) || ((t)=>{
            const e = ((t)=>{
                if (!t.ownerDocument || !t.ownerDocument.defaultView) return null;
                try {
                    return t.ownerDocument.defaultView.frameElement;
                } catch (t) {
                    return null;
                }
            })(t);
            return !!e && (e.clientHeight < t.scrollHeight || e.clientWidth < t.scrollWidth);
        })(t);
    }
    return !1;
}, $84afe414f2660b16$var$o = (t, e, n, o, l, r, i, s)=>r < t && i > e || r > t && i < e ? 0 : r <= t && s <= n || i >= e && s >= n ? r - t - o : i > e && s < n || r < t && s > n ? i - e + l : 0, $84afe414f2660b16$var$l = (t)=>{
    const e = t.parentElement;
    return null == e ? t.getRootNode().host || null : e;
}, $84afe414f2660b16$export$3b12cb22b12b954b = (e, r)=>{
    var i, s, d, h;
    if ("undefined" == typeof document) return [];
    const { scrollMode: c, block: f, inline: u, boundary: a, skipOverflowHiddenElements: g } = r, p = "function" == typeof a ? a : (t)=>t !== a;
    if (!$84afe414f2660b16$var$t(e)) throw new TypeError("Invalid target");
    const m = document.scrollingElement || document.documentElement, w = [];
    let W = e;
    for(; $84afe414f2660b16$var$t(W) && p(W);){
        if (W = $84afe414f2660b16$var$l(W), W === m) {
            w.push(W);
            break;
        }
        null != W && W === document.body && $84afe414f2660b16$var$n(W) && !$84afe414f2660b16$var$n(document.documentElement) || null != W && $84afe414f2660b16$var$n(W, g) && w.push(W);
    }
    const b = null != (s = null == (i = window.visualViewport) ? void 0 : i.width) ? s : innerWidth, H = null != (h = null == (d = window.visualViewport) ? void 0 : d.height) ? h : innerHeight, { scrollX: y, scrollY: M } = window, { height: v, width: E, top: x, right: C, bottom: I, left: R } = e.getBoundingClientRect(), { top: T, right: B, bottom: F, left: V } = ((t)=>{
        const e = window.getComputedStyle(t);
        return {
            top: parseFloat(e.scrollMarginTop) || 0,
            right: parseFloat(e.scrollMarginRight) || 0,
            bottom: parseFloat(e.scrollMarginBottom) || 0,
            left: parseFloat(e.scrollMarginLeft) || 0
        };
    })(e);
    let k = "start" === f || "nearest" === f ? x - T : "end" === f ? I + F : x + v / 2 - T + F, D = "center" === u ? R + E / 2 - V + B : "end" === u ? C + B : R - V;
    const L = [];
    for(let t = 0; t < w.length; t++){
        const e = w[t], { height: l, width: r, top: i, right: s, bottom: d, left: h } = e.getBoundingClientRect();
        if ("if-needed" === c && x >= 0 && R >= 0 && I <= H && C <= b && (e === m && !$84afe414f2660b16$var$n(e) || x >= i && I <= d && R >= h && C <= s)) return L;
        const a = getComputedStyle(e), g = parseInt(a.borderLeftWidth, 10), p = parseInt(a.borderTopWidth, 10), W = parseInt(a.borderRightWidth, 10), T = parseInt(a.borderBottomWidth, 10);
        let B = 0, F = 0;
        const V = "offsetWidth" in e ? e.offsetWidth - e.clientWidth - g - W : 0, S = "offsetHeight" in e ? e.offsetHeight - e.clientHeight - p - T : 0, X = "offsetWidth" in e ? 0 === e.offsetWidth ? 0 : r / e.offsetWidth : 0, Y = "offsetHeight" in e ? 0 === e.offsetHeight ? 0 : l / e.offsetHeight : 0;
        if (m === e) B = "start" === f ? k : "end" === f ? k - H : "nearest" === f ? $84afe414f2660b16$var$o(M, M + H, H, p, T, M + k, M + k + v, v) : k - H / 2, F = "start" === u ? D : "center" === u ? D - b / 2 : "end" === u ? D - b : $84afe414f2660b16$var$o(y, y + b, b, g, W, y + D, y + D + E, E), B = Math.max(0, B + M), F = Math.max(0, F + y);
        else {
            B = "start" === f ? k - i - p : "end" === f ? k - d + T + S : "nearest" === f ? $84afe414f2660b16$var$o(i, d, l, p, T + S, k, k + v, v) : k - (i + l / 2) + S / 2, F = "start" === u ? D - h - g : "center" === u ? D - (h + r / 2) + V / 2 : "end" === u ? D - s + W + V : $84afe414f2660b16$var$o(h, s, r, g, W + V, D, D + E, E);
            const { scrollLeft: t, scrollTop: n } = e;
            B = 0 === Y ? 0 : Math.max(0, Math.min(n + B / Y, e.scrollHeight - l / Y + S)), F = 0 === X ? 0 : Math.max(0, Math.min(t + F / X, e.scrollWidth - r / X + V)), k += n - B, D += t - F;
        }
        L.push({
            el: e,
            top: B,
            left: F
        });
    }
    return L;
};


const $d9106a5b9745d941$var$o = (t)=>!1 === t ? {
        block: "end",
        inline: "nearest"
    } : ((t)=>t === Object(t) && 0 !== Object.keys(t).length)(t) ? t : {
        block: "start",
        inline: "nearest"
    };
function $d9106a5b9745d941$export$2e2bcd8739ae039(e, r) {
    if (!e.isConnected || !((t)=>{
        let o = t;
        for(; o && o.parentNode;){
            if (o.parentNode === document) return !0;
            o = o.parentNode instanceof ShadowRoot ? o.parentNode.host : o.parentNode;
        }
        return !1;
    })(e)) return;
    const n = ((t)=>{
        const o = window.getComputedStyle(t);
        return {
            top: parseFloat(o.scrollMarginTop) || 0,
            right: parseFloat(o.scrollMarginRight) || 0,
            bottom: parseFloat(o.scrollMarginBottom) || 0,
            left: parseFloat(o.scrollMarginLeft) || 0
        };
    })(e);
    if (((t)=>"object" == typeof t && "function" == typeof t.behavior)(r)) return r.behavior((0, $84afe414f2660b16$export$3b12cb22b12b954b)(e, r));
    const l = "boolean" == typeof r || null == r ? void 0 : r.behavior;
    for (const { el: a, top: i, left: s } of (0, $84afe414f2660b16$export$3b12cb22b12b954b)(e, $d9106a5b9745d941$var$o(r))){
        const t = i - n.top + n.bottom, o = s - n.left + n.right;
        a.scroll({
            top: t,
            left: o,
            behavior: l
        });
    }
}



// form item name black list.  in form ,you can use form.id get the form item element.
// use object hasOwnProperty will get better performance if black list is longer.
const $f74dd4a124fbbd4c$var$formItemNameBlackList = [
    'parentNode'
];
// default form item id prefix.
const $f74dd4a124fbbd4c$var$defaultItemNamePrefixCls = 'form_item';
function $f74dd4a124fbbd4c$export$45b10814cc054894(candidate) {
    if (candidate === undefined || candidate === false) return [];
    return Array.isArray(candidate) ? candidate : [
        candidate
    ];
}
function $f74dd4a124fbbd4c$export$f4457e83c74ac000(namePath, formName) {
    if (!namePath.length) return undefined;
    const mergedId = namePath.join('_');
    if (formName) return `${formName}_${mergedId}`;
    const isIllegalName = $f74dd4a124fbbd4c$var$formItemNameBlackList.includes(mergedId);
    return isIllegalName ? `${$f74dd4a124fbbd4c$var$defaultItemNamePrefixCls}_${mergedId}` : mergedId;
}
function $f74dd4a124fbbd4c$export$b70265791d2079d4(errors, warnings, meta, defaultValidateStatus, hasFeedback, validateStatus) {
    let status = defaultValidateStatus;
    if (validateStatus !== undefined) status = validateStatus;
    else if (meta.validating) status = 'validating';
    else if (errors.length) status = 'error';
    else if (warnings.length) status = 'warning';
    else if (meta.touched || hasFeedback && meta.validated) // success feedback should display when pass hasFeedback prop and current value is valid value
    status = 'success';
    return status;
}


function $d8f08ea9dad8fd93$export$368b682c15953eea(name) {
    const namePath = (0, $f74dd4a124fbbd4c$export$45b10814cc054894)(name);
    return namePath.join('_');
}
function $d8f08ea9dad8fd93$var$getFieldDOMNode(name, wrapForm) {
    const field = wrapForm.getFieldInstance(name);
    const fieldDom = (0, $b1bf69966442e513$export$9aa546fdc20ae5b3)(field);
    if (fieldDom) return fieldDom;
    const fieldId = (0, $f74dd4a124fbbd4c$export$f4457e83c74ac000)((0, $f74dd4a124fbbd4c$export$45b10814cc054894)(name), wrapForm.__INTERNAL__.name);
    if (fieldId) return document.getElementById(fieldId);
}
function $d8f08ea9dad8fd93$export$2e2bcd8739ae039(form) {
    const [rcForm] = (0, $371286eaaac67666$export$2e2bcd8739ae039)();
    const itemsRef = $5E6i4.useRef({});
    const wrapForm = $5E6i4.useMemo(()=>form ?? {
            ...rcForm,
            __INTERNAL__: {
                itemRef: (name)=>(node)=>{
                        const namePathStr = $d8f08ea9dad8fd93$export$368b682c15953eea(name);
                        if (node) itemsRef.current[namePathStr] = node;
                        else delete itemsRef.current[namePathStr];
                    }
            },
            scrollToField: (name, options = {})=>{
                const { focus: focus, ...restOpt } = options;
                const node = $d8f08ea9dad8fd93$var$getFieldDOMNode(name, wrapForm);
                if (node) {
                    (0, $d9106a5b9745d941$export$2e2bcd8739ae039)(node, {
                        scrollMode: 'if-needed',
                        block: 'nearest',
                        ...restOpt
                    });
                    // Focus if scroll success
                    if (focus) wrapForm.focusField(name);
                }
            },
            focusField: (name)=>{
                const itemRef = wrapForm.getFieldInstance(name);
                if ((0, $addbc2fddcbb77a9$export$f6e2535fb5126e54)(itemRef?.focus)) itemRef.focus();
                else $d8f08ea9dad8fd93$var$getFieldDOMNode(name, wrapForm)?.focus?.();
            },
            getFieldInstance: (name)=>{
                const namePathStr = $d8f08ea9dad8fd93$export$368b682c15953eea(name);
                return itemsRef.current[namePathStr];
            }
        }, [
        form,
        rcForm
    ]);
    return [
        wrapForm
    ];
}





"use client";
const $3e778fbd82d716df$var$InternalForm = (props, ref)=>{
    const contextDisabled = $5E6i4.useContext((0, $2ab14018ea5b2d79$export$2e2bcd8739ae039));
    const { getPrefixCls: getPrefixCls, direction: direction, requiredMark: contextRequiredMark, colon: contextColon, scrollToFirstError: contextScrollToFirstError, className: contextClassName, style: contextStyle, styles: contextStyles, classNames: contextClassNames, tooltip: contextTooltip, labelAlign: contextLabelAlign, labelWrap: contextLabelWrap } = (0, $519f2fad435b3034$export$46f4bd6436a25a31)('form');
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, size: size, disabled: disabled = contextDisabled, form: form, colon: colon, labelAlign: labelAlign, labelWrap: labelWrap, labelCol: labelCol, wrapperCol: wrapperCol, layout: layout = 'horizontal', scrollToFirstError: scrollToFirstError, requiredMark: requiredMark, onFinishFailed: onFinishFailed, name: name, style: style, feedbackIcons: feedbackIcons, variant: variant, classNames: classNames, styles: styles, tooltip: tooltip, ...restFormProps } = props;
    const mergedSize = (0, $4bfc7567df2a969e$export$2e2bcd8739ae039)(size);
    const contextValidateMessages = $5E6i4.useContext((0, $0b2e649db3b80700$export$2e2bcd8739ae039));
    const mergedRequiredMark = $5E6i4.useMemo(()=>{
        if (requiredMark !== undefined) return requiredMark;
        if (contextRequiredMark !== undefined) return contextRequiredMark;
        return true;
    }, [
        requiredMark,
        contextRequiredMark
    ]);
    const mergedColon = colon ?? contextColon;
    const mergedLabelAlign = labelAlign ?? contextLabelAlign;
    const mergedLabelWrap = labelWrap ?? contextLabelWrap;
    const mergedTooltip = {
        ...contextTooltip,
        ...tooltip
    };
    const prefixCls = getPrefixCls('form', customizePrefixCls);
    // Style
    const rootCls = (0, $d104ec5f99ed66d7$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $5517d3ccd7b50da5$export$2e2bcd8739ae039)(prefixCls, rootCls);
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        size: mergedSize,
        disabled: disabled,
        layout: layout,
        colon: mergedColon,
        requiredMark: mergedRequiredMark,
        labelAlign: mergedLabelAlign,
        labelWrap: mergedLabelWrap
    };
    const contextStyleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $722c8632ba7bdb89$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    });
    const formClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-${layout}`, {
        [`${prefixCls}-hide-required-mark`]: mergedRequiredMark === false,
        // todo: remove in next major version
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-large`]: mergedSize === 'large',
        [`${prefixCls}-small`]: mergedSize === 'small'
    }, cssVarCls, rootCls, hashId, contextClassName, className, rootClassName, mergedClassNames.root);
    const [wrapForm] = (0, $d8f08ea9dad8fd93$export$2e2bcd8739ae039)(form);
    const { __INTERNAL__: __INTERNAL__ } = wrapForm;
    __INTERNAL__.name = name;
    const formContextValue = $5E6i4.useMemo(()=>({
            name: name,
            labelAlign: mergedLabelAlign,
            labelCol: labelCol,
            labelWrap: mergedLabelWrap,
            wrapperCol: wrapperCol,
            layout: layout,
            colon: mergedColon,
            requiredMark: mergedRequiredMark,
            itemRef: __INTERNAL__.itemRef,
            form: wrapForm,
            feedbackIcons: feedbackIcons,
            tooltip: mergedTooltip,
            classNames: mergedClassNames,
            styles: mergedStyles
        }), [
        name,
        mergedLabelAlign,
        mergedLabelWrap,
        labelCol,
        wrapperCol,
        layout,
        mergedColon,
        mergedRequiredMark,
        wrapForm,
        feedbackIcons,
        mergedClassNames,
        mergedStyles,
        mergedTooltip
    ]);
    const nativeElementRef = $5E6i4.useRef(null);
    $5E6i4.useImperativeHandle(ref, ()=>({
            ...wrapForm,
            nativeElement: nativeElementRef.current?.nativeElement
        }));
    const scrollToField = (options, fieldName)=>{
        if (options) {
            let defaultScrollToFirstError = {
                block: 'nearest'
            };
            if ((0, $addbc2fddcbb77a9$export$53b83ca8eaab0383)(options)) defaultScrollToFirstError = {
                ...defaultScrollToFirstError,
                ...options
            };
            wrapForm.scrollToField(fieldName, defaultScrollToFirstError);
        }
    };
    const onInternalFinishFailed = (errorInfo)=>{
        onFinishFailed?.(errorInfo);
        if (errorInfo.errorFields.length) {
            const fieldName = errorInfo.errorFields[0].name;
            if (scrollToFirstError !== undefined) {
                scrollToField(scrollToFirstError, fieldName);
                return;
            }
            if (contextScrollToFirstError !== undefined) scrollToField(contextScrollToFirstError, fieldName);
        }
    };
    return /*#__PURE__*/ $5E6i4.createElement((0, $e785311f53d64def$export$6f0555dad42725fb).Provider, {
        value: variant
    }, /*#__PURE__*/ $5E6i4.createElement((0, $2ab14018ea5b2d79$export$6adb5f3b918b11bb), {
        disabled: disabled
    }, /*#__PURE__*/ $5E6i4.createElement((0, $d7f139cecf1d3086$export$2e2bcd8739ae039).Provider, {
        value: mergedSize
    }, /*#__PURE__*/ $5E6i4.createElement((0, $e785311f53d64def$export$8ce1ff4f94d08846), {
        // This is not list in API, we pass with spread
        validateMessages: contextValidateMessages
    }, /*#__PURE__*/ $5E6i4.createElement((0, $e785311f53d64def$export$c24727297075ec6a).Provider, {
        value: formContextValue
    }, /*#__PURE__*/ $5E6i4.createElement((0, $e785311f53d64def$export$80e4c53cb85dcab1), {
        status: true
    }, /*#__PURE__*/ $5E6i4.createElement((0, $5119e48acb9487c1$export$2e2bcd8739ae039), {
        id: name,
        ...restFormProps,
        name: name,
        onFinishFailed: onInternalFinishFailed,
        form: wrapForm,
        ref: nativeElementRef,
        style: mergedStyles?.root,
        className: formClassName
    })))))));
};
const $3e778fbd82d716df$var$Form = /*#__PURE__*/ $5E6i4.forwardRef($3e778fbd82d716df$var$InternalForm);
var $3e778fbd82d716df$export$2e2bcd8739ae039 = $3e778fbd82d716df$var$Form;




var $5E6i4 = parcelRequire("5E6i4");











const $c2b001df316bc44b$var$useChildren = (children)=>{
    if ((0, $addbc2fddcbb77a9$export$f6e2535fb5126e54)(children)) return children;
    const childList = (0, $2ec1a2166f2295ea$export$2e2bcd8739ae039)(children);
    return childList.length <= 1 ? childList[0] : childList;
};
var $c2b001df316bc44b$export$2e2bcd8739ae039 = $c2b001df316bc44b$var$useChildren;



var $5E6i4 = parcelRequire("5E6i4");


const $08696216cca76e43$var$useFormItemStatus = ()=>{
    const { status: status, errors: errors = [], warnings: warnings = [] } = $5E6i4.useContext((0, $e785311f53d64def$export$bbb5553c6c7a14ed));
    return {
        status: status,
        errors: errors,
        warnings: warnings
    };
};
// Only used for compatible package. Not promise this will work on future version.
$08696216cca76e43$var$useFormItemStatus.Context = (0, $e785311f53d64def$export$bbb5553c6c7a14ed);
var $08696216cca76e43$export$2e2bcd8739ae039 = $08696216cca76e43$var$useFormItemStatus;



var $5E6i4 = parcelRequire("5E6i4");

function $6ec0871ca307cad3$export$2e2bcd8739ae039(defaultValue) {
    const [value, setValue] = $5E6i4.useState(defaultValue);
    const frameRef = $5E6i4.useRef(null);
    const batchRef = $5E6i4.useRef([]);
    const destroyRef = $5E6i4.useRef(false);
    $5E6i4.useEffect(()=>{
        destroyRef.current = false;
        return ()=>{
            destroyRef.current = true;
            (0, $1d949665862f071a$export$2e2bcd8739ae039).cancel(frameRef.current);
            frameRef.current = null;
        };
    }, []);
    function setFrameValue(updater) {
        if (destroyRef.current) return;
        if (frameRef.current === null) {
            batchRef.current = [];
            frameRef.current = (0, $1d949665862f071a$export$2e2bcd8739ae039)(()=>{
                frameRef.current = null;
                setValue((prevValue)=>{
                    let current = prevValue;
                    batchRef.current.forEach((func)=>{
                        current = func(current);
                    });
                    return current;
                });
            });
        }
        batchRef.current.push(updater);
    }
    return [
        value,
        setFrameValue
    ];
}



var $5E6i4 = parcelRequire("5E6i4");



const $bc8fba6392ad2f88$var$useItemRef = ()=>{
    const { itemRef: itemRef } = $5E6i4.useContext((0, $e785311f53d64def$export$c24727297075ec6a));
    const cacheRef = $5E6i4.useRef({});
    const getRef = (name, children)=>{
        // Outer caller already check the `supportRef`
        const childrenRef = children && (0, $addbc2fddcbb77a9$export$53b83ca8eaab0383)(children) && (0, $92c8c75386168ffc$export$7465e5c0bf44f19a)(children);
        const nameStr = name.join('_');
        if (cacheRef.current.name !== nameStr || cacheRef.current.originRef !== childrenRef) {
            cacheRef.current.name = nameStr;
            cacheRef.current.originRef = childrenRef;
            cacheRef.current.ref = (0, $92c8c75386168ffc$export$ab452c34e8e05029)(itemRef(name), childrenRef);
        }
        return cacheRef.current.ref;
    };
    return getRef;
};
var $bc8fba6392ad2f88$export$2e2bcd8739ae039 = $bc8fba6392ad2f88$var$useItemRef;





var $5E6i4 = parcelRequire("5E6i4");



var $5E6i4 = parcelRequire("5E6i4");



var $5E6i4 = parcelRequire("5E6i4");


const $516a7fee9bbc8875$export$74c1bf8296b1541f = [
    'xxxl',
    'xxl',
    'xl',
    'lg',
    'md',
    'sm',
    'xs'
];
const $516a7fee9bbc8875$export$9af3fe7b7131195 = [].concat($516a7fee9bbc8875$export$74c1bf8296b1541f).reverse();
const $516a7fee9bbc8875$var$getResponsiveMap = (token)=>({
        xs: `(max-width: ${token.screenXSMax}px)`,
        sm: `(min-width: ${token.screenSM}px)`,
        md: `(min-width: ${token.screenMD}px)`,
        lg: `(min-width: ${token.screenLG}px)`,
        xl: `(min-width: ${token.screenXL}px)`,
        xxl: `(min-width: ${token.screenXXL}px)`,
        xxxl: `(min-width: ${token.screenXXXL}px)`
    });
/**
 * Ensures that the breakpoints token are valid, in good order
 * For each breakpoint : screenMin <= screen <= screenMax and screenMax <= nextScreenMin
 */ const $516a7fee9bbc8875$var$validateBreakpoints = (token)=>{
    const indexableToken = token;
    const revBreakpoints = [].concat($516a7fee9bbc8875$export$74c1bf8296b1541f).reverse();
    revBreakpoints.forEach((breakpoint, i)=>{
        const breakpointUpper = breakpoint.toUpperCase();
        const screenMin = `screen${breakpointUpper}Min`;
        const screen = `screen${breakpointUpper}`;
        if (!(indexableToken[screenMin] <= indexableToken[screen])) throw new Error(`${screenMin}<=${screen} fails : !(${indexableToken[screenMin]}<=${indexableToken[screen]})`);
        if (i < revBreakpoints.length - 1) {
            const screenMax = `screen${breakpointUpper}Max`;
            if (!(indexableToken[screen] <= indexableToken[screenMax])) throw new Error(`${screen}<=${screenMax} fails : !(${indexableToken[screen]}<=${indexableToken[screenMax]})`);
            const nextBreakpointUpperMin = revBreakpoints[i + 1].toUpperCase();
            const nextScreenMin = `screen${nextBreakpointUpperMin}Min`;
            if (!(indexableToken[screenMax] <= indexableToken[nextScreenMin])) throw new Error(`${screenMax}<=${nextScreenMin} fails : !(${indexableToken[screenMax]}<=${indexableToken[nextScreenMin]})`);
        }
    });
    return token;
};
const $516a7fee9bbc8875$export$862220c15691d248 = (screens, screenSizes)=>{
    if (!screenSizes) return;
    for (const breakpoint of $516a7fee9bbc8875$export$74c1bf8296b1541f){
        if (screens[breakpoint] && screenSizes?.[breakpoint] !== undefined) return screenSizes[breakpoint];
    }
};
const $516a7fee9bbc8875$var$useResponsiveObserver = ()=>{
    const [, token] = (0, $cb3a44f4e76623bb$export$2e2bcd8739ae039)();
    const responsiveMap = $516a7fee9bbc8875$var$getResponsiveMap($516a7fee9bbc8875$var$validateBreakpoints(token));
    // To avoid repeat create instance, we add `useMemo` here.
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useMemo(()=>{
        const subscribers = new Map();
        let subUid = -1;
        let screens = {};
        return {
            responsiveMap: responsiveMap,
            matchHandlers: {},
            dispatch (pointMap) {
                screens = pointMap;
                subscribers.forEach((func)=>{
                    func(screens);
                });
                return subscribers.size >= 1;
            },
            subscribe (func) {
                if (!subscribers.size) this.register();
                subUid += 1;
                subscribers.set(subUid, func);
                func(screens);
                return subUid;
            },
            unsubscribe (paramToken) {
                subscribers.delete(paramToken);
                if (!subscribers.size) this.unregister();
            },
            register () {
                Object.entries(responsiveMap).forEach(([screen, mediaQuery])=>{
                    const listener = ({ matches: matches })=>{
                        this.dispatch({
                            ...screens,
                            [screen]: matches
                        });
                    };
                    const mql = window.matchMedia(mediaQuery);
                    if ((0, $addbc2fddcbb77a9$export$f6e2535fb5126e54)(mql.addEventListener)) mql.addEventListener('change', listener);
                    this.matchHandlers[mediaQuery] = {
                        mql: mql,
                        listener: listener
                    };
                    listener(mql);
                });
            },
            unregister () {
                Object.values(responsiveMap).forEach((mediaQuery)=>{
                    const handler = this.matchHandlers[mediaQuery];
                    if ((0, $addbc2fddcbb77a9$export$f6e2535fb5126e54)(handler?.mql.removeEventListener)) handler.mql.removeEventListener('change', handler?.listener);
                });
                subscribers.clear();
            }
        };
    }, [
        responsiveMap
    ]);
};
var $516a7fee9bbc8875$export$2e2bcd8739ae039 = $516a7fee9bbc8875$var$useResponsiveObserver;




var $5E6i4 = parcelRequire("5E6i4");



"use client";
function $0fea836ebed3c499$var$useBreakpoint(refreshOnChange = true, defaultScreens = {}) {
    const screensRef = (0, $5E6i4.useRef)(defaultScreens);
    const [, forceUpdate] = (0, $150b7c5d4f292a06$export$91db9bc4f8ac944a)();
    const responsiveObserver = (0, $516a7fee9bbc8875$export$2e2bcd8739ae039)();
    (0, $518ae471aa4f03a7$export$2e2bcd8739ae039)(()=>{
        const token = responsiveObserver.subscribe((supportScreens)=>{
            screensRef.current = supportScreens;
            if (refreshOnChange) forceUpdate();
        });
        return ()=>responsiveObserver.unsubscribe(token);
    }, [
        refreshOnChange
    ]);
    return screensRef.current;
}
var $0fea836ebed3c499$export$2e2bcd8739ae039 = $0fea836ebed3c499$var$useBreakpoint;




function $be58f2412a22140b$export$2e2bcd8739ae039(gutter, screens) {
    const results = [
        undefined,
        undefined
    ];
    const normalizedGutter = Array.isArray(gutter) ? gutter : [
        gutter,
        undefined
    ];
    // By default use as `xs`
    const mergedScreens = screens || {
        xs: true,
        sm: true,
        md: true,
        lg: true,
        xl: true,
        xxl: true,
        xxxl: true
    };
    normalizedGutter.forEach((g, index)=>{
        if ((0, $addbc2fddcbb77a9$export$53b83ca8eaab0383)(g)) for(let i = 0; i < (0, $516a7fee9bbc8875$export$74c1bf8296b1541f).length; i++){
            const breakpoint = (0, $516a7fee9bbc8875$export$74c1bf8296b1541f)[i];
            if (mergedScreens[breakpoint] && g[breakpoint] !== undefined) {
                results[index] = g[breakpoint];
                break;
            }
        }
        else results[index] = g;
    });
    return results;
}



var $5E6i4 = parcelRequire("5E6i4");
const $dccfa2aea0363e8f$var$RowContext = /*#__PURE__*/ (0, $5E6i4.createContext)({});
var $dccfa2aea0363e8f$export$2e2bcd8739ae039 = $dccfa2aea0363e8f$var$RowContext;





// ============================== Row-Shared ==============================
const $70020273e1dffc84$var$genGridRowStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        // Grid system
        [componentCls]: {
            display: 'flex',
            flexFlow: 'row wrap',
            minWidth: 0,
            '&::before, &::after': {
                display: 'flex'
            },
            '&-no-wrap': {
                flexWrap: 'nowrap'
            },
            // The origin of the X-axis
            '&-start': {
                justifyContent: 'flex-start'
            },
            // The center of the X-axis
            '&-center': {
                justifyContent: 'center'
            },
            // The opposite of the X-axis
            '&-end': {
                justifyContent: 'flex-end'
            },
            '&-space-between': {
                justifyContent: 'space-between'
            },
            '&-space-around': {
                justifyContent: 'space-around'
            },
            '&-space-evenly': {
                justifyContent: 'space-evenly'
            },
            // Align at the top
            '&-top': {
                alignItems: 'flex-start'
            },
            // Align at the center
            '&-middle': {
                alignItems: 'center'
            },
            '&-bottom': {
                alignItems: 'flex-end'
            }
        }
    };
};
// ============================== Col-Shared ==============================
const $70020273e1dffc84$var$genGridColStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        // Grid system
        [componentCls]: {
            position: 'relative',
            maxWidth: '100%',
            // Prevent columns from collapsing when empty
            minHeight: 1
        }
    };
};
const $70020273e1dffc84$var$genLoopGridColumnsStyle = (token, sizeCls)=>{
    const { componentCls: componentCls, gridColumns: gridColumns, antCls: antCls } = token;
    const [gridVarName, gridVarRef] = (0, $761caadb5301aee1$export$d82b8f66c5649e14)(antCls, 'grid');
    const [, colVarRef] = (0, $761caadb5301aee1$export$d82b8f66c5649e14)(antCls, 'col');
    const gridColumnsStyle = {};
    for(let i = gridColumns; i >= 0; i--)if (i === 0) {
        gridColumnsStyle[`${componentCls}${sizeCls}-${i}`] = {
            display: 'none'
        };
        gridColumnsStyle[`${componentCls}-push-${i}`] = {
            insetInlineStart: 'auto'
        };
        gridColumnsStyle[`${componentCls}-pull-${i}`] = {
            insetInlineEnd: 'auto'
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-push-${i}`] = {
            insetInlineStart: 'auto'
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-pull-${i}`] = {
            insetInlineEnd: 'auto'
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-offset-${i}`] = {
            marginInlineStart: 0
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-order-${i}`] = {
            order: 0
        };
    } else {
        gridColumnsStyle[`${componentCls}${sizeCls}-${i}`] = [
            // https://github.com/ant-design/ant-design/issues/44456
            // Form set `display: flex` on Col which will override `display: block`.
            // Let's get it from css variable to support override.
            {
                [gridVarName('display')]: 'block',
                // Fallback to display if variable not support
                display: 'block'
            },
            {
                display: gridVarRef('display'),
                flex: `0 0 ${i / gridColumns * 100}%`,
                maxWidth: `${i / gridColumns * 100}%`
            }
        ];
        gridColumnsStyle[`${componentCls}${sizeCls}-push-${i}`] = {
            insetInlineStart: `${i / gridColumns * 100}%`
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-pull-${i}`] = {
            insetInlineEnd: `${i / gridColumns * 100}%`
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-offset-${i}`] = {
            marginInlineStart: `${i / gridColumns * 100}%`
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-order-${i}`] = {
            order: i
        };
    }
    // Flex CSS Var
    gridColumnsStyle[`${componentCls}${sizeCls}-flex`] = {
        flex: colVarRef(`${sizeCls.replace(/-/, '')}-flex`)
    };
    return gridColumnsStyle;
};
const $70020273e1dffc84$var$genGridStyle = (token, sizeCls)=>$70020273e1dffc84$var$genLoopGridColumnsStyle(token, sizeCls);
const $70020273e1dffc84$var$genGridMediaStyle = (token, screenSize, sizeCls)=>({
        [`@media (min-width: ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(screenSize)})`]: {
            ...$70020273e1dffc84$var$genGridStyle(token, sizeCls)
        }
    });
const $70020273e1dffc84$export$519f4f378a4f8e85 = ()=>({});
const $70020273e1dffc84$export$5504d86ab3175593 = ()=>({});
const $70020273e1dffc84$export$b0d9c6b8be4e14cd = (0, $761caadb5301aee1$export$51ec95de45185b42)('Grid', $70020273e1dffc84$var$genGridRowStyle, $70020273e1dffc84$export$519f4f378a4f8e85);
const $70020273e1dffc84$export$6353f655434817c5 = (token)=>{
    const mediaSizesMap = {
        xs: token.screenXSMin,
        sm: token.screenSMMin,
        md: token.screenMDMin,
        lg: token.screenLGMin,
        xl: token.screenXLMin,
        xxl: token.screenXXLMin,
        xxxl: token.screenXXXLMin
    };
    return mediaSizesMap;
};
const $70020273e1dffc84$export$4d3e83959861592f = (0, $761caadb5301aee1$export$51ec95de45185b42)('Grid', (token)=>{
    const gridToken = (0, $f564548c7b6877d5$export$4950aa0f605343fb)(token, {
        gridColumns: 24 // Row is divided into 24 parts in Grid
    });
    const gridMediaSizesMap = $70020273e1dffc84$export$6353f655434817c5(gridToken);
    delete gridMediaSizesMap.xs;
    return [
        $70020273e1dffc84$var$genGridColStyle(gridToken),
        $70020273e1dffc84$var$genGridStyle(gridToken, ''),
        $70020273e1dffc84$var$genGridStyle(gridToken, '-xs'),
        Object.keys(gridMediaSizesMap).map((key)=>$70020273e1dffc84$var$genGridMediaStyle(gridToken, gridMediaSizesMap[key], `-${key}`)).reduce((pre, cur)=>({
                ...pre,
                ...cur
            }), {})
    ];
}, $70020273e1dffc84$export$5504d86ab3175593);


"use client";
const $4510a048fee5b223$var$_RowAligns = [
    'top',
    'middle',
    'bottom',
    'stretch'
];
const $4510a048fee5b223$var$_RowJustify = [
    'start',
    'end',
    'center',
    'space-around',
    'space-between',
    'space-evenly'
];
const $4510a048fee5b223$var$getMergedPropByScreen = (oriProp, screen)=>{
    if ((0, $addbc2fddcbb77a9$export$844ec244b1367d54)(oriProp)) return oriProp;
    if ((0, $addbc2fddcbb77a9$export$53b83ca8eaab0383)(oriProp)) for(let i = 0; i < (0, $516a7fee9bbc8875$export$74c1bf8296b1541f).length; i++){
        const breakpoint = (0, $516a7fee9bbc8875$export$74c1bf8296b1541f)[i];
        if (!screen || !screen[breakpoint]) continue;
        const curVal = oriProp[breakpoint];
        if (curVal !== undefined) return curVal;
    }
    return '';
};
const $4510a048fee5b223$var$Row = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, justify: justify, align: align, className: className, style: style, children: children, gutter: gutter = 0, wrap: wrap, ...others } = props;
    const { getPrefixCls: getPrefixCls, direction: direction } = $5E6i4.useContext((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
    const screens = (0, $0fea836ebed3c499$export$2e2bcd8739ae039)(true, null);
    const mergedAlign = $4510a048fee5b223$var$getMergedPropByScreen(align, screens);
    const mergedJustify = $4510a048fee5b223$var$getMergedPropByScreen(justify, screens);
    const prefixCls = getPrefixCls('row', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $70020273e1dffc84$export$b0d9c6b8be4e14cd)(prefixCls);
    const gutters = (0, $be58f2412a22140b$export$2e2bcd8739ae039)(gutter, screens);
    const classes = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, {
        [`${prefixCls}-no-wrap`]: wrap === false,
        [`${prefixCls}-${mergedJustify}`]: mergedJustify,
        [`${prefixCls}-${mergedAlign}`]: mergedAlign,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, className, hashId, cssVarCls);
    // Add gutter related style
    const rowStyle = {};
    if (gutters?.[0]) {
        const horizontalGutter = (0, $addbc2fddcbb77a9$export$7e4aa119212bc614)(gutters[0]) ? `${gutters[0] / -2}px` : `calc(${gutters[0]} / -2)`;
        rowStyle.marginInline = horizontalGutter;
    }
    // "gutters" is a new array in each rendering phase, it'll make 'React.useMemo' effectless.
    // So we deconstruct "gutters" variable here.
    const [gutterH, gutterV] = gutters;
    rowStyle.rowGap = gutterV;
    const rowContext = $5E6i4.useMemo(()=>({
            gutter: [
                gutterH,
                gutterV
            ],
            wrap: wrap
        }), [
        gutterH,
        gutterV,
        wrap
    ]);
    return /*#__PURE__*/ $5E6i4.createElement((0, $dccfa2aea0363e8f$export$2e2bcd8739ae039).Provider, {
        value: rowContext
    }, /*#__PURE__*/ $5E6i4.createElement("div", {
        ...others,
        className: classes,
        style: {
            ...rowStyle,
            ...style
        },
        ref: ref
    }, children));
});
var $4510a048fee5b223$export$2e2bcd8739ae039 = $4510a048fee5b223$var$Row;





var $5E6i4 = parcelRequire("5E6i4");





var $5E6i4 = parcelRequire("5E6i4");








"use client";
function $fc63721f75259c62$var$parseFlex(flex) {
    if (flex === 'auto') return '1 1 auto';
    if ((0, $addbc2fddcbb77a9$export$7e4aa119212bc614)(flex)) return `${flex} ${flex} auto`;
    if (/^\d+(\.\d+)?(px|em|rem|%)$/.test(flex)) return `0 0 ${flex}`;
    return flex;
}
const $fc63721f75259c62$var$Col = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { getPrefixCls: getPrefixCls, direction: direction } = $5E6i4.useContext((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
    const { gutter: gutter, wrap: wrap } = $5E6i4.useContext((0, $dccfa2aea0363e8f$export$2e2bcd8739ae039));
    const { prefixCls: customizePrefixCls, span: span, order: order, offset: offset, push: push, pull: pull, className: className, children: children, flex: flex, style: style, ...others } = props;
    const prefixCls = getPrefixCls('col', customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const [hashId, cssVarCls] = (0, $70020273e1dffc84$export$4d3e83959861592f)(prefixCls);
    const [varName] = (0, $761caadb5301aee1$export$d82b8f66c5649e14)(rootPrefixCls, 'col');
    // ===================== Size ======================
    const sizeStyle = {};
    let sizeClassObj = {};
    (0, $516a7fee9bbc8875$export$9af3fe7b7131195).forEach((size)=>{
        let sizeProps = {};
        const propSize = props[size];
        if ((0, $addbc2fddcbb77a9$export$7e4aa119212bc614)(propSize)) sizeProps.span = propSize;
        else if ((0, $addbc2fddcbb77a9$export$53b83ca8eaab0383)(propSize)) sizeProps = propSize || {};
        delete others[size];
        sizeClassObj = {
            ...sizeClassObj,
            [`${prefixCls}-${size}-${sizeProps.span}`]: (0, $b63de2b9864a5d1a$export$826fff653a329e83)(sizeProps.span),
            [`${prefixCls}-${size}-order-${sizeProps.order}`]: sizeProps.order || sizeProps.order === 0,
            [`${prefixCls}-${size}-offset-${sizeProps.offset}`]: sizeProps.offset || sizeProps.offset === 0,
            [`${prefixCls}-${size}-push-${sizeProps.push}`]: sizeProps.push || sizeProps.push === 0,
            [`${prefixCls}-${size}-pull-${sizeProps.pull}`]: sizeProps.pull || sizeProps.pull === 0,
            [`${prefixCls}-rtl`]: direction === 'rtl'
        };
        // Responsive flex layout
        if (sizeProps.flex || sizeProps.flex === 0) {
            sizeClassObj[`${prefixCls}-${size}-flex`] = true;
            sizeStyle[varName(`${size}-flex`)] = $fc63721f75259c62$var$parseFlex(sizeProps.flex);
        }
    });
    // ==================== Normal =====================
    const classes = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, {
        [`${prefixCls}-${span}`]: span !== undefined,
        [`${prefixCls}-order-${order}`]: order,
        [`${prefixCls}-offset-${offset}`]: offset,
        [`${prefixCls}-push-${push}`]: push,
        [`${prefixCls}-pull-${pull}`]: pull
    }, className, sizeClassObj, hashId, cssVarCls);
    const mergedStyle = {};
    // Horizontal gutter use padding
    if (gutter?.[0]) {
        const horizontalGutter = (0, $addbc2fddcbb77a9$export$7e4aa119212bc614)(gutter[0]) ? `${gutter[0] / 2}px` : `calc(${gutter[0]} / 2)`;
        mergedStyle.paddingInline = horizontalGutter;
    }
    if (flex || flex === 0) {
        mergedStyle.flex = $fc63721f75259c62$var$parseFlex(flex);
        // Hack for Firefox to avoid size issue
        // https://github.com/ant-design/ant-design/pull/20023#issuecomment-564389553
        if (wrap === false && !mergedStyle.minWidth) mergedStyle.minWidth = 0;
    }
    // ==================== Render =====================
    return /*#__PURE__*/ $5E6i4.createElement("div", {
        ...others,
        style: {
            ...mergedStyle,
            ...style,
            ...sizeStyle
        },
        className: classes,
        ref: ref
    }, children);
});
var $fc63721f75259c62$export$2e2bcd8739ae039 = $fc63721f75259c62$var$Col;




/**
 * Fallback of IE.
 * Safe to remove.
 */ 

// ============================= Fallback =============================
const $fe7e65cdf305fc7c$var$genFallbackStyle = (token)=>{
    const { formItemCls: formItemCls } = token;
    return {
        '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)': {
            // Fallback for IE, safe to remove we not support it anymore
            [`${formItemCls}-control`]: {
                display: 'flex'
            }
        }
    };
};
var // ============================== Export ==============================
$fe7e65cdf305fc7c$export$2e2bcd8739ae039 = (0, $761caadb5301aee1$export$1537386bc155ea56)([
    'Form',
    'item-item'
], (token, { rootPrefixCls: rootPrefixCls })=>{
    const formToken = (0, $5517d3ccd7b50da5$export$362fb92a8f81bbf9)(token, rootPrefixCls);
    return $fe7e65cdf305fc7c$var$genFallbackStyle(formToken);
});


"use client";
const $eda00fb363a3e548$var$GRID_MAX = 24;
const $eda00fb363a3e548$var$FormItemInput = (props)=>{
    const { prefixCls: prefixCls, status: status, labelCol: labelCol, wrapperCol: wrapperCol, children: children, errors: errors, warnings: warnings, _internalItemRender: formItemRender, extra: extra, help: help, fieldId: fieldId, marginBottom: marginBottom, onErrorVisibleChanged: onErrorVisibleChanged, label: label } = props;
    const baseClassName = `${prefixCls}-item`;
    const formContext = $5E6i4.useContext((0, $e785311f53d64def$export$c24727297075ec6a));
    const { classNames: contextClassNames, styles: contextStyles } = formContext;
    const mergedWrapperCol = $5E6i4.useMemo(()=>{
        let mergedWrapper = {
            ...wrapperCol || formContext.wrapperCol || {}
        };
        if (label === null && !labelCol && !wrapperCol && formContext.labelCol) {
            const list = [
                undefined
            ].concat((0, $0acfae8147afe964$export$2e2bcd8739ae039)((0, $516a7fee9bbc8875$export$9af3fe7b7131195)));
            list.forEach((size)=>{
                const _size = size ? [
                    size
                ] : [];
                const formLabel = (0, $0dd37614b50139aa$export$2e2bcd8739ae039)(formContext.labelCol, _size);
                const formLabelObj = (0, $addbc2fddcbb77a9$export$53b83ca8eaab0383)(formLabel) ? formLabel : {};
                const wrapper = (0, $0dd37614b50139aa$export$2e2bcd8739ae039)(mergedWrapper, _size);
                const wrapperObj = (0, $addbc2fddcbb77a9$export$53b83ca8eaab0383)(wrapper) ? wrapper : {};
                if ('span' in formLabelObj && !('offset' in wrapperObj) && formLabelObj.span < $eda00fb363a3e548$var$GRID_MAX) mergedWrapper = (0, $4eb3db67adf477c8$export$2e2bcd8739ae039)(mergedWrapper, [].concat(_size, [
                    'offset'
                ]), formLabelObj.span);
            });
        }
        return mergedWrapper;
    }, [
        wrapperCol,
        formContext.wrapperCol,
        formContext.labelCol,
        label,
        labelCol
    ]);
    const className = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${baseClassName}-control`, mergedWrapperCol.className);
    // Pass to sub FormItem should not with col info
    const subFormContext = $5E6i4.useMemo(()=>{
        const { labelCol: _labelCol, wrapperCol: _wrapperCol, ...rest } = formContext;
        return rest;
    }, [
        formContext
    ]);
    const extraRef = $5E6i4.useRef(null);
    const [extraHeight, setExtraHeight] = $5E6i4.useState(0);
    const hasExtra = (0, $b63de2b9864a5d1a$export$72280d5f896dac9a)(extra);
    (0, $518ae471aa4f03a7$export$2e2bcd8739ae039)(()=>{
        if (hasExtra && extraRef.current) setExtraHeight(extraRef.current.clientHeight);
        else setExtraHeight(0);
    }, [
        extra,
        hasExtra
    ]);
    const inputDom = /*#__PURE__*/ $5E6i4.createElement("div", {
        className: `${baseClassName}-control-input`
    }, /*#__PURE__*/ $5E6i4.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${baseClassName}-control-input-content`, contextClassNames?.content),
        style: contextStyles?.content
    }, children));
    const formItemContext = $5E6i4.useMemo(()=>({
            prefixCls: prefixCls,
            status: status
        }), [
        prefixCls,
        status
    ]);
    const errorListDom = marginBottom !== null || errors.length || warnings.length ? /*#__PURE__*/ $5E6i4.createElement((0, $e785311f53d64def$export$fb6582d3042cc879).Provider, {
        value: formItemContext
    }, /*#__PURE__*/ $5E6i4.createElement((0, $31128c86bbaedc80$export$2e2bcd8739ae039), {
        fieldId: fieldId,
        errors: errors,
        warnings: warnings,
        help: help,
        helpStatus: status,
        className: `${baseClassName}-explain-connected`,
        onVisibleChanged: onErrorVisibleChanged
    })) : null;
    const extraProps = {};
    if (fieldId) extraProps.id = `${fieldId}_extra`;
    const extraDom = hasExtra ? /*#__PURE__*/ $5E6i4.createElement("div", {
        ...extraProps,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${baseClassName}-extra`, contextClassNames?.extra),
        style: contextStyles?.extra,
        ref: extraRef
    }, extra) : null;
    const additionalDom = errorListDom || extraDom ? /*#__PURE__*/ $5E6i4.createElement("div", {
        className: `${baseClassName}-additional`,
        style: marginBottom ? {
            minHeight: marginBottom + extraHeight
        } : {}
    }, errorListDom, extraDom) : null;
    const dom = formItemRender && formItemRender.mark === 'pro_table_render' && formItemRender.render ? formItemRender.render(props, {
        input: inputDom,
        errorList: errorListDom,
        extra: extraDom
    }) : /*#__PURE__*/ $5E6i4.createElement($5E6i4.Fragment, null, inputDom, additionalDom);
    return /*#__PURE__*/ $5E6i4.createElement((0, $e785311f53d64def$export$c24727297075ec6a).Provider, {
        value: subFormContext
    }, /*#__PURE__*/ $5E6i4.createElement((0, $fc63721f75259c62$export$2e2bcd8739ae039), {
        ...mergedWrapperCol,
        className: className
    }, dom), /*#__PURE__*/ $5E6i4.createElement((0, $fe7e65cdf305fc7c$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }));
};
var $eda00fb363a3e548$export$2e2bcd8739ae039 = $eda00fb363a3e548$var$FormItemInput;



var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $4e298923df720322$var$QuestionCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0130.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1080 0 40 40 0 10-80 0z"
                }
            }
        ]
    },
    "name": "question-circle",
    "theme": "outlined"
};
var $4e298923df720322$export$2e2bcd8739ae039 = $4e298923df720322$var$QuestionCircleOutlined;



function $f572dd29a59c22b6$var$_extends() {
    $f572dd29a59c22b6$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f572dd29a59c22b6$var$_extends.apply(this, arguments);
}
const $f572dd29a59c22b6$var$QuestionCircleOutlined = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $f572dd29a59c22b6$var$_extends({}, props, {
        ref: ref,
        icon: (0, $4e298923df720322$export$2e2bcd8739ae039)
    }));
/**![question-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0wIDgyMGMtMjA1LjQgMC0zNzItMTY2LjYtMzcyLTM3MnMxNjYuNi0zNzIgMzcyLTM3MiAzNzIgMTY2LjYgMzcyIDM3Mi0xNjYuNiAzNzItMzcyIDM3MnoiIC8+PHBhdGggZD0iTTYyMy42IDMxNi43QzU5My42IDI5MC40IDU1NCAyNzYgNTEyIDI3NnMtODEuNiAxNC41LTExMS42IDQwLjdDMzY5LjIgMzQ0IDM1MiAzODAuNyAzNTIgNDIwdjcuNmMwIDQuNCAzLjYgOCA4IDhoNDhjNC40IDAgOC0zLjYgOC04VjQyMGMwLTQ0LjEgNDMuMS04MCA5Ni04MHM5NiAzNS45IDk2IDgwYzAgMzEuMS0yMiA1OS42LTU2LjEgNzIuNy0yMS4yIDguMS0zOS4yIDIyLjMtNTIuMSA0MC45LTEzLjEgMTktMTkuOSA0MS44LTE5LjkgNjQuOVY2MjBjMCA0LjQgMy42IDggOCA4aDQ4YzQuNCAwIDgtMy42IDgtOHYtMjIuN2E0OC4zIDQ4LjMgMCAwMTMwLjktNDQuOGM1OS0yMi43IDk3LjEtNzQuNyA5Ny4xLTEzMi41LjEtMzkuMy0xNy4xLTc2LTQ4LjMtMTAzLjN6TTQ3MiA3MzJhNDAgNDAgMCAxMDgwIDAgNDAgNDAgMCAxMC04MCAweiIgLz48L3N2Zz4=) */ const $f572dd29a59c22b6$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($f572dd29a59c22b6$var$QuestionCircleOutlined);
var $f572dd29a59c22b6$export$2e2bcd8739ae039 = $f572dd29a59c22b6$var$RefIcon;





var $5E6i4 = parcelRequire("5E6i4");


const $c2e65c60caae4ac1$var$convertToTooltipProps = (tooltip, context)=>{
    if (!(0, $b63de2b9864a5d1a$export$72280d5f896dac9a)(tooltip)) return null;
    if ((0, $addbc2fddcbb77a9$export$53b83ca8eaab0383)(tooltip) && !/*#__PURE__*/ (0, $5E6i4.isValidElement)(tooltip)) return {
        ...context,
        ...tooltip
    };
    return {
        ...context,
        title: tooltip
    };
};
var $c2e65c60caae4ac1$export$2e2bcd8739ae039 = $c2e65c60caae4ac1$var$convertToTooltipProps;








"use client";
const $2e07bca864158234$var$FormItemLabel = ({ prefixCls: prefixCls, label: label, htmlFor: htmlFor, labelCol: labelCol, labelAlign: labelAlign, colon: colon, required: required, requiredMark: requiredMark, tooltip: tooltip, vertical: vertical })=>{
    const [formLocale] = (0, $a2f3e1f88973a5e2$export$2e2bcd8739ae039)('Form');
    const { labelAlign: contextLabelAlign, labelCol: contextLabelCol, labelWrap: labelWrap, colon: contextColon, classNames: contextClassNames, styles: contextStyles, tooltip: contextTooltip } = $5E6i4.useContext((0, $e785311f53d64def$export$c24727297075ec6a));
    if (!(0, $b63de2b9864a5d1a$export$72280d5f896dac9a)(label)) return null;
    const mergedLabelCol = labelCol || contextLabelCol || {};
    const mergedLabelAlign = labelAlign || contextLabelAlign;
    const labelClsBasic = `${prefixCls}-item-label`;
    const labelColClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(labelClsBasic, mergedLabelAlign === 'left' && `${labelClsBasic}-left`, mergedLabelCol.className, {
        [`${labelClsBasic}-wrap`]: !!labelWrap
    });
    let labelChildren = label;
    // Keep label is original where there should have no colon
    const computedColon = colon === true || contextColon !== false && colon !== false;
    const haveColon = computedColon && !vertical;
    // Remove duplicated user input colon
    if (haveColon && typeof label === 'string' && label.trim()) labelChildren = label.replace(/[:|：]\s*$/, '');
    const tooltipProps = (0, $c2e65c60caae4ac1$export$2e2bcd8739ae039)(tooltip, contextTooltip);
    if (tooltipProps) {
        const tooltipNode = /*#__PURE__*/ $5E6i4.createElement((0, $1bb718ecb5669b36$export$2e2bcd8739ae039), {
            ...tooltipProps
        }, /*#__PURE__*/ $5E6i4.createElement("span", {
            className: `${prefixCls}-item-tooltip`,
            onClick: (e)=>{
                e.preventDefault();
            },
            tabIndex: -1
        }, tooltipProps.icon || tooltipProps.children || /*#__PURE__*/ $5E6i4.createElement((0, $f572dd29a59c22b6$export$2e2bcd8739ae039), null)));
        labelChildren = /*#__PURE__*/ $5E6i4.createElement($5E6i4.Fragment, null, labelChildren, tooltipNode);
    }
    // Required Mark
    const isOptionalMark = requiredMark === 'optional';
    const isRenderMark = (0, $addbc2fddcbb77a9$export$f6e2535fb5126e54)(requiredMark);
    const hideRequiredMark = requiredMark === false;
    if (isRenderMark) labelChildren = requiredMark(labelChildren, {
        required: !!required
    });
    else if (isOptionalMark && !required) labelChildren = /*#__PURE__*/ $5E6i4.createElement($5E6i4.Fragment, null, labelChildren, /*#__PURE__*/ $5E6i4.createElement("span", {
        className: `${prefixCls}-item-optional`
    }, formLocale?.optional || (0, $7a40da28675d08a9$export$2e2bcd8739ae039).Form?.optional));
    // https://github.com/ant-design/ant-design/pull/52950#discussion_r1980880316
    let markType;
    if (hideRequiredMark) markType = 'hidden';
    else if (isOptionalMark || isRenderMark) markType = 'optional';
    const labelClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(contextClassNames?.label, {
        [`${prefixCls}-item-required`]: required,
        [`${prefixCls}-item-required-mark-${markType}`]: markType,
        [`${prefixCls}-item-no-colon`]: !computedColon
    });
    return /*#__PURE__*/ $5E6i4.createElement((0, $fc63721f75259c62$export$2e2bcd8739ae039), {
        ...mergedLabelCol,
        className: labelColClassName
    }, /*#__PURE__*/ $5E6i4.createElement("label", {
        htmlFor: htmlFor,
        className: labelClassName,
        style: contextStyles?.label,
        title: typeof label === 'string' ? label : undefined
    }, labelChildren));
};
var $2e07bca864158234$export$2e2bcd8739ae039 = $2e07bca864158234$var$FormItemLabel;





var $5E6i4 = parcelRequire("5E6i4");







"use client";
const $b9d431d24975c6ea$var$iconMap = {
    success: (0, $b89ac8aaffc055f4$export$2e2bcd8739ae039),
    warning: (0, $02cacf707e93d6b4$export$2e2bcd8739ae039),
    error: (0, $18493f15518cd625$export$2e2bcd8739ae039),
    validating: (0, $6e3183dc0ea574da$export$2e2bcd8739ae039)
};
function $b9d431d24975c6ea$var$StatusProvider({ children: children, errors: errors, warnings: warnings, hasFeedback: hasFeedback, validateStatus: validateStatus, prefixCls: prefixCls, meta: meta, noStyle: noStyle, name: name }) {
    const itemPrefixCls = `${prefixCls}-item`;
    const { feedbackIcons: feedbackIcons } = $5E6i4.useContext((0, $e785311f53d64def$export$c24727297075ec6a));
    const mergedValidateStatus = (0, $f74dd4a124fbbd4c$export$b70265791d2079d4)(errors, warnings, meta, null, !!hasFeedback, validateStatus);
    const { isFormItemInput: parentIsFormItemInput, status: parentStatus, hasFeedback: parentHasFeedback, feedbackIcon: parentFeedbackIcon, name: parentName } = $5E6i4.useContext((0, $e785311f53d64def$export$bbb5553c6c7a14ed));
    // ====================== Context =======================
    const formItemStatusContext = $5E6i4.useMemo(()=>{
        let feedbackIcon;
        if (hasFeedback) {
            const customIcons = hasFeedback !== true && hasFeedback.icons || feedbackIcons;
            const customIconNode = mergedValidateStatus && customIcons?.({
                status: mergedValidateStatus,
                errors: errors,
                warnings: warnings
            })?.[mergedValidateStatus];
            const IconNode = mergedValidateStatus ? $b9d431d24975c6ea$var$iconMap[mergedValidateStatus] : null;
            feedbackIcon = customIconNode !== false && IconNode ? /*#__PURE__*/ $5E6i4.createElement("span", {
                className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${itemPrefixCls}-feedback-icon`, `${itemPrefixCls}-feedback-icon-${mergedValidateStatus}`)
            }, customIconNode || /*#__PURE__*/ $5E6i4.createElement(IconNode, null)) : null;
        }
        const context = {
            status: mergedValidateStatus || '',
            errors: errors,
            warnings: warnings,
            hasFeedback: !!hasFeedback,
            feedbackIcon: feedbackIcon,
            isFormItemInput: true,
            name: name
        };
        // No style will follow parent context
        if (noStyle) {
            context.status = (mergedValidateStatus ?? parentStatus) || '';
            context.isFormItemInput = parentIsFormItemInput;
            context.hasFeedback = !!(hasFeedback ?? parentHasFeedback);
            context.feedbackIcon = hasFeedback !== undefined ? context.feedbackIcon : parentFeedbackIcon;
            context.name = name ?? parentName;
        }
        return context;
    }, [
        mergedValidateStatus,
        errors,
        warnings,
        hasFeedback,
        feedbackIcons,
        noStyle,
        name,
        parentIsFormItemInput,
        parentStatus,
        itemPrefixCls,
        parentHasFeedback,
        parentFeedbackIcon,
        parentName
    ]);
    // ======================= Render =======================
    return /*#__PURE__*/ $5E6i4.createElement((0, $e785311f53d64def$export$bbb5553c6c7a14ed).Provider, {
        value: formItemStatusContext
    }, children);
}
var $b9d431d24975c6ea$export$2e2bcd8739ae039 = $b9d431d24975c6ea$var$StatusProvider;


"use client";
function $425680646b7dbf32$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, className: className, rootClassName: rootClassName, style: style, help: help, errors: errors, warnings: warnings, validateStatus: validateStatus, meta: meta, hasFeedback: hasFeedback, hidden: hidden, children: children, fieldId: fieldId, required: required, isRequired: isRequired, onSubItemMetaChange: onSubItemMetaChange, layout: propsLayout, name: name, ...restProps } = props;
    const itemPrefixCls = `${prefixCls}-item`;
    const { requiredMark: requiredMark, layout: formLayout } = $5E6i4.useContext((0, $e785311f53d64def$export$c24727297075ec6a));
    const layout = propsLayout || formLayout;
    const vertical = layout === 'vertical';
    // ======================== Margin ========================
    const itemRef = $5E6i4.useRef(null);
    const debounceErrors = (0, $9a553e4a0a469bcd$export$2e2bcd8739ae039)(errors);
    const debounceWarnings = (0, $9a553e4a0a469bcd$export$2e2bcd8739ae039)(warnings);
    const hasHelp = (0, $b63de2b9864a5d1a$export$826fff653a329e83)(help);
    const hasError = !!(hasHelp || debounceErrors.length || debounceWarnings.length);
    const isOnScreen = !!itemRef.current && (0, $8fba40dfe94c55fb$export$2e2bcd8739ae039)(itemRef.current);
    const [marginBottom, setMarginBottom] = $5E6i4.useState(null);
    (0, $518ae471aa4f03a7$export$2e2bcd8739ae039)(()=>{
        if (hasError && itemRef.current) {
            // The element must be part of the DOMTree to use getComputedStyle
            // https://stackoverflow.com/questions/35360711/getcomputedstyle-returns-a-cssstyledeclaration-but-all-properties-are-empty-on-a
            const itemStyle = getComputedStyle(itemRef.current);
            setMarginBottom(Number.parseInt(itemStyle.marginBottom, 10));
        }
    }, [
        hasError,
        isOnScreen
    ]);
    const onErrorVisibleChanged = (nextVisible)=>{
        if (!nextVisible && !hasError) setMarginBottom(null);
    };
    // ======================== Status ========================
    const getValidateState = (isDebounce = false)=>{
        const _errors = isDebounce ? debounceErrors : meta.errors;
        const _warnings = isDebounce ? debounceWarnings : meta.warnings;
        return (0, $f74dd4a124fbbd4c$export$b70265791d2079d4)(_errors, _warnings, meta, '', !!hasFeedback, validateStatus);
    };
    const mergedValidateStatus = getValidateState();
    // ======================== Render ========================
    const itemClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(itemPrefixCls, className, rootClassName, {
        [`${itemPrefixCls}-with-help`]: hasHelp || debounceErrors.length || debounceWarnings.length,
        // Status
        [`${itemPrefixCls}-has-feedback`]: mergedValidateStatus && hasFeedback,
        [`${itemPrefixCls}-has-success`]: mergedValidateStatus === 'success',
        [`${itemPrefixCls}-has-warning`]: mergedValidateStatus === 'warning',
        [`${itemPrefixCls}-has-error`]: mergedValidateStatus === 'error',
        [`${itemPrefixCls}-is-validating`]: mergedValidateStatus === 'validating',
        [`${itemPrefixCls}-hidden`]: hidden,
        // Layout
        [`${itemPrefixCls}-${layout}`]: layout
    });
    return /*#__PURE__*/ $5E6i4.createElement("div", {
        className: itemClassName,
        style: style,
        ref: itemRef
    }, /*#__PURE__*/ $5E6i4.createElement((0, $4510a048fee5b223$export$2e2bcd8739ae039), {
        className: `${itemPrefixCls}-row`,
        ...(0, $48bd91d9f828de66$export$2e2bcd8739ae039)(restProps, [
            '_internalItemRender',
            'colon',
            'dependencies',
            'extra',
            'fieldKey',
            'getValueFromEvent',
            'getValueProps',
            'htmlFor',
            'id',
            // It is deprecated because `htmlFor` is its replacement.
            'initialValue',
            'isListField',
            'label',
            'labelAlign',
            'labelCol',
            'labelWrap',
            'messageVariables',
            'name',
            'normalize',
            'noStyle',
            'preserve',
            'requiredMark',
            'rules',
            'shouldUpdate',
            'trigger',
            'tooltip',
            'validateFirst',
            'validateTrigger',
            'valuePropName',
            'wrapperCol',
            'validateDebounce'
        ])
    }, /*#__PURE__*/ $5E6i4.createElement((0, $2e07bca864158234$export$2e2bcd8739ae039), {
        htmlFor: fieldId,
        ...props,
        requiredMark: requiredMark,
        required: required ?? isRequired,
        prefixCls: prefixCls,
        vertical: vertical
    }), /*#__PURE__*/ $5E6i4.createElement((0, $eda00fb363a3e548$export$2e2bcd8739ae039), {
        ...props,
        ...meta,
        errors: debounceErrors,
        warnings: debounceWarnings,
        prefixCls: prefixCls,
        status: mergedValidateStatus,
        help: help,
        marginBottom: marginBottom,
        onErrorVisibleChanged: onErrorVisibleChanged
    }, /*#__PURE__*/ $5E6i4.createElement((0, $e785311f53d64def$export$d718247e9f9b0b9e).Provider, {
        value: onSubItemMetaChange
    }, /*#__PURE__*/ $5E6i4.createElement((0, $b9d431d24975c6ea$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        meta: meta,
        errors: meta.errors,
        warnings: meta.warnings,
        hasFeedback: hasFeedback,
        // Already calculated
        validateStatus: mergedValidateStatus,
        name: name
    }, children)))), !!marginBottom && /*#__PURE__*/ $5E6i4.createElement("div", {
        className: `${itemPrefixCls}-margin-offset`,
        style: {
            marginBottom: -marginBottom
        }
    }));
}



"use client";
const $7d0427eb4310afbd$var$NAME_SPLIT = '__SPLIT__';
const $7d0427eb4310afbd$var$_ValidateStatuses = [
    'success',
    'warning',
    'error',
    'validating',
    ''
];
// https://github.com/ant-design/ant-design/issues/46417
// `getValueProps` may modify the value props name,
// we should check if the control is similar.
function $7d0427eb4310afbd$var$isSimilarControl(a, b) {
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
    return keysA.length === keysB.length && keysA.every((key)=>{
        const propValueA = a[key];
        const propValueB = b[key];
        return propValueA === propValueB || (0, $addbc2fddcbb77a9$export$f6e2535fb5126e54)(propValueA) || (0, $addbc2fddcbb77a9$export$f6e2535fb5126e54)(propValueB);
    });
}
const $7d0427eb4310afbd$var$MemoInput = /*#__PURE__*/ $5E6i4.memo((props)=>props.children, (prev, next)=>$7d0427eb4310afbd$var$isSimilarControl(prev.control, next.control) && prev.update === next.update && prev.childProps.length === next.childProps.length && prev.childProps.every((value, index)=>value === next.childProps[index]));
function $7d0427eb4310afbd$var$genEmptyMeta() {
    return {
        errors: [],
        warnings: [],
        touched: false,
        validating: false,
        name: [],
        validated: false
    };
}
function $7d0427eb4310afbd$var$InternalFormItem(props) {
    const { name: name, noStyle: noStyle, className: className, dependencies: dependencies, prefixCls: customizePrefixCls, shouldUpdate: shouldUpdate, rules: rules, children: children, required: required, label: label, messageVariables: messageVariables, trigger: trigger = 'onChange', validateTrigger: validateTrigger, hidden: hidden, help: help, layout: layout } = props;
    const { getPrefixCls: getPrefixCls } = $5E6i4.useContext((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
    const { name: formName } = $5E6i4.useContext((0, $e785311f53d64def$export$c24727297075ec6a));
    const mergedChildren = (0, $c2b001df316bc44b$export$2e2bcd8739ae039)(children);
    const isRenderProps = (0, $addbc2fddcbb77a9$export$f6e2535fb5126e54)(mergedChildren);
    const notifyParentMetaChange = $5E6i4.useContext((0, $e785311f53d64def$export$d718247e9f9b0b9e));
    const { validateTrigger: contextValidateTrigger } = $5E6i4.useContext((0, $4eb49d26951fd5b1$export$2e2bcd8739ae039));
    const mergedValidateTrigger = (0, $b63de2b9864a5d1a$export$826fff653a329e83)(validateTrigger) ? validateTrigger : contextValidateTrigger;
    const hasName = (0, $b63de2b9864a5d1a$export$826fff653a329e83)(name);
    const prefixCls = getPrefixCls('form', customizePrefixCls);
    // Style
    const rootCls = (0, $d104ec5f99ed66d7$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $5517d3ccd7b50da5$export$2e2bcd8739ae039)(prefixCls, rootCls);
    // ========================= Warn =========================
    const warning = (0, $bedf93c14dee83a9$export$e02e8dff7b78de83)('Form.Item');
    // ========================= MISC =========================
    // Get `noStyle` required info
    const listContext = $5E6i4.useContext((0, $3befa91cc1f10543$export$2e2bcd8739ae039));
    const fieldKeyPathRef = $5E6i4.useRef(null);
    // ======================== Errors ========================
    // >>>>> Collect sub field errors
    const [subFieldErrors, setSubFieldErrors] = (0, $6ec0871ca307cad3$export$2e2bcd8739ae039)({});
    // >>>>> Current field errors
    const [meta, setMeta] = (0, $42260c70cd082563$export$2e2bcd8739ae039)(()=>$7d0427eb4310afbd$var$genEmptyMeta());
    const onMetaChange = (nextMeta)=>{
        // This keyInfo is not correct when field is removed
        // Since origin keyManager no longer keep the origin key anymore
        // Which means we need cache origin one and reuse when removed
        const keyInfo = listContext?.getKey(nextMeta.name);
        // Destroy will reset all the meta
        setMeta(nextMeta.destroy ? $7d0427eb4310afbd$var$genEmptyMeta() : nextMeta, true);
        // Bump to parent since noStyle
        if (noStyle && help !== false && notifyParentMetaChange) {
            let namePath = nextMeta.name;
            if (!nextMeta.destroy) {
                if (keyInfo !== undefined) {
                    const [fieldKey, restPath] = keyInfo;
                    namePath = [
                        fieldKey
                    ].concat((0, $0acfae8147afe964$export$2e2bcd8739ae039)(restPath));
                    fieldKeyPathRef.current = namePath;
                }
            } else // Use origin cache data
            namePath = fieldKeyPathRef.current || namePath;
            notifyParentMetaChange(nextMeta, namePath);
        }
    };
    // >>>>> Collect noStyle Field error to the top FormItem
    const onSubItemMetaChange = (subMeta, uniqueKeys)=>{
        // Only `noStyle` sub item will trigger
        setSubFieldErrors((prevSubFieldErrors)=>{
            const clone = {
                ...prevSubFieldErrors
            };
            // name: ['user', 1] + key: [4] = ['user', 4]
            const mergedNamePath = [].concat((0, $0acfae8147afe964$export$2e2bcd8739ae039)(subMeta.name.slice(0, -1)), (0, $0acfae8147afe964$export$2e2bcd8739ae039)(uniqueKeys));
            const mergedNameKey = mergedNamePath.join($7d0427eb4310afbd$var$NAME_SPLIT);
            if (subMeta.destroy) // Remove
            delete clone[mergedNameKey];
            else // Update
            clone[mergedNameKey] = subMeta;
            return clone;
        });
    };
    // >>>>> Get merged errors
    const [mergedErrors, mergedWarnings] = $5E6i4.useMemo(()=>{
        const errorList = (0, $0acfae8147afe964$export$2e2bcd8739ae039)(meta.errors);
        const warningList = (0, $0acfae8147afe964$export$2e2bcd8739ae039)(meta.warnings);
        Object.values(subFieldErrors).forEach((subFieldError)=>{
            errorList.push.apply(errorList, (0, $0acfae8147afe964$export$2e2bcd8739ae039)(subFieldError.errors || []));
            warningList.push.apply(warningList, (0, $0acfae8147afe964$export$2e2bcd8739ae039)(subFieldError.warnings || []));
        });
        return [
            errorList,
            warningList
        ];
    }, [
        subFieldErrors,
        meta.errors,
        meta.warnings
    ]);
    // ===================== Children Ref =====================
    const getItemRef = (0, $bc8fba6392ad2f88$export$2e2bcd8739ae039)();
    // ======================== Render ========================
    function renderLayout(baseChildren, fieldId, isRequired) {
        if (noStyle && !hidden) return /*#__PURE__*/ $5E6i4.createElement((0, $b9d431d24975c6ea$export$2e2bcd8739ae039), {
            prefixCls: prefixCls,
            hasFeedback: props.hasFeedback,
            validateStatus: props.validateStatus,
            meta: meta,
            errors: mergedErrors,
            warnings: mergedWarnings,
            noStyle: true,
            name: name
        }, baseChildren);
        return /*#__PURE__*/ $5E6i4.createElement((0, $425680646b7dbf32$export$2e2bcd8739ae039), {
            key: "row",
            ...props,
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(className, cssVarCls, rootCls, hashId),
            prefixCls: prefixCls,
            fieldId: fieldId,
            isRequired: isRequired,
            errors: mergedErrors,
            warnings: mergedWarnings,
            meta: meta,
            onSubItemMetaChange: onSubItemMetaChange,
            layout: layout,
            name: name
        }, baseChildren);
    }
    if (!hasName && !isRenderProps && !dependencies) return renderLayout(mergedChildren);
    let variables = {};
    if (typeof label === 'string') variables.label = label;
    else if (name) variables.label = String(name);
    if (messageVariables) variables = {
        ...variables,
        ...messageVariables
    };
    // >>>>> With Field
    return /*#__PURE__*/ $5E6i4.createElement((0, $a17e0c124d87e81c$export$2e2bcd8739ae039), {
        ...props,
        messageVariables: variables,
        trigger: trigger,
        validateTrigger: mergedValidateTrigger,
        onMetaChange: onMetaChange
    }, (control, renderMeta, context)=>{
        const mergedName = (0, $f74dd4a124fbbd4c$export$45b10814cc054894)(name).length && renderMeta ? renderMeta.name : [];
        const fieldId = (0, $f74dd4a124fbbd4c$export$f4457e83c74ac000)(mergedName, formName);
        const isRequired = required !== undefined ? required : rules?.some((rule)=>{
            if ((0, $addbc2fddcbb77a9$export$53b83ca8eaab0383)(rule) && rule.required && !rule.warningOnly) return true;
            if ((0, $addbc2fddcbb77a9$export$f6e2535fb5126e54)(rule)) {
                const ruleEntity = rule(context);
                return ruleEntity?.required && !ruleEntity?.warningOnly;
            }
            return false;
        });
        // ======================= Children =======================
        const mergedControl = {
            ...control
        };
        let childNode = null;
        if (Array.isArray(mergedChildren) && hasName) childNode = mergedChildren;
        else if (isRenderProps && (!(shouldUpdate || dependencies) || hasName)) ;
        else if (dependencies && !isRenderProps && !hasName) ;
        else if (/*#__PURE__*/ $5E6i4.isValidElement(mergedChildren)) {
            const childProps = {
                ...mergedChildren.props,
                ...mergedControl
            };
            if (!childProps.id) childProps.id = fieldId;
            const hasExtra = (0, $b63de2b9864a5d1a$export$72280d5f896dac9a)(props.extra);
            if (help || mergedErrors.length > 0 || mergedWarnings.length > 0 || hasExtra) {
                const describedbyArr = [];
                if (help || mergedErrors.length > 0) describedbyArr.push(`${fieldId}_help`);
                if (hasExtra) describedbyArr.push(`${fieldId}_extra`);
                childProps['aria-describedby'] = describedbyArr.join(' ');
            }
            if (mergedErrors.length > 0) childProps['aria-invalid'] = 'true';
            if (isRequired) childProps['aria-required'] = 'true';
            if ((0, $92c8c75386168ffc$export$c1cec34af06bcf7)(mergedChildren)) childProps.ref = getItemRef(mergedName, mergedChildren);
            // We should keep user origin event handler
            const triggers = new Set([].concat((0, $0acfae8147afe964$export$2e2bcd8739ae039)((0, $f74dd4a124fbbd4c$export$45b10814cc054894)(trigger)), (0, $0acfae8147afe964$export$2e2bcd8739ae039)((0, $f74dd4a124fbbd4c$export$45b10814cc054894)(mergedValidateTrigger))));
            triggers.forEach((eventName)=>{
                childProps[eventName] = (...args)=>{
                    mergedControl[eventName]?.(...args);
                    mergedChildren.props[eventName]?.(...args);
                };
            });
            // List of props that need to be watched for changes -> if changes are detected in MemoInput -> rerender
            const watchingChildProps = [
                childProps['aria-required'],
                childProps['aria-invalid'],
                childProps['aria-describedby']
            ];
            childNode = /*#__PURE__*/ $5E6i4.createElement($7d0427eb4310afbd$var$MemoInput, {
                control: mergedControl,
                update: mergedChildren,
                childProps: watchingChildProps
            }, (0, $552e20b6ec4e63a6$export$e530037191fcd5d7)(mergedChildren, childProps));
        } else if (isRenderProps && (shouldUpdate || dependencies) && !hasName) childNode = mergedChildren(context);
        else childNode = mergedChildren;
        return renderLayout(childNode, fieldId, isRequired);
    });
}
const $7d0427eb4310afbd$var$FormItem = $7d0427eb4310afbd$var$InternalFormItem;
$7d0427eb4310afbd$var$FormItem.useStatus = (0, $08696216cca76e43$export$2e2bcd8739ae039);
var $7d0427eb4310afbd$export$2e2bcd8739ae039 = $7d0427eb4310afbd$var$FormItem;



var $5E6i4 = parcelRequire("5E6i4");





"use client";
const $cf50ce13144cc077$var$FormList = ({ prefixCls: customizePrefixCls, children: children, ...props })=>{
    const { getPrefixCls: getPrefixCls } = $5E6i4.useContext((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('form', customizePrefixCls);
    const contextValue = $5E6i4.useMemo(()=>({
            prefixCls: prefixCls,
            status: 'error'
        }), [
        prefixCls
    ]);
    return /*#__PURE__*/ $5E6i4.createElement((0, $5564230e782827e0$export$2e2bcd8739ae039), {
        ...props
    }, (fields, operation, meta)=>/*#__PURE__*/ $5E6i4.createElement((0, $e785311f53d64def$export$fb6582d3042cc879).Provider, {
            value: contextValue
        }, children(fields.map((field)=>({
                ...field,
                fieldKey: field.key
            })), operation, {
            errors: meta.errors,
            warnings: meta.warnings
        })));
};
var $cf50ce13144cc077$export$2e2bcd8739ae039 = $cf50ce13144cc077$var$FormList;



var $5E6i4 = parcelRequire("5E6i4");

function $3d5f7aa855429512$export$2e2bcd8739ae039() {
    const { form: form } = $5E6i4.useContext((0, $e785311f53d64def$export$c24727297075ec6a));
    return form;
}


"use client";
const $500c6374712950d2$var$Form = (0, $3e778fbd82d716df$export$2e2bcd8739ae039);
$500c6374712950d2$var$Form.Item = (0, $7d0427eb4310afbd$export$2e2bcd8739ae039);
$500c6374712950d2$var$Form.List = (0, $cf50ce13144cc077$export$2e2bcd8739ae039);
$500c6374712950d2$var$Form.ErrorList = (0, $31128c86bbaedc80$export$2e2bcd8739ae039);
$500c6374712950d2$var$Form.useForm = (0, $d8f08ea9dad8fd93$export$2e2bcd8739ae039);
$500c6374712950d2$var$Form.useFormInstance = (0, $3d5f7aa855429512$export$2e2bcd8739ae039);
$500c6374712950d2$var$Form.useWatch = (0, $879990ccad36e4bf$export$2e2bcd8739ae039);
$500c6374712950d2$var$Form.Provider = (0, $e785311f53d64def$export$8ce1ff4f94d08846);
var $500c6374712950d2$export$2e2bcd8739ae039 = $500c6374712950d2$var$Form;


var $5E6i4 = parcelRequire("5E6i4");





var $5E6i4 = parcelRequire("5E6i4");








var $5E6i4 = parcelRequire("5E6i4");

const $b3482faf6dda424f$export$c0a98b854d121670 = (mask, maskClosable)=>{
    let maskConfig = {};
    if ((0, $addbc2fddcbb77a9$export$53b83ca8eaab0383)(mask)) // Copy so that filling `closable` below never writes back to the user's `mask` object
    maskConfig = {
        ...mask
    };
    if (typeof mask === 'boolean') maskConfig = {
        enabled: mask
    };
    if (maskConfig.closable === undefined && maskClosable !== undefined) maskConfig.closable = maskClosable;
    return maskConfig;
};
const $b3482faf6dda424f$export$a4ac1bdd74570410 = (mask, contextMask, prefixCls, maskClosable)=>{
    return (0, $5E6i4.useMemo)(()=>{
        const maskConfig = $b3482faf6dda424f$export$c0a98b854d121670(mask, maskClosable);
        const contextMaskConfig = $b3482faf6dda424f$export$c0a98b854d121670(contextMask);
        const mergedConfig = {
            blur: false,
            ...contextMaskConfig,
            ...maskConfig,
            closable: maskConfig.closable ?? maskClosable ?? contextMaskConfig.closable ?? true
        };
        const className = mergedConfig.blur ? `${prefixCls}-mask-blur` : undefined;
        return [
            mergedConfig.enabled !== false,
            {
                mask: className
            },
            !!mergedConfig.closable
        ];
    }, [
        mask,
        contextMask,
        prefixCls,
        maskClosable
    ]);
};










var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");




"use client";
const $6876735e3ab2dfcd$var$ActionButton = (props)=>{
    const { type: type, children: children, prefixCls: prefixCls, buttonProps: buttonProps, close: close, autoFocus: autoFocus, emitEvent: emitEvent, isSilent: isSilent, quitOnNullishReturnValue: quitOnNullishReturnValue, actionFn: actionFn } = props;
    const clickedRef = $5E6i4.useRef(false);
    const buttonRef = $5E6i4.useRef(null);
    const [loading, setLoading] = (0, $42260c70cd082563$export$2e2bcd8739ae039)(false);
    const onInternalClose = (...args)=>{
        close?.(...args);
    };
    $5E6i4.useEffect(()=>{
        let timeoutId = null;
        if (autoFocus) timeoutId = setTimeout(()=>{
            buttonRef.current?.focus({
                preventScroll: true
            });
        });
        return ()=>{
            if (timeoutId) clearTimeout(timeoutId);
        };
    }, [
        autoFocus
    ]);
    const handlePromiseOnOk = (returnValueOfOnOk)=>{
        if (!(0, $addbc2fddcbb77a9$export$f5b060c2914b97c8)(returnValueOfOnOk)) return;
        setLoading(true);
        returnValueOfOnOk.then((...args)=>{
            setLoading(false, true);
            onInternalClose.apply(void 0, args);
            clickedRef.current = false;
        }, (e)=>{
            // See: https://github.com/ant-design/ant-design/issues/6183
            setLoading(false, true);
            clickedRef.current = false;
            // Do not throw if is `await` mode
            if (isSilent?.()) return;
            return Promise.reject(e);
        });
    };
    const onClick = (e)=>{
        if (clickedRef.current) return;
        clickedRef.current = true;
        if (!actionFn) {
            onInternalClose();
            return;
        }
        let returnValueOfOnOk;
        if (emitEvent) {
            returnValueOfOnOk = actionFn(e);
            if (quitOnNullishReturnValue && !(0, $addbc2fddcbb77a9$export$f5b060c2914b97c8)(returnValueOfOnOk)) {
                clickedRef.current = false;
                onInternalClose(e);
                return;
            }
        } else if (actionFn.length) {
            returnValueOfOnOk = actionFn(close);
            // https://github.com/ant-design/ant-design/issues/23358
            clickedRef.current = false;
        } else {
            returnValueOfOnOk = actionFn();
            if (!(0, $addbc2fddcbb77a9$export$f5b060c2914b97c8)(returnValueOfOnOk)) {
                onInternalClose();
                return;
            }
        }
        handlePromiseOnOk(returnValueOfOnOk);
    };
    return /*#__PURE__*/ $5E6i4.createElement((0, $17f39e4db74a8975$export$2e2bcd8739ae039), {
        ...(0, $0ceddc1355cab302$export$19bc9a290855952)(type),
        onClick: onClick,
        loading: loading,
        prefixCls: prefixCls,
        ...buttonProps,
        ref: buttonRef
    }, children);
};
var $6876735e3ab2dfcd$export$2e2bcd8739ae039 = $6876735e3ab2dfcd$var$ActionButton;



var $5E6i4 = parcelRequire("5E6i4");
const $d91b78c27439fbf5$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createContext({});
const { Provider: $d91b78c27439fbf5$export$7c9538f5f3c365e9 } = $d91b78c27439fbf5$export$ab57792b9b6974a6;


"use client";
const $4483c8ba9379f48f$var$ConfirmCancelBtn = ()=>{
    const { autoFocusButton: autoFocusButton, cancelButtonProps: cancelButtonProps, cancelTextLocale: cancelTextLocale, isSilent: isSilent, mergedOkCancel: mergedOkCancel, rootPrefixCls: rootPrefixCls, close: close, onCancel: onCancel, onConfirm: onConfirm, onClose: onClose } = (0, $5E6i4.useContext)((0, $d91b78c27439fbf5$export$ab57792b9b6974a6));
    return mergedOkCancel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $6876735e3ab2dfcd$export$2e2bcd8739ae039), {
        isSilent: isSilent,
        actionFn: onCancel,
        close: (...args)=>{
            close?.(...args);
            onConfirm?.(false);
            onClose?.();
        },
        autoFocus: autoFocusButton === 'cancel',
        buttonProps: cancelButtonProps,
        prefixCls: `${rootPrefixCls}-btn`
    }, cancelTextLocale) : null;
};
var $4483c8ba9379f48f$export$2e2bcd8739ae039 = $4483c8ba9379f48f$var$ConfirmCancelBtn;



var $5E6i4 = parcelRequire("5E6i4");


"use client";
const $856ada7f26ae4641$var$ConfirmOkBtn = ()=>{
    const { autoFocusButton: autoFocusButton, close: close, isSilent: isSilent, okButtonProps: okButtonProps, rootPrefixCls: rootPrefixCls, okTextLocale: okTextLocale, okType: okType, onConfirm: onConfirm, onOk: onOk, onClose: onClose } = (0, $5E6i4.useContext)((0, $d91b78c27439fbf5$export$ab57792b9b6974a6));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $6876735e3ab2dfcd$export$2e2bcd8739ae039), {
        isSilent: isSilent,
        type: okType || 'primary',
        actionFn: onOk,
        close: (...args)=>{
            close?.(...args);
            onConfirm?.(true);
            onClose?.();
        },
        autoFocus: autoFocusButton === 'ok',
        buttonProps: okButtonProps,
        prefixCls: `${rootPrefixCls}-btn`
    }, okTextLocale);
};
var $856ada7f26ae4641$export$2e2bcd8739ae039 = $856ada7f26ae4641$var$ConfirmOkBtn;




var $5E6i4 = parcelRequire("5E6i4");



var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");
const $df35dcd6d6437f6a$export$ee4e38b469b6f5d1 = /*#__PURE__*/ $5E6i4.createContext({});





var $5E6i4 = parcelRequire("5E6i4");
// =============================== Motion ===============================
function $c8811d69162483ae$export$ec1a7ebf4579c1c3(prefixCls, transitionName, animationName) {
    let motionName = transitionName;
    if (!motionName && animationName) motionName = `${prefixCls}-${animationName}`;
    return motionName;
}
// =============================== Offset ===============================
function $c8811d69162483ae$var$getScroll(w, top) {
    let ret = w[`page${top ? 'Y' : 'X'}Offset`];
    const method = `scroll${top ? 'Top' : 'Left'}`;
    if (typeof ret !== 'number') {
        const d = w.document;
        ret = d.documentElement[method];
        if (typeof ret !== 'number') ret = d.body[method];
    }
    return ret;
}
function $c8811d69162483ae$export$cc800923e997bb8(el) {
    const rect = el.getBoundingClientRect();
    const pos = {
        left: rect.left,
        top: rect.top
    };
    const doc = el.ownerDocument;
    const w = doc.defaultView || doc.parentWindow;
    pos.left += $c8811d69162483ae$var$getScroll(w);
    pos.top += $c8811d69162483ae$var$getScroll(w, true);
    return pos;
}



var $5E6i4 = parcelRequire("5E6i4");






var $5E6i4 = parcelRequire("5E6i4");


var $5E6i4 = parcelRequire("5E6i4");
var $bc9f03f59f424ee8$export$2e2bcd8739ae039 = /*#__PURE__*/ $5E6i4.memo(({ children: children })=>children, (_, { shouldUpdate: shouldUpdate })=>!shouldUpdate);


function $6cfb0b1093c47c51$var$_extends() {
    $6cfb0b1093c47c51$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6cfb0b1093c47c51$var$_extends.apply(this, arguments);
}
const $6cfb0b1093c47c51$var$Panel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, className: className, style: style, title: title, ariaId: ariaId, footer: footer, closable: closable, closeIcon: closeIcon, onClose: onClose, children: children, bodyStyle: bodyStyle, bodyProps: bodyProps, modalRender: modalRender, onMouseDown: onMouseDown, onMouseUp: onMouseUp, holderRef: holderRef, visible: visible, forceRender: forceRender, width: width, height: height, classNames: modalClassNames, styles: modalStyles, isFixedPos: isFixedPos, focusTrap: focusTrap } = props;
    // ================================= Refs =================================
    const { panel: panelRef } = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useContext((0, $df35dcd6d6437f6a$export$ee4e38b469b6f5d1));
    const internalRef = (0, $5E6i4.useRef)(null);
    const mergedRef = (0, $92c8c75386168ffc$export$1d1c999670a1285d)(holderRef, panelRef, internalRef);
    const [ignoreElement] = (0, $806ab00ed04609c6$export$9e3bf6f439c42dc9)(visible && isFixedPos && focusTrap !== false, ()=>internalRef.current);
    (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useImperativeHandle(ref, ()=>({
            focus: ()=>{
                internalRef.current?.focus({
                    preventScroll: true
                });
            }
        }));
    // ================================ Style =================================
    const contentStyle = {};
    if (width !== undefined) contentStyle.width = width;
    if (height !== undefined) contentStyle.height = height;
    // ================================ Render ================================
    const footerNode = footer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-footer`, modalClassNames?.footer),
        style: {
            ...modalStyles?.footer
        }
    }, footer) : null;
    const headerNode = title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-header`, modalClassNames?.header),
        style: {
            ...modalStyles?.header
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-title`, modalClassNames?.title),
        id: ariaId,
        style: {
            ...modalStyles?.title
        }
    }, title)) : null;
    const closableObj = (0, $5E6i4.useMemo)(()=>{
        if (typeof closable === 'object' && closable !== null) return closable;
        if (closable) return {
            closeIcon: closeIcon ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("span", {
                className: `${prefixCls}-close-x`
            })
        };
        return {};
    }, [
        closable,
        closeIcon,
        prefixCls
    ]);
    const ariaProps = (0, $78cde6532419ffca$export$2e2bcd8739ae039)(closableObj, true);
    const closeBtnIsDisabled = typeof closable === 'object' && closable.disabled;
    const closerNode = closable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("button", $6cfb0b1093c47c51$var$_extends({
        type: "button",
        onClick: onClose,
        "aria-label": "Close"
    }, ariaProps, {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-close`, modalClassNames?.close),
        disabled: closeBtnIsDisabled,
        style: modalStyles?.close
    }), closableObj.closeIcon) : null;
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-container`, modalClassNames?.container),
        style: modalStyles?.container
    }, closerNode, headerNode, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("div", $6cfb0b1093c47c51$var$_extends({
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-body`, modalClassNames?.body),
        style: {
            ...bodyStyle,
            ...modalStyles?.body
        }
    }, bodyProps), children), footerNode);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("div", {
        key: "dialog-element",
        role: "dialog",
        "aria-labelledby": title ? ariaId : null,
        "aria-modal": "true",
        ref: mergedRef,
        style: {
            ...style,
            ...contentStyle
        },
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, className),
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        tabIndex: -1,
        onFocus: (e)=>{
            ignoreElement(e.target);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $bc9f03f59f424ee8$export$2e2bcd8739ae039), {
        shouldUpdate: visible || forceRender
    }, modalRender ? modalRender(content) : content));
});
var $6cfb0b1093c47c51$export$2e2bcd8739ae039 = $6cfb0b1093c47c51$var$Panel;


function $f7616f6f6b9329f4$var$_extends() {
    $f7616f6f6b9329f4$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f7616f6f6b9329f4$var$_extends.apply(this, arguments);
}
const $f7616f6f6b9329f4$var$Content = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, title: title, style: style, className: className, visible: visible, forceRender: forceRender, destroyOnHidden: destroyOnHidden, motionName: motionName, ariaId: ariaId, onVisibleChanged: onVisibleChanged, mousePosition: mousePosition } = props;
    const dialogRef = (0, $5E6i4.useRef)(null);
    const panelRef = (0, $5E6i4.useRef)(null);
    // ============================== Refs ==============================
    $5E6i4.useImperativeHandle(ref, ()=>({
            ...panelRef.current,
            inMotion: dialogRef.current.inMotion,
            enableMotion: dialogRef.current.enableMotion
        }));
    // ============================= Style ==============================
    const [transformOrigin, setTransformOrigin] = $5E6i4.useState();
    const contentStyle = {};
    if (transformOrigin) contentStyle.transformOrigin = transformOrigin;
    function onPrepare() {
        if (!dialogRef.current?.nativeElement) return;
        const elementOffset = (0, $c8811d69162483ae$export$cc800923e997bb8)(dialogRef.current.nativeElement);
        setTransformOrigin(mousePosition && (mousePosition.x || mousePosition.y) ? `${mousePosition.x - elementOffset.left}px ${mousePosition.y - elementOffset.top}px` : '');
    }
    // ============================= Render =============================
    return /*#__PURE__*/ $5E6i4.createElement((0, $5371a8954d0d2416$export$2e2bcd8739ae039), {
        visible: visible,
        onVisibleChanged: onVisibleChanged,
        onAppearPrepare: onPrepare,
        onEnterPrepare: onPrepare,
        forceRender: forceRender,
        motionName: motionName,
        removeOnLeave: destroyOnHidden,
        ref: dialogRef
    }, ({ className: motionClassName, style: motionStyle }, motionRef)=>/*#__PURE__*/ $5E6i4.createElement((0, $6cfb0b1093c47c51$export$2e2bcd8739ae039), $f7616f6f6b9329f4$var$_extends({}, props, {
            ref: panelRef,
            title: title,
            ariaId: ariaId,
            prefixCls: prefixCls,
            holderRef: motionRef,
            style: {
                ...motionStyle,
                ...style,
                ...contentStyle
            },
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(className, motionClassName)
        })));
});
var $f7616f6f6b9329f4$export$2e2bcd8739ae039 = $f7616f6f6b9329f4$var$Content;



var $5E6i4 = parcelRequire("5E6i4");


function $8f2913c3cde96757$var$_extends() {
    $8f2913c3cde96757$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8f2913c3cde96757$var$_extends.apply(this, arguments);
}
const $8f2913c3cde96757$var$Mask = (props)=>{
    const { prefixCls: prefixCls, style: style, visible: visible, maskProps: maskProps, motionName: motionName, className: className } = props;
    return /*#__PURE__*/ $5E6i4.createElement((0, $5371a8954d0d2416$export$2e2bcd8739ae039), {
        key: "mask",
        visible: visible,
        motionName: motionName,
        leavedClassName: `${prefixCls}-mask-hidden`
    }, ({ className: motionClassName, style: motionStyle }, ref)=>/*#__PURE__*/ $5E6i4.createElement("div", $8f2913c3cde96757$var$_extends({
            ref: ref,
            style: {
                ...motionStyle,
                ...style
            },
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-mask`, motionClassName, className)
        }, maskProps)));
};
var $8f2913c3cde96757$export$2e2bcd8739ae039 = $8f2913c3cde96757$var$Mask;


function $010aee5ffbfa5438$var$_extends() {
    $010aee5ffbfa5438$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $010aee5ffbfa5438$var$_extends.apply(this, arguments);
}
const $010aee5ffbfa5438$var$Dialog = (props)=>{
    const { prefixCls: prefixCls = 'rc-dialog', zIndex: zIndex, visible: visible = false, focusTriggerAfterClose: focusTriggerAfterClose = true, wrapStyle: wrapStyle, wrapClassName: wrapClassName, wrapProps: wrapProps, onClose: onClose, afterOpenChange: afterOpenChange, afterClose: afterClose, transitionName: // Dialog
    transitionName, animation: animation, closable: closable = true, mask: // Mask
    mask = true, maskTransitionName: maskTransitionName, maskAnimation: maskAnimation, maskClosable: maskClosable = true, maskStyle: maskStyle, maskProps: maskProps, rootClassName: rootClassName, rootStyle: rootStyle, classNames: modalClassNames, styles: modalStyles } = props;
    var prop;
    const lastOutSideActiveElementRef = (0, $5E6i4.useRef)(null);
    const wrapperRef = (0, $5E6i4.useRef)(null);
    const contentRef = (0, $5E6i4.useRef)(null);
    const [animatedVisible, setAnimatedVisible] = $5E6i4.useState(visible);
    const [isFixedPos, setIsFixedPos] = $5E6i4.useState(false);
    // ========================== Init ==========================
    const ariaId = (0, $378d6dcdebc6b864$export$2e2bcd8739ae039)();
    function saveLastOutSideActiveElementRef() {
        if (!(0, $e13c8a0b3403715d$export$2e2bcd8739ae039)(wrapperRef.current, document.activeElement)) lastOutSideActiveElementRef.current = document.activeElement;
    }
    function focusDialogContent() {
        if (!(0, $e13c8a0b3403715d$export$2e2bcd8739ae039)(wrapperRef.current, document.activeElement)) contentRef.current?.focus();
    }
    // ========================= Events =========================
    // Close action will trigger by:
    //   1. When hide motion end
    //   2. Controlled `open` to `false` immediately after set to `true` which will not trigger motion
    function doClose() {
        // Clean up scroll bar & focus back
        setAnimatedVisible(false);
        if (mask && lastOutSideActiveElementRef.current && focusTriggerAfterClose) {
            try {
                lastOutSideActiveElementRef.current.focus({
                    preventScroll: true
                });
            } catch (e) {
            // Do nothing
            }
            lastOutSideActiveElementRef.current = null;
        }
        // Trigger afterClose only when change visible from true to false
        if (animatedVisible) afterClose?.();
    }
    function onDialogVisibleChanged(newVisible) {
        // Try to focus
        if (newVisible) focusDialogContent();
        else doClose();
        afterOpenChange?.(newVisible);
    }
    function onInternalClose(e) {
        onClose?.(e);
    }
    // >>> Content
    const mouseDownOnMaskRef = (0, $5E6i4.useRef)(false);
    // >>> Wrapper
    // Close only when element not on dialog
    let onWrapperClick = null;
    if (maskClosable) onWrapperClick = (e)=>{
        if (wrapperRef.current === e.target && mouseDownOnMaskRef.current) onInternalClose(e);
    };
    function onWrapperMouseDown(e) {
        mouseDownOnMaskRef.current = e.target === wrapperRef.current;
    }
    // ========================= Effect =========================
    (0, $5E6i4.useEffect)(()=>{
        if (visible) {
            mouseDownOnMaskRef.current = false;
            setAnimatedVisible(true);
            saveLastOutSideActiveElementRef();
            // Calc the position style
            if (wrapperRef.current) {
                const computedWrapStyle = getComputedStyle(wrapperRef.current);
                setIsFixedPos(computedWrapStyle.position === 'fixed');
            }
        } else if (animatedVisible && contentRef.current.enableMotion() && !contentRef.current.inMotion()) doClose();
    }, [
        visible
    ]);
    const mergedStyle = {
        zIndex: zIndex,
        ...wrapStyle,
        ...modalStyles?.wrapper,
        display: !animatedVisible ? 'none' : null
    };
    // ========================= Render =========================
    return /*#__PURE__*/ $5E6i4.createElement("div", $010aee5ffbfa5438$var$_extends({
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-root`, rootClassName),
        style: rootStyle
    }, (0, $78cde6532419ffca$export$2e2bcd8739ae039)(props, {
        data: true
    })), /*#__PURE__*/ $5E6i4.createElement((0, $8f2913c3cde96757$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        visible: mask && visible,
        motionName: (0, $c8811d69162483ae$export$ec1a7ebf4579c1c3)(prefixCls, maskTransitionName, maskAnimation),
        style: {
            zIndex: zIndex,
            ...maskStyle,
            ...modalStyles?.mask
        },
        maskProps: maskProps,
        className: modalClassNames?.mask
    }), /*#__PURE__*/ $5E6i4.createElement("div", $010aee5ffbfa5438$var$_extends({
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-wrap`, wrapClassName, modalClassNames?.wrapper),
        ref: wrapperRef,
        onClick: onWrapperClick,
        onMouseDown: onWrapperMouseDown,
        style: mergedStyle
    }, wrapProps), /*#__PURE__*/ $5E6i4.createElement((0, $f7616f6f6b9329f4$export$2e2bcd8739ae039), $010aee5ffbfa5438$var$_extends({}, props, {
        isFixedPos: isFixedPos,
        ref: contentRef,
        closable: closable,
        ariaId: ariaId,
        prefixCls: prefixCls,
        visible: visible && animatedVisible,
        onClose: onInternalClose,
        onVisibleChanged: onDialogVisibleChanged,
        motionName: (0, $c8811d69162483ae$export$ec1a7ebf4579c1c3)(prefixCls, transitionName, animation)
    }))));
};
var $010aee5ffbfa5438$export$2e2bcd8739ae039 = $010aee5ffbfa5438$var$Dialog;


function $1c868a7ae01aa61d$var$_extends() {
    $1c868a7ae01aa61d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1c868a7ae01aa61d$var$_extends.apply(this, arguments);
}
// fix issue #10656
/*
 * getContainer remarks
 * Custom container should not be return, because in the Portal component, it will remove the
 * return container element here, if the custom container is the only child of it's component,
 * like issue #10656, It will has a conflict with removeChild method in react-dom.
 * So here should add a child (div element) to custom container.
 * */ const $1c868a7ae01aa61d$var$DialogWrap = (props)=>{
    const { visible: visible, getContainer: getContainer, forceRender: forceRender, destroyOnHidden: destroyOnHidden = false, afterClose: afterClose, closable: closable, panelRef: panelRef, keyboard: keyboard = true, scrollLock: scrollLock = true, onClose: onClose } = props;
    const { scrollLock: _, ...restProps } = props;
    const [animatedVisible, setAnimatedVisible] = $5E6i4.useState(visible);
    const refContext = $5E6i4.useMemo(()=>({
            panel: panelRef
        }), [
        panelRef
    ]);
    const onEsc = ({ top: top, event: event })=>{
        if (top && keyboard) {
            event.stopPropagation();
            onClose?.(event);
            return;
        }
    };
    $5E6i4.useEffect(()=>{
        if (visible) setAnimatedVisible(true);
    }, [
        visible
    ]);
    // Destroy on close will remove wrapped div
    if (!forceRender && destroyOnHidden && !animatedVisible) return null;
    return /*#__PURE__*/ $5E6i4.createElement((0, $df35dcd6d6437f6a$export$ee4e38b469b6f5d1).Provider, {
        value: refContext
    }, /*#__PURE__*/ $5E6i4.createElement((0, $bd882e1916f36420$export$2e2bcd8739ae039), {
        open: visible || forceRender || animatedVisible,
        onEsc: onEsc,
        autoDestroy: false,
        getContainer: getContainer,
        autoLock: scrollLock && (visible || animatedVisible)
    }, /*#__PURE__*/ $5E6i4.createElement((0, $010aee5ffbfa5438$export$2e2bcd8739ae039), $1c868a7ae01aa61d$var$_extends({}, restProps, {
        destroyOnHidden: destroyOnHidden,
        afterClose: ()=>{
            const closableObj = closable && typeof closable === 'object' ? closable : {};
            const { afterClose: closableAfterClose } = closableObj || {};
            closableAfterClose?.();
            afterClose?.();
            setAnimatedVisible(false);
        }
    }))));
};
var $1c868a7ae01aa61d$export$2e2bcd8739ae039 = $1c868a7ae01aa61d$var$DialogWrap;



var $b40f07ce9df7ff4a$export$2e2bcd8739ae039 = (0, $1c868a7ae01aa61d$export$2e2bcd8739ae039);






var $5E6i4 = parcelRequire("5E6i4");





"use client";
const $be8e19a8189a28c3$export$51ad9c30389f050b = (context)=>{
    if (!context) return undefined;
    const { closable: closable, closeIcon: closeIcon } = context;
    return {
        closable: closable,
        closeIcon: closeIcon
    };
};
const $be8e19a8189a28c3$var$EmptyFallbackCloseCollection = {};
const $be8e19a8189a28c3$var$computeClosableConfig = (closable, closeIcon)=>{
    if (!closable && (closable === false || closeIcon === false || closeIcon === null)) return false;
    if (!(0, $b63de2b9864a5d1a$export$826fff653a329e83)(closable) && !(0, $b63de2b9864a5d1a$export$826fff653a329e83)(closeIcon)) return null;
    let closableConfig = {
        closeIcon: typeof closeIcon !== 'boolean' && (0, $b63de2b9864a5d1a$export$826fff653a329e83)(closeIcon) ? closeIcon : undefined
    };
    if ((0, $addbc2fddcbb77a9$export$53b83ca8eaab0383)(closable)) closableConfig = {
        ...closableConfig,
        ...closable
    };
    return closableConfig;
};
const $be8e19a8189a28c3$var$mergeClosableConfigs = (propConfig, contextConfig, fallbackConfig)=>{
    if (propConfig === false) return false;
    if (propConfig) return (0, $7b47fcffadf6d245$export$2e2bcd8739ae039)(fallbackConfig, contextConfig, propConfig);
    if (contextConfig === false) return false;
    if (contextConfig) return (0, $7b47fcffadf6d245$export$2e2bcd8739ae039)(fallbackConfig, contextConfig);
    return fallbackConfig.closable ? fallbackConfig : false;
};
const $be8e19a8189a28c3$var$computeCloseIcon = (mergedConfig, fallbackCloseCollection, closeLabel)=>{
    const { closeIconRender: closeIconRender } = fallbackCloseCollection;
    const { closeIcon: closeIcon, ...restConfig } = mergedConfig;
    let finalCloseIcon = closeIcon;
    const ariaOrDataProps = (0, $78cde6532419ffca$export$2e2bcd8739ae039)(restConfig, true);
    if ((0, $b63de2b9864a5d1a$export$826fff653a329e83)(finalCloseIcon)) {
        if (closeIconRender) finalCloseIcon = closeIconRender(finalCloseIcon);
        finalCloseIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).isValidElement(finalCloseIcon) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).cloneElement(finalCloseIcon, {
            'aria-label': closeLabel,
            ...finalCloseIcon.props,
            ...ariaOrDataProps
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("span", {
            "aria-label": closeLabel,
            ...ariaOrDataProps
        }, finalCloseIcon);
    }
    return [
        finalCloseIcon,
        {
            'aria-label': closeLabel,
            ...ariaOrDataProps
        }
    ];
};
const $be8e19a8189a28c3$export$41ed0597a5c42f8 = (propCloseCollection, contextCloseCollection, fallbackCloseCollection = $be8e19a8189a28c3$var$EmptyFallbackCloseCollection, closeLabel = 'Close')=>{
    const propConfig = $be8e19a8189a28c3$var$computeClosableConfig(propCloseCollection?.closable, propCloseCollection?.closeIcon);
    const contextConfig = $be8e19a8189a28c3$var$computeClosableConfig(contextCloseCollection?.closable, contextCloseCollection?.closeIcon);
    const mergedFallback = {
        closeIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $80d24bc031ad50e3$export$2e2bcd8739ae039), null),
        ...fallbackCloseCollection
    };
    const mergedConfig = $be8e19a8189a28c3$var$mergeClosableConfigs(propConfig, contextConfig, mergedFallback);
    const closeBtnIsDisabled = typeof mergedConfig !== 'boolean' ? !!mergedConfig?.disabled : false;
    if (mergedConfig === false) return [
        false,
        null,
        closeBtnIsDisabled,
        {}
    ];
    const [closeIcon, ariaProps] = $be8e19a8189a28c3$var$computeCloseIcon(mergedConfig, mergedFallback, closeLabel);
    return [
        true,
        closeIcon,
        closeBtnIsDisabled,
        ariaProps
    ];
};
const $be8e19a8189a28c3$export$aa101db403ccf5f3 = (propCloseCollection, contextCloseCollection, fallbackCloseCollection = $be8e19a8189a28c3$var$EmptyFallbackCloseCollection)=>{
    const [contextLocale] = (0, $a2f3e1f88973a5e2$export$2e2bcd8739ae039)('global', (0, $7a40da28675d08a9$export$2e2bcd8739ae039).global);
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useMemo(()=>{
        return $be8e19a8189a28c3$export$41ed0597a5c42f8(propCloseCollection, contextCloseCollection, {
            closeIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $80d24bc031ad50e3$export$2e2bcd8739ae039), null),
            ...fallbackCloseCollection
        }, contextLocale.close);
    }, [
        propCloseCollection,
        contextCloseCollection,
        fallbackCloseCollection,
        contextLocale.close
    ]);
};






const $07d437cdf8ee8084$export$7dbdadf5e9653129 = ()=>(0, $8b91ba628d942bf2$export$2e2bcd8739ae039)() && window.document.documentElement;








var $5E6i4 = parcelRequire("5E6i4");
function $17d7bf7c7826c5df$export$2e2bcd8739ae039(focusable, defaultTrap, legacyFocusTriggerAfterClose) {
    return (0, $5E6i4.useMemo)(()=>{
        const ret = {
            trap: defaultTrap ?? true,
            focusTriggerAfterClose: legacyFocusTriggerAfterClose ?? true
        };
        return {
            ...ret,
            ...focusable
        };
    }, [
        focusable,
        defaultTrap,
        legacyFocusTriggerAfterClose
    ]);
}




var $5E6i4 = parcelRequire("5E6i4");

function $385c9e213971d03d$var$voidFunc() {}
const $385c9e213971d03d$var$WatermarkContext = /*#__PURE__*/ $5E6i4.createContext({
    add: $385c9e213971d03d$var$voidFunc,
    remove: $385c9e213971d03d$var$voidFunc
});
function $385c9e213971d03d$export$94ab53417567be34(panelSelector) {
    const watermark = $5E6i4.useContext($385c9e213971d03d$var$WatermarkContext);
    const panelEleRef = $5E6i4.useRef(null);
    const panelRef = (0, $68990f4402d2f009$export$2e2bcd8739ae039)((ele)=>{
        if (ele) {
            const innerContentEle = panelSelector ? ele.querySelector(panelSelector) : ele;
            if (innerContentEle) {
                watermark.add(innerContentEle);
                panelEleRef.current = innerContentEle;
            }
        } else watermark.remove(panelEleRef.current);
    });
    return panelRef;
}
var $385c9e213971d03d$export$2e2bcd8739ae039 = $385c9e213971d03d$var$WatermarkContext;



var $5E6i4 = parcelRequire("5E6i4");







var $5E6i4 = parcelRequire("5E6i4");


"use client";
const $6b81068c633b31cb$var$NormalCancelBtn = ()=>{
    const { cancelButtonProps: cancelButtonProps, cancelTextLocale: cancelTextLocale, onCancel: onCancel } = (0, $5E6i4.useContext)((0, $d91b78c27439fbf5$export$ab57792b9b6974a6));
    const onInternalClick = (event)=>{
        onCancel?.(event);
        cancelButtonProps?.onClick?.(event);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $17f39e4db74a8975$export$2e2bcd8739ae039), {
        ...cancelButtonProps,
        onClick: onInternalClick
    }, cancelTextLocale);
};
var $6b81068c633b31cb$export$2e2bcd8739ae039 = $6b81068c633b31cb$var$NormalCancelBtn;



var $5E6i4 = parcelRequire("5E6i4");



"use client";
const $9b8e62d51220f167$var$NormalOkBtn = ()=>{
    const { confirmLoading: confirmLoading, okButtonProps: okButtonProps, okType: okType, okTextLocale: okTextLocale, onOk: onOk } = (0, $5E6i4.useContext)((0, $d91b78c27439fbf5$export$ab57792b9b6974a6));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $17f39e4db74a8975$export$2e2bcd8739ae039), {
        ...(0, $0ceddc1355cab302$export$19bc9a290855952)(okType),
        loading: confirmLoading,
        onClick: onOk,
        ...okButtonProps
    }, okTextLocale);
};
var $9b8e62d51220f167$export$2e2bcd8739ae039 = $9b8e62d51220f167$var$NormalOkBtn;




"use client";
function $baa89cad5d6e1221$export$97c34646962d356e(prefixCls, closeIcon) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("span", {
        className: `${prefixCls}-close-x`
    }, (0, $b63de2b9864a5d1a$export$72280d5f896dac9a)(closeIcon) ? closeIcon : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $80d24bc031ad50e3$export$2e2bcd8739ae039), {
        className: `${prefixCls}-close-icon`
    }));
}
const $baa89cad5d6e1221$export$a06f1c675e846f6f = (props)=>{
    const { okText: okText, okType: okType = 'primary', cancelText: cancelText, confirmLoading: confirmLoading, onOk: onOk, onCancel: onCancel, okButtonProps: okButtonProps, cancelButtonProps: cancelButtonProps, footer: footer } = props;
    const [locale] = (0, $a2f3e1f88973a5e2$export$2e2bcd8739ae039)('Modal', (0, $89984c3eb9021529$export$1b6004afda18cd51)());
    // ================== Locale Text ==================
    const okTextLocale = (0, $c3b60ef18d99af24$export$2e2bcd8739ae039)(okText, locale?.okText);
    const cancelTextLocale = (0, $c3b60ef18d99af24$export$2e2bcd8739ae039)(cancelText, locale?.cancelText);
    const memoizedValue = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useMemo(()=>{
        return {
            confirmLoading: confirmLoading,
            okButtonProps: okButtonProps,
            cancelButtonProps: cancelButtonProps,
            okTextLocale: okTextLocale,
            cancelTextLocale: cancelTextLocale,
            okType: okType,
            onOk: onOk,
            onCancel: onCancel
        };
    }, [
        confirmLoading,
        okButtonProps,
        cancelButtonProps,
        okTextLocale,
        cancelTextLocale,
        okType,
        onOk,
        onCancel
    ]);
    let footerNode;
    if ((0, $addbc2fddcbb77a9$export$f6e2535fb5126e54)(footer) || typeof footer === 'undefined') {
        footerNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $6b81068c633b31cb$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $9b8e62d51220f167$export$2e2bcd8739ae039), null));
        if ((0, $addbc2fddcbb77a9$export$f6e2535fb5126e54)(footer)) footerNode = footer(footerNode, {
            OkBtn: (0, $9b8e62d51220f167$export$2e2bcd8739ae039),
            CancelBtn: (0, $6b81068c633b31cb$export$2e2bcd8739ae039)
        });
        footerNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $d91b78c27439fbf5$export$7c9538f5f3c365e9), {
            value: memoizedValue
        }, footerNode);
    } else footerNode = footer;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $2ab14018ea5b2d79$export$6adb5f3b918b11bb), {
        disabled: false
    }, footerNode);
};








function $3f4cbf08de7bcc1c$var$box(position) {
    return {
        position: position,
        inset: 0
    };
}
const $3f4cbf08de7bcc1c$export$8bb6dada04673ddd = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    return [
        {
            [`${componentCls}-root`]: {
                [`${componentCls}${antCls}-zoom-enter, ${componentCls}${antCls}-zoom-appear`]: {
                    // reset scale avoid mousePosition bug
                    transform: 'none',
                    opacity: 0,
                    animationDuration: token.motionDurationSlow,
                    // https://github.com/ant-design/ant-design/issues/11777
                    userSelect: 'none'
                },
                // https://github.com/ant-design/ant-design/issues/37329
                // https://github.com/ant-design/ant-design/issues/40272
                [`${componentCls}${antCls}-zoom-leave ${componentCls}-container`]: {
                    pointerEvents: 'none'
                },
                [`${componentCls}-mask`]: {
                    ...$3f4cbf08de7bcc1c$var$box('fixed'),
                    zIndex: token.zIndexPopupBase,
                    height: '100%',
                    backgroundColor: token.colorBgMask,
                    pointerEvents: 'none',
                    [`&${componentCls}-mask-blur`]: {
                        backdropFilter: 'blur(4px)'
                    },
                    [`${componentCls}-hidden`]: {
                        display: 'none'
                    }
                },
                [`${componentCls}-wrap`]: {
                    ...$3f4cbf08de7bcc1c$var$box('fixed'),
                    zIndex: token.zIndexPopupBase,
                    overflow: 'auto',
                    outline: 0,
                    WebkitOverflowScrolling: 'touch'
                }
            }
        },
        {
            [`${componentCls}-root`]: (0, $74fc3232bfd7dcd0$export$2909268c8354a12)(token)
        }
    ];
};
const $3f4cbf08de7bcc1c$var$genModalStyle = (token)=>{
    const { componentCls: componentCls, motionDurationMid: motionDurationMid } = token;
    return [
        // ======================== Root =========================
        {
            [`${componentCls}-root`]: {
                [`${componentCls}-wrap-rtl`]: {
                    direction: 'rtl'
                },
                [`${componentCls}-centered`]: {
                    textAlign: 'center',
                    '&::before': {
                        display: 'inline-block',
                        width: 0,
                        height: '100%',
                        verticalAlign: 'middle',
                        content: '""'
                    },
                    [componentCls]: {
                        top: 0,
                        display: 'inline-block',
                        paddingBottom: 0,
                        textAlign: 'start',
                        verticalAlign: 'middle'
                    }
                },
                [`@media (max-width: ${token.screenSMMax}px)`]: {
                    [componentCls]: {
                        maxWidth: 'calc(100vw - 16px)',
                        margin: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.marginXS)} auto`
                    },
                    [`${componentCls}-centered`]: {
                        [componentCls]: {
                            flex: 1
                        }
                    }
                }
            }
        },
        // ======================== Modal ========================
        {
            [componentCls]: {
                ...(0, $cd5a520fee8002b4$export$23997c3e44cc1c59)(token),
                pointerEvents: 'none',
                position: 'relative',
                top: 100,
                width: 'auto',
                maxWidth: `calc(100vw - ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.calc(token.margin).mul(2).equal())})`,
                margin: '0 auto',
                '&:focus-visible': {
                    borderRadius: token.borderRadiusLG,
                    ...(0, $cd5a520fee8002b4$export$6539948f0a737e39)(token)
                },
                [`${componentCls}-title`]: {
                    margin: 0,
                    color: token.titleColor,
                    fontWeight: token.fontWeightStrong,
                    fontSize: token.titleFontSize,
                    lineHeight: token.titleLineHeight,
                    wordWrap: 'break-word'
                },
                [`${componentCls}-container`]: {
                    position: 'relative',
                    backgroundColor: token.contentBg,
                    backgroundClip: 'padding-box',
                    border: 0,
                    borderRadius: token.borderRadiusLG,
                    boxShadow: token.boxShadow,
                    pointerEvents: 'auto',
                    padding: token.contentPadding
                },
                [`${componentCls}-close`]: {
                    position: 'absolute',
                    top: token.calc(token.modalHeaderHeight).sub(token.modalCloseBtnSize).div(2).equal(),
                    insetInlineEnd: token.calc(token.modalHeaderHeight).sub(token.modalCloseBtnSize).div(2).equal(),
                    zIndex: token.calc(token.zIndexPopupBase).add(10).equal(),
                    padding: 0,
                    color: token.modalCloseIconColor,
                    fontWeight: token.fontWeightStrong,
                    lineHeight: 1,
                    textDecoration: 'none',
                    background: 'transparent',
                    borderRadius: token.borderRadiusSM,
                    width: token.modalCloseBtnSize,
                    height: token.modalCloseBtnSize,
                    border: 0,
                    outline: 0,
                    cursor: 'pointer',
                    transition: [
                        'color',
                        'background-color'
                    ].map((prop)=>`${prop} ${motionDurationMid}`).join(', '),
                    '&-x': {
                        display: 'flex',
                        fontSize: token.fontSizeLG,
                        fontStyle: 'normal',
                        lineHeight: (0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.modalCloseBtnSize),
                        justifyContent: 'center',
                        textTransform: 'none',
                        textRendering: 'auto'
                    },
                    '&:disabled': {
                        pointerEvents: 'none'
                    },
                    '&:hover': {
                        color: token.modalCloseIconHoverColor,
                        backgroundColor: token.colorBgTextHover,
                        textDecoration: 'none'
                    },
                    '&:active': {
                        backgroundColor: token.colorBgTextActive
                    },
                    ...(0, $cd5a520fee8002b4$export$a44db842bcb28231)(token)
                },
                [`${componentCls}-header`]: {
                    color: token.colorText,
                    background: token.headerBg,
                    borderRadius: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.borderRadiusLG)} 0 0`,
                    marginBottom: token.headerMarginBottom,
                    padding: token.headerPadding,
                    borderBottom: token.headerBorderBottom
                },
                [`${componentCls}-body`]: {
                    fontSize: token.fontSize,
                    lineHeight: token.lineHeight,
                    wordWrap: 'break-word',
                    padding: token.bodyPadding,
                    [`${componentCls}-body-skeleton`]: {
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        margin: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.margin)} auto`
                    }
                },
                [`${componentCls}-footer`]: {
                    textAlign: 'end',
                    background: token.footerBg,
                    marginTop: token.footerMarginTop,
                    padding: token.footerPadding,
                    borderTop: token.footerBorderTop,
                    borderRadius: token.footerBorderRadius,
                    [`> ${token.antCls}-btn + ${token.antCls}-btn`]: {
                        marginInlineStart: token.marginXS
                    }
                },
                [`${componentCls}-open`]: {
                    overflow: 'hidden'
                }
            }
        },
        // ======================== Pure =========================
        {
            [`${componentCls}-pure-panel`]: {
                top: 'auto',
                padding: 0,
                display: 'flex',
                flexDirection: 'column',
                [`${componentCls}-container,
          ${componentCls}-body,
          ${componentCls}-confirm-body-wrapper`]: {
                    display: 'flex',
                    flexDirection: 'column',
                    flex: 'auto'
                },
                [`${componentCls}-confirm-body`]: {
                    marginBottom: 'auto'
                }
            }
        }
    ];
};
const $3f4cbf08de7bcc1c$var$genRTLStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-root`]: {
            [`${componentCls}-wrap-rtl`]: {
                direction: 'rtl',
                [`${componentCls}-confirm-body`]: {
                    direction: 'rtl'
                }
            }
        }
    };
};
const $3f4cbf08de7bcc1c$var$genResponsiveWidthStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const oriGridMediaSizesMap = (0, $70020273e1dffc84$export$6353f655434817c5)(token);
    const gridMediaSizesMap = {
        ...oriGridMediaSizesMap
    };
    delete gridMediaSizesMap.xs;
    const cssVarPrefix = `--${componentCls.replace('.', '')}-`;
    const responsiveStyles = Object.keys(gridMediaSizesMap).map((key)=>({
            [`@media (min-width: ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(gridMediaSizesMap[key])})`]: {
                width: `var(${cssVarPrefix}${key}-width)`
            }
        }));
    return {
        [`${componentCls}-root`]: {
            [componentCls]: [].concat((0, $0acfae8147afe964$export$2e2bcd8739ae039)(Object.keys(oriGridMediaSizesMap).map((currentKey, index)=>{
                const previousKey = Object.keys(oriGridMediaSizesMap)[index - 1];
                return previousKey ? {
                    [`${cssVarPrefix}${currentKey}-width`]: `var(${cssVarPrefix}${previousKey}-width)`
                } : null;
            })), [
                {
                    width: `var(${cssVarPrefix}xs-width)`
                }
            ], (0, $0acfae8147afe964$export$2e2bcd8739ae039)(responsiveStyles))
        }
    };
};
const $3f4cbf08de7bcc1c$export$362fb92a8f81bbf9 = (token)=>{
    const headerPaddingVertical = token.padding;
    const headerFontSize = token.fontSizeHeading5;
    const headerLineHeight = token.lineHeightHeading5;
    const modalToken = (0, $f564548c7b6877d5$export$4950aa0f605343fb)(token, {
        modalHeaderHeight: token.calc(token.calc(headerLineHeight).mul(headerFontSize).equal()).add(token.calc(headerPaddingVertical).mul(2).equal()).equal(),
        modalFooterBorderColorSplit: token.colorSplit,
        modalFooterBorderStyle: token.lineType,
        modalFooterBorderWidth: token.lineWidth,
        modalCloseIconColor: token.colorIcon,
        modalCloseIconHoverColor: token.colorIconHover,
        modalCloseBtnSize: token.controlHeight,
        modalConfirmIconSize: token.fontHeight,
        modalTitleHeight: token.calc(token.titleFontSize).mul(token.titleLineHeight).equal()
    });
    return modalToken;
};
const $3f4cbf08de7bcc1c$export$9ca1be8807fe0675 = (token)=>({
        footerBg: 'transparent',
        headerBg: 'transparent',
        titleLineHeight: token.lineHeightHeading5,
        titleFontSize: token.fontSizeHeading5,
        contentBg: token.colorBgElevated,
        titleColor: token.colorTextHeading,
        // internal
        contentPadding: token.wireframe ? 0 : `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.paddingMD)} ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.paddingContentHorizontalLG)}`,
        headerPadding: token.wireframe ? `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.padding)} ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.paddingLG)}` : 0,
        headerBorderBottom: token.wireframe ? `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorSplit}` : 'none',
        headerMarginBottom: token.wireframe ? 0 : token.marginXS,
        bodyPadding: token.wireframe ? token.paddingLG : 0,
        footerPadding: token.wireframe ? `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.paddingXS)} ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.padding)}` : 0,
        footerBorderTop: token.wireframe ? `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorSplit}` : 'none',
        footerBorderRadius: token.wireframe ? `0 0 ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.borderRadiusLG)}` : 0,
        footerMarginTop: token.wireframe ? 0 : token.marginSM,
        confirmBodyPadding: token.wireframe ? `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.padding * 2)} ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.padding * 2)} ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.paddingLG)}` : 0,
        confirmIconMarginInlineEnd: token.wireframe ? token.margin : token.marginSM,
        confirmBtnsMarginTop: token.wireframe ? token.marginLG : token.marginSM,
        mask: true
    });
var $3f4cbf08de7bcc1c$export$2e2bcd8739ae039 = (0, $761caadb5301aee1$export$51ec95de45185b42)('Modal', (token)=>{
    const modalToken = $3f4cbf08de7bcc1c$export$362fb92a8f81bbf9(token);
    return [
        $3f4cbf08de7bcc1c$var$genModalStyle(modalToken),
        $3f4cbf08de7bcc1c$var$genRTLStyle(modalToken),
        $3f4cbf08de7bcc1c$export$8bb6dada04673ddd(modalToken),
        (0, $67ba63c38ba87091$export$f5d123412490d9dc)(modalToken, 'zoom'),
        $3f4cbf08de7bcc1c$var$genResponsiveWidthStyle(modalToken)
    ];
}, $3f4cbf08de7bcc1c$export$9ca1be8807fe0675, {
    unitless: {
        titleLineHeight: true
    }
});


"use client";
let $b67bfa5e8f4d23c7$var$mousePosition;
// ref: https://github.com/ant-design/ant-design/issues/15795
const $b67bfa5e8f4d23c7$var$getClickPosition = (e)=>{
    $b67bfa5e8f4d23c7$var$mousePosition = {
        x: e.pageX,
        y: e.pageY
    };
    // 100ms 内发生过点击事件，则从点击位置动画展示
    // 否则直接 zoom 展示
    // 这样可以兼容非点击方式展开
    setTimeout(()=>{
        $b67bfa5e8f4d23c7$var$mousePosition = null;
    }, 100);
};
// 只有点击事件支持从鼠标位置动画展开
if ((0, $07d437cdf8ee8084$export$7dbdadf5e9653129)()) document.documentElement.addEventListener('click', $b67bfa5e8f4d23c7$var$getClickPosition, true);
const $b67bfa5e8f4d23c7$var$Modal = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, open: open, wrapClassName: wrapClassName, centered: centered, getContainer: getContainer, style: style, width: width = 520, footer: footer, classNames: classNames, styles: styles, children: children, loading: loading, confirmLoading: confirmLoading, zIndex: customizeZIndex, mousePosition: customizeMousePosition, onOk: onOk, onCancel: onCancel, okButtonProps: okButtonProps, cancelButtonProps: cancelButtonProps, destroyOnHidden: destroyOnHidden, destroyOnClose: destroyOnClose, panelRef: panelRef = null, closable: closable, mask: modalMask, modalRender: modalRender, maskClosable: maskClosable, _semanticOmit: _semanticOmit, scrollLock: scrollLock, focusTriggerAfterClose: // Focusable
    focusTriggerAfterClose, focusable: focusable, _renderSemanticContent: _renderSemanticContent, ...restProps } = props;
    const { getPopupContainer: getContextPopupContainer, getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles, centered: contextCentered, cancelButtonProps: contextCancelButtonProps, okButtonProps: contextOkButtonProps, mask: contextMask, focusable: contextFocusable } = (0, $519f2fad435b3034$export$46f4bd6436a25a31)('modal');
    const { modal: modalContext } = $5E6i4.useContext((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
    const [closableAfterClose, onClose] = $5E6i4.useMemo(()=>{
        if (typeof closable === 'boolean') return [
            undefined,
            undefined
        ];
        return [
            closable?.afterClose,
            closable?.onClose
        ];
    }, [
        closable
    ]);
    const prefixCls = getPrefixCls('modal', customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    // ============================ Mask ============================
    const [mergedMask, maskBlurClassName, mergeMaskClosable] = (0, $b3482faf6dda424f$export$a4ac1bdd74570410)(modalMask, contextMask, prefixCls, maskClosable);
    // ========================== Focusable =========================
    const mergedFocusable = (0, $17d7bf7c7826c5df$export$2e2bcd8739ae039)({
        ...contextFocusable,
        ...focusable
    }, mergedMask, focusTriggerAfterClose);
    // ============================ Open ============================
    const handleCancel = (e)=>{
        if (confirmLoading) return;
        onCancel?.(e);
        onClose?.();
    };
    const handleOk = (e)=>{
        onOk?.(e);
        onClose?.();
    };
    var deprecatedName, newName;
    // Style
    const rootCls = (0, $d104ec5f99ed66d7$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $3f4cbf08de7bcc1c$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const wrapClassNameExtended = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(wrapClassName, {
        [`${prefixCls}-centered`]: centered ?? contextCentered,
        [`${prefixCls}-wrap-rtl`]: direction === 'rtl'
    });
    const dialogFooter = footer !== null && !loading ? /*#__PURE__*/ $5E6i4.createElement((0, $baa89cad5d6e1221$export$a06f1c675e846f6f), {
        ...props,
        okButtonProps: {
            ...contextOkButtonProps,
            ...okButtonProps
        },
        onOk: handleOk,
        cancelButtonProps: {
            ...contextCancelButtonProps,
            ...cancelButtonProps
        },
        onCancel: handleCancel
    }) : null;
    const [rawClosable, mergedCloseIcon, closeBtnIsDisabled, ariaProps] = (0, $be8e19a8189a28c3$export$aa101db403ccf5f3)((0, $be8e19a8189a28c3$export$51ad9c30389f050b)(props), (0, $be8e19a8189a28c3$export$51ad9c30389f050b)(modalContext), {
        closable: true,
        closeIcon: /*#__PURE__*/ $5E6i4.createElement((0, $80d24bc031ad50e3$export$2e2bcd8739ae039), {
            className: `${prefixCls}-close-icon`
        }),
        closeIconRender: (icon)=>(0, $baa89cad5d6e1221$export$97c34646962d356e)(prefixCls, icon)
    });
    const mergedClosable = rawClosable ? {
        disabled: closeBtnIsDisabled,
        closeIcon: mergedCloseIcon,
        afterClose: closableAfterClose,
        ...ariaProps
    } : false;
    // ============================ modalRender ============================
    const mergedModalRender = modalRender ? (node)=>/*#__PURE__*/ $5E6i4.createElement("div", {
            className: `${prefixCls}-render`
        }, modalRender(node)) : undefined;
    // ============================ Refs ============================
    // Select `ant-modal-container` by `panelRef`
    const panelClassName = `.${prefixCls}-${modalRender ? 'render' : 'container'}`;
    const innerPanelRef = (0, $385c9e213971d03d$export$94ab53417567be34)(panelClassName);
    const mergedPanelRef = (0, $92c8c75386168ffc$export$ab452c34e8e05029)(panelRef, innerPanelRef);
    // ============================ zIndex ============================
    const [zIndex, contextZIndex] = (0, $09c5eb33e460ecef$export$3e7906d4075187a4)('Modal', customizeZIndex);
    const mergedProps = {
        ...props,
        width: width,
        panelRef: panelRef,
        focusTriggerAfterClose: mergedFocusable.focusTriggerAfterClose,
        focusable: mergedFocusable,
        mask: mergedMask,
        maskClosable: mergeMaskClosable,
        zIndex: zIndex
    };
    const [mergedClassNames, mergedStyles] = (0, $722c8632ba7bdb89$export$648566b068f28737)([
        contextClassNames,
        classNames,
        maskBlurClassName
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const dialogClassNames = _semanticOmit ? (0, $48bd91d9f828de66$export$2e2bcd8739ae039)(mergedClassNames, _semanticOmit) : mergedClassNames;
    const dialogStyles = _semanticOmit ? (0, $48bd91d9f828de66$export$2e2bcd8739ae039)(mergedStyles, _semanticOmit) : mergedStyles;
    const semanticContent = _renderSemanticContent ? _renderSemanticContent({
        classNames: mergedClassNames,
        styles: mergedStyles
    }) : children;
    // =========================== Width ============================
    const [numWidth, responsiveWidth] = $5E6i4.useMemo(()=>{
        if ((0, $addbc2fddcbb77a9$export$53b83ca8eaab0383)(width)) return [
            undefined,
            width
        ];
        return [
            width,
            undefined
        ];
    }, [
        width
    ]);
    const responsiveWidthVars = $5E6i4.useMemo(()=>{
        const vars = {};
        if (responsiveWidth) Object.keys(responsiveWidth).forEach((breakpoint)=>{
            const breakpointWidth = responsiveWidth[breakpoint];
            if ((0, $b63de2b9864a5d1a$export$826fff653a329e83)(breakpointWidth)) vars[`--${prefixCls}-${breakpoint}-width`] = (0, $addbc2fddcbb77a9$export$7e4aa119212bc614)(breakpointWidth) ? `${breakpointWidth}px` : breakpointWidth;
        });
        return vars;
    }, [
        prefixCls,
        responsiveWidth
    ]);
    // =========================== Render ===========================
    return /*#__PURE__*/ $5E6i4.createElement((0, $33ed3a59b63447d5$export$2e2bcd8739ae039), {
        form: true,
        space: true
    }, /*#__PURE__*/ $5E6i4.createElement((0, $c8c4739fe508f3df$export$2e2bcd8739ae039).Provider, {
        value: contextZIndex
    }, /*#__PURE__*/ $5E6i4.createElement((0, $b40f07ce9df7ff4a$export$2e2bcd8739ae039), {
        width: numWidth,
        ...restProps,
        zIndex: zIndex,
        getContainer: getContainer === undefined ? getContextPopupContainer : getContainer,
        prefixCls: prefixCls,
        rootClassName: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(hashId, rootClassName, cssVarCls, rootCls, dialogClassNames.root),
        rootStyle: dialogStyles.root,
        footer: dialogFooter,
        visible: open,
        mousePosition: customizeMousePosition ?? $b67bfa5e8f4d23c7$var$mousePosition,
        onClose: handleCancel,
        closable: mergedClosable,
        closeIcon: mergedCloseIcon,
        transitionName: (0, $c2c363b881b49d51$export$27c72201b1d09951)(rootPrefixCls, 'zoom', props.transitionName),
        maskTransitionName: (0, $c2c363b881b49d51$export$27c72201b1d09951)(rootPrefixCls, 'fade', props.maskTransitionName),
        mask: mergedMask,
        maskClosable: mergeMaskClosable,
        scrollLock: scrollLock,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(hashId, className, contextClassName),
        style: {
            ...contextStyle,
            ...style,
            ...responsiveWidthVars
        },
        classNames: {
            ...dialogClassNames,
            wrapper: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(dialogClassNames.wrapper, wrapClassNameExtended)
        },
        styles: dialogStyles,
        panelRef: mergedPanelRef,
        destroyOnHidden: destroyOnHidden ?? destroyOnClose,
        modalRender: mergedModalRender,
        // Focusable
        focusTriggerAfterClose: mergedFocusable.focusTriggerAfterClose,
        focusTrap: mergedFocusable.trap
    }, loading ? /*#__PURE__*/ $5E6i4.createElement((0, $55f3a1bd00c2d717$export$2e2bcd8739ae039), {
        active: true,
        title: false,
        paragraph: {
            rows: 4
        },
        className: `${prefixCls}-body-skeleton`
    }) : semanticContent)));
};
var $b67bfa5e8f4d23c7$export$2e2bcd8739ae039 = $b67bfa5e8f4d23c7$var$Modal;






// ============================= Confirm ==============================
const $d43f9caf58e7e1f1$var$genModalConfirmStyle = (token)=>{
    const { componentCls: componentCls, titleFontSize: titleFontSize, titleLineHeight: titleLineHeight, modalConfirmIconSize: modalConfirmIconSize, fontSize: fontSize, lineHeight: lineHeight, modalTitleHeight: modalTitleHeight, fontHeight: fontHeight, confirmBodyPadding: confirmBodyPadding } = token;
    const confirmComponentCls = `${componentCls}-confirm`;
    return {
        [confirmComponentCls]: {
            '&-rtl': {
                direction: 'rtl'
            },
            [`${token.antCls}-modal-header`]: {
                display: 'none'
            },
            [`${confirmComponentCls}-body-wrapper`]: {
                ...(0, $cd5a520fee8002b4$export$8c467e8859fdef13)()
            },
            [`&${componentCls} ${componentCls}-body`]: {
                padding: confirmBodyPadding
            },
            // ====================== Body ======================
            [`${confirmComponentCls}-body`]: {
                display: 'flex',
                flexWrap: 'nowrap',
                alignItems: 'start',
                [`> ${token.iconCls}`]: {
                    flex: 'none',
                    fontSize: modalConfirmIconSize,
                    marginInlineEnd: token.confirmIconMarginInlineEnd,
                    marginTop: token.calc(token.calc(fontHeight).sub(modalConfirmIconSize).equal()).div(2).equal()
                },
                [`&-has-title > ${token.iconCls}`]: {
                    marginTop: token.calc(token.calc(modalTitleHeight).sub(modalConfirmIconSize).equal()).div(2).equal()
                }
            },
            [`${confirmComponentCls}-paragraph`]: {
                display: 'flex',
                flexDirection: 'column',
                flex: 'auto',
                rowGap: token.marginXS,
                // https://github.com/ant-design/ant-design/issues/51912
                maxWidth: `calc(100% - ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.marginSM)})`
            },
            [`${confirmComponentCls}-body-no-icon ${confirmComponentCls}-paragraph`]: {
                maxWidth: '100%'
            },
            // https://github.com/ant-design/ant-design/issues/48159
            [`${token.iconCls} + ${confirmComponentCls}-paragraph`]: {
                maxWidth: `calc(100% - ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.calc(token.modalConfirmIconSize).add(token.marginSM).equal())})`
            },
            [`${confirmComponentCls}-title`]: {
                color: token.colorTextHeading,
                fontWeight: token.fontWeightStrong,
                fontSize: titleFontSize,
                lineHeight: titleLineHeight
            },
            [`${confirmComponentCls}-container`]: {
                color: token.colorText,
                fontSize: fontSize,
                lineHeight: lineHeight
            },
            // ===================== Footer =====================
            [`${confirmComponentCls}-btns`]: {
                textAlign: 'end',
                marginTop: token.confirmBtnsMarginTop,
                [`${token.antCls}-btn + ${token.antCls}-btn`]: {
                    marginBottom: 0,
                    marginInlineStart: token.marginXS
                }
            }
        },
        [`${confirmComponentCls}-error ${confirmComponentCls}-body > ${token.iconCls}`]: {
            color: token.colorError
        },
        [`${confirmComponentCls}-warning ${confirmComponentCls}-body > ${token.iconCls},
        ${confirmComponentCls}-confirm ${confirmComponentCls}-body > ${token.iconCls}`]: {
            color: token.colorWarning
        },
        [`${confirmComponentCls}-info ${confirmComponentCls}-body > ${token.iconCls}`]: {
            color: token.colorInfo
        },
        [`${confirmComponentCls}-success ${confirmComponentCls}-body > ${token.iconCls}`]: {
            color: token.colorSuccess
        }
    };
};
var // ============================== Export ==============================
$d43f9caf58e7e1f1$export$2e2bcd8739ae039 = (0, $761caadb5301aee1$export$1537386bc155ea56)([
    'Modal',
    'confirm'
], (token)=>{
    const modalToken = (0, $3f4cbf08de7bcc1c$export$362fb92a8f81bbf9)(token);
    return $d43f9caf58e7e1f1$var$genModalConfirmStyle(modalToken);
}, (0, $3f4cbf08de7bcc1c$export$9ca1be8807fe0675), {
    // confirm is weak than modal since no conflict here
    order: -1000
});


"use client";
const $52a602ef9fda20e2$var$CONFIRM_OMIT_SEMANTIC_NAMES = [
    'body'
];
const $52a602ef9fda20e2$export$78cf841dc2c9f0b5 = (props)=>{
    const { prefixCls: prefixCls, icon: icon, okText: okText, cancelText: cancelText, confirmPrefixCls: confirmPrefixCls, type: type, okCancel: okCancel, footer: footer, // Legacy for static function usage
    locale: staticLocale, autoFocusButton: autoFocusButton, focusable: focusable, contentClassName: contentClassName, contentStyle: contentStyle, ...restProps } = props;
    const { infoIcon: infoIcon, successIcon: successIcon, errorIcon: errorIcon, warningIcon: warningIcon } = (0, $519f2fad435b3034$export$46f4bd6436a25a31)('modal');
    // Icon
    let mergedIcon = icon;
    // 支持传入 { icon: null } 或 { icon: false } 来隐藏`Modal.confirm`默认的Icon
    if (icon === undefined) switch(type){
        case 'info':
            mergedIcon = (0, $c3b60ef18d99af24$export$2e2bcd8739ae039)(infoIcon, /*#__PURE__*/ $5E6i4.createElement((0, $dc185fbb803a7cae$export$2e2bcd8739ae039), null));
            break;
        case 'success':
            mergedIcon = (0, $c3b60ef18d99af24$export$2e2bcd8739ae039)(successIcon, /*#__PURE__*/ $5E6i4.createElement((0, $b89ac8aaffc055f4$export$2e2bcd8739ae039), null));
            break;
        case 'error':
            mergedIcon = (0, $c3b60ef18d99af24$export$2e2bcd8739ae039)(errorIcon, /*#__PURE__*/ $5E6i4.createElement((0, $18493f15518cd625$export$2e2bcd8739ae039), null));
            break;
        default:
            mergedIcon = (0, $c3b60ef18d99af24$export$2e2bcd8739ae039)(warningIcon, /*#__PURE__*/ $5E6i4.createElement((0, $02cacf707e93d6b4$export$2e2bcd8739ae039), null));
    }
    // 默认为 true，保持向下兼容
    const mergedOkCancel = okCancel ?? type === 'confirm';
    const mergedAutoFocusButton = $5E6i4.useMemo(()=>{
        const base = focusable?.autoFocusButton || autoFocusButton;
        return base || base === null ? base : 'ok';
    }, [
        autoFocusButton,
        focusable?.autoFocusButton
    ]);
    const [locale] = (0, $a2f3e1f88973a5e2$export$2e2bcd8739ae039)('Modal');
    const mergedLocale = staticLocale || locale;
    // ================== Locale Text ==================
    const okTextLocale = (0, $c3b60ef18d99af24$export$2e2bcd8739ae039)(okText, mergedOkCancel ? mergedLocale?.okText : mergedLocale?.justOkText);
    const cancelTextLocale = (0, $c3b60ef18d99af24$export$2e2bcd8739ae039)(cancelText, mergedLocale?.cancelText);
    // ================= Context Value =================
    const { closable: closable } = restProps;
    const { onClose: onClose } = (0, $addbc2fddcbb77a9$export$53b83ca8eaab0383)(closable) ? closable : {};
    const memoizedValue = $5E6i4.useMemo(()=>{
        return {
            autoFocusButton: mergedAutoFocusButton,
            cancelTextLocale: cancelTextLocale,
            okTextLocale: okTextLocale,
            mergedOkCancel: mergedOkCancel,
            onClose: onClose,
            ...restProps
        };
    }, [
        mergedAutoFocusButton,
        cancelTextLocale,
        okTextLocale,
        mergedOkCancel,
        onClose,
        restProps
    ]);
    // ====================== Footer Origin Node ======================
    const footerOriginNode = /*#__PURE__*/ $5E6i4.createElement($5E6i4.Fragment, null, /*#__PURE__*/ $5E6i4.createElement((0, $4483c8ba9379f48f$export$2e2bcd8739ae039), null), /*#__PURE__*/ $5E6i4.createElement((0, $856ada7f26ae4641$export$2e2bcd8739ae039), null));
    const hasTitle = (0, $b63de2b9864a5d1a$export$72280d5f896dac9a)(props.title);
    const hasIcon = (0, $b63de2b9864a5d1a$export$72280d5f896dac9a)(mergedIcon);
    const bodyCls = `${confirmPrefixCls}-body`;
    return /*#__PURE__*/ $5E6i4.createElement("div", {
        className: `${confirmPrefixCls}-body-wrapper`
    }, /*#__PURE__*/ $5E6i4.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(bodyCls, {
            [`${bodyCls}-has-title`]: hasTitle,
            [`${bodyCls}-no-icon`]: !hasIcon
        })
    }, mergedIcon, /*#__PURE__*/ $5E6i4.createElement("div", {
        className: `${confirmPrefixCls}-paragraph`
    }, hasTitle && /*#__PURE__*/ $5E6i4.createElement("span", {
        className: `${confirmPrefixCls}-title`
    }, props.title), /*#__PURE__*/ $5E6i4.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${confirmPrefixCls}-content`, contentClassName),
        style: contentStyle
    }, props.content))), footer === undefined || (0, $addbc2fddcbb77a9$export$f6e2535fb5126e54)(footer) ? /*#__PURE__*/ $5E6i4.createElement((0, $d91b78c27439fbf5$export$7c9538f5f3c365e9), {
        value: memoizedValue
    }, /*#__PURE__*/ $5E6i4.createElement("div", {
        className: `${confirmPrefixCls}-btns`
    }, (0, $addbc2fddcbb77a9$export$f6e2535fb5126e54)(footer) ? footer(footerOriginNode, {
        OkBtn: $856ada7f26ae4641$export$2e2bcd8739ae039,
        CancelBtn: $4483c8ba9379f48f$export$2e2bcd8739ae039
    }) : footerOriginNode)) : footer, /*#__PURE__*/ $5E6i4.createElement((0, $d43f9caf58e7e1f1$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }));
};
const $52a602ef9fda20e2$var$ConfirmDialog = (props)=>{
    const { close: close, zIndex: zIndex, maskStyle: maskStyle, direction: direction, prefixCls: prefixCls, wrapClassName: wrapClassName, rootPrefixCls: rootPrefixCls, bodyStyle: bodyStyle, closable: closable = false, onConfirm: onConfirm, styles: styles, title: title, mask: mask, maskClosable: maskClosable, okButtonProps: okButtonProps, cancelButtonProps: cancelButtonProps } = props;
    const { cancelButtonProps: contextCancelButtonProps, okButtonProps: contextOkButtonProps } = (0, $519f2fad435b3034$export$46f4bd6436a25a31)('modal');
    var deprecatedName, newName;
    const confirmPrefixCls = `${prefixCls}-confirm`;
    const width = props.width || 416;
    const style = props.style || {};
    const semanticStyles = (0, $addbc2fddcbb77a9$export$f6e2535fb5126e54)(styles) ? (info)=>({
            body: bodyStyle,
            mask: maskStyle,
            ...styles(info)
        }) : {
        body: bodyStyle,
        mask: maskStyle,
        ...styles
    };
    const modalProps = (0, $48bd91d9f828de66$export$2e2bcd8739ae039)(props, [
        'bodyStyle',
        'maskStyle'
    ]);
    const classString = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(confirmPrefixCls, `${confirmPrefixCls}-${props.type}`, {
        [`${confirmPrefixCls}-rtl`]: direction === 'rtl'
    }, props.className);
    // ========================== Mask ==========================
    // 默认为 false，保持旧版默认行为
    const mergedMask = $5E6i4.useMemo(()=>{
        const nextMaskConfig = (0, $b3482faf6dda424f$export$c0a98b854d121670)(mask, maskClosable);
        nextMaskConfig.closable ?? (nextMaskConfig.closable = false);
        return nextMaskConfig;
    }, [
        mask,
        maskClosable
    ]);
    // ========================= zIndex =========================
    const [, token] = (0, $cb3a44f4e76623bb$export$2e2bcd8739ae039)();
    const mergedZIndex = $5E6i4.useMemo(()=>{
        if (zIndex !== undefined) return zIndex;
        // Static always use max zIndex
        return token.zIndexPopupBase + (0, $09c5eb33e460ecef$export$33ada7d8845f7e5);
    }, [
        zIndex,
        token
    ]);
    // ========================= Render =========================
    return /*#__PURE__*/ $5E6i4.createElement((0, $b67bfa5e8f4d23c7$export$2e2bcd8739ae039), {
        ...modalProps,
        className: classString,
        wrapClassName: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)({
            [`${confirmPrefixCls}-centered`]: !!props.centered
        }, wrapClassName),
        onCancel: ()=>{
            close?.({
                triggerCancel: true
            });
            onConfirm?.(false);
        },
        title: title,
        footer: null,
        transitionName: (0, $c2c363b881b49d51$export$27c72201b1d09951)(rootPrefixCls || '', 'zoom', props.transitionName),
        maskTransitionName: (0, $c2c363b881b49d51$export$27c72201b1d09951)(rootPrefixCls || '', 'fade', props.maskTransitionName),
        mask: mergedMask,
        style: style,
        styles: semanticStyles,
        width: width,
        zIndex: mergedZIndex,
        closable: closable,
        _semanticOmit: $52a602ef9fda20e2$var$CONFIRM_OMIT_SEMANTIC_NAMES,
        _renderSemanticContent: ({ classNames: mergedClassNames, styles: mergedStyles })=>/*#__PURE__*/ $5E6i4.createElement($52a602ef9fda20e2$export$78cf841dc2c9f0b5, {
                ...props,
                confirmPrefixCls: confirmPrefixCls,
                okButtonProps: {
                    ...contextOkButtonProps,
                    ...okButtonProps
                },
                cancelButtonProps: {
                    ...contextCancelButtonProps,
                    ...cancelButtonProps
                },
                contentClassName: mergedClassNames.body,
                contentStyle: mergedStyles.body
            })
    });
};
const $52a602ef9fda20e2$var$ConfirmDialogWrapper = (props)=>{
    const { rootPrefixCls: rootPrefixCls, iconPrefixCls: iconPrefixCls, direction: direction, theme: theme } = props;
    return /*#__PURE__*/ $5E6i4.createElement((0, $58662003e62ec648$export$2e2bcd8739ae039), {
        prefixCls: rootPrefixCls,
        iconPrefixCls: iconPrefixCls,
        direction: direction,
        theme: theme
    }, /*#__PURE__*/ $5E6i4.createElement($52a602ef9fda20e2$var$ConfirmDialog, {
        ...props
    }));
};
var $52a602ef9fda20e2$export$2e2bcd8739ae039 = $52a602ef9fda20e2$var$ConfirmDialogWrapper;


const $f2a31b2c1dd5e53d$var$destroyFns = [];
var $f2a31b2c1dd5e53d$export$2e2bcd8739ae039 = $f2a31b2c1dd5e53d$var$destroyFns;



"use client";
let $fc0dec7e56e96a91$var$defaultRootPrefixCls = '';
function $fc0dec7e56e96a91$var$getRootPrefixCls() {
    return $fc0dec7e56e96a91$var$defaultRootPrefixCls;
}
const $fc0dec7e56e96a91$var$ConfirmDialogWrapper = (props)=>{
    const { prefixCls: customizePrefixCls, getContainer: getContainer, direction: direction } = props;
    const runtimeLocale = (0, $89984c3eb9021529$export$1b6004afda18cd51)();
    const config = (0, $5E6i4.useContext)((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
    const rootPrefixCls = $fc0dec7e56e96a91$var$getRootPrefixCls() || config.getPrefixCls();
    // because Modal.config set rootPrefixCls, which is different from other components
    const prefixCls = customizePrefixCls || `${rootPrefixCls}-modal`;
    let mergedGetContainer = getContainer;
    if (mergedGetContainer === false) mergedGetContainer = undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $52a602ef9fda20e2$export$2e2bcd8739ae039), {
        ...props,
        rootPrefixCls: rootPrefixCls,
        prefixCls: prefixCls,
        iconPrefixCls: config.iconPrefixCls,
        theme: config.theme,
        direction: direction ?? config.direction,
        locale: config.locale?.Modal ?? runtimeLocale,
        getContainer: mergedGetContainer
    });
};
function $fc0dec7e56e96a91$export$2e2bcd8739ae039(config) {
    const global = (0, $58662003e62ec648$export$f9cd1e43211d8a4a)();
    const container = document.createDocumentFragment();
    let currentConfig = {
        ...config,
        close: close,
        open: true
    };
    let timeoutId;
    function destroy(...args) {
        const triggerCancel = args.some((param)=>param?.triggerCancel);
        if (triggerCancel) config.onCancel?.(()=>{}, ...args.slice(1));
        for(let i = 0; i < (0, $f2a31b2c1dd5e53d$export$2e2bcd8739ae039).length; i++){
            const fn = (0, $f2a31b2c1dd5e53d$export$2e2bcd8739ae039)[i];
            if (fn === close) {
                (0, $f2a31b2c1dd5e53d$export$2e2bcd8739ae039).splice(i, 1);
                break;
            }
        }
        (0, $ffa1d788dcb0dd15$export$121e2d597d222bad)(container).then(()=>{
        // Do nothing
        });
    }
    const scheduleRender = (props)=>{
        clearTimeout(timeoutId);
        /**
     * https://github.com/ant-design/ant-design/issues/23623
     *
     * Sync render blocks React event. Let's make this async.
     */ timeoutId = setTimeout(()=>{
            const rootPrefixCls = global.getPrefixCls(undefined, $fc0dec7e56e96a91$var$getRootPrefixCls());
            const iconPrefixCls = global.getIconPrefixCls();
            const theme = global.getTheme();
            const dom = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement($fc0dec7e56e96a91$var$ConfirmDialogWrapper, {
                ...props
            });
            (0, $ffa1d788dcb0dd15$export$b3890eb0ae9dca99)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $58662003e62ec648$export$2e2bcd8739ae039), {
                prefixCls: rootPrefixCls,
                iconPrefixCls: iconPrefixCls,
                theme: theme
            }, (0, $addbc2fddcbb77a9$export$f6e2535fb5126e54)(global.holderRender) ? global.holderRender(dom) : dom), container);
        });
    };
    function close(...args) {
        currentConfig = {
            ...currentConfig,
            open: false,
            afterClose: ()=>{
                if ((0, $addbc2fddcbb77a9$export$f6e2535fb5126e54)(config.afterClose)) config.afterClose();
                // @ts-ignore
                destroy.apply(this, args);
            }
        };
        scheduleRender(currentConfig);
    }
    function update(configUpdate) {
        if ((0, $addbc2fddcbb77a9$export$f6e2535fb5126e54)(configUpdate)) currentConfig = configUpdate(currentConfig);
        else currentConfig = {
            ...currentConfig,
            ...configUpdate
        };
        scheduleRender(currentConfig);
    }
    scheduleRender(currentConfig);
    (0, $f2a31b2c1dd5e53d$export$2e2bcd8739ae039).push(close);
    return {
        destroy: close,
        update: update
    };
}
function $fc0dec7e56e96a91$export$503fa8fed137d104(props) {
    return {
        ...props,
        type: 'warning'
    };
}
function $fc0dec7e56e96a91$export$2f728eab0dacbb2e(props) {
    return {
        ...props,
        type: 'info'
    };
}
function $fc0dec7e56e96a91$export$2b5f8d7f29c805d4(props) {
    return {
        ...props,
        type: 'success'
    };
}
function $fc0dec7e56e96a91$export$60e9e0884ce12b55(props) {
    return {
        ...props,
        type: 'error'
    };
}
function $fc0dec7e56e96a91$export$665b64399d4af99c(props) {
    return {
        ...props,
        type: 'confirm'
    };
}
function $fc0dec7e56e96a91$export$ff0b30c638ae2396({ rootPrefixCls: rootPrefixCls }) {
    $fc0dec7e56e96a91$var$defaultRootPrefixCls = rootPrefixCls;
}





var $5E6i4 = parcelRequire("5E6i4");










"use client";
const $d89bf59589b01911$var$PurePanel = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, closeIcon: closeIcon, closable: closable, type: type, title: title, children: children, footer: footer, style: style, classNames: classNames, styles: styles, ...restProps } = props;
    const { getPrefixCls: getPrefixCls } = $5E6i4.useContext((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
    const { className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $519f2fad435b3034$export$46f4bd6436a25a31)('modal');
    const rootPrefixCls = getPrefixCls();
    const prefixCls = customizePrefixCls || getPrefixCls('modal');
    const rootCls = (0, $d104ec5f99ed66d7$export$2e2bcd8739ae039)(rootPrefixCls);
    const [hashId, cssVarCls] = (0, $3f4cbf08de7bcc1c$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const contextStyleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $722c8632ba7bdb89$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: props
    });
    const confirmPrefixCls = `${prefixCls}-confirm`;
    // Choose target props by confirm mark
    let additionalProps = {};
    if (type) additionalProps = {
        closable: closable ?? false,
        title: '',
        footer: '',
        children: /*#__PURE__*/ $5E6i4.createElement((0, $52a602ef9fda20e2$export$78cf841dc2c9f0b5), {
            ...props,
            prefixCls: prefixCls,
            confirmPrefixCls: confirmPrefixCls,
            rootPrefixCls: rootPrefixCls,
            content: children
        })
    };
    else additionalProps = {
        closable: closable ?? true,
        title: title,
        footer: footer !== null && /*#__PURE__*/ $5E6i4.createElement((0, $baa89cad5d6e1221$export$a06f1c675e846f6f), {
            ...props
        }),
        children: children
    };
    return /*#__PURE__*/ $5E6i4.createElement((0, $6cfb0b1093c47c51$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(hashId, `${prefixCls}-pure-panel`, type && confirmPrefixCls, type && `${confirmPrefixCls}-${type}`, className, contextClassName, cssVarCls, rootCls, mergedClassNames.root),
        style: mergedStyles.root,
        ...restProps,
        closeIcon: (0, $baa89cad5d6e1221$export$97c34646962d356e)(prefixCls, closeIcon),
        closable: closable,
        classNames: mergedClassNames,
        styles: mergedStyles,
        ...additionalProps
    });
};
var $d89bf59589b01911$export$2e2bcd8739ae039 = (0, $f49bb770731dacb5$export$29e2a8c3cdb34b03)($d89bf59589b01911$var$PurePanel);




var $5E6i4 = parcelRequire("5E6i4");


var $5E6i4 = parcelRequire("5E6i4");
const $a622ae5653d2a3bd$export$26425c9dd59b4436 = ()=>{
    const [elements, setElements] = $5E6i4.useState([]);
    const patchElement = $5E6i4.useCallback((element)=>{
        // append a new element to elements (and create a new ref)
        setElements((originElements)=>[].concat((0, $0acfae8147afe964$export$2e2bcd8739ae039)(originElements), [
                element
            ]));
        // return a function that removes the new element out of elements (and create a new ref)
        // it works a little like useEffect
        return ()=>{
            setElements((originElements)=>originElements.filter((ele)=>ele !== element));
        };
    }, []);
    return [
        elements,
        patchElement
    ];
};





var $5E6i4 = parcelRequire("5E6i4");






"use client";
const $794eee636d43484e$var$HookModal = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { afterClose: hookAfterClose, config: config, ...restProps } = props;
    const [open, setOpen] = $5E6i4.useState(true);
    const [innerConfig, setInnerConfig] = $5E6i4.useState(config);
    const { direction: direction, getPrefixCls: getPrefixCls } = $5E6i4.useContext((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('modal');
    const rootPrefixCls = getPrefixCls();
    const afterClose = ()=>{
        hookAfterClose();
        innerConfig.afterClose?.();
    };
    const close = (...args)=>{
        setOpen(false);
        const triggerCancel = args.some((param)=>param?.triggerCancel);
        if (triggerCancel) innerConfig.onCancel?.(()=>{}, ...args.slice(1));
    };
    $5E6i4.useImperativeHandle(ref, ()=>({
            destroy: close,
            update: (newConfig)=>{
                setInnerConfig((originConfig)=>{
                    const nextConfig = (0, $addbc2fddcbb77a9$export$f6e2535fb5126e54)(newConfig) ? newConfig(originConfig) : newConfig;
                    return {
                        ...originConfig,
                        ...nextConfig
                    };
                });
            }
        }));
    const mergedOkCancel = innerConfig.okCancel ?? innerConfig.type === 'confirm';
    const [contextLocale] = (0, $a2f3e1f88973a5e2$export$2e2bcd8739ae039)('Modal', (0, $7a40da28675d08a9$export$2e2bcd8739ae039).Modal);
    return /*#__PURE__*/ $5E6i4.createElement((0, $52a602ef9fda20e2$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        rootPrefixCls: rootPrefixCls,
        ...innerConfig,
        close: close,
        open: open,
        afterClose: afterClose,
        okText: (0, $c3b60ef18d99af24$export$2e2bcd8739ae039)(innerConfig.okText, mergedOkCancel ? contextLocale?.okText : contextLocale?.justOkText),
        direction: innerConfig.direction || direction,
        cancelText: (0, $c3b60ef18d99af24$export$2e2bcd8739ae039)(innerConfig.cancelText, contextLocale?.cancelText),
        ...restProps
    });
});
var $794eee636d43484e$export$2e2bcd8739ae039 = $794eee636d43484e$var$HookModal;


"use client";
let $338d8104a83f8074$var$uuid = 0;
const $338d8104a83f8074$var$ElementsHolder = /*#__PURE__*/ $5E6i4.memo(/*#__PURE__*/ $5E6i4.forwardRef((_props, ref)=>{
    const [elements, patchElement] = (0, $a622ae5653d2a3bd$export$26425c9dd59b4436)();
    $5E6i4.useImperativeHandle(ref, ()=>({
            patchElement: patchElement
        }), [
        patchElement
    ]);
    return /*#__PURE__*/ $5E6i4.createElement($5E6i4.Fragment, null, elements);
}));
function $338d8104a83f8074$var$useModal() {
    const holderRef = $5E6i4.useRef(null);
    // ========================== Effect ==========================
    const [actionQueue, setActionQueue] = $5E6i4.useState([]);
    $5E6i4.useEffect(()=>{
        if (actionQueue.length) {
            const cloneQueue = (0, $0acfae8147afe964$export$2e2bcd8739ae039)(actionQueue);
            cloneQueue.forEach((action)=>{
                action();
            });
            setActionQueue([]);
        }
    }, [
        actionQueue
    ]);
    // =========================== Hook ===========================
    const getConfirmFunc = $5E6i4.useCallback((withFunc)=>function hookConfirm(config) {
            $338d8104a83f8074$var$uuid += 1;
            const modalRef = /*#__PURE__*/ $5E6i4.createRef();
            // Proxy to promise with `onClose`
            let resolvePromise;
            const promise = new Promise((resolve)=>{
                resolvePromise = resolve;
            });
            let silent = false;
            let closeFunc;
            const modal = /*#__PURE__*/ $5E6i4.createElement((0, $794eee636d43484e$export$2e2bcd8739ae039), {
                key: `modal-${$338d8104a83f8074$var$uuid}`,
                config: withFunc(config),
                ref: modalRef,
                afterClose: ()=>{
                    closeFunc?.();
                },
                isSilent: ()=>silent,
                onConfirm: (confirmed)=>{
                    resolvePromise(confirmed);
                }
            });
            closeFunc = holderRef.current?.patchElement(modal);
            if (closeFunc) (0, $f2a31b2c1dd5e53d$export$2e2bcd8739ae039).push(closeFunc);
            const instance = {
                destroy: ()=>{
                    function destroyAction() {
                        modalRef.current?.destroy();
                    }
                    if (modalRef.current) destroyAction();
                    else setActionQueue((prev)=>[].concat((0, $0acfae8147afe964$export$2e2bcd8739ae039)(prev), [
                            destroyAction
                        ]));
                },
                update: (newConfig)=>{
                    function updateAction() {
                        modalRef.current?.update(newConfig);
                    }
                    if (modalRef.current) updateAction();
                    else setActionQueue((prev)=>[].concat((0, $0acfae8147afe964$export$2e2bcd8739ae039)(prev), [
                            updateAction
                        ]));
                },
                then: (resolve)=>{
                    silent = true;
                    return promise.then(resolve);
                }
            };
            return instance;
        }, []);
    const fns = $5E6i4.useMemo(()=>({
            info: getConfirmFunc((0, $fc0dec7e56e96a91$export$2f728eab0dacbb2e)),
            success: getConfirmFunc((0, $fc0dec7e56e96a91$export$2b5f8d7f29c805d4)),
            error: getConfirmFunc((0, $fc0dec7e56e96a91$export$60e9e0884ce12b55)),
            warning: getConfirmFunc((0, $fc0dec7e56e96a91$export$503fa8fed137d104)),
            confirm: getConfirmFunc((0, $fc0dec7e56e96a91$export$665b64399d4af99c))
        }), [
        getConfirmFunc
    ]);
    return [
        fns,
        /*#__PURE__*/ $5E6i4.createElement($338d8104a83f8074$var$ElementsHolder, {
            key: "modal-holder",
            ref: holderRef
        })
    ];
}
var $338d8104a83f8074$export$2e2bcd8739ae039 = $338d8104a83f8074$var$useModal;


"use client";
function $8d1ff632133ae5da$var$modalWarn(props) {
    return (0, $fc0dec7e56e96a91$export$2e2bcd8739ae039)((0, $fc0dec7e56e96a91$export$503fa8fed137d104)(props));
}
const $8d1ff632133ae5da$var$Modal = (0, $b67bfa5e8f4d23c7$export$2e2bcd8739ae039);
$8d1ff632133ae5da$var$Modal.useModal = (0, $338d8104a83f8074$export$2e2bcd8739ae039);
$8d1ff632133ae5da$var$Modal.info = function infoFn(props) {
    return (0, $fc0dec7e56e96a91$export$2e2bcd8739ae039)((0, $fc0dec7e56e96a91$export$2f728eab0dacbb2e)(props));
};
$8d1ff632133ae5da$var$Modal.success = function successFn(props) {
    return (0, $fc0dec7e56e96a91$export$2e2bcd8739ae039)((0, $fc0dec7e56e96a91$export$2b5f8d7f29c805d4)(props));
};
$8d1ff632133ae5da$var$Modal.error = function errorFn(props) {
    return (0, $fc0dec7e56e96a91$export$2e2bcd8739ae039)((0, $fc0dec7e56e96a91$export$60e9e0884ce12b55)(props));
};
$8d1ff632133ae5da$var$Modal.warning = $8d1ff632133ae5da$var$modalWarn;
$8d1ff632133ae5da$var$Modal.warn = $8d1ff632133ae5da$var$modalWarn;
$8d1ff632133ae5da$var$Modal.confirm = function confirmFn(props) {
    return (0, $fc0dec7e56e96a91$export$2e2bcd8739ae039)((0, $fc0dec7e56e96a91$export$665b64399d4af99c)(props));
};
$8d1ff632133ae5da$var$Modal.destroyAll = function destroyAllFn() {
    while((0, $f2a31b2c1dd5e53d$export$2e2bcd8739ae039).length){
        const close = (0, $f2a31b2c1dd5e53d$export$2e2bcd8739ae039).pop();
        if (close) close();
    }
};
$8d1ff632133ae5da$var$Modal.config = (0, $fc0dec7e56e96a91$export$ff0b30c638ae2396);
$8d1ff632133ae5da$var$Modal._InternalPanelDoNotUseOrYouWillBeFired = (0, $d89bf59589b01911$export$2e2bcd8739ae039);
var $8d1ff632133ae5da$export$2e2bcd8739ae039 = $8d1ff632133ae5da$var$Modal;


var $5E6i4 = parcelRequire("5E6i4");



var $5E6i4 = parcelRequire("5E6i4");

var $ibUU1 = parcelRequire("ibUU1");

var $5E6i4 = parcelRequire("5E6i4");



var $5E6i4 = parcelRequire("5E6i4");

var $0390d89dc0e9860e$export$2e2bcd8739ae039 = (file, acceptedFiles)=>{
    if (file && acceptedFiles) {
        const acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
        const fileName = file.name || '';
        const mimeType = file.type || '';
        const baseMimeType = mimeType.replace(/\/.*$/, '');
        return acceptedFilesArray.some((type)=>{
            const validType = type.trim();
            // This is something like */*,*  allow all files
            if (/^\*(\/\*)?$/.test(type)) return true;
            // like .jpg, .png
            if (validType.charAt(0) === '.') {
                const lowerFileName = fileName.toLowerCase();
                const lowerType = validType.toLowerCase();
                let affixList = [
                    lowerType
                ];
                if (lowerType === '.jpg' || lowerType === '.jpeg') affixList = [
                    '.jpg',
                    '.jpeg'
                ];
                return affixList.some((affix)=>lowerFileName.endsWith(affix));
            }
            // This is something like a image/* mime type
            if (/\/\*$/.test(validType)) return baseMimeType === validType.replace(/\/.*$/, '');
            // Full match
            if (mimeType === validType) return true;
            // Invalidate type should skip
            if (/^\w+$/.test(validType)) {
                (0, $f757b9ac02fa080d$export$2e2bcd8739ae039)(false, `Upload takes an invalidate 'accept' type '${validType}'.Skip for check.`);
                return true;
            }
            return false;
        });
    }
    return true;
};


function $67f1a7b53e01b96a$var$getError(option, xhr) {
    const msg = `cannot ${option.method} ${option.action} ${xhr.status}'`;
    const err = new Error(msg);
    err.status = xhr.status;
    err.method = option.method;
    err.url = option.action;
    return err;
}
function $67f1a7b53e01b96a$var$getBody(xhr) {
    const text = xhr.responseText || xhr.response;
    if (!text) return text;
    try {
        return JSON.parse(text);
    } catch (e) {
        return text;
    }
}
function $67f1a7b53e01b96a$export$2e2bcd8739ae039(option) {
    // eslint-disable-next-line no-undef
    const xhr = new XMLHttpRequest();
    if (option.onProgress && xhr.upload) xhr.upload.onprogress = function progress(e) {
        if (e.total > 0) e.percent = e.loaded / e.total * 100;
        option.onProgress(e);
    };
    // eslint-disable-next-line no-undef
    const formData = new FormData();
    if (option.data) Object.keys(option.data).forEach((key)=>{
        const value = option.data[key];
        // support key-value array data
        if (Array.isArray(value)) {
            value.forEach((item)=>{
                // { list: [ 11, 22 ] }
                // formData.append('list[]', 11);
                formData.append(`${key}[]`, item);
            });
            return;
        }
        formData.append(key, value);
    });
    // eslint-disable-next-line no-undef
    if (option.file instanceof Blob) formData.append(option.filename, option.file, option.file.name);
    else formData.append(option.filename, option.file);
    xhr.onerror = function error(e) {
        option.onError(e);
    };
    xhr.onload = function onload() {
        // allow success when 2xx status
        // see https://github.com/react-component/upload/issues/34
        if (xhr.status < 200 || xhr.status >= 300) return option.onError($67f1a7b53e01b96a$var$getError(option, xhr), $67f1a7b53e01b96a$var$getBody(xhr));
        return option.onSuccess($67f1a7b53e01b96a$var$getBody(xhr), xhr);
    };
    xhr.open(option.method, option.action, true);
    // Has to be after `.open()`. See https://github.com/enyo/dropzone/issues/179
    if (option.withCredentials && 'withCredentials' in xhr) xhr.withCredentials = true;
    const headers = option.headers || {};
    // when set headers['X-Requested-With'] = null , can close default XHR header
    // see https://github.com/react-component/upload/issues/33
    if (headers['X-Requested-With'] !== null) xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    Object.keys(headers).forEach((h)=>{
        if (headers[h] !== null) xhr.setRequestHeader(h, headers[h]);
    });
    xhr.send(formData);
    return {
        abort () {
            xhr.abort();
        }
    };
}


// https://github.com/ant-design/ant-design/issues/50080
const $9e3eaa90ef70eabb$var$traverseFileTree = async (files, isAccepted)=>{
    const flattenFileList = [];
    const progressFileList = [];
    files.forEach((file)=>progressFileList.push(file.webkitGetAsEntry()));
    async function readDirectory(directory) {
        const dirReader = directory.createReader();
        const entries = [];
        while(true){
            const results = await new Promise((resolve)=>{
                dirReader.readEntries(resolve, ()=>resolve([]));
            });
            const n = results.length;
            if (!n) break;
            for(let i = 0; i < n; i++)entries.push(results[i]);
        }
        return entries;
    }
    async function readFile(item) {
        return new Promise((reslove)=>{
            item.file((file)=>{
                if (isAccepted(file)) {
                    // https://github.com/ant-design/ant-design/issues/16426
                    if (item.fullPath && !file.webkitRelativePath) {
                        Object.defineProperties(file, {
                            webkitRelativePath: {
                                writable: true
                            }
                        });
                        // eslint-disable-next-line no-param-reassign
                        file.webkitRelativePath = item.fullPath.replace(/^\//, '');
                        Object.defineProperties(file, {
                            webkitRelativePath: {
                                writable: false
                            }
                        });
                    }
                    reslove(file);
                } else reslove(null);
            });
        });
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const _traverseFileTree = async (item, path)=>{
        if (!item) return;
        // eslint-disable-next-line no-param-reassign
        item.path = path || '';
        if (item.isFile) {
            const file = await readFile(item);
            if (file) flattenFileList.push(file);
        } else if (item.isDirectory) {
            const entries = await readDirectory(item);
            progressFileList.push(...entries);
        }
    };
    let wipIndex = 0;
    while(wipIndex < progressFileList.length){
        await _traverseFileTree(progressFileList[wipIndex]);
        wipIndex++;
    }
    return flattenFileList;
};
var $9e3eaa90ef70eabb$export$2e2bcd8739ae039 = $9e3eaa90ef70eabb$var$traverseFileTree;


const $c0d2866c3ec03b03$var$now = +new Date();
let $c0d2866c3ec03b03$var$index = 0;
function $c0d2866c3ec03b03$export$2e2bcd8739ae039() {
    // eslint-disable-next-line no-plusplus
    return `rc-upload-${$c0d2866c3ec03b03$var$now}-${++$c0d2866c3ec03b03$var$index}`;
}


function $74d537d93b28be8a$var$_extends() {
    $74d537d93b28be8a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $74d537d93b28be8a$var$_extends.apply(this, arguments);
}
class $74d537d93b28be8a$var$AjaxUploader extends (0, $5E6i4.Component) {
    state = {
        uid: (0, $c0d2866c3ec03b03$export$2e2bcd8739ae039)()
    };
    reqs = {};
    fileInput;
    _isMounted;
    filterFile = (file, force = false)=>{
        const { accept: accept, directory: directory } = this.props;
        let filterFn;
        let acceptFormat;
        if (typeof accept === 'string') acceptFormat = accept;
        else {
            const { filter: filter, format: format } = accept || {};
            acceptFormat = format;
            if (filter === 'native') filterFn = ()=>true;
            else filterFn = filter;
        }
        const mergedFilter = filterFn || (directory || force ? (currentFile)=>(0, $0390d89dc0e9860e$export$2e2bcd8739ae039)(currentFile, acceptFormat) : ()=>true);
        return mergedFilter(file);
    };
    onChange = (e)=>{
        const { files: files } = e.target;
        const acceptedFiles = [
            ...files
        ].filter((file)=>this.filterFile(file));
        this.uploadFiles(acceptedFiles);
        this.reset();
    };
    onClick = (event)=>{
        const el = this.fileInput;
        if (!el) return;
        const target = event.target;
        const { onClick: onClick } = this.props;
        if (target && target.tagName === 'BUTTON') {
            const parent = el.parentNode;
            parent.focus();
            target.blur();
        }
        el.click();
        if (onClick) onClick(event);
    };
    onKeyDown = (e)=>{
        if (e.key === 'Enter') this.onClick(e);
    };
    onDataTransferFiles = async (dataTransfer, existFileCallback)=>{
        const { multiple: multiple, directory: directory } = this.props;
        const items = [
            ...dataTransfer.items || []
        ];
        let files = [
            ...dataTransfer.files || []
        ];
        if (files.length > 0 || items.some((item)=>item.kind === 'file')) existFileCallback?.();
        if (directory) {
            files = await (0, $9e3eaa90ef70eabb$export$2e2bcd8739ae039)(Array.prototype.slice.call(items), this.filterFile);
            this.uploadFiles(files);
        } else {
            let acceptFiles = [
                ...files
            ].filter((file)=>this.filterFile(file, true));
            if (multiple === false) acceptFiles = files.slice(0, 1);
            this.uploadFiles(acceptFiles);
        }
    };
    onFilePaste = async (e)=>{
        const { pastable: pastable } = this.props;
        if (!pastable) return;
        if (e.type === 'paste') {
            const clipboardData = e.clipboardData;
            return this.onDataTransferFiles(clipboardData, ()=>{
                e.preventDefault();
            });
        }
    };
    onFileDragOver = (e)=>{
        e.preventDefault();
    };
    onFileDrop = async (e)=>{
        e.preventDefault();
        if (e.type === 'drop') {
            const dataTransfer = e.dataTransfer;
            return this.onDataTransferFiles(dataTransfer);
        }
    };
    componentDidMount() {
        this._isMounted = true;
        const { pastable: pastable } = this.props;
        if (pastable) document.addEventListener('paste', this.onFilePaste);
    }
    componentWillUnmount() {
        this._isMounted = false;
        this.abort();
        document.removeEventListener('paste', this.onFilePaste);
    }
    componentDidUpdate(prevProps) {
        const { pastable: pastable } = this.props;
        if (pastable && !prevProps.pastable) document.addEventListener('paste', this.onFilePaste);
        else if (!pastable && prevProps.pastable) document.removeEventListener('paste', this.onFilePaste);
    }
    uploadFiles = (files)=>{
        const originFiles = [
            ...files
        ];
        const postFiles = originFiles.map((file)=>{
            // eslint-disable-next-line no-param-reassign
            file.uid = (0, $c0d2866c3ec03b03$export$2e2bcd8739ae039)();
            return this.processFile(file, originFiles);
        });
        // Batch upload files
        Promise.all(postFiles).then((fileList)=>{
            const { onBatchStart: onBatchStart } = this.props;
            onBatchStart?.(fileList.map(({ origin: origin, parsedFile: parsedFile })=>({
                    file: origin,
                    parsedFile: parsedFile
                })));
            fileList.filter((file)=>file.parsedFile !== null).forEach((file)=>{
                this.post(file);
            });
        });
    };
    /**
   * Process file before upload. When all the file is ready, we start upload.
   */ processFile = async (file, fileList)=>{
        const { beforeUpload: beforeUpload } = this.props;
        let transformedFile = file;
        if (beforeUpload) {
            try {
                transformedFile = await beforeUpload(file, fileList);
            } catch (e) {
                // Rejection will also trade as false
                transformedFile = false;
            }
            if (transformedFile === false) return {
                origin: file,
                parsedFile: null,
                action: null,
                data: null
            };
        }
        // Get latest action
        const { action: action } = this.props;
        let mergedAction;
        if (typeof action === 'function') mergedAction = await action(file);
        else mergedAction = action;
        // Get latest data
        const { data: data } = this.props;
        let mergedData;
        if (typeof data === 'function') mergedData = await data(file);
        else mergedData = data;
        const parsedData = // string type is from legacy `transformFile`.
        // Not sure if this will work since no related test case works with it
        (typeof transformedFile === 'object' || typeof transformedFile === 'string') && transformedFile ? transformedFile : file;
        let parsedFile;
        if (parsedData instanceof File) parsedFile = parsedData;
        else parsedFile = new File([
            parsedData
        ], file.name, {
            type: file.type
        });
        const mergedParsedFile = parsedFile;
        mergedParsedFile.uid = file.uid;
        return {
            origin: file,
            data: mergedData,
            parsedFile: mergedParsedFile,
            action: mergedAction
        };
    };
    post({ data: data, origin: origin, action: action, parsedFile: parsedFile }) {
        if (!this._isMounted) return;
        const { onStart: onStart, customRequest: customRequest, name: name, headers: headers, withCredentials: withCredentials, method: method } = this.props;
        const { uid: uid } = origin;
        const request = customRequest || (0, $67f1a7b53e01b96a$export$2e2bcd8739ae039);
        const requestOption = {
            action: action,
            filename: name,
            data: data,
            file: parsedFile,
            headers: headers,
            withCredentials: withCredentials,
            method: method || 'post',
            onProgress: (e)=>{
                const { onProgress: onProgress } = this.props;
                onProgress?.(e, parsedFile);
            },
            onSuccess: (ret, xhr)=>{
                const { onSuccess: onSuccess } = this.props;
                onSuccess?.(ret, parsedFile, xhr);
                delete this.reqs[uid];
            },
            onError: (err, ret)=>{
                const { onError: onError } = this.props;
                onError?.(err, ret, parsedFile);
                delete this.reqs[uid];
            }
        };
        onStart(origin);
        this.reqs[uid] = request(requestOption, {
            defaultRequest: $67f1a7b53e01b96a$export$2e2bcd8739ae039
        });
    }
    reset() {
        this.setState({
            uid: (0, $c0d2866c3ec03b03$export$2e2bcd8739ae039)()
        });
    }
    abort(file) {
        const { reqs: reqs } = this;
        if (file) {
            const uid = file.uid ? file.uid : file;
            if (reqs[uid] && reqs[uid].abort) reqs[uid].abort();
            delete reqs[uid];
        } else Object.keys(reqs).forEach((uid)=>{
            if (reqs[uid] && reqs[uid].abort) reqs[uid].abort();
            delete reqs[uid];
        });
    }
    saveFileInput = (node)=>{
        this.fileInput = node;
    };
    render() {
        const { component: Tag, prefixCls: prefixCls, className: className, classNames: classNames = {}, disabled: disabled, id: id, name: name, style: style, styles: styles = {}, multiple: multiple, accept: accept, capture: capture, children: children, directory: directory, openFileDialogOnClick: openFileDialogOnClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, hasControlInside: hasControlInside, ...otherProps } = this.props;
        // Extract accept format for input element
        const acceptFormat = typeof accept === 'string' ? accept : accept?.format;
        const cls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, {
            [`${prefixCls}-disabled`]: disabled,
            [className]: className
        });
        // because input don't have directory/webkitdirectory type declaration
        const dirProps = directory ? {
            directory: 'directory',
            webkitdirectory: 'webkitdirectory'
        } : {};
        const events = disabled ? {} : {
            onClick: openFileDialogOnClick ? this.onClick : ()=>{},
            onKeyDown: openFileDialogOnClick ? this.onKeyDown : ()=>{},
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onDrop: this.onFileDrop,
            onDragOver: this.onFileDragOver,
            tabIndex: hasControlInside ? undefined : '0'
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement(Tag, $74d537d93b28be8a$var$_extends({}, events, {
            className: cls,
            role: hasControlInside ? undefined : 'button',
            style: style
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("input", $74d537d93b28be8a$var$_extends({}, (0, $78cde6532419ffca$export$2e2bcd8739ae039)(otherProps, {
            aria: true,
            data: true
        }), {
            id: id,
            name: name,
            disabled: disabled,
            type: "file",
            ref: this.saveFileInput,
            onClick: (e)=>e.stopPropagation() // https://github.com/ant-design/ant-design/issues/19948
            ,
            key: this.state.uid,
            style: {
                display: 'none',
                ...styles.input
            },
            className: classNames.input,
            accept: acceptFormat
        }, dirProps, {
            multiple: multiple,
            onChange: this.onChange
        }, capture != null ? {
            capture: capture
        } : {})), children);
    }
}
var $74d537d93b28be8a$export$2e2bcd8739ae039 = $74d537d93b28be8a$var$AjaxUploader;


function $9bf581864170134c$var$_extends() {
    $9bf581864170134c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9bf581864170134c$var$_extends.apply(this, arguments);
}
function $9bf581864170134c$var$empty() {}
class $9bf581864170134c$var$Upload extends (0, $5E6i4.Component) {
    static defaultProps = {
        component: 'span',
        prefixCls: 'rc-upload',
        data: {},
        headers: {},
        name: 'file',
        multipart: false,
        onStart: $9bf581864170134c$var$empty,
        onError: $9bf581864170134c$var$empty,
        onSuccess: $9bf581864170134c$var$empty,
        multiple: false,
        beforeUpload: null,
        customRequest: null,
        withCredentials: false,
        openFileDialogOnClick: true,
        hasControlInside: false
    };
    uploader;
    abort(file) {
        this.uploader.abort(file);
    }
    saveUploader = (node)=>{
        this.uploader = node;
    };
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $74d537d93b28be8a$export$2e2bcd8739ae039), $9bf581864170134c$var$_extends({}, this.props, {
            ref: this.saveUploader
        }));
    }
}
var $9bf581864170134c$export$2e2bcd8739ae039 = $9bf581864170134c$var$Upload;


var $c68e810a7c07a7e5$export$2e2bcd8739ae039 = (0, $9bf581864170134c$export$2e2bcd8739ae039);
















const $47d99e3b90e1c3af$var$genDraggerStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls } = token;
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}-drag`]: {
                position: 'relative',
                width: '100%',
                height: '100%',
                textAlign: 'center',
                background: token.colorFillAlter,
                border: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.lineWidth)} dashed ${token.colorBorder}`,
                borderRadius: token.borderRadiusLG,
                cursor: 'pointer',
                transition: `border-color ${token.motionDurationSlow}`,
                [componentCls]: {
                    padding: token.padding
                },
                [`${componentCls}-btn`]: {
                    display: 'table',
                    width: '100%',
                    height: '100%',
                    outline: 'none',
                    borderRadius: token.borderRadiusLG,
                    '&:focus-visible': {
                        outline: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.lineWidthFocus)} solid ${token.colorPrimaryBorder}`
                    }
                },
                [`${componentCls}-drag-container`]: {
                    display: 'table-cell',
                    verticalAlign: 'middle'
                },
                [`
          &:not(${componentCls}-disabled):hover,
          &-hover:not(${componentCls}-disabled)
        `]: {
                    borderColor: token.colorPrimaryHover
                },
                [`p${componentCls}-drag-icon`]: {
                    marginBottom: token.margin,
                    [iconCls]: {
                        color: token.colorPrimary,
                        fontSize: token.uploadThumbnailSize
                    }
                },
                [`p${componentCls}-text`]: {
                    margin: `0 0 ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.marginXXS)}`,
                    color: token.colorTextHeading,
                    fontSize: token.fontSizeLG
                },
                [`p${componentCls}-hint`]: {
                    color: token.colorTextDescription,
                    fontSize: token.fontSize
                },
                // ===================== Disabled =====================
                [`&${componentCls}-disabled`]: {
                    [`p${componentCls}-drag-icon ${iconCls},
            p${componentCls}-text,
            p${componentCls}-hint
          `]: {
                        color: token.colorTextDisabled
                    }
                }
            }
        }
    };
};
var $47d99e3b90e1c3af$export$2e2bcd8739ae039 = $47d99e3b90e1c3af$var$genDraggerStyle;




const $7b0a6821b55713d1$var$genListStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, fontSize: fontSize, lineHeight: lineHeight, motionDurationSlow: motionDurationSlow, calc: calc } = token;
    const itemCls = `${componentCls}-list-item`;
    const actionsCls = `${itemCls}-actions`;
    const actionCls = `${itemCls}-action`;
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}-list`]: {
                ...(0, $cd5a520fee8002b4$export$8c467e8859fdef13)(),
                lineHeight: token.lineHeight,
                [itemCls]: {
                    position: 'relative',
                    height: calc(token.lineHeight).mul(fontSize).equal(),
                    marginTop: token.marginXS,
                    fontSize: fontSize,
                    display: 'flex',
                    alignItems: 'center',
                    transition: `background-color ${motionDurationSlow}`,
                    borderRadius: token.borderRadiusSM,
                    '&:hover': {
                        backgroundColor: token.controlItemBgHover
                    },
                    [`${itemCls}-name`]: {
                        ...(0, $cd5a520fee8002b4$export$b2b65df0d0824629),
                        padding: `0 ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.paddingXS)}`,
                        lineHeight: lineHeight,
                        flex: 'auto',
                        transition: `all ${motionDurationSlow}`
                    },
                    [actionsCls]: {
                        whiteSpace: 'nowrap',
                        [actionCls]: {
                            opacity: 0
                        },
                        '@media (hover: none), (pointer: coarse)': {
                            [actionCls]: {
                                opacity: 1
                            }
                        },
                        [iconCls]: {
                            color: token.actionsColor,
                            transition: `all ${motionDurationSlow}`
                        },
                        [`
              ${actionCls}:focus-visible,
              &.picture ${actionCls}
            `]: {
                            opacity: 1
                        }
                    },
                    [`${componentCls}-icon ${iconCls}`]: {
                        color: token.colorIcon,
                        fontSize: fontSize
                    },
                    [`${itemCls}-progress`]: {
                        position: 'absolute',
                        bottom: token.calc(token.uploadProgressOffset).mul(-1).equal(),
                        width: '100%',
                        paddingInlineStart: calc(fontSize).add(token.paddingXS).equal(),
                        fontSize: fontSize,
                        lineHeight: 0,
                        pointerEvents: 'none',
                        '> div': {
                            margin: 0
                        }
                    }
                },
                [`${itemCls}:hover ${actionCls}`]: {
                    opacity: 1
                },
                [`${itemCls}-error`]: {
                    color: token.colorError,
                    [`${itemCls}-name, ${componentCls}-icon ${iconCls}`]: {
                        color: token.colorError
                    },
                    [actionsCls]: {
                        [`${iconCls}, ${iconCls}:hover`]: {
                            color: token.colorError
                        },
                        [actionCls]: {
                            opacity: 1
                        }
                    }
                },
                [`${componentCls}-list-item-container`]: {
                    transition: [
                        'opacity',
                        'height'
                    ].map((prop)=>`${prop} ${motionDurationSlow}`).join(', '),
                    // For smooth removing animation
                    '&::before': {
                        display: 'table',
                        width: 0,
                        height: 0,
                        content: '""'
                    }
                }
            }
        }
    };
};
var $7b0a6821b55713d1$export$2e2bcd8739ae039 = $7b0a6821b55713d1$var$genListStyle;




// =========================== Motion ===========================
const $689be026b5c900fa$var$genMotionStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const uploadAnimateInlineIn = new (0, $14544cbeb8c8473b$export$2e2bcd8739ae039)('uploadAnimateInlineIn', {
        from: {
            width: 0,
            height: 0,
            padding: 0,
            opacity: 0,
            margin: token.calc(token.marginXS).div(-2).equal()
        }
    });
    const uploadAnimateInlineOut = new (0, $14544cbeb8c8473b$export$2e2bcd8739ae039)('uploadAnimateInlineOut', {
        to: {
            width: 0,
            height: 0,
            padding: 0,
            opacity: 0,
            margin: token.calc(token.marginXS).div(-2).equal()
        }
    });
    const inlineCls = `${componentCls}-animate-inline`;
    return [
        {
            [`${componentCls}-wrapper`]: {
                [`${inlineCls}-appear, ${inlineCls}-enter, ${inlineCls}-leave`]: {
                    animationDuration: token.motionDurationSlow,
                    animationTimingFunction: token.motionEaseInOutCirc,
                    animationFillMode: 'forwards'
                },
                [`${inlineCls}-appear, ${inlineCls}-enter`]: {
                    animationName: uploadAnimateInlineIn
                },
                [`${inlineCls}-leave`]: {
                    animationName: uploadAnimateInlineOut
                }
            }
        },
        {
            [`${componentCls}-wrapper`]: (0, $74fc3232bfd7dcd0$export$2909268c8354a12)(token)
        },
        uploadAnimateInlineIn,
        uploadAnimateInlineOut
    ];
};
var $689be026b5c900fa$export$2e2bcd8739ae039 = $689be026b5c900fa$var$genMotionStyle;




const $b0c3b90d4e2ba544$export$353fdbacdd19997a = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, uploadThumbnailSize: uploadThumbnailSize, uploadProgressOffset: uploadProgressOffset, calc: calc } = token;
    const listCls = `${componentCls}-list`;
    const itemCls = `${listCls}-item`;
    return {
        [`${componentCls}-wrapper`]: {
            // ${listCls} 增加优先级
            [`
        ${listCls}${listCls}-picture,
        ${listCls}${listCls}-picture-card,
        ${listCls}${listCls}-picture-circle
      `]: {
                [itemCls]: {
                    position: 'relative',
                    height: calc(uploadThumbnailSize).add(calc(token.lineWidth).mul(2)).add(calc(token.paddingXS).mul(2)).equal(),
                    padding: token.paddingXS,
                    border: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                    borderRadius: token.borderRadiusLG,
                    '&:hover': {
                        background: 'transparent'
                    },
                    [`${itemCls}-thumbnail`]: {
                        ...(0, $cd5a520fee8002b4$export$b2b65df0d0824629),
                        width: uploadThumbnailSize,
                        height: uploadThumbnailSize,
                        lineHeight: (0, $56bae8a99c3cba6e$export$523c0b569236b342)(calc(uploadThumbnailSize).add(token.paddingSM).equal()),
                        textAlign: 'center',
                        flex: 'none',
                        [iconCls]: {
                            fontSize: token.fontSizeHeading2,
                            color: token.colorPrimary
                        },
                        img: {
                            display: 'block',
                            width: '100%',
                            height: '100%',
                            overflow: 'hidden'
                        }
                    },
                    [`${itemCls}-progress`]: {
                        bottom: calc(token.fontSize).mul(token.lineHeight).div(2).add(uploadProgressOffset).equal(),
                        width: `calc(100% - ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(calc(token.paddingSM).mul(2).equal())})`,
                        marginTop: 0,
                        paddingInlineStart: calc(uploadThumbnailSize).add(token.paddingXS).equal()
                    }
                },
                [`${itemCls}-error`]: {
                    borderColor: token.colorError,
                    [`${itemCls}-thumbnail${itemCls}-file ${iconCls}`]: {
                        color: token.colorError
                    }
                },
                [`${itemCls}-uploading`]: {
                    borderStyle: 'dashed',
                    [`${itemCls}-name`]: {
                        marginBottom: uploadProgressOffset
                    }
                }
            },
            [`${listCls}${listCls}-picture-circle ${itemCls}`]: {
                [`&, &::before, ${itemCls}-thumbnail`]: {
                    borderRadius: '50%'
                }
            }
        }
    };
};
const $b0c3b90d4e2ba544$export$31311f200c99910f = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, fontSizeLG: fontSizeLG, colorTextLightSolid: colorTextLightSolid, calc: calc } = token;
    const listCls = `${componentCls}-list`;
    const itemCls = `${listCls}-item`;
    const uploadPictureCardSize = token.uploadPicCardSize;
    return {
        [`
      ${componentCls}-wrapper${componentCls}-picture-card-wrapper,
      ${componentCls}-wrapper${componentCls}-picture-circle-wrapper
    `]: {
            ...(0, $cd5a520fee8002b4$export$8c467e8859fdef13)(),
            display: 'block',
            [`${componentCls}${componentCls}-select`]: {
                width: uploadPictureCardSize,
                height: uploadPictureCardSize,
                textAlign: 'center',
                verticalAlign: 'top',
                backgroundColor: token.colorFillAlter,
                border: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.lineWidth)} dashed ${token.colorBorder}`,
                borderRadius: token.borderRadiusLG,
                cursor: 'pointer',
                transition: `border-color ${token.motionDurationSlow}`,
                [`> ${componentCls}`]: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%',
                    textAlign: 'center'
                },
                [`&:not(${componentCls}-disabled):hover`]: {
                    borderColor: token.colorPrimary
                }
            },
            // list
            [`${listCls}${listCls}-picture-card, ${listCls}${listCls}-picture-circle`]: {
                display: 'flex',
                flexWrap: 'wrap',
                '&:not(:empty)': {
                    minHeight: uploadPictureCardSize
                },
                '@supports not (gap: 1px)': {
                    '& > *': {
                        marginBlockEnd: token.marginXS,
                        marginInlineEnd: token.marginXS
                    }
                },
                '@supports (gap: 1px)': {
                    gap: token.marginXS
                },
                [`${listCls}-item-container`]: {
                    display: 'inline-block',
                    width: uploadPictureCardSize,
                    height: uploadPictureCardSize,
                    verticalAlign: 'top'
                },
                '&::after': {
                    display: 'none'
                },
                '&::before': {
                    display: 'none'
                },
                [itemCls]: {
                    height: '100%',
                    margin: 0,
                    '&::before': {
                        position: 'absolute',
                        zIndex: 1,
                        width: `calc(100% - ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(calc(token.paddingXS).mul(2).equal())})`,
                        height: `calc(100% - ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(calc(token.paddingXS).mul(2).equal())})`,
                        backgroundColor: token.colorBgMask,
                        opacity: 0,
                        transition: `all ${token.motionDurationSlow}`,
                        content: '" "'
                    }
                },
                [`${itemCls}:hover`]: {
                    [`&::before, ${itemCls}-actions`]: {
                        opacity: 1
                    }
                },
                [`${itemCls}-actions`]: {
                    position: 'absolute',
                    insetInlineStart: 0,
                    zIndex: 10,
                    width: '100%',
                    whiteSpace: 'nowrap',
                    textAlign: 'center',
                    opacity: 0,
                    transition: `all ${token.motionDurationSlow}`,
                    [`
            ${iconCls}-eye,
            ${iconCls}-download,
            ${iconCls}-delete
          `]: {
                        zIndex: 10,
                        width: fontSizeLG,
                        margin: `0 ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.marginXXS)}`,
                        fontSize: fontSizeLG,
                        cursor: 'pointer',
                        transition: `all ${token.motionDurationSlow}`,
                        color: colorTextLightSolid,
                        '&:hover': {
                            color: colorTextLightSolid
                        },
                        svg: {
                            verticalAlign: 'baseline'
                        }
                    }
                },
                [`${itemCls}-thumbnail, ${itemCls}-thumbnail img`]: {
                    position: 'static',
                    display: 'block',
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain'
                },
                [`${itemCls}-name`]: {
                    display: 'none',
                    textAlign: 'center'
                },
                [`${itemCls}-file + ${itemCls}-name`]: {
                    position: 'absolute',
                    bottom: token.margin,
                    display: 'block',
                    width: `calc(100% - ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(calc(token.paddingXS).mul(2).equal())})`
                },
                [`${itemCls}-uploading`]: {
                    [`&${itemCls}`]: {
                        backgroundColor: token.colorFillAlter
                    },
                    [`&::before, ${iconCls}-eye, ${iconCls}-download, ${iconCls}-delete`]: {
                        display: 'none'
                    }
                },
                [`${itemCls}-progress`]: {
                    bottom: token.marginXL,
                    width: `calc(100% - ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(calc(token.paddingXS).mul(2).equal())})`,
                    paddingInlineStart: 0
                }
            }
        },
        [`${componentCls}-wrapper${componentCls}-picture-circle-wrapper`]: {
            [`${componentCls}${componentCls}-select`]: {
                borderRadius: '50%'
            }
        }
    };
};


// =========================== Motion ===========================
const $32f94f3462a6860f$var$genRtlStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-rtl`]: {
            direction: 'rtl'
        }
    };
};
var $32f94f3462a6860f$export$2e2bcd8739ae039 = $32f94f3462a6860f$var$genRtlStyle;


const $5ef6d53e9e3237ff$var$genBaseStyle = (token)=>{
    const { componentCls: componentCls, colorTextDisabled: colorTextDisabled } = token;
    return {
        [`${componentCls}-wrapper`]: {
            ...(0, $cd5a520fee8002b4$export$23997c3e44cc1c59)(token),
            [componentCls]: {
                outline: 0,
                "input[type='file']": {
                    cursor: 'pointer'
                }
            },
            [`${componentCls}-select`]: {
                display: 'inline-block'
            },
            [`${componentCls}-hidden`]: {
                display: 'none'
            },
            [`${componentCls}-disabled`]: {
                color: colorTextDisabled,
                cursor: 'not-allowed'
            }
        }
    };
};
const $5ef6d53e9e3237ff$export$9ca1be8807fe0675 = (token)=>({
        actionsColor: token.colorIcon,
        pictureCardSize: token.controlHeightLG * 2.55
    });
var // ============================== Export ==============================
$5ef6d53e9e3237ff$export$2e2bcd8739ae039 = (0, $761caadb5301aee1$export$51ec95de45185b42)('Upload', (token)=>{
    const { fontSizeHeading3: fontSizeHeading3, marginXS: marginXS, lineWidth: lineWidth, pictureCardSize: pictureCardSize, calc: calc } = token;
    const uploadToken = (0, $f564548c7b6877d5$export$4950aa0f605343fb)(token, {
        uploadThumbnailSize: calc(fontSizeHeading3).mul(2).equal(),
        uploadProgressOffset: calc(calc(marginXS).div(2)).add(lineWidth).equal(),
        uploadPicCardSize: pictureCardSize
    });
    return [
        $5ef6d53e9e3237ff$var$genBaseStyle(uploadToken),
        (0, $47d99e3b90e1c3af$export$2e2bcd8739ae039)(uploadToken),
        (0, $b0c3b90d4e2ba544$export$353fdbacdd19997a)(uploadToken),
        (0, $b0c3b90d4e2ba544$export$31311f200c99910f)(uploadToken),
        (0, $7b0a6821b55713d1$export$2e2bcd8739ae039)(uploadToken),
        (0, $689be026b5c900fa$export$2e2bcd8739ae039)(uploadToken),
        (0, $32f94f3462a6860f$export$2e2bcd8739ae039)(uploadToken),
        (0, $5f07542305776ab3$export$2e2bcd8739ae039)(uploadToken)
    ];
}, $5ef6d53e9e3237ff$export$9ca1be8807fe0675);




var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $2fad16cf080b429d$var$FileOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z"
                }
            }
        ]
    },
    "name": "file",
    "theme": "outlined"
};
var $2fad16cf080b429d$export$2e2bcd8739ae039 = $2fad16cf080b429d$var$FileOutlined;



function $70372d32dbe4addb$var$_extends() {
    $70372d32dbe4addb$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $70372d32dbe4addb$var$_extends.apply(this, arguments);
}
const $70372d32dbe4addb$var$FileOutlined = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $70372d32dbe4addb$var$_extends({}, props, {
        ref: ref,
        icon: (0, $2fad16cf080b429d$export$2e2bcd8739ae039)
    }));
/**![file](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg1NC42IDI4OC42TDYzOS40IDczLjRjLTYtNi0xNC4xLTkuNC0yMi42LTkuNEgxOTJjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjgzMmMwIDE3LjcgMTQuMyAzMiAzMiAzMmg2NDBjMTcuNyAwIDMyLTE0LjMgMzItMzJWMzExLjNjMC04LjUtMy40LTE2LjctOS40LTIyLjd6TTc5MC4yIDMyNkg2MDJWMTM3LjhMNzkwLjIgMzI2em0xLjggNTYySDIzMlYxMzZoMzAydjIxNmE0MiA0MiAwIDAwNDIgNDJoMjE2djQ5NHoiIC8+PC9zdmc+) */ const $70372d32dbe4addb$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($70372d32dbe4addb$var$FileOutlined);
var $70372d32dbe4addb$export$2e2bcd8739ae039 = $70372d32dbe4addb$var$RefIcon;




var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $d401c2c61249bc25$var$PaperClipOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M779.3 196.6c-94.2-94.2-247.6-94.2-341.7 0l-261 260.8c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l261-260.8c32.4-32.4 75.5-50.2 121.3-50.2s88.9 17.8 121.2 50.2c32.4 32.4 50.2 75.5 50.2 121.2 0 45.8-17.8 88.8-50.2 121.2l-266 265.9-43.1 43.1c-40.3 40.3-105.8 40.3-146.1 0-19.5-19.5-30.2-45.4-30.2-73s10.7-53.5 30.2-73l263.9-263.8c6.7-6.6 15.5-10.3 24.9-10.3h.1c9.4 0 18.1 3.7 24.7 10.3 6.7 6.7 10.3 15.5 10.3 24.9 0 9.3-3.7 18.1-10.3 24.7L372.4 653c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l215.6-215.6c19.9-19.9 30.8-46.3 30.8-74.4s-11-54.6-30.8-74.4c-41.1-41.1-107.9-41-149 0L463 364 224.8 602.1A172.22 172.22 0 00174 724.8c0 46.3 18.1 89.8 50.8 122.5 33.9 33.8 78.3 50.7 122.7 50.7 44.4 0 88.8-16.9 122.6-50.7l309.2-309C824.8 492.7 850 432 850 367.5c.1-64.6-25.1-125.3-70.7-170.9z"
                }
            }
        ]
    },
    "name": "paper-clip",
    "theme": "outlined"
};
var $d401c2c61249bc25$export$2e2bcd8739ae039 = $d401c2c61249bc25$var$PaperClipOutlined;



function $fa43313e830d0cea$var$_extends() {
    $fa43313e830d0cea$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fa43313e830d0cea$var$_extends.apply(this, arguments);
}
const $fa43313e830d0cea$var$PaperClipOutlined = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $fa43313e830d0cea$var$_extends({}, props, {
        ref: ref,
        icon: (0, $d401c2c61249bc25$export$2e2bcd8739ae039)
    }));
/**![paper-clip](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTc3OS4zIDE5Ni42Yy05NC4yLTk0LjItMjQ3LjYtOTQuMi0zNDEuNyAwbC0yNjEgMjYwLjhjLTEuNyAxLjctMi42IDQtMi42IDYuNHMuOSA0LjcgMi42IDYuNGwzNi45IDM2LjlhOSA5IDAgMDAxMi43IDBsMjYxLTI2MC44YzMyLjQtMzIuNCA3NS41LTUwLjIgMTIxLjMtNTAuMnM4OC45IDE3LjggMTIxLjIgNTAuMmMzMi40IDMyLjQgNTAuMiA3NS41IDUwLjIgMTIxLjIgMCA0NS44LTE3LjggODguOC01MC4yIDEyMS4ybC0yNjYgMjY1LjktNDMuMSA0My4xYy00MC4zIDQwLjMtMTA1LjggNDAuMy0xNDYuMSAwLTE5LjUtMTkuNS0zMC4yLTQ1LjQtMzAuMi03M3MxMC43LTUzLjUgMzAuMi03M2wyNjMuOS0yNjMuOGM2LjctNi42IDE1LjUtMTAuMyAyNC45LTEwLjNoLjFjOS40IDAgMTguMSAzLjcgMjQuNyAxMC4zIDYuNyA2LjcgMTAuMyAxNS41IDEwLjMgMjQuOSAwIDkuMy0zLjcgMTguMS0xMC4zIDI0LjdMMzcyLjQgNjUzYy0xLjcgMS43LTIuNiA0LTIuNiA2LjRzLjkgNC43IDIuNiA2LjRsMzYuOSAzNi45YTkgOSAwIDAwMTIuNyAwbDIxNS42LTIxNS42YzE5LjktMTkuOSAzMC44LTQ2LjMgMzAuOC03NC40cy0xMS01NC42LTMwLjgtNzQuNGMtNDEuMS00MS4xLTEwNy45LTQxLTE0OSAwTDQ2MyAzNjQgMjI0LjggNjAyLjFBMTcyLjIyIDE3Mi4yMiAwIDAwMTc0IDcyNC44YzAgNDYuMyAxOC4xIDg5LjggNTAuOCAxMjIuNSAzMy45IDMzLjggNzguMyA1MC43IDEyMi43IDUwLjcgNDQuNCAwIDg4LjgtMTYuOSAxMjIuNi01MC43bDMwOS4yLTMwOUM4MjQuOCA0OTIuNyA4NTAgNDMyIDg1MCAzNjcuNWMuMS02NC42LTI1LjEtMTI1LjMtNzAuNy0xNzAuOXoiIC8+PC9zdmc+) */ const $fa43313e830d0cea$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($fa43313e830d0cea$var$PaperClipOutlined);
var $fa43313e830d0cea$export$2e2bcd8739ae039 = $fa43313e830d0cea$var$RefIcon;



var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $fe8cf9e8bd439958$var$PictureOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2zM304 456a88 88 0 100-176 88 88 0 000 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z"
                }
            }
        ]
    },
    "name": "picture",
    "theme": "outlined"
};
var $fe8cf9e8bd439958$export$2e2bcd8739ae039 = $fe8cf9e8bd439958$var$PictureOutlined;



function $3d00f6c811915fa3$var$_extends() {
    $3d00f6c811915fa3$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3d00f6c811915fa3$var$_extends.apply(this, arguments);
}
const $3d00f6c811915fa3$var$PictureOutlined = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $3d00f6c811915fa3$var$_extends({}, props, {
        ref: ref,
        icon: (0, $fe8cf9e8bd439958$export$2e2bcd8739ae039)
    }));
/**![picture](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkyOCAxNjBIOTZjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjY0MGMwIDE3LjcgMTQuMyAzMiAzMiAzMmg4MzJjMTcuNyAwIDMyLTE0LjMgMzItMzJWMTkyYzAtMTcuNy0xNC4zLTMyLTMyLTMyem0tNDAgNjMySDEzNnYtMzkuOWwxMzguNS0xNjQuMyAxNTAuMSAxNzhMNjU4LjEgNDg5IDg4OCA3NjEuNlY3OTJ6bTAtMTI5LjhMNjY0LjIgMzk2LjhjLTMuMi0zLjgtOS0zLjgtMTIuMiAwTDQyNC42IDY2Ni40bC0xNDQtMTcwLjdjLTMuMi0zLjgtOS0zLjgtMTIuMiAwTDEzNiA2NTIuN1YyMzJoNzUydjQzMC4yek0zMDQgNDU2YTg4IDg4IDAgMTAwLTE3NiA4OCA4OCAwIDAwMCAxNzZ6bTAtMTE2YzE1LjUgMCAyOCAxMi41IDI4IDI4cy0xMi41IDI4LTI4IDI4LTI4LTEyLjUtMjgtMjggMTIuNS0yOCAyOC0yOHoiIC8+PC9zdmc+) */ const $3d00f6c811915fa3$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($3d00f6c811915fa3$var$PictureOutlined);
var $3d00f6c811915fa3$export$2e2bcd8739ae039 = $3d00f6c811915fa3$var$RefIcon;












function $365f292f34f9cf9e$export$6dc848fd109e803d(file) {
    return {
        ...file,
        lastModified: file.lastModified,
        lastModifiedDate: file.lastModifiedDate,
        name: file.name,
        size: file.size,
        type: file.type,
        uid: file.uid,
        percent: 0,
        originFileObj: file
    };
}
function $365f292f34f9cf9e$export$65c2063f64290f37(file, fileList) {
    const nextFileList = (0, $0acfae8147afe964$export$2e2bcd8739ae039)(fileList);
    const fileIndex = nextFileList.findIndex(({ uid: uid })=>uid === file.uid);
    if (fileIndex === -1) nextFileList.push(file);
    else nextFileList[fileIndex] = file;
    return nextFileList;
}
function $365f292f34f9cf9e$export$1165ac073f485fae(file, fileList) {
    const matchKey = file.uid !== undefined ? 'uid' : 'name';
    return fileList.filter((item)=>item[matchKey] === file[matchKey])[0];
}
function $365f292f34f9cf9e$export$f3bced642db28a96(file, fileList) {
    const matchKey = file.uid !== undefined ? 'uid' : 'name';
    const removed = fileList.filter((item)=>item[matchKey] !== file[matchKey]);
    if (removed.length === fileList.length) return null;
    return removed;
}
// ==================== Default Image Preview ====================
const $365f292f34f9cf9e$var$extname = (url = '')=>{
    const temp = url.split('/');
    const filename = temp[temp.length - 1];
    const filenameWithoutSuffix = filename.split(/#|\?/)[0];
    return (/\.[^./\\]*$/.exec(filenameWithoutSuffix) || [
        ''
    ])[0];
};
const $365f292f34f9cf9e$var$isImageFileType = (type)=>type.indexOf('image/') === 0;
const $365f292f34f9cf9e$var$imageExtensions = [
    '.avif',
    '.bmp',
    '.dpg',
    '.gif',
    '.heic',
    '.heif',
    '.ico',
    '.jfif',
    '.jpg',
    '.jpeg',
    '.png',
    '.svg',
    '.tif',
    '.tiff',
    '.webp'
];
const $365f292f34f9cf9e$export$431d13c2db3f6781 = (file)=>{
    if (file.type && !file.thumbUrl) return $365f292f34f9cf9e$var$isImageFileType(file.type);
    const url = file.thumbUrl || file.url || '';
    const extension = $365f292f34f9cf9e$var$extname(url || file.name);
    if (/^data:image\//.test(url) || $365f292f34f9cf9e$var$imageExtensions.includes(extension?.toLowerCase() || '')) return true;
    if (/^data:/.test(url)) // other file types of base64
    return false;
    if (extension) // other file types which have extension
    return false;
    return true;
};
const $365f292f34f9cf9e$var$MEASURE_SIZE = 200;
function $365f292f34f9cf9e$export$b5db251096956c0d(file) {
    return new Promise((resolve)=>{
        if (!file.type || !$365f292f34f9cf9e$var$isImageFileType(file.type)) {
            resolve('');
            return;
        }
        if (file.type.startsWith('image/gif')) {
            const reader = new FileReader();
            reader.onload = ()=>{
                if (reader.result) resolve(reader.result);
            };
            reader.readAsDataURL(file);
            return;
        }
        const canvas = document.createElement('canvas');
        canvas.width = $365f292f34f9cf9e$var$MEASURE_SIZE;
        canvas.height = $365f292f34f9cf9e$var$MEASURE_SIZE;
        canvas.style.cssText = `position: fixed; left: 0; top: 0; width: ${$365f292f34f9cf9e$var$MEASURE_SIZE}px; height: ${$365f292f34f9cf9e$var$MEASURE_SIZE}px; z-index: 9999; display: none;`;
        document.body.appendChild(canvas);
        const ctx = canvas.getContext('2d');
        const img = new Image();
        img.onload = ()=>{
            const { width: width, height: height } = img;
            let drawWidth = $365f292f34f9cf9e$var$MEASURE_SIZE;
            let drawHeight = $365f292f34f9cf9e$var$MEASURE_SIZE;
            let offsetX = 0;
            let offsetY = 0;
            if (width > height) {
                drawHeight = height * ($365f292f34f9cf9e$var$MEASURE_SIZE / width);
                offsetY = -(drawHeight - drawWidth) / 2;
            } else {
                drawWidth = width * ($365f292f34f9cf9e$var$MEASURE_SIZE / height);
                offsetX = -(drawWidth - drawHeight) / 2;
            }
            ctx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight);
            const dataURL = canvas.toDataURL();
            document.body.removeChild(canvas);
            window.URL.revokeObjectURL(img.src);
            resolve(dataURL);
        };
        img.crossOrigin = 'anonymous';
        if (file.type.startsWith('image/svg+xml')) {
            const reader = new FileReader();
            reader.onload = ()=>{
                if (reader.result && typeof reader.result === 'string') img.src = reader.result;
            };
            reader.readAsDataURL(file);
        } else img.src = window.URL.createObjectURL(file);
    });
}



var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $de0df7e9b3095ed9$var$DeleteOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z"
                }
            }
        ]
    },
    "name": "delete",
    "theme": "outlined"
};
var $de0df7e9b3095ed9$export$2e2bcd8739ae039 = $de0df7e9b3095ed9$var$DeleteOutlined;



function $424ba773c7c920f3$var$_extends() {
    $424ba773c7c920f3$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $424ba773c7c920f3$var$_extends.apply(this, arguments);
}
const $424ba773c7c920f3$var$DeleteOutlined = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $424ba773c7c920f3$var$_extends({}, props, {
        ref: ref,
        icon: (0, $de0df7e9b3095ed9$export$2e2bcd8739ae039)
    }));
/**![delete](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTM2MCAxODRoLThjNC40IDAgOC0zLjYgOC04djhoMzA0di04YzAgNC40IDMuNiA4IDggOGgtOHY3Mmg3MnYtODBjMC0zNS4zLTI4LjctNjQtNjQtNjRIMzUyYy0zNS4zIDAtNjQgMjguNy02NCA2NHY4MGg3MnYtNzJ6bTUwNCA3MkgxNjBjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjMyYzAgNC40IDMuNiA4IDggOGg2MC40bDI0LjcgNTIzYzEuNiAzNC4xIDI5LjggNjEgNjMuOSA2MWg0NTRjMzQuMiAwIDYyLjMtMjYuOCA2My45LTYxbDI0LjctNTIzSDg4OGM0LjQgMCA4LTMuNiA4LTh2LTMyYzAtMTcuNy0xNC4zLTMyLTMyLTMyek03MzEuMyA4NDBIMjkyLjdsLTI0LjItNTEyaDQ4N2wtMjQuMiA1MTJ6IiAvPjwvc3ZnPg==) */ const $424ba773c7c920f3$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($424ba773c7c920f3$var$DeleteOutlined);
var $424ba773c7c920f3$export$2e2bcd8739ae039 = $424ba773c7c920f3$var$RefIcon;



var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $7447461f237ce002$var$DownloadOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M505.7 661a8 8 0 0012.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V168c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "download",
    "theme": "outlined"
};
var $7447461f237ce002$export$2e2bcd8739ae039 = $7447461f237ce002$var$DownloadOutlined;



function $093f7bace4fdf24c$var$_extends() {
    $093f7bace4fdf24c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $093f7bace4fdf24c$var$_extends.apply(this, arguments);
}
const $093f7bace4fdf24c$var$DownloadOutlined = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $093f7bace4fdf24c$var$_extends({}, props, {
        ref: ref,
        icon: (0, $7447461f237ce002$export$2e2bcd8739ae039)
    }));
/**![download](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUwNS43IDY2MWE4IDggMCAwMDEyLjYgMGwxMTItMTQxLjdjNC4xLTUuMi40LTEyLjktNi4zLTEyLjloLTc0LjFWMTY4YzAtNC40LTMuNi04LTgtOGgtNjBjLTQuNCAwLTggMy42LTggOHYzMzguM0g0MDBjLTYuNyAwLTEwLjQgNy43LTYuMyAxMi45bDExMiAxNDEuOHpNODc4IDYyNmgtNjBjLTQuNCAwLTggMy42LTggOHYxNTRIMjE0VjYzNGMwLTQuNC0zLjYtOC04LThoLTYwYy00LjQgMC04IDMuNi04IDh2MTk4YzAgMTcuNyAxNC4zIDMyIDMyIDMyaDY4NGMxNy43IDAgMzItMTQuMyAzMi0zMlY2MzRjMC00LjQtMy42LTgtOC04eiIgLz48L3N2Zz4=) */ const $093f7bace4fdf24c$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($093f7bace4fdf24c$var$DownloadOutlined);
var $093f7bace4fdf24c$export$2e2bcd8739ae039 = $093f7bace4fdf24c$var$RefIcon;









var $5E6i4 = parcelRequire("5E6i4");



var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $e1b276b224f678dd$var$CheckOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"
                }
            }
        ]
    },
    "name": "check",
    "theme": "outlined"
};
var $e1b276b224f678dd$export$2e2bcd8739ae039 = $e1b276b224f678dd$var$CheckOutlined;



function $9eb4119242359573$var$_extends() {
    $9eb4119242359573$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9eb4119242359573$var$_extends.apply(this, arguments);
}
const $9eb4119242359573$var$CheckOutlined = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $9eb4119242359573$var$_extends({}, props, {
        ref: ref,
        icon: (0, $e1b276b224f678dd$export$2e2bcd8739ae039)
    }));
/**![check](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkxMiAxOTBoLTY5LjljLTkuOCAwLTE5LjEgNC41LTI1LjEgMTIuMkw0MDQuNyA3MjQuNSAyMDcgNDc0YTMyIDMyIDAgMDAtMjUuMS0xMi4ySDExMmMtNi43IDAtMTAuNCA3LjctNi4zIDEyLjlsMjczLjkgMzQ3YzEyLjggMTYuMiAzNy40IDE2LjIgNTAuMyAwbDQ4OC40LTYxOC45YzQuMS01LjEuNC0xMi44LTYuMy0xMi44eiIgLz48L3N2Zz4=) */ const $9eb4119242359573$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($9eb4119242359573$var$CheckOutlined);
var $9eb4119242359573$export$2e2bcd8739ae039 = $9eb4119242359573$var$RefIcon;











var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");



var $5E6i4 = parcelRequire("5E6i4");
const $bd6b220d9f9ab640$export$9c21a3269931e1e6 = {
    percent: 0,
    prefixCls: 'rc-progress',
    strokeColor: '#2db7f5',
    strokeLinecap: 'round',
    strokeWidth: 1,
    railColor: '#D9D9D9',
    railWidth: 1,
    gapPosition: 'bottom',
    loading: false
};
const $bd6b220d9f9ab640$export$7685006d504ecf0b = ()=>{
    const pathsRef = (0, $5E6i4.useRef)([]);
    const prevTimeStamp = (0, $5E6i4.useRef)(null);
    (0, $5E6i4.useEffect)(()=>{
        const now = Date.now();
        let updated = false;
        pathsRef.current.forEach((path)=>{
            if (!path) return;
            updated = true;
            const pathStyle = path.style;
            pathStyle.transitionDuration = '.3s, .3s, .3s, .06s';
            if (prevTimeStamp.current && now - prevTimeStamp.current < 100) pathStyle.transitionDuration = '0s, 0s';
        });
        if (updated) prevTimeStamp.current = Date.now();
    });
    return pathsRef.current;
};



var $5E6i4 = parcelRequire("5E6i4");
var $7373dcec1ce6f91d$export$2e2bcd8739ae039 = (options)=>{
    const { id: id, percent: percent, strokeLinecap: strokeLinecap, strokeWidth: strokeWidth, loading: loading } = options;
    if (!loading) return {
        indeterminateStyleProps: {},
        indeterminateStyleAnimation: null
    };
    const animationName = `${id}-indeterminate-animate`;
    const strokeDashOffset = 100 - (percent + (strokeLinecap === 'round' ? strokeWidth : 0));
    return {
        indeterminateStyleProps: {
            strokeDasharray: `${percent} 100`,
            animation: `${animationName} .6s linear alternate infinite`,
            strokeDashoffset: 0
        },
        indeterminateStyleAnimation: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("style", null, `@keyframes ${animationName} {
            0% { stroke-dashoffset: 0; }
            100% { stroke-dashoffset: -${strokeDashOffset};
          }`)
    };
};


function $c931ac8bd5cc50e4$var$_extends() {
    $c931ac8bd5cc50e4$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c931ac8bd5cc50e4$var$_extends.apply(this, arguments);
}
const $c931ac8bd5cc50e4$var$Line = (props)=>{
    const { id: id, className: className, percent: percent, prefixCls: prefixCls, strokeColor: strokeColor, strokeLinecap: strokeLinecap, strokeWidth: strokeWidth, style: style, railColor: railColor, railWidth: railWidth, transition: transition, loading: loading, ...restProps } = {
        ...(0, $bd6b220d9f9ab640$export$9c21a3269931e1e6),
        ...props
    };
    const mergedId = (0, $378d6dcdebc6b864$export$2e2bcd8739ae039)(id);
    // eslint-disable-next-line no-param-reassign
    delete restProps.gapPosition;
    const percentList = Array.isArray(percent) ? percent : [
        percent
    ];
    const strokeColorList = Array.isArray(strokeColor) ? strokeColor : [
        strokeColor
    ];
    const paths = (0, $bd6b220d9f9ab640$export$7685006d504ecf0b)();
    const center = strokeWidth / 2;
    const right = 100 - strokeWidth / 2;
    const pathString = `M ${strokeLinecap === 'round' ? center : 0},${center}
         L ${strokeLinecap === 'round' ? right : 100},${center}`;
    const viewBoxString = `0 0 100 ${strokeWidth}`;
    let stackPtg = 0;
    const { indeterminateStyleProps: indeterminateStyleProps, indeterminateStyleAnimation: indeterminateStyleAnimation } = (0, $7373dcec1ce6f91d$export$2e2bcd8739ae039)({
        id: mergedId,
        loading: loading,
        percent: percentList[0],
        strokeLinecap: strokeLinecap,
        strokeWidth: strokeWidth
    });
    return /*#__PURE__*/ $5E6i4.createElement("svg", $c931ac8bd5cc50e4$var$_extends({
        id: id,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-line`, className),
        viewBox: viewBoxString,
        preserveAspectRatio: "none",
        style: style,
        role: "presentation"
    }, restProps), /*#__PURE__*/ $5E6i4.createElement("path", {
        className: `${prefixCls}-line-rail`,
        d: pathString,
        strokeLinecap: strokeLinecap,
        stroke: railColor,
        strokeWidth: railWidth || strokeWidth,
        fillOpacity: "0"
    }), percentList.map((ptg, index)=>{
        const dashPercent = strokeLinecap === 'round' ? 1 - strokeWidth / 100 : strokeLinecap === 'square' ? 1 - strokeWidth / 2 / 100 : 1;
        const pathStyle = {
            strokeDasharray: `${ptg * dashPercent}px, 100px`,
            strokeDashoffset: `-${stackPtg}px`,
            transition: transition || 'stroke-dashoffset 0.3s ease 0s, stroke-dasharray .3s ease 0s, stroke 0.3s linear',
            ...indeterminateStyleProps
        };
        const color = strokeColorList[index] || strokeColorList[strokeColorList.length - 1];
        stackPtg += ptg;
        return /*#__PURE__*/ $5E6i4.createElement("path", {
            key: index,
            className: `${prefixCls}-line-path`,
            d: pathString,
            strokeLinecap: strokeLinecap,
            stroke: color,
            strokeWidth: strokeWidth,
            fillOpacity: "0",
            ref: (elem)=>{
                // https://reactjs.org/docs/refs-and-the-dom.html#callback-refs
                // React will call the ref callback with the DOM element when the component mounts,
                // and call it with `null` when it unmounts.
                // Refs are guaranteed to be up-to-date before componentDidMount or componentDidUpdate fires.
                paths[index] = elem;
            },
            style: pathStyle
        });
    }), indeterminateStyleAnimation);
};
var $c931ac8bd5cc50e4$export$2e2bcd8739ae039 = $c931ac8bd5cc50e4$var$Line;



var $5E6i4 = parcelRequire("5E6i4");




var $5E6i4 = parcelRequire("5E6i4");

const $6a17564e624aedb8$var$Block = ({ bg: bg, children: children })=>/*#__PURE__*/ $5E6i4.createElement("div", {
        style: {
            width: '100%',
            height: '100%',
            background: bg
        }
    }, children);
function $6a17564e624aedb8$var$getPtgColors(color, scale) {
    return Object.keys(color).map((key)=>{
        const parsedKey = parseFloat(key);
        const ptgKey = `${Math.floor(parsedKey * scale)}%`;
        return `${color[key]} ${ptgKey}`;
    });
}
const $6a17564e624aedb8$var$PtgCircle = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, color: color, gradientId: gradientId, radius: radius, className: className, style: circleStyleForStack, ptg: ptg, strokeLinecap: strokeLinecap, strokeWidth: strokeWidth, size: size, gapDegree: gapDegree } = props;
    const isGradient = color && typeof color === 'object';
    const stroke = isGradient ? `#FFF` : undefined;
    // ========================== Circle ==========================
    const halfSize = size / 2;
    const circleNode = /*#__PURE__*/ $5E6i4.createElement("circle", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-circle-path`, className),
        r: radius,
        cx: halfSize,
        cy: halfSize,
        stroke: stroke,
        strokeLinecap: strokeLinecap,
        strokeWidth: strokeWidth,
        opacity: ptg === 0 ? 0 : 1,
        style: circleStyleForStack,
        ref: ref
    });
    // ========================== Render ==========================
    if (!isGradient) return circleNode;
    const maskId = `${gradientId}-conic`;
    const fromDeg = gapDegree ? `${180 + gapDegree / 2}deg` : '0deg';
    const conicColors = $6a17564e624aedb8$var$getPtgColors(color, (360 - gapDegree) / 360);
    const linearColors = $6a17564e624aedb8$var$getPtgColors(color, 1);
    const conicColorBg = `conic-gradient(from ${fromDeg}, ${conicColors.join(', ')})`;
    const linearColorBg = `linear-gradient(to ${gapDegree ? 'bottom' : 'top'}, ${linearColors.join(', ')})`;
    return /*#__PURE__*/ $5E6i4.createElement($5E6i4.Fragment, null, /*#__PURE__*/ $5E6i4.createElement("mask", {
        id: maskId
    }, circleNode), /*#__PURE__*/ $5E6i4.createElement("foreignObject", {
        x: 0,
        y: 0,
        width: size,
        height: size,
        mask: `url(#${maskId})`
    }, /*#__PURE__*/ $5E6i4.createElement($6a17564e624aedb8$var$Block, {
        bg: linearColorBg
    }, /*#__PURE__*/ $5E6i4.createElement($6a17564e624aedb8$var$Block, {
        bg: conicColorBg
    }))));
});
var $6a17564e624aedb8$export$2e2bcd8739ae039 = $6a17564e624aedb8$var$PtgCircle;


const $136674eebf74d737$export$b8239b3abadfb141 = 100;
const $136674eebf74d737$export$b0aaf64d8cc0f6db = (perimeter, perimeterWithoutGap, offset, percent, rotateDeg, gapDegree, gapPosition, strokeColor, strokeLinecap, strokeWidth, stepSpace = 0)=>{
    const offsetDeg = offset / 100 * 360 * ((360 - gapDegree) / 360);
    const positionDeg = gapDegree === 0 ? 0 : ({
        bottom: 0,
        top: 180,
        left: 90,
        right: -90
    })[gapPosition];
    let strokeDashoffset = (100 - percent) / 100 * perimeterWithoutGap;
    // Fix percent accuracy when strokeLinecap is round
    // https://github.com/ant-design/ant-design/issues/35009
    if (strokeLinecap === 'round' && percent !== 100) {
        strokeDashoffset += strokeWidth / 2;
        // when percent is small enough (<= 1%), keep smallest value to avoid it's disappearance
        if (strokeDashoffset >= perimeterWithoutGap) strokeDashoffset = perimeterWithoutGap - 0.01;
    }
    const halfSize = $136674eebf74d737$export$b8239b3abadfb141 / 2;
    return {
        stroke: typeof strokeColor === 'string' ? strokeColor : undefined,
        strokeDasharray: `${perimeterWithoutGap}px ${perimeter}`,
        strokeDashoffset: strokeDashoffset + stepSpace,
        transform: `rotate(${rotateDeg + offsetDeg + positionDeg}deg)`,
        transformOrigin: `${halfSize}px ${halfSize}px`,
        transition: 'stroke-dashoffset .3s ease 0s, stroke-dasharray .3s ease 0s, stroke .3s, stroke-width .06s ease .3s, opacity .3s ease 0s',
        fillOpacity: 0
    };
};



var $5E6i4 = parcelRequire("5E6i4");
var $6794e647643c345c$export$2e2bcd8739ae039 = ({ id: id, loading: loading })=>{
    if (!loading) return {
        indeterminateStyleProps: {},
        indeterminateStyleAnimation: null
    };
    const animationName = `${id}-indeterminate-animate`;
    return {
        indeterminateStyleProps: {
            transform: 'rotate(0deg)',
            animation: `${animationName} 1s linear infinite`
        },
        indeterminateStyleAnimation: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("style", null, `@keyframes ${animationName} {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }`)
    };
};


function $19278119e2028a7b$var$_extends() {
    $19278119e2028a7b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $19278119e2028a7b$var$_extends.apply(this, arguments);
}
function $19278119e2028a7b$var$toArray(value) {
    const mergedValue = value ?? [];
    return Array.isArray(mergedValue) ? mergedValue : [
        mergedValue
    ];
}
const $19278119e2028a7b$var$Circle = (props)=>{
    const { id: id, prefixCls: prefixCls, classNames: classNames = {}, styles: styles = {}, steps: steps, strokeWidth: strokeWidth, railWidth: railWidth, gapDegree: gapDegree = 0, gapPosition: gapPosition, railColor: railColor, strokeLinecap: strokeLinecap, style: style, className: className, strokeColor: strokeColor, percent: percent, loading: loading, ...restProps } = {
        ...(0, $bd6b220d9f9ab640$export$9c21a3269931e1e6),
        ...props
    };
    const halfSize = (0, $136674eebf74d737$export$b8239b3abadfb141) / 2;
    const mergedId = (0, $378d6dcdebc6b864$export$2e2bcd8739ae039)(id);
    const gradientId = `${mergedId}-gradient`;
    const radius = halfSize - strokeWidth / 2;
    const perimeter = Math.PI * 2 * radius;
    const rotateDeg = gapDegree > 0 ? 90 + gapDegree / 2 : -90;
    const perimeterWithoutGap = perimeter * ((360 - gapDegree) / 360);
    const { count: stepCount, gap: stepGap } = typeof steps === 'object' ? steps : {
        count: steps,
        gap: 2
    };
    const percentList = $19278119e2028a7b$var$toArray(percent);
    const strokeColorList = $19278119e2028a7b$var$toArray(strokeColor);
    const gradient = strokeColorList.find((color)=>color && typeof color === 'object');
    const isConicGradient = gradient && typeof gradient === 'object';
    const mergedStrokeLinecap = isConicGradient ? 'butt' : strokeLinecap;
    const { indeterminateStyleProps: indeterminateStyleProps, indeterminateStyleAnimation: indeterminateStyleAnimation } = (0, $6794e647643c345c$export$2e2bcd8739ae039)({
        id: mergedId,
        loading: loading
    });
    const circleStyle = (0, $136674eebf74d737$export$b0aaf64d8cc0f6db)(perimeter, perimeterWithoutGap, 0, 100, rotateDeg, gapDegree, gapPosition, railColor, mergedStrokeLinecap, strokeWidth);
    const paths = (0, $bd6b220d9f9ab640$export$7685006d504ecf0b)();
    const getStokeList = ()=>{
        let stackPtg = 0;
        return percentList.map((ptg, index)=>{
            const color = strokeColorList[index] || strokeColorList[strokeColorList.length - 1];
            const circleStyleForStack = (0, $136674eebf74d737$export$b0aaf64d8cc0f6db)(perimeter, perimeterWithoutGap, stackPtg, ptg, rotateDeg, gapDegree, gapPosition, color, mergedStrokeLinecap, strokeWidth);
            stackPtg += ptg;
            return /*#__PURE__*/ $5E6i4.createElement((0, $6a17564e624aedb8$export$2e2bcd8739ae039), {
                key: index,
                color: color,
                ptg: ptg,
                radius: radius,
                prefixCls: prefixCls,
                gradientId: gradientId,
                className: classNames.track,
                style: {
                    ...circleStyleForStack,
                    ...indeterminateStyleProps,
                    ...styles.track
                },
                strokeLinecap: mergedStrokeLinecap,
                strokeWidth: strokeWidth,
                gapDegree: gapDegree,
                ref: (elem)=>{
                    // https://reactjs.org/docs/refs-and-the-dom.html#callback-refs
                    // React will call the ref callback with the DOM element when the component mounts,
                    // and call it with `null` when it unmounts.
                    // Refs are guaranteed to be up-to-date before componentDidMount or componentDidUpdate fires.
                    paths[index] = elem;
                },
                size: (0, $136674eebf74d737$export$b8239b3abadfb141)
            });
        }).reverse();
    };
    const getStepStokeList = ()=>{
        // only show the first percent when pass steps
        const current = Math.round(stepCount * (percentList[0] / 100));
        const stepPtg = 100 / stepCount;
        let stackPtg = 0;
        return new Array(stepCount).fill(null).map((_, index)=>{
            const color = index <= current - 1 ? strokeColorList[0] : railColor;
            const stroke = color && typeof color === 'object' ? `url(#${gradientId})` : undefined;
            const circleStyleForStack = (0, $136674eebf74d737$export$b0aaf64d8cc0f6db)(perimeter, perimeterWithoutGap, stackPtg, stepPtg, rotateDeg, gapDegree, gapPosition, color, 'butt', strokeWidth, stepGap);
            stackPtg += (perimeterWithoutGap - circleStyleForStack.strokeDashoffset + stepGap) * 100 / perimeterWithoutGap;
            return /*#__PURE__*/ $5E6i4.createElement("circle", {
                key: index,
                className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-circle-path`, classNames.track),
                r: radius,
                cx: halfSize,
                cy: halfSize,
                stroke: stroke,
                strokeWidth: strokeWidth,
                opacity: 1,
                style: {
                    ...circleStyleForStack,
                    ...styles.track
                },
                ref: (elem)=>{
                    paths[index] = elem;
                }
            });
        });
    };
    return /*#__PURE__*/ $5E6i4.createElement("svg", $19278119e2028a7b$var$_extends({
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-circle`, classNames.root, className),
        viewBox: `0 0 ${(0, $136674eebf74d737$export$b8239b3abadfb141)} ${(0, $136674eebf74d737$export$b8239b3abadfb141)}`,
        style: {
            ...styles.root,
            ...style
        },
        id: id,
        role: "presentation"
    }, restProps), !stepCount && /*#__PURE__*/ $5E6i4.createElement("circle", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-circle-rail`, classNames.rail),
        r: radius,
        cx: halfSize,
        cy: halfSize,
        stroke: railColor,
        strokeLinecap: mergedStrokeLinecap,
        strokeWidth: railWidth || strokeWidth,
        style: {
            ...circleStyle,
            ...styles.rail
        }
    }), stepCount ? getStepStokeList() : getStokeList(), indeterminateStyleAnimation);
};
var $19278119e2028a7b$export$2e2bcd8739ae039 = $19278119e2028a7b$var$Circle;











function $8da8010d664cada6$export$2caef35201f951a0(progress) {
    if (!progress || progress < 0) return 0;
    if (progress > 100) return 100;
    return progress;
}
function $8da8010d664cada6$export$4ab1c09ce4ee99b({ success: success }) {
    let percent;
    if (success && 'percent' in success) percent = success.percent;
    return percent;
}
const $8da8010d664cada6$export$6712e0f6cd0ea03 = ({ percent: percent, success: success })=>{
    const realSuccessPercent = $8da8010d664cada6$export$2caef35201f951a0($8da8010d664cada6$export$4ab1c09ce4ee99b({
        success: success
    }));
    return [
        realSuccessPercent,
        $8da8010d664cada6$export$2caef35201f951a0($8da8010d664cada6$export$2caef35201f951a0(percent) - realSuccessPercent)
    ];
};
const $8da8010d664cada6$export$a73db48ef11a2bc3 = ({ success: success = {}, strokeColor: strokeColor })=>{
    const { strokeColor: successColor } = success;
    return [
        successColor || (0, $37058c64b679ada5$export$3968a3afc810b5f5).green,
        strokeColor || null
    ];
};
const $8da8010d664cada6$export$31b21d0167753bb4 = (size, type, extra)=>{
    let width = -1;
    let height = -1;
    if (type === 'step') {
        const steps = extra.steps;
        const strokeWidth = extra.strokeWidth;
        if (typeof size === 'string' || typeof size === 'undefined') {
            width = size === 'small' ? 2 : 14;
            height = strokeWidth ?? 8;
        } else if ((0, $addbc2fddcbb77a9$export$7e4aa119212bc614)(size)) [width, height] = [
            size,
            size
        ];
        else [width = 14, height = 8] = Array.isArray(size) ? size : [
            size.width,
            size.height
        ];
        width *= steps;
    } else if (type === 'line') {
        const strokeWidth = extra?.strokeWidth;
        if (typeof size === 'string' || typeof size === 'undefined') height = strokeWidth || (size === 'small' ? 6 : 8);
        else if ((0, $addbc2fddcbb77a9$export$7e4aa119212bc614)(size)) [width, height] = [
            size,
            size
        ];
        else [width = -1, height = 8] = Array.isArray(size) ? size : [
            size.width,
            size.height
        ];
    } else if (type === 'circle' || type === 'dashboard') {
        if (typeof size === 'string' || typeof size === 'undefined') [width, height] = size === 'small' ? [
            60,
            60
        ] : [
            120,
            120
        ];
        else if ((0, $addbc2fddcbb77a9$export$7e4aa119212bc614)(size)) [width, height] = [
            size,
            size
        ];
        else if (Array.isArray(size)) {
            width = size[0] ?? size[1] ?? 120;
            height = size[0] ?? size[1] ?? 120;
        }
    }
    return [
        width,
        height
    ];
};


"use client";
const $9d5f09da16e3ddd9$var$CIRCLE_MIN_STROKE_WIDTH = 3;
const $9d5f09da16e3ddd9$var$getMinPercent = (width)=>$9d5f09da16e3ddd9$var$CIRCLE_MIN_STROKE_WIDTH / width * 100;
const $9d5f09da16e3ddd9$var$OMIT_SEMANTIC_NAMES = [
    'root',
    'body',
    'indicator'
];
const $9d5f09da16e3ddd9$var$Circle = (props)=>{
    const { prefixCls: prefixCls, classNames: classNames, styles: styles, railColor: railColor, trailColor: trailColor, strokeLinecap: strokeLinecap = 'round', gapPosition: gapPosition, gapPlacement: gapPlacement, gapDegree: gapDegree, width: originWidth = 120, type: type, children: children, success: success, size: size = originWidth, steps: steps } = props;
    const { direction: direction } = (0, $519f2fad435b3034$export$46f4bd6436a25a31)('progress');
    const mergedRailColor = railColor ?? trailColor;
    const [width, height] = (0, $8da8010d664cada6$export$31b21d0167753bb4)(size, 'circle');
    let { strokeWidth: strokeWidth } = props;
    if (strokeWidth === undefined) strokeWidth = Math.max($9d5f09da16e3ddd9$var$getMinPercent(width), 6);
    const circleStyle = {
        width: width,
        height: height,
        fontSize: width * 0.15 + 6
    };
    const realGapDegree = $5E6i4.useMemo(()=>{
        // Support gapDeg = 0 when type = 'dashboard'
        if (gapDegree || gapDegree === 0) return gapDegree;
        if (type === 'dashboard') return 75;
        return undefined;
    }, [
        gapDegree,
        type
    ]);
    const percentArray = (0, $8da8010d664cada6$export$6712e0f6cd0ea03)(props);
    const gapPos = $5E6i4.useMemo(()=>{
        const mergedPlacement = (gapPlacement ?? gapPosition) || type === 'dashboard' && 'bottom' || undefined;
        const isRTL = direction === 'rtl';
        switch(mergedPlacement){
            case 'start':
                return isRTL ? 'right' : 'left';
            case 'end':
                return isRTL ? 'left' : 'right';
            default:
                return mergedPlacement;
        }
    }, [
        direction,
        gapPlacement,
        gapPosition,
        type
    ]);
    // using className to style stroke color
    const isGradient = (0, $addbc2fddcbb77a9$export$53b83ca8eaab0383)(props.strokeColor);
    const strokeColor = (0, $8da8010d664cada6$export$a73db48ef11a2bc3)({
        success: success,
        strokeColor: props.strokeColor
    });
    const wrapperClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-body`, {
        [`${prefixCls}-circle-gradient`]: isGradient
    }, classNames.body);
    const circleContent = /*#__PURE__*/ $5E6i4.createElement((0, $19278119e2028a7b$export$2e2bcd8739ae039), {
        steps: steps,
        percent: steps ? percentArray[1] : percentArray,
        strokeWidth: strokeWidth,
        railWidth: strokeWidth,
        strokeColor: steps ? strokeColor[1] : strokeColor,
        strokeLinecap: strokeLinecap,
        railColor: mergedRailColor,
        prefixCls: prefixCls,
        gapDegree: realGapDegree,
        gapPosition: gapPos,
        classNames: (0, $48bd91d9f828de66$export$2e2bcd8739ae039)(classNames, $9d5f09da16e3ddd9$var$OMIT_SEMANTIC_NAMES),
        styles: (0, $48bd91d9f828de66$export$2e2bcd8739ae039)(styles, $9d5f09da16e3ddd9$var$OMIT_SEMANTIC_NAMES)
    });
    const smallCircle = width <= 20;
    const node = /*#__PURE__*/ $5E6i4.createElement("div", {
        className: wrapperClassName,
        style: {
            ...circleStyle,
            ...styles.body
        }
    }, circleContent, !smallCircle && children);
    if (smallCircle) return /*#__PURE__*/ $5E6i4.createElement((0, $1bb718ecb5669b36$export$2e2bcd8739ae039), {
        title: children
    }, node);
    return node;
};
var $9d5f09da16e3ddd9$export$2e2bcd8739ae039 = $9d5f09da16e3ddd9$var$Circle;



var $5E6i4 = parcelRequire("5E6i4");






const $e373e1aa7c9d1e69$export$ce7447cfda329128 = '--progress-line-stroke-color';
const $e373e1aa7c9d1e69$var$genAntProgressActive = (isRtl)=>{
    const direction = isRtl ? '100%' : '-100%';
    return new (0, $14544cbeb8c8473b$export$2e2bcd8739ae039)(`antProgress${isRtl ? 'RTL' : 'LTR'}Active`, {
        '0%': {
            transform: `translateX(${direction}) scaleX(0)`,
            opacity: 0.1
        },
        '20%': {
            transform: `translateX(${direction}) scaleX(0)`,
            opacity: 0.5
        },
        to: {
            transform: 'translateX(0) scaleX(1)',
            opacity: 0
        }
    });
};
// ====================================================================
// ==                              Base                              ==
// ====================================================================
const $e373e1aa7c9d1e69$var$genBaseStyle = (token)=>{
    const { componentCls: progressCls, iconCls: iconPrefixCls } = token;
    return {
        [progressCls]: {
            ...(0, $cd5a520fee8002b4$export$23997c3e44cc1c59)(token),
            display: 'inline-flex',
            '&-rtl': {
                direction: 'rtl'
            },
            [`${progressCls}-indicator`]: {
                color: token.colorText,
                lineHeight: 1,
                whiteSpace: 'nowrap',
                verticalAlign: 'middle',
                wordBreak: 'normal',
                [iconPrefixCls]: {
                    fontSize: token.fontSize
                }
            },
            [`&${progressCls}-status-exception`]: {
                [`${progressCls}-indicator`]: {
                    color: token.colorError
                }
            },
            [`&${progressCls}-status-success`]: {
                [`${progressCls}-indicator`]: {
                    color: token.colorSuccess
                }
            }
        }
    };
};
// ====================================================================
// ==                              Line                              ==
// ====================================================================
const $e373e1aa7c9d1e69$var$genLineStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-line`]: {
            position: 'relative',
            width: '100%',
            fontSize: token.fontSize,
            [`${componentCls}-body`]: {
                display: 'inline-flex',
                alignItems: 'center',
                width: '100%',
                gap: token.marginXS
            },
            [`${componentCls}-rail`]: {
                flex: 'auto',
                background: token.remainingColor,
                borderRadius: token.lineBorderRadius,
                position: 'relative',
                width: '100%',
                overflow: 'hidden'
            },
            [`&${componentCls}-status-active`]: {
                [`${componentCls}-track:after`]: {
                    content: '""',
                    position: 'absolute',
                    inset: 0,
                    backgroundColor: token.colorBgContainer,
                    borderRadius: 'inherit',
                    opacity: 0,
                    animationName: $e373e1aa7c9d1e69$var$genAntProgressActive(),
                    animationDuration: token.progressActiveMotionDuration,
                    animationTimingFunction: token.motionEaseOutQuint,
                    animationIterationCount: 'infinite'
                }
            },
            [`${componentCls}-track`]: {
                position: 'absolute',
                insetInlineStart: 0,
                insetBlock: 0,
                borderRadius: 'inherit',
                background: token.defaultColor,
                transition: `all ${token.motionDurationSlow} ${token.motionEaseInOutCirc}`,
                minWidth: 'max-content',
                display: 'flex',
                alignItems: 'center',
                '&-success': {
                    background: token.colorSuccess
                }
            },
            [`&${componentCls}-status-exception`]: {
                [`${componentCls}-track`]: {
                    background: token.colorError
                }
            },
            [`&${componentCls}-status-success`]: {
                [`${componentCls}-track`]: {
                    background: token.colorSuccess
                }
            },
            // >>>>> indicator
            // >>> Outer
            [`${componentCls}-indicator-outer`]: {
                [`&${componentCls}-indicator-start`]: {
                    order: -1
                }
            },
            [`${componentCls}-body-layout-bottom`]: {
                flexDirection: 'column',
                alignItems: 'center',
                gap: token.marginXXS
            },
            // >>> Inner
            [`${componentCls}-indicator${componentCls}-indicator-inner`]: {
                color: token.colorWhite,
                paddingInline: token.paddingXXS,
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                [`&${componentCls}-indicator-end`]: {
                    justifyContent: 'end'
                },
                [`&${componentCls}-indicator-start`]: {
                    justifyContent: 'start'
                },
                [`&${componentCls}-indicator-bright`]: {
                    color: 'rgba(0, 0, 0, 0.45)'
                }
            }
        }
    };
};
// ====================================================================
// ==                             Circle                             ==
// ====================================================================
const $e373e1aa7c9d1e69$var$genCircleStyle = (token)=>{
    const { componentCls: progressCls, iconCls: iconPrefixCls } = token;
    return {
        [`${progressCls}-circle`]: {
            [`${progressCls}-circle-rail`]: {
                stroke: token.remainingColor
            },
            [`${progressCls}-body:not(${progressCls}-circle-gradient)`]: {
                [`${progressCls}-circle-path`]: {
                    stroke: token.defaultColor
                }
            },
            [`${progressCls}-body`]: {
                position: 'relative',
                lineHeight: 1,
                backgroundColor: 'transparent'
            },
            [`${progressCls}-indicator`]: {
                position: 'absolute',
                insetBlockStart: '50%',
                insetInlineStart: 0,
                width: '100%',
                margin: 0,
                padding: 0,
                color: token.circleTextColor,
                fontSize: token.circleTextFontSize,
                lineHeight: 1,
                whiteSpace: 'normal',
                textAlign: 'center',
                transform: 'translateY(-50%)',
                [iconPrefixCls]: {
                    fontSize: token.circleIconFontSize
                }
            },
            [`&${progressCls}-status-exception`]: {
                [`${progressCls}-body:not(${progressCls}-circle-gradient)`]: {
                    [`${progressCls}-circle-path`]: {
                        stroke: token.colorError
                    }
                }
            },
            [`&${progressCls}-status-success`]: {
                [`${progressCls}-body:not(${progressCls}-circle-gradient)`]: {
                    [`${progressCls}-circle-path`]: {
                        stroke: token.colorSuccess
                    }
                }
            }
        },
        [`${progressCls}-inline-circle`]: {
            lineHeight: 1,
            [`${progressCls}-inner`]: {
                verticalAlign: 'bottom'
            }
        }
    };
};
// ====================================================================
// ==                              Step                              ==
// ====================================================================
const $e373e1aa7c9d1e69$var$genStepStyle = (token)=>{
    const { componentCls: progressCls } = token;
    return {
        [progressCls]: {
            [`${progressCls}-steps`]: {
                display: 'inline-block',
                '&-body': {
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    gap: token.progressStepMarginInlineEnd,
                    [`${progressCls}-indicator`]: {
                        marginInlineStart: token.marginXS
                    }
                },
                '&-item': {
                    flexShrink: 0,
                    minWidth: token.progressStepMinWidth,
                    backgroundColor: token.remainingColor,
                    transition: `all ${token.motionDurationSlow}`,
                    '&-active': {
                        backgroundColor: token.defaultColor
                    }
                }
            }
        }
    };
};
// ====================================================================
// ==                           Small Line                           ==
// ====================================================================
const $e373e1aa7c9d1e69$var$genSmallLine = (token)=>{
    const { componentCls: progressCls, iconCls: iconPrefixCls } = token;
    return {
        [progressCls]: {
            [`${progressCls}-small&-line, ${progressCls}-small&-line ${progressCls}-indicator ${iconPrefixCls}`]: {
                fontSize: token.fontSizeSM
            }
        }
    };
};
const $e373e1aa7c9d1e69$export$9ca1be8807fe0675 = (token)=>({
        circleTextColor: token.colorText,
        defaultColor: token.colorInfo,
        remainingColor: token.colorFillSecondary,
        lineBorderRadius: 100,
        // magic for capsule shape, should be a very large number
        circleTextFontSize: '1em',
        circleIconFontSize: `${token.fontSize / token.fontSizeSM}em`
    });
var $e373e1aa7c9d1e69$export$2e2bcd8739ae039 = (0, $761caadb5301aee1$export$51ec95de45185b42)('Progress', (token)=>{
    const progressStepMarginInlineEnd = token.calc(token.marginXXS).div(2).equal();
    const progressToken = (0, $f564548c7b6877d5$export$4950aa0f605343fb)(token, {
        progressStepMarginInlineEnd: progressStepMarginInlineEnd,
        progressStepMinWidth: progressStepMarginInlineEnd,
        progressActiveMotionDuration: '2.4s'
    });
    return [
        $e373e1aa7c9d1e69$var$genBaseStyle(progressToken),
        $e373e1aa7c9d1e69$var$genLineStyle(progressToken),
        $e373e1aa7c9d1e69$var$genCircleStyle(progressToken),
        $e373e1aa7c9d1e69$var$genStepStyle(progressToken),
        $e373e1aa7c9d1e69$var$genSmallLine(progressToken)
    ];
}, $e373e1aa7c9d1e69$export$9ca1be8807fe0675);



"use client";
const $c44f9c84f48a8bc7$export$8947b167cf78cbe = (gradients)=>{
    let tempArr = [];
    Object.keys(gradients).forEach((key)=>{
        const formattedKey = Number.parseFloat(key.replace(/%/g, ''));
        if (!Number.isNaN(formattedKey)) tempArr.push({
            key: formattedKey,
            value: gradients[key]
        });
    });
    tempArr = tempArr.sort((a, b)=>a.key - b.key);
    return tempArr.map(({ key: key, value: value })=>`${value} ${key}%`).join(', ');
};
const $c44f9c84f48a8bc7$export$22b6122229807a9f = (strokeColor, directionConfig)=>{
    const { from: from = (0, $37058c64b679ada5$export$3968a3afc810b5f5).blue, to: to = (0, $37058c64b679ada5$export$3968a3afc810b5f5).blue, direction: direction = directionConfig === 'rtl' ? 'to left' : 'to right', ...rest } = strokeColor;
    if (Object.keys(rest).length !== 0) {
        const sortedGradients = $c44f9c84f48a8bc7$export$8947b167cf78cbe(rest);
        const background = `linear-gradient(${direction}, ${sortedGradients})`;
        return {
            background: background,
            [(0, $e373e1aa7c9d1e69$export$ce7447cfda329128)]: background
        };
    }
    const background = `linear-gradient(${direction}, ${from}, ${to})`;
    return {
        background: background,
        [(0, $e373e1aa7c9d1e69$export$ce7447cfda329128)]: background
    };
};
const $c44f9c84f48a8bc7$var$Line = (props)=>{
    const { prefixCls: prefixCls, classNames: classNames, styles: styles, direction: directionConfig, percent: percent, size: size, strokeWidth: strokeWidth, strokeColor: strokeColor, strokeLinecap: strokeLinecap = 'round', children: children, railColor: railColor, trailColor: trailColor, percentPosition: percentPosition, success: success } = props;
    const { align: infoAlign, type: infoPosition } = percentPosition;
    const mergedRailColor = railColor ?? trailColor;
    const borderRadius = strokeLinecap === 'square' || strokeLinecap === 'butt' ? 0 : undefined;
    // ========================= Size =========================
    const mergedSize = size ?? [
        -1,
        strokeWidth || 8
    ];
    const [width, height] = (0, $8da8010d664cada6$export$31b21d0167753bb4)(mergedSize, 'line', {
        strokeWidth: strokeWidth
    });
    // ========================= Rail =========================
    const railStyle = {
        backgroundColor: mergedRailColor || undefined,
        borderRadius: borderRadius,
        height: height
    };
    // ======================== Tracks ========================
    const trackCls = `${prefixCls}-track`;
    const backgroundProps = strokeColor && typeof strokeColor !== 'string' ? $c44f9c84f48a8bc7$export$22b6122229807a9f(strokeColor, directionConfig) : {
        [(0, $e373e1aa7c9d1e69$export$ce7447cfda329128)]: strokeColor,
        background: strokeColor
    };
    const percentTrackStyle = {
        width: `${(0, $8da8010d664cada6$export$2caef35201f951a0)(percent)}%`,
        height: height,
        borderRadius: borderRadius,
        ...backgroundProps
    };
    const successPercent = (0, $8da8010d664cada6$export$4ab1c09ce4ee99b)(props);
    const successTrackStyle = {
        width: `${(0, $8da8010d664cada6$export$2caef35201f951a0)(successPercent)}%`,
        height: height,
        borderRadius: borderRadius,
        backgroundColor: success?.strokeColor
    };
    // ======================== Render ========================
    return /*#__PURE__*/ $5E6i4.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-body`, classNames.body, {
            [`${prefixCls}-body-layout-bottom`]: infoAlign === 'center' && infoPosition === 'outer'
        }),
        style: {
            width: width > 0 ? width : '100%',
            ...styles.body
        }
    }, /*#__PURE__*/ $5E6i4.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-rail`, classNames.rail),
        style: {
            ...railStyle,
            ...styles.rail
        }
    }, /*#__PURE__*/ $5E6i4.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(trackCls, classNames.track),
        style: {
            ...percentTrackStyle,
            ...styles.track
        }
    }, infoPosition === 'inner' && children), successPercent !== undefined && /*#__PURE__*/ $5E6i4.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(trackCls, `${trackCls}-success`, classNames.track),
        style: {
            ...successTrackStyle,
            ...styles.track
        }
    })), infoPosition === 'outer' && children);
};
var $c44f9c84f48a8bc7$export$2e2bcd8739ae039 = $c44f9c84f48a8bc7$var$Line;



var $5E6i4 = parcelRequire("5E6i4");


"use client";
const $83abb278f0cad198$var$Steps = (props)=>{
    const { classNames: classNames, styles: styles, size: size, steps: steps, rounding: customRounding = Math.round, percent: percent = 0, strokeWidth: strokeWidth = 8, strokeColor: strokeColor, railColor: railColor, trailColor: trailColor, prefixCls: prefixCls, children: children } = props;
    const current = customRounding(steps * (percent / 100));
    const stepWidth = size === 'small' ? 2 : 14;
    const mergedSize = size ?? [
        stepWidth,
        strokeWidth
    ];
    const [width, height] = (0, $8da8010d664cada6$export$31b21d0167753bb4)(mergedSize, 'step', {
        steps: steps,
        strokeWidth: strokeWidth
    });
    const unitWidth = width / steps;
    const styledSteps = Array.from({
        length: steps
    });
    const mergedRailColor = railColor ?? trailColor;
    for(let i = 0; i < steps; i++){
        const color = Array.isArray(strokeColor) ? strokeColor[i] : strokeColor;
        styledSteps[i] = /*#__PURE__*/ $5E6i4.createElement("div", {
            key: i,
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-steps-item`, {
                [`${prefixCls}-steps-item-active`]: i <= current - 1
            }, classNames.track),
            style: {
                backgroundColor: i <= current - 1 ? color : mergedRailColor,
                width: unitWidth,
                height: height,
                ...styles.track
            }
        });
    }
    return /*#__PURE__*/ $5E6i4.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-steps-body`, classNames.body),
        style: styles.body
    }, styledSteps, children);
};
var $83abb278f0cad198$export$2e2bcd8739ae039 = $83abb278f0cad198$var$Steps;




"use client";
const $f6cf4e8668055ad6$export$e54ebc7fe4b5dc4e = [
    'line',
    'circle',
    'dashboard'
];
const $f6cf4e8668055ad6$var$ProgressStatuses = [
    'normal',
    'exception',
    'active',
    'success'
];
const $f6cf4e8668055ad6$var$Progress = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, classNames: classNames, styles: styles, steps: steps, strokeColor: strokeColor, percent: percent = 0, size: size = 'medium', showInfo: showInfo = true, type: type = 'line', status: status, format: format, style: style, percentPosition: percentPosition = {}, ...restProps } = props;
    // ========================= MISC =========================
    const { align: infoAlign = 'end', type: infoPosition = 'outer' } = percentPosition;
    const strokeColorNotArray = Array.isArray(strokeColor) ? strokeColor[0] : strokeColor;
    const strokeColorNotGradient = typeof strokeColor === 'string' || Array.isArray(strokeColor) ? strokeColor : undefined;
    const strokeColorIsBright = $5E6i4.useMemo(()=>{
        if (strokeColorNotArray) {
            const color = typeof strokeColorNotArray === 'string' ? strokeColorNotArray : Object.values(strokeColorNotArray)[0];
            return new (0, $1b0a692e36565107$export$2c4f38d6c0ecc25a)(color).isLight();
        }
        return false;
    }, [
        strokeColor
    ]);
    const percentNumber = $5E6i4.useMemo(()=>{
        const successPercent = (0, $8da8010d664cada6$export$4ab1c09ce4ee99b)(props);
        return Number.parseInt(successPercent !== undefined ? (successPercent ?? 0)?.toString() : (percent ?? 0)?.toString(), 10);
    }, [
        percent,
        props.success
    ]);
    const progressStatus = $5E6i4.useMemo(()=>{
        if (!$f6cf4e8668055ad6$var$ProgressStatuses.includes(status) && percentNumber >= 100) return 'success';
        return status || 'normal';
    }, [
        status,
        percentNumber
    ]);
    // ======================= Context ========================
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $519f2fad435b3034$export$46f4bd6436a25a31)('progress');
    const prefixCls = getPrefixCls('progress', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $e373e1aa7c9d1e69$export$2e2bcd8739ae039)(prefixCls);
    const mergedProps = {
        ...props,
        percent: percent,
        type: type,
        size: size,
        showInfo: showInfo,
        percentPosition: percentPosition
    };
    // ======================== Styles ========================
    const contextStyleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $722c8632ba7bdb89$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    });
    // ========================= Info =========================
    const isLineType = type === 'line';
    const isPureLineType = isLineType && !steps;
    const progressInfo = $5E6i4.useMemo(()=>{
        if (!showInfo) return null;
        const successPercent = (0, $8da8010d664cada6$export$4ab1c09ce4ee99b)(props);
        let text;
        const textFormatter = format || ((number)=>`${number}%`);
        const isBrightInnerColor = isLineType && strokeColorIsBright && infoPosition === 'inner';
        if (infoPosition === 'inner' || format || progressStatus !== 'exception' && progressStatus !== 'success') text = textFormatter((0, $8da8010d664cada6$export$2caef35201f951a0)(percent), (0, $8da8010d664cada6$export$2caef35201f951a0)(successPercent));
        else if (progressStatus === 'exception') text = isLineType ? /*#__PURE__*/ $5E6i4.createElement((0, $18493f15518cd625$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $5E6i4.createElement((0, $80d24bc031ad50e3$export$2e2bcd8739ae039), null);
        else if (progressStatus === 'success') text = isLineType ? /*#__PURE__*/ $5E6i4.createElement((0, $b89ac8aaffc055f4$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $5E6i4.createElement((0, $9eb4119242359573$export$2e2bcd8739ae039), null);
        return /*#__PURE__*/ $5E6i4.createElement("span", {
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-indicator`, {
                [`${prefixCls}-indicator-bright`]: isBrightInnerColor,
                [`${prefixCls}-indicator-${infoAlign}`]: isPureLineType,
                [`${prefixCls}-indicator-${infoPosition}`]: isPureLineType
            }, mergedClassNames.indicator),
            style: mergedStyles.indicator,
            title: typeof text === 'string' ? text : undefined
        }, text);
    }, [
        showInfo,
        percent,
        percentNumber,
        progressStatus,
        type,
        prefixCls,
        format,
        isLineType,
        strokeColorIsBright,
        infoPosition,
        infoAlign,
        isPureLineType,
        mergedClassNames.indicator,
        mergedStyles.indicator
    ]);
    var deprecatedName, newName;
    // ======================== Render ========================
    const sharedProps = {
        ...props,
        classNames: mergedClassNames,
        styles: mergedStyles
    };
    let progress;
    // Render progress shape
    if (type === 'line') progress = steps ? /*#__PURE__*/ $5E6i4.createElement((0, $83abb278f0cad198$export$2e2bcd8739ae039), {
        ...sharedProps,
        strokeColor: strokeColorNotGradient,
        prefixCls: prefixCls,
        steps: (0, $addbc2fddcbb77a9$export$53b83ca8eaab0383)(steps) ? steps.count : steps
    }, progressInfo) : /*#__PURE__*/ $5E6i4.createElement((0, $c44f9c84f48a8bc7$export$2e2bcd8739ae039), {
        ...sharedProps,
        strokeColor: strokeColorNotArray,
        prefixCls: prefixCls,
        direction: direction,
        percentPosition: {
            align: infoAlign,
            type: infoPosition
        }
    }, progressInfo);
    else if (type === 'circle' || type === 'dashboard') progress = /*#__PURE__*/ $5E6i4.createElement((0, $9d5f09da16e3ddd9$export$2e2bcd8739ae039), {
        ...sharedProps,
        strokeColor: strokeColorNotArray,
        prefixCls: prefixCls,
        progressStatus: progressStatus
    }, progressInfo);
    const classString = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-status-${progressStatus}`, {
        [`${prefixCls}-${type === 'dashboard' && 'circle' || type}`]: type !== 'line',
        [`${prefixCls}-inline-circle`]: type === 'circle' && (0, $8da8010d664cada6$export$31b21d0167753bb4)(size, 'circle')[0] <= 20,
        [`${prefixCls}-line`]: isPureLineType,
        [`${prefixCls}-line-align-${infoAlign}`]: isPureLineType,
        [`${prefixCls}-line-position-${infoPosition}`]: isPureLineType,
        [`${prefixCls}-steps`]: steps,
        [`${prefixCls}-show-info`]: showInfo,
        [`${prefixCls}-small`]: size === 'small',
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, contextClassName, className, rootClassName, mergedClassNames.root, hashId, cssVarCls);
    return /*#__PURE__*/ $5E6i4.createElement("div", {
        ref: ref,
        style: mergedStyles.root,
        className: classString,
        role: "progressbar",
        "aria-valuenow": percentNumber,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        ...(0, $48bd91d9f828de66$export$2e2bcd8739ae039)(restProps, [
            'railColor',
            'trailColor',
            'strokeWidth',
            'width',
            'gapDegree',
            'gapPosition',
            'gapPlacement',
            'strokeLinecap',
            'success'
        ])
    }, progress);
});
var $f6cf4e8668055ad6$export$2e2bcd8739ae039 = $f6cf4e8668055ad6$var$Progress;


"use client";
var $6183ec12df2c0e71$export$2e2bcd8739ae039 = (0, $f6cf4e8668055ad6$export$2e2bcd8739ae039);



"use client";
const $2e9266051561cacb$var$ListItem = /*#__PURE__*/ $5E6i4.forwardRef(({ prefixCls: prefixCls, className: className, style: style, classNames: itemClassNames, styles: styles, locale: locale, listType: listType, file: file, items: items, progress: progressProps, iconRender: iconRender, actionIconRender: actionIconRender, itemRender: itemRender, isImgUrl: isImgUrl, showPreviewIcon: showPreviewIcon, showRemoveIcon: showRemoveIcon, showDownloadIcon: showDownloadIcon, previewIcon: customPreviewIcon, removeIcon: customRemoveIcon, downloadIcon: customDownloadIcon, extra: customExtra, onPreview: onPreview, hasPreview: hasPreview, onDownload: onDownload, onClose: onClose }, ref)=>{
    // Status: which will ignore `removed` status
    const { status: status } = file;
    const [mergedStatus, setMergedStatus] = $5E6i4.useState(status);
    $5E6i4.useEffect(()=>{
        if (status !== 'removed') setMergedStatus(status);
    }, [
        status
    ]);
    // Delay to show the progress bar
    const [showProgress, setShowProgress] = (0, $2114fb66f76f632e$export$2e2bcd8739ae039)(false);
    $5E6i4.useEffect(()=>{
        setShowProgress(true, {
            ms: 300
        });
    }, []);
    const iconNode = iconRender(file);
    let icon = /*#__PURE__*/ $5E6i4.createElement("div", {
        className: `${prefixCls}-icon`
    }, iconNode);
    if (listType === 'picture' || listType === 'picture-card' || listType === 'picture-circle') {
        if (mergedStatus === 'uploading' || !file.thumbUrl && !file.url) {
            const uploadingClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-list-item-thumbnail`, {
                [`${prefixCls}-list-item-file`]: mergedStatus !== 'uploading'
            });
            icon = /*#__PURE__*/ $5E6i4.createElement("div", {
                className: uploadingClassName
            }, iconNode);
        } else {
            const thumbnail = isImgUrl?.(file) ? /*#__PURE__*/ $5E6i4.createElement("img", {
                src: file.thumbUrl || file.url,
                alt: file.name,
                className: `${prefixCls}-list-item-image`,
                crossOrigin: file.crossOrigin
            }) : iconNode;
            const aClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-list-item-thumbnail`, {
                [`${prefixCls}-list-item-file`]: isImgUrl && !isImgUrl(file)
            });
            icon = /*#__PURE__*/ $5E6i4.createElement("a", {
                className: aClassName,
                onClick: (e)=>onPreview(file, e),
                href: file.url || file.thumbUrl,
                target: "_blank",
                rel: "noopener noreferrer"
            }, thumbnail);
        }
    }
    const listItemClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-list-item`, `${prefixCls}-list-item-${mergedStatus}`, itemClassNames?.item);
    const linkProps = typeof file.linkProps === 'string' ? JSON.parse(file.linkProps) : file.linkProps;
    const removeIcon = ((0, $addbc2fddcbb77a9$export$f6e2535fb5126e54)(showRemoveIcon) ? showRemoveIcon(file) : showRemoveIcon) ? actionIconRender(((0, $addbc2fddcbb77a9$export$f6e2535fb5126e54)(customRemoveIcon) ? customRemoveIcon(file) : customRemoveIcon) || /*#__PURE__*/ $5E6i4.createElement((0, $424ba773c7c920f3$export$2e2bcd8739ae039), null), ()=>onClose(file), prefixCls, locale.removeFile, // acceptUploadDisabled is true, only remove icon will follow Upload disabled prop
    // https://github.com/ant-design/ant-design/issues/46171
    true) : null;
    const downloadIcon = ((0, $addbc2fddcbb77a9$export$f6e2535fb5126e54)(showDownloadIcon) ? showDownloadIcon(file) : showDownloadIcon) && mergedStatus === 'done' ? actionIconRender(((0, $addbc2fddcbb77a9$export$f6e2535fb5126e54)(customDownloadIcon) ? customDownloadIcon(file) : customDownloadIcon) || /*#__PURE__*/ $5E6i4.createElement((0, $093f7bace4fdf24c$export$2e2bcd8739ae039), null), ()=>onDownload(file), prefixCls, locale.downloadFile) : null;
    const downloadOrDelete = listType !== 'picture-card' && listType !== 'picture-circle' && /*#__PURE__*/ $5E6i4.createElement("span", {
        key: "download-delete",
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-list-item-actions`, {
            picture: listType === 'picture'
        })
    }, downloadIcon, removeIcon);
    const extraContent = (0, $addbc2fddcbb77a9$export$f6e2535fb5126e54)(customExtra) ? customExtra(file) : customExtra;
    const extra = extraContent && /*#__PURE__*/ $5E6i4.createElement("span", {
        className: `${prefixCls}-list-item-extra`
    }, extraContent);
    const listItemNameClass = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-list-item-name`);
    const onPreviewKeyDown = (e)=>{
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onPreview(file, e);
        }
    };
    const spanProps = hasPreview ? {
        role: 'button',
        tabIndex: 0,
        onClick: (e)=>onPreview(file, e),
        onKeyDown: onPreviewKeyDown
    } : {};
    const fileName = file.url ? /*#__PURE__*/ $5E6i4.createElement("a", {
        key: "view",
        target: "_blank",
        rel: "noopener noreferrer",
        className: listItemNameClass,
        title: file.name,
        ...linkProps,
        href: file.url,
        onClick: (e)=>{
            linkProps?.onClick?.(e);
            if (!e.defaultPrevented) onPreview(file, e);
        }
    }, file.name, extra) : /*#__PURE__*/ $5E6i4.createElement("span", {
        key: "view",
        className: listItemNameClass,
        ...spanProps,
        title: file.name
    }, file.name, extra);
    const previewIcon = ((0, $addbc2fddcbb77a9$export$f6e2535fb5126e54)(showPreviewIcon) ? showPreviewIcon(file) : showPreviewIcon) && (file.url || file.thumbUrl) ? /*#__PURE__*/ $5E6i4.createElement("a", {
        href: file.url || file.thumbUrl,
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: (e)=>onPreview(file, e),
        title: locale.previewFile,
        "aria-label": locale.previewFile || undefined
    }, (0, $addbc2fddcbb77a9$export$f6e2535fb5126e54)(customPreviewIcon) ? customPreviewIcon(file) : customPreviewIcon || /*#__PURE__*/ $5E6i4.createElement((0, $21b283b110732d66$export$2e2bcd8739ae039), null)) : null;
    const pictureCardActions = (listType === 'picture-card' || listType === 'picture-circle') && mergedStatus !== 'uploading' && /*#__PURE__*/ $5E6i4.createElement("span", {
        className: `${prefixCls}-list-item-actions`
    }, previewIcon, mergedStatus === 'done' && downloadIcon, removeIcon);
    const { getPrefixCls: getPrefixCls } = $5E6i4.useContext((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
    const rootPrefixCls = getPrefixCls();
    const dom = /*#__PURE__*/ $5E6i4.createElement("div", {
        className: listItemClassName,
        style: styles?.item
    }, icon, fileName, downloadOrDelete, pictureCardActions, showProgress && /*#__PURE__*/ $5E6i4.createElement((0, $5371a8954d0d2416$export$2e2bcd8739ae039), {
        motionName: `${rootPrefixCls}-fade`,
        visible: mergedStatus === 'uploading',
        motionDeadline: 2000
    }, ({ className: motionClassName })=>{
        // show loading icon if upload progress listener is disabled
        const loadingProgress = 'percent' in file ? /*#__PURE__*/ $5E6i4.createElement((0, $6183ec12df2c0e71$export$2e2bcd8739ae039), {
            type: "line",
            percent: file.percent,
            "aria-label": file['aria-label'],
            "aria-labelledby": file['aria-labelledby'],
            ...progressProps
        }) : null;
        return /*#__PURE__*/ $5E6i4.createElement("div", {
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-list-item-progress`, motionClassName)
        }, loadingProgress);
    }));
    const message = file.response && typeof file.response === 'string' ? file.response : file.error?.statusText || file.error?.message || locale.uploadError;
    const item = mergedStatus === 'error' ? /*#__PURE__*/ $5E6i4.createElement((0, $1bb718ecb5669b36$export$2e2bcd8739ae039), {
        title: message,
        getPopupContainer: (node)=>node.parentNode
    }, dom) : dom;
    return /*#__PURE__*/ $5E6i4.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-list-item-container`, className),
        style: style,
        ref: ref
    }, itemRender ? itemRender(item, file, items, {
        download: onDownload.bind(null, file),
        preview: onPreview.bind(null, file),
        remove: onClose.bind(null, file)
    }) : item);
});
var $2e9266051561cacb$export$2e2bcd8739ae039 = $2e9266051561cacb$var$ListItem;


"use client";
const $c398dfa99aa268d4$var$InternalUploadList = (props, ref)=>{
    const { listType: listType = 'text', previewFile: previewFile = (0, $365f292f34f9cf9e$export$b5db251096956c0d), onPreview: onPreview, onDownload: onDownload, onRemove: onRemove, locale: locale, iconRender: iconRender, isImageUrl: isImgUrl = (0, $365f292f34f9cf9e$export$431d13c2db3f6781), prefixCls: customizePrefixCls, items: items = [], showPreviewIcon: showPreviewIcon = true, showRemoveIcon: showRemoveIcon = true, showDownloadIcon: showDownloadIcon = false, removeIcon: removeIcon, previewIcon: previewIcon, downloadIcon: downloadIcon, extra: extra, progress: progress = {
        size: [
            -1,
            2
        ],
        showInfo: false
    }, appendAction: appendAction, appendActionVisible: appendActionVisible = true, itemRender: itemRender, disabled: disabled, classNames: uploadListClassNames, styles: styles } = props;
    const [, forceUpdate] = (0, $150b7c5d4f292a06$export$91db9bc4f8ac944a)();
    const [motionAppear, setMotionAppear] = $5E6i4.useState(false);
    const isPictureCardOrCirle = [
        'picture-card',
        'picture-circle'
    ].includes(listType);
    // ============================= Effect =============================
    $5E6i4.useEffect(()=>{
        if (!listType.startsWith('picture')) return;
        (items || []).forEach((file)=>{
            if (!(file.originFileObj instanceof File || file.originFileObj instanceof Blob) || file.thumbUrl !== undefined) return;
            file.thumbUrl = '';
            previewFile?.(file.originFileObj).then((previewDataUrl)=>{
                // Need append '' to avoid dead loop
                file.thumbUrl = previewDataUrl || '';
                forceUpdate();
            });
        });
    }, [
        listType,
        items,
        previewFile
    ]);
    $5E6i4.useEffect(()=>{
        setMotionAppear(true);
    }, []);
    // ============================= Events =============================
    const onInternalPreview = (file, e)=>{
        if (!onPreview) return;
        e?.preventDefault();
        return onPreview(file);
    };
    const onInternalDownload = (file)=>{
        if ((0, $addbc2fddcbb77a9$export$f6e2535fb5126e54)(onDownload)) onDownload(file);
        else if (file.url) window.open(file.url, '_blank', 'noopener');
    };
    const onInternalClose = (file)=>{
        onRemove?.(file);
    };
    const internalIconRender = (file)=>{
        if (iconRender) return iconRender(file, listType);
        const isLoading = file.status === 'uploading';
        if (listType.startsWith('picture')) {
            const loadingIcon = listType === 'picture' ? /*#__PURE__*/ $5E6i4.createElement((0, $6e3183dc0ea574da$export$2e2bcd8739ae039), null) : locale.uploading;
            const fileIcon = isImgUrl?.(file) ? /*#__PURE__*/ $5E6i4.createElement((0, $3d00f6c811915fa3$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $5E6i4.createElement((0, $70372d32dbe4addb$export$2e2bcd8739ae039), null);
            return isLoading ? loadingIcon : fileIcon;
        }
        return isLoading ? /*#__PURE__*/ $5E6i4.createElement((0, $6e3183dc0ea574da$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $5E6i4.createElement((0, $fa43313e830d0cea$export$2e2bcd8739ae039), null);
    };
    const actionIconRender = (customIcon, callback, prefixCls, title, acceptUploadDisabled)=>{
        const btnProps = {
            type: 'text',
            size: 'small',
            title: title,
            'aria-label': title || undefined,
            onClick: (e)=>{
                callback();
                if (/*#__PURE__*/ $5E6i4.isValidElement(customIcon)) customIcon.props.onClick?.(e);
            },
            className: `${prefixCls}-list-item-action`,
            disabled: acceptUploadDisabled ? disabled : false
        };
        return /*#__PURE__*/ $5E6i4.isValidElement(customIcon) ? /*#__PURE__*/ $5E6i4.createElement((0, $17f39e4db74a8975$export$2e2bcd8739ae039), {
            ...btnProps,
            icon: (0, $552e20b6ec4e63a6$export$e530037191fcd5d7)(customIcon, {
                ...customIcon.props,
                onClick: ()=>{}
            })
        }) : /*#__PURE__*/ $5E6i4.createElement((0, $17f39e4db74a8975$export$2e2bcd8739ae039), {
            ...btnProps
        }, /*#__PURE__*/ $5E6i4.createElement("span", null, customIcon));
    };
    // ============================== Ref ===============================
    // Test needs
    $5E6i4.useImperativeHandle(ref, ()=>({
            handlePreview: onInternalPreview,
            handleDownload: onInternalDownload
        }));
    const { getPrefixCls: getPrefixCls } = $5E6i4.useContext((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
    // ============================= Render =============================
    const prefixCls = getPrefixCls('upload', customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const listClassNames = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-list`, `${prefixCls}-list-${listType}`, uploadListClassNames?.list);
    const listItemMotion = $5E6i4.useMemo(()=>(0, $48bd91d9f828de66$export$2e2bcd8739ae039)((0, $c2c363b881b49d51$export$2e2bcd8739ae039)(rootPrefixCls), [
            'onAppearEnd',
            'onEnterEnd',
            'onLeaveEnd'
        ]), [
        rootPrefixCls
    ]);
    const motionConfig = {
        ...isPictureCardOrCirle ? {} : listItemMotion,
        motionDeadline: 2000,
        motionName: `${prefixCls}-${isPictureCardOrCirle ? 'animate-inline' : 'animate'}`,
        keys: (0, $0acfae8147afe964$export$2e2bcd8739ae039)(items.map((file)=>({
                key: file.uid,
                file: file
            }))),
        motionAppear: motionAppear
    };
    return /*#__PURE__*/ $5E6i4.createElement("div", {
        className: listClassNames,
        style: styles?.list
    }, /*#__PURE__*/ $5E6i4.createElement((0, $f8bf6ab12693d160$export$2e2bcd8739ae039), {
        ...motionConfig,
        component: false
    }, ({ key: key, file: file, className: motionClassName, style: motionStyle })=>/*#__PURE__*/ $5E6i4.createElement((0, $2e9266051561cacb$export$2e2bcd8739ae039), {
            key: key,
            locale: locale,
            prefixCls: prefixCls,
            className: motionClassName,
            style: motionStyle,
            classNames: uploadListClassNames,
            styles: styles,
            file: file,
            items: items,
            progress: progress,
            listType: listType,
            isImgUrl: isImgUrl,
            showPreviewIcon: showPreviewIcon,
            showRemoveIcon: showRemoveIcon,
            showDownloadIcon: showDownloadIcon,
            removeIcon: removeIcon,
            previewIcon: previewIcon,
            downloadIcon: downloadIcon,
            extra: extra,
            iconRender: internalIconRender,
            actionIconRender: actionIconRender,
            itemRender: itemRender,
            onPreview: onInternalPreview,
            hasPreview: !!onPreview,
            onDownload: onInternalDownload,
            onClose: onInternalClose
        })), appendAction && /*#__PURE__*/ $5E6i4.createElement((0, $5371a8954d0d2416$export$2e2bcd8739ae039), {
        ...motionConfig,
        visible: appendActionVisible,
        forceRender: true
    }, ({ className: motionClassName, style: motionStyle })=>(0, $552e20b6ec4e63a6$export$e530037191fcd5d7)(appendAction, (oriProps)=>({
                className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(oriProps.className, motionClassName),
                style: {
                    ...motionStyle,
                    // prevent the element has hover css pseudo-class that may cause animation to end prematurely.
                    pointerEvents: motionClassName ? 'none' : undefined,
                    ...oriProps.style
                }
            }))));
};
const $c398dfa99aa268d4$var$UploadList = /*#__PURE__*/ $5E6i4.forwardRef($c398dfa99aa268d4$var$InternalUploadList);
var $c398dfa99aa268d4$export$2e2bcd8739ae039 = $c398dfa99aa268d4$var$UploadList;



"use client";
const $994528b58dfa2a3a$export$8f9bb9ff126b1bf5 = `__LIST_IGNORE_${Date.now()}__`;
const $994528b58dfa2a3a$var$InternalUpload = (props, ref)=>{
    const config = (0, $519f2fad435b3034$export$46f4bd6436a25a31)('upload');
    const { fileList: fileList, defaultFileList: defaultFileList, onRemove: onRemove, showUploadList: showUploadList = true, listType: listType = 'text', onPreview: onPreview, onDownload: onDownload, onChange: onChange, onDrop: onDrop, previewFile: previewFile, disabled: customDisabled, locale: propLocale, iconRender: iconRender, isImageUrl: isImageUrl, progress: customProgress, prefixCls: customizePrefixCls, className: className, type: type = 'select', children: children, style: style, itemRender: itemRender, maxCount: maxCount, data: data = {}, multiple: multiple = false, hasControlInside: hasControlInside = true, action: action = '', accept: customAccept, supportServerRender: supportServerRender = true, rootClassName: rootClassName, styles: styles, classNames: classNames } = props;
    // ===================== Disabled =====================
    const disabled = $5E6i4.useContext((0, $2ab14018ea5b2d79$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled ?? disabled;
    const customRequest = props.customRequest || config.customRequest;
    const mergedProgress = config.progress || customProgress ? {
        ...config.progress,
        ...customProgress
    } : undefined;
    const mergedAccept = (0, $c3b60ef18d99af24$export$2e2bcd8739ae039)(customAccept, config.accept, '');
    const [internalFileList, setMergedFileList] = (0, $e18df22f16a16360$export$2e2bcd8739ae039)(defaultFileList, fileList);
    const mergedFileList = internalFileList || [];
    const getMergedFileList = (0, $68990f4402d2f009$export$2e2bcd8739ae039)(()=>mergedFileList);
    const [dragState, setDragState] = $5E6i4.useState('drop');
    const uploadRef = $5E6i4.useRef(null);
    const wrapRef = $5E6i4.useRef(null);
    // Control mode will auto fill file uid if not provided
    $5E6i4.useMemo(()=>{
        const timestamp = Date.now();
        (fileList || []).forEach((file, index)=>{
            if (!file.uid && !Object.isFrozen(file)) file.uid = `__AUTO__${timestamp}_${index}__`;
        });
    }, [
        fileList
    ]);
    const onInternalChange = (file, changedFileList, event)=>{
        let cloneList = (0, $0acfae8147afe964$export$2e2bcd8739ae039)(changedFileList);
        let exceedMaxCount = false;
        // Cut to match count
        if (maxCount === 1) cloneList = cloneList.slice(-1);
        else if (maxCount) {
            exceedMaxCount = cloneList.length > maxCount;
            cloneList = cloneList.slice(0, maxCount);
        }
        // Prevent React18 auto batch since input[upload] trigger process at same time
        // which makes fileList closure problem
        // eslint-disable-next-line react-dom/no-flush-sync
        (0, $ibUU1.flushSync)(()=>{
            setMergedFileList(cloneList);
        });
        const changeInfo = {
            file: file,
            fileList: cloneList
        };
        if (event) changeInfo.event = event;
        if (!exceedMaxCount || file.status === 'removed' || // We should ignore event if current file is exceed `maxCount`
        cloneList.some((f)=>f.uid === file.uid)) // eslint-disable-next-line react-dom/no-flush-sync
        (0, $ibUU1.flushSync)(()=>{
            onChange?.(changeInfo);
        });
    };
    const mergedBeforeUpload = async (file, fileListArgs)=>{
        const { beforeUpload: beforeUpload } = props;
        let parsedFile = file;
        if (beforeUpload) {
            const result = await beforeUpload(file, fileListArgs);
            if (result === false) return false;
            // Hack for LIST_IGNORE, we add additional info to remove from the list
            delete file[$994528b58dfa2a3a$export$8f9bb9ff126b1bf5];
            if (result === $994528b58dfa2a3a$export$8f9bb9ff126b1bf5) {
                Object.defineProperty(file, $994528b58dfa2a3a$export$8f9bb9ff126b1bf5, {
                    value: true,
                    configurable: true
                });
                return false;
            }
            if ((0, $addbc2fddcbb77a9$export$53b83ca8eaab0383)(result)) parsedFile = result;
        }
        return parsedFile;
    };
    const onBatchStart = (batchFileInfoList)=>{
        // Skip file which marked as `LIST_IGNORE`, these file will not add to file list
        const filteredFileInfoList = batchFileInfoList.filter((info)=>!info.file[$994528b58dfa2a3a$export$8f9bb9ff126b1bf5]);
        // Nothing to do since no file need upload
        if (!filteredFileInfoList.length) return;
        const objectFileList = filteredFileInfoList.map((info)=>(0, $365f292f34f9cf9e$export$6dc848fd109e803d)(info.file));
        // Concat new files with prev files
        let newFileList = (0, $0acfae8147afe964$export$2e2bcd8739ae039)(mergedFileList);
        objectFileList.forEach((fileObj)=>{
            // Replace file if exist
            newFileList = (0, $365f292f34f9cf9e$export$65c2063f64290f37)(fileObj, newFileList);
        });
        objectFileList.forEach((fileObj, index)=>{
            // Repeat trigger `onChange` event for compatible
            let triggerFileObj = fileObj;
            if (!filteredFileInfoList[index].parsedFile) {
                // `beforeUpload` return false
                const { originFileObj: originFileObj } = fileObj;
                let clone;
                try {
                    clone = new File([
                        originFileObj
                    ], originFileObj.name, {
                        type: originFileObj.type
                    });
                } catch  {
                    clone = new Blob([
                        originFileObj
                    ], {
                        type: originFileObj.type
                    });
                    clone.name = originFileObj.name;
                    clone.lastModifiedDate = new Date();
                    clone.lastModified = new Date().getTime();
                }
                clone.uid = fileObj.uid;
                triggerFileObj = clone;
            } else // Inject `uploading` status
            fileObj.status = 'uploading';
            onInternalChange(triggerFileObj, newFileList);
        });
    };
    const onSuccess = (response, file, xhr)=>{
        try {
            if (typeof response === 'string') response = JSON.parse(response);
        } catch  {
        /* do nothing */ }
        // removed
        if (!(0, $365f292f34f9cf9e$export$1165ac073f485fae)(file, mergedFileList)) return;
        const targetItem = (0, $365f292f34f9cf9e$export$6dc848fd109e803d)(file);
        targetItem.status = 'done';
        targetItem.percent = 100;
        targetItem.response = response;
        targetItem.xhr = xhr;
        const nextFileList = (0, $365f292f34f9cf9e$export$65c2063f64290f37)(targetItem, mergedFileList);
        onInternalChange(targetItem, nextFileList);
    };
    const onProgress = (e, file)=>{
        // removed
        if (!(0, $365f292f34f9cf9e$export$1165ac073f485fae)(file, mergedFileList)) return;
        const targetItem = (0, $365f292f34f9cf9e$export$6dc848fd109e803d)(file);
        targetItem.status = 'uploading';
        targetItem.percent = e.percent;
        const nextFileList = (0, $365f292f34f9cf9e$export$65c2063f64290f37)(targetItem, mergedFileList);
        onInternalChange(targetItem, nextFileList, e);
    };
    const onError = (error, response, file)=>{
        // removed
        if (!(0, $365f292f34f9cf9e$export$1165ac073f485fae)(file, mergedFileList)) return;
        const targetItem = (0, $365f292f34f9cf9e$export$6dc848fd109e803d)(file);
        targetItem.error = error;
        targetItem.response = response;
        targetItem.status = 'error';
        const nextFileList = (0, $365f292f34f9cf9e$export$65c2063f64290f37)(targetItem, mergedFileList);
        onInternalChange(targetItem, nextFileList);
    };
    const handleRemove = (file)=>{
        let currentFile;
        Promise.resolve((0, $addbc2fddcbb77a9$export$f6e2535fb5126e54)(onRemove) ? onRemove(file) : onRemove).then((ret)=>{
            // Prevent removing file
            if (ret === false) return;
            const currentFileList = getMergedFileList();
            const removedFileList = (0, $365f292f34f9cf9e$export$f3bced642db28a96)(file, currentFileList);
            if (removedFileList) {
                currentFile = {
                    ...file,
                    status: 'removed'
                };
                currentFileList.forEach((item)=>{
                    const matchKey = currentFile.uid !== undefined ? 'uid' : 'name';
                    if (item[matchKey] === currentFile[matchKey] && !Object.isFrozen(item)) item.status = 'removed';
                });
                uploadRef.current?.abort(currentFile);
                onInternalChange(currentFile, removedFileList);
            }
        });
    };
    const onFileDrop = (e)=>{
        setDragState(e.type);
        if (e.type === 'drop') onDrop?.(e);
    };
    // Test needs
    $5E6i4.useImperativeHandle(ref, ()=>({
            onBatchStart: onBatchStart,
            onSuccess: onSuccess,
            onProgress: onProgress,
            onError: onError,
            fileList: mergedFileList,
            upload: uploadRef.current,
            nativeElement: wrapRef.current
        }));
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $519f2fad435b3034$export$46f4bd6436a25a31)('upload');
    const prefixCls = getPrefixCls('upload', customizePrefixCls);
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        listType: listType,
        showUploadList: showUploadList,
        type: type,
        multiple: multiple,
        hasControlInside: hasControlInside,
        supportServerRender: supportServerRender,
        disabled: mergedDisabled
    };
    const contextTriggerStyle = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(contextStyle, 'trigger');
    const triggerStyle = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(style, 'trigger');
    const [mergedClassNames, mergedStyles] = (0, $722c8632ba7bdb89$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextTriggerStyle,
        styles,
        triggerStyle
    ], {
        props: mergedProps
    });
    const rcUploadProps = {
        onBatchStart: onBatchStart,
        onError: onError,
        onProgress: onProgress,
        onSuccess: onSuccess,
        ...props,
        customRequest: customRequest,
        data: data,
        multiple: multiple,
        action: action,
        accept: mergedAccept,
        supportServerRender: supportServerRender,
        prefixCls: prefixCls,
        disabled: mergedDisabled,
        beforeUpload: mergedBeforeUpload,
        onChange: undefined,
        hasControlInside: hasControlInside
    };
    delete rcUploadProps.className;
    delete rcUploadProps.style;
    // Remove id to avoid open by label when trigger is hidden
    // !children: https://github.com/ant-design/ant-design/issues/14298
    // disabled: https://github.com/ant-design/ant-design/issues/16478
    //           https://github.com/ant-design/ant-design/issues/24197
    if (!children || mergedDisabled) delete rcUploadProps.id;
    const wrapperCls = `${prefixCls}-wrapper`;
    const [hashId, cssVarCls] = (0, $5ef6d53e9e3237ff$export$2e2bcd8739ae039)(prefixCls, wrapperCls);
    const [contextLocale] = (0, $a2f3e1f88973a5e2$export$2e2bcd8739ae039)('Upload', (0, $7a40da28675d08a9$export$2e2bcd8739ae039).Upload);
    const { showRemoveIcon: showRemoveIcon, showPreviewIcon: showPreviewIcon, showDownloadIcon: showDownloadIcon, removeIcon: removeIcon, previewIcon: previewIcon, downloadIcon: downloadIcon, extra: extra } = typeof showUploadList === 'boolean' ? {} : showUploadList;
    // use showRemoveIcon if it is specified explicitly
    const realShowRemoveIcon = typeof showRemoveIcon === 'undefined' ? !mergedDisabled : showRemoveIcon;
    const renderUploadList = (button, buttonVisible)=>{
        if (!showUploadList) return button;
        return /*#__PURE__*/ $5E6i4.createElement((0, $c398dfa99aa268d4$export$2e2bcd8739ae039), {
            classNames: mergedClassNames,
            styles: mergedStyles,
            prefixCls: prefixCls,
            listType: listType,
            items: mergedFileList,
            previewFile: previewFile,
            onPreview: onPreview,
            onDownload: onDownload,
            onRemove: handleRemove,
            showRemoveIcon: realShowRemoveIcon,
            showPreviewIcon: showPreviewIcon,
            showDownloadIcon: showDownloadIcon,
            removeIcon: removeIcon,
            previewIcon: previewIcon,
            downloadIcon: downloadIcon,
            iconRender: iconRender,
            extra: extra,
            locale: {
                ...contextLocale,
                ...propLocale
            },
            isImageUrl: isImageUrl,
            progress: mergedProgress,
            appendAction: button,
            appendActionVisible: buttonVisible,
            itemRender: itemRender,
            disabled: mergedDisabled
        });
    };
    const mergedRootCls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(wrapperCls, className, rootClassName, hashId, cssVarCls, contextClassName, mergedClassNames.root, {
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-picture-card-wrapper`]: listType === 'picture-card',
        [`${prefixCls}-picture-circle-wrapper`]: listType === 'picture-circle'
    });
    const mergedRootStyle = {
        ...mergedStyles.root
    };
    // ======================== Render ========================
    if (type === 'drag') {
        const dragCls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(hashId, prefixCls, `${prefixCls}-drag`, {
            [`${prefixCls}-drag-uploading`]: mergedFileList.some((file)=>file.status === 'uploading'),
            [`${prefixCls}-drag-hover`]: dragState === 'dragover',
            [`${prefixCls}-disabled`]: mergedDisabled,
            [`${prefixCls}-rtl`]: direction === 'rtl'
        }, mergedClassNames.trigger);
        return /*#__PURE__*/ $5E6i4.createElement("span", {
            className: mergedRootCls,
            ref: wrapRef,
            style: mergedRootStyle
        }, /*#__PURE__*/ $5E6i4.createElement("div", {
            className: dragCls,
            style: mergedStyles.trigger,
            onDrop: onFileDrop,
            onDragOver: onFileDrop,
            onDragLeave: onFileDrop
        }, /*#__PURE__*/ $5E6i4.createElement((0, $c68e810a7c07a7e5$export$2e2bcd8739ae039), {
            ...rcUploadProps,
            ref: uploadRef,
            className: `${prefixCls}-btn`
        }, /*#__PURE__*/ $5E6i4.createElement("div", {
            className: `${prefixCls}-drag-container`
        }, children))), renderUploadList());
    }
    const uploadBtnCls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-select`, {
        [`${prefixCls}-disabled`]: mergedDisabled,
        [`${prefixCls}-hidden`]: !children
    }, mergedClassNames.trigger);
    const uploadButton = /*#__PURE__*/ $5E6i4.createElement("div", {
        className: uploadBtnCls,
        style: mergedStyles.trigger
    }, /*#__PURE__*/ $5E6i4.createElement((0, $c68e810a7c07a7e5$export$2e2bcd8739ae039), {
        ...rcUploadProps,
        ref: uploadRef
    }));
    if (listType === 'picture-card' || listType === 'picture-circle') return /*#__PURE__*/ $5E6i4.createElement("span", {
        className: mergedRootCls,
        ref: wrapRef,
        style: mergedRootStyle
    }, renderUploadList(uploadButton, !!children));
    return /*#__PURE__*/ $5E6i4.createElement("span", {
        className: mergedRootCls,
        ref: wrapRef,
        style: mergedRootStyle
    }, uploadButton, renderUploadList());
};
const $994528b58dfa2a3a$var$Upload = /*#__PURE__*/ $5E6i4.forwardRef($994528b58dfa2a3a$var$InternalUpload);
var $994528b58dfa2a3a$export$2e2bcd8739ae039 = $994528b58dfa2a3a$var$Upload;


"use client";
const $741385cbe7471949$var$Dragger = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { style: style, height: height, hasControlInside: hasControlInside = false, children: children, ...restProps } = props;
    const mergedStyle = {
        ...style,
        ...(0, $b63de2b9864a5d1a$export$826fff653a329e83)(height) && {
            height: height
        }
    };
    return /*#__PURE__*/ $5E6i4.createElement((0, $994528b58dfa2a3a$export$2e2bcd8739ae039), {
        ref: ref,
        hasControlInside: hasControlInside,
        ...restProps,
        style: mergedStyle,
        type: "drag"
    }, children);
});
var $741385cbe7471949$export$2e2bcd8739ae039 = $741385cbe7471949$var$Dragger;



"use client";
const $80214002dbda5f05$var$Upload = (0, $994528b58dfa2a3a$export$2e2bcd8739ae039);
$80214002dbda5f05$var$Upload.Dragger = (0, $741385cbe7471949$export$2e2bcd8739ae039);
$80214002dbda5f05$var$Upload.LIST_IGNORE = (0, $994528b58dfa2a3a$export$8f9bb9ff126b1bf5);
var $80214002dbda5f05$export$2e2bcd8739ae039 = $80214002dbda5f05$var$Upload;




var $5E6i4 = parcelRequire("5E6i4");



/** Imports a MusicXML file (paper, 7.2: "an option to import custom sheet music"). */ const $ce683bf34071f3bb$var$ImportSheet = ({ isOpen: isOpen, onClose: onClose, onImported: onImported })=>{
    const { t: translate } = (0, $705ab703c44be5bc$export$9fc83ad70ead8663)();
    const [file, setFile] = (0, $5E6i4.useState)();
    const [title, setTitle] = (0, $5E6i4.useState)('');
    const [composer, setComposer] = (0, $5E6i4.useState)('');
    const [error, setError] = (0, $5E6i4.useState)();
    const [isImporting, setIsImporting] = (0, $5E6i4.useState)(false);
    const reset = ()=>{
        setFile(undefined);
        setTitle('');
        setComposer('');
        setError(undefined);
    };
    const submit = async ()=>{
        if (!file) return;
        setIsImporting(true);
        setError(undefined);
        try {
            const response = await (0, $0d16547caa56a13b$export$2e2bcd8739ae039).post(`${(0, $f3690857a25f275e$export$959cc5b93fe4d66)()}/music-sheets`, await file.arrayBuffer(), {
                headers: {
                    'Content-Type': 'application/octet-stream'
                },
                params: {
                    composer: composer || undefined,
                    fileName: file.name,
                    title: title || undefined
                }
            });
            onImported(response.data);
            reset();
            onClose();
        } catch (reason) {
            setError((0, $d65ba47825fbd282$export$d78e6d61b3e1e377)(reason));
        } finally{
            setIsImporting(false);
        }
    };
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $8d1ff632133ae5da$export$2e2bcd8739ae039), {
        confirmLoading: isImporting,
        okButtonProps: {
            disabled: !file
        },
        okText: translate('import.submit'),
        onCancel: ()=>{
            reset();
            onClose();
        },
        onOk: submit,
        open: isOpen,
        title: translate('import.title'),
        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)((0, $500c6374712950d2$export$2e2bcd8739ae039), {
            layout: "vertical",
            children: [
                /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $500c6374712950d2$export$2e2bcd8739ae039).Item, {
                    label: translate('import.file'),
                    required: true,
                    children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)((0, $80214002dbda5f05$export$2e2bcd8739ae039).Dragger, {
                        accept: ".musicxml,.xml,.mxl",
                        beforeUpload: (chosen)=>{
                            setFile(chosen);
                            setError(undefined);
                            // The file is sent on submit, not by the upload component.
                            return false;
                        },
                        fileList: file ? [
                            {
                                name: file.name,
                                status: 'done',
                                uid: file.name
                            }
                        ] : [],
                        maxCount: 1,
                        onRemove: ()=>setFile(undefined),
                        children: [
                            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("p", {
                                className: "ant-upload-drag-icon",
                                children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $f53527c0d5d8cbe5$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("p", {
                                className: "ant-upload-text",
                                children: translate('import.drop')
                            }),
                            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("p", {
                                className: "ant-upload-hint",
                                children: translate('import.hint')
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $500c6374712950d2$export$2e2bcd8739ae039).Item, {
                    extra: translate('import.fromFile'),
                    htmlFor: "import-sheet-title",
                    label: translate('import.titleLabel'),
                    children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $8951186c565e4005$export$2e2bcd8739ae039), {
                        id: "import-sheet-title",
                        maxLength: 120,
                        onChange: (event)=>setTitle(event.target.value),
                        value: title
                    })
                }),
                /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $500c6374712950d2$export$2e2bcd8739ae039).Item, {
                    extra: translate('import.fromFile'),
                    htmlFor: "import-sheet-composer",
                    label: translate('import.composer'),
                    children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $8951186c565e4005$export$2e2bcd8739ae039), {
                        id: "import-sheet-composer",
                        maxLength: 120,
                        onChange: (event)=>setComposer(event.target.value),
                        value: composer
                    })
                }),
                error && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $4d1605d50bf1d84b$export$2e2bcd8739ae039), {
                    showIcon: true,
                    title: error,
                    type: "error"
                })
            ]
        })
    });
};
var $ce683bf34071f3bb$export$2e2bcd8739ae039 = $ce683bf34071f3bb$var$ImportSheet;







var $5E6i4 = parcelRequire("5E6i4");

var $ibUU1 = parcelRequire("ibUU1");

var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");

var $e7184004df161b8b$var$defaultTarget = (0, $7c82df226e6db626$export$4e09c449d6c407f7) ? window : null;
var $e7184004df161b8b$var$isListenerType1 = function(target) {
    return !!target.addEventListener;
};
var $e7184004df161b8b$var$isListenerType2 = function(target) {
    return !!target.on;
};
var $e7184004df161b8b$var$useEvent = function(name, handler, target, options) {
    if (target === void 0) target = $e7184004df161b8b$var$defaultTarget;
    (0, $5E6i4.useEffect)(function() {
        if (!handler) return;
        if (!target) return;
        if ($e7184004df161b8b$var$isListenerType1(target)) (0, $7c82df226e6db626$export$af631764ddc44097)(target, name, handler, options);
        else if ($e7184004df161b8b$var$isListenerType2(target)) target.on(name, handler, options);
        return function() {
            if ($e7184004df161b8b$var$isListenerType1(target)) (0, $7c82df226e6db626$export$8c8705df4a2dcec9)(target, name, handler, options);
            else if ($e7184004df161b8b$var$isListenerType2(target)) target.off(name, handler, options);
        };
    }, [
        name,
        handler,
        target,
        JSON.stringify(options)
    ]);
};
var $e7184004df161b8b$export$2e2bcd8739ae039 = $e7184004df161b8b$var$useEvent;



var $370fd9796cc17e68$var$createKeyPredicate = function(keyFilter) {
    return typeof keyFilter === 'function' ? keyFilter : typeof keyFilter === 'string' ? function(event) {
        return event.key === keyFilter;
    } : keyFilter ? function() {
        return true;
    } : function() {
        return false;
    };
};
var $370fd9796cc17e68$var$useKey = function(key, fn, opts, deps) {
    if (fn === void 0) fn = (0, $7c82df226e6db626$export$8793edee2d425525);
    if (opts === void 0) opts = {};
    if (deps === void 0) deps = [
        key
    ];
    var _a = opts.event, event = _a === void 0 ? 'keydown' : _a, target = opts.target, options = opts.options;
    var useMemoHandler = (0, $5E6i4.useMemo)(function() {
        var predicate = $370fd9796cc17e68$var$createKeyPredicate(key);
        var handler = function(handlerEvent) {
            if (predicate(handlerEvent)) return fn(handlerEvent);
        };
        return handler;
    }, deps);
    (0, $e7184004df161b8b$export$2e2bcd8739ae039)(event, useMemoHandler, target, options);
};
var $370fd9796cc17e68$export$2e2bcd8739ae039 = $370fd9796cc17e68$var$useKey;



const $63de5ab31bfa06ec$var$rnds8 = new Uint8Array(16);
function $63de5ab31bfa06ec$export$2e2bcd8739ae039() {
    return crypto.getRandomValues($63de5ab31bfa06ec$var$rnds8);
}


var $0667d326f59fbc08$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;


function $155d30e82effc462$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $0667d326f59fbc08$export$2e2bcd8739ae039).test(uuid);
}
var $155d30e82effc462$export$2e2bcd8739ae039 = $155d30e82effc462$var$validate;


const $09c76daa571dd1dd$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$09c76daa571dd1dd$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $09c76daa571dd1dd$export$8fb373d660548968(arr, offset = 0) {
    return ($09c76daa571dd1dd$var$byteToHex[arr[offset + 0]] + $09c76daa571dd1dd$var$byteToHex[arr[offset + 1]] + $09c76daa571dd1dd$var$byteToHex[arr[offset + 2]] + $09c76daa571dd1dd$var$byteToHex[arr[offset + 3]] + '-' + $09c76daa571dd1dd$var$byteToHex[arr[offset + 4]] + $09c76daa571dd1dd$var$byteToHex[arr[offset + 5]] + '-' + $09c76daa571dd1dd$var$byteToHex[arr[offset + 6]] + $09c76daa571dd1dd$var$byteToHex[arr[offset + 7]] + '-' + $09c76daa571dd1dd$var$byteToHex[arr[offset + 8]] + $09c76daa571dd1dd$var$byteToHex[arr[offset + 9]] + '-' + $09c76daa571dd1dd$var$byteToHex[arr[offset + 10]] + $09c76daa571dd1dd$var$byteToHex[arr[offset + 11]] + $09c76daa571dd1dd$var$byteToHex[arr[offset + 12]] + $09c76daa571dd1dd$var$byteToHex[arr[offset + 13]] + $09c76daa571dd1dd$var$byteToHex[arr[offset + 14]] + $09c76daa571dd1dd$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $09c76daa571dd1dd$var$stringify(arr, offset = 0) {
    const uuid = $09c76daa571dd1dd$export$8fb373d660548968(arr, offset);
    if (!(0, $155d30e82effc462$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $09c76daa571dd1dd$export$2e2bcd8739ae039 = $09c76daa571dd1dd$var$stringify;


function $cc904d2b6f5c076b$var$v4(options, buf, offset) {
    if (!buf && !options && crypto.randomUUID) return crypto.randomUUID();
    return $cc904d2b6f5c076b$var$_v4(options, buf, offset);
}
function $cc904d2b6f5c076b$var$_v4(options, buf, offset) {
    options = options || {};
    const rnds = options.random ?? options.rng?.() ?? (0, $63de5ab31bfa06ec$export$2e2bcd8739ae039)();
    if (rnds.length < 16) throw new Error('Random bytes length must be >= 16');
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    if (buf) {
        offset = offset || 0;
        if (offset < 0 || offset + 16 > buf.length) throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $09c76daa571dd1dd$export$8fb373d660548968)(rnds);
}
var $cc904d2b6f5c076b$export$2e2bcd8739ae039 = $cc904d2b6f5c076b$var$v4;


const $9ecda7333d28e490$export$c48094ccb2640a99 = 800;
const $9ecda7333d28e490$export$9ca2902b8ce32929 = 20;
const $9ecda7333d28e490$export$7395e4cb572e863b = 0.6;
const $9ecda7333d28e490$export$d87c4465c591a827 = '#808080';
const $9ecda7333d28e490$export$47a4f6ea72e40329 = 1;
const $9ecda7333d28e490$export$e33e649b64add65d = 0.4;
const $9ecda7333d28e490$export$da8fddcadef8a54b = 0.2;
const $9ecda7333d28e490$export$c49073cd0364c68 = 10;
const $9ecda7333d28e490$export$8e87780efcb71645 = 20;






var $ibUU1 = parcelRequire("ibUU1");






var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $8bad48b213e16f68$var$AlignLeftOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M120 230h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 424h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm784 140H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-424H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "align-left",
    "theme": "outlined"
};
var $8bad48b213e16f68$export$2e2bcd8739ae039 = $8bad48b213e16f68$var$AlignLeftOutlined;



function $ee51eca14ea12f5a$var$_extends() {
    $ee51eca14ea12f5a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ee51eca14ea12f5a$var$_extends.apply(this, arguments);
}
const $ee51eca14ea12f5a$var$AlignLeftOutlined = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $ee51eca14ea12f5a$var$_extends({}, props, {
        ref: ref,
        icon: (0, $8bad48b213e16f68$export$2e2bcd8739ae039)
    }));
/**![align-left](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTEyMCAyMzBoNDk2YzQuNCAwIDgtMy42IDgtOHYtNTZjMC00LjQtMy42LTgtOC04SDEyMGMtNC40IDAtOCAzLjYtOCA4djU2YzAgNC40IDMuNiA4IDggOHptMCA0MjRoNDk2YzQuNCAwIDgtMy42IDgtOHYtNTZjMC00LjQtMy42LTgtOC04SDEyMGMtNC40IDAtOCAzLjYtOCA4djU2YzAgNC40IDMuNiA4IDggOHptNzg0IDE0MEgxMjBjLTQuNCAwLTggMy42LTggOHY1NmMwIDQuNCAzLjYgOCA4IDhoNzg0YzQuNCAwIDgtMy42IDgtOHYtNTZjMC00LjQtMy42LTgtOC04em0wLTQyNEgxMjBjLTQuNCAwLTggMy42LTggOHY1NmMwIDQuNCAzLjYgOCA4IDhoNzg0YzQuNCAwIDgtMy42IDgtOHYtNTZjMC00LjQtMy42LTgtOC04eiIgLz48L3N2Zz4=) */ const $ee51eca14ea12f5a$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($ee51eca14ea12f5a$var$AlignLeftOutlined);
var $ee51eca14ea12f5a$export$2e2bcd8739ae039 = $ee51eca14ea12f5a$var$RefIcon;


var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $38aa07463d31dae1$var$ColumnWidthOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M180 176h-60c-4.4 0-8 3.6-8 8v656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V184c0-4.4-3.6-8-8-8zm724 0h-60c-4.4 0-8 3.6-8 8v656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V184c0-4.4-3.6-8-8-8zM785.3 504.3L657.7 403.6a7.23 7.23 0 00-11.7 5.7V476H378v-62.8c0-6-7-9.4-11.7-5.7L238.7 508.3a7.14 7.14 0 000 11.3l127.5 100.8c4.7 3.7 11.7.4 11.7-5.7V548h268v62.8c0 6 7 9.4 11.7 5.7l127.5-100.8c3.8-2.9 3.8-8.5.2-11.4z"
                }
            }
        ]
    },
    "name": "column-width",
    "theme": "outlined"
};
var $38aa07463d31dae1$export$2e2bcd8739ae039 = $38aa07463d31dae1$var$ColumnWidthOutlined;



function $c84a6b52a83822ee$var$_extends() {
    $c84a6b52a83822ee$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c84a6b52a83822ee$var$_extends.apply(this, arguments);
}
const $c84a6b52a83822ee$var$ColumnWidthOutlined = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $c84a6b52a83822ee$var$_extends({}, props, {
        ref: ref,
        icon: (0, $38aa07463d31dae1$export$2e2bcd8739ae039)
    }));
/**![column-width](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTE4MCAxNzZoLTYwYy00LjQgMC04IDMuNi04IDh2NjU2YzAgNC40IDMuNiA4IDggOGg2MGM0LjQgMCA4LTMuNiA4LThWMTg0YzAtNC40LTMuNi04LTgtOHptNzI0IDBoLTYwYy00LjQgMC04IDMuNi04IDh2NjU2YzAgNC40IDMuNiA4IDggOGg2MGM0LjQgMCA4LTMuNiA4LThWMTg0YzAtNC40LTMuNi04LTgtOHpNNzg1LjMgNTA0LjNMNjU3LjcgNDAzLjZhNy4yMyA3LjIzIDAgMDAtMTEuNyA1LjdWNDc2SDM3OHYtNjIuOGMwLTYtNy05LjQtMTEuNy01LjdMMjM4LjcgNTA4LjNhNy4xNCA3LjE0IDAgMDAwIDExLjNsMTI3LjUgMTAwLjhjNC43IDMuNyAxMS43LjQgMTEuNy01LjdWNTQ4aDI2OHY2Mi44YzAgNiA3IDkuNCAxMS43IDUuN2wxMjcuNS0xMDAuOGMzLjgtMi45IDMuOC04LjUuMi0xMS40eiIgLz48L3N2Zz4=) */ const $c84a6b52a83822ee$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($c84a6b52a83822ee$var$ColumnWidthOutlined);
var $c84a6b52a83822ee$export$2e2bcd8739ae039 = $c84a6b52a83822ee$var$RefIcon;


var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $1135ee297326328b$var$InfoCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M464 336a48 48 0 1096 0 48 48 0 10-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "info-circle",
    "theme": "outlined"
};
var $1135ee297326328b$export$2e2bcd8739ae039 = $1135ee297326328b$var$InfoCircleOutlined;



function $e1bc962ecfda250a$var$_extends() {
    $e1bc962ecfda250a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e1bc962ecfda250a$var$_extends.apply(this, arguments);
}
const $e1bc962ecfda250a$var$InfoCircleOutlined = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $e1bc962ecfda250a$var$_extends({}, props, {
        ref: ref,
        icon: (0, $1135ee297326328b$export$2e2bcd8739ae039)
    }));
/**![info-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0wIDgyMGMtMjA1LjQgMC0zNzItMTY2LjYtMzcyLTM3MnMxNjYuNi0zNzIgMzcyLTM3MiAzNzIgMTY2LjYgMzcyIDM3Mi0xNjYuNiAzNzItMzcyIDM3MnoiIC8+PHBhdGggZD0iTTQ2NCAzMzZhNDggNDggMCAxMDk2IDAgNDggNDggMCAxMC05NiAwem03MiAxMTJoLTQ4Yy00LjQgMC04IDMuNi04IDh2MjcyYzAgNC40IDMuNiA4IDggOGg0OGM0LjQgMCA4LTMuNiA4LThWNDU2YzAtNC40LTMuNi04LTgtOHoiIC8+PC9zdmc+) */ const $e1bc962ecfda250a$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($e1bc962ecfda250a$var$InfoCircleOutlined);
var $e1bc962ecfda250a$export$2e2bcd8739ae039 = $e1bc962ecfda250a$var$RefIcon;


var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $006473fd11c6c826$var$SoundOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M625.9 115c-5.9 0-11.9 1.6-17.4 5.3L254 352H90c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h164l354.5 231.7c5.5 3.6 11.6 5.3 17.4 5.3 16.7 0 32.1-13.3 32.1-32.1V147.1c0-18.8-15.4-32.1-32.1-32.1zM586 803L293.4 611.7l-18-11.7H146V424h129.4l17.9-11.7L586 221v582zm348-327H806c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16zm-41.9 261.8l-110.3-63.7a15.9 15.9 0 00-21.7 5.9l-19.9 34.5c-4.4 7.6-1.8 17.4 5.8 21.8L856.3 800a15.9 15.9 0 0021.7-5.9l19.9-34.5c4.4-7.6 1.7-17.4-5.8-21.8zM760 344a15.9 15.9 0 0021.7 5.9L892 286.2c7.6-4.4 10.2-14.2 5.8-21.8L878 230a15.9 15.9 0 00-21.7-5.9L746 287.8a15.99 15.99 0 00-5.8 21.8L760 344z"
                }
            }
        ]
    },
    "name": "sound",
    "theme": "outlined"
};
var $006473fd11c6c826$export$2e2bcd8739ae039 = $006473fd11c6c826$var$SoundOutlined;



function $9432be6e4165a739$var$_extends() {
    $9432be6e4165a739$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9432be6e4165a739$var$_extends.apply(this, arguments);
}
const $9432be6e4165a739$var$SoundOutlined = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $9432be6e4165a739$var$_extends({}, props, {
        ref: ref,
        icon: (0, $006473fd11c6c826$export$2e2bcd8739ae039)
    }));
/**![sound](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTYyNS45IDExNWMtNS45IDAtMTEuOSAxLjYtMTcuNCA1LjNMMjU0IDM1Mkg5MGMtOC44IDAtMTYgNy4yLTE2IDE2djI4OGMwIDguOCA3LjIgMTYgMTYgMTZoMTY0bDM1NC41IDIzMS43YzUuNSAzLjYgMTEuNiA1LjMgMTcuNCA1LjMgMTYuNyAwIDMyLjEtMTMuMyAzMi4xLTMyLjFWMTQ3LjFjMC0xOC44LTE1LjQtMzIuMS0zMi4xLTMyLjF6TTU4NiA4MDNMMjkzLjQgNjExLjdsLTE4LTExLjdIMTQ2VjQyNGgxMjkuNGwxNy45LTExLjdMNTg2IDIyMXY1ODJ6bTM0OC0zMjdIODA2Yy04LjggMC0xNiA3LjItMTYgMTZ2NDBjMCA4LjggNy4yIDE2IDE2IDE2aDEyOGM4LjggMCAxNi03LjIgMTYtMTZ2LTQwYzAtOC44LTcuMi0xNi0xNi0xNnptLTQxLjkgMjYxLjhsLTExMC4zLTYzLjdhMTUuOSAxNS45IDAgMDAtMjEuNyA1LjlsLTE5LjkgMzQuNWMtNC40IDcuNi0xLjggMTcuNCA1LjggMjEuOEw4NTYuMyA4MDBhMTUuOSAxNS45IDAgMDAyMS43LTUuOWwxOS45LTM0LjVjNC40LTcuNiAxLjctMTcuNC01LjgtMjEuOHpNNzYwIDM0NGExNS45IDE1LjkgMCAwMDIxLjcgNS45TDg5MiAyODYuMmM3LjYtNC40IDEwLjItMTQuMiA1LjgtMjEuOEw4NzggMjMwYTE1LjkgMTUuOSAwIDAwLTIxLjctNS45TDc0NiAyODcuOGExNS45OSAxNS45OSAwIDAwLTUuOCAyMS44TDc2MCAzNDR6IiAvPjwvc3ZnPg==) */ const $9432be6e4165a739$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($9432be6e4165a739$var$SoundOutlined);
var $9432be6e4165a739$export$2e2bcd8739ae039 = $9432be6e4165a739$var$RefIcon;


var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $da277addbe45a4d8$var$TagOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M938 458.8l-29.6-312.6c-1.5-16.2-14.4-29-30.6-30.6L565.2 86h-.4c-3.2 0-5.7 1-7.6 2.9L88.9 557.2a9.96 9.96 0 000 14.1l363.8 363.8c1.9 1.9 4.4 2.9 7.1 2.9s5.2-1 7.1-2.9l468.3-468.3c2-2.1 3-5 2.8-8zM459.7 834.7L189.3 564.3 589 164.6 836 188l23.4 247-399.7 399.7zM680 256c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm0 120c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                }
            }
        ]
    },
    "name": "tag",
    "theme": "outlined"
};
var $da277addbe45a4d8$export$2e2bcd8739ae039 = $da277addbe45a4d8$var$TagOutlined;



function $a708ae8b61682253$var$_extends() {
    $a708ae8b61682253$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a708ae8b61682253$var$_extends.apply(this, arguments);
}
const $a708ae8b61682253$var$TagOutlined = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $a708ae8b61682253$var$_extends({}, props, {
        ref: ref,
        icon: (0, $da277addbe45a4d8$export$2e2bcd8739ae039)
    }));
/**![tag](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkzOCA0NTguOGwtMjkuNi0zMTIuNmMtMS41LTE2LjItMTQuNC0yOS0zMC42LTMwLjZMNTY1LjIgODZoLS40Yy0zLjIgMC01LjcgMS03LjYgMi45TDg4LjkgNTU3LjJhOS45NiA5Ljk2IDAgMDAwIDE0LjFsMzYzLjggMzYzLjhjMS45IDEuOSA0LjQgMi45IDcuMSAyLjlzNS4yLTEgNy4xLTIuOWw0NjguMy00NjguM2MyLTIuMSAzLTUgMi44LTh6TTQ1OS43IDgzNC43TDE4OS4zIDU2NC4zIDU4OSAxNjQuNiA4MzYgMTg4bDIzLjQgMjQ3LTM5OS43IDM5OS43ek02ODAgMjU2Yy00OC41IDAtODggMzkuNS04OCA4OHMzOS41IDg4IDg4IDg4IDg4LTM5LjUgODgtODgtMzkuNS04OC04OC04OHptMCAxMjBjLTE3LjcgMC0zMi0xNC4zLTMyLTMyczE0LjMtMzIgMzItMzIgMzIgMTQuMyAzMiAzMi0xNC4zIDMyLTMyIDMyeiIgLz48L3N2Zz4=) */ const $a708ae8b61682253$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($a708ae8b61682253$var$TagOutlined);
var $a708ae8b61682253$export$2e2bcd8739ae039 = $a708ae8b61682253$var$RefIcon;




const $7a1d887315ca37d3$var$PatternTooltip = ({ children: children, hint: hint, isDeactivated: isDeactivated = false, isOpen: isOpen, pattern: pattern, shouldDisplayDisclaimer: shouldDisplayDisclaimer = false, shouldDisplayOccurrences: shouldDisplayOccurrences = false })=>{
    if (pattern === undefined || isDeactivated) return children;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $1bb718ecb5669b36$export$2e2bcd8739ae039), {
        mouseEnterDelay: 0,
        open: isOpen,
        placement: "leftTop",
        // The tooltip only shows: the pointer passes through it to the marks and notes beneath, so moving onto it
        // leaves the mark and closes it instead of keeping it open over what the pointer is after.
        styles: {
            root: {
                pointerEvents: 'none'
            }
        },
        title: ()=>{
            const { t: translate } = (0, $705ab703c44be5bc$export$9fc83ad70ead8663)();
            return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)((0, $90cae257cc958273$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("span", {
                                className: "mb-1 flex items-center text-slate-400 text-xs",
                                children: [
                                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $a708ae8b61682253$export$2e2bcd8739ae039), {
                                        className: "mr-1"
                                    }),
                                    translate('melodicPattern.configuration.label')
                                ]
                            }),
                            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("span", {
                                className: "ml-1",
                                children: pattern.label
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
                        className: "mt-2",
                        children: [
                            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("span", {
                                className: "flex items-center text-slate-400 text-xs",
                                children: [
                                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $ee51eca14ea12f5a$export$2e2bcd8739ae039), {
                                        className: "mr-1"
                                    }),
                                    translate('melodicPattern.configuration.description')
                                ]
                            }),
                            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("span", {
                                className: "ml-1",
                                children: pattern.description || '-'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
                        className: "mt-2",
                        children: [
                            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("span", {
                                className: "mb-1 flex items-center text-slate-400 text-xs",
                                children: [
                                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $c84a6b52a83822ee$export$2e2bcd8739ae039), {
                                        className: "mr-1"
                                    }),
                                    translate('melodicPattern.configuration.length')
                                ]
                            }),
                            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("span", {
                                className: "ml-1",
                                children: pattern.length
                            })
                        ]
                    }),
                    shouldDisplayOccurrences && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
                        className: "mt-2",
                        children: [
                            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("span", {
                                className: "mb-1 flex items-center text-slate-400 text-xs",
                                children: [
                                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $c84a6b52a83822ee$export$2e2bcd8739ae039), {
                                        className: "mr-1"
                                    }),
                                    translate('melodicPattern.configuration.occurrences')
                                ]
                            }),
                            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("span", {
                                className: "ml-1",
                                children: [
                                    pattern.occurrences.length,
                                    " (",
                                    pattern.uniqueOccurrencesCount,
                                    ")"
                                ]
                            })
                        ]
                    }),
                    hint && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("span", {
                        className: "mt-2 flex items-center text-slate-400 leading-tight",
                        style: {
                            fontSize: 11
                        },
                        children: [
                            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $9432be6e4165a739$export$2e2bcd8739ae039), {
                                className: "mr-1"
                            }),
                            hint
                        ]
                    }),
                    shouldDisplayDisclaimer && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("span", {
                        className: "mt-2 flex items-center text-slate-400 leading-tight",
                        style: {
                            fontSize: 11
                        },
                        children: [
                            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $e1bc962ecfda250a$export$2e2bcd8739ae039), {
                                className: "mr-1"
                            }),
                            translate('melodicPattern.tooltip.disclaimer')
                        ]
                    })
                ]
            });
        },
        children: children
    });
};
var $7a1d887315ca37d3$export$2e2bcd8739ae039 = $7a1d887315ca37d3$var$PatternTooltip;


const $2a70544114aeb517$export$e91d549d49c2dc53 = 'pattern-highlight';
const $2a70544114aeb517$var$EllipsisLine = (0, $07090e743135ae89$export$2e2bcd8739ae039).line`
  stroke: ${(styles)=>styles.$color};
  stroke-dasharray: 5;
  stroke-opacity: ${(styles)=>styles.$colorOpacity};
  stroke-width: 4;
`;
const $2a70544114aeb517$var$PatternHighlight = ({ color: color, colorOpacity: colorOpacity, coordinates: coordinates, hasEllipsisLeft: hasEllipsisLeft, hasEllipsisRight: hasEllipsisRight, hoveredOccurrenceIndex: hoveredOccurrenceIndex, hoveredOccurrences: hoveredOccurrences, hoveredPatternIDs: hoveredPatternIDs, id: id, occurrenceIndex: occurrenceIndex, page: page, pattern: pattern, shouldShowTooltip: shouldShowTooltip })=>{
    // The highlights are recomputed after the patterns changed: for one render a segment may still belong to an entry
    // that was just hidden (Suggestions panel of a discovered family).
    const occurrence = pattern?.occurrences[occurrenceIndex];
    if (pattern === undefined || occurrence === undefined) return null;
    if (coordinates.length === 1) coordinates.push(coordinates[0]);
    const firstCoordinate = coordinates[0];
    const isHovered = hoveredPatternIDs.includes(id) && hoveredOccurrenceIndex === occurrenceIndex;
    const lastCoordinate = coordinates[coordinates.length - 1];
    const shouldBeTransparent = hoveredPatternIDs.length > 0 && !hoveredPatternIDs.includes(id) || hoveredOccurrenceIndex !== undefined && occurrenceIndex !== hoveredOccurrenceIndex || hoveredOccurrences.length > 0 && !hoveredOccurrences.some((hoveredOccurrence)=>(0, $e5b6a001e5093ab5$export$973cb4c224e2e27b)(occurrence, hoveredOccurrence));
    if (shouldBeTransparent) colorOpacity = (0, $9ecda7333d28e490$export$da8fddcadef8a54b);
    const chipWidth = (pattern.label?.length ?? 0) * 6 + 8;
    return /*#__PURE__*/ (0, $ibUU1.createPortal)(/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $7a1d887315ca37d3$export$2e2bcd8739ae039), {
        pattern: pattern,
        isOpen: shouldShowTooltip && isHovered && !hasEllipsisLeft,
        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("g", {
            className: $2a70544114aeb517$export$e91d549d49c2dc53,
            tabIndex: -1,
            children: [
                hasEllipsisLeft ? /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($2a70544114aeb517$var$EllipsisLine, {
                            $color: color,
                            $colorOpacity: colorOpacity,
                            x1: firstCoordinate[0],
                            x2: firstCoordinate[0] - 25,
                            y1: firstCoordinate[1] - 8,
                            y2: firstCoordinate[1] - 8
                        }),
                        /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($2a70544114aeb517$var$EllipsisLine, {
                            $color: color,
                            $colorOpacity: colorOpacity,
                            x1: firstCoordinate[0],
                            x2: firstCoordinate[0] - 25,
                            y1: firstCoordinate[1] + 8,
                            y2: firstCoordinate[1] + 8
                        })
                    ]
                }) : null,
                /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("polyline", {
                    points: coordinates.map(([x, y])=>`${x},${y}`).join(' '),
                    style: {
                        cursor: 'pointer',
                        fill: 'none',
                        stroke: color,
                        strokeLinecap: 'round',
                        strokeLinejoin: 'round',
                        strokeOpacity: colorOpacity,
                        strokeWidth: 20
                    }
                }),
                !hasEllipsisLeft && pattern.label && // The label names the pattern beside its colour (audit F07: colour alone carried identity in the sheet).
                /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("g", {
                    opacity: shouldBeTransparent ? 0.35 : 1,
                    pointerEvents: "none",
                    children: [
                        /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("rect", {
                            fill: color,
                            height: 13,
                            rx: 3,
                            stroke: "#ffffff",
                            strokeWidth: 1,
                            width: chipWidth,
                            x: firstCoordinate[0] - chipWidth / 2,
                            y: firstCoordinate[1] - 25
                        }),
                        /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("text", {
                            dominantBaseline: "central",
                            fill: (0, $a9ceb34ac62682a2$export$2e2bcd8739ae039).mostReadable(color, [
                                '#ffffff',
                                '#0b0b0b'
                            ]).toHexString(),
                            fontFamily: "sans-serif",
                            fontSize: 9,
                            fontWeight: 700,
                            textAnchor: "middle",
                            x: firstCoordinate[0],
                            y: firstCoordinate[1] - 18.5,
                            children: pattern.label
                        })
                    ]
                }),
                hasEllipsisRight ? /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($2a70544114aeb517$var$EllipsisLine, {
                            $color: color,
                            $colorOpacity: colorOpacity,
                            x1: lastCoordinate[0],
                            x2: lastCoordinate[0] + 25,
                            y1: lastCoordinate[1] - 8,
                            y2: lastCoordinate[1] - 8
                        }),
                        /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($2a70544114aeb517$var$EllipsisLine, {
                            $color: color,
                            $colorOpacity: colorOpacity,
                            x1: lastCoordinate[0],
                            x2: lastCoordinate[0] + 25,
                            y1: lastCoordinate[1] + 8,
                            y2: lastCoordinate[1] + 8
                        })
                    ]
                }) : null
            ]
        })
    }), page);
};
var $2a70544114aeb517$export$2e2bcd8739ae039 = $2a70544114aeb517$var$PatternHighlight;




var $5E6i4 = parcelRequire("5E6i4");
const $ca0029180522dabd$var$defaultSelection = {
    focusingID: undefined
};
const $ca0029180522dabd$export$7c7a4fd7f1336e2c = /*#__PURE__*/ (0, $5E6i4.createContext)([
    $ca0029180522dabd$var$defaultSelection,
    undefined
]);
const $ca0029180522dabd$var$SelectionContextProvider = ({ children: children })=>{
    const [selection, setSelection] = (0, $5E6i4.useState)($ca0029180522dabd$var$defaultSelection);
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($ca0029180522dabd$export$7c7a4fd7f1336e2c.Provider, {
        value: [
            selection,
            setSelection
        ],
        children: children
    });
};
var $ca0029180522dabd$export$2e2bcd8739ae039 = $ca0029180522dabd$var$SelectionContextProvider;



/**
 * Score following: while a playback runs (the whole piece or one entry), the written notes that sound light up in
 * the sheet (layout.css, `.is-sounding`). One playback runs at a time, so the lit notes are kept here for all of them.
 */ const $4276fbe97a4bd973$var$soundingClass = 'is-sounding';
let $4276fbe97a4bd973$var$lit = new Set();
const $4276fbe97a4bd973$export$4c117c7f2bc3ff1a = (noteElements)=>{
    if (!noteElements) return [];
    const contexts = noteElements.data();
    return noteElements.nodes().map((element, index)=>{
        const { note: note, voiceNumber: voiceNumber } = contexts[index];
        const onset = (0, $60078af3cede2a64$export$d66a0ac0c9083fa1)(note.sourceNote);
        return {
            element: element,
            end: onset + note.sourceNote.Length.RealValue * 4,
            isRest: note.sourceNote.isRest(),
            onset: onset,
            voice: voiceNumber
        };
    }).filter((span)=>!span.isRest).map(({ isRest: _, ...span })=>span);
};
const $4276fbe97a4bd973$export$81aa32e9df80256d = 'melodyvis-reveal';
/** A zoomed sheet scrolls to the notes that are struck when they are out of its view. */ const $4276fbe97a4bd973$var$keepInView = (element)=>{
    const viewport = element.closest('.melodyvis-sheet-viewport');
    if (!viewport) return;
    const view = viewport.getBoundingClientRect();
    const note = element.getBoundingClientRect();
    if (note.top < view.top || note.bottom > view.bottom || note.left < view.left || note.right > view.right) {
        if (viewport.classList.contains('is-a4')) viewport.dispatchEvent(new CustomEvent($4276fbe97a4bd973$export$81aa32e9df80256d, {
            detail: element
        }));
        else element.scrollIntoView({
            block: 'center',
            inline: 'center'
        });
    }
};
/** Lights up the given notes, and only them. */ const $4276fbe97a4bd973$var$light = (sounding)=>{
    $4276fbe97a4bd973$var$lit.forEach((element)=>{
        if (!sounding.has(element)) element.classList.remove($4276fbe97a4bd973$var$soundingClass);
    });
    const struck = [
        ...sounding
    ].filter((element)=>!$4276fbe97a4bd973$var$lit.has(element));
    sounding.forEach((element)=>element.classList.add($4276fbe97a4bd973$var$soundingClass));
    $4276fbe97a4bd973$var$lit = sounding;
    if (struck.length > 0) $4276fbe97a4bd973$var$keepInView(struck[0]);
};
const $4276fbe97a4bd973$export$88e4cf4d18f1259e = ()=>$4276fbe97a4bd973$var$light(new Set());
const $4276fbe97a4bd973$export$8f0a8bcebb0f44bb = (spans, playback, { isFollowed: isFollowed = ()=>true, offsetAt: offsetAt = (position)=>position, onOffset: onOffset } = {})=>{
    let source;
    let followed = [];
    let frame;
    let isActive = true;
    const step = ()=>{
        const current = spans();
        if (current !== source) {
            source = current;
            followed = current.filter(isFollowed);
        }
        const offset = offsetAt(playback.position());
        $4276fbe97a4bd973$var$light(new Set(followed.filter((span)=>span.onset <= offset + 1e-6 && offset < span.end - 1e-6).map((span)=>span.element)));
        onOffset?.(offset);
        frame = window.requestAnimationFrame(step);
    };
    const halt = ()=>{
        isActive = false;
        if (frame !== undefined) window.cancelAnimationFrame(frame);
    };
    const stop = ()=>{
        halt();
        $4276fbe97a4bd973$export$88e4cf4d18f1259e();
    };
    playback.started.then(()=>{
        if (isActive) frame = window.requestAnimationFrame(step);
    });
    playback.finished.then(()=>{
        if (isActive) stop();
    });
    return {
        release: halt,
        stop: stop
    };
};




var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $1d77af19162707e3$var$ZoomInOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M637 443H519V309c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v134H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h118v134c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V519h118c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z"
                }
            }
        ]
    },
    "name": "zoom-in",
    "theme": "outlined"
};
var $1d77af19162707e3$export$2e2bcd8739ae039 = $1d77af19162707e3$var$ZoomInOutlined;



function $f4c7cde8fe500b2a$var$_extends() {
    $f4c7cde8fe500b2a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f4c7cde8fe500b2a$var$_extends.apply(this, arguments);
}
const $f4c7cde8fe500b2a$var$ZoomInOutlined = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $f4c7cde8fe500b2a$var$_extends({}, props, {
        ref: ref,
        icon: (0, $1d77af19162707e3$export$2e2bcd8739ae039)
    }));
/**![zoom-in](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTYzNyA0NDNINTE5VjMwOWMwLTQuNC0zLjYtOC04LThoLTYwYy00LjQgMC04IDMuNi04IDh2MTM0SDMyNWMtNC40IDAtOCAzLjYtOCA4djYwYzAgNC40IDMuNiA4IDggOGgxMTh2MTM0YzAgNC40IDMuNiA4IDggOGg2MGM0LjQgMCA4LTMuNiA4LThWNTE5aDExOGM0LjQgMCA4LTMuNiA4LTh2LTYwYzAtNC40LTMuNi04LTgtOHptMjg0IDQyNEw3NzUgNzIxYzEyMi4xLTE0OC45IDExMy42LTM2OS41LTI2LTUwOS0xNDgtMTQ4LjEtMzg4LjQtMTQ4LjEtNTM3IDAtMTQ4LjEgMTQ4LjYtMTQ4LjEgMzg5IDAgNTM3IDEzOS41IDEzOS42IDM2MC4xIDE0OC4xIDUwOSAyNmwxNDYgMTQ2YzMuMiAyLjggOC4zIDIuOCAxMSAwbDQzLTQzYzIuOC0yLjcgMi44LTcuOCAwLTExek02OTYgNjk2Yy0xMTguOCAxMTguNy0zMTEuMiAxMTguNy00MzAgMC0xMTguNy0xMTguOC0xMTguNy0zMTEuMiAwLTQzMCAxMTguOC0xMTguNyAzMTEuMi0xMTguNyA0MzAgMCAxMTguNyAxMTguOCAxMTguNyAzMTEuMiAwIDQzMHoiIC8+PC9zdmc+) */ const $f4c7cde8fe500b2a$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($f4c7cde8fe500b2a$var$ZoomInOutlined);
var $f4c7cde8fe500b2a$export$2e2bcd8739ae039 = $f4c7cde8fe500b2a$var$RefIcon;


var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $524bb4e7c635b88d$var$ZoomOutOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M637 443H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h312c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z"
                }
            }
        ]
    },
    "name": "zoom-out",
    "theme": "outlined"
};
var $524bb4e7c635b88d$export$2e2bcd8739ae039 = $524bb4e7c635b88d$var$ZoomOutOutlined;



function $cf778bd8920077ee$var$_extends() {
    $cf778bd8920077ee$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cf778bd8920077ee$var$_extends.apply(this, arguments);
}
const $cf778bd8920077ee$var$ZoomOutOutlined = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $cf778bd8920077ee$var$_extends({}, props, {
        ref: ref,
        icon: (0, $524bb4e7c635b88d$export$2e2bcd8739ae039)
    }));
/**![zoom-out](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTYzNyA0NDNIMzI1Yy00LjQgMC04IDMuNi04IDh2NjBjMCA0LjQgMy42IDggOCA4aDMxMmM0LjQgMCA4LTMuNiA4LTh2LTYwYzAtNC40LTMuNi04LTgtOHptMjg0IDQyNEw3NzUgNzIxYzEyMi4xLTE0OC45IDExMy42LTM2OS41LTI2LTUwOS0xNDgtMTQ4LjEtMzg4LjQtMTQ4LjEtNTM3IDAtMTQ4LjEgMTQ4LjYtMTQ4LjEgMzg5IDAgNTM3IDEzOS41IDEzOS42IDM2MC4xIDE0OC4xIDUwOSAyNmwxNDYgMTQ2YzMuMiAyLjggOC4zIDIuOCAxMSAwbDQzLTQzYzIuOC0yLjcgMi44LTcuOCAwLTExek02OTYgNjk2Yy0xMTguOCAxMTguNy0zMTEuMiAxMTguNy00MzAgMC0xMTguNy0xMTguOC0xMTguNy0zMTEuMiAwLTQzMCAxMTguOC0xMTguNyAzMTEuMi0xMTguNyA0MzAgMCAxMTguNyAxMTguOCAxMTguNyAzMTEuMiAwIDQzMHoiIC8+PC9zdmc+) */ const $cf778bd8920077ee$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($cf778bd8920077ee$var$ZoomOutOutlined);
var $cf778bd8920077ee$export$2e2bcd8739ae039 = $cf778bd8920077ee$var$RefIcon;




const $8d63fa2ce3e90264$export$fa2b69b04e5b8fb1 = [
    0.5,
    0.67,
    0.8,
    1,
    1.25,
    1.5,
    2,
    2.5,
    3
];
const $8d63fa2ce3e90264$export$69eb57c05890b16b = $8d63fa2ce3e90264$export$fa2b69b04e5b8fb1[0];
const $8d63fa2ce3e90264$export$d3781d7535f3eda7 = $8d63fa2ce3e90264$export$fa2b69b04e5b8fb1[$8d63fa2ce3e90264$export$fa2b69b04e5b8fb1.length - 1];
const $8d63fa2ce3e90264$export$80ff5834dba7d796 = (zoom)=>Math.min($8d63fa2ce3e90264$export$d3781d7535f3eda7, Math.max($8d63fa2ce3e90264$export$69eb57c05890b16b, zoom));
const $8d63fa2ce3e90264$export$9ba614e489c54e54 = (zoom, direction)=>direction > 0 ? $8d63fa2ce3e90264$export$fa2b69b04e5b8fb1.find((level)=>level > zoom + 0.01) ?? $8d63fa2ce3e90264$export$d3781d7535f3eda7 : [
        ...$8d63fa2ce3e90264$export$fa2b69b04e5b8fb1
    ].reverse().find((level)=>level < zoom - 0.01) ?? $8d63fa2ce3e90264$export$69eb57c05890b16b;
/**
 * Zoom of the sheet (MelodyAnalysis lays the music out again at the new size): zooming in gives larger notes, fewer
 * bars per line and more pages; a page always fits the view, so the sheet never scrolls sideways.
 */ const $8d63fa2ce3e90264$var$SheetZoom = ({ onChange: onChange, zoom: zoom })=>{
    const { t: translate } = (0, $705ab703c44be5bc$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
        "aria-label": translate('sheetZoom.group'),
        className: "flex items-center",
        role: "group",
        children: [
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $1bb718ecb5669b36$export$2e2bcd8739ae039), {
                title: translate('sheetZoom.zoomOut'),
                children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $67d71c16fdfc3a0e$export$2e2bcd8739ae039), {
                    "aria-label": translate('sheetZoom.zoomOut'),
                    disabled: zoom <= $8d63fa2ce3e90264$export$69eb57c05890b16b + 1e-3,
                    icon: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $cf778bd8920077ee$export$2e2bcd8739ae039), {}),
                    onClick: ()=>onChange($8d63fa2ce3e90264$export$9ba614e489c54e54(zoom, -1)),
                    size: "small",
                    type: "text"
                })
            }),
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $1bb718ecb5669b36$export$2e2bcd8739ae039), {
                title: translate('sheetZoom.original'),
                children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)((0, $67d71c16fdfc3a0e$export$2e2bcd8739ae039), {
                    "aria-label": translate('sheetZoom.original'),
                    onClick: ()=>onChange(1),
                    size: "small",
                    style: {
                        fontVariantNumeric: 'tabular-nums',
                        minWidth: 52
                    },
                    type: "text",
                    children: [
                        Math.round(zoom * 100),
                        " %"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $1bb718ecb5669b36$export$2e2bcd8739ae039), {
                title: translate('sheetZoom.zoomIn'),
                children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $67d71c16fdfc3a0e$export$2e2bcd8739ae039), {
                    "aria-label": translate('sheetZoom.zoomIn'),
                    disabled: zoom >= $8d63fa2ce3e90264$export$d3781d7535f3eda7 - 1e-3,
                    icon: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $f4c7cde8fe500b2a$export$2e2bcd8739ae039), {}),
                    onClick: ()=>onChange($8d63fa2ce3e90264$export$9ba614e489c54e54(zoom, 1)),
                    size: "small",
                    type: "text"
                })
            })
        ]
    });
};
const $8d63fa2ce3e90264$var$pageModeKey = 'melodyvis.pageMode';
const $8d63fa2ce3e90264$export$afdcfb9c771acb68 = ()=>{
    try {
        return window.localStorage.getItem($8d63fa2ce3e90264$var$pageModeKey) === 'fit' ? 'fit' : 'a4';
    } catch  {
        return 'a4';
    }
};
const $8d63fa2ce3e90264$export$74e82acf0257e796 = ({ onChange: onChange, pageMode: pageMode })=>{
    const { t: translate } = (0, $705ab703c44be5bc$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $c5c464a2c0131554$export$2e2bcd8739ae039), {
        "aria-label": translate('pageMode.group'),
        onChange: (value)=>{
            try {
                window.localStorage.setItem($8d63fa2ce3e90264$var$pageModeKey, value);
            } catch  {
            // Without storage the choice lasts until the page is reloaded.
            }
            onChange(value);
        },
        options: [
            {
                label: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $1bb718ecb5669b36$export$2e2bcd8739ae039), {
                    title: translate('pageMode.a4Hint'),
                    children: translate('pageMode.a4')
                }),
                value: 'a4'
            },
            {
                label: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $1bb718ecb5669b36$export$2e2bcd8739ae039), {
                    title: translate('pageMode.fitHint'),
                    children: translate('pageMode.fit')
                }),
                value: 'fit'
            }
        ],
        size: "small",
        value: pageMode
    });
};
var $8d63fa2ce3e90264$export$2e2bcd8739ae039 = $8d63fa2ce3e90264$var$SheetZoom;



const $2c02c8dc1811708f$export$37a550b61ef27b21 = 'music-sheet-container';
// Width of an A4 page in staff spaces (OSMD units): a printed score's staff size of about 7 mm.
const $2c02c8dc1811708f$var$a4PageUnits = 120;
/**
 * The white space around the music of every page, in staff spaces (OSMD units; 'compacttight' leaves almost none, so
 * the notes ran to the edges): an A4 page about 12 mm as printed, a fitted page (which scales with the zoom) less. The
 * top margin is the space above the first staff: notes above it reach into the margin a little.
 */ const $2c02c8dc1811708f$var$pageMargins = {
    a4: {
        bottom: 7,
        side: 7,
        top: 8
    },
    fit: {
        bottom: 3,
        side: 3,
        top: 4
    }
};
// The title block of the first page (OSMD units): heights of the title and of the line with artist and year, and the
// space between the block and the first staff (more than a margin: notes above the staff reach into it).
const $2c02c8dc1811708f$var$titleHeight = 3;
const $2c02c8dc1811708f$var$bylineHeight = 2.2;
const $2c02c8dc1811708f$var$titleGap = 6;
// The brace or bracket in front of a system of several staves lies left of the system, in its page's left margin.
const $2c02c8dc1811708f$var$bracketWidth = 1.4;
/** Whether the systems begin with a brace or bracket (several staves, as in piano music, or several instruments). */ const $2c02c8dc1811708f$var$hasBrackets = (openSheetMusicDisplay)=>{
    const instruments = openSheetMusicDisplay.Sheet?.getVisibleInstruments() ?? [];
    return instruments.length > 1 || instruments.some((instrument)=>instrument.Staves.length > 1);
};
// The canvas around an A4 page: its edges never come further into the view than this.
const $2c02c8dc1811708f$var$a4CanvasMargin = 16;
// Dragged this far beyond the edge of a zoomed-in page, the page turns.
const $2c02c8dc1811708f$var$a4TurnOvershoot = 80;
const $2c02c8dc1811708f$export$d6389a1ed25e8b6b = 'ul.ant-pagination';
const $2c02c8dc1811708f$var$maximumHoverDistance = 40;
// A pointer that moves farther than this while pressed grabs the page instead of selecting a note.
const $2c02c8dc1811708f$var$grabThreshold = 8;
/** Arrow keys belong to text fields and sliders while they have the focus (audit ISSUE-011). */ const $2c02c8dc1811708f$var$isTyping = (event)=>{
    const target = event.target;
    return Boolean(target?.closest('input, textarea, select, [contenteditable="true"], [role="slider"], [role="combobox"]'));
};
const $2c02c8dc1811708f$var$AnimatedCircle = (0, $07090e743135ae89$export$2e2bcd8739ae039).circle`
  cx: ${(styles)=>styles.cx};
  cy: ${(styles)=>styles.cy};
  transition-duration: 0.15s;
  transition-property: cx, cy;
`;
const $2c02c8dc1811708f$var$MelodyAnalysis = ({ currentPage: currentPage, hoveredOccurrenceIndex: hoveredOccurrenceIndex, hoveredOccurrences: hoveredOccurrences, hoveredPatternIDs: hoveredPatternIDs, isMusicSheetRendered: isMusicSheetRendered, musicSheets: musicSheets, noteBeamElements: noteBeamElements, noteElements: noteElements, noteStemElements: noteStemElements, numberOfPages: numberOfPages, pageMode: pageMode, patterns: patterns, selectedMusicSheet: selectedMusicSheet, setAbsoluteOffsetPageMap: setAbsoluteOffsetPageMap, setConfiguringID: setConfiguringID, setCurrentPage: setCurrentPage, setHoveredOccurrenceIndex: setHoveredOccurrenceIndex, setHoveredPatternIDs: setHoveredPatternIDs, setIsMusicSheetRendered: setIsMusicSheetRendered, setNewPattern: setNewPattern, setNoteBeamElements: setNoteBeamElements, setNoteElements: setNoteElements, setNoteStemElements: setNoteStemElements, setNumberOfPages: setNumberOfPages, setPatterns: setPatterns, setSelectedMusicSheetID: setSelectedMusicSheetID, setSuggestingID: setSuggestingID, setZoom: setZoom, suggestingID: suggestingID, voices: voices, zoom: zoom })=>{
    const numberOfSkeletonPlaceholders = 7;
    const viewportReference = (0, $5E6i4.useRef)(null);
    const sheetReference = (0, $5E6i4.useRef)(null);
    // The zoom the music is laid out at, the page size it was laid out for and the first note of the page that was on
    // view (to stay there when the music is laid out again).
    const zoomReference = (0, $5E6i4.useRef)(1);
    const renderedSize = (0, $5E6i4.useRef)(undefined);
    const readingOffset = (0, $5E6i4.useRef)(undefined);
    const [renderCount, setRenderCount] = (0, $5E6i4.useState)(0);
    const currentPageReference = (0, $5E6i4.useRef)(currentPage);
    currentPageReference.current = currentPage;
    const numberOfPagesReference = (0, $5E6i4.useRef)(numberOfPages);
    numberOfPagesReference.current = numberOfPages;
    const pageModeReference = (0, $5E6i4.useRef)(pageMode);
    pageModeReference.current = pageMode;
    // The page mode the music was laid out in.
    const renderedMode = (0, $5E6i4.useRef)(pageMode);
    // Where the A4 pages lie on the canvas (top left corner, in pixels of the view).
    const pan = (0, $5E6i4.useRef)({
        x: 0,
        y: 0
    });
    const a4Pages = ()=>Array.from(document.querySelectorAll(`#${$2c02c8dc1811708f$export$37a550b61ef27b21} svg[id^=osmdSvgPage]`));
    /** The size of an A4 page at the zoom: at 100 % the whole page fits the canvas. */ const a4PageSize = ()=>{
        const viewport = viewportReference.current;
        const viewBox = a4Pages()[0]?.getAttribute('viewBox')?.split(' ').map(Number);
        if (!viewport || !viewBox || !(viewBox[2] > 0)) return undefined;
        const ratio = viewBox[3] / viewBox[2];
        const fitted = Math.min(viewport.clientWidth - 2 * $2c02c8dc1811708f$var$a4CanvasMargin, (viewport.clientHeight - 2 * $2c02c8dc1811708f$var$a4CanvasMargin) / ratio);
        const width = Math.max(fitted, 120) * zoomReference.current;
        return {
            height: width * ratio,
            width: width
        };
    };
    /**
   * Puts the pages where `pan` says, kept on the canvas: centred along a side where the page is smaller than the view,
   * otherwise its edges never come further in than the margin.
   */ const placeA4Pages = ()=>{
        const viewport = viewportReference.current;
        const pages = document.getElementById($2c02c8dc1811708f$export$37a550b61ef27b21);
        const size = a4PageSize();
        if (!viewport || !pages || !size || renderedMode.current !== 'a4') return;
        const keep = (value, view, extent)=>extent + 2 * $2c02c8dc1811708f$var$a4CanvasMargin <= view ? (view - extent) / 2 : Math.min($2c02c8dc1811708f$var$a4CanvasMargin, Math.max(view - extent - $2c02c8dc1811708f$var$a4CanvasMargin, value));
        pan.current = {
            x: keep(pan.current.x, viewport.clientWidth, size.width),
            y: keep(pan.current.y, viewport.clientHeight, size.height)
        };
        pages.style.transform = `translate(${pan.current.x}px, ${pan.current.y}px)`;
    };
    /** Sizes the A4 pages for the zoom and the view; the music on them stays as it was laid out. */ const sizeA4Pages = ()=>{
        const pages = document.getElementById($2c02c8dc1811708f$export$37a550b61ef27b21);
        const size = a4PageSize();
        if (!pages || !size || renderedMode.current !== 'a4') return;
        a4Pages().forEach((page)=>{
            page.setAttribute('width', String(size.width));
            page.setAttribute('height', String(size.height));
        });
        pages.style.width = `${size.width}px`;
        placeA4Pages();
    };
    /** Zooms the A4 pages around a point of the view (the pointer; by default the middle of the view). */ const zoomA4At = (target, anchor)=>{
        const viewport = viewportReference.current;
        const before = a4PageSize();
        zoomReference.current = target;
        const after = a4PageSize();
        if (viewport && before && after) {
            const point = anchor ?? {
                x: viewport.clientWidth / 2,
                y: viewport.clientHeight / 2
            };
            const scale = after.width / before.width;
            pan.current = {
                x: point.x - (point.x - pan.current.x) * scale,
                y: point.y - (point.y - pan.current.y) * scale
            };
        }
        sizeA4Pages();
    };
    /** The top of the page (its left edge when zoomed in): where reading goes on after turning a page. */ const showTopOfA4Page = ()=>{
        pan.current = {
            x: Number.POSITIVE_INFINITY,
            y: Number.POSITIVE_INFINITY
        };
        placeA4Pages();
    };
    /** Moves the A4 pages smoothly, e.g. to the notes that sound (score following). */ const glideA4Pages = (move)=>{
        const pages = document.getElementById($2c02c8dc1811708f$export$37a550b61ef27b21);
        pages?.classList.add('is-gliding');
        move();
        window.setTimeout(()=>pages?.classList.remove('is-gliding'), 320);
    };
    const [musicSheetContainerReference, { height: musicSheetContainerHeight, width: musicSheetContainerWidth }] = (0, $5da09a61d0d65faf$export$2e2bcd8739ae039)();
    const [hoveredNote, setHoveredNote] = (0, $5E6i4.useState)();
    const [hoveredNoteContext, setHoveredNoteContext] = (0, $5E6i4.useState)();
    const [isHovering, setIsHovering] = (0, $5E6i4.useState)(false);
    const [noteBeamsOnCurrentPage, setNoteBeamsOnCurrentPage] = (0, $5E6i4.useState)();
    const [noteElementsOnCurrentPage, setNoteElementsOnCurrentPage] = (0, $5E6i4.useState)();
    const [noteStemsOnCurrentPage, setNoteStemsOnCurrentPage] = (0, $5E6i4.useState)();
    const [openSheetMusicDisplay, setOpenSheetMusicDisplay] = (0, $5E6i4.useState)();
    const [patternEndNoteContext, setPatternEndNoteContext] = (0, $5E6i4.useState)();
    const [patternHighlights, setPatternHighlights] = (0, $5E6i4.useState)([]);
    const [patternStartNoteContext, setPatternStartNoteContext] = (0, $5E6i4.useState)();
    const [selection] = (0, $5E6i4.useContext)((0, $ca0029180522dabd$export$7c7a4fd7f1336e2c));
    const [theme] = (0, $5E6i4.useContext)((0, $3c154bbb0fa44c80$export$2c657da244d00bd6));
    const [voiceColoringHitSet, setVoiceColoringHitSet] = (0, $5E6i4.useState)(new Set());
    const highlightSelectedVoice = (noteContextForComparison)=>{
        noteElementsOnCurrentPage.attr('opacity', (noteContext)=>noteContext.voiceNumber === noteContextForComparison.voiceNumber && (0, $60078af3cede2a64$export$d66a0ac0c9083fa1)(noteContext.note.sourceNote) >= (0, $60078af3cede2a64$export$d66a0ac0c9083fa1)(noteContextForComparison.note.sourceNote) ? (0, $9ecda7333d28e490$export$47a4f6ea72e40329) : (0, $9ecda7333d28e490$export$da8fddcadef8a54b));
        const noteElementNumbersInPattern = noteElementsOnCurrentPage.filter((noteContext)=>noteContext === noteContextForComparison || noteContext.voiceNumber === noteContextForComparison.voiceNumber && (0, $60078af3cede2a64$export$d66a0ac0c9083fa1)(noteContext.note.sourceNote) > (0, $60078af3cede2a64$export$d66a0ac0c9083fa1)(noteContextForComparison.note.sourceNote)).nodes().map((node)=>node.id.match(/\d+/)[0]);
        noteStemsOnCurrentPage.attr('opacity', function() {
            const thisNoteNumber = this.id.match(/\d+/)?.[0];
            return noteElementNumbersInPattern.includes(thisNoteNumber) ? (0, $9ecda7333d28e490$export$47a4f6ea72e40329) : (0, $9ecda7333d28e490$export$da8fddcadef8a54b);
        });
        noteBeamsOnCurrentPage.attr('opacity', (0, $9ecda7333d28e490$export$da8fddcadef8a54b));
    };
    (0, $5E6i4.useEffect)(()=>{
        // The fugue of the paper's figures is the default; an imported sheet stays selected when the catalogue reloads.
        if (musicSheets.length > 0 && !selectedMusicSheet) setSelectedMusicSheetID(musicSheets.find((musicSheet)=>musicSheet.title === 'Fugue No. 2 in C Minor (BWV 847)').id);
    }, [
        musicSheets
    ]);
    (0, $8a614d8dd398f993$export$2e2bcd8739ae039)(async ()=>{
        if (selectedMusicSheet) {
            const musicSheetContainer = document.querySelector(`#${$2c02c8dc1811708f$export$37a550b61ef27b21}`);
            musicSheetContainer.innerHTML = '';
            setIsMusicSheetRendered(false);
            setOpenSheetMusicDisplay(undefined);
            setPatterns([]);
            setConfiguringID(undefined);
            setCurrentPage(1);
            setHoveredNote(undefined);
            setHoveredNoteContext(undefined);
            setHoveredOccurrenceIndex(undefined);
            setHoveredPatternIDs([]);
            setNewPattern(undefined);
            setNoteBeamElements(undefined);
            setNoteBeamsOnCurrentPage(undefined);
            setNoteElements(undefined);
            setNoteElementsOnCurrentPage(undefined);
            setNoteStemElements(undefined);
            setNoteStemsOnCurrentPage(undefined);
            setNumberOfPages(undefined);
            setPatternStartNoteContext(undefined);
            setPatternEndNoteContext(undefined);
            setPatternHighlights([]);
            setSuggestingID(undefined);
            setVoiceColoringHitSet(new Set());
            zoomReference.current = 1;
            setZoom(1);
            readingOffset.current = undefined;
            (0, $e5b6a001e5093ab5$export$6be52bf1a7712494).reset();
            renderedMode.current = pageModeReference.current;
            renderedSize.current = await $2c02c8dc1811708f$var$displayMusicSheet(selectedMusicSheet, musicSheetContainer, setOpenSheetMusicDisplay, renderedMode.current);
            // The pages are known once OSMD has drawn them. Waiting for the container's measured size (below) stalled in a
            // tab in the background, which the browser does not render: the notes were never mapped, the saved analysis
            // never restored.
            setNumberOfPages(musicSheetContainer.querySelectorAll(':scope > div').length);
            setIsMusicSheetRendered(true);
        }
    }, [
        selectedMusicSheet
    ]);
    (0, $5E6i4.useEffect)(()=>{
        // Once per rendered sheet (if the pages were not counted after drawing): zooming changes the container's size,
        // which must not return to page 1.
        if (!numberOfPages && musicSheetContainerHeight > 250 && musicSheetContainerWidth > 250) {
            setCurrentPage(1);
            setNumberOfPages(document.querySelectorAll('#music-sheet-container > div').length);
        }
    }, [
        musicSheetContainerHeight,
        musicSheetContainerWidth
    ]);
    (0, $5E6i4.useEffect)(()=>{
        if (isMusicSheetRendered && numberOfPages && voices && !noteElements) {
            const elements = $2c02c8dc1811708f$var$getNoteElements(openSheetMusicDisplay, voices, voiceColoringHitSet, setAbsoluteOffsetPageMap, setVoiceColoringHitSet);
            setNoteElements(elements);
            $2c02c8dc1811708f$var$preparePages(numberOfPages, renderedMode.current);
            if (renderedMode.current === 'a4') {
                // A freshly rendered sheet appears in place: a page turn just before (the first page on opening a sheet) would
                // otherwise let it glide in from the corner while its notes are already measured and pointed at.
                document.getElementById($2c02c8dc1811708f$export$37a550b61ef27b21)?.classList.remove('is-gliding');
                pan.current = {
                    x: Number.POSITIVE_INFINITY,
                    y: Number.POSITIVE_INFINITY
                };
                sizeA4Pages();
            }
            $2c02c8dc1811708f$var$addPatternHighlightContainers(numberOfPages);
            // After the music was laid out again (zoom, size of the view): the page with the music that was on view.
            if (readingOffset.current !== undefined) {
                const page = $2c02c8dc1811708f$var$pageWithOffset(elements, readingOffset.current);
                if (page !== undefined) setCurrentPage(page);
            }
        }
    }, [
        isMusicSheetRendered,
        numberOfPages,
        openSheetMusicDisplay,
        voices,
        renderCount
    ]);
    (0, $5E6i4.useEffect)(()=>{
        if (currentPage !== undefined && noteElements) {
            setNoteBeamElements((0, $a85203b65095458d$export$2e2bcd8739ae039)('svg[id^=osmdSvgPage] > g .vf-beam[id]'));
            setNoteStemElements((0, $a85203b65095458d$export$2e2bcd8739ae039)('svg[id^=osmdSvgPage] > g .vf-stem[id]'));
            setNoteBeamsOnCurrentPage((0, $a85203b65095458d$export$2e2bcd8739ae039)(`${$2c02c8dc1811708f$export$ca52df61d3bbb90(currentPage)} > g .vf-beam[id]`));
            setNoteElementsOnCurrentPage(noteElements.filter(function() {
                return this.ownerSVGElement.id === $2c02c8dc1811708f$var$getPageNameFromNumber(currentPage);
            }));
            setNoteStemsOnCurrentPage((0, $a85203b65095458d$export$2e2bcd8739ae039)(`${$2c02c8dc1811708f$export$ca52df61d3bbb90(currentPage)} > g .vf-stem[id]`));
        }
    }, [
        currentPage,
        noteElements
    ]);
    (0, $5E6i4.useEffect)(()=>{
        if (openSheetMusicDisplay && noteBeamsOnCurrentPage && noteElementsOnCurrentPage && noteStemsOnCurrentPage && patternStartNoteContext !== undefined && patternEndNoteContext === undefined) highlightSelectedVoice(patternStartNoteContext);
    }, [
        noteBeamsOnCurrentPage,
        noteElementsOnCurrentPage,
        noteStemsOnCurrentPage
    ]);
    (0, $5E6i4.useEffect)(()=>{
        if (openSheetMusicDisplay && noteElementsOnCurrentPage) {
            if (selection.focusingID !== undefined) {
                (0, $4506c173c1ba6b79$export$2e2bcd8739ae039)($2c02c8dc1811708f$export$5b67ce9b8df92936(currentPage)).on('click', null).on('mousemove', null);
                return;
            }
            (0, $4506c173c1ba6b79$export$2e2bcd8739ae039)($2c02c8dc1811708f$export$5b67ce9b8df92936(currentPage)).on('click', ()=>{
                if (hoveredPatternIDs.length > 0) {
                    /*
             * We want to configure the shortest pattern because it is the most difficult to interactively select.
             * The longer enclosing patterns can still be configured by hovering near the non-overlapping parts.
             */ const shortestPatternID = $2c02c8dc1811708f$var$getShortestPatternIDFromIDs(hoveredPatternIDs, patterns);
                    setConfiguringID(shortestPatternID);
                    return;
                }
                if (hoveredNoteContext === undefined) return;
                if (patternStartNoteContext === undefined) {
                    setPatternStartNoteContext(hoveredNoteContext);
                    highlightSelectedVoice(hoveredNoteContext);
                } else if (patternEndNoteContext === undefined) {
                    setPatternEndNoteContext(hoveredNoteContext);
                    setHoveredNote(undefined);
                    setHoveredNoteContext(undefined);
                    noteBeamElements.attr('opacity', (0, $9ecda7333d28e490$export$47a4f6ea72e40329));
                    noteElements.attr('opacity', (0, $9ecda7333d28e490$export$47a4f6ea72e40329));
                    noteStemElements.attr('opacity', (0, $9ecda7333d28e490$export$47a4f6ea72e40329));
                }
            }).on('mousemove', (event)=>{
                const { x: x, y: y } = event;
                setIsHovering(true);
                // The note whose head is closest to the pointer. Measuring from the corners of the notes' bounding boxes
                // made the selection jump to notes of other staves (study feedback P5).
                const closest = {
                    distance: $2c02c8dc1811708f$var$maximumHoverDistance
                };
                // After the first click, only later notes of the same voice can end the pattern (audit ISSUE-005).
                const startOffset = patternStartNoteContext ? (0, $60078af3cede2a64$export$d66a0ac0c9083fa1)(patternStartNoteContext.note.sourceNote) : undefined;
                noteElementsOnCurrentPage.each(function(noteContext) {
                    if (patternStartNoteContext && (noteContext.voiceNumber !== patternStartNoteContext.voiceNumber || (0, $60078af3cede2a64$export$d66a0ac0c9083fa1)(noteContext.note.sourceNote) <= startOffset)) return;
                    const head = this.querySelector('g.vf-notehead path') ?? this;
                    const box = head.getBoundingClientRect();
                    const distance = Math.hypot(x - (box.x + box.width / 2), y - (box.y + box.height / 2));
                    if (distance < closest.distance) {
                        closest.context = noteContext;
                        closest.distance = distance;
                        closest.note = this;
                    }
                });
                const hoveredNote = closest.note;
                const hoveredNoteContext = closest.context;
                if (hoveredNote === undefined || hoveredNoteContext === undefined) {
                    setHoveredNote(undefined);
                    setHoveredNoteContext(undefined);
                    return;
                }
                const hasNoVoice = hoveredNoteContext.voiceNumber === undefined;
                const hoveredNoteAbsoluteOffset = (0, $60078af3cede2a64$export$d66a0ac0c9083fa1)(hoveredNoteContext.note.sourceNote);
                const isRest = hoveredNoteContext.note.sourceNote.isRest();
                const enclosingPatterns = patterns.filter((pattern)=>pattern.isVisible).filter((pattern)=>pattern.occurrences.some((occurrence)=>(0, $60078af3cede2a64$export$7a96d400b96d7c37)(hoveredNoteAbsoluteOffset, occurrence.firstOffset, occurrence.lastOffset) && occurrence.voiceNumber === hoveredNoteContext.voiceNumber));
                if ((patternStartNoteContext === undefined || hoveredNoteContext.voiceNumber === patternStartNoteContext?.voiceNumber && hoveredNoteAbsoluteOffset > (0, $60078af3cede2a64$export$d66a0ac0c9083fa1)(patternStartNoteContext.note.sourceNote)) && !hasNoVoice && !isRest && enclosingPatterns.length === 0) {
                    setHoveredNote(hoveredNote);
                    setHoveredNoteContext(hoveredNoteContext);
                    setHoveredOccurrenceIndex(undefined);
                    setHoveredPatternIDs([]);
                } else if (!hasNoVoice && !isRest && enclosingPatterns.length > 0) {
                    const absoluteOffset = (0, $60078af3cede2a64$export$d66a0ac0c9083fa1)(hoveredNoteContext.note.sourceNote);
                    const shortestPatternID = $2c02c8dc1811708f$var$getShortestPatternIDFromIDs(enclosingPatterns.map((pattern)=>pattern.id), patterns);
                    const shortestPattern = patterns.find((pattern)=>pattern.id === shortestPatternID);
                    if (shortestPattern) {
                        setHoveredOccurrenceIndex(shortestPattern.occurrences.findIndex((occurrence)=>occurrence.voiceNumber === hoveredNoteContext.voiceNumber && (0, $60078af3cede2a64$export$7a96d400b96d7c37)(absoluteOffset, occurrence.firstOffset, occurrence.lastOffset)));
                        setHoveredPatternIDs([
                            shortestPatternID
                        ]);
                    } else setHoveredPatternIDs([]);
                    setHoveredNote(undefined);
                    setHoveredNoteContext(undefined);
                } else if (hasNoVoice || isRest || enclosingPatterns.length > 0) {
                    setHoveredNote(undefined);
                    setHoveredNoteContext(undefined);
                    setHoveredOccurrenceIndex(undefined);
                    setHoveredPatternIDs([]);
                }
            }).on('mouseleave', ()=>{
                setHoveredNote(undefined);
                setHoveredNoteContext(undefined);
                setHoveredOccurrenceIndex(undefined);
                setHoveredPatternIDs([]);
                setIsHovering(false);
            });
        }
    }, [
        currentPage,
        hoveredNote,
        hoveredNoteContext,
        hoveredPatternIDs,
        noteBeamsOnCurrentPage,
        noteElementsOnCurrentPage,
        noteStemsOnCurrentPage,
        openSheetMusicDisplay,
        patterns,
        patternStartNoteContext,
        patternEndNoteContext,
        selection.focusingID
    ]);
    (0, $370fd9796cc17e68$export$2e2bcd8739ae039)((event)=>event.key === 'Escape', ()=>{
        if (patternStartNoteContext !== undefined && patternEndNoteContext === undefined) {
            setHoveredNote(undefined);
            setHoveredNoteContext(undefined);
            setPatternStartNoteContext(undefined);
            noteBeamElements.attr('opacity', (0, $9ecda7333d28e490$export$47a4f6ea72e40329));
            noteElements.attr('opacity', (0, $9ecda7333d28e490$export$47a4f6ea72e40329));
            noteStemElements.attr('opacity', (0, $9ecda7333d28e490$export$47a4f6ea72e40329));
        }
    }, {
        event: 'keyup'
    });
    (0, $5E6i4.useEffect)(()=>{
        if (openSheetMusicDisplay && noteElements) {
            noteElements.selectAll('g.vf-note g.vf-notehead path')// Replicate the note context for each path in the note, e.g., for each note in a chord.
            .data((noteContext, _, paths)=>Array.from(paths).map(()=>noteContext)).attr('fill', (noteContext)=>theme.colorVoices ? voices.find((voice)=>voice.number === noteContext.voiceNumber)?.color : 'black');
            if (theme.colorVoices) (0, $a85203b65095458d$export$2e2bcd8739ae039)(`.${(0, $2a70544114aeb517$export$e91d549d49c2dc53)}`).lower();
            else (0, $a85203b65095458d$export$2e2bcd8739ae039)(`.${(0, $2a70544114aeb517$export$e91d549d49c2dc53)}`).raise();
        }
    }, [
        theme.colorVoices,
        noteElements,
        openSheetMusicDisplay,
        voices
    ]);
    (0, $5E6i4.useEffect)(()=>{
        if (selection.focusingID === undefined) {
            (0, $4506c173c1ba6b79$export$2e2bcd8739ae039)($2c02c8dc1811708f$export$5b67ce9b8df92936(currentPage)).classed('cursor-default', false);
            (0, $4506c173c1ba6b79$export$2e2bcd8739ae039)($2c02c8dc1811708f$export$5b67ce9b8df92936(currentPage)).classed('cursor-pointer', true);
        } else {
            (0, $4506c173c1ba6b79$export$2e2bcd8739ae039)($2c02c8dc1811708f$export$5b67ce9b8df92936(currentPage)).classed('cursor-default', true);
            (0, $4506c173c1ba6b79$export$2e2bcd8739ae039)($2c02c8dc1811708f$export$5b67ce9b8df92936(currentPage)).classed('cursor-pointer', false);
        }
    }, [
        selection.focusingID
    ]);
    (0, $5E6i4.useEffect)(()=>{
        if (patternStartNoteContext !== undefined && patternEndNoteContext !== undefined) {
            const firstOffset = (0, $60078af3cede2a64$export$d66a0ac0c9083fa1)(patternStartNoteContext.note.sourceNote);
            const lastOffset = (0, $60078af3cede2a64$export$d66a0ac0c9083fa1)(patternEndNoteContext.note.sourceNote);
            const voiceNumber = patternStartNoteContext.voiceNumber;
            const noteContexts = noteElements.data().filter((noteContext)=>noteContext.voiceNumber === voiceNumber);
            const patternLength = noteContexts.findIndex((noteContext)=>noteContext === patternEndNoteContext) - noteContexts.findIndex((noteContext)=>noteContext === patternStartNoteContext) + 1;
            const newPattern = {
                color: theme.colorByVoice ? theme.getVoiceColor(voiceNumber) : theme.availablePatternColors.pop(),
                connectedToByOccurrences: [],
                connectedToByOperator: [],
                description: undefined,
                hasBeenQueried: false,
                id: (0, $cc904d2b6f5c076b$export$2e2bcd8739ae039)(),
                isLocked: false,
                isUserDefined: true,
                isVisible: true,
                label: (0, $e5b6a001e5093ab5$export$6be52bf1a7712494).next(),
                length: patternLength,
                occurrences: [
                    {
                        firstOffset: firstOffset,
                        lastOffset: lastOffset,
                        voiceNumber: voiceNumber
                    }
                ],
                uniqueOccurrencesCount: 1,
                voiceNumber: voiceNumber
            };
            setNewPattern(newPattern);
            // A pattern whose suggestions are still open stays: selecting the next pattern used to delete it silently.
            setPatterns((oldPatterns)=>[
                    ...oldPatterns,
                    newPattern
                ]);
            setConfiguringID(newPattern.id);
            setSuggestingID(newPattern.id);
            setPatternStartNoteContext(undefined);
            setPatternEndNoteContext(undefined);
        }
    }, [
        patternEndNoteContext,
        patternStartNoteContext
    ]);
    (0, $5E6i4.useEffect)(()=>{
        if (openSheetMusicDisplay && noteElements) {
            // Also while voices are coloured; only the stacking order differs (audit ISSUE-013).
            setPatternHighlights($2c02c8dc1811708f$var$computePatternHighlights(noteElements, patterns, selection.focusingID));
            if (patterns.length === 0) (0, $e5b6a001e5093ab5$export$6be52bf1a7712494).reset();
        }
    }, [
        patterns,
        selection.focusingID,
        noteElements
    ]);
    (0, $370fd9796cc17e68$export$2e2bcd8739ae039)((event)=>event.key === 'ArrowRight' && !$2c02c8dc1811708f$var$isTyping(event), ()=>{
        if (currentPage < numberOfPages) setCurrentPage(currentPage + 1);
    }, {
        event: 'keyup'
    });
    (0, $370fd9796cc17e68$export$2e2bcd8739ae039)((event)=>event.key === 'ArrowLeft' && !$2c02c8dc1811708f$var$isTyping(event), ()=>{
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    }, {
        event: 'keyup'
    });
    (0, $5E6i4.useEffect)(()=>{
        for(let pageNumber = 1; pageNumber <= numberOfPages; pageNumber++){
            const pageContainer = document.querySelector(`#osmdCanvasPage${pageNumber}`);
            if (pageContainer === null) continue;
            // All pages share one place (layout.css); only the current one shows and takes the pointer. The others keep
            // their layout, so their highlights and notes can still be measured.
            pageContainer.style.visibility = pageNumber === currentPage ? 'visible' : 'hidden';
        }
    }, [
        currentPage,
        numberOfPages,
        renderCount
    ]);
    (0, $5E6i4.useEffect)(()=>{
        if (renderedMode.current === 'a4') glideA4Pages(showTopOfA4Page);
    }, [
        currentPage
    ]);
    /**
   * Lays the music out again at the zoom, with pages that fill the view: zooming in gives fewer bars per line and more
   * pages, never a sideways scroll. The page with the music that was on view stays on view. Unless `force`, only when
   * the view changed its size.
   */ const layOut = (force)=>{
        const pages = document.querySelector(`#${$2c02c8dc1811708f$export$37a550b61ef27b21}`);
        if (!openSheetMusicDisplay || !isMusicSheetRendered || !pages) return;
        const mode = pageModeReference.current;
        // An A4 page keeps its music when the view changes its size: it is only scaled.
        if (!force && mode === 'a4' && renderedMode.current === 'a4') {
            sizeA4Pages();
            return;
        }
        // A4 gave the pages a width of their own (sizeA4Pages); fitted pages take the view's.
        if (mode === 'fit') pages.style.width = '';
        const size = $2c02c8dc1811708f$var$pageFormatOf(pages);
        const previous = renderedSize.current;
        if (!force && previous && Math.abs(size.width - previous.width) < 8 && Math.abs(size.height - previous.height) < 8) return;
        const shown = noteElementsOnCurrentPage?.data().map((noteContext)=>(0, $60078af3cede2a64$export$d66a0ac0c9083fa1)(noteContext.note.sourceNote)) ?? [];
        if (shown.length > 0) readingOffset.current = Math.min(...shown);
        // The notes are drawn anew: a selection in progress and everything bound to the old notes go.
        setPatternStartNoteContext(undefined);
        setPatternEndNoteContext(undefined);
        setHoveredNote(undefined);
        setHoveredNoteContext(undefined);
        setNoteElements(undefined);
        setNoteElementsOnCurrentPage(undefined);
        setNoteBeamElements(undefined);
        setNoteBeamsOnCurrentPage(undefined);
        setNoteStemElements(undefined);
        setNoteStemsOnCurrentPage(undefined);
        setPatternHighlights([]);
        setVoiceColoringHitSet(new Set());
        $2c02c8dc1811708f$var$applyPageLayout(openSheetMusicDisplay, pages, mode, size, zoomReference.current);
        openSheetMusicDisplay.render();
        renderedMode.current = mode;
        renderedSize.current = size;
        pages.style.transform = '';
        setNumberOfPages(pages.querySelectorAll(':scope > div').length);
        setRenderCount((count)=>count + 1);
    };
    const layOutReference = (0, $5E6i4.useRef)(layOut);
    layOutReference.current = layOut;
    (0, $5E6i4.useEffect)(()=>{
        // An A4 page is only scaled, around the middle of the view (the wheel zooms it around the pointer itself).
        if (renderedMode.current === 'a4' && openSheetMusicDisplay && isMusicSheetRendered) {
            if (Math.abs(zoom - zoomReference.current) > 1e-3) zoomA4At(zoom);
            return;
        }
        zoomReference.current = zoom;
        if (openSheetMusicDisplay && isMusicSheetRendered && Math.abs(openSheetMusicDisplay.Zoom - zoom) > 1e-3) layOut(true);
    }, [
        zoom
    ]);
    (0, $5E6i4.useEffect)(()=>{
        if (openSheetMusicDisplay && isMusicSheetRendered && renderedMode.current !== pageMode) layOut(true);
    }, [
        pageMode
    ]);
    // Ctrl (or Cmd) and the mouse wheel, or pinching on a touchpad, zoom instead of the browser. While the wheel turns,
    // fitted pages are scaled around the pointer as a preview and the music is laid out when it rests; an A4 page zooms
    // around the pointer at once. On the A4 canvas the wheel alone moves the page (Shift: sideways).
    (0, $5E6i4.useEffect)(()=>{
        const viewport = viewportReference.current;
        if (!viewport) return;
        let target;
        let timer;
        const onWheel = (event)=>{
            if (renderedMode.current === 'a4' && pageModeReference.current === 'a4') {
                const bounds = viewport.getBoundingClientRect();
                if (event.ctrlKey || event.metaKey) {
                    event.preventDefault();
                    target = (0, $8d63fa2ce3e90264$export$80ff5834dba7d796)((target ?? zoomReference.current) * Math.exp(-event.deltaY * 0.002));
                    zoomA4At(Math.round(target * 100) / 100, {
                        x: event.clientX - bounds.left,
                        y: event.clientY - bounds.top
                    });
                    window.clearTimeout(timer);
                    timer = window.setTimeout(()=>{
                        target = undefined;
                        setZoom(zoomReference.current);
                    }, 150);
                    return;
                }
                const unit = event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? viewport.clientHeight : 1;
                const dx = (event.shiftKey ? event.deltaY : event.deltaX) * unit;
                const dy = (event.shiftKey ? 0 : event.deltaY) * unit;
                const before = {
                    ...pan.current
                };
                pan.current = {
                    x: pan.current.x - dx,
                    y: pan.current.y - dy
                };
                placeA4Pages();
                // A page that fits the view does not move: the wheel then scrolls what is around the sheet.
                if (pan.current.x !== before.x || pan.current.y !== before.y) event.preventDefault();
                return;
            }
            if (!event.ctrlKey && !event.metaKey) return;
            event.preventDefault();
            target = (0, $8d63fa2ce3e90264$export$80ff5834dba7d796)((target ?? zoomReference.current) * Math.exp(-event.deltaY * 0.002));
            const pages = viewport.firstElementChild;
            if (pages) {
                const bounds = viewport.getBoundingClientRect();
                pages.style.transformOrigin = `${event.clientX - bounds.left}px ${event.clientY - bounds.top + viewport.scrollTop}px`;
                pages.style.transform = `scale(${target / zoomReference.current})`;
            }
            window.clearTimeout(timer);
            timer = window.setTimeout(()=>{
                const zoomed = Math.round((target ?? zoomReference.current) * 100) / 100;
                target = undefined;
                if (Math.abs(zoomed - zoomReference.current) < 0.005) {
                    if (pages) pages.style.transform = '';
                } else setZoom(zoomed);
            }, 250);
        };
        viewport.addEventListener('wheel', onWheel, {
            passive: false
        });
        return ()=>{
            viewport.removeEventListener('wheel', onWheel);
            window.clearTimeout(timer);
        };
    }, []);
    // A page fills the view: when the view changes its size (window, browser zoom, layout), the music is laid out again
    // (an A4 page is sized anew).
    (0, $5E6i4.useEffect)(()=>{
        const sheet = sheetReference.current;
        if (!sheet) return;
        let timer;
        const observer = new ResizeObserver(()=>{
            window.clearTimeout(timer);
            timer = window.setTimeout(()=>layOutReference.current(false), 250);
        });
        observer.observe(sheet);
        return ()=>{
            observer.disconnect();
            window.clearTimeout(timer);
        };
    }, []);
    (0, $370fd9796cc17e68$export$2e2bcd8739ae039)((event)=>[
            '+',
            '-',
            '0'
        ].includes(event.key) && !event.ctrlKey && !event.metaKey && !event.altKey && !$2c02c8dc1811708f$var$isTyping(event), (event)=>{
        if (event.key === '+') setZoom((0, $8d63fa2ce3e90264$export$9ba614e489c54e54)(zoomReference.current, 1));
        else if (event.key === '-') setZoom((0, $8d63fa2ce3e90264$export$9ba614e489c54e54)(zoomReference.current, -1));
        else setZoom(1);
    });
    // Grabbing the page: dragged sideways it turns like a page of a book (next page to the left); a page taller than the
    // view (zoomed in) moves up and down with it. On the A4 canvas a page larger than the view moves with the pointer in
    // every direction, and turns when it is dragged on beyond its edge. A click without moving still selects notes.
    (0, $5E6i4.useEffect)(()=>{
        const viewport = viewportReference.current;
        if (!viewport) return;
        let start;
        let isGrabbing = false;
        let wasGrabbed = false;
        // How far a zoomed-in A4 page was dragged beyond its edge (negative: to the left).
        let overshoot = 0;
        const page = ()=>document.querySelector(`#osmdCanvasPage${currentPageReference.current}`);
        const isA4 = ()=>renderedMode.current === 'a4' && pageModeReference.current === 'a4';
        // A page that fits the view sideways turns when dragged sideways; a larger one moves.
        const fitsSideways = ()=>{
            const size = a4PageSize();
            return !size || size.width + 2 * $2c02c8dc1811708f$var$a4CanvasMargin <= viewport.clientWidth;
        };
        const isAtEnd = (dx)=>dx > 0 && currentPageReference.current <= 1 || dx < 0 && currentPageReference.current >= (numberOfPagesReference.current ?? 1);
        const onPointerDown = (event)=>{
            if (event.button !== 0) return;
            start = {
                pan: {
                    ...pan.current
                },
                pointerId: event.pointerId,
                scrollTop: viewport.scrollTop,
                time: event.timeStamp,
                x: event.clientX,
                y: event.clientY
            };
            isGrabbing = false;
            overshoot = 0;
        };
        const onPointerMove = (event)=>{
            if (!start || event.pointerId !== start.pointerId) return;
            const dx = event.clientX - start.x;
            const dy = event.clientY - start.y;
            if (!isGrabbing && Math.hypot(dx, dy) < $2c02c8dc1811708f$var$grabThreshold) return;
            if (!isGrabbing) {
                isGrabbing = true;
                viewport.setPointerCapture(event.pointerId);
                viewport.classList.add('is-grabbing');
            }
            const grabbed = page();
            if (isA4()) {
                const turnsSideways = fitsSideways();
                const wanted = {
                    x: turnsSideways ? pan.current.x : start.pan.x + dx,
                    y: start.pan.y + dy
                };
                pan.current = wanted;
                placeA4Pages();
                // Beyond its edge the page follows halfway (a quarter at the first and the last page).
                overshoot = turnsSideways ? dx : wanted.x - pan.current.x;
                const follows = overshoot / (isAtEnd(overshoot) ? 4 : turnsSideways ? 1 : 2);
                if (grabbed) grabbed.style.transform = overshoot ? `translateX(${follows}px)` : '';
                return;
            }
            // The first and the last page resist: there is no page to turn to.
            if (grabbed) grabbed.style.transform = `translateX(${isAtEnd(dx) ? dx / 4 : dx}px)`;
            viewport.scrollTop = start.scrollTop - dy;
        };
        const onPointerUp = (event)=>{
            if (!start || event.pointerId !== start.pointerId) return;
            if (isGrabbing) {
                const isZoomedIn = isA4() && !fitsSideways();
                const dx = isA4() ? overshoot : event.clientX - start.x;
                const speed = Math.abs(dx) / Math.max(1, event.timeStamp - start.time);
                const turns = isZoomedIn ? Math.abs(dx) > $2c02c8dc1811708f$var$a4TurnOvershoot : Math.abs(dx) > Math.min(120, viewport.clientWidth * 0.15) || Math.abs(dx) > 30 && speed > 0.5;
                const grabbed = page();
                if (grabbed) grabbed.style.transform = '';
                viewport.classList.remove('is-grabbing');
                wasGrabbed = true;
                if (turns && dx < 0) setCurrentPage((current)=>Math.min(current + 1, numberOfPagesReference.current ?? 1));
                if (turns && dx > 0) setCurrentPage((current)=>Math.max(current - 1, 1));
            }
            start = undefined;
            isGrabbing = false;
        };
        // Releasing a grabbed page ends with a click, which must not select a note.
        const onClick = (event)=>{
            if (!wasGrabbed) return;
            wasGrabbed = false;
            event.stopPropagation();
            event.preventDefault();
        };
        // Score following on the A4 canvas: the page moves so that the notes that sound are in the middle of the view.
        const onReveal = (event)=>{
            if (!isA4()) return;
            const view = viewport.getBoundingClientRect();
            const note = event.detail.getBoundingClientRect();
            glideA4Pages(()=>{
                pan.current = {
                    x: pan.current.x + view.left + view.width / 2 - (note.left + note.width / 2),
                    y: pan.current.y + view.top + view.height / 2 - (note.top + note.height / 2)
                };
                placeA4Pages();
            });
        };
        viewport.addEventListener('pointerdown', onPointerDown);
        viewport.addEventListener('pointermove', onPointerMove);
        viewport.addEventListener('pointerup', onPointerUp);
        viewport.addEventListener('pointercancel', onPointerUp);
        viewport.addEventListener('click', onClick, true);
        viewport.addEventListener((0, $4276fbe97a4bd973$export$81aa32e9df80256d), onReveal);
        return ()=>{
            viewport.removeEventListener('pointerdown', onPointerDown);
            viewport.removeEventListener('pointermove', onPointerMove);
            viewport.removeEventListener('pointerup', onPointerUp);
            viewport.removeEventListener('pointercancel', onPointerUp);
            viewport.removeEventListener('click', onClick, true);
            viewport.removeEventListener((0, $4276fbe97a4bd973$export$81aa32e9df80256d), onReveal);
        };
    }, []);
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
        className: "relative flex min-h-0 flex-col text-center",
        ref: sheetReference,
        style: {
            flex: 10
        },
        children: [
            !isMusicSheetRendered ? /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("div", {
                className: "flex flex-col items-center animate-pulse",
                children: [
                    ...Array(numberOfSkeletonPlaceholders)
                ].map((_, index)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("div", {
                        className: "w-4/5 h-24 mb-3 mt-3 rounded-md bg-gray-200"
                    }, index))
            }) : undefined,
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("div", {
                className: `melodyvis-sheet-viewport min-h-0 ${pageMode === 'a4' ? 'is-a4' : ''} ${isMusicSheetRendered ? 'flex-1' : 'h-0 invisible'}`,
                ref: viewportReference,
                children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("div", {
                    className: "melodyvis-sheet-pages",
                    id: $2c02c8dc1811708f$export$37a550b61ef27b21,
                    ref: musicSheetContainerReference
                })
            }),
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($2c02c8dc1811708f$var$HoveredNoteIndicator, {
                currentPage: currentPage,
                hoveredNote: hoveredNote,
                hoveredNoteContext: hoveredNoteContext
            }),
            patternHighlights.map((patternHighlight)=>{
                // The highlights are recomputed after the patterns changed: for one render they may still list a pattern
                // that was just discarded or deleted.
                const pattern = patterns.find((candidate)=>candidate.id === patternHighlight.id);
                if (pattern === undefined) return null;
                return patternHighlight.segments.map((segment, segmentIndex)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $2a70544114aeb517$export$2e2bcd8739ae039), {
                        color: patternHighlight.color,
                        colorOpacity: theme.colorVoices ? (0, $9ecda7333d28e490$export$e33e649b64add65d) : (0, $9ecda7333d28e490$export$7395e4cb572e863b),
                        coordinates: segment.points,
                        hasEllipsisLeft: segmentIndex > 0 && patternHighlight.segments[segmentIndex - 1].occurrenceIndex === segment.occurrenceIndex,
                        hasEllipsisRight: segmentIndex < patternHighlight.segments.length - 1 && patternHighlight.segments[segmentIndex + 1].occurrenceIndex === segment.occurrenceIndex,
                        hoveredOccurrenceIndex: hoveredOccurrenceIndex,
                        hoveredOccurrences: hoveredOccurrences,
                        hoveredPatternIDs: hoveredPatternIDs,
                        id: patternHighlight.id,
                        occurrenceIndex: segment.occurrenceIndex,
                        page: segment.page,
                        pattern: pattern,
                        shouldShowTooltip: isHovering
                    }, `${patternHighlight.id}-${segmentIndex}`));
            })
        ]
    });
};
const $2c02c8dc1811708f$var$HoveredNoteIndicator = ({ currentPage: currentPage, hoveredNote: hoveredNote, hoveredNoteContext: hoveredNoteContext })=>{
    const [theme] = (0, $5E6i4.useContext)((0, $3c154bbb0fa44c80$export$2c657da244d00bd6));
    if (hoveredNote === undefined) return null;
    hoveredNote = hoveredNote.querySelector('g.vf-notehead path');
    const page = document.querySelector($2c02c8dc1811708f$export$5b67ce9b8df92936(currentPage));
    const { height: height, width: width, x: x, y: y } = hoveredNote.getBBox();
    if (page === null) return null;
    return /*#__PURE__*/ (0, $ibUU1.createPortal)(/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($2c02c8dc1811708f$var$AnimatedCircle, {
        cx: x + width / 2,
        cy: y + height / 2,
        fill: theme.colorByVoice ? theme.getVoiceColor(hoveredNoteContext.voiceNumber) : theme.availablePatternColors[theme.availablePatternColors.length - 1],
        fillOpacity: (0, $9ecda7333d28e490$export$7395e4cb572e863b),
        r: 10
    }), page);
};
const $2c02c8dc1811708f$var$addPatternHighlightContainers = (numberOfPages)=>{
    for(let pageNumber = 1; pageNumber <= numberOfPages; pageNumber++){
        const pageContent = document.querySelector($2c02c8dc1811708f$export$5b67ce9b8df92936(pageNumber));
        if (pageContent === null) continue;
        const patternHighlightContainer = document.createElementNS('http://www.w3.org/2000/svg', 'g');
        patternHighlightContainer.id = `${$2c02c8dc1811708f$var$getPageNameFromNumber(pageNumber)}-pattern-highlights`;
        // Highlights are no keyboard stops: with patterns shown, Tab stopped on the containers of every page.
        patternHighlightContainer.setAttribute('tabindex', '-1');
        pageContent.prepend(patternHighlightContainer);
    }
};
const $2c02c8dc1811708f$var$computePatternHighlights = (noteElements, patterns, focusingID)=>{
    if (patterns.length === 0) return [];
    const patternHighlights = {};
    patterns.filter((pattern)=>pattern.isVisible && (focusingID === undefined || focusingID === pattern.id)).forEach((pattern)=>{
        pattern.occurrences.forEach((occurrence, occurrenceIndex)=>$2c02c8dc1811708f$var$computePatternHighlightSegments(noteElements, pattern.color, patternHighlights, pattern.id, occurrence, occurrenceIndex));
    });
    return Object.values(patternHighlights);
};
const $2c02c8dc1811708f$var$computePatternHighlightSegments = (noteElements, patternColor, patternHighlights, patternID, occurrence, occurrenceIndex)=>noteElements.filter((noteContext)=>{
        const absoluteOffset = (0, $60078af3cede2a64$export$d66a0ac0c9083fa1)(noteContext.note.sourceNote);
        const matchesOffset = (0, $60078af3cede2a64$export$7a96d400b96d7c37)(absoluteOffset, occurrence.firstOffset, occurrence.lastOffset);
        const occursInVoice = occurrence.voiceNumber === noteContext.voiceNumber;
        return occursInVoice && matchesOffset;
    }).sort((firstNoteContext, secondNoteContext)=>(0, $60078af3cede2a64$export$d66a0ac0c9083fa1)(firstNoteContext.note.sourceNote) - (0, $60078af3cede2a64$export$d66a0ac0c9083fa1)(secondNoteContext.note.sourceNote)).each((noteContext, index, nodes)=>{
        const node = nodes[index];
        const page = document.getElementById(`${node.viewportElement.id}-pattern-highlights`);
        const boundingBox = node.querySelector('g.vf-notehead path').getBBox();
        const centerX = boundingBox.x + boundingBox.width / 2;
        const centerY = boundingBox.y + boundingBox.height / 2;
        const rightX = boundingBox.x + boundingBox.width;
        const system = noteContext.note.parentVoiceEntry?.parentStaffEntry?.parentMeasure?.ParentMusicSystem;
        if (patternHighlights[patternID] !== undefined) {
            const numberOfSegments = patternHighlights[patternID].segments.length;
            const lastSegment = patternHighlights[patternID].segments[numberOfSegments - 1];
            // A segment stays in one line of music: the next line (or page) begins a new one, even where its first note is
            // further right than the last note of the line before (a voice that rests there), which drew a bar across.
            if (lastSegment.points[lastSegment.points.length - 1][0] > rightX || lastSegment.page !== page || system !== undefined && lastSegment.system !== system || occurrenceIndex !== patternHighlights[patternID].segments[numberOfSegments - 1].occurrenceIndex) patternHighlights[patternID].segments.push({
                occurrenceIndex: occurrenceIndex,
                page: page,
                points: [
                    [
                        centerX,
                        centerY
                    ]
                ],
                system: system
            });
            else patternHighlights[patternID].segments[numberOfSegments - 1].points.push([
                centerX,
                centerY
            ]);
        } else patternHighlights[patternID] = {
            color: patternColor,
            id: patternID,
            segments: [
                {
                    occurrenceIndex: occurrenceIndex,
                    page: page,
                    points: [
                        [
                            centerX,
                            centerY
                        ]
                    ],
                    system: system
                }
            ]
        };
    });
/** The page format that fills the sheet's view (at most the visible height in the one-column layout). */ const $2c02c8dc1811708f$var$pageFormatOf = (pages)=>{
    const column = pages.closest('.melodyvis-sheet-column');
    const height = Math.min(column?.clientHeight ?? window.innerHeight, window.innerHeight - 80) - 24;
    return {
        height: Math.max(height, 200),
        width: Math.max(pages.offsetWidth, 200)
    };
};
/**
 * The page format and OSMD zoom of a layout. OSMD makes a page as wide as its container (in units: width / zoom / 10)
 * and as high as the format's aspect ratio says: an A4 page is laid out a4PageUnits wide whatever the view, a fitted
 * page fills the view at the zoom.
 */ const $2c02c8dc1811708f$var$applyPageLayout = (openSheetMusicDisplay, pages, mode, size, zoom)=>{
    const rules = openSheetMusicDisplay.EngravingRules;
    const margins = $2c02c8dc1811708f$var$pageMargins[mode];
    rules.PageLeftMargin = margins.side + ($2c02c8dc1811708f$var$hasBrackets(openSheetMusicDisplay) ? $2c02c8dc1811708f$var$bracketWidth : 0);
    rules.PageRightMargin = margins.side;
    rules.PageBottomMargin = margins.bottom;
    // 'compacttight' places the first staff of a page at the narrow top margin.
    rules.PageTopMargin = margins.top;
    rules.PageTopMarginNarrow = margins.top;
    // The title starts at the top margin; OSMD puts the first staff at the top margin plus the title's distances.
    rules.TitleTopDistance = margins.top;
    rules.TitleBottomDistance = rules.RenderSubtitle ? $2c02c8dc1811708f$var$titleGap - margins.top + rules.SheetMinimumDistanceBetweenTitleAndSubtitle + $2c02c8dc1811708f$var$bylineHeight : $2c02c8dc1811708f$var$titleGap - margins.top;
    if (mode === 'a4') {
        // On the canvas the pages take no width from the view (layout.css): OSMD, which clears them before it measures,
        // gets one of its own.
        pages.style.width = `${Math.max(pages.parentElement?.clientWidth ?? 0, 600)}px`;
        openSheetMusicDisplay.Zoom = pages.offsetWidth / (10 * $2c02c8dc1811708f$var$a4PageUnits);
        openSheetMusicDisplay.setCustomPageFormat(210, 297);
    } else {
        openSheetMusicDisplay.Zoom = zoom;
        openSheetMusicDisplay.setCustomPageFormat(size.width, size.height);
    }
};
const $2c02c8dc1811708f$var$yearPattern = /^(1[4-9]\d\d|20\d\d)$/;
const $2c02c8dc1811708f$export$57cbac366909837b = (musicXML)=>{
    if (!musicXML) return undefined;
    const texts = Array.from(musicXML.matchAll(/<(credit-words|work-title|movement-title)\b[^>]*>([^<]*)</g), (match)=>match[2].trim());
    return texts.find((text)=>$2c02c8dc1811708f$var$yearPattern.test(text)) ?? texts.map((text)=>text.match(/\((1[4-9]\d\d|20\d\d)\)/)?.[1]).find(Boolean);
};
const $2c02c8dc1811708f$export$4be858f36b69cc02 = (musicSheet)=>{
    const composer = musicSheet.composer?.trim();
    const artist = composer && !/^unknown$/i.test(composer) ? composer : undefined;
    return {
        byline: [
            artist,
            $2c02c8dc1811708f$export$57cbac366909837b(musicSheet.musicXML)
        ].filter(Boolean).join(" \xb7 "),
        title: musicSheet.title?.trim() ?? ''
    };
};
/**
 * OSMD draws the title block on the first page, centred above the music: the catalogue's title, below it the artist
 * and the year (the MusicXML's own credits stay off, they repeat or contradict the catalogue). Part of the page's SVG,
 * so it scales and moves with the page and the highlights stay on their notes.
 */ const $2c02c8dc1811708f$var$showTitleBlock = (openSheetMusicDisplay, musicSheet)=>{
    const { byline: byline, title: title } = $2c02c8dc1811708f$export$4be858f36b69cc02(musicSheet);
    const rules = openSheetMusicDisplay.EngravingRules;
    const sheet = openSheetMusicDisplay.Sheet;
    rules.SheetTitleHeight = $2c02c8dc1811708f$var$titleHeight;
    rules.SheetSubtitleHeight = $2c02c8dc1811708f$var$bylineHeight;
    rules.RenderTitle = title.length > 0;
    rules.RenderSubtitle = title.length > 0 && byline.length > 0;
    rules.RenderComposer = false;
    rules.RenderLyricist = false;
    rules.RenderCopyright = false;
    if (title) sheet.TitleString = title;
    if (byline) sheet.SubtitleString = byline;
};
/** Renders the sheet at its original size, on A4 pages or on pages that fill the view; returns the page size. */ const $2c02c8dc1811708f$var$displayMusicSheet = async (musicSheet, musicSheetContainer, setOpenSheetMusicDisplay, mode)=>{
    if (musicSheet) {
        const openSheetMusicDisplay = new (0, $4c574b2b3c7bfc41$exports.OpenSheetMusicDisplay)(musicSheetContainer, {
            autoResize: false,
            drawingParameters: 'compacttight'
        });
        await openSheetMusicDisplay.load(musicSheet.musicXML);
        $2c02c8dc1811708f$var$showTitleBlock(openSheetMusicDisplay, musicSheet);
        const size = $2c02c8dc1811708f$var$pageFormatOf(musicSheetContainer);
        $2c02c8dc1811708f$var$applyPageLayout(openSheetMusicDisplay, musicSheetContainer, mode, size, 1);
        openSheetMusicDisplay.render();
        setOpenSheetMusicDisplay(openSheetMusicDisplay);
        return size;
    }
};
/** The page of the first note at or after the offset. */ const $2c02c8dc1811708f$var$pageWithOffset = (elements, offset)=>{
    let first;
    elements.each(function(noteContext) {
        const noteOffset = (0, $60078af3cede2a64$export$d66a0ac0c9083fa1)(noteContext.note.sourceNote);
        if (noteOffset < offset - 1e-6 || first && first.offset <= noteOffset) return;
        first = {
            offset: noteOffset,
            page: Number(this.ownerSVGElement.id.match(/\d+/)[0])
        };
    });
    return first?.page;
};
const $2c02c8dc1811708f$var$getNoteElements = (openSheetMusicDisplay, voices, voiceColoringHitSet, setAbsoluteOffsetPageMap, setVoiceColoringHitSet)=>{
    const absoluteOffsetPageMap = new Map();
    const elements = [];
    const noteContexts = [];
    openSheetMusicDisplay.GraphicSheet.MeasureList.forEach((system)=>{
        system.forEach((measure)=>{
            // Staves without a measure here and notes OSMD does not draw individually (e.g. inside multi-measure rests)
            // have no SVG element; they crashed the app (audit finding F17, Symphony No. 5).
            measure?.staffEntries.forEach((staffEntry)=>{
                staffEntry.graphicalVoiceEntries.forEach((graphicalVoiceEntry)=>{
                    graphicalVoiceEntry.notes.forEach((note)=>{
                        const vexFlowNote = note;
                        const element = vexFlowNote.vfnote?.[0]?.getAttribute('el');
                        if (!element?.ownerSVGElement) return;
                        const voiceNumber = $2c02c8dc1811708f$var$getVoiceNumber(voices, note.sourceNote, measure.MeasureNumber, voiceColoringHitSet);
                        const pageNumber = element.ownerSVGElement.id.match(/\d+/)[0];
                        const absoluteNoteOffset = (0, $60078af3cede2a64$export$d66a0ac0c9083fa1)(note.sourceNote);
                        absoluteOffsetPageMap.set(absoluteNoteOffset, Number(pageNumber));
                        elements.push(element);
                        // FIXME: coloring does not work for chord notes other than the root.
                        noteContexts.push({
                            note: note,
                            voiceNumber: voiceNumber
                        });
                    });
                });
            });
        });
    });
    setAbsoluteOffsetPageMap(absoluteOffsetPageMap);
    setVoiceColoringHitSet(new Set(voiceColoringHitSet));
    return (0, $a85203b65095458d$export$2e2bcd8739ae039)(elements).data(noteContexts);
};
const $2c02c8dc1811708f$export$5b67ce9b8df92936 = (pageNumber)=>`${$2c02c8dc1811708f$export$ca52df61d3bbb90(pageNumber)} > g`;
const $2c02c8dc1811708f$export$ca52df61d3bbb90 = (pageNumber)=>`#${$2c02c8dc1811708f$var$getPageNameFromNumber(pageNumber)}`;
const $2c02c8dc1811708f$var$getPageNameFromNumber = (pageNumber)=>`osmdSvgPage${pageNumber}`;
const $2c02c8dc1811708f$var$getShortestPatternIDFromIDs = (patternIDs, patterns)=>patterns.filter((pattern)=>patternIDs.includes(pattern.id)).sort((firstPattern, secondPattern)=>firstPattern.length - secondPattern.length)[0].id;
const $2c02c8dc1811708f$var$getVoiceNumber = (ofVoices, forNote, inMeasureNumber, voiceColoringHitSet)=>ofVoices.find((voice)=>voice.measures.filter((measure)=>measure.number === inMeasureNumber).some((measure)=>measure.elements.some((element)=>{
                // We need the hit set to avoid elements with the same duration/offset/pitch being matched to the same voice.
                if (voiceColoringHitSet.has(element)) return false;
                if ((0, $60078af3cede2a64$export$d9e93408681959cd)(forNote)) {
                    if (Array.isArray(element.pitch) && (0, $60078af3cede2a64$export$31e3bd67f7b73048)(forNote) === element.pitch.length) {
                        const chordNotesAlign = forNote.ParentVoiceEntry.Notes.every((note, index)=>{
                            const notePitch = `${(0, $60078af3cede2a64$export$ab8457433da1bda8)(note.Pitch.FundamentalNote)}${(0, $60078af3cede2a64$export$af79ad9d2c33c52d)(note.Pitch.Accidental)}${note.Pitch.Octave + 3}`;
                            const elementPitch = element.pitch[index];
                            return notePitch === elementPitch;
                        });
                        if (!chordNotesAlign) return false;
                    } else return false;
                } else {
                    const forNotePitch = (0, $60078af3cede2a64$export$483288ae205f46f1)(forNote);
                    if (!(forNote.isRest() && element.pitch === null || forNotePitch === element.pitch)) return false;
                }
                const forNoteDuration = (0, $60078af3cede2a64$export$75bba95db5c3e753)(forNote);
                const forNoteOffset = (0, $60078af3cede2a64$export$622cea445a1c5b7d)(forNote);
                const matchesDuration = forNote.IsGraceNote || forNoteDuration === element.duration;
                const matchesOffset = forNoteOffset === element.offset;
                const matches = matchesDuration && matchesOffset;
                // For an unknown reason, chords are not colored correctly if included in the hit set.
                if (matches && !Array.isArray(element.pitch)) voiceColoringHitSet.add(element);
                return matches;
            })))?.number;
/**
 * Crops each fitted page to its music (the last page ends early; an A4 page stays a whole sheet) and groups its
 * contents for the note selection.
 */ const $2c02c8dc1811708f$var$preparePages = (numberOfPages, mode)=>{
    for(let pageNumber = 1; pageNumber <= numberOfPages; pageNumber++){
        const pageContent = document.querySelector($2c02c8dc1811708f$export$ca52df61d3bbb90(pageNumber));
        if (pageContent === null) continue;
        if (mode === 'fit') {
            const boundingBox = pageContent.getBBox();
            const svgViewBox = pageContent.getAttribute('viewBox').split(' ');
            // Cropped at the scale the page was laid out at: its height shrinks, its notes keep their size. Below the music
            // stays the page's bottom margin (the view box counts 10 per staff space).
            const contentHeight = Math.min(Number(svgViewBox[3]), boundingBox.y + boundingBox.height + 10 * $2c02c8dc1811708f$var$pageMargins.fit.bottom);
            const scale = Number(pageContent.getAttribute('width')) / Number(svgViewBox[2]);
            pageContent.setAttribute('viewBox', `${svgViewBox[0]} ${svgViewBox[1]} ${svgViewBox[2]} ${contentHeight}`);
            if (scale > 0) pageContent.setAttribute('height', String(contentHeight * scale));
        }
        // Group music sheet elements to decrease the part of the user interface that allows for note selection.
        const pageContents = Array.from(document.querySelectorAll(`${$2c02c8dc1811708f$export$ca52df61d3bbb90(pageNumber)} > *`));
        // Remove elements from the page's SVG.
        pageContents.forEach((element)=>element.remove());
        // Create a group that contains the music sheet elements.
        const pageContentsContainer = document.createElementNS('http://www.w3.org/2000/svg', 'g');
        pageContentsContainer.classList.add('cursor-pointer', 'background-white', 'focus:outline-0');
        pageContentsContainer.style.pointerEvents = 'bounding-box';
        document.querySelector($2c02c8dc1811708f$export$ca52df61d3bbb90(pageNumber)).append(pageContentsContainer);
        // Add elements to the page's container.
        document.querySelector(`${$2c02c8dc1811708f$export$ca52df61d3bbb90(pageNumber)} > g`).append(...pageContents);
    }
};
var $2c02c8dc1811708f$export$2e2bcd8739ae039 = $2c02c8dc1811708f$var$MelodyAnalysis;




var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $4d7dc71fab2cf360$var$AimOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M952 474H829.8C812.5 327.6 696.4 211.5 550 194.2V72c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v122.2C327.6 211.5 211.5 327.6 194.2 474H72c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h122.2C211.5 696.4 327.6 812.5 474 829.8V952c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V829.8C696.4 812.5 812.5 696.4 829.8 550H952c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zM512 756c-134.8 0-244-109.2-244-244s109.2-244 244-244 244 109.2 244 244-109.2 244-244 244z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 392c-32.1 0-62.1 12.4-84.8 35.2-22.7 22.7-35.2 52.7-35.2 84.8s12.5 62.1 35.2 84.8C449.9 619.4 480 632 512 632s62.1-12.5 84.8-35.2C619.4 574.1 632 544 632 512s-12.5-62.1-35.2-84.8A118.57 118.57 0 00512 392z"
                }
            }
        ]
    },
    "name": "aim",
    "theme": "outlined"
};
var $4d7dc71fab2cf360$export$2e2bcd8739ae039 = $4d7dc71fab2cf360$var$AimOutlined;



function $a91ec3b72a351c7b$var$_extends() {
    $a91ec3b72a351c7b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a91ec3b72a351c7b$var$_extends.apply(this, arguments);
}
const $a91ec3b72a351c7b$var$AimOutlined = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $a91ec3b72a351c7b$var$_extends({}, props, {
        ref: ref,
        icon: (0, $4d7dc71fab2cf360$export$2e2bcd8739ae039)
    }));
/**![aim](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk1MiA0NzRIODI5LjhDODEyLjUgMzI3LjYgNjk2LjQgMjExLjUgNTUwIDE5NC4yVjcyYzAtNC40LTMuNi04LTgtOGgtNjBjLTQuNCAwLTggMy42LTggOHYxMjIuMkMzMjcuNiAyMTEuNSAyMTEuNSAzMjcuNiAxOTQuMiA0NzRINzJjLTQuNCAwLTggMy42LTggOHY2MGMwIDQuNCAzLjYgOCA4IDhoMTIyLjJDMjExLjUgNjk2LjQgMzI3LjYgODEyLjUgNDc0IDgyOS44Vjk1MmMwIDQuNCAzLjYgOCA4IDhoNjBjNC40IDAgOC0zLjYgOC04VjgyOS44QzY5Ni40IDgxMi41IDgxMi41IDY5Ni40IDgyOS44IDU1MEg5NTJjNC40IDAgOC0zLjYgOC04di02MGMwLTQuNC0zLjYtOC04LTh6TTUxMiA3NTZjLTEzNC44IDAtMjQ0LTEwOS4yLTI0NC0yNDRzMTA5LjItMjQ0IDI0NC0yNDQgMjQ0IDEwOS4yIDI0NCAyNDQtMTA5LjIgMjQ0LTI0NCAyNDR6IiAvPjxwYXRoIGQ9Ik01MTIgMzkyYy0zMi4xIDAtNjIuMSAxMi40LTg0LjggMzUuMi0yMi43IDIyLjctMzUuMiA1Mi43LTM1LjIgODQuOHMxMi41IDYyLjEgMzUuMiA4NC44QzQ0OS45IDYxOS40IDQ4MCA2MzIgNTEyIDYzMnM2Mi4xLTEyLjUgODQuOC0zNS4yQzYxOS40IDU3NC4xIDYzMiA1NDQgNjMyIDUxMnMtMTIuNS02Mi4xLTM1LjItODQuOEExMTguNTcgMTE4LjU3IDAgMDA1MTIgMzkyeiIgLz48L3N2Zz4=) */ const $a91ec3b72a351c7b$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($a91ec3b72a351c7b$var$AimOutlined);
var $a91ec3b72a351c7b$export$2e2bcd8739ae039 = $a91ec3b72a351c7b$var$RefIcon;


var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $a554560b70af31c3$var$ApartmentOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M908 640H804V488c0-4.4-3.6-8-8-8H548v-96h108c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h108v96H228c-4.4 0-8 3.6-8 8v152H116c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16V656c0-8.8-7.2-16-16-16H292v-88h440v88H620c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16V656c0-8.8-7.2-16-16-16zm-564 76v168H176V716h168zm84-408V140h168v168H428zm420 576H680V716h168v168z"
                }
            }
        ]
    },
    "name": "apartment",
    "theme": "outlined"
};
var $a554560b70af31c3$export$2e2bcd8739ae039 = $a554560b70af31c3$var$ApartmentOutlined;



function $48c6022fa0e38db4$var$_extends() {
    $48c6022fa0e38db4$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $48c6022fa0e38db4$var$_extends.apply(this, arguments);
}
const $48c6022fa0e38db4$var$ApartmentOutlined = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $48c6022fa0e38db4$var$_extends({}, props, {
        ref: ref,
        icon: (0, $a554560b70af31c3$export$2e2bcd8739ae039)
    }));
/**![apartment](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkwOCA2NDBIODA0VjQ4OGMwLTQuNC0zLjYtOC04LThINTQ4di05NmgxMDhjOC44IDAgMTYtNy4yIDE2LTE2VjgwYzAtOC44LTcuMi0xNi0xNi0xNkgzNjhjLTguOCAwLTE2IDcuMi0xNiAxNnYyODhjMCA4LjggNy4yIDE2IDE2IDE2aDEwOHY5NkgyMjhjLTQuNCAwLTggMy42LTggOHYxNTJIMTE2Yy04LjggMC0xNiA3LjItMTYgMTZ2Mjg4YzAgOC44IDcuMiAxNiAxNiAxNmgyODhjOC44IDAgMTYtNy4yIDE2LTE2VjY1NmMwLTguOC03LjItMTYtMTYtMTZIMjkydi04OGg0NDB2ODhINjIwYy04LjggMC0xNiA3LjItMTYgMTZ2Mjg4YzAgOC44IDcuMiAxNiAxNiAxNmgyODhjOC44IDAgMTYtNy4yIDE2LTE2VjY1NmMwLTguOC03LjItMTYtMTYtMTZ6bS01NjQgNzZ2MTY4SDE3NlY3MTZoMTY4em04NC00MDhWMTQwaDE2OHYxNjhINDI4em00MjAgNTc2SDY4MFY3MTZoMTY4djE2OHoiIC8+PC9zdmc+) */ const $48c6022fa0e38db4$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($48c6022fa0e38db4$var$ApartmentOutlined);
var $48c6022fa0e38db4$export$2e2bcd8739ae039 = $48c6022fa0e38db4$var$RefIcon;


var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $069dabbb494b985b$var$FullscreenOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M290 236.4l43.9-43.9a8.01 8.01 0 00-4.7-13.6L169 160c-5.1-.6-9.5 3.7-8.9 8.9L179 329.1c.8 6.6 8.9 9.4 13.6 4.7l43.7-43.7L370 423.7c3.1 3.1 8.2 3.1 11.3 0l42.4-42.3c3.1-3.1 3.1-8.2 0-11.3L290 236.4zm352.7 187.3c3.1 3.1 8.2 3.1 11.3 0l133.7-133.6 43.7 43.7a8.01 8.01 0 0013.6-4.7L863.9 169c.6-5.1-3.7-9.5-8.9-8.9L694.8 179c-6.6.8-9.4 8.9-4.7 13.6l43.9 43.9L600.3 370a8.03 8.03 0 000 11.3l42.4 42.4zM845 694.9c-.8-6.6-8.9-9.4-13.6-4.7l-43.7 43.7L654 600.3a8.03 8.03 0 00-11.3 0l-42.4 42.3a8.03 8.03 0 000 11.3L734 787.6l-43.9 43.9a8.01 8.01 0 004.7 13.6L855 864c5.1.6 9.5-3.7 8.9-8.9L845 694.9zm-463.7-94.6a8.03 8.03 0 00-11.3 0L236.3 733.9l-43.7-43.7a8.01 8.01 0 00-13.6 4.7L160.1 855c-.6 5.1 3.7 9.5 8.9 8.9L329.2 845c6.6-.8 9.4-8.9 4.7-13.6L290 787.6 423.7 654c3.1-3.1 3.1-8.2 0-11.3l-42.4-42.4z"
                }
            }
        ]
    },
    "name": "fullscreen",
    "theme": "outlined"
};
var $069dabbb494b985b$export$2e2bcd8739ae039 = $069dabbb494b985b$var$FullscreenOutlined;



function $8398e9e7789278c2$var$_extends() {
    $8398e9e7789278c2$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8398e9e7789278c2$var$_extends.apply(this, arguments);
}
const $8398e9e7789278c2$var$FullscreenOutlined = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $8398e9e7789278c2$var$_extends({}, props, {
        ref: ref,
        icon: (0, $069dabbb494b985b$export$2e2bcd8739ae039)
    }));
/**![fullscreen](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI5MCAyMzYuNGw0My45LTQzLjlhOC4wMSA4LjAxIDAgMDAtNC43LTEzLjZMMTY5IDE2MGMtNS4xLS42LTkuNSAzLjctOC45IDguOUwxNzkgMzI5LjFjLjggNi42IDguOSA5LjQgMTMuNiA0LjdsNDMuNy00My43TDM3MCA0MjMuN2MzLjEgMy4xIDguMiAzLjEgMTEuMyAwbDQyLjQtNDIuM2MzLjEtMy4xIDMuMS04LjIgMC0xMS4zTDI5MCAyMzYuNHptMzUyLjcgMTg3LjNjMy4xIDMuMSA4LjIgMy4xIDExLjMgMGwxMzMuNy0xMzMuNiA0My43IDQzLjdhOC4wMSA4LjAxIDAgMDAxMy42LTQuN0w4NjMuOSAxNjljLjYtNS4xLTMuNy05LjUtOC45LTguOUw2OTQuOCAxNzljLTYuNi44LTkuNCA4LjktNC43IDEzLjZsNDMuOSA0My45TDYwMC4zIDM3MGE4LjAzIDguMDMgMCAwMDAgMTEuM2w0Mi40IDQyLjR6TTg0NSA2OTQuOWMtLjgtNi42LTguOS05LjQtMTMuNi00LjdsLTQzLjcgNDMuN0w2NTQgNjAwLjNhOC4wMyA4LjAzIDAgMDAtMTEuMyAwbC00Mi40IDQyLjNhOC4wMyA4LjAzIDAgMDAwIDExLjNMNzM0IDc4Ny42bC00My45IDQzLjlhOC4wMSA4LjAxIDAgMDA0LjcgMTMuNkw4NTUgODY0YzUuMS42IDkuNS0zLjcgOC45LTguOUw4NDUgNjk0Ljl6bS00NjMuNy05NC42YTguMDMgOC4wMyAwIDAwLTExLjMgMEwyMzYuMyA3MzMuOWwtNDMuNy00My43YTguMDEgOC4wMSAwIDAwLTEzLjYgNC43TDE2MC4xIDg1NWMtLjYgNS4xIDMuNyA5LjUgOC45IDguOUwzMjkuMiA4NDVjNi42LS44IDkuNC04LjkgNC43LTEzLjZMMjkwIDc4Ny42IDQyMy43IDY1NGMzLjEtMy4xIDMuMS04LjIgMC0xMS4zbC00Mi40LTQyLjR6IiAvPjwvc3ZnPg==) */ const $8398e9e7789278c2$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($8398e9e7789278c2$var$FullscreenOutlined);
var $8398e9e7789278c2$export$2e2bcd8739ae039 = $8398e9e7789278c2$var$RefIcon;


var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $547f3be8db6522bd$var$RocketTwoTone = {
    "icon": function render(primaryColor, secondaryColor) {
        return {
            "tag": "svg",
            "attrs": {
                "viewBox": "64 64 896 896",
                "focusable": "false"
            },
            "children": [
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M261.7 621.4c-9.4 14.6-17 30.3-22.5 46.6H324V558.7c-24.8 16.2-46 37.5-62.3 62.7zM700 558.7V668h84.8c-5.5-16.3-13.1-32-22.5-46.6a211.6 211.6 0 00-62.3-62.7zm-64-239.9l-124-147-124 147V668h248V318.8zM512 448a48.01 48.01 0 010-96 48.01 48.01 0 010 96z",
                        "fill": secondaryColor
                    }
                },
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M864 736c0-111.6-65.4-208-160-252.9V317.3c0-15.1-5.3-29.7-15.1-41.2L536.5 95.4C530.1 87.8 521 84 512 84s-18.1 3.8-24.5 11.4L335.1 276.1a63.97 63.97 0 00-15.1 41.2v165.8C225.4 528 160 624.4 160 736h156.5c-2.3 7.2-3.5 15-3.5 23.8 0 22.1 7.6 43.7 21.4 60.8a97.2 97.2 0 0043.1 30.6c23.1 54 75.6 88.8 134.5 88.8 29.1 0 57.3-8.6 81.4-24.8 23.6-15.8 41.9-37.9 53-64a97 97 0 0043.1-30.5 97.52 97.52 0 0021.4-60.8c0-8.4-1.1-16.4-3.1-23.8L864 736zm-540-68h-84.8c5.5-16.3 13.1-32 22.5-46.6 16.3-25.2 37.5-46.5 62.3-62.7V668zm64-184.9V318.8l124-147 124 147V668H388V483.1zm240.1 301.1c-5.2 3-11.2 4.2-17.1 3.4l-19.5-2.4-2.8 19.4c-5.4 37.9-38.4 66.5-76.7 66.5s-71.3-28.6-76.7-66.5l-2.8-19.5-19.5 2.5a27.7 27.7 0 01-17.1-3.5c-8.7-5-14.1-14.3-14.1-24.4 0-10.6 5.9-19.4 14.6-23.8h231.3c8.8 4.5 14.6 13.3 14.6 23.8-.1 10.2-5.5 19.6-14.2 24.5zM700 668V558.7a211.6 211.6 0 0162.3 62.7c9.4 14.6 17 30.3 22.5 46.6H700z",
                        "fill": primaryColor
                    }
                },
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M464 400a48 48 0 1096 0 48 48 0 10-96 0z",
                        "fill": primaryColor
                    }
                }
            ]
        };
    },
    "name": "rocket",
    "theme": "twotone"
};
var $547f3be8db6522bd$export$2e2bcd8739ae039 = $547f3be8db6522bd$var$RocketTwoTone;



var $5E6i4 = parcelRequire("5E6i4");



var $5E6i4 = parcelRequire("5E6i4");


const $59687e2598189137$export$125a42e065541a9d = (0, $37058c64b679ada5$export$2aa0182783e7e9de).primary;
function $59687e2598189137$export$b71c93f469694483(primaryColor) {
    // choose the second color
    return (0, $0452e534096bcd2f$export$2e2bcd8739ae039)(primaryColor)[0];
}



const $cbad66fe42b638a4$var$twoToneColorPalette = {
    primaryColor: '#333',
    secondaryColor: '#E6E6E6',
    calculated: false
};
function $cbad66fe42b638a4$var$setTwoToneColors({ primaryColor: primaryColor, secondaryColor: secondaryColor }) {
    $cbad66fe42b638a4$var$twoToneColorPalette.primaryColor = primaryColor;
    $cbad66fe42b638a4$var$twoToneColorPalette.secondaryColor = secondaryColor || (0, $59687e2598189137$export$b71c93f469694483)(primaryColor);
    $cbad66fe42b638a4$var$twoToneColorPalette.calculated = !!secondaryColor;
}
function $cbad66fe42b638a4$var$getTwoToneColors() {
    return {
        ...$cbad66fe42b638a4$var$twoToneColorPalette
    };
}
const $cbad66fe42b638a4$var$IconBaseTwoTone = (props)=>{
    const { icon: icon, className: className, onClick: onClick, style: style, primaryColor: primaryColor, secondaryColor: secondaryColor, ...restProps } = props;
    const svgRef = $5E6i4.useRef(null);
    let colors = $cbad66fe42b638a4$var$twoToneColorPalette;
    if (primaryColor) colors = {
        primaryColor: primaryColor,
        secondaryColor: secondaryColor || (0, $59687e2598189137$export$b71c93f469694483)(primaryColor)
    };
    (0, $6b049bda961bd2ba$export$938b1f86b61613d0)(svgRef);
    (0, $6b049bda961bd2ba$export$491112666e282270)((0, $6b049bda961bd2ba$export$ab652842c37578f4)(icon), `icon should be icon definiton, but got ${typeof icon}`);
    if (!(0, $6b049bda961bd2ba$export$ab652842c37578f4)(icon)) return null;
    let target = icon;
    if (target && typeof target.icon === 'function') target = {
        ...target,
        icon: target.icon(colors.primaryColor, colors.secondaryColor)
    };
    return (0, $6b049bda961bd2ba$export$80d376111cc09ad7)(target.icon, `svg-${target.name}`, {
        className: className,
        onClick: onClick,
        style: style,
        'data-icon': target.name,
        width: '1em',
        height: '1em',
        fill: 'currentColor',
        'aria-hidden': 'true',
        ...restProps,
        ref: svgRef
    });
};
$cbad66fe42b638a4$var$IconBaseTwoTone.displayName = 'IconReact';
$cbad66fe42b638a4$var$IconBaseTwoTone.getTwoToneColors = $cbad66fe42b638a4$var$getTwoToneColors;
$cbad66fe42b638a4$var$IconBaseTwoTone.setTwoToneColors = $cbad66fe42b638a4$var$setTwoToneColors;
var $cbad66fe42b638a4$export$2e2bcd8739ae039 = $cbad66fe42b638a4$var$IconBaseTwoTone;





function $9daecf430ab8122a$export$b5b464c3d8433a9b(twoToneColor) {
    if (!twoToneColor) return [];
    return Array.isArray(twoToneColor) ? twoToneColor : [
        twoToneColor
    ];
}


function $44aa390b783b6644$export$8a145f34580ff02b(twoToneColor) {
    const [primaryColor, secondaryColor] = (0, $9daecf430ab8122a$export$b5b464c3d8433a9b)(twoToneColor);
    return (0, $cbad66fe42b638a4$export$2e2bcd8739ae039).setTwoToneColors({
        primaryColor: primaryColor,
        secondaryColor: secondaryColor
    });
}
function $44aa390b783b6644$export$abc7c554784cb4a7() {
    const colors = (0, $cbad66fe42b638a4$export$2e2bcd8739ae039).getTwoToneColors();
    if (!colors.calculated) return colors.primaryColor;
    return [
        colors.primaryColor,
        colors.secondaryColor
    ];
}





'use client';
function $8c8908e72e16fc29$var$_extends() {
    $8c8908e72e16fc29$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8c8908e72e16fc29$var$_extends.apply(this, arguments);
}
// Initial setting
// should move it to antd main repo?
(0, $44aa390b783b6644$export$8a145f34580ff02b)((0, $59687e2598189137$export$125a42e065541a9d));
// https://github.com/DefinitelyTyped/DefinitelyTyped/issues/34757#issuecomment-488848720
const $8c8908e72e16fc29$var$Icon = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { className: // affect outter <i>...</i>
    className, icon: // affect inner <svg>...</svg>
    icon, spin: spin, rotate: rotate, tabIndex: tabIndex, onClick: onClick, twoToneColor: // other
    twoToneColor, ...restProps } = props;
    const { prefixCls: prefixCls = 'anticon', rootClassName: rootClassName } = $5E6i4.useContext((0, $2a60f785f1b30e7d$export$2e2bcd8739ae039));
    (0, $6b049bda961bd2ba$export$491112666e282270)((0, $6b049bda961bd2ba$export$ab652842c37578f4)(icon), `icon should be icon definiton, but got ${typeof icon}`);
    if (!(0, $6b049bda961bd2ba$export$ab652842c37578f4)(icon)) return null;
    const classString = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(rootClassName, prefixCls, {
        [`${prefixCls}-${icon.name}`]: !!icon.name,
        [`${prefixCls}-spin`]: !!spin || icon.name === 'loading'
    }, className);
    let iconTabIndex = tabIndex;
    if (iconTabIndex === undefined && onClick) iconTabIndex = -1;
    const svgStyle = rotate ? {
        msTransform: `rotate(${rotate}deg)`,
        transform: `rotate(${rotate}deg)`
    } : undefined;
    const [primaryColor, secondaryColor] = (0, $9daecf430ab8122a$export$b5b464c3d8433a9b)(twoToneColor);
    return /*#__PURE__*/ $5E6i4.createElement("span", $8c8908e72e16fc29$var$_extends({
        role: "img",
        "aria-label": icon.name
    }, restProps, {
        ref: ref,
        tabIndex: iconTabIndex,
        onClick: onClick,
        className: classString
    }), /*#__PURE__*/ $5E6i4.createElement((0, $cbad66fe42b638a4$export$2e2bcd8739ae039), {
        icon: icon,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        style: svgStyle
    }));
});
$8c8908e72e16fc29$var$Icon.getTwoToneColor = (0, $44aa390b783b6644$export$abc7c554784cb4a7);
$8c8908e72e16fc29$var$Icon.setTwoToneColor = (0, $44aa390b783b6644$export$8a145f34580ff02b);
var $8c8908e72e16fc29$export$2e2bcd8739ae039 = $8c8908e72e16fc29$var$Icon;


function $b38986e5c635d7ef$var$_extends() {
    $b38986e5c635d7ef$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b38986e5c635d7ef$var$_extends.apply(this, arguments);
}
const $b38986e5c635d7ef$var$RocketTwoTone = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $8c8908e72e16fc29$export$2e2bcd8739ae039), $b38986e5c635d7ef$var$_extends({}, props, {
        ref: ref,
        icon: (0, $547f3be8db6522bd$export$2e2bcd8739ae039)
    }));
/**![rocket](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI2MS43IDYyMS40Yy05LjQgMTQuNi0xNyAzMC4zLTIyLjUgNDYuNkgzMjRWNTU4LjdjLTI0LjggMTYuMi00NiAzNy41LTYyLjMgNjIuN3pNNzAwIDU1OC43VjY2OGg4NC44Yy01LjUtMTYuMy0xMy4xLTMyLTIyLjUtNDYuNmEyMTEuNiAyMTEuNiAwIDAwLTYyLjMtNjIuN3ptLTY0LTIzOS45bC0xMjQtMTQ3LTEyNCAxNDdWNjY4aDI0OFYzMTguOHpNNTEyIDQ0OGE0OC4wMSA0OC4wMSAwIDAxMC05NiA0OC4wMSA0OC4wMSAwIDAxMCA5NnoiIGZpbGw9IiNlNmY0ZmYiIC8+PHBhdGggZD0iTTg2NCA3MzZjMC0xMTEuNi02NS40LTIwOC0xNjAtMjUyLjlWMzE3LjNjMC0xNS4xLTUuMy0yOS43LTE1LjEtNDEuMkw1MzYuNSA5NS40QzUzMC4xIDg3LjggNTIxIDg0IDUxMiA4NHMtMTguMSAzLjgtMjQuNSAxMS40TDMzNS4xIDI3Ni4xYTYzLjk3IDYzLjk3IDAgMDAtMTUuMSA0MS4ydjE2NS44QzIyNS40IDUyOCAxNjAgNjI0LjQgMTYwIDczNmgxNTYuNWMtMi4zIDcuMi0zLjUgMTUtMy41IDIzLjggMCAyMi4xIDcuNiA0My43IDIxLjQgNjAuOGE5Ny4yIDk3LjIgMCAwMDQzLjEgMzAuNmMyMy4xIDU0IDc1LjYgODguOCAxMzQuNSA4OC44IDI5LjEgMCA1Ny4zLTguNiA4MS40LTI0LjggMjMuNi0xNS44IDQxLjktMzcuOSA1My02NGE5NyA5NyAwIDAwNDMuMS0zMC41IDk3LjUyIDk3LjUyIDAgMDAyMS40LTYwLjhjMC04LjQtMS4xLTE2LjQtMy4xLTIzLjhMODY0IDczNnptLTU0MC02OGgtODQuOGM1LjUtMTYuMyAxMy4xLTMyIDIyLjUtNDYuNiAxNi4zLTI1LjIgMzcuNS00Ni41IDYyLjMtNjIuN1Y2Njh6bTY0LTE4NC45VjMxOC44bDEyNC0xNDcgMTI0IDE0N1Y2NjhIMzg4VjQ4My4xem0yNDAuMSAzMDEuMWMtNS4yIDMtMTEuMiA0LjItMTcuMSAzLjRsLTE5LjUtMi40LTIuOCAxOS40Yy01LjQgMzcuOS0zOC40IDY2LjUtNzYuNyA2Ni41cy03MS4zLTI4LjYtNzYuNy02Ni41bC0yLjgtMTkuNS0xOS41IDIuNWEyNy43IDI3LjcgMCAwMS0xNy4xLTMuNWMtOC43LTUtMTQuMS0xNC4zLTE0LjEtMjQuNCAwLTEwLjYgNS45LTE5LjQgMTQuNi0yMy44aDIzMS4zYzguOCA0LjUgMTQuNiAxMy4zIDE0LjYgMjMuOC0uMSAxMC4yLTUuNSAxOS42LTE0LjIgMjQuNXpNNzAwIDY2OFY1NTguN2EyMTEuNiAyMTEuNiAwIDAxNjIuMyA2Mi43YzkuNCAxNC42IDE3IDMwLjMgMjIuNSA0Ni42SDcwMHoiIGZpbGw9IiMxNjc3ZmYiIC8+PHBhdGggZD0iTTQ2NCA0MDBhNDggNDggMCAxMDk2IDAgNDggNDggMCAxMC05NiAweiIgZmlsbD0iIzE2NzdmZiIgLz48L3N2Zz4=) */ const $b38986e5c635d7ef$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($b38986e5c635d7ef$var$RocketTwoTone);
var $b38986e5c635d7ef$export$2e2bcd8739ae039 = $b38986e5c635d7ef$var$RefIcon;


var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $7b007216951fc832$var$UnlockOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M832 464H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v68c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-68c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zm-40 376H232V536h560v304zM484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 10-56 0z"
                }
            }
        ]
    },
    "name": "unlock",
    "theme": "outlined"
};
var $7b007216951fc832$export$2e2bcd8739ae039 = $7b007216951fc832$var$UnlockOutlined;



function $4cffafdc589c376e$var$_extends() {
    $4cffafdc589c376e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4cffafdc589c376e$var$_extends.apply(this, arguments);
}
const $4cffafdc589c376e$var$UnlockOutlined = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $4cffafdc589c376e$var$_extends({}, props, {
        ref: ref,
        icon: (0, $7b007216951fc832$export$2e2bcd8739ae039)
    }));
/**![unlock](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTgzMiA0NjRIMzMyVjI0MGMwLTMwLjkgMjUuMS01NiA1Ni01NmgyNDhjMzAuOSAwIDU2IDI1LjEgNTYgNTZ2NjhjMCA0LjQgMy42IDggOCA4aDU2YzQuNCAwIDgtMy42IDgtOHYtNjhjMC03MC43LTU3LjMtMTI4LTEyOC0xMjhIMzg4Yy03MC43IDAtMTI4IDU3LjMtMTI4IDEyOHYyMjRoLTY4Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnYzODRjMCAxNy43IDE0LjMgMzIgMzIgMzJoNjQwYzE3LjcgMCAzMi0xNC4zIDMyLTMyVjQ5NmMwLTE3LjctMTQuMy0zMi0zMi0zMnptLTQwIDM3NkgyMzJWNTM2aDU2MHYzMDR6TTQ4NCA3MDF2NTNjMCA0LjQgMy42IDggOCA4aDQwYzQuNCAwIDgtMy42IDgtOHYtNTNhNDguMDEgNDguMDEgMCAxMC01NiAweiIgLz48L3N2Zz4=) */ const $4cffafdc589c376e$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($4cffafdc589c376e$var$UnlockOutlined);
var $4cffafdc589c376e$export$2e2bcd8739ae039 = $4cffafdc589c376e$var$RefIcon;


// @visx/visx
// @visx/annotation

var $5E6i4 = parcelRequire("5E6i4");
var $852a55cf17d8b19d$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if ($852a55cf17d8b19d$exports) {
        classNames.default = classNames;
        $852a55cf17d8b19d$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



var $5E6i4 = parcelRequire("5E6i4");
const $c3d210f80631e294$var$AnnotationContext = /*#__PURE__*/ (0, $5E6i4.createContext)({});
var $c3d210f80631e294$export$2e2bcd8739ae039 = $c3d210f80631e294$var$AnnotationContext;



function $8e4cb0f381c19383$export$2e2bcd8739ae039(_ref) {
    let { className: className, x: propsX, y: propsY, dx: propsDx, dy: propsDy, type: type = 'elbow', stroke: stroke = '#222', pathProps: pathProps } = _ref;
    // if props are provided, they take precedence over context
    const annotationContext = (0, $5E6i4.useContext)((0, $c3d210f80631e294$export$2e2bcd8739ae039));
    const x0 = propsX == null ? annotationContext.x ?? 0 : propsX;
    const y0 = propsY == null ? annotationContext.y ?? 0 : propsY;
    const dx = propsDx == null ? annotationContext.dx ?? 0 : propsDx;
    const dy = propsDy == null ? annotationContext.dy ?? 0 : propsDy;
    let x1 = x0; // only used with elbow type
    let y1 = y0;
    const x2 = x0 + dx;
    const y2 = y0 + dy;
    if (type === 'elbow') {
        // if dx < dy, find the intesection of y=x or y=-x from subject, with vertical line to label
        if (Math.abs(dx) <= Math.abs(dy)) {
            // target line is vertical x = x2
            x1 = x2;
            // intersection with y=x line (if dy > 0) or y=x (if dy < 0)
            const sign = dy > 0 ? 1 : -1;
            y1 = y0 + sign * Math.abs(x1 - x0);
        } else {
            // target line is horizontal y = y2
            y1 = y2;
            // find intersection with y=-x line (if dx > 0) or y=x (if dx < 0)
            const sign = dx > 0 ? 1 : -1;
            x1 = x0 + sign * Math.abs(y1 - y0);
        }
    }
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("path", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-annotation-connector', className),
        strokeWidth: 1,
        stroke: stroke,
        fill: "transparent",
        pointerEvents: "none",
        d: `M${x0},${y0}${type === 'elbow' ? `L${x1},${y1}` : ''}L${x2},${y2}`,
        ...pathProps
    });
}



var $5E6i4 = parcelRequire("5E6i4");

// @visx/group


function $268dd56f34f61467$export$2e2bcd8739ae039(_ref) {
    let { top: top = 0, left: left = 0, transform: transform, className: className, children: children, innerRef: innerRef, ...restProps } = _ref;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("g", {
        ref: innerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-group', className),
        transform: transform || `translate(${left}, ${top})`,
        ...restProps,
        children: children
    });
}




var $eff7bcaf5d7bfb95$exports = {};

$parcel$export($eff7bcaf5d7bfb95$exports, "Text", () => $6f18bc0a5cbf18e6$export$2e2bcd8739ae039);
$parcel$export($eff7bcaf5d7bfb95$exports, "getStringWidth", () => $7c1a017409158fda$export$2e2bcd8739ae039);
$parcel$export($eff7bcaf5d7bfb95$exports, "useText", () => $e878f6fa2473b9e0$export$2e2bcd8739ae039);
// @visx/text

var $5E6i4 = parcelRequire("5E6i4");
var $c8691c276e5a853c$exports = {};
/**
 * Module dependencies
 */ var $d8858058c7f05a18$exports = {};
$d8858058c7f05a18$exports = $d8858058c7f05a18$var$balanced;
function $d8858058c7f05a18$var$balanced(a, b, str) {
    if (a instanceof RegExp) a = $d8858058c7f05a18$var$maybeMatch(a, str);
    if (b instanceof RegExp) b = $d8858058c7f05a18$var$maybeMatch(b, str);
    var r = $d8858058c7f05a18$var$range(a, b, str);
    return r && {
        start: r[0],
        end: r[1],
        pre: str.slice(0, r[0]),
        body: str.slice(r[0] + a.length, r[1]),
        post: str.slice(r[1] + b.length)
    };
}
function $d8858058c7f05a18$var$maybeMatch(reg, str) {
    var m = str.match(reg);
    return m ? m[0] : null;
}
$d8858058c7f05a18$var$balanced.range = $d8858058c7f05a18$var$range;
function $d8858058c7f05a18$var$range(a, b, str) {
    var begs, beg, left, right, result;
    var ai = str.indexOf(a);
    var bi = str.indexOf(b, ai + 1);
    var i = ai;
    if (ai >= 0 && bi > 0) {
        begs = [];
        left = str.length;
        while(i >= 0 && !result){
            if (i == ai) {
                begs.push(i);
                ai = str.indexOf(a, i + 1);
            } else if (begs.length == 1) result = [
                begs.pop(),
                bi
            ];
            else {
                beg = begs.pop();
                if (beg < left) {
                    left = beg;
                    right = bi;
                }
                bi = str.indexOf(b, i + 1);
            }
            i = ai < bi && ai >= 0 ? ai : bi;
        }
        if (begs.length) result = [
            left,
            right
        ];
    }
    return result;
}


var $0d966ba42808a3d5$exports = {};
/*
 * Module dependencies
 */ var $ece6cebd4cde3765$exports = {};
'use strict';
$ece6cebd4cde3765$exports = $ece6cebd4cde3765$var$balanced;
function $ece6cebd4cde3765$var$balanced(a, b, str) {
    if (a instanceof RegExp) a = $ece6cebd4cde3765$var$maybeMatch(a, str);
    if (b instanceof RegExp) b = $ece6cebd4cde3765$var$maybeMatch(b, str);
    var r = $ece6cebd4cde3765$var$range(a, b, str);
    return r && {
        start: r[0],
        end: r[1],
        pre: str.slice(0, r[0]),
        body: str.slice(r[0] + a.length, r[1]),
        post: str.slice(r[1] + b.length)
    };
}
function $ece6cebd4cde3765$var$maybeMatch(reg, str) {
    var m = str.match(reg);
    return m ? m[0] : null;
}
$ece6cebd4cde3765$var$balanced.range = $ece6cebd4cde3765$var$range;
function $ece6cebd4cde3765$var$range(a, b, str) {
    var begs, beg, left, right, result;
    var ai = str.indexOf(a);
    var bi = str.indexOf(b, ai + 1);
    var i = ai;
    if (ai >= 0 && bi > 0) {
        if (a === b) return [
            ai,
            bi
        ];
        begs = [];
        left = str.length;
        while(i >= 0 && !result){
            if (i == ai) {
                begs.push(i);
                ai = str.indexOf(a, i + 1);
            } else if (begs.length == 1) result = [
                begs.pop(),
                bi
            ];
            else {
                beg = begs.pop();
                if (beg < left) {
                    left = beg;
                    right = bi;
                }
                bi = str.indexOf(b, i + 1);
            }
            i = ai < bi && ai >= 0 ? ai : bi;
        }
        if (begs.length) result = [
            left,
            right
        ];
    }
    return result;
}


/**
 * Expose `reduceFunctionCall`
 *
 * @type {Function}
 */ $0d966ba42808a3d5$exports = $0d966ba42808a3d5$var$reduceFunctionCall;
/**
 * Walkthrough all expressions, evaluate them and insert them into the declaration
 *
 * @param {Array} expressions
 * @param {Object} declaration
 */ function $0d966ba42808a3d5$var$reduceFunctionCall(string, functionRE, callback) {
    var call = string;
    return $0d966ba42808a3d5$var$getFunctionCalls(string, functionRE).reduce(function(string, obj) {
        return string.replace(obj.functionIdentifier + "(" + obj.matches.body + ")", $0d966ba42808a3d5$var$evalFunctionCall(obj.matches.body, obj.functionIdentifier, callback, call, functionRE));
    }, string);
}
/**
 * Parses expressions in a value
 *
 * @param {String} value
 * @returns {Array}
 * @api private
 */ function $0d966ba42808a3d5$var$getFunctionCalls(call, functionRE) {
    var expressions = [];
    var fnRE = typeof functionRE === "string" ? new RegExp("\\b(" + functionRE + ")\\(") : functionRE;
    do {
        var searchMatch = fnRE.exec(call);
        if (!searchMatch) return expressions;
        if (searchMatch[1] === undefined) throw new Error("Missing the first couple of parenthesis to get the function identifier in " + functionRE);
        var fn = searchMatch[1];
        var startIndex = searchMatch.index;
        var matches = $ece6cebd4cde3765$exports("(", ")", call.substring(startIndex));
        if (!matches || matches.start !== searchMatch[0].length - 1) throw new SyntaxError(fn + "(): missing closing ')' in the value '" + call + "'");
        expressions.push({
            matches: matches,
            functionIdentifier: fn
        });
        call = matches.post;
    }while (fnRE.test(call));
    return expressions;
}
/**
 * Evaluates an expression
 *
 * @param {String} expression
 * @returns {String}
 * @api private
 */ function $0d966ba42808a3d5$var$evalFunctionCall(string, functionIdentifier, callback, call, functionRE) {
    // allow recursivity
    return callback($0d966ba42808a3d5$var$reduceFunctionCall(string, functionRE, callback), functionIdentifier, call);
}


var $167f9e8a14f16add$exports = {};
var $62cec72fee1f50e4$exports = {};
var $820a9ab144818dcd$exports = {};
var $8c356dd63d67489b$exports = {};
'use strict';
var $e7a8d7aec9c520f9$exports = {};
"use strict";
var $e7a8d7aec9c520f9$var$Mexp = function(parsed) {
    this.value = parsed;
};
$e7a8d7aec9c520f9$var$Mexp.math = {
    isDegree: true,
    acos: function(x) {
        return $e7a8d7aec9c520f9$var$Mexp.math.isDegree ? 180 / Math.PI * Math.acos(x) : Math.acos(x);
    },
    add: function(a, b) {
        return a + b;
    },
    asin: function(x) {
        return $e7a8d7aec9c520f9$var$Mexp.math.isDegree ? 180 / Math.PI * Math.asin(x) : Math.asin(x);
    },
    atan: function(x) {
        return $e7a8d7aec9c520f9$var$Mexp.math.isDegree ? 180 / Math.PI * Math.atan(x) : Math.atan(x);
    },
    acosh: function(x) {
        return Math.log(x + Math.sqrt(x * x - 1));
    },
    asinh: function(x) {
        return Math.log(x + Math.sqrt(x * x + 1));
    },
    atanh: function(x) {
        return Math.log((1 + x) / (1 - x));
    },
    C: function(n, r) {
        var pro = 1;
        var other = n - r;
        var choice = r;
        if (choice < other) {
            choice = other;
            other = r;
        }
        for(var i = choice + 1; i <= n; i++)pro *= i;
        return pro / $e7a8d7aec9c520f9$var$Mexp.math.fact(other);
    },
    changeSign: function(x) {
        return -x;
    },
    cos: function(x) {
        if ($e7a8d7aec9c520f9$var$Mexp.math.isDegree) x = $e7a8d7aec9c520f9$var$Mexp.math.toRadian(x);
        return Math.cos(x);
    },
    cosh: function(x) {
        return (Math.pow(Math.E, x) + Math.pow(Math.E, -1 * x)) / 2;
    },
    div: function(a, b) {
        return a / b;
    },
    fact: function(n) {
        if (n % 1 !== 0) return 'NaN';
        var pro = 1;
        for(var i = 2; i <= n; i++)pro *= i;
        return pro;
    },
    inverse: function(x) {
        return 1 / x;
    },
    log: function(i) {
        return Math.log(i) / Math.log(10);
    },
    mod: function(a, b) {
        return a % b;
    },
    mul: function(a, b) {
        return a * b;
    },
    P: function(n, r) {
        var pro = 1;
        for(var i = Math.floor(n) - Math.floor(r) + 1; i <= Math.floor(n); i++)pro *= i;
        return pro;
    },
    Pi: function(low, high, ex) {
        var pro = 1;
        for(var i = low; i <= high; i++)pro *= Number(ex.postfixEval({
            n: i
        }));
        return pro;
    },
    pow10x: function(e) {
        var x = 1;
        while(e--)x *= 10;
        return x;
    },
    sigma: function(low, high, ex) {
        var sum = 0;
        for(var i = low; i <= high; i++)sum += Number(ex.postfixEval({
            n: i
        }));
        return sum;
    },
    sin: function(x) {
        if ($e7a8d7aec9c520f9$var$Mexp.math.isDegree) x = $e7a8d7aec9c520f9$var$Mexp.math.toRadian(x);
        return Math.sin(x);
    },
    sinh: function(x) {
        return (Math.pow(Math.E, x) - Math.pow(Math.E, -1 * x)) / 2;
    },
    sub: function(a, b) {
        return a - b;
    },
    tan: function(x) {
        if ($e7a8d7aec9c520f9$var$Mexp.math.isDegree) x = $e7a8d7aec9c520f9$var$Mexp.math.toRadian(x);
        return Math.tan(x);
    },
    tanh: function(x) {
        return $e7a8d7aec9c520f9$var$Mexp.sinha(x) / $e7a8d7aec9c520f9$var$Mexp.cosha(x);
    },
    toRadian: function(x) {
        return x * Math.PI / 180;
    },
    and: function(a, b) {
        return a & b;
    }
};
$e7a8d7aec9c520f9$var$Mexp.Exception = function(message) {
    this.message = message;
};
$e7a8d7aec9c520f9$exports = $e7a8d7aec9c520f9$var$Mexp;


function $8c356dd63d67489b$var$inc(arr, val) {
    for(var i = 0; i < arr.length; i++)arr[i] += val;
    return arr;
}
var $8c356dd63d67489b$var$tokens = [
    {
        token: 'sin',
        show: 'sin',
        type: 0,
        value: $e7a8d7aec9c520f9$exports.math.sin
    },
    {
        token: 'cos',
        show: 'cos',
        type: 0,
        value: $e7a8d7aec9c520f9$exports.math.cos
    },
    {
        token: 'tan',
        show: 'tan',
        type: 0,
        value: $e7a8d7aec9c520f9$exports.math.tan
    },
    {
        token: 'pi',
        show: '&pi;',
        type: 3,
        value: 'PI'
    },
    {
        token: '(',
        show: '(',
        type: 4,
        value: '('
    },
    {
        token: ')',
        show: ')',
        type: 5,
        value: ')'
    },
    {
        token: 'P',
        show: 'P',
        type: 10,
        value: $e7a8d7aec9c520f9$exports.math.P
    },
    {
        token: 'C',
        show: 'C',
        type: 10,
        value: $e7a8d7aec9c520f9$exports.math.C
    },
    {
        token: ' ',
        show: ' ',
        type: 14,
        value: ' '.anchor
    },
    {
        token: 'asin',
        show: 'asin',
        type: 0,
        value: $e7a8d7aec9c520f9$exports.math.asin
    },
    {
        token: 'acos',
        show: 'acos',
        type: 0,
        value: $e7a8d7aec9c520f9$exports.math.acos
    },
    {
        token: 'atan',
        show: 'atan',
        type: 0,
        value: $e7a8d7aec9c520f9$exports.math.atan
    },
    {
        token: '7',
        show: '7',
        type: 1,
        value: '7'
    },
    {
        token: '8',
        show: '8',
        type: 1,
        value: '8'
    },
    {
        token: '9',
        show: '9',
        type: 1,
        value: '9'
    },
    {
        token: 'int',
        show: 'Int',
        type: 0,
        value: Math.floor
    },
    {
        token: 'cosh',
        show: 'cosh',
        type: 0,
        value: $e7a8d7aec9c520f9$exports.math.cosh
    },
    {
        token: 'acosh',
        show: 'acosh',
        type: 0,
        value: $e7a8d7aec9c520f9$exports.math.acosh
    },
    {
        token: 'ln',
        show: ' ln',
        type: 0,
        value: Math.log
    },
    {
        token: '^',
        show: '^',
        type: 10,
        value: Math.pow
    },
    {
        token: 'root',
        show: 'root',
        type: 0,
        value: Math.sqrt
    },
    {
        token: '4',
        show: '4',
        type: 1,
        value: '4'
    },
    {
        token: '5',
        show: '5',
        type: 1,
        value: '5'
    },
    {
        token: '6',
        show: '6',
        type: 1,
        value: '6'
    },
    {
        token: '/',
        show: '&divide;',
        type: 2,
        value: $e7a8d7aec9c520f9$exports.math.div
    },
    {
        token: '!',
        show: '!',
        type: 7,
        value: $e7a8d7aec9c520f9$exports.math.fact
    },
    {
        token: 'tanh',
        show: 'tanh',
        type: 0,
        value: $e7a8d7aec9c520f9$exports.math.tanh
    },
    {
        token: 'atanh',
        show: 'atanh',
        type: 0,
        value: $e7a8d7aec9c520f9$exports.math.atanh
    },
    {
        token: 'Mod',
        show: ' Mod ',
        type: 2,
        value: $e7a8d7aec9c520f9$exports.math.mod
    },
    {
        token: '1',
        show: '1',
        type: 1,
        value: '1'
    },
    {
        token: '2',
        show: '2',
        type: 1,
        value: '2'
    },
    {
        token: '3',
        show: '3',
        type: 1,
        value: '3'
    },
    {
        token: '*',
        show: '&times;',
        type: 2,
        value: $e7a8d7aec9c520f9$exports.math.mul
    },
    {
        token: 'sinh',
        show: 'sinh',
        type: 0,
        value: $e7a8d7aec9c520f9$exports.math.sinh
    },
    {
        token: 'asinh',
        show: 'asinh',
        type: 0,
        value: $e7a8d7aec9c520f9$exports.math.asinh
    },
    {
        token: 'e',
        show: 'e',
        type: 3,
        value: 'E'
    },
    {
        token: 'log',
        show: ' log',
        type: 0,
        value: $e7a8d7aec9c520f9$exports.math.log
    },
    {
        token: '0',
        show: '0',
        type: 1,
        value: '0'
    },
    {
        token: '.',
        show: '.',
        type: 6,
        value: '.'
    },
    {
        token: '+',
        show: '+',
        type: 9,
        value: $e7a8d7aec9c520f9$exports.math.add
    },
    {
        token: '-',
        show: '-',
        type: 9,
        value: $e7a8d7aec9c520f9$exports.math.sub
    },
    {
        token: ',',
        show: ',',
        type: 11,
        value: ','
    },
    {
        token: 'Sigma',
        show: '&Sigma;',
        type: 12,
        value: $e7a8d7aec9c520f9$exports.math.sigma
    },
    {
        token: 'n',
        show: 'n',
        type: 13,
        value: 'n'
    },
    {
        token: 'Pi',
        show: '&Pi;',
        type: 12,
        value: $e7a8d7aec9c520f9$exports.math.Pi
    },
    {
        token: 'pow',
        show: 'pow',
        type: 8,
        value: Math.pow,
        numberOfArguments: 2
    },
    {
        token: '&',
        show: '&',
        type: 9,
        value: $e7a8d7aec9c520f9$exports.math.and
    }
];
var $8c356dd63d67489b$var$preced = {
    0: 11,
    1: 0,
    2: 3,
    3: 0,
    4: 0,
    5: 0,
    6: 0,
    7: 11,
    8: 11,
    9: 1,
    10: 10,
    11: 0,
    12: 11,
    13: 0,
    14: -1,
    15: 11
} // stores precedence by types
;
for(var $8c356dd63d67489b$var$i = 0; $8c356dd63d67489b$var$i < $8c356dd63d67489b$var$tokens.length; $8c356dd63d67489b$var$i++)$8c356dd63d67489b$var$tokens[$8c356dd63d67489b$var$i].precedence = $8c356dd63d67489b$var$preced[$8c356dd63d67489b$var$tokens[$8c356dd63d67489b$var$i].type];
var $8c356dd63d67489b$var$type0 = {
    0: true,
    1: true,
    3: true,
    4: true,
    6: true,
    8: true,
    9: true,
    12: true,
    13: true,
    14: true,
    15: true
} // type2:true,type4:true,type9:true,type11:true,type21:true,type22
;
var $8c356dd63d67489b$var$type1 = {
    0: true,
    1: true,
    2: true,
    3: true,
    4: true,
    5: true,
    6: true,
    7: true,
    8: true,
    9: true,
    10: true,
    11: true,
    12: true,
    13: true,
    15: true
} // type3:true,type5:true,type7:true,type23
;
var $8c356dd63d67489b$var$type1Asterick = {
    0: true,
    3: true,
    4: true,
    8: true,
    12: true,
    13: true,
    15: true
};
var $8c356dd63d67489b$var$empty = {};
var $8c356dd63d67489b$var$type3Asterick = {
    0: true,
    1: true,
    3: true,
    4: true,
    6: true,
    8: true,
    12: true,
    13: true,
    15: true
} // type_5:true,type_7:true,type_23
;
var $8c356dd63d67489b$var$type6 = {
    1: true
};
var $8c356dd63d67489b$var$newAr = [
    [],
    [
        '1',
        '2',
        '3',
        '7',
        '8',
        '9',
        '4',
        '5',
        '6',
        '+',
        '-',
        '*',
        '/',
        '(',
        ')',
        '^',
        '!',
        'P',
        'C',
        'e',
        '0',
        '.',
        ',',
        'n',
        ' ',
        '&'
    ],
    [
        'pi',
        'ln',
        'Pi'
    ],
    [
        'sin',
        'cos',
        'tan',
        'Del',
        'int',
        'Mod',
        'log',
        'pow'
    ],
    [
        'asin',
        'acos',
        'atan',
        'cosh',
        'root',
        'tanh',
        'sinh'
    ],
    [
        'acosh',
        'atanh',
        'asinh',
        'Sigma'
    ]
];
function $8c356dd63d67489b$var$match(str1, str2, i, x) {
    for(var f = 0; f < x; f++){
        if (str1[i + f] !== str2[f]) return false;
    }
    return true;
}
$e7a8d7aec9c520f9$exports.tokenTypes = {
    FUNCTION_WITH_ONE_ARG: 0,
    NUMBER: 1,
    BINARY_OPERATOR_HIGH_PRECENDENCE: 2,
    CONSTANT: 3,
    OPENING_PARENTHESIS: 4,
    CLOSING_PARENTHESIS: 5,
    DECIMAL: 6,
    POSTFIX_FUNCTION_WITH_ONE_ARG: 7,
    FUNCTION_WITH_N_ARGS: 8,
    BINARY_OPERATOR_LOW_PRECENDENCE: 9,
    BINARY_OPERATOR_PERMUTATION: 10,
    COMMA: 11,
    EVALUATED_FUNCTION: 12,
    EVALUATED_FUNCTION_PARAMETER: 13,
    SPACE: 14
};
/**
  
  0 : function with syntax function_name(Maths_exp)
  1 : numbers
  2 : binary operators like * / Mod left associate and same precedence
  3 : Math constant values like e,pi,Cruncher ans
  4 : opening bracket
  5 : closing bracket
  6 : decimal
  7 : function with syntax (Math_exp)function_name
  8: function with syntax function_name(Math_exp1,Math_exp2)
  9 : binary operator like +,-
  10: binary operator like P C or ^
  11: ,
  12: function with , seperated three parameters and third parameter is a string that will be mexp string
  13: variable of Sigma function
 */ $e7a8d7aec9c520f9$exports.addToken = function(newTokens) {
    for(var i = 0; i < newTokens.length; i++){
        var x = newTokens[i].token.length;
        var temp = -1;
        if (newTokens[i].type === $e7a8d7aec9c520f9$exports.tokenTypes.FUNCTION_WITH_N_ARGS && newTokens[i].numberOfArguments === undefined) newTokens[i].numberOfArguments = 2;
        // newAr is a specially designed data structure index of 1d array = length of tokens
        $8c356dd63d67489b$var$newAr[x] = $8c356dd63d67489b$var$newAr[x] || [];
        for(var y = 0; y < $8c356dd63d67489b$var$newAr[x].length; y++)if (newTokens[i].token === $8c356dd63d67489b$var$newAr[x][y]) {
            temp = $8c356dd63d67489b$var$indexOfToken($8c356dd63d67489b$var$newAr[x][y], $8c356dd63d67489b$var$tokens);
            break;
        }
        if (temp === -1) {
            $8c356dd63d67489b$var$tokens.push(newTokens[i]);
            newTokens[i].precedence = $8c356dd63d67489b$var$preced[newTokens[i].type];
            if ($8c356dd63d67489b$var$newAr.length <= newTokens[i].token.length) $8c356dd63d67489b$var$newAr[newTokens[i].token.length] = [];
            $8c356dd63d67489b$var$newAr[newTokens[i].token.length].push(newTokens[i].token);
        } else {
            // overwrite
            $8c356dd63d67489b$var$tokens[temp] = newTokens[i];
            newTokens[i].precedence = $8c356dd63d67489b$var$preced[newTokens[i].type];
        }
    }
};
function $8c356dd63d67489b$var$indexOfToken(key, tokens) {
    for(var search = 0; search < tokens.length; search++){
        if (tokens[search].token === key) return search;
    }
    return -1;
}
function $8c356dd63d67489b$var$tokenize(string) {
    var nodes = [];
    var length = string.length;
    var key, x, y;
    for(var i = 0; i < length; i++){
        if (i < length - 1 && string[i] === ' ' && string[i + 1] === ' ') continue;
        key = '';
        for(x = string.length - i > $8c356dd63d67489b$var$newAr.length - 2 ? $8c356dd63d67489b$var$newAr.length - 1 : string.length - i; x > 0; x--){
            if ($8c356dd63d67489b$var$newAr[x] === undefined) continue;
            for(y = 0; y < $8c356dd63d67489b$var$newAr[x].length; y++)if ($8c356dd63d67489b$var$match(string, $8c356dd63d67489b$var$newAr[x][y], i, x)) {
                key = $8c356dd63d67489b$var$newAr[x][y];
                y = $8c356dd63d67489b$var$newAr[x].length;
                x = 0;
            }
        }
        i += key.length - 1;
        if (key === '') throw new $e7a8d7aec9c520f9$exports.Exception("Can't understand after " + string.slice(i));
        nodes.push($8c356dd63d67489b$var$tokens[$8c356dd63d67489b$var$indexOfToken(key, $8c356dd63d67489b$var$tokens)]);
    }
    return nodes;
}
var $8c356dd63d67489b$var$changeSignObj = {
    value: $e7a8d7aec9c520f9$exports.math.changeSign,
    type: 0,
    pre: 21,
    show: '-'
};
var $8c356dd63d67489b$var$closingParObj = {
    value: ')',
    show: ')',
    type: 5,
    pre: 0
};
var $8c356dd63d67489b$var$openingParObj = {
    value: '(',
    type: 4,
    pre: 0,
    show: '('
};
$e7a8d7aec9c520f9$exports.lex = function(inp, tokens) {
    'use strict';
    var str = [
        $8c356dd63d67489b$var$openingParObj
    ];
    var ptc = [] // Parenthesis to close at the beginning is after one token
    ;
    var inpStr = inp;
    var allowed = $8c356dd63d67489b$var$type0;
    var bracToClose = 0;
    var asterick = $8c356dd63d67489b$var$empty;
    var prevKey = '';
    var i;
    if (typeof tokens !== 'undefined') $e7a8d7aec9c520f9$exports.addToken(tokens);
    var obj = {};
    var nodes = $8c356dd63d67489b$var$tokenize(inpStr);
    for(i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.type === 14) {
            if (i > 0 && i < nodes.length - 1 && nodes[i + 1].type === 1 && (nodes[i - 1].type === 1 || nodes[i - 1].type === 6)) throw new $e7a8d7aec9c520f9$exports.Exception('Unexpected Space');
            continue;
        }
        var cToken = node.token;
        var cType = node.type;
        var cEv = node.value;
        var cPre = node.precedence;
        var cShow = node.show;
        var pre = str[str.length - 1];
        var j;
        for(j = ptc.length; j--;){
            // loop over ptc
            if (ptc[j] === 0) {
                if ([
                    0,
                    2,
                    3,
                    4,
                    5,
                    9,
                    11,
                    12,
                    13
                ].indexOf(cType) !== -1) {
                    if (allowed[cType] !== true) throw new $e7a8d7aec9c520f9$exports.Exception(cToken + ' is not allowed after ' + prevKey);
                    str.push($8c356dd63d67489b$var$closingParObj);
                    allowed = $8c356dd63d67489b$var$type1;
                    asterick = $8c356dd63d67489b$var$type3Asterick;
                    ptc.pop();
                }
            } else break;
        }
        if (allowed[cType] !== true) throw new $e7a8d7aec9c520f9$exports.Exception(cToken + ' is not allowed after ' + prevKey);
        if (asterick[cType] === true) {
            cType = 2;
            cEv = $e7a8d7aec9c520f9$exports.math.mul;
            cShow = '&times;';
            cPre = 3;
            i = i - 1;
        }
        obj = {
            value: cEv,
            type: cType,
            pre: cPre,
            show: cShow,
            numberOfArguments: node.numberOfArguments
        };
        if (cType === 0) {
            allowed = $8c356dd63d67489b$var$type0;
            asterick = $8c356dd63d67489b$var$empty;
            $8c356dd63d67489b$var$inc(ptc, 2);
            str.push(obj);
            if (nodes[i + 1].type !== 4) {
                str.push($8c356dd63d67489b$var$openingParObj);
                ptc.push(2);
            }
        // bracToClose++
        } else if (cType === 1) {
            if (pre.type === 1) {
                pre.value += cEv;
                $8c356dd63d67489b$var$inc(ptc, 1);
            } else str.push(obj);
            allowed = $8c356dd63d67489b$var$type1;
            asterick = $8c356dd63d67489b$var$type1Asterick;
        } else if (cType === 2) {
            allowed = $8c356dd63d67489b$var$type0;
            asterick = $8c356dd63d67489b$var$empty;
            $8c356dd63d67489b$var$inc(ptc, 2);
            str.push(obj);
        } else if (cType === 3) {
            // constant
            str.push(obj);
            allowed = $8c356dd63d67489b$var$type1;
            asterick = $8c356dd63d67489b$var$type3Asterick;
        } else if (cType === 4) {
            $8c356dd63d67489b$var$inc(ptc, 1);
            bracToClose++;
            allowed = $8c356dd63d67489b$var$type0;
            asterick = $8c356dd63d67489b$var$empty;
            str.push(obj);
        } else if (cType === 5) {
            if (!bracToClose) throw new $e7a8d7aec9c520f9$exports.Exception('Closing parenthesis are more than opening one, wait What!!!');
            bracToClose--;
            allowed = $8c356dd63d67489b$var$type1;
            asterick = $8c356dd63d67489b$var$type3Asterick;
            str.push(obj);
            $8c356dd63d67489b$var$inc(ptc, 1);
        } else if (cType === 6) {
            if (pre.hasDec) throw new $e7a8d7aec9c520f9$exports.Exception('Two decimals are not allowed in one number');
            if (pre.type !== 1) {
                pre = {
                    value: 0,
                    type: 1,
                    pre: 0
                } // pre needs to be changed as it will the last value now to be safe in later code
                ;
                str.push(pre);
            // inc(ptc, 1)
            }
            allowed = $8c356dd63d67489b$var$type6;
            $8c356dd63d67489b$var$inc(ptc, 1);
            asterick = $8c356dd63d67489b$var$empty;
            pre.value += cEv;
            pre.hasDec = true;
        } else if (cType === 7) {
            allowed = $8c356dd63d67489b$var$type1;
            asterick = $8c356dd63d67489b$var$type3Asterick;
            $8c356dd63d67489b$var$inc(ptc, 1);
            str.push(obj);
        }
        if (cType === 8) {
            allowed = $8c356dd63d67489b$var$type0;
            asterick = $8c356dd63d67489b$var$empty;
            $8c356dd63d67489b$var$inc(ptc, node.numberOfArguments + 2);
            str.push(obj);
            // str.push(openingParObj)
            if (nodes[i + 1].type !== 4) {
                str.push($8c356dd63d67489b$var$openingParObj);
                ptc.push(node.numberOfArguments + 2);
            }
        } else if (cType === 9) {
            if (pre.type === 9) {
                if (pre.value === $e7a8d7aec9c520f9$exports.math.add) {
                    pre.value = cEv;
                    pre.show = cShow;
                    $8c356dd63d67489b$var$inc(ptc, 1);
                } else if (pre.value === $e7a8d7aec9c520f9$exports.math.sub && cShow === '-') {
                    pre.value = $e7a8d7aec9c520f9$exports.math.add;
                    pre.show = '+';
                    $8c356dd63d67489b$var$inc(ptc, 1);
                }
            } else if (pre.type !== 5 && pre.type !== 7 && pre.type !== 1 && pre.type !== 3 && pre.type !== 13) // changesign only when negative is found
            {
                if (cToken === '-') {
                    // do nothing for + token
                    // don't add with the above if statement as that will run the else statement of parent if on Ctoken +
                    allowed = $8c356dd63d67489b$var$type0;
                    asterick = $8c356dd63d67489b$var$empty;
                    $8c356dd63d67489b$var$inc(ptc, 2).push(2);
                    str.push($8c356dd63d67489b$var$changeSignObj);
                    str.push($8c356dd63d67489b$var$openingParObj);
                }
            } else {
                str.push(obj);
                $8c356dd63d67489b$var$inc(ptc, 2);
            }
            allowed = $8c356dd63d67489b$var$type0;
            asterick = $8c356dd63d67489b$var$empty;
        } else if (cType === 10) {
            allowed = $8c356dd63d67489b$var$type0;
            asterick = $8c356dd63d67489b$var$empty;
            $8c356dd63d67489b$var$inc(ptc, 2);
            str.push(obj);
        } else if (cType === 11) {
            allowed = $8c356dd63d67489b$var$type0;
            asterick = $8c356dd63d67489b$var$empty;
            str.push(obj);
        } else if (cType === 12) {
            allowed = $8c356dd63d67489b$var$type0;
            asterick = $8c356dd63d67489b$var$empty;
            $8c356dd63d67489b$var$inc(ptc, 6);
            str.push(obj);
            if (nodes[i + 1].type !== 4) {
                str.push($8c356dd63d67489b$var$openingParObj);
                ptc.push(6);
            }
        } else if (cType === 13) {
            allowed = $8c356dd63d67489b$var$type1;
            asterick = $8c356dd63d67489b$var$type3Asterick;
            str.push(obj);
        }
        $8c356dd63d67489b$var$inc(ptc, -1);
        prevKey = cToken;
    }
    for(j = ptc.length; j--;)// loop over ptc
    str.push($8c356dd63d67489b$var$closingParObj);
    if (allowed[5] !== true) throw new $e7a8d7aec9c520f9$exports.Exception('complete the expression');
    while(bracToClose--)str.push($8c356dd63d67489b$var$closingParObj);
    str.push($8c356dd63d67489b$var$closingParObj);
    //        console.log(str);
    return new $e7a8d7aec9c520f9$exports(str);
};
$8c356dd63d67489b$exports = $e7a8d7aec9c520f9$exports;


$8c356dd63d67489b$exports.prototype.toPostfix = function() {
    'use strict';
    var post = [], elem, popped, prep, pre, ele;
    var stack = [
        {
            value: "(",
            type: 4,
            pre: 0
        }
    ];
    var arr = this.value;
    for(var i = 1; i < arr.length; i++){
        if (arr[i].type === 1 || arr[i].type === 3 || arr[i].type === 13) {
            if (arr[i].type === 1) arr[i].value = Number(arr[i].value);
            post.push(arr[i]);
        } else if (arr[i].type === 4) stack.push(arr[i]);
        else if (arr[i].type === 5) while((popped = stack.pop()).type !== 4)post.push(popped);
        else if (arr[i].type === 11) {
            while((popped = stack.pop()).type !== 4)post.push(popped);
            stack.push(popped);
        } else {
            elem = arr[i];
            pre = elem.pre;
            ele = stack[stack.length - 1];
            prep = ele.pre;
            var flag = ele.value == 'Math.pow' && elem.value == 'Math.pow';
            if (pre > prep) stack.push(elem);
            else {
                while(prep >= pre && !flag || flag && pre < prep){
                    popped = stack.pop();
                    ele = stack[stack.length - 1];
                    post.push(popped);
                    prep = ele.pre;
                    flag = elem.value == 'Math.pow' && ele.value == 'Math.pow';
                }
                stack.push(elem);
            }
        }
    }
    return new $8c356dd63d67489b$exports(post);
};
$820a9ab144818dcd$exports = $8c356dd63d67489b$exports;


$820a9ab144818dcd$exports.prototype.postfixEval = function(UserDefined) {
    'use strict';
    UserDefined = UserDefined || {};
    UserDefined.PI = Math.PI;
    UserDefined.E = Math.E;
    var stack = [], pop1, pop2, pop3;
    var disp = [];
    var temp = '';
    var arr = this.value;
    var bool = typeof UserDefined.n !== 'undefined';
    for(var i = 0; i < arr.length; i++){
        if (arr[i].type === 1) stack.push({
            value: arr[i].value,
            type: 1
        });
        else if (arr[i].type === 3) stack.push({
            value: UserDefined[arr[i].value],
            type: 1
        });
        else if (arr[i].type === 0) {
            if (typeof stack[stack.length - 1].type === 'undefined') stack[stack.length - 1].value.push(arr[i]);
            else stack[stack.length - 1].value = arr[i].value(stack[stack.length - 1].value);
        } else if (arr[i].type === 7) {
            if (typeof stack[stack.length - 1].type === 'undefined') stack[stack.length - 1].value.push(arr[i]);
            else stack[stack.length - 1].value = arr[i].value(stack[stack.length - 1].value);
        } else if (arr[i].type === 8) {
            var popped = [];
            for(var x = 0; x < arr[i].numberOfArguments; x++)popped.push(stack.pop().value);
            stack.push({
                type: 1,
                value: arr[i].value.apply(arr[i], popped.reverse())
            });
        } else if (arr[i].type === 10) {
            pop1 = stack.pop();
            pop2 = stack.pop();
            if (typeof pop2.type === 'undefined') {
                pop2.value = pop2.concat(pop1);
                pop2.value.push(arr[i]);
                stack.push(pop2);
            } else if (typeof pop1.type === 'undefined') {
                pop1.unshift(pop2);
                pop1.push(arr[i]);
                stack.push(pop1);
            } else stack.push({
                type: 1,
                value: arr[i].value(pop2.value, pop1.value)
            });
        } else if (arr[i].type === 2 || arr[i].type === 9) {
            pop1 = stack.pop();
            pop2 = stack.pop();
            if (typeof pop2.type === 'undefined') {
                pop2 = pop2.concat(pop1);
                pop2.push(arr[i]);
                stack.push(pop2);
            } else if (typeof pop1.type === 'undefined') {
                pop1.unshift(pop2);
                pop1.push(arr[i]);
                stack.push(pop1);
            } else stack.push({
                type: 1,
                value: arr[i].value(pop2.value, pop1.value)
            });
        } else if (arr[i].type === 12) {
            pop1 = stack.pop();
            if (typeof pop1.type !== 'undefined') pop1 = [
                pop1
            ];
            pop2 = stack.pop();
            pop3 = stack.pop();
            stack.push({
                type: 1,
                value: arr[i].value(pop3.value, pop2.value, new $820a9ab144818dcd$exports(pop1))
            });
        } else if (arr[i].type === 13) {
            if (bool) stack.push({
                value: UserDefined[arr[i].value],
                type: 3
            });
            else stack.push([
                arr[i]
            ]);
        }
    }
    if (stack.length > 1) throw new $820a9ab144818dcd$exports.Exception('Uncaught Syntax error');
    return stack[0].value > 1000000000000000 ? 'Infinity' : parseFloat(stack[0].value.toFixed(15));
};
$820a9ab144818dcd$exports.eval = function(str, tokens, obj) {
    if (typeof tokens === 'undefined') return this.lex(str).toPostfix().postfixEval();
    else if (typeof obj === 'undefined') {
        if (typeof tokens.length !== 'undefined') return this.lex(str, tokens).toPostfix().postfixEval();
        else return this.lex(str).toPostfix().postfixEval(tokens);
    } else return this.lex(str, tokens).toPostfix().postfixEval(obj);
};
$62cec72fee1f50e4$exports = $820a9ab144818dcd$exports;


$62cec72fee1f50e4$exports.prototype.formulaEval = function() {
    "use strict";
    var stack = [], pop1, pop2, pop3;
    var disp = [];
    var temp = '';
    var arr = this.value;
    for(var i = 0; i < arr.length; i++){
        if (arr[i].type === 1 || arr[i].type === 3) disp.push({
            value: arr[i].type === 3 ? arr[i].show : arr[i].value,
            type: 1
        });
        else if (arr[i].type === 13) disp.push({
            value: arr[i].show,
            type: 1
        });
        else if (arr[i].type === 0) disp[disp.length - 1] = {
            value: arr[i].show + (arr[i].show != "-" ? "(" : "") + disp[disp.length - 1].value + (arr[i].show != "-" ? ")" : ""),
            type: 0
        };
        else if (arr[i].type === 7) disp[disp.length - 1] = {
            value: (disp[disp.length - 1].type != 1 ? "(" : "") + disp[disp.length - 1].value + (disp[disp.length - 1].type != 1 ? ")" : "") + arr[i].show,
            type: 7
        };
        else if (arr[i].type === 10) {
            pop1 = disp.pop();
            pop2 = disp.pop();
            if (arr[i].show === 'P' || arr[i].show === 'C') disp.push({
                value: "<sup>" + pop2.value + "</sup>" + arr[i].show + "<sub>" + pop1.value + "</sub>",
                type: 10
            });
            else disp.push({
                value: (pop2.type != 1 ? "(" : "") + pop2.value + (pop2.type != 1 ? ")" : "") + "<sup>" + pop1.value + "</sup>",
                type: 1
            });
        } else if (arr[i].type === 2 || arr[i].type === 9) {
            pop1 = disp.pop();
            pop2 = disp.pop();
            disp.push({
                value: (pop2.type != 1 ? "(" : "") + pop2.value + (pop2.type != 1 ? ")" : "") + arr[i].show + (pop1.type != 1 ? "(" : "") + pop1.value + (pop1.type != 1 ? ")" : ""),
                type: arr[i].type
            });
        } else if (arr[i].type === 12) {
            pop1 = disp.pop();
            pop2 = disp.pop();
            pop3 = disp.pop();
            disp.push({
                value: arr[i].show + "(" + pop3.value + "," + pop2.value + "," + pop1.value + ")",
                type: 12
            });
        }
    }
    return disp[0].value;
};
$167f9e8a14f16add$exports = $62cec72fee1f50e4$exports;


/**
 * Constantes
 */ var $c8691c276e5a853c$var$MAX_STACK = 100 // should be enough for a single calc()...
;
var $c8691c276e5a853c$var$NESTED_CALC_RE = /(\+|\-|\*|\\|[^a-z]|)(\s*)(\()/g;
/**
 * Global variables
 */ var $c8691c276e5a853c$var$stack;
/**
 * Expose reduceCSSCalc plugin
 *
 * @type {Function}
 */ $c8691c276e5a853c$exports = $c8691c276e5a853c$var$reduceCSSCalc;
/**
 * Reduce CSS calc() in a string, whenever it's possible
 *
 * @param {String} value css input
 */ function $c8691c276e5a853c$var$reduceCSSCalc(value, decimalPrecision) {
    $c8691c276e5a853c$var$stack = 0;
    decimalPrecision = Math.pow(10, decimalPrecision === undefined ? 5 : decimalPrecision);
    // Allow calc() on multiple lines
    value = value.replace(/\n+/g, " ");
    /**
   * Evaluates an expression
   *
   * @param {String} expression
   * @returns {String}
   */ function evaluateExpression(expression, functionIdentifier, call) {
        if ($c8691c276e5a853c$var$stack++ > $c8691c276e5a853c$var$MAX_STACK) {
            $c8691c276e5a853c$var$stack = 0;
            throw new Error("Call stack overflow for " + call);
        }
        if (expression === "") throw new Error(functionIdentifier + "(): '" + call + "' must contain a non-whitespace string");
        expression = evaluateNestedExpression(expression, call);
        var units = $c8691c276e5a853c$var$getUnitsInExpression(expression);
        // If the expression contains multiple units or CSS variables,
        // then let the expression be (i.e. browser calc())
        if (units.length > 1 || expression.indexOf("var(") > -1) return functionIdentifier + "(" + expression + ")";
        var unit = units[0] || "";
        if (unit === "%") // Convert percentages to numbers, to handle expressions like: 50% * 50% (will become: 25%):
        // console.log(expression)
        expression = expression.replace(/\b[0-9\.]+%/g, function(percent) {
            return parseFloat(percent.slice(0, -1)) * 0.01;
        });
        // Remove units in expression:
        var toEvaluate = expression.replace(new RegExp(unit, "gi"), "");
        var result;
        try {
            result = $167f9e8a14f16add$exports.eval(toEvaluate);
        } catch (e) {
            return functionIdentifier + "(" + expression + ")";
        }
        // Transform back to a percentage result:
        if (unit === "%") result *= 100;
        // adjust rounding shit
        // (0.1 * 0.2 === 0.020000000000000004)
        if (functionIdentifier.length || unit === "%") result = Math.round(result * decimalPrecision) / decimalPrecision;
        // Add unit
        result += unit;
        return result;
    }
    /**
   * Evaluates nested expressions
   *
   * @param {String} expression
   * @returns {String}
   */ function evaluateNestedExpression(expression, call) {
        // Remove the calc part from nested expressions to ensure
        // better browser compatibility
        expression = expression.replace(/((?:\-[a-z]+\-)?calc)/g, "");
        var evaluatedPart = "";
        var nonEvaluatedPart = expression;
        var matches;
        while(matches = $c8691c276e5a853c$var$NESTED_CALC_RE.exec(nonEvaluatedPart)){
            if (matches[0].index > 0) evaluatedPart += nonEvaluatedPart.substring(0, matches[0].index);
            var balancedExpr = $d8858058c7f05a18$exports("(", ")", nonEvaluatedPart.substring([
                0
            ].index));
            if (balancedExpr.body === "") throw new Error("'" + expression + "' must contain a non-whitespace string");
            var evaluated = evaluateExpression(balancedExpr.body, "", call);
            evaluatedPart += balancedExpr.pre + evaluated;
            nonEvaluatedPart = balancedExpr.post;
        }
        return evaluatedPart + nonEvaluatedPart;
    }
    return $0d966ba42808a3d5$exports(value, /((?:\-[a-z]+\-)?calc)\(/, evaluateExpression);
}
/**
 * Checks what units are used in an expression
 *
 * @param {String} expression
 * @returns {Array}
 */ function $c8691c276e5a853c$var$getUnitsInExpression(expression) {
    var uniqueUnits = [];
    var uniqueLowerCaseUnits = [];
    var unitRegEx = /[\.0-9]([%a-z]+)/gi;
    var matches = unitRegEx.exec(expression);
    while(matches){
        if (!matches || !matches[1]) continue;
        if (uniqueLowerCaseUnits.indexOf(matches[1].toLowerCase()) === -1) {
            uniqueUnits.push(matches[1]);
            uniqueLowerCaseUnits.push(matches[1].toLowerCase());
        }
        matches = unitRegEx.exec(expression);
    }
    return uniqueUnits;
}


function $e78b926df1936c47$export$2e2bcd8739ae039(func, resolver) {
    const cache = new Map();
    return function memoized() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        const key = resolver(...args);
        if (cache.has(key)) return cache.get(key);
        const result = func.apply(this, args);
        cache.set(key, result);
        return result;
    };
}


const $7c1a017409158fda$var$MEASUREMENT_ELEMENT_ID = '__react_svg_text_measurement_id';
function $7c1a017409158fda$var$getStringWidth(str, style) {
    if (typeof document === 'undefined') return null;
    try {
        // Calculate length of each word to be used to determine number of words per line
        let textEl = document.getElementById($7c1a017409158fda$var$MEASUREMENT_ELEMENT_ID);
        if (!textEl) {
            const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            svg.setAttribute('aria-hidden', 'true');
            svg.style.width = '0';
            svg.style.height = '0';
            svg.style.position = 'absolute';
            svg.style.top = '-100%';
            svg.style.left = '-100%';
            textEl = document.createElementNS('http://www.w3.org/2000/svg', 'text');
            textEl.setAttribute('id', $7c1a017409158fda$var$MEASUREMENT_ELEMENT_ID);
            svg.appendChild(textEl);
            document.body.appendChild(svg);
        }
        Object.assign(textEl.style, style);
        textEl.textContent = str;
        return textEl.getComputedTextLength();
    } catch  {
        return null;
    }
}
var $7c1a017409158fda$export$2e2bcd8739ae039 = (0, $e78b926df1936c47$export$2e2bcd8739ae039)($7c1a017409158fda$var$getStringWidth, (str, style)=>`${str}_${JSON.stringify(style)}`);


function $e878f6fa2473b9e0$var$isNumber(val) {
    return typeof val === 'number';
}
function $e878f6fa2473b9e0$var$isXOrYInValid(xOrY) {
    return(// number that is not NaN or Infinity
    typeof xOrY === 'number' && Number.isFinite(xOrY) || // for percentage
    typeof xOrY === 'string');
}
function $e878f6fa2473b9e0$export$2e2bcd8739ae039(props) {
    const { verticalAnchor: verticalAnchor = 'end', scaleToFit: scaleToFit = false, angle: angle, width: width, lineHeight: lineHeight = '1em', capHeight: capHeight = '0.71em', children: // Magic number from d3
    children, style: style, ...textProps } = props;
    const { x: x = 0, y: y = 0 } = textProps;
    const isXOrYNotValid = !$e878f6fa2473b9e0$var$isXOrYInValid(x) || !$e878f6fa2473b9e0$var$isXOrYInValid(y);
    const { wordsWithWidth: wordsWithWidth, spaceWidth: spaceWidth } = (0, $5E6i4.useMemo)(()=>{
        const words = children == null ? [] : children.toString().split(/(?:(?!\u00A0+)\s+)/);
        return {
            wordsWithWidth: words.map((word)=>({
                    word: word,
                    wordWidth: (0, $7c1a017409158fda$export$2e2bcd8739ae039)(word, style) || 0
                })),
            spaceWidth: (0, $7c1a017409158fda$export$2e2bcd8739ae039)('\u00A0', style) || 0
        };
    }, [
        children,
        style
    ]);
    const wordsByLines = (0, $5E6i4.useMemo)(()=>{
        if (isXOrYNotValid) return [];
        // Only perform calculations if using features that require them (multiline, scaleToFit)
        if (width || scaleToFit) return wordsWithWidth.reduce((result, _ref)=>{
            let { word: word, wordWidth: wordWidth } = _ref;
            const currentLine = result[result.length - 1];
            if (currentLine && (width == null || scaleToFit || (currentLine.width || 0) + wordWidth + spaceWidth < width)) {
                // Word can be added to an existing line
                currentLine.words.push(word);
                currentLine.width = currentLine.width || 0;
                currentLine.width += wordWidth + spaceWidth;
            } else {
                // Add first word to line or word is too long to scaleToFit on existing line
                const newLine = {
                    words: [
                        word
                    ],
                    width: wordWidth
                };
                result.push(newLine);
            }
            return result;
        }, []);
        return [
            {
                words: children == null ? [] : children.toString().split(/(?:(?!\u00A0+)\s+)/)
            }
        ];
    }, [
        isXOrYNotValid,
        width,
        scaleToFit,
        children,
        wordsWithWidth,
        spaceWidth
    ]);
    const startDy = (0, $5E6i4.useMemo)(()=>{
        const startDyStr = isXOrYNotValid ? '' : verticalAnchor === 'start' ? (0, (/*@__PURE__*/$parcel$interopDefault($c8691c276e5a853c$exports)))(`calc(${capHeight})`) : verticalAnchor === 'middle' ? (0, (/*@__PURE__*/$parcel$interopDefault($c8691c276e5a853c$exports)))(`calc(${(wordsByLines.length - 1) / 2} * -${lineHeight} + (${capHeight} / 2))`) : (0, (/*@__PURE__*/$parcel$interopDefault($c8691c276e5a853c$exports)))(`calc(${wordsByLines.length - 1} * -${lineHeight})`);
        return startDyStr;
    }, [
        isXOrYNotValid,
        verticalAnchor,
        capHeight,
        wordsByLines.length,
        lineHeight
    ]);
    const transform = (0, $5E6i4.useMemo)(()=>{
        const transforms = [];
        if (isXOrYNotValid) return '';
        if ($e878f6fa2473b9e0$var$isNumber(x) && $e878f6fa2473b9e0$var$isNumber(y) && $e878f6fa2473b9e0$var$isNumber(width) && scaleToFit && wordsByLines.length > 0) {
            const lineWidth = wordsByLines[0].width || 1;
            const sx = scaleToFit === 'shrink-only' ? Math.min(width / lineWidth, 1) : width / lineWidth;
            const sy = sx;
            const originX = x - sx * x;
            const originY = y - sy * y;
            transforms.push(`matrix(${sx}, 0, 0, ${sy}, ${originX}, ${originY})`);
        }
        if (angle) transforms.push(`rotate(${angle}, ${x}, ${y})`);
        return transforms.length > 0 ? transforms.join(' ') : '';
    }, [
        isXOrYNotValid,
        x,
        y,
        width,
        scaleToFit,
        wordsByLines,
        angle
    ]);
    return {
        wordsByLines: wordsByLines,
        startDy: startDy,
        transform: transform
    };
}



const $6f18bc0a5cbf18e6$var$SVG_STYLE = {
    overflow: 'visible'
};
function $6f18bc0a5cbf18e6$export$2e2bcd8739ae039(props) {
    const { dx: dx = 0, dy: dy = 0, textAnchor: textAnchor = 'start', innerRef: innerRef, innerTextRef: innerTextRef, verticalAnchor: verticalAnchor, angle: angle, lineHeight: lineHeight = '1em', scaleToFit: // eslint-disable-next-line @typescript-eslint/no-unused-vars
    scaleToFit = false, capHeight: capHeight, width: width, ...textProps } = props;
    const { x: x = 0, fontSize: fontSize } = textProps;
    const { wordsByLines: wordsByLines, startDy: startDy, transform: transform } = (0, $e878f6fa2473b9e0$export$2e2bcd8739ae039)(props);
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("svg", {
        ref: innerRef,
        x: dx,
        y: dy,
        fontSize: fontSize,
        style: $6f18bc0a5cbf18e6$var$SVG_STYLE,
        children: wordsByLines.length > 0 ? /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("text", {
            ref: innerTextRef,
            transform: transform,
            ...textProps,
            textAnchor: textAnchor,
            children: wordsByLines.map((line, index)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("tspan", {
                    x: x,
                    dy: index === 0 ? startDy : lineHeight,
                    children: line.words.join(' ')
                }, index))
        }) : null
    });
}







var $5E6i4 = parcelRequire("5E6i4");
function $7979479b9515458b$var$g(n, t) {
    let o;
    return (...i)=>{
        window.clearTimeout(o), o = window.setTimeout(()=>n(...i), t);
    };
}
function $7979479b9515458b$export$2e2bcd8739ae039({ debounce: n, scroll: t, polyfill: o, offsetSize: i } = {
    debounce: 0,
    scroll: !1,
    offsetSize: !1
}) {
    const a = o || (typeof window == "undefined" ? class {
    } : window.ResizeObserver);
    if (!a) throw new Error("This browser does not support ResizeObserver out of the box. See: https://github.com/react-spring/react-use-measure/#resize-observer-polyfills");
    const [c, h] = (0, $5E6i4.useState)({
        left: 0,
        top: 0,
        width: 0,
        height: 0,
        bottom: 0,
        right: 0,
        x: 0,
        y: 0
    }), e = (0, $5E6i4.useRef)({
        element: null,
        scrollContainers: null,
        resizeObserver: null,
        lastBounds: c,
        orientationHandler: null
    }), d = n ? typeof n == "number" ? n : n.scroll : null, f = n ? typeof n == "number" ? n : n.resize : null, w = (0, $5E6i4.useRef)(!1);
    (0, $5E6i4.useEffect)(()=>(w.current = !0, ()=>void (w.current = !1)));
    const [z, m, s] = (0, $5E6i4.useMemo)(()=>{
        const r = ()=>{
            if (!e.current.element) return;
            const { left: y, top: C, width: H, height: O, bottom: S, right: x, x: B, y: R } = e.current.element.getBoundingClientRect(), l = {
                left: y,
                top: C,
                width: H,
                height: O,
                bottom: S,
                right: x,
                x: B,
                y: R
            };
            e.current.element instanceof HTMLElement && i && (l.height = e.current.element.offsetHeight, l.width = e.current.element.offsetWidth), Object.freeze(l), w.current && !$7979479b9515458b$var$D(e.current.lastBounds, l) && h(e.current.lastBounds = l);
        };
        return [
            r,
            f ? $7979479b9515458b$var$g(r, f) : r,
            d ? $7979479b9515458b$var$g(r, d) : r
        ];
    }, [
        h,
        i,
        d,
        f
    ]);
    function v() {
        e.current.scrollContainers && (e.current.scrollContainers.forEach((r)=>r.removeEventListener("scroll", s, !0)), e.current.scrollContainers = null), e.current.resizeObserver && (e.current.resizeObserver.disconnect(), e.current.resizeObserver = null), e.current.orientationHandler && ("orientation" in screen && "removeEventListener" in screen.orientation ? screen.orientation.removeEventListener("change", e.current.orientationHandler) : "onorientationchange" in window && window.removeEventListener("orientationchange", e.current.orientationHandler));
    }
    function b() {
        e.current.element && (e.current.resizeObserver = new a(s), e.current.resizeObserver.observe(e.current.element), t && e.current.scrollContainers && e.current.scrollContainers.forEach((r)=>r.addEventListener("scroll", s, {
                capture: !0,
                passive: !0
            })), e.current.orientationHandler = ()=>{
            s();
        }, "orientation" in screen && "addEventListener" in screen.orientation ? screen.orientation.addEventListener("change", e.current.orientationHandler) : "onorientationchange" in window && window.addEventListener("orientationchange", e.current.orientationHandler));
    }
    const L = (r)=>{
        !r || r === e.current.element || (v(), e.current.element = r, e.current.scrollContainers = $7979479b9515458b$var$E(r), b());
    };
    return $7979479b9515458b$var$X(s, !!t), $7979479b9515458b$var$W(m), (0, $5E6i4.useEffect)(()=>{
        v(), b();
    }, [
        t,
        s,
        m
    ]), (0, $5E6i4.useEffect)(()=>v, []), [
        L,
        c,
        z
    ];
}
function $7979479b9515458b$var$W(n) {
    (0, $5E6i4.useEffect)(()=>{
        const t = n;
        return window.addEventListener("resize", t), ()=>void window.removeEventListener("resize", t);
    }, [
        n
    ]);
}
function $7979479b9515458b$var$X(n, t) {
    (0, $5E6i4.useEffect)(()=>{
        if (t) {
            const o = n;
            return window.addEventListener("scroll", o, {
                capture: !0,
                passive: !0
            }), ()=>void window.removeEventListener("scroll", o, !0);
        }
    }, [
        n,
        t
    ]);
}
function $7979479b9515458b$var$E(n) {
    const t = [];
    if (!n || n === document.body) return t;
    const { overflow: o, overflowX: i, overflowY: a } = window.getComputedStyle(n);
    return [
        o,
        i,
        a
    ].some((c)=>c === "auto" || c === "scroll") && t.push(n), [
        ...t,
        ...$7979479b9515458b$var$E(n.parentElement)
    ];
}
const $7979479b9515458b$var$k = [
    "x",
    "y",
    "top",
    "bottom",
    "left",
    "right",
    "width",
    "height"
], $7979479b9515458b$var$D = (n, t)=>$7979479b9515458b$var$k.every((o)=>n[o] === t[o]);




function $81e548fc4e144797$export$2e2bcd8739ae039(_ref) {
    let { anchorLineOrientation: anchorLineOrientation, anchorLineStroke: anchorLineStroke, verticalAnchor: verticalAnchor, horizontalAnchor: horizontalAnchor, width: width, height: height } = _ref;
    const backgroundOutline = {
        stroke: anchorLineStroke,
        strokeWidth: 2
    };
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)((0, $90cae257cc958273$exports.Fragment), {
        children: [
            anchorLineOrientation === 'horizontal' && verticalAnchor === 'start' && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("line", {
                ...backgroundOutline,
                x1: 0,
                x2: width,
                y1: 0,
                y2: 0
            }),
            anchorLineOrientation === 'horizontal' && verticalAnchor === 'end' && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("line", {
                ...backgroundOutline,
                x1: 0,
                x2: width,
                y1: height,
                y2: height
            }),
            anchorLineOrientation === 'vertical' && horizontalAnchor === 'start' && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("line", {
                ...backgroundOutline,
                x1: 0,
                x2: 0,
                y1: 0,
                y2: height
            }),
            anchorLineOrientation === 'vertical' && horizontalAnchor === 'end' && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("line", {
                ...backgroundOutline,
                x1: width,
                x2: width,
                y1: 0,
                y2: height
            })
        ]
    });
}



const $745d31e6a5f1a5e9$var$DEFAULT_PADDING = {
    top: 12,
    right: 12,
    bottom: 12,
    left: 12
};
function $745d31e6a5f1a5e9$var$getCompletePadding(padding) {
    if (typeof padding === 'undefined') return $745d31e6a5f1a5e9$var$DEFAULT_PADDING;
    if (typeof padding === 'number') return {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
    return {
        ...$745d31e6a5f1a5e9$var$DEFAULT_PADDING,
        ...padding
    };
}
function $745d31e6a5f1a5e9$export$2e2bcd8739ae039(_ref) {
    let { anchorLineStroke: anchorLineStroke = '#222', backgroundFill: backgroundFill = '#eaeaea', backgroundPadding: backgroundPadding, backgroundProps: backgroundProps, className: className, fontColor: fontColor = '#222', horizontalAnchor: propsHorizontalAnchor, resizeObserverPolyfill: resizeObserverPolyfill, showAnchorLine: showAnchorLine = true, showBackground: showBackground = true, subtitle: subtitle, subtitleDy: subtitleDy = 4, subtitleFontSize: subtitleFontSize = 12, subtitleFontWeight: subtitleFontWeight = 200, subtitleProps: subtitleProps, title: title, titleFontSize: titleFontSize = 16, titleFontWeight: titleFontWeight = 600, titleProps: titleProps, verticalAnchor: propsVerticalAnchor, width: propWidth, maxWidth: maxWidth = 125, x: propsX, y: propsY } = _ref;
    // we must measure the rendered html content to compute container height
    const [titleRef, titleBounds] = (0, $7979479b9515458b$export$2e2bcd8739ae039)({
        polyfill: resizeObserverPolyfill
    });
    const [subtitleRef, subtitleBounds] = (0, $7979479b9515458b$export$2e2bcd8739ae039)({
        polyfill: resizeObserverPolyfill
    });
    const padding = (0, $5E6i4.useMemo)(()=>$745d31e6a5f1a5e9$var$getCompletePadding(backgroundPadding), [
        backgroundPadding
    ]);
    // if props are provided, they take precedence over context
    const { x: x = 0, y: y = 0, dx: dx = 0, dy: dy = 0 } = (0, $5E6i4.useContext)((0, $c3d210f80631e294$export$2e2bcd8739ae039));
    const height = Math.floor(padding.top + padding.bottom + (titleBounds.height ?? 0) + (subtitleBounds.height ?? 0));
    const { wordsByLines: titleWordsByLine } = (0, $e878f6fa2473b9e0$export$2e2bcd8739ae039)({
        children: title,
        verticalAnchor: 'start',
        capHeight: titleFontSize,
        fontSize: titleFontSize,
        fontWeight: titleFontWeight,
        fontFamily: titleProps?.fontFamily,
        width: maxWidth,
        ...titleProps
    });
    const { wordsByLines: subtitleWordsByLine } = (0, $e878f6fa2473b9e0$export$2e2bcd8739ae039)({
        children: subtitle,
        verticalAnchor: 'start',
        capHeight: subtitleFontSize,
        fontSize: subtitleFontSize,
        fontWeight: subtitleFontWeight,
        fontFamily: subtitleProps?.fontFamily,
        width: maxWidth,
        ...subtitleProps
    });
    const titleMeasuredWidth = titleWordsByLine.reduce((maxTitleWidth, line)=>Math.max(maxTitleWidth, line.width ?? 0), 0);
    const subtitleMeasuredWidth = subtitleWordsByLine.reduce((maxSubtitleWidth, line)=>Math.max(maxSubtitleWidth, line.width ?? 0), 0);
    const textMeasuredWidth = Math.ceil(Math.min(maxWidth, Math.max(titleMeasuredWidth, subtitleMeasuredWidth)));
    const measuredWidth = padding.right + padding.left + textMeasuredWidth;
    const width = propWidth ?? measuredWidth;
    const innerWidth = width - padding.left - padding.right;
    // offset container position based on horizontal + vertical anchor
    const horizontalAnchor = propsHorizontalAnchor || (Math.abs(dx) < Math.abs(dy) ? 'middle' : dx > 0 ? 'start' : 'end');
    const verticalAnchor = propsVerticalAnchor || (Math.abs(dx) > Math.abs(dy) ? 'middle' : dy > 0 ? 'start' : 'end');
    const containerCoords = (0, $5E6i4.useMemo)(()=>{
        let adjustedX = propsX == null ? x + dx : propsX;
        let adjustedY = propsY == null ? y + dy : propsY;
        if (horizontalAnchor === 'middle') adjustedX -= width / 2;
        if (horizontalAnchor === 'end') adjustedX -= width;
        if (verticalAnchor === 'middle') adjustedY -= height / 2;
        if (verticalAnchor === 'end') adjustedY -= height;
        return {
            x: adjustedX,
            y: adjustedY
        };
    }, [
        propsX,
        x,
        dx,
        propsY,
        y,
        dy,
        horizontalAnchor,
        verticalAnchor,
        width,
        height
    ]);
    const titleFontFamily = titleProps?.fontFamily;
    const titleStyle = (0, $5E6i4.useMemo)(()=>({
            fontSize: titleFontSize,
            fontWeight: titleFontWeight,
            fontFamily: titleFontFamily
        }), [
        titleFontSize,
        titleFontWeight,
        titleFontFamily
    ]);
    const subtitleFontFamily = subtitleProps?.fontFamily;
    const subtitleStyle = (0, $5E6i4.useMemo)(()=>({
            fontSize: subtitleFontSize,
            fontWeight: subtitleFontWeight,
            fontFamily: subtitleFontFamily
        }), [
        subtitleFontSize,
        subtitleFontWeight,
        subtitleFontFamily
    ]);
    return !title && !subtitle ? null : /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)((0, $268dd56f34f61467$export$2e2bcd8739ae039), {
        top: containerCoords.y,
        left: containerCoords.x,
        pointerEvents: "none",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-annotationlabel', className),
        opacity: titleBounds.height === 0 && subtitleBounds.height === 0 ? 0 : 1,
        children: [
            showBackground && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("rect", {
                className: "visx-annotationlabel-background",
                fill: backgroundFill,
                x: 0,
                y: 0,
                width: width,
                height: height,
                ...backgroundProps
            }),
            showAnchorLine && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $81e548fc4e144797$export$2e2bcd8739ae039), {
                anchorLineOrientation: Math.abs(dx) > Math.abs(dy) ? 'vertical' : 'horizontal',
                anchorLineStroke: anchorLineStroke,
                verticalAnchor: verticalAnchor,
                horizontalAnchor: horizontalAnchor,
                width: width,
                height: height
            }),
            title && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $6f18bc0a5cbf18e6$export$2e2bcd8739ae039), {
                innerTextRef: titleRef,
                fill: fontColor,
                verticalAnchor: "start",
                x: padding.left + (titleProps?.textAnchor === 'middle' ? innerWidth / 2 : 0),
                y: padding.top,
                width: innerWidth,
                capHeight: titleFontSize // capHeight should match fontSize, used for first line line height
                ,
                style: titleStyle // used for size calculation
                ,
                ...titleProps,
                children: title
            }),
            subtitle && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $6f18bc0a5cbf18e6$export$2e2bcd8739ae039), {
                innerTextRef: subtitleRef,
                fill: fontColor,
                verticalAnchor: "start",
                x: padding.left + (subtitleProps?.textAnchor === 'middle' ? innerWidth / 2 : 0),
                y: padding.top + (titleBounds.height ?? 0),
                dy: title ? subtitleDy : 0,
                width: innerWidth,
                capHeight: subtitleFontSize // capHeight should match fontSize, used for first line line height
                ,
                style: subtitleStyle // used for size calculation
                ,
                ...subtitleProps,
                children: subtitle
            })
        ]
    });
}



var $5E6i4 = parcelRequire("5E6i4");






const $491211f3b50ef8c7$var$wrapperStyle = {
    display: 'inline-block'
};
function $491211f3b50ef8c7$export$2e2bcd8739ae039(_ref) {
    let { anchorLineStroke: anchorLineStroke = '#222', children: children, className: className, containerStyle: containerStyle, horizontalAnchor: propsHorizontalAnchor, resizeObserverPolyfill: resizeObserverPolyfill, showAnchorLine: showAnchorLine = true, verticalAnchor: propsVerticalAnchor, x: propsX, y: propsY } = _ref;
    // we must measure the rendered title + subtitle to compute container height
    const [labelRef, titleBounds] = (0, $7979479b9515458b$export$2e2bcd8739ae039)({
        polyfill: resizeObserverPolyfill
    });
    const { width: width, height: height } = titleBounds;
    // if props are provided, they take precedence over context
    const { x: x = 0, y: y = 0, dx: dx = 0, dy: dy = 0 } = (0, $5E6i4.useContext)((0, $c3d210f80631e294$export$2e2bcd8739ae039));
    // offset container position based on horizontal + vertical anchor
    const horizontalAnchor = propsHorizontalAnchor || (Math.abs(dx) < Math.abs(dy) ? 'middle' : dx > 0 ? 'start' : 'end');
    const verticalAnchor = propsVerticalAnchor || (Math.abs(dx) > Math.abs(dy) ? 'middle' : dy > 0 ? 'start' : 'end');
    const containerCoords = (0, $5E6i4.useMemo)(()=>{
        let adjustedX = propsX == null ? x + dx : propsX;
        let adjustedY = propsY == null ? y + dy : propsY;
        if (horizontalAnchor === 'middle') adjustedX -= width / 2;
        if (horizontalAnchor === 'end') adjustedX -= width;
        if (verticalAnchor === 'middle') adjustedY -= height / 2;
        if (verticalAnchor === 'end') adjustedY -= height;
        return {
            x: adjustedX,
            y: adjustedY
        };
    }, [
        propsX,
        x,
        dx,
        propsY,
        y,
        dy,
        horizontalAnchor,
        verticalAnchor,
        width,
        height
    ]);
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)((0, $268dd56f34f61467$export$2e2bcd8739ae039), {
        top: containerCoords.y,
        left: containerCoords.x,
        pointerEvents: "none",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-annotationlabel', className),
        children: [
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("foreignObject", {
                width: width,
                height: height,
                overflow: "visible",
                children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("div", {
                    ref: labelRef,
                    style: containerStyle ? {
                        ...$491211f3b50ef8c7$var$wrapperStyle,
                        ...containerStyle
                    } : $491211f3b50ef8c7$var$wrapperStyle,
                    children: children
                })
            }),
            showAnchorLine && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $81e548fc4e144797$export$2e2bcd8739ae039), {
                anchorLineOrientation: Math.abs(dx) > Math.abs(dy) ? 'vertical' : 'horizontal',
                anchorLineStroke: anchorLineStroke,
                verticalAnchor: verticalAnchor,
                horizontalAnchor: horizontalAnchor,
                width: width,
                height: height
            })
        ]
    });
}



var $5E6i4 = parcelRequire("5E6i4");



function $a18816b548e9bea1$export$2e2bcd8739ae039(_ref) {
    let { className: className, x: propsX, y: propsY, stroke: stroke = '#222', radius: radius = 16, ...restProps } = _ref;
    // if props are provided, they take precedence over context
    const annotationContext = (0, $5E6i4.useContext)((0, $c3d210f80631e294$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("circle", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-annotation-subject', 'visx-annotation-subject-circle', className),
        cx: propsX || annotationContext.x,
        cy: propsY || annotationContext.y,
        r: radius,
        fill: "transparent",
        pointerEvents: "none",
        stroke: stroke,
        ...restProps
    });
}



var $5E6i4 = parcelRequire("5E6i4");



function $55a74deae7198147$export$2e2bcd8739ae039(_ref) {
    let { className: className, x: propsX, y: propsY, orientation: orientation = 'vertical', min: min, max: max, stroke: stroke = '#222', ...restProps } = _ref;
    // if props are provided, they take precedence over context
    const annotationContext = (0, $5E6i4.useContext)((0, $c3d210f80631e294$export$2e2bcd8739ae039));
    const lineIsVertical = orientation === 'vertical';
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("line", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-annotation-subject', 'visx-annotation-subject-line', className),
        x1: lineIsVertical ? propsX || annotationContext.x : min,
        x2: lineIsVertical ? propsX || annotationContext.x : max,
        y1: lineIsVertical ? min : propsY || annotationContext.y,
        y2: lineIsVertical ? max : propsY || annotationContext.y,
        fill: "transparent",
        pointerEvents: "none",
        stroke: stroke,
        ...restProps
    });
}



var $5E6i4 = parcelRequire("5E6i4");


function $66e1399a00a9dd25$export$2e2bcd8739ae039(_ref) {
    let { x: x, y: y, dx: dx, dy: dy, children: children } = _ref;
    const value = (0, $5E6i4.useMemo)(()=>({
            x: x,
            y: y,
            dx: dx,
            dy: dy
        }), [
        x,
        y,
        dx,
        dy
    ]);
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $c3d210f80631e294$export$2e2bcd8739ae039).Provider, {
        value: value,
        children: children
    });
}


/* eslint-disable react/jsx-handler-names */ 
var $5E6i4 = parcelRequire("5E6i4");
// @visx/drag
/* eslint-disable react/jsx-handler-names */ 
var $5E6i4 = parcelRequire("5E6i4");
// @visx/point
class $4f1f378f21d00070$export$2e2bcd8739ae039 {
    x = 0;
    y = 0;
    constructor(_ref){
        let { x: x = 0, y: y = 0 } = _ref;
        this.x = x;
        this.y = y;
    }
    value() {
        return {
            x: this.x,
            y: this.y
        };
    }
    toArray() {
        return [
            this.x,
            this.y
        ];
    }
}



function $e526e4a452699e2a$export$2e2bcd8739ae039(point1, point2) {
    return new (0, $4f1f378f21d00070$export$2e2bcd8739ae039)({
        x: point1.x + point2.x,
        y: point1.y + point2.y
    });
}



function $d484078227c9345d$export$2e2bcd8739ae039(point1, point2) {
    return new (0, $4f1f378f21d00070$export$2e2bcd8739ae039)({
        x: point1.x - point2.x,
        y: point1.y - point2.y
    });
}




// @visx/event

function $dbb594287616dc2c$export$45a5e7f76e0caa8d(elem) {
    return !!elem && elem instanceof Element;
}
function $dbb594287616dc2c$export$17eda790a720ec57(elem) {
    return !!elem && (elem instanceof SVGElement || 'ownerSVGElement' in elem);
}
function $dbb594287616dc2c$export$66957ea77182581d(elem) {
    return !!elem && 'createSVGPoint' in elem;
}
function $dbb594287616dc2c$export$d320b9df0ffd0744(elem) {
    return !!elem && 'getScreenCTM' in elem;
}
function $dbb594287616dc2c$export$c4dfce035d43d1e0(event) {
    return !!event && 'changedTouches' in event;
}
function $dbb594287616dc2c$export$764db16956f554f8(event) {
    return !!event && 'clientX' in event;
}
function $dbb594287616dc2c$export$9671ea99bd126ace(event) {
    return !!event && (event instanceof Event || 'nativeEvent' in event && event.nativeEvent instanceof Event);
}



const $1d51281c738afa62$var$DEFAULT_POINT = {
    x: 0,
    y: 0
};
function $1d51281c738afa62$export$2e2bcd8739ae039(event) {
    if (!event) return {
        ...$1d51281c738afa62$var$DEFAULT_POINT
    };
    if ((0, $dbb594287616dc2c$export$c4dfce035d43d1e0)(event)) return event.changedTouches.length > 0 ? {
        x: event.changedTouches[0].clientX,
        y: event.changedTouches[0].clientY
    } : {
        ...$1d51281c738afa62$var$DEFAULT_POINT
    };
    if ((0, $dbb594287616dc2c$export$764db16956f554f8)(event)) return {
        x: event.clientX,
        y: event.clientY
    };
    // for focus events try to extract the center position of the target element
    const target = event?.target;
    const boundingClientRect = target && 'getBoundingClientRect' in target ? target.getBoundingClientRect() : null;
    if (!boundingClientRect) return {
        ...$1d51281c738afa62$var$DEFAULT_POINT
    };
    return {
        x: boundingClientRect.x + boundingClientRect.width / 2,
        y: boundingClientRect.y + boundingClientRect.height / 2
    };
}


function $212dd266c057ccc6$export$2e2bcd8739ae039(node, event) {
    if (!node || !event) return null;
    const coords = (0, $1d51281c738afa62$export$2e2bcd8739ae039)(event);
    // find top-most SVG
    const svg = (0, $dbb594287616dc2c$export$17eda790a720ec57)(node) ? node.ownerSVGElement : node;
    const screenCTM = (0, $dbb594287616dc2c$export$d320b9df0ffd0744)(svg) ? svg.getScreenCTM() : null;
    if ((0, $dbb594287616dc2c$export$66957ea77182581d)(svg) && screenCTM) {
        let point = svg.createSVGPoint();
        point.x = coords.x;
        point.y = coords.y;
        point = point.matrixTransform(screenCTM.inverse());
        return new (0, $4f1f378f21d00070$export$2e2bcd8739ae039)({
            x: point.x,
            y: point.y
        });
    }
    // fall back to bounding box
    const rect = node.getBoundingClientRect();
    return new (0, $4f1f378f21d00070$export$2e2bcd8739ae039)({
        x: coords.x - rect.left - node.clientLeft,
        y: coords.y - rect.top - node.clientTop
    });
}



function $45e9151834fcba9b$export$2e2bcd8739ae039(nodeOrEvent, maybeEvent) {
    // localPoint(node, event)
    if ((0, $dbb594287616dc2c$export$45a5e7f76e0caa8d)(nodeOrEvent) && maybeEvent) return (0, $212dd266c057ccc6$export$2e2bcd8739ae039)(nodeOrEvent, maybeEvent);
    // localPoint(event)
    if ((0, $dbb594287616dc2c$export$9671ea99bd126ace)(nodeOrEvent)) {
        const event = nodeOrEvent;
        const node = event.target;
        if (node) return (0, $212dd266c057ccc6$export$2e2bcd8739ae039)(node, event);
    }
    return null;
}


// eslint-disable-next-line no-restricted-exports






var $5E6i4 = parcelRequire("5E6i4");
function $87c2b3247dacd8a6$export$2e2bcd8739ae039(initialState) {
    const [state, setState] = (0, $5E6i4.useState)(initialState);
    const callbackRef = (0, $5E6i4.useRef)(null);
    const setStateCallback = (0, $5E6i4.useCallback)((nextState, callback)=>{
        callbackRef.current = callback || null;
        setState(nextState);
    }, [
        setState
    ]);
    // if we use useEffect, some callback invocations are skipped
    (0, $5E6i4.useLayoutEffect)(()=>{
        // `null` on initial render, so we only execute callback on state *updates*
        if (callbackRef.current) {
            callbackRef.current(state);
            callbackRef.current = null; // reset callback after execution
        }
    }, [
        state
    ]);
    return [
        state,
        setStateCallback
    ];
}


/** Clamps number within the inclusive lower and upper bounds. */ function $61311192b2568209$export$2e2bcd8739ae039(number, lower, upper) {
    return Math.min(Math.max(number, lower), upper);
}


/** Gets closest point from list of points */ function $330a9348dd46de97$export$2e2bcd8739ae039(point, samples) {
    let closestPoint = point;
    let minDistance = Infinity;
    for (const sample of samples){
        const distance = Math.sqrt((sample.x - point.x) ** 2 + (sample.y - point.y) ** 2);
        if (distance < minDistance) {
            minDistance = distance;
            closestPoint = {
                x: sample.x,
                y: sample.y
            };
        }
    }
    return closestPoint;
}


function $d3ff5be71df305ea$export$2e2bcd8739ae039(point, samples) {
    let restrict = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (samples.length > 0) return (0, $330a9348dd46de97$export$2e2bcd8739ae039)(point, samples);
    return {
        x: (0, $61311192b2568209$export$2e2bcd8739ae039)(point.x, restrict.xMin ?? -Infinity, restrict.xMax ?? Infinity),
        y: (0, $61311192b2568209$export$2e2bcd8739ae039)(point.y, restrict.yMin ?? -Infinity, restrict.yMax ?? Infinity)
    };
}



var $5E6i4 = parcelRequire("5E6i4");
function $bcb67ca0a4fde02d$var$getSamples(restrictToPath, transform) {
    let precision = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    if (!restrictToPath) return [];
    const samples = [];
    const pathLength = restrictToPath.getTotalLength();
    for(let sampleLength = 0; sampleLength <= pathLength; sampleLength += precision){
        const sample = restrictToPath.getPointAtLength(sampleLength);
        const transformedSample = sample.matrixTransform(transform);
        samples.push(transformedSample);
    }
    return samples;
}
function $bcb67ca0a4fde02d$export$2e2bcd8739ae039(restrictToPath) {
    const samples = (0, $5E6i4.useMemo)(()=>{
        if (!restrictToPath) return [];
        const transform = restrictToPath.getCTM() || new DOMMatrix();
        return $bcb67ca0a4fde02d$var$getSamples(restrictToPath, transform);
    // The path can transform without triggering a re-render,
    // so we need to update the samples whenever the length changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        restrictToPath?.getTotalLength()
    ]);
    return samples;
}


function $70d882cb281c415b$export$2e2bcd8739ae039() {
    let { resetOnStart: resetOnStart = false, snapToPointer: snapToPointer = true, onDragEnd: onDragEnd, onDragMove: onDragMove, onDragStart: onDragStart, x: x, y: y, dx: dx, dy: dy, isDragging: isDragging, restrict: restrict = {}, restrictToPath: restrictToPath } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // use ref to detect prop changes
    const positionPropsRef = (0, $5E6i4.useRef)({
        x: x,
        y: y,
        dx: dx,
        dy: dy
    });
    const [dragState, setDragStateWithCallback] = (0, $87c2b3247dacd8a6$export$2e2bcd8739ae039)({
        x: x,
        y: y,
        dx: dx ?? 0,
        dy: dy ?? 0,
        isDragging: false
    });
    // Track distance between pointer on dragStart and position of element being dragged
    const [dragStartPointerOffset, setDragStartPointerOffset] = (0, $5E6i4.useState)(new (0, $4f1f378f21d00070$export$2e2bcd8739ae039)({
        x: 0,
        y: 0
    }));
    // if prop position changes, update state
    (0, $5E6i4.useEffect)(()=>{
        if (positionPropsRef.current.x !== x || positionPropsRef.current.y !== y || positionPropsRef.current.dx !== dx || positionPropsRef.current.dy !== dy) {
            positionPropsRef.current = {
                x: x,
                y: y,
                dx: dx,
                dy: dy
            };
            setDragStateWithCallback((currState)=>({
                    ...currState,
                    x: x,
                    y: y,
                    dx: dx ?? 0,
                    dy: dy ?? 0
                }));
        }
    });
    (0, $5E6i4.useEffect)(()=>{
        if (isDragging !== undefined && dragState.isDragging !== isDragging) setDragStateWithCallback((currState)=>({
                ...currState,
                isDragging: isDragging
            }));
    }, [
        dragState.isDragging,
        isDragging,
        setDragStateWithCallback
    ]);
    const restrictToPathSamples = (0, $bcb67ca0a4fde02d$export$2e2bcd8739ae039)(restrictToPath);
    const handleDragStart = (0, $5E6i4.useCallback)((event)=>{
        event.persist();
        setDragStateWithCallback((currState)=>{
            // eslint-disable-next-line no-shadow
            const { x: x = 0, y: y = 0, dx: dx, dy: dy } = currState;
            const currentPoint = new (0, $4f1f378f21d00070$export$2e2bcd8739ae039)({
                x: (x || 0) + dx,
                y: (y || 0) + dy
            });
            const eventPoint = (0, $45e9151834fcba9b$export$2e2bcd8739ae039)(event) || new (0, $4f1f378f21d00070$export$2e2bcd8739ae039)({
                x: 0,
                y: 0
            });
            const point = snapToPointer ? eventPoint : currentPoint;
            const dragPoint = (0, $d3ff5be71df305ea$export$2e2bcd8739ae039)(point, restrictToPathSamples, restrict);
            setDragStartPointerOffset((0, $d484078227c9345d$export$2e2bcd8739ae039)(currentPoint, eventPoint));
            return {
                isDragging: true,
                dx: resetOnStart ? 0 : currState.dx,
                dy: resetOnStart ? 0 : currState.dy,
                x: resetOnStart ? dragPoint.x : dragPoint.x - currState.dx,
                y: resetOnStart ? dragPoint.y : dragPoint.y - currState.dy
            };
        }, onDragStart && ((currState)=>{
            onDragStart({
                ...currState,
                event: event
            });
        }));
    }, [
        onDragStart,
        resetOnStart,
        restrict,
        restrictToPathSamples,
        setDragStateWithCallback,
        snapToPointer
    ]);
    const handleDragMove = (0, $5E6i4.useCallback)((event)=>{
        event.persist();
        setDragStateWithCallback((currState)=>{
            if (!currState.isDragging) return currState;
            // eslint-disable-next-line no-shadow
            const { x: x = 0, y: y = 0 } = currState;
            const pointerPoint = (0, $45e9151834fcba9b$export$2e2bcd8739ae039)(event) || new (0, $4f1f378f21d00070$export$2e2bcd8739ae039)({
                x: 0,
                y: 0
            });
            const point = snapToPointer ? pointerPoint : (0, $e526e4a452699e2a$export$2e2bcd8739ae039)(pointerPoint, dragStartPointerOffset);
            const dragPoint = (0, $d3ff5be71df305ea$export$2e2bcd8739ae039)(point, restrictToPathSamples, restrict);
            return {
                ...currState,
                dx: dragPoint.x - x,
                dy: dragPoint.y - y
            };
        }, onDragMove && ((currState)=>{
            if (currState.isDragging) onDragMove({
                ...currState,
                event: event
            });
        }));
    }, [
        setDragStateWithCallback,
        onDragMove,
        snapToPointer,
        dragStartPointerOffset,
        restrictToPathSamples,
        restrict
    ]);
    const handleDragEnd = (0, $5E6i4.useCallback)((event)=>{
        event.persist();
        setDragStateWithCallback((currState)=>({
                ...currState,
                isDragging: false
            }), onDragEnd && ((currState)=>{
            onDragEnd({
                ...currState,
                event: event
            });
        }));
    }, [
        onDragEnd,
        setDragStateWithCallback
    ]);
    return {
        ...dragState,
        dragEnd: handleDragEnd,
        dragMove: handleDragMove,
        dragStart: handleDragStart
    };
}



function $04ec6ca6caf932c8$export$2e2bcd8739ae039(_ref) {
    let { captureDragArea: captureDragArea = true, snapToPointer: snapToPointer = true, children: children, dx: dx, dy: dy, height: height, onDragEnd: onDragEnd, onDragMove: onDragMove, onDragStart: onDragStart, resetOnStart: resetOnStart, width: width, x: x, y: y, isDragging: isDragging, restrict: restrict, restrictToPath: restrictToPath } = _ref;
    const drag = (0, $70d882cb281c415b$export$2e2bcd8739ae039)({
        resetOnStart: resetOnStart,
        snapToPointer: snapToPointer,
        onDragEnd: onDragEnd,
        onDragMove: onDragMove,
        onDragStart: onDragStart,
        x: x,
        y: y,
        dx: dx,
        dy: dy,
        isDragging: isDragging,
        restrict: restrict,
        restrictToPath: restrictToPath
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)((0, $90cae257cc958273$exports.Fragment), {
        children: [
            drag.isDragging && captureDragArea && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("rect", {
                width: width,
                height: height,
                onPointerDown: drag.dragStart,
                onPointerMove: drag.dragMove,
                onPointerUp: drag.dragEnd,
                fill: "transparent"
            }),
            children(drag)
        ]
    });
}



/** Given at an array of items, moves the item at the specified index to the end of the array. */ function $2ed259ad9f4b089b$export$2e2bcd8739ae039(items, raiseIndex) {
    const array = [
        ...items
    ];
    const lastIndex = array.length - 1;
    const [raiseItem] = array.splice(raiseIndex, 1);
    array.splice(lastIndex, 0, raiseItem);
    return array;
}






const $b0f54f19bbad2881$var$defaultDragHandleProps = {
    r: 10,
    fill: 'transparent',
    stroke: '#777',
    strokeDasharray: '4,2',
    strokeWidth: 2
};
function $b0f54f19bbad2881$export$2e2bcd8739ae039(_ref) {
    let { canEditLabel: canEditLabel = true, canEditSubject: canEditSubject = true, children: children, dx: labelDx = 0, dy: labelDy = 0, height: height, labelDragHandleProps: labelDragHandleProps, onDragEnd: onDragEnd, onDragMove: onDragMove, onDragStart: onDragStart, subjectDragHandleProps: subjectDragHandleProps, width: width, x: subjectX = 0, y: subjectY = 0 } = _ref;
    // chicken before the egg, we need these to reference drag state
    // in drag callbacks which are defined before useDrag() state is available
    const subjectDragRef = (0, $5E6i4.useRef)(undefined);
    const labelDragRef = (0, $5E6i4.useRef)(undefined);
    const handleDragStart = (0, $5E6i4.useCallback)((_ref2)=>{
        let { event: event } = _ref2;
        if (onDragStart) onDragStart({
            event: event,
            x: subjectX + (subjectDragRef.current?.dx ?? 0),
            y: subjectY + (subjectDragRef.current?.dy ?? 0),
            dx: labelDx + (labelDragRef.current?.dx ?? 0),
            dy: labelDy + (labelDragRef.current?.dy ?? 0)
        });
    }, [
        labelDx,
        labelDy,
        onDragStart,
        subjectX,
        subjectY
    ]);
    const handleDragMove = (0, $5E6i4.useCallback)((_ref3)=>{
        let { event: event } = _ref3;
        if (onDragMove) onDragMove({
            event: event,
            x: subjectX + (subjectDragRef.current?.dx ?? 0),
            y: subjectY + (subjectDragRef.current?.dy ?? 0),
            dx: labelDx + (labelDragRef.current?.dx ?? 0),
            dy: labelDy + (labelDragRef.current?.dy ?? 0)
        });
    }, [
        labelDx,
        labelDy,
        onDragMove,
        subjectX,
        subjectY
    ]);
    const handleDragEnd = (0, $5E6i4.useCallback)((_ref4)=>{
        let { event: event } = _ref4;
        if (onDragEnd) onDragEnd({
            event: event,
            x: subjectX + (subjectDragRef.current?.dx ?? 0),
            y: subjectY + (subjectDragRef.current?.dy ?? 0),
            dx: labelDx + (labelDragRef.current?.dx ?? 0),
            dy: labelDy + (labelDragRef.current?.dy ?? 0)
        });
    }, [
        labelDx,
        labelDy,
        onDragEnd,
        subjectX,
        subjectY
    ]);
    const subjectDrag = (0, $70d882cb281c415b$export$2e2bcd8739ae039)({
        onDragStart: handleDragStart,
        onDragMove: handleDragMove,
        onDragEnd: handleDragEnd,
        x: subjectX,
        y: subjectY
    });
    const labelDrag = (0, $70d882cb281c415b$export$2e2bcd8739ae039)({
        onDragStart: handleDragStart,
        onDragMove: handleDragMove,
        onDragEnd: handleDragEnd,
        x: labelDx,
        y: labelDy
    });
    // enable referencing these in the callbacks defined before useDrag is called
    subjectDragRef.current = subjectDrag;
    labelDragRef.current = labelDrag;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)((0, $90cae257cc958273$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $66e1399a00a9dd25$export$2e2bcd8739ae039), {
                x: subjectX + subjectDrag.dx,
                y: subjectY + subjectDrag.dy,
                dx: labelDx + labelDrag.dx,
                dy: labelDy + labelDrag.dy,
                children: children
            }),
            subjectDrag.isDragging && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("rect", {
                width: width,
                height: height,
                onMouseMove: subjectDrag.dragMove,
                onMouseUp: subjectDrag.dragEnd,
                fill: "transparent"
            }),
            canEditSubject && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("circle", {
                cx: subjectX,
                cy: subjectY,
                transform: `translate(${subjectDrag.dx},${subjectDrag.dy})`,
                onMouseMove: subjectDrag.dragMove,
                onMouseUp: subjectDrag.dragEnd,
                onMouseDown: subjectDrag.dragStart,
                onTouchStart: subjectDrag.dragStart,
                onTouchMove: subjectDrag.dragMove,
                onTouchEnd: subjectDrag.dragEnd,
                cursor: subjectDrag.isDragging ? 'grabbing' : 'grab',
                ...$b0f54f19bbad2881$var$defaultDragHandleProps,
                ...subjectDragHandleProps
            }),
            labelDrag.isDragging && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("rect", {
                width: width,
                height: height,
                onMouseMove: labelDrag.dragMove,
                onMouseUp: labelDrag.dragEnd,
                fill: "transparent"
            }),
            canEditLabel && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("circle", {
                cx: subjectX + subjectDrag.dx + labelDx,
                cy: subjectY + subjectDrag.dy + labelDy,
                transform: `translate(${labelDrag.dx},${labelDrag.dy})`,
                onMouseMove: labelDrag.dragMove,
                onMouseUp: labelDrag.dragEnd,
                onMouseDown: labelDrag.dragStart,
                onTouchStart: labelDrag.dragStart,
                onTouchMove: labelDrag.dragMove,
                onTouchEnd: labelDrag.dragEnd,
                cursor: labelDrag.isDragging ? 'grabbing' : 'grab',
                ...$b0f54f19bbad2881$var$defaultDragHandleProps,
                ...labelDragHandleProps
            })
        ]
    });
}





// @visx/axis


var $b2a13829cfbee039$exports = {};

$parcel$export($b2a13829cfbee039$exports, "scaleBand", () => $55c09c3fb6b4542d$export$2e2bcd8739ae039);
$parcel$export($b2a13829cfbee039$exports, "scalePoint", () => $19667b65a701425c$export$2e2bcd8739ae039);
$parcel$export($b2a13829cfbee039$exports, "scaleLinear", () => $7c30a724ea2126a9$export$2e2bcd8739ae039);
$parcel$export($b2a13829cfbee039$exports, "scaleRadial", () => $9ea23020740d40b4$export$2e2bcd8739ae039);
$parcel$export($b2a13829cfbee039$exports, "scaleTime", () => $9293131f8df33854$export$2e2bcd8739ae039);
$parcel$export($b2a13829cfbee039$exports, "scaleUtc", () => $6d96436fd4fae85b$export$2e2bcd8739ae039);
$parcel$export($b2a13829cfbee039$exports, "scaleLog", () => $3be95b016ada5024$export$2e2bcd8739ae039);
$parcel$export($b2a13829cfbee039$exports, "scalePower", () => $de43f0bde6acd688$export$2e2bcd8739ae039);
$parcel$export($b2a13829cfbee039$exports, "scaleOrdinal", () => $5d94097fa39ec873$export$2e2bcd8739ae039);
$parcel$export($b2a13829cfbee039$exports, "scaleQuantize", () => $37285808ce9dc87c$export$2e2bcd8739ae039);
$parcel$export($b2a13829cfbee039$exports, "scaleQuantile", () => $08921a9c9364d4a7$export$2e2bcd8739ae039);
$parcel$export($b2a13829cfbee039$exports, "scaleSymlog", () => $87c9697de24f333a$export$2e2bcd8739ae039);
$parcel$export($b2a13829cfbee039$exports, "scaleThreshold", () => $a8c10262ca4e2293$export$2e2bcd8739ae039);
$parcel$export($b2a13829cfbee039$exports, "scaleSqrt", () => $b042c0e768280497$export$2e2bcd8739ae039);
$parcel$export($b2a13829cfbee039$exports, "createScale", () => $070a822dceb20443$export$2e2bcd8739ae039);
$parcel$export($b2a13829cfbee039$exports, "updateScale", () => $5b100e954a7d74e0$export$2e2bcd8739ae039);
$parcel$export($b2a13829cfbee039$exports, "inferScaleType", () => $6adbb8ead5221144$export$2e2bcd8739ae039);
$parcel$export($b2a13829cfbee039$exports, "coerceNumber", () => $c32ed8852dffe2f4$export$2e2bcd8739ae039);
$parcel$export($b2a13829cfbee039$exports, "getTicks", () => $739bbf10d3a1c70b$export$2e2bcd8739ae039);
$parcel$export($b2a13829cfbee039$exports, "toString", () => $1cc2865a704159f1$export$2e2bcd8739ae039);
$parcel$export($b2a13829cfbee039$exports, "scaleCanBeZeroed", () => $818e625ab5eaa16c$export$2e2bcd8739ae039);
// @visx/scale
/**
 * `@visx/vendor/d3-scale` (ESM)
 * See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
 *
 * This ESM package re-exports the underlying installed dependencies of 
 * `node_modules/d3-scale`
 */ 

function $8df5ecfba528bb74$export$2e2bcd8739ae039(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}




function $6d34d2706a66a4b6$var$transformLog(x) {
    return Math.log(x);
}
function $6d34d2706a66a4b6$var$transformExp(x) {
    return Math.exp(x);
}
function $6d34d2706a66a4b6$var$transformLogn(x) {
    return -Math.log(-x);
}
function $6d34d2706a66a4b6$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $6d34d2706a66a4b6$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $6d34d2706a66a4b6$var$powp(base) {
    return base === 10 ? $6d34d2706a66a4b6$var$pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function $6d34d2706a66a4b6$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function $6d34d2706a66a4b6$var$reflect(f) {
    return (x, k)=>-f(-x, k);
}
function $6d34d2706a66a4b6$export$860836db074028f0(transform) {
    const scale = transform($6d34d2706a66a4b6$var$transformLog, $6d34d2706a66a4b6$var$transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = $6d34d2706a66a4b6$var$logp(base), pows = $6d34d2706a66a4b6$var$powp(base);
        if (domain()[0] < 0) {
            logs = $6d34d2706a66a4b6$var$reflect(logs), pows = $6d34d2706a66a4b6$var$reflect(pows);
            transform($6d34d2706a66a4b6$var$transformLogn, $6d34d2706a66a4b6$var$transformExpn);
        } else transform($6d34d2706a66a4b6$var$transformLog, $6d34d2706a66a4b6$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, $9db2f87bc4be21a0$export$2e2bcd8739ae039)(u, v, n);
        } else z = (0, $9db2f87bc4be21a0$export$2e2bcd8739ae039)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, $5f29b13e3a196c8e$export$2e2bcd8739ae039)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, $170ab7dc5db36a3a$export$d9468344d3651243)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, $8df5ecfba528bb74$export$2e2bcd8739ae039)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function $6d34d2706a66a4b6$export$2e2bcd8739ae039() {
    const scale = $6d34d2706a66a4b6$export$860836db074028f0((0, $ca897062bcd43aee$export$6b468dcfb64c653c)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, $ca897062bcd43aee$export$784d13d8ee351f07)(scale, $6d34d2706a66a4b6$export$2e2bcd8739ae039()).base(scale.base());
    (0, $9d977ca9c6671195$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}




function $943d43665bf2f2ea$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $943d43665bf2f2ea$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $943d43665bf2f2ea$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $943d43665bf2f2ea$export$34695211ec403a46(transform) {
    var scale = transform((0, $ca897062bcd43aee$export$f0954fd7d5368655), (0, $ca897062bcd43aee$export$f0954fd7d5368655)), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform((0, $ca897062bcd43aee$export$f0954fd7d5368655), (0, $ca897062bcd43aee$export$f0954fd7d5368655)) : exponent === 0.5 ? transform($943d43665bf2f2ea$var$transformSqrt, $943d43665bf2f2ea$var$transformSquare) : transform($943d43665bf2f2ea$var$transformPow(exponent), $943d43665bf2f2ea$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $9d892af289cba166$export$16a5d4b4a61a274d)(scale);
}
function $943d43665bf2f2ea$export$2e2bcd8739ae039() {
    var scale = $943d43665bf2f2ea$export$34695211ec403a46((0, $ca897062bcd43aee$export$6b468dcfb64c653c)());
    scale.copy = function() {
        return (0, $ca897062bcd43aee$export$784d13d8ee351f07)(scale, $943d43665bf2f2ea$export$2e2bcd8739ae039()).exponent(scale.exponent());
    };
    (0, $9d977ca9c6671195$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}
function $943d43665bf2f2ea$export$eba8049fb5020b81() {
    return $943d43665bf2f2ea$export$2e2bcd8739ae039.apply(null, arguments).exponent(0.5);
}

function $f00071c610b1d550$export$2e2bcd8739ae039(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}


function $f42dd251a2d2a135$export$2e2bcd8739ae039(values, valueof) {
    let max;
    let maxIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    return maxIndex;
}


function $953b35247d12a031$export$2e2bcd8739ae039(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}


function $62406cf79a78445a$export$2e2bcd8739ae039(values, valueof) {
    let min;
    let minIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    return minIndex;
}



function $0ac7b0d588dda485$export$2e2bcd8739ae039(source, keys) {
    return Array.from(keys, (key)=>source[key]);
}


function $73a2964b914a559c$export$2e2bcd8739ae039(values, ...F) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    values = Array.from(values);
    let [f] = F;
    if (f && f.length !== 2 || F.length > 1) {
        const index = Uint32Array.from(values, (d, i)=>i);
        if (F.length > 1) {
            F = F.map((f)=>values.map(f));
            index.sort((i, j)=>{
                for (const f of F){
                    const c = $73a2964b914a559c$export$686e14b8469efec4(f[i], f[j]);
                    if (c) return c;
                }
            });
        } else {
            f = values.map(f);
            index.sort((i, j)=>$73a2964b914a559c$export$686e14b8469efec4(f[i], f[j]));
        }
        return (0, $0ac7b0d588dda485$export$2e2bcd8739ae039)(values, index);
    }
    return values.sort($73a2964b914a559c$export$5708b2c031939e56(f));
}
function $73a2964b914a559c$export$5708b2c031939e56(compare = (0, $d281dc4bedcaa4bb$export$2e2bcd8739ae039)) {
    if (compare === (0, $d281dc4bedcaa4bb$export$2e2bcd8739ae039)) return $73a2964b914a559c$export$686e14b8469efec4;
    if (typeof compare !== "function") throw new TypeError("compare is not a function");
    return (a, b)=>{
        const x = compare(a, b);
        if (x || x === 0) return x;
        return (compare(b, b) === 0) - (compare(a, a) === 0);
    };
}
function $73a2964b914a559c$export$686e14b8469efec4(a, b) {
    return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
}


function $90f1dd7064c87943$export$2e2bcd8739ae039(array, k, left = 0, right = Infinity, compare) {
    k = Math.floor(k);
    left = Math.floor(Math.max(0, left));
    right = Math.floor(Math.min(array.length - 1, right));
    if (!(left <= k && k <= right)) return array;
    compare = compare === undefined ? (0, $73a2964b914a559c$export$686e14b8469efec4) : (0, $73a2964b914a559c$export$5708b2c031939e56)(compare);
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $90f1dd7064c87943$export$2e2bcd8739ae039(array, k, newLeft, newRight, compare);
        }
        const t = array[k];
        let i = left;
        let j = right;
        $90f1dd7064c87943$var$swap(array, left, k);
        if (compare(array[right], t) > 0) $90f1dd7064c87943$var$swap(array, left, right);
        while(i < j){
            $90f1dd7064c87943$var$swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) $90f1dd7064c87943$var$swap(array, left, j);
        else ++j, $90f1dd7064c87943$var$swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function $90f1dd7064c87943$var$swap(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
}





function $02eaa94e9e355554$export$2e2bcd8739ae039(values, compare = (0, $d281dc4bedcaa4bb$export$2e2bcd8739ae039)) {
    let max;
    let defined = false;
    if (compare.length === 1) {
        let maxValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $d281dc4bedcaa4bb$export$2e2bcd8739ae039)(value, maxValue) > 0 : (0, $d281dc4bedcaa4bb$export$2e2bcd8739ae039)(value, value) === 0) {
                max = element;
                maxValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
            max = value;
            defined = true;
        }
    }
    return max;
}


function $edccd806a00830c3$export$2e2bcd8739ae039(values, p, valueof) {
    values = Float64Array.from((0, $7fd7fc20c5d99156$export$1f6c9cc012ebacae)(values, valueof));
    if (!(n = values.length) || isNaN(p = +p)) return;
    if (p <= 0 || n < 2) return (0, $953b35247d12a031$export$2e2bcd8739ae039)(values);
    if (p >= 1) return (0, $f00071c610b1d550$export$2e2bcd8739ae039)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, $f00071c610b1d550$export$2e2bcd8739ae039)((0, $90f1dd7064c87943$export$2e2bcd8739ae039)(values, i0).subarray(0, i0 + 1)), value1 = (0, $953b35247d12a031$export$2e2bcd8739ae039)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function $edccd806a00830c3$export$f924a6cad778dddb(values, p, valueof = (0, $7fd7fc20c5d99156$export$2e2bcd8739ae039)) {
    if (!(n = values.length) || isNaN(p = +p)) return;
    if (p <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}
function $edccd806a00830c3$export$f1fcc854ecc6ce55(values, p, valueof = (0, $7fd7fc20c5d99156$export$2e2bcd8739ae039)) {
    if (isNaN(p = +p)) return;
    numbers = Float64Array.from(values, (_, i)=>(0, $7fd7fc20c5d99156$export$2e2bcd8739ae039)(valueof(values[i], i, values)));
    if (p <= 0) return (0, $62406cf79a78445a$export$2e2bcd8739ae039)(numbers);
    if (p >= 1) return (0, $f42dd251a2d2a135$export$2e2bcd8739ae039)(numbers);
    var numbers, index = Uint32Array.from(values, (_, i)=>i), j = numbers.length - 1, i = Math.floor(j * p);
    (0, $90f1dd7064c87943$export$2e2bcd8739ae039)(index, i, 0, j, (i, j)=>(0, $73a2964b914a559c$export$686e14b8469efec4)(numbers[i], numbers[j]));
    i = (0, $02eaa94e9e355554$export$2e2bcd8739ae039)(index.subarray(0, i + 1), (i)=>numbers[i]);
    return i >= 0 ? i : -1;
}



function $73da9d48522c828d$export$2e2bcd8739ae039() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, $edccd806a00830c3$export$f924a6cad778dddb)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : range[(0, $cc44a5a8212c170d$export$2e2bcd8739ae039)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort((0, $d281dc4bedcaa4bb$export$2e2bcd8739ae039));
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return $73da9d48522c828d$export$2e2bcd8739ae039().domain(domain).range(range).unknown(unknown);
    };
    return (0, $9d977ca9c6671195$export$23c7bb9e6558da2a).apply(scale, arguments);
}




function $a72f3e06ecfba646$export$2e2bcd8739ae039() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, $cc44a5a8212c170d$export$2e2bcd8739ae039)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return $a72f3e06ecfba646$export$2e2bcd8739ae039().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return (0, $9d977ca9c6671195$export$23c7bb9e6558da2a).apply((0, $9d892af289cba166$export$16a5d4b4a61a274d)(scale), arguments);
}





function $19b5df9a14a4474f$var$square(x) {
    return Math.sign(x) * x * x;
}
function $19b5df9a14a4474f$var$unsquare(x) {
    return Math.sign(x) * Math.sqrt(Math.abs(x));
}
function $19b5df9a14a4474f$export$2e2bcd8739ae039() {
    var squared = (0, $ca897062bcd43aee$export$2e2bcd8739ae039)(), range = [
        0,
        1
    ], round = false, unknown;
    function scale(x) {
        var y = $19b5df9a14a4474f$var$unsquare(squared(x));
        return isNaN(y) ? unknown : round ? Math.round(y) : y;
    }
    scale.invert = function(y) {
        return squared.invert($19b5df9a14a4474f$var$square(y));
    };
    scale.domain = function(_) {
        return arguments.length ? (squared.domain(_), scale) : squared.domain();
    };
    scale.range = function(_) {
        return arguments.length ? (squared.range((range = Array.from(_, (0, $7c3585a41f9f1074$export$2e2bcd8739ae039))).map($19b5df9a14a4474f$var$square)), scale) : range.slice();
    };
    scale.rangeRound = function(_) {
        return scale.range(_).round(true);
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, scale) : round;
    };
    scale.clamp = function(_) {
        return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $19b5df9a14a4474f$export$2e2bcd8739ae039(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
    };
    (0, $9d977ca9c6671195$export$23c7bb9e6558da2a).apply(scale, arguments);
    return (0, $9d892af289cba166$export$16a5d4b4a61a274d)(scale);
}




function $4d8d9c4f2eaba224$var$transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function $4d8d9c4f2eaba224$var$transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function $4d8d9c4f2eaba224$export$4602684e614eba38(transform) {
    var c = 1, scale = transform($4d8d9c4f2eaba224$var$transformSymlog(c), $4d8d9c4f2eaba224$var$transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform($4d8d9c4f2eaba224$var$transformSymlog(c = +_), $4d8d9c4f2eaba224$var$transformSymexp(c)) : c;
    };
    return (0, $9d892af289cba166$export$16a5d4b4a61a274d)(scale);
}
function $4d8d9c4f2eaba224$export$2e2bcd8739ae039() {
    var scale = $4d8d9c4f2eaba224$export$4602684e614eba38((0, $ca897062bcd43aee$export$6b468dcfb64c653c)());
    scale.copy = function() {
        return (0, $ca897062bcd43aee$export$784d13d8ee351f07)(scale, $4d8d9c4f2eaba224$export$2e2bcd8739ae039()).constant(scale.constant());
    };
    return (0, $9d977ca9c6671195$export$23c7bb9e6558da2a).apply(scale, arguments);
}



function $b276826d7c360777$export$2e2bcd8739ae039() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x != null && x <= x ? range[(0, $cc44a5a8212c170d$export$2e2bcd8739ae039)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $b276826d7c360777$export$2e2bcd8739ae039().domain(domain).range(range).unknown(unknown);
    };
    return (0, $9d977ca9c6671195$export$23c7bb9e6558da2a).apply(scale, arguments);
}

const $c6b3302b8f30af9e$var$t0 = new Date, $c6b3302b8f30af9e$var$t1 = new Date;
function $c6b3302b8f30af9e$export$1a539c8b2950ab40(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = (date)=>{
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = (date)=>{
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = (date)=>{
        const d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = (date, step)=>{
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = (start, stop, step)=>{
        const range = [];
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        let previous;
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = (test)=>{
        return $c6b3302b8f30af9e$export$1a539c8b2950ab40((date)=>{
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, (date, step)=>{
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = (start, end)=>{
            $c6b3302b8f30af9e$var$t0.setTime(+start), $c6b3302b8f30af9e$var$t1.setTime(+end);
            floori($c6b3302b8f30af9e$var$t0), floori($c6b3302b8f30af9e$var$t1);
            return Math.floor(count($c6b3302b8f30af9e$var$t0, $c6b3302b8f30af9e$var$t1));
        };
        interval.every = (step)=>{
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? (d)=>field(d) % step === 0 : (d)=>interval.count(0, d) % step === 0);
        };
    }
    return interval;
}


const $585613f7913c53cb$export$79ef0e34099623dc = 1000;
const $585613f7913c53cb$export$683905d551c33fa9 = $585613f7913c53cb$export$79ef0e34099623dc * 60;
const $585613f7913c53cb$export$4157bf0c8e241659 = $585613f7913c53cb$export$683905d551c33fa9 * 60;
const $585613f7913c53cb$export$353686095f4fbf45 = $585613f7913c53cb$export$4157bf0c8e241659 * 24;
const $585613f7913c53cb$export$c241eb88520d5016 = $585613f7913c53cb$export$353686095f4fbf45 * 7;
const $585613f7913c53cb$export$ab95684df7020b26 = $585613f7913c53cb$export$353686095f4fbf45 * 30;
const $585613f7913c53cb$export$61f8ee2d834c6959 = $585613f7913c53cb$export$353686095f4fbf45 * 365;


const $5e70dbbdf6cbcd60$export$8888529b966033e5 = (0, $c6b3302b8f30af9e$export$1a539c8b2950ab40)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $585613f7913c53cb$export$683905d551c33fa9)) / (0, $585613f7913c53cb$export$353686095f4fbf45), (date)=>date.getDate() - 1);
const $5e70dbbdf6cbcd60$export$6657a54f3034cf45 = $5e70dbbdf6cbcd60$export$8888529b966033e5.range;
const $5e70dbbdf6cbcd60$export$c8cbc42cefd47140 = (0, $c6b3302b8f30af9e$export$1a539c8b2950ab40)((date)=>{
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCDate(date.getUTCDate() + step);
}, (start, end)=>{
    return (end - start) / (0, $585613f7913c53cb$export$353686095f4fbf45);
}, (date)=>{
    return date.getUTCDate() - 1;
});
const $5e70dbbdf6cbcd60$export$d277e198508549a1 = $5e70dbbdf6cbcd60$export$c8cbc42cefd47140.range;
const $5e70dbbdf6cbcd60$export$fb065be2d7ea4a71 = (0, $c6b3302b8f30af9e$export$1a539c8b2950ab40)((date)=>{
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCDate(date.getUTCDate() + step);
}, (start, end)=>{
    return (end - start) / (0, $585613f7913c53cb$export$353686095f4fbf45);
}, (date)=>{
    return Math.floor(date / (0, $585613f7913c53cb$export$353686095f4fbf45));
});
const $5e70dbbdf6cbcd60$export$a491caaf5e9481aa = $5e70dbbdf6cbcd60$export$fb065be2d7ea4a71.range;



const $466ae73b10808091$export$46c68a5833bc315b = (0, $c6b3302b8f30af9e$export$1a539c8b2950ab40)((date)=>{
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $585613f7913c53cb$export$79ef0e34099623dc) - date.getMinutes() * (0, $585613f7913c53cb$export$683905d551c33fa9));
}, (date, step)=>{
    date.setTime(+date + step * (0, $585613f7913c53cb$export$4157bf0c8e241659));
}, (start, end)=>{
    return (end - start) / (0, $585613f7913c53cb$export$4157bf0c8e241659);
}, (date)=>{
    return date.getHours();
});
const $466ae73b10808091$export$fb843f9087cd5235 = $466ae73b10808091$export$46c68a5833bc315b.range;
const $466ae73b10808091$export$31f6f2b3c63ac75e = (0, $c6b3302b8f30af9e$export$1a539c8b2950ab40)((date)=>{
    date.setUTCMinutes(0, 0, 0);
}, (date, step)=>{
    date.setTime(+date + step * (0, $585613f7913c53cb$export$4157bf0c8e241659));
}, (start, end)=>{
    return (end - start) / (0, $585613f7913c53cb$export$4157bf0c8e241659);
}, (date)=>{
    return date.getUTCHours();
});
const $466ae73b10808091$export$6e7a76cd5f50b719 = $466ae73b10808091$export$31f6f2b3c63ac75e.range;



const $09fb27a5e4fb95ff$export$a7e4c34a52f0576 = (0, $c6b3302b8f30af9e$export$1a539c8b2950ab40)((date)=>{
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $585613f7913c53cb$export$79ef0e34099623dc));
}, (date, step)=>{
    date.setTime(+date + step * (0, $585613f7913c53cb$export$683905d551c33fa9));
}, (start, end)=>{
    return (end - start) / (0, $585613f7913c53cb$export$683905d551c33fa9);
}, (date)=>{
    return date.getMinutes();
});
const $09fb27a5e4fb95ff$export$186d65358374c0a2 = $09fb27a5e4fb95ff$export$a7e4c34a52f0576.range;
const $09fb27a5e4fb95ff$export$efe6712d6003761b = (0, $c6b3302b8f30af9e$export$1a539c8b2950ab40)((date)=>{
    date.setUTCSeconds(0, 0);
}, (date, step)=>{
    date.setTime(+date + step * (0, $585613f7913c53cb$export$683905d551c33fa9));
}, (start, end)=>{
    return (end - start) / (0, $585613f7913c53cb$export$683905d551c33fa9);
}, (date)=>{
    return date.getUTCMinutes();
});
const $09fb27a5e4fb95ff$export$cedd563624e8ee50 = $09fb27a5e4fb95ff$export$efe6712d6003761b.range;


const $c5a74691cb11e301$export$7e1084fb688591c1 = (0, $c6b3302b8f30af9e$export$1a539c8b2950ab40)((date)=>{
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setMonth(date.getMonth() + step);
}, (start, end)=>{
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, (date)=>{
    return date.getMonth();
});
const $c5a74691cb11e301$export$3e24aa839cd0f1c4 = $c5a74691cb11e301$export$7e1084fb688591c1.range;
const $c5a74691cb11e301$export$cd49b3d2bcfe50d5 = (0, $c6b3302b8f30af9e$export$1a539c8b2950ab40)((date)=>{
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCMonth(date.getUTCMonth() + step);
}, (start, end)=>{
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, (date)=>{
    return date.getUTCMonth();
});
const $c5a74691cb11e301$export$49159f585997498 = $c5a74691cb11e301$export$cd49b3d2bcfe50d5.range;



const $e83c1f2e5676a7ce$export$3d3c77ce7df7d30d = (0, $c6b3302b8f30af9e$export$1a539c8b2950ab40)((date)=>{
    date.setTime(date - date.getMilliseconds());
}, (date, step)=>{
    date.setTime(+date + step * (0, $585613f7913c53cb$export$79ef0e34099623dc));
}, (start, end)=>{
    return (end - start) / (0, $585613f7913c53cb$export$79ef0e34099623dc);
}, (date)=>{
    return date.getUTCSeconds();
});
const $e83c1f2e5676a7ce$export$4792e48abc550fa1 = $e83c1f2e5676a7ce$export$3d3c77ce7df7d30d.range;




const $9dcec43af91aed1b$export$edc5e5cb87280477 = (0, $c6b3302b8f30af9e$export$1a539c8b2950ab40)(()=>{
// noop
}, (date, step)=>{
    date.setTime(+date + step);
}, (start, end)=>{
    return end - start;
});
// An optimized implementation for this simple case.
$9dcec43af91aed1b$export$edc5e5cb87280477.every = (k)=>{
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $9dcec43af91aed1b$export$edc5e5cb87280477;
    return (0, $c6b3302b8f30af9e$export$1a539c8b2950ab40)((date)=>{
        date.setTime(Math.floor(date / k) * k);
    }, (date, step)=>{
        date.setTime(+date + step * k);
    }, (start, end)=>{
        return (end - start) / k;
    });
};
const $9dcec43af91aed1b$export$9a27fac83d67afd3 = $9dcec43af91aed1b$export$edc5e5cb87280477.range;








function $f0217d3152d62256$var$timeWeekday(i) {
    return (0, $c6b3302b8f30af9e$export$1a539c8b2950ab40)((date)=>{
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setDate(date.getDate() + step * 7);
    }, (start, end)=>{
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $585613f7913c53cb$export$683905d551c33fa9)) / (0, $585613f7913c53cb$export$c241eb88520d5016);
    });
}
const $f0217d3152d62256$export$22ee6205b762968c = $f0217d3152d62256$var$timeWeekday(0);
const $f0217d3152d62256$export$e79bbe0177cf1b01 = $f0217d3152d62256$var$timeWeekday(1);
const $f0217d3152d62256$export$57c0658c29f77708 = $f0217d3152d62256$var$timeWeekday(2);
const $f0217d3152d62256$export$3fbeef226c256e43 = $f0217d3152d62256$var$timeWeekday(3);
const $f0217d3152d62256$export$608689422d5cf9f4 = $f0217d3152d62256$var$timeWeekday(4);
const $f0217d3152d62256$export$548e5227aa183dca = $f0217d3152d62256$var$timeWeekday(5);
const $f0217d3152d62256$export$c56a3ad248908e19 = $f0217d3152d62256$var$timeWeekday(6);
const $f0217d3152d62256$export$eac514c8a8674eba = $f0217d3152d62256$export$22ee6205b762968c.range;
const $f0217d3152d62256$export$f7219b1481948356 = $f0217d3152d62256$export$e79bbe0177cf1b01.range;
const $f0217d3152d62256$export$77e22b12c5bed05b = $f0217d3152d62256$export$57c0658c29f77708.range;
const $f0217d3152d62256$export$b85d407a471809e8 = $f0217d3152d62256$export$3fbeef226c256e43.range;
const $f0217d3152d62256$export$c1bc1c49254c8855 = $f0217d3152d62256$export$608689422d5cf9f4.range;
const $f0217d3152d62256$export$3691a1557fff46f1 = $f0217d3152d62256$export$548e5227aa183dca.range;
const $f0217d3152d62256$export$b755452d02cba8d2 = $f0217d3152d62256$export$c56a3ad248908e19.range;
function $f0217d3152d62256$var$utcWeekday(i) {
    return (0, $c6b3302b8f30af9e$export$1a539c8b2950ab40)((date)=>{
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, (start, end)=>{
        return (end - start) / (0, $585613f7913c53cb$export$c241eb88520d5016);
    });
}
const $f0217d3152d62256$export$4898b06303a92011 = $f0217d3152d62256$var$utcWeekday(0);
const $f0217d3152d62256$export$9cfc53b9cfafd080 = $f0217d3152d62256$var$utcWeekday(1);
const $f0217d3152d62256$export$2a6d545f77eceb15 = $f0217d3152d62256$var$utcWeekday(2);
const $f0217d3152d62256$export$a5c25d8ed64433c4 = $f0217d3152d62256$var$utcWeekday(3);
const $f0217d3152d62256$export$1db08111baec2f53 = $f0217d3152d62256$var$utcWeekday(4);
const $f0217d3152d62256$export$29265e34dd5921f7 = $f0217d3152d62256$var$utcWeekday(5);
const $f0217d3152d62256$export$85b74dad05049604 = $f0217d3152d62256$var$utcWeekday(6);
const $f0217d3152d62256$export$6f3e1c2b0f7d7880 = $f0217d3152d62256$export$4898b06303a92011.range;
const $f0217d3152d62256$export$1d2d8b858bb366f9 = $f0217d3152d62256$export$9cfc53b9cfafd080.range;
const $f0217d3152d62256$export$1d5f6785fc7f30f8 = $f0217d3152d62256$export$2a6d545f77eceb15.range;
const $f0217d3152d62256$export$7a75faf0e37ef4af = $f0217d3152d62256$export$a5c25d8ed64433c4.range;
const $f0217d3152d62256$export$417eb959611b2f2f = $f0217d3152d62256$export$1db08111baec2f53.range;
const $f0217d3152d62256$export$59d308db7af08c64 = $f0217d3152d62256$export$29265e34dd5921f7.range;
const $f0217d3152d62256$export$a124108a0a7f34c8 = $f0217d3152d62256$export$85b74dad05049604.range;




const $5a498de4d8c46fef$export$cd17cfe45df0c046 = (0, $c6b3302b8f30af9e$export$1a539c8b2950ab40)((date)=>{
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setFullYear(date.getFullYear() + step);
}, (start, end)=>{
    return end.getFullYear() - start.getFullYear();
}, (date)=>{
    return date.getFullYear();
});
// An optimized implementation for this simple case.
$5a498de4d8c46fef$export$cd17cfe45df0c046.every = (k)=>{
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $c6b3302b8f30af9e$export$1a539c8b2950ab40)((date)=>{
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setFullYear(date.getFullYear() + step * k);
    });
};
const $5a498de4d8c46fef$export$69a4e90dd2cc3bd1 = $5a498de4d8c46fef$export$cd17cfe45df0c046.range;
const $5a498de4d8c46fef$export$d5c3802e389714c4 = (0, $c6b3302b8f30af9e$export$1a539c8b2950ab40)((date)=>{
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, (start, end)=>{
    return end.getUTCFullYear() - start.getUTCFullYear();
}, (date)=>{
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
$5a498de4d8c46fef$export$d5c3802e389714c4.every = (k)=>{
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $c6b3302b8f30af9e$export$1a539c8b2950ab40)((date)=>{
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
const $5a498de4d8c46fef$export$3e24d311e17f5802 = $5a498de4d8c46fef$export$d5c3802e389714c4.range;


function $5d6df0d387e86087$var$ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            (0, $e83c1f2e5676a7ce$export$3d3c77ce7df7d30d),
            1,
            (0, $585613f7913c53cb$export$79ef0e34099623dc)
        ],
        [
            (0, $e83c1f2e5676a7ce$export$3d3c77ce7df7d30d),
            5,
            5 * (0, $585613f7913c53cb$export$79ef0e34099623dc)
        ],
        [
            (0, $e83c1f2e5676a7ce$export$3d3c77ce7df7d30d),
            15,
            15 * (0, $585613f7913c53cb$export$79ef0e34099623dc)
        ],
        [
            (0, $e83c1f2e5676a7ce$export$3d3c77ce7df7d30d),
            30,
            30 * (0, $585613f7913c53cb$export$79ef0e34099623dc)
        ],
        [
            minute,
            1,
            (0, $585613f7913c53cb$export$683905d551c33fa9)
        ],
        [
            minute,
            5,
            5 * (0, $585613f7913c53cb$export$683905d551c33fa9)
        ],
        [
            minute,
            15,
            15 * (0, $585613f7913c53cb$export$683905d551c33fa9)
        ],
        [
            minute,
            30,
            30 * (0, $585613f7913c53cb$export$683905d551c33fa9)
        ],
        [
            hour,
            1,
            (0, $585613f7913c53cb$export$4157bf0c8e241659)
        ],
        [
            hour,
            3,
            3 * (0, $585613f7913c53cb$export$4157bf0c8e241659)
        ],
        [
            hour,
            6,
            6 * (0, $585613f7913c53cb$export$4157bf0c8e241659)
        ],
        [
            hour,
            12,
            12 * (0, $585613f7913c53cb$export$4157bf0c8e241659)
        ],
        [
            day,
            1,
            (0, $585613f7913c53cb$export$353686095f4fbf45)
        ],
        [
            day,
            2,
            2 * (0, $585613f7913c53cb$export$353686095f4fbf45)
        ],
        [
            week,
            1,
            (0, $585613f7913c53cb$export$c241eb88520d5016)
        ],
        [
            month,
            1,
            (0, $585613f7913c53cb$export$ab95684df7020b26)
        ],
        [
            month,
            3,
            3 * (0, $585613f7913c53cb$export$ab95684df7020b26)
        ],
        [
            year,
            1,
            (0, $585613f7913c53cb$export$61f8ee2d834c6959)
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, $2e786e1650447282$export$2e2bcd8739ae039)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, $9db2f87bc4be21a0$export$81087d9b915d4ede)(start / (0, $585613f7913c53cb$export$61f8ee2d834c6959), stop / (0, $585613f7913c53cb$export$61f8ee2d834c6959), count));
        if (i === 0) return (0, $9dcec43af91aed1b$export$edc5e5cb87280477).every(Math.max((0, $9db2f87bc4be21a0$export$81087d9b915d4ede)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [$5d6df0d387e86087$export$826ba5ae907e9767, $5d6df0d387e86087$export$6262d8d056ea44c4] = $5d6df0d387e86087$var$ticker((0, $5a498de4d8c46fef$export$d5c3802e389714c4), (0, $c5a74691cb11e301$export$cd49b3d2bcfe50d5), (0, $f0217d3152d62256$export$4898b06303a92011), (0, $5e70dbbdf6cbcd60$export$fb065be2d7ea4a71), (0, $466ae73b10808091$export$31f6f2b3c63ac75e), (0, $09fb27a5e4fb95ff$export$efe6712d6003761b));
const [$5d6df0d387e86087$export$60c76498552d28a6, $5d6df0d387e86087$export$69511150134dd174] = $5d6df0d387e86087$var$ticker((0, $5a498de4d8c46fef$export$cd17cfe45df0c046), (0, $c5a74691cb11e301$export$7e1084fb688591c1), (0, $f0217d3152d62256$export$22ee6205b762968c), (0, $5e70dbbdf6cbcd60$export$8888529b966033e5), (0, $466ae73b10808091$export$46c68a5833bc315b), (0, $09fb27a5e4fb95ff$export$a7e4c34a52f0576));



function $6de5a51ed5ba9bf1$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $6de5a51ed5ba9bf1$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $6de5a51ed5ba9bf1$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $6de5a51ed5ba9bf1$export$2e2bcd8739ae039(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $6de5a51ed5ba9bf1$var$formatRe(locale_periods), periodLookup = $6de5a51ed5ba9bf1$var$formatLookup(locale_periods), weekdayRe = $6de5a51ed5ba9bf1$var$formatRe(locale_weekdays), weekdayLookup = $6de5a51ed5ba9bf1$var$formatLookup(locale_weekdays), shortWeekdayRe = $6de5a51ed5ba9bf1$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $6de5a51ed5ba9bf1$var$formatLookup(locale_shortWeekdays), monthRe = $6de5a51ed5ba9bf1$var$formatRe(locale_months), monthLookup = $6de5a51ed5ba9bf1$var$formatLookup(locale_months), shortMonthRe = $6de5a51ed5ba9bf1$var$formatRe(locale_shortMonths), shortMonthLookup = $6de5a51ed5ba9bf1$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $6de5a51ed5ba9bf1$var$formatDayOfMonth,
        "e": $6de5a51ed5ba9bf1$var$formatDayOfMonth,
        "f": $6de5a51ed5ba9bf1$var$formatMicroseconds,
        "g": $6de5a51ed5ba9bf1$var$formatYearISO,
        "G": $6de5a51ed5ba9bf1$var$formatFullYearISO,
        "H": $6de5a51ed5ba9bf1$var$formatHour24,
        "I": $6de5a51ed5ba9bf1$var$formatHour12,
        "j": $6de5a51ed5ba9bf1$var$formatDayOfYear,
        "L": $6de5a51ed5ba9bf1$var$formatMilliseconds,
        "m": $6de5a51ed5ba9bf1$var$formatMonthNumber,
        "M": $6de5a51ed5ba9bf1$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $6de5a51ed5ba9bf1$var$formatUnixTimestamp,
        "s": $6de5a51ed5ba9bf1$var$formatUnixTimestampSeconds,
        "S": $6de5a51ed5ba9bf1$var$formatSeconds,
        "u": $6de5a51ed5ba9bf1$var$formatWeekdayNumberMonday,
        "U": $6de5a51ed5ba9bf1$var$formatWeekNumberSunday,
        "V": $6de5a51ed5ba9bf1$var$formatWeekNumberISO,
        "w": $6de5a51ed5ba9bf1$var$formatWeekdayNumberSunday,
        "W": $6de5a51ed5ba9bf1$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $6de5a51ed5ba9bf1$var$formatYear,
        "Y": $6de5a51ed5ba9bf1$var$formatFullYear,
        "Z": $6de5a51ed5ba9bf1$var$formatZone,
        "%": $6de5a51ed5ba9bf1$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $6de5a51ed5ba9bf1$var$formatUTCDayOfMonth,
        "e": $6de5a51ed5ba9bf1$var$formatUTCDayOfMonth,
        "f": $6de5a51ed5ba9bf1$var$formatUTCMicroseconds,
        "g": $6de5a51ed5ba9bf1$var$formatUTCYearISO,
        "G": $6de5a51ed5ba9bf1$var$formatUTCFullYearISO,
        "H": $6de5a51ed5ba9bf1$var$formatUTCHour24,
        "I": $6de5a51ed5ba9bf1$var$formatUTCHour12,
        "j": $6de5a51ed5ba9bf1$var$formatUTCDayOfYear,
        "L": $6de5a51ed5ba9bf1$var$formatUTCMilliseconds,
        "m": $6de5a51ed5ba9bf1$var$formatUTCMonthNumber,
        "M": $6de5a51ed5ba9bf1$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $6de5a51ed5ba9bf1$var$formatUnixTimestamp,
        "s": $6de5a51ed5ba9bf1$var$formatUnixTimestampSeconds,
        "S": $6de5a51ed5ba9bf1$var$formatUTCSeconds,
        "u": $6de5a51ed5ba9bf1$var$formatUTCWeekdayNumberMonday,
        "U": $6de5a51ed5ba9bf1$var$formatUTCWeekNumberSunday,
        "V": $6de5a51ed5ba9bf1$var$formatUTCWeekNumberISO,
        "w": $6de5a51ed5ba9bf1$var$formatUTCWeekdayNumberSunday,
        "W": $6de5a51ed5ba9bf1$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $6de5a51ed5ba9bf1$var$formatUTCYear,
        "Y": $6de5a51ed5ba9bf1$var$formatUTCFullYear,
        "Z": $6de5a51ed5ba9bf1$var$formatUTCZone,
        "%": $6de5a51ed5ba9bf1$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $6de5a51ed5ba9bf1$var$parseDayOfMonth,
        "e": $6de5a51ed5ba9bf1$var$parseDayOfMonth,
        "f": $6de5a51ed5ba9bf1$var$parseMicroseconds,
        "g": $6de5a51ed5ba9bf1$var$parseYear,
        "G": $6de5a51ed5ba9bf1$var$parseFullYear,
        "H": $6de5a51ed5ba9bf1$var$parseHour24,
        "I": $6de5a51ed5ba9bf1$var$parseHour24,
        "j": $6de5a51ed5ba9bf1$var$parseDayOfYear,
        "L": $6de5a51ed5ba9bf1$var$parseMilliseconds,
        "m": $6de5a51ed5ba9bf1$var$parseMonthNumber,
        "M": $6de5a51ed5ba9bf1$var$parseMinutes,
        "p": parsePeriod,
        "q": $6de5a51ed5ba9bf1$var$parseQuarter,
        "Q": $6de5a51ed5ba9bf1$var$parseUnixTimestamp,
        "s": $6de5a51ed5ba9bf1$var$parseUnixTimestampSeconds,
        "S": $6de5a51ed5ba9bf1$var$parseSeconds,
        "u": $6de5a51ed5ba9bf1$var$parseWeekdayNumberMonday,
        "U": $6de5a51ed5ba9bf1$var$parseWeekNumberSunday,
        "V": $6de5a51ed5ba9bf1$var$parseWeekNumberISO,
        "w": $6de5a51ed5ba9bf1$var$parseWeekdayNumberSunday,
        "W": $6de5a51ed5ba9bf1$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $6de5a51ed5ba9bf1$var$parseYear,
        "Y": $6de5a51ed5ba9bf1$var$parseFullYear,
        "Z": $6de5a51ed5ba9bf1$var$parseZone,
        "%": $6de5a51ed5ba9bf1$var$parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $6de5a51ed5ba9bf1$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $6de5a51ed5ba9bf1$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $6de5a51ed5ba9bf1$var$utcDate($6de5a51ed5ba9bf1$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, $f0217d3152d62256$export$9cfc53b9cfafd080).ceil(week) : (0, $f0217d3152d62256$export$9cfc53b9cfafd080)(week);
                    week = (0, $5e70dbbdf6cbcd60$export$c8cbc42cefd47140).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $6de5a51ed5ba9bf1$var$localDate($6de5a51ed5ba9bf1$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, $f0217d3152d62256$export$e79bbe0177cf1b01).ceil(week) : (0, $f0217d3152d62256$export$e79bbe0177cf1b01)(week);
                    week = (0, $5e70dbbdf6cbcd60$export$8888529b966033e5).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $6de5a51ed5ba9bf1$var$utcDate($6de5a51ed5ba9bf1$var$newDate(d.y, 0, 1)).getUTCDay() : $6de5a51ed5ba9bf1$var$localDate($6de5a51ed5ba9bf1$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $6de5a51ed5ba9bf1$var$utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return $6de5a51ed5ba9bf1$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $6de5a51ed5ba9bf1$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $6de5a51ed5ba9bf1$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $6de5a51ed5ba9bf1$var$numberRe = /^\s*\d+/, $6de5a51ed5ba9bf1$var$percentRe = /^%/, $6de5a51ed5ba9bf1$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $6de5a51ed5ba9bf1$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $6de5a51ed5ba9bf1$var$requote(s) {
    return s.replace($6de5a51ed5ba9bf1$var$requoteRe, "\\$&");
}
function $6de5a51ed5ba9bf1$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($6de5a51ed5ba9bf1$var$requote).join("|") + ")", "i");
}
function $6de5a51ed5ba9bf1$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $6de5a51ed5ba9bf1$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $6de5a51ed5ba9bf1$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $6de5a51ed5ba9bf1$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $6de5a51ed5ba9bf1$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $6de5a51ed5ba9bf1$var$parseWeekNumberSunday(d, string, i) {
    var n = $6de5a51ed5ba9bf1$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $6de5a51ed5ba9bf1$var$parseWeekNumberISO(d, string, i) {
    var n = $6de5a51ed5ba9bf1$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $6de5a51ed5ba9bf1$var$parseWeekNumberMonday(d, string, i) {
    var n = $6de5a51ed5ba9bf1$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $6de5a51ed5ba9bf1$var$parseFullYear(d, string, i) {
    var n = $6de5a51ed5ba9bf1$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $6de5a51ed5ba9bf1$var$parseYear(d, string, i) {
    var n = $6de5a51ed5ba9bf1$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $6de5a51ed5ba9bf1$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $6de5a51ed5ba9bf1$var$parseQuarter(d, string, i) {
    var n = $6de5a51ed5ba9bf1$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $6de5a51ed5ba9bf1$var$parseMonthNumber(d, string, i) {
    var n = $6de5a51ed5ba9bf1$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $6de5a51ed5ba9bf1$var$parseDayOfMonth(d, string, i) {
    var n = $6de5a51ed5ba9bf1$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $6de5a51ed5ba9bf1$var$parseDayOfYear(d, string, i) {
    var n = $6de5a51ed5ba9bf1$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $6de5a51ed5ba9bf1$var$parseHour24(d, string, i) {
    var n = $6de5a51ed5ba9bf1$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $6de5a51ed5ba9bf1$var$parseMinutes(d, string, i) {
    var n = $6de5a51ed5ba9bf1$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $6de5a51ed5ba9bf1$var$parseSeconds(d, string, i) {
    var n = $6de5a51ed5ba9bf1$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $6de5a51ed5ba9bf1$var$parseMilliseconds(d, string, i) {
    var n = $6de5a51ed5ba9bf1$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $6de5a51ed5ba9bf1$var$parseMicroseconds(d, string, i) {
    var n = $6de5a51ed5ba9bf1$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $6de5a51ed5ba9bf1$var$parseLiteralPercent(d, string, i) {
    var n = $6de5a51ed5ba9bf1$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $6de5a51ed5ba9bf1$var$parseUnixTimestamp(d, string, i) {
    var n = $6de5a51ed5ba9bf1$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $6de5a51ed5ba9bf1$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $6de5a51ed5ba9bf1$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $6de5a51ed5ba9bf1$var$formatDayOfMonth(d, p) {
    return $6de5a51ed5ba9bf1$var$pad(d.getDate(), p, 2);
}
function $6de5a51ed5ba9bf1$var$formatHour24(d, p) {
    return $6de5a51ed5ba9bf1$var$pad(d.getHours(), p, 2);
}
function $6de5a51ed5ba9bf1$var$formatHour12(d, p) {
    return $6de5a51ed5ba9bf1$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $6de5a51ed5ba9bf1$var$formatDayOfYear(d, p) {
    return $6de5a51ed5ba9bf1$var$pad(1 + (0, $5e70dbbdf6cbcd60$export$8888529b966033e5).count((0, $5a498de4d8c46fef$export$cd17cfe45df0c046)(d), d), p, 3);
}
function $6de5a51ed5ba9bf1$var$formatMilliseconds(d, p) {
    return $6de5a51ed5ba9bf1$var$pad(d.getMilliseconds(), p, 3);
}
function $6de5a51ed5ba9bf1$var$formatMicroseconds(d, p) {
    return $6de5a51ed5ba9bf1$var$formatMilliseconds(d, p) + "000";
}
function $6de5a51ed5ba9bf1$var$formatMonthNumber(d, p) {
    return $6de5a51ed5ba9bf1$var$pad(d.getMonth() + 1, p, 2);
}
function $6de5a51ed5ba9bf1$var$formatMinutes(d, p) {
    return $6de5a51ed5ba9bf1$var$pad(d.getMinutes(), p, 2);
}
function $6de5a51ed5ba9bf1$var$formatSeconds(d, p) {
    return $6de5a51ed5ba9bf1$var$pad(d.getSeconds(), p, 2);
}
function $6de5a51ed5ba9bf1$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $6de5a51ed5ba9bf1$var$formatWeekNumberSunday(d, p) {
    return $6de5a51ed5ba9bf1$var$pad((0, $f0217d3152d62256$export$22ee6205b762968c).count((0, $5a498de4d8c46fef$export$cd17cfe45df0c046)(d) - 1, d), p, 2);
}
function $6de5a51ed5ba9bf1$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $f0217d3152d62256$export$608689422d5cf9f4)(d) : (0, $f0217d3152d62256$export$608689422d5cf9f4).ceil(d);
}
function $6de5a51ed5ba9bf1$var$formatWeekNumberISO(d, p) {
    d = $6de5a51ed5ba9bf1$var$dISO(d);
    return $6de5a51ed5ba9bf1$var$pad((0, $f0217d3152d62256$export$608689422d5cf9f4).count((0, $5a498de4d8c46fef$export$cd17cfe45df0c046)(d), d) + ((0, $5a498de4d8c46fef$export$cd17cfe45df0c046)(d).getDay() === 4), p, 2);
}
function $6de5a51ed5ba9bf1$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $6de5a51ed5ba9bf1$var$formatWeekNumberMonday(d, p) {
    return $6de5a51ed5ba9bf1$var$pad((0, $f0217d3152d62256$export$e79bbe0177cf1b01).count((0, $5a498de4d8c46fef$export$cd17cfe45df0c046)(d) - 1, d), p, 2);
}
function $6de5a51ed5ba9bf1$var$formatYear(d, p) {
    return $6de5a51ed5ba9bf1$var$pad(d.getFullYear() % 100, p, 2);
}
function $6de5a51ed5ba9bf1$var$formatYearISO(d, p) {
    d = $6de5a51ed5ba9bf1$var$dISO(d);
    return $6de5a51ed5ba9bf1$var$pad(d.getFullYear() % 100, p, 2);
}
function $6de5a51ed5ba9bf1$var$formatFullYear(d, p) {
    return $6de5a51ed5ba9bf1$var$pad(d.getFullYear() % 10000, p, 4);
}
function $6de5a51ed5ba9bf1$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $f0217d3152d62256$export$608689422d5cf9f4)(d) : (0, $f0217d3152d62256$export$608689422d5cf9f4).ceil(d);
    return $6de5a51ed5ba9bf1$var$pad(d.getFullYear() % 10000, p, 4);
}
function $6de5a51ed5ba9bf1$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $6de5a51ed5ba9bf1$var$pad(z / 60 | 0, "0", 2) + $6de5a51ed5ba9bf1$var$pad(z % 60, "0", 2);
}
function $6de5a51ed5ba9bf1$var$formatUTCDayOfMonth(d, p) {
    return $6de5a51ed5ba9bf1$var$pad(d.getUTCDate(), p, 2);
}
function $6de5a51ed5ba9bf1$var$formatUTCHour24(d, p) {
    return $6de5a51ed5ba9bf1$var$pad(d.getUTCHours(), p, 2);
}
function $6de5a51ed5ba9bf1$var$formatUTCHour12(d, p) {
    return $6de5a51ed5ba9bf1$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $6de5a51ed5ba9bf1$var$formatUTCDayOfYear(d, p) {
    return $6de5a51ed5ba9bf1$var$pad(1 + (0, $5e70dbbdf6cbcd60$export$c8cbc42cefd47140).count((0, $5a498de4d8c46fef$export$d5c3802e389714c4)(d), d), p, 3);
}
function $6de5a51ed5ba9bf1$var$formatUTCMilliseconds(d, p) {
    return $6de5a51ed5ba9bf1$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $6de5a51ed5ba9bf1$var$formatUTCMicroseconds(d, p) {
    return $6de5a51ed5ba9bf1$var$formatUTCMilliseconds(d, p) + "000";
}
function $6de5a51ed5ba9bf1$var$formatUTCMonthNumber(d, p) {
    return $6de5a51ed5ba9bf1$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $6de5a51ed5ba9bf1$var$formatUTCMinutes(d, p) {
    return $6de5a51ed5ba9bf1$var$pad(d.getUTCMinutes(), p, 2);
}
function $6de5a51ed5ba9bf1$var$formatUTCSeconds(d, p) {
    return $6de5a51ed5ba9bf1$var$pad(d.getUTCSeconds(), p, 2);
}
function $6de5a51ed5ba9bf1$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $6de5a51ed5ba9bf1$var$formatUTCWeekNumberSunday(d, p) {
    return $6de5a51ed5ba9bf1$var$pad((0, $f0217d3152d62256$export$4898b06303a92011).count((0, $5a498de4d8c46fef$export$d5c3802e389714c4)(d) - 1, d), p, 2);
}
function $6de5a51ed5ba9bf1$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $f0217d3152d62256$export$1db08111baec2f53)(d) : (0, $f0217d3152d62256$export$1db08111baec2f53).ceil(d);
}
function $6de5a51ed5ba9bf1$var$formatUTCWeekNumberISO(d, p) {
    d = $6de5a51ed5ba9bf1$var$UTCdISO(d);
    return $6de5a51ed5ba9bf1$var$pad((0, $f0217d3152d62256$export$1db08111baec2f53).count((0, $5a498de4d8c46fef$export$d5c3802e389714c4)(d), d) + ((0, $5a498de4d8c46fef$export$d5c3802e389714c4)(d).getUTCDay() === 4), p, 2);
}
function $6de5a51ed5ba9bf1$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $6de5a51ed5ba9bf1$var$formatUTCWeekNumberMonday(d, p) {
    return $6de5a51ed5ba9bf1$var$pad((0, $f0217d3152d62256$export$9cfc53b9cfafd080).count((0, $5a498de4d8c46fef$export$d5c3802e389714c4)(d) - 1, d), p, 2);
}
function $6de5a51ed5ba9bf1$var$formatUTCYear(d, p) {
    return $6de5a51ed5ba9bf1$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $6de5a51ed5ba9bf1$var$formatUTCYearISO(d, p) {
    d = $6de5a51ed5ba9bf1$var$UTCdISO(d);
    return $6de5a51ed5ba9bf1$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $6de5a51ed5ba9bf1$var$formatUTCFullYear(d, p) {
    return $6de5a51ed5ba9bf1$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $6de5a51ed5ba9bf1$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $f0217d3152d62256$export$1db08111baec2f53)(d) : (0, $f0217d3152d62256$export$1db08111baec2f53).ceil(d);
    return $6de5a51ed5ba9bf1$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $6de5a51ed5ba9bf1$var$formatUTCZone() {
    return "+0000";
}
function $6de5a51ed5ba9bf1$var$formatLiteralPercent() {
    return "%";
}
function $6de5a51ed5ba9bf1$var$formatUnixTimestamp(d) {
    return +d;
}
function $6de5a51ed5ba9bf1$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}


var $dacd7ed0336494bc$var$locale;
var $dacd7ed0336494bc$export$94f4d87fad5dcf9a;
var $dacd7ed0336494bc$export$32b9cd16e1b8c8d2;
var $dacd7ed0336494bc$export$1a08fe38f63ebbbb;
var $dacd7ed0336494bc$export$3edae9cf8e233729;
$dacd7ed0336494bc$export$2e2bcd8739ae039({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $dacd7ed0336494bc$export$2e2bcd8739ae039(definition) {
    $dacd7ed0336494bc$var$locale = (0, $6de5a51ed5ba9bf1$export$2e2bcd8739ae039)(definition);
    $dacd7ed0336494bc$export$94f4d87fad5dcf9a = $dacd7ed0336494bc$var$locale.format;
    $dacd7ed0336494bc$export$32b9cd16e1b8c8d2 = $dacd7ed0336494bc$var$locale.parse;
    $dacd7ed0336494bc$export$1a08fe38f63ebbbb = $dacd7ed0336494bc$var$locale.utcFormat;
    $dacd7ed0336494bc$export$3edae9cf8e233729 = $dacd7ed0336494bc$var$locale.utcParse;
    return $dacd7ed0336494bc$var$locale;
}





function $0db31d2e50a00172$var$date(t) {
    return new Date(t);
}
function $0db31d2e50a00172$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $0db31d2e50a00172$export$56bbcdb8aca31149(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, $ca897062bcd43aee$export$2e2bcd8739ae039)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, $0db31d2e50a00172$var$number)) : domain().map($0db31d2e50a00172$var$date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, $8df5ecfba528bb74$export$2e2bcd8739ae039)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $ca897062bcd43aee$export$784d13d8ee351f07)(scale, $0db31d2e50a00172$export$56bbcdb8aca31149(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function $0db31d2e50a00172$export$2e2bcd8739ae039() {
    return (0, $9d977ca9c6671195$export$23c7bb9e6558da2a).apply($0db31d2e50a00172$export$56bbcdb8aca31149((0, $5d6df0d387e86087$export$60c76498552d28a6), (0, $5d6df0d387e86087$export$69511150134dd174), (0, $5a498de4d8c46fef$export$cd17cfe45df0c046), (0, $c5a74691cb11e301$export$7e1084fb688591c1), (0, $f0217d3152d62256$export$22ee6205b762968c), (0, $5e70dbbdf6cbcd60$export$8888529b966033e5), (0, $466ae73b10808091$export$46c68a5833bc315b), (0, $09fb27a5e4fb95ff$export$a7e4c34a52f0576), (0, $e83c1f2e5676a7ce$export$3d3c77ce7df7d30d), (0, $dacd7ed0336494bc$export$94f4d87fad5dcf9a)).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}





function $ee184e54692052cd$export$2e2bcd8739ae039() {
    return (0, $9d977ca9c6671195$export$23c7bb9e6558da2a).apply((0, $0db31d2e50a00172$export$56bbcdb8aca31149)((0, $5d6df0d387e86087$export$826ba5ae907e9767), (0, $5d6df0d387e86087$export$6262d8d056ea44c4), (0, $5a498de4d8c46fef$export$d5c3802e389714c4), (0, $c5a74691cb11e301$export$cd49b3d2bcfe50d5), (0, $f0217d3152d62256$export$4898b06303a92011), (0, $5e70dbbdf6cbcd60$export$c8cbc42cefd47140), (0, $466ae73b10808091$export$31f6f2b3c63ac75e), (0, $09fb27a5e4fb95ff$export$efe6712d6003761b), (0, $e83c1f2e5676a7ce$export$3d3c77ce7df7d30d), (0, $dacd7ed0336494bc$export$1a08fe38f63ebbbb)).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}




function $4ef393c360195193$export$2e2bcd8739ae039(scale, config) {
    if (config.domain) {
        if ('nice' in scale || 'quantiles' in scale) // continuous input scales
        scale.domain(config.domain);
        else if ('padding' in scale) // point and band scales
        scale.domain(config.domain);
        else // ordinal and threshold scale
        scale.domain(config.domain);
    }
}


function $169f6e66bb1a381c$export$2e2bcd8739ae039(scale, config) {
    if (config.range) {
        if ('padding' in scale) // point and band scales
        scale.range(config.range);
        else // the rest
        scale.range(config.range);
    }
}


function $2056cb1b51a29316$export$2e2bcd8739ae039(scale, config) {
    if ('align' in scale && 'align' in config && typeof config.align !== 'undefined') scale.align(config.align);
}


function $0f09d4c4772a5152$export$2e2bcd8739ae039(scale, config) {
    if ('base' in scale && 'base' in config && typeof config.base !== 'undefined') scale.base(config.base);
}


function $07ca0d7706c3b538$export$2e2bcd8739ae039(scale, config) {
    if ('clamp' in scale && 'clamp' in config && typeof config.clamp !== 'undefined') scale.clamp(config.clamp);
}


function $bef6035fa56ef947$export$2e2bcd8739ae039(scale, config) {
    if ('constant' in scale && 'constant' in config && typeof config.constant !== 'undefined') scale.constant(config.constant);
}


function $e4af377e72cb9526$export$2e2bcd8739ae039(scale, config) {
    if ('exponent' in scale && 'exponent' in config && typeof config.exponent !== 'undefined') scale.exponent(config.exponent);
}


/**
 * `@visx/vendor/d3-interpolate` (ESM)
 * See upstream license: https://github.com/d3/d3-interpolate/blob/main/LICENSE
 *
 * This ESM package re-exports the underlying installed dependencies of 
 * `node_modules/d3-interpolate`
 */ 
var $jKHze = parcelRequire("jKHze");

var $9eF39 = parcelRequire("9eF39");
const $934e15f7e80b4c50$export$8449e153fbd325fc = Math.PI / 180;
const $934e15f7e80b4c50$export$41fc368e1a942b97 = 180 / Math.PI;


var $71c371d0463c3865$var$A = -0.14861, $71c371d0463c3865$var$B = 1.78277, $71c371d0463c3865$var$C = -0.29227, $71c371d0463c3865$var$D = -0.90649, $71c371d0463c3865$var$E = 1.97294, $71c371d0463c3865$var$ED = $71c371d0463c3865$var$E * $71c371d0463c3865$var$D, $71c371d0463c3865$var$EB = $71c371d0463c3865$var$E * $71c371d0463c3865$var$B, $71c371d0463c3865$var$BC_DA = $71c371d0463c3865$var$B * $71c371d0463c3865$var$C - $71c371d0463c3865$var$D * $71c371d0463c3865$var$A;
function $71c371d0463c3865$var$cubehelixConvert(o) {
    if (o instanceof $71c371d0463c3865$export$57ed4bde61a1e2f2) return new $71c371d0463c3865$export$57ed4bde61a1e2f2(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof (0, $9eF39.Rgb))) o = (0, $9eF39.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($71c371d0463c3865$var$BC_DA * b + $71c371d0463c3865$var$ED * r - $71c371d0463c3865$var$EB * g) / ($71c371d0463c3865$var$BC_DA + $71c371d0463c3865$var$ED - $71c371d0463c3865$var$EB), bl = b - l, k = ($71c371d0463c3865$var$E * (g - l) - $71c371d0463c3865$var$C * bl) / $71c371d0463c3865$var$D, s = Math.sqrt(k * k + bl * bl) / ($71c371d0463c3865$var$E * l * (1 - l)), h = s ? Math.atan2(k, bl) * (0, $934e15f7e80b4c50$export$41fc368e1a942b97) - 120 : NaN;
    return new $71c371d0463c3865$export$57ed4bde61a1e2f2(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $71c371d0463c3865$export$2e2bcd8739ae039(h, s, l, opacity) {
    return arguments.length === 1 ? $71c371d0463c3865$var$cubehelixConvert(h) : new $71c371d0463c3865$export$57ed4bde61a1e2f2(h, s, l, opacity == null ? 1 : opacity);
}
function $71c371d0463c3865$export$57ed4bde61a1e2f2(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $jKHze.default)($71c371d0463c3865$export$57ed4bde61a1e2f2, $71c371d0463c3865$export$2e2bcd8739ae039, (0, $jKHze.extend)((0, $9eF39.Color), {
    brighter (k) {
        k = k == null ? (0, $9eF39.brighter) : Math.pow((0, $9eF39.brighter), k);
        return new $71c371d0463c3865$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? (0, $9eF39.darker) : Math.pow((0, $9eF39.darker), k);
        return new $71c371d0463c3865$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * (0, $934e15f7e80b4c50$export$8449e153fbd325fc), l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new (0, $9eF39.Rgb)(255 * (l + a * ($71c371d0463c3865$var$A * cosh + $71c371d0463c3865$var$B * sinh)), 255 * (l + a * ($71c371d0463c3865$var$C * cosh + $71c371d0463c3865$var$D * sinh)), 255 * (l + a * ($71c371d0463c3865$var$E * cosh)), this.opacity);
    }
}));



function $c9c323aa53ae4fa4$var$cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, $71c371d0463c3865$export$2e2bcd8739ae039)(start)).h, (end = (0, $71c371d0463c3865$export$2e2bcd8739ae039)(end)).h), s = (0, $8dfce0561889250e$export$2e2bcd8739ae039)(start.s, end.s), l = (0, $8dfce0561889250e$export$2e2bcd8739ae039)(start.l, end.l), opacity = (0, $8dfce0561889250e$export$2e2bcd8739ae039)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var $c9c323aa53ae4fa4$export$2e2bcd8739ae039 = $c9c323aa53ae4fa4$var$cubehelix((0, $8dfce0561889250e$export$97d7b0c7ddb78dcf));
var $c9c323aa53ae4fa4$export$934fa09ad474a1b4 = $c9c323aa53ae4fa4$var$cubehelix((0, $8dfce0561889250e$export$2e2bcd8739ae039));


var $jKHze = parcelRequire("jKHze");

var $9eF39 = parcelRequire("9eF39");

// https://observablehq.com/@mbostock/lab-and-rgb
const $79be02bbebd55f8d$var$K = 18, $79be02bbebd55f8d$var$Xn = 0.96422, $79be02bbebd55f8d$var$Yn = 1, $79be02bbebd55f8d$var$Zn = 0.82521, $79be02bbebd55f8d$var$t0 = 4 / 29, $79be02bbebd55f8d$var$t1 = 6 / 29, $79be02bbebd55f8d$var$t2 = 3 * $79be02bbebd55f8d$var$t1 * $79be02bbebd55f8d$var$t1, $79be02bbebd55f8d$var$t3 = $79be02bbebd55f8d$var$t1 * $79be02bbebd55f8d$var$t1 * $79be02bbebd55f8d$var$t1;
function $79be02bbebd55f8d$var$labConvert(o) {
    if (o instanceof $79be02bbebd55f8d$export$f2722c70a60257f7) return new $79be02bbebd55f8d$export$f2722c70a60257f7(o.l, o.a, o.b, o.opacity);
    if (o instanceof $79be02bbebd55f8d$export$d9397e094a5fbb9a) return $79be02bbebd55f8d$var$hcl2lab(o);
    if (!(o instanceof (0, $9eF39.Rgb))) o = (0, $9eF39.rgbConvert)(o);
    var r = $79be02bbebd55f8d$var$rgb2lrgb(o.r), g = $79be02bbebd55f8d$var$rgb2lrgb(o.g), b = $79be02bbebd55f8d$var$rgb2lrgb(o.b), y = $79be02bbebd55f8d$var$xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / $79be02bbebd55f8d$var$Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = $79be02bbebd55f8d$var$xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / $79be02bbebd55f8d$var$Xn);
        z = $79be02bbebd55f8d$var$xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / $79be02bbebd55f8d$var$Zn);
    }
    return new $79be02bbebd55f8d$export$f2722c70a60257f7(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function $79be02bbebd55f8d$export$3e2c219d3ab79d01(l, opacity) {
    return new $79be02bbebd55f8d$export$f2722c70a60257f7(l, 0, 0, opacity == null ? 1 : opacity);
}
function $79be02bbebd55f8d$export$2e2bcd8739ae039(l, a, b, opacity) {
    return arguments.length === 1 ? $79be02bbebd55f8d$var$labConvert(l) : new $79be02bbebd55f8d$export$f2722c70a60257f7(l, a, b, opacity == null ? 1 : opacity);
}
function $79be02bbebd55f8d$export$f2722c70a60257f7(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $jKHze.default)($79be02bbebd55f8d$export$f2722c70a60257f7, $79be02bbebd55f8d$export$2e2bcd8739ae039, (0, $jKHze.extend)((0, $9eF39.Color), {
    brighter (k) {
        return new $79be02bbebd55f8d$export$f2722c70a60257f7(this.l + $79be02bbebd55f8d$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker (k) {
        return new $79be02bbebd55f8d$export$f2722c70a60257f7(this.l - $79be02bbebd55f8d$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb () {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = $79be02bbebd55f8d$var$Xn * $79be02bbebd55f8d$var$lab2xyz(x);
        y = $79be02bbebd55f8d$var$Yn * $79be02bbebd55f8d$var$lab2xyz(y);
        z = $79be02bbebd55f8d$var$Zn * $79be02bbebd55f8d$var$lab2xyz(z);
        return new (0, $9eF39.Rgb)($79be02bbebd55f8d$var$lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), $79be02bbebd55f8d$var$lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), $79be02bbebd55f8d$var$lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function $79be02bbebd55f8d$var$xyz2lab(t) {
    return t > $79be02bbebd55f8d$var$t3 ? Math.pow(t, 1 / 3) : t / $79be02bbebd55f8d$var$t2 + $79be02bbebd55f8d$var$t0;
}
function $79be02bbebd55f8d$var$lab2xyz(t) {
    return t > $79be02bbebd55f8d$var$t1 ? t * t * t : $79be02bbebd55f8d$var$t2 * (t - $79be02bbebd55f8d$var$t0);
}
function $79be02bbebd55f8d$var$lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function $79be02bbebd55f8d$var$rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function $79be02bbebd55f8d$var$hclConvert(o) {
    if (o instanceof $79be02bbebd55f8d$export$d9397e094a5fbb9a) return new $79be02bbebd55f8d$export$d9397e094a5fbb9a(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof $79be02bbebd55f8d$export$f2722c70a60257f7)) o = $79be02bbebd55f8d$var$labConvert(o);
    if (o.a === 0 && o.b === 0) return new $79be02bbebd55f8d$export$d9397e094a5fbb9a(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * (0, $934e15f7e80b4c50$export$41fc368e1a942b97);
    return new $79be02bbebd55f8d$export$d9397e094a5fbb9a(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function $79be02bbebd55f8d$export$5a21418738164530(l, c, h, opacity) {
    return arguments.length === 1 ? $79be02bbebd55f8d$var$hclConvert(l) : new $79be02bbebd55f8d$export$d9397e094a5fbb9a(h, c, l, opacity == null ? 1 : opacity);
}
function $79be02bbebd55f8d$export$d0e870ba50062ff1(h, c, l, opacity) {
    return arguments.length === 1 ? $79be02bbebd55f8d$var$hclConvert(h) : new $79be02bbebd55f8d$export$d9397e094a5fbb9a(h, c, l, opacity == null ? 1 : opacity);
}
function $79be02bbebd55f8d$export$d9397e094a5fbb9a(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function $79be02bbebd55f8d$var$hcl2lab(o) {
    if (isNaN(o.h)) return new $79be02bbebd55f8d$export$f2722c70a60257f7(o.l, 0, 0, o.opacity);
    var h = o.h * (0, $934e15f7e80b4c50$export$8449e153fbd325fc);
    return new $79be02bbebd55f8d$export$f2722c70a60257f7(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, $jKHze.default)($79be02bbebd55f8d$export$d9397e094a5fbb9a, $79be02bbebd55f8d$export$d0e870ba50062ff1, (0, $jKHze.extend)((0, $9eF39.Color), {
    brighter (k) {
        return new $79be02bbebd55f8d$export$d9397e094a5fbb9a(this.h, this.c, this.l + $79be02bbebd55f8d$var$K * (k == null ? 1 : k), this.opacity);
    },
    darker (k) {
        return new $79be02bbebd55f8d$export$d9397e094a5fbb9a(this.h, this.c, this.l - $79be02bbebd55f8d$var$K * (k == null ? 1 : k), this.opacity);
    },
    rgb () {
        return $79be02bbebd55f8d$var$hcl2lab(this).rgb();
    }
}));



function $ecd90dd57fea92ab$var$hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $79be02bbebd55f8d$export$d0e870ba50062ff1)(start)).h, (end = (0, $79be02bbebd55f8d$export$d0e870ba50062ff1)(end)).h), c = (0, $8dfce0561889250e$export$2e2bcd8739ae039)(start.c, end.c), l = (0, $8dfce0561889250e$export$2e2bcd8739ae039)(start.l, end.l), opacity = (0, $8dfce0561889250e$export$2e2bcd8739ae039)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $ecd90dd57fea92ab$export$2e2bcd8739ae039 = $ecd90dd57fea92ab$var$hcl((0, $8dfce0561889250e$export$97d7b0c7ddb78dcf));
var $ecd90dd57fea92ab$export$5aaa50f7615f9b70 = $ecd90dd57fea92ab$var$hcl((0, $8dfce0561889250e$export$2e2bcd8739ae039));


var $9eF39 = parcelRequire("9eF39");

function $8b284d5f526b3abd$var$hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $9eF39.hsl)(start)).h, (end = (0, $9eF39.hsl)(end)).h), s = (0, $8dfce0561889250e$export$2e2bcd8739ae039)(start.s, end.s), l = (0, $8dfce0561889250e$export$2e2bcd8739ae039)(start.l, end.l), opacity = (0, $8dfce0561889250e$export$2e2bcd8739ae039)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $8b284d5f526b3abd$export$2e2bcd8739ae039 = $8b284d5f526b3abd$var$hsl((0, $8dfce0561889250e$export$97d7b0c7ddb78dcf));
var $8b284d5f526b3abd$export$a2c535e270a59256 = $8b284d5f526b3abd$var$hsl((0, $8dfce0561889250e$export$2e2bcd8739ae039));



function $c2982b9b18e1014d$export$2e2bcd8739ae039(start, end) {
    var l = (0, $8dfce0561889250e$export$2e2bcd8739ae039)((start = (0, $79be02bbebd55f8d$export$2e2bcd8739ae039)(start)).l, (end = (0, $79be02bbebd55f8d$export$2e2bcd8739ae039)(end)).l), a = (0, $8dfce0561889250e$export$2e2bcd8739ae039)(start.a, end.a), b = (0, $8dfce0561889250e$export$2e2bcd8739ae039)(start.b, end.b), opacity = (0, $8dfce0561889250e$export$2e2bcd8739ae039)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}




const $32a5a85184a4af27$var$interpolatorMap = {
    lab: (0, $c2982b9b18e1014d$export$2e2bcd8739ae039),
    hcl: (0, $ecd90dd57fea92ab$export$2e2bcd8739ae039),
    'hcl-long': (0, $ecd90dd57fea92ab$export$5aaa50f7615f9b70),
    hsl: (0, $8b284d5f526b3abd$export$2e2bcd8739ae039),
    'hsl-long': (0, $8b284d5f526b3abd$export$a2c535e270a59256),
    cubehelix: (0, $c9c323aa53ae4fa4$export$2e2bcd8739ae039),
    'cubehelix-long': (0, $c9c323aa53ae4fa4$export$934fa09ad474a1b4),
    rgb: (0, $c99ed0dd240dae7d$export$2e2bcd8739ae039)
};
function $32a5a85184a4af27$export$2e2bcd8739ae039(interpolate) {
    switch(interpolate){
        case 'lab':
        case 'hcl':
        case 'hcl-long':
        case 'hsl':
        case 'hsl-long':
        case 'cubehelix':
        case 'cubehelix-long':
        case 'rgb':
            return $32a5a85184a4af27$var$interpolatorMap[interpolate];
        default:
    }
    const { type: type, gamma: gamma } = interpolate;
    const interpolator = $32a5a85184a4af27$var$interpolatorMap[type];
    return typeof gamma === 'undefined' ? interpolator : interpolator.gamma(gamma);
}


function $d15c3a3f034528e2$export$2e2bcd8739ae039(scale, config) {
    if ('interpolate' in config && 'interpolate' in scale && typeof config.interpolate !== 'undefined') {
        const interpolator = (0, $32a5a85184a4af27$export$2e2bcd8739ae039)(config.interpolate);
        scale.interpolate(interpolator);
    }
}


/**
 * `@visx/vendor/d3-time` (ESM)
 * See upstream license: https://github.com/d3/d3-time/blob/main/LICENSE
 *
 * This ESM package re-exports the underlying installed dependencies of 
 * `node_modules/d3-time`
 */ 



const $b3e4321f03ad5c8d$var$TEST_TIME = new Date(Date.UTC(2020, 1, 2, 3, 4, 5));
const $b3e4321f03ad5c8d$var$TEST_FORMAT = '%Y-%m-%d %H:%M';
function $b3e4321f03ad5c8d$export$2e2bcd8739ae039(scale) {
    // The only difference between time and utc scale is
    // whether the tick format function is utcFormat or timeFormat
    const output = scale.tickFormat(1, $b3e4321f03ad5c8d$var$TEST_FORMAT)($b3e4321f03ad5c8d$var$TEST_TIME);
    return output === '2020-02-02 03:04';
}


const $c71766a01d1b0e23$var$localTimeIntervals = {
    day: (0, $5e70dbbdf6cbcd60$export$8888529b966033e5),
    hour: (0, $466ae73b10808091$export$46c68a5833bc315b),
    minute: (0, $09fb27a5e4fb95ff$export$a7e4c34a52f0576),
    month: (0, $c5a74691cb11e301$export$7e1084fb688591c1),
    second: (0, $e83c1f2e5676a7ce$export$3d3c77ce7df7d30d),
    week: (0, $f0217d3152d62256$export$22ee6205b762968c),
    year: (0, $5a498de4d8c46fef$export$cd17cfe45df0c046)
};
const $c71766a01d1b0e23$var$utcIntervals = {
    day: (0, $5e70dbbdf6cbcd60$export$c8cbc42cefd47140),
    hour: (0, $466ae73b10808091$export$31f6f2b3c63ac75e),
    minute: (0, $09fb27a5e4fb95ff$export$efe6712d6003761b),
    month: (0, $c5a74691cb11e301$export$cd49b3d2bcfe50d5),
    second: (0, $e83c1f2e5676a7ce$export$3d3c77ce7df7d30d),
    week: (0, $f0217d3152d62256$export$4898b06303a92011),
    year: (0, $5a498de4d8c46fef$export$d5c3802e389714c4)
};
function $c71766a01d1b0e23$export$2e2bcd8739ae039(scale, config) {
    if ('nice' in config && typeof config.nice !== 'undefined' && 'nice' in scale) {
        const { nice: nice } = config;
        if (typeof nice === 'boolean') {
            if (nice) scale.nice();
        } else if (typeof nice === 'number') scale.nice(nice);
        else {
            const timeScale = scale;
            const isUtc = (0, $b3e4321f03ad5c8d$export$2e2bcd8739ae039)(timeScale);
            if (typeof nice === 'string') timeScale.nice(isUtc ? $c71766a01d1b0e23$var$utcIntervals[nice] : $c71766a01d1b0e23$var$localTimeIntervals[nice]);
            else {
                const { interval: interval, step: step } = nice;
                const parsedInterval = (isUtc ? $c71766a01d1b0e23$var$utcIntervals[interval] : $c71766a01d1b0e23$var$localTimeIntervals[interval]).every(step);
                if (parsedInterval != null) timeScale.nice(parsedInterval);
            }
        }
    }
}


function $d258ff077feec804$export$2e2bcd8739ae039(scale, config) {
    if ('padding' in scale && 'padding' in config && typeof config.padding !== 'undefined') scale.padding(config.padding);
    if ('paddingInner' in scale && 'paddingInner' in config && typeof config.paddingInner !== 'undefined') scale.paddingInner(config.paddingInner);
    if ('paddingOuter' in scale && 'paddingOuter' in config && typeof config.paddingOuter !== 'undefined') scale.paddingOuter(config.paddingOuter);
}


function $d17f2404a7205197$export$2e2bcd8739ae039(scale, config) {
    if (config.reverse) {
        const reversedRange = scale.range().slice().reverse();
        if ('padding' in scale) // point and band scales
        scale.range(reversedRange);
        else // the rest
        scale.range(reversedRange);
    }
}



function $49fb7556171b94e3$export$2e2bcd8739ae039(scale, config) {
    if ('round' in config && typeof config.round !== 'undefined') {
        if (config.round && 'interpolate' in config && typeof config.interpolate !== 'undefined') console.warn(`[visx/scale/applyRound] ignoring round: scale config contains round and interpolate. only applying interpolate. config:`, config);
        else if ('round' in scale) // for point and band scales
        scale.round(config.round);
        else if ('interpolate' in scale && config.round) // for continuous output scales
        // setting config.round = true
        // is actually setting interpolator to interpolateRound
        // as these scales do not have scale.round() function
        scale.interpolate((0, $a7eb384d18622265$export$2e2bcd8739ae039));
    }
}


function $d2c0972fde40e644$export$2e2bcd8739ae039(scale, config) {
    if ('unknown' in scale && 'unknown' in config && typeof config.unknown !== 'undefined') scale.unknown(config.unknown);
}


function $b2498d1a7b34c687$export$2e2bcd8739ae039(scale, config) {
    if ('zero' in config && config.zero === true) {
        const domain = scale.domain();
        const [a, b] = domain;
        const isDescending = b < a;
        const [min, max] = isDescending ? [
            b,
            a
        ] : [
            a,
            b
        ];
        const domainWithZero = [
            Math.min(0, min),
            Math.max(0, max)
        ];
        scale.domain(isDescending ? domainWithZero.reverse() : domainWithZero);
    }
}


const $16766098afa85835$export$5f274da11658f617 = [
    // domain => nice => zero
    'domain',
    'nice',
    'zero',
    // interpolate before round
    'interpolate',
    'round',
    // set range then reverse
    'range',
    'reverse',
    // Order does not matter for these operators
    'align',
    'base',
    'clamp',
    'constant',
    'exponent',
    'padding',
    'unknown'
];
// Use Record to enforce that all keys in OperatorType must exist.
const $16766098afa85835$var$operators = {
    domain: $4ef393c360195193$export$2e2bcd8739ae039,
    nice: $c71766a01d1b0e23$export$2e2bcd8739ae039,
    zero: $b2498d1a7b34c687$export$2e2bcd8739ae039,
    interpolate: $d15c3a3f034528e2$export$2e2bcd8739ae039,
    round: $49fb7556171b94e3$export$2e2bcd8739ae039,
    align: $2056cb1b51a29316$export$2e2bcd8739ae039,
    base: $0f09d4c4772a5152$export$2e2bcd8739ae039,
    clamp: $07ca0d7706c3b538$export$2e2bcd8739ae039,
    constant: $bef6035fa56ef947$export$2e2bcd8739ae039,
    exponent: $e4af377e72cb9526$export$2e2bcd8739ae039,
    padding: $d258ff077feec804$export$2e2bcd8739ae039,
    range: $169f6e66bb1a381c$export$2e2bcd8739ae039,
    reverse: $d17f2404a7205197$export$2e2bcd8739ae039,
    unknown: $d2c0972fde40e644$export$2e2bcd8739ae039
};
function $16766098afa85835$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, ops = new Array(_len), _key = 0; _key < _len; _key++)ops[_key] = arguments[_key];
    const selection = new Set(ops);
    const selectedOps = $16766098afa85835$export$5f274da11658f617.filter((o)=>selection.has(o));
    return function applyOperators(scale, config) {
        if (typeof config !== 'undefined') selectedOps.forEach((op)=>{
            $16766098afa85835$var$operators[op](scale, config);
        });
        return scale;
    };
}


const $55c09c3fb6b4542d$export$933021962cd38dc1 = (0, $16766098afa85835$export$2e2bcd8739ae039)('domain', 'range', 'reverse', 'align', 'padding', 'round');
function $55c09c3fb6b4542d$export$2e2bcd8739ae039(config) {
    return $55c09c3fb6b4542d$export$933021962cd38dc1((0, $b1f3e4f79b270385$export$2e2bcd8739ae039)(), config);
}




const $19667b65a701425c$export$1c86c961a04b7858 = (0, $16766098afa85835$export$2e2bcd8739ae039)('domain', 'range', 'reverse', 'align', 'padding', 'round');
function $19667b65a701425c$export$2e2bcd8739ae039(config) {
    return $19667b65a701425c$export$1c86c961a04b7858((0, $b1f3e4f79b270385$export$105684a3041cb6f3)(), config);
}




const $7c30a724ea2126a9$export$7ce4d19a8c2ea22f = (0, $16766098afa85835$export$2e2bcd8739ae039)('domain', 'range', 'reverse', 'clamp', 'interpolate', 'nice', 'round', 'zero');
function $7c30a724ea2126a9$export$2e2bcd8739ae039(config) {
    return $7c30a724ea2126a9$export$7ce4d19a8c2ea22f((0, $9d892af289cba166$export$2e2bcd8739ae039)(), config);
}




const $9ea23020740d40b4$export$431f734484ef79b2 = (0, $16766098afa85835$export$2e2bcd8739ae039)('domain', 'range', 'clamp', 'nice', 'round', 'unknown');
function $9ea23020740d40b4$export$2e2bcd8739ae039(config) {
    return $9ea23020740d40b4$export$431f734484ef79b2((0, $19b5df9a14a4474f$export$2e2bcd8739ae039)(), config);
}




const $9293131f8df33854$export$a5ffb43f629473d4 = (0, $16766098afa85835$export$2e2bcd8739ae039)('domain', 'range', 'reverse', 'clamp', 'interpolate', 'nice', 'round');
function $9293131f8df33854$export$2e2bcd8739ae039(config) {
    return $9293131f8df33854$export$a5ffb43f629473d4((0, $0db31d2e50a00172$export$2e2bcd8739ae039)(), config);
}




const $6d96436fd4fae85b$export$1299f524ec3d9872 = (0, $16766098afa85835$export$2e2bcd8739ae039)('domain', 'range', 'reverse', 'clamp', 'interpolate', 'nice', 'round');
function $6d96436fd4fae85b$export$2e2bcd8739ae039(config) {
    return $6d96436fd4fae85b$export$1299f524ec3d9872((0, $ee184e54692052cd$export$2e2bcd8739ae039)(), config);
}




const $3be95b016ada5024$export$8cc7d5fc9fe1e0a3 = (0, $16766098afa85835$export$2e2bcd8739ae039)('domain', 'range', 'reverse', 'base', 'clamp', 'interpolate', 'nice', 'round');
function $3be95b016ada5024$export$2e2bcd8739ae039(config) {
    return $3be95b016ada5024$export$8cc7d5fc9fe1e0a3((0, $6d34d2706a66a4b6$export$2e2bcd8739ae039)(), config);
}




const $de43f0bde6acd688$export$87922a197a8e8c70 = (0, $16766098afa85835$export$2e2bcd8739ae039)('domain', 'range', 'reverse', 'clamp', 'exponent', 'interpolate', 'nice', 'round', 'zero');
function $de43f0bde6acd688$export$2e2bcd8739ae039(config) {
    return $de43f0bde6acd688$export$87922a197a8e8c70((0, $943d43665bf2f2ea$export$2e2bcd8739ae039)(), config);
}




const $5d94097fa39ec873$export$6c7fd0f60d1828d8 = (0, $16766098afa85835$export$2e2bcd8739ae039)('domain', 'range', 'reverse', 'unknown');
function $5d94097fa39ec873$export$2e2bcd8739ae039(config) {
    return $5d94097fa39ec873$export$6c7fd0f60d1828d8((0, $33dac692c189562a$export$2e2bcd8739ae039)(), config);
}




const $37285808ce9dc87c$export$5f3cf6e7c7b02548 = (0, $16766098afa85835$export$2e2bcd8739ae039)('domain', 'range', 'reverse', 'nice', 'zero');
function $37285808ce9dc87c$export$2e2bcd8739ae039(config) {
    return $37285808ce9dc87c$export$5f3cf6e7c7b02548((0, $a72f3e06ecfba646$export$2e2bcd8739ae039)(), config);
}




const $08921a9c9364d4a7$export$6972bc79bfb62230 = (0, $16766098afa85835$export$2e2bcd8739ae039)('domain', 'range', 'reverse');
function $08921a9c9364d4a7$export$2e2bcd8739ae039(config) {
    return $08921a9c9364d4a7$export$6972bc79bfb62230((0, $73da9d48522c828d$export$2e2bcd8739ae039)(), config);
}




const $87c9697de24f333a$export$35de7e99c307a66e = (0, $16766098afa85835$export$2e2bcd8739ae039)('domain', 'range', 'reverse', 'clamp', 'constant', 'nice', 'zero', 'round');
function $87c9697de24f333a$export$2e2bcd8739ae039(config) {
    return $87c9697de24f333a$export$35de7e99c307a66e((0, $4d8d9c4f2eaba224$export$2e2bcd8739ae039)(), config);
}




const $a8c10262ca4e2293$export$fc66f3d92af66a26 = (0, $16766098afa85835$export$2e2bcd8739ae039)('domain', 'range', 'reverse');
function $a8c10262ca4e2293$export$2e2bcd8739ae039(config) {
    return $a8c10262ca4e2293$export$fc66f3d92af66a26((0, $b276826d7c360777$export$2e2bcd8739ae039)(), config);
}




const $b042c0e768280497$export$c04980cdcd9c7a7a = (0, $16766098afa85835$export$2e2bcd8739ae039)('domain', 'range', 'reverse', 'clamp', 'interpolate', 'nice', 'round', 'zero');
function $b042c0e768280497$export$2e2bcd8739ae039(config) {
    return $b042c0e768280497$export$c04980cdcd9c7a7a((0, $943d43665bf2f2ea$export$eba8049fb5020b81)(), config);
}


/* eslint-disable @typescript-eslint/no-unused-vars */ /* eslint-disable no-redeclare */ 













// If the config is a linear config then a ScaleLinear will be returned
// instead of a union type of all scales.
// Actual implementation
function $070a822dceb20443$var$createScale(config) {
    if (typeof config !== 'undefined' && 'type' in config) switch(config.type){
        case 'linear':
            return (0, $7c30a724ea2126a9$export$2e2bcd8739ae039)(config);
        case 'log':
            return (0, $3be95b016ada5024$export$2e2bcd8739ae039)(config);
        case 'pow':
            return (0, $de43f0bde6acd688$export$2e2bcd8739ae039)(config);
        case 'sqrt':
            return (0, $b042c0e768280497$export$2e2bcd8739ae039)(config);
        case 'symlog':
            return (0, $87c9697de24f333a$export$2e2bcd8739ae039)(config);
        case 'time':
            return (0, $9293131f8df33854$export$2e2bcd8739ae039)(config);
        case 'utc':
            return (0, $6d96436fd4fae85b$export$2e2bcd8739ae039)(config);
        case 'quantile':
            return (0, $08921a9c9364d4a7$export$2e2bcd8739ae039)(config);
        case 'quantize':
            return (0, $37285808ce9dc87c$export$2e2bcd8739ae039)(config);
        case 'threshold':
            return (0, $a8c10262ca4e2293$export$2e2bcd8739ae039)(config);
        case 'ordinal':
            return (0, $5d94097fa39ec873$export$2e2bcd8739ae039)(config);
        case 'point':
            return (0, $19667b65a701425c$export$2e2bcd8739ae039)(config);
        case 'band':
            return (0, $55c09c3fb6b4542d$export$2e2bcd8739ae039)(config);
        case 'radial':
            return (0, $9ea23020740d40b4$export$2e2bcd8739ae039)(config);
        default:
    }
    // If type is not specified, fallback to linear scale
    return (0, $7c30a724ea2126a9$export$2e2bcd8739ae039)(config);
}
var $070a822dceb20443$export$2e2bcd8739ae039 = $070a822dceb20443$var$createScale;


/* eslint-disable no-redeclare */ /* eslint-disable @typescript-eslint/no-unused-vars */ 
const $5b100e954a7d74e0$var$applyAllOperators = (0, $16766098afa85835$export$2e2bcd8739ae039)(...(0, $16766098afa85835$export$5f274da11658f617));
// Overload function signature for more strict typing, e.g.,
// If the scale is a ScaleLinear, the config is a linear config.
// Actual implementation
function $5b100e954a7d74e0$var$updateScale(scale, config) {
    return $5b100e954a7d74e0$var$applyAllOperators(scale.copy(), config);
}
var $5b100e954a7d74e0$export$2e2bcd8739ae039 = $5b100e954a7d74e0$var$updateScale;



function $6adbb8ead5221144$export$2e2bcd8739ae039(scale) {
    // Try a sequence of typeguards to figure out the scale type
    if ('paddingInner' in scale) return 'band';
    if ('padding' in scale) return 'point';
    if ('quantiles' in scale) return 'quantile';
    if ('base' in scale) return 'log';
    if ('exponent' in scale) return scale.exponent() === 0.5 ? 'sqrt' : 'pow';
    if ('constant' in scale) return 'symlog';
    if ('clamp' in scale) {
        // Radial scales don't have interpolate method (unlike linear/time/utc)
        if (!('interpolate' in scale)) return 'radial';
        // Linear, Time or Utc scales
        const ticks = scale.ticks?.();
        if (ticks?.[0] instanceof Date) return (0, $b3e4321f03ad5c8d$export$2e2bcd8739ae039)(scale) ? 'utc' : 'time';
        return 'linear';
    }
    if ('nice' in scale) return 'quantize';
    if ('invertExtent' in scale) return 'threshold';
    return 'ordinal';
}


function $c32ed8852dffe2f4$export$2e2bcd8739ae039(val) {
    if ((typeof val === 'function' || typeof val === 'object' && !!val) && 'valueOf' in val) {
        const num = val.valueOf();
        if (typeof num === 'number') return num;
    }
    return val;
}


function $739bbf10d3a1c70b$export$2e2bcd8739ae039(scale, numTicks) {
    // Because `Scale` is generic type which maybe a subset of AnyD3Scale
    // that may not have `ticks` field,
    // TypeScript will not let us do the `'ticks' in scale` check directly.
    // Have to manually cast and expand type first.
    const s = scale;
    if ('ticks' in s) return s.ticks(numTicks);
    return s.domain().filter((_, index, arr)=>numTicks == null || arr.length <= numTicks || index % Math.round((arr.length - 1) / numTicks) === 0);
}


function $1cc2865a704159f1$export$2e2bcd8739ae039(x) {
    return x?.toString();
}


const $818e625ab5eaa16c$var$zeroableScaleTypes = new Set([
    'linear',
    'pow',
    'quantize',
    'sqrt',
    'symlog'
]);
function $818e625ab5eaa16c$export$2e2bcd8739ae039(scaleConfig) {
    return $818e625ab5eaa16c$var$zeroableScaleTypes.has(scaleConfig.type);
}


 // export types



var $236064fbb945a850$exports = {};

$parcel$export($236064fbb945a850$exports, "Arc", () => $c1e5b18b42dd328c$export$2e2bcd8739ae039);
$parcel$export($236064fbb945a850$exports, "Pie", () => $fa2d2f13de1937d0$export$2e2bcd8739ae039);
$parcel$export($236064fbb945a850$exports, "Line", () => $0e0a7792039d1a63$export$2e2bcd8739ae039);
$parcel$export($236064fbb945a850$exports, "LinePath", () => $c006d6ed47f7fa5f$export$2e2bcd8739ae039);
$parcel$export($236064fbb945a850$exports, "LineRadial", () => $da7179d0d53aa699$export$2e2bcd8739ae039);
$parcel$export($236064fbb945a850$exports, "Area", () => $ae7af5d88f7c9f70$export$2e2bcd8739ae039);
$parcel$export($236064fbb945a850$exports, "AreaClosed", () => $f9824f32a0689eb8$export$2e2bcd8739ae039);
$parcel$export($236064fbb945a850$exports, "AreaStack", () => $efaacb852b5226b1$export$2e2bcd8739ae039);
$parcel$export($236064fbb945a850$exports, "Bar", () => $3a3ab9fc8020305e$export$2e2bcd8739ae039);
$parcel$export($236064fbb945a850$exports, "BarRounded", () => $9037c5c0e8ce94e9$export$2e2bcd8739ae039);
$parcel$export($236064fbb945a850$exports, "BarGroup", () => $c5fdf5cddb9bcd9d$export$2e2bcd8739ae039);
$parcel$export($236064fbb945a850$exports, "BarGroupHorizontal", () => $251e90938cc6ac64$export$2e2bcd8739ae039);
$parcel$export($236064fbb945a850$exports, "BarStack", () => $6a2a8d0a868fcbb4$export$2e2bcd8739ae039);
$parcel$export($236064fbb945a850$exports, "BarStackHorizontal", () => $2dfb473045f8737e$export$2e2bcd8739ae039);
$parcel$export($236064fbb945a850$exports, "Stack", () => $3e92e1d89015b35b$export$2e2bcd8739ae039);
$parcel$export($236064fbb945a850$exports, "stackOffset", () => $f69514daf01a6903$export$2e2bcd8739ae039);
$parcel$export($236064fbb945a850$exports, "STACK_OFFSETS", () => $f69514daf01a6903$export$b29440972ed4e3cc);
$parcel$export($236064fbb945a850$exports, "STACK_OFFSET_NAMES", () => $f69514daf01a6903$export$f80b76cb2a25b919);
$parcel$export($236064fbb945a850$exports, "stackOrder", () => $b5407fe64a34b7cf$export$2e2bcd8739ae039);
$parcel$export($236064fbb945a850$exports, "STACK_ORDERS", () => $b5407fe64a34b7cf$export$f142d556a99f483c);
$parcel$export($236064fbb945a850$exports, "STACK_ORDER_NAMES", () => $b5407fe64a34b7cf$export$82f7741b5fe7f581);
$parcel$export($236064fbb945a850$exports, "degreesToRadians", () => $c585f1020bc3a488$export$c9fcf1a7df975d78);
$parcel$export($236064fbb945a850$exports, "getX", () => $c5a13e2a3e68b248$export$3a667a3b7e4d6701);
$parcel$export($236064fbb945a850$exports, "getY", () => $c5a13e2a3e68b248$export$337238c011325465);
$parcel$export($236064fbb945a850$exports, "getSource", () => $c5a13e2a3e68b248$export$dd2b6e807fb37ba3);
$parcel$export($236064fbb945a850$exports, "getTarget", () => $c5a13e2a3e68b248$export$c22522a4dfa48e9c);
$parcel$export($236064fbb945a850$exports, "getFirstItem", () => $c5a13e2a3e68b248$export$fbdeaa6a76694f71);
$parcel$export($236064fbb945a850$exports, "getSecondItem", () => $c5a13e2a3e68b248$export$18f9732b2021233c);
$parcel$export($236064fbb945a850$exports, "getBandwidth", () => $becd10fb064d621f$export$2e2bcd8739ae039);
$parcel$export($236064fbb945a850$exports, "LinkHorizontal", () => $ef54cb82c658c34a$export$2e2bcd8739ae039);
$parcel$export($236064fbb945a850$exports, "pathHorizontalDiagonal", () => $ef54cb82c658c34a$export$5bd8ca5f0c6b40b1);
$parcel$export($236064fbb945a850$exports, "LinkVertical", () => $208c7b6a644ccbfb$export$2e2bcd8739ae039);
$parcel$export($236064fbb945a850$exports, "pathVerticalDiagonal", () => $208c7b6a644ccbfb$export$53ba7b9927038e36);
$parcel$export($236064fbb945a850$exports, "LinkRadial", () => $ef3df5449039fa5d$export$2e2bcd8739ae039);
$parcel$export($236064fbb945a850$exports, "pathRadialDiagonal", () => $ef3df5449039fa5d$export$db837e8c7d6ea1b8);
$parcel$export($236064fbb945a850$exports, "LinkHorizontalCurve", () => $2e8a4bcce3c23d67$export$2e2bcd8739ae039);
$parcel$export($236064fbb945a850$exports, "pathHorizontalCurve", () => $2e8a4bcce3c23d67$export$cf8f8f087bf9e99);
$parcel$export($236064fbb945a850$exports, "LinkVerticalCurve", () => $dd785ee049636812$export$2e2bcd8739ae039);
$parcel$export($236064fbb945a850$exports, "pathVerticalCurve", () => $dd785ee049636812$export$8e538f4740957e64);
$parcel$export($236064fbb945a850$exports, "LinkRadialCurve", () => $0880240a34e0887e$export$2e2bcd8739ae039);
$parcel$export($236064fbb945a850$exports, "pathRadialCurve", () => $0880240a34e0887e$export$12d4a736eaeb4ba4);
$parcel$export($236064fbb945a850$exports, "LinkHorizontalLine", () => $b4ee84af13759f53$export$2e2bcd8739ae039);
$parcel$export($236064fbb945a850$exports, "pathHorizontalLine", () => $b4ee84af13759f53$export$f668c9d7464216ca);
$parcel$export($236064fbb945a850$exports, "LinkVerticalLine", () => $d5fe5334fc361fd6$export$2e2bcd8739ae039);
$parcel$export($236064fbb945a850$exports, "pathVerticalLine", () => $d5fe5334fc361fd6$export$724baf2291f19a28);
$parcel$export($236064fbb945a850$exports, "LinkRadialLine", () => $95ced4b130e965cf$export$2e2bcd8739ae039);
$parcel$export($236064fbb945a850$exports, "pathRadialLine", () => $95ced4b130e965cf$export$64b3403f14a8112e);
$parcel$export($236064fbb945a850$exports, "LinkHorizontalStep", () => $d927d2638f3b74de$export$2e2bcd8739ae039);
$parcel$export($236064fbb945a850$exports, "pathHorizontalStep", () => $d927d2638f3b74de$export$d6aeb1e4545d4807);
$parcel$export($236064fbb945a850$exports, "LinkVerticalStep", () => $4b1b0d7820b2d377$export$2e2bcd8739ae039);
$parcel$export($236064fbb945a850$exports, "pathVerticalStep", () => $4b1b0d7820b2d377$export$af9123cf8db9a5f9);
$parcel$export($236064fbb945a850$exports, "LinkRadialStep", () => $1199fe97dcbffe67$export$2e2bcd8739ae039);
$parcel$export($236064fbb945a850$exports, "pathRadialStep", () => $1199fe97dcbffe67$export$48f16a2e735e6163);
$parcel$export($236064fbb945a850$exports, "Polygon", () => $67466de18a091a87$export$2e2bcd8739ae039);
$parcel$export($236064fbb945a850$exports, "getPoints", () => $67466de18a091a87$export$af0496c55bf31eb);
$parcel$export($236064fbb945a850$exports, "getPoint", () => $67466de18a091a87$export$92d53b972f97f55a);
$parcel$export($236064fbb945a850$exports, "Circle", () => $60af5efcf68a36aa$export$2e2bcd8739ae039);
$parcel$export($236064fbb945a850$exports, "SplitLinePath", () => $ddcd9b48115befc4$export$2e2bcd8739ae039);
// @visx/shape

var $04c5cfbed3c2a8af$exports = {};

$parcel$export($04c5cfbed3c2a8af$exports, "arc", () => $04c5cfbed3c2a8af$export$ff1ef9a5c671f043);
$parcel$export($04c5cfbed3c2a8af$exports, "area", () => $04c5cfbed3c2a8af$export$bb3edc44842b5f2e);
$parcel$export($04c5cfbed3c2a8af$exports, "line", () => $04c5cfbed3c2a8af$export$53f1d5ea8de3d7c);
$parcel$export($04c5cfbed3c2a8af$exports, "pie", () => $04c5cfbed3c2a8af$export$47a9dca4012556c5);
$parcel$export($04c5cfbed3c2a8af$exports, "radialLine", () => $04c5cfbed3c2a8af$export$e51eca5eb5360e96);
$parcel$export($04c5cfbed3c2a8af$exports, "stack", () => $04c5cfbed3c2a8af$export$a57ab32f40f83ea9);
/**
 * `@visx/vendor/d3-shape` (ESM)
 * See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
 *
 * This ESM package re-exports the underlying installed dependencies of 
 * `node_modules/d3-shape`
 */ function $2c26b6a7171506ce$export$2e2bcd8739ae039(x) {
    return function constant() {
        return x;
    };
}


const $943da603a0b13397$export$2335f513bbd82c6d = Math.abs;
const $943da603a0b13397$export$b8b770ee6a0d9760 = Math.atan2;
const $943da603a0b13397$export$50d414a77b60d802 = Math.cos;
const $943da603a0b13397$export$8960430cfd85939f = Math.max;
const $943da603a0b13397$export$96ec731ed4dcb222 = Math.min;
const $943da603a0b13397$export$5de3937cb4b592ed = Math.sin;
const $943da603a0b13397$export$eba8049fb5020b81 = Math.sqrt;
const $943da603a0b13397$export$6c421550c66a327d = 1e-12;
const $943da603a0b13397$export$18c7bea995a110f = Math.PI;
const $943da603a0b13397$export$e51408a300e8929a = $943da603a0b13397$export$18c7bea995a110f / 2;
const $943da603a0b13397$export$a4b4b4d4d776fe92 = 2 * $943da603a0b13397$export$18c7bea995a110f;
function $943da603a0b13397$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $943da603a0b13397$export$18c7bea995a110f : Math.acos(x);
}
function $943da603a0b13397$export$41726bdb1fc63f(x) {
    return x >= 1 ? $943da603a0b13397$export$e51408a300e8929a : x <= -1 ? -$943da603a0b13397$export$e51408a300e8929a : Math.asin(x);
}


const $746f2af20cbe541b$var$pi = Math.PI, $746f2af20cbe541b$var$tau = 2 * $746f2af20cbe541b$var$pi, $746f2af20cbe541b$var$epsilon = 1e-6, $746f2af20cbe541b$var$tauEpsilon = $746f2af20cbe541b$var$tau - $746f2af20cbe541b$var$epsilon;
function $746f2af20cbe541b$var$append(strings) {
    this._ += strings[0];
    for(let i = 1, n = strings.length; i < n; ++i)this._ += arguments[i] + strings[i];
}
function $746f2af20cbe541b$var$appendRound(digits) {
    let d = Math.floor(digits);
    if (!(d >= 0)) throw new Error(`invalid digits: ${digits}`);
    if (d > 15) return $746f2af20cbe541b$var$append;
    const k = 10 ** d;
    return function(strings) {
        this._ += strings[0];
        for(let i = 1, n = strings.length; i < n; ++i)this._ += Math.round(arguments[i] * k) / k + strings[i];
    };
}
class $746f2af20cbe541b$export$4b2950bdac9b6ee9 {
    constructor(digits){
        this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
        this._ = "";
        this._append = digits == null ? $746f2af20cbe541b$var$append : $746f2af20cbe541b$var$appendRound(digits);
    }
    moveTo(x, y) {
        this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}`;
    }
    closePath() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._append`Z`;
        }
    }
    lineTo(x, y) {
        this._append`L${this._x1 = +x},${this._y1 = +y}`;
    }
    quadraticCurveTo(x1, y1, x, y) {
        this._append`Q${+x1},${+y1},${this._x1 = +x},${this._y1 = +y}`;
    }
    bezierCurveTo(x1, y1, x2, y2, x, y) {
        this._append`C${+x1},${+y1},${+x2},${+y2},${this._x1 = +x},${this._y1 = +y}`;
    }
    arcTo(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        // Is the radius negative? Error.
        if (r < 0) throw new Error(`negative radius: ${r}`);
        let x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._append`M${this._x1 = x1},${this._y1 = y1}`;
        else if (!(l01_2 > $746f2af20cbe541b$var$epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $746f2af20cbe541b$var$epsilon) || !r) this._append`L${this._x1 = x1},${this._y1 = y1}`;
        else {
            let x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($746f2af20cbe541b$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $746f2af20cbe541b$var$epsilon) this._append`L${x1 + t01 * x01},${y1 + t01 * y01}`;
            this._append`A${r},${r},0,0,${+(y01 * x20 > x01 * y20)},${this._x1 = x1 + t21 * x21},${this._y1 = y1 + t21 * y21}`;
        }
    }
    arc(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        // Is the radius negative? Error.
        if (r < 0) throw new Error(`negative radius: ${r}`);
        let dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._append`M${x0},${y0}`;
        else if (Math.abs(this._x1 - x0) > $746f2af20cbe541b$var$epsilon || Math.abs(this._y1 - y0) > $746f2af20cbe541b$var$epsilon) this._append`L${x0},${y0}`;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $746f2af20cbe541b$var$tau + $746f2af20cbe541b$var$tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $746f2af20cbe541b$var$tauEpsilon) this._append`A${r},${r},0,1,${cw},${x - dx},${y - dy}A${r},${r},0,1,${cw},${this._x1 = x0},${this._y1 = y0}`;
        else if (da > $746f2af20cbe541b$var$epsilon) this._append`A${r},${r},0,${+(da >= $746f2af20cbe541b$var$pi)},${cw},${this._x1 = x + r * Math.cos(a1)},${this._y1 = y + r * Math.sin(a1)}`;
    }
    rect(x, y, w, h) {
        this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}h${w = +w}v${+h}h${-w}Z`;
    }
    toString() {
        return this._;
    }
}
function $746f2af20cbe541b$export$bb654e07daaf8c3a() {
    return new $746f2af20cbe541b$export$4b2950bdac9b6ee9;
}
// Allow instanceof d3.path
$746f2af20cbe541b$export$bb654e07daaf8c3a.prototype = $746f2af20cbe541b$export$4b2950bdac9b6ee9.prototype;
function $746f2af20cbe541b$export$e181c6ece8d9cc5f(digits = 3) {
    return new $746f2af20cbe541b$export$4b2950bdac9b6ee9(+digits);
}


function $c8ad0a1c5e7228a7$export$fb6e83118a5dcd45(shape) {
    let digits = 3;
    shape.digits = function(_) {
        if (!arguments.length) return digits;
        if (_ == null) digits = null;
        else {
            const d = Math.floor(_);
            if (!(d >= 0)) throw new RangeError(`invalid digits: ${_}`);
            digits = d;
        }
        return shape;
    };
    return ()=>new (0, $746f2af20cbe541b$export$4b2950bdac9b6ee9)(digits);
}


function $8f91d7e9c47620ae$var$arcInnerRadius(d) {
    return d.innerRadius;
}
function $8f91d7e9c47620ae$var$arcOuterRadius(d) {
    return d.outerRadius;
}
function $8f91d7e9c47620ae$var$arcStartAngle(d) {
    return d.startAngle;
}
function $8f91d7e9c47620ae$var$arcEndAngle(d) {
    return d.endAngle;
}
function $8f91d7e9c47620ae$var$arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function $8f91d7e9c47620ae$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < (0, $943da603a0b13397$export$6c421550c66a327d)) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
}
// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function $8f91d7e9c47620ae$var$cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, $943da603a0b13397$export$eba8049fb5020b81)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, $943da603a0b13397$export$eba8049fb5020b81)((0, $943da603a0b13397$export$8960430cfd85939f)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00;
    // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}
function $8f91d7e9c47620ae$export$2e2bcd8739ae039() {
    var innerRadius = $8f91d7e9c47620ae$var$arcInnerRadius, outerRadius = $8f91d7e9c47620ae$var$arcOuterRadius, cornerRadius = (0, $2c26b6a7171506ce$export$2e2bcd8739ae039)(0), padRadius = null, startAngle = $8f91d7e9c47620ae$var$arcStartAngle, endAngle = $8f91d7e9c47620ae$var$arcEndAngle, padAngle = $8f91d7e9c47620ae$var$arcPadAngle, context = null, path = (0, $c8ad0a1c5e7228a7$export$fb6e83118a5dcd45)(arc);
    function arc() {
        var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - (0, $943da603a0b13397$export$e51408a300e8929a), a1 = endAngle.apply(this, arguments) - (0, $943da603a0b13397$export$e51408a300e8929a), da = (0, $943da603a0b13397$export$2335f513bbd82c6d)(a1 - a0), cw = a1 > a0;
        if (!context) context = buffer = path();
        // Ensure that the outer radius is always larger than the inner radius.
        if (r1 < r0) r = r1, r1 = r0, r0 = r;
        // Is it a point?
        if (!(r1 > (0, $943da603a0b13397$export$6c421550c66a327d))) context.moveTo(0, 0);
        else if (da > (0, $943da603a0b13397$export$a4b4b4d4d776fe92) - (0, $943da603a0b13397$export$6c421550c66a327d)) {
            context.moveTo(r1 * (0, $943da603a0b13397$export$50d414a77b60d802)(a0), r1 * (0, $943da603a0b13397$export$5de3937cb4b592ed)(a0));
            context.arc(0, 0, r1, a0, a1, !cw);
            if (r0 > (0, $943da603a0b13397$export$6c421550c66a327d)) {
                context.moveTo(r0 * (0, $943da603a0b13397$export$50d414a77b60d802)(a1), r0 * (0, $943da603a0b13397$export$5de3937cb4b592ed)(a1));
                context.arc(0, 0, r0, a1, a0, cw);
            }
        } else {
            var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > (0, $943da603a0b13397$export$6c421550c66a327d) && (padRadius ? +padRadius.apply(this, arguments) : (0, $943da603a0b13397$export$eba8049fb5020b81)(r0 * r0 + r1 * r1)), rc = (0, $943da603a0b13397$export$96ec731ed4dcb222)((0, $943da603a0b13397$export$2335f513bbd82c6d)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1;
            // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
            if (rp > (0, $943da603a0b13397$export$6c421550c66a327d)) {
                var p0 = (0, $943da603a0b13397$export$41726bdb1fc63f)(rp / r0 * (0, $943da603a0b13397$export$5de3937cb4b592ed)(ap)), p1 = (0, $943da603a0b13397$export$41726bdb1fc63f)(rp / r1 * (0, $943da603a0b13397$export$5de3937cb4b592ed)(ap));
                if ((da0 -= p0 * 2) > (0, $943da603a0b13397$export$6c421550c66a327d)) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                if ((da1 -= p1 * 2) > (0, $943da603a0b13397$export$6c421550c66a327d)) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }
            var x01 = r1 * (0, $943da603a0b13397$export$50d414a77b60d802)(a01), y01 = r1 * (0, $943da603a0b13397$export$5de3937cb4b592ed)(a01), x10 = r0 * (0, $943da603a0b13397$export$50d414a77b60d802)(a10), y10 = r0 * (0, $943da603a0b13397$export$5de3937cb4b592ed)(a10);
            // Apply rounded corners?
            if (rc > (0, $943da603a0b13397$export$6c421550c66a327d)) {
                var x11 = r1 * (0, $943da603a0b13397$export$50d414a77b60d802)(a11), y11 = r1 * (0, $943da603a0b13397$export$5de3937cb4b592ed)(a11), x00 = r0 * (0, $943da603a0b13397$export$50d414a77b60d802)(a00), y00 = r0 * (0, $943da603a0b13397$export$5de3937cb4b592ed)(a00), oc;
                // Restrict the corner radius according to the sector angle. If this
                // intersection fails, it’s probably because the arc is too small, so
                // disable the corner radius entirely.
                if (da < (0, $943da603a0b13397$export$18c7bea995a110f)) {
                    if (oc = $8f91d7e9c47620ae$var$intersect(x01, y01, x00, y00, x11, y11, x10, y10)) {
                        var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, $943da603a0b13397$export$5de3937cb4b592ed)((0, $943da603a0b13397$export$fd6306be3fde5b04)((ax * bx + ay * by) / ((0, $943da603a0b13397$export$eba8049fb5020b81)(ax * ax + ay * ay) * (0, $943da603a0b13397$export$eba8049fb5020b81)(bx * bx + by * by))) / 2), lc = (0, $943da603a0b13397$export$eba8049fb5020b81)(oc[0] * oc[0] + oc[1] * oc[1]);
                        rc0 = (0, $943da603a0b13397$export$96ec731ed4dcb222)(rc, (r0 - lc) / (kc - 1));
                        rc1 = (0, $943da603a0b13397$export$96ec731ed4dcb222)(rc, (r1 - lc) / (kc + 1));
                    } else rc0 = rc1 = 0;
                }
            }
            // Is the sector collapsed to a line?
            if (!(da1 > (0, $943da603a0b13397$export$6c421550c66a327d))) context.moveTo(x01, y01);
            else if (rc1 > (0, $943da603a0b13397$export$6c421550c66a327d)) {
                t0 = $8f91d7e9c47620ae$var$cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = $8f91d7e9c47620ae$var$cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
                // Have the corners merged?
                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, $943da603a0b13397$export$b8b770ee6a0d9760)(t0.y01, t0.x01), (0, $943da603a0b13397$export$b8b770ee6a0d9760)(t1.y01, t1.x01), !cw);
                else {
                    context.arc(t0.cx, t0.cy, rc1, (0, $943da603a0b13397$export$b8b770ee6a0d9760)(t0.y01, t0.x01), (0, $943da603a0b13397$export$b8b770ee6a0d9760)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, (0, $943da603a0b13397$export$b8b770ee6a0d9760)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $943da603a0b13397$export$b8b770ee6a0d9760)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, (0, $943da603a0b13397$export$b8b770ee6a0d9760)(t1.y11, t1.x11), (0, $943da603a0b13397$export$b8b770ee6a0d9760)(t1.y01, t1.x01), !cw);
                }
            } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
            // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?
            if (!(r0 > (0, $943da603a0b13397$export$6c421550c66a327d)) || !(da0 > (0, $943da603a0b13397$export$6c421550c66a327d))) context.lineTo(x10, y10);
            else if (rc0 > (0, $943da603a0b13397$export$6c421550c66a327d)) {
                t0 = $8f91d7e9c47620ae$var$cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = $8f91d7e9c47620ae$var$cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
                // Have the corners merged?
                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, $943da603a0b13397$export$b8b770ee6a0d9760)(t0.y01, t0.x01), (0, $943da603a0b13397$export$b8b770ee6a0d9760)(t1.y01, t1.x01), !cw);
                else {
                    context.arc(t0.cx, t0.cy, rc0, (0, $943da603a0b13397$export$b8b770ee6a0d9760)(t0.y01, t0.x01), (0, $943da603a0b13397$export$b8b770ee6a0d9760)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, (0, $943da603a0b13397$export$b8b770ee6a0d9760)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $943da603a0b13397$export$b8b770ee6a0d9760)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, (0, $943da603a0b13397$export$b8b770ee6a0d9760)(t1.y11, t1.x11), (0, $943da603a0b13397$export$b8b770ee6a0d9760)(t1.y01, t1.x01), !cw);
                }
            } else context.arc(0, 0, r0, a10, a00, cw);
        }
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - (0, $943da603a0b13397$export$18c7bea995a110f) / 2;
        return [
            (0, $943da603a0b13397$export$50d414a77b60d802)(a) * r,
            (0, $943da603a0b13397$export$5de3937cb4b592ed)(a) * r
        ];
    };
    arc.innerRadius = function(_) {
        return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, $2c26b6a7171506ce$export$2e2bcd8739ae039)(+_), arc) : innerRadius;
    };
    arc.outerRadius = function(_) {
        return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, $2c26b6a7171506ce$export$2e2bcd8739ae039)(+_), arc) : outerRadius;
    };
    arc.cornerRadius = function(_) {
        return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, $2c26b6a7171506ce$export$2e2bcd8739ae039)(+_), arc) : cornerRadius;
    };
    arc.padRadius = function(_) {
        return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, $2c26b6a7171506ce$export$2e2bcd8739ae039)(+_), arc) : padRadius;
    };
    arc.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $2c26b6a7171506ce$export$2e2bcd8739ae039)(+_), arc) : startAngle;
    };
    arc.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $2c26b6a7171506ce$export$2e2bcd8739ae039)(+_), arc) : endAngle;
    };
    arc.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $2c26b6a7171506ce$export$2e2bcd8739ae039)(+_), arc) : padAngle;
    };
    arc.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };
    return arc;
}

var $efd74fc39470cc3f$export$58adb3bec8346d0f = Array.prototype.slice;
function $efd74fc39470cc3f$export$2e2bcd8739ae039(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}



function $d87e124a9f71ed55$var$Linear(context) {
    this._context = context;
}
$d87e124a9f71ed55$var$Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $d87e124a9f71ed55$export$2e2bcd8739ae039(context) {
    return new $d87e124a9f71ed55$var$Linear(context);
}






function $1e92aab74a22a78e$export$d141bba7fdc215a3(p) {
    return p[0];
}
function $1e92aab74a22a78e$export$4a5767248b18ef41(p) {
    return p[1];
}


function $9c3cecaa353b7825$export$2e2bcd8739ae039(x, y) {
    var defined = (0, $2c26b6a7171506ce$export$2e2bcd8739ae039)(true), context = null, curve = (0, $d87e124a9f71ed55$export$2e2bcd8739ae039), output = null, path = (0, $c8ad0a1c5e7228a7$export$fb6e83118a5dcd45)(line);
    x = typeof x === "function" ? x : x === undefined ? (0, $1e92aab74a22a78e$export$d141bba7fdc215a3) : (0, $2c26b6a7171506ce$export$2e2bcd8739ae039)(x);
    y = typeof y === "function" ? y : y === undefined ? (0, $1e92aab74a22a78e$export$4a5767248b18ef41) : (0, $2c26b6a7171506ce$export$2e2bcd8739ae039)(y);
    function line(data) {
        var i, n = (data = (0, $efd74fc39470cc3f$export$2e2bcd8739ae039)(data)).length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = path());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $2c26b6a7171506ce$export$2e2bcd8739ae039)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $2c26b6a7171506ce$export$2e2bcd8739ae039)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $2c26b6a7171506ce$export$2e2bcd8739ae039)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}




function $ee850285c0f937e9$export$2e2bcd8739ae039(x0, y0, y1) {
    var x1 = null, defined = (0, $2c26b6a7171506ce$export$2e2bcd8739ae039)(true), context = null, curve = (0, $d87e124a9f71ed55$export$2e2bcd8739ae039), output = null, path = (0, $c8ad0a1c5e7228a7$export$fb6e83118a5dcd45)(area);
    x0 = typeof x0 === "function" ? x0 : x0 === undefined ? (0, $1e92aab74a22a78e$export$d141bba7fdc215a3) : (0, $2c26b6a7171506ce$export$2e2bcd8739ae039)(+x0);
    y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, $2c26b6a7171506ce$export$2e2bcd8739ae039)(0) : (0, $2c26b6a7171506ce$export$2e2bcd8739ae039)(+y0);
    y1 = typeof y1 === "function" ? y1 : y1 === undefined ? (0, $1e92aab74a22a78e$export$4a5767248b18ef41) : (0, $2c26b6a7171506ce$export$2e2bcd8739ae039)(+y1);
    function area(data) {
        var i, j, k, n = (data = (0, $efd74fc39470cc3f$export$2e2bcd8739ae039)(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = path());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, $9c3cecaa353b7825$export$2e2bcd8739ae039)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $2c26b6a7171506ce$export$2e2bcd8739ae039)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $2c26b6a7171506ce$export$2e2bcd8739ae039)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, $2c26b6a7171506ce$export$2e2bcd8739ae039)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $2c26b6a7171506ce$export$2e2bcd8739ae039)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $2c26b6a7171506ce$export$2e2bcd8739ae039)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, $2c26b6a7171506ce$export$2e2bcd8739ae039)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $2c26b6a7171506ce$export$2e2bcd8739ae039)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}



function $20f4cb6aacd49b3c$export$2e2bcd8739ae039(x, y) {
    return [
        (y = +y) * Math.cos(x -= Math.PI / 2),
        y * Math.sin(x)
    ];
}


class $83e77297f5450da5$var$Bump {
    constructor(context, x){
        this._context = context;
        this._x = x;
    }
    areaStart() {
        this._line = 0;
    }
    areaEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    }
    point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                if (this._line) this._context.lineTo(x, y);
                else this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);
                else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
                break;
        }
        this._x0 = x, this._y0 = y;
    }
}
class $83e77297f5450da5$var$BumpRadial {
    constructor(context){
        this._context = context;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {}
    point(x, y) {
        x = +x, y = +y;
        if (this._point === 0) this._point = 1;
        else {
            const p0 = (0, $20f4cb6aacd49b3c$export$2e2bcd8739ae039)(this._x0, this._y0);
            const p1 = (0, $20f4cb6aacd49b3c$export$2e2bcd8739ae039)(this._x0, this._y0 = (this._y0 + y) / 2);
            const p2 = (0, $20f4cb6aacd49b3c$export$2e2bcd8739ae039)(x, this._y0);
            const p3 = (0, $20f4cb6aacd49b3c$export$2e2bcd8739ae039)(x, y);
            this._context.moveTo(...p0);
            this._context.bezierCurveTo(...p1, ...p2, ...p3);
        }
        this._x0 = x, this._y0 = y;
    }
}
function $83e77297f5450da5$export$2c099b5096f70ce6(context) {
    return new $83e77297f5450da5$var$Bump(context, true);
}
function $83e77297f5450da5$export$908da9dfa54cbed6(context) {
    return new $83e77297f5450da5$var$Bump(context, false);
}
function $83e77297f5450da5$export$8c82a77a5061b331(context) {
    return new $83e77297f5450da5$var$BumpRadial(context);
}




function $13606a4646f930aa$var$linkSource(d) {
    return d.source;
}
function $13606a4646f930aa$var$linkTarget(d) {
    return d.target;
}
function $13606a4646f930aa$export$9c30223ca0a664fb(curve) {
    let source = $13606a4646f930aa$var$linkSource, target = $13606a4646f930aa$var$linkTarget, x = (0, $1e92aab74a22a78e$export$d141bba7fdc215a3), y = (0, $1e92aab74a22a78e$export$4a5767248b18ef41), context = null, output = null, path = (0, $c8ad0a1c5e7228a7$export$fb6e83118a5dcd45)(link);
    function link() {
        let buffer;
        const argv = (0, $efd74fc39470cc3f$export$58adb3bec8346d0f).call(arguments);
        const s = source.apply(this, argv);
        const t = target.apply(this, argv);
        if (context == null) output = curve(buffer = path());
        output.lineStart();
        argv[0] = s, output.point(+x.apply(this, argv), +y.apply(this, argv));
        argv[0] = t, output.point(+x.apply(this, argv), +y.apply(this, argv));
        output.lineEnd();
        if (buffer) return output = null, buffer + "" || null;
    }
    link.source = function(_) {
        return arguments.length ? (source = _, link) : source;
    };
    link.target = function(_) {
        return arguments.length ? (target = _, link) : target;
    };
    link.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $2c26b6a7171506ce$export$2e2bcd8739ae039)(+_), link) : x;
    };
    link.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $2c26b6a7171506ce$export$2e2bcd8739ae039)(+_), link) : y;
    };
    link.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), link) : context;
    };
    return link;
}
function $13606a4646f930aa$export$e7c381889b2cd14d() {
    return $13606a4646f930aa$export$9c30223ca0a664fb((0, $83e77297f5450da5$export$2c099b5096f70ce6));
}
function $13606a4646f930aa$export$75de4c8c66884e04() {
    return $13606a4646f930aa$export$9c30223ca0a664fb((0, $83e77297f5450da5$export$908da9dfa54cbed6));
}
function $13606a4646f930aa$export$7739cfe68d4e0799() {
    const l = $13606a4646f930aa$export$9c30223ca0a664fb((0, $83e77297f5450da5$export$8c82a77a5061b331));
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    return l;
}



function $18ada1814a4116da$export$2e2bcd8739ae039(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}


function $2eefc4a6dcde4919$export$2e2bcd8739ae039(d) {
    return d;
}



function $568857482d9c7c61$export$2e2bcd8739ae039() {
    var value = (0, $2eefc4a6dcde4919$export$2e2bcd8739ae039), sortValues = (0, $18ada1814a4116da$export$2e2bcd8739ae039), sort = null, startAngle = (0, $2c26b6a7171506ce$export$2e2bcd8739ae039)(0), endAngle = (0, $2c26b6a7171506ce$export$2e2bcd8739ae039)((0, $943da603a0b13397$export$a4b4b4d4d776fe92)), padAngle = (0, $2c26b6a7171506ce$export$2e2bcd8739ae039)(0);
    function pie(data) {
        var i, n = (data = (0, $efd74fc39470cc3f$export$2e2bcd8739ae039)(data)).length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min((0, $943da603a0b13397$export$a4b4b4d4d776fe92), Math.max(-(0, $943da603a0b13397$export$a4b4b4d4d776fe92), endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
        for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
        // Optionally sort the arcs by previously-computed values or by data.
        if (sortValues != null) index.sort(function(i, j) {
            return sortValues(arcs[i], arcs[j]);
        });
        else if (sort != null) index.sort(function(i, j) {
            return sort(data[i], data[j]);
        });
        // Compute the arcs! They are stored in the original data's order.
        for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
            data: data[j],
            index: i,
            value: v,
            startAngle: a0,
            endAngle: a1,
            padAngle: p
        };
        return arcs;
    }
    pie.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $2c26b6a7171506ce$export$2e2bcd8739ae039)(+_), pie) : value;
    };
    pie.sortValues = function(_) {
        return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
    };
    pie.sort = function(_) {
        return arguments.length ? (sort = _, sortValues = null, pie) : sort;
    };
    pie.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $2c26b6a7171506ce$export$2e2bcd8739ae039)(+_), pie) : startAngle;
    };
    pie.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $2c26b6a7171506ce$export$2e2bcd8739ae039)(+_), pie) : endAngle;
    };
    pie.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $2c26b6a7171506ce$export$2e2bcd8739ae039)(+_), pie) : padAngle;
    };
    return pie;
}


var $8351eec2da1699f5$export$22d25ffb9fb15b6f = $8351eec2da1699f5$export$2e2bcd8739ae039((0, $d87e124a9f71ed55$export$2e2bcd8739ae039));
function $8351eec2da1699f5$var$Radial(curve) {
    this._curve = curve;
}
$8351eec2da1699f5$var$Radial.prototype = {
    areaStart: function() {
        this._curve.areaStart();
    },
    areaEnd: function() {
        this._curve.areaEnd();
    },
    lineStart: function() {
        this._curve.lineStart();
    },
    lineEnd: function() {
        this._curve.lineEnd();
    },
    point: function(a, r) {
        this._curve.point(r * Math.sin(a), r * -Math.cos(a));
    }
};
function $8351eec2da1699f5$export$2e2bcd8739ae039(curve) {
    function radial(context) {
        return new $8351eec2da1699f5$var$Radial(curve(context));
    }
    radial._curve = curve;
    return radial;
}



function $3d983e251cb2c8a2$export$4d8815a75dc8cd4d(l) {
    var c = l.curve;
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    l.curve = function(_) {
        return arguments.length ? c((0, $8351eec2da1699f5$export$2e2bcd8739ae039)(_)) : c()._curve;
    };
    return l;
}
function $3d983e251cb2c8a2$export$2e2bcd8739ae039() {
    return $3d983e251cb2c8a2$export$4d8815a75dc8cd4d((0, $9c3cecaa353b7825$export$2e2bcd8739ae039)().curve((0, $8351eec2da1699f5$export$22d25ffb9fb15b6f)));
}



function $0c3303cc8d5e6665$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}


function $e90a0a2c97350ba9$export$2e2bcd8739ae039(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}


function $6be110a9c654dd03$var$stackValue(d, key) {
    return d[key];
}
function $6be110a9c654dd03$var$stackSeries(key) {
    const series = [];
    series.key = key;
    return series;
}
function $6be110a9c654dd03$export$2e2bcd8739ae039() {
    var keys = (0, $2c26b6a7171506ce$export$2e2bcd8739ae039)([]), order = (0, $e90a0a2c97350ba9$export$2e2bcd8739ae039), offset = (0, $0c3303cc8d5e6665$export$2e2bcd8739ae039), value = $6be110a9c654dd03$var$stackValue;
    function stack(data) {
        var sz = Array.from(keys.apply(this, arguments), $6be110a9c654dd03$var$stackSeries), i, n = sz.length, j = -1, oz;
        for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
            0,
            +value(d, sz[i].key, j, data)
        ]).data = d;
        for(i = 0, oz = (0, $efd74fc39470cc3f$export$2e2bcd8739ae039)(order(sz)); i < n; ++i)sz[oz[i]].index = i;
        offset(sz, oz);
        return sz;
    }
    stack.keys = function(_) {
        return arguments.length ? (keys = typeof _ === "function" ? _ : (0, $2c26b6a7171506ce$export$2e2bcd8739ae039)(Array.from(_)), stack) : keys;
    };
    stack.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $2c26b6a7171506ce$export$2e2bcd8739ae039)(+_), stack) : value;
    };
    stack.order = function(_) {
        return arguments.length ? (order = _ == null ? (0, $e90a0a2c97350ba9$export$2e2bcd8739ae039) : typeof _ === "function" ? _ : (0, $2c26b6a7171506ce$export$2e2bcd8739ae039)(Array.from(_)), stack) : order;
    };
    stack.offset = function(_) {
        return arguments.length ? (offset = _ == null ? (0, $0c3303cc8d5e6665$export$2e2bcd8739ae039) : _, stack) : offset;
    };
    return stack;
}

function $c22e2b272895d626$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
        if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
        else if (dy < 0) d[1] = yn, d[0] = yn += dy;
        else d[0] = 0, d[1] = dy;
    }
}


function $cd9b40e1b01dac12$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
        for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
        if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
    }
    (0, $0c3303cc8d5e6665$export$2e2bcd8739ae039)(series, order);
}


function $be3be0d59092db9a$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
        for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
        s0[j][1] += s0[j][0] = -y / 2;
    }
    (0, $0c3303cc8d5e6665$export$2e2bcd8739ae039)(series, order);
}


function $459d7141716d56e4$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for(var y = 0, j = 1, s0, m, n; j < m; ++j){
        for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
            var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
            for(var k = 0; k < i; ++k){
                var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                s3 += skj0 - skj1;
            }
            s1 += sij0, s2 += s3 * sij0;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    (0, $0c3303cc8d5e6665$export$2e2bcd8739ae039)(series, order);
}


function $00c670233718a772$export$2e2bcd8739ae039(series) {
    var sums = series.map($00c670233718a772$export$8a63f25cc62965f1);
    return (0, $e90a0a2c97350ba9$export$2e2bcd8739ae039)(series).sort(function(a, b) {
        return sums[a] - sums[b];
    });
}
function $00c670233718a772$export$8a63f25cc62965f1(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}


function $54c119307e15c7a3$export$2e2bcd8739ae039(series) {
    return (0, $00c670233718a772$export$2e2bcd8739ae039)(series).reverse();
}


function $7264d200c2616f5b$export$2e2bcd8739ae039(series) {
    var peaks = series.map($7264d200c2616f5b$var$peak);
    return (0, $e90a0a2c97350ba9$export$2e2bcd8739ae039)(series).sort(function(a, b) {
        return peaks[a] - peaks[b];
    });
}
function $7264d200c2616f5b$var$peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}



function $a01db1fe7c29147e$export$2e2bcd8739ae039(series) {
    var n = series.length, i, j, sums = series.map((0, $00c670233718a772$export$8a63f25cc62965f1)), order = (0, $7264d200c2616f5b$export$2e2bcd8739ae039)(series), top = 0, bottom = 0, tops = [], bottoms = [];
    for(i = 0; i < n; ++i){
        j = order[i];
        if (top < bottom) {
            top += sums[j];
            tops.push(j);
        } else {
            bottom += sums[j];
            bottoms.push(j);
        }
    }
    return bottoms.reverse().concat(tops);
}


function $0f2cef1001b9f880$export$2e2bcd8739ae039(series) {
    return (0, $e90a0a2c97350ba9$export$2e2bcd8739ae039)(series).reverse();
}




const $587ebc75592109d6$var$sqrt3 = (0, $943da603a0b13397$export$eba8049fb5020b81)(3);
var $587ebc75592109d6$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $943da603a0b13397$export$eba8049fb5020b81)(size + (0, $943da603a0b13397$export$96ec731ed4dcb222)(size / 28, 0.75)) * 0.59436;
        const t = r / 2;
        const u = t * $587ebc75592109d6$var$sqrt3;
        context.moveTo(0, r);
        context.lineTo(0, -r);
        context.moveTo(-u, -t);
        context.lineTo(u, t);
        context.moveTo(-u, t);
        context.lineTo(u, -t);
    }
};



var $99dc9be8d3a6e141$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $943da603a0b13397$export$eba8049fb5020b81)(size / (0, $943da603a0b13397$export$18c7bea995a110f));
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, (0, $943da603a0b13397$export$a4b4b4d4d776fe92));
    }
};



var $ad740482921b4df8$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $943da603a0b13397$export$eba8049fb5020b81)(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};



const $78c4e72d0d208477$var$tan30 = (0, $943da603a0b13397$export$eba8049fb5020b81)(1 / 3);
const $78c4e72d0d208477$var$tan30_2 = $78c4e72d0d208477$var$tan30 * 2;
var $78c4e72d0d208477$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const y = (0, $943da603a0b13397$export$eba8049fb5020b81)(size / $78c4e72d0d208477$var$tan30_2);
        const x = y * $78c4e72d0d208477$var$tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};



var $cdc1ffef48aa22f5$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $943da603a0b13397$export$eba8049fb5020b81)(size) * 0.62625;
        context.moveTo(0, -r);
        context.lineTo(r, 0);
        context.lineTo(0, r);
        context.lineTo(-r, 0);
        context.closePath();
    }
};



var $995f8de161df83bf$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $943da603a0b13397$export$eba8049fb5020b81)(size - (0, $943da603a0b13397$export$96ec731ed4dcb222)(size / 7, 2)) * 0.87559;
        context.moveTo(-r, 0);
        context.lineTo(r, 0);
        context.moveTo(0, r);
        context.lineTo(0, -r);
    }
};



var $ae86d870f041ac46$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const w = (0, $943da603a0b13397$export$eba8049fb5020b81)(size);
        const x = -w / 2;
        context.rect(x, x, w, w);
    }
};



var $2357856b4158d6da$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $943da603a0b13397$export$eba8049fb5020b81)(size) * 0.4431;
        context.moveTo(r, r);
        context.lineTo(r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, r);
        context.closePath();
    }
};



const $ad6b3dee1e949ade$var$ka = 0.89081309152928522810;
const $ad6b3dee1e949ade$var$kr = (0, $943da603a0b13397$export$5de3937cb4b592ed)((0, $943da603a0b13397$export$18c7bea995a110f) / 10) / (0, $943da603a0b13397$export$5de3937cb4b592ed)(7 * (0, $943da603a0b13397$export$18c7bea995a110f) / 10);
const $ad6b3dee1e949ade$var$kx = (0, $943da603a0b13397$export$5de3937cb4b592ed)((0, $943da603a0b13397$export$a4b4b4d4d776fe92) / 10) * $ad6b3dee1e949ade$var$kr;
const $ad6b3dee1e949ade$var$ky = -(0, $943da603a0b13397$export$50d414a77b60d802)((0, $943da603a0b13397$export$a4b4b4d4d776fe92) / 10) * $ad6b3dee1e949ade$var$kr;
var $ad6b3dee1e949ade$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $943da603a0b13397$export$eba8049fb5020b81)(size * $ad6b3dee1e949ade$var$ka);
        const x = $ad6b3dee1e949ade$var$kx * r;
        const y = $ad6b3dee1e949ade$var$ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(let i = 1; i < 5; ++i){
            const a = (0, $943da603a0b13397$export$a4b4b4d4d776fe92) * i / 5;
            const c = (0, $943da603a0b13397$export$50d414a77b60d802)(a);
            const s = (0, $943da603a0b13397$export$5de3937cb4b592ed)(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};



const $81723e6d3f8e7883$var$sqrt3 = (0, $943da603a0b13397$export$eba8049fb5020b81)(3);
var $81723e6d3f8e7883$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const y = -(0, $943da603a0b13397$export$eba8049fb5020b81)(size / ($81723e6d3f8e7883$var$sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-$81723e6d3f8e7883$var$sqrt3 * y, -y);
        context.lineTo($81723e6d3f8e7883$var$sqrt3 * y, -y);
        context.closePath();
    }
};



const $61e290ed1d9eb7e5$var$sqrt3 = (0, $943da603a0b13397$export$eba8049fb5020b81)(3);
var $61e290ed1d9eb7e5$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const s = (0, $943da603a0b13397$export$eba8049fb5020b81)(size) * 0.6824;
        const t = s / 2;
        const u = s * $61e290ed1d9eb7e5$var$sqrt3 / 2; // cos(Math.PI / 6)
        context.moveTo(0, -s);
        context.lineTo(u, t);
        context.lineTo(-u, t);
        context.closePath();
    }
};



const $acd724fef4bf01f9$var$c = -0.5;
const $acd724fef4bf01f9$var$s = (0, $943da603a0b13397$export$eba8049fb5020b81)(3) / 2;
const $acd724fef4bf01f9$var$k = 1 / (0, $943da603a0b13397$export$eba8049fb5020b81)(12);
const $acd724fef4bf01f9$var$a = ($acd724fef4bf01f9$var$k / 2 + 1) * 3;
var $acd724fef4bf01f9$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $943da603a0b13397$export$eba8049fb5020b81)(size / $acd724fef4bf01f9$var$a);
        const x0 = r / 2, y0 = r * $acd724fef4bf01f9$var$k;
        const x1 = x0, y1 = r * $acd724fef4bf01f9$var$k + r;
        const x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo($acd724fef4bf01f9$var$c * x0 - $acd724fef4bf01f9$var$s * y0, $acd724fef4bf01f9$var$s * x0 + $acd724fef4bf01f9$var$c * y0);
        context.lineTo($acd724fef4bf01f9$var$c * x1 - $acd724fef4bf01f9$var$s * y1, $acd724fef4bf01f9$var$s * x1 + $acd724fef4bf01f9$var$c * y1);
        context.lineTo($acd724fef4bf01f9$var$c * x2 - $acd724fef4bf01f9$var$s * y2, $acd724fef4bf01f9$var$s * x2 + $acd724fef4bf01f9$var$c * y2);
        context.lineTo($acd724fef4bf01f9$var$c * x0 + $acd724fef4bf01f9$var$s * y0, $acd724fef4bf01f9$var$c * y0 - $acd724fef4bf01f9$var$s * x0);
        context.lineTo($acd724fef4bf01f9$var$c * x1 + $acd724fef4bf01f9$var$s * y1, $acd724fef4bf01f9$var$c * y1 - $acd724fef4bf01f9$var$s * x1);
        context.lineTo($acd724fef4bf01f9$var$c * x2 + $acd724fef4bf01f9$var$s * y2, $acd724fef4bf01f9$var$c * y2 - $acd724fef4bf01f9$var$s * x2);
        context.closePath();
    }
};



var $31ce2ec367ef4276$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $943da603a0b13397$export$eba8049fb5020b81)(size - (0, $943da603a0b13397$export$96ec731ed4dcb222)(size / 6, 1.7)) * 0.6189;
        context.moveTo(-r, -r);
        context.lineTo(r, r);
        context.moveTo(-r, r);
        context.lineTo(r, -r);
    }
};


const $366ee85fae7a7cdc$export$19158c96a6700c15 = [
    (0, $99dc9be8d3a6e141$export$2e2bcd8739ae039),
    (0, $ad740482921b4df8$export$2e2bcd8739ae039),
    (0, $78c4e72d0d208477$export$2e2bcd8739ae039),
    (0, $ae86d870f041ac46$export$2e2bcd8739ae039),
    (0, $ad6b3dee1e949ade$export$2e2bcd8739ae039),
    (0, $81723e6d3f8e7883$export$2e2bcd8739ae039),
    (0, $acd724fef4bf01f9$export$2e2bcd8739ae039)
];
const $366ee85fae7a7cdc$export$915e06de6acf8fe = [
    (0, $99dc9be8d3a6e141$export$2e2bcd8739ae039),
    (0, $995f8de161df83bf$export$2e2bcd8739ae039),
    (0, $31ce2ec367ef4276$export$2e2bcd8739ae039),
    (0, $61e290ed1d9eb7e5$export$2e2bcd8739ae039),
    (0, $587ebc75592109d6$export$2e2bcd8739ae039),
    (0, $2357856b4158d6da$export$2e2bcd8739ae039),
    (0, $cdc1ffef48aa22f5$export$2e2bcd8739ae039)
];
function $366ee85fae7a7cdc$export$2e2bcd8739ae039(type, size) {
    let context = null, path = (0, $c8ad0a1c5e7228a7$export$fb6e83118a5dcd45)(symbol);
    type = typeof type === "function" ? type : (0, $2c26b6a7171506ce$export$2e2bcd8739ae039)(type || (0, $99dc9be8d3a6e141$export$2e2bcd8739ae039));
    size = typeof size === "function" ? size : (0, $2c26b6a7171506ce$export$2e2bcd8739ae039)(size === undefined ? 64 : +size);
    function symbol() {
        let buffer;
        if (!context) context = buffer = path();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, $2c26b6a7171506ce$export$2e2bcd8739ae039)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, $2c26b6a7171506ce$export$2e2bcd8739ae039)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}




/**
 * This is a workaround for TypeScript not inferring the correct
 * method overload/signature for some d3 shape methods.
 */ function $de63c6bb63cceedd$export$2e2bcd8739ae039(func, value) {
    if (typeof value === 'number') func(value);
    else func(value);
}



const $b5407fe64a34b7cf$export$f142d556a99f483c = {
    ascending: (0, $00c670233718a772$export$2e2bcd8739ae039),
    descending: (0, $54c119307e15c7a3$export$2e2bcd8739ae039),
    insideout: (0, $a01db1fe7c29147e$export$2e2bcd8739ae039),
    none: (0, $e90a0a2c97350ba9$export$2e2bcd8739ae039),
    reverse: (0, $0f2cef1001b9f880$export$2e2bcd8739ae039)
};
const $b5407fe64a34b7cf$export$82f7741b5fe7f581 = Object.keys($b5407fe64a34b7cf$export$f142d556a99f483c);
function $b5407fe64a34b7cf$export$2e2bcd8739ae039(order) {
    return order && $b5407fe64a34b7cf$export$f142d556a99f483c[order] || $b5407fe64a34b7cf$export$f142d556a99f483c.none;
}



const $f69514daf01a6903$export$b29440972ed4e3cc = {
    expand: (0, $cd9b40e1b01dac12$export$2e2bcd8739ae039),
    diverging: (0, $c22e2b272895d626$export$2e2bcd8739ae039),
    none: (0, $0c3303cc8d5e6665$export$2e2bcd8739ae039),
    silhouette: (0, $be3be0d59092db9a$export$2e2bcd8739ae039),
    wiggle: (0, $459d7141716d56e4$export$2e2bcd8739ae039)
};
const $f69514daf01a6903$export$f80b76cb2a25b919 = Object.keys($f69514daf01a6903$export$b29440972ed4e3cc);
function $f69514daf01a6903$export$2e2bcd8739ae039(offset) {
    return offset && $f69514daf01a6903$export$b29440972ed4e3cc[offset] || $f69514daf01a6903$export$b29440972ed4e3cc.none;
}


function $04c5cfbed3c2a8af$export$ff1ef9a5c671f043() {
    let { innerRadius: innerRadius, outerRadius: outerRadius, cornerRadius: cornerRadius, startAngle: startAngle, endAngle: endAngle, padAngle: padAngle, padRadius: padRadius } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const path = (0, $8f91d7e9c47620ae$export$2e2bcd8739ae039)();
    if (innerRadius != null) (0, $de63c6bb63cceedd$export$2e2bcd8739ae039)(path.innerRadius, innerRadius);
    if (outerRadius != null) (0, $de63c6bb63cceedd$export$2e2bcd8739ae039)(path.outerRadius, outerRadius);
    if (cornerRadius != null) (0, $de63c6bb63cceedd$export$2e2bcd8739ae039)(path.cornerRadius, cornerRadius);
    if (startAngle != null) (0, $de63c6bb63cceedd$export$2e2bcd8739ae039)(path.startAngle, startAngle);
    if (endAngle != null) (0, $de63c6bb63cceedd$export$2e2bcd8739ae039)(path.endAngle, endAngle);
    if (padAngle != null) (0, $de63c6bb63cceedd$export$2e2bcd8739ae039)(path.padAngle, padAngle);
    if (padRadius != null) (0, $de63c6bb63cceedd$export$2e2bcd8739ae039)(path.padRadius, padRadius);
    return path;
}
function $04c5cfbed3c2a8af$export$bb3edc44842b5f2e() {
    let { x: x, x0: x0, x1: x1, y: y, y0: y0, y1: y1, defined: defined, curve: curve } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const path = (0, $ee850285c0f937e9$export$2e2bcd8739ae039)();
    if (x) (0, $de63c6bb63cceedd$export$2e2bcd8739ae039)(path.x, x);
    if (x0) (0, $de63c6bb63cceedd$export$2e2bcd8739ae039)(path.x0, x0);
    if (x1) (0, $de63c6bb63cceedd$export$2e2bcd8739ae039)(path.x1, x1);
    if (y) (0, $de63c6bb63cceedd$export$2e2bcd8739ae039)(path.y, y);
    if (y0) (0, $de63c6bb63cceedd$export$2e2bcd8739ae039)(path.y0, y0);
    if (y1) (0, $de63c6bb63cceedd$export$2e2bcd8739ae039)(path.y1, y1);
    if (defined) path.defined(defined);
    if (curve) path.curve(curve);
    return path;
}
function $04c5cfbed3c2a8af$export$53f1d5ea8de3d7c() {
    let { x: x, y: y, defined: defined, curve: curve } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const path = (0, $9c3cecaa353b7825$export$2e2bcd8739ae039)();
    if (x) (0, $de63c6bb63cceedd$export$2e2bcd8739ae039)(path.x, x);
    if (y) (0, $de63c6bb63cceedd$export$2e2bcd8739ae039)(path.y, y);
    if (defined) path.defined(defined);
    if (curve) path.curve(curve);
    return path;
}
function $04c5cfbed3c2a8af$export$47a9dca4012556c5() {
    let { startAngle: startAngle, endAngle: endAngle, padAngle: padAngle, value: value, sort: sort, sortValues: sortValues } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const path = (0, $568857482d9c7c61$export$2e2bcd8739ae039)();
    // In d3-shape v3+, sortValues defaults to descending sort.
    // To maintain visx's behavior of preserving input order by default,
    // we explicitly set sortValues to null when neither sort nor sortValues is provided.
    // Note: d3's pie generator clears sortValues when sort is set, and vice versa.
    if (sortValues !== undefined) path.sortValues(sortValues);
    else if (sort === undefined) // Neither provided - disable sorting to preserve input order
    path.sortValues(null);
    else if (sort === null) // explicit null: clear comparator
    path.sort(null);
    else // here sort is narrowed to a comparator function
    path.sort(sort);
    if (value != null) path.value(value);
    if (padAngle != null) (0, $de63c6bb63cceedd$export$2e2bcd8739ae039)(path.padAngle, padAngle);
    if (startAngle != null) (0, $de63c6bb63cceedd$export$2e2bcd8739ae039)(path.startAngle, startAngle);
    if (endAngle != null) (0, $de63c6bb63cceedd$export$2e2bcd8739ae039)(path.endAngle, endAngle);
    return path;
}
function $04c5cfbed3c2a8af$export$e51eca5eb5360e96() {
    let { angle: angle, radius: radius, defined: defined, curve: curve } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const path = (0, $3d983e251cb2c8a2$export$2e2bcd8739ae039)();
    if (angle) (0, $de63c6bb63cceedd$export$2e2bcd8739ae039)(path.angle, angle);
    if (radius) (0, $de63c6bb63cceedd$export$2e2bcd8739ae039)(path.radius, radius);
    if (defined) path.defined(defined);
    if (curve) path.curve(curve);
    return path;
}
function $04c5cfbed3c2a8af$export$a57ab32f40f83ea9(_ref) {
    let { keys: keys, value: value, order: order, offset: offset } = _ref;
    const path = (0, $6be110a9c654dd03$export$2e2bcd8739ae039)();
    if (keys) path.keys(keys);
    if (value) (0, $de63c6bb63cceedd$export$2e2bcd8739ae039)(path.value, value);
    if (order) path.order((0, $b5407fe64a34b7cf$export$2e2bcd8739ae039)(order));
    if (offset) path.offset((0, $f69514daf01a6903$export$2e2bcd8739ae039)(offset));
    return path;
}



function $c1e5b18b42dd328c$export$2e2bcd8739ae039(_ref) {
    let { className: className, data: data, innerRadius: innerRadius, outerRadius: outerRadius, cornerRadius: cornerRadius, startAngle: startAngle, endAngle: endAngle, padAngle: padAngle, padRadius: padRadius, children: children, innerRef: innerRef, ...restProps } = _ref;
    const path = (0, $04c5cfbed3c2a8af$export$ff1ef9a5c671f043)({
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        cornerRadius: cornerRadius,
        startAngle: startAngle,
        endAngle: endAngle,
        padAngle: padAngle,
        padRadius: padRadius
    });
    if (children) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: children({
            path: path
        })
    });
    if (!data && (startAngle == null || endAngle == null || innerRadius == null || outerRadius == null)) {
        console.warn('[@visx/shape/Arc]: expected data because one of startAngle, endAngle, innerRadius, outerRadius is undefined. Bailing.');
        return null;
    }
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("path", {
        ref: innerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-arc', className),
        d: path(data) || '',
        ...restProps
    });
}






function $fa2d2f13de1937d0$export$2e2bcd8739ae039(_ref) {
    let { className: className, top: top, left: left, data: data = [], centroid: centroid, innerRadius: innerRadius = 0, outerRadius: outerRadius, cornerRadius: cornerRadius, startAngle: startAngle, endAngle: endAngle, padAngle: padAngle, padRadius: padRadius, pieSort: pieSort, pieSortValues: pieSortValues, pieValue: pieValue, children: children, fill: fill = '', ...restProps } = _ref;
    const path = (0, $04c5cfbed3c2a8af$export$ff1ef9a5c671f043)({
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        cornerRadius: cornerRadius,
        padRadius: padRadius
    });
    const pie = (0, $04c5cfbed3c2a8af$export$47a9dca4012556c5)({
        startAngle: startAngle,
        endAngle: endAngle,
        padAngle: padAngle,
        value: pieValue,
        sort: pieSort,
        sortValues: pieSortValues
    });
    const arcs = pie(data);
    if (children) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: children({
            arcs: arcs,
            path: path,
            pie: pie
        })
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $268dd56f34f61467$export$2e2bcd8739ae039), {
        className: "visx-pie-arcs-group",
        top: top,
        left: left,
        children: arcs.map((arc, i)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("path", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-pie-arc', className),
                        d: path(arc) || '',
                        fill: fill == null || typeof fill === 'string' ? fill : fill(arc),
                        ...restProps
                    }),
                    centroid?.(path.centroid(arc), arc)
                ]
            }, `pie-arc-${i}`))
    });
}




function $0e0a7792039d1a63$export$2e2bcd8739ae039(_ref) {
    let { from: from = {
        x: 0,
        y: 0
    }, to: to = {
        x: 1,
        y: 1
    }, fill: fill = 'transparent', className: className, innerRef: innerRef, ...restProps } = _ref;
    const isRectilinear = from.x === to.x || from.y === to.y;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("line", {
        ref: innerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-line', className),
        x1: from.x,
        y1: from.y,
        x2: to.x,
        y2: to.y,
        fill: fill,
        shapeRendering: isRectilinear ? 'crispEdges' : 'auto',
        ...restProps
    });
}





function $c006d6ed47f7fa5f$export$2e2bcd8739ae039(_ref) {
    let { children: children, data: data = [], x: x, y: y, fill: fill = 'transparent', className: className, curve: curve, innerRef: innerRef, defined: defined = ()=>true, ...restProps } = _ref;
    const path = (0, $04c5cfbed3c2a8af$export$53f1d5ea8de3d7c)({
        x: x,
        y: y,
        defined: defined,
        curve: curve
    });
    if (children) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: children({
            path: path
        })
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("path", {
        ref: innerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-linepath', className),
        d: path(data) || '',
        fill: fill,
        strokeLinecap: "round",
        ...restProps
    });
}





function $da7179d0d53aa699$export$2e2bcd8739ae039(_ref) {
    let { className: className, angle: angle, radius: radius, defined: defined, curve: curve, data: data = [], innerRef: innerRef, children: children, fill: fill = 'transparent', ...restProps } = _ref;
    const path = (0, $04c5cfbed3c2a8af$export$e51eca5eb5360e96)({
        angle: angle,
        radius: radius,
        defined: defined,
        curve: curve
    });
    if (children) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: children({
            path: path
        })
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("path", {
        ref: innerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-line-radial', className),
        d: path(data) || '',
        fill: fill,
        ...restProps
    });
}





function $ae7af5d88f7c9f70$export$2e2bcd8739ae039(_ref) {
    let { children: children, x: x, x0: x0, x1: x1, y: y, y0: y0, y1: y1, data: data = [], defined: defined = ()=>true, className: className, curve: curve, innerRef: innerRef, ...restProps } = _ref;
    const path = (0, $04c5cfbed3c2a8af$export$bb3edc44842b5f2e)({
        x: x,
        x0: x0,
        x1: x1,
        y: y,
        y0: y0,
        y1: y1,
        defined: defined,
        curve: curve
    });
    if (children) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: children({
            path: path
        })
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("path", {
        ref: innerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-area', className),
        d: path(data) || '',
        ...restProps
    });
}






function $f9824f32a0689eb8$export$2e2bcd8739ae039(_ref) {
    let { x: x, x0: x0, x1: x1, y: y, y1: y1, y0: y0, yScale: yScale, data: data = [], defined: defined = ()=>true, className: className, curve: curve, innerRef: innerRef, children: children, ...restProps } = _ref;
    const path = (0, $04c5cfbed3c2a8af$export$bb3edc44842b5f2e)({
        x: x,
        x0: x0,
        x1: x1,
        defined: defined,
        curve: curve
    });
    if (y0 == null) /**
     * by default set the baseline to the first element of the yRange
     * @TODO take the minimum instead?
     */ path.y0(yScale.range()[0]);
    else (0, $de63c6bb63cceedd$export$2e2bcd8739ae039)(path.y0, y0);
    if (y && !y1) (0, $de63c6bb63cceedd$export$2e2bcd8739ae039)(path.y1, y);
    if (y1 && !y) (0, $de63c6bb63cceedd$export$2e2bcd8739ae039)(path.y1, y1);
    if (children) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: children({
            path: path
        })
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("path", {
        ref: innerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-area-closed', className),
        d: path(data) || '',
        ...restProps
    });
}







function $3e92e1d89015b35b$export$2e2bcd8739ae039(_ref) {
    let { className: className, top: top, left: left, keys: keys, data: data, curve: curve, defined: defined, x: x, x0: x0, x1: x1, y0: y0, y1: y1, value: value, order: order, offset: offset, color: color, children: children, ...restProps } = _ref;
    const stack = (0, $04c5cfbed3c2a8af$export$a57ab32f40f83ea9)({
        keys: keys,
        value: value,
        order: order,
        offset: offset
    });
    const path = (0, $04c5cfbed3c2a8af$export$bb3edc44842b5f2e)({
        x: x,
        x0: x0,
        x1: x1,
        y0: y0,
        y1: y1,
        curve: curve,
        defined: defined
    });
    const stacks = stack(data);
    if (children) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: children({
            stacks: stacks,
            path: path,
            stack: stack
        })
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $268dd56f34f61467$export$2e2bcd8739ae039), {
        top: top,
        left: left,
        children: stacks.map((series, i)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("path", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-stack', className),
                d: path(series) || '',
                fill: color?.(series.key, i),
                ...restProps
            }, `stack-${i}-${series.key || ''}`))
    });
}



function $efaacb852b5226b1$export$2e2bcd8739ae039(_ref) {
    let { className: className, top: top, left: left, keys: keys, data: data, curve: curve, defined: defined, x: x, x0: x0, x1: x1, y0: y0, y1: y1, value: value, order: order, offset: offset, color: color, children: children, ...restProps } = _ref;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $3e92e1d89015b35b$export$2e2bcd8739ae039), {
        className: className,
        top: top,
        left: left,
        keys: keys,
        data: data,
        curve: curve,
        defined: defined,
        x: x,
        x0: x0,
        x1: x1,
        y0: y0,
        y1: y1,
        value: value,
        order: order,
        offset: offset,
        color: color,
        ...restProps,
        children: children || ((_ref2)=>{
            let { stacks: stacks, path: path } = _ref2;
            return stacks.map((series, i)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("path", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-area-stack', className),
                    d: path(series) || '',
                    fill: color?.(series.key, i),
                    ...restProps
                }, `area-stack-${i}-${series.key || ''}`));
        })
    });
}




function $3a3ab9fc8020305e$export$2e2bcd8739ae039(_ref) {
    let { className: className, innerRef: innerRef, ...restProps } = _ref;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("rect", {
        ref: innerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-bar', className),
        ...restProps
    });
}




function $9037c5c0e8ce94e9$export$e9680bfc0bc93b2f(_ref) {
    let { all: all, bottom: bottom, bottomLeft: bottomLeft, bottomRight: bottomRight, height: height, left: left, radius: radius, right: right, top: top, topLeft: topLeft, topRight: topRight, width: width, x: x, y: y } = _ref;
    topRight = all || top || right || topRight;
    bottomRight = all || bottom || right || bottomRight;
    bottomLeft = all || bottom || left || bottomLeft;
    topLeft = all || top || left || topLeft;
    // clamp radius to center of shortest side of the rect
    radius = Math.max(1, Math.min(radius, Math.min(width, height) / 2));
    const diameter = 2 * radius;
    const path = `M${x + radius},${y} h${width - diameter}
 ${topRight ? `a${radius},${radius} 0 0 1 ${radius},${radius}` : `h${radius}v${radius}`}
 v${height - diameter}
 ${bottomRight ? `a${radius},${radius} 0 0 1 ${-radius},${radius}` : `v${radius}h${-radius}`}
 h${diameter - width}
 ${bottomLeft ? `a${radius},${radius} 0 0 1 ${-radius},${-radius}` : `h${-radius}v${-radius}`}
 v${diameter - height}
 ${topLeft ? `a${radius},${radius} 0 0 1 ${radius},${-radius}` : `v${-radius}h${radius}`}
z`.split('\n').join('');
    return path;
}
function $9037c5c0e8ce94e9$export$2e2bcd8739ae039(_ref2) {
    let { children: children, className: className, innerRef: innerRef, x: x, y: y, width: width, height: height, radius: radius, all: all = false, top: top = false, bottom: bottom = false, left: left = false, right: right = false, topLeft: topLeft = false, topRight: topRight = false, bottomLeft: bottomLeft = false, bottomRight: bottomRight = false, ...restProps } = _ref2;
    const path = $9037c5c0e8ce94e9$export$e9680bfc0bc93b2f({
        x: x,
        y: y,
        width: width,
        height: height,
        radius: radius,
        all: all,
        top: top,
        bottom: bottom,
        left: left,
        right: right,
        topLeft: topLeft,
        topRight: topRight,
        bottomLeft: bottomLeft,
        bottomRight: bottomRight
    });
    if (children) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: children({
            path: path
        })
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("path", {
        ref: innerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-bar-rounded', className),
        d: path,
        ...restProps
    });
}





function $becd10fb064d621f$export$2e2bcd8739ae039(scale) {
    if ('bandwidth' in scale) return scale.bandwidth();
    const range = scale.range();
    const domain = scale.domain();
    return Math.abs(range[range.length - 1] - range[0]) / domain.length;
}



function $c5fdf5cddb9bcd9d$export$2e2bcd8739ae039(_ref) {
    let { data: data, className: className, top: top, left: left, x0: x0, x0Scale: x0Scale, x1Scale: x1Scale, yScale: yScale, color: color, keys: keys, height: height, children: children, ...restProps } = _ref;
    const barWidth = (0, $becd10fb064d621f$export$2e2bcd8739ae039)(x1Scale);
    const barGroups = data.map((group, i)=>({
            index: i,
            x0: x0Scale(x0(group)),
            bars: keys.map((key, j)=>{
                const value = group[key];
                return {
                    index: j,
                    key: key,
                    value: value,
                    width: barWidth,
                    x: x1Scale(key) || 0,
                    y: yScale(value) || 0,
                    color: color(key, j),
                    height: height - (yScale(value) || 0)
                };
            })
        }));
    if (children) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: children(barGroups)
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $268dd56f34f61467$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-bar-group', className),
        top: top,
        left: left,
        children: barGroups.map((barGroup)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $268dd56f34f61467$export$2e2bcd8739ae039), {
                left: barGroup.x0,
                children: barGroup.bars.map((bar)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $3a3ab9fc8020305e$export$2e2bcd8739ae039), {
                        x: bar.x,
                        y: bar.y,
                        width: bar.width,
                        height: bar.height,
                        fill: bar.color,
                        ...restProps
                    }, `bar-group-bar-${barGroup.index}-${bar.index}-${bar.value}-${bar.key}`))
            }, `bar-group-${barGroup.index}-${barGroup.x0}`))
    });
}







function $251e90938cc6ac64$export$2e2bcd8739ae039(_ref) {
    let { data: data, className: className, top: top, left: left, x: x = ()=>0, y0: y0, y0Scale: y0Scale, y1Scale: y1Scale, xScale: xScale, color: color, keys: keys, width: width, children: children, ...restProps } = _ref;
    const barHeight = (0, $becd10fb064d621f$export$2e2bcd8739ae039)(y1Scale);
    const barGroups = data.map((group, i)=>({
            index: i,
            y0: y0Scale(y0(group)) || 0,
            bars: keys.map((key, j)=>{
                const value = group[key];
                return {
                    index: j,
                    key: key,
                    value: value,
                    height: barHeight,
                    x: x(value) || 0,
                    y: y1Scale(key) || 0,
                    color: color(key, j),
                    width: xScale(value) || 0
                };
            })
        }));
    if (children) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: children(barGroups)
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $268dd56f34f61467$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-bar-group-horizontal', className),
        top: top,
        left: left,
        children: barGroups.map((barGroup)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $268dd56f34f61467$export$2e2bcd8739ae039), {
                top: barGroup.y0,
                children: barGroup.bars.map((bar)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $3a3ab9fc8020305e$export$2e2bcd8739ae039), {
                        x: bar.x,
                        y: bar.y,
                        width: bar.width,
                        height: bar.height,
                        fill: bar.color,
                        ...restProps
                    }, `bar-group-bar-${barGroup.index}-${bar.index}-${bar.value}-${bar.key}`))
            }, `bar-group-${barGroup.index}-${barGroup.y0}`))
    });
}





function $c5a13e2a3e68b248$export$3a667a3b7e4d6701(l) {
    return typeof l?.x === 'number' ? l?.x : 0;
}
function $c5a13e2a3e68b248$export$337238c011325465(l) {
    return typeof l?.y === 'number' ? l?.y : 0;
}
function $c5a13e2a3e68b248$export$dd2b6e807fb37ba3(l) {
    return l?.source;
}
function $c5a13e2a3e68b248$export$c22522a4dfa48e9c(l) {
    return l?.target;
}
function $c5a13e2a3e68b248$export$fbdeaa6a76694f71(d) {
    return d?.[0];
}
function $c5a13e2a3e68b248$export$18f9732b2021233c(d) {
    return d?.[1];
}








function $6a2a8d0a868fcbb4$export$2e2bcd8739ae039(_ref) {
    let { data: data, className: className, top: top, left: left, x: x, y0: y0 = (0, $c5a13e2a3e68b248$export$fbdeaa6a76694f71), y1: y1 = (0, $c5a13e2a3e68b248$export$18f9732b2021233c), xScale: xScale, yScale: yScale, color: color, keys: keys, value: value, order: order, offset: offset, children: children, ...restProps } = _ref;
    const stack = (0, $6be110a9c654dd03$export$2e2bcd8739ae039)();
    if (keys) stack.keys(keys);
    if (value) (0, $de63c6bb63cceedd$export$2e2bcd8739ae039)(stack.value, value);
    if (order) stack.order((0, $b5407fe64a34b7cf$export$2e2bcd8739ae039)(order));
    if (offset) stack.offset((0, $f69514daf01a6903$export$2e2bcd8739ae039)(offset));
    const stacks = stack(data);
    const barWidth = (0, $becd10fb064d621f$export$2e2bcd8739ae039)(xScale);
    const barStacks = stacks.map((barStack, i)=>{
        const { key: key } = barStack;
        return {
            index: i,
            key: key,
            bars: barStack.map((bar, j)=>{
                const barHeight = (yScale(y0(bar)) || 0) - (yScale(y1(bar)) || 0);
                const barY = yScale(y1(bar));
                const barX = 'bandwidth' in xScale ? xScale(x(bar.data)) : Math.max((xScale(x(bar.data)) || 0) - barWidth / 2);
                return {
                    bar: bar,
                    key: key,
                    index: j,
                    height: barHeight,
                    width: barWidth,
                    x: barX || 0,
                    y: barY || 0,
                    color: color(barStack.key, j)
                };
            })
        };
    });
    if (children) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: children(barStacks)
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $268dd56f34f61467$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-bar-stack', className),
        top: top,
        left: left,
        children: barStacks.map((barStack)=>barStack.bars.map((bar)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $3a3ab9fc8020305e$export$2e2bcd8739ae039), {
                    x: bar.x,
                    y: bar.y,
                    height: bar.height,
                    width: bar.width,
                    fill: bar.color,
                    ...restProps
                }, `bar-stack-${barStack.index}-${bar.index}`)))
    });
}












function $2dfb473045f8737e$export$2e2bcd8739ae039(_ref) {
    let { data: data, className: className, top: top, left: left, y: y, x0: x0 = (0, $c5a13e2a3e68b248$export$fbdeaa6a76694f71), x1: x1 = (0, $c5a13e2a3e68b248$export$18f9732b2021233c), xScale: xScale, yScale: yScale, color: color, keys: keys, value: value, order: order, offset: offset, children: children, ...restProps } = _ref;
    const stack = (0, $6be110a9c654dd03$export$2e2bcd8739ae039)();
    if (keys) stack.keys(keys);
    if (value) (0, $de63c6bb63cceedd$export$2e2bcd8739ae039)(stack.value, value);
    if (order) stack.order((0, $b5407fe64a34b7cf$export$2e2bcd8739ae039)(order));
    if (offset) stack.offset((0, $f69514daf01a6903$export$2e2bcd8739ae039)(offset));
    const stacks = stack(data);
    const barHeight = (0, $becd10fb064d621f$export$2e2bcd8739ae039)(yScale);
    const barStacks = stacks.map((barStack, i)=>{
        const { key: key } = barStack;
        return {
            index: i,
            key: key,
            bars: barStack.map((bar, j)=>{
                const barWidth = (xScale(x1(bar)) || 0) - (xScale(x0(bar)) || 0);
                const barX = xScale(x0(bar));
                const barY = 'bandwidth' in yScale ? yScale(y(bar.data)) : Math.max((yScale(y(bar.data)) || 0) - barWidth / 2);
                return {
                    bar: bar,
                    key: key,
                    index: j,
                    height: barHeight,
                    width: barWidth,
                    x: barX || 0,
                    y: barY || 0,
                    color: color(barStack.key, j)
                };
            })
        };
    });
    if (children) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: children(barStacks)
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $268dd56f34f61467$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-bar-stack-horizontal', className),
        top: top,
        left: left,
        children: barStacks.map((barStack)=>barStack.bars.map((bar)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $3a3ab9fc8020305e$export$2e2bcd8739ae039), {
                    x: bar.x,
                    y: bar.y,
                    height: bar.height,
                    width: bar.width,
                    fill: bar.color,
                    ...restProps
                }, `bar-stack-${barStack.index}-${bar.index}`)))
    });
}





const $c585f1020bc3a488$export$c9fcf1a7df975d78 = (degrees)=>Math.PI / 180 * degrees;








function $ef54cb82c658c34a$export$5bd8ca5f0c6b40b1(_ref) {
    let { source: source, target: target, x: x, y: y } = _ref;
    return (data)=>{
        const link = (0, $13606a4646f930aa$export$e7c381889b2cd14d)();
        link.x(x);
        link.y(y);
        link.source(source);
        link.target(target);
        return link(data);
    };
}
function $ef54cb82c658c34a$export$2e2bcd8739ae039(_ref2) {
    let { className: className, children: children, data: data, innerRef: innerRef, path: path, x: x = (0, $c5a13e2a3e68b248$export$337238c011325465), y: // note this returns a y value
    y = (0, $c5a13e2a3e68b248$export$3a667a3b7e4d6701), source: // note this returns an x value
    source = (0, $c5a13e2a3e68b248$export$dd2b6e807fb37ba3), target: target = (0, $c5a13e2a3e68b248$export$c22522a4dfa48e9c), ...restProps } = _ref2;
    const pathGen = path || $ef54cb82c658c34a$export$5bd8ca5f0c6b40b1({
        source: source,
        target: target,
        x: x,
        y: y
    });
    if (children) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: children({
            path: pathGen
        })
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("path", {
        ref: innerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-link visx-link-horizontal-diagonal', className),
        d: pathGen(data) || '',
        ...restProps
    });
}






function $208c7b6a644ccbfb$export$53ba7b9927038e36(_ref) {
    let { source: source, target: target, x: x, y: y } = _ref;
    return (data)=>{
        const link = (0, $13606a4646f930aa$export$75de4c8c66884e04)();
        link.x(x);
        link.y(y);
        link.source(source);
        link.target(target);
        return link(data);
    };
}
function $208c7b6a644ccbfb$export$2e2bcd8739ae039(_ref2) {
    let { className: className, children: children, data: data, innerRef: innerRef, path: path, x: x = (0, $c5a13e2a3e68b248$export$3a667a3b7e4d6701), y: y = (0, $c5a13e2a3e68b248$export$337238c011325465), source: source = (0, $c5a13e2a3e68b248$export$dd2b6e807fb37ba3), target: target = (0, $c5a13e2a3e68b248$export$c22522a4dfa48e9c), ...restProps } = _ref2;
    const pathGen = path || $208c7b6a644ccbfb$export$53ba7b9927038e36({
        source: source,
        target: target,
        x: x,
        y: y
    });
    if (children) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: children({
            path: pathGen
        })
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("path", {
        ref: innerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-link visx-link-vertical-diagonal', className),
        d: pathGen(data) || '',
        ...restProps
    });
}






function $ef3df5449039fa5d$export$db837e8c7d6ea1b8(_ref) {
    let { source: source, target: target, angle: angle, radius: radius } = _ref;
    return (data)=>{
        const link = (0, $13606a4646f930aa$export$7739cfe68d4e0799)();
        link.angle(angle);
        link.radius(radius);
        link.source(source);
        link.target(target);
        return link(data);
    };
}
function $ef3df5449039fa5d$export$2e2bcd8739ae039(_ref2) {
    let { className: className, children: children, data: data, innerRef: innerRef, path: path, angle: angle = (0, $c5a13e2a3e68b248$export$3a667a3b7e4d6701), radius: radius = (0, $c5a13e2a3e68b248$export$337238c011325465), source: source = (0, $c5a13e2a3e68b248$export$dd2b6e807fb37ba3), target: target = (0, $c5a13e2a3e68b248$export$c22522a4dfa48e9c), ...restProps } = _ref2;
    const pathGen = path || $ef3df5449039fa5d$export$db837e8c7d6ea1b8({
        source: source,
        target: target,
        angle: angle,
        radius: radius
    });
    if (children) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: children({
            path: pathGen
        })
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("path", {
        ref: innerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-link visx-link-radial-diagonal', className),
        d: pathGen(data) || '',
        ...restProps
    });
}



/**
 * `@visx/vendor/d3-path` (ESM)
 * See upstream license: https://github.com/d3/d3-path/blob/main/LICENSE
 *
 * This ESM package re-exports the underlying installed dependencies of 
 * `node_modules/d3-path`
 */ 




function $2e8a4bcce3c23d67$export$cf8f8f087bf9e99(_ref) {
    let { source: source, target: target, x: x, y: y, percent: percent } = _ref;
    return (link)=>{
        const sourceData = source(link);
        const targetData = target(link);
        const sx = x(sourceData);
        const sy = y(sourceData);
        const tx = x(targetData);
        const ty = y(targetData);
        const dx = tx - sx;
        const dy = ty - sy;
        const ix = percent * (dx + dy);
        const iy = percent * (dy - dx);
        const path = (0, $746f2af20cbe541b$export$bb654e07daaf8c3a)();
        path.moveTo(sx, sy);
        path.bezierCurveTo(sx + ix, sy + iy, tx + iy, ty - ix, tx, ty);
        return path.toString();
    };
}
function $2e8a4bcce3c23d67$export$2e2bcd8739ae039(_ref2) {
    let { className: className, children: children, data: data, innerRef: innerRef, path: path, percent: percent = 0.2, x: x = (0, $c5a13e2a3e68b248$export$337238c011325465), y: // note this returns a y value
    y = (0, $c5a13e2a3e68b248$export$3a667a3b7e4d6701), source: // note this returns an x value
    source = (0, $c5a13e2a3e68b248$export$dd2b6e807fb37ba3), target: target = (0, $c5a13e2a3e68b248$export$c22522a4dfa48e9c), ...restProps } = _ref2;
    const pathGen = path || $2e8a4bcce3c23d67$export$cf8f8f087bf9e99({
        source: source,
        target: target,
        x: x,
        y: y,
        percent: percent
    });
    if (children) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: children({
            path: pathGen
        })
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("path", {
        ref: innerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-link visx-link-horizontal-curve', className),
        d: pathGen(data) || '',
        ...restProps
    });
}






function $dd785ee049636812$export$8e538f4740957e64(_ref) {
    let { source: source, target: target, x: x, y: y, percent: percent } = _ref;
    return (link)=>{
        const sourceData = source(link);
        const targetData = target(link);
        const sx = x(sourceData);
        const sy = y(sourceData);
        const tx = x(targetData);
        const ty = y(targetData);
        const dx = tx - sx;
        const dy = ty - sy;
        const ix = percent * (dx + dy);
        const iy = percent * (dy - dx);
        const path = (0, $746f2af20cbe541b$export$bb654e07daaf8c3a)();
        path.moveTo(sx, sy);
        path.bezierCurveTo(sx + ix, sy + iy, tx + iy, ty - ix, tx, ty);
        return path.toString();
    };
}
function $dd785ee049636812$export$2e2bcd8739ae039(_ref2) {
    let { className: className, children: children, data: data, innerRef: innerRef, path: path, percent: percent = 0.2, x: x = (0, $c5a13e2a3e68b248$export$3a667a3b7e4d6701), y: y = (0, $c5a13e2a3e68b248$export$337238c011325465), source: source = (0, $c5a13e2a3e68b248$export$dd2b6e807fb37ba3), target: target = (0, $c5a13e2a3e68b248$export$c22522a4dfa48e9c), ...restProps } = _ref2;
    const pathGen = path || $dd785ee049636812$export$8e538f4740957e64({
        source: source,
        target: target,
        x: x,
        y: y,
        percent: percent
    });
    if (children) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: children({
            path: pathGen
        })
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("path", {
        ref: innerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-link visx-link-vertical-curve', className),
        d: pathGen(data) || '',
        ...restProps
    });
}






function $0880240a34e0887e$export$12d4a736eaeb4ba4(_ref) {
    let { source: source, target: target, x: x, y: y, percent: percent } = _ref;
    return (link)=>{
        const sourceData = source(link);
        const targetData = target(link);
        const sa = x(sourceData) - Math.PI / 2;
        const sr = y(sourceData);
        const ta = x(targetData) - Math.PI / 2;
        const tr = y(targetData);
        const sc = Math.cos(sa);
        const ss = Math.sin(sa);
        const tc = Math.cos(ta);
        const ts = Math.sin(ta);
        const sx = sr * sc;
        const sy = sr * ss;
        const tx = tr * tc;
        const ty = tr * ts;
        const dx = tx - sx;
        const dy = ty - sy;
        const ix = percent * (dx + dy);
        const iy = percent * (dy - dx);
        const path = (0, $746f2af20cbe541b$export$bb654e07daaf8c3a)();
        path.moveTo(sx, sy);
        path.bezierCurveTo(sx + ix, sy + iy, tx + iy, ty - ix, tx, ty);
        return path.toString();
    };
}
function $0880240a34e0887e$export$2e2bcd8739ae039(_ref2) {
    let { className: className, children: children, data: data, innerRef: innerRef, path: path, percent: percent = 0.2, x: x = (0, $c5a13e2a3e68b248$export$3a667a3b7e4d6701), y: y = (0, $c5a13e2a3e68b248$export$337238c011325465), source: source = (0, $c5a13e2a3e68b248$export$dd2b6e807fb37ba3), target: target = (0, $c5a13e2a3e68b248$export$c22522a4dfa48e9c), ...restProps } = _ref2;
    const pathGen = path || $0880240a34e0887e$export$12d4a736eaeb4ba4({
        source: source,
        target: target,
        x: x,
        y: y,
        percent: percent
    });
    if (children) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: children({
            path: pathGen
        })
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("path", {
        ref: innerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-link visx-link-radial-curve', className),
        d: pathGen(data) || '',
        ...restProps
    });
}






function $b4ee84af13759f53$export$f668c9d7464216ca(_ref) {
    let { source: source, target: target, x: x, y: y } = _ref;
    return (data)=>{
        const sourceData = source(data);
        const targetData = target(data);
        const sx = x(sourceData);
        const sy = y(sourceData);
        const tx = x(targetData);
        const ty = y(targetData);
        const path = (0, $746f2af20cbe541b$export$bb654e07daaf8c3a)();
        path.moveTo(sx, sy);
        path.lineTo(tx, ty);
        return path.toString();
    };
}
function $b4ee84af13759f53$export$2e2bcd8739ae039(_ref2) {
    let { className: className, children: children, innerRef: innerRef, data: data, path: path, x: x = (0, $c5a13e2a3e68b248$export$337238c011325465), y: // note this returns a y value
    y = (0, $c5a13e2a3e68b248$export$3a667a3b7e4d6701), source: // note this returns a x value
    source = (0, $c5a13e2a3e68b248$export$dd2b6e807fb37ba3), target: target = (0, $c5a13e2a3e68b248$export$c22522a4dfa48e9c), ...restProps } = _ref2;
    const pathGen = path || $b4ee84af13759f53$export$f668c9d7464216ca({
        source: source,
        target: target,
        x: x,
        y: y
    });
    if (children) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: children({
            path: pathGen
        })
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("path", {
        ref: innerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-link visx-link-horizontal-line', className),
        d: pathGen(data) || '',
        ...restProps
    });
}






function $d5fe5334fc361fd6$export$724baf2291f19a28(_ref) {
    let { source: source, target: target, x: x, y: y } = _ref;
    return (data)=>{
        const sourceData = source(data);
        const targetData = target(data);
        const sx = x(sourceData);
        const sy = y(sourceData);
        const tx = x(targetData);
        const ty = y(targetData);
        const path = (0, $746f2af20cbe541b$export$bb654e07daaf8c3a)();
        path.moveTo(sx, sy);
        path.lineTo(tx, ty);
        return path.toString();
    };
}
function $d5fe5334fc361fd6$export$2e2bcd8739ae039(_ref2) {
    let { className: className, innerRef: innerRef, data: data, path: path, x: x = (0, $c5a13e2a3e68b248$export$3a667a3b7e4d6701), y: y = (0, $c5a13e2a3e68b248$export$337238c011325465), source: source = (0, $c5a13e2a3e68b248$export$dd2b6e807fb37ba3), target: target = (0, $c5a13e2a3e68b248$export$c22522a4dfa48e9c), children: children, ...restProps } = _ref2;
    const pathGen = path || $d5fe5334fc361fd6$export$724baf2291f19a28({
        source: source,
        target: target,
        x: x,
        y: y
    });
    if (children) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: children({
            path: pathGen
        })
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("path", {
        ref: innerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-link visx-link-vertical-line', className),
        d: pathGen(data) || '',
        ...restProps
    });
}






function $95ced4b130e965cf$export$64b3403f14a8112e(_ref) {
    let { source: source, target: target, x: x, y: y } = _ref;
    return (data)=>{
        const sourceData = source(data);
        const targetData = target(data);
        const sa = x(sourceData) - Math.PI / 2;
        const sr = y(sourceData);
        const ta = x(targetData) - Math.PI / 2;
        const tr = y(targetData);
        const sc = Math.cos(sa);
        const ss = Math.sin(sa);
        const tc = Math.cos(ta);
        const ts = Math.sin(ta);
        const path = (0, $746f2af20cbe541b$export$bb654e07daaf8c3a)();
        path.moveTo(sr * sc, sr * ss);
        path.lineTo(tr * tc, tr * ts);
        return path.toString();
    };
}
function $95ced4b130e965cf$export$2e2bcd8739ae039(_ref2) {
    let { className: className, innerRef: innerRef, data: data, path: path, x: x = (0, $c5a13e2a3e68b248$export$3a667a3b7e4d6701), y: y = (0, $c5a13e2a3e68b248$export$337238c011325465), source: source = (0, $c5a13e2a3e68b248$export$dd2b6e807fb37ba3), target: target = (0, $c5a13e2a3e68b248$export$c22522a4dfa48e9c), children: children, ...restProps } = _ref2;
    const pathGen = path || $95ced4b130e965cf$export$64b3403f14a8112e({
        source: source,
        target: target,
        x: x,
        y: y
    });
    if (children) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: children({
            path: pathGen
        })
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("path", {
        ref: innerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-link visx-link-radial-line', className),
        d: pathGen(data) || '',
        ...restProps
    });
}






function $d927d2638f3b74de$export$d6aeb1e4545d4807(_ref) {
    let { source: source, target: target, x: x, y: y, percent: percent } = _ref;
    return (link)=>{
        const sourceData = source(link);
        const targetData = target(link);
        const sx = x(sourceData);
        const sy = y(sourceData);
        const tx = x(targetData);
        const ty = y(targetData);
        const path = (0, $746f2af20cbe541b$export$bb654e07daaf8c3a)();
        path.moveTo(sx, sy);
        path.lineTo(sx + (tx - sx) * percent, sy);
        path.lineTo(sx + (tx - sx) * percent, ty);
        path.lineTo(tx, ty);
        return path.toString();
    };
}
function $d927d2638f3b74de$export$2e2bcd8739ae039(_ref2) {
    let { className: className, innerRef: innerRef, data: data, path: path, percent: percent = 0.5, x: x = (0, $c5a13e2a3e68b248$export$337238c011325465), y: // note this returns a y value
    y = (0, $c5a13e2a3e68b248$export$3a667a3b7e4d6701), source: // note this returns a x value
    source = (0, $c5a13e2a3e68b248$export$dd2b6e807fb37ba3), target: target = (0, $c5a13e2a3e68b248$export$c22522a4dfa48e9c), children: children, ...restProps } = _ref2;
    const pathGen = path || $d927d2638f3b74de$export$d6aeb1e4545d4807({
        source: source,
        target: target,
        x: x,
        y: y,
        percent: percent
    });
    if (children) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: children({
            path: pathGen
        })
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("path", {
        ref: innerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-link visx-link-horizontal-step', className),
        d: pathGen(data) || '',
        ...restProps
    });
}






function $4b1b0d7820b2d377$export$af9123cf8db9a5f9(_ref) {
    let { source: source, target: target, x: x, y: y, percent: percent } = _ref;
    return (link)=>{
        const sourceData = source(link);
        const targetData = target(link);
        const sx = x(sourceData);
        const sy = y(sourceData);
        const tx = x(targetData);
        const ty = y(targetData);
        const path = (0, $746f2af20cbe541b$export$bb654e07daaf8c3a)();
        path.moveTo(sx, sy);
        path.lineTo(sx, sy + (ty - sy) * percent);
        path.lineTo(tx, sy + (ty - sy) * percent);
        path.lineTo(tx, ty);
        return path.toString();
    };
}
function $4b1b0d7820b2d377$export$2e2bcd8739ae039(_ref2) {
    let { className: className, innerRef: innerRef, data: data, path: path, percent: percent = 0.5, x: x = (0, $c5a13e2a3e68b248$export$3a667a3b7e4d6701), y: y = (0, $c5a13e2a3e68b248$export$337238c011325465), source: source = (0, $c5a13e2a3e68b248$export$dd2b6e807fb37ba3), target: target = (0, $c5a13e2a3e68b248$export$c22522a4dfa48e9c), children: children, ...restProps } = _ref2;
    const pathGen = path || $4b1b0d7820b2d377$export$af9123cf8db9a5f9({
        source: source,
        target: target,
        x: x,
        y: y,
        percent: percent
    });
    if (children) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: children({
            path: pathGen
        })
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("path", {
        ref: innerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-link visx-link-vertical-step', className),
        d: pathGen(data) || '',
        ...restProps
    });
}





function $1199fe97dcbffe67$export$48f16a2e735e6163(_ref) {
    let { source: source, target: target, x: x, y: y } = _ref;
    return (link)=>{
        const sourceData = source(link);
        const targetData = target(link);
        const sx = x(sourceData);
        const sy = y(sourceData);
        const tx = x(targetData);
        const ty = y(targetData);
        const sa = sx - Math.PI / 2;
        const sr = sy;
        const ta = tx - Math.PI / 2;
        const tr = ty;
        const sc = Math.cos(sa);
        const ss = Math.sin(sa);
        const tc = Math.cos(ta);
        const ts = Math.sin(ta);
        const sf = Math.abs(ta - sa) > Math.PI ? ta <= sa : ta > sa;
        return `
      M${sr * sc},${sr * ss}
      A${sr},${sr},0,0,${sf ? 1 : 0},${sr * tc},${sr * ts}
      L${tr * tc},${tr * ts}
    `;
    };
}
function $1199fe97dcbffe67$export$2e2bcd8739ae039(_ref2) {
    let { className: className, innerRef: innerRef, data: data, path: path, x: x = (0, $c5a13e2a3e68b248$export$3a667a3b7e4d6701), y: y = (0, $c5a13e2a3e68b248$export$337238c011325465), source: source = (0, $c5a13e2a3e68b248$export$dd2b6e807fb37ba3), target: target = (0, $c5a13e2a3e68b248$export$c22522a4dfa48e9c), children: children, ...restProps } = _ref2;
    const pathGen = path || $1199fe97dcbffe67$export$48f16a2e735e6163({
        source: source,
        target: target,
        x: x,
        y: y
    });
    if (children) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: children({
            path: pathGen
        })
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("path", {
        ref: innerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-link visx-link-radial-step', className),
        d: pathGen(data) || '',
        ...restProps
    });
}





const $67466de18a091a87$var$DEFAULT_CENTER = {
    x: 0,
    y: 0
};
const $67466de18a091a87$export$92d53b972f97f55a = (_ref)=>{
    let { sides: sides = 4, size: size = 25, center: center = $67466de18a091a87$var$DEFAULT_CENTER, rotate: rotate = 0, side: side } = _ref;
    const degrees = 360 / sides * side - rotate;
    const radians = (0, $c585f1020bc3a488$export$c9fcf1a7df975d78)(degrees);
    return {
        x: center.x + size * Math.cos(radians),
        y: center.y + size * Math.sin(radians)
    };
};
const $67466de18a091a87$export$af0496c55bf31eb = (_ref2)=>{
    let { sides: sides, size: size, center: center, rotate: rotate } = _ref2;
    return new Array(sides).fill(0).map((_, side)=>$67466de18a091a87$export$92d53b972f97f55a({
            sides: sides,
            size: size,
            center: center,
            rotate: rotate,
            side: side
        }));
};
function $67466de18a091a87$export$2e2bcd8739ae039(_ref3) {
    let { sides: sides = 4, size: size = 25, center: center = $67466de18a091a87$var$DEFAULT_CENTER, rotate: rotate = 0, className: className, children: children, innerRef: innerRef, points: points, ...restProps } = _ref3;
    const pointsToRender = points || $67466de18a091a87$export$af0496c55bf31eb({
        sides: sides,
        size: size,
        center: center,
        rotate: rotate
    }).map((_ref4)=>{
        let { x: x, y: y } = _ref4;
        return [
            x,
            y
        ];
    });
    if (children) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: children({
            points: pointsToRender
        })
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("polygon", {
        ref: innerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-polygon', className),
        points: pointsToRender.join(' '),
        ...restProps
    });
}




function $60af5efcf68a36aa$export$2e2bcd8739ae039(_ref) {
    let { className: className, innerRef: innerRef, ...restProps } = _ref;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("circle", {
        ref: innerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-circle', className),
        ...restProps
    });
}



var $5E6i4 = parcelRequire("5E6i4");
const $6ee6d6d4a6b93191$var$SVG_NAMESPACE_URL = 'http://www.w3.org/2000/svg';
function $6ee6d6d4a6b93191$export$2e2bcd8739ae039(elementId) {
    let pathElement = document.getElementById(elementId);
    // create a single path element if not done already
    if (!pathElement) {
        const svg = document.createElementNS($6ee6d6d4a6b93191$var$SVG_NAMESPACE_URL, 'svg');
        // not visible
        svg.setAttribute('aria-hidden', 'true');
        svg.style.opacity = '0';
        svg.style.width = '0';
        svg.style.height = '0';
        // off screen
        svg.style.position = 'absolute';
        svg.style.top = '-100%';
        svg.style.left = '-100%';
        // no mouse events
        svg.style.pointerEvents = 'none';
        pathElement = document.createElementNS($6ee6d6d4a6b93191$var$SVG_NAMESPACE_URL, 'path');
        pathElement.setAttribute('id', elementId);
        svg.appendChild(pathElement);
        document.body.appendChild(svg);
    }
    return pathElement;
}


const $9aeb739b4a775723$var$MEASUREMENT_ELEMENT_ID = '__visx_splitpath_svg_path_measurement_id';
/** Different algorithms to segment the line */ const $9aeb739b4a775723$var$TRUE = ()=>true;
function $9aeb739b4a775723$export$2e2bcd8739ae039(_ref) {
    let { path: path, pointsInSegments: pointsInSegments, segmentation: segmentation = 'x', sampleRate: sampleRate = 1 } = _ref;
    try {
        const pathElement = (0, $6ee6d6d4a6b93191$export$2e2bcd8739ae039)($9aeb739b4a775723$var$MEASUREMENT_ELEMENT_ID);
        pathElement.setAttribute('d', path);
        const totalLength = pathElement.getTotalLength();
        const numSegments = pointsInSegments.length;
        const lineSegments = pointsInSegments.map(()=>[]);
        if (segmentation === 'x' || segmentation === 'y') {
            const segmentStarts = pointsInSegments.map((points)=>points.find((p)=>typeof p[segmentation] === 'number')?.[segmentation]);
            const first = pathElement.getPointAtLength(0);
            const last = pathElement.getPointAtLength(totalLength);
            const isIncreasing = last[segmentation] > first[segmentation];
            const isBeyondSegmentStart = isIncreasing ? segmentStarts.map((start)=>typeof start === 'undefined' ? $9aeb739b4a775723$var$TRUE : (xOrY)=>xOrY >= start) : segmentStarts.map((start)=>typeof start === 'undefined' ? $9aeb739b4a775723$var$TRUE : (xOrY)=>xOrY <= start);
            let currentSegment = 0;
            for(let distance = 0; distance <= totalLength; distance += sampleRate){
                const sample = pathElement.getPointAtLength(distance);
                const position = sample[segmentation];
                // find the current segment to which this sample belongs
                while(currentSegment < numSegments - 1 && isBeyondSegmentStart[currentSegment + 1](position))currentSegment += 1;
                // add sample to segment
                lineSegments[currentSegment].push(sample);
            }
        } else {
            // segmentation === "length"
            const numPointsInSegment = pointsInSegments.map((points)=>points.length);
            const numPoints = numPointsInSegment.reduce((sum, curr)=>sum + curr, 0);
            const lengthBetweenPoints = totalLength / Math.max(1, numPoints - 1);
            const segmentStarts = numPointsInSegment.slice(0, numSegments - 1);
            segmentStarts.unshift(0);
            for(let i = 2; i < numSegments; i += 1)segmentStarts[i] += segmentStarts[i - 1];
            for(let i = 0; i < numSegments; i += 1)segmentStarts[i] *= lengthBetweenPoints;
            let currentSegment = 0;
            for(let distance = 0; distance <= totalLength; distance += sampleRate){
                const sample = pathElement.getPointAtLength(distance);
                // find the current segment to which this sample belongs
                while(currentSegment < numSegments - 1 && distance >= segmentStarts[currentSegment + 1])currentSegment += 1;
                // add sample to segment
                lineSegments[currentSegment].push(sample);
            }
        }
        return lineSegments;
    } catch (e) {
        console.warn(e);
        return [];
    }
}





const $ddcd9b48115befc4$var$getX = (d)=>d.x || 0;
const $ddcd9b48115befc4$var$getY = (d)=>d.y || 0;
function $ddcd9b48115befc4$export$2e2bcd8739ae039(_ref) {
    let { children: children, className: className, curve: curve, defined: defined, segmentation: segmentation, sampleRate: sampleRate, segments: segments, x: x, y: y, styles: styles } = _ref;
    // Convert data in all segments to points.
    const pointsInSegments = (0, $5E6i4.useMemo)(()=>{
        const xFn = typeof x === 'number' || typeof x === 'undefined' ? ()=>x : x;
        const yFn = typeof y === 'number' || typeof y === 'undefined' ? ()=>y : y;
        return segments.map((s)=>s.map((value, i)=>({
                    x: xFn(value, i, s),
                    y: yFn(value, i, s)
                })));
    }, [
        x,
        y,
        segments
    ]);
    const pathString = (0, $5E6i4.useMemo)(()=>{
        const path = (0, $04c5cfbed3c2a8af$export$53f1d5ea8de3d7c)({
            x: x,
            y: y,
            defined: defined,
            curve: curve
        });
        return path(segments.flat()) || '';
    }, [
        x,
        y,
        defined,
        curve,
        segments
    ]);
    const splitLineSegments = (0, $5E6i4.useMemo)(()=>(0, $9aeb739b4a775723$export$2e2bcd8739ae039)({
            path: pathString,
            segmentation: segmentation,
            pointsInSegments: pointsInSegments,
            sampleRate: sampleRate
        }), [
        pathString,
        segmentation,
        pointsInSegments,
        sampleRate
    ]);
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("g", {
        children: splitLineSegments.map((segment, index)=>children ? /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $5E6i4.Fragment), {
                children: children({
                    index: index,
                    segment: segment,
                    styles: styles[index] || styles[index % styles.length]
                })
            }, index) : /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $c006d6ed47f7fa5f$export$2e2bcd8739ae039), {
                className: className,
                data: segment,
                x: $ddcd9b48115befc4$var$getX,
                y: $ddcd9b48115befc4$var$getY,
                ...styles[index] || styles[index % styles.length]
            }, index))
    });
}



$parcel$exportWildcard($236064fbb945a850$exports, $04c5cfbed3c2a8af$exports);



const $660e4a853e3f2665$var$Orientation = {
    top: 'top',
    left: 'left',
    right: 'right',
    bottom: 'bottom'
};
var $660e4a853e3f2665$export$2e2bcd8739ae039 = $660e4a853e3f2665$var$Orientation;


function $0819d92a1a453b8e$export$2e2bcd8739ae039(_ref) {
    let { labelOffset: labelOffset, labelProps: labelProps, orientation: orientation, range: range, tickLabelFontSize: tickLabelFontSize, tickLength: tickLength } = _ref;
    const sign = orientation === (0, $660e4a853e3f2665$export$2e2bcd8739ae039).left || orientation === (0, $660e4a853e3f2665$export$2e2bcd8739ae039).top ? -1 : 1;
    let x;
    let y;
    let transform;
    if (orientation === (0, $660e4a853e3f2665$export$2e2bcd8739ae039).top || orientation === (0, $660e4a853e3f2665$export$2e2bcd8739ae039).bottom) {
        const yBottomOffset = orientation === (0, $660e4a853e3f2665$export$2e2bcd8739ae039).bottom && typeof labelProps.fontSize === 'number' ? labelProps.fontSize : 0;
        x = (Number(range[0]) + Number(range[range.length - 1])) / 2;
        y = sign * (tickLength + labelOffset + tickLabelFontSize + yBottomOffset);
    } else {
        x = sign * ((Number(range[0]) + Number(range[range.length - 1])) / 2);
        y = -(tickLength + labelOffset);
        transform = `rotate(${sign * 90})`;
    }
    return {
        x: x,
        y: y,
        transform: transform
    };
}









function $f4b89d0cc2bf30ec$export$2e2bcd8739ae039(_ref) {
    let { hideTicks: hideTicks, horizontal: horizontal, orientation: orientation, tickClassName: tickClassName, tickComponent: tickComponent, tickLabelProps: allTickLabelProps, tickStroke: tickStroke = '#222', tickTransform: tickTransform, ticks: ticks, strokeWidth: strokeWidth, tickLineProps: tickLineProps } = _ref;
    return ticks.map((_ref2)=>{
        let { value: value, index: index, from: from, to: to, formattedValue: formattedValue } = _ref2;
        const tickLabelProps = allTickLabelProps[index] ?? {};
        const tickLabelFontSize = Math.max(10, typeof tickLabelProps.fontSize === 'number' && tickLabelProps.fontSize || 0);
        const tickYCoord = to.y + (horizontal && orientation !== (0, $660e4a853e3f2665$export$2e2bcd8739ae039).top ? tickLabelFontSize : 0);
        return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)((0, $268dd56f34f61467$export$2e2bcd8739ae039), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-axis-tick', tickClassName),
            transform: tickTransform,
            children: [
                !hideTicks && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $0e0a7792039d1a63$export$2e2bcd8739ae039), {
                    from: from,
                    to: to,
                    stroke: tickStroke,
                    strokeWidth: strokeWidth,
                    strokeLinecap: "square",
                    ...tickLineProps
                }),
                tickComponent ? tickComponent({
                    ...tickLabelProps,
                    x: to.x,
                    y: tickYCoord,
                    formattedValue: formattedValue
                }) : /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $6f18bc0a5cbf18e6$export$2e2bcd8739ae039), {
                    x: to.x,
                    y: tickYCoord,
                    ...tickLabelProps,
                    children: formattedValue
                })
            ]
        }, `visx-tick-${value}-${index}`);
    });
}



const $e8f2cbc1e79f2ebd$var$defaultTextProps = {
    textAnchor: 'middle',
    fontFamily: 'Arial',
    fontSize: 10,
    fill: '#222'
};
function $e8f2cbc1e79f2ebd$export$2e2bcd8739ae039(_ref) {
    let { axisFromPoint: axisFromPoint, axisLineClassName: axisLineClassName, axisToPoint: axisToPoint, hideAxisLine: hideAxisLine, hideTicks: hideTicks, horizontal: horizontal, label: label = '', labelClassName: labelClassName, labelOffset: labelOffset = 14, labelProps: labelProps, orientation: orientation = (0, $660e4a853e3f2665$export$2e2bcd8739ae039).bottom, scale: scale, stroke: stroke = '#222', strokeDasharray: strokeDasharray, strokeWidth: strokeWidth = 1, tickClassName: tickClassName, tickComponent: tickComponent, tickLineProps: tickLineProps, tickLabelProps: tickLabelProps, tickLength: tickLength = 8, tickStroke: tickStroke = '#222', tickTransform: tickTransform, ticks: ticks, ticksComponent: ticksComponent = (0, $f4b89d0cc2bf30ec$export$2e2bcd8739ae039) } = _ref;
    const combinedLabelProps = {
        ...$e8f2cbc1e79f2ebd$var$defaultTextProps,
        ...labelProps
    };
    const tickLabelPropsDefault = {
        ...$e8f2cbc1e79f2ebd$var$defaultTextProps,
        ...typeof tickLabelProps === 'object' ? tickLabelProps : null
    };
    // compute the max tick label size to compute label offset
    const allTickLabelProps = ticks.map((_ref2)=>{
        let { value: value, index: index } = _ref2;
        return typeof tickLabelProps === 'function' ? tickLabelProps(value, index, ticks) : tickLabelPropsDefault;
    });
    const maxTickLabelFontSize = Math.max(10, ...allTickLabelProps.map((props)=>typeof props.fontSize === 'number' ? props.fontSize : 0));
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)((0, $90cae257cc958273$exports.Fragment), {
        children: [
            ticksComponent({
                hideTicks: hideTicks,
                horizontal: horizontal,
                orientation: orientation,
                scale: scale,
                tickClassName: tickClassName,
                tickComponent: tickComponent,
                tickLabelProps: allTickLabelProps,
                tickStroke: tickStroke,
                tickTransform: tickTransform,
                ticks: ticks,
                strokeWidth: strokeWidth,
                tickLineProps: tickLineProps
            }),
            !hideAxisLine && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $0e0a7792039d1a63$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-axis-line', axisLineClassName),
                from: axisFromPoint,
                to: axisToPoint,
                stroke: stroke,
                strokeWidth: strokeWidth,
                strokeDasharray: strokeDasharray
            }),
            label && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $6f18bc0a5cbf18e6$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-axis-label', labelClassName),
                ...(0, $0819d92a1a453b8e$export$2e2bcd8739ae039)({
                    labelOffset: labelOffset,
                    labelProps: combinedLabelProps,
                    orientation: orientation,
                    range: scale.range(),
                    tickLabelFontSize: maxTickLabelFontSize,
                    tickLength: tickLength
                }),
                ...combinedLabelProps,
                children: label
            })
        ]
    });
}


/**
 * Create a function that returns a tick position for the given tick value
 */ function $57086f09edc16779$export$2e2bcd8739ae039(scale) {
    let align = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'center';
    // Broaden type before using 'xxx' in s as typeguard.
    const s = scale;
    // For point or band scales,
    // have to add offset to make the tick at center or end.
    if (align !== 'start' && 'bandwidth' in s) {
        let offset = s.bandwidth();
        if (align === 'center') offset /= 2;
        if (s.round()) offset = Math.round(offset);
        return (d)=>{
            const scaledValue = s(d);
            return typeof scaledValue === 'number' ? scaledValue + offset : scaledValue;
        };
    }
    return scale;
}



function $a34a1b98f4bcda3e$export$2e2bcd8739ae039(scale) {
    // Broaden type before using 'xxx' in s as typeguard.
    const s = scale;
    // For point or band scales,
    // have to add offset to make the tick centered.
    if ('tickFormat' in s) return s.tickFormat();
    return 0, $1cc2865a704159f1$export$2e2bcd8739ae039;
}



function $65a918ef00725b36$export$2e2bcd8739ae039(_ref, horizontal) {
    let { x: x, y: y } = _ref;
    return new (0, $4f1f378f21d00070$export$2e2bcd8739ae039)(horizontal ? {
        x: x,
        y: y
    } : {
        x: y,
        y: x
    });
}



const $4e0f49c0a12aeff2$export$11136c05bdbedbe3 = 0;
function $4e0f49c0a12aeff2$export$2e2bcd8739ae039() {
    let originalRangePadding = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $4e0f49c0a12aeff2$export$11136c05bdbedbe3;
    return typeof originalRangePadding === 'number' ? {
        start: originalRangePadding,
        end: originalRangePadding
    } : {
        start: $4e0f49c0a12aeff2$export$11136c05bdbedbe3,
        end: $4e0f49c0a12aeff2$export$11136c05bdbedbe3,
        ...originalRangePadding
    };
}



function $6b3475a108831342$export$2e2bcd8739ae039(_ref) {
    let { children: children = (0, $e8f2cbc1e79f2ebd$export$2e2bcd8739ae039), axisClassName: axisClassName, hideAxisLine: hideAxisLine = false, hideTicks: hideTicks = false, hideZero: hideZero = false, innerRef: innerRef, left: left = 0, numTicks: numTicks = 10, orientation: orientation = (0, $660e4a853e3f2665$export$2e2bcd8739ae039).bottom, rangePadding: rangePadding = 0, scale: scale, tickFormat: tickFormat, tickLength: tickLength = 8, tickValues: tickValues, top: top = 0, ...restProps } = _ref;
    const format = tickFormat ?? (0, $a34a1b98f4bcda3e$export$2e2bcd8739ae039)(scale);
    const isLeft = orientation === (0, $660e4a853e3f2665$export$2e2bcd8739ae039).left;
    const isTop = orientation === (0, $660e4a853e3f2665$export$2e2bcd8739ae039).top;
    const horizontal = isTop || orientation === (0, $660e4a853e3f2665$export$2e2bcd8739ae039).bottom;
    const tickPosition = (0, $57086f09edc16779$export$2e2bcd8739ae039)(scale);
    const tickSign = isLeft || isTop ? -1 : 1;
    const range = scale.range();
    const rangePaddingConfig = (0, $4e0f49c0a12aeff2$export$2e2bcd8739ae039)(rangePadding);
    const axisFromPoint = (0, $65a918ef00725b36$export$2e2bcd8739ae039)({
        x: Number(range[0]) + 0.5 - rangePaddingConfig.start,
        y: 0
    }, horizontal);
    const axisToPoint = (0, $65a918ef00725b36$export$2e2bcd8739ae039)({
        x: Number(range[range.length - 1]) + 0.5 + rangePaddingConfig.end,
        y: 0
    }, horizontal);
    const filteredTickValues = (tickValues ?? (0, $739bbf10d3a1c70b$export$2e2bcd8739ae039)(scale, numTicks)).filter((value)=>!hideZero || value !== 0 && value !== '0').map((value, index)=>({
            value: value,
            index: index
        }));
    const ticks = filteredTickValues.map((_ref2)=>{
        let { value: value, index: index } = _ref2;
        const scaledValue = (0, $c32ed8852dffe2f4$export$2e2bcd8739ae039)(tickPosition(value));
        return {
            value: value,
            index: index,
            from: (0, $65a918ef00725b36$export$2e2bcd8739ae039)({
                x: scaledValue,
                y: 0
            }, horizontal),
            to: (0, $65a918ef00725b36$export$2e2bcd8739ae039)({
                x: scaledValue,
                y: tickLength * tickSign
            }, horizontal),
            formattedValue: format(value, index, filteredTickValues)
        };
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $268dd56f34f61467$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-axis', axisClassName),
        innerRef: innerRef,
        top: top,
        left: left,
        children: children({
            ...restProps,
            axisFromPoint: axisFromPoint,
            axisToPoint: axisToPoint,
            hideAxisLine: hideAxisLine,
            hideTicks: hideTicks,
            hideZero: hideZero,
            horizontal: horizontal,
            numTicks: numTicks,
            orientation: orientation,
            rangePadding: rangePadding,
            scale: scale,
            tickFormat: format,
            tickLength: tickLength,
            tickPosition: tickPosition,
            tickSign: tickSign,
            ticks: ticks
        })
    });
}






const $40eb5ba1e71416db$export$ec95513e2647ff3 = {
    dx: '-0.25em',
    dy: '0.25em',
    fill: '#222',
    fontFamily: 'Arial',
    fontSize: 10,
    textAnchor: 'end'
};
function $40eb5ba1e71416db$export$2e2bcd8739ae039(_ref) {
    let { axisClassName: axisClassName, labelOffset: labelOffset = 36, tickLength: tickLength = 8, tickLabelProps: tickLabelProps, ...restProps } = _ref;
    const tickLabelPropsFinal = typeof tickLabelProps === 'function' ? tickLabelProps : {
        ...$40eb5ba1e71416db$export$ec95513e2647ff3,
        ...tickLabelProps
    };
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $6b3475a108831342$export$2e2bcd8739ae039), {
        axisClassName: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-axis-left', axisClassName),
        labelOffset: labelOffset,
        orientation: (0, $660e4a853e3f2665$export$2e2bcd8739ae039).left,
        tickLabelProps: tickLabelPropsFinal,
        tickLength: tickLength,
        ...restProps
    });
}






const $b0dfd1dd26b95c95$export$d9b3d941e1097696 = {
    dx: '0.25em',
    dy: '0.25em',
    fill: '#222',
    fontFamily: 'Arial',
    fontSize: 10,
    textAnchor: 'start'
};
function $b0dfd1dd26b95c95$export$2e2bcd8739ae039(_ref) {
    let { axisClassName: axisClassName, labelOffset: labelOffset = 36, tickLength: tickLength = 8, tickLabelProps: tickLabelProps, ...restProps } = _ref;
    const tickLabelPropsFinal = typeof tickLabelProps === 'function' ? tickLabelProps : {
        ...$b0dfd1dd26b95c95$export$d9b3d941e1097696,
        ...tickLabelProps
    };
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $6b3475a108831342$export$2e2bcd8739ae039), {
        axisClassName: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-axis-right', axisClassName),
        labelOffset: labelOffset,
        orientation: (0, $660e4a853e3f2665$export$2e2bcd8739ae039).right,
        tickLabelProps: tickLabelPropsFinal,
        tickLength: tickLength,
        ...restProps
    });
}






const $c027b19079928942$export$abccf24a0da5427e = {
    dy: '-0.75em',
    fill: '#222',
    fontFamily: 'Arial',
    fontSize: 10,
    textAnchor: 'middle'
};
function $c027b19079928942$export$2e2bcd8739ae039(_ref) {
    let { axisClassName: axisClassName, labelOffset: labelOffset = 8, tickLength: tickLength = 8, tickLabelProps: tickLabelProps, ...restProps } = _ref;
    const tickLabelPropsFinal = typeof tickLabelProps === 'function' ? tickLabelProps : {
        ...$c027b19079928942$export$abccf24a0da5427e,
        ...tickLabelProps
    };
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $6b3475a108831342$export$2e2bcd8739ae039), {
        axisClassName: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-axis-top', axisClassName),
        labelOffset: labelOffset,
        orientation: (0, $660e4a853e3f2665$export$2e2bcd8739ae039).top,
        tickLabelProps: tickLabelPropsFinal,
        tickLength: tickLength,
        ...restProps
    });
}






const $63b868b63ae0f3d1$export$cd0785a309729df9 = {
    dy: '0.25em',
    fill: '#222',
    fontFamily: 'Arial',
    fontSize: 10,
    textAnchor: 'middle'
};
function $63b868b63ae0f3d1$export$2e2bcd8739ae039(_ref) {
    let { axisClassName: axisClassName, labelOffset: labelOffset = 8, tickLength: tickLength = 8, tickLabelProps: tickLabelProps, ...restProps } = _ref;
    const tickLabelPropsFinal = typeof tickLabelProps === 'function' ? tickLabelProps : {
        ...$63b868b63ae0f3d1$export$cd0785a309729df9,
        ...tickLabelProps
    };
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $6b3475a108831342$export$2e2bcd8739ae039), {
        axisClassName: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-axis-bottom', axisClassName),
        labelOffset: labelOffset,
        orientation: (0, $660e4a853e3f2665$export$2e2bcd8739ae039).bottom,
        tickLabelProps: tickLabelPropsFinal,
        tickLength: tickLength,
        ...restProps
    });
}





// @visx/bounds
/* eslint react/no-did-mount-set-state: 0 */ 
var $5E6i4 = parcelRequire("5E6i4");

const $4eed57823eb4c4d9$var$emptyRect = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    width: 0,
    height: 0
};
function $4eed57823eb4c4d9$export$2e2bcd8739ae039(BaseComponent) {
    return class WrappedComponent extends (0, $5E6i4.PureComponent) {
        static displayName = (()=>`withBoundingRects(${BaseComponent.displayName || ''})`)();
        constructor(props){
            super(props);
            this.state = {
                rect: undefined,
                parentRect: undefined
            };
            this.nodeRef = /*#__PURE__*/ (0, $5E6i4.createRef)();
            this.getRects = this.getRects.bind(this);
        }
        componentDidMount() {
            this.node = this.nodeRef?.current || null;
            this.setState(()=>this.getRects());
        }
        getRects() {
            if (!this.node) return this.state;
            const { node: node } = this;
            const parentNode = node.parentNode;
            const rect = node.getBoundingClientRect ? node.getBoundingClientRect() : $4eed57823eb4c4d9$var$emptyRect;
            const parentRect = parentNode?.getBoundingClientRect ? parentNode.getBoundingClientRect() : $4eed57823eb4c4d9$var$emptyRect;
            return {
                rect: rect,
                parentRect: parentRect
            };
        }
        render() {
            return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(BaseComponent, {
                nodeRef: this.nodeRef,
                getRects: this.getRects,
                ...this.state,
                ...this.props
            });
        }
    };
}




// @visx/brush

var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");


/* eslint react/jsx-handler-names: 0 */ 
var $5E6i4 = parcelRequire("5E6i4");

function $1aad569f11ff69c8$export$ba254c7738e004b6(scale, value) {
    // Test if the scale is an ordinalScale or not,
    // Since an ordinalScale doesn't support invert function.
    if ('invert' in scale && typeof scale.invert !== 'undefined') return scale.invert(value).valueOf();
    const [start, end] = scale.range();
    let i = 0;
    // ordinal should have step
    const step = 'step' in scale && typeof scale.step !== 'undefined' ? scale.step() : 1;
    const width = step * (end - start) / Math.abs(end - start);
    if (width > 0) while(value > start + width * (i + 1))i += 1;
    else while(value < start + width * (i + 1))i += 1;
    return i;
}
function $1aad569f11ff69c8$export$3100c299dcd85ca3(scale, start, end, tolerentDelta) {
    let domain;
    const invertedStart = $1aad569f11ff69c8$export$ba254c7738e004b6(scale, start + (start < end ? -tolerentDelta : tolerentDelta));
    const invertedEnd = $1aad569f11ff69c8$export$ba254c7738e004b6(scale, end + (end < start ? -tolerentDelta : tolerentDelta));
    const minValue = Math.min(invertedStart, invertedEnd);
    const maxValue = Math.max(invertedStart, invertedEnd);
    if ('invert' in scale && typeof scale.invert !== 'undefined') domain = {
        start: minValue,
        end: maxValue
    };
    else {
        const values = [];
        const scaleDomain = scale.domain();
        for(let i = minValue; i <= maxValue; i += 1)values.push(scaleDomain[i]);
        domain = {
            values: values
        };
    }
    return domain;
}
function $1aad569f11ff69c8$export$ccc55dee332fd8dd(event) {
    if (typeof window !== 'undefined' && window.TouchEvent && event instanceof TouchEvent) return {
        pageX: event.touches[0].pageX,
        pageY: event.touches[0].pageY
    };
    const pointerEvent = event;
    return {
        pageX: pointerEvent.pageX,
        pageY: pointerEvent.pageY
    };
}
function $1aad569f11ff69c8$export$61fc7d43ac8f84b0(func, delay) {
    let timeoutId;
    return function debouncedFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        clearTimeout(timeoutId);
        timeoutId = setTimeout(()=>{
            func.apply(this, args);
        }, delay);
    };
}



class $ffb60a362ef5a838$export$2e2bcd8739ae039 extends (0, $5E6i4.Component) {
    handleDragStart = (drag)=>{
        const { onBrushHandleChange: onBrushHandleChange, type: type, onBrushStart: onBrushStart } = this.props;
        if (onBrushHandleChange) onBrushHandleChange(type, (0, $1aad569f11ff69c8$export$ccc55dee332fd8dd)(drag.event));
        if (onBrushStart) onBrushStart(drag);
    };
    handleDragMove = (drag)=>{
        const { updateBrush: updateBrush, type: type, isControlled: isControlled } = this.props;
        if (!drag.isDragging || isControlled) return;
        updateBrush((prevBrush)=>{
            const { start: start, end: end } = prevBrush;
            let move = 0;
            const xMax = Math.max(start.x, end.x);
            const xMin = Math.min(start.x, end.x);
            const yMax = Math.max(start.y, end.y);
            const yMin = Math.min(start.y, end.y);
            switch(type){
                case 'right':
                    move = xMax + drag.dx;
                    return {
                        ...prevBrush,
                        activeHandle: type,
                        extent: {
                            ...prevBrush.extent,
                            x0: Math.max(Math.min(move, start.x), prevBrush.bounds.x0),
                            x1: Math.min(Math.max(move, start.x), prevBrush.bounds.x1)
                        }
                    };
                case 'left':
                    move = xMin + drag.dx;
                    return {
                        ...prevBrush,
                        activeHandle: type,
                        extent: {
                            ...prevBrush.extent,
                            x0: Math.min(move, end.x),
                            x1: Math.max(move, end.x)
                        }
                    };
                case 'bottom':
                    move = yMax + drag.dy;
                    return {
                        ...prevBrush,
                        activeHandle: type,
                        extent: {
                            ...prevBrush.extent,
                            y0: Math.min(move, start.y),
                            y1: Math.max(move, start.y)
                        }
                    };
                case 'top':
                    move = yMin + drag.dy;
                    return {
                        ...prevBrush,
                        activeHandle: type,
                        extent: {
                            ...prevBrush.extent,
                            y0: Math.min(move, end.y),
                            y1: Math.max(move, end.y)
                        }
                    };
                // BrushHandle skips corners use BrushCorner for those
                case 'topLeft':
                case 'topRight':
                case 'bottomLeft':
                case 'bottomRight':
                default:
                    return prevBrush;
            }
        });
    };
    handleDragEnd = ()=>{
        const { updateBrush: updateBrush, onBrushEnd: onBrushEnd, onBrushHandleChange: onBrushHandleChange, isControlled: isControlled } = this.props;
        if (!isControlled) updateBrush((prevBrush)=>{
            const { start: start, end: end, extent: extent } = prevBrush;
            start.x = Math.min(extent.x0, extent.x1);
            start.y = Math.min(extent.y0, extent.y0);
            end.x = Math.max(extent.x0, extent.x1);
            end.y = Math.max(extent.y0, extent.y1);
            const nextBrush = {
                ...prevBrush,
                start: start,
                end: end,
                activeHandle: null,
                isBrushing: false,
                extent: {
                    x0: Math.min(start.x, end.x),
                    x1: Math.max(start.x, end.x),
                    y0: Math.min(start.y, end.y),
                    y1: Math.max(start.y, end.y)
                }
            };
            if (onBrushEnd) onBrushEnd(nextBrush);
            return nextBrush;
        });
        if (onBrushHandleChange) onBrushHandleChange();
    };
    render() {
        const { stageWidth: stageWidth, stageHeight: stageHeight, brush: brush, type: type, handle: handle, isControlled: isControlled, isDragInProgress: isDragInProgress, renderBrushHandle: renderBrushHandle } = this.props;
        const { x: x, y: y, width: width, height: height } = handle;
        const cursor = type === 'right' || type === 'left' ? 'ew-resize' : 'ns-resize';
        return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $04ec6ca6caf932c8$export$2e2bcd8739ae039), {
            width: stageWidth,
            height: stageHeight,
            onDragStart: this.handleDragStart,
            onDragMove: this.handleDragMove,
            onDragEnd: this.handleDragEnd,
            resetOnStart: true,
            isDragging: isControlled ? isDragInProgress : undefined,
            children: (_ref)=>{
                let { dragStart: dragStart, dragEnd: dragEnd, dragMove: dragMove, isDragging: isDragging } = _ref;
                return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("g", {
                    children: [
                        isDragging && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("rect", {
                            fill: "transparent",
                            width: stageWidth,
                            height: stageHeight,
                            style: {
                                cursor: cursor
                            },
                            onPointerMove: dragMove,
                            onPointerUp: isControlled ? undefined : dragEnd,
                            onPointerLeave: isControlled ? undefined : dragEnd
                        }),
                        !renderBrushHandle && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("rect", {
                            x: x,
                            y: y,
                            width: width,
                            height: height,
                            fill: "transparent",
                            className: `visx-brush-handle-${type}`,
                            onPointerDown: dragStart,
                            onPointerMove: dragMove,
                            onPointerUp: isControlled ? undefined : dragEnd,
                            style: {
                                cursor: cursor,
                                pointerEvents: !!brush.activeHandle || !!brush.isBrushing ? 'none' : 'all'
                            }
                        }),
                        renderBrushHandle && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("g", {
                            onPointerDown: dragStart,
                            onPointerMove: dragMove,
                            onPointerUp: isControlled ? undefined : dragEnd,
                            children: renderBrushHandle({
                                ...this.props.handle,
                                height: stageHeight,
                                className: `visx-brush-handle-${type}`,
                                isBrushActive: brush.extent.x0 !== -1 && brush.extent.x1 !== -1
                            })
                        })
                    ]
                });
            }
        });
    }
}


/* eslint react/jsx-handler-names: 0 */ 
var $5E6i4 = parcelRequire("5E6i4");


class $5ba8ecc0f274ce31$export$2e2bcd8739ae039 extends (0, $5E6i4.Component) {
    static defaultProps = {
        style: {}
    };
    cornerDragMove = (drag)=>{
        const { updateBrush: updateBrush, type: type } = this.props;
        if (!drag.isDragging) return;
        updateBrush((prevBrush)=>{
            const { start: start, end: end } = prevBrush;
            const xMax = Math.max(start.x, end.x);
            const xMin = Math.min(start.x, end.x);
            const yMax = Math.max(start.y, end.y);
            const yMin = Math.min(start.y, end.y);
            let moveX = 0;
            let moveY = 0;
            switch(type){
                case 'topRight':
                    moveX = xMax + drag.dx;
                    moveY = yMin + drag.dy;
                    return {
                        ...prevBrush,
                        activeHandle: type,
                        extent: {
                            ...prevBrush.extent,
                            x0: Math.max(Math.min(moveX, start.x), prevBrush.bounds.x0),
                            x1: Math.min(Math.max(moveX, start.x), prevBrush.bounds.x1),
                            y0: Math.max(Math.min(moveY, end.y), prevBrush.bounds.y0),
                            y1: Math.min(Math.max(moveY, end.y), prevBrush.bounds.y1)
                        }
                    };
                case 'topLeft':
                    moveX = xMin + drag.dx;
                    moveY = yMin + drag.dy;
                    return {
                        ...prevBrush,
                        activeHandle: type,
                        extent: {
                            ...prevBrush.extent,
                            x0: Math.max(Math.min(moveX, end.x), prevBrush.bounds.x0),
                            x1: Math.min(Math.max(moveX, end.x), prevBrush.bounds.x1),
                            y0: Math.max(Math.min(moveY, end.y), prevBrush.bounds.y0),
                            y1: Math.min(Math.max(moveY, end.y), prevBrush.bounds.y1)
                        }
                    };
                case 'bottomLeft':
                    moveX = xMin + drag.dx;
                    moveY = yMax + drag.dy;
                    return {
                        ...prevBrush,
                        activeHandle: type,
                        extent: {
                            ...prevBrush.extent,
                            x0: Math.max(Math.min(moveX, end.x), prevBrush.bounds.x0),
                            x1: Math.min(Math.max(moveX, end.x), prevBrush.bounds.x1),
                            y0: Math.max(Math.min(moveY, start.y), prevBrush.bounds.y0),
                            y1: Math.min(Math.max(moveY, start.y), prevBrush.bounds.y1)
                        }
                    };
                case 'bottomRight':
                    moveX = xMax + drag.dx;
                    moveY = yMax + drag.dy;
                    return {
                        ...prevBrush,
                        activeHandle: type,
                        extent: {
                            ...prevBrush.extent,
                            x0: Math.max(Math.min(moveX, start.x), prevBrush.bounds.x0),
                            x1: Math.min(Math.max(moveX, start.x), prevBrush.bounds.x1),
                            y0: Math.max(Math.min(moveY, start.y), prevBrush.bounds.y0),
                            y1: Math.min(Math.max(moveY, start.y), prevBrush.bounds.y1)
                        }
                    };
                // BrushCorner skips edges use BrushHandle for those
                case 'top':
                case 'right':
                case 'bottom':
                case 'left':
                default:
                    return prevBrush;
            }
        });
    };
    cornerDragEnd = ()=>{
        const { updateBrush: updateBrush, onBrushEnd: onBrushEnd } = this.props;
        updateBrush((prevBrush)=>{
            const { start: start, end: end, extent: extent } = prevBrush;
            start.x = Math.min(extent.x0, extent.x1);
            start.y = Math.min(extent.y0, extent.y0);
            end.x = Math.max(extent.x0, extent.x1);
            end.y = Math.max(extent.y0, extent.y1);
            const nextBrush = {
                ...prevBrush,
                start: start,
                end: end,
                activeHandle: null,
                domain: {
                    x0: Math.min(start.x, end.x),
                    x1: Math.max(start.x, end.x),
                    y0: Math.min(start.y, end.y),
                    y1: Math.max(start.y, end.y)
                }
            };
            if (onBrushEnd) onBrushEnd(nextBrush);
            return nextBrush;
        });
    };
    render() {
        const { type: type, brush: brush, stageWidth: stageWidth, stageHeight: stageHeight, style: styleProp, corner: corner } = this.props;
        const cursor = styleProp?.cursor || (type === 'topLeft' || type === 'bottomRight' ? 'nwse-resize' : 'nesw-resize');
        const pointerEvents = brush.activeHandle || brush.isBrushing ? 'none' : 'all';
        return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $04ec6ca6caf932c8$export$2e2bcd8739ae039), {
            width: stageWidth,
            height: stageHeight,
            onDragMove: this.cornerDragMove,
            onDragEnd: this.cornerDragEnd,
            resetOnStart: true,
            children: (_ref)=>{
                let { dragMove: dragMove, dragEnd: dragEnd, dragStart: dragStart, isDragging: isDragging } = _ref;
                return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("g", {
                    children: [
                        isDragging && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("rect", {
                            fill: "transparent",
                            width: stageWidth,
                            height: stageHeight,
                            style: {
                                cursor: cursor
                            },
                            onPointerMove: dragMove,
                            onPointerUp: dragEnd
                        }),
                        /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("rect", {
                            fill: "transparent",
                            onPointerDown: dragStart,
                            onPointerMove: dragMove,
                            onPointerUp: dragEnd,
                            className: `visx-brush-corner-${type}`,
                            style: {
                                cursor: cursor,
                                pointerEvents: pointerEvents,
                                ...styleProp
                            },
                            ...corner
                        })
                    ]
                });
            }
        });
    }
}


/* eslint react/jsx-handler-names: 0 */ 
var $5E6i4 = parcelRequire("5E6i4");



const $1fd55101461d7f64$var$DRAGGING_OVERLAY_STYLES = {
    cursor: 'move'
};
class $1fd55101461d7f64$export$2e2bcd8739ae039 extends (0, $5E6i4.Component) {
    static defaultProps = {
        onMouseLeave: null,
        onMouseUp: null,
        onMouseMove: null,
        onClick: null
    };
    selectionDragStart = (drag)=>{
        const { onMoveSelectionChange: onMoveSelectionChange, onBrushStart: onBrushStart } = this.props;
        if (onMoveSelectionChange) onMoveSelectionChange('move', (0, $1aad569f11ff69c8$export$ccc55dee332fd8dd)(drag.event));
        if (onBrushStart) onBrushStart(drag);
    };
    selectionDragMove = (drag)=>{
        const { updateBrush: updateBrush, isControlled: isControlled } = this.props;
        if (isControlled) return;
        updateBrush((prevBrush)=>{
            const { x: x0, y: y0 } = prevBrush.start;
            const { x: x1, y: y1 } = prevBrush.end;
            const validDx = drag.dx > 0 ? Math.min(drag.dx, prevBrush.bounds.x1 - x1) : Math.max(drag.dx, prevBrush.bounds.x0 - x0);
            const validDy = drag.dy > 0 ? Math.min(drag.dy, prevBrush.bounds.y1 - y1) : Math.max(drag.dy, prevBrush.bounds.y0 - y0);
            return {
                ...prevBrush,
                isBrushing: true,
                extent: {
                    ...prevBrush.extent,
                    x0: x0 + validDx,
                    x1: x1 + validDx,
                    y0: y0 + validDy,
                    y1: y1 + validDy
                }
            };
        });
    };
    selectionDragEnd = ()=>{
        const { updateBrush: updateBrush, onBrushEnd: onBrushEnd, onMoveSelectionChange: onMoveSelectionChange, isControlled: isControlled } = this.props;
        if (!isControlled) updateBrush((prevBrush)=>{
            const nextBrush = {
                ...prevBrush,
                isBrushing: false,
                start: {
                    ...prevBrush.start,
                    x: Math.min(prevBrush.extent.x0, prevBrush.extent.x1),
                    y: Math.min(prevBrush.extent.y0, prevBrush.extent.y1)
                },
                end: {
                    ...prevBrush.end,
                    x: Math.max(prevBrush.extent.x0, prevBrush.extent.x1),
                    y: Math.max(prevBrush.extent.y0, prevBrush.extent.y1)
                }
            };
            if (onBrushEnd) onBrushEnd(nextBrush);
            return nextBrush;
        });
        if (onMoveSelectionChange) onMoveSelectionChange();
    };
    render() {
        const { width: width, height: height, stageWidth: stageWidth, stageHeight: stageHeight, brush: brush, disableDraggingSelection: disableDraggingSelection, onMouseLeave: onMouseLeave, onMouseMove: onMouseMove, onMouseUp: onMouseUp, onClick: onClick, selectedBoxStyle: selectedBoxStyle, isControlled: isControlled, isDragInProgress: isDragInProgress } = this.props;
        return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $04ec6ca6caf932c8$export$2e2bcd8739ae039), {
            width: width,
            height: height,
            resetOnStart: true,
            onDragStart: this.selectionDragStart,
            onDragMove: this.selectionDragMove,
            onDragEnd: this.selectionDragEnd,
            isDragging: isControlled ? isDragInProgress : undefined,
            children: (_ref)=>{
                let { isDragging: isDragging, dragStart: dragStart, dragEnd: dragEnd, dragMove: dragMove } = _ref;
                return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("g", {
                    children: [
                        isDragging && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("rect", {
                            width: stageWidth,
                            height: stageHeight,
                            fill: "transparent",
                            onPointerUp: isControlled ? undefined : dragEnd,
                            onPointerMove: dragMove,
                            onPointerLeave: isControlled ? undefined : dragEnd,
                            style: $1fd55101461d7f64$var$DRAGGING_OVERLAY_STYLES
                        }),
                        /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("rect", {
                            x: Math.min(brush.extent.x0, brush.extent.x1),
                            y: Math.min(brush.extent.y0, brush.extent.y1),
                            width: width,
                            height: height,
                            className: "visx-brush-selection",
                            onPointerDown: disableDraggingSelection ? undefined : dragStart,
                            onPointerLeave: (event)=>{
                                if (onMouseLeave) onMouseLeave(event);
                            },
                            onPointerMove: (event)=>{
                                dragMove(event);
                                if (onMouseMove) onMouseMove(event);
                            },
                            onPointerUp: (event)=>{
                                if (!isControlled) dragEnd(event);
                                if (onMouseUp) onMouseUp(event);
                            },
                            onClick: (event)=>{
                                if (onClick) onClick(event);
                            },
                            style: {
                                pointerEvents: brush.isBrushing || brush.activeHandle ? 'none' : 'all',
                                cursor: disableDraggingSelection ? undefined : 'move'
                            },
                            ...selectedBoxStyle
                        })
                    ]
                });
            }
        });
    }
}




function $e4a572b163246e31$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $3a3ab9fc8020305e$export$2e2bcd8739ae039), {
        className: "visx-brush-overlay",
        fill: "transparent",
        x: 0,
        y: 0,
        ...props
    });
}




class $e07c3e2ef1bf0349$export$2e2bcd8739ae039 extends (0, $5E6i4.Component) {
    constructor(props){
        super(props);
        const { initialBrushPosition: initialBrushPosition } = props;
        const extent = initialBrushPosition ? this.getExtent(initialBrushPosition.start, initialBrushPosition.end) : {
            x0: -1,
            x1: -1,
            y0: -1,
            y1: -1
        };
        this.state = {
            start: {
                x: Math.max(0, extent.x0),
                y: Math.max(0, extent.y0)
            },
            end: {
                x: Math.max(0, extent.x1),
                y: Math.max(0, extent.y1)
            },
            extent: extent,
            bounds: {
                x0: 0,
                x1: this.props.width,
                y0: 0,
                y1: this.props.height
            },
            isBrushing: false,
            brushingType: undefined,
            activeHandle: null
        };
    }
    mouseUpTime = 0;
    mouseDownTime = 0;
    static defaultProps = {
        brushDirection: 'both',
        inheritedMargin: {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        },
        onChange: null,
        handleSize: 4,
        resizeTriggerAreas: [
            'left',
            'right'
        ],
        onBrushStart: null,
        onBrushEnd: null,
        onMouseLeave: null,
        onMouseUp: null,
        onMouseMove: null,
        onClick: null,
        disableDraggingSelection: false,
        disableDraggingOverlay: false,
        clickSensitivity: 200,
        resetOnEnd: false,
        initialBrushPosition: null,
        useWindowMoveEvents: false,
        renderBrushHandles: null
    };
    getIdleState = ()=>{
        const { width: width, height: height } = this.props;
        return {
            start: {
                x: 0,
                y: 0
            },
            end: {
                x: 0,
                y: 0
            },
            extent: {
                x0: -1,
                x1: -1,
                y0: -1,
                y1: -1
            },
            bounds: {
                x0: 0,
                x1: width,
                y0: 0,
                y1: height
            },
            isBrushing: false,
            brushPageOffset: undefined,
            activeHandle: null,
            brushingType: undefined
        };
    };
    componentDidUpdate(prevProps) {
        if (this.props.width !== prevProps.width || this.props.height !== prevProps.height) this.setState((prevBrush)=>{
            let { start: start, end: end, extent: extent } = prevBrush;
            if (!(extent.x0 === -1 && extent.x1 === -1 && extent.y0 === -1 && extent.y1 === -1)) {
                const widthRatio = this.props.width / prevProps.width;
                const heightRatio = this.props.height / prevProps.height;
                start = {
                    x: widthRatio * extent.x0,
                    y: heightRatio * extent.y0
                };
                end = {
                    x: widthRatio * extent.x1,
                    y: heightRatio * extent.y1
                };
                extent = this.getExtent(start, end);
            }
            return {
                start: start,
                end: end,
                extent: extent,
                bounds: {
                    x0: 0,
                    x1: this.props.width,
                    y0: 0,
                    y1: this.props.height
                }
            };
        });
    }
    componentDidMount() {
        if (this.props.useWindowMoveEvents) {
            window.addEventListener('mouseup', this.handleWindowPointerUp);
            window.addEventListener('mousemove', this.debouncedHandleWindowPointerMove);
        }
    }
    componentWillUnmount() {
        if (this.props.useWindowMoveEvents) {
            window.removeEventListener('mouseup', this.handleWindowPointerUp);
            window.removeEventListener('mousemove', this.debouncedHandleWindowPointerMove);
        }
    }
    handleWindowPointerUp = ()=>{
        const { useWindowMoveEvents: useWindowMoveEvents, onBrushEnd: onBrushEnd, resetOnEnd: resetOnEnd } = this.props;
        const { brushingType: brushingType } = this.state;
        if (useWindowMoveEvents && brushingType) this.updateBrush((prevBrush)=>{
            const { start: start, end: end, extent: extent } = prevBrush;
            start.x = Math.min(extent.x0, extent.x1);
            start.y = Math.min(extent.y0, extent.y0);
            end.x = Math.max(extent.x0, extent.x1);
            end.y = Math.max(extent.y0, extent.y1);
            let newState = {
                ...prevBrush,
                activeHandle: null,
                isBrushing: false,
                brushingType: undefined
            };
            if (onBrushEnd) onBrushEnd(newState);
            if (resetOnEnd) newState = {
                ...newState,
                ...this.getIdleState()
            };
            return newState;
        });
    };
    handleWindowPointerMove = (event)=>{
        const { useWindowMoveEvents: useWindowMoveEvents } = this.props;
        const { brushingType: brushingType, isBrushing: isBrushing, brushPageOffset: brushPageOffset, start: start } = this.state;
        if (!useWindowMoveEvents || !isBrushing) return;
        /* We use event page coordinates to calculate the offset between the initial pointer position and
       the current pointer position so Brush could be resized/moved relatively. */ const offsetX = event.pageX - (brushPageOffset?.pageX || 0);
        const offsetY = event.pageY - (brushPageOffset?.pageY || 0);
        if ([
            'left',
            'right',
            'top',
            'bottom'
        ].includes(brushingType ?? '')) this.updateBrush((prevBrush)=>{
            const { x: x0, y: y0 } = prevBrush.start;
            const { x: x1, y: y1 } = prevBrush.end;
            return {
                ...prevBrush,
                isBrushing: true,
                extent: {
                    ...prevBrush.extent,
                    ...this.getExtent({
                        x: brushingType === 'left' ? Math.min(Math.max(x0 + offsetX, prevBrush.bounds.x0), prevBrush.bounds.x1) : x0,
                        y: brushingType === 'top' ? Math.min(Math.max(y0 + offsetY, prevBrush.bounds.y0), prevBrush.bounds.y1) : y0
                    }, {
                        x: brushingType === 'right' ? Math.min(Math.max(x1 + offsetX, prevBrush.bounds.x0), prevBrush.bounds.x1) : x1,
                        y: brushingType === 'bottom' ? Math.min(Math.max(y1 + offsetY, prevBrush.bounds.y0), prevBrush.bounds.y1) : y1
                    })
                }
            };
        });
        if (brushingType === 'move') this.updateBrush((prevBrush)=>{
            const { x: x0, y: y0 } = prevBrush.start;
            const { x: x1, y: y1 } = prevBrush.end;
            const validDx = offsetX > 0 ? Math.min(offsetX, prevBrush.bounds.x1 - x1) : Math.max(offsetX, prevBrush.bounds.x0 - x0);
            const validDy = offsetY > 0 ? Math.min(offsetY, prevBrush.bounds.y1 - y1) : Math.max(offsetY, prevBrush.bounds.y0 - y0);
            return {
                ...prevBrush,
                isBrushing: true,
                extent: {
                    ...prevBrush.extent,
                    x0: x0 + validDx,
                    y0: y0 + validDy,
                    x1: x1 + validDx,
                    y1: y1 + validDy
                }
            };
        });
        if (brushingType === 'select') this.updateBrush((prevBrush)=>{
            const { x: x0, y: y0 } = prevBrush.start;
            const newEnd = {
                x: Math.min(Math.max(x0 + offsetX, prevBrush.bounds.x0), prevBrush.bounds.x1),
                y: Math.min(Math.max(y0 + offsetY, prevBrush.bounds.y0), prevBrush.bounds.y1)
            };
            const extent = this.getExtent(start, newEnd);
            const newState = {
                ...prevBrush,
                end: newEnd,
                extent: extent
            };
            return newState;
        });
    };
    debouncedHandleWindowPointerMove = (()=>(0, $1aad569f11ff69c8$export$61fc7d43ac8f84b0)(this.handleWindowPointerMove, 1))();
    getExtent = (start, end)=>{
        const { brushDirection: brushDirection, width: width, height: height } = this.props;
        const x0 = brushDirection === 'vertical' ? 0 : Math.min(start.x || 0, end.x || 0);
        const x1 = brushDirection === 'vertical' ? width : Math.max(start.x || 0, end.x || 0);
        const y0 = brushDirection === 'horizontal' ? 0 : Math.min(start.y || 0, end.y || 0);
        const y1 = brushDirection === 'horizontal' ? height : Math.max(start.y || 0, end.y || 0);
        return {
            x0: x0,
            x1: x1,
            y0: y0,
            y1: y1
        };
    };
    handleDragStart = (draw)=>{
        const { onBrushStart: onBrushStart, left: left, top: top, inheritedMargin: inheritedMargin, useWindowMoveEvents: useWindowMoveEvents } = this.props;
        const marginLeft = inheritedMargin?.left ? inheritedMargin.left : 0;
        const marginTop = inheritedMargin?.top ? inheritedMargin.top : 0;
        const start = {
            x: (draw.x || 0) + draw.dx - left - marginLeft,
            y: (draw.y || 0) + draw.dy - top - marginTop
        };
        const end = {
            ...start
        };
        if (onBrushStart) onBrushStart(start);
        this.updateBrush((prevBrush)=>({
                ...prevBrush,
                start: start,
                end: end,
                extent: {
                    x0: -1,
                    x1: -1,
                    y0: -1,
                    y1: -1
                },
                isBrushing: true,
                brushingType: 'select',
                brushPageOffset: useWindowMoveEvents ? (0, $1aad569f11ff69c8$export$ccc55dee332fd8dd)(draw.event) : undefined
            }));
    };
    handleBrushStart = (drag)=>{
        const { onBrushStart: onBrushStart, left: left, top: top, inheritedMargin: inheritedMargin } = this.props;
        if (onBrushStart) {
            const marginLeft = inheritedMargin?.left ? inheritedMargin.left : 0;
            const marginTop = inheritedMargin?.top ? inheritedMargin.top : 0;
            const start = {
                x: (drag.x || 0) + drag.dx - left - marginLeft,
                y: (drag.y || 0) + drag.dy - top - marginTop
            };
            onBrushStart(start);
        }
    };
    handleDragMove = (drag)=>{
        const { left: left, top: top, inheritedMargin: inheritedMargin, useWindowMoveEvents: useWindowMoveEvents } = this.props;
        if (!drag.isDragging || useWindowMoveEvents) return;
        const marginLeft = inheritedMargin?.left || 0;
        const marginTop = inheritedMargin?.top || 0;
        const end = {
            x: (drag.x || 0) + drag.dx - left - marginLeft,
            y: (drag.y || 0) + drag.dy - top - marginTop
        };
        this.updateBrush((prevBrush)=>{
            const { start: start } = prevBrush;
            const extent = this.getExtent(start, end);
            return {
                ...prevBrush,
                end: end,
                extent: extent
            };
        });
    };
    handleDragEnd = ()=>{
        const { onBrushEnd: onBrushEnd, resetOnEnd: resetOnEnd, useWindowMoveEvents: useWindowMoveEvents } = this.props;
        if (!useWindowMoveEvents) this.updateBrush((prevBrush)=>{
            const { extent: extent } = prevBrush;
            let newState = {
                ...prevBrush,
                start: {
                    x: extent.x0,
                    y: extent.y0
                },
                end: {
                    x: extent.x1,
                    y: extent.y1
                },
                isBrushing: false,
                brushingType: undefined,
                activeHandle: null
            };
            if (onBrushEnd) onBrushEnd(newState);
            if (resetOnEnd) newState = {
                ...newState,
                ...this.getIdleState()
            };
            return newState;
        });
    };
    getBrushWidth = ()=>{
        const { extent: extent } = this.state;
        const { x0: x0, x1: x1 } = extent;
        return Math.max(Math.max(x0, x1) - Math.min(x0, x1), 0);
    };
    getBrushHeight = ()=>{
        const { extent: extent } = this.state;
        const { y1: y1, y0: y0 } = extent;
        return Math.max(Math.max(y0, y1) - Math.min(y0, y1), 0);
    };
    handles = ()=>{
        const { handleSize: handleSize } = this.props;
        const { extent: extent } = this.state;
        const { x0: x0, x1: x1, y0: y0, y1: y1 } = extent;
        const offset = handleSize / 2;
        const width = this.getBrushWidth();
        const height = this.getBrushHeight();
        return {
            top: {
                x: x0 - offset,
                y: y0 - offset,
                height: handleSize,
                width: width + handleSize
            },
            bottom: {
                x: x0 - offset,
                y: y1 - offset,
                height: handleSize,
                width: width + handleSize
            },
            right: {
                x: x1 - offset,
                y: y0 - offset,
                height: height + handleSize,
                width: handleSize
            },
            left: {
                x: x0 - offset,
                y: y0 - offset,
                height: height + handleSize,
                width: handleSize
            }
        };
    };
    corners = ()=>{
        const { handleSize: handleSize } = this.props;
        const { extent: extent } = this.state;
        const { x0: x0, x1: x1, y0: y0, y1: y1 } = extent;
        const offset = handleSize / 2;
        const width = handleSize;
        const height = handleSize;
        return {
            topLeft: {
                x: Math.min(x0, x1) - offset,
                y: Math.min(y0, y1) - offset,
                width: width,
                height: height
            },
            topRight: {
                x: Math.max(x0, x1) - offset,
                y: Math.min(y0, y1) - offset,
                width: width,
                height: height
            },
            bottomLeft: {
                x: Math.min(x0, x1) - offset,
                y: Math.max(y0, y1) - offset,
                width: width,
                height: height
            },
            bottomRight: {
                x: Math.max(x0, x1) - offset,
                y: Math.max(y0, y1) - offset,
                width: width,
                height: height
            }
        };
    };
    updateBrush = (updater)=>{
        const { onChange: onChange } = this.props;
        this.setState(updater, ()=>{
            if (onChange) onChange(this.state);
        });
    };
    reset = ()=>this.updateBrush(()=>this.getIdleState());
    handleBrushingTypeChange = (type, brushPageOffset)=>{
        this.updateBrush((prevBrush)=>{
            const next = {
                ...prevBrush,
                brushingType: type,
                isBrushing: type !== undefined
            };
            if (brushPageOffset || type === undefined) next.brushPageOffset = brushPageOffset;
            return next;
        });
    };
    render() {
        const { start: start, end: end } = this.state;
        const { top: top, left: left, width: stageWidth, height: stageHeight, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onMouseMove: onMouseMove, onBrushEnd: onBrushEnd, onClick: onClick, resizeTriggerAreas: resizeTriggerAreas, selectedBoxStyle: selectedBoxStyle, disableDraggingSelection: disableDraggingSelection, disableDraggingOverlay: disableDraggingOverlay, clickSensitivity: clickSensitivity, useWindowMoveEvents: useWindowMoveEvents, renderBrushHandle: renderBrushHandle } = this.props;
        const { brushingType: brushingType } = this.state;
        const handles = this.handles();
        const corners = this.corners();
        const width = this.getBrushWidth();
        const height = this.getBrushHeight();
        const resizeTriggerAreaSet = new Set(resizeTriggerAreas);
        return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)((0, $268dd56f34f61467$export$2e2bcd8739ae039), {
            className: "visx-brush",
            top: top,
            left: left,
            children: [
                disableDraggingOverlay ? /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $e4a572b163246e31$export$2e2bcd8739ae039), {
                    width: stageWidth,
                    height: stageHeight,
                    onClick: (event)=>{
                        const duration = this.mouseUpTime - this.mouseDownTime;
                        if (onClick && duration < clickSensitivity) onClick(event);
                    },
                    style: {
                        cursor: 'default'
                    }
                }) : /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $04ec6ca6caf932c8$export$2e2bcd8739ae039), {
                    width: stageWidth,
                    height: stageHeight,
                    resetOnStart: true,
                    onDragStart: this.handleDragStart,
                    onDragMove: this.handleDragMove,
                    onDragEnd: this.handleDragEnd,
                    isDragging: useWindowMoveEvents ? brushingType === 'select' : undefined,
                    children: (_ref)=>{
                        let { dragStart: dragStart, isDragging: isDragging, dragMove: dragMove, dragEnd: dragEnd } = _ref;
                        return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $e4a572b163246e31$export$2e2bcd8739ae039), {
                            width: stageWidth,
                            height: stageHeight,
                            onDoubleClick: ()=>this.reset(),
                            onClick: (event)=>{
                                const duration = this.mouseUpTime - this.mouseDownTime;
                                if (onClick && duration < clickSensitivity) onClick(event);
                            },
                            onPointerDown: (event)=>{
                                this.mouseDownTime = Date.now();
                                dragStart(event);
                            },
                            onPointerLeave: (event)=>{
                                if (onMouseLeave) onMouseLeave(event);
                            },
                            onPointerMove: (event)=>{
                                if (!isDragging && onMouseMove) onMouseMove(event);
                                if (isDragging) dragMove(event);
                            },
                            onPointerUp: (event)=>{
                                this.mouseUpTime = Date.now();
                                if (onMouseUp) onMouseUp(event);
                                dragEnd(event);
                            },
                            style: {
                                cursor: 'crosshair'
                            }
                        });
                    }
                }),
                start && end && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $1fd55101461d7f64$export$2e2bcd8739ae039), {
                    updateBrush: this.updateBrush,
                    width: width,
                    height: height,
                    stageWidth: stageWidth,
                    stageHeight: stageHeight,
                    brush: this.state,
                    disableDraggingSelection: disableDraggingSelection,
                    onBrushEnd: onBrushEnd,
                    onBrushStart: this.handleBrushStart,
                    onMouseLeave: onMouseLeave,
                    onMouseMove: onMouseMove,
                    onMouseUp: onMouseUp,
                    onMoveSelectionChange: this.handleBrushingTypeChange,
                    onClick: onClick,
                    selectedBoxStyle: selectedBoxStyle,
                    isControlled: useWindowMoveEvents,
                    isDragInProgress: useWindowMoveEvents ? brushingType === 'move' : undefined
                }),
                start && end && Object.keys(handles).filter((handleKey)=>resizeTriggerAreaSet.has(handleKey)).map((handleKey)=>{
                    const handle = handles[handleKey];
                    return handle && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $ffb60a362ef5a838$export$2e2bcd8739ae039), {
                        type: handleKey,
                        handle: handle,
                        stageWidth: stageWidth,
                        stageHeight: stageHeight,
                        updateBrush: this.updateBrush,
                        brush: this.state,
                        onBrushStart: this.handleBrushStart,
                        onBrushEnd: onBrushEnd,
                        isControlled: useWindowMoveEvents,
                        isDragInProgress: useWindowMoveEvents ? brushingType === handleKey : undefined,
                        onBrushHandleChange: this.handleBrushingTypeChange,
                        renderBrushHandle: renderBrushHandle
                    }, `handle-${handleKey}`);
                }),
                start && end && Object.keys(corners).filter((cornerKey)=>resizeTriggerAreaSet.has(cornerKey)).map((cornerKey)=>{
                    const corner = corners[cornerKey];
                    return corner && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $5ba8ecc0f274ce31$export$2e2bcd8739ae039), {
                        type: cornerKey,
                        brush: this.state,
                        updateBrush: this.updateBrush,
                        stageWidth: stageWidth,
                        stageHeight: stageHeight,
                        corner: corner,
                        onBrushEnd: onBrushEnd
                    }, `corner-${cornerKey}`);
                })
            ]
        });
    }
}




const $7533018f806f859e$var$SAFE_PIXEL = 2;
const $7533018f806f859e$var$DEFAULT_COLOR = 'steelblue';
class $7533018f806f859e$var$Brush extends (0, $5E6i4.Component) {
    static defaultProps = (()=>({
            xScale: null,
            yScale: null,
            onChange: null,
            height: 0,
            width: 0,
            selectedBoxStyle: {
                fill: $7533018f806f859e$var$DEFAULT_COLOR,
                fillOpacity: 0.2,
                stroke: $7533018f806f859e$var$DEFAULT_COLOR,
                strokeWidth: 1,
                strokeOpacity: 0.8
            },
            margin: {
                top: 0,
                left: 0,
                right: 0,
                bottom: 0
            },
            handleSize: 4,
            brushDirection: 'horizontal',
            initialBrushPosition: null,
            resizeTriggerAreas: [
                'left',
                'right'
            ],
            brushRegion: 'chart',
            yAxisOrientation: 'right',
            xAxisOrientation: 'bottom',
            onBrushStart: null,
            onBrushEnd: null,
            disableDraggingSelection: false,
            resetOnEnd: false,
            onMouseMove: null,
            onMouseLeave: null,
            onClick: null,
            useWindowMoveEvents: false,
            renderBrushHandles: null
        }))();
    handleChange = (brush)=>{
        const { onChange: onChange } = this.props;
        if (!onChange) return;
        const { x0: x0 } = brush.extent;
        if (typeof x0 === 'undefined' || x0 < 0) {
            onChange(null);
            return;
        }
        const domain = this.convertRangeToDomain(brush);
        onChange(domain);
    };
    convertRangeToDomain(brush) {
        const { xScale: xScale, yScale: yScale } = this.props;
        const { x0: x0, x1: x1, y0: y0, y1: y1 } = brush.extent;
        const xDomain = (0, $1aad569f11ff69c8$export$3100c299dcd85ca3)(xScale, x0 || 0, x1 || 0, $7533018f806f859e$var$SAFE_PIXEL);
        const yDomain = (0, $1aad569f11ff69c8$export$3100c299dcd85ca3)(yScale, y0 || 0, y1 || 0, $7533018f806f859e$var$SAFE_PIXEL);
        const domain = {
            x0: xDomain.start || 0,
            x1: xDomain.end || 0,
            xValues: xDomain.values,
            y0: yDomain.start || 0,
            y1: yDomain.end || 0,
            yValues: yDomain.values
        };
        return domain;
    }
    handleBrushStart = (point)=>{
        const { onBrushStart: onBrushStart } = this.props;
        if (!onBrushStart) return;
        const { x: x, y: y } = point;
        const { xScale: xScale, yScale: yScale } = this.props;
        const invertedX = (0, $1aad569f11ff69c8$export$ba254c7738e004b6)(xScale, x);
        const invertedY = (0, $1aad569f11ff69c8$export$ba254c7738e004b6)(yScale, y);
        onBrushStart({
            x: 'invert' in xScale && typeof xScale.invert !== 'undefined' ? invertedX : xScale.domain()[invertedX],
            y: 'invert' in yScale && typeof yScale.invert !== 'undefined' ? invertedY : yScale.domain()[invertedY]
        });
    };
    handleBrushEnd = (brush)=>{
        const { onBrushEnd: onBrushEnd } = this.props;
        if (!onBrushEnd) return;
        const { x0: x0 } = brush.extent;
        if (typeof x0 === 'undefined' || x0 < 0) {
            onBrushEnd(null);
            return;
        }
        const domain = this.convertRangeToDomain(brush);
        onBrushEnd(domain);
    };
    render() {
        const { xScale: xScale, yScale: yScale, height: height, width: width, margin: margin, brushDirection: brushDirection, initialBrushPosition: initialBrushPosition, innerRef: innerRef, resizeTriggerAreas: resizeTriggerAreas, brushRegion: brushRegion, yAxisOrientation: yAxisOrientation, xAxisOrientation: xAxisOrientation, selectedBoxStyle: selectedBoxStyle, disableDraggingSelection: disableDraggingSelection, disableDraggingOverlay: disableDraggingOverlay, resetOnEnd: resetOnEnd, onMouseLeave: onMouseLeave, onMouseMove: onMouseMove, onClick: onClick, handleSize: handleSize, useWindowMoveEvents: useWindowMoveEvents, renderBrushHandle: renderBrushHandle } = this.props;
        if (!xScale || !yScale) return null;
        let brushRegionWidth;
        let brushRegionHeight;
        let left;
        let top;
        const marginLeft = margin?.left ? margin.left : 0;
        const marginTop = margin?.top ? margin.top : 0;
        const marginRight = margin?.right ? margin.right : 0;
        const marginBottom = margin?.bottom ? margin.bottom : 0;
        if (brushRegion === 'chart') {
            left = 0;
            top = 0;
            brushRegionWidth = width;
            brushRegionHeight = height;
        } else if (brushRegion === 'yAxis') {
            top = 0;
            brushRegionHeight = height;
            if (yAxisOrientation === 'right') {
                left = width;
                brushRegionWidth = marginRight;
            } else {
                left = -marginLeft;
                brushRegionWidth = marginLeft;
            }
        } else {
            left = 0;
            brushRegionWidth = width;
            if (xAxisOrientation === 'bottom') {
                top = height;
                brushRegionHeight = marginBottom;
            } else {
                top = -marginTop;
                brushRegionHeight = marginTop;
            }
        }
        return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $e07c3e2ef1bf0349$export$2e2bcd8739ae039), {
            width: brushRegionWidth,
            height: brushRegionHeight,
            left: left,
            top: top,
            brushDirection: brushDirection,
            disableDraggingSelection: disableDraggingSelection,
            disableDraggingOverlay: disableDraggingOverlay,
            handleSize: handleSize,
            inheritedMargin: margin,
            initialBrushPosition: initialBrushPosition,
            ref: innerRef,
            resetOnEnd: resetOnEnd,
            resizeTriggerAreas: resizeTriggerAreas,
            selectedBoxStyle: selectedBoxStyle,
            onBrushEnd: this.handleBrushEnd,
            onBrushStart: this.handleBrushStart,
            onChange: this.handleChange,
            onClick: onClick,
            onMouseLeave: onMouseLeave,
            onMouseMove: onMouseMove,
            useWindowMoveEvents: useWindowMoveEvents,
            renderBrushHandle: renderBrushHandle
        });
    }
}
var $7533018f806f859e$export$2e2bcd8739ae039 = $7533018f806f859e$var$Brush;




// @visx/clip-path

function $5c6fb60692d29a02$export$2e2bcd8739ae039(_ref) {
    let { id: id, children: children, ...restProps } = _ref;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("defs", {
        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("clipPath", {
            id: id,
            ...restProps,
            children: children
        })
    });
}




function $e1715a29b2849733$export$2e2bcd8739ae039(_ref) {
    let { id: id, cx: cx, cy: cy, r: r, ...restProps } = _ref;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $5c6fb60692d29a02$export$2e2bcd8739ae039), {
        id: id,
        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("circle", {
            cx: cx,
            cy: cy,
            r: r,
            ...restProps
        })
    });
}




function $4babf928d7166ed2$export$2e2bcd8739ae039(_ref) {
    let { id: id, x: x = 0, y: y = 0, width: width = 1, height: height = 1, ...restProps } = _ref;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $5c6fb60692d29a02$export$2e2bcd8739ae039), {
        id: id,
        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("rect", {
            x: x,
            y: y,
            width: width,
            height: height,
            ...restProps
        })
    });
}




// @visx/curve





// @visx/geo


/**
 * `@visx/vendor/d3-geo` (ESM)
 * See upstream license: https://github.com/d3/d3-geo/blob/main/LICENSE
 *
 * This ESM package re-exports the underlying installed dependencies of 
 * `node_modules/d3-geo`
 */ var $5014467dbc1df298$export$6c421550c66a327d = 1e-6;
var $5014467dbc1df298$export$92c06fba281fe81b = 1e-12;
var $5014467dbc1df298$export$18c7bea995a110f = Math.PI;
var $5014467dbc1df298$export$e51408a300e8929a = $5014467dbc1df298$export$18c7bea995a110f / 2;
var $5014467dbc1df298$export$c39a5cba78ea0fc2 = $5014467dbc1df298$export$18c7bea995a110f / 4;
var $5014467dbc1df298$export$a4b4b4d4d776fe92 = $5014467dbc1df298$export$18c7bea995a110f * 2;
var $5014467dbc1df298$export$41fc368e1a942b97 = 180 / $5014467dbc1df298$export$18c7bea995a110f;
var $5014467dbc1df298$export$8449e153fbd325fc = $5014467dbc1df298$export$18c7bea995a110f / 180;
var $5014467dbc1df298$export$2335f513bbd82c6d = Math.abs;
var $5014467dbc1df298$export$628dc4eed22b0fbd = Math.atan;
var $5014467dbc1df298$export$b8b770ee6a0d9760 = Math.atan2;
var $5014467dbc1df298$export$50d414a77b60d802 = Math.cos;
var $5014467dbc1df298$export$803ce6b71a0a94b2 = Math.ceil;
var $5014467dbc1df298$export$b310ec824aaee37f = Math.exp;
var $5014467dbc1df298$export$a3fe094919f356fd = Math.floor;
var $5014467dbc1df298$export$f95c7888b62f8e9a = Math.hypot;
var $5014467dbc1df298$export$bef1f36f5486a6a3 = Math.log;
var $5014467dbc1df298$export$9c297f60e22e3389 = Math.pow;
var $5014467dbc1df298$export$5de3937cb4b592ed = Math.sin;
var $5014467dbc1df298$export$c5552dfdbc7cec71 = Math.sign || function(x) {
    return x > 0 ? 1 : x < 0 ? -1 : 0;
};
var $5014467dbc1df298$export$eba8049fb5020b81 = Math.sqrt;
var $5014467dbc1df298$export$fcdd3b0b3246a325 = Math.tan;
function $5014467dbc1df298$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $5014467dbc1df298$export$18c7bea995a110f : Math.acos(x);
}
function $5014467dbc1df298$export$41726bdb1fc63f(x) {
    return x > 1 ? $5014467dbc1df298$export$e51408a300e8929a : x < -1 ? -$5014467dbc1df298$export$e51408a300e8929a : Math.asin(x);
}
function $5014467dbc1df298$export$e808712c2966e662(x) {
    return (x = $5014467dbc1df298$export$5de3937cb4b592ed(x / 2)) * x;
}



function $629d028a9279c5af$export$2e2bcd8739ae039() {}


function $bfbdb20a42788011$export$2e2bcd8739ae039() {
    var lines = [], line;
    return {
        point: function(x, y, m) {
            line.push([
                x,
                y,
                m
            ]);
        },
        lineStart: function() {
            lines.push(line = []);
        },
        lineEnd: (0, $629d028a9279c5af$export$2e2bcd8739ae039),
        rejoin: function() {
            if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
        },
        result: function() {
            var result = lines;
            lines = [];
            line = null;
            return result;
        }
    };
}



function $85be1de058b1c064$export$2e2bcd8739ae039(a, b) {
    return (0, $5014467dbc1df298$export$2335f513bbd82c6d)(a[0] - b[0]) < (0, $5014467dbc1df298$export$6c421550c66a327d) && (0, $5014467dbc1df298$export$2335f513bbd82c6d)(a[1] - b[1]) < (0, $5014467dbc1df298$export$6c421550c66a327d);
}



function $0d13a7a6536781f5$var$Intersection(point, points, other, entry) {
    this.x = point;
    this.z = points;
    this.o = other; // another intersection
    this.e = entry; // is an entry?
    this.v = false; // visited
    this.n = this.p = null; // next & previous
}
function $0d13a7a6536781f5$export$2e2bcd8739ae039(segments, compareIntersection, startInside, interpolate, stream) {
    var subject = [], clip = [], i, n;
    segments.forEach(function(segment) {
        if ((n = segment.length - 1) <= 0) return;
        var n, p0 = segment[0], p1 = segment[n], x;
        if ((0, $85be1de058b1c064$export$2e2bcd8739ae039)(p0, p1)) {
            if (!p0[2] && !p1[2]) {
                stream.lineStart();
                for(i = 0; i < n; ++i)stream.point((p0 = segment[i])[0], p0[1]);
                stream.lineEnd();
                return;
            }
            // handle degenerate cases by moving the point
            p1[0] += 2 * (0, $5014467dbc1df298$export$6c421550c66a327d);
        }
        subject.push(x = new $0d13a7a6536781f5$var$Intersection(p0, segment, null, true));
        clip.push(x.o = new $0d13a7a6536781f5$var$Intersection(p0, null, x, false));
        subject.push(x = new $0d13a7a6536781f5$var$Intersection(p1, segment, null, false));
        clip.push(x.o = new $0d13a7a6536781f5$var$Intersection(p1, null, x, true));
    });
    if (!subject.length) return;
    clip.sort(compareIntersection);
    $0d13a7a6536781f5$var$link(subject);
    $0d13a7a6536781f5$var$link(clip);
    for(i = 0, n = clip.length; i < n; ++i)clip[i].e = startInside = !startInside;
    var start = subject[0], points, point;
    while(true){
        // Find first unvisited intersection.
        var current = start, isSubject = true;
        while(current.v)if ((current = current.n) === start) return;
        points = current.z;
        stream.lineStart();
        do {
            current.v = current.o.v = true;
            if (current.e) {
                if (isSubject) for(i = 0, n = points.length; i < n; ++i)stream.point((point = points[i])[0], point[1]);
                else interpolate(current.x, current.n.x, 1, stream);
                current = current.n;
            } else {
                if (isSubject) {
                    points = current.p.z;
                    for(i = points.length - 1; i >= 0; --i)stream.point((point = points[i])[0], point[1]);
                } else interpolate(current.x, current.p.x, -1, stream);
                current = current.p;
            }
            current = current.o;
            points = current.z;
            isSubject = !isSubject;
        }while (!current.v);
        stream.lineEnd();
    }
}
function $0d13a7a6536781f5$var$link(array) {
    if (!(n = array.length)) return;
    var n, i = 0, a = array[0], b;
    while(++i < n){
        a.n = b = array[i];
        b.p = a;
        a = b;
    }
    a.n = b = array[0];
    b.p = a;
}



// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
class $20fab5183e47798b$export$bda7ba77fb86c375 {
    constructor(){
        this._partials = new Float64Array(32);
        this._n = 0;
    }
    add(x) {
        const p = this._partials;
        let i = 0;
        for(let j = 0; j < this._n && j < 32; j++){
            const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
            if (lo) p[i++] = lo;
            x = hi;
        }
        p[i] = x;
        this._n = i + 1;
        return this;
    }
    valueOf() {
        const p = this._partials;
        let n = this._n, x, y, lo, hi = 0;
        if (n > 0) {
            hi = p[--n];
            while(n > 0){
                x = hi;
                y = p[--n];
                hi = x + y;
                lo = y - (hi - x);
                if (lo) break;
            }
            if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                y = lo * 2;
                x = hi + y;
                if (y == x - hi) hi = x;
            }
        }
        return hi;
    }
}
function $20fab5183e47798b$export$61cb83f1a93e9fae(values, valueof) {
    const adder = new $20fab5183e47798b$export$bda7ba77fb86c375();
    if (valueof === undefined) {
        for (let value of values)if (value = +value) adder.add(value);
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
    }
    return +adder;
}
function $20fab5183e47798b$export$5a6391da70c130da(values, valueof) {
    const adder = new $20fab5183e47798b$export$bda7ba77fb86c375();
    let index = -1;
    return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
}



function $057546dd303bea92$export$12f9ad44fe773943(cartesian) {
    return [
        (0, $5014467dbc1df298$export$b8b770ee6a0d9760)(cartesian[1], cartesian[0]),
        (0, $5014467dbc1df298$export$41726bdb1fc63f)(cartesian[2])
    ];
}
function $057546dd303bea92$export$6e6697ef026a96(spherical) {
    var lambda = spherical[0], phi = spherical[1], cosPhi = (0, $5014467dbc1df298$export$50d414a77b60d802)(phi);
    return [
        cosPhi * (0, $5014467dbc1df298$export$50d414a77b60d802)(lambda),
        cosPhi * (0, $5014467dbc1df298$export$5de3937cb4b592ed)(lambda),
        (0, $5014467dbc1df298$export$5de3937cb4b592ed)(phi)
    ];
}
function $057546dd303bea92$export$2ef80f51436a9de9(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function $057546dd303bea92$export$4763f5351b14293f(a, b) {
    return [
        a[1] * b[2] - a[2] * b[1],
        a[2] * b[0] - a[0] * b[2],
        a[0] * b[1] - a[1] * b[0]
    ];
}
function $057546dd303bea92$export$e62eba72fc898eae(a, b) {
    a[0] += b[0], a[1] += b[1], a[2] += b[2];
}
function $057546dd303bea92$export$52d0ee3fc868d452(vector, k) {
    return [
        vector[0] * k,
        vector[1] * k,
        vector[2] * k
    ];
}
function $057546dd303bea92$export$6789498aec2cb34b(d) {
    var l = (0, $5014467dbc1df298$export$eba8049fb5020b81)(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
    d[0] /= l, d[1] /= l, d[2] /= l;
}



function $ccef3ffd90288fb6$var$longitude(point) {
    return (0, $5014467dbc1df298$export$2335f513bbd82c6d)(point[0]) <= (0, $5014467dbc1df298$export$18c7bea995a110f) ? point[0] : (0, $5014467dbc1df298$export$c5552dfdbc7cec71)(point[0]) * (((0, $5014467dbc1df298$export$2335f513bbd82c6d)(point[0]) + (0, $5014467dbc1df298$export$18c7bea995a110f)) % (0, $5014467dbc1df298$export$a4b4b4d4d776fe92) - (0, $5014467dbc1df298$export$18c7bea995a110f));
}
function $ccef3ffd90288fb6$export$2e2bcd8739ae039(polygon, point) {
    var lambda = $ccef3ffd90288fb6$var$longitude(point), phi = point[1], sinPhi = (0, $5014467dbc1df298$export$5de3937cb4b592ed)(phi), normal = [
        (0, $5014467dbc1df298$export$5de3937cb4b592ed)(lambda),
        -(0, $5014467dbc1df298$export$50d414a77b60d802)(lambda),
        0
    ], angle = 0, winding = 0;
    var sum = new (0, $20fab5183e47798b$export$bda7ba77fb86c375)();
    if (sinPhi === 1) phi = (0, $5014467dbc1df298$export$e51408a300e8929a) + (0, $5014467dbc1df298$export$6c421550c66a327d);
    else if (sinPhi === -1) phi = -(0, $5014467dbc1df298$export$e51408a300e8929a) - (0, $5014467dbc1df298$export$6c421550c66a327d);
    for(var i = 0, n = polygon.length; i < n; ++i){
        if (!(m = (ring = polygon[i]).length)) continue;
        var ring, m, point0 = ring[m - 1], lambda0 = $ccef3ffd90288fb6$var$longitude(point0), phi0 = point0[1] / 2 + (0, $5014467dbc1df298$export$c39a5cba78ea0fc2), sinPhi0 = (0, $5014467dbc1df298$export$5de3937cb4b592ed)(phi0), cosPhi0 = (0, $5014467dbc1df298$export$50d414a77b60d802)(phi0);
        for(var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1){
            var point1 = ring[j], lambda1 = $ccef3ffd90288fb6$var$longitude(point1), phi1 = point1[1] / 2 + (0, $5014467dbc1df298$export$c39a5cba78ea0fc2), sinPhi1 = (0, $5014467dbc1df298$export$5de3937cb4b592ed)(phi1), cosPhi1 = (0, $5014467dbc1df298$export$50d414a77b60d802)(phi1), delta = lambda1 - lambda0, sign = delta >= 0 ? 1 : -1, absDelta = sign * delta, antimeridian = absDelta > (0, $5014467dbc1df298$export$18c7bea995a110f), k = sinPhi0 * sinPhi1;
            sum.add((0, $5014467dbc1df298$export$b8b770ee6a0d9760)(k * sign * (0, $5014467dbc1df298$export$5de3937cb4b592ed)(absDelta), cosPhi0 * cosPhi1 + k * (0, $5014467dbc1df298$export$50d414a77b60d802)(absDelta)));
            angle += antimeridian ? delta + sign * (0, $5014467dbc1df298$export$a4b4b4d4d776fe92) : delta;
            // Are the longitudes either side of the point’s meridian (lambda),
            // and are the latitudes smaller than the parallel (phi)?
            if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
                var arc = (0, $057546dd303bea92$export$4763f5351b14293f)((0, $057546dd303bea92$export$6e6697ef026a96)(point0), (0, $057546dd303bea92$export$6e6697ef026a96)(point1));
                (0, $057546dd303bea92$export$6789498aec2cb34b)(arc);
                var intersection = (0, $057546dd303bea92$export$4763f5351b14293f)(normal, arc);
                (0, $057546dd303bea92$export$6789498aec2cb34b)(intersection);
                var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * (0, $5014467dbc1df298$export$41726bdb1fc63f)(intersection[2]);
                if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) winding += antimeridian ^ delta >= 0 ? 1 : -1;
            }
        }
    }
    // First, determine whether the South pole is inside or outside:
    //
    // It is inside if:
    // * the polygon winds around it in a clockwise direction.
    // * the polygon does not (cumulatively) wind around it, but has a negative
    //   (counter-clockwise) area.
    //
    // Second, count the (signed) number of times a segment crosses a lambda
    // from the point to the South pole.  If it is zero, then the point is the
    // same side as the South pole.
    return (angle < -(0, $5014467dbc1df298$export$6c421550c66a327d) || angle < (0, $5014467dbc1df298$export$6c421550c66a327d) && sum < -(0, $5014467dbc1df298$export$92c06fba281fe81b)) ^ winding & 1;
}


function* $464e62f73e13bbc1$var$flatten(arrays) {
    for (const array of arrays)yield* array;
}
function $464e62f73e13bbc1$export$2e2bcd8739ae039(arrays) {
    return Array.from($464e62f73e13bbc1$var$flatten(arrays));
}


function $75e66a1aed9b7472$export$2e2bcd8739ae039(pointVisible, clipLine, interpolate, start) {
    return function(sink) {
        var line = clipLine(sink), ringBuffer = (0, $bfbdb20a42788011$export$2e2bcd8739ae039)(), ringSink = clipLine(ringBuffer), polygonStarted = false, polygon, segments, ring;
        var clip = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: function() {
                clip.point = pointRing;
                clip.lineStart = ringStart;
                clip.lineEnd = ringEnd;
                segments = [];
                polygon = [];
            },
            polygonEnd: function() {
                clip.point = point;
                clip.lineStart = lineStart;
                clip.lineEnd = lineEnd;
                segments = (0, $464e62f73e13bbc1$export$2e2bcd8739ae039)(segments);
                var startInside = (0, $ccef3ffd90288fb6$export$2e2bcd8739ae039)(polygon, start);
                if (segments.length) {
                    if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                    (0, $0d13a7a6536781f5$export$2e2bcd8739ae039)(segments, $75e66a1aed9b7472$var$compareIntersection, startInside, interpolate, sink);
                } else if (startInside) {
                    if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                    sink.lineStart();
                    interpolate(null, null, 1, sink);
                    sink.lineEnd();
                }
                if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
                segments = polygon = null;
            },
            sphere: function() {
                sink.polygonStart();
                sink.lineStart();
                interpolate(null, null, 1, sink);
                sink.lineEnd();
                sink.polygonEnd();
            }
        };
        function point(lambda, phi) {
            if (pointVisible(lambda, phi)) sink.point(lambda, phi);
        }
        function pointLine(lambda, phi) {
            line.point(lambda, phi);
        }
        function lineStart() {
            clip.point = pointLine;
            line.lineStart();
        }
        function lineEnd() {
            clip.point = point;
            line.lineEnd();
        }
        function pointRing(lambda, phi) {
            ring.push([
                lambda,
                phi
            ]);
            ringSink.point(lambda, phi);
        }
        function ringStart() {
            ringSink.lineStart();
            ring = [];
        }
        function ringEnd() {
            pointRing(ring[0][0], ring[0][1]);
            ringSink.lineEnd();
            var clean = ringSink.clean(), ringSegments = ringBuffer.result(), i, n = ringSegments.length, m, segment, point;
            ring.pop();
            polygon.push(ring);
            ring = null;
            if (!n) return;
            // No intersections.
            if (clean & 1) {
                segment = ringSegments[0];
                if ((m = segment.length - 1) > 0) {
                    if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                    sink.lineStart();
                    for(i = 0; i < m; ++i)sink.point((point = segment[i])[0], point[1]);
                    sink.lineEnd();
                }
                return;
            }
            // Rejoin connected segments.
            // TODO reuse ringBuffer.rejoin()?
            if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
            segments.push(ringSegments.filter($75e66a1aed9b7472$var$validSegment));
        }
        return clip;
    };
}
function $75e66a1aed9b7472$var$validSegment(segment) {
    return segment.length > 1;
}
// Intersections are sorted along the clip edge. For both antimeridian cutting
// and circle clipping, the same comparison is used.
function $75e66a1aed9b7472$var$compareIntersection(a, b) {
    return ((a = a.x)[0] < 0 ? a[1] - (0, $5014467dbc1df298$export$e51408a300e8929a) - (0, $5014467dbc1df298$export$6c421550c66a327d) : (0, $5014467dbc1df298$export$e51408a300e8929a) - a[1]) - ((b = b.x)[0] < 0 ? b[1] - (0, $5014467dbc1df298$export$e51408a300e8929a) - (0, $5014467dbc1df298$export$6c421550c66a327d) : (0, $5014467dbc1df298$export$e51408a300e8929a) - b[1]);
}



var $5bdfb7fc1601d293$export$2e2bcd8739ae039 = (0, $75e66a1aed9b7472$export$2e2bcd8739ae039)(function() {
    return true;
}, $5bdfb7fc1601d293$var$clipAntimeridianLine, $5bdfb7fc1601d293$var$clipAntimeridianInterpolate, [
    -(0, $5014467dbc1df298$export$18c7bea995a110f),
    -(0, $5014467dbc1df298$export$e51408a300e8929a)
]);
// Takes a line and cuts into visible segments. Return values: 0 - there were
// intersections or the line was empty; 1 - no intersections; 2 - there were
// intersections, and the first and last segments should be rejoined.
function $5bdfb7fc1601d293$var$clipAntimeridianLine(stream) {
    var lambda0 = NaN, phi0 = NaN, sign0 = NaN, clean; // no intersections
    return {
        lineStart: function() {
            stream.lineStart();
            clean = 1;
        },
        point: function(lambda1, phi1) {
            var sign1 = lambda1 > 0 ? (0, $5014467dbc1df298$export$18c7bea995a110f) : -(0, $5014467dbc1df298$export$18c7bea995a110f), delta = (0, $5014467dbc1df298$export$2335f513bbd82c6d)(lambda1 - lambda0);
            if ((0, $5014467dbc1df298$export$2335f513bbd82c6d)(delta - (0, $5014467dbc1df298$export$18c7bea995a110f)) < (0, $5014467dbc1df298$export$6c421550c66a327d)) {
                stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? (0, $5014467dbc1df298$export$e51408a300e8929a) : -(0, $5014467dbc1df298$export$e51408a300e8929a));
                stream.point(sign0, phi0);
                stream.lineEnd();
                stream.lineStart();
                stream.point(sign1, phi0);
                stream.point(lambda1, phi0);
                clean = 0;
            } else if (sign0 !== sign1 && delta >= (0, $5014467dbc1df298$export$18c7bea995a110f)) {
                if ((0, $5014467dbc1df298$export$2335f513bbd82c6d)(lambda0 - sign0) < (0, $5014467dbc1df298$export$6c421550c66a327d)) lambda0 -= sign0 * (0, $5014467dbc1df298$export$6c421550c66a327d); // handle degeneracies
                if ((0, $5014467dbc1df298$export$2335f513bbd82c6d)(lambda1 - sign1) < (0, $5014467dbc1df298$export$6c421550c66a327d)) lambda1 -= sign1 * (0, $5014467dbc1df298$export$6c421550c66a327d);
                phi0 = $5bdfb7fc1601d293$var$clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
                stream.point(sign0, phi0);
                stream.lineEnd();
                stream.lineStart();
                stream.point(sign1, phi0);
                clean = 0;
            }
            stream.point(lambda0 = lambda1, phi0 = phi1);
            sign0 = sign1;
        },
        lineEnd: function() {
            stream.lineEnd();
            lambda0 = phi0 = NaN;
        },
        clean: function() {
            return 2 - clean; // if intersections, rejoin first and last segments
        }
    };
}
function $5bdfb7fc1601d293$var$clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
    var cosPhi0, cosPhi1, sinLambda0Lambda1 = (0, $5014467dbc1df298$export$5de3937cb4b592ed)(lambda0 - lambda1);
    return (0, $5014467dbc1df298$export$2335f513bbd82c6d)(sinLambda0Lambda1) > (0, $5014467dbc1df298$export$6c421550c66a327d) ? (0, $5014467dbc1df298$export$628dc4eed22b0fbd)(((0, $5014467dbc1df298$export$5de3937cb4b592ed)(phi0) * (cosPhi1 = (0, $5014467dbc1df298$export$50d414a77b60d802)(phi1)) * (0, $5014467dbc1df298$export$5de3937cb4b592ed)(lambda1) - (0, $5014467dbc1df298$export$5de3937cb4b592ed)(phi1) * (cosPhi0 = (0, $5014467dbc1df298$export$50d414a77b60d802)(phi0)) * (0, $5014467dbc1df298$export$5de3937cb4b592ed)(lambda0)) / (cosPhi0 * cosPhi1 * sinLambda0Lambda1)) : (phi0 + phi1) / 2;
}
function $5bdfb7fc1601d293$var$clipAntimeridianInterpolate(from, to, direction, stream) {
    var phi;
    if (from == null) {
        phi = direction * (0, $5014467dbc1df298$export$e51408a300e8929a);
        stream.point(-(0, $5014467dbc1df298$export$18c7bea995a110f), phi);
        stream.point(0, phi);
        stream.point((0, $5014467dbc1df298$export$18c7bea995a110f), phi);
        stream.point((0, $5014467dbc1df298$export$18c7bea995a110f), 0);
        stream.point((0, $5014467dbc1df298$export$18c7bea995a110f), -phi);
        stream.point(0, -phi);
        stream.point(-(0, $5014467dbc1df298$export$18c7bea995a110f), -phi);
        stream.point(-(0, $5014467dbc1df298$export$18c7bea995a110f), 0);
        stream.point(-(0, $5014467dbc1df298$export$18c7bea995a110f), phi);
    } else if ((0, $5014467dbc1df298$export$2335f513bbd82c6d)(from[0] - to[0]) > (0, $5014467dbc1df298$export$6c421550c66a327d)) {
        var lambda = from[0] < to[0] ? (0, $5014467dbc1df298$export$18c7bea995a110f) : -(0, $5014467dbc1df298$export$18c7bea995a110f);
        phi = direction * lambda / 2;
        stream.point(-lambda, phi);
        stream.point(0, phi);
        stream.point(lambda, phi);
    } else stream.point(to[0], to[1]);
}




function $e806eccfc141f2f8$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}



function $b0c84e7f90ec5100$export$2e2bcd8739ae039(a, b) {
    function compose(x, y) {
        return x = a(x, y), b(x[0], x[1]);
    }
    if (a.invert && b.invert) compose.invert = function(x, y) {
        return x = b.invert(x, y), x && a.invert(x[0], x[1]);
    };
    return compose;
}



function $e037517fdf565264$var$rotationIdentity(lambda, phi) {
    if ((0, $5014467dbc1df298$export$2335f513bbd82c6d)(lambda) > (0, $5014467dbc1df298$export$18c7bea995a110f)) lambda -= Math.round(lambda / (0, $5014467dbc1df298$export$a4b4b4d4d776fe92)) * (0, $5014467dbc1df298$export$a4b4b4d4d776fe92);
    return [
        lambda,
        phi
    ];
}
$e037517fdf565264$var$rotationIdentity.invert = $e037517fdf565264$var$rotationIdentity;
function $e037517fdf565264$export$a2ba89726971a90f(deltaLambda, deltaPhi, deltaGamma) {
    return (deltaLambda %= (0, $5014467dbc1df298$export$a4b4b4d4d776fe92)) ? deltaPhi || deltaGamma ? (0, $b0c84e7f90ec5100$export$2e2bcd8739ae039)($e037517fdf565264$var$rotationLambda(deltaLambda), $e037517fdf565264$var$rotationPhiGamma(deltaPhi, deltaGamma)) : $e037517fdf565264$var$rotationLambda(deltaLambda) : deltaPhi || deltaGamma ? $e037517fdf565264$var$rotationPhiGamma(deltaPhi, deltaGamma) : $e037517fdf565264$var$rotationIdentity;
}
function $e037517fdf565264$var$forwardRotationLambda(deltaLambda) {
    return function(lambda, phi) {
        lambda += deltaLambda;
        if ((0, $5014467dbc1df298$export$2335f513bbd82c6d)(lambda) > (0, $5014467dbc1df298$export$18c7bea995a110f)) lambda -= Math.round(lambda / (0, $5014467dbc1df298$export$a4b4b4d4d776fe92)) * (0, $5014467dbc1df298$export$a4b4b4d4d776fe92);
        return [
            lambda,
            phi
        ];
    };
}
function $e037517fdf565264$var$rotationLambda(deltaLambda) {
    var rotation = $e037517fdf565264$var$forwardRotationLambda(deltaLambda);
    rotation.invert = $e037517fdf565264$var$forwardRotationLambda(-deltaLambda);
    return rotation;
}
function $e037517fdf565264$var$rotationPhiGamma(deltaPhi, deltaGamma) {
    var cosDeltaPhi = (0, $5014467dbc1df298$export$50d414a77b60d802)(deltaPhi), sinDeltaPhi = (0, $5014467dbc1df298$export$5de3937cb4b592ed)(deltaPhi), cosDeltaGamma = (0, $5014467dbc1df298$export$50d414a77b60d802)(deltaGamma), sinDeltaGamma = (0, $5014467dbc1df298$export$5de3937cb4b592ed)(deltaGamma);
    function rotation(lambda, phi) {
        var cosPhi = (0, $5014467dbc1df298$export$50d414a77b60d802)(phi), x = (0, $5014467dbc1df298$export$50d414a77b60d802)(lambda) * cosPhi, y = (0, $5014467dbc1df298$export$5de3937cb4b592ed)(lambda) * cosPhi, z = (0, $5014467dbc1df298$export$5de3937cb4b592ed)(phi), k = z * cosDeltaPhi + x * sinDeltaPhi;
        return [
            (0, $5014467dbc1df298$export$b8b770ee6a0d9760)(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
            (0, $5014467dbc1df298$export$41726bdb1fc63f)(k * cosDeltaGamma + y * sinDeltaGamma)
        ];
    }
    rotation.invert = function(lambda, phi) {
        var cosPhi = (0, $5014467dbc1df298$export$50d414a77b60d802)(phi), x = (0, $5014467dbc1df298$export$50d414a77b60d802)(lambda) * cosPhi, y = (0, $5014467dbc1df298$export$5de3937cb4b592ed)(lambda) * cosPhi, z = (0, $5014467dbc1df298$export$5de3937cb4b592ed)(phi), k = z * cosDeltaGamma - y * sinDeltaGamma;
        return [
            (0, $5014467dbc1df298$export$b8b770ee6a0d9760)(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
            (0, $5014467dbc1df298$export$41726bdb1fc63f)(k * cosDeltaPhi - x * sinDeltaPhi)
        ];
    };
    return rotation;
}
function $e037517fdf565264$export$2e2bcd8739ae039(rotate) {
    rotate = $e037517fdf565264$export$a2ba89726971a90f(rotate[0] * (0, $5014467dbc1df298$export$8449e153fbd325fc), rotate[1] * (0, $5014467dbc1df298$export$8449e153fbd325fc), rotate.length > 2 ? rotate[2] * (0, $5014467dbc1df298$export$8449e153fbd325fc) : 0);
    function forward(coordinates) {
        coordinates = rotate(coordinates[0] * (0, $5014467dbc1df298$export$8449e153fbd325fc), coordinates[1] * (0, $5014467dbc1df298$export$8449e153fbd325fc));
        return coordinates[0] *= (0, $5014467dbc1df298$export$41fc368e1a942b97), coordinates[1] *= (0, $5014467dbc1df298$export$41fc368e1a942b97), coordinates;
    }
    forward.invert = function(coordinates) {
        coordinates = rotate.invert(coordinates[0] * (0, $5014467dbc1df298$export$8449e153fbd325fc), coordinates[1] * (0, $5014467dbc1df298$export$8449e153fbd325fc));
        return coordinates[0] *= (0, $5014467dbc1df298$export$41fc368e1a942b97), coordinates[1] *= (0, $5014467dbc1df298$export$41fc368e1a942b97), coordinates;
    };
    return forward;
}


function $509835772d31d358$export$b5441eb324cd8d4e(stream, radius, delta, direction, t0, t1) {
    if (!delta) return;
    var cosRadius = (0, $5014467dbc1df298$export$50d414a77b60d802)(radius), sinRadius = (0, $5014467dbc1df298$export$5de3937cb4b592ed)(radius), step = direction * delta;
    if (t0 == null) {
        t0 = radius + direction * (0, $5014467dbc1df298$export$a4b4b4d4d776fe92);
        t1 = radius - step / 2;
    } else {
        t0 = $509835772d31d358$var$circleRadius(cosRadius, t0);
        t1 = $509835772d31d358$var$circleRadius(cosRadius, t1);
        if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * (0, $5014467dbc1df298$export$a4b4b4d4d776fe92);
    }
    for(var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step){
        point = (0, $057546dd303bea92$export$12f9ad44fe773943)([
            cosRadius,
            -sinRadius * (0, $5014467dbc1df298$export$50d414a77b60d802)(t),
            -sinRadius * (0, $5014467dbc1df298$export$5de3937cb4b592ed)(t)
        ]);
        stream.point(point[0], point[1]);
    }
}
// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
function $509835772d31d358$var$circleRadius(cosRadius, point) {
    point = (0, $057546dd303bea92$export$6e6697ef026a96)(point), point[0] -= cosRadius;
    (0, $057546dd303bea92$export$6789498aec2cb34b)(point);
    var radius = (0, $5014467dbc1df298$export$fd6306be3fde5b04)(-point[1]);
    return ((-point[2] < 0 ? -radius : radius) + (0, $5014467dbc1df298$export$a4b4b4d4d776fe92) - (0, $5014467dbc1df298$export$6c421550c66a327d)) % (0, $5014467dbc1df298$export$a4b4b4d4d776fe92);
}
function $509835772d31d358$export$2e2bcd8739ae039() {
    var center = (0, $e806eccfc141f2f8$export$2e2bcd8739ae039)([
        0,
        0
    ]), radius = (0, $e806eccfc141f2f8$export$2e2bcd8739ae039)(90), precision = (0, $e806eccfc141f2f8$export$2e2bcd8739ae039)(6), ring, rotate, stream = {
        point: point
    };
    function point(x, y) {
        ring.push(x = rotate(x, y));
        x[0] *= (0, $5014467dbc1df298$export$41fc368e1a942b97), x[1] *= (0, $5014467dbc1df298$export$41fc368e1a942b97);
    }
    function circle() {
        var c = center.apply(this, arguments), r = radius.apply(this, arguments) * (0, $5014467dbc1df298$export$8449e153fbd325fc), p = precision.apply(this, arguments) * (0, $5014467dbc1df298$export$8449e153fbd325fc);
        ring = [];
        rotate = (0, $e037517fdf565264$export$a2ba89726971a90f)(-c[0] * (0, $5014467dbc1df298$export$8449e153fbd325fc), -c[1] * (0, $5014467dbc1df298$export$8449e153fbd325fc), 0).invert;
        $509835772d31d358$export$b5441eb324cd8d4e(stream, r, p, 1);
        c = {
            type: "Polygon",
            coordinates: [
                ring
            ]
        };
        ring = rotate = null;
        return c;
    }
    circle.center = function(_) {
        return arguments.length ? (center = typeof _ === "function" ? _ : (0, $e806eccfc141f2f8$export$2e2bcd8739ae039)([
            +_[0],
            +_[1]
        ]), circle) : center;
    };
    circle.radius = function(_) {
        return arguments.length ? (radius = typeof _ === "function" ? _ : (0, $e806eccfc141f2f8$export$2e2bcd8739ae039)(+_), circle) : radius;
    };
    circle.precision = function(_) {
        return arguments.length ? (precision = typeof _ === "function" ? _ : (0, $e806eccfc141f2f8$export$2e2bcd8739ae039)(+_), circle) : precision;
    };
    return circle;
}





function $8408006352d591a4$export$2e2bcd8739ae039(radius) {
    var cr = (0, $5014467dbc1df298$export$50d414a77b60d802)(radius), delta = 6 * (0, $5014467dbc1df298$export$8449e153fbd325fc), smallRadius = cr > 0, notHemisphere = (0, $5014467dbc1df298$export$2335f513bbd82c6d)(cr) > (0, $5014467dbc1df298$export$6c421550c66a327d); // TODO optimise for this common case
    function interpolate(from, to, direction, stream) {
        (0, $509835772d31d358$export$b5441eb324cd8d4e)(stream, radius, delta, direction, from, to);
    }
    function visible(lambda, phi) {
        return (0, $5014467dbc1df298$export$50d414a77b60d802)(lambda) * (0, $5014467dbc1df298$export$50d414a77b60d802)(phi) > cr;
    }
    // Takes a line and cuts into visible segments. Return values used for polygon
    // clipping: 0 - there were intersections or the line was empty; 1 - no
    // intersections 2 - there were intersections, and the first and last segments
    // should be rejoined.
    function clipLine(stream) {
        var point0, c0, v0, v00, clean; // no intersections
        return {
            lineStart: function() {
                v00 = v0 = false;
                clean = 1;
            },
            point: function(lambda, phi) {
                var point1 = [
                    lambda,
                    phi
                ], point2, v = visible(lambda, phi), c = smallRadius ? v ? 0 : code(lambda, phi) : v ? code(lambda + (lambda < 0 ? (0, $5014467dbc1df298$export$18c7bea995a110f) : -(0, $5014467dbc1df298$export$18c7bea995a110f)), phi) : 0;
                if (!point0 && (v00 = v0 = v)) stream.lineStart();
                if (v !== v0) {
                    point2 = intersect(point0, point1);
                    if (!point2 || (0, $85be1de058b1c064$export$2e2bcd8739ae039)(point0, point2) || (0, $85be1de058b1c064$export$2e2bcd8739ae039)(point1, point2)) point1[2] = 1;
                }
                if (v !== v0) {
                    clean = 0;
                    if (v) {
                        // outside going in
                        stream.lineStart();
                        point2 = intersect(point1, point0);
                        stream.point(point2[0], point2[1]);
                    } else {
                        // inside going out
                        point2 = intersect(point0, point1);
                        stream.point(point2[0], point2[1], 2);
                        stream.lineEnd();
                    }
                    point0 = point2;
                } else if (notHemisphere && point0 && smallRadius ^ v) {
                    var t;
                    // If the codes for two points are different, or are both zero,
                    // and there this segment intersects with the small circle.
                    if (!(c & c0) && (t = intersect(point1, point0, true))) {
                        clean = 0;
                        if (smallRadius) {
                            stream.lineStart();
                            stream.point(t[0][0], t[0][1]);
                            stream.point(t[1][0], t[1][1]);
                            stream.lineEnd();
                        } else {
                            stream.point(t[1][0], t[1][1]);
                            stream.lineEnd();
                            stream.lineStart();
                            stream.point(t[0][0], t[0][1], 3);
                        }
                    }
                }
                if (v && (!point0 || !(0, $85be1de058b1c064$export$2e2bcd8739ae039)(point0, point1))) stream.point(point1[0], point1[1]);
                point0 = point1, v0 = v, c0 = c;
            },
            lineEnd: function() {
                if (v0) stream.lineEnd();
                point0 = null;
            },
            // Rejoin first and last segments if there were intersections and the first
            // and last points were visible.
            clean: function() {
                return clean | (v00 && v0) << 1;
            }
        };
    }
    // Intersects the great circle between a and b with the clip circle.
    function intersect(a, b, two) {
        var pa = (0, $057546dd303bea92$export$6e6697ef026a96)(a), pb = (0, $057546dd303bea92$export$6e6697ef026a96)(b);
        // We have two planes, n1.p = d1 and n2.p = d2.
        // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
        var n1 = [
            1,
            0,
            0
        ], n2 = (0, $057546dd303bea92$export$4763f5351b14293f)(pa, pb), n2n2 = (0, $057546dd303bea92$export$2ef80f51436a9de9)(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
        // Two polar points.
        if (!determinant) return !two && a;
        var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = (0, $057546dd303bea92$export$4763f5351b14293f)(n1, n2), A = (0, $057546dd303bea92$export$52d0ee3fc868d452)(n1, c1), B = (0, $057546dd303bea92$export$52d0ee3fc868d452)(n2, c2);
        (0, $057546dd303bea92$export$e62eba72fc898eae)(A, B);
        // Solve |p(t)|^2 = 1.
        var u = n1xn2, w = (0, $057546dd303bea92$export$2ef80f51436a9de9)(A, u), uu = (0, $057546dd303bea92$export$2ef80f51436a9de9)(u, u), t2 = w * w - uu * ((0, $057546dd303bea92$export$2ef80f51436a9de9)(A, A) - 1);
        if (t2 < 0) return;
        var t = (0, $5014467dbc1df298$export$eba8049fb5020b81)(t2), q = (0, $057546dd303bea92$export$52d0ee3fc868d452)(u, (-w - t) / uu);
        (0, $057546dd303bea92$export$e62eba72fc898eae)(q, A);
        q = (0, $057546dd303bea92$export$12f9ad44fe773943)(q);
        if (!two) return q;
        // Two intersection points.
        var lambda0 = a[0], lambda1 = b[0], phi0 = a[1], phi1 = b[1], z;
        if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;
        var delta = lambda1 - lambda0, polar = (0, $5014467dbc1df298$export$2335f513bbd82c6d)(delta - (0, $5014467dbc1df298$export$18c7bea995a110f)) < (0, $5014467dbc1df298$export$6c421550c66a327d), meridian = polar || delta < (0, $5014467dbc1df298$export$6c421550c66a327d);
        if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;
        // Check that the first point is between a and b.
        if (meridian ? polar ? phi0 + phi1 > 0 ^ q[1] < ((0, $5014467dbc1df298$export$2335f513bbd82c6d)(q[0] - lambda0) < (0, $5014467dbc1df298$export$6c421550c66a327d) ? phi0 : phi1) : phi0 <= q[1] && q[1] <= phi1 : delta > (0, $5014467dbc1df298$export$18c7bea995a110f) ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
            var q1 = (0, $057546dd303bea92$export$52d0ee3fc868d452)(u, (-w + t) / uu);
            (0, $057546dd303bea92$export$e62eba72fc898eae)(q1, A);
            return [
                q,
                (0, $057546dd303bea92$export$12f9ad44fe773943)(q1)
            ];
        }
    }
    // Generates a 4-bit vector representing the location of a point relative to
    // the small circle's bounding box.
    function code(lambda, phi) {
        var r = smallRadius ? radius : (0, $5014467dbc1df298$export$18c7bea995a110f) - radius, code = 0;
        if (lambda < -r) code |= 1; // left
        else if (lambda > r) code |= 2; // right
        if (phi < -r) code |= 4; // below
        else if (phi > r) code |= 8; // above
        return code;
    }
    return (0, $75e66a1aed9b7472$export$2e2bcd8739ae039)(visible, clipLine, interpolate, smallRadius ? [
        0,
        -radius
    ] : [
        -(0, $5014467dbc1df298$export$18c7bea995a110f),
        radius - (0, $5014467dbc1df298$export$18c7bea995a110f)
    ]);
}




function $5d0a11426d7c1b33$export$2e2bcd8739ae039(a, b, x0, y0, x1, y1) {
    var ax = a[0], ay = a[1], bx = b[0], by = b[1], t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
    r = x0 - ax;
    if (!dx && r > 0) return;
    r /= dx;
    if (dx < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    } else if (dx > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    }
    r = x1 - ax;
    if (!dx && r < 0) return;
    r /= dx;
    if (dx < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    } else if (dx > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    }
    r = y0 - ay;
    if (!dy && r > 0) return;
    r /= dy;
    if (dy < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    } else if (dy > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    }
    r = y1 - ay;
    if (!dy && r < 0) return;
    r /= dy;
    if (dy < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    } else if (dy > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    }
    if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
    if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
    return true;
}




var $f71f9a3f5a654a7f$var$clipMax = 1e9, $f71f9a3f5a654a7f$var$clipMin = -$f71f9a3f5a654a7f$var$clipMax;
function $f71f9a3f5a654a7f$export$2e2bcd8739ae039(x0, y0, x1, y1) {
    function visible(x, y) {
        return x0 <= x && x <= x1 && y0 <= y && y <= y1;
    }
    function interpolate(from, to, direction, stream) {
        var a = 0, a1 = 0;
        if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoint(from, to) < 0 ^ direction > 0) do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
        while ((a = (a + direction + 4) % 4) !== a1);
        else stream.point(to[0], to[1]);
    }
    function corner(p, direction) {
        return (0, $5014467dbc1df298$export$2335f513bbd82c6d)(p[0] - x0) < (0, $5014467dbc1df298$export$6c421550c66a327d) ? direction > 0 ? 0 : 3 : (0, $5014467dbc1df298$export$2335f513bbd82c6d)(p[0] - x1) < (0, $5014467dbc1df298$export$6c421550c66a327d) ? direction > 0 ? 2 : 1 : (0, $5014467dbc1df298$export$2335f513bbd82c6d)(p[1] - y0) < (0, $5014467dbc1df298$export$6c421550c66a327d) ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
    }
    function compareIntersection(a, b) {
        return comparePoint(a.x, b.x);
    }
    function comparePoint(a, b) {
        var ca = corner(a, 1), cb = corner(b, 1);
        return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
    }
    return function(stream) {
        var activeStream = stream, bufferStream = (0, $bfbdb20a42788011$export$2e2bcd8739ae039)(), segments, polygon, ring, x__, y__, v__, x_, y_, v_, first, clean;
        var clipStream = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: polygonStart,
            polygonEnd: polygonEnd
        };
        function point(x, y) {
            if (visible(x, y)) activeStream.point(x, y);
        }
        function polygonInside() {
            var winding = 0;
            for(var i = 0, n = polygon.length; i < n; ++i)for(var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j){
                a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
                if (a1 <= y1) {
                    if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding;
                } else if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding;
            }
            return winding;
        }
        // Buffer geometry within a polygon and then clip it en masse.
        function polygonStart() {
            activeStream = bufferStream, segments = [], polygon = [], clean = true;
        }
        function polygonEnd() {
            var startInside = polygonInside(), cleanInside = clean && startInside, visible = (segments = (0, $464e62f73e13bbc1$export$2e2bcd8739ae039)(segments)).length;
            if (cleanInside || visible) {
                stream.polygonStart();
                if (cleanInside) {
                    stream.lineStart();
                    interpolate(null, null, 1, stream);
                    stream.lineEnd();
                }
                if (visible) (0, $0d13a7a6536781f5$export$2e2bcd8739ae039)(segments, compareIntersection, startInside, interpolate, stream);
                stream.polygonEnd();
            }
            activeStream = stream, segments = polygon = ring = null;
        }
        function lineStart() {
            clipStream.point = linePoint;
            if (polygon) polygon.push(ring = []);
            first = true;
            v_ = false;
            x_ = y_ = NaN;
        }
        // TODO rather than special-case polygons, simply handle them separately.
        // Ideally, coincident intersection points should be jittered to avoid
        // clipping issues.
        function lineEnd() {
            if (segments) {
                linePoint(x__, y__);
                if (v__ && v_) bufferStream.rejoin();
                segments.push(bufferStream.result());
            }
            clipStream.point = point;
            if (v_) activeStream.lineEnd();
        }
        function linePoint(x, y) {
            var v = visible(x, y);
            if (polygon) ring.push([
                x,
                y
            ]);
            if (first) {
                x__ = x, y__ = y, v__ = v;
                first = false;
                if (v) {
                    activeStream.lineStart();
                    activeStream.point(x, y);
                }
            } else if (v && v_) activeStream.point(x, y);
            else {
                var a = [
                    x_ = Math.max($f71f9a3f5a654a7f$var$clipMin, Math.min($f71f9a3f5a654a7f$var$clipMax, x_)),
                    y_ = Math.max($f71f9a3f5a654a7f$var$clipMin, Math.min($f71f9a3f5a654a7f$var$clipMax, y_))
                ], b = [
                    x = Math.max($f71f9a3f5a654a7f$var$clipMin, Math.min($f71f9a3f5a654a7f$var$clipMax, x)),
                    y = Math.max($f71f9a3f5a654a7f$var$clipMin, Math.min($f71f9a3f5a654a7f$var$clipMax, y))
                ];
                if ((0, $5d0a11426d7c1b33$export$2e2bcd8739ae039)(a, b, x0, y0, x1, y1)) {
                    if (!v_) {
                        activeStream.lineStart();
                        activeStream.point(a[0], a[1]);
                    }
                    activeStream.point(b[0], b[1]);
                    if (!v) activeStream.lineEnd();
                    clean = false;
                } else if (v) {
                    activeStream.lineStart();
                    activeStream.point(x, y);
                    clean = false;
                }
            }
            x_ = x, y_ = y, v_ = v;
        }
        return clipStream;
    };
}



var $9778824e69a6f802$export$2e2bcd8739ae039 = (x)=>x;




function $39d88b71380b02d5$export$2e2bcd8739ae039(methods) {
    return {
        stream: $39d88b71380b02d5$export$6b468dcfb64c653c(methods)
    };
}
function $39d88b71380b02d5$export$6b468dcfb64c653c(methods) {
    return function(stream) {
        var s = new $39d88b71380b02d5$var$TransformStream;
        for(var key in methods)s[key] = methods[key];
        s.stream = stream;
        return s;
    };
}
function $39d88b71380b02d5$var$TransformStream() {}
$39d88b71380b02d5$var$TransformStream.prototype = {
    constructor: $39d88b71380b02d5$var$TransformStream,
    point: function(x, y) {
        this.stream.point(x, y);
    },
    sphere: function() {
        this.stream.sphere();
    },
    lineStart: function() {
        this.stream.lineStart();
    },
    lineEnd: function() {
        this.stream.lineEnd();
    },
    polygonStart: function() {
        this.stream.polygonStart();
    },
    polygonEnd: function() {
        this.stream.polygonEnd();
    }
};


function $f8e7105390e68212$var$streamGeometry(geometry, stream) {
    if (geometry && $f8e7105390e68212$var$streamGeometryType.hasOwnProperty(geometry.type)) $f8e7105390e68212$var$streamGeometryType[geometry.type](geometry, stream);
}
var $f8e7105390e68212$var$streamObjectType = {
    Feature: function(object, stream) {
        $f8e7105390e68212$var$streamGeometry(object.geometry, stream);
    },
    FeatureCollection: function(object, stream) {
        var features = object.features, i = -1, n = features.length;
        while(++i < n)$f8e7105390e68212$var$streamGeometry(features[i].geometry, stream);
    }
};
var $f8e7105390e68212$var$streamGeometryType = {
    Sphere: function(object, stream) {
        stream.sphere();
    },
    Point: function(object, stream) {
        object = object.coordinates;
        stream.point(object[0], object[1], object[2]);
    },
    MultiPoint: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)object = coordinates[i], stream.point(object[0], object[1], object[2]);
    },
    LineString: function(object, stream) {
        $f8e7105390e68212$var$streamLine(object.coordinates, stream, 0);
    },
    MultiLineString: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)$f8e7105390e68212$var$streamLine(coordinates[i], stream, 0);
    },
    Polygon: function(object, stream) {
        $f8e7105390e68212$var$streamPolygon(object.coordinates, stream);
    },
    MultiPolygon: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)$f8e7105390e68212$var$streamPolygon(coordinates[i], stream);
    },
    GeometryCollection: function(object, stream) {
        var geometries = object.geometries, i = -1, n = geometries.length;
        while(++i < n)$f8e7105390e68212$var$streamGeometry(geometries[i], stream);
    }
};
function $f8e7105390e68212$var$streamLine(coordinates, stream, closed) {
    var i = -1, n = coordinates.length - closed, coordinate;
    stream.lineStart();
    while(++i < n)coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
    stream.lineEnd();
}
function $f8e7105390e68212$var$streamPolygon(coordinates, stream) {
    var i = -1, n = coordinates.length;
    stream.polygonStart();
    while(++i < n)$f8e7105390e68212$var$streamLine(coordinates[i], stream, 1);
    stream.polygonEnd();
}
function $f8e7105390e68212$export$2e2bcd8739ae039(object, stream) {
    if (object && $f8e7105390e68212$var$streamObjectType.hasOwnProperty(object.type)) $f8e7105390e68212$var$streamObjectType[object.type](object, stream);
    else $f8e7105390e68212$var$streamGeometry(object, stream);
}



var $3c50db2f346565b6$var$x0 = Infinity, $3c50db2f346565b6$var$y0 = $3c50db2f346565b6$var$x0, $3c50db2f346565b6$var$x1 = -$3c50db2f346565b6$var$x0, $3c50db2f346565b6$var$y1 = $3c50db2f346565b6$var$x1;
var $3c50db2f346565b6$var$boundsStream = {
    point: $3c50db2f346565b6$var$boundsPoint,
    lineStart: (0, $629d028a9279c5af$export$2e2bcd8739ae039),
    lineEnd: (0, $629d028a9279c5af$export$2e2bcd8739ae039),
    polygonStart: (0, $629d028a9279c5af$export$2e2bcd8739ae039),
    polygonEnd: (0, $629d028a9279c5af$export$2e2bcd8739ae039),
    result: function() {
        var bounds = [
            [
                $3c50db2f346565b6$var$x0,
                $3c50db2f346565b6$var$y0
            ],
            [
                $3c50db2f346565b6$var$x1,
                $3c50db2f346565b6$var$y1
            ]
        ];
        $3c50db2f346565b6$var$x1 = $3c50db2f346565b6$var$y1 = -($3c50db2f346565b6$var$y0 = $3c50db2f346565b6$var$x0 = Infinity);
        return bounds;
    }
};
function $3c50db2f346565b6$var$boundsPoint(x, y) {
    if (x < $3c50db2f346565b6$var$x0) $3c50db2f346565b6$var$x0 = x;
    if (x > $3c50db2f346565b6$var$x1) $3c50db2f346565b6$var$x1 = x;
    if (y < $3c50db2f346565b6$var$y0) $3c50db2f346565b6$var$y0 = y;
    if (y > $3c50db2f346565b6$var$y1) $3c50db2f346565b6$var$y1 = y;
}
var $3c50db2f346565b6$export$2e2bcd8739ae039 = $3c50db2f346565b6$var$boundsStream;


function $2986da8a0f2b701e$var$fit(projection, fitBounds, object) {
    var clip = projection.clipExtent && projection.clipExtent();
    projection.scale(150).translate([
        0,
        0
    ]);
    if (clip != null) projection.clipExtent(null);
    (0, $f8e7105390e68212$export$2e2bcd8739ae039)(object, projection.stream((0, $3c50db2f346565b6$export$2e2bcd8739ae039)));
    fitBounds((0, $3c50db2f346565b6$export$2e2bcd8739ae039).result());
    if (clip != null) projection.clipExtent(clip);
    return projection;
}
function $2986da8a0f2b701e$export$e450184041869e7f(projection, extent, object) {
    return $2986da8a0f2b701e$var$fit(projection, function(b) {
        var w = extent[1][0] - extent[0][0], h = extent[1][1] - extent[0][1], k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])), x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2, y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}
function $2986da8a0f2b701e$export$33a367fa1728c3ba(projection, size, object) {
    return $2986da8a0f2b701e$export$e450184041869e7f(projection, [
        [
            0,
            0
        ],
        size
    ], object);
}
function $2986da8a0f2b701e$export$7d8f2192ef31c5a7(projection, width, object) {
    return $2986da8a0f2b701e$var$fit(projection, function(b) {
        var w = +width, k = w / (b[1][0] - b[0][0]), x = (w - k * (b[1][0] + b[0][0])) / 2, y = -k * b[0][1];
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}
function $2986da8a0f2b701e$export$7069bab0d2ced675(projection, height, object) {
    return $2986da8a0f2b701e$var$fit(projection, function(b) {
        var h = +height, k = h / (b[1][1] - b[0][1]), x = -k * b[0][0], y = (h - k * (b[1][1] + b[0][1])) / 2;
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}





var $037ab6d9141cb00c$var$maxDepth = 16, $037ab6d9141cb00c$var$cosMinDistance = (0, $5014467dbc1df298$export$50d414a77b60d802)(30 * (0, $5014467dbc1df298$export$8449e153fbd325fc)); // cos(minimum angular distance)
function $037ab6d9141cb00c$export$2e2bcd8739ae039(project, delta2) {
    return +delta2 ? $037ab6d9141cb00c$var$resample(project, delta2) : $037ab6d9141cb00c$var$resampleNone(project);
}
function $037ab6d9141cb00c$var$resampleNone(project) {
    return (0, $39d88b71380b02d5$export$6b468dcfb64c653c)({
        point: function(x, y) {
            x = project(x, y);
            this.stream.point(x[0], x[1]);
        }
    });
}
function $037ab6d9141cb00c$var$resample(project, delta2) {
    function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
        var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
        if (d2 > 4 * delta2 && depth--) {
            var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = (0, $5014467dbc1df298$export$eba8049fb5020b81)(a * a + b * b + c * c), phi2 = (0, $5014467dbc1df298$export$41726bdb1fc63f)(c /= m), lambda2 = (0, $5014467dbc1df298$export$2335f513bbd82c6d)((0, $5014467dbc1df298$export$2335f513bbd82c6d)(c) - 1) < (0, $5014467dbc1df298$export$6c421550c66a327d) || (0, $5014467dbc1df298$export$2335f513bbd82c6d)(lambda0 - lambda1) < (0, $5014467dbc1df298$export$6c421550c66a327d) ? (lambda0 + lambda1) / 2 : (0, $5014467dbc1df298$export$b8b770ee6a0d9760)(b, a), p = project(lambda2, phi2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
            if (dz * dz / d2 > delta2 // perpendicular projected distance
             || (0, $5014467dbc1df298$export$2335f513bbd82c6d)((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
             || a0 * a1 + b0 * b1 + c0 * c1 < $037ab6d9141cb00c$var$cosMinDistance) {
                resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
                stream.point(x2, y2);
                resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
            }
        }
    }
    return function(stream) {
        var lambda00, x00, y00, a00, b00, c00, lambda0, x0, y0, a0, b0, c0; // previous point
        var resampleStream = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: function() {
                stream.polygonStart();
                resampleStream.lineStart = ringStart;
            },
            polygonEnd: function() {
                stream.polygonEnd();
                resampleStream.lineStart = lineStart;
            }
        };
        function point(x, y) {
            x = project(x, y);
            stream.point(x[0], x[1]);
        }
        function lineStart() {
            x0 = NaN;
            resampleStream.point = linePoint;
            stream.lineStart();
        }
        function linePoint(lambda, phi) {
            var c = (0, $057546dd303bea92$export$6e6697ef026a96)([
                lambda,
                phi
            ]), p = project(lambda, phi);
            resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], $037ab6d9141cb00c$var$maxDepth, stream);
            stream.point(x0, y0);
        }
        function lineEnd() {
            resampleStream.point = point;
            stream.lineEnd();
        }
        function ringStart() {
            lineStart();
            resampleStream.point = ringPoint;
            resampleStream.lineEnd = ringEnd;
        }
        function ringPoint(lambda, phi) {
            linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
            resampleStream.point = linePoint;
        }
        function ringEnd() {
            resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, $037ab6d9141cb00c$var$maxDepth, stream);
            resampleStream.lineEnd = lineEnd;
            lineEnd();
        }
        return resampleStream;
    };
}


var $62df487288d92943$var$transformRadians = (0, $39d88b71380b02d5$export$6b468dcfb64c653c)({
    point: function(x, y) {
        this.stream.point(x * (0, $5014467dbc1df298$export$8449e153fbd325fc), y * (0, $5014467dbc1df298$export$8449e153fbd325fc));
    }
});
function $62df487288d92943$var$transformRotate(rotate) {
    return (0, $39d88b71380b02d5$export$6b468dcfb64c653c)({
        point: function(x, y) {
            var r = rotate(x, y);
            return this.stream.point(r[0], r[1]);
        }
    });
}
function $62df487288d92943$var$scaleTranslate(k, dx, dy, sx, sy) {
    function transform(x, y) {
        x *= sx;
        y *= sy;
        return [
            dx + k * x,
            dy - k * y
        ];
    }
    transform.invert = function(x, y) {
        return [
            (x - dx) / k * sx,
            (dy - y) / k * sy
        ];
    };
    return transform;
}
function $62df487288d92943$var$scaleTranslateRotate(k, dx, dy, sx, sy, alpha) {
    if (!alpha) return $62df487288d92943$var$scaleTranslate(k, dx, dy, sx, sy);
    var cosAlpha = (0, $5014467dbc1df298$export$50d414a77b60d802)(alpha), sinAlpha = (0, $5014467dbc1df298$export$5de3937cb4b592ed)(alpha), a = cosAlpha * k, b = sinAlpha * k, ai = cosAlpha / k, bi = sinAlpha / k, ci = (sinAlpha * dy - cosAlpha * dx) / k, fi = (sinAlpha * dx + cosAlpha * dy) / k;
    function transform(x, y) {
        x *= sx;
        y *= sy;
        return [
            a * x - b * y + dx,
            dy - b * x - a * y
        ];
    }
    transform.invert = function(x, y) {
        return [
            sx * (ai * x - bi * y + ci),
            sy * (fi - bi * x - ai * y)
        ];
    };
    return transform;
}
function $62df487288d92943$export$2e2bcd8739ae039(project) {
    return $62df487288d92943$export$155d5a6fa6fddeba(function() {
        return project;
    })();
}
function $62df487288d92943$export$155d5a6fa6fddeba(projectAt) {
    var project, k = 150, x = 480, y = 250, lambda = 0, phi = 0, deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, alpha = 0, sx = 1, sy = 1, theta = null, preclip = (0, $5bdfb7fc1601d293$export$2e2bcd8739ae039), x0 = null, y0, x1, y1, postclip = (0, $9778824e69a6f802$export$2e2bcd8739ae039), delta2 = 0.5, projectResample, projectTransform, projectRotateTransform, cache, cacheStream;
    function projection(point) {
        return projectRotateTransform(point[0] * (0, $5014467dbc1df298$export$8449e153fbd325fc), point[1] * (0, $5014467dbc1df298$export$8449e153fbd325fc));
    }
    function invert(point) {
        point = projectRotateTransform.invert(point[0], point[1]);
        return point && [
            point[0] * (0, $5014467dbc1df298$export$41fc368e1a942b97),
            point[1] * (0, $5014467dbc1df298$export$41fc368e1a942b97)
        ];
    }
    projection.stream = function(stream) {
        return cache && cacheStream === stream ? cache : cache = $62df487288d92943$var$transformRadians($62df487288d92943$var$transformRotate(rotate)(preclip(projectResample(postclip(cacheStream = stream)))));
    };
    projection.preclip = function(_) {
        return arguments.length ? (preclip = _, theta = undefined, reset()) : preclip;
    };
    projection.postclip = function(_) {
        return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
    };
    projection.clipAngle = function(_) {
        return arguments.length ? (preclip = +_ ? (0, $8408006352d591a4$export$2e2bcd8739ae039)(theta = _ * (0, $5014467dbc1df298$export$8449e153fbd325fc)) : (theta = null, $5bdfb7fc1601d293$export$2e2bcd8739ae039), reset()) : theta * (0, $5014467dbc1df298$export$41fc368e1a942b97);
    };
    projection.clipExtent = function(_) {
        return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, $9778824e69a6f802$export$2e2bcd8739ae039) : (0, $f71f9a3f5a654a7f$export$2e2bcd8739ae039)(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    projection.scale = function(_) {
        return arguments.length ? (k = +_, recenter()) : k;
    };
    projection.translate = function(_) {
        return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [
            x,
            y
        ];
    };
    projection.center = function(_) {
        return arguments.length ? (lambda = _[0] % 360 * (0, $5014467dbc1df298$export$8449e153fbd325fc), phi = _[1] % 360 * (0, $5014467dbc1df298$export$8449e153fbd325fc), recenter()) : [
            lambda * (0, $5014467dbc1df298$export$41fc368e1a942b97),
            phi * (0, $5014467dbc1df298$export$41fc368e1a942b97)
        ];
    };
    projection.rotate = function(_) {
        return arguments.length ? (deltaLambda = _[0] % 360 * (0, $5014467dbc1df298$export$8449e153fbd325fc), deltaPhi = _[1] % 360 * (0, $5014467dbc1df298$export$8449e153fbd325fc), deltaGamma = _.length > 2 ? _[2] % 360 * (0, $5014467dbc1df298$export$8449e153fbd325fc) : 0, recenter()) : [
            deltaLambda * (0, $5014467dbc1df298$export$41fc368e1a942b97),
            deltaPhi * (0, $5014467dbc1df298$export$41fc368e1a942b97),
            deltaGamma * (0, $5014467dbc1df298$export$41fc368e1a942b97)
        ];
    };
    projection.angle = function(_) {
        return arguments.length ? (alpha = _ % 360 * (0, $5014467dbc1df298$export$8449e153fbd325fc), recenter()) : alpha * (0, $5014467dbc1df298$export$41fc368e1a942b97);
    };
    projection.reflectX = function(_) {
        return arguments.length ? (sx = _ ? -1 : 1, recenter()) : sx < 0;
    };
    projection.reflectY = function(_) {
        return arguments.length ? (sy = _ ? -1 : 1, recenter()) : sy < 0;
    };
    projection.precision = function(_) {
        return arguments.length ? (projectResample = (0, $037ab6d9141cb00c$export$2e2bcd8739ae039)(projectTransform, delta2 = _ * _), reset()) : (0, $5014467dbc1df298$export$eba8049fb5020b81)(delta2);
    };
    projection.fitExtent = function(extent, object) {
        return (0, $2986da8a0f2b701e$export$e450184041869e7f)(projection, extent, object);
    };
    projection.fitSize = function(size, object) {
        return (0, $2986da8a0f2b701e$export$33a367fa1728c3ba)(projection, size, object);
    };
    projection.fitWidth = function(width, object) {
        return (0, $2986da8a0f2b701e$export$7d8f2192ef31c5a7)(projection, width, object);
    };
    projection.fitHeight = function(height, object) {
        return (0, $2986da8a0f2b701e$export$7069bab0d2ced675)(projection, height, object);
    };
    function recenter() {
        var center = $62df487288d92943$var$scaleTranslateRotate(k, 0, 0, sx, sy, alpha).apply(null, project(lambda, phi)), transform = $62df487288d92943$var$scaleTranslateRotate(k, x - center[0], y - center[1], sx, sy, alpha);
        rotate = (0, $e037517fdf565264$export$a2ba89726971a90f)(deltaLambda, deltaPhi, deltaGamma);
        projectTransform = (0, $b0c84e7f90ec5100$export$2e2bcd8739ae039)(project, transform);
        projectRotateTransform = (0, $b0c84e7f90ec5100$export$2e2bcd8739ae039)(rotate, projectTransform);
        projectResample = (0, $037ab6d9141cb00c$export$2e2bcd8739ae039)(projectTransform, delta2);
        return reset();
    }
    function reset() {
        cache = cacheStream = null;
        return projection;
    }
    return function() {
        project = projectAt.apply(this, arguments);
        projection.invert = project.invert && invert;
        return recenter();
    };
}


function $fabbe9c216275504$export$228272587c4d24d8(projectAt) {
    var phi0 = 0, phi1 = (0, $5014467dbc1df298$export$18c7bea995a110f) / 3, m = (0, $62df487288d92943$export$155d5a6fa6fddeba)(projectAt), p = m(phi0, phi1);
    p.parallels = function(_) {
        return arguments.length ? m(phi0 = _[0] * (0, $5014467dbc1df298$export$8449e153fbd325fc), phi1 = _[1] * (0, $5014467dbc1df298$export$8449e153fbd325fc)) : [
            phi0 * (0, $5014467dbc1df298$export$41fc368e1a942b97),
            phi1 * (0, $5014467dbc1df298$export$41fc368e1a942b97)
        ];
    };
    return p;
}



function $c773a23001a96151$export$ae68c6db8b65046a(phi0) {
    var cosPhi0 = (0, $5014467dbc1df298$export$50d414a77b60d802)(phi0);
    function forward(lambda, phi) {
        return [
            lambda * cosPhi0,
            (0, $5014467dbc1df298$export$5de3937cb4b592ed)(phi) / cosPhi0
        ];
    }
    forward.invert = function(x, y) {
        return [
            x / cosPhi0,
            (0, $5014467dbc1df298$export$41726bdb1fc63f)(y * cosPhi0)
        ];
    };
    return forward;
}


function $20597787d7efceb9$export$75409dad1c406288(y0, y1) {
    var sy0 = (0, $5014467dbc1df298$export$5de3937cb4b592ed)(y0), n = (sy0 + (0, $5014467dbc1df298$export$5de3937cb4b592ed)(y1)) / 2;
    // Are the parallels symmetrical around the Equator?
    if ((0, $5014467dbc1df298$export$2335f513bbd82c6d)(n) < (0, $5014467dbc1df298$export$6c421550c66a327d)) return (0, $c773a23001a96151$export$ae68c6db8b65046a)(y0);
    var c = 1 + sy0 * (2 * n - sy0), r0 = (0, $5014467dbc1df298$export$eba8049fb5020b81)(c) / n;
    function project(x, y) {
        var r = (0, $5014467dbc1df298$export$eba8049fb5020b81)(c - 2 * n * (0, $5014467dbc1df298$export$5de3937cb4b592ed)(y)) / n;
        return [
            r * (0, $5014467dbc1df298$export$5de3937cb4b592ed)(x *= n),
            r0 - r * (0, $5014467dbc1df298$export$50d414a77b60d802)(x)
        ];
    }
    project.invert = function(x, y) {
        var r0y = r0 - y, l = (0, $5014467dbc1df298$export$b8b770ee6a0d9760)(x, (0, $5014467dbc1df298$export$2335f513bbd82c6d)(r0y)) * (0, $5014467dbc1df298$export$c5552dfdbc7cec71)(r0y);
        if (r0y * n < 0) l -= (0, $5014467dbc1df298$export$18c7bea995a110f) * (0, $5014467dbc1df298$export$c5552dfdbc7cec71)(x) * (0, $5014467dbc1df298$export$c5552dfdbc7cec71)(r0y);
        return [
            l / n,
            (0, $5014467dbc1df298$export$41726bdb1fc63f)((c - (x * x + r0y * r0y) * n * n) / (2 * n))
        ];
    };
    return project;
}
function $20597787d7efceb9$export$2e2bcd8739ae039() {
    return (0, $fabbe9c216275504$export$228272587c4d24d8)($20597787d7efceb9$export$75409dad1c406288).scale(155.424).center([
        0,
        33.6442
    ]);
}


function $44584b08a6447cdd$export$2e2bcd8739ae039() {
    return (0, $20597787d7efceb9$export$2e2bcd8739ae039)().parallels([
        29.5,
        45.5
    ]).scale(1070).translate([
        480,
        250
    ]).rotate([
        96,
        0
    ]).center([
        -0.6,
        38.7
    ]);
}





// The projections must have mutually exclusive clip regions on the sphere,
// as this will avoid emitting interleaving lines and polygons.
function $9d8e7d8286335c53$var$multiplex(streams) {
    var n = streams.length;
    return {
        point: function(x, y) {
            var i = -1;
            while(++i < n)streams[i].point(x, y);
        },
        sphere: function() {
            var i = -1;
            while(++i < n)streams[i].sphere();
        },
        lineStart: function() {
            var i = -1;
            while(++i < n)streams[i].lineStart();
        },
        lineEnd: function() {
            var i = -1;
            while(++i < n)streams[i].lineEnd();
        },
        polygonStart: function() {
            var i = -1;
            while(++i < n)streams[i].polygonStart();
        },
        polygonEnd: function() {
            var i = -1;
            while(++i < n)streams[i].polygonEnd();
        }
    };
}
function $9d8e7d8286335c53$export$2e2bcd8739ae039() {
    var cache, cacheStream, lower48 = (0, $44584b08a6447cdd$export$2e2bcd8739ae039)(), lower48Point, alaska = (0, $20597787d7efceb9$export$2e2bcd8739ae039)().rotate([
        154,
        0
    ]).center([
        -2,
        58.5
    ]).parallels([
        55,
        65
    ]), alaskaPoint, hawaii = (0, $20597787d7efceb9$export$2e2bcd8739ae039)().rotate([
        157,
        0
    ]).center([
        -3,
        19.9
    ]).parallels([
        8,
        18
    ]), hawaiiPoint, point, pointStream = {
        point: function(x, y) {
            point = [
                x,
                y
            ];
        }
    };
    function albersUsa(coordinates) {
        var x = coordinates[0], y = coordinates[1];
        return point = null, (lower48Point.point(x, y), point) || (alaskaPoint.point(x, y), point) || (hawaiiPoint.point(x, y), point);
    }
    albersUsa.invert = function(coordinates) {
        var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
        return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii : lower48).invert(coordinates);
    };
    albersUsa.stream = function(stream) {
        return cache && cacheStream === stream ? cache : cache = $9d8e7d8286335c53$var$multiplex([
            lower48.stream(cacheStream = stream),
            alaska.stream(stream),
            hawaii.stream(stream)
        ]);
    };
    albersUsa.precision = function(_) {
        if (!arguments.length) return lower48.precision();
        lower48.precision(_), alaska.precision(_), hawaii.precision(_);
        return reset();
    };
    albersUsa.scale = function(_) {
        if (!arguments.length) return lower48.scale();
        lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
        return albersUsa.translate(lower48.translate());
    };
    albersUsa.translate = function(_) {
        if (!arguments.length) return lower48.translate();
        var k = lower48.scale(), x = +_[0], y = +_[1];
        lower48Point = lower48.translate(_).clipExtent([
            [
                x - 0.455 * k,
                y - 0.238 * k
            ],
            [
                x + 0.455 * k,
                y + 0.238 * k
            ]
        ]).stream(pointStream);
        alaskaPoint = alaska.translate([
            x - 0.307 * k,
            y + 0.201 * k
        ]).clipExtent([
            [
                x - 0.425 * k + (0, $5014467dbc1df298$export$6c421550c66a327d),
                y + 0.120 * k + (0, $5014467dbc1df298$export$6c421550c66a327d)
            ],
            [
                x - 0.214 * k - (0, $5014467dbc1df298$export$6c421550c66a327d),
                y + 0.234 * k - (0, $5014467dbc1df298$export$6c421550c66a327d)
            ]
        ]).stream(pointStream);
        hawaiiPoint = hawaii.translate([
            x - 0.205 * k,
            y + 0.212 * k
        ]).clipExtent([
            [
                x - 0.214 * k + (0, $5014467dbc1df298$export$6c421550c66a327d),
                y + 0.166 * k + (0, $5014467dbc1df298$export$6c421550c66a327d)
            ],
            [
                x - 0.115 * k - (0, $5014467dbc1df298$export$6c421550c66a327d),
                y + 0.234 * k - (0, $5014467dbc1df298$export$6c421550c66a327d)
            ]
        ]).stream(pointStream);
        return reset();
    };
    albersUsa.fitExtent = function(extent, object) {
        return (0, $2986da8a0f2b701e$export$e450184041869e7f)(albersUsa, extent, object);
    };
    albersUsa.fitSize = function(size, object) {
        return (0, $2986da8a0f2b701e$export$33a367fa1728c3ba)(albersUsa, size, object);
    };
    albersUsa.fitWidth = function(width, object) {
        return (0, $2986da8a0f2b701e$export$7d8f2192ef31c5a7)(albersUsa, width, object);
    };
    albersUsa.fitHeight = function(height, object) {
        return (0, $2986da8a0f2b701e$export$7069bab0d2ced675)(albersUsa, height, object);
    };
    function reset() {
        cache = cacheStream = null;
        return albersUsa;
    }
    return albersUsa.scale(1070);
}



var $234afe9128c63e18$var$A1 = 1.340264, $234afe9128c63e18$var$A2 = -0.081106, $234afe9128c63e18$var$A3 = 0.000893, $234afe9128c63e18$var$A4 = 0.003796, $234afe9128c63e18$var$M = (0, $5014467dbc1df298$export$eba8049fb5020b81)(3) / 2, $234afe9128c63e18$var$iterations = 12;
function $234afe9128c63e18$export$a320734067e7a731(lambda, phi) {
    var l = (0, $5014467dbc1df298$export$41726bdb1fc63f)($234afe9128c63e18$var$M * (0, $5014467dbc1df298$export$5de3937cb4b592ed)(phi)), l2 = l * l, l6 = l2 * l2 * l2;
    return [
        lambda * (0, $5014467dbc1df298$export$50d414a77b60d802)(l) / ($234afe9128c63e18$var$M * ($234afe9128c63e18$var$A1 + 3 * $234afe9128c63e18$var$A2 * l2 + l6 * (7 * $234afe9128c63e18$var$A3 + 9 * $234afe9128c63e18$var$A4 * l2))),
        l * ($234afe9128c63e18$var$A1 + $234afe9128c63e18$var$A2 * l2 + l6 * ($234afe9128c63e18$var$A3 + $234afe9128c63e18$var$A4 * l2))
    ];
}
$234afe9128c63e18$export$a320734067e7a731.invert = function(x, y) {
    var l = y, l2 = l * l, l6 = l2 * l2 * l2;
    for(var i = 0, delta, fy, fpy; i < $234afe9128c63e18$var$iterations; ++i){
        fy = l * ($234afe9128c63e18$var$A1 + $234afe9128c63e18$var$A2 * l2 + l6 * ($234afe9128c63e18$var$A3 + $234afe9128c63e18$var$A4 * l2)) - y;
        fpy = $234afe9128c63e18$var$A1 + 3 * $234afe9128c63e18$var$A2 * l2 + l6 * (7 * $234afe9128c63e18$var$A3 + 9 * $234afe9128c63e18$var$A4 * l2);
        l -= delta = fy / fpy, l2 = l * l, l6 = l2 * l2 * l2;
        if ((0, $5014467dbc1df298$export$2335f513bbd82c6d)(delta) < (0, $5014467dbc1df298$export$92c06fba281fe81b)) break;
    }
    return [
        $234afe9128c63e18$var$M * x * ($234afe9128c63e18$var$A1 + 3 * $234afe9128c63e18$var$A2 * l2 + l6 * (7 * $234afe9128c63e18$var$A3 + 9 * $234afe9128c63e18$var$A4 * l2)) / (0, $5014467dbc1df298$export$50d414a77b60d802)(l),
        (0, $5014467dbc1df298$export$41726bdb1fc63f)((0, $5014467dbc1df298$export$5de3937cb4b592ed)(l) / $234afe9128c63e18$var$M)
    ];
};
function $234afe9128c63e18$export$2e2bcd8739ae039() {
    return (0, $62df487288d92943$export$2e2bcd8739ae039)($234afe9128c63e18$export$a320734067e7a731).scale(177.158);
}

function $7c985a3d07f0c273$export$2e2bcd8739ae039(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}



function $25f1420916e3b1e4$var$graticuleX(y0, y1, dy) {
    var y = (0, $7c985a3d07f0c273$export$2e2bcd8739ae039)(y0, y1 - (0, $5014467dbc1df298$export$6c421550c66a327d), dy).concat(y1);
    return function(x) {
        return y.map(function(y) {
            return [
                x,
                y
            ];
        });
    };
}
function $25f1420916e3b1e4$var$graticuleY(x0, x1, dx) {
    var x = (0, $7c985a3d07f0c273$export$2e2bcd8739ae039)(x0, x1 - (0, $5014467dbc1df298$export$6c421550c66a327d), dx).concat(x1);
    return function(y) {
        return x.map(function(x) {
            return [
                x,
                y
            ];
        });
    };
}
function $25f1420916e3b1e4$export$2e2bcd8739ae039() {
    var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
    function graticule() {
        return {
            type: "MultiLineString",
            coordinates: lines()
        };
    }
    function lines() {
        return (0, $7c985a3d07f0c273$export$2e2bcd8739ae039)((0, $5014467dbc1df298$export$803ce6b71a0a94b2)(X0 / DX) * DX, X1, DX).map(X).concat((0, $7c985a3d07f0c273$export$2e2bcd8739ae039)((0, $5014467dbc1df298$export$803ce6b71a0a94b2)(Y0 / DY) * DY, Y1, DY).map(Y)).concat((0, $7c985a3d07f0c273$export$2e2bcd8739ae039)((0, $5014467dbc1df298$export$803ce6b71a0a94b2)(x0 / dx) * dx, x1, dx).filter(function(x) {
            return (0, $5014467dbc1df298$export$2335f513bbd82c6d)(x % DX) > (0, $5014467dbc1df298$export$6c421550c66a327d);
        }).map(x)).concat((0, $7c985a3d07f0c273$export$2e2bcd8739ae039)((0, $5014467dbc1df298$export$803ce6b71a0a94b2)(y0 / dy) * dy, y1, dy).filter(function(y) {
            return (0, $5014467dbc1df298$export$2335f513bbd82c6d)(y % DY) > (0, $5014467dbc1df298$export$6c421550c66a327d);
        }).map(y));
    }
    graticule.lines = function() {
        return lines().map(function(coordinates) {
            return {
                type: "LineString",
                coordinates: coordinates
            };
        });
    };
    graticule.outline = function() {
        return {
            type: "Polygon",
            coordinates: [
                X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1))
            ]
        };
    };
    graticule.extent = function(_) {
        if (!arguments.length) return graticule.extentMinor();
        return graticule.extentMajor(_).extentMinor(_);
    };
    graticule.extentMajor = function(_) {
        if (!arguments.length) return [
            [
                X0,
                Y0
            ],
            [
                X1,
                Y1
            ]
        ];
        X0 = +_[0][0], X1 = +_[1][0];
        Y0 = +_[0][1], Y1 = +_[1][1];
        if (X0 > X1) _ = X0, X0 = X1, X1 = _;
        if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
        return graticule.precision(precision);
    };
    graticule.extentMinor = function(_) {
        if (!arguments.length) return [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
        x0 = +_[0][0], x1 = +_[1][0];
        y0 = +_[0][1], y1 = +_[1][1];
        if (x0 > x1) _ = x0, x0 = x1, x1 = _;
        if (y0 > y1) _ = y0, y0 = y1, y1 = _;
        return graticule.precision(precision);
    };
    graticule.step = function(_) {
        if (!arguments.length) return graticule.stepMinor();
        return graticule.stepMajor(_).stepMinor(_);
    };
    graticule.stepMajor = function(_) {
        if (!arguments.length) return [
            DX,
            DY
        ];
        DX = +_[0], DY = +_[1];
        return graticule;
    };
    graticule.stepMinor = function(_) {
        if (!arguments.length) return [
            dx,
            dy
        ];
        dx = +_[0], dy = +_[1];
        return graticule;
    };
    graticule.precision = function(_) {
        if (!arguments.length) return precision;
        precision = +_;
        x = $25f1420916e3b1e4$var$graticuleX(y0, y1, 90);
        y = $25f1420916e3b1e4$var$graticuleY(x0, x1, precision);
        X = $25f1420916e3b1e4$var$graticuleX(Y0, Y1, 90);
        Y = $25f1420916e3b1e4$var$graticuleY(X0, X1, precision);
        return graticule;
    };
    return graticule.extentMajor([
        [
            -180,
            -90 + (0, $5014467dbc1df298$export$6c421550c66a327d)
        ],
        [
            180,
            90 - (0, $5014467dbc1df298$export$6c421550c66a327d)
        ]
    ]).extentMinor([
        [
            -180,
            -80 - (0, $5014467dbc1df298$export$6c421550c66a327d)
        ],
        [
            180,
            80 + (0, $5014467dbc1df298$export$6c421550c66a327d)
        ]
    ]);
}
function $25f1420916e3b1e4$export$b8db4e9403a5b6f1() {
    return $25f1420916e3b1e4$export$2e2bcd8739ae039()();
}




function $1c9fe90bb6f8cb90$export$94ff8a57e9b91cc3(lambda, phi) {
    return [
        lambda,
        (0, $5014467dbc1df298$export$bef1f36f5486a6a3)((0, $5014467dbc1df298$export$fcdd3b0b3246a325)(((0, $5014467dbc1df298$export$e51408a300e8929a) + phi) / 2))
    ];
}
$1c9fe90bb6f8cb90$export$94ff8a57e9b91cc3.invert = function(x, y) {
    return [
        x,
        2 * (0, $5014467dbc1df298$export$628dc4eed22b0fbd)((0, $5014467dbc1df298$export$b310ec824aaee37f)(y)) - (0, $5014467dbc1df298$export$e51408a300e8929a)
    ];
};
function $1c9fe90bb6f8cb90$export$2e2bcd8739ae039() {
    return $1c9fe90bb6f8cb90$export$44b9b66a01f2127b($1c9fe90bb6f8cb90$export$94ff8a57e9b91cc3).scale(961 / (0, $5014467dbc1df298$export$a4b4b4d4d776fe92));
}
function $1c9fe90bb6f8cb90$export$44b9b66a01f2127b(project) {
    var m = (0, $62df487288d92943$export$2e2bcd8739ae039)(project), center = m.center, scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, x0 = null, y0, x1, y1; // clip extent
    m.scale = function(_) {
        return arguments.length ? (scale(_), reclip()) : scale();
    };
    m.translate = function(_) {
        return arguments.length ? (translate(_), reclip()) : translate();
    };
    m.center = function(_) {
        return arguments.length ? (center(_), reclip()) : center();
    };
    m.clipExtent = function(_) {
        return arguments.length ? (_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reclip()) : x0 == null ? null : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    function reclip() {
        var k = (0, $5014467dbc1df298$export$18c7bea995a110f) * scale(), t = m((0, $e037517fdf565264$export$2e2bcd8739ae039)(m.rotate()).invert([
            0,
            0
        ]));
        return clipExtent(x0 == null ? [
            [
                t[0] - k,
                t[1] - k
            ],
            [
                t[0] + k,
                t[1] + k
            ]
        ] : project === $1c9fe90bb6f8cb90$export$94ff8a57e9b91cc3 ? [
            [
                Math.max(t[0] - k, x0),
                y0
            ],
            [
                Math.min(t[0] + k, x1),
                y1
            ]
        ] : [
            [
                x0,
                Math.max(t[1] - k, y0)
            ],
            [
                x1,
                Math.min(t[1] + k, y1)
            ]
        ]);
    }
    return reclip();
}



function $cf706c6b835c6c13$export$acb6def22fe878e6(lambda, phi) {
    var phi2 = phi * phi, phi4 = phi2 * phi2;
    return [
        lambda * (0.8707 - 0.131979 * phi2 + phi4 * (-0.013791 + phi4 * (0.003971 * phi2 - 0.001529 * phi4))),
        phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4)))
    ];
}
$cf706c6b835c6c13$export$acb6def22fe878e6.invert = function(x, y) {
    var phi = y, i = 25, delta;
    do {
        var phi2 = phi * phi, phi4 = phi2 * phi2;
        phi -= delta = (phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4))) - y) / (1.007226 + phi2 * (0.045255 + phi4 * (-0.311325 + 0.259866 * phi2 - 0.005916 * 11 * phi4)));
    }while ((0, $5014467dbc1df298$export$2335f513bbd82c6d)(delta) > (0, $5014467dbc1df298$export$6c421550c66a327d) && --i > 0);
    return [
        x / (0.8707 + (phi2 = phi * phi) * (-0.131979 + phi2 * (-0.013791 + phi2 * phi2 * phi2 * (0.003971 - 0.001529 * phi2)))),
        phi
    ];
};
function $cf706c6b835c6c13$export$2e2bcd8739ae039() {
    return (0, $62df487288d92943$export$2e2bcd8739ae039)($cf706c6b835c6c13$export$acb6def22fe878e6).scale(175.295);
}



function $9b5ca02d13390170$export$f1211ac1bdb0796(scale) {
    return function(x, y) {
        var cx = (0, $5014467dbc1df298$export$50d414a77b60d802)(x), cy = (0, $5014467dbc1df298$export$50d414a77b60d802)(y), k = scale(cx * cy);
        if (k === Infinity) return [
            2,
            0
        ];
        return [
            k * cy * (0, $5014467dbc1df298$export$5de3937cb4b592ed)(x),
            k * (0, $5014467dbc1df298$export$5de3937cb4b592ed)(y)
        ];
    };
}
function $9b5ca02d13390170$export$3cee429f13e44eac(angle) {
    return function(x, y) {
        var z = (0, $5014467dbc1df298$export$eba8049fb5020b81)(x * x + y * y), c = angle(z), sc = (0, $5014467dbc1df298$export$5de3937cb4b592ed)(c), cc = (0, $5014467dbc1df298$export$50d414a77b60d802)(c);
        return [
            (0, $5014467dbc1df298$export$b8b770ee6a0d9760)(x * sc, z * cc),
            (0, $5014467dbc1df298$export$41726bdb1fc63f)(z && y * sc / z)
        ];
    };
}



function $97224c541d25297c$export$1cd9c2eb846182a(x, y) {
    return [
        (0, $5014467dbc1df298$export$50d414a77b60d802)(y) * (0, $5014467dbc1df298$export$5de3937cb4b592ed)(x),
        (0, $5014467dbc1df298$export$5de3937cb4b592ed)(y)
    ];
}
$97224c541d25297c$export$1cd9c2eb846182a.invert = (0, $9b5ca02d13390170$export$3cee429f13e44eac)((0, $5014467dbc1df298$export$41726bdb1fc63f));
function $97224c541d25297c$export$2e2bcd8739ae039() {
    return (0, $62df487288d92943$export$2e2bcd8739ae039)($97224c541d25297c$export$1cd9c2eb846182a).scale(249.5).clipAngle(90 + (0, $5014467dbc1df298$export$6c421550c66a327d));
}






var $216562bc47e7316c$var$areaSum = new (0, $20fab5183e47798b$export$bda7ba77fb86c375)(), $216562bc47e7316c$var$areaRingSum = new (0, $20fab5183e47798b$export$bda7ba77fb86c375)(), $216562bc47e7316c$var$x00, $216562bc47e7316c$var$y00, $216562bc47e7316c$var$x0, $216562bc47e7316c$var$y0;
var $216562bc47e7316c$var$areaStream = {
    point: (0, $629d028a9279c5af$export$2e2bcd8739ae039),
    lineStart: (0, $629d028a9279c5af$export$2e2bcd8739ae039),
    lineEnd: (0, $629d028a9279c5af$export$2e2bcd8739ae039),
    polygonStart: function() {
        $216562bc47e7316c$var$areaStream.lineStart = $216562bc47e7316c$var$areaRingStart;
        $216562bc47e7316c$var$areaStream.lineEnd = $216562bc47e7316c$var$areaRingEnd;
    },
    polygonEnd: function() {
        $216562bc47e7316c$var$areaStream.lineStart = $216562bc47e7316c$var$areaStream.lineEnd = $216562bc47e7316c$var$areaStream.point = (0, $629d028a9279c5af$export$2e2bcd8739ae039);
        $216562bc47e7316c$var$areaSum.add((0, $5014467dbc1df298$export$2335f513bbd82c6d)($216562bc47e7316c$var$areaRingSum));
        $216562bc47e7316c$var$areaRingSum = new (0, $20fab5183e47798b$export$bda7ba77fb86c375)();
    },
    result: function() {
        var area = $216562bc47e7316c$var$areaSum / 2;
        $216562bc47e7316c$var$areaSum = new (0, $20fab5183e47798b$export$bda7ba77fb86c375)();
        return area;
    }
};
function $216562bc47e7316c$var$areaRingStart() {
    $216562bc47e7316c$var$areaStream.point = $216562bc47e7316c$var$areaPointFirst;
}
function $216562bc47e7316c$var$areaPointFirst(x, y) {
    $216562bc47e7316c$var$areaStream.point = $216562bc47e7316c$var$areaPoint;
    $216562bc47e7316c$var$x00 = $216562bc47e7316c$var$x0 = x, $216562bc47e7316c$var$y00 = $216562bc47e7316c$var$y0 = y;
}
function $216562bc47e7316c$var$areaPoint(x, y) {
    $216562bc47e7316c$var$areaRingSum.add($216562bc47e7316c$var$y0 * x - $216562bc47e7316c$var$x0 * y);
    $216562bc47e7316c$var$x0 = x, $216562bc47e7316c$var$y0 = y;
}
function $216562bc47e7316c$var$areaRingEnd() {
    $216562bc47e7316c$var$areaPoint($216562bc47e7316c$var$x00, $216562bc47e7316c$var$y00);
}
var $216562bc47e7316c$export$2e2bcd8739ae039 = $216562bc47e7316c$var$areaStream;




// TODO Enforce positive area for exterior, negative area for interior?
var $66eecc5a77b3c175$var$X0 = 0, $66eecc5a77b3c175$var$Y0 = 0, $66eecc5a77b3c175$var$Z0 = 0, $66eecc5a77b3c175$var$X1 = 0, $66eecc5a77b3c175$var$Y1 = 0, $66eecc5a77b3c175$var$Z1 = 0, $66eecc5a77b3c175$var$X2 = 0, $66eecc5a77b3c175$var$Y2 = 0, $66eecc5a77b3c175$var$Z2 = 0, $66eecc5a77b3c175$var$x00, $66eecc5a77b3c175$var$y00, $66eecc5a77b3c175$var$x0, $66eecc5a77b3c175$var$y0;
var $66eecc5a77b3c175$var$centroidStream = {
    point: $66eecc5a77b3c175$var$centroidPoint,
    lineStart: $66eecc5a77b3c175$var$centroidLineStart,
    lineEnd: $66eecc5a77b3c175$var$centroidLineEnd,
    polygonStart: function() {
        $66eecc5a77b3c175$var$centroidStream.lineStart = $66eecc5a77b3c175$var$centroidRingStart;
        $66eecc5a77b3c175$var$centroidStream.lineEnd = $66eecc5a77b3c175$var$centroidRingEnd;
    },
    polygonEnd: function() {
        $66eecc5a77b3c175$var$centroidStream.point = $66eecc5a77b3c175$var$centroidPoint;
        $66eecc5a77b3c175$var$centroidStream.lineStart = $66eecc5a77b3c175$var$centroidLineStart;
        $66eecc5a77b3c175$var$centroidStream.lineEnd = $66eecc5a77b3c175$var$centroidLineEnd;
    },
    result: function() {
        var centroid = $66eecc5a77b3c175$var$Z2 ? [
            $66eecc5a77b3c175$var$X2 / $66eecc5a77b3c175$var$Z2,
            $66eecc5a77b3c175$var$Y2 / $66eecc5a77b3c175$var$Z2
        ] : $66eecc5a77b3c175$var$Z1 ? [
            $66eecc5a77b3c175$var$X1 / $66eecc5a77b3c175$var$Z1,
            $66eecc5a77b3c175$var$Y1 / $66eecc5a77b3c175$var$Z1
        ] : $66eecc5a77b3c175$var$Z0 ? [
            $66eecc5a77b3c175$var$X0 / $66eecc5a77b3c175$var$Z0,
            $66eecc5a77b3c175$var$Y0 / $66eecc5a77b3c175$var$Z0
        ] : [
            NaN,
            NaN
        ];
        $66eecc5a77b3c175$var$X0 = $66eecc5a77b3c175$var$Y0 = $66eecc5a77b3c175$var$Z0 = $66eecc5a77b3c175$var$X1 = $66eecc5a77b3c175$var$Y1 = $66eecc5a77b3c175$var$Z1 = $66eecc5a77b3c175$var$X2 = $66eecc5a77b3c175$var$Y2 = $66eecc5a77b3c175$var$Z2 = 0;
        return centroid;
    }
};
function $66eecc5a77b3c175$var$centroidPoint(x, y) {
    $66eecc5a77b3c175$var$X0 += x;
    $66eecc5a77b3c175$var$Y0 += y;
    ++$66eecc5a77b3c175$var$Z0;
}
function $66eecc5a77b3c175$var$centroidLineStart() {
    $66eecc5a77b3c175$var$centroidStream.point = $66eecc5a77b3c175$var$centroidPointFirstLine;
}
function $66eecc5a77b3c175$var$centroidPointFirstLine(x, y) {
    $66eecc5a77b3c175$var$centroidStream.point = $66eecc5a77b3c175$var$centroidPointLine;
    $66eecc5a77b3c175$var$centroidPoint($66eecc5a77b3c175$var$x0 = x, $66eecc5a77b3c175$var$y0 = y);
}
function $66eecc5a77b3c175$var$centroidPointLine(x, y) {
    var dx = x - $66eecc5a77b3c175$var$x0, dy = y - $66eecc5a77b3c175$var$y0, z = (0, $5014467dbc1df298$export$eba8049fb5020b81)(dx * dx + dy * dy);
    $66eecc5a77b3c175$var$X1 += z * ($66eecc5a77b3c175$var$x0 + x) / 2;
    $66eecc5a77b3c175$var$Y1 += z * ($66eecc5a77b3c175$var$y0 + y) / 2;
    $66eecc5a77b3c175$var$Z1 += z;
    $66eecc5a77b3c175$var$centroidPoint($66eecc5a77b3c175$var$x0 = x, $66eecc5a77b3c175$var$y0 = y);
}
function $66eecc5a77b3c175$var$centroidLineEnd() {
    $66eecc5a77b3c175$var$centroidStream.point = $66eecc5a77b3c175$var$centroidPoint;
}
function $66eecc5a77b3c175$var$centroidRingStart() {
    $66eecc5a77b3c175$var$centroidStream.point = $66eecc5a77b3c175$var$centroidPointFirstRing;
}
function $66eecc5a77b3c175$var$centroidRingEnd() {
    $66eecc5a77b3c175$var$centroidPointRing($66eecc5a77b3c175$var$x00, $66eecc5a77b3c175$var$y00);
}
function $66eecc5a77b3c175$var$centroidPointFirstRing(x, y) {
    $66eecc5a77b3c175$var$centroidStream.point = $66eecc5a77b3c175$var$centroidPointRing;
    $66eecc5a77b3c175$var$centroidPoint($66eecc5a77b3c175$var$x00 = $66eecc5a77b3c175$var$x0 = x, $66eecc5a77b3c175$var$y00 = $66eecc5a77b3c175$var$y0 = y);
}
function $66eecc5a77b3c175$var$centroidPointRing(x, y) {
    var dx = x - $66eecc5a77b3c175$var$x0, dy = y - $66eecc5a77b3c175$var$y0, z = (0, $5014467dbc1df298$export$eba8049fb5020b81)(dx * dx + dy * dy);
    $66eecc5a77b3c175$var$X1 += z * ($66eecc5a77b3c175$var$x0 + x) / 2;
    $66eecc5a77b3c175$var$Y1 += z * ($66eecc5a77b3c175$var$y0 + y) / 2;
    $66eecc5a77b3c175$var$Z1 += z;
    z = $66eecc5a77b3c175$var$y0 * x - $66eecc5a77b3c175$var$x0 * y;
    $66eecc5a77b3c175$var$X2 += z * ($66eecc5a77b3c175$var$x0 + x);
    $66eecc5a77b3c175$var$Y2 += z * ($66eecc5a77b3c175$var$y0 + y);
    $66eecc5a77b3c175$var$Z2 += z * 3;
    $66eecc5a77b3c175$var$centroidPoint($66eecc5a77b3c175$var$x0 = x, $66eecc5a77b3c175$var$y0 = y);
}
var $66eecc5a77b3c175$export$2e2bcd8739ae039 = $66eecc5a77b3c175$var$centroidStream;




function $6e672c38a1e7e8d9$export$2e2bcd8739ae039(context) {
    this._context = context;
}
$6e672c38a1e7e8d9$export$2e2bcd8739ae039.prototype = {
    _radius: 4.5,
    pointRadius: function(_) {
        return this._radius = _, this;
    },
    polygonStart: function() {
        this._line = 0;
    },
    polygonEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line === 0) this._context.closePath();
        this._point = NaN;
    },
    point: function(x, y) {
        switch(this._point){
            case 0:
                this._context.moveTo(x, y);
                this._point = 1;
                break;
            case 1:
                this._context.lineTo(x, y);
                break;
            default:
                this._context.moveTo(x + this._radius, y);
                this._context.arc(x, y, this._radius, 0, (0, $5014467dbc1df298$export$a4b4b4d4d776fe92));
                break;
        }
    },
    result: (0, $629d028a9279c5af$export$2e2bcd8739ae039)
};





var $1a9cfe23c0aa5438$var$lengthSum = new (0, $20fab5183e47798b$export$bda7ba77fb86c375)(), $1a9cfe23c0aa5438$var$lengthRing, $1a9cfe23c0aa5438$var$x00, $1a9cfe23c0aa5438$var$y00, $1a9cfe23c0aa5438$var$x0, $1a9cfe23c0aa5438$var$y0;
var $1a9cfe23c0aa5438$var$lengthStream = {
    point: (0, $629d028a9279c5af$export$2e2bcd8739ae039),
    lineStart: function() {
        $1a9cfe23c0aa5438$var$lengthStream.point = $1a9cfe23c0aa5438$var$lengthPointFirst;
    },
    lineEnd: function() {
        if ($1a9cfe23c0aa5438$var$lengthRing) $1a9cfe23c0aa5438$var$lengthPoint($1a9cfe23c0aa5438$var$x00, $1a9cfe23c0aa5438$var$y00);
        $1a9cfe23c0aa5438$var$lengthStream.point = (0, $629d028a9279c5af$export$2e2bcd8739ae039);
    },
    polygonStart: function() {
        $1a9cfe23c0aa5438$var$lengthRing = true;
    },
    polygonEnd: function() {
        $1a9cfe23c0aa5438$var$lengthRing = null;
    },
    result: function() {
        var length = +$1a9cfe23c0aa5438$var$lengthSum;
        $1a9cfe23c0aa5438$var$lengthSum = new (0, $20fab5183e47798b$export$bda7ba77fb86c375)();
        return length;
    }
};
function $1a9cfe23c0aa5438$var$lengthPointFirst(x, y) {
    $1a9cfe23c0aa5438$var$lengthStream.point = $1a9cfe23c0aa5438$var$lengthPoint;
    $1a9cfe23c0aa5438$var$x00 = $1a9cfe23c0aa5438$var$x0 = x, $1a9cfe23c0aa5438$var$y00 = $1a9cfe23c0aa5438$var$y0 = y;
}
function $1a9cfe23c0aa5438$var$lengthPoint(x, y) {
    $1a9cfe23c0aa5438$var$x0 -= x, $1a9cfe23c0aa5438$var$y0 -= y;
    $1a9cfe23c0aa5438$var$lengthSum.add((0, $5014467dbc1df298$export$eba8049fb5020b81)($1a9cfe23c0aa5438$var$x0 * $1a9cfe23c0aa5438$var$x0 + $1a9cfe23c0aa5438$var$y0 * $1a9cfe23c0aa5438$var$y0));
    $1a9cfe23c0aa5438$var$x0 = x, $1a9cfe23c0aa5438$var$y0 = y;
}
var $1a9cfe23c0aa5438$export$2e2bcd8739ae039 = $1a9cfe23c0aa5438$var$lengthStream;


// Simple caching for constant-radius points.
let $099e4e3a13e36320$var$cacheDigits, $099e4e3a13e36320$var$cacheAppend, $099e4e3a13e36320$var$cacheRadius, $099e4e3a13e36320$var$cacheCircle;
class $099e4e3a13e36320$export$2e2bcd8739ae039 {
    constructor(digits){
        this._append = digits == null ? $099e4e3a13e36320$var$append : $099e4e3a13e36320$var$appendRound(digits);
        this._radius = 4.5;
        this._ = "";
    }
    pointRadius(_) {
        this._radius = +_;
        return this;
    }
    polygonStart() {
        this._line = 0;
    }
    polygonEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line === 0) this._ += "Z";
        this._point = NaN;
    }
    point(x, y) {
        switch(this._point){
            case 0:
                this._append`M${x},${y}`;
                this._point = 1;
                break;
            case 1:
                this._append`L${x},${y}`;
                break;
            default:
                this._append`M${x},${y}`;
                if (this._radius !== $099e4e3a13e36320$var$cacheRadius || this._append !== $099e4e3a13e36320$var$cacheAppend) {
                    const r = this._radius;
                    const s = this._;
                    this._ = ""; // stash the old string so we can cache the circle path fragment
                    this._append`m0,${r}a${r},${r} 0 1,1 0,${-2 * r}a${r},${r} 0 1,1 0,${2 * r}z`;
                    $099e4e3a13e36320$var$cacheRadius = r;
                    $099e4e3a13e36320$var$cacheAppend = this._append;
                    $099e4e3a13e36320$var$cacheCircle = this._;
                    this._ = s;
                }
                this._ += $099e4e3a13e36320$var$cacheCircle;
                break;
        }
    }
    result() {
        const result = this._;
        this._ = "";
        return result.length ? result : null;
    }
}
function $099e4e3a13e36320$var$append(strings) {
    let i = 1;
    this._ += strings[0];
    for(const j = strings.length; i < j; ++i)this._ += arguments[i] + strings[i];
}
function $099e4e3a13e36320$var$appendRound(digits) {
    const d = Math.floor(digits);
    if (!(d >= 0)) throw new RangeError(`invalid digits: ${digits}`);
    if (d > 15) return $099e4e3a13e36320$var$append;
    if (d !== $099e4e3a13e36320$var$cacheDigits) {
        const k = 10 ** d;
        $099e4e3a13e36320$var$cacheDigits = d;
        $099e4e3a13e36320$var$cacheAppend = function append(strings) {
            let i = 1;
            this._ += strings[0];
            for(const j = strings.length; i < j; ++i)this._ += Math.round(arguments[i] * k) / k + strings[i];
        };
    }
    return $099e4e3a13e36320$var$cacheAppend;
}


function $14b301fb67cb91c1$export$2e2bcd8739ae039(projection, context) {
    let digits = 3, pointRadius = 4.5, projectionStream, contextStream;
    function path(object) {
        if (object) {
            if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
            (0, $f8e7105390e68212$export$2e2bcd8739ae039)(object, projectionStream(contextStream));
        }
        return contextStream.result();
    }
    path.area = function(object) {
        (0, $f8e7105390e68212$export$2e2bcd8739ae039)(object, projectionStream((0, $216562bc47e7316c$export$2e2bcd8739ae039)));
        return (0, $216562bc47e7316c$export$2e2bcd8739ae039).result();
    };
    path.measure = function(object) {
        (0, $f8e7105390e68212$export$2e2bcd8739ae039)(object, projectionStream((0, $1a9cfe23c0aa5438$export$2e2bcd8739ae039)));
        return (0, $1a9cfe23c0aa5438$export$2e2bcd8739ae039).result();
    };
    path.bounds = function(object) {
        (0, $f8e7105390e68212$export$2e2bcd8739ae039)(object, projectionStream((0, $3c50db2f346565b6$export$2e2bcd8739ae039)));
        return (0, $3c50db2f346565b6$export$2e2bcd8739ae039).result();
    };
    path.centroid = function(object) {
        (0, $f8e7105390e68212$export$2e2bcd8739ae039)(object, projectionStream((0, $66eecc5a77b3c175$export$2e2bcd8739ae039)));
        return (0, $66eecc5a77b3c175$export$2e2bcd8739ae039).result();
    };
    path.projection = function(_) {
        if (!arguments.length) return projection;
        projectionStream = _ == null ? (projection = null, $9778824e69a6f802$export$2e2bcd8739ae039) : (projection = _).stream;
        return path;
    };
    path.context = function(_) {
        if (!arguments.length) return context;
        contextStream = _ == null ? (context = null, new (0, $099e4e3a13e36320$export$2e2bcd8739ae039)(digits)) : new (0, $6e672c38a1e7e8d9$export$2e2bcd8739ae039)(context = _);
        if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
        return path;
    };
    path.pointRadius = function(_) {
        if (!arguments.length) return pointRadius;
        pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
        return path;
    };
    path.digits = function(_) {
        if (!arguments.length) return digits;
        if (_ == null) digits = null;
        else {
            const d = Math.floor(_);
            if (!(d >= 0)) throw new RangeError(`invalid digits: ${_}`);
            digits = d;
        }
        if (context === null) contextStream = new (0, $099e4e3a13e36320$export$2e2bcd8739ae039)(digits);
        return path;
    };
    return path.projection(projection).digits(digits).context(context);
}







function $8ca59304573d356e$export$2e2bcd8739ae039(_ref) {
    let { graticule: graticule, lines: lines, outline: outline, extent: extent, extentMajor: extentMajor, extentMinor: extentMinor, step: step, stepMajor: stepMajor, stepMinor: stepMinor, precision: precision, children: children, ...restProps } = _ref;
    const currGraticule = (0, $25f1420916e3b1e4$export$2e2bcd8739ae039)();
    if (extent) currGraticule.extent(extent);
    if (extentMajor) currGraticule.extentMajor(extentMajor);
    if (extentMinor) currGraticule.extentMinor(extentMinor);
    if (step) currGraticule.step(step);
    if (stepMajor) currGraticule.stepMajor(stepMajor);
    if (stepMinor) currGraticule.stepMinor(stepMinor);
    if (precision) currGraticule.precision(precision);
    if (children) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: children({
            graticule: currGraticule
        })
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)((0, $268dd56f34f61467$export$2e2bcd8739ae039), {
        className: "visx-geo-graticule",
        children: [
            graticule && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("path", {
                d: graticule(currGraticule()),
                fill: "none",
                stroke: "black",
                ...restProps
            }),
            lines && currGraticule.lines().map((line, i)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("g", {
                    children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("path", {
                        d: lines(line),
                        fill: "none",
                        stroke: "black",
                        ...restProps
                    })
                }, i)),
            outline && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("path", {
                d: outline(currGraticule.outline()),
                fill: "none",
                stroke: "black",
                ...restProps
            })
        ]
    });
}



const $19810dec108bbb57$var$projectionMapping = {
    orthographic: ()=>(0, $97224c541d25297c$export$2e2bcd8739ae039)(),
    albers: ()=>(0, $44584b08a6447cdd$export$2e2bcd8739ae039)(),
    albersUsa: ()=>(0, $9d8e7d8286335c53$export$2e2bcd8739ae039)(),
    mercator: ()=>(0, $1c9fe90bb6f8cb90$export$2e2bcd8739ae039)(),
    naturalEarth: ()=>(0, $cf706c6b835c6c13$export$2e2bcd8739ae039)(),
    equalEarth: ()=>(0, $234afe9128c63e18$export$2e2bcd8739ae039)()
};
function $19810dec108bbb57$export$2e2bcd8739ae039(_ref) {
    let { data: data, projection: projection = 'mercator', projectionFunc: projectionFunc, clipAngle: clipAngle, clipExtent: clipExtent, scale: scale, translate: translate, center: center, rotate: rotate, precision: precision, fitExtent: fitExtent, fitSize: fitSize, centroid: centroid, graticule: graticule, graticuleLines: graticuleLines, graticuleOutline: graticuleOutline, className: className, innerRef: innerRef, digits: digits, pointRadius: pointRadius, children: children, ...restProps } = _ref;
    const maybeCustomProjection = typeof projection === 'string' ? $19810dec108bbb57$var$projectionMapping[projection] : projection;
    const currProjection = maybeCustomProjection();
    if (clipAngle && currProjection.clipAngle) currProjection.clipAngle(clipAngle);
    if (clipExtent && currProjection.clipExtent) currProjection.clipExtent(clipExtent);
    if (scale && currProjection.scale) currProjection.scale(scale);
    if (translate && currProjection.translate) currProjection.translate(translate);
    if (center && currProjection.center) currProjection.center(center);
    if (rotate && currProjection.rotate) currProjection.rotate(rotate);
    if (precision && currProjection.precision) currProjection.precision(precision);
    if (fitExtent && currProjection.fitExtent) currProjection.fitExtent(...fitExtent);
    if (fitSize && currProjection.fitSize) currProjection.fitSize(...fitSize);
    const path = (0, $14b301fb67cb91c1$export$2e2bcd8739ae039)().projection(currProjection);
    if (digits !== undefined) path.digits(digits);
    if (pointRadius !== undefined) path.pointRadius(pointRadius);
    const features = data.map((feature, i)=>({
            feature: feature,
            type: projection,
            projection: currProjection,
            index: i,
            centroid: path.centroid(feature),
            path: path(feature)
        }));
    if (children) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: children({
            path: path,
            features: features,
            projection: currProjection
        })
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)((0, $268dd56f34f61467$export$2e2bcd8739ae039), {
        className: "visx-geo",
        children: [
            graticule && !graticule.foreground && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $8ca59304573d356e$export$2e2bcd8739ae039), {
                graticule: (ml)=>path(ml) || '',
                ...graticule
            }),
            graticuleLines && !graticuleLines.foreground && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $8ca59304573d356e$export$2e2bcd8739ae039), {
                lines: (l)=>path(l) || '',
                ...graticuleLines
            }),
            graticuleOutline && !graticuleOutline.foreground && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $8ca59304573d356e$export$2e2bcd8739ae039), {
                outline: (p)=>path(p) || '',
                ...graticuleOutline
            }),
            features.map((feature, i)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("path", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(`visx-geo-${projection}`, className),
                            d: feature.path || '',
                            ref: innerRef?.(feature, i),
                            ...restProps
                        }),
                        centroid?.(feature.centroid, feature)
                    ]
                }, `${projection}-${i}`)),
            projectionFunc?.(currProjection),
            graticule?.foreground && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $8ca59304573d356e$export$2e2bcd8739ae039), {
                graticule: (ml)=>path(ml) || '',
                ...graticule
            }),
            graticuleLines?.foreground && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $8ca59304573d356e$export$2e2bcd8739ae039), {
                lines: (l)=>path(l) || '',
                ...graticuleLines
            }),
            graticuleOutline?.foreground && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $8ca59304573d356e$export$2e2bcd8739ae039), {
                outline: (p)=>path(p) || '',
                ...graticuleOutline
            })
        ]
    });
}



function $ddb77353e2ef7f19$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $19810dec108bbb57$export$2e2bcd8739ae039), {
        projection: "albers",
        ...props
    });
}




function $492825c530089253$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $19810dec108bbb57$export$2e2bcd8739ae039), {
        projection: "albersUsa",
        ...props
    });
}




function $631b2d243c4661dd$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $19810dec108bbb57$export$2e2bcd8739ae039), {
        projection: "mercator",
        ...props
    });
}




function $3cbdbc0648cdf293$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $19810dec108bbb57$export$2e2bcd8739ae039), {
        projection: "orthographic",
        ...props
    });
}




function $7f50cff90e0ee8f8$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $19810dec108bbb57$export$2e2bcd8739ae039), {
        projection: "naturalEarth",
        ...props
    });
}




function $96f7b1cd8c89cd93$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $19810dec108bbb57$export$2e2bcd8739ae039), {
        projection: "equalEarth",
        ...props
    });
}




function $bb093aee1caf1290$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $19810dec108bbb57$export$2e2bcd8739ae039), {
        ...props
    });
}





// @visx/glyph



function $494d82bc6c1a228f$export$2e2bcd8739ae039(_ref) {
    let { top: top = 0, left: left = 0, className: className, children: children } = _ref;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $268dd56f34f61467$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-glyph', className),
        top: top,
        left: left,
        children: children
    });
}





function $d7fb3571f7821e80$export$2e2bcd8739ae039(_ref) {
    let { top: top = 0, left: left = 0, className: className, ...restProps } = _ref;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $494d82bc6c1a228f$export$2e2bcd8739ae039), {
        top: top,
        left: left,
        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("circle", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-glyph-dot', className),
            ...restProps
        })
    });
}






function $5ef358e79d534cd1$export$2e2bcd8739ae039(_ref) {
    let { children: children, className: className, top: top, left: left, size: size, ...restProps } = _ref;
    const path = (0, $366ee85fae7a7cdc$export$2e2bcd8739ae039)();
    path.type((0, $ad740482921b4df8$export$2e2bcd8739ae039));
    // TS can't differentiate the method overload here
    if (typeof size === 'number') path.size(size);
    else if (size) path.size(size);
    if (children) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: children({
            path: path
        })
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $494d82bc6c1a228f$export$2e2bcd8739ae039), {
        top: top,
        left: left,
        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("path", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-glyph-cross', className),
            d: path() || '',
            ...restProps
        })
    });
}






function $79be726138c7a79a$export$2e2bcd8739ae039(_ref) {
    let { children: children, className: className, top: top, left: left, size: size, ...restProps } = _ref;
    const path = (0, $366ee85fae7a7cdc$export$2e2bcd8739ae039)();
    path.type((0, $78c4e72d0d208477$export$2e2bcd8739ae039));
    // TS can't differentiate the method overload here
    if (typeof size === 'number') path.size(size);
    else if (size) path.size(size);
    if (children) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: children({
            path: path
        })
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $494d82bc6c1a228f$export$2e2bcd8739ae039), {
        top: top,
        left: left,
        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("path", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-glyph-diamond', className),
            d: path() || '',
            ...restProps
        })
    });
}






function $764c965ef8432301$export$2e2bcd8739ae039(_ref) {
    let { children: children, className: className, top: top, left: left, size: size, ...restProps } = _ref;
    const path = (0, $366ee85fae7a7cdc$export$2e2bcd8739ae039)();
    path.type((0, $ad6b3dee1e949ade$export$2e2bcd8739ae039));
    // TS can't differentiate the method overload here
    if (typeof size === 'number') path.size(size);
    else if (size) path.size(size);
    if (children) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: children({
            path: path
        })
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $494d82bc6c1a228f$export$2e2bcd8739ae039), {
        top: top,
        left: left,
        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("path", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-glyph-star', className),
            d: path() || '',
            ...restProps
        })
    });
}






function $77d311df0fedb245$export$2e2bcd8739ae039(_ref) {
    let { children: children, className: className, top: top, left: left, size: size, ...restProps } = _ref;
    const path = (0, $366ee85fae7a7cdc$export$2e2bcd8739ae039)();
    path.type((0, $81723e6d3f8e7883$export$2e2bcd8739ae039));
    // TS can't differentiate the method overload here
    if (typeof size === 'number') path.size(size);
    else if (size) path.size(size);
    if (children) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: children({
            path: path
        })
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $494d82bc6c1a228f$export$2e2bcd8739ae039), {
        top: top,
        left: left,
        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("path", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-glyph-triangle', className),
            d: path() || '',
            ...restProps
        })
    });
}






function $515457ec229306b6$export$2e2bcd8739ae039(_ref) {
    let { children: children, className: className, top: top, left: left, size: size, ...restProps } = _ref;
    const path = (0, $366ee85fae7a7cdc$export$2e2bcd8739ae039)();
    path.type((0, $acd724fef4bf01f9$export$2e2bcd8739ae039));
    // TS can't differentiate the method overload here
    if (typeof size === 'number') path.size(size);
    else if (size) path.size(size);
    if (children) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: children({
            path: path
        })
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $494d82bc6c1a228f$export$2e2bcd8739ae039), {
        top: top,
        left: left,
        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("path", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-glyph-wye', className),
            d: path() || '',
            ...restProps
        })
    });
}






function $ee8b33b1433b2fd6$export$2e2bcd8739ae039(_ref) {
    let { children: children, className: className, top: top, left: left, size: size, ...restProps } = _ref;
    const path = (0, $366ee85fae7a7cdc$export$2e2bcd8739ae039)();
    path.type((0, $ae86d870f041ac46$export$2e2bcd8739ae039));
    // TS can't differentiate the method overload here
    if (typeof size === 'number') path.size(size);
    else if (size) path.size(size);
    if (children) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: children({
            path: path
        })
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $494d82bc6c1a228f$export$2e2bcd8739ae039), {
        top: top,
        left: left,
        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("path", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-glyph-square', className),
            d: path() || '',
            ...restProps
        })
    });
}






function $d6f2f27c553b7dfc$export$2e2bcd8739ae039(_ref) {
    let { children: children, className: className, top: top, left: left, size: size, ...restProps } = _ref;
    const path = (0, $366ee85fae7a7cdc$export$2e2bcd8739ae039)();
    path.type((0, $99dc9be8d3a6e141$export$2e2bcd8739ae039));
    // TS can't differentiate the method overload here
    if (typeof size === 'number') path.size(size);
    else if (size) path.size(size);
    if (children) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: children({
            path: path
        })
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $494d82bc6c1a228f$export$2e2bcd8739ae039), {
        top: top,
        left: left,
        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("path", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-glyph-circle', className),
            d: path() || '',
            ...restProps
        })
    });
}




// @visx/gradient

function $e4917ebb291999ee$export$2e2bcd8739ae039(_ref) {
    let { children: children, id: id, from: from, to: to, x1: _x1, y1: _y1, x2: _x2, y2: _y2, fromOffset: fromOffset = '0%', fromOpacity: fromOpacity = 1, toOffset: toOffset = '100%', toOpacity: toOpacity = 1, rotate: rotate, transform: transform, vertical: vertical = true, ...restProps } = _ref;
    let x1 = _x1;
    let x2 = _x2;
    let y1 = _y1;
    let y2 = _y2;
    if (vertical && !x1 && !x2 && !y1 && !y2) {
        x1 = '0';
        x2 = '0';
        y1 = '0';
        y2 = '1';
    }
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("defs", {
        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("linearGradient", {
            id: id,
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2,
            gradientTransform: rotate ? `rotate(${rotate})` : transform,
            ...restProps,
            children: [
                !!children && children,
                !children && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("stop", {
                    offset: fromOffset,
                    stopColor: from,
                    stopOpacity: fromOpacity
                }),
                !children && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("stop", {
                    offset: toOffset,
                    stopColor: to,
                    stopOpacity: toOpacity
                })
            ]
        })
    });
}



function $227426df49a1ca6a$export$2e2bcd8739ae039(_ref) {
    let { children: children, id: id, from: from, to: to, fromOffset: fromOffset = '0%', fromOpacity: fromOpacity = 1, toOffset: toOffset = '100%', toOpacity: toOpacity = 1, rotate: rotate, transform: transform, ...restProps } = _ref;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("defs", {
        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("radialGradient", {
            id: id,
            gradientTransform: rotate ? `rotate(${rotate})` : transform,
            ...restProps,
            children: [
                !!children && children,
                !children && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("stop", {
                    offset: fromOffset,
                    stopColor: from,
                    stopOpacity: fromOpacity
                }),
                !children && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("stop", {
                    offset: toOffset,
                    stopColor: to,
                    stopOpacity: toOpacity
                })
            ]
        })
    });
}




function $bbec304962f8794d$export$2e2bcd8739ae039(_ref) {
    let { from: from = '#184E86', to: to = '#57CA85', ...restProps } = _ref;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $e4917ebb291999ee$export$2e2bcd8739ae039), {
        from: from,
        to: to,
        ...restProps
    });
}




function $b3fbdfd9e61de8df$export$2e2bcd8739ae039(_ref) {
    let { from: from = '#42E695', to: to = '#3BB2B8', ...restProps } = _ref;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $e4917ebb291999ee$export$2e2bcd8739ae039), {
        from: from,
        to: to,
        ...restProps
    });
}




function $bb2dffcbcbbbd1bc$export$2e2bcd8739ae039(_ref) {
    let { from: from = '#FCE38A', to: to = '#F38181', ...restProps } = _ref;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $e4917ebb291999ee$export$2e2bcd8739ae039), {
        from: from,
        to: to,
        ...restProps
    });
}




function $69bb3e7bec0abf02$export$2e2bcd8739ae039(_ref) {
    let { from: from = '#F02FC2', to: to = '#6094EA', ...restProps } = _ref;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $e4917ebb291999ee$export$2e2bcd8739ae039), {
        from: from,
        to: to,
        ...restProps
    });
}




function $6260c02b38fbdabb$export$2e2bcd8739ae039(_ref) {
    let { from: from = '#F54EA2', to: to = '#FF7676', ...restProps } = _ref;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $e4917ebb291999ee$export$2e2bcd8739ae039), {
        from: from,
        to: to,
        ...restProps
    });
}




function $d5ea33ff8dff528e$export$2e2bcd8739ae039(_ref) {
    let { from: from = '#7117EA', to: to = '#EA6060', ...restProps } = _ref;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $e4917ebb291999ee$export$2e2bcd8739ae039), {
        from: from,
        to: to,
        ...restProps
    });
}




function $b12c5c1e938e9ac3$export$2e2bcd8739ae039(_ref) {
    let { from: from = '#622774', to: to = '#C53364', ...restProps } = _ref;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $e4917ebb291999ee$export$2e2bcd8739ae039), {
        from: from,
        to: to,
        ...restProps
    });
}




function $e36d591e26fada62$export$2e2bcd8739ae039(_ref) {
    let { from: from = '#5B247A', to: to = '#1BCEDF', ...restProps } = _ref;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $e4917ebb291999ee$export$2e2bcd8739ae039), {
        from: from,
        to: to,
        ...restProps
    });
}




function $cd5eda37f3f9c8a8$export$2e2bcd8739ae039(_ref) {
    let { from: from = '#65799B', to: to = '#5E2563', ...restProps } = _ref;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $e4917ebb291999ee$export$2e2bcd8739ae039), {
        from: from,
        to: to,
        ...restProps
    });
}




function $f839e5a6bf267eed$export$2e2bcd8739ae039(_ref) {
    let { from: from = '#17EAD9', to: to = '#6078EA', ...restProps } = _ref;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $e4917ebb291999ee$export$2e2bcd8739ae039), {
        from: from,
        to: to,
        ...restProps
    });
}




// @visx/grid





function $6f5260de6e34345d$export$2e2bcd8739ae039(scale) {
    return 'bandwidth' in scale ? scale.bandwidth() : 0;
}



function $2113d7ba46a62464$export$2e2bcd8739ae039(_ref) {
    let { top: top = 0, left: left = 0, scale: scale, width: width, stroke: stroke = '#eaf0f6', strokeWidth: strokeWidth = 1, strokeDasharray: strokeDasharray, className: className, children: children, numTicks: numTicks = 10, lineStyle: lineStyle, offset: offset, tickValues: tickValues, ...restProps } = _ref;
    const ticks = tickValues ?? (0, $739bbf10d3a1c70b$export$2e2bcd8739ae039)(scale, numTicks);
    const scaleOffset = (offset ?? 0) + (0, $6f5260de6e34345d$export$2e2bcd8739ae039)(scale) / 2;
    const tickLines = ticks.map((d, index)=>{
        const y = ((0, $c32ed8852dffe2f4$export$2e2bcd8739ae039)(scale(d)) ?? 0) + scaleOffset;
        return {
            index: index,
            from: new (0, $4f1f378f21d00070$export$2e2bcd8739ae039)({
                x: 0,
                y: y
            }),
            to: new (0, $4f1f378f21d00070$export$2e2bcd8739ae039)({
                x: width,
                y: y
            })
        };
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $268dd56f34f61467$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-rows', className),
        top: top,
        left: left,
        children: children ? children({
            lines: tickLines
        }) : tickLines.map((_ref2)=>{
            let { from: from, to: to, index: index } = _ref2;
            return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $0e0a7792039d1a63$export$2e2bcd8739ae039), {
                from: from,
                to: to,
                stroke: stroke,
                strokeWidth: strokeWidth,
                strokeDasharray: strokeDasharray,
                style: lineStyle,
                ...restProps
            }, `row-line-${index}`);
        })
    });
}









function $4b74c05c432587fa$export$2e2bcd8739ae039(_ref) {
    let { top: top = 0, left: left = 0, scale: scale, height: height, stroke: stroke = '#eaf0f6', strokeWidth: strokeWidth = 1, strokeDasharray: strokeDasharray, className: className, numTicks: numTicks = 10, lineStyle: lineStyle, offset: offset, tickValues: tickValues, children: children, ...restProps } = _ref;
    const ticks = tickValues ?? (0, $739bbf10d3a1c70b$export$2e2bcd8739ae039)(scale, numTicks);
    const scaleOffset = (offset ?? 0) + (0, $6f5260de6e34345d$export$2e2bcd8739ae039)(scale) / 2;
    const tickLines = ticks.map((d, index)=>{
        const x = ((0, $c32ed8852dffe2f4$export$2e2bcd8739ae039)(scale(d)) ?? 0) + scaleOffset;
        return {
            index: index,
            from: new (0, $4f1f378f21d00070$export$2e2bcd8739ae039)({
                x: x,
                y: 0
            }),
            to: new (0, $4f1f378f21d00070$export$2e2bcd8739ae039)({
                x: x,
                y: height
            })
        };
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $268dd56f34f61467$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-columns', className),
        top: top,
        left: left,
        children: children ? children({
            lines: tickLines
        }) : tickLines.map((_ref2)=>{
            let { from: from, to: to, index: index } = _ref2;
            return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $0e0a7792039d1a63$export$2e2bcd8739ae039), {
                from: from,
                to: to,
                stroke: stroke,
                strokeWidth: strokeWidth,
                strokeDasharray: strokeDasharray,
                style: lineStyle,
                ...restProps
            }, `column-line-${index}`);
        })
    });
}







function $007a5fe41d142733$export$2e2bcd8739ae039(_ref) {
    let { top: top, left: left, xScale: xScale, yScale: yScale, width: width, height: height, className: className, stroke: stroke, strokeWidth: strokeWidth, strokeDasharray: strokeDasharray, numTicksRows: numTicksRows, numTicksColumns: numTicksColumns, rowLineStyle: rowLineStyle, columnLineStyle: columnLineStyle, xOffset: xOffset, yOffset: yOffset, rowTickValues: rowTickValues, columnTickValues: columnTickValues, ...restProps } = _ref;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)((0, $268dd56f34f61467$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-grid', className),
        top: top,
        left: left,
        children: [
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $2113d7ba46a62464$export$2e2bcd8739ae039), {
                className: className,
                scale: yScale,
                width: width,
                stroke: stroke,
                strokeWidth: strokeWidth,
                strokeDasharray: strokeDasharray,
                numTicks: numTicksRows,
                lineStyle: rowLineStyle,
                offset: yOffset,
                tickValues: rowTickValues,
                ...restProps
            }),
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $4b74c05c432587fa$export$2e2bcd8739ae039), {
                className: className,
                scale: xScale,
                height: height,
                stroke: stroke,
                strokeWidth: strokeWidth,
                strokeDasharray: strokeDasharray,
                numTicks: numTicksColumns,
                lineStyle: columnLineStyle,
                offset: xOffset,
                tickValues: columnTickValues,
                ...restProps
            })
        ]
    });
}







function $d6552ecacc8aa3df$export$2e2bcd8739ae039(_ref) {
    let { radius: radius, angle: angle } = _ref;
    return {
        x: radius * Math.cos(angle),
        y: radius * Math.sin(angle)
    };
}



function $9419970c1ea88b9e$export$2e2bcd8739ae039(_ref) {
    let { className: className, innerRadius: innerRadius = 0, left: left = 0, lineClassName: lineClassName, lineStyle: lineStyle, numTicks: numTicks = 10, outerRadius: outerRadius = 0, scale: scale, stroke: stroke = '#eaf0f6', strokeDasharray: strokeDasharray, strokeWidth: strokeWidth = 1, tickValues: tickValues, top: top = 0, children: children, // Explicitly extract children so it doesn't get spread to Line
    ...restProps } = _ref;
    const ticks = tickValues ?? (0, $739bbf10d3a1c70b$export$2e2bcd8739ae039)(scale, numTicks);
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $268dd56f34f61467$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-grid-angle', className),
        top: top,
        left: left,
        children: ticks.map((tick, i)=>{
            const angle = ((0, $c32ed8852dffe2f4$export$2e2bcd8739ae039)(scale(tick)) ?? Math.PI / 2) - Math.PI / 2;
            return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $0e0a7792039d1a63$export$2e2bcd8739ae039), {
                className: lineClassName,
                from: new (0, $4f1f378f21d00070$export$2e2bcd8739ae039)((0, $d6552ecacc8aa3df$export$2e2bcd8739ae039)({
                    angle: angle,
                    radius: innerRadius
                })),
                to: new (0, $4f1f378f21d00070$export$2e2bcd8739ae039)((0, $d6552ecacc8aa3df$export$2e2bcd8739ae039)({
                    angle: angle,
                    radius: outerRadius
                })),
                stroke: stroke,
                strokeWidth: strokeWidth,
                strokeDasharray: strokeDasharray,
                style: lineStyle,
                ...restProps
            }, `polar-grid-${tick}-${i}`);
        })
    });
}







function $6d261ae369c4a7cb$export$2e2bcd8739ae039(_ref) {
    let { arcThickness: arcThickness, className: className, endAngle: endAngle = 2 * Math.PI, fill: fill = 'transparent', fillOpacity: fillOpacity = 1, left: left = 0, lineClassName: lineClassName, lineStyle: lineStyle, numTicks: numTicks = 10, scale: scale, startAngle: startAngle = 0, stroke: stroke = '#eaf0f6', strokeWidth: strokeWidth = 1, strokeDasharray: strokeDasharray, tickValues: tickValues, top: top = 0, ...restProps } = _ref;
    const radii = tickValues ?? (0, $739bbf10d3a1c70b$export$2e2bcd8739ae039)(scale, numTicks);
    const innerRadius = Math.min(...scale.domain());
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $268dd56f34f61467$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-grid-radial', className),
        top: top,
        left: left,
        children: radii.map((radius, i)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $c1e5b18b42dd328c$export$2e2bcd8739ae039), {
                className: lineClassName,
                startAngle: startAngle,
                endAngle: endAngle,
                innerRadius: scale(arcThickness ? radius - arcThickness : innerRadius),
                outerRadius: scale(radius),
                fill: fill,
                fillOpacity: fillOpacity,
                stroke: stroke,
                strokeWidth: strokeWidth,
                strokeDasharray: strokeDasharray,
                style: lineStyle,
                ...restProps
            }, `radial-grid-${radius}-${i}`))
    });
}







function $c99b573f1d5065b7$export$2e2bcd8739ae039(_ref) {
    let { arcThickness: arcThickness, className: className, classNameAngle: classNameAngle, classNameRadial: classNameRadial, endAngle: endAngle, fillRadial: fillRadial, innerRadius: innerRadius, left: left, lineClassNameAngle: lineClassNameAngle, lineClassNameRadial: lineClassNameRadial, lineStyleAngle: lineStyleAngle, lineStyleRadial: lineStyleRadial, numTicksAngle: numTicksAngle, numTicksRadial: numTicksRadial, outerRadius: outerRadius, scaleAngle: scaleAngle, scaleRadial: scaleRadial, startAngle: startAngle, strokeAngle: strokeAngle, strokeRadial: strokeRadial, strokeWidthAngle: strokeWidthAngle, strokeWidthRadial: strokeWidthRadial, strokeDasharrayAngle: strokeDasharrayAngle, strokeDasharrayRadial: strokeDasharrayRadial, tickValuesAngle: tickValuesAngle, tickValuesRadial: tickValuesRadial, top: top } = _ref;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)((0, $268dd56f34f61467$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-grid-polar', className),
        top: top,
        left: left,
        children: [
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $9419970c1ea88b9e$export$2e2bcd8739ae039), {
                className: classNameAngle,
                innerRadius: innerRadius,
                lineClassName: lineClassNameAngle,
                lineStyle: lineStyleAngle,
                numTicks: numTicksAngle,
                outerRadius: outerRadius,
                scale: scaleAngle,
                stroke: strokeAngle,
                strokeWidth: strokeWidthAngle,
                strokeDasharray: strokeDasharrayAngle,
                tickValues: tickValuesAngle
            }),
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $6d261ae369c4a7cb$export$2e2bcd8739ae039), {
                arcThickness: arcThickness,
                className: classNameRadial,
                endAngle: endAngle,
                fill: fillRadial,
                lineClassName: lineClassNameRadial,
                lineStyle: lineStyleRadial,
                numTicks: numTicksRadial,
                scale: scaleRadial,
                startAngle: startAngle,
                stroke: strokeRadial,
                strokeWidth: strokeWidthRadial,
                strokeDasharray: strokeDasharrayRadial,
                tickValues: tickValuesRadial
            })
        ]
    });
}





// @visx/heatmap



function $da0d9959a254b848$export$2e2bcd8739ae039(_ref) {
    let { className: className, top: top, left: left, data: data = [], gap: gap = 1, radius: radius = 6, xScale: xScale, yScale: yScale, colorScale: colorScale = ()=>undefined, opacityScale: opacityScale = ()=>1, bins: bins = (column)=>column?.bins, count: // eslint-disable-line @typescript-eslint/no-explicit-any
    count = (cell)=>cell?.count, children: // eslint-disable-line @typescript-eslint/no-explicit-any
    children, ...restProps } = _ref;
    const innerRadius = radius - gap;
    const heatmap = data.map((columnDatum, column)=>{
        const x = xScale(column);
        return bins(columnDatum).map((bin, row)=>{
            const countValue = count(bin);
            return {
                bin: bin,
                row: row,
                column: column,
                datum: columnDatum,
                radius: radius,
                gap: gap,
                count: countValue,
                cx: radius + x,
                cy: yScale(row) + gap + radius,
                r: innerRadius,
                opacity: opacityScale(countValue),
                color: colorScale(countValue)
            };
        });
    });
    if (children) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: children(heatmap)
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $268dd56f34f61467$export$2e2bcd8739ae039), {
        className: "visx-heatmap-circles",
        top: top,
        left: left,
        children: heatmap.map((columns)=>columns.map((bin)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("circle", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-heatmap-circle', className),
                    r: bin.r,
                    cx: bin.cx,
                    cy: bin.cy,
                    fill: bin.color,
                    fillOpacity: bin.opacity,
                    ...restProps
                }, `heatmap-tile-circle-${bin.row}-${bin.column}`)))
    });
}





function $ac0588d4d4ec4739$export$2e2bcd8739ae039(_ref) {
    let { className: className, top: top, left: left, data: data = [], binWidth: binWidth = 6, binHeight: binHeight = 6, x0: x0 = 0, gap: gap = 1, xScale: xScale, yScale: yScale, colorScale: colorScale = ()=>undefined, opacityScale: opacityScale = ()=>1, bins: bins = (d)=>d?.bins, count: // eslint-disable-line @typescript-eslint/no-explicit-any
    count = (d)=>d?.count, children: // eslint-disable-line @typescript-eslint/no-explicit-any
    children, ...restProps } = _ref;
    const width = binWidth - gap;
    const height = binHeight - gap;
    const heatmap = data.map((datum, column)=>{
        const x = xScale(column);
        return bins(datum).map((bin, row)=>{
            const countValue = count(bin);
            return {
                bin: bin,
                row: row,
                column: column,
                datum: datum,
                width: width,
                height: height,
                gap: gap,
                count: countValue,
                x: x + x0,
                y: yScale(row) + gap,
                color: colorScale(countValue),
                opacity: opacityScale(countValue)
            };
        });
    });
    if (children) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: children(heatmap)
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $268dd56f34f61467$export$2e2bcd8739ae039), {
        className: "visx-heatmap-rects",
        top: top,
        left: left,
        children: heatmap.map((_bins)=>_bins.map((bin)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("rect", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-heatmap-rect', className),
                    width: bin.width,
                    height: bin.height,
                    x: bin.x,
                    y: bin.y,
                    fill: bin.color,
                    fillOpacity: bin.opacity,
                    ...restProps
                }, `heatmap-tile-rect-${bin.row}-${bin.column}`)))
    });
}




// @visx/hierarchy

var $5E6i4 = parcelRequire("5E6i4");


function $5bc0462261dda62e$var$count(node) {
    var sum = 0, children = node.children, i = children && children.length;
    if (!i) sum = 1;
    else while(--i >= 0)sum += children[i].value;
    node.value = sum;
}
function $5bc0462261dda62e$export$2e2bcd8739ae039() {
    return this.eachAfter($5bc0462261dda62e$var$count);
}


function $4c30aea04bed84ec$export$2e2bcd8739ae039(callback) {
    var node = this, current, next = [
        node
    ], children, i, n;
    do {
        current = next.reverse(), next = [];
        while(node = current.pop()){
            callback(node), children = node.children;
            if (children) for(i = 0, n = children.length; i < n; ++i)next.push(children[i]);
        }
    }while (next.length);
    return this;
}


function $e8b0c0755eb39e09$export$2e2bcd8739ae039(callback) {
    var node = this, nodes = [
        node
    ], children, i;
    while(node = nodes.pop()){
        callback(node), children = node.children;
        if (children) for(i = children.length - 1; i >= 0; --i)nodes.push(children[i]);
    }
    return this;
}


function $ac5e692b1c1ae126$export$2e2bcd8739ae039(callback) {
    var node = this, nodes = [
        node
    ], next = [], children, i, n;
    while(node = nodes.pop()){
        next.push(node), children = node.children;
        if (children) for(i = 0, n = children.length; i < n; ++i)nodes.push(children[i]);
    }
    while(node = next.pop())callback(node);
    return this;
}


function $e8f7e4de6be0a566$export$2e2bcd8739ae039(value) {
    return this.eachAfter(function(node) {
        var sum = +value(node.data) || 0, children = node.children, i = children && children.length;
        while(--i >= 0)sum += children[i].value;
        node.value = sum;
    });
}


function $63b2c03ec9b90c3e$export$2e2bcd8739ae039(compare) {
    return this.eachBefore(function(node) {
        if (node.children) node.children.sort(compare);
    });
}


function $6d77ff71a102bad9$export$2e2bcd8739ae039(end) {
    var start = this, ancestor = $6d77ff71a102bad9$var$leastCommonAncestor(start, end), nodes = [
        start
    ];
    while(start !== ancestor){
        start = start.parent;
        nodes.push(start);
    }
    var k = nodes.length;
    while(end !== ancestor){
        nodes.splice(k, 0, end);
        end = end.parent;
    }
    return nodes;
}
function $6d77ff71a102bad9$var$leastCommonAncestor(a, b) {
    if (a === b) return a;
    var aNodes = a.ancestors(), bNodes = b.ancestors(), c = null;
    a = aNodes.pop();
    b = bNodes.pop();
    while(a === b){
        c = a;
        a = aNodes.pop();
        b = bNodes.pop();
    }
    return c;
}


function $87d220309bf2b9cb$export$2e2bcd8739ae039() {
    var node = this, nodes = [
        node
    ];
    while(node = node.parent)nodes.push(node);
    return nodes;
}


function $c60af1c30d4766c7$export$2e2bcd8739ae039() {
    var nodes = [];
    this.each(function(node) {
        nodes.push(node);
    });
    return nodes;
}


function $b81d3ab9f250955f$export$2e2bcd8739ae039() {
    var leaves = [];
    this.eachBefore(function(node) {
        if (!node.children) leaves.push(node);
    });
    return leaves;
}


function $be05b6e58b221f10$export$2e2bcd8739ae039() {
    var root = this, links = [];
    root.each(function(node) {
        if (node !== root) links.push({
            source: node.parent,
            target: node
        });
    });
    return links;
}


function $3bf5d97c8df5a843$export$2e2bcd8739ae039(data, children) {
    var root = new $3bf5d97c8df5a843$export$85c928794f8d04d4(data), valued = +data.value && (root.value = data.value), node, nodes = [
        root
    ], child, childs, i, n;
    if (children == null) children = $3bf5d97c8df5a843$var$defaultChildren;
    while(node = nodes.pop()){
        if (valued) node.value = +node.data.value;
        if ((childs = children(node.data)) && (n = childs.length)) {
            node.children = new Array(n);
            for(i = n - 1; i >= 0; --i){
                nodes.push(child = node.children[i] = new $3bf5d97c8df5a843$export$85c928794f8d04d4(childs[i]));
                child.parent = node;
                child.depth = node.depth + 1;
            }
        }
    }
    return root.eachBefore($3bf5d97c8df5a843$export$5af32d52ab5dfd57);
}
function $3bf5d97c8df5a843$var$node_copy() {
    return $3bf5d97c8df5a843$export$2e2bcd8739ae039(this).eachBefore($3bf5d97c8df5a843$var$copyData);
}
function $3bf5d97c8df5a843$var$defaultChildren(d) {
    return d.children;
}
function $3bf5d97c8df5a843$var$copyData(node) {
    node.data = node.data.data;
}
function $3bf5d97c8df5a843$export$5af32d52ab5dfd57(node) {
    var height = 0;
    do node.height = height;
    while ((node = node.parent) && node.height < ++height);
}
function $3bf5d97c8df5a843$export$85c928794f8d04d4(data) {
    this.data = data;
    this.depth = this.height = 0;
    this.parent = null;
}
$3bf5d97c8df5a843$export$85c928794f8d04d4.prototype = $3bf5d97c8df5a843$export$2e2bcd8739ae039.prototype = {
    constructor: $3bf5d97c8df5a843$export$85c928794f8d04d4,
    count: (0, $5bc0462261dda62e$export$2e2bcd8739ae039),
    each: (0, $4c30aea04bed84ec$export$2e2bcd8739ae039),
    eachAfter: (0, $ac5e692b1c1ae126$export$2e2bcd8739ae039),
    eachBefore: (0, $e8b0c0755eb39e09$export$2e2bcd8739ae039),
    sum: (0, $e8f7e4de6be0a566$export$2e2bcd8739ae039),
    sort: (0, $63b2c03ec9b90c3e$export$2e2bcd8739ae039),
    path: (0, $6d77ff71a102bad9$export$2e2bcd8739ae039),
    ancestors: (0, $87d220309bf2b9cb$export$2e2bcd8739ae039),
    descendants: (0, $c60af1c30d4766c7$export$2e2bcd8739ae039),
    leaves: (0, $b81d3ab9f250955f$export$2e2bcd8739ae039),
    links: (0, $be05b6e58b221f10$export$2e2bcd8739ae039),
    copy: $3bf5d97c8df5a843$var$node_copy
};


function $a9b15b2becedf3fd$var$defaultSeparation(a, b) {
    return a.parent === b.parent ? 1 : 2;
}
// function radialSeparation(a, b) {
//   return (a.parent === b.parent ? 1 : 2) / a.depth;
// }
// This function is used to traverse the left contour of a subtree (or
// subforest). It returns the successor of v on this contour. This successor is
// either given by the leftmost child of v or by the thread of v. The function
// returns null if and only if v is on the highest level of its subtree.
function $a9b15b2becedf3fd$var$nextLeft(v) {
    var children = v.children;
    return children ? children[0] : v.t;
}
// This function works analogously to nextLeft.
function $a9b15b2becedf3fd$var$nextRight(v) {
    var children = v.children;
    return children ? children[children.length - 1] : v.t;
}
// Shifts the current subtree rooted at w+. This is done by increasing
// prelim(w+) and mod(w+) by shift.
function $a9b15b2becedf3fd$var$moveSubtree(wm, wp, shift) {
    var change = shift / (wp.i - wm.i);
    wp.c -= change;
    wp.s += shift;
    wm.c += change;
    wp.z += shift;
    wp.m += shift;
}
// All other shifts, applied to the smaller subtrees between w- and w+, are
// performed by this function. To prepare the shifts, we have to adjust
// change(w+), shift(w+), and change(w-).
function $a9b15b2becedf3fd$var$executeShifts(v) {
    var shift = 0, change = 0, children = v.children, i = children.length, w;
    while(--i >= 0){
        w = children[i];
        w.z += shift;
        w.m += shift;
        shift += w.s + (change += w.c);
    }
}
// If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
// returns the specified (default) ancestor.
function $a9b15b2becedf3fd$var$nextAncestor(vim, v, ancestor) {
    return vim.a.parent === v.parent ? vim.a : ancestor;
}
function $a9b15b2becedf3fd$var$TreeNode(node, i) {
    this._ = node;
    this.parent = null;
    this.children = null;
    this.A = null; // default ancestor
    this.a = this; // ancestor
    this.z = 0; // prelim
    this.m = 0; // mod
    this.c = 0; // change
    this.s = 0; // shift
    this.t = null; // thread
    this.i = i; // number
}
$a9b15b2becedf3fd$var$TreeNode.prototype = Object.create((0, $3bf5d97c8df5a843$export$85c928794f8d04d4).prototype);
function $a9b15b2becedf3fd$var$treeRoot(root) {
    var tree = new $a9b15b2becedf3fd$var$TreeNode(root, 0), node, nodes = [
        tree
    ], child, children, i, n;
    while(node = nodes.pop())if (children = node._.children) {
        node.children = new Array(n = children.length);
        for(i = n - 1; i >= 0; --i){
            nodes.push(child = node.children[i] = new $a9b15b2becedf3fd$var$TreeNode(children[i], i));
            child.parent = node;
        }
    }
    (tree.parent = new $a9b15b2becedf3fd$var$TreeNode(null, 0)).children = [
        tree
    ];
    return tree;
}
function $a9b15b2becedf3fd$export$2e2bcd8739ae039() {
    var separation = $a9b15b2becedf3fd$var$defaultSeparation, dx = 1, dy = 1, nodeSize = null;
    function tree(root) {
        var t = $a9b15b2becedf3fd$var$treeRoot(root);
        // Compute the layout using Buchheim et al.’s algorithm.
        t.eachAfter(firstWalk), t.parent.m = -t.z;
        t.eachBefore(secondWalk);
        // If a fixed node size is specified, scale x and y.
        if (nodeSize) root.eachBefore(sizeNode);
        else {
            var left = root, right = root, bottom = root;
            root.eachBefore(function(node) {
                if (node.x < left.x) left = node;
                if (node.x > right.x) right = node;
                if (node.depth > bottom.depth) bottom = node;
            });
            var s = left === right ? 1 : separation(left, right) / 2, tx = s - left.x, kx = dx / (right.x + s + tx), ky = dy / (bottom.depth || 1);
            root.eachBefore(function(node) {
                node.x = (node.x + tx) * kx;
                node.y = node.depth * ky;
            });
        }
        return root;
    }
    // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
    // applied recursively to the children of v, as well as the function
    // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
    // node v is placed to the midpoint of its outermost children.
    function firstWalk(v) {
        var children = v.children, siblings = v.parent.children, w = v.i ? siblings[v.i - 1] : null;
        if (children) {
            $a9b15b2becedf3fd$var$executeShifts(v);
            var midpoint = (children[0].z + children[children.length - 1].z) / 2;
            if (w) {
                v.z = w.z + separation(v._, w._);
                v.m = v.z - midpoint;
            } else v.z = midpoint;
        } else if (w) v.z = w.z + separation(v._, w._);
        v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
    }
    // Computes all real x-coordinates by summing up the modifiers recursively.
    function secondWalk(v) {
        v._.x = v.z + v.parent.m;
        v.m += v.parent.m;
    }
    // The core of the algorithm. Here, a new subtree is combined with the
    // previous subtrees. Threads are used to traverse the inside and outside
    // contours of the left and right subtree up to the highest common level. The
    // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
    // superscript o means outside and i means inside, the subscript - means left
    // subtree and + means right subtree. For summing up the modifiers along the
    // contour, we use respective variables si+, si-, so-, and so+. Whenever two
    // nodes of the inside contours conflict, we compute the left one of the
    // greatest uncommon ancestors using the function ANCESTOR and call MOVE
    // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
    // Finally, we add a new thread (if necessary).
    function apportion(v, w, ancestor) {
        if (w) {
            var vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
            while(vim = $a9b15b2becedf3fd$var$nextRight(vim), vip = $a9b15b2becedf3fd$var$nextLeft(vip), vim && vip){
                vom = $a9b15b2becedf3fd$var$nextLeft(vom);
                vop = $a9b15b2becedf3fd$var$nextRight(vop);
                vop.a = v;
                shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
                if (shift > 0) {
                    $a9b15b2becedf3fd$var$moveSubtree($a9b15b2becedf3fd$var$nextAncestor(vim, v, ancestor), v, shift);
                    sip += shift;
                    sop += shift;
                }
                sim += vim.m;
                sip += vip.m;
                som += vom.m;
                sop += vop.m;
            }
            if (vim && !$a9b15b2becedf3fd$var$nextRight(vop)) {
                vop.t = vim;
                vop.m += sim - sop;
            }
            if (vip && !$a9b15b2becedf3fd$var$nextLeft(vom)) {
                vom.t = vip;
                vom.m += sip - som;
                ancestor = v;
            }
        }
        return ancestor;
    }
    function sizeNode(node) {
        node.x *= dx;
        node.y = node.depth * dy;
    }
    tree.separation = function(x) {
        return arguments.length ? (separation = x, tree) : separation;
    };
    tree.size = function(x) {
        return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : nodeSize ? null : [
            dx,
            dy
        ];
    };
    tree.nodeSize = function(x) {
        return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : nodeSize ? [
            dx,
            dy
        ] : null;
    };
    return tree;
}



const $fb731c5040e585f2$var$DEFAULT_LINK = {
    source: {
        x: 0,
        y: 0
    },
    target: {
        x: 0,
        y: 0
    }
};
function $fb731c5040e585f2$export$2e2bcd8739ae039(_ref) {
    let { link: link = $fb731c5040e585f2$var$DEFAULT_LINK } = _ref;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("line", {
        x1: link.source.x,
        y1: link.source.y,
        x2: link.target.x,
        y2: link.target.y,
        strokeWidth: 2,
        stroke: "#999",
        strokeOpacity: 0.6
    });
}



function $86bf3d84ae824766$export$2e2bcd8739ae039(_ref) {
    let { node: node = {
        x: 0,
        y: 0,
        r: 15
    } } = _ref;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("circle", {
        cx: node.x,
        cy: node.y,
        r: node.r || 15,
        fill: "#21D4FD"
    });
}



function $f2ca98a84a961b41$export$2e2bcd8739ae039(_ref) {
    let { top: top, left: left, className: className, root: root, size: size, nodeSize: nodeSize, separation: separation, children: children, linkComponent: linkComponent = (0, $fb731c5040e585f2$export$2e2bcd8739ae039), nodeComponent: nodeComponent = (0, $86bf3d84ae824766$export$2e2bcd8739ae039) } = _ref;
    const tree = (0, $a9b15b2becedf3fd$export$2e2bcd8739ae039)();
    if (size) tree.size(size);
    if (nodeSize) tree.nodeSize(nodeSize);
    if (separation) tree.separation(separation);
    const data = tree(root);
    if (children) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: children(data)
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)((0, $268dd56f34f61467$export$2e2bcd8739ae039), {
        top: top,
        left: left,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-tree', className),
        children: [
            linkComponent && data.links().map((link, i)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $268dd56f34f61467$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $5E6i4.createElement)(linkComponent, {
                        link: link
                    })
                }, `tree-link-${i}`)),
            nodeComponent && data.descendants().map((node, i)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $268dd56f34f61467$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $5E6i4.createElement)(nodeComponent, {
                        node: node
                    })
                }, `tree-node-${i}`))
        ]
    });
}



var $5E6i4 = parcelRequire("5E6i4");


function $817a5d33f6308ece$export$2e2bcd8739ae039(node) {
    node.x0 = Math.round(node.x0);
    node.y0 = Math.round(node.y0);
    node.x1 = Math.round(node.x1);
    node.y1 = Math.round(node.y1);
}


function $448c20a5851826a5$export$2e2bcd8739ae039(parent, x0, y0, x1, y1) {
    var nodes = parent.children, node, i = -1, n = nodes.length, k = parent.value && (x1 - x0) / parent.value;
    while(++i < n){
        node = nodes[i], node.y0 = y0, node.y1 = y1;
        node.x0 = x0, node.x1 = x0 += node.value * k;
    }
}


function $ec2543105d42e7ce$export$2e2bcd8739ae039(parent, x0, y0, x1, y1) {
    var nodes = parent.children, node, i = -1, n = nodes.length, k = parent.value && (y1 - y0) / parent.value;
    while(++i < n){
        node = nodes[i], node.x0 = x0, node.x1 = x1;
        node.y0 = y0, node.y1 = y0 += node.value * k;
    }
}


var $dd2f19c881e0175e$export$324943737027944a = (1 + Math.sqrt(5)) / 2;
function $dd2f19c881e0175e$export$9ff1217655212093(ratio, parent, x0, y0, x1, y1) {
    var rows = [], nodes = parent.children, row, nodeValue, i0 = 0, i1 = 0, n = nodes.length, dx, dy, value = parent.value, sumValue, minValue, maxValue, newRatio, minRatio, alpha, beta;
    while(i0 < n){
        dx = x1 - x0, dy = y1 - y0;
        // Find the next non-empty node.
        do sumValue = nodes[i1++].value;
        while (!sumValue && i1 < n);
        minValue = maxValue = sumValue;
        alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
        beta = sumValue * sumValue * alpha;
        minRatio = Math.max(maxValue / beta, beta / minValue);
        // Keep adding nodes while the aspect ratio maintains or improves.
        for(; i1 < n; ++i1){
            sumValue += nodeValue = nodes[i1].value;
            if (nodeValue < minValue) minValue = nodeValue;
            if (nodeValue > maxValue) maxValue = nodeValue;
            beta = sumValue * sumValue * alpha;
            newRatio = Math.max(maxValue / beta, beta / minValue);
            if (newRatio > minRatio) {
                sumValue -= nodeValue;
                break;
            }
            minRatio = newRatio;
        }
        // Position and record the row orientation.
        rows.push(row = {
            value: sumValue,
            dice: dx < dy,
            children: nodes.slice(i0, i1)
        });
        if (row.dice) (0, $448c20a5851826a5$export$2e2bcd8739ae039)(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
        else (0, $ec2543105d42e7ce$export$2e2bcd8739ae039)(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
        value -= sumValue, i0 = i1;
    }
    return rows;
}
var $dd2f19c881e0175e$export$2e2bcd8739ae039 = function custom(ratio) {
    function squarify(parent, x0, y0, x1, y1) {
        $dd2f19c881e0175e$export$9ff1217655212093(ratio, parent, x0, y0, x1, y1);
    }
    squarify.ratio = function(x) {
        return custom((x = +x) > 1 ? x : 1);
    };
    return squarify;
}($dd2f19c881e0175e$export$324943737027944a);


function $e1aae961c39b6653$export$516e28dec6a4b6d4(f) {
    return f == null ? null : $e1aae961c39b6653$export$a7a0278c004aac3f(f);
}
function $e1aae961c39b6653$export$a7a0278c004aac3f(f) {
    if (typeof f !== "function") throw new Error;
    return f;
}


function $f2f9aa13a48c75cf$export$99e2e371aa6a9db() {
    return 0;
}
function $f2f9aa13a48c75cf$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $823a982916de6fe5$export$2e2bcd8739ae039() {
    var tile = (0, $dd2f19c881e0175e$export$2e2bcd8739ae039), round = false, dx = 1, dy = 1, paddingStack = [
        0
    ], paddingInner = (0, $f2f9aa13a48c75cf$export$99e2e371aa6a9db), paddingTop = (0, $f2f9aa13a48c75cf$export$99e2e371aa6a9db), paddingRight = (0, $f2f9aa13a48c75cf$export$99e2e371aa6a9db), paddingBottom = (0, $f2f9aa13a48c75cf$export$99e2e371aa6a9db), paddingLeft = (0, $f2f9aa13a48c75cf$export$99e2e371aa6a9db);
    function treemap(root) {
        root.x0 = root.y0 = 0;
        root.x1 = dx;
        root.y1 = dy;
        root.eachBefore(positionNode);
        paddingStack = [
            0
        ];
        if (round) root.eachBefore((0, $817a5d33f6308ece$export$2e2bcd8739ae039));
        return root;
    }
    function positionNode(node) {
        var p = paddingStack[node.depth], x0 = node.x0 + p, y0 = node.y0 + p, x1 = node.x1 - p, y1 = node.y1 - p;
        if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
        if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
        node.x0 = x0;
        node.y0 = y0;
        node.x1 = x1;
        node.y1 = y1;
        if (node.children) {
            p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
            x0 += paddingLeft(node) - p;
            y0 += paddingTop(node) - p;
            x1 -= paddingRight(node) - p;
            y1 -= paddingBottom(node) - p;
            if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
            if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
            tile(node, x0, y0, x1, y1);
        }
    }
    treemap.round = function(x) {
        return arguments.length ? (round = !!x, treemap) : round;
    };
    treemap.size = function(x) {
        return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [
            dx,
            dy
        ];
    };
    treemap.tile = function(x) {
        return arguments.length ? (tile = (0, $e1aae961c39b6653$export$a7a0278c004aac3f)(x), treemap) : tile;
    };
    treemap.padding = function(x) {
        return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
    };
    treemap.paddingInner = function(x) {
        return arguments.length ? (paddingInner = typeof x === "function" ? x : (0, $f2f9aa13a48c75cf$export$2e2bcd8739ae039)(+x), treemap) : paddingInner;
    };
    treemap.paddingOuter = function(x) {
        return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
    };
    treemap.paddingTop = function(x) {
        return arguments.length ? (paddingTop = typeof x === "function" ? x : (0, $f2f9aa13a48c75cf$export$2e2bcd8739ae039)(+x), treemap) : paddingTop;
    };
    treemap.paddingRight = function(x) {
        return arguments.length ? (paddingRight = typeof x === "function" ? x : (0, $f2f9aa13a48c75cf$export$2e2bcd8739ae039)(+x), treemap) : paddingRight;
    };
    treemap.paddingBottom = function(x) {
        return arguments.length ? (paddingBottom = typeof x === "function" ? x : (0, $f2f9aa13a48c75cf$export$2e2bcd8739ae039)(+x), treemap) : paddingBottom;
    };
    treemap.paddingLeft = function(x) {
        return arguments.length ? (paddingLeft = typeof x === "function" ? x : (0, $f2f9aa13a48c75cf$export$2e2bcd8739ae039)(+x), treemap) : paddingLeft;
    };
    return treemap;
}



function $456f79e8be4afdec$export$2e2bcd8739ae039(_ref) {
    let { node: { x0: x0, x1: x1, y0: y0, y1: y1 } } = _ref;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("rect", {
        x: x0,
        y: y0,
        width: Math.abs(x1 - x0),
        height: Math.abs(y1 - y0),
        fill: "#21D4FD"
    });
}


/**
 * This is a workaround for TypeScript not inferring the correct
 * method overload/signature for some d3 shape methods.
 */ function $1e51454be2a1e3fa$export$2e2bcd8739ae039(func, value) {
    if (typeof value === 'number') func(value);
    else func(value);
}



function $249f5137a571bbbf$export$2e2bcd8739ae039(_ref) {
    let { top: top, left: left, className: className, root: root, tile: tile, size: size, round: round, padding: padding, paddingInner: paddingInner, paddingOuter: paddingOuter, paddingTop: paddingTop, paddingRight: paddingRight, paddingBottom: paddingBottom, paddingLeft: paddingLeft, children: children, nodeComponent: nodeComponent = (0, $456f79e8be4afdec$export$2e2bcd8739ae039) } = _ref;
    const treemap = (0, $823a982916de6fe5$export$2e2bcd8739ae039)();
    if (tile) treemap.tile(tile);
    if (size) treemap.size(size);
    if (round) treemap.round(round);
    if (padding) (0, $1e51454be2a1e3fa$export$2e2bcd8739ae039)(treemap.padding, padding);
    if (paddingInner) (0, $1e51454be2a1e3fa$export$2e2bcd8739ae039)(treemap.paddingInner, paddingInner);
    if (paddingOuter) (0, $1e51454be2a1e3fa$export$2e2bcd8739ae039)(treemap.paddingOuter, paddingOuter);
    if (paddingTop) (0, $1e51454be2a1e3fa$export$2e2bcd8739ae039)(treemap.paddingTop, paddingTop);
    if (paddingRight) (0, $1e51454be2a1e3fa$export$2e2bcd8739ae039)(treemap.paddingRight, paddingRight);
    if (paddingBottom) (0, $1e51454be2a1e3fa$export$2e2bcd8739ae039)(treemap.paddingBottom, paddingBottom);
    if (paddingLeft) (0, $1e51454be2a1e3fa$export$2e2bcd8739ae039)(treemap.paddingLeft, paddingLeft);
    const data = treemap(root);
    if (children) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: children(data)
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $268dd56f34f61467$export$2e2bcd8739ae039), {
        top: top,
        left: left,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-treemap', className),
        children: nodeComponent && data.descendants().map((node, i)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $268dd56f34f61467$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $5E6i4.createElement)(nodeComponent, {
                    node: node
                })
            }, `treemap-node-${i}`))
    });
}



var $5E6i4 = parcelRequire("5E6i4");


function $cf28743afa372daf$var$defaultSeparation(a, b) {
    return a.parent === b.parent ? 1 : 2;
}
function $cf28743afa372daf$var$meanX(children) {
    return children.reduce($cf28743afa372daf$var$meanXReduce, 0) / children.length;
}
function $cf28743afa372daf$var$meanXReduce(x, c) {
    return x + c.x;
}
function $cf28743afa372daf$var$maxY(children) {
    return 1 + children.reduce($cf28743afa372daf$var$maxYReduce, 0);
}
function $cf28743afa372daf$var$maxYReduce(y, c) {
    return Math.max(y, c.y);
}
function $cf28743afa372daf$var$leafLeft(node) {
    var children;
    while(children = node.children)node = children[0];
    return node;
}
function $cf28743afa372daf$var$leafRight(node) {
    var children;
    while(children = node.children)node = children[children.length - 1];
    return node;
}
function $cf28743afa372daf$export$2e2bcd8739ae039() {
    var separation = $cf28743afa372daf$var$defaultSeparation, dx = 1, dy = 1, nodeSize = false;
    function cluster(root) {
        var previousNode, x = 0;
        // First walk, computing the initial x & y values.
        root.eachAfter(function(node) {
            var children = node.children;
            if (children) {
                node.x = $cf28743afa372daf$var$meanX(children);
                node.y = $cf28743afa372daf$var$maxY(children);
            } else {
                node.x = previousNode ? x += separation(node, previousNode) : 0;
                node.y = 0;
                previousNode = node;
            }
        });
        var left = $cf28743afa372daf$var$leafLeft(root), right = $cf28743afa372daf$var$leafRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
        // Second walk, normalizing x & y to the desired size.
        return root.eachAfter(nodeSize ? function(node) {
            node.x = (node.x - root.x) * dx;
            node.y = (root.y - node.y) * dy;
        } : function(node) {
            node.x = (node.x - x0) / (x1 - x0) * dx;
            node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
        });
    }
    cluster.separation = function(x) {
        return arguments.length ? (separation = x, cluster) : separation;
    };
    cluster.size = function(x) {
        return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : nodeSize ? null : [
            dx,
            dy
        ];
    };
    cluster.nodeSize = function(x) {
        return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : nodeSize ? [
            dx,
            dy
        ] : null;
    };
    return cluster;
}





function $f91b3624e0cdc061$export$2e2bcd8739ae039(_ref) {
    let { top: top, left: left, className: className, root: root, size: size, nodeSize: nodeSize, separation: separation, children: children, linkComponent: linkComponent = (0, $fb731c5040e585f2$export$2e2bcd8739ae039), nodeComponent: nodeComponent = (0, $86bf3d84ae824766$export$2e2bcd8739ae039) } = _ref;
    const cluster = (0, $cf28743afa372daf$export$2e2bcd8739ae039)();
    if (size) cluster.size(size);
    if (nodeSize !== undefined) cluster.nodeSize(nodeSize);
    if (separation) cluster.separation(separation);
    const data = cluster(root);
    if (children) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: children(data)
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)((0, $268dd56f34f61467$export$2e2bcd8739ae039), {
        top: top,
        left: left,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-cluster', className),
        children: [
            linkComponent && data.links().map((link, i)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $268dd56f34f61467$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $5E6i4.createElement)(linkComponent, {
                        link: link
                    })
                }, `cluster-link-${i}`)),
            nodeComponent && data.descendants().map((node, i)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $268dd56f34f61467$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $5E6i4.createElement)(nodeComponent, {
                        node: node
                    })
                }, `cluster-node-${i}`))
        ]
    });
}



var $5E6i4 = parcelRequire("5E6i4");


var $f52f4bb1a99b7b75$export$58adb3bec8346d0f = Array.prototype.slice;
function $f52f4bb1a99b7b75$export$448332262467e042(array) {
    var m = array.length, t, i;
    while(m){
        i = Math.random() * m-- | 0;
        t = array[m];
        array[m] = array[i];
        array[i] = t;
    }
    return array;
}


function $5a51c17b0ce0d213$export$2e2bcd8739ae039(circles) {
    var i = 0, n = (circles = (0, $f52f4bb1a99b7b75$export$448332262467e042)((0, $f52f4bb1a99b7b75$export$58adb3bec8346d0f).call(circles))).length, B = [], p, e;
    while(i < n){
        p = circles[i];
        if (e && $5a51c17b0ce0d213$var$enclosesWeak(e, p)) ++i;
        else e = $5a51c17b0ce0d213$var$encloseBasis(B = $5a51c17b0ce0d213$var$extendBasis(B, p)), i = 0;
    }
    return e;
}
function $5a51c17b0ce0d213$var$extendBasis(B, p) {
    var i, j;
    if ($5a51c17b0ce0d213$var$enclosesWeakAll(p, B)) return [
        p
    ];
    // If we get here then B must have at least one element.
    for(i = 0; i < B.length; ++i){
        if ($5a51c17b0ce0d213$var$enclosesNot(p, B[i]) && $5a51c17b0ce0d213$var$enclosesWeakAll($5a51c17b0ce0d213$var$encloseBasis2(B[i], p), B)) return [
            B[i],
            p
        ];
    }
    // If we get here then B must have at least two elements.
    for(i = 0; i < B.length - 1; ++i)for(j = i + 1; j < B.length; ++j){
        if ($5a51c17b0ce0d213$var$enclosesNot($5a51c17b0ce0d213$var$encloseBasis2(B[i], B[j]), p) && $5a51c17b0ce0d213$var$enclosesNot($5a51c17b0ce0d213$var$encloseBasis2(B[i], p), B[j]) && $5a51c17b0ce0d213$var$enclosesNot($5a51c17b0ce0d213$var$encloseBasis2(B[j], p), B[i]) && $5a51c17b0ce0d213$var$enclosesWeakAll($5a51c17b0ce0d213$var$encloseBasis3(B[i], B[j], p), B)) return [
            B[i],
            B[j],
            p
        ];
    }
    // If we get here then something is very wrong.
    throw new Error;
}
function $5a51c17b0ce0d213$var$enclosesNot(a, b) {
    var dr = a.r - b.r, dx = b.x - a.x, dy = b.y - a.y;
    return dr < 0 || dr * dr < dx * dx + dy * dy;
}
function $5a51c17b0ce0d213$var$enclosesWeak(a, b) {
    var dr = a.r - b.r + 1e-6, dx = b.x - a.x, dy = b.y - a.y;
    return dr > 0 && dr * dr > dx * dx + dy * dy;
}
function $5a51c17b0ce0d213$var$enclosesWeakAll(a, B) {
    for(var i = 0; i < B.length; ++i){
        if (!$5a51c17b0ce0d213$var$enclosesWeak(a, B[i])) return false;
    }
    return true;
}
function $5a51c17b0ce0d213$var$encloseBasis(B) {
    switch(B.length){
        case 1:
            return $5a51c17b0ce0d213$var$encloseBasis1(B[0]);
        case 2:
            return $5a51c17b0ce0d213$var$encloseBasis2(B[0], B[1]);
        case 3:
            return $5a51c17b0ce0d213$var$encloseBasis3(B[0], B[1], B[2]);
    }
}
function $5a51c17b0ce0d213$var$encloseBasis1(a) {
    return {
        x: a.x,
        y: a.y,
        r: a.r
    };
}
function $5a51c17b0ce0d213$var$encloseBasis2(a, b) {
    var x1 = a.x, y1 = a.y, r1 = a.r, x2 = b.x, y2 = b.y, r2 = b.r, x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1, l = Math.sqrt(x21 * x21 + y21 * y21);
    return {
        x: (x1 + x2 + x21 / l * r21) / 2,
        y: (y1 + y2 + y21 / l * r21) / 2,
        r: (l + r1 + r2) / 2
    };
}
function $5a51c17b0ce0d213$var$encloseBasis3(a, b, c) {
    var x1 = a.x, y1 = a.y, r1 = a.r, x2 = b.x, y2 = b.y, r2 = b.r, x3 = c.x, y3 = c.y, r3 = c.r, a2 = x1 - x2, a3 = x1 - x3, b2 = y1 - y2, b3 = y1 - y3, c2 = r2 - r1, c3 = r3 - r1, d1 = x1 * x1 + y1 * y1 - r1 * r1, d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2, d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3, ab = a3 * b2 - a2 * b3, xa = (b2 * d3 - b3 * d2) / (ab * 2) - x1, xb = (b3 * c2 - b2 * c3) / ab, ya = (a3 * d2 - a2 * d3) / (ab * 2) - y1, yb = (a2 * c3 - a3 * c2) / ab, A = xb * xb + yb * yb - 1, B = 2 * (r1 + xa * xb + ya * yb), C = xa * xa + ya * ya - r1 * r1, r = -(A ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
    return {
        x: x1 + xa + xb * r,
        y: y1 + ya + yb * r,
        r: r
    };
}


function $cb892481955f462d$var$place(b, a, c) {
    var dx = b.x - a.x, x, a2, dy = b.y - a.y, y, b2, d2 = dx * dx + dy * dy;
    if (d2) {
        a2 = a.r + c.r, a2 *= a2;
        b2 = b.r + c.r, b2 *= b2;
        if (a2 > b2) {
            x = (d2 + b2 - a2) / (2 * d2);
            y = Math.sqrt(Math.max(0, b2 / d2 - x * x));
            c.x = b.x - x * dx - y * dy;
            c.y = b.y - x * dy + y * dx;
        } else {
            x = (d2 + a2 - b2) / (2 * d2);
            y = Math.sqrt(Math.max(0, a2 / d2 - x * x));
            c.x = a.x + x * dx - y * dy;
            c.y = a.y + x * dy + y * dx;
        }
    } else {
        c.x = a.x + c.r;
        c.y = a.y;
    }
}
function $cb892481955f462d$var$intersects(a, b) {
    var dr = a.r + b.r - 1e-6, dx = b.x - a.x, dy = b.y - a.y;
    return dr > 0 && dr * dr > dx * dx + dy * dy;
}
function $cb892481955f462d$var$score(node) {
    var a = node._, b = node.next._, ab = a.r + b.r, dx = (a.x * b.r + b.x * a.r) / ab, dy = (a.y * b.r + b.y * a.r) / ab;
    return dx * dx + dy * dy;
}
function $cb892481955f462d$var$Node(circle) {
    this._ = circle;
    this.next = null;
    this.previous = null;
}
function $cb892481955f462d$export$b86b5dcbc4bfc7a7(circles) {
    if (!(n = circles.length)) return 0;
    var a, b, c, n, aa, ca, i, j, k, sj, sk;
    // Place the first circle.
    a = circles[0], a.x = 0, a.y = 0;
    if (!(n > 1)) return a.r;
    // Place the second circle.
    b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
    if (!(n > 2)) return a.r + b.r;
    // Place the third circle.
    $cb892481955f462d$var$place(b, a, c = circles[2]);
    // Initialize the front-chain using the first three circles a, b and c.
    a = new $cb892481955f462d$var$Node(a), b = new $cb892481955f462d$var$Node(b), c = new $cb892481955f462d$var$Node(c);
    a.next = c.previous = b;
    b.next = a.previous = c;
    c.next = b.previous = a;
    // Attempt to place each remaining circle…
    pack: for(i = 3; i < n; ++i){
        $cb892481955f462d$var$place(a._, b._, c = circles[i]), c = new $cb892481955f462d$var$Node(c);
        // Find the closest intersecting circle on the front-chain, if any.
        // “Closeness” is determined by linear distance along the front-chain.
        // “Ahead” or “behind” is likewise determined by linear distance.
        j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
        do if (sj <= sk) {
            if ($cb892481955f462d$var$intersects(j._, c._)) {
                b = j, a.next = b, b.previous = a, --i;
                continue pack;
            }
            sj += j._.r, j = j.next;
        } else {
            if ($cb892481955f462d$var$intersects(k._, c._)) {
                a = k, a.next = b, b.previous = a, --i;
                continue pack;
            }
            sk += k._.r, k = k.previous;
        }
        while (j !== k.next);
        // Success! Insert the new circle c between a and b.
        c.previous = a, c.next = b, a.next = b.previous = b = c;
        // Compute the new closest circle pair to the centroid.
        aa = $cb892481955f462d$var$score(a);
        while((c = c.next) !== b)if ((ca = $cb892481955f462d$var$score(c)) < aa) a = c, aa = ca;
        b = a.next;
    }
    // Compute the enclosing circle of the front chain.
    a = [
        b._
    ], c = b;
    while((c = c.next) !== b)a.push(c._);
    c = (0, $5a51c17b0ce0d213$export$2e2bcd8739ae039)(a);
    // Translate the circles to put the enclosing circle around the origin.
    for(i = 0; i < n; ++i)a = circles[i], a.x -= c.x, a.y -= c.y;
    return c.r;
}
function $cb892481955f462d$export$2e2bcd8739ae039(circles) {
    $cb892481955f462d$export$b86b5dcbc4bfc7a7(circles);
    return circles;
}




function $cbe0a782b031f558$var$defaultRadius(d) {
    return Math.sqrt(d.value);
}
function $cbe0a782b031f558$export$2e2bcd8739ae039() {
    var radius = null, dx = 1, dy = 1, padding = (0, $f2f9aa13a48c75cf$export$99e2e371aa6a9db);
    function pack(root) {
        root.x = dx / 2, root.y = dy / 2;
        if (radius) root.eachBefore($cbe0a782b031f558$var$radiusLeaf(radius)).eachAfter($cbe0a782b031f558$var$packChildren(padding, 0.5)).eachBefore($cbe0a782b031f558$var$translateChild(1));
        else root.eachBefore($cbe0a782b031f558$var$radiusLeaf($cbe0a782b031f558$var$defaultRadius)).eachAfter($cbe0a782b031f558$var$packChildren((0, $f2f9aa13a48c75cf$export$99e2e371aa6a9db), 1)).eachAfter($cbe0a782b031f558$var$packChildren(padding, root.r / Math.min(dx, dy))).eachBefore($cbe0a782b031f558$var$translateChild(Math.min(dx, dy) / (2 * root.r)));
        return root;
    }
    pack.radius = function(x) {
        return arguments.length ? (radius = (0, $e1aae961c39b6653$export$516e28dec6a4b6d4)(x), pack) : radius;
    };
    pack.size = function(x) {
        return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [
            dx,
            dy
        ];
    };
    pack.padding = function(x) {
        return arguments.length ? (padding = typeof x === "function" ? x : (0, $f2f9aa13a48c75cf$export$2e2bcd8739ae039)(+x), pack) : padding;
    };
    return pack;
}
function $cbe0a782b031f558$var$radiusLeaf(radius) {
    return function(node) {
        if (!node.children) node.r = Math.max(0, +radius(node) || 0);
    };
}
function $cbe0a782b031f558$var$packChildren(padding, k) {
    return function(node) {
        if (children = node.children) {
            var children, i, n = children.length, r = padding(node) * k || 0, e;
            if (r) for(i = 0; i < n; ++i)children[i].r += r;
            e = (0, $cb892481955f462d$export$b86b5dcbc4bfc7a7)(children);
            if (r) for(i = 0; i < n; ++i)children[i].r -= r;
            node.r = e + r;
        }
    };
}
function $cbe0a782b031f558$var$translateChild(k) {
    return function(node) {
        var parent = node.parent;
        node.r *= k;
        if (parent) {
            node.x = parent.x + k * node.x;
            node.y = parent.y + k * node.y;
        }
    };
}




function $320313a56821aef9$export$2e2bcd8739ae039(_ref) {
    let { top: top, left: left, className: className, root: root, radius: radius, size: size, padding: padding, children: children, nodeComponent: nodeComponent = (0, $86bf3d84ae824766$export$2e2bcd8739ae039) } = _ref;
    const pack = (0, $cbe0a782b031f558$export$2e2bcd8739ae039)();
    if (size) pack.size(size);
    if (radius !== undefined) pack.radius(radius);
    if (padding) pack.padding(padding);
    const data = pack(root);
    if (children) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: children(data)
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $268dd56f34f61467$export$2e2bcd8739ae039), {
        top: top,
        left: left,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-pack', className),
        children: nodeComponent && data.descendants().map((node, i)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $268dd56f34f61467$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $5E6i4.createElement)(nodeComponent, {
                    node: node
                })
            }, `pack-node-${i}`))
    });
}



var $5E6i4 = parcelRequire("5E6i4");




function $fc873473760a360d$export$2e2bcd8739ae039() {
    var dx = 1, dy = 1, padding = 0, round = false;
    function partition(root) {
        var n = root.height + 1;
        root.x0 = root.y0 = padding;
        root.x1 = dx;
        root.y1 = dy / n;
        root.eachBefore(positionNode(dy, n));
        if (round) root.eachBefore((0, $817a5d33f6308ece$export$2e2bcd8739ae039));
        return root;
    }
    function positionNode(dy, n) {
        return function(node) {
            if (node.children) (0, $448c20a5851826a5$export$2e2bcd8739ae039)(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
            var x0 = node.x0, y0 = node.y0, x1 = node.x1 - padding, y1 = node.y1 - padding;
            if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
            if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
            node.x0 = x0;
            node.y0 = y0;
            node.x1 = x1;
            node.y1 = y1;
        };
    }
    partition.round = function(x) {
        return arguments.length ? (round = !!x, partition) : round;
    };
    partition.size = function(x) {
        return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [
            dx,
            dy
        ];
    };
    partition.padding = function(x) {
        return arguments.length ? (padding = +x, partition) : padding;
    };
    return partition;
}




function $5b0ec4d434c87873$export$2e2bcd8739ae039(_ref) {
    let { top: top, left: left, className: className, root: root, size: size, round: round, padding: padding, children: children, nodeComponent: nodeComponent = (0, $456f79e8be4afdec$export$2e2bcd8739ae039) } = _ref;
    const partition = (0, $fc873473760a360d$export$2e2bcd8739ae039)();
    if (size) partition.size(size);
    if (round) partition.round(round);
    if (padding) partition.padding(padding);
    const data = partition(root);
    if (children) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: children(data)
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $268dd56f34f61467$export$2e2bcd8739ae039), {
        top: top,
        left: left,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-partition', className),
        children: nodeComponent && data.descendants().map((node, i)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $268dd56f34f61467$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $5E6i4.createElement)(nodeComponent, {
                    node: node
                })
            }, `partition-node-${i}`))
    });
}








// @visx/legend


function $394a6d73278016d9$export$2e2bcd8739ae039(_ref) {
    let { flexDirection: flexDirection = 'row', alignItems: alignItems = 'center', margin: margin = '0', display: display = 'flex', children: children, ...restProps } = _ref;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("div", {
        className: "visx-legend-item",
        style: {
            display: display,
            alignItems: alignItems,
            flexDirection: flexDirection,
            margin: margin
        },
        ...restProps,
        children: children
    });
}



function $690686aed3035950$export$2e2bcd8739ae039(_ref) {
    let { flex: flex = '1', label: label, margin: margin = '5px 0', align: align = 'left', children: children, ...restProps } = _ref;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("div", {
        className: "visx-legend-label",
        style: {
            justifyContent: align,
            display: 'flex',
            flex: flex,
            margin: margin
        },
        ...restProps,
        children: children || label
    });
}



function $bc1d0e9dac24187b$export$2e2bcd8739ae039(_ref) {
    let { fill: fill, width: width, height: height, style: style } = _ref;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("div", {
        style: {
            width: width,
            height: height,
            background: fill,
            ...style
        }
    });
}



var $5E6i4 = parcelRequire("5E6i4");



function $85c04d4ea1d1cb47$export$2e2bcd8739ae039(_ref) {
    let { fill: fill, width: width, height: height, style: style } = _ref;
    const cleanWidth = typeof width === 'string' || typeof width === 'undefined' ? 0 : width;
    const cleanHeight = typeof height === 'string' || typeof height === 'undefined' ? 0 : height;
    const size = Math.max(cleanWidth, cleanHeight);
    const radius = size / 2;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("svg", {
        width: size,
        height: size,
        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $268dd56f34f61467$export$2e2bcd8739ae039), {
            top: radius,
            left: radius,
            children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("circle", {
                r: radius,
                fill: fill,
                style: style
            })
        })
    });
}




function $d60a8dfb1c0ffcd9$export$2e2bcd8739ae039(_ref) {
    let { fill: fill, width: width, height: height, style: style } = _ref;
    const cleanHeight = typeof height === 'string' || typeof height === 'undefined' ? 0 : height;
    const lineThickness = typeof style?.strokeWidth === 'number' ? style?.strokeWidth : 2;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("svg", {
        width: width,
        height: height,
        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $268dd56f34f61467$export$2e2bcd8739ae039), {
            top: cleanHeight / 2 - lineThickness / 2,
            children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("line", {
                x1: 0,
                x2: width,
                y1: 0,
                y2: 0,
                stroke: fill,
                strokeWidth: lineThickness,
                style: style
            })
        })
    });
}


const $60275131b7fd72ef$var$NO_OP = ()=>undefined;
function $60275131b7fd72ef$export$2e2bcd8739ae039(_ref) {
    let { shape: shape = 'rect', fill: fill = $60275131b7fd72ef$var$NO_OP, size: size = $60275131b7fd72ef$var$NO_OP, width: width, height: height, label: label, item: item, itemIndex: itemIndex, shapeStyle: shapeStyle = $60275131b7fd72ef$var$NO_OP } = _ref;
    const props = {
        width: width,
        height: height,
        item: item,
        itemIndex: itemIndex,
        label: label,
        fill: fill({
            ...label
        }),
        size: size({
            ...label
        }),
        style: shapeStyle({
            ...label
        })
    };
    if (typeof shape === 'string') {
        if (shape === 'circle') return /*#__PURE__*/ (0, $5E6i4.createElement)((0, $85c04d4ea1d1cb47$export$2e2bcd8739ae039), props);
        if (shape === 'line') return /*#__PURE__*/ (0, $5E6i4.createElement)((0, $d60a8dfb1c0ffcd9$export$2e2bcd8739ae039), props);
        return /*#__PURE__*/ (0, $5E6i4.createElement)((0, $bc1d0e9dac24187b$export$2e2bcd8739ae039), props);
    }
    if (/*#__PURE__*/ (0, $5E6i4.isValidElement)(shape)) return /*#__PURE__*/ (0, $5E6i4.cloneElement)(shape, props);
    if (shape) return /*#__PURE__*/ (0, $5E6i4.createElement)(shape, props);
    return null;
}



function $45179f2ef802cf2e$export$2e2bcd8739ae039(_ref) {
    let { shape: shape = (0, $bc1d0e9dac24187b$export$2e2bcd8739ae039), width: width, height: height, margin: margin, label: label, item: item, itemIndex: itemIndex, fill: fill, size: size, shapeStyle: shapeStyle } = _ref;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("div", {
        className: "visx-legend-shape",
        style: {
            display: 'flex',
            width: size ? size({
                ...label
            }) : width,
            height: size ? size({
                ...label
            }) : height,
            margin: margin
        },
        children: (0, $60275131b7fd72ef$export$2e2bcd8739ae039)({
            shape: shape,
            item: item,
            itemIndex: itemIndex,
            label: label,
            width: width,
            height: height,
            fill: fill,
            shapeStyle: shapeStyle
        })
    });
}


/** Returns an object's value if defined, or the object. */ function $fdb7e99d786b2348$export$2e2bcd8739ae039(_) {
    if (_ && typeof _ === 'object' && 'value' in _ && typeof _.value !== 'undefined') return _.value;
    return _;
}
function $fdb7e99d786b2348$export$e1d8c0161b68b39b(_) {
    return String($fdb7e99d786b2348$export$2e2bcd8739ae039(_));
}


/** Returns a function which takes a Datum and index as input, and returns a formatted label object. */ function $bc0923623d19d1e5$export$2e2bcd8739ae039(_ref) {
    let { scale: scale, labelFormat: labelFormat } = _ref;
    return (d, i)=>({
            datum: d,
            index: i,
            text: `${labelFormat(d, i)}`,
            value: scale(d)
        });
}



const $9f7014900852c782$var$defaultStyle = {
    display: 'flex'
};
function $9f7014900852c782$export$2e2bcd8739ae039(_ref) {
    let { className: className, style: style = $9f7014900852c782$var$defaultStyle, scale: scale, shape: shape, domain: inputDomain, fill: fill = (0, $fdb7e99d786b2348$export$e1d8c0161b68b39b), size: size = (0, $fdb7e99d786b2348$export$e1d8c0161b68b39b), labelFormat: labelFormat = (0, $fdb7e99d786b2348$export$2e2bcd8739ae039), labelTransform: labelTransform = (0, $bc0923623d19d1e5$export$2e2bcd8739ae039), shapeWidth: shapeWidth = 15, shapeHeight: shapeHeight = 15, shapeMargin: shapeMargin = '2px 4px 2px 0', shapeStyle: shapeStyle, labelAlign: labelAlign = 'left', labelFlex: labelFlex = '1', labelMargin: labelMargin = '0 4px', itemMargin: itemMargin = '0', direction: direction = 'column', itemDirection: itemDirection = 'row', legendLabelProps: legendLabelProps, children: children, ...legendItemProps } = _ref;
    // `Scale extends ScaleType` constraint is tricky
    //  could consider removing `scale` altogether in the future and making `domain: Datum[]` required
    const domain = inputDomain || ('domain' in scale ? scale.domain() : []);
    const labelFormatter = labelTransform({
        scale: scale,
        labelFormat: labelFormat
    });
    const labels = domain.map(labelFormatter);
    if (children) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: children(labels)
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-legend', className),
        style: {
            ...style,
            flexDirection: direction
        },
        children: labels.map((label, i)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)((0, $394a6d73278016d9$export$2e2bcd8739ae039), {
                margin: itemMargin,
                flexDirection: itemDirection,
                ...legendItemProps,
                children: [
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $45179f2ef802cf2e$export$2e2bcd8739ae039), {
                        shape: shape,
                        height: shapeHeight,
                        width: shapeWidth,
                        margin: shapeMargin,
                        item: domain[i],
                        itemIndex: i,
                        label: label,
                        fill: fill,
                        size: size,
                        shapeStyle: shapeStyle
                    }),
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $690686aed3035950$export$2e2bcd8739ae039), {
                        label: label.text,
                        flex: labelFlex,
                        margin: labelMargin,
                        align: labelAlign,
                        ...legendLabelProps
                    })
                ]
            }, `legend-${label.text}-${i}`))
    });
}



function $e9e2a322e1ad7830$export$2e2bcd8739ae039(x) {
    return x;
}



function $d3e2baadb061a9d6$var$labelFormatterFactoryFactory(_ref) {
    let { labelDelimiter: labelDelimiter } = _ref;
    return (_ref2)=>{
        let { scale: scale, labelFormat: labelFormat } = _ref2;
        return (datum, index)=>{
            const [x0, x1] = scale.invertExtent(scale(datum));
            return {
                extent: [
                    x0,
                    x1
                ],
                text: `${labelFormat(x0, index)} ${labelDelimiter} ${labelFormat(x1, index)}`,
                value: scale(x0),
                datum: datum,
                index: index
            };
        };
    };
}
function $d3e2baadb061a9d6$export$2e2bcd8739ae039(_ref3) {
    let { domain: inputDomain, scale: scale, labelFormat: labelFormat = (0, $e9e2a322e1ad7830$export$2e2bcd8739ae039), labelTransform: inputLabelTransform, labelDelimiter: labelDelimiter = '-', ...restProps } = _ref3;
    // transform range into input values because it may contain more elements
    const domain = inputDomain || scale.range().map((output)=>scale.invertExtent(output)[0]);
    const labelTransform = inputLabelTransform || $d3e2baadb061a9d6$var$labelFormatterFactoryFactory({
        labelDelimiter: labelDelimiter
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $9f7014900852c782$export$2e2bcd8739ae039), {
        scale: scale,
        domain: domain,
        labelFormat: labelFormat,
        labelTransform: labelTransform,
        ...restProps
    });
}



function $030bc8a3c9a3722e$export$2e2bcd8739ae039(_ref) {
    let { steps: steps = 5, scale: scale } = _ref;
    const domain = scale.domain();
    const start = domain[0];
    const end = domain[domain.length - 1];
    if (typeof start === 'number' && typeof end === 'number') {
        const step = (end - start) / (steps - 1);
        return new Array(steps).fill(1).reduce((acc, cur, i)=>{
            acc.push(start + i * step);
            return acc;
        }, []);
    }
    return [];
}



function $3fcd85171001cce4$export$2e2bcd8739ae039(_ref) {
    let { scale: scale, domain: inputDomain, steps: steps = 5, ...restProps } = _ref;
    const domain = inputDomain || (0, $030bc8a3c9a3722e$export$2e2bcd8739ae039)({
        steps: steps,
        scale: scale
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $9f7014900852c782$export$2e2bcd8739ae039), {
        scale: scale,
        domain: domain,
        ...restProps
    });
}




function $94586c1c7d52d586$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $9f7014900852c782$export$2e2bcd8739ae039), {
        ...props
    });
}





const $b6005bd0e8f85f2b$var$formatZero = (label)=>label === 0 ? '0' : label || '';
/** Default transform implicitly assumes that Datum is of type number. */ function $b6005bd0e8f85f2b$var$defaultTransform(_ref) {
    let { labelDelimiter: labelDelimiter, labelLower: labelLower, labelUpper: labelUpper } = _ref;
    return (_ref2)=>{
        let { scale: scale, labelFormat: labelFormat } = _ref2;
        const scaleRange = scale.range();
        return (d, i)=>{
            const [d0, d1] = scaleRange.length >= i ? scale.invertExtent(scaleRange[i]) : [
                undefined,
                undefined
            ];
            let delimiter = ` ${labelDelimiter} `;
            let text = '';
            let value;
            if (d0 == null && typeof d1 === 'number') {
                // lower threshold e.g., [undefined, number]
                delimiter = labelLower || delimiter;
                value = d1 - Math.abs(2 * d1 - 1); // guarantees a value smaller than the lower threshold
                text = `${delimiter}${$b6005bd0e8f85f2b$var$formatZero(labelFormat(d1, i))}`;
            } else if (d0 != null && d1 != null) {
                // threshold step
                value = d;
                text = `${$b6005bd0e8f85f2b$var$formatZero(labelFormat(d0, i))}${delimiter}${$b6005bd0e8f85f2b$var$formatZero(labelFormat(d1, i))}`;
            } else if (typeof d0 === 'number' && d1 == null) {
                // upper threshold e.g., [number, undefined]
                delimiter = labelUpper || delimiter;
                value = d0 + Math.abs(2 * d0 + 1); // // guarantees a value larger than the upper threshold
                text = `${delimiter}${$b6005bd0e8f85f2b$var$formatZero(labelFormat(d0, i))}`;
            }
            return {
                extent: [
                    d0,
                    d1
                ],
                value: scale(value),
                text: text,
                datum: d,
                index: i
            };
        };
    };
}
function $b6005bd0e8f85f2b$export$2e2bcd8739ae039(_ref3) {
    let { scale: scale, domain: inputDomain, labelFormat: labelFormat = (0, $e9e2a322e1ad7830$export$2e2bcd8739ae039), labelTransform: inputLabelTransform, labelDelimiter: labelDelimiter = 'to', labelLower: labelLower = 'Less than ', labelUpper: labelUpper = 'More than ', ...restProps } = _ref3;
    // d3 docs specify that for n values in a domain, there should be n+1 values in the range
    // https://github.com/d3/d3-scale#threshold_domain
    // therefore if a domain is not specified we transform the range into input values
    // because it should contain more elements
    const domain = inputDomain || scale.range().map((output)=>scale.invertExtent(output)[0]);
    const labelTransform = inputLabelTransform || $b6005bd0e8f85f2b$var$defaultTransform({
        labelDelimiter: labelDelimiter,
        labelLower: labelLower,
        labelUpper: labelUpper
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $9f7014900852c782$export$2e2bcd8739ae039), {
        scale: scale,
        domain: domain,
        labelFormat: labelFormat,
        labelTransform: labelTransform,
        ...restProps
    });
}







function $a2df26f9f0bd2753$export$2e2bcd8739ae039(_ref) {
    let { scale: scale, domain: inputDomain, steps: steps = 5, labelFormat: labelFormat = (0, $e9e2a322e1ad7830$export$2e2bcd8739ae039), labelTransform: labelTransform = (0, $bc0923623d19d1e5$export$2e2bcd8739ae039), ...restProps } = _ref;
    const domain = inputDomain || (0, $030bc8a3c9a3722e$export$2e2bcd8739ae039)({
        steps: steps,
        scale: scale
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $9f7014900852c782$export$2e2bcd8739ae039), {
        scale: scale,
        domain: domain,
        labelFormat: labelFormat,
        labelTransform: labelTransform,
        ...restProps
    });
}










// @visx/marker

function $e4055e566202fe7e$export$2e2bcd8739ae039(_ref) {
    let { id: id, markerWidth: markerWidth = 3, markerHeight: markerHeight = 3, markerUnits: markerUnits = 'userSpaceOnUse', children: children, ...restProps } = _ref;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("defs", {
        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("marker", {
            id: id,
            markerWidth: markerWidth,
            markerHeight: markerHeight,
            markerUnits: markerUnits,
            ...restProps,
            children: children
        })
    });
}




function $8c1bb49b884e94ae$export$2e2bcd8739ae039(_ref) {
    let { id: id, size: size = 9, strokeWidth: strokeWidth = 1, ...restProps } = _ref;
    const max = size + strokeWidth * 2;
    const midX = size;
    const midY = max / 2;
    const points = `0 0, ${size} ${size / 2}, 0 ${size}`;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $e4055e566202fe7e$export$2e2bcd8739ae039), {
        id: id,
        markerWidth: max,
        markerHeight: max,
        refX: midX,
        refY: midY,
        orient: "auto",
        markerUnits: "strokeWidth",
        fill: "none",
        strokeWidth: strokeWidth,
        ...restProps,
        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("g", {
            transform: `translate(${strokeWidth}, ${strokeWidth})`,
            children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("polyline", {
                points: points
            })
        })
    });
}




function $cf6028463231efe8$export$2e2bcd8739ae039(_ref) {
    let { id: id, size: size = 9, strokeWidth: strokeWidth = 1, ...restProps } = _ref;
    const bounds = size + strokeWidth;
    const mid = size / 2;
    const points = `0 ${mid}, ${mid} ${mid}, ${mid} 0, ${mid} ${size}, ${mid} ${mid}, ${size} ${mid}`;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $e4055e566202fe7e$export$2e2bcd8739ae039), {
        id: id,
        markerWidth: bounds,
        markerHeight: bounds,
        refX: mid,
        refY: mid,
        orient: "auto",
        markerUnits: "strokeWidth",
        fill: "none",
        strokeWidth: strokeWidth,
        ...restProps,
        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("polyline", {
            points: points
        })
    });
}




function $39f19b84254adf8a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $cf6028463231efe8$export$2e2bcd8739ae039), {
        orient: 45,
        ...props
    });
}




function $c7fd67a64a7c3298$export$2e2bcd8739ae039(_ref) {
    let { id: id, size: size = 9, strokeWidth: strokeWidth = 1, ...restProps } = _ref;
    const diameter = size * 2;
    const bounds = diameter + strokeWidth;
    const mid = bounds / 2;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $e4055e566202fe7e$export$2e2bcd8739ae039), {
        id: id,
        markerWidth: bounds,
        markerHeight: bounds,
        refX: 0,
        refY: mid,
        orient: "auto-start-reverse",
        markerUnits: "strokeWidth",
        strokeWidth: strokeWidth,
        ...restProps,
        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("circle", {
            r: size,
            cx: mid,
            cy: mid
        })
    });
}




function $b8c8f6b1d439fdac$export$2e2bcd8739ae039(_ref) {
    let { id: id, size: size = 9, fill: fill, stroke: stroke, strokeWidth: strokeWidth = 1, ...restProps } = _ref;
    const max = Math.max(size, strokeWidth * 2);
    const midX = max / 2;
    const midY = size / 2;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $e4055e566202fe7e$export$2e2bcd8739ae039), {
        id: id,
        markerWidth: max,
        markerHeight: size,
        refX: midX,
        refY: midY,
        orient: "auto",
        markerUnits: "strokeWidth",
        fill: fill || stroke,
        stroke: "none",
        ...restProps,
        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("rect", {
            width: strokeWidth,
            height: size,
            x: midX
        })
    });
}




// @visx/mock-data
// https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
const $8cd69b69191949b4$var$mul = 0x19660D;
const $8cd69b69191949b4$var$inc = 0x3C6EF35F;
const $8cd69b69191949b4$var$eps = 1 / 0x100000000;
function $8cd69b69191949b4$export$2e2bcd8739ae039(seed = Math.random()) {
    let state = (0 <= seed && seed < 1 ? seed / $8cd69b69191949b4$var$eps : Math.abs(seed)) | 0;
    return ()=>(state = $8cd69b69191949b4$var$mul * state + $8cd69b69191949b4$var$inc | 0, $8cd69b69191949b4$var$eps * (state >>> 0));
}


function $9fdb9584b90a1623$export$2e2bcd8739ae039(/** Seed in the interval [0, 1). */ seed) {
    return (0, $8cd69b69191949b4$export$2e2bcd8739ae039)(seed);
}


function $4256ccee2925b58c$export$2e2bcd8739ae039(length, /** Optional random seed in the interval [0, 1). */ seed, /** Optional start time in ms UTC. */ startTimeMs) {
    const random = seed == null ? Math.random : (0, $9fdb9584b90a1623$export$2e2bcd8739ae039)(seed);
    const startDateMs = startTimeMs == null ? Date.now() : new Date(startTimeMs).valueOf();
    return new Array(length).fill(1).map((_, idx)=>({
            date: new Date(startDateMs - idx * 3600000),
            // eslint-disable-next-line no-bitwise
            value: random() * 3000 | 0
        }));
}


var $7a4d6af9b607fa6f$export$2e2bcd8739ae039 = Math.random;


var $bb073f6a6ca18415$export$2e2bcd8739ae039 = function sourceRandomNormal(source) {
    function randomNormal(mu, sigma) {
        var x, r;
        mu = mu == null ? 0 : +mu;
        sigma = sigma == null ? 1 : +sigma;
        return function() {
            var y;
            // If available, use the second previously-generated uniform random.
            if (x != null) y = x, x = null;
            else do {
                x = source() * 2 - 1;
                y = source() * 2 - 1;
                r = x * x + y * y;
            }while (!r || r > 1);
            return mu + sigma * y * Math.sqrt(-2 * Math.log(r) / r);
        };
    }
    randomNormal.source = sourceRandomNormal;
    return randomNormal;
}((0, $7a4d6af9b607fa6f$export$2e2bcd8739ae039));



const $0799f01512f439cc$var$sqrt3 = Math.sqrt(3);
function $0799f01512f439cc$var$range(length) {
    return new Array(length).fill(1);
}
function $0799f01512f439cc$export$20bf9a472027d2a0(length, _ref) {
    let [offsetX, offsetY, index] = _ref;
    let random = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $bb073f6a6ca18415$export$2e2bcd8739ae039)(0, 0.2);
    return $0799f01512f439cc$var$range(length).map(()=>[
            random() + offsetX,
            random() + offsetY,
            index
        ]);
}
function $0799f01512f439cc$export$2e2bcd8739ae039() {
    let count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 300;
    let seed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    const random = seed == null ? undefined : (0, $bb073f6a6ca18415$export$2e2bcd8739ae039).source((0, $9fdb9584b90a1623$export$2e2bcd8739ae039)(seed))(0, 0.2);
    return [
        ...$0799f01512f439cc$export$20bf9a472027d2a0(count, [
            $0799f01512f439cc$var$sqrt3,
            1,
            0
        ], random),
        ...$0799f01512f439cc$export$20bf9a472027d2a0(count, [
            -$0799f01512f439cc$var$sqrt3,
            1,
            1
        ], random),
        ...$0799f01512f439cc$export$20bf9a472027d2a0(count, [
            0,
            -1,
            2
        ], random)
    ];
}




const $a07bd8ddea6958e4$var$defaultCount = (idx, number)=>Math.random() * (25 * (number - idx));
const $a07bd8ddea6958e4$var$defaultBin = (idx, length)=>idx * 150;
function $a07bd8ddea6958e4$export$2e2bcd8739ae039(length) {
    let bin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $a07bd8ddea6958e4$var$defaultBin;
    let count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $a07bd8ddea6958e4$var$defaultCount;
    return new Array(length).fill(1).reduce((data, d, i)=>data.concat([
            {
                bin: bin(i, length),
                count: count(i, length)
            }
        ]), []);
}



function $43f59e7785278ba3$export$2e2bcd8739ae039(length, height, bin, count) {
    return new Array(length).fill(1).reduce((arr, _, i)=>arr.concat([
            {
                bin: i,
                bins: (0, $a07bd8ddea6958e4$export$2e2bcd8739ae039)(height, bin, count)
            }
        ]), []);
}


function $adb5bfc717e73a1d$export$2e2bcd8739ae039(_ref) {
    let { radius: radius, width: width, height: height } = _ref;
    const theta = Math.PI * (3 - Math.sqrt(5));
    return (idx)=>{
        const r = radius * Math.sqrt(idx);
        const a = theta * idx;
        return {
            x: width / 2 + r * Math.cos(a),
            y: height / 2 + r * Math.sin(a)
        };
    };
}



const $0c095b8e6e943ea4$var$defaultRandom = (0, $bb073f6a6ca18415$export$2e2bcd8739ae039)(4, 3);
const $0c095b8e6e943ea4$var$defaultRandomOffset = ()=>Math.random() * 10;
const $0c095b8e6e943ea4$var$sampleSize = 1000;
function $0c095b8e6e943ea4$export$2e2bcd8739ae039(/** Number of stat distributions to generate. */ number) {
    let random = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $0c095b8e6e943ea4$var$defaultRandom;
    let randomOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $0c095b8e6e943ea4$var$defaultRandomOffset;
    const data = [];
    for(let i = 0; i < number; i += 1){
        const points = [];
        const offset = randomOffset();
        for(let j = 0; j < $0c095b8e6e943ea4$var$sampleSize; j += 1)points.push(offset + random());
        points.sort((a, b)=>a - b);
        const firstQuartile = points[Math.round($0c095b8e6e943ea4$var$sampleSize / 4)];
        const thirdQuartile = points[Math.round(3 * $0c095b8e6e943ea4$var$sampleSize / 4)];
        const IQR = thirdQuartile - firstQuartile;
        const min = firstQuartile - 1.5 * IQR;
        const max = thirdQuartile + 1.5 * IQR;
        const outliers = points.filter((p)=>p < min || p > max);
        const binWidth = 2 * IQR * ($0c095b8e6e943ea4$var$sampleSize - outliers.length) ** (-1 / 3);
        const binNum = Math.round((max - min) / binWidth);
        const actualBinWidth = (max - min) / binNum;
        const bins = new Array(binNum + 2).fill(0);
        const values = new Array(binNum + 2).fill(min);
        for(let ii = 1; ii <= binNum; ii += 1)values[ii] += actualBinWidth * (ii - 0.5);
        values[values.length - 1] = max;
        points.filter((p)=>p >= min && p <= max).forEach((p)=>{
            bins[Math.floor((p - min) / actualBinWidth) + 1] += 1;
        });
        const binData = values.map((v, index)=>({
                value: v,
                count: bins[index]
            }));
        const boxPlot = {
            x: `Statistics ${i}`,
            min: min,
            firstQuartile: firstQuartile,
            median: points[Math.round($0c095b8e6e943ea4$var$sampleSize / 2)],
            thirdQuartile: thirdQuartile,
            max: max,
            outliers: outliers
        };
        data.push({
            boxPlot: boxPlot,
            binData: binData
        });
    }
    return data;
}


const $0c8ca50a4276708d$var$appleStock = [
    {
        date: '2007-04-24T07:00:00.000Z',
        close: 93.24
    },
    {
        date: '2007-04-25T07:00:00.000Z',
        close: 95.35
    },
    {
        date: '2007-04-26T07:00:00.000Z',
        close: 98.84
    },
    {
        date: '2007-04-27T07:00:00.000Z',
        close: 99.92
    },
    {
        date: '2007-04-30T07:00:00.000Z',
        close: 99.8
    },
    {
        date: '2007-05-01T07:00:00.000Z',
        close: 99.47
    },
    {
        date: '2007-05-02T07:00:00.000Z',
        close: 100.39
    },
    {
        date: '2007-05-03T07:00:00.000Z',
        close: 100.4
    },
    {
        date: '2007-05-04T07:00:00.000Z',
        close: 100.81
    },
    {
        date: '2007-05-07T07:00:00.000Z',
        close: 103.92
    },
    {
        date: '2007-05-08T07:00:00.000Z',
        close: 105.06
    },
    {
        date: '2007-05-09T07:00:00.000Z',
        close: 106.88
    },
    {
        date: '2007-05-10T07:00:00.000Z',
        close: 107.34
    },
    {
        date: '2007-05-11T07:00:00.000Z',
        close: 108.74
    },
    {
        date: '2007-05-14T07:00:00.000Z',
        close: 109.36
    },
    {
        date: '2007-05-15T07:00:00.000Z',
        close: 107.52
    },
    {
        date: '2007-05-16T07:00:00.000Z',
        close: 107.34
    },
    {
        date: '2007-05-17T07:00:00.000Z',
        close: 109.44
    },
    {
        date: '2007-05-18T07:00:00.000Z',
        close: 110.02
    },
    {
        date: '2007-05-21T07:00:00.000Z',
        close: 111.98
    },
    {
        date: '2007-05-22T07:00:00.000Z',
        close: 113.54
    },
    {
        date: '2007-05-23T07:00:00.000Z',
        close: 112.89
    },
    {
        date: '2007-05-24T07:00:00.000Z',
        close: 110.69
    },
    {
        date: '2007-05-25T07:00:00.000Z',
        close: 113.62
    },
    {
        date: '2007-05-29T07:00:00.000Z',
        close: 114.35
    },
    {
        date: '2007-05-30T07:00:00.000Z',
        close: 118.77
    },
    {
        date: '2007-05-31T07:00:00.000Z',
        close: 121.19
    },
    {
        date: '2007-06-01T07:00:00.000Z',
        close: 118.4
    },
    {
        date: '2007-06-04T07:00:00.000Z',
        close: 121.33
    },
    {
        date: '2007-06-05T07:00:00.000Z',
        close: 122.67
    },
    {
        date: '2007-06-06T07:00:00.000Z',
        close: 123.64
    },
    {
        date: '2007-06-07T07:00:00.000Z',
        close: 124.07
    },
    {
        date: '2007-06-08T07:00:00.000Z',
        close: 124.49
    },
    {
        date: '2007-06-11T07:00:00.000Z',
        close: 120.19
    },
    {
        date: '2007-06-12T07:00:00.000Z',
        close: 120.38
    },
    {
        date: '2007-06-13T07:00:00.000Z',
        close: 117.5
    },
    {
        date: '2007-06-14T07:00:00.000Z',
        close: 118.75
    },
    {
        date: '2007-06-15T07:00:00.000Z',
        close: 120.5
    },
    {
        date: '2007-06-18T07:00:00.000Z',
        close: 125.09
    },
    {
        date: '2007-06-19T07:00:00.000Z',
        close: 123.66
    },
    {
        date: '2007-06-20T07:00:00.000Z',
        close: 121.55
    },
    {
        date: '2007-06-21T07:00:00.000Z',
        close: 123.9
    },
    {
        date: '2007-06-22T07:00:00.000Z',
        close: 123
    },
    {
        date: '2007-06-25T07:00:00.000Z',
        close: 122.34
    },
    {
        date: '2007-06-26T07:00:00.000Z',
        close: 119.65
    },
    {
        date: '2007-06-27T07:00:00.000Z',
        close: 121.89
    },
    {
        date: '2007-06-28T07:00:00.000Z',
        close: 120.56
    },
    {
        date: '2007-06-29T07:00:00.000Z',
        close: 122.04
    },
    {
        date: '2007-07-02T07:00:00.000Z',
        close: 121.26
    },
    {
        date: '2007-07-03T07:00:00.000Z',
        close: 127.17
    },
    {
        date: '2007-07-05T07:00:00.000Z',
        close: 132.75
    },
    {
        date: '2007-07-06T07:00:00.000Z',
        close: 132.3
    },
    {
        date: '2007-07-09T07:00:00.000Z',
        close: 130.33
    },
    {
        date: '2007-07-10T07:00:00.000Z',
        close: 132.35
    },
    {
        date: '2007-07-11T07:00:00.000Z',
        close: 132.39
    },
    {
        date: '2007-07-12T07:00:00.000Z',
        close: 134.07
    },
    {
        date: '2007-07-13T07:00:00.000Z',
        close: 137.73
    },
    {
        date: '2007-07-16T07:00:00.000Z',
        close: 138.1
    },
    {
        date: '2007-07-17T07:00:00.000Z',
        close: 138.91
    },
    {
        date: '2007-07-18T07:00:00.000Z',
        close: 138.12
    },
    {
        date: '2007-07-19T07:00:00.000Z',
        close: 140
    },
    {
        date: '2007-07-20T07:00:00.000Z',
        close: 143.75
    },
    {
        date: '2007-07-23T07:00:00.000Z',
        close: 143.7
    },
    {
        date: '2007-07-24T07:00:00.000Z',
        close: 134.89
    },
    {
        date: '2007-07-25T07:00:00.000Z',
        close: 137.26
    },
    {
        date: '2007-07-26T07:00:00.000Z',
        close: 146
    },
    {
        date: '2007-07-27T07:00:00.000Z',
        close: 143.85
    },
    {
        date: '2007-07-30T07:00:00.000Z',
        close: 141.43
    },
    {
        date: '2007-07-31T07:00:00.000Z',
        close: 131.76
    },
    {
        date: '2007-08-01T07:00:00.000Z',
        close: 135
    },
    {
        date: '2007-08-02T07:00:00.000Z',
        close: 136.49
    },
    {
        date: '2007-08-03T07:00:00.000Z',
        close: 131.85
    },
    {
        date: '2007-08-06T07:00:00.000Z',
        close: 135.25
    },
    {
        date: '2007-08-07T07:00:00.000Z',
        close: 135.03
    },
    {
        date: '2007-08-08T07:00:00.000Z',
        close: 134.01
    },
    {
        date: '2007-08-09T07:00:00.000Z',
        close: 126.39
    },
    {
        date: '2007-08-10T07:00:00.000Z',
        close: 125
    },
    {
        date: '2007-08-13T07:00:00.000Z',
        close: 127.79
    },
    {
        date: '2007-08-14T07:00:00.000Z',
        close: 124.03
    },
    {
        date: '2007-08-15T07:00:00.000Z',
        close: 119.9
    },
    {
        date: '2007-08-16T07:00:00.000Z',
        close: 117.05
    },
    {
        date: '2007-08-17T07:00:00.000Z',
        close: 122.06
    },
    {
        date: '2007-08-20T07:00:00.000Z',
        close: 122.22
    },
    {
        date: '2007-08-21T07:00:00.000Z',
        close: 127.57
    },
    {
        date: '2007-08-22T07:00:00.000Z',
        close: 132.51
    },
    {
        date: '2007-08-23T07:00:00.000Z',
        close: 131.07
    },
    {
        date: '2007-08-24T07:00:00.000Z',
        close: 135.3
    },
    {
        date: '2007-08-27T07:00:00.000Z',
        close: 132.25
    },
    {
        date: '2007-08-28T07:00:00.000Z',
        close: 126.82
    },
    {
        date: '2007-08-29T07:00:00.000Z',
        close: 134.08
    },
    {
        date: '2007-08-30T07:00:00.000Z',
        close: 136.25
    },
    {
        date: '2007-08-31T07:00:00.000Z',
        close: 138.48
    },
    {
        date: '2007-09-04T07:00:00.000Z',
        close: 144.16
    },
    {
        date: '2007-09-05T07:00:00.000Z',
        close: 136.76
    },
    {
        date: '2007-09-06T07:00:00.000Z',
        close: 135.01
    },
    {
        date: '2007-09-07T07:00:00.000Z',
        close: 131.77
    },
    {
        date: '2007-09-10T07:00:00.000Z',
        close: 136.71
    },
    {
        date: '2007-09-11T07:00:00.000Z',
        close: 135.49
    },
    {
        date: '2007-09-12T07:00:00.000Z',
        close: 136.85
    },
    {
        date: '2007-09-13T07:00:00.000Z',
        close: 137.2
    },
    {
        date: '2007-09-14T07:00:00.000Z',
        close: 138.81
    },
    {
        date: '2007-09-17T07:00:00.000Z',
        close: 138.41
    },
    {
        date: '2007-09-18T07:00:00.000Z',
        close: 140.92
    },
    {
        date: '2007-09-19T07:00:00.000Z',
        close: 140.77
    },
    {
        date: '2007-09-20T07:00:00.000Z',
        close: 140.31
    },
    {
        date: '2007-09-21T07:00:00.000Z',
        close: 144.15
    },
    {
        date: '2007-09-24T07:00:00.000Z',
        close: 148.28
    },
    {
        date: '2007-09-25T07:00:00.000Z',
        close: 153.18
    },
    {
        date: '2007-09-26T07:00:00.000Z',
        close: 152.77
    },
    {
        date: '2007-09-27T07:00:00.000Z',
        close: 154.5
    },
    {
        date: '2007-09-28T07:00:00.000Z',
        close: 153.47
    },
    {
        date: '2007-10-01T07:00:00.000Z',
        close: 156.34
    },
    {
        date: '2007-10-02T07:00:00.000Z',
        close: 158.45
    },
    {
        date: '2007-10-03T07:00:00.000Z',
        close: 157.92
    },
    {
        date: '2007-10-04T07:00:00.000Z',
        close: 156.24
    },
    {
        date: '2007-10-05T07:00:00.000Z',
        close: 161.45
    },
    {
        date: '2007-10-08T07:00:00.000Z',
        close: 167.91
    },
    {
        date: '2007-10-09T07:00:00.000Z',
        close: 167.86
    },
    {
        date: '2007-10-10T07:00:00.000Z',
        close: 166.79
    },
    {
        date: '2007-10-11T07:00:00.000Z',
        close: 162.23
    },
    {
        date: '2007-10-12T07:00:00.000Z',
        close: 167.25
    },
    {
        date: '2007-10-15T07:00:00.000Z',
        close: 166.98
    },
    {
        date: '2007-10-16T07:00:00.000Z',
        close: 169.58
    },
    {
        date: '2007-10-17T07:00:00.000Z',
        close: 172.75
    },
    {
        date: '2007-10-18T07:00:00.000Z',
        close: 173.5
    },
    {
        date: '2007-10-19T07:00:00.000Z',
        close: 170.42
    },
    {
        date: '2007-10-22T07:00:00.000Z',
        close: 174.36
    },
    {
        date: '2007-10-23T07:00:00.000Z',
        close: 186.16
    },
    {
        date: '2007-10-24T07:00:00.000Z',
        close: 185.93
    },
    {
        date: '2007-10-25T07:00:00.000Z',
        close: 182.78
    },
    {
        date: '2007-10-26T07:00:00.000Z',
        close: 184.7
    },
    {
        date: '2007-10-29T07:00:00.000Z',
        close: 185.09
    },
    {
        date: '2007-10-30T07:00:00.000Z',
        close: 187
    },
    {
        date: '2007-10-31T07:00:00.000Z',
        close: 189.95
    },
    {
        date: '2007-11-01T07:00:00.000Z',
        close: 187.44
    },
    {
        date: '2007-11-02T07:00:00.000Z',
        close: 187.87
    },
    {
        date: '2007-11-05T08:00:00.000Z',
        close: 186.18
    },
    {
        date: '2007-11-06T08:00:00.000Z',
        close: 191.79
    },
    {
        date: '2007-11-07T08:00:00.000Z',
        close: 186.3
    },
    {
        date: '2007-11-08T08:00:00.000Z',
        close: 175.47
    },
    {
        date: '2007-11-09T08:00:00.000Z',
        close: 165.37
    },
    {
        date: '2007-11-12T08:00:00.000Z',
        close: 153.76
    },
    {
        date: '2007-11-13T08:00:00.000Z',
        close: 169.96
    },
    {
        date: '2007-11-14T08:00:00.000Z',
        close: 166.11
    },
    {
        date: '2007-11-15T08:00:00.000Z',
        close: 164.3
    },
    {
        date: '2007-11-16T08:00:00.000Z',
        close: 166.39
    },
    {
        date: '2007-11-19T08:00:00.000Z',
        close: 163.95
    },
    {
        date: '2007-11-20T08:00:00.000Z',
        close: 168.85
    },
    {
        date: '2007-11-21T08:00:00.000Z',
        close: 168.46
    },
    {
        date: '2007-11-23T08:00:00.000Z',
        close: 171.54
    },
    {
        date: '2007-11-26T08:00:00.000Z',
        close: 172.54
    },
    {
        date: '2007-11-27T08:00:00.000Z',
        close: 174.81
    },
    {
        date: '2007-11-28T08:00:00.000Z',
        close: 180.22
    },
    {
        date: '2007-11-29T08:00:00.000Z',
        close: 184.29
    },
    {
        date: '2007-11-30T08:00:00.000Z',
        close: 182.22
    },
    {
        date: '2007-12-03T08:00:00.000Z',
        close: 178.86
    },
    {
        date: '2007-12-04T08:00:00.000Z',
        close: 179.81
    },
    {
        date: '2007-12-05T08:00:00.000Z',
        close: 185.5
    },
    {
        date: '2007-12-06T08:00:00.000Z',
        close: 189.95
    },
    {
        date: '2007-12-07T08:00:00.000Z',
        close: 194.3
    },
    {
        date: '2007-12-10T08:00:00.000Z',
        close: 194.21
    },
    {
        date: '2007-12-11T08:00:00.000Z',
        close: 188.54
    },
    {
        date: '2007-12-12T08:00:00.000Z',
        close: 190.86
    },
    {
        date: '2007-12-13T08:00:00.000Z',
        close: 191.83
    },
    {
        date: '2007-12-14T08:00:00.000Z',
        close: 190.39
    },
    {
        date: '2007-12-17T08:00:00.000Z',
        close: 184.4
    },
    {
        date: '2007-12-18T08:00:00.000Z',
        close: 182.98
    },
    {
        date: '2007-12-19T08:00:00.000Z',
        close: 183.12
    },
    {
        date: '2007-12-20T08:00:00.000Z',
        close: 187.21
    },
    {
        date: '2007-12-21T08:00:00.000Z',
        close: 193.91
    },
    {
        date: '2007-12-24T08:00:00.000Z',
        close: 198.8
    },
    {
        date: '2007-12-26T08:00:00.000Z',
        close: 198.95
    },
    {
        date: '2007-12-27T08:00:00.000Z',
        close: 198.57
    },
    {
        date: '2007-12-28T08:00:00.000Z',
        close: 199.83
    },
    {
        date: '2007-12-31T08:00:00.000Z',
        close: 198.08
    },
    {
        date: '2008-01-02T08:00:00.000Z',
        close: 194.84
    },
    {
        date: '2008-01-03T08:00:00.000Z',
        close: 194.93
    },
    {
        date: '2008-01-04T08:00:00.000Z',
        close: 180.05
    },
    {
        date: '2008-01-07T08:00:00.000Z',
        close: 177.64
    },
    {
        date: '2008-01-08T08:00:00.000Z',
        close: 171.25
    },
    {
        date: '2008-01-09T08:00:00.000Z',
        close: 179.4
    },
    {
        date: '2008-01-10T08:00:00.000Z',
        close: 178.02
    },
    {
        date: '2008-01-11T08:00:00.000Z',
        close: 172.69
    },
    {
        date: '2008-01-14T08:00:00.000Z',
        close: 178.78
    },
    {
        date: '2008-01-15T08:00:00.000Z',
        close: 169.04
    },
    {
        date: '2008-01-16T08:00:00.000Z',
        close: 159.64
    },
    {
        date: '2008-01-17T08:00:00.000Z',
        close: 160.89
    },
    {
        date: '2008-01-18T08:00:00.000Z',
        close: 161.36
    },
    {
        date: '2008-01-22T08:00:00.000Z',
        close: 155.64
    },
    {
        date: '2008-01-23T08:00:00.000Z',
        close: 139.07
    },
    {
        date: '2008-01-24T08:00:00.000Z',
        close: 135.6
    },
    {
        date: '2008-01-25T08:00:00.000Z',
        close: 130.01
    },
    {
        date: '2008-01-28T08:00:00.000Z',
        close: 130.01
    },
    {
        date: '2008-01-29T08:00:00.000Z',
        close: 131.54
    },
    {
        date: '2008-01-30T08:00:00.000Z',
        close: 132.18
    },
    {
        date: '2008-01-31T08:00:00.000Z',
        close: 135.36
    },
    {
        date: '2008-02-01T08:00:00.000Z',
        close: 133.75
    },
    {
        date: '2008-02-04T08:00:00.000Z',
        close: 131.65
    },
    {
        date: '2008-02-05T08:00:00.000Z',
        close: 129.36
    },
    {
        date: '2008-02-06T08:00:00.000Z',
        close: 122
    },
    {
        date: '2008-02-07T08:00:00.000Z',
        close: 121.24
    },
    {
        date: '2008-02-08T08:00:00.000Z',
        close: 125.48
    },
    {
        date: '2008-02-11T08:00:00.000Z',
        close: 129.45
    },
    {
        date: '2008-02-12T08:00:00.000Z',
        close: 124.86
    },
    {
        date: '2008-02-13T08:00:00.000Z',
        close: 129.4
    },
    {
        date: '2008-02-14T08:00:00.000Z',
        close: 127.46
    },
    {
        date: '2008-02-15T08:00:00.000Z',
        close: 124.63
    },
    {
        date: '2008-02-19T08:00:00.000Z',
        close: 122.18
    },
    {
        date: '2008-02-20T08:00:00.000Z',
        close: 123.82
    },
    {
        date: '2008-02-21T08:00:00.000Z',
        close: 121.54
    },
    {
        date: '2008-02-22T08:00:00.000Z',
        close: 119.46
    },
    {
        date: '2008-02-25T08:00:00.000Z',
        close: 119.74
    },
    {
        date: '2008-02-26T08:00:00.000Z',
        close: 119.15
    },
    {
        date: '2008-02-27T08:00:00.000Z',
        close: 122.96
    },
    {
        date: '2008-02-28T08:00:00.000Z',
        close: 129.91
    },
    {
        date: '2008-02-29T08:00:00.000Z',
        close: 125.02
    },
    {
        date: '2008-03-03T08:00:00.000Z',
        close: 121.73
    },
    {
        date: '2008-03-04T08:00:00.000Z',
        close: 124.62
    },
    {
        date: '2008-03-05T08:00:00.000Z',
        close: 124.49
    },
    {
        date: '2008-03-06T08:00:00.000Z',
        close: 120.93
    },
    {
        date: '2008-03-07T08:00:00.000Z',
        close: 122.25
    },
    {
        date: '2008-03-10T07:00:00.000Z',
        close: 119.69
    },
    {
        date: '2008-03-11T07:00:00.000Z',
        close: 127.35
    },
    {
        date: '2008-03-12T07:00:00.000Z',
        close: 126.03
    },
    {
        date: '2008-03-13T07:00:00.000Z',
        close: 127.94
    },
    {
        date: '2008-03-14T07:00:00.000Z',
        close: 126.61
    },
    {
        date: '2008-03-17T07:00:00.000Z',
        close: 126.73
    },
    {
        date: '2008-03-18T07:00:00.000Z',
        close: 132.82
    },
    {
        date: '2008-03-19T07:00:00.000Z',
        close: 129.67
    },
    {
        date: '2008-03-20T07:00:00.000Z',
        close: 133.27
    },
    {
        date: '2008-03-24T07:00:00.000Z',
        close: 139.53
    },
    {
        date: '2008-03-25T07:00:00.000Z',
        close: 140.98
    },
    {
        date: '2008-03-26T07:00:00.000Z',
        close: 145.06
    },
    {
        date: '2008-03-27T07:00:00.000Z',
        close: 140.25
    },
    {
        date: '2008-03-28T07:00:00.000Z',
        close: 143.01
    },
    {
        date: '2008-03-31T07:00:00.000Z',
        close: 143.5
    },
    {
        date: '2008-04-01T07:00:00.000Z',
        close: 149.53
    },
    {
        date: '2008-04-02T07:00:00.000Z',
        close: 147.49
    },
    {
        date: '2008-04-03T07:00:00.000Z',
        close: 151.61
    },
    {
        date: '2008-04-04T07:00:00.000Z',
        close: 153.08
    },
    {
        date: '2008-04-07T07:00:00.000Z',
        close: 155.89
    },
    {
        date: '2008-04-08T07:00:00.000Z',
        close: 152.84
    },
    {
        date: '2008-04-09T07:00:00.000Z',
        close: 151.44
    },
    {
        date: '2008-04-10T07:00:00.000Z',
        close: 154.55
    },
    {
        date: '2008-04-11T07:00:00.000Z',
        close: 147.14
    },
    {
        date: '2008-04-14T07:00:00.000Z',
        close: 147.78
    },
    {
        date: '2008-04-15T07:00:00.000Z',
        close: 148.38
    },
    {
        date: '2008-04-16T07:00:00.000Z',
        close: 153.7
    },
    {
        date: '2008-04-17T07:00:00.000Z',
        close: 154.49
    },
    {
        date: '2008-04-18T07:00:00.000Z',
        close: 161.04
    },
    {
        date: '2008-04-21T07:00:00.000Z',
        close: 168.16
    },
    {
        date: '2008-04-22T07:00:00.000Z',
        close: 160.2
    },
    {
        date: '2008-04-23T07:00:00.000Z',
        close: 162.89
    },
    {
        date: '2008-04-24T07:00:00.000Z',
        close: 168.94
    },
    {
        date: '2008-04-25T07:00:00.000Z',
        close: 169.73
    },
    {
        date: '2008-04-28T07:00:00.000Z',
        close: 172.24
    },
    {
        date: '2008-04-29T07:00:00.000Z',
        close: 175.05
    },
    {
        date: '2008-04-30T07:00:00.000Z',
        close: 173.95
    },
    {
        date: '2008-05-01T07:00:00.000Z',
        close: 180
    },
    {
        date: '2008-05-02T07:00:00.000Z',
        close: 180.94
    },
    {
        date: '2008-05-05T07:00:00.000Z',
        close: 184.73
    },
    {
        date: '2008-05-06T07:00:00.000Z',
        close: 186.66
    },
    {
        date: '2008-05-07T07:00:00.000Z',
        close: 182.59
    },
    {
        date: '2008-05-08T07:00:00.000Z',
        close: 185.06
    },
    {
        date: '2008-05-09T07:00:00.000Z',
        close: 183.45
    },
    {
        date: '2008-05-12T07:00:00.000Z',
        close: 188.16
    },
    {
        date: '2008-05-13T07:00:00.000Z',
        close: 189.96
    },
    {
        date: '2008-05-14T07:00:00.000Z',
        close: 186.26
    },
    {
        date: '2008-05-15T07:00:00.000Z',
        close: 189.73
    },
    {
        date: '2008-05-16T07:00:00.000Z',
        close: 187.62
    },
    {
        date: '2008-05-19T07:00:00.000Z',
        close: 183.6
    },
    {
        date: '2008-05-20T07:00:00.000Z',
        close: 185.9
    },
    {
        date: '2008-05-21T07:00:00.000Z',
        close: 178.19
    },
    {
        date: '2008-05-22T07:00:00.000Z',
        close: 177.05
    },
    {
        date: '2008-05-23T07:00:00.000Z',
        close: 181.17
    },
    {
        date: '2008-05-27T07:00:00.000Z',
        close: 186.43
    },
    {
        date: '2008-05-28T07:00:00.000Z',
        close: 187.01
    },
    {
        date: '2008-05-29T07:00:00.000Z',
        close: 186.69
    },
    {
        date: '2008-05-30T07:00:00.000Z',
        close: 188.75
    },
    {
        date: '2008-06-02T07:00:00.000Z',
        close: 186.1
    },
    {
        date: '2008-06-03T07:00:00.000Z',
        close: 185.37
    },
    {
        date: '2008-06-04T07:00:00.000Z',
        close: 185.19
    },
    {
        date: '2008-06-05T07:00:00.000Z',
        close: 189.43
    },
    {
        date: '2008-06-06T07:00:00.000Z',
        close: 185.64
    },
    {
        date: '2008-06-09T07:00:00.000Z',
        close: 181.61
    },
    {
        date: '2008-06-10T07:00:00.000Z',
        close: 185.64
    },
    {
        date: '2008-06-11T07:00:00.000Z',
        close: 180.81
    },
    {
        date: '2008-06-12T07:00:00.000Z',
        close: 173.26
    },
    {
        date: '2008-06-13T07:00:00.000Z',
        close: 172.37
    },
    {
        date: '2008-06-16T07:00:00.000Z',
        close: 176.84
    },
    {
        date: '2008-06-17T07:00:00.000Z',
        close: 181.43
    },
    {
        date: '2008-06-18T07:00:00.000Z',
        close: 178.75
    },
    {
        date: '2008-06-19T07:00:00.000Z',
        close: 180.9
    },
    {
        date: '2008-06-20T07:00:00.000Z',
        close: 175.27
    },
    {
        date: '2008-06-23T07:00:00.000Z',
        close: 173.16
    },
    {
        date: '2008-06-24T07:00:00.000Z',
        close: 173.25
    },
    {
        date: '2008-06-25T07:00:00.000Z',
        close: 177.39
    },
    {
        date: '2008-06-26T07:00:00.000Z',
        close: 168.26
    },
    {
        date: '2008-06-27T07:00:00.000Z',
        close: 170.09
    },
    {
        date: '2008-06-30T07:00:00.000Z',
        close: 167.44
    },
    {
        date: '2008-07-01T07:00:00.000Z',
        close: 174.68
    },
    {
        date: '2008-07-02T07:00:00.000Z',
        close: 168.18
    },
    {
        date: '2008-07-03T07:00:00.000Z',
        close: 170.12
    },
    {
        date: '2008-07-07T07:00:00.000Z',
        close: 175.16
    },
    {
        date: '2008-07-08T07:00:00.000Z',
        close: 179.55
    },
    {
        date: '2008-07-09T07:00:00.000Z',
        close: 174.25
    },
    {
        date: '2008-07-10T07:00:00.000Z',
        close: 176.63
    },
    {
        date: '2008-07-11T07:00:00.000Z',
        close: 172.58
    },
    {
        date: '2008-07-14T07:00:00.000Z',
        close: 173.88
    },
    {
        date: '2008-07-15T07:00:00.000Z',
        close: 169.64
    },
    {
        date: '2008-07-16T07:00:00.000Z',
        close: 172.81
    },
    {
        date: '2008-07-17T07:00:00.000Z',
        close: 171.81
    },
    {
        date: '2008-07-18T07:00:00.000Z',
        close: 165.15
    },
    {
        date: '2008-07-21T07:00:00.000Z',
        close: 166.29
    },
    {
        date: '2008-07-22T07:00:00.000Z',
        close: 162.02
    },
    {
        date: '2008-07-23T07:00:00.000Z',
        close: 166.26
    },
    {
        date: '2008-07-24T07:00:00.000Z',
        close: 159.03
    },
    {
        date: '2008-07-25T07:00:00.000Z',
        close: 162.12
    },
    {
        date: '2008-07-28T07:00:00.000Z',
        close: 154.4
    },
    {
        date: '2008-07-29T07:00:00.000Z',
        close: 157.08
    },
    {
        date: '2008-07-30T07:00:00.000Z',
        close: 159.88
    },
    {
        date: '2008-07-31T07:00:00.000Z',
        close: 158.95
    },
    {
        date: '2008-08-01T07:00:00.000Z',
        close: 156.66
    },
    {
        date: '2008-08-04T07:00:00.000Z',
        close: 153.23
    },
    {
        date: '2008-08-05T07:00:00.000Z',
        close: 160.64
    },
    {
        date: '2008-08-06T07:00:00.000Z',
        close: 164.19
    },
    {
        date: '2008-08-07T07:00:00.000Z',
        close: 163.57
    },
    {
        date: '2008-08-08T07:00:00.000Z',
        close: 169.55
    },
    {
        date: '2008-08-11T07:00:00.000Z',
        close: 173.56
    },
    {
        date: '2008-08-12T07:00:00.000Z',
        close: 176.73
    },
    {
        date: '2008-08-13T07:00:00.000Z',
        close: 179.3
    },
    {
        date: '2008-08-14T07:00:00.000Z',
        close: 179.32
    },
    {
        date: '2008-08-15T07:00:00.000Z',
        close: 175.74
    },
    {
        date: '2008-08-18T07:00:00.000Z',
        close: 175.39
    },
    {
        date: '2008-08-19T07:00:00.000Z',
        close: 173.53
    },
    {
        date: '2008-08-20T07:00:00.000Z',
        close: 175.84
    },
    {
        date: '2008-08-21T07:00:00.000Z',
        close: 174.29
    },
    {
        date: '2008-08-22T07:00:00.000Z',
        close: 176.79
    },
    {
        date: '2008-08-25T07:00:00.000Z',
        close: 172.55
    },
    {
        date: '2008-08-26T07:00:00.000Z',
        close: 173.64
    },
    {
        date: '2008-08-27T07:00:00.000Z',
        close: 174.67
    },
    {
        date: '2008-08-28T07:00:00.000Z',
        close: 173.74
    },
    {
        date: '2008-08-29T07:00:00.000Z',
        close: 169.53
    },
    {
        date: '2008-09-02T07:00:00.000Z',
        close: 166.19
    },
    {
        date: '2008-09-03T07:00:00.000Z',
        close: 166.96
    },
    {
        date: '2008-09-04T07:00:00.000Z',
        close: 161.22
    },
    {
        date: '2008-09-05T07:00:00.000Z',
        close: 160.18
    },
    {
        date: '2008-09-08T07:00:00.000Z',
        close: 157.92
    },
    {
        date: '2008-09-09T07:00:00.000Z',
        close: 151.68
    },
    {
        date: '2008-09-10T07:00:00.000Z',
        close: 151.61
    },
    {
        date: '2008-09-11T07:00:00.000Z',
        close: 152.65
    },
    {
        date: '2008-09-12T07:00:00.000Z',
        close: 148.94
    },
    {
        date: '2008-09-15T07:00:00.000Z',
        close: 140.36
    },
    {
        date: '2008-09-16T07:00:00.000Z',
        close: 139.88
    },
    {
        date: '2008-09-17T07:00:00.000Z',
        close: 127.83
    },
    {
        date: '2008-09-18T07:00:00.000Z',
        close: 134.09
    },
    {
        date: '2008-09-19T07:00:00.000Z',
        close: 140.91
    },
    {
        date: '2008-09-22T07:00:00.000Z',
        close: 131.05
    },
    {
        date: '2008-09-23T07:00:00.000Z',
        close: 126.84
    },
    {
        date: '2008-09-24T07:00:00.000Z',
        close: 128.71
    },
    {
        date: '2008-09-25T07:00:00.000Z',
        close: 131.93
    },
    {
        date: '2008-09-26T07:00:00.000Z',
        close: 128.24
    },
    {
        date: '2008-09-29T07:00:00.000Z',
        close: 105.26
    },
    {
        date: '2008-09-30T07:00:00.000Z',
        close: 113.66
    },
    {
        date: '2008-10-01T07:00:00.000Z',
        close: 109.12
    },
    {
        date: '2008-10-02T07:00:00.000Z',
        close: 100.1
    },
    {
        date: '2008-10-03T07:00:00.000Z',
        close: 97.07
    },
    {
        date: '2008-10-06T07:00:00.000Z',
        close: 98.14
    },
    {
        date: '2008-10-07T07:00:00.000Z',
        close: 89.16
    },
    {
        date: '2008-10-08T07:00:00.000Z',
        close: 89.79
    },
    {
        date: '2008-10-09T07:00:00.000Z',
        close: 88.74
    },
    {
        date: '2008-10-10T07:00:00.000Z',
        close: 96.8
    },
    {
        date: '2008-10-13T07:00:00.000Z',
        close: 110.26
    },
    {
        date: '2008-10-14T07:00:00.000Z',
        close: 104.08
    },
    {
        date: '2008-10-15T07:00:00.000Z',
        close: 97.95
    },
    {
        date: '2008-10-16T07:00:00.000Z',
        close: 101.89
    },
    {
        date: '2008-10-17T07:00:00.000Z',
        close: 97.4
    },
    {
        date: '2008-10-20T07:00:00.000Z',
        close: 98.44
    },
    {
        date: '2008-10-21T07:00:00.000Z',
        close: 91.49
    },
    {
        date: '2008-10-22T07:00:00.000Z',
        close: 96.87
    },
    {
        date: '2008-10-23T07:00:00.000Z',
        close: 98.23
    },
    {
        date: '2008-10-24T07:00:00.000Z',
        close: 96.38
    },
    {
        date: '2008-10-27T07:00:00.000Z',
        close: 92.09
    },
    {
        date: '2008-10-28T07:00:00.000Z',
        close: 99.91
    },
    {
        date: '2008-10-29T07:00:00.000Z',
        close: 104.55
    },
    {
        date: '2008-10-30T07:00:00.000Z',
        close: 111.04
    },
    {
        date: '2008-10-31T07:00:00.000Z',
        close: 107.59
    },
    {
        date: '2008-11-03T08:00:00.000Z',
        close: 106.96
    },
    {
        date: '2008-11-04T08:00:00.000Z',
        close: 110.99
    },
    {
        date: '2008-11-05T08:00:00.000Z',
        close: 103.3
    },
    {
        date: '2008-11-06T08:00:00.000Z',
        close: 99.1
    },
    {
        date: '2008-11-07T08:00:00.000Z',
        close: 98.24
    },
    {
        date: '2008-11-10T08:00:00.000Z',
        close: 95.88
    },
    {
        date: '2008-11-11T08:00:00.000Z',
        close: 94.77
    },
    {
        date: '2008-11-12T08:00:00.000Z',
        close: 90.12
    },
    {
        date: '2008-11-13T08:00:00.000Z',
        close: 96.44
    },
    {
        date: '2008-11-14T08:00:00.000Z',
        close: 90.24
    },
    {
        date: '2008-11-17T08:00:00.000Z',
        close: 88.14
    },
    {
        date: '2008-11-18T08:00:00.000Z',
        close: 89.91
    },
    {
        date: '2008-11-19T08:00:00.000Z',
        close: 86.29
    },
    {
        date: '2008-11-20T08:00:00.000Z',
        close: 80.49
    },
    {
        date: '2008-11-21T08:00:00.000Z',
        close: 82.58
    },
    {
        date: '2008-11-24T08:00:00.000Z',
        close: 92.95
    },
    {
        date: '2008-11-25T08:00:00.000Z',
        close: 90.8
    },
    {
        date: '2008-11-26T08:00:00.000Z',
        close: 95
    },
    {
        date: '2008-11-27T08:00:00.000Z',
        close: 95
    },
    {
        date: '2008-11-28T08:00:00.000Z',
        close: 92.67
    },
    {
        date: '2008-12-01T08:00:00.000Z',
        close: 88.93
    },
    {
        date: '2008-12-02T08:00:00.000Z',
        close: 92.47
    },
    {
        date: '2008-12-03T08:00:00.000Z',
        close: 95.9
    },
    {
        date: '2008-12-04T08:00:00.000Z',
        close: 91.41
    },
    {
        date: '2008-12-05T08:00:00.000Z',
        close: 94
    },
    {
        date: '2008-12-08T08:00:00.000Z',
        close: 99.72
    },
    {
        date: '2008-12-09T08:00:00.000Z',
        close: 100.06
    },
    {
        date: '2008-12-10T08:00:00.000Z',
        close: 98.21
    },
    {
        date: '2008-12-11T08:00:00.000Z',
        close: 95
    },
    {
        date: '2008-12-12T08:00:00.000Z',
        close: 98.27
    },
    {
        date: '2008-12-15T08:00:00.000Z',
        close: 94.75
    },
    {
        date: '2008-12-16T08:00:00.000Z',
        close: 95.43
    },
    {
        date: '2008-12-17T08:00:00.000Z',
        close: 89.16
    },
    {
        date: '2008-12-18T08:00:00.000Z',
        close: 89.43
    },
    {
        date: '2008-12-19T08:00:00.000Z',
        close: 90
    },
    {
        date: '2008-12-22T08:00:00.000Z',
        close: 85.74
    },
    {
        date: '2008-12-23T08:00:00.000Z',
        close: 86.38
    },
    {
        date: '2008-12-24T08:00:00.000Z',
        close: 85.04
    },
    {
        date: '2008-12-25T08:00:00.000Z',
        close: 85.04
    },
    {
        date: '2008-12-26T08:00:00.000Z',
        close: 85.81
    },
    {
        date: '2008-12-29T08:00:00.000Z',
        close: 86.61
    },
    {
        date: '2008-12-30T08:00:00.000Z',
        close: 86.29
    },
    {
        date: '2008-12-31T08:00:00.000Z',
        close: 85.35
    },
    {
        date: '2009-01-01T08:00:00.000Z',
        close: 85.35
    },
    {
        date: '2009-01-02T08:00:00.000Z',
        close: 90.75
    },
    {
        date: '2009-01-05T08:00:00.000Z',
        close: 94.58
    },
    {
        date: '2009-01-06T08:00:00.000Z',
        close: 93.02
    },
    {
        date: '2009-01-07T08:00:00.000Z',
        close: 91.01
    },
    {
        date: '2009-01-08T08:00:00.000Z',
        close: 92.7
    },
    {
        date: '2009-01-09T08:00:00.000Z',
        close: 90.58
    },
    {
        date: '2009-01-12T08:00:00.000Z',
        close: 88.66
    },
    {
        date: '2009-01-13T08:00:00.000Z',
        close: 87.71
    },
    {
        date: '2009-01-14T08:00:00.000Z',
        close: 85.33
    },
    {
        date: '2009-01-15T08:00:00.000Z',
        close: 83.38
    },
    {
        date: '2009-01-16T08:00:00.000Z',
        close: 82.33
    },
    {
        date: '2009-01-20T08:00:00.000Z',
        close: 78.2
    },
    {
        date: '2009-01-21T08:00:00.000Z',
        close: 82.83
    },
    {
        date: '2009-01-22T08:00:00.000Z',
        close: 88.36
    },
    {
        date: '2009-01-23T08:00:00.000Z',
        close: 88.36
    },
    {
        date: '2009-01-26T08:00:00.000Z',
        close: 89.64
    },
    {
        date: '2009-01-27T08:00:00.000Z',
        close: 90.73
    },
    {
        date: '2009-01-28T08:00:00.000Z',
        close: 94.2
    },
    {
        date: '2009-01-29T08:00:00.000Z',
        close: 93
    },
    {
        date: '2009-01-30T08:00:00.000Z',
        close: 90.13
    },
    {
        date: '2009-02-02T08:00:00.000Z',
        close: 91.51
    },
    {
        date: '2009-02-03T08:00:00.000Z',
        close: 92.98
    },
    {
        date: '2009-02-04T08:00:00.000Z',
        close: 93.55
    },
    {
        date: '2009-02-05T08:00:00.000Z',
        close: 96.46
    },
    {
        date: '2009-02-06T08:00:00.000Z',
        close: 99.72
    },
    {
        date: '2009-02-09T08:00:00.000Z',
        close: 102.51
    },
    {
        date: '2009-02-10T08:00:00.000Z',
        close: 97.83
    },
    {
        date: '2009-02-11T08:00:00.000Z',
        close: 96.82
    },
    {
        date: '2009-02-12T08:00:00.000Z',
        close: 99.27
    },
    {
        date: '2009-02-13T08:00:00.000Z',
        close: 99.16
    },
    {
        date: '2009-02-17T08:00:00.000Z',
        close: 94.53
    },
    {
        date: '2009-02-18T08:00:00.000Z',
        close: 94.37
    },
    {
        date: '2009-02-19T08:00:00.000Z',
        close: 90.64
    },
    {
        date: '2009-02-20T08:00:00.000Z',
        close: 91.2
    },
    {
        date: '2009-02-23T08:00:00.000Z',
        close: 86.95
    },
    {
        date: '2009-02-24T08:00:00.000Z',
        close: 90.25
    },
    {
        date: '2009-02-25T08:00:00.000Z',
        close: 91.16
    },
    {
        date: '2009-02-26T08:00:00.000Z',
        close: 89.19
    },
    {
        date: '2009-02-27T08:00:00.000Z',
        close: 89.31
    },
    {
        date: '2009-03-02T08:00:00.000Z',
        close: 87.94
    },
    {
        date: '2009-03-03T08:00:00.000Z',
        close: 88.37
    },
    {
        date: '2009-03-04T08:00:00.000Z',
        close: 91.17
    },
    {
        date: '2009-03-05T08:00:00.000Z',
        close: 88.84
    },
    {
        date: '2009-03-06T08:00:00.000Z',
        close: 85.3
    },
    {
        date: '2009-03-09T07:00:00.000Z',
        close: 83.11
    },
    {
        date: '2009-03-10T07:00:00.000Z',
        close: 88.63
    },
    {
        date: '2009-03-11T07:00:00.000Z',
        close: 92.68
    },
    {
        date: '2009-03-12T07:00:00.000Z',
        close: 96.35
    },
    {
        date: '2009-03-13T07:00:00.000Z',
        close: 95.93
    },
    {
        date: '2009-03-16T07:00:00.000Z',
        close: 95.42
    },
    {
        date: '2009-03-17T07:00:00.000Z',
        close: 99.66
    },
    {
        date: '2009-03-18T07:00:00.000Z',
        close: 101.52
    },
    {
        date: '2009-03-19T07:00:00.000Z',
        close: 101.62
    },
    {
        date: '2009-03-20T07:00:00.000Z',
        close: 101.59
    },
    {
        date: '2009-03-23T07:00:00.000Z',
        close: 107.66
    },
    {
        date: '2009-03-24T07:00:00.000Z',
        close: 106.5
    },
    {
        date: '2009-03-25T07:00:00.000Z',
        close: 106.49
    },
    {
        date: '2009-03-26T07:00:00.000Z',
        close: 109.87
    },
    {
        date: '2009-03-27T07:00:00.000Z',
        close: 106.85
    },
    {
        date: '2009-03-30T07:00:00.000Z',
        close: 104.49
    },
    {
        date: '2009-03-31T07:00:00.000Z',
        close: 105.12
    },
    {
        date: '2009-04-01T07:00:00.000Z',
        close: 108.69
    },
    {
        date: '2009-04-02T07:00:00.000Z',
        close: 112.71
    },
    {
        date: '2009-04-03T07:00:00.000Z',
        close: 115.99
    },
    {
        date: '2009-04-06T07:00:00.000Z',
        close: 118.45
    },
    {
        date: '2009-04-07T07:00:00.000Z',
        close: 115
    },
    {
        date: '2009-04-08T07:00:00.000Z',
        close: 116.32
    },
    {
        date: '2009-04-09T07:00:00.000Z',
        close: 119.57
    },
    {
        date: '2009-04-10T07:00:00.000Z',
        close: 119.57
    },
    {
        date: '2009-04-13T07:00:00.000Z',
        close: 120.22
    },
    {
        date: '2009-04-14T07:00:00.000Z',
        close: 118.31
    },
    {
        date: '2009-04-15T07:00:00.000Z',
        close: 117.64
    },
    {
        date: '2009-04-16T07:00:00.000Z',
        close: 121.45
    },
    {
        date: '2009-04-17T07:00:00.000Z',
        close: 123.42
    },
    {
        date: '2009-04-20T07:00:00.000Z',
        close: 120.5
    },
    {
        date: '2009-04-21T07:00:00.000Z',
        close: 121.76
    },
    {
        date: '2009-04-22T07:00:00.000Z',
        close: 121.51
    },
    {
        date: '2009-04-23T07:00:00.000Z',
        close: 125.4
    },
    {
        date: '2009-04-24T07:00:00.000Z',
        close: 123.9
    },
    {
        date: '2009-04-27T07:00:00.000Z',
        close: 124.73
    },
    {
        date: '2009-04-28T07:00:00.000Z',
        close: 123.9
    },
    {
        date: '2009-04-29T07:00:00.000Z',
        close: 125.14
    },
    {
        date: '2009-04-30T07:00:00.000Z',
        close: 125.83
    },
    {
        date: '2009-05-01T07:00:00.000Z',
        close: 127.24
    },
    {
        date: '2009-05-04T07:00:00.000Z',
        close: 132.07
    },
    {
        date: '2009-05-05T07:00:00.000Z',
        close: 132.71
    },
    {
        date: '2009-05-06T07:00:00.000Z',
        close: 132.5
    },
    {
        date: '2009-05-07T07:00:00.000Z',
        close: 129.06
    },
    {
        date: '2009-05-08T07:00:00.000Z',
        close: 129.19
    },
    {
        date: '2009-05-11T07:00:00.000Z',
        close: 129.57
    },
    {
        date: '2009-05-12T07:00:00.000Z',
        close: 124.42
    },
    {
        date: '2009-05-13T07:00:00.000Z',
        close: 119.49
    },
    {
        date: '2009-05-14T07:00:00.000Z',
        close: 122.95
    },
    {
        date: '2009-05-15T07:00:00.000Z',
        close: 122.42
    },
    {
        date: '2009-05-18T07:00:00.000Z',
        close: 126.65
    },
    {
        date: '2009-05-19T07:00:00.000Z',
        close: 127.45
    },
    {
        date: '2009-05-20T07:00:00.000Z',
        close: 125.87
    },
    {
        date: '2009-05-21T07:00:00.000Z',
        close: 124.18
    },
    {
        date: '2009-05-22T07:00:00.000Z',
        close: 122.5
    },
    {
        date: '2009-05-26T07:00:00.000Z',
        close: 130.78
    },
    {
        date: '2009-05-27T07:00:00.000Z',
        close: 133.05
    },
    {
        date: '2009-05-28T07:00:00.000Z',
        close: 135.07
    },
    {
        date: '2009-05-29T07:00:00.000Z',
        close: 135.81
    },
    {
        date: '2009-06-01T07:00:00.000Z',
        close: 139.35
    },
    {
        date: '2009-06-02T07:00:00.000Z',
        close: 139.49
    },
    {
        date: '2009-06-03T07:00:00.000Z',
        close: 140.95
    },
    {
        date: '2009-06-04T07:00:00.000Z',
        close: 143.74
    },
    {
        date: '2009-06-05T07:00:00.000Z',
        close: 144.67
    },
    {
        date: '2009-06-08T07:00:00.000Z',
        close: 143.85
    },
    {
        date: '2009-06-09T07:00:00.000Z',
        close: 142.72
    },
    {
        date: '2009-06-10T07:00:00.000Z',
        close: 140.25
    },
    {
        date: '2009-06-11T07:00:00.000Z',
        close: 139.95
    },
    {
        date: '2009-06-12T07:00:00.000Z',
        close: 136.97
    },
    {
        date: '2009-06-15T07:00:00.000Z',
        close: 136.09
    },
    {
        date: '2009-06-16T07:00:00.000Z',
        close: 136.35
    },
    {
        date: '2009-06-17T07:00:00.000Z',
        close: 135.58
    },
    {
        date: '2009-06-18T07:00:00.000Z',
        close: 135.88
    },
    {
        date: '2009-06-19T07:00:00.000Z',
        close: 139.48
    },
    {
        date: '2009-06-22T07:00:00.000Z',
        close: 137.37
    },
    {
        date: '2009-06-23T07:00:00.000Z',
        close: 134.01
    },
    {
        date: '2009-06-24T07:00:00.000Z',
        close: 136.22
    },
    {
        date: '2009-06-25T07:00:00.000Z',
        close: 139.86
    },
    {
        date: '2009-06-26T07:00:00.000Z',
        close: 142.44
    },
    {
        date: '2009-06-29T07:00:00.000Z',
        close: 141.97
    },
    {
        date: '2009-06-30T07:00:00.000Z',
        close: 142.43
    },
    {
        date: '2009-07-01T07:00:00.000Z',
        close: 142.83
    },
    {
        date: '2009-07-02T07:00:00.000Z',
        close: 140.02
    },
    {
        date: '2009-07-03T07:00:00.000Z',
        close: 140.02
    },
    {
        date: '2009-07-06T07:00:00.000Z',
        close: 138.61
    },
    {
        date: '2009-07-07T07:00:00.000Z',
        close: 135.4
    },
    {
        date: '2009-07-08T07:00:00.000Z',
        close: 137.22
    },
    {
        date: '2009-07-09T07:00:00.000Z',
        close: 136.36
    },
    {
        date: '2009-07-10T07:00:00.000Z',
        close: 138.52
    },
    {
        date: '2009-07-13T07:00:00.000Z',
        close: 142.34
    },
    {
        date: '2009-07-14T07:00:00.000Z',
        close: 142.27
    },
    {
        date: '2009-07-15T07:00:00.000Z',
        close: 146.88
    },
    {
        date: '2009-07-16T07:00:00.000Z',
        close: 147.52
    },
    {
        date: '2009-07-17T07:00:00.000Z',
        close: 151.75
    },
    {
        date: '2009-07-20T07:00:00.000Z',
        close: 152.91
    },
    {
        date: '2009-07-21T07:00:00.000Z',
        close: 151.51
    },
    {
        date: '2009-07-22T07:00:00.000Z',
        close: 156.74
    },
    {
        date: '2009-07-23T07:00:00.000Z',
        close: 157.82
    },
    {
        date: '2009-07-24T07:00:00.000Z',
        close: 159.99
    },
    {
        date: '2009-07-27T07:00:00.000Z',
        close: 160.1
    },
    {
        date: '2009-07-28T07:00:00.000Z',
        close: 160
    },
    {
        date: '2009-07-29T07:00:00.000Z',
        close: 160.03
    },
    {
        date: '2009-07-30T07:00:00.000Z',
        close: 162.79
    },
    {
        date: '2009-07-31T07:00:00.000Z',
        close: 163.39
    },
    {
        date: '2009-08-03T07:00:00.000Z',
        close: 166.43
    },
    {
        date: '2009-08-04T07:00:00.000Z',
        close: 165.55
    },
    {
        date: '2009-08-05T07:00:00.000Z',
        close: 165.11
    },
    {
        date: '2009-08-06T07:00:00.000Z',
        close: 163.91
    },
    {
        date: '2009-08-07T07:00:00.000Z',
        close: 165.51
    },
    {
        date: '2009-08-10T07:00:00.000Z',
        close: 164.72
    },
    {
        date: '2009-08-12T07:00:00.000Z',
        close: 165.31
    },
    {
        date: '2009-08-13T07:00:00.000Z',
        close: 168.42
    },
    {
        date: '2009-08-14T07:00:00.000Z',
        close: 166.78
    },
    {
        date: '2009-08-17T07:00:00.000Z',
        close: 159.59
    },
    {
        date: '2009-08-18T07:00:00.000Z',
        close: 164
    },
    {
        date: '2009-08-19T07:00:00.000Z',
        close: 164.6
    },
    {
        date: '2009-08-20T07:00:00.000Z',
        close: 166.33
    },
    {
        date: '2009-08-21T07:00:00.000Z',
        close: 169.22
    },
    {
        date: '2009-08-24T07:00:00.000Z',
        close: 169.06
    },
    {
        date: '2009-08-25T07:00:00.000Z',
        close: 169.4
    },
    {
        date: '2009-08-26T07:00:00.000Z',
        close: 167.41
    },
    {
        date: '2009-08-27T07:00:00.000Z',
        close: 169.45
    },
    {
        date: '2009-08-28T07:00:00.000Z',
        close: 170.05
    },
    {
        date: '2009-08-31T07:00:00.000Z',
        close: 168.21
    },
    {
        date: '2009-09-01T07:00:00.000Z',
        close: 165.3
    },
    {
        date: '2009-09-02T07:00:00.000Z',
        close: 165.18
    },
    {
        date: '2009-09-03T07:00:00.000Z',
        close: 166.55
    },
    {
        date: '2009-09-04T07:00:00.000Z',
        close: 170.31
    },
    {
        date: '2009-09-08T07:00:00.000Z',
        close: 172.93
    },
    {
        date: '2009-09-09T07:00:00.000Z',
        close: 171.14
    },
    {
        date: '2009-09-10T07:00:00.000Z',
        close: 172.56
    },
    {
        date: '2009-09-11T07:00:00.000Z',
        close: 172.16
    },
    {
        date: '2009-09-14T07:00:00.000Z',
        close: 173.72
    },
    {
        date: '2009-09-15T07:00:00.000Z',
        close: 175.16
    },
    {
        date: '2009-09-16T07:00:00.000Z',
        close: 181.87
    },
    {
        date: '2009-09-17T07:00:00.000Z',
        close: 184.55
    },
    {
        date: '2009-09-18T07:00:00.000Z',
        close: 185.02
    },
    {
        date: '2009-09-21T07:00:00.000Z',
        close: 184.02
    },
    {
        date: '2009-09-22T07:00:00.000Z',
        close: 184.48
    },
    {
        date: '2009-09-23T07:00:00.000Z',
        close: 185.5
    },
    {
        date: '2009-09-24T07:00:00.000Z',
        close: 183.82
    },
    {
        date: '2009-09-25T07:00:00.000Z',
        close: 182.37
    },
    {
        date: '2009-09-28T07:00:00.000Z',
        close: 186.15
    },
    {
        date: '2009-09-29T07:00:00.000Z',
        close: 185.38
    },
    {
        date: '2009-09-30T07:00:00.000Z',
        close: 185.35
    },
    {
        date: '2009-10-01T07:00:00.000Z',
        close: 180.86
    },
    {
        date: '2009-10-02T07:00:00.000Z',
        close: 184.9
    },
    {
        date: '2009-10-05T07:00:00.000Z',
        close: 186.02
    },
    {
        date: '2009-10-06T07:00:00.000Z',
        close: 190.01
    },
    {
        date: '2009-10-07T07:00:00.000Z',
        close: 190.25
    },
    {
        date: '2009-10-08T07:00:00.000Z',
        close: 189.27
    },
    {
        date: '2009-10-09T07:00:00.000Z',
        close: 190.47
    },
    {
        date: '2009-10-12T07:00:00.000Z',
        close: 190.81
    },
    {
        date: '2009-10-13T07:00:00.000Z',
        close: 190.02
    },
    {
        date: '2009-10-14T07:00:00.000Z',
        close: 191.29
    },
    {
        date: '2009-10-15T07:00:00.000Z',
        close: 190.56
    },
    {
        date: '2009-10-16T07:00:00.000Z',
        close: 188.05
    },
    {
        date: '2009-10-19T07:00:00.000Z',
        close: 189.86
    },
    {
        date: '2009-10-20T07:00:00.000Z',
        close: 198.76
    },
    {
        date: '2009-10-21T07:00:00.000Z',
        close: 204.92
    },
    {
        date: '2009-10-22T07:00:00.000Z',
        close: 205.2
    },
    {
        date: '2009-10-23T07:00:00.000Z',
        close: 203.94
    },
    {
        date: '2009-10-26T07:00:00.000Z',
        close: 202.48
    },
    {
        date: '2009-10-27T07:00:00.000Z',
        close: 197.37
    },
    {
        date: '2009-10-28T07:00:00.000Z',
        close: 192.4
    },
    {
        date: '2009-10-29T07:00:00.000Z',
        close: 196.35
    },
    {
        date: '2009-10-30T07:00:00.000Z',
        close: 188.5
    },
    {
        date: '2009-11-02T08:00:00.000Z',
        close: 189.31
    },
    {
        date: '2009-11-03T08:00:00.000Z',
        close: 188.75
    },
    {
        date: '2009-11-04T08:00:00.000Z',
        close: 190.81
    },
    {
        date: '2009-11-05T08:00:00.000Z',
        close: 194.03
    },
    {
        date: '2009-11-06T08:00:00.000Z',
        close: 194.34
    },
    {
        date: '2009-11-09T08:00:00.000Z',
        close: 201.46
    },
    {
        date: '2009-11-10T08:00:00.000Z',
        close: 202.98
    },
    {
        date: '2009-11-11T08:00:00.000Z',
        close: 203.25
    },
    {
        date: '2009-11-12T08:00:00.000Z',
        close: 201.99
    },
    {
        date: '2009-11-13T08:00:00.000Z',
        close: 204.45
    },
    {
        date: '2009-11-16T08:00:00.000Z',
        close: 206.63
    },
    {
        date: '2009-11-17T08:00:00.000Z',
        close: 207
    },
    {
        date: '2009-11-18T08:00:00.000Z',
        close: 205.96
    },
    {
        date: '2009-11-19T08:00:00.000Z',
        close: 200.51
    },
    {
        date: '2009-11-20T08:00:00.000Z',
        close: 199.92
    },
    {
        date: '2009-11-23T08:00:00.000Z',
        close: 205.88
    },
    {
        date: '2009-11-24T08:00:00.000Z',
        close: 204.44
    },
    {
        date: '2009-11-25T08:00:00.000Z',
        close: 204.19
    },
    {
        date: '2009-11-26T08:00:00.000Z',
        close: 204.19
    },
    {
        date: '2009-11-27T08:00:00.000Z',
        close: 200.59
    },
    {
        date: '2009-11-30T08:00:00.000Z',
        close: 199.91
    },
    {
        date: '2009-12-01T08:00:00.000Z',
        close: 196.97
    },
    {
        date: '2009-12-02T08:00:00.000Z',
        close: 196.23
    },
    {
        date: '2009-12-03T08:00:00.000Z',
        close: 196.48
    },
    {
        date: '2009-12-04T08:00:00.000Z',
        close: 193.32
    },
    {
        date: '2009-12-07T08:00:00.000Z',
        close: 188.95
    },
    {
        date: '2009-12-08T08:00:00.000Z',
        close: 189.87
    },
    {
        date: '2009-12-09T08:00:00.000Z',
        close: 197.8
    },
    {
        date: '2009-12-10T08:00:00.000Z',
        close: 196.43
    },
    {
        date: '2009-12-11T08:00:00.000Z',
        close: 194.67
    },
    {
        date: '2009-12-14T08:00:00.000Z',
        close: 196.98
    },
    {
        date: '2009-12-15T08:00:00.000Z',
        close: 194.17
    },
    {
        date: '2009-12-16T08:00:00.000Z',
        close: 195.03
    },
    {
        date: '2009-12-17T08:00:00.000Z',
        close: 191.86
    },
    {
        date: '2009-12-18T08:00:00.000Z',
        close: 195.43
    },
    {
        date: '2009-12-21T08:00:00.000Z',
        close: 198.23
    },
    {
        date: '2009-12-22T08:00:00.000Z',
        close: 200.36
    },
    {
        date: '2009-12-23T08:00:00.000Z',
        close: 202.1
    },
    {
        date: '2009-12-24T08:00:00.000Z',
        close: 209.04
    },
    {
        date: '2009-12-25T08:00:00.000Z',
        close: 209.04
    },
    {
        date: '2009-12-28T08:00:00.000Z',
        close: 211.61
    },
    {
        date: '2009-12-29T08:00:00.000Z',
        close: 209.1
    },
    {
        date: '2009-12-30T08:00:00.000Z',
        close: 211.64
    },
    {
        date: '2009-12-31T08:00:00.000Z',
        close: 210.73
    },
    {
        date: '2010-01-01T08:00:00.000Z',
        close: 210.73
    },
    {
        date: '2010-01-04T08:00:00.000Z',
        close: 214.01
    },
    {
        date: '2010-01-05T08:00:00.000Z',
        close: 214.38
    },
    {
        date: '2010-01-06T08:00:00.000Z',
        close: 210.97
    },
    {
        date: '2010-01-07T08:00:00.000Z',
        close: 210.58
    },
    {
        date: '2010-01-08T08:00:00.000Z',
        close: 211.98
    },
    {
        date: '2010-01-11T08:00:00.000Z',
        close: 210.11
    },
    {
        date: '2010-01-12T08:00:00.000Z',
        close: 207.72
    },
    {
        date: '2010-01-13T08:00:00.000Z',
        close: 210.65
    },
    {
        date: '2010-01-14T08:00:00.000Z',
        close: 209.43
    },
    {
        date: '2010-01-15T08:00:00.000Z',
        close: 205.93
    },
    {
        date: '2010-01-18T08:00:00.000Z',
        close: 205.93
    },
    {
        date: '2010-01-19T08:00:00.000Z',
        close: 215.04
    },
    {
        date: '2010-01-20T08:00:00.000Z',
        close: 211.72
    },
    {
        date: '2010-01-21T08:00:00.000Z',
        close: 208.07
    },
    {
        date: '2010-01-22T08:00:00.000Z',
        close: 197.75
    },
    {
        date: '2010-01-25T08:00:00.000Z',
        close: 203.08
    },
    {
        date: '2010-01-26T08:00:00.000Z',
        close: 205.94
    },
    {
        date: '2010-01-27T08:00:00.000Z',
        close: 207.88
    },
    {
        date: '2010-01-28T08:00:00.000Z',
        close: 199.29
    },
    {
        date: '2010-01-29T08:00:00.000Z',
        close: 192.06
    },
    {
        date: '2010-02-01T08:00:00.000Z',
        close: 194.73
    },
    {
        date: '2010-02-02T08:00:00.000Z',
        close: 195.86
    },
    {
        date: '2010-02-03T08:00:00.000Z',
        close: 199.23
    },
    {
        date: '2010-02-04T08:00:00.000Z',
        close: 192.05
    },
    {
        date: '2010-02-05T08:00:00.000Z',
        close: 195.46
    },
    {
        date: '2010-02-08T08:00:00.000Z',
        close: 194.12
    },
    {
        date: '2010-02-09T08:00:00.000Z',
        close: 196.19
    },
    {
        date: '2010-02-10T08:00:00.000Z',
        close: 195.12
    },
    {
        date: '2010-02-11T08:00:00.000Z',
        close: 198.67
    },
    {
        date: '2010-02-12T08:00:00.000Z',
        close: 200.38
    },
    {
        date: '2010-02-15T08:00:00.000Z',
        close: 200.38
    },
    {
        date: '2010-02-16T08:00:00.000Z',
        close: 203.4
    },
    {
        date: '2010-02-17T08:00:00.000Z',
        close: 202.55
    },
    {
        date: '2010-02-18T08:00:00.000Z',
        close: 202.93
    },
    {
        date: '2010-02-19T08:00:00.000Z',
        close: 201.67
    },
    {
        date: '2010-02-22T08:00:00.000Z',
        close: 200.42
    },
    {
        date: '2010-02-23T08:00:00.000Z',
        close: 197.06
    },
    {
        date: '2010-02-24T08:00:00.000Z',
        close: 200.66
    },
    {
        date: '2010-02-25T08:00:00.000Z',
        close: 202
    },
    {
        date: '2010-02-26T08:00:00.000Z',
        close: 204.62
    },
    {
        date: '2010-03-01T08:00:00.000Z',
        close: 208.99
    },
    {
        date: '2010-03-02T08:00:00.000Z',
        close: 208.85
    },
    {
        date: '2010-03-03T08:00:00.000Z',
        close: 209.33
    },
    {
        date: '2010-03-04T08:00:00.000Z',
        close: 210.71
    },
    {
        date: '2010-03-05T08:00:00.000Z',
        close: 218.95
    },
    {
        date: '2010-03-08T08:00:00.000Z',
        close: 219.08
    },
    {
        date: '2010-03-09T08:00:00.000Z',
        close: 223.02
    },
    {
        date: '2010-03-10T08:00:00.000Z',
        close: 224.84
    },
    {
        date: '2010-03-11T08:00:00.000Z',
        close: 225.5
    },
    {
        date: '2010-03-12T08:00:00.000Z',
        close: 226.6
    },
    {
        date: '2010-03-15T07:00:00.000Z',
        close: 223.84
    },
    {
        date: '2010-03-16T07:00:00.000Z',
        close: 224.45
    },
    {
        date: '2010-03-17T07:00:00.000Z',
        close: 224.12
    },
    {
        date: '2010-03-18T07:00:00.000Z',
        close: 224.65
    },
    {
        date: '2010-03-19T07:00:00.000Z',
        close: 222.25
    },
    {
        date: '2010-03-22T07:00:00.000Z',
        close: 224.75
    },
    {
        date: '2010-03-23T07:00:00.000Z',
        close: 228.36
    },
    {
        date: '2010-03-24T07:00:00.000Z',
        close: 229.37
    },
    {
        date: '2010-03-25T07:00:00.000Z',
        close: 226.65
    },
    {
        date: '2010-03-26T07:00:00.000Z',
        close: 230.9
    },
    {
        date: '2010-03-29T07:00:00.000Z',
        close: 232.39
    },
    {
        date: '2010-03-30T07:00:00.000Z',
        close: 235.84
    },
    {
        date: '2010-03-31T07:00:00.000Z',
        close: 235
    },
    {
        date: '2010-04-01T07:00:00.000Z',
        close: 235.97
    },
    {
        date: '2010-04-02T07:00:00.000Z',
        close: 235.97
    },
    {
        date: '2010-04-05T07:00:00.000Z',
        close: 238.49
    },
    {
        date: '2010-04-06T07:00:00.000Z',
        close: 239.54
    },
    {
        date: '2010-04-07T07:00:00.000Z',
        close: 240.6
    },
    {
        date: '2010-04-08T07:00:00.000Z',
        close: 239.95
    },
    {
        date: '2010-04-09T07:00:00.000Z',
        close: 241.79
    },
    {
        date: '2010-04-12T07:00:00.000Z',
        close: 242.29
    },
    {
        date: '2010-04-13T07:00:00.000Z',
        close: 242.43
    },
    {
        date: '2010-04-14T07:00:00.000Z',
        close: 245.69
    },
    {
        date: '2010-04-15T07:00:00.000Z',
        close: 248.92
    },
    {
        date: '2010-04-16T07:00:00.000Z',
        close: 247.4
    },
    {
        date: '2010-04-19T07:00:00.000Z',
        close: 247.07
    },
    {
        date: '2010-04-20T07:00:00.000Z',
        close: 244.59
    },
    {
        date: '2010-04-21T07:00:00.000Z',
        close: 259.22
    },
    {
        date: '2010-04-22T07:00:00.000Z',
        close: 266.47
    },
    {
        date: '2010-04-23T07:00:00.000Z',
        close: 270.83
    },
    {
        date: '2010-04-26T07:00:00.000Z',
        close: 269.5
    },
    {
        date: '2010-04-27T07:00:00.000Z',
        close: 262.04
    },
    {
        date: '2010-04-28T07:00:00.000Z',
        close: 261.6
    },
    {
        date: '2010-04-29T07:00:00.000Z',
        close: 268.64
    },
    {
        date: '2010-04-30T07:00:00.000Z',
        close: 261.09
    },
    {
        date: '2010-05-03T07:00:00.000Z',
        close: 266.35
    },
    {
        date: '2010-05-04T07:00:00.000Z',
        close: 258.68
    },
    {
        date: '2010-05-05T07:00:00.000Z',
        close: 255.98
    },
    {
        date: '2010-05-06T07:00:00.000Z',
        close: 246.25
    },
    {
        date: '2010-05-07T07:00:00.000Z',
        close: 235.86
    },
    {
        date: '2010-05-10T07:00:00.000Z',
        close: 253.99
    },
    {
        date: '2010-05-11T07:00:00.000Z',
        close: 256.52
    },
    {
        date: '2010-05-12T07:00:00.000Z',
        close: 262.09
    },
    {
        date: '2010-05-13T07:00:00.000Z',
        close: 258.36
    },
    {
        date: '2010-05-14T07:00:00.000Z',
        close: 253.82
    },
    {
        date: '2010-05-17T07:00:00.000Z',
        close: 254.22
    },
    {
        date: '2010-05-18T07:00:00.000Z',
        close: 252.36
    },
    {
        date: '2010-05-19T07:00:00.000Z',
        close: 248.34
    },
    {
        date: '2010-05-20T07:00:00.000Z',
        close: 237.76
    },
    {
        date: '2010-05-21T07:00:00.000Z',
        close: 242.32
    },
    {
        date: '2010-05-24T07:00:00.000Z',
        close: 246.76
    },
    {
        date: '2010-05-25T07:00:00.000Z',
        close: 245.22
    },
    {
        date: '2010-05-26T07:00:00.000Z',
        close: 244.11
    },
    {
        date: '2010-05-27T07:00:00.000Z',
        close: 253.35
    },
    {
        date: '2010-05-28T07:00:00.000Z',
        close: 256.88
    },
    {
        date: '2010-05-31T07:00:00.000Z',
        close: 256.88
    },
    {
        date: '2010-06-01T07:00:00.000Z',
        close: 260.83
    },
    {
        date: '2010-06-02T07:00:00.000Z',
        close: 263.95
    },
    {
        date: '2010-06-03T07:00:00.000Z',
        close: 263.12
    },
    {
        date: '2010-06-04T07:00:00.000Z',
        close: 255.96
    },
    {
        date: '2010-06-07T07:00:00.000Z',
        close: 250.94
    },
    {
        date: '2010-06-08T07:00:00.000Z',
        close: 249.33
    },
    {
        date: '2010-06-09T07:00:00.000Z',
        close: 243.2
    },
    {
        date: '2010-06-10T07:00:00.000Z',
        close: 250.51
    },
    {
        date: '2010-06-11T07:00:00.000Z',
        close: 253.51
    },
    {
        date: '2010-06-14T07:00:00.000Z',
        close: 254.28
    },
    {
        date: '2010-06-15T07:00:00.000Z',
        close: 259.69
    },
    {
        date: '2010-06-16T07:00:00.000Z',
        close: 267.25
    },
    {
        date: '2010-06-17T07:00:00.000Z',
        close: 271.87
    },
    {
        date: '2010-06-18T07:00:00.000Z',
        close: 274.07
    },
    {
        date: '2010-06-21T07:00:00.000Z',
        close: 270.17
    },
    {
        date: '2010-06-22T07:00:00.000Z',
        close: 273.85
    },
    {
        date: '2010-06-23T07:00:00.000Z',
        close: 270.97
    },
    {
        date: '2010-06-24T07:00:00.000Z',
        close: 269
    },
    {
        date: '2010-06-25T07:00:00.000Z',
        close: 266.7
    },
    {
        date: '2010-06-28T07:00:00.000Z',
        close: 268.3
    },
    {
        date: '2010-06-29T07:00:00.000Z',
        close: 256.17
    },
    {
        date: '2010-06-30T07:00:00.000Z',
        close: 251.53
    },
    {
        date: '2010-07-01T07:00:00.000Z',
        close: 248.48
    },
    {
        date: '2010-07-02T07:00:00.000Z',
        close: 246.94
    },
    {
        date: '2010-07-05T07:00:00.000Z',
        close: 246.94
    },
    {
        date: '2010-07-06T07:00:00.000Z',
        close: 248.63
    },
    {
        date: '2010-07-07T07:00:00.000Z',
        close: 258.66
    },
    {
        date: '2010-07-08T07:00:00.000Z',
        close: 258.09
    },
    {
        date: '2010-07-09T07:00:00.000Z',
        close: 259.62
    },
    {
        date: '2010-07-12T07:00:00.000Z',
        close: 257.28
    },
    {
        date: '2010-07-13T07:00:00.000Z',
        close: 251.8
    },
    {
        date: '2010-07-14T07:00:00.000Z',
        close: 252.73
    },
    {
        date: '2010-07-15T07:00:00.000Z',
        close: 251.45
    },
    {
        date: '2010-07-16T07:00:00.000Z',
        close: 249.9
    },
    {
        date: '2010-07-19T07:00:00.000Z',
        close: 245.58
    },
    {
        date: '2010-07-20T07:00:00.000Z',
        close: 251.89
    },
    {
        date: '2010-07-21T07:00:00.000Z',
        close: 254.24
    },
    {
        date: '2010-07-22T07:00:00.000Z',
        close: 259.02
    },
    {
        date: '2010-07-23T07:00:00.000Z',
        close: 259.94
    },
    {
        date: '2010-07-26T07:00:00.000Z',
        close: 259.28
    },
    {
        date: '2010-07-27T07:00:00.000Z',
        close: 264.08
    },
    {
        date: '2010-07-28T07:00:00.000Z',
        close: 260.96
    },
    {
        date: '2010-07-29T07:00:00.000Z',
        close: 258.11
    },
    {
        date: '2010-07-30T07:00:00.000Z',
        close: 257.25
    },
    {
        date: '2010-08-02T07:00:00.000Z',
        close: 261.85
    },
    {
        date: '2010-08-03T07:00:00.000Z',
        close: 261.93
    },
    {
        date: '2010-08-04T07:00:00.000Z',
        close: 262.98
    },
    {
        date: '2010-08-05T07:00:00.000Z',
        close: 261.7
    },
    {
        date: '2010-08-06T07:00:00.000Z',
        close: 260.09
    },
    {
        date: '2010-08-09T07:00:00.000Z',
        close: 261.75
    },
    {
        date: '2010-08-10T07:00:00.000Z',
        close: 259.41
    },
    {
        date: '2010-08-11T07:00:00.000Z',
        close: 250.19
    },
    {
        date: '2010-08-12T07:00:00.000Z',
        close: 251.79
    },
    {
        date: '2010-08-13T07:00:00.000Z',
        close: 249.1
    },
    {
        date: '2010-08-16T07:00:00.000Z',
        close: 247.64
    },
    {
        date: '2010-08-17T07:00:00.000Z',
        close: 251.97
    },
    {
        date: '2010-08-18T07:00:00.000Z',
        close: 253.07
    },
    {
        date: '2010-08-19T07:00:00.000Z',
        close: 249.88
    },
    {
        date: '2010-08-20T07:00:00.000Z',
        close: 249.64
    },
    {
        date: '2010-08-23T07:00:00.000Z',
        close: 245.8
    },
    {
        date: '2010-08-24T07:00:00.000Z',
        close: 239.93
    },
    {
        date: '2010-08-25T07:00:00.000Z',
        close: 242.89
    },
    {
        date: '2010-08-26T07:00:00.000Z',
        close: 240.28
    },
    {
        date: '2010-08-27T07:00:00.000Z',
        close: 241.62
    },
    {
        date: '2010-08-30T07:00:00.000Z',
        close: 242.5
    },
    {
        date: '2010-08-31T07:00:00.000Z',
        close: 243.1
    },
    {
        date: '2010-09-01T07:00:00.000Z',
        close: 250.33
    },
    {
        date: '2010-09-02T07:00:00.000Z',
        close: 252.17
    },
    {
        date: '2010-09-03T07:00:00.000Z',
        close: 258.77
    },
    {
        date: '2010-09-06T07:00:00.000Z',
        close: 258.77
    },
    {
        date: '2010-09-07T07:00:00.000Z',
        close: 257.81
    },
    {
        date: '2010-09-08T07:00:00.000Z',
        close: 262.92
    },
    {
        date: '2010-09-09T07:00:00.000Z',
        close: 263.07
    },
    {
        date: '2010-09-10T07:00:00.000Z',
        close: 263.41
    },
    {
        date: '2010-09-13T07:00:00.000Z',
        close: 267.04
    },
    {
        date: '2010-09-14T07:00:00.000Z',
        close: 268.06
    },
    {
        date: '2010-09-15T07:00:00.000Z',
        close: 270.22
    },
    {
        date: '2010-09-16T07:00:00.000Z',
        close: 276.57
    },
    {
        date: '2010-09-17T07:00:00.000Z',
        close: 275.37
    },
    {
        date: '2010-09-20T07:00:00.000Z',
        close: 283.23
    },
    {
        date: '2010-09-21T07:00:00.000Z',
        close: 283.77
    },
    {
        date: '2010-09-22T07:00:00.000Z',
        close: 287.75
    },
    {
        date: '2010-09-23T07:00:00.000Z',
        close: 288.92
    },
    {
        date: '2010-09-24T07:00:00.000Z',
        close: 292.32
    },
    {
        date: '2010-09-27T07:00:00.000Z',
        close: 291.16
    },
    {
        date: '2010-09-28T07:00:00.000Z',
        close: 286.86
    },
    {
        date: '2010-09-29T07:00:00.000Z',
        close: 287.37
    },
    {
        date: '2010-09-30T07:00:00.000Z',
        close: 283.75
    },
    {
        date: '2010-10-01T07:00:00.000Z',
        close: 282.52
    },
    {
        date: '2010-10-04T07:00:00.000Z',
        close: 278.64
    },
    {
        date: '2010-10-05T07:00:00.000Z',
        close: 288.94
    },
    {
        date: '2010-10-06T07:00:00.000Z',
        close: 289.19
    },
    {
        date: '2010-10-07T07:00:00.000Z',
        close: 289.22
    },
    {
        date: '2010-10-08T07:00:00.000Z',
        close: 294.07
    },
    {
        date: '2010-10-11T07:00:00.000Z',
        close: 295.36
    },
    {
        date: '2010-10-12T07:00:00.000Z',
        close: 298.54
    },
    {
        date: '2010-10-13T07:00:00.000Z',
        close: 300.14
    },
    {
        date: '2010-10-14T07:00:00.000Z',
        close: 302.31
    },
    {
        date: '2010-10-15T07:00:00.000Z',
        close: 314.74
    },
    {
        date: '2010-10-18T07:00:00.000Z',
        close: 318
    },
    {
        date: '2010-10-19T07:00:00.000Z',
        close: 309.49
    },
    {
        date: '2010-10-20T07:00:00.000Z',
        close: 310.53
    },
    {
        date: '2010-10-21T07:00:00.000Z',
        close: 309.52
    },
    {
        date: '2010-10-22T07:00:00.000Z',
        close: 307.47
    },
    {
        date: '2010-10-25T07:00:00.000Z',
        close: 308.84
    },
    {
        date: '2010-10-26T07:00:00.000Z',
        close: 308.05
    },
    {
        date: '2010-10-27T07:00:00.000Z',
        close: 307.83
    },
    {
        date: '2010-10-28T07:00:00.000Z',
        close: 305.24
    },
    {
        date: '2010-10-29T07:00:00.000Z',
        close: 300.98
    },
    {
        date: '2010-11-01T07:00:00.000Z',
        close: 304.18
    },
    {
        date: '2010-11-02T07:00:00.000Z',
        close: 309.36
    },
    {
        date: '2010-11-03T07:00:00.000Z',
        close: 312.8
    },
    {
        date: '2010-11-04T07:00:00.000Z',
        close: 318.27
    },
    {
        date: '2010-11-05T07:00:00.000Z',
        close: 317.13
    },
    {
        date: '2010-11-08T08:00:00.000Z',
        close: 318.62
    },
    {
        date: '2010-11-09T08:00:00.000Z',
        close: 316.08
    },
    {
        date: '2010-11-10T08:00:00.000Z',
        close: 318.03
    },
    {
        date: '2010-11-11T08:00:00.000Z',
        close: 316.66
    },
    {
        date: '2010-11-12T08:00:00.000Z',
        close: 308.03
    },
    {
        date: '2010-11-15T08:00:00.000Z',
        close: 307.04
    },
    {
        date: '2010-11-16T08:00:00.000Z',
        close: 301.59
    },
    {
        date: '2010-11-17T08:00:00.000Z',
        close: 300.5
    },
    {
        date: '2010-11-18T08:00:00.000Z',
        close: 308.43
    },
    {
        date: '2010-11-19T08:00:00.000Z',
        close: 306.73
    },
    {
        date: '2010-11-22T08:00:00.000Z',
        close: 313.36
    },
    {
        date: '2010-11-23T08:00:00.000Z',
        close: 308.73
    },
    {
        date: '2010-11-24T08:00:00.000Z',
        close: 314.8
    },
    {
        date: '2010-11-26T08:00:00.000Z',
        close: 315
    },
    {
        date: '2010-11-29T08:00:00.000Z',
        close: 316.87
    },
    {
        date: '2010-11-30T08:00:00.000Z',
        close: 311.15
    },
    {
        date: '2010-12-01T08:00:00.000Z',
        close: 316.4
    },
    {
        date: '2010-12-02T08:00:00.000Z',
        close: 318.15
    },
    {
        date: '2010-12-03T08:00:00.000Z',
        close: 317.44
    },
    {
        date: '2010-12-06T08:00:00.000Z',
        close: 320.15
    },
    {
        date: '2010-12-07T08:00:00.000Z',
        close: 318.21
    },
    {
        date: '2010-12-08T08:00:00.000Z',
        close: 321.01
    },
    {
        date: '2010-12-09T08:00:00.000Z',
        close: 319.76
    },
    {
        date: '2010-12-10T08:00:00.000Z',
        close: 320.56
    },
    {
        date: '2010-12-13T08:00:00.000Z',
        close: 321.67
    },
    {
        date: '2010-12-14T08:00:00.000Z',
        close: 320.29
    },
    {
        date: '2010-12-15T08:00:00.000Z',
        close: 320.36
    },
    {
        date: '2010-12-16T08:00:00.000Z',
        close: 321.25
    },
    {
        date: '2010-12-17T08:00:00.000Z',
        close: 320.61
    },
    {
        date: '2010-12-20T08:00:00.000Z',
        close: 322.21
    },
    {
        date: '2010-12-21T08:00:00.000Z',
        close: 324.2
    },
    {
        date: '2010-12-22T08:00:00.000Z',
        close: 325.16
    },
    {
        date: '2010-12-23T08:00:00.000Z',
        close: 323.6
    },
    {
        date: '2010-12-27T08:00:00.000Z',
        close: 324.68
    },
    {
        date: '2010-12-28T08:00:00.000Z',
        close: 325.47
    },
    {
        date: '2010-12-29T08:00:00.000Z',
        close: 325.29
    },
    {
        date: '2010-12-30T08:00:00.000Z',
        close: 323.66
    },
    {
        date: '2010-12-31T08:00:00.000Z',
        close: 322.56
    },
    {
        date: '2011-01-03T08:00:00.000Z',
        close: 329.57
    },
    {
        date: '2011-01-04T08:00:00.000Z',
        close: 331.29
    },
    {
        date: '2011-01-05T08:00:00.000Z',
        close: 334
    },
    {
        date: '2011-01-06T08:00:00.000Z',
        close: 333.73
    },
    {
        date: '2011-01-07T08:00:00.000Z',
        close: 336.12
    },
    {
        date: '2011-01-10T08:00:00.000Z',
        close: 342.46
    },
    {
        date: '2011-01-11T08:00:00.000Z',
        close: 341.64
    },
    {
        date: '2011-01-12T08:00:00.000Z',
        close: 344.42
    },
    {
        date: '2011-01-13T08:00:00.000Z',
        close: 345.68
    },
    {
        date: '2011-01-14T08:00:00.000Z',
        close: 348.48
    },
    {
        date: '2011-01-18T08:00:00.000Z',
        close: 340.65
    },
    {
        date: '2011-01-19T08:00:00.000Z',
        close: 338.84
    },
    {
        date: '2011-01-20T08:00:00.000Z',
        close: 332.68
    },
    {
        date: '2011-01-21T08:00:00.000Z',
        close: 326.72
    },
    {
        date: '2011-01-24T08:00:00.000Z',
        close: 337.45
    },
    {
        date: '2011-01-25T08:00:00.000Z',
        close: 341.4
    },
    {
        date: '2011-01-26T08:00:00.000Z',
        close: 343.85
    },
    {
        date: '2011-01-27T08:00:00.000Z',
        close: 343.21
    },
    {
        date: '2011-01-28T08:00:00.000Z',
        close: 336.1
    },
    {
        date: '2011-01-31T08:00:00.000Z',
        close: 339.32
    },
    {
        date: '2011-02-01T08:00:00.000Z',
        close: 345.03
    },
    {
        date: '2011-02-02T08:00:00.000Z',
        close: 344.32
    },
    {
        date: '2011-02-03T08:00:00.000Z',
        close: 343.44
    },
    {
        date: '2011-02-04T08:00:00.000Z',
        close: 346.5
    },
    {
        date: '2011-02-07T08:00:00.000Z',
        close: 351.88
    },
    {
        date: '2011-02-08T08:00:00.000Z',
        close: 355.2
    },
    {
        date: '2011-02-09T08:00:00.000Z',
        close: 358.16
    },
    {
        date: '2011-02-10T08:00:00.000Z',
        close: 354.54
    },
    {
        date: '2011-02-11T08:00:00.000Z',
        close: 356.85
    },
    {
        date: '2011-02-14T08:00:00.000Z',
        close: 359.18
    },
    {
        date: '2011-02-15T08:00:00.000Z',
        close: 359.9
    },
    {
        date: '2011-02-16T08:00:00.000Z',
        close: 363.13
    },
    {
        date: '2011-02-17T08:00:00.000Z',
        close: 358.3
    },
    {
        date: '2011-02-18T08:00:00.000Z',
        close: 350.56
    },
    {
        date: '2011-02-22T08:00:00.000Z',
        close: 338.61
    },
    {
        date: '2011-02-23T08:00:00.000Z',
        close: 342.62
    },
    {
        date: '2011-02-24T08:00:00.000Z',
        close: 342.88
    },
    {
        date: '2011-02-25T08:00:00.000Z',
        close: 348.16
    },
    {
        date: '2011-02-28T08:00:00.000Z',
        close: 353.21
    },
    {
        date: '2011-03-01T08:00:00.000Z',
        close: 349.31
    },
    {
        date: '2011-03-02T08:00:00.000Z',
        close: 352.12
    },
    {
        date: '2011-03-03T08:00:00.000Z',
        close: 359.56
    },
    {
        date: '2011-03-04T08:00:00.000Z',
        close: 360
    },
    {
        date: '2011-03-07T08:00:00.000Z',
        close: 355.36
    },
    {
        date: '2011-03-08T08:00:00.000Z',
        close: 355.76
    },
    {
        date: '2011-03-09T08:00:00.000Z',
        close: 352.47
    },
    {
        date: '2011-03-10T08:00:00.000Z',
        close: 346.67
    },
    {
        date: '2011-03-11T08:00:00.000Z',
        close: 351.99
    },
    {
        date: '2011-03-14T07:00:00.000Z',
        close: 353.56
    },
    {
        date: '2011-03-15T07:00:00.000Z',
        close: 345.43
    },
    {
        date: '2011-03-16T07:00:00.000Z',
        close: 330.01
    },
    {
        date: '2011-03-17T07:00:00.000Z',
        close: 334.64
    },
    {
        date: '2011-03-18T07:00:00.000Z',
        close: 330.67
    },
    {
        date: '2011-03-21T07:00:00.000Z',
        close: 339.3
    },
    {
        date: '2011-03-22T07:00:00.000Z',
        close: 341.2
    },
    {
        date: '2011-03-23T07:00:00.000Z',
        close: 339.19
    },
    {
        date: '2011-03-24T07:00:00.000Z',
        close: 344.97
    },
    {
        date: '2011-03-25T07:00:00.000Z',
        close: 351.54
    },
    {
        date: '2011-03-28T07:00:00.000Z',
        close: 350.44
    },
    {
        date: '2011-03-29T07:00:00.000Z',
        close: 350.96
    },
    {
        date: '2011-03-30T07:00:00.000Z',
        close: 348.63
    },
    {
        date: '2011-03-31T07:00:00.000Z',
        close: 348.51
    },
    {
        date: '2011-04-01T07:00:00.000Z',
        close: 344.56
    },
    {
        date: '2011-04-04T07:00:00.000Z',
        close: 341.19
    },
    {
        date: '2011-04-05T07:00:00.000Z',
        close: 338.89
    },
    {
        date: '2011-04-06T07:00:00.000Z',
        close: 338.04
    },
    {
        date: '2011-04-07T07:00:00.000Z',
        close: 338.08
    },
    {
        date: '2011-04-08T07:00:00.000Z',
        close: 335.06
    },
    {
        date: '2011-04-11T07:00:00.000Z',
        close: 330.8
    },
    {
        date: '2011-04-12T07:00:00.000Z',
        close: 332.4
    },
    {
        date: '2011-04-13T07:00:00.000Z',
        close: 336.13
    },
    {
        date: '2011-04-14T07:00:00.000Z',
        close: 332.42
    },
    {
        date: '2011-04-15T07:00:00.000Z',
        close: 327.46
    },
    {
        date: '2011-04-18T07:00:00.000Z',
        close: 331.85
    },
    {
        date: '2011-04-19T07:00:00.000Z',
        close: 337.86
    },
    {
        date: '2011-04-20T07:00:00.000Z',
        close: 342.41
    },
    {
        date: '2011-04-21T07:00:00.000Z',
        close: 350.7
    },
    {
        date: '2011-04-25T07:00:00.000Z',
        close: 353.01
    },
    {
        date: '2011-04-26T07:00:00.000Z',
        close: 350.42
    },
    {
        date: '2011-04-27T07:00:00.000Z',
        close: 350.15
    },
    {
        date: '2011-04-28T07:00:00.000Z',
        close: 346.75
    },
    {
        date: '2011-04-29T07:00:00.000Z',
        close: 350.13
    },
    {
        date: '2011-05-02T07:00:00.000Z',
        close: 346.28
    },
    {
        date: '2011-05-03T07:00:00.000Z',
        close: 348.2
    },
    {
        date: '2011-05-04T07:00:00.000Z',
        close: 349.57
    },
    {
        date: '2011-05-05T07:00:00.000Z',
        close: 346.75
    },
    {
        date: '2011-05-06T07:00:00.000Z',
        close: 346.66
    },
    {
        date: '2011-05-09T07:00:00.000Z',
        close: 347.6
    },
    {
        date: '2011-05-10T07:00:00.000Z',
        close: 349.45
    },
    {
        date: '2011-05-11T07:00:00.000Z',
        close: 347.23
    },
    {
        date: '2011-05-12T07:00:00.000Z',
        close: 346.57
    },
    {
        date: '2011-05-13T07:00:00.000Z',
        close: 340.5
    },
    {
        date: '2011-05-16T07:00:00.000Z',
        close: 333.3
    },
    {
        date: '2011-05-17T07:00:00.000Z',
        close: 336.14
    },
    {
        date: '2011-05-18T07:00:00.000Z',
        close: 339.87
    },
    {
        date: '2011-05-19T07:00:00.000Z',
        close: 340.53
    },
    {
        date: '2011-05-20T07:00:00.000Z',
        close: 335.22
    },
    {
        date: '2011-05-23T07:00:00.000Z',
        close: 334.4
    },
    {
        date: '2011-05-24T07:00:00.000Z',
        close: 332.19
    },
    {
        date: '2011-05-25T07:00:00.000Z',
        close: 336.78
    },
    {
        date: '2011-05-26T07:00:00.000Z',
        close: 335
    },
    {
        date: '2011-05-27T07:00:00.000Z',
        close: 337.41
    },
    {
        date: '2011-05-31T07:00:00.000Z',
        close: 347.83
    },
    {
        date: '2011-06-01T07:00:00.000Z',
        close: 345.51
    },
    {
        date: '2011-06-02T07:00:00.000Z',
        close: 346.1
    },
    {
        date: '2011-06-03T07:00:00.000Z',
        close: 343.44
    },
    {
        date: '2011-06-06T07:00:00.000Z',
        close: 338.04
    },
    {
        date: '2011-06-07T07:00:00.000Z',
        close: 332.04
    },
    {
        date: '2011-06-08T07:00:00.000Z',
        close: 332.24
    },
    {
        date: '2011-06-09T07:00:00.000Z',
        close: 331.49
    },
    {
        date: '2011-06-10T07:00:00.000Z',
        close: 325.9
    },
    {
        date: '2011-06-13T07:00:00.000Z',
        close: 326.6
    },
    {
        date: '2011-06-14T07:00:00.000Z',
        close: 332.44
    },
    {
        date: '2011-06-15T07:00:00.000Z',
        close: 326.75
    },
    {
        date: '2011-06-16T07:00:00.000Z',
        close: 325.16
    },
    {
        date: '2011-06-17T07:00:00.000Z',
        close: 320.26
    },
    {
        date: '2011-06-20T07:00:00.000Z',
        close: 315.32
    },
    {
        date: '2011-06-21T07:00:00.000Z',
        close: 325.3
    },
    {
        date: '2011-06-22T07:00:00.000Z',
        close: 322.61
    },
    {
        date: '2011-06-23T07:00:00.000Z',
        close: 331.23
    },
    {
        date: '2011-06-24T07:00:00.000Z',
        close: 326.35
    },
    {
        date: '2011-06-27T07:00:00.000Z',
        close: 332.04
    },
    {
        date: '2011-06-28T07:00:00.000Z',
        close: 335.26
    },
    {
        date: '2011-06-29T07:00:00.000Z',
        close: 334.04
    },
    {
        date: '2011-06-30T07:00:00.000Z',
        close: 335.67
    },
    {
        date: '2011-07-01T07:00:00.000Z',
        close: 343.26
    },
    {
        date: '2011-07-05T07:00:00.000Z',
        close: 349.43
    },
    {
        date: '2011-07-06T07:00:00.000Z',
        close: 351.76
    },
    {
        date: '2011-07-07T07:00:00.000Z',
        close: 357.2
    },
    {
        date: '2011-07-08T07:00:00.000Z',
        close: 359.71
    },
    {
        date: '2011-07-11T07:00:00.000Z',
        close: 354
    },
    {
        date: '2011-07-12T07:00:00.000Z',
        close: 353.75
    },
    {
        date: '2011-07-13T07:00:00.000Z',
        close: 358.02
    },
    {
        date: '2011-07-14T07:00:00.000Z',
        close: 357.77
    },
    {
        date: '2011-07-15T07:00:00.000Z',
        close: 364.92
    },
    {
        date: '2011-07-18T07:00:00.000Z',
        close: 373.8
    },
    {
        date: '2011-07-19T07:00:00.000Z',
        close: 376.85
    },
    {
        date: '2011-07-20T07:00:00.000Z',
        close: 386.9
    },
    {
        date: '2011-07-21T07:00:00.000Z',
        close: 387.29
    },
    {
        date: '2011-07-22T07:00:00.000Z',
        close: 393.3
    },
    {
        date: '2011-07-25T07:00:00.000Z',
        close: 398.5
    },
    {
        date: '2011-07-26T07:00:00.000Z',
        close: 403.41
    },
    {
        date: '2011-07-27T07:00:00.000Z',
        close: 392.59
    },
    {
        date: '2011-07-28T07:00:00.000Z',
        close: 391.82
    },
    {
        date: '2011-07-29T07:00:00.000Z',
        close: 390.48
    },
    {
        date: '2011-08-01T07:00:00.000Z',
        close: 396.75
    },
    {
        date: '2011-08-02T07:00:00.000Z',
        close: 388.91
    },
    {
        date: '2011-08-03T07:00:00.000Z',
        close: 392.57
    },
    {
        date: '2011-08-04T07:00:00.000Z',
        close: 377.37
    },
    {
        date: '2011-08-05T07:00:00.000Z',
        close: 373.62
    },
    {
        date: '2011-08-08T07:00:00.000Z',
        close: 353.21
    },
    {
        date: '2011-08-09T07:00:00.000Z',
        close: 374.01
    },
    {
        date: '2011-08-10T07:00:00.000Z',
        close: 363.69
    },
    {
        date: '2011-08-11T07:00:00.000Z',
        close: 373.7
    },
    {
        date: '2011-08-12T07:00:00.000Z',
        close: 376.99
    },
    {
        date: '2011-08-15T07:00:00.000Z',
        close: 383.41
    },
    {
        date: '2011-08-16T07:00:00.000Z',
        close: 380.48
    },
    {
        date: '2011-08-17T07:00:00.000Z',
        close: 380.44
    },
    {
        date: '2011-08-18T07:00:00.000Z',
        close: 366.05
    },
    {
        date: '2011-08-19T07:00:00.000Z',
        close: 356.03
    },
    {
        date: '2011-08-22T07:00:00.000Z',
        close: 356.44
    },
    {
        date: '2011-08-23T07:00:00.000Z',
        close: 373.6
    },
    {
        date: '2011-08-24T07:00:00.000Z',
        close: 376.18
    },
    {
        date: '2011-08-25T07:00:00.000Z',
        close: 373.72
    },
    {
        date: '2011-08-26T07:00:00.000Z',
        close: 383.58
    },
    {
        date: '2011-08-29T07:00:00.000Z',
        close: 389.97
    },
    {
        date: '2011-08-30T07:00:00.000Z',
        close: 389.99
    },
    {
        date: '2011-08-31T07:00:00.000Z',
        close: 384.83
    },
    {
        date: '2011-09-01T07:00:00.000Z',
        close: 381.03
    },
    {
        date: '2011-09-02T07:00:00.000Z',
        close: 374.05
    },
    {
        date: '2011-09-06T07:00:00.000Z',
        close: 379.74
    },
    {
        date: '2011-09-07T07:00:00.000Z',
        close: 383.93
    },
    {
        date: '2011-09-08T07:00:00.000Z',
        close: 384.14
    },
    {
        date: '2011-09-09T07:00:00.000Z',
        close: 377.48
    },
    {
        date: '2011-09-12T07:00:00.000Z',
        close: 379.94
    },
    {
        date: '2011-09-13T07:00:00.000Z',
        close: 384.62
    },
    {
        date: '2011-09-14T07:00:00.000Z',
        close: 389.3
    },
    {
        date: '2011-09-15T07:00:00.000Z',
        close: 392.96
    },
    {
        date: '2011-09-16T07:00:00.000Z',
        close: 400.5
    },
    {
        date: '2011-09-19T07:00:00.000Z',
        close: 411.63
    },
    {
        date: '2011-09-20T07:00:00.000Z',
        close: 413.45
    },
    {
        date: '2011-09-21T07:00:00.000Z',
        close: 412.14
    },
    {
        date: '2011-09-22T07:00:00.000Z',
        close: 401.82
    },
    {
        date: '2011-09-23T07:00:00.000Z',
        close: 404.3
    },
    {
        date: '2011-09-26T07:00:00.000Z',
        close: 403.17
    },
    {
        date: '2011-09-27T07:00:00.000Z',
        close: 399.26
    },
    {
        date: '2011-09-28T07:00:00.000Z',
        close: 397.01
    },
    {
        date: '2011-09-29T07:00:00.000Z',
        close: 390.57
    },
    {
        date: '2011-09-30T07:00:00.000Z',
        close: 381.32
    },
    {
        date: '2011-10-03T07:00:00.000Z',
        close: 374.6
    },
    {
        date: '2011-10-04T07:00:00.000Z',
        close: 372.5
    },
    {
        date: '2011-10-05T07:00:00.000Z',
        close: 378.25
    },
    {
        date: '2011-10-06T07:00:00.000Z',
        close: 377.37
    },
    {
        date: '2011-10-07T07:00:00.000Z',
        close: 369.8
    },
    {
        date: '2011-10-10T07:00:00.000Z',
        close: 388.81
    },
    {
        date: '2011-10-11T07:00:00.000Z',
        close: 400.29
    },
    {
        date: '2011-10-12T07:00:00.000Z',
        close: 402.19
    },
    {
        date: '2011-10-13T07:00:00.000Z',
        close: 408.43
    },
    {
        date: '2011-10-14T07:00:00.000Z',
        close: 422
    },
    {
        date: '2011-10-17T07:00:00.000Z',
        close: 419.99
    },
    {
        date: '2011-10-18T07:00:00.000Z',
        close: 422.24
    },
    {
        date: '2011-10-19T07:00:00.000Z',
        close: 398.62
    },
    {
        date: '2011-10-20T07:00:00.000Z',
        close: 395.31
    },
    {
        date: '2011-10-21T07:00:00.000Z',
        close: 392.87
    },
    {
        date: '2011-10-24T07:00:00.000Z',
        close: 405.77
    },
    {
        date: '2011-10-25T07:00:00.000Z',
        close: 397.77
    },
    {
        date: '2011-10-26T07:00:00.000Z',
        close: 400.6
    },
    {
        date: '2011-10-27T07:00:00.000Z',
        close: 404.69
    },
    {
        date: '2011-10-28T07:00:00.000Z',
        close: 404.95
    },
    {
        date: '2011-10-31T07:00:00.000Z',
        close: 404.78
    },
    {
        date: '2011-11-01T07:00:00.000Z',
        close: 396.51
    },
    {
        date: '2011-11-02T07:00:00.000Z',
        close: 397.41
    },
    {
        date: '2011-11-03T07:00:00.000Z',
        close: 403.07
    },
    {
        date: '2011-11-04T07:00:00.000Z',
        close: 400.24
    },
    {
        date: '2011-11-07T08:00:00.000Z',
        close: 399.73
    },
    {
        date: '2011-11-08T08:00:00.000Z',
        close: 406.23
    },
    {
        date: '2011-11-09T08:00:00.000Z',
        close: 395.28
    },
    {
        date: '2011-11-10T08:00:00.000Z',
        close: 385.22
    },
    {
        date: '2011-11-11T08:00:00.000Z',
        close: 384.62
    },
    {
        date: '2011-11-14T08:00:00.000Z',
        close: 379.26
    },
    {
        date: '2011-11-15T08:00:00.000Z',
        close: 388.83
    },
    {
        date: '2011-11-16T08:00:00.000Z',
        close: 384.77
    },
    {
        date: '2011-11-17T08:00:00.000Z',
        close: 377.41
    },
    {
        date: '2011-11-18T08:00:00.000Z',
        close: 374.94
    },
    {
        date: '2011-11-21T08:00:00.000Z',
        close: 369.01
    },
    {
        date: '2011-11-22T08:00:00.000Z',
        close: 376.51
    },
    {
        date: '2011-11-23T08:00:00.000Z',
        close: 366.99
    },
    {
        date: '2011-11-25T08:00:00.000Z',
        close: 363.57
    },
    {
        date: '2011-11-28T08:00:00.000Z',
        close: 376.12
    },
    {
        date: '2011-11-29T08:00:00.000Z',
        close: 373.2
    },
    {
        date: '2011-11-30T08:00:00.000Z',
        close: 382.2
    },
    {
        date: '2011-12-01T08:00:00.000Z',
        close: 387.93
    },
    {
        date: '2011-12-02T08:00:00.000Z',
        close: 389.7
    },
    {
        date: '2011-12-05T08:00:00.000Z',
        close: 393.01
    },
    {
        date: '2011-12-06T08:00:00.000Z',
        close: 390.95
    },
    {
        date: '2011-12-07T08:00:00.000Z',
        close: 389.09
    },
    {
        date: '2011-12-08T08:00:00.000Z',
        close: 390.66
    },
    {
        date: '2011-12-09T08:00:00.000Z',
        close: 393.62
    },
    {
        date: '2011-12-12T08:00:00.000Z',
        close: 391.84
    },
    {
        date: '2011-12-13T08:00:00.000Z',
        close: 388.81
    },
    {
        date: '2011-12-14T08:00:00.000Z',
        close: 380.19
    },
    {
        date: '2011-12-15T08:00:00.000Z',
        close: 378.94
    },
    {
        date: '2011-12-16T08:00:00.000Z',
        close: 381.02
    },
    {
        date: '2011-12-19T08:00:00.000Z',
        close: 382.21
    },
    {
        date: '2011-12-20T08:00:00.000Z',
        close: 395.95
    },
    {
        date: '2011-12-21T08:00:00.000Z',
        close: 396.44
    },
    {
        date: '2011-12-22T08:00:00.000Z',
        close: 398.55
    },
    {
        date: '2011-12-23T08:00:00.000Z',
        close: 403.43
    },
    {
        date: '2011-12-27T08:00:00.000Z',
        close: 406.53
    },
    {
        date: '2011-12-28T08:00:00.000Z',
        close: 402.64
    },
    {
        date: '2011-12-29T08:00:00.000Z',
        close: 405.12
    },
    {
        date: '2011-12-30T08:00:00.000Z',
        close: 405
    },
    {
        date: '2012-01-03T08:00:00.000Z',
        close: 411.23
    },
    {
        date: '2012-01-04T08:00:00.000Z',
        close: 413.44
    },
    {
        date: '2012-01-05T08:00:00.000Z',
        close: 418.03
    },
    {
        date: '2012-01-06T08:00:00.000Z',
        close: 422.4
    },
    {
        date: '2012-01-09T08:00:00.000Z',
        close: 421.73
    },
    {
        date: '2012-01-10T08:00:00.000Z',
        close: 423.24
    },
    {
        date: '2012-01-11T08:00:00.000Z',
        close: 422.55
    },
    {
        date: '2012-01-12T08:00:00.000Z',
        close: 421.39
    },
    {
        date: '2012-01-13T08:00:00.000Z',
        close: 419.81
    },
    {
        date: '2012-01-17T08:00:00.000Z',
        close: 424.7
    },
    {
        date: '2012-01-18T08:00:00.000Z',
        close: 429.11
    },
    {
        date: '2012-01-19T08:00:00.000Z',
        close: 427.75
    },
    {
        date: '2012-01-20T08:00:00.000Z',
        close: 420.3
    },
    {
        date: '2012-01-23T08:00:00.000Z',
        close: 427.41
    },
    {
        date: '2012-01-24T08:00:00.000Z',
        close: 420.41
    },
    {
        date: '2012-01-25T08:00:00.000Z',
        close: 446.66
    },
    {
        date: '2012-01-26T08:00:00.000Z',
        close: 444.63
    },
    {
        date: '2012-01-27T08:00:00.000Z',
        close: 447.28
    },
    {
        date: '2012-01-30T08:00:00.000Z',
        close: 453.01
    },
    {
        date: '2012-01-31T08:00:00.000Z',
        close: 456.48
    },
    {
        date: '2012-02-01T08:00:00.000Z',
        close: 456.19
    },
    {
        date: '2012-02-02T08:00:00.000Z',
        close: 455.12
    },
    {
        date: '2012-02-03T08:00:00.000Z',
        close: 459.68
    },
    {
        date: '2012-02-06T08:00:00.000Z',
        close: 463.97
    },
    {
        date: '2012-02-07T08:00:00.000Z',
        close: 468.83
    },
    {
        date: '2012-02-08T08:00:00.000Z',
        close: 476.68
    },
    {
        date: '2012-02-09T08:00:00.000Z',
        close: 493.17
    },
    {
        date: '2012-02-10T08:00:00.000Z',
        close: 493.42
    },
    {
        date: '2012-02-13T08:00:00.000Z',
        close: 502.6
    },
    {
        date: '2012-02-14T08:00:00.000Z',
        close: 509.46
    },
    {
        date: '2012-02-15T08:00:00.000Z',
        close: 497.67
    },
    {
        date: '2012-02-16T08:00:00.000Z',
        close: 502.21
    },
    {
        date: '2012-02-17T08:00:00.000Z',
        close: 502.12
    },
    {
        date: '2012-02-21T08:00:00.000Z',
        close: 514.85
    },
    {
        date: '2012-02-22T08:00:00.000Z',
        close: 513.04
    },
    {
        date: '2012-02-23T08:00:00.000Z',
        close: 516.39
    },
    {
        date: '2012-02-24T08:00:00.000Z',
        close: 522.41
    },
    {
        date: '2012-02-27T08:00:00.000Z',
        close: 525.76
    },
    {
        date: '2012-02-28T08:00:00.000Z',
        close: 535.41
    },
    {
        date: '2012-02-29T08:00:00.000Z',
        close: 542.44
    },
    {
        date: '2012-03-01T08:00:00.000Z',
        close: 544.47
    },
    {
        date: '2012-03-02T08:00:00.000Z',
        close: 545.18
    },
    {
        date: '2012-03-05T08:00:00.000Z',
        close: 533.16
    },
    {
        date: '2012-03-06T08:00:00.000Z',
        close: 530.26
    },
    {
        date: '2012-03-07T08:00:00.000Z',
        close: 530.69
    },
    {
        date: '2012-03-08T08:00:00.000Z',
        close: 541.99
    },
    {
        date: '2012-03-09T08:00:00.000Z',
        close: 545.17
    },
    {
        date: '2012-03-12T07:00:00.000Z',
        close: 552
    },
    {
        date: '2012-03-13T07:00:00.000Z',
        close: 568.1
    },
    {
        date: '2012-03-14T07:00:00.000Z',
        close: 589.58
    },
    {
        date: '2012-03-15T07:00:00.000Z',
        close: 585.56
    },
    {
        date: '2012-03-16T07:00:00.000Z',
        close: 585.57
    },
    {
        date: '2012-03-19T07:00:00.000Z',
        close: 601.1
    },
    {
        date: '2012-03-20T07:00:00.000Z',
        close: 605.96
    },
    {
        date: '2012-03-21T07:00:00.000Z',
        close: 602.5
    },
    {
        date: '2012-03-22T07:00:00.000Z',
        close: 599.34
    },
    {
        date: '2012-03-23T07:00:00.000Z',
        close: 596.05
    },
    {
        date: '2012-03-26T07:00:00.000Z',
        close: 606.98
    },
    {
        date: '2012-03-27T07:00:00.000Z',
        close: 614.48
    },
    {
        date: '2012-03-28T07:00:00.000Z',
        close: 617.62
    },
    {
        date: '2012-03-29T07:00:00.000Z',
        close: 609.86
    },
    {
        date: '2012-03-30T07:00:00.000Z',
        close: 599.55
    },
    {
        date: '2012-04-02T07:00:00.000Z',
        close: 618.63
    },
    {
        date: '2012-04-03T07:00:00.000Z',
        close: 629.32
    },
    {
        date: '2012-04-04T07:00:00.000Z',
        close: 624.31
    },
    {
        date: '2012-04-05T07:00:00.000Z',
        close: 633.68
    },
    {
        date: '2012-04-09T07:00:00.000Z',
        close: 636.23
    },
    {
        date: '2012-04-10T07:00:00.000Z',
        close: 628.44
    },
    {
        date: '2012-04-11T07:00:00.000Z',
        close: 626.2
    },
    {
        date: '2012-04-12T07:00:00.000Z',
        close: 622.77
    },
    {
        date: '2012-04-13T07:00:00.000Z',
        close: 605.23
    },
    {
        date: '2012-04-16T07:00:00.000Z',
        close: 580.13
    },
    {
        date: '2012-04-17T07:00:00.000Z',
        close: 609.7
    },
    {
        date: '2012-04-18T07:00:00.000Z',
        close: 608.34
    },
    {
        date: '2012-04-19T07:00:00.000Z',
        close: 587.44
    },
    {
        date: '2012-04-20T07:00:00.000Z',
        close: 572.98
    },
    {
        date: '2012-04-23T07:00:00.000Z',
        close: 571.7
    },
    {
        date: '2012-04-24T07:00:00.000Z',
        close: 560.28
    },
    {
        date: '2012-04-25T07:00:00.000Z',
        close: 610
    },
    {
        date: '2012-04-26T07:00:00.000Z',
        close: 607.7
    },
    {
        date: '2012-04-27T07:00:00.000Z',
        close: 603
    },
    {
        date: '2012-04-30T07:00:00.000Z',
        close: 583.98
    },
    {
        date: '2012-05-01T07:00:00.000Z',
        close: 582.13
    }
];
var $0c8ca50a4276708d$export$2e2bcd8739ae039 = $0c8ca50a4276708d$var$appleStock;


const $0e7a87273ba01706$var$bitcoinPrice = {
    currency: 'USD',
    prices: [
        {
            price: '2486.69',
            time: '2017-07-03T00:00:00Z'
        },
        {
            price: '2457.05',
            time: '2017-07-02T00:00:00Z'
        },
        {
            price: '2486.09',
            time: '2017-07-01T00:00:00Z'
        },
        {
            price: '2535.85',
            time: '2017-06-30T00:00:00Z'
        },
        {
            price: '2546.06',
            time: '2017-06-29T00:00:00Z'
        },
        {
            price: '2465.83',
            time: '2017-06-28T00:00:00Z'
        },
        {
            price: '2424.59',
            time: '2017-06-27T00:00:00Z'
        },
        {
            price: '2503.52',
            time: '2017-06-26T00:00:00Z'
        },
        {
            price: '2605.97',
            time: '2017-06-25T00:00:00Z'
        },
        {
            price: '2681.55',
            time: '2017-06-24T00:00:00Z'
        },
        {
            price: '2685.69',
            time: '2017-06-23T00:00:00Z'
        },
        {
            price: '2677.86',
            time: '2017-06-22T00:00:00Z'
        },
        {
            price: '2672.44',
            time: '2017-06-21T00:00:00Z'
        },
        {
            price: '2604.15',
            time: '2017-06-20T00:00:00Z'
        },
        {
            price: '2560.02',
            time: '2017-06-19T00:00:00Z'
        },
        {
            price: '2560.02',
            time: '2017-06-18T00:00:00Z'
        },
        {
            price: '2496.85',
            time: '2017-06-17T00:00:00Z'
        },
        {
            price: '2396.05',
            time: '2017-06-16T00:00:00Z'
        },
        {
            price: '2510.72',
            time: '2017-06-15T00:00:00Z'
        },
        {
            price: '2691.87',
            time: '2017-06-14T00:00:00Z'
        },
        {
            price: '2767.11',
            time: '2017-06-13T00:00:00Z'
        },
        {
            price: '2875.40',
            time: '2017-06-12T00:00:00Z'
        },
        {
            price: '2893.70',
            time: '2017-06-11T00:00:00Z'
        },
        {
            price: '2840.12',
            time: '2017-06-10T00:00:00Z'
        },
        {
            price: '2787.07',
            time: '2017-06-09T00:00:00Z'
        },
        {
            price: '2784.10',
            time: '2017-06-08T00:00:00Z'
        },
        {
            price: '2824.72',
            time: '2017-06-07T00:00:00Z'
        },
        {
            price: '2717.66',
            time: '2017-06-06T00:00:00Z'
        },
        {
            price: '2561.24',
            time: '2017-06-05T00:00:00Z'
        },
        {
            price: '2521.49',
            time: '2017-06-04T00:00:00Z'
        },
        {
            price: '2474.40',
            time: '2017-06-03T00:00:00Z'
        },
        {
            price: '2415.43',
            time: '2017-06-02T00:00:00Z'
        },
        {
            price: '2326.10',
            time: '2017-06-01T00:00:00Z'
        },
        {
            price: '2257.12',
            time: '2017-05-31T00:00:00Z'
        },
        {
            price: '2259.77',
            time: '2017-05-30T00:00:00Z'
        },
        {
            price: '2241.54',
            time: '2017-05-29T00:00:00Z'
        },
        {
            price: '2177.53',
            time: '2017-05-28T00:00:00Z'
        },
        {
            price: '2286.81',
            time: '2017-05-27T00:00:00Z'
        },
        {
            price: '2529.24',
            time: '2017-05-26T00:00:00Z'
        },
        {
            price: '2495.06',
            time: '2017-05-25T00:00:00Z'
        },
        {
            price: '2291.99',
            time: '2017-05-24T00:00:00Z'
        },
        {
            price: '2193.03',
            time: '2017-05-23T00:00:00Z'
        },
        {
            price: '2111.77',
            time: '2017-05-22T00:00:00Z'
        },
        {
            price: '2028.07',
            time: '2017-05-21T00:00:00Z'
        },
        {
            price: '1969.02',
            time: '2017-05-20T00:00:00Z'
        },
        {
            price: '1887.03',
            time: '2017-05-19T00:00:00Z'
        },
        {
            price: '1826.10',
            time: '2017-05-18T00:00:00Z'
        },
        {
            price: '1780.64',
            time: '2017-05-17T00:00:00Z'
        },
        {
            price: '1749.55',
            time: '2017-05-16T00:00:00Z'
        },
        {
            price: '1776.40',
            time: '2017-05-15T00:00:00Z'
        },
        {
            price: '1757.89',
            time: '2017-05-14T00:00:00Z'
        },
        {
            price: '1744.99',
            time: '2017-05-13T00:00:00Z'
        },
        {
            price: '1805.78',
            time: '2017-05-12T00:00:00Z'
        },
        {
            price: '1797.73',
            time: '2017-05-11T00:00:00Z'
        },
        {
            price: '1744.12',
            time: '2017-05-10T00:00:00Z'
        },
        {
            price: '1686.35',
            time: '2017-05-09T00:00:00Z'
        },
        {
            price: '1615.85',
            time: '2017-05-08T00:00:00Z'
        },
        {
            price: '1587.20',
            time: '2017-05-07T00:00:00Z'
        },
        {
            price: '1586.94',
            time: '2017-05-06T00:00:00Z'
        },
        {
            price: '1581.34',
            time: '2017-05-05T00:00:00Z'
        },
        {
            price: '1527.60',
            time: '2017-05-04T00:00:00Z'
        },
        {
            price: '1471.55',
            time: '2017-05-03T00:00:00Z'
        },
        {
            price: '1443.54',
            time: '2017-05-02T00:00:00Z'
        },
        {
            price: '1390.24',
            time: '2017-05-01T00:00:00Z'
        },
        {
            price: '1355.06',
            time: '2017-04-30T00:00:00Z'
        },
        {
            price: '1348.26',
            time: '2017-04-29T00:00:00Z'
        },
        {
            price: '1332.27',
            time: '2017-04-28T00:00:00Z'
        },
        {
            price: '1309.72',
            time: '2017-04-27T00:00:00Z'
        },
        {
            price: '1284.85',
            time: '2017-04-26T00:00:00Z'
        },
        {
            price: '1263.26',
            time: '2017-04-25T00:00:00Z'
        },
        {
            price: '1250.04',
            time: '2017-04-24T00:00:00Z'
        },
        {
            price: '1246.39',
            time: '2017-04-23T00:00:00Z'
        },
        {
            price: '1246.58',
            time: '2017-04-22T00:00:00Z'
        },
        {
            price: '1236.49',
            time: '2017-04-21T00:00:00Z'
        },
        {
            price: '1213.50',
            time: '2017-04-20T00:00:00Z'
        },
        {
            price: '1200.11',
            time: '2017-04-19T00:00:00Z'
        },
        {
            price: '1189.61',
            time: '2017-04-18T00:00:00Z'
        },
        {
            price: '1181.45',
            time: '2017-04-17T00:00:00Z'
        },
        {
            price: '1181.88',
            time: '2017-04-16T00:00:00Z'
        },
        {
            price: '1181.83',
            time: '2017-04-15T00:00:00Z'
        },
        {
            price: '1186.16',
            time: '2017-04-14T00:00:00Z'
        },
        {
            price: '1204.46',
            time: '2017-04-13T00:00:00Z'
        },
        {
            price: '1217.29',
            time: '2017-04-12T00:00:00Z'
        },
        {
            price: '1213.63',
            time: '2017-04-11T00:00:00Z'
        },
        {
            price: '1202.89',
            time: '2017-04-10T00:00:00Z'
        },
        {
            price: '1191.20',
            time: '2017-04-09T00:00:00Z'
        },
        {
            price: '1190.41',
            time: '2017-04-08T00:00:00Z'
        },
        {
            price: '1180.29',
            time: '2017-04-07T00:00:00Z'
        },
        {
            price: '1150.33',
            time: '2017-04-06T00:00:00Z'
        },
        {
            price: '1140.12',
            time: '2017-04-05T00:00:00Z'
        },
        {
            price: '1145.39',
            time: '2017-04-04T00:00:00Z'
        },
        {
            price: '1119.65',
            time: '2017-04-03T00:00:00Z'
        },
        {
            price: '1093.52',
            time: '2017-04-02T00:00:00Z'
        },
        {
            price: '1076.90',
            time: '2017-04-01T00:00:00Z'
        },
        {
            price: '1051.25',
            time: '2017-03-31T00:00:00Z'
        },
        {
            price: '1037.28',
            time: '2017-03-30T00:00:00Z'
        },
        {
            price: '1039.87',
            time: '2017-03-29T00:00:00Z'
        },
        {
            price: '1023.50',
            time: '2017-03-28T00:00:00Z'
        },
        {
            price: '988.37',
            time: '2017-03-27T00:00:00Z'
        },
        {
            price: '952.11',
            time: '2017-03-26T00:00:00Z'
        },
        {
            price: '961.10',
            time: '2017-03-25T00:00:00Z'
        },
        {
            price: '1014.03',
            time: '2017-03-24T00:00:00Z'
        },
        {
            price: '1043.38',
            time: '2017-03-23T00:00:00Z'
        },
        {
            price: '1068.36',
            time: '2017-03-22T00:00:00Z'
        },
        {
            price: '1060.90',
            time: '2017-03-21T00:00:00Z'
        },
        {
            price: '1024.30',
            time: '2017-03-20T00:00:00Z'
        },
        {
            price: '1022.64',
            time: '2017-03-19T00:00:00Z'
        },
        {
            price: '1082.00',
            time: '2017-03-18T00:00:00Z'
        },
        {
            price: '1177.35',
            time: '2017-03-17T00:00:00Z'
        },
        {
            price: '1238.63',
            time: '2017-03-16T00:00:00Z'
        },
        {
            price: '1250.37',
            time: '2017-03-15T00:00:00Z'
        },
        {
            price: '1242.67',
            time: '2017-03-14T00:00:00Z'
        },
        {
            price: '1222.09',
            time: '2017-03-13T00:00:00Z'
        },
        {
            price: '1193.70',
            time: '2017-03-12T00:00:00Z'
        },
        {
            price: '1194.52',
            time: '2017-03-11T00:00:00Z'
        },
        {
            price: '1193.55',
            time: '2017-03-10T00:00:00Z'
        },
        {
            price: '1188.06',
            time: '2017-03-09T00:00:00Z'
        },
        {
            price: '1227.60',
            time: '2017-03-08T00:00:00Z'
        },
        {
            price: '1270.32',
            time: '2017-03-07T00:00:00Z'
        },
        {
            price: '1274.57',
            time: '2017-03-06T00:00:00Z'
        },
        {
            price: '1274.54',
            time: '2017-03-05T00:00:00Z'
        },
        {
            price: '1280.36',
            time: '2017-03-04T00:00:00Z'
        },
        {
            price: '1262.32',
            time: '2017-03-03T00:00:00Z'
        },
        {
            price: '1228.19',
            time: '2017-03-02T00:00:00Z'
        },
        {
            price: '1203.02',
            time: '2017-03-01T00:00:00Z'
        },
        {
            price: '1192.69',
            time: '2017-02-28T00:00:00Z'
        },
        {
            price: '1177.64',
            time: '2017-02-27T00:00:00Z'
        },
        {
            price: '1168.97',
            time: '2017-02-26T00:00:00Z'
        },
        {
            price: '1180.19',
            time: '2017-02-25T00:00:00Z'
        },
        {
            price: '1168.59',
            time: '2017-02-24T00:00:00Z'
        },
        {
            price: '1137.16',
            time: '2017-02-23T00:00:00Z'
        },
        {
            price: '1114.89',
            time: '2017-02-22T00:00:00Z'
        },
        {
            price: '1083.83',
            time: '2017-02-21T00:00:00Z'
        },
        {
            price: '1061.14',
            time: '2017-02-20T00:00:00Z'
        },
        {
            price: '1062.95',
            time: '2017-02-19T00:00:00Z'
        },
        {
            price: '1058.15',
            time: '2017-02-18T00:00:00Z'
        },
        {
            price: '1039.30',
            time: '2017-02-17T00:00:00Z'
        },
        {
            price: '1020.38',
            time: '2017-02-16T00:00:00Z'
        },
        {
            price: '1010.49',
            time: '2017-02-15T00:00:00Z'
        },
        {
            price: '1006.83',
            time: '2017-02-14T00:00:00Z'
        },
        {
            price: '1008.77',
            time: '2017-02-13T00:00:00Z'
        },
        {
            price: '1013.09',
            time: '2017-02-12T00:00:00Z'
        },
        {
            price: '998.84',
            time: '2017-02-11T00:00:00Z'
        },
        {
            price: '1005.98',
            time: '2017-02-10T00:00:00Z'
        },
        {
            price: '1040.79',
            time: '2017-02-09T00:00:00Z'
        },
        {
            price: '1049.02',
            time: '2017-02-08T00:00:00Z'
        },
        {
            price: '1033.10',
            time: '2017-02-07T00:00:00Z'
        },
        {
            price: '1022.49',
            time: '2017-02-06T00:00:00Z'
        },
        {
            price: '1021.09',
            time: '2017-02-05T00:00:00Z'
        },
        {
            price: '1016.81',
            time: '2017-02-04T00:00:00Z'
        },
        {
            price: '1004.46',
            time: '2017-02-03T00:00:00Z'
        },
        {
            price: '985.20',
            time: '2017-02-02T00:00:00Z'
        },
        {
            price: '960.05',
            time: '2017-02-01T00:00:00Z'
        },
        {
            price: '932.34',
            time: '2017-01-31T00:00:00Z'
        },
        {
            price: '921.61',
            time: '2017-01-30T00:00:00Z'
        },
        {
            price: '923.45',
            time: '2017-01-29T00:00:00Z'
        },
        {
            price: '922.11',
            time: '2017-01-28T00:00:00Z'
        },
        {
            price: '914.58',
            time: '2017-01-27T00:00:00Z'
        },
        {
            price: '903.38',
            time: '2017-01-26T00:00:00Z'
        },
        {
            price: '902.84',
            time: '2017-01-25T00:00:00Z'
        },
        {
            price: '915.84',
            time: '2017-01-24T00:00:00Z'
        },
        {
            price: '926.01',
            time: '2017-01-23T00:00:00Z'
        },
        {
            price: '923.76',
            time: '2017-01-22T00:00:00Z'
        },
        {
            price: '908.72',
            time: '2017-01-21T00:00:00Z'
        },
        {
            price: '897.88',
            time: '2017-01-20T00:00:00Z'
        },
        {
            price: '893.30',
            time: '2017-01-19T00:00:00Z'
        },
        {
            price: '884.78',
            time: '2017-01-18T00:00:00Z'
        },
        {
            price: '857.51',
            time: '2017-01-17T00:00:00Z'
        },
        {
            price: '830.58',
            time: '2017-01-16T00:00:00Z'
        },
        {
            price: '830.58',
            time: '2017-01-15T00:00:00Z'
        },
        {
            price: '823.48',
            time: '2017-01-14T00:00:00Z'
        },
        {
            price: '801.98',
            time: '2017-01-13T00:00:00Z'
        },
        {
            price: '822.05',
            time: '2017-01-12T00:00:00Z'
        },
        {
            price: '879.50',
            time: '2017-01-11T00:00:00Z'
        },
        {
            price: '903.21',
            time: '2017-01-10T00:00:00Z'
        },
        {
            price: '911.94',
            time: '2017-01-09T00:00:00Z'
        },
        {
            price: '901.05',
            time: '2017-01-08T00:00:00Z'
        },
        {
            price: '908.09',
            time: '2017-01-07T00:00:00Z'
        },
        {
            price: '996.25',
            time: '2017-01-06T00:00:00Z'
        },
        {
            price: '1069.40',
            time: '2017-01-05T00:00:00Z'
        },
        {
            price: '1051.69',
            time: '2017-01-04T00:00:00Z'
        },
        {
            price: '1016.35',
            time: '2017-01-03T00:00:00Z'
        },
        {
            price: '996.34',
            time: '2017-01-02T00:00:00Z'
        },
        {
            price: '970.17',
            time: '2017-01-01T00:00:00Z'
        },
        {
            price: '958.35',
            time: '2016-12-31T00:00:00Z'
        },
        {
            price: '964.73',
            time: '2016-12-30T00:00:00Z'
        },
        {
            price: '962.92',
            time: '2016-12-29T00:00:00Z'
        },
        {
            price: '934.67',
            time: '2016-12-28T00:00:00Z'
        },
        {
            price: '908.25',
            time: '2016-12-27T00:00:00Z'
        },
        {
            price: '886.48',
            time: '2016-12-26T00:00:00Z'
        },
        {
            price: '887.28',
            time: '2016-12-25T00:00:00Z'
        },
        {
            price: '899.73',
            time: '2016-12-24T00:00:00Z'
        },
        {
            price: '877.04',
            time: '2016-12-23T00:00:00Z'
        },
        {
            price: '835.45',
            time: '2016-12-22T00:00:00Z'
        },
        {
            price: '803.14',
            time: '2016-12-21T00:00:00Z'
        },
        {
            price: '792.10',
            time: '2016-12-20T00:00:00Z'
        },
        {
            price: '791.55',
            time: '2016-12-19T00:00:00Z'
        },
        {
            price: '789.75',
            time: '2016-12-18T00:00:00Z'
        },
        {
            price: '784.61',
            time: '2016-12-17T00:00:00Z'
        },
        {
            price: '779.31',
            time: '2016-12-16T00:00:00Z'
        },
        {
            price: '778.71',
            time: '2016-12-15T00:00:00Z'
        },
        {
            price: '779.81',
            time: '2016-12-14T00:00:00Z'
        },
        {
            price: '778.68',
            time: '2016-12-13T00:00:00Z'
        },
        {
            price: '773.11',
            time: '2016-12-12T00:00:00Z'
        },
        {
            price: '772.10',
            time: '2016-12-11T00:00:00Z'
        },
        {
            price: '772.37',
            time: '2016-12-10T00:00:00Z'
        },
        {
            price: '769.21',
            time: '2016-12-09T00:00:00Z'
        },
        {
            price: '764.95',
            time: '2016-12-08T00:00:00Z'
        },
        {
            price: '759.64',
            time: '2016-12-07T00:00:00Z'
        },
        {
            price: '756.74',
            time: '2016-12-06T00:00:00Z'
        },
        {
            price: '761.05',
            time: '2016-12-05T00:00:00Z'
        },
        {
            price: '766.03',
            time: '2016-12-04T00:00:00Z'
        },
        {
            price: '767.07',
            time: '2016-12-03T00:00:00Z'
        },
        {
            price: '758.38',
            time: '2016-12-02T00:00:00Z'
        },
        {
            price: '743.33',
            time: '2016-12-01T00:00:00Z'
        },
        {
            price: '734.93',
            time: '2016-11-30T00:00:00Z'
        },
        {
            price: '731.72',
            time: '2016-11-29T00:00:00Z'
        },
        {
            price: '732.50',
            time: '2016-11-28T00:00:00Z'
        },
        {
            price: '734.23',
            time: '2016-11-27T00:00:00Z'
        },
        {
            price: '734.74',
            time: '2016-11-26T00:00:00Z'
        },
        {
            price: '736.43',
            time: '2016-11-25T00:00:00Z'
        },
        {
            price: '740.24',
            time: '2016-11-24T00:00:00Z'
        },
        {
            price: '740.85',
            time: '2016-11-23T00:00:00Z'
        },
        {
            price: '737.26',
            time: '2016-11-22T00:00:00Z'
        },
        {
            price: '738.17',
            time: '2016-11-21T00:00:00Z'
        },
        {
            price: '745.10',
            time: '2016-11-20T00:00:00Z'
        },
        {
            price: '745.69',
            time: '2016-11-19T00:00:00Z'
        },
        {
            price: '742.72',
            time: '2016-11-18T00:00:00Z'
        },
        {
            price: '732.75',
            time: '2016-11-17T00:00:00Z'
        },
        {
            price: '716.87',
            time: '2016-11-16T00:00:00Z'
        },
        {
            price: '707.17',
            time: '2016-11-15T00:00:00Z'
        },
        {
            price: '700.30',
            time: '2016-11-14T00:00:00Z'
        },
        {
            price: '703.71',
            time: '2016-11-13T00:00:00Z'
        },
        {
            price: '712.65',
            time: '2016-11-12T00:00:00Z'
        },
        {
            price: '715.15',
            time: '2016-11-11T00:00:00Z'
        },
        {
            price: '721.56',
            time: '2016-11-10T00:00:00Z'
        },
        {
            price: '718.51',
            time: '2016-11-09T00:00:00Z'
        },
        {
            price: '708.54',
            time: '2016-11-08T00:00:00Z'
        },
        {
            price: '710.74',
            time: '2016-11-07T00:00:00Z'
        },
        {
            price: '709.48',
            time: '2016-11-06T00:00:00Z'
        },
        {
            price: '703.17',
            time: '2016-11-05T00:00:00Z'
        },
        {
            price: '712.76',
            time: '2016-11-04T00:00:00Z'
        },
        {
            price: '725.39',
            time: '2016-11-03T00:00:00Z'
        },
        {
            price: '723.98',
            time: '2016-11-02T00:00:00Z'
        },
        {
            price: '710.86',
            time: '2016-11-01T00:00:00Z'
        },
        {
            price: '703.78',
            time: '2016-10-31T00:00:00Z'
        },
        {
            price: '708.07',
            time: '2016-10-30T00:00:00Z'
        },
        {
            price: '697.97',
            time: '2016-10-29T00:00:00Z'
        },
        {
            price: '685.53',
            time: '2016-10-28T00:00:00Z'
        },
        {
            price: '673.66',
            time: '2016-10-27T00:00:00Z'
        },
        {
            price: '658.85',
            time: '2016-10-26T00:00:00Z'
        },
        {
            price: '651.53',
            time: '2016-10-25T00:00:00Z'
        },
        {
            price: '650.70',
            time: '2016-10-24T00:00:00Z'
        },
        {
            price: '645.89',
            time: '2016-10-23T00:00:00Z'
        },
        {
            price: '634.72',
            time: '2016-10-22T00:00:00Z'
        },
        {
            price: '629.16',
            time: '2016-10-21T00:00:00Z'
        },
        {
            price: '630.62',
            time: '2016-10-20T00:00:00Z'
        },
        {
            price: '635.10',
            time: '2016-10-19T00:00:00Z'
        },
        {
            price: '638.61',
            time: '2016-10-18T00:00:00Z'
        },
        {
            price: '640.72',
            time: '2016-10-17T00:00:00Z'
        },
        {
            price: '640.40',
            time: '2016-10-16T00:00:00Z'
        },
        {
            price: '638.01',
            time: '2016-10-15T00:00:00Z'
        },
        {
            price: '636.78',
            time: '2016-10-14T00:00:00Z'
        },
        {
            price: '638.92',
            time: '2016-10-13T00:00:00Z'
        },
        {
            price: '637.50',
            time: '2016-10-12T00:00:00Z'
        },
        {
            price: '626.13',
            time: '2016-10-11T00:00:00Z'
        },
        {
            price: '617.95',
            time: '2016-10-10T00:00:00Z'
        },
        {
            price: '618.60',
            time: '2016-10-09T00:00:00Z'
        },
        {
            price: '617.01',
            time: '2016-10-08T00:00:00Z'
        },
        {
            price: '613.82',
            time: '2016-10-07T00:00:00Z'
        },
        {
            price: '612.13',
            time: '2016-10-06T00:00:00Z'
        },
        {
            price: '611.18',
            time: '2016-10-05T00:00:00Z'
        },
        {
            price: '612.03',
            time: '2016-10-04T00:00:00Z'
        },
        {
            price: '613.11',
            time: '2016-10-03T00:00:00Z'
        },
        {
            price: '613.41',
            time: '2016-10-02T00:00:00Z'
        },
        {
            price: '610.09',
            time: '2016-10-01T00:00:00Z'
        },
        {
            price: '605.86',
            time: '2016-09-30T00:00:00Z'
        },
        {
            price: '605.11',
            time: '2016-09-29T00:00:00Z'
        },
        {
            price: '604.93',
            time: '2016-09-28T00:00:00Z'
        },
        {
            price: '605.19',
            time: '2016-09-27T00:00:00Z'
        },
        {
            price: '603.80',
            time: '2016-09-26T00:00:00Z'
        },
        {
            price: '603.11',
            time: '2016-09-25T00:00:00Z'
        },
        {
            price: '601.59',
            time: '2016-09-24T00:00:00Z'
        },
        {
            price: '598.07',
            time: '2016-09-23T00:00:00Z'
        },
        {
            price: '597.36',
            time: '2016-09-22T00:00:00Z'
        },
        {
            price: '603.37',
            time: '2016-09-21T00:00:00Z'
        },
        {
            price: '609.43',
            time: '2016-09-20T00:00:00Z'
        },
        {
            price: '609.55',
            time: '2016-09-19T00:00:00Z'
        },
        {
            price: '608.32',
            time: '2016-09-18T00:00:00Z'
        },
        {
            price: '607.22',
            time: '2016-09-17T00:00:00Z'
        },
        {
            price: '607.46',
            time: '2016-09-16T00:00:00Z'
        },
        {
            price: '608.80',
            time: '2016-09-15T00:00:00Z'
        },
        {
            price: '608.80',
            time: '2016-09-14T00:00:00Z'
        },
        {
            price: '607.62',
            time: '2016-09-13T00:00:00Z'
        },
        {
            price: '614.06',
            time: '2016-09-12T00:00:00Z'
        },
        {
            price: '622.21',
            time: '2016-09-11T00:00:00Z'
        },
        {
            price: '623.19',
            time: '2016-09-10T00:00:00Z'
        },
        {
            price: '623.02',
            time: '2016-09-09T00:00:00Z'
        },
        {
            price: '618.19',
            time: '2016-09-08T00:00:00Z'
        },
        {
            price: '611.09',
            time: '2016-09-07T00:00:00Z'
        },
        {
            price: '608.25',
            time: '2016-09-06T00:00:00Z'
        },
        {
            price: '607.02',
            time: '2016-09-05T00:00:00Z'
        },
        {
            price: '593.49',
            time: '2016-09-04T00:00:00Z'
        },
        {
            price: '576.89',
            time: '2016-09-03T00:00:00Z'
        },
        {
            price: '572.49',
            time: '2016-09-02T00:00:00Z'
        },
        {
            price: '572.06',
            time: '2016-09-01T00:00:00Z'
        },
        {
            price: '573.79',
            time: '2016-08-31T00:00:00Z'
        },
        {
            price: '574.60',
            time: '2016-08-30T00:00:00Z'
        },
        {
            price: '573.26',
            time: '2016-08-29T00:00:00Z'
        },
        {
            price: '573.30',
            time: '2016-08-28T00:00:00Z'
        },
        {
            price: '576.00',
            time: '2016-08-27T00:00:00Z'
        },
        {
            price: '576.57',
            time: '2016-08-26T00:00:00Z'
        },
        {
            price: '577.57',
            time: '2016-08-25T00:00:00Z'
        },
        {
            price: '581.51',
            time: '2016-08-24T00:00:00Z'
        },
        {
            price: '582.90',
            time: '2016-08-23T00:00:00Z'
        },
        {
            price: '582.28',
            time: '2016-08-22T00:00:00Z'
        },
        {
            price: '580.17',
            time: '2016-08-21T00:00:00Z'
        },
        {
            price: '576.59',
            time: '2016-08-20T00:00:00Z'
        },
        {
            price: '575.01',
            time: '2016-08-19T00:00:00Z'
        },
        {
            price: '575.87',
            time: '2016-08-18T00:00:00Z'
        },
        {
            price: '574.76',
            time: '2016-08-17T00:00:00Z'
        },
        {
            price: '571.46',
            time: '2016-08-16T00:00:00Z'
        },
        {
            price: '574.12',
            time: '2016-08-15T00:00:00Z'
        },
        {
            price: '583.05',
            time: '2016-08-14T00:00:00Z'
        },
        {
            price: '587.77',
            time: '2016-08-13T00:00:00Z'
        },
        {
            price: '590.57',
            time: '2016-08-12T00:00:00Z'
        },
        {
            price: '592.91',
            time: '2016-08-11T00:00:00Z'
        },
        {
            price: '590.88',
            time: '2016-08-10T00:00:00Z'
        },
        {
            price: '591.39',
            time: '2016-08-09T00:00:00Z'
        },
        {
            price: '593.78',
            time: '2016-08-08T00:00:00Z'
        },
        {
            price: '588.18',
            time: '2016-08-07T00:00:00Z'
        },
        {
            price: '580.65',
            time: '2016-08-06T00:00:00Z'
        },
        {
            price: '580.37',
            time: '2016-08-05T00:00:00Z'
        },
        {
            price: '568.21',
            time: '2016-08-04T00:00:00Z'
        },
        {
            price: '573.49',
            time: '2016-08-03T00:00:00Z'
        },
        {
            price: '606.17',
            time: '2016-08-02T00:00:00Z'
        },
        {
            price: '629.55',
            time: '2016-08-01T00:00:00Z'
        },
        {
            price: '648.08',
            time: '2016-07-31T00:00:00Z'
        },
        {
            price: '657.23',
            time: '2016-07-30T00:00:00Z'
        },
        {
            price: '657.20',
            time: '2016-07-29T00:00:00Z'
        },
        {
            price: '655.84',
            time: '2016-07-28T00:00:00Z'
        },
        {
            price: '654.63',
            time: '2016-07-27T00:00:00Z'
        },
        {
            price: '656.40',
            time: '2016-07-26T00:00:00Z'
        },
        {
            price: '658.69',
            time: '2016-07-25T00:00:00Z'
        },
        {
            price: '659.01',
            time: '2016-07-24T00:00:00Z'
        },
        {
            price: '660.73',
            time: '2016-07-23T00:00:00Z'
        },
        {
            price: '664.14',
            time: '2016-07-22T00:00:00Z'
        },
        {
            price: '668.16',
            time: '2016-07-21T00:00:00Z'
        },
        {
            price: '672.13',
            time: '2016-07-20T00:00:00Z'
        },
        {
            price: '676.06',
            time: '2016-07-19T00:00:00Z'
        },
        {
            price: '675.67',
            time: '2016-07-18T00:00:00Z'
        },
        {
            price: '669.77',
            time: '2016-07-17T00:00:00Z'
        },
        {
            price: '666.29',
            time: '2016-07-16T00:00:00Z'
        },
        {
            price: '662.46',
            time: '2016-07-15T00:00:00Z'
        },
        {
            price: '661.86',
            time: '2016-07-14T00:00:00Z'
        },
        {
            price: '661.74',
            time: '2016-07-13T00:00:00Z'
        },
        {
            price: '656.05',
            time: '2016-07-12T00:00:00Z'
        },
        {
            price: '651.80',
            time: '2016-07-11T00:00:00Z'
        },
        {
            price: '652.32',
            time: '2016-07-10T00:00:00Z'
        },
        {
            price: '651.86',
            time: '2016-07-09T00:00:00Z'
        },
        {
            price: '647.65',
            time: '2016-07-08T00:00:00Z'
        },
        {
            price: '659.86',
            time: '2016-07-07T00:00:00Z'
        },
        {
            price: '674.19',
            time: '2016-07-06T00:00:00Z'
        },
        {
            price: '674.08',
            time: '2016-07-05T00:00:00Z'
        },
        {
            price: '676.18',
            time: '2016-07-04T00:00:00Z'
        }
    ]
};
var $0e7a87273ba01706$export$2e2bcd8739ae039 = $0e7a87273ba01706$var$bitcoinPrice;


const $6ece6bda933e0c38$var$letterFrequency = [
    {
        letter: 'A',
        frequency: 0.08167
    },
    {
        letter: 'B',
        frequency: 0.01492
    },
    {
        letter: 'C',
        frequency: 0.02782
    },
    {
        letter: 'D',
        frequency: 0.04253
    },
    {
        letter: 'E',
        frequency: 0.12702
    },
    {
        letter: 'F',
        frequency: 0.02288
    },
    {
        letter: 'G',
        frequency: 0.02015
    },
    {
        letter: 'H',
        frequency: 0.06094
    },
    {
        letter: 'I',
        frequency: 0.06966
    },
    {
        letter: 'J',
        frequency: 0.00153
    },
    {
        letter: 'K',
        frequency: 0.00772
    },
    {
        letter: 'L',
        frequency: 0.04025
    },
    {
        letter: 'M',
        frequency: 0.02406
    },
    {
        letter: 'N',
        frequency: 0.06749
    },
    {
        letter: 'O',
        frequency: 0.07507
    },
    {
        letter: 'P',
        frequency: 0.01929
    },
    {
        letter: 'Q',
        frequency: 0.00095
    },
    {
        letter: 'R',
        frequency: 0.05987
    },
    {
        letter: 'S',
        frequency: 0.06327
    },
    {
        letter: 'T',
        frequency: 0.09056
    },
    {
        letter: 'U',
        frequency: 0.02758
    },
    {
        letter: 'V',
        frequency: 0.00978
    },
    {
        letter: 'W',
        frequency: 0.0236
    },
    {
        letter: 'X',
        frequency: 0.0015
    },
    {
        letter: 'Y',
        frequency: 0.01974
    },
    {
        letter: 'Z',
        frequency: 0.00074
    }
];
var $6ece6bda933e0c38$export$2e2bcd8739ae039 = $6ece6bda933e0c38$var$letterFrequency;


const $88c830a15940181a$var$browserUsage = [
    {
        date: '2015 Jun 15',
        'Google Chrome': '48.09',
        'Internet Explorer': '24.14',
        Firefox: '18.82',
        Safari: '7.46',
        'Microsoft Edge': '0.03',
        Opera: '1.32',
        Mozilla: '0.12',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Jun 16',
        'Google Chrome': '48',
        'Internet Explorer': '24.19',
        Firefox: '18.96',
        Safari: '7.36',
        'Microsoft Edge': '0.03',
        Opera: '1.32',
        Mozilla: '0.12',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Jun 17',
        'Google Chrome': '47.87',
        'Internet Explorer': '24.44',
        Firefox: '18.91',
        Safari: '7.27',
        'Microsoft Edge': '0.03',
        Opera: '1.36',
        Mozilla: '0.12',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Jun 18',
        'Google Chrome': '48.22',
        'Internet Explorer': '23.83',
        Firefox: '19.16',
        Safari: '7.24',
        'Microsoft Edge': '0.04',
        Opera: '1.39',
        Mozilla: '0.12',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Jun 19',
        'Google Chrome': '47.91',
        'Internet Explorer': '23.86',
        Firefox: '19.35',
        Safari: '7.31',
        'Microsoft Edge': '0.04',
        Opera: '1.41',
        Mozilla: '0.12',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Jun 20',
        'Google Chrome': '48.78',
        'Internet Explorer': '21.14',
        Firefox: '19.66',
        Safari: '8.42',
        'Microsoft Edge': '0.05',
        Opera: '1.83',
        Mozilla: '0.1',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Jun 21',
        'Google Chrome': '49.43',
        'Internet Explorer': '20.55',
        Firefox: '19.42',
        Safari: '8.66',
        'Microsoft Edge': '0.05',
        Opera: '1.75',
        Mozilla: '0.12',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Jun 22',
        'Google Chrome': '48.98',
        'Internet Explorer': '23.47',
        Firefox: '18.84',
        Safari: '7.25',
        'Microsoft Edge': '0.04',
        Opera: '1.28',
        Mozilla: '0.12',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Jun 23',
        'Google Chrome': '48.69',
        'Internet Explorer': '23.76',
        Firefox: '18.89',
        Safari: '7.22',
        'Microsoft Edge': '0.04',
        Opera: '1.27',
        Mozilla: '0.11',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Jun 24',
        'Google Chrome': '49.17',
        'Internet Explorer': '23.35',
        Firefox: '18.91',
        Safari: '7.09',
        'Microsoft Edge': '0.04',
        Opera: '1.32',
        Mozilla: '0.12',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Jun 25',
        'Google Chrome': '49.32',
        'Internet Explorer': '23.39',
        Firefox: '18.76',
        Safari: '7.03',
        'Microsoft Edge': '0.04',
        Opera: '1.34',
        Mozilla: '0.11',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Jun 26',
        'Google Chrome': '49.39',
        'Internet Explorer': '23.11',
        Firefox: '18.84',
        Safari: '7.14',
        'Microsoft Edge': '0.04',
        Opera: '1.37',
        Mozilla: '0.1',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Jun 27',
        'Google Chrome': '49.77',
        'Internet Explorer': '20.68',
        Firefox: '19.23',
        Safari: '8.46',
        'Microsoft Edge': '0.05',
        Opera: '1.71',
        Mozilla: '0.09',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Jun 28',
        'Google Chrome': '50.07',
        'Internet Explorer': '20.41',
        Firefox: '18.91',
        Safari: '8.77',
        'Microsoft Edge': '0.05',
        Opera: '1.69',
        Mozilla: '0.1',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Jun 29',
        'Google Chrome': '49.32',
        'Internet Explorer': '23.3',
        Firefox: '18.54',
        Safari: '7.4',
        'Microsoft Edge': '0.04',
        Opera: '1.27',
        Mozilla: '0.11',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Jun 30',
        'Google Chrome': '49.99',
        'Internet Explorer': '22.94',
        Firefox: '18.45',
        Safari: '7.07',
        'Microsoft Edge': '0.07',
        Opera: '1.32',
        Mozilla: '0.13',
        'Other/Unknown': '0.02'
    },
    {
        date: '2015 Jul 1',
        'Google Chrome': '50.22',
        'Internet Explorer': '22.79',
        Firefox: '18.46',
        Safari: '6.95',
        'Microsoft Edge': '0.07',
        Opera: '1.37',
        Mozilla: '0.12',
        'Other/Unknown': '0.02'
    },
    {
        date: '2015 Jul 2',
        'Google Chrome': '50.33',
        'Internet Explorer': '22.59',
        Firefox: '18.74',
        Safari: '6.69',
        'Microsoft Edge': '0.07',
        Opera: '1.45',
        Mozilla: '0.12',
        'Other/Unknown': '0.02'
    },
    {
        date: '2015 Jul 3',
        'Google Chrome': '50.4',
        'Internet Explorer': '21.29',
        Firefox: '19.28',
        Safari: '7.28',
        'Microsoft Edge': '0.08',
        Opera: '1.54',
        Mozilla: '0.11',
        'Other/Unknown': '0.02'
    },
    {
        date: '2015 Jul 4',
        'Google Chrome': '50.83',
        'Internet Explorer': '20.02',
        Firefox: '19.12',
        Safari: '7.99',
        'Microsoft Edge': '0.08',
        Opera: '1.82',
        Mozilla: '0.11',
        'Other/Unknown': '0.02'
    },
    {
        date: '2015 Jul 5',
        'Google Chrome': '51.6',
        'Internet Explorer': '19.6',
        Firefox: '18.43',
        Safari: '8.58',
        'Microsoft Edge': '0.07',
        Opera: '1.62',
        Mozilla: '0.1',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Jul 6',
        'Google Chrome': '50.53',
        'Internet Explorer': '22.64',
        Firefox: '18.04',
        Safari: '7.33',
        'Microsoft Edge': '0.07',
        Opera: '1.27',
        Mozilla: '0.11',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Jul 7',
        'Google Chrome': '50.01',
        'Internet Explorer': '23.02',
        Firefox: '18.32',
        Safari: '7.25',
        'Microsoft Edge': '0.07',
        Opera: '1.25',
        Mozilla: '0.06',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Jul 8',
        'Google Chrome': '49.52',
        'Internet Explorer': '23.17',
        Firefox: '18.55',
        Safari: '7.31',
        'Microsoft Edge': '0.07',
        Opera: '1.32',
        Mozilla: '0.05',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Jul 9',
        'Google Chrome': '49.31',
        'Internet Explorer': '23.24',
        Firefox: '18.7',
        Safari: '7.22',
        'Microsoft Edge': '0.08',
        Opera: '1.39',
        Mozilla: '0.05',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Jul 10',
        'Google Chrome': '48.4',
        'Internet Explorer': '23.68',
        Firefox: '18.97',
        Safari: '7.37',
        'Microsoft Edge': '0.09',
        Opera: '1.43',
        Mozilla: '0.05',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Jul 11',
        'Google Chrome': '48.87',
        'Internet Explorer': '21.22',
        Firefox: '19.33',
        Safari: '8.65',
        'Microsoft Edge': '0.1',
        Opera: '1.76',
        Mozilla: '0.06',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Jul 12',
        'Google Chrome': '49.4',
        'Internet Explorer': '20.87',
        Firefox: '18.84',
        Safari: '8.99',
        'Microsoft Edge': '0.09',
        Opera: '1.73',
        Mozilla: '0.07',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Jul 13',
        'Google Chrome': '49.12',
        'Internet Explorer': '23.35',
        Firefox: '18.49',
        Safari: '7.51',
        'Microsoft Edge': '0.07',
        Opera: '1.39',
        Mozilla: '0.05',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Jul 14',
        'Google Chrome': '49.36',
        'Internet Explorer': '23.2',
        Firefox: '18.48',
        Safari: '7.48',
        'Microsoft Edge': '0.08',
        Opera: '1.35',
        Mozilla: '0.05',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Jul 15',
        'Google Chrome': '48.88',
        'Internet Explorer': '23.73',
        Firefox: '18.46',
        Safari: '7.44',
        'Microsoft Edge': '0.09',
        Opera: '1.34',
        Mozilla: '0.05',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Jul 16',
        'Google Chrome': '48.76',
        'Internet Explorer': '23.77',
        Firefox: '18.5',
        Safari: '7.43',
        'Microsoft Edge': '0.09',
        Opera: '1.4',
        Mozilla: '0.05',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Jul 17',
        'Google Chrome': '47.58',
        'Internet Explorer': '24.54',
        Firefox: '18.76',
        Safari: '7.53',
        'Microsoft Edge': '0.09',
        Opera: '1.43',
        Mozilla: '0.06',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Jul 18',
        'Google Chrome': '48.06',
        'Internet Explorer': '21.89',
        Firefox: '19.14',
        Safari: '8.99',
        'Microsoft Edge': '0.11',
        Opera: '1.74',
        Mozilla: '0.07',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Jul 19',
        'Google Chrome': '48.39',
        'Internet Explorer': '21.5',
        Firefox: '19',
        Safari: '9.23',
        'Microsoft Edge': '0.11',
        Opera: '1.7',
        Mozilla: '0.07',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Jul 20',
        'Google Chrome': '48.32',
        'Internet Explorer': '23.91',
        Firefox: '18.62',
        Safari: '7.68',
        'Microsoft Edge': '0.09',
        Opera: '1.32',
        Mozilla: '0.06',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Jul 21',
        'Google Chrome': '47.81',
        'Internet Explorer': '24.98',
        Firefox: '18.34',
        Safari: '7.52',
        'Microsoft Edge': '0.08',
        Opera: '1.2',
        Mozilla: '0.06',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Jul 22',
        'Google Chrome': '48.28',
        'Internet Explorer': '24.4',
        Firefox: '18.45',
        Safari: '7.44',
        'Microsoft Edge': '0.08',
        Opera: '1.29',
        Mozilla: '0.06',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Jul 23',
        'Google Chrome': '48.41',
        'Internet Explorer': '24.2',
        Firefox: '18.57',
        Safari: '7.35',
        'Microsoft Edge': '0.08',
        Opera: '1.31',
        Mozilla: '0.07',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Jul 24',
        'Google Chrome': '48.22',
        'Internet Explorer': '23.96',
        Firefox: '18.67',
        Safari: '7.55',
        'Microsoft Edge': '0.1',
        Opera: '1.42',
        Mozilla: '0.06',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Jul 25',
        'Google Chrome': '48.11',
        'Internet Explorer': '21.86',
        Firefox: '19.28',
        Safari: '8.88',
        'Microsoft Edge': '0.1',
        Opera: '1.65',
        Mozilla: '0.08',
        'Other/Unknown': '0.02'
    },
    {
        date: '2015 Jul 26',
        'Google Chrome': '48.27',
        'Internet Explorer': '21.57',
        Firefox: '19',
        Safari: '9.38',
        'Microsoft Edge': '0.11',
        Opera: '1.59',
        Mozilla: '0.08',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Jul 27',
        'Google Chrome': '48.5',
        'Internet Explorer': '23.72',
        Firefox: '18.59',
        Safari: '7.76',
        'Microsoft Edge': '0.1',
        Opera: '1.27',
        Mozilla: '0.06',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Jul 28',
        'Google Chrome': '48.48',
        'Internet Explorer': '23.95',
        Firefox: '18.46',
        Safari: '7.61',
        'Microsoft Edge': '0.12',
        Opera: '1.31',
        Mozilla: '0.07',
        'Other/Unknown': '0.02'
    },
    {
        date: '2015 Jul 29',
        'Google Chrome': '48.33',
        'Internet Explorer': '23.77',
        Firefox: '18.56',
        Safari: '7.51',
        'Microsoft Edge': '0.42',
        Opera: '1.33',
        Mozilla: '0.06',
        'Other/Unknown': '0.02'
    },
    {
        date: '2015 Jul 30',
        'Google Chrome': '47.8',
        'Internet Explorer': '24.06',
        Firefox: '18.6',
        Safari: '7.46',
        'Microsoft Edge': '0.7',
        Opera: '1.3',
        Mozilla: '0.07',
        'Other/Unknown': '0.02'
    },
    {
        date: '2015 Jul 31',
        'Google Chrome': '48.41',
        'Internet Explorer': '22.9',
        Firefox: '18.88',
        Safari: '7.48',
        'Microsoft Edge': '0.84',
        Opera: '1.41',
        Mozilla: '0.07',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Aug 1',
        'Google Chrome': '48.8',
        'Internet Explorer': '20.29',
        Firefox: '19.16',
        Safari: '8.75',
        'Microsoft Edge': '1.16',
        Opera: '1.75',
        Mozilla: '0.07',
        'Other/Unknown': '0.02'
    },
    {
        date: '2015 Aug 2',
        'Google Chrome': '48.95',
        'Internet Explorer': '20.27',
        Firefox: '18.81',
        Safari: '9',
        'Microsoft Edge': '1.23',
        Opera: '1.65',
        Mozilla: '0.08',
        'Other/Unknown': '0.02'
    },
    {
        date: '2015 Aug 3',
        'Google Chrome': '49.07',
        'Internet Explorer': '22.67',
        Firefox: '18.35',
        Safari: '7.59',
        'Microsoft Edge': '0.93',
        Opera: '1.31',
        Mozilla: '0.07',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Aug 4',
        'Google Chrome': '49.18',
        'Internet Explorer': '22.72',
        Firefox: '18.31',
        Safari: '7.44',
        'Microsoft Edge': '0.95',
        Opera: '1.32',
        Mozilla: '0.07',
        'Other/Unknown': '0.02'
    },
    {
        date: '2015 Aug 5',
        'Google Chrome': '49.56',
        'Internet Explorer': '22.37',
        Firefox: '18.28',
        Safari: '7.38',
        'Microsoft Edge': '0.99',
        Opera: '1.34',
        Mozilla: '0.06',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Aug 6',
        'Google Chrome': '49.77',
        'Internet Explorer': '21.81',
        Firefox: '18.28',
        Safari: '7.67',
        'Microsoft Edge': '1.12',
        Opera: '1.28',
        Mozilla: '0.05',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Aug 7',
        'Google Chrome': '48.73',
        'Internet Explorer': '22.63',
        Firefox: '18.42',
        Safari: '7.5',
        'Microsoft Edge': '1.26',
        Opera: '1.39',
        Mozilla: '0.06',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Aug 8',
        'Google Chrome': '49.6',
        'Internet Explorer': '18.97',
        Firefox: '19.11',
        Safari: '8.79',
        'Microsoft Edge': '1.69',
        Opera: '1.74',
        Mozilla: '0.09',
        'Other/Unknown': '0.02'
    },
    {
        date: '2015 Aug 9',
        'Google Chrome': '49.68',
        'Internet Explorer': '18.85',
        Firefox: '18.71',
        Safari: '9.23',
        'Microsoft Edge': '1.72',
        Opera: '1.72',
        Mozilla: '0.08',
        'Other/Unknown': '0.02'
    },
    {
        date: '2015 Aug 10',
        'Google Chrome': '49.11',
        'Internet Explorer': '22.54',
        Firefox: '17.97',
        Safari: '7.64',
        'Microsoft Edge': '1.28',
        Opera: '1.39',
        Mozilla: '0.06',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Aug 11',
        'Google Chrome': '49.21',
        'Internet Explorer': '22.59',
        Firefox: '17.96',
        Safari: '7.56',
        'Microsoft Edge': '1.27',
        Opera: '1.35',
        Mozilla: '0.05',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Aug 12',
        'Google Chrome': '48.95',
        'Internet Explorer': '22.68',
        Firefox: '18.21',
        Safari: '7.44',
        'Microsoft Edge': '1.3',
        Opera: '1.35',
        Mozilla: '0.06',
        'Other/Unknown': '0.02'
    },
    {
        date: '2015 Aug 13',
        'Google Chrome': '49.31',
        'Internet Explorer': '22.28',
        Firefox: '18.19',
        Safari: '7.32',
        'Microsoft Edge': '1.31',
        Opera: '1.51',
        Mozilla: '0.06',
        'Other/Unknown': '0.02'
    },
    {
        date: '2015 Aug 14',
        'Google Chrome': '49.08',
        'Internet Explorer': '21.98',
        Firefox: '18.38',
        Safari: '7.47',
        'Microsoft Edge': '1.43',
        Opera: '1.56',
        Mozilla: '0.07',
        'Other/Unknown': '0.02'
    },
    {
        date: '2015 Aug 15',
        'Google Chrome': '49.1',
        'Internet Explorer': '19.47',
        Firefox: '18.77',
        Safari: '8.85',
        'Microsoft Edge': '1.87',
        Opera: '1.86',
        Mozilla: '0.08',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Aug 16',
        'Google Chrome': '49.5',
        'Internet Explorer': '19.33',
        Firefox: '18.42',
        Safari: '9.12',
        'Microsoft Edge': '1.83',
        Opera: '1.72',
        Mozilla: '0.08',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Aug 17',
        'Google Chrome': '49.42',
        'Internet Explorer': '22.12',
        Firefox: '18.06',
        Safari: '7.5',
        'Microsoft Edge': '1.36',
        Opera: '1.44',
        Mozilla: '0.08',
        'Other/Unknown': '0.02'
    },
    {
        date: '2015 Aug 18',
        'Google Chrome': '49.46',
        'Internet Explorer': '22.16',
        Firefox: '18.05',
        Safari: '7.43',
        'Microsoft Edge': '1.41',
        Opera: '1.41',
        Mozilla: '0.06',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Aug 19',
        'Google Chrome': '49.51',
        'Internet Explorer': '22.21',
        Firefox: '17.93',
        Safari: '7.46',
        'Microsoft Edge': '1.39',
        Opera: '1.42',
        Mozilla: '0.07',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Aug 20',
        'Google Chrome': '49.43',
        'Internet Explorer': '22.38',
        Firefox: '17.91',
        Safari: '7.31',
        'Microsoft Edge': '1.42',
        Opera: '1.47',
        Mozilla: '0.06',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Aug 21',
        'Google Chrome': '49.44',
        'Internet Explorer': '21.79',
        Firefox: '18.3',
        Safari: '7.39',
        'Microsoft Edge': '1.51',
        Opera: '1.47',
        Mozilla: '0.08',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Aug 22',
        'Google Chrome': '49.79',
        'Internet Explorer': '19.29',
        Firefox: '18.51',
        Safari: '8.67',
        'Microsoft Edge': '1.91',
        Opera: '1.74',
        Mozilla: '0.08',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Aug 23',
        'Google Chrome': '50.12',
        'Internet Explorer': '18.91',
        Firefox: '18.1',
        Safari: '9.11',
        'Microsoft Edge': '1.89',
        Opera: '1.8',
        Mozilla: '0.07',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Aug 24',
        'Google Chrome': '49.34',
        'Internet Explorer': '22.2',
        Firefox: '18.01',
        Safari: '7.62',
        'Microsoft Edge': '1.48',
        Opera: '1.29',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Aug 25',
        'Google Chrome': '49.21',
        'Internet Explorer': '22.51',
        Firefox: '17.91',
        Safari: '7.47',
        'Microsoft Edge': '1.47',
        Opera: '1.38',
        Mozilla: '0.05',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Aug 26',
        'Google Chrome': '49.06',
        'Internet Explorer': '22.58',
        Firefox: '17.92',
        Safari: '7.52',
        'Microsoft Edge': '1.47',
        Opera: '1.39',
        Mozilla: '0.04',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Aug 27',
        'Google Chrome': '48.89',
        'Internet Explorer': '22.63',
        Firefox: '17.98',
        Safari: '7.57',
        'Microsoft Edge': '1.51',
        Opera: '1.35',
        Mozilla: '0.06',
        'Other/Unknown': '0.02'
    },
    {
        date: '2015 Aug 28',
        'Google Chrome': '48.69',
        'Internet Explorer': '22.44',
        Firefox: '18.2',
        Safari: '7.56',
        'Microsoft Edge': '1.61',
        Opera: '1.43',
        Mozilla: '0.06',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Aug 29',
        'Google Chrome': '48.64',
        'Internet Explorer': '19.87',
        Firefox: '18.43',
        Safari: '9.16',
        'Microsoft Edge': '2.07',
        Opera: '1.74',
        Mozilla: '0.08',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Aug 30',
        'Google Chrome': '49.72',
        'Internet Explorer': '18.84',
        Firefox: '17.88',
        Safari: '9.76',
        'Microsoft Edge': '2.03',
        Opera: '1.69',
        Mozilla: '0.08',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Aug 31',
        'Google Chrome': '49.43',
        'Internet Explorer': '21.94',
        Firefox: '17.82',
        Safari: '7.87',
        'Microsoft Edge': '1.57',
        Opera: '1.31',
        Mozilla: '0.05',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Sep 1',
        'Google Chrome': '49.65',
        'Internet Explorer': '21.91',
        Firefox: '17.95',
        Safari: '7.52',
        'Microsoft Edge': '1.52',
        Opera: '1.39',
        Mozilla: '0.06',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Sep 2',
        'Google Chrome': '49.73',
        'Internet Explorer': '21.85',
        Firefox: '18.02',
        Safari: '7.49',
        'Microsoft Edge': '1.53',
        Opera: '1.3',
        Mozilla: '0.06',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Sep 3',
        'Google Chrome': '49.59',
        'Internet Explorer': '21.97',
        Firefox: '17.88',
        Safari: '7.6',
        'Microsoft Edge': '1.58',
        Opera: '1.31',
        Mozilla: '0.06',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Sep 4',
        'Google Chrome': '49.52',
        'Internet Explorer': '21.64',
        Firefox: '18.06',
        Safari: '7.62',
        'Microsoft Edge': '1.67',
        Opera: '1.41',
        Mozilla: '0.06',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Sep 5',
        'Google Chrome': '50.28',
        'Internet Explorer': '18.93',
        Firefox: '18.19',
        Safari: '8.71',
        'Microsoft Edge': '2.13',
        Opera: '1.69',
        Mozilla: '0.07',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Sep 6',
        'Google Chrome': '50.25',
        'Internet Explorer': '18.67',
        Firefox: '18.2',
        Safari: '9.04',
        'Microsoft Edge': '2.09',
        Opera: '1.67',
        Mozilla: '0.07',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Sep 7',
        'Google Chrome': '49.83',
        'Internet Explorer': '19.8',
        Firefox: '18.39',
        Safari: '8.63',
        'Microsoft Edge': '1.86',
        Opera: '1.43',
        Mozilla: '0.05',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Sep 8',
        'Google Chrome': '50',
        'Internet Explorer': '21.8',
        Firefox: '17.62',
        Safari: '7.66',
        'Microsoft Edge': '1.55',
        Opera: '1.31',
        Mozilla: '0.06',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Sep 9',
        'Google Chrome': '49.81',
        'Internet Explorer': '21.89',
        Firefox: '17.58',
        Safari: '7.83',
        'Microsoft Edge': '1.59',
        Opera: '1.25',
        Mozilla: '0.05',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Sep 10',
        'Google Chrome': '49.65',
        'Internet Explorer': '21.93',
        Firefox: '17.74',
        Safari: '7.82',
        'Microsoft Edge': '1.6',
        Opera: '1.19',
        Mozilla: '0.05',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Sep 11',
        'Google Chrome': '49.75',
        'Internet Explorer': '21.71',
        Firefox: '17.88',
        Safari: '7.64',
        'Microsoft Edge': '1.67',
        Opera: '1.29',
        Mozilla: '0.05',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Sep 12',
        'Google Chrome': '49.86',
        'Internet Explorer': '19.04',
        Firefox: '17.96',
        Safari: '9.3',
        'Microsoft Edge': '2.21',
        Opera: '1.56',
        Mozilla: '0.06',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Sep 13',
        'Google Chrome': '50.1',
        'Internet Explorer': '18.71',
        Firefox: '17.76',
        Safari: '9.69',
        'Microsoft Edge': '2.19',
        Opera: '1.49',
        Mozilla: '0.06',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Sep 14',
        'Google Chrome': '49.91',
        'Internet Explorer': '21.55',
        Firefox: '17.87',
        Safari: '7.74',
        'Microsoft Edge': '1.66',
        Opera: '1.21',
        Mozilla: '0.05',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Sep 15',
        'Google Chrome': '50.1',
        'Internet Explorer': '21.34',
        Firefox: '17.96',
        Safari: '7.63',
        'Microsoft Edge': '1.66',
        Opera: '1.25',
        Mozilla: '0.05',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Sep 16',
        'Google Chrome': '50.6',
        'Internet Explorer': '21.53',
        Firefox: '17.44',
        Safari: '7.56',
        'Microsoft Edge': '1.59',
        Opera: '1.23',
        Mozilla: '0.05',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Sep 17',
        'Google Chrome': '50.59',
        'Internet Explorer': '21.59',
        Firefox: '17.55',
        Safari: '7.37',
        'Microsoft Edge': '1.6',
        Opera: '1.24',
        Mozilla: '0.05',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Sep 18',
        'Google Chrome': '50.57',
        'Internet Explorer': '21.75',
        Firefox: '17.43',
        Safari: '7.17',
        'Microsoft Edge': '1.7',
        Opera: '1.32',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Sep 19',
        'Google Chrome': '51.33',
        'Internet Explorer': '18.77',
        Firefox: '17.63',
        Safari: '8.37',
        'Microsoft Edge': '2.17',
        Opera: '1.66',
        Mozilla: '0.05',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Sep 20',
        'Google Chrome': '51.41',
        'Internet Explorer': '18.15',
        Firefox: '17.55',
        Safari: '9.09',
        'Microsoft Edge': '2.17',
        Opera: '1.58',
        Mozilla: '0.05',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Sep 21',
        'Google Chrome': '50.76',
        'Internet Explorer': '21.38',
        Firefox: '17.41',
        Safari: '7.52',
        'Microsoft Edge': '1.67',
        Opera: '1.22',
        Mozilla: '0.04',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Sep 22',
        'Google Chrome': '50.6',
        'Internet Explorer': '21.48',
        Firefox: '17.55',
        Safari: '7.41',
        'Microsoft Edge': '1.7',
        Opera: '1.22',
        Mozilla: '0.04',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Sep 23',
        'Google Chrome': '50.56',
        'Internet Explorer': '21.5',
        Firefox: '17.52',
        Safari: '7.42',
        'Microsoft Edge': '1.71',
        Opera: '1.25',
        Mozilla: '0.04',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Sep 24',
        'Google Chrome': '50.66',
        'Internet Explorer': '21.34',
        Firefox: '17.52',
        Safari: '7.45',
        'Microsoft Edge': '1.7',
        Opera: '1.29',
        Mozilla: '0.04',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Sep 25',
        'Google Chrome': '50.87',
        'Internet Explorer': '20.84',
        Firefox: '17.84',
        Safari: '7.24',
        'Microsoft Edge': '1.78',
        Opera: '1.39',
        Mozilla: '0.04',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Sep 26',
        'Google Chrome': '51.66',
        'Internet Explorer': '17.77',
        Firefox: '18.01',
        Safari: '8.52',
        'Microsoft Edge': '2.28',
        Opera: '1.71',
        Mozilla: '0.05',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Sep 27',
        'Google Chrome': '51.99',
        'Internet Explorer': '17.24',
        Firefox: '17.71',
        Safari: '9.17',
        'Microsoft Edge': '2.25',
        Opera: '1.6',
        Mozilla: '0.04',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Sep 28',
        'Google Chrome': '50.77',
        'Internet Explorer': '21.23',
        Firefox: '17.52',
        Safari: '7.49',
        'Microsoft Edge': '1.73',
        Opera: '1.22',
        Mozilla: '0.03',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Sep 29',
        'Google Chrome': '50.75',
        'Internet Explorer': '21.39',
        Firefox: '17.47',
        Safari: '7.38',
        'Microsoft Edge': '1.74',
        Opera: '1.22',
        Mozilla: '0.04',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Sep 30',
        'Google Chrome': '50.8',
        'Internet Explorer': '21.34',
        Firefox: '17.4',
        Safari: '7.46',
        'Microsoft Edge': '1.74',
        Opera: '1.23',
        Mozilla: '0.03',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Oct 1',
        'Google Chrome': '50.82',
        'Internet Explorer': '21.39',
        Firefox: '17.19',
        Safari: '7.55',
        'Microsoft Edge': '1.78',
        Opera: '1.24',
        Mozilla: '0.03',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Oct 2',
        'Google Chrome': '50.93',
        'Internet Explorer': '21.17',
        Firefox: '17.32',
        Safari: '7.38',
        'Microsoft Edge': '1.86',
        Opera: '1.32',
        Mozilla: '0.03',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Oct 3',
        'Google Chrome': '51.69',
        'Internet Explorer': '18.12',
        Firefox: '17.51',
        Safari: '8.61',
        'Microsoft Edge': '2.34',
        Opera: '1.68',
        Mozilla: '0.03',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Oct 4',
        'Google Chrome': '52.06',
        'Internet Explorer': '17.59',
        Firefox: '17.18',
        Safari: '9.25',
        'Microsoft Edge': '2.32',
        Opera: '1.58',
        Mozilla: '0.03',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Oct 5',
        'Google Chrome': '51.4',
        'Internet Explorer': '20.73',
        Firefox: '17.24',
        Safari: '7.56',
        'Microsoft Edge': '1.81',
        Opera: '1.22',
        Mozilla: '0.03',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Oct 6',
        'Google Chrome': '51.81',
        'Internet Explorer': '20.35',
        Firefox: '17.31',
        Safari: '7.46',
        'Microsoft Edge': '1.79',
        Opera: '1.25',
        Mozilla: '0.03',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Oct 7',
        'Google Chrome': '51.98',
        'Internet Explorer': '20.18',
        Firefox: '17.29',
        Safari: '7.49',
        'Microsoft Edge': '1.76',
        Opera: '1.27',
        Mozilla: '0.03',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Oct 8',
        'Google Chrome': '50.97',
        'Internet Explorer': '20.56',
        Firefox: '17.72',
        Safari: '7.63',
        'Microsoft Edge': '1.79',
        Opera: '1.3',
        Mozilla: '0.03',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Oct 9',
        'Google Chrome': '50.94',
        'Internet Explorer': '20.42',
        Firefox: '17.8',
        Safari: '7.52',
        'Microsoft Edge': '1.88',
        Opera: '1.4',
        Mozilla: '0.03',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Oct 10',
        'Google Chrome': '51.02',
        'Internet Explorer': '17.74',
        Firefox: '18.26',
        Safari: '8.79',
        'Microsoft Edge': '2.38',
        Opera: '1.75',
        Mozilla: '0.03',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Oct 11',
        'Google Chrome': '52.07',
        'Internet Explorer': '16.83',
        Firefox: '17.77',
        Safari: '9.23',
        'Microsoft Edge': '2.32',
        Opera: '1.72',
        Mozilla: '0.04',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Oct 12',
        'Google Chrome': '50.9',
        'Internet Explorer': '19.94',
        Firefox: '17.55',
        Safari: '8.27',
        'Microsoft Edge': '1.94',
        Opera: '1.35',
        Mozilla: '0.04',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Oct 13',
        'Google Chrome': '51.52',
        'Internet Explorer': '19.66',
        Firefox: '17.71',
        Safari: '7.76',
        'Microsoft Edge': '1.78',
        Opera: '1.51',
        Mozilla: '0.04',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Oct 14',
        'Google Chrome': '51.75',
        'Internet Explorer': '19.37',
        Firefox: '17.85',
        Safari: '7.72',
        'Microsoft Edge': '1.82',
        Opera: '1.44',
        Mozilla: '0.04',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Oct 15',
        'Google Chrome': '51.37',
        'Internet Explorer': '19.66',
        Firefox: '17.92',
        Safari: '7.68',
        'Microsoft Edge': '1.87',
        Opera: '1.46',
        Mozilla: '0.03',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Oct 16',
        'Google Chrome': '51.29',
        'Internet Explorer': '19.56',
        Firefox: '18.06',
        Safari: '7.62',
        'Microsoft Edge': '1.91',
        Opera: '1.52',
        Mozilla: '0.03',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Oct 17',
        'Google Chrome': '52.47',
        'Internet Explorer': '15.8',
        Firefox: '18.39',
        Safari: '8.96',
        'Microsoft Edge': '2.46',
        Opera: '1.88',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Oct 18',
        'Google Chrome': '51.88',
        'Internet Explorer': '16.03',
        Firefox: '18.07',
        Safari: '9.75',
        'Microsoft Edge': '2.42',
        Opera: '1.79',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Oct 19',
        'Google Chrome': '51.48',
        'Internet Explorer': '19.69',
        Firefox: '17.68',
        Safari: '7.87',
        'Microsoft Edge': '1.83',
        Opera: '1.41',
        Mozilla: '0.03',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Oct 20',
        'Google Chrome': '51.58',
        'Internet Explorer': '19.73',
        Firefox: '17.63',
        Safari: '7.85',
        'Microsoft Edge': '1.8',
        Opera: '1.38',
        Mozilla: '0.03',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Oct 21',
        'Google Chrome': '52.04',
        'Internet Explorer': '20.14',
        Firefox: '16.99',
        Safari: '7.63',
        'Microsoft Edge': '1.81',
        Opera: '1.34',
        Mozilla: '0.03',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Oct 22',
        'Google Chrome': '51.62',
        'Internet Explorer': '20.1',
        Firefox: '17.28',
        Safari: '7.75',
        'Microsoft Edge': '1.86',
        Opera: '1.35',
        Mozilla: '0.04',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Oct 23',
        'Google Chrome': '51.87',
        'Internet Explorer': '19.88',
        Firefox: '17.17',
        Safari: '7.64',
        'Microsoft Edge': '1.94',
        Opera: '1.45',
        Mozilla: '0.04',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Oct 24',
        'Google Chrome': '52.62',
        'Internet Explorer': '16.25',
        Firefox: '17.52',
        Safari: '9.28',
        'Microsoft Edge': '2.5',
        Opera: '1.78',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Oct 25',
        'Google Chrome': '52.64',
        'Internet Explorer': '16.1',
        Firefox: '17.4',
        Safari: '9.69',
        'Microsoft Edge': '2.46',
        Opera: '1.67',
        Mozilla: '0.04',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Oct 26',
        'Google Chrome': '52.29',
        'Internet Explorer': '19.72',
        Firefox: '17',
        Safari: '7.81',
        'Microsoft Edge': '1.88',
        Opera: '1.26',
        Mozilla: '0.03',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Oct 27',
        'Google Chrome': '51.88',
        'Internet Explorer': '20.08',
        Firefox: '17.1',
        Safari: '7.73',
        'Microsoft Edge': '1.87',
        Opera: '1.3',
        Mozilla: '0.03',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Oct 28',
        'Google Chrome': '51.92',
        'Internet Explorer': '19.48',
        Firefox: '17.49',
        Safari: '7.86',
        'Microsoft Edge': '1.93',
        Opera: '1.28',
        Mozilla: '0.03',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Oct 29',
        'Google Chrome': '51.56',
        'Internet Explorer': '19.74',
        Firefox: '17.83',
        Safari: '7.64',
        'Microsoft Edge': '1.9',
        Opera: '1.31',
        Mozilla: '0.03',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Oct 30',
        'Google Chrome': '51.8',
        'Internet Explorer': '19.42',
        Firefox: '17.86',
        Safari: '7.5',
        'Microsoft Edge': '1.99',
        Opera: '1.38',
        Mozilla: '0.03',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Oct 31',
        'Google Chrome': '52.67',
        'Internet Explorer': '16.22',
        Firefox: '18.22',
        Safari: '8.62',
        'Microsoft Edge': '2.46',
        Opera: '1.76',
        Mozilla: '0.04',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Nov 1',
        'Google Chrome': '52.4',
        'Internet Explorer': '15.92',
        Firefox: '17.77',
        Safari: '9.7',
        'Microsoft Edge': '2.48',
        Opera: '1.62',
        Mozilla: '0.1',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Nov 2',
        'Google Chrome': '51.9',
        'Internet Explorer': '19.56',
        Firefox: '17.26',
        Safari: '7.93',
        'Microsoft Edge': '1.96',
        Opera: '1.32',
        Mozilla: '0.06',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Nov 3',
        'Google Chrome': '51.95',
        'Internet Explorer': '19.83',
        Firefox: '17.41',
        Safari: '7.53',
        'Microsoft Edge': '1.89',
        Opera: '1.33',
        Mozilla: '0.06',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Nov 4',
        'Google Chrome': '52.25',
        'Internet Explorer': '19.61',
        Firefox: '17.24',
        Safari: '7.57',
        'Microsoft Edge': '1.83',
        Opera: '1.44',
        Mozilla: '0.06',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Nov 5',
        'Google Chrome': '51.98',
        'Internet Explorer': '19.9',
        Firefox: '17.2',
        Safari: '7.63',
        'Microsoft Edge': '1.87',
        Opera: '1.35',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Nov 6',
        'Google Chrome': '51.38',
        'Internet Explorer': '20.09',
        Firefox: '17.39',
        Safari: '7.74',
        'Microsoft Edge': '1.97',
        Opera: '1.36',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Nov 7',
        'Google Chrome': '52.45',
        'Internet Explorer': '16.46',
        Firefox: '17.38',
        Safari: '9.32',
        'Microsoft Edge': '2.6',
        Opera: '1.7',
        Mozilla: '0.08',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Nov 8',
        'Google Chrome': '52.61',
        'Internet Explorer': '16.12',
        Firefox: '16.97',
        Safari: '9.97',
        'Microsoft Edge': '2.55',
        Opera: '1.69',
        Mozilla: '0.08',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Nov 9',
        'Google Chrome': '51.65',
        'Internet Explorer': '20.18',
        Firefox: '16.67',
        Safari: '8.21',
        'Microsoft Edge': '1.96',
        Opera: '1.28',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Nov 10',
        'Google Chrome': '51.95',
        'Internet Explorer': '19.99',
        Firefox: '16.46',
        Safari: '8.29',
        'Microsoft Edge': '1.95',
        Opera: '1.29',
        Mozilla: '0.07',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Nov 11',
        'Google Chrome': '52.74',
        'Internet Explorer': '18.91',
        Firefox: '16.38',
        Safari: '8.49',
        'Microsoft Edge': '2.04',
        Opera: '1.37',
        Mozilla: '0.06',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Nov 12',
        'Google Chrome': '52.16',
        'Internet Explorer': '19.88',
        Firefox: '16.54',
        Safari: '8.03',
        'Microsoft Edge': '1.99',
        Opera: '1.35',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Nov 13',
        'Google Chrome': '52.17',
        'Internet Explorer': '19.7',
        Firefox: '16.65',
        Safari: '7.98',
        'Microsoft Edge': '2.09',
        Opera: '1.35',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Nov 14',
        'Google Chrome': '52.81',
        'Internet Explorer': '16.25',
        Firefox: '17.02',
        Safari: '9.53',
        'Microsoft Edge': '2.71',
        Opera: '1.62',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Nov 15',
        'Google Chrome': '52.89',
        'Internet Explorer': '15.65',
        Firefox: '16.97',
        Safari: '10.25',
        'Microsoft Edge': '2.62',
        Opera: '1.56',
        Mozilla: '0.06',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Nov 16',
        'Google Chrome': '52.68',
        'Internet Explorer': '19.59',
        Firefox: '16.23',
        Safari: '8.22',
        'Microsoft Edge': '2',
        Opera: '1.24',
        Mozilla: '0.04',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Nov 17',
        'Google Chrome': '52.6',
        'Internet Explorer': '19.62',
        Firefox: '16.38',
        Safari: '8.12',
        'Microsoft Edge': '1.96',
        Opera: '1.28',
        Mozilla: '0.04',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Nov 18',
        'Google Chrome': '52.35',
        'Internet Explorer': '19.79',
        Firefox: '16.39',
        Safari: '8.12',
        'Microsoft Edge': '1.99',
        Opera: '1.33',
        Mozilla: '0.04',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Nov 19',
        'Google Chrome': '52.37',
        'Internet Explorer': '19.81',
        Firefox: '16.46',
        Safari: '8',
        'Microsoft Edge': '2',
        Opera: '1.31',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Nov 20',
        'Google Chrome': '52.2',
        'Internet Explorer': '19.55',
        Firefox: '16.74',
        Safari: '7.96',
        'Microsoft Edge': '2.11',
        Opera: '1.39',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Nov 21',
        'Google Chrome': '52.7',
        'Internet Explorer': '16.03',
        Firefox: '17.04',
        Safari: '9.83',
        'Microsoft Edge': '2.72',
        Opera: '1.62',
        Mozilla: '0.06',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Nov 22',
        'Google Chrome': '52.72',
        'Internet Explorer': '15.75',
        Firefox: '16.9',
        Safari: '10.36',
        'Microsoft Edge': '2.68',
        Opera: '1.54',
        Mozilla: '0.06',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Nov 23',
        'Google Chrome': '52.35',
        'Internet Explorer': '19.53',
        Firefox: '16.53',
        Safari: '8.21',
        'Microsoft Edge': '2.04',
        Opera: '1.28',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Nov 24',
        'Google Chrome': '52.33',
        'Internet Explorer': '19.53',
        Firefox: '16.75',
        Safari: '7.96',
        'Microsoft Edge': '2.03',
        Opera: '1.34',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Nov 25',
        'Google Chrome': '52.34',
        'Internet Explorer': '19.04',
        Firefox: '17.02',
        Safari: '7.82',
        'Microsoft Edge': '2.07',
        Opera: '1.64',
        Mozilla: '0.06',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Nov 26',
        'Google Chrome': '53.29',
        'Internet Explorer': '17.12',
        Firefox: '17.42',
        Safari: '8.12',
        'Microsoft Edge': '2.27',
        Opera: '1.7',
        Mozilla: '0.07',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Nov 27',
        'Google Chrome': '52.46',
        'Internet Explorer': '17.83',
        Firefox: '17.12',
        Safari: '8.58',
        'Microsoft Edge': '2.49',
        Opera: '1.46',
        Mozilla: '0.06',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Nov 28',
        'Google Chrome': '52.84',
        'Internet Explorer': '15.74',
        Firefox: '17.03',
        Safari: '9.7',
        'Microsoft Edge': '2.97',
        Opera: '1.67',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Nov 29',
        'Google Chrome': '52.8',
        'Internet Explorer': '15.57',
        Firefox: '16.72',
        Safari: '10.32',
        'Microsoft Edge': '2.91',
        Opera: '1.63',
        Mozilla: '0.06',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Nov 30',
        'Google Chrome': '52.71',
        'Internet Explorer': '19.08',
        Firefox: '16.21',
        Safari: '8.49',
        'Microsoft Edge': '2.22',
        Opera: '1.24',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Dec 1',
        'Google Chrome': '52.41',
        'Internet Explorer': '19.62',
        Firefox: '16.28',
        Safari: '8.11',
        'Microsoft Edge': '2.25',
        Opera: '1.29',
        Mozilla: '0.04',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Dec 2',
        'Google Chrome': '52.64',
        'Internet Explorer': '19.41',
        Firefox: '16.18',
        Safari: '8.1',
        'Microsoft Edge': '2.31',
        Opera: '1.31',
        Mozilla: '0.04',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Dec 3',
        'Google Chrome': '52.37',
        'Internet Explorer': '19.3',
        Firefox: '16.4',
        Safari: '8.23',
        'Microsoft Edge': '2.31',
        Opera: '1.35',
        Mozilla: '0.04',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Dec 4',
        'Google Chrome': '52.15',
        'Internet Explorer': '19.2',
        Firefox: '16.72',
        Safari: '7.98',
        'Microsoft Edge': '2.46',
        Opera: '1.44',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Dec 5',
        'Google Chrome': '52.15',
        'Internet Explorer': '15.77',
        Firefox: '17.33',
        Safari: '9.82',
        'Microsoft Edge': '3.18',
        Opera: '1.68',
        Mozilla: '0.07',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Dec 6',
        'Google Chrome': '52.92',
        'Internet Explorer': '15.33',
        Firefox: '16.65',
        Safari: '10.31',
        'Microsoft Edge': '3.06',
        Opera: '1.67',
        Mozilla: '0.06',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Dec 7',
        'Google Chrome': '52.59',
        'Internet Explorer': '19.15',
        Firefox: '16.25',
        Safari: '8.36',
        'Microsoft Edge': '2.34',
        Opera: '1.26',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Dec 8',
        'Google Chrome': '52.57',
        'Internet Explorer': '19.12',
        Firefox: '16.38',
        Safari: '8.21',
        'Microsoft Edge': '2.38',
        Opera: '1.28',
        Mozilla: '0.05',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Dec 9',
        'Google Chrome': '52.47',
        'Internet Explorer': '19.47',
        Firefox: '16.41',
        Safari: '7.98',
        'Microsoft Edge': '2.31',
        Opera: '1.3',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Dec 10',
        'Google Chrome': '52.22',
        'Internet Explorer': '20',
        Firefox: '16.4',
        Safari: '7.73',
        'Microsoft Edge': '2.35',
        Opera: '1.25',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Dec 11',
        'Google Chrome': '51.97',
        'Internet Explorer': '19.54',
        Firefox: '16.69',
        Safari: '7.91',
        'Microsoft Edge': '2.49',
        Opera: '1.34',
        Mozilla: '0.06',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Dec 12',
        'Google Chrome': '52.03',
        'Internet Explorer': '16.49',
        Firefox: '16.84',
        Safari: '9.67',
        'Microsoft Edge': '3.18',
        Opera: '1.68',
        Mozilla: '0.1',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Dec 13',
        'Google Chrome': '52.17',
        'Internet Explorer': '16.22',
        Firefox: '16.61',
        Safari: '10.18',
        'Microsoft Edge': '3.16',
        Opera: '1.57',
        Mozilla: '0.08',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Dec 14',
        'Google Chrome': '51.48',
        'Internet Explorer': '20.71',
        Firefox: '16.04',
        Safari: '8.12',
        'Microsoft Edge': '2.39',
        Opera: '1.21',
        Mozilla: '0.06',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Dec 15',
        'Google Chrome': '51.64',
        'Internet Explorer': '20.54',
        Firefox: '16.11',
        Safari: '8.05',
        'Microsoft Edge': '2.37',
        Opera: '1.23',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Dec 16',
        'Google Chrome': '51.32',
        'Internet Explorer': '21.04',
        Firefox: '16.04',
        Safari: '7.9',
        'Microsoft Edge': '2.45',
        Opera: '1.2',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Dec 17',
        'Google Chrome': '51.03',
        'Internet Explorer': '21.29',
        Firefox: '16.13',
        Safari: '7.77',
        'Microsoft Edge': '2.46',
        Opera: '1.25',
        Mozilla: '0.06',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Dec 18',
        'Google Chrome': '50.9',
        'Internet Explorer': '20.71',
        Firefox: '16.59',
        Safari: '7.73',
        'Microsoft Edge': '2.6',
        Opera: '1.38',
        Mozilla: '0.08',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Dec 19',
        'Google Chrome': '51.36',
        'Internet Explorer': '17.02',
        Firefox: '17.13',
        Safari: '9.36',
        'Microsoft Edge': '3.29',
        Opera: '1.75',
        Mozilla: '0.09',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Dec 20',
        'Google Chrome': '52.24',
        'Internet Explorer': '16.39',
        Firefox: '17.18',
        Safari: '9.39',
        'Microsoft Edge': '3.13',
        Opera: '1.58',
        Mozilla: '0.08',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Dec 21',
        'Google Chrome': '51.44',
        'Internet Explorer': '20.62',
        Firefox: '16.64',
        Safari: '7.45',
        'Microsoft Edge': '2.51',
        Opera: '1.28',
        Mozilla: '0.06',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Dec 22',
        'Google Chrome': '51.44',
        'Internet Explorer': '20.64',
        Firefox: '16.72',
        Safari: '7.23',
        'Microsoft Edge': '2.58',
        Opera: '1.33',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Dec 23',
        'Google Chrome': '50.69',
        'Internet Explorer': '21.15',
        Firefox: '16.69',
        Safari: '7.24',
        'Microsoft Edge': '2.7',
        Opera: '1.46',
        Mozilla: '0.06',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Dec 24',
        'Google Chrome': '50.13',
        'Internet Explorer': '20.14',
        Firefox: '16.68',
        Safari: '8',
        'Microsoft Edge': '3.1',
        Opera: '1.85',
        Mozilla: '0.08',
        'Other/Unknown': '0.02'
    },
    {
        date: '2015 Dec 25',
        'Google Chrome': '50.55',
        'Internet Explorer': '17.4',
        Firefox: '16.92',
        Safari: '9.19',
        'Microsoft Edge': '3.73',
        Opera: '2.1',
        Mozilla: '0.09',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Dec 26',
        'Google Chrome': '50.12',
        'Internet Explorer': '17.8',
        Firefox: '16.92',
        Safari: '9.44',
        'Microsoft Edge': '3.72',
        Opera: '1.9',
        Mozilla: '0.09',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Dec 27',
        'Google Chrome': '50.68',
        'Internet Explorer': '17.25',
        Firefox: '16.89',
        Safari: '9.55',
        'Microsoft Edge': '3.73',
        Opera: '1.81',
        Mozilla: '0.09',
        'Other/Unknown': '0'
    },
    {
        date: '2015 Dec 28',
        'Google Chrome': '49.89',
        'Internet Explorer': '21.09',
        Firefox: '16.22',
        Safari: '8.13',
        'Microsoft Edge': '3.21',
        Opera: '1.39',
        Mozilla: '0.07',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Dec 29',
        'Google Chrome': '50.27',
        'Internet Explorer': '20.86',
        Firefox: '16.25',
        Safari: '7.95',
        'Microsoft Edge': '3.22',
        Opera: '1.37',
        Mozilla: '0.08',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Dec 30',
        'Google Chrome': '49.85',
        'Internet Explorer': '21.28',
        Firefox: '16.26',
        Safari: '7.87',
        'Microsoft Edge': '3.29',
        Opera: '1.37',
        Mozilla: '0.08',
        'Other/Unknown': '0.01'
    },
    {
        date: '2015 Dec 31',
        'Google Chrome': '49.4',
        'Internet Explorer': '20.41',
        Firefox: '16.43',
        Safari: '8.52',
        'Microsoft Edge': '3.57',
        Opera: '1.59',
        Mozilla: '0.08',
        'Other/Unknown': '0.01'
    },
    {
        date: '2016 Jan 1',
        'Google Chrome': '50.07',
        'Internet Explorer': '16.61',
        Firefox: '17.36',
        Safari: '10.09',
        'Microsoft Edge': '4.01',
        Opera: '1.76',
        Mozilla: '0.09',
        'Other/Unknown': '0.01'
    },
    {
        date: '2016 Jan 2',
        'Google Chrome': '50.72',
        'Internet Explorer': '16.66',
        Firefox: '17.22',
        Safari: '9.67',
        'Microsoft Edge': '3.91',
        Opera: '1.74',
        Mozilla: '0.08',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Jan 3',
        'Google Chrome': '51.23',
        'Internet Explorer': '16.46',
        Firefox: '16.95',
        Safari: '9.87',
        'Microsoft Edge': '3.75',
        Opera: '1.67',
        Mozilla: '0.07',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Jan 4',
        'Google Chrome': '51.26',
        'Internet Explorer': '20.36',
        Firefox: '16.35',
        Safari: '7.84',
        'Microsoft Edge': '2.85',
        Opera: '1.29',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Jan 5',
        'Google Chrome': '51.32',
        'Internet Explorer': '20.21',
        Firefox: '16.35',
        Safari: '7.89',
        'Microsoft Edge': '2.79',
        Opera: '1.36',
        Mozilla: '0.06',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Jan 6',
        'Google Chrome': '51.81',
        'Internet Explorer': '19.86',
        Firefox: '16.2',
        Safari: '7.93',
        'Microsoft Edge': '2.76',
        Opera: '1.38',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Jan 7',
        'Google Chrome': '51.85',
        'Internet Explorer': '19.82',
        Firefox: '16.31',
        Safari: '7.81',
        'Microsoft Edge': '2.76',
        Opera: '1.4',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Jan 8',
        'Google Chrome': '50.99',
        'Internet Explorer': '20.36',
        Firefox: '16.55',
        Safari: '7.64',
        'Microsoft Edge': '2.9',
        Opera: '1.49',
        Mozilla: '0.06',
        'Other/Unknown': '0.01'
    },
    {
        date: '2016 Jan 9',
        'Google Chrome': '51.5',
        'Internet Explorer': '16.58',
        Firefox: '17.03',
        Safari: '9.38',
        'Microsoft Edge': '3.57',
        Opera: '1.86',
        Mozilla: '0.07',
        'Other/Unknown': '0.01'
    },
    {
        date: '2016 Jan 10',
        'Google Chrome': '51.88',
        'Internet Explorer': '15.91',
        Firefox: '17',
        Safari: '9.79',
        'Microsoft Edge': '3.52',
        Opera: '1.81',
        Mozilla: '0.07',
        'Other/Unknown': '0.01'
    },
    {
        date: '2016 Jan 11',
        'Google Chrome': '51.91',
        'Internet Explorer': '19.73',
        Firefox: '16.3',
        Safari: '7.93',
        'Microsoft Edge': '2.72',
        Opera: '1.37',
        Mozilla: '0.04',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Jan 12',
        'Google Chrome': '51.99',
        'Internet Explorer': '19.63',
        Firefox: '16.35',
        Safari: '7.84',
        'Microsoft Edge': '2.74',
        Opera: '1.39',
        Mozilla: '0.07',
        'Other/Unknown': '0.01'
    },
    {
        date: '2016 Jan 13',
        'Google Chrome': '52.31',
        'Internet Explorer': '19.26',
        Firefox: '16.25',
        Safari: '7.95',
        'Microsoft Edge': '2.85',
        Opera: '1.33',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Jan 14',
        'Google Chrome': '52.07',
        'Internet Explorer': '19.64',
        Firefox: '16.1',
        Safari: '7.95',
        'Microsoft Edge': '2.87',
        Opera: '1.32',
        Mozilla: '0.04',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Jan 15',
        'Google Chrome': '52.21',
        'Internet Explorer': '18.83',
        Firefox: '16.42',
        Safari: '7.98',
        'Microsoft Edge': '3.04',
        Opera: '1.46',
        Mozilla: '0.06',
        'Other/Unknown': '0.01'
    },
    {
        date: '2016 Jan 16',
        'Google Chrome': '52.65',
        'Internet Explorer': '15.51',
        Firefox: '16.86',
        Safari: '9.5',
        'Microsoft Edge': '3.66',
        Opera: '1.75',
        Mozilla: '0.06',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Jan 17',
        'Google Chrome': '52.48',
        'Internet Explorer': '15.69',
        Firefox: '16.61',
        Safari: '9.84',
        'Microsoft Edge': '3.66',
        Opera: '1.66',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Jan 18',
        'Google Chrome': '52.07',
        'Internet Explorer': '18.91',
        Firefox: '16.31',
        Safari: '8.36',
        'Microsoft Edge': '3',
        Opera: '1.3',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Jan 19',
        'Google Chrome': '52.51',
        'Internet Explorer': '19.48',
        Firefox: '16.08',
        Safari: '7.91',
        'Microsoft Edge': '2.72',
        Opera: '1.25',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Jan 20',
        'Google Chrome': '52.82',
        'Internet Explorer': '19.01',
        Firefox: '16.14',
        Safari: '7.97',
        'Microsoft Edge': '2.76',
        Opera: '1.25',
        Mozilla: '0.05',
        'Other/Unknown': '0.01'
    },
    {
        date: '2016 Jan 21',
        'Google Chrome': '52.76',
        'Internet Explorer': '19.26',
        Firefox: '16.12',
        Safari: '7.79',
        'Microsoft Edge': '2.74',
        Opera: '1.3',
        Mozilla: '0.04',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Jan 22',
        'Google Chrome': '52.56',
        'Internet Explorer': '18.8',
        Firefox: '16.33',
        Safari: '7.9',
        'Microsoft Edge': '2.95',
        Opera: '1.4',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Jan 23',
        'Google Chrome': '52.38',
        'Internet Explorer': '15.76',
        Firefox: '16.79',
        Safari: '9.5',
        'Microsoft Edge': '3.78',
        Opera: '1.72',
        Mozilla: '0.06',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Jan 24',
        'Google Chrome': '53.12',
        'Internet Explorer': '15.22',
        Firefox: '16.55',
        Safari: '9.83',
        'Microsoft Edge': '3.57',
        Opera: '1.65',
        Mozilla: '0.06',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Jan 25',
        'Google Chrome': '52.55',
        'Internet Explorer': '19.12',
        Firefox: '16.15',
        Safari: '7.94',
        'Microsoft Edge': '2.89',
        Opera: '1.32',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Jan 26',
        'Google Chrome': '52.45',
        'Internet Explorer': '19.49',
        Firefox: '16.03',
        Safari: '7.83',
        'Microsoft Edge': '2.87',
        Opera: '1.28',
        Mozilla: '0.04',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Jan 27',
        'Google Chrome': '52.64',
        'Internet Explorer': '19.42',
        Firefox: '16.06',
        Safari: '7.7',
        'Microsoft Edge': '2.84',
        Opera: '1.29',
        Mozilla: '0.04',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Jan 28',
        'Google Chrome': '51.95',
        'Internet Explorer': '19.87',
        Firefox: '16.15',
        Safari: '7.77',
        'Microsoft Edge': '2.92',
        Opera: '1.32',
        Mozilla: '0.04',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Jan 29',
        'Google Chrome': '51.03',
        'Internet Explorer': '20',
        Firefox: '16.6',
        Safari: '7.85',
        'Microsoft Edge': '3.07',
        Opera: '1.4',
        Mozilla: '0.04',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Jan 30',
        'Google Chrome': '50.97',
        'Internet Explorer': '16.86',
        Firefox: '17.28',
        Safari: '9.36',
        'Microsoft Edge': '3.71',
        Opera: '1.76',
        Mozilla: '0.06',
        'Other/Unknown': '0.01'
    },
    {
        date: '2016 Jan 31',
        'Google Chrome': '52.36',
        'Internet Explorer': '15.75',
        Firefox: '16.71',
        Safari: '9.85',
        'Microsoft Edge': '3.63',
        Opera: '1.63',
        Mozilla: '0.06',
        'Other/Unknown': '0.01'
    },
    {
        date: '2016 Feb 1',
        'Google Chrome': '52.62',
        'Internet Explorer': '19.09',
        Firefox: '16.1',
        Safari: '7.98',
        'Microsoft Edge': '2.88',
        Opera: '1.28',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Feb 2',
        'Google Chrome': '52.48',
        'Internet Explorer': '19.25',
        Firefox: '16.25',
        Safari: '7.83',
        'Microsoft Edge': '2.85',
        Opera: '1.29',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Feb 3',
        'Google Chrome': '52.47',
        'Internet Explorer': '19.16',
        Firefox: '16.16',
        Safari: '7.94',
        'Microsoft Edge': '2.91',
        Opera: '1.31',
        Mozilla: '0.04',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Feb 4',
        'Google Chrome': '51.91',
        'Internet Explorer': '19.77',
        Firefox: '16.12',
        Safari: '7.83',
        'Microsoft Edge': '3',
        Opera: '1.31',
        Mozilla: '0.05',
        'Other/Unknown': '0.01'
    },
    {
        date: '2016 Feb 5',
        'Google Chrome': '51.76',
        'Internet Explorer': '19.36',
        Firefox: '16.44',
        Safari: '7.78',
        'Microsoft Edge': '3.15',
        Opera: '1.44',
        Mozilla: '0.06',
        'Other/Unknown': '0.01'
    },
    {
        date: '2016 Feb 6',
        'Google Chrome': '52.11',
        'Internet Explorer': '15.66',
        Firefox: '16.99',
        Safari: '9.43',
        'Microsoft Edge': '3.96',
        Opera: '1.78',
        Mozilla: '0.06',
        'Other/Unknown': '0.01'
    },
    {
        date: '2016 Feb 7',
        'Google Chrome': '52.41',
        'Internet Explorer': '15.14',
        Firefox: '17.12',
        Safari: '9.69',
        'Microsoft Edge': '3.81',
        Opera: '1.77',
        Mozilla: '0.06',
        'Other/Unknown': '0.01'
    },
    {
        date: '2016 Feb 8',
        'Google Chrome': '51.83',
        'Internet Explorer': '19.4',
        Firefox: '15.93',
        Safari: '8.38',
        'Microsoft Edge': '3.13',
        Opera: '1.27',
        Mozilla: '0.04',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Feb 9',
        'Google Chrome': '52.01',
        'Internet Explorer': '19.2',
        Firefox: '16.01',
        Safari: '8.25',
        'Microsoft Edge': '3.09',
        Opera: '1.37',
        Mozilla: '0.06',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Feb 10',
        'Google Chrome': '52.92',
        'Internet Explorer': '18.52',
        Firefox: '15.94',
        Safari: '8.23',
        'Microsoft Edge': '2.93',
        Opera: '1.41',
        Mozilla: '0.05',
        'Other/Unknown': '0.01'
    },
    {
        date: '2016 Feb 11',
        'Google Chrome': '52.71',
        'Internet Explorer': '18.9',
        Firefox: '16.17',
        Safari: '7.94',
        'Microsoft Edge': '2.88',
        Opera: '1.35',
        Mozilla: '0.05',
        'Other/Unknown': '0.01'
    },
    {
        date: '2016 Feb 12',
        'Google Chrome': '52.37',
        'Internet Explorer': '18.63',
        Firefox: '16.65',
        Safari: '7.84',
        'Microsoft Edge': '3.01',
        Opera: '1.45',
        Mozilla: '0.05',
        'Other/Unknown': '0.01'
    },
    {
        date: '2016 Feb 13',
        'Google Chrome': '52.73',
        'Internet Explorer': '14.69',
        Firefox: '17.33',
        Safari: '9.38',
        'Microsoft Edge': '3.92',
        Opera: '1.87',
        Mozilla: '0.07',
        'Other/Unknown': '0.01'
    },
    {
        date: '2016 Feb 14',
        'Google Chrome': '52.73',
        'Internet Explorer': '14.91',
        Firefox: '17.06',
        Safari: '9.67',
        'Microsoft Edge': '3.85',
        Opera: '1.71',
        Mozilla: '0.06',
        'Other/Unknown': '0.01'
    },
    {
        date: '2016 Feb 15',
        'Google Chrome': '52.68',
        'Internet Explorer': '17.65',
        Firefox: '16.58',
        Safari: '8.54',
        'Microsoft Edge': '3.2',
        Opera: '1.31',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Feb 16',
        'Google Chrome': '53.18',
        'Internet Explorer': '18.24',
        Firefox: '16.32',
        Safari: '7.98',
        'Microsoft Edge': '2.93',
        Opera: '1.3',
        Mozilla: '0.05',
        'Other/Unknown': '0.01'
    },
    {
        date: '2016 Feb 17',
        'Google Chrome': '52.8',
        'Internet Explorer': '18.68',
        Firefox: '16.37',
        Safari: '7.83',
        'Microsoft Edge': '2.97',
        Opera: '1.3',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Feb 18',
        'Google Chrome': '52.85',
        'Internet Explorer': '18.74',
        Firefox: '16.32',
        Safari: '7.74',
        'Microsoft Edge': '2.93',
        Opera: '1.37',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Feb 19',
        'Google Chrome': '52.5',
        'Internet Explorer': '18.49',
        Firefox: '16.7',
        Safari: '7.75',
        'Microsoft Edge': '3.08',
        Opera: '1.43',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Feb 20',
        'Google Chrome': '52.15',
        'Internet Explorer': '15.14',
        Firefox: '17.4',
        Safari: '9.45',
        'Microsoft Edge': '3.89',
        Opera: '1.9',
        Mozilla: '0.07',
        'Other/Unknown': '0.01'
    },
    {
        date: '2016 Feb 21',
        'Google Chrome': '52.1',
        'Internet Explorer': '14.95',
        Firefox: '17.14',
        Safari: '10.17',
        'Microsoft Edge': '3.9',
        Opera: '1.66',
        Mozilla: '0.07',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Feb 22',
        'Google Chrome': '52.35',
        'Internet Explorer': '18.91',
        Firefox: '16.41',
        Safari: '8.05',
        'Microsoft Edge': '2.97',
        Opera: '1.25',
        Mozilla: '0.04',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Feb 23',
        'Google Chrome': '52',
        'Internet Explorer': '19.19',
        Firefox: '16.48',
        Safari: '8.07',
        'Microsoft Edge': '2.97',
        Opera: '1.25',
        Mozilla: '0.04',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Feb 24',
        'Google Chrome': '52.27',
        'Internet Explorer': '18.8',
        Firefox: '16.71',
        Safari: '7.93',
        'Microsoft Edge': '2.96',
        Opera: '1.28',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Feb 25',
        'Google Chrome': '52.2',
        'Internet Explorer': '18.84',
        Firefox: '16.71',
        Safari: '7.91',
        'Microsoft Edge': '2.98',
        Opera: '1.31',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Feb 26',
        'Google Chrome': '52.28',
        'Internet Explorer': '18.37',
        Firefox: '16.95',
        Safari: '7.86',
        'Microsoft Edge': '3.09',
        Opera: '1.39',
        Mozilla: '0.06',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Feb 27',
        'Google Chrome': '52.63',
        'Internet Explorer': '14.89',
        Firefox: '17.29',
        Safari: '9.44',
        'Microsoft Edge': '3.9',
        Opera: '1.77',
        Mozilla: '0.06',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Feb 28',
        'Google Chrome': '52.74',
        'Internet Explorer': '14.98',
        Firefox: '16.83',
        Safari: '9.89',
        'Microsoft Edge': '3.85',
        Opera: '1.64',
        Mozilla: '0.06',
        'Other/Unknown': '0.01'
    },
    {
        date: '2016 Feb 29',
        'Google Chrome': '53.2',
        'Internet Explorer': '18.53',
        Firefox: '16.18',
        Safari: '7.88',
        'Microsoft Edge': '3',
        Opera: '1.17',
        Mozilla: '0.04',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Mar 1',
        'Google Chrome': '53.27',
        'Internet Explorer': '18.36',
        Firefox: '16.23',
        Safari: '7.99',
        'Microsoft Edge': '2.92',
        Opera: '1.18',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Mar 2',
        'Google Chrome': '53.37',
        'Internet Explorer': '18.14',
        Firefox: '16.21',
        Safari: '8.14',
        'Microsoft Edge': '2.89',
        Opera: '1.19',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Mar 3',
        'Google Chrome': '53.03',
        'Internet Explorer': '18.51',
        Firefox: '16.26',
        Safari: '7.98',
        'Microsoft Edge': '2.97',
        Opera: '1.22',
        Mozilla: '0.04',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Mar 4',
        'Google Chrome': '52.47',
        'Internet Explorer': '18.63',
        Firefox: '16.48',
        Safari: '7.92',
        'Microsoft Edge': '3.13',
        Opera: '1.32',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Mar 5',
        'Google Chrome': '52.43',
        'Internet Explorer': '14.9',
        Firefox: '17.03',
        Safari: '9.82',
        'Microsoft Edge': '4.04',
        Opera: '1.72',
        Mozilla: '0.06',
        'Other/Unknown': '0.01'
    },
    {
        date: '2016 Mar 6',
        'Google Chrome': '52.86',
        'Internet Explorer': '14.56',
        Firefox: '16.85',
        Safari: '10.1',
        'Microsoft Edge': '3.95',
        Opera: '1.63',
        Mozilla: '0.06',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Mar 7',
        'Google Chrome': '52.59',
        'Internet Explorer': '18.9',
        Firefox: '16.25',
        Safari: '7.99',
        'Microsoft Edge': '3.01',
        Opera: '1.22',
        Mozilla: '0.04',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Mar 8',
        'Google Chrome': '52.75',
        'Internet Explorer': '18.59',
        Firefox: '16.36',
        Safari: '7.99',
        'Microsoft Edge': '3.01',
        Opera: '1.24',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Mar 9',
        'Google Chrome': '53.16',
        'Internet Explorer': '18.21',
        Firefox: '16.39',
        Safari: '7.89',
        'Microsoft Edge': '3.05',
        Opera: '1.26',
        Mozilla: '0.04',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Mar 10',
        'Google Chrome': '52.99',
        'Internet Explorer': '18.49',
        Firefox: '16.45',
        Safari: '7.7',
        'Microsoft Edge': '3.04',
        Opera: '1.28',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Mar 11',
        'Google Chrome': '52.42',
        'Internet Explorer': '18.46',
        Firefox: '16.68',
        Safari: '7.81',
        'Microsoft Edge': '3.22',
        Opera: '1.36',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Mar 12',
        'Google Chrome': '51.86',
        'Internet Explorer': '15.55',
        Firefox: '17.13',
        Safari: '9.46',
        'Microsoft Edge': '4.16',
        Opera: '1.78',
        Mozilla: '0.06',
        'Other/Unknown': '0.01'
    },
    {
        date: '2016 Mar 13',
        'Google Chrome': '51.95',
        'Internet Explorer': '15.09',
        Firefox: '17.03',
        Safari: '10.04',
        'Microsoft Edge': '4.17',
        Opera: '1.66',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Mar 14',
        'Google Chrome': '51.94',
        'Internet Explorer': '19.4',
        Firefox: '16.23',
        Safari: '8.01',
        'Microsoft Edge': '3.16',
        Opera: '1.21',
        Mozilla: '0.04',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Mar 15',
        'Google Chrome': '52.49',
        'Internet Explorer': '18.73',
        Firefox: '16.42',
        Safari: '7.96',
        'Microsoft Edge': '3.11',
        Opera: '1.23',
        Mozilla: '0.05',
        'Other/Unknown': '0.01'
    },
    {
        date: '2016 Mar 16',
        'Google Chrome': '52.41',
        'Internet Explorer': '18.66',
        Firefox: '16.61',
        Safari: '7.85',
        'Microsoft Edge': '3.17',
        Opera: '1.26',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Mar 17',
        'Google Chrome': '52.26',
        'Internet Explorer': '19.15',
        Firefox: '16.53',
        Safari: '7.58',
        'Microsoft Edge': '3.15',
        Opera: '1.29',
        Mozilla: '0.04',
        'Other/Unknown': '0.01'
    },
    {
        date: '2016 Mar 18',
        'Google Chrome': '51.98',
        'Internet Explorer': '18.86',
        Firefox: '16.76',
        Safari: '7.69',
        'Microsoft Edge': '3.3',
        Opera: '1.37',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Mar 19',
        'Google Chrome': '51.89',
        'Internet Explorer': '15.61',
        Firefox: '17',
        Safari: '9.39',
        'Microsoft Edge': '4.21',
        Opera: '1.79',
        Mozilla: '0.11',
        'Other/Unknown': '0.01'
    },
    {
        date: '2016 Mar 20',
        'Google Chrome': '51.86',
        'Internet Explorer': '15.29',
        Firefox: '16.87',
        Safari: '9.91',
        'Microsoft Edge': '4.27',
        Opera: '1.71',
        Mozilla: '0.08',
        'Other/Unknown': '0.01'
    },
    {
        date: '2016 Mar 21',
        'Google Chrome': '52.74',
        'Internet Explorer': '18.37',
        Firefox: '16.28',
        Safari: '7.99',
        'Microsoft Edge': '3.22',
        Opera: '1.35',
        Mozilla: '0.04',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Mar 22',
        'Google Chrome': '52.93',
        'Internet Explorer': '18.46',
        Firefox: '16.22',
        Safari: '7.76',
        'Microsoft Edge': '3.12',
        Opera: '1.45',
        Mozilla: '0.05',
        'Other/Unknown': '0.01'
    },
    {
        date: '2016 Mar 23',
        'Google Chrome': '52.65',
        'Internet Explorer': '18.47',
        Firefox: '16.28',
        Safari: '7.76',
        'Microsoft Edge': '3.22',
        Opera: '1.58',
        Mozilla: '0.03',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Mar 24',
        'Google Chrome': '52.53',
        'Internet Explorer': '18.25',
        Firefox: '16.21',
        Safari: '8.03',
        'Microsoft Edge': '3.36',
        Opera: '1.58',
        Mozilla: '0.04',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Mar 25',
        'Google Chrome': '52.15',
        'Internet Explorer': '16.95',
        Firefox: '16.75',
        Safari: '8.7',
        'Microsoft Edge': '3.76',
        Opera: '1.64',
        Mozilla: '0.04',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Mar 26',
        'Google Chrome': '52.24',
        'Internet Explorer': '15.04',
        Firefox: '17.07',
        Safari: '9.52',
        'Microsoft Edge': '4.23',
        Opera: '1.85',
        Mozilla: '0.04',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Mar 27',
        'Google Chrome': '52.56',
        'Internet Explorer': '14.27',
        Firefox: '16.98',
        Safari: '10.11',
        'Microsoft Edge': '4.26',
        Opera: '1.78',
        Mozilla: '0.04',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Mar 28',
        'Google Chrome': '53.31',
        'Internet Explorer': '17.05',
        Firefox: '16.2',
        Safari: '8.49',
        'Microsoft Edge': '3.48',
        Opera: '1.43',
        Mozilla: '0.03',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Mar 29',
        'Google Chrome': '52.98',
        'Internet Explorer': '17.82',
        Firefox: '16.37',
        Safari: '8.09',
        'Microsoft Edge': '3.23',
        Opera: '1.48',
        Mozilla: '0.03',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Mar 30',
        'Google Chrome': '53.07',
        'Internet Explorer': '17.84',
        Firefox: '16.37',
        Safari: '7.96',
        'Microsoft Edge': '3.27',
        Opera: '1.45',
        Mozilla: '0.04',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Mar 31',
        'Google Chrome': '53.4',
        'Internet Explorer': '17.73',
        Firefox: '16.24',
        Safari: '7.84',
        'Microsoft Edge': '3.3',
        Opera: '1.43',
        Mozilla: '0.04',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Apr 1',
        'Google Chrome': '52.72',
        'Internet Explorer': '18.26',
        Firefox: '16.4',
        Safari: '7.72',
        'Microsoft Edge': '3.4',
        Opera: '1.47',
        Mozilla: '0.04',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Apr 2',
        'Google Chrome': '52.99',
        'Internet Explorer': '14.44',
        Firefox: '16.96',
        Safari: '9.33',
        'Microsoft Edge': '4.35',
        Opera: '1.87',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Apr 3',
        'Google Chrome': '53.29',
        'Internet Explorer': '14.13',
        Firefox: '16.7',
        Safari: '9.8',
        'Microsoft Edge': '4.2',
        Opera: '1.82',
        Mozilla: '0.06',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Apr 4',
        'Google Chrome': '53.65',
        'Internet Explorer': '17.74',
        Firefox: '16.06',
        Safari: '7.79',
        'Microsoft Edge': '3.22',
        Opera: '1.5',
        Mozilla: '0.03',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Apr 5',
        'Google Chrome': '53.21',
        'Internet Explorer': '18.25',
        Firefox: '16.05',
        Safari: '7.71',
        'Microsoft Edge': '3.21',
        Opera: '1.54',
        Mozilla: '0.04',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Apr 6',
        'Google Chrome': '53.29',
        'Internet Explorer': '18.24',
        Firefox: '16.02',
        Safari: '7.52',
        'Microsoft Edge': '3.28',
        Opera: '1.6',
        Mozilla: '0.04',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Apr 7',
        'Google Chrome': '52.77',
        'Internet Explorer': '18.33',
        Firefox: '16.26',
        Safari: '7.56',
        'Microsoft Edge': '3.35',
        Opera: '1.69',
        Mozilla: '0.03',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Apr 8',
        'Google Chrome': '52.41',
        'Internet Explorer': '18.15',
        Firefox: '16.82',
        Safari: '7.65',
        'Microsoft Edge': '3.5',
        Opera: '1.42',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Apr 9',
        'Google Chrome': '52.03',
        'Internet Explorer': '15.11',
        Firefox: '17.19',
        Safari: '9.37',
        'Microsoft Edge': '4.48',
        Opera: '1.77',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Apr 10',
        'Google Chrome': '52.62',
        'Internet Explorer': '14.85',
        Firefox: '16.78',
        Safari: '9.63',
        'Microsoft Edge': '4.42',
        Opera: '1.66',
        Mozilla: '0.04',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Apr 11',
        'Google Chrome': '52.54',
        'Internet Explorer': '18.79',
        Firefox: '16.17',
        Safari: '7.73',
        'Microsoft Edge': '3.37',
        Opera: '1.34',
        Mozilla: '0.07',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Apr 12',
        'Google Chrome': '53.2',
        'Internet Explorer': '18.04',
        Firefox: '16.1',
        Safari: '7.61',
        'Microsoft Edge': '3.34',
        Opera: '1.65',
        Mozilla: '0.06',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Apr 13',
        'Google Chrome': '53.01',
        'Internet Explorer': '17.89',
        Firefox: '16.22',
        Safari: '7.67',
        'Microsoft Edge': '3.39',
        Opera: '1.72',
        Mozilla: '0.1',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Apr 14',
        'Google Chrome': '53.2',
        'Internet Explorer': '18.06',
        Firefox: '16.08',
        Safari: '7.53',
        'Microsoft Edge': '3.3',
        Opera: '1.68',
        Mozilla: '0.15',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Apr 15',
        'Google Chrome': '52.96',
        'Internet Explorer': '17.82',
        Firefox: '16.32',
        Safari: '7.52',
        'Microsoft Edge': '3.46',
        Opera: '1.81',
        Mozilla: '0.12',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Apr 16',
        'Google Chrome': '52.52',
        'Internet Explorer': '14.52',
        Firefox: '17.23',
        Safari: '9.32',
        'Microsoft Edge': '4.47',
        Opera: '1.81',
        Mozilla: '0.13',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Apr 17',
        'Google Chrome': '52.71',
        'Internet Explorer': '14.25',
        Firefox: '16.94',
        Safari: '9.9',
        'Microsoft Edge': '4.4',
        Opera: '1.7',
        Mozilla: '0.09',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Apr 18',
        'Google Chrome': '53.22',
        'Internet Explorer': '17.85',
        Firefox: '16.08',
        Safari: '7.79',
        'Microsoft Edge': '3.33',
        Opera: '1.66',
        Mozilla: '0.07',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Apr 19',
        'Google Chrome': '53.51',
        'Internet Explorer': '17.76',
        Firefox: '16.19',
        Safari: '7.77',
        'Microsoft Edge': '3.27',
        Opera: '1.43',
        Mozilla: '0.06',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Apr 20',
        'Google Chrome': '53.62',
        'Internet Explorer': '17.44',
        Firefox: '16.12',
        Safari: '7.81',
        'Microsoft Edge': '3.36',
        Opera: '1.57',
        Mozilla: '0.08',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Apr 21',
        'Google Chrome': '53.4',
        'Internet Explorer': '17.94',
        Firefox: '15.94',
        Safari: '7.59',
        'Microsoft Edge': '3.47',
        Opera: '1.6',
        Mozilla: '0.07',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Apr 22',
        'Google Chrome': '52.62',
        'Internet Explorer': '18.57',
        Firefox: '16.13',
        Safari: '7.55',
        'Microsoft Edge': '3.61',
        Opera: '1.46',
        Mozilla: '0.08',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Apr 23',
        'Google Chrome': '52.42',
        'Internet Explorer': '14.46',
        Firefox: '17.12',
        Safari: '9.44',
        'Microsoft Edge': '4.72',
        Opera: '1.75',
        Mozilla: '0.09',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Apr 24',
        'Google Chrome': '53.43',
        'Internet Explorer': '13.62',
        Firefox: '16.79',
        Safari: '9.84',
        'Microsoft Edge': '4.59',
        Opera: '1.66',
        Mozilla: '0.07',
        'Other/Unknown': '0.01'
    },
    {
        date: '2016 Apr 25',
        'Google Chrome': '53.48',
        'Internet Explorer': '17.72',
        Firefox: '15.98',
        Safari: '7.79',
        'Microsoft Edge': '3.46',
        Opera: '1.5',
        Mozilla: '0.06',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Apr 26',
        'Google Chrome': '53.5',
        'Internet Explorer': '17.81',
        Firefox: '16.13',
        Safari: '7.73',
        'Microsoft Edge': '3.4',
        Opera: '1.36',
        Mozilla: '0.07',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Apr 27',
        'Google Chrome': '53.68',
        'Internet Explorer': '17.4',
        Firefox: '16.39',
        Safari: '7.76',
        'Microsoft Edge': '3.45',
        Opera: '1.24',
        Mozilla: '0.07',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Apr 28',
        'Google Chrome': '53.08',
        'Internet Explorer': '18.16',
        Firefox: '16.31',
        Safari: '7.68',
        'Microsoft Edge': '3.49',
        Opera: '1.21',
        Mozilla: '0.08',
        'Other/Unknown': '0.01'
    },
    {
        date: '2016 Apr 29',
        'Google Chrome': '53.09',
        'Internet Explorer': '17.74',
        Firefox: '16.65',
        Safari: '7.59',
        'Microsoft Edge': '3.56',
        Opera: '1.28',
        Mozilla: '0.09',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Apr 30',
        'Google Chrome': '53.1',
        'Internet Explorer': '14.09',
        Firefox: '16.82',
        Safari: '9.4',
        'Microsoft Edge': '4.86',
        Opera: '1.65',
        Mozilla: '0.1',
        'Other/Unknown': '0'
    },
    {
        date: '2016 May 1',
        'Google Chrome': '52.76',
        'Internet Explorer': '13.89',
        Firefox: '16.72',
        Safari: '10.07',
        'Microsoft Edge': '4.88',
        Opera: '1.58',
        Mozilla: '0.08',
        'Other/Unknown': '0.01'
    },
    {
        date: '2016 May 2',
        'Google Chrome': '53.44',
        'Internet Explorer': '17.2',
        Firefox: '16.17',
        Safari: '8.2',
        'Microsoft Edge': '3.67',
        Opera: '1.21',
        Mozilla: '0.1',
        'Other/Unknown': '0'
    },
    {
        date: '2016 May 3',
        'Google Chrome': '52.97',
        'Internet Explorer': '17.96',
        Firefox: '16.21',
        Safari: '7.85',
        'Microsoft Edge': '3.52',
        Opera: '1.41',
        Mozilla: '0.07',
        'Other/Unknown': '0'
    },
    {
        date: '2016 May 4',
        'Google Chrome': '53.55',
        'Internet Explorer': '17.62',
        Firefox: '16.01',
        Safari: '7.62',
        'Microsoft Edge': '3.57',
        Opera: '1.54',
        Mozilla: '0.08',
        'Other/Unknown': '0'
    },
    {
        date: '2016 May 5',
        'Google Chrome': '53.76',
        'Internet Explorer': '17.45',
        Firefox: '15.92',
        Safari: '7.6',
        'Microsoft Edge': '3.63',
        Opera: '1.57',
        Mozilla: '0.08',
        'Other/Unknown': '0'
    },
    {
        date: '2016 May 6',
        'Google Chrome': '52.97',
        'Internet Explorer': '17.61',
        Firefox: '16.28',
        Safari: '7.72',
        'Microsoft Edge': '3.78',
        Opera: '1.55',
        Mozilla: '0.09',
        'Other/Unknown': '0'
    },
    {
        date: '2016 May 7',
        'Google Chrome': '51.82',
        'Internet Explorer': '14.56',
        Firefox: '17.28',
        Safari: '9.66',
        'Microsoft Edge': '4.86',
        Opera: '1.72',
        Mozilla: '0.1',
        'Other/Unknown': '0'
    },
    {
        date: '2016 May 8',
        'Google Chrome': '52.46',
        'Internet Explorer': '14.09',
        Firefox: '17.17',
        Safari: '9.79',
        'Microsoft Edge': '4.69',
        Opera: '1.71',
        Mozilla: '0.09',
        'Other/Unknown': '0'
    },
    {
        date: '2016 May 9',
        'Google Chrome': '53.05',
        'Internet Explorer': '18.2',
        Firefox: '16.1',
        Safari: '7.92',
        'Microsoft Edge': '3.58',
        Opera: '1.08',
        Mozilla: '0.06',
        'Other/Unknown': '0'
    },
    {
        date: '2016 May 10',
        'Google Chrome': '52.83',
        'Internet Explorer': '18.34',
        Firefox: '16.14',
        Safari: '7.77',
        'Microsoft Edge': '3.62',
        Opera: '1.24',
        Mozilla: '0.06',
        'Other/Unknown': '0'
    },
    {
        date: '2016 May 11',
        'Google Chrome': '53.18',
        'Internet Explorer': '17.93',
        Firefox: '16.28',
        Safari: '7.67',
        'Microsoft Edge': '3.6',
        Opera: '1.26',
        Mozilla: '0.07',
        'Other/Unknown': '0'
    },
    {
        date: '2016 May 12',
        'Google Chrome': '52.5',
        'Internet Explorer': '18.46',
        Firefox: '16.41',
        Safari: '7.53',
        'Microsoft Edge': '3.63',
        Opera: '1.4',
        Mozilla: '0.07',
        'Other/Unknown': '0'
    },
    {
        date: '2016 May 13',
        'Google Chrome': '51.81',
        'Internet Explorer': '18.58',
        Firefox: '16.66',
        Safari: '7.6',
        'Microsoft Edge': '3.77',
        Opera: '1.48',
        Mozilla: '0.09',
        'Other/Unknown': '0'
    },
    {
        date: '2016 May 14',
        'Google Chrome': '50.29',
        'Internet Explorer': '15.33',
        Firefox: '17.99',
        Safari: '9.42',
        'Microsoft Edge': '4.96',
        Opera: '1.91',
        Mozilla: '0.1',
        'Other/Unknown': '0'
    },
    {
        date: '2016 May 15',
        'Google Chrome': '51.36',
        'Internet Explorer': '14.55',
        Firefox: '17.56',
        Safari: '9.66',
        'Microsoft Edge': '4.91',
        Opera: '1.87',
        Mozilla: '0.08',
        'Other/Unknown': '0'
    },
    {
        date: '2016 May 16',
        'Google Chrome': '52.3',
        'Internet Explorer': '18.24',
        Firefox: '16.41',
        Safari: '7.76',
        'Microsoft Edge': '3.73',
        Opera: '1.49',
        Mozilla: '0.06',
        'Other/Unknown': '0'
    },
    {
        date: '2016 May 17',
        'Google Chrome': '52.05',
        'Internet Explorer': '18.88',
        Firefox: '16.42',
        Safari: '7.64',
        'Microsoft Edge': '3.57',
        Opera: '1.37',
        Mozilla: '0.06',
        'Other/Unknown': '0'
    },
    {
        date: '2016 May 18',
        'Google Chrome': '51.99',
        'Internet Explorer': '18.87',
        Firefox: '16.43',
        Safari: '7.76',
        'Microsoft Edge': '3.64',
        Opera: '1.24',
        Mozilla: '0.06',
        'Other/Unknown': '0'
    },
    {
        date: '2016 May 19',
        'Google Chrome': '51.67',
        'Internet Explorer': '19.25',
        Firefox: '16.18',
        Safari: '7.96',
        'Microsoft Edge': '3.77',
        Opera: '1.1',
        Mozilla: '0.07',
        'Other/Unknown': '0'
    },
    {
        date: '2016 May 20',
        'Google Chrome': '51.75',
        'Internet Explorer': '18.51',
        Firefox: '16.52',
        Safari: '7.88',
        'Microsoft Edge': '4.09',
        Opera: '1.19',
        Mozilla: '0.07',
        'Other/Unknown': '0'
    },
    {
        date: '2016 May 21',
        'Google Chrome': '51.83',
        'Internet Explorer': '14.13',
        Firefox: '17.6',
        Safari: '9.54',
        'Microsoft Edge': '5.19',
        Opera: '1.62',
        Mozilla: '0.07',
        'Other/Unknown': '0'
    },
    {
        date: '2016 May 22',
        'Google Chrome': '52.46',
        'Internet Explorer': '13.53',
        Firefox: '17.44',
        Safari: '9.82',
        'Microsoft Edge': '5.07',
        Opera: '1.61',
        Mozilla: '0.07',
        'Other/Unknown': '0'
    },
    {
        date: '2016 May 23',
        'Google Chrome': '52.6',
        'Internet Explorer': '18.04',
        Firefox: '16.37',
        Safari: '7.69',
        'Microsoft Edge': '3.95',
        Opera: '1.3',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2016 May 24',
        'Google Chrome': '52.83',
        'Internet Explorer': '17.85',
        Firefox: '16.46',
        Safari: '7.58',
        'Microsoft Edge': '3.91',
        Opera: '1.32',
        Mozilla: '0.06',
        'Other/Unknown': '0'
    },
    {
        date: '2016 May 25',
        'Google Chrome': '53.16',
        'Internet Explorer': '17.45',
        Firefox: '16.35',
        Safari: '7.6',
        'Microsoft Edge': '3.99',
        Opera: '1.39',
        Mozilla: '0.06',
        'Other/Unknown': '0'
    },
    {
        date: '2016 May 26',
        'Google Chrome': '52.81',
        'Internet Explorer': '17.8',
        Firefox: '16.38',
        Safari: '7.67',
        'Microsoft Edge': '3.95',
        Opera: '1.33',
        Mozilla: '0.06',
        'Other/Unknown': '0'
    },
    {
        date: '2016 May 27',
        'Google Chrome': '52.54',
        'Internet Explorer': '17.27',
        Firefox: '16.86',
        Safari: '7.73',
        'Microsoft Edge': '4.17',
        Opera: '1.35',
        Mozilla: '0.07',
        'Other/Unknown': '0'
    },
    {
        date: '2016 May 28',
        'Google Chrome': '52.58',
        'Internet Explorer': '13.24',
        Firefox: '17.76',
        Safari: '9.27',
        'Microsoft Edge': '5.33',
        Opera: '1.74',
        Mozilla: '0.09',
        'Other/Unknown': '0'
    },
    {
        date: '2016 May 29',
        'Google Chrome': '52.85',
        'Internet Explorer': '12.95',
        Firefox: '17.78',
        Safari: '9.34',
        'Microsoft Edge': '5.29',
        Opera: '1.72',
        Mozilla: '0.07',
        'Other/Unknown': '0'
    },
    {
        date: '2016 May 30',
        'Google Chrome': '52.89',
        'Internet Explorer': '14.39',
        Firefox: '17.67',
        Safari: '8.53',
        'Microsoft Edge': '4.86',
        Opera: '1.59',
        Mozilla: '0.07',
        'Other/Unknown': '0'
    },
    {
        date: '2016 May 31',
        'Google Chrome': '53.61',
        'Internet Explorer': '17.15',
        Firefox: '16.08',
        Safari: '7.6',
        'Microsoft Edge': '4.13',
        Opera: '1.37',
        Mozilla: '0.06',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Jun 1',
        'Google Chrome': '53.58',
        'Internet Explorer': '16.65',
        Firefox: '16.01',
        Safari: '7.99',
        'Microsoft Edge': '4.29',
        Opera: '1.42',
        Mozilla: '0.06',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Jun 2',
        'Google Chrome': '52.76',
        'Internet Explorer': '17.4',
        Firefox: '16.35',
        Safari: '7.81',
        'Microsoft Edge': '4.29',
        Opera: '1.33',
        Mozilla: '0.06',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Jun 3',
        'Google Chrome': '52.44',
        'Internet Explorer': '16.96',
        Firefox: '16.52',
        Safari: '7.71',
        'Microsoft Edge': '4.6',
        Opera: '1.69',
        Mozilla: '0.08',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Jun 4',
        'Google Chrome': '52.33',
        'Internet Explorer': '12.93',
        Firefox: '17.3',
        Safari: '9.52',
        'Microsoft Edge': '5.88',
        Opera: '1.96',
        Mozilla: '0.08',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Jun 5',
        'Google Chrome': '52.38',
        'Internet Explorer': '12.56',
        Firefox: '17.42',
        Safari: '9.66',
        'Microsoft Edge': '5.76',
        Opera: '2.14',
        Mozilla: '0.08',
        'Other/Unknown': '0.01'
    },
    {
        date: '2016 Jun 6',
        'Google Chrome': '52.69',
        'Internet Explorer': '17.32',
        Firefox: '16.31',
        Safari: '7.43',
        'Microsoft Edge': '4.18',
        Opera: '2.01',
        Mozilla: '0.06',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Jun 7',
        'Google Chrome': '52.95',
        'Internet Explorer': '17.47',
        Firefox: '16.28',
        Safari: '7.65',
        'Microsoft Edge': '4.05',
        Opera: '1.55',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Jun 8',
        'Google Chrome': '52.68',
        'Internet Explorer': '17.66',
        Firefox: '16.3',
        Safari: '7.6',
        'Microsoft Edge': '4.14',
        Opera: '1.56',
        Mozilla: '0.06',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Jun 9',
        'Google Chrome': '52.3',
        'Internet Explorer': '18.02',
        Firefox: '16.25',
        Safari: '7.85',
        'Microsoft Edge': '4.14',
        Opera: '1.38',
        Mozilla: '0.07',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Jun 10',
        'Google Chrome': '52.22',
        'Internet Explorer': '17.36',
        Firefox: '16.46',
        Safari: '7.96',
        'Microsoft Edge': '4.44',
        Opera: '1.49',
        Mozilla: '0.07',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Jun 11',
        'Google Chrome': '52.06',
        'Internet Explorer': '13.19',
        Firefox: '17.21',
        Safari: '9.98',
        'Microsoft Edge': '5.78',
        Opera: '1.69',
        Mozilla: '0.09',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Jun 12',
        'Google Chrome': '52.09',
        'Internet Explorer': '12.75',
        Firefox: '16.89',
        Safari: '10.65',
        'Microsoft Edge': '5.96',
        Opera: '1.6',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Jun 13',
        'Google Chrome': '53.18',
        'Internet Explorer': '16.87',
        Firefox: '16.21',
        Safari: '8.15',
        'Microsoft Edge': '4.39',
        Opera: '1.15',
        Mozilla: '0.05',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Jun 14',
        'Google Chrome': '53.45',
        'Internet Explorer': '17.03',
        Firefox: '16.15',
        Safari: '7.8',
        'Microsoft Edge': '4.31',
        Opera: '1.21',
        Mozilla: '0.04',
        'Other/Unknown': '0'
    },
    {
        date: '2016 Jun 15',
        'Google Chrome': '53.4',
        'Internet Explorer': '18.12',
        Firefox: '16.51',
        Safari: '6.69',
        'Microsoft Edge': '3.84',
        Opera: '1.4',
        Mozilla: '0.04',
        'Other/Unknown': '0'
    }
];
var $88c830a15940181a$export$2e2bcd8739ae039 = $88c830a15940181a$var$browserUsage;


const $c80551d930cafdca$var$groupDateValue = [
    {
        key: 'Group1',
        value: '37',
        date: '04/23/12'
    },
    {
        key: 'Group2',
        value: '12',
        date: '04/23/12'
    },
    {
        key: 'Group3',
        value: '46',
        date: '04/23/12'
    },
    {
        key: 'Group1',
        value: '32',
        date: '04/24/12'
    },
    {
        key: 'Group2',
        value: '19',
        date: '04/24/12'
    },
    {
        key: 'Group3',
        value: '42',
        date: '04/24/12'
    },
    {
        key: 'Group1',
        value: '45',
        date: '04/25/12'
    },
    {
        key: 'Group2',
        value: '16',
        date: '04/25/12'
    },
    {
        key: 'Group3',
        value: '44',
        date: '04/25/12'
    },
    {
        key: 'Group1',
        value: '24',
        date: '04/26/12'
    },
    {
        key: 'Group2',
        value: '52',
        date: '04/26/12'
    },
    {
        key: 'Group3',
        value: '64',
        date: '04/26/12'
    }
];
var $c80551d930cafdca$export$2e2bcd8739ae039 = $c80551d930cafdca$var$groupDateValue;


const $824089a18792383f$var$cityTemperature = [
    {
        date: '2011-10-01',
        'New York': '63.4',
        'San Francisco': '62.7',
        Austin: '72.2'
    },
    {
        date: '2011-10-02',
        'New York': '58.0',
        'San Francisco': '59.9',
        Austin: '67.7'
    },
    {
        date: '2011-10-03',
        'New York': '53.3',
        'San Francisco': '59.1',
        Austin: '69.4'
    },
    {
        date: '2011-10-04',
        'New York': '55.7',
        'San Francisco': '58.8',
        Austin: '68.0'
    },
    {
        date: '2011-10-05',
        'New York': '64.2',
        'San Francisco': '58.7',
        Austin: '72.4'
    },
    {
        date: '2011-10-06',
        'New York': '58.8',
        'San Francisco': '57.0',
        Austin: '77.0'
    },
    {
        date: '2011-10-07',
        'New York': '57.9',
        'San Francisco': '56.7',
        Austin: '82.3'
    },
    {
        date: '2011-10-08',
        'New York': '61.8',
        'San Francisco': '56.8',
        Austin: '78.9'
    },
    {
        date: '2011-10-09',
        'New York': '69.3',
        'San Francisco': '56.7',
        Austin: '68.8'
    },
    {
        date: '2011-10-10',
        'New York': '71.2',
        'San Francisco': '60.1',
        Austin: '68.7'
    },
    {
        date: '2011-10-11',
        'New York': '68.7',
        'San Francisco': '61.1',
        Austin: '70.3'
    },
    {
        date: '2011-10-12',
        'New York': '61.8',
        'San Francisco': '61.5',
        Austin: '75.3'
    },
    {
        date: '2011-10-13',
        'New York': '63.0',
        'San Francisco': '64.3',
        Austin: '76.6'
    },
    {
        date: '2011-10-14',
        'New York': '66.9',
        'San Francisco': '67.1',
        Austin: '66.6'
    },
    {
        date: '2011-10-15',
        'New York': '61.7',
        'San Francisco': '64.6',
        Austin: '68.0'
    },
    {
        date: '2011-10-16',
        'New York': '61.8',
        'San Francisco': '61.6',
        Austin: '70.6'
    },
    {
        date: '2011-10-17',
        'New York': '62.8',
        'San Francisco': '61.1',
        Austin: '71.1'
    },
    {
        date: '2011-10-18',
        'New York': '60.8',
        'San Francisco': '59.2',
        Austin: '70.0'
    },
    {
        date: '2011-10-19',
        'New York': '62.1',
        'San Francisco': '58.9',
        Austin: '61.6'
    },
    {
        date: '2011-10-20',
        'New York': '65.1',
        'San Francisco': '57.2',
        Austin: '57.4'
    },
    {
        date: '2011-10-21',
        'New York': '55.6',
        'San Francisco': '56.4',
        Austin: '64.3'
    },
    {
        date: '2011-10-22',
        'New York': '54.4',
        'San Francisco': '60.7',
        Austin: '72.4'
    },
    {
        date: '2011-10-23',
        'New York': '54.4',
        'San Francisco': '65.1',
        Austin: '72.4'
    },
    {
        date: '2011-10-24',
        'New York': '54.8',
        'San Francisco': '60.9',
        Austin: '72.5'
    },
    {
        date: '2011-10-25',
        'New York': '57.9',
        'San Francisco': '56.1',
        Austin: '72.7'
    },
    {
        date: '2011-10-26',
        'New York': '54.6',
        'San Francisco': '54.6',
        Austin: '73.4'
    },
    {
        date: '2011-10-27',
        'New York': '54.4',
        'San Francisco': '56.1',
        Austin: '70.7'
    },
    {
        date: '2011-10-28',
        'New York': '42.5',
        'San Francisco': '58.1',
        Austin: '56.8'
    },
    {
        date: '2011-10-29',
        'New York': '40.9',
        'San Francisco': '57.5',
        Austin: '51.0'
    },
    {
        date: '2011-10-30',
        'New York': '38.6',
        'San Francisco': '57.7',
        Austin: '54.9'
    },
    {
        date: '2011-10-31',
        'New York': '44.2',
        'San Francisco': '55.1',
        Austin: '58.8'
    },
    {
        date: '2011-11-01',
        'New York': '49.6',
        'San Francisco': '57.9',
        Austin: '62.6'
    },
    {
        date: '2011-11-02',
        'New York': '47.2',
        'San Francisco': '64.6',
        Austin: '71.0'
    },
    {
        date: '2011-11-03',
        'New York': '50.1',
        'San Francisco': '56.2',
        Austin: '58.4'
    },
    {
        date: '2011-11-04',
        'New York': '50.1',
        'San Francisco': '50.5',
        Austin: '45.1'
    },
    {
        date: '2011-11-05',
        'New York': '43.5',
        'San Francisco': '51.3',
        Austin: '52.2'
    },
    {
        date: '2011-11-06',
        'New York': '43.8',
        'San Francisco': '52.6',
        Austin: '73.0'
    },
    {
        date: '2011-11-07',
        'New York': '48.9',
        'San Francisco': '51.4',
        Austin: '75.4'
    },
    {
        date: '2011-11-08',
        'New York': '55.5',
        'San Francisco': '50.6',
        Austin: '72.1'
    },
    {
        date: '2011-11-09',
        'New York': '53.7',
        'San Francisco': '54.6',
        Austin: '56.6'
    },
    {
        date: '2011-11-10',
        'New York': '57.7',
        'San Francisco': '55.6',
        Austin: '55.4'
    },
    {
        date: '2011-11-11',
        'New York': '48.5',
        'San Francisco': '53.9',
        Austin: '46.7'
    },
    {
        date: '2011-11-12',
        'New York': '46.8',
        'San Francisco': '54.0',
        Austin: '62.0'
    },
    {
        date: '2011-11-13',
        'New York': '51.1',
        'San Francisco': '53.8',
        Austin: '71.6'
    },
    {
        date: '2011-11-14',
        'New York': '56.8',
        'San Francisco': '53.5',
        Austin: '75.5'
    },
    {
        date: '2011-11-15',
        'New York': '59.7',
        'San Francisco': '53.4',
        Austin: '72.1'
    },
    {
        date: '2011-11-16',
        'New York': '56.5',
        'San Francisco': '52.2',
        Austin: '65.7'
    },
    {
        date: '2011-11-17',
        'New York': '49.6',
        'San Francisco': '52.7',
        Austin: '56.8'
    },
    {
        date: '2011-11-18',
        'New York': '41.5',
        'San Francisco': '53.1',
        Austin: '49.9'
    },
    {
        date: '2011-11-19',
        'New York': '44.3',
        'San Francisco': '49.0',
        Austin: '71.7'
    },
    {
        date: '2011-11-20',
        'New York': '54.0',
        'San Francisco': '50.4',
        Austin: '77.7'
    },
    {
        date: '2011-11-21',
        'New York': '54.1',
        'San Francisco': '51.1',
        Austin: '76.4'
    },
    {
        date: '2011-11-22',
        'New York': '49.4',
        'San Francisco': '52.3',
        Austin: '68.8'
    },
    {
        date: '2011-11-23',
        'New York': '50.0',
        'San Francisco': '54.6',
        Austin: '57.0'
    },
    {
        date: '2011-11-24',
        'New York': '44.0',
        'San Francisco': '55.1',
        Austin: '55.5'
    },
    {
        date: '2011-11-25',
        'New York': '50.3',
        'San Francisco': '51.5',
        Austin: '61.6'
    },
    {
        date: '2011-11-26',
        'New York': '52.1',
        'San Francisco': '53.6',
        Austin: '64.1'
    },
    {
        date: '2011-11-27',
        'New York': '49.6',
        'San Francisco': '52.3',
        Austin: '51.1'
    },
    {
        date: '2011-11-28',
        'New York': '57.2',
        'San Francisco': '51.0',
        Austin: '43.0'
    },
    {
        date: '2011-11-29',
        'New York': '59.1',
        'San Francisco': '49.5',
        Austin: '46.4'
    },
    {
        date: '2011-11-30',
        'New York': '50.6',
        'San Francisco': '49.8',
        Austin: '48.0'
    },
    {
        date: '2011-12-01',
        'New York': '44.3',
        'San Francisco': '60.4',
        Austin: '48.1'
    },
    {
        date: '2011-12-02',
        'New York': '43.9',
        'San Francisco': '62.2',
        Austin: '60.6'
    },
    {
        date: '2011-12-03',
        'New York': '42.1',
        'San Francisco': '58.3',
        Austin: '62.6'
    },
    {
        date: '2011-12-04',
        'New York': '43.9',
        'San Francisco': '52.7',
        Austin: '57.1'
    },
    {
        date: '2011-12-05',
        'New York': '50.2',
        'San Francisco': '51.5',
        Austin: '44.2'
    },
    {
        date: '2011-12-06',
        'New York': '54.2',
        'San Francisco': '49.9',
        Austin: '37.4'
    },
    {
        date: '2011-12-07',
        'New York': '54.6',
        'San Francisco': '48.6',
        Austin: '35.0'
    },
    {
        date: '2011-12-08',
        'New York': '43.4',
        'San Francisco': '46.4',
        Austin: '37.0'
    },
    {
        date: '2011-12-09',
        'New York': '42.2',
        'San Francisco': '49.8',
        Austin: '45.4'
    },
    {
        date: '2011-12-10',
        'New York': '45.0',
        'San Francisco': '52.1',
        Austin: '50.7'
    },
    {
        date: '2011-12-11',
        'New York': '33.8',
        'San Francisco': '48.8',
        Austin: '48.6'
    },
    {
        date: '2011-12-12',
        'New York': '36.8',
        'San Francisco': '47.4',
        Austin: '52.2'
    },
    {
        date: '2011-12-13',
        'New York': '38.6',
        'San Francisco': '47.2',
        Austin: '60.8'
    },
    {
        date: '2011-12-14',
        'New York': '41.9',
        'San Francisco': '46.1',
        Austin: '70.0'
    },
    {
        date: '2011-12-15',
        'New York': '49.6',
        'San Francisco': '48.8',
        Austin: '64.2'
    },
    {
        date: '2011-12-16',
        'New York': '50.2',
        'San Francisco': '47.9',
        Austin: '50.9'
    },
    {
        date: '2011-12-17',
        'New York': '40.6',
        'San Francisco': '49.8',
        Austin: '51.6'
    },
    {
        date: '2011-12-18',
        'New York': '29.1',
        'San Francisco': '49.1',
        Austin: '55.2'
    },
    {
        date: '2011-12-19',
        'New York': '33.7',
        'San Francisco': '48.3',
        Austin: '62.1'
    },
    {
        date: '2011-12-20',
        'New York': '45.8',
        'San Francisco': '49.3',
        Austin: '56.3'
    },
    {
        date: '2011-12-21',
        'New York': '47.4',
        'San Francisco': '48.4',
        Austin: '47.2'
    },
    {
        date: '2011-12-22',
        'New York': '54.4',
        'San Francisco': '53.3',
        Austin: '52.3'
    },
    {
        date: '2011-12-23',
        'New York': '47.8',
        'San Francisco': '47.5',
        Austin: '45.2'
    },
    {
        date: '2011-12-24',
        'New York': '34.9',
        'San Francisco': '47.9',
        Austin: '43.6'
    },
    {
        date: '2011-12-25',
        'New York': '35.9',
        'San Francisco': '48.9',
        Austin: '42.9'
    },
    {
        date: '2011-12-26',
        'New York': '43.6',
        'San Francisco': '45.9',
        Austin: '48.2'
    },
    {
        date: '2011-12-27',
        'New York': '42.9',
        'San Francisco': '47.2',
        Austin: '45.4'
    },
    {
        date: '2011-12-28',
        'New York': '46.2',
        'San Francisco': '48.9',
        Austin: '44.2'
    },
    {
        date: '2011-12-29',
        'New York': '30.8',
        'San Francisco': '50.9',
        Austin: '50.4'
    },
    {
        date: '2011-12-30',
        'New York': '40.8',
        'San Francisco': '52.9',
        Austin: '52.4'
    },
    {
        date: '2011-12-31',
        'New York': '49.8',
        'San Francisco': '50.1',
        Austin: '53.5'
    },
    {
        date: '2012-01-01',
        'New York': '46.3',
        'San Francisco': '53.9',
        Austin: '55.9'
    },
    {
        date: '2012-01-02',
        'New York': '43.2',
        'San Francisco': '53.1',
        Austin: '48.2'
    },
    {
        date: '2012-01-03',
        'New York': '30.3',
        'San Francisco': '49.7',
        Austin: '41.0'
    },
    {
        date: '2012-01-04',
        'New York': '19.2',
        'San Francisco': '52.7',
        Austin: '48.9'
    },
    {
        date: '2012-01-05',
        'New York': '32.1',
        'San Francisco': '52.6',
        Austin: '54.8'
    },
    {
        date: '2012-01-06',
        'New York': '41.2',
        'San Francisco': '49.0',
        Austin: '61.2'
    },
    {
        date: '2012-01-07',
        'New York': '47.0',
        'San Francisco': '51.0',
        Austin: '59.7'
    },
    {
        date: '2012-01-08',
        'New York': '46.0',
        'San Francisco': '56.8',
        Austin: '52.5'
    },
    {
        date: '2012-01-09',
        'New York': '34.7',
        'San Francisco': '52.3',
        Austin: '54.0'
    },
    {
        date: '2012-01-10',
        'New York': '39.4',
        'San Francisco': '51.6',
        Austin: '47.7'
    },
    {
        date: '2012-01-11',
        'New York': '40.4',
        'San Francisco': '49.8',
        Austin: '49.2'
    },
    {
        date: '2012-01-12',
        'New York': '45.4',
        'San Francisco': '51.9',
        Austin: '48.4'
    },
    {
        date: '2012-01-13',
        'New York': '40.7',
        'San Francisco': '53.7',
        Austin: '40.2'
    },
    {
        date: '2012-01-14',
        'New York': '30.4',
        'San Francisco': '52.9',
        Austin: '43.9'
    },
    {
        date: '2012-01-15',
        'New York': '23.9',
        'San Francisco': '49.7',
        Austin: '45.2'
    },
    {
        date: '2012-01-16',
        'New York': '22.6',
        'San Francisco': '45.3',
        Austin: '65.0'
    },
    {
        date: '2012-01-17',
        'New York': '39.8',
        'San Francisco': '43.6',
        Austin: '68.2'
    },
    {
        date: '2012-01-18',
        'New York': '43.2',
        'San Francisco': '45.0',
        Austin: '47.5'
    },
    {
        date: '2012-01-19',
        'New York': '26.3',
        'San Francisco': '47.3',
        Austin: '57.1'
    },
    {
        date: '2012-01-20',
        'New York': '32.8',
        'San Francisco': '51.4',
        Austin: '61.9'
    },
    {
        date: '2012-01-21',
        'New York': '27.4',
        'San Francisco': '53.7',
        Austin: '54.6'
    },
    {
        date: '2012-01-22',
        'New York': '25.0',
        'San Francisco': '48.3',
        Austin: '56.7'
    },
    {
        date: '2012-01-23',
        'New York': '39.4',
        'San Francisco': '52.9',
        Austin: '54.4'
    },
    {
        date: '2012-01-24',
        'New York': '48.7',
        'San Francisco': '49.1',
        Austin: '52.7'
    },
    {
        date: '2012-01-25',
        'New York': '43.0',
        'San Francisco': '52.1',
        Austin: '61.8'
    },
    {
        date: '2012-01-26',
        'New York': '37.1',
        'San Francisco': '53.6',
        Austin: '55.0'
    },
    {
        date: '2012-01-27',
        'New York': '48.2',
        'San Francisco': '50.4',
        Austin: '50.7'
    },
    {
        date: '2012-01-28',
        'New York': '43.7',
        'San Francisco': '50.3',
        Austin: '52.9'
    },
    {
        date: '2012-01-29',
        'New York': '40.1',
        'San Francisco': '53.8',
        Austin: '44.4'
    },
    {
        date: '2012-01-30',
        'New York': '38.0',
        'San Francisco': '51.9',
        Austin: '49.1'
    },
    {
        date: '2012-01-31',
        'New York': '43.5',
        'San Francisco': '50.0',
        Austin: '62.8'
    },
    {
        date: '2012-02-01',
        'New York': '50.4',
        'San Francisco': '50.0',
        Austin: '64.6'
    },
    {
        date: '2012-02-02',
        'New York': '45.8',
        'San Francisco': '51.3',
        Austin: '61.1'
    },
    {
        date: '2012-02-03',
        'New York': '37.5',
        'San Francisco': '51.5',
        Austin: '70.0'
    },
    {
        date: '2012-02-04',
        'New York': '40.8',
        'San Francisco': '52.0',
        Austin: '61.3'
    },
    {
        date: '2012-02-05',
        'New York': '36.5',
        'San Francisco': '53.8',
        Austin: '48.2'
    },
    {
        date: '2012-02-06',
        'New York': '39.1',
        'San Francisco': '54.6',
        Austin: '44.2'
    },
    {
        date: '2012-02-07',
        'New York': '43.2',
        'San Francisco': '54.3',
        Austin: '51.3'
    },
    {
        date: '2012-02-08',
        'New York': '36.5',
        'San Francisco': '51.9',
        Austin: '49.2'
    },
    {
        date: '2012-02-09',
        'New York': '36.5',
        'San Francisco': '53.8',
        Austin: '45.7'
    },
    {
        date: '2012-02-10',
        'New York': '38.3',
        'San Francisco': '53.9',
        Austin: '54.1'
    },
    {
        date: '2012-02-11',
        'New York': '36.9',
        'San Francisco': '52.3',
        Austin: '44.9'
    },
    {
        date: '2012-02-12',
        'New York': '29.7',
        'San Francisco': '50.1',
        Austin: '36.5'
    },
    {
        date: '2012-02-13',
        'New York': '33.1',
        'San Francisco': '49.5',
        Austin: '44.8'
    },
    {
        date: '2012-02-14',
        'New York': '39.6',
        'San Francisco': '48.6',
        Austin: '52.3'
    },
    {
        date: '2012-02-15',
        'New York': '42.3',
        'San Francisco': '49.9',
        Austin: '68.0'
    },
    {
        date: '2012-02-16',
        'New York': '39.7',
        'San Francisco': '52.4',
        Austin: '54.6'
    },
    {
        date: '2012-02-17',
        'New York': '46.0',
        'San Francisco': '49.9',
        Austin: '53.8'
    },
    {
        date: '2012-02-18',
        'New York': '41.2',
        'San Francisco': '51.6',
        Austin: '56.2'
    },
    {
        date: '2012-02-19',
        'New York': '39.8',
        'San Francisco': '47.8',
        Austin: '50.8'
    },
    {
        date: '2012-02-20',
        'New York': '38.1',
        'San Francisco': '48.7',
        Austin: '53.0'
    },
    {
        date: '2012-02-21',
        'New York': '37.1',
        'San Francisco': '49.7',
        Austin: '61.0'
    },
    {
        date: '2012-02-22',
        'New York': '45.5',
        'San Francisco': '53.4',
        Austin: '68.8'
    },
    {
        date: '2012-02-23',
        'New York': '50.6',
        'San Francisco': '54.1',
        Austin: '69.4'
    },
    {
        date: '2012-02-24',
        'New York': '42.7',
        'San Francisco': '55.9',
        Austin: '59.3'
    },
    {
        date: '2012-02-25',
        'New York': '42.6',
        'San Francisco': '51.7',
        Austin: '47.2'
    },
    {
        date: '2012-02-26',
        'New York': '36.9',
        'San Francisco': '47.7',
        Austin: '47.7'
    },
    {
        date: '2012-02-27',
        'New York': '40.9',
        'San Francisco': '45.4',
        Austin: '61.9'
    },
    {
        date: '2012-02-28',
        'New York': '45.9',
        'San Francisco': '47.0',
        Austin: '67.2'
    },
    {
        date: '2012-02-29',
        'New York': '40.7',
        'San Francisco': '49.8',
        Austin: '70.1'
    },
    {
        date: '2012-03-01',
        'New York': '41.3',
        'San Francisco': '48.9',
        Austin: '62.1'
    },
    {
        date: '2012-03-02',
        'New York': '36.8',
        'San Francisco': '48.1',
        Austin: '72.7'
    },
    {
        date: '2012-03-03',
        'New York': '47.6',
        'San Francisco': '50.7',
        Austin: '59.0'
    },
    {
        date: '2012-03-04',
        'New York': '44.2',
        'San Francisco': '55.0',
        Austin: '51.8'
    },
    {
        date: '2012-03-05',
        'New York': '38.5',
        'San Francisco': '48.8',
        Austin: '55.0'
    },
    {
        date: '2012-03-06',
        'New York': '32.9',
        'San Francisco': '48.4',
        Austin: '61.8'
    },
    {
        date: '2012-03-07',
        'New York': '43.3',
        'San Francisco': '49.9',
        Austin: '67.1'
    },
    {
        date: '2012-03-08',
        'New York': '51.2',
        'San Francisco': '49.2',
        Austin: '72.0'
    },
    {
        date: '2012-03-09',
        'New York': '47.8',
        'San Francisco': '51.7',
        Austin: '46.4'
    },
    {
        date: '2012-03-10',
        'New York': '37.2',
        'San Francisco': '49.3',
        Austin: '46.7'
    },
    {
        date: '2012-03-11',
        'New York': '42.9',
        'San Francisco': '50.0',
        Austin: '56.9'
    },
    {
        date: '2012-03-12',
        'New York': '48.8',
        'San Francisco': '48.6',
        Austin: '61.9'
    },
    {
        date: '2012-03-13',
        'New York': '52.6',
        'San Francisco': '53.9',
        Austin: '68.8'
    },
    {
        date: '2012-03-14',
        'New York': '60.5',
        'San Francisco': '55.2',
        Austin: '71.9'
    },
    {
        date: '2012-03-15',
        'New York': '47.2',
        'San Francisco': '55.9',
        Austin: '72.0'
    },
    {
        date: '2012-03-16',
        'New York': '44.7',
        'San Francisco': '54.6',
        Austin: '72.5'
    },
    {
        date: '2012-03-17',
        'New York': '48.2',
        'San Francisco': '48.2',
        Austin: '71.7'
    },
    {
        date: '2012-03-18',
        'New York': '48.2',
        'San Francisco': '47.1',
        Austin: '71.1'
    },
    {
        date: '2012-03-19',
        'New York': '53.1',
        'San Francisco': '45.8',
        Austin: '73.0'
    },
    {
        date: '2012-03-20',
        'New York': '57.8',
        'San Francisco': '49.7',
        Austin: '63.8'
    },
    {
        date: '2012-03-21',
        'New York': '57.5',
        'San Francisco': '51.4',
        Austin: '60.0'
    },
    {
        date: '2012-03-22',
        'New York': '57.3',
        'San Francisco': '51.4',
        Austin: '62.3'
    },
    {
        date: '2012-03-23',
        'New York': '61.7',
        'San Francisco': '48.4',
        Austin: '61.1'
    },
    {
        date: '2012-03-24',
        'New York': '55.8',
        'San Francisco': '49.0',
        Austin: '62.0'
    },
    {
        date: '2012-03-25',
        'New York': '48.4',
        'San Francisco': '46.4',
        Austin: '64.6'
    },
    {
        date: '2012-03-26',
        'New York': '49.8',
        'San Francisco': '49.7',
        Austin: '66.0'
    },
    {
        date: '2012-03-27',
        'New York': '39.6',
        'San Francisco': '54.1',
        Austin: '65.8'
    },
    {
        date: '2012-03-28',
        'New York': '49.7',
        'San Francisco': '54.6',
        Austin: '69.2'
    },
    {
        date: '2012-03-29',
        'New York': '56.8',
        'San Francisco': '52.3',
        Austin: '69.5'
    },
    {
        date: '2012-03-30',
        'New York': '46.5',
        'San Francisco': '54.5',
        Austin: '73.5'
    },
    {
        date: '2012-03-31',
        'New York': '42.2',
        'San Francisco': '56.2',
        Austin: '73.9'
    },
    {
        date: '2012-04-01',
        'New York': '45.3',
        'San Francisco': '51.1',
        Austin: '75.3'
    },
    {
        date: '2012-04-02',
        'New York': '48.1',
        'San Francisco': '50.5',
        Austin: '75.4'
    },
    {
        date: '2012-04-03',
        'New York': '51.2',
        'San Francisco': '52.2',
        Austin: '77.3'
    },
    {
        date: '2012-04-04',
        'New York': '61.0',
        'San Francisco': '50.6',
        Austin: '67.0'
    },
    {
        date: '2012-04-05',
        'New York': '50.7',
        'San Francisco': '47.9',
        Austin: '71.1'
    },
    {
        date: '2012-04-06',
        'New York': '48.0',
        'San Francisco': '47.4',
        Austin: '70.4'
    },
    {
        date: '2012-04-07',
        'New York': '51.1',
        'San Francisco': '49.4',
        Austin: '73.6'
    },
    {
        date: '2012-04-08',
        'New York': '55.7',
        'San Francisco': '50.0',
        Austin: '71.1'
    },
    {
        date: '2012-04-09',
        'New York': '58.3',
        'San Francisco': '51.3',
        Austin: '70.0'
    },
    {
        date: '2012-04-10',
        'New York': '55.0',
        'San Francisco': '53.8',
        Austin: '69.0'
    },
    {
        date: '2012-04-11',
        'New York': '49.0',
        'San Francisco': '52.9',
        Austin: '69.2'
    },
    {
        date: '2012-04-12',
        'New York': '51.7',
        'San Francisco': '53.9',
        Austin: '74.5'
    },
    {
        date: '2012-04-13',
        'New York': '53.1',
        'San Francisco': '50.2',
        Austin: '73.4'
    },
    {
        date: '2012-04-14',
        'New York': '55.2',
        'San Francisco': '50.9',
        Austin: '76.0'
    },
    {
        date: '2012-04-15',
        'New York': '62.3',
        'San Francisco': '51.5',
        Austin: '74.5'
    },
    {
        date: '2012-04-16',
        'New York': '62.9',
        'San Francisco': '51.9',
        Austin: '63.6'
    },
    {
        date: '2012-04-17',
        'New York': '69.3',
        'San Francisco': '53.2',
        Austin: '67.3'
    },
    {
        date: '2012-04-18',
        'New York': '59.0',
        'San Francisco': '53.0',
        Austin: '65.1'
    },
    {
        date: '2012-04-19',
        'New York': '54.1',
        'San Francisco': '55.1',
        Austin: '67.9'
    },
    {
        date: '2012-04-20',
        'New York': '56.5',
        'San Francisco': '55.8',
        Austin: '68.9'
    },
    {
        date: '2012-04-21',
        'New York': '58.2',
        'San Francisco': '58.0',
        Austin: '65.1'
    },
    {
        date: '2012-04-22',
        'New York': '52.4',
        'San Francisco': '52.8',
        Austin: '65.4'
    },
    {
        date: '2012-04-23',
        'New York': '51.6',
        'San Francisco': '55.1',
        Austin: '70.1'
    },
    {
        date: '2012-04-24',
        'New York': '49.3',
        'San Francisco': '57.9',
        Austin: '67.0'
    },
    {
        date: '2012-04-25',
        'New York': '52.5',
        'San Francisco': '57.5',
        Austin: '75.4'
    },
    {
        date: '2012-04-26',
        'New York': '50.5',
        'San Francisco': '55.3',
        Austin: '77.5'
    },
    {
        date: '2012-04-27',
        'New York': '51.9',
        'San Francisco': '53.5',
        Austin: '77.0'
    },
    {
        date: '2012-04-28',
        'New York': '47.4',
        'San Francisco': '54.7',
        Austin: '77.7'
    },
    {
        date: '2012-04-29',
        'New York': '54.1',
        'San Francisco': '54.0',
        Austin: '77.7'
    },
    {
        date: '2012-04-30',
        'New York': '51.9',
        'San Francisco': '53.4',
        Austin: '77.7'
    },
    {
        date: '2012-05-01',
        'New York': '57.4',
        'San Francisco': '52.7',
        Austin: '77.0'
    },
    {
        date: '2012-05-02',
        'New York': '53.7',
        'San Francisco': '50.7',
        Austin: '77.9'
    },
    {
        date: '2012-05-03',
        'New York': '53.1',
        'San Francisco': '52.6',
        Austin: '79.1'
    },
    {
        date: '2012-05-04',
        'New York': '57.2',
        'San Francisco': '53.4',
        Austin: '80.1'
    },
    {
        date: '2012-05-05',
        'New York': '57.0',
        'San Francisco': '53.1',
        Austin: '82.1'
    },
    {
        date: '2012-05-06',
        'New York': '56.6',
        'San Francisco': '56.5',
        Austin: '79.0'
    },
    {
        date: '2012-05-07',
        'New York': '54.6',
        'San Francisco': '55.3',
        Austin: '79.8'
    },
    {
        date: '2012-05-08',
        'New York': '57.9',
        'San Francisco': '52.0',
        Austin: '70.0'
    },
    {
        date: '2012-05-09',
        'New York': '59.2',
        'San Francisco': '52.4',
        Austin: '69.8'
    },
    {
        date: '2012-05-10',
        'New York': '61.1',
        'San Francisco': '53.4',
        Austin: '71.3'
    },
    {
        date: '2012-05-11',
        'New York': '59.7',
        'San Francisco': '53.1',
        Austin: '69.4'
    },
    {
        date: '2012-05-12',
        'New York': '64.1',
        'San Francisco': '49.9',
        Austin: '72.0'
    },
    {
        date: '2012-05-13',
        'New York': '65.3',
        'San Francisco': '52.0',
        Austin: '72.4'
    },
    {
        date: '2012-05-14',
        'New York': '64.2',
        'San Francisco': '56.0',
        Austin: '72.5'
    },
    {
        date: '2012-05-15',
        'New York': '62.0',
        'San Francisco': '53.0',
        Austin: '67.6'
    },
    {
        date: '2012-05-16',
        'New York': '63.8',
        'San Francisco': '51.0',
        Austin: '69.0'
    },
    {
        date: '2012-05-17',
        'New York': '64.5',
        'San Francisco': '51.4',
        Austin: '72.7'
    },
    {
        date: '2012-05-18',
        'New York': '61.0',
        'San Francisco': '52.2',
        Austin: '73.7'
    },
    {
        date: '2012-05-19',
        'New York': '62.6',
        'San Francisco': '52.4',
        Austin: '77.5'
    },
    {
        date: '2012-05-20',
        'New York': '66.2',
        'San Francisco': '54.5',
        Austin: '75.8'
    },
    {
        date: '2012-05-21',
        'New York': '62.7',
        'San Francisco': '52.8',
        Austin: '76.9'
    },
    {
        date: '2012-05-22',
        'New York': '63.7',
        'San Francisco': '53.9',
        Austin: '78.8'
    },
    {
        date: '2012-05-23',
        'New York': '66.4',
        'San Francisco': '56.5',
        Austin: '77.7'
    },
    {
        date: '2012-05-24',
        'New York': '64.5',
        'San Francisco': '54.7',
        Austin: '80.6'
    },
    {
        date: '2012-05-25',
        'New York': '65.4',
        'San Francisco': '52.5',
        Austin: '81.4'
    },
    {
        date: '2012-05-26',
        'New York': '69.4',
        'San Francisco': '52.1',
        Austin: '82.3'
    },
    {
        date: '2012-05-27',
        'New York': '71.9',
        'San Francisco': '52.2',
        Austin: '80.3'
    },
    {
        date: '2012-05-28',
        'New York': '74.4',
        'San Francisco': '52.9',
        Austin: '80.3'
    },
    {
        date: '2012-05-29',
        'New York': '75.9',
        'San Francisco': '52.1',
        Austin: '82.2'
    },
    {
        date: '2012-05-30',
        'New York': '72.9',
        'San Francisco': '52.1',
        Austin: '81.9'
    },
    {
        date: '2012-05-31',
        'New York': '72.5',
        'San Francisco': '53.3',
        Austin: '82.4'
    },
    {
        date: '2012-06-01',
        'New York': '67.2',
        'San Francisco': '54.8',
        Austin: '77.9'
    },
    {
        date: '2012-06-02',
        'New York': '68.3',
        'San Francisco': '54.0',
        Austin: '81.1'
    },
    {
        date: '2012-06-03',
        'New York': '67.7',
        'San Francisco': '52.3',
        Austin: '82.2'
    },
    {
        date: '2012-06-04',
        'New York': '61.9',
        'San Francisco': '55.3',
        Austin: '81.2'
    },
    {
        date: '2012-06-05',
        'New York': '58.3',
        'San Francisco': '53.5',
        Austin: '83.0'
    },
    {
        date: '2012-06-06',
        'New York': '61.7',
        'San Francisco': '54.1',
        Austin: '83.2'
    },
    {
        date: '2012-06-07',
        'New York': '66.7',
        'San Francisco': '53.9',
        Austin: '82.1'
    },
    {
        date: '2012-06-08',
        'New York': '68.7',
        'San Francisco': '54.4',
        Austin: '77.5'
    },
    {
        date: '2012-06-09',
        'New York': '72.2',
        'San Francisco': '55.0',
        Austin: '77.9'
    },
    {
        date: '2012-06-10',
        'New York': '72.6',
        'San Francisco': '60.0',
        Austin: '82.9'
    },
    {
        date: '2012-06-11',
        'New York': '69.2',
        'San Francisco': '57.2',
        Austin: '86.8'
    },
    {
        date: '2012-06-12',
        'New York': '66.9',
        'San Francisco': '55.1',
        Austin: '85.3'
    },
    {
        date: '2012-06-13',
        'New York': '66.7',
        'San Francisco': '53.3',
        Austin: '76.9'
    },
    {
        date: '2012-06-14',
        'New York': '67.7',
        'San Francisco': '53.4',
        Austin: '84.5'
    },
    {
        date: '2012-06-15',
        'New York': '68.5',
        'San Francisco': '54.6',
        Austin: '84.4'
    },
    {
        date: '2012-06-16',
        'New York': '67.5',
        'San Francisco': '57.0',
        Austin: '83.8'
    },
    {
        date: '2012-06-17',
        'New York': '64.2',
        'San Francisco': '55.6',
        Austin: '82.5'
    },
    {
        date: '2012-06-18',
        'New York': '61.7',
        'San Francisco': '52.5',
        Austin: '82.9'
    },
    {
        date: '2012-06-19',
        'New York': '66.4',
        'San Francisco': '53.9',
        Austin: '82.5'
    },
    {
        date: '2012-06-20',
        'New York': '77.9',
        'San Francisco': '55.3',
        Austin: '81.3'
    },
    {
        date: '2012-06-21',
        'New York': '88.3',
        'San Francisco': '53.3',
        Austin: '80.8'
    },
    {
        date: '2012-06-22',
        'New York': '82.2',
        'San Francisco': '54.1',
        Austin: '81.7'
    },
    {
        date: '2012-06-23',
        'New York': '77.0',
        'San Francisco': '55.2',
        Austin: '83.9'
    },
    {
        date: '2012-06-24',
        'New York': '75.4',
        'San Francisco': '55.8',
        Austin: '85.5'
    },
    {
        date: '2012-06-25',
        'New York': '70.9',
        'San Francisco': '56.8',
        Austin: '87.2'
    },
    {
        date: '2012-06-26',
        'New York': '65.9',
        'San Francisco': '57.5',
        Austin: '88.0'
    },
    {
        date: '2012-06-27',
        'New York': '73.5',
        'San Francisco': '57.7',
        Austin: '89.6'
    },
    {
        date: '2012-06-28',
        'New York': '77.4',
        'San Francisco': '56.6',
        Austin: '86.7'
    },
    {
        date: '2012-06-29',
        'New York': '79.6',
        'San Francisco': '56.4',
        Austin: '85.3'
    },
    {
        date: '2012-06-30',
        'New York': '84.2',
        'San Francisco': '58.4',
        Austin: '81.7'
    },
    {
        date: '2012-07-01',
        'New York': '81.8',
        'San Francisco': '58.8',
        Austin: '78.5'
    },
    {
        date: '2012-07-02',
        'New York': '82.5',
        'San Francisco': '56.4',
        Austin: '83.1'
    },
    {
        date: '2012-07-03',
        'New York': '80.2',
        'San Francisco': '56.5',
        Austin: '83.1'
    },
    {
        date: '2012-07-04',
        'New York': '77.8',
        'San Francisco': '55.8',
        Austin: '84.5'
    },
    {
        date: '2012-07-05',
        'New York': '86.1',
        'San Francisco': '54.8',
        Austin: '84.6'
    },
    {
        date: '2012-07-06',
        'New York': '79.9',
        'San Francisco': '54.9',
        Austin: '84.2'
    },
    {
        date: '2012-07-07',
        'New York': '83.5',
        'San Francisco': '54.7',
        Austin: '86.7'
    },
    {
        date: '2012-07-08',
        'New York': '81.5',
        'San Francisco': '52.8',
        Austin: '84.3'
    },
    {
        date: '2012-07-09',
        'New York': '77.8',
        'San Francisco': '53.7',
        Austin: '83.7'
    },
    {
        date: '2012-07-10',
        'New York': '76.1',
        'San Francisco': '53.1',
        Austin: '77.1'
    },
    {
        date: '2012-07-11',
        'New York': '76.3',
        'San Francisco': '52.7',
        Austin: '77.4'
    },
    {
        date: '2012-07-12',
        'New York': '75.8',
        'San Francisco': '52.0',
        Austin: '80.6'
    },
    {
        date: '2012-07-13',
        'New York': '77.2',
        'San Francisco': '53.4',
        Austin: '81.4'
    },
    {
        date: '2012-07-14',
        'New York': '79.3',
        'San Francisco': '54.0',
        Austin: '80.2'
    },
    {
        date: '2012-07-15',
        'New York': '78.9',
        'San Francisco': '54.0',
        Austin: '81.8'
    },
    {
        date: '2012-07-16',
        'New York': '79.6',
        'San Francisco': '54.5',
        Austin: '77.3'
    },
    {
        date: '2012-07-17',
        'New York': '83.3',
        'San Francisco': '56.7',
        Austin: '80.8'
    },
    {
        date: '2012-07-18',
        'New York': '84.3',
        'San Francisco': '57.5',
        Austin: '81.6'
    },
    {
        date: '2012-07-19',
        'New York': '75.1',
        'San Francisco': '57.1',
        Austin: '80.9'
    },
    {
        date: '2012-07-20',
        'New York': '68.4',
        'San Francisco': '58.1',
        Austin: '83.9'
    },
    {
        date: '2012-07-21',
        'New York': '68.4',
        'San Francisco': '57.6',
        Austin: '85.6'
    },
    {
        date: '2012-07-22',
        'New York': '72.2',
        'San Francisco': '56.0',
        Austin: '83.6'
    },
    {
        date: '2012-07-23',
        'New York': '75.6',
        'San Francisco': '56.6',
        Austin: '84.0'
    },
    {
        date: '2012-07-24',
        'New York': '82.6',
        'San Francisco': '57.8',
        Austin: '83.0'
    },
    {
        date: '2012-07-25',
        'New York': '78.4',
        'San Francisco': '57.5',
        Austin: '84.8'
    },
    {
        date: '2012-07-26',
        'New York': '77.0',
        'San Francisco': '56.4',
        Austin: '84.4'
    },
    {
        date: '2012-07-27',
        'New York': '79.4',
        'San Francisco': '55.3',
        Austin: '84.3'
    },
    {
        date: '2012-07-28',
        'New York': '77.4',
        'San Francisco': '55.0',
        Austin: '83.9'
    },
    {
        date: '2012-07-29',
        'New York': '72.5',
        'San Francisco': '55.6',
        Austin: '85.0'
    },
    {
        date: '2012-07-30',
        'New York': '72.9',
        'San Francisco': '55.6',
        Austin: '84.9'
    },
    {
        date: '2012-07-31',
        'New York': '73.6',
        'San Francisco': '55.9',
        Austin: '86.3'
    },
    {
        date: '2012-08-01',
        'New York': '75.0',
        'San Francisco': '55.4',
        Austin: '86.5'
    },
    {
        date: '2012-08-02',
        'New York': '77.7',
        'San Francisco': '54.4',
        Austin: '85.8'
    },
    {
        date: '2012-08-03',
        'New York': '79.7',
        'San Francisco': '53.7',
        Austin: '85.3'
    },
    {
        date: '2012-08-04',
        'New York': '79.6',
        'San Francisco': '54.1',
        Austin: '86.0'
    },
    {
        date: '2012-08-05',
        'New York': '81.5',
        'San Francisco': '57.8',
        Austin: '84.2'
    },
    {
        date: '2012-08-06',
        'New York': '80.0',
        'San Francisco': '58.2',
        Austin: '81.9'
    },
    {
        date: '2012-08-07',
        'New York': '75.7',
        'San Francisco': '58.0',
        Austin: '86.5'
    },
    {
        date: '2012-08-08',
        'New York': '77.8',
        'San Francisco': '57.0',
        Austin: '86.1'
    },
    {
        date: '2012-08-09',
        'New York': '78.6',
        'San Francisco': '55.0',
        Austin: '86.8'
    },
    {
        date: '2012-08-10',
        'New York': '77.8',
        'San Francisco': '54.8',
        Austin: '88.0'
    },
    {
        date: '2012-08-11',
        'New York': '78.5',
        'San Francisco': '53.0',
        Austin: '85.1'
    },
    {
        date: '2012-08-12',
        'New York': '78.8',
        'San Francisco': '52.5',
        Austin: '87.4'
    },
    {
        date: '2012-08-13',
        'New York': '78.6',
        'San Francisco': '53.3',
        Austin: '88.0'
    },
    {
        date: '2012-08-14',
        'New York': '76.8',
        'San Francisco': '53.9',
        Austin: '88.0'
    },
    {
        date: '2012-08-15',
        'New York': '76.7',
        'San Francisco': '56.2',
        Austin: '87.2'
    },
    {
        date: '2012-08-16',
        'New York': '75.9',
        'San Francisco': '57.1',
        Austin: '86.1'
    },
    {
        date: '2012-08-17',
        'New York': '77.6',
        'San Francisco': '55.3',
        Austin: '86.8'
    },
    {
        date: '2012-08-18',
        'New York': '72.6',
        'San Francisco': '56.2',
        Austin: '84.9'
    },
    {
        date: '2012-08-19',
        'New York': '70.4',
        'San Francisco': '54.3',
        Austin: '76.8'
    },
    {
        date: '2012-08-20',
        'New York': '71.8',
        'San Francisco': '53.1',
        Austin: '80.6'
    },
    {
        date: '2012-08-21',
        'New York': '73.6',
        'San Francisco': '53.4',
        Austin: '80.0'
    },
    {
        date: '2012-08-22',
        'New York': '74.7',
        'San Francisco': '54.5',
        Austin: '78.2'
    },
    {
        date: '2012-08-23',
        'New York': '74.6',
        'San Francisco': '55.7',
        Austin: '79.1'
    },
    {
        date: '2012-08-24',
        'New York': '76.0',
        'San Francisco': '54.8',
        Austin: '81.9'
    },
    {
        date: '2012-08-25',
        'New York': '76.2',
        'San Francisco': '53.8',
        Austin: '84.7'
    },
    {
        date: '2012-08-26',
        'New York': '73.4',
        'San Francisco': '56.5',
        Austin: '83.5'
    },
    {
        date: '2012-08-27',
        'New York': '74.6',
        'San Francisco': '58.3',
        Austin: '82.1'
    },
    {
        date: '2012-08-28',
        'New York': '79.4',
        'San Francisco': '58.7',
        Austin: '84.0'
    },
    {
        date: '2012-08-29',
        'New York': '74.7',
        'San Francisco': '57.5',
        Austin: '85.7'
    },
    {
        date: '2012-08-30',
        'New York': '73.5',
        'San Francisco': '55.9',
        Austin: '87.2'
    },
    {
        date: '2012-08-31',
        'New York': '77.9',
        'San Francisco': '55.4',
        Austin: '82.9'
    },
    {
        date: '2012-09-01',
        'New York': '80.7',
        'San Francisco': '55.7',
        Austin: '84.8'
    },
    {
        date: '2012-09-02',
        'New York': '75.1',
        'San Francisco': '53.1',
        Austin: '83.9'
    },
    {
        date: '2012-09-03',
        'New York': '73.5',
        'San Francisco': '53.5',
        Austin: '85.5'
    },
    {
        date: '2012-09-04',
        'New York': '73.5',
        'San Francisco': '52.5',
        Austin: '86.4'
    },
    {
        date: '2012-09-05',
        'New York': '77.7',
        'San Francisco': '54.5',
        Austin: '85.8'
    },
    {
        date: '2012-09-06',
        'New York': '74.2',
        'San Francisco': '56.3',
        Austin: '85.4'
    },
    {
        date: '2012-09-07',
        'New York': '76.0',
        'San Francisco': '56.4',
        Austin: '85.3'
    },
    {
        date: '2012-09-08',
        'New York': '77.1',
        'San Francisco': '56.5',
        Austin: '81.9'
    },
    {
        date: '2012-09-09',
        'New York': '69.7',
        'San Francisco': '56.4',
        Austin: '74.8'
    },
    {
        date: '2012-09-10',
        'New York': '67.8',
        'San Francisco': '55.4',
        Austin: '71.6'
    },
    {
        date: '2012-09-11',
        'New York': '64.0',
        'San Francisco': '56.2',
        Austin: '75.9'
    },
    {
        date: '2012-09-12',
        'New York': '68.1',
        'San Francisco': '55.7',
        Austin: '82.1'
    },
    {
        date: '2012-09-13',
        'New York': '69.3',
        'San Francisco': '54.3',
        Austin: '80.5'
    },
    {
        date: '2012-09-14',
        'New York': '70.0',
        'San Francisco': '55.2',
        Austin: '70.0'
    },
    {
        date: '2012-09-15',
        'New York': '69.3',
        'San Francisco': '54.3',
        Austin: '71.2'
    },
    {
        date: '2012-09-16',
        'New York': '66.3',
        'San Francisco': '52.9',
        Austin: '70.3'
    },
    {
        date: '2012-09-17',
        'New York': '67.0',
        'San Francisco': '54.8',
        Austin: '72.1'
    },
    {
        date: '2012-09-18',
        'New York': '72.8',
        'San Francisco': '54.8',
        Austin: '73.7'
    },
    {
        date: '2012-09-19',
        'New York': '67.2',
        'San Francisco': '56.8',
        Austin: '72.7'
    },
    {
        date: '2012-09-20',
        'New York': '62.1',
        'San Francisco': '55.4',
        Austin: '71.7'
    },
    {
        date: '2012-09-21',
        'New York': '64.0',
        'San Francisco': '55.8',
        Austin: '72.9'
    },
    {
        date: '2012-09-22',
        'New York': '65.5',
        'San Francisco': '55.9',
        Austin: '73.1'
    },
    {
        date: '2012-09-23',
        'New York': '65.7',
        'San Francisco': '52.8',
        Austin: '75.6'
    },
    {
        date: '2012-09-24',
        'New York': '60.4',
        'San Francisco': '54.5',
        Austin: '78.3'
    },
    {
        date: '2012-09-25',
        'New York': '63.2',
        'San Francisco': '53.3',
        Austin: '78.3'
    },
    {
        date: '2012-09-26',
        'New York': '68.5',
        'San Francisco': '53.6',
        Austin: '79.6'
    },
    {
        date: '2012-09-27',
        'New York': '69.2',
        'San Francisco': '52.1',
        Austin: '76.4'
    },
    {
        date: '2012-09-28',
        'New York': '68.7',
        'San Francisco': '52.6',
        Austin: '77.2'
    },
    {
        date: '2012-09-29',
        'New York': '62.5',
        'San Francisco': '53.9',
        Austin: '75.2'
    },
    {
        date: '2012-09-30',
        'New York': '62.3',
        'San Francisco': '55.1',
        Austin: '71.9'
    }
];
var $824089a18792383f$export$2e2bcd8739ae039 = $824089a18792383f$var$cityTemperature;


const $73d17d24fbdba218$var$lesMiserables = {
    nodes: [
        {
            id: 'Myriel',
            group: 1
        },
        {
            id: 'Napoleon',
            group: 1
        },
        {
            id: 'Mlle.Baptistine',
            group: 1
        },
        {
            id: 'Mme.Magloire',
            group: 1
        },
        {
            id: 'CountessdeLo',
            group: 1
        },
        {
            id: 'Geborand',
            group: 1
        },
        {
            id: 'Champtercier',
            group: 1
        },
        {
            id: 'Cravatte',
            group: 1
        },
        {
            id: 'Count',
            group: 1
        },
        {
            id: 'OldMan',
            group: 1
        },
        {
            id: 'Labarre',
            group: 2
        },
        {
            id: 'Valjean',
            group: 2
        },
        {
            id: 'Marguerite',
            group: 3
        },
        {
            id: 'Mme.deR',
            group: 2
        },
        {
            id: 'Isabeau',
            group: 2
        },
        {
            id: 'Gervais',
            group: 2
        },
        {
            id: 'Tholomyes',
            group: 3
        },
        {
            id: 'Listolier',
            group: 3
        },
        {
            id: 'Fameuil',
            group: 3
        },
        {
            id: 'Blacheville',
            group: 3
        },
        {
            id: 'Favourite',
            group: 3
        },
        {
            id: 'Dahlia',
            group: 3
        },
        {
            id: 'Zephine',
            group: 3
        },
        {
            id: 'Fantine',
            group: 3
        },
        {
            id: 'Mme.Thenardier',
            group: 4
        },
        {
            id: 'Thenardier',
            group: 4
        },
        {
            id: 'Cosette',
            group: 5
        },
        {
            id: 'Javert',
            group: 4
        },
        {
            id: 'Fauchelevent',
            group: 0
        },
        {
            id: 'Bamatabois',
            group: 2
        },
        {
            id: 'Perpetue',
            group: 3
        },
        {
            id: 'Simplice',
            group: 2
        },
        {
            id: 'Scaufflaire',
            group: 2
        },
        {
            id: 'Woman1',
            group: 2
        },
        {
            id: 'Judge',
            group: 2
        },
        {
            id: 'Champmathieu',
            group: 2
        },
        {
            id: 'Brevet',
            group: 2
        },
        {
            id: 'Chenildieu',
            group: 2
        },
        {
            id: 'Cochepaille',
            group: 2
        },
        {
            id: 'Pontmercy',
            group: 4
        },
        {
            id: 'Boulatruelle',
            group: 6
        },
        {
            id: 'Eponine',
            group: 4
        },
        {
            id: 'Anzelma',
            group: 4
        },
        {
            id: 'Woman2',
            group: 5
        },
        {
            id: 'MotherInnocent',
            group: 0
        },
        {
            id: 'Gribier',
            group: 0
        },
        {
            id: 'Jondrette',
            group: 7
        },
        {
            id: 'Mme.Burgon',
            group: 7
        },
        {
            id: 'Gavroche',
            group: 8
        },
        {
            id: 'Gillenormand',
            group: 5
        },
        {
            id: 'Magnon',
            group: 5
        },
        {
            id: 'Mlle.Gillenormand',
            group: 5
        },
        {
            id: 'Mme.Pontmercy',
            group: 5
        },
        {
            id: 'Mlle.Vaubois',
            group: 5
        },
        {
            id: 'Lt.Gillenormand',
            group: 5
        },
        {
            id: 'Marius',
            group: 8
        },
        {
            id: 'BaronessT',
            group: 5
        },
        {
            id: 'Mabeuf',
            group: 8
        },
        {
            id: 'Enjolras',
            group: 8
        },
        {
            id: 'Combeferre',
            group: 8
        },
        {
            id: 'Prouvaire',
            group: 8
        },
        {
            id: 'Feuilly',
            group: 8
        },
        {
            id: 'Courfeyrac',
            group: 8
        },
        {
            id: 'Bahorel',
            group: 8
        },
        {
            id: 'Bossuet',
            group: 8
        },
        {
            id: 'Joly',
            group: 8
        },
        {
            id: 'Grantaire',
            group: 8
        },
        {
            id: 'MotherPlutarch',
            group: 9
        },
        {
            id: 'Gueulemer',
            group: 4
        },
        {
            id: 'Babet',
            group: 4
        },
        {
            id: 'Claquesous',
            group: 4
        },
        {
            id: 'Montparnasse',
            group: 4
        },
        {
            id: 'Toussaint',
            group: 5
        },
        {
            id: 'Child1',
            group: 10
        },
        {
            id: 'Child2',
            group: 10
        },
        {
            id: 'Brujon',
            group: 4
        },
        {
            id: 'Mme.Hucheloup',
            group: 8
        }
    ],
    links: [
        {
            source: 'Napoleon',
            target: 'Myriel',
            value: 1
        },
        {
            source: 'Mlle.Baptistine',
            target: 'Myriel',
            value: 8
        },
        {
            source: 'Mme.Magloire',
            target: 'Myriel',
            value: 10
        },
        {
            source: 'Mme.Magloire',
            target: 'Mlle.Baptistine',
            value: 6
        },
        {
            source: 'CountessdeLo',
            target: 'Myriel',
            value: 1
        },
        {
            source: 'Geborand',
            target: 'Myriel',
            value: 1
        },
        {
            source: 'Champtercier',
            target: 'Myriel',
            value: 1
        },
        {
            source: 'Cravatte',
            target: 'Myriel',
            value: 1
        },
        {
            source: 'Count',
            target: 'Myriel',
            value: 2
        },
        {
            source: 'OldMan',
            target: 'Myriel',
            value: 1
        },
        {
            source: 'Valjean',
            target: 'Labarre',
            value: 1
        },
        {
            source: 'Valjean',
            target: 'Mme.Magloire',
            value: 3
        },
        {
            source: 'Valjean',
            target: 'Mlle.Baptistine',
            value: 3
        },
        {
            source: 'Valjean',
            target: 'Myriel',
            value: 5
        },
        {
            source: 'Marguerite',
            target: 'Valjean',
            value: 1
        },
        {
            source: 'Mme.deR',
            target: 'Valjean',
            value: 1
        },
        {
            source: 'Isabeau',
            target: 'Valjean',
            value: 1
        },
        {
            source: 'Gervais',
            target: 'Valjean',
            value: 1
        },
        {
            source: 'Listolier',
            target: 'Tholomyes',
            value: 4
        },
        {
            source: 'Fameuil',
            target: 'Tholomyes',
            value: 4
        },
        {
            source: 'Fameuil',
            target: 'Listolier',
            value: 4
        },
        {
            source: 'Blacheville',
            target: 'Tholomyes',
            value: 4
        },
        {
            source: 'Blacheville',
            target: 'Listolier',
            value: 4
        },
        {
            source: 'Blacheville',
            target: 'Fameuil',
            value: 4
        },
        {
            source: 'Favourite',
            target: 'Tholomyes',
            value: 3
        },
        {
            source: 'Favourite',
            target: 'Listolier',
            value: 3
        },
        {
            source: 'Favourite',
            target: 'Fameuil',
            value: 3
        },
        {
            source: 'Favourite',
            target: 'Blacheville',
            value: 4
        },
        {
            source: 'Dahlia',
            target: 'Tholomyes',
            value: 3
        },
        {
            source: 'Dahlia',
            target: 'Listolier',
            value: 3
        },
        {
            source: 'Dahlia',
            target: 'Fameuil',
            value: 3
        },
        {
            source: 'Dahlia',
            target: 'Blacheville',
            value: 3
        },
        {
            source: 'Dahlia',
            target: 'Favourite',
            value: 5
        },
        {
            source: 'Zephine',
            target: 'Tholomyes',
            value: 3
        },
        {
            source: 'Zephine',
            target: 'Listolier',
            value: 3
        },
        {
            source: 'Zephine',
            target: 'Fameuil',
            value: 3
        },
        {
            source: 'Zephine',
            target: 'Blacheville',
            value: 3
        },
        {
            source: 'Zephine',
            target: 'Favourite',
            value: 4
        },
        {
            source: 'Zephine',
            target: 'Dahlia',
            value: 4
        },
        {
            source: 'Fantine',
            target: 'Tholomyes',
            value: 3
        },
        {
            source: 'Fantine',
            target: 'Listolier',
            value: 3
        },
        {
            source: 'Fantine',
            target: 'Fameuil',
            value: 3
        },
        {
            source: 'Fantine',
            target: 'Blacheville',
            value: 3
        },
        {
            source: 'Fantine',
            target: 'Favourite',
            value: 4
        },
        {
            source: 'Fantine',
            target: 'Dahlia',
            value: 4
        },
        {
            source: 'Fantine',
            target: 'Zephine',
            value: 4
        },
        {
            source: 'Fantine',
            target: 'Marguerite',
            value: 2
        },
        {
            source: 'Fantine',
            target: 'Valjean',
            value: 9
        },
        {
            source: 'Mme.Thenardier',
            target: 'Fantine',
            value: 2
        },
        {
            source: 'Mme.Thenardier',
            target: 'Valjean',
            value: 7
        },
        {
            source: 'Thenardier',
            target: 'Mme.Thenardier',
            value: 13
        },
        {
            source: 'Thenardier',
            target: 'Fantine',
            value: 1
        },
        {
            source: 'Thenardier',
            target: 'Valjean',
            value: 12
        },
        {
            source: 'Cosette',
            target: 'Mme.Thenardier',
            value: 4
        },
        {
            source: 'Cosette',
            target: 'Valjean',
            value: 31
        },
        {
            source: 'Cosette',
            target: 'Tholomyes',
            value: 1
        },
        {
            source: 'Cosette',
            target: 'Thenardier',
            value: 1
        },
        {
            source: 'Javert',
            target: 'Valjean',
            value: 17
        },
        {
            source: 'Javert',
            target: 'Fantine',
            value: 5
        },
        {
            source: 'Javert',
            target: 'Thenardier',
            value: 5
        },
        {
            source: 'Javert',
            target: 'Mme.Thenardier',
            value: 1
        },
        {
            source: 'Javert',
            target: 'Cosette',
            value: 1
        },
        {
            source: 'Fauchelevent',
            target: 'Valjean',
            value: 8
        },
        {
            source: 'Fauchelevent',
            target: 'Javert',
            value: 1
        },
        {
            source: 'Bamatabois',
            target: 'Fantine',
            value: 1
        },
        {
            source: 'Bamatabois',
            target: 'Javert',
            value: 1
        },
        {
            source: 'Bamatabois',
            target: 'Valjean',
            value: 2
        },
        {
            source: 'Perpetue',
            target: 'Fantine',
            value: 1
        },
        {
            source: 'Simplice',
            target: 'Perpetue',
            value: 2
        },
        {
            source: 'Simplice',
            target: 'Valjean',
            value: 3
        },
        {
            source: 'Simplice',
            target: 'Fantine',
            value: 2
        },
        {
            source: 'Simplice',
            target: 'Javert',
            value: 1
        },
        {
            source: 'Scaufflaire',
            target: 'Valjean',
            value: 1
        },
        {
            source: 'Woman1',
            target: 'Valjean',
            value: 2
        },
        {
            source: 'Woman1',
            target: 'Javert',
            value: 1
        },
        {
            source: 'Judge',
            target: 'Valjean',
            value: 3
        },
        {
            source: 'Judge',
            target: 'Bamatabois',
            value: 2
        },
        {
            source: 'Champmathieu',
            target: 'Valjean',
            value: 3
        },
        {
            source: 'Champmathieu',
            target: 'Judge',
            value: 3
        },
        {
            source: 'Champmathieu',
            target: 'Bamatabois',
            value: 2
        },
        {
            source: 'Brevet',
            target: 'Judge',
            value: 2
        },
        {
            source: 'Brevet',
            target: 'Champmathieu',
            value: 2
        },
        {
            source: 'Brevet',
            target: 'Valjean',
            value: 2
        },
        {
            source: 'Brevet',
            target: 'Bamatabois',
            value: 1
        },
        {
            source: 'Chenildieu',
            target: 'Judge',
            value: 2
        },
        {
            source: 'Chenildieu',
            target: 'Champmathieu',
            value: 2
        },
        {
            source: 'Chenildieu',
            target: 'Brevet',
            value: 2
        },
        {
            source: 'Chenildieu',
            target: 'Valjean',
            value: 2
        },
        {
            source: 'Chenildieu',
            target: 'Bamatabois',
            value: 1
        },
        {
            source: 'Cochepaille',
            target: 'Judge',
            value: 2
        },
        {
            source: 'Cochepaille',
            target: 'Champmathieu',
            value: 2
        },
        {
            source: 'Cochepaille',
            target: 'Brevet',
            value: 2
        },
        {
            source: 'Cochepaille',
            target: 'Chenildieu',
            value: 2
        },
        {
            source: 'Cochepaille',
            target: 'Valjean',
            value: 2
        },
        {
            source: 'Cochepaille',
            target: 'Bamatabois',
            value: 1
        },
        {
            source: 'Pontmercy',
            target: 'Thenardier',
            value: 1
        },
        {
            source: 'Boulatruelle',
            target: 'Thenardier',
            value: 1
        },
        {
            source: 'Eponine',
            target: 'Mme.Thenardier',
            value: 2
        },
        {
            source: 'Eponine',
            target: 'Thenardier',
            value: 3
        },
        {
            source: 'Anzelma',
            target: 'Eponine',
            value: 2
        },
        {
            source: 'Anzelma',
            target: 'Thenardier',
            value: 2
        },
        {
            source: 'Anzelma',
            target: 'Mme.Thenardier',
            value: 1
        },
        {
            source: 'Woman2',
            target: 'Valjean',
            value: 3
        },
        {
            source: 'Woman2',
            target: 'Cosette',
            value: 1
        },
        {
            source: 'Woman2',
            target: 'Javert',
            value: 1
        },
        {
            source: 'MotherInnocent',
            target: 'Fauchelevent',
            value: 3
        },
        {
            source: 'MotherInnocent',
            target: 'Valjean',
            value: 1
        },
        {
            source: 'Gribier',
            target: 'Fauchelevent',
            value: 2
        },
        {
            source: 'Mme.Burgon',
            target: 'Jondrette',
            value: 1
        },
        {
            source: 'Gavroche',
            target: 'Mme.Burgon',
            value: 2
        },
        {
            source: 'Gavroche',
            target: 'Thenardier',
            value: 1
        },
        {
            source: 'Gavroche',
            target: 'Javert',
            value: 1
        },
        {
            source: 'Gavroche',
            target: 'Valjean',
            value: 1
        },
        {
            source: 'Gillenormand',
            target: 'Cosette',
            value: 3
        },
        {
            source: 'Gillenormand',
            target: 'Valjean',
            value: 2
        },
        {
            source: 'Magnon',
            target: 'Gillenormand',
            value: 1
        },
        {
            source: 'Magnon',
            target: 'Mme.Thenardier',
            value: 1
        },
        {
            source: 'Mlle.Gillenormand',
            target: 'Gillenormand',
            value: 9
        },
        {
            source: 'Mlle.Gillenormand',
            target: 'Cosette',
            value: 2
        },
        {
            source: 'Mlle.Gillenormand',
            target: 'Valjean',
            value: 2
        },
        {
            source: 'Mme.Pontmercy',
            target: 'Mlle.Gillenormand',
            value: 1
        },
        {
            source: 'Mme.Pontmercy',
            target: 'Pontmercy',
            value: 1
        },
        {
            source: 'Mlle.Vaubois',
            target: 'Mlle.Gillenormand',
            value: 1
        },
        {
            source: 'Lt.Gillenormand',
            target: 'Mlle.Gillenormand',
            value: 2
        },
        {
            source: 'Lt.Gillenormand',
            target: 'Gillenormand',
            value: 1
        },
        {
            source: 'Lt.Gillenormand',
            target: 'Cosette',
            value: 1
        },
        {
            source: 'Marius',
            target: 'Mlle.Gillenormand',
            value: 6
        },
        {
            source: 'Marius',
            target: 'Gillenormand',
            value: 12
        },
        {
            source: 'Marius',
            target: 'Pontmercy',
            value: 1
        },
        {
            source: 'Marius',
            target: 'Lt.Gillenormand',
            value: 1
        },
        {
            source: 'Marius',
            target: 'Cosette',
            value: 21
        },
        {
            source: 'Marius',
            target: 'Valjean',
            value: 19
        },
        {
            source: 'Marius',
            target: 'Tholomyes',
            value: 1
        },
        {
            source: 'Marius',
            target: 'Thenardier',
            value: 2
        },
        {
            source: 'Marius',
            target: 'Eponine',
            value: 5
        },
        {
            source: 'Marius',
            target: 'Gavroche',
            value: 4
        },
        {
            source: 'BaronessT',
            target: 'Gillenormand',
            value: 1
        },
        {
            source: 'BaronessT',
            target: 'Marius',
            value: 1
        },
        {
            source: 'Mabeuf',
            target: 'Marius',
            value: 1
        },
        {
            source: 'Mabeuf',
            target: 'Eponine',
            value: 1
        },
        {
            source: 'Mabeuf',
            target: 'Gavroche',
            value: 1
        },
        {
            source: 'Enjolras',
            target: 'Marius',
            value: 7
        },
        {
            source: 'Enjolras',
            target: 'Gavroche',
            value: 7
        },
        {
            source: 'Enjolras',
            target: 'Javert',
            value: 6
        },
        {
            source: 'Enjolras',
            target: 'Mabeuf',
            value: 1
        },
        {
            source: 'Enjolras',
            target: 'Valjean',
            value: 4
        },
        {
            source: 'Combeferre',
            target: 'Enjolras',
            value: 15
        },
        {
            source: 'Combeferre',
            target: 'Marius',
            value: 5
        },
        {
            source: 'Combeferre',
            target: 'Gavroche',
            value: 6
        },
        {
            source: 'Combeferre',
            target: 'Mabeuf',
            value: 2
        },
        {
            source: 'Prouvaire',
            target: 'Gavroche',
            value: 1
        },
        {
            source: 'Prouvaire',
            target: 'Enjolras',
            value: 4
        },
        {
            source: 'Prouvaire',
            target: 'Combeferre',
            value: 2
        },
        {
            source: 'Feuilly',
            target: 'Gavroche',
            value: 2
        },
        {
            source: 'Feuilly',
            target: 'Enjolras',
            value: 6
        },
        {
            source: 'Feuilly',
            target: 'Prouvaire',
            value: 2
        },
        {
            source: 'Feuilly',
            target: 'Combeferre',
            value: 5
        },
        {
            source: 'Feuilly',
            target: 'Mabeuf',
            value: 1
        },
        {
            source: 'Feuilly',
            target: 'Marius',
            value: 1
        },
        {
            source: 'Courfeyrac',
            target: 'Marius',
            value: 9
        },
        {
            source: 'Courfeyrac',
            target: 'Enjolras',
            value: 17
        },
        {
            source: 'Courfeyrac',
            target: 'Combeferre',
            value: 13
        },
        {
            source: 'Courfeyrac',
            target: 'Gavroche',
            value: 7
        },
        {
            source: 'Courfeyrac',
            target: 'Mabeuf',
            value: 2
        },
        {
            source: 'Courfeyrac',
            target: 'Eponine',
            value: 1
        },
        {
            source: 'Courfeyrac',
            target: 'Feuilly',
            value: 6
        },
        {
            source: 'Courfeyrac',
            target: 'Prouvaire',
            value: 3
        },
        {
            source: 'Bahorel',
            target: 'Combeferre',
            value: 5
        },
        {
            source: 'Bahorel',
            target: 'Gavroche',
            value: 5
        },
        {
            source: 'Bahorel',
            target: 'Courfeyrac',
            value: 6
        },
        {
            source: 'Bahorel',
            target: 'Mabeuf',
            value: 2
        },
        {
            source: 'Bahorel',
            target: 'Enjolras',
            value: 4
        },
        {
            source: 'Bahorel',
            target: 'Feuilly',
            value: 3
        },
        {
            source: 'Bahorel',
            target: 'Prouvaire',
            value: 2
        },
        {
            source: 'Bahorel',
            target: 'Marius',
            value: 1
        },
        {
            source: 'Bossuet',
            target: 'Marius',
            value: 5
        },
        {
            source: 'Bossuet',
            target: 'Courfeyrac',
            value: 12
        },
        {
            source: 'Bossuet',
            target: 'Gavroche',
            value: 5
        },
        {
            source: 'Bossuet',
            target: 'Bahorel',
            value: 4
        },
        {
            source: 'Bossuet',
            target: 'Enjolras',
            value: 10
        },
        {
            source: 'Bossuet',
            target: 'Feuilly',
            value: 6
        },
        {
            source: 'Bossuet',
            target: 'Prouvaire',
            value: 2
        },
        {
            source: 'Bossuet',
            target: 'Combeferre',
            value: 9
        },
        {
            source: 'Bossuet',
            target: 'Mabeuf',
            value: 1
        },
        {
            source: 'Bossuet',
            target: 'Valjean',
            value: 1
        },
        {
            source: 'Joly',
            target: 'Bahorel',
            value: 5
        },
        {
            source: 'Joly',
            target: 'Bossuet',
            value: 7
        },
        {
            source: 'Joly',
            target: 'Gavroche',
            value: 3
        },
        {
            source: 'Joly',
            target: 'Courfeyrac',
            value: 5
        },
        {
            source: 'Joly',
            target: 'Enjolras',
            value: 5
        },
        {
            source: 'Joly',
            target: 'Feuilly',
            value: 5
        },
        {
            source: 'Joly',
            target: 'Prouvaire',
            value: 2
        },
        {
            source: 'Joly',
            target: 'Combeferre',
            value: 5
        },
        {
            source: 'Joly',
            target: 'Mabeuf',
            value: 1
        },
        {
            source: 'Joly',
            target: 'Marius',
            value: 2
        },
        {
            source: 'Grantaire',
            target: 'Bossuet',
            value: 3
        },
        {
            source: 'Grantaire',
            target: 'Enjolras',
            value: 3
        },
        {
            source: 'Grantaire',
            target: 'Combeferre',
            value: 1
        },
        {
            source: 'Grantaire',
            target: 'Courfeyrac',
            value: 2
        },
        {
            source: 'Grantaire',
            target: 'Joly',
            value: 2
        },
        {
            source: 'Grantaire',
            target: 'Gavroche',
            value: 1
        },
        {
            source: 'Grantaire',
            target: 'Bahorel',
            value: 1
        },
        {
            source: 'Grantaire',
            target: 'Feuilly',
            value: 1
        },
        {
            source: 'Grantaire',
            target: 'Prouvaire',
            value: 1
        },
        {
            source: 'MotherPlutarch',
            target: 'Mabeuf',
            value: 3
        },
        {
            source: 'Gueulemer',
            target: 'Thenardier',
            value: 5
        },
        {
            source: 'Gueulemer',
            target: 'Valjean',
            value: 1
        },
        {
            source: 'Gueulemer',
            target: 'Mme.Thenardier',
            value: 1
        },
        {
            source: 'Gueulemer',
            target: 'Javert',
            value: 1
        },
        {
            source: 'Gueulemer',
            target: 'Gavroche',
            value: 1
        },
        {
            source: 'Gueulemer',
            target: 'Eponine',
            value: 1
        },
        {
            source: 'Babet',
            target: 'Thenardier',
            value: 6
        },
        {
            source: 'Babet',
            target: 'Gueulemer',
            value: 6
        },
        {
            source: 'Babet',
            target: 'Valjean',
            value: 1
        },
        {
            source: 'Babet',
            target: 'Mme.Thenardier',
            value: 1
        },
        {
            source: 'Babet',
            target: 'Javert',
            value: 2
        },
        {
            source: 'Babet',
            target: 'Gavroche',
            value: 1
        },
        {
            source: 'Babet',
            target: 'Eponine',
            value: 1
        },
        {
            source: 'Claquesous',
            target: 'Thenardier',
            value: 4
        },
        {
            source: 'Claquesous',
            target: 'Babet',
            value: 4
        },
        {
            source: 'Claquesous',
            target: 'Gueulemer',
            value: 4
        },
        {
            source: 'Claquesous',
            target: 'Valjean',
            value: 1
        },
        {
            source: 'Claquesous',
            target: 'Mme.Thenardier',
            value: 1
        },
        {
            source: 'Claquesous',
            target: 'Javert',
            value: 1
        },
        {
            source: 'Claquesous',
            target: 'Eponine',
            value: 1
        },
        {
            source: 'Claquesous',
            target: 'Enjolras',
            value: 1
        },
        {
            source: 'Montparnasse',
            target: 'Javert',
            value: 1
        },
        {
            source: 'Montparnasse',
            target: 'Babet',
            value: 2
        },
        {
            source: 'Montparnasse',
            target: 'Gueulemer',
            value: 2
        },
        {
            source: 'Montparnasse',
            target: 'Claquesous',
            value: 2
        },
        {
            source: 'Montparnasse',
            target: 'Valjean',
            value: 1
        },
        {
            source: 'Montparnasse',
            target: 'Gavroche',
            value: 1
        },
        {
            source: 'Montparnasse',
            target: 'Eponine',
            value: 1
        },
        {
            source: 'Montparnasse',
            target: 'Thenardier',
            value: 1
        },
        {
            source: 'Toussaint',
            target: 'Cosette',
            value: 2
        },
        {
            source: 'Toussaint',
            target: 'Javert',
            value: 1
        },
        {
            source: 'Toussaint',
            target: 'Valjean',
            value: 1
        },
        {
            source: 'Child1',
            target: 'Gavroche',
            value: 2
        },
        {
            source: 'Child2',
            target: 'Gavroche',
            value: 2
        },
        {
            source: 'Child2',
            target: 'Child1',
            value: 3
        },
        {
            source: 'Brujon',
            target: 'Babet',
            value: 3
        },
        {
            source: 'Brujon',
            target: 'Gueulemer',
            value: 3
        },
        {
            source: 'Brujon',
            target: 'Thenardier',
            value: 3
        },
        {
            source: 'Brujon',
            target: 'Gavroche',
            value: 1
        },
        {
            source: 'Brujon',
            target: 'Eponine',
            value: 1
        },
        {
            source: 'Brujon',
            target: 'Claquesous',
            value: 1
        },
        {
            source: 'Brujon',
            target: 'Montparnasse',
            value: 1
        },
        {
            source: 'Mme.Hucheloup',
            target: 'Bossuet',
            value: 1
        },
        {
            source: 'Mme.Hucheloup',
            target: 'Joly',
            value: 1
        },
        {
            source: 'Mme.Hucheloup',
            target: 'Grantaire',
            value: 1
        },
        {
            source: 'Mme.Hucheloup',
            target: 'Bahorel',
            value: 1
        },
        {
            source: 'Mme.Hucheloup',
            target: 'Courfeyrac',
            value: 1
        },
        {
            source: 'Mme.Hucheloup',
            target: 'Gavroche',
            value: 1
        },
        {
            source: 'Mme.Hucheloup',
            target: 'Enjolras',
            value: 1
        }
    ]
};
var $73d17d24fbdba218$export$2e2bcd8739ae039 = $73d17d24fbdba218$var$lesMiserables;


const $2f3aca5dccaf0d4e$var$exoplanets = [
    {
        name: 'Jupiter',
        radius: 10.97,
        distance: 0
    },
    {
        name: 'Saturn',
        radius: 9.14,
        distance: 0
    },
    {
        name: 'Uranus',
        radius: 3.98,
        distance: 0
    },
    {
        name: 'Neptune',
        radius: 3.86,
        distance: 0
    },
    {
        name: 'Earth',
        radius: 1,
        distance: 0
    },
    {
        name: 'Venus',
        radius: 0.95,
        distance: 0
    },
    {
        name: 'Mars',
        radius: 0.532,
        distance: 0
    },
    {
        name: 'Mercury',
        radius: 0.383,
        distance: 0
    },
    {
        name: 'Pluto',
        radius: 0.181,
        distance: 0
    },
    {
        name: '11 Com b',
        radius: 12.64,
        distance: 110.6
    },
    {
        name: '11 UMi b',
        radius: 12.89,
        distance: 119.5
    },
    {
        name: '14 And b',
        radius: 13.18,
        distance: 76.4
    },
    {
        name: '14 Her b',
        radius: 13.24,
        distance: 18.1
    },
    {
        name: '16 Cyg B b',
        radius: 13.69,
        distance: 21.41
    },
    {
        name: '18 Del b',
        radius: 12.9,
        distance: 73.1
    },
    {
        name: '1RXS1609 b',
        radius: 19.04,
        distance: 145
    },
    {
        name: '24 Sex b',
        radius: 13.62,
        distance: 74.8
    },
    {
        name: '24 Sex c',
        radius: 13.99,
        distance: 74.8
    },
    {
        name: '2M 0103(AB) b',
        radius: 12.74,
        distance: 47.2
    },
    {
        name: '2M 0122-2439 b',
        radius: 12.74,
        distance: 36
    },
    {
        name: '2M 044144 b',
        radius: 13.04,
        distance: 140
    },
    {
        name: '2M 0746+20 b',
        radius: 10.86,
        distance: 12.21
    },
    {
        name: '2M 2140+16 b',
        radius: 10.3,
        distance: 25
    },
    {
        name: '2M 2206-20 b',
        radius: 14.56,
        distance: 26.67
    },
    {
        name: '2M1207 b',
        radius: 13.31,
        distance: 52.4
    },
    {
        name: '30 Ari B b',
        radius: 12.92,
        distance: 39.4
    },
    {
        name: '4 Uma b',
        radius: 13.06,
        distance: 78.5
    },
    {
        name: '42 Dra b',
        radius: 13.32,
        distance: 97.3
    },
    {
        name: '47 Uma b',
        radius: 13.51,
        distance: 13.97
    },
    {
        name: '47 Uma c',
        radius: 14.21,
        distance: 13.97
    },
    {
        name: '47 Uma d',
        radius: 13.7,
        distance: 13.97
    },
    {
        name: '51 Peg b',
        radius: 14.28,
        distance: 14.7
    },
    {
        name: '55 Cnc b',
        radius: 14.03,
        distance: 12.34
    },
    {
        name: '55 Cnc c',
        radius: 8.48,
        distance: 12.34
    },
    {
        name: '55 Cnc d',
        radius: 13.33,
        distance: 12.34
    },
    {
        name: '55 Cnc e',
        radius: 1.99,
        distance: 12.34
    },
    {
        name: '55 Cnc f',
        radius: 7.75,
        distance: 12.34
    },
    {
        name: '6 Lyn b',
        radius: 13.53,
        distance: 56.9
    },
    {
        name: '61 Vir b',
        radius: 1.89,
        distance: 8.52
    },
    {
        name: '61 Vir c',
        radius: 4.63,
        distance: 8.52
    },
    {
        name: '61 Vir d',
        radius: 5.26,
        distance: 8.52
    },
    {
        name: '7 CMa b',
        radius: 13.5,
        distance: 19.75
    },
    {
        name: '70 Vir b',
        radius: 13.09,
        distance: 22
    },
    {
        name: '75 Cet b',
        radius: 13.37,
        distance: 81.5
    },
    {
        name: '81 Cet b',
        radius: 13.19,
        distance: 97.2
    },
    {
        name: '91 Aqr b',
        radius: 13.41,
        distance: 45.9
    },
    {
        name: 'AB Pic b',
        radius: 12.79,
        distance: 47.3
    },
    {
        name: 'alf Ari b',
        radius: 13.66,
        distance: 20.2
    },
    {
        name: 'alf Cen B b',
        radius: 1.1,
        distance: 1.3
    },
    {
        name: 'BD +48 738 b',
        radius: 13.9,
        distance: null
    },
    {
        name: 'BD+15 2940 b',
        radius: 13.81,
        distance: 585
    },
    {
        name: 'BD+20 274 c',
        radius: 13.22,
        distance: null
    },
    {
        name: 'BD-061339 b',
        radius: 3.29,
        distance: 20
    },
    {
        name: 'BD-061339 c',
        radius: 9.22,
        distance: 20
    },
    {
        name: 'BD-082823 b',
        radius: 4.04,
        distance: 42.2
    },
    {
        name: 'BD-082823 c',
        radius: 14.44,
        distance: 42.2
    },
    {
        name: 'BD-10 3166 b',
        radius: 14.26,
        distance: 66
    },
    {
        name: 'BD-17 63 b',
        radius: 13.2,
        distance: 34.6
    },
    {
        name: 'BD14 4559 b',
        radius: 13.75,
        distance: 50
    },
    {
        name: 'BD20 2457 b',
        radius: 12.6,
        distance: 200
    },
    {
        name: 'BD20 2457 c',
        radius: 12.82,
        distance: 200
    },
    {
        name: 'beta Pic b',
        radius: 13.07,
        distance: 19.3
    },
    {
        name: 'CD-35 2722 b',
        radius: 12.44,
        distance: 21.3
    },
    {
        name: 'CFBDS 1458 b',
        radius: 13.1,
        distance: 23.1
    },
    {
        name: 'CHXR 73 b',
        radius: 12.78,
        distance: null
    },
    {
        name: 'CoRoT-1 b',
        radius: 16.69,
        distance: 460
    },
    {
        name: 'CoRoT-10 b',
        radius: 10.86,
        distance: 345
    },
    {
        name: 'CoRoT-11 b',
        radius: 16.02,
        distance: 560
    },
    {
        name: 'CoRoT-12 b',
        radius: 16.13,
        distance: 1150
    },
    {
        name: 'CoRoT-13 b',
        radius: 9.91,
        distance: 1310
    },
    {
        name: 'CoRoT-14 b',
        radius: 12.21,
        distance: 1340
    },
    {
        name: 'CoRoT-16 b',
        radius: 13.1,
        distance: 840
    },
    {
        name: 'CoRoT-17 b',
        radius: 11.42,
        distance: 920
    },
    {
        name: 'CoRoT-18 b',
        radius: 14.67,
        distance: 870
    },
    {
        name: 'CoRoT-19 b',
        radius: 14.45,
        distance: 800
    },
    {
        name: 'CoRoT-2 b',
        radius: 16.41,
        distance: 300
    },
    {
        name: 'CoRoT-20 b',
        radius: 9.41,
        distance: 1230
    },
    {
        name: 'CoRoT-21 b',
        radius: 14.56,
        distance: null
    },
    {
        name: 'CoRoT-23 b',
        radius: 12.1,
        distance: 600
    },
    {
        name: 'CoRoT-25 b',
        radius: 12.1,
        distance: 1000
    },
    {
        name: 'CoRoT-26 b',
        radius: 14.11,
        distance: 1670
    },
    {
        name: 'CoRoT-3 b',
        radius: 11.31,
        distance: 680
    },
    {
        name: 'CoRoT-4 b',
        radius: 13.33,
        distance: null
    },
    {
        name: 'CoRoT-5 b',
        radius: 14.9,
        distance: 400
    },
    {
        name: 'CoRoT-6 b',
        radius: 13.06,
        distance: null
    },
    {
        name: 'CoRoT-7 b',
        radius: 1.67,
        distance: 150
    },
    {
        name: 'CoRoT-7 c',
        radius: 2.43,
        distance: 150
    },
    {
        name: 'CoRoT-8 b',
        radius: 6.37,
        distance: 380
    },
    {
        name: 'CoRoT-9 b',
        radius: 10.53,
        distance: 460
    },
    {
        name: 'CT Cha b',
        radius: 24.64,
        distance: 165
    },
    {
        name: 'DH Tau b',
        radius: 12.81,
        distance: null
    },
    {
        name: 'DP Leo b',
        radius: 13.07,
        distance: null
    },
    {
        name: 'eps CrB b',
        radius: 13.02,
        distance: 67.9
    },
    {
        name: 'eps Eridani b',
        radius: 13.73,
        distance: 3.2
    },
    {
        name: 'eps Tau b',
        radius: 13.03,
        distance: 45
    },
    {
        name: 'Fomalhaut b',
        radius: 13.61,
        distance: 7.7
    },
    {
        name: 'FU Tau b',
        radius: 12.74,
        distance: 140
    },
    {
        name: 'gamma 1 Leo b',
        radius: 12.97,
        distance: 38.5
    },
    {
        name: 'gamma Cephei b',
        radius: 13.65,
        distance: 13.79
    },
    {
        name: 'GJ 1214 b',
        radius: 2.67,
        distance: 13
    },
    {
        name: 'GJ 163 b',
        radius: 3.71,
        distance: 15
    },
    {
        name: 'GJ 163 c',
        radius: 2.43,
        distance: 15
    },
    {
        name: 'Gj 163 d',
        radius: 5.58,
        distance: 15
    },
    {
        name: 'GJ 176 b',
        radius: 2.43,
        distance: 9.42
    },
    {
        name: 'GJ 3021 b',
        radius: 13.38,
        distance: 17.62
    },
    {
        name: 'GJ 317 b',
        radius: 13.66,
        distance: 15.1
    },
    {
        name: 'GJ 317 c',
        radius: 13.61,
        distance: 15.1
    },
    {
        name: 'GJ 328 b',
        radius: 13.49,
        distance: 19.8
    },
    {
        name: 'GJ 3470 b',
        radius: 4.19,
        distance: 30.7
    },
    {
        name: 'GJ 3634 b',
        radius: 2.2,
        distance: 19.8
    },
    {
        name: 'GJ 433 b',
        radius: 2.01,
        distance: 9.04
    },
    {
        name: 'GJ 433 c',
        radius: 7.63,
        distance: 9.04
    },
    {
        name: 'GJ 436 b',
        radius: 4.09,
        distance: 10.2
    },
    {
        name: 'GJ 504 b',
        radius: 13.24,
        distance: 17.56
    },
    {
        name: 'GJ 667C b',
        radius: 1.95,
        distance: 7.23
    },
    {
        name: 'GJ 667C c',
        radius: 1.74,
        distance: 7.23
    },
    {
        name: 'GJ 667C d',
        radius: 2.19,
        distance: 7.23
    },
    {
        name: 'GJ 667C e',
        radius: 1.52,
        distance: 7.23
    },
    {
        name: 'GJ 667C f',
        radius: 1.52,
        distance: 7.23
    },
    {
        name: 'GJ 667C g',
        radius: 1.93,
        distance: 7.23
    },
    {
        name: 'GJ 674 b',
        radius: 3.62,
        distance: 4.54
    },
    {
        name: 'GJ 676A b',
        radius: 13.21,
        distance: 16.45
    },
    {
        name: 'GJ 676A c',
        radius: 13.37,
        distance: 16.45
    },
    {
        name: 'GJ 676A d',
        radius: 1.9,
        distance: 16.45
    },
    {
        name: 'GJ 676A e',
        radius: 3.87,
        distance: 16.45
    },
    {
        name: 'GJ 832 b',
        radius: 14.13,
        distance: 4.94
    },
    {
        name: 'GJ 849 b',
        radius: 13.97,
        distance: 9.1
    },
    {
        name: 'GJ 849 c',
        radius: 13.98,
        distance: 9.1
    },
    {
        name: 'Gl 179 b',
        radius: 14.02,
        distance: 12.3
    },
    {
        name: 'Gl 581 b',
        radius: 4.29,
        distance: 6.21
    },
    {
        name: 'Gl 581 c',
        radius: 1.94,
        distance: 6.21
    },
    {
        name: 'Gl 581 d',
        radius: 2.05,
        distance: 6.21
    },
    {
        name: 'Gl 581 e',
        radius: 1.27,
        distance: 6.21
    },
    {
        name: 'Gl 649 b',
        radius: 14.44,
        distance: 10.34
    },
    {
        name: 'Gl 649 c',
        radius: 3.49,
        distance: 10.34
    },
    {
        name: 'Gl 86 b',
        radius: 13.31,
        distance: 10.9
    },
    {
        name: 'Gliese 876 b',
        radius: 13.56,
        distance: 4.7
    },
    {
        name: 'Gliese 876 c',
        radius: 14.08,
        distance: 4.7
    },
    {
        name: 'Gliese 876 d',
        radius: 2.15,
        distance: 4.7
    },
    {
        name: 'Gliese 876 e',
        radius: 4.09,
        distance: 4.7
    },
    {
        name: 'GQ Lup b',
        radius: 20.16,
        distance: 140
    },
    {
        name: 'GSC 06214-00210 b',
        radius: 12.69,
        distance: 145
    },
    {
        name: 'HAT-P-1 b',
        radius: 14.77,
        distance: 139
    },
    {
        name: 'HAT-P-11 b',
        radius: 4.73,
        distance: 38
    },
    {
        name: 'HAT-P-12 b',
        radius: 10.69,
        distance: 142.5
    },
    {
        name: 'HAT-P-13 b',
        radius: 14.34,
        distance: 214
    },
    {
        name: 'HAT-P-13 c',
        radius: 12.76,
        distance: 214
    },
    {
        name: 'HAT-P-14 b',
        radius: 13.44,
        distance: 205
    },
    {
        name: 'HAT-P-15 b',
        radius: 12.01,
        distance: 190
    },
    {
        name: 'HAT-P-16 b',
        radius: 14.44,
        distance: 235
    },
    {
        name: 'HAT-P-17 b',
        radius: 11.31,
        distance: 90
    },
    {
        name: 'HAT-P-17 c',
        radius: 13.77,
        distance: 90
    },
    {
        name: 'HAT-P-18 b',
        radius: 11.09,
        distance: 166
    },
    {
        name: 'HAT-P-19 b',
        radius: 12.68,
        distance: 215
    },
    {
        name: 'HAT-P-2 b',
        radius: 10.65,
        distance: 118
    },
    {
        name: 'HAT-P-20 b',
        radius: 9.71,
        distance: 70
    },
    {
        name: 'HAT-P-21 b',
        radius: 11.47,
        distance: 254
    },
    {
        name: 'HAT-P-22 b',
        radius: 12.1,
        distance: 82
    },
    {
        name: 'HAT-P-23 b',
        radius: 15.32,
        distance: 393
    },
    {
        name: 'HAT-P-24 b',
        radius: 13.91,
        distance: 306
    },
    {
        name: 'HAT-P-25 b',
        radius: 13.33,
        distance: 297
    },
    {
        name: 'HAT-P-26 b',
        radius: 6.32,
        distance: 134
    },
    {
        name: 'HAT-P-27-WASP-40 b',
        radius: 11.82,
        distance: 204
    },
    {
        name: 'HAT-P-28 b',
        radius: 13.57,
        distance: 395
    },
    {
        name: 'HAT-P-29 b',
        radius: 12.4,
        distance: 322
    },
    {
        name: 'HAT-P-3 b',
        radius: 9.26,
        distance: 130
    },
    {
        name: 'HAT-P-30-WASP-51 b',
        radius: 15.01,
        distance: 193
    },
    {
        name: 'HAT-P-31 b',
        radius: 11.98,
        distance: 354
    },
    {
        name: 'HAT-P-32 b',
        radius: 22.81,
        distance: 320
    },
    {
        name: 'HAT-P-33 b',
        radius: 20.46,
        distance: 419
    },
    {
        name: 'HAT-P-34 b',
        radius: 12.4,
        distance: 257
    },
    {
        name: 'HAT-P-35 b',
        radius: 14.92,
        distance: 535
    },
    {
        name: 'HAT-P-36 b',
        radius: 14.16,
        distance: 317
    },
    {
        name: 'HAT-P-37 b',
        radius: 13.19,
        distance: 411
    },
    {
        name: 'HAT-P-38 b',
        radius: 9.24,
        distance: 249
    },
    {
        name: 'HAT-P-39 b',
        radius: 17.6,
        distance: 642
    },
    {
        name: 'HAT-P-4 b',
        radius: 14.22,
        distance: 310
    },
    {
        name: 'HAT-P-40 b',
        radius: 19.38,
        distance: 501
    },
    {
        name: 'HAT-P-41 b',
        radius: 17.12,
        distance: 311
    },
    {
        name: 'HAT-P-42 b',
        radius: 14.3,
        distance: 447
    },
    {
        name: 'HAT-P-43 b',
        radius: 14.37,
        distance: 543
    },
    {
        name: 'HAT-P-44 b',
        radius: 14.34,
        distance: 374
    },
    {
        name: 'HAT-P-44 c',
        radius: 13.65,
        distance: 374
    },
    {
        name: 'HAT-P-45 b',
        radius: 15.97,
        distance: 305
    },
    {
        name: 'HAT-P-46 b',
        radius: 14.38,
        distance: 296
    },
    {
        name: 'HAT-P-46 c',
        radius: 13.55,
        distance: 296
    },
    {
        name: 'HAT-P-5 b',
        radius: 14.02,
        distance: 340
    },
    {
        name: 'HAT-P-6 b',
        radius: 14.9,
        distance: 200
    },
    {
        name: 'HAT-P-7 b',
        radius: 15.92,
        distance: 320
    },
    {
        name: 'HAT-P-8 b',
        radius: 16.8,
        distance: 230
    },
    {
        name: 'HAT-P-9 b',
        radius: 15.68,
        distance: 480
    },
    {
        name: 'HATS-1 b',
        radius: 14.58,
        distance: 303
    },
    {
        name: 'HATS-2 b',
        radius: 13.08,
        distance: 360
    },
    {
        name: 'HATS-3 b',
        radius: 15.47,
        distance: 453
    },
    {
        name: 'HD 100655 b',
        radius: 13.69,
        distance: 122
    },
    {
        name: 'HD 100777 b',
        radius: 13.86,
        distance: 52.8
    },
    {
        name: 'HD 10180 c',
        radius: 3.85,
        distance: 39.4
    },
    {
        name: 'HD 10180 d',
        radius: 3.62,
        distance: 39.4
    },
    {
        name: 'HD 10180 e',
        radius: 5.54,
        distance: 39.4
    },
    {
        name: 'HD 10180 f',
        radius: 5.39,
        distance: 39.4
    },
    {
        name: 'HD 10180 g',
        radius: 5.06,
        distance: 39.4
    },
    {
        name: 'HD 10180 h',
        radius: 9.38,
        distance: 39.4
    },
    {
        name: 'HD 101930 b',
        radius: 11.69,
        distance: 30.49
    },
    {
        name: 'HD 102117 b',
        radius: 8.56,
        distance: 42
    },
    {
        name: 'HD 102195 b',
        radius: 14.3,
        distance: 28.98
    },
    {
        name: 'HD 102272 b',
        radius: 13.14,
        distance: 360
    },
    {
        name: 'HD 102272 c',
        radius: 13.5,
        distance: 360
    },
    {
        name: 'HD 102329 b',
        radius: 13.14,
        distance: 158
    },
    {
        name: 'HD 102365 b',
        radius: 4.29,
        distance: 9.24
    },
    {
        name: 'HD 102956 b',
        radius: 13.94,
        distance: 126
    },
    {
        name: 'HD 103197 b',
        radius: 6.25,
        distance: 49.3
    },
    {
        name: 'HD 103774 b',
        radius: 14.32,
        distance: 55
    },
    {
        name: 'HD 104067 b',
        radius: 8.95,
        distance: 20.8
    },
    {
        name: 'HD 104985 b',
        radius: 13.11,
        distance: 102
    },
    {
        name: 'HD 106252 b',
        radius: 13.03,
        distance: 37.44
    },
    {
        name: 'HD 106270 b',
        radius: 12.87,
        distance: 84.9
    },
    {
        name: 'HD 10647 b',
        radius: 13.96,
        distance: 17.3
    },
    {
        name: 'HD 106515A b',
        radius: 12.87,
        distance: 35.2
    },
    {
        name: 'HD 10697 b',
        radius: 13.11,
        distance: 32.56
    },
    {
        name: 'HD 107148 b',
        radius: 9.57,
        distance: 51.3
    },
    {
        name: 'HD 108147 b',
        radius: 10.81,
        distance: 38.57
    },
    {
        name: 'HD 108863 b',
        radius: 13.5,
        distance: 139
    },
    {
        name: 'HD 108874 b',
        radius: 13.79,
        distance: 68.5
    },
    {
        name: 'HD 108874 c',
        radius: 13.92,
        distance: 68.5
    },
    {
        name: 'HD 109246 b',
        radius: 14.05,
        distance: 65.6
    },
    {
        name: 'HD 109271 b',
        radius: 4.85,
        distance: 62
    },
    {
        name: 'HD 109271 c',
        radius: 5.87,
        distance: 62
    },
    {
        name: 'HD 109749 b',
        radius: 11.25,
        distance: 59
    },
    {
        name: 'HD 110014 b',
        radius: 12.87,
        distance: 90
    },
    {
        name: 'HD 111232 b',
        radius: 13.08,
        distance: 29
    },
    {
        name: 'HD 113337 b',
        radius: 13.4,
        distance: 36.9
    },
    {
        name: 'HD 113538 b',
        radius: 11.02,
        distance: 15.8
    },
    {
        name: 'HD 113538 c',
        radius: 14.08,
        distance: 15.8
    },
    {
        name: 'HD 114386 b',
        radius: 13.83,
        distance: 28
    },
    {
        name: 'HD 114386 c',
        radius: 13.78,
        distance: 28
    },
    {
        name: 'HD 114729 b',
        radius: 14.01,
        distance: 35
    },
    {
        name: 'HD 114762 b',
        radius: 12.87,
        distance: 39.46
    },
    {
        name: 'HD 114783 b',
        radius: 13.93,
        distance: 20.4
    },
    {
        name: 'HD 11506 b',
        radius: 13.37,
        distance: 53.82
    },
    {
        name: 'HD 11506 c',
        radius: 14.02,
        distance: 53.82
    },
    {
        name: 'HD 116029 b',
        radius: 13.59,
        distance: 123.2
    },
    {
        name: 'HD 117207 b',
        radius: 13.6,
        distance: 33
    },
    {
        name: 'HD 117618 b',
        radius: 8.73,
        distance: 38
    },
    {
        name: 'HD 117618 c',
        radius: 10.1,
        distance: 38
    },
    {
        name: 'HD 118203 b',
        radius: 13.59,
        distance: 88.6
    },
    {
        name: 'HD 11964 b',
        radius: 14.14,
        distance: 33.98
    },
    {
        name: 'HD 11964 c',
        radius: 5.54,
        distance: 33.98
    },
    {
        name: 'HD 11977 b',
        radius: 13.09,
        distance: 66.5
    },
    {
        name: 'HD 120084 b',
        radius: 13.19,
        distance: 97.7
    },
    {
        name: 'HD 121504 b',
        radius: 13.84,
        distance: 44.37
    },
    {
        name: 'HD 122430 b',
        radius: 13.34,
        distance: 135
    },
    {
        name: 'HD 125595 b',
        radius: 3.89,
        distance: 27.4
    },
    {
        name: 'HD 125612 b',
        radius: 13.43,
        distance: 52.82
    },
    {
        name: 'HD 125612 c',
        radius: 4.66,
        distance: 52.82
    },
    {
        name: 'HD 125612 d',
        radius: 13.05,
        distance: 52.82
    },
    {
        name: 'HD 126525 b',
        radius: 9.93,
        distance: 38.1
    },
    {
        name: 'HD 12661 b',
        radius: 13.55,
        distance: 37.16
    },
    {
        name: 'HD 12661 c',
        radius: 13.72,
        distance: 37.16
    },
    {
        name: 'HD 126614 b',
        radius: 14.37,
        distance: 72.4
    },
    {
        name: 'HD 128311 b',
        radius: 13.57,
        distance: 16.6
    },
    {
        name: 'HD 128311 c',
        radius: 13.4,
        distance: 16.6
    },
    {
        name: 'HD 129445 b',
        radius: 13.71,
        distance: 67.61
    },
    {
        name: 'HD 130322 b',
        radius: 13.92,
        distance: 30
    },
    {
        name: 'HD 131496 b',
        radius: 13.57,
        distance: 110
    },
    {
        name: 'HD 13189 b',
        radius: 12.77,
        distance: 185
    },
    {
        name: 'HD 132406 b',
        radius: 13.16,
        distance: 71
    },
    {
        name: 'HD 132563B b',
        radius: 13.75,
        distance: 96
    },
    {
        name: 'HD 134060 b',
        radius: 3.52,
        distance: 24.2
    },
    {
        name: 'HD 134060 c',
        radius: 7.95,
        distance: 24.2
    },
    {
        name: 'HD 134606 b',
        radius: 2.57,
        distance: 26.5
    },
    {
        name: 'HD 134606 c',
        radius: 3.69,
        distance: 26.5
    },
    {
        name: 'HD 134606 d',
        radius: 7.03,
        distance: 26.5
    },
    {
        name: 'HD 134987 b',
        radius: 13.72,
        distance: 22.2
    },
    {
        name: 'HD 134987 c',
        radius: 14.02,
        distance: 22.2
    },
    {
        name: 'HD 136352 b',
        radius: 1.92,
        distance: 14.8
    },
    {
        name: 'HD 136352 c',
        radius: 3.56,
        distance: 14.8
    },
    {
        name: 'HD 136352 d',
        radius: 3.22,
        distance: 14.8
    },
    {
        name: 'HD 136418 b',
        radius: 13.61,
        distance: 98.2
    },
    {
        name: 'HD 137388 b',
        radius: 9.9,
        distance: 38
    },
    {
        name: 'HD 13808 b',
        radius: 3.37,
        distance: 28.6
    },
    {
        name: 'HD 13808 c',
        radius: 3.57,
        distance: 28.6
    },
    {
        name: 'HD 13908 b',
        radius: 13.93,
        distance: 71.2
    },
    {
        name: 'HD 13908 c',
        radius: 13.14,
        distance: 71.2
    },
    {
        name: 'HD 13931 b',
        radius: 13.64,
        distance: 44.2
    },
    {
        name: 'HD 139357 b',
        radius: 12.92,
        distance: 121.4
    },
    {
        name: 'HD 141937 b',
        radius: 12.93,
        distance: 33.46
    },
    {
        name: 'HD 142 b',
        radius: 13.82,
        distance: 20.6
    },
    {
        name: 'HD 142 c',
        radius: 13.19,
        distance: 20.6
    },
    {
        name: 'HD 142022 A b',
        radius: 13.2,
        distance: 35.87
    },
    {
        name: 'HD 142245 b',
        radius: 13.64,
        distance: 109.5
    },
    {
        name: 'HD 142415 b',
        radius: 13.71,
        distance: 34.2
    },
    {
        name: 'HD 143361 b',
        radius: 13.42,
        distance: 59.35
    },
    {
        name: 'HD 145377 b',
        radius: 13.15,
        distance: 57.7
    },
    {
        name: 'HD 145457 b',
        radius: 13.45,
        distance: 126
    },
    {
        name: 'HD 1461 b',
        radius: 2.3,
        distance: 23.4
    },
    {
        name: 'HD 1461 c',
        radius: 2.03,
        distance: 23.4
    },
    {
        name: 'HD 147018 b',
        radius: 13.59,
        distance: 42.96
    },
    {
        name: 'HD 147018 c',
        radius: 13.09,
        distance: 42.96
    },
    {
        name: 'HD 147513 b',
        radius: 13.84,
        distance: 12.9
    },
    {
        name: 'HD 148156 b',
        radius: 14,
        distance: 53.05
    },
    {
        name: 'HD 148427 b',
        radius: 13.94,
        distance: 59.3
    },
    {
        name: 'HD 149026 b',
        radius: 8.04,
        distance: 78.9
    },
    {
        name: 'HD 149143 b',
        radius: 13.79,
        distance: 63
    },
    {
        name: 'HD 1502 b',
        radius: 13.42,
        distance: 159
    },
    {
        name: 'HD 150433 b',
        radius: 8.45,
        distance: 29.6
    },
    {
        name: 'HD 150706 b',
        radius: 13.48,
        distance: 27.2
    },
    {
        name: 'HD 152079 b',
        radius: 13.43,
        distance: 85.17
    },
    {
        name: 'HD 152581 b',
        radius: 13.74,
        distance: 186
    },
    {
        name: 'HD 153950 b',
        radius: 13.48,
        distance: 49.6
    },
    {
        name: 'HD 154088 b',
        radius: 2.06,
        distance: 17.8
    },
    {
        name: 'HD 154345 b',
        radius: 13.93,
        distance: 18.06
    },
    {
        name: 'HD 154672 b',
        radius: 13.21,
        distance: 65.8
    },
    {
        name: 'HD 154857 b',
        radius: 13.66,
        distance: 68.5
    },
    {
        name: 'HD 155358 b',
        radius: 14,
        distance: 43
    },
    {
        name: 'HD 155358 c',
        radius: 14.02,
        distance: 43
    },
    {
        name: 'HD 156279 b',
        radius: 12.93,
        distance: 36.6
    },
    {
        name: 'HD 156411 b',
        radius: 14.06,
        distance: 55.1
    },
    {
        name: 'HD 156668 b',
        radius: 1.72,
        distance: 24.5
    },
    {
        name: 'HD 157172 b',
        radius: 7,
        distance: 31.9
    },
    {
        name: 'HD 158038 b',
        radius: 13.66,
        distance: 103.6
    },
    {
        name: 'HD 159243 b',
        radius: 13.81,
        distance: 69.2
    },
    {
        name: 'HD 159243 c',
        radius: 13.57,
        distance: 69.2
    },
    {
        name: 'HD 159868 b',
        radius: 13.59,
        distance: 52.7
    },
    {
        name: 'HD 159868 c',
        radius: 14.07,
        distance: 52.7
    },
    {
        name: 'HD 16141 b',
        radius: 9.7,
        distance: 35.9
    },
    {
        name: 'HD 16175 b',
        radius: 13.27,
        distance: 59.8
    },
    {
        name: 'HD 162020 b',
        radius: 12.76,
        distance: 31.26
    },
    {
        name: 'HD 163607 b',
        radius: 14.05,
        distance: 69
    },
    {
        name: 'HD 163607 c',
        radius: 13.55,
        distance: 69
    },
    {
        name: 'HD 16417 b',
        radius: 5.13,
        distance: 25.5
    },
    {
        name: 'HD 164509 b',
        radius: 14.26,
        distance: 52
    },
    {
        name: 'HD 164604 b',
        radius: 13.48,
        distance: 38
    },
    {
        name: 'HD 164922 b',
        radius: 14.4,
        distance: 21.93
    },
    {
        name: 'HD 166724 b',
        radius: 13.3,
        distance: 42.3
    },
    {
        name: 'HD 167042 b',
        radius: 13.71,
        distance: 50
    },
    {
        name: 'HD 168443 b',
        radius: 13.03,
        distance: 37.38
    },
    {
        name: 'HD 168443 c',
        radius: 12.69,
        distance: 37.38
    },
    {
        name: 'HD 168746 b',
        radius: 10.07,
        distance: 43.12
    },
    {
        name: 'HD 1690 b',
        radius: 13.12,
        distance: 319
    },
    {
        name: 'HD 169830 b',
        radius: 13.45,
        distance: 36.32
    },
    {
        name: 'HD 169830 c',
        radius: 13.3,
        distance: 36.32
    },
    {
        name: 'HD 170469 b',
        radius: 14.11,
        distance: 64.97
    },
    {
        name: 'HD 17092 b',
        radius: 13.25,
        distance: 109
    },
    {
        name: 'HD 171028 b',
        radius: 13.62,
        distance: 90
    },
    {
        name: 'HD 171238 b',
        radius: 13.5,
        distance: 50.28
    },
    {
        name: 'HD 17156 b',
        radius: 12.26,
        distance: 78.24
    },
    {
        name: 'HD 173416 b',
        radius: 13.48,
        distance: 135
    },
    {
        name: 'HD 175167 b',
        radius: 13.02,
        distance: 67.02
    },
    {
        name: 'HD 175541 b',
        radius: 14.15,
        distance: 128
    },
    {
        name: 'HD 176051 b',
        radius: 13.74,
        distance: 14.99
    },
    {
        name: 'HD 177830 b',
        radius: 13.75,
        distance: 59
    },
    {
        name: 'HD 177830 c',
        radius: 7.93,
        distance: 59
    },
    {
        name: 'HD 178911 B b',
        radius: 13.11,
        distance: 46.73
    },
    {
        name: 'HD 179079 b',
        radius: 5.58,
        distance: 63.69
    },
    {
        name: 'HD 179949 b',
        radius: 13.95,
        distance: 27
    },
    {
        name: 'HD 180314 b',
        radius: 12.58,
        distance: 132
    },
    {
        name: 'HD 180902 b',
        radius: 13.71,
        distance: 110
    },
    {
        name: 'HD 181342 b',
        radius: 13.39,
        distance: 110.6
    },
    {
        name: 'HD 181433 b',
        radius: 2.3,
        distance: 26.15
    },
    {
        name: 'HD 181433 c',
        radius: 14.13,
        distance: 26.15
    },
    {
        name: 'HD 181433 d',
        radius: 14.21,
        distance: 26.15
    },
    {
        name: 'HD 181720 b',
        radius: 14.39,
        distance: 56
    },
    {
        name: 'HD 183263 b',
        radius: 13.35,
        distance: 53
    },
    {
        name: 'HD 183263 c',
        radius: 13.33,
        distance: 53
    },
    {
        name: 'HD 185269 b',
        radius: 13.95,
        distance: 47
    },
    {
        name: 'HD 187085 b',
        radius: 14.06,
        distance: 44.98
    },
    {
        name: 'HD 187123 b',
        radius: 14.23,
        distance: 50
    },
    {
        name: 'HD 187123 c',
        radius: 13.62,
        distance: 50
    },
    {
        name: 'HD 18742 b',
        radius: 13.48,
        distance: 135
    },
    {
        name: 'HD 188015 b',
        radius: 13.82,
        distance: 52.6
    },
    {
        name: 'HD 189567 b',
        radius: 3.32,
        distance: 17.7
    },
    {
        name: 'HD 189733 b',
        radius: 12.75,
        distance: 19.3
    },
    {
        name: 'HD 190360 b',
        radius: 13.74,
        distance: 15.89
    },
    {
        name: 'HD 190360 c',
        radius: 4.61,
        distance: 15.89
    },
    {
        name: 'HD 190647 b',
        radius: 13.64,
        distance: 54.2
    },
    {
        name: 'HD 190984 b',
        radius: 13.42,
        distance: 103
    },
    {
        name: 'HD 192263 b',
        radius: 14.07,
        distance: 19.9
    },
    {
        name: 'HD 192310 b',
        radius: 4.43,
        distance: 8.82
    },
    {
        name: 'HD 192310 c',
        radius: 5.38,
        distance: 8.82
    },
    {
        name: 'HD 192699 b',
        radius: 13.51,
        distance: 67
    },
    {
        name: 'HD 195019 b',
        radius: 13.34,
        distance: 37.36
    },
    {
        name: 'HD 196050 b',
        radius: 13.46,
        distance: 46.9
    },
    {
        name: 'HD 196067 b',
        radius: 13.01,
        distance: 44.3
    },
    {
        name: 'HD 196885 A b',
        radius: 13.44,
        distance: 33
    },
    {
        name: 'HD 197037 b',
        radius: 14.03,
        distance: 33
    },
    {
        name: 'HD 19994 b',
        radius: 13.69,
        distance: 22.38
    },
    {
        name: 'HD 20003 b',
        radius: 3.67,
        distance: 43.8
    },
    {
        name: 'HD 20003 c',
        radius: 3.9,
        distance: 43.8
    },
    {
        name: 'HD 200964 b',
        radius: 13.65,
        distance: 68.4
    },
    {
        name: 'HD 200964 c',
        radius: 13.97,
        distance: 68.4
    },
    {
        name: 'HD 202206 b',
        radius: 12.68,
        distance: 46.34
    },
    {
        name: 'HD 202206 c',
        radius: 13.52,
        distance: 46.34
    },
    {
        name: 'HD 20367 b',
        radius: 13.9,
        distance: 27
    },
    {
        name: 'HD 2039 b',
        radius: 13.22,
        distance: 89.8
    },
    {
        name: 'HD 204313 b',
        radius: 13.36,
        distance: 47.37
    },
    {
        name: 'HD 204313 c',
        radius: 4.48,
        distance: 47.37
    },
    {
        name: 'HD 204313 d',
        radius: 13.69,
        distance: 47.37
    },
    {
        name: 'HD 204941 b',
        radius: 10.93,
        distance: 27
    },
    {
        name: 'HD 205739 b',
        radius: 13.78,
        distance: 90.3
    },
    {
        name: 'HD 206610 b',
        radius: 13.57,
        distance: 194
    },
    {
        name: 'HD 20781 b',
        radius: 3.67,
        distance: 35.4
    },
    {
        name: 'HD 20781 c',
        radius: 4.27,
        distance: 35.4
    },
    {
        name: 'HD 20782 b',
        radius: 13.64,
        distance: 36.02
    },
    {
        name: 'HD 207832 b',
        radius: 14.13,
        distance: 54.4
    },
    {
        name: 'HD 207832 c',
        radius: 14,
        distance: 54.4
    },
    {
        name: 'HD 20794 b',
        radius: 1.44,
        distance: 6.06
    },
    {
        name: 'HD 20794 c',
        radius: 1.38,
        distance: 6.06
    },
    {
        name: 'HD 20794 d',
        radius: 1.83,
        distance: 6.06
    },
    {
        name: 'HD 208487 b',
        radius: 14.34,
        distance: 45
    },
    {
        name: 'HD 208527 b',
        radius: 12.86,
        distance: 320.2
    },
    {
        name: 'HD 20868 b',
        radius: 13.62,
        distance: 48.9
    },
    {
        name: 'HD 209458 b',
        radius: 15.46,
        distance: 47
    },
    {
        name: 'HD 210277 b',
        radius: 13.83,
        distance: 21.29
    },
    {
        name: 'HD 210702 b',
        radius: 13.64,
        distance: 56
    },
    {
        name: 'HD 212301 b',
        radius: 14.3,
        distance: 52.7
    },
    {
        name: 'HD 212771 b',
        radius: 13.55,
        distance: 131
    },
    {
        name: 'HD 213240 b',
        radius: 13.26,
        distance: 40.75
    },
    {
        name: 'HD 215152 b',
        radius: 1.45,
        distance: 21.5
    },
    {
        name: 'HD 215152 c',
        radius: 1.52,
        distance: 21.5
    },
    {
        name: 'HD 215456 b',
        radius: 6.35,
        distance: 38
    },
    {
        name: 'HD 215456 c',
        radius: 10.46,
        distance: 38
    },
    {
        name: 'HD 215497 b',
        radius: 2.1,
        distance: 44
    },
    {
        name: 'HD 215497 c',
        radius: 14.44,
        distance: 44
    },
    {
        name: 'HD 216435 b',
        radius: 13.82,
        distance: 33.3
    },
    {
        name: 'HD 216437 b',
        radius: 13.66,
        distance: 26.5
    },
    {
        name: 'HD 216770 b',
        radius: 14.12,
        distance: 38
    },
    {
        name: 'HD 21693 b',
        radius: 3.35,
        distance: 32.4
    },
    {
        name: 'HD 21693 c',
        radius: 4.95,
        distance: 32.4
    },
    {
        name: 'HD 217107 b',
        radius: 13.8,
        distance: 19.72
    },
    {
        name: 'HD 217107 c',
        radius: 13.52,
        distance: 19.72
    },
    {
        name: 'HD 217786 b',
        radius: 12.8,
        distance: 54.8
    },
    {
        name: 'HD 218566 b',
        radius: 9.57,
        distance: 29.94
    },
    {
        name: 'HD 219077 b',
        radius: 12.84,
        distance: 29.35
    },
    {
        name: 'HD 219415 b',
        radius: 13.86,
        distance: null
    },
    {
        name: 'HD 219828 b',
        radius: 5.01,
        distance: 81.1
    },
    {
        name: 'HD 220074 b',
        radius: 12.81,
        distance: 290.2
    },
    {
        name: 'HD 220689 b',
        radius: 13.83,
        distance: 44.6
    },
    {
        name: 'HD 220773 b',
        radius: 13.76,
        distance: 49
    },
    {
        name: 'HD 221287 b',
        radius: 13.42,
        distance: 52.9
    },
    {
        name: 'HD 222155 b',
        radius: 13.64,
        distance: 49.1
    },
    {
        name: 'HD 222582 b',
        radius: 13.02,
        distance: 42
    },
    {
        name: 'HD 224693 b',
        radius: 14.08,
        distance: 94
    },
    {
        name: 'HD 22781 b',
        radius: 12.78,
        distance: 31.79
    },
    {
        name: 'HD 23079 b',
        radius: 13.51,
        distance: 34.8
    },
    {
        name: 'HD 23127 b',
        radius: 13.74,
        distance: 89.1
    },
    {
        name: 'HD 231701 b',
        radius: 13.89,
        distance: 108.4
    },
    {
        name: 'HD 233604 b',
        radius: 13.03,
        distance: null
    },
    {
        name: 'HD 23596 b',
        radius: 13,
        distance: 52
    },
    {
        name: 'HD 240210 b',
        radius: 13.07,
        distance: 143
    },
    {
        name: 'HD 240237 b',
        radius: 13.19,
        distance: 1500
    },
    {
        name: 'HD 24040 b',
        radius: 13.31,
        distance: 46.51
    },
    {
        name: 'HD 25171 b',
        radius: 13.95,
        distance: 55
    },
    {
        name: 'HD 2638 b',
        radius: 14.26,
        distance: 53.71
    },
    {
        name: 'HD 27442 b',
        radius: 13.79,
        distance: 18.1
    },
    {
        name: 'HD 27631 b',
        radius: 13.69,
        distance: 45.5
    },
    {
        name: 'HD 27894 b',
        radius: 14.15,
        distance: 42.37
    },
    {
        name: 'HD 28185 b',
        radius: 13.15,
        distance: 39.4
    },
    {
        name: 'HD 28254 b',
        radius: 13.86,
        distance: 56.2
    },
    {
        name: 'HD 285507 b',
        radius: 13.9,
        distance: 41.3
    },
    {
        name: 'HD 28678 b',
        radius: 13.69,
        distance: 227
    },
    {
        name: 'HD 290327 b',
        radius: 13.51,
        distance: 54.9
    },
    {
        name: 'HD 2952 b',
        radius: 13.65,
        distance: 115.2
    },
    {
        name: 'HD 30177 b',
        radius: 13.02,
        distance: 55
    },
    {
        name: 'HD 30562 b',
        radius: 13.81,
        distance: 26.5
    },
    {
        name: 'HD 30856 b',
        radius: 13.66,
        distance: 118.1
    },
    {
        name: 'HD 31253 b',
        radius: 14.25,
        distance: 53.82
    },
    {
        name: 'HD 31527 b',
        radius: 3.58,
        distance: 38.6
    },
    {
        name: 'HD 31527 c',
        radius: 4.28,
        distance: 38.6
    },
    {
        name: 'HD 31527 d',
        radius: 4.38,
        distance: 38.6
    },
    {
        name: 'HD 32518 b',
        radius: 13.43,
        distance: 117.4
    },
    {
        name: 'HD 330075 b',
        radius: 14.15,
        distance: 50.2
    },
    {
        name: 'HD 33142 b',
        radius: 13.81,
        distance: 126
    },
    {
        name: 'HD 33283 b',
        radius: 14.44,
        distance: 86
    },
    {
        name: 'HD 33564 b',
        radius: 12.95,
        distance: 20.98
    },
    {
        name: 'HD 34445 b',
        radius: 14.03,
        distance: 46.5
    },
    {
        name: 'HD 3651 b',
        radius: 9.32,
        distance: 11
    },
    {
        name: 'HD 3651 c',
        radius: 6.46,
        distance: 11
    },
    {
        name: 'HD 37124 b',
        radius: 14.11,
        distance: 33
    },
    {
        name: 'HD 37124 c',
        radius: 14.12,
        distance: 33
    },
    {
        name: 'HD 37124 d',
        radius: 14.09,
        distance: 33
    },
    {
        name: 'HD 37605 b',
        radius: 13.46,
        distance: 44
    },
    {
        name: 'HD 37605 c',
        radius: 13.32,
        distance: 44
    },
    {
        name: 'HD 38283 b',
        radius: 14.43,
        distance: 37.7
    },
    {
        name: 'HD 38529 b',
        radius: 14.04,
        distance: 39.28
    },
    {
        name: 'HD 38529 c',
        radius: 12.67,
        distance: 39.28
    },
    {
        name: 'HD 38801 b',
        radius: 12.89,
        distance: 99.4
    },
    {
        name: 'HD 38858 b',
        radius: 6.18,
        distance: 15.2
    },
    {
        name: 'HD 39091 b',
        radius: 12.9,
        distance: 18.32
    },
    {
        name: 'HD 39194 b',
        radius: 1.64,
        distance: 25.9
    },
    {
        name: 'HD 39194 c',
        radius: 2.03,
        distance: 25.9
    },
    {
        name: 'HD 39194 d',
        radius: 1.9,
        distance: 25.9
    },
    {
        name: 'HD 40307 b',
        radius: 1.69,
        distance: 12.8
    },
    {
        name: 'HD 40307 c',
        radius: 2.14,
        distance: 12.8
    },
    {
        name: 'HD 40307 d',
        radius: 3.21,
        distance: 12.8
    },
    {
        name: 'HD 40307 e',
        radius: 1.7,
        distance: 12.8
    },
    {
        name: 'HD 40307 f',
        radius: 2.04,
        distance: 12.8
    },
    {
        name: 'HD 40307 g',
        radius: 2.39,
        distance: 12.8
    },
    {
        name: 'HD 40979 b',
        radius: 13.39,
        distance: 33.3
    },
    {
        name: 'HD 41004 A b',
        radius: 13.51,
        distance: 42.5
    },
    {
        name: 'HD 41004 B b',
        radius: 12.66,
        distance: 43.03
    },
    {
        name: 'HD 4113 b',
        radius: 13.72,
        distance: 44
    },
    {
        name: 'HD 41248 b',
        radius: 4.03,
        distance: 52.38
    },
    {
        name: 'HD 41248 c',
        radius: 3.3,
        distance: 52.38
    },
    {
        name: 'HD 4203 b',
        radius: 13.6,
        distance: 77.5
    },
    {
        name: 'HD 4208 b',
        radius: 14.03,
        distance: 33.9
    },
    {
        name: 'HD 4308 b',
        radius: 3.81,
        distance: 21.9
    },
    {
        name: 'HD 4313 b',
        radius: 13.55,
        distance: 137
    },
    {
        name: 'HD 43197 b',
        radius: 14.16,
        distance: 54.9
    },
    {
        name: 'HD 43691 b',
        radius: 13.52,
        distance: 93.2
    },
    {
        name: 'HD 44219 b',
        radius: 14.18,
        distance: 50.43
    },
    {
        name: 'HD 45184 b',
        radius: 3.78,
        distance: 21.9
    },
    {
        name: 'HD 45350 b',
        radius: 13.66,
        distance: 49
    },
    {
        name: 'HD 45364 b',
        radius: 8.98,
        distance: 32.6
    },
    {
        name: 'HD 45364 c',
        radius: 14.12,
        distance: 32.6
    },
    {
        name: 'HD 45652 b',
        radius: 14.27,
        distance: 36
    },
    {
        name: 'HD 46375 b',
        radius: 10.53,
        distance: 33.4
    },
    {
        name: 'HD 47186 b',
        radius: 5.24,
        distance: 37.84
    },
    {
        name: 'HD 47186 c',
        radius: 14.41,
        distance: 37.84
    },
    {
        name: 'HD 47536 b',
        radius: 13.21,
        distance: 121.36
    },
    {
        name: 'HD 47536 c',
        radius: 13,
        distance: 121.36
    },
    {
        name: 'HD 48265 b',
        radius: 13.86,
        distance: 87.4
    },
    {
        name: 'HD 49674 b',
        radius: 6.83,
        distance: 40.7
    },
    {
        name: 'HD 50499 b',
        radius: 13.68,
        distance: 47.26
    },
    {
        name: 'HD 50554 b',
        radius: 13.2,
        distance: 31.03
    },
    {
        name: 'HD 51608 b',
        radius: 3.85,
        distance: 34.8
    },
    {
        name: 'HD 51608 c',
        radius: 4.59,
        distance: 34.8
    },
    {
        name: 'HD 52265 b',
        radius: 13.9,
        distance: 28
    },
    {
        name: 'HD 52265 c',
        radius: 14.35,
        distance: 28
    },
    {
        name: 'HD 5319 b',
        radius: 13.63,
        distance: 100
    },
    {
        name: 'HD 5608 b',
        radius: 13.71,
        distance: 58.2
    },
    {
        name: 'HD 5891 b',
        radius: 13.03,
        distance: 251
    },
    {
        name: 'HD 59686 b',
        radius: 13.19,
        distance: 92
    },
    {
        name: 'HD 60532 b',
        radius: 13.41,
        distance: 25.7
    },
    {
        name: 'HD 60532 c',
        radius: 13.04,
        distance: 25.7
    },
    {
        name: 'HD 62509 b',
        radius: 13.45,
        distance: 10.34
    },
    {
        name: 'HD 63454 b',
        radius: 14.37,
        distance: 35.8
    },
    {
        name: 'HD 63765 b',
        radius: 14.13,
        distance: 32.6
    },
    {
        name: 'HD 6434 b',
        radius: 14.36,
        distance: 40.32
    },
    {
        name: 'HD 65216 b',
        radius: 13.84,
        distance: 34.3
    },
    {
        name: 'HD 65216 c',
        radius: 9.22,
        distance: 34.3
    },
    {
        name: 'HD 66141 b',
        radius: 13.07,
        distance: 80.9
    },
    {
        name: 'HD 66428 b',
        radius: 13.46,
        distance: 55
    },
    {
        name: 'HD 6718 b',
        radius: 13.72,
        distance: 55.9
    },
    {
        name: 'HD 68988 b',
        radius: 13.64,
        distance: 58
    },
    {
        name: 'HD 69830 b',
        radius: 3.4,
        distance: 12.6
    },
    {
        name: 'HD 69830 c',
        radius: 3.68,
        distance: 12.6
    },
    {
        name: 'HD 69830 d',
        radius: 4.66,
        distance: 12.6
    },
    {
        name: 'HD 70573 b',
        radius: 13.12,
        distance: 45.7
    },
    {
        name: 'HD 70642 b',
        radius: 13.61,
        distance: 28.8
    },
    {
        name: 'HD 7199 b',
        radius: 11.47,
        distance: 36
    },
    {
        name: 'HD 72659 b',
        radius: 13.41,
        distance: 49.8
    },
    {
        name: 'HD 73256 b',
        radius: 13.64,
        distance: 36.5
    },
    {
        name: 'HD 73267 b',
        radius: 13.42,
        distance: 54.91
    },
    {
        name: 'HD 73526 b',
        radius: 13.45,
        distance: 99
    },
    {
        name: 'HD 73526 c',
        radius: 13.51,
        distance: 99
    },
    {
        name: 'HD 73534 b',
        radius: 13.86,
        distance: 96.99
    },
    {
        name: 'HD 74156 b',
        radius: 13.64,
        distance: 64.56
    },
    {
        name: 'HD 74156 c',
        radius: 13.01,
        distance: 64.56
    },
    {
        name: 'HD 7449 b',
        radius: 13.88,
        distance: 39
    },
    {
        name: 'HD 7449 c',
        radius: 13.61,
        distance: 39
    },
    {
        name: 'HD 75289 b',
        radius: 14.33,
        distance: 28.94
    },
    {
        name: 'HD 75898 b',
        radius: 13.51,
        distance: 80.58
    },
    {
        name: 'HD 76700 b',
        radius: 9.24,
        distance: 59.7
    },
    {
        name: 'HD 77338 b',
        radius: 14.18,
        distance: 40.75
    },
    {
        name: 'HD 7924 b',
        radius: 2.56,
        distance: 16.8
    },
    {
        name: 'HD 79498 b',
        radius: 13.79,
        distance: 49
    },
    {
        name: 'HD 80606 b',
        radius: 10.32,
        distance: 58.4
    },
    {
        name: 'HD 81040 b',
        radius: 13.07,
        distance: 32.56
    },
    {
        name: 'HD 81688 b',
        radius: 13.48,
        distance: 88.26
    },
    {
        name: 'HD 82886 b',
        radius: 13.81,
        distance: 125
    },
    {
        name: 'HD 82943 b',
        radius: 13.23,
        distance: 27.46
    },
    {
        name: 'HD 82943 c',
        radius: 13.23,
        distance: 27.46
    },
    {
        name: 'HD 82943 d',
        radius: 14.43,
        distance: 27.46
    },
    {
        name: 'HD 83443 b',
        radius: 14.35,
        distance: 43.54
    },
    {
        name: 'HD 8535 b',
        radius: 14.1,
        distance: 52.5
    },
    {
        name: 'HD 85390 b',
        radius: 7.38,
        distance: 33.96
    },
    {
        name: 'HD 85390 c',
        radius: 10.1,
        distance: 33.96
    },
    {
        name: 'HD 85512 b',
        radius: 1.6,
        distance: 11.15
    },
    {
        name: 'HD 8574 b',
        radius: 13.59,
        distance: 44.2
    },
    {
        name: 'HD 86081 b',
        radius: 13.74,
        distance: 91
    },
    {
        name: 'HD 86226 b',
        radius: 13.74,
        distance: 42.48
    },
    {
        name: 'HD 86264 b',
        radius: 13.07,
        distance: 72.6
    },
    {
        name: 'HD 8673 b',
        radius: 12.77,
        distance: 38.25
    },
    {
        name: 'HD 87883 b',
        radius: 12.83,
        distance: 18.1
    },
    {
        name: 'HD 88133 b',
        radius: 9.83,
        distance: 74.5
    },
    {
        name: 'HD 89307 b',
        radius: 13.61,
        distance: 30.9
    },
    {
        name: 'HD 89744 b',
        radius: 13.05,
        distance: 40
    },
    {
        name: 'HD 89744 c',
        radius: 13.34,
        distance: 40
    },
    {
        name: 'HD 90156 b',
        radius: 4.61,
        distance: 39.6
    },
    {
        name: 'HD 92788 b',
        radius: 13.32,
        distance: 32.82
    },
    {
        name: 'HD 92788 c',
        radius: 13.91,
        distance: 32.82
    },
    {
        name: 'HD 93083 b',
        radius: 14.39,
        distance: 28.9
    },
    {
        name: 'HD 93385 b',
        radius: 2.42,
        distance: 42.2
    },
    {
        name: 'HD 93385 c',
        radius: 3.33,
        distance: 42.2
    },
    {
        name: 'HD 9446 b',
        radius: 14.09,
        distance: 53
    },
    {
        name: 'HD 9446 c',
        radius: 13.66,
        distance: 53
    },
    {
        name: 'HD 95086 b',
        radius: 13.19,
        distance: 90.4
    },
    {
        name: 'HD 95089 b',
        radius: 13.84,
        distance: 139
    },
    {
        name: 'HD 9578 b',
        radius: 14.08,
        distance: 57.24
    },
    {
        name: 'HD 96063 b',
        radius: 13.97,
        distance: 158
    },
    {
        name: 'HD 96127 b',
        radius: 13.31,
        distance: 540
    },
    {
        name: 'HD 96167 b',
        radius: 14.1,
        distance: 84
    },
    {
        name: 'HD 96700 b',
        radius: 2.53,
        distance: 25.6
    },
    {
        name: 'HD 96700 c',
        radius: 3.78,
        distance: 25.6
    },
    {
        name: 'HD 97658 b',
        radius: 2.34,
        distance: 21.1
    },
    {
        name: 'HD 98219 b',
        radius: 13.66,
        distance: 134
    },
    {
        name: 'HD 98649 b',
        radius: 13.02,
        distance: 40.3
    },
    {
        name: 'HD 99109 b',
        radius: 14.24,
        distance: 60.5
    },
    {
        name: 'HD 99492 b',
        radius: 6.63,
        distance: 18
    },
    {
        name: 'HD 99492 c',
        radius: 14.4,
        distance: 18
    },
    {
        name: 'HD 99706 b',
        radius: 13.77,
        distance: 129
    },
    {
        name: 'HIP 12961 b',
        radius: 14.41,
        distance: 23
    },
    {
        name: 'HIP 13044 b',
        radius: 13.82,
        distance: 701
    },
    {
        name: 'HIP 14810 b',
        radius: 13.32,
        distance: 52.9
    },
    {
        name: 'HIP 14810 c',
        radius: 13.81,
        distance: 52.9
    },
    {
        name: 'HIP 14810 d',
        radius: 14.18,
        distance: 52.9
    },
    {
        name: 'HIP 5158 b',
        radius: 13.76,
        distance: 45
    },
    {
        name: 'HIP 5158 c',
        radius: 12.74,
        distance: 45
    },
    {
        name: 'HIP 57050 b',
        radius: 11.65,
        distance: 11
    },
    {
        name: 'HIP 57274 b',
        radius: 3.57,
        distance: 25.92
    },
    {
        name: 'HIP 57274 c',
        radius: 14.34,
        distance: 25.92
    },
    {
        name: 'HIP 57274 d',
        radius: 14.22,
        distance: 25.92
    },
    {
        name: 'HIP 63242 b',
        radius: 12.89,
        distance: 135
    },
    {
        name: 'HIP 70849 b',
        radius: 12.96,
        distance: 24
    },
    {
        name: 'HIP 75458 b',
        radius: 12.97,
        distance: 31.5
    },
    {
        name: 'HIP 77900 b',
        radius: 12.56,
        distance: null
    },
    {
        name: 'HIP 78530 b',
        radius: 12.57,
        distance: 156.7
    },
    {
        name: 'HIP 79431 b',
        radius: 13.59,
        distance: 14.4
    },
    {
        name: 'HIP 91258 b',
        radius: 13.83,
        distance: 44.9
    },
    {
        name: 'HN Peg b',
        radius: 12.32,
        distance: 18.4
    },
    {
        name: 'HR 228 b',
        radius: 13.47,
        distance: null
    },
    {
        name: 'HR 228 c',
        radius: 13.47,
        distance: null
    },
    {
        name: 'HR 810 b',
        radius: 13.56,
        distance: 17.17
    },
    {
        name: 'HR 8799 b',
        radius: 12.32,
        distance: 39.4
    },
    {
        name: 'HR 8799 c',
        radius: 14.56,
        distance: 39.4
    },
    {
        name: 'HR 8799 d',
        radius: 13.44,
        distance: 39.4
    },
    {
        name: 'HR 8799 e',
        radius: 12.96,
        distance: 39.4
    },
    {
        name: 'HU Aqr(AB) c',
        radius: 13.08,
        distance: null
    },
    {
        name: 'HW Vir(AB) b',
        radius: 12.76,
        distance: 181
    },
    {
        name: 'kappa And b',
        radius: 12.74,
        distance: 51.6
    },
    {
        name: 'kappa CrB b',
        radius: 13.71,
        distance: 31.1
    },
    {
        name: 'KELT-1 b',
        radius: 12.5,
        distance: 263
    },
    {
        name: 'KELT-2A b',
        radius: 14.63,
        distance: 128.9
    },
    {
        name: 'KELT-3 b',
        radius: 14.93,
        distance: 178
    },
    {
        name: 'KELT-6 b',
        radius: 13.33,
        distance: null
    },
    {
        name: 'Kepler-10 b',
        radius: 1.41,
        distance: 173
    },
    {
        name: 'Kepler-10 c',
        radius: 2.23,
        distance: 173
    },
    {
        name: 'Kepler-11 b',
        radius: 1.8,
        distance: null
    },
    {
        name: 'Kepler-11 c',
        radius: 2.87,
        distance: null
    },
    {
        name: 'Kepler-11 d',
        radius: 3.12,
        distance: null
    },
    {
        name: 'Kepler-11 e',
        radius: 4.53,
        distance: null
    },
    {
        name: 'Kepler-11 f',
        radius: 2.49,
        distance: null
    },
    {
        name: 'Kepler-11 g',
        radius: 3.67,
        distance: null
    },
    {
        name: 'Kepler-12 b',
        radius: 18.98,
        distance: null
    },
    {
        name: 'Kepler-13 b',
        radius: 20.5,
        distance: null
    },
    {
        name: 'Kepler-14 b',
        radius: 12.72,
        distance: 980
    },
    {
        name: 'Kepler-15 b',
        radius: 10.75,
        distance: null
    },
    {
        name: 'Kepler-16(AB) b',
        radius: 8.44,
        distance: null
    },
    {
        name: 'Kepler-17 b',
        radius: 14.69,
        distance: 800
    },
    {
        name: 'Kepler-18 b',
        radius: 2,
        distance: null
    },
    {
        name: 'Kepler-18 c',
        radius: 5.48,
        distance: null
    },
    {
        name: 'Kepler-18 d',
        radius: 6.96,
        distance: null
    },
    {
        name: 'Kepler-19 b',
        radius: 2.22,
        distance: null
    },
    {
        name: 'Kepler-20 b',
        radius: 1.9,
        distance: 290
    },
    {
        name: 'Kepler-20 c',
        radius: 3.06,
        distance: 290
    },
    {
        name: 'Kepler-20 d',
        radius: 2.8,
        distance: 290
    },
    {
        name: 'Kepler-20 e',
        radius: 0.87,
        distance: 290
    },
    {
        name: 'Kepler-20 f',
        radius: 1.01,
        distance: 290
    },
    {
        name: 'Kepler-21 b',
        radius: 1.63,
        distance: 108
    },
    {
        name: 'Kepler-22 b',
        radius: 2.35,
        distance: 190
    },
    {
        name: 'Kepler-23 b',
        radius: 1.9,
        distance: null
    },
    {
        name: 'Kepler-23 c',
        radius: 3.25,
        distance: null
    },
    {
        name: 'Kepler-24 b',
        radius: 2.35,
        distance: null
    },
    {
        name: 'Kepler-24 c',
        radius: 2.8,
        distance: null
    },
    {
        name: 'Kepler-25 b',
        radius: 2.58,
        distance: null
    },
    {
        name: 'Kepler-25 c',
        radius: 4.48,
        distance: null
    },
    {
        name: 'Kepler-26 b',
        radius: 3.58,
        distance: null
    },
    {
        name: 'Kepler-26 c',
        radius: 3.58,
        distance: null
    },
    {
        name: 'Kepler-27 b',
        radius: 4.03,
        distance: null
    },
    {
        name: 'Kepler-27 c',
        radius: 4.93,
        distance: null
    },
    {
        name: 'Kepler-28 b',
        radius: 3.58,
        distance: null
    },
    {
        name: 'Kepler-28 c',
        radius: 3.36,
        distance: null
    },
    {
        name: 'Kepler-29 b',
        radius: 3.58,
        distance: null
    },
    {
        name: 'Kepler-29 c',
        radius: 2.91,
        distance: null
    },
    {
        name: 'Kepler-30 b',
        radius: 3.92,
        distance: null
    },
    {
        name: 'Kepler-30 c',
        radius: 12.32,
        distance: null
    },
    {
        name: 'Kepler-30 d',
        radius: 8.85,
        distance: null
    },
    {
        name: 'Kepler-31 b',
        radius: 4.26,
        distance: null
    },
    {
        name: 'Kepler-31 c',
        radius: 4.26,
        distance: null
    },
    {
        name: 'Kepler-32 b',
        radius: 4.14,
        distance: null
    },
    {
        name: 'Kepler-32 c',
        radius: 3.7,
        distance: null
    },
    {
        name: 'Kepler-33 b',
        radius: 1.79,
        distance: null
    },
    {
        name: 'Kepler-33 c',
        radius: 3.25,
        distance: null
    },
    {
        name: 'Kepler-33 d',
        radius: 5.38,
        distance: null
    },
    {
        name: 'Kepler-33 e',
        radius: 4.03,
        distance: null
    },
    {
        name: 'Kepler-33 f',
        radius: 4.48,
        distance: null
    },
    {
        name: 'Kepler-34(AB)  b',
        radius: 8.55,
        distance: 1499
    },
    {
        name: 'Kepler-35(AB) b',
        radius: 8.15,
        distance: 1645
    },
    {
        name: 'Kepler-36 b',
        radius: 1.48,
        distance: null
    },
    {
        name: 'Kepler-36 c',
        radius: 3.68,
        distance: null
    },
    {
        name: 'Kepler-37 b',
        radius: 0.3,
        distance: 66
    },
    {
        name: 'Kepler-37 c',
        radius: 0.74,
        distance: 66
    },
    {
        name: 'Kepler-37 d',
        radius: 1.98,
        distance: 66
    },
    {
        name: 'Kepler-38(AB) b',
        radius: 4.37,
        distance: null
    },
    {
        name: 'Kepler-39 b',
        radius: 13.66,
        distance: 1200
    },
    {
        name: 'Kepler-4 b',
        radius: 4,
        distance: 550
    },
    {
        name: 'Kepler-40 b',
        radius: 13.1,
        distance: 2700
    },
    {
        name: 'Kepler-41  b',
        radius: 9.42,
        distance: 730
    },
    {
        name: 'Kepler-42 b',
        radius: 0.78,
        distance: 38.7
    },
    {
        name: 'Kepler-42 c',
        radius: 0.73,
        distance: 38.7
    },
    {
        name: 'Kepler-42 d',
        radius: 0.57,
        distance: 38.7
    },
    {
        name: 'Kepler-43 b',
        radius: 13.44,
        distance: 1950
    },
    {
        name: 'Kepler-44 b',
        radius: 13.89,
        distance: 2250
    },
    {
        name: 'Kepler-45 b',
        radius: 10.75,
        distance: 333
    },
    {
        name: 'Kepler-46 b',
        radius: 9.09,
        distance: 857
    },
    {
        name: 'Kepler-46 c',
        radius: 14.38,
        distance: 857
    },
    {
        name: 'Kepler-47(AB) b',
        radius: 3.02,
        distance: null
    },
    {
        name: 'Kepler-47(AB) c',
        radius: 4.59,
        distance: null
    },
    {
        name: 'Kepler-48 b',
        radius: 2.02,
        distance: null
    },
    {
        name: 'Kepler-48 c',
        radius: 3.36,
        distance: null
    },
    {
        name: 'Kepler-49 b',
        radius: 2.69,
        distance: null
    },
    {
        name: 'Kepler-49 c',
        radius: 2.58,
        distance: null
    },
    {
        name: 'Kepler-5 b',
        radius: 16.03,
        distance: null
    },
    {
        name: 'Kepler-50 b',
        radius: 2.24,
        distance: null
    },
    {
        name: 'Kepler-50 c',
        radius: 2.8,
        distance: null
    },
    {
        name: 'Kepler-51 b',
        radius: 7.06,
        distance: null
    },
    {
        name: 'Kepler-51 c',
        radius: 5.71,
        distance: null
    },
    {
        name: 'Kepler-52 b',
        radius: 2.13,
        distance: null
    },
    {
        name: 'Kepler-52 c',
        radius: 1.79,
        distance: null
    },
    {
        name: 'Kepler-53 b',
        radius: 2.91,
        distance: null
    },
    {
        name: 'Kepler-53 c',
        radius: 3.14,
        distance: null
    },
    {
        name: 'Kepler-54 b',
        radius: 2.13,
        distance: null
    },
    {
        name: 'Kepler-54 c',
        radius: 1.23,
        distance: null
    },
    {
        name: 'Kepler-55 b',
        radius: 2.46,
        distance: null
    },
    {
        name: 'Kepler-55 c',
        radius: 2.24,
        distance: null
    },
    {
        name: 'Kepler-56 b',
        radius: 6.5,
        distance: null
    },
    {
        name: 'Kepler-56 c',
        radius: 9.86,
        distance: null
    },
    {
        name: 'Kepler-56 d',
        radius: 13.33,
        distance: null
    },
    {
        name: 'Kepler-57 b',
        radius: 2.24,
        distance: null
    },
    {
        name: 'Kepler-57 c',
        radius: 1.57,
        distance: null
    },
    {
        name: 'Kepler-58 b',
        radius: 2.8,
        distance: null
    },
    {
        name: 'Kepler-58 c',
        radius: 2.91,
        distance: null
    },
    {
        name: 'Kepler-59 b',
        radius: 1.1,
        distance: null
    },
    {
        name: 'Kepler-59 c',
        radius: 2.02,
        distance: null
    },
    {
        name: 'Kepler-6 b',
        radius: 14.82,
        distance: null
    },
    {
        name: 'Kepler-60 b',
        radius: 2.24,
        distance: null
    },
    {
        name: 'Kepler-60 c',
        radius: 2.46,
        distance: null
    },
    {
        name: 'Kepler-60 d',
        radius: 2.58,
        distance: null
    },
    {
        name: 'Kepler-61 b',
        radius: 2.15,
        distance: 326
    },
    {
        name: 'Kepler-62 b',
        radius: 1.31,
        distance: 368
    },
    {
        name: 'Kepler-62 c',
        radius: 0.54,
        distance: 368
    },
    {
        name: 'Kepler-62 d',
        radius: 1.95,
        distance: 368
    },
    {
        name: 'Kepler-62 e',
        radius: 1.61,
        distance: 368
    },
    {
        name: 'Kepler-62 f',
        radius: 1.41,
        distance: 368
    },
    {
        name: 'Kepler-63 b',
        radius: 6.1,
        distance: 200
    },
    {
        name: 'Kepler-65 b',
        radius: 1.42,
        distance: null
    },
    {
        name: 'Kepler-65 c',
        radius: 2.58,
        distance: null
    },
    {
        name: 'Kepler-65 d',
        radius: 1.51,
        distance: null
    },
    {
        name: 'Kepler-66 b',
        radius: 2.8,
        distance: 1107
    },
    {
        name: 'Kepler-67 b',
        radius: 2.91,
        distance: 1107
    },
    {
        name: 'Kepler-68 b',
        radius: 2.3,
        distance: 135
    },
    {
        name: 'Kepler-68 c',
        radius: 0.91,
        distance: 135
    },
    {
        name: 'Kepler-68 d',
        radius: 13.89,
        distance: 135
    },
    {
        name: 'Kepler-69 b',
        radius: 2.24,
        distance: null
    },
    {
        name: 'Kepler-69 c',
        radius: 1.71,
        distance: null
    },
    {
        name: 'Kepler-7 b',
        radius: 18.08,
        distance: null
    },
    {
        name: 'Kepler-70  b',
        radius: 0.76,
        distance: 1180
    },
    {
        name: 'Kepler-70 c',
        radius: 0.87,
        distance: 1180
    },
    {
        name: 'Kepler-71 b',
        radius: 11.71,
        distance: null
    },
    {
        name: 'Kepler-74 b',
        radius: 14.78,
        distance: 1330
    },
    {
        name: 'Kepler-75 b',
        radius: 11.54,
        distance: 1140
    },
    {
        name: 'Kepler-76 b',
        radius: 14,
        distance: null
    },
    {
        name: 'Kepler-77 b',
        radius: 10.75,
        distance: 570
    },
    {
        name: 'Kepler-78 b',
        radius: 1.2,
        distance: null
    },
    {
        name: 'Kepler-79 b',
        radius: 3.3,
        distance: null
    },
    {
        name: 'Kepler-79 c',
        radius: 3.73,
        distance: null
    },
    {
        name: 'Kepler-79 d',
        radius: 7.17,
        distance: null
    },
    {
        name: 'Kepler-79 e',
        radius: 3.49,
        distance: null
    },
    {
        name: 'Kepler-8 b',
        radius: 15.89,
        distance: 1330
    },
    {
        name: 'Kepler-80 b',
        radius: 2.35,
        distance: null
    },
    {
        name: 'Kepler-80 c',
        radius: 2.58,
        distance: null
    },
    {
        name: 'Kepler-80 d',
        radius: 1.4,
        distance: null
    },
    {
        name: 'Kepler-80 e',
        radius: 1.5,
        distance: null
    },
    {
        name: 'Kepler-80 f',
        radius: 1.3,
        distance: null
    },
    {
        name: 'Kepler-81 b',
        radius: 2.54,
        distance: null
    },
    {
        name: 'Kepler-81 c',
        radius: 2.45,
        distance: null
    },
    {
        name: 'Kepler-82 b',
        radius: 4,
        distance: null
    },
    {
        name: 'Kepler-82 c',
        radius: 5.3,
        distance: null
    },
    {
        name: 'Kepler-83 b',
        radius: 2.34,
        distance: null
    },
    {
        name: 'Kepler-83 c',
        radius: 1.94,
        distance: null
    },
    {
        name: 'Kepler-84 b',
        radius: 2.2,
        distance: null
    },
    {
        name: 'Kepler-84 c',
        radius: 2.4,
        distance: null
    },
    {
        name: 'Kepler-85 b',
        radius: 1.99,
        distance: null
    },
    {
        name: 'Kepler-85 c',
        radius: 2.21,
        distance: null
    },
    {
        name: 'Kepler-86 b',
        radius: 10.14,
        distance: null
    },
    {
        name: 'Kepler-87 b',
        radius: 13.55,
        distance: null
    },
    {
        name: 'Kepler-87 c',
        radius: 6.15,
        distance: null
    },
    {
        name: 'Kepler-88 b',
        radius: 4.22,
        distance: 385
    },
    {
        name: 'Kepler-88 c',
        radius: 14.04,
        distance: 385
    },
    {
        name: 'Kepler-89 b',
        radius: 1.71,
        distance: null
    },
    {
        name: 'Kepler-89 c',
        radius: 4.32,
        distance: null
    },
    {
        name: 'Kepler-89 d',
        radius: 11.2,
        distance: null
    },
    {
        name: 'Kepler-89 e',
        radius: 6.16,
        distance: null
    },
    {
        name: 'Kepler-9 b',
        radius: 9.42,
        distance: null
    },
    {
        name: 'Kepler-9 c',
        radius: 9.21,
        distance: null
    },
    {
        name: 'Kepler-9 d',
        radius: 1.65,
        distance: null
    },
    {
        name: 'Kepler-90 b',
        radius: 1.31,
        distance: null
    },
    {
        name: 'Kepler-90 c',
        radius: 1.19,
        distance: null
    },
    {
        name: 'Kepler-90 d',
        radius: 2.88,
        distance: null
    },
    {
        name: 'Kepler-90 e',
        radius: 2.67,
        distance: null
    },
    {
        name: 'Kepler-90 f',
        radius: 2.89,
        distance: null
    },
    {
        name: 'Kepler-90 g',
        radius: 8.12,
        distance: null
    },
    {
        name: 'Kepler-90 h',
        radius: 11.31,
        distance: null
    },
    {
        name: 'KIC-10255705 b',
        radius: 7.28,
        distance: null
    },
    {
        name: 'KIC-10905746 b',
        radius: 2.65,
        distance: null
    },
    {
        name: 'KIC-11152511 b',
        radius: 4.03,
        distance: null
    },
    {
        name: 'KIC-12351927(AB) b',
        radius: 4.37,
        distance: null
    },
    {
        name: 'KIC-12454613 b',
        radius: 2.69,
        distance: null
    },
    {
        name: 'KIC-12557548 b',
        radius: 0.85,
        distance: 470
    },
    {
        name: 'KIC-5010054 b',
        radius: 6.94,
        distance: null
    },
    {
        name: 'KIC-5094412 b',
        radius: 5.71,
        distance: null
    },
    {
        name: 'KIC-5522786 b',
        radius: 1.23,
        distance: null
    },
    {
        name: 'KIC-5732155 b',
        radius: 12.77,
        distance: null
    },
    {
        name: 'KIC-6185331 b',
        radius: 8.06,
        distance: null
    },
    {
        name: 'KIC-6372194 b',
        radius: 8.29,
        distance: null
    },
    {
        name: 'KIC-6436029 c',
        radius: 3.07,
        distance: null
    },
    {
        name: 'KIC-8852719 b',
        radius: 3.53,
        distance: null
    },
    {
        name: 'KIC-9662267 b',
        radius: 3.81,
        distance: null
    },
    {
        name: 'KIC-9704149 b',
        radius: 4.48,
        distance: null
    },
    {
        name: 'KOI-111 b',
        radius: 2.14,
        distance: null
    },
    {
        name: 'KOI-111 c',
        radius: 2.05,
        distance: null
    },
    {
        name: 'KOI-115 b',
        radius: 4.82,
        distance: null
    },
    {
        name: 'KOI-115 c',
        radius: 1.91,
        distance: null
    },
    {
        name: 'KOI-117 b',
        radius: 1.58,
        distance: null
    },
    {
        name: 'KOI-117 c',
        radius: 1.71,
        distance: null
    },
    {
        name: 'KOI-1203 b',
        radius: 2.9,
        distance: null
    },
    {
        name: 'KOI-1203 c',
        radius: 2.8,
        distance: null
    },
    {
        name: 'KOI-1215 b',
        radius: 2.92,
        distance: null
    },
    {
        name: 'KOI-1215 c',
        radius: 3.36,
        distance: null
    },
    {
        name: 'KOI-1236 b',
        radius: 4.31,
        distance: null
    },
    {
        name: 'KOI-1236 c',
        radius: 3.1,
        distance: null
    },
    {
        name: 'KOI-1278 b',
        radius: 2.46,
        distance: null
    },
    {
        name: 'KOI-1278 c',
        radius: 3.1,
        distance: null
    },
    {
        name: 'KOI-156 b',
        radius: 1.18,
        distance: null
    },
    {
        name: 'KOI-156 c',
        radius: 1.6,
        distance: null
    },
    {
        name: 'KOI-156 d',
        radius: 2.53,
        distance: null
    },
    {
        name: 'KOI-1563 b',
        radius: 3.61,
        distance: null
    },
    {
        name: 'KOI-1563 c',
        radius: 3.3,
        distance: null
    },
    {
        name: 'KOI-1576 c',
        radius: 2.8,
        distance: null
    },
    {
        name: 'KOI-1676 b',
        radius: 3.2,
        distance: null
    },
    {
        name: 'KOI-1781 b',
        radius: 1.88,
        distance: null
    },
    {
        name: 'KOI-1843 b',
        radius: 0.58,
        distance: null
    },
    {
        name: 'KOI-1873 b',
        radius: 2.31,
        distance: null
    },
    {
        name: 'KOI-1873 c',
        radius: 5.41,
        distance: null
    },
    {
        name: 'KOI-202 b',
        radius: 11.42,
        distance: null
    },
    {
        name: 'KOI-2025 b',
        radius: 3.1,
        distance: null
    },
    {
        name: 'KOI-2025 c',
        radius: 2.8,
        distance: null
    },
    {
        name: 'KOI-206 b',
        radius: 7.84,
        distance: null
    },
    {
        name: 'KOI-2672 b',
        radius: 3.47,
        distance: null
    },
    {
        name: 'KOI-2672 c',
        radius: 5.26,
        distance: null
    },
    {
        name: 'KOI-274 b',
        radius: 1.13,
        distance: null
    },
    {
        name: 'KOI-274 c',
        radius: 1.13,
        distance: null
    },
    {
        name: 'KOI-282 b',
        radius: 2.9,
        distance: null
    },
    {
        name: 'KOI-285 b',
        radius: 3.52,
        distance: null
    },
    {
        name: 'KOI-285 c',
        radius: 2.61,
        distance: null
    },
    {
        name: 'KOI-370 b',
        radius: 2.65,
        distance: null
    },
    {
        name: 'KOI-370 c',
        radius: 4.42,
        distance: null
    },
    {
        name: 'KOI-523 b',
        radius: 2.9,
        distance: null
    },
    {
        name: 'KOI-523 c',
        radius: 7.11,
        distance: null
    },
    {
        name: 'KOI-680 b',
        radius: 7.28,
        distance: null
    },
    {
        name: 'KOI-730 b',
        radius: 3.47,
        distance: null
    },
    {
        name: 'KOI-730 c',
        radius: 2.58,
        distance: null
    },
    {
        name: 'KOI-730 d',
        radius: 2.8,
        distance: null
    },
    {
        name: 'KOI-730 e',
        radius: 2.02,
        distance: null
    },
    {
        name: 'KOI-82 b',
        radius: 2.2,
        distance: null
    },
    {
        name: 'KOI-82 c',
        radius: 1.34,
        distance: null
    },
    {
        name: 'KOI-82 d',
        radius: 0.69,
        distance: null
    },
    {
        name: 'KOI-834 b',
        radius: 5.61,
        distance: null
    },
    {
        name: 'KOI-834 c',
        radius: 2,
        distance: null
    },
    {
        name: 'ksi Aql b',
        radius: 13.46,
        distance: 62.7
    },
    {
        name: 'LKCA 15 b',
        radius: 13.13,
        distance: 145
    },
    {
        name: 'MOA-2007-BLG-192-L b',
        radius: 1.54,
        distance: 700
    },
    {
        name: 'MOA-2007-BLG-400-L b',
        radius: 13.97,
        distance: 6000
    },
    {
        name: 'MOA-2008-BLG-310-L b',
        radius: 10.07,
        distance: 6000
    },
    {
        name: 'MOA-2008-BLG-379L b',
        radius: 13.17,
        distance: 3600
    },
    {
        name: 'MOA-2009-BLG-266L b',
        radius: 3.38,
        distance: 3040
    },
    {
        name: 'MOA-2009-BLG-319 b',
        radius: 8.14,
        distance: 6100
    },
    {
        name: 'MOA-2009-BLG-387L b',
        radius: 13.5,
        distance: 5700
    },
    {
        name: 'MOA-2010-BLG-328L b',
        radius: 3.42,
        distance: 810
    },
    {
        name: 'MOA-2010-BLG-477L b',
        radius: 13.74,
        distance: 2300
    },
    {
        name: 'MOA-2011-BLG-293L b',
        radius: 13.23,
        distance: 7700
    },
    {
        name: 'MOA-2011-BLG-322 b',
        radius: 12.96,
        distance: 7740
    },
    {
        name: 'MOA-bin-1 b',
        radius: 13.34,
        distance: 5100
    },
    {
        name: 'mu Ara b',
        radius: 13.69,
        distance: 15.3
    },
    {
        name: 'mu Ara c',
        radius: 3.41,
        distance: 15.3
    },
    {
        name: 'mu Ara d',
        radius: 14.23,
        distance: 15.3
    },
    {
        name: 'mu Ara e',
        radius: 13.66,
        distance: 15.3
    },
    {
        name: 'NGC 2423 3 b',
        radius: 12.89,
        distance: 766
    },
    {
        name: 'NGC 4349 No 127 b',
        radius: 12.63,
        distance: 2176
    },
    {
        name: 'NN Ser(AB) c',
        radius: 13.07,
        distance: 500
    },
    {
        name: 'NN Ser(AB) d',
        radius: 13.55,
        distance: 500
    },
    {
        name: 'nu Oph b',
        radius: 12.55,
        distance: 46.8
    },
    {
        name: 'nu Oph c',
        radius: 12.5,
        distance: 46.8
    },
    {
        name: 'NY Vir b',
        radius: 13.49,
        distance: null
    },
    {
        name: 'OGLE-05-071L b',
        radius: 13.37,
        distance: 3300
    },
    {
        name: 'OGLE-05-169L b',
        radius: 3.78,
        distance: 2700
    },
    {
        name: 'OGLE-05-390L b',
        radius: 1.94,
        distance: 6500
    },
    {
        name: 'OGLE-06-109L b',
        radius: 14.07,
        distance: 1510
    },
    {
        name: 'OGLE-06-109L c',
        radius: 11.04,
        distance: 1510
    },
    {
        name: 'OGLE-2007-BLG-368L b',
        radius: 5.15,
        distance: 5900
    },
    {
        name: 'OGLE-2009-BLG-151_MOA-2009-232 b',
        radius: 12.97,
        distance: 390
    },
    {
        name: 'OGLE-2011-BLG-0251 b',
        radius: 13.88,
        distance: 4090
    },
    {
        name: 'OGLE-2011-BLG-0420 b',
        radius: 12.88,
        distance: 1990
    },
    {
        name: 'OGLE-2012-BLG-0026L b',
        radius: 7.22,
        distance: 4080
    },
    {
        name: 'OGLE-2012-BLG-0026L c',
        radius: 14.04,
        distance: 4080
    },
    {
        name: 'OGLE-2012-BLG-0358L b',
        radius: 13.58,
        distance: 1760
    },
    {
        name: 'OGLE-2012-BLG-0406L b',
        radius: 13.41,
        distance: 4970
    },
    {
        name: 'OGLE-TR-10 b',
        radius: 19.26,
        distance: 1500
    },
    {
        name: 'OGLE-TR-111 b',
        radius: 12.06,
        distance: 1500
    },
    {
        name: 'OGLE-TR-113 b',
        radius: 12.43,
        distance: 1500
    },
    {
        name: 'OGLE-TR-132 b',
        radius: 13.78,
        distance: 1500
    },
    {
        name: 'OGLE-TR-182 b',
        radius: 16.46,
        distance: null
    },
    {
        name: 'OGLE-TR-211 b',
        radius: 14.11,
        distance: null
    },
    {
        name: 'OGLE-TR-56 b',
        radius: 13.44,
        distance: 1500
    },
    {
        name: 'OGLE2-TR-L9 b',
        radius: 18.08,
        distance: 900
    },
    {
        name: 'OGLE235-MOA53 b',
        radius: 13.5,
        distance: 5200
    },
    {
        name: 'ome Ser b',
        radius: 13.62,
        distance: 80.6
    },
    {
        name: 'omi CrB b',
        radius: 13.68,
        distance: 84
    },
    {
        name: 'omi UMa b',
        radius: 13.23,
        distance: 56.3
    },
    {
        name: 'Oph 11 b',
        radius: 12.6,
        distance: 145
    },
    {
        name: 'PH1-Kepler-64 b',
        radius: 6.19,
        distance: null
    },
    {
        name: 'POTS-1 b',
        radius: 10.54,
        distance: null
    },
    {
        name: 'Pr0201 c',
        radius: 14.14,
        distance: null
    },
    {
        name: 'Pr0211 b',
        radius: 13.59,
        distance: null
    },
    {
        name: 'PSR 1257 12 b',
        radius: 0.3,
        distance: 710
    },
    {
        name: 'PSR 1257 12 c',
        radius: 1.72,
        distance: 710
    },
    {
        name: 'PSR 1257 12 d',
        radius: 1.66,
        distance: 710
    },
    {
        name: 'PSR 1719-14 b',
        radius: 4.48,
        distance: 1200
    },
    {
        name: 'PSR B1620-26 b',
        radius: 13.51,
        distance: 3800
    },
    {
        name: 'Qatar-1 b',
        radius: 13.04,
        distance: null
    },
    {
        name: 'Qatar-2 b',
        radius: 12.81,
        distance: null
    },
    {
        name: 'Ross 458(AB) c',
        radius: 12.98,
        distance: 114
    },
    {
        name: 'ROXs 42B b',
        radius: 12.83,
        distance: 135
    },
    {
        name: 'RR Cae b',
        radius: 13.22,
        distance: null
    },
    {
        name: 'SR 12 AB c',
        radius: 12.8,
        distance: 125
    },
    {
        name: 'SWEEPS-04b',
        radius: 9.07,
        distance: 8500
    },
    {
        name: 'SWEEPS-11b',
        radius: 12.66,
        distance: 8500
    },
    {
        name: 'tau Boo b',
        radius: 13.14,
        distance: 15.6
    },
    {
        name: 'tau Gem b',
        radius: 12.55,
        distance: 98.4
    },
    {
        name: 'TrES-1b',
        radius: 12.31,
        distance: 157
    },
    {
        name: 'TrES-2b',
        radius: 13.09,
        distance: 220
    },
    {
        name: 'TrES-3b',
        radius: 14.62,
        distance: null
    },
    {
        name: 'TrES-4b',
        radius: 19.11,
        distance: 479
    },
    {
        name: 'TrES-5b',
        radius: 13.54,
        distance: 360
    },
    {
        name: 'ups And b',
        radius: 14.15,
        distance: 13.47
    },
    {
        name: 'ups And c',
        radius: 13.66,
        distance: 13.47
    },
    {
        name: 'ups And d',
        radius: 12.91,
        distance: 13.47
    },
    {
        name: 'ups And e',
        radius: 13.9,
        distance: 13.47
    },
    {
        name: 'USco1602-2401 b',
        radius: 12.22,
        distance: null
    },
    {
        name: 'USco1610-1913 b',
        radius: 12.56,
        distance: null
    },
    {
        name: 'USco1612-1800 b',
        radius: 12.46,
        distance: null
    },
    {
        name: 'UScoCTIO 108 b',
        radius: 12.72,
        distance: 145
    },
    {
        name: 'UZ For(ab) d',
        radius: 12.96,
        distance: null
    },
    {
        name: 'V391 Peg b',
        radius: 13.41,
        distance: 1400
    },
    {
        name: 'WASP-1 b',
        radius: 16.62,
        distance: null
    },
    {
        name: 'WASP-10 b',
        radius: 12.1,
        distance: 90
    },
    {
        name: 'WASP-100 b',
        radius: 18.93,
        distance: null
    },
    {
        name: 'WASP-101 b',
        radius: 15.79,
        distance: null
    },
    {
        name: 'WASP-11-HAT-P-10 b',
        radius: 11.7,
        distance: 125
    },
    {
        name: 'WASP-12 b',
        radius: 19.44,
        distance: 427
    },
    {
        name: 'WASP-13 b',
        radius: 15.29,
        distance: 156
    },
    {
        name: 'WASP-14 b',
        radius: 14.35,
        distance: 160
    },
    {
        name: 'WASP-15 b',
        radius: 15.99,
        distance: 308
    },
    {
        name: 'WASP-16 b',
        radius: 11.29,
        distance: null
    },
    {
        name: 'WASP-17 b',
        radius: 22.3,
        distance: null
    },
    {
        name: 'WASP-18 b',
        radius: 13.05,
        distance: 100
    },
    {
        name: 'WASP-19 b',
        radius: 15.62,
        distance: null
    },
    {
        name: 'WASP-2 b',
        radius: 12.08,
        distance: 144
    },
    {
        name: 'WASP-20 b',
        radius: 10.08,
        distance: null
    },
    {
        name: 'WASP-21 b',
        radius: 13.55,
        distance: 230
    },
    {
        name: 'WASP-22 b',
        radius: 12.97,
        distance: 300
    },
    {
        name: 'WASP-23 b',
        radius: 10.77,
        distance: null
    },
    {
        name: 'WASP-24 b',
        radius: 12.36,
        distance: 330
    },
    {
        name: 'WASP-25 b',
        radius: 14.11,
        distance: 169
    },
    {
        name: 'WASP-26 b',
        radius: 14.35,
        distance: 250
    },
    {
        name: 'WASP-28 b',
        radius: 12.54,
        distance: 334
    },
    {
        name: 'WASP-29 b',
        radius: 9.42,
        distance: 80
    },
    {
        name: 'WASP-3 b',
        radius: 16.28,
        distance: 223
    },
    {
        name: 'WASP-31 b',
        radius: 17.21,
        distance: 400
    },
    {
        name: 'WASP-32 b',
        radius: 13.22,
        distance: null
    },
    {
        name: 'WASP-33 b',
        radius: 16.11,
        distance: 116
    },
    {
        name: 'WASP-34 b',
        radius: 13.66,
        distance: 120
    },
    {
        name: 'WASP-35 b',
        radius: 14.78,
        distance: null
    },
    {
        name: 'WASP-36 b',
        radius: 14.21,
        distance: 450
    },
    {
        name: 'WASP-37 b',
        radius: 12.72,
        distance: 338
    },
    {
        name: 'WASP-38 b',
        radius: 12.08,
        distance: 110
    },
    {
        name: 'WASP-39 b',
        radius: 14.22,
        distance: 230
    },
    {
        name: 'WASP-4 b',
        radius: 15.62,
        distance: 300
    },
    {
        name: 'WASP-41 b',
        radius: 13.55,
        distance: 180
    },
    {
        name: 'WASP-42 b',
        radius: 12.1,
        distance: null
    },
    {
        name: 'WASP-43 b',
        radius: 11.6,
        distance: null
    },
    {
        name: 'WASP-44 b',
        radius: 12.77,
        distance: null
    },
    {
        name: 'WASP-45 b',
        radius: 12.99,
        distance: null
    },
    {
        name: 'WASP-46 b',
        radius: 14.67,
        distance: null
    },
    {
        name: 'WASP-47 b',
        radius: 12.88,
        distance: 200
    },
    {
        name: 'WASP-48 b',
        radius: 18.7,
        distance: null
    },
    {
        name: 'WASP-49 b',
        radius: 12.49,
        distance: null
    },
    {
        name: 'WASP-5 b',
        radius: 13.12,
        distance: 297
    },
    {
        name: 'WASP-50 b',
        radius: 12.75,
        distance: 230
    },
    {
        name: 'WASP-52 b',
        radius: 14.22,
        distance: 140
    },
    {
        name: 'WASP-53 b',
        radius: 13.44,
        distance: null
    },
    {
        name: 'WASP-54 b',
        radius: 15.68,
        distance: null
    },
    {
        name: 'WASP-55 b',
        radius: 14.56,
        distance: 330
    },
    {
        name: 'WASP-56 b',
        radius: 13.44,
        distance: null
    },
    {
        name: 'WASP-57 b',
        radius: 12.32,
        distance: null
    },
    {
        name: 'WASP-58 b',
        radius: 15.34,
        distance: 300
    },
    {
        name: 'WASP-59 b',
        radius: 10.08,
        distance: 125
    },
    {
        name: 'WASP-6 b',
        radius: 13.71,
        distance: 307
    },
    {
        name: 'WASP-60 b',
        radius: 10.08,
        distance: 400
    },
    {
        name: 'WASP-61 b',
        radius: 13.89,
        distance: 480
    },
    {
        name: 'WASP-62 b',
        radius: 15.57,
        distance: 160
    },
    {
        name: 'WASP-63 b',
        radius: 16.02,
        distance: 330
    },
    {
        name: 'WASP-64 b',
        radius: 7.84,
        distance: null
    },
    {
        name: 'WASP-65 b',
        radius: 12.45,
        distance: 310
    },
    {
        name: 'WASP-66 b',
        radius: 15.57,
        distance: 380
    },
    {
        name: 'WASP-67 b',
        radius: 15.68,
        distance: 225
    },
    {
        name: 'WASP-68 b',
        radius: 10.08,
        distance: null
    },
    {
        name: 'WASP-69 b',
        radius: 11.2,
        distance: null
    },
    {
        name: 'WASP-7 b',
        radius: 14.9,
        distance: 140
    },
    {
        name: 'WASP-70 b',
        radius: 8.96,
        distance: null
    },
    {
        name: 'WASP-71 b',
        radius: 16.8,
        distance: 200
    },
    {
        name: 'WASP-72 b',
        radius: 14.22,
        distance: null
    },
    {
        name: 'WASP-75 b',
        radius: 14.22,
        distance: 260
    },
    {
        name: 'WASP-76 b',
        radius: 20.5,
        distance: 120
    },
    {
        name: 'WASP-77A b',
        radius: 13.55,
        distance: null
    },
    {
        name: 'WASP-78 b',
        radius: 19.6,
        distance: 550
    },
    {
        name: 'WASP-79 b',
        radius: 19.04,
        distance: 240
    },
    {
        name: 'WASP-8 b',
        radius: 11.63,
        distance: 87
    },
    {
        name: 'WASP-80 b',
        radius: 10.66,
        distance: 60
    },
    {
        name: 'WASP-82 b',
        radius: 18.7,
        distance: 200
    },
    {
        name: 'WASP-84 b',
        radius: 10.55,
        distance: 120
    },
    {
        name: 'WASP-90 b',
        radius: 18.26,
        distance: 340
    },
    {
        name: 'WASP-95 b',
        radius: 13.55,
        distance: null
    },
    {
        name: 'WASP-96 b',
        radius: 13.44,
        distance: null
    },
    {
        name: 'WASP-97 b',
        radius: 12.66,
        distance: null
    },
    {
        name: 'WASP-98 b',
        radius: 12.32,
        distance: null
    },
    {
        name: 'WASP-99 b',
        radius: 12.32,
        distance: null
    },
    {
        name: 'WD 0806-661B b',
        radius: 13.01,
        distance: 19.2
    },
    {
        name: 'WISE 1217+16A b',
        radius: 11.2,
        distance: 10
    },
    {
        name: 'WISE 1711+3500 b',
        radius: 12.74,
        distance: 19
    },
    {
        name: 'WTS-1 b',
        radius: 16.69,
        distance: 3200
    },
    {
        name: 'WTS-2 b',
        radius: 14.56,
        distance: 1000
    },
    {
        name: 'XO-1 b',
        radius: 13.26,
        distance: 200
    },
    {
        name: 'XO-2 b',
        radius: 10.9,
        distance: 149
    },
    {
        name: 'XO-3 b',
        radius: 13.63,
        distance: 260
    },
    {
        name: 'XO-4 b',
        radius: 15.01,
        distance: 293
    },
    {
        name: 'XO-5 b',
        radius: 11.54,
        distance: 255
    }
];
var $2f3aca5dccaf0d4e$export$2e2bcd8739ae039 = $2f3aca5dccaf0d4e$var$exoplanets;


const $d57ce98620308c89$var$planets = [
    {
        name: 'Jupiter',
        radius: '10.97',
        distance: '0'
    },
    {
        name: 'Saturn',
        radius: '9.14',
        distance: '0'
    },
    {
        name: 'Uranus',
        radius: '3.98',
        distance: '0'
    },
    {
        name: 'Neptune',
        radius: '3.86',
        distance: '0'
    },
    {
        name: 'Earth',
        radius: '1',
        distance: '0'
    },
    {
        name: 'Venus',
        radius: '0.950',
        distance: '0'
    },
    {
        name: 'Mars',
        radius: '0.532',
        distance: '0'
    },
    {
        name: 'Mercury',
        radius: '0.383',
        distance: '0'
    },
    {
        name: 'Pluto',
        radius: '0.181',
        distance: '0'
    }
];
var $d57ce98620308c89$export$2e2bcd8739ae039 = $d57ce98620308c89$var$planets;


const $66ef3598a56ddb7c$var$shakespeare = [
    {
        id: 'Shakespeare',
        parent: null,
        size: 0
    },
    {
        id: 'Comedies',
        parent: 'Shakespeare',
        size: null
    },
    {
        id: 'Tragedies',
        parent: 'Shakespeare',
        size: null
    },
    {
        id: 'Histories',
        parent: 'Shakespeare',
        size: null
    },
    {
        id: 'As You Like It',
        parent: 'Comedies',
        size: null
    },
    {
        id: 'Adam',
        parent: 'As You Like It',
        size: 10
    },
    {
        id: 'Amiens',
        parent: 'As You Like It',
        size: 10
    },
    {
        id: 'Audrey',
        parent: 'As You Like It',
        size: 12
    },
    {
        id: 'Celia',
        parent: 'As You Like It',
        size: 108
    },
    {
        id: 'Charles',
        parent: 'As You Like It',
        size: 8
    },
    {
        id: 'Corin',
        parent: 'As You Like It',
        size: 24
    },
    {
        id: 'Dennis',
        parent: 'As You Like It',
        size: 2
    },
    {
        id: 'Duke',
        parent: 'As You Like It',
        size: 32
    },
    {
        id: 'Frederick',
        parent: 'As You Like It',
        size: 20
    },
    {
        id: 'Hymen',
        parent: 'As You Like It',
        size: 1
    },
    {
        id: 'Jaques (lord)',
        parent: 'As You Like It',
        size: 57
    },
    {
        id: 'Jaques (son)',
        parent: 'As You Like It',
        size: 2
    },
    {
        id: 'Le Beau',
        parent: 'As You Like It',
        size: 14
    },
    {
        id: 'Oliver',
        parent: 'As You Like It',
        size: 37
    },
    {
        id: 'Orlando',
        parent: 'As You Like It',
        size: 120
    },
    {
        id: 'Phebe',
        parent: 'As You Like It',
        size: 23
    },
    {
        id: 'Rosalind',
        parent: 'As You Like It',
        size: 201
    },
    {
        id: 'Silvius',
        parent: 'As You Like It',
        size: 24
    },
    {
        id: 'Sir Oliver Martext',
        parent: 'As You Like It',
        size: 3
    },
    {
        id: 'Touchstone',
        parent: 'As You Like It',
        size: 74
    },
    {
        id: 'William',
        parent: 'As You Like It',
        size: 11
    },
    {
        id: 'Comedy Of Errors',
        parent: 'Comedies',
        size: null
    },
    {
        id: 'Adriana',
        parent: 'Comedy Of Errors',
        size: 79
    },
    {
        id: 'Aegeon',
        parent: 'Comedy Of Errors',
        size: 17
    },
    {
        id: 'Aemilia',
        parent: 'Comedy Of Errors',
        size: 16
    },
    {
        id: 'Angelo',
        parent: 'Comedy Of Errors',
        size: 31
    },
    {
        id: 'Antipholus of Ephesus',
        parent: 'Comedy Of Errors',
        size: 76
    },
    {
        id: 'Antipholus of Syracuse',
        parent: 'Comedy Of Errors',
        size: 103
    },
    {
        id: 'Balthazar',
        parent: 'Comedy Of Errors',
        size: 5
    },
    {
        id: 'Courtezan',
        parent: 'Comedy Of Errors',
        size: 11
    },
    {
        id: 'Dromio of Ephesus',
        parent: 'Comedy Of Errors',
        size: 63
    },
    {
        id: 'Dromio of Syracuse',
        parent: 'Comedy Of Errors',
        size: 99
    },
    {
        id: 'Luce',
        parent: 'Comedy Of Errors',
        size: 7
    },
    {
        id: 'Luciana',
        parent: 'Comedy Of Errors',
        size: 43
    },
    {
        id: 'Pinch',
        parent: 'Comedy Of Errors',
        size: 6
    },
    {
        id: 'Solinus',
        parent: 'Comedy Of Errors',
        size: 22
    },
    {
        id: 'Merchant Of Venice',
        parent: 'Comedies',
        size: null
    },
    {
        id: 'Antonio',
        parent: 'Merchant Of Venice',
        size: 47
    },
    {
        id: 'Balthasar',
        parent: 'Merchant Of Venice',
        size: 1
    },
    {
        id: 'Bassanio',
        parent: 'Merchant Of Venice',
        size: 73
    },
    {
        id: 'Duke (of Venice)',
        parent: 'Merchant Of Venice',
        size: 18
    },
    {
        id: 'Gratiano',
        parent: 'Merchant Of Venice',
        size: 48
    },
    {
        id: 'Jessica',
        parent: 'Merchant Of Venice',
        size: 26
    },
    {
        id: 'Launcelot Gobbo',
        parent: 'Merchant Of Venice',
        size: 44
    },
    {
        id: 'Leonardo',
        parent: 'Merchant Of Venice',
        size: 2
    },
    {
        id: 'Lorenzo',
        parent: 'Merchant Of Venice',
        size: 47
    },
    {
        id: 'Nerissa',
        parent: 'Merchant Of Venice',
        size: 36
    },
    {
        id: 'Old Gobbo',
        parent: 'Merchant Of Venice',
        size: 19
    },
    {
        id: 'Portia',
        parent: 'Merchant Of Venice',
        size: 117
    },
    {
        id: 'Prince of Arragon',
        parent: 'Merchant Of Venice',
        size: 4
    },
    {
        id: 'Prince of Morocco',
        parent: 'Merchant Of Venice',
        size: 7
    },
    {
        id: 'Salanio',
        parent: 'Merchant Of Venice',
        size: 18
    },
    {
        id: 'Salarino',
        parent: 'Merchant Of Venice',
        size: 27
    },
    {
        id: 'Salerio',
        parent: 'Merchant Of Venice',
        size: 6
    },
    {
        id: 'Shylock',
        parent: 'Merchant Of Venice',
        size: 79
    },
    {
        id: 'Stephano',
        parent: 'Merchant Of Venice',
        size: 3
    },
    {
        id: 'Tubal',
        parent: 'Merchant Of Venice',
        size: 8
    },
    {
        id: "Midsummer Night's Dream",
        parent: 'Comedies',
        size: null
    },
    {
        id: 'Bottom',
        parent: "Midsummer Night's Dream",
        size: 59
    },
    {
        id: 'Cobweb',
        parent: "Midsummer Night's Dream",
        size: 4
    },
    {
        id: 'Demetrius',
        parent: "Midsummer Night's Dream",
        size: 48
    },
    {
        id: 'Egeus',
        parent: "Midsummer Night's Dream",
        size: 7
    },
    {
        id: 'Fairy',
        parent: "Midsummer Night's Dream",
        size: 4
    },
    {
        id: 'Flute',
        parent: "Midsummer Night's Dream",
        size: 18
    },
    {
        id: 'Helena',
        parent: "Midsummer Night's Dream",
        size: 36
    },
    {
        id: 'Hermia',
        parent: "Midsummer Night's Dream",
        size: 48
    },
    {
        id: 'Hippolyta',
        parent: "Midsummer Night's Dream",
        size: 14
    },
    {
        id: 'Lysander',
        parent: "Midsummer Night's Dream",
        size: 50
    },
    {
        id: 'Moth',
        parent: "Midsummer Night's Dream",
        size: 2
    },
    {
        id: 'Mustardseed',
        parent: "Midsummer Night's Dream",
        size: 5
    },
    {
        id: 'Oberon',
        parent: "Midsummer Night's Dream",
        size: 29
    },
    {
        id: 'Peaseblossom',
        parent: "Midsummer Night's Dream",
        size: 4
    },
    {
        id: 'Philostrate',
        parent: "Midsummer Night's Dream",
        size: 6
    },
    {
        id: 'Puck',
        parent: "Midsummer Night's Dream",
        size: 33
    },
    {
        id: 'Quince',
        parent: "Midsummer Night's Dream",
        size: 40
    },
    {
        id: 'Snout',
        parent: "Midsummer Night's Dream",
        size: 9
    },
    {
        id: 'Snug',
        parent: "Midsummer Night's Dream",
        size: 4
    },
    {
        id: 'Starveling',
        parent: "Midsummer Night's Dream",
        size: 7
    },
    {
        id: 'Theseus',
        parent: "Midsummer Night's Dream",
        size: 48
    },
    {
        id: 'Titania',
        parent: "Midsummer Night's Dream",
        size: 23
    },
    {
        id: 'Taming Of The Shrew',
        parent: 'Comedies',
        size: null
    },
    {
        id: 'Baptista Minola',
        parent: 'Taming Of The Shrew',
        size: 68
    },
    {
        id: 'Bianca',
        parent: 'Taming Of The Shrew',
        size: 29
    },
    {
        id: 'Biondello',
        parent: 'Taming Of The Shrew',
        size: 39
    },
    {
        id: 'Christopher Sly',
        parent: 'Taming Of The Shrew',
        size: 24
    },
    {
        id: 'Curtis',
        parent: 'Taming Of The Shrew',
        size: 20
    },
    {
        id: 'Gremio',
        parent: 'Taming Of The Shrew',
        size: 58
    },
    {
        id: 'Grumio',
        parent: 'Taming Of The Shrew',
        size: 63
    },
    {
        id: 'Haberdasher',
        parent: 'Taming Of The Shrew',
        size: 1
    },
    {
        id: 'Hortensio',
        parent: 'Taming Of The Shrew',
        size: 70
    },
    {
        id: 'Joseph',
        parent: 'Taming Of The Shrew',
        size: 1
    },
    {
        id: 'Katherina',
        parent: 'Taming Of The Shrew',
        size: 82
    },
    {
        id: 'Lucentio',
        parent: 'Taming Of The Shrew',
        size: 61
    },
    {
        id: 'Nathaniel',
        parent: 'Taming Of The Shrew',
        size: 4
    },
    {
        id: 'Nicholas',
        parent: 'Taming Of The Shrew',
        size: 1
    },
    {
        id: 'Peter',
        parent: 'Taming Of The Shrew',
        size: 2
    },
    {
        id: 'Petruchio',
        parent: 'Taming Of The Shrew',
        size: 158
    },
    {
        id: 'Philip',
        parent: 'Taming Of The Shrew',
        size: 1
    },
    {
        id: 'Tranio',
        parent: 'Taming Of The Shrew',
        size: 90
    },
    {
        id: 'Vincentio',
        parent: 'Taming Of The Shrew',
        size: 23
    },
    {
        id: 'The Tempest',
        parent: 'Comedies',
        size: null
    },
    {
        id: 'Adrian',
        parent: 'The Tempest',
        size: 9
    },
    {
        id: 'Alonso',
        parent: 'The Tempest',
        size: 40
    },
    {
        id: 'Antonio, duke of Milan',
        parent: 'The Tempest',
        size: 57
    },
    {
        id: 'Ariel',
        parent: 'The Tempest',
        size: 45
    },
    {
        id: 'Caliban',
        parent: 'The Tempest',
        size: 50
    },
    {
        id: 'Ceres',
        parent: 'The Tempest',
        size: 4
    },
    {
        id: 'Ferdinand',
        parent: 'The Tempest',
        size: 31
    },
    {
        id: 'Francisco',
        parent: 'The Tempest',
        size: 2
    },
    {
        id: 'Gonzalo',
        parent: 'The Tempest',
        size: 52
    },
    {
        id: 'Iris',
        parent: 'The Tempest',
        size: 4
    },
    {
        id: 'Juno',
        parent: 'The Tempest',
        size: 2
    },
    {
        id: 'Master',
        parent: 'The Tempest',
        size: 2
    },
    {
        id: 'Miranda',
        parent: 'The Tempest',
        size: 50
    },
    {
        id: 'Nymphs',
        parent: 'The Tempest',
        size: 0
    },
    {
        id: 'Prospero',
        parent: 'The Tempest',
        size: 114
    },
    {
        id: 'Reapers',
        parent: 'The Tempest',
        size: 0
    },
    {
        id: 'Sebastian',
        parent: 'The Tempest',
        size: 67
    },
    {
        id: 'Stephano (Servant to Portia)',
        parent: 'The Tempest',
        size: 60
    },
    {
        id: 'Trinculo',
        parent: 'The Tempest',
        size: 39
    },
    {
        id: 'Henry VIII',
        parent: 'Histories',
        size: null
    },
    {
        id: 'Anne Bullen',
        parent: 'Henry VIII',
        size: 18
    },
    {
        id: 'Archbishop Cranmer',
        parent: 'Henry VIII',
        size: 21
    },
    {
        id: 'Bishop Lincoln',
        parent: 'Henry VIII',
        size: 2
    },
    {
        id: 'Brandon',
        parent: 'Henry VIII',
        size: 6
    },
    {
        id: 'Capucius',
        parent: 'Henry VIII',
        size: 5
    },
    {
        id: 'Cardinal Campeius',
        parent: 'Henry VIII',
        size: 14
    },
    {
        id: 'Cardinal Wolsey',
        parent: 'Henry VIII',
        size: 79
    },
    {
        id: 'Cromwell',
        parent: 'Henry VIII',
        size: 21
    },
    {
        id: 'Doctor Butts',
        parent: 'Henry VIII',
        size: 4
    },
    {
        id: 'Duke of Buckingham',
        parent: 'Henry VIII',
        size: 26
    },
    {
        id: 'Duke of Norfolk',
        parent: 'Henry VIII',
        size: 48
    },
    {
        id: 'Duke of Suffolk',
        parent: 'Henry VIII',
        size: 30
    },
    {
        id: 'Earl of Surrey',
        parent: 'Henry VIII',
        size: 24
    },
    {
        id: 'First Secretary to Wolsey',
        parent: 'Henry VIII',
        size: 2
    },
    {
        id: 'Gardiner',
        parent: 'Henry VIII',
        size: 22
    },
    {
        id: 'Garter',
        parent: 'Henry VIII',
        size: 1
    },
    {
        id: 'Griffith',
        parent: 'Henry VIII',
        size: 13
    },
    {
        id: 'King Henry VIII',
        parent: 'Henry VIII',
        size: 81
    },
    {
        id: 'Lord Abergavenny',
        parent: 'Henry VIII',
        size: 5
    },
    {
        id: 'Lord Chamberlain',
        parent: 'Henry VIII',
        size: 38
    },
    {
        id: 'Lord Chancellor',
        parent: 'Henry VIII',
        size: 7
    },
    {
        id: 'Lord Sands',
        parent: 'Henry VIII',
        size: 17
    },
    {
        id: 'Old Lady',
        parent: 'Henry VIII',
        size: 14
    },
    {
        id: 'Patience',
        parent: 'Henry VIII',
        size: 3
    },
    {
        id: 'Porter (door-keeper of the Council-chamber)',
        parent: 'Henry VIII',
        size: 10
    },
    {
        id: 'Queen Katharine',
        parent: 'Henry VIII',
        size: 50
    },
    {
        id: 'Sir Anthony Denny',
        parent: 'Henry VIII',
        size: 3
    },
    {
        id: 'Sir Henry Guildford',
        parent: 'Henry VIII',
        size: 1
    },
    {
        id: 'Sir Nicholas Vaux',
        parent: 'Henry VIII',
        size: 1
    },
    {
        id: 'Sir Thomas Lovell',
        parent: 'Henry VIII',
        size: 21
    },
    {
        id: 'Surveyor to the Duke of Buckingham',
        parent: 'Henry VIII',
        size: 9
    },
    {
        id: 'History Of King John',
        parent: 'Histories',
        size: null
    },
    {
        id: 'Arthur Duke of Bretagne',
        parent: 'History Of King John',
        size: 23
    },
    {
        id: 'Blanch',
        parent: 'History Of King John',
        size: 9
    },
    {
        id: 'Cardinal Pandulph',
        parent: 'History Of King John',
        size: 23
    },
    {
        id: 'Chatillon',
        parent: 'History Of King John',
        size: 5
    },
    {
        id: 'Constance',
        parent: 'History Of King John',
        size: 36
    },
    {
        id: 'Essex',
        parent: 'History Of King John',
        size: 1
    },
    {
        id: 'Faulconbridge',
        parent: 'History Of King John',
        size: 4
    },
    {
        id: 'Hubert de Burgh',
        parent: 'History Of King John',
        size: 52
    },
    {
        id: 'James Gurney',
        parent: 'History Of King John',
        size: 1
    },
    {
        id: 'King John',
        parent: 'History Of King John',
        size: 95
    },
    {
        id: 'King Phillip',
        parent: 'History Of King John',
        size: 43
    },
    {
        id: 'Lady Faulconbridge',
        parent: 'History Of King John',
        size: 5
    },
    {
        id: 'Lewis the Dauphin',
        parent: 'History Of King John',
        size: 29
    },
    {
        id: 'Lord Bigot',
        parent: 'History Of King John',
        size: 6
    },
    {
        id: 'Lymoges duke of Austria',
        parent: 'History Of King John',
        size: 16
    },
    {
        id: 'Melun',
        parent: 'History Of King John',
        size: 3
    },
    {
        id: 'Pembroke earl of Pembroke',
        parent: 'History Of King John',
        size: 20
    },
    {
        id: 'Peter of Pomfret',
        parent: 'History Of King John',
        size: 1
    },
    {
        id: 'Philip the Bastard',
        parent: 'History Of King John',
        size: 89
    },
    {
        id: 'Prince Henry',
        parent: 'History Of King John',
        size: 8
    },
    {
        id: 'Queen Elinor',
        parent: 'History Of King John',
        size: 22
    },
    {
        id: 'Salisbury earl of Salisbury',
        parent: 'History Of King John',
        size: 36
    },
    {
        id: 'Antony And Cleopatra',
        parent: 'Tragedies',
        size: null
    },
    {
        id: 'Agrippa',
        parent: 'Antony And Cleopatra',
        size: 28
    },
    {
        id: 'Alexas',
        parent: 'Antony And Cleopatra',
        size: 15
    },
    {
        id: 'Antony',
        parent: 'Antony And Cleopatra',
        size: 202
    },
    {
        id: 'Canidius',
        parent: 'Antony And Cleopatra',
        size: 10
    },
    {
        id: 'Captain',
        parent: 'Antony And Cleopatra',
        size: 1
    },
    {
        id: 'Charmian',
        parent: 'Antony And Cleopatra',
        size: 63
    },
    {
        id: 'Cleopatra',
        parent: 'Antony And Cleopatra',
        size: 204
    },
    {
        id: 'Demetrius (Friend to Antony)',
        parent: 'Antony And Cleopatra',
        size: 2
    },
    {
        id: 'Dercetas',
        parent: 'Antony And Cleopatra',
        size: 5
    },
    {
        id: 'Diomedes',
        parent: 'Antony And Cleopatra',
        size: 7
    },
    {
        id: 'Dolabella',
        parent: 'Antony And Cleopatra',
        size: 23
    },
    {
        id: 'Domitius Enobarus',
        parent: 'Antony And Cleopatra',
        size: 113
    },
    {
        id: 'Egyptian',
        parent: 'Antony And Cleopatra',
        size: 2
    },
    {
        id: 'Eros',
        parent: 'Antony And Cleopatra',
        size: 27
    },
    {
        id: 'Euphronius',
        parent: 'Antony And Cleopatra',
        size: 5
    },
    {
        id: 'Gallus',
        parent: 'Antony And Cleopatra',
        size: 1
    },
    {
        id: 'Iras',
        parent: 'Antony And Cleopatra',
        size: 18
    },
    {
        id: 'Lepidus',
        parent: 'Antony And Cleopatra',
        size: 30
    },
    {
        id: 'Mardian',
        parent: 'Antony And Cleopatra',
        size: 7
    },
    {
        id: 'Mecaenas',
        parent: 'Antony And Cleopatra',
        size: 16
    },
    {
        id: 'Menas',
        parent: 'Antony And Cleopatra',
        size: 35
    },
    {
        id: 'Menecrates',
        parent: 'Antony And Cleopatra',
        size: 2
    },
    {
        id: 'Octavia',
        parent: 'Antony And Cleopatra',
        size: 13
    },
    {
        id: 'Octavius',
        parent: 'Antony And Cleopatra',
        size: 98
    },
    {
        id: 'Philo',
        parent: 'Antony And Cleopatra',
        size: 2
    },
    {
        id: 'Pompey',
        parent: 'Antony And Cleopatra',
        size: 41
    },
    {
        id: 'Proculeius',
        parent: 'Antony And Cleopatra',
        size: 10
    },
    {
        id: 'Scarus',
        parent: 'Antony And Cleopatra',
        size: 12
    },
    {
        id: 'Seleucus',
        parent: 'Antony And Cleopatra',
        size: 3
    },
    {
        id: 'Silius',
        parent: 'Antony And Cleopatra',
        size: 3
    },
    {
        id: 'Taurus',
        parent: 'Antony And Cleopatra',
        size: 1
    },
    {
        id: 'Thyreus',
        parent: 'Antony And Cleopatra',
        size: 12
    },
    {
        id: 'Varrius',
        parent: 'Antony And Cleopatra',
        size: 1
    },
    {
        id: 'Ventidius',
        parent: 'Antony And Cleopatra',
        size: 4
    },
    {
        id: 'Coriolanus',
        parent: 'Tragedies',
        size: null
    },
    {
        id: 'Aedile',
        parent: 'Coriolanus',
        size: 10
    },
    {
        id: 'Cominius',
        parent: 'Coriolanus',
        size: 67
    },
    {
        id: 'Coriolanus (Caius Marcius Coriolanus)',
        parent: 'Coriolanus',
        size: 189
    },
    {
        id: 'Junius Brutus',
        parent: 'Coriolanus',
        size: 91
    },
    {
        id: 'Lieutenant',
        parent: 'Coriolanus',
        size: 4
    },
    {
        id: 'Menenius Agrippa',
        parent: 'Coriolanus',
        size: 162
    },
    {
        id: 'Patrician',
        parent: 'Coriolanus',
        size: 3
    },
    {
        id: 'Roman',
        parent: 'Coriolanus',
        size: 10
    },
    {
        id: 'Sicinius Velutus',
        parent: 'Coriolanus',
        size: 117
    },
    {
        id: 'Titus Lartius',
        parent: 'Coriolanus',
        size: 23
    },
    {
        id: 'Tullus Aufidius',
        parent: 'Coriolanus',
        size: 45
    },
    {
        id: 'Valeria',
        parent: 'Coriolanus',
        size: 14
    },
    {
        id: 'Virgilia',
        parent: 'Coriolanus',
        size: 26
    },
    {
        id: 'Volsce',
        parent: 'Coriolanus',
        size: 9
    },
    {
        id: 'Volumnia',
        parent: 'Coriolanus',
        size: 57
    },
    {
        id: 'Young Coriolanus',
        parent: 'Coriolanus',
        size: 1
    },
    {
        id: 'Cymbeline',
        parent: 'Tragedies',
        size: null
    },
    {
        id: 'Arviragus',
        parent: 'Cymbeline',
        size: 46
    },
    {
        id: 'Belarius',
        parent: 'Cymbeline',
        size: 58
    },
    {
        id: 'Caius Lucius',
        parent: 'Cymbeline',
        size: 25
    },
    {
        id: 'Cloten',
        parent: 'Cymbeline',
        size: 77
    },
    {
        id: 'Cornelius (physician)',
        parent: 'Cymbeline',
        size: 13
    },
    {
        id: 'Cymbeline, King of Britain',
        parent: 'Cymbeline',
        size: 81
    },
    {
        id: 'Guiderius',
        parent: 'Cymbeline',
        size: 62
    },
    {
        id: 'Helen',
        parent: 'Cymbeline',
        size: 0
    },
    {
        id: 'Iachimo',
        parent: 'Cymbeline',
        size: 77
    },
    {
        id: 'Imogen',
        parent: 'Cymbeline',
        size: 118
    },
    {
        id: 'Jupiter',
        parent: 'Cymbeline',
        size: 1
    },
    {
        id: 'Philario',
        parent: 'Cymbeline',
        size: 14
    },
    {
        id: 'Pisanio',
        parent: 'Cymbeline',
        size: 58
    },
    {
        id: 'Posthumus Leonatus',
        parent: 'Cymbeline',
        size: 77
    },
    {
        id: 'Queen',
        parent: 'Cymbeline',
        size: 27
    },
    {
        id: 'Roman Captain',
        parent: 'Cymbeline',
        size: 4
    },
    {
        id: 'Sicilius Leonatus',
        parent: 'Cymbeline',
        size: 7
    },
    {
        id: 'The Tragedy of Hamlet, Prince of Denmark',
        parent: 'Tragedies',
        size: null
    },
    {
        id: 'Bernardo',
        parent: 'The Tragedy of Hamlet, Prince of Denmark',
        size: 19
    },
    {
        id: 'Claudius, King of Denmark',
        parent: 'The Tragedy of Hamlet, Prince of Denmark',
        size: 102
    },
    {
        id: 'Cornelius',
        parent: 'The Tragedy of Hamlet, Prince of Denmark',
        size: 1
    },
    {
        id: "Father's Ghost",
        parent: 'The Tragedy of Hamlet, Prince of Denmark',
        size: 15
    },
    {
        id: 'Fortinbras',
        parent: 'The Tragedy of Hamlet, Prince of Denmark',
        size: 6
    },
    {
        id: 'Francisco ',
        parent: 'The Tragedy of Hamlet, Prince of Denmark',
        size: 8
    },
    {
        id: 'Gertrude',
        parent: 'The Tragedy of Hamlet, Prince of Denmark',
        size: 69
    },
    {
        id: 'Guildenstern',
        parent: 'The Tragedy of Hamlet, Prince of Denmark',
        size: 29
    },
    {
        id: 'Hamlet',
        parent: 'The Tragedy of Hamlet, Prince of Denmark',
        size: 358
    },
    {
        id: 'Horatio',
        parent: 'The Tragedy of Hamlet, Prince of Denmark',
        size: 109
    },
    {
        id: 'Laertes',
        parent: 'The Tragedy of Hamlet, Prince of Denmark',
        size: 62
    },
    {
        id: 'Lucianus',
        parent: 'The Tragedy of Hamlet, Prince of Denmark',
        size: 0
    },
    {
        id: 'Marcellus',
        parent: 'The Tragedy of Hamlet, Prince of Denmark',
        size: 37
    },
    {
        id: 'Ophelia',
        parent: 'The Tragedy of Hamlet, Prince of Denmark',
        size: 58
    },
    {
        id: 'Osric',
        parent: 'The Tragedy of Hamlet, Prince of Denmark',
        size: 25
    },
    {
        id: 'Polonius',
        parent: 'The Tragedy of Hamlet, Prince of Denmark',
        size: 86
    },
    {
        id: 'Reynaldo',
        parent: 'The Tragedy of Hamlet, Prince of Denmark',
        size: 13
    },
    {
        id: 'Rosencrantz',
        parent: 'The Tragedy of Hamlet, Prince of Denmark',
        size: 48
    },
    {
        id: 'Voltemand',
        parent: 'The Tragedy of Hamlet, Prince of Denmark',
        size: 1
    },
    {
        id: 'Julius Caesar',
        parent: 'Tragedies',
        size: null
    },
    {
        id: 'Antony (Marcus Antonius)',
        parent: 'Julius Caesar',
        size: 51
    },
    {
        id: 'Artemidorus of Cnidos',
        parent: 'Julius Caesar',
        size: 4
    },
    {
        id: 'Brutus (Marcus Brutus)',
        parent: 'Julius Caesar',
        size: 194
    },
    {
        id: 'Caesar (Julius Caesar)',
        parent: 'Julius Caesar',
        size: 42
    },
    {
        id: 'Calpurnia',
        parent: 'Julius Caesar',
        size: 6
    },
    {
        id: 'Casca',
        parent: 'Julius Caesar',
        size: 39
    },
    {
        id: 'Cassius',
        parent: 'Julius Caesar',
        size: 140
    },
    {
        id: 'Cicero',
        parent: 'Julius Caesar',
        size: 4
    },
    {
        id: 'Cinna',
        parent: 'Julius Caesar',
        size: 11
    },
    {
        id: 'Cinna the Poet',
        parent: 'Julius Caesar',
        size: 8
    },
    {
        id: 'Claudius',
        parent: 'Julius Caesar',
        size: 2
    },
    {
        id: 'Clitus',
        parent: 'Julius Caesar',
        size: 8
    },
    {
        id: 'Dardanius',
        parent: 'Julius Caesar',
        size: 3
    },
    {
        id: 'Decius Brutus',
        parent: 'Julius Caesar',
        size: 12
    },
    {
        id: 'Flavius',
        parent: 'Julius Caesar',
        size: 5
    },
    {
        id: 'Lepidus (Marcus Antonius Lepidus)',
        parent: 'Julius Caesar',
        size: 3
    },
    {
        id: 'Ligarius',
        parent: 'Julius Caesar',
        size: 5
    },
    {
        id: 'Lucilius',
        parent: 'Julius Caesar',
        size: 10
    },
    {
        id: 'Lucius',
        parent: 'Julius Caesar',
        size: 24
    },
    {
        id: 'Marullus',
        parent: 'Julius Caesar',
        size: 6
    },
    {
        id: 'Messala',
        parent: 'Julius Caesar',
        size: 20
    },
    {
        id: 'Metellus Cimber',
        parent: 'Julius Caesar',
        size: 5
    },
    {
        id: 'Octavius (Octavius Caesar)',
        parent: 'Julius Caesar',
        size: 19
    },
    {
        id: 'Pindarus',
        parent: 'Julius Caesar',
        size: 5
    },
    {
        id: 'Popilius (Popilius Lena)',
        parent: 'Julius Caesar',
        size: 2
    },
    {
        id: 'Portia (wife of Brutus)',
        parent: 'Julius Caesar',
        size: 16
    },
    {
        id: 'Publius',
        parent: 'Julius Caesar',
        size: 2
    },
    {
        id: 'Strato',
        parent: 'Julius Caesar',
        size: 4
    },
    {
        id: 'Tintinius',
        parent: 'Julius Caesar',
        size: 10
    },
    {
        id: 'Trebonius',
        parent: 'Julius Caesar',
        size: 4
    },
    {
        id: 'Varro',
        parent: 'Julius Caesar',
        size: 6
    },
    {
        id: 'Volumnius',
        parent: 'Julius Caesar',
        size: 3
    },
    {
        id: 'Young Cato',
        parent: 'Julius Caesar',
        size: 3
    },
    {
        id: 'King Lear',
        parent: 'Tragedies',
        size: null
    },
    {
        id: 'Cordelia',
        parent: 'King Lear',
        size: 31
    },
    {
        id: 'Curan',
        parent: 'King Lear',
        size: 4
    },
    {
        id: 'Duke of Albany',
        parent: 'King Lear',
        size: 58
    },
    {
        id: 'Duke of Burgundy',
        parent: 'King Lear',
        size: 5
    },
    {
        id: 'Duke of Cornwall',
        parent: 'King Lear',
        size: 53
    },
    {
        id: 'Earl of Gloucester',
        parent: 'King Lear',
        size: 118
    },
    {
        id: 'Earl of Kent',
        parent: 'King Lear',
        size: 127
    },
    {
        id: 'Edgar',
        parent: 'King Lear',
        size: 98
    },
    {
        id: 'Edmund',
        parent: 'King Lear',
        size: 79
    },
    {
        id: 'Goneril',
        parent: 'King Lear',
        size: 53
    },
    {
        id: 'King of France',
        parent: 'King Lear',
        size: 5
    },
    {
        id: 'Lear',
        parent: 'King Lear',
        size: 188
    },
    {
        id: 'Oswald',
        parent: 'King Lear',
        size: 38
    },
    {
        id: 'Regan',
        parent: 'King Lear',
        size: 73
    },
    {
        id: 'The Tragedy Of Macbeth',
        parent: 'Tragedies',
        size: null
    },
    {
        id: 'Angus',
        parent: 'The Tragedy Of Macbeth',
        size: 4
    },
    {
        id: 'Banquo',
        parent: 'The Tragedy Of Macbeth',
        size: 33
    },
    {
        id: 'Caithness',
        parent: 'The Tragedy Of Macbeth',
        size: 3
    },
    {
        id: 'Donalbain',
        parent: 'The Tragedy Of Macbeth',
        size: 3
    },
    {
        id: 'Duncan',
        parent: 'The Tragedy Of Macbeth',
        size: 18
    },
    {
        id: 'Fleance',
        parent: 'The Tragedy Of Macbeth',
        size: 2
    },
    {
        id: 'Hecate',
        parent: 'The Tragedy Of Macbeth',
        size: 2
    },
    {
        id: 'Lady Macbeth',
        parent: 'The Tragedy Of Macbeth',
        size: 59
    },
    {
        id: 'Lady Macduff',
        parent: 'The Tragedy Of Macbeth',
        size: 19
    },
    {
        id: 'Lennox',
        parent: 'The Tragedy Of Macbeth',
        size: 21
    },
    {
        id: 'Macbeth',
        parent: 'The Tragedy Of Macbeth',
        size: 146
    },
    {
        id: 'Macduff',
        parent: 'The Tragedy Of Macbeth',
        size: 59
    },
    {
        id: 'Malcolm',
        parent: 'The Tragedy Of Macbeth',
        size: 40
    },
    {
        id: 'Menteith',
        parent: 'The Tragedy Of Macbeth',
        size: 5
    },
    {
        id: 'Porter',
        parent: 'The Tragedy Of Macbeth',
        size: 4
    },
    {
        id: 'Ross',
        parent: 'The Tragedy Of Macbeth',
        size: 39
    },
    {
        id: 'Seyton',
        parent: 'The Tragedy Of Macbeth',
        size: 5
    },
    {
        id: 'Siward',
        parent: 'The Tragedy Of Macbeth',
        size: 11
    },
    {
        id: "Son (Macduff's son)",
        parent: 'The Tragedy Of Macbeth',
        size: 14
    },
    {
        id: 'Young Siward',
        parent: 'The Tragedy Of Macbeth',
        size: 4
    },
    {
        id: 'The Tragedy Of Othello',
        parent: 'Tragedies',
        size: null
    },
    {
        id: 'Bianca (Mistress to Cassio)',
        parent: 'The Tragedy Of Othello',
        size: 15
    },
    {
        id: 'Brabantio',
        parent: 'The Tragedy Of Othello',
        size: 30
    },
    {
        id: 'Cassio',
        parent: 'The Tragedy Of Othello',
        size: 110
    },
    {
        id: 'Desdemona',
        parent: 'The Tragedy Of Othello',
        size: 165
    },
    {
        id: 'Duke of Venice',
        parent: 'The Tragedy Of Othello',
        size: 25
    },
    {
        id: 'Emilia',
        parent: 'The Tragedy Of Othello',
        size: 103
    },
    {
        id: 'Gratiano (Brother to Brabantio)',
        parent: 'The Tragedy Of Othello',
        size: 20
    },
    {
        id: 'Iago',
        parent: 'The Tragedy Of Othello',
        size: 272
    },
    {
        id: 'Lodovico',
        parent: 'The Tragedy Of Othello',
        size: 33
    },
    {
        id: 'Montano',
        parent: 'The Tragedy Of Othello',
        size: 24
    },
    {
        id: 'Othello',
        parent: 'The Tragedy Of Othello',
        size: 274
    },
    {
        id: 'Roderigo',
        parent: 'The Tragedy Of Othello',
        size: 59
    },
    {
        id: 'Romeo And Juliet',
        parent: 'Tragedies',
        size: null
    },
    {
        id: 'Abraham',
        parent: 'Romeo And Juliet',
        size: 5
    },
    {
        id: 'Balthasar (Servant to Romeo)',
        parent: 'Romeo And Juliet',
        size: 12
    },
    {
        id: 'Benvolio',
        parent: 'Romeo And Juliet',
        size: 64
    },
    {
        id: 'Capulet',
        parent: 'Romeo And Juliet',
        size: 51
    },
    {
        id: 'Friar John',
        parent: 'Romeo And Juliet',
        size: 4
    },
    {
        id: 'Friar Laurence',
        parent: 'Romeo And Juliet',
        size: 55
    },
    {
        id: 'Gregory',
        parent: 'Romeo And Juliet',
        size: 15
    },
    {
        id: 'Juliet',
        parent: 'Romeo And Juliet',
        size: 118
    },
    {
        id: 'Lady Capulet',
        parent: 'Romeo And Juliet',
        size: 45
    },
    {
        id: 'Lady Montague',
        parent: 'Romeo And Juliet',
        size: 2
    },
    {
        id: 'Mercutio',
        parent: 'Romeo And Juliet',
        size: 62
    },
    {
        id: 'Montague',
        parent: 'Romeo And Juliet',
        size: 10
    },
    {
        id: 'Paris',
        parent: 'Romeo And Juliet',
        size: 23
    },
    {
        id: "Peter (Servant to Juliet's Nurse)",
        parent: 'Romeo And Juliet',
        size: 13
    },
    {
        id: 'Prince Escalus',
        parent: 'Romeo And Juliet',
        size: 16
    },
    {
        id: 'Romeo',
        parent: 'Romeo And Juliet',
        size: 163
    },
    {
        id: 'Sampson',
        parent: 'Romeo And Juliet',
        size: 20
    },
    {
        id: 'Tybalt',
        parent: 'Romeo And Juliet',
        size: 17
    }
];
var $66ef3598a56ddb7c$export$2e2bcd8739ae039 = $66ef3598a56ddb7c$var$shakespeare;




// @visx/network


var $5E6i4 = parcelRequire("5E6i4");



function $1762e4a107294077$export$2e2bcd8739ae039(_ref) {
    let { links: links = [], linkComponent: linkComponent, className: className } = _ref;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: links.map((link, i)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $268dd56f34f61467$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-network-link', className),
                children: /*#__PURE__*/ (0, $5E6i4.createElement)(linkComponent, {
                    link: link
                })
            }, `network-link-${i}`))
    });
}



var $5E6i4 = parcelRequire("5E6i4");



function $e1c55b3960e8892c$export$2e2bcd8739ae039(_ref) {
    let { r: r = 15, fill: fill = '#21D4FD', node: node, // Accept but don't use the node prop
    ...rest } = _ref;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("circle", {
        r: r,
        fill: fill,
        ...rest
    });
}



function $bbef781418e1ae7b$export$2e2bcd8739ae039(_ref) {
    let { nodes: nodes = [], nodeComponent: nodeComponent = (0, $e1c55b3960e8892c$export$2e2bcd8739ae039), className: className, x: x = (d)=>d?.x || 0, y: // eslint-disable-line @typescript-eslint/no-explicit-any
    y = (d)=>d?.y || 0 // eslint-disable-line @typescript-eslint/no-explicit-any
     } = _ref;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: nodes.map((node, i)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $268dd56f34f61467$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-network-node', className),
                left: x(node),
                top: y(node),
                children: /*#__PURE__*/ (0, $5E6i4.createElement)(nodeComponent, {
                    node: node
                })
            }, `network-node-${i}`))
    });
}




function $95efd74e1e6dc0f9$export$2e2bcd8739ae039(_ref) {
    let { link: link } = _ref;
    return link?.source && link.target ? /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("line", {
        x1: link.source.x,
        y1: link.source.y,
        x2: link.target.x,
        y2: link.target.y,
        strokeWidth: 2,
        stroke: "#999",
        strokeOpacity: 0.6
    }) : null;
}



function $40c2ddd7a24ea06e$export$2e2bcd8739ae039(_ref) {
    let { graph: graph, linkComponent: linkComponent = (0, $95efd74e1e6dc0f9$export$2e2bcd8739ae039), nodeComponent: nodeComponent = (0, $e1c55b3960e8892c$export$2e2bcd8739ae039), top: top, left: left } = _ref;
    return graph ? /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)((0, $268dd56f34f61467$export$2e2bcd8739ae039), {
        top: top,
        left: left,
        children: [
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $1762e4a107294077$export$2e2bcd8739ae039), {
                links: graph.links,
                linkComponent: linkComponent
            }),
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $bbef781418e1ae7b$export$2e2bcd8739ae039), {
                nodes: graph.nodes,
                nodeComponent: nodeComponent
            })
        ]
    }) : null;
}








// @visx/pattern

function $a42b1188a19ec189$export$2e2bcd8739ae039(_ref) {
    let { id: id, width: width, height: height, children: children } = _ref;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("defs", {
        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("pattern", {
            id: id,
            width: width,
            height: height,
            patternUnits: "userSpaceOnUse",
            children: children
        })
    });
}




const $06eb7b3501750213$export$c37d4d4692ef0c91 = {
    horizontal: 'horizontal',
    vertical: 'vertical',
    diagonal: 'diagonal',
    diagonalRightToLeft: 'diagonalRightToLeft'
};



function $5e908c4911e2ef3d$export$777054cdc3eb6ab2(_ref) {
    let { height: height, orientation: orientation } = _ref;
    switch(orientation){
        case (0, $06eb7b3501750213$export$c37d4d4692ef0c91).horizontal:
            return `M 0,${height / 2} l ${height},0`;
        case (0, $06eb7b3501750213$export$c37d4d4692ef0c91).diagonal:
            return `M 0,${height} l ${height},${-height} M ${-height / 4},${height / 4} l ${height / 2},${-height / 2}
             M ${3 / 4 * height},${5 / 4 * height} l ${height / 2},${-height / 2}`;
        case (0, $06eb7b3501750213$export$c37d4d4692ef0c91).diagonalRightToLeft:
            return `M 0,0 l ${height},${height}
        M ${-height / 4},${3 / 4 * height} l ${height / 2},${height / 2}
        M ${3 / 4 * height},${-height / 4} l ${height / 2},${height / 2}`;
        case (0, $06eb7b3501750213$export$c37d4d4692ef0c91).vertical:
        default:
            return `M ${height / 2}, 0 l 0, ${height}`;
    }
}
function $5e908c4911e2ef3d$export$2e2bcd8739ae039(_ref2) {
    let { id: id, width: width, height: height, stroke: stroke, strokeWidth: strokeWidth, strokeDasharray: strokeDasharray, strokeLinecap: strokeLinecap = 'square', shapeRendering: shapeRendering = 'auto', orientation: orientation = [
        'vertical'
    ], background: background, className: className } = _ref2;
    const orientations = Array.isArray(orientation) ? orientation : [
        orientation
    ];
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)((0, $a42b1188a19ec189$export$2e2bcd8739ae039), {
        id: id,
        width: width,
        height: height,
        children: [
            !!background && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("rect", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-pattern-line-background'),
                width: width,
                height: height,
                fill: background
            }),
            orientations.map((o, i)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("path", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-pattern-line', className),
                    d: $5e908c4911e2ef3d$export$777054cdc3eb6ab2({
                        orientation: o,
                        height: height
                    }),
                    stroke: stroke,
                    strokeWidth: strokeWidth,
                    strokeDasharray: strokeDasharray,
                    strokeLinecap: strokeLinecap,
                    shapeRendering: shapeRendering
                }, `visx-${id}-line-${o}-${i}`))
        ]
    });
}





function $d1427be6b1df8507$export$2e2bcd8739ae039(_ref) {
    let { id: id, width: width, height: height, radius: radius = 2, fill: fill, stroke: stroke, strokeWidth: strokeWidth, strokeDasharray: strokeDasharray, background: background, complement: complement = false, className: className } = _ref;
    let corners;
    if (complement) corners = [
        [
            0,
            0
        ],
        [
            0,
            height
        ],
        [
            width,
            0
        ],
        [
            width,
            height
        ]
    ];
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)((0, $a42b1188a19ec189$export$2e2bcd8739ae039), {
        id: id,
        width: width,
        height: height,
        children: [
            !!background && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("rect", {
                width: width,
                height: height,
                fill: background
            }),
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("circle", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-pattern-circle', className),
                cx: width / 2,
                cy: height / 2,
                r: radius,
                fill: fill,
                stroke: stroke,
                strokeWidth: strokeWidth,
                strokeDasharray: strokeDasharray
            }),
            corners?.map((_ref2)=>{
                let [cornerX, cornerY] = _ref2;
                return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("circle", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-pattern-circle visx-pattern-circle-complement', className),
                    cx: cornerX,
                    cy: cornerY,
                    r: radius,
                    fill: fill,
                    stroke: stroke,
                    strokeWidth: strokeWidth,
                    strokeDasharray: strokeDasharray
                }, `${id}-complement-${cornerX}-${cornerY}`);
            })
        ]
    });
}






function $0df39ffed2a62f41$export$2e2bcd8739ae039(_ref) {
    let { id: id, width: width, height: height, path: path, fill: fill = 'transparent', stroke: stroke, strokeWidth: strokeWidth, strokeDasharray: strokeDasharray, strokeLinecap: strokeLinecap = 'square', shapeRendering: shapeRendering = 'auto', background: background, className: className } = _ref;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)((0, $a42b1188a19ec189$export$2e2bcd8739ae039), {
        id: id,
        width: width,
        height: height,
        children: [
            !!background && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("rect", {
                width: width,
                height: height,
                fill: background
            }),
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("path", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-pattern-path', className),
                d: path,
                fill: fill,
                stroke: stroke,
                strokeWidth: strokeWidth,
                strokeDasharray: strokeDasharray,
                strokeLinecap: strokeLinecap,
                shapeRendering: shapeRendering
            })
        ]
    });
}



function $9a000481cffa0d43$export$2e2bcd8739ae039(_ref) {
    let { id: id, width: width, height: height, fill: fill, stroke: stroke, strokeWidth: strokeWidth, strokeDasharray: strokeDasharray, strokeLinecap: strokeLinecap, shapeRendering: shapeRendering, background: background, className: className } = _ref;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $0df39ffed2a62f41$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-pattern-wave', className),
        path: `M 0 ${height / 2} c ${height / 8} ${-height / 4} , ${height * 3 / 8} ${-height / 4} , ${height / 2} 0
             c ${height / 8} ${height / 4} , ${height * 3 / 8} ${height / 4} , ${height / 2} 0 M ${-height / 2} ${height / 2}
             c ${height / 8} ${height / 4} , ${height * 3 / 8} ${height / 4} , ${height / 2} 0 M ${height} ${height / 2}
             c ${height / 8} ${-height / 4} , ${height * 3 / 8} ${-height / 4} , ${height / 2} 0`,
        id: id,
        width: width,
        height: height,
        fill: fill,
        stroke: stroke,
        strokeWidth: strokeWidth,
        strokeDasharray: strokeDasharray,
        strokeLinecap: strokeLinecap,
        shapeRendering: shapeRendering,
        background: background
    });
}





function $080e17e0af26366b$export$2e2bcd8739ae039(_ref) {
    let { id: id, height: height, fill: fill, stroke: stroke, strokeWidth: strokeWidth, strokeDasharray: strokeDasharray, strokeLinecap: strokeLinecap, shapeRendering: shapeRendering, background: background, className: className, size: size = 3 } = _ref;
    const sqrtSize = Math.sqrt(size);
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $0df39ffed2a62f41$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-pattern-hexagon', className),
        path: `M ${height},0 l ${height},0 l ${height / 2},${height * sqrtSize / 2} l ${-height / 2},${height * sqrtSize / 2} l ${-height},0 l ${-height / 2},${-height * sqrtSize / 2} Z M 0,${height * sqrtSize / 2} l ${height / 2},0 M ${3 * height},${height * sqrtSize / 2} l ${-height / 2},0`,
        id: id,
        width: size,
        height: sqrtSize,
        fill: fill,
        stroke: stroke,
        strokeWidth: strokeWidth,
        strokeDasharray: strokeDasharray,
        strokeLinecap: strokeLinecap,
        shapeRendering: shapeRendering,
        background: background
    });
}







var $c54f2a1238da1ae4$exports = {};

$parcel$export($c54f2a1238da1ae4$exports, "ParentSize", () => $66012142a13b7a2b$export$2e2bcd8739ae039);
$parcel$export($c54f2a1238da1ae4$exports, "ScaleSVG", () => $9c8d98022b8c112f$export$2e2bcd8739ae039);
$parcel$export($c54f2a1238da1ae4$exports, "withParentSize", () => $3a651eaaa3d1cb8f$export$2e2bcd8739ae039);
$parcel$export($c54f2a1238da1ae4$exports, "withScreenSize", () => $c0cb84a9eaede922$export$2e2bcd8739ae039);
$parcel$export($c54f2a1238da1ae4$exports, "useParentSize", () => $c9d9c799c0ffe8ed$export$2e2bcd8739ae039);
$parcel$export($c54f2a1238da1ae4$exports, "useScreenSize", () => $65ca56ad72721c29$export$2e2bcd8739ae039);
$parcel$export($c54f2a1238da1ae4$exports, "debounce", () => $1cd3ba1ba76c811a$export$61fc7d43ac8f84b0);
// @visx/responsive

var $5E6i4 = parcelRequire("5E6i4");
/**
 * Creates a debounced function that delays invoking `func` until after `wait` milliseconds
 * have elapsed since the last invocation.
 *
 * When `leading` is true, the function fires immediately on the first call (leading edge),
 * and also fires on the trailing edge if there were subsequent calls during the wait period
 * (matching lodash behavior with leading:true, trailing:true).
 */ function $1cd3ba1ba76c811a$export$61fc7d43ac8f84b0(func, wait) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const { leading: leading = false } = options;
    let timeoutId;
    // Track args for the trailing call; null means no subsequent calls after leading
    let pendingArgs = null;
    let pendingContext;
    function debounced() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (leading && timeoutId === undefined) {
            // Fire immediately on the leading edge, no pending trailing needed yet
            func.apply(this, args);
            pendingArgs = null;
        } else {
            // Record these args for the trailing call
            pendingArgs = args;
            pendingContext = this;
        }
        clearTimeout(timeoutId);
        timeoutId = setTimeout(()=>{
            timeoutId = undefined;
            if (pendingArgs !== null) {
                func.apply(pendingContext, pendingArgs);
                pendingArgs = null;
                pendingContext = undefined;
            }
        }, wait);
    }
    debounced.cancel = function cancel() {
        clearTimeout(timeoutId);
        timeoutId = undefined;
        pendingArgs = null;
        pendingContext = undefined;
    };
    return debounced;
}


const $c9d9c799c0ffe8ed$var$defaultIgnoreDimensions = [];
const $c9d9c799c0ffe8ed$var$defaultInitialSize = {
    width: 0,
    height: 0,
    top: 0,
    left: 0
};
function $c9d9c799c0ffe8ed$export$2e2bcd8739ae039() {
    let { initialSize: initialSize = $c9d9c799c0ffe8ed$var$defaultInitialSize, debounceTime: debounceTime = 300, ignoreDimensions: ignoreDimensions = $c9d9c799c0ffe8ed$var$defaultIgnoreDimensions, enableDebounceLeadingCall: enableDebounceLeadingCall = true, resizeObserverPolyfill: resizeObserverPolyfill, externalRef: externalRef } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const [node, setNode] = (0, $5E6i4.useState)(null);
    const parentRef = (0, $5E6i4.useCallback)((el)=>{
        setNode(el);
        if (typeof externalRef === 'function') externalRef(el);
        else if (externalRef != null) // eslint-disable-next-line no-param-reassign -- standard ref-merging pattern
        externalRef.current = el;
    }, [
        externalRef
    ]);
    const animationFrameID = (0, $5E6i4.useRef)(0);
    const [state, setState] = (0, $5E6i4.useState)({
        ...$c9d9c799c0ffe8ed$var$defaultInitialSize,
        ...initialSize
    });
    const resize = (0, $5E6i4.useMemo)(()=>{
        const normalized = Array.isArray(ignoreDimensions) ? ignoreDimensions : [
            ignoreDimensions
        ];
        return (0, $1cd3ba1ba76c811a$export$61fc7d43ac8f84b0)((incoming)=>{
            setState((existing)=>{
                const stateKeys = Object.keys(existing);
                const keysWithChanges = stateKeys.filter((key)=>existing[key] !== incoming[key]);
                const shouldBail = keysWithChanges.every((key)=>normalized.includes(key));
                return shouldBail ? existing : incoming;
            });
        }, debounceTime, {
            leading: enableDebounceLeadingCall
        });
    }, [
        debounceTime,
        enableDebounceLeadingCall,
        ignoreDimensions
    ]);
    (0, $5E6i4.useEffect)(()=>{
        if (!node) {
            resize.cancel();
            return;
        }
        const LocalResizeObserver = resizeObserverPolyfill || window.ResizeObserver;
        const observer = new LocalResizeObserver((entries)=>{
            entries.forEach((entry)=>{
                const { left: left, top: top, width: width, height: height } = entry?.contentRect ?? {};
                animationFrameID.current = window.requestAnimationFrame(()=>{
                    resize({
                        width: width,
                        height: height,
                        top: top,
                        left: left
                    });
                });
            });
        });
        observer.observe(node);
        return ()=>{
            window.cancelAnimationFrame(animationFrameID.current);
            observer.disconnect();
            resize.cancel();
        };
    }, [
        node,
        resize,
        resizeObserverPolyfill
    ]);
    return {
        parentRef: parentRef,
        node: node,
        resize: resize,
        ...state
    };
}



const $66012142a13b7a2b$var$defaultOuterStyles = {
    width: '100%',
    height: '100%',
    position: 'relative'
};
const $66012142a13b7a2b$var$measurementStyles = {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    overflow: 'hidden'
};
function $66012142a13b7a2b$export$2e2bcd8739ae039(_ref) {
    let { className: className, children: children, debounceTime: debounceTime, ignoreDimensions: ignoreDimensions, initialSize: initialSize, parentSizeStyles: parentSizeStyles, enableDebounceLeadingCall: enableDebounceLeadingCall = true, resizeObserverPolyfill: resizeObserverPolyfill, style: style, ...restProps } = _ref;
    const { parentRef: parentRef, node: node, resize: resize, ...dimensions } = (0, $c9d9c799c0ffe8ed$export$2e2bcd8739ae039)({
        initialSize: initialSize,
        debounceTime: debounceTime,
        ignoreDimensions: ignoreDimensions,
        enableDebounceLeadingCall: enableDebounceLeadingCall,
        resizeObserverPolyfill: resizeObserverPolyfill
    });
    const outerStyle = parentSizeStyles ? {
        position: 'relative',
        ...parentSizeStyles,
        ...style
    } : {
        ...$66012142a13b7a2b$var$defaultOuterStyles,
        ...style
    };
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("div", {
        style: outerStyle,
        className: className,
        ...restProps,
        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("div", {
            style: $66012142a13b7a2b$var$measurementStyles,
            ref: parentRef,
            children: children({
                ...dimensions,
                ref: node,
                resize: resize
            })
        })
    });
}



function $9c8d98022b8c112f$export$2e2bcd8739ae039(_ref) {
    let { children: children, width: width, height: height, xOrigin: xOrigin = 0, yOrigin: yOrigin = 0, preserveAspectRatio: preserveAspectRatio = 'xMinYMin meet', innerRef: innerRef } = _ref;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("div", {
        style: {
            display: 'inline-block',
            position: 'relative',
            width: '100%',
            verticalAlign: 'top',
            overflow: 'hidden'
        },
        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("svg", {
            preserveAspectRatio: preserveAspectRatio,
            viewBox: `${xOrigin} ${yOrigin} ${width} ${height}`,
            ref: innerRef,
            children: children
        })
    });
}



var $5E6i4 = parcelRequire("5E6i4");


const $3a651eaaa3d1cb8f$var$CONTAINER_STYLES = {
    width: '100%',
    height: '100%',
    position: 'relative'
};
const $3a651eaaa3d1cb8f$var$MEASUREMENT_STYLES = {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    overflow: 'hidden'
};
function $3a651eaaa3d1cb8f$export$2e2bcd8739ae039(BaseComponent, /** Optionally inject a ResizeObserver polyfill, else this *must* be globally available. */ resizeObserverPolyfill) {
    return class WrappedComponent extends (0, $5E6i4.Component) {
        displayName = (()=>`withParentSize(${BaseComponent.displayName ?? BaseComponent.name ?? 'Component'})`)();
        state = (()=>({
                parentWidth: undefined,
                parentHeight: undefined
            }))();
        animationFrameID = 0;
        container = null;
        componentDidMount() {
            const ResizeObserverLocal = resizeObserverPolyfill || window.ResizeObserver;
            this.resizeObserver = new ResizeObserverLocal((entries)=>{
                entries.forEach((entry)=>{
                    const { width: width, height: height } = entry.contentRect;
                    this.animationFrameID = window.requestAnimationFrame(()=>{
                        this.resize({
                            width: width,
                            height: height
                        });
                    });
                });
            });
            if (this.container) this.resizeObserver.observe(this.container);
        }
        componentWillUnmount() {
            window.cancelAnimationFrame(this.animationFrameID);
            if (this.resizeObserver) this.resizeObserver.disconnect();
            this.resize.cancel();
        }
        setRef = (ref)=>{
            this.container = ref;
        };
        resize = (()=>(0, $1cd3ba1ba76c811a$export$61fc7d43ac8f84b0)(// eslint-disable-next-line unicorn/consistent-function-scoping
            (_ref)=>{
                let { width: width, height: height } = _ref;
                this.setState({
                    parentWidth: width,
                    parentHeight: height
                });
            }, this.props.debounceTime ?? 300, {
                leading: this.props.enableDebounceLeadingCall ?? true
            }))();
        render() {
            const { initialWidth: initialWidth, initialHeight: initialHeight } = this.props;
            const { parentWidth: parentWidth = initialWidth, parentHeight: parentHeight = initialHeight } = this.state;
            return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("div", {
                style: $3a651eaaa3d1cb8f$var$CONTAINER_STYLES,
                children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("div", {
                    style: $3a651eaaa3d1cb8f$var$MEASUREMENT_STYLES,
                    ref: this.setRef,
                    children: parentWidth != null && parentHeight != null && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(BaseComponent, {
                        parentWidth: parentWidth,
                        parentHeight: parentHeight,
                        ...this.props
                    })
                })
            });
        }
    };
}



var $5E6i4 = parcelRequire("5E6i4");


function $c0cb84a9eaede922$export$2e2bcd8739ae039(BaseComponent) {
    return class WrappedComponent extends (0, $5E6i4.Component) {
        displayName = (()=>`withScreenSize(${BaseComponent.displayName ?? BaseComponent.name ?? 'Component'})`)();
        state = (()=>({
                screenWidth: undefined,
                screenHeight: undefined
            }))();
        componentDidMount() {
            window.addEventListener('resize', this.resize, false);
            this.resize();
        }
        componentWillUnmount() {
            window.removeEventListener('resize', this.resize, false);
            this.resize.cancel();
        }
        resize = (()=>(0, $1cd3ba1ba76c811a$export$61fc7d43ac8f84b0)(// eslint-disable-next-line unicorn/consistent-function-scoping
            ()=>{
                this.setState(()=>({
                        screenWidth: window.innerWidth,
                        screenHeight: window.innerHeight
                    }));
            }, this.props.debounceTime ?? this.props.windowResizeDebounceTime ?? 300, {
                leading: this.props.enableDebounceLeadingCall ?? true
            }))();
        render() {
            const { screenWidth: screenWidth, screenHeight: screenHeight } = this.state;
            return screenWidth == null || screenHeight == null ? null : /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(BaseComponent, {
                screenWidth: screenWidth,
                screenHeight: screenHeight,
                ...this.props
            });
        }
    };
}




var $5E6i4 = parcelRequire("5E6i4");

const $65ca56ad72721c29$var$defaultInitialSize = {
    width: 0,
    height: 0
};
const $65ca56ad72721c29$var$useScreenSize = function() {
    let { initialSize: initialSize = $65ca56ad72721c29$var$defaultInitialSize, debounceTime: debounceTime = 300, enableDebounceLeadingCall: enableDebounceLeadingCall = true } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const [screenSize, setScreenSize] = (0, $5E6i4.useState)(initialSize);
    const handleResize = (0, $5E6i4.useMemo)(()=>(0, $1cd3ba1ba76c811a$export$61fc7d43ac8f84b0)(()=>{
            setScreenSize(()=>({
                    width: window.innerWidth,
                    height: window.innerHeight
                }));
        }, debounceTime, {
            leading: enableDebounceLeadingCall
        }), [
        debounceTime,
        enableDebounceLeadingCall
    ]);
    (0, $5E6i4.useEffect)(()=>{
        handleResize();
        window.addEventListener('resize', handleResize, false);
        return ()=>{
            window.removeEventListener('resize', handleResize, false);
            handleResize.cancel();
        };
    }, [
        handleResize
    ]);
    return screenSize;
};
var $65ca56ad72721c29$export$2e2bcd8739ae039 = $65ca56ad72721c29$var$useScreenSize;








// @visx/threshold




function $8e340a26d903abc6$export$2e2bcd8739ae039(_ref) {
    let { className: className, curve: curve, clipAboveTo: clipAboveTo, clipBelowTo: clipBelowTo, data: data, defined: defined, x: x, y0: y0, y1: y1, aboveAreaProps: aboveAreaProps, belowAreaProps: belowAreaProps, id: id = '' } = _ref;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("g", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-threshold', className),
        children: [
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $ae7af5d88f7c9f70$export$2e2bcd8739ae039), {
                curve: curve,
                data: data,
                x: x,
                y1: y1,
                defined: defined,
                children: (_ref2)=>{
                    let { path: path } = _ref2;
                    // TS cannot infer the correct method overload
                    let belowPath = null;
                    let abovePath = null;
                    if (typeof clipBelowTo === 'number') belowPath = path.y0(clipBelowTo)(data);
                    else belowPath = path.y0(clipBelowTo)(data);
                    if (typeof clipAboveTo === 'number') abovePath = path.y0(clipAboveTo)(data);
                    else abovePath = path.y0(clipAboveTo)(data);
                    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $5c6fb60692d29a02$export$2e2bcd8739ae039), {
                                id: `threshold-clip-below-${id}`,
                                children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("path", {
                                    d: belowPath || ''
                                })
                            }),
                            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $5c6fb60692d29a02$export$2e2bcd8739ae039), {
                                id: `threshold-clip-above-${id}`,
                                children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("path", {
                                    d: abovePath || ''
                                })
                            })
                        ]
                    });
                }
            }),
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $ae7af5d88f7c9f70$export$2e2bcd8739ae039), {
                curve: curve,
                data: data,
                defined: defined,
                x: x,
                y0: y0,
                y1: y1,
                strokeWidth: 0,
                clipPath: `url(#threshold-clip-below-${id})`,
                ...belowAreaProps
            }),
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $ae7af5d88f7c9f70$export$2e2bcd8739ae039), {
                curve: curve,
                data: data,
                defined: defined,
                x: x,
                y0: y0,
                y1: y1,
                strokeWidth: 0,
                clipPath: `url(#threshold-clip-above-${id})`,
                ...aboveAreaProps
            })
        ]
    });
}




// @visx/tooltip

var $5E6i4 = parcelRequire("5E6i4");
function $46bbe600a3d3d653$export$2e2bcd8739ae039(/** Optional initial TooltipState. */ initialTooltipState) {
    const [tooltipState, setTooltipState] = (0, $5E6i4.useState)({
        tooltipOpen: false,
        ...initialTooltipState
    });
    const showTooltip = (0, $5E6i4.useCallback)((showArgs)=>setTooltipState(typeof showArgs === 'function' ? (_ref)=>{
            let { tooltipOpen: tooltipOpen, ...show } = _ref;
            return {
                ...showArgs(show),
                tooltipOpen: true
            };
        } : {
            tooltipOpen: true,
            tooltipLeft: showArgs.tooltipLeft,
            tooltipTop: showArgs.tooltipTop,
            tooltipData: showArgs.tooltipData
        }), [
        setTooltipState
    ]);
    const hideTooltip = (0, $5E6i4.useCallback)(()=>setTooltipState({
            tooltipOpen: false,
            tooltipLeft: undefined,
            tooltipTop: undefined,
            tooltipData: undefined
        }), [
        setTooltipState
    ]);
    return {
        tooltipOpen: tooltipState.tooltipOpen,
        tooltipLeft: tooltipState.tooltipLeft,
        tooltipTop: tooltipState.tooltipTop,
        tooltipData: tooltipState.tooltipData,
        updateTooltip: setTooltipState,
        showTooltip: showTooltip,
        hideTooltip: hideTooltip
    };
}



function $8004b9fbf763f009$export$2e2bcd8739ae039(BaseComponent) {
    let containerProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        style: {
            position: 'relative',
            width: 'inherit',
            height: 'inherit'
        }
    };
    let renderContainer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (children, props)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("div", {
            ...props,
            children: children
        });
    const WrappedComponent = (props)=>{
        const tooltipProps = (0, $46bbe600a3d3d653$export$2e2bcd8739ae039)();
        return renderContainer(/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(BaseComponent, {
            ...tooltipProps,
            ...props
        }), containerProps);
    };
    return WrappedComponent;
}




var $5E6i4 = parcelRequire("5E6i4");


var $5E6i4 = parcelRequire("5E6i4");

var $ibUU1 = parcelRequire("ibUU1");
class $29849ecd41776fa4$export$2e2bcd8739ae039 extends (0, $5E6i4.PureComponent) {
    componentWillUnmount() {
        if (this.node && document.body) {
            document.body.removeChild(this.node);
            delete this.node;
        }
    }
    render() {
        // SSR check
        if (!this.node && typeof document !== 'undefined') {
            this.node = document.createElement('div');
            if (this.props.zIndex != null) this.node.style.zIndex = `${this.props.zIndex}`;
            document.body.append(this.node);
        }
        if (!this.node) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ibUU1))).createPortal(this.props.children, this.node);
    }
}



var $5E6i4 = parcelRequire("5E6i4");


const $79662e844814a817$export$214b055320e0bf32 = {
    position: 'absolute',
    backgroundColor: 'white',
    color: '#666666',
    padding: '0.3rem 0.5rem',
    borderRadius: '3px',
    fontSize: '14px',
    boxShadow: '0 1px 2px rgba(33,33,33,0.2)',
    lineHeight: '1em',
    pointerEvents: 'none'
};
const $79662e844814a817$var$Tooltip = /*#__PURE__*/ (0, $5E6i4.forwardRef)((_ref, ref)=>{
    let { className: className, top: top, left: left, offsetLeft: offsetLeft = 10, offsetTop: offsetTop = 10, style: style = $79662e844814a817$export$214b055320e0bf32, children: children, unstyled: unstyled = false, applyPositionStyle: applyPositionStyle = false, ...restProps } = _ref;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("div", {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-tooltip', className),
        style: {
            top: top == null || offsetTop == null ? top : top + offsetTop,
            left: left == null || offsetLeft == null ? left : left + offsetLeft,
            ...applyPositionStyle && {
                position: 'absolute'
            },
            ...!unstyled && style
        },
        ...restProps,
        children: children
    });
});
$79662e844814a817$var$Tooltip.displayName = 'Tooltip';
var $79662e844814a817$export$2e2bcd8739ae039 = $79662e844814a817$var$Tooltip;





var $5E6i4 = parcelRequire("5E6i4");
const $7c7866c64758d72a$var$TooltipPositionContext = /*#__PURE__*/ (0, $5E6i4.createContext)({
    isFlippedVertically: false,
    isFlippedHorizontally: false
});
const $7c7866c64758d72a$export$c4495e18a4fda94d = $7c7866c64758d72a$var$TooltipPositionContext.Provider;
const $7c7866c64758d72a$export$1449c3910e5757a2 = $7c7866c64758d72a$var$TooltipPositionContext.Consumer;
const $7c7866c64758d72a$export$964a3aa90a7606c2 = ()=>(0, $5E6i4.useContext)($7c7866c64758d72a$var$TooltipPositionContext);



function $9b61bbeba2c9d58f$var$TooltipWithBounds(_ref) {
    let { children: children, getRects: getRects, left: initialLeft = 0, offsetLeft: offsetLeft = 10, offsetTop: offsetTop = 10, parentRect: parentBounds, rect: ownBounds, style: style = (0, $79662e844814a817$export$214b055320e0bf32), top: initialTop = 0, unstyled: unstyled = false, nodeRef: nodeRef, ...otherProps } = _ref;
    let transform;
    let placeTooltipLeft = false;
    let placeTooltipUp = false;
    if (ownBounds && parentBounds) {
        let left = initialLeft;
        let top = initialTop;
        if (parentBounds.width) {
            const rightPlacementClippedPx = left + offsetLeft + ownBounds.width - parentBounds.width;
            const leftPlacementClippedPx = ownBounds.width - left - offsetLeft;
            placeTooltipLeft = rightPlacementClippedPx > 0 && rightPlacementClippedPx > leftPlacementClippedPx;
        } else {
            const rightPlacementClippedPx = left + offsetLeft + ownBounds.width - window.innerWidth;
            const leftPlacementClippedPx = ownBounds.width - left - offsetLeft;
            placeTooltipLeft = rightPlacementClippedPx > 0 && rightPlacementClippedPx > leftPlacementClippedPx;
        }
        if (parentBounds.height) {
            const bottomPlacementClippedPx = top + offsetTop + ownBounds.height - parentBounds.height;
            const topPlacementClippedPx = ownBounds.height - top - offsetTop;
            placeTooltipUp = bottomPlacementClippedPx > 0 && bottomPlacementClippedPx > topPlacementClippedPx;
        } else placeTooltipUp = top + offsetTop + ownBounds.height > window.innerHeight;
        left = placeTooltipLeft ? left - ownBounds.width - offsetLeft : left + offsetLeft;
        top = placeTooltipUp ? top - ownBounds.height - offsetTop : top + offsetTop;
        left = Math.round(left);
        top = Math.round(top);
        transform = `translate(${left}px, ${top}px)`;
    }
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $79662e844814a817$export$2e2bcd8739ae039), {
        ref: nodeRef,
        style: {
            left: 0,
            top: 0,
            transform: transform,
            ...!unstyled && style
        },
        ...otherProps,
        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $7c7866c64758d72a$export$c4495e18a4fda94d), {
            value: {
                isFlippedVertically: !placeTooltipUp,
                isFlippedHorizontally: !placeTooltipLeft
            },
            children: children
        })
    });
}
var $9b61bbeba2c9d58f$export$2e2bcd8739ae039 = (0, $4eed57823eb4c4d9$export$2e2bcd8739ae039)($9b61bbeba2c9d58f$var$TooltipWithBounds);



function $e3512a662e2d715f$export$2e2bcd8739ae039() {
    let { detectBounds: detectBoundsOption = true, zIndex: zIndexOption, ...useMeasureOptions } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const [containerRef, containerBounds, forceRefreshBounds] = (0, $7979479b9515458b$export$2e2bcd8739ae039)(useMeasureOptions);
    const [isSsr, setIsSsr] = (0, $5E6i4.useState)(false);
    (0, $5E6i4.useEffect)(()=>{
        setIsSsr(false);
    }, []);
    const TooltipInPortal = (0, $5E6i4.useMemo)(()=>function(_ref) {
            let { left: containerLeft = 0, top: containerTop = 0, detectBounds: detectBoundsProp, // allow override at component-level
            zIndex: zIndexProp, // allow override at the component-level
            ...tooltipProps } = _ref;
            const detectBounds = detectBoundsProp == null ? detectBoundsOption : detectBoundsProp;
            const zIndex = zIndexProp == null ? zIndexOption : zIndexProp;
            const TooltipComponent = detectBounds ? (0, $9b61bbeba2c9d58f$export$2e2bcd8739ae039) : (0, $79662e844814a817$export$2e2bcd8739ae039);
            // convert container coordinates to page coordinates
            const scrollX = isSsr ? 0 : window.scrollX;
            const scrollY = isSsr ? 0 : window.scrollY;
            const portalLeft = containerLeft + (containerBounds.left || 0) + scrollX;
            const portalTop = containerTop + (containerBounds.top || 0) + scrollY;
            return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $29849ecd41776fa4$export$2e2bcd8739ae039), {
                zIndex: zIndex,
                children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(TooltipComponent, {
                    left: portalLeft,
                    top: portalTop,
                    ...tooltipProps
                })
            });
        }, [
        detectBoundsOption,
        zIndexOption,
        containerBounds.left,
        containerBounds.top,
        isSsr
    ]);
    return {
        containerRef: containerRef,
        containerBounds: containerBounds,
        forceRefreshBounds: forceRefreshBounds,
        TooltipInPortal: TooltipInPortal
    };
}








// @visx/voronoi
function $c075cb212444e96a$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $8af60d91540fa915$export$d141bba7fdc215a3(d) {
    return d[0];
}
function $8af60d91540fa915$export$4a5767248b18ef41(d) {
    return d[1];
}



var $7NDp4 = parcelRequire("7NDp4");
function $98a95976d0524724$export$2e2bcd8739ae039() {
    var x = (0, $8af60d91540fa915$export$d141bba7fdc215a3), y = (0, $8af60d91540fa915$export$4a5767248b18ef41), extent = null;
    function voronoi(data) {
        return new (0, $7NDp4.default)(data.map(function(d, i) {
            var s = [
                Math.round(x(d, i, data) / (0, $7NDp4.epsilon)) * (0, $7NDp4.epsilon),
                Math.round(y(d, i, data) / (0, $7NDp4.epsilon)) * (0, $7NDp4.epsilon)
            ];
            s.index = i;
            s.data = d;
            return s;
        }), extent);
    }
    voronoi.polygons = function(data) {
        return voronoi(data).polygons();
    };
    voronoi.links = function(data) {
        return voronoi(data).links();
    };
    voronoi.triangles = function(data) {
        return voronoi(data).triangles();
    };
    voronoi.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $c075cb212444e96a$export$2e2bcd8739ae039)(+_), voronoi) : x;
    };
    voronoi.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $c075cb212444e96a$export$2e2bcd8739ae039)(+_), voronoi) : y;
    };
    voronoi.extent = function(_) {
        return arguments.length ? (extent = _ == null ? null : [
            [
                +_[0][0],
                +_[0][1]
            ],
            [
                +_[1][0],
                +_[1][1]
            ]
        ], voronoi) : extent && [
            [
                extent[0][0],
                extent[0][1]
            ],
            [
                extent[1][0],
                extent[1][1]
            ]
        ];
    };
    voronoi.size = function(_) {
        return arguments.length ? (extent = _ == null ? null : [
            [
                0,
                0
            ],
            [
                +_[0],
                +_[1]
            ]
        ], voronoi) : extent && [
            extent[1][0] - extent[0][0],
            extent[1][1] - extent[0][1]
        ];
    };
    return voronoi;
}




const $0c4146fd83599fcf$var$CLIP_PADDING = 1;
function $0c4146fd83599fcf$export$2e2bcd8739ae039(_ref) {
    let { width: width = 0, height: height = 0, x: x, y: y } = _ref;
    const voronoiGenerator = (0, $98a95976d0524724$export$2e2bcd8739ae039)();
    if (x) voronoiGenerator.x(x);
    if (y) voronoiGenerator.y(y);
    voronoiGenerator.extent([
        [
            -$0c4146fd83599fcf$var$CLIP_PADDING,
            -$0c4146fd83599fcf$var$CLIP_PADDING
        ],
        [
            width + $0c4146fd83599fcf$var$CLIP_PADDING,
            height + $0c4146fd83599fcf$var$CLIP_PADDING
        ]
    ]);
    return voronoiGenerator;
}




function $20e310f1d9c68795$export$2e2bcd8739ae039(_ref) {
    let { polygon: polygon, className: className, children: children, ...restProps } = _ref;
    if (!polygon) return null;
    const path = `M${polygon.join('L')}Z`;
    if (children) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: children({
            path: path,
            polygon: polygon
        })
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("path", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-voronoi-polygon', className),
        d: path,
        ...restProps
    });
}




// @visx/wordcloud


var $5E6i4 = parcelRequire("5E6i4");
var $173f6853be84c6b1$exports = {};
// Word cloud layout by Jason Davies, https://www.jasondavies.com/wordcloud/
// Algorithm due to Jonathan Feinberg, https://s3.amazonaws.com/static.mrfeinberg.com/bv_ch03.pdf
var $371799e22fbff833$var$noop = {
    value: function() {}
};
function $371799e22fbff833$var$dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new $371799e22fbff833$var$Dispatch(_);
}
function $371799e22fbff833$var$Dispatch(_) {
    this._ = _;
}
function $371799e22fbff833$var$parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
$371799e22fbff833$var$Dispatch.prototype = $371799e22fbff833$var$dispatch.prototype = {
    constructor: $371799e22fbff833$var$Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = $371799e22fbff833$var$parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = $371799e22fbff833$var$get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = $371799e22fbff833$var$set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = $371799e22fbff833$var$set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new $371799e22fbff833$var$Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function $371799e22fbff833$var$get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function $371799e22fbff833$var$set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = $371799e22fbff833$var$noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
var $371799e22fbff833$export$2e2bcd8739ae039 = $371799e22fbff833$var$dispatch;


var $173f6853be84c6b1$require$dispatch = $371799e22fbff833$export$2e2bcd8739ae039;
const $173f6853be84c6b1$var$RADIANS = Math.PI / 180;
const $173f6853be84c6b1$var$SPIRALS = {
    archimedean: $173f6853be84c6b1$var$archimedeanSpiral,
    rectangular: $173f6853be84c6b1$var$rectangularSpiral
};
const $173f6853be84c6b1$var$cw = 64;
const $173f6853be84c6b1$var$ch = 2048;
$173f6853be84c6b1$exports = function() {
    var size = [
        256,
        256
    ], text = $173f6853be84c6b1$var$cloudText, font = $173f6853be84c6b1$var$cloudFont, fontSize = $173f6853be84c6b1$var$cloudFontSize, fontStyle = $173f6853be84c6b1$var$cloudFontNormal, fontWeight = $173f6853be84c6b1$var$cloudFontNormal, padding = $173f6853be84c6b1$var$cloudPadding, spiral = $173f6853be84c6b1$var$archimedeanSpiral, words = [], timeInterval = Infinity, event = $173f6853be84c6b1$require$dispatch("word", "end"), timer = null, random = Math.random, rotate = ()=>(~~(random() * 6) - 3) * 30, cloud = {}, canvas = $173f6853be84c6b1$var$cloudCanvas;
    cloud.canvas = function(_) {
        return arguments.length ? (canvas = $173f6853be84c6b1$var$functor(_), cloud) : canvas;
    };
    cloud.start = function() {
        var contextAndRatio = getContext(canvas()), board = $173f6853be84c6b1$var$zeroArray((size[0] >> 5) * size[1]), bounds = null, n = words.length, i = -1, tags = [], data = words.map(function(d, i) {
            d.text = text.call(this, d, i);
            d.font = font.call(this, d, i);
            d.style = fontStyle.call(this, d, i);
            d.weight = fontWeight.call(this, d, i);
            d.rotate = rotate.call(this, d, i);
            d.size = ~~fontSize.call(this, d, i);
            d.padding = padding.call(this, d, i);
            return d;
        }).sort(function(a, b) {
            return b.size - a.size;
        });
        if (timer) clearInterval(timer);
        timer = setInterval(step, 0);
        step();
        return cloud;
        function step() {
            var start = Date.now();
            while(Date.now() - start < timeInterval && ++i < n && timer){
                var d = data[i];
                d.x = size[0] * (random() + .5) >> 1;
                d.y = size[1] * (random() + .5) >> 1;
                $173f6853be84c6b1$var$cloudSprite(contextAndRatio, d, data, i);
                if (d.hasText && place(board, d, bounds)) {
                    tags.push(d);
                    event.call("word", cloud, d);
                    if (bounds) $173f6853be84c6b1$var$cloudBounds(bounds, d);
                    else bounds = [
                        {
                            x: d.x + d.x0,
                            y: d.y + d.y0
                        },
                        {
                            x: d.x + d.x1,
                            y: d.y + d.y1
                        }
                    ];
                    // Temporary hack
                    d.x -= size[0] >> 1;
                    d.y -= size[1] >> 1;
                }
            }
            if (i >= n) {
                cloud.stop();
                event.call("end", cloud, tags, bounds);
            }
        }
    };
    cloud.stop = function() {
        if (timer) {
            clearInterval(timer);
            timer = null;
        }
        for (const d of words)delete d.sprite;
        return cloud;
    };
    function getContext(canvas) {
        const context = canvas.getContext("2d", {
            willReadFrequently: true
        });
        canvas.width = canvas.height = 1;
        const ratio = Math.sqrt(context.getImageData(0, 0, 1, 1).data.length >> 2);
        canvas.width = ($173f6853be84c6b1$var$cw << 5) / ratio;
        canvas.height = $173f6853be84c6b1$var$ch / ratio;
        context.fillStyle = context.strokeStyle = "red";
        return {
            context: context,
            ratio: ratio
        };
    }
    function place(board, tag, bounds) {
        var perimeter = [
            {
                x: 0,
                y: 0
            },
            {
                x: size[0],
                y: size[1]
            }
        ], startX = tag.x, startY = tag.y, maxDelta = Math.sqrt(size[0] * size[0] + size[1] * size[1]), s = spiral(size), dt = random() < .5 ? 1 : -1, t = -dt, dxdy, dx, dy;
        while(dxdy = s(t += dt)){
            dx = ~~dxdy[0];
            dy = ~~dxdy[1];
            if (Math.min(Math.abs(dx), Math.abs(dy)) >= maxDelta) break;
            tag.x = startX + dx;
            tag.y = startY + dy;
            if (tag.x + tag.x0 < 0 || tag.y + tag.y0 < 0 || tag.x + tag.x1 > size[0] || tag.y + tag.y1 > size[1]) continue;
            // TODO only check for collisions within current bounds.
            if (!bounds || $173f6853be84c6b1$var$collideRects(tag, bounds)) {
                if (!$173f6853be84c6b1$var$cloudCollide(tag, board, size[0])) {
                    var sprite = tag.sprite, w = tag.width >> 5, sw = size[0] >> 5, lx = tag.x - (w << 4), sx = lx & 0x7f, msx = 32 - sx, h = tag.y1 - tag.y0, x = (tag.y + tag.y0) * sw + (lx >> 5), last;
                    for(var j = 0; j < h; j++){
                        last = 0;
                        for(var i = 0; i <= w; i++)board[x + i] |= last << msx | (i < w ? (last = sprite[j * w + i]) >>> sx : 0);
                        x += sw;
                    }
                    return true;
                }
            }
        }
        return false;
    }
    cloud.timeInterval = function(_) {
        return arguments.length ? (timeInterval = _ == null ? Infinity : _, cloud) : timeInterval;
    };
    cloud.words = function(_) {
        return arguments.length ? (words = _, cloud) : words;
    };
    cloud.size = function(_) {
        return arguments.length ? (size = [
            +_[0],
            +_[1]
        ], cloud) : size;
    };
    cloud.font = function(_) {
        return arguments.length ? (font = $173f6853be84c6b1$var$functor(_), cloud) : font;
    };
    cloud.fontStyle = function(_) {
        return arguments.length ? (fontStyle = $173f6853be84c6b1$var$functor(_), cloud) : fontStyle;
    };
    cloud.fontWeight = function(_) {
        return arguments.length ? (fontWeight = $173f6853be84c6b1$var$functor(_), cloud) : fontWeight;
    };
    cloud.rotate = function(_) {
        return arguments.length ? (rotate = $173f6853be84c6b1$var$functor(_), cloud) : rotate;
    };
    cloud.text = function(_) {
        return arguments.length ? (text = $173f6853be84c6b1$var$functor(_), cloud) : text;
    };
    cloud.spiral = function(_) {
        return arguments.length ? (spiral = $173f6853be84c6b1$var$SPIRALS[_] || _, cloud) : spiral;
    };
    cloud.fontSize = function(_) {
        return arguments.length ? (fontSize = $173f6853be84c6b1$var$functor(_), cloud) : fontSize;
    };
    cloud.padding = function(_) {
        return arguments.length ? (padding = $173f6853be84c6b1$var$functor(_), cloud) : padding;
    };
    cloud.random = function(_) {
        return arguments.length ? (random = _, cloud) : random;
    };
    cloud.on = function() {
        var value = event.on.apply(event, arguments);
        return value === event ? cloud : value;
    };
    return cloud;
};
function $173f6853be84c6b1$var$cloudText(d) {
    return d.text;
}
function $173f6853be84c6b1$var$cloudFont() {
    return "serif";
}
function $173f6853be84c6b1$var$cloudFontNormal() {
    return "normal";
}
function $173f6853be84c6b1$var$cloudFontSize(d) {
    return Math.sqrt(d.value);
}
function $173f6853be84c6b1$var$cloudPadding() {
    return 1;
}
// Fetches a monochrome sprite bitmap for the specified text.
// Load in batches for speed.
function $173f6853be84c6b1$var$cloudSprite(contextAndRatio, d, data, di) {
    if (d.sprite) return;
    var c = contextAndRatio.context, ratio = contextAndRatio.ratio;
    c.clearRect(0, 0, ($173f6853be84c6b1$var$cw << 5) / ratio, $173f6853be84c6b1$var$ch / ratio);
    var x = 0, y = 0, maxh = 0, n = data.length;
    --di;
    while(++di < n){
        d = data[di];
        c.save();
        c.font = d.style + " " + d.weight + " " + ~~((d.size + 1) / ratio) + "px " + d.font;
        const metrics = c.measureText(d.text);
        const anchor = -Math.floor(metrics.width / 2);
        let w = (metrics.width + 1) * ratio;
        let h = d.size << 1;
        if (d.rotate) {
            var sr = Math.sin(d.rotate * $173f6853be84c6b1$var$RADIANS), cr = Math.cos(d.rotate * $173f6853be84c6b1$var$RADIANS), wcr = w * cr, wsr = w * sr, hcr = h * cr, hsr = h * sr;
            w = Math.max(Math.abs(wcr + hsr), Math.abs(wcr - hsr)) + 0x1f >> 5 << 5;
            h = ~~Math.max(Math.abs(wsr + hcr), Math.abs(wsr - hcr));
        } else w = w + 0x1f >> 5 << 5;
        if (h > maxh) maxh = h;
        if (x + w >= $173f6853be84c6b1$var$cw << 5) {
            x = 0;
            y += maxh;
            maxh = 0;
        }
        if (y + h >= $173f6853be84c6b1$var$ch) break;
        c.translate((x + (w >> 1)) / ratio, (y + (h >> 1)) / ratio);
        if (d.rotate) c.rotate(d.rotate * $173f6853be84c6b1$var$RADIANS);
        c.fillText(d.text, anchor, 0);
        if (d.padding) c.lineWidth = 2 * d.padding, c.strokeText(d.text, anchor, 0);
        c.restore();
        d.width = w;
        d.height = h;
        d.xoff = x;
        d.yoff = y;
        d.x1 = w >> 1;
        d.y1 = h >> 1;
        d.x0 = -d.x1;
        d.y0 = -d.y1;
        d.hasText = true;
        x += w;
    }
    var pixels = c.getImageData(0, 0, ($173f6853be84c6b1$var$cw << 5) / ratio, $173f6853be84c6b1$var$ch / ratio).data, sprite = [];
    while(--di >= 0){
        d = data[di];
        if (!d.hasText) continue;
        var w = d.width, w32 = w >> 5, h = d.y1 - d.y0;
        // Zero the buffer
        for(var i = 0; i < h * w32; i++)sprite[i] = 0;
        x = d.xoff;
        if (x == null) return;
        y = d.yoff;
        var seen = 0, seenRow = -1;
        for(var j = 0; j < h; j++){
            for(var i = 0; i < w; i++){
                var k = w32 * j + (i >> 5), m = pixels[(y + j) * ($173f6853be84c6b1$var$cw << 5) + (x + i) << 2] ? 1 << 31 - i % 32 : 0;
                sprite[k] |= m;
                seen |= m;
            }
            if (seen) seenRow = j;
            else {
                d.y0++;
                h--;
                j--;
                y++;
            }
        }
        d.y1 = d.y0 + seenRow;
        d.sprite = sprite.slice(0, (d.y1 - d.y0) * w32);
    }
}
// Use mask-based collision detection.
function $173f6853be84c6b1$var$cloudCollide(tag, board, sw) {
    sw >>= 5;
    var sprite = tag.sprite, w = tag.width >> 5, lx = tag.x - (w << 4), sx = lx & 0x7f, msx = 32 - sx, h = tag.y1 - tag.y0, x = (tag.y + tag.y0) * sw + (lx >> 5), last;
    for(var j = 0; j < h; j++){
        last = 0;
        for(var i = 0; i <= w; i++){
            if ((last << msx | (i < w ? (last = sprite[j * w + i]) >>> sx : 0)) & board[x + i]) return true;
        }
        x += sw;
    }
    return false;
}
function $173f6853be84c6b1$var$cloudBounds(bounds, d) {
    var b0 = bounds[0], b1 = bounds[1];
    if (d.x + d.x0 < b0.x) b0.x = d.x + d.x0;
    if (d.y + d.y0 < b0.y) b0.y = d.y + d.y0;
    if (d.x + d.x1 > b1.x) b1.x = d.x + d.x1;
    if (d.y + d.y1 > b1.y) b1.y = d.y + d.y1;
}
function $173f6853be84c6b1$var$collideRects(a, b) {
    return a.x + a.x1 > b[0].x && a.x + a.x0 < b[1].x && a.y + a.y1 > b[0].y && a.y + a.y0 < b[1].y;
}
function $173f6853be84c6b1$var$archimedeanSpiral(size) {
    var e = size[0] / size[1];
    return function(t) {
        return [
            e * (t *= .1) * Math.cos(t),
            t * Math.sin(t)
        ];
    };
}
function $173f6853be84c6b1$var$rectangularSpiral(size) {
    var dy = 4, dx = dy * size[0] / size[1], x = 0, y = 0;
    return function(t) {
        var sign = t < 0 ? -1 : 1;
        // See triangular numbers: T_n = n * (n + 1) / 2.
        switch(Math.sqrt(1 + 4 * sign * t) - sign & 3){
            case 0:
                x += dx;
                break;
            case 1:
                y += dy;
                break;
            case 2:
                x -= dx;
                break;
            default:
                y -= dy;
                break;
        }
        return [
            x,
            y
        ];
    };
}
// TODO reuse arrays?
function $173f6853be84c6b1$var$zeroArray(n) {
    var a = [], i = -1;
    while(++i < n)a[i] = 0;
    return a;
}
function $173f6853be84c6b1$var$cloudCanvas() {
    return document.createElement("canvas");
}
function $173f6853be84c6b1$var$functor(d) {
    return typeof d === "function" ? d : function() {
        return d;
    };
}


function $c46146e8ab8f4baf$export$2e2bcd8739ae039(_ref) {
    let { width: width, height: height, font: font, fontSize: fontSize, fontStyle: fontStyle, fontWeight: fontWeight, padding: padding, random: random, rotate: rotate, spiral: spiral, words: words } = _ref;
    const [cloudWords, setCloudWords] = (0, $5E6i4.useState)([]);
    (0, $5E6i4.useEffect)(()=>{
        if (width === 0 || height === 0) return;
        const layout = (0, (/*@__PURE__*/$parcel$interopDefault($173f6853be84c6b1$exports)))();
        layout.size([
            width,
            height
        ]);
        layout.words(words);
        if (typeof random !== 'undefined') layout.random(random);
        if (typeof font !== 'undefined') layout.font(font);
        if (typeof padding !== 'undefined') layout.padding(padding);
        if (typeof fontSize !== 'undefined') layout.fontSize(fontSize);
        if (typeof fontStyle !== 'undefined') layout.fontStyle(fontStyle);
        if (typeof fontWeight !== 'undefined') layout.fontWeight(fontWeight);
        if (typeof rotate !== 'undefined') layout.rotate(rotate);
        if (typeof spiral !== 'undefined') layout.spiral(spiral);
        layout.on('end', setCloudWords);
        layout.start();
        return function cleanup() {
            layout.stop();
        };
    }, [
        width,
        height,
        font,
        fontSize,
        fontStyle,
        fontWeight,
        padding,
        random,
        rotate,
        spiral,
        words
    ]);
    return cloudWords;
}



function $60e174456d1c94a7$export$2e2bcd8739ae039(props) {
    const { children: children, ...wordcloudConfig } = props;
    const { width: width, height: height } = wordcloudConfig;
    const words = (0, $c46146e8ab8f4baf$export$2e2bcd8739ae039)(wordcloudConfig);
    if (width === 0 || height === 0) return null;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("svg", {
        width: width,
        height: height,
        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $268dd56f34f61467$export$2e2bcd8739ae039), {
            left: width / 2,
            top: height / 2,
            children: children(words)
        })
    });
}





// @visx/xychart
// components


var $5E6i4 = parcelRequire("5E6i4");

/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $5E6i4 = parcelRequire("5E6i4");
/** Utilities for inferring context generics */ const $89eeb2e4952e291d$var$DataContext = /*#__PURE__*/ (0, $5E6i4.createContext)({});
var $89eeb2e4952e291d$export$2e2bcd8739ae039 = $89eeb2e4952e291d$var$DataContext;


function $db2a599b5b32ff26$export$2e2bcd8739ae039(scale) {
    // Broaden type before using 'xxx' in s as typeguard.
    const s = scale;
    return s && 'bandwidth' in s ? s?.bandwidth() ?? 0 : 0;
}


function $0e64952a2d1e8b9b$export$2e2bcd8739ae039(_) {
    return _ != null && typeof _ === 'number' && !Number.isNaN(_) && Number.isFinite(_);
}



// used for auto-positioning
const $c5c94b524879e8fb$var$minimumLabelDimension = 16;
function $c5c94b524879e8fb$export$2e2bcd8739ae039(_ref) {
    let { AnnotationComponent: AnnotationComponent, children: children, datum: datum, dataKey: dataKey, xAccessor: propsXAccessor, yAccessor: propsYAccessor, dx: propsDx = 0, dy: propsDy = 0, ...annotationProps } = _ref;
    const { innerHeight: innerHeight, innerWidth: innerWidth, margin: margin, xScale: xScale, yScale: yScale, dataRegistry: dataRegistry } = (0, $5E6i4.useContext)((0, $89eeb2e4952e291d$export$2e2bcd8739ae039)) || {};
    const xBandWidth = (0, $5E6i4.useMemo)(()=>xScale ? (0, $db2a599b5b32ff26$export$2e2bcd8739ae039)(xScale) : 0, [
        xScale
    ]);
    const yBandWidth = (0, $5E6i4.useMemo)(()=>yScale ? (0, $db2a599b5b32ff26$export$2e2bcd8739ae039)(yScale) : 0, [
        yScale
    ]);
    if ((!propsXAccessor || !propsYAccessor) && !dataKey) {
        console.warn('[@visx/xychart/BaseAnnotation]: dataKey or x/yAccessors must be specified.');
        return null;
    }
    const registryEntry = propsXAccessor && propsYAccessor || dataKey == null ? null : dataRegistry?.get(dataKey);
    const xAccessor = propsXAccessor || registryEntry?.xAccessor;
    const yAccessor = propsYAccessor || registryEntry?.yAccessor;
    if (!xScale || !yScale || !innerWidth || !innerHeight || !xAccessor || !yAccessor || !margin) return null;
    const x = ((0, $c32ed8852dffe2f4$export$2e2bcd8739ae039)(xScale(xAccessor(datum))) ?? NaN) + xBandWidth / 2;
    const y = ((0, $c32ed8852dffe2f4$export$2e2bcd8739ae039)(yScale(yAccessor(datum))) ?? NaN) + yBandWidth / 2;
    const dx = x + propsDx + $c5c94b524879e8fb$var$minimumLabelDimension > margin.left + innerWidth ? -propsDx : propsDx;
    const dy = y + propsDy + $c5c94b524879e8fb$var$minimumLabelDimension > margin.top + innerHeight ? -propsDy : propsDy;
    return (0, $0e64952a2d1e8b9b$export$2e2bcd8739ae039)(x) && (0, $0e64952a2d1e8b9b$export$2e2bcd8739ae039)(y) ? /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(AnnotationComponent, {
        width: innerWidth,
        height: innerHeight,
        ...annotationProps,
        x: x,
        y: y,
        dx: dx,
        dy: dy,
        children: children
    }) : null;
}



function $443ee544615a15c2$export$2e2bcd8739ae039(_ref) {
    let { editable: editable, ...props } = _ref;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $c5c94b524879e8fb$export$2e2bcd8739ae039), {
        AnnotationComponent: editable ? (0, $b0f54f19bbad2881$export$2e2bcd8739ae039) : (0, $66e1399a00a9dd25$export$2e2bcd8739ae039),
        ...props
    });
}



var $5E6i4 = parcelRequire("5E6i4");
//#region \0rolldown/runtime.js
var $b767f6cddc9ce6d2$var$__defProp = Object.defineProperty;
var $b767f6cddc9ce6d2$export$625550452a3fa3ec = (all, no_symbols)=>{
    let target = {};
    for(var name in all)$b767f6cddc9ce6d2$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
    if (!no_symbols) $b767f6cddc9ce6d2$var$__defProp(target, Symbol.toStringTag, {
        value: "Module"
    });
    return target;
};


//#region src/index.ts
let $7a0c7bd96c8bfe17$var$updateQueue = $7a0c7bd96c8bfe17$var$makeQueue();
/**
* Schedule an update for next frame.
* Your function can return `true` to repeat next frame.
*/ const $7a0c7bd96c8bfe17$export$27f233d61a9e2fa4 = (fn)=>$7a0c7bd96c8bfe17$var$schedule(fn, $7a0c7bd96c8bfe17$var$updateQueue);
let $7a0c7bd96c8bfe17$var$writeQueue = $7a0c7bd96c8bfe17$var$makeQueue();
$7a0c7bd96c8bfe17$export$27f233d61a9e2fa4.write = (fn)=>$7a0c7bd96c8bfe17$var$schedule(fn, $7a0c7bd96c8bfe17$var$writeQueue);
let $7a0c7bd96c8bfe17$var$onStartQueue = $7a0c7bd96c8bfe17$var$makeQueue();
$7a0c7bd96c8bfe17$export$27f233d61a9e2fa4.onStart = (fn)=>$7a0c7bd96c8bfe17$var$schedule(fn, $7a0c7bd96c8bfe17$var$onStartQueue);
let $7a0c7bd96c8bfe17$var$onFrameQueue = $7a0c7bd96c8bfe17$var$makeQueue();
$7a0c7bd96c8bfe17$export$27f233d61a9e2fa4.onFrame = (fn)=>$7a0c7bd96c8bfe17$var$schedule(fn, $7a0c7bd96c8bfe17$var$onFrameQueue);
let $7a0c7bd96c8bfe17$var$onFinishQueue = $7a0c7bd96c8bfe17$var$makeQueue();
$7a0c7bd96c8bfe17$export$27f233d61a9e2fa4.onFinish = (fn)=>$7a0c7bd96c8bfe17$var$schedule(fn, $7a0c7bd96c8bfe17$var$onFinishQueue);
let $7a0c7bd96c8bfe17$var$timeouts = [];
$7a0c7bd96c8bfe17$export$27f233d61a9e2fa4.setTimeout = (handler, ms)=>{
    const time = $7a0c7bd96c8bfe17$export$27f233d61a9e2fa4.now() + ms;
    const cancel = ()=>{
        const i = $7a0c7bd96c8bfe17$var$timeouts.findIndex((t)=>t.cancel == cancel);
        if (~i) $7a0c7bd96c8bfe17$var$timeouts.splice(i, 1);
        $7a0c7bd96c8bfe17$var$pendingCount -= ~i ? 1 : 0;
    };
    const timeout = {
        time: time,
        handler: handler,
        cancel: cancel
    };
    $7a0c7bd96c8bfe17$var$timeouts.splice($7a0c7bd96c8bfe17$var$findTimeout(time), 0, timeout);
    $7a0c7bd96c8bfe17$var$pendingCount += 1;
    $7a0c7bd96c8bfe17$var$start();
    return timeout;
};
/** Find the index where the given time is not greater. */ const $7a0c7bd96c8bfe17$var$findTimeout = (time)=>~(~$7a0c7bd96c8bfe17$var$timeouts.findIndex((t)=>t.time > time) || ~$7a0c7bd96c8bfe17$var$timeouts.length);
$7a0c7bd96c8bfe17$export$27f233d61a9e2fa4.cancel = (fn)=>{
    $7a0c7bd96c8bfe17$var$onStartQueue.delete(fn);
    $7a0c7bd96c8bfe17$var$onFrameQueue.delete(fn);
    $7a0c7bd96c8bfe17$var$onFinishQueue.delete(fn);
    $7a0c7bd96c8bfe17$var$updateQueue.delete(fn);
    $7a0c7bd96c8bfe17$var$writeQueue.delete(fn);
};
$7a0c7bd96c8bfe17$export$27f233d61a9e2fa4.sync = (fn)=>{
    $7a0c7bd96c8bfe17$var$sync = true;
    $7a0c7bd96c8bfe17$export$27f233d61a9e2fa4.batchedUpdates(fn);
    $7a0c7bd96c8bfe17$var$sync = false;
};
$7a0c7bd96c8bfe17$export$27f233d61a9e2fa4.throttle = (fn)=>{
    let lastArgs;
    function queuedFn() {
        try {
            fn(...lastArgs);
        } finally{
            lastArgs = null;
        }
    }
    function throttled(...args) {
        lastArgs = args;
        $7a0c7bd96c8bfe17$export$27f233d61a9e2fa4.onStart(queuedFn);
    }
    throttled.handler = fn;
    throttled.cancel = ()=>{
        $7a0c7bd96c8bfe17$var$onStartQueue.delete(queuedFn);
        lastArgs = null;
    };
    return throttled;
};
let $7a0c7bd96c8bfe17$var$nativeRaf = typeof window != "undefined" ? window.requestAnimationFrame : ()=>{};
$7a0c7bd96c8bfe17$export$27f233d61a9e2fa4.use = (impl)=>$7a0c7bd96c8bfe17$var$nativeRaf = impl;
$7a0c7bd96c8bfe17$export$27f233d61a9e2fa4.now = typeof performance != "undefined" ? ()=>performance.now() : Date.now;
$7a0c7bd96c8bfe17$export$27f233d61a9e2fa4.batchedUpdates = (fn)=>fn();
$7a0c7bd96c8bfe17$export$27f233d61a9e2fa4.catch = console.error;
$7a0c7bd96c8bfe17$export$27f233d61a9e2fa4.frameLoop = "always";
$7a0c7bd96c8bfe17$export$27f233d61a9e2fa4.onDemand = ()=>{};
$7a0c7bd96c8bfe17$export$27f233d61a9e2fa4.advance = ()=>{
    if ($7a0c7bd96c8bfe17$export$27f233d61a9e2fa4.frameLoop !== "demand") console.warn("Cannot call the manual advancement of rafz whilst frameLoop is not set as demand");
    else $7a0c7bd96c8bfe17$var$update();
};
/** The most recent timestamp. */ let $7a0c7bd96c8bfe17$var$ts = -1;
/** The number of pending tasks  */ let $7a0c7bd96c8bfe17$var$pendingCount = 0;
/** When true, scheduling is disabled. */ let $7a0c7bd96c8bfe17$var$sync = false;
function $7a0c7bd96c8bfe17$var$schedule(fn, queue) {
    if ($7a0c7bd96c8bfe17$var$sync) {
        queue.delete(fn);
        fn(0);
    } else {
        queue.add(fn);
        $7a0c7bd96c8bfe17$var$start();
        if ($7a0c7bd96c8bfe17$export$27f233d61a9e2fa4.frameLoop === "demand") $7a0c7bd96c8bfe17$export$27f233d61a9e2fa4.onDemand();
    }
}
function $7a0c7bd96c8bfe17$var$start() {
    if ($7a0c7bd96c8bfe17$var$ts < 0) {
        $7a0c7bd96c8bfe17$var$ts = 0;
        if ($7a0c7bd96c8bfe17$export$27f233d61a9e2fa4.frameLoop !== "demand") $7a0c7bd96c8bfe17$var$nativeRaf($7a0c7bd96c8bfe17$var$loop);
    }
}
function $7a0c7bd96c8bfe17$var$stop() {
    $7a0c7bd96c8bfe17$var$ts = -1;
}
function $7a0c7bd96c8bfe17$var$loop() {
    if (~$7a0c7bd96c8bfe17$var$ts) {
        $7a0c7bd96c8bfe17$var$nativeRaf($7a0c7bd96c8bfe17$var$loop);
        $7a0c7bd96c8bfe17$export$27f233d61a9e2fa4.batchedUpdates($7a0c7bd96c8bfe17$var$update);
    }
}
function $7a0c7bd96c8bfe17$var$update() {
    const prevTs = $7a0c7bd96c8bfe17$var$ts;
    $7a0c7bd96c8bfe17$var$ts = $7a0c7bd96c8bfe17$export$27f233d61a9e2fa4.now();
    const count = $7a0c7bd96c8bfe17$var$findTimeout($7a0c7bd96c8bfe17$var$ts);
    if (count) {
        $7a0c7bd96c8bfe17$var$eachSafely($7a0c7bd96c8bfe17$var$timeouts.splice(0, count), (t)=>t.handler());
        $7a0c7bd96c8bfe17$var$pendingCount -= count;
    }
    if (!$7a0c7bd96c8bfe17$var$pendingCount) {
        $7a0c7bd96c8bfe17$var$stop();
        return;
    }
    $7a0c7bd96c8bfe17$var$onStartQueue.flush();
    $7a0c7bd96c8bfe17$var$updateQueue.flush(prevTs ? Math.min(64, $7a0c7bd96c8bfe17$var$ts - prevTs) : 16.667);
    $7a0c7bd96c8bfe17$var$onFrameQueue.flush();
    $7a0c7bd96c8bfe17$var$writeQueue.flush();
    $7a0c7bd96c8bfe17$var$onFinishQueue.flush();
    if ($7a0c7bd96c8bfe17$export$27f233d61a9e2fa4.frameLoop === "demand" && $7a0c7bd96c8bfe17$var$pendingCount > 0) $7a0c7bd96c8bfe17$export$27f233d61a9e2fa4.onDemand();
}
function $7a0c7bd96c8bfe17$var$makeQueue() {
    let next = /* @__PURE__ */ new Set();
    let current = next;
    return {
        add (fn) {
            $7a0c7bd96c8bfe17$var$pendingCount += current == next && !next.has(fn) ? 1 : 0;
            next.add(fn);
        },
        delete (fn) {
            $7a0c7bd96c8bfe17$var$pendingCount -= current == next && next.has(fn) ? 1 : 0;
            return next.delete(fn);
        },
        flush (arg) {
            if (current.size) {
                next = /* @__PURE__ */ new Set();
                $7a0c7bd96c8bfe17$var$pendingCount -= current.size;
                $7a0c7bd96c8bfe17$var$eachSafely(current, (fn)=>fn(arg) && next.add(fn));
                $7a0c7bd96c8bfe17$var$pendingCount += next.size;
                current = next;
            }
        }
    };
}
function $7a0c7bd96c8bfe17$var$eachSafely(values, each) {
    values.forEach((value)=>{
        try {
            each(value);
        } catch (e) {
            $7a0c7bd96c8bfe17$export$27f233d61a9e2fa4.catch(e);
        }
    });
}
/** Tree-shakable state for testing purposes */ const $7a0c7bd96c8bfe17$export$ef91a23fc803e177 = {
    /** The number of pending tasks */ count () {
        return $7a0c7bd96c8bfe17$var$pendingCount;
    },
    /** Whether there's a raf update loop running */ isRunning () {
        return $7a0c7bd96c8bfe17$var$ts >= 0;
    },
    /** Clear internal state. Never call from update loop! */ clear () {
        $7a0c7bd96c8bfe17$var$ts = -1;
        $7a0c7bd96c8bfe17$var$timeouts = [];
        $7a0c7bd96c8bfe17$var$onStartQueue = $7a0c7bd96c8bfe17$var$makeQueue();
        $7a0c7bd96c8bfe17$var$updateQueue = $7a0c7bd96c8bfe17$var$makeQueue();
        $7a0c7bd96c8bfe17$var$onFrameQueue = $7a0c7bd96c8bfe17$var$makeQueue();
        $7a0c7bd96c8bfe17$var$writeQueue = $7a0c7bd96c8bfe17$var$makeQueue();
        $7a0c7bd96c8bfe17$var$onFinishQueue = $7a0c7bd96c8bfe17$var$makeQueue();
        $7a0c7bd96c8bfe17$var$pendingCount = 0;
    }
};



var $5E6i4 = parcelRequire("5E6i4");
//#region src/helpers.ts
function $16ba30d4a13c00f2$export$8793edee2d425525() {}
const $16ba30d4a13c00f2$export$5c74248ea0e35446 = (obj, key, value)=>Object.defineProperty(obj, key, {
        value: value,
        writable: true,
        configurable: true
    });
const $16ba30d4a13c00f2$export$226b3eccf92c9ed9 = {
    arr: Array.isArray,
    obj: (a)=>!!a && a.constructor.name === "Object",
    fun: (a)=>typeof a === "function",
    str: (a)=>typeof a === "string",
    num: (a)=>typeof a === "number",
    und: (a)=>a === void 0
};
/** Compare animatable values */ function $16ba30d4a13c00f2$export$248d38f6296296c5(a, b) {
    if ($16ba30d4a13c00f2$export$226b3eccf92c9ed9.arr(a)) {
        if (!$16ba30d4a13c00f2$export$226b3eccf92c9ed9.arr(b) || a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++)if (a[i] !== b[i]) return false;
        return true;
    }
    return a === b;
}
/** Minifiable `.forEach` call */ const $16ba30d4a13c00f2$export$79b2f7037acddd43 = (obj, fn)=>obj.forEach(fn);
/** Iterate the properties of an object */ function $16ba30d4a13c00f2$export$f4c6fe153f5a944e(obj, fn, ctx) {
    if ($16ba30d4a13c00f2$export$226b3eccf92c9ed9.arr(obj)) {
        for(let i = 0; i < obj.length; i++)fn.call(ctx, obj[i], `${i}`);
        return;
    }
    for(const key in obj)if (obj.hasOwnProperty(key)) fn.call(ctx, obj[key], key);
}
const $16ba30d4a13c00f2$export$45b10814cc054894 = (a)=>$16ba30d4a13c00f2$export$226b3eccf92c9ed9.und(a) ? [] : $16ba30d4a13c00f2$export$226b3eccf92c9ed9.arr(a) ? a : [
        a
    ];
function $16ba30d4a13c00f2$export$4909b86c8034bf73(queue, iterator) {
    if (queue.size) {
        const items = Array.from(queue);
        queue.clear();
        $16ba30d4a13c00f2$export$79b2f7037acddd43(items, iterator);
    }
}
/** Call every function in the queue with the same arguments. */ const $16ba30d4a13c00f2$export$7ba486852759e806 = (queue, ...args)=>$16ba30d4a13c00f2$export$4909b86c8034bf73(queue, (fn)=>fn(...args));
const $16ba30d4a13c00f2$export$48d7c418edadb60c = ()=>typeof window === "undefined" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);
//#endregion
//#region src/globals.ts
var $16ba30d4a13c00f2$export$cceeabf822b64fc0 = /* @__PURE__ */ (0, $b767f6cddc9ce6d2$export$625550452a3fa3ec)({
    assign: ()=>$16ba30d4a13c00f2$var$assign,
    colors: ()=>$16ba30d4a13c00f2$var$colors$1,
    createStringInterpolator: ()=>$16ba30d4a13c00f2$var$createStringInterpolator$1,
    skipAnimation: ()=>$16ba30d4a13c00f2$var$skipAnimation,
    to: ()=>$16ba30d4a13c00f2$var$to,
    willAdvance: ()=>$16ba30d4a13c00f2$var$willAdvance
});
let $16ba30d4a13c00f2$var$createStringInterpolator$1;
let $16ba30d4a13c00f2$var$to;
let $16ba30d4a13c00f2$var$colors$1 = null;
let $16ba30d4a13c00f2$var$skipAnimation = false;
let $16ba30d4a13c00f2$var$willAdvance = $16ba30d4a13c00f2$export$8793edee2d425525;
const $16ba30d4a13c00f2$var$assign = (globals)=>{
    if (globals.to) $16ba30d4a13c00f2$var$to = globals.to;
    if (globals.now) (0, $7a0c7bd96c8bfe17$export$27f233d61a9e2fa4).now = globals.now;
    if (globals.colors !== void 0) $16ba30d4a13c00f2$var$colors$1 = globals.colors;
    if (globals.skipAnimation != null) $16ba30d4a13c00f2$var$skipAnimation = globals.skipAnimation;
    if (globals.createStringInterpolator) $16ba30d4a13c00f2$var$createStringInterpolator$1 = globals.createStringInterpolator;
    if (globals.requestAnimationFrame) (0, $7a0c7bd96c8bfe17$export$27f233d61a9e2fa4).use(globals.requestAnimationFrame);
    if (globals.batchedUpdates) (0, $7a0c7bd96c8bfe17$export$27f233d61a9e2fa4).batchedUpdates = globals.batchedUpdates;
    if (globals.willAdvance) $16ba30d4a13c00f2$var$willAdvance = globals.willAdvance;
    if (globals.frameLoop) (0, $7a0c7bd96c8bfe17$export$27f233d61a9e2fa4).frameLoop = globals.frameLoop;
    if (globals.onDemand) (0, $7a0c7bd96c8bfe17$export$27f233d61a9e2fa4).onDemand = globals.onDemand;
};
//#endregion
//#region src/FrameLoop.ts
const $16ba30d4a13c00f2$var$startQueue = /* @__PURE__ */ new Set();
let $16ba30d4a13c00f2$var$currentFrame = [];
let $16ba30d4a13c00f2$var$prevFrame = [];
let $16ba30d4a13c00f2$var$priority = 0;
/**
* The frameloop executes its animations in order of lowest priority first.
* Animations are retained until idle.
*/ const $16ba30d4a13c00f2$export$a57f5080a3bcc90a = {
    get idle () {
        return !$16ba30d4a13c00f2$var$startQueue.size && !$16ba30d4a13c00f2$var$currentFrame.length;
    },
    /** Advance the given animation on every frame until idle. */ start (animation) {
        if ($16ba30d4a13c00f2$var$priority > animation.priority) {
            $16ba30d4a13c00f2$var$startQueue.add(animation);
            (0, $7a0c7bd96c8bfe17$export$27f233d61a9e2fa4).onStart($16ba30d4a13c00f2$var$flushStartQueue);
        } else {
            $16ba30d4a13c00f2$var$startSafely(animation);
            (0, $7a0c7bd96c8bfe17$export$27f233d61a9e2fa4)($16ba30d4a13c00f2$var$advance);
        }
    },
    advance: /** Advance all animations by the given time. */ $16ba30d4a13c00f2$var$advance,
    /** Call this when an animation's priority changes. */ sort (animation) {
        if ($16ba30d4a13c00f2$var$priority) (0, $7a0c7bd96c8bfe17$export$27f233d61a9e2fa4).onFrame(()=>$16ba30d4a13c00f2$export$a57f5080a3bcc90a.sort(animation));
        else {
            const prevIndex = $16ba30d4a13c00f2$var$currentFrame.indexOf(animation);
            if (~prevIndex) {
                $16ba30d4a13c00f2$var$currentFrame.splice(prevIndex, 1);
                $16ba30d4a13c00f2$var$startUnsafely(animation);
            }
        }
    },
    /**
	* Clear all animations. For testing purposes.
	*
	* ☠️ Never call this from within the frameloop.
	*/ clear () {
        $16ba30d4a13c00f2$var$currentFrame = [];
        $16ba30d4a13c00f2$var$startQueue.clear();
    }
};
function $16ba30d4a13c00f2$var$flushStartQueue() {
    $16ba30d4a13c00f2$var$startQueue.forEach($16ba30d4a13c00f2$var$startSafely);
    $16ba30d4a13c00f2$var$startQueue.clear();
    (0, $7a0c7bd96c8bfe17$export$27f233d61a9e2fa4)($16ba30d4a13c00f2$var$advance);
}
function $16ba30d4a13c00f2$var$startSafely(animation) {
    if (!$16ba30d4a13c00f2$var$currentFrame.includes(animation)) $16ba30d4a13c00f2$var$startUnsafely(animation);
}
function $16ba30d4a13c00f2$var$startUnsafely(animation) {
    $16ba30d4a13c00f2$var$currentFrame.splice($16ba30d4a13c00f2$var$findIndex($16ba30d4a13c00f2$var$currentFrame, (other)=>other.priority > animation.priority), 0, animation);
}
function $16ba30d4a13c00f2$var$advance(dt) {
    const nextFrame = $16ba30d4a13c00f2$var$prevFrame;
    for(let i = 0; i < $16ba30d4a13c00f2$var$currentFrame.length; i++){
        const animation = $16ba30d4a13c00f2$var$currentFrame[i];
        $16ba30d4a13c00f2$var$priority = animation.priority;
        if (!animation.idle) {
            $16ba30d4a13c00f2$var$willAdvance(animation);
            animation.advance(dt);
            if (!animation.idle) nextFrame.push(animation);
        }
    }
    $16ba30d4a13c00f2$var$priority = 0;
    $16ba30d4a13c00f2$var$prevFrame = $16ba30d4a13c00f2$var$currentFrame;
    $16ba30d4a13c00f2$var$prevFrame.length = 0;
    $16ba30d4a13c00f2$var$currentFrame = nextFrame;
    return $16ba30d4a13c00f2$var$currentFrame.length > 0;
}
/** Like `Array.prototype.findIndex` but returns `arr.length` instead of `-1` */ function $16ba30d4a13c00f2$var$findIndex(arr, test) {
    const index = arr.findIndex(test);
    return index < 0 ? arr.length : index;
}
//#endregion
//#region src/clamp.ts
const $16ba30d4a13c00f2$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);
//#endregion
//#region src/colors.ts
const $16ba30d4a13c00f2$export$8f45430ccf837300 = {
    transparent: 0,
    aliceblue: 4042850303,
    antiquewhite: 4209760255,
    aqua: 16777215,
    aquamarine: 2147472639,
    azure: 4043309055,
    beige: 4126530815,
    bisque: 4293182719,
    black: 255,
    blanchedalmond: 4293643775,
    blue: 65535,
    blueviolet: 2318131967,
    brown: 2771004159,
    burlywood: 3736635391,
    burntsienna: 3934150143,
    cadetblue: 1604231423,
    chartreuse: 2147418367,
    chocolate: 3530104575,
    coral: 4286533887,
    cornflowerblue: 1687547391,
    cornsilk: 4294499583,
    crimson: 3692313855,
    cyan: 16777215,
    darkblue: 35839,
    darkcyan: 9145343,
    darkgoldenrod: 3095792639,
    darkgray: 2846468607,
    darkgreen: 6553855,
    darkgrey: 2846468607,
    darkkhaki: 3182914559,
    darkmagenta: 2332068863,
    darkolivegreen: 1433087999,
    darkorange: 4287365375,
    darkorchid: 2570243327,
    darkred: 2332033279,
    darksalmon: 3918953215,
    darkseagreen: 2411499519,
    darkslateblue: 1211993087,
    darkslategray: 793726975,
    darkslategrey: 793726975,
    darkturquoise: 13554175,
    darkviolet: 2483082239,
    deeppink: 4279538687,
    deepskyblue: 12582911,
    dimgray: 1768516095,
    dimgrey: 1768516095,
    dodgerblue: 512819199,
    firebrick: 2988581631,
    floralwhite: 4294635775,
    forestgreen: 579543807,
    fuchsia: 4278255615,
    gainsboro: 3705462015,
    ghostwhite: 4177068031,
    gold: 4292280575,
    goldenrod: 3668254975,
    gray: 2155905279,
    green: 8388863,
    greenyellow: 2919182335,
    grey: 2155905279,
    honeydew: 4043305215,
    hotpink: 4285117695,
    indianred: 3445382399,
    indigo: 1258324735,
    ivory: 4294963455,
    khaki: 4041641215,
    lavender: 3873897215,
    lavenderblush: 4293981695,
    lawngreen: 2096890111,
    lemonchiffon: 4294626815,
    lightblue: 2916673279,
    lightcoral: 4034953471,
    lightcyan: 3774873599,
    lightgoldenrodyellow: 4210742015,
    lightgray: 3553874943,
    lightgreen: 2431553791,
    lightgrey: 3553874943,
    lightpink: 4290167295,
    lightsalmon: 4288707327,
    lightseagreen: 548580095,
    lightskyblue: 2278488831,
    lightslategray: 2005441023,
    lightslategrey: 2005441023,
    lightsteelblue: 2965692159,
    lightyellow: 4294959359,
    lime: 16711935,
    limegreen: 852308735,
    linen: 4210091775,
    magenta: 4278255615,
    maroon: 2147483903,
    mediumaquamarine: 1724754687,
    mediumblue: 52735,
    mediumorchid: 3126187007,
    mediumpurple: 2473647103,
    mediumseagreen: 1018393087,
    mediumslateblue: 2070474495,
    mediumspringgreen: 16423679,
    mediumturquoise: 1221709055,
    mediumvioletred: 3340076543,
    midnightblue: 421097727,
    mintcream: 4127193855,
    mistyrose: 4293190143,
    moccasin: 4293178879,
    navajowhite: 4292783615,
    navy: 33023,
    oldlace: 4260751103,
    olive: 2155872511,
    olivedrab: 1804477439,
    orange: 4289003775,
    orangered: 4282712319,
    orchid: 3664828159,
    palegoldenrod: 4008225535,
    palegreen: 2566625535,
    paleturquoise: 2951671551,
    palevioletred: 3681588223,
    papayawhip: 4293907967,
    peachpuff: 4292524543,
    peru: 3448061951,
    pink: 4290825215,
    plum: 3718307327,
    powderblue: 2967529215,
    purple: 2147516671,
    rebeccapurple: 1714657791,
    red: 4278190335,
    rosybrown: 3163525119,
    royalblue: 1097458175,
    saddlebrown: 2336560127,
    salmon: 4202722047,
    sandybrown: 4104413439,
    seagreen: 780883967,
    seashell: 4294307583,
    sienna: 2689740287,
    silver: 3233857791,
    skyblue: 2278484991,
    slateblue: 1784335871,
    slategray: 1887473919,
    slategrey: 1887473919,
    snow: 4294638335,
    springgreen: 16744447,
    steelblue: 1182971135,
    tan: 3535047935,
    teal: 8421631,
    thistle: 3636451583,
    tomato: 4284696575,
    turquoise: 1088475391,
    violet: 4001558271,
    wheat: 4125012991,
    white: 4294967295,
    whitesmoke: 4126537215,
    yellow: 4294902015,
    yellowgreen: 2597139199
};
//#endregion
//#region src/colorMatchers.ts
const $16ba30d4a13c00f2$var$NUMBER = "[-+]?\\d*\\.?\\d+";
const $16ba30d4a13c00f2$var$PERCENTAGE = "[-+]?\\d*\\.?\\d+%";
function $16ba30d4a13c00f2$var$call(...parts) {
    return "\\(\\s*(" + parts.join(")\\s*,\\s*(") + ")\\s*\\)";
}
const $16ba30d4a13c00f2$export$8972dc0e6ad9238f = new RegExp("rgb" + $16ba30d4a13c00f2$var$call($16ba30d4a13c00f2$var$NUMBER, $16ba30d4a13c00f2$var$NUMBER, $16ba30d4a13c00f2$var$NUMBER));
const $16ba30d4a13c00f2$export$4e46ac54fc82cf3b = new RegExp("rgba" + $16ba30d4a13c00f2$var$call($16ba30d4a13c00f2$var$NUMBER, $16ba30d4a13c00f2$var$NUMBER, $16ba30d4a13c00f2$var$NUMBER, $16ba30d4a13c00f2$var$NUMBER));
const $16ba30d4a13c00f2$export$8f4a7c0bb78e6ea8 = new RegExp("hsl" + $16ba30d4a13c00f2$var$call($16ba30d4a13c00f2$var$NUMBER, $16ba30d4a13c00f2$var$PERCENTAGE, $16ba30d4a13c00f2$var$PERCENTAGE));
const $16ba30d4a13c00f2$export$810b04175080204c = new RegExp("hsla" + $16ba30d4a13c00f2$var$call($16ba30d4a13c00f2$var$NUMBER, $16ba30d4a13c00f2$var$PERCENTAGE, $16ba30d4a13c00f2$var$PERCENTAGE, $16ba30d4a13c00f2$var$NUMBER));
const $16ba30d4a13c00f2$export$a99b93d698493da5 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
const $16ba30d4a13c00f2$export$4573e032242724d8 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
const $16ba30d4a13c00f2$export$86e51e8f361b966e = /^#([0-9a-fA-F]{6})$/;
const $16ba30d4a13c00f2$export$a09ec12fb14c61c4 = /^#([0-9a-fA-F]{8})$/;
//#endregion
//#region src/normalizeColor.ts
function $16ba30d4a13c00f2$var$normalizeColor(color) {
    let match;
    if (typeof color === "number") return color >>> 0 === color && color >= 0 && color <= 4294967295 ? color : null;
    if (match = $16ba30d4a13c00f2$export$86e51e8f361b966e.exec(color)) return parseInt(match[1] + "ff", 16) >>> 0;
    if ($16ba30d4a13c00f2$var$colors$1 && $16ba30d4a13c00f2$var$colors$1[color] !== void 0) return $16ba30d4a13c00f2$var$colors$1[color];
    if (match = $16ba30d4a13c00f2$export$8972dc0e6ad9238f.exec(color)) return ($16ba30d4a13c00f2$var$parse255(match[1]) << 24 | $16ba30d4a13c00f2$var$parse255(match[2]) << 16 | $16ba30d4a13c00f2$var$parse255(match[3]) << 8 | 255) >>> 0;
    if (match = $16ba30d4a13c00f2$export$4e46ac54fc82cf3b.exec(color)) return ($16ba30d4a13c00f2$var$parse255(match[1]) << 24 | $16ba30d4a13c00f2$var$parse255(match[2]) << 16 | $16ba30d4a13c00f2$var$parse255(match[3]) << 8 | $16ba30d4a13c00f2$var$parse1(match[4])) >>> 0;
    if (match = $16ba30d4a13c00f2$export$a99b93d698493da5.exec(color)) return parseInt(match[1] + match[1] + match[2] + match[2] + match[3] + match[3] + "ff", 16) >>> 0;
    if (match = $16ba30d4a13c00f2$export$a09ec12fb14c61c4.exec(color)) return parseInt(match[1], 16) >>> 0;
    if (match = $16ba30d4a13c00f2$export$4573e032242724d8.exec(color)) return parseInt(match[1] + match[1] + match[2] + match[2] + match[3] + match[3] + match[4] + match[4], 16) >>> 0;
    if (match = $16ba30d4a13c00f2$export$8f4a7c0bb78e6ea8.exec(color)) return ($16ba30d4a13c00f2$var$hslToRgb($16ba30d4a13c00f2$var$parse360(match[1]), $16ba30d4a13c00f2$var$parsePercentage(match[2]), $16ba30d4a13c00f2$var$parsePercentage(match[3])) | 255) >>> 0;
    if (match = $16ba30d4a13c00f2$export$810b04175080204c.exec(color)) return ($16ba30d4a13c00f2$var$hslToRgb($16ba30d4a13c00f2$var$parse360(match[1]), $16ba30d4a13c00f2$var$parsePercentage(match[2]), $16ba30d4a13c00f2$var$parsePercentage(match[3])) | $16ba30d4a13c00f2$var$parse1(match[4])) >>> 0;
    return null;
}
function $16ba30d4a13c00f2$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $16ba30d4a13c00f2$var$hslToRgb(h, s, l) {
    const q = l < .5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    const r = $16ba30d4a13c00f2$var$hue2rgb(p, q, h + 1 / 3);
    const g = $16ba30d4a13c00f2$var$hue2rgb(p, q, h);
    const b = $16ba30d4a13c00f2$var$hue2rgb(p, q, h - 1 / 3);
    return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
}
function $16ba30d4a13c00f2$var$parse255(str) {
    const int = parseInt(str, 10);
    if (int < 0) return 0;
    if (int > 255) return 255;
    return int;
}
function $16ba30d4a13c00f2$var$parse360(str) {
    return (parseFloat(str) % 360 + 360) % 360 / 360;
}
function $16ba30d4a13c00f2$var$parse1(str) {
    const num = parseFloat(str);
    if (num < 0) return 0;
    if (num > 1) return 255;
    return Math.round(num * 255);
}
function $16ba30d4a13c00f2$var$parsePercentage(str) {
    const int = parseFloat(str);
    if (int < 0) return 0;
    if (int > 100) return 1;
    return int / 100;
}
//#endregion
//#region src/colorToRgba.ts
function $16ba30d4a13c00f2$export$61db176b839af1f(input) {
    let int32Color = $16ba30d4a13c00f2$var$normalizeColor(input);
    if (int32Color === null) return input;
    int32Color = int32Color || 0;
    return `rgba(${(int32Color & 4278190080) >>> 24}, ${(int32Color & 16711680) >>> 16}, ${(int32Color & 65280) >>> 8}, ${(int32Color & 255) / 255})`;
}
//#endregion
//#region src/createInterpolator.ts
const $16ba30d4a13c00f2$export$b12af43b97697ef5 = (range, output, extrapolate)=>{
    if ($16ba30d4a13c00f2$export$226b3eccf92c9ed9.fun(range)) return range;
    if ($16ba30d4a13c00f2$export$226b3eccf92c9ed9.arr(range)) return $16ba30d4a13c00f2$export$b12af43b97697ef5({
        range: range,
        output: output,
        extrapolate: extrapolate
    });
    if ($16ba30d4a13c00f2$export$226b3eccf92c9ed9.str(range.output[0])) return $16ba30d4a13c00f2$var$createStringInterpolator$1(range);
    const config = range;
    const outputRange = config.output;
    const inputRange = config.range || [
        0,
        1
    ];
    const extrapolateLeft = config.extrapolateLeft || config.extrapolate || "extend";
    const extrapolateRight = config.extrapolateRight || config.extrapolate || "extend";
    const easing = config.easing || ((t)=>t);
    return (input)=>{
        const range = $16ba30d4a13c00f2$var$findRange(input, inputRange);
        return $16ba30d4a13c00f2$var$interpolate(input, inputRange[range], inputRange[range + 1], outputRange[range], outputRange[range + 1], easing, extrapolateLeft, extrapolateRight, config.map);
    };
};
function $16ba30d4a13c00f2$var$interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
    let result = map ? map(input) : input;
    if (result < inputMin) {
        if (extrapolateLeft === "identity") return result;
        else if (extrapolateLeft === "clamp") result = inputMin;
    }
    if (result > inputMax) {
        if (extrapolateRight === "identity") return result;
        else if (extrapolateRight === "clamp") result = inputMax;
    }
    if (outputMin === outputMax) return outputMin;
    if (inputMin === inputMax) return input <= inputMin ? outputMin : outputMax;
    if (inputMin === -Infinity) result = -result;
    else if (inputMax === Infinity) result = result - inputMin;
    else result = (result - inputMin) / (inputMax - inputMin);
    result = easing(result);
    if (outputMin === -Infinity) result = -result;
    else if (outputMax === Infinity) result = result + outputMin;
    else result = result * (outputMax - outputMin) + outputMin;
    return result;
}
function $16ba30d4a13c00f2$var$findRange(input, inputRange) {
    for(var i = 1; i < inputRange.length - 1; ++i)if (inputRange[i] >= input) break;
    return i - 1;
}
//#endregion
//#region src/easings.ts
const $16ba30d4a13c00f2$var$steps = (steps, direction = "end")=>(progress)=>{
        progress = direction === "end" ? Math.min(progress, .999) : Math.max(progress, .001);
        const expanded = progress * steps;
        return $16ba30d4a13c00f2$export$7d15b64cf5a3a4c4(0, 1, (direction === "end" ? Math.floor(expanded) : Math.ceil(expanded)) / steps);
    };
const $16ba30d4a13c00f2$var$c1 = 1.70158;
const $16ba30d4a13c00f2$var$c2 = $16ba30d4a13c00f2$var$c1 * 1.525;
const $16ba30d4a13c00f2$var$c3 = 2.70158;
const $16ba30d4a13c00f2$var$c4 = 2 * Math.PI / 3;
const $16ba30d4a13c00f2$var$c5 = 2 * Math.PI / 4.5;
const $16ba30d4a13c00f2$var$bounceOut = (x)=>{
    const n1 = 7.5625;
    const d1 = 2.75;
    if (x < 1 / d1) return n1 * x * x;
    else if (x < 2 / d1) return n1 * (x -= 1.5 / d1) * x + .75;
    else if (x < 2.5 / d1) return n1 * (x -= 2.25 / d1) * x + .9375;
    else return n1 * (x -= 2.625 / d1) * x + .984375;
};
const $16ba30d4a13c00f2$export$15a0bf1b4bbacad8 = {
    linear: (x)=>x,
    easeInQuad: (x)=>x * x,
    easeOutQuad: (x)=>1 - (1 - x) * (1 - x),
    easeInOutQuad: (x)=>x < .5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2,
    easeInCubic: (x)=>x * x * x,
    easeOutCubic: (x)=>1 - Math.pow(1 - x, 3),
    easeInOutCubic: (x)=>x < .5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2,
    easeInQuart: (x)=>x * x * x * x,
    easeOutQuart: (x)=>1 - Math.pow(1 - x, 4),
    easeInOutQuart: (x)=>x < .5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2,
    easeInQuint: (x)=>x * x * x * x * x,
    easeOutQuint: (x)=>1 - Math.pow(1 - x, 5),
    easeInOutQuint: (x)=>x < .5 ? 16 * x * x * x * x * x : 1 - Math.pow(-2 * x + 2, 5) / 2,
    easeInSine: (x)=>1 - Math.cos(x * Math.PI / 2),
    easeOutSine: (x)=>Math.sin(x * Math.PI / 2),
    easeInOutSine: (x)=>-(Math.cos(Math.PI * x) - 1) / 2,
    easeInExpo: (x)=>x === 0 ? 0 : Math.pow(2, 10 * x - 10),
    easeOutExpo: (x)=>x === 1 ? 1 : 1 - Math.pow(2, -10 * x),
    easeInOutExpo: (x)=>x === 0 ? 0 : x === 1 ? 1 : x < .5 ? Math.pow(2, 20 * x - 10) / 2 : (2 - Math.pow(2, -20 * x + 10)) / 2,
    easeInCirc: (x)=>1 - Math.sqrt(1 - Math.pow(x, 2)),
    easeOutCirc: (x)=>Math.sqrt(1 - Math.pow(x - 1, 2)),
    easeInOutCirc: (x)=>x < .5 ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2,
    easeInBack: (x)=>$16ba30d4a13c00f2$var$c3 * x * x * x - $16ba30d4a13c00f2$var$c1 * x * x,
    easeOutBack: (x)=>1 + $16ba30d4a13c00f2$var$c3 * Math.pow(x - 1, 3) + $16ba30d4a13c00f2$var$c1 * Math.pow(x - 1, 2),
    easeInOutBack: (x)=>x < .5 ? Math.pow(2 * x, 2) * (7.189819 * x - $16ba30d4a13c00f2$var$c2) / 2 : (Math.pow(2 * x - 2, 2) * (3.5949095 * (x * 2 - 2) + $16ba30d4a13c00f2$var$c2) + 2) / 2,
    easeInElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : -Math.pow(2, 10 * x - 10) * Math.sin((x * 10 - 10.75) * $16ba30d4a13c00f2$var$c4),
    easeOutElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : Math.pow(2, -10 * x) * Math.sin((x * 10 - .75) * $16ba30d4a13c00f2$var$c4) + 1,
    easeInOutElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : x < .5 ? -(Math.pow(2, 20 * x - 10) * Math.sin((20 * x - 11.125) * $16ba30d4a13c00f2$var$c5)) / 2 : Math.pow(2, -20 * x + 10) * Math.sin((20 * x - 11.125) * $16ba30d4a13c00f2$var$c5) / 2 + 1,
    easeInBounce: (x)=>1 - $16ba30d4a13c00f2$var$bounceOut(1 - x),
    easeOutBounce: $16ba30d4a13c00f2$var$bounceOut,
    easeInOutBounce: (x)=>x < .5 ? (1 - $16ba30d4a13c00f2$var$bounceOut(1 - 2 * x)) / 2 : (1 + $16ba30d4a13c00f2$var$bounceOut(2 * x - 1)) / 2,
    steps: $16ba30d4a13c00f2$var$steps
};
//#endregion
//#region src/fluids.ts
/**
* MIT License
* Copyright (c) Alec Larson
* Permission is hereby granted, free of charge, to any person obtaining a copy
* of this software and associated documentation files (the "Software"), to deal
* in the Software without restriction, including without limitation the rights
* to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
* copies of the Software, and to permit persons to whom the Software is
* furnished to do so, subject to the following conditions:
*
* The above copyright notice and this permission notice shall be included in all
* copies or substantial portions of the Software.
*
* THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
* IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
* FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
* AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
* LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
* OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
* SOFTWARE.
*/ const $16ba30d4a13c00f2$var$$get = Symbol.for("FluidValue.get");
const $16ba30d4a13c00f2$var$$observers = Symbol.for("FluidValue.observers");
/** Returns true if `arg` can be observed. */ const $16ba30d4a13c00f2$export$57ea7e3a7f6280c7 = (arg)=>Boolean(arg && arg[$16ba30d4a13c00f2$var$$get]);
/**
* Get the current value.
* If `arg` is not observable, `arg` is returned.
*/ const $16ba30d4a13c00f2$export$e37b7520edd66839 = (arg)=>arg && arg[$16ba30d4a13c00f2$var$$get] ? arg[$16ba30d4a13c00f2$var$$get]() : arg;
/** Get the current observer set. Never mutate it directly! */ const $16ba30d4a13c00f2$export$133f54e9f7cf1796 = (target)=>target[$16ba30d4a13c00f2$var$$observers] || null;
function $16ba30d4a13c00f2$export$8cbca1207adce0c0(observer, event) {
    if (observer.eventObserved) observer.eventObserved(event);
    else observer(event);
}
function $16ba30d4a13c00f2$export$31752c40a5fab62a(target, event) {
    const observers = target[$16ba30d4a13c00f2$var$$observers];
    if (observers) observers.forEach((observer)=>{
        $16ba30d4a13c00f2$export$8cbca1207adce0c0(observer, event);
    });
}
/**
* Extend this class for automatic TypeScript support when passing this
* value to `fluids`-compatible libraries.
*/ var $16ba30d4a13c00f2$export$aff8e1ac1a016a2 = class {
    constructor(get){
        if (!get && !(get = this.get)) throw Error("Unknown getter");
        $16ba30d4a13c00f2$export$a3b4618659637aa3(this, get);
    }
};
/** Define the getter called by `getFluidValue`. */ const $16ba30d4a13c00f2$export$a3b4618659637aa3 = (target, get)=>$16ba30d4a13c00f2$var$setHidden(target, $16ba30d4a13c00f2$var$$get, get);
function $16ba30d4a13c00f2$export$72d604e3f8d000a5(target, observer) {
    if (target[$16ba30d4a13c00f2$var$$get]) {
        let observers = target[$16ba30d4a13c00f2$var$$observers];
        if (!observers) $16ba30d4a13c00f2$var$setHidden(target, $16ba30d4a13c00f2$var$$observers, observers = /* @__PURE__ */ new Set());
        if (!observers.has(observer)) {
            observers.add(observer);
            if (target.observerAdded) target.observerAdded(observers.size, observer);
        }
    }
    return observer;
}
function $16ba30d4a13c00f2$export$7a0eb830d336339b(target, observer) {
    const observers = target[$16ba30d4a13c00f2$var$$observers];
    if (observers && observers.has(observer)) {
        const count = observers.size - 1;
        if (count) observers.delete(observer);
        else target[$16ba30d4a13c00f2$var$$observers] = null;
        if (target.observerRemoved) target.observerRemoved(count, observer);
    }
}
const $16ba30d4a13c00f2$var$setHidden = (target, key, value)=>Object.defineProperty(target, key, {
        value: value,
        writable: true,
        configurable: true
    });
//#endregion
//#region src/regexs.ts
const $16ba30d4a13c00f2$var$numberRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
const $16ba30d4a13c00f2$var$colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi;
const $16ba30d4a13c00f2$var$unitRegex = new RegExp(`(${$16ba30d4a13c00f2$var$numberRegex.source})(%|[a-z]+)`, "i");
const $16ba30d4a13c00f2$var$rgbaRegex = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi;
/**
* Parse special CSS variable format into a CSS token and a fallback.
*
* ```
* `var(--foo, #fff)` => [`--foo`, '#fff']
* ```
*
*/ const $16ba30d4a13c00f2$var$cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
//#endregion
//#region src/variableToRgba.ts
/**
* takes a CSS variable and attempts
* to turn it into a RGBA value
*
* ```
* 'var(--white)' => 'rgba(255,255,255,1)'
* ```
*
* @param input string
* @returns string
*/ const $16ba30d4a13c00f2$var$variableToRgba = (input)=>{
    const [token, fallback] = $16ba30d4a13c00f2$var$parseCSSVariable(input);
    if (!token || $16ba30d4a13c00f2$export$48d7c418edadb60c()) return input;
    const value = window.getComputedStyle(document.documentElement).getPropertyValue(token);
    if (value) /**
	* We have a valid variable returned
	* trim and return
	*/ return value.trim();
    else if (fallback && fallback.startsWith("--")) {
        /**
		* fallback is something like --my-variable
		* so we try get property value
		*/ const value = window.getComputedStyle(document.documentElement).getPropertyValue(fallback);
        /**
		* if it exists, return else nothing was found so just return the input
		*/ if (value) return value;
        else return input;
    } else if (fallback && $16ba30d4a13c00f2$var$cssVariableRegex.test(fallback)) /**
	* We have a fallback and it's another CSS variable
	*/ return $16ba30d4a13c00f2$var$variableToRgba(fallback);
    else if (fallback) /**
	* We have a fallback and it's not a CSS variable
	*/ return fallback;
    /**
	* Nothing worked so just return the input
	* like our other FluidValue replace functions do
	*/ return input;
};
const $16ba30d4a13c00f2$var$parseCSSVariable = (current)=>{
    const match = $16ba30d4a13c00f2$var$cssVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token, fallback] = match;
    return [
        token,
        fallback
    ];
};
//#endregion
//#region src/stringInterpolation.ts
let $16ba30d4a13c00f2$var$namedColorRegex;
const $16ba30d4a13c00f2$var$rgbaRound = (_, p1, p2, p3, p4)=>`rgba(${Math.round(p1)}, ${Math.round(p2)}, ${Math.round(p3)}, ${p4})`;
const $16ba30d4a13c00f2$var$getNumbers = (value)=>value.match($16ba30d4a13c00f2$var$numberRegex) ?? [];
/**
* Supports string shapes by extracting numbers so new values can be computed,
* and recombines those values into new strings of the same shape.  Supports
* things like:
*
*     "rgba(123, 42, 99, 0.36)"           // colors
*     "-45deg"                            // values with units
*     "0 2px 2px 0px rgba(0, 0, 0, 0.12)" // CSS box-shadows
*     "rotate(0deg) translate(2px, 3px)"  // CSS transforms
*/ const $16ba30d4a13c00f2$export$4759a013d387347a = (config)=>{
    if (!$16ba30d4a13c00f2$var$namedColorRegex) $16ba30d4a13c00f2$var$namedColorRegex = $16ba30d4a13c00f2$var$colors$1 ? new RegExp(`(${Object.keys($16ba30d4a13c00f2$var$colors$1).join("|")})(?!\\w)`, "g") : /^\b$/;
    const output = config.output.map((value)=>{
        return $16ba30d4a13c00f2$export$e37b7520edd66839(value).replace($16ba30d4a13c00f2$var$cssVariableRegex, $16ba30d4a13c00f2$var$variableToRgba).replace($16ba30d4a13c00f2$var$colorRegex, $16ba30d4a13c00f2$export$61db176b839af1f).replace($16ba30d4a13c00f2$var$namedColorRegex, $16ba30d4a13c00f2$export$61db176b839af1f);
    });
    const keyframes = output.map((value)=>$16ba30d4a13c00f2$var$getNumbers(value).map(Number));
    const interpolators = keyframes[0].map((_, i)=>keyframes.map((values)=>{
            if (!(i in values)) throw Error("The arity of each \"output\" value must be equal");
            return values[i];
        })).map((output)=>$16ba30d4a13c00f2$export$b12af43b97697ef5({
            ...config,
            output: output
        }));
    const inputRange = config.range || [
        0,
        1
    ];
    const allTokens = output.map((value)=>$16ba30d4a13c00f2$var$getNumbers(value));
    const decimalCounts = allTokens[0].map((_, pos)=>{
        const counts = allTokens.map((tokens)=>{
            const token = tokens[pos];
            const dot = token.indexOf(".");
            return dot === -1 ? 0 : token.length - dot - 1;
        });
        return counts.every((c)=>c === counts[0]) && counts[0] > 0 ? counts[0] : null;
    });
    return (input)=>{
        const keyIdx = inputRange.indexOf(input);
        if (keyIdx !== -1) return output[keyIdx];
        const missingUnit = !$16ba30d4a13c00f2$var$unitRegex.test(output[0]) && output.find((value)=>$16ba30d4a13c00f2$var$unitRegex.test(value))?.replace($16ba30d4a13c00f2$var$numberRegex, "");
        let i = 0;
        return output[0].replace($16ba30d4a13c00f2$var$numberRegex, ()=>{
            const pos = i++;
            const value = interpolators[pos](input);
            const decimals = decimalCounts[pos];
            return `${decimals != null ? value.toFixed(decimals) : value}${missingUnit || ""}`;
        }).replace($16ba30d4a13c00f2$var$rgbaRegex, $16ba30d4a13c00f2$var$rgbaRound);
    };
};
//#endregion
//#region src/deprecations.ts
const $16ba30d4a13c00f2$export$82e9f45cca5ba907 = "react-spring: ";
const $16ba30d4a13c00f2$export$d2de3aaeafa91619 = (fn)=>{
    const func = fn;
    let called = false;
    if (typeof func != "function") throw new TypeError(`${$16ba30d4a13c00f2$export$82e9f45cca5ba907}once requires a function parameter`);
    return (...args)=>{
        if (!called) {
            func(...args);
            called = true;
        }
    };
};
const $16ba30d4a13c00f2$var$warnInterpolate = $16ba30d4a13c00f2$export$d2de3aaeafa91619(console.warn);
function $16ba30d4a13c00f2$export$2abfcde8ae218ba8() {
    $16ba30d4a13c00f2$var$warnInterpolate(`${$16ba30d4a13c00f2$export$82e9f45cca5ba907}The "interpolate" function is deprecated in v9 (use "to" instead)`);
}
const $16ba30d4a13c00f2$var$warnDirectCall = $16ba30d4a13c00f2$export$d2de3aaeafa91619(console.warn);
function $16ba30d4a13c00f2$export$d99d974913ad3b12() {
    $16ba30d4a13c00f2$var$warnDirectCall(`${$16ba30d4a13c00f2$export$82e9f45cca5ba907}Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions`);
}
//#endregion
//#region src/isAnimatedString.ts
function $16ba30d4a13c00f2$export$75bed621f62abfa9(value) {
    return $16ba30d4a13c00f2$export$226b3eccf92c9ed9.str(value) && (value[0] == "#" || /\d/.test(value) || !$16ba30d4a13c00f2$export$48d7c418edadb60c() && $16ba30d4a13c00f2$var$cssVariableRegex.test(value) || value in ($16ba30d4a13c00f2$var$colors$1 || {}));
}
//#endregion
//#region src/dom-events/resize/resizeElement.ts
let $16ba30d4a13c00f2$var$observer;
const $16ba30d4a13c00f2$var$resizeHandlers = /* @__PURE__ */ new WeakMap();
const $16ba30d4a13c00f2$var$getBorderBoxSize = (entry)=>{
    const boxSize = Array.isArray(entry.borderBoxSize) ? entry.borderBoxSize[0] : entry.borderBoxSize;
    if (!boxSize) return entry.contentRect;
    const writingMode = getComputedStyle(entry.target).writingMode;
    return writingMode.startsWith("vertical-") || writingMode.startsWith("sideways-") ? {
        width: boxSize.blockSize,
        height: boxSize.inlineSize
    } : {
        width: boxSize.inlineSize,
        height: boxSize.blockSize
    };
};
const $16ba30d4a13c00f2$var$handleObservation = (entries)=>entries.forEach((entry)=>{
        return $16ba30d4a13c00f2$var$resizeHandlers.get(entry.target)?.forEach((handler)=>handler($16ba30d4a13c00f2$var$getBorderBoxSize(entry)));
    });
function $16ba30d4a13c00f2$var$resizeElement(handler, target) {
    /**
	* If there's a resize observer in the ENV then use that too.
	*/ if (!$16ba30d4a13c00f2$var$observer) {
        if (typeof ResizeObserver !== "undefined") $16ba30d4a13c00f2$var$observer = new ResizeObserver($16ba30d4a13c00f2$var$handleObservation);
    }
    /**
	* Fetch the handlers for the target
	*/ let elementHandlers = $16ba30d4a13c00f2$var$resizeHandlers.get(target);
    /**
	* If there are no handlers create a new set for the target
	* and then add to the map
	*/ if (!elementHandlers) {
        elementHandlers = /* @__PURE__ */ new Set();
        $16ba30d4a13c00f2$var$resizeHandlers.set(target, elementHandlers);
    }
    /**
	* Add the handler to the target's set
	* and observe the target if possible.
	*/ elementHandlers.add(handler);
    if ($16ba30d4a13c00f2$var$observer) $16ba30d4a13c00f2$var$observer.observe(target, {
        box: "border-box"
    });
    /**
	* Cleanup the event handlers and potential observers.
	*/ return ()=>{
        const elementHandlers = $16ba30d4a13c00f2$var$resizeHandlers.get(target);
        if (!elementHandlers) return;
        elementHandlers.delete(handler);
        if (!elementHandlers.size && $16ba30d4a13c00f2$var$observer) $16ba30d4a13c00f2$var$observer.unobserve(target);
    };
}
//#endregion
//#region src/dom-events/resize/resizeWindow.ts
const $16ba30d4a13c00f2$var$listeners = /* @__PURE__ */ new Set();
let $16ba30d4a13c00f2$var$cleanupWindowResizeHandler;
const $16ba30d4a13c00f2$var$createResizeHandler = ()=>{
    const handleResize = ()=>{
        $16ba30d4a13c00f2$var$listeners.forEach((callback)=>callback({
                width: window.innerWidth,
                height: window.innerHeight
            }));
    };
    window.addEventListener("resize", handleResize);
    return ()=>{
        window.removeEventListener("resize", handleResize);
    };
};
const $16ba30d4a13c00f2$var$resizeWindow = (callback)=>{
    $16ba30d4a13c00f2$var$listeners.add(callback);
    if (!$16ba30d4a13c00f2$var$cleanupWindowResizeHandler) $16ba30d4a13c00f2$var$cleanupWindowResizeHandler = $16ba30d4a13c00f2$var$createResizeHandler();
    return ()=>{
        $16ba30d4a13c00f2$var$listeners.delete(callback);
        if (!$16ba30d4a13c00f2$var$listeners.size && $16ba30d4a13c00f2$var$cleanupWindowResizeHandler) {
            $16ba30d4a13c00f2$var$cleanupWindowResizeHandler();
            $16ba30d4a13c00f2$var$cleanupWindowResizeHandler = void 0;
        }
    };
};
//#endregion
//#region src/dom-events/resize/index.ts
const $16ba30d4a13c00f2$export$45b39e67d4ce4921 = (callback, { container: container = document.documentElement } = {})=>{
    if (container === document.documentElement) return $16ba30d4a13c00f2$var$resizeWindow(callback);
    else return $16ba30d4a13c00f2$var$resizeElement(callback, container);
};
//#endregion
//#region src/progress.ts
const $16ba30d4a13c00f2$var$progress = (min, max, value)=>max - min === 0 ? 1 : (value - min) / (max - min);
//#endregion
//#region src/dom-events/scroll/ScrollHandler.ts
const $16ba30d4a13c00f2$var$SCROLL_KEYS = {
    x: {
        length: "Width",
        position: "Left"
    },
    y: {
        length: "Height",
        position: "Top"
    }
};
/**
* Why use a class? More extensible in the future.
*/ var $16ba30d4a13c00f2$var$ScrollHandler = class {
    constructor(callback, container){
        this.createAxis = ()=>({
                current: 0,
                progress: 0,
                scrollLength: 0
            });
        this.updateAxis = (axisName)=>{
            const axis = this.info[axisName];
            const { length: length, position: position } = $16ba30d4a13c00f2$var$SCROLL_KEYS[axisName];
            axis.current = this.container[`scroll${position}`];
            axis.scrollLength = this.container[`scroll${length}`] - this.container[`client${length}`];
            axis.progress = $16ba30d4a13c00f2$var$progress(0, axis.scrollLength, axis.current);
        };
        this.update = ()=>{
            this.updateAxis("x");
            this.updateAxis("y");
        };
        this.sendEvent = ()=>{
            this.callback(this.info);
        };
        this.advance = ()=>{
            this.update();
            this.sendEvent();
        };
        this.callback = callback;
        this.container = container;
        this.info = {
            time: 0,
            x: this.createAxis(),
            y: this.createAxis()
        };
    }
};
//#endregion
//#region src/dom-events/scroll/index.ts
const $16ba30d4a13c00f2$var$scrollListeners = /* @__PURE__ */ new WeakMap();
const $16ba30d4a13c00f2$var$resizeListeners = /* @__PURE__ */ new WeakMap();
const $16ba30d4a13c00f2$var$onScrollHandlers = /* @__PURE__ */ new WeakMap();
const $16ba30d4a13c00f2$var$getTarget = (container)=>container === document.documentElement ? window : container;
const $16ba30d4a13c00f2$export$d4d89fd61e5416ee = (callback, { container: container = document.documentElement } = {})=>{
    /**
	* get the current handlers for the target
	*/ let containerHandlers = $16ba30d4a13c00f2$var$onScrollHandlers.get(container);
    /**
	* If there aren't any handlers then create a new set.
	*/ if (!containerHandlers) {
        containerHandlers = /* @__PURE__ */ new Set();
        $16ba30d4a13c00f2$var$onScrollHandlers.set(container, containerHandlers);
    }
    /**
	* Create a new ScrollHandler class and add it to the set.
	*/ const containerHandler = new $16ba30d4a13c00f2$var$ScrollHandler(callback, container);
    containerHandlers.add(containerHandler);
    /**
	* If there are no scrollListeners then we need to make them
	*/ if (!$16ba30d4a13c00f2$var$scrollListeners.has(container)) {
        /**
		* Return true so RAFZ continues to run it
		*/ const listener = ()=>{
            containerHandlers?.forEach((handler)=>handler.advance());
            return true;
        };
        $16ba30d4a13c00f2$var$scrollListeners.set(container, listener);
        const target = $16ba30d4a13c00f2$var$getTarget(container);
        /**
		* Add resize handlers so we can correctly calculate the
		* scroll position on changes
		*/ window.addEventListener("resize", listener, {
            passive: true
        });
        if (container !== document.documentElement) $16ba30d4a13c00f2$var$resizeListeners.set(container, $16ba30d4a13c00f2$export$45b39e67d4ce4921(listener, {
            container: container
        }));
        /**
		* Add the actual scroll listener
		*/ target.addEventListener("scroll", listener, {
            passive: true
        });
    }
    /**
	* Start animation loop
	*/ const animateScroll = $16ba30d4a13c00f2$var$scrollListeners.get(container);
    (0, $7a0c7bd96c8bfe17$export$27f233d61a9e2fa4)(animateScroll);
    return ()=>{
        /**
		* Clear it on cleanup
		*/ (0, $7a0c7bd96c8bfe17$export$27f233d61a9e2fa4).cancel(animateScroll);
        /**
		* Check if we even have any handlers for this container.
		*/ const containerHandlers = $16ba30d4a13c00f2$var$onScrollHandlers.get(container);
        if (!containerHandlers) return;
        containerHandlers.delete(containerHandler);
        if (containerHandlers.size) return;
        /**
		* If no more handlers, remove the scroll listener too.
		*/ const listener = $16ba30d4a13c00f2$var$scrollListeners.get(container);
        $16ba30d4a13c00f2$var$scrollListeners.delete(container);
        if (listener) {
            $16ba30d4a13c00f2$var$getTarget(container).removeEventListener("scroll", listener);
            window.removeEventListener("resize", listener);
            $16ba30d4a13c00f2$var$resizeListeners.get(container)?.();
        }
    };
};
//#endregion
//#region src/hooks/useConstant.ts
/**
* Creates a constant value over the lifecycle of a component.
*/ function $16ba30d4a13c00f2$export$fe4300aa8eebea86(init) {
    const ref = (0, $5E6i4.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}
//#endregion
//#region src/hooks/useIsomorphicLayoutEffect.ts
/**
* Use this to read layout from the DOM and synchronously
* re-render if the isSSR returns true. Updates scheduled
* inside `useIsomorphicLayoutEffect` will be flushed
* synchronously in the browser, before the browser has
* a chance to paint.
*/ const $16ba30d4a13c00f2$export$700979bc83e7db82 = $16ba30d4a13c00f2$export$48d7c418edadb60c() ? (0, $5E6i4.useEffect) : (0, $5E6i4.useLayoutEffect);
//#endregion
//#region src/hooks/useIsMounted.ts
const $16ba30d4a13c00f2$var$useIsMounted = ()=>{
    const isMounted = (0, $5E6i4.useRef)(false);
    $16ba30d4a13c00f2$export$700979bc83e7db82(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
};
//#endregion
//#region src/hooks/useForceUpdate.ts
/** Return a function that re-renders this component, if still mounted */ function $16ba30d4a13c00f2$export$91db9bc4f8ac944a() {
    const update = (0, $5E6i4.useState)()[1];
    const isMounted = $16ba30d4a13c00f2$var$useIsMounted();
    return ()=>{
        if (isMounted.current) update(Math.random());
    };
}
//#endregion
//#region src/hooks/useMemoOne.ts
function $16ba30d4a13c00f2$export$b6feb8998cd9b342(getResult, inputs) {
    const [initial] = (0, $5E6i4.useState)(()=>({
            inputs: inputs,
            result: getResult()
        }));
    const committed = (0, $5E6i4.useRef)(void 0);
    const prevCache = committed.current;
    let cache = prevCache;
    if (cache) {
        if (!Boolean(inputs && cache.inputs && $16ba30d4a13c00f2$var$areInputsEqual(inputs, cache.inputs))) cache = {
            inputs: inputs,
            result: getResult()
        };
    } else cache = initial;
    (0, $5E6i4.useEffect)(()=>{
        committed.current = cache;
        if (prevCache == initial) initial.inputs = initial.result = void 0;
    }, [
        cache
    ]);
    return cache.result;
}
function $16ba30d4a13c00f2$var$areInputsEqual(next, prev) {
    if (next.length !== prev.length) return false;
    for(let i = 0; i < next.length; i++)if (next[i] !== prev[i]) return false;
    return true;
}
//#endregion
//#region src/hooks/useOnce.ts
const $16ba30d4a13c00f2$export$392544347a18b6ea = (effect)=>(0, $5E6i4.useEffect)(effect, $16ba30d4a13c00f2$var$emptyDeps);
const $16ba30d4a13c00f2$var$emptyDeps = [];
//#endregion
//#region src/hooks/usePrev.ts
/** Use a value from the previous render */ function $16ba30d4a13c00f2$export$ef7ad0c4e19d7fbf(value) {
    const prevRef = (0, $5E6i4.useRef)(void 0);
    (0, $5E6i4.useEffect)(()=>{
        prevRef.current = value;
    });
    return prevRef.current;
}
//#endregion
//#region src/hooks/useReducedMotion.ts
/**
* Returns `boolean` or `null`, used to automatically
* set skipAnimations to the value of the user's
* `prefers-reduced-motion` query.
*
* The return value, post-effect, is the value of their prefered setting
*/ const $16ba30d4a13c00f2$export$6a42007cf1e7b6f8 = ()=>{
    const [reducedMotion, setReducedMotion] = (0, $5E6i4.useState)(null);
    $16ba30d4a13c00f2$export$700979bc83e7db82(()=>{
        const mql = window.matchMedia("(prefers-reduced-motion)");
        const handleMediaChange = (e)=>{
            setReducedMotion(e.matches);
            $16ba30d4a13c00f2$var$assign({
                skipAnimation: e.matches
            });
        };
        handleMediaChange(mql);
        if (mql.addEventListener) mql.addEventListener("change", handleMediaChange);
        else mql.addListener(handleMediaChange);
        return ()=>{
            if (mql.removeEventListener) mql.removeEventListener("change", handleMediaChange);
            else mql.removeListener(handleMediaChange);
        };
    }, []);
    return reducedMotion;
};



var $5E6i4 = parcelRequire("5E6i4");


var $5E6i4 = parcelRequire("5E6i4");
//#region src/Animated.ts
const $b2c49db26f0b3d2c$var$$node = Symbol.for("Animated:node");
const $b2c49db26f0b3d2c$export$3df5e165e801a70f = (value)=>!!value && value[$b2c49db26f0b3d2c$var$$node] === value;
/** Get the owner's `Animated` node. */ const $b2c49db26f0b3d2c$export$6b63995194a3a9e4 = (owner)=>owner && owner[$b2c49db26f0b3d2c$var$$node];
/** Set the owner's `Animated` node. */ const $b2c49db26f0b3d2c$export$b553cb5b22b81b04 = (owner, node)=>(0, $16ba30d4a13c00f2$export$5c74248ea0e35446)(owner, $b2c49db26f0b3d2c$var$$node, node);
/** Get every `AnimatedValue` in the owner's `Animated` node. */ const $b2c49db26f0b3d2c$export$ccab2b64c5d440 = (owner)=>owner && owner[$b2c49db26f0b3d2c$var$$node] && owner[$b2c49db26f0b3d2c$var$$node].getPayload();
var $b2c49db26f0b3d2c$export$31627395a3b18e54 = class {
    constructor(){
        $b2c49db26f0b3d2c$export$b553cb5b22b81b04(this, this);
    }
    /** Get every `AnimatedValue` used by this node. */ getPayload() {
        return this.payload || [];
    }
};
//#endregion
//#region src/AnimatedValue.ts
/** An animated number or a native attribute value */ var $b2c49db26f0b3d2c$export$cb1e8f3c05d37ad5 = class AnimatedValue extends $b2c49db26f0b3d2c$export$31627395a3b18e54 {
    constructor(_value){
        super();
        this._value = _value;
        this.done = true;
        this.durationProgress = 0;
        if ((0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).num(this._value)) this.lastPosition = this._value;
    }
    /** @internal */ static create(value) {
        return new AnimatedValue(value);
    }
    getPayload() {
        return [
            this
        ];
    }
    getValue() {
        return this._value;
    }
    setValue(value, step) {
        if ((0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).num(value)) {
            this.lastPosition = value;
            if (step) {
                value = Math.round(value / step) * step;
                if (this.done) this.lastPosition = value;
            }
        }
        if (this._value === value) return false;
        this._value = value;
        return true;
    }
    reset() {
        const { done: done } = this;
        this.done = false;
        if ((0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).num(this._value)) {
            this.elapsedTime = 0;
            this.durationProgress = 0;
            this.lastPosition = this._value;
            if (done) this.lastVelocity = null;
            this.v0 = null;
        }
    }
};
//#endregion
//#region src/AnimatedString.ts
var $b2c49db26f0b3d2c$export$f6c6c4cbd7fa5b93 = class AnimatedString extends $b2c49db26f0b3d2c$export$cb1e8f3c05d37ad5 {
    constructor(value){
        super(0);
        this._string = null;
        this._toString = (0, $16ba30d4a13c00f2$export$b12af43b97697ef5)({
            output: [
                value,
                value
            ]
        });
    }
    /** @internal */ static create(value) {
        return new AnimatedString(value);
    }
    getValue() {
        const value = this._string;
        return value == null ? this._string = this._toString(this._value) : value;
    }
    setValue(value) {
        if ((0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).str(value)) {
            if (value == this._string) return false;
            this._string = value;
            this._value = 1;
        } else if (super.setValue(value)) this._string = null;
        else return false;
        return true;
    }
    reset(goal) {
        if (goal) this._toString = (0, $16ba30d4a13c00f2$export$b12af43b97697ef5)({
            output: [
                this.getValue(),
                goal
            ]
        });
        this._value = 0;
        super.reset();
    }
};
//#endregion
//#region src/context.ts
const $b2c49db26f0b3d2c$var$TreeContext = {
    dependencies: null
};
//#endregion
//#region src/AnimatedObject.ts
/** An object containing `Animated` nodes */ var $b2c49db26f0b3d2c$export$f1b0b9e366a6e2d4 = class extends $b2c49db26f0b3d2c$export$31627395a3b18e54 {
    constructor(source){
        super();
        this.source = source;
        this.setValue(source);
    }
    getValue(animated) {
        const values = {};
        (0, $16ba30d4a13c00f2$export$f4c6fe153f5a944e)(this.source, (source, key)=>{
            if ($b2c49db26f0b3d2c$export$3df5e165e801a70f(source)) values[key] = source.getValue(animated);
            else if ((0, $16ba30d4a13c00f2$export$57ea7e3a7f6280c7)(source)) values[key] = (0, $16ba30d4a13c00f2$export$e37b7520edd66839)(source);
            else if (!animated) values[key] = source;
        });
        return values;
    }
    /** Replace the raw object data */ setValue(source) {
        this.source = source;
        this.payload = this._makePayload(source);
    }
    reset() {
        if (this.payload) (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)(this.payload, (node)=>node.reset());
    }
    /** Create a payload set. */ _makePayload(source) {
        if (source) {
            const payload = /* @__PURE__ */ new Set();
            (0, $16ba30d4a13c00f2$export$f4c6fe153f5a944e)(source, this._addToPayload, payload);
            return Array.from(payload);
        }
    }
    /** Add to a payload set. */ _addToPayload(source) {
        if ($b2c49db26f0b3d2c$var$TreeContext.dependencies && (0, $16ba30d4a13c00f2$export$57ea7e3a7f6280c7)(source)) $b2c49db26f0b3d2c$var$TreeContext.dependencies.add(source);
        const payload = $b2c49db26f0b3d2c$export$ccab2b64c5d440(source);
        if (payload) (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)(payload, (node)=>this.add(node));
    }
};
//#endregion
//#region src/AnimatedArray.ts
/** An array of animated nodes */ var $b2c49db26f0b3d2c$export$ede394683406942d = class AnimatedArray extends $b2c49db26f0b3d2c$export$f1b0b9e366a6e2d4 {
    constructor(source){
        super(source);
    }
    /** @internal */ static create(source) {
        return new AnimatedArray(source);
    }
    getValue() {
        return this.source.map((node)=>node.getValue());
    }
    setValue(source) {
        const payload = this.getPayload();
        if (source.length == payload.length) return payload.map((node, i)=>node.setValue(source[i])).some(Boolean);
        super.setValue(source.map($b2c49db26f0b3d2c$var$makeAnimated));
        return true;
    }
};
function $b2c49db26f0b3d2c$var$makeAnimated(value) {
    return ((0, $16ba30d4a13c00f2$export$75bed621f62abfa9)(value) ? $b2c49db26f0b3d2c$export$f6c6c4cbd7fa5b93 : $b2c49db26f0b3d2c$export$cb1e8f3c05d37ad5).create(value);
}
//#endregion
//#region src/getAnimatedType.ts
/** Return the `Animated` node constructor for a given value */ function $b2c49db26f0b3d2c$export$e6b77ddbe47b132e(value) {
    const parentNode = $b2c49db26f0b3d2c$export$6b63995194a3a9e4(value);
    return parentNode ? parentNode.constructor : (0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).arr(value) ? $b2c49db26f0b3d2c$export$ede394683406942d : (0, $16ba30d4a13c00f2$export$75bed621f62abfa9)(value) ? $b2c49db26f0b3d2c$export$f6c6c4cbd7fa5b93 : $b2c49db26f0b3d2c$export$cb1e8f3c05d37ad5;
}
//#endregion
//#region src/withAnimated.tsx
const $b2c49db26f0b3d2c$var$withAnimated = (Component, host)=>{
    const hasInstance = !(0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).fun(Component) || Component.prototype && Component.prototype.isReactComponent;
    return (0, $5E6i4.forwardRef)((givenProps, givenRef)=>{
        const instanceRef = (0, $5E6i4.useRef)(null);
        const ref = hasInstance && (0, $5E6i4.useCallback)((value)=>{
            instanceRef.current = $b2c49db26f0b3d2c$var$updateRef(givenRef, value);
        }, [
            givenRef
        ]);
        const [props, deps] = $b2c49db26f0b3d2c$var$getAnimatedState(givenProps, host);
        const forceUpdate = (0, $16ba30d4a13c00f2$export$91db9bc4f8ac944a)();
        const callback = ()=>{
            const instance = instanceRef.current;
            if (hasInstance && !instance) return;
            if ((instance ? host.applyAnimatedValues(instance, props.getValue(true)) : false) === false) forceUpdate();
        };
        const observer = new $b2c49db26f0b3d2c$var$PropsObserver(callback, deps);
        const observerRef = (0, $5E6i4.useRef)(void 0);
        (0, $16ba30d4a13c00f2$export$700979bc83e7db82)(()=>{
            observerRef.current = observer;
            (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)(deps, (dep)=>(0, $16ba30d4a13c00f2$export$72d604e3f8d000a5)(dep, observer));
            return ()=>{
                if (observerRef.current) {
                    (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)(observerRef.current.deps, (dep)=>(0, $16ba30d4a13c00f2$export$7a0eb830d336339b)(dep, observerRef.current));
                    (0, $7a0c7bd96c8bfe17$export$27f233d61a9e2fa4).cancel(observerRef.current.update);
                }
            };
        });
        (0, $5E6i4.useEffect)(callback, []);
        (0, $16ba30d4a13c00f2$export$392544347a18b6ea)(()=>()=>{
                const observer = observerRef.current;
                (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)(observer.deps, (dep)=>(0, $16ba30d4a13c00f2$export$7a0eb830d336339b)(dep, observer));
            });
        const usedProps = host.getComponentProps(props.getValue());
        return /* @__PURE__ */ $5E6i4.createElement(Component, {
            ...usedProps,
            ref: ref
        });
    });
};
var $b2c49db26f0b3d2c$var$PropsObserver = class {
    constructor(update, deps){
        this.update = update;
        this.deps = deps;
    }
    eventObserved(event) {
        if (event.type == "change") (0, $7a0c7bd96c8bfe17$export$27f233d61a9e2fa4).write(this.update);
    }
};
function $b2c49db26f0b3d2c$var$getAnimatedState(props, host) {
    const dependencies = /* @__PURE__ */ new Set();
    $b2c49db26f0b3d2c$var$TreeContext.dependencies = dependencies;
    if (props.style) props = {
        ...props,
        style: host.createAnimatedStyle(props.style)
    };
    props = new $b2c49db26f0b3d2c$export$f1b0b9e366a6e2d4(props);
    $b2c49db26f0b3d2c$var$TreeContext.dependencies = null;
    return [
        props,
        dependencies
    ];
}
function $b2c49db26f0b3d2c$var$updateRef(ref, value) {
    if (ref) {
        if ((0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).fun(ref)) ref(value);
        else ref.current = value;
    }
    return value;
}
//#endregion
//#region src/createHost.ts
const $b2c49db26f0b3d2c$var$cacheKey = Symbol.for("AnimatedComponent");
const $b2c49db26f0b3d2c$var$fallbackCache = /* @__PURE__ */ new WeakMap();
const $b2c49db26f0b3d2c$export$4ee5c78f6dcbcef = (components, { applyAnimatedValues: applyAnimatedValues = ()=>false, createAnimatedStyle: createAnimatedStyle = (style)=>new $b2c49db26f0b3d2c$export$f1b0b9e366a6e2d4(style), getComponentProps: getComponentProps = (props)=>props } = {})=>{
    const hostConfig = {
        applyAnimatedValues: applyAnimatedValues,
        createAnimatedStyle: createAnimatedStyle,
        getComponentProps: getComponentProps
    };
    const animated = (Component)=>{
        const displayName = $b2c49db26f0b3d2c$var$getDisplayName(Component) || "Anonymous";
        if ((0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).str(Component)) Component = animated[Component] || (animated[Component] = $b2c49db26f0b3d2c$var$withAnimated(Component, hostConfig));
        else {
            let cached = Component[$b2c49db26f0b3d2c$var$cacheKey] ?? $b2c49db26f0b3d2c$var$fallbackCache.get(Component);
            if (!cached) {
                cached = $b2c49db26f0b3d2c$var$withAnimated(Component, hostConfig);
                try {
                    Component[$b2c49db26f0b3d2c$var$cacheKey] = cached;
                } catch  {}
                $b2c49db26f0b3d2c$var$fallbackCache.set(Component, cached);
            }
            Component = cached;
        }
        Component.displayName = `Animated(${displayName})`;
        return Component;
    };
    (0, $16ba30d4a13c00f2$export$f4c6fe153f5a944e)(components, (Component, key)=>{
        if ((0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).arr(components)) key = $b2c49db26f0b3d2c$var$getDisplayName(Component);
        animated[key] = animated(Component);
    });
    return {
        animated: animated
    };
};
const $b2c49db26f0b3d2c$var$getDisplayName = (arg)=>(0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).str(arg) ? arg : arg && (0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).str(arg.displayName) ? arg.displayName : (0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).fun(arg) && arg.name || null;


//#region src/utils.ts
/** Use `[T] extends [Any]` to know if a type parameter is `any` */ var $65138aba4b4b01c9$export$b24b633b1364b94b = class {
};


//#region src/helpers.ts
function $c52c96d382753013$var$callProp(value, ...args) {
    return (0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).fun(value) ? value(...args) : value;
}
/** Try to coerce the given value into a boolean using the given key */ const $c52c96d382753013$var$matchProp = (value, key)=>value === true || !!(key && value && ((0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).fun(value) ? value(key) : (0, $16ba30d4a13c00f2$export$45b10814cc054894)(value).includes(key)));
const $c52c96d382753013$var$resolveProp = (prop, key)=>(0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).obj(prop) ? key && prop[key] : prop;
/** Get the default value being set for the given `key` */ const $c52c96d382753013$var$getDefaultProp = (props, key)=>props.default === true ? props[key] : props.default ? props.default[key] : void 0;
const $c52c96d382753013$var$noopTransform = (value)=>value;
/**
* Extract the default props from an update.
*
* When the `default` prop is falsy, this function still behaves as if
* `default: true` was used. The `default` prop is always respected when
* truthy.
*/ const $c52c96d382753013$var$getDefaultProps = (props, transform = $c52c96d382753013$var$noopTransform)=>{
    let keys = $c52c96d382753013$var$DEFAULT_PROPS;
    if (props.default && props.default !== true) {
        props = props.default;
        keys = Object.keys(props);
    }
    const defaults = {};
    for (const key of keys){
        const value = transform(props[key], key);
        if (!(0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).und(value)) defaults[key] = value;
    }
    return defaults;
};
/**
* These props are implicitly used as defaults when defined in a
* declarative update (eg: render-based) or any update with `default: true`.
*
* Use `default: {}` or `default: false` to opt-out of these implicit defaults
* for any given update.
*
* Note: These are not the only props with default values. For example, the
* `pause`, `cancel`, and `immediate` props. But those must be updated with
* the object syntax (eg: `default: { immediate: true }`).
*/ const $c52c96d382753013$var$DEFAULT_PROPS = [
    "config",
    "onProps",
    "onStart",
    "onChange",
    "onPause",
    "onResume",
    "onRest"
];
const $c52c96d382753013$var$RESERVED_PROPS = {
    config: 1,
    from: 1,
    to: 1,
    ref: 1,
    loop: 1,
    reset: 1,
    pause: 1,
    cancel: 1,
    reverse: 1,
    immediate: 1,
    default: 1,
    delay: 1,
    onProps: 1,
    onStart: 1,
    onChange: 1,
    onPause: 1,
    onResume: 1,
    onRest: 1,
    onResolve: 1,
    items: 1,
    trail: 1,
    sort: 1,
    expires: 1,
    initial: 1,
    enter: 1,
    update: 1,
    leave: 1,
    children: 1,
    onDestroyed: 1,
    keys: 1,
    callId: 1,
    parentId: 1
};
/**
* Extract any properties whose keys are *not* reserved for customizing your
* animations. All hooks use this function, which means `useTransition` props
* are reserved for `useSpring` calls, etc.
*/ function $c52c96d382753013$var$getForwardProps(props) {
    const forward = {};
    let count = 0;
    (0, $16ba30d4a13c00f2$export$f4c6fe153f5a944e)(props, (value, prop)=>{
        if (!$c52c96d382753013$var$RESERVED_PROPS[prop]) {
            forward[prop] = value;
            count++;
        }
    });
    if (count) return forward;
}
/**
* Clone the given `props` and move all non-reserved props
* into the `to` prop.
*/ function $c52c96d382753013$export$b971039a739bf227(props) {
    const to = $c52c96d382753013$var$getForwardProps(props);
    if (to) {
        const out = {
            to: to
        };
        (0, $16ba30d4a13c00f2$export$f4c6fe153f5a944e)(props, (val, key)=>key in to || (out[key] = val));
        return out;
    }
    return {
        ...props
    };
}
function $c52c96d382753013$var$computeGoal(value) {
    const resolved = (0, $16ba30d4a13c00f2$export$e37b7520edd66839)(value);
    if ((0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).arr(resolved)) return resolved.map($c52c96d382753013$var$computeGoal);
    if ((0, $16ba30d4a13c00f2$export$75bed621f62abfa9)(resolved)) return (0, $16ba30d4a13c00f2$export$cceeabf822b64fc0).createStringInterpolator({
        range: [
            0,
            1
        ],
        output: [
            resolved,
            resolved
        ]
    })(1);
    return resolved;
}
function $c52c96d382753013$var$hasProps(props) {
    for(const _ in props)return true;
    return false;
}
function $c52c96d382753013$var$isAsyncTo(to) {
    return (0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).fun(to) || (0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).arr(to) && (0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).obj(to[0]);
}
/** Detach `ctrl` from `ctrl.ref` and (optionally) the given `ref` */ function $c52c96d382753013$var$detachRefs(ctrl, ref) {
    ctrl.ref?.delete(ctrl);
    ref?.delete(ctrl);
}
/** Replace `ctrl.ref` with the given `ref` (if defined) */ function $c52c96d382753013$var$replaceRef(ctrl, ref) {
    if (ref && ctrl.ref !== ref) {
        ctrl.ref?.delete(ctrl);
        ref.add(ctrl);
        ctrl.ref = ref;
    }
}
//#endregion
//#region src/hooks/useChain.ts
/**
* Used to orchestrate animation hooks in sequence with one another.
* This is best used when you specifically want to orchestrate different
* types of animation hook e.g. `useSpring` & `useTransition` in
* sequence as opposed to multiple `useSpring` hooks.
*
*
* ```jsx
* export const MyComponent = () => {
*  //...
*  useChain([springRef, transitionRef])
*  //...
* }
* ```
*
* @param refs – An array of `SpringRef`s.
* @param timeSteps – Optional array of numbers that define the
* delay between each animation from 0-1. The length should correlate
* to the length of `refs`.
* @param timeFrame – Optional number that defines the total duration
*
* @public
*/ function $c52c96d382753013$export$a4a17273dffcc09c(refs, timeSteps, timeFrame = 1e3) {
    (0, $16ba30d4a13c00f2$export$700979bc83e7db82)(()=>{
        if (timeSteps) {
            let prevDelay = 0;
            (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)(refs, (ref, i)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    let delay = timeFrame * timeSteps[i];
                    if (isNaN(delay)) delay = prevDelay;
                    else prevDelay = delay;
                    (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)(controllers, (ctrl)=>{
                        (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)(ctrl.queue, (props)=>{
                            const memoizedDelayProp = props.delay;
                            props.delay = (key)=>delay + $c52c96d382753013$var$callProp(memoizedDelayProp || 0, key);
                        });
                    });
                    ref.start();
                }
            });
        } else {
            let p = Promise.resolve();
            (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)(refs, (ref)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    const queues = controllers.map((ctrl)=>{
                        const q = ctrl.queue;
                        ctrl.queue = [];
                        return q;
                    });
                    p = p.then(()=>{
                        (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)(controllers, (ctrl, i)=>(0, $16ba30d4a13c00f2$export$79b2f7037acddd43)(queues[i] || [], (update)=>ctrl.queue.push(update)));
                        return Promise.all(ref.start());
                    });
                }
            });
        }
    });
}
//#endregion
//#region src/constants.ts
const $c52c96d382753013$export$e506a1d27d1eaa20 = {
    default: {
        tension: 170,
        friction: 26
    },
    gentle: {
        tension: 120,
        friction: 14
    },
    wobbly: {
        tension: 180,
        friction: 12
    },
    stiff: {
        tension: 210,
        friction: 20
    },
    slow: {
        tension: 280,
        friction: 60
    },
    molasses: {
        tension: 280,
        friction: 120
    }
};
//#endregion
//#region src/AnimationConfig.ts
const $c52c96d382753013$var$defaults = {
    ...$c52c96d382753013$export$e506a1d27d1eaa20.default,
    mass: 1,
    damping: 1,
    easing: (0, $16ba30d4a13c00f2$export$15a0bf1b4bbacad8).linear,
    clamp: false
};
var $c52c96d382753013$var$AnimationConfig = class {
    constructor(){
        this.velocity = 0;
        Object.assign(this, $c52c96d382753013$var$defaults);
    }
};
function $c52c96d382753013$var$mergeConfig(config, newConfig, defaultConfig) {
    if (defaultConfig) {
        defaultConfig = {
            ...defaultConfig
        };
        $c52c96d382753013$var$sanitizeConfig(defaultConfig, newConfig);
        newConfig = {
            ...defaultConfig,
            ...newConfig
        };
    }
    $c52c96d382753013$var$sanitizeConfig(config, newConfig);
    Object.assign(config, newConfig);
    for(const key in $c52c96d382753013$var$defaults)if (config[key] == null) config[key] = $c52c96d382753013$var$defaults[key];
    let { frequency: frequency, damping: damping } = config;
    const { mass: mass } = config;
    if (!(0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).und(frequency)) {
        if (frequency < .01) frequency = .01;
        if (damping < 0) damping = 0;
        config.tension = Math.pow(2 * Math.PI / frequency, 2) * mass;
        config.friction = 4 * Math.PI * damping * mass / frequency;
    }
    return config;
}
function $c52c96d382753013$var$sanitizeConfig(config, props) {
    if (!(0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).und(props.decay)) config.duration = void 0;
    else {
        const isTensionConfig = !(0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).und(props.tension) || !(0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).und(props.friction);
        if (isTensionConfig || !(0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).und(props.frequency) || !(0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).und(props.damping) || !(0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).und(props.mass)) {
            config.duration = void 0;
            config.decay = void 0;
        }
        if (isTensionConfig) config.frequency = void 0;
    }
}
//#endregion
//#region src/Animation.ts
const $c52c96d382753013$var$emptyArray = [];
/** An animation being executed by the frameloop */ var $c52c96d382753013$var$Animation = class {
    constructor(){
        this.changed = false;
        this.values = $c52c96d382753013$var$emptyArray;
        this.toValues = null;
        this.fromValues = $c52c96d382753013$var$emptyArray;
        this.config = new $c52c96d382753013$var$AnimationConfig();
        this.immediate = false;
    }
};
//#endregion
//#region src/scheduleProps.ts
/**
* This function sets a timeout if both the `delay` prop exists and
* the `cancel` prop is not `true`.
*
* The `actions.start` function must handle the `cancel` prop itself,
* but the `pause` prop is taken care of.
*/ function $c52c96d382753013$var$scheduleProps(callId, { key: key, props: props, defaultProps: defaultProps, state: state, actions: actions }) {
    return new Promise((resolve, reject)=>{
        let delay;
        let timeout;
        let cancel = $c52c96d382753013$var$matchProp(props.cancel ?? defaultProps?.cancel, key);
        if (cancel) onStart();
        else {
            if (!(0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).und(props.pause)) state.paused = $c52c96d382753013$var$matchProp(props.pause, key);
            let pause = defaultProps?.pause;
            if (pause !== true) pause = state.paused || $c52c96d382753013$var$matchProp(pause, key);
            delay = $c52c96d382753013$var$callProp(props.delay || 0, key);
            if (pause) {
                state.resumeQueue.add(onResume);
                actions.pause();
            } else {
                actions.resume();
                onResume();
            }
        }
        function onPause() {
            state.resumeQueue.add(onResume);
            state.timeouts.delete(timeout);
            timeout.cancel();
            delay = timeout.time - (0, $7a0c7bd96c8bfe17$export$27f233d61a9e2fa4).now();
        }
        function onResume() {
            if (delay > 0 && !(0, $16ba30d4a13c00f2$export$cceeabf822b64fc0).skipAnimation) {
                state.delayed = true;
                timeout = (0, $7a0c7bd96c8bfe17$export$27f233d61a9e2fa4).setTimeout(onStart, delay);
                state.pauseQueue.add(onPause);
                state.timeouts.add(timeout);
            } else onStart();
        }
        function onStart() {
            if (state.delayed) state.delayed = false;
            state.pauseQueue.delete(onPause);
            state.timeouts.delete(timeout);
            if (callId <= (state.cancelId || 0)) cancel = true;
            try {
                actions.start({
                    ...props,
                    callId: callId,
                    cancel: cancel
                }, resolve);
            } catch (err) {
                reject(err);
            }
        }
    });
}
//#endregion
//#region src/AnimationResult.ts
/** @internal */ const $c52c96d382753013$var$getCombinedResult = (target, results)=>results.length == 1 ? results[0] : results.some((result)=>result.cancelled) ? $c52c96d382753013$var$getCancelledResult(target.get()) : results.every((result)=>result.noop) ? $c52c96d382753013$var$getNoopResult(target.get()) : $c52c96d382753013$var$getFinishedResult(target.get(), results.every((result)=>result.finished));
/** No-op results are for updates that never start an animation. */ const $c52c96d382753013$var$getNoopResult = (value)=>({
        value: value,
        noop: true,
        finished: true,
        cancelled: false
    });
const $c52c96d382753013$var$getFinishedResult = (value, finished, cancelled = false)=>({
        value: value,
        finished: finished,
        cancelled: cancelled
    });
const $c52c96d382753013$var$getCancelledResult = (value)=>({
        value: value,
        cancelled: true,
        finished: false
    });
//#endregion
//#region src/runAsync.ts
/**
* Start an async chain or an async script.
*
* Always call `runAsync` in the action callback of a `scheduleProps` call.
*
* The `T` parameter can be a set of animated values (as an object type)
* or a primitive type for a single animated value.
*/ function $c52c96d382753013$var$runAsync(to, props, state, target) {
    const { callId: callId, parentId: parentId, onRest: onRest } = props;
    const { asyncTo: prevTo, promise: prevPromise } = state;
    if (!parentId && to === prevTo && !props.reset) return prevPromise;
    return state.promise = (async ()=>{
        state.asyncId = callId;
        state.asyncTo = to;
        const defaultProps = $c52c96d382753013$var$getDefaultProps(props, (value, key)=>key === "onRest" ? void 0 : value);
        let preventBail;
        let bail;
        const bailPromise = new Promise((resolve, reject)=>(preventBail = resolve, bail = reject));
        const bailIfEnded = (bailSignal)=>{
            const bailResult = callId <= (state.cancelId || 0) && $c52c96d382753013$var$getCancelledResult(target) || callId !== state.asyncId && $c52c96d382753013$var$getFinishedResult(target, false);
            if (bailResult) {
                bailSignal.result = bailResult;
                bail(bailSignal);
                throw bailSignal;
            }
        };
        let skipAnimationCallCount = 0;
        const SKIP_ANIMATION_CALL_LIMIT = 1024;
        const animate = (arg1, arg2)=>{
            const bailSignal = new $c52c96d382753013$export$d362d093fa99dc7();
            const skipAnimationSignal = new $c52c96d382753013$var$SkipAnimationSignal();
            return (async ()=>{
                bailIfEnded(bailSignal);
                const props = (0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).obj(arg1) ? {
                    ...arg1
                } : {
                    ...arg2,
                    to: arg1
                };
                props.parentId = callId;
                (0, $16ba30d4a13c00f2$export$f4c6fe153f5a944e)(defaultProps, (value, key)=>{
                    if ((0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).und(props[key])) props[key] = value;
                });
                if ((0, $16ba30d4a13c00f2$export$cceeabf822b64fc0).skipAnimation) {
                    if (++skipAnimationCallCount > SKIP_ANIMATION_CALL_LIMIT) {
                        $c52c96d382753013$var$stopAsync(state);
                        skipAnimationSignal.result = $c52c96d382753013$var$getFinishedResult(target, false);
                        bail(skipAnimationSignal);
                        throw skipAnimationSignal;
                    }
                    props.immediate = true;
                    return await target.start(props);
                }
                const result = await target.start(props);
                bailIfEnded(bailSignal);
                if (state.paused) await new Promise((resume)=>{
                    state.resumeQueue.add(resume);
                });
                return result;
            })();
        };
        let result;
        try {
            let animating;
            if ((0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).arr(to)) animating = (async (queue)=>{
                for (const props of queue)await animate(props);
            })(to);
            else animating = Promise.resolve(to(animate, target.stop.bind(target)));
            await Promise.all([
                animating.then(preventBail),
                bailPromise
            ]);
            result = $c52c96d382753013$var$getFinishedResult(target.get(), true, false);
        } catch (err) {
            if (err instanceof $c52c96d382753013$export$d362d093fa99dc7) result = err.result;
            else if (err instanceof $c52c96d382753013$var$SkipAnimationSignal) result = err.result;
            else throw err;
        } finally{
            if (callId == state.asyncId) {
                state.asyncId = parentId;
                state.asyncTo = parentId ? prevTo : void 0;
                state.promise = parentId ? prevPromise : void 0;
            }
        }
        if ((0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).fun(onRest)) (0, $7a0c7bd96c8bfe17$export$27f233d61a9e2fa4).batchedUpdates(()=>{
            onRest(result, target, target.item);
        });
        return result;
    })();
}
/** Stop the current `runAsync` call with `finished: false` (or with `cancelled: true` when `cancelId` is defined) */ function $c52c96d382753013$var$stopAsync(state, cancelId) {
    (0, $16ba30d4a13c00f2$export$4909b86c8034bf73)(state.timeouts, (t)=>t.cancel());
    state.pauseQueue.clear();
    state.resumeQueue.clear();
    state.asyncId = state.asyncTo = state.promise = void 0;
    if (cancelId) state.cancelId = cancelId;
}
/** This error is thrown to signal an interrupted async animation. */ var $c52c96d382753013$export$d362d093fa99dc7 = class extends Error {
    constructor(){
        super("An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise.");
    }
};
var $c52c96d382753013$var$SkipAnimationSignal = class extends Error {
    constructor(){
        super("SkipAnimationSignal");
    }
};
//#endregion
//#region src/FrameValue.ts
const $c52c96d382753013$var$isFrameValue = (value)=>value instanceof $c52c96d382753013$export$8229896f80e2495e;
let $c52c96d382753013$var$nextId$1 = 1;
/**
* A kind of `FluidValue` that manages an `AnimatedValue` node.
*
* Its underlying value can be accessed and even observed.
*/ var $c52c96d382753013$export$8229896f80e2495e = class extends (0, $16ba30d4a13c00f2$export$aff8e1ac1a016a2) {
    constructor(..._args){
        super(..._args);
        this.id = $c52c96d382753013$var$nextId$1++;
        this._priority = 0;
    }
    get priority() {
        return this._priority;
    }
    set priority(priority) {
        if (this._priority != priority) {
            this._priority = priority;
            this._onPriorityChange(priority);
        }
    }
    /** Get the current value */ get() {
        const node = (0, $b2c49db26f0b3d2c$export$6b63995194a3a9e4)(this);
        return node && node.getValue();
    }
    /** Create a spring that maps our value to another value */ to(...args) {
        return (0, $16ba30d4a13c00f2$export$cceeabf822b64fc0).to(this, args);
    }
    /** @deprecated Use the `to` method instead. */ interpolate(...args) {
        (0, $16ba30d4a13c00f2$export$2abfcde8ae218ba8)();
        return (0, $16ba30d4a13c00f2$export$cceeabf822b64fc0).to(this, args);
    }
    toJSON() {
        return this.get();
    }
    observerAdded(count) {
        if (count == 1) this._attach();
    }
    observerRemoved(count) {
        if (count == 0) this._detach();
    }
    /** Called when the first child is added. */ _attach() {}
    /** Called when the last child is removed. */ _detach() {}
    /** Tell our children about our new value */ _onChange(value, idle = false) {
        (0, $16ba30d4a13c00f2$export$31752c40a5fab62a)(this, {
            type: "change",
            parent: this,
            value: value,
            idle: idle
        });
    }
    /** Tell our children about our new priority */ _onPriorityChange(priority) {
        if (!this.idle) (0, $16ba30d4a13c00f2$export$a57f5080a3bcc90a).sort(this);
        (0, $16ba30d4a13c00f2$export$31752c40a5fab62a)(this, {
            type: "priority",
            parent: this,
            priority: priority
        });
    }
};
//#endregion
//#region src/SpringPhase.ts
/** The property symbol of the current animation phase. */ const $c52c96d382753013$var$$P = Symbol.for("SpringPhase");
const $c52c96d382753013$var$HAS_ANIMATED = 1;
const $c52c96d382753013$var$IS_ANIMATING = 2;
const $c52c96d382753013$var$IS_PAUSED = 4;
/** Returns true if the `target` has ever animated. */ const $c52c96d382753013$var$hasAnimated = (target)=>(target[$c52c96d382753013$var$$P] & $c52c96d382753013$var$HAS_ANIMATED) > 0;
/** Returns true if the `target` is animating (even if paused). */ const $c52c96d382753013$var$isAnimating = (target)=>(target[$c52c96d382753013$var$$P] & $c52c96d382753013$var$IS_ANIMATING) > 0;
/** Returns true if the `target` is paused (even if idle). */ const $c52c96d382753013$var$isPaused = (target)=>(target[$c52c96d382753013$var$$P] & $c52c96d382753013$var$IS_PAUSED) > 0;
/** Set the active bit of the `target` phase. */ const $c52c96d382753013$var$setActiveBit = (target, active)=>active ? target[$c52c96d382753013$var$$P] |= 3 : target[$c52c96d382753013$var$$P] &= -3;
const $c52c96d382753013$var$setPausedBit = (target, paused)=>paused ? target[$c52c96d382753013$var$$P] |= $c52c96d382753013$var$IS_PAUSED : target[$c52c96d382753013$var$$P] &= -5;
//#endregion
//#region src/SpringValue.ts
/**
* Only numbers, strings, and arrays of numbers/strings are supported.
* Non-animatable strings are also supported.
*/ var $c52c96d382753013$export$5854d13427d5a954 = class extends $c52c96d382753013$export$8229896f80e2495e {
    constructor(arg1, arg2){
        super();
        this.animation = new $c52c96d382753013$var$Animation();
        this.defaultProps = {};
        this._state = {
            paused: false,
            delayed: false,
            pauseQueue: /* @__PURE__ */ new Set(),
            resumeQueue: /* @__PURE__ */ new Set(),
            timeouts: /* @__PURE__ */ new Set()
        };
        this._pendingCalls = /* @__PURE__ */ new Set();
        this._lastCallId = 0;
        this._lastToId = 0;
        this._memoizedDuration = 0;
        if (!(0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).und(arg1) || !(0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).und(arg2)) {
            const props = (0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).obj(arg1) ? {
                ...arg1
            } : {
                ...arg2,
                from: arg1
            };
            if ((0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).und(props.default)) props.default = true;
            this.start(props);
        }
    }
    /** Equals true when not advancing on each frame. */ get idle() {
        return !($c52c96d382753013$var$isAnimating(this) || this._state.asyncTo) || $c52c96d382753013$var$isPaused(this);
    }
    get goal() {
        return (0, $16ba30d4a13c00f2$export$e37b7520edd66839)(this.animation.to);
    }
    get velocity() {
        const node = (0, $b2c49db26f0b3d2c$export$6b63995194a3a9e4)(this);
        return node instanceof (0, $b2c49db26f0b3d2c$export$cb1e8f3c05d37ad5) ? node.lastVelocity || 0 : node.getPayload().map((node)=>node.lastVelocity || 0);
    }
    /**
	* When true, this value has been animated at least once.
	*/ get hasAnimated() {
        return $c52c96d382753013$var$hasAnimated(this);
    }
    /**
	* When true, this value has an unfinished animation,
	* which is either active or paused.
	*/ get isAnimating() {
        return $c52c96d382753013$var$isAnimating(this);
    }
    /**
	* When true, all current and future animations are paused.
	*/ get isPaused() {
        return $c52c96d382753013$var$isPaused(this);
    }
    /**
	*
	*
	*/ get isDelayed() {
        return this._state.delayed;
    }
    /** Advance the current animation by a number of milliseconds */ advance(dt) {
        let idle = true;
        let changed = false;
        const anim = this.animation;
        let { toValues: toValues } = anim;
        const { config: config } = anim;
        const payload = (0, $b2c49db26f0b3d2c$export$ccab2b64c5d440)(anim.to);
        if (!payload && (0, $16ba30d4a13c00f2$export$57ea7e3a7f6280c7)(anim.to)) toValues = (0, $16ba30d4a13c00f2$export$45b10814cc054894)((0, $16ba30d4a13c00f2$export$e37b7520edd66839)(anim.to));
        anim.values.forEach((node, i)=>{
            if (node.done) return;
            const to = node.constructor == (0, $b2c49db26f0b3d2c$export$f6c6c4cbd7fa5b93) ? 1 : payload ? payload[i].lastPosition : toValues[i];
            let finished = anim.immediate;
            let position = to;
            if (!finished) {
                position = node.lastPosition;
                if (config.tension <= 0) {
                    node.done = true;
                    return;
                }
                let elapsed = node.elapsedTime += dt;
                const from = anim.fromValues[i];
                const v0 = node.v0 != null ? node.v0 : node.v0 = (0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).arr(config.velocity) ? config.velocity[i] : config.velocity;
                let velocity;
                /** The smallest distance from a value before being treated like said value. */ /**
				* TODO: make this value ~0.0001 by default in next breaking change
				* for more info see – https://github.com/pmndrs/react-spring/issues/1389
				*/ const precision = config.precision || (from == to ? .005 : Math.max(Math.max(Math.abs(to), Math.abs(from), 1) * Number.EPSILON, Math.min(1, Math.abs(to - from) * .001)));
                if (!(0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).und(config.duration)) {
                    let p = 1;
                    if (config.duration > 0) {
                        /**
						* Here we check if the duration has changed in the config
						* and if so update the elapsed time to the percentage
						* of completition so there is no jank in the animation
						* https://github.com/pmndrs/react-spring/issues/1163
						*/ if (this._memoizedDuration !== config.duration) {
                            this._memoizedDuration = config.duration;
                            if (node.durationProgress > 0) {
                                node.elapsedTime = config.duration * node.durationProgress;
                                elapsed = node.elapsedTime += dt;
                            }
                        }
                        p = (config.progress || 0) + elapsed / this._memoizedDuration;
                        p = p > 1 ? 1 : p < 0 ? 0 : p;
                        node.durationProgress = p;
                    }
                    position = from + config.easing(p) * (to - from);
                    velocity = (position - node.lastPosition) / dt;
                    finished = p == 1;
                } else if (config.decay) {
                    const decay = config.decay === true ? .998 : config.decay;
                    const e = Math.exp(-(1 - decay) * elapsed);
                    position = from + v0 / (1 - decay) * (1 - e);
                    finished = Math.abs(node.lastPosition - position) <= precision;
                    velocity = v0 * e;
                } else {
                    velocity = node.lastVelocity == null ? v0 : node.lastVelocity;
                    /** The velocity at which movement is essentially none */ const restVelocity = config.restVelocity || precision / 10;
                    const bounceFactor = config.clamp ? 0 : config.bounce;
                    const canBounce = !(0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).und(bounceFactor);
                    /** When `true`, the value is increasing over time */ const isGrowing = from == to ? node.v0 > 0 : from < to;
                    /** When `true`, the velocity is considered moving */ let isMoving;
                    /** When `true`, the velocity is being deflected or clamped */ let isBouncing = false;
                    const step = 1;
                    const numSteps = Math.ceil(dt / step);
                    for(let n = 0; n < numSteps; ++n){
                        isMoving = Math.abs(velocity) > restVelocity;
                        if (!isMoving) {
                            finished = Math.abs(to - position) <= precision;
                            if (finished) break;
                        }
                        if (canBounce) {
                            isBouncing = position == to || position > to == isGrowing;
                            if (isBouncing) {
                                velocity = -velocity * bounceFactor;
                                position = to;
                            }
                        }
                        const acceleration = (-config.tension * 1e-6 * (position - to) + -config.friction * .001 * velocity) / config.mass;
                        velocity = velocity + acceleration * step;
                        position = position + velocity * step;
                    }
                }
                node.lastVelocity = velocity;
                if (Number.isNaN(position)) {
                    console.warn(`Got NaN while animating:`, this);
                    finished = true;
                }
            }
            if (payload && !payload[i].done) finished = false;
            if (finished) node.done = true;
            else idle = false;
            if (node.setValue(position, config.round)) changed = true;
        });
        const node = (0, $b2c49db26f0b3d2c$export$6b63995194a3a9e4)(this);
        /**
		* Get the node's current value, this will be different
		* to anim.to when config.decay is true
		*/ const currVal = node.getValue();
        if (idle) {
            const finalVal = (0, $16ba30d4a13c00f2$export$e37b7520edd66839)(anim.to);
            /**
			* check if they're not equal, or if they're
			* change and if there's no config.decay set
			*/ if ((currVal !== finalVal || changed) && !config.decay) {
                node.setValue(finalVal);
                this._onChange(finalVal);
            } else if (changed && config.decay) /**
			* if it's changed but there is a config.decay,
			* just call _onChange with currrent value
			*/ this._onChange(currVal);
            this._stop();
        } else if (changed) /**
		* if the spring has changed, but is not idle,
		* just call the _onChange handler
		*/ this._onChange(currVal);
    }
    /** Set the current value, while stopping the current animation */ set(value) {
        (0, $7a0c7bd96c8bfe17$export$27f233d61a9e2fa4).batchedUpdates(()=>{
            this._stop();
            this._focus(value);
            this._set(value);
        });
        return this;
    }
    /**
	* Freeze the active animation in time, as well as any updates merged
	* before `resume` is called.
	*/ pause() {
        this._update({
            pause: true
        });
    }
    /** Resume the animation if paused. */ resume() {
        this._update({
            pause: false
        });
    }
    /** Skip to the end of the current animation. */ finish() {
        if ($c52c96d382753013$var$isAnimating(this)) {
            const { to: to, config: config } = this.animation;
            (0, $7a0c7bd96c8bfe17$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                this._onStart();
                if (!config.decay) this._set(to, false);
                this._stop();
            });
        }
        return this;
    }
    /** Push props into the pending queue. */ update(props) {
        (this.queue || (this.queue = [])).push(props);
        return this;
    }
    start(to, arg2) {
        let queue;
        if (!(0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).und(to)) queue = [
            (0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).obj(to) ? to : {
                ...arg2,
                to: to
            }
        ];
        else {
            queue = this.queue || [];
            this.queue = [];
        }
        return Promise.all(queue.map((props)=>{
            return this._update(props);
        })).then((results)=>$c52c96d382753013$var$getCombinedResult(this, results));
    }
    /**
	* Stop the current animation, and cancel any delayed updates.
	*
	* Pass `true` to call `onRest` with `cancelled: true`.
	*/ stop(cancel) {
        const { to: to } = this.animation;
        if (!(0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).und(to)) this._focus(this.get());
        $c52c96d382753013$var$stopAsync(this._state, cancel && this._lastCallId);
        (0, $7a0c7bd96c8bfe17$export$27f233d61a9e2fa4).batchedUpdates(()=>this._stop(to, cancel));
        return this;
    }
    /** Restart the animation. */ reset() {
        this._update({
            reset: true
        });
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") this._start();
        else if (event.type == "priority") this.priority = event.priority + 1;
    }
    /**
	* Parse the `to` and `from` range from the given `props` object.
	*
	* This also ensures the initial value is available to animated components
	* during the render phase.
	*/ _prepareNode(props) {
        const key = this.key || "";
        let { to: to, from: from } = props;
        to = (0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).obj(to) ? to[key] : to;
        if (to == null || $c52c96d382753013$var$isAsyncTo(to)) to = void 0;
        from = (0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).obj(from) ? from[key] : from;
        if (from == null) from = void 0;
        const range = {
            to: to,
            from: from
        };
        if (!$c52c96d382753013$var$hasAnimated(this)) {
            if (props.reverse) [to, from] = [
                from,
                to
            ];
            from = (0, $16ba30d4a13c00f2$export$e37b7520edd66839)(from);
            if (!(0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).und(from)) this._set(from);
            else if (!(0, $b2c49db26f0b3d2c$export$6b63995194a3a9e4)(this)) this._set(to);
        }
        return range;
    }
    /** Every update is processed by this method before merging. */ _update({ ...props }, isLoop) {
        const { key: key, defaultProps: defaultProps } = this;
        if (props.default) Object.assign(defaultProps, $c52c96d382753013$var$getDefaultProps(props, (value, prop)=>/^on/.test(prop) ? $c52c96d382753013$var$resolveProp(value, key) : value));
        $c52c96d382753013$var$mergeActiveFn(this, props, "onProps");
        $c52c96d382753013$var$sendEvent(this, "onProps", props, this);
        const range = this._prepareNode(props);
        if (Object.isFrozen(this)) throw Error("Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?");
        const state = this._state;
        return $c52c96d382753013$var$scheduleProps(++this._lastCallId, {
            key: key,
            props: props,
            defaultProps: defaultProps,
            state: state,
            actions: {
                pause: ()=>{
                    if (!$c52c96d382753013$var$isPaused(this)) {
                        $c52c96d382753013$var$setPausedBit(this, true);
                        (0, $16ba30d4a13c00f2$export$7ba486852759e806)(state.pauseQueue);
                        $c52c96d382753013$var$sendEvent(this, "onPause", $c52c96d382753013$var$getFinishedResult(this, $c52c96d382753013$var$checkFinished(this, this.animation.to)), this);
                    }
                },
                resume: ()=>{
                    if ($c52c96d382753013$var$isPaused(this)) {
                        $c52c96d382753013$var$setPausedBit(this, false);
                        if ($c52c96d382753013$var$isAnimating(this)) this._resume();
                        (0, $16ba30d4a13c00f2$export$7ba486852759e806)(state.resumeQueue);
                        $c52c96d382753013$var$sendEvent(this, "onResume", $c52c96d382753013$var$getFinishedResult(this, $c52c96d382753013$var$checkFinished(this, this.animation.to)), this);
                    }
                },
                start: this._merge.bind(this, range)
            }
        }).then((result)=>{
            if (props.loop && result.finished && !(isLoop && result.noop)) {
                const nextProps = $c52c96d382753013$var$createLoopUpdate(props);
                if (nextProps) return this._update(nextProps, true);
            }
            return result;
        });
    }
    /** Merge props into the current animation */ _merge(range, props, resolve) {
        if (props.cancel) {
            this.stop(true);
            return resolve($c52c96d382753013$var$getCancelledResult(this));
        }
        /** The "to" prop is defined. */ const hasToProp = !(0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).und(range.to);
        /** The "from" prop is defined. */ const hasFromProp = !(0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).und(range.from);
        if (hasToProp || hasFromProp) {
            if (props.callId > this._lastToId) this._lastToId = props.callId;
            else return resolve($c52c96d382753013$var$getCancelledResult(this));
        }
        const { key: key, defaultProps: defaultProps, animation: anim } = this;
        const { to: prevTo, from: prevFrom } = anim;
        let { to: to = prevTo, from: from = prevFrom } = range;
        if (hasFromProp && !hasToProp && (!props.default || (0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).und(to))) to = from;
        if (props.reverse) [to, from] = [
            from,
            to
        ];
        /** The "from" value is changing. */ const hasFromChanged = !(0, $16ba30d4a13c00f2$export$248d38f6296296c5)(from, prevFrom);
        if (hasFromChanged) anim.from = from;
        from = (0, $16ba30d4a13c00f2$export$e37b7520edd66839)(from);
        /** The "to" value is changing. */ const hasToChanged = !(0, $16ba30d4a13c00f2$export$248d38f6296296c5)(to, prevTo);
        if (hasToChanged) this._focus(to);
        /** The "to" prop is async. */ const hasAsyncTo = $c52c96d382753013$var$isAsyncTo(props.to);
        const { config: config } = anim;
        const { decay: decay, velocity: velocity } = config;
        if ((hasToProp || hasFromProp) && !config.decay) config.velocity = 0;
        if (props.config && !hasAsyncTo) $c52c96d382753013$var$mergeConfig(config, $c52c96d382753013$var$callProp(props.config, key), props.config !== defaultProps.config ? $c52c96d382753013$var$callProp(defaultProps.config, key) : void 0);
        let node = (0, $b2c49db26f0b3d2c$export$6b63995194a3a9e4)(this);
        if (!node || (0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).und(to)) return resolve($c52c96d382753013$var$getFinishedResult(this, true));
        /** When true, start at the "from" value. */ const reset = (0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).und(props.reset) ? hasFromProp && !props.default : !(0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).und(from) && $c52c96d382753013$var$matchProp(props.reset, key);
        const value = reset ? from : this.get();
        const goal = $c52c96d382753013$var$computeGoal(to);
        const isAnimatable = (0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).num(goal) || (0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).arr(goal) || (0, $16ba30d4a13c00f2$export$75bed621f62abfa9)(goal);
        const immediate = !hasAsyncTo && (!isAnimatable || $c52c96d382753013$var$matchProp(defaultProps.immediate || props.immediate, key));
        if (hasToChanged) {
            const nodeType = (0, $b2c49db26f0b3d2c$export$e6b77ddbe47b132e)(to);
            if (nodeType !== node.constructor) {
                if (immediate) node = this._set(goal);
                else throw Error(`Cannot animate between ${node.constructor.name} and ${nodeType.name}, as the "to" prop suggests`);
            }
        }
        const goalType = node.constructor;
        let started = (0, $16ba30d4a13c00f2$export$57ea7e3a7f6280c7)(to);
        let finished = false;
        if (!started) {
            const hasValueChanged = reset || !$c52c96d382753013$var$hasAnimated(this) && hasFromChanged;
            if (hasToChanged || hasValueChanged) {
                finished = (0, $16ba30d4a13c00f2$export$248d38f6296296c5)($c52c96d382753013$var$computeGoal(value), goal);
                started = !finished;
            }
            if (!(0, $16ba30d4a13c00f2$export$248d38f6296296c5)(anim.immediate, immediate) && !immediate || !(0, $16ba30d4a13c00f2$export$248d38f6296296c5)(config.decay, decay) || !(0, $16ba30d4a13c00f2$export$248d38f6296296c5)(config.velocity, velocity)) started = true;
        }
        if (finished && $c52c96d382753013$var$isAnimating(this)) {
            if (anim.changed && !reset) started = true;
            else if (!started) this._stop(prevTo);
        }
        if (!hasAsyncTo) {
            if (started || (0, $16ba30d4a13c00f2$export$57ea7e3a7f6280c7)(prevTo)) {
                anim.values = node.getPayload();
                anim.toValues = (0, $16ba30d4a13c00f2$export$57ea7e3a7f6280c7)(to) ? null : goalType == (0, $b2c49db26f0b3d2c$export$f6c6c4cbd7fa5b93) ? [
                    1
                ] : (0, $16ba30d4a13c00f2$export$45b10814cc054894)(goal);
            }
            if (anim.immediate != immediate) {
                anim.immediate = immediate;
                if (!immediate && !reset) this._set(prevTo);
            }
            if (started) {
                const { onRest: onRest } = anim;
                (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)($c52c96d382753013$var$ACTIVE_EVENTS, (type)=>$c52c96d382753013$var$mergeActiveFn(this, props, type));
                const result = $c52c96d382753013$var$getFinishedResult(this, $c52c96d382753013$var$checkFinished(this, prevTo));
                (0, $16ba30d4a13c00f2$export$7ba486852759e806)(this._pendingCalls, result);
                this._pendingCalls.add(resolve);
                if (anim.changed) (0, $7a0c7bd96c8bfe17$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                    anim.changed = !reset;
                    onRest?.(result, this);
                    if (reset) $c52c96d382753013$var$callProp(defaultProps.onRest, result);
                    else anim.onStart?.(result, this);
                });
            }
        }
        if (reset) this._set(value);
        if (hasAsyncTo) resolve($c52c96d382753013$var$runAsync(props.to, props, this._state, this));
        else if (started) this._start();
        else if ($c52c96d382753013$var$isAnimating(this) && !hasToChanged) this._pendingCalls.add(resolve);
        else resolve($c52c96d382753013$var$getNoopResult(value));
    }
    /** Update the `animation.to` value, which might be a `FluidValue` */ _focus(value) {
        const anim = this.animation;
        if (value !== anim.to) {
            if ((0, $16ba30d4a13c00f2$export$133f54e9f7cf1796)(this)) this._detach();
            anim.to = value;
            if ((0, $16ba30d4a13c00f2$export$133f54e9f7cf1796)(this)) this._attach();
        }
    }
    _attach() {
        let priority = 0;
        const { to: to } = this.animation;
        if ((0, $16ba30d4a13c00f2$export$57ea7e3a7f6280c7)(to)) {
            (0, $16ba30d4a13c00f2$export$72d604e3f8d000a5)(to, this);
            if ($c52c96d382753013$var$isFrameValue(to)) priority = to.priority + 1;
        }
        this.priority = priority;
    }
    _detach() {
        const { to: to } = this.animation;
        if ((0, $16ba30d4a13c00f2$export$57ea7e3a7f6280c7)(to)) (0, $16ba30d4a13c00f2$export$7a0eb830d336339b)(to, this);
    }
    /**
	* Update the current value from outside the frameloop,
	* and return the `Animated` node.
	*/ _set(arg, idle = true) {
        const value = (0, $16ba30d4a13c00f2$export$e37b7520edd66839)(arg);
        if (!(0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).und(value)) {
            const oldNode = (0, $b2c49db26f0b3d2c$export$6b63995194a3a9e4)(this);
            if (!oldNode || !(0, $16ba30d4a13c00f2$export$248d38f6296296c5)(value, oldNode.getValue())) {
                const nodeType = (0, $b2c49db26f0b3d2c$export$e6b77ddbe47b132e)(value);
                if (!oldNode || oldNode.constructor != nodeType) (0, $b2c49db26f0b3d2c$export$b553cb5b22b81b04)(this, nodeType.create(value));
                else oldNode.setValue(value);
                if (oldNode) (0, $7a0c7bd96c8bfe17$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                    this._onChange(value, idle);
                });
            }
        }
        return (0, $b2c49db26f0b3d2c$export$6b63995194a3a9e4)(this);
    }
    _onStart() {
        const anim = this.animation;
        if (!anim.changed) {
            anim.changed = true;
            $c52c96d382753013$var$sendEvent(this, "onStart", $c52c96d382753013$var$getFinishedResult(this, $c52c96d382753013$var$checkFinished(this, anim.to)), this);
        }
    }
    _onChange(value, idle) {
        const result = $c52c96d382753013$var$getFinishedResult(value, false);
        if (!idle) {
            this._onStart();
            $c52c96d382753013$var$callProp(this.animation.onChange, result, this);
        }
        $c52c96d382753013$var$callProp(this.defaultProps.onChange, result, this);
        super._onChange(value, idle);
    }
    _start() {
        const anim = this.animation;
        (0, $b2c49db26f0b3d2c$export$6b63995194a3a9e4)(this).reset((0, $16ba30d4a13c00f2$export$e37b7520edd66839)(anim.to));
        if (!anim.immediate) anim.fromValues = anim.values.map((node)=>node.lastPosition);
        if (!$c52c96d382753013$var$isAnimating(this)) {
            $c52c96d382753013$var$setActiveBit(this, true);
            if (!$c52c96d382753013$var$isPaused(this)) this._resume();
        }
    }
    _resume() {
        if ((0, $16ba30d4a13c00f2$export$cceeabf822b64fc0).skipAnimation) this.finish();
        else (0, $16ba30d4a13c00f2$export$a57f5080a3bcc90a).start(this);
    }
    /**
	* Exit the frameloop and notify `onRest` listeners.
	*
	* Always wrap `_stop` calls with `batchedUpdates`.
	*/ _stop(goal, cancel) {
        if ($c52c96d382753013$var$isAnimating(this)) {
            $c52c96d382753013$var$setActiveBit(this, false);
            const anim = this.animation;
            (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)(anim.values, (node)=>{
                node.done = true;
            });
            if (anim.toValues) anim.onChange = anim.onPause = anim.onResume = void 0;
            (0, $16ba30d4a13c00f2$export$31752c40a5fab62a)(this, {
                type: "idle",
                parent: this
            });
            const result = cancel ? $c52c96d382753013$var$getCancelledResult(this.get()) : $c52c96d382753013$var$getFinishedResult(this.get(), $c52c96d382753013$var$checkFinished(this, goal ?? anim.to));
            (0, $16ba30d4a13c00f2$export$7ba486852759e806)(this._pendingCalls, result);
            anim.changed = false;
            $c52c96d382753013$var$sendEvent(this, "onRest", result, this);
        }
    }
};
/** Returns true when the current value and goal value are equal. */ function $c52c96d382753013$var$checkFinished(target, to) {
    const goal = $c52c96d382753013$var$computeGoal(to);
    return (0, $16ba30d4a13c00f2$export$248d38f6296296c5)($c52c96d382753013$var$computeGoal(target.get()), goal);
}
function $c52c96d382753013$var$createLoopUpdate(props, loop = props.loop, to = props.to) {
    const loopRet = $c52c96d382753013$var$callProp(loop);
    if (loopRet) {
        const overrides = loopRet !== true && $c52c96d382753013$export$b971039a739bf227(loopRet);
        const reverse = (overrides || props).reverse;
        const reset = !overrides || overrides.reset;
        return $c52c96d382753013$var$createUpdate({
            ...props,
            loop: loop,
            default: false,
            pause: void 0,
            to: !reverse || $c52c96d382753013$var$isAsyncTo(to) ? to : void 0,
            from: reset ? props.from : void 0,
            reset: reset,
            ...overrides
        });
    }
}
/**
* Return a new object based on the given `props`.
*
* - All non-reserved props are moved into the `to` prop object.
* - The `keys` prop is set to an array of affected keys,
*   or `null` if all keys are affected.
*/ function $c52c96d382753013$var$createUpdate(props) {
    const { to: to, from: from } = props = $c52c96d382753013$export$b971039a739bf227(props);
    const keys = /* @__PURE__ */ new Set();
    if ((0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).obj(to)) $c52c96d382753013$var$findDefined(to, keys);
    if ((0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).obj(from)) $c52c96d382753013$var$findDefined(from, keys);
    props.keys = keys.size ? Array.from(keys) : null;
    return props;
}
/**
* A modified version of `createUpdate` meant for declarative APIs.
*/ function $c52c96d382753013$var$declareUpdate(props) {
    const update = $c52c96d382753013$var$createUpdate(props);
    if ((0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).und(update.default)) update.default = $c52c96d382753013$var$getDefaultProps(update);
    return update;
}
/** Find keys with defined values */ function $c52c96d382753013$var$findDefined(values, keys) {
    (0, $16ba30d4a13c00f2$export$f4c6fe153f5a944e)(values, (value, key)=>value != null && keys.add(key));
}
/** Event props with "active handler" support */ const $c52c96d382753013$var$ACTIVE_EVENTS = [
    "onStart",
    "onRest",
    "onChange",
    "onPause",
    "onResume"
];
function $c52c96d382753013$var$mergeActiveFn(target, props, type) {
    target.animation[type] = props[type] !== $c52c96d382753013$var$getDefaultProp(props, type) ? $c52c96d382753013$var$resolveProp(props[type], target.key) : void 0;
}
/** Call the active handler first, then the default handler. */ function $c52c96d382753013$var$sendEvent(target, type, ...args) {
    target.animation[type]?.(...args);
    target.defaultProps[type]?.(...args);
}
//#endregion
//#region src/Controller.ts
/** Events batched by the `Controller` class */ const $c52c96d382753013$var$BATCHED_EVENTS = [
    "onStart",
    "onChange",
    "onRest"
];
let $c52c96d382753013$var$nextId = 1;
var $c52c96d382753013$export$bd0bf19f25da8474 = class {
    constructor(props, flush){
        this.id = $c52c96d382753013$var$nextId++;
        this.springs = {};
        this.queue = [];
        this._lastAsyncId = 0;
        this._lastLoopId = 0;
        this._active = /* @__PURE__ */ new Set();
        this._changed = /* @__PURE__ */ new Set();
        this._started = false;
        this._state = {
            paused: false,
            pauseQueue: /* @__PURE__ */ new Set(),
            resumeQueue: /* @__PURE__ */ new Set(),
            timeouts: /* @__PURE__ */ new Set()
        };
        this._events = {
            onStart: /* @__PURE__ */ new Map(),
            onChange: /* @__PURE__ */ new Map(),
            onRest: /* @__PURE__ */ new Map()
        };
        this._onFrame = this._onFrame.bind(this);
        if (flush) this._flush = flush;
        if (props) this.start({
            default: true,
            ...props
        });
    }
    /**
	* Equals `true` when no spring values are in the frameloop, and
	* no async animation is currently active.
	*/ get idle() {
        return !this._state.asyncTo && Object.values(this.springs).every((spring)=>{
            return spring.idle && !spring.isDelayed && !spring.isPaused;
        });
    }
    get item() {
        return this._item;
    }
    set item(item) {
        this._item = item;
    }
    /** Get the current values of our springs */ get() {
        const values = {};
        this.each((spring, key)=>values[key] = spring.get());
        return values;
    }
    /** Set the current values without animating. */ set(values) {
        for(const key in values){
            const value = values[key];
            if (!(0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).und(value)) this.springs[key].set(value);
        }
    }
    /** Push an update onto the queue of each value. */ update(props) {
        if (props) this.queue.push($c52c96d382753013$var$createUpdate(props));
        return this;
    }
    /**
	* Start the queued animations for every spring, and resolve the returned
	* promise once all queued animations have finished or been cancelled.
	*
	* When you pass a queue (instead of nothing), that queue is used instead of
	* the queued animations added with the `update` method, which are left alone.
	*/ start(props) {
        let { queue: queue } = this;
        if (props) queue = (0, $16ba30d4a13c00f2$export$45b10814cc054894)(props).map($c52c96d382753013$var$createUpdate);
        else this.queue = [];
        if (this._flush) return this._flush(this, queue);
        $c52c96d382753013$var$prepareKeys(this, queue);
        return $c52c96d382753013$var$flushUpdateQueue(this, queue);
    }
    /** @internal */ stop(arg, keys) {
        if (arg !== !!arg) keys = arg;
        if (keys) {
            const springs = this.springs;
            (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)((0, $16ba30d4a13c00f2$export$45b10814cc054894)(keys), (key)=>springs[key].stop(!!arg));
        } else {
            $c52c96d382753013$var$stopAsync(this._state, this._lastAsyncId);
            this.each((spring)=>spring.stop(!!arg));
        }
        return this;
    }
    /** Freeze the active animation in time */ pause(keys) {
        if ((0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).und(keys)) this.start({
            pause: true
        });
        else {
            const springs = this.springs;
            (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)((0, $16ba30d4a13c00f2$export$45b10814cc054894)(keys), (key)=>springs[key].pause());
        }
        return this;
    }
    /** Resume the animation if paused. */ resume(keys) {
        if ((0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).und(keys)) this.start({
            pause: false
        });
        else {
            const springs = this.springs;
            (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)((0, $16ba30d4a13c00f2$export$45b10814cc054894)(keys), (key)=>springs[key].resume());
        }
        return this;
    }
    /** Call a function once per spring value */ each(iterator) {
        (0, $16ba30d4a13c00f2$export$f4c6fe153f5a944e)(this.springs, iterator);
    }
    /**
	* Subscribe to loop iteration restarts on this controller. Returns an
	* unsubscribe function. Listeners fire synchronously inside `flushUpdate`
	* just before the next iteration is dispatched.
	* @internal
	*/ onLoopReset(fn) {
        const set = this._onLoopReset ?? (this._onLoopReset = /* @__PURE__ */ new Set());
        set.add(fn);
        return ()=>{
            set.delete(fn);
        };
    }
    /** @internal Called at the end of every animation frame */ _onFrame() {
        const { onStart: onStart, onChange: onChange, onRest: onRest } = this._events;
        const active = this._active.size > 0;
        const changed = this._changed.size > 0;
        if (active && !this._started || changed && !this._started) {
            this._started = true;
            (0, $16ba30d4a13c00f2$export$4909b86c8034bf73)(onStart, ([onStart, result])=>{
                result.value = this.get();
                onStart(result, this, this._item);
            });
        }
        const idle = !active && this._started;
        const values = changed || idle && onRest.size ? this.get() : null;
        if (changed && onChange.size) (0, $16ba30d4a13c00f2$export$4909b86c8034bf73)(onChange, ([onChange, result])=>{
            result.value = values;
            onChange(result, this, this._item);
        });
        if (idle) {
            this._started = false;
            (0, $16ba30d4a13c00f2$export$4909b86c8034bf73)(onRest, ([onRest, result])=>{
                result.value = values;
                onRest(result, this, this._item);
            });
        }
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") {
            this._changed.add(event.parent);
            if (!event.idle) this._active.add(event.parent);
        } else if (event.type == "idle") this._active.delete(event.parent);
        else return;
        (0, $7a0c7bd96c8bfe17$export$27f233d61a9e2fa4).onFrame(this._onFrame);
    }
};
/**
* Warning: Props might be mutated.
*/ function $c52c96d382753013$var$flushUpdateQueue(ctrl, queue) {
    return Promise.all(queue.map((props)=>$c52c96d382753013$var$flushUpdate(ctrl, props))).then((results)=>$c52c96d382753013$var$getCombinedResult(ctrl, results));
}
/**
* Warning: Props might be mutated.
*
* Process a single set of props using the given controller.
*
* The returned promise resolves to `true` once the update is
* applied and any animations it starts are finished without being
* stopped or cancelled.
*/ async function $c52c96d382753013$var$flushUpdate(ctrl, props, isLoop) {
    const { keys: keys, to: to, from: from, loop: loop, onRest: onRest, onResolve: onResolve } = props;
    const defaults = (0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).obj(props.default) && props.default;
    if (loop) props.loop = false;
    const propsAny = props;
    const loopId = !isLoop && !propsAny.parentId && "loop" in props ? ++ctrl["_lastLoopId"] : isLoop ? propsAny.loopId : ctrl["_lastLoopId"];
    if (to === false) props.to = null;
    if (from === false) props.from = null;
    const asyncTo = (0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).arr(to) || (0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).fun(to) ? to : void 0;
    if (asyncTo) {
        props.to = void 0;
        props.onRest = void 0;
        if (defaults) defaults.onRest = void 0;
    } else (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)($c52c96d382753013$var$BATCHED_EVENTS, (key)=>{
        const handler = props[key];
        if ((0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).fun(handler)) {
            const queue = ctrl["_events"][key];
            props[key] = ({ finished: finished, cancelled: cancelled })=>{
                const result = queue.get(handler);
                if (result) {
                    if (!finished) result.finished = false;
                    if (cancelled) result.cancelled = true;
                } else queue.set(handler, {
                    value: null,
                    finished: finished || false,
                    cancelled: cancelled || false
                });
            };
            if (defaults) defaults[key] = props[key];
        }
    });
    const state = ctrl["_state"];
    if (props.pause === !state.paused) {
        state.paused = props.pause;
        (0, $16ba30d4a13c00f2$export$7ba486852759e806)(props.pause ? state.pauseQueue : state.resumeQueue);
    } else if (state.paused) props.pause = true;
    const promises = (keys || Object.keys(ctrl.springs)).map((key)=>ctrl.springs[key].start(props));
    const cancel = props.cancel === true || $c52c96d382753013$var$getDefaultProp(props, "cancel") === true;
    if (asyncTo || cancel && state.asyncId) promises.push($c52c96d382753013$var$scheduleProps(++ctrl["_lastAsyncId"], {
        props: props,
        state: state,
        actions: {
            pause: (0, $16ba30d4a13c00f2$export$8793edee2d425525),
            resume: (0, $16ba30d4a13c00f2$export$8793edee2d425525),
            start (props, resolve) {
                if (cancel) {
                    $c52c96d382753013$var$stopAsync(state, ctrl["_lastAsyncId"]);
                    resolve($c52c96d382753013$var$getCancelledResult(ctrl));
                } else {
                    props.onRest = onRest;
                    resolve($c52c96d382753013$var$runAsync(asyncTo, props, state, ctrl));
                }
            }
        }
    }));
    if (state.paused) await new Promise((resume)=>{
        state.resumeQueue.add(resume);
    });
    const result = $c52c96d382753013$var$getCombinedResult(ctrl, await Promise.all(promises));
    if (loop && result.finished && !(isLoop && result.noop) && loopId === ctrl["_lastLoopId"]) {
        const nextProps = $c52c96d382753013$var$createLoopUpdate(props, loop, to);
        if (nextProps) {
            nextProps.loopId = loopId;
            ctrl["_onLoopReset"]?.forEach((fn)=>fn());
            $c52c96d382753013$var$prepareKeys(ctrl, [
                nextProps
            ]);
            return $c52c96d382753013$var$flushUpdate(ctrl, nextProps, true);
        }
    }
    if (onResolve) (0, $7a0c7bd96c8bfe17$export$27f233d61a9e2fa4).batchedUpdates(()=>onResolve(result, ctrl, ctrl.item));
    return result;
}
/**
* From an array of updates, get the map of `SpringValue` objects
* by their keys. Springs are created when any update wants to
* animate a new key.
*
* Springs created by `getSprings` are neither cached nor observed
* until they're given to `setSprings`.
*/ function $c52c96d382753013$var$getSprings(ctrl, props) {
    const springs = {
        ...ctrl.springs
    };
    if (props) (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)((0, $16ba30d4a13c00f2$export$45b10814cc054894)(props), (props)=>{
        if ((0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).und(props.keys)) props = $c52c96d382753013$var$createUpdate(props);
        if (!(0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).obj(props.to)) props = {
            ...props,
            to: void 0
        };
        $c52c96d382753013$var$prepareSprings(springs, props, (key)=>{
            return $c52c96d382753013$var$createSpring(key);
        });
    });
    $c52c96d382753013$var$setSprings(ctrl, springs);
    return springs;
}
/**
* Tell a controller to manage the given `SpringValue` objects
* whose key is not already in use.
*/ function $c52c96d382753013$var$setSprings(ctrl, springs) {
    (0, $16ba30d4a13c00f2$export$f4c6fe153f5a944e)(springs, (spring, key)=>{
        if (!ctrl.springs[key]) {
            ctrl.springs[key] = spring;
            (0, $16ba30d4a13c00f2$export$72d604e3f8d000a5)(spring, ctrl);
        }
    });
}
function $c52c96d382753013$var$createSpring(key, observer) {
    const spring = new $c52c96d382753013$export$5854d13427d5a954();
    spring.key = key;
    if (observer) (0, $16ba30d4a13c00f2$export$72d604e3f8d000a5)(spring, observer);
    return spring;
}
/**
* Ensure spring objects exist for each defined key.
*
* Using the `props`, the `Animated` node of each `SpringValue` may
* be created or updated.
*/ function $c52c96d382753013$var$prepareSprings(springs, props, create) {
    if (props.keys) (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)(props.keys, (key)=>{
        (springs[key] || (springs[key] = create(key)))["_prepareNode"](props);
    });
}
/**
* Ensure spring objects exist for each defined key, and attach the
* `ctrl` to them for observation.
*
* The queue is expected to contain `createUpdate` results.
*/ function $c52c96d382753013$var$prepareKeys(ctrl, queue) {
    (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)(queue, (props)=>{
        $c52c96d382753013$var$prepareSprings(ctrl.springs, props, (key)=>{
            return $c52c96d382753013$var$createSpring(key, ctrl);
        });
    });
}
//#endregion
//#region src/SpringContext.tsx
const $c52c96d382753013$export$f12a216ec50d2cf1 = $5E6i4.createContext({
    pause: false,
    immediate: false
});
//#endregion
//#region src/SpringRef.ts
const $c52c96d382753013$export$2471ae76e2946684 = ()=>{
    const current = [];
    const SpringRef = function(props) {
        (0, $16ba30d4a13c00f2$export$d99d974913ad3b12)();
        const results = [];
        (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            if ((0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).und(props)) results.push(ctrl.start());
            else {
                const update = _getProps(props, ctrl, i);
                if (update) results.push(ctrl.start(update));
            }
        });
        return results;
    };
    SpringRef.current = current;
    /** Add a controller to this ref */ SpringRef.add = function(ctrl) {
        if (!current.includes(ctrl)) current.push(ctrl);
    };
    /** Remove a controller from this ref */ SpringRef.delete = function(ctrl) {
        const i = current.indexOf(ctrl);
        if (~i) current.splice(i, 1);
    };
    /** Pause all animations. */ SpringRef.pause = function() {
        (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.pause(...arguments));
        return this;
    };
    /** Resume all animations. */ SpringRef.resume = function() {
        (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.resume(...arguments));
        return this;
    };
    /** Update the state of each controller without animating. */ SpringRef.set = function(values) {
        (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            const update = (0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).fun(values) ? values(i, ctrl) : values;
            if (update) ctrl.set(update);
        });
    };
    SpringRef.start = function(props) {
        const results = [];
        (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            if ((0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).und(props)) results.push(ctrl.start());
            else {
                const update = this._getProps(props, ctrl, i);
                if (update) results.push(ctrl.start(update));
            }
        });
        return results;
    };
    /** Stop all animations. */ SpringRef.stop = function() {
        (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.stop(...arguments));
        return this;
    };
    SpringRef.update = function(props) {
        (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)(current, (ctrl, i)=>ctrl.update(this._getProps(props, ctrl, i)));
        return this;
    };
    /** Overridden by `useTrail` to manipulate props */ const _getProps = function(arg, ctrl, index) {
        return (0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).fun(arg) ? arg(index, ctrl) : arg;
    };
    SpringRef._getProps = _getProps;
    return SpringRef;
};
//#endregion
//#region src/hooks/useSprings.ts
/** @internal */ function $c52c96d382753013$export$15786d483ab9f469(length, props, deps) {
    const propsFn = (0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).fun(props) && props;
    if (propsFn && !deps) deps = [];
    const ref = (0, $5E6i4.useMemo)(()=>propsFn || arguments.length == 3 ? $c52c96d382753013$export$2471ae76e2946684() : void 0, []);
    const layoutId = (0, $5E6i4.useRef)(0);
    const forceUpdate = (0, $16ba30d4a13c00f2$export$91db9bc4f8ac944a)();
    const state = (0, $5E6i4.useMemo)(()=>({
            ctrls: [],
            queue: [],
            flush (ctrl, updates) {
                const springs = $c52c96d382753013$var$getSprings(ctrl, updates);
                return layoutId.current > 0 && !state.queue.length && !Object.keys(springs).some((key)=>!ctrl.springs[key]) ? $c52c96d382753013$var$flushUpdateQueue(ctrl, updates) : new Promise((resolve)=>{
                    $c52c96d382753013$var$setSprings(ctrl, springs);
                    state.queue.push(()=>{
                        resolve($c52c96d382753013$var$flushUpdateQueue(ctrl, updates));
                    });
                    forceUpdate();
                });
            }
        }), []);
    const ctrls = (0, $5E6i4.useRef)([
        ...state.ctrls
    ]);
    const updates = (0, $5E6i4.useRef)([]);
    const strictModeRestartSnapshot = (0, $5E6i4.useRef)([]);
    strictModeRestartSnapshot.current = [];
    const prevLength = (0, $16ba30d4a13c00f2$export$ef7ad0c4e19d7fbf)(length) || 0;
    (0, $5E6i4.useMemo)(()=>{
        (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)(ctrls.current.slice(length, prevLength), (ctrl)=>{
            $c52c96d382753013$var$detachRefs(ctrl, ref);
            ctrl.stop(true);
        });
        ctrls.current.length = length;
        declareUpdates(prevLength, length);
    }, [
        length
    ]);
    (0, $5E6i4.useMemo)(()=>{
        declareUpdates(0, Math.min(prevLength, length));
    }, deps);
    /** Fill the `updates` array with declarative updates for the given index range. */ function declareUpdates(startIndex, endIndex) {
        for(let i = startIndex; i < endIndex; i++){
            const ctrl = ctrls.current[i] || (ctrls.current[i] = new $c52c96d382753013$export$bd0bf19f25da8474(null, state.flush));
            const update = propsFn ? propsFn(i, ctrl) : props[i];
            if (update) updates.current[i] = $c52c96d382753013$var$declareUpdate(update);
        }
    }
    const springs = ctrls.current.map((ctrl, i)=>$c52c96d382753013$var$getSprings(ctrl, updates.current[i]));
    const context = (0, $5E6i4.useContext)($c52c96d382753013$export$f12a216ec50d2cf1);
    const hasContext = context !== (0, $16ba30d4a13c00f2$export$ef7ad0c4e19d7fbf)(context) && $c52c96d382753013$var$hasProps(context);
    (0, $16ba30d4a13c00f2$export$700979bc83e7db82)(()=>{
        layoutId.current++;
        state.ctrls = ctrls.current;
        const { queue: queue } = state;
        if (queue.length) {
            state.queue = [];
            (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)(queue, (cb)=>cb());
        }
        const activeUpdates = updates.current.length > 0 ? updates.current : strictModeRestartSnapshot.current;
        (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)(ctrls.current, (ctrl, i)=>{
            ref?.add(ctrl);
            if (hasContext) ctrl.start({
                default: context
            });
            const update = activeUpdates[i];
            if (update) {
                $c52c96d382753013$var$replaceRef(ctrl, update.ref);
                if (ctrl.ref) ctrl.queue.push({
                    ...update,
                    default: (0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).obj(update.default) ? {
                        ...update.default
                    } : update.default
                });
                else ctrl.start(update);
            }
        });
        if (updates.current.length > 0) strictModeRestartSnapshot.current = updates.current;
        updates.current = [];
    });
    (0, $16ba30d4a13c00f2$export$392544347a18b6ea)(()=>()=>{
            (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)(state.ctrls, (ctrl)=>ctrl.stop(true));
        });
    const values = springs.map((x)=>({
            ...x
        }));
    return ref ? [
        values,
        ref
    ] : values;
}
//#endregion
//#region src/hooks/useSpring.ts
/** @internal */ function $c52c96d382753013$export$c4af9125706c4d30(props, deps) {
    const isFn = (0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).fun(props);
    const [[values], ref] = $c52c96d382753013$export$15786d483ab9f469(1, isFn ? props : [
        props
    ], isFn ? deps || [] : deps);
    return isFn || arguments.length == 2 ? [
        values,
        ref
    ] : values;
}
//#endregion
//#region src/hooks/useSpringRef.ts
const $c52c96d382753013$var$initSpringRef = ()=>$c52c96d382753013$export$2471ae76e2946684();
const $c52c96d382753013$export$564bff9c23cad2ca = ()=>(0, $5E6i4.useState)($c52c96d382753013$var$initSpringRef)[0];
//#endregion
//#region src/hooks/useSpringValue.ts
/**
* Creates a constant single `SpringValue` that can be interacted
* with imperatively. This is an advanced API and does not react
* to updates from the parent component e.g. passing a new initial value
*
*
* ```jsx
* export const MyComponent = () => {
*   const opacity = useSpringValue(1)
*
*   return <animated.div style={{ opacity }} />
* }
* ```
*
* @param initial – The initial value of the `SpringValue`.
* @param props – Typically the same props as `useSpring` e.g. `config`, `loop` etc.
*
* @public
*/ const $c52c96d382753013$export$ab73804b080feffc = (initial, props)=>{
    const springValue = (0, $16ba30d4a13c00f2$export$fe4300aa8eebea86)(()=>new $c52c96d382753013$export$5854d13427d5a954(initial, props));
    (0, $16ba30d4a13c00f2$export$392544347a18b6ea)(()=>()=>{
            springValue.stop();
        });
    return springValue;
};
//#endregion
//#region src/hooks/useTrail.ts
function $c52c96d382753013$export$250279104b4672ed(length, propsArg, deps) {
    const propsFn = (0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).fun(propsArg) && propsArg;
    if (propsFn && !deps) deps = [];
    let reverse;
    let passedRef = void 0;
    if (!propsFn) {
        reverse = propsArg.reverse;
        passedRef = propsArg.ref;
    } else reverse = true;
    const result = $c52c96d382753013$export$15786d483ab9f469(length, (i, ctrl)=>{
        const props = propsFn ? propsFn(i, ctrl) : propsArg;
        if (propsFn) {
            passedRef = props.ref;
            reverse = reverse && props.reverse;
        }
        return props;
    }, deps || [
        {}
    ]);
    (0, $16ba30d4a13c00f2$export$700979bc83e7db82)(()=>{
        const ctrls = result[1].current;
        const head = ctrls[reverse ? ctrls.length - 1 : 0];
        const unsubscribers = [];
        /**
		* Run through the ref passed by the `useSprings` hook.
		*/ (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)(ctrls, (ctrl, i)=>{
            const parent = ctrls[i + (reverse ? 1 : -1)];
            /**
			* If there's a passed ref then we replace the ctrl ref with it
			*/ $c52c96d382753013$var$replaceRef(ctrl, passedRef);
            /**
			* And if there's a ctrl ref then we update instead of start
			* which means nothing is fired until the start method
			* of said passedRef is called.
			*/ if (ctrl.ref) {
                if (parent) ctrl.update({
                    to: parent.springs
                });
            } else if (parent) ctrl.start({
                to: parent.springs
            });
            else ctrl.start();
            if (ctrl !== head) unsubscribers.push(head.onLoopReset(()=>{
                ctrl.start({
                    reset: true
                });
            }));
        });
        return ()=>{
            (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)(unsubscribers, (unsubscribe)=>unsubscribe());
        };
    }, deps);
    if (propsFn || arguments.length == 3) {
        const ref = passedRef ?? result[1];
        ref["_getProps"] = (propsArg, ctrl, i)=>{
            const props = (0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).fun(propsArg) ? propsArg(i, ctrl) : propsArg;
            if (props) {
                const parent = ref.current[i + (props.reverse ? 1 : -1)];
                if (parent) props.to = parent.springs;
                return props;
            }
        };
        return result;
    }
    return result[0];
}
//#endregion
//#region src/hooks/useTransition.tsx
function $c52c96d382753013$export$7b286972b8d8ccbf(data, props, deps) {
    const propsFn = (0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).fun(props) && props;
    const { reset: reset, sort: sort, trail: trail = 0, reverse: reverse = false, expires: expires = true, exitBeforeEnter: exitBeforeEnter = false, onDestroyed: onDestroyed, ref: propsRef, config: propsConfig } = propsFn ? propsFn() : props;
    const ref = (0, $5E6i4.useMemo)(()=>propsFn || arguments.length == 3 ? $c52c96d382753013$export$2471ae76e2946684() : void 0, []);
    const items = (0, $16ba30d4a13c00f2$export$45b10814cc054894)(data);
    const transitions = [];
    const usedTransitions = (0, $5E6i4.useRef)(null);
    const prevTransitions = reset ? null : usedTransitions.current;
    (0, $16ba30d4a13c00f2$export$700979bc83e7db82)(()=>{
        usedTransitions.current = transitions;
    });
    (0, $16ba30d4a13c00f2$export$392544347a18b6ea)(()=>{
        /**
		* If transitions exist on mount of the component
		* then reattach their refs on-mount, this was required
		* for react18 strict mode to work properly.
		*
		* StrictMode's simulated unmount detaches the controller from its ref but
		* leaves `ctrl.ref` set, so we reset it here to let the commit phase's
		* `replaceRef` reattach an *injected* ref. We must NOT assign the local
		* `ref` to `ctrl.ref` — that would make a function/deps-form transition
		* defer its enter animation as if a ref were injected (see #2287).
		*
		* See https://github.com/pmndrs/react-spring/issues/1890
		*/ (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)(transitions, (t)=>{
            ref?.add(t.ctrl);
            t.ctrl.ref = void 0;
        });
        return ()=>{
            (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)(usedTransitions.current, (t)=>{
                if (t.expired) clearTimeout(t.expirationId);
                $c52c96d382753013$var$detachRefs(t.ctrl, ref);
                t.ctrl.stop(true);
            });
        };
    });
    const keys = $c52c96d382753013$var$getKeys(items, propsFn ? propsFn() : props, prevTransitions);
    const expired = reset && usedTransitions.current || [];
    (0, $16ba30d4a13c00f2$export$700979bc83e7db82)(()=>(0, $16ba30d4a13c00f2$export$79b2f7037acddd43)(expired, ({ ctrl: ctrl, item: item, key: key })=>{
            $c52c96d382753013$var$detachRefs(ctrl, ref);
            $c52c96d382753013$var$callProp(onDestroyed, item, key);
        }));
    const reused = [];
    if (prevTransitions) (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)(prevTransitions, (t, i)=>{
        if (t.expired) {
            clearTimeout(t.expirationId);
            expired.push(t);
        } else {
            i = reused[i] = keys.indexOf(t.key);
            if (~i) transitions[i] = t;
        }
    });
    (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)(items, (item, i)=>{
        if (!transitions[i]) {
            transitions[i] = {
                key: keys[i],
                item: item,
                phase: "mount",
                ctrl: new $c52c96d382753013$export$bd0bf19f25da8474()
            };
            transitions[i].ctrl.item = item;
        }
    });
    if (reused.length) {
        let i = -1;
        const { leave: leave } = propsFn ? propsFn() : props;
        (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)(reused, (keyIndex, prevIndex)=>{
            const t = prevTransitions[prevIndex];
            if (~keyIndex) {
                i = transitions.indexOf(t);
                transitions[i] = {
                    ...t,
                    item: items[keyIndex]
                };
            } else if (leave) transitions.splice(++i, 0, t);
        });
    }
    if ((0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).fun(sort)) transitions.sort((a, b)=>sort(a.item, b.item));
    let delay = -trail;
    const trailedPayloads = [];
    const forceUpdate = (0, $16ba30d4a13c00f2$export$91db9bc4f8ac944a)();
    const defaultProps = $c52c96d382753013$var$getDefaultProps(props);
    const changes = /* @__PURE__ */ new Map();
    const exitingTransitions = (0, $5E6i4.useRef)(/* @__PURE__ */ new Map());
    const forceChange = (0, $5E6i4.useRef)(false);
    (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)(transitions, (t, i)=>{
        const key = t.key;
        const prevPhase = t.phase;
        const p = propsFn ? propsFn() : props;
        let to;
        let phase;
        const propsDelay = $c52c96d382753013$var$callProp(p.delay || 0, key);
        if (prevPhase == "mount") {
            to = p.enter;
            phase = "enter";
        } else {
            const isLeave = keys.indexOf(key) < 0;
            if (prevPhase != "leave") {
                if (isLeave) {
                    to = p.leave;
                    phase = "leave";
                } else if (to = p.update) phase = "update";
                else return;
            } else if (!isLeave) {
                to = p.enter;
                phase = "enter";
            } else return;
        }
        to = $c52c96d382753013$var$callProp(to, t.item, i);
        to = (0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).obj(to) ? $c52c96d382753013$export$b971039a739bf227(to) : {
            to: to
        };
        /**
		* This would allow us to give different delays for phases.
		* If we were to do this, we'd have to suffle the prop
		* spreading below to set delay last.
		* But if we were going to do that, we should consider letting
		* the prop trail also be part of a phase.
		*/ if (!to.config) {
            const config = propsConfig || defaultProps.config;
            to.config = $c52c96d382753013$var$callProp(config, t.item, i, phase);
        }
        delay += trail;
        const payload = {
            ...defaultProps,
            delay: propsDelay + delay,
            ref: propsRef,
            immediate: p.immediate,
            reset: false,
            ...to
        };
        if (phase == "enter" && (0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).und(payload.from)) {
            const p = propsFn ? propsFn() : props;
            payload.from = $c52c96d382753013$var$callProp((0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).und(p.initial) || prevTransitions ? p.from : p.initial, t.item, i);
        }
        const { onResolve: onResolve } = payload;
        payload.onResolve = (result)=>{
            $c52c96d382753013$var$callProp(onResolve, result);
            const transitions = usedTransitions.current;
            const t = transitions.find((t)=>t.key === key);
            if (!t) return;
            if (result.cancelled && t.phase != "update") /**
			* @legacy Reset the phase of a cancelled enter/leave transition, so it can
			* retry the animation on the next render.
			*
			* Note: leaving this here made the transitioned item respawn.
			*/ return;
            if (t.ctrl.idle) {
                const idle = transitions.every((t)=>t.ctrl.idle);
                if (t.phase == "leave") {
                    exitingTransitions.current.delete(t);
                    const expiry = $c52c96d382753013$var$callProp(expires, t.item);
                    if (expiry !== false) {
                        const expiryMs = expiry === true ? 0 : expiry;
                        t.expired = true;
                        if (!idle && expiryMs > 0) {
                            if (expiryMs <= 2147483647) t.expirationId = setTimeout(forceUpdate, expiryMs);
                            return;
                        }
                    }
                }
                if (idle && transitions.some((t)=>t.expired)) {
                    if (exitBeforeEnter) /**
					* If we have exitBeforeEnter == true
					* we need to force the animation to start
					*/ forceChange.current = true;
                    forceUpdate();
                }
            }
        };
        const springs = $c52c96d382753013$var$getSprings(t.ctrl, payload);
        trailedPayloads.push({
            payload: payload,
            propsDelay: propsDelay
        });
        /**
		* Make a separate map for the exiting changes and "regular" changes
		*/ if (phase === "leave" && exitBeforeEnter) exitingTransitions.current.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
        else changes.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
    });
    if (reverse && trail) {
        const total = trailedPayloads.length;
        (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)(trailedPayloads, ({ payload: payload, propsDelay: propsDelay }, i)=>{
            payload.delay = propsDelay + (total - 1 - i) * trail;
        });
    }
    const context = (0, $5E6i4.useContext)($c52c96d382753013$export$f12a216ec50d2cf1);
    const hasContext = context !== (0, $16ba30d4a13c00f2$export$ef7ad0c4e19d7fbf)(context) && $c52c96d382753013$var$hasProps(context);
    (0, $16ba30d4a13c00f2$export$700979bc83e7db82)(()=>{
        if (hasContext) (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)(transitions, (t)=>{
            t.ctrl.start({
                default: context
            });
        });
    }, [
        context
    ]);
    (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)(changes, (_, t)=>{
        /**
		* If we have children to exit because exitBeforeEnter is
		* set to true, we remove the transitions so they go to back
		* to their initial state.
		*/ if (exitingTransitions.current.size) {
            const ind = transitions.findIndex((state)=>state.key === t.key);
            transitions.splice(ind, 1);
        }
    });
    (0, $16ba30d4a13c00f2$export$700979bc83e7db82)(()=>{
        (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)(exitingTransitions.current.size ? exitingTransitions.current : changes, ({ phase: phase, payload: payload }, t)=>{
            const { ctrl: ctrl } = t;
            t.phase = phase;
            ref?.add(ctrl);
            if (hasContext && phase == "enter") ctrl.start({
                default: context
            });
            if (payload) {
                $c52c96d382753013$var$replaceRef(ctrl, payload.ref);
                /**
				* When an injected ref exists, the update is postponed
				* until the ref has its `start` method called.
				* Unless we have exitBeforeEnter in which case will skip
				* to enter the new animation straight away as if they "overlapped"
				*/ if (ctrl.ref && !forceChange.current) ctrl.update(payload);
                else {
                    ctrl.start(payload);
                    if (forceChange.current) forceChange.current = false;
                }
            }
        });
    }, reset ? void 0 : deps);
    const renderTransitions = (render)=>/* @__PURE__ */ $5E6i4.createElement($5E6i4.Fragment, null, transitions.map((t, i)=>{
            const change = changes.get(t) || exitingTransitions.current.get(t);
            const { springs: springs } = change || t.ctrl;
            const state = change ? {
                ...t,
                phase: change.phase
            } : t;
            const elem = render({
                ...springs
            }, t.item, state, i);
            const key = (0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).str(t.key) || (0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).num(t.key) ? t.key : t.ctrl.id;
            const isLegacyReact = $5E6i4.version < "19.0.0";
            const props = elem?.props ?? {};
            const elemRef = isLegacyReact ? elem?.ref : props?.ref;
            return elem && elem.type ? /* @__PURE__ */ $5E6i4.createElement(elem.type, {
                ...props,
                key: key,
                ref: elemRef
            }) : elem;
        }));
    return ref ? [
        renderTransitions,
        ref
    ] : renderTransitions;
}
/** Local state for auto-generated item keys */ let $c52c96d382753013$var$nextKey = 1;
function $c52c96d382753013$var$getKeys(items, { key: key, keys: keys = key }, prevTransitions) {
    if (keys === null) {
        const reused = /* @__PURE__ */ new Set();
        return items.map((item)=>{
            const t = prevTransitions && prevTransitions.find((t)=>t.item === item && t.phase !== "leave" && !reused.has(t));
            if (t) {
                reused.add(t);
                return t.key;
            }
            return $c52c96d382753013$var$nextKey++;
        });
    }
    return (0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).und(keys) ? items : (0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).fun(keys) ? items.map(keys) : (0, $16ba30d4a13c00f2$export$45b10814cc054894)(keys);
}
//#endregion
//#region src/hooks/useScroll.ts
/**
* A small utility abstraction around our signature useSpring hook. It's a great way to create
* a scroll-linked animation. With either the raw value of distance or a 0-1 progress value.
* You can either use the scroll values of the whole document, or just a specific element.
*
* 
```jsx
import { useScroll, animated } from '@react-spring/web'

function MyComponent() {
const { scrollYProgress } = useScroll()

return (
<animated.div style={{ opacity: scrollYProgress }}>
Hello World
</animated.div>
)
}
```
* 
* @param {UseScrollOptions} useScrollOptions options for the useScroll hook.
* @param {MutableRefObject<HTMLElement>} useScrollOptions.container the container to listen to scroll events on, defaults to the window.
*
* @returns {SpringValues<{scrollX: number; scrollY: number; scrollXProgress: number; scrollYProgress: number}>} SpringValues the collection of values returned from the inner hook
*/ const $c52c96d382753013$export$d928051c8cd740b = ({ container: container, ...springOptions } = {})=>{
    const [scrollValues, api] = $c52c96d382753013$export$c4af9125706c4d30(()=>({
            scrollX: 0,
            scrollY: 0,
            scrollXProgress: 0,
            scrollYProgress: 0,
            ...springOptions
        }), []);
    (0, $16ba30d4a13c00f2$export$700979bc83e7db82)(()=>{
        const cleanupScroll = (0, $16ba30d4a13c00f2$export$d4d89fd61e5416ee)(({ x: x, y: y })=>{
            api.start({
                scrollX: x.current,
                scrollXProgress: x.progress,
                scrollY: y.current,
                scrollYProgress: y.progress
            });
        }, {
            container: container?.current || void 0
        });
        return ()=>{
            /**
			* Stop the springs on unmount.
			*/ (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)(Object.values(scrollValues), (value)=>value.stop());
            cleanupScroll();
        };
    }, []);
    return scrollValues;
};
//#endregion
//#region src/hooks/useResize.ts
/**
* A small abstraction around the `useSpring` hook. It returns a `SpringValues` 
* object with the `width` and `height` of the element it's attached to & doesn't 
* necessarily have to be attached to the window, by passing a `container` you 
* can observe that element's size instead.
* 
```jsx
import { useResize, animated } from '@react-spring/web'

function MyComponent() {
const { width } = useResize()

return (
<animated.div style={{ width }}>
Hello World
</animated.div>
)
}
```
* 
* @param {UseResizeOptions} UseResizeOptions options for the useScroll hook.
* @param {MutableRefObject<HTMLElement>} UseResizeOptions.container the container to listen to scroll events on, defaults to the window.
*
* @returns {SpringValues<{width: number; height: number;}>} SpringValues the collection of values returned from the inner hook
*/ const $c52c96d382753013$export$e8b771555dc4a003 = ({ container: container, ...springOptions })=>{
    const [sizeValues, api] = $c52c96d382753013$export$c4af9125706c4d30(()=>({
            width: 0,
            height: 0,
            ...springOptions
        }), []);
    (0, $16ba30d4a13c00f2$export$700979bc83e7db82)(()=>{
        const cleanupScroll = (0, $16ba30d4a13c00f2$export$45b39e67d4ce4921)(({ width: width, height: height })=>{
            api.start({
                width: width,
                height: height,
                immediate: sizeValues.width.get() === 0 || sizeValues.height.get() === 0 || springOptions.immediate === true
            });
        }, {
            container: container?.current || void 0
        });
        return ()=>{
            /**
			* Stop the springs on unmount.
			*/ (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)(Object.values(sizeValues), (value)=>value.stop());
            cleanupScroll();
        };
    }, []);
    return sizeValues;
};
//#endregion
//#region src/hooks/useInView.ts
const $c52c96d382753013$var$defaultThresholdOptions = {
    any: 0,
    all: 1
};
function $c52c96d382753013$export$2f62ee6831462844(props, args) {
    const [isInView, setIsInView] = (0, $5E6i4.useState)(false);
    const ref = (0, $5E6i4.useRef)(void 0);
    const propsFn = (0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).fun(props) && props;
    const { to: to = {}, from: from = {}, ...restSpringProps } = propsFn ? propsFn() : {};
    const intersectionArguments = propsFn ? args : props;
    const [springs, api] = $c52c96d382753013$export$c4af9125706c4d30(()=>({
            from: from,
            ...restSpringProps
        }), []);
    (0, $16ba30d4a13c00f2$export$700979bc83e7db82)(()=>{
        const element = ref.current;
        const { root: root, once: once, amount: amount = "any", ...restArgs } = intersectionArguments ?? {};
        if (!element || once && isInView || typeof IntersectionObserver === "undefined") return;
        const activeIntersections = /* @__PURE__ */ new WeakMap();
        const onEnter = ()=>{
            if (to) api.start(to);
            setIsInView(true);
            const cleanup = ()=>{
                if (from) api.start(from);
                setIsInView(false);
            };
            return once ? void 0 : cleanup;
        };
        const handleIntersection = (entries)=>{
            entries.forEach((entry)=>{
                const onLeave = activeIntersections.get(entry.target);
                if (entry.isIntersecting === Boolean(onLeave)) return;
                if (entry.isIntersecting) {
                    const newOnLeave = onEnter();
                    if ((0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).fun(newOnLeave)) activeIntersections.set(entry.target, newOnLeave);
                    else observer.unobserve(entry.target);
                } else if (onLeave) {
                    onLeave();
                    activeIntersections.delete(entry.target);
                }
            });
        };
        const observer = new IntersectionObserver(handleIntersection, {
            root: root && root.current || void 0,
            threshold: typeof amount === "number" || Array.isArray(amount) ? amount : $c52c96d382753013$var$defaultThresholdOptions[amount],
            ...restArgs
        });
        observer.observe(element);
        return ()=>observer.unobserve(element);
    }, [
        intersectionArguments
    ]);
    if (propsFn) return [
        ref,
        springs
    ];
    return [
        ref,
        isInView
    ];
}
//#endregion
//#region src/components/Spring.tsx
function $c52c96d382753013$export$a500e5b516cedfc({ children: children, ...props }) {
    return children($c52c96d382753013$export$c4af9125706c4d30(props));
}
//#endregion
//#region src/components/Trail.tsx
function $c52c96d382753013$export$3b8b9d47fbf8fd2b({ items: items, children: children, ...props }) {
    const trails = $c52c96d382753013$export$250279104b4672ed(items.length, props);
    return items.map((item, index)=>{
        const result = children(item, index);
        return (0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).fun(result) ? result(trails[index]) : result;
    });
}
//#endregion
//#region src/components/Transition.tsx
function $c52c96d382753013$export$be58926105124dd4({ items: items, children: children, ...props }) {
    return $c52c96d382753013$export$7b286972b8d8ccbf(items, props)(children);
}
//#endregion
//#region src/Interpolation.ts
/**
* An `Interpolation` is a memoized value that's computed whenever one of its
* `FluidValue` dependencies has its value changed.
*
* Other `FrameValue` objects can depend on this. For example, passing an
* `Interpolation` as the `to` prop of a `useSpring` call will trigger an
* animation toward the memoized value.
*/ var $c52c96d382753013$export$b0cc4f9860136880 = class extends $c52c96d382753013$export$8229896f80e2495e {
    constructor(source, args){
        super();
        this.source = source;
        this.idle = true;
        this._active = /* @__PURE__ */ new Set();
        this.calc = (0, $16ba30d4a13c00f2$export$b12af43b97697ef5)(...args);
        const value = this._get();
        const nodeType = (0, $b2c49db26f0b3d2c$export$e6b77ddbe47b132e)(value);
        (0, $b2c49db26f0b3d2c$export$b553cb5b22b81b04)(this, nodeType.create(value));
    }
    advance(_dt) {
        const value = this._get();
        if (!(0, $16ba30d4a13c00f2$export$248d38f6296296c5)(value, this.get())) {
            (0, $b2c49db26f0b3d2c$export$6b63995194a3a9e4)(this).setValue(value);
            this._onChange(value, this.idle);
        }
        if (!this.idle && $c52c96d382753013$var$checkIdle(this._active)) $c52c96d382753013$var$becomeIdle(this);
    }
    _get() {
        const inputs = (0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).arr(this.source) ? this.source.map((0, $16ba30d4a13c00f2$export$e37b7520edd66839)) : (0, $16ba30d4a13c00f2$export$45b10814cc054894)((0, $16ba30d4a13c00f2$export$e37b7520edd66839)(this.source));
        return this.calc(...inputs);
    }
    _start() {
        if (this.idle && !$c52c96d382753013$var$checkIdle(this._active)) {
            this.idle = false;
            (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)((0, $b2c49db26f0b3d2c$export$ccab2b64c5d440)(this), (node)=>{
                node.done = false;
            });
            if ((0, $16ba30d4a13c00f2$export$cceeabf822b64fc0).skipAnimation) {
                (0, $7a0c7bd96c8bfe17$export$27f233d61a9e2fa4).batchedUpdates(()=>this.advance());
                $c52c96d382753013$var$becomeIdle(this);
            } else (0, $16ba30d4a13c00f2$export$a57f5080a3bcc90a).start(this);
        }
    }
    _attach() {
        let priority = 1;
        (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)((0, $16ba30d4a13c00f2$export$45b10814cc054894)(this.source), (source)=>{
            if ((0, $16ba30d4a13c00f2$export$57ea7e3a7f6280c7)(source)) (0, $16ba30d4a13c00f2$export$72d604e3f8d000a5)(source, this);
            if ($c52c96d382753013$var$isFrameValue(source)) {
                if (!source.idle) this._active.add(source);
                priority = Math.max(priority, source.priority + 1);
            }
        });
        this.priority = priority;
        this._start();
    }
    _detach() {
        (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)((0, $16ba30d4a13c00f2$export$45b10814cc054894)(this.source), (source)=>{
            if ((0, $16ba30d4a13c00f2$export$57ea7e3a7f6280c7)(source)) (0, $16ba30d4a13c00f2$export$7a0eb830d336339b)(source, this);
        });
        this._active.clear();
        $c52c96d382753013$var$becomeIdle(this);
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") {
            if (event.idle) this.advance();
            else {
                this._active.add(event.parent);
                this._start();
            }
        } else if (event.type == "idle") this._active.delete(event.parent);
        else if (event.type == "priority") this.priority = (0, $16ba30d4a13c00f2$export$45b10814cc054894)(this.source).reduce((highest, parent)=>Math.max(highest, ($c52c96d382753013$var$isFrameValue(parent) ? parent.priority : 0) + 1), 0);
    }
};
/** Returns true for an idle source. */ function $c52c96d382753013$var$isIdle(source) {
    return source.idle !== false;
}
/** Return true if all values in the given set are idle or paused. */ function $c52c96d382753013$var$checkIdle(active) {
    return !active.size || Array.from(active).every($c52c96d382753013$var$isIdle);
}
/** Become idle if not already idle. */ function $c52c96d382753013$var$becomeIdle(self) {
    if (!self.idle) {
        self.idle = true;
        (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)((0, $b2c49db26f0b3d2c$export$ccab2b64c5d440)(self), (node)=>{
            node.done = true;
        });
        (0, $16ba30d4a13c00f2$export$31752c40a5fab62a)(self, {
            type: "idle",
            parent: self
        });
    }
}
//#endregion
//#region src/interpolate.ts
/** Map the value of one or more dependencies */ const $c52c96d382753013$export$2c618a4308a30424 = (source, ...args)=>new $c52c96d382753013$export$b0cc4f9860136880(source, args);
/** @deprecated Use the `to` export instead */ const $c52c96d382753013$export$89e29e4ab65e70a9 = (source, ...args)=>((0, $16ba30d4a13c00f2$export$2abfcde8ae218ba8)(), new $c52c96d382753013$export$b0cc4f9860136880(source, args));
//#endregion
//#region src/globals.ts
(0, $16ba30d4a13c00f2$export$cceeabf822b64fc0).assign({
    createStringInterpolator: $16ba30d4a13c00f2$export$4759a013d387347a,
    to: (source, args)=>new $c52c96d382753013$export$b0cc4f9860136880(source, args)
});
/** Advance all animations by the given time */ const $c52c96d382753013$export$722fbec263ad908a = (0, $16ba30d4a13c00f2$export$a57f5080a3bcc90a).advance;



var $ibUU1 = parcelRequire("ibUU1");


//#region src/applyAnimatedValues.ts
const $40932a561d468393$var$isCustomPropRE = /^--/;
function $40932a561d468393$var$dangerousStyleValue(name, value) {
    if (value == null || typeof value === "boolean" || value === "") return "";
    if (typeof value === "number" && value !== 0 && !$40932a561d468393$var$isCustomPropRE.test(name) && !($40932a561d468393$var$isUnitlessNumber.hasOwnProperty(name) && $40932a561d468393$var$isUnitlessNumber[name])) return value + "px";
    return ("" + value).trim();
}
const $40932a561d468393$var$attributeCache = {};
function $40932a561d468393$var$applyAnimatedValues(instance, props) {
    if (!instance.nodeType || !instance.setAttribute || !instance.removeAttribute) return false;
    const isFilterElement = instance.nodeName === "filter" || instance.parentNode && instance.parentNode.nodeName === "filter";
    const { className: className, style: style, children: children, scrollTop: scrollTop, scrollLeft: scrollLeft, viewBox: viewBox, ...attributes } = props;
    const values = Object.values(attributes);
    const names = Object.keys(attributes).map((name)=>isFilterElement || instance.hasAttribute(name) ? name : $40932a561d468393$var$attributeCache[name] || ($40932a561d468393$var$attributeCache[name] = name.replace(/([A-Z])/g, (n)=>"-" + n.toLowerCase())));
    if (props.hasOwnProperty("children")) instance.textContent = children;
    for(const name in style)if (style.hasOwnProperty(name)) {
        const value = $40932a561d468393$var$dangerousStyleValue(name, style[name]);
        if ($40932a561d468393$var$isCustomPropRE.test(name)) instance.style.setProperty(name, value);
        else instance.style[name] = value;
    }
    names.forEach((name, i)=>{
        const value = values[i];
        if (value !== void 0) instance.setAttribute(name, value);
        else instance.removeAttribute(name);
    });
    if (props.hasOwnProperty("className")) {
        if (className !== void 0) instance.className = className;
        else instance.removeAttribute("class");
    }
    if (scrollTop !== void 0) instance.scrollTop = scrollTop;
    if (scrollLeft !== void 0) instance.scrollLeft = scrollLeft;
    if (props.hasOwnProperty("viewBox")) {
        if (viewBox !== void 0) instance.setAttribute("viewBox", viewBox);
        else instance.removeAttribute("viewBox");
    }
}
let $40932a561d468393$var$isUnitlessNumber = {
    animationIterationCount: true,
    borderImageOutset: true,
    borderImageSlice: true,
    borderImageWidth: true,
    boxFlex: true,
    boxFlexGroup: true,
    boxOrdinalGroup: true,
    columnCount: true,
    columns: true,
    flex: true,
    flexGrow: true,
    flexPositive: true,
    flexShrink: true,
    flexNegative: true,
    flexOrder: true,
    gridRow: true,
    gridRowEnd: true,
    gridRowSpan: true,
    gridRowStart: true,
    gridColumn: true,
    gridColumnEnd: true,
    gridColumnSpan: true,
    gridColumnStart: true,
    fontWeight: true,
    lineClamp: true,
    lineHeight: true,
    opacity: true,
    order: true,
    orphans: true,
    tabSize: true,
    widows: true,
    zIndex: true,
    zoom: true,
    fillOpacity: true,
    floodOpacity: true,
    stopOpacity: true,
    strokeDasharray: true,
    strokeDashoffset: true,
    strokeMiterlimit: true,
    strokeOpacity: true,
    strokeWidth: true
};
const $40932a561d468393$var$prefixKey = (prefix, key)=>prefix + key.charAt(0).toUpperCase() + key.substring(1);
const $40932a561d468393$var$prefixes = [
    "Webkit",
    "Ms",
    "Moz",
    "O"
];
$40932a561d468393$var$isUnitlessNumber = Object.keys($40932a561d468393$var$isUnitlessNumber).reduce((acc, prop)=>{
    $40932a561d468393$var$prefixes.forEach((prefix)=>acc[$40932a561d468393$var$prefixKey(prefix, prop)] = acc[prop]);
    return acc;
}, $40932a561d468393$var$isUnitlessNumber);
//#endregion
//#region src/AnimatedStyle.ts
/** The transform-functions
* (https://developer.mozilla.org/fr/docs/Web/CSS/transform-function)
* that you can pass as keys to your animated component style and that will be
* animated. Perspective has been left out as it would conflict with the
* non-transform perspective style.
*/ const $40932a561d468393$var$domTransforms = /^(matrix3d|matrix|translate3d|translate[XYZ]?|scale3d|scale[XYZ]?|rotate3d|rotate[XYZ]?|skew[XY]?)$/;
const $40932a561d468393$var$pxTransforms = /^(translate)/;
const $40932a561d468393$var$degTransforms = /^(rotate|skew)/;
/** Add a unit to the value when the value is unit-less (eg: a number) */ const $40932a561d468393$var$addUnit = (value, unit)=>(0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).num(value) && value !== 0 ? value + unit : value;
/**
* Checks if the input value matches the identity value.
*
*     isValueIdentity(0, 0)              // => true
*     isValueIdentity('0px', 0)          // => true
*     isValueIdentity([0, '0px', 0], 0)  // => true
*/ const $40932a561d468393$var$isValueIdentity = (value, id)=>(0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).arr(value) ? value.every((v)=>$40932a561d468393$var$isValueIdentity(v, id)) : (0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).num(value) ? value === id : parseFloat(value) === id;
/**
* This AnimatedStyle will simplify animated components transforms by
* interpolating all transform function passed as keys in the style object
* including shortcuts such as x, y and z for translateX/Y/Z
*/ var $40932a561d468393$var$AnimatedStyle = class extends (0, $b2c49db26f0b3d2c$export$f1b0b9e366a6e2d4) {
    constructor({ x: x, y: y, z: z, ...style }){
        /**
		* An array of arrays that contains the values (static or fluid)
		* used by each transform function.
		*/ const inputs = [];
        /**
		* An array of functions that take a list of values (static or fluid)
		* and returns (1) a CSS transform string and (2) a boolean that's true
		* when the transform has no effect (eg: an identity transform).
		*/ const transforms = [];
        if (x || y || z) {
            inputs.push([
                x || 0,
                y || 0,
                z || 0
            ]);
            transforms.push((xyz)=>[
                    `translate3d(${xyz.map((v)=>$40932a561d468393$var$addUnit(v, "px")).join(",")})`,
                    $40932a561d468393$var$isValueIdentity(xyz, 0)
                ]);
        }
        (0, $16ba30d4a13c00f2$export$f4c6fe153f5a944e)(style, (value, key)=>{
            if (key === "transform") {
                inputs.push([
                    value || ""
                ]);
                transforms.push((transform)=>[
                        transform,
                        transform === ""
                    ]);
            } else if ($40932a561d468393$var$domTransforms.test(key)) {
                delete style[key];
                if ((0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).und(value)) return;
                const unit = $40932a561d468393$var$pxTransforms.test(key) ? "px" : $40932a561d468393$var$degTransforms.test(key) ? "deg" : "";
                inputs.push((0, $16ba30d4a13c00f2$export$45b10814cc054894)(value));
                transforms.push(key === "rotate3d" ? ([x, y, z, deg])=>[
                        `rotate3d(${x},${y},${z},${$40932a561d468393$var$addUnit(deg, unit)})`,
                        $40932a561d468393$var$isValueIdentity(deg, 0)
                    ] : (input)=>[
                        `${key}(${input.map((v)=>$40932a561d468393$var$addUnit(v, unit)).join(",")})`,
                        $40932a561d468393$var$isValueIdentity(input, key.startsWith("scale") ? 1 : 0)
                    ]);
            }
        });
        if (inputs.length) style.transform = new $40932a561d468393$var$FluidTransform(inputs, transforms);
        super(style);
    }
};
/** @internal */ var $40932a561d468393$var$FluidTransform = class extends (0, $16ba30d4a13c00f2$export$aff8e1ac1a016a2) {
    constructor(inputs, transforms){
        super();
        this.inputs = inputs;
        this.transforms = transforms;
        this._value = null;
    }
    get() {
        return this._value || (this._value = this._get());
    }
    _get() {
        let transform = "";
        let identity = true;
        (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)(this.inputs, (input, i)=>{
            const arg1 = (0, $16ba30d4a13c00f2$export$e37b7520edd66839)(input[0]);
            const [t, id] = this.transforms[i]((0, $16ba30d4a13c00f2$export$226b3eccf92c9ed9).arr(arg1) ? arg1 : input.map((0, $16ba30d4a13c00f2$export$e37b7520edd66839)));
            transform += " " + t;
            identity = identity && id;
        });
        return identity ? "none" : transform;
    }
    observerAdded(count) {
        if (count == 1) (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)(this.inputs, (input)=>(0, $16ba30d4a13c00f2$export$79b2f7037acddd43)(input, (value)=>(0, $16ba30d4a13c00f2$export$57ea7e3a7f6280c7)(value) && (0, $16ba30d4a13c00f2$export$72d604e3f8d000a5)(value, this)));
    }
    observerRemoved(count) {
        if (count == 0) (0, $16ba30d4a13c00f2$export$79b2f7037acddd43)(this.inputs, (input)=>(0, $16ba30d4a13c00f2$export$79b2f7037acddd43)(input, (value)=>(0, $16ba30d4a13c00f2$export$57ea7e3a7f6280c7)(value) && (0, $16ba30d4a13c00f2$export$7a0eb830d336339b)(value, this)));
    }
    eventObserved(event) {
        if (event.type == "change") this._value = null;
        (0, $16ba30d4a13c00f2$export$31752c40a5fab62a)(this, event);
    }
};
//#endregion
//#region src/primitives.ts
const $40932a561d468393$var$primitives = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
//#endregion
//#region src/index.ts
(0, $16ba30d4a13c00f2$export$cceeabf822b64fc0).assign({
    batchedUpdates: (0, $ibUU1.unstable_batchedUpdates),
    createStringInterpolator: $16ba30d4a13c00f2$export$4759a013d387347a,
    colors: $16ba30d4a13c00f2$export$8f45430ccf837300
});
const $40932a561d468393$var$host = (0, $b2c49db26f0b3d2c$export$4ee5c78f6dcbcef)($40932a561d468393$var$primitives, {
    applyAnimatedValues: $40932a561d468393$var$applyAnimatedValues,
    createAnimatedStyle: (style)=>new $40932a561d468393$var$AnimatedStyle(style),
    getComponentProps: ({ scrollTop: scrollTop, scrollLeft: scrollLeft, ...props })=>props
});
const $40932a561d468393$export$407448d2b89b1813 = $40932a561d468393$var$host.animated;





function $e6ffad519da57951$var$BaseAnimatedAnnotation(_ref) {
    let { x: x = 0, y: y = 0, AnnotationComponent: AnnotationComponent, ...props } = _ref;
    const lastXY = (0, $5E6i4.useRef)({
        x: x,
        y: y
    });
    // in order to keep x/y/dx/dy accurate in AnnotationComponent, animate the delta
    // between positions, to an x + y transform of zero from the previous value
    const animatedXY = (0, $c52c96d382753013$export$c4af9125706c4d30)({
        from: {
            x: lastXY.current.x - x,
            y: lastXY.current.y - y
        },
        to: {
            x: 0,
            y: 0
        },
        reset: true
    });
    (0, $5E6i4.useEffect)(()=>{
        lastXY.current = {
            x: x,
            y: y
        };
    }, [
        x,
        y
    ]);
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $40932a561d468393$export$407448d2b89b1813).g, {
        // for perf animate a group element not the Annotation itself
        transform: (0, $c52c96d382753013$export$2c618a4308a30424)([
            animatedXY.x,
            animatedXY.y
        ], (xVal, yVal)=>`translate(${xVal}, ${yVal})`),
        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(AnnotationComponent, {
            x: x,
            y: y,
            ...props
        })
    });
}
function $e6ffad519da57951$export$2e2bcd8739ae039(_ref2) {
    let { editable: editable, ...props } = _ref2;
    const AnnotationComponent = (0, $5E6i4.useCallback)((annotationProps)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($e6ffad519da57951$var$BaseAnimatedAnnotation, {
            AnnotationComponent: editable ? (0, $b0f54f19bbad2881$export$2e2bcd8739ae039) : (0, $66e1399a00a9dd25$export$2e2bcd8739ae039),
            ...annotationProps
        }), [
        editable
    ]);
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $c5c94b524879e8fb$export$2e2bcd8739ae039), {
        AnnotationComponent: AnnotationComponent,
        ...props
    });
}



var $5E6i4 = parcelRequire("5E6i4");



const $14cf8b3f3ccc2841$var$defaultBackgroundProps = {
    fillOpacity: 0.7
};
function $14cf8b3f3ccc2841$export$2e2bcd8739ae039(props) {
    const { theme: theme, resizeObserverPolyfill: resizeObserverPolyfill } = (0, $5E6i4.useContext)((0, $89eeb2e4952e291d$export$2e2bcd8739ae039));
    const titleProps = theme?.svgLabelBig;
    const subtitleProps = theme?.svgLabelSmall;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $745d31e6a5f1a5e9$export$2e2bcd8739ae039), {
        anchorLineStroke: theme?.axisStyles.x.bottom.axisLine.stroke,
        backgroundFill: theme?.backgroundColor,
        backgroundProps: $14cf8b3f3ccc2841$var$defaultBackgroundProps,
        showAnchorLine: true,
        subtitleFontSize: subtitleProps?.fontSize,
        subtitleFontWeight: subtitleProps?.fontWeight,
        subtitleProps: subtitleProps,
        titleFontSize: titleProps?.fontSize,
        titleFontWeight: titleProps?.fontWeight,
        titleProps: titleProps,
        resizeObserverPolyfill: resizeObserverPolyfill,
        ...props
    });
}



var $5E6i4 = parcelRequire("5E6i4");



function $04cbb27c073cd3e4$export$2e2bcd8739ae039(props) {
    const { theme: theme } = (0, $5E6i4.useContext)((0, $89eeb2e4952e291d$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $8e4cb0f381c19383$export$2e2bcd8739ae039), {
        stroke: theme?.axisStyles.x.bottom.axisLine.stroke,
        ...props
    });
}



var $5E6i4 = parcelRequire("5E6i4");



function $058af26bcd7f0c1e$export$2e2bcd8739ae039(props) {
    const { theme: theme } = (0, $5E6i4.useContext)((0, $89eeb2e4952e291d$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $a18816b548e9bea1$export$2e2bcd8739ae039), {
        stroke: theme?.axisStyles.x.bottom.axisLine.stroke,
        ...props
    });
}



var $5E6i4 = parcelRequire("5E6i4");



function $6402c11d2184b496$export$2e2bcd8739ae039(_ref) {
    let { min: min, max: max, ...props } = _ref;
    const { theme: theme, margin: margin, innerHeight: innerHeight = 0, innerWidth: innerWidth = 0 } = (0, $5E6i4.useContext)((0, $89eeb2e4952e291d$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $55a74deae7198147$export$2e2bcd8739ae039), {
        stroke: theme?.axisStyles.x.bottom.axisLine.stroke,
        min: min ?? (props.orientation === 'horizontal' ? margin?.left : margin?.top) ?? 0,
        max: max ?? (props.orientation === 'horizontal' ? (margin?.left ?? 0) + innerWidth : (margin?.top ?? 0) + innerHeight),
        ...props
    });
}


// @visx/react-spring





var $5E6i4 = parcelRequire("5E6i4");

function $20d6a12102a6540f$var$animatedValue(animationTrajectory, positionOnScale, scaleMin, scaleMax, scaleHalfwayPoint) {
    switch(animationTrajectory){
        case 'center':
            return scaleHalfwayPoint;
        case 'min':
            return scaleMin ?? 0;
        case 'max':
            return scaleMax ?? 0;
        case 'outside':
        default:
            return ((positionOnScale ?? 0) < scaleHalfwayPoint ? scaleMin : scaleMax) ?? 0;
    }
}
function $20d6a12102a6540f$var$enterUpdate(_ref) {
    let { from: from, to: to } = _ref;
    return {
        fromX: from.x,
        toX: to.x,
        fromY: from.y,
        toY: to.y,
        opacity: 1
    };
}
function $20d6a12102a6540f$export$2e2bcd8739ae039(_ref2) {
    let { scale: scale, animateXOrY: animateXOrY, animationTrajectory: initAnimationTrajectory = 'outside' } = _ref2;
    const shouldAnimateX = animateXOrY === 'x';
    return (0, $5E6i4.useMemo)(()=>{
        const [a, b] = scale.range().map((0, $c32ed8852dffe2f4$export$2e2bcd8739ae039));
        const isDescending = b != null && a != null && b < a;
        const [scaleMin, scaleMax] = isDescending ? [
            b,
            a
        ] : [
            a,
            b
        ];
        const scaleLength = b != null && a != null ? Math.abs(b - a) : 0;
        const scaleHalfwayPoint = (scaleMin ?? 0) + scaleLength / 2;
        let animationTrajectory = initAnimationTrajectory;
        // correct direction for y-axis which is inverted due to svg coords
        if (!shouldAnimateX && initAnimationTrajectory === 'min') animationTrajectory = 'max';
        if (!shouldAnimateX && initAnimationTrajectory === 'max') animationTrajectory = 'min';
        const fromLeave = (_ref3)=>{
            let { from: from, to: to } = _ref3;
            return {
                fromX: shouldAnimateX ? $20d6a12102a6540f$var$animatedValue(animationTrajectory, from.x, scaleMin, scaleMax, scaleHalfwayPoint) : from.x,
                toX: shouldAnimateX ? $20d6a12102a6540f$var$animatedValue(animationTrajectory, from.x, scaleMin, scaleMax, scaleHalfwayPoint) : to.x,
                fromY: shouldAnimateX ? from.y : $20d6a12102a6540f$var$animatedValue(animationTrajectory, from.y, scaleMin, scaleMax, scaleHalfwayPoint),
                toY: shouldAnimateX ? to.y : $20d6a12102a6540f$var$animatedValue(animationTrajectory, from.y, scaleMin, scaleMax, scaleHalfwayPoint),
                opacity: 0
            };
        };
        return {
            from: fromLeave,
            leave: fromLeave,
            enter: $20d6a12102a6540f$var$enterUpdate,
            update: $20d6a12102a6540f$var$enterUpdate
        };
    }, [
        scale,
        shouldAnimateX,
        initAnimationTrajectory
    ]);
}



function $e1f55dadf3943159$export$2e2bcd8739ae039(_ref) {
    let { hideTicks: hideTicks, horizontal: horizontal, orientation: orientation, scale: scale, tickClassName: tickClassName, tickComponent: tickComponent, tickLabelProps: allTickLabelProps, tickStroke: tickStroke = '#222', tickTransform: tickTransform, ticks: ticks, tickLineProps: tickLineProps, animationTrajectory: animationTrajectory } = _ref;
    const animatedTicks = (0, $c52c96d382753013$export$7b286972b8d8ccbf)(ticks, {
        ...(0, $20d6a12102a6540f$export$2e2bcd8739ae039)({
            scale: scale,
            animateXOrY: horizontal ? 'x' : 'y',
            animationTrajectory: animationTrajectory
        }),
        keys: (tick)=>`tick-${tick.value}-${tick.index}`
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: animatedTicks((_ref2, item, _ref3, index)=>{
            let { fromX: fromX, toX: toX, fromY: fromY, toY: toY, opacity: opacity } = _ref2;
            let { key: key } = _ref3;
            const tickLabelProps = allTickLabelProps[index] ?? allTickLabelProps[0] ?? {};
            return item == null || key == null ? null : /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)((0, $40932a561d468393$export$407448d2b89b1813).g, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('visx-axis-tick', tickClassName),
                transform: tickTransform,
                children: [
                    !hideTicks && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $40932a561d468393$export$407448d2b89b1813).line, {
                        x1: fromX,
                        x2: toX,
                        y1: fromY,
                        y2: toY,
                        stroke: tickStroke,
                        strokeLinecap: "square",
                        strokeOpacity: opacity,
                        ...tickLineProps
                    }),
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $40932a561d468393$export$407448d2b89b1813).g, {
                        transform: (0, $c52c96d382753013$export$2c618a4308a30424)([
                            toX,
                            toY
                        ], (interpolatedX, interpolatedY)=>`translate(${interpolatedX},${interpolatedY + (orientation === (0, $660e4a853e3f2665$export$2e2bcd8739ae039).bottom && typeof tickLabelProps.fontSize === 'number' ? tickLabelProps.fontSize ?? 10 : 0)})`),
                        opacity: opacity,
                        children: tickComponent ? tickComponent({
                            ...tickLabelProps,
                            x: toX,
                            y: toY,
                            formattedValue: item?.formattedValue
                        }) : /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $6f18bc0a5cbf18e6$export$2e2bcd8739ae039), {
                            ...tickLabelProps,
                            children: item?.formattedValue
                        })
                    }, index)
                ]
            }, key);
        })
    });
}



var $5E6i4 = parcelRequire("5E6i4");



function $54096842dd2b3f3a$export$2e2bcd8739ae039(_ref) {
    let { animationTrajectory: animationTrajectory, tickComponent: tickComponent, ...axisProps } = _ref;
    // wrap the ticksComponent so we can pass animationTrajectory
    const ticksComponent = (0, $5E6i4.useMemo)(()=>// eslint-disable-next-line react/no-unstable-nested-components
        function TicksComponent(ticks) {
            return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $e1f55dadf3943159$export$2e2bcd8739ae039), {
                ...ticks,
                tickComponent: tickComponent,
                animationTrajectory: animationTrajectory
            });
        }, [
        animationTrajectory,
        tickComponent
    ]);
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $6b3475a108831342$export$2e2bcd8739ae039), {
        ...axisProps,
        ticksComponent: ticksComponent
    });
}






function $840fde9bba97c5be$export$2e2bcd8739ae039(_ref) {
    let { scale: scale, lines: lines, animationTrajectory: animationTrajectory, animateXOrY: animateXOrY, lineKey: lineKey, lineStyle: lineStyle, ...lineProps } = _ref;
    const animatedLines = (0, $c52c96d382753013$export$7b286972b8d8ccbf)(lines, {
        ...(0, $20d6a12102a6540f$export$2e2bcd8739ae039)({
            scale: scale,
            animateXOrY: animateXOrY,
            animationTrajectory: animationTrajectory
        }),
        key: lineKey
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: animatedLines((_ref2, _, _ref3)=>{
            let { fromX: fromX, toX: toX, fromY: fromY, toY: toY, opacity: opacity } = _ref2;
            let { key: key } = _ref3;
            return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $40932a561d468393$export$407448d2b89b1813).line, {
                x1: fromX,
                x2: toX,
                y1: fromY,
                y2: toY,
                strokeOpacity: opacity,
                style: lineStyle,
                ...lineProps
            }, key);
        })
    });
}



function $a864cc2e4891856d$export$2e2bcd8739ae039(_ref) {
    let { scale: scale, width: width, numTicks: numTicks, tickValues: tickValues, offset: offset, className: className, animationTrajectory: animationTrajectory, top: top, left: left, ...lineProps } = _ref;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $2113d7ba46a62464$export$2e2bcd8739ae039), {
        scale: scale,
        width: width,
        numTicks: numTicks,
        tickValues: tickValues,
        className: className,
        top: top,
        left: left,
        offset: offset,
        children: (_ref2)=>{
            let { lines: lines } = _ref2;
            return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $840fde9bba97c5be$export$2e2bcd8739ae039), {
                scale: scale,
                lines: lines,
                animationTrajectory: animationTrajectory,
                animateXOrY: "y",
                lineKey: (line)=>`row-${line?.from?.y ?? ''}-${line.index}`,
                ...lineProps
            });
        }
    });
}





function $f1e318715e5af301$export$2e2bcd8739ae039(_ref) {
    let { scale: scale, height: height, numTicks: numTicks, tickValues: tickValues, offset: offset, className: className, animationTrajectory: animationTrajectory, top: top, left: left, ...lineProps } = _ref;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $4b74c05c432587fa$export$2e2bcd8739ae039), {
        scale: scale,
        height: height,
        numTicks: numTicks,
        tickValues: tickValues,
        className: className,
        offset: offset,
        top: top,
        left: left,
        children: (_ref2)=>{
            let { lines: lines } = _ref2;
            return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $840fde9bba97c5be$export$2e2bcd8739ae039), {
                scale: scale,
                lines: lines,
                animationTrajectory: animationTrajectory,
                animateXOrY: "x",
                lineKey: (line)=>`column-${line?.from?.x ?? ''}-${line.index}`,
                ...lineProps
            });
        }
    });
}





var $5E6i4 = parcelRequire("5E6i4");


function $b219b1dae135c38d$export$2e2bcd8739ae039(_ref) {
    let { AxisComponent: AxisComponent, ...props } = _ref;
    const { theme: theme, xScale: xScale, yScale: yScale, margin: margin, width: width, height: height, dataRegistry: dataRegistry } = (0, $5E6i4.useContext)((0, $89eeb2e4952e291d$export$2e2bcd8739ae039));
    const { orientation: orientation } = props;
    const axisStyles = (0, $5E6i4.useMemo)(()=>orientation === 'left' || orientation === 'right' ? theme?.axisStyles?.y?.[orientation] : theme?.axisStyles?.x?.[orientation], [
        theme,
        orientation
    ]);
    const maybeTickLabelProps = props.tickLabelProps;
    const tickLabelProps = (0, $5E6i4.useMemo)(()=>maybeTickLabelProps || axisStyles // construct from props + theme if possible
         ? (value, index, values)=>// by default, wrap vertical-axis tick labels within the allotted margin space
            // this does not currently account for axis label
            ({
                ...axisStyles?.tickLabel,
                width: orientation === 'left' || orientation === 'right' ? margin?.[orientation] : undefined,
                ...typeof maybeTickLabelProps === 'function' ? maybeTickLabelProps(value, index, values) : maybeTickLabelProps
            }) : undefined, [
        maybeTickLabelProps,
        axisStyles,
        orientation,
        margin
    ]);
    const topOffset = orientation === 'bottom' ? (height ?? 0) - (margin?.bottom ?? 0) : orientation === 'top' ? margin?.top ?? 0 : 0;
    const leftOffset = orientation === 'left' ? margin?.left ?? 0 : orientation === 'right' ? (width ?? 0) - (margin?.right ?? 0) : 0;
    const scale = orientation === 'left' || orientation === 'right' ? yScale : xScale;
    // Don't render axis until data is registered with non-empty data, otherwise the
    // fallback scaleLinear() with domain [0,1] will cause tickFormat to receive
    // incorrect intermediate values.
    const hasRegisteredData = dataRegistry?.entries().some((entry)=>entry.data.length > 0) ?? false;
    return scale && hasRegisteredData ? /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(AxisComponent, {
        top: topOffset,
        left: leftOffset,
        labelProps: axisStyles?.axisLabel,
        stroke: axisStyles?.axisLine?.stroke,
        strokeWidth: axisStyles?.axisLine?.strokeWidth,
        tickLength: axisStyles?.tickLength,
        tickStroke: axisStyles?.tickLine?.stroke,
        ...props,
        tickLabelProps: tickLabelProps,
        scale: scale
    }) : null;
}



function $c46627bce80be242$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $b219b1dae135c38d$export$2e2bcd8739ae039), {
        AxisComponent: (0, $54096842dd2b3f3a$export$2e2bcd8739ae039),
        ...props
    });
}


/* eslint-disable react/no-unstable-nested-components */ 
var $5E6i4 = parcelRequire("5E6i4");


var $5E6i4 = parcelRequire("5E6i4");


function $a6258636011bb81d$export$2e2bcd8739ae039(_ref) {
    let { rows: rows = true, columns: columns = true, GridRowsComponent: GridRowsComponent, GridColumnsComponent: GridColumnsComponent, ...props } = _ref;
    const { theme: theme, xScale: columnsScale, yScale: rowsScale, margin: margin, innerWidth: innerWidth, innerHeight: innerHeight } = (0, $5E6i4.useContext)((0, $89eeb2e4952e291d$export$2e2bcd8739ae039));
    const gridLineStyles = theme?.gridStyles;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)((0, $90cae257cc958273$exports.Fragment), {
        children: [
            rows && rowsScale && innerWidth != null && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(GridRowsComponent, {
                left: margin?.left,
                lineStyle: gridLineStyles,
                width: innerWidth,
                scale: rowsScale,
                ...props
            }),
            columns && columnsScale && innerHeight != null && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(GridColumnsComponent, {
                top: margin?.top,
                lineStyle: gridLineStyles,
                height: innerHeight,
                scale: columnsScale,
                ...props
            })
        ]
    });
}



function $d54ef70dbd020ed0$export$2e2bcd8739ae039(_ref) {
    let { animationTrajectory: animationTrajectory, ...props } = _ref;
    const RowsComponent = (0, $5E6i4.useMemo)(()=>function RowsFC(rowProps) {
            return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $a864cc2e4891856d$export$2e2bcd8739ae039), {
                ...rowProps,
                animationTrajectory: animationTrajectory
            });
        }, [
        animationTrajectory
    ]);
    const ColumnsComponent = (0, $5E6i4.useMemo)(()=>function ColumnsFC(rowProps) {
            return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $f1e318715e5af301$export$2e2bcd8739ae039), {
                ...rowProps,
                animationTrajectory: animationTrajectory
            });
        }, [
        animationTrajectory
    ]);
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $a6258636011bb81d$export$2e2bcd8739ae039), {
        GridRowsComponent: RowsComponent,
        GridColumnsComponent: ColumnsComponent,
        ...props
    });
}





function $2c896f0e083a07dd$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $b219b1dae135c38d$export$2e2bcd8739ae039), {
        AxisComponent: (0, $6b3475a108831342$export$2e2bcd8739ae039),
        ...props
    });
}





function $12b754a41732799c$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $a6258636011bb81d$export$2e2bcd8739ae039), {
        GridRowsComponent: (0, $2113d7ba46a62464$export$2e2bcd8739ae039),
        GridColumnsComponent: (0, $4b74c05c432587fa$export$2e2bcd8739ae039),
        ...props
    });
}



var $5E6i4 = parcelRequire("5E6i4");

/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $5E6i4 = parcelRequire("5E6i4");
const $7b4c170e6fbbacb9$var$TooltipContext = /*#__PURE__*/ (0, $5E6i4.createContext)(null);
var $7b4c170e6fbbacb9$export$2e2bcd8739ae039 = $7b4c170e6fbbacb9$var$TooltipContext;






/** fontSize + lineHeight from default styles break precise location of crosshair, etc. */ const $25fb68fd052b1b05$var$TOOLTIP_NO_STYLE = {
    position: 'absolute',
    pointerEvents: 'none',
    fontSize: 0,
    lineHeight: 0
};
const $25fb68fd052b1b05$var$INVISIBLE_STYLES = {
    position: 'absolute',
    left: 0,
    top: 0,
    opacity: 0,
    width: 0,
    height: 0,
    pointerEvents: 'none'
};
function $25fb68fd052b1b05$var$DefaultGlyph(_ref) {
    let { x: x, y: y, size: size, color: color, glyphStyle: glyphStyle } = _ref;
    const { theme: theme } = (0, $5E6i4.useContext)((0, $89eeb2e4952e291d$export$2e2bcd8739ae039)) || {};
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("circle", {
        cx: x,
        cy: y,
        r: size,
        fill: color,
        stroke: theme?.backgroundColor,
        strokeWidth: 1.5,
        paintOrder: "fill",
        ...glyphStyle
    });
}
function $25fb68fd052b1b05$var$defaultRenderGlyph(_ref2) {
    let { key: key, ...props } = _ref2;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($25fb68fd052b1b05$var$DefaultGlyph, {
        ...props
    });
}
function $25fb68fd052b1b05$var$TooltipInner(_ref3) {
    let { debounce: debounce, detectBounds: detectBounds, horizontalCrosshairStyle: horizontalCrosshairStyle, glyphStyle: glyphStyle, renderTooltip: renderTooltip, renderGlyph: renderGlyph = $25fb68fd052b1b05$var$defaultRenderGlyph, resizeObserverPolyfill: resizeObserverPolyfillProp, scroll: scroll = true, showDatumGlyph: showDatumGlyph = false, showHorizontalCrosshair: showHorizontalCrosshair = false, showSeriesGlyphs: showSeriesGlyphs = false, showVerticalCrosshair: showVerticalCrosshair = false, snapTooltipToDatumX: snapTooltipToDatumX = false, snapTooltipToDatumY: snapTooltipToDatumY = false, verticalCrosshairStyle: verticalCrosshairStyle, zIndex: zIndex, ...tooltipProps } = _ref3;
    const { colorScale: colorScale, theme: theme, innerHeight: innerHeight, innerWidth: innerWidth, margin: margin, xScale: xScale, yScale: yScale, dataRegistry: dataRegistry, resizeObserverPolyfill: resizeObserverPolyfill } = (0, $5E6i4.useContext)((0, $89eeb2e4952e291d$export$2e2bcd8739ae039)) || {};
    const tooltipContext = (0, $5E6i4.useContext)((0, $7b4c170e6fbbacb9$export$2e2bcd8739ae039));
    const { containerRef: containerRef, TooltipInPortal: TooltipInPortal, forceRefreshBounds: forceRefreshBounds } = (0, $e3512a662e2d715f$export$2e2bcd8739ae039)({
        debounce: debounce,
        detectBounds: detectBounds,
        polyfill: resizeObserverPolyfill || resizeObserverPolyfillProp,
        scroll: scroll,
        zIndex: zIndex
    });
    // To correctly position itself in a Portal, the tooltip must know its container bounds
    // this is done by rendering an invisible node whose ref can be used to find its parentElement
    const setContainerRef = (0, $5E6i4.useCallback)((ownRef)=>{
        containerRef(ownRef?.parentElement ?? null);
    }, [
        containerRef
    ]);
    const tooltipContent = tooltipContext?.tooltipOpen ? renderTooltip({
        ...tooltipContext,
        colorScale: colorScale
    }) : null;
    const showTooltip = tooltipContext?.tooltipOpen && tooltipContent != null;
    // useTooltipInPortal is powered by react-use-measure and will update portal positions upon
    // resize and page scroll. however it **cannot** detect when a chart container moves on a
    // page due to animation or drag-and-drop, etc.
    // therefore we force refresh the bounds any time we transition from a hidden tooltip to
    // one that is visible.
    const lastShowTooltip = (0, $5E6i4.useRef)(false);
    (0, $5E6i4.useEffect)(()=>{
        if (showTooltip && !lastShowTooltip.current) forceRefreshBounds();
        lastShowTooltip.current = showTooltip;
    }, [
        showTooltip,
        forceRefreshBounds
    ]);
    let tooltipLeft = tooltipContext?.tooltipLeft;
    let tooltipTop = tooltipContext?.tooltipTop;
    const xScaleBandwidth = xScale ? (0, $db2a599b5b32ff26$export$2e2bcd8739ae039)(xScale) : 0;
    const yScaleBandwidth = yScale ? (0, $db2a599b5b32ff26$export$2e2bcd8739ae039)(yScale) : 0;
    const getDatumLeftTop = (0, $5E6i4.useCallback)((key, datum)=>{
        const entry = dataRegistry?.get(key);
        const xAccessor = entry?.xAccessor;
        const yAccessor = entry?.yAccessor;
        const left = xScale && xAccessor ? Number(xScale(xAccessor(datum))) + xScaleBandwidth / 2 : undefined;
        const top = yScale && yAccessor ? Number(yScale(yAccessor(datum))) + yScaleBandwidth / 2 : undefined;
        return {
            left: left,
            top: top
        };
    }, [
        dataRegistry,
        xScaleBandwidth,
        yScaleBandwidth,
        xScale,
        yScale
    ]);
    const nearestDatum = tooltipContext?.tooltipData?.nearestDatum;
    const nearestDatumKey = nearestDatum?.key ?? '';
    // snap x- or y-coord to the actual data point (not event coordinates)
    if (showTooltip && nearestDatum && (snapTooltipToDatumX || snapTooltipToDatumY)) {
        const { left: left, top: top } = getDatumLeftTop(nearestDatumKey, nearestDatum.datum);
        tooltipLeft = snapTooltipToDatumX && (0, $0e64952a2d1e8b9b$export$2e2bcd8739ae039)(left) ? left : tooltipLeft;
        tooltipTop = snapTooltipToDatumY && (0, $0e64952a2d1e8b9b$export$2e2bcd8739ae039)(top) ? top : tooltipTop;
    }
    // collect positions + styles for glyphs; glyphs always snap to Datum, not event coords
    const glyphProps = [];
    if (showTooltip && (showDatumGlyph || showSeriesGlyphs)) {
        const size = Number(glyphStyle?.radius ?? 4);
        if (showSeriesGlyphs) Object.values(tooltipContext?.tooltipData?.datumByKey ?? {}).forEach((_ref4)=>{
            let { key: key, datum: datum, index: index } = _ref4;
            const color = colorScale?.(key) ?? theme?.htmlLabel?.color ?? '#222';
            const { left: left, top: top } = getDatumLeftTop(key, datum);
            // don't show glyphs if coords are unavailable
            if (!(0, $0e64952a2d1e8b9b$export$2e2bcd8739ae039)(left) || !(0, $0e64952a2d1e8b9b$export$2e2bcd8739ae039)(top)) return;
            glyphProps.push({
                key: key,
                color: color,
                datum: datum,
                index: index,
                size: size,
                x: left,
                y: top,
                glyphStyle: glyphStyle,
                isNearestDatum: nearestDatum ? nearestDatum.key === key : false
            });
        });
        else if (nearestDatum) {
            const { left: left, top: top } = getDatumLeftTop(nearestDatumKey, nearestDatum.datum);
            // don't show glyphs if coords are unavailable
            if ((0, $0e64952a2d1e8b9b$export$2e2bcd8739ae039)(left) && (0, $0e64952a2d1e8b9b$export$2e2bcd8739ae039)(top)) {
                const color = (nearestDatumKey && colorScale?.(nearestDatumKey)) ?? // @ts-expect-error
                null ?? theme?.gridStyles?.stroke ?? theme?.htmlLabel?.color ?? '#222';
                glyphProps.push({
                    key: nearestDatumKey,
                    color: color,
                    datum: nearestDatum.datum,
                    index: nearestDatum.index,
                    size: size,
                    x: left,
                    y: top,
                    glyphStyle: glyphStyle,
                    isNearestDatum: true
                });
            }
        }
    }
    return(/*#__PURE__*/ // Tooltip can be rendered as a child of SVG or HTML since its output is rendered in a Portal.
    // So use svg element to find container ref because it's a valid child of SVG and HTML parents.
    (0, $90cae257cc958273$exports.jsxs)((0, $90cae257cc958273$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("svg", {
                ref: setContainerRef,
                style: $25fb68fd052b1b05$var$INVISIBLE_STYLES
            }),
            showTooltip && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)((0, $90cae257cc958273$exports.Fragment), {
                children: [
                    showVerticalCrosshair && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(TooltipInPortal, {
                        className: "visx-crosshair visx-crosshair-vertical",
                        left: tooltipLeft,
                        top: margin?.top,
                        offsetLeft: 0,
                        offsetTop: 0,
                        detectBounds: false,
                        style: $25fb68fd052b1b05$var$TOOLTIP_NO_STYLE,
                        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("svg", {
                            width: "1",
                            height: innerHeight,
                            overflow: "visible",
                            children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("line", {
                                x1: 0,
                                x2: 0,
                                y1: 0,
                                y2: innerHeight,
                                strokeWidth: 1.5,
                                stroke: theme?.gridStyles?.stroke ?? theme?.htmlLabel?.color ?? '#222',
                                ...verticalCrosshairStyle
                            })
                        })
                    }),
                    showHorizontalCrosshair && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(TooltipInPortal, {
                        className: "visx-crosshair visx-crosshair-horizontal",
                        left: margin?.left,
                        top: tooltipTop,
                        offsetLeft: 0,
                        offsetTop: 0,
                        detectBounds: false,
                        style: $25fb68fd052b1b05$var$TOOLTIP_NO_STYLE,
                        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("svg", {
                            width: innerWidth,
                            height: "1",
                            overflow: "visible",
                            children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("line", {
                                x1: 0,
                                x2: innerWidth,
                                y1: 0,
                                y2: 0,
                                strokeWidth: 1.5,
                                stroke: theme?.gridStyles?.stroke ?? theme?.htmlLabel?.color ?? '#222',
                                ...horizontalCrosshairStyle
                            })
                        })
                    }),
                    glyphProps.map((_ref5)=>{
                        let { key: key, x: x, y: y, ...props } = _ref5;
                        return(/*#__PURE__*/ // We render glyps in a portal so that they can overflow the container if necessary
                        (0, $90cae257cc958273$exports.jsx)(TooltipInPortal, {
                            className: "visx-tooltip-glyph",
                            left: x,
                            top: y,
                            offsetLeft: 0,
                            offsetTop: 0,
                            detectBounds: false,
                            style: $25fb68fd052b1b05$var$TOOLTIP_NO_STYLE,
                            children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("svg", {
                                overflow: "visible",
                                children: renderGlyph({
                                    key: key,
                                    x: 0,
                                    y: 0,
                                    ...props
                                })
                            })
                        }, key));
                    }),
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(TooltipInPortal, {
                        left: tooltipLeft,
                        top: tooltipTop,
                        style: {
                            ...(0, $79662e844814a817$export$214b055320e0bf32),
                            background: theme?.backgroundColor ?? 'white',
                            boxShadow: `0 1px 2px 
                ${theme?.htmlLabel?.color ? `${theme?.htmlLabel?.color}55` : '#22222255'}`,
                            ...theme?.htmlLabel
                        },
                        ...tooltipProps,
                        children: tooltipContent
                    })
                ]
            })
        ]
    }));
}
function $25fb68fd052b1b05$export$2e2bcd8739ae039(props) {
    const tooltipContext = (0, $5E6i4.useContext)((0, $7b4c170e6fbbacb9$export$2e2bcd8739ae039));
    if (!tooltipContext?.tooltipOpen) return null;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($25fb68fd052b1b05$var$TooltipInner, {
        ...props
    });
}


/* eslint jsx-a11y/mouse-events-have-key-events: 'off', @typescript-eslint/no-explicit-any: 'off' */ 
var $5E6i4 = parcelRequire("5E6i4");



var $5E6i4 = parcelRequire("5E6i4");


var $5E6i4 = parcelRequire("5E6i4");
const $91fed4a739027c70$var$EventEmitterContext = /*#__PURE__*/ (0, $5E6i4.createContext)(null);
var $91fed4a739027c70$export$2e2bcd8739ae039 = $91fed4a739027c70$var$EventEmitterContext;


function $6c01a54159ea3986$export$2e2bcd8739ae039(/** Type of event to subscribe to. */ eventType, /** Handler invoked on emission of EventType event.  */ handler, /** Optional valid sources for EventType subscription. */ allowedSources) {
    const emitter = (0, $5E6i4.useContext)((0, $91fed4a739027c70$export$2e2bcd8739ae039));
    const allowedSourcesRef = (0, $5E6i4.useRef)(undefined);
    allowedSourcesRef.current = allowedSources; // use ref so allowedSources[] can change without creating new handlers
    // wrap emitter.emit so we can enforce stricter type signature
    const emit = (0, $5E6i4.useCallback)((type, event, source)=>{
        if (emitter) emitter.emit(type, {
            event: event,
            svgPoint: (0, $45e9151834fcba9b$export$2e2bcd8739ae039)(event),
            source: source
        });
    }, [
        emitter
    ]);
    (0, $5E6i4.useEffect)(()=>{
        if (emitter && eventType && handler) {
            // register handler, with source filtering as needed
            const handlerWithSourceFilter = (params)=>{
                if (!allowedSourcesRef.current || params?.source && allowedSourcesRef.current?.includes(params.source)) handler(params);
            };
            emitter.on(eventType, handlerWithSourceFilter);
            return ()=>emitter?.off(eventType, handlerWithSourceFilter);
        }
        return undefined;
    }, [
        emitter,
        eventType,
        handler
    ]);
    return emitter ? emit : null;
}



var $5E6i4 = parcelRequire("5E6i4");
function $3302e5de9211bd84$export$2e2bcd8739ae039(n) {
    return {
        all: n = n || new Map,
        on: function(t, e) {
            var i = n.get(t);
            i && i.push(e) || n.set(t, [
                e
            ]);
        },
        off: function(t, e) {
            var i = n.get(t);
            i && i.splice(i.indexOf(e) >>> 0, 1);
        },
        emit: function(t, e) {
            (n.get(t) || []).slice().map(function(n) {
                n(e);
            }), (n.get("*") || []).slice().map(function(n) {
                n(t, e);
            });
        }
    };
}




function $6c7df19502598e56$export$2e2bcd8739ae039(_ref) {
    let { children: children } = _ref;
    const emitter = (0, $5E6i4.useMemo)(()=>(0, $3302e5de9211bd84$export$2e2bcd8739ae039)(), []);
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $91fed4a739027c70$export$2e2bcd8739ae039).Provider, {
        value: emitter,
        children: children
    });
}




var $5E6i4 = parcelRequire("5E6i4");





function $6150be618b9e8550$export$2e2bcd8739ae039(_ref) {
    let { hideTooltipDebounceMs: hideTooltipDebounceMs = 400, children: children } = _ref;
    const { tooltipOpen: tooltipOpen, tooltipLeft: tooltipLeft, tooltipTop: tooltipTop, tooltipData: tooltipData, updateTooltip: updateTooltip, hideTooltip: privateHideTooltip } = (0, $46bbe600a3d3d653$export$2e2bcd8739ae039)(undefined);
    const debouncedHideTooltip = (0, $5E6i4.useRef)(null);
    function cancelDeboundedHideTooltip() {
        if (debouncedHideTooltip.current) {
            debouncedHideTooltip.current.cancel();
            debouncedHideTooltip.current = null;
        }
    }
    (0, $5E6i4.useEffect)(()=>cancelDeboundedHideTooltip, []);
    const showTooltip = (0, $5E6i4.useRef)((_ref2)=>{
        let { svgPoint: svgPoint, index: index, key: key, datum: datum, distanceX: distanceX, distanceY: distanceY } = _ref2;
        // cancel any hideTooltip calls so it won't hide after invoking the logic below
        cancelDeboundedHideTooltip();
        const cleanDistanceX = (0, $0e64952a2d1e8b9b$export$2e2bcd8739ae039)(distanceX) ? distanceX : Infinity;
        const cleanDistanceY = (0, $0e64952a2d1e8b9b$export$2e2bcd8739ae039)(distanceY) ? distanceY : Infinity;
        const distance = Math.sqrt(cleanDistanceX ** 2 + cleanDistanceY ** 2);
        updateTooltip((_ref3)=>{
            let { tooltipData: currData } = _ref3;
            const currNearestDatumDistance = currData?.nearestDatum && (0, $0e64952a2d1e8b9b$export$2e2bcd8739ae039)(currData.nearestDatum.distance) ? currData.nearestDatum.distance : Infinity;
            return {
                tooltipOpen: true,
                tooltipLeft: svgPoint?.x,
                tooltipTop: svgPoint?.y,
                tooltipData: {
                    nearestDatum: (currData?.nearestDatum?.key ?? '') !== key && currNearestDatumDistance < distance ? currData?.nearestDatum : {
                        key: key,
                        index: index,
                        datum: datum,
                        distance: distance
                    },
                    datumByKey: {
                        ...currData?.datumByKey,
                        [key]: {
                            datum: datum,
                            index: index,
                            key: key
                        }
                    }
                }
            };
        });
    });
    const hideTooltip = (0, $5E6i4.useCallback)(()=>{
        debouncedHideTooltip.current = (0, $1cd3ba1ba76c811a$export$61fc7d43ac8f84b0)(privateHideTooltip, hideTooltipDebounceMs);
        debouncedHideTooltip.current();
    }, [
        privateHideTooltip,
        hideTooltipDebounceMs
    ]);
    const value = (0, $5E6i4.useMemo)(()=>({
            tooltipOpen: tooltipOpen,
            tooltipLeft: tooltipLeft,
            tooltipTop: tooltipTop,
            tooltipData: tooltipData,
            updateTooltip: updateTooltip,
            showTooltip: showTooltip.current,
            hideTooltip: hideTooltip
        }), [
        hideTooltip,
        tooltipData,
        tooltipLeft,
        tooltipOpen,
        tooltipTop,
        updateTooltip
    ]);
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $7b4c170e6fbbacb9$export$2e2bcd8739ae039).Provider, {
        value: value,
        children: children
    });
}


/* eslint-disable @typescript-eslint/no-explicit-any */ 

var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");
// source https://yeun.github.io/open-color/
const $89b5c35691e4b5c7$export$61254e8993990612 = {
    red: [
        '#fff5f5',
        '#ffe3e3',
        '#ffc9c9',
        '#ffa8a8',
        '#ff8787',
        '#ff6b6b',
        '#fa5252',
        '#f03e3e',
        '#e03131',
        '#c92a2a'
    ],
    pink: [
        '#fff0f6',
        '#ffdeeb',
        '#fcc2d7',
        '#faa2c1',
        '#f783ac',
        '#f06595',
        '#e64980',
        '#d6336c',
        '#c2255c',
        '#a61e4d'
    ],
    grape: [
        '#f8f0fc',
        '#f3d9fa',
        '#eebefa',
        '#e599f7',
        '#da77f2',
        '#cc5de8',
        '#be4bdb',
        '#ae3ec9',
        '#9c36b5',
        '#862e9c'
    ],
    violet: [
        '#f3f0ff',
        '#e5dbff',
        '#d0bfff',
        '#b197fc',
        '#9775fa',
        '#845ef7',
        '#7950f2',
        '#7048e8',
        '#6741d9',
        '#5f3dc4'
    ],
    indigo: [
        '#edf2ff',
        '#dbe4ff',
        '#bac8ff',
        '#91a7ff',
        '#748ffc',
        '#5c7cfa',
        '#4c6ef5',
        '#4263eb',
        '#3b5bdb',
        '#364fc7'
    ],
    blue: [
        '#e8f7ff',
        '#ccedff',
        '#a3daff',
        '#72c3fc',
        '#4dadf7',
        '#329af0',
        '#228ae6',
        '#1c7cd6',
        '#1b6ec2',
        '#1862ab'
    ],
    cyan: [
        '#e3fafc',
        '#c5f6fa',
        '#99e9f2',
        '#66d9e8',
        '#3bc9db',
        '#22b8cf',
        '#15aabf',
        '#1098ad',
        '#0c8599',
        '#0b7285'
    ],
    teal: [
        '#e6fcf5',
        '#c3fae8',
        '#96f2d7',
        '#63e6be',
        '#38d9a9',
        '#20c997',
        '#12b886',
        '#0ca678',
        '#099268',
        '#087f5b'
    ],
    green: [
        '#ebfbee',
        '#d3f9d8',
        '#b2f2bb',
        '#8ce99a',
        '#69db7c',
        '#51cf66',
        '#40c057',
        '#37b24d',
        '#2f9e44',
        '#2b8a3e'
    ],
    lime: [
        '#f4fce3',
        '#e9fac8',
        '#d8f5a2',
        '#c0eb75',
        '#a9e34b',
        '#94d82d',
        '#82c91e',
        '#74b816',
        '#66a80f',
        '#5c940d'
    ],
    yellow: [
        '#fff9db',
        '#fff3bf',
        '#ffec99',
        '#ffe066',
        '#ffd43b',
        '#fcc419',
        '#fab005',
        '#f59f00',
        '#f08c00',
        '#e67700'
    ],
    orange: [
        '#fff4e6',
        '#ffe8cc',
        '#ffd8a8',
        '#ffc078',
        '#ffa94d',
        '#ff922b',
        '#fd7e14',
        '#f76707',
        '#e8590c',
        '#d9480f'
    ],
    gray: [
        '#f8f9fa',
        '#f1f3f5',
        '#e9ecef',
        '#dee2e6',
        '#ced4da',
        '#adb5bd',
        '#868e96',
        '#495057',
        '#343a40',
        '#212529'
    ]
};
const $89b5c35691e4b5c7$export$10473e9ffc331ca1 = $89b5c35691e4b5c7$export$61254e8993990612.gray;
const $89b5c35691e4b5c7$export$32f78bffcd82ff28 = $89b5c35691e4b5c7$export$10473e9ffc331ca1[7];
const $89b5c35691e4b5c7$export$f1dd60f4a4247eae = [
    $89b5c35691e4b5c7$export$61254e8993990612.cyan[9],
    $89b5c35691e4b5c7$export$61254e8993990612.cyan[3],
    $89b5c35691e4b5c7$export$61254e8993990612.yellow[5],
    $89b5c35691e4b5c7$export$61254e8993990612.red[4],
    $89b5c35691e4b5c7$export$61254e8993990612.grape[8],
    $89b5c35691e4b5c7$export$61254e8993990612.grape[5],
    $89b5c35691e4b5c7$export$61254e8993990612.pink[9]
];



const $e59fdd064fe47bfd$var$defaultLabelStyles = {
    fontFamily: '-apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,sans-serif',
    fontWeight: 700,
    fontSize: 12,
    textAnchor: 'middle',
    pointerEvents: 'none',
    letterSpacing: 0.4
};
function $e59fdd064fe47bfd$export$2e2bcd8739ae039(config) {
    const baseSvgLabel = {
        ...$e59fdd064fe47bfd$var$defaultLabelStyles,
        fill: (0, $89b5c35691e4b5c7$export$32f78bffcd82ff28),
        stroke: 'none',
        ...config.svgLabelBig
    };
    const baseTickLabel = {
        ...$e59fdd064fe47bfd$var$defaultLabelStyles,
        fontWeight: 200,
        fontSize: 11,
        fill: (0, $89b5c35691e4b5c7$export$32f78bffcd82ff28),
        stroke: 'none',
        ...config.svgLabelSmall
    };
    const baseHtmlLabel = {
        color: config.htmlLabel?.color ?? config.svgLabelBig?.fill ?? config.svgLabelSmall?.fill ?? (0, $89b5c35691e4b5c7$export$32f78bffcd82ff28),
        ...$e59fdd064fe47bfd$var$defaultLabelStyles,
        ...config.htmlLabel
    };
    return {
        backgroundColor: config.backgroundColor,
        colors: [
            ...config.colors
        ],
        htmlLabel: {
            ...baseHtmlLabel
        },
        svgLabelSmall: {
            ...baseTickLabel
        },
        svgLabelBig: {
            ...baseSvgLabel
        },
        gridStyles: {
            stroke: config.gridColor,
            strokeWidth: 1,
            ...config.gridStyles
        },
        axisStyles: {
            x: {
                top: {
                    axisLabel: {
                        ...baseSvgLabel,
                        dy: '-0.25em' // needs to include font-size
                    },
                    axisLine: {
                        stroke: config.gridColorDark,
                        strokeWidth: 2,
                        ...config.xAxisLineStyles
                    },
                    tickLabel: {
                        ...baseTickLabel,
                        dy: '-0.25em' // needs to include font-size
                    },
                    tickLength: config.tickLength,
                    tickLine: {
                        strokeWidth: 1,
                        stroke: config.gridColor,
                        ...config.xTickLineStyles
                    }
                },
                bottom: {
                    axisLabel: {
                        ...baseSvgLabel,
                        dy: '-0.25em'
                    },
                    axisLine: {
                        stroke: config.gridColorDark,
                        strokeWidth: 2,
                        ...config.xAxisLineStyles
                    },
                    tickLabel: {
                        ...baseTickLabel,
                        dy: '0.125em'
                    },
                    tickLength: config.tickLength,
                    tickLine: {
                        strokeWidth: 1,
                        stroke: config.gridColor,
                        ...config.xTickLineStyles
                    }
                }
            },
            y: {
                left: {
                    axisLabel: {
                        ...baseSvgLabel,
                        dx: '-1.25em'
                    },
                    axisLine: {
                        stroke: config.gridColor,
                        strokeWidth: 1,
                        ...config.yAxisLineStyles
                    },
                    tickLabel: {
                        ...baseTickLabel,
                        textAnchor: 'end',
                        dx: '-0.25em',
                        dy: '0.25em'
                    },
                    tickLength: config.tickLength,
                    tickLine: {
                        strokeWidth: 1,
                        stroke: config.gridColor,
                        ...config.yTickLineStyles
                    }
                },
                right: {
                    axisLabel: {
                        ...baseSvgLabel,
                        dx: '1.25em'
                    },
                    axisLine: {
                        stroke: config.gridColor,
                        strokeWidth: 1,
                        ...config.yAxisLineStyles
                    },
                    tickLabel: {
                        ...baseTickLabel,
                        textAnchor: 'start',
                        dx: '0.25em',
                        dy: '0.25em'
                    },
                    tickLength: config.tickLength,
                    tickLine: {
                        strokeWidth: 1,
                        stroke: config.gridColor,
                        ...config.yTickLineStyles
                    }
                }
            }
        }
    };
}


var $5a0fef92b6e89c70$export$2e2bcd8739ae039 = (0, $e59fdd064fe47bfd$export$2e2bcd8739ae039)({
    backgroundColor: '#fff',
    colors: (0, $89b5c35691e4b5c7$export$f1dd60f4a4247eae),
    tickLength: 4,
    svgLabelSmall: {
        fill: (0, $89b5c35691e4b5c7$export$10473e9ffc331ca1)[7]
    },
    svgLabelBig: {
        fill: (0, $89b5c35691e4b5c7$export$10473e9ffc331ca1)[9]
    },
    gridColor: (0, $89b5c35691e4b5c7$export$10473e9ffc331ca1)[5],
    gridColorDark: (0, $89b5c35691e4b5c7$export$10473e9ffc331ca1)[9]
});


const $070796c7135422c6$var$ThemeContext = /*#__PURE__*/ (0, $5E6i4.createContext)((0, $5a0fef92b6e89c70$export$2e2bcd8739ae039));
var $070796c7135422c6$export$2e2bcd8739ae039 = $070796c7135422c6$var$ThemeContext;




var $5E6i4 = parcelRequire("5E6i4");
/** A class for holding data entries */ class $d8fc60deeb85ff60$export$2e2bcd8739ae039 {
    registry = {};
    registryKeys = [];
    /** Add one or more entries to the registry. */ registerData(entryOrEntries) {
        const entries = Array.isArray(entryOrEntries) ? entryOrEntries : [
            entryOrEntries
        ];
        entries.forEach((currEntry)=>{
            this.registry[currEntry.key] = currEntry;
            this.registryKeys = Object.keys(this.registry);
        });
    }
    /** Remove one or more entries to the registry. */ unregisterData(keyOrKeys) {
        const keys = Array.isArray(keyOrKeys) ? keyOrKeys : [
            keyOrKeys
        ];
        keys.forEach((currKey)=>{
            delete this.registry[currKey];
            this.registryKeys = Object.keys(this.registry);
        });
    }
    /** Returns all data registry entries. This value is not constant between calls. */ entries() {
        return Object.values(this.registry);
    }
    /** Returns a specific entity from the registry, if it exists. */ get(key) {
        return this.registry[key];
    }
    /**
   * Returns the current registry keys.
   * This value is constant between calls if the keys themselves have not changed.
   */ keys() {
        return this.registryKeys;
    }
}


function $f34f6b8ed5eaa41a$export$2e2bcd8739ae039() {
    const [, forceUpdate] = (0, $5E6i4.useState)(Math.random());
    const privateRegistry = (0, $5E6i4.useMemo)(()=>new (0, $d8fc60deeb85ff60$export$2e2bcd8739ae039)(), []);
    return (0, $5E6i4.useMemo)(()=>({
            registerData: function() {
                privateRegistry.registerData(...arguments);
                forceUpdate(Math.random());
            },
            unregisterData: function() {
                privateRegistry.unregisterData(...arguments);
                forceUpdate(Math.random());
            },
            entries: ()=>privateRegistry.entries(),
            get: (key)=>privateRegistry.get(key),
            keys: ()=>privateRegistry.keys()
        }), [
        privateRegistry
    ]);
}



var $5E6i4 = parcelRequire("5E6i4");
const $4215feb9c6fc4579$var$DEFAULT_DIMS = {
    width: 0,
    height: 0,
    margin: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }
};
function $4215feb9c6fc4579$export$2e2bcd8739ae039(initialDims) {
    const [dimensions, privateSetDimensions] = (0, $5E6i4.useState)({
        width: initialDims?.width == null ? $4215feb9c6fc4579$var$DEFAULT_DIMS.width : initialDims.width,
        height: initialDims?.height == null ? $4215feb9c6fc4579$var$DEFAULT_DIMS.height : initialDims.height,
        margin: initialDims?.margin == null ? $4215feb9c6fc4579$var$DEFAULT_DIMS.margin : initialDims.margin
    });
    // expose a setter with better memoization logic
    const publicSetDimensions = (0, $5E6i4.useCallback)((dims)=>{
        if (dims.width !== dimensions.width || dims.height !== dimensions.height || dims.margin.left !== dimensions.margin.left || dims.margin.right !== dimensions.margin.right || dims.margin.top !== dimensions.margin.top || dims.margin.bottom !== dimensions.margin.bottom) privateSetDimensions(dims);
    }, [
        dimensions.width,
        dimensions.height,
        dimensions.margin.left,
        dimensions.margin.right,
        dimensions.margin.bottom,
        dimensions.margin.top
    ]);
    return [
        dimensions,
        publicSetDimensions
    ];
}



/**
 * `@visx/vendor/d3-array` (ESM)
 * See upstream license: https://github.com/d3/d3-array/blob/main/LICENSE
 *
 * This ESM package re-exports the underlying installed dependencies of 
 * `node_modules/d3-array`
 */ function $9ace486398acc884$export$2e2bcd8739ae039(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}



function $2da0cdc400270c87$export$2e2bcd8739ae039(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}


function $b0d013ff406cf08c$export$2e2bcd8739ae039(f) {
    let compare1, compare2, delta;
    // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = (0, $9ace486398acc884$export$2e2bcd8739ae039);
        compare2 = (d, x)=>(0, $9ace486398acc884$export$2e2bcd8739ae039)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === (0, $9ace486398acc884$export$2e2bcd8739ae039) || f === (0, $2da0cdc400270c87$export$2e2bcd8739ae039) ? f : $b0d013ff406cf08c$var$zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $b0d013ff406cf08c$var$zero() {
    return 0;
}


function $6f4f88e9ad94e3aa$export$2e2bcd8739ae039(x) {
    return x === null ? NaN : +x;
}
function* $6f4f88e9ad94e3aa$export$1f6c9cc012ebacae(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}


const $36919d4a540184a0$var$ascendingBisect = (0, $b0d013ff406cf08c$export$2e2bcd8739ae039)((0, $9ace486398acc884$export$2e2bcd8739ae039));
const $36919d4a540184a0$export$4d945ad3ad5751b0 = $36919d4a540184a0$var$ascendingBisect.right;
const $36919d4a540184a0$export$df7d25c84ebd12a5 = $36919d4a540184a0$var$ascendingBisect.left;
const $36919d4a540184a0$export$c1cb828b1117c77b = (0, $b0d013ff406cf08c$export$2e2bcd8739ae039)((0, $6f4f88e9ad94e3aa$export$2e2bcd8739ae039)).center;
var $36919d4a540184a0$export$2e2bcd8739ae039 = $36919d4a540184a0$export$4d945ad3ad5751b0;

function $6b7620569dc79965$export$2e2bcd8739ae039(values, valueof) {
    let min;
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}





var $5E6i4 = parcelRequire("5E6i4");
/* eslint-disable @typescript-eslint/no-explicit-any */ function $7a3977efb1a0992d$export$2e2bcd8739ae039(scaleConfig) {
    return scaleConfig?.type === 'band' || scaleConfig?.type === 'ordinal' || scaleConfig?.type === 'point';
}


function $af49473a8b722b2d$export$2e2bcd8739ae039(_ref) {
    let { dataRegistry: dataRegistry, xRange: xRange, xScaleConfig: xScaleConfig, yRange: yRange, yScaleConfig: yScaleConfig } = _ref;
    // pull out memoization keys that are less likely to change
    const registryKeys = dataRegistry.keys();
    const [xMin, xMax] = xRange;
    const [yMin, yMax] = yRange;
    const memoizedXScale = (0, $5E6i4.useMemo)(()=>{
        const registryEntries = registryKeys.map((key)=>dataRegistry.get(key));
        const xValues = registryEntries.reduce((combined, entry)=>entry ? combined.concat(entry.data.map((d)=>entry.xAccessor(d))) : combined, []);
        // d3Extent scale returns NaN domain for empty arrays
        if (xValues.length === 0) return undefined;
        const xDomain = (0, $7a3977efb1a0992d$export$2e2bcd8739ae039)(xScaleConfig) ? xValues : (0, $6b7620569dc79965$export$2e2bcd8739ae039)(xValues);
        let xScale = (0, $818e625ab5eaa16c$export$2e2bcd8739ae039)(xScaleConfig) ? (0, $070a822dceb20443$export$2e2bcd8739ae039)({
            range: [
                xMin,
                xMax
            ],
            domain: xDomain,
            zero: true,
            ...xScaleConfig
        }) : (0, $070a822dceb20443$export$2e2bcd8739ae039)({
            range: [
                xMin,
                xMax
            ],
            domain: xDomain,
            ...xScaleConfig
        });
        // apply any scale updates from the registry
        registryEntries.forEach((entry)=>{
            if (entry?.xScale) xScale = entry.xScale(xScale);
        });
        return xScale;
    }, [
        dataRegistry,
        xScaleConfig,
        registryKeys,
        xMin,
        xMax
    ]);
    // same for yScale. this logic is hard to apply generically because of the scale types / accessors
    const memoizedYScale = (0, $5E6i4.useMemo)(()=>{
        const registryEntries = registryKeys.map((key)=>dataRegistry.get(key));
        const yValues = registryEntries.reduce((combined, entry)=>entry ? combined.concat(entry.data.map((d)=>entry.yAccessor(d))) : combined, []);
        // d3Extent scale returns NaN domain for empty arrays
        if (yValues.length === 0) return undefined;
        const yDomain = (0, $7a3977efb1a0992d$export$2e2bcd8739ae039)(yScaleConfig) ? yValues : (0, $6b7620569dc79965$export$2e2bcd8739ae039)(yValues);
        let yScale = (0, $818e625ab5eaa16c$export$2e2bcd8739ae039)(yScaleConfig) ? (0, $070a822dceb20443$export$2e2bcd8739ae039)({
            range: [
                yMin,
                yMax
            ],
            domain: yDomain,
            zero: true,
            ...yScaleConfig
        }) : (0, $070a822dceb20443$export$2e2bcd8739ae039)({
            range: [
                yMin,
                yMax
            ],
            domain: yDomain,
            ...yScaleConfig
        });
        // apply any scale updates from the registry
        registryEntries.forEach((entry)=>{
            if (entry?.yScale) yScale = entry.yScale(yScale);
        });
        return yScale;
    }, [
        dataRegistry,
        yScaleConfig,
        registryKeys,
        yMin,
        yMax
    ]);
    return {
        xScale: memoizedXScale,
        yScale: memoizedYScale
    };
}




function $0d5dd104263953b8$export$2e2bcd8739ae039(_ref) {
    let { initialDimensions: initialDimensions, theme: propsTheme, xScale: xScaleConfig, yScale: yScaleConfig, children: children, horizontal: initialHorizontal = 'auto', resizeObserverPolyfill: resizeObserverPolyfill } = _ref;
    // `DataProvider` provides a theme so that `ThemeProvider` is not strictly needed.
    // `props.theme` takes precedent over `context.theme`, which has a default even if
    // a ThemeProvider is not present.
    const contextTheme = (0, $5E6i4.useContext)((0, $070796c7135422c6$export$2e2bcd8739ae039));
    const theme = propsTheme || contextTheme;
    const [{ width: width, height: height, margin: margin }, setDimensions] = (0, $4215feb9c6fc4579$export$2e2bcd8739ae039)(initialDimensions);
    const innerWidth = Math.max(0, width - margin.left - margin.right);
    const innerHeight = Math.max(0, height - margin.top - margin.bottom);
    const dataRegistry = (0, $f34f6b8ed5eaa41a$export$2e2bcd8739ae039)();
    const { xScale: xScale, yScale: yScale } = (0, $af49473a8b722b2d$export$2e2bcd8739ae039)({
        dataRegistry: dataRegistry,
        xScaleConfig: xScaleConfig,
        yScaleConfig: yScaleConfig,
        xRange: [
            margin.left,
            Math.max(0, width - margin.right)
        ],
        yRange: [
            Math.max(0, height - margin.bottom),
            margin.top
        ]
    });
    const registryKeys = dataRegistry.keys();
    const colorScale = (0, $5E6i4.useMemo)(()=>(0, $5d94097fa39ec873$export$2e2bcd8739ae039)({
            domain: registryKeys,
            range: theme.colors
        }), [
        registryKeys,
        theme.colors
    ]);
    const horizontal = initialHorizontal === 'auto' ? (0, $7a3977efb1a0992d$export$2e2bcd8739ae039)(yScaleConfig) || yScaleConfig.type === 'time' || yScaleConfig.type === 'utc' : initialHorizontal;
    const value = (0, $5E6i4.useMemo)(()=>({
            dataRegistry: dataRegistry,
            registerData: dataRegistry.registerData,
            unregisterData: dataRegistry.unregisterData,
            xScale: xScale || (0, $7c30a724ea2126a9$export$2e2bcd8739ae039)(),
            yScale: yScale || (0, $7c30a724ea2126a9$export$2e2bcd8739ae039)(),
            colorScale: colorScale,
            theme: theme,
            width: width,
            height: height,
            margin: margin,
            innerWidth: innerWidth,
            innerHeight: innerHeight,
            setDimensions: setDimensions,
            horizontal: horizontal,
            resizeObserverPolyfill: resizeObserverPolyfill
        }), // everything here should be memoized between renders
    // to avoid child re-renders
    [
        colorScale,
        dataRegistry,
        height,
        horizontal,
        innerHeight,
        innerWidth,
        margin,
        setDimensions,
        theme,
        width,
        xScale,
        yScale,
        resizeObserverPolyfill
    ]);
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $89eeb2e4952e291d$export$2e2bcd8739ae039).Provider, {
        value: value,
        children: children
    });
}



var $5E6i4 = parcelRequire("5E6i4");

function $5398e509b78bd2e9$export$2e2bcd8739ae039(_ref) {
    let { source: source, onPointerOut: onPointerOut = true, onPointerMove: onPointerMove = true, onPointerUp: onPointerUp = true, onPointerDown: onPointerDown = true, onFocus: onFocus = false, onBlur: onBlur = false } = _ref;
    const emit = (0, $6c01a54159ea3986$export$2e2bcd8739ae039)();
    const emitPointerMove = (0, $5E6i4.useCallback)((event)=>emit?.('pointermove', event, source), [
        emit,
        source
    ]);
    const emitPointerOut = (0, $5E6i4.useCallback)((event)=>emit?.('pointerout', event, source), [
        emit,
        source
    ]);
    const emitPointerUp = (0, $5E6i4.useCallback)((event)=>emit?.('pointerup', event, source), [
        emit,
        source
    ]);
    const emitPointerDown = (0, $5E6i4.useCallback)((event)=>emit?.('pointerdown', event, source), [
        emit,
        source
    ]);
    const emitFocus = (0, $5E6i4.useCallback)((event)=>emit?.('focus', event, source), [
        emit,
        source
    ]);
    const emitBlur = (0, $5E6i4.useCallback)((event)=>emit?.('blur', event, source), [
        emit,
        source
    ]);
    return {
        onPointerMove: onPointerMove ? emitPointerMove : undefined,
        onFocus: onFocus ? emitFocus : undefined,
        onBlur: onBlur ? emitBlur : undefined,
        onPointerOut: onPointerOut ? emitPointerOut : undefined,
        onPointerUp: onPointerUp ? emitPointerUp : undefined,
        onPointerDown: onPointerDown ? emitPointerDown : undefined
    };
}


// event sources
const $ea50bd05f08590bd$export$7b61f117b26ab7e7 = 'AREASERIES_EVENT_SOURCE';
const $ea50bd05f08590bd$export$4e49b0cacbdaad4e = 'AREASTACK_EVENT_SOURCE';
const $ea50bd05f08590bd$export$c1861ee6e88456a7 = 'BARGROUP_EVENT_SOURCE';
const $ea50bd05f08590bd$export$a0b4eafb3ed9dd6c = 'BARSERIES_EVENT_SOURCE';
const $ea50bd05f08590bd$export$1411a3296d826139 = 'BARSTACK_EVENT_SOURCE';
const $ea50bd05f08590bd$export$64f476fc17eeef05 = 'GLYPHSERIES_EVENT_SOURCE';
const $ea50bd05f08590bd$export$f037ec20d0f10ad2 = 'LINESERIES_EVENT_SOURCE';
const $ea50bd05f08590bd$export$69b1818e3c4e83f9 = 'XYCHART_EVENT_SOURCE';



var $5E6i4 = parcelRequire("5E6i4");

// functional definition of a PointerEvent (mouse, touch)
function $3da9593b22e14311$export$1d0a87a519049f8c(event) {
    return !!event && ('clientX' in event || 'changedTouches' in event);
}
function $3da9593b22e14311$export$9829d00ac5f2232d(event) {
    return !!event && !$3da9593b22e14311$export$1d0a87a519049f8c(event);
}



function $e19c591e265a895a$export$2e2bcd8739ae039(_ref) {
    let { scale: scale, accessor: accessor, scaledValue: scaledValue, data: data } = _ref;
    const coercedScale = scale; // broaden type before type guards below
    let nearestDatum;
    let nearestDatumIndex;
    // if scale has .invert(), convert svg coord to nearest data value
    if ('invert' in coercedScale && typeof coercedScale.invert === 'function') {
        const bisect = (0, $b0d013ff406cf08c$export$2e2bcd8739ae039)(accessor).left;
        // find closest data value, then map that to closest datum
        const dataValue = Number(coercedScale.invert(scaledValue));
        const index = bisect(data, dataValue);
        // take the two datum nearest this index, and compute which is closer
        const nearestDatum0 = data[index - 1];
        const nearestDatum1 = data[index];
        nearestDatum = !nearestDatum0 || Math.abs(dataValue - accessor(nearestDatum0)) > Math.abs(dataValue - accessor(nearestDatum1)) ? nearestDatum1 : nearestDatum0;
        nearestDatumIndex = nearestDatum === nearestDatum0 ? index - 1 : index;
    } else if ('step' in coercedScale && typeof coercedScale.step !== 'undefined') {
        // band scales don't have an invert function but they do have discrete domains
        // so we manually invert
        const domain = scale.domain();
        const range = scale.range().map(Number);
        const sortedRange = [
            ...range
        ].sort((a, b)=>a - b); // bisectLeft assumes sort
        const rangePoints = (0, $7c985a3d07f0c273$export$2e2bcd8739ae039)(sortedRange[0], sortedRange[1], coercedScale.step());
        const domainIndex = (0, $36919d4a540184a0$export$df7d25c84ebd12a5)(rangePoints, scaledValue);
        // y-axis scales may have reverse ranges, correct for this
        const sortedDomain = range[0] < range[1] ? domain : domain.reverse();
        const domainValue = sortedDomain[domainIndex - 1];
        const index = data.findIndex((d)=>String(accessor(d)) === String(domainValue));
        nearestDatum = data[index];
        nearestDatumIndex = index;
    } else {
        console.warn('[visx/xychart/findNearestDatum] encountered incompatible scale type, bailing');
        return null;
    }
    if (nearestDatum == null || nearestDatumIndex == null) return null;
    const distance = Math.abs(Number(coercedScale(accessor(nearestDatum))) - scaledValue);
    return {
        datum: nearestDatum,
        index: nearestDatumIndex,
        distance: distance
    };
}


function $698e3ee4c9e2d960$export$2e2bcd8739ae039(_ref) {
    let { xScale: scale, xAccessor: accessor, yScale: yScale, yAccessor: yAccessor, point: point, data: data } = _ref;
    if (!point) return null;
    const nearestDatum = (0, $e19c591e265a895a$export$2e2bcd8739ae039)({
        scale: scale,
        accessor: accessor,
        scaledValue: point.x,
        data: data
    });
    return nearestDatum ? {
        datum: nearestDatum.datum,
        index: nearestDatum.index,
        distanceX: nearestDatum.distance,
        distanceY: Math.abs(Number(yScale(yAccessor(nearestDatum.datum))) - point.y)
    } : null;
}



function $cbad0121f1caded8$export$2e2bcd8739ae039(_ref) {
    let { yScale: scale, yAccessor: accessor, xScale: xScale, xAccessor: xAccessor, point: point, data: data } = _ref;
    if (!point) return null;
    const nearestDatum = (0, $e19c591e265a895a$export$2e2bcd8739ae039)({
        scale: scale,
        accessor: accessor,
        scaledValue: point.y,
        data: data
    });
    return nearestDatum ? {
        datum: nearestDatum.datum,
        index: nearestDatum.index,
        distanceY: nearestDatum.distance,
        distanceX: Math.abs(Number(xScale(xAccessor(nearestDatum.datum))) - point.x)
    } : null;
}



const $02a402fc28bf7f67$export$76917c244f8b44cb = '__POINTER_EVENTS_ALL';
const $02a402fc28bf7f67$export$ee16f91d64c2973e = '__POINTER_EVENTS_NEAREST';
function $02a402fc28bf7f67$export$2e2bcd8739ae039(_ref) {
    let { dataKey: dataKey, findNearestDatum: findNearestDatumProps, onBlur: onBlur, onFocus: onFocus, onPointerMove: onPointerMove, onPointerOut: onPointerOut, onPointerUp: onPointerUp, onPointerDown: onPointerDown, allowedSources: allowedSources } = _ref;
    const { width: width, height: height, horizontal: horizontal, dataRegistry: dataRegistry, xScale: xScale, yScale: yScale } = (0, $5E6i4.useContext)((0, $89eeb2e4952e291d$export$2e2bcd8739ae039));
    const findNearestDatum = findNearestDatumProps || (horizontal ? (0, $cbad0121f1caded8$export$2e2bcd8739ae039) : (0, $698e3ee4c9e2d960$export$2e2bcd8739ae039));
    // this logic is shared by pointerup, pointermove, and focus handlers
    const getHandlerParams = (0, $5E6i4.useCallback)((params)=>{
        const { svgPoint: svgPoint, event: event } = params || {};
        const pointerParamsByKey = {};
        // nearest Datum across all dataKeys, if relevant
        let nearestDatumPointerParams = null;
        let nearestDatumDistance = Infinity;
        if (params && event && svgPoint && width && height) {
            const considerAllKeys = dataKey === $02a402fc28bf7f67$export$ee16f91d64c2973e || dataKey === $02a402fc28bf7f67$export$76917c244f8b44cb;
            const dataKeys = considerAllKeys ? dataRegistry?.keys() ?? [] : Array.isArray(dataKey) ? dataKey : [
                dataKey
            ];
            // find nearestDatum for relevant dataKey(s)
            dataKeys.forEach((key)=>{
                const entry = dataRegistry?.get(key);
                if (entry) {
                    const nearestDatum = findNearestDatum({
                        dataKey: key,
                        data: entry.data,
                        height: height,
                        point: svgPoint,
                        width: width,
                        xAccessor: entry.xAccessor,
                        xScale: xScale,
                        yAccessor: entry.yAccessor,
                        yScale: yScale
                    });
                    if (nearestDatum) {
                        pointerParamsByKey[key] = {
                            key: key,
                            svgPoint: svgPoint,
                            event: event,
                            ...nearestDatum
                        };
                        // compute nearest Datum if not emitting events for all keys
                        if (dataKey === $02a402fc28bf7f67$export$ee16f91d64c2973e) {
                            const distance = Math.sqrt((nearestDatum.distanceX ?? Infinity) + (nearestDatum.distanceY ?? Infinity));
                            nearestDatumPointerParams = distance < nearestDatumDistance ? pointerParamsByKey[key] : nearestDatumPointerParams;
                            nearestDatumDistance = Math.min(nearestDatumDistance, distance);
                        }
                    }
                }
            });
            const pointerParams = dataKey === $02a402fc28bf7f67$export$ee16f91d64c2973e ? [
                nearestDatumPointerParams
            ] : dataKey === $02a402fc28bf7f67$export$76917c244f8b44cb || Array.isArray(dataKey) ? Object.values(pointerParamsByKey) : [
                pointerParamsByKey[dataKey]
            ];
            return pointerParams.filter((param)=>param);
        }
        return [];
    }, [
        dataKey,
        dataRegistry,
        xScale,
        yScale,
        width,
        height,
        findNearestDatum
    ]);
    const handlePointerMove = (0, $5E6i4.useCallback)((params)=>{
        if (onPointerMove) getHandlerParams(params).forEach((p)=>onPointerMove(p));
    }, [
        getHandlerParams,
        onPointerMove
    ]);
    const handlePointerUp = (0, $5E6i4.useCallback)((params)=>{
        if (onPointerUp) getHandlerParams(params).forEach((p)=>onPointerUp(p));
    }, [
        getHandlerParams,
        onPointerUp
    ]);
    const handlePointerDown = (0, $5E6i4.useCallback)((params)=>{
        if (onPointerDown) getHandlerParams(params).forEach((p)=>onPointerDown(p));
    }, [
        getHandlerParams,
        onPointerDown
    ]);
    const handleFocus = (0, $5E6i4.useCallback)((params)=>{
        if (onFocus) getHandlerParams(params).forEach((p)=>onFocus(p));
    }, [
        getHandlerParams,
        onFocus
    ]);
    const handlePointerOut = (0, $5E6i4.useCallback)((params)=>{
        const event = params?.event;
        if (event && (0, $3da9593b22e14311$export$1d0a87a519049f8c)(event) && onPointerOut) onPointerOut(event);
    }, [
        onPointerOut
    ]);
    const handleBlur = (0, $5E6i4.useCallback)((params)=>{
        const event = params?.event;
        if (event && (0, $3da9593b22e14311$export$9829d00ac5f2232d)(event) && onBlur) onBlur(event);
    }, [
        onBlur
    ]);
    (0, $6c01a54159ea3986$export$2e2bcd8739ae039)('pointermove', onPointerMove ? handlePointerMove : undefined, allowedSources);
    (0, $6c01a54159ea3986$export$2e2bcd8739ae039)('pointerout', onPointerOut ? handlePointerOut : undefined, allowedSources);
    (0, $6c01a54159ea3986$export$2e2bcd8739ae039)('pointerup', onPointerUp ? handlePointerUp : undefined, allowedSources);
    (0, $6c01a54159ea3986$export$2e2bcd8739ae039)('pointerdown', onPointerDown ? handlePointerDown : undefined, allowedSources);
    (0, $6c01a54159ea3986$export$2e2bcd8739ae039)('focus', onFocus ? handleFocus : undefined, allowedSources);
    (0, $6c01a54159ea3986$export$2e2bcd8739ae039)('blur', onBlur ? handleBlur : undefined, allowedSources);
}



const $2216e32732176be2$var$DEFAULT_MARGIN = {
    top: 50,
    right: 50,
    bottom: 50,
    left: 50
};
const $2216e32732176be2$var$allowedEventSources = [
    (0, $ea50bd05f08590bd$export$69b1818e3c4e83f9)
];
function $2216e32732176be2$export$2e2bcd8739ae039(props) {
    const { accessibilityLabel: accessibilityLabel = 'XYChart', captureEvents: captureEvents = true, children: children, height: height, horizontal: horizontal, margin: margin = $2216e32732176be2$var$DEFAULT_MARGIN, onPointerMove: onPointerMove, onPointerOut: onPointerOut, onPointerUp: onPointerUp, onPointerDown: onPointerDown, pointerEventsDataKey: pointerEventsDataKey = 'nearest', theme: theme, width: width, xScale: xScale, yScale: yScale, // pass prop to context so it can be used anywhere
    resizeObserverPolyfill: resizeObserverPolyfillProp } = props;
    const { setDimensions: setDimensions, resizeObserverPolyfill: resizeObserverPolyfill } = (0, $5E6i4.useContext)((0, $89eeb2e4952e291d$export$2e2bcd8739ae039));
    const tooltipContext = (0, $5E6i4.useContext)((0, $7b4c170e6fbbacb9$export$2e2bcd8739ae039));
    const emit = (0, $6c01a54159ea3986$export$2e2bcd8739ae039)();
    // update dimensions in context
    (0, $5E6i4.useEffect)(()=>{
        if (setDimensions && width != null && height != null && width > 0 && height > 0) setDimensions({
            width: width,
            height: height,
            margin: margin
        });
    }, [
        setDimensions,
        width,
        height,
        margin
    ]);
    const eventEmitters = (0, $5398e509b78bd2e9$export$2e2bcd8739ae039)({
        source: (0, $ea50bd05f08590bd$export$69b1818e3c4e83f9)
    });
    (0, $02a402fc28bf7f67$export$2e2bcd8739ae039)({
        dataKey: pointerEventsDataKey === 'nearest' ? (0, $02a402fc28bf7f67$export$ee16f91d64c2973e) : (0, $02a402fc28bf7f67$export$76917c244f8b44cb),
        onPointerMove: onPointerMove,
        onPointerOut: onPointerOut,
        onPointerUp: onPointerUp,
        onPointerDown: onPointerDown,
        allowedSources: $2216e32732176be2$var$allowedEventSources
    });
    // if Context or dimensions are not available, wrap self in the needed providers
    if (!setDimensions) {
        if (!xScale || !yScale) {
            console.warn('[@visx/xychart] XYChart: When no DataProvider is available in context, you must pass xScale & yScale config to XYChart.');
            return null;
        }
        return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $0d5dd104263953b8$export$2e2bcd8739ae039), {
            xScale: xScale,
            yScale: yScale,
            theme: theme,
            initialDimensions: {
                width: width,
                height: height,
                margin: margin
            },
            horizontal: horizontal,
            resizeObserverPolyfill: resizeObserverPolyfillProp,
            children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($2216e32732176be2$export$2e2bcd8739ae039, {
                ...props
            })
        });
    }
    if (width == null || height == null) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $66012142a13b7a2b$export$2e2bcd8739ae039), {
        resizeObserverPolyfill: resizeObserverPolyfill,
        children: (dims)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($2216e32732176be2$export$2e2bcd8739ae039, {
                ...props,
                width: props.width == null ? dims.width : props.width,
                height: props.height == null ? dims.height : props.height
            })
    });
    if (tooltipContext == null) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $6150be618b9e8550$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($2216e32732176be2$export$2e2bcd8739ae039, {
            ...props
        })
    });
    // EventEmitterProvider should be the last wrapper so we do not duplicate handlers
    if (emit == null) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $6c7df19502598e56$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($2216e32732176be2$export$2e2bcd8739ae039, {
            ...props
        })
    });
    if (width <= 0 || height <= 0) return null;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("svg", {
        width: width,
        height: height,
        "aria-label": accessibilityLabel,
        children: [
            children,
            captureEvents && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("rect", {
                x: margin.left,
                y: margin.top,
                width: width - margin.left - margin.right,
                height: height - margin.top - margin.bottom,
                fill: "transparent",
                ...eventEmitters
            })
        ]
    });
}



var $5E6i4 = parcelRequire("5E6i4");




function $6d06d25c93208edf$export$2e2bcd8739ae039(scale, accessor) {
    let align = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'center';
    return (d)=>{
        const scaledValue = scale(accessor(d));
        if ((0, $0e64952a2d1e8b9b$export$2e2bcd8739ae039)(scaledValue)) {
            const bandwidthOffset = (align === 'start' ? 0 : (0, $db2a599b5b32ff26$export$2e2bcd8739ae039)(scale)) / (align === 'center' ? 2 : 1);
            return scaledValue + bandwidthOffset;
        }
        return NaN;
    };
}




function $491a89eb18c3b50f$export$2e2bcd8739ae039(scale) {
    const [a, b] = scale.range().map((rangeBoundary)=>(0, $c32ed8852dffe2f4$export$2e2bcd8739ae039)(rangeBoundary) ?? 0);
    const isDescending = a != null && b != null && b < a;
    const maybeScaleZero = scale(0);
    const [minOutput, maxOutput] = isDescending ? [
        b,
        a
    ] : [
        a,
        b
    ];
    // if maybeScaleZero _is_ a number, but the scale is not clamped and it's outside the domain
    // fallback to the scale's minimum
    return isDescending ? (0, $0e64952a2d1e8b9b$export$2e2bcd8739ae039)(maybeScaleZero) ? Math.min(Math.max(minOutput, maybeScaleZero), maxOutput) : maxOutput : (0, $0e64952a2d1e8b9b$export$2e2bcd8739ae039)(maybeScaleZero) ? Math.max(maybeScaleZero, minOutput) : minOutput;
}





var $5E6i4 = parcelRequire("5E6i4");





var $5E6i4 = parcelRequire("5E6i4");



function $525e2ebff06e337c$export$2e2bcd8739ae039(_ref) {
    let { dataKey: dataKey, enableEvents: enableEvents, findNearestDatum: findNearestDatum, onBlur: onBlurProps, onFocus: onFocusProps, onPointerMove: onPointerMoveProps, onPointerOut: onPointerOutProps, onPointerUp: onPointerUpProps, onPointerDown: onPointerDownProps, source: source, allowedSources: allowedSources } = _ref;
    const { showTooltip: showTooltip, hideTooltip: hideTooltip } = (0, $5E6i4.useContext)((0, $7b4c170e6fbbacb9$export$2e2bcd8739ae039)) ?? {};
    const onPointerMove = (0, $5E6i4.useCallback)((params)=>{
        showTooltip(params);
        if (onPointerMoveProps) onPointerMoveProps(params);
    }, [
        showTooltip,
        onPointerMoveProps
    ]);
    const onFocus = (0, $5E6i4.useCallback)((params)=>{
        showTooltip(params);
        if (onFocusProps) onFocusProps(params);
    }, [
        showTooltip,
        onFocusProps
    ]);
    const onPointerOut = (0, $5E6i4.useCallback)((event)=>{
        hideTooltip();
        if (event && onPointerOutProps) onPointerOutProps(event);
    }, [
        hideTooltip,
        onPointerOutProps
    ]);
    const onBlur = (0, $5E6i4.useCallback)((event)=>{
        hideTooltip();
        if (event && onBlurProps) onBlurProps(event);
    }, [
        hideTooltip,
        onBlurProps
    ]);
    const onPointerDown = (0, $5E6i4.useCallback)((params)=>{
        showTooltip(params);
        if (onPointerDownProps) onPointerDownProps(params);
    }, [
        showTooltip,
        onPointerDownProps
    ]);
    (0, $02a402fc28bf7f67$export$2e2bcd8739ae039)({
        dataKey: dataKey,
        findNearestDatum: findNearestDatum,
        onBlur: enableEvents ? onBlur : undefined,
        onFocus: enableEvents ? onFocus : undefined,
        onPointerMove: enableEvents ? onPointerMove : undefined,
        onPointerOut: enableEvents ? onPointerOut : undefined,
        onPointerUp: enableEvents ? onPointerUpProps : undefined,
        onPointerDown: enableEvents ? onPointerDown : undefined,
        allowedSources: allowedSources
    });
    return (0, $5398e509b78bd2e9$export$2e2bcd8739ae039)({
        source: source,
        onBlur: !!onBlurProps && enableEvents,
        onFocus: !!onFocusProps && enableEvents,
        onPointerMove: !!onPointerMoveProps && enableEvents,
        onPointerOut: !!onPointerOutProps && enableEvents,
        onPointerUp: !!onPointerUpProps && enableEvents,
        onPointerDown: !!onPointerDownProps && enableEvents
    });
}



function $3481b14a5a91b691$export$8fc9707bca69433a(_ref) {
    let { colorAccessor: colorAccessor, data: data, dataKey: dataKey, onBlur: onBlur, onFocus: onFocus, onPointerMove: onPointerMove, onPointerOut: onPointerOut, onPointerUp: onPointerUp, onPointerDown: onPointerDown, enableEvents: enableEvents = true, renderGlyphs: renderGlyphs, size: size = 8, xAccessor: xAccessor, xScale: xScale, yAccessor: yAccessor, yScale: yScale } = _ref;
    const { colorScale: colorScale, theme: theme, horizontal: horizontal } = (0, $5E6i4.useContext)((0, $89eeb2e4952e291d$export$2e2bcd8739ae039));
    const getScaledX = (0, $5E6i4.useMemo)(()=>(0, $6d06d25c93208edf$export$2e2bcd8739ae039)(xScale, xAccessor), [
        xScale,
        xAccessor
    ]);
    const getScaledY = (0, $5E6i4.useMemo)(()=>(0, $6d06d25c93208edf$export$2e2bcd8739ae039)(yScale, yAccessor), [
        yScale,
        yAccessor
    ]);
    const color = colorScale?.(dataKey) ?? theme?.colors?.[0] ?? '#222';
    const ownEventSourceKey = `${(0, $ea50bd05f08590bd$export$64f476fc17eeef05)}-${dataKey}`;
    const eventEmitters = (0, $525e2ebff06e337c$export$2e2bcd8739ae039)({
        dataKey: dataKey,
        enableEvents: enableEvents,
        onBlur: onBlur,
        onFocus: onFocus,
        onPointerMove: onPointerMove,
        onPointerOut: onPointerOut,
        onPointerUp: onPointerUp,
        onPointerDown: onPointerDown,
        source: ownEventSourceKey,
        allowedSources: [
            (0, $ea50bd05f08590bd$export$69b1818e3c4e83f9),
            ownEventSourceKey
        ]
    });
    const glyphs = (0, $5E6i4.useMemo)(()=>data.map((datum, i)=>{
            const x = getScaledX(datum);
            if (!(0, $0e64952a2d1e8b9b$export$2e2bcd8739ae039)(x)) return null;
            const y = getScaledY(datum);
            if (!(0, $0e64952a2d1e8b9b$export$2e2bcd8739ae039)(y)) return null;
            return {
                key: `${i}`,
                x: x,
                y: y,
                color: colorAccessor?.(datum, i) ?? color,
                size: typeof size === 'function' ? size(datum) : size,
                datum: datum
            };
        }).filter((point)=>point), [
        color,
        colorAccessor,
        data,
        getScaledX,
        getScaledY,
        size
    ]);
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: renderGlyphs({
            glyphs: glyphs,
            xScale: xScale,
            yScale: yScale,
            horizontal: horizontal,
            ...eventEmitters
        })
    });
}
function $3481b14a5a91b691$export$2e2bcd8739ae039(props) {
    const { dataKey: dataKey, data: data, xAccessor: xAccessor, yAccessor: yAccessor } = props;
    const { xScale: xScale, yScale: yScale, dataRegistry: dataRegistry } = (0, $5E6i4.useContext)((0, $89eeb2e4952e291d$export$2e2bcd8739ae039));
    (0, $5E6i4.useEffect)(()=>{
        if (dataRegistry) dataRegistry.registerData({
            key: dataKey,
            data: data,
            xAccessor: xAccessor,
            yAccessor: yAccessor
        });
        return ()=>dataRegistry?.unregisterData(dataKey);
    }, [
        dataRegistry,
        dataKey,
        data,
        xAccessor,
        yAccessor
    ]);
    const registryEntry = dataRegistry?.get(dataKey);
    // if scales or data are not available in context, render nothing
    if (!xScale || !yScale || !registryEntry) return null;
    // otherwise pass props + over-write data/accessors
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($3481b14a5a91b691$export$8fc9707bca69433a, {
        ...props,
        xScale: xScale,
        yScale: yScale,
        data: registryEntry.data,
        xAccessor: registryEntry.xAccessor,
        yAccessor: registryEntry.yAccessor
    });
}



function $78a9902da6fac585$export$2e2bcd8739ae039(_ref) {
    let { key: key, color: color, x: x, y: y, size: size, onBlur: onBlur, onFocus: onFocus, onPointerMove: onPointerMove, onPointerOut: onPointerOut, onPointerUp: onPointerUp } = _ref;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("circle", {
        className: "visx-circle-glyph",
        tabIndex: onBlur || onFocus ? 0 : undefined,
        fill: color,
        r: size / 2,
        cx: x,
        cy: y,
        onBlur: onBlur,
        onFocus: onFocus,
        onPointerMove: onPointerMove,
        onPointerOut: onPointerOut,
        onPointerUp: onPointerUp
    }, key);
}




function $3741da8c049ee8fe$var$BaseAreaSeries(_ref) {
    let { PathComponent: PathComponent = 'path', curve: curve, data: data, dataKey: dataKey, lineProps: lineProps, onBlur: onBlur, onFocus: onFocus, onPointerMove: onPointerMove, onPointerOut: onPointerOut, onPointerUp: onPointerUp, onPointerDown: onPointerDown, enableEvents: enableEvents = true, renderLine: renderLine = true, xAccessor: xAccessor, x0Accessor: x0Accessor, xScale: xScale, yAccessor: yAccessor, y0Accessor: y0Accessor, yScale: yScale, ...areaProps } = _ref;
    const { colorScale: colorScale, theme: theme, horizontal: horizontal } = (0, $5E6i4.useContext)((0, $89eeb2e4952e291d$export$2e2bcd8739ae039));
    const getScaledX0 = (0, $5E6i4.useMemo)(()=>x0Accessor ? (0, $6d06d25c93208edf$export$2e2bcd8739ae039)(xScale, x0Accessor) : undefined, [
        xScale,
        x0Accessor
    ]);
    const getScaledX = (0, $5E6i4.useMemo)(()=>(0, $6d06d25c93208edf$export$2e2bcd8739ae039)(xScale, xAccessor), [
        xScale,
        xAccessor
    ]);
    const getScaledY0 = (0, $5E6i4.useMemo)(()=>y0Accessor ? (0, $6d06d25c93208edf$export$2e2bcd8739ae039)(yScale, y0Accessor) : undefined, [
        yScale,
        y0Accessor
    ]);
    const getScaledY = (0, $5E6i4.useMemo)(()=>(0, $6d06d25c93208edf$export$2e2bcd8739ae039)(yScale, yAccessor), [
        yScale,
        yAccessor
    ]);
    const isDefined = (0, $5E6i4.useCallback)((d)=>(0, $0e64952a2d1e8b9b$export$2e2bcd8739ae039)(xScale(xAccessor(d))) && (0, $0e64952a2d1e8b9b$export$2e2bcd8739ae039)(yScale(yAccessor(d))), [
        xScale,
        xAccessor,
        yScale,
        yAccessor
    ]);
    const color = colorScale?.(dataKey) ?? theme?.colors?.[0] ?? '#222';
    const ownEventSourceKey = `${(0, $ea50bd05f08590bd$export$7b61f117b26ab7e7)}-${dataKey}`;
    const eventEmitters = (0, $525e2ebff06e337c$export$2e2bcd8739ae039)({
        dataKey: dataKey,
        enableEvents: enableEvents,
        onBlur: onBlur,
        onFocus: onFocus,
        onPointerMove: onPointerMove,
        onPointerOut: onPointerOut,
        onPointerUp: onPointerUp,
        onPointerDown: onPointerDown,
        source: ownEventSourceKey,
        allowedSources: [
            (0, $ea50bd05f08590bd$export$69b1818e3c4e83f9),
            ownEventSourceKey
        ]
    });
    // accessor functions for the area generator
    const accessors = (0, $5E6i4.useMemo)(()=>{
        const numericScaleBaseline = (0, $491a89eb18c3b50f$export$2e2bcd8739ae039)(horizontal ? xScale : yScale);
        return horizontal ? {
            x0: getScaledX0 ?? numericScaleBaseline,
            x1: getScaledX,
            y: getScaledY
        } : {
            x: getScaledX,
            y0: getScaledY0 ?? numericScaleBaseline,
            y1: getScaledY
        };
    }, [
        xScale,
        yScale,
        horizontal,
        getScaledX,
        getScaledY,
        getScaledX0,
        getScaledY0
    ]);
    // render invisible glyphs for focusing if onFocus/onBlur are defined
    const captureFocusEvents = Boolean(onFocus || onBlur);
    const renderGlyphs = (0, $5E6i4.useCallback)((_ref2)=>{
        let { glyphs: glyphs } = _ref2;
        return captureFocusEvents ? glyphs.map((glyph)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $5E6i4.Fragment), {
                children: (0, $78a9902da6fac585$export$2e2bcd8739ae039)({
                    ...glyph,
                    color: 'transparent',
                    onFocus: eventEmitters.onFocus,
                    onBlur: eventEmitters.onBlur
                })
            }, glyph.key)) : null;
    }, [
        captureFocusEvents,
        eventEmitters.onFocus,
        eventEmitters.onBlur
    ]);
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)((0, $90cae257cc958273$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $ae7af5d88f7c9f70$export$2e2bcd8739ae039), {
                ...accessors,
                ...areaProps,
                curve: curve,
                defined: isDefined,
                children: (_ref3)=>{
                    let { path: path } = _ref3;
                    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(PathComponent, {
                        className: "visx-area",
                        stroke: "transparent",
                        fill: color,
                        strokeLinecap: "round" // without this a datum surrounded by nulls will not be visible
                        ,
                        ...areaProps,
                        d: path(data) || '',
                        ...eventEmitters
                    });
                }
            }),
            renderLine && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $c006d6ed47f7fa5f$export$2e2bcd8739ae039), {
                x: getScaledX,
                y: getScaledY,
                defined: isDefined,
                curve: curve,
                ...lineProps,
                children: (_ref4)=>{
                    let { path: path } = _ref4;
                    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(PathComponent, {
                        className: "visx-line",
                        fill: "transparent",
                        stroke: color,
                        strokeWidth: 2,
                        pointerEvents: "none",
                        strokeLinecap: "round" // without this a datum surrounded by nulls will not be visible
                        ,
                        ...lineProps,
                        d: path(data) || ''
                    });
                }
            }),
            captureFocusEvents && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $3481b14a5a91b691$export$8fc9707bca69433a), {
                dataKey: dataKey,
                data: data,
                xAccessor: xAccessor,
                yAccessor: yAccessor,
                xScale: xScale,
                yScale: yScale,
                renderGlyphs: renderGlyphs
            })
        ]
    });
}
function $3741da8c049ee8fe$export$2e2bcd8739ae039(props) {
    const { dataKey: dataKey, data: data, xAccessor: xAccessor, yAccessor: yAccessor } = props;
    const { xScale: xScale, yScale: yScale, dataRegistry: dataRegistry } = (0, $5E6i4.useContext)((0, $89eeb2e4952e291d$export$2e2bcd8739ae039));
    (0, $5E6i4.useEffect)(()=>{
        if (dataRegistry) dataRegistry.registerData({
            key: dataKey,
            data: data,
            xAccessor: xAccessor,
            yAccessor: yAccessor
        });
        return ()=>dataRegistry?.unregisterData(dataKey);
    }, [
        dataRegistry,
        dataKey,
        data,
        xAccessor,
        yAccessor
    ]);
    const registryEntry = dataRegistry?.get(dataKey);
    // if scales or data are not available in context, render nothing
    if (!xScale || !yScale || !registryEntry) return null;
    // otherwise pass props + over-write data/accessors
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($3741da8c049ee8fe$var$BaseAreaSeries, {
        ...props,
        xScale: xScale,
        yScale: yScale,
        data: registryEntry.data,
        xAccessor: registryEntry.xAccessor,
        yAccessor: registryEntry.yAccessor
    });
}



function $9a3c3a64f8c44e5b$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $3741da8c049ee8fe$export$2e2bcd8739ae039), {
        ...props
    });
}



var $5E6i4 = parcelRequire("5E6i4");





var $5E6i4 = parcelRequire("5E6i4");






const $b6c023a85b474122$var$getStack = (bar)=>bar?.data?.stack;
// returns average of top + bottom of bar (the middle) as this enables more accurately
// finding the nearest datum to a FocusEvent (which is based on the middle of the rect bounding box)
const $b6c023a85b474122$var$getNumericValue = (bar)=>((0, $c5a13e2a3e68b248$export$fbdeaa6a76694f71)(bar) + (0, $c5a13e2a3e68b248$export$18f9732b2021233c)(bar)) / 2;
function $b6c023a85b474122$export$2e2bcd8739ae039(stackedData, comprehensiveDomain, horizontal) {
    const [xAccessor, yAccessor] = horizontal ? [
        $b6c023a85b474122$var$getNumericValue,
        $b6c023a85b474122$var$getStack
    ] : [
        $b6c023a85b474122$var$getStack,
        $b6c023a85b474122$var$getNumericValue
    ];
    return stackedData.map((data, index)=>{
        const entry = {
            key: data.key,
            data: data,
            xAccessor: xAccessor,
            yAccessor: yAccessor
        };
        // update the numeric domain to account for full data stack
        // only need to do this for one key
        if (comprehensiveDomain.length > 0 && index === 0) {
            if (horizontal) entry.xScale = (scale)=>scale.domain((0, $6b7620569dc79965$export$2e2bcd8739ae039)(scale.domain().concat(comprehensiveDomain)));
            else entry.yScale = (scale)=>scale.domain((0, $6b7620569dc79965$export$2e2bcd8739ae039)(scale.domain().concat(comprehensiveDomain)));
        }
        return entry;
    }).filter((entry)=>entry);
}


/** Returns the value which forms a stack group. */ const $d2b0065d3c9ce23f$export$9882dd06892ae868 = (d)=>d.stack;
function $d2b0065d3c9ce23f$export$2e2bcd8739ae039(seriesChildren, horizontal) {
    const dataByStackValue = new Map();
    seriesChildren.forEach((child)=>{
        const { dataKey: dataKey, data: data, xAccessor: xAccessor, yAccessor: yAccessor } = child.props;
        // this should exist but double check
        if (!xAccessor || !yAccessor) return;
        const [stackFn, valueFn] = horizontal ? [
            yAccessor,
            xAccessor
        ] : [
            xAccessor,
            yAccessor
        ];
        data.forEach((d)=>{
            const stack = stackFn(d);
            const numericValue = valueFn(d);
            const stackKey = String(stack);
            if (!dataByStackValue.has(stackKey)) dataByStackValue.set(stackKey, {
                stack: stack,
                positiveSum: 0,
                negativeSum: 0
            });
            const stackEntry = dataByStackValue.get(stackKey);
            stackEntry[dataKey] = numericValue;
            stackEntry[numericValue >= 0 ? 'positiveSum' : 'negativeSum'] += numericValue;
        });
    });
    return Array.from(dataByStackValue.values());
}



var $5E6i4 = parcelRequire("5E6i4");
/** Returns whether the ReactNode has props (and therefore is an `Element` versus primitive type) */ function $7ed14d9802759345$var$isChildWithProps(child) {
    return !!child && typeof child === 'object' && 'props' in child && child.props != null;
}
function $7ed14d9802759345$export$2e2bcd8739ae039(children) {
    return (0, $5E6i4.Children).toArray(children).flatMap((child)=>{
        if ($7ed14d9802759345$var$isChildWithProps(child) && child.props.children) return child.props.children;
        return child;
    }).filter((child)=>$7ed14d9802759345$var$isChildWithProps(child));
}


function $e35a346be91c9600$export$2e2bcd8739ae039(_ref) {
    let { children: children, order: order, offset: offset } = _ref;
    const { horizontal: horizontal, registerData: registerData, unregisterData: unregisterData } = (0, $5E6i4.useContext)((0, $89eeb2e4952e291d$export$2e2bcd8739ae039));
    // find series children
    // @TODO: memoization doesn't work well if at all for this
    const seriesChildren = (0, $5E6i4.useMemo)(()=>(0, $7ed14d9802759345$export$2e2bcd8739ae039)(children), [
        children
    ]);
    // extract data keys from child series
    const dataKeys = (0, $5E6i4.useMemo)(()=>seriesChildren.filter((child)=>child.props.dataKey).map((child)=>child.props.dataKey), [
        seriesChildren
    ]);
    // group all child data by stack value { [x | y]: { [dataKey]: value } }
    // this format is needed by d3Stack
    const combinedData = (0, $5E6i4.useMemo)(()=>(0, $d2b0065d3c9ce23f$export$2e2bcd8739ae039)(seriesChildren, horizontal), [
        horizontal,
        seriesChildren
    ]);
    // stack data
    const stackedData = (0, $5E6i4.useMemo)(()=>{
        // automatically set offset to diverging if it's undefined and negative values are present
        const hasSomeNegativeValues = offset ? null : combinedData.some((d)=>d.negativeSum < 0);
        const stack = (0, $6be110a9c654dd03$export$2e2bcd8739ae039)();
        stack.keys(dataKeys);
        if (order) stack.order((0, $b5407fe64a34b7cf$export$2e2bcd8739ae039)(order));
        if (offset || hasSomeNegativeValues) stack.offset((0, $f69514daf01a6903$export$2e2bcd8739ae039)(offset || 'diverging'));
        return stack(combinedData);
    }, [
        combinedData,
        dataKeys,
        order,
        offset
    ]);
    // update the domain to account for the (directional) stacked value
    const comprehensiveDomain = (0, $5E6i4.useMemo)(()=>(0, $6b7620569dc79965$export$2e2bcd8739ae039)(stackedData.reduce((allDatum, stack)=>{
            stack.forEach((_ref2)=>{
                let [min, max] = _ref2;
                allDatum.push(min);
                allDatum.push(max);
            });
            return allDatum;
        }, [])), [
        stackedData
    ]);
    // register all child data using the stack-transformed values
    (0, $5E6i4.useEffect)(()=>{
        const dataToRegister = (0, $b6c023a85b474122$export$2e2bcd8739ae039)(stackedData, comprehensiveDomain, horizontal);
        registerData(dataToRegister);
        // unregister data on unmount
        return ()=>unregisterData(dataKeys);
    }, [
        dataKeys,
        comprehensiveDomain,
        horizontal,
        stackedData,
        registerData,
        unregisterData,
        seriesChildren
    ]);
    return {
        seriesChildren: seriesChildren,
        dataKeys: dataKeys,
        stackedData: stackedData
    };
}







function $ee222afb4e9b93ff$export$2e2bcd8739ae039(nearestDatumArgs, seriesData, horizontal) {
    const { xScale: xScale, yScale: yScale, point: point } = nearestDatumArgs;
    const datum = (horizontal ? (0, $cbad0121f1caded8$export$2e2bcd8739ae039) : (0, $698e3ee4c9e2d960$export$2e2bcd8739ae039))(nearestDatumArgs);
    const seriesDatum = datum?.index == null ? null : seriesData[datum.index];
    return datum && seriesDatum && point ? {
        index: datum.index,
        datum: seriesDatum,
        distanceX: horizontal // if mouse is ON the stack series, set 0 distance
         ? point.x >= Number(xScale((0, $c5a13e2a3e68b248$export$fbdeaa6a76694f71)(datum.datum)) ?? Infinity) && point.x <= Number(xScale((0, $c5a13e2a3e68b248$export$18f9732b2021233c)(datum.datum)) ?? -Infinity) ? 0 : datum.distanceX : datum.distanceX,
        distanceY: horizontal ? datum.distanceY // if mouse is ON the stack series, set 0 distance
         : point.y <= Number(yScale((0, $c5a13e2a3e68b248$export$fbdeaa6a76694f71)(datum.datum)) ?? -Infinity) && point.y >= Number(yScale((0, $c5a13e2a3e68b248$export$18f9732b2021233c)(datum.datum)) ?? Infinity) ? 0 : datum.distanceY
    } : null;
}







const $0afda1b8e4162dac$var$identity = (_)=>_;
function $0afda1b8e4162dac$var$BaseAreaStack(_ref) {
    let { PathComponent: PathComponent = 'path', children: children, curve: curve, enableEvents: enableEvents = true, offset: offset, onBlur: onBlur, onFocus: onFocus, onPointerMove: onPointerMove, onPointerOut: onPointerOut, onPointerUp: onPointerUp, onPointerDown: onPointerDown, order: order, renderLine: renderLine = true } = _ref;
    const { colorScale: colorScale, dataRegistry: dataRegistry, horizontal: horizontal, xScale: xScale, yScale: yScale, theme: theme } = (0, $5E6i4.useContext)((0, $89eeb2e4952e291d$export$2e2bcd8739ae039));
    const { dataKeys: dataKeys, seriesChildren: seriesChildren, stackedData: stackedData } = (0, $e35a346be91c9600$export$2e2bcd8739ae039)({
        children: children,
        order: order,
        offset: offset
    });
    // accessor functions for the stack generator
    const accessors = (0, $5E6i4.useMemo)(()=>{
        const xOffset = (0, $db2a599b5b32ff26$export$2e2bcd8739ae039)(xScale) / 2;
        const yOffset = (0, $db2a599b5b32ff26$export$2e2bcd8739ae039)(yScale) / 2;
        return horizontal ? {
            y: (d)=>((0, $c32ed8852dffe2f4$export$2e2bcd8739ae039)(yScale((0, $d2b0065d3c9ce23f$export$9882dd06892ae868)(d.data))) ?? 0) + yOffset,
            x0: (d)=>((0, $c32ed8852dffe2f4$export$2e2bcd8739ae039)(xScale((0, $c5a13e2a3e68b248$export$fbdeaa6a76694f71)(d))) ?? 0) + xOffset,
            x1: (d)=>((0, $c32ed8852dffe2f4$export$2e2bcd8739ae039)(xScale((0, $c5a13e2a3e68b248$export$18f9732b2021233c)(d))) ?? 0) + xOffset,
            defined: (d)=>(0, $0e64952a2d1e8b9b$export$2e2bcd8739ae039)(yScale((0, $d2b0065d3c9ce23f$export$9882dd06892ae868)(d.data))) && (0, $0e64952a2d1e8b9b$export$2e2bcd8739ae039)(xScale((0, $c5a13e2a3e68b248$export$18f9732b2021233c)(d)))
        } : {
            x: (d)=>((0, $c32ed8852dffe2f4$export$2e2bcd8739ae039)(xScale((0, $d2b0065d3c9ce23f$export$9882dd06892ae868)(d.data))) ?? 0) + xOffset,
            y0: (d)=>((0, $c32ed8852dffe2f4$export$2e2bcd8739ae039)(yScale((0, $c5a13e2a3e68b248$export$fbdeaa6a76694f71)(d))) ?? 0) + yOffset,
            y1: (d)=>((0, $c32ed8852dffe2f4$export$2e2bcd8739ae039)(yScale((0, $c5a13e2a3e68b248$export$18f9732b2021233c)(d))) ?? 0) + yOffset,
            defined: (d)=>(0, $0e64952a2d1e8b9b$export$2e2bcd8739ae039)(xScale((0, $d2b0065d3c9ce23f$export$9882dd06892ae868)(d.data))) && (0, $0e64952a2d1e8b9b$export$2e2bcd8739ae039)(yScale((0, $c5a13e2a3e68b248$export$18f9732b2021233c)(d)))
        };
    }, [
        xScale,
        yScale,
        horizontal
    ]);
    // pull out all area + line props for each dataKey
    const stacks = (0, $5E6i4.useMemo)(()=>stackedData.map((stack, stackIndex)=>{
            const areaSeries = seriesChildren.find((child)=>child.props.dataKey === stack.key);
            const { data: data, dataKey: dataKey, xAccessor: xAccessor, yAccessor: yAccessor, curve: _, PathComponent: __, lineProps: lineProps, renderLine: ___, ...svgPathProps } = areaSeries?.props || {};
            const areaProps = {
                fill: colorScale?.(stack.key) ?? theme?.colors?.[0] ?? '#222',
                ...svgPathProps
            };
            return {
                key: `${stackIndex}-${stack.key}`,
                accessors: accessors,
                data: stack,
                areaProps: areaProps,
                lineProps: lineProps
            };
        }), [
        stackedData,
        accessors,
        colorScale,
        seriesChildren,
        theme
    ]);
    // custom logic to find the nearest AreaStackDatum (context) and return the original Datum (props)
    const findNearestDatum = (0, $5E6i4.useCallback)((params)=>{
        const childData = seriesChildren.find((child)=>child.props.dataKey === params.dataKey)?.props?.data;
        return childData ? (0, $ee222afb4e9b93ff$export$2e2bcd8739ae039)(params, childData, horizontal) : null;
    }, [
        seriesChildren,
        horizontal
    ]);
    const ownEventSourceKey = `${(0, $ea50bd05f08590bd$export$4e49b0cacbdaad4e)}-${dataKeys.join('-')}`;
    const eventEmitters = (0, $525e2ebff06e337c$export$2e2bcd8739ae039)({
        dataKey: dataKeys,
        enableEvents: enableEvents,
        findNearestDatum: // @ts-expect-error Datum input + return type are expected to be the same type but they differ
        // for AreaStack (registry data is StackedDatum, return type is user Datum)
        findNearestDatum,
        onBlur: onBlur,
        onFocus: onFocus,
        onPointerMove: onPointerMove,
        onPointerOut: onPointerOut,
        onPointerUp: onPointerUp,
        onPointerDown: onPointerDown,
        source: ownEventSourceKey,
        allowedSources: [
            (0, $ea50bd05f08590bd$export$69b1818e3c4e83f9),
            ownEventSourceKey
        ]
    });
    // render invisible glyphs for focusing if onFocus/onBlur are defined
    const captureFocusEvents = Boolean(onFocus || onBlur);
    const renderGlyphs = (0, $5E6i4.useCallback)((_ref2)=>{
        let { glyphs: glyphs } = _ref2;
        return captureFocusEvents ? glyphs.map((glyph)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $5E6i4.Fragment), {
                children: (0, $78a9902da6fac585$export$2e2bcd8739ae039)({
                    ...glyph,
                    color: 'transparent',
                    onFocus: eventEmitters.onFocus,
                    onBlur: eventEmitters.onBlur
                })
            }, glyph.key)) : null;
    }, [
        captureFocusEvents,
        eventEmitters.onFocus,
        eventEmitters.onBlur
    ]);
    // if scales and data are not available in the registry, bail
    if (dataKeys.some((key)=>dataRegistry.get(key) == null) || !xScale || !yScale || !colorScale) return null;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("g", {
        className: "visx-area-stack",
        children: [
            stacks.map((stack)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $ae7af5d88f7c9f70$export$2e2bcd8739ae039), {
                    curve: curve,
                    ...stack.accessors,
                    children: (_ref3)=>{
                        let { path: path } = _ref3;
                        return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(PathComponent, {
                            className: "visx-area",
                            stroke: "transparent",
                            d: path(stack.data) || '',
                            ...stack.areaProps,
                            ...eventEmitters
                        });
                    }
                }, stack.key)),
            renderLine && stacks.map((stack)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $c006d6ed47f7fa5f$export$2e2bcd8739ae039), {
                    // note: this currently doesn't work well for offset=wiggle
                    // because it only draws a single line. with two lines you
                    // get overlap across stacks :/
                    x: stack.accessors.x || stack.accessors.x1,
                    y: stack.accessors.y || stack.accessors.y1,
                    defined: stack.accessors.defined,
                    curve: curve,
                    ...stack.lineProps,
                    children: (_ref4)=>{
                        let { path: path } = _ref4;
                        return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(PathComponent, {
                            className: "visx-line",
                            fill: "transparent",
                            stroke: stack.areaProps.fill,
                            strokeWidth: 2,
                            pointerEvents: "none",
                            ...stack.lineProps,
                            d: path(stack.data) || ''
                        });
                    }
                }, `line-${stack.key}`)),
            captureFocusEvents && stacks.map((_, i)=>{
                // render in reverse stack order tab to top-values first
                const stack = stacks[stacks.length - i - 1];
                return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $3481b14a5a91b691$export$8fc9707bca69433a), {
                    dataKey: stack.key,
                    data: stack.data,
                    xAccessor: stack.accessors.x || stack.accessors.x1,
                    yAccessor: stack.accessors.y || stack.accessors.y1,
                    xScale: $0afda1b8e4162dac$var$identity,
                    yScale: $0afda1b8e4162dac$var$identity,
                    renderGlyphs: renderGlyphs
                }, `glyphs-${stack.key}`);
            })
        ]
    });
}
var $0afda1b8e4162dac$export$2e2bcd8739ae039 = $0afda1b8e4162dac$var$BaseAreaStack;



function $7f176e44b1550d0a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $0afda1b8e4162dac$export$2e2bcd8739ae039), {
        ...props
    });
}



var $5E6i4 = parcelRequire("5E6i4");









function $b794cc91de99c839$export$2e2bcd8739ae039(nearestDatumArgs, groupScale, horizontal) {
    const { dataKey: dataKey, xAccessor: xAccessor, yAccessor: yAccessor, xScale: xScale, yScale: yScale, point: point } = nearestDatumArgs;
    const datum = (horizontal ? (0, $cbad0121f1caded8$export$2e2bcd8739ae039) : (0, $698e3ee4c9e2d960$export$2e2bcd8739ae039))(nearestDatumArgs);
    if (!datum || !point) return null;
    const barGroupOffset = groupScale(dataKey);
    const barWidth = groupScale.step();
    if (horizontal) {
        const groupPosition = yScale(yAccessor(datum.datum));
        const barStart = (groupPosition ?? Infinity) + (barGroupOffset ?? Infinity);
        const barEnd = barStart + barWidth;
        const barMiddle = (barStart + barEnd) / 2;
        const cursorIsOnBar = point.y >= barStart && point.y <= barEnd;
        return {
            ...datum,
            distanceX: 0,
            // we want all group bars to have same X distance so only Y distance matters
            distanceY: cursorIsOnBar ? 0 : Math.abs(point.y - barMiddle)
        };
    }
    const groupPosition = xScale(xAccessor(datum.datum));
    const barStart = (groupPosition ?? Infinity) + (barGroupOffset ?? Infinity);
    const barEnd = barStart + barWidth;
    const barMiddle = (barStart + barEnd) / 2;
    const cursorIsOnBar = point.x >= barStart && point.x <= barEnd;
    return {
        ...datum,
        distanceY: 0,
        // we want all group bars to have same Y distance so only X distance matters
        distanceX: cursorIsOnBar ? 0 : Math.abs(point.x - barMiddle)
    };
}




function $7768449ad1621004$export$2e2bcd8739ae039(_ref) {
    let { children: children, padding: padding = 0.1, sortBars: sortBars, BarsComponent: BarsComponent, onBlur: onBlur, onFocus: onFocus, onPointerMove: onPointerMove, onPointerOut: onPointerOut, onPointerUp: onPointerUp, onPointerDown: onPointerDown, enableEvents: enableEvents = true } = _ref;
    const { colorScale: colorScale, dataRegistry: dataRegistry, horizontal: horizontal, registerData: registerData, unregisterData: unregisterData, xScale: xScale, yScale: yScale } = (0, $5E6i4.useContext)((0, $89eeb2e4952e291d$export$2e2bcd8739ae039));
    const barSeriesChildren = (0, $5E6i4.useMemo)(()=>(0, $7ed14d9802759345$export$2e2bcd8739ae039)(children), [
        children
    ]);
    // extract data keys from child series
    const dataKeys = (0, $5E6i4.useMemo)(()=>barSeriesChildren.map((child)=>child.props.dataKey ?? '').filter((key)=>key), [
        barSeriesChildren
    ]);
    // register all child data
    (0, $5E6i4.useEffect)(()=>{
        const dataToRegister = barSeriesChildren.map((child)=>{
            const { dataKey: key, data: data, xAccessor: xAccessor, yAccessor: yAccessor } = child.props;
            return {
                key: key,
                data: data,
                xAccessor: xAccessor,
                yAccessor: yAccessor
            };
        });
        registerData(dataToRegister);
        return ()=>unregisterData(dataKeys);
    }, [
        registerData,
        unregisterData,
        barSeriesChildren,
        dataKeys
    ]);
    // create group scale
    const groupScale = (0, $5E6i4.useMemo)(()=>(0, $55c09c3fb6b4542d$export$2e2bcd8739ae039)({
            domain: sortBars ? [
                ...dataKeys
            ].sort(sortBars) : dataKeys,
            range: [
                0,
                (0, $db2a599b5b32ff26$export$2e2bcd8739ae039)(horizontal ? yScale : xScale)
            ],
            padding: padding
        }), [
        sortBars,
        dataKeys,
        xScale,
        yScale,
        horizontal,
        padding
    ]);
    const findNearestDatum = (0, $5E6i4.useCallback)((params)=>(0, $b794cc91de99c839$export$2e2bcd8739ae039)(params, groupScale, horizontal), [
        groupScale,
        horizontal
    ]);
    const ownEventSourceKey = `${(0, $ea50bd05f08590bd$export$c1861ee6e88456a7)}-${dataKeys.join('-')}}`;
    const eventEmitters = (0, $525e2ebff06e337c$export$2e2bcd8739ae039)({
        dataKey: dataKeys,
        enableEvents: enableEvents,
        findNearestDatum: findNearestDatum,
        onBlur: onBlur,
        onFocus: onFocus,
        onPointerMove: onPointerMove,
        onPointerOut: onPointerOut,
        onPointerUp: onPointerUp,
        onPointerDown: onPointerDown,
        source: ownEventSourceKey,
        allowedSources: [
            (0, $ea50bd05f08590bd$export$69b1818e3c4e83f9),
            ownEventSourceKey
        ]
    });
    const xZeroPosition = (0, $5E6i4.useMemo)(()=>xScale ? (0, $491a89eb18c3b50f$export$2e2bcd8739ae039)(xScale) : 0, [
        xScale
    ]);
    const yZeroPosition = (0, $5E6i4.useMemo)(()=>yScale ? (0, $491a89eb18c3b50f$export$2e2bcd8739ae039)(yScale) : 0, [
        yScale
    ]);
    const registryEntries = dataKeys.map((key)=>dataRegistry.get(key));
    // if scales and data are not available in the registry, bail
    if (registryEntries.some((entry)=>entry == null) || !xScale || !yScale || !colorScale) return null;
    const barThickness = (0, $db2a599b5b32ff26$export$2e2bcd8739ae039)(groupScale);
    const barSeries = registryEntries.map((_ref2)=>{
        let { xAccessor: xAccessor, yAccessor: yAccessor, data: data, key: key } = _ref2;
        const getLength = (d)=>horizontal ? (xScale(xAccessor(d)) ?? NaN) - xZeroPosition : (yScale(yAccessor(d)) ?? NaN) - yZeroPosition;
        const getGroupPosition = horizontal ? (d)=>yScale(yAccessor(d)) ?? NaN : (d)=>xScale(xAccessor(d)) ?? NaN;
        const withinGroupPosition = groupScale(key) ?? 0;
        const getX = horizontal ? (d)=>xZeroPosition + Math.min(0, getLength(d)) : (d)=>getGroupPosition(d) + withinGroupPosition;
        const getY = horizontal ? (d)=>getGroupPosition(d) + withinGroupPosition : (d)=>yZeroPosition + Math.min(0, getLength(d));
        const getWidth = horizontal ? (d)=>Math.abs(getLength(d)) : ()=>barThickness;
        const getHeight = horizontal ? ()=>barThickness : (d)=>Math.abs(getLength(d));
        // get props from child BarSeries, if available
        const childBarSeries = barSeriesChildren.find((child)=>child.props.dataKey === key);
        const { colorAccessor: colorAccessor, radius: radius, radiusAll: radiusAll, radiusBottom: radiusBottom, radiusLeft: radiusLeft, radiusRight: radiusRight, radiusTop: radiusTop } = childBarSeries?.props || {};
        return {
            key: key,
            radius: radius,
            radiusAll: radiusAll,
            radiusBottom: radiusBottom,
            radiusLeft: radiusLeft,
            radiusRight: radiusRight,
            radiusTop: radiusTop,
            bars: data.map((bar, index)=>{
                const barX = getX(bar);
                if (!(0, $0e64952a2d1e8b9b$export$2e2bcd8739ae039)(barX)) return null;
                const barY = getY(bar);
                if (!(0, $0e64952a2d1e8b9b$export$2e2bcd8739ae039)(barY)) return null;
                const barWidth = getWidth(bar);
                if (!(0, $0e64952a2d1e8b9b$export$2e2bcd8739ae039)(barWidth)) return null;
                const barHeight = getHeight(bar);
                if (!(0, $0e64952a2d1e8b9b$export$2e2bcd8739ae039)(barHeight)) return null;
                return {
                    key: `${key}-${index}`,
                    x: barX,
                    y: barY,
                    width: barWidth,
                    height: barHeight,
                    fill: colorAccessor?.(bar, index) ?? colorScale(key)
                };
            }).filter((bar)=>bar)
        };
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("g", {
        className: "visx-bar-group",
        children: barSeries.map((series)=>series && /*#__PURE__*/ (0, $5E6i4.createElement)(BarsComponent, {
                horizontal: horizontal,
                xScale: xScale,
                yScale: yScale,
                ...series,
                ...eventEmitters,
                key: series.key
            }))
    });
}


/* eslint-disable @typescript-eslint/no-explicit-any */ 

function $aa8afe1bc71a1c3a$export$2e2bcd8739ae039(_ref) {
    let { bars: bars, horizontal: horizontal, xScale: xScale, yScale: yScale, radius: radius, radiusAll: radiusAll, radiusTop: radiusTop, radiusRight: radiusRight, radiusBottom: radiusBottom, radiusLeft: radiusLeft, ...restProps } = _ref;
    const isFocusable = Boolean(restProps.onFocus || restProps.onBlur);
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: bars.map((_ref2)=>{
            let { key: key, ...barProps } = _ref2;
            return radius == null ? /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("rect", {
                className: "visx-bar",
                tabIndex: isFocusable ? 0 : undefined,
                ...barProps,
                ...restProps
            }, key) : /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $9037c5c0e8ce94e9$export$2e2bcd8739ae039), {
                className: "visx-bar",
                tabIndex: isFocusable ? 0 : undefined,
                radius: radius,
                all: radiusAll,
                top: radiusTop,
                right: radiusRight,
                bottom: radiusBottom,
                left: radiusLeft,
                ...barProps,
                ...restProps
            }, key);
        })
    });
}



function $e5c40ec95114b85c$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $7768449ad1621004$export$2e2bcd8739ae039), {
        ...props,
        BarsComponent: (0, $aa8afe1bc71a1c3a$export$2e2bcd8739ae039)
    });
}



var $5E6i4 = parcelRequire("5E6i4");








// Fallback bandwidth estimate assumes no missing data values (divides chart space by # datum)
const $23b9bc497e324d24$var$getFallbackBandwidth = (fullBarWidth, barPadding)=>// clamp padding to [0, 1], bar thickness = (1-padding) * availableSpace
    fullBarWidth * (1 - Math.min(1, Math.max(0, barPadding)));
function $23b9bc497e324d24$var$BaseBarSeries(_ref) {
    let { BarsComponent: BarsComponent, barPadding: barPadding = 0.1, colorAccessor: colorAccessor, data: data, dataKey: dataKey, onBlur: onBlur, onFocus: onFocus, onPointerMove: onPointerMove, onPointerOut: onPointerOut, onPointerUp: onPointerUp, onPointerDown: onPointerDown, enableEvents: enableEvents = true, xAccessor: xAccessor, xScale: xScale, yAccessor: yAccessor, yScale: yScale, ...barComponentProps } = _ref;
    const { colorScale: colorScale, horizontal: horizontal, theme: theme, innerWidth: innerWidth = 0, innerHeight: innerHeight = 0 } = (0, $5E6i4.useContext)((0, $89eeb2e4952e291d$export$2e2bcd8739ae039));
    const getScaledX = (0, $5E6i4.useMemo)(()=>(0, $6d06d25c93208edf$export$2e2bcd8739ae039)(xScale, xAccessor), [
        xScale,
        xAccessor
    ]);
    const getScaledY = (0, $5E6i4.useMemo)(()=>(0, $6d06d25c93208edf$export$2e2bcd8739ae039)(yScale, yAccessor), [
        yScale,
        yAccessor
    ]);
    const scaleBandwidth = (0, $db2a599b5b32ff26$export$2e2bcd8739ae039)(horizontal ? yScale : xScale);
    const barThickness = scaleBandwidth || $23b9bc497e324d24$var$getFallbackBandwidth((horizontal ? innerHeight : innerWidth) / data.length, barPadding);
    const xZeroPosition = (0, $5E6i4.useMemo)(()=>xScale ? (0, $491a89eb18c3b50f$export$2e2bcd8739ae039)(xScale) : 0, [
        xScale
    ]);
    const yZeroPosition = (0, $5E6i4.useMemo)(()=>yScale ? (0, $491a89eb18c3b50f$export$2e2bcd8739ae039)(yScale) : 0, [
        yScale
    ]);
    const color = colorScale?.(dataKey) ?? theme?.colors?.[0] ?? '#222';
    const bars = (0, $5E6i4.useMemo)(()=>{
        const xOffset = horizontal ? 0 : -barThickness / 2;
        const yOffset = horizontal ? -barThickness / 2 : 0;
        return data.map((datum, index)=>{
            const x = getScaledX(datum) + xOffset;
            if (!(0, $0e64952a2d1e8b9b$export$2e2bcd8739ae039)(x)) return null;
            const y = getScaledY(datum) + yOffset;
            if (!(0, $0e64952a2d1e8b9b$export$2e2bcd8739ae039)(y)) return null;
            const barLength = horizontal ? x - xZeroPosition : y - yZeroPosition;
            if (!(0, $0e64952a2d1e8b9b$export$2e2bcd8739ae039)(barLength)) return null;
            return {
                key: `${index}`,
                x: horizontal ? xZeroPosition + Math.min(0, barLength) : x,
                y: horizontal ? y : yZeroPosition + Math.min(0, barLength),
                width: horizontal ? Math.abs(barLength) : barThickness,
                height: horizontal ? barThickness : Math.abs(barLength),
                fill: colorAccessor?.(datum, index) ?? color
            };
        }).filter((bar)=>bar);
    }, [
        barThickness,
        color,
        colorAccessor,
        data,
        getScaledX,
        getScaledY,
        horizontal,
        xZeroPosition,
        yZeroPosition
    ]);
    const ownEventSourceKey = `${(0, $ea50bd05f08590bd$export$a0b4eafb3ed9dd6c)}-${dataKey}`;
    const eventEmitters = (0, $525e2ebff06e337c$export$2e2bcd8739ae039)({
        dataKey: dataKey,
        enableEvents: enableEvents,
        onBlur: onBlur,
        onFocus: onFocus,
        onPointerMove: onPointerMove,
        onPointerOut: onPointerOut,
        onPointerUp: onPointerUp,
        onPointerDown: onPointerDown,
        source: ownEventSourceKey,
        allowedSources: [
            (0, $ea50bd05f08590bd$export$69b1818e3c4e83f9),
            ownEventSourceKey
        ]
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("g", {
        className: "vx-bar-series",
        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(BarsComponent, {
            bars: bars,
            horizontal: horizontal,
            xScale: xScale,
            yScale: yScale,
            ...eventEmitters,
            ...barComponentProps
        })
    });
}
function $23b9bc497e324d24$export$2e2bcd8739ae039(props) {
    const { dataKey: dataKey, data: data, xAccessor: xAccessor, yAccessor: yAccessor } = props;
    const { xScale: xScale, yScale: yScale, dataRegistry: dataRegistry } = (0, $5E6i4.useContext)((0, $89eeb2e4952e291d$export$2e2bcd8739ae039));
    (0, $5E6i4.useEffect)(()=>{
        if (dataRegistry) dataRegistry.registerData({
            key: dataKey,
            data: data,
            xAccessor: xAccessor,
            yAccessor: yAccessor
        });
        return ()=>dataRegistry?.unregisterData(dataKey);
    }, [
        dataRegistry,
        dataKey,
        data,
        xAccessor,
        yAccessor
    ]);
    const registryEntry = dataRegistry?.get(dataKey);
    // if scales or data are not available in context, render nothing
    if (!xScale || !yScale || !registryEntry) return null;
    // otherwise pass props + over-write data/accessors
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($23b9bc497e324d24$var$BaseBarSeries, {
        ...props,
        xScale: xScale,
        yScale: yScale,
        data: registryEntry.data,
        xAccessor: registryEntry.xAccessor,
        yAccessor: registryEntry.yAccessor
    });
}




function $f918a57a107bc535$var$BarSeries(_ref) {
    let { colorAccessor: colorAccessor, ...props } = _ref;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $23b9bc497e324d24$export$2e2bcd8739ae039), {
        ...props,
        colorAccessor: colorAccessor,
        BarsComponent: (0, $aa8afe1bc71a1c3a$export$2e2bcd8739ae039)
    });
}
var $f918a57a107bc535$export$2e2bcd8739ae039 = $f918a57a107bc535$var$BarSeries;



var $5E6i4 = parcelRequire("5E6i4");









function $180fac556531f275$var$BaseBarStack(_ref) {
    let { children: children, order: order, offset: offset, BarsComponent: BarsComponent, onBlur: onBlur, onFocus: onFocus, onPointerMove: onPointerMove, onPointerOut: onPointerOut, onPointerUp: onPointerUp, onPointerDown: onPointerDown, enableEvents: enableEvents = true } = _ref;
    const { colorScale: colorScale, dataRegistry: dataRegistry, horizontal: horizontal, xScale: xScale, yScale: yScale } = (0, $5E6i4.useContext)((0, $89eeb2e4952e291d$export$2e2bcd8739ae039));
    const { seriesChildren: seriesChildren, dataKeys: dataKeys, stackedData: stackedData } = (0, $e35a346be91c9600$export$2e2bcd8739ae039)({
        children: children,
        order: order,
        offset: offset
    });
    // custom logic to find the nearest AreaStackDatum (context) and return the original Datum (props)
    const findNearestDatum = (0, $5E6i4.useCallback)((params)=>{
        const childData = seriesChildren.find((child)=>child.props.dataKey === params.dataKey)?.props?.data;
        return childData ? (0, $ee222afb4e9b93ff$export$2e2bcd8739ae039)(params, childData, horizontal) : null;
    }, [
        seriesChildren,
        horizontal
    ]);
    const ownEventSourceKey = `${(0, $ea50bd05f08590bd$export$1411a3296d826139)}-${dataKeys.join('-')}`;
    const eventEmitters = (0, $525e2ebff06e337c$export$2e2bcd8739ae039)({
        dataKey: dataKeys,
        enableEvents: enableEvents,
        findNearestDatum: // @ts-expect-error Datum input + return type are expected to be the same type but they differ for BarStack (registry data is StackedDatum, return type is user Datum)
        findNearestDatum,
        onBlur: onBlur,
        onFocus: onFocus,
        onPointerMove: onPointerMove,
        onPointerOut: onPointerOut,
        onPointerUp: onPointerUp,
        onPointerDown: onPointerDown,
        source: ownEventSourceKey,
        allowedSources: [
            (0, $ea50bd05f08590bd$export$69b1818e3c4e83f9),
            ownEventSourceKey
        ]
    });
    const registryEntries = dataKeys.map((key)=>dataRegistry.get(key));
    // if scales and data are not available in the registry, bail
    if (registryEntries.some((entry)=>entry == null) || !xScale || !yScale || !colorScale) return null;
    const barThickness = (0, $becd10fb064d621f$export$2e2bcd8739ae039)(horizontal ? yScale : xScale);
    const halfBarThickness = barThickness / 2;
    let getWidth;
    let getHeight;
    let getX;
    let getY;
    if (horizontal) {
        getWidth = (bar)=>(xScale((0, $c5a13e2a3e68b248$export$18f9732b2021233c)(bar)) ?? NaN) - (xScale((0, $c5a13e2a3e68b248$export$fbdeaa6a76694f71)(bar)) ?? NaN);
        getHeight = ()=>barThickness;
        getX = (bar)=>xScale((0, $c5a13e2a3e68b248$export$fbdeaa6a76694f71)(bar));
        getY = (bar)=>'bandwidth' in yScale ? yScale((0, $d2b0065d3c9ce23f$export$9882dd06892ae868)(bar.data)) : Math.max((yScale((0, $d2b0065d3c9ce23f$export$9882dd06892ae868)(bar.data)) ?? NaN) - halfBarThickness);
    } else {
        getWidth = ()=>barThickness;
        getHeight = (bar)=>(yScale((0, $c5a13e2a3e68b248$export$fbdeaa6a76694f71)(bar)) ?? NaN) - (yScale((0, $c5a13e2a3e68b248$export$18f9732b2021233c)(bar)) ?? NaN);
        getX = (bar)=>'bandwidth' in xScale ? xScale((0, $d2b0065d3c9ce23f$export$9882dd06892ae868)(bar.data)) : Math.max((xScale((0, $d2b0065d3c9ce23f$export$9882dd06892ae868)(bar.data)) ?? NaN) - halfBarThickness);
        getY = (bar)=>yScale((0, $c5a13e2a3e68b248$export$18f9732b2021233c)(bar));
    }
    const barSeries = stackedData.map((barStack, stackIndex)=>{
        const entry = dataRegistry.get(barStack.key);
        if (!entry) return null;
        // get props from child BarSeries, if available
        const childBarSeries = seriesChildren.find((child)=>child.props.dataKey === barStack.key);
        const { colorAccessor: colorAccessor, radius: radius, radiusAll: radiusAll, radiusBottom: radiusBottom, radiusLeft: radiusLeft, radiusRight: radiusRight, radiusTop: radiusTop } = childBarSeries?.props || {};
        return {
            key: barStack.key,
            radius: radius,
            radiusAll: radiusAll,
            radiusBottom: radiusBottom,
            radiusLeft: radiusLeft,
            radiusRight: radiusRight,
            radiusTop: radiusTop,
            bars: barStack.map((bar, index)=>{
                const barX = getX(bar);
                if (!(0, $0e64952a2d1e8b9b$export$2e2bcd8739ae039)(barX)) return null;
                const barY = getY(bar);
                if (!(0, $0e64952a2d1e8b9b$export$2e2bcd8739ae039)(barY)) return null;
                const barWidth = getWidth(bar);
                if (!(0, $0e64952a2d1e8b9b$export$2e2bcd8739ae039)(barWidth)) return null;
                const barHeight = getHeight(bar);
                if (!(0, $0e64952a2d1e8b9b$export$2e2bcd8739ae039)(barHeight)) return null;
                const barSeriesDatum = colorAccessor ? childBarSeries?.props?.data[index] : null;
                return {
                    key: `${stackIndex}-${barStack.key}-${index}`,
                    x: barX,
                    y: barY,
                    width: barWidth,
                    height: barHeight,
                    fill: barSeriesDatum && colorAccessor ? colorAccessor(barSeriesDatum, index) : colorScale(barStack.key)
                };
            }).filter((bar)=>bar)
        };
    }).filter((series)=>series);
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("g", {
        className: "visx-bar-stack",
        children: barSeries.map((series)=>series && /*#__PURE__*/ (0, $5E6i4.createElement)(BarsComponent, {
                horizontal: horizontal,
                xScale: xScale,
                yScale: yScale,
                ...series,
                ...eventEmitters,
                key: series.key
            }))
    });
}
var $180fac556531f275$export$2e2bcd8739ae039 = $180fac556531f275$var$BaseBarStack;




function $2ca82a2132fc4c20$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $180fac556531f275$export$2e2bcd8739ae039), {
        ...props,
        BarsComponent: (0, $aa8afe1bc71a1c3a$export$2e2bcd8739ae039)
    });
}



var $5E6i4 = parcelRequire("5E6i4");



function $9f0e616da5c3aaae$export$2e2bcd8739ae039(_ref) {
    let { renderGlyph: renderGlyph = (0, $78a9902da6fac585$export$2e2bcd8739ae039), ...props } = _ref;
    const renderGlyphs = (0, $5E6i4.useCallback)((_ref2)=>{
        let { glyphs: glyphs, onPointerMove: onPointerMove, onPointerOut: onPointerOut, onPointerUp: onPointerUp, onFocus: onFocus, onBlur: onBlur } = _ref2;
        return glyphs.map((glyph)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $5E6i4.Fragment), {
                children: renderGlyph({
                    ...glyph,
                    onPointerMove: onPointerMove,
                    onPointerOut: onPointerOut,
                    onPointerUp: onPointerUp,
                    onFocus: onFocus,
                    onBlur: onBlur
                })
            }, glyph.key));
    }, [
        renderGlyph
    ]);
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $3481b14a5a91b691$export$2e2bcd8739ae039), {
        ...props,
        renderGlyphs: renderGlyphs
    });
}



var $5E6i4 = parcelRequire("5E6i4");









function $1427de44a18d8ede$var$BaseLineSeries(_ref) {
    let { colorAccessor: colorAccessor, curve: curve, data: data, dataKey: dataKey, onBlur: onBlur, onFocus: onFocus, onPointerMove: onPointerMove, onPointerOut: onPointerOut, onPointerUp: onPointerUp, onPointerDown: onPointerDown, enableEvents: enableEvents = true, xAccessor: xAccessor, xScale: xScale, yAccessor: yAccessor, yScale: yScale, PathComponent: PathComponent = 'path', ...lineProps } = _ref;
    const { colorScale: colorScale, theme: theme } = (0, $5E6i4.useContext)((0, $89eeb2e4952e291d$export$2e2bcd8739ae039));
    const getScaledX = (0, $5E6i4.useMemo)(()=>(0, $6d06d25c93208edf$export$2e2bcd8739ae039)(xScale, xAccessor), [
        xScale,
        xAccessor
    ]);
    const getScaledY = (0, $5E6i4.useMemo)(()=>(0, $6d06d25c93208edf$export$2e2bcd8739ae039)(yScale, yAccessor), [
        yScale,
        yAccessor
    ]);
    const isDefined = (0, $5E6i4.useCallback)((d)=>(0, $0e64952a2d1e8b9b$export$2e2bcd8739ae039)(xScale(xAccessor(d))) && (0, $0e64952a2d1e8b9b$export$2e2bcd8739ae039)(yScale(yAccessor(d))), [
        xScale,
        xAccessor,
        yScale,
        yAccessor
    ]);
    const color = colorScale?.(dataKey) ?? theme?.colors?.[0] ?? '#222';
    const ownEventSourceKey = `${(0, $ea50bd05f08590bd$export$f037ec20d0f10ad2)}-${dataKey}`;
    const eventEmitters = (0, $525e2ebff06e337c$export$2e2bcd8739ae039)({
        dataKey: dataKey,
        enableEvents: enableEvents,
        onBlur: onBlur,
        onFocus: onFocus,
        onPointerMove: onPointerMove,
        onPointerOut: onPointerOut,
        onPointerUp: onPointerUp,
        onPointerDown: onPointerDown,
        source: ownEventSourceKey,
        allowedSources: [
            (0, $ea50bd05f08590bd$export$69b1818e3c4e83f9),
            ownEventSourceKey
        ]
    });
    // render invisible glyphs for focusing if onFocus/onBlur are defined
    const captureFocusEvents = Boolean(onFocus || onBlur);
    const renderGlyphs = (0, $5E6i4.useCallback)((_ref2)=>{
        let { glyphs: glyphs } = _ref2;
        return captureFocusEvents ? glyphs.map((glyph)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $5E6i4.Fragment), {
                children: (0, $78a9902da6fac585$export$2e2bcd8739ae039)({
                    ...glyph,
                    color: 'transparent',
                    onFocus: eventEmitters.onFocus,
                    onBlur: eventEmitters.onBlur
                })
            }, glyph.key)) : null;
    }, [
        captureFocusEvents,
        eventEmitters.onFocus,
        eventEmitters.onBlur
    ]);
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)((0, $90cae257cc958273$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $c006d6ed47f7fa5f$export$2e2bcd8739ae039), {
                x: getScaledX,
                y: getScaledY,
                defined: isDefined,
                curve: curve,
                ...lineProps,
                children: (_ref3)=>{
                    let { path: path } = _ref3;
                    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)(PathComponent, {
                        stroke: colorAccessor?.(dataKey) ?? color,
                        strokeWidth: 2,
                        fill: "transparent",
                        strokeLinecap: "round" // without this a datum surrounded by nulls will not be visible
                        ,
                        ...lineProps,
                        d: path(data) || '',
                        ...eventEmitters
                    });
                }
            }),
            captureFocusEvents && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $3481b14a5a91b691$export$8fc9707bca69433a), {
                dataKey: dataKey,
                data: data,
                xAccessor: xAccessor,
                yAccessor: yAccessor,
                xScale: xScale,
                yScale: yScale,
                renderGlyphs: renderGlyphs
            })
        ]
    });
}
function $1427de44a18d8ede$export$2e2bcd8739ae039(props) {
    const { dataKey: dataKey, data: data, xAccessor: xAccessor, yAccessor: yAccessor } = props;
    const { xScale: xScale, yScale: yScale, dataRegistry: dataRegistry } = (0, $5E6i4.useContext)((0, $89eeb2e4952e291d$export$2e2bcd8739ae039));
    (0, $5E6i4.useEffect)(()=>{
        if (dataRegistry) dataRegistry.registerData({
            key: dataKey,
            data: data,
            xAccessor: xAccessor,
            yAccessor: yAccessor
        });
        return ()=>dataRegistry?.unregisterData(dataKey);
    }, [
        dataRegistry,
        dataKey,
        data,
        xAccessor,
        yAccessor
    ]);
    const registryEntry = dataRegistry?.get(dataKey);
    // if scales or data are not available in context, render nothing
    if (!xScale || !yScale || !registryEntry) return null;
    // otherwise pass props + over-write data/accessors
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($1427de44a18d8ede$var$BaseLineSeries, {
        ...props,
        xScale: xScale,
        yScale: yScale,
        data: registryEntry.data,
        xAccessor: registryEntry.xAccessor,
        yAccessor: registryEntry.yAccessor
    });
}



function $d02f7b1978af803c$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $1427de44a18d8ede$export$2e2bcd8739ae039), {
        ...props
    });
}



var $5E6i4 = parcelRequire("5E6i4");

var $8026ef973ac62440$exports = {};
(function(global, factory) {
    factory($8026ef973ac62440$exports);
})($8026ef973ac62440$exports, function(exports1) {
    'use strict';
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _extends() {
        _extends = Object.assign || function(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        };
        return _extends.apply(this, arguments);
    }
    function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
            keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function _objectSpread2(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
                _defineProperty(target, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            else ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target;
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _createForOfIteratorHelper(o, allowArrayLike) {
        var it;
        if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
            if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                if (it) o = it;
                var i = 0;
                var F = function() {};
                return {
                    s: F,
                    n: function() {
                        if (i >= o.length) return {
                            done: true
                        };
                        return {
                            done: false,
                            value: o[i++]
                        };
                    },
                    e: function(e) {
                        throw e;
                    },
                    f: F
                };
            }
            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        var normalCompletion = true, didErr = false, err;
        return {
            s: function() {
                it = o[Symbol.iterator]();
            },
            n: function() {
                var step = it.next();
                normalCompletion = step.done;
                return step;
            },
            e: function(e) {
                didErr = true;
                err = e;
            },
            f: function() {
                try {
                    if (!normalCompletion && it.return != null) it.return();
                } finally{
                    if (didErr) throw err;
                }
            }
        };
    }
    /**
 * de Casteljau's algorithm for drawing and splitting bezier curves.
 * Inspired by https://pomax.github.io/bezierinfo/
 *
 * @param {Number[][]} points Array of [x,y] points: [start, control1, control2, ..., end]
 *   The original segment to split.
 * @param {Number} t Where to split the curve (value between [0, 1])
 * @return {Object} An object { left, right } where left is the segment from 0..t and
 *   right is the segment from t..1.
 */ function decasteljau(points, t) {
        var left = [];
        var right = [];
        function decasteljauRecurse(points, t) {
            if (points.length === 1) {
                left.push(points[0]);
                right.push(points[0]);
            } else {
                var newPoints = Array(points.length - 1);
                for(var i = 0; i < newPoints.length; i++){
                    if (i === 0) left.push(points[0]);
                    if (i === newPoints.length - 1) right.push(points[i + 1]);
                    newPoints[i] = [
                        (1 - t) * points[i][0] + t * points[i + 1][0],
                        (1 - t) * points[i][1] + t * points[i + 1][1]
                    ];
                }
                decasteljauRecurse(newPoints, t);
            }
        }
        if (points.length) decasteljauRecurse(points, t);
        return {
            left: left,
            right: right.reverse()
        };
    }
    /**
 * Convert segments represented as points back into a command object
 *
 * @param {Number[][]} points Array of [x,y] points: [start, control1, control2, ..., end]
 *   Represents a segment
 * @return {Object} A command object representing the segment.
 */ function pointsToCommand(points) {
        var command = {};
        if (points.length === 4) {
            command.x2 = points[2][0];
            command.y2 = points[2][1];
        }
        if (points.length >= 3) {
            command.x1 = points[1][0];
            command.y1 = points[1][1];
        }
        command.x = points[points.length - 1][0];
        command.y = points[points.length - 1][1];
        if (points.length === 4) // start, control1, control2, end
        command.type = 'C';
        else if (points.length === 3) // start, control, end
        command.type = 'Q';
        else // start, end
        command.type = 'L';
        return command;
    }
    /**
 * Runs de Casteljau's algorithm enough times to produce the desired number of segments.
 *
 * @param {Number[][]} points Array of [x,y] points for de Casteljau (the initial segment to split)
 * @param {Number} segmentCount Number of segments to split the original into
 * @return {Number[][][]} Array of segments
 */ function splitCurveAsPoints(points, segmentCount) {
        segmentCount = segmentCount || 2;
        var segments = [];
        var remainingCurve = points;
        var tIncrement = 1 / segmentCount; // x-----x-----x-----x
        // t=  0.33   0.66   1
        // x-----o-----------x
        // r=  0.33
        //       x-----o-----x
        // r=         0.5  (0.33 / (1 - 0.33))  === tIncrement / (1 - (tIncrement * (i - 1))
        // x-----x-----x-----x----x
        // t=  0.25   0.5   0.75  1
        // x-----o----------------x
        // r=  0.25
        //       x-----o----------x
        // r=         0.33  (0.25 / (1 - 0.25))
        //             x-----o----x
        // r=         0.5  (0.25 / (1 - 0.5))
        for(var i = 0; i < segmentCount - 1; i++){
            var tRelative = tIncrement / (1 - tIncrement * i);
            var split = decasteljau(remainingCurve, tRelative);
            segments.push(split.left);
            remainingCurve = split.right;
        } // last segment is just to the end from the last point
        segments.push(remainingCurve);
        return segments;
    }
    /**
 * Convert command objects to arrays of points, run de Casteljau's algorithm on it
 * to split into to the desired number of segments.
 *
 * @param {Object} commandStart The start command object
 * @param {Object} commandEnd The end command object
 * @param {Number} segmentCount The number of segments to create
 * @return {Object[]} An array of commands representing the segments in sequence
 */ function splitCurve(commandStart, commandEnd, segmentCount) {
        var points = [
            [
                commandStart.x,
                commandStart.y
            ]
        ];
        if (commandEnd.x1 != null) points.push([
            commandEnd.x1,
            commandEnd.y1
        ]);
        if (commandEnd.x2 != null) points.push([
            commandEnd.x2,
            commandEnd.y2
        ]);
        points.push([
            commandEnd.x,
            commandEnd.y
        ]);
        return splitCurveAsPoints(points, segmentCount).map(pointsToCommand);
    }
    var commandTokenRegex = /[MLCSTQAHVZmlcstqahv]|-?[\d.e+-]+/g;
    /**
 * List of params for each command type in a path `d` attribute
 */ var typeMap = {
        M: [
            'x',
            'y'
        ],
        L: [
            'x',
            'y'
        ],
        H: [
            'x'
        ],
        V: [
            'y'
        ],
        C: [
            'x1',
            'y1',
            'x2',
            'y2',
            'x',
            'y'
        ],
        S: [
            'x2',
            'y2',
            'x',
            'y'
        ],
        Q: [
            'x1',
            'y1',
            'x',
            'y'
        ],
        T: [
            'x',
            'y'
        ],
        A: [
            'rx',
            'ry',
            'xAxisRotation',
            'largeArcFlag',
            'sweepFlag',
            'x',
            'y'
        ],
        Z: []
    }; // Add lower case entries too matching uppercase (e.g. 'm' == 'M')
    Object.keys(typeMap).forEach(function(key) {
        typeMap[key.toLowerCase()] = typeMap[key];
    });
    function arrayOfLength(length, value) {
        var array = Array(length);
        for(var i = 0; i < length; i++)array[i] = value;
        return array;
    }
    /**
 * Converts a command object to a string to be used in a `d` attribute
 * @param {Object} command A command object
 * @return {String} The string for the `d` attribute
 */ function commandToString(command) {
        return "".concat(command.type).concat(typeMap[command.type].map(function(p) {
            return command[p];
        }).join(','));
    }
    /**
 * Converts command A to have the same type as command B.
 *
 * e.g., L0,5 -> C0,5,0,5,0,5
 *
 * Uses these rules:
 * x1 <- x
 * x2 <- x
 * y1 <- y
 * y2 <- y
 * rx <- 0
 * ry <- 0
 * xAxisRotation <- read from B
 * largeArcFlag <- read from B
 * sweepflag <- read from B
 *
 * @param {Object} aCommand Command object from path `d` attribute
 * @param {Object} bCommand Command object from path `d` attribute to match against
 * @return {Object} aCommand converted to type of bCommand
 */ function convertToSameType(aCommand, bCommand) {
        var conversionMap = {
            x1: 'x',
            y1: 'y',
            x2: 'x',
            y2: 'y'
        };
        var readFromBKeys = [
            'xAxisRotation',
            'largeArcFlag',
            'sweepFlag'
        ]; // convert (but ignore M types)
        if (aCommand.type !== bCommand.type && bCommand.type.toUpperCase() !== 'M') {
            var aConverted = {};
            Object.keys(bCommand).forEach(function(bKey) {
                var bValue = bCommand[bKey]; // first read from the A command
                var aValue = aCommand[bKey]; // if it is one of these values, read from B no matter what
                if (aValue === undefined) {
                    if (readFromBKeys.includes(bKey)) aValue = bValue;
                    else {
                        // if it wasn't in the A command, see if an equivalent was
                        if (aValue === undefined && conversionMap[bKey]) aValue = aCommand[conversionMap[bKey]];
                         // if it doesn't have a converted value, use 0
                        if (aValue === undefined) aValue = 0;
                    }
                }
                aConverted[bKey] = aValue;
            }); // update the type to match B
            aConverted.type = bCommand.type;
            aCommand = aConverted;
        }
        return aCommand;
    }
    /**
 * Interpolate between command objects commandStart and commandEnd segmentCount times.
 * If the types are L, Q, or C then the curves are split as per de Casteljau's algorithm.
 * Otherwise we just copy commandStart segmentCount - 1 times, finally ending with commandEnd.
 *
 * @param {Object} commandStart Command object at the beginning of the segment
 * @param {Object} commandEnd Command object at the end of the segment
 * @param {Number} segmentCount The number of segments to split this into. If only 1
 *   Then [commandEnd] is returned.
 * @return {Object[]} Array of ~segmentCount command objects between commandStart and
 *   commandEnd. (Can be segmentCount+1 objects if commandStart is type M).
 */ function splitSegment(commandStart, commandEnd, segmentCount) {
        var segments = []; // line, quadratic bezier, or cubic bezier
        if (commandEnd.type === 'L' || commandEnd.type === 'Q' || commandEnd.type === 'C') segments = segments.concat(splitCurve(commandStart, commandEnd, segmentCount)); // general case - just copy the same point
        else {
            var copyCommand = _extends({}, commandStart); // convert M to L
            if (copyCommand.type === 'M') copyCommand.type = 'L';
            segments = segments.concat(arrayOfLength(segmentCount - 1).map(function() {
                return copyCommand;
            }));
            segments.push(commandEnd);
        }
        return segments;
    }
    /**
 * Extends an array of commandsToExtend to the length of the referenceCommands by
 * splitting segments until the number of commands match. Ensures all the actual
 * points of commandsToExtend are in the extended array.
 *
 * @param {Object[]} commandsToExtend The command object array to extend
 * @param {Object[]} referenceCommands The command object array to match in length
 * @param {Function} excludeSegment a function that takes a start command object and
 *   end command object and returns true if the segment should be excluded from splitting.
 * @return {Object[]} The extended commandsToExtend array
 */ function extend(commandsToExtend, referenceCommands, excludeSegment) {
        // compute insertion points:
        // number of segments in the path to extend
        var numSegmentsToExtend = commandsToExtend.length - 1; // number of segments in the reference path.
        var numReferenceSegments = referenceCommands.length - 1; // this value is always between [0, 1].
        var segmentRatio = numSegmentsToExtend / numReferenceSegments; // create a map, mapping segments in referenceCommands to how many points
        // should be added in that segment (should always be >= 1 since we need each
        // point itself).
        // 0 = segment 0-1, 1 = segment 1-2, n-1 = last vertex
        var countPointsPerSegment = arrayOfLength(numReferenceSegments).reduce(function(accum, d, i) {
            var insertIndex = Math.floor(segmentRatio * i); // handle excluding segments
            if (excludeSegment && insertIndex < commandsToExtend.length - 1 && excludeSegment(commandsToExtend[insertIndex], commandsToExtend[insertIndex + 1])) {
                // set the insertIndex to the segment that this point should be added to:
                // round the insertIndex essentially so we split half and half on
                // neighbouring segments. hence the segmentRatio * i < 0.5
                var addToPriorSegment = segmentRatio * i % 1 < 0.5; // only skip segment if we already have 1 point in it (can't entirely remove a segment)
                if (accum[insertIndex]) {
                    // TODO - Note this is a naive algorithm that should work for most d3-area use cases
                    // but if two adjacent segments are supposed to be skipped, this will not perform as
                    // expected. Could be updated to search for nearest segment to place the point in, but
                    // will only do that if necessary.
                    // add to the prior segment
                    if (addToPriorSegment) {
                        if (insertIndex > 0) insertIndex -= 1; // not possible to add to previous so adding to next
                        else if (insertIndex < commandsToExtend.length - 1) insertIndex += 1;
                         // add to next segment
                    } else if (insertIndex < commandsToExtend.length - 1) insertIndex += 1; // not possible to add to next so adding to previous
                    else if (insertIndex > 0) insertIndex -= 1;
                }
            }
            accum[insertIndex] = (accum[insertIndex] || 0) + 1;
            return accum;
        }, []); // extend each segment to have the correct number of points for a smooth interpolation
        var extended = countPointsPerSegment.reduce(function(extended, segmentCount, i) {
            // if last command, just add `segmentCount` number of times
            if (i === commandsToExtend.length - 1) {
                var lastCommandCopies = arrayOfLength(segmentCount, _extends({}, commandsToExtend[commandsToExtend.length - 1])); // convert M to L
                if (lastCommandCopies[0].type === 'M') lastCommandCopies.forEach(function(d) {
                    d.type = 'L';
                });
                return extended.concat(lastCommandCopies);
            } // otherwise, split the segment segmentCount times.
            return extended.concat(splitSegment(commandsToExtend[i], commandsToExtend[i + 1], segmentCount));
        }, []); // add in the very first point since splitSegment only adds in the ones after it
        extended.unshift(commandsToExtend[0]);
        return extended;
    }
    /**
 * Takes a path `d` string and converts it into an array of command
 * objects. Drops the `Z` character.
 *
 * @param {String|null} d A path `d` string
 */ function pathCommandsFromString(d) {
        // split into valid tokens
        var tokens = (d || '').match(commandTokenRegex) || [];
        var commands = [];
        var commandArgs;
        var command; // iterate over each token, checking if we are at a new command
        // by presence in the typeMap
        for(var i = 0; i < tokens.length; ++i){
            commandArgs = typeMap[tokens[i]]; // new command found:
            if (commandArgs) {
                command = {
                    type: tokens[i]
                }; // add each of the expected args for this command:
                for(var a = 0; a < commandArgs.length; ++a)command[commandArgs[a]] = +tokens[i + a + 1];
                 // need to increment our token index appropriately since
                // we consumed token args
                i += commandArgs.length;
                commands.push(command);
            }
        }
        return commands;
    }
    /**
 * Interpolate from A to B by extending A and B during interpolation to have
 * the same number of points. This allows for a smooth transition when they
 * have a different number of points.
 *
 * Ignores the `Z` command in paths unless both A and B end with it.
 *
 * This function works directly with arrays of command objects instead of with
 * path `d` strings (see interpolatePath for working with `d` strings).
 *
 * @param {Object[]} aCommandsInput Array of path commands
 * @param {Object[]} bCommandsInput Array of path commands
 * @param {Function} excludeSegment a function that takes a start command object and
 *   end command object and returns true if the segment should be excluded from splitting.
 * @returns {Function} Interpolation function that maps t ([0, 1]) to an array of path commands.
 */ function interpolatePathCommands(aCommandsInput, bCommandsInput, excludeSegment) {
        // make a copy so we don't mess with the input arrays
        var aCommands = aCommandsInput == null ? [] : aCommandsInput.slice();
        var bCommands = bCommandsInput == null ? [] : bCommandsInput.slice(); // both input sets are empty, so we don't interpolate
        if (!aCommands.length && !bCommands.length) return function nullInterpolator() {
            return [];
        };
         // do we add Z during interpolation? yes if both have it. (we'd expect both to have it or not)
        var addZ = (aCommands.length === 0 || aCommands[aCommands.length - 1].type === 'Z') && (bCommands.length === 0 || bCommands[bCommands.length - 1].type === 'Z'); // we temporarily remove Z
        if (aCommands.length > 0 && aCommands[aCommands.length - 1].type === 'Z') aCommands.pop();
        if (bCommands.length > 0 && bCommands[bCommands.length - 1].type === 'Z') bCommands.pop();
         // if A is empty, treat it as if it used to contain just the first point
        // of B. This makes it so the line extends out of from that first point.
        if (!aCommands.length) aCommands.push(bCommands[0]); // otherwise if B is empty, treat it as if it contains the first point
        else if (!bCommands.length) bCommands.push(aCommands[0]);
         // extend to match equal size
        var numPointsToExtend = Math.abs(bCommands.length - aCommands.length);
        if (numPointsToExtend !== 0) {
            // B has more points than A, so add points to A before interpolating
            if (bCommands.length > aCommands.length) aCommands = extend(aCommands, bCommands, excludeSegment); // else if A has more points than B, add more points to B
            else if (bCommands.length < aCommands.length) bCommands = extend(bCommands, aCommands, excludeSegment);
        } // commands have same length now.
        // convert commands in A to the same type as those in B
        aCommands = aCommands.map(function(aCommand, i) {
            return convertToSameType(aCommand, bCommands[i]);
        }); // create mutable interpolated command objects
        var interpolatedCommands = aCommands.map(function(aCommand) {
            return _objectSpread2({}, aCommand);
        });
        if (addZ) interpolatedCommands.push({
            type: 'Z'
        });
        return function pathCommandInterpolator(t) {
            // at 1 return the final value without the extensions used during interpolation
            if (t === 1) return bCommandsInput == null ? [] : bCommandsInput;
             // interpolate the commands using the mutable interpolated command objs
            // we can skip at t=0 since we copied aCommands to begin
            if (t > 0) for(var i = 0; i < interpolatedCommands.length; ++i){
                // if (interpolatedCommands[i].type === 'Z') continue;
                var aCommand = aCommands[i];
                var bCommand = bCommands[i];
                var interpolatedCommand = interpolatedCommands[i];
                var _iterator = _createForOfIteratorHelper(typeMap[interpolatedCommand.type]), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var arg = _step.value;
                        interpolatedCommand[arg] = (1 - t) * aCommand[arg] + t * bCommand[arg]; // do not use floats for flags (#27), round to integer
                        if (arg === 'largeArcFlag' || arg === 'sweepFlag') interpolatedCommand[arg] = Math.round(interpolatedCommand[arg]);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
            return interpolatedCommands;
        };
    }
    /**
 * Interpolate from A to B by extending A and B during interpolation to have
 * the same number of points. This allows for a smooth transition when they
 * have a different number of points.
 *
 * Ignores the `Z` character in paths unless both A and B end with it.
 *
 * @param {String} a The `d` attribute for a path
 * @param {String} b The `d` attribute for a path
 * @param {Function} excludeSegment a function that takes a start command object and
 *   end command object and returns true if the segment should be excluded from splitting.
 * @returns {Function} Interpolation function that maps t ([0, 1]) to a path `d` string.
 */ function interpolatePath(a, b, excludeSegment) {
        var aCommands = pathCommandsFromString(a);
        var bCommands = pathCommandsFromString(b);
        if (!aCommands.length && !bCommands.length) return function nullInterpolator() {
            return '';
        };
        var commandInterpolator = interpolatePathCommands(aCommands, bCommands, excludeSegment);
        return function pathStringInterpolator(t) {
            // at 1 return the final value without the extensions used during interpolation
            if (t === 1) return b == null ? '' : b;
            var interpolatedCommands = commandInterpolator(t); // convert to a string (fastest concat: https://jsperf.com/join-concat/150)
            var interpolatedString = '';
            var _iterator2 = _createForOfIteratorHelper(interpolatedCommands), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var interpolatedCommand = _step2.value;
                    interpolatedString += commandToString(interpolatedCommand);
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            return interpolatedString;
        };
    }
    exports1.interpolatePath = interpolatePath;
    exports1.interpolatePathCommands = interpolatePathCommands;
    exports1.pathCommandsFromString = pathCommandsFromString;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});




function $fddb102d4e47b354$var$AnimatedPath(_ref) {
    let { d: d, stroke: stroke = 'transparent', fill: fill = 'transparent', ...lineProps } = _ref;
    const previousD = (0, $5E6i4.useRef)(d);
    // updating d in quick succession will ruin the animation because startD === endD.
    // debounce it slightly
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const setPreviousD = (0, $5E6i4.useCallback)((0, $1cd3ba1ba76c811a$export$61fc7d43ac8f84b0)((dValue)=>{
        previousD.current = dValue;
    }, 50), [] // create once
    );
    // react-spring cannot interpolate paths which have a differing number of points
    // flubber is the "best" at interpolating but assumes closed paths
    // d3-interpolate-path is better at interpolating extra/fewer points so we use that
    const interpolator = (0, $8026ef973ac62440$exports.interpolatePath)(previousD.current, d);
    setPreviousD(d);
    const { t: t } = (0, $c52c96d382753013$export$c4af9125706c4d30)({
        from: {
            t: 0
        },
        to: {
            t: 1
        },
        reset: true,
        delay: 0
    });
    const tweened = (0, $c52c96d382753013$export$c4af9125706c4d30)({
        stroke: stroke,
        fill: fill
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $40932a561d468393$export$407448d2b89b1813).path, {
        className: "visx-path",
        d: t.to(interpolator),
        stroke: tweened.stroke,
        fill: tweened.fill,
        ...lineProps
    });
}
var $fddb102d4e47b354$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5E6i4.memo)($fddb102d4e47b354$var$AnimatedPath);




function $4191e002ab693d8c$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $3741da8c049ee8fe$export$2e2bcd8739ae039), {
        ...props,
        PathComponent: (0, $fddb102d4e47b354$export$2e2bcd8739ae039)
    });
}





function $cd9ab1c10a4a90ee$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $0afda1b8e4162dac$export$2e2bcd8739ae039), {
        ...props,
        PathComponent: (0, $fddb102d4e47b354$export$2e2bcd8739ae039)
    });
}





var $5E6i4 = parcelRequire("5E6i4");

/* react-spring cannot tween colors with url ids (patterns, gradients), these helpers detect and clean them. */ const $ba670b26046658e2$var$neutralCleanColor = 'rgba(0,0,0,0.1)';
const $ba670b26046658e2$export$4ef9eff566c9f3f0 = (color)=>Boolean(color?.includes('url('));
const $ba670b26046658e2$export$7c60661442a838cf = (color)=>$ba670b26046658e2$export$4ef9eff566c9f3f0(color) ? $ba670b26046658e2$var$neutralCleanColor : color;





function $07b39f2592ff78b5$var$enterUpdate(_ref) {
    let { x: x, y: y, width: width, height: height, fill: fill } = _ref;
    return {
        x: x,
        y: y,
        width: width,
        height: height,
        fill: (0, $ba670b26046658e2$export$7c60661442a838cf)(fill),
        opacity: 1
    };
}
function $07b39f2592ff78b5$var$useBarTransitionConfig(_ref2) {
    let { scale: scale, horizontal: horizontal } = _ref2;
    const shouldAnimateX = !!horizontal;
    return (0, $5E6i4.useMemo)(()=>{
        const scaleBaseline = (0, $491a89eb18c3b50f$export$2e2bcd8739ae039)(scale);
        function fromLeave(_ref3) {
            let { x: x, y: y, width: width, height: height, fill: fill } = _ref3;
            return {
                x: shouldAnimateX ? scaleBaseline ?? 0 : x,
                y: shouldAnimateX ? y : scaleBaseline ?? 0,
                width: shouldAnimateX ? 0 : width,
                height: shouldAnimateX ? height : 0,
                fill: (0, $ba670b26046658e2$export$7c60661442a838cf)(fill),
                opacity: 0
            };
        }
        return {
            unique: true,
            from: fromLeave,
            leave: fromLeave,
            enter: $07b39f2592ff78b5$var$enterUpdate,
            update: $07b39f2592ff78b5$var$enterUpdate,
            keys: (bar)=>bar.key
        };
    }, [
        scale,
        shouldAnimateX
    ]);
}
function $07b39f2592ff78b5$var$AnimatedBarsRounded(_ref4) {
    let { bars: bars, xScale: xScale, yScale: yScale, horizontal: horizontal, radius: radius, radiusAll: radiusAll, radiusTop: radiusTop, radiusRight: radiusRight, radiusBottom: radiusBottom, radiusLeft: radiusLeft, ...pathProps } = _ref4;
    return(/*#__PURE__*/ // eslint-disable-next-line react/jsx-no-useless-fragment
    (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: bars.map((_ref5)=>{
            let { key: key, fill: fill, x: x, y: y, width: width, height: height } = _ref5;
            return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $9037c5c0e8ce94e9$export$2e2bcd8739ae039), {
                x: x,
                y: y,
                width: width,
                height: height,
                radius: radius,
                all: radiusAll,
                top: radiusTop,
                right: radiusRight,
                bottom: radiusBottom,
                left: radiusLeft,
                children: (_ref6)=>{
                    let { path: path } = _ref6;
                    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $fddb102d4e47b354$export$2e2bcd8739ae039), {
                        className: "visx-bar visx-bar-rounded",
                        d: path,
                        fill: fill,
                        ...pathProps
                    });
                }
            }, key);
        })
    }));
}
function $07b39f2592ff78b5$var$AnimatedBarsUnrounded(_ref7) {
    let { bars: bars, xScale: xScale, yScale: yScale, horizontal: horizontal, radius: radius, radiusAll: radiusAll, radiusTop: radiusTop, radiusRight: radiusRight, radiusBottom: radiusBottom, radiusLeft: radiusLeft, ...rectProps } = _ref7;
    const animatedBars = (0, $c52c96d382753013$export$7b286972b8d8ccbf)(bars, {
        ...$07b39f2592ff78b5$var$useBarTransitionConfig({
            horizontal: horizontal,
            scale: horizontal ? xScale : yScale
        })
    });
    const isFocusable = Boolean(rectProps.onFocus || rectProps.onBlur);
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: animatedBars((_ref8, item, _ref9)=>{
            let { x: x, y: y, width: width, height: height, fill: fill, opacity: opacity } = _ref8;
            let { key: key } = _ref9;
            return item == null || key == null ? null : /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $40932a561d468393$export$407448d2b89b1813).rect, {
                tabIndex: isFocusable ? 0 : undefined,
                className: "visx-bar",
                x: x,
                y: y,
                width: width,
                height: height,
                fill: (0, $ba670b26046658e2$export$4ef9eff566c9f3f0)(item.fill) ? item.fill : fill,
                opacity: opacity,
                ...rectProps
            }, key);
        })
    });
}
function $07b39f2592ff78b5$export$2e2bcd8739ae039(props) {
    return props.radius == null ? /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($07b39f2592ff78b5$var$AnimatedBarsUnrounded, {
        ...props
    }) : /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($07b39f2592ff78b5$var$AnimatedBarsRounded, {
        ...props,
        radius: props.radius
    });
}



function $3e052b3b3f64a0dd$export$2e2bcd8739ae039(_ref) {
    let { colorAccessor: colorAccessor, ...props } = _ref;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $23b9bc497e324d24$export$2e2bcd8739ae039), {
        ...props,
        colorAccessor: colorAccessor,
        BarsComponent: (0, $07b39f2592ff78b5$export$2e2bcd8739ae039)
    });
}





function $646c28ef4dd3f879$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $180fac556531f275$export$2e2bcd8739ae039), {
        ...props,
        BarsComponent: (0, $07b39f2592ff78b5$export$2e2bcd8739ae039)
    });
}





function $6c9a5fd9687747e6$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $7768449ad1621004$export$2e2bcd8739ae039), {
        ...props,
        BarsComponent: (0, $07b39f2592ff78b5$export$2e2bcd8739ae039)
    });
}



var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");




function $203517fa2c9f7f62$export$ea88d2929b3a20c(_ref) {
    let { xScale: xScale, yScale: yScale, horizontal: horizontal } = _ref;
    const xScaleBaseline = (0, $491a89eb18c3b50f$export$2e2bcd8739ae039)(xScale);
    const yScaleBaseline = (0, $491a89eb18c3b50f$export$2e2bcd8739ae039)(yScale);
    return (0, $5E6i4.useMemo)(()=>({
            unique: true,
            from: (_ref2)=>{
                let { x: x, y: y, color: color } = _ref2;
                return {
                    x: horizontal ? xScaleBaseline : x,
                    y: horizontal ? y : yScaleBaseline,
                    color: (0, $ba670b26046658e2$export$7c60661442a838cf)(color),
                    opacity: 0
                };
            },
            leave: (_ref3)=>{
                let { x: x, y: y, color: color } = _ref3;
                return {
                    x: horizontal ? xScaleBaseline : x,
                    y: horizontal ? y : yScaleBaseline,
                    color: (0, $ba670b26046658e2$export$7c60661442a838cf)(color),
                    opacity: 0
                };
            },
            enter: (_ref4)=>{
                let { x: x, y: y, color: color } = _ref4;
                return {
                    x: x,
                    y: y,
                    color: (0, $ba670b26046658e2$export$7c60661442a838cf)(color),
                    opacity: 1
                };
            },
            update: (_ref5)=>{
                let { x: x, y: y, color: color } = _ref5;
                return {
                    x: x,
                    y: y,
                    color: (0, $ba670b26046658e2$export$7c60661442a838cf)(color),
                    opacity: 1
                };
            },
            keys: (glyph)=>glyph.key
        }), [
        xScaleBaseline,
        yScaleBaseline,
        horizontal
    ]);
}
function $203517fa2c9f7f62$export$2e2bcd8739ae039(_ref6) {
    let { renderGlyph: renderGlyph, glyphs: glyphs, horizontal: horizontal, xScale: xScale, yScale: yScale, onBlur: onBlur, onFocus: onFocus, onPointerMove: onPointerMove, onPointerOut: onPointerOut, onPointerUp: onPointerUp } = _ref6;
    const animatedGlyphs = (0, $c52c96d382753013$export$7b286972b8d8ccbf)(glyphs, {
        ...$203517fa2c9f7f62$export$ea88d2929b3a20c({
            xScale: xScale,
            yScale: yScale,
            horizontal: horizontal
        })
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: animatedGlyphs((_ref7, item, _ref8)=>{
            let { x: x, y: y, color: color, opacity: opacity } = _ref7;
            let { key: key } = _ref8;
            return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $40932a561d468393$export$407448d2b89b1813).g, {
                transform: (0, $c52c96d382753013$export$2c618a4308a30424)([
                    x,
                    y
                ], (xVal, yVal)=>`translate(${xVal}, ${yVal})`),
                color: color,
                opacity: opacity,
                children: renderGlyph({
                    key: key,
                    datum: item.datum,
                    index: item.index,
                    x: 0,
                    y: 0,
                    size: item.size,
                    // currentColor doesn't work with url-based colors (pattern, gradient)
                    // otherwise currentColor allows us to animate the color of the <g /> element
                    color: (0, $ba670b26046658e2$export$4ef9eff566c9f3f0)(item.color) ? item.color : 'currentColor',
                    onBlur: onBlur,
                    onFocus: onFocus,
                    onPointerMove: onPointerMove,
                    onPointerOut: onPointerOut,
                    onPointerUp: onPointerUp
                })
            }, key);
        })
    });
}





function $a2419e44d538e868$export$2e2bcd8739ae039(_ref) {
    let { renderGlyph: renderGlyph = (0, $78a9902da6fac585$export$2e2bcd8739ae039), ...props } = _ref;
    const renderGlyphs = (0, $5E6i4.useCallback)((glyphsProps)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $203517fa2c9f7f62$export$2e2bcd8739ae039), {
            ...glyphsProps,
            renderGlyph: renderGlyph
        }), [
        renderGlyph
    ]);
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $3481b14a5a91b691$export$2e2bcd8739ae039), {
        ...props,
        renderGlyphs: renderGlyphs
    });
}





function $12d70aabec652bc9$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $1427de44a18d8ede$export$2e2bcd8739ae039), {
        ...props,
        PathComponent: (0, $fddb102d4e47b354$export$2e2bcd8739ae039)
    });
}











function $7e7e4c30f16132e4$export$2e2bcd8739ae039(_ref) {
    let { theme: theme = (0, $5a0fef92b6e89c70$export$2e2bcd8739ae039), children: children } = _ref;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $070796c7135422c6$export$2e2bcd8739ae039).Provider, {
        value: theme,
        children: children
    });
}







var $5c5bea749209352e$export$2e2bcd8739ae039 = (0, $e59fdd064fe47bfd$export$2e2bcd8739ae039)({
    backgroundColor: '#222',
    colors: [
        (0, $89b5c35691e4b5c7$export$61254e8993990612).cyan[4],
        (0, $89b5c35691e4b5c7$export$61254e8993990612).teal[1],
        (0, $89b5c35691e4b5c7$export$61254e8993990612).yellow[2],
        (0, $89b5c35691e4b5c7$export$61254e8993990612).red[4],
        (0, $89b5c35691e4b5c7$export$61254e8993990612).grape[3],
        (0, $89b5c35691e4b5c7$export$61254e8993990612).grape[6],
        (0, $89b5c35691e4b5c7$export$61254e8993990612).pink[3]
    ],
    tickLength: 4,
    svgLabelSmall: {
        fill: (0, $89b5c35691e4b5c7$export$10473e9ffc331ca1)[2]
    },
    svgLabelBig: {
        fill: (0, $89b5c35691e4b5c7$export$10473e9ffc331ca1)[0]
    },
    gridColor: (0, $89b5c35691e4b5c7$export$10473e9ffc331ca1)[4],
    gridColorDark: (0, $89b5c35691e4b5c7$export$10473e9ffc331ca1)[1]
});




 // types


// @visx/zoom

var $5E6i4 = parcelRequire("5E6i4");

function $76c9c102e95074d9$var$clamp(v, min, max) {
    return Math.max(min, Math.min(v, max));
}
const $76c9c102e95074d9$export$e7c866399fa523f5 = {
    toVector (v, fallback) {
        if (v === undefined) v = fallback;
        return Array.isArray(v) ? v : [
            v,
            v
        ];
    },
    add (v1, v2) {
        return [
            v1[0] + v2[0],
            v1[1] + v2[1]
        ];
    },
    sub (v1, v2) {
        return [
            v1[0] - v2[0],
            v1[1] - v2[1]
        ];
    },
    addTo (v1, v2) {
        v1[0] += v2[0];
        v1[1] += v2[1];
    },
    subTo (v1, v2) {
        v1[0] -= v2[0];
        v1[1] -= v2[1];
    }
};
function $76c9c102e95074d9$var$rubberband(distance, dimension, constant) {
    if (dimension === 0 || Math.abs(dimension) === Infinity) return Math.pow(distance, constant * 5);
    return distance * dimension * constant / (dimension + constant * distance);
}
function $76c9c102e95074d9$export$43caf9889c228507(position, min, max, constant = 0.15) {
    if (constant === 0) return $76c9c102e95074d9$var$clamp(position, min, max);
    if (position < min) return -$76c9c102e95074d9$var$rubberband(min - position, max - min, constant) + min;
    if (position > max) return +$76c9c102e95074d9$var$rubberband(position - max, max - min, constant) + max;
    return position;
}
function $76c9c102e95074d9$export$db3b6bfb95261072(bounds, [Vx, Vy], [Rx, Ry]) {
    const [[X0, X1], [Y0, Y1]] = bounds;
    return [
        $76c9c102e95074d9$export$43caf9889c228507(Vx, X0, X1, Rx),
        $76c9c102e95074d9$export$43caf9889c228507(Vy, Y0, Y1, Ry)
    ];
}


function $f141e7d376023231$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $f141e7d376023231$var$_toPropertyKey(arg) {
    var key = $f141e7d376023231$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $f141e7d376023231$export$407448d2b89b1813(obj, key, value) {
    key = $f141e7d376023231$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f141e7d376023231$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f141e7d376023231$export$71511d61b312f219(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f141e7d376023231$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f141e7d376023231$export$407448d2b89b1813(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f141e7d376023231$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $f141e7d376023231$var$EVENT_TYPE_MAP = {
    pointer: {
        start: 'down',
        change: 'move',
        end: 'up'
    },
    mouse: {
        start: 'down',
        change: 'move',
        end: 'up'
    },
    touch: {
        start: 'start',
        change: 'move',
        end: 'end'
    },
    gesture: {
        start: 'start',
        change: 'change',
        end: 'end'
    }
};
function $f141e7d376023231$var$capitalize(string) {
    if (!string) return '';
    return string[0].toUpperCase() + string.slice(1);
}
const $f141e7d376023231$var$actionsWithoutCaptureSupported = [
    'enter',
    'leave'
];
function $f141e7d376023231$var$hasCapture(capture = false, actionKey) {
    return capture && !$f141e7d376023231$var$actionsWithoutCaptureSupported.includes(actionKey);
}
function $f141e7d376023231$export$4368d992c4eafac0(device, action = '', capture = false) {
    const deviceProps = $f141e7d376023231$var$EVENT_TYPE_MAP[device];
    const actionKey = deviceProps ? deviceProps[action] || action : action;
    return 'on' + $f141e7d376023231$var$capitalize(device) + $f141e7d376023231$var$capitalize(actionKey) + ($f141e7d376023231$var$hasCapture(capture, actionKey) ? 'Capture' : '');
}
const $f141e7d376023231$var$pointerCaptureEvents = [
    'gotpointercapture',
    'lostpointercapture'
];
function $f141e7d376023231$export$ffb5f4729a158638(prop) {
    let eventKey = prop.substring(2).toLowerCase();
    const passive = !!~eventKey.indexOf('passive');
    if (passive) eventKey = eventKey.replace('passive', '');
    const captureKey = $f141e7d376023231$var$pointerCaptureEvents.includes(eventKey) ? 'capturecapture' : 'capture';
    const capture = !!~eventKey.indexOf(captureKey);
    if (capture) eventKey = eventKey.replace('capture', '');
    return {
        device: eventKey,
        capture: capture,
        passive: passive
    };
}
function $f141e7d376023231$export$625550452a3fa3ec(device, action = '') {
    const deviceProps = $f141e7d376023231$var$EVENT_TYPE_MAP[device];
    const actionKey = deviceProps ? deviceProps[action] || action : action;
    return device + actionKey;
}
function $f141e7d376023231$export$23f2a1d2818174ef(event) {
    return 'touches' in event;
}
function $f141e7d376023231$var$getPointerType(event) {
    if ($f141e7d376023231$export$23f2a1d2818174ef(event)) return 'touch';
    if ('pointerType' in event) return event.pointerType;
    return 'mouse';
}
function $f141e7d376023231$var$getCurrentTargetTouchList(event) {
    return Array.from(event.touches).filter((e)=>{
        var _event$currentTarget, _event$currentTarget$;
        return e.target === event.currentTarget || ((_event$currentTarget = event.currentTarget) === null || _event$currentTarget === void 0 || (_event$currentTarget$ = _event$currentTarget.contains) === null || _event$currentTarget$ === void 0 ? void 0 : _event$currentTarget$.call(_event$currentTarget, e.target));
    });
}
function $f141e7d376023231$var$getTouchList(event) {
    return event.type === 'touchend' || event.type === 'touchcancel' ? event.changedTouches : event.targetTouches;
}
function $f141e7d376023231$var$getValueEvent(event) {
    return $f141e7d376023231$export$23f2a1d2818174ef(event) ? $f141e7d376023231$var$getTouchList(event)[0] : event;
}
function $f141e7d376023231$var$distanceAngle(P1, P2) {
    try {
        const dx = P2.clientX - P1.clientX;
        const dy = P2.clientY - P1.clientY;
        const cx = (P2.clientX + P1.clientX) / 2;
        const cy = (P2.clientY + P1.clientY) / 2;
        const distance = Math.hypot(dx, dy);
        const angle = -(Math.atan2(dx, dy) * 180) / Math.PI;
        const origin = [
            cx,
            cy
        ];
        return {
            angle: angle,
            distance: distance,
            origin: origin
        };
    } catch (_unused) {}
    return null;
}
function $f141e7d376023231$export$8b22cf2602fb60ce(event) {
    return $f141e7d376023231$var$getCurrentTargetTouchList(event).map((touch)=>touch.identifier);
}
function $f141e7d376023231$var$touchDistanceAngle(event, ids) {
    const [P1, P2] = Array.from(event.touches).filter((touch)=>ids.includes(touch.identifier));
    return $f141e7d376023231$var$distanceAngle(P1, P2);
}
function $f141e7d376023231$var$pointerId(event) {
    const valueEvent = $f141e7d376023231$var$getValueEvent(event);
    return $f141e7d376023231$export$23f2a1d2818174ef(event) ? valueEvent.identifier : valueEvent.pointerId;
}
function $f141e7d376023231$var$pointerValues(event) {
    const valueEvent = $f141e7d376023231$var$getValueEvent(event);
    return [
        valueEvent.clientX,
        valueEvent.clientY
    ];
}
const $f141e7d376023231$var$LINE_HEIGHT = 40;
const $f141e7d376023231$var$PAGE_HEIGHT = 800;
function $f141e7d376023231$var$wheelValues(event) {
    let { deltaX: deltaX, deltaY: deltaY, deltaMode: deltaMode } = event;
    if (deltaMode === 1) {
        deltaX *= $f141e7d376023231$var$LINE_HEIGHT;
        deltaY *= $f141e7d376023231$var$LINE_HEIGHT;
    } else if (deltaMode === 2) {
        deltaX *= $f141e7d376023231$var$PAGE_HEIGHT;
        deltaY *= $f141e7d376023231$var$PAGE_HEIGHT;
    }
    return [
        deltaX,
        deltaY
    ];
}
function $f141e7d376023231$var$scrollValues(event) {
    var _ref, _ref2;
    const { scrollX: scrollX, scrollY: scrollY, scrollLeft: scrollLeft, scrollTop: scrollTop } = event.currentTarget;
    return [
        (_ref = scrollX !== null && scrollX !== void 0 ? scrollX : scrollLeft) !== null && _ref !== void 0 ? _ref : 0,
        (_ref2 = scrollY !== null && scrollY !== void 0 ? scrollY : scrollTop) !== null && _ref2 !== void 0 ? _ref2 : 0
    ];
}
function $f141e7d376023231$var$getEventDetails(event) {
    const payload = {};
    if ('buttons' in event) payload.buttons = event.buttons;
    if ('shiftKey' in event) {
        const { shiftKey: shiftKey, altKey: altKey, metaKey: metaKey, ctrlKey: ctrlKey } = event;
        Object.assign(payload, {
            shiftKey: shiftKey,
            altKey: altKey,
            metaKey: metaKey,
            ctrlKey: ctrlKey
        });
    }
    return payload;
}
function $f141e7d376023231$var$call(v, ...args) {
    if (typeof v === 'function') return v(...args);
    else return v;
}
function $f141e7d376023231$var$noop() {}
function $f141e7d376023231$export$db3b6bfb95261072(...fns) {
    if (fns.length === 0) return $f141e7d376023231$var$noop;
    if (fns.length === 1) return fns[0];
    return function() {
        let result;
        for (const fn of fns)result = fn.apply(this, arguments) || result;
        return result;
    };
}
function $f141e7d376023231$var$assignDefault(value, fallback) {
    return Object.assign({}, fallback, value || {});
}
const $f141e7d376023231$var$BEFORE_LAST_KINEMATICS_DELAY = 32;
class $f141e7d376023231$var$Engine {
    constructor(ctrl, args, key){
        this.ctrl = ctrl;
        this.args = args;
        this.key = key;
        if (!this.state) {
            this.state = {};
            this.computeValues([
                0,
                0
            ]);
            this.computeInitial();
            if (this.init) this.init();
            this.reset();
        }
    }
    get state() {
        return this.ctrl.state[this.key];
    }
    set state(state) {
        this.ctrl.state[this.key] = state;
    }
    get shared() {
        return this.ctrl.state.shared;
    }
    get eventStore() {
        return this.ctrl.gestureEventStores[this.key];
    }
    get timeoutStore() {
        return this.ctrl.gestureTimeoutStores[this.key];
    }
    get config() {
        return this.ctrl.config[this.key];
    }
    get sharedConfig() {
        return this.ctrl.config.shared;
    }
    get handler() {
        return this.ctrl.handlers[this.key];
    }
    reset() {
        const { state: state, shared: shared, ingKey: ingKey, args: args } = this;
        shared[ingKey] = state._active = state.active = state._blocked = state._force = false;
        state._step = [
            false,
            false
        ];
        state.intentional = false;
        state._movement = [
            0,
            0
        ];
        state._distance = [
            0,
            0
        ];
        state._direction = [
            0,
            0
        ];
        state._delta = [
            0,
            0
        ];
        state._bounds = [
            [
                -Infinity,
                Infinity
            ],
            [
                -Infinity,
                Infinity
            ]
        ];
        state.args = args;
        state.axis = undefined;
        state.memo = undefined;
        state.elapsedTime = state.timeDelta = 0;
        state.direction = [
            0,
            0
        ];
        state.distance = [
            0,
            0
        ];
        state.overflow = [
            0,
            0
        ];
        state._movementBound = [
            false,
            false
        ];
        state.velocity = [
            0,
            0
        ];
        state.movement = [
            0,
            0
        ];
        state.delta = [
            0,
            0
        ];
        state.timeStamp = 0;
    }
    start(event) {
        const state = this.state;
        const config = this.config;
        if (!state._active) {
            this.reset();
            this.computeInitial();
            state._active = true;
            state.target = event.target;
            state.currentTarget = event.currentTarget;
            state.lastOffset = config.from ? $f141e7d376023231$var$call(config.from, state) : state.offset;
            state.offset = state.lastOffset;
            state.startTime = state.timeStamp = event.timeStamp;
        }
    }
    computeValues(values) {
        const state = this.state;
        state._values = values;
        state.values = this.config.transform(values);
    }
    computeInitial() {
        const state = this.state;
        state._initial = state._values;
        state.initial = state.values;
    }
    compute(event) {
        const { state: state, config: config, shared: shared } = this;
        state.args = this.args;
        let dt = 0;
        if (event) {
            state.event = event;
            if (config.preventDefault && event.cancelable) state.event.preventDefault();
            state.type = event.type;
            shared.touches = this.ctrl.pointerIds.size || this.ctrl.touchIds.size;
            shared.locked = !!document.pointerLockElement;
            Object.assign(shared, $f141e7d376023231$var$getEventDetails(event));
            shared.down = shared.pressed = shared.buttons % 2 === 1 || shared.touches > 0;
            dt = event.timeStamp - state.timeStamp;
            state.timeStamp = event.timeStamp;
            state.elapsedTime = state.timeStamp - state.startTime;
        }
        if (state._active) {
            const _absoluteDelta = state._delta.map(Math.abs);
            (0, $76c9c102e95074d9$export$e7c866399fa523f5).addTo(state._distance, _absoluteDelta);
        }
        if (this.axisIntent) this.axisIntent(event);
        const [_m0, _m1] = state._movement;
        const [t0, t1] = config.threshold;
        const { _step: _step, values: values } = state;
        if (config.hasCustomTransform) {
            if (_step[0] === false) _step[0] = Math.abs(_m0) >= t0 && values[0];
            if (_step[1] === false) _step[1] = Math.abs(_m1) >= t1 && values[1];
        } else {
            if (_step[0] === false) _step[0] = Math.abs(_m0) >= t0 && Math.sign(_m0) * t0;
            if (_step[1] === false) _step[1] = Math.abs(_m1) >= t1 && Math.sign(_m1) * t1;
        }
        state.intentional = _step[0] !== false || _step[1] !== false;
        if (!state.intentional) return;
        const movement = [
            0,
            0
        ];
        if (config.hasCustomTransform) {
            const [v0, v1] = values;
            movement[0] = _step[0] !== false ? v0 - _step[0] : 0;
            movement[1] = _step[1] !== false ? v1 - _step[1] : 0;
        } else {
            movement[0] = _step[0] !== false ? _m0 - _step[0] : 0;
            movement[1] = _step[1] !== false ? _m1 - _step[1] : 0;
        }
        if (this.restrictToAxis && !state._blocked) this.restrictToAxis(movement);
        const previousOffset = state.offset;
        const gestureIsActive = state._active && !state._blocked || state.active;
        if (gestureIsActive) {
            state.first = state._active && !state.active;
            state.last = !state._active && state.active;
            state.active = shared[this.ingKey] = state._active;
            if (event) {
                if (state.first) {
                    if ('bounds' in config) state._bounds = $f141e7d376023231$var$call(config.bounds, state);
                    if (this.setup) this.setup();
                }
                state.movement = movement;
                this.computeOffset();
            }
        }
        const [ox, oy] = state.offset;
        const [[x0, x1], [y0, y1]] = state._bounds;
        state.overflow = [
            ox < x0 ? -1 : ox > x1 ? 1 : 0,
            oy < y0 ? -1 : oy > y1 ? 1 : 0
        ];
        state._movementBound[0] = state.overflow[0] ? state._movementBound[0] === false ? state._movement[0] : state._movementBound[0] : false;
        state._movementBound[1] = state.overflow[1] ? state._movementBound[1] === false ? state._movement[1] : state._movementBound[1] : false;
        const rubberband = state._active ? config.rubberband || [
            0,
            0
        ] : [
            0,
            0
        ];
        state.offset = (0, $76c9c102e95074d9$export$db3b6bfb95261072)(state._bounds, state.offset, rubberband);
        state.delta = (0, $76c9c102e95074d9$export$e7c866399fa523f5).sub(state.offset, previousOffset);
        this.computeMovement();
        if (gestureIsActive && (!state.last || dt > $f141e7d376023231$var$BEFORE_LAST_KINEMATICS_DELAY)) {
            state.delta = (0, $76c9c102e95074d9$export$e7c866399fa523f5).sub(state.offset, previousOffset);
            const absoluteDelta = state.delta.map(Math.abs);
            (0, $76c9c102e95074d9$export$e7c866399fa523f5).addTo(state.distance, absoluteDelta);
            state.direction = state.delta.map(Math.sign);
            state._direction = state._delta.map(Math.sign);
            if (!state.first && dt > 0) {
                state.velocity = [
                    absoluteDelta[0] / dt,
                    absoluteDelta[1] / dt
                ];
                state.timeDelta = dt;
            }
        }
    }
    emit() {
        const state = this.state;
        const shared = this.shared;
        const config = this.config;
        if (!state._active) this.clean();
        if ((state._blocked || !state.intentional) && !state._force && !config.triggerAllEvents) return;
        const memo = this.handler($f141e7d376023231$export$71511d61b312f219($f141e7d376023231$export$71511d61b312f219($f141e7d376023231$export$71511d61b312f219({}, shared), state), {}, {
            [this.aliasKey]: state.values
        }));
        if (memo !== undefined) state.memo = memo;
    }
    clean() {
        this.eventStore.clean();
        this.timeoutStore.clean();
    }
}
function $f141e7d376023231$var$selectAxis([dx, dy], threshold) {
    const absDx = Math.abs(dx);
    const absDy = Math.abs(dy);
    if (absDx > absDy && absDx > threshold) return 'x';
    if (absDy > absDx && absDy > threshold) return 'y';
    return undefined;
}
class $f141e7d376023231$var$CoordinatesEngine extends $f141e7d376023231$var$Engine {
    constructor(...args){
        super(...args);
        $f141e7d376023231$export$407448d2b89b1813(this, "aliasKey", 'xy');
    }
    reset() {
        super.reset();
        this.state.axis = undefined;
    }
    init() {
        this.state.offset = [
            0,
            0
        ];
        this.state.lastOffset = [
            0,
            0
        ];
    }
    computeOffset() {
        this.state.offset = (0, $76c9c102e95074d9$export$e7c866399fa523f5).add(this.state.lastOffset, this.state.movement);
    }
    computeMovement() {
        this.state.movement = (0, $76c9c102e95074d9$export$e7c866399fa523f5).sub(this.state.offset, this.state.lastOffset);
    }
    axisIntent(event) {
        const state = this.state;
        const config = this.config;
        if (!state.axis && event) {
            const threshold = typeof config.axisThreshold === 'object' ? config.axisThreshold[$f141e7d376023231$var$getPointerType(event)] : config.axisThreshold;
            state.axis = $f141e7d376023231$var$selectAxis(state._movement, threshold);
        }
        state._blocked = (config.lockDirection || !!config.axis) && !state.axis || !!config.axis && config.axis !== state.axis;
    }
    restrictToAxis(v) {
        if (this.config.axis || this.config.lockDirection) switch(this.state.axis){
            case 'x':
                v[1] = 0;
                break;
            case 'y':
                v[0] = 0;
                break;
        }
    }
}
const $f141e7d376023231$var$identity = (v)=>v;
const $f141e7d376023231$var$DEFAULT_RUBBERBAND = 0.15;
const $f141e7d376023231$var$commonConfigResolver = {
    enabled (value = true) {
        return value;
    },
    eventOptions (value, _k, config) {
        return $f141e7d376023231$export$71511d61b312f219($f141e7d376023231$export$71511d61b312f219({}, config.shared.eventOptions), value);
    },
    preventDefault (value = false) {
        return value;
    },
    triggerAllEvents (value = false) {
        return value;
    },
    rubberband (value = 0) {
        switch(value){
            case true:
                return [
                    $f141e7d376023231$var$DEFAULT_RUBBERBAND,
                    $f141e7d376023231$var$DEFAULT_RUBBERBAND
                ];
            case false:
                return [
                    0,
                    0
                ];
            default:
                return (0, $76c9c102e95074d9$export$e7c866399fa523f5).toVector(value);
        }
    },
    from (value) {
        if (typeof value === 'function') return value;
        if (value != null) return (0, $76c9c102e95074d9$export$e7c866399fa523f5).toVector(value);
    },
    transform (value, _k, config) {
        const transform = value || config.shared.transform;
        this.hasCustomTransform = !!transform;
        var v;
        return transform || $f141e7d376023231$var$identity;
    },
    threshold (value) {
        return (0, $76c9c102e95074d9$export$e7c866399fa523f5).toVector(value, 0);
    }
};
var $f141e7d376023231$var$value, $f141e7d376023231$var$value1, $f141e7d376023231$var$value2;
const $f141e7d376023231$var$DEFAULT_AXIS_THRESHOLD = 0;
const $f141e7d376023231$var$coordinatesConfigResolver = $f141e7d376023231$export$71511d61b312f219($f141e7d376023231$export$71511d61b312f219({}, $f141e7d376023231$var$commonConfigResolver), {}, {
    axis (_v, _k, { axis: axis }) {
        this.lockDirection = axis === 'lock';
        if (!this.lockDirection) return axis;
    },
    axisThreshold (value = $f141e7d376023231$var$DEFAULT_AXIS_THRESHOLD) {
        return value;
    },
    bounds (value = {}) {
        if (typeof value === 'function') return (state)=>$f141e7d376023231$var$coordinatesConfigResolver.bounds(value(state));
        if ('current' in value) return ()=>value.current;
        if (typeof HTMLElement === 'function' && value instanceof HTMLElement) return value;
        const { left: left = -Infinity, right: right = Infinity, top: top = -Infinity, bottom: bottom = Infinity } = value;
        return [
            [
                left,
                right
            ],
            [
                top,
                bottom
            ]
        ];
    }
});
const $f141e7d376023231$var$KEYS_DELTA_MAP = {
    ArrowRight: (displacement, factor = 1)=>[
            displacement * factor,
            0
        ],
    ArrowLeft: (displacement, factor = 1)=>[
            -1 * displacement * factor,
            0
        ],
    ArrowUp: (displacement, factor = 1)=>[
            0,
            -1 * displacement * factor
        ],
    ArrowDown: (displacement, factor = 1)=>[
            0,
            displacement * factor
        ]
};
class $f141e7d376023231$var$DragEngine extends $f141e7d376023231$var$CoordinatesEngine {
    constructor(...args){
        super(...args);
        $f141e7d376023231$export$407448d2b89b1813(this, "ingKey", 'dragging');
    }
    reset() {
        super.reset();
        const state = this.state;
        state._pointerId = undefined;
        state._pointerActive = false;
        state._keyboardActive = false;
        state._preventScroll = false;
        state._delayed = false;
        state.swipe = [
            0,
            0
        ];
        state.tap = false;
        state.canceled = false;
        state.cancel = this.cancel.bind(this);
    }
    setup() {
        const state = this.state;
        if (state._bounds instanceof HTMLElement) {
            const boundRect = state._bounds.getBoundingClientRect();
            const targetRect = state.currentTarget.getBoundingClientRect();
            const _bounds = {
                left: boundRect.left - targetRect.left + state.offset[0],
                right: boundRect.right - targetRect.right + state.offset[0],
                top: boundRect.top - targetRect.top + state.offset[1],
                bottom: boundRect.bottom - targetRect.bottom + state.offset[1]
            };
            state._bounds = $f141e7d376023231$var$coordinatesConfigResolver.bounds(_bounds);
        }
    }
    cancel() {
        const state = this.state;
        if (state.canceled) return;
        state.canceled = true;
        state._active = false;
        setTimeout(()=>{
            this.compute();
            this.emit();
        }, 0);
    }
    setActive() {
        this.state._active = this.state._pointerActive || this.state._keyboardActive;
    }
    clean() {
        this.pointerClean();
        this.state._pointerActive = false;
        this.state._keyboardActive = false;
        super.clean();
    }
    pointerDown(event) {
        const config = this.config;
        const state = this.state;
        if (event.buttons != null && (Array.isArray(config.pointerButtons) ? !config.pointerButtons.includes(event.buttons) : config.pointerButtons !== -1 && config.pointerButtons !== event.buttons)) return;
        const ctrlIds = this.ctrl.setEventIds(event);
        if (config.pointerCapture) event.target.setPointerCapture(event.pointerId);
        if (ctrlIds && ctrlIds.size > 1 && state._pointerActive) return;
        this.start(event);
        this.setupPointer(event);
        state._pointerId = $f141e7d376023231$var$pointerId(event);
        state._pointerActive = true;
        this.computeValues($f141e7d376023231$var$pointerValues(event));
        this.computeInitial();
        if (config.preventScrollAxis && $f141e7d376023231$var$getPointerType(event) !== 'mouse') {
            state._active = false;
            this.setupScrollPrevention(event);
        } else if (config.delay > 0) {
            this.setupDelayTrigger(event);
            if (config.triggerAllEvents) {
                this.compute(event);
                this.emit();
            }
        } else this.startPointerDrag(event);
    }
    startPointerDrag(event) {
        const state = this.state;
        state._active = true;
        state._preventScroll = true;
        state._delayed = false;
        this.compute(event);
        this.emit();
    }
    pointerMove(event) {
        const state = this.state;
        const config = this.config;
        if (!state._pointerActive) return;
        const id = $f141e7d376023231$var$pointerId(event);
        if (state._pointerId !== undefined && id !== state._pointerId) return;
        const _values = $f141e7d376023231$var$pointerValues(event);
        if (document.pointerLockElement === event.target) state._delta = [
            event.movementX,
            event.movementY
        ];
        else {
            state._delta = (0, $76c9c102e95074d9$export$e7c866399fa523f5).sub(_values, state._values);
            this.computeValues(_values);
        }
        (0, $76c9c102e95074d9$export$e7c866399fa523f5).addTo(state._movement, state._delta);
        this.compute(event);
        if (state._delayed && state.intentional) {
            this.timeoutStore.remove('dragDelay');
            state.active = false;
            this.startPointerDrag(event);
            return;
        }
        if (config.preventScrollAxis && !state._preventScroll) {
            if (state.axis) {
                if (state.axis === config.preventScrollAxis || config.preventScrollAxis === 'xy') {
                    state._active = false;
                    this.clean();
                    return;
                } else {
                    this.timeoutStore.remove('startPointerDrag');
                    this.startPointerDrag(event);
                    return;
                }
            } else return;
        }
        this.emit();
    }
    pointerUp(event) {
        this.ctrl.setEventIds(event);
        try {
            if (this.config.pointerCapture && event.target.hasPointerCapture(event.pointerId)) event.target.releasePointerCapture(event.pointerId);
        } catch (_unused) {}
        const state = this.state;
        const config = this.config;
        if (!state._active || !state._pointerActive) return;
        const id = $f141e7d376023231$var$pointerId(event);
        if (state._pointerId !== undefined && id !== state._pointerId) return;
        this.state._pointerActive = false;
        this.setActive();
        this.compute(event);
        const [dx, dy] = state._distance;
        state.tap = dx <= config.tapsThreshold && dy <= config.tapsThreshold;
        if (state.tap && config.filterTaps) state._force = true;
        else {
            const [_dx, _dy] = state._delta;
            const [_mx, _my] = state._movement;
            const [svx, svy] = config.swipe.velocity;
            const [sx, sy] = config.swipe.distance;
            const sdt = config.swipe.duration;
            if (state.elapsedTime < sdt) {
                const _vx = Math.abs(_dx / state.timeDelta);
                const _vy = Math.abs(_dy / state.timeDelta);
                if (_vx > svx && Math.abs(_mx) > sx) state.swipe[0] = Math.sign(_dx);
                if (_vy > svy && Math.abs(_my) > sy) state.swipe[1] = Math.sign(_dy);
            }
        }
        this.emit();
    }
    pointerClick(event) {
        if (!this.state.tap && event.detail > 0) {
            event.preventDefault();
            event.stopPropagation();
        }
    }
    setupPointer(event) {
        const config = this.config;
        const device = config.device;
        var _unused2;
        if (config.pointerLock) event.currentTarget.requestPointerLock();
        if (!config.pointerCapture) {
            this.eventStore.add(this.sharedConfig.window, device, 'change', this.pointerMove.bind(this));
            this.eventStore.add(this.sharedConfig.window, device, 'end', this.pointerUp.bind(this));
            this.eventStore.add(this.sharedConfig.window, device, 'cancel', this.pointerUp.bind(this));
        }
    }
    pointerClean() {
        if (this.config.pointerLock && document.pointerLockElement === this.state.currentTarget) document.exitPointerLock();
    }
    preventScroll(event) {
        if (this.state._preventScroll && event.cancelable) event.preventDefault();
    }
    setupScrollPrevention(event) {
        this.state._preventScroll = false;
        $f141e7d376023231$var$persistEvent(event);
        const remove = this.eventStore.add(this.sharedConfig.window, 'touch', 'change', this.preventScroll.bind(this), {
            passive: false
        });
        this.eventStore.add(this.sharedConfig.window, 'touch', 'end', remove);
        this.eventStore.add(this.sharedConfig.window, 'touch', 'cancel', remove);
        this.timeoutStore.add('startPointerDrag', this.startPointerDrag.bind(this), this.config.preventScrollDelay, event);
    }
    setupDelayTrigger(event) {
        this.state._delayed = true;
        this.timeoutStore.add('dragDelay', ()=>{
            this.state._step = [
                0,
                0
            ];
            this.startPointerDrag(event);
        }, this.config.delay);
    }
    keyDown(event) {
        const deltaFn = $f141e7d376023231$var$KEYS_DELTA_MAP[event.key];
        if (deltaFn) {
            const state = this.state;
            const factor = event.shiftKey ? 10 : event.altKey ? 0.1 : 1;
            this.start(event);
            state._delta = deltaFn(this.config.keyboardDisplacement, factor);
            state._keyboardActive = true;
            (0, $76c9c102e95074d9$export$e7c866399fa523f5).addTo(state._movement, state._delta);
            this.compute(event);
            this.emit();
        }
    }
    keyUp(event) {
        if (!(event.key in $f141e7d376023231$var$KEYS_DELTA_MAP)) return;
        this.state._keyboardActive = false;
        this.setActive();
        this.compute(event);
        this.emit();
    }
    bind(bindFunction) {
        const device = this.config.device;
        bindFunction(device, 'start', this.pointerDown.bind(this));
        if (this.config.pointerCapture) {
            bindFunction(device, 'change', this.pointerMove.bind(this));
            bindFunction(device, 'end', this.pointerUp.bind(this));
            bindFunction(device, 'cancel', this.pointerUp.bind(this));
            bindFunction('lostPointerCapture', '', this.pointerUp.bind(this));
        }
        if (this.config.keys) {
            bindFunction('key', 'down', this.keyDown.bind(this));
            bindFunction('key', 'up', this.keyUp.bind(this));
        }
        if (this.config.filterTaps) bindFunction('click', '', this.pointerClick.bind(this), {
            capture: true,
            passive: false
        });
    }
}
function $f141e7d376023231$var$persistEvent(event) {
    'persist' in event && typeof event.persist === 'function' && event.persist();
}
const $f141e7d376023231$var$isBrowser = typeof window !== 'undefined' && window.document && window.document.createElement;
function $f141e7d376023231$var$supportsTouchEvents() {
    return $f141e7d376023231$var$isBrowser && 'ontouchstart' in window;
}
function $f141e7d376023231$var$isTouchScreen() {
    return $f141e7d376023231$var$supportsTouchEvents() || $f141e7d376023231$var$isBrowser && window.navigator.maxTouchPoints > 1;
}
function $f141e7d376023231$var$supportsPointerEvents() {
    return $f141e7d376023231$var$isBrowser && 'onpointerdown' in window;
}
function $f141e7d376023231$var$supportsPointerLock() {
    return $f141e7d376023231$var$isBrowser && 'exitPointerLock' in window.document;
}
function $f141e7d376023231$var$supportsGestureEvents() {
    try {
        return 'constructor' in GestureEvent;
    } catch (e) {
        return false;
    }
}
const $f141e7d376023231$export$25ce5a424b770e84 = {
    isBrowser: $f141e7d376023231$var$isBrowser,
    gesture: $f141e7d376023231$var$supportsGestureEvents(),
    touch: $f141e7d376023231$var$supportsTouchEvents(),
    touchscreen: $f141e7d376023231$var$isTouchScreen(),
    pointer: $f141e7d376023231$var$supportsPointerEvents(),
    pointerLock: $f141e7d376023231$var$supportsPointerLock()
};
const $f141e7d376023231$var$DEFAULT_PREVENT_SCROLL_DELAY = 250;
const $f141e7d376023231$var$DEFAULT_DRAG_DELAY = 180;
const $f141e7d376023231$var$DEFAULT_SWIPE_VELOCITY = 0.5;
const $f141e7d376023231$var$DEFAULT_SWIPE_DISTANCE = 50;
const $f141e7d376023231$var$DEFAULT_SWIPE_DURATION = 250;
const $f141e7d376023231$var$DEFAULT_KEYBOARD_DISPLACEMENT = 10;
const $f141e7d376023231$var$DEFAULT_DRAG_AXIS_THRESHOLD = {
    mouse: 0,
    touch: 0,
    pen: 8
};
const $f141e7d376023231$var$dragConfigResolver = $f141e7d376023231$export$71511d61b312f219($f141e7d376023231$export$71511d61b312f219({}, $f141e7d376023231$var$coordinatesConfigResolver), {}, {
    device (_v, _k, { pointer: { touch: touch = false, lock: lock = false, mouse: mouse = false } = {} }) {
        this.pointerLock = lock && $f141e7d376023231$export$25ce5a424b770e84.pointerLock;
        if ($f141e7d376023231$export$25ce5a424b770e84.touch && touch) return 'touch';
        if (this.pointerLock) return 'mouse';
        if ($f141e7d376023231$export$25ce5a424b770e84.pointer && !mouse) return 'pointer';
        if ($f141e7d376023231$export$25ce5a424b770e84.touch) return 'touch';
        return 'mouse';
    },
    preventScrollAxis (value, _k, { preventScroll: preventScroll }) {
        this.preventScrollDelay = typeof preventScroll === 'number' ? preventScroll : preventScroll || preventScroll === undefined && value ? $f141e7d376023231$var$DEFAULT_PREVENT_SCROLL_DELAY : undefined;
        if (!$f141e7d376023231$export$25ce5a424b770e84.touchscreen || preventScroll === false) return undefined;
        return value ? value : preventScroll !== undefined ? 'y' : undefined;
    },
    pointerCapture (_v, _k, { pointer: { capture: capture = true, buttons: buttons = 1, keys: keys = true } = {} }) {
        this.pointerButtons = buttons;
        this.keys = keys;
        return !this.pointerLock && this.device === 'pointer' && capture;
    },
    threshold (value, _k, { filterTaps: filterTaps = false, tapsThreshold: tapsThreshold = 3, axis: axis }) {
        const threshold = (0, $76c9c102e95074d9$export$e7c866399fa523f5).toVector(value, filterTaps ? tapsThreshold : axis ? 1 : 0);
        this.filterTaps = filterTaps;
        this.tapsThreshold = tapsThreshold;
        return threshold;
    },
    swipe ({ velocity: velocity = $f141e7d376023231$var$DEFAULT_SWIPE_VELOCITY, distance: distance = $f141e7d376023231$var$DEFAULT_SWIPE_DISTANCE, duration: duration = $f141e7d376023231$var$DEFAULT_SWIPE_DURATION } = {}) {
        return {
            velocity: this.transform((0, $76c9c102e95074d9$export$e7c866399fa523f5).toVector(velocity)),
            distance: this.transform((0, $76c9c102e95074d9$export$e7c866399fa523f5).toVector(distance)),
            duration: duration
        };
    },
    delay (value = 0) {
        switch(value){
            case true:
                return $f141e7d376023231$var$DEFAULT_DRAG_DELAY;
            case false:
                return 0;
            default:
                return value;
        }
    },
    axisThreshold (value) {
        if (!value) return $f141e7d376023231$var$DEFAULT_DRAG_AXIS_THRESHOLD;
        return $f141e7d376023231$export$71511d61b312f219($f141e7d376023231$export$71511d61b312f219({}, $f141e7d376023231$var$DEFAULT_DRAG_AXIS_THRESHOLD), value);
    },
    keyboardDisplacement (value = $f141e7d376023231$var$DEFAULT_KEYBOARD_DISPLACEMENT) {
        return value;
    }
});
var $f141e7d376023231$var$value3, $f141e7d376023231$var$value4, $f141e7d376023231$var$value5, $f141e7d376023231$var$value6, $f141e7d376023231$var$value7;
function $f141e7d376023231$var$clampStateInternalMovementToBounds(state) {
    const [ox, oy] = state.overflow;
    const [dx, dy] = state._delta;
    const [dirx, diry] = state._direction;
    if (ox < 0 && dx > 0 && dirx < 0 || ox > 0 && dx < 0 && dirx > 0) state._movement[0] = state._movementBound[0];
    if (oy < 0 && dy > 0 && diry < 0 || oy > 0 && dy < 0 && diry > 0) state._movement[1] = state._movementBound[1];
}
const $f141e7d376023231$var$SCALE_ANGLE_RATIO_INTENT_DEG = 30;
const $f141e7d376023231$var$PINCH_WHEEL_RATIO = 100;
class $f141e7d376023231$var$PinchEngine extends $f141e7d376023231$var$Engine {
    constructor(...args){
        super(...args);
        $f141e7d376023231$export$407448d2b89b1813(this, "ingKey", 'pinching');
        $f141e7d376023231$export$407448d2b89b1813(this, "aliasKey", 'da');
    }
    init() {
        this.state.offset = [
            1,
            0
        ];
        this.state.lastOffset = [
            1,
            0
        ];
        this.state._pointerEvents = new Map();
    }
    reset() {
        super.reset();
        const state = this.state;
        state._touchIds = [];
        state.canceled = false;
        state.cancel = this.cancel.bind(this);
        state.turns = 0;
    }
    computeOffset() {
        const { type: type, movement: movement, lastOffset: lastOffset } = this.state;
        if (type === 'wheel') this.state.offset = (0, $76c9c102e95074d9$export$e7c866399fa523f5).add(movement, lastOffset);
        else this.state.offset = [
            (1 + movement[0]) * lastOffset[0],
            movement[1] + lastOffset[1]
        ];
    }
    computeMovement() {
        const { offset: offset, lastOffset: lastOffset } = this.state;
        this.state.movement = [
            offset[0] / lastOffset[0],
            offset[1] - lastOffset[1]
        ];
    }
    axisIntent() {
        const state = this.state;
        const [_m0, _m1] = state._movement;
        if (!state.axis) {
            const axisMovementDifference = Math.abs(_m0) * $f141e7d376023231$var$SCALE_ANGLE_RATIO_INTENT_DEG - Math.abs(_m1);
            if (axisMovementDifference < 0) state.axis = 'angle';
            else if (axisMovementDifference > 0) state.axis = 'scale';
        }
    }
    restrictToAxis(v) {
        if (this.config.lockDirection) {
            if (this.state.axis === 'scale') v[1] = 0;
            else if (this.state.axis === 'angle') v[0] = 0;
        }
    }
    cancel() {
        const state = this.state;
        if (state.canceled) return;
        setTimeout(()=>{
            state.canceled = true;
            state._active = false;
            this.compute();
            this.emit();
        }, 0);
    }
    touchStart(event) {
        this.ctrl.setEventIds(event);
        const state = this.state;
        const ctrlTouchIds = this.ctrl.touchIds;
        if (state._active) {
            if (state._touchIds.every((id)=>ctrlTouchIds.has(id))) return;
        }
        if (ctrlTouchIds.size < 2) return;
        this.start(event);
        state._touchIds = Array.from(ctrlTouchIds).slice(0, 2);
        const payload = $f141e7d376023231$var$touchDistanceAngle(event, state._touchIds);
        if (!payload) return;
        this.pinchStart(event, payload);
    }
    pointerStart(event) {
        if (event.buttons != null && event.buttons % 2 !== 1) return;
        this.ctrl.setEventIds(event);
        event.target.setPointerCapture(event.pointerId);
        const state = this.state;
        const _pointerEvents = state._pointerEvents;
        const ctrlPointerIds = this.ctrl.pointerIds;
        if (state._active) {
            if (Array.from(_pointerEvents.keys()).every((id)=>ctrlPointerIds.has(id))) return;
        }
        if (_pointerEvents.size < 2) _pointerEvents.set(event.pointerId, event);
        if (state._pointerEvents.size < 2) return;
        this.start(event);
        const payload = $f141e7d376023231$var$distanceAngle(...Array.from(_pointerEvents.values()));
        if (!payload) return;
        this.pinchStart(event, payload);
    }
    pinchStart(event, payload) {
        const state = this.state;
        state.origin = payload.origin;
        this.computeValues([
            payload.distance,
            payload.angle
        ]);
        this.computeInitial();
        this.compute(event);
        this.emit();
    }
    touchMove(event) {
        if (!this.state._active) return;
        const payload = $f141e7d376023231$var$touchDistanceAngle(event, this.state._touchIds);
        if (!payload) return;
        this.pinchMove(event, payload);
    }
    pointerMove(event) {
        const _pointerEvents = this.state._pointerEvents;
        if (_pointerEvents.has(event.pointerId)) _pointerEvents.set(event.pointerId, event);
        if (!this.state._active) return;
        const payload = $f141e7d376023231$var$distanceAngle(...Array.from(_pointerEvents.values()));
        if (!payload) return;
        this.pinchMove(event, payload);
    }
    pinchMove(event, payload) {
        const state = this.state;
        const prev_a = state._values[1];
        const delta_a = payload.angle - prev_a;
        let delta_turns = 0;
        if (Math.abs(delta_a) > 270) delta_turns += Math.sign(delta_a);
        this.computeValues([
            payload.distance,
            payload.angle - 360 * delta_turns
        ]);
        state.origin = payload.origin;
        state.turns = delta_turns;
        state._movement = [
            state._values[0] / state._initial[0] - 1,
            state._values[1] - state._initial[1]
        ];
        this.compute(event);
        this.emit();
    }
    touchEnd(event) {
        this.ctrl.setEventIds(event);
        if (!this.state._active) return;
        if (this.state._touchIds.some((id)=>!this.ctrl.touchIds.has(id))) {
            this.state._active = false;
            this.compute(event);
            this.emit();
        }
    }
    pointerEnd(event) {
        const state = this.state;
        this.ctrl.setEventIds(event);
        try {
            event.target.releasePointerCapture(event.pointerId);
        } catch (_unused) {}
        if (state._pointerEvents.has(event.pointerId)) state._pointerEvents.delete(event.pointerId);
        if (!state._active) return;
        if (state._pointerEvents.size < 2) {
            state._active = false;
            this.compute(event);
            this.emit();
        }
    }
    gestureStart(event) {
        if (event.cancelable) event.preventDefault();
        const state = this.state;
        if (state._active) return;
        this.start(event);
        this.computeValues([
            event.scale,
            event.rotation
        ]);
        state.origin = [
            event.clientX,
            event.clientY
        ];
        this.compute(event);
        this.emit();
    }
    gestureMove(event) {
        if (event.cancelable) event.preventDefault();
        if (!this.state._active) return;
        const state = this.state;
        this.computeValues([
            event.scale,
            event.rotation
        ]);
        state.origin = [
            event.clientX,
            event.clientY
        ];
        const _previousMovement = state._movement;
        state._movement = [
            event.scale - 1,
            event.rotation
        ];
        state._delta = (0, $76c9c102e95074d9$export$e7c866399fa523f5).sub(state._movement, _previousMovement);
        this.compute(event);
        this.emit();
    }
    gestureEnd(event) {
        if (!this.state._active) return;
        this.state._active = false;
        this.compute(event);
        this.emit();
    }
    wheel(event) {
        const modifierKey = this.config.modifierKey;
        if (modifierKey && (Array.isArray(modifierKey) ? !modifierKey.find((k)=>event[k]) : !event[modifierKey])) return;
        if (!this.state._active) this.wheelStart(event);
        else this.wheelChange(event);
        this.timeoutStore.add('wheelEnd', this.wheelEnd.bind(this));
    }
    wheelStart(event) {
        this.start(event);
        this.wheelChange(event);
    }
    wheelChange(event) {
        const isR3f = 'uv' in event;
        if (!isR3f) {
            if (event.cancelable) event.preventDefault();
        }
        const state = this.state;
        state._delta = [
            -$f141e7d376023231$var$wheelValues(event)[1] / $f141e7d376023231$var$PINCH_WHEEL_RATIO * state.offset[0],
            0
        ];
        (0, $76c9c102e95074d9$export$e7c866399fa523f5).addTo(state._movement, state._delta);
        $f141e7d376023231$var$clampStateInternalMovementToBounds(state);
        this.state.origin = [
            event.clientX,
            event.clientY
        ];
        this.compute(event);
        this.emit();
    }
    wheelEnd() {
        if (!this.state._active) return;
        this.state._active = false;
        this.compute();
        this.emit();
    }
    bind(bindFunction) {
        const device = this.config.device;
        if (!!device) {
            bindFunction(device, 'start', this[device + 'Start'].bind(this));
            bindFunction(device, 'change', this[device + 'Move'].bind(this));
            bindFunction(device, 'end', this[device + 'End'].bind(this));
            bindFunction(device, 'cancel', this[device + 'End'].bind(this));
            bindFunction('lostPointerCapture', '', this[device + 'End'].bind(this));
        }
        if (this.config.pinchOnWheel) bindFunction('wheel', '', this.wheel.bind(this), {
            passive: false
        });
    }
}
const $f141e7d376023231$var$pinchConfigResolver = $f141e7d376023231$export$71511d61b312f219($f141e7d376023231$export$71511d61b312f219({}, $f141e7d376023231$var$commonConfigResolver), {}, {
    device (_v, _k, { shared: shared, pointer: { touch: touch = false } = {} }) {
        const sharedConfig = shared;
        if (sharedConfig.target && !$f141e7d376023231$export$25ce5a424b770e84.touch && $f141e7d376023231$export$25ce5a424b770e84.gesture) return 'gesture';
        if ($f141e7d376023231$export$25ce5a424b770e84.touch && touch) return 'touch';
        if ($f141e7d376023231$export$25ce5a424b770e84.touchscreen) {
            if ($f141e7d376023231$export$25ce5a424b770e84.pointer) return 'pointer';
            if ($f141e7d376023231$export$25ce5a424b770e84.touch) return 'touch';
        }
    },
    bounds (_v, _k, { scaleBounds: scaleBounds = {}, angleBounds: angleBounds = {} }) {
        const _scaleBounds = (state)=>{
            const D = $f141e7d376023231$var$assignDefault($f141e7d376023231$var$call(scaleBounds, state), {
                min: -Infinity,
                max: Infinity
            });
            return [
                D.min,
                D.max
            ];
        };
        const _angleBounds = (state)=>{
            const A = $f141e7d376023231$var$assignDefault($f141e7d376023231$var$call(angleBounds, state), {
                min: -Infinity,
                max: Infinity
            });
            return [
                A.min,
                A.max
            ];
        };
        if (typeof scaleBounds !== 'function' && typeof angleBounds !== 'function') return [
            _scaleBounds(),
            _angleBounds()
        ];
        return (state)=>[
                _scaleBounds(state),
                _angleBounds(state)
            ];
    },
    threshold (value, _k, config) {
        this.lockDirection = config.axis === 'lock';
        const threshold = (0, $76c9c102e95074d9$export$e7c866399fa523f5).toVector(value, this.lockDirection ? [
            0.1,
            3
        ] : 0);
        return threshold;
    },
    modifierKey (value) {
        if (value === undefined) return 'ctrlKey';
        return value;
    },
    pinchOnWheel (value = true) {
        return value;
    }
});
class $f141e7d376023231$var$MoveEngine extends $f141e7d376023231$var$CoordinatesEngine {
    constructor(...args){
        super(...args);
        $f141e7d376023231$export$407448d2b89b1813(this, "ingKey", 'moving');
    }
    move(event) {
        if (this.config.mouseOnly && event.pointerType !== 'mouse') return;
        if (!this.state._active) this.moveStart(event);
        else this.moveChange(event);
        this.timeoutStore.add('moveEnd', this.moveEnd.bind(this));
    }
    moveStart(event) {
        this.start(event);
        this.computeValues($f141e7d376023231$var$pointerValues(event));
        this.compute(event);
        this.computeInitial();
        this.emit();
    }
    moveChange(event) {
        if (!this.state._active) return;
        const values = $f141e7d376023231$var$pointerValues(event);
        const state = this.state;
        state._delta = (0, $76c9c102e95074d9$export$e7c866399fa523f5).sub(values, state._values);
        (0, $76c9c102e95074d9$export$e7c866399fa523f5).addTo(state._movement, state._delta);
        this.computeValues(values);
        this.compute(event);
        this.emit();
    }
    moveEnd(event) {
        if (!this.state._active) return;
        this.state._active = false;
        this.compute(event);
        this.emit();
    }
    bind(bindFunction) {
        bindFunction('pointer', 'change', this.move.bind(this));
        bindFunction('pointer', 'leave', this.moveEnd.bind(this));
    }
}
const $f141e7d376023231$var$moveConfigResolver = $f141e7d376023231$export$71511d61b312f219($f141e7d376023231$export$71511d61b312f219({}, $f141e7d376023231$var$coordinatesConfigResolver), {}, {
    mouseOnly: (value = true)=>value
});
class $f141e7d376023231$var$ScrollEngine extends $f141e7d376023231$var$CoordinatesEngine {
    constructor(...args){
        super(...args);
        $f141e7d376023231$export$407448d2b89b1813(this, "ingKey", 'scrolling');
    }
    scroll(event) {
        if (!this.state._active) this.start(event);
        this.scrollChange(event);
        this.timeoutStore.add('scrollEnd', this.scrollEnd.bind(this));
    }
    scrollChange(event) {
        if (event.cancelable) event.preventDefault();
        const state = this.state;
        const values = $f141e7d376023231$var$scrollValues(event);
        state._delta = (0, $76c9c102e95074d9$export$e7c866399fa523f5).sub(values, state._values);
        (0, $76c9c102e95074d9$export$e7c866399fa523f5).addTo(state._movement, state._delta);
        this.computeValues(values);
        this.compute(event);
        this.emit();
    }
    scrollEnd() {
        if (!this.state._active) return;
        this.state._active = false;
        this.compute();
        this.emit();
    }
    bind(bindFunction) {
        bindFunction('scroll', '', this.scroll.bind(this));
    }
}
const $f141e7d376023231$var$scrollConfigResolver = $f141e7d376023231$var$coordinatesConfigResolver;
class $f141e7d376023231$var$WheelEngine extends $f141e7d376023231$var$CoordinatesEngine {
    constructor(...args){
        super(...args);
        $f141e7d376023231$export$407448d2b89b1813(this, "ingKey", 'wheeling');
    }
    wheel(event) {
        if (!this.state._active) this.start(event);
        this.wheelChange(event);
        this.timeoutStore.add('wheelEnd', this.wheelEnd.bind(this));
    }
    wheelChange(event) {
        const state = this.state;
        state._delta = $f141e7d376023231$var$wheelValues(event);
        (0, $76c9c102e95074d9$export$e7c866399fa523f5).addTo(state._movement, state._delta);
        $f141e7d376023231$var$clampStateInternalMovementToBounds(state);
        this.compute(event);
        this.emit();
    }
    wheelEnd() {
        if (!this.state._active) return;
        this.state._active = false;
        this.compute();
        this.emit();
    }
    bind(bindFunction) {
        bindFunction('wheel', '', this.wheel.bind(this));
    }
}
const $f141e7d376023231$var$wheelConfigResolver = $f141e7d376023231$var$coordinatesConfigResolver;
class $f141e7d376023231$var$HoverEngine extends $f141e7d376023231$var$CoordinatesEngine {
    constructor(...args){
        super(...args);
        $f141e7d376023231$export$407448d2b89b1813(this, "ingKey", 'hovering');
    }
    enter(event) {
        if (this.config.mouseOnly && event.pointerType !== 'mouse') return;
        this.start(event);
        this.computeValues($f141e7d376023231$var$pointerValues(event));
        this.compute(event);
        this.emit();
    }
    leave(event) {
        if (this.config.mouseOnly && event.pointerType !== 'mouse') return;
        const state = this.state;
        if (!state._active) return;
        state._active = false;
        const values = $f141e7d376023231$var$pointerValues(event);
        state._movement = state._delta = (0, $76c9c102e95074d9$export$e7c866399fa523f5).sub(values, state._values);
        this.computeValues(values);
        this.compute(event);
        state.delta = state.movement;
        this.emit();
    }
    bind(bindFunction) {
        bindFunction('pointer', 'enter', this.enter.bind(this));
        bindFunction('pointer', 'leave', this.leave.bind(this));
    }
}
const $f141e7d376023231$var$hoverConfigResolver = $f141e7d376023231$export$71511d61b312f219($f141e7d376023231$export$71511d61b312f219({}, $f141e7d376023231$var$coordinatesConfigResolver), {}, {
    mouseOnly: (value = true)=>value
});
const $f141e7d376023231$export$a9c23c6ac3fc3eca = new Map();
const $f141e7d376023231$export$e7094788287c5e9b = new Map();
function $f141e7d376023231$export$43caf9889c228507(action) {
    $f141e7d376023231$export$a9c23c6ac3fc3eca.set(action.key, action.engine);
    $f141e7d376023231$export$e7094788287c5e9b.set(action.key, action.resolver);
}
const $f141e7d376023231$export$f1e1789686576879 = {
    key: 'drag',
    engine: $f141e7d376023231$var$DragEngine,
    resolver: $f141e7d376023231$var$dragConfigResolver
};
const $f141e7d376023231$export$dda1d9f60106f0e9 = {
    key: 'hover',
    engine: $f141e7d376023231$var$HoverEngine,
    resolver: $f141e7d376023231$var$hoverConfigResolver
};
const $f141e7d376023231$export$953cecd6e717a553 = {
    key: 'move',
    engine: $f141e7d376023231$var$MoveEngine,
    resolver: $f141e7d376023231$var$moveConfigResolver
};
const $f141e7d376023231$export$2d1720544b23b823 = {
    key: 'pinch',
    engine: $f141e7d376023231$var$PinchEngine,
    resolver: $f141e7d376023231$var$pinchConfigResolver
};
const $f141e7d376023231$export$2408f22a0fab9ae5 = {
    key: 'scroll',
    engine: $f141e7d376023231$var$ScrollEngine,
    resolver: $f141e7d376023231$var$scrollConfigResolver
};
const $f141e7d376023231$export$efccba1c4a2ef57b = {
    key: 'wheel',
    engine: $f141e7d376023231$var$WheelEngine,
    resolver: $f141e7d376023231$var$wheelConfigResolver
};






var $5E6i4 = parcelRequire("5E6i4");


function $0f2137e99ba23540$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $0f2137e99ba23540$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $0f2137e99ba23540$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
const $0f2137e99ba23540$var$sharedConfigResolver = {
    target (value) {
        if (value) return ()=>'current' in value ? value.current : value;
        return undefined;
    },
    enabled (value = true) {
        return value;
    },
    window (value = (0, $f141e7d376023231$export$25ce5a424b770e84).isBrowser ? window : undefined) {
        return value;
    },
    eventOptions ({ passive: passive = true, capture: capture = false } = {}) {
        return {
            passive: passive,
            capture: capture
        };
    },
    transform (value) {
        return value;
    }
};
const $0f2137e99ba23540$var$_excluded = [
    "target",
    "eventOptions",
    "window",
    "enabled",
    "transform"
];
function $0f2137e99ba23540$var$resolveWith(config = {}, resolvers) {
    const result = {};
    for (const [key, resolver] of Object.entries(resolvers))switch(typeof resolver){
        case 'function':
            result[key] = resolver.call(result, config[key], key, config);
            break;
        case 'object':
            result[key] = $0f2137e99ba23540$var$resolveWith(config[key], resolver);
            break;
        case 'boolean':
            if (resolver) result[key] = config[key];
            break;
    }
    return result;
}
function $0f2137e99ba23540$var$parse(newConfig, gestureKey, _config = {}) {
    const _ref = newConfig, { target: target, eventOptions: eventOptions, window: window1, enabled: enabled, transform: transform } = _ref, rest = $0f2137e99ba23540$var$_objectWithoutProperties(_ref, $0f2137e99ba23540$var$_excluded);
    _config.shared = $0f2137e99ba23540$var$resolveWith({
        target: target,
        eventOptions: eventOptions,
        window: window1,
        enabled: enabled,
        transform: transform
    }, $0f2137e99ba23540$var$sharedConfigResolver);
    if (gestureKey) {
        const resolver = (0, $f141e7d376023231$export$e7094788287c5e9b).get(gestureKey);
        _config[gestureKey] = $0f2137e99ba23540$var$resolveWith((0, $f141e7d376023231$export$71511d61b312f219)({
            shared: _config.shared
        }, rest), resolver);
    } else for(const key in rest){
        const resolver = (0, $f141e7d376023231$export$e7094788287c5e9b).get(key);
        if (resolver) _config[key] = $0f2137e99ba23540$var$resolveWith((0, $f141e7d376023231$export$71511d61b312f219)({
            shared: _config.shared
        }, rest[key]), resolver);
    }
    return _config;
}
class $0f2137e99ba23540$var$EventStore {
    constructor(ctrl, gestureKey){
        (0, $f141e7d376023231$export$407448d2b89b1813)(this, "_listeners", new Set());
        this._ctrl = ctrl;
        this._gestureKey = gestureKey;
    }
    add(element, device, action, handler, options) {
        const listeners = this._listeners;
        const type = (0, $f141e7d376023231$export$625550452a3fa3ec)(device, action);
        const _options = this._gestureKey ? this._ctrl.config[this._gestureKey].eventOptions : {};
        const eventOptions = (0, $f141e7d376023231$export$71511d61b312f219)((0, $f141e7d376023231$export$71511d61b312f219)({}, _options), options);
        element.addEventListener(type, handler, eventOptions);
        const remove = ()=>{
            element.removeEventListener(type, handler, eventOptions);
            listeners.delete(remove);
        };
        listeners.add(remove);
        return remove;
    }
    clean() {
        this._listeners.forEach((remove)=>remove());
        this._listeners.clear();
    }
}
class $0f2137e99ba23540$var$TimeoutStore {
    constructor(){
        (0, $f141e7d376023231$export$407448d2b89b1813)(this, "_timeouts", new Map());
    }
    add(key, callback, ms = 140, ...args) {
        this.remove(key);
        this._timeouts.set(key, window.setTimeout(callback, ms, ...args));
    }
    remove(key) {
        const timeout = this._timeouts.get(key);
        if (timeout) window.clearTimeout(timeout);
    }
    clean() {
        this._timeouts.forEach((timeout)=>void window.clearTimeout(timeout));
        this._timeouts.clear();
    }
}
class $0f2137e99ba23540$export$bd0bf19f25da8474 {
    constructor(handlers){
        (0, $f141e7d376023231$export$407448d2b89b1813)(this, "gestures", new Set());
        (0, $f141e7d376023231$export$407448d2b89b1813)(this, "_targetEventStore", new $0f2137e99ba23540$var$EventStore(this));
        (0, $f141e7d376023231$export$407448d2b89b1813)(this, "gestureEventStores", {});
        (0, $f141e7d376023231$export$407448d2b89b1813)(this, "gestureTimeoutStores", {});
        (0, $f141e7d376023231$export$407448d2b89b1813)(this, "handlers", {});
        (0, $f141e7d376023231$export$407448d2b89b1813)(this, "config", {});
        (0, $f141e7d376023231$export$407448d2b89b1813)(this, "pointerIds", new Set());
        (0, $f141e7d376023231$export$407448d2b89b1813)(this, "touchIds", new Set());
        (0, $f141e7d376023231$export$407448d2b89b1813)(this, "state", {
            shared: {
                shiftKey: false,
                metaKey: false,
                ctrlKey: false,
                altKey: false
            }
        });
        $0f2137e99ba23540$var$resolveGestures(this, handlers);
    }
    setEventIds(event) {
        if ((0, $f141e7d376023231$export$23f2a1d2818174ef)(event)) {
            this.touchIds = new Set((0, $f141e7d376023231$export$8b22cf2602fb60ce)(event));
            return this.touchIds;
        } else if ('pointerId' in event) {
            if (event.type === 'pointerup' || event.type === 'pointercancel') this.pointerIds.delete(event.pointerId);
            else if (event.type === 'pointerdown') this.pointerIds.add(event.pointerId);
            return this.pointerIds;
        }
    }
    applyHandlers(handlers, nativeHandlers) {
        this.handlers = handlers;
        this.nativeHandlers = nativeHandlers;
    }
    applyConfig(config, gestureKey) {
        this.config = $0f2137e99ba23540$var$parse(config, gestureKey, this.config);
    }
    clean() {
        this._targetEventStore.clean();
        for (const key of this.gestures){
            this.gestureEventStores[key].clean();
            this.gestureTimeoutStores[key].clean();
        }
    }
    effect() {
        if (this.config.shared.target) this.bind();
        return ()=>this._targetEventStore.clean();
    }
    bind(...args) {
        const sharedConfig = this.config.shared;
        const props = {};
        let target;
        if (sharedConfig.target) {
            target = sharedConfig.target();
            if (!target) return;
        }
        if (sharedConfig.enabled) {
            for (const gestureKey of this.gestures){
                const gestureConfig = this.config[gestureKey];
                const bindFunction = $0f2137e99ba23540$var$bindToProps(props, gestureConfig.eventOptions, !!target);
                if (gestureConfig.enabled) {
                    const Engine = (0, $f141e7d376023231$export$a9c23c6ac3fc3eca).get(gestureKey);
                    new Engine(this, args, gestureKey).bind(bindFunction);
                }
            }
            const nativeBindFunction = $0f2137e99ba23540$var$bindToProps(props, sharedConfig.eventOptions, !!target);
            for(const eventKey in this.nativeHandlers)nativeBindFunction(eventKey, '', (event)=>this.nativeHandlers[eventKey]((0, $f141e7d376023231$export$71511d61b312f219)((0, $f141e7d376023231$export$71511d61b312f219)({}, this.state.shared), {}, {
                    event: event,
                    args: args
                })), undefined, true);
        }
        for(const handlerProp in props)props[handlerProp] = (0, $f141e7d376023231$export$db3b6bfb95261072)(...props[handlerProp]);
        if (!target) return props;
        for(const handlerProp in props){
            const { device: device, capture: capture, passive: passive } = (0, $f141e7d376023231$export$ffb5f4729a158638)(handlerProp);
            this._targetEventStore.add(target, device, '', props[handlerProp], {
                capture: capture,
                passive: passive
            });
        }
    }
}
function $0f2137e99ba23540$var$setupGesture(ctrl, gestureKey) {
    ctrl.gestures.add(gestureKey);
    ctrl.gestureEventStores[gestureKey] = new $0f2137e99ba23540$var$EventStore(ctrl, gestureKey);
    ctrl.gestureTimeoutStores[gestureKey] = new $0f2137e99ba23540$var$TimeoutStore();
}
function $0f2137e99ba23540$var$resolveGestures(ctrl, internalHandlers) {
    if (internalHandlers.drag) $0f2137e99ba23540$var$setupGesture(ctrl, 'drag');
    if (internalHandlers.wheel) $0f2137e99ba23540$var$setupGesture(ctrl, 'wheel');
    if (internalHandlers.scroll) $0f2137e99ba23540$var$setupGesture(ctrl, 'scroll');
    if (internalHandlers.move) $0f2137e99ba23540$var$setupGesture(ctrl, 'move');
    if (internalHandlers.pinch) $0f2137e99ba23540$var$setupGesture(ctrl, 'pinch');
    if (internalHandlers.hover) $0f2137e99ba23540$var$setupGesture(ctrl, 'hover');
}
const $0f2137e99ba23540$var$bindToProps = (props, eventOptions, withPassiveOption)=>(device, action, handler, options = {}, isNative = false)=>{
        var _options$capture, _options$passive;
        const capture = (_options$capture = options.capture) !== null && _options$capture !== void 0 ? _options$capture : eventOptions.capture;
        const passive = (_options$passive = options.passive) !== null && _options$passive !== void 0 ? _options$passive : eventOptions.passive;
        let handlerProp = isNative ? device : (0, $f141e7d376023231$export$4368d992c4eafac0)(device, action, capture);
        if (withPassiveOption && passive) handlerProp += 'Passive';
        props[handlerProp] = props[handlerProp] || [];
        props[handlerProp].push(handler);
    };
const $0f2137e99ba23540$var$RE_NOT_NATIVE = /^on(Drag|Wheel|Scroll|Move|Pinch|Hover)/;
function $0f2137e99ba23540$var$sortHandlers(_handlers) {
    const native = {};
    const handlers = {};
    const actions = new Set();
    for(let key in _handlers)if ($0f2137e99ba23540$var$RE_NOT_NATIVE.test(key)) {
        actions.add(RegExp.lastMatch);
        handlers[key] = _handlers[key];
    } else native[key] = _handlers[key];
    return [
        handlers,
        native,
        actions
    ];
}
function $0f2137e99ba23540$var$registerGesture(actions, handlers, handlerKey, key, internalHandlers, config) {
    if (!actions.has(handlerKey)) return;
    if (!(0, $f141e7d376023231$export$a9c23c6ac3fc3eca).has(key)) return;
    const startKey = handlerKey + 'Start';
    const endKey = handlerKey + 'End';
    const fn = (state)=>{
        let memo = undefined;
        if (state.first && startKey in handlers) handlers[startKey](state);
        if (handlerKey in handlers) memo = handlers[handlerKey](state);
        if (state.last && endKey in handlers) handlers[endKey](state);
        return memo;
    };
    internalHandlers[key] = fn;
    config[key] = config[key] || {};
}
function $0f2137e99ba23540$export$c14d3c7045c4485d(mergedHandlers, mergedConfig) {
    const [handlers, nativeHandlers, actions] = $0f2137e99ba23540$var$sortHandlers(mergedHandlers);
    const internalHandlers = {};
    $0f2137e99ba23540$var$registerGesture(actions, handlers, 'onDrag', 'drag', internalHandlers, mergedConfig);
    $0f2137e99ba23540$var$registerGesture(actions, handlers, 'onWheel', 'wheel', internalHandlers, mergedConfig);
    $0f2137e99ba23540$var$registerGesture(actions, handlers, 'onScroll', 'scroll', internalHandlers, mergedConfig);
    $0f2137e99ba23540$var$registerGesture(actions, handlers, 'onPinch', 'pinch', internalHandlers, mergedConfig);
    $0f2137e99ba23540$var$registerGesture(actions, handlers, 'onMove', 'move', internalHandlers, mergedConfig);
    $0f2137e99ba23540$var$registerGesture(actions, handlers, 'onHover', 'hover', internalHandlers, mergedConfig);
    return {
        handlers: internalHandlers,
        config: mergedConfig,
        nativeHandlers: nativeHandlers
    };
}







function $595225a5ad43e488$var$useRecognizers(handlers, config = {}, gestureKey, nativeHandlers) {
    const ctrl = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useMemo(()=>new (0, $0f2137e99ba23540$export$bd0bf19f25da8474)(handlers), []);
    ctrl.applyHandlers(handlers, nativeHandlers);
    ctrl.applyConfig(config, gestureKey);
    (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useEffect(ctrl.effect.bind(ctrl));
    (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useEffect(()=>{
        return ctrl.clean.bind(ctrl);
    }, []);
    if (config.target === undefined) return ctrl.bind.bind(ctrl);
    return undefined;
}
function $595225a5ad43e488$export$7941f8aafa4b6021(handler, config) {
    (0, $f141e7d376023231$export$43caf9889c228507)((0, $f141e7d376023231$export$f1e1789686576879));
    return $595225a5ad43e488$var$useRecognizers({
        drag: handler
    }, config || {}, 'drag');
}
function $595225a5ad43e488$export$ccc26886ea7dba8f(handler, config) {
    (0, $f141e7d376023231$export$43caf9889c228507)((0, $f141e7d376023231$export$2d1720544b23b823));
    return $595225a5ad43e488$var$useRecognizers({
        pinch: handler
    }, config || {}, 'pinch');
}
function $595225a5ad43e488$export$43260e1b277d5f62(handler, config) {
    (0, $f141e7d376023231$export$43caf9889c228507)((0, $f141e7d376023231$export$efccba1c4a2ef57b));
    return $595225a5ad43e488$var$useRecognizers({
        wheel: handler
    }, config || {}, 'wheel');
}
function $595225a5ad43e488$export$d928051c8cd740b(handler, config) {
    (0, $f141e7d376023231$export$43caf9889c228507)((0, $f141e7d376023231$export$2408f22a0fab9ae5));
    return $595225a5ad43e488$var$useRecognizers({
        scroll: handler
    }, config || {}, 'scroll');
}
function $595225a5ad43e488$export$36da96379f79f245(handler, config) {
    (0, $f141e7d376023231$export$43caf9889c228507)((0, $f141e7d376023231$export$953cecd6e717a553));
    return $595225a5ad43e488$var$useRecognizers({
        move: handler
    }, config || {}, 'move');
}
function $595225a5ad43e488$export$ae780daf29e6d456(handler, config) {
    (0, $f141e7d376023231$export$43caf9889c228507)((0, $f141e7d376023231$export$dda1d9f60106f0e9));
    return $595225a5ad43e488$var$useRecognizers({
        hover: handler
    }, config || {}, 'hover');
}
function $595225a5ad43e488$export$ee99e1f7df2b9180(actions) {
    actions.forEach((0, $f141e7d376023231$export$43caf9889c228507));
    return function useGesture(_handlers, _config) {
        const { handlers: handlers, nativeHandlers: nativeHandlers, config: config } = (0, $0f2137e99ba23540$export$c14d3c7045c4485d)(_handlers, _config || {});
        return $595225a5ad43e488$var$useRecognizers(handlers, config, undefined, nativeHandlers);
    };
}
function $595225a5ad43e488$export$ece84446a783717(handlers, config) {
    const hook = $595225a5ad43e488$export$ee99e1f7df2b9180([
        (0, $f141e7d376023231$export$f1e1789686576879),
        (0, $f141e7d376023231$export$2d1720544b23b823),
        (0, $f141e7d376023231$export$2408f22a0fab9ae5),
        (0, $f141e7d376023231$export$efccba1c4a2ef57b),
        (0, $f141e7d376023231$export$953cecd6e717a553),
        (0, $f141e7d376023231$export$dda1d9f60106f0e9)
    ]);
    return hook(handlers, config || {});
}


function $496b89894a66b1b9$export$d0f771a6fa439234() {
    return {
        scaleX: 1,
        scaleY: 1,
        translateX: 0,
        translateY: 0,
        skewX: 0,
        skewY: 0
    };
}
function $496b89894a66b1b9$export$f3cf8b510f9cb8ab(_ref) {
    let { scaleX: scaleX = 1, scaleY: scaleY = 1, translateX: translateX = 0, translateY: translateY = 0, skewX: skewX = 0, skewY: skewY = 0 } = _ref;
    return {
        scaleX: scaleX,
        scaleY: scaleY,
        translateX: translateX,
        translateY: translateY,
        skewX: skewX,
        skewY: skewY
    };
}
function $496b89894a66b1b9$export$35eeeb583b889fff(_ref2) {
    let { scaleX: scaleX, scaleY: scaleY, translateX: translateX, translateY: translateY, skewX: skewX, skewY: skewY } = _ref2;
    const denominator = scaleX * scaleY - skewY * skewX;
    return {
        scaleX: scaleY / denominator,
        scaleY: scaleX / denominator,
        translateX: (scaleY * translateX - skewX * translateY) / -denominator,
        translateY: (skewY * translateX - scaleX * translateY) / denominator,
        skewX: skewX / -denominator,
        skewY: skewY / -denominator
    };
}
function $496b89894a66b1b9$export$8c48718e98c0b9bf(matrix, _ref3) {
    let { x: x, y: y } = _ref3;
    return {
        x: matrix.scaleX * x + matrix.skewX * y + matrix.translateX,
        y: matrix.skewY * x + matrix.scaleY * y + matrix.translateY
    };
}
function $496b89894a66b1b9$export$5438c8d9dfead235(matrix, _ref4) {
    let { x: x, y: y } = _ref4;
    return $496b89894a66b1b9$export$8c48718e98c0b9bf($496b89894a66b1b9$export$35eeeb583b889fff(matrix), {
        x: x,
        y: y
    });
}
function $496b89894a66b1b9$export$f89d8f511263c5b(scaleX) {
    let maybeScaleY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    const scaleY = maybeScaleY || scaleX;
    return $496b89894a66b1b9$export$f3cf8b510f9cb8ab({
        scaleX: scaleX,
        scaleY: scaleY
    });
}
function $496b89894a66b1b9$export$71eed220948761bd(translateX, translateY) {
    return $496b89894a66b1b9$export$f3cf8b510f9cb8ab({
        translateX: translateX,
        translateY: translateY
    });
}
function $496b89894a66b1b9$export$84b43e5e8429f175(matrix1, matrix2) {
    return {
        scaleX: matrix1.scaleX * matrix2.scaleX + matrix1.skewX * matrix2.skewY,
        scaleY: matrix1.skewY * matrix2.skewX + matrix1.scaleY * matrix2.scaleY,
        translateX: matrix1.scaleX * matrix2.translateX + matrix1.skewX * matrix2.translateY + matrix1.translateX,
        translateY: matrix1.skewY * matrix2.translateX + matrix1.scaleY * matrix2.translateY + matrix1.translateY,
        skewX: matrix1.scaleX * matrix2.skewX + matrix1.skewX * matrix2.scaleY,
        skewY: matrix1.skewY * matrix2.scaleX + matrix1.scaleY * matrix2.skewY
    };
}
function $496b89894a66b1b9$export$f0f0662b65b114c9() {
    for(var _len = arguments.length, matrices = new Array(_len), _key = 0; _key < _len; _key++)matrices[_key] = arguments[_key];
    switch(matrices.length){
        case 0:
            throw new Error('composeMatrices() requires arguments: was called with no args');
        case 1:
            return matrices[0];
        case 2:
            return $496b89894a66b1b9$export$84b43e5e8429f175(matrices[0], matrices[1]);
        default:
            {
                const [matrix1, matrix2, ...restMatrices] = matrices;
                const matrix = $496b89894a66b1b9$export$84b43e5e8429f175(matrix1, matrix2);
                return $496b89894a66b1b9$export$f0f0662b65b114c9(matrix, ...restMatrices);
            }
    }
}



// default prop values
const $b830c8b4420d3ab0$var$defaultInitialTransformMatrix = {
    scaleX: 1,
    scaleY: 1,
    translateX: 0,
    translateY: 0,
    skewX: 0,
    skewY: 0
};
const $b830c8b4420d3ab0$var$defaultWheelDelta = (event)=>-event.deltaY > 0 ? {
        scaleX: 1.1,
        scaleY: 1.1
    } : {
        scaleX: 0.9,
        scaleY: 0.9
    };
const $b830c8b4420d3ab0$var$defaultPinchDelta = (_ref)=>{
    let { offset: [s], lastOffset: [lastS] } = _ref;
    return {
        scaleX: s - lastS < 0 ? 0.9 : 1.1,
        scaleY: s - lastS < 0 ? 0.9 : 1.1
    };
};
function $b830c8b4420d3ab0$var$Zoom(_ref2) {
    let { scaleXMin: scaleXMin = 0, scaleXMax: scaleXMax = Infinity, scaleYMin: scaleYMin = 0, scaleYMax: scaleYMax = Infinity, initialTransformMatrix: initialTransformMatrix = $b830c8b4420d3ab0$var$defaultInitialTransformMatrix, wheelDelta: wheelDelta = $b830c8b4420d3ab0$var$defaultWheelDelta, pinchDelta: pinchDelta = $b830c8b4420d3ab0$var$defaultPinchDelta, width: width, height: height, constrain: constrain, children: children } = _ref2;
    const containerRef = (0, $5E6i4.useRef)(null);
    const matrixStateRef = (0, $5E6i4.useRef)(initialTransformMatrix);
    const [transformMatrix, setTransformMatrixState] = (0, $5E6i4.useState)(initialTransformMatrix);
    const [isDragging, setIsDragging] = (0, $5E6i4.useState)(false);
    const [startTranslate, setStartTranslate] = (0, $5E6i4.useState)(undefined);
    const [startPoint, setStartPoint] = (0, $5E6i4.useState)(undefined);
    const defaultConstrain = (0, $5E6i4.useCallback)((newTransformMatrix, prevTransformMatrix)=>{
        if (constrain) return constrain(newTransformMatrix, prevTransformMatrix);
        const { scaleX: scaleX, scaleY: scaleY } = newTransformMatrix;
        const shouldConstrainScaleX = scaleX > scaleXMax || scaleX < scaleXMin;
        const shouldConstrainScaleY = scaleY > scaleYMax || scaleY < scaleYMin;
        if (shouldConstrainScaleX || shouldConstrainScaleY) return prevTransformMatrix;
        return newTransformMatrix;
    }, [
        constrain,
        scaleXMin,
        scaleXMax,
        scaleYMin,
        scaleYMax
    ]);
    const setTransformMatrix = (0, $5E6i4.useCallback)((newTransformMatrix)=>{
        setTransformMatrixState((prevTransformMatrix)=>{
            const updatedTransformMatrix = defaultConstrain(newTransformMatrix, prevTransformMatrix);
            matrixStateRef.current = updatedTransformMatrix;
            return updatedTransformMatrix;
        });
    }, [
        defaultConstrain
    ]);
    const applyToPoint = (0, $5E6i4.useCallback)((_ref3)=>{
        let { x: x, y: y } = _ref3;
        return (0, $496b89894a66b1b9$export$8c48718e98c0b9bf)(transformMatrix, {
            x: x,
            y: y
        });
    }, [
        transformMatrix
    ]);
    const applyInverseToPoint = (0, $5E6i4.useCallback)((_ref4)=>{
        let { x: x, y: y } = _ref4;
        return (0, $496b89894a66b1b9$export$5438c8d9dfead235)(transformMatrix, {
            x: x,
            y: y
        });
    }, [
        transformMatrix
    ]);
    const reset = (0, $5E6i4.useCallback)(()=>{
        setTransformMatrix(initialTransformMatrix);
    }, [
        initialTransformMatrix,
        setTransformMatrix
    ]);
    const scale = (0, $5E6i4.useCallback)((_ref5)=>{
        let { scaleX: scaleX, scaleY: maybeScaleY, point: point } = _ref5;
        const scaleY = maybeScaleY || scaleX;
        const cleanPoint = point || {
            x: width / 2,
            y: height / 2
        };
        // need to use ref value instead of state here because wheel listener does not have access to latest state
        const translate = (0, $496b89894a66b1b9$export$5438c8d9dfead235)(matrixStateRef.current, cleanPoint);
        const nextMatrix = (0, $496b89894a66b1b9$export$f0f0662b65b114c9)(matrixStateRef.current, (0, $496b89894a66b1b9$export$71eed220948761bd)(translate.x, translate.y), (0, $496b89894a66b1b9$export$f89d8f511263c5b)(scaleX, scaleY), (0, $496b89894a66b1b9$export$71eed220948761bd)(-translate.x, -translate.y));
        setTransformMatrix(nextMatrix);
        if (isDragging) {
            const { translateX: translateX, translateY: translateY } = matrixStateRef.current;
            setStartPoint(point);
            setStartTranslate({
                translateX: translateX,
                translateY: translateY
            });
        }
    }, [
        height,
        width,
        isDragging,
        setTransformMatrix
    ]);
    const translate = (0, $5E6i4.useCallback)((_ref6)=>{
        let { translateX: translateX, translateY: translateY } = _ref6;
        const nextMatrix = (0, $496b89894a66b1b9$export$f0f0662b65b114c9)(transformMatrix, (0, $496b89894a66b1b9$export$71eed220948761bd)(translateX, translateY));
        setTransformMatrix(nextMatrix);
    }, [
        setTransformMatrix,
        transformMatrix
    ]);
    const setTranslate = (0, $5E6i4.useCallback)((_ref7)=>{
        let { translateX: translateX, translateY: translateY } = _ref7;
        const nextMatrix = {
            ...transformMatrix,
            translateX: translateX,
            translateY: translateY
        };
        setTransformMatrix(nextMatrix);
    }, [
        setTransformMatrix,
        transformMatrix
    ]);
    const translateTo = (0, $5E6i4.useCallback)((_ref8)=>{
        let { x: x, y: y } = _ref8;
        const point = (0, $496b89894a66b1b9$export$5438c8d9dfead235)(transformMatrix, {
            x: x,
            y: y
        });
        setTranslate({
            translateX: point.x,
            translateY: point.y
        });
    }, [
        setTranslate,
        transformMatrix
    ]);
    const invert = (0, $5E6i4.useCallback)(()=>(0, $496b89894a66b1b9$export$35eeeb583b889fff)(transformMatrix), [
        transformMatrix
    ]);
    const toStringInvert = (0, $5E6i4.useCallback)(()=>{
        const { translateX: translateX, translateY: translateY, scaleX: scaleX, scaleY: scaleY, skewX: skewX, skewY: skewY } = invert();
        return `matrix(${scaleX}, ${skewY}, ${skewX}, ${scaleY}, ${translateX}, ${translateY})`;
    }, [
        invert
    ]);
    const dragStart = (0, $5E6i4.useCallback)((event)=>{
        const { translateX: translateX, translateY: translateY } = transformMatrix;
        setStartPoint((0, $45e9151834fcba9b$export$2e2bcd8739ae039)(event) || undefined);
        setStartTranslate({
            translateX: translateX,
            translateY: translateY
        });
        setIsDragging(true);
    }, [
        transformMatrix
    ]);
    const dragMove = (0, $5E6i4.useCallback)((event, options)=>{
        if (!isDragging || !startPoint || !startTranslate) return;
        const currentPoint = (0, $45e9151834fcba9b$export$2e2bcd8739ae039)(event);
        const dx = currentPoint ? -(startPoint.x - currentPoint.x) : -startPoint.x;
        const dy = currentPoint ? -(startPoint.y - currentPoint.y) : -startPoint.y;
        let translateX = startTranslate.translateX + dx;
        if (options?.offsetX) translateX += options?.offsetX ?? 0;
        let translateY = startTranslate.translateY + dy;
        if (options?.offsetY) translateY += options?.offsetY ?? 0;
        setTranslate({
            translateX: translateX,
            translateY: translateY
        });
    }, [
        isDragging,
        setTranslate,
        startPoint,
        startTranslate
    ]);
    const dragEnd = (0, $5E6i4.useCallback)(()=>{
        setStartPoint(undefined);
        setStartTranslate(undefined);
        setIsDragging(false);
    }, []);
    const handleWheel = (0, $5E6i4.useCallback)((event)=>{
        event.preventDefault();
        const point = (0, $45e9151834fcba9b$export$2e2bcd8739ae039)(event) || undefined;
        const { scaleX: scaleX, scaleY: scaleY } = wheelDelta(event);
        scale({
            scaleX: scaleX,
            scaleY: scaleY,
            point: point
        });
    }, [
        scale,
        wheelDelta
    ]);
    const handlePinch = (0, $5E6i4.useCallback)((state)=>{
        const { origin: [ox, oy], memo: memo } = state;
        let currentMemo = memo;
        if (containerRef.current) {
            const { top: top, left: left } = currentMemo ?? containerRef.current.getBoundingClientRect();
            if (!currentMemo) currentMemo = {
                top: top,
                left: left
            };
            const { scaleX: scaleX, scaleY: scaleY } = pinchDelta(state);
            scale({
                scaleX: scaleX,
                scaleY: scaleY,
                point: {
                    x: ox - left,
                    y: oy - top
                }
            });
        }
        return currentMemo;
    }, [
        scale,
        pinchDelta
    ]);
    const toString = (0, $5E6i4.useCallback)(()=>{
        const { translateX: translateX, translateY: translateY, scaleX: scaleX, scaleY: scaleY, skewX: skewX, skewY: skewY } = transformMatrix;
        return `matrix(${scaleX}, ${skewY}, ${skewX}, ${scaleY}, ${translateX}, ${translateY})`;
    }, [
        transformMatrix
    ]);
    const center = (0, $5E6i4.useCallback)(()=>{
        const centerPoint = {
            x: width / 2,
            y: height / 2
        };
        const inverseCentroid = applyInverseToPoint(centerPoint);
        translate({
            translateX: inverseCentroid.x - centerPoint.x,
            translateY: inverseCentroid.y - centerPoint.y
        });
    }, [
        height,
        width,
        applyInverseToPoint,
        translate
    ]);
    const clear = (0, $5E6i4.useCallback)(()=>{
        setTransformMatrix((0, $496b89894a66b1b9$export$d0f771a6fa439234)());
    }, [
        setTransformMatrix
    ]);
    (0, $595225a5ad43e488$export$ece84446a783717)({
        onDragStart: (_ref9)=>{
            let { event: event } = _ref9;
            if (!(event instanceof KeyboardEvent)) dragStart(event);
        },
        onDrag: (_ref0)=>{
            let { event: event, pinching: pinching, cancel: cancel } = _ref0;
            if (pinching) {
                cancel();
                dragEnd();
            } else if (!(event instanceof KeyboardEvent)) dragMove(event);
        },
        onDragEnd: dragEnd,
        onPinch: handlePinch,
        onWheel: (_ref1)=>{
            let { event: event, active: active, pinching: pinching } = _ref1;
            if (// Outside of Safari, the wheel event is fired together with the pinch event
            pinching || // currently onWheelEnd emits one final wheel event which causes 2x scale
            // updates for the last tick. ensuring that the gesture is active avoids this
            !active) return;
            handleWheel(event);
        }
    }, {
        target: containerRef,
        eventOptions: {
            passive: false
        },
        drag: {
            filterTaps: true
        }
    });
    const zoom = {
        initialTransformMatrix: initialTransformMatrix,
        transformMatrix: transformMatrix,
        isDragging: isDragging,
        center: center,
        clear: clear,
        scale: scale,
        translate: translate,
        translateTo: translateTo,
        setTranslate: setTranslate,
        setTransformMatrix: setTransformMatrix,
        reset: reset,
        handleWheel: handleWheel,
        handlePinch: handlePinch,
        dragEnd: dragEnd,
        dragMove: dragMove,
        dragStart: dragStart,
        toString: toString,
        invert: invert,
        toStringInvert: toStringInvert,
        applyToPoint: applyToPoint,
        applyInverseToPoint: applyInverseToPoint,
        containerRef: containerRef
    };
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
        children: children(zoom)
    });
}
var $b830c8b4420d3ab0$export$2e2bcd8739ae039 = $b830c8b4420d3ab0$var$Zoom;









const $9b02f3abbd8e413a$export$871608497c498473 = (d)=>d instanceof Date;
const $9b02f3abbd8e413a$export$dd1bc94b04021eeb = (o)=>Object.keys(o).length === 0;
const $9b02f3abbd8e413a$export$a6cdc56e425d0d0a = (o)=>o != null && typeof o === 'object';
const $9b02f3abbd8e413a$export$5a15a386532a5ea4 = (o, ...args)=>Object.prototype.hasOwnProperty.call(o, ...args);
const $9b02f3abbd8e413a$export$83b788b1a3698c03 = (o)=>$9b02f3abbd8e413a$export$a6cdc56e425d0d0a(o) && $9b02f3abbd8e413a$export$dd1bc94b04021eeb(o);
const $9b02f3abbd8e413a$export$d6d64087a1bd2d = ()=>Object.create(null);


const $df3e3b214656b7ef$var$diff = (lhs, rhs)=>{
    if (lhs === rhs) return {}; // equal return no diff
    if (!(0, $9b02f3abbd8e413a$export$a6cdc56e425d0d0a)(lhs) || !(0, $9b02f3abbd8e413a$export$a6cdc56e425d0d0a)(rhs)) return rhs; // return updated rhs
    const deletedValues = Object.keys(lhs).reduce((acc, key)=>{
        if (!(0, $9b02f3abbd8e413a$export$5a15a386532a5ea4)(rhs, key)) acc[key] = undefined;
        return acc;
    }, (0, $9b02f3abbd8e413a$export$d6d64087a1bd2d)());
    if ((0, $9b02f3abbd8e413a$export$871608497c498473)(lhs) || (0, $9b02f3abbd8e413a$export$871608497c498473)(rhs)) {
        if (lhs.valueOf() == rhs.valueOf()) return {};
        return rhs;
    }
    return Object.keys(rhs).reduce((acc, key)=>{
        if (!(0, $9b02f3abbd8e413a$export$5a15a386532a5ea4)(lhs, key)) {
            acc[key] = rhs[key]; // return added r key
            return acc;
        }
        const difference = $df3e3b214656b7ef$var$diff(lhs[key], rhs[key]);
        // If the difference is empty, and the lhs is an empty object or the rhs is not an empty object
        if ((0, $9b02f3abbd8e413a$export$83b788b1a3698c03)(difference) && !(0, $9b02f3abbd8e413a$export$871608497c498473)(difference) && ((0, $9b02f3abbd8e413a$export$83b788b1a3698c03)(lhs[key]) || !(0, $9b02f3abbd8e413a$export$83b788b1a3698c03)(rhs[key]))) return acc; // return no diff
        acc[key] = difference // return updated key
        ;
        return acc; // return updated key
    }, deletedValues);
};
var $df3e3b214656b7ef$export$2e2bcd8739ae039 = $df3e3b214656b7ef$var$diff;



const $a8cdb5e6467580f8$var$addedDiff = (lhs, rhs)=>{
    if (lhs === rhs || !(0, $9b02f3abbd8e413a$export$a6cdc56e425d0d0a)(lhs) || !(0, $9b02f3abbd8e413a$export$a6cdc56e425d0d0a)(rhs)) return {};
    return Object.keys(rhs).reduce((acc, key)=>{
        if ((0, $9b02f3abbd8e413a$export$5a15a386532a5ea4)(lhs, key)) {
            const difference = $a8cdb5e6467580f8$var$addedDiff(lhs[key], rhs[key]);
            if ((0, $9b02f3abbd8e413a$export$a6cdc56e425d0d0a)(difference) && (0, $9b02f3abbd8e413a$export$dd1bc94b04021eeb)(difference)) return acc;
            acc[key] = difference;
            return acc;
        }
        acc[key] = rhs[key];
        return acc;
    }, (0, $9b02f3abbd8e413a$export$d6d64087a1bd2d)());
};
var $a8cdb5e6467580f8$export$2e2bcd8739ae039 = $a8cdb5e6467580f8$var$addedDiff;



const $cbe3342050544821$var$deletedDiff = (lhs, rhs)=>{
    if (lhs === rhs || !(0, $9b02f3abbd8e413a$export$a6cdc56e425d0d0a)(lhs) || !(0, $9b02f3abbd8e413a$export$a6cdc56e425d0d0a)(rhs)) return {};
    return Object.keys(lhs).reduce((acc, key)=>{
        if ((0, $9b02f3abbd8e413a$export$5a15a386532a5ea4)(rhs, key)) {
            const difference = $cbe3342050544821$var$deletedDiff(lhs[key], rhs[key]);
            if ((0, $9b02f3abbd8e413a$export$a6cdc56e425d0d0a)(difference) && (0, $9b02f3abbd8e413a$export$dd1bc94b04021eeb)(difference)) return acc;
            acc[key] = difference;
            return acc;
        }
        acc[key] = undefined;
        return acc;
    }, (0, $9b02f3abbd8e413a$export$d6d64087a1bd2d)());
};
var $cbe3342050544821$export$2e2bcd8739ae039 = $cbe3342050544821$var$deletedDiff;



const $0247689484ae1cd0$var$updatedDiff = (lhs, rhs)=>{
    if (lhs === rhs) return {};
    if (!(0, $9b02f3abbd8e413a$export$a6cdc56e425d0d0a)(lhs) || !(0, $9b02f3abbd8e413a$export$a6cdc56e425d0d0a)(rhs)) return rhs;
    if ((0, $9b02f3abbd8e413a$export$871608497c498473)(lhs) || (0, $9b02f3abbd8e413a$export$871608497c498473)(rhs)) {
        if (lhs.valueOf() == rhs.valueOf()) return {};
        return rhs;
    }
    return Object.keys(rhs).reduce((acc, key)=>{
        if ((0, $9b02f3abbd8e413a$export$5a15a386532a5ea4)(lhs, key)) {
            const difference = $0247689484ae1cd0$var$updatedDiff(lhs[key], rhs[key]);
            // If the difference is empty, and the lhs is an empty object or the rhs is not an empty object
            if ((0, $9b02f3abbd8e413a$export$83b788b1a3698c03)(difference) && !(0, $9b02f3abbd8e413a$export$871608497c498473)(difference) && ((0, $9b02f3abbd8e413a$export$83b788b1a3698c03)(lhs[key]) || !(0, $9b02f3abbd8e413a$export$83b788b1a3698c03)(rhs[key]))) return acc; // return no diff
            acc[key] = difference;
            return acc;
        }
        return acc;
    }, (0, $9b02f3abbd8e413a$export$d6d64087a1bd2d)());
};
var $0247689484ae1cd0$export$2e2bcd8739ae039 = $0247689484ae1cd0$var$updatedDiff;





const $02bea948bef00660$var$detailedDiff = (lhs, rhs)=>({
        added: (0, $a8cdb5e6467580f8$export$2e2bcd8739ae039)(lhs, rhs),
        deleted: (0, $cbe3342050544821$export$2e2bcd8739ae039)(lhs, rhs),
        updated: (0, $0247689484ae1cd0$export$2e2bcd8739ae039)(lhs, rhs)
    });
var $02bea948bef00660$export$2e2bcd8739ae039 = $02bea948bef00660$var$detailedDiff;





var $5E6i4 = parcelRequire("5E6i4");


var $5E6i4 = parcelRequire("5E6i4");
function $a428b4512e0a10bf$export$2e2bcd8739ae039(state) {
    var ref = (0, $5E6i4.useRef)();
    (0, $5E6i4.useEffect)(function() {
        ref.current = state;
    });
    return ref.current;
}







var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $14d451469199038b$var$BgColorsOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M766.4 744.3c43.7 0 79.4-36.2 79.4-80.5 0-53.5-79.4-140.8-79.4-140.8S687 610.3 687 663.8c0 44.3 35.7 80.5 79.4 80.5zm-377.1-44.1c7.1 7.1 18.6 7.1 25.6 0l256.1-256c7.1-7.1 7.1-18.6 0-25.6l-256-256c-.6-.6-1.3-1.2-2-1.7l-78.2-78.2a9.11 9.11 0 00-12.8 0l-48 48a9.11 9.11 0 000 12.8l67.2 67.2-207.8 207.9c-7.1 7.1-7.1 18.6 0 25.6l255.9 256zm12.9-448.6l178.9 178.9H223.4l178.8-178.9zM904 816H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "bg-colors",
    "theme": "outlined"
};
var $14d451469199038b$export$2e2bcd8739ae039 = $14d451469199038b$var$BgColorsOutlined;



function $afb0b12e1f7ced20$var$_extends() {
    $afb0b12e1f7ced20$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $afb0b12e1f7ced20$var$_extends.apply(this, arguments);
}
const $afb0b12e1f7ced20$var$BgColorsOutlined = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $afb0b12e1f7ced20$var$_extends({}, props, {
        ref: ref,
        icon: (0, $14d451469199038b$export$2e2bcd8739ae039)
    }));
/**![bg-colors](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTc2Ni40IDc0NC4zYzQzLjcgMCA3OS40LTM2LjIgNzkuNC04MC41IDAtNTMuNS03OS40LTE0MC44LTc5LjQtMTQwLjhTNjg3IDYxMC4zIDY4NyA2NjMuOGMwIDQ0LjMgMzUuNyA4MC41IDc5LjQgODAuNXptLTM3Ny4xLTQ0LjFjNy4xIDcuMSAxOC42IDcuMSAyNS42IDBsMjU2LjEtMjU2YzcuMS03LjEgNy4xLTE4LjYgMC0yNS42bC0yNTYtMjU2Yy0uNi0uNi0xLjMtMS4yLTItMS43bC03OC4yLTc4LjJhOS4xMSA5LjExIDAgMDAtMTIuOCAwbC00OCA0OGE5LjExIDkuMTEgMCAwMDAgMTIuOGw2Ny4yIDY3LjItMjA3LjggMjA3LjljLTcuMSA3LjEtNy4xIDE4LjYgMCAyNS42bDI1NS45IDI1NnptMTIuOS00NDguNmwxNzguOSAxNzguOUgyMjMuNGwxNzguOC0xNzguOXpNOTA0IDgxNkgxMjBjLTQuNCAwLTggMy42LTggOHY4MGMwIDQuNCAzLjYgOCA4IDhoNzg0YzQuNCAwIDgtMy42IDgtOHYtODBjMC00LjQtMy42LTgtOC04eiIgLz48L3N2Zz4=) */ const $afb0b12e1f7ced20$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($afb0b12e1f7ced20$var$BgColorsOutlined);
var $afb0b12e1f7ced20$export$2e2bcd8739ae039 = $afb0b12e1f7ced20$var$RefIcon;


var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $7114afa4c812cdce$var$LockOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM332 240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224H332V240zm460 600H232V536h560v304zM484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 10-56 0z"
                }
            }
        ]
    },
    "name": "lock",
    "theme": "outlined"
};
var $7114afa4c812cdce$export$2e2bcd8739ae039 = $7114afa4c812cdce$var$LockOutlined;



function $87a2cb5e973fcac7$var$_extends() {
    $87a2cb5e973fcac7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $87a2cb5e973fcac7$var$_extends.apply(this, arguments);
}
const $87a2cb5e973fcac7$var$LockOutlined = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $87a2cb5e973fcac7$var$_extends({}, props, {
        ref: ref,
        icon: (0, $7114afa4c812cdce$export$2e2bcd8739ae039)
    }));
/**![lock](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTgzMiA0NjRoLTY4VjI0MGMwLTcwLjctNTcuMy0xMjgtMTI4LTEyOEgzODhjLTcwLjcgMC0xMjggNTcuMy0xMjggMTI4djIyNGgtNjhjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjM4NGMwIDE3LjcgMTQuMyAzMiAzMiAzMmg2NDBjMTcuNyAwIDMyLTE0LjMgMzItMzJWNDk2YzAtMTcuNy0xNC4zLTMyLTMyLTMyek0zMzIgMjQwYzAtMzAuOSAyNS4xLTU2IDU2LTU2aDI0OGMzMC45IDAgNTYgMjUuMSA1NiA1NnYyMjRIMzMyVjI0MHptNDYwIDYwMEgyMzJWNTM2aDU2MHYzMDR6TTQ4NCA3MDF2NTNjMCA0LjQgMy42IDggOCA4aDQwYzQuNCAwIDgtMy42IDgtOHYtNTNhNDguMDEgNDguMDEgMCAxMC01NiAweiIgLz48L3N2Zz4=) */ const $87a2cb5e973fcac7$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($87a2cb5e973fcac7$var$LockOutlined);
var $87a2cb5e973fcac7$export$2e2bcd8739ae039 = $87a2cb5e973fcac7$var$RefIcon;


var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $4fe1ee7573e65702$var$NumberOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M872 394c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H708V152c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v166H400V152c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v166H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h168v236H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h168v166c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V706h228v166c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V706h164c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H708V394h164zM628 630H400V394h228v236z"
                }
            }
        ]
    },
    "name": "number",
    "theme": "outlined"
};
var $4fe1ee7573e65702$export$2e2bcd8739ae039 = $4fe1ee7573e65702$var$NumberOutlined;



function $acab2f81313f86ce$var$_extends() {
    $acab2f81313f86ce$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $acab2f81313f86ce$var$_extends.apply(this, arguments);
}
const $acab2f81313f86ce$var$NumberOutlined = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $acab2f81313f86ce$var$_extends({}, props, {
        ref: ref,
        icon: (0, $4fe1ee7573e65702$export$2e2bcd8739ae039)
    }));
/**![number](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg3MiAzOTRjNC40IDAgOC0zLjYgOC04di02MGMwLTQuNC0zLjYtOC04LThINzA4VjE1MmMwLTQuNC0zLjYtOC04LThoLTY0Yy00LjQgMC04IDMuNi04IDh2MTY2SDQwMFYxNTJjMC00LjQtMy42LTgtOC04aC02NGMtNC40IDAtOCAzLjYtOCA4djE2NkgxNTJjLTQuNCAwLTggMy42LTggOHY2MGMwIDQuNCAzLjYgOCA4IDhoMTY4djIzNkgxNTJjLTQuNCAwLTggMy42LTggOHY2MGMwIDQuNCAzLjYgOCA4IDhoMTY4djE2NmMwIDQuNCAzLjYgOCA4IDhoNjRjNC40IDAgOC0zLjYgOC04VjcwNmgyMjh2MTY2YzAgNC40IDMuNiA4IDggOGg2NGM0LjQgMCA4LTMuNiA4LThWNzA2aDE2NGM0LjQgMCA4LTMuNiA4LTh2LTYwYzAtNC40LTMuNi04LTgtOEg3MDhWMzk0aDE2NHpNNjI4IDYzMEg0MDBWMzk0aDIyOHYyMzZ6IiAvPjwvc3ZnPg==) */ const $acab2f81313f86ce$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($acab2f81313f86ce$var$NumberOutlined);
var $acab2f81313f86ce$export$2e2bcd8739ae039 = $acab2f81313f86ce$var$RefIcon;



var $5E6i4 = parcelRequire("5E6i4");







var $5E6i4 = parcelRequire("5E6i4");




const $6c01b9c32050ea39$export$15e5fca53711d340 = (propValue)=>{
    if (!(0, $b63de2b9864a5d1a$export$72280d5f896dac9a)(propValue)) return null;
    return (0, $addbc2fddcbb77a9$export$f6e2535fb5126e54)(propValue) ? propValue() : propValue;
};









var $5E6i4 = parcelRequire("5E6i4");












const $f0fb751e7e08765b$var$FALL_BACK_ORIGIN = '50%';
const $f0fb751e7e08765b$var$genBaseStyle = (token)=>{
    const { componentCls: componentCls, popoverColor: popoverColor, titleMinWidth: titleMinWidth, fontWeightStrong: fontWeightStrong, innerPadding: innerPadding, dropShadowPopover: dropShadowPopover, colorTextHeading: colorTextHeading, borderRadiusLG: borderRadiusLG, zIndexPopup: zIndexPopup, titleMarginBottom: titleMarginBottom, colorBgElevated: colorBgElevated, popoverBg: popoverBg, titleBorderBottom: titleBorderBottom, innerContentPadding: innerContentPadding, titlePadding: titlePadding, antCls: antCls } = token;
    const [varName, varRef] = (0, $761caadb5301aee1$export$d82b8f66c5649e14)(antCls, 'tooltip');
    return [
        {
            [componentCls]: {
                ...(0, $cd5a520fee8002b4$export$23997c3e44cc1c59)(token),
                position: 'absolute',
                top: 0,
                // use `left` to fix https://github.com/ant-design/ant-design/issues/39195
                left: {
                    _skip_check_: true,
                    value: 0
                },
                zIndex: zIndexPopup,
                fontWeight: 400,
                whiteSpace: 'normal',
                textAlign: 'start',
                cursor: 'auto',
                userSelect: 'text',
                filter: dropShadowPopover,
                // When use `autoArrow`, origin will follow the arrow position
                [varName('valid-offset-x')]: varRef('arrow-offset-x', 'var(--arrow-x)'),
                transformOrigin: [
                    varRef('valid-offset-x', $f0fb751e7e08765b$var$FALL_BACK_ORIGIN),
                    `var(--arrow-y, ${$f0fb751e7e08765b$var$FALL_BACK_ORIGIN})`
                ].join(' '),
                [varName('arrow-background-color')]: colorBgElevated,
                width: 'max-content',
                maxWidth: '100vw',
                '&-rtl': {
                    direction: 'rtl'
                },
                '&-hidden': {
                    display: 'none'
                },
                [`${componentCls}-content`]: {
                    position: 'relative'
                },
                [`${componentCls}-container`]: {
                    backgroundColor: popoverBg,
                    backgroundClip: 'padding-box',
                    borderRadius: borderRadiusLG,
                    padding: innerPadding
                },
                [`${componentCls}-title`]: {
                    minWidth: titleMinWidth,
                    marginBottom: titleMarginBottom,
                    color: colorTextHeading,
                    fontWeight: fontWeightStrong,
                    borderBottom: titleBorderBottom,
                    padding: titlePadding
                },
                [`${componentCls}-content`]: {
                    color: popoverColor,
                    padding: innerContentPadding
                }
            }
        },
        // Arrow Style
        (0, $2540b05188c79e49$export$2e2bcd8739ae039)(token, varRef('arrow-background-color'), {
            arrowShadow: false
        }),
        // Pure Render
        {
            [`${componentCls}-pure`]: {
                position: 'relative',
                maxWidth: 'none',
                margin: token.sizePopupArrow,
                display: 'inline-block'
            }
        }
    ];
};
const $f0fb751e7e08765b$var$genColorStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    const [varName] = (0, $761caadb5301aee1$export$d82b8f66c5649e14)(antCls, 'tooltip');
    return {
        [componentCls]: (0, $2535cf92607464fc$export$6d4fe3a00a1811ad).map((colorKey)=>{
            const lightColor = token[`${colorKey}6`];
            return {
                [`&${componentCls}-${colorKey}`]: {
                    [varName('arrow-background-color')]: lightColor,
                    [`${componentCls}-inner`]: {
                        backgroundColor: lightColor
                    },
                    [`${componentCls}-arrow`]: {
                        background: 'transparent'
                    }
                }
            };
        })
    };
};
const $f0fb751e7e08765b$export$9ca1be8807fe0675 = (token)=>{
    const { lineWidth: lineWidth, controlHeight: controlHeight, fontHeight: fontHeight, padding: padding, wireframe: wireframe, zIndexPopupBase: zIndexPopupBase, borderRadiusLG: borderRadiusLG, marginXS: marginXS, lineType: lineType, colorSplit: colorSplit, paddingSM: paddingSM } = token;
    const titlePaddingBlockDist = controlHeight - fontHeight;
    const popoverTitlePaddingBlockTop = titlePaddingBlockDist / 2;
    const popoverTitlePaddingBlockBottom = titlePaddingBlockDist / 2 - lineWidth;
    const popoverPaddingHorizontal = padding;
    return {
        titleMinWidth: 177,
        zIndexPopup: zIndexPopupBase + 30,
        ...(0, $0c98a14a5d55f8de$export$87e38ee403661ccc)(token),
        ...(0, $2540b05188c79e49$export$bddc192327bb9823)({
            contentRadius: borderRadiusLG,
            limitVerticalRadius: true
        }),
        // internal
        innerPadding: wireframe ? 0 : 12,
        titleMarginBottom: wireframe ? 0 : marginXS,
        titlePadding: wireframe ? `${popoverTitlePaddingBlockTop}px ${popoverPaddingHorizontal}px ${popoverTitlePaddingBlockBottom}px` : 0,
        titleBorderBottom: wireframe ? `${lineWidth}px ${lineType} ${colorSplit}` : 'none',
        innerContentPadding: wireframe ? `${paddingSM}px ${popoverPaddingHorizontal}px` : 0
    };
};
var $f0fb751e7e08765b$export$2e2bcd8739ae039 = (0, $761caadb5301aee1$export$51ec95de45185b42)('Popover', (token)=>{
    const { colorBgElevated: colorBgElevated, colorText: colorText } = token;
    const popoverToken = (0, $f564548c7b6877d5$export$4950aa0f605343fb)(token, {
        popoverBg: colorBgElevated,
        popoverColor: colorText
    });
    return [
        $f0fb751e7e08765b$var$genBaseStyle(popoverToken),
        $f0fb751e7e08765b$var$genColorStyle(popoverToken),
        (0, $67ba63c38ba87091$export$f5d123412490d9dc)(popoverToken, 'zoom-big')
    ];
}, $f0fb751e7e08765b$export$9ca1be8807fe0675, {
    resetStyle: false,
    deprecatedTokens: [
        [
            'width',
            'titleMinWidth'
        ],
        [
            'minWidth',
            'titleMinWidth'
        ]
    ]
});


"use client";
const $4e968fd9425105f5$export$c6fdb837b070b4ff = (props)=>{
    const { title: title, content: content, prefixCls: prefixCls, classNames: classNames, styles: styles } = props;
    if (!(0, $b63de2b9864a5d1a$export$72280d5f896dac9a)(title) && !(0, $b63de2b9864a5d1a$export$72280d5f896dac9a)(content)) return null;
    return /*#__PURE__*/ $5E6i4.createElement($5E6i4.Fragment, null, (0, $b63de2b9864a5d1a$export$72280d5f896dac9a)(title) && /*#__PURE__*/ $5E6i4.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-title`, classNames?.title),
        style: styles?.title
    }, title), (0, $b63de2b9864a5d1a$export$72280d5f896dac9a)(content) && /*#__PURE__*/ $5E6i4.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-content`, classNames?.content),
        style: styles?.content
    }, content));
};
const $4e968fd9425105f5$export$c40925af82c95d5b = (props)=>{
    const { hashId: hashId, prefixCls: prefixCls, className: className, style: style, placement: placement = 'top', title: title, content: content, children: children, classNames: classNames, styles: styles } = props;
    const titleNode = (0, $6c01b9c32050ea39$export$15e5fca53711d340)(title);
    const contentNode = (0, $6c01b9c32050ea39$export$15e5fca53711d340)(content);
    const mergedProps = {
        ...props,
        placement: placement
    };
    const [mergedClassNames, mergedStyles] = (0, $722c8632ba7bdb89$export$648566b068f28737)([
        classNames
    ], [
        styles
    ], {
        props: mergedProps
    });
    const rootClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(hashId, prefixCls, `${prefixCls}-pure`, `${prefixCls}-placement-${placement}`, className);
    return /*#__PURE__*/ $5E6i4.createElement("div", {
        className: rootClassName,
        style: style
    }, /*#__PURE__*/ $5E6i4.createElement("div", {
        className: `${prefixCls}-arrow`
    }), /*#__PURE__*/ $5E6i4.createElement((0, $405f5aaf9af8ea26$export$2e2bcd8739ae039), {
        ...props,
        className: hashId,
        prefixCls: prefixCls,
        classNames: mergedClassNames,
        styles: mergedStyles
    }, children || /*#__PURE__*/ $5E6i4.createElement($4e968fd9425105f5$export$c6fdb837b070b4ff, {
        prefixCls: prefixCls,
        title: titleNode,
        content: contentNode,
        classNames: mergedClassNames,
        styles: mergedStyles
    })));
};
const $4e968fd9425105f5$var$PurePanel = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, ...restProps } = props;
    const { getPrefixCls: getPrefixCls } = $5E6i4.useContext((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('popover', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $f0fb751e7e08765b$export$2e2bcd8739ae039)(prefixCls);
    return /*#__PURE__*/ $5E6i4.createElement($4e968fd9425105f5$export$c40925af82c95d5b, {
        ...restProps,
        prefixCls: prefixCls,
        hashId: hashId,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(className, cssVarCls)
    });
};
var $4e968fd9425105f5$export$2e2bcd8739ae039 = $4e968fd9425105f5$var$PurePanel;



"use client";
const $93eb2f6d46bfe5a2$var$InternalPopover = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, title: title, content: content, overlayClassName: overlayClassName, placement: placement = 'top', trigger: trigger, children: children, mouseEnterDelay: mouseEnterDelay, mouseLeaveDelay: mouseLeaveDelay, onOpenChange: onOpenChange, overlayStyle: overlayStyle = {}, styles: styles, classNames: classNames, motion: motion, arrow: popoverArrow, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles, arrow: contextArrow, trigger: contextTrigger, mouseEnterDelay: contextMouseEnterDelay, mouseLeaveDelay: contextMouseLeaveDelay } = (0, $519f2fad435b3034$export$46f4bd6436a25a31)('popover');
    const mergedMouseEnterDelay = mouseEnterDelay ?? contextMouseEnterDelay ?? 0.1;
    const mergedMouseLeaveDelay = mouseLeaveDelay ?? contextMouseLeaveDelay ?? 0.1;
    const prefixCls = getPrefixCls('popover', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $f0fb751e7e08765b$export$2e2bcd8739ae039)(prefixCls);
    const rootPrefixCls = getPrefixCls();
    const mergedArrow = (0, $fc11ff6780dcb007$export$2e2bcd8739ae039)(popoverArrow, contextArrow);
    const mergedTrigger = trigger || contextTrigger || 'hover';
    // ============================= Styles =============================
    const mergedProps = {
        ...props,
        placement: placement,
        trigger: mergedTrigger,
        mouseEnterDelay: mergedMouseEnterDelay,
        mouseLeaveDelay: mergedMouseLeaveDelay,
        overlayStyle: overlayStyle,
        styles: styles,
        classNames: classNames
    };
    const contextStyleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(contextStyle);
    const overlayStyleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(overlayStyle);
    const [mergedClassNames, mergedStyles] = (0, $722c8632ba7bdb89$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        overlayStyleRoot
    ], {
        props: mergedProps
    });
    const rootClassNames = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(overlayClassName, hashId, cssVarCls, contextClassName, mergedClassNames.root);
    const [open, setOpen] = (0, $e18df22f16a16360$export$2e2bcd8739ae039)(props.defaultOpen ?? false, props.open);
    const settingOpen = (nextOpen)=>{
        setOpen(nextOpen);
        onOpenChange?.(nextOpen);
    };
    const titleNode = (0, $6c01b9c32050ea39$export$15e5fca53711d340)(title);
    const contentNode = (0, $6c01b9c32050ea39$export$15e5fca53711d340)(content);
    return /*#__PURE__*/ $5E6i4.createElement((0, $1bb718ecb5669b36$export$2e2bcd8739ae039), {
        unique: false,
        arrow: mergedArrow,
        placement: placement,
        trigger: mergedTrigger,
        mouseEnterDelay: mergedMouseEnterDelay,
        mouseLeaveDelay: mergedMouseLeaveDelay,
        ...restProps,
        prefixCls: prefixCls,
        classNames: {
            root: rootClassNames,
            container: mergedClassNames.container,
            arrow: mergedClassNames.arrow
        },
        styles: {
            root: mergedStyles.root,
            container: mergedStyles.container,
            arrow: mergedStyles.arrow
        },
        ref: ref,
        open: open,
        onOpenChange: settingOpen,
        overlay: (0, $b63de2b9864a5d1a$export$72280d5f896dac9a)(titleNode) || (0, $b63de2b9864a5d1a$export$72280d5f896dac9a)(contentNode) ? /*#__PURE__*/ $5E6i4.createElement((0, $4e968fd9425105f5$export$c6fdb837b070b4ff), {
            prefixCls: prefixCls,
            title: titleNode,
            content: contentNode,
            classNames: mergedClassNames,
            styles: mergedStyles
        }) : null,
        motion: {
            motionName: (0, $c2c363b881b49d51$export$27c72201b1d09951)(rootPrefixCls, 'zoom-big', typeof motion?.motionName === 'string' ? motion?.motionName : undefined)
        },
        "data-popover-inject": true
    }, children);
});
const $93eb2f6d46bfe5a2$var$Popover = $93eb2f6d46bfe5a2$var$InternalPopover;
$93eb2f6d46bfe5a2$var$Popover._InternalPanelDoNotUseOrYouWillBeFired = (0, $4e968fd9425105f5$export$2e2bcd8739ae039);
var $93eb2f6d46bfe5a2$export$2e2bcd8739ae039 = $93eb2f6d46bfe5a2$var$Popover;




var $5E6i4 = parcelRequire("5E6i4");












// =============================== Base ===============================
const $b12755b65ddc5ea2$var$genBaseStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, antCls: antCls, zIndexPopup: zIndexPopup, colorText: colorText, colorWarning: colorWarning, marginXXS: marginXXS, marginXS: marginXS, fontSize: fontSize, fontWeightStrong: fontWeightStrong, colorTextHeading: colorTextHeading } = token;
    return {
        [componentCls]: {
            zIndex: zIndexPopup,
            [`&${antCls}-popover`]: {
                fontSize: fontSize
            },
            [`${componentCls}-message`]: {
                marginBottom: marginXS,
                display: 'flex',
                flexWrap: 'nowrap',
                alignItems: 'start',
                [`> ${componentCls}-message-icon`]: {
                    color: colorWarning
                },
                [`> ${componentCls}-message-icon ${iconCls}`]: {
                    fontSize: fontSize,
                    lineHeight: 1,
                    marginInlineEnd: marginXS
                },
                [`${componentCls}-title`]: {
                    fontWeight: fontWeightStrong,
                    color: colorTextHeading,
                    '&:only-child': {
                        fontWeight: 400
                    }
                },
                [`${componentCls}-description`]: {
                    marginTop: marginXXS,
                    color: colorText
                }
            },
            [`${componentCls}-buttons`]: {
                textAlign: 'end',
                whiteSpace: 'nowrap',
                button: {
                    marginInlineStart: marginXS
                }
            }
        }
    };
};
const $b12755b65ddc5ea2$export$9ca1be8807fe0675 = (token)=>{
    const { zIndexPopupBase: zIndexPopupBase } = token;
    return {
        zIndexPopup: zIndexPopupBase + 60
    };
};
var $b12755b65ddc5ea2$export$2e2bcd8739ae039 = (0, $761caadb5301aee1$export$51ec95de45185b42)('Popconfirm', $b12755b65ddc5ea2$var$genBaseStyle, $b12755b65ddc5ea2$export$9ca1be8807fe0675, {
    resetStyle: false
});


"use client";
const $1a20f79887cb22de$export$c6fdb837b070b4ff = (props)=>{
    const { prefixCls: prefixCls, okButtonProps: okButtonProps, cancelButtonProps: cancelButtonProps, title: title, description: description, cancelText: cancelText, okText: okText, okType: okType = 'primary', icon: icon = /*#__PURE__*/ $5E6i4.createElement((0, $02cacf707e93d6b4$export$2e2bcd8739ae039), null), showCancel: showCancel = true, close: close, onConfirm: onConfirm, onCancel: onCancel, onPopupClick: onPopupClick, classNames: classNames, styles: styles } = props;
    const { getPrefixCls: getPrefixCls } = $5E6i4.useContext((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
    const [contextLocale] = (0, $a2f3e1f88973a5e2$export$2e2bcd8739ae039)('Popconfirm', (0, $7a40da28675d08a9$export$2e2bcd8739ae039).Popconfirm);
    const titleNode = (0, $6c01b9c32050ea39$export$15e5fca53711d340)(title);
    const descriptionNode = (0, $6c01b9c32050ea39$export$15e5fca53711d340)(description);
    return /*#__PURE__*/ $5E6i4.createElement("div", {
        className: `${prefixCls}-inner-content`,
        onClick: onPopupClick
    }, /*#__PURE__*/ $5E6i4.createElement("div", {
        className: `${prefixCls}-message`
    }, icon && /*#__PURE__*/ $5E6i4.createElement("span", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-message-icon`, classNames?.icon),
        style: styles?.icon
    }, icon), /*#__PURE__*/ $5E6i4.createElement("div", {
        className: `${prefixCls}-message-text`
    }, (0, $b63de2b9864a5d1a$export$72280d5f896dac9a)(titleNode) && /*#__PURE__*/ $5E6i4.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-title`, classNames?.title),
        style: styles?.title
    }, titleNode), (0, $b63de2b9864a5d1a$export$72280d5f896dac9a)(descriptionNode) && /*#__PURE__*/ $5E6i4.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-description`, classNames?.content),
        style: styles?.content
    }, descriptionNode))), /*#__PURE__*/ $5E6i4.createElement("div", {
        className: `${prefixCls}-buttons`
    }, showCancel && /*#__PURE__*/ $5E6i4.createElement((0, $17f39e4db74a8975$export$2e2bcd8739ae039), {
        onClick: onCancel,
        size: "small",
        ...cancelButtonProps
    }, cancelText || contextLocale?.cancelText), /*#__PURE__*/ $5E6i4.createElement((0, $6876735e3ab2dfcd$export$2e2bcd8739ae039), {
        buttonProps: {
            size: 'small',
            ...(0, $0ceddc1355cab302$export$19bc9a290855952)(okType),
            ...okButtonProps
        },
        actionFn: onConfirm,
        close: close,
        prefixCls: getPrefixCls('btn'),
        quitOnNullishReturnValue: true,
        emitEvent: true
    }, okText || contextLocale?.okText)));
};
const $1a20f79887cb22de$var$PurePanel = (props)=>{
    const { prefixCls: customizePrefixCls, placement: placement, className: className, style: style, ...restProps } = props;
    const { getPrefixCls: getPrefixCls } = $5E6i4.useContext((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('popconfirm', customizePrefixCls);
    (0, $b12755b65ddc5ea2$export$2e2bcd8739ae039)(prefixCls);
    return /*#__PURE__*/ $5E6i4.createElement((0, $4e968fd9425105f5$export$2e2bcd8739ae039), {
        placement: placement,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, className),
        style: style,
        content: /*#__PURE__*/ $5E6i4.createElement($1a20f79887cb22de$export$c6fdb837b070b4ff, {
            prefixCls: prefixCls,
            ...restProps
        })
    });
};
var $1a20f79887cb22de$export$2e2bcd8739ae039 = $1a20f79887cb22de$var$PurePanel;



"use client";
const $ee1d917a45794f63$var$InternalPopconfirm = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, placement: placement = 'top', trigger: trigger, okType: okType = 'primary', icon: icon = /*#__PURE__*/ $5E6i4.createElement((0, $02cacf707e93d6b4$export$2e2bcd8739ae039), null), children: children, overlayClassName: overlayClassName, onOpenChange: onOpenChange, overlayStyle: overlayStyle, styles: styles, arrow: popconfirmArrow, classNames: classNames, disabled: disabled = false, mouseEnterDelay: mouseEnterDelay, mouseLeaveDelay: mouseLeaveDelay, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles, arrow: contextArrow, trigger: contextTrigger, mouseEnterDelay: contextMouseEnterDelay, mouseLeaveDelay: contextMouseLeaveDelay } = (0, $519f2fad435b3034$export$46f4bd6436a25a31)('popconfirm');
    const [open, setOpen] = (0, $e18df22f16a16360$export$2e2bcd8739ae039)(props.defaultOpen ?? false, props.open);
    const mergedArrow = (0, $fc11ff6780dcb007$export$2e2bcd8739ae039)(popconfirmArrow, contextArrow);
    const mergedTrigger = trigger || contextTrigger || 'click';
    const mergedMouseEnterDelay = mouseEnterDelay ?? contextMouseEnterDelay ?? 0.1;
    const mergedMouseLeaveDelay = mouseLeaveDelay ?? contextMouseLeaveDelay ?? 0.1;
    const settingOpen = (nextOpen)=>{
        setOpen(nextOpen);
        onOpenChange?.(nextOpen);
    };
    const close = ()=>{
        settingOpen(false);
    };
    const onConfirm = (e)=>props.onConfirm?.call(undefined, e);
    const onCancel = (e)=>{
        settingOpen(false);
        props.onCancel?.call(undefined, e);
    };
    const onInternalOpenChange = (nextOpen)=>{
        if (disabled) return;
        settingOpen(nextOpen);
    };
    const prefixCls = getPrefixCls('popconfirm', customizePrefixCls);
    const mergedProps = {
        ...props,
        placement: placement,
        trigger: mergedTrigger,
        okType: okType,
        overlayStyle: overlayStyle,
        styles: styles,
        classNames: classNames,
        mouseEnterDelay: mergedMouseEnterDelay,
        mouseLeaveDelay: mergedMouseLeaveDelay
    };
    const contextStyleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(contextStyle);
    const overlayStyleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(overlayStyle);
    const [mergedClassNames, mergedStyles] = (0, $722c8632ba7bdb89$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        overlayStyleRoot
    ], {
        props: mergedProps
    });
    const rootClassNames = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, contextClassName, overlayClassName, mergedClassNames.root);
    (0, $b12755b65ddc5ea2$export$2e2bcd8739ae039)(prefixCls);
    return /*#__PURE__*/ $5E6i4.createElement((0, $93eb2f6d46bfe5a2$export$2e2bcd8739ae039), {
        arrow: mergedArrow,
        ...(0, $48bd91d9f828de66$export$2e2bcd8739ae039)(restProps, [
            'title'
        ]),
        trigger: mergedTrigger,
        placement: placement,
        onOpenChange: onInternalOpenChange,
        open: open,
        ref: ref,
        mouseEnterDelay: mergedMouseEnterDelay,
        mouseLeaveDelay: mergedMouseLeaveDelay,
        classNames: {
            root: rootClassNames,
            container: mergedClassNames.container,
            arrow: mergedClassNames.arrow
        },
        styles: {
            root: mergedStyles.root,
            container: mergedStyles.container,
            arrow: mergedStyles.arrow
        },
        content: /*#__PURE__*/ $5E6i4.createElement((0, $1a20f79887cb22de$export$c6fdb837b070b4ff), {
            okType: okType,
            icon: icon,
            ...props,
            prefixCls: prefixCls,
            close: close,
            onConfirm: onConfirm,
            onCancel: onCancel,
            classNames: mergedClassNames,
            styles: mergedStyles
        }),
        "data-popover-inject": true
    }, children);
});
const $ee1d917a45794f63$var$Popconfirm = $ee1d917a45794f63$var$InternalPopconfirm;
// We don't care debug panel
/* istanbul ignore next */ $ee1d917a45794f63$var$Popconfirm._InternalPanelDoNotUseOrYouWillBeFired = (0, $1a20f79887cb22de$export$2e2bcd8739ae039);
var $ee1d917a45794f63$export$2e2bcd8739ae039 = $ee1d917a45794f63$var$Popconfirm;


var $5E6i4 = parcelRequire("5E6i4");


var $5E6i4 = parcelRequire("5E6i4");



function $f7b433aa251aba95$var$_extends() {
    $f7b433aa251aba95$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f7b433aa251aba95$var$_extends.apply(this, arguments);
}
const $f7b433aa251aba95$var$Switch = /*#__PURE__*/ $5E6i4.forwardRef(({ prefixCls: prefixCls = 'rc-switch', className: className, checked: checked, defaultChecked: defaultChecked, disabled: disabled, loadingIcon: loadingIcon, checkedChildren: checkedChildren, unCheckedChildren: unCheckedChildren, onClick: onClick, onChange: onChange, onKeyDown: onKeyDown, styles: styles, classNames: switchClassNames, ...restProps }, ref)=>{
    const [innerChecked, setInnerChecked] = (0, $e18df22f16a16360$export$2e2bcd8739ae039)(defaultChecked ?? false, checked);
    function triggerChange(newChecked, event) {
        let mergedChecked = innerChecked;
        if (!disabled) {
            mergedChecked = newChecked;
            setInnerChecked(mergedChecked);
            onChange?.(mergedChecked, event);
        }
        return mergedChecked;
    }
    function onInternalKeyDown(e) {
        if (e.which === (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).LEFT) triggerChange(false, e);
        else if (e.which === (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).RIGHT) triggerChange(true, e);
        onKeyDown?.(e);
    }
    function onInternalClick(e) {
        const ret = triggerChange(!innerChecked, e);
        // [Legacy] trigger onClick with value
        onClick?.(ret, e);
    }
    const switchClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, className, {
        [`${prefixCls}-checked`]: innerChecked,
        [`${prefixCls}-disabled`]: disabled
    });
    return /*#__PURE__*/ $5E6i4.createElement("button", $f7b433aa251aba95$var$_extends({}, restProps, {
        type: "button",
        role: "switch",
        "aria-checked": innerChecked,
        disabled: disabled,
        className: switchClassName,
        ref: ref,
        onKeyDown: onInternalKeyDown,
        onClick: onInternalClick
    }), loadingIcon, /*#__PURE__*/ $5E6i4.createElement("span", {
        className: `${prefixCls}-inner`
    }, /*#__PURE__*/ $5E6i4.createElement("span", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-inner-checked`, switchClassNames?.content),
        style: styles?.content
    }, checkedChildren), /*#__PURE__*/ $5E6i4.createElement("span", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-inner-unchecked`, switchClassNames?.content),
        style: styles?.content
    }, unCheckedChildren)));
});
$f7b433aa251aba95$var$Switch.displayName = 'Switch';
var $f7b433aa251aba95$export$2e2bcd8739ae039 = $f7b433aa251aba95$var$Switch;















const $3a83c18f59586c21$var$genSwitchSmallStyle = (token)=>{
    const { componentCls: componentCls, trackHeightSM: trackHeightSM, trackPadding: trackPadding, trackMinWidthSM: trackMinWidthSM, innerMinMarginSM: innerMinMarginSM, innerMaxMarginSM: innerMaxMarginSM, handleSizeSM: handleSizeSM, calc: calc } = token;
    const switchInnerCls = `${componentCls}-inner`;
    const trackPaddingCalc = (0, $56bae8a99c3cba6e$export$523c0b569236b342)(calc(handleSizeSM).add(calc(trackPadding).mul(2)).equal());
    const innerMaxMarginCalc = (0, $56bae8a99c3cba6e$export$523c0b569236b342)(calc(innerMaxMarginSM).mul(2).equal());
    return {
        [componentCls]: {
            [`&${componentCls}-small`]: {
                minWidth: trackMinWidthSM,
                height: trackHeightSM,
                lineHeight: (0, $56bae8a99c3cba6e$export$523c0b569236b342)(trackHeightSM),
                [`${componentCls}-inner`]: {
                    paddingInlineStart: innerMaxMarginSM,
                    paddingInlineEnd: innerMinMarginSM,
                    [`${switchInnerCls}-checked, ${switchInnerCls}-unchecked`]: {
                        minHeight: trackHeightSM
                    },
                    [`${switchInnerCls}-checked`]: {
                        marginInlineStart: `calc(-100% + ${trackPaddingCalc} - ${innerMaxMarginCalc})`,
                        marginInlineEnd: `calc(100% - ${trackPaddingCalc} + ${innerMaxMarginCalc})`
                    },
                    [`${switchInnerCls}-unchecked`]: {
                        marginTop: calc(trackHeightSM).mul(-1).equal(),
                        marginInlineStart: 0,
                        marginInlineEnd: 0
                    }
                },
                [`${componentCls}-handle`]: {
                    width: handleSizeSM,
                    height: handleSizeSM
                },
                [`${componentCls}-loading-icon`]: {
                    top: calc(calc(handleSizeSM).sub(token.switchLoadingIconSize)).div(2).equal(),
                    fontSize: token.switchLoadingIconSize
                },
                [`&${componentCls}-checked`]: {
                    [`${componentCls}-inner`]: {
                        paddingInlineStart: innerMinMarginSM,
                        paddingInlineEnd: innerMaxMarginSM,
                        [`${switchInnerCls}-checked`]: {
                            marginInlineStart: 0,
                            marginInlineEnd: 0
                        },
                        [`${switchInnerCls}-unchecked`]: {
                            marginInlineStart: `calc(100% - ${trackPaddingCalc} + ${innerMaxMarginCalc})`,
                            marginInlineEnd: `calc(-100% + ${trackPaddingCalc} - ${innerMaxMarginCalc})`
                        }
                    },
                    [`${componentCls}-handle`]: {
                        insetInlineStart: `calc(100% - ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(calc(handleSizeSM).add(trackPadding).equal())})`
                    }
                },
                [`&:not(${componentCls}-disabled):active`]: {
                    [`&:not(${componentCls}-checked) ${switchInnerCls}`]: {
                        [`${switchInnerCls}-unchecked`]: {
                            marginInlineStart: calc(token.marginXXS).div(2).equal(),
                            marginInlineEnd: calc(token.marginXXS).mul(-1).div(2).equal()
                        }
                    },
                    [`&${componentCls}-checked ${switchInnerCls}`]: {
                        [`${switchInnerCls}-checked`]: {
                            marginInlineStart: calc(token.marginXXS).mul(-1).div(2).equal(),
                            marginInlineEnd: calc(token.marginXXS).div(2).equal()
                        }
                    }
                }
            }
        }
    };
};
const $3a83c18f59586c21$var$genSwitchLoadingStyle = (token)=>{
    const { componentCls: componentCls, handleSize: handleSize, calc: calc } = token;
    return {
        [componentCls]: {
            [`${componentCls}-loading-icon${token.iconCls}`]: {
                position: 'relative',
                top: calc(calc(handleSize).sub(token.fontSize)).div(2).equal(),
                color: token.switchLoadingIconColor,
                verticalAlign: 'top'
            },
            [`&${componentCls}-checked ${componentCls}-loading-icon`]: {
                color: token.switchColor
            }
        }
    };
};
const $3a83c18f59586c21$var$genSwitchHandleStyle = (token)=>{
    const { componentCls: componentCls, trackPadding: trackPadding, handleBg: handleBg, handleShadow: handleShadow, handleSize: handleSize, calc: calc } = token;
    const switchHandleCls = `${componentCls}-handle`;
    return {
        [componentCls]: {
            [switchHandleCls]: {
                position: 'absolute',
                top: trackPadding,
                insetInlineStart: trackPadding,
                width: handleSize,
                height: handleSize,
                transition: `all ${token.switchDuration} ease-in-out`,
                ...(0, $3c4103d4365d19b7$export$c5b4e7cabb00fc99)(),
                '&::before': {
                    position: 'absolute',
                    top: 0,
                    insetInlineEnd: 0,
                    bottom: 0,
                    insetInlineStart: 0,
                    backgroundColor: handleBg,
                    borderRadius: calc(handleSize).div(2).equal(),
                    boxShadow: handleShadow,
                    transition: `all ${token.switchDuration} ease-in-out`,
                    content: '""',
                    ...(0, $3c4103d4365d19b7$export$a2e3d2d19d960234)()
                }
            },
            [`&${componentCls}-checked ${switchHandleCls}`]: {
                insetInlineStart: `calc(100% - ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(calc(handleSize).add(trackPadding).equal())})`
            },
            [`&:not(${componentCls}-disabled):active`]: {
                [`${switchHandleCls}::before`]: {
                    insetInlineEnd: token.switchHandleActiveInset,
                    insetInlineStart: 0
                },
                [`&${componentCls}-checked ${switchHandleCls}::before`]: {
                    insetInlineEnd: 0,
                    insetInlineStart: token.switchHandleActiveInset
                }
            }
        }
    };
};
const $3a83c18f59586c21$var$genSwitchInnerStyle = (token)=>{
    const { componentCls: componentCls, trackHeight: trackHeight, trackPadding: trackPadding, innerMinMargin: innerMinMargin, innerMaxMargin: innerMaxMargin, handleSize: handleSize, switchDuration: switchDuration, calc: calc } = token;
    const switchInnerCls = `${componentCls}-inner`;
    const trackPaddingCalc = (0, $56bae8a99c3cba6e$export$523c0b569236b342)(calc(handleSize).add(calc(trackPadding).mul(2)).equal());
    const innerMaxMarginCalc = (0, $56bae8a99c3cba6e$export$523c0b569236b342)(calc(innerMaxMargin).mul(2).equal());
    return {
        [componentCls]: {
            [switchInnerCls]: {
                display: 'block',
                overflow: 'hidden',
                borderRadius: 100,
                height: '100%',
                paddingInlineStart: innerMaxMargin,
                paddingInlineEnd: innerMinMargin,
                transition: [
                    `padding-inline-start`,
                    `padding-inline-end`
                ].map((prop)=>`${prop} ${switchDuration} ease-in-out`).join(', '),
                ...(0, $3c4103d4365d19b7$export$c5b4e7cabb00fc99)(),
                [`${switchInnerCls}-checked, ${switchInnerCls}-unchecked`]: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: token.colorTextLightSolid,
                    fontSize: token.fontSizeSM,
                    pointerEvents: 'none',
                    minHeight: trackHeight,
                    transition: [
                        `margin-inline-start`,
                        `margin-inline-end`
                    ].map((prop)=>`${prop} ${switchDuration} ease-in-out`).join(', '),
                    ...(0, $3c4103d4365d19b7$export$c5b4e7cabb00fc99)()
                },
                [`${switchInnerCls}-checked`]: {
                    marginInlineStart: `calc(-100% + ${trackPaddingCalc} - ${innerMaxMarginCalc})`,
                    marginInlineEnd: `calc(100% - ${trackPaddingCalc} + ${innerMaxMarginCalc})`
                },
                [`${switchInnerCls}-unchecked`]: {
                    marginTop: calc(trackHeight).mul(-1).equal(),
                    marginInlineStart: 0,
                    marginInlineEnd: 0
                }
            },
            [`&${componentCls}-checked ${switchInnerCls}`]: {
                paddingInlineStart: innerMinMargin,
                paddingInlineEnd: innerMaxMargin,
                [`${switchInnerCls}-checked`]: {
                    marginInlineStart: 0,
                    marginInlineEnd: 0
                },
                [`${switchInnerCls}-unchecked`]: {
                    marginInlineStart: `calc(100% - ${trackPaddingCalc} + ${innerMaxMarginCalc})`,
                    marginInlineEnd: `calc(-100% + ${trackPaddingCalc} - ${innerMaxMarginCalc})`
                }
            },
            [`&:not(${componentCls}-disabled):active`]: {
                [`&:not(${componentCls}-checked) ${switchInnerCls}`]: {
                    [`${switchInnerCls}-unchecked`]: {
                        marginInlineStart: calc(trackPadding).mul(2).equal(),
                        marginInlineEnd: calc(trackPadding).mul(-1).mul(2).equal()
                    }
                },
                [`&${componentCls}-checked ${switchInnerCls}`]: {
                    [`${switchInnerCls}-checked`]: {
                        marginInlineStart: calc(trackPadding).mul(-1).mul(2).equal(),
                        marginInlineEnd: calc(trackPadding).mul(2).equal()
                    }
                }
            }
        }
    };
};
const $3a83c18f59586c21$var$genSwitchStyle = (token)=>{
    const { componentCls: componentCls, trackHeight: trackHeight, trackMinWidth: trackMinWidth } = token;
    return {
        [componentCls]: {
            ...(0, $cd5a520fee8002b4$export$23997c3e44cc1c59)(token),
            position: 'relative',
            display: 'inline-block',
            boxSizing: 'border-box',
            minWidth: trackMinWidth,
            height: trackHeight,
            lineHeight: (0, $56bae8a99c3cba6e$export$523c0b569236b342)(trackHeight),
            verticalAlign: 'middle',
            background: token.colorTextQuaternary,
            border: '0',
            borderRadius: 100,
            cursor: 'pointer',
            transition: `all ${token.motionDurationMid}`,
            userSelect: 'none',
            ...(0, $3c4103d4365d19b7$export$c5b4e7cabb00fc99)(),
            [`&:hover:not(${componentCls}-disabled)`]: {
                background: token.colorTextTertiary
            },
            ...(0, $cd5a520fee8002b4$export$a44db842bcb28231)(token),
            [`&${componentCls}-checked`]: {
                background: token.switchColor,
                [`&:hover:not(${componentCls}-disabled)`]: {
                    background: token.colorPrimaryHover
                }
            },
            [`&${componentCls}-loading, &${componentCls}-disabled`]: {
                cursor: 'not-allowed',
                opacity: token.switchDisabledOpacity,
                '*': {
                    boxShadow: 'none',
                    cursor: 'not-allowed'
                }
            },
            // rtl style
            [`&${componentCls}-rtl`]: {
                direction: 'rtl'
            }
        }
    };
};
const $3a83c18f59586c21$export$9ca1be8807fe0675 = (token)=>{
    const { fontSize: fontSize, lineHeight: lineHeight, controlHeight: controlHeight, colorWhite: colorWhite } = token;
    const height = fontSize * lineHeight;
    const heightSM = controlHeight / 2;
    const padding = 2; // Fixed value
    const handleSize = height - padding * 2;
    const handleSizeSM = heightSM - padding * 2;
    return {
        trackHeight: height,
        trackHeightSM: heightSM,
        trackMinWidth: handleSize * 2 + padding * 4,
        trackMinWidthSM: handleSizeSM * 2 + padding * 2,
        trackPadding: padding,
        // Fixed value
        handleBg: colorWhite,
        handleSize: handleSize,
        handleSizeSM: handleSizeSM,
        handleShadow: `0 2px 4px 0 ${new (0, $1b0a692e36565107$export$2c4f38d6c0ecc25a)('#00230b').setA(0.2).toRgbString()}`,
        innerMinMargin: handleSize / 2,
        innerMaxMargin: handleSize + padding + padding * 2,
        innerMinMarginSM: handleSizeSM / 2,
        innerMaxMarginSM: handleSizeSM + padding + padding * 2
    };
};
var $3a83c18f59586c21$export$2e2bcd8739ae039 = (0, $761caadb5301aee1$export$51ec95de45185b42)('Switch', (token)=>{
    const switchToken = (0, $f564548c7b6877d5$export$4950aa0f605343fb)(token, {
        switchDuration: token.motionDurationMid,
        switchColor: token.colorPrimary,
        switchDisabledOpacity: token.opacityLoading,
        switchLoadingIconSize: token.calc(token.fontSizeIcon).mul(0.75).equal(),
        switchLoadingIconColor: `rgba(0, 0, 0, ${token.opacityLoading})`,
        switchHandleActiveInset: '-30%'
    });
    return [
        $3a83c18f59586c21$var$genSwitchStyle(switchToken),
        // inner style
        $3a83c18f59586c21$var$genSwitchInnerStyle(switchToken),
        // handle style
        $3a83c18f59586c21$var$genSwitchHandleStyle(switchToken),
        // loading style
        $3a83c18f59586c21$var$genSwitchLoadingStyle(switchToken),
        // small style
        $3a83c18f59586c21$var$genSwitchSmallStyle(switchToken)
    ];
}, $3a83c18f59586c21$export$9ca1be8807fe0675);


"use client";
const $bccd02a83058d871$var$InternalSwitch = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, size: customizeSize, disabled: customDisabled, loading: loading, className: className, rootClassName: rootClassName, style: style, checked: checkedProp, value: value, defaultChecked: defaultCheckedProp, defaultValue: defaultValue, onChange: onChange, styles: styles, classNames: classNames, ...restProps } = props;
    const [checked, setChecked] = (0, $e18df22f16a16360$export$2e2bcd8739ae039)(defaultCheckedProp ?? defaultValue ?? false, checkedProp ?? value);
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $519f2fad435b3034$export$46f4bd6436a25a31)('switch');
    // ===================== Disabled =====================
    const disabled = $5E6i4.useContext((0, $2ab14018ea5b2d79$export$2e2bcd8739ae039));
    const mergedDisabled = (customDisabled ?? disabled) || loading;
    const prefixCls = getPrefixCls('switch', customizePrefixCls);
    // Style
    const [hashId, cssVarCls] = (0, $3a83c18f59586c21$export$2e2bcd8739ae039)(prefixCls);
    const mergedSize = (0, $4bfc7567df2a969e$export$2e2bcd8739ae039)(customizeSize);
    const mergedProps = {
        ...props,
        size: mergedSize,
        disabled: mergedDisabled
    };
    const contextStyleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $722c8632ba7bdb89$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    });
    const loadingIcon = /*#__PURE__*/ $5E6i4.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-handle`, mergedClassNames.indicator),
        style: mergedStyles.indicator
    }, loading && /*#__PURE__*/ $5E6i4.createElement((0, $6e3183dc0ea574da$export$2e2bcd8739ae039), {
        className: `${prefixCls}-loading-icon`
    }));
    const classes = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(contextClassName, {
        [`${prefixCls}-small`]: mergedSize === 'small',
        [`${prefixCls}-loading`]: loading,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, className, rootClassName, mergedClassNames.root, hashId, cssVarCls);
    const changeHandler = (...args)=>{
        setChecked(args[0]);
        onChange?.(...args);
    };
    return /*#__PURE__*/ $5E6i4.createElement((0, $fac597d347ed38a8$export$2e2bcd8739ae039), {
        component: "Switch",
        disabled: mergedDisabled
    }, /*#__PURE__*/ $5E6i4.createElement((0, $f7b433aa251aba95$export$2e2bcd8739ae039), {
        ...restProps,
        classNames: mergedClassNames,
        styles: mergedStyles,
        checked: checked,
        onChange: changeHandler,
        prefixCls: prefixCls,
        className: classes,
        style: mergedStyles.root,
        disabled: mergedDisabled,
        ref: ref,
        loadingIcon: loadingIcon
    }));
});
const $bccd02a83058d871$var$Switch = $bccd02a83058d871$var$InternalSwitch;
$bccd02a83058d871$var$Switch.__ANT_SWITCH = true;
var $bccd02a83058d871$export$2e2bcd8739ae039 = $bccd02a83058d871$var$Switch;


var $5E6i4 = parcelRequire("5E6i4");




var $5E6i4 = parcelRequire("5E6i4");









var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $550a0b2c3660d946$var$EnterOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M864 170h-60c-4.4 0-8 3.6-8 8v518H310v-73c0-6.7-7.8-10.5-13-6.3l-141.9 112a8 8 0 000 12.6l141.9 112c5.3 4.2 13 .4 13-6.3v-75h498c35.3 0 64-28.7 64-64V178c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "enter",
    "theme": "outlined"
};
var $550a0b2c3660d946$export$2e2bcd8739ae039 = $550a0b2c3660d946$var$EnterOutlined;



function $7338c6d9e9b9cc58$var$_extends() {
    $7338c6d9e9b9cc58$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7338c6d9e9b9cc58$var$_extends.apply(this, arguments);
}
const $7338c6d9e9b9cc58$var$EnterOutlined = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $7338c6d9e9b9cc58$var$_extends({}, props, {
        ref: ref,
        icon: (0, $550a0b2c3660d946$export$2e2bcd8739ae039)
    }));
/**![enter](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg2NCAxNzBoLTYwYy00LjQgMC04IDMuNi04IDh2NTE4SDMxMHYtNzNjMC02LjctNy44LTEwLjUtMTMtNi4zbC0xNDEuOSAxMTJhOCA4IDAgMDAwIDEyLjZsMTQxLjkgMTEyYzUuMyA0LjIgMTMgLjQgMTMtNi4zdi03NWg0OThjMzUuMyAwIDY0LTI4LjcgNjQtNjRWMTc4YzAtNC40LTMuNi04LTgtOHoiIC8+PC9zdmc+) */ const $7338c6d9e9b9cc58$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($7338c6d9e9b9cc58$var$EnterOutlined);
var $7338c6d9e9b9cc58$export$2e2bcd8739ae039 = $7338c6d9e9b9cc58$var$RefIcon;








/*
.typography-title(@fontSize; @fontWeight; @lineHeight; @headingColor; @headingMarginBottom;) {
 margin-bottom: @headingMarginBottom;
 color: @headingColor;
 font-weight: @fontWeight;
 fontSize: @fontSize;
 line-height: @lineHeight;
}
*/ 


const $7eaf8ca3e662a36a$var$getTitleStyle = (fontSize, lineHeight, color, token)=>{
    const { titleMarginBottom: titleMarginBottom, fontWeightStrong: fontWeightStrong } = token;
    return {
        marginBottom: titleMarginBottom,
        color: color,
        fontWeight: fontWeightStrong,
        fontSize: fontSize,
        lineHeight: lineHeight
    };
};
const $7eaf8ca3e662a36a$export$83146cf7d1bec659 = (token)=>{
    const headings = [
        1,
        2,
        3,
        4,
        5
    ];
    const styles = {};
    headings.forEach((headingLevel)=>{
        styles[`
      h${headingLevel}&,
      div&-h${headingLevel},
      div&-h${headingLevel} > textarea,
      h${headingLevel}
    `] = $7eaf8ca3e662a36a$var$getTitleStyle(token[`fontSizeHeading${headingLevel}`], token[`lineHeightHeading${headingLevel}`], token.colorTextHeading, token);
    });
    return styles;
};
const $7eaf8ca3e662a36a$export$566f4066c7caac18 = (token)=>{
    const { componentCls: componentCls } = token;
    const linkCls = `${componentCls}-link`;
    return {
        [`&${linkCls}`]: {
            ...(0, $cd5a520fee8002b4$export$9a16e7694a707ab4)(token),
            userSelect: 'text',
            [`&[disabled], &${componentCls}-disabled`]: {
                color: token.colorTextDisabled,
                cursor: 'not-allowed',
                '&:active, &:hover': {
                    color: token.colorTextDisabled
                },
                '&:active': {
                    pointerEvents: 'none',
                    // Action buttons (copy, edit, expand) must remain interactive even when
                    // the disabled link is being clicked, otherwise their click events get
                    // swallowed by the parent's pointer-events: none during :active.
                    [`${componentCls}-actions`]: {
                        pointerEvents: 'auto'
                    }
                }
            }
        }
    };
};
const $7eaf8ca3e662a36a$export$977383a86f45014b = (token)=>({
        code: {
            margin: '0 0.2em',
            paddingInline: '0.4em',
            paddingBlock: '0.2em 0.1em',
            fontSize: '85%',
            fontFamily: token.fontFamilyCode,
            background: 'rgba(150, 150, 150, 0.1)',
            border: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} rgba(100, 100, 100, 0.2)`,
            borderRadius: 3
        },
        kbd: {
            margin: '0 0.2em',
            paddingInline: '0.4em',
            paddingBlock: '0.15em 0.1em',
            fontSize: '90%',
            fontFamily: token.fontFamilyCode,
            background: 'rgba(150, 150, 150, 0.06)',
            border: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} rgba(100, 100, 100, 0.2)`,
            borderBottomWidth: 2,
            borderRadius: 3
        },
        mark: {
            padding: 0,
            // FIXME hardcode in v4
            backgroundColor: (0, $37058c64b679ada5$export$c24201f7fe3571d8)[2]
        },
        'u, ins': {
            textDecoration: 'underline',
            textDecorationSkipInk: 'auto'
        },
        's, del': {
            textDecoration: 'line-through'
        },
        strong: {
            fontWeight: token.fontWeightStrong
        },
        // list
        'ul, ol': {
            marginInline: 0,
            marginBlock: '0 1em',
            padding: 0,
            li: {
                marginInline: '20px 0',
                marginBlock: 0,
                paddingInline: '4px 0',
                paddingBlock: 0
            }
        },
        ul: {
            listStyleType: 'circle',
            ul: {
                listStyleType: 'disc'
            }
        },
        ol: {
            listStyleType: 'decimal'
        },
        // pre & block
        'pre, blockquote': {
            margin: '1em 0'
        },
        pre: {
            padding: '0.4em 0.6em',
            whiteSpace: 'pre-wrap',
            wordWrap: 'break-word',
            background: 'rgba(150, 150, 150, 0.1)',
            border: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} rgba(100, 100, 100, 0.2)`,
            borderRadius: 3,
            fontFamily: token.fontFamilyCode,
            // Compatible for marked
            code: {
                display: 'inline',
                margin: 0,
                padding: 0,
                fontSize: 'inherit',
                fontFamily: 'inherit',
                background: 'transparent',
                border: 0
            }
        },
        blockquote: {
            paddingInline: '0.6em 0',
            paddingBlock: 0,
            borderInlineStart: '4px solid rgba(100, 100, 100, 0.2)',
            opacity: 0.85
        },
        // table - Follow Table component default style
        table: {
            width: '100%',
            textAlign: 'start',
            borderCollapse: 'separate',
            borderSpacing: 0,
            marginBlock: '1em',
            'th, td': {
                padding: (0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.padding),
                overflowWrap: 'break-word',
                borderBottom: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`
            },
            'thead > tr:first-child > th:first-child': {
                borderStartStartRadius: token.borderRadiusLG
            },
            'thead > tr:first-child > th:last-child': {
                borderStartEndRadius: token.borderRadiusLG
            },
            'thead > tr > th': {
                textAlign: 'start',
                position: 'relative',
                color: token.colorTextHeading,
                fontWeight: token.fontWeightStrong,
                backgroundColor: token.colorFillAlter,
                transition: `background-color ${token.motionDurationMid} ease`,
                '&:not(:last-child)::before': {
                    position: 'absolute',
                    top: '50%',
                    insetInlineEnd: 0,
                    width: 1,
                    height: '1.6em',
                    backgroundColor: token.colorSplit,
                    transform: 'translateY(-50%)',
                    content: '""'
                }
            },
            'tbody > tr': {
                '> th, > td': {
                    transition: `background-color ${token.motionDurationMid} ease`
                },
                '&:hover > th, &:hover > td': {
                    backgroundColor: token.colorFillAlter
                }
            }
        }
    });
const $7eaf8ca3e662a36a$export$2667badb03518972 = (token)=>{
    const { componentCls: componentCls, paddingSM: paddingSM } = token;
    const inputShift = paddingSM;
    return {
        '&-edit-content': {
            position: 'relative',
            'div&': {
                insetInlineStart: token.calc(token.paddingSM).mul(-1).equal(),
                insetBlockStart: token.calc(inputShift).div(-2).add(1).equal(),
                marginBottom: token.calc(inputShift).div(2).sub(2).equal()
            },
            [`${componentCls}-edit-content-confirm`]: {
                position: 'absolute',
                insetInlineEnd: token.calc(token.marginXS).add(2).equal(),
                insetBlockEnd: token.marginXS,
                color: token.colorIcon,
                // default style
                fontWeight: 400,
                fontSize: token.fontSize,
                fontStyle: 'normal',
                pointerEvents: 'none'
            },
            // Double the `-edit-content` class to raise this selector's specificity
            // above Input's own `textarea.ant-input { line-height: token.lineHeight }`
            // rule. Both otherwise share the same (0,1,1) specificity and Input is
            // injected after Typography, so on the raw TextArea path the Input rule
            // would win the cascade and the inherited font props below (notably
            // `line-height`) would not apply.
            [`&${componentCls}-edit-content textarea`]: {
                margin: '0!important',
                // Inherit the edited element's typography so the editing textarea
                // matches the rendered text (including customized heading tokens such
                // as `fontSizeHeading1` and the strong heading weight), keeping editing
                // WYSIWYG. Browsers do not inherit font properties for form controls by
                // default, so they are set explicitly here.
                fontSize: 'inherit',
                lineHeight: 'inherit',
                fontFamily: 'inherit',
                fontWeight: 'inherit',
                // Fix Editable Textarea flash in Firefox
                MozTransition: 'none',
                height: '1em'
            }
        }
    };
};
const $7eaf8ca3e662a36a$export$34755446404037a5 = (token)=>({
        [`${token.componentCls}-copy-success`]: {
            '&, &:hover, &:focus': {
                color: token.colorSuccess
            }
        },
        [`${token.componentCls}-copy-icon-only`]: {
            marginInlineStart: 0
        }
    });
const $7eaf8ca3e662a36a$export$d9556a50eba3003b = ()=>({
        'a&-ellipsis, span&-ellipsis': {
            display: 'inline-block',
            maxWidth: '100%'
        },
        '&-ellipsis-single-line': {
            ...(0, $cd5a520fee8002b4$export$b2b65df0d0824629),
            // https://blog.csdn.net/iefreer/article/details/50421025
            'a&, span&': {
                verticalAlign: 'bottom'
            },
            '> code': {
                paddingBlock: 0,
                maxWidth: 'calc(100% - 1.2em)',
                display: 'inline-block',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                verticalAlign: 'bottom',
                // https://github.com/ant-design/ant-design/issues/45953
                boxSizing: 'content-box'
            }
        },
        '&-ellipsis-multiple-line': {
            display: '-webkit-box',
            overflow: 'hidden',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical'
        }
    });


const $18ca6e0096c2af4d$var$genTypographyStyle = (token)=>{
    const { componentCls: componentCls, titleMarginTop: titleMarginTop } = token;
    return {
        [componentCls]: {
            color: token.colorText,
            wordBreak: 'break-word',
            lineHeight: token.lineHeight,
            [`&${componentCls}-secondary, &${componentCls}-link${componentCls}-secondary`]: {
                color: token.colorTextDescription
            },
            [`&${componentCls}-success, &${componentCls}-link${componentCls}-success`]: {
                color: token.colorSuccessText
            },
            [`&${componentCls}-warning, &${componentCls}-link${componentCls}-warning`]: {
                color: token.colorWarningText
            },
            [`&${componentCls}-danger, &${componentCls}-link${componentCls}-danger`]: {
                color: token.colorErrorText,
                [`&${componentCls}-link:active, &${componentCls}-link:focus`]: {
                    color: token.colorErrorTextActive
                },
                [`&${componentCls}-link:hover`]: {
                    color: token.colorErrorTextHover
                }
            },
            [`&${componentCls}-disabled`]: {
                color: token.colorTextDisabled,
                cursor: 'not-allowed',
                userSelect: 'none'
            },
            'div&, p': {
                marginBottom: '1em'
            },
            ...(0, $7eaf8ca3e662a36a$export$83146cf7d1bec659)(token),
            [`& + h1${componentCls}, & + h2${componentCls}, & + h3${componentCls}, & + h4${componentCls}, & + h5${componentCls}`]: {
                marginTop: titleMarginTop
            },
            'div, ul, li, p, h1, h2, h3, h4, h5': {
                '+ h1, + h2, + h3, + h4, + h5': {
                    marginTop: titleMarginTop
                }
            },
            ...(0, $7eaf8ca3e662a36a$export$977383a86f45014b)(token),
            ...(0, $7eaf8ca3e662a36a$export$566f4066c7caac18)(token),
            // Operation
            [`${componentCls}-actions`]: {
                display: 'inline'
            },
            [`
        ${componentCls}-expand,
        ${componentCls}-collapse,
        ${componentCls}-edit,
        ${componentCls}-copy
      `]: {
                ...(0, $cd5a520fee8002b4$export$9a16e7694a707ab4)(token),
                marginInlineStart: token.marginXXS
            },
            [`${componentCls}-actions-start`]: {
                [`
          ${componentCls}-expand,
          ${componentCls}-collapse,
          ${componentCls}-edit,
          ${componentCls}-copy:not(${componentCls}-copy-icon-only)
        `]: {
                    marginInlineStart: 0,
                    marginInlineEnd: token.marginXXS
                }
            },
            ...(0, $7eaf8ca3e662a36a$export$2667badb03518972)(token),
            ...(0, $7eaf8ca3e662a36a$export$34755446404037a5)(token),
            ...(0, $7eaf8ca3e662a36a$export$d9556a50eba3003b)(),
            '&-rtl': {
                direction: 'rtl'
            }
        }
    };
};
const $18ca6e0096c2af4d$export$9ca1be8807fe0675 = ()=>({
        titleMarginTop: '1.2em',
        titleMarginBottom: '0.5em'
    });
var // ============================== Export ==============================
$18ca6e0096c2af4d$export$2e2bcd8739ae039 = (0, $761caadb5301aee1$export$51ec95de45185b42)('Typography', $18ca6e0096c2af4d$var$genTypographyStyle, $18ca6e0096c2af4d$export$9ca1be8807fe0675);


"use client";
const $ef1e36e24f1f95b3$var$Editable = (props)=>{
    const { prefixCls: prefixCls, 'aria-label': ariaLabel, className: className, style: style, classNames: classNames, styles: styles, direction: direction, maxLength: maxLength, autoSize: autoSize = true, value: value, onSave: onSave, onCancel: onCancel, onEnd: onEnd, component: component, enterIcon: enterIcon = /*#__PURE__*/ $5E6i4.createElement((0, $7338c6d9e9b9cc58$export$2e2bcd8739ae039), null) } = props;
    const ref = $5E6i4.useRef(null);
    const inCompositionRef = $5E6i4.useRef(false);
    const lastKeyCodeRef = $5E6i4.useRef(null);
    const [current, setCurrent] = $5E6i4.useState(value);
    $5E6i4.useEffect(()=>{
        setCurrent(value);
    }, [
        value
    ]);
    $5E6i4.useEffect(()=>{
        if (ref.current?.resizableTextArea) {
            const { textArea: textArea } = ref.current.resizableTextArea;
            textArea.focus();
            const { length: length } = textArea.value;
            textArea.setSelectionRange(length, length);
        }
    }, []);
    const onChange = ({ target: target })=>{
        setCurrent(target.value.replace(/[\n\r]/g, ''));
    };
    const onCompositionStart = ()=>{
        inCompositionRef.current = true;
    };
    const onCompositionEnd = ()=>{
        inCompositionRef.current = false;
    };
    const onKeyDown = ({ keyCode: keyCode })=>{
        // We don't record keyCode when IME is using
        if (inCompositionRef.current) return;
        lastKeyCodeRef.current = keyCode;
    };
    const confirmChange = ()=>{
        onSave(current.trim());
    };
    const onKeyUp = ({ keyCode: keyCode, ctrlKey: ctrlKey, altKey: altKey, metaKey: metaKey, shiftKey: shiftKey })=>{
        // Check if it's a real key
        if (lastKeyCodeRef.current !== keyCode || inCompositionRef.current || ctrlKey || altKey || metaKey || shiftKey) return;
        if (keyCode === (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).ENTER) {
            confirmChange();
            onEnd?.();
        } else if (keyCode === (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).ESC) onCancel();
    };
    const onBlur = ()=>{
        confirmChange();
    };
    const [hashId, cssVarCls] = (0, $18ca6e0096c2af4d$export$2e2bcd8739ae039)(prefixCls);
    const textAreaClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-edit-content`, {
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-${component}`]: !!component
    }, className, classNames.root, hashId, cssVarCls);
    return /*#__PURE__*/ $5E6i4.createElement("div", {
        className: textAreaClassName,
        style: {
            ...styles.root,
            ...style
        }
    }, /*#__PURE__*/ $5E6i4.createElement((0, $5f40ac6a13c531df$export$2e2bcd8739ae039), {
        ref: ref,
        maxLength: maxLength,
        value: current,
        onChange: onChange,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onCompositionStart: onCompositionStart,
        onCompositionEnd: onCompositionEnd,
        onBlur: onBlur,
        "aria-label": ariaLabel,
        rows: 1,
        autoSize: autoSize,
        className: classNames.textarea,
        style: styles.textarea
    }), enterIcon !== null ? (0, $552e20b6ec4e63a6$export$e530037191fcd5d7)(enterIcon, {
        className: `${prefixCls}-edit-content-confirm`
    }) : null);
};
var $ef1e36e24f1f95b3$export$2e2bcd8739ae039 = $ef1e36e24f1f95b3$var$Editable;



var $5E6i4 = parcelRequire("5E6i4");


const $c6440ae52218eaf7$var$execCopy = (text, isHtmlFormat)=>{
    let copySuccess = false;
    const onCopy = (event)=>{
        event.stopPropagation();
        event.preventDefault();
        event.clipboardData?.clearData();
        event.clipboardData?.setData('text/plain', text);
        if (isHtmlFormat) event.clipboardData?.setData('text/html', text);
        copySuccess = true;
    };
    try {
        document.addEventListener('copy', onCopy, {
            capture: true
        });
        document.execCommand('copy');
        return copySuccess;
    } catch  {
        return false;
    } finally{
        document.removeEventListener('copy', onCopy, {
            capture: true
        });
    }
};
const $c6440ae52218eaf7$var$asyncCopy = async (text, isHtmlFormat)=>{
    try {
        if (isHtmlFormat) await navigator.clipboard.write([
            new ClipboardItem({
                'text/html': new Blob([
                    text
                ], {
                    type: 'text/html'
                }),
                'text/plain': new Blob([
                    text
                ], {
                    type: 'text/plain'
                })
            })
        ]);
        else await navigator.clipboard.writeText(text);
        return true;
    } catch  {
        return false;
    }
};
async function $c6440ae52218eaf7$var$copy(text, config) {
    if (typeof text !== 'string') return false;
    const isHtmlFormat = config?.format === 'text/html';
    if (await $c6440ae52218eaf7$var$asyncCopy(text, isHtmlFormat)) return true;
    if ($c6440ae52218eaf7$var$execCopy(text, isHtmlFormat)) return true;
    return false;
}
var $c6440ae52218eaf7$export$2e2bcd8739ae039 = $c6440ae52218eaf7$var$copy;




const $e4634557ccd94b34$var$toList = (val, config = {})=>{
    if (!(0, $b63de2b9864a5d1a$export$826fff653a329e83)(val) && config?.skipEmpty) return [];
    return Array.isArray(val) ? val : [
        val
    ];
};
var $e4634557ccd94b34$export$2e2bcd8739ae039 = $e4634557ccd94b34$var$toList;


const $425af3883c06c10c$var$useCopyClick = ({ copyConfig: copyConfig, children: children })=>{
    const [copied, setCopied] = (0, $2114fb66f76f632e$export$2e2bcd8739ae039)(false);
    const [copyLoading, setCopyLoading] = $5E6i4.useState(false);
    const copyOptions = {};
    if (copyConfig.format) copyOptions.format = copyConfig.format;
    // Keep copy action up to date
    const onClick = (0, $68990f4402d2f009$export$2e2bcd8739ae039)(async (e)=>{
        e?.preventDefault();
        e?.stopPropagation();
        setCopyLoading(true);
        try {
            const text = (0, $addbc2fddcbb77a9$export$f6e2535fb5126e54)(copyConfig.text) ? await copyConfig.text() : copyConfig.text;
            await (0, $c6440ae52218eaf7$export$2e2bcd8739ae039)(text || (0, $e4634557ccd94b34$export$2e2bcd8739ae039)(children, {
                skipEmpty: true
            }).join('') || '', copyOptions);
            setCopyLoading(false);
            setCopied(true, true);
            // Trigger tips update
            setCopied(false, {
                ms: 3000
            });
            copyConfig.onCopy?.(e);
        } catch (error) {
            setCopyLoading(false);
            throw error;
        }
    });
    return {
        copied: copied,
        copyLoading: copyLoading,
        onClick: onClick
    };
};
var $425af3883c06c10c$export$2e2bcd8739ae039 = $425af3883c06c10c$var$useCopyClick;



var $5E6i4 = parcelRequire("5E6i4");

const $9c61dd59860a1733$var$useMergedConfig = (propConfig, templateConfig)=>{
    const support = Boolean(propConfig);
    return $5E6i4.useMemo(()=>{
        const config = {
            ...templateConfig,
            ...support && (0, $addbc2fddcbb77a9$export$53b83ca8eaab0383)(propConfig) ? propConfig : null
        };
        return [
            support,
            config
        ];
    }, [
        support,
        propConfig,
        templateConfig
    ]);
};
var $9c61dd59860a1733$export$2e2bcd8739ae039 = $9c61dd59860a1733$var$useMergedConfig;



var $5E6i4 = parcelRequire("5E6i4");
const $aaf79fd1e5956b33$var$usePrevious = (value)=>{
    const ref = (0, $5E6i4.useRef)(undefined);
    (0, $5E6i4.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
};
var $aaf79fd1e5956b33$export$2e2bcd8739ae039 = $aaf79fd1e5956b33$var$usePrevious;



var $5E6i4 = parcelRequire("5E6i4");

const $de08b92016b185f9$var$useTooltipProps = (tooltip, editConfigText, children)=>(0, $5E6i4.useMemo)(()=>{
        if (tooltip === true) return {
            title: editConfigText ?? children
        };
        if (/*#__PURE__*/ (0, $5E6i4.isValidElement)(tooltip)) return {
            title: tooltip
        };
        if ((0, $addbc2fddcbb77a9$export$53b83ca8eaab0383)(tooltip)) return {
            title: editConfigText ?? children,
            ...tooltip
        };
        return {
            title: tooltip
        };
    }, [
        tooltip,
        editConfigText,
        children
    ]);
var $de08b92016b185f9$export$2e2bcd8739ae039 = $de08b92016b185f9$var$useTooltipProps;



var $5E6i4 = parcelRequire("5E6i4");


const $13e5d97dd61cab42$export$b5d9abe3479853dc = (customizePrefixCls, classNames, styles, typographyDirection, props)=>{
    const { getPrefixCls: getPrefixCls, direction: contextDirection, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $519f2fad435b3034$export$46f4bd6436a25a31)('typography');
    const direction = typographyDirection ?? contextDirection;
    const prefixCls = getPrefixCls('typography', customizePrefixCls);
    const mergedProps = {
        ...props,
        prefixCls: prefixCls,
        direction: direction
    };
    const contextClassNamesObject = (0, $5E6i4.useMemo)(()=>({
            root: contextClassName
        }), [
        contextClassName
    ]);
    const contextStyleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(contextStyle);
    const [mergedClassNames, mergedStyles] = (0, $722c8632ba7bdb89$export$648566b068f28737)([
        contextClassNamesObject,
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles
    ], {
        props: mergedProps
    });
    return [
        mergedClassNames,
        mergedStyles,
        prefixCls,
        direction
    ];
};



var $5E6i4 = parcelRequire("5E6i4");



"use client";
const $4eb6ce847f0b7f1d$export$eb9bd2b66ef4fd8d = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { component: Component = 'article', className: className, rootClassName: rootClassName, children: children, direction: direction, style: style, classNames: classNames, styles: styles, prefixCls: prefixCls, ...restProps } = props;
    const [hashId, cssVarCls] = (0, $18ca6e0096c2af4d$export$2e2bcd8739ae039)(prefixCls);
    const componentClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, {
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, className, rootClassName, hashId, cssVarCls, classNames?.root);
    const mergedStyle = {
        ...styles?.root,
        ...style
    };
    return /*#__PURE__*/ $5E6i4.createElement(Component, {
        ...restProps,
        className: componentClassName,
        style: mergedStyle,
        ref: ref
    }, children);
});
const $4eb6ce847f0b7f1d$var$Typography = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, direction: typographyDirection, classNames: classNames, styles: styles, ...restProps } = props;
    const [mergedClassNames, mergedStyles, mergedPrefixCls, mergedDirection] = (0, $13e5d97dd61cab42$export$b5d9abe3479853dc)(customizePrefixCls, classNames, styles, typographyDirection, props);
    return /*#__PURE__*/ $5E6i4.createElement($4eb6ce847f0b7f1d$export$eb9bd2b66ef4fd8d, {
        ref: ref,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(className, rootClassName),
        direction: mergedDirection,
        classNames: mergedClassNames,
        styles: mergedStyles,
        prefixCls: mergedPrefixCls,
        ...restProps
    });
});
var $4eb6ce847f0b7f1d$export$2e2bcd8739ae039 = $4eb6ce847f0b7f1d$var$Typography;



var $5E6i4 = parcelRequire("5E6i4");


var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $10cdb80d0cb318f4$var$CopyOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z"
                }
            }
        ]
    },
    "name": "copy",
    "theme": "outlined"
};
var $10cdb80d0cb318f4$export$2e2bcd8739ae039 = $10cdb80d0cb318f4$var$CopyOutlined;



function $bf74679de6219ea9$var$_extends() {
    $bf74679de6219ea9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bf74679de6219ea9$var$_extends.apply(this, arguments);
}
const $bf74679de6219ea9$var$CopyOutlined = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $bf74679de6219ea9$var$_extends({}, props, {
        ref: ref,
        icon: (0, $10cdb80d0cb318f4$export$2e2bcd8739ae039)
    }));
/**![copy](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTgzMiA2NEgyOTZjLTQuNCAwLTggMy42LTggOHY1NmMwIDQuNCAzLjYgOCA4IDhoNDk2djY4OGMwIDQuNCAzLjYgOCA4IDhoNTZjNC40IDAgOC0zLjYgOC04Vjk2YzAtMTcuNy0xNC4zLTMyLTMyLTMyek03MDQgMTkySDE5MmMtMTcuNyAwLTMyIDE0LjMtMzIgMzJ2NTMwLjdjMCA4LjUgMy40IDE2LjYgOS40IDIyLjZsMTczLjMgMTczLjNjMi4yIDIuMiA0LjcgNCA3LjQgNS41djEuOWg0LjJjMy41IDEuMyA3LjIgMiAxMSAySDcwNGMxNy43IDAgMzItMTQuMyAzMi0zMlYyMjRjMC0xNy43LTE0LjMtMzItMzItMzJ6TTM1MCA4NTYuMkwyNjMuOSA3NzBIMzUwdjg2LjJ6TTY2NCA4ODhINDE0Vjc0NmMwLTIyLjEtMTcuOS00MC00MC00MEgyMzJWMjY0aDQzMnY2MjR6IiAvPjwvc3ZnPg==) */ const $bf74679de6219ea9$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($bf74679de6219ea9$var$CopyOutlined);
var $bf74679de6219ea9$export$2e2bcd8739ae039 = $bf74679de6219ea9$var$RefIcon;






const $fb316a6b2d1fea1d$export$54c946ade31abb75 = (val)=>{
    if (val === false) return [
        false,
        false
    ];
    return (0, $e4634557ccd94b34$export$2e2bcd8739ae039)(val);
};
function $fb316a6b2d1fea1d$export$3f778c4e796a1f9c(dom, defaultNode, needDom) {
    if (dom === true || dom === undefined) return defaultNode;
    return dom || needDom && defaultNode;
}
function $fb316a6b2d1fea1d$export$5714fcf57d9d6988(ele) {
    // Create a new div to get the size
    const childDiv = document.createElement('em');
    ele.appendChild(childDiv);
    const rect = ele.getBoundingClientRect();
    const childRect = childDiv.getBoundingClientRect();
    // Reset
    ele.removeChild(childDiv);
    // Range checker
    return(// Horizontal out of range
    rect.left > childRect.left || childRect.right > rect.right || // Vertical out of range
    rect.top > childRect.top || childRect.bottom > rect.bottom);
}
const $fb316a6b2d1fea1d$export$a748c1acb7702f51 = (val)=>[
        'string',
        'number'
    ].includes(typeof val);


"use client";
const $b9e474eaa3716fb7$var$CopyBtn = (props)=>{
    const { prefixCls: prefixCls, copied: copied, locale: locale, iconOnly: iconOnly, tooltips: tooltips, icon: icon, tabIndex: tabIndex, onCopy: onCopy, loading: btnLoading, className: className, style: style } = props;
    const tooltipNodes = (0, $fb316a6b2d1fea1d$export$54c946ade31abb75)(tooltips);
    const iconNodes = (0, $fb316a6b2d1fea1d$export$54c946ade31abb75)(icon);
    const { copied: copiedText, copy: copyText } = locale ?? {};
    const systemStr = copied ? copiedText : copyText;
    const copyTitle = (0, $fb316a6b2d1fea1d$export$3f778c4e796a1f9c)(tooltipNodes[copied ? 1 : 0], systemStr);
    const ariaLabel = typeof copyTitle === 'string' ? copyTitle : systemStr;
    return /*#__PURE__*/ $5E6i4.createElement((0, $1bb718ecb5669b36$export$2e2bcd8739ae039), {
        title: copyTitle
    }, /*#__PURE__*/ $5E6i4.createElement("button", {
        type: "button",
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-copy`, className, {
            [`${prefixCls}-copy-success`]: copied,
            [`${prefixCls}-copy-icon-only`]: iconOnly
        }),
        style: style,
        onClick: onCopy,
        "aria-label": ariaLabel,
        tabIndex: tabIndex
    }, copied ? (0, $fb316a6b2d1fea1d$export$3f778c4e796a1f9c)(iconNodes[1], /*#__PURE__*/ $5E6i4.createElement((0, $9eb4119242359573$export$2e2bcd8739ae039), null), true) : (0, $fb316a6b2d1fea1d$export$3f778c4e796a1f9c)(iconNodes[0], btnLoading ? /*#__PURE__*/ $5E6i4.createElement((0, $6e3183dc0ea574da$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $5E6i4.createElement((0, $bf74679de6219ea9$export$2e2bcd8739ae039), null), true)));
};
var $b9e474eaa3716fb7$export$2e2bcd8739ae039 = $b9e474eaa3716fb7$var$CopyBtn;




var $5E6i4 = parcelRequire("5E6i4");


"use client";
const $bde8b77274c15ca9$var$MeasureText = /*#__PURE__*/ $5E6i4.forwardRef(({ style: style, children: children }, ref)=>{
    const spanRef = $5E6i4.useRef(null);
    $5E6i4.useImperativeHandle(ref, ()=>({
            isExceed: ()=>{
                const span = spanRef.current;
                return span.scrollHeight > span.clientHeight;
            },
            getHeight: ()=>spanRef.current.clientHeight
        }));
    return /*#__PURE__*/ $5E6i4.createElement("span", {
        "aria-hidden": true,
        ref: spanRef,
        style: {
            position: 'fixed',
            display: 'block',
            left: 0,
            top: 0,
            pointerEvents: 'none',
            backgroundColor: 'rgba(255, 0, 0, 0.65)',
            ...style
        }
    }, children);
});
const $bde8b77274c15ca9$var$getNodesLen = (nodeList)=>nodeList.reduce((totalLen, node)=>totalLen + ((0, $fb316a6b2d1fea1d$export$a748c1acb7702f51)(node) ? String(node).length : 1), 0);
function $bde8b77274c15ca9$var$sliceNodes(nodeList, len) {
    let currLen = 0;
    const currentNodeList = [];
    for(let i = 0; i < nodeList.length; i += 1){
        // Match to return
        if (currLen === len) return currentNodeList;
        const node = nodeList[i];
        const canCut = (0, $fb316a6b2d1fea1d$export$a748c1acb7702f51)(node);
        const nodeLen = canCut ? String(node).length : 1;
        const nextLen = currLen + nodeLen;
        // Exceed but current not which means we need cut this
        // This will not happen on validate ReactElement
        if (nextLen > len) {
            const restLen = len - currLen;
            currentNodeList.push(String(node).slice(0, restLen));
            return currentNodeList;
        }
        currentNodeList.push(node);
        currLen = nextLen;
    }
    return nodeList;
}
// Measure for the `text` is exceed the `rows` or not
const $bde8b77274c15ca9$var$STATUS_MEASURE_NONE = 0;
const $bde8b77274c15ca9$var$STATUS_MEASURE_PREPARE = 1;
const $bde8b77274c15ca9$var$STATUS_MEASURE_START = 2;
const $bde8b77274c15ca9$var$STATUS_MEASURE_NEED_ELLIPSIS = 3;
const $bde8b77274c15ca9$var$STATUS_MEASURE_NO_NEED_ELLIPSIS = 4;
const $bde8b77274c15ca9$var$lineClipStyle = {
    display: '-webkit-box',
    overflow: 'hidden',
    WebkitBoxOrient: 'vertical'
};
function $bde8b77274c15ca9$export$2e2bcd8739ae039(props) {
    const { enableMeasure: enableMeasure, width: width, text: text, children: children, rows: rows, expanded: expanded, measureDeps: measureDeps, miscDeps: miscDeps, onEllipsis: onEllipsis } = props;
    const nodeList = $5E6i4.useMemo(()=>(0, $2ec1a2166f2295ea$export$2e2bcd8739ae039)(text), [
        text
    ]);
    const nodeLen = $5E6i4.useMemo(()=>$bde8b77274c15ca9$var$getNodesLen(nodeList), [
        text
    ]);
    // ========================= Full Content =========================
    // Used for measure only, which means it's always render as no need ellipsis
    const fullContent = $5E6i4.useMemo(()=>children(nodeList, false), [
        text
    ].concat((0, $0acfae8147afe964$export$2e2bcd8739ae039)(measureDeps)));
    // ========================= Cut Content ==========================
    const [ellipsisCutIndex, setEllipsisCutIndex] = $5E6i4.useState(null);
    const cutMidRef = $5E6i4.useRef(null);
    // ========================= NeedEllipsis =========================
    const measureWhiteSpaceRef = $5E6i4.useRef(null);
    const needEllipsisRef = $5E6i4.useRef(null);
    // Measure for `rows-1` height, to avoid operation exceed the line height
    const descRowsEllipsisRef = $5E6i4.useRef(null);
    const symbolRowEllipsisRef = $5E6i4.useRef(null);
    const [canEllipsis, setCanEllipsis] = $5E6i4.useState(false);
    const [needEllipsis, setNeedEllipsis] = $5E6i4.useState($bde8b77274c15ca9$var$STATUS_MEASURE_NONE);
    const [ellipsisHeight, setEllipsisHeight] = $5E6i4.useState(0);
    const [parentWhiteSpace, setParentWhiteSpace] = $5E6i4.useState(null);
    // Trigger start measure
    (0, $518ae471aa4f03a7$export$2e2bcd8739ae039)(()=>{
        if (enableMeasure && width && nodeLen) setNeedEllipsis($bde8b77274c15ca9$var$STATUS_MEASURE_PREPARE);
        else setNeedEllipsis($bde8b77274c15ca9$var$STATUS_MEASURE_NONE);
    }, [
        width,
        text,
        rows,
        enableMeasure,
        nodeList
    ].concat((0, $0acfae8147afe964$export$2e2bcd8739ae039)(measureDeps)));
    // Measure process
    (0, $518ae471aa4f03a7$export$2e2bcd8739ae039)(()=>{
        if (needEllipsis === $bde8b77274c15ca9$var$STATUS_MEASURE_PREPARE) {
            setNeedEllipsis($bde8b77274c15ca9$var$STATUS_MEASURE_START);
            // Parent ref `white-space`
            const nextWhiteSpace = measureWhiteSpaceRef.current && getComputedStyle(measureWhiteSpaceRef.current).whiteSpace;
            setParentWhiteSpace(nextWhiteSpace);
        } else if (needEllipsis === $bde8b77274c15ca9$var$STATUS_MEASURE_START) {
            const isOverflow = !!needEllipsisRef.current?.isExceed();
            setNeedEllipsis(isOverflow ? $bde8b77274c15ca9$var$STATUS_MEASURE_NEED_ELLIPSIS : $bde8b77274c15ca9$var$STATUS_MEASURE_NO_NEED_ELLIPSIS);
            setEllipsisCutIndex(isOverflow ? [
                0,
                nodeLen
            ] : null);
            setCanEllipsis(isOverflow);
            // Get the basic height of ellipsis rows
            const baseRowsEllipsisHeight = needEllipsisRef.current?.getHeight() || 0;
            // Get the height of `rows - 1` + symbol height
            const descRowsEllipsisHeight = rows === 1 ? 0 : descRowsEllipsisRef.current?.getHeight() || 0;
            const symbolRowEllipsisHeight = symbolRowEllipsisRef.current?.getHeight() || 0;
            const maxRowsHeight = Math.max(baseRowsEllipsisHeight, // height of rows with ellipsis
            descRowsEllipsisHeight + symbolRowEllipsisHeight);
            setEllipsisHeight(maxRowsHeight + 1);
            onEllipsis(isOverflow);
        }
    }, [
        needEllipsis
    ]);
    // ========================= Cut Measure ==========================
    const cutMidIndex = ellipsisCutIndex ? Math.ceil((ellipsisCutIndex[0] + ellipsisCutIndex[1]) / 2) : 0;
    (0, $518ae471aa4f03a7$export$2e2bcd8739ae039)(()=>{
        const [minIndex, maxIndex] = ellipsisCutIndex || [
            0,
            0
        ];
        if (minIndex !== maxIndex) {
            const midHeight = cutMidRef.current?.getHeight() || 0;
            const isOverflow = midHeight > ellipsisHeight;
            let targetMidIndex = cutMidIndex;
            if (maxIndex - minIndex === 1) targetMidIndex = isOverflow ? minIndex : maxIndex;
            setEllipsisCutIndex(isOverflow ? [
                minIndex,
                targetMidIndex
            ] : [
                targetMidIndex,
                maxIndex
            ]);
        }
    }, [
        ellipsisCutIndex,
        cutMidIndex
    ]);
    // ========================= Text Content =========================
    const finalContent = $5E6i4.useMemo(()=>{
        // Skip everything if `enableMeasure` is disabled
        if (!enableMeasure) return children(nodeList, false);
        if (needEllipsis !== $bde8b77274c15ca9$var$STATUS_MEASURE_NEED_ELLIPSIS || !ellipsisCutIndex || ellipsisCutIndex[0] !== ellipsisCutIndex[1]) {
            const content = children(nodeList, false);
            // Limit the max line count to avoid scrollbar blink unless no need ellipsis
            // https://github.com/ant-design/ant-design/issues/42958
            if ([
                $bde8b77274c15ca9$var$STATUS_MEASURE_NO_NEED_ELLIPSIS,
                $bde8b77274c15ca9$var$STATUS_MEASURE_NONE
            ].includes(needEllipsis)) return content;
            return /*#__PURE__*/ $5E6i4.createElement("span", {
                style: {
                    ...$bde8b77274c15ca9$var$lineClipStyle,
                    WebkitLineClamp: rows
                }
            }, content);
        }
        return children(expanded ? nodeList : $bde8b77274c15ca9$var$sliceNodes(nodeList, ellipsisCutIndex[0]), canEllipsis);
    }, [
        expanded,
        needEllipsis,
        ellipsisCutIndex,
        nodeList
    ].concat((0, $0acfae8147afe964$export$2e2bcd8739ae039)(miscDeps)));
    // ============================ Render ============================
    const measureStyle = {
        width: width,
        margin: 0,
        padding: 0,
        whiteSpace: parentWhiteSpace === 'nowrap' ? 'normal' : 'inherit'
    };
    return /*#__PURE__*/ $5E6i4.createElement($5E6i4.Fragment, null, finalContent, needEllipsis === $bde8b77274c15ca9$var$STATUS_MEASURE_START && /*#__PURE__*/ $5E6i4.createElement($5E6i4.Fragment, null, /*#__PURE__*/ $5E6i4.createElement($bde8b77274c15ca9$var$MeasureText, {
        style: {
            ...measureStyle,
            ...$bde8b77274c15ca9$var$lineClipStyle,
            WebkitLineClamp: rows
        },
        ref: needEllipsisRef
    }, fullContent), /*#__PURE__*/ $5E6i4.createElement($bde8b77274c15ca9$var$MeasureText, {
        style: {
            ...measureStyle,
            ...$bde8b77274c15ca9$var$lineClipStyle,
            WebkitLineClamp: rows - 1
        },
        ref: descRowsEllipsisRef
    }, fullContent), /*#__PURE__*/ $5E6i4.createElement($bde8b77274c15ca9$var$MeasureText, {
        style: {
            ...measureStyle,
            ...$bde8b77274c15ca9$var$lineClipStyle,
            WebkitLineClamp: 1
        },
        ref: symbolRowEllipsisRef
    }, children([], true))), needEllipsis === $bde8b77274c15ca9$var$STATUS_MEASURE_NEED_ELLIPSIS && ellipsisCutIndex && ellipsisCutIndex[0] !== ellipsisCutIndex[1] && /*#__PURE__*/ $5E6i4.createElement($bde8b77274c15ca9$var$MeasureText, {
        style: {
            ...measureStyle,
            top: 400
        },
        ref: cutMidRef
    }, children($bde8b77274c15ca9$var$sliceNodes(nodeList, cutMidIndex), true)), needEllipsis === $bde8b77274c15ca9$var$STATUS_MEASURE_PREPARE && /*#__PURE__*/ $5E6i4.createElement("span", {
        style: {
            whiteSpace: 'inherit'
        },
        ref: measureWhiteSpaceRef
    }));
}



var $5E6i4 = parcelRequire("5E6i4");

"use client";
const $6db715de728eabee$var$EllipsisTooltip = ({ enableEllipsis: enableEllipsis, isEllipsis: isEllipsis, disabled: disabled, children: children, tooltipProps: tooltipProps })=>{
    if (!tooltipProps?.title || !enableEllipsis) return children;
    return /*#__PURE__*/ $5E6i4.createElement((0, $1bb718ecb5669b36$export$2e2bcd8739ae039), {
        ...tooltipProps,
        disabled: !isEllipsis || disabled
    }, children);
};
var $6db715de728eabee$export$2e2bcd8739ae039 = $6db715de728eabee$var$EllipsisTooltip;



"use client";
function $f605876bae21f52a$var$wrapperDecorations({ mark: mark, code: code, underline: underline, delete: del, strong: strong, keyboard: keyboard, italic: italic }, content) {
    let currentContent = content;
    function wrap(tag, needed) {
        if (!needed) return;
        currentContent = /*#__PURE__*/ $5E6i4.createElement(tag, {}, currentContent);
    }
    wrap('strong', strong);
    wrap('u', underline);
    wrap('del', del);
    wrap('code', code);
    wrap('mark', mark);
    wrap('kbd', keyboard);
    wrap('i', italic);
    return currentContent;
}
const $f605876bae21f52a$var$ELLIPSIS_STR = '...';
const $f605876bae21f52a$var$DECORATION_PROPS = [
    'delete',
    'mark',
    'code',
    'underline',
    'strong',
    'keyboard',
    'italic'
];
const $f605876bae21f52a$var$Base = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, className: className, style: style, classNames: classNames, styles: styles, direction: typographyDirection, type: type, disabled: disabled, children: children, ellipsis: ellipsis, editable: editable, copyable: copyable, actions: actions, component: component, title: title, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, ...restProps } = props;
    const [textLocale] = (0, $a2f3e1f88973a5e2$export$2e2bcd8739ae039)('Text');
    const typographyRef = $5E6i4.useRef(null);
    const editIconRef = $5E6i4.useRef(null);
    const [mergedClassNames, mergedStyles, prefixCls, direction] = (0, $13e5d97dd61cab42$export$b5d9abe3479853dc)(customizePrefixCls, classNames, styles, typographyDirection, props);
    const textProps = (0, $48bd91d9f828de66$export$2e2bcd8739ae039)(restProps, $f605876bae21f52a$var$DECORATION_PROPS);
    // ========================== Editable ==========================
    const [enableEdit, editConfig] = (0, $9c61dd59860a1733$export$2e2bcd8739ae039)(editable);
    const [editing, setEditing] = (0, $e18df22f16a16360$export$2e2bcd8739ae039)(false, editConfig.editing);
    const { triggerType: triggerType = [
        'icon'
    ] } = editConfig;
    const triggerEdit = (edit)=>{
        if (edit) editConfig.onStart?.();
        setEditing(edit);
    };
    // Focus edit icon when back
    const prevEditing = (0, $aaf79fd1e5956b33$export$2e2bcd8739ae039)(editing);
    (0, $518ae471aa4f03a7$export$2e2bcd8739ae039)(()=>{
        if (!editing && prevEditing) editIconRef.current?.focus();
    }, [
        editing
    ]);
    const onEditClick = (e)=>{
        e?.preventDefault();
        triggerEdit(true);
    };
    const onEditChange = (value)=>{
        editConfig.onChange?.(value);
        triggerEdit(false);
    };
    const onEditCancel = ()=>{
        editConfig.onCancel?.();
        triggerEdit(false);
    };
    // ========================== Copyable ==========================
    const [enableCopy, copyConfig] = (0, $9c61dd59860a1733$export$2e2bcd8739ae039)(copyable);
    const { placement: placement = 'end' } = actions ?? {};
    const { copied: copied, copyLoading: copyLoading, onClick: onCopyClick } = (0, $425af3883c06c10c$export$2e2bcd8739ae039)({
        copyConfig: copyConfig,
        children: children
    });
    // ========================== Ellipsis ==========================
    const [isLineClampSupport, setIsLineClampSupport] = $5E6i4.useState(false);
    const [isTextOverflowSupport, setIsTextOverflowSupport] = $5E6i4.useState(false);
    const [isJsEllipsis, setIsJsEllipsis] = $5E6i4.useState(false);
    const [isNativeEllipsis, setIsNativeEllipsis] = $5E6i4.useState(false);
    const [isNativeVisible, setIsNativeVisible] = $5E6i4.useState(true);
    const [enableEllipsis, ellipsisConfig] = (0, $9c61dd59860a1733$export$2e2bcd8739ae039)(ellipsis, {
        expandable: false,
        symbol: (isExpanded)=>isExpanded ? textLocale?.collapse : textLocale?.expand
    });
    const [expanded, setExpanded] = (0, $e18df22f16a16360$export$2e2bcd8739ae039)(ellipsisConfig.defaultExpanded || false, ellipsisConfig.expanded);
    const mergedEnableEllipsis = enableEllipsis && (!expanded || ellipsisConfig.expandable === 'collapsible');
    // Shared prop to reduce bundle size
    const { rows: rows = 1 } = ellipsisConfig;
    const needMeasureEllipsis = $5E6i4.useMemo(()=>// Disable ellipsis
        mergedEnableEllipsis && // Provide suffix
        (ellipsisConfig.suffix !== undefined || ellipsisConfig.onEllipsis || // Can't use css ellipsis since we need to provide the place for button
        ellipsisConfig.expandable || enableEdit || enableCopy), [
        mergedEnableEllipsis,
        ellipsisConfig,
        enableEdit,
        enableCopy
    ]);
    (0, $518ae471aa4f03a7$export$2e2bcd8739ae039)(()=>{
        if (enableEllipsis && !needMeasureEllipsis) {
            setIsLineClampSupport((0, $bc5e191b379ba96f$export$d616d7831008e86c)('webkitLineClamp'));
            setIsTextOverflowSupport((0, $bc5e191b379ba96f$export$d616d7831008e86c)('textOverflow'));
        }
    }, [
        needMeasureEllipsis,
        enableEllipsis
    ]);
    const [cssEllipsis, setCssEllipsis] = $5E6i4.useState(mergedEnableEllipsis);
    const canUseCssEllipsis = $5E6i4.useMemo(()=>{
        if (needMeasureEllipsis) return false;
        if (rows === 1) return isTextOverflowSupport;
        return isLineClampSupport;
    }, [
        needMeasureEllipsis,
        rows,
        isLineClampSupport,
        isTextOverflowSupport
    ]);
    // We use effect to change from css ellipsis to js ellipsis.
    // To make SSR still can see the ellipsis.
    (0, $518ae471aa4f03a7$export$2e2bcd8739ae039)(()=>{
        setCssEllipsis(canUseCssEllipsis && mergedEnableEllipsis);
    }, [
        canUseCssEllipsis,
        mergedEnableEllipsis
    ]);
    const tooltipProps = (0, $de08b92016b185f9$export$2e2bcd8739ae039)(ellipsisConfig.tooltip, editConfig.text, children);
    const needNativeEllipsisMeasure = cssEllipsis && !!tooltipProps.title;
    const isMergedEllipsis = mergedEnableEllipsis && (cssEllipsis ? needNativeEllipsisMeasure && isNativeEllipsis : isJsEllipsis);
    const cssTextOverflow = mergedEnableEllipsis && rows === 1 && cssEllipsis;
    const cssLineClamp = mergedEnableEllipsis && rows > 1 && cssEllipsis;
    // >>>>> Expand
    const onExpandClick = (e, info)=>{
        setExpanded(info.expanded);
        ellipsisConfig.onExpand?.(e, info);
    };
    const [ellipsisWidth, setEllipsisWidth] = $5E6i4.useState(0);
    const [isHoveringOperations, setIsHoveringOperations] = (0, $2114fb66f76f632e$export$2e2bcd8739ae039)(false);
    const isHoveringTypographyRef = $5E6i4.useRef(false);
    const onResize = ({ offsetWidth: offsetWidth })=>{
        setEllipsisWidth(offsetWidth);
    };
    // >>>>> JS Ellipsis
    const onJsEllipsis = (jsEllipsis)=>{
        setIsJsEllipsis(jsEllipsis);
        // Trigger if changed
        if (isJsEllipsis !== jsEllipsis) ellipsisConfig.onEllipsis?.(jsEllipsis);
    };
    // >>>>> Native ellipsis
    const measureNativeEllipsis = $5E6i4.useCallback(()=>{
        const textEle = typographyRef.current;
        if (enableEllipsis && needNativeEllipsisMeasure && textEle) {
            const currentEllipsis = (0, $fb316a6b2d1fea1d$export$5714fcf57d9d6988)(textEle);
            setIsNativeEllipsis((prev)=>prev === currentEllipsis ? prev : currentEllipsis);
        }
    }, [
        enableEllipsis,
        needNativeEllipsisMeasure
    ]);
    // Keep the result current while the Typography is hovered, but do not force every
    // Typography instance to read layout during a bulk render or resize.
    $5E6i4.useEffect(()=>{
        if (isHoveringTypographyRef.current) measureNativeEllipsis();
    }, [
        measureNativeEllipsis,
        children,
        cssLineClamp,
        isNativeVisible,
        ellipsisWidth
    ]);
    // https://github.com/ant-design/ant-design/issues/36786
    // Use IntersectionObserver to check if element is invisible
    $5E6i4.useEffect(()=>{
        const textEle = typographyRef.current;
        if (typeof IntersectionObserver === 'undefined' || !textEle || !needNativeEllipsisMeasure || !mergedEnableEllipsis) return;
        const observer = new IntersectionObserver(()=>{
            setIsNativeVisible(!!textEle.offsetParent);
        });
        observer.observe(textEle);
        return ()=>{
            observer.disconnect();
        };
    }, [
        needNativeEllipsisMeasure,
        mergedEnableEllipsis
    ]);
    // ========================== Tooltip ===========================
    const topAriaLabel = $5E6i4.useMemo(()=>{
        if (!enableEllipsis || cssEllipsis) return undefined;
        return [
            editConfig.text,
            children,
            title,
            tooltipProps.title
        ].find((0, $fb316a6b2d1fea1d$export$a748c1acb7702f51));
    }, [
        enableEllipsis,
        cssEllipsis,
        title,
        tooltipProps.title,
        isMergedEllipsis,
        editConfig.text
    ]);
    // =========================== Render ===========================
    // >>>>>>>>>>> Editing input
    if (editing) return /*#__PURE__*/ $5E6i4.createElement((0, $ef1e36e24f1f95b3$export$2e2bcd8739ae039), {
        value: editConfig.text ?? (typeof children === 'string' ? children : ''),
        onSave: onEditChange,
        onCancel: onEditCancel,
        onEnd: editConfig.onEnd,
        prefixCls: prefixCls,
        className: className,
        style: style,
        direction: direction,
        component: component,
        maxLength: editConfig.maxLength,
        autoSize: editConfig.autoSize,
        enterIcon: editConfig.enterIcon,
        classNames: mergedClassNames,
        styles: mergedStyles
    });
    // >>>>>>>>>>> Typography
    // Expand
    const renderExpand = ()=>{
        const { expandable: expandable, symbol: symbol } = ellipsisConfig;
        return expandable ? /*#__PURE__*/ $5E6i4.createElement("button", {
            type: "button",
            key: "expand",
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-${expanded ? 'collapse' : 'expand'}`, mergedClassNames.action),
            style: mergedStyles.action,
            onClick: (e)=>onExpandClick(e, {
                    expanded: !expanded
                }),
            "aria-label": expanded ? textLocale.collapse : textLocale?.expand
        }, (0, $addbc2fddcbb77a9$export$f6e2535fb5126e54)(symbol) ? symbol(expanded) : symbol) : null;
    };
    // Edit
    const renderEdit = ()=>{
        if (!enableEdit) return;
        const { icon: icon, tooltip: tooltip, tabIndex: tabIndex } = editConfig;
        const editTitle = (0, $2ec1a2166f2295ea$export$2e2bcd8739ae039)(tooltip)[0] || textLocale?.edit;
        const ariaLabel = typeof editTitle === 'string' ? editTitle : '';
        return triggerType.includes('icon') ? /*#__PURE__*/ $5E6i4.createElement((0, $1bb718ecb5669b36$export$2e2bcd8739ae039), {
            key: "edit",
            title: tooltip === false ? '' : editTitle
        }, /*#__PURE__*/ $5E6i4.createElement("button", {
            type: "button",
            ref: editIconRef,
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-edit`, mergedClassNames.action),
            style: mergedStyles.action,
            onClick: onEditClick,
            "aria-label": ariaLabel,
            tabIndex: tabIndex
        }, icon || /*#__PURE__*/ $5E6i4.createElement((0, $a5a7c3d0277b871b$export$2e2bcd8739ae039), {
            role: "button"
        }))) : null;
    };
    // Copy
    const renderCopy = ()=>{
        if (!enableCopy) return null;
        return /*#__PURE__*/ $5E6i4.createElement((0, $b9e474eaa3716fb7$export$2e2bcd8739ae039), {
            key: "copy",
            ...copyConfig,
            prefixCls: prefixCls,
            copied: copied,
            locale: textLocale,
            onCopy: onCopyClick,
            loading: copyLoading,
            iconOnly: !(0, $b63de2b9864a5d1a$export$72280d5f896dac9a)(children),
            className: mergedClassNames.action,
            style: mergedStyles.action
        });
    };
    const renderOperations = (canEllipsis)=>{
        const expandNode = canEllipsis && renderExpand();
        const editNode = renderEdit();
        const copyNode = renderCopy();
        if (!expandNode && !editNode && !copyNode) return null;
        return /*#__PURE__*/ $5E6i4.createElement("span", {
            key: "operations",
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-actions`, mergedClassNames.actions, {
                [`${prefixCls}-actions-start`]: placement === 'start'
            }),
            style: mergedStyles.actions,
            onMouseEnter: ()=>setIsHoveringOperations(true, true),
            onMouseLeave: ()=>setIsHoveringOperations(false, {
                    // Delay 500ms for better user experience
                    ms: 500
                })
        }, expandNode, editNode, copyNode);
    };
    const renderEllipsis = (canEllipsis)=>[
            canEllipsis && !expanded && /*#__PURE__*/ $5E6i4.createElement("span", {
                "aria-hidden": true,
                key: "ellipsis"
            }, $f605876bae21f52a$var$ELLIPSIS_STR),
            ellipsisConfig.suffix
        ];
    return /*#__PURE__*/ $5E6i4.createElement((0, $3a396118caae8741$export$2e2bcd8739ae039), {
        onResize: onResize,
        disabled: !mergedEnableEllipsis
    }, (resizeRef)=>/*#__PURE__*/ $5E6i4.createElement((0, $6db715de728eabee$export$2e2bcd8739ae039), {
            tooltipProps: tooltipProps,
            enableEllipsis: mergedEnableEllipsis,
            isEllipsis: isMergedEllipsis,
            disabled: isHoveringOperations
        }, /*#__PURE__*/ $5E6i4.createElement((0, $4eb6ce847f0b7f1d$export$eb9bd2b66ef4fd8d), {
            onMouseEnter: (e)=>{
                isHoveringTypographyRef.current = true;
                measureNativeEllipsis();
                onMouseEnter?.(e);
            },
            onMouseLeave: (e)=>{
                isHoveringTypographyRef.current = false;
                onMouseLeave?.(e);
            },
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)({
                [`${prefixCls}-${type}`]: type,
                [`${prefixCls}-disabled`]: disabled,
                [`${prefixCls}-ellipsis`]: enableEllipsis,
                [`${prefixCls}-ellipsis-single-line`]: cssTextOverflow,
                [`${prefixCls}-ellipsis-multiple-line`]: cssLineClamp,
                [`${prefixCls}-link`]: component === 'a'
            }, className),
            classNames: mergedClassNames,
            styles: mergedStyles,
            prefixCls: prefixCls,
            style: {
                ...style,
                WebkitLineClamp: cssLineClamp ? rows : undefined
            },
            component: component,
            ref: (0, $92c8c75386168ffc$export$ab452c34e8e05029)(resizeRef, typographyRef, ref),
            direction: direction,
            onClick: (e)=>{
                if (triggerType.includes('text')) onEditClick(e);
                onClick?.(e);
            },
            "aria-label": topAriaLabel?.toString(),
            title: title,
            ...textProps
        }, /*#__PURE__*/ $5E6i4.createElement((0, $bde8b77274c15ca9$export$2e2bcd8739ae039), {
            enableMeasure: mergedEnableEllipsis && !cssEllipsis,
            text: children,
            rows: rows,
            width: ellipsisWidth,
            onEllipsis: onJsEllipsis,
            expanded: expanded,
            measureDeps: [
                placement
            ],
            miscDeps: [
                copied,
                expanded,
                copyLoading,
                enableEdit,
                enableCopy,
                placement,
                textLocale
            ].concat((0, $0acfae8147afe964$export$2e2bcd8739ae039)($f605876bae21f52a$var$DECORATION_PROPS.map((key)=>props[key])))
        }, (node, canEllipsis)=>$f605876bae21f52a$var$wrapperDecorations(props, /*#__PURE__*/ $5E6i4.createElement($5E6i4.Fragment, null, placement === 'start' ? renderOperations(canEllipsis) : null, node.length > 0 && canEllipsis && !expanded && topAriaLabel ? /*#__PURE__*/ $5E6i4.createElement("span", {
                key: "show-content",
                "aria-hidden": true
            }, node) : node, renderEllipsis(canEllipsis), placement === 'start' ? null : renderOperations(canEllipsis)))))));
});
var $f605876bae21f52a$export$2e2bcd8739ae039 = $f605876bae21f52a$var$Base;


"use client";
const $8e1fd4b167aab42e$var$Link = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { ellipsis: ellipsis, rel: rel, children: children, // @ts-expect-error: https://github.com/ant-design/ant-design/issues/26622
    navigate: _navigate, ...restProps } = props;
    const mergedProps = {
        ...restProps,
        rel: rel === undefined && restProps.target === '_blank' ? 'noopener noreferrer' : rel
    };
    return /*#__PURE__*/ $5E6i4.createElement((0, $f605876bae21f52a$export$2e2bcd8739ae039), {
        ...mergedProps,
        ref: ref,
        ellipsis: !!ellipsis,
        component: "a"
    }, children);
});
var $8e1fd4b167aab42e$export$2e2bcd8739ae039 = $8e1fd4b167aab42e$var$Link;



var $5E6i4 = parcelRequire("5E6i4");

"use client";
const $fd535ca70e1e3813$var$Paragraph = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { children: children, ...restProps } = props;
    return /*#__PURE__*/ $5E6i4.createElement((0, $f605876bae21f52a$export$2e2bcd8739ae039), {
        ref: ref,
        ...restProps,
        component: "div"
    }, children);
});
var $fd535ca70e1e3813$export$2e2bcd8739ae039 = $fd535ca70e1e3813$var$Paragraph;



var $5E6i4 = parcelRequire("5E6i4");




"use client";
const $f4d578017edc194d$var$Text = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { ellipsis: ellipsis, children: children, ...restProps } = props;
    const mergedEllipsis = $5E6i4.useMemo(()=>{
        if ((0, $addbc2fddcbb77a9$export$53b83ca8eaab0383)(ellipsis)) return (0, $48bd91d9f828de66$export$2e2bcd8739ae039)(ellipsis, [
            'expandable',
            'rows'
        ]);
        return ellipsis;
    }, [
        ellipsis
    ]);
    return /*#__PURE__*/ $5E6i4.createElement((0, $f605876bae21f52a$export$2e2bcd8739ae039), {
        ref: ref,
        ...restProps,
        ellipsis: mergedEllipsis,
        component: "span"
    }, children);
});
var $f4d578017edc194d$export$2e2bcd8739ae039 = $f4d578017edc194d$var$Text;



var $5E6i4 = parcelRequire("5E6i4");


"use client";
const $1d176dc0153ba815$var$TITLE_ELE_LIST = [
    1,
    2,
    3,
    4,
    5
];
const $1d176dc0153ba815$var$Title = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { level: level = 1, children: children, ...restProps } = props;
    const component = $1d176dc0153ba815$var$TITLE_ELE_LIST.includes(level) ? `h${level}` : `h1`;
    return /*#__PURE__*/ $5E6i4.createElement((0, $f605876bae21f52a$export$2e2bcd8739ae039), {
        ref: ref,
        ...restProps,
        component: component
    }, children);
});
var $1d176dc0153ba815$export$2e2bcd8739ae039 = $1d176dc0153ba815$var$Title;



"use client";
const $1356cdf58e4737d7$var$Typography = (0, $4eb6ce847f0b7f1d$export$2e2bcd8739ae039);
$1356cdf58e4737d7$var$Typography.Text = (0, $f4d578017edc194d$export$2e2bcd8739ae039);
$1356cdf58e4737d7$var$Typography.Link = (0, $8e1fd4b167aab42e$export$2e2bcd8739ae039);
$1356cdf58e4737d7$var$Typography.Title = (0, $1d176dc0153ba815$export$2e2bcd8739ae039);
$1356cdf58e4737d7$var$Typography.Paragraph = (0, $fd535ca70e1e3813$export$2e2bcd8739ae039);
var $1356cdf58e4737d7$export$2e2bcd8739ae039 = $1356cdf58e4737d7$var$Typography;



var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");
var $c8d725e5ba719c3a$exports = {};
'use strict';
Object.defineProperty($c8d725e5ba719c3a$exports, "__esModule", {
    value: true
});
$c8d725e5ba719c3a$exports.ReactCSS = $c8d725e5ba719c3a$exports.loop = $c8d725e5ba719c3a$exports.handleActive = $c8d725e5ba719c3a$exports.handleHover = $c8d725e5ba719c3a$exports.hover = undefined;
var $9bfa1597487f0a02$exports = {};
'use strict';
Object.defineProperty($9bfa1597487f0a02$exports, "__esModule", {
    value: true
});
$9bfa1597487f0a02$exports.flattenNames = undefined;
var $239c7b245137daad$exports = {};

var $hxQbQ = parcelRequire("hxQbQ");

var $fSG8F = parcelRequire("fSG8F");

var $hemqo = parcelRequire("hemqo");
/** `Object#toString` result references. */ var $239c7b245137daad$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $239c7b245137daad$var$isString(value) {
    return typeof value == 'string' || !$fSG8F(value) && $hemqo(value) && $hxQbQ(value) == $239c7b245137daad$var$stringTag;
}
$239c7b245137daad$exports = $239c7b245137daad$var$isString;


var $9bfa1597487f0a02$var$_isString3 = $9bfa1597487f0a02$var$_interopRequireDefault($239c7b245137daad$exports);
var $e9b6c25470173b5b$exports = {};

var $4inKO = parcelRequire("4inKO");

var $4hbJJ = parcelRequire("4hbJJ");
/**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $e9b6c25470173b5b$var$forOwn(object, iteratee) {
    return object && $4inKO(object, $4hbJJ(iteratee));
}
$e9b6c25470173b5b$exports = $e9b6c25470173b5b$var$forOwn;


var $9bfa1597487f0a02$var$_forOwn3 = $9bfa1597487f0a02$var$_interopRequireDefault($e9b6c25470173b5b$exports);
var $dce598c76c6fa79c$exports = {};

var $hxQbQ = parcelRequire("hxQbQ");
var $477ffd831213a9db$exports = {};

var $lCxZh = parcelRequire("lCxZh");
/** Built-in value references. */ var $477ffd831213a9db$var$getPrototype = $lCxZh(Object.getPrototypeOf, Object);
$477ffd831213a9db$exports = $477ffd831213a9db$var$getPrototype;



var $hemqo = parcelRequire("hemqo");
/** `Object#toString` result references. */ var $dce598c76c6fa79c$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $dce598c76c6fa79c$var$funcProto = Function.prototype, $dce598c76c6fa79c$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $dce598c76c6fa79c$var$funcToString = $dce598c76c6fa79c$var$funcProto.toString;
/** Used to check objects for own properties. */ var $dce598c76c6fa79c$var$hasOwnProperty = $dce598c76c6fa79c$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $dce598c76c6fa79c$var$objectCtorString = $dce598c76c6fa79c$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $dce598c76c6fa79c$var$isPlainObject(value) {
    if (!$hemqo(value) || $hxQbQ(value) != $dce598c76c6fa79c$var$objectTag) return false;
    var proto = $477ffd831213a9db$exports(value);
    if (proto === null) return true;
    var Ctor = $dce598c76c6fa79c$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $dce598c76c6fa79c$var$funcToString.call(Ctor) == $dce598c76c6fa79c$var$objectCtorString;
}
$dce598c76c6fa79c$exports = $dce598c76c6fa79c$var$isPlainObject;


var $9bfa1597487f0a02$var$_isPlainObject3 = $9bfa1597487f0a02$var$_interopRequireDefault($dce598c76c6fa79c$exports);
var $60735b838bcba5a1$exports = {};
var $f2f47bab3766be64$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $f2f47bab3766be64$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$f2f47bab3766be64$exports = $f2f47bab3766be64$var$arrayMap;


var $e96f8385e2145e24$exports = {};
var $eb1aa91b1762d83a$exports = {};
var $271b5acd65f18f15$exports = {};
var $94d303896d62668a$exports = {};
var $35da48e08e9a349a$exports = {};
var $57f9050bfc9b1b80$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $57f9050bfc9b1b80$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$57f9050bfc9b1b80$exports = $57f9050bfc9b1b80$var$listCacheClear;


var $e0732c20885a4822$exports = {};
var $028d8494c233069e$exports = {};
var $f99e04e5a327d734$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $f99e04e5a327d734$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$f99e04e5a327d734$exports = $f99e04e5a327d734$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $028d8494c233069e$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($f99e04e5a327d734$exports(array[length][0], key)) return length;
    }
    return -1;
}
$028d8494c233069e$exports = $028d8494c233069e$var$assocIndexOf;


/** Used for built-in method references. */ var $e0732c20885a4822$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $e0732c20885a4822$var$splice = $e0732c20885a4822$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $e0732c20885a4822$var$listCacheDelete(key) {
    var data = this.__data__, index = $028d8494c233069e$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $e0732c20885a4822$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$e0732c20885a4822$exports = $e0732c20885a4822$var$listCacheDelete;


var $9314ea006c26ecab$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $9314ea006c26ecab$var$listCacheGet(key) {
    var data = this.__data__, index = $028d8494c233069e$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$9314ea006c26ecab$exports = $9314ea006c26ecab$var$listCacheGet;


var $43828f1b132ea93e$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $43828f1b132ea93e$var$listCacheHas(key) {
    return $028d8494c233069e$exports(this.__data__, key) > -1;
}
$43828f1b132ea93e$exports = $43828f1b132ea93e$var$listCacheHas;


var $4170187bbc25e163$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $4170187bbc25e163$var$listCacheSet(key, value) {
    var data = this.__data__, index = $028d8494c233069e$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$4170187bbc25e163$exports = $4170187bbc25e163$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $35da48e08e9a349a$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$35da48e08e9a349a$var$ListCache.prototype.clear = $57f9050bfc9b1b80$exports;
$35da48e08e9a349a$var$ListCache.prototype['delete'] = $e0732c20885a4822$exports;
$35da48e08e9a349a$var$ListCache.prototype.get = $9314ea006c26ecab$exports;
$35da48e08e9a349a$var$ListCache.prototype.has = $43828f1b132ea93e$exports;
$35da48e08e9a349a$var$ListCache.prototype.set = $4170187bbc25e163$exports;
$35da48e08e9a349a$exports = $35da48e08e9a349a$var$ListCache;


var $6cd8a5cf94a5f8e1$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $6cd8a5cf94a5f8e1$var$stackClear() {
    this.__data__ = new $35da48e08e9a349a$exports;
    this.size = 0;
}
$6cd8a5cf94a5f8e1$exports = $6cd8a5cf94a5f8e1$var$stackClear;


var $c716238803a7ce27$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $c716238803a7ce27$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
$c716238803a7ce27$exports = $c716238803a7ce27$var$stackDelete;


var $cf2a11b6806fe496$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $cf2a11b6806fe496$var$stackGet(key) {
    return this.__data__.get(key);
}
$cf2a11b6806fe496$exports = $cf2a11b6806fe496$var$stackGet;


var $fbf02988a5246b9e$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $fbf02988a5246b9e$var$stackHas(key) {
    return this.__data__.has(key);
}
$fbf02988a5246b9e$exports = $fbf02988a5246b9e$var$stackHas;


var $06827a4ccb5d826d$exports = {};

var $2ef77f178988c2a9$exports = {};
var $d139d2e71c9648ac$exports = {};
var $e483421f021d0d5f$exports = {};

var $8NZGN = parcelRequire("8NZGN");
var $58fa7837f049ac98$exports = {};
var $bf187f2c11d16386$exports = {};

var $cxIyV = parcelRequire("cxIyV");
/** Used to detect overreaching core-js shims. */ var $bf187f2c11d16386$var$coreJsData = $cxIyV["__core-js_shared__"];
$bf187f2c11d16386$exports = $bf187f2c11d16386$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $58fa7837f049ac98$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($bf187f2c11d16386$exports && $bf187f2c11d16386$exports.keys && $bf187f2c11d16386$exports.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $58fa7837f049ac98$var$isMasked(func) {
    return !!$58fa7837f049ac98$var$maskSrcKey && $58fa7837f049ac98$var$maskSrcKey in func;
}
$58fa7837f049ac98$exports = $58fa7837f049ac98$var$isMasked;



var $fFfYm = parcelRequire("fFfYm");
var $ab798ffd2b879d64$exports = {};
/** Used for built-in method references. */ var $ab798ffd2b879d64$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $ab798ffd2b879d64$var$funcToString = $ab798ffd2b879d64$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $ab798ffd2b879d64$var$toSource(func) {
    if (func != null) {
        try {
            return $ab798ffd2b879d64$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
$ab798ffd2b879d64$exports = $ab798ffd2b879d64$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $e483421f021d0d5f$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $e483421f021d0d5f$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $e483421f021d0d5f$var$funcProto = Function.prototype, $e483421f021d0d5f$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $e483421f021d0d5f$var$funcToString = $e483421f021d0d5f$var$funcProto.toString;
/** Used to check objects for own properties. */ var $e483421f021d0d5f$var$hasOwnProperty = $e483421f021d0d5f$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $e483421f021d0d5f$var$reIsNative = RegExp('^' + $e483421f021d0d5f$var$funcToString.call($e483421f021d0d5f$var$hasOwnProperty).replace($e483421f021d0d5f$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $e483421f021d0d5f$var$baseIsNative(value) {
    if (!$fFfYm(value) || $58fa7837f049ac98$exports(value)) return false;
    var pattern = $8NZGN(value) ? $e483421f021d0d5f$var$reIsNative : $e483421f021d0d5f$var$reIsHostCtor;
    return pattern.test($ab798ffd2b879d64$exports(value));
}
$e483421f021d0d5f$exports = $e483421f021d0d5f$var$baseIsNative;


var $7102d39d71844405$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $7102d39d71844405$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$7102d39d71844405$exports = $7102d39d71844405$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $d139d2e71c9648ac$var$getNative(object, key) {
    var value = $7102d39d71844405$exports(object, key);
    return $e483421f021d0d5f$exports(value) ? value : undefined;
}
$d139d2e71c9648ac$exports = $d139d2e71c9648ac$var$getNative;



var $cxIyV = parcelRequire("cxIyV");
/* Built-in method references that are verified to be native. */ var $2ef77f178988c2a9$var$Map = $d139d2e71c9648ac$exports($cxIyV, 'Map');
$2ef77f178988c2a9$exports = $2ef77f178988c2a9$var$Map;


var $d4f702305322972d$exports = {};
var $f2cd06e78c7d1f3f$exports = {};
var $12932e73f85f9d0f$exports = {};
var $26390fde236a9d12$exports = {};
var $41649f8f1dc9b500$exports = {};

/* Built-in method references that are verified to be native. */ var $41649f8f1dc9b500$var$nativeCreate = $d139d2e71c9648ac$exports(Object, 'create');
$41649f8f1dc9b500$exports = $41649f8f1dc9b500$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $26390fde236a9d12$var$hashClear() {
    this.__data__ = $41649f8f1dc9b500$exports ? $41649f8f1dc9b500$exports(null) : {};
    this.size = 0;
}
$26390fde236a9d12$exports = $26390fde236a9d12$var$hashClear;


var $7105a928cf386258$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $7105a928cf386258$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$7105a928cf386258$exports = $7105a928cf386258$var$hashDelete;


var $29f212206a2cb5a1$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $29f212206a2cb5a1$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $29f212206a2cb5a1$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $29f212206a2cb5a1$var$hasOwnProperty = $29f212206a2cb5a1$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $29f212206a2cb5a1$var$hashGet(key) {
    var data = this.__data__;
    if ($41649f8f1dc9b500$exports) {
        var result = data[key];
        return result === $29f212206a2cb5a1$var$HASH_UNDEFINED ? undefined : result;
    }
    return $29f212206a2cb5a1$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$29f212206a2cb5a1$exports = $29f212206a2cb5a1$var$hashGet;


var $dc3c6540c458f31b$exports = {};

/** Used for built-in method references. */ var $dc3c6540c458f31b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dc3c6540c458f31b$var$hasOwnProperty = $dc3c6540c458f31b$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $dc3c6540c458f31b$var$hashHas(key) {
    var data = this.__data__;
    return $41649f8f1dc9b500$exports ? data[key] !== undefined : $dc3c6540c458f31b$var$hasOwnProperty.call(data, key);
}
$dc3c6540c458f31b$exports = $dc3c6540c458f31b$var$hashHas;


var $a42de6488a4108d1$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $a42de6488a4108d1$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $a42de6488a4108d1$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $41649f8f1dc9b500$exports && value === undefined ? $a42de6488a4108d1$var$HASH_UNDEFINED : value;
    return this;
}
$a42de6488a4108d1$exports = $a42de6488a4108d1$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $12932e73f85f9d0f$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$12932e73f85f9d0f$var$Hash.prototype.clear = $26390fde236a9d12$exports;
$12932e73f85f9d0f$var$Hash.prototype['delete'] = $7105a928cf386258$exports;
$12932e73f85f9d0f$var$Hash.prototype.get = $29f212206a2cb5a1$exports;
$12932e73f85f9d0f$var$Hash.prototype.has = $dc3c6540c458f31b$exports;
$12932e73f85f9d0f$var$Hash.prototype.set = $a42de6488a4108d1$exports;
$12932e73f85f9d0f$exports = $12932e73f85f9d0f$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $f2cd06e78c7d1f3f$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $12932e73f85f9d0f$exports,
        'map': new ($2ef77f178988c2a9$exports || $35da48e08e9a349a$exports),
        'string': new $12932e73f85f9d0f$exports
    };
}
$f2cd06e78c7d1f3f$exports = $f2cd06e78c7d1f3f$var$mapCacheClear;


var $37aa2d8aafd45c8a$exports = {};
var $f63e435ddccf31fe$exports = {};
var $818484af5abc6117$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $818484af5abc6117$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
$818484af5abc6117$exports = $818484af5abc6117$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $f63e435ddccf31fe$var$getMapData(map, key) {
    var data = map.__data__;
    return $818484af5abc6117$exports(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
$f63e435ddccf31fe$exports = $f63e435ddccf31fe$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $37aa2d8aafd45c8a$var$mapCacheDelete(key) {
    var result = $f63e435ddccf31fe$exports(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
$37aa2d8aafd45c8a$exports = $37aa2d8aafd45c8a$var$mapCacheDelete;


var $ab35fc84f88abd88$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $ab35fc84f88abd88$var$mapCacheGet(key) {
    return $f63e435ddccf31fe$exports(this, key).get(key);
}
$ab35fc84f88abd88$exports = $ab35fc84f88abd88$var$mapCacheGet;


var $91cfda215c6cbfd3$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $91cfda215c6cbfd3$var$mapCacheHas(key) {
    return $f63e435ddccf31fe$exports(this, key).has(key);
}
$91cfda215c6cbfd3$exports = $91cfda215c6cbfd3$var$mapCacheHas;


var $521d2bdb33227dcc$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $521d2bdb33227dcc$var$mapCacheSet(key, value) {
    var data = $f63e435ddccf31fe$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$521d2bdb33227dcc$exports = $521d2bdb33227dcc$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $d4f702305322972d$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$d4f702305322972d$var$MapCache.prototype.clear = $f2cd06e78c7d1f3f$exports;
$d4f702305322972d$var$MapCache.prototype['delete'] = $37aa2d8aafd45c8a$exports;
$d4f702305322972d$var$MapCache.prototype.get = $ab35fc84f88abd88$exports;
$d4f702305322972d$var$MapCache.prototype.has = $91cfda215c6cbfd3$exports;
$d4f702305322972d$var$MapCache.prototype.set = $521d2bdb33227dcc$exports;
$d4f702305322972d$exports = $d4f702305322972d$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $06827a4ccb5d826d$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $06827a4ccb5d826d$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $35da48e08e9a349a$exports) {
        var pairs = data.__data__;
        if (!$2ef77f178988c2a9$exports || pairs.length < $06827a4ccb5d826d$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $d4f702305322972d$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$06827a4ccb5d826d$exports = $06827a4ccb5d826d$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $94d303896d62668a$var$Stack(entries) {
    var data = this.__data__ = new $35da48e08e9a349a$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$94d303896d62668a$var$Stack.prototype.clear = $6cd8a5cf94a5f8e1$exports;
$94d303896d62668a$var$Stack.prototype['delete'] = $c716238803a7ce27$exports;
$94d303896d62668a$var$Stack.prototype.get = $cf2a11b6806fe496$exports;
$94d303896d62668a$var$Stack.prototype.has = $fbf02988a5246b9e$exports;
$94d303896d62668a$var$Stack.prototype.set = $06827a4ccb5d826d$exports;
$94d303896d62668a$exports = $94d303896d62668a$var$Stack;


var $a237166ee29225a3$exports = {};
var $0794cbabf3530ee0$exports = {};

var $32560ce7d6132760$exports = {};
var $e4680efffa27a929$exports = {};

var $fb2c6776f6044957$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $fb2c6776f6044957$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $fb2c6776f6044957$var$setCacheAdd(value) {
    this.__data__.set(value, $fb2c6776f6044957$var$HASH_UNDEFINED);
    return this;
}
$fb2c6776f6044957$exports = $fb2c6776f6044957$var$setCacheAdd;


var $1e7bccb028d84152$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */ function $1e7bccb028d84152$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$1e7bccb028d84152$exports = $1e7bccb028d84152$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $e4680efffa27a929$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $d4f702305322972d$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$e4680efffa27a929$var$SetCache.prototype.add = $e4680efffa27a929$var$SetCache.prototype.push = $fb2c6776f6044957$exports;
$e4680efffa27a929$var$SetCache.prototype.has = $1e7bccb028d84152$exports;
$e4680efffa27a929$exports = $e4680efffa27a929$var$SetCache;


var $26e469ce8876d958$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $26e469ce8876d958$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$26e469ce8876d958$exports = $26e469ce8876d958$var$arraySome;


var $0c707c2df2e0d243$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $0c707c2df2e0d243$var$cacheHas(cache, key) {
    return cache.has(key);
}
$0c707c2df2e0d243$exports = $0c707c2df2e0d243$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $32560ce7d6132760$var$COMPARE_PARTIAL_FLAG = 1, $32560ce7d6132760$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $32560ce7d6132760$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $32560ce7d6132760$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $32560ce7d6132760$var$COMPARE_UNORDERED_FLAG ? new $e4680efffa27a929$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$26e469ce8876d958$exports(other, function(othValue, othIndex) {
                if (!$0c707c2df2e0d243$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
$32560ce7d6132760$exports = $32560ce7d6132760$var$equalArrays;


var $9338bb4bedddfebc$exports = {};

var $cT2ec = parcelRequire("cT2ec");
var $4949feb6464de9ec$exports = {};

var $cxIyV = parcelRequire("cxIyV");
/** Built-in value references. */ var $4949feb6464de9ec$var$Uint8Array = $cxIyV.Uint8Array;
$4949feb6464de9ec$exports = $4949feb6464de9ec$var$Uint8Array;




var $e1ac46d36446a74d$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $e1ac46d36446a74d$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$e1ac46d36446a74d$exports = $e1ac46d36446a74d$var$mapToArray;


var $4a2295d0087ab8a8$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $4a2295d0087ab8a8$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$4a2295d0087ab8a8$exports = $4a2295d0087ab8a8$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $9338bb4bedddfebc$var$COMPARE_PARTIAL_FLAG = 1, $9338bb4bedddfebc$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $9338bb4bedddfebc$var$boolTag = '[object Boolean]', $9338bb4bedddfebc$var$dateTag = '[object Date]', $9338bb4bedddfebc$var$errorTag = '[object Error]', $9338bb4bedddfebc$var$mapTag = '[object Map]', $9338bb4bedddfebc$var$numberTag = '[object Number]', $9338bb4bedddfebc$var$regexpTag = '[object RegExp]', $9338bb4bedddfebc$var$setTag = '[object Set]', $9338bb4bedddfebc$var$stringTag = '[object String]', $9338bb4bedddfebc$var$symbolTag = '[object Symbol]';
var $9338bb4bedddfebc$var$arrayBufferTag = '[object ArrayBuffer]', $9338bb4bedddfebc$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $9338bb4bedddfebc$var$symbolProto = $cT2ec ? $cT2ec.prototype : undefined, $9338bb4bedddfebc$var$symbolValueOf = $9338bb4bedddfebc$var$symbolProto ? $9338bb4bedddfebc$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $9338bb4bedddfebc$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $9338bb4bedddfebc$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $9338bb4bedddfebc$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $4949feb6464de9ec$exports(object), new $4949feb6464de9ec$exports(other))) return false;
            return true;
        case $9338bb4bedddfebc$var$boolTag:
        case $9338bb4bedddfebc$var$dateTag:
        case $9338bb4bedddfebc$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $f99e04e5a327d734$exports(+object, +other);
        case $9338bb4bedddfebc$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $9338bb4bedddfebc$var$regexpTag:
        case $9338bb4bedddfebc$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $9338bb4bedddfebc$var$mapTag:
            var convert = $e1ac46d36446a74d$exports;
        case $9338bb4bedddfebc$var$setTag:
            var isPartial = bitmask & $9338bb4bedddfebc$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $4a2295d0087ab8a8$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $9338bb4bedddfebc$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $32560ce7d6132760$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $9338bb4bedddfebc$var$symbolTag:
            if ($9338bb4bedddfebc$var$symbolValueOf) return $9338bb4bedddfebc$var$symbolValueOf.call(object) == $9338bb4bedddfebc$var$symbolValueOf.call(other);
    }
    return false;
}
$9338bb4bedddfebc$exports = $9338bb4bedddfebc$var$equalByTag;


var $6bfef1d1c11441ab$exports = {};
var $9afd71f0d3c7859c$exports = {};
var $c0989f99f96befc2$exports = {};
var $a82343f118641bc5$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $a82343f118641bc5$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$a82343f118641bc5$exports = $a82343f118641bc5$var$arrayPush;



var $fSG8F = parcelRequire("fSG8F");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $c0989f99f96befc2$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $fSG8F(object) ? result : $a82343f118641bc5$exports(result, symbolsFunc(object));
}
$c0989f99f96befc2$exports = $c0989f99f96befc2$var$baseGetAllKeys;


var $c79b5dac738d14ee$exports = {};
var $935ad4117c7eae59$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $935ad4117c7eae59$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$935ad4117c7eae59$exports = $935ad4117c7eae59$var$arrayFilter;


var $2f11c4caba214559$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $2f11c4caba214559$var$stubArray() {
    return [];
}
$2f11c4caba214559$exports = $2f11c4caba214559$var$stubArray;


/** Used for built-in method references. */ var $c79b5dac738d14ee$var$objectProto = Object.prototype;
/** Built-in value references. */ var $c79b5dac738d14ee$var$propertyIsEnumerable = $c79b5dac738d14ee$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $c79b5dac738d14ee$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $c79b5dac738d14ee$var$getSymbols = !$c79b5dac738d14ee$var$nativeGetSymbols ? $2f11c4caba214559$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $935ad4117c7eae59$exports($c79b5dac738d14ee$var$nativeGetSymbols(object), function(symbol) {
        return $c79b5dac738d14ee$var$propertyIsEnumerable.call(object, symbol);
    });
};
$c79b5dac738d14ee$exports = $c79b5dac738d14ee$var$getSymbols;



var $3LPLJ = parcelRequire("3LPLJ");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $9afd71f0d3c7859c$var$getAllKeys(object) {
    return $c0989f99f96befc2$exports(object, $3LPLJ, $c79b5dac738d14ee$exports);
}
$9afd71f0d3c7859c$exports = $9afd71f0d3c7859c$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $6bfef1d1c11441ab$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $6bfef1d1c11441ab$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $6bfef1d1c11441ab$var$hasOwnProperty = $6bfef1d1c11441ab$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $6bfef1d1c11441ab$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $6bfef1d1c11441ab$var$COMPARE_PARTIAL_FLAG, objProps = $9afd71f0d3c7859c$exports(object), objLength = objProps.length, othProps = $9afd71f0d3c7859c$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $6bfef1d1c11441ab$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
$6bfef1d1c11441ab$exports = $6bfef1d1c11441ab$var$equalObjects;


var $27fff0c742d61ae2$exports = {};
var $637a8a0a42f4e5cf$exports = {};


var $cxIyV = parcelRequire("cxIyV");
/* Built-in method references that are verified to be native. */ var $637a8a0a42f4e5cf$var$DataView = $d139d2e71c9648ac$exports($cxIyV, 'DataView');
$637a8a0a42f4e5cf$exports = $637a8a0a42f4e5cf$var$DataView;



var $acf6e581bff01fef$exports = {};


var $cxIyV = parcelRequire("cxIyV");
/* Built-in method references that are verified to be native. */ var $acf6e581bff01fef$var$Promise = $d139d2e71c9648ac$exports($cxIyV, 'Promise');
$acf6e581bff01fef$exports = $acf6e581bff01fef$var$Promise;


var $8c9ee126279b9015$exports = {};


var $cxIyV = parcelRequire("cxIyV");
/* Built-in method references that are verified to be native. */ var $8c9ee126279b9015$var$Set = $d139d2e71c9648ac$exports($cxIyV, 'Set');
$8c9ee126279b9015$exports = $8c9ee126279b9015$var$Set;


var $0f252975f69388f7$exports = {};


var $cxIyV = parcelRequire("cxIyV");
/* Built-in method references that are verified to be native. */ var $0f252975f69388f7$var$WeakMap = $d139d2e71c9648ac$exports($cxIyV, 'WeakMap');
$0f252975f69388f7$exports = $0f252975f69388f7$var$WeakMap;



var $hxQbQ = parcelRequire("hxQbQ");

/** `Object#toString` result references. */ var $27fff0c742d61ae2$var$mapTag = '[object Map]', $27fff0c742d61ae2$var$objectTag = '[object Object]', $27fff0c742d61ae2$var$promiseTag = '[object Promise]', $27fff0c742d61ae2$var$setTag = '[object Set]', $27fff0c742d61ae2$var$weakMapTag = '[object WeakMap]';
var $27fff0c742d61ae2$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $27fff0c742d61ae2$var$dataViewCtorString = $ab798ffd2b879d64$exports($637a8a0a42f4e5cf$exports), $27fff0c742d61ae2$var$mapCtorString = $ab798ffd2b879d64$exports($2ef77f178988c2a9$exports), $27fff0c742d61ae2$var$promiseCtorString = $ab798ffd2b879d64$exports($acf6e581bff01fef$exports), $27fff0c742d61ae2$var$setCtorString = $ab798ffd2b879d64$exports($8c9ee126279b9015$exports), $27fff0c742d61ae2$var$weakMapCtorString = $ab798ffd2b879d64$exports($0f252975f69388f7$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $27fff0c742d61ae2$var$getTag = $hxQbQ;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($637a8a0a42f4e5cf$exports && $27fff0c742d61ae2$var$getTag(new $637a8a0a42f4e5cf$exports(new ArrayBuffer(1))) != $27fff0c742d61ae2$var$dataViewTag || $2ef77f178988c2a9$exports && $27fff0c742d61ae2$var$getTag(new $2ef77f178988c2a9$exports) != $27fff0c742d61ae2$var$mapTag || $acf6e581bff01fef$exports && $27fff0c742d61ae2$var$getTag($acf6e581bff01fef$exports.resolve()) != $27fff0c742d61ae2$var$promiseTag || $8c9ee126279b9015$exports && $27fff0c742d61ae2$var$getTag(new $8c9ee126279b9015$exports) != $27fff0c742d61ae2$var$setTag || $0f252975f69388f7$exports && $27fff0c742d61ae2$var$getTag(new $0f252975f69388f7$exports) != $27fff0c742d61ae2$var$weakMapTag) $27fff0c742d61ae2$var$getTag = function(value) {
    var result = $hxQbQ(value), Ctor = result == $27fff0c742d61ae2$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $ab798ffd2b879d64$exports(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $27fff0c742d61ae2$var$dataViewCtorString:
            return $27fff0c742d61ae2$var$dataViewTag;
        case $27fff0c742d61ae2$var$mapCtorString:
            return $27fff0c742d61ae2$var$mapTag;
        case $27fff0c742d61ae2$var$promiseCtorString:
            return $27fff0c742d61ae2$var$promiseTag;
        case $27fff0c742d61ae2$var$setCtorString:
            return $27fff0c742d61ae2$var$setTag;
        case $27fff0c742d61ae2$var$weakMapCtorString:
            return $27fff0c742d61ae2$var$weakMapTag;
    }
    return result;
};
$27fff0c742d61ae2$exports = $27fff0c742d61ae2$var$getTag;



var $fSG8F = parcelRequire("fSG8F");

var $hpW0S = parcelRequire("hpW0S");

var $9PkbX = parcelRequire("9PkbX");
/** Used to compose bitmasks for value comparisons. */ var $0794cbabf3530ee0$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $0794cbabf3530ee0$var$argsTag = '[object Arguments]', $0794cbabf3530ee0$var$arrayTag = '[object Array]', $0794cbabf3530ee0$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $0794cbabf3530ee0$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0794cbabf3530ee0$var$hasOwnProperty = $0794cbabf3530ee0$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $0794cbabf3530ee0$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $fSG8F(object), othIsArr = $fSG8F(other), objTag = objIsArr ? $0794cbabf3530ee0$var$arrayTag : $27fff0c742d61ae2$exports(object), othTag = othIsArr ? $0794cbabf3530ee0$var$arrayTag : $27fff0c742d61ae2$exports(other);
    objTag = objTag == $0794cbabf3530ee0$var$argsTag ? $0794cbabf3530ee0$var$objectTag : objTag;
    othTag = othTag == $0794cbabf3530ee0$var$argsTag ? $0794cbabf3530ee0$var$objectTag : othTag;
    var objIsObj = objTag == $0794cbabf3530ee0$var$objectTag, othIsObj = othTag == $0794cbabf3530ee0$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $hpW0S(object)) {
        if (!$hpW0S(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $94d303896d62668a$exports);
        return objIsArr || $9PkbX(object) ? $32560ce7d6132760$exports(object, other, bitmask, customizer, equalFunc, stack) : $9338bb4bedddfebc$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $0794cbabf3530ee0$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $0794cbabf3530ee0$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $0794cbabf3530ee0$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $94d303896d62668a$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $94d303896d62668a$exports);
    return $6bfef1d1c11441ab$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$0794cbabf3530ee0$exports = $0794cbabf3530ee0$var$baseIsEqualDeep;



var $hemqo = parcelRequire("hemqo");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $a237166ee29225a3$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$hemqo(value) && !$hemqo(other)) return value !== value && other !== other;
    return $0794cbabf3530ee0$exports(value, other, bitmask, customizer, $a237166ee29225a3$var$baseIsEqual, stack);
}
$a237166ee29225a3$exports = $a237166ee29225a3$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $271b5acd65f18f15$var$COMPARE_PARTIAL_FLAG = 1, $271b5acd65f18f15$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $271b5acd65f18f15$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $94d303896d62668a$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $a237166ee29225a3$exports(srcValue, objValue, $271b5acd65f18f15$var$COMPARE_PARTIAL_FLAG | $271b5acd65f18f15$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$271b5acd65f18f15$exports = $271b5acd65f18f15$var$baseIsMatch;


var $ea2f4c02d94edc9d$exports = {};
var $372f5ca205e9bf78$exports = {};

var $fFfYm = parcelRequire("fFfYm");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $372f5ca205e9bf78$var$isStrictComparable(value) {
    return value === value && !$fFfYm(value);
}
$372f5ca205e9bf78$exports = $372f5ca205e9bf78$var$isStrictComparable;



var $3LPLJ = parcelRequire("3LPLJ");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $ea2f4c02d94edc9d$var$getMatchData(object) {
    var result = $3LPLJ(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $372f5ca205e9bf78$exports(value)
        ];
    }
    return result;
}
$ea2f4c02d94edc9d$exports = $ea2f4c02d94edc9d$var$getMatchData;


var $4bcf843050ed884e$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $4bcf843050ed884e$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$4bcf843050ed884e$exports = $4bcf843050ed884e$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $eb1aa91b1762d83a$var$baseMatches(source) {
    var matchData = $ea2f4c02d94edc9d$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $4bcf843050ed884e$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $271b5acd65f18f15$exports(object, source, matchData);
    };
}
$eb1aa91b1762d83a$exports = $eb1aa91b1762d83a$var$baseMatches;


var $72e9dc1ee32c4f6f$exports = {};

var $b6423b93eca8c090$exports = {};
var $e904361d02ae88fe$exports = {};
var $ad221e8729f4bc20$exports = {};

var $fSG8F = parcelRequire("fSG8F");
var $e58f54ad9208adac$exports = {};

var $fSG8F = parcelRequire("fSG8F");
var $8d97c1dbf922a3fb$exports = {};

var $hxQbQ = parcelRequire("hxQbQ");

var $hemqo = parcelRequire("hemqo");
/** `Object#toString` result references. */ var $8d97c1dbf922a3fb$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $8d97c1dbf922a3fb$var$isSymbol(value) {
    return typeof value == 'symbol' || $hemqo(value) && $hxQbQ(value) == $8d97c1dbf922a3fb$var$symbolTag;
}
$8d97c1dbf922a3fb$exports = $8d97c1dbf922a3fb$var$isSymbol;


/** Used to match property names within property paths. */ var $e58f54ad9208adac$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $e58f54ad9208adac$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $e58f54ad9208adac$var$isKey(value, object) {
    if ($fSG8F(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $8d97c1dbf922a3fb$exports(value)) return true;
    return $e58f54ad9208adac$var$reIsPlainProp.test(value) || !$e58f54ad9208adac$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$e58f54ad9208adac$exports = $e58f54ad9208adac$var$isKey;


var $ed5533eb92c4ead0$exports = {};
var $e6283d7818a689fd$exports = {};
var $050c2eca2e38844e$exports = {};

/** Error message constants. */ var $050c2eca2e38844e$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $050c2eca2e38844e$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($050c2eca2e38844e$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($050c2eca2e38844e$var$memoize.Cache || $d4f702305322972d$exports);
    return memoized;
}
// Expose `MapCache`.
$050c2eca2e38844e$var$memoize.Cache = $d4f702305322972d$exports;
$050c2eca2e38844e$exports = $050c2eca2e38844e$var$memoize;


/** Used as the maximum memoize cache size. */ var $e6283d7818a689fd$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $e6283d7818a689fd$var$memoizeCapped(func) {
    var result = $050c2eca2e38844e$exports(func, function(key) {
        if (cache.size === $e6283d7818a689fd$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$e6283d7818a689fd$exports = $e6283d7818a689fd$var$memoizeCapped;


/** Used to match property names within property paths. */ var $ed5533eb92c4ead0$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $ed5533eb92c4ead0$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $ed5533eb92c4ead0$var$stringToPath = $e6283d7818a689fd$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($ed5533eb92c4ead0$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($ed5533eb92c4ead0$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
$ed5533eb92c4ead0$exports = $ed5533eb92c4ead0$var$stringToPath;


var $8609948e2d453432$exports = {};
var $47f92bec73563b7a$exports = {};

var $cT2ec = parcelRequire("cT2ec");


var $fSG8F = parcelRequire("fSG8F");

/** Used as references for various `Number` constants. */ var $47f92bec73563b7a$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $47f92bec73563b7a$var$symbolProto = $cT2ec ? $cT2ec.prototype : undefined, $47f92bec73563b7a$var$symbolToString = $47f92bec73563b7a$var$symbolProto ? $47f92bec73563b7a$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $47f92bec73563b7a$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($fSG8F(value)) // Recursively convert values (susceptible to call stack limits).
    return $f2f47bab3766be64$exports(value, $47f92bec73563b7a$var$baseToString) + '';
    if ($8d97c1dbf922a3fb$exports(value)) return $47f92bec73563b7a$var$symbolToString ? $47f92bec73563b7a$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$47f92bec73563b7a$var$INFINITY ? '-0' : result;
}
$47f92bec73563b7a$exports = $47f92bec73563b7a$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $8609948e2d453432$var$toString(value) {
    return value == null ? '' : $47f92bec73563b7a$exports(value);
}
$8609948e2d453432$exports = $8609948e2d453432$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $ad221e8729f4bc20$var$castPath(value, object) {
    if ($fSG8F(value)) return value;
    return $e58f54ad9208adac$exports(value, object) ? [
        value
    ] : $ed5533eb92c4ead0$exports($8609948e2d453432$exports(value));
}
$ad221e8729f4bc20$exports = $ad221e8729f4bc20$var$castPath;


var $57b46a238f9f5cb7$exports = {};

/** Used as references for various `Number` constants. */ var $57b46a238f9f5cb7$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $57b46a238f9f5cb7$var$toKey(value) {
    if (typeof value == 'string' || $8d97c1dbf922a3fb$exports(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$57b46a238f9f5cb7$var$INFINITY ? '-0' : result;
}
$57b46a238f9f5cb7$exports = $57b46a238f9f5cb7$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $e904361d02ae88fe$var$baseGet(object, path) {
    path = $ad221e8729f4bc20$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$57b46a238f9f5cb7$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$e904361d02ae88fe$exports = $e904361d02ae88fe$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $b6423b93eca8c090$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $e904361d02ae88fe$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$b6423b93eca8c090$exports = $b6423b93eca8c090$var$get;


var $e617b2377c5a52f0$exports = {};
var $4e04c87ad093b2c2$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $4e04c87ad093b2c2$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$4e04c87ad093b2c2$exports = $4e04c87ad093b2c2$var$baseHasIn;


var $1e636534494217d3$exports = {};


var $bTgvk = parcelRequire("bTgvk");

var $fSG8F = parcelRequire("fSG8F");

var $hK6dh = parcelRequire("hK6dh");

var $4gWDz = parcelRequire("4gWDz");

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $1e636534494217d3$var$hasPath(object, path, hasFunc) {
    path = $ad221e8729f4bc20$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $57b46a238f9f5cb7$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $4gWDz(length) && $hK6dh(key, length) && ($fSG8F(object) || $bTgvk(object));
}
$1e636534494217d3$exports = $1e636534494217d3$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $e617b2377c5a52f0$var$hasIn(object, path) {
    return object != null && $1e636534494217d3$exports(object, path, $4e04c87ad093b2c2$exports);
}
$e617b2377c5a52f0$exports = $e617b2377c5a52f0$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $72e9dc1ee32c4f6f$var$COMPARE_PARTIAL_FLAG = 1, $72e9dc1ee32c4f6f$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $72e9dc1ee32c4f6f$var$baseMatchesProperty(path, srcValue) {
    if ($e58f54ad9208adac$exports(path) && $372f5ca205e9bf78$exports(srcValue)) return $4bcf843050ed884e$exports($57b46a238f9f5cb7$exports(path), srcValue);
    return function(object) {
        var objValue = $b6423b93eca8c090$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $e617b2377c5a52f0$exports(object, path) : $a237166ee29225a3$exports(srcValue, objValue, $72e9dc1ee32c4f6f$var$COMPARE_PARTIAL_FLAG | $72e9dc1ee32c4f6f$var$COMPARE_UNORDERED_FLAG);
    };
}
$72e9dc1ee32c4f6f$exports = $72e9dc1ee32c4f6f$var$baseMatchesProperty;



var $hD1eO = parcelRequire("hD1eO");

var $fSG8F = parcelRequire("fSG8F");
var $5d60651716e4665e$exports = {};
var $e7cdceb10d744afe$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $e7cdceb10d744afe$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$e7cdceb10d744afe$exports = $e7cdceb10d744afe$var$baseProperty;


var $640d5a599ff91c18$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $640d5a599ff91c18$var$basePropertyDeep(path) {
    return function(object) {
        return $e904361d02ae88fe$exports(object, path);
    };
}
$640d5a599ff91c18$exports = $640d5a599ff91c18$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $5d60651716e4665e$var$property(path) {
    return $e58f54ad9208adac$exports(path) ? $e7cdceb10d744afe$exports($57b46a238f9f5cb7$exports(path)) : $640d5a599ff91c18$exports(path);
}
$5d60651716e4665e$exports = $5d60651716e4665e$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $e96f8385e2145e24$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $hD1eO;
    if (typeof value == 'object') return $fSG8F(value) ? $72e9dc1ee32c4f6f$exports(value[0], value[1]) : $eb1aa91b1762d83a$exports(value);
    return $5d60651716e4665e$exports(value);
}
$e96f8385e2145e24$exports = $e96f8385e2145e24$var$baseIteratee;


var $4c6245e2a29145b4$exports = {};

var $yomYX = parcelRequire("yomYX");

var $5Yk3N = parcelRequire("5Yk3N");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $4c6245e2a29145b4$var$baseMap(collection, iteratee) {
    var index = -1, result = $5Yk3N(collection) ? Array(collection.length) : [];
    $yomYX(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
$4c6245e2a29145b4$exports = $4c6245e2a29145b4$var$baseMap;



var $fSG8F = parcelRequire("fSG8F");
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $60735b838bcba5a1$var$map(collection, iteratee) {
    var func = $fSG8F(collection) ? $f2f47bab3766be64$exports : $4c6245e2a29145b4$exports;
    return func(collection, $e96f8385e2145e24$exports(iteratee, 3));
}
$60735b838bcba5a1$exports = $60735b838bcba5a1$var$map;


var $9bfa1597487f0a02$var$_map3 = $9bfa1597487f0a02$var$_interopRequireDefault($60735b838bcba5a1$exports);
function $9bfa1597487f0a02$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $9bfa1597487f0a02$var$flattenNames = $9bfa1597487f0a02$exports.flattenNames = function flattenNames() {
    var things = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var names = [];
    (0, $9bfa1597487f0a02$var$_map3.default)(things, function(thing) {
        if (Array.isArray(thing)) flattenNames(thing).map(function(name) {
            return names.push(name);
        });
        else if ((0, $9bfa1597487f0a02$var$_isPlainObject3.default)(thing)) (0, $9bfa1597487f0a02$var$_forOwn3.default)(thing, function(value, key) {
            value === true && names.push(key);
            names.push(key + '-' + value);
        });
        else if ((0, $9bfa1597487f0a02$var$_isString3.default)(thing)) names.push(thing);
    });
    return names;
};
$9bfa1597487f0a02$exports.default = $9bfa1597487f0a02$var$flattenNames;


var $c8d725e5ba719c3a$var$_flattenNames2 = $c8d725e5ba719c3a$var$_interopRequireDefault($9bfa1597487f0a02$exports);
var $244e8957092e1986$exports = {};
'use strict';
Object.defineProperty($244e8957092e1986$exports, "__esModule", {
    value: true
});
$244e8957092e1986$exports.mergeClasses = undefined;

var $244e8957092e1986$var$_forOwn3 = $244e8957092e1986$var$_interopRequireDefault($e9b6c25470173b5b$exports);
var $843ade5093e88e4b$exports = {};
var $8587a5ff6f5fecd8$exports = {};


var $3bBKN = parcelRequire("3bBKN");
var $4ed0ae2b4d246418$exports = {};
var $bf0060c3aa46535f$exports = {};
var $d08fd2a913e24a5c$exports = {};

var $d08fd2a913e24a5c$var$defineProperty = function() {
    try {
        var func = $d139d2e71c9648ac$exports(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
$d08fd2a913e24a5c$exports = $d08fd2a913e24a5c$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $bf0060c3aa46535f$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $d08fd2a913e24a5c$exports) $d08fd2a913e24a5c$exports(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
$bf0060c3aa46535f$exports = $bf0060c3aa46535f$var$baseAssignValue;



/** Used for built-in method references. */ var $4ed0ae2b4d246418$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4ed0ae2b4d246418$var$hasOwnProperty = $4ed0ae2b4d246418$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $4ed0ae2b4d246418$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($4ed0ae2b4d246418$var$hasOwnProperty.call(object, key) && $f99e04e5a327d734$exports(objValue, value)) || value === undefined && !(key in object)) $bf0060c3aa46535f$exports(object, key, value);
}
$4ed0ae2b4d246418$exports = $4ed0ae2b4d246418$var$assignValue;


var $a37abff6735316bd$exports = {};
var $dd70a55862ec4473$exports = {};


/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $dd70a55862ec4473$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $bf0060c3aa46535f$exports(object, key, newValue);
        else $4ed0ae2b4d246418$exports(object, key, newValue);
    }
    return object;
}
$dd70a55862ec4473$exports = $dd70a55862ec4473$var$copyObject;



var $3LPLJ = parcelRequire("3LPLJ");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $a37abff6735316bd$var$baseAssign(object, source) {
    return object && $dd70a55862ec4473$exports(source, $3LPLJ(source), object);
}
$a37abff6735316bd$exports = $a37abff6735316bd$var$baseAssign;


var $72c3de1dd219d0b3$exports = {};

var $40028ff2b01d3789$exports = {};

var $2WLt3 = parcelRequire("2WLt3");
var $6e05315c2e2c32de$exports = {};

var $fFfYm = parcelRequire("fFfYm");

var $ag6Pp = parcelRequire("ag6Pp");
var $49815d084cdd72ea$exports = {};
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $49815d084cdd72ea$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
$49815d084cdd72ea$exports = $49815d084cdd72ea$var$nativeKeysIn;


/** Used for built-in method references. */ var $6e05315c2e2c32de$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $6e05315c2e2c32de$var$hasOwnProperty = $6e05315c2e2c32de$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $6e05315c2e2c32de$var$baseKeysIn(object) {
    if (!$fFfYm(object)) return $49815d084cdd72ea$exports(object);
    var isProto = $ag6Pp(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$6e05315c2e2c32de$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
$6e05315c2e2c32de$exports = $6e05315c2e2c32de$var$baseKeysIn;



var $5Yk3N = parcelRequire("5Yk3N");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $40028ff2b01d3789$var$keysIn(object) {
    return $5Yk3N(object) ? $2WLt3(object, true) : $6e05315c2e2c32de$exports(object);
}
$40028ff2b01d3789$exports = $40028ff2b01d3789$var$keysIn;


/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $72c3de1dd219d0b3$var$baseAssignIn(object, source) {
    return object && $dd70a55862ec4473$exports(source, $40028ff2b01d3789$exports(source), object);
}
$72c3de1dd219d0b3$exports = $72c3de1dd219d0b3$var$baseAssignIn;



var $c6Pa8 = parcelRequire("c6Pa8");
var $696081b51beb437f$exports = {};
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $696081b51beb437f$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
$696081b51beb437f$exports = $696081b51beb437f$var$copyArray;


var $d960641aa1fafbe2$exports = {};


/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $d960641aa1fafbe2$var$copySymbols(source, object) {
    return $dd70a55862ec4473$exports(source, $c79b5dac738d14ee$exports(source), object);
}
$d960641aa1fafbe2$exports = $d960641aa1fafbe2$var$copySymbols;


var $b11fdf10515316f7$exports = {};

var $4f97b7e38c82c0ff$exports = {};




/* Built-in method references for those with the same name as other `lodash` methods. */ var $4f97b7e38c82c0ff$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $4f97b7e38c82c0ff$var$getSymbolsIn = !$4f97b7e38c82c0ff$var$nativeGetSymbols ? $2f11c4caba214559$exports : function(object) {
    var result = [];
    while(object){
        $a82343f118641bc5$exports(result, $c79b5dac738d14ee$exports(object));
        object = $477ffd831213a9db$exports(object);
    }
    return result;
};
$4f97b7e38c82c0ff$exports = $4f97b7e38c82c0ff$var$getSymbolsIn;


/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $b11fdf10515316f7$var$copySymbolsIn(source, object) {
    return $dd70a55862ec4473$exports(source, $4f97b7e38c82c0ff$exports(source), object);
}
$b11fdf10515316f7$exports = $b11fdf10515316f7$var$copySymbolsIn;



var $cd8fec6578a936aa$exports = {};



/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $cd8fec6578a936aa$var$getAllKeysIn(object) {
    return $c0989f99f96befc2$exports(object, $40028ff2b01d3789$exports, $4f97b7e38c82c0ff$exports);
}
$cd8fec6578a936aa$exports = $cd8fec6578a936aa$var$getAllKeysIn;



var $22a3d56c59fcbef8$exports = {};
/** Used for built-in method references. */ var $22a3d56c59fcbef8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $22a3d56c59fcbef8$var$hasOwnProperty = $22a3d56c59fcbef8$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $22a3d56c59fcbef8$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $22a3d56c59fcbef8$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
$22a3d56c59fcbef8$exports = $22a3d56c59fcbef8$var$initCloneArray;


var $0bd4e0432b175c8e$exports = {};
var $6a2bdbef0b6e14e7$exports = {};

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $6a2bdbef0b6e14e7$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $4949feb6464de9ec$exports(result).set(new $4949feb6464de9ec$exports(arrayBuffer));
    return result;
}
$6a2bdbef0b6e14e7$exports = $6a2bdbef0b6e14e7$var$cloneArrayBuffer;


var $1e311f8669ebb3de$exports = {};

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $1e311f8669ebb3de$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $6a2bdbef0b6e14e7$exports(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
$1e311f8669ebb3de$exports = $1e311f8669ebb3de$var$cloneDataView;


var $8219147d9260d18a$exports = {};
/** Used to match `RegExp` flags from their coerced string values. */ var $8219147d9260d18a$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $8219147d9260d18a$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $8219147d9260d18a$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
$8219147d9260d18a$exports = $8219147d9260d18a$var$cloneRegExp;


var $bc82074322d8145f$exports = {};

var $cT2ec = parcelRequire("cT2ec");
/** Used to convert symbols to primitives and strings. */ var $bc82074322d8145f$var$symbolProto = $cT2ec ? $cT2ec.prototype : undefined, $bc82074322d8145f$var$symbolValueOf = $bc82074322d8145f$var$symbolProto ? $bc82074322d8145f$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $bc82074322d8145f$var$cloneSymbol(symbol) {
    return $bc82074322d8145f$var$symbolValueOf ? Object($bc82074322d8145f$var$symbolValueOf.call(symbol)) : {};
}
$bc82074322d8145f$exports = $bc82074322d8145f$var$cloneSymbol;


var $94b3869fd3fdb66e$exports = {};

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $94b3869fd3fdb66e$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $6a2bdbef0b6e14e7$exports(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
$94b3869fd3fdb66e$exports = $94b3869fd3fdb66e$var$cloneTypedArray;


/** `Object#toString` result references. */ var $0bd4e0432b175c8e$var$boolTag = '[object Boolean]', $0bd4e0432b175c8e$var$dateTag = '[object Date]', $0bd4e0432b175c8e$var$mapTag = '[object Map]', $0bd4e0432b175c8e$var$numberTag = '[object Number]', $0bd4e0432b175c8e$var$regexpTag = '[object RegExp]', $0bd4e0432b175c8e$var$setTag = '[object Set]', $0bd4e0432b175c8e$var$stringTag = '[object String]', $0bd4e0432b175c8e$var$symbolTag = '[object Symbol]';
var $0bd4e0432b175c8e$var$arrayBufferTag = '[object ArrayBuffer]', $0bd4e0432b175c8e$var$dataViewTag = '[object DataView]', $0bd4e0432b175c8e$var$float32Tag = '[object Float32Array]', $0bd4e0432b175c8e$var$float64Tag = '[object Float64Array]', $0bd4e0432b175c8e$var$int8Tag = '[object Int8Array]', $0bd4e0432b175c8e$var$int16Tag = '[object Int16Array]', $0bd4e0432b175c8e$var$int32Tag = '[object Int32Array]', $0bd4e0432b175c8e$var$uint8Tag = '[object Uint8Array]', $0bd4e0432b175c8e$var$uint8ClampedTag = '[object Uint8ClampedArray]', $0bd4e0432b175c8e$var$uint16Tag = '[object Uint16Array]', $0bd4e0432b175c8e$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $0bd4e0432b175c8e$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $0bd4e0432b175c8e$var$arrayBufferTag:
            return $6a2bdbef0b6e14e7$exports(object);
        case $0bd4e0432b175c8e$var$boolTag:
        case $0bd4e0432b175c8e$var$dateTag:
            return new Ctor(+object);
        case $0bd4e0432b175c8e$var$dataViewTag:
            return $1e311f8669ebb3de$exports(object, isDeep);
        case $0bd4e0432b175c8e$var$float32Tag:
        case $0bd4e0432b175c8e$var$float64Tag:
        case $0bd4e0432b175c8e$var$int8Tag:
        case $0bd4e0432b175c8e$var$int16Tag:
        case $0bd4e0432b175c8e$var$int32Tag:
        case $0bd4e0432b175c8e$var$uint8Tag:
        case $0bd4e0432b175c8e$var$uint8ClampedTag:
        case $0bd4e0432b175c8e$var$uint16Tag:
        case $0bd4e0432b175c8e$var$uint32Tag:
            return $94b3869fd3fdb66e$exports(object, isDeep);
        case $0bd4e0432b175c8e$var$mapTag:
            return new Ctor;
        case $0bd4e0432b175c8e$var$numberTag:
        case $0bd4e0432b175c8e$var$stringTag:
            return new Ctor(object);
        case $0bd4e0432b175c8e$var$regexpTag:
            return $8219147d9260d18a$exports(object);
        case $0bd4e0432b175c8e$var$setTag:
            return new Ctor;
        case $0bd4e0432b175c8e$var$symbolTag:
            return $bc82074322d8145f$exports(object);
    }
}
$0bd4e0432b175c8e$exports = $0bd4e0432b175c8e$var$initCloneByTag;


var $46cedd2b987da5d2$exports = {};
var $0d63a365fb938b44$exports = {};

var $fFfYm = parcelRequire("fFfYm");
/** Built-in value references. */ var $0d63a365fb938b44$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $0d63a365fb938b44$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$fFfYm(proto)) return {};
        if ($0d63a365fb938b44$var$objectCreate) return $0d63a365fb938b44$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
$0d63a365fb938b44$exports = $0d63a365fb938b44$var$baseCreate;




var $ag6Pp = parcelRequire("ag6Pp");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $46cedd2b987da5d2$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !$ag6Pp(object) ? $0d63a365fb938b44$exports($477ffd831213a9db$exports(object)) : {};
}
$46cedd2b987da5d2$exports = $46cedd2b987da5d2$var$initCloneObject;



var $fSG8F = parcelRequire("fSG8F");

var $hpW0S = parcelRequire("hpW0S");
var $2ef3de1127460700$exports = {};
var $b3a1ca90289d5c9b$exports = {};


var $hemqo = parcelRequire("hemqo");
/** `Object#toString` result references. */ var $b3a1ca90289d5c9b$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $b3a1ca90289d5c9b$var$baseIsMap(value) {
    return $hemqo(value) && $27fff0c742d61ae2$exports(value) == $b3a1ca90289d5c9b$var$mapTag;
}
$b3a1ca90289d5c9b$exports = $b3a1ca90289d5c9b$var$baseIsMap;



var $5QUe7 = parcelRequire("5QUe7");

var $5KV2H = parcelRequire("5KV2H");
/* Node.js helper references. */ var $2ef3de1127460700$var$nodeIsMap = $5KV2H && $5KV2H.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $2ef3de1127460700$var$isMap = $2ef3de1127460700$var$nodeIsMap ? $5QUe7($2ef3de1127460700$var$nodeIsMap) : $b3a1ca90289d5c9b$exports;
$2ef3de1127460700$exports = $2ef3de1127460700$var$isMap;



var $fFfYm = parcelRequire("fFfYm");
var $80af07060618e9bc$exports = {};
var $fa18fb74e9e8ec15$exports = {};


var $hemqo = parcelRequire("hemqo");
/** `Object#toString` result references. */ var $fa18fb74e9e8ec15$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $fa18fb74e9e8ec15$var$baseIsSet(value) {
    return $hemqo(value) && $27fff0c742d61ae2$exports(value) == $fa18fb74e9e8ec15$var$setTag;
}
$fa18fb74e9e8ec15$exports = $fa18fb74e9e8ec15$var$baseIsSet;



var $5QUe7 = parcelRequire("5QUe7");

var $5KV2H = parcelRequire("5KV2H");
/* Node.js helper references. */ var $80af07060618e9bc$var$nodeIsSet = $5KV2H && $5KV2H.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $80af07060618e9bc$var$isSet = $80af07060618e9bc$var$nodeIsSet ? $5QUe7($80af07060618e9bc$var$nodeIsSet) : $fa18fb74e9e8ec15$exports;
$80af07060618e9bc$exports = $80af07060618e9bc$var$isSet;



var $3LPLJ = parcelRequire("3LPLJ");

/** Used to compose bitmasks for cloning. */ var $8587a5ff6f5fecd8$var$CLONE_DEEP_FLAG = 1, $8587a5ff6f5fecd8$var$CLONE_FLAT_FLAG = 2, $8587a5ff6f5fecd8$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $8587a5ff6f5fecd8$var$argsTag = '[object Arguments]', $8587a5ff6f5fecd8$var$arrayTag = '[object Array]', $8587a5ff6f5fecd8$var$boolTag = '[object Boolean]', $8587a5ff6f5fecd8$var$dateTag = '[object Date]', $8587a5ff6f5fecd8$var$errorTag = '[object Error]', $8587a5ff6f5fecd8$var$funcTag = '[object Function]', $8587a5ff6f5fecd8$var$genTag = '[object GeneratorFunction]', $8587a5ff6f5fecd8$var$mapTag = '[object Map]', $8587a5ff6f5fecd8$var$numberTag = '[object Number]', $8587a5ff6f5fecd8$var$objectTag = '[object Object]', $8587a5ff6f5fecd8$var$regexpTag = '[object RegExp]', $8587a5ff6f5fecd8$var$setTag = '[object Set]', $8587a5ff6f5fecd8$var$stringTag = '[object String]', $8587a5ff6f5fecd8$var$symbolTag = '[object Symbol]', $8587a5ff6f5fecd8$var$weakMapTag = '[object WeakMap]';
var $8587a5ff6f5fecd8$var$arrayBufferTag = '[object ArrayBuffer]', $8587a5ff6f5fecd8$var$dataViewTag = '[object DataView]', $8587a5ff6f5fecd8$var$float32Tag = '[object Float32Array]', $8587a5ff6f5fecd8$var$float64Tag = '[object Float64Array]', $8587a5ff6f5fecd8$var$int8Tag = '[object Int8Array]', $8587a5ff6f5fecd8$var$int16Tag = '[object Int16Array]', $8587a5ff6f5fecd8$var$int32Tag = '[object Int32Array]', $8587a5ff6f5fecd8$var$uint8Tag = '[object Uint8Array]', $8587a5ff6f5fecd8$var$uint8ClampedTag = '[object Uint8ClampedArray]', $8587a5ff6f5fecd8$var$uint16Tag = '[object Uint16Array]', $8587a5ff6f5fecd8$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $8587a5ff6f5fecd8$var$cloneableTags = {};
$8587a5ff6f5fecd8$var$cloneableTags[$8587a5ff6f5fecd8$var$argsTag] = $8587a5ff6f5fecd8$var$cloneableTags[$8587a5ff6f5fecd8$var$arrayTag] = $8587a5ff6f5fecd8$var$cloneableTags[$8587a5ff6f5fecd8$var$arrayBufferTag] = $8587a5ff6f5fecd8$var$cloneableTags[$8587a5ff6f5fecd8$var$dataViewTag] = $8587a5ff6f5fecd8$var$cloneableTags[$8587a5ff6f5fecd8$var$boolTag] = $8587a5ff6f5fecd8$var$cloneableTags[$8587a5ff6f5fecd8$var$dateTag] = $8587a5ff6f5fecd8$var$cloneableTags[$8587a5ff6f5fecd8$var$float32Tag] = $8587a5ff6f5fecd8$var$cloneableTags[$8587a5ff6f5fecd8$var$float64Tag] = $8587a5ff6f5fecd8$var$cloneableTags[$8587a5ff6f5fecd8$var$int8Tag] = $8587a5ff6f5fecd8$var$cloneableTags[$8587a5ff6f5fecd8$var$int16Tag] = $8587a5ff6f5fecd8$var$cloneableTags[$8587a5ff6f5fecd8$var$int32Tag] = $8587a5ff6f5fecd8$var$cloneableTags[$8587a5ff6f5fecd8$var$mapTag] = $8587a5ff6f5fecd8$var$cloneableTags[$8587a5ff6f5fecd8$var$numberTag] = $8587a5ff6f5fecd8$var$cloneableTags[$8587a5ff6f5fecd8$var$objectTag] = $8587a5ff6f5fecd8$var$cloneableTags[$8587a5ff6f5fecd8$var$regexpTag] = $8587a5ff6f5fecd8$var$cloneableTags[$8587a5ff6f5fecd8$var$setTag] = $8587a5ff6f5fecd8$var$cloneableTags[$8587a5ff6f5fecd8$var$stringTag] = $8587a5ff6f5fecd8$var$cloneableTags[$8587a5ff6f5fecd8$var$symbolTag] = $8587a5ff6f5fecd8$var$cloneableTags[$8587a5ff6f5fecd8$var$uint8Tag] = $8587a5ff6f5fecd8$var$cloneableTags[$8587a5ff6f5fecd8$var$uint8ClampedTag] = $8587a5ff6f5fecd8$var$cloneableTags[$8587a5ff6f5fecd8$var$uint16Tag] = $8587a5ff6f5fecd8$var$cloneableTags[$8587a5ff6f5fecd8$var$uint32Tag] = true;
$8587a5ff6f5fecd8$var$cloneableTags[$8587a5ff6f5fecd8$var$errorTag] = $8587a5ff6f5fecd8$var$cloneableTags[$8587a5ff6f5fecd8$var$funcTag] = $8587a5ff6f5fecd8$var$cloneableTags[$8587a5ff6f5fecd8$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $8587a5ff6f5fecd8$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $8587a5ff6f5fecd8$var$CLONE_DEEP_FLAG, isFlat = bitmask & $8587a5ff6f5fecd8$var$CLONE_FLAT_FLAG, isFull = bitmask & $8587a5ff6f5fecd8$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$fFfYm(value)) return value;
    var isArr = $fSG8F(value);
    if (isArr) {
        result = $22a3d56c59fcbef8$exports(value);
        if (!isDeep) return $696081b51beb437f$exports(value, result);
    } else {
        var tag = $27fff0c742d61ae2$exports(value), isFunc = tag == $8587a5ff6f5fecd8$var$funcTag || tag == $8587a5ff6f5fecd8$var$genTag;
        if ($hpW0S(value)) return $c6Pa8(value, isDeep);
        if (tag == $8587a5ff6f5fecd8$var$objectTag || tag == $8587a5ff6f5fecd8$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $46cedd2b987da5d2$exports(value);
            if (!isDeep) return isFlat ? $b11fdf10515316f7$exports(value, $72c3de1dd219d0b3$exports(result, value)) : $d960641aa1fafbe2$exports(value, $a37abff6735316bd$exports(result, value));
        } else {
            if (!$8587a5ff6f5fecd8$var$cloneableTags[tag]) return object ? value : {};
            result = $0bd4e0432b175c8e$exports(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $94d303896d62668a$exports);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($80af07060618e9bc$exports(value)) value.forEach(function(subValue) {
        result.add($8587a5ff6f5fecd8$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($2ef3de1127460700$exports(value)) value.forEach(function(subValue, key) {
        result.set(key, $8587a5ff6f5fecd8$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $cd8fec6578a936aa$exports : $9afd71f0d3c7859c$exports : isFlat ? $40028ff2b01d3789$exports : $3LPLJ;
    var props = isArr ? undefined : keysFunc(value);
    $3bBKN(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $4ed0ae2b4d246418$exports(result, key, $8587a5ff6f5fecd8$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
$8587a5ff6f5fecd8$exports = $8587a5ff6f5fecd8$var$baseClone;


/** Used to compose bitmasks for cloning. */ var $843ade5093e88e4b$var$CLONE_DEEP_FLAG = 1, $843ade5093e88e4b$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $843ade5093e88e4b$var$cloneDeep(value) {
    return $8587a5ff6f5fecd8$exports(value, $843ade5093e88e4b$var$CLONE_DEEP_FLAG | $843ade5093e88e4b$var$CLONE_SYMBOLS_FLAG);
}
$843ade5093e88e4b$exports = $843ade5093e88e4b$var$cloneDeep;


var $244e8957092e1986$var$_cloneDeep3 = $244e8957092e1986$var$_interopRequireDefault($843ade5093e88e4b$exports);
var $244e8957092e1986$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $244e8957092e1986$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $244e8957092e1986$var$mergeClasses = $244e8957092e1986$exports.mergeClasses = function mergeClasses(classes) {
    var activeNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var styles = classes.default && (0, $244e8957092e1986$var$_cloneDeep3.default)(classes.default) || {};
    activeNames.map(function(name) {
        var toMerge = classes[name];
        if (toMerge) (0, $244e8957092e1986$var$_forOwn3.default)(toMerge, function(value, key) {
            if (!styles[key]) styles[key] = {};
            styles[key] = $244e8957092e1986$var$_extends({}, styles[key], toMerge[key]);
        });
        return name;
    });
    return styles;
};
$244e8957092e1986$exports.default = $244e8957092e1986$var$mergeClasses;


var $c8d725e5ba719c3a$var$_mergeClasses2 = $c8d725e5ba719c3a$var$_interopRequireDefault($244e8957092e1986$exports);
var $3ffc4dae3a7450a7$exports = {};
'use strict';
Object.defineProperty($3ffc4dae3a7450a7$exports, "__esModule", {
    value: true
});
$3ffc4dae3a7450a7$exports.autoprefix = undefined;

var $3ffc4dae3a7450a7$var$_forOwn3 = $3ffc4dae3a7450a7$var$_interopRequireDefault($e9b6c25470173b5b$exports);
var $3ffc4dae3a7450a7$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $3ffc4dae3a7450a7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $3ffc4dae3a7450a7$var$transforms = {
    borderRadius: function borderRadius(value) {
        return {
            msBorderRadius: value,
            MozBorderRadius: value,
            OBorderRadius: value,
            WebkitBorderRadius: value,
            borderRadius: value
        };
    },
    boxShadow: function boxShadow(value) {
        return {
            msBoxShadow: value,
            MozBoxShadow: value,
            OBoxShadow: value,
            WebkitBoxShadow: value,
            boxShadow: value
        };
    },
    userSelect: function userSelect(value) {
        return {
            WebkitTouchCallout: value,
            KhtmlUserSelect: value,
            MozUserSelect: value,
            msUserSelect: value,
            WebkitUserSelect: value,
            userSelect: value
        };
    },
    flex: function flex(value) {
        return {
            WebkitBoxFlex: value,
            MozBoxFlex: value,
            WebkitFlex: value,
            msFlex: value,
            flex: value
        };
    },
    flexBasis: function flexBasis(value) {
        return {
            WebkitFlexBasis: value,
            flexBasis: value
        };
    },
    justifyContent: function justifyContent(value) {
        return {
            WebkitJustifyContent: value,
            justifyContent: value
        };
    },
    transition: function transition(value) {
        return {
            msTransition: value,
            MozTransition: value,
            OTransition: value,
            WebkitTransition: value,
            transition: value
        };
    },
    transform: function transform(value) {
        return {
            msTransform: value,
            MozTransform: value,
            OTransform: value,
            WebkitTransform: value,
            transform: value
        };
    },
    absolute: function absolute(value) {
        var direction = value && value.split(' ');
        return {
            position: 'absolute',
            top: direction && direction[0],
            right: direction && direction[1],
            bottom: direction && direction[2],
            left: direction && direction[3]
        };
    },
    extend: function extend(name, otherElementStyles) {
        var otherStyle = otherElementStyles[name];
        if (otherStyle) return otherStyle;
        return {
            'extend': name
        };
    }
};
var $3ffc4dae3a7450a7$var$autoprefix = $3ffc4dae3a7450a7$exports.autoprefix = function autoprefix(elements) {
    var prefixed = {};
    (0, $3ffc4dae3a7450a7$var$_forOwn3.default)(elements, function(styles, element) {
        var expanded = {};
        (0, $3ffc4dae3a7450a7$var$_forOwn3.default)(styles, function(value, key) {
            var transform = $3ffc4dae3a7450a7$var$transforms[key];
            if (transform) expanded = $3ffc4dae3a7450a7$var$_extends({}, expanded, transform(value));
            else expanded[key] = value;
        });
        prefixed[element] = expanded;
    });
    return prefixed;
};
$3ffc4dae3a7450a7$exports.default = $3ffc4dae3a7450a7$var$autoprefix;


var $c8d725e5ba719c3a$var$_autoprefix2 = $c8d725e5ba719c3a$var$_interopRequireDefault($3ffc4dae3a7450a7$exports);
var $8a3f2194d48fc95e$exports = {};
'use strict';
Object.defineProperty($8a3f2194d48fc95e$exports, "__esModule", {
    value: true
});
$8a3f2194d48fc95e$exports.hover = undefined;
var $8a3f2194d48fc95e$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $5E6i4 = parcelRequire("5E6i4");
var $8a3f2194d48fc95e$var$_react2 = $8a3f2194d48fc95e$var$_interopRequireDefault($5E6i4);
function $8a3f2194d48fc95e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8a3f2194d48fc95e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8a3f2194d48fc95e$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $8a3f2194d48fc95e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $8a3f2194d48fc95e$var$hover = $8a3f2194d48fc95e$exports.hover = function hover(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
    return function(_React$Component) {
        $8a3f2194d48fc95e$var$_inherits(Hover, _React$Component);
        function Hover() {
            var _ref;
            var _temp, _this, _ret;
            $8a3f2194d48fc95e$var$_classCallCheck(this, Hover);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $8a3f2194d48fc95e$var$_possibleConstructorReturn(this, (_ref = Hover.__proto__ || Object.getPrototypeOf(Hover)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                hover: false
            }, _this.handleMouseOver = function() {
                return _this.setState({
                    hover: true
                });
            }, _this.handleMouseOut = function() {
                return _this.setState({
                    hover: false
                });
            }, _this.render = function() {
                return $8a3f2194d48fc95e$var$_react2.default.createElement(Span, {
                    onMouseOver: _this.handleMouseOver,
                    onMouseOut: _this.handleMouseOut
                }, $8a3f2194d48fc95e$var$_react2.default.createElement(Component, $8a3f2194d48fc95e$var$_extends({}, _this.props, _this.state)));
            }, _temp), $8a3f2194d48fc95e$var$_possibleConstructorReturn(_this, _ret);
        }
        return Hover;
    }($8a3f2194d48fc95e$var$_react2.default.Component);
};
$8a3f2194d48fc95e$exports.default = $8a3f2194d48fc95e$var$hover;


var $c8d725e5ba719c3a$var$_hover3 = $c8d725e5ba719c3a$var$_interopRequireDefault($8a3f2194d48fc95e$exports);
var $a6a8077b056f147a$exports = {};
'use strict';
Object.defineProperty($a6a8077b056f147a$exports, "__esModule", {
    value: true
});
$a6a8077b056f147a$exports.active = undefined;
var $a6a8077b056f147a$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $5E6i4 = parcelRequire("5E6i4");
var $a6a8077b056f147a$var$_react2 = $a6a8077b056f147a$var$_interopRequireDefault($5E6i4);
function $a6a8077b056f147a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a6a8077b056f147a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a6a8077b056f147a$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $a6a8077b056f147a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $a6a8077b056f147a$var$active = $a6a8077b056f147a$exports.active = function active(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
    return function(_React$Component) {
        $a6a8077b056f147a$var$_inherits(Active, _React$Component);
        function Active() {
            var _ref;
            var _temp, _this, _ret;
            $a6a8077b056f147a$var$_classCallCheck(this, Active);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $a6a8077b056f147a$var$_possibleConstructorReturn(this, (_ref = Active.__proto__ || Object.getPrototypeOf(Active)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                active: false
            }, _this.handleMouseDown = function() {
                return _this.setState({
                    active: true
                });
            }, _this.handleMouseUp = function() {
                return _this.setState({
                    active: false
                });
            }, _this.render = function() {
                return $a6a8077b056f147a$var$_react2.default.createElement(Span, {
                    onMouseDown: _this.handleMouseDown,
                    onMouseUp: _this.handleMouseUp
                }, $a6a8077b056f147a$var$_react2.default.createElement(Component, $a6a8077b056f147a$var$_extends({}, _this.props, _this.state)));
            }, _temp), $a6a8077b056f147a$var$_possibleConstructorReturn(_this, _ret);
        }
        return Active;
    }($a6a8077b056f147a$var$_react2.default.Component);
};
$a6a8077b056f147a$exports.default = $a6a8077b056f147a$var$active;


var $c8d725e5ba719c3a$var$_active2 = $c8d725e5ba719c3a$var$_interopRequireDefault($a6a8077b056f147a$exports);
var $a4b977f78244772e$exports = {};
'use strict';
Object.defineProperty($a4b977f78244772e$exports, "__esModule", {
    value: true
});
var $a4b977f78244772e$var$loopable = function loopable(i, length) {
    var props = {};
    var setProp = function setProp(name) {
        var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        props[name] = value;
    };
    i === 0 && setProp('first-child');
    i === length - 1 && setProp('last-child');
    (i === 0 || i % 2 === 0) && setProp('even');
    Math.abs(i % 2) === 1 && setProp('odd');
    setProp('nth-child', i);
    return props;
};
$a4b977f78244772e$exports.default = $a4b977f78244772e$var$loopable;


var $c8d725e5ba719c3a$var$_loop3 = $c8d725e5ba719c3a$var$_interopRequireDefault($a4b977f78244772e$exports);
function $c8d725e5ba719c3a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$c8d725e5ba719c3a$exports.hover = $c8d725e5ba719c3a$var$_hover3.default;
$c8d725e5ba719c3a$exports.handleHover = $c8d725e5ba719c3a$var$_hover3.default;
$c8d725e5ba719c3a$exports.handleActive = $c8d725e5ba719c3a$var$_active2.default;
$c8d725e5ba719c3a$exports.loop = $c8d725e5ba719c3a$var$_loop3.default;
var $c8d725e5ba719c3a$var$ReactCSS = $c8d725e5ba719c3a$exports.ReactCSS = function ReactCSS(classes) {
    for(var _len = arguments.length, activations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)activations[_key - 1] = arguments[_key];
    var activeNames = (0, $c8d725e5ba719c3a$var$_flattenNames2.default)(activations);
    var merged = (0, $c8d725e5ba719c3a$var$_mergeClasses2.default)(classes, activeNames);
    return (0, $c8d725e5ba719c3a$var$_autoprefix2.default)(merged);
};
$c8d725e5ba719c3a$exports.default = $c8d725e5ba719c3a$var$ReactCSS;



var $5E6i4 = parcelRequire("5E6i4");

var $897180ce59247221$export$a056a977bf6a9a3c = function calculateChange(e, hsl, direction, initialA, container) {
    var containerWidth = container.clientWidth;
    var containerHeight = container.clientHeight;
    var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (direction === 'vertical') {
        var a = void 0;
        if (top < 0) a = 0;
        else if (top > containerHeight) a = 1;
        else a = Math.round(top * 100 / containerHeight) / 100;
        if (hsl.a !== a) return {
            h: hsl.h,
            s: hsl.s,
            l: hsl.l,
            a: a,
            source: 'rgb'
        };
    } else {
        var _a = void 0;
        if (left < 0) _a = 0;
        else if (left > containerWidth) _a = 1;
        else _a = Math.round(left * 100 / containerWidth) / 100;
        if (initialA !== _a) return {
            h: hsl.h,
            s: hsl.s,
            l: hsl.l,
            a: _a,
            source: 'rgb'
        };
    }
    return null;
};



var $5E6i4 = parcelRequire("5E6i4");

var $86343d8562205351$var$checkboardCache = {};
var $86343d8562205351$export$b3890eb0ae9dca99 = function render(c1, c2, size, serverCanvas) {
    if (typeof document === 'undefined' && !serverCanvas) return null;
    var canvas = serverCanvas ? new serverCanvas() : document.createElement('canvas');
    canvas.width = size * 2;
    canvas.height = size * 2;
    var ctx = canvas.getContext('2d');
    if (!ctx) return null;
     // If no context can be found, return early.
    ctx.fillStyle = c1;
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = c2;
    ctx.fillRect(0, 0, size, size);
    ctx.translate(size, size);
    ctx.fillRect(0, 0, size, size);
    return canvas.toDataURL();
};
var $86343d8562205351$export$3988ae62b71be9a3 = function get(c1, c2, size, serverCanvas) {
    var key = c1 + '-' + c2 + '-' + size + (serverCanvas ? '-server' : '');
    if ($86343d8562205351$var$checkboardCache[key]) return $86343d8562205351$var$checkboardCache[key];
    var checkboard = $86343d8562205351$export$b3890eb0ae9dca99(c1, c2, size, serverCanvas);
    $86343d8562205351$var$checkboardCache[key] = checkboard;
    return checkboard;
};


var $9494de16828d37a1$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $9494de16828d37a1$export$457ff74489f64b4a = function Checkboard(_ref) {
    var white = _ref.white, grey = _ref.grey, size = _ref.size, renderers = _ref.renderers, borderRadius = _ref.borderRadius, boxShadow = _ref.boxShadow, children = _ref.children;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($c8d725e5ba719c3a$exports)))({
        'default': {
            grid: {
                borderRadius: borderRadius,
                boxShadow: boxShadow,
                absolute: '0px 0px 0px 0px',
                background: 'url(' + $86343d8562205351$export$3988ae62b71be9a3(white, grey, size, renderers.canvas) + ') center left'
            }
        }
    });
    return (0, $5E6i4.isValidElement)(children) ? (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).cloneElement(children, $9494de16828d37a1$var$_extends({}, children.props, {
        style: $9494de16828d37a1$var$_extends({}, children.props.style, styles.grid)
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.grid
    });
};
$9494de16828d37a1$export$457ff74489f64b4a.defaultProps = {
    size: 8,
    white: 'transparent',
    grey: 'rgba(0,0,0,.08)',
    renderers: {}
};
var $9494de16828d37a1$export$2e2bcd8739ae039 = $9494de16828d37a1$export$457ff74489f64b4a;


var $7bb4498a032d4109$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $7bb4498a032d4109$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $7bb4498a032d4109$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7bb4498a032d4109$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $7bb4498a032d4109$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $7bb4498a032d4109$export$b3d0ceb706f8af43 = function(_ref) {
    $7bb4498a032d4109$var$_inherits(Alpha, _ref);
    function Alpha() {
        var _ref2;
        var _temp, _this, _ret;
        $7bb4498a032d4109$var$_classCallCheck(this, Alpha);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $7bb4498a032d4109$var$_possibleConstructorReturn(this, (_ref2 = Alpha.__proto__ || Object.getPrototypeOf(Alpha)).call.apply(_ref2, [
            this
        ].concat(args))), _this), _this.handleChange = function(e) {
            var change = $897180ce59247221$export$a056a977bf6a9a3c(e, _this.props.hsl, _this.props.direction, _this.props.a, _this.container);
            change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
        }, _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            window.addEventListener('mousemove', _this.handleChange);
            window.addEventListener('mouseup', _this.handleMouseUp);
        }, _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        }, _this.unbindEventListeners = function() {
            window.removeEventListener('mousemove', _this.handleChange);
            window.removeEventListener('mouseup', _this.handleMouseUp);
        }, _temp), $7bb4498a032d4109$var$_possibleConstructorReturn(_this, _ret);
    }
    $7bb4498a032d4109$var$_createClass(Alpha, [
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var rgb = this.props.rgb;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($c8d725e5ba719c3a$exports)))({
                    'default': {
                        alpha: {
                            absolute: '0px 0px 0px 0px',
                            borderRadius: this.props.radius
                        },
                        checkboard: {
                            absolute: '0px 0px 0px 0px',
                            overflow: 'hidden',
                            borderRadius: this.props.radius
                        },
                        gradient: {
                            absolute: '0px 0px 0px 0px',
                            background: 'linear-gradient(to right, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)',
                            boxShadow: this.props.shadow,
                            borderRadius: this.props.radius
                        },
                        container: {
                            position: 'relative',
                            height: '100%',
                            margin: '0 3px'
                        },
                        pointer: {
                            position: 'absolute',
                            left: rgb.a * 100 + '%'
                        },
                        slider: {
                            width: '4px',
                            borderRadius: '1px',
                            height: '8px',
                            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
                            background: '#fff',
                            marginTop: '1px',
                            transform: 'translateX(-2px)'
                        }
                    },
                    'vertical': {
                        gradient: {
                            background: 'linear-gradient(to bottom, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)'
                        },
                        pointer: {
                            left: 0,
                            top: rgb.a * 100 + '%'
                        }
                    },
                    'overwrite': $7bb4498a032d4109$var$_extends({}, this.props.style)
                }, {
                    vertical: this.props.direction === 'vertical',
                    overwrite: true
                });
                return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
                    style: styles.alpha
                }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
                    style: styles.checkboard
                }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $9494de16828d37a1$export$2e2bcd8739ae039), {
                    renderers: this.props.renderers
                })), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
                    style: styles.gradient
                }), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
                    style: styles.container,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
                    style: styles.pointer
                }, this.props.pointer ? (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement(this.props.pointer, this.props) : (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
                    style: styles.slider
                }))));
            }
        }
    ]);
    return Alpha;
}((0, $5E6i4.PureComponent) || (0, $5E6i4.Component));
var $7bb4498a032d4109$export$2e2bcd8739ae039 = $7bb4498a032d4109$export$b3d0ceb706f8af43;




var $5E6i4 = parcelRequire("5E6i4");

var $cb537f80953d7d1d$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $cb537f80953d7d1d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $cb537f80953d7d1d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $cb537f80953d7d1d$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $cb537f80953d7d1d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $cb537f80953d7d1d$var$DEFAULT_ARROW_OFFSET = 1;
var $cb537f80953d7d1d$var$UP_KEY_CODE = 38;
var $cb537f80953d7d1d$var$DOWN_KEY_CODE = 40;
var $cb537f80953d7d1d$var$VALID_KEY_CODES = [
    $cb537f80953d7d1d$var$UP_KEY_CODE,
    $cb537f80953d7d1d$var$DOWN_KEY_CODE
];
var $cb537f80953d7d1d$var$isValidKeyCode = function isValidKeyCode(keyCode) {
    return $cb537f80953d7d1d$var$VALID_KEY_CODES.indexOf(keyCode) > -1;
};
var $cb537f80953d7d1d$var$getNumberValue = function getNumberValue(value) {
    return Number(String(value).replace(/%/g, ''));
};
var $cb537f80953d7d1d$var$idCounter = 1;
var $cb537f80953d7d1d$export$bfb3cbb78d3c298 = function(_ref) {
    $cb537f80953d7d1d$var$_inherits(EditableInput, _ref);
    function EditableInput(props) {
        $cb537f80953d7d1d$var$_classCallCheck(this, EditableInput);
        var _this = $cb537f80953d7d1d$var$_possibleConstructorReturn(this, (EditableInput.__proto__ || Object.getPrototypeOf(EditableInput)).call(this));
        _this.handleBlur = function() {
            if (_this.state.blurValue) _this.setState({
                value: _this.state.blurValue,
                blurValue: null
            });
        };
        _this.handleChange = function(e) {
            _this.setUpdatedValue(e.target.value, e);
        };
        _this.handleKeyDown = function(e) {
            // In case `e.target.value` is a percentage remove the `%` character
            // and update accordingly with a percentage
            // https://github.com/casesandberg/react-color/issues/383
            var value = $cb537f80953d7d1d$var$getNumberValue(e.target.value);
            if (!isNaN(value) && $cb537f80953d7d1d$var$isValidKeyCode(e.keyCode)) {
                var offset = _this.getArrowOffset();
                var updatedValue = e.keyCode === $cb537f80953d7d1d$var$UP_KEY_CODE ? value + offset : value - offset;
                _this.setUpdatedValue(updatedValue, e);
            }
        };
        _this.handleDrag = function(e) {
            if (_this.props.dragLabel) {
                var newValue = Math.round(_this.props.value + e.movementX);
                if (newValue >= 0 && newValue <= _this.props.dragMax) _this.props.onChange && _this.props.onChange(_this.getValueObjectWithLabel(newValue), e);
            }
        };
        _this.handleMouseDown = function(e) {
            if (_this.props.dragLabel) {
                e.preventDefault();
                _this.handleDrag(e);
                window.addEventListener('mousemove', _this.handleDrag);
                window.addEventListener('mouseup', _this.handleMouseUp);
            }
        };
        _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        };
        _this.unbindEventListeners = function() {
            window.removeEventListener('mousemove', _this.handleDrag);
            window.removeEventListener('mouseup', _this.handleMouseUp);
        };
        _this.state = {
            value: String(props.value).toUpperCase(),
            blurValue: String(props.value).toUpperCase()
        };
        _this.inputId = 'rc-editable-input-' + $cb537f80953d7d1d$var$idCounter++;
        return _this;
    }
    $cb537f80953d7d1d$var$_createClass(EditableInput, [
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps, prevState) {
                if (this.props.value !== this.state.value && (prevProps.value !== this.props.value || prevState.value !== this.state.value)) {
                    if (this.input === document.activeElement) this.setState({
                        blurValue: String(this.props.value).toUpperCase()
                    });
                    else this.setState({
                        value: String(this.props.value).toUpperCase(),
                        blurValue: !this.state.blurValue && String(this.props.value).toUpperCase()
                    });
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: 'getValueObjectWithLabel',
            value: function getValueObjectWithLabel(value) {
                return $cb537f80953d7d1d$var$_defineProperty({}, this.props.label, value);
            }
        },
        {
            key: 'getArrowOffset',
            value: function getArrowOffset() {
                return this.props.arrowOffset || $cb537f80953d7d1d$var$DEFAULT_ARROW_OFFSET;
            }
        },
        {
            key: 'setUpdatedValue',
            value: function setUpdatedValue(value, e) {
                var onChangeValue = this.props.label ? this.getValueObjectWithLabel(value) : value;
                this.props.onChange && this.props.onChange(onChangeValue, e);
                this.setState({
                    value: value
                });
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($c8d725e5ba719c3a$exports)))({
                    'default': {
                        wrap: {
                            position: 'relative'
                        }
                    },
                    'user-override': {
                        wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
                        input: this.props.style && this.props.style.input ? this.props.style.input : {},
                        label: this.props.style && this.props.style.label ? this.props.style.label : {}
                    },
                    'dragLabel-true': {
                        label: {
                            cursor: 'ew-resize'
                        }
                    }
                }, {
                    'user-override': true
                }, this.props);
                return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
                    style: styles.wrap
                }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('input', {
                    id: this.inputId,
                    style: styles.input,
                    ref: function ref(input) {
                        return _this2.input = input;
                    },
                    value: this.state.value,
                    onKeyDown: this.handleKeyDown,
                    onChange: this.handleChange,
                    onBlur: this.handleBlur,
                    placeholder: this.props.placeholder,
                    spellCheck: 'false'
                }), this.props.label && !this.props.hideLabel ? (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('label', {
                    htmlFor: this.inputId,
                    style: styles.label,
                    onMouseDown: this.handleMouseDown
                }, this.props.label) : null);
            }
        }
    ]);
    return EditableInput;
}((0, $5E6i4.PureComponent) || (0, $5E6i4.Component));
var $cb537f80953d7d1d$export$2e2bcd8739ae039 = $cb537f80953d7d1d$export$bfb3cbb78d3c298;



var $5E6i4 = parcelRequire("5E6i4");

var $3cb973f97ccd11ce$export$a056a977bf6a9a3c = function calculateChange(e, direction, hsl, container) {
    var containerWidth = container.clientWidth;
    var containerHeight = container.clientHeight;
    var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (direction === 'vertical') {
        var h = void 0;
        if (top < 0) h = 359;
        else if (top > containerHeight) h = 0;
        else {
            var percent = -(top * 100 / containerHeight) + 100;
            h = 360 * percent / 100;
        }
        if (hsl.h !== h) return {
            h: h,
            s: hsl.s,
            l: hsl.l,
            a: hsl.a,
            source: 'hsl'
        };
    } else {
        var _h = void 0;
        if (left < 0) _h = 0;
        else if (left > containerWidth) _h = 359;
        else {
            var _percent = left * 100 / containerWidth;
            _h = 360 * _percent / 100;
        }
        if (hsl.h !== _h) return {
            h: _h,
            s: hsl.s,
            l: hsl.l,
            a: hsl.a,
            source: 'hsl'
        };
    }
    return null;
};


var $50e2c19f358237c5$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $50e2c19f358237c5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $50e2c19f358237c5$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $50e2c19f358237c5$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $50e2c19f358237c5$export$3e22a96a58989a47 = function(_ref) {
    $50e2c19f358237c5$var$_inherits(Hue, _ref);
    function Hue() {
        var _ref2;
        var _temp, _this, _ret;
        $50e2c19f358237c5$var$_classCallCheck(this, Hue);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $50e2c19f358237c5$var$_possibleConstructorReturn(this, (_ref2 = Hue.__proto__ || Object.getPrototypeOf(Hue)).call.apply(_ref2, [
            this
        ].concat(args))), _this), _this.handleChange = function(e) {
            var change = $3cb973f97ccd11ce$export$a056a977bf6a9a3c(e, _this.props.direction, _this.props.hsl, _this.container);
            change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
        }, _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            window.addEventListener('mousemove', _this.handleChange);
            window.addEventListener('mouseup', _this.handleMouseUp);
        }, _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        }, _temp), $50e2c19f358237c5$var$_possibleConstructorReturn(_this, _ret);
    }
    $50e2c19f358237c5$var$_createClass(Hue, [
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: 'unbindEventListeners',
            value: function unbindEventListeners() {
                window.removeEventListener('mousemove', this.handleChange);
                window.removeEventListener('mouseup', this.handleMouseUp);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var _props$direction = this.props.direction, direction = _props$direction === undefined ? 'horizontal' : _props$direction;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($c8d725e5ba719c3a$exports)))({
                    'default': {
                        hue: {
                            absolute: '0px 0px 0px 0px',
                            borderRadius: this.props.radius,
                            boxShadow: this.props.shadow
                        },
                        container: {
                            padding: '0 2px',
                            position: 'relative',
                            height: '100%',
                            borderRadius: this.props.radius
                        },
                        pointer: {
                            position: 'absolute',
                            left: this.props.hsl.h * 100 / 360 + '%'
                        },
                        slider: {
                            marginTop: '1px',
                            width: '4px',
                            borderRadius: '1px',
                            height: '8px',
                            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
                            background: '#fff',
                            transform: 'translateX(-2px)'
                        }
                    },
                    'vertical': {
                        pointer: {
                            left: '0px',
                            top: -(this.props.hsl.h * 100 / 360) + 100 + '%'
                        }
                    }
                }, {
                    vertical: direction === 'vertical'
                });
                return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
                    style: styles.hue
                }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
                    className: 'hue-' + direction,
                    style: styles.container,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('style', null, '\n            .hue-horizontal {\n              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0\n                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to right, #f00 0%, #ff0\n                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n\n            .hue-vertical {\n              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,\n                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,\n                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n          '), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
                    style: styles.pointer
                }, this.props.pointer ? (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement(this.props.pointer, this.props) : (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
                    style: styles.slider
                }))));
            }
        }
    ]);
    return Hue;
}((0, $5E6i4.PureComponent) || (0, $5E6i4.Component));
var $50e2c19f358237c5$export$2e2bcd8739ae039 = $50e2c19f358237c5$export$3e22a96a58989a47;



var $5E6i4 = parcelRequire("5E6i4");
var $38b29c2dc0019b47$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $38b29c2dc0019b47$var$ReactIs, $38b29c2dc0019b47$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$38b29c2dc0019b47$exports = (parcelRequire("dflA0"))();



/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $8b74307cbb0d9832$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $8b74307cbb0d9832$export$2e2bcd8739ae039 = $8b74307cbb0d9832$var$listCacheClear;


/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $20348e11d29d6c7e$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $20348e11d29d6c7e$export$2e2bcd8739ae039 = $20348e11d29d6c7e$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $7348acbc088e4bbd$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $20348e11d29d6c7e$export$2e2bcd8739ae039)(array[length][0], key)) return length;
    }
    return -1;
}
var $7348acbc088e4bbd$export$2e2bcd8739ae039 = $7348acbc088e4bbd$var$assocIndexOf;


/** Used for built-in method references. */ var $1a8a51eccb88cc57$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $1a8a51eccb88cc57$var$splice = $1a8a51eccb88cc57$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $1a8a51eccb88cc57$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $7348acbc088e4bbd$export$2e2bcd8739ae039)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $1a8a51eccb88cc57$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $1a8a51eccb88cc57$export$2e2bcd8739ae039 = $1a8a51eccb88cc57$var$listCacheDelete;



/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $ed3a684c154ef82e$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $7348acbc088e4bbd$export$2e2bcd8739ae039)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $ed3a684c154ef82e$export$2e2bcd8739ae039 = $ed3a684c154ef82e$var$listCacheGet;



/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $9dded9697d13880c$var$listCacheHas(key) {
    return (0, $7348acbc088e4bbd$export$2e2bcd8739ae039)(this.__data__, key) > -1;
}
var $9dded9697d13880c$export$2e2bcd8739ae039 = $9dded9697d13880c$var$listCacheHas;



/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $cfd555febf1dfa51$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $7348acbc088e4bbd$export$2e2bcd8739ae039)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $cfd555febf1dfa51$export$2e2bcd8739ae039 = $cfd555febf1dfa51$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $bb72d5c5e4972f2b$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$bb72d5c5e4972f2b$var$ListCache.prototype.clear = (0, $8b74307cbb0d9832$export$2e2bcd8739ae039);
$bb72d5c5e4972f2b$var$ListCache.prototype['delete'] = (0, $1a8a51eccb88cc57$export$2e2bcd8739ae039);
$bb72d5c5e4972f2b$var$ListCache.prototype.get = (0, $ed3a684c154ef82e$export$2e2bcd8739ae039);
$bb72d5c5e4972f2b$var$ListCache.prototype.has = (0, $9dded9697d13880c$export$2e2bcd8739ae039);
$bb72d5c5e4972f2b$var$ListCache.prototype.set = (0, $cfd555febf1dfa51$export$2e2bcd8739ae039);
var $bb72d5c5e4972f2b$export$2e2bcd8739ae039 = $bb72d5c5e4972f2b$var$ListCache;



/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $1840c4bc332fa4d5$var$stackClear() {
    this.__data__ = new (0, $bb72d5c5e4972f2b$export$2e2bcd8739ae039);
    this.size = 0;
}
var $1840c4bc332fa4d5$export$2e2bcd8739ae039 = $1840c4bc332fa4d5$var$stackClear;


/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $9ca32999a70c2b11$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
var $9ca32999a70c2b11$export$2e2bcd8739ae039 = $9ca32999a70c2b11$var$stackDelete;


/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $71a3442eb92f6299$var$stackGet(key) {
    return this.__data__.get(key);
}
var $71a3442eb92f6299$export$2e2bcd8739ae039 = $71a3442eb92f6299$var$stackGet;


/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $56fab5b80b72764b$var$stackHas(key) {
    return this.__data__.has(key);
}
var $56fab5b80b72764b$export$2e2bcd8739ae039 = $56fab5b80b72764b$var$stackHas;




var $88ff1 = parcelRequire("88ff1");
/** Built-in value references. */ var $6c469b965cf02ea3$var$Symbol = (0, $88ff1.default).Symbol;
var $6c469b965cf02ea3$export$2e2bcd8739ae039 = $6c469b965cf02ea3$var$Symbol;



/** Used for built-in method references. */ var $714eba825f356d10$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $714eba825f356d10$var$hasOwnProperty = $714eba825f356d10$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $714eba825f356d10$var$nativeObjectToString = $714eba825f356d10$var$objectProto.toString;
/** Built-in value references. */ var $714eba825f356d10$var$symToStringTag = (0, $6c469b965cf02ea3$export$2e2bcd8739ae039) ? (0, $6c469b965cf02ea3$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $714eba825f356d10$var$getRawTag(value) {
    var isOwn = $714eba825f356d10$var$hasOwnProperty.call(value, $714eba825f356d10$var$symToStringTag), tag = value[$714eba825f356d10$var$symToStringTag];
    try {
        value[$714eba825f356d10$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $714eba825f356d10$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$714eba825f356d10$var$symToStringTag] = tag;
        else delete value[$714eba825f356d10$var$symToStringTag];
    }
    return result;
}
var $714eba825f356d10$export$2e2bcd8739ae039 = $714eba825f356d10$var$getRawTag;


/** Used for built-in method references. */ var $2952a7ee97df1bfe$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $2952a7ee97df1bfe$var$nativeObjectToString = $2952a7ee97df1bfe$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $2952a7ee97df1bfe$var$objectToString(value) {
    return $2952a7ee97df1bfe$var$nativeObjectToString.call(value);
}
var $2952a7ee97df1bfe$export$2e2bcd8739ae039 = $2952a7ee97df1bfe$var$objectToString;


/** `Object#toString` result references. */ var $78d0e963301c7165$var$nullTag = '[object Null]', $78d0e963301c7165$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $78d0e963301c7165$var$symToStringTag = (0, $6c469b965cf02ea3$export$2e2bcd8739ae039) ? (0, $6c469b965cf02ea3$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $78d0e963301c7165$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $78d0e963301c7165$var$undefinedTag : $78d0e963301c7165$var$nullTag;
    return $78d0e963301c7165$var$symToStringTag && $78d0e963301c7165$var$symToStringTag in Object(value) ? (0, $714eba825f356d10$export$2e2bcd8739ae039)(value) : (0, $2952a7ee97df1bfe$export$2e2bcd8739ae039)(value);
}
var $78d0e963301c7165$export$2e2bcd8739ae039 = $78d0e963301c7165$var$baseGetTag;


/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $3a5d5535658447fe$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
var $3a5d5535658447fe$export$2e2bcd8739ae039 = $3a5d5535658447fe$var$isObject;


/** `Object#toString` result references. */ var $cd7e0f735b5159c6$var$asyncTag = '[object AsyncFunction]', $cd7e0f735b5159c6$var$funcTag = '[object Function]', $cd7e0f735b5159c6$var$genTag = '[object GeneratorFunction]', $cd7e0f735b5159c6$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $cd7e0f735b5159c6$var$isFunction(value) {
    if (!(0, $3a5d5535658447fe$export$2e2bcd8739ae039)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $78d0e963301c7165$export$2e2bcd8739ae039)(value);
    return tag == $cd7e0f735b5159c6$var$funcTag || tag == $cd7e0f735b5159c6$var$genTag || tag == $cd7e0f735b5159c6$var$asyncTag || tag == $cd7e0f735b5159c6$var$proxyTag;
}
var $cd7e0f735b5159c6$export$2e2bcd8739ae039 = $cd7e0f735b5159c6$var$isFunction;



var $88ff1 = parcelRequire("88ff1");
/** Used to detect overreaching core-js shims. */ var $ceb607468cce86ca$var$coreJsData = (0, $88ff1.default)['__core-js_shared__'];
var $ceb607468cce86ca$export$2e2bcd8739ae039 = $ceb607468cce86ca$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $151ee3610dd4c5c1$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $ceb607468cce86ca$export$2e2bcd8739ae039) && (0, $ceb607468cce86ca$export$2e2bcd8739ae039).keys && (0, $ceb607468cce86ca$export$2e2bcd8739ae039).keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $151ee3610dd4c5c1$var$isMasked(func) {
    return !!$151ee3610dd4c5c1$var$maskSrcKey && $151ee3610dd4c5c1$var$maskSrcKey in func;
}
var $151ee3610dd4c5c1$export$2e2bcd8739ae039 = $151ee3610dd4c5c1$var$isMasked;



/** Used for built-in method references. */ var $5ebedf6a5b17fdc4$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $5ebedf6a5b17fdc4$var$funcToString = $5ebedf6a5b17fdc4$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $5ebedf6a5b17fdc4$var$toSource(func) {
    if (func != null) {
        try {
            return $5ebedf6a5b17fdc4$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
var $5ebedf6a5b17fdc4$export$2e2bcd8739ae039 = $5ebedf6a5b17fdc4$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $a3af87fea671a4a2$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $a3af87fea671a4a2$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $a3af87fea671a4a2$var$funcProto = Function.prototype, $a3af87fea671a4a2$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $a3af87fea671a4a2$var$funcToString = $a3af87fea671a4a2$var$funcProto.toString;
/** Used to check objects for own properties. */ var $a3af87fea671a4a2$var$hasOwnProperty = $a3af87fea671a4a2$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $a3af87fea671a4a2$var$reIsNative = RegExp('^' + $a3af87fea671a4a2$var$funcToString.call($a3af87fea671a4a2$var$hasOwnProperty).replace($a3af87fea671a4a2$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $a3af87fea671a4a2$var$baseIsNative(value) {
    if (!(0, $3a5d5535658447fe$export$2e2bcd8739ae039)(value) || (0, $151ee3610dd4c5c1$export$2e2bcd8739ae039)(value)) return false;
    var pattern = (0, $cd7e0f735b5159c6$export$2e2bcd8739ae039)(value) ? $a3af87fea671a4a2$var$reIsNative : $a3af87fea671a4a2$var$reIsHostCtor;
    return pattern.test((0, $5ebedf6a5b17fdc4$export$2e2bcd8739ae039)(value));
}
var $a3af87fea671a4a2$export$2e2bcd8739ae039 = $a3af87fea671a4a2$var$baseIsNative;


/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $775eaa44b0375d16$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $775eaa44b0375d16$export$2e2bcd8739ae039 = $775eaa44b0375d16$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $c3b3bf1710191a20$var$getNative(object, key) {
    var value = (0, $775eaa44b0375d16$export$2e2bcd8739ae039)(object, key);
    return (0, $a3af87fea671a4a2$export$2e2bcd8739ae039)(value) ? value : undefined;
}
var $c3b3bf1710191a20$export$2e2bcd8739ae039 = $c3b3bf1710191a20$var$getNative;



var $88ff1 = parcelRequire("88ff1");
/* Built-in method references that are verified to be native. */ var $a728fb45d90bee23$var$Map = (0, $c3b3bf1710191a20$export$2e2bcd8739ae039)((0, $88ff1.default), 'Map');
var $a728fb45d90bee23$export$2e2bcd8739ae039 = $a728fb45d90bee23$var$Map;



/* Built-in method references that are verified to be native. */ var $66f4856a3e73d5a4$var$nativeCreate = (0, $c3b3bf1710191a20$export$2e2bcd8739ae039)(Object, 'create');
var $66f4856a3e73d5a4$export$2e2bcd8739ae039 = $66f4856a3e73d5a4$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $5c97d59cef0323a9$var$hashClear() {
    this.__data__ = (0, $66f4856a3e73d5a4$export$2e2bcd8739ae039) ? (0, $66f4856a3e73d5a4$export$2e2bcd8739ae039)(null) : {};
    this.size = 0;
}
var $5c97d59cef0323a9$export$2e2bcd8739ae039 = $5c97d59cef0323a9$var$hashClear;


/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $2d57a4cfc75fe532$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $2d57a4cfc75fe532$export$2e2bcd8739ae039 = $2d57a4cfc75fe532$var$hashDelete;



/** Used to stand-in for `undefined` hash values. */ var $d7a01c39f048daff$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $d7a01c39f048daff$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d7a01c39f048daff$var$hasOwnProperty = $d7a01c39f048daff$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $d7a01c39f048daff$var$hashGet(key) {
    var data = this.__data__;
    if (0, $66f4856a3e73d5a4$export$2e2bcd8739ae039) {
        var result = data[key];
        return result === $d7a01c39f048daff$var$HASH_UNDEFINED ? undefined : result;
    }
    return $d7a01c39f048daff$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $d7a01c39f048daff$export$2e2bcd8739ae039 = $d7a01c39f048daff$var$hashGet;



/** Used for built-in method references. */ var $32fd91ebb78d505b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $32fd91ebb78d505b$var$hasOwnProperty = $32fd91ebb78d505b$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $32fd91ebb78d505b$var$hashHas(key) {
    var data = this.__data__;
    return (0, $66f4856a3e73d5a4$export$2e2bcd8739ae039) ? data[key] !== undefined : $32fd91ebb78d505b$var$hasOwnProperty.call(data, key);
}
var $32fd91ebb78d505b$export$2e2bcd8739ae039 = $32fd91ebb78d505b$var$hashHas;



/** Used to stand-in for `undefined` hash values. */ var $04f0209a4f602dfa$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $04f0209a4f602dfa$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $66f4856a3e73d5a4$export$2e2bcd8739ae039) && value === undefined ? $04f0209a4f602dfa$var$HASH_UNDEFINED : value;
    return this;
}
var $04f0209a4f602dfa$export$2e2bcd8739ae039 = $04f0209a4f602dfa$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $31d1c4dcfddfec45$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$31d1c4dcfddfec45$var$Hash.prototype.clear = (0, $5c97d59cef0323a9$export$2e2bcd8739ae039);
$31d1c4dcfddfec45$var$Hash.prototype['delete'] = (0, $2d57a4cfc75fe532$export$2e2bcd8739ae039);
$31d1c4dcfddfec45$var$Hash.prototype.get = (0, $d7a01c39f048daff$export$2e2bcd8739ae039);
$31d1c4dcfddfec45$var$Hash.prototype.has = (0, $32fd91ebb78d505b$export$2e2bcd8739ae039);
$31d1c4dcfddfec45$var$Hash.prototype.set = (0, $04f0209a4f602dfa$export$2e2bcd8739ae039);
var $31d1c4dcfddfec45$export$2e2bcd8739ae039 = $31d1c4dcfddfec45$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $6abd81e62f9678cb$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new (0, $31d1c4dcfddfec45$export$2e2bcd8739ae039),
        'map': new ((0, $a728fb45d90bee23$export$2e2bcd8739ae039) || (0, $bb72d5c5e4972f2b$export$2e2bcd8739ae039)),
        'string': new (0, $31d1c4dcfddfec45$export$2e2bcd8739ae039)
    };
}
var $6abd81e62f9678cb$export$2e2bcd8739ae039 = $6abd81e62f9678cb$var$mapCacheClear;


/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $5d925956b9442a7e$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
var $5d925956b9442a7e$export$2e2bcd8739ae039 = $5d925956b9442a7e$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $5ce5f89a69a8677a$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $5d925956b9442a7e$export$2e2bcd8739ae039)(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
var $5ce5f89a69a8677a$export$2e2bcd8739ae039 = $5ce5f89a69a8677a$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $593291dd61f45bea$var$mapCacheDelete(key) {
    var result = (0, $5ce5f89a69a8677a$export$2e2bcd8739ae039)(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $593291dd61f45bea$export$2e2bcd8739ae039 = $593291dd61f45bea$var$mapCacheDelete;



/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $ea8e6b75bd934fd8$var$mapCacheGet(key) {
    return (0, $5ce5f89a69a8677a$export$2e2bcd8739ae039)(this, key).get(key);
}
var $ea8e6b75bd934fd8$export$2e2bcd8739ae039 = $ea8e6b75bd934fd8$var$mapCacheGet;



/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $1bcd8ddf34067b4c$var$mapCacheHas(key) {
    return (0, $5ce5f89a69a8677a$export$2e2bcd8739ae039)(this, key).has(key);
}
var $1bcd8ddf34067b4c$export$2e2bcd8739ae039 = $1bcd8ddf34067b4c$var$mapCacheHas;



/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $1d396df710191adf$var$mapCacheSet(key, value) {
    var data = (0, $5ce5f89a69a8677a$export$2e2bcd8739ae039)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $1d396df710191adf$export$2e2bcd8739ae039 = $1d396df710191adf$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $9199a9f997152e3f$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$9199a9f997152e3f$var$MapCache.prototype.clear = (0, $6abd81e62f9678cb$export$2e2bcd8739ae039);
$9199a9f997152e3f$var$MapCache.prototype['delete'] = (0, $593291dd61f45bea$export$2e2bcd8739ae039);
$9199a9f997152e3f$var$MapCache.prototype.get = (0, $ea8e6b75bd934fd8$export$2e2bcd8739ae039);
$9199a9f997152e3f$var$MapCache.prototype.has = (0, $1bcd8ddf34067b4c$export$2e2bcd8739ae039);
$9199a9f997152e3f$var$MapCache.prototype.set = (0, $1d396df710191adf$export$2e2bcd8739ae039);
var $9199a9f997152e3f$export$2e2bcd8739ae039 = $9199a9f997152e3f$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $64e222dfd76618e3$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $64e222dfd76618e3$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $bb72d5c5e4972f2b$export$2e2bcd8739ae039)) {
        var pairs = data.__data__;
        if (!(0, $a728fb45d90bee23$export$2e2bcd8739ae039) || pairs.length < $64e222dfd76618e3$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $9199a9f997152e3f$export$2e2bcd8739ae039)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $64e222dfd76618e3$export$2e2bcd8739ae039 = $64e222dfd76618e3$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $943244c58bd28e87$var$Stack(entries) {
    var data = this.__data__ = new (0, $bb72d5c5e4972f2b$export$2e2bcd8739ae039)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$943244c58bd28e87$var$Stack.prototype.clear = (0, $1840c4bc332fa4d5$export$2e2bcd8739ae039);
$943244c58bd28e87$var$Stack.prototype['delete'] = (0, $9ca32999a70c2b11$export$2e2bcd8739ae039);
$943244c58bd28e87$var$Stack.prototype.get = (0, $71a3442eb92f6299$export$2e2bcd8739ae039);
$943244c58bd28e87$var$Stack.prototype.has = (0, $56fab5b80b72764b$export$2e2bcd8739ae039);
$943244c58bd28e87$var$Stack.prototype.set = (0, $64e222dfd76618e3$export$2e2bcd8739ae039);
var $943244c58bd28e87$export$2e2bcd8739ae039 = $943244c58bd28e87$var$Stack;



var $e347eb62075e3d3a$var$defineProperty = function() {
    try {
        var func = (0, $c3b3bf1710191a20$export$2e2bcd8739ae039)(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
var $e347eb62075e3d3a$export$2e2bcd8739ae039 = $e347eb62075e3d3a$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $0399d968baf7fafe$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && (0, $e347eb62075e3d3a$export$2e2bcd8739ae039)) (0, $e347eb62075e3d3a$export$2e2bcd8739ae039)(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
var $0399d968baf7fafe$export$2e2bcd8739ae039 = $0399d968baf7fafe$var$baseAssignValue;



/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $680e12afb219d8d3$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !(0, $20348e11d29d6c7e$export$2e2bcd8739ae039)(object[key], value) || value === undefined && !(key in object)) (0, $0399d968baf7fafe$export$2e2bcd8739ae039)(object, key, value);
}
var $680e12afb219d8d3$export$2e2bcd8739ae039 = $680e12afb219d8d3$var$assignMergeValue;


/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $d8b68fede41de8c1$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
var $d8b68fede41de8c1$export$2e2bcd8739ae039 = $d8b68fede41de8c1$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $41177e2198f69c3b$var$baseFor = (0, $d8b68fede41de8c1$export$2e2bcd8739ae039)();
var $41177e2198f69c3b$export$2e2bcd8739ae039 = $41177e2198f69c3b$var$baseFor;




var $5cQSY = parcelRequire("5cQSY");

var $88ff1 = parcelRequire("88ff1");
/** Built-in value references. */ var $afedf5477d293e45$var$Uint8Array = (0, $88ff1.default).Uint8Array;
var $afedf5477d293e45$export$2e2bcd8739ae039 = $afedf5477d293e45$var$Uint8Array;


/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $2b1ef32634d08fa2$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $afedf5477d293e45$export$2e2bcd8739ae039)(result).set(new (0, $afedf5477d293e45$export$2e2bcd8739ae039)(arrayBuffer));
    return result;
}
var $2b1ef32634d08fa2$export$2e2bcd8739ae039 = $2b1ef32634d08fa2$var$cloneArrayBuffer;


/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $cf12e69f5523e68d$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $2b1ef32634d08fa2$export$2e2bcd8739ae039)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $cf12e69f5523e68d$export$2e2bcd8739ae039 = $cf12e69f5523e68d$var$cloneTypedArray;


/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $c2b736eebac175e8$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $c2b736eebac175e8$export$2e2bcd8739ae039 = $c2b736eebac175e8$var$copyArray;



/** Built-in value references. */ var $53948dd96078a616$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $53948dd96078a616$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $3a5d5535658447fe$export$2e2bcd8739ae039)(proto)) return {};
        if ($53948dd96078a616$var$objectCreate) return $53948dd96078a616$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $53948dd96078a616$export$2e2bcd8739ae039 = $53948dd96078a616$var$baseCreate;


/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $61c400371ba6a7c9$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $61c400371ba6a7c9$export$2e2bcd8739ae039 = $61c400371ba6a7c9$var$overArg;


/** Built-in value references. */ var $47def465b108965d$var$getPrototype = (0, $61c400371ba6a7c9$export$2e2bcd8739ae039)(Object.getPrototypeOf, Object);
var $47def465b108965d$export$2e2bcd8739ae039 = $47def465b108965d$var$getPrototype;


/** Used for built-in method references. */ var $85bd9a7c9846241d$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $85bd9a7c9846241d$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $85bd9a7c9846241d$var$objectProto;
    return value === proto;
}
var $85bd9a7c9846241d$export$2e2bcd8739ae039 = $85bd9a7c9846241d$var$isPrototype;


/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $8a20df450d7fa267$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !(0, $85bd9a7c9846241d$export$2e2bcd8739ae039)(object) ? (0, $53948dd96078a616$export$2e2bcd8739ae039)((0, $47def465b108965d$export$2e2bcd8739ae039)(object)) : {};
}
var $8a20df450d7fa267$export$2e2bcd8739ae039 = $8a20df450d7fa267$var$initCloneObject;



/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $c01ca98128351866$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $c01ca98128351866$export$2e2bcd8739ae039 = $c01ca98128351866$var$isObjectLike;


/** `Object#toString` result references. */ var $255c27faa1efd804$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $255c27faa1efd804$var$baseIsArguments(value) {
    return (0, $c01ca98128351866$export$2e2bcd8739ae039)(value) && (0, $78d0e963301c7165$export$2e2bcd8739ae039)(value) == $255c27faa1efd804$var$argsTag;
}
var $255c27faa1efd804$export$2e2bcd8739ae039 = $255c27faa1efd804$var$baseIsArguments;



/** Used for built-in method references. */ var $f532c2ab54a17342$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f532c2ab54a17342$var$hasOwnProperty = $f532c2ab54a17342$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $f532c2ab54a17342$var$propertyIsEnumerable = $f532c2ab54a17342$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $f532c2ab54a17342$var$isArguments = (0, $255c27faa1efd804$export$2e2bcd8739ae039)(function() {
    return arguments;
}()) ? (0, $255c27faa1efd804$export$2e2bcd8739ae039) : function(value) {
    return (0, $c01ca98128351866$export$2e2bcd8739ae039)(value) && $f532c2ab54a17342$var$hasOwnProperty.call(value, 'callee') && !$f532c2ab54a17342$var$propertyIsEnumerable.call(value, 'callee');
};
var $f532c2ab54a17342$export$2e2bcd8739ae039 = $f532c2ab54a17342$var$isArguments;


/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $4e89eca7c168bf58$var$isArray = Array.isArray;
var $4e89eca7c168bf58$export$2e2bcd8739ae039 = $4e89eca7c168bf58$var$isArray;



/** Used as references for various `Number` constants. */ var $00ca08e227cc81d0$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $00ca08e227cc81d0$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $00ca08e227cc81d0$var$MAX_SAFE_INTEGER;
}
var $00ca08e227cc81d0$export$2e2bcd8739ae039 = $00ca08e227cc81d0$var$isLength;


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $54bd1a68a2c78ec4$var$isArrayLike(value) {
    return value != null && (0, $00ca08e227cc81d0$export$2e2bcd8739ae039)(value.length) && !(0, $cd7e0f735b5159c6$export$2e2bcd8739ae039)(value);
}
var $54bd1a68a2c78ec4$export$2e2bcd8739ae039 = $54bd1a68a2c78ec4$var$isArrayLike;



/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $e5cd0a881ecdaea4$var$isArrayLikeObject(value) {
    return (0, $c01ca98128351866$export$2e2bcd8739ae039)(value) && (0, $54bd1a68a2c78ec4$export$2e2bcd8739ae039)(value);
}
var $e5cd0a881ecdaea4$export$2e2bcd8739ae039 = $e5cd0a881ecdaea4$var$isArrayLikeObject;



var $kaMt5 = parcelRequire("kaMt5");





/** `Object#toString` result references. */ var $705ed8e84949ce80$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $705ed8e84949ce80$var$funcProto = Function.prototype, $705ed8e84949ce80$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $705ed8e84949ce80$var$funcToString = $705ed8e84949ce80$var$funcProto.toString;
/** Used to check objects for own properties. */ var $705ed8e84949ce80$var$hasOwnProperty = $705ed8e84949ce80$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $705ed8e84949ce80$var$objectCtorString = $705ed8e84949ce80$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $705ed8e84949ce80$var$isPlainObject(value) {
    if (!(0, $c01ca98128351866$export$2e2bcd8739ae039)(value) || (0, $78d0e963301c7165$export$2e2bcd8739ae039)(value) != $705ed8e84949ce80$var$objectTag) return false;
    var proto = (0, $47def465b108965d$export$2e2bcd8739ae039)(value);
    if (proto === null) return true;
    var Ctor = $705ed8e84949ce80$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $705ed8e84949ce80$var$funcToString.call(Ctor) == $705ed8e84949ce80$var$objectCtorString;
}
var $705ed8e84949ce80$export$2e2bcd8739ae039 = $705ed8e84949ce80$var$isPlainObject;





/** `Object#toString` result references. */ var $6218bc63f13b744d$var$argsTag = '[object Arguments]', $6218bc63f13b744d$var$arrayTag = '[object Array]', $6218bc63f13b744d$var$boolTag = '[object Boolean]', $6218bc63f13b744d$var$dateTag = '[object Date]', $6218bc63f13b744d$var$errorTag = '[object Error]', $6218bc63f13b744d$var$funcTag = '[object Function]', $6218bc63f13b744d$var$mapTag = '[object Map]', $6218bc63f13b744d$var$numberTag = '[object Number]', $6218bc63f13b744d$var$objectTag = '[object Object]', $6218bc63f13b744d$var$regexpTag = '[object RegExp]', $6218bc63f13b744d$var$setTag = '[object Set]', $6218bc63f13b744d$var$stringTag = '[object String]', $6218bc63f13b744d$var$weakMapTag = '[object WeakMap]';
var $6218bc63f13b744d$var$arrayBufferTag = '[object ArrayBuffer]', $6218bc63f13b744d$var$dataViewTag = '[object DataView]', $6218bc63f13b744d$var$float32Tag = '[object Float32Array]', $6218bc63f13b744d$var$float64Tag = '[object Float64Array]', $6218bc63f13b744d$var$int8Tag = '[object Int8Array]', $6218bc63f13b744d$var$int16Tag = '[object Int16Array]', $6218bc63f13b744d$var$int32Tag = '[object Int32Array]', $6218bc63f13b744d$var$uint8Tag = '[object Uint8Array]', $6218bc63f13b744d$var$uint8ClampedTag = '[object Uint8ClampedArray]', $6218bc63f13b744d$var$uint16Tag = '[object Uint16Array]', $6218bc63f13b744d$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $6218bc63f13b744d$var$typedArrayTags = {};
$6218bc63f13b744d$var$typedArrayTags[$6218bc63f13b744d$var$float32Tag] = $6218bc63f13b744d$var$typedArrayTags[$6218bc63f13b744d$var$float64Tag] = $6218bc63f13b744d$var$typedArrayTags[$6218bc63f13b744d$var$int8Tag] = $6218bc63f13b744d$var$typedArrayTags[$6218bc63f13b744d$var$int16Tag] = $6218bc63f13b744d$var$typedArrayTags[$6218bc63f13b744d$var$int32Tag] = $6218bc63f13b744d$var$typedArrayTags[$6218bc63f13b744d$var$uint8Tag] = $6218bc63f13b744d$var$typedArrayTags[$6218bc63f13b744d$var$uint8ClampedTag] = $6218bc63f13b744d$var$typedArrayTags[$6218bc63f13b744d$var$uint16Tag] = $6218bc63f13b744d$var$typedArrayTags[$6218bc63f13b744d$var$uint32Tag] = true;
$6218bc63f13b744d$var$typedArrayTags[$6218bc63f13b744d$var$argsTag] = $6218bc63f13b744d$var$typedArrayTags[$6218bc63f13b744d$var$arrayTag] = $6218bc63f13b744d$var$typedArrayTags[$6218bc63f13b744d$var$arrayBufferTag] = $6218bc63f13b744d$var$typedArrayTags[$6218bc63f13b744d$var$boolTag] = $6218bc63f13b744d$var$typedArrayTags[$6218bc63f13b744d$var$dataViewTag] = $6218bc63f13b744d$var$typedArrayTags[$6218bc63f13b744d$var$dateTag] = $6218bc63f13b744d$var$typedArrayTags[$6218bc63f13b744d$var$errorTag] = $6218bc63f13b744d$var$typedArrayTags[$6218bc63f13b744d$var$funcTag] = $6218bc63f13b744d$var$typedArrayTags[$6218bc63f13b744d$var$mapTag] = $6218bc63f13b744d$var$typedArrayTags[$6218bc63f13b744d$var$numberTag] = $6218bc63f13b744d$var$typedArrayTags[$6218bc63f13b744d$var$objectTag] = $6218bc63f13b744d$var$typedArrayTags[$6218bc63f13b744d$var$regexpTag] = $6218bc63f13b744d$var$typedArrayTags[$6218bc63f13b744d$var$setTag] = $6218bc63f13b744d$var$typedArrayTags[$6218bc63f13b744d$var$stringTag] = $6218bc63f13b744d$var$typedArrayTags[$6218bc63f13b744d$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $6218bc63f13b744d$var$baseIsTypedArray(value) {
    return (0, $c01ca98128351866$export$2e2bcd8739ae039)(value) && (0, $00ca08e227cc81d0$export$2e2bcd8739ae039)(value.length) && !!$6218bc63f13b744d$var$typedArrayTags[(0, $78d0e963301c7165$export$2e2bcd8739ae039)(value)];
}
var $6218bc63f13b744d$export$2e2bcd8739ae039 = $6218bc63f13b744d$var$baseIsTypedArray;


/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $9a876a340d0eaf8a$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $9a876a340d0eaf8a$export$2e2bcd8739ae039 = $9a876a340d0eaf8a$var$baseUnary;



var $ecuFs = parcelRequire("ecuFs");
/* Node.js helper references. */ var $400b674b6154a343$var$nodeIsTypedArray = (0, $ecuFs.default) && (0, $ecuFs.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $400b674b6154a343$var$isTypedArray = $400b674b6154a343$var$nodeIsTypedArray ? (0, $9a876a340d0eaf8a$export$2e2bcd8739ae039)($400b674b6154a343$var$nodeIsTypedArray) : (0, $6218bc63f13b744d$export$2e2bcd8739ae039);
var $400b674b6154a343$export$2e2bcd8739ae039 = $400b674b6154a343$var$isTypedArray;


/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $309c733a9a85e4a8$var$safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
var $309c733a9a85e4a8$export$2e2bcd8739ae039 = $309c733a9a85e4a8$var$safeGet;




/** Used for built-in method references. */ var $dcc404d101cbff62$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dcc404d101cbff62$var$hasOwnProperty = $dcc404d101cbff62$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $dcc404d101cbff62$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($dcc404d101cbff62$var$hasOwnProperty.call(object, key) && (0, $20348e11d29d6c7e$export$2e2bcd8739ae039)(objValue, value)) || value === undefined && !(key in object)) (0, $0399d968baf7fafe$export$2e2bcd8739ae039)(object, key, value);
}
var $dcc404d101cbff62$export$2e2bcd8739ae039 = $dcc404d101cbff62$var$assignValue;



/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $d40ce3979824f6d6$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $0399d968baf7fafe$export$2e2bcd8739ae039)(object, key, newValue);
        else (0, $dcc404d101cbff62$export$2e2bcd8739ae039)(object, key, newValue);
    }
    return object;
}
var $d40ce3979824f6d6$export$2e2bcd8739ae039 = $d40ce3979824f6d6$var$copyObject;


/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $68a15a1f1d8bbe62$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $68a15a1f1d8bbe62$export$2e2bcd8739ae039 = $68a15a1f1d8bbe62$var$baseTimes;





var $kaMt5 = parcelRequire("kaMt5");
/** Used as references for various `Number` constants. */ var $e6573ced148df7ca$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $e6573ced148df7ca$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $e6573ced148df7ca$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $e6573ced148df7ca$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $e6573ced148df7ca$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $e6573ced148df7ca$export$2e2bcd8739ae039 = $e6573ced148df7ca$var$isIndex;



/** Used for built-in method references. */ var $6dbf92121a2a1c55$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $6dbf92121a2a1c55$var$hasOwnProperty = $6dbf92121a2a1c55$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $6dbf92121a2a1c55$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $4e89eca7c168bf58$export$2e2bcd8739ae039)(value), isArg = !isArr && (0, $f532c2ab54a17342$export$2e2bcd8739ae039)(value), isBuff = !isArr && !isArg && (0, $kaMt5.default)(value), isType = !isArr && !isArg && !isBuff && (0, $400b674b6154a343$export$2e2bcd8739ae039)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $68a15a1f1d8bbe62$export$2e2bcd8739ae039)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $6dbf92121a2a1c55$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    (0, $e6573ced148df7ca$export$2e2bcd8739ae039)(key, length)))) result.push(key);
    return result;
}
var $6dbf92121a2a1c55$export$2e2bcd8739ae039 = $6dbf92121a2a1c55$var$arrayLikeKeys;




/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $6593578f8a93ac4c$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $6593578f8a93ac4c$export$2e2bcd8739ae039 = $6593578f8a93ac4c$var$nativeKeysIn;


/** Used for built-in method references. */ var $5c62b7750ac376c7$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $5c62b7750ac376c7$var$hasOwnProperty = $5c62b7750ac376c7$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $5c62b7750ac376c7$var$baseKeysIn(object) {
    if (!(0, $3a5d5535658447fe$export$2e2bcd8739ae039)(object)) return (0, $6593578f8a93ac4c$export$2e2bcd8739ae039)(object);
    var isProto = (0, $85bd9a7c9846241d$export$2e2bcd8739ae039)(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$5c62b7750ac376c7$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $5c62b7750ac376c7$export$2e2bcd8739ae039 = $5c62b7750ac376c7$var$baseKeysIn;



/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $d231563e6e05952c$var$keysIn(object) {
    return (0, $54bd1a68a2c78ec4$export$2e2bcd8739ae039)(object) ? (0, $6dbf92121a2a1c55$export$2e2bcd8739ae039)(object, true) : (0, $5c62b7750ac376c7$export$2e2bcd8739ae039)(object);
}
var $d231563e6e05952c$export$2e2bcd8739ae039 = $d231563e6e05952c$var$keysIn;


/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $aa79638aef3b6a45$var$toPlainObject(value) {
    return (0, $d40ce3979824f6d6$export$2e2bcd8739ae039)(value, (0, $d231563e6e05952c$export$2e2bcd8739ae039)(value));
}
var $aa79638aef3b6a45$export$2e2bcd8739ae039 = $aa79638aef3b6a45$var$toPlainObject;


/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $c3ee577b78c2e981$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = (0, $309c733a9a85e4a8$export$2e2bcd8739ae039)(object, key), srcValue = (0, $309c733a9a85e4a8$export$2e2bcd8739ae039)(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        (0, $680e12afb219d8d3$export$2e2bcd8739ae039)(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = (0, $4e89eca7c168bf58$export$2e2bcd8739ae039)(srcValue), isBuff = !isArr && (0, $kaMt5.default)(srcValue), isTyped = !isArr && !isBuff && (0, $400b674b6154a343$export$2e2bcd8739ae039)(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ((0, $4e89eca7c168bf58$export$2e2bcd8739ae039)(objValue)) newValue = objValue;
            else if ((0, $e5cd0a881ecdaea4$export$2e2bcd8739ae039)(objValue)) newValue = (0, $c2b736eebac175e8$export$2e2bcd8739ae039)(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = (0, $5cQSY.default)(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = (0, $cf12e69f5523e68d$export$2e2bcd8739ae039)(srcValue, true);
            } else newValue = [];
        } else if ((0, $705ed8e84949ce80$export$2e2bcd8739ae039)(srcValue) || (0, $f532c2ab54a17342$export$2e2bcd8739ae039)(srcValue)) {
            newValue = objValue;
            if ((0, $f532c2ab54a17342$export$2e2bcd8739ae039)(objValue)) newValue = (0, $aa79638aef3b6a45$export$2e2bcd8739ae039)(objValue);
            else if (!(0, $3a5d5535658447fe$export$2e2bcd8739ae039)(objValue) || (0, $cd7e0f735b5159c6$export$2e2bcd8739ae039)(objValue)) newValue = (0, $8a20df450d7fa267$export$2e2bcd8739ae039)(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    (0, $680e12afb219d8d3$export$2e2bcd8739ae039)(object, key, newValue);
}
var $c3ee577b78c2e981$export$2e2bcd8739ae039 = $c3ee577b78c2e981$var$baseMergeDeep;





/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $662c39c476d30066$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    (0, $41177e2198f69c3b$export$2e2bcd8739ae039)(source, function(srcValue, key) {
        stack || (stack = new (0, $943244c58bd28e87$export$2e2bcd8739ae039));
        if ((0, $3a5d5535658447fe$export$2e2bcd8739ae039)(srcValue)) (0, $c3ee577b78c2e981$export$2e2bcd8739ae039)(object, source, key, srcIndex, $662c39c476d30066$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer((0, $309c733a9a85e4a8$export$2e2bcd8739ae039)(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            (0, $680e12afb219d8d3$export$2e2bcd8739ae039)(object, key, newValue);
        }
    }, (0, $d231563e6e05952c$export$2e2bcd8739ae039));
}
var $662c39c476d30066$export$2e2bcd8739ae039 = $662c39c476d30066$var$baseMerge;


/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $ccf754f92b5d06ef$var$identity(value) {
    return value;
}
var $ccf754f92b5d06ef$export$2e2bcd8739ae039 = $ccf754f92b5d06ef$var$identity;


/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $57e159b6d09a59ac$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
var $57e159b6d09a59ac$export$2e2bcd8739ae039 = $57e159b6d09a59ac$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $a2d0d48a281d9048$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $a2d0d48a281d9048$var$overRest(func, start, transform) {
    start = $a2d0d48a281d9048$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $a2d0d48a281d9048$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return (0, $57e159b6d09a59ac$export$2e2bcd8739ae039)(func, this, otherArgs);
    };
}
var $a2d0d48a281d9048$export$2e2bcd8739ae039 = $a2d0d48a281d9048$var$overRest;


/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $5a50549e4b94b408$var$constant(value) {
    return function() {
        return value;
    };
}
var $5a50549e4b94b408$export$2e2bcd8739ae039 = $5a50549e4b94b408$var$constant;




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $55b75401d6b3dccd$var$baseSetToString = !(0, $e347eb62075e3d3a$export$2e2bcd8739ae039) ? (0, $ccf754f92b5d06ef$export$2e2bcd8739ae039) : function(func, string) {
    return (0, $e347eb62075e3d3a$export$2e2bcd8739ae039)(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': (0, $5a50549e4b94b408$export$2e2bcd8739ae039)(string),
        'writable': true
    });
};
var $55b75401d6b3dccd$export$2e2bcd8739ae039 = $55b75401d6b3dccd$var$baseSetToString;


/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $1f831a440a5c48db$var$HOT_COUNT = 800, $1f831a440a5c48db$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $1f831a440a5c48db$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $1f831a440a5c48db$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $1f831a440a5c48db$var$nativeNow(), remaining = $1f831a440a5c48db$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $1f831a440a5c48db$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
var $1f831a440a5c48db$export$2e2bcd8739ae039 = $1f831a440a5c48db$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $48221f5d0edf1987$var$setToString = (0, $1f831a440a5c48db$export$2e2bcd8739ae039)((0, $55b75401d6b3dccd$export$2e2bcd8739ae039));
var $48221f5d0edf1987$export$2e2bcd8739ae039 = $48221f5d0edf1987$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $a187b798eb14790b$var$baseRest(func, start) {
    return (0, $48221f5d0edf1987$export$2e2bcd8739ae039)((0, $a2d0d48a281d9048$export$2e2bcd8739ae039)(func, start, (0, $ccf754f92b5d06ef$export$2e2bcd8739ae039)), func + '');
}
var $a187b798eb14790b$export$2e2bcd8739ae039 = $a187b798eb14790b$var$baseRest;






/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $134fb6c1a09c2307$var$isIterateeCall(value, index, object) {
    if (!(0, $3a5d5535658447fe$export$2e2bcd8739ae039)(object)) return false;
    var type = typeof index;
    if (type == 'number' ? (0, $54bd1a68a2c78ec4$export$2e2bcd8739ae039)(object) && (0, $e6573ced148df7ca$export$2e2bcd8739ae039)(index, object.length) : type == 'string' && index in object) return (0, $20348e11d29d6c7e$export$2e2bcd8739ae039)(object[index], value);
    return false;
}
var $134fb6c1a09c2307$export$2e2bcd8739ae039 = $134fb6c1a09c2307$var$isIterateeCall;


/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $28db9ce8942174e9$var$createAssigner(assigner) {
    return (0, $a187b798eb14790b$export$2e2bcd8739ae039)(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && (0, $134fb6c1a09c2307$export$2e2bcd8739ae039)(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
var $28db9ce8942174e9$export$2e2bcd8739ae039 = $28db9ce8942174e9$var$createAssigner;


/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $2b042368e2ec1525$var$merge = (0, $28db9ce8942174e9$export$2e2bcd8739ae039)(function(object, source, srcIndex) {
    (0, $662c39c476d30066$export$2e2bcd8739ae039)(object, source, srcIndex);
});
var $2b042368e2ec1525$export$2e2bcd8739ae039 = $2b042368e2ec1525$var$merge;


var $7eb330dc2b73c9b0$export$5eec0980ed568dae = function Raised(_ref) {
    var zDepth = _ref.zDepth, radius = _ref.radius, background = _ref.background, children = _ref.children, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($c8d725e5ba719c3a$exports)))((0, $2b042368e2ec1525$export$2e2bcd8739ae039)({
        'default': {
            wrap: {
                position: 'relative',
                display: 'inline-block'
            },
            content: {
                position: 'relative'
            },
            bg: {
                absolute: '0px 0px 0px 0px',
                boxShadow: '0 ' + zDepth + 'px ' + zDepth * 4 + 'px rgba(0,0,0,.24)',
                borderRadius: radius,
                background: background
            }
        },
        'zDepth-0': {
            bg: {
                boxShadow: 'none'
            }
        },
        'zDepth-1': {
            bg: {
                boxShadow: '0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)'
            }
        },
        'zDepth-2': {
            bg: {
                boxShadow: '0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)'
            }
        },
        'zDepth-3': {
            bg: {
                boxShadow: '0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)'
            }
        },
        'zDepth-4': {
            bg: {
                boxShadow: '0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)'
            }
        },
        'zDepth-5': {
            bg: {
                boxShadow: '0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)'
            }
        },
        'square': {
            bg: {
                borderRadius: '0'
            }
        },
        'circle': {
            bg: {
                borderRadius: '50%'
            }
        }
    }, passedStyles), {
        'zDepth-1': zDepth === 1
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.wrap
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.bg
    }), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.content
    }, children));
};
$7eb330dc2b73c9b0$export$5eec0980ed568dae.propTypes = {
    background: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
    zDepth: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOf([
        0,
        1,
        2,
        3,
        4,
        5
    ]),
    radius: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).number,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).object
};
$7eb330dc2b73c9b0$export$5eec0980ed568dae.defaultProps = {
    background: '#fff',
    zDepth: 1,
    radius: 2,
    styles: {}
};
var $7eb330dc2b73c9b0$export$2e2bcd8739ae039 = $7eb330dc2b73c9b0$export$5eec0980ed568dae;



var $5E6i4 = parcelRequire("5E6i4");



var $88ff1 = parcelRequire("88ff1");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $6ff6148e719e3675$var$now = function() {
    return (0, $88ff1.default).Date.now();
};
var $6ff6148e719e3675$export$2e2bcd8739ae039 = $6ff6148e719e3675$var$now;


/** Used to match a single whitespace character. */ var $ec4c047b7a2d9ae6$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $ec4c047b7a2d9ae6$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $ec4c047b7a2d9ae6$var$reWhitespace.test(string.charAt(index)));
    return index;
}
var $ec4c047b7a2d9ae6$export$2e2bcd8739ae039 = $ec4c047b7a2d9ae6$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $3275aad1f9ac49f2$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $3275aad1f9ac49f2$var$baseTrim(string) {
    return string ? string.slice(0, (0, $ec4c047b7a2d9ae6$export$2e2bcd8739ae039)(string) + 1).replace($3275aad1f9ac49f2$var$reTrimStart, '') : string;
}
var $3275aad1f9ac49f2$export$2e2bcd8739ae039 = $3275aad1f9ac49f2$var$baseTrim;





/** `Object#toString` result references. */ var $8d54cd76e2aab7af$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $8d54cd76e2aab7af$var$isSymbol(value) {
    return typeof value == 'symbol' || (0, $c01ca98128351866$export$2e2bcd8739ae039)(value) && (0, $78d0e963301c7165$export$2e2bcd8739ae039)(value) == $8d54cd76e2aab7af$var$symbolTag;
}
var $8d54cd76e2aab7af$export$2e2bcd8739ae039 = $8d54cd76e2aab7af$var$isSymbol;


/** Used as references for various `Number` constants. */ var $6285f1f0dda12671$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $6285f1f0dda12671$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $6285f1f0dda12671$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $6285f1f0dda12671$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $6285f1f0dda12671$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $6285f1f0dda12671$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ((0, $8d54cd76e2aab7af$export$2e2bcd8739ae039)(value)) return $6285f1f0dda12671$var$NAN;
    if ((0, $3a5d5535658447fe$export$2e2bcd8739ae039)(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = (0, $3a5d5535658447fe$export$2e2bcd8739ae039)(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = (0, $3275aad1f9ac49f2$export$2e2bcd8739ae039)(value);
    var isBinary = $6285f1f0dda12671$var$reIsBinary.test(value);
    return isBinary || $6285f1f0dda12671$var$reIsOctal.test(value) ? $6285f1f0dda12671$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $6285f1f0dda12671$var$reIsBadHex.test(value) ? $6285f1f0dda12671$var$NAN : +value;
}
var $6285f1f0dda12671$export$2e2bcd8739ae039 = $6285f1f0dda12671$var$toNumber;


/** Error message constants. */ var $7e93a5822d5a817f$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $7e93a5822d5a817f$var$nativeMax = Math.max, $7e93a5822d5a817f$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $7e93a5822d5a817f$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($7e93a5822d5a817f$var$FUNC_ERROR_TEXT);
    wait = (0, $6285f1f0dda12671$export$2e2bcd8739ae039)(wait) || 0;
    if ((0, $3a5d5535658447fe$export$2e2bcd8739ae039)(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $7e93a5822d5a817f$var$nativeMax((0, $6285f1f0dda12671$export$2e2bcd8739ae039)(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $7e93a5822d5a817f$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = (0, $6ff6148e719e3675$export$2e2bcd8739ae039)();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge((0, $6ff6148e719e3675$export$2e2bcd8739ae039)());
    }
    function debounced() {
        var time = (0, $6ff6148e719e3675$export$2e2bcd8739ae039)(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
var $7e93a5822d5a817f$export$2e2bcd8739ae039 = $7e93a5822d5a817f$var$debounce;



/** Error message constants. */ var $8aaa3b5c6ea991da$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $8aaa3b5c6ea991da$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($8aaa3b5c6ea991da$var$FUNC_ERROR_TEXT);
    if ((0, $3a5d5535658447fe$export$2e2bcd8739ae039)(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return (0, $7e93a5822d5a817f$export$2e2bcd8739ae039)(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
var $8aaa3b5c6ea991da$export$2e2bcd8739ae039 = $8aaa3b5c6ea991da$var$throttle;


var $b4a90fbaacaca737$export$a056a977bf6a9a3c = function calculateChange(e, hsl, container) {
    var _container$getBoundin = container.getBoundingClientRect(), containerWidth = _container$getBoundin.width, containerHeight = _container$getBoundin.height;
    var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (left < 0) left = 0;
    else if (left > containerWidth) left = containerWidth;
    if (top < 0) top = 0;
    else if (top > containerHeight) top = containerHeight;
    var saturation = left / containerWidth;
    var bright = 1 - top / containerHeight;
    return {
        h: hsl.h,
        s: saturation,
        v: bright,
        a: hsl.a,
        source: 'hsv'
    };
};


var $93b5269a0cba01ab$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $93b5269a0cba01ab$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $93b5269a0cba01ab$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $93b5269a0cba01ab$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $93b5269a0cba01ab$export$c4dbe12ffaee3c8e = function(_ref) {
    $93b5269a0cba01ab$var$_inherits(Saturation, _ref);
    function Saturation(props) {
        $93b5269a0cba01ab$var$_classCallCheck(this, Saturation);
        var _this = $93b5269a0cba01ab$var$_possibleConstructorReturn(this, (Saturation.__proto__ || Object.getPrototypeOf(Saturation)).call(this, props));
        _this.handleChange = function(e) {
            typeof _this.props.onChange === 'function' && _this.throttle(_this.props.onChange, $b4a90fbaacaca737$export$a056a977bf6a9a3c(e, _this.props.hsl, _this.container), e);
        };
        _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            var renderWindow = _this.getContainerRenderWindow();
            renderWindow.addEventListener('mousemove', _this.handleChange);
            renderWindow.addEventListener('mouseup', _this.handleMouseUp);
        };
        _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        };
        _this.throttle = (0, $8aaa3b5c6ea991da$export$2e2bcd8739ae039)(function(fn, data, e) {
            fn(data, e);
        }, 50);
        return _this;
    }
    $93b5269a0cba01ab$var$_createClass(Saturation, [
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.throttle.cancel();
                this.unbindEventListeners();
            }
        },
        {
            key: 'getContainerRenderWindow',
            value: function getContainerRenderWindow() {
                var container = this.container;
                var renderWindow = window;
                while(!renderWindow.document.contains(container) && renderWindow.parent !== renderWindow)renderWindow = renderWindow.parent;
                return renderWindow;
            }
        },
        {
            key: 'unbindEventListeners',
            value: function unbindEventListeners() {
                var renderWindow = this.getContainerRenderWindow();
                renderWindow.removeEventListener('mousemove', this.handleChange);
                renderWindow.removeEventListener('mouseup', this.handleMouseUp);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var _ref2 = this.props.style || {}, color = _ref2.color, white = _ref2.white, black = _ref2.black, pointer = _ref2.pointer, circle = _ref2.circle;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($c8d725e5ba719c3a$exports)))({
                    'default': {
                        color: {
                            absolute: '0px 0px 0px 0px',
                            background: 'hsl(' + this.props.hsl.h + ',100%, 50%)',
                            borderRadius: this.props.radius
                        },
                        white: {
                            absolute: '0px 0px 0px 0px',
                            borderRadius: this.props.radius
                        },
                        black: {
                            absolute: '0px 0px 0px 0px',
                            boxShadow: this.props.shadow,
                            borderRadius: this.props.radius
                        },
                        pointer: {
                            position: 'absolute',
                            top: -(this.props.hsv.v * 100) + 100 + '%',
                            left: this.props.hsv.s * 100 + '%',
                            cursor: 'default'
                        },
                        circle: {
                            width: '4px',
                            height: '4px',
                            boxShadow: '0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),\n            0 0 1px 2px rgba(0,0,0,.4)',
                            borderRadius: '50%',
                            cursor: 'hand',
                            transform: 'translate(-2px, -2px)'
                        }
                    },
                    'custom': {
                        color: color,
                        white: white,
                        black: black,
                        pointer: pointer,
                        circle: circle
                    }
                }, {
                    'custom': !!this.props.style
                });
                return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
                    style: styles.color,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('style', null, '\n          .saturation-white {\n            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));\n            background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n          }\n          .saturation-black {\n            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));\n            background: linear-gradient(to top, #000, rgba(0,0,0,0));\n          }\n        '), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
                    style: styles.white,
                    className: 'saturation-white'
                }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
                    style: styles.black,
                    className: 'saturation-black'
                }), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
                    style: styles.pointer
                }, this.props.pointer ? (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement(this.props.pointer, this.props) : (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
                    style: styles.circle
                }))));
            }
        }
    ]);
    return Saturation;
}((0, $5E6i4.PureComponent) || (0, $5E6i4.Component));
var $93b5269a0cba01ab$export$2e2bcd8739ae039 = $93b5269a0cba01ab$export$c4dbe12ffaee3c8e;



var $5E6i4 = parcelRequire("5E6i4");

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $5334ca3f0b92932d$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $5334ca3f0b92932d$export$2e2bcd8739ae039 = $5334ca3f0b92932d$var$arrayEach;






/* Built-in method references for those with the same name as other `lodash` methods. */ var $82e396e01872d8bf$var$nativeKeys = (0, $61c400371ba6a7c9$export$2e2bcd8739ae039)(Object.keys, Object);
var $82e396e01872d8bf$export$2e2bcd8739ae039 = $82e396e01872d8bf$var$nativeKeys;


/** Used for built-in method references. */ var $b69b5e23097c4757$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b69b5e23097c4757$var$hasOwnProperty = $b69b5e23097c4757$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $b69b5e23097c4757$var$baseKeys(object) {
    if (!(0, $85bd9a7c9846241d$export$2e2bcd8739ae039)(object)) return (0, $82e396e01872d8bf$export$2e2bcd8739ae039)(object);
    var result = [];
    for(var key in Object(object))if ($b69b5e23097c4757$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
var $b69b5e23097c4757$export$2e2bcd8739ae039 = $b69b5e23097c4757$var$baseKeys;



/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $0305e0c44cc303ee$var$keys(object) {
    return (0, $54bd1a68a2c78ec4$export$2e2bcd8739ae039)(object) ? (0, $6dbf92121a2a1c55$export$2e2bcd8739ae039)(object) : (0, $b69b5e23097c4757$export$2e2bcd8739ae039)(object);
}
var $0305e0c44cc303ee$export$2e2bcd8739ae039 = $0305e0c44cc303ee$var$keys;


/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $07c5304cd9a13fbd$var$baseForOwn(object, iteratee) {
    return object && (0, $41177e2198f69c3b$export$2e2bcd8739ae039)(object, iteratee, (0, $0305e0c44cc303ee$export$2e2bcd8739ae039));
}
var $07c5304cd9a13fbd$export$2e2bcd8739ae039 = $07c5304cd9a13fbd$var$baseForOwn;



/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $ede11e916186f91a$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!(0, $54bd1a68a2c78ec4$export$2e2bcd8739ae039)(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
var $ede11e916186f91a$export$2e2bcd8739ae039 = $ede11e916186f91a$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $5309be07bb94a4b5$var$baseEach = (0, $ede11e916186f91a$export$2e2bcd8739ae039)((0, $07c5304cd9a13fbd$export$2e2bcd8739ae039));
var $5309be07bb94a4b5$export$2e2bcd8739ae039 = $5309be07bb94a4b5$var$baseEach;



/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $2bbb08d6a66b5d3e$var$castFunction(value) {
    return typeof value == 'function' ? value : (0, $ccf754f92b5d06ef$export$2e2bcd8739ae039);
}
var $2bbb08d6a66b5d3e$export$2e2bcd8739ae039 = $2bbb08d6a66b5d3e$var$castFunction;



/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $9a11e2ab7a2a368a$var$forEach(collection, iteratee) {
    var func = (0, $4e89eca7c168bf58$export$2e2bcd8739ae039)(collection) ? (0, $5334ca3f0b92932d$export$2e2bcd8739ae039) : (0, $5309be07bb94a4b5$export$2e2bcd8739ae039);
    return func(collection, (0, $2bbb08d6a66b5d3e$export$2e2bcd8739ae039)(iteratee));
}
var $9a11e2ab7a2a368a$export$2e2bcd8739ae039 = $9a11e2ab7a2a368a$var$forEach;



var $3e246347c8e3b5b0$export$4837207a530c7f21 = function simpleCheckForValidColor(data) {
    var keysToCheck = [
        'r',
        'g',
        'b',
        'a',
        'h',
        's',
        'l',
        'v'
    ];
    var checked = 0;
    var passed = 0;
    (0, $9a11e2ab7a2a368a$export$2e2bcd8739ae039)(keysToCheck, function(letter) {
        if (data[letter]) {
            checked += 1;
            if (!isNaN(data[letter])) passed += 1;
            if (letter === 's' || letter === 'l') {
                var percentPatt = /^\d+%$/;
                if (percentPatt.test(data[letter])) passed += 1;
            }
        }
    });
    return checked === passed ? data : false;
};
var $3e246347c8e3b5b0$export$6bed283375899438 = function toState(data, oldHue) {
    var color = data.hex ? (0, $a9ceb34ac62682a2$export$2e2bcd8739ae039)(data.hex) : (0, $a9ceb34ac62682a2$export$2e2bcd8739ae039)(data);
    var hsl = color.toHsl();
    var hsv = color.toHsv();
    var rgb = color.toRgb();
    var hex = color.toHex();
    if (hsl.s === 0) {
        hsl.h = oldHue || 0;
        hsv.h = oldHue || 0;
    }
    var transparent = hex === '000000' && rgb.a === 0;
    return {
        hsl: hsl,
        hex: transparent ? 'transparent' : '#' + hex,
        rgb: rgb,
        hsv: hsv,
        oldHue: data.h || oldHue || hsl.h,
        source: data.source
    };
};
var $3e246347c8e3b5b0$export$944f75ec5697b362 = function isValidHex(hex) {
    if (hex === 'transparent') return true;
    // disable hex4 and hex8
    var lh = String(hex).charAt(0) === '#' ? 1 : 0;
    return hex.length !== 4 + lh && hex.length < 7 + lh && (0, $a9ceb34ac62682a2$export$2e2bcd8739ae039)(hex).isValid();
};
var $3e246347c8e3b5b0$export$3609eb1d7e55dec = function getContrastingColor(data) {
    if (!data) return '#fff';
    var col = $3e246347c8e3b5b0$export$6bed283375899438(data);
    if (col.hex === 'transparent') return 'rgba(0,0,0,0.4)';
    var yiq = (col.rgb.r * 299 + col.rgb.g * 587 + col.rgb.b * 114) / 1000;
    return yiq >= 128 ? '#000' : '#fff';
};
var $3e246347c8e3b5b0$export$a90204d1394caf30 = {
    hsl: {
        a: 1,
        h: 0,
        l: 0.5,
        s: 1
    },
    hex: '#ff0000',
    rgb: {
        r: 255,
        g: 0,
        b: 0,
        a: 1
    },
    hsv: {
        h: 0,
        s: 1,
        v: 1,
        a: 1
    }
};
var $3e246347c8e3b5b0$export$e76ec4c5b3cadd73 = function isvalidColorString(string, type) {
    var stringWithoutDegree = string.replace("\xb0", '');
    return (0, $a9ceb34ac62682a2$export$2e2bcd8739ae039)(type + ' (' + stringWithoutDegree + ')')._ok;
};


var $d9d5623a706e13aa$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $d9d5623a706e13aa$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $d9d5623a706e13aa$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d9d5623a706e13aa$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $d9d5623a706e13aa$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $d9d5623a706e13aa$export$68265aef2e61bec7 = function ColorWrap(Picker) {
    var ColorPicker = function(_ref) {
        $d9d5623a706e13aa$var$_inherits(ColorPicker, _ref);
        function ColorPicker(props) {
            $d9d5623a706e13aa$var$_classCallCheck(this, ColorPicker);
            var _this = $d9d5623a706e13aa$var$_possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this));
            _this.handleChange = function(data, event) {
                var isValidColor = $3e246347c8e3b5b0$export$4837207a530c7f21(data);
                if (isValidColor) {
                    var colors = $3e246347c8e3b5b0$export$6bed283375899438(data, data.h || _this.state.oldHue);
                    _this.setState(colors);
                    _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, colors, event);
                    _this.props.onChange && _this.props.onChange(colors, event);
                }
            };
            _this.handleSwatchHover = function(data, event) {
                var isValidColor = $3e246347c8e3b5b0$export$4837207a530c7f21(data);
                if (isValidColor) {
                    var colors = $3e246347c8e3b5b0$export$6bed283375899438(data, data.h || _this.state.oldHue);
                    _this.props.onSwatchHover && _this.props.onSwatchHover(colors, event);
                }
            };
            _this.state = $d9d5623a706e13aa$var$_extends({}, $3e246347c8e3b5b0$export$6bed283375899438(props.color, 0));
            _this.debounce = (0, $7e93a5822d5a817f$export$2e2bcd8739ae039)(function(fn, data, event) {
                fn(data, event);
            }, 100);
            return _this;
        }
        $d9d5623a706e13aa$var$_createClass(ColorPicker, [
            {
                key: 'render',
                value: function render() {
                    var optionalEvents = {};
                    if (this.props.onSwatchHover) optionalEvents.onSwatchHover = this.handleSwatchHover;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement(Picker, $d9d5623a706e13aa$var$_extends({}, this.props, this.state, {
                        onChange: this.handleChange
                    }, optionalEvents));
                }
            }
        ], [
            {
                key: 'getDerivedStateFromProps',
                value: function getDerivedStateFromProps(nextProps, state) {
                    return $d9d5623a706e13aa$var$_extends({}, $3e246347c8e3b5b0$export$6bed283375899438(nextProps.color, state.oldHue));
                }
            }
        ]);
        return ColorPicker;
    }((0, $5E6i4.PureComponent) || (0, $5E6i4.Component));
    ColorPicker.propTypes = $d9d5623a706e13aa$var$_extends({}, Picker.propTypes);
    ColorPicker.defaultProps = $d9d5623a706e13aa$var$_extends({}, Picker.defaultProps, {
        color: {
            h: 250,
            s: 0.50,
            l: 0.20,
            a: 1
        }
    });
    return ColorPicker;
};
var $d9d5623a706e13aa$export$2e2bcd8739ae039 = $d9d5623a706e13aa$export$68265aef2e61bec7;



var $5E6i4 = parcelRequire("5E6i4");


var $7lP2n = parcelRequire("7lP2n");

var $01e9c8ec84dd90c0$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $01e9c8ec84dd90c0$var$ENTER = 13;
var $01e9c8ec84dd90c0$export$c463048d6131b309 = function Swatch(_ref) {
    var color = _ref.color, style = _ref.style, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onHover = _ref.onHover, _ref$title = _ref.title, title = _ref$title === undefined ? color : _ref$title, children = _ref.children, focus = _ref.focus, _ref$focusStyle = _ref.focusStyle, focusStyle = _ref$focusStyle === undefined ? {} : _ref$focusStyle;
    var transparent = color === 'transparent';
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($c8d725e5ba719c3a$exports)))({
        default: {
            swatch: $01e9c8ec84dd90c0$var$_extends({
                background: color,
                height: '100%',
                width: '100%',
                cursor: 'pointer',
                position: 'relative',
                outline: 'none'
            }, style, focus ? focusStyle : {})
        }
    });
    var handleClick = function handleClick(e) {
        return onClick(color, e);
    };
    var handleKeyDown = function handleKeyDown(e) {
        return e.keyCode === $01e9c8ec84dd90c0$var$ENTER && onClick(color, e);
    };
    var handleHover = function handleHover(e) {
        return onHover(color, e);
    };
    var optionalEvents = {};
    if (onHover) optionalEvents.onMouseOver = handleHover;
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', $01e9c8ec84dd90c0$var$_extends({
        style: styles.swatch,
        onClick: handleClick,
        title: title,
        tabIndex: 0,
        onKeyDown: handleKeyDown
    }, optionalEvents), children, transparent && (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $9494de16828d37a1$export$2e2bcd8739ae039), {
        borderRadius: styles.swatch.borderRadius,
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.1)'
    }));
};
var $01e9c8ec84dd90c0$export$2e2bcd8739ae039 = (0, $7lP2n.handleFocus)($01e9c8ec84dd90c0$export$c463048d6131b309);





var $5E6i4 = parcelRequire("5E6i4");

var $95b1aaaccf5f6c4a$export$5bbd8091d1d0e224 = function AlphaPointer(_ref) {
    var direction = _ref.direction;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($c8d725e5ba719c3a$exports)))({
        'default': {
            picker: {
                width: '18px',
                height: '18px',
                borderRadius: '50%',
                transform: 'translate(-9px, -1px)',
                backgroundColor: 'rgb(248, 248, 248)',
                boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
            }
        },
        'vertical': {
            picker: {
                transform: 'translate(-3px, -9px)'
            }
        }
    }, {
        vertical: direction === 'vertical'
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.picker
    });
};
var $95b1aaaccf5f6c4a$export$2e2bcd8739ae039 = $95b1aaaccf5f6c4a$export$5bbd8091d1d0e224;


var $31d5de10cf9fffab$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $31d5de10cf9fffab$export$421d2c1bdabf8a68 = function AlphaPicker(_ref) {
    var rgb = _ref.rgb, hsl = _ref.hsl, width = _ref.width, height = _ref.height, onChange = _ref.onChange, direction = _ref.direction, style = _ref.style, renderers = _ref.renderers, pointer = _ref.pointer, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($c8d725e5ba719c3a$exports)))({
        'default': {
            picker: {
                position: 'relative',
                width: width,
                height: height
            },
            alpha: {
                radius: '2px',
                style: style
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.picker,
        className: 'alpha-picker ' + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $7bb4498a032d4109$export$2e2bcd8739ae039), $31d5de10cf9fffab$var$_extends({}, styles.alpha, {
        rgb: rgb,
        hsl: hsl,
        pointer: pointer,
        renderers: renderers,
        onChange: onChange,
        direction: direction
    })));
};
$31d5de10cf9fffab$export$421d2c1bdabf8a68.defaultProps = {
    width: '316px',
    height: '16px',
    direction: 'horizontal',
    pointer: (0, $95b1aaaccf5f6c4a$export$2e2bcd8739ae039)
};
var $31d5de10cf9fffab$export$2e2bcd8739ae039 = (0, $d9d5623a706e13aa$export$2e2bcd8739ae039)($31d5de10cf9fffab$export$421d2c1bdabf8a68);



var $5E6i4 = parcelRequire("5E6i4");






var $5E6i4 = parcelRequire("5E6i4");

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $4c0e1763f876d6be$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $4c0e1763f876d6be$export$2e2bcd8739ae039 = $4c0e1763f876d6be$var$arrayMap;





/** Used to stand-in for `undefined` hash values. */ var $55d459e9220a4ef5$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $55d459e9220a4ef5$var$setCacheAdd(value) {
    this.__data__.set(value, $55d459e9220a4ef5$var$HASH_UNDEFINED);
    return this;
}
var $55d459e9220a4ef5$export$2e2bcd8739ae039 = $55d459e9220a4ef5$var$setCacheAdd;


/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */ function $9d1d9c866039352d$var$setCacheHas(value) {
    return this.__data__.has(value);
}
var $9d1d9c866039352d$export$2e2bcd8739ae039 = $9d1d9c866039352d$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $a50d8f42ba50d4a6$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new (0, $9199a9f997152e3f$export$2e2bcd8739ae039);
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$a50d8f42ba50d4a6$var$SetCache.prototype.add = $a50d8f42ba50d4a6$var$SetCache.prototype.push = (0, $55d459e9220a4ef5$export$2e2bcd8739ae039);
$a50d8f42ba50d4a6$var$SetCache.prototype.has = (0, $9d1d9c866039352d$export$2e2bcd8739ae039);
var $a50d8f42ba50d4a6$export$2e2bcd8739ae039 = $a50d8f42ba50d4a6$var$SetCache;


/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $fc97d8aa8fc089c9$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
var $fc97d8aa8fc089c9$export$2e2bcd8739ae039 = $fc97d8aa8fc089c9$var$arraySome;


/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $c95cbcf40509c2f1$var$cacheHas(cache, key) {
    return cache.has(key);
}
var $c95cbcf40509c2f1$export$2e2bcd8739ae039 = $c95cbcf40509c2f1$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $8bc88ea86e12b152$var$COMPARE_PARTIAL_FLAG = 1, $8bc88ea86e12b152$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $8bc88ea86e12b152$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $8bc88ea86e12b152$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $8bc88ea86e12b152$var$COMPARE_UNORDERED_FLAG ? new (0, $a50d8f42ba50d4a6$export$2e2bcd8739ae039) : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!(0, $fc97d8aa8fc089c9$export$2e2bcd8739ae039)(other, function(othValue, othIndex) {
                if (!(0, $c95cbcf40509c2f1$export$2e2bcd8739ae039)(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
var $8bc88ea86e12b152$export$2e2bcd8739ae039 = $8bc88ea86e12b152$var$equalArrays;






/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $37842856d12267bb$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
var $37842856d12267bb$export$2e2bcd8739ae039 = $37842856d12267bb$var$mapToArray;


/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $3a3bb36d151d7b67$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
var $3a3bb36d151d7b67$export$2e2bcd8739ae039 = $3a3bb36d151d7b67$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $22c064fb0fd18dff$var$COMPARE_PARTIAL_FLAG = 1, $22c064fb0fd18dff$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $22c064fb0fd18dff$var$boolTag = '[object Boolean]', $22c064fb0fd18dff$var$dateTag = '[object Date]', $22c064fb0fd18dff$var$errorTag = '[object Error]', $22c064fb0fd18dff$var$mapTag = '[object Map]', $22c064fb0fd18dff$var$numberTag = '[object Number]', $22c064fb0fd18dff$var$regexpTag = '[object RegExp]', $22c064fb0fd18dff$var$setTag = '[object Set]', $22c064fb0fd18dff$var$stringTag = '[object String]', $22c064fb0fd18dff$var$symbolTag = '[object Symbol]';
var $22c064fb0fd18dff$var$arrayBufferTag = '[object ArrayBuffer]', $22c064fb0fd18dff$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $22c064fb0fd18dff$var$symbolProto = (0, $6c469b965cf02ea3$export$2e2bcd8739ae039) ? (0, $6c469b965cf02ea3$export$2e2bcd8739ae039).prototype : undefined, $22c064fb0fd18dff$var$symbolValueOf = $22c064fb0fd18dff$var$symbolProto ? $22c064fb0fd18dff$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $22c064fb0fd18dff$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $22c064fb0fd18dff$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $22c064fb0fd18dff$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new (0, $afedf5477d293e45$export$2e2bcd8739ae039)(object), new (0, $afedf5477d293e45$export$2e2bcd8739ae039)(other))) return false;
            return true;
        case $22c064fb0fd18dff$var$boolTag:
        case $22c064fb0fd18dff$var$dateTag:
        case $22c064fb0fd18dff$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return (0, $20348e11d29d6c7e$export$2e2bcd8739ae039)(+object, +other);
        case $22c064fb0fd18dff$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $22c064fb0fd18dff$var$regexpTag:
        case $22c064fb0fd18dff$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $22c064fb0fd18dff$var$mapTag:
            var convert = (0, $37842856d12267bb$export$2e2bcd8739ae039);
        case $22c064fb0fd18dff$var$setTag:
            var isPartial = bitmask & $22c064fb0fd18dff$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = (0, $3a3bb36d151d7b67$export$2e2bcd8739ae039));
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $22c064fb0fd18dff$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = (0, $8bc88ea86e12b152$export$2e2bcd8739ae039)(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $22c064fb0fd18dff$var$symbolTag:
            if ($22c064fb0fd18dff$var$symbolValueOf) return $22c064fb0fd18dff$var$symbolValueOf.call(object) == $22c064fb0fd18dff$var$symbolValueOf.call(other);
    }
    return false;
}
var $22c064fb0fd18dff$export$2e2bcd8739ae039 = $22c064fb0fd18dff$var$equalByTag;


/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $2daadab6f5e1620b$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $2daadab6f5e1620b$export$2e2bcd8739ae039 = $2daadab6f5e1620b$var$arrayPush;



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $808d84ea700c2d30$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $4e89eca7c168bf58$export$2e2bcd8739ae039)(object) ? result : (0, $2daadab6f5e1620b$export$2e2bcd8739ae039)(result, symbolsFunc(object));
}
var $808d84ea700c2d30$export$2e2bcd8739ae039 = $808d84ea700c2d30$var$baseGetAllKeys;


/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $3b40f7502ebff4aa$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $3b40f7502ebff4aa$export$2e2bcd8739ae039 = $3b40f7502ebff4aa$var$arrayFilter;


/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $46dba6e6fcb5f506$var$stubArray() {
    return [];
}
var $46dba6e6fcb5f506$export$2e2bcd8739ae039 = $46dba6e6fcb5f506$var$stubArray;


/** Used for built-in method references. */ var $684b42031cc1d950$var$objectProto = Object.prototype;
/** Built-in value references. */ var $684b42031cc1d950$var$propertyIsEnumerable = $684b42031cc1d950$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $684b42031cc1d950$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $684b42031cc1d950$var$getSymbols = !$684b42031cc1d950$var$nativeGetSymbols ? (0, $46dba6e6fcb5f506$export$2e2bcd8739ae039) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $3b40f7502ebff4aa$export$2e2bcd8739ae039)($684b42031cc1d950$var$nativeGetSymbols(object), function(symbol) {
        return $684b42031cc1d950$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $684b42031cc1d950$export$2e2bcd8739ae039 = $684b42031cc1d950$var$getSymbols;



/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $2535cb02ae366ae9$var$getAllKeys(object) {
    return (0, $808d84ea700c2d30$export$2e2bcd8739ae039)(object, (0, $0305e0c44cc303ee$export$2e2bcd8739ae039), (0, $684b42031cc1d950$export$2e2bcd8739ae039));
}
var $2535cb02ae366ae9$export$2e2bcd8739ae039 = $2535cb02ae366ae9$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $f7c336ce0175f619$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $f7c336ce0175f619$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f7c336ce0175f619$var$hasOwnProperty = $f7c336ce0175f619$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $f7c336ce0175f619$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $f7c336ce0175f619$var$COMPARE_PARTIAL_FLAG, objProps = (0, $2535cb02ae366ae9$export$2e2bcd8739ae039)(object), objLength = objProps.length, othProps = (0, $2535cb02ae366ae9$export$2e2bcd8739ae039)(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $f7c336ce0175f619$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
var $f7c336ce0175f619$export$2e2bcd8739ae039 = $f7c336ce0175f619$var$equalObjects;




var $88ff1 = parcelRequire("88ff1");
/* Built-in method references that are verified to be native. */ var $5f047212c2e7ae75$var$DataView = (0, $c3b3bf1710191a20$export$2e2bcd8739ae039)((0, $88ff1.default), 'DataView');
var $5f047212c2e7ae75$export$2e2bcd8739ae039 = $5f047212c2e7ae75$var$DataView;





var $88ff1 = parcelRequire("88ff1");
/* Built-in method references that are verified to be native. */ var $6efdf8e9766a40e1$var$Promise = (0, $c3b3bf1710191a20$export$2e2bcd8739ae039)((0, $88ff1.default), 'Promise');
var $6efdf8e9766a40e1$export$2e2bcd8739ae039 = $6efdf8e9766a40e1$var$Promise;




var $88ff1 = parcelRequire("88ff1");
/* Built-in method references that are verified to be native. */ var $4749f8980a35cd20$var$Set = (0, $c3b3bf1710191a20$export$2e2bcd8739ae039)((0, $88ff1.default), 'Set');
var $4749f8980a35cd20$export$2e2bcd8739ae039 = $4749f8980a35cd20$var$Set;




var $88ff1 = parcelRequire("88ff1");
/* Built-in method references that are verified to be native. */ var $7ff5bef645418466$var$WeakMap = (0, $c3b3bf1710191a20$export$2e2bcd8739ae039)((0, $88ff1.default), 'WeakMap');
var $7ff5bef645418466$export$2e2bcd8739ae039 = $7ff5bef645418466$var$WeakMap;




/** `Object#toString` result references. */ var $9c772e06e8271634$var$mapTag = '[object Map]', $9c772e06e8271634$var$objectTag = '[object Object]', $9c772e06e8271634$var$promiseTag = '[object Promise]', $9c772e06e8271634$var$setTag = '[object Set]', $9c772e06e8271634$var$weakMapTag = '[object WeakMap]';
var $9c772e06e8271634$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $9c772e06e8271634$var$dataViewCtorString = (0, $5ebedf6a5b17fdc4$export$2e2bcd8739ae039)((0, $5f047212c2e7ae75$export$2e2bcd8739ae039)), $9c772e06e8271634$var$mapCtorString = (0, $5ebedf6a5b17fdc4$export$2e2bcd8739ae039)((0, $a728fb45d90bee23$export$2e2bcd8739ae039)), $9c772e06e8271634$var$promiseCtorString = (0, $5ebedf6a5b17fdc4$export$2e2bcd8739ae039)((0, $6efdf8e9766a40e1$export$2e2bcd8739ae039)), $9c772e06e8271634$var$setCtorString = (0, $5ebedf6a5b17fdc4$export$2e2bcd8739ae039)((0, $4749f8980a35cd20$export$2e2bcd8739ae039)), $9c772e06e8271634$var$weakMapCtorString = (0, $5ebedf6a5b17fdc4$export$2e2bcd8739ae039)((0, $7ff5bef645418466$export$2e2bcd8739ae039));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $9c772e06e8271634$var$getTag = (0, $78d0e963301c7165$export$2e2bcd8739ae039);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $5f047212c2e7ae75$export$2e2bcd8739ae039) && $9c772e06e8271634$var$getTag(new (0, $5f047212c2e7ae75$export$2e2bcd8739ae039)(new ArrayBuffer(1))) != $9c772e06e8271634$var$dataViewTag || (0, $a728fb45d90bee23$export$2e2bcd8739ae039) && $9c772e06e8271634$var$getTag(new (0, $a728fb45d90bee23$export$2e2bcd8739ae039)) != $9c772e06e8271634$var$mapTag || (0, $6efdf8e9766a40e1$export$2e2bcd8739ae039) && $9c772e06e8271634$var$getTag((0, $6efdf8e9766a40e1$export$2e2bcd8739ae039).resolve()) != $9c772e06e8271634$var$promiseTag || (0, $4749f8980a35cd20$export$2e2bcd8739ae039) && $9c772e06e8271634$var$getTag(new (0, $4749f8980a35cd20$export$2e2bcd8739ae039)) != $9c772e06e8271634$var$setTag || (0, $7ff5bef645418466$export$2e2bcd8739ae039) && $9c772e06e8271634$var$getTag(new (0, $7ff5bef645418466$export$2e2bcd8739ae039)) != $9c772e06e8271634$var$weakMapTag) $9c772e06e8271634$var$getTag = function(value) {
    var result = (0, $78d0e963301c7165$export$2e2bcd8739ae039)(value), Ctor = result == $9c772e06e8271634$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $5ebedf6a5b17fdc4$export$2e2bcd8739ae039)(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $9c772e06e8271634$var$dataViewCtorString:
            return $9c772e06e8271634$var$dataViewTag;
        case $9c772e06e8271634$var$mapCtorString:
            return $9c772e06e8271634$var$mapTag;
        case $9c772e06e8271634$var$promiseCtorString:
            return $9c772e06e8271634$var$promiseTag;
        case $9c772e06e8271634$var$setCtorString:
            return $9c772e06e8271634$var$setTag;
        case $9c772e06e8271634$var$weakMapCtorString:
            return $9c772e06e8271634$var$weakMapTag;
    }
    return result;
};
var $9c772e06e8271634$export$2e2bcd8739ae039 = $9c772e06e8271634$var$getTag;




var $kaMt5 = parcelRequire("kaMt5");

/** Used to compose bitmasks for value comparisons. */ var $a39be6d56b6e96f0$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $a39be6d56b6e96f0$var$argsTag = '[object Arguments]', $a39be6d56b6e96f0$var$arrayTag = '[object Array]', $a39be6d56b6e96f0$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $a39be6d56b6e96f0$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a39be6d56b6e96f0$var$hasOwnProperty = $a39be6d56b6e96f0$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $a39be6d56b6e96f0$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = (0, $4e89eca7c168bf58$export$2e2bcd8739ae039)(object), othIsArr = (0, $4e89eca7c168bf58$export$2e2bcd8739ae039)(other), objTag = objIsArr ? $a39be6d56b6e96f0$var$arrayTag : (0, $9c772e06e8271634$export$2e2bcd8739ae039)(object), othTag = othIsArr ? $a39be6d56b6e96f0$var$arrayTag : (0, $9c772e06e8271634$export$2e2bcd8739ae039)(other);
    objTag = objTag == $a39be6d56b6e96f0$var$argsTag ? $a39be6d56b6e96f0$var$objectTag : objTag;
    othTag = othTag == $a39be6d56b6e96f0$var$argsTag ? $a39be6d56b6e96f0$var$objectTag : othTag;
    var objIsObj = objTag == $a39be6d56b6e96f0$var$objectTag, othIsObj = othTag == $a39be6d56b6e96f0$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && (0, $kaMt5.default)(object)) {
        if (!(0, $kaMt5.default)(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new (0, $943244c58bd28e87$export$2e2bcd8739ae039));
        return objIsArr || (0, $400b674b6154a343$export$2e2bcd8739ae039)(object) ? (0, $8bc88ea86e12b152$export$2e2bcd8739ae039)(object, other, bitmask, customizer, equalFunc, stack) : (0, $22c064fb0fd18dff$export$2e2bcd8739ae039)(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $a39be6d56b6e96f0$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $a39be6d56b6e96f0$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $a39be6d56b6e96f0$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new (0, $943244c58bd28e87$export$2e2bcd8739ae039));
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new (0, $943244c58bd28e87$export$2e2bcd8739ae039));
    return (0, $f7c336ce0175f619$export$2e2bcd8739ae039)(object, other, bitmask, customizer, equalFunc, stack);
}
var $a39be6d56b6e96f0$export$2e2bcd8739ae039 = $a39be6d56b6e96f0$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $2b5454b03a4a1424$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !(0, $c01ca98128351866$export$2e2bcd8739ae039)(value) && !(0, $c01ca98128351866$export$2e2bcd8739ae039)(other)) return value !== value && other !== other;
    return (0, $a39be6d56b6e96f0$export$2e2bcd8739ae039)(value, other, bitmask, customizer, $2b5454b03a4a1424$var$baseIsEqual, stack);
}
var $2b5454b03a4a1424$export$2e2bcd8739ae039 = $2b5454b03a4a1424$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $a256ed177bbce786$var$COMPARE_PARTIAL_FLAG = 1, $a256ed177bbce786$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $a256ed177bbce786$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new (0, $943244c58bd28e87$export$2e2bcd8739ae039);
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? (0, $2b5454b03a4a1424$export$2e2bcd8739ae039)(srcValue, objValue, $a256ed177bbce786$var$COMPARE_PARTIAL_FLAG | $a256ed177bbce786$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
var $a256ed177bbce786$export$2e2bcd8739ae039 = $a256ed177bbce786$var$baseIsMatch;



/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $ae53cc785ac753e8$var$isStrictComparable(value) {
    return value === value && !(0, $3a5d5535658447fe$export$2e2bcd8739ae039)(value);
}
var $ae53cc785ac753e8$export$2e2bcd8739ae039 = $ae53cc785ac753e8$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $3fe726a10a639929$var$getMatchData(object) {
    var result = (0, $0305e0c44cc303ee$export$2e2bcd8739ae039)(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            (0, $ae53cc785ac753e8$export$2e2bcd8739ae039)(value)
        ];
    }
    return result;
}
var $3fe726a10a639929$export$2e2bcd8739ae039 = $3fe726a10a639929$var$getMatchData;


/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $47db2742f94bc0e5$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
var $47db2742f94bc0e5$export$2e2bcd8739ae039 = $47db2742f94bc0e5$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $6b08a7a28c13004d$var$baseMatches(source) {
    var matchData = (0, $3fe726a10a639929$export$2e2bcd8739ae039)(source);
    if (matchData.length == 1 && matchData[0][2]) return (0, $47db2742f94bc0e5$export$2e2bcd8739ae039)(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || (0, $a256ed177bbce786$export$2e2bcd8739ae039)(object, source, matchData);
    };
}
var $6b08a7a28c13004d$export$2e2bcd8739ae039 = $6b08a7a28c13004d$var$baseMatches;






/** Used to match property names within property paths. */ var $0880cc93fd76ca24$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $0880cc93fd76ca24$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $0880cc93fd76ca24$var$isKey(value, object) {
    if ((0, $4e89eca7c168bf58$export$2e2bcd8739ae039)(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || (0, $8d54cd76e2aab7af$export$2e2bcd8739ae039)(value)) return true;
    return $0880cc93fd76ca24$var$reIsPlainProp.test(value) || !$0880cc93fd76ca24$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
var $0880cc93fd76ca24$export$2e2bcd8739ae039 = $0880cc93fd76ca24$var$isKey;



/** Error message constants. */ var $3e75bbfe157a126c$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $3e75bbfe157a126c$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($3e75bbfe157a126c$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($3e75bbfe157a126c$var$memoize.Cache || (0, $9199a9f997152e3f$export$2e2bcd8739ae039));
    return memoized;
}
// Expose `MapCache`.
$3e75bbfe157a126c$var$memoize.Cache = (0, $9199a9f997152e3f$export$2e2bcd8739ae039);
var $3e75bbfe157a126c$export$2e2bcd8739ae039 = $3e75bbfe157a126c$var$memoize;


/** Used as the maximum memoize cache size. */ var $afa8d0cff214b4ef$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $afa8d0cff214b4ef$var$memoizeCapped(func) {
    var result = (0, $3e75bbfe157a126c$export$2e2bcd8739ae039)(func, function(key) {
        if (cache.size === $afa8d0cff214b4ef$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $afa8d0cff214b4ef$export$2e2bcd8739ae039 = $afa8d0cff214b4ef$var$memoizeCapped;


/** Used to match property names within property paths. */ var $c343365377d5c420$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $c343365377d5c420$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $c343365377d5c420$var$stringToPath = (0, $afa8d0cff214b4ef$export$2e2bcd8739ae039)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($c343365377d5c420$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($c343365377d5c420$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
var $c343365377d5c420$export$2e2bcd8739ae039 = $c343365377d5c420$var$stringToPath;






/** Used as references for various `Number` constants. */ var $646e64abf6cdbc4d$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $646e64abf6cdbc4d$var$symbolProto = (0, $6c469b965cf02ea3$export$2e2bcd8739ae039) ? (0, $6c469b965cf02ea3$export$2e2bcd8739ae039).prototype : undefined, $646e64abf6cdbc4d$var$symbolToString = $646e64abf6cdbc4d$var$symbolProto ? $646e64abf6cdbc4d$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $646e64abf6cdbc4d$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ((0, $4e89eca7c168bf58$export$2e2bcd8739ae039)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $4c0e1763f876d6be$export$2e2bcd8739ae039)(value, $646e64abf6cdbc4d$var$baseToString) + '';
    if ((0, $8d54cd76e2aab7af$export$2e2bcd8739ae039)(value)) return $646e64abf6cdbc4d$var$symbolToString ? $646e64abf6cdbc4d$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$646e64abf6cdbc4d$var$INFINITY ? '-0' : result;
}
var $646e64abf6cdbc4d$export$2e2bcd8739ae039 = $646e64abf6cdbc4d$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $c6fa90171beea9a1$var$toString(value) {
    return value == null ? '' : (0, $646e64abf6cdbc4d$export$2e2bcd8739ae039)(value);
}
var $c6fa90171beea9a1$export$2e2bcd8739ae039 = $c6fa90171beea9a1$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $631f15221609b783$var$castPath(value, object) {
    if ((0, $4e89eca7c168bf58$export$2e2bcd8739ae039)(value)) return value;
    return (0, $0880cc93fd76ca24$export$2e2bcd8739ae039)(value, object) ? [
        value
    ] : (0, $c343365377d5c420$export$2e2bcd8739ae039)((0, $c6fa90171beea9a1$export$2e2bcd8739ae039)(value));
}
var $631f15221609b783$export$2e2bcd8739ae039 = $631f15221609b783$var$castPath;



/** Used as references for various `Number` constants. */ var $e86e7db34e3c6c0f$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $e86e7db34e3c6c0f$var$toKey(value) {
    if (typeof value == 'string' || (0, $8d54cd76e2aab7af$export$2e2bcd8739ae039)(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$e86e7db34e3c6c0f$var$INFINITY ? '-0' : result;
}
var $e86e7db34e3c6c0f$export$2e2bcd8739ae039 = $e86e7db34e3c6c0f$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $0362610c1a21f124$var$baseGet(object, path) {
    path = (0, $631f15221609b783$export$2e2bcd8739ae039)(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[(0, $e86e7db34e3c6c0f$export$2e2bcd8739ae039)(path[index++])];
    return index && index == length ? object : undefined;
}
var $0362610c1a21f124$export$2e2bcd8739ae039 = $0362610c1a21f124$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $245e159867b467d5$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : (0, $0362610c1a21f124$export$2e2bcd8739ae039)(object, path);
    return result === undefined ? defaultValue : result;
}
var $245e159867b467d5$export$2e2bcd8739ae039 = $245e159867b467d5$var$get;


/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $febaeea625e28a8e$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
var $febaeea625e28a8e$export$2e2bcd8739ae039 = $febaeea625e28a8e$var$baseHasIn;








/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $4e5a3bab0c44a21f$var$hasPath(object, path, hasFunc) {
    path = (0, $631f15221609b783$export$2e2bcd8739ae039)(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = (0, $e86e7db34e3c6c0f$export$2e2bcd8739ae039)(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && (0, $00ca08e227cc81d0$export$2e2bcd8739ae039)(length) && (0, $e6573ced148df7ca$export$2e2bcd8739ae039)(key, length) && ((0, $4e89eca7c168bf58$export$2e2bcd8739ae039)(object) || (0, $f532c2ab54a17342$export$2e2bcd8739ae039)(object));
}
var $4e5a3bab0c44a21f$export$2e2bcd8739ae039 = $4e5a3bab0c44a21f$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $5def084302b318a6$var$hasIn(object, path) {
    return object != null && (0, $4e5a3bab0c44a21f$export$2e2bcd8739ae039)(object, path, (0, $febaeea625e28a8e$export$2e2bcd8739ae039));
}
var $5def084302b318a6$export$2e2bcd8739ae039 = $5def084302b318a6$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $98549f494a9cb1d2$var$COMPARE_PARTIAL_FLAG = 1, $98549f494a9cb1d2$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $98549f494a9cb1d2$var$baseMatchesProperty(path, srcValue) {
    if ((0, $0880cc93fd76ca24$export$2e2bcd8739ae039)(path) && (0, $ae53cc785ac753e8$export$2e2bcd8739ae039)(srcValue)) return (0, $47db2742f94bc0e5$export$2e2bcd8739ae039)((0, $e86e7db34e3c6c0f$export$2e2bcd8739ae039)(path), srcValue);
    return function(object) {
        var objValue = (0, $245e159867b467d5$export$2e2bcd8739ae039)(object, path);
        return objValue === undefined && objValue === srcValue ? (0, $5def084302b318a6$export$2e2bcd8739ae039)(object, path) : (0, $2b5454b03a4a1424$export$2e2bcd8739ae039)(srcValue, objValue, $98549f494a9cb1d2$var$COMPARE_PARTIAL_FLAG | $98549f494a9cb1d2$var$COMPARE_UNORDERED_FLAG);
    };
}
var $98549f494a9cb1d2$export$2e2bcd8739ae039 = $98549f494a9cb1d2$var$baseMatchesProperty;




/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $b761e1c56efdcada$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
var $b761e1c56efdcada$export$2e2bcd8739ae039 = $b761e1c56efdcada$var$baseProperty;



/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $e39c69880b79707d$var$basePropertyDeep(path) {
    return function(object) {
        return (0, $0362610c1a21f124$export$2e2bcd8739ae039)(object, path);
    };
}
var $e39c69880b79707d$export$2e2bcd8739ae039 = $e39c69880b79707d$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $0ee3932ecadf7095$var$property(path) {
    return (0, $0880cc93fd76ca24$export$2e2bcd8739ae039)(path) ? (0, $b761e1c56efdcada$export$2e2bcd8739ae039)((0, $e86e7db34e3c6c0f$export$2e2bcd8739ae039)(path)) : (0, $e39c69880b79707d$export$2e2bcd8739ae039)(path);
}
var $0ee3932ecadf7095$export$2e2bcd8739ae039 = $0ee3932ecadf7095$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $40a08e81468a01a4$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return 0, $ccf754f92b5d06ef$export$2e2bcd8739ae039;
    if (typeof value == 'object') return (0, $4e89eca7c168bf58$export$2e2bcd8739ae039)(value) ? (0, $98549f494a9cb1d2$export$2e2bcd8739ae039)(value[0], value[1]) : (0, $6b08a7a28c13004d$export$2e2bcd8739ae039)(value);
    return (0, $0ee3932ecadf7095$export$2e2bcd8739ae039)(value);
}
var $40a08e81468a01a4$export$2e2bcd8739ae039 = $40a08e81468a01a4$var$baseIteratee;




/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $face14c6df2c407a$var$baseMap(collection, iteratee) {
    var index = -1, result = (0, $54bd1a68a2c78ec4$export$2e2bcd8739ae039)(collection) ? Array(collection.length) : [];
    (0, $5309be07bb94a4b5$export$2e2bcd8739ae039)(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
var $face14c6df2c407a$export$2e2bcd8739ae039 = $face14c6df2c407a$var$baseMap;



/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $f872dc2287484c72$var$map(collection, iteratee) {
    var func = (0, $4e89eca7c168bf58$export$2e2bcd8739ae039)(collection) ? (0, $4c0e1763f876d6be$export$2e2bcd8739ae039) : (0, $face14c6df2c407a$export$2e2bcd8739ae039);
    return func(collection, (0, $40a08e81468a01a4$export$2e2bcd8739ae039)(iteratee, 3));
}
var $f872dc2287484c72$export$2e2bcd8739ae039 = $f872dc2287484c72$var$map;



var $de86b60be55bba48$export$2ce88c5250e54734 = function BlockSwatches(_ref) {
    var colors = _ref.colors, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($c8d725e5ba719c3a$exports)))({
        'default': {
            swatches: {
                marginRight: '-10px'
            },
            swatch: {
                width: '22px',
                height: '22px',
                float: 'left',
                marginRight: '10px',
                marginBottom: '10px',
                borderRadius: '4px'
            },
            clear: {
                clear: 'both'
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.swatches
    }, (0, $f872dc2287484c72$export$2e2bcd8739ae039)(colors, function(c) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $01e9c8ec84dd90c0$export$2e2bcd8739ae039), {
            key: c,
            color: c,
            style: styles.swatch,
            onClick: onClick,
            onHover: onSwatchHover,
            focusStyle: {
                boxShadow: '0 0 4px ' + c
            }
        });
    }), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.clear
    }));
};
var $de86b60be55bba48$export$2e2bcd8739ae039 = $de86b60be55bba48$export$2ce88c5250e54734;


var $89e9bbcacd80acf1$export$d96a8827a60d6b69 = function Block(_ref) {
    var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, hex = _ref.hex, colors = _ref.colors, width = _ref.width, triangle = _ref.triangle, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var transparent = hex === 'transparent';
    var handleChange = function handleChange(hexCode, e) {
        $3e246347c8e3b5b0$export$944f75ec5697b362(hexCode) && onChange({
            hex: hexCode,
            source: 'hex'
        }, e);
    };
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($c8d725e5ba719c3a$exports)))((0, $2b042368e2ec1525$export$2e2bcd8739ae039)({
        'default': {
            card: {
                width: width,
                background: '#fff',
                boxShadow: '0 1px rgba(0,0,0,.1)',
                borderRadius: '6px',
                position: 'relative'
            },
            head: {
                height: '110px',
                background: hex,
                borderRadius: '6px 6px 0 0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative'
            },
            body: {
                padding: '10px'
            },
            label: {
                fontSize: '18px',
                color: $3e246347c8e3b5b0$export$3609eb1d7e55dec(hex),
                position: 'relative'
            },
            triangle: {
                width: '0px',
                height: '0px',
                borderStyle: 'solid',
                borderWidth: '0 10px 10px 10px',
                borderColor: 'transparent transparent ' + hex + ' transparent',
                position: 'absolute',
                top: '-10px',
                left: '50%',
                marginLeft: '-10px'
            },
            input: {
                width: '100%',
                fontSize: '12px',
                color: '#666',
                border: '0px',
                outline: 'none',
                height: '22px',
                boxShadow: 'inset 0 0 0 1px #ddd',
                borderRadius: '4px',
                padding: '0 7px',
                boxSizing: 'border-box'
            }
        },
        'hide-triangle': {
            triangle: {
                display: 'none'
            }
        }
    }, passedStyles), {
        'hide-triangle': triangle === 'hide'
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.card,
        className: 'block-picker ' + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.triangle
    }), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.head
    }, transparent && (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $9494de16828d37a1$export$2e2bcd8739ae039), {
        borderRadius: '6px 6px 0 0'
    }), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.label
    }, hex)), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.body
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $de86b60be55bba48$export$2e2bcd8739ae039), {
        colors: colors,
        onClick: handleChange,
        onSwatchHover: onSwatchHover
    }), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $cb537f80953d7d1d$export$2e2bcd8739ae039), {
        style: {
            input: styles.input
        },
        value: hex,
        onChange: handleChange
    })));
};
$89e9bbcacd80acf1$export$d96a8827a60d6b69.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).number
    ]),
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string),
    triangle: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOf([
        'top',
        'hide'
    ]),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).object
};
$89e9bbcacd80acf1$export$d96a8827a60d6b69.defaultProps = {
    width: 170,
    colors: [
        '#D9E3F0',
        '#F47373',
        '#697689',
        '#37D67A',
        '#2CCCE4',
        '#555555',
        '#dce775',
        '#ff8a65',
        '#ba68c8'
    ],
    triangle: 'top',
    styles: {}
};
var $89e9bbcacd80acf1$export$2e2bcd8739ae039 = (0, $d9d5623a706e13aa$export$2e2bcd8739ae039)($89e9bbcacd80acf1$export$d96a8827a60d6b69);



var $5E6i4 = parcelRequire("5E6i4");




var $672d8daba6bf990f$export$a90204d1394caf30 = {
    "50": "#ffebee",
    "100": "#ffcdd2",
    "200": "#ef9a9a",
    "300": "#e57373",
    "400": "#ef5350",
    "500": "#f44336",
    "600": "#e53935",
    "700": "#d32f2f",
    "800": "#c62828",
    "900": "#b71c1c",
    "a100": "#ff8a80",
    "a200": "#ff5252",
    "a400": "#ff1744",
    "a700": "#d50000"
};
var $672d8daba6bf990f$export$47853bc718611763 = {
    "50": "#fce4ec",
    "100": "#f8bbd0",
    "200": "#f48fb1",
    "300": "#f06292",
    "400": "#ec407a",
    "500": "#e91e63",
    "600": "#d81b60",
    "700": "#c2185b",
    "800": "#ad1457",
    "900": "#880e4f",
    "a100": "#ff80ab",
    "a200": "#ff4081",
    "a400": "#f50057",
    "a700": "#c51162"
};
var $672d8daba6bf990f$export$e13cce2a2d16a9d4 = {
    "50": "#f3e5f5",
    "100": "#e1bee7",
    "200": "#ce93d8",
    "300": "#ba68c8",
    "400": "#ab47bc",
    "500": "#9c27b0",
    "600": "#8e24aa",
    "700": "#7b1fa2",
    "800": "#6a1b9a",
    "900": "#4a148c",
    "a100": "#ea80fc",
    "a200": "#e040fb",
    "a400": "#d500f9",
    "a700": "#aa00ff"
};
var $672d8daba6bf990f$export$51ef95b19086af57 = {
    "50": "#ede7f6",
    "100": "#d1c4e9",
    "200": "#b39ddb",
    "300": "#9575cd",
    "400": "#7e57c2",
    "500": "#673ab7",
    "600": "#5e35b1",
    "700": "#512da8",
    "800": "#4527a0",
    "900": "#311b92",
    "a100": "#b388ff",
    "a200": "#7c4dff",
    "a400": "#651fff",
    "a700": "#6200ea"
};
var $672d8daba6bf990f$export$3e6ccc7b8562d453 = {
    "50": "#e8eaf6",
    "100": "#c5cae9",
    "200": "#9fa8da",
    "300": "#7986cb",
    "400": "#5c6bc0",
    "500": "#3f51b5",
    "600": "#3949ab",
    "700": "#303f9f",
    "800": "#283593",
    "900": "#1a237e",
    "a100": "#8c9eff",
    "a200": "#536dfe",
    "a400": "#3d5afe",
    "a700": "#304ffe"
};
var $672d8daba6bf990f$export$2aa0182783e7e9de = {
    "50": "#e3f2fd",
    "100": "#bbdefb",
    "200": "#90caf9",
    "300": "#64b5f6",
    "400": "#42a5f5",
    "500": "#2196f3",
    "600": "#1e88e5",
    "700": "#1976d2",
    "800": "#1565c0",
    "900": "#0d47a1",
    "a100": "#82b1ff",
    "a200": "#448aff",
    "a400": "#2979ff",
    "a700": "#2962ff"
};
var $672d8daba6bf990f$export$7b0d29b70b435c21 = {
    "50": "#e1f5fe",
    "100": "#b3e5fc",
    "200": "#81d4fa",
    "300": "#4fc3f7",
    "400": "#29b6f6",
    "500": "#03a9f4",
    "600": "#039be5",
    "700": "#0288d1",
    "800": "#0277bd",
    "900": "#01579b",
    "a100": "#80d8ff",
    "a200": "#40c4ff",
    "a400": "#00b0ff",
    "a700": "#0091ea"
};
var $672d8daba6bf990f$export$7474046f446842ee = {
    "50": "#e0f7fa",
    "100": "#b2ebf2",
    "200": "#80deea",
    "300": "#4dd0e1",
    "400": "#26c6da",
    "500": "#00bcd4",
    "600": "#00acc1",
    "700": "#0097a7",
    "800": "#00838f",
    "900": "#006064",
    "a100": "#84ffff",
    "a200": "#18ffff",
    "a400": "#00e5ff",
    "a700": "#00b8d4"
};
var $672d8daba6bf990f$export$8bf7dff220b82b4a = {
    "50": "#e0f2f1",
    "100": "#b2dfdb",
    "200": "#80cbc4",
    "300": "#4db6ac",
    "400": "#26a69a",
    "500": "#009688",
    "600": "#00897b",
    "700": "#00796b",
    "800": "#00695c",
    "900": "#004d40",
    "a100": "#a7ffeb",
    "a200": "#64ffda",
    "a400": "#1de9b6",
    "a700": "#00bfa5"
};
var $672d8daba6bf990f$export$955a2ebd2fb142ae = {
    "50": "#e8f5e9",
    "100": "#c8e6c9",
    "200": "#a5d6a7",
    "300": "#81c784",
    "400": "#66bb6a",
    "500": "#4caf50",
    "600": "#43a047",
    "700": "#388e3c",
    "800": "#2e7d32",
    "900": "#1b5e20",
    "a100": "#b9f6ca",
    "a200": "#69f0ae",
    "a400": "#00e676",
    "a700": "#00c853"
};
var $672d8daba6bf990f$export$559a8c00376dc936 = {
    "50": "#f1f8e9",
    "100": "#dcedc8",
    "200": "#c5e1a5",
    "300": "#aed581",
    "400": "#9ccc65",
    "500": "#8bc34a",
    "600": "#7cb342",
    "700": "#689f38",
    "800": "#558b2f",
    "900": "#33691e",
    "a100": "#ccff90",
    "a200": "#b2ff59",
    "a400": "#76ff03",
    "a700": "#64dd17"
};
var $672d8daba6bf990f$export$221d31baf2636aad = {
    "50": "#f9fbe7",
    "100": "#f0f4c3",
    "200": "#e6ee9c",
    "300": "#dce775",
    "400": "#d4e157",
    "500": "#cddc39",
    "600": "#c0ca33",
    "700": "#afb42b",
    "800": "#9e9d24",
    "900": "#827717",
    "a100": "#f4ff81",
    "a200": "#eeff41",
    "a400": "#c6ff00",
    "a700": "#aeea00"
};
var $672d8daba6bf990f$export$594c5a8758200c32 = {
    "50": "#fffde7",
    "100": "#fff9c4",
    "200": "#fff59d",
    "300": "#fff176",
    "400": "#ffee58",
    "500": "#ffeb3b",
    "600": "#fdd835",
    "700": "#fbc02d",
    "800": "#f9a825",
    "900": "#f57f17",
    "a100": "#ffff8d",
    "a200": "#ffff00",
    "a400": "#ffea00",
    "a700": "#ffd600"
};
var $672d8daba6bf990f$export$7c1ecc66643fdbd6 = {
    "50": "#fff8e1",
    "100": "#ffecb3",
    "200": "#ffe082",
    "300": "#ffd54f",
    "400": "#ffca28",
    "500": "#ffc107",
    "600": "#ffb300",
    "700": "#ffa000",
    "800": "#ff8f00",
    "900": "#ff6f00",
    "a100": "#ffe57f",
    "a200": "#ffd740",
    "a400": "#ffc400",
    "a700": "#ffab00"
};
var $672d8daba6bf990f$export$ad766f34ace1cafd = {
    "50": "#fff3e0",
    "100": "#ffe0b2",
    "200": "#ffcc80",
    "300": "#ffb74d",
    "400": "#ffa726",
    "500": "#ff9800",
    "600": "#fb8c00",
    "700": "#f57c00",
    "800": "#ef6c00",
    "900": "#e65100",
    "a100": "#ffd180",
    "a200": "#ffab40",
    "a400": "#ff9100",
    "a700": "#ff6d00"
};
var $672d8daba6bf990f$export$1ceed3dd9ec11704 = {
    "50": "#fbe9e7",
    "100": "#ffccbc",
    "200": "#ffab91",
    "300": "#ff8a65",
    "400": "#ff7043",
    "500": "#ff5722",
    "600": "#f4511e",
    "700": "#e64a19",
    "800": "#d84315",
    "900": "#bf360c",
    "a100": "#ff9e80",
    "a200": "#ff6e40",
    "a400": "#ff3d00",
    "a700": "#dd2c00"
};
var $672d8daba6bf990f$export$b6e6178d3f565007 = {
    "50": "#efebe9",
    "100": "#d7ccc8",
    "200": "#bcaaa4",
    "300": "#a1887f",
    "400": "#8d6e63",
    "500": "#795548",
    "600": "#6d4c41",
    "700": "#5d4037",
    "800": "#4e342e",
    "900": "#3e2723"
};
var $672d8daba6bf990f$export$e4c89085febbc618 = {
    "50": "#fafafa",
    "100": "#f5f5f5",
    "200": "#eeeeee",
    "300": "#e0e0e0",
    "400": "#bdbdbd",
    "500": "#9e9e9e",
    "600": "#757575",
    "700": "#616161",
    "800": "#424242",
    "900": "#212121"
};
var $672d8daba6bf990f$export$7c2da42d08c019c9 = {
    "50": "#eceff1",
    "100": "#cfd8dc",
    "200": "#b0bec5",
    "300": "#90a4ae",
    "400": "#78909c",
    "500": "#607d8b",
    "600": "#546e7a",
    "700": "#455a64",
    "800": "#37474f",
    "900": "#263238"
};
var $672d8daba6bf990f$export$b413907788b50267 = {
    "primary": "rgba(0, 0, 0, 0.87)",
    "secondary": "rgba(0, 0, 0, 0.54)",
    "disabled": "rgba(0, 0, 0, 0.38)",
    "dividers": "rgba(0, 0, 0, 0.12)"
};
var $672d8daba6bf990f$export$c962f8177a273028 = {
    "primary": "rgba(255, 255, 255, 1)",
    "secondary": "rgba(255, 255, 255, 0.7)",
    "disabled": "rgba(255, 255, 255, 0.5)",
    "dividers": "rgba(255, 255, 255, 0.12)"
};
var $672d8daba6bf990f$export$969f6c634341b5cf = {
    "active": "rgba(0, 0, 0, 0.54)",
    "inactive": "rgba(0, 0, 0, 0.38)"
};
var $672d8daba6bf990f$export$6b4a43519c60f4b1 = {
    "active": "rgba(255, 255, 255, 1)",
    "inactive": "rgba(255, 255, 255, 0.5)"
};
var $672d8daba6bf990f$export$8fa4e5556fd77a60 = "#ffffff";
var $672d8daba6bf990f$export$c073df10e766abfa = "#000000";
var $672d8daba6bf990f$export$2e2bcd8739ae039 = {
    red: $672d8daba6bf990f$export$a90204d1394caf30,
    pink: $672d8daba6bf990f$export$47853bc718611763,
    purple: $672d8daba6bf990f$export$e13cce2a2d16a9d4,
    deepPurple: $672d8daba6bf990f$export$51ef95b19086af57,
    indigo: $672d8daba6bf990f$export$3e6ccc7b8562d453,
    blue: $672d8daba6bf990f$export$2aa0182783e7e9de,
    lightBlue: $672d8daba6bf990f$export$7b0d29b70b435c21,
    cyan: $672d8daba6bf990f$export$7474046f446842ee,
    teal: $672d8daba6bf990f$export$8bf7dff220b82b4a,
    green: $672d8daba6bf990f$export$955a2ebd2fb142ae,
    lightGreen: $672d8daba6bf990f$export$559a8c00376dc936,
    lime: $672d8daba6bf990f$export$221d31baf2636aad,
    yellow: $672d8daba6bf990f$export$594c5a8758200c32,
    amber: $672d8daba6bf990f$export$7c1ecc66643fdbd6,
    orange: $672d8daba6bf990f$export$ad766f34ace1cafd,
    deepOrange: $672d8daba6bf990f$export$1ceed3dd9ec11704,
    brown: $672d8daba6bf990f$export$b6e6178d3f565007,
    grey: $672d8daba6bf990f$export$e4c89085febbc618,
    blueGrey: $672d8daba6bf990f$export$7c2da42d08c019c9,
    darkText: $672d8daba6bf990f$export$b413907788b50267,
    lightText: $672d8daba6bf990f$export$c962f8177a273028,
    darkIcons: $672d8daba6bf990f$export$969f6c634341b5cf,
    lightIcons: $672d8daba6bf990f$export$6b4a43519c60f4b1,
    white: $672d8daba6bf990f$export$8fa4e5556fd77a60,
    black: $672d8daba6bf990f$export$c073df10e766abfa
};




var $5E6i4 = parcelRequire("5E6i4");


var $2a1fd9b9e8df08a9$export$945d5c8ebb42b0ff = function CircleSwatch(_ref) {
    var color = _ref.color, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover, hover = _ref.hover, active = _ref.active, circleSize = _ref.circleSize, circleSpacing = _ref.circleSpacing;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($c8d725e5ba719c3a$exports)))({
        'default': {
            swatch: {
                width: circleSize,
                height: circleSize,
                marginRight: circleSpacing,
                marginBottom: circleSpacing,
                transform: 'scale(1)',
                transition: '100ms transform ease'
            },
            Swatch: {
                borderRadius: '50%',
                background: 'transparent',
                boxShadow: 'inset 0 0 0 ' + (circleSize / 2 + 1) + 'px ' + color,
                transition: '100ms box-shadow ease'
            }
        },
        'hover': {
            swatch: {
                transform: 'scale(1.2)'
            }
        },
        'active': {
            Swatch: {
                boxShadow: 'inset 0 0 0 3px ' + color
            }
        }
    }, {
        hover: hover,
        active: active
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $01e9c8ec84dd90c0$export$2e2bcd8739ae039), {
        style: styles.Swatch,
        color: color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
            boxShadow: styles.Swatch.boxShadow + ', 0 0 5px ' + color
        }
    }));
};
$2a1fd9b9e8df08a9$export$945d5c8ebb42b0ff.defaultProps = {
    circleSize: 28,
    circleSpacing: 14
};
var $2a1fd9b9e8df08a9$export$2e2bcd8739ae039 = (0, $c8d725e5ba719c3a$exports.handleHover)($2a1fd9b9e8df08a9$export$945d5c8ebb42b0ff);


var $57c76864175e51a4$export$c89a927ffc67e6fa = function Circle(_ref) {
    var width = _ref.width, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex = _ref.hex, circleSize = _ref.circleSize, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, circleSpacing = _ref.circleSpacing, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($c8d725e5ba719c3a$exports)))((0, $2b042368e2ec1525$export$2e2bcd8739ae039)({
        'default': {
            card: {
                width: width,
                display: 'flex',
                flexWrap: 'wrap',
                marginRight: -circleSpacing,
                marginBottom: -circleSpacing
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(hexCode, e) {
        return onChange({
            hex: hexCode,
            source: 'hex'
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.card,
        className: 'circle-picker ' + className
    }, (0, $f872dc2287484c72$export$2e2bcd8739ae039)(colors, function(c) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $2a1fd9b9e8df08a9$export$2e2bcd8739ae039), {
            key: c,
            color: c,
            onClick: handleChange,
            onSwatchHover: onSwatchHover,
            active: hex === c.toLowerCase(),
            circleSize: circleSize,
            circleSpacing: circleSpacing
        });
    }));
};
$57c76864175e51a4$export$c89a927ffc67e6fa.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).number
    ]),
    circleSize: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).number,
    circleSpacing: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).number,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).object
};
$57c76864175e51a4$export$c89a927ffc67e6fa.defaultProps = {
    width: 252,
    circleSize: 28,
    circleSpacing: 14,
    colors: [
        $672d8daba6bf990f$export$a90204d1394caf30['500'],
        $672d8daba6bf990f$export$47853bc718611763['500'],
        $672d8daba6bf990f$export$e13cce2a2d16a9d4['500'],
        $672d8daba6bf990f$export$51ef95b19086af57['500'],
        $672d8daba6bf990f$export$3e6ccc7b8562d453['500'],
        $672d8daba6bf990f$export$2aa0182783e7e9de['500'],
        $672d8daba6bf990f$export$7b0d29b70b435c21['500'],
        $672d8daba6bf990f$export$7474046f446842ee['500'],
        $672d8daba6bf990f$export$8bf7dff220b82b4a['500'],
        $672d8daba6bf990f$export$955a2ebd2fb142ae['500'],
        $672d8daba6bf990f$export$559a8c00376dc936['500'],
        $672d8daba6bf990f$export$221d31baf2636aad['500'],
        $672d8daba6bf990f$export$594c5a8758200c32['500'],
        $672d8daba6bf990f$export$7c1ecc66643fdbd6['500'],
        $672d8daba6bf990f$export$ad766f34ace1cafd['500'],
        $672d8daba6bf990f$export$1ceed3dd9ec11704['500'],
        $672d8daba6bf990f$export$b6e6178d3f565007['500'],
        $672d8daba6bf990f$export$7c2da42d08c019c9['500']
    ],
    styles: {}
};
var $57c76864175e51a4$export$2e2bcd8739ae039 = (0, $d9d5623a706e13aa$export$2e2bcd8739ae039)($57c76864175e51a4$export$c89a927ffc67e6fa);



var $5E6i4 = parcelRequire("5E6i4");





var $5E6i4 = parcelRequire("5E6i4");


/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ function $f86e31dc597f2957$var$isUndefined(value) {
    return value === undefined;
}
var $f86e31dc597f2957$export$2e2bcd8739ae039 = $f86e31dc597f2957$var$isUndefined;



var $017e2026873c3ead$exports = {};
'use strict';
Object.defineProperty($017e2026873c3ead$exports, "__esModule", {
    value: true
});
var $017e2026873c3ead$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $5E6i4 = parcelRequire("5E6i4");
var $017e2026873c3ead$var$_react2 = $017e2026873c3ead$var$_interopRequireDefault($5E6i4);
function $017e2026873c3ead$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $017e2026873c3ead$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var $017e2026873c3ead$var$DEFAULT_SIZE = 24;
$017e2026873c3ead$exports.default = function(_ref) {
    var _ref$fill = _ref.fill, fill = _ref$fill === undefined ? 'currentColor' : _ref$fill, _ref$width = _ref.width, width = _ref$width === undefined ? $017e2026873c3ead$var$DEFAULT_SIZE : _ref$width, _ref$height = _ref.height, height = _ref$height === undefined ? $017e2026873c3ead$var$DEFAULT_SIZE : _ref$height, _ref$style = _ref.style, style = _ref$style === undefined ? {} : _ref$style, props = $017e2026873c3ead$var$_objectWithoutProperties(_ref, [
        'fill',
        'width',
        'height',
        'style'
    ]);
    return $017e2026873c3ead$var$_react2.default.createElement('svg', $017e2026873c3ead$var$_extends({
        viewBox: '0 0 ' + $017e2026873c3ead$var$DEFAULT_SIZE + ' ' + $017e2026873c3ead$var$DEFAULT_SIZE,
        style: $017e2026873c3ead$var$_extends({
            fill: fill,
            width: width,
            height: height
        }, style)
    }, props), $017e2026873c3ead$var$_react2.default.createElement('path', {
        d: 'M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z'
    }));
};


var $2275fcb89d2bc9cc$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $2275fcb89d2bc9cc$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $2275fcb89d2bc9cc$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $2275fcb89d2bc9cc$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $2275fcb89d2bc9cc$export$71685d48a2432635 = function(_React$Component) {
    $2275fcb89d2bc9cc$var$_inherits(ChromeFields, _React$Component);
    function ChromeFields(props) {
        $2275fcb89d2bc9cc$var$_classCallCheck(this, ChromeFields);
        var _this = $2275fcb89d2bc9cc$var$_possibleConstructorReturn(this, (ChromeFields.__proto__ || Object.getPrototypeOf(ChromeFields)).call(this));
        _this.toggleViews = function() {
            if (_this.state.view === 'hex') _this.setState({
                view: 'rgb'
            });
            else if (_this.state.view === 'rgb') _this.setState({
                view: 'hsl'
            });
            else if (_this.state.view === 'hsl') {
                if (_this.props.hsl.a === 1) _this.setState({
                    view: 'hex'
                });
                else _this.setState({
                    view: 'rgb'
                });
            }
        };
        _this.handleChange = function(data, e) {
            if (data.hex) $3e246347c8e3b5b0$export$944f75ec5697b362(data.hex) && _this.props.onChange({
                hex: data.hex,
                source: 'hex'
            }, e);
            else if (data.r || data.g || data.b) _this.props.onChange({
                r: data.r || _this.props.rgb.r,
                g: data.g || _this.props.rgb.g,
                b: data.b || _this.props.rgb.b,
                source: 'rgb'
            }, e);
            else if (data.a) {
                if (data.a < 0) data.a = 0;
                else if (data.a > 1) data.a = 1;
                _this.props.onChange({
                    h: _this.props.hsl.h,
                    s: _this.props.hsl.s,
                    l: _this.props.hsl.l,
                    a: Math.round(data.a * 100) / 100,
                    source: 'rgb'
                }, e);
            } else if (data.h || data.s || data.l) {
                // Remove any occurances of '%'.
                if (typeof data.s === 'string' && data.s.includes('%')) data.s = data.s.replace('%', '');
                if (typeof data.l === 'string' && data.l.includes('%')) data.l = data.l.replace('%', '');
                // We store HSL as a unit interval so we need to override the 1 input to 0.01
                if (data.s == 1) data.s = 0.01;
                else if (data.l == 1) data.l = 0.01;
                _this.props.onChange({
                    h: data.h || _this.props.hsl.h,
                    s: Number(!(0, $f86e31dc597f2957$export$2e2bcd8739ae039)(data.s) ? data.s : _this.props.hsl.s),
                    l: Number(!(0, $f86e31dc597f2957$export$2e2bcd8739ae039)(data.l) ? data.l : _this.props.hsl.l),
                    source: 'hsl'
                }, e);
            }
        };
        _this.showHighlight = function(e) {
            e.currentTarget.style.background = '#eee';
        };
        _this.hideHighlight = function(e) {
            e.currentTarget.style.background = 'transparent';
        };
        if (props.hsl.a !== 1 && props.view === "hex") _this.state = {
            view: "rgb"
        };
        else _this.state = {
            view: props.view
        };
        return _this;
    }
    $2275fcb89d2bc9cc$var$_createClass(ChromeFields, [
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($c8d725e5ba719c3a$exports)))({
                    'default': {
                        wrap: {
                            paddingTop: '16px',
                            display: 'flex'
                        },
                        fields: {
                            flex: '1',
                            display: 'flex',
                            marginLeft: '-6px'
                        },
                        field: {
                            paddingLeft: '6px',
                            width: '100%'
                        },
                        alpha: {
                            paddingLeft: '6px',
                            width: '100%'
                        },
                        toggle: {
                            width: '32px',
                            textAlign: 'right',
                            position: 'relative'
                        },
                        icon: {
                            marginRight: '-4px',
                            marginTop: '12px',
                            cursor: 'pointer',
                            position: 'relative'
                        },
                        iconHighlight: {
                            position: 'absolute',
                            width: '24px',
                            height: '28px',
                            background: '#eee',
                            borderRadius: '4px',
                            top: '10px',
                            left: '12px',
                            display: 'none'
                        },
                        input: {
                            fontSize: '11px',
                            color: '#333',
                            width: '100%',
                            borderRadius: '2px',
                            border: 'none',
                            boxShadow: 'inset 0 0 0 1px #dadada',
                            height: '21px',
                            textAlign: 'center'
                        },
                        label: {
                            textTransform: 'uppercase',
                            fontSize: '11px',
                            lineHeight: '11px',
                            color: '#969696',
                            textAlign: 'center',
                            display: 'block',
                            marginTop: '12px'
                        },
                        svg: {
                            fill: '#333',
                            width: '24px',
                            height: '24px',
                            border: '1px transparent solid',
                            borderRadius: '5px'
                        }
                    },
                    'disableAlpha': {
                        alpha: {
                            display: 'none'
                        }
                    }
                }, this.props, this.state);
                var fields = void 0;
                if (this.state.view === 'hex') fields = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
                    style: styles.fields,
                    className: 'flexbox-fix'
                }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $cb537f80953d7d1d$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'hex',
                    value: this.props.hex,
                    onChange: this.handleChange
                })));
                else if (this.state.view === 'rgb') fields = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
                    style: styles.fields,
                    className: 'flexbox-fix'
                }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $cb537f80953d7d1d$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'r',
                    value: this.props.rgb.r,
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $cb537f80953d7d1d$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'g',
                    value: this.props.rgb.g,
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $cb537f80953d7d1d$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'b',
                    value: this.props.rgb.b,
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
                    style: styles.alpha
                }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $cb537f80953d7d1d$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'a',
                    value: this.props.rgb.a,
                    arrowOffset: 0.01,
                    onChange: this.handleChange
                })));
                else if (this.state.view === 'hsl') fields = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
                    style: styles.fields,
                    className: 'flexbox-fix'
                }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $cb537f80953d7d1d$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'h',
                    value: Math.round(this.props.hsl.h),
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $cb537f80953d7d1d$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 's',
                    value: Math.round(this.props.hsl.s * 100) + '%',
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $cb537f80953d7d1d$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'l',
                    value: Math.round(this.props.hsl.l * 100) + '%',
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
                    style: styles.alpha
                }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $cb537f80953d7d1d$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'a',
                    value: this.props.hsl.a,
                    arrowOffset: 0.01,
                    onChange: this.handleChange
                })));
                return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
                    style: styles.wrap,
                    className: 'flexbox-fix'
                }, fields, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
                    style: styles.toggle
                }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
                    style: styles.icon,
                    onClick: this.toggleViews,
                    ref: function ref(icon) {
                        return _this2.icon = icon;
                    }
                }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($017e2026873c3ead$exports))), {
                    style: styles.svg,
                    onMouseOver: this.showHighlight,
                    onMouseEnter: this.showHighlight,
                    onMouseOut: this.hideHighlight
                }))));
            }
        }
    ], [
        {
            key: 'getDerivedStateFromProps',
            value: function getDerivedStateFromProps(nextProps, state) {
                if (nextProps.hsl.a !== 1 && state.view === 'hex') return {
                    view: 'rgb'
                };
                return null;
            }
        }
    ]);
    return ChromeFields;
}((0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).Component);
$2275fcb89d2bc9cc$export$71685d48a2432635.defaultProps = {
    view: "hex"
};
var $2275fcb89d2bc9cc$export$2e2bcd8739ae039 = $2275fcb89d2bc9cc$export$71685d48a2432635;



var $5E6i4 = parcelRequire("5E6i4");

var $e1a846274f48607d$export$a632586f9a957100 = function ChromePointer() {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($c8d725e5ba719c3a$exports)))({
        'default': {
            picker: {
                width: '12px',
                height: '12px',
                borderRadius: '6px',
                transform: 'translate(-6px, -1px)',
                backgroundColor: 'rgb(248, 248, 248)',
                boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.picker
    });
};
var $e1a846274f48607d$export$2e2bcd8739ae039 = $e1a846274f48607d$export$a632586f9a957100;



var $5E6i4 = parcelRequire("5E6i4");

var $bfafe1ad85060b6e$export$190c1afe887f7ef7 = function ChromePointerCircle() {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($c8d725e5ba719c3a$exports)))({
        'default': {
            picker: {
                width: '12px',
                height: '12px',
                borderRadius: '6px',
                boxShadow: 'inset 0 0 0 1px #fff',
                transform: 'translate(-6px, -6px)'
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.picker
    });
};
var $bfafe1ad85060b6e$export$2e2bcd8739ae039 = $bfafe1ad85060b6e$export$190c1afe887f7ef7;


var $b06e8960235a0643$export$31a305e9779b48b4 = function Chrome(_ref) {
    var width = _ref.width, onChange = _ref.onChange, disableAlpha = _ref.disableAlpha, rgb = _ref.rgb, hsl = _ref.hsl, hsv = _ref.hsv, hex = _ref.hex, renderers = _ref.renderers, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className, defaultView = _ref.defaultView;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($c8d725e5ba719c3a$exports)))((0, $2b042368e2ec1525$export$2e2bcd8739ae039)({
        'default': {
            picker: {
                width: width,
                background: '#fff',
                borderRadius: '2px',
                boxShadow: '0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)',
                boxSizing: 'initial',
                fontFamily: 'Menlo'
            },
            saturation: {
                width: '100%',
                paddingBottom: '55%',
                position: 'relative',
                borderRadius: '2px 2px 0 0',
                overflow: 'hidden'
            },
            Saturation: {
                radius: '2px 2px 0 0'
            },
            body: {
                padding: '16px 16px 12px'
            },
            controls: {
                display: 'flex'
            },
            color: {
                width: '32px'
            },
            swatch: {
                marginTop: '6px',
                width: '16px',
                height: '16px',
                borderRadius: '8px',
                position: 'relative',
                overflow: 'hidden'
            },
            active: {
                absolute: '0px 0px 0px 0px',
                borderRadius: '8px',
                boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.1)',
                background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', ' + rgb.a + ')',
                zIndex: '2'
            },
            toggles: {
                flex: '1'
            },
            hue: {
                height: '10px',
                position: 'relative',
                marginBottom: '8px'
            },
            Hue: {
                radius: '2px'
            },
            alpha: {
                height: '10px',
                position: 'relative'
            },
            Alpha: {
                radius: '2px'
            }
        },
        'disableAlpha': {
            color: {
                width: '22px'
            },
            alpha: {
                display: 'none'
            },
            hue: {
                marginBottom: '0px'
            },
            swatch: {
                width: '10px',
                height: '10px',
                marginTop: '0px'
            }
        }
    }, passedStyles), {
        disableAlpha: disableAlpha
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.picker,
        className: 'chrome-picker ' + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.saturation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $93b5269a0cba01ab$export$2e2bcd8739ae039), {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        pointer: (0, $bfafe1ad85060b6e$export$2e2bcd8739ae039),
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.body
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.controls,
        className: 'flexbox-fix'
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.color
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.active
    }), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $9494de16828d37a1$export$2e2bcd8739ae039), {
        renderers: renderers
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.toggles
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.hue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $50e2c19f358237c5$export$2e2bcd8739ae039), {
        style: styles.Hue,
        hsl: hsl,
        pointer: (0, $e1a846274f48607d$export$2e2bcd8739ae039),
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.alpha
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $7bb4498a032d4109$export$2e2bcd8739ae039), {
        style: styles.Alpha,
        rgb: rgb,
        hsl: hsl,
        pointer: (0, $e1a846274f48607d$export$2e2bcd8739ae039),
        renderers: renderers,
        onChange: onChange
    })))), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $2275fcb89d2bc9cc$export$2e2bcd8739ae039), {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        view: defaultView,
        onChange: onChange,
        disableAlpha: disableAlpha
    })));
};
$b06e8960235a0643$export$31a305e9779b48b4.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).number
    ]),
    disableAlpha: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).object,
    defaultView: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOf([
        "hex",
        "rgb",
        "hsl"
    ])
};
$b06e8960235a0643$export$31a305e9779b48b4.defaultProps = {
    width: 225,
    disableAlpha: false,
    styles: {}
};
var $b06e8960235a0643$export$2e2bcd8739ae039 = (0, $d9d5623a706e13aa$export$2e2bcd8739ae039)($b06e8960235a0643$export$31a305e9779b48b4);



var $5E6i4 = parcelRequire("5E6i4");







var $5E6i4 = parcelRequire("5E6i4");



var $a320e668fb4061b2$export$df654652e5203306 = function CompactColor(_ref) {
    var color = _ref.color, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onSwatchHover = _ref.onSwatchHover, active = _ref.active;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($c8d725e5ba719c3a$exports)))({
        'default': {
            color: {
                background: color,
                width: '15px',
                height: '15px',
                float: 'left',
                marginRight: '5px',
                marginBottom: '5px',
                position: 'relative',
                cursor: 'pointer'
            },
            dot: {
                absolute: '5px 5px 5px 5px',
                background: $3e246347c8e3b5b0$export$3609eb1d7e55dec(color),
                borderRadius: '50%',
                opacity: '0'
            }
        },
        'active': {
            dot: {
                opacity: '1'
            }
        },
        'color-#FFFFFF': {
            color: {
                boxShadow: 'inset 0 0 0 1px #ddd'
            },
            dot: {
                background: '#000'
            }
        },
        'transparent': {
            dot: {
                background: '#000'
            }
        }
    }, {
        active: active,
        'color-#FFFFFF': color === '#FFFFFF',
        'transparent': color === 'transparent'
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $01e9c8ec84dd90c0$export$2e2bcd8739ae039), {
        style: styles.color,
        color: color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
            boxShadow: '0 0 4px ' + color
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.dot
    }));
};
var $a320e668fb4061b2$export$2e2bcd8739ae039 = $a320e668fb4061b2$export$df654652e5203306;



var $5E6i4 = parcelRequire("5E6i4");


var $34b0176382a7022d$export$11cdb14a03223d9c = function CompactFields(_ref) {
    var hex = _ref.hex, rgb = _ref.rgb, onChange = _ref.onChange;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($c8d725e5ba719c3a$exports)))({
        'default': {
            fields: {
                display: 'flex',
                paddingBottom: '6px',
                paddingRight: '5px',
                position: 'relative'
            },
            active: {
                position: 'absolute',
                top: '6px',
                left: '5px',
                height: '9px',
                width: '9px',
                background: hex
            },
            HEXwrap: {
                flex: '6',
                position: 'relative'
            },
            HEXinput: {
                width: '80%',
                padding: '0px',
                paddingLeft: '20%',
                border: 'none',
                outline: 'none',
                background: 'none',
                fontSize: '12px',
                color: '#333',
                height: '16px'
            },
            HEXlabel: {
                display: 'none'
            },
            RGBwrap: {
                flex: '3',
                position: 'relative'
            },
            RGBinput: {
                width: '70%',
                padding: '0px',
                paddingLeft: '30%',
                border: 'none',
                outline: 'none',
                background: 'none',
                fontSize: '12px',
                color: '#333',
                height: '16px'
            },
            RGBlabel: {
                position: 'absolute',
                top: '3px',
                left: '0px',
                lineHeight: '16px',
                textTransform: 'uppercase',
                fontSize: '12px',
                color: '#999'
            }
        }
    });
    var handleChange = function handleChange(data, e) {
        if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            source: 'rgb'
        }, e);
        else onChange({
            hex: data.hex,
            source: 'hex'
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.fields,
        className: 'flexbox-fix'
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.active
    }), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $cb537f80953d7d1d$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.HEXwrap,
            input: styles.HEXinput,
            label: styles.HEXlabel
        },
        label: 'hex',
        value: hex,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $cb537f80953d7d1d$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'r',
        value: rgb.r,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $cb537f80953d7d1d$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'g',
        value: rgb.g,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $cb537f80953d7d1d$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'b',
        value: rgb.b,
        onChange: handleChange
    }));
};
var $34b0176382a7022d$export$2e2bcd8739ae039 = $34b0176382a7022d$export$11cdb14a03223d9c;


var $fa0445a0f3f9459b$export$6479582a9c9e50ce = function Compact(_ref) {
    var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex = _ref.hex, rgb = _ref.rgb, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($c8d725e5ba719c3a$exports)))((0, $2b042368e2ec1525$export$2e2bcd8739ae039)({
        'default': {
            Compact: {
                background: '#f6f6f6',
                radius: '4px'
            },
            compact: {
                paddingTop: '5px',
                paddingLeft: '5px',
                boxSizing: 'initial',
                width: '240px'
            },
            clear: {
                clear: 'both'
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(data, e) {
        if (data.hex) $3e246347c8e3b5b0$export$944f75ec5697b362(data.hex) && onChange({
            hex: data.hex,
            source: 'hex'
        }, e);
        else onChange(data, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $7eb330dc2b73c9b0$export$2e2bcd8739ae039), {
        style: styles.Compact,
        styles: passedStyles
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.compact,
        className: 'compact-picker ' + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', null, (0, $f872dc2287484c72$export$2e2bcd8739ae039)(colors, function(c) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $a320e668fb4061b2$export$2e2bcd8739ae039), {
            key: c,
            color: c,
            active: c.toLowerCase() === hex,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
        });
    }), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.clear
    })), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $34b0176382a7022d$export$2e2bcd8739ae039), {
        hex: hex,
        rgb: rgb,
        onChange: handleChange
    })));
};
$fa0445a0f3f9459b$export$6479582a9c9e50ce.propTypes = {
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).object
};
$fa0445a0f3f9459b$export$6479582a9c9e50ce.defaultProps = {
    colors: [
        '#4D4D4D',
        '#999999',
        '#FFFFFF',
        '#F44E3B',
        '#FE9200',
        '#FCDC00',
        '#DBDF00',
        '#A4DD00',
        '#68CCCA',
        '#73D8FF',
        '#AEA1FF',
        '#FDA1FF',
        '#333333',
        '#808080',
        '#cccccc',
        '#D33115',
        '#E27300',
        '#FCC400',
        '#B0BC00',
        '#68BC00',
        '#16A5A5',
        '#009CE0',
        '#7B64FF',
        '#FA28FF',
        '#000000',
        '#666666',
        '#B3B3B3',
        '#9F0500',
        '#C45100',
        '#FB9E00',
        '#808900',
        '#194D33',
        '#0C797D',
        '#0062B1',
        '#653294',
        '#AB149E'
    ],
    styles: {}
};
var $fa0445a0f3f9459b$export$2e2bcd8739ae039 = (0, $d9d5623a706e13aa$export$2e2bcd8739ae039)($fa0445a0f3f9459b$export$6479582a9c9e50ce);



var $5E6i4 = parcelRequire("5E6i4");






var $5E6i4 = parcelRequire("5E6i4");


var $cc74900b6334ad30$export$d653c538b92bb84f = function GithubSwatch(_ref) {
    var hover = _ref.hover, color = _ref.color, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover;
    var hoverSwatch = {
        position: 'relative',
        zIndex: '2',
        outline: '2px solid #fff',
        boxShadow: '0 0 5px 2px rgba(0,0,0,0.25)'
    };
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($c8d725e5ba719c3a$exports)))({
        'default': {
            swatch: {
                width: '25px',
                height: '25px',
                fontSize: '0'
            }
        },
        'hover': {
            swatch: hoverSwatch
        }
    }, {
        hover: hover
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $01e9c8ec84dd90c0$export$2e2bcd8739ae039), {
        color: color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: hoverSwatch
    }));
};
var $cc74900b6334ad30$export$2e2bcd8739ae039 = (0, $c8d725e5ba719c3a$exports.handleHover)($cc74900b6334ad30$export$d653c538b92bb84f);


var $5b8198740f008c6c$export$61d478c2aba5d9a5 = function Github(_ref) {
    var width = _ref.width, colors = _ref.colors, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, triangle = _ref.triangle, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($c8d725e5ba719c3a$exports)))((0, $2b042368e2ec1525$export$2e2bcd8739ae039)({
        'default': {
            card: {
                width: width,
                background: '#fff',
                border: '1px solid rgba(0,0,0,0.2)',
                boxShadow: '0 3px 12px rgba(0,0,0,0.15)',
                borderRadius: '4px',
                position: 'relative',
                padding: '5px',
                display: 'flex',
                flexWrap: 'wrap'
            },
            triangle: {
                position: 'absolute',
                border: '7px solid transparent',
                borderBottomColor: '#fff'
            },
            triangleShadow: {
                position: 'absolute',
                border: '8px solid transparent',
                borderBottomColor: 'rgba(0,0,0,0.15)'
            }
        },
        'hide-triangle': {
            triangle: {
                display: 'none'
            },
            triangleShadow: {
                display: 'none'
            }
        },
        'top-left-triangle': {
            triangle: {
                top: '-14px',
                left: '10px'
            },
            triangleShadow: {
                top: '-16px',
                left: '9px'
            }
        },
        'top-right-triangle': {
            triangle: {
                top: '-14px',
                right: '10px'
            },
            triangleShadow: {
                top: '-16px',
                right: '9px'
            }
        },
        'bottom-left-triangle': {
            triangle: {
                top: '35px',
                left: '10px',
                transform: 'rotate(180deg)'
            },
            triangleShadow: {
                top: '37px',
                left: '9px',
                transform: 'rotate(180deg)'
            }
        },
        'bottom-right-triangle': {
            triangle: {
                top: '35px',
                right: '10px',
                transform: 'rotate(180deg)'
            },
            triangleShadow: {
                top: '37px',
                right: '9px',
                transform: 'rotate(180deg)'
            }
        }
    }, passedStyles), {
        'hide-triangle': triangle === 'hide',
        'top-left-triangle': triangle === 'top-left',
        'top-right-triangle': triangle === 'top-right',
        'bottom-left-triangle': triangle === 'bottom-left',
        'bottom-right-triangle': triangle === 'bottom-right'
    });
    var handleChange = function handleChange(hex, e) {
        return onChange({
            hex: hex,
            source: 'hex'
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.card,
        className: 'github-picker ' + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.triangleShadow
    }), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.triangle
    }), (0, $f872dc2287484c72$export$2e2bcd8739ae039)(colors, function(c) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $cc74900b6334ad30$export$2e2bcd8739ae039), {
            color: c,
            key: c,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
        });
    }));
};
$5b8198740f008c6c$export$61d478c2aba5d9a5.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).number
    ]),
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string),
    triangle: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOf([
        'hide',
        'top-left',
        'top-right',
        'bottom-left',
        'bottom-right'
    ]),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).object
};
$5b8198740f008c6c$export$61d478c2aba5d9a5.defaultProps = {
    width: 200,
    colors: [
        '#B80000',
        '#DB3E00',
        '#FCCB00',
        '#008B02',
        '#006B76',
        '#1273DE',
        '#004DCF',
        '#5300EB',
        '#EB9694',
        '#FAD0C3',
        '#FEF3BD',
        '#C1E1C5',
        '#BEDADC',
        '#C4DEF6',
        '#BED3F3',
        '#D4C4FB'
    ],
    triangle: 'top-left',
    styles: {}
};
var $5b8198740f008c6c$export$2e2bcd8739ae039 = (0, $d9d5623a706e13aa$export$2e2bcd8739ae039)($5b8198740f008c6c$export$61d478c2aba5d9a5);



var $5E6i4 = parcelRequire("5E6i4");





var $5E6i4 = parcelRequire("5E6i4");

var $21dc5bed66045b36$export$9c10b52c64965f67 = function SliderPointer(_ref) {
    var direction = _ref.direction;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($c8d725e5ba719c3a$exports)))({
        'default': {
            picker: {
                width: '18px',
                height: '18px',
                borderRadius: '50%',
                transform: 'translate(-9px, -1px)',
                backgroundColor: 'rgb(248, 248, 248)',
                boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
            }
        },
        'vertical': {
            picker: {
                transform: 'translate(-3px, -9px)'
            }
        }
    }, {
        vertical: direction === 'vertical'
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.picker
    });
};
var $21dc5bed66045b36$export$2e2bcd8739ae039 = $21dc5bed66045b36$export$9c10b52c64965f67;


var $b9472939e53203d4$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $b9472939e53203d4$export$f176087feb20230e = function HuePicker(_ref) {
    var width = _ref.width, height = _ref.height, onChange = _ref.onChange, hsl = _ref.hsl, direction = _ref.direction, pointer = _ref.pointer, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($c8d725e5ba719c3a$exports)))((0, $2b042368e2ec1525$export$2e2bcd8739ae039)({
        'default': {
            picker: {
                position: 'relative',
                width: width,
                height: height
            },
            hue: {
                radius: '2px'
            }
        }
    }, passedStyles));
    // Overwrite to provide pure hue color
    var handleChange = function handleChange(data) {
        return onChange({
            a: 1,
            h: data.h,
            l: 0.5,
            s: 1
        });
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.picker,
        className: 'hue-picker ' + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $50e2c19f358237c5$export$2e2bcd8739ae039), $b9472939e53203d4$var$_extends({}, styles.hue, {
        hsl: hsl,
        pointer: pointer,
        onChange: handleChange,
        direction: direction
    })));
};
$b9472939e53203d4$export$f176087feb20230e.propTypes = {
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).object
};
$b9472939e53203d4$export$f176087feb20230e.defaultProps = {
    width: '316px',
    height: '16px',
    direction: 'horizontal',
    pointer: (0, $21dc5bed66045b36$export$2e2bcd8739ae039),
    styles: {}
};
var $b9472939e53203d4$export$2e2bcd8739ae039 = (0, $d9d5623a706e13aa$export$2e2bcd8739ae039)($b9472939e53203d4$export$f176087feb20230e);



var $5E6i4 = parcelRequire("5E6i4");




var $7be50c65829f011f$export$a2d8b23205c25948 = function Material(_ref) {
    var onChange = _ref.onChange, hex = _ref.hex, rgb = _ref.rgb, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($c8d725e5ba719c3a$exports)))((0, $2b042368e2ec1525$export$2e2bcd8739ae039)({
        'default': {
            material: {
                width: '98px',
                height: '98px',
                padding: '16px',
                fontFamily: 'Roboto'
            },
            HEXwrap: {
                position: 'relative'
            },
            HEXinput: {
                width: '100%',
                marginTop: '12px',
                fontSize: '15px',
                color: '#333',
                padding: '0px',
                border: '0px',
                borderBottom: '2px solid ' + hex,
                outline: 'none',
                height: '30px'
            },
            HEXlabel: {
                position: 'absolute',
                top: '0px',
                left: '0px',
                fontSize: '11px',
                color: '#999999',
                textTransform: 'capitalize'
            },
            Hex: {
                style: {}
            },
            RGBwrap: {
                position: 'relative'
            },
            RGBinput: {
                width: '100%',
                marginTop: '12px',
                fontSize: '15px',
                color: '#333',
                padding: '0px',
                border: '0px',
                borderBottom: '1px solid #eee',
                outline: 'none',
                height: '30px'
            },
            RGBlabel: {
                position: 'absolute',
                top: '0px',
                left: '0px',
                fontSize: '11px',
                color: '#999999',
                textTransform: 'capitalize'
            },
            split: {
                display: 'flex',
                marginRight: '-10px',
                paddingTop: '11px'
            },
            third: {
                flex: '1',
                paddingRight: '10px'
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(data, e) {
        if (data.hex) $3e246347c8e3b5b0$export$944f75ec5697b362(data.hex) && onChange({
            hex: data.hex,
            source: 'hex'
        }, e);
        else if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            source: 'rgb'
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $7eb330dc2b73c9b0$export$2e2bcd8739ae039), {
        styles: passedStyles
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.material,
        className: 'material-picker ' + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $cb537f80953d7d1d$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.HEXwrap,
            input: styles.HEXinput,
            label: styles.HEXlabel
        },
        label: 'hex',
        value: hex,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.split,
        className: 'flexbox-fix'
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.third
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $cb537f80953d7d1d$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'r',
        value: rgb.r,
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.third
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $cb537f80953d7d1d$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'g',
        value: rgb.g,
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.third
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $cb537f80953d7d1d$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'b',
        value: rgb.b,
        onChange: handleChange
    })))));
};
var $7be50c65829f011f$export$2e2bcd8739ae039 = (0, $d9d5623a706e13aa$export$2e2bcd8739ae039)($7be50c65829f011f$export$a2d8b23205c25948);



var $5E6i4 = parcelRequire("5E6i4");





var $5E6i4 = parcelRequire("5E6i4");



var $f6a97b026e041e2d$export$b1808ee9bfa8f4d0 = function PhotoshopPicker(_ref) {
    var onChange = _ref.onChange, rgb = _ref.rgb, hsv = _ref.hsv, hex = _ref.hex;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($c8d725e5ba719c3a$exports)))({
        'default': {
            fields: {
                paddingTop: '5px',
                paddingBottom: '9px',
                width: '80px',
                position: 'relative'
            },
            divider: {
                height: '5px'
            },
            RGBwrap: {
                position: 'relative'
            },
            RGBinput: {
                marginLeft: '40%',
                width: '40%',
                height: '18px',
                border: '1px solid #888888',
                boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
                marginBottom: '5px',
                fontSize: '13px',
                paddingLeft: '3px',
                marginRight: '10px'
            },
            RGBlabel: {
                left: '0px',
                top: '0px',
                width: '34px',
                textTransform: 'uppercase',
                fontSize: '13px',
                height: '18px',
                lineHeight: '22px',
                position: 'absolute'
            },
            HEXwrap: {
                position: 'relative'
            },
            HEXinput: {
                marginLeft: '20%',
                width: '80%',
                height: '18px',
                border: '1px solid #888888',
                boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
                marginBottom: '6px',
                fontSize: '13px',
                paddingLeft: '3px'
            },
            HEXlabel: {
                position: 'absolute',
                top: '0px',
                left: '0px',
                width: '14px',
                textTransform: 'uppercase',
                fontSize: '13px',
                height: '18px',
                lineHeight: '22px'
            },
            fieldSymbols: {
                position: 'absolute',
                top: '5px',
                right: '-7px',
                fontSize: '13px'
            },
            symbol: {
                height: '20px',
                lineHeight: '22px',
                paddingBottom: '7px'
            }
        }
    });
    var handleChange = function handleChange(data, e) {
        if (data['#']) $3e246347c8e3b5b0$export$944f75ec5697b362(data['#']) && onChange({
            hex: data['#'],
            source: 'hex'
        }, e);
        else if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            source: 'rgb'
        }, e);
        else if (data.h || data.s || data.v) onChange({
            h: data.h || hsv.h,
            s: data.s || hsv.s,
            v: data.v || hsv.v,
            source: 'hsv'
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.fields
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $cb537f80953d7d1d$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'h',
        value: Math.round(hsv.h),
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $cb537f80953d7d1d$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 's',
        value: Math.round(hsv.s * 100),
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $cb537f80953d7d1d$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'v',
        value: Math.round(hsv.v * 100),
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.divider
    }), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $cb537f80953d7d1d$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'r',
        value: rgb.r,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $cb537f80953d7d1d$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'g',
        value: rgb.g,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $cb537f80953d7d1d$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'b',
        value: rgb.b,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.divider
    }), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $cb537f80953d7d1d$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.HEXwrap,
            input: styles.HEXinput,
            label: styles.HEXlabel
        },
        label: '#',
        value: hex.replace('#', ''),
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.fieldSymbols
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.symbol
    }, '\xB0'), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.symbol
    }, '%'), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.symbol
    }, '%')));
};
var $f6a97b026e041e2d$export$2e2bcd8739ae039 = $f6a97b026e041e2d$export$b1808ee9bfa8f4d0;



var $5E6i4 = parcelRequire("5E6i4");

var $ddadc48e7452ec03$export$123b96ff8455915 = function PhotoshopPointerCircle(_ref) {
    var hsl = _ref.hsl;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($c8d725e5ba719c3a$exports)))({
        'default': {
            picker: {
                width: '12px',
                height: '12px',
                borderRadius: '6px',
                boxShadow: 'inset 0 0 0 1px #fff',
                transform: 'translate(-6px, -6px)'
            }
        },
        'black-outline': {
            picker: {
                boxShadow: 'inset 0 0 0 1px #000'
            }
        }
    }, {
        'black-outline': hsl.l > 0.5
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.picker
    });
};
var $ddadc48e7452ec03$export$2e2bcd8739ae039 = $ddadc48e7452ec03$export$123b96ff8455915;



var $5E6i4 = parcelRequire("5E6i4");

var $736554a0f0905571$export$123b96ff8455915 = function PhotoshopPointerCircle() {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($c8d725e5ba719c3a$exports)))({
        'default': {
            triangle: {
                width: 0,
                height: 0,
                borderStyle: 'solid',
                borderWidth: '4px 0 4px 6px',
                borderColor: 'transparent transparent transparent #fff',
                position: 'absolute',
                top: '1px',
                left: '1px'
            },
            triangleBorder: {
                width: 0,
                height: 0,
                borderStyle: 'solid',
                borderWidth: '5px 0 5px 8px',
                borderColor: 'transparent transparent transparent #555'
            },
            left: {
                Extend: 'triangleBorder',
                transform: 'translate(-13px, -4px)'
            },
            leftInside: {
                Extend: 'triangle',
                transform: 'translate(-8px, -5px)'
            },
            right: {
                Extend: 'triangleBorder',
                transform: 'translate(20px, -14px) rotate(180deg)'
            },
            rightInside: {
                Extend: 'triangle',
                transform: 'translate(-8px, -5px)'
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.pointer
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.left
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.leftInside
    })), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.right
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.rightInside
    })));
};
var $736554a0f0905571$export$2e2bcd8739ae039 = $736554a0f0905571$export$123b96ff8455915;



var $5E6i4 = parcelRequire("5E6i4");

var $94cef155f87a2e75$export$f7d38a0bd3b98717 = function PhotoshopButton(_ref) {
    var onClick = _ref.onClick, label = _ref.label, children = _ref.children, active = _ref.active;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($c8d725e5ba719c3a$exports)))({
        'default': {
            button: {
                backgroundImage: 'linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)',
                border: '1px solid #878787',
                borderRadius: '2px',
                height: '20px',
                boxShadow: '0 1px 0 0 #EAEAEA',
                fontSize: '14px',
                color: '#000',
                lineHeight: '20px',
                textAlign: 'center',
                marginBottom: '10px',
                cursor: 'pointer'
            }
        },
        'active': {
            button: {
                boxShadow: '0 0 0 1px #878787'
            }
        }
    }, {
        active: active
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.button,
        onClick: onClick
    }, label || children);
};
var $94cef155f87a2e75$export$2e2bcd8739ae039 = $94cef155f87a2e75$export$f7d38a0bd3b98717;



var $5E6i4 = parcelRequire("5E6i4");

var $cff1800bb6bb6654$export$ce0d7acd66f46f2b = function PhotoshopPreviews(_ref) {
    var rgb = _ref.rgb, currentColor = _ref.currentColor;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($c8d725e5ba719c3a$exports)))({
        'default': {
            swatches: {
                border: '1px solid #B3B3B3',
                borderBottom: '1px solid #F0F0F0',
                marginBottom: '2px',
                marginTop: '1px'
            },
            new: {
                height: '34px',
                background: 'rgb(' + rgb.r + ',' + rgb.g + ', ' + rgb.b + ')',
                boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000'
            },
            current: {
                height: '34px',
                background: currentColor,
                boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000'
            },
            label: {
                fontSize: '14px',
                color: '#000',
                textAlign: 'center'
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', null, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.label
    }, 'new'), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.swatches
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.new
    }), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.current
    })), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.label
    }, 'current'));
};
var $cff1800bb6bb6654$export$2e2bcd8739ae039 = $cff1800bb6bb6654$export$ce0d7acd66f46f2b;


var $7df70560b573cf8a$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $7df70560b573cf8a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7df70560b573cf8a$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $7df70560b573cf8a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $7df70560b573cf8a$export$4ed116dea8ad5956 = function(_React$Component) {
    $7df70560b573cf8a$var$_inherits(Photoshop, _React$Component);
    function Photoshop(props) {
        $7df70560b573cf8a$var$_classCallCheck(this, Photoshop);
        var _this = $7df70560b573cf8a$var$_possibleConstructorReturn(this, (Photoshop.__proto__ || Object.getPrototypeOf(Photoshop)).call(this));
        _this.state = {
            currentColor: props.hex
        };
        return _this;
    }
    $7df70560b573cf8a$var$_createClass(Photoshop, [
        {
            key: 'render',
            value: function render() {
                var _props = this.props, _props$styles = _props.styles, passedStyles = _props$styles === undefined ? {} : _props$styles, _props$className = _props.className, className = _props$className === undefined ? '' : _props$className;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($c8d725e5ba719c3a$exports)))((0, $2b042368e2ec1525$export$2e2bcd8739ae039)({
                    'default': {
                        picker: {
                            background: '#DCDCDC',
                            borderRadius: '4px',
                            boxShadow: '0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)',
                            boxSizing: 'initial',
                            width: '513px'
                        },
                        head: {
                            backgroundImage: 'linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)',
                            borderBottom: '1px solid #B1B1B1',
                            boxShadow: 'inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)',
                            height: '23px',
                            lineHeight: '24px',
                            borderRadius: '4px 4px 0 0',
                            fontSize: '13px',
                            color: '#4D4D4D',
                            textAlign: 'center'
                        },
                        body: {
                            padding: '15px 15px 0',
                            display: 'flex'
                        },
                        saturation: {
                            width: '256px',
                            height: '256px',
                            position: 'relative',
                            border: '2px solid #B3B3B3',
                            borderBottom: '2px solid #F0F0F0',
                            overflow: 'hidden'
                        },
                        hue: {
                            position: 'relative',
                            height: '256px',
                            width: '19px',
                            marginLeft: '10px',
                            border: '2px solid #B3B3B3',
                            borderBottom: '2px solid #F0F0F0'
                        },
                        controls: {
                            width: '180px',
                            marginLeft: '10px'
                        },
                        top: {
                            display: 'flex'
                        },
                        previews: {
                            width: '60px'
                        },
                        actions: {
                            flex: '1',
                            marginLeft: '20px'
                        }
                    }
                }, passedStyles));
                return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
                    style: styles.picker,
                    className: 'photoshop-picker ' + className
                }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
                    style: styles.head
                }, this.props.header), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
                    style: styles.body,
                    className: 'flexbox-fix'
                }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
                    style: styles.saturation
                }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $93b5269a0cba01ab$export$2e2bcd8739ae039), {
                    hsl: this.props.hsl,
                    hsv: this.props.hsv,
                    pointer: (0, $ddadc48e7452ec03$export$2e2bcd8739ae039),
                    onChange: this.props.onChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
                    style: styles.hue
                }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $50e2c19f358237c5$export$2e2bcd8739ae039), {
                    direction: 'vertical',
                    hsl: this.props.hsl,
                    pointer: (0, $736554a0f0905571$export$2e2bcd8739ae039),
                    onChange: this.props.onChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
                    style: styles.controls
                }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
                    style: styles.top,
                    className: 'flexbox-fix'
                }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
                    style: styles.previews
                }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $cff1800bb6bb6654$export$2e2bcd8739ae039), {
                    rgb: this.props.rgb,
                    currentColor: this.state.currentColor
                })), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
                    style: styles.actions
                }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $94cef155f87a2e75$export$2e2bcd8739ae039), {
                    label: 'OK',
                    onClick: this.props.onAccept,
                    active: true
                }), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $94cef155f87a2e75$export$2e2bcd8739ae039), {
                    label: 'Cancel',
                    onClick: this.props.onCancel
                }), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $f6a97b026e041e2d$export$2e2bcd8739ae039), {
                    onChange: this.props.onChange,
                    rgb: this.props.rgb,
                    hsv: this.props.hsv,
                    hex: this.props.hex
                }))))));
            }
        }
    ]);
    return Photoshop;
}((0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).Component);
$7df70560b573cf8a$export$4ed116dea8ad5956.propTypes = {
    header: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).object
};
$7df70560b573cf8a$export$4ed116dea8ad5956.defaultProps = {
    header: 'Color Picker',
    styles: {}
};
var $7df70560b573cf8a$export$2e2bcd8739ae039 = (0, $d9d5623a706e13aa$export$2e2bcd8739ae039)($7df70560b573cf8a$export$4ed116dea8ad5956);



var $5E6i4 = parcelRequire("5E6i4");




/* eslint-disable no-param-reassign */ 
var $5E6i4 = parcelRequire("5E6i4");



var $a6f9ebcebc273470$export$a9bdb1170868e062 = function SketchFields(_ref) {
    var onChange = _ref.onChange, rgb = _ref.rgb, hsl = _ref.hsl, hex = _ref.hex, disableAlpha = _ref.disableAlpha;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($c8d725e5ba719c3a$exports)))({
        'default': {
            fields: {
                display: 'flex',
                paddingTop: '4px'
            },
            single: {
                flex: '1',
                paddingLeft: '6px'
            },
            alpha: {
                flex: '1',
                paddingLeft: '6px'
            },
            double: {
                flex: '2'
            },
            input: {
                width: '80%',
                padding: '4px 10% 3px',
                border: 'none',
                boxShadow: 'inset 0 0 0 1px #ccc',
                fontSize: '11px'
            },
            label: {
                display: 'block',
                textAlign: 'center',
                fontSize: '11px',
                color: '#222',
                paddingTop: '3px',
                paddingBottom: '4px',
                textTransform: 'capitalize'
            }
        },
        'disableAlpha': {
            alpha: {
                display: 'none'
            }
        }
    }, {
        disableAlpha: disableAlpha
    });
    var handleChange = function handleChange(data, e) {
        if (data.hex) $3e246347c8e3b5b0$export$944f75ec5697b362(data.hex) && onChange({
            hex: data.hex,
            source: 'hex'
        }, e);
        else if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            a: rgb.a,
            source: 'rgb'
        }, e);
        else if (data.a) {
            if (data.a < 0) data.a = 0;
            else if (data.a > 100) data.a = 100;
            data.a /= 100;
            onChange({
                h: hsl.h,
                s: hsl.s,
                l: hsl.l,
                a: data.a,
                source: 'rgb'
            }, e);
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.fields,
        className: 'flexbox-fix'
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.double
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $cb537f80953d7d1d$export$2e2bcd8739ae039), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: 'hex',
        value: hex.replace('#', ''),
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $cb537f80953d7d1d$export$2e2bcd8739ae039), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: 'r',
        value: rgb.r,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
    })), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $cb537f80953d7d1d$export$2e2bcd8739ae039), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: 'g',
        value: rgb.g,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
    })), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $cb537f80953d7d1d$export$2e2bcd8739ae039), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: 'b',
        value: rgb.b,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
    })), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.alpha
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $cb537f80953d7d1d$export$2e2bcd8739ae039), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: 'a',
        value: Math.round(rgb.a * 100),
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '100'
    })));
};
var $a6f9ebcebc273470$export$2e2bcd8739ae039 = $a6f9ebcebc273470$export$a9bdb1170868e062;



var $5E6i4 = parcelRequire("5E6i4");



var $b8cc4d1409fb78aa$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $b8cc4d1409fb78aa$export$cc78acae6744db3b = function SketchPresetColors(_ref) {
    var colors = _ref.colors, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onSwatchHover = _ref.onSwatchHover;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($c8d725e5ba719c3a$exports)))({
        'default': {
            colors: {
                margin: '0 -10px',
                padding: '10px 0 0 10px',
                borderTop: '1px solid #eee',
                display: 'flex',
                flexWrap: 'wrap',
                position: 'relative'
            },
            swatchWrap: {
                width: '16px',
                height: '16px',
                margin: '0 10px 10px 0'
            },
            swatch: {
                borderRadius: '3px',
                boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15)'
            }
        },
        'no-presets': {
            colors: {
                display: 'none'
            }
        }
    }, {
        'no-presets': !colors || !colors.length
    });
    var handleClick = function handleClick(hex, e) {
        onClick({
            hex: hex,
            source: 'hex'
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.colors,
        className: 'flexbox-fix'
    }, colors.map(function(colorObjOrString) {
        var c = typeof colorObjOrString === 'string' ? {
            color: colorObjOrString
        } : colorObjOrString;
        var key = '' + c.color + (c.title || '');
        return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
            key: key,
            style: styles.swatchWrap
        }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $01e9c8ec84dd90c0$export$2e2bcd8739ae039), $b8cc4d1409fb78aa$var$_extends({}, c, {
            style: styles.swatch,
            onClick: handleClick,
            onHover: onSwatchHover,
            focusStyle: {
                boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px ' + c.color
            }
        })));
    }));
};
$b8cc4d1409fb78aa$export$cc78acae6744db3b.propTypes = {
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).shape({
            color: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
            title: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string
        })
    ])).isRequired
};
var $b8cc4d1409fb78aa$export$2e2bcd8739ae039 = $b8cc4d1409fb78aa$export$cc78acae6744db3b;


var $e118cbe38e036f15$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $e118cbe38e036f15$export$361fce2090be193f = function Sketch(_ref) {
    var width = _ref.width, rgb = _ref.rgb, hex = _ref.hex, hsv = _ref.hsv, hsl = _ref.hsl, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, disableAlpha = _ref.disableAlpha, presetColors = _ref.presetColors, renderers = _ref.renderers, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($c8d725e5ba719c3a$exports)))((0, $2b042368e2ec1525$export$2e2bcd8739ae039)({
        'default': $e118cbe38e036f15$var$_extends({
            picker: {
                width: width,
                padding: '10px 10px 0',
                boxSizing: 'initial',
                background: '#fff',
                borderRadius: '4px',
                boxShadow: '0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)'
            },
            saturation: {
                width: '100%',
                paddingBottom: '75%',
                position: 'relative',
                overflow: 'hidden'
            },
            Saturation: {
                radius: '3px',
                shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
            },
            controls: {
                display: 'flex'
            },
            sliders: {
                padding: '4px 0',
                flex: '1'
            },
            color: {
                width: '24px',
                height: '24px',
                position: 'relative',
                marginTop: '4px',
                marginLeft: '4px',
                borderRadius: '3px'
            },
            activeColor: {
                absolute: '0px 0px 0px 0px',
                borderRadius: '2px',
                background: 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + rgb.a + ')',
                boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
            },
            hue: {
                position: 'relative',
                height: '10px',
                overflow: 'hidden'
            },
            Hue: {
                radius: '2px',
                shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
            },
            alpha: {
                position: 'relative',
                height: '10px',
                marginTop: '4px',
                overflow: 'hidden'
            },
            Alpha: {
                radius: '2px',
                shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
            }
        }, passedStyles),
        'disableAlpha': {
            color: {
                height: '10px'
            },
            hue: {
                height: '10px'
            },
            alpha: {
                display: 'none'
            }
        }
    }, passedStyles), {
        disableAlpha: disableAlpha
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.picker,
        className: 'sketch-picker ' + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.saturation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $93b5269a0cba01ab$export$2e2bcd8739ae039), {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.controls,
        className: 'flexbox-fix'
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.sliders
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.hue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $50e2c19f358237c5$export$2e2bcd8739ae039), {
        style: styles.Hue,
        hsl: hsl,
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.alpha
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $7bb4498a032d4109$export$2e2bcd8739ae039), {
        style: styles.Alpha,
        rgb: rgb,
        hsl: hsl,
        renderers: renderers,
        onChange: onChange
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.color
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $9494de16828d37a1$export$2e2bcd8739ae039), null), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.activeColor
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $a6f9ebcebc273470$export$2e2bcd8739ae039), {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        onChange: onChange,
        disableAlpha: disableAlpha
    }), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $b8cc4d1409fb78aa$export$2e2bcd8739ae039), {
        colors: presetColors,
        onClick: onChange,
        onSwatchHover: onSwatchHover
    }));
};
$e118cbe38e036f15$export$361fce2090be193f.propTypes = {
    disableAlpha: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).number
    ]),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).object
};
$e118cbe38e036f15$export$361fce2090be193f.defaultProps = {
    disableAlpha: false,
    width: 200,
    styles: {},
    presetColors: [
        '#D0021B',
        '#F5A623',
        '#F8E71C',
        '#8B572A',
        '#7ED321',
        '#417505',
        '#BD10E0',
        '#9013FE',
        '#4A90E2',
        '#50E3C2',
        '#B8E986',
        '#000000',
        '#4A4A4A',
        '#9B9B9B',
        '#FFFFFF'
    ]
};
var $e118cbe38e036f15$export$2e2bcd8739ae039 = (0, $d9d5623a706e13aa$export$2e2bcd8739ae039)($e118cbe38e036f15$export$361fce2090be193f);



var $5E6i4 = parcelRequire("5E6i4");





var $5E6i4 = parcelRequire("5E6i4");


var $5E6i4 = parcelRequire("5E6i4");

var $ea40afa43acf9e7c$export$5c11afa672411de4 = function SliderSwatch(_ref) {
    var hsl = _ref.hsl, offset = _ref.offset, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, active = _ref.active, first = _ref.first, last = _ref.last;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($c8d725e5ba719c3a$exports)))({
        'default': {
            swatch: {
                height: '12px',
                background: 'hsl(' + hsl.h + ', 50%, ' + offset * 100 + '%)',
                cursor: 'pointer'
            }
        },
        'first': {
            swatch: {
                borderRadius: '2px 0 0 2px'
            }
        },
        'last': {
            swatch: {
                borderRadius: '0 2px 2px 0'
            }
        },
        'active': {
            swatch: {
                transform: 'scaleY(1.8)',
                borderRadius: '3.6px/2px'
            }
        }
    }, {
        active: active,
        first: first,
        last: last
    });
    var handleClick = function handleClick(e) {
        return onClick({
            h: hsl.h,
            s: 0.5,
            l: offset,
            source: 'hsl'
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.swatch,
        onClick: handleClick
    });
};
var $ea40afa43acf9e7c$export$2e2bcd8739ae039 = $ea40afa43acf9e7c$export$5c11afa672411de4;


var $bf5a214261830751$export$48f49e32c66cdd61 = function SliderSwatches(_ref) {
    var onClick = _ref.onClick, hsl = _ref.hsl;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($c8d725e5ba719c3a$exports)))({
        'default': {
            swatches: {
                marginTop: '20px'
            },
            swatch: {
                boxSizing: 'border-box',
                width: '20%',
                paddingRight: '1px',
                float: 'left'
            },
            clear: {
                clear: 'both'
            }
        }
    });
    // Acceptible difference in floating point equality
    var epsilon = 0.1;
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.swatches
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $ea40afa43acf9e7c$export$2e2bcd8739ae039), {
        hsl: hsl,
        offset: '.80',
        active: Math.abs(hsl.l - 0.80) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick,
        first: true
    })), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $ea40afa43acf9e7c$export$2e2bcd8739ae039), {
        hsl: hsl,
        offset: '.65',
        active: Math.abs(hsl.l - 0.65) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
    })), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $ea40afa43acf9e7c$export$2e2bcd8739ae039), {
        hsl: hsl,
        offset: '.50',
        active: Math.abs(hsl.l - 0.50) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
    })), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $ea40afa43acf9e7c$export$2e2bcd8739ae039), {
        hsl: hsl,
        offset: '.35',
        active: Math.abs(hsl.l - 0.35) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
    })), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $ea40afa43acf9e7c$export$2e2bcd8739ae039), {
        hsl: hsl,
        offset: '.20',
        active: Math.abs(hsl.l - 0.20) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick,
        last: true
    })), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.clear
    }));
};
var $bf5a214261830751$export$2e2bcd8739ae039 = $bf5a214261830751$export$48f49e32c66cdd61;



var $5E6i4 = parcelRequire("5E6i4");

var $96c409e9d356bf0c$export$9c10b52c64965f67 = function SliderPointer() {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($c8d725e5ba719c3a$exports)))({
        'default': {
            picker: {
                width: '14px',
                height: '14px',
                borderRadius: '6px',
                transform: 'translate(-7px, -1px)',
                backgroundColor: 'rgb(248, 248, 248)',
                boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.picker
    });
};
var $96c409e9d356bf0c$export$2e2bcd8739ae039 = $96c409e9d356bf0c$export$9c10b52c64965f67;


var $333a4fc52c757c0e$export$472062a354075cee = function Slider(_ref) {
    var hsl = _ref.hsl, onChange = _ref.onChange, pointer = _ref.pointer, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($c8d725e5ba719c3a$exports)))((0, $2b042368e2ec1525$export$2e2bcd8739ae039)({
        'default': {
            hue: {
                height: '12px',
                position: 'relative'
            },
            Hue: {
                radius: '2px'
            }
        }
    }, passedStyles));
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.wrap || {},
        className: 'slider-picker ' + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.hue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $50e2c19f358237c5$export$2e2bcd8739ae039), {
        style: styles.Hue,
        hsl: hsl,
        pointer: pointer,
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.swatches
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $bf5a214261830751$export$2e2bcd8739ae039), {
        hsl: hsl,
        onClick: onChange
    })));
};
$333a4fc52c757c0e$export$472062a354075cee.propTypes = {
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).object
};
$333a4fc52c757c0e$export$472062a354075cee.defaultProps = {
    pointer: (0, $96c409e9d356bf0c$export$2e2bcd8739ae039),
    styles: {}
};
var $333a4fc52c757c0e$export$2e2bcd8739ae039 = (0, $d9d5623a706e13aa$export$2e2bcd8739ae039)($333a4fc52c757c0e$export$472062a354075cee);



var $5E6i4 = parcelRequire("5E6i4");







var $5E6i4 = parcelRequire("5E6i4");



var $5E6i4 = parcelRequire("5E6i4");



var $b64c91e36e64c6af$exports = {};
'use strict';
Object.defineProperty($b64c91e36e64c6af$exports, "__esModule", {
    value: true
});
var $b64c91e36e64c6af$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $5E6i4 = parcelRequire("5E6i4");
var $b64c91e36e64c6af$var$_react2 = $b64c91e36e64c6af$var$_interopRequireDefault($5E6i4);
function $b64c91e36e64c6af$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b64c91e36e64c6af$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var $b64c91e36e64c6af$var$DEFAULT_SIZE = 24;
$b64c91e36e64c6af$exports.default = function(_ref) {
    var _ref$fill = _ref.fill, fill = _ref$fill === undefined ? 'currentColor' : _ref$fill, _ref$width = _ref.width, width = _ref$width === undefined ? $b64c91e36e64c6af$var$DEFAULT_SIZE : _ref$width, _ref$height = _ref.height, height = _ref$height === undefined ? $b64c91e36e64c6af$var$DEFAULT_SIZE : _ref$height, _ref$style = _ref.style, style = _ref$style === undefined ? {} : _ref$style, props = $b64c91e36e64c6af$var$_objectWithoutProperties(_ref, [
        'fill',
        'width',
        'height',
        'style'
    ]);
    return $b64c91e36e64c6af$var$_react2.default.createElement('svg', $b64c91e36e64c6af$var$_extends({
        viewBox: '0 0 ' + $b64c91e36e64c6af$var$DEFAULT_SIZE + ' ' + $b64c91e36e64c6af$var$DEFAULT_SIZE,
        style: $b64c91e36e64c6af$var$_extends({
            fill: fill,
            width: width,
            height: height
        }, style)
    }, props), $b64c91e36e64c6af$var$_react2.default.createElement('path', {
        d: 'M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z'
    }));
};


var $e67695f774b07855$export$af5303fde6798b43 = function SwatchesColor(_ref) {
    var color = _ref.color, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onSwatchHover = _ref.onSwatchHover, first = _ref.first, last = _ref.last, active = _ref.active;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($c8d725e5ba719c3a$exports)))({
        'default': {
            color: {
                width: '40px',
                height: '24px',
                cursor: 'pointer',
                background: color,
                marginBottom: '1px'
            },
            check: {
                color: $3e246347c8e3b5b0$export$3609eb1d7e55dec(color),
                marginLeft: '8px',
                display: 'none'
            }
        },
        'first': {
            color: {
                overflow: 'hidden',
                borderRadius: '2px 2px 0 0'
            }
        },
        'last': {
            color: {
                overflow: 'hidden',
                borderRadius: '0 0 2px 2px'
            }
        },
        'active': {
            check: {
                display: 'block'
            }
        },
        'color-#FFFFFF': {
            color: {
                boxShadow: 'inset 0 0 0 1px #ddd'
            },
            check: {
                color: '#333'
            }
        },
        'transparent': {
            check: {
                color: '#333'
            }
        }
    }, {
        first: first,
        last: last,
        active: active,
        'color-#FFFFFF': color === '#FFFFFF',
        'transparent': color === 'transparent'
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $01e9c8ec84dd90c0$export$2e2bcd8739ae039), {
        color: color,
        style: styles.color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
            boxShadow: '0 0 4px ' + color
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.check
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b64c91e36e64c6af$exports))), null)));
};
var $e67695f774b07855$export$2e2bcd8739ae039 = $e67695f774b07855$export$af5303fde6798b43;


var $0331e66c61a22c98$export$354a0399ec1ad469 = function SwatchesGroup(_ref) {
    var onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover, group = _ref.group, active = _ref.active;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($c8d725e5ba719c3a$exports)))({
        'default': {
            group: {
                paddingBottom: '10px',
                width: '40px',
                float: 'left',
                marginRight: '10px'
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.group
    }, (0, $f872dc2287484c72$export$2e2bcd8739ae039)(group, function(color, i) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $e67695f774b07855$export$2e2bcd8739ae039), {
            key: color,
            color: color,
            active: color.toLowerCase() === active,
            first: i === 0,
            last: i === group.length - 1,
            onClick: onClick,
            onSwatchHover: onSwatchHover
        });
    }));
};
var $0331e66c61a22c98$export$2e2bcd8739ae039 = $0331e66c61a22c98$export$354a0399ec1ad469;


var $ca2ee23d6310f6a5$export$81ebbfd13e06b049 = function Swatches(_ref) {
    var width = _ref.width, height = _ref.height, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex = _ref.hex, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($c8d725e5ba719c3a$exports)))((0, $2b042368e2ec1525$export$2e2bcd8739ae039)({
        'default': {
            picker: {
                width: width,
                height: height
            },
            overflow: {
                height: height,
                overflowY: 'scroll'
            },
            body: {
                padding: '16px 0 6px 16px'
            },
            clear: {
                clear: 'both'
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(data, e) {
        return onChange({
            hex: data,
            source: 'hex'
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.picker,
        className: 'swatches-picker ' + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $7eb330dc2b73c9b0$export$2e2bcd8739ae039), null, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.overflow
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.body
    }, (0, $f872dc2287484c72$export$2e2bcd8739ae039)(colors, function(group) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $0331e66c61a22c98$export$2e2bcd8739ae039), {
            key: group.toString(),
            group: group,
            active: hex,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
        });
    }), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.clear
    })))));
};
$ca2ee23d6310f6a5$export$81ebbfd13e06b049.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).number
    ]),
    height: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).number
    ]),
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string)),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).object
};
$ca2ee23d6310f6a5$export$81ebbfd13e06b049.defaultProps = {
    width: 320,
    height: 240,
    colors: [
        [
            $672d8daba6bf990f$export$a90204d1394caf30['900'],
            $672d8daba6bf990f$export$a90204d1394caf30['700'],
            $672d8daba6bf990f$export$a90204d1394caf30['500'],
            $672d8daba6bf990f$export$a90204d1394caf30['300'],
            $672d8daba6bf990f$export$a90204d1394caf30['100']
        ],
        [
            $672d8daba6bf990f$export$47853bc718611763['900'],
            $672d8daba6bf990f$export$47853bc718611763['700'],
            $672d8daba6bf990f$export$47853bc718611763['500'],
            $672d8daba6bf990f$export$47853bc718611763['300'],
            $672d8daba6bf990f$export$47853bc718611763['100']
        ],
        [
            $672d8daba6bf990f$export$e13cce2a2d16a9d4['900'],
            $672d8daba6bf990f$export$e13cce2a2d16a9d4['700'],
            $672d8daba6bf990f$export$e13cce2a2d16a9d4['500'],
            $672d8daba6bf990f$export$e13cce2a2d16a9d4['300'],
            $672d8daba6bf990f$export$e13cce2a2d16a9d4['100']
        ],
        [
            $672d8daba6bf990f$export$51ef95b19086af57['900'],
            $672d8daba6bf990f$export$51ef95b19086af57['700'],
            $672d8daba6bf990f$export$51ef95b19086af57['500'],
            $672d8daba6bf990f$export$51ef95b19086af57['300'],
            $672d8daba6bf990f$export$51ef95b19086af57['100']
        ],
        [
            $672d8daba6bf990f$export$3e6ccc7b8562d453['900'],
            $672d8daba6bf990f$export$3e6ccc7b8562d453['700'],
            $672d8daba6bf990f$export$3e6ccc7b8562d453['500'],
            $672d8daba6bf990f$export$3e6ccc7b8562d453['300'],
            $672d8daba6bf990f$export$3e6ccc7b8562d453['100']
        ],
        [
            $672d8daba6bf990f$export$2aa0182783e7e9de['900'],
            $672d8daba6bf990f$export$2aa0182783e7e9de['700'],
            $672d8daba6bf990f$export$2aa0182783e7e9de['500'],
            $672d8daba6bf990f$export$2aa0182783e7e9de['300'],
            $672d8daba6bf990f$export$2aa0182783e7e9de['100']
        ],
        [
            $672d8daba6bf990f$export$7b0d29b70b435c21['900'],
            $672d8daba6bf990f$export$7b0d29b70b435c21['700'],
            $672d8daba6bf990f$export$7b0d29b70b435c21['500'],
            $672d8daba6bf990f$export$7b0d29b70b435c21['300'],
            $672d8daba6bf990f$export$7b0d29b70b435c21['100']
        ],
        [
            $672d8daba6bf990f$export$7474046f446842ee['900'],
            $672d8daba6bf990f$export$7474046f446842ee['700'],
            $672d8daba6bf990f$export$7474046f446842ee['500'],
            $672d8daba6bf990f$export$7474046f446842ee['300'],
            $672d8daba6bf990f$export$7474046f446842ee['100']
        ],
        [
            $672d8daba6bf990f$export$8bf7dff220b82b4a['900'],
            $672d8daba6bf990f$export$8bf7dff220b82b4a['700'],
            $672d8daba6bf990f$export$8bf7dff220b82b4a['500'],
            $672d8daba6bf990f$export$8bf7dff220b82b4a['300'],
            $672d8daba6bf990f$export$8bf7dff220b82b4a['100']
        ],
        [
            '#194D33',
            $672d8daba6bf990f$export$955a2ebd2fb142ae['700'],
            $672d8daba6bf990f$export$955a2ebd2fb142ae['500'],
            $672d8daba6bf990f$export$955a2ebd2fb142ae['300'],
            $672d8daba6bf990f$export$955a2ebd2fb142ae['100']
        ],
        [
            $672d8daba6bf990f$export$559a8c00376dc936['900'],
            $672d8daba6bf990f$export$559a8c00376dc936['700'],
            $672d8daba6bf990f$export$559a8c00376dc936['500'],
            $672d8daba6bf990f$export$559a8c00376dc936['300'],
            $672d8daba6bf990f$export$559a8c00376dc936['100']
        ],
        [
            $672d8daba6bf990f$export$221d31baf2636aad['900'],
            $672d8daba6bf990f$export$221d31baf2636aad['700'],
            $672d8daba6bf990f$export$221d31baf2636aad['500'],
            $672d8daba6bf990f$export$221d31baf2636aad['300'],
            $672d8daba6bf990f$export$221d31baf2636aad['100']
        ],
        [
            $672d8daba6bf990f$export$594c5a8758200c32['900'],
            $672d8daba6bf990f$export$594c5a8758200c32['700'],
            $672d8daba6bf990f$export$594c5a8758200c32['500'],
            $672d8daba6bf990f$export$594c5a8758200c32['300'],
            $672d8daba6bf990f$export$594c5a8758200c32['100']
        ],
        [
            $672d8daba6bf990f$export$7c1ecc66643fdbd6['900'],
            $672d8daba6bf990f$export$7c1ecc66643fdbd6['700'],
            $672d8daba6bf990f$export$7c1ecc66643fdbd6['500'],
            $672d8daba6bf990f$export$7c1ecc66643fdbd6['300'],
            $672d8daba6bf990f$export$7c1ecc66643fdbd6['100']
        ],
        [
            $672d8daba6bf990f$export$ad766f34ace1cafd['900'],
            $672d8daba6bf990f$export$ad766f34ace1cafd['700'],
            $672d8daba6bf990f$export$ad766f34ace1cafd['500'],
            $672d8daba6bf990f$export$ad766f34ace1cafd['300'],
            $672d8daba6bf990f$export$ad766f34ace1cafd['100']
        ],
        [
            $672d8daba6bf990f$export$1ceed3dd9ec11704['900'],
            $672d8daba6bf990f$export$1ceed3dd9ec11704['700'],
            $672d8daba6bf990f$export$1ceed3dd9ec11704['500'],
            $672d8daba6bf990f$export$1ceed3dd9ec11704['300'],
            $672d8daba6bf990f$export$1ceed3dd9ec11704['100']
        ],
        [
            $672d8daba6bf990f$export$b6e6178d3f565007['900'],
            $672d8daba6bf990f$export$b6e6178d3f565007['700'],
            $672d8daba6bf990f$export$b6e6178d3f565007['500'],
            $672d8daba6bf990f$export$b6e6178d3f565007['300'],
            $672d8daba6bf990f$export$b6e6178d3f565007['100']
        ],
        [
            $672d8daba6bf990f$export$7c2da42d08c019c9['900'],
            $672d8daba6bf990f$export$7c2da42d08c019c9['700'],
            $672d8daba6bf990f$export$7c2da42d08c019c9['500'],
            $672d8daba6bf990f$export$7c2da42d08c019c9['300'],
            $672d8daba6bf990f$export$7c2da42d08c019c9['100']
        ],
        [
            '#000000',
            '#525252',
            '#969696',
            '#D9D9D9',
            '#FFFFFF'
        ]
    ],
    styles: {}
};
var $ca2ee23d6310f6a5$export$2e2bcd8739ae039 = (0, $d9d5623a706e13aa$export$2e2bcd8739ae039)($ca2ee23d6310f6a5$export$81ebbfd13e06b049);



var $5E6i4 = parcelRequire("5E6i4");






var $e19e7e01c9c00417$export$9e389cdad32a5b7a = function Twitter(_ref) {
    var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, hex = _ref.hex, colors = _ref.colors, width = _ref.width, triangle = _ref.triangle, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($c8d725e5ba719c3a$exports)))((0, $2b042368e2ec1525$export$2e2bcd8739ae039)({
        'default': {
            card: {
                width: width,
                background: '#fff',
                border: '0 solid rgba(0,0,0,0.25)',
                boxShadow: '0 1px 4px rgba(0,0,0,0.25)',
                borderRadius: '4px',
                position: 'relative'
            },
            body: {
                padding: '15px 9px 9px 15px'
            },
            label: {
                fontSize: '18px',
                color: '#fff'
            },
            triangle: {
                width: '0px',
                height: '0px',
                borderStyle: 'solid',
                borderWidth: '0 9px 10px 9px',
                borderColor: 'transparent transparent #fff transparent',
                position: 'absolute'
            },
            triangleShadow: {
                width: '0px',
                height: '0px',
                borderStyle: 'solid',
                borderWidth: '0 9px 10px 9px',
                borderColor: 'transparent transparent rgba(0,0,0,.1) transparent',
                position: 'absolute'
            },
            hash: {
                background: '#F0F0F0',
                height: '30px',
                width: '30px',
                borderRadius: '4px 0 0 4px',
                float: 'left',
                color: '#98A1A4',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            },
            input: {
                width: '100px',
                fontSize: '14px',
                color: '#666',
                border: '0px',
                outline: 'none',
                height: '28px',
                boxShadow: 'inset 0 0 0 1px #F0F0F0',
                boxSizing: 'content-box',
                borderRadius: '0 4px 4px 0',
                float: 'left',
                paddingLeft: '8px'
            },
            swatch: {
                width: '30px',
                height: '30px',
                float: 'left',
                borderRadius: '4px',
                margin: '0 6px 6px 0'
            },
            clear: {
                clear: 'both'
            }
        },
        'hide-triangle': {
            triangle: {
                display: 'none'
            },
            triangleShadow: {
                display: 'none'
            }
        },
        'top-left-triangle': {
            triangle: {
                top: '-10px',
                left: '12px'
            },
            triangleShadow: {
                top: '-11px',
                left: '12px'
            }
        },
        'top-right-triangle': {
            triangle: {
                top: '-10px',
                right: '12px'
            },
            triangleShadow: {
                top: '-11px',
                right: '12px'
            }
        }
    }, passedStyles), {
        'hide-triangle': triangle === 'hide',
        'top-left-triangle': triangle === 'top-left',
        'top-right-triangle': triangle === 'top-right'
    });
    var handleChange = function handleChange(hexcode, e) {
        $3e246347c8e3b5b0$export$944f75ec5697b362(hexcode) && onChange({
            hex: hexcode,
            source: 'hex'
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.card,
        className: 'twitter-picker ' + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.triangleShadow
    }), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.triangle
    }), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.body
    }, (0, $f872dc2287484c72$export$2e2bcd8739ae039)(colors, function(c, i) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $01e9c8ec84dd90c0$export$2e2bcd8739ae039), {
            key: i,
            color: c,
            hex: c,
            style: styles.swatch,
            onClick: handleChange,
            onHover: onSwatchHover,
            focusStyle: {
                boxShadow: '0 0 4px ' + c
            }
        });
    }), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.hash
    }, '#'), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $cb537f80953d7d1d$export$2e2bcd8739ae039), {
        label: null,
        style: {
            input: styles.input
        },
        value: hex.replace('#', ''),
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.clear
    })));
};
$e19e7e01c9c00417$export$9e389cdad32a5b7a.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).number
    ]),
    triangle: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOf([
        'hide',
        'top-left',
        'top-right'
    ]),
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).object
};
$e19e7e01c9c00417$export$9e389cdad32a5b7a.defaultProps = {
    width: 276,
    colors: [
        '#FF6900',
        '#FCB900',
        '#7BDCB5',
        '#00D084',
        '#8ED1FC',
        '#0693E3',
        '#ABB8C3',
        '#EB144C',
        '#F78DA7',
        '#9900EF'
    ],
    triangle: 'top-left',
    styles: {}
};
var $e19e7e01c9c00417$export$2e2bcd8739ae039 = (0, $d9d5623a706e13aa$export$2e2bcd8739ae039)($e19e7e01c9c00417$export$9e389cdad32a5b7a);



var $5E6i4 = parcelRequire("5E6i4");





var $5E6i4 = parcelRequire("5E6i4");


var $89fd1b36a86c2e6a$export$a928e0fe8b70765d = function GooglePointerCircle(props) {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($c8d725e5ba719c3a$exports)))({
        'default': {
            picker: {
                width: '20px',
                height: '20px',
                borderRadius: '22px',
                border: '2px #fff solid',
                transform: 'translate(-12px, -13px)',
                background: 'hsl(' + Math.round(props.hsl.h) + ', ' + Math.round(props.hsl.s * 100) + '%, ' + Math.round(props.hsl.l * 100) + '%)'
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.picker
    });
};
$89fd1b36a86c2e6a$export$a928e0fe8b70765d.propTypes = {
    hsl: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).shape({
        h: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).number,
        s: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).number,
        l: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).number,
        a: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).number
    })
};
$89fd1b36a86c2e6a$export$a928e0fe8b70765d.defaultProps = {
    hsl: {
        a: 1,
        h: 249.94,
        l: 0.2,
        s: 0.50
    }
};
var $89fd1b36a86c2e6a$export$2e2bcd8739ae039 = $89fd1b36a86c2e6a$export$a928e0fe8b70765d;



var $5E6i4 = parcelRequire("5E6i4");


var $fa754fab1b49fb4e$export$9de61b9626feed9a = function GooglePointer(props) {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($c8d725e5ba719c3a$exports)))({
        'default': {
            picker: {
                width: '20px',
                height: '20px',
                borderRadius: '22px',
                transform: 'translate(-10px, -7px)',
                background: 'hsl(' + Math.round(props.hsl.h) + ', 100%, 50%)',
                border: '2px white solid'
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.picker
    });
};
$fa754fab1b49fb4e$export$9de61b9626feed9a.propTypes = {
    hsl: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).shape({
        h: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).number,
        s: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).number,
        l: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).number,
        a: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).number
    })
};
$fa754fab1b49fb4e$export$9de61b9626feed9a.defaultProps = {
    hsl: {
        a: 1,
        h: 249.94,
        l: 0.2,
        s: 0.50
    }
};
var $fa754fab1b49fb4e$export$2e2bcd8739ae039 = $fa754fab1b49fb4e$export$9de61b9626feed9a;



var $5E6i4 = parcelRequire("5E6i4");



var $b4ceb6abfee96ea2$export$e50902ed332e5599 = function GoogleFields(_ref) {
    var onChange = _ref.onChange, rgb = _ref.rgb, hsl = _ref.hsl, hex = _ref.hex, hsv = _ref.hsv;
    var handleChange = function handleChange(data, e) {
        if (data.hex) $3e246347c8e3b5b0$export$944f75ec5697b362(data.hex) && onChange({
            hex: data.hex,
            source: 'hex'
        }, e);
        else if (data.rgb) {
            var values = data.rgb.split(',');
            $3e246347c8e3b5b0$export$e76ec4c5b3cadd73(data.rgb, 'rgb') && onChange({
                r: values[0],
                g: values[1],
                b: values[2],
                a: 1,
                source: 'rgb'
            }, e);
        } else if (data.hsv) {
            var _values = data.hsv.split(',');
            if ($3e246347c8e3b5b0$export$e76ec4c5b3cadd73(data.hsv, 'hsv')) {
                _values[2] = _values[2].replace('%', '');
                _values[1] = _values[1].replace('%', '');
                _values[0] = _values[0].replace("\xb0", '');
                if (_values[1] == 1) _values[1] = 0.01;
                else if (_values[2] == 1) _values[2] = 0.01;
                onChange({
                    h: Number(_values[0]),
                    s: Number(_values[1]),
                    v: Number(_values[2]),
                    source: 'hsv'
                }, e);
            }
        } else if (data.hsl) {
            var _values2 = data.hsl.split(',');
            if ($3e246347c8e3b5b0$export$e76ec4c5b3cadd73(data.hsl, 'hsl')) {
                _values2[2] = _values2[2].replace('%', '');
                _values2[1] = _values2[1].replace('%', '');
                _values2[0] = _values2[0].replace("\xb0", '');
                if (hsvValue[1] == 1) hsvValue[1] = 0.01;
                else if (hsvValue[2] == 1) hsvValue[2] = 0.01;
                onChange({
                    h: Number(_values2[0]),
                    s: Number(_values2[1]),
                    v: Number(_values2[2]),
                    source: 'hsl'
                }, e);
            }
        }
    };
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($c8d725e5ba719c3a$exports)))({
        'default': {
            wrap: {
                display: 'flex',
                height: '100px',
                marginTop: '4px'
            },
            fields: {
                width: '100%'
            },
            column: {
                paddingTop: '10px',
                display: 'flex',
                justifyContent: 'space-between'
            },
            double: {
                padding: '0px 4.4px',
                boxSizing: 'border-box'
            },
            input: {
                width: '100%',
                height: '38px',
                boxSizing: 'border-box',
                padding: '4px 10% 3px',
                textAlign: 'center',
                border: '1px solid #dadce0',
                fontSize: '11px',
                textTransform: 'lowercase',
                borderRadius: '5px',
                outline: 'none',
                fontFamily: 'Roboto,Arial,sans-serif'
            },
            input2: {
                height: '38px',
                width: '100%',
                border: '1px solid #dadce0',
                boxSizing: 'border-box',
                fontSize: '11px',
                textTransform: 'lowercase',
                borderRadius: '5px',
                outline: 'none',
                paddingLeft: '10px',
                fontFamily: 'Roboto,Arial,sans-serif'
            },
            label: {
                textAlign: 'center',
                fontSize: '12px',
                background: '#fff',
                position: 'absolute',
                textTransform: 'uppercase',
                color: '#3c4043',
                width: '35px',
                top: '-6px',
                left: '0',
                right: '0',
                marginLeft: 'auto',
                marginRight: 'auto',
                fontFamily: 'Roboto,Arial,sans-serif'
            },
            label2: {
                left: '10px',
                textAlign: 'center',
                fontSize: '12px',
                background: '#fff',
                position: 'absolute',
                textTransform: 'uppercase',
                color: '#3c4043',
                width: '32px',
                top: '-6px',
                fontFamily: 'Roboto,Arial,sans-serif'
            },
            single: {
                flexGrow: '1',
                margin: '0px 4.4px'
            }
        }
    });
    var rgbValue = rgb.r + ', ' + rgb.g + ', ' + rgb.b;
    var hslValue = Math.round(hsl.h) + '\xB0, ' + Math.round(hsl.s * 100) + '%, ' + Math.round(hsl.l * 100) + '%';
    var hsvValue = Math.round(hsv.h) + '\xB0, ' + Math.round(hsv.s * 100) + '%, ' + Math.round(hsv.v * 100) + '%';
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.wrap,
        className: 'flexbox-fix'
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.fields
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.double
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $cb537f80953d7d1d$export$2e2bcd8739ae039), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: 'hex',
        value: hex,
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.column
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $cb537f80953d7d1d$export$2e2bcd8739ae039), {
        style: {
            input: styles.input2,
            label: styles.label2
        },
        label: 'rgb',
        value: rgbValue,
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $cb537f80953d7d1d$export$2e2bcd8739ae039), {
        style: {
            input: styles.input2,
            label: styles.label2
        },
        label: 'hsv',
        value: hsvValue,
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $cb537f80953d7d1d$export$2e2bcd8739ae039), {
        style: {
            input: styles.input2,
            label: styles.label2
        },
        label: 'hsl',
        value: hslValue,
        onChange: handleChange
    })))));
};
var $b4ceb6abfee96ea2$export$2e2bcd8739ae039 = $b4ceb6abfee96ea2$export$e50902ed332e5599;


var $aa4d2922c4556da5$export$347eee6e8bf67997 = function Google(_ref) {
    var width = _ref.width, onChange = _ref.onChange, rgb = _ref.rgb, hsl = _ref.hsl, hsv = _ref.hsv, hex = _ref.hex, header = _ref.header, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($c8d725e5ba719c3a$exports)))((0, $2b042368e2ec1525$export$2e2bcd8739ae039)({
        'default': {
            picker: {
                width: width,
                background: '#fff',
                border: '1px solid #dfe1e5',
                boxSizing: 'initial',
                display: 'flex',
                flexWrap: 'wrap',
                borderRadius: '8px 8px 0px 0px'
            },
            head: {
                height: '57px',
                width: '100%',
                paddingTop: '16px',
                paddingBottom: '16px',
                paddingLeft: '16px',
                fontSize: '20px',
                boxSizing: 'border-box',
                fontFamily: 'Roboto-Regular,HelveticaNeue,Arial,sans-serif'
            },
            saturation: {
                width: '70%',
                padding: '0px',
                position: 'relative',
                overflow: 'hidden'
            },
            swatch: {
                width: '30%',
                height: '228px',
                padding: '0px',
                background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', 1)',
                position: 'relative',
                overflow: 'hidden'
            },
            body: {
                margin: 'auto',
                width: '95%'
            },
            controls: {
                display: 'flex',
                boxSizing: 'border-box',
                height: '52px',
                paddingTop: '22px'
            },
            color: {
                width: '32px'
            },
            hue: {
                height: '8px',
                position: 'relative',
                margin: '0px 16px 0px 16px',
                width: '100%'
            },
            Hue: {
                radius: '2px'
            }
        }
    }, passedStyles));
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.picker,
        className: 'google-picker ' + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.head
    }, header), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.swatch
    }), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.saturation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $93b5269a0cba01ab$export$2e2bcd8739ae039), {
        hsl: hsl,
        hsv: hsv,
        pointer: (0, $89fd1b36a86c2e6a$export$2e2bcd8739ae039),
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.body
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.controls,
        className: 'flexbox-fix'
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement('div', {
        style: styles.hue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $50e2c19f358237c5$export$2e2bcd8739ae039), {
        style: styles.Hue,
        hsl: hsl,
        radius: '4px',
        pointer: (0, $fa754fab1b49fb4e$export$2e2bcd8739ae039),
        onChange: onChange
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $b4ceb6abfee96ea2$export$2e2bcd8739ae039), {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        hsv: hsv,
        onChange: onChange
    })));
};
$aa4d2922c4556da5$export$347eee6e8bf67997.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).number
    ]),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).object,
    header: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string
};
$aa4d2922c4556da5$export$347eee6e8bf67997.defaultProps = {
    width: 652,
    styles: {},
    header: 'Color picker'
};
var $aa4d2922c4556da5$export$2e2bcd8739ae039 = (0, $d9d5623a706e13aa$export$2e2bcd8739ae039)($aa4d2922c4556da5$export$347eee6e8bf67997);





var $bdcc2cf97b7b69bf$exports = {};
'use strict';
Object.defineProperty($bdcc2cf97b7b69bf$exports, "__esModule", {
    value: true
});
var $110169876b63aa8b$exports = {};
'use strict';
Object.defineProperty($110169876b63aa8b$exports, "__esModule", {
    value: true
});
$110169876b63aa8b$exports.Alpha = undefined;
var $110169876b63aa8b$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $110169876b63aa8b$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $5E6i4 = parcelRequire("5E6i4");
var $110169876b63aa8b$var$_react2 = $110169876b63aa8b$var$_interopRequireDefault($5E6i4);

var $110169876b63aa8b$var$_reactcss2 = $110169876b63aa8b$var$_interopRequireDefault($c8d725e5ba719c3a$exports);
var $c756d77ae092ed71$exports = {};
'use strict';
Object.defineProperty($c756d77ae092ed71$exports, "__esModule", {
    value: true
});
var $c756d77ae092ed71$var$calculateChange = $c756d77ae092ed71$exports.calculateChange = function calculateChange(e, hsl, direction, initialA, container) {
    var containerWidth = container.clientWidth;
    var containerHeight = container.clientHeight;
    var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (direction === 'vertical') {
        var a = void 0;
        if (top < 0) a = 0;
        else if (top > containerHeight) a = 1;
        else a = Math.round(top * 100 / containerHeight) / 100;
        if (hsl.a !== a) return {
            h: hsl.h,
            s: hsl.s,
            l: hsl.l,
            a: a,
            source: 'rgb'
        };
    } else {
        var _a = void 0;
        if (left < 0) _a = 0;
        else if (left > containerWidth) _a = 1;
        else _a = Math.round(left * 100 / containerWidth) / 100;
        if (initialA !== _a) return {
            h: hsl.h,
            s: hsl.s,
            l: hsl.l,
            a: _a,
            source: 'rgb'
        };
    }
    return null;
};


var $110169876b63aa8b$var$alpha = $110169876b63aa8b$var$_interopRequireWildcard($c756d77ae092ed71$exports);
var $749294d42ac76cc8$exports = {};
'use strict';
Object.defineProperty($749294d42ac76cc8$exports, "__esModule", {
    value: true
});
$749294d42ac76cc8$exports.Checkboard = undefined;
var $749294d42ac76cc8$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $5E6i4 = parcelRequire("5E6i4");
var $749294d42ac76cc8$var$_react2 = $749294d42ac76cc8$var$_interopRequireDefault($5E6i4);

var $749294d42ac76cc8$var$_reactcss2 = $749294d42ac76cc8$var$_interopRequireDefault($c8d725e5ba719c3a$exports);
var $0e802f33e5df4e42$exports = {};
'use strict';
Object.defineProperty($0e802f33e5df4e42$exports, "__esModule", {
    value: true
});
var $0e802f33e5df4e42$var$checkboardCache = {};
var $0e802f33e5df4e42$var$render = $0e802f33e5df4e42$exports.render = function render(c1, c2, size, serverCanvas) {
    if (typeof document === 'undefined' && !serverCanvas) return null;
    var canvas = serverCanvas ? new serverCanvas() : document.createElement('canvas');
    canvas.width = size * 2;
    canvas.height = size * 2;
    var ctx = canvas.getContext('2d');
    if (!ctx) return null;
     // If no context can be found, return early.
    ctx.fillStyle = c1;
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = c2;
    ctx.fillRect(0, 0, size, size);
    ctx.translate(size, size);
    ctx.fillRect(0, 0, size, size);
    return canvas.toDataURL();
};
var $0e802f33e5df4e42$var$get = $0e802f33e5df4e42$exports.get = function get(c1, c2, size, serverCanvas) {
    var key = c1 + '-' + c2 + '-' + size + (serverCanvas ? '-server' : '');
    if ($0e802f33e5df4e42$var$checkboardCache[key]) return $0e802f33e5df4e42$var$checkboardCache[key];
    var checkboard = $0e802f33e5df4e42$var$render(c1, c2, size, serverCanvas);
    $0e802f33e5df4e42$var$checkboardCache[key] = checkboard;
    return checkboard;
};


var $749294d42ac76cc8$var$checkboard = $749294d42ac76cc8$var$_interopRequireWildcard($0e802f33e5df4e42$exports);
function $749294d42ac76cc8$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $749294d42ac76cc8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $749294d42ac76cc8$var$Checkboard = $749294d42ac76cc8$exports.Checkboard = function Checkboard(_ref) {
    var white = _ref.white, grey = _ref.grey, size = _ref.size, renderers = _ref.renderers, borderRadius = _ref.borderRadius, boxShadow = _ref.boxShadow, children = _ref.children;
    var styles = (0, $749294d42ac76cc8$var$_reactcss2.default)({
        'default': {
            grid: {
                borderRadius: borderRadius,
                boxShadow: boxShadow,
                absolute: '0px 0px 0px 0px',
                background: 'url(' + $749294d42ac76cc8$var$checkboard.get(white, grey, size, renderers.canvas) + ') center left'
            }
        }
    });
    return (0, $5E6i4.isValidElement)(children) ? $749294d42ac76cc8$var$_react2.default.cloneElement(children, $749294d42ac76cc8$var$_extends({}, children.props, {
        style: $749294d42ac76cc8$var$_extends({}, children.props.style, styles.grid)
    })) : $749294d42ac76cc8$var$_react2.default.createElement('div', {
        style: styles.grid
    });
};
$749294d42ac76cc8$var$Checkboard.defaultProps = {
    size: 8,
    white: 'transparent',
    grey: 'rgba(0,0,0,.08)',
    renderers: {}
};
$749294d42ac76cc8$exports.default = $749294d42ac76cc8$var$Checkboard;


var $110169876b63aa8b$var$_Checkboard2 = $110169876b63aa8b$var$_interopRequireDefault($749294d42ac76cc8$exports);
function $110169876b63aa8b$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $110169876b63aa8b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $110169876b63aa8b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $110169876b63aa8b$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $110169876b63aa8b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $110169876b63aa8b$var$Alpha = $110169876b63aa8b$exports.Alpha = function(_ref) {
    $110169876b63aa8b$var$_inherits(Alpha, _ref);
    function Alpha() {
        var _ref2;
        var _temp, _this, _ret;
        $110169876b63aa8b$var$_classCallCheck(this, Alpha);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $110169876b63aa8b$var$_possibleConstructorReturn(this, (_ref2 = Alpha.__proto__ || Object.getPrototypeOf(Alpha)).call.apply(_ref2, [
            this
        ].concat(args))), _this), _this.handleChange = function(e) {
            var change = $110169876b63aa8b$var$alpha.calculateChange(e, _this.props.hsl, _this.props.direction, _this.props.a, _this.container);
            change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
        }, _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            window.addEventListener('mousemove', _this.handleChange);
            window.addEventListener('mouseup', _this.handleMouseUp);
        }, _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        }, _this.unbindEventListeners = function() {
            window.removeEventListener('mousemove', _this.handleChange);
            window.removeEventListener('mouseup', _this.handleMouseUp);
        }, _temp), $110169876b63aa8b$var$_possibleConstructorReturn(_this, _ret);
    }
    $110169876b63aa8b$var$_createClass(Alpha, [
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var rgb = this.props.rgb;
                var styles = (0, $110169876b63aa8b$var$_reactcss2.default)({
                    'default': {
                        alpha: {
                            absolute: '0px 0px 0px 0px',
                            borderRadius: this.props.radius
                        },
                        checkboard: {
                            absolute: '0px 0px 0px 0px',
                            overflow: 'hidden',
                            borderRadius: this.props.radius
                        },
                        gradient: {
                            absolute: '0px 0px 0px 0px',
                            background: 'linear-gradient(to right, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)',
                            boxShadow: this.props.shadow,
                            borderRadius: this.props.radius
                        },
                        container: {
                            position: 'relative',
                            height: '100%',
                            margin: '0 3px'
                        },
                        pointer: {
                            position: 'absolute',
                            left: rgb.a * 100 + '%'
                        },
                        slider: {
                            width: '4px',
                            borderRadius: '1px',
                            height: '8px',
                            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
                            background: '#fff',
                            marginTop: '1px',
                            transform: 'translateX(-2px)'
                        }
                    },
                    'vertical': {
                        gradient: {
                            background: 'linear-gradient(to bottom, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)'
                        },
                        pointer: {
                            left: 0,
                            top: rgb.a * 100 + '%'
                        }
                    },
                    'overwrite': $110169876b63aa8b$var$_extends({}, this.props.style)
                }, {
                    vertical: this.props.direction === 'vertical',
                    overwrite: true
                });
                return $110169876b63aa8b$var$_react2.default.createElement('div', {
                    style: styles.alpha
                }, $110169876b63aa8b$var$_react2.default.createElement('div', {
                    style: styles.checkboard
                }, $110169876b63aa8b$var$_react2.default.createElement($110169876b63aa8b$var$_Checkboard2.default, {
                    renderers: this.props.renderers
                })), $110169876b63aa8b$var$_react2.default.createElement('div', {
                    style: styles.gradient
                }), $110169876b63aa8b$var$_react2.default.createElement('div', {
                    style: styles.container,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, $110169876b63aa8b$var$_react2.default.createElement('div', {
                    style: styles.pointer
                }, this.props.pointer ? $110169876b63aa8b$var$_react2.default.createElement(this.props.pointer, this.props) : $110169876b63aa8b$var$_react2.default.createElement('div', {
                    style: styles.slider
                }))));
            }
        }
    ]);
    return Alpha;
}($5E6i4.PureComponent || $5E6i4.Component);
$110169876b63aa8b$exports.default = $110169876b63aa8b$var$Alpha;


Object.defineProperty($bdcc2cf97b7b69bf$exports, 'Alpha', {
    enumerable: true,
    get: function get() {
        return $bdcc2cf97b7b69bf$var$_interopRequireDefault($110169876b63aa8b$exports).default;
    }
});

Object.defineProperty($bdcc2cf97b7b69bf$exports, 'Checkboard', {
    enumerable: true,
    get: function get() {
        return $bdcc2cf97b7b69bf$var$_interopRequireDefault($749294d42ac76cc8$exports).default;
    }
});
var $9dae2ee4433d2173$exports = {};
'use strict';
Object.defineProperty($9dae2ee4433d2173$exports, "__esModule", {
    value: true
});
$9dae2ee4433d2173$exports.EditableInput = undefined;
var $9dae2ee4433d2173$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $5E6i4 = parcelRequire("5E6i4");
var $9dae2ee4433d2173$var$_react2 = $9dae2ee4433d2173$var$_interopRequireDefault($5E6i4);

var $9dae2ee4433d2173$var$_reactcss2 = $9dae2ee4433d2173$var$_interopRequireDefault($c8d725e5ba719c3a$exports);
function $9dae2ee4433d2173$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9dae2ee4433d2173$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9dae2ee4433d2173$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9dae2ee4433d2173$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $9dae2ee4433d2173$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $9dae2ee4433d2173$var$DEFAULT_ARROW_OFFSET = 1;
var $9dae2ee4433d2173$var$UP_KEY_CODE = 38;
var $9dae2ee4433d2173$var$DOWN_KEY_CODE = 40;
var $9dae2ee4433d2173$var$VALID_KEY_CODES = [
    $9dae2ee4433d2173$var$UP_KEY_CODE,
    $9dae2ee4433d2173$var$DOWN_KEY_CODE
];
var $9dae2ee4433d2173$var$isValidKeyCode = function isValidKeyCode(keyCode) {
    return $9dae2ee4433d2173$var$VALID_KEY_CODES.indexOf(keyCode) > -1;
};
var $9dae2ee4433d2173$var$getNumberValue = function getNumberValue(value) {
    return Number(String(value).replace(/%/g, ''));
};
var $9dae2ee4433d2173$var$idCounter = 1;
var $9dae2ee4433d2173$var$EditableInput = $9dae2ee4433d2173$exports.EditableInput = function(_ref) {
    $9dae2ee4433d2173$var$_inherits(EditableInput, _ref);
    function EditableInput(props) {
        $9dae2ee4433d2173$var$_classCallCheck(this, EditableInput);
        var _this = $9dae2ee4433d2173$var$_possibleConstructorReturn(this, (EditableInput.__proto__ || Object.getPrototypeOf(EditableInput)).call(this));
        _this.handleBlur = function() {
            if (_this.state.blurValue) _this.setState({
                value: _this.state.blurValue,
                blurValue: null
            });
        };
        _this.handleChange = function(e) {
            _this.setUpdatedValue(e.target.value, e);
        };
        _this.handleKeyDown = function(e) {
            // In case `e.target.value` is a percentage remove the `%` character
            // and update accordingly with a percentage
            // https://github.com/casesandberg/react-color/issues/383
            var value = $9dae2ee4433d2173$var$getNumberValue(e.target.value);
            if (!isNaN(value) && $9dae2ee4433d2173$var$isValidKeyCode(e.keyCode)) {
                var offset = _this.getArrowOffset();
                var updatedValue = e.keyCode === $9dae2ee4433d2173$var$UP_KEY_CODE ? value + offset : value - offset;
                _this.setUpdatedValue(updatedValue, e);
            }
        };
        _this.handleDrag = function(e) {
            if (_this.props.dragLabel) {
                var newValue = Math.round(_this.props.value + e.movementX);
                if (newValue >= 0 && newValue <= _this.props.dragMax) _this.props.onChange && _this.props.onChange(_this.getValueObjectWithLabel(newValue), e);
            }
        };
        _this.handleMouseDown = function(e) {
            if (_this.props.dragLabel) {
                e.preventDefault();
                _this.handleDrag(e);
                window.addEventListener('mousemove', _this.handleDrag);
                window.addEventListener('mouseup', _this.handleMouseUp);
            }
        };
        _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        };
        _this.unbindEventListeners = function() {
            window.removeEventListener('mousemove', _this.handleDrag);
            window.removeEventListener('mouseup', _this.handleMouseUp);
        };
        _this.state = {
            value: String(props.value).toUpperCase(),
            blurValue: String(props.value).toUpperCase()
        };
        _this.inputId = 'rc-editable-input-' + $9dae2ee4433d2173$var$idCounter++;
        return _this;
    }
    $9dae2ee4433d2173$var$_createClass(EditableInput, [
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps, prevState) {
                if (this.props.value !== this.state.value && (prevProps.value !== this.props.value || prevState.value !== this.state.value)) {
                    if (this.input === document.activeElement) this.setState({
                        blurValue: String(this.props.value).toUpperCase()
                    });
                    else this.setState({
                        value: String(this.props.value).toUpperCase(),
                        blurValue: !this.state.blurValue && String(this.props.value).toUpperCase()
                    });
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: 'getValueObjectWithLabel',
            value: function getValueObjectWithLabel(value) {
                return $9dae2ee4433d2173$var$_defineProperty({}, this.props.label, value);
            }
        },
        {
            key: 'getArrowOffset',
            value: function getArrowOffset() {
                return this.props.arrowOffset || $9dae2ee4433d2173$var$DEFAULT_ARROW_OFFSET;
            }
        },
        {
            key: 'setUpdatedValue',
            value: function setUpdatedValue(value, e) {
                var onChangeValue = this.props.label ? this.getValueObjectWithLabel(value) : value;
                this.props.onChange && this.props.onChange(onChangeValue, e);
                this.setState({
                    value: value
                });
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var styles = (0, $9dae2ee4433d2173$var$_reactcss2.default)({
                    'default': {
                        wrap: {
                            position: 'relative'
                        }
                    },
                    'user-override': {
                        wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
                        input: this.props.style && this.props.style.input ? this.props.style.input : {},
                        label: this.props.style && this.props.style.label ? this.props.style.label : {}
                    },
                    'dragLabel-true': {
                        label: {
                            cursor: 'ew-resize'
                        }
                    }
                }, {
                    'user-override': true
                }, this.props);
                return $9dae2ee4433d2173$var$_react2.default.createElement('div', {
                    style: styles.wrap
                }, $9dae2ee4433d2173$var$_react2.default.createElement('input', {
                    id: this.inputId,
                    style: styles.input,
                    ref: function ref(input) {
                        return _this2.input = input;
                    },
                    value: this.state.value,
                    onKeyDown: this.handleKeyDown,
                    onChange: this.handleChange,
                    onBlur: this.handleBlur,
                    placeholder: this.props.placeholder,
                    spellCheck: 'false'
                }), this.props.label && !this.props.hideLabel ? $9dae2ee4433d2173$var$_react2.default.createElement('label', {
                    htmlFor: this.inputId,
                    style: styles.label,
                    onMouseDown: this.handleMouseDown
                }, this.props.label) : null);
            }
        }
    ]);
    return EditableInput;
}($5E6i4.PureComponent || $5E6i4.Component);
$9dae2ee4433d2173$exports.default = $9dae2ee4433d2173$var$EditableInput;


Object.defineProperty($bdcc2cf97b7b69bf$exports, 'EditableInput', {
    enumerable: true,
    get: function get() {
        return $bdcc2cf97b7b69bf$var$_interopRequireDefault($9dae2ee4433d2173$exports).default;
    }
});
var $911789294bfb8719$exports = {};
'use strict';
Object.defineProperty($911789294bfb8719$exports, "__esModule", {
    value: true
});
$911789294bfb8719$exports.Hue = undefined;
var $911789294bfb8719$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $5E6i4 = parcelRequire("5E6i4");
var $911789294bfb8719$var$_react2 = $911789294bfb8719$var$_interopRequireDefault($5E6i4);

var $911789294bfb8719$var$_reactcss2 = $911789294bfb8719$var$_interopRequireDefault($c8d725e5ba719c3a$exports);
var $666b7eca230a0f20$exports = {};
'use strict';
Object.defineProperty($666b7eca230a0f20$exports, "__esModule", {
    value: true
});
var $666b7eca230a0f20$var$calculateChange = $666b7eca230a0f20$exports.calculateChange = function calculateChange(e, direction, hsl, container) {
    var containerWidth = container.clientWidth;
    var containerHeight = container.clientHeight;
    var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (direction === 'vertical') {
        var h = void 0;
        if (top < 0) h = 359;
        else if (top > containerHeight) h = 0;
        else {
            var percent = -(top * 100 / containerHeight) + 100;
            h = 360 * percent / 100;
        }
        if (hsl.h !== h) return {
            h: h,
            s: hsl.s,
            l: hsl.l,
            a: hsl.a,
            source: 'hsl'
        };
    } else {
        var _h = void 0;
        if (left < 0) _h = 0;
        else if (left > containerWidth) _h = 359;
        else {
            var _percent = left * 100 / containerWidth;
            _h = 360 * _percent / 100;
        }
        if (hsl.h !== _h) return {
            h: _h,
            s: hsl.s,
            l: hsl.l,
            a: hsl.a,
            source: 'hsl'
        };
    }
    return null;
};


var $911789294bfb8719$var$hue = $911789294bfb8719$var$_interopRequireWildcard($666b7eca230a0f20$exports);
function $911789294bfb8719$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $911789294bfb8719$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $911789294bfb8719$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $911789294bfb8719$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $911789294bfb8719$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $911789294bfb8719$var$Hue = $911789294bfb8719$exports.Hue = function(_ref) {
    $911789294bfb8719$var$_inherits(Hue, _ref);
    function Hue() {
        var _ref2;
        var _temp, _this, _ret;
        $911789294bfb8719$var$_classCallCheck(this, Hue);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $911789294bfb8719$var$_possibleConstructorReturn(this, (_ref2 = Hue.__proto__ || Object.getPrototypeOf(Hue)).call.apply(_ref2, [
            this
        ].concat(args))), _this), _this.handleChange = function(e) {
            var change = $911789294bfb8719$var$hue.calculateChange(e, _this.props.direction, _this.props.hsl, _this.container);
            change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
        }, _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            window.addEventListener('mousemove', _this.handleChange);
            window.addEventListener('mouseup', _this.handleMouseUp);
        }, _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        }, _temp), $911789294bfb8719$var$_possibleConstructorReturn(_this, _ret);
    }
    $911789294bfb8719$var$_createClass(Hue, [
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: 'unbindEventListeners',
            value: function unbindEventListeners() {
                window.removeEventListener('mousemove', this.handleChange);
                window.removeEventListener('mouseup', this.handleMouseUp);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var _props$direction = this.props.direction, direction = _props$direction === undefined ? 'horizontal' : _props$direction;
                var styles = (0, $911789294bfb8719$var$_reactcss2.default)({
                    'default': {
                        hue: {
                            absolute: '0px 0px 0px 0px',
                            borderRadius: this.props.radius,
                            boxShadow: this.props.shadow
                        },
                        container: {
                            padding: '0 2px',
                            position: 'relative',
                            height: '100%',
                            borderRadius: this.props.radius
                        },
                        pointer: {
                            position: 'absolute',
                            left: this.props.hsl.h * 100 / 360 + '%'
                        },
                        slider: {
                            marginTop: '1px',
                            width: '4px',
                            borderRadius: '1px',
                            height: '8px',
                            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
                            background: '#fff',
                            transform: 'translateX(-2px)'
                        }
                    },
                    'vertical': {
                        pointer: {
                            left: '0px',
                            top: -(this.props.hsl.h * 100 / 360) + 100 + '%'
                        }
                    }
                }, {
                    vertical: direction === 'vertical'
                });
                return $911789294bfb8719$var$_react2.default.createElement('div', {
                    style: styles.hue
                }, $911789294bfb8719$var$_react2.default.createElement('div', {
                    className: 'hue-' + direction,
                    style: styles.container,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, $911789294bfb8719$var$_react2.default.createElement('style', null, '\n            .hue-horizontal {\n              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0\n                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to right, #f00 0%, #ff0\n                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n\n            .hue-vertical {\n              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,\n                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,\n                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n          '), $911789294bfb8719$var$_react2.default.createElement('div', {
                    style: styles.pointer
                }, this.props.pointer ? $911789294bfb8719$var$_react2.default.createElement(this.props.pointer, this.props) : $911789294bfb8719$var$_react2.default.createElement('div', {
                    style: styles.slider
                }))));
            }
        }
    ]);
    return Hue;
}($5E6i4.PureComponent || $5E6i4.Component);
$911789294bfb8719$exports.default = $911789294bfb8719$var$Hue;


Object.defineProperty($bdcc2cf97b7b69bf$exports, 'Hue', {
    enumerable: true,
    get: function get() {
        return $bdcc2cf97b7b69bf$var$_interopRequireDefault($911789294bfb8719$exports).default;
    }
});
var $67815b6d4c2088ec$exports = {};
'use strict';
Object.defineProperty($67815b6d4c2088ec$exports, "__esModule", {
    value: true
});
$67815b6d4c2088ec$exports.Raised = undefined;

var $5E6i4 = parcelRequire("5E6i4");
var $67815b6d4c2088ec$var$_react2 = $67815b6d4c2088ec$var$_interopRequireDefault($5E6i4);

var $67815b6d4c2088ec$var$_propTypes2 = $67815b6d4c2088ec$var$_interopRequireDefault($38b29c2dc0019b47$exports);

var $67815b6d4c2088ec$var$_reactcss2 = $67815b6d4c2088ec$var$_interopRequireDefault($c8d725e5ba719c3a$exports);
var $e8753c4e7084656b$exports = {};
var $5e692200bff9c8ee$exports = {};

var $d4f576f7e8fa9af1$exports = {};


/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $d4f576f7e8fa9af1$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !$f99e04e5a327d734$exports(object[key], value) || value === undefined && !(key in object)) $bf0060c3aa46535f$exports(object, key, value);
}
$d4f576f7e8fa9af1$exports = $d4f576f7e8fa9af1$var$assignMergeValue;



var $8TiJt = parcelRequire("8TiJt");
var $69d607bafdcfa865$exports = {};


var $c6Pa8 = parcelRequire("c6Pa8");




var $bTgvk = parcelRequire("bTgvk");

var $fSG8F = parcelRequire("fSG8F");
var $aa24a73568bd7365$exports = {};

var $5Yk3N = parcelRequire("5Yk3N");

var $hemqo = parcelRequire("hemqo");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $aa24a73568bd7365$var$isArrayLikeObject(value) {
    return $hemqo(value) && $5Yk3N(value);
}
$aa24a73568bd7365$exports = $aa24a73568bd7365$var$isArrayLikeObject;



var $hpW0S = parcelRequire("hpW0S");

var $8NZGN = parcelRequire("8NZGN");

var $fFfYm = parcelRequire("fFfYm");


var $9PkbX = parcelRequire("9PkbX");
var $c7d31863f5749d03$exports = {};
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $c7d31863f5749d03$var$safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
$c7d31863f5749d03$exports = $c7d31863f5749d03$var$safeGet;


var $91c50d3ef78fcd60$exports = {};


/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $91c50d3ef78fcd60$var$toPlainObject(value) {
    return $dd70a55862ec4473$exports(value, $40028ff2b01d3789$exports(value));
}
$91c50d3ef78fcd60$exports = $91c50d3ef78fcd60$var$toPlainObject;


/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $69d607bafdcfa865$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = $c7d31863f5749d03$exports(object, key), srcValue = $c7d31863f5749d03$exports(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        $d4f576f7e8fa9af1$exports(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = $fSG8F(srcValue), isBuff = !isArr && $hpW0S(srcValue), isTyped = !isArr && !isBuff && $9PkbX(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ($fSG8F(objValue)) newValue = objValue;
            else if ($aa24a73568bd7365$exports(objValue)) newValue = $696081b51beb437f$exports(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = $c6Pa8(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = $94b3869fd3fdb66e$exports(srcValue, true);
            } else newValue = [];
        } else if ($dce598c76c6fa79c$exports(srcValue) || $bTgvk(srcValue)) {
            newValue = objValue;
            if ($bTgvk(objValue)) newValue = $91c50d3ef78fcd60$exports(objValue);
            else if (!$fFfYm(objValue) || $8NZGN(objValue)) newValue = $46cedd2b987da5d2$exports(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    $d4f576f7e8fa9af1$exports(object, key, newValue);
}
$69d607bafdcfa865$exports = $69d607bafdcfa865$var$baseMergeDeep;



var $fFfYm = parcelRequire("fFfYm");


/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $5e692200bff9c8ee$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    $8TiJt(source, function(srcValue, key) {
        stack || (stack = new $94d303896d62668a$exports);
        if ($fFfYm(srcValue)) $69d607bafdcfa865$exports(object, source, key, srcIndex, $5e692200bff9c8ee$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer($c7d31863f5749d03$exports(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            $d4f576f7e8fa9af1$exports(object, key, newValue);
        }
    }, $40028ff2b01d3789$exports);
}
$5e692200bff9c8ee$exports = $5e692200bff9c8ee$var$baseMerge;


var $20a6ecbe68249076$exports = {};
var $6e1168881e4cec28$exports = {};

var $hD1eO = parcelRequire("hD1eO");
var $da1d72f36d5f7b72$exports = {};
var $c8265a580ed65608$exports = {};
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $c8265a580ed65608$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
$c8265a580ed65608$exports = $c8265a580ed65608$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $da1d72f36d5f7b72$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $da1d72f36d5f7b72$var$overRest(func, start, transform) {
    start = $da1d72f36d5f7b72$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $da1d72f36d5f7b72$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $c8265a580ed65608$exports(func, this, otherArgs);
    };
}
$da1d72f36d5f7b72$exports = $da1d72f36d5f7b72$var$overRest;


var $ea522d34dcf216c6$exports = {};
var $74fffc70a7853b50$exports = {};
var $c0b8ca66c7d40703$exports = {};
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $c0b8ca66c7d40703$var$constant(value) {
    return function() {
        return value;
    };
}
$c0b8ca66c7d40703$exports = $c0b8ca66c7d40703$var$constant;




var $hD1eO = parcelRequire("hD1eO");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $74fffc70a7853b50$var$baseSetToString = !$d08fd2a913e24a5c$exports ? $hD1eO : function(func, string) {
    return $d08fd2a913e24a5c$exports(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': $c0b8ca66c7d40703$exports(string),
        'writable': true
    });
};
$74fffc70a7853b50$exports = $74fffc70a7853b50$var$baseSetToString;


var $520e203414d8f34c$exports = {};
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $520e203414d8f34c$var$HOT_COUNT = 800, $520e203414d8f34c$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $520e203414d8f34c$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $520e203414d8f34c$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $520e203414d8f34c$var$nativeNow(), remaining = $520e203414d8f34c$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $520e203414d8f34c$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
$520e203414d8f34c$exports = $520e203414d8f34c$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $ea522d34dcf216c6$var$setToString = $520e203414d8f34c$exports($74fffc70a7853b50$exports);
$ea522d34dcf216c6$exports = $ea522d34dcf216c6$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $6e1168881e4cec28$var$baseRest(func, start) {
    return $ea522d34dcf216c6$exports($da1d72f36d5f7b72$exports(func, start, $hD1eO), func + '');
}
$6e1168881e4cec28$exports = $6e1168881e4cec28$var$baseRest;


var $993ce8a72a8812dc$exports = {};


var $5Yk3N = parcelRequire("5Yk3N");

var $hK6dh = parcelRequire("hK6dh");

var $fFfYm = parcelRequire("fFfYm");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $993ce8a72a8812dc$var$isIterateeCall(value, index, object) {
    if (!$fFfYm(object)) return false;
    var type = typeof index;
    if (type == 'number' ? $5Yk3N(object) && $hK6dh(index, object.length) : type == 'string' && index in object) return $f99e04e5a327d734$exports(object[index], value);
    return false;
}
$993ce8a72a8812dc$exports = $993ce8a72a8812dc$var$isIterateeCall;


/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $20a6ecbe68249076$var$createAssigner(assigner) {
    return $6e1168881e4cec28$exports(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && $993ce8a72a8812dc$exports(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
$20a6ecbe68249076$exports = $20a6ecbe68249076$var$createAssigner;


/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $e8753c4e7084656b$var$merge = $20a6ecbe68249076$exports(function(object, source, srcIndex) {
    $5e692200bff9c8ee$exports(object, source, srcIndex);
});
$e8753c4e7084656b$exports = $e8753c4e7084656b$var$merge;


var $67815b6d4c2088ec$var$_merge2 = $67815b6d4c2088ec$var$_interopRequireDefault($e8753c4e7084656b$exports);
function $67815b6d4c2088ec$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $67815b6d4c2088ec$var$Raised = $67815b6d4c2088ec$exports.Raised = function Raised(_ref) {
    var zDepth = _ref.zDepth, radius = _ref.radius, background = _ref.background, children = _ref.children, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles;
    var styles = (0, $67815b6d4c2088ec$var$_reactcss2.default)((0, $67815b6d4c2088ec$var$_merge2.default)({
        'default': {
            wrap: {
                position: 'relative',
                display: 'inline-block'
            },
            content: {
                position: 'relative'
            },
            bg: {
                absolute: '0px 0px 0px 0px',
                boxShadow: '0 ' + zDepth + 'px ' + zDepth * 4 + 'px rgba(0,0,0,.24)',
                borderRadius: radius,
                background: background
            }
        },
        'zDepth-0': {
            bg: {
                boxShadow: 'none'
            }
        },
        'zDepth-1': {
            bg: {
                boxShadow: '0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)'
            }
        },
        'zDepth-2': {
            bg: {
                boxShadow: '0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)'
            }
        },
        'zDepth-3': {
            bg: {
                boxShadow: '0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)'
            }
        },
        'zDepth-4': {
            bg: {
                boxShadow: '0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)'
            }
        },
        'zDepth-5': {
            bg: {
                boxShadow: '0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)'
            }
        },
        'square': {
            bg: {
                borderRadius: '0'
            }
        },
        'circle': {
            bg: {
                borderRadius: '50%'
            }
        }
    }, passedStyles), {
        'zDepth-1': zDepth === 1
    });
    return $67815b6d4c2088ec$var$_react2.default.createElement('div', {
        style: styles.wrap
    }, $67815b6d4c2088ec$var$_react2.default.createElement('div', {
        style: styles.bg
    }), $67815b6d4c2088ec$var$_react2.default.createElement('div', {
        style: styles.content
    }, children));
};
$67815b6d4c2088ec$var$Raised.propTypes = {
    background: $67815b6d4c2088ec$var$_propTypes2.default.string,
    zDepth: $67815b6d4c2088ec$var$_propTypes2.default.oneOf([
        0,
        1,
        2,
        3,
        4,
        5
    ]),
    radius: $67815b6d4c2088ec$var$_propTypes2.default.number,
    styles: $67815b6d4c2088ec$var$_propTypes2.default.object
};
$67815b6d4c2088ec$var$Raised.defaultProps = {
    background: '#fff',
    zDepth: 1,
    radius: 2,
    styles: {}
};
$67815b6d4c2088ec$exports.default = $67815b6d4c2088ec$var$Raised;


Object.defineProperty($bdcc2cf97b7b69bf$exports, 'Raised', {
    enumerable: true,
    get: function get() {
        return $bdcc2cf97b7b69bf$var$_interopRequireDefault($67815b6d4c2088ec$exports).default;
    }
});
var $11191a369abe7d4b$exports = {};
'use strict';
Object.defineProperty($11191a369abe7d4b$exports, "__esModule", {
    value: true
});
$11191a369abe7d4b$exports.Saturation = undefined;
var $11191a369abe7d4b$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $5E6i4 = parcelRequire("5E6i4");
var $11191a369abe7d4b$var$_react2 = $11191a369abe7d4b$var$_interopRequireDefault($5E6i4);

var $11191a369abe7d4b$var$_reactcss2 = $11191a369abe7d4b$var$_interopRequireDefault($c8d725e5ba719c3a$exports);
var $16b6e938397a58b4$exports = {};
var $603e4c60a3719c2b$exports = {};

var $fFfYm = parcelRequire("fFfYm");
var $2aa256436bcff4ab$exports = {};

var $cxIyV = parcelRequire("cxIyV");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $2aa256436bcff4ab$var$now = function() {
    return $cxIyV.Date.now();
};
$2aa256436bcff4ab$exports = $2aa256436bcff4ab$var$now;


var $75a36d1dd8614065$exports = {};
var $5818318216a9842b$exports = {};
var $5aebe623c3d110de$exports = {};
/** Used to match a single whitespace character. */ var $5aebe623c3d110de$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $5aebe623c3d110de$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $5aebe623c3d110de$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$5aebe623c3d110de$exports = $5aebe623c3d110de$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $5818318216a9842b$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $5818318216a9842b$var$baseTrim(string) {
    return string ? string.slice(0, $5aebe623c3d110de$exports(string) + 1).replace($5818318216a9842b$var$reTrimStart, '') : string;
}
$5818318216a9842b$exports = $5818318216a9842b$var$baseTrim;



var $fFfYm = parcelRequire("fFfYm");

/** Used as references for various `Number` constants. */ var $75a36d1dd8614065$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $75a36d1dd8614065$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $75a36d1dd8614065$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $75a36d1dd8614065$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $75a36d1dd8614065$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $75a36d1dd8614065$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($8d97c1dbf922a3fb$exports(value)) return $75a36d1dd8614065$var$NAN;
    if ($fFfYm(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $fFfYm(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $5818318216a9842b$exports(value);
    var isBinary = $75a36d1dd8614065$var$reIsBinary.test(value);
    return isBinary || $75a36d1dd8614065$var$reIsOctal.test(value) ? $75a36d1dd8614065$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $75a36d1dd8614065$var$reIsBadHex.test(value) ? $75a36d1dd8614065$var$NAN : +value;
}
$75a36d1dd8614065$exports = $75a36d1dd8614065$var$toNumber;


/** Error message constants. */ var $603e4c60a3719c2b$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $603e4c60a3719c2b$var$nativeMax = Math.max, $603e4c60a3719c2b$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $603e4c60a3719c2b$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($603e4c60a3719c2b$var$FUNC_ERROR_TEXT);
    wait = $75a36d1dd8614065$exports(wait) || 0;
    if ($fFfYm(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $603e4c60a3719c2b$var$nativeMax($75a36d1dd8614065$exports(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $603e4c60a3719c2b$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $2aa256436bcff4ab$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($2aa256436bcff4ab$exports());
    }
    function debounced() {
        var time = $2aa256436bcff4ab$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$603e4c60a3719c2b$exports = $603e4c60a3719c2b$var$debounce;



var $fFfYm = parcelRequire("fFfYm");
/** Error message constants. */ var $16b6e938397a58b4$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $16b6e938397a58b4$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($16b6e938397a58b4$var$FUNC_ERROR_TEXT);
    if ($fFfYm(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $603e4c60a3719c2b$exports(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
$16b6e938397a58b4$exports = $16b6e938397a58b4$var$throttle;


var $11191a369abe7d4b$var$_throttle2 = $11191a369abe7d4b$var$_interopRequireDefault($16b6e938397a58b4$exports);
var $74130cb9c850e0a2$exports = {};
'use strict';
Object.defineProperty($74130cb9c850e0a2$exports, "__esModule", {
    value: true
});
var $74130cb9c850e0a2$var$calculateChange = $74130cb9c850e0a2$exports.calculateChange = function calculateChange(e, hsl, container) {
    var _container$getBoundin = container.getBoundingClientRect(), containerWidth = _container$getBoundin.width, containerHeight = _container$getBoundin.height;
    var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (left < 0) left = 0;
    else if (left > containerWidth) left = containerWidth;
    if (top < 0) top = 0;
    else if (top > containerHeight) top = containerHeight;
    var saturation = left / containerWidth;
    var bright = 1 - top / containerHeight;
    return {
        h: hsl.h,
        s: saturation,
        v: bright,
        a: hsl.a,
        source: 'hsv'
    };
};


var $11191a369abe7d4b$var$saturation = $11191a369abe7d4b$var$_interopRequireWildcard($74130cb9c850e0a2$exports);
function $11191a369abe7d4b$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $11191a369abe7d4b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $11191a369abe7d4b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $11191a369abe7d4b$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $11191a369abe7d4b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $11191a369abe7d4b$var$Saturation = $11191a369abe7d4b$exports.Saturation = function(_ref) {
    $11191a369abe7d4b$var$_inherits(Saturation, _ref);
    function Saturation(props) {
        $11191a369abe7d4b$var$_classCallCheck(this, Saturation);
        var _this = $11191a369abe7d4b$var$_possibleConstructorReturn(this, (Saturation.__proto__ || Object.getPrototypeOf(Saturation)).call(this, props));
        _this.handleChange = function(e) {
            typeof _this.props.onChange === 'function' && _this.throttle(_this.props.onChange, $11191a369abe7d4b$var$saturation.calculateChange(e, _this.props.hsl, _this.container), e);
        };
        _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            var renderWindow = _this.getContainerRenderWindow();
            renderWindow.addEventListener('mousemove', _this.handleChange);
            renderWindow.addEventListener('mouseup', _this.handleMouseUp);
        };
        _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        };
        _this.throttle = (0, $11191a369abe7d4b$var$_throttle2.default)(function(fn, data, e) {
            fn(data, e);
        }, 50);
        return _this;
    }
    $11191a369abe7d4b$var$_createClass(Saturation, [
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.throttle.cancel();
                this.unbindEventListeners();
            }
        },
        {
            key: 'getContainerRenderWindow',
            value: function getContainerRenderWindow() {
                var container = this.container;
                var renderWindow = window;
                while(!renderWindow.document.contains(container) && renderWindow.parent !== renderWindow)renderWindow = renderWindow.parent;
                return renderWindow;
            }
        },
        {
            key: 'unbindEventListeners',
            value: function unbindEventListeners() {
                var renderWindow = this.getContainerRenderWindow();
                renderWindow.removeEventListener('mousemove', this.handleChange);
                renderWindow.removeEventListener('mouseup', this.handleMouseUp);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var _ref2 = this.props.style || {}, color = _ref2.color, white = _ref2.white, black = _ref2.black, pointer = _ref2.pointer, circle = _ref2.circle;
                var styles = (0, $11191a369abe7d4b$var$_reactcss2.default)({
                    'default': {
                        color: {
                            absolute: '0px 0px 0px 0px',
                            background: 'hsl(' + this.props.hsl.h + ',100%, 50%)',
                            borderRadius: this.props.radius
                        },
                        white: {
                            absolute: '0px 0px 0px 0px',
                            borderRadius: this.props.radius
                        },
                        black: {
                            absolute: '0px 0px 0px 0px',
                            boxShadow: this.props.shadow,
                            borderRadius: this.props.radius
                        },
                        pointer: {
                            position: 'absolute',
                            top: -(this.props.hsv.v * 100) + 100 + '%',
                            left: this.props.hsv.s * 100 + '%',
                            cursor: 'default'
                        },
                        circle: {
                            width: '4px',
                            height: '4px',
                            boxShadow: '0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),\n            0 0 1px 2px rgba(0,0,0,.4)',
                            borderRadius: '50%',
                            cursor: 'hand',
                            transform: 'translate(-2px, -2px)'
                        }
                    },
                    'custom': {
                        color: color,
                        white: white,
                        black: black,
                        pointer: pointer,
                        circle: circle
                    }
                }, {
                    'custom': !!this.props.style
                });
                return $11191a369abe7d4b$var$_react2.default.createElement('div', {
                    style: styles.color,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, $11191a369abe7d4b$var$_react2.default.createElement('style', null, '\n          .saturation-white {\n            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));\n            background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n          }\n          .saturation-black {\n            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));\n            background: linear-gradient(to top, #000, rgba(0,0,0,0));\n          }\n        '), $11191a369abe7d4b$var$_react2.default.createElement('div', {
                    style: styles.white,
                    className: 'saturation-white'
                }, $11191a369abe7d4b$var$_react2.default.createElement('div', {
                    style: styles.black,
                    className: 'saturation-black'
                }), $11191a369abe7d4b$var$_react2.default.createElement('div', {
                    style: styles.pointer
                }, this.props.pointer ? $11191a369abe7d4b$var$_react2.default.createElement(this.props.pointer, this.props) : $11191a369abe7d4b$var$_react2.default.createElement('div', {
                    style: styles.circle
                }))));
            }
        }
    ]);
    return Saturation;
}($5E6i4.PureComponent || $5E6i4.Component);
$11191a369abe7d4b$exports.default = $11191a369abe7d4b$var$Saturation;


Object.defineProperty($bdcc2cf97b7b69bf$exports, 'Saturation', {
    enumerable: true,
    get: function get() {
        return $bdcc2cf97b7b69bf$var$_interopRequireDefault($11191a369abe7d4b$exports).default;
    }
});
var $071d84a70ced1707$exports = {};
'use strict';
Object.defineProperty($071d84a70ced1707$exports, "__esModule", {
    value: true
});
$071d84a70ced1707$exports.ColorWrap = undefined;
var $071d84a70ced1707$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $071d84a70ced1707$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $5E6i4 = parcelRequire("5E6i4");
var $071d84a70ced1707$var$_react2 = $071d84a70ced1707$var$_interopRequireDefault($5E6i4);

var $071d84a70ced1707$var$_debounce2 = $071d84a70ced1707$var$_interopRequireDefault($603e4c60a3719c2b$exports);
var $c77a05c51dcb740e$exports = {};
'use strict';
Object.defineProperty($c77a05c51dcb740e$exports, "__esModule", {
    value: true
});
$c77a05c51dcb740e$exports.isvalidColorString = $c77a05c51dcb740e$exports.red = $c77a05c51dcb740e$exports.getContrastingColor = $c77a05c51dcb740e$exports.isValidHex = $c77a05c51dcb740e$exports.toState = $c77a05c51dcb740e$exports.simpleCheckForValidColor = undefined;
var $7b0c8a3226cc4475$exports = {};

$7b0c8a3226cc4475$exports = (parcelRequire("kaywu"));


var $c77a05c51dcb740e$var$_each2 = $c77a05c51dcb740e$var$_interopRequireDefault($7b0c8a3226cc4475$exports);
var $cce32070de57c37f$exports = {};
// This file is autogenerated. It's used to publish CJS to npm.
(function(global, factory) {
    $cce32070de57c37f$exports = factory();
})($cce32070de57c37f$exports, function() {
    'use strict';
    function _typeof(obj) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
    }
    // https://github.com/bgrins/TinyColor
    // Brian Grinstead, MIT License
    var trimLeft = /^\s+/;
    var trimRight = /\s+$/;
    function tinycolor(color, opts) {
        color = color ? color : "";
        opts = opts || {};
        // If input is already a tinycolor, return itself
        if (color instanceof tinycolor) return color;
        // If we are called as a function, call using new instead
        if (!(this instanceof tinycolor)) return new tinycolor(color, opts);
        var rgb = inputToRGB(color);
        this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb.format;
        this._gradientType = opts.gradientType;
        // Don't let the range of [0,255] come back in [0,1].
        // Potentially lose a little bit of precision here, but will fix issues where
        // .5 gets interpreted as half of the total, instead of half of 1
        // If it was supposed to be 128, this was already taken care of by `inputToRgb`
        if (this._r < 1) this._r = Math.round(this._r);
        if (this._g < 1) this._g = Math.round(this._g);
        if (this._b < 1) this._b = Math.round(this._b);
        this._ok = rgb.ok;
    }
    tinycolor.prototype = {
        isDark: function isDark() {
            return this.getBrightness() < 128;
        },
        isLight: function isLight() {
            return !this.isDark();
        },
        isValid: function isValid() {
            return this._ok;
        },
        getOriginalInput: function getOriginalInput() {
            return this._originalInput;
        },
        getFormat: function getFormat() {
            return this._format;
        },
        getAlpha: function getAlpha() {
            return this._a;
        },
        getBrightness: function getBrightness() {
            //http://www.w3.org/TR/AERT#color-contrast
            var rgb = this.toRgb();
            return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
        },
        getLuminance: function getLuminance() {
            //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
            var rgb = this.toRgb();
            var RsRGB, GsRGB, BsRGB, R, G, B;
            RsRGB = rgb.r / 255;
            GsRGB = rgb.g / 255;
            BsRGB = rgb.b / 255;
            if (RsRGB <= 0.03928) R = RsRGB / 12.92;
            else R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
            if (GsRGB <= 0.03928) G = GsRGB / 12.92;
            else G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
            if (BsRGB <= 0.03928) B = BsRGB / 12.92;
            else B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
            return 0.2126 * R + 0.7152 * G + 0.0722 * B;
        },
        setAlpha: function setAlpha(value) {
            this._a = boundAlpha(value);
            this._roundA = Math.round(100 * this._a) / 100;
            return this;
        },
        toHsv: function toHsv() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            return {
                h: hsv.h * 360,
                s: hsv.s,
                v: hsv.v,
                a: this._a
            };
        },
        toHsvString: function toHsvString() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            var h = Math.round(hsv.h * 360), s = Math.round(hsv.s * 100), v = Math.round(hsv.v * 100);
            return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
        },
        toHsl: function toHsl() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            return {
                h: hsl.h * 360,
                s: hsl.s,
                l: hsl.l,
                a: this._a
            };
        },
        toHslString: function toHslString() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            var h = Math.round(hsl.h * 360), s = Math.round(hsl.s * 100), l = Math.round(hsl.l * 100);
            return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
        },
        toHex: function toHex(allow3Char) {
            return rgbToHex(this._r, this._g, this._b, allow3Char);
        },
        toHexString: function toHexString(allow3Char) {
            return "#" + this.toHex(allow3Char);
        },
        toHex8: function toHex8(allow4Char) {
            return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
        },
        toHex8String: function toHex8String(allow4Char) {
            return "#" + this.toHex8(allow4Char);
        },
        toRgb: function toRgb() {
            return {
                r: Math.round(this._r),
                g: Math.round(this._g),
                b: Math.round(this._b),
                a: this._a
            };
        },
        toRgbString: function toRgbString() {
            return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
        },
        toPercentageRgb: function toPercentageRgb() {
            return {
                r: Math.round(bound01(this._r, 255) * 100) + "%",
                g: Math.round(bound01(this._g, 255) * 100) + "%",
                b: Math.round(bound01(this._b, 255) * 100) + "%",
                a: this._a
            };
        },
        toPercentageRgbString: function toPercentageRgbString() {
            return this._a == 1 ? "rgb(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
        },
        toName: function toName() {
            if (this._a === 0) return "transparent";
            if (this._a < 1) return false;
            return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
        },
        toFilter: function toFilter(secondColor) {
            var hex8String = "#" + rgbaToArgbHex(this._r, this._g, this._b, this._a);
            var secondHex8String = hex8String;
            var gradientType = this._gradientType ? "GradientType = 1, " : "";
            if (secondColor) {
                var s = tinycolor(secondColor);
                secondHex8String = "#" + rgbaToArgbHex(s._r, s._g, s._b, s._a);
            }
            return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
        },
        toString: function toString(format) {
            var formatSet = !!format;
            format = format || this._format;
            var formattedString = false;
            var hasAlpha = this._a < 1 && this._a >= 0;
            var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
            if (needsAlphaFormat) {
                // Special case for "transparent", all other non-alpha formats
                // will return rgba when there is transparency.
                if (format === "name" && this._a === 0) return this.toName();
                return this.toRgbString();
            }
            if (format === "rgb") formattedString = this.toRgbString();
            if (format === "prgb") formattedString = this.toPercentageRgbString();
            if (format === "hex" || format === "hex6") formattedString = this.toHexString();
            if (format === "hex3") formattedString = this.toHexString(true);
            if (format === "hex4") formattedString = this.toHex8String(true);
            if (format === "hex8") formattedString = this.toHex8String();
            if (format === "name") formattedString = this.toName();
            if (format === "hsl") formattedString = this.toHslString();
            if (format === "hsv") formattedString = this.toHsvString();
            return formattedString || this.toHexString();
        },
        clone: function clone() {
            return tinycolor(this.toString());
        },
        _applyModification: function _applyModification(fn, args) {
            var color = fn.apply(null, [
                this
            ].concat([].slice.call(args)));
            this._r = color._r;
            this._g = color._g;
            this._b = color._b;
            this.setAlpha(color._a);
            return this;
        },
        lighten: function lighten() {
            return this._applyModification(_lighten, arguments);
        },
        brighten: function brighten() {
            return this._applyModification(_brighten, arguments);
        },
        darken: function darken() {
            return this._applyModification(_darken, arguments);
        },
        desaturate: function desaturate() {
            return this._applyModification(_desaturate, arguments);
        },
        saturate: function saturate() {
            return this._applyModification(_saturate, arguments);
        },
        greyscale: function greyscale() {
            return this._applyModification(_greyscale, arguments);
        },
        spin: function spin() {
            return this._applyModification(_spin, arguments);
        },
        _applyCombination: function _applyCombination(fn, args) {
            return fn.apply(null, [
                this
            ].concat([].slice.call(args)));
        },
        analogous: function analogous() {
            return this._applyCombination(_analogous, arguments);
        },
        complement: function complement() {
            return this._applyCombination(_complement, arguments);
        },
        monochromatic: function monochromatic() {
            return this._applyCombination(_monochromatic, arguments);
        },
        splitcomplement: function splitcomplement() {
            return this._applyCombination(_splitcomplement, arguments);
        },
        // Disabled until https://github.com/bgrins/TinyColor/issues/254
        // polyad: function (number) {
        //   return this._applyCombination(polyad, [number]);
        // },
        triad: function triad() {
            return this._applyCombination(polyad, [
                3
            ]);
        },
        tetrad: function tetrad() {
            return this._applyCombination(polyad, [
                4
            ]);
        }
    };
    // If input is an object, force 1 into "1.0" to handle ratios properly
    // String input requires "1.0" as input, so 1 will be treated as 1
    tinycolor.fromRatio = function(color, opts) {
        if (_typeof(color) == "object") {
            var newColor = {};
            for(var i in color)if (color.hasOwnProperty(i)) {
                if (i === "a") newColor[i] = color[i];
                else newColor[i] = convertToPercentage(color[i]);
            }
            color = newColor;
        }
        return tinycolor(color, opts);
    };
    // Given a string or object, convert that input to RGB
    // Possible string inputs:
    //
    //     "red"
    //     "#f00" or "f00"
    //     "#ff0000" or "ff0000"
    //     "#ff000000" or "ff000000"
    //     "rgb 255 0 0" or "rgb (255, 0, 0)"
    //     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
    //     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
    //     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
    //     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
    //     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
    //     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
    //
    function inputToRGB(color) {
        var rgb = {
            r: 0,
            g: 0,
            b: 0
        };
        var a = 1;
        var s = null;
        var v = null;
        var l = null;
        var ok = false;
        var format = false;
        if (typeof color == "string") color = stringInputToObject(color);
        if (_typeof(color) == "object") {
            if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
                rgb = rgbToRgb(color.r, color.g, color.b);
                ok = true;
                format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
            } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
                s = convertToPercentage(color.s);
                v = convertToPercentage(color.v);
                rgb = hsvToRgb(color.h, s, v);
                ok = true;
                format = "hsv";
            } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
                s = convertToPercentage(color.s);
                l = convertToPercentage(color.l);
                rgb = hslToRgb(color.h, s, l);
                ok = true;
                format = "hsl";
            }
            if (color.hasOwnProperty("a")) a = color.a;
        }
        a = boundAlpha(a);
        return {
            ok: ok,
            format: color.format || format,
            r: Math.min(255, Math.max(rgb.r, 0)),
            g: Math.min(255, Math.max(rgb.g, 0)),
            b: Math.min(255, Math.max(rgb.b, 0)),
            a: a
        };
    }
    // Conversion Functions
    // --------------------
    // `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
    // <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
    // `rgbToRgb`
    // Handle bounds / percentage checking to conform to CSS color spec
    // <http://www.w3.org/TR/css3-color/>
    // *Assumes:* r, g, b in [0, 255] or [0, 1]
    // *Returns:* { r, g, b } in [0, 255]
    function rgbToRgb(r, g, b) {
        return {
            r: bound01(r, 255) * 255,
            g: bound01(g, 255) * 255,
            b: bound01(b, 255) * 255
        };
    }
    // `rgbToHsl`
    // Converts an RGB color value to HSL.
    // *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
    // *Returns:* { h, s, l } in [0,1]
    function rgbToHsl(r, g, b) {
        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);
        var max = Math.max(r, g, b), min = Math.min(r, g, b);
        var h, s, l = (max + min) / 2;
        if (max == min) h = s = 0; // achromatic
        else {
            var d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch(max){
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        return {
            h: h,
            s: s,
            l: l
        };
    }
    // `hslToRgb`
    // Converts an HSL color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
    function hslToRgb(h, s, l) {
        var r, g, b;
        h = bound01(h, 360);
        s = bound01(s, 100);
        l = bound01(l, 100);
        function hue2rgb(p, q, t) {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1 / 6) return p + (q - p) * 6 * t;
            if (t < 0.5) return q;
            if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
            return p;
        }
        if (s === 0) r = g = b = l; // achromatic
        else {
            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var p = 2 * l - q;
            r = hue2rgb(p, q, h + 1 / 3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1 / 3);
        }
        return {
            r: r * 255,
            g: g * 255,
            b: b * 255
        };
    }
    // `rgbToHsv`
    // Converts an RGB color value to HSV
    // *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
    // *Returns:* { h, s, v } in [0,1]
    function rgbToHsv(r, g, b) {
        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);
        var max = Math.max(r, g, b), min = Math.min(r, g, b);
        var h, s, v = max;
        var d = max - min;
        s = max === 0 ? 0 : d / max;
        if (max == min) h = 0; // achromatic
        else {
            switch(max){
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        return {
            h: h,
            s: s,
            v: v
        };
    }
    // `hsvToRgb`
    // Converts an HSV color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
    function hsvToRgb(h, s, v) {
        h = bound01(h, 360) * 6;
        s = bound01(s, 100);
        v = bound01(v, 100);
        var i = Math.floor(h), f = h - i, p = v * (1 - s), q = v * (1 - f * s), t = v * (1 - (1 - f) * s), mod = i % 6, r = [
            v,
            q,
            p,
            p,
            t,
            v
        ][mod], g = [
            t,
            v,
            v,
            q,
            p,
            p
        ][mod], b = [
            p,
            p,
            t,
            v,
            v,
            q
        ][mod];
        return {
            r: r * 255,
            g: g * 255,
            b: b * 255
        };
    }
    // `rgbToHex`
    // Converts an RGB color to hex
    // Assumes r, g, and b are contained in the set [0, 255]
    // Returns a 3 or 6 character hex
    function rgbToHex(r, g, b, allow3Char) {
        var hex = [
            pad2(Math.round(r).toString(16)),
            pad2(Math.round(g).toString(16)),
            pad2(Math.round(b).toString(16))
        ];
        // Return a 3 character hex if possible
        if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
        return hex.join("");
    }
    // `rgbaToHex`
    // Converts an RGBA color plus alpha transparency to hex
    // Assumes r, g, b are contained in the set [0, 255] and
    // a in [0, 1]. Returns a 4 or 8 character rgba hex
    function rgbaToHex(r, g, b, a, allow4Char) {
        var hex = [
            pad2(Math.round(r).toString(16)),
            pad2(Math.round(g).toString(16)),
            pad2(Math.round(b).toString(16)),
            pad2(convertDecimalToHex(a))
        ];
        // Return a 4 character hex if possible
        if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
        return hex.join("");
    }
    // `rgbaToArgbHex`
    // Converts an RGBA color to an ARGB Hex8 string
    // Rarely used, but required for "toFilter()"
    function rgbaToArgbHex(r, g, b, a) {
        var hex = [
            pad2(convertDecimalToHex(a)),
            pad2(Math.round(r).toString(16)),
            pad2(Math.round(g).toString(16)),
            pad2(Math.round(b).toString(16))
        ];
        return hex.join("");
    }
    // `equals`
    // Can be called with any tinycolor input
    tinycolor.equals = function(color1, color2) {
        if (!color1 || !color2) return false;
        return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
    };
    tinycolor.random = function() {
        return tinycolor.fromRatio({
            r: Math.random(),
            g: Math.random(),
            b: Math.random()
        });
    };
    // Modification Functions
    // ----------------------
    // Thanks to less.js for some of the basics here
    // <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>
    function _desaturate(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.s -= amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }
    function _saturate(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.s += amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }
    function _greyscale(color) {
        return tinycolor(color).desaturate(100);
    }
    function _lighten(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.l += amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }
    function _brighten(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var rgb = tinycolor(color).toRgb();
        rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
        rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
        rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
        return tinycolor(rgb);
    }
    function _darken(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.l -= amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }
    // Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
    // Values outside of this range will be wrapped into this range.
    function _spin(color, amount) {
        var hsl = tinycolor(color).toHsl();
        var hue = (hsl.h + amount) % 360;
        hsl.h = hue < 0 ? 360 + hue : hue;
        return tinycolor(hsl);
    }
    // Combination Functions
    // ---------------------
    // Thanks to jQuery xColor for some of the ideas behind these
    // <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>
    function _complement(color) {
        var hsl = tinycolor(color).toHsl();
        hsl.h = (hsl.h + 180) % 360;
        return tinycolor(hsl);
    }
    function polyad(color, number) {
        if (isNaN(number) || number <= 0) throw new Error("Argument to polyad must be a positive number");
        var hsl = tinycolor(color).toHsl();
        var result = [
            tinycolor(color)
        ];
        var step = 360 / number;
        for(var i = 1; i < number; i++)result.push(tinycolor({
            h: (hsl.h + i * step) % 360,
            s: hsl.s,
            l: hsl.l
        }));
        return result;
    }
    function _splitcomplement(color) {
        var hsl = tinycolor(color).toHsl();
        var h = hsl.h;
        return [
            tinycolor(color),
            tinycolor({
                h: (h + 72) % 360,
                s: hsl.s,
                l: hsl.l
            }),
            tinycolor({
                h: (h + 216) % 360,
                s: hsl.s,
                l: hsl.l
            })
        ];
    }
    function _analogous(color, results, slices) {
        results = results || 6;
        slices = slices || 30;
        var hsl = tinycolor(color).toHsl();
        var part = 360 / slices;
        var ret = [
            tinycolor(color)
        ];
        for(hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;){
            hsl.h = (hsl.h + part) % 360;
            ret.push(tinycolor(hsl));
        }
        return ret;
    }
    function _monochromatic(color, results) {
        results = results || 6;
        var hsv = tinycolor(color).toHsv();
        var h = hsv.h, s = hsv.s, v = hsv.v;
        var ret = [];
        var modification = 1 / results;
        while(results--){
            ret.push(tinycolor({
                h: h,
                s: s,
                v: v
            }));
            v = (v + modification) % 1;
        }
        return ret;
    }
    // Utility Functions
    // ---------------------
    tinycolor.mix = function(color1, color2, amount) {
        amount = amount === 0 ? 0 : amount || 50;
        var rgb1 = tinycolor(color1).toRgb();
        var rgb2 = tinycolor(color2).toRgb();
        var p = amount / 100;
        var rgba = {
            r: (rgb2.r - rgb1.r) * p + rgb1.r,
            g: (rgb2.g - rgb1.g) * p + rgb1.g,
            b: (rgb2.b - rgb1.b) * p + rgb1.b,
            a: (rgb2.a - rgb1.a) * p + rgb1.a
        };
        return tinycolor(rgba);
    };
    // Readability Functions
    // ---------------------
    // <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
    // `contrast`
    // Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
    tinycolor.readability = function(color1, color2) {
        var c1 = tinycolor(color1);
        var c2 = tinycolor(color2);
        return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
    };
    // `isReadable`
    // Ensure that foreground and background color combinations meet WCAG2 guidelines.
    // The third argument is an optional Object.
    //      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
    //      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
    // If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
    // *Example*
    //    tinycolor.isReadable("#000", "#111") => false
    //    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
    tinycolor.isReadable = function(color1, color2, wcag2) {
        var readability = tinycolor.readability(color1, color2);
        var wcag2Parms, out;
        out = false;
        wcag2Parms = validateWCAG2Parms(wcag2);
        switch(wcag2Parms.level + wcag2Parms.size){
            case "AAsmall":
            case "AAAlarge":
                out = readability >= 4.5;
                break;
            case "AAlarge":
                out = readability >= 3;
                break;
            case "AAAsmall":
                out = readability >= 7;
                break;
        }
        return out;
    };
    // `mostReadable`
    // Given a base color and a list of possible foreground or background
    // colors for that base, returns the most readable color.
    // Optionally returns Black or White if the most readable color is unreadable.
    // *Example*
    //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
    //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
    //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
    //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
    tinycolor.mostReadable = function(baseColor, colorList, args) {
        var bestColor = null;
        var bestScore = 0;
        var readability;
        var includeFallbackColors, level, size;
        args = args || {};
        includeFallbackColors = args.includeFallbackColors;
        level = args.level;
        size = args.size;
        for(var i = 0; i < colorList.length; i++){
            readability = tinycolor.readability(baseColor, colorList[i]);
            if (readability > bestScore) {
                bestScore = readability;
                bestColor = tinycolor(colorList[i]);
            }
        }
        if (tinycolor.isReadable(baseColor, bestColor, {
            level: level,
            size: size
        }) || !includeFallbackColors) return bestColor;
        else {
            args.includeFallbackColors = false;
            return tinycolor.mostReadable(baseColor, [
                "#fff",
                "#000"
            ], args);
        }
    };
    // Big List of Colors
    // ------------------
    // <https://www.w3.org/TR/css-color-4/#named-colors>
    var names = tinycolor.names = {
        aliceblue: "f0f8ff",
        antiquewhite: "faebd7",
        aqua: "0ff",
        aquamarine: "7fffd4",
        azure: "f0ffff",
        beige: "f5f5dc",
        bisque: "ffe4c4",
        black: "000",
        blanchedalmond: "ffebcd",
        blue: "00f",
        blueviolet: "8a2be2",
        brown: "a52a2a",
        burlywood: "deb887",
        burntsienna: "ea7e5d",
        cadetblue: "5f9ea0",
        chartreuse: "7fff00",
        chocolate: "d2691e",
        coral: "ff7f50",
        cornflowerblue: "6495ed",
        cornsilk: "fff8dc",
        crimson: "dc143c",
        cyan: "0ff",
        darkblue: "00008b",
        darkcyan: "008b8b",
        darkgoldenrod: "b8860b",
        darkgray: "a9a9a9",
        darkgreen: "006400",
        darkgrey: "a9a9a9",
        darkkhaki: "bdb76b",
        darkmagenta: "8b008b",
        darkolivegreen: "556b2f",
        darkorange: "ff8c00",
        darkorchid: "9932cc",
        darkred: "8b0000",
        darksalmon: "e9967a",
        darkseagreen: "8fbc8f",
        darkslateblue: "483d8b",
        darkslategray: "2f4f4f",
        darkslategrey: "2f4f4f",
        darkturquoise: "00ced1",
        darkviolet: "9400d3",
        deeppink: "ff1493",
        deepskyblue: "00bfff",
        dimgray: "696969",
        dimgrey: "696969",
        dodgerblue: "1e90ff",
        firebrick: "b22222",
        floralwhite: "fffaf0",
        forestgreen: "228b22",
        fuchsia: "f0f",
        gainsboro: "dcdcdc",
        ghostwhite: "f8f8ff",
        gold: "ffd700",
        goldenrod: "daa520",
        gray: "808080",
        green: "008000",
        greenyellow: "adff2f",
        grey: "808080",
        honeydew: "f0fff0",
        hotpink: "ff69b4",
        indianred: "cd5c5c",
        indigo: "4b0082",
        ivory: "fffff0",
        khaki: "f0e68c",
        lavender: "e6e6fa",
        lavenderblush: "fff0f5",
        lawngreen: "7cfc00",
        lemonchiffon: "fffacd",
        lightblue: "add8e6",
        lightcoral: "f08080",
        lightcyan: "e0ffff",
        lightgoldenrodyellow: "fafad2",
        lightgray: "d3d3d3",
        lightgreen: "90ee90",
        lightgrey: "d3d3d3",
        lightpink: "ffb6c1",
        lightsalmon: "ffa07a",
        lightseagreen: "20b2aa",
        lightskyblue: "87cefa",
        lightslategray: "789",
        lightslategrey: "789",
        lightsteelblue: "b0c4de",
        lightyellow: "ffffe0",
        lime: "0f0",
        limegreen: "32cd32",
        linen: "faf0e6",
        magenta: "f0f",
        maroon: "800000",
        mediumaquamarine: "66cdaa",
        mediumblue: "0000cd",
        mediumorchid: "ba55d3",
        mediumpurple: "9370db",
        mediumseagreen: "3cb371",
        mediumslateblue: "7b68ee",
        mediumspringgreen: "00fa9a",
        mediumturquoise: "48d1cc",
        mediumvioletred: "c71585",
        midnightblue: "191970",
        mintcream: "f5fffa",
        mistyrose: "ffe4e1",
        moccasin: "ffe4b5",
        navajowhite: "ffdead",
        navy: "000080",
        oldlace: "fdf5e6",
        olive: "808000",
        olivedrab: "6b8e23",
        orange: "ffa500",
        orangered: "ff4500",
        orchid: "da70d6",
        palegoldenrod: "eee8aa",
        palegreen: "98fb98",
        paleturquoise: "afeeee",
        palevioletred: "db7093",
        papayawhip: "ffefd5",
        peachpuff: "ffdab9",
        peru: "cd853f",
        pink: "ffc0cb",
        plum: "dda0dd",
        powderblue: "b0e0e6",
        purple: "800080",
        rebeccapurple: "663399",
        red: "f00",
        rosybrown: "bc8f8f",
        royalblue: "4169e1",
        saddlebrown: "8b4513",
        salmon: "fa8072",
        sandybrown: "f4a460",
        seagreen: "2e8b57",
        seashell: "fff5ee",
        sienna: "a0522d",
        silver: "c0c0c0",
        skyblue: "87ceeb",
        slateblue: "6a5acd",
        slategray: "708090",
        slategrey: "708090",
        snow: "fffafa",
        springgreen: "00ff7f",
        steelblue: "4682b4",
        tan: "d2b48c",
        teal: "008080",
        thistle: "d8bfd8",
        tomato: "ff6347",
        turquoise: "40e0d0",
        violet: "ee82ee",
        wheat: "f5deb3",
        white: "fff",
        whitesmoke: "f5f5f5",
        yellow: "ff0",
        yellowgreen: "9acd32"
    };
    // Make it easy to access colors via `hexNames[hex]`
    var hexNames = tinycolor.hexNames = flip(names);
    // Utilities
    // ---------
    // `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
    function flip(o) {
        var flipped = {};
        for(var i in o)if (o.hasOwnProperty(i)) flipped[o[i]] = i;
        return flipped;
    }
    // Return a valid alpha value [0,1] with all invalid values being set to 1
    function boundAlpha(a) {
        a = parseFloat(a);
        if (isNaN(a) || a < 0 || a > 1) a = 1;
        return a;
    }
    // Take input from [0, n] and return it as [0, 1]
    function bound01(n, max) {
        if (isOnePointZero(n)) n = "100%";
        var processPercent = isPercentage(n);
        n = Math.min(max, Math.max(0, parseFloat(n)));
        // Automatically convert percentage into number
        if (processPercent) n = parseInt(n * max, 10) / 100;
        // Handle floating point rounding errors
        if (Math.abs(n - max) < 0.000001) return 1;
        // Convert into [0, 1] range if it isn't already
        return n % max / parseFloat(max);
    }
    // Force a number between 0 and 1
    function clamp01(val) {
        return Math.min(1, Math.max(0, val));
    }
    // Parse a base-16 hex value into a base-10 integer
    function parseIntFromHex(val) {
        return parseInt(val, 16);
    }
    // Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
    // <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
    function isOnePointZero(n) {
        return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
    }
    // Check to see if string passed in is a percentage
    function isPercentage(n) {
        return typeof n === "string" && n.indexOf("%") != -1;
    }
    // Force a hex value to have 2 characters
    function pad2(c) {
        return c.length == 1 ? "0" + c : "" + c;
    }
    // Replace a decimal with it's percentage value
    function convertToPercentage(n) {
        if (n <= 1) n = n * 100 + "%";
        return n;
    }
    // Converts a decimal to a hex value
    function convertDecimalToHex(d) {
        return Math.round(parseFloat(d) * 255).toString(16);
    }
    // Converts a hex value to a decimal
    function convertHexToDecimal(h) {
        return parseIntFromHex(h) / 255;
    }
    var matchers = function() {
        // <http://www.w3.org/TR/css3-values/#integers>
        var CSS_INTEGER = "[-\\+]?\\d+%?";
        // <http://www.w3.org/TR/css3-values/#number-value>
        var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
        // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
        var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
        // Actual matching.
        // Parentheses and commas are optional, but not required.
        // Whitespace can take the place of commas or opening paren
        var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
        var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
        return {
            CSS_UNIT: new RegExp(CSS_UNIT),
            rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
            rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
            hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
            hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
            hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
            hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
            hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
            hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
        };
    }();
    // `isValidCSSUnit`
    // Take in a single string / number and check to see if it looks like a CSS unit
    // (see `matchers` above for definition).
    function isValidCSSUnit(color) {
        return !!matchers.CSS_UNIT.exec(color);
    }
    // `stringInputToObject`
    // Permissive string parsing.  Take in a number of formats, and output an object
    // based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
    function stringInputToObject(color) {
        color = color.replace(trimLeft, "").replace(trimRight, "").toLowerCase();
        var named = false;
        if (names[color]) {
            color = names[color];
            named = true;
        } else if (color == "transparent") return {
            r: 0,
            g: 0,
            b: 0,
            a: 0,
            format: "name"
        };
        // Try to match string input using regular expressions.
        // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
        // Just return an object and let the conversion functions handle that.
        // This way the result will be the same whether the tinycolor is initialized with string or object.
        var match;
        if (match = matchers.rgb.exec(color)) return {
            r: match[1],
            g: match[2],
            b: match[3]
        };
        if (match = matchers.rgba.exec(color)) return {
            r: match[1],
            g: match[2],
            b: match[3],
            a: match[4]
        };
        if (match = matchers.hsl.exec(color)) return {
            h: match[1],
            s: match[2],
            l: match[3]
        };
        if (match = matchers.hsla.exec(color)) return {
            h: match[1],
            s: match[2],
            l: match[3],
            a: match[4]
        };
        if (match = matchers.hsv.exec(color)) return {
            h: match[1],
            s: match[2],
            v: match[3]
        };
        if (match = matchers.hsva.exec(color)) return {
            h: match[1],
            s: match[2],
            v: match[3],
            a: match[4]
        };
        if (match = matchers.hex8.exec(color)) return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            a: convertHexToDecimal(match[4]),
            format: named ? "name" : "hex8"
        };
        if (match = matchers.hex6.exec(color)) return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            format: named ? "name" : "hex"
        };
        if (match = matchers.hex4.exec(color)) return {
            r: parseIntFromHex(match[1] + "" + match[1]),
            g: parseIntFromHex(match[2] + "" + match[2]),
            b: parseIntFromHex(match[3] + "" + match[3]),
            a: convertHexToDecimal(match[4] + "" + match[4]),
            format: named ? "name" : "hex8"
        };
        if (match = matchers.hex3.exec(color)) return {
            r: parseIntFromHex(match[1] + "" + match[1]),
            g: parseIntFromHex(match[2] + "" + match[2]),
            b: parseIntFromHex(match[3] + "" + match[3]),
            format: named ? "name" : "hex"
        };
        return false;
    }
    function validateWCAG2Parms(parms) {
        // return valid WCAG2 parms for isReadable.
        // If input parms are invalid, return {"level":"AA", "size":"small"}
        var level, size;
        parms = parms || {
            level: "AA",
            size: "small"
        };
        level = (parms.level || "AA").toUpperCase();
        size = (parms.size || "small").toLowerCase();
        if (level !== "AA" && level !== "AAA") level = "AA";
        if (size !== "small" && size !== "large") size = "small";
        return {
            level: level,
            size: size
        };
    }
    return tinycolor;
});


var $c77a05c51dcb740e$var$_tinycolor2 = $c77a05c51dcb740e$var$_interopRequireDefault($cce32070de57c37f$exports);
function $c77a05c51dcb740e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $c77a05c51dcb740e$var$simpleCheckForValidColor = $c77a05c51dcb740e$exports.simpleCheckForValidColor = function simpleCheckForValidColor(data) {
    var keysToCheck = [
        'r',
        'g',
        'b',
        'a',
        'h',
        's',
        'l',
        'v'
    ];
    var checked = 0;
    var passed = 0;
    (0, $c77a05c51dcb740e$var$_each2.default)(keysToCheck, function(letter) {
        if (data[letter]) {
            checked += 1;
            if (!isNaN(data[letter])) passed += 1;
            if (letter === 's' || letter === 'l') {
                var percentPatt = /^\d+%$/;
                if (percentPatt.test(data[letter])) passed += 1;
            }
        }
    });
    return checked === passed ? data : false;
};
var $c77a05c51dcb740e$var$toState = $c77a05c51dcb740e$exports.toState = function toState(data, oldHue) {
    var color = data.hex ? (0, $c77a05c51dcb740e$var$_tinycolor2.default)(data.hex) : (0, $c77a05c51dcb740e$var$_tinycolor2.default)(data);
    var hsl = color.toHsl();
    var hsv = color.toHsv();
    var rgb = color.toRgb();
    var hex = color.toHex();
    if (hsl.s === 0) {
        hsl.h = oldHue || 0;
        hsv.h = oldHue || 0;
    }
    var transparent = hex === '000000' && rgb.a === 0;
    return {
        hsl: hsl,
        hex: transparent ? 'transparent' : '#' + hex,
        rgb: rgb,
        hsv: hsv,
        oldHue: data.h || oldHue || hsl.h,
        source: data.source
    };
};
var $c77a05c51dcb740e$var$isValidHex = $c77a05c51dcb740e$exports.isValidHex = function isValidHex(hex) {
    if (hex === 'transparent') return true;
    // disable hex4 and hex8
    var lh = String(hex).charAt(0) === '#' ? 1 : 0;
    return hex.length !== 4 + lh && hex.length < 7 + lh && (0, $c77a05c51dcb740e$var$_tinycolor2.default)(hex).isValid();
};
var $c77a05c51dcb740e$var$getContrastingColor = $c77a05c51dcb740e$exports.getContrastingColor = function getContrastingColor(data) {
    if (!data) return '#fff';
    var col = $c77a05c51dcb740e$var$toState(data);
    if (col.hex === 'transparent') return 'rgba(0,0,0,0.4)';
    var yiq = (col.rgb.r * 299 + col.rgb.g * 587 + col.rgb.b * 114) / 1000;
    return yiq >= 128 ? '#000' : '#fff';
};
var $c77a05c51dcb740e$var$red = $c77a05c51dcb740e$exports.red = {
    hsl: {
        a: 1,
        h: 0,
        l: 0.5,
        s: 1
    },
    hex: '#ff0000',
    rgb: {
        r: 255,
        g: 0,
        b: 0,
        a: 1
    },
    hsv: {
        h: 0,
        s: 1,
        v: 1,
        a: 1
    }
};
var $c77a05c51dcb740e$var$isvalidColorString = $c77a05c51dcb740e$exports.isvalidColorString = function isvalidColorString(string, type) {
    var stringWithoutDegree = string.replace("\xb0", '');
    return (0, $c77a05c51dcb740e$var$_tinycolor2.default)(type + ' (' + stringWithoutDegree + ')')._ok;
};


var $071d84a70ced1707$var$color = $071d84a70ced1707$var$_interopRequireWildcard($c77a05c51dcb740e$exports);
function $071d84a70ced1707$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $071d84a70ced1707$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $071d84a70ced1707$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $071d84a70ced1707$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $071d84a70ced1707$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $071d84a70ced1707$var$ColorWrap = $071d84a70ced1707$exports.ColorWrap = function ColorWrap(Picker) {
    var ColorPicker = function(_ref) {
        $071d84a70ced1707$var$_inherits(ColorPicker, _ref);
        function ColorPicker(props) {
            $071d84a70ced1707$var$_classCallCheck(this, ColorPicker);
            var _this = $071d84a70ced1707$var$_possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this));
            _this.handleChange = function(data, event) {
                var isValidColor = $071d84a70ced1707$var$color.simpleCheckForValidColor(data);
                if (isValidColor) {
                    var colors = $071d84a70ced1707$var$color.toState(data, data.h || _this.state.oldHue);
                    _this.setState(colors);
                    _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, colors, event);
                    _this.props.onChange && _this.props.onChange(colors, event);
                }
            };
            _this.handleSwatchHover = function(data, event) {
                var isValidColor = $071d84a70ced1707$var$color.simpleCheckForValidColor(data);
                if (isValidColor) {
                    var colors = $071d84a70ced1707$var$color.toState(data, data.h || _this.state.oldHue);
                    _this.props.onSwatchHover && _this.props.onSwatchHover(colors, event);
                }
            };
            _this.state = $071d84a70ced1707$var$_extends({}, $071d84a70ced1707$var$color.toState(props.color, 0));
            _this.debounce = (0, $071d84a70ced1707$var$_debounce2.default)(function(fn, data, event) {
                fn(data, event);
            }, 100);
            return _this;
        }
        $071d84a70ced1707$var$_createClass(ColorPicker, [
            {
                key: 'render',
                value: function render() {
                    var optionalEvents = {};
                    if (this.props.onSwatchHover) optionalEvents.onSwatchHover = this.handleSwatchHover;
                    return $071d84a70ced1707$var$_react2.default.createElement(Picker, $071d84a70ced1707$var$_extends({}, this.props, this.state, {
                        onChange: this.handleChange
                    }, optionalEvents));
                }
            }
        ], [
            {
                key: 'getDerivedStateFromProps',
                value: function getDerivedStateFromProps(nextProps, state) {
                    return $071d84a70ced1707$var$_extends({}, $071d84a70ced1707$var$color.toState(nextProps.color, state.oldHue));
                }
            }
        ]);
        return ColorPicker;
    }($5E6i4.PureComponent || $5E6i4.Component);
    ColorPicker.propTypes = $071d84a70ced1707$var$_extends({}, Picker.propTypes);
    ColorPicker.defaultProps = $071d84a70ced1707$var$_extends({}, Picker.defaultProps, {
        color: {
            h: 250,
            s: 0.50,
            l: 0.20,
            a: 1
        }
    });
    return ColorPicker;
};
$071d84a70ced1707$exports.default = $071d84a70ced1707$var$ColorWrap;


Object.defineProperty($bdcc2cf97b7b69bf$exports, 'ColorWrap', {
    enumerable: true,
    get: function get() {
        return $bdcc2cf97b7b69bf$var$_interopRequireDefault($071d84a70ced1707$exports).default;
    }
});
var $b6499764ab6ffa93$exports = {};
'use strict';
Object.defineProperty($b6499764ab6ffa93$exports, "__esModule", {
    value: true
});
$b6499764ab6ffa93$exports.Swatch = undefined;
var $b6499764ab6ffa93$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $5E6i4 = parcelRequire("5E6i4");
var $b6499764ab6ffa93$var$_react2 = $b6499764ab6ffa93$var$_interopRequireDefault($5E6i4);

var $b6499764ab6ffa93$var$_reactcss2 = $b6499764ab6ffa93$var$_interopRequireDefault($c8d725e5ba719c3a$exports);

var $4CjQ4 = parcelRequire("4CjQ4");

var $b6499764ab6ffa93$var$_Checkboard2 = $b6499764ab6ffa93$var$_interopRequireDefault($749294d42ac76cc8$exports);
function $b6499764ab6ffa93$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $b6499764ab6ffa93$var$ENTER = 13;
var $b6499764ab6ffa93$var$Swatch = $b6499764ab6ffa93$exports.Swatch = function Swatch(_ref) {
    var color = _ref.color, style = _ref.style, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onHover = _ref.onHover, _ref$title = _ref.title, title = _ref$title === undefined ? color : _ref$title, children = _ref.children, focus = _ref.focus, _ref$focusStyle = _ref.focusStyle, focusStyle = _ref$focusStyle === undefined ? {} : _ref$focusStyle;
    var transparent = color === 'transparent';
    var styles = (0, $b6499764ab6ffa93$var$_reactcss2.default)({
        default: {
            swatch: $b6499764ab6ffa93$var$_extends({
                background: color,
                height: '100%',
                width: '100%',
                cursor: 'pointer',
                position: 'relative',
                outline: 'none'
            }, style, focus ? focusStyle : {})
        }
    });
    var handleClick = function handleClick(e) {
        return onClick(color, e);
    };
    var handleKeyDown = function handleKeyDown(e) {
        return e.keyCode === $b6499764ab6ffa93$var$ENTER && onClick(color, e);
    };
    var handleHover = function handleHover(e) {
        return onHover(color, e);
    };
    var optionalEvents = {};
    if (onHover) optionalEvents.onMouseOver = handleHover;
    return $b6499764ab6ffa93$var$_react2.default.createElement('div', $b6499764ab6ffa93$var$_extends({
        style: styles.swatch,
        onClick: handleClick,
        title: title,
        tabIndex: 0,
        onKeyDown: handleKeyDown
    }, optionalEvents), children, transparent && $b6499764ab6ffa93$var$_react2.default.createElement($b6499764ab6ffa93$var$_Checkboard2.default, {
        borderRadius: styles.swatch.borderRadius,
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.1)'
    }));
};
$b6499764ab6ffa93$exports.default = (0, $4CjQ4.handleFocus)($b6499764ab6ffa93$var$Swatch);


Object.defineProperty($bdcc2cf97b7b69bf$exports, 'Swatch', {
    enumerable: true,
    get: function get() {
        return $bdcc2cf97b7b69bf$var$_interopRequireDefault($b6499764ab6ffa93$exports).default;
    }
});
function $bdcc2cf97b7b69bf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}





const $a2d27d3e8912bfe6$export$212b69dfa18d3b40 = 'melodic-pattern-configuration';
// A button, so the colour can also be changed with the keyboard (audit ISSUE-022).
const $a2d27d3e8912bfe6$var$ColoredPatch = (0, $07090e743135ae89$export$2e2bcd8739ae039).button`
  background-color: ${(styles)=>styles.$color};
  border: 0;
  border-radius: 0.2rem;
  cursor: pointer;
  display: block;
  height: 15px;
  padding: 0;
  width: 100px;
`;
const $a2d27d3e8912bfe6$var$HueWrapper = (0, $07090e743135ae89$export$2e2bcd8739ae039).div`
  width: -fill-available;

  div > .hue-horizontal > div > div {
    height: 22px !important;
  }
`;
const $a2d27d3e8912bfe6$var$SmallInput = (0, $07090e743135ae89$export$2e2bcd8739ae039)((0, $8951186c565e4005$export$2e2bcd8739ae039))`
  width: 100px;
`;
// antd 6 sizes the skeleton with more specific selectors than antd 4 and only gives the class name to the wrapper, not
// to the inner element any more: the repeated & outweighs antd's selectors, the inner element is sized explicitly.
const $a2d27d3e8912bfe6$var$SmallSkeletonInput = (0, $07090e743135ae89$export$2e2bcd8739ae039)((0, $55f3a1bd00c2d717$export$2e2bcd8739ae039).Input)`
  &&& {
    height: 22px !important;
    width: ${(styles)=>styles.$stretch ? '-webkit-fill-available' : '100px'};
  }

  &&& .ant-skeleton-input {
    height: 22px;
    min-width: unset;
    width: ${(styles)=>styles.$stretch ? '-webkit-fill-available' : '100px'};
  }
`;
const { Text: $a2d27d3e8912bfe6$var$Text, Title: $a2d27d3e8912bfe6$var$Title } = (0, $1356cdf58e4737d7$export$2e2bcd8739ae039);
const $a2d27d3e8912bfe6$var$ColorPicker = (0, $d9d5623a706e13aa$export$2e2bcd8739ae039)((props)=>{
    const [intermediateColor, setIntermediateColor] = (0, $5E6i4.useState)(props.hex);
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
        className: "grid grid-cols-2 gap-x-1",
        children: [
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($a2d27d3e8912bfe6$var$HueWrapper, {
                className: "relative h-[24px] p-1",
                children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $bdcc2cf97b7b69bf$exports.Hue), {
                    ...props,
                    onChange: props.onChange
                })
            }),
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $8951186c565e4005$export$2e2bcd8739ae039), {
                maxLength: 7,
                onBlur: ()=>setIntermediateColor(props.hex),
                onChange: (event)=>{
                    const color = event.target.value;
                    setIntermediateColor(color);
                    if (/^#[0-9A-F]{6}$/i.test(color)) props.onChange(color);
                },
                prefix: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $afb0b12e1f7ced20$export$2e2bcd8739ae039), {}),
                size: "small",
                value: intermediateColor
            })
        ]
    });
});
const $a2d27d3e8912bfe6$var$PatternConfiguration = ({ configuringID: configuringID, nodes: nodes, patterns: patterns, setConfiguringID: setConfiguringID, setNodes: setNodes, setPatterns: setPatterns, setSuggestingID: setSuggestingID })=>{
    const pattern = patterns.find((pattern)=>pattern.id === configuringID);
    const [color, setColor] = (0, $5E6i4.useState)(pattern?.color);
    const [labelDraft, setLabelDraft] = (0, $5E6i4.useState)();
    // The button's tooltip would cover the confirmation's buttons.
    const [isConfirmingDelete, setIsConfirmingDelete] = (0, $5E6i4.useState)(false);
    const isLabelEmpty = labelDraft !== undefined && labelDraft.trim() === '';
    const { t: translate } = (0, $705ab703c44be5bc$export$9fc83ad70ead8663)();
    (0, $5E6i4.useEffect)(()=>{
        setColor(pattern?.color);
        setLabelDraft(undefined);
    }, [
        configuringID
    ]);
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
        className: "flex items-center justify-between",
        id: $a2d27d3e8912bfe6$export$212b69dfa18d3b40,
        children: [
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($a2d27d3e8912bfe6$var$Title, {
                className: "!m-0 text-center rotate-180 whitespace-pre-wrap !leading-none",
                level: 5,
                style: {
                    writingMode: 'vertical-rl'
                },
                children: translate('melodicPattern.configuration.title')
            }),
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
                className: "pb-4 pr-2 pt-4 grid gap-x-4 gap-y-2",
                style: {
                    gridTemplateColumns: 'repeat(4, min-content(1px))'
                },
                children: [
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("span", {
                                className: "mb-1 flex items-center text-slate-600 text-xs",
                                children: [
                                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $a708ae8b61682253$export$2e2bcd8739ae039), {
                                        className: "mr-1"
                                    }),
                                    translate('melodicPattern.configuration.label')
                                ]
                            }),
                            configuringID === undefined ? /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($a2d27d3e8912bfe6$var$SmallSkeletonInput, {
                                size: "small"
                            }) : /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($a2d27d3e8912bfe6$var$SmallInput, {
                                "aria-invalid": isLabelEmpty,
                                "aria-label": translate('melodicPattern.configuration.label'),
                                maxLength: 50,
                                // An empty label is shown while typing but never stored (audit ISSUE-016: "undefined..." in the
                                // timeline); leaving the field restores the last label.
                                onBlur: ()=>setLabelDraft(undefined),
                                onChange: (event)=>{
                                    const label = event.target.value;
                                    setLabelDraft(label);
                                    if (label.trim() === '') return;
                                    setPatterns((oldPatterns)=>{
                                        const patternToChange = oldPatterns.find((pattern)=>pattern.id === configuringID);
                                        if (patternToChange !== undefined) {
                                            patternToChange.label = label;
                                            return [
                                                ...oldPatterns
                                            ];
                                        } else return oldPatterns;
                                    });
                                },
                                size: "small",
                                status: isLabelEmpty ? 'error' : undefined,
                                value: labelDraft ?? pattern?.label,
                                variant: "borderless"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("span", {
                                className: "mb-1 flex items-center text-slate-600 text-xs",
                                children: [
                                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $afb0b12e1f7ced20$export$2e2bcd8739ae039), {
                                        className: "mr-1"
                                    }),
                                    translate('melodicPattern.configuration.color'),
                                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $1bb718ecb5669b36$export$2e2bcd8739ae039), {
                                        classNames: {
                                            root: '!text-xs'
                                        },
                                        title: translate('melodicPattern.configuration.disclaimer'),
                                        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $e1bc962ecfda250a$export$2e2bcd8739ae039), {
                                            className: "ml-1",
                                            style: {
                                                fontSize: 'xx-small'
                                            }
                                        })
                                    })
                                ]
                            }),
                            configuringID === undefined ? /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($a2d27d3e8912bfe6$var$SmallSkeletonInput, {
                                size: "small"
                            }) : /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $93eb2f6d46bfe5a2$export$2e2bcd8739ae039), {
                                content: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($a2d27d3e8912bfe6$var$ColorPicker, {
                                    color: color || pattern?.color,
                                    onChange: (color)=>setColor(color.hex),
                                    onChangeComplete: (color)=>setPatterns((oldPatterns)=>{
                                            const patternToChange = oldPatterns.find((pattern)=>pattern.id === configuringID);
                                            if (patternToChange !== undefined) {
                                                patternToChange.color = color.hex;
                                                setColor(color.hex);
                                                return [
                                                    ...oldPatterns
                                                ];
                                            } else return oldPatterns;
                                        })
                                }),
                                id: "color-picker",
                                styles: {
                                    container: {
                                        padding: '0.5rem',
                                        width: 250
                                    },
                                    content: {
                                        padding: 0
                                    }
                                },
                                trigger: "click",
                                children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($a2d27d3e8912bfe6$var$ColoredPatch, {
                                    $color: pattern?.color,
                                    "aria-label": translate('melodicPattern.configuration.color'),
                                    className: "ml-1 mt-2",
                                    type: "button"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("span", {
                                className: "mb-1 flex items-center text-slate-600 text-xs",
                                children: [
                                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $c84a6b52a83822ee$export$2e2bcd8739ae039), {
                                        className: "mr-1"
                                    }),
                                    translate('melodicPattern.configuration.length')
                                ]
                            }),
                            configuringID === undefined ? /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($a2d27d3e8912bfe6$var$SmallSkeletonInput, {
                                size: "small"
                            }) : /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($a2d27d3e8912bfe6$var$Text, {
                                className: "ml-1.5",
                                children: pattern?.length
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("span", {
                                className: "mb-1 flex items-center text-slate-600 text-xs whitespace-nowrap",
                                children: [
                                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $acab2f81313f86ce$export$2e2bcd8739ae039), {
                                        className: "mr-1"
                                    }),
                                    translate('melodicPattern.configuration.occurrences')
                                ]
                            }),
                            configuringID === undefined ? /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($a2d27d3e8912bfe6$var$SmallSkeletonInput, {
                                $stretch: true,
                                size: "small"
                            }) : /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)($a2d27d3e8912bfe6$var$Text, {
                                className: "ml-1.5",
                                children: [
                                    pattern?.occurrences.length,
                                    " (",
                                    pattern?.uniqueOccurrencesCount,
                                    ")"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
                        style: {
                            gridColumn: 'span 4'
                        },
                        children: [
                            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("span", {
                                className: "mb-1 flex items-center text-slate-600 text-xs",
                                children: [
                                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $ee51eca14ea12f5a$export$2e2bcd8739ae039), {
                                        className: "mr-1"
                                    }),
                                    translate('melodicPattern.configuration.description')
                                ]
                            }),
                            configuringID === undefined ? /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($a2d27d3e8912bfe6$var$SmallSkeletonInput, {
                                $stretch: true,
                                size: "small"
                            }) : /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $8951186c565e4005$export$2e2bcd8739ae039), {
                                maxLength: 280,
                                onChange: (event)=>setPatterns((oldPatterns)=>{
                                        const patternToChange = oldPatterns.find((pattern)=>pattern.id === configuringID);
                                        if (patternToChange !== undefined) {
                                            patternToChange.description = event.target.value;
                                            return [
                                                ...oldPatterns
                                            ];
                                        } else return oldPatterns;
                                    }),
                                placeholder: translate('melodicPattern.configuration.descriptionPlaceholder'),
                                size: "small",
                                value: pattern?.description,
                                variant: "borderless"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
                className: "h-full flex flex-col items-center justify-center",
                children: [
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $bccd02a83058d871$export$2e2bcd8739ae039), {
                        "aria-label": translate('melodicPattern.configuration.lock'),
                        checked: pattern?.isLocked,
                        checkedChildren: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $87a2cb5e973fcac7$export$2e2bcd8739ae039), {}),
                        disabled: configuringID === undefined,
                        onChange: (checked)=>{
                            const nodeIndexToUnlock = nodes.findIndex((node)=>node.id === configuringID);
                            // With individual entries shown, a group has no node of its own to pin.
                            if (nodeIndexToUnlock === -1) ;
                            else if (checked) {
                                nodes[nodeIndexToUnlock].fx = nodes[nodeIndexToUnlock].x;
                                nodes[nodeIndexToUnlock].fy = nodes[nodeIndexToUnlock].y;
                            } else {
                                delete nodes[nodeIndexToUnlock].fx;
                                delete nodes[nodeIndexToUnlock].fy;
                            }
                            setNodes([
                                ...nodes
                            ]);
                            setPatterns((oldPatterns)=>{
                                const patternToChange = oldPatterns.find((oldPattern)=>oldPattern.id === configuringID);
                                patternToChange.isLocked = checked;
                                return [
                                    ...oldPatterns
                                ];
                            });
                        },
                        size: "small",
                        unCheckedChildren: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $4cffafdc589c376e$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $ee1d917a45794f63$export$2e2bcd8739ae039), {
                        cancelText: translate('toolbar.cancel'),
                        disabled: configuringID === undefined || !pattern?.isUserDefined,
                        okButtonProps: {
                            danger: true
                        },
                        okText: translate('toolbar.delete'),
                        onOpenChange: setIsConfirmingDelete,
                        onConfirm: ()=>{
                            setPatterns((oldPatterns)=>{
                                const patternToDelete = oldPatterns.find((oldPattern)=>oldPattern.id === configuringID);
                                const patternToDeleteIndex = oldPatterns.findIndex((oldPattern)=>oldPattern.id === configuringID);
                                if (patternToDeleteIndex !== -1) {
                                    if (patternToDelete && patternToDelete.isUserDefined) patternToDelete.connectedToByOperator.forEach((target)=>{
                                        const targetPatternIndex = oldPatterns.findIndex((oldPattern)=>oldPattern.id === target.id);
                                        if (targetPatternIndex !== -1) oldPatterns.splice(targetPatternIndex, 1);
                                    });
                                    oldPatterns.splice(patternToDeleteIndex, 1);
                                    (0, $e5b6a001e5093ab5$export$6be52bf1a7712494).add(patternToDelete.label);
                                }
                                return [
                                    ...oldPatterns
                                ];
                            });
                            setConfiguringID(undefined);
                            setSuggestingID(undefined);
                        },
                        title: translate('melodicPattern.configuration.deleteConfirm', {
                            label: pattern?.label
                        }),
                        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $1bb718ecb5669b36$export$2e2bcd8739ae039), {
                            open: isConfirmingDelete ? false : undefined,
                            title: translate(pattern && !pattern.isUserDefined ? 'melodicPattern.configuration.deleteSuggested' : 'melodicPattern.configuration.delete'),
                            children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("span", {
                                className: "mt-2",
                                children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $67d71c16fdfc3a0e$export$2e2bcd8739ae039), {
                                    "aria-label": translate('melodicPattern.configuration.delete'),
                                    danger: true,
                                    disabled: configuringID === undefined || !pattern?.isUserDefined,
                                    icon: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $424ba773c7c920f3$export$2e2bcd8739ae039), {}),
                                    size: "small",
                                    type: "text"
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $a2d27d3e8912bfe6$export$2e2bcd8739ae039 = $a2d27d3e8912bfe6$var$PatternConfiguration;



const { scaleLinear: $2b5809ac53051808$var$scaleLinear } = (0, $b2a13829cfbee039$exports);
const $2b5809ac53051808$var$entryKey = (occurrence)=>`${occurrence.voiceNumber}:${occurrence.firstOffset}:${occurrence.lastOffset}`;
/**
 * The graph with every entry of an operator group as a node of its own instead of one node per group (paper 7.2:
 * "individual patterns resulting from the operators are currently combined into single nodes which could be
 * extended"). An entry that several operators found is one node with an edge from each of them, so the overlaps that
 * the dashed edges summarise between groups become visible entry by entry.
 */ const $2b5809ac53051808$var$entriesOf = (shown, patternNodes, previous)=>{
    const groups = shown.filter((pattern)=>!pattern.isUserDefined);
    const nodes = patternNodes.filter((node)=>!groups.some((group)=>group.id === node.id));
    const entries = new Map();
    // New entries start evenly on a ring around the pattern their operator was applied to.
    const anchorOf = new Map();
    shown.forEach((source)=>source.connectedToByOperator.forEach((target)=>{
            const sourceNode = patternNodes.find((node)=>node.id === source.id);
            if (sourceNode !== undefined && !anchorOf.has(target.id)) anchorOf.set(target.id, sourceNode);
        }));
    const entryCount = groups.reduce((count, group)=>count + group.occurrences.length, 0);
    let ringIndex = 0;
    groups.forEach((group)=>{
        const groupNode = patternNodes.find((node)=>node.id === group.id);
        const anchor = anchorOf.get(group.id) ?? groupNode;
        group.occurrences.forEach((occurrence, index)=>{
            if (entries.has($2b5809ac53051808$var$entryKey(occurrence))) return;
            const id = `${group.id}#${index}`;
            const placed = previous.find((node)=>node.id === id);
            const node = {
                color: group.color,
                id: id,
                label: `${group.label}${index + 1}`,
                occurrenceIndex: index,
                patternID: group.id,
                x: placed?.x ?? (anchor?.x ?? 0) + 160 * Math.cos(2 * Math.PI * ringIndex / Math.max(entryCount, 1)),
                y: placed?.y ?? (anchor?.y ?? 0) + 160 * Math.sin(2 * Math.PI * ringIndex / Math.max(entryCount, 1))
            };
            ringIndex += 1;
            entries.set($2b5809ac53051808$var$entryKey(occurrence), node);
            nodes.push(node);
        });
    });
    const edges = [];
    shown.forEach((source)=>{
        // A group was searched from its first entry (chaining), a selected pattern is a node of its own.
        const sourceNode = source.isUserDefined ? nodes.find((node)=>node.id === source.id) : entries.get($2b5809ac53051808$var$entryKey(source.occurrences[0]));
        source.connectedToByOperator.forEach((target)=>{
            const group = groups.find((candidate)=>candidate.id === target.id);
            if (sourceNode === undefined || group === undefined) return;
            group.occurrences.forEach((occurrence)=>{
                const entry = entries.get($2b5809ac53051808$var$entryKey(occurrence));
                const isKnown = edges.some((edge)=>edge.source === sourceNode && edge.target === entry && edge.byOperator === target.byOperator);
                if (entry === undefined || entry === sourceNode || isKnown) return;
                edges.push({
                    byOperator: target.byOperator,
                    isBidirectional: (0, $e5b6a001e5093ab5$export$2ffb6bdccc8a5ed0)(target.byOperator),
                    source: sourceNode,
                    target: entry
                });
            });
        });
    });
    return {
        edges: edges,
        nodes: nodes
    };
};
const $2b5809ac53051808$var$isOccurrenceEdge = (edge)=>'byOccurrences' in edge;
const $2b5809ac53051808$var$requiresLayout = (previous, next)=>{
    if (previous === undefined || previous.length !== next.length) return true;
    const changes = (0, $02bea948bef00660$export$2e2bcd8739ae039)(previous, next);
    return Object.values(changes.updated).length > 0 && Object.values(changes.updated).every((update)=>Object.keys(update).includes('x') || Object.keys(update).includes('y'));
};
const $2b5809ac53051808$export$6b145896f7568079 = 'melody-graph';
const $2b5809ac53051808$var$MelodyGraph = ({ configuringID: configuringID, hoveredOccurrences: hoveredOccurrences, hoveredPatternIDs: hoveredPatternIDs, patterns: patterns, setConfiguringID: setConfiguringID, setHoveredOccurrenceIndex: setHoveredOccurrenceIndex, setHoveredOccurrences: setHoveredOccurrences, setHoveredPatternIDs: setHoveredPatternIDs, setPatterns: setPatterns, setSuggestingID: setSuggestingID })=>{
    const clickAwayGraphContainer = (0, $5E6i4.useRef)(null);
    const [edges, setEdges] = (0, $5E6i4.useState)([]);
    const [edgesAnimated, setEdgesAnimated] = (0, $5E6i4.useState)([]);
    const [graphContainer, { height: height, width: width }] = (0, $5da09a61d0d65faf$export$2e2bcd8739ae039)();
    const graphGroup = (0, $5E6i4.useRef)(null);
    const [isDragging, setIsDragging] = (0, $5E6i4.useState)(false);
    const [isPanning, setIsPanning] = (0, $5E6i4.useState)(false);
    const [melodyGraphTransform, setMelodyGraphTransform] = (0, $5E6i4.useState)('');
    const [nodes, setNodes] = (0, $5E6i4.useState)([]);
    const [nodesAnimated, setNodesAnimated] = (0, $5E6i4.useState)([]);
    const [showsEntries, setShowsEntries] = (0, $5E6i4.useState)(false);
    // Set when the entries were laid out: once they are rendered, the graph is fitted into view.
    const [shouldFit, setShouldFit] = (0, $5E6i4.useState)(false);
    const previousNodes = (0, $a428b4512e0a10bf$export$2e2bcd8739ae039)(nodes);
    const runningLayouts = (0, $5E6i4.useRef)(new Set());
    const stopLayouts = ()=>{
        runningLayouts.current.forEach((layout)=>layout.stop());
        runningLayouts.current.clear();
    };
    const [selection, setSelection] = (0, $5E6i4.useContext)((0, $ca0029180522dabd$export$7c7a4fd7f1336e2c));
    const { t: translate } = (0, $705ab703c44be5bc$export$9fc83ad70ead8663)();
    const arrowHeadHeight = 4;
    const arrowHeadWidth = 5;
    const occurrenceCounts = patterns.filter((pattern)=>pattern.isVisible).map((pattern)=>pattern.occurrences.length);
    const zoomHandler = (0, $2e3210259ae866af$export$2e2bcd8739ae039)();
    /** Pans and zooms so the whole graph is visible; `maximumScale` 1 only ever zooms out. */ const fitIntoView = (maximumScale = Infinity)=>{
        const graphBoundingBox = graphGroup.current?.getBBox();
        if (!graphBoundingBox || graphBoundingBox.width === 0 || graphBoundingBox.height === 0) return;
        const padding = 25;
        const transform = (0, $2aeeefb9d4aa62cb$export$f0954fd7d5368655).translate(width / 2, height / 2).scale(Math.min(maximumScale, (width - padding) / graphBoundingBox.width, (height - padding) / graphBoundingBox.height)).translate(-graphBoundingBox.x - graphBoundingBox.width / 2, -graphBoundingBox.y - graphBoundingBox.height / 2);
        setMelodyGraphTransform(transform.toString());
        zoomHandler.transform((0, $4506c173c1ba6b79$export$2e2bcd8739ae039)('#zoom'), transform);
    };
    const addDragToNodes = (simulation)=>{
        const dragHandler = (0, $c21609f852d50cdc$export$2e2bcd8739ae039)().on('start', (_event, node)=>{
            if (simulation) simulation.alphaTarget(0.01).restart();
            node.fx = node.x;
            node.fy = node.y;
            setIsDragging(true);
            setHoveredPatternIDs([]);
            setHoveredOccurrenceIndex(undefined);
        }).on('drag', (event, node)=>{
            const nodeID = node.id;
            const pattern = patterns.find((pattern)=>pattern.id === nodeID);
            if (pattern?.isLocked) return;
            node.fx = event.x;
            node.fy = event.y;
        }).on('end', (_event, node)=>{
            if (simulation) simulation.alphaTarget(0);
            delete node.fx;
            delete node.fy;
            setIsDragging(false);
        });
        // @ts-ignore
        dragHandler((0, $a85203b65095458d$export$2e2bcd8739ae039)('g.node').data(nodes));
    };
    const resetFocus = (event)=>{
        setSelection((oldSelection)=>({
                ...oldSelection,
                focusingID: undefined
            }));
        if (configuringID !== undefined && !event.target.classList.contains('node') && !event.target.parentElement.classList.contains('node')) setConfiguringID(undefined);
    };
    (0, $5E6i4.useEffect)(()=>{
        let center = [
            width / 2,
            height / 2
        ];
        if (patterns.length > 0) {
            if (nodesAnimated.length > 0 && nodesAnimated.some((node)=>!node.id.startsWith('melodic-pattern-'))) {
                const xCoordinates = nodesAnimated.map((node)=>node.x);
                const yCoordinates = nodesAnimated.map((node)=>node.y);
                const bottom = Math.max(...yCoordinates);
                const left = Math.min(...xCoordinates);
                const right = Math.max(...xCoordinates);
                const top = Math.min(...yCoordinates);
                const height = bottom - top;
                const width = right - left;
                const midPoint = [
                    left + width / 2,
                    top + height / 2
                ];
                if (height > width) center = [
                    right + width / 2,
                    midPoint[1]
                ];
                else center = [
                    midPoint[0],
                    top - height / 2
                ];
            }
            const patternNodes = patterns.filter((pattern)=>pattern.isVisible && (selection.focusingID === undefined || selection.focusingID === pattern.id)).map((pattern)=>{
                const node = nodesAnimated.find((nodeAnimated)=>nodeAnimated.id === pattern.id);
                const connectedNode = nodesAnimated.find((nodeAnimated)=>nodeAnimated.id === patterns.find((otherPattern)=>otherPattern.connectedToByOperator.map(({ id: id })=>id).includes(pattern.id))?.id);
                return {
                    color: pattern.color,
                    fx: node?.fx,
                    fy: node?.fy,
                    id: pattern.id,
                    label: pattern.label,
                    x: node ? node.x : connectedNode ? connectedNode.x : center[0],
                    y: node ? node.y : connectedNode ? connectedNode.y : center[1]
                };
            });
            if (showsEntries) {
                const entryGraph = $2b5809ac53051808$var$entriesOf(patterns.filter((pattern)=>pattern.isVisible && (selection.focusingID === undefined || selection.focusingID === pattern.id)), patternNodes, nodesAnimated);
                setNodes(entryGraph.nodes);
                setEdges(entryGraph.edges);
                return;
            }
            setNodes([
                ...patternNodes
            ]);
            let patternOccurrenceConnections = patterns.filter((pattern)=>pattern.isVisible && (selection.focusingID === undefined || selection.focusingID === pattern.id)).flatMap((pattern)=>pattern.connectedToByOccurrences.filter((target)=>patterns.some((pattern)=>{
                        const sourcePattern = patterns.find((potentialSourcePattern)=>potentialSourcePattern.id === target.id);
                        return pattern.id === target.id && sourcePattern.isVisible;
                    })).map((target)=>{
                    const sourceNode = patternNodes.find((node)=>node.id === pattern.id);
                    const targetNode = patternNodes.find((node)=>node.id === target.id);
                    if (sourceNode === undefined || targetNode === undefined) return;
                    return {
                        byOccurrences: target.occurrences,
                        isBidirectional: true,
                        source: sourceNode,
                        target: targetNode
                    };
                }).filter((edge)=>edge !== undefined));
            patternOccurrenceConnections = patternOccurrenceConnections.filter((connection, index)=>{
                const duplicateConnectionIndex = patternOccurrenceConnections.findIndex((potentialConnection)=>potentialConnection.source.id === connection.target.id && potentialConnection.target.id === connection.source.id);
                return duplicateConnectionIndex === -1 || duplicateConnectionIndex > index;
            });
            const patternOperatorConnections = patterns.filter((pattern)=>pattern.isVisible && (selection.focusingID === undefined || selection.focusingID === pattern.id)).flatMap((pattern)=>pattern.connectedToByOperator.filter((target)=>patterns.some((pattern)=>{
                        const sourcePattern = patterns.find((potentialSourcePattern)=>potentialSourcePattern.id === target.id);
                        return pattern.id === target.id && sourcePattern.isVisible;
                    })).map((target)=>{
                    const sourceNode = patternNodes.find((node)=>node.id === pattern.id);
                    const targetNode = patternNodes.find((node)=>node.id === target.id);
                    if (sourceNode === undefined || targetNode === undefined) return;
                    return {
                        byOperator: target.byOperator,
                        isBidirectional: (0, $e5b6a001e5093ab5$export$2ffb6bdccc8a5ed0)(target.byOperator),
                        source: sourceNode,
                        target: targetNode
                    };
                }).filter((edge)=>edge !== undefined));
            setEdges([
                ...patternOperatorConnections,
                ...patternOccurrenceConnections
            ]);
        } else {
            // No placeholder nodes (audit F04: the grey A, B and C looked like patterns); the empty state explains instead.
            setEdges([]);
            setNodes([]);
        }
    }, [
        height,
        patterns,
        selection.focusingID,
        showsEntries,
        width
    ]);
    (0, $5E6i4.useLayoutEffect)(()=>{
        if (nodes.length === 0) {
            stopLayouts();
            setNodesAnimated([]);
            setEdgesAnimated([]);
            return;
        }
        const center = [
            width / 2,
            height / 2
        ];
        const simulation = (0, $c1d4a37d6d45ae13$export$2e2bcd8739ae039)(nodes).alphaDecay(0.06) // Controls for roughly 100 iterations.
        .force('x', (0, $ba7b4235e1775cec$export$2e2bcd8739ae039)(center[0]).strength(showsEntries ? 0.02 : 0.1)).force('y', (0, $399269a1232ff250$export$2e2bcd8739ae039)(center[1]).strength(showsEntries ? 0.02 : 0.1))// Entry nodes are small (minimum radius): a compact layout keeps a group's entries together.
        .force('collision', (0, $53e4a88a69e53efa$export$2e2bcd8739ae039)(showsEntries ? 2 * (0, $9ecda7333d28e490$export$c49073cd0364c68) + 6 : 50)).force('link', (0, $9fd4d9b47239ceb4$export$2e2bcd8739ae039)(edges).id((node)=>node.id)// In the entry mode the edges are long and the pull to the centre weak, so the entries form a ring whose
        // operator icons (on the edges' middles) do not overlap; the graph is fitted into view afterwards.
        .distance(showsEntries ? 160 : 30));
        /*
     * The simulation does not have to run if the graph does not require any animation at the
     * moment. If necessary, the simulation is restarted to animate the graph while dragging later.
     */ if (!$2b5809ac53051808$var$requiresLayout(previousNodes, nodes)) {
            simulation.stop();
            setNodesAnimated([
                ...nodes
            ]);
            setEdgesAnimated([
                ...edges
            ]);
        } else if (showsEntries) {
            // One node per entry can mean a hundred nodes: their layout is computed at once instead of being animated over
            // a hundred frames, which kept them moving for a long time on a busy machine.
            stopLayouts();
            simulation.stop();
            simulation.tick(Math.ceil(Math.log(simulation.alphaMin()) / Math.log(1 - simulation.alphaDecay())));
            setNodesAnimated([
                ...simulation.nodes()
            ]);
            setEdgesAnimated([
                ...edges
            ]);
            setShouldFit(true);
        } else {
            // A layout of outdated nodes would draw them again (e.g. after a pattern was discarded); a layout that is still
            // running for the current nodes continues when only the size or the edges changed (branch above).
            stopLayouts();
            runningLayouts.current.add(simulation);
            simulation.on('end', ()=>runningLayouts.current.delete(simulation));
        }
        simulation.on('tick', ()=>{
            const nodesAnimated = simulation.nodes();
            setNodesAnimated([
                ...nodesAnimated
            ]);
            setEdgesAnimated([
                ...edges
            ]);
        });
        addDragToNodes(simulation);
    }, [
        edges,
        height,
        nodes,
        showsEntries,
        width
    ]);
    (0, $5E6i4.useEffect)(()=>{
        if (!shouldFit) return;
        setShouldFit(false);
        fitIntoView(1);
    }, [
        nodesAnimated,
        shouldFit
    ]);
    (0, $5E6i4.useLayoutEffect)(()=>{
        zoomHandler.on('start', ()=>setIsPanning(true)).on('zoom', (event)=>setMelodyGraphTransform(event.transform)).on('end', ()=>setIsPanning(false));
        (0, $4506c173c1ba6b79$export$2e2bcd8739ae039)('#zoom').call(zoomHandler).on('dblclick.zoom', null);
    });
    const maximumOccurrenceCount = Math.max(...occurrenceCounts);
    const minimumOccurrenceCount = Math.min(...occurrenceCounts);
    const offsetScale = $2b5809ac53051808$var$scaleLinear({
        domain: [
            minimumOccurrenceCount,
            maximumOccurrenceCount
        ],
        range: [
            (0, $9ecda7333d28e490$export$c49073cd0364c68),
            (0, $9ecda7333d28e490$export$8e87780efcb71645)
        ],
        round: true
    });
    const radius = (pattern)=>minimumOccurrenceCount === maximumOccurrenceCount || minimumOccurrenceCount === Infinity || maximumOccurrenceCount === -Infinity ? (0, $9ecda7333d28e490$export$c49073cd0364c68) : offsetScale(pattern?.occurrences.length ?? minimumOccurrenceCount);
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
        className: "w-full relative mb-5 mt-5 flex flex-col",
        ref: clickAwayGraphContainer,
        style: {
            height: '-webkit-fill-available',
            width: 'calc(100% - 1.25rem)'
        },
        children: [
            patterns.length === 0 && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("div", {
                className: "pointer-events-none absolute inset-0 flex items-center justify-center p-6",
                children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $3a3a0d3a83db59d1$export$2e2bcd8739ae039), {
                    // antd's description colour has a contrast of about 2:1.
                    description: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("span", {
                        className: "text-slate-600",
                        children: translate('melodyGraph.empty')
                    }),
                    image: (0, $3a3a0d3a83db59d1$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE
                })
            }),
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
                className: "absolute left-2 top-2",
                children: [
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $67d71c16fdfc3a0e$export$2e2bcd8739ae039), {
                        className: "mr-1 bg-white",
                        "aria-label": translate('melodyGraph.controls.fit'),
                        icon: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $8398e9e7789278c2$export$2e2bcd8739ae039), {}),
                        title: translate('melodyGraph.controls.fit'),
                        onClick: (event)=>{
                            fitIntoView();
                            event.stopPropagation();
                        },
                        shape: "circle",
                        size: "small"
                    }),
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $67d71c16fdfc3a0e$export$2e2bcd8739ae039), {
                        className: `mr-1 ${patterns.filter((pattern)=>pattern.isVisible).some((pattern)=>pattern.isLocked) ? undefined : 'bg-white'}`,
                        disabled: !patterns.filter((pattern)=>pattern.isVisible).some((pattern)=>pattern.isLocked),
                        "aria-label": translate('melodyGraph.controls.unlockAll'),
                        icon: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $4cffafdc589c376e$export$2e2bcd8739ae039), {}),
                        title: translate('melodyGraph.controls.unlockAll'),
                        onClick: (event)=>{
                            setPatterns((oldPatterns)=>{
                                oldPatterns.filter((oldPattern)=>oldPattern.isVisible).forEach((oldPattern)=>oldPattern.isLocked = false);
                                return [
                                    ...oldPatterns
                                ];
                            });
                            setNodes(nodes.map((node)=>{
                                delete node.fx;
                                delete node.fy;
                                return node;
                            }));
                            event.stopPropagation();
                        },
                        shape: "circle",
                        size: "small",
                        type: patterns.filter((pattern)=>pattern.isVisible).some((pattern)=>pattern.isLocked) ? 'primary' : 'default'
                    }),
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $67d71c16fdfc3a0e$export$2e2bcd8739ae039), {
                        className: selection.focusingID === undefined ? 'bg-white' : undefined,
                        disabled: configuringID === undefined,
                        "aria-label": translate('melodyGraph.controls.focus'),
                        icon: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $a91ec3b72a351c7b$export$2e2bcd8739ae039), {}),
                        title: translate('melodyGraph.controls.focus'),
                        onClick: (event)=>{
                            if (selection.focusingID !== undefined) setSelection((oldSelection)=>({
                                    ...oldSelection,
                                    focusingID: undefined
                                }));
                            else setSelection((oldSelection)=>({
                                    ...oldSelection,
                                    focusingID: configuringID
                                }));
                            event.stopPropagation();
                        },
                        shape: "circle",
                        size: "small",
                        type: selection.focusingID === undefined ? 'default' : 'primary'
                    }),
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $67d71c16fdfc3a0e$export$2e2bcd8739ae039), {
                        "aria-label": translate('melodyGraph.controls.entries'),
                        "aria-pressed": showsEntries,
                        className: `ml-1 ${showsEntries ? '' : 'bg-white'}`,
                        icon: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $48c6022fa0e38db4$export$2e2bcd8739ae039), {}),
                        onClick: (event)=>{
                            setShowsEntries((shows)=>!shows);
                            event.stopPropagation();
                        },
                        shape: "circle",
                        size: "small",
                        title: translate('melodyGraph.controls.entries'),
                        type: showsEntries ? 'primary' : 'default'
                    })
                ]
            }),
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("div", {
                className: "h-full w-full border border-dashed border-gray-300",
                id: $2b5809ac53051808$export$6b145896f7568079,
                ref: graphContainer,
                children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("svg", {
                    className: "cursor-move",
                    height: "100%",
                    onClick: resetFocus,
                    width: "100%",
                    children: [
                        /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("defs", {
                            children: edgesAnimated.map((edge, index)=>{
                                const targetNode = edge.target;
                                const targetPattern = patterns.find((pattern)=>pattern.id === targetNode.id);
                                // Better than filtering the edges beforehand to keep the index consistent with the rendering of the edges.
                                if (edge.isBidirectional) return null;
                                return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("marker", {
                                    id: `arrow-head-${index}`,
                                    markerWidth: arrowHeadWidth,
                                    markerHeight: arrowHeadHeight,
                                    refX: radius(targetPattern) / 2 + arrowHeadWidth,
                                    refY: arrowHeadHeight / 2,
                                    orient: "auto",
                                    children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("polygon", {
                                        fill: "lightGrey",
                                        points: `0 0, ${arrowHeadWidth} ${arrowHeadHeight / 2}, 0 ${arrowHeadHeight}`
                                    })
                                }, index);
                            })
                        }),
                        /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("rect", {
                            className: "fill-transparent",
                            height: height,
                            id: "zoom",
                            width: width
                        }),
                        /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("g", {
                            ref: graphGroup,
                            transform: melodyGraphTransform,
                            children: [
                                edgesAnimated.map((edge, index)=>{
                                    // Edges between the same two nodes (an entry found by several operators) share their line: their
                                    // icons are spread along it.
                                    const pair = (candidate)=>[
                                            candidate.source.id,
                                            candidate.target.id
                                        ].sort().join('|');
                                    const parallel = edgesAnimated.filter((candidate)=>pair(candidate) === pair(edge));
                                    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($2b5809ac53051808$var$MelodyGraphEdge, {
                                        edge: edge,
                                        hoveredOccurrences: hoveredOccurrences,
                                        hoveredPatternIDs: hoveredPatternIDs,
                                        index: index,
                                        parallelCount: parallel.length,
                                        parallelIndex: parallel.indexOf(edge),
                                        setHoveredOccurrences: setHoveredOccurrences
                                    }, index);
                                }),
                                nodesAnimated.map((node, index)=>{
                                    const pattern = patterns.find((pattern)=>pattern.id === (node.patternID ?? node.id));
                                    // The nodes follow the patterns one render later: skip a pattern that was just discarded or deleted.
                                    if (pattern === undefined) return null;
                                    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($2b5809ac53051808$var$MelodyGraphNode, {
                                        configuringID: configuringID,
                                        hoveredOccurrences: hoveredOccurrences,
                                        hoveredPatternIDs: hoveredPatternIDs,
                                        isDragging: isDragging,
                                        isPanning: isPanning,
                                        node: node,
                                        pattern: pattern,
                                        radius: node.patternID === undefined ? radius(pattern) : (0, $9ecda7333d28e490$export$c49073cd0364c68),
                                        setConfiguringID: setConfiguringID,
                                        setHoveredOccurrenceIndex: setHoveredOccurrenceIndex,
                                        setHoveredPatternIDs: setHoveredPatternIDs
                                    }, index);
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $a2d27d3e8912bfe6$export$2e2bcd8739ae039), {
                configuringID: configuringID,
                nodes: nodes,
                patterns: patterns,
                setConfiguringID: setConfiguringID,
                setNodes: setNodes,
                setPatterns: setPatterns,
                setSuggestingID: setSuggestingID
            })
        ]
    });
};
const $2b5809ac53051808$var$MelodyGraphEdge = ({ edge: edge, hoveredOccurrences: hoveredOccurrences, hoveredPatternIDs: hoveredPatternIDs, index: index, parallelCount: parallelCount, parallelIndex: parallelIndex, setHoveredOccurrences: setHoveredOccurrences })=>{
    // The middle of the edge, or a point beside it for parallel edges.
    const along = 0.5 + 0.18 * (parallelIndex - (parallelCount - 1) / 2);
    const center = [
        edge.source.x + along * (edge.target.x - edge.source.x),
        edge.source.y + along * (edge.target.y - edge.source.y)
    ];
    const circleRadius = 3;
    const imageSize = 16;
    const shouldBeTransparent = hoveredPatternIDs.length > 0 || hoveredOccurrences.length > 0 && (!$2b5809ac53051808$var$isOccurrenceEdge(edge) || !edge.byOccurrences.some((occurrence)=>hoveredOccurrences.some((hoveredOccurrence)=>(0, $e5b6a001e5093ab5$export$973cb4c224e2e27b)(hoveredOccurrence, occurrence))));
    const { t: translate } = (0, $705ab703c44be5bc$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("g", {
        children: [
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("line", {
                markerEnd: edge.isBidirectional ? '' : `url(#arrow-head-${index})`,
                stroke: "lightGrey",
                strokeDasharray: $2b5809ac53051808$var$isOccurrenceEdge(edge) ? '4 2' : '',
                strokeWidth: 2,
                style: {
                    strokeOpacity: shouldBeTransparent ? (0, $9ecda7333d28e490$export$e33e649b64add65d) : (0, $9ecda7333d28e490$export$47a4f6ea72e40329)
                },
                x1: edge.source.x,
                y1: edge.source.y,
                x2: edge.target.x,
                y2: edge.target.y
            }),
            $2b5809ac53051808$var$isOccurrenceEdge(edge) ? /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $1bb718ecb5669b36$export$2e2bcd8739ae039), {
                onOpenChange: (open)=>setHoveredOccurrences(open ? edge.byOccurrences : []),
                title: translate(`melodyGraph.commonOccurrencesEdge`, {
                    count: edge.byOccurrences.length
                }),
                children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("circle", {
                    cx: center[0],
                    cy: center[1],
                    fill: "lightGrey",
                    r: circleRadius,
                    opacity: shouldBeTransparent ? (0, $9ecda7333d28e490$export$e33e649b64add65d) : (0, $9ecda7333d28e490$export$47a4f6ea72e40329),
                    stroke: "grey",
                    style: {
                        cursor: 'help'
                    }
                })
            }) : /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $1bb718ecb5669b36$export$2e2bcd8739ae039), {
                title: translate(`suggestions.operators.${edge.byOperator}.title`),
                children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("image", {
                    height: imageSize,
                    href: (0, $e5b6a001e5093ab5$export$95535b6ba8828fcd)(edge.byOperator),
                    opacity: shouldBeTransparent ? (0, $9ecda7333d28e490$export$e33e649b64add65d) : (0, $9ecda7333d28e490$export$47a4f6ea72e40329),
                    style: {
                        cursor: 'help',
                        outline: '1px solid lightGrey'
                    },
                    width: imageSize,
                    x: center[0] - imageSize / 2,
                    y: center[1] - imageSize / 2
                })
            })
        ]
    });
};
const $2b5809ac53051808$var$MelodyGraphNode = ({ configuringID: configuringID, hoveredOccurrences: hoveredOccurrences, hoveredPatternIDs: hoveredPatternIDs, isDragging: isDragging, isPanning: isPanning, node: node, pattern: pattern, radius: radius, setConfiguringID: setConfiguringID, setHoveredOccurrenceIndex: setHoveredOccurrenceIndex, setHoveredPatternIDs: setHoveredPatternIDs })=>{
    const [selection, setSelection] = (0, $5E6i4.useContext)((0, $ca0029180522dabd$export$7c7a4fd7f1336e2c));
    const patternID = node.patternID ?? node.id;
    const occurrences = node.occurrenceIndex === undefined ? pattern?.occurrences ?? [] : [
        pattern?.occurrences[node.occurrenceIndex]
    ].filter((occurrence)=>occurrence !== undefined);
    const hasFixedPosition = node.fx !== undefined && node.fy !== undefined;
    const shouldBeTransparent = hoveredPatternIDs.length > 0 && !hoveredPatternIDs.includes(patternID) || hoveredOccurrences.length > 0 && occurrences.every((occurrence)=>hoveredOccurrences.every((hoveredOccurrence)=>!(0, $e5b6a001e5093ab5$export$973cb4c224e2e27b)(hoveredOccurrence, occurrence)));
    const stopHovering = ()=>{
        setHoveredOccurrenceIndex(undefined);
        setHoveredPatternIDs([]);
    };
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("g", {
        className: "cursor-pointer node",
        onClick: ()=>{
            stopHovering();
            setConfiguringID(patternID);
        },
        onDoubleClick: ()=>{
            stopHovering();
            if (selection.focusingID === undefined || selection.focusingID !== patternID) {
                setConfiguringID(patternID);
                setSelection((oldSelection)=>({
                        ...oldSelection,
                        focusingID: patternID
                    }));
            } else setSelection((oldSelection)=>({
                    ...oldSelection,
                    focusingID: undefined
                }));
        },
        onMouseEnter: ()=>{
            if (isDragging || isPanning) return;
            setHoveredPatternIDs([
                patternID
            ]);
            // An entry node brushes exactly its occurrence in the sheet and the timeline.
            if (node.occurrenceIndex !== undefined) setHoveredOccurrenceIndex(node.occurrenceIndex);
        },
        onMouseLeave: stopHovering,
        style: {
            fillOpacity: shouldBeTransparent ? (0, $9ecda7333d28e490$export$e33e649b64add65d) : (0, $9ecda7333d28e490$export$47a4f6ea72e40329)
        },
        children: [
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("circle", {
                cx: hasFixedPosition ? node.fx : node.x,
                cy: hasFixedPosition ? node.fy : node.y,
                fill: node.color,
                r: radius,
                stroke: configuringID !== undefined && configuringID === pattern?.id || pattern?.isLocked ? 'grey' : undefined,
                strokeDasharray: pattern?.isLocked ? 4 : undefined,
                strokeWidth: 2
            }),
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("text", {
                alignmentBaseline: "middle",
                fill: (0, $a9ceb34ac62682a2$export$2e2bcd8739ae039).mostReadable(node.color, [
                    '#808080'
                ], {
                    includeFallbackColors: true,
                    level: 'AAA',
                    size: 'small'
                }).toHexString(),
                fontSize: "xx-small",
                textAnchor: "middle",
                x: hasFixedPosition ? node.fx : node.x,
                y: hasFixedPosition ? node.fy : node.y,
                children: node.label
            }),
            pattern && !pattern.isUserDefined && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("foreignObject", {
                className: "flex",
                height: 10,
                width: 10,
                x: (hasFixedPosition ? node.fx : node.x) + Math.cos(Math.PI / 3) * radius + 4,
                y: (hasFixedPosition ? node.fy : node.y) - Math.sin(Math.PI / 3) * radius - 4,
                children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $b38986e5c635d7ef$export$2e2bcd8739ae039), {
                    className: "mr-1",
                    style: {
                        fontSize: 9
                    },
                    twoToneColor: "orange"
                })
            })
        ]
    });
};
var $2b5809ac53051808$export$2e2bcd8739ae039 = $2b5809ac53051808$var$MelodyGraph;






var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $aa9eb035f853f343$var$BulbOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M632 888H392c-4.4 0-8 3.6-8 8v32c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32v-32c0-4.4-3.6-8-8-8zM512 64c-181.1 0-328 146.9-328 328 0 121.4 66 227.4 164 284.1V792c0 17.7 14.3 32 32 32h264c17.7 0 32-14.3 32-32V676.1c98-56.7 164-162.7 164-284.1 0-181.1-146.9-328-328-328zm127.9 549.8L604 634.6V752H420V634.6l-35.9-20.8C305.4 568.3 256 484.5 256 392c0-141.4 114.6-256 256-256s256 114.6 256 256c0 92.5-49.4 176.3-128.1 221.8z"
                }
            }
        ]
    },
    "name": "bulb",
    "theme": "outlined"
};
var $aa9eb035f853f343$export$2e2bcd8739ae039 = $aa9eb035f853f343$var$BulbOutlined;



function $d65423fe016bd8b5$var$_extends() {
    $d65423fe016bd8b5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d65423fe016bd8b5$var$_extends.apply(this, arguments);
}
const $d65423fe016bd8b5$var$BulbOutlined = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $d65423fe016bd8b5$var$_extends({}, props, {
        ref: ref,
        icon: (0, $aa9eb035f853f343$export$2e2bcd8739ae039)
    }));
/**![bulb](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTYzMiA4ODhIMzkyYy00LjQgMC04IDMuNi04IDh2MzJjMCAxNy43IDE0LjMgMzIgMzIgMzJoMTkyYzE3LjcgMCAzMi0xNC4zIDMyLTMydi0zMmMwLTQuNC0zLjYtOC04LTh6TTUxMiA2NGMtMTgxLjEgMC0zMjggMTQ2LjktMzI4IDMyOCAwIDEyMS40IDY2IDIyNy40IDE2NCAyODQuMVY3OTJjMCAxNy43IDE0LjMgMzIgMzIgMzJoMjY0YzE3LjcgMCAzMi0xNC4zIDMyLTMyVjY3Ni4xYzk4LTU2LjcgMTY0LTE2Mi43IDE2NC0yODQuMSAwLTE4MS4xLTE0Ni45LTMyOC0zMjgtMzI4em0xMjcuOSA1NDkuOEw2MDQgNjM0LjZWNzUySDQyMFY2MzQuNmwtMzUuOS0yMC44QzMwNS40IDU2OC4zIDI1NiA0ODQuNSAyNTYgMzkyYzAtMTQxLjQgMTE0LjYtMjU2IDI1Ni0yNTZzMjU2IDExNC42IDI1NiAyNTZjMCA5Mi41LTQ5LjQgMTc2LjMtMTI4LjEgMjIxLjh6IiAvPjwvc3ZnPg==) */ const $d65423fe016bd8b5$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($d65423fe016bd8b5$var$BulbOutlined);
var $d65423fe016bd8b5$export$2e2bcd8739ae039 = $d65423fe016bd8b5$var$RefIcon;


var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $48b6a3a46510a0be$var$SettingOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M924.8 625.7l-65.5-56c3.1-19 4.7-38.4 4.7-57.8s-1.6-38.8-4.7-57.8l65.5-56a32.03 32.03 0 009.3-35.2l-.9-2.6a443.74 443.74 0 00-79.7-137.9l-1.8-2.1a32.12 32.12 0 00-35.1-9.5l-81.3 28.9c-30-24.6-63.5-44-99.7-57.6l-15.7-85a32.05 32.05 0 00-25.8-25.7l-2.7-.5c-52.1-9.4-106.9-9.4-159 0l-2.7.5a32.05 32.05 0 00-25.8 25.7l-15.8 85.4a351.86 351.86 0 00-99 57.4l-81.9-29.1a32 32 0 00-35.1 9.5l-1.8 2.1a446.02 446.02 0 00-79.7 137.9l-.9 2.6c-4.5 12.5-.8 26.5 9.3 35.2l66.3 56.6c-3.1 18.8-4.6 38-4.6 57.1 0 19.2 1.5 38.4 4.6 57.1L99 625.5a32.03 32.03 0 00-9.3 35.2l.9 2.6c18.1 50.4 44.9 96.9 79.7 137.9l1.8 2.1a32.12 32.12 0 0035.1 9.5l81.9-29.1c29.8 24.5 63.1 43.9 99 57.4l15.8 85.4a32.05 32.05 0 0025.8 25.7l2.7.5a449.4 449.4 0 00159 0l2.7-.5a32.05 32.05 0 0025.8-25.7l15.7-85a350 350 0 0099.7-57.6l81.3 28.9a32 32 0 0035.1-9.5l1.8-2.1c34.8-41.1 61.6-87.5 79.7-137.9l.9-2.6c4.5-12.3.8-26.3-9.3-35zM788.3 465.9c2.5 15.1 3.8 30.6 3.8 46.1s-1.3 31-3.8 46.1l-6.6 40.1 74.7 63.9a370.03 370.03 0 01-42.6 73.6L721 702.8l-31.4 25.8c-23.9 19.6-50.5 35-79.3 45.8l-38.1 14.3-17.9 97a377.5 377.5 0 01-85 0l-17.9-97.2-37.8-14.5c-28.5-10.8-55-26.2-78.7-45.7l-31.4-25.9-93.4 33.2c-17-22.9-31.2-47.6-42.6-73.6l75.5-64.5-6.5-40c-2.4-14.9-3.7-30.3-3.7-45.5 0-15.3 1.2-30.6 3.7-45.5l6.5-40-75.5-64.5c11.3-26.1 25.6-50.7 42.6-73.6l93.4 33.2 31.4-25.9c23.7-19.5 50.2-34.9 78.7-45.7l37.9-14.3 17.9-97.2c28.1-3.2 56.8-3.2 85 0l17.9 97 38.1 14.3c28.7 10.8 55.4 26.2 79.3 45.8l31.4 25.8 92.8-32.9c17 22.9 31.2 47.6 42.6 73.6L781.8 426l6.5 39.9zM512 326c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 01512 614c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 01400 502c0-29.9 11.7-58 32.8-79.2C454 401.6 482.1 390 512 390c29.9 0 58 11.6 79.2 32.8A111.6 111.6 0 01624 502c0 29.9-11.7 58-32.8 79.2z"
                }
            }
        ]
    },
    "name": "setting",
    "theme": "outlined"
};
var $48b6a3a46510a0be$export$2e2bcd8739ae039 = $48b6a3a46510a0be$var$SettingOutlined;



function $a988bc300b3d4f80$var$_extends() {
    $a988bc300b3d4f80$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a988bc300b3d4f80$var$_extends.apply(this, arguments);
}
const $a988bc300b3d4f80$var$SettingOutlined = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $a988bc300b3d4f80$var$_extends({}, props, {
        ref: ref,
        icon: (0, $48b6a3a46510a0be$export$2e2bcd8739ae039)
    }));
/**![setting](data:image/svg+xml;base64,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) */ const $a988bc300b3d4f80$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($a988bc300b3d4f80$var$SettingOutlined);
var $a988bc300b3d4f80$export$2e2bcd8739ae039 = $a988bc300b3d4f80$var$RefIcon;



var $5E6i4 = parcelRequire("5E6i4");



var $5E6i4 = parcelRequire("5E6i4");
function $1a80c65399ebe891$var$_extends() {
    $1a80c65399ebe891$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1a80c65399ebe891$var$_extends.apply(this, arguments);
}
const $1a80c65399ebe891$export$48513f6b9f8ce62d = /*#__PURE__*/ (0, $5E6i4.forwardRef)((props, ref)=>{
    const { prefixCls: prefixCls = 'rc-checkbox', className: className, style: style, checked: checked, disabled: disabled, defaultChecked: defaultChecked = false, type: type = 'checkbox', title: title, onChange: onChange, ...inputProps } = props;
    const inputRef = (0, $5E6i4.useRef)(null);
    const holderRef = (0, $5E6i4.useRef)(null);
    const [rawValue, setRawValue] = (0, $e18df22f16a16360$export$2e2bcd8739ae039)(defaultChecked, checked);
    (0, $5E6i4.useImperativeHandle)(ref, ()=>({
            focus: (options)=>{
                inputRef.current?.focus(options);
            },
            blur: ()=>{
                inputRef.current?.blur();
            },
            input: inputRef.current,
            nativeElement: holderRef.current
        }));
    const classString = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, className, {
        [`${prefixCls}-checked`]: rawValue,
        [`${prefixCls}-disabled`]: disabled
    });
    const handleChange = (e)=>{
        if (disabled) return;
        if (!('checked' in props)) setRawValue(e.target.checked);
        onChange?.({
            target: {
                ...props,
                type: type,
                checked: e.target.checked
            },
            stopPropagation () {
                e.stopPropagation();
            },
            preventDefault () {
                e.preventDefault();
            },
            nativeEvent: e.nativeEvent
        });
    };
    return /*#__PURE__*/ $5E6i4.createElement("span", {
        className: classString,
        title: title,
        style: style,
        ref: holderRef
    }, /*#__PURE__*/ $5E6i4.createElement("input", $1a80c65399ebe891$var$_extends({}, inputProps, {
        className: `${prefixCls}-input`,
        ref: inputRef,
        onChange: handleChange,
        disabled: disabled,
        checked: !!rawValue,
        type: type
    })));
});
var $1a80c65399ebe891$export$2e2bcd8739ae039 = $1a80c65399ebe891$export$48513f6b9f8ce62d;













var $5E6i4 = parcelRequire("5E6i4");
const $996378aacb18ff42$var$GroupContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createContext(null);
var $996378aacb18ff42$export$2e2bcd8739ae039 = $996378aacb18ff42$var$GroupContext;






const $3d8abc7fe3b892dc$export$92a97fe1d1148438 = (token)=>{
    const { checkboxCls: checkboxCls, checkboxSize: checkboxSize, lineWidth: lineWidth } = token;
    const wrapperCls = `${checkboxCls}-wrapper`;
    const hoverMediaQuery = '@media (hover: hover) and (pointer: fine)';
    return [
        // ===================== Basic =====================
        {
            // Group
            [`${checkboxCls}-group`]: {
                ...(0, $cd5a520fee8002b4$export$23997c3e44cc1c59)(token),
                display: 'inline-flex',
                flexWrap: 'wrap',
                columnGap: token.marginXS,
                // Group > Grid
                [`> ${token.antCls}-row`]: {
                    flex: 1
                }
            },
            // Wrapper
            [wrapperCls]: {
                ...(0, $cd5a520fee8002b4$export$23997c3e44cc1c59)(token),
                display: 'inline-flex',
                alignItems: 'baseline',
                cursor: 'pointer',
                // Fix checkbox & radio in flex align #30260
                '&:after': {
                    display: 'inline-block',
                    width: 0,
                    overflow: 'hidden',
                    content: "'\\a0'"
                },
                // Checkbox near checkbox
                [`& + ${wrapperCls}`]: {
                    marginInlineStart: 0
                }
            },
            // Wrapper > Checkbox
            [checkboxCls]: {
                ...(0, $cd5a520fee8002b4$export$23997c3e44cc1c59)(token),
                position: 'relative',
                whiteSpace: 'nowrap',
                lineHeight: 1,
                cursor: 'pointer',
                // To make alignment right when `controlHeight` is changed
                // Ref: https://github.com/ant-design/ant-design/issues/41564
                alignSelf: 'center',
                // Styles moved from inner
                boxSizing: 'border-box',
                display: 'block',
                width: checkboxSize,
                height: checkboxSize,
                direction: 'ltr',
                backgroundColor: token.colorBgContainer,
                border: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(lineWidth)} ${token.lineType} ${token.colorBorder}`,
                borderRadius: token.borderRadiusSM,
                borderCollapse: 'separate',
                transition: `all ${token.motionDurationSlow}`,
                flex: 'none',
                ...(0, $3c4103d4365d19b7$export$c5b4e7cabb00fc99)(),
                // Checkmark
                '&:after': {
                    boxSizing: 'border-box',
                    position: 'absolute',
                    top: `calc(${checkboxSize} / 2 - ${lineWidth})`,
                    insetInlineStart: `calc(${checkboxSize} / 4 - ${lineWidth})`,
                    display: 'table',
                    width: token.calc(checkboxSize).div(14).mul(5).equal(),
                    height: token.calc(checkboxSize).div(14).mul(8).equal(),
                    border: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.lineWidthBold)} solid ${token.colorWhite}`,
                    borderTop: 0,
                    borderInlineStart: 0,
                    transform: 'rotate(45deg) scale(0) translate(-50%,-50%)',
                    opacity: 0,
                    content: '""',
                    transition: `all ${token.motionDurationFast} ${token.motionEaseInBack}, opacity ${token.motionDurationFast}`,
                    ...(0, $3c4103d4365d19b7$export$a2e3d2d19d960234)()
                },
                // Wrapper > Checkbox > input
                [`${checkboxCls}-input`]: {
                    position: 'absolute',
                    // Since baseline align will get additional space offset,
                    // we need to move input to top to make it align with text.
                    // Ref: https://github.com/ant-design/ant-design/issues/38926#issuecomment-1486137799
                    inset: `calc(-1 * (${lineWidth}))`,
                    zIndex: 1,
                    cursor: 'pointer',
                    opacity: 0,
                    margin: 0
                },
                // Focus outline on checkbox when input is focus-visible
                [`&:has(${checkboxCls}-input:focus-visible)`]: (0, $cd5a520fee8002b4$export$6539948f0a737e39)(token),
                // Wrapper > Checkbox + Text
                '& + span': {
                    paddingInlineStart: token.paddingXS,
                    paddingInlineEnd: token.paddingXS
                }
            }
        },
        // ===================== Hover =====================
        {
            [hoverMediaQuery]: {
                // Wrapper & Wrapper > Checkbox
                [`
          ${wrapperCls}:not(${wrapperCls}-disabled),
          ${checkboxCls}:not(${checkboxCls}-disabled)
        `]: {
                    [`&:hover ${checkboxCls}`]: {
                        borderColor: token.colorPrimary
                    }
                },
                [`${wrapperCls}:not(${wrapperCls}-disabled)`]: {
                    [`&:hover ${checkboxCls}-checked:not(${checkboxCls}-disabled)`]: {
                        backgroundColor: token.colorPrimaryHover,
                        borderColor: 'transparent'
                    }
                }
            }
        },
        // ==================== Checked ====================
        {
            // Wrapper > Checkbox
            [`${checkboxCls}-checked`]: {
                backgroundColor: token.colorPrimary,
                borderColor: token.colorPrimary,
                '&:after': {
                    opacity: 1,
                    transform: 'rotate(45deg) scale(1) translate(-50%,-50%)',
                    transition: `all ${token.motionDurationMid} ${token.motionEaseOutBack} ${token.motionDurationFast}`,
                    ...(0, $3c4103d4365d19b7$export$a2e3d2d19d960234)()
                },
                [hoverMediaQuery]: {
                    // Hover on checked checkbox directly
                    [`&:not(${checkboxCls}-disabled):hover`]: {
                        backgroundColor: token.colorPrimaryHover,
                        borderColor: 'transparent'
                    }
                }
            }
        },
        // ================= Indeterminate =================
        {
            [checkboxCls]: {
                '&-indeterminate': {
                    backgroundColor: token.colorBgContainer,
                    borderColor: token.colorBorder,
                    '&:after': {
                        top: '50%',
                        insetInlineStart: '50%',
                        width: token.calc(token.fontSizeLG).div(2).equal(),
                        height: token.calc(token.fontSizeLG).div(2).equal(),
                        backgroundColor: token.colorPrimary,
                        border: 0,
                        transform: 'translate(-50%, -50%) scale(1)',
                        opacity: 1,
                        content: '""'
                    },
                    [hoverMediaQuery]: {
                        // https://github.com/ant-design/ant-design/issues/50074
                        [`&:not(${checkboxCls}-disabled):hover`]: {
                            backgroundColor: token.colorBgContainer,
                            borderColor: token.colorPrimary
                        }
                    }
                }
            }
        },
        // ==================== Disable ====================
        {
            // Wrapper
            [`${wrapperCls}-disabled`]: {
                cursor: 'not-allowed'
            },
            // Wrapper > Checkbox
            [`${checkboxCls}-disabled`]: {
                // Wrapper > Checkbox > input
                [`&, ${checkboxCls}-input`]: {
                    cursor: 'not-allowed',
                    // Disabled for native input to enable Tooltip event handler
                    // ref: https://github.com/ant-design/ant-design/issues/39822#issuecomment-1365075901
                    pointerEvents: 'none'
                },
                // Disabled checkbox styles
                background: token.colorBgContainerDisabled,
                borderColor: token.colorBorder,
                '&:after': {
                    borderColor: token.colorTextDisabled
                },
                '& + span': {
                    color: token.colorTextDisabled
                },
                [`&${checkboxCls}-indeterminate::after`]: {
                    background: token.colorTextDisabled
                }
            }
        }
    ];
};
function $3d8abc7fe3b892dc$export$3d2f074408bd1b82(prefixCls, token) {
    const checkboxToken = (0, $f564548c7b6877d5$export$4950aa0f605343fb)(token, {
        checkboxCls: `.${prefixCls}`,
        checkboxSize: token.controlInteractiveSize
    });
    return $3d8abc7fe3b892dc$export$92a97fe1d1148438(checkboxToken);
}
var $3d8abc7fe3b892dc$export$2e2bcd8739ae039 = (0, $761caadb5301aee1$export$51ec95de45185b42)('Checkbox', (token, { prefixCls: prefixCls })=>[
        $3d8abc7fe3b892dc$export$3d2f074408bd1b82(prefixCls, token)
    ]);



var $5E6i4 = parcelRequire("5E6i4");

function $a2789165b8d7822a$export$2e2bcd8739ae039(onOriginInputClick) {
    const labelClickLockRef = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useRef(null);
    const clearLock = ()=>{
        (0, $1d949665862f071a$export$2e2bcd8739ae039).cancel(labelClickLockRef.current);
        labelClickLockRef.current = null;
    };
    const onLabelClick = ()=>{
        clearLock();
        labelClickLockRef.current = (0, $1d949665862f071a$export$2e2bcd8739ae039)(()=>{
            labelClickLockRef.current = null;
        });
    };
    const onInputClick = (e)=>{
        if (labelClickLockRef.current) {
            e.stopPropagation();
            clearLock();
        }
        onOriginInputClick?.(e);
    };
    return [
        onLabelClick,
        onInputClick
    ];
}


"use client";
const $4841c6d8699e605c$var$InternalCheckbox = (props, ref)=>{
    const { prefixCls: customizePrefixCls, children: children, indeterminate: indeterminate = false, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, skipGroup: skipGroup = false, disabled: disabled, rootClassName: // Style
    rootClassName, className: className, style: style, classNames: classNames, styles: styles, name: // Name
    name, value: // Value
    value, checked: // Checked
    checked, defaultChecked: defaultChecked, onChange: onChange, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $519f2fad435b3034$export$46f4bd6436a25a31)('checkbox');
    const checkboxGroup = $5E6i4.useContext((0, $996378aacb18ff42$export$2e2bcd8739ae039));
    const { isFormItemInput: isFormItemInput } = $5E6i4.useContext((0, $e785311f53d64def$export$bbb5553c6c7a14ed));
    const contextDisabled = $5E6i4.useContext((0, $2ab14018ea5b2d79$export$2e2bcd8739ae039));
    const mergedDisabled = disabled ?? checkboxGroup?.disabled ?? contextDisabled;
    // ============================= Checked ==============================
    const [innerChecked, setInnerChecked] = (0, $e18df22f16a16360$export$2e2bcd8739ae039)(defaultChecked, checked);
    let mergedChecked = innerChecked;
    const onInternalChange = (0, $68990f4402d2f009$export$2e2bcd8739ae039)((event)=>{
        setInnerChecked(event.target.checked);
        onChange?.(event);
        if (!skipGroup && checkboxGroup?.toggleOption) checkboxGroup.toggleOption({
            label: children,
            value: value
        });
    });
    // ============================== Group ===============================
    if (checkboxGroup && !skipGroup) mergedChecked = checkboxGroup.value.includes(value);
    const checkboxRef = $5E6i4.useRef(null);
    const mergedRef = (0, $92c8c75386168ffc$export$1d1c999670a1285d)(ref, checkboxRef);
    $5E6i4.useEffect(()=>{
        if (skipGroup || !checkboxGroup) return;
        checkboxGroup.registerValue(value);
        return ()=>{
            checkboxGroup.cancelValue(value);
        };
    }, [
        value,
        skipGroup
    ]);
    // ========================== Indeterminate ===========================
    $5E6i4.useEffect(()=>{
        if (checkboxRef.current?.input) checkboxRef.current.input.indeterminate = indeterminate;
    }, [
        indeterminate
    ]);
    // ============================== Style ===============================
    const prefixCls = getPrefixCls('checkbox', customizePrefixCls);
    const rootCls = (0, $d104ec5f99ed66d7$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $3d8abc7fe3b892dc$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const checkboxProps = {
        ...restProps
    };
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        indeterminate: indeterminate,
        disabled: mergedDisabled,
        checked: mergedChecked
    };
    const contextStyleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $722c8632ba7bdb89$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    });
    const classString = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-wrapper`, {
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-wrapper-checked`]: mergedChecked,
        [`${prefixCls}-wrapper-disabled`]: mergedDisabled,
        [`${prefixCls}-wrapper-in-form-item`]: isFormItemInput
    }, contextClassName, className, mergedClassNames.root, rootClassName, cssVarCls, rootCls, hashId);
    const checkboxClass = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(mergedClassNames.icon, {
        [`${prefixCls}-indeterminate`]: indeterminate
    }, (0, $fb5e646f63645964$export$23466a5792b7a5d3), hashId);
    // ============================ Event Lock ============================
    const [onLabelClick, onInputClick] = (0, $a2789165b8d7822a$export$2e2bcd8739ae039)(checkboxProps.onClick);
    // ============================== Render ==============================
    return /*#__PURE__*/ $5E6i4.createElement((0, $fac597d347ed38a8$export$2e2bcd8739ae039), {
        component: "Checkbox",
        disabled: mergedDisabled
    }, /*#__PURE__*/ $5E6i4.createElement("label", {
        className: classString,
        style: mergedStyles.root,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onClick: onLabelClick
    }, /*#__PURE__*/ $5E6i4.createElement((0, $1a80c65399ebe891$export$2e2bcd8739ae039), {
        ...checkboxProps,
        name: !skipGroup && checkboxGroup ? checkboxGroup.name : name,
        checked: mergedChecked,
        onClick: onInputClick,
        onChange: onInternalChange,
        prefixCls: prefixCls,
        className: checkboxClass,
        style: mergedStyles.icon,
        disabled: mergedDisabled,
        ref: mergedRef,
        value: value
    }), (0, $b63de2b9864a5d1a$export$72280d5f896dac9a)(children) && /*#__PURE__*/ $5E6i4.createElement("span", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-label`, mergedClassNames.label),
        style: mergedStyles.label
    }, children)));
};
const $4841c6d8699e605c$var$Checkbox = /*#__PURE__*/ $5E6i4.forwardRef($4841c6d8699e605c$var$InternalCheckbox);
var $4841c6d8699e605c$export$2e2bcd8739ae039 = $4841c6d8699e605c$var$Checkbox;




var $5E6i4 = parcelRequire("5E6i4");








"use client";
const $678c6e5752d35810$var$CheckboxGroup = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { defaultValue: defaultValue, children: children, options: options = [], prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, onChange: onChange, role: role = 'group', ...restProps } = props;
    const { getPrefixCls: getPrefixCls, direction: direction } = $5E6i4.useContext((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
    const [value, setValue] = (0, $e18df22f16a16360$export$2e2bcd8739ae039)(defaultValue || [], restProps.value);
    const mergedValue = value || [];
    const [registeredValues, setRegisteredValues] = $5E6i4.useState([]);
    const memoizedOptions = $5E6i4.useMemo(()=>{
        return options.map((option)=>{
            if ((0, $addbc2fddcbb77a9$export$844ec244b1367d54)(option) || (0, $addbc2fddcbb77a9$export$7e4aa119212bc614)(option)) return {
                label: option,
                value: option
            };
            return option;
        }).filter((item)=>(0, $b63de2b9864a5d1a$export$826fff653a329e83)(item) && (0, $b63de2b9864a5d1a$export$826fff653a329e83)(item.value));
    }, [
        options
    ]);
    const cancelValue = (val)=>{
        setRegisteredValues((prevValues)=>prevValues.filter((v)=>v !== val));
    };
    const registerValue = (val)=>{
        setRegisteredValues((prevValues)=>[].concat((0, $0acfae8147afe964$export$2e2bcd8739ae039)(prevValues), [
                val
            ]));
    };
    const toggleOption = (option)=>{
        const optionIndex = mergedValue.indexOf(option.value);
        const newValue = (0, $0acfae8147afe964$export$2e2bcd8739ae039)(mergedValue);
        if (optionIndex === -1) newValue.push(option.value);
        else newValue.splice(optionIndex, 1);
        setValue(newValue);
        onChange?.(newValue.filter((val)=>registeredValues.includes(val)).sort((a, b)=>{
            const indexA = memoizedOptions.findIndex((opt)=>opt.value === a);
            const indexB = memoizedOptions.findIndex((opt)=>opt.value === b);
            return indexA - indexB;
        }));
    };
    const prefixCls = getPrefixCls('checkbox', customizePrefixCls);
    const groupPrefixCls = `${prefixCls}-group`;
    const rootCls = (0, $d104ec5f99ed66d7$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $3d8abc7fe3b892dc$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const domProps = (0, $48bd91d9f828de66$export$2e2bcd8739ae039)(restProps, [
        'value',
        'disabled'
    ]);
    const childrenNode = memoizedOptions.length > 0 ? memoizedOptions.map((option)=>/*#__PURE__*/ $5E6i4.createElement((0, $4841c6d8699e605c$export$2e2bcd8739ae039), {
            prefixCls: prefixCls,
            key: option.value.toString(),
            disabled: 'disabled' in option ? option.disabled : restProps.disabled,
            value: option.value,
            checked: mergedValue.includes(option.value),
            onChange: option.onChange,
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${groupPrefixCls}-item`, option.className),
            style: option.style,
            title: option.title,
            id: option.id,
            required: option.required
        }, option.label)) : children;
    const memoizedContext = $5E6i4.useMemo(()=>({
            toggleOption: toggleOption,
            value: mergedValue,
            disabled: restProps.disabled,
            name: restProps.name,
            registerValue: // https://github.com/ant-design/ant-design/issues/16376
            registerValue,
            cancelValue: cancelValue
        }), [
        toggleOption,
        mergedValue,
        restProps.disabled,
        restProps.name,
        registerValue,
        cancelValue
    ]);
    const classString = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(groupPrefixCls, {
        [`${groupPrefixCls}-rtl`]: direction === 'rtl'
    }, className, rootClassName, cssVarCls, rootCls, hashId);
    return /*#__PURE__*/ $5E6i4.createElement("div", {
        className: classString,
        style: style,
        role: role,
        ...domProps,
        ref: ref
    }, /*#__PURE__*/ $5E6i4.createElement((0, $996378aacb18ff42$export$2e2bcd8739ae039).Provider, {
        value: memoizedContext
    }, childrenNode));
});
var $678c6e5752d35810$export$2e2bcd8739ae039 = $678c6e5752d35810$var$CheckboxGroup;


"use client";
const $7f1dcd4b821f85a8$var$Checkbox = (0, $4841c6d8699e605c$export$2e2bcd8739ae039);
$7f1dcd4b821f85a8$var$Checkbox.Group = (0, $678c6e5752d35810$export$2e2bcd8739ae039);
$7f1dcd4b821f85a8$var$Checkbox.__ANT_CHECKBOX = true;
var $7f1dcd4b821f85a8$export$2e2bcd8739ae039 = $7f1dcd4b821f85a8$var$Checkbox;


var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $cd9e281ca17257ec$var$DoubleLeftOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M272.9 512l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L186.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H532c6.7 0 10.4-7.7 6.3-12.9L272.9 512zm304 0l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L490.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H836c6.7 0 10.4-7.7 6.3-12.9L576.9 512z"
                }
            }
        ]
    },
    "name": "double-left",
    "theme": "outlined"
};
var $cd9e281ca17257ec$export$2e2bcd8739ae039 = $cd9e281ca17257ec$var$DoubleLeftOutlined;



function $70a2db1425a9091c$var$_extends() {
    $70a2db1425a9091c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $70a2db1425a9091c$var$_extends.apply(this, arguments);
}
const $70a2db1425a9091c$var$DoubleLeftOutlined = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $70a2db1425a9091c$var$_extends({}, props, {
        ref: ref,
        icon: (0, $cd9e281ca17257ec$export$2e2bcd8739ae039)
    }));
/**![double-left](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI3Mi45IDUxMmwyNjUuNC0zMzkuMWM0LjEtNS4yLjQtMTIuOS02LjMtMTIuOWgtNzcuM2MtNC45IDAtOS42IDIuMy0xMi42IDYuMUwxODYuOCA0OTIuM2EzMS45OSAzMS45OSAwIDAwMCAzOS41bDI1NS4zIDMyNi4xYzMgMy45IDcuNyA2LjEgMTIuNiA2LjFINTMyYzYuNyAwIDEwLjQtNy43IDYuMy0xMi45TDI3Mi45IDUxMnptMzA0IDBsMjY1LjQtMzM5LjFjNC4xLTUuMi40LTEyLjktNi4zLTEyLjloLTc3LjNjLTQuOSAwLTkuNiAyLjMtMTIuNiA2LjFMNDkwLjggNDkyLjNhMzEuOTkgMzEuOTkgMCAwMDAgMzkuNWwyNTUuMyAzMjYuMWMzIDMuOSA3LjcgNi4xIDEyLjYgNi4xSDgzNmM2LjcgMCAxMC40LTcuNyA2LjMtMTIuOUw1NzYuOSA1MTJ6IiAvPjwvc3ZnPg==) */ const $70a2db1425a9091c$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($70a2db1425a9091c$var$DoubleLeftOutlined);
var $70a2db1425a9091c$export$2e2bcd8739ae039 = $70a2db1425a9091c$var$RefIcon;



var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $1419a64ecff9b76c$var$DoubleRightOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 00188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 00492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z"
                }
            }
        ]
    },
    "name": "double-right",
    "theme": "outlined"
};
var $1419a64ecff9b76c$export$2e2bcd8739ae039 = $1419a64ecff9b76c$var$DoubleRightOutlined;



function $e42cf5ddc79412c9$var$_extends() {
    $e42cf5ddc79412c9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e42cf5ddc79412c9$var$_extends.apply(this, arguments);
}
const $e42cf5ddc79412c9$var$DoubleRightOutlined = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $e42cf5ddc79412c9$var$_extends({}, props, {
        ref: ref,
        icon: (0, $1419a64ecff9b76c$export$2e2bcd8739ae039)
    }));
/**![double-right](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUzMy4yIDQ5Mi4zTDI3Ny45IDE2Ni4xYy0zLTMuOS03LjctNi4xLTEyLjYtNi4xSDE4OGMtNi43IDAtMTAuNCA3LjctNi4zIDEyLjlMNDQ3LjEgNTEyIDE4MS43IDg1MS4xQTcuOTggNy45OCAwIDAwMTg4IDg2NGg3Ny4zYzQuOSAwIDkuNi0yLjMgMTIuNi02LjFsMjU1LjMtMzI2LjFjOS4xLTExLjcgOS4xLTI3LjkgMC0zOS41em0zMDQgMEw1ODEuOSAxNjYuMWMtMy0zLjktNy43LTYuMS0xMi42LTYuMUg0OTJjLTYuNyAwLTEwLjQgNy43LTYuMyAxMi45TDc1MS4xIDUxMiA0ODUuNyA4NTEuMUE3Ljk4IDcuOTggMCAwMDQ5MiA4NjRoNzcuM2M0LjkgMCA5LjYtMi4zIDEyLjYtNi4xbDI1NS4zLTMyNi4xYzkuMS0xMS43IDkuMS0yNy45IDAtMzkuNXoiIC8+PC9zdmc+) */ const $e42cf5ddc79412c9$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($e42cf5ddc79412c9$var$DoubleRightOutlined);
var $e42cf5ddc79412c9$export$2e2bcd8739ae039 = $e42cf5ddc79412c9$var$RefIcon;








var $5E6i4 = parcelRequire("5E6i4");
const $f87ede0fd911792c$var$locale = {
    // Options
    items_per_page: "\u6761/\u9875",
    jump_to: "\u8DF3\u81F3",
    jump_to_confirm: "\u786E\u5B9A",
    page: "\u9875",
    // Pagination
    prev_page: "\u4E0A\u4E00\u9875",
    next_page: "\u4E0B\u4E00\u9875",
    prev_5: "\u5411\u524D 5 \u9875",
    next_5: "\u5411\u540E 5 \u9875",
    prev_3: "\u5411\u524D 3 \u9875",
    next_3: "\u5411\u540E 3 \u9875",
    page_size: "\u9875\u7801"
};
var $f87ede0fd911792c$export$2e2bcd8739ae039 = $f87ede0fd911792c$var$locale;




var $5E6i4 = parcelRequire("5E6i4");
const $3adc21240feb6180$var$defaultPageSizeOptions = [
    10,
    20,
    50,
    100
];
const $3adc21240feb6180$var$Options = (props)=>{
    const { pageSizeOptions: pageSizeOptions = $3adc21240feb6180$var$defaultPageSizeOptions, locale: locale, changeSize: changeSize, pageSize: pageSize, goButton: goButton, quickGo: quickGo, rootPrefixCls: rootPrefixCls, disabled: disabled, buildOptionText: buildOptionText, showSizeChanger: showSizeChanger, sizeChangerRender: sizeChangerRender } = props;
    const [goInputText, setGoInputText] = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useState('');
    const getValidValue = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useMemo(()=>{
        return !goInputText || Number.isNaN(goInputText) ? undefined : Number(goInputText);
    }, [
        goInputText
    ]);
    const mergeBuildOptionText = typeof buildOptionText === 'function' ? buildOptionText : (value)=>`${value} ${locale.items_per_page}`;
    const handleChange = (e)=>{
        const value = e.target.value;
        if (/^\d*$/.test(value)) setGoInputText(value);
    };
    const handleBlur = (e)=>{
        if (goButton || goInputText === '') return;
        setGoInputText('');
        if (e.relatedTarget && (e.relatedTarget.className.includes(`${rootPrefixCls}-item-link`) || e.relatedTarget.className.includes(`${rootPrefixCls}-item`))) return;
        quickGo?.(getValidValue);
    };
    const go = (e)=>{
        if (goInputText === '') return;
        if (e.keyCode === (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).ENTER || e.type === 'click') {
            setGoInputText('');
            quickGo?.(getValidValue);
        }
    };
    const getPageSizeOptions = ()=>{
        if (pageSizeOptions.some((option)=>option.toString() === pageSize.toString())) return pageSizeOptions;
        return pageSizeOptions.concat([
            pageSize
        ]).sort((a, b)=>{
            const numberA = Number.isNaN(Number(a)) ? 0 : Number(a);
            const numberB = Number.isNaN(Number(b)) ? 0 : Number(b);
            return numberA - numberB;
        });
    };
    // ============== cls ==============
    const prefixCls = `${rootPrefixCls}-options`;
    // ============== render ==============
    if (!showSizeChanger && !quickGo) return null;
    let changeSelect = null;
    let goInput = null;
    let gotoButton = null;
    // >>>>> Size Changer
    if (showSizeChanger && sizeChangerRender) changeSelect = sizeChangerRender({
        disabled: disabled,
        size: pageSize,
        onSizeChange: (nextValue)=>{
            changeSize?.(Number(nextValue));
        },
        'aria-label': locale.page_size,
        className: `${prefixCls}-size-changer`,
        options: getPageSizeOptions().map((opt)=>({
                label: mergeBuildOptionText(opt),
                value: opt
            }))
    });
    // >>>>> Quick Go
    if (quickGo) {
        if (goButton) gotoButton = typeof goButton === 'boolean' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("button", {
            type: "button",
            onClick: go,
            onKeyUp: go,
            disabled: disabled,
            className: `${prefixCls}-quick-jumper-button`
        }, locale.jump_to_confirm) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("span", {
            onClick: go,
            onKeyUp: go
        }, goButton);
        goInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("div", {
            className: `${prefixCls}-quick-jumper`
        }, locale.jump_to, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("input", {
            disabled: disabled,
            type: "text",
            value: goInputText,
            onChange: handleChange,
            onKeyUp: go,
            onBlur: handleBlur,
            "aria-label": locale.page
        }), locale.page, gotoButton);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("li", {
        className: prefixCls
    }, changeSelect, goInput);
};
var $3adc21240feb6180$export$2e2bcd8739ae039 = $3adc21240feb6180$var$Options;


/* eslint react/prop-types: 0 */ 

var $5E6i4 = parcelRequire("5E6i4");
const $96124fb0b3db03dd$var$Pager = (props)=>{
    const { rootPrefixCls: rootPrefixCls, page: page, active: active, className: className, style: style, showTitle: showTitle, onClick: onClick, onKeyPress: onKeyPress, itemRender: itemRender } = props;
    const prefixCls = `${rootPrefixCls}-item`;
    const cls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-${page}`, {
        [`${prefixCls}-active`]: active,
        [`${prefixCls}-disabled`]: !page
    }, className);
    const handleClick = ()=>{
        onClick(page);
    };
    const handleKeyPress = (e)=>{
        onKeyPress(e, onClick, page);
    };
    const pager = itemRender(page, 'page', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("a", {
        rel: "nofollow"
    }, page));
    return pager ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("li", {
        title: showTitle ? String(page) : null,
        className: cls,
        style: style,
        onClick: handleClick,
        onKeyDown: handleKeyPress,
        tabIndex: 0
    }, pager) : null;
};
var $96124fb0b3db03dd$export$2e2bcd8739ae039 = $96124fb0b3db03dd$var$Pager;


function $046ea69c7c6e9f97$var$_extends() {
    $046ea69c7c6e9f97$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $046ea69c7c6e9f97$var$_extends.apply(this, arguments);
}
const $046ea69c7c6e9f97$var$defaultItemRender = (_, __, element)=>element;
function $046ea69c7c6e9f97$var$noop() {}
function $046ea69c7c6e9f97$var$isInteger(v) {
    const value = Number(v);
    return typeof value === 'number' && !Number.isNaN(value) && isFinite(value) && Math.floor(value) === value;
}
function $046ea69c7c6e9f97$var$calculatePage(p, pageSize, total) {
    const _pageSize = typeof p === 'undefined' ? pageSize : p;
    return Math.floor((total - 1) / _pageSize) + 1;
}
const $046ea69c7c6e9f97$var$Pagination = (props)=>{
    const { prefixCls: // cls
    prefixCls = 'rc-pagination', selectPrefixCls: selectPrefixCls = 'rc-select', className: className, classNames: paginationClassNames, styles: styles, // control
    current: currentProp, defaultCurrent: defaultCurrent = 1, total: total = 0, pageSize: pageSizeProp, defaultPageSize: defaultPageSize = 10, onChange: onChange = $046ea69c7c6e9f97$var$noop, hideOnSinglePage: // config
    hideOnSinglePage, align: align, showPrevNextJumpers: showPrevNextJumpers = true, showQuickJumper: showQuickJumper, showLessItems: showLessItems, showTitle: showTitle = true, onShowSizeChange: onShowSizeChange = $046ea69c7c6e9f97$var$noop, locale: locale = (0, $f87ede0fd911792c$export$2e2bcd8739ae039), style: style, totalBoundaryShowSizeChanger: totalBoundaryShowSizeChanger = 50, disabled: disabled, simple: simple, showTotal: showTotal, showSizeChanger: showSizeChanger = total > totalBoundaryShowSizeChanger, sizeChangerRender: sizeChangerRender, pageSizeOptions: pageSizeOptions, itemRender: // render
    itemRender = $046ea69c7c6e9f97$var$defaultItemRender, jumpPrevIcon: jumpPrevIcon, jumpNextIcon: jumpNextIcon, prevIcon: prevIcon, nextIcon: nextIcon } = props;
    const paginationRef = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useRef(null);
    const [pageSize, setPageSize] = (0, $e18df22f16a16360$export$2e2bcd8739ae039)(defaultPageSize, pageSizeProp);
    const [internalCurrent, setCurrent] = (0, $e18df22f16a16360$export$2e2bcd8739ae039)(defaultCurrent, currentProp);
    const current = Math.max(1, Math.min(internalCurrent, $046ea69c7c6e9f97$var$calculatePage(undefined, pageSize, total)));
    const [internalInputVal, setInternalInputVal] = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useState(current);
    (0, $5E6i4.useEffect)(()=>{
        setInternalInputVal(current);
    }, [
        current
    ]);
    const hasOnChange = onChange !== $046ea69c7c6e9f97$var$noop;
    const hasCurrent = 'current' in props;
    const jumpPrevPage = Math.max(1, current - (showLessItems ? 3 : 5));
    const jumpNextPage = Math.min($046ea69c7c6e9f97$var$calculatePage(undefined, pageSize, total), current + (showLessItems ? 3 : 5));
    function getItemIcon(icon, label) {
        let iconNode = icon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("button", {
            type: "button",
            "aria-label": label,
            className: `${prefixCls}-item-link`
        });
        if (typeof icon === 'function') iconNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement(icon, props);
        return iconNode;
    }
    function getValidValue(e) {
        const inputValue = e.target.value;
        const allPages = $046ea69c7c6e9f97$var$calculatePage(undefined, pageSize, total);
        let value;
        if (inputValue === '') value = inputValue;
        else if (Number.isNaN(Number(inputValue))) value = internalInputVal;
        else if (inputValue >= allPages) value = allPages;
        else value = Number(inputValue);
        return value;
    }
    function isValid(page) {
        return $046ea69c7c6e9f97$var$isInteger(page) && page !== current && $046ea69c7c6e9f97$var$isInteger(total) && total > 0;
    }
    const shouldDisplayQuickJumper = total > pageSize ? showQuickJumper : false;
    /**
   * prevent "up arrow" key reseting cursor position within textbox
   * @see https://stackoverflow.com/a/1081114
   */ function handleKeyDown(event) {
        if (event.keyCode === (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).UP || event.keyCode === (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).DOWN) event.preventDefault();
    }
    function handleKeyUp(event) {
        const value = getValidValue(event);
        if (value !== internalInputVal) setInternalInputVal(value);
        switch(event.keyCode){
            case (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).ENTER:
                handleChange(value);
                break;
            case (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).UP:
                handleChange(value - 1);
                break;
            case (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).DOWN:
                handleChange(value + 1);
                break;
            default:
                break;
        }
    }
    function handleBlur(event) {
        handleChange(getValidValue(event));
    }
    function changePageSize(size) {
        const newCurrent = $046ea69c7c6e9f97$var$calculatePage(size, pageSize, total);
        const nextCurrent = current > newCurrent && newCurrent !== 0 ? newCurrent : current;
        setPageSize(size);
        setInternalInputVal(nextCurrent);
        onShowSizeChange?.(current, size);
        setCurrent(nextCurrent);
        onChange?.(nextCurrent, size);
    }
    function handleChange(page) {
        if (isValid(page) && !disabled) {
            const currentPage = $046ea69c7c6e9f97$var$calculatePage(undefined, pageSize, total);
            let newPage = page;
            if (page > currentPage) newPage = currentPage;
            else if (page < 1) newPage = 1;
            if (newPage !== internalInputVal) setInternalInputVal(newPage);
            setCurrent(newPage);
            onChange?.(newPage, pageSize);
            return newPage;
        }
        return current;
    }
    const hasPrev = current > 1;
    const hasNext = current < $046ea69c7c6e9f97$var$calculatePage(undefined, pageSize, total);
    function prevHandle() {
        if (hasPrev) handleChange(current - 1);
    }
    function nextHandle() {
        if (hasNext) handleChange(current + 1);
    }
    function jumpPrevHandle() {
        handleChange(jumpPrevPage);
    }
    function jumpNextHandle() {
        handleChange(jumpNextPage);
    }
    function runIfEnter(event, callback, ...restParams) {
        if (event.key === 'Enter' || event.charCode === (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).ENTER || event.keyCode === (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).ENTER) callback(...restParams);
    }
    function runIfEnterPrev(event) {
        runIfEnter(event, prevHandle);
    }
    function runIfEnterNext(event) {
        runIfEnter(event, nextHandle);
    }
    function runIfEnterJumpPrev(event) {
        runIfEnter(event, jumpPrevHandle);
    }
    function runIfEnterJumpNext(event) {
        runIfEnter(event, jumpNextHandle);
    }
    function renderPrev(prevPage) {
        const prevButton = itemRender(prevPage, 'prev', getItemIcon(prevIcon, 'prev page'));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).isValidElement(prevButton) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).cloneElement(prevButton, {
            disabled: !hasPrev
        }) : prevButton;
    }
    function renderNext(nextPage) {
        const nextButton = itemRender(nextPage, 'next', getItemIcon(nextIcon, 'next page'));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).isValidElement(nextButton) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).cloneElement(nextButton, {
            disabled: !hasNext
        }) : nextButton;
    }
    function handleGoTO(event) {
        if (event.type === 'click' || event.keyCode === (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).ENTER) handleChange(internalInputVal);
    }
    let jumpPrev = null;
    const dataOrAriaAttributeProps = (0, $78cde6532419ffca$export$2e2bcd8739ae039)(props, {
        aria: true,
        data: true
    });
    const totalText = showTotal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("li", {
        className: `${prefixCls}-total-text`
    }, showTotal(total, [
        total === 0 ? 0 : (current - 1) * pageSize + 1,
        current * pageSize > total ? total : current * pageSize
    ]));
    let jumpNext = null;
    const allPages = $046ea69c7c6e9f97$var$calculatePage(undefined, pageSize, total);
    // ================== Render ==================
    // When hideOnSinglePage is true and there is only 1 page, hide the pager
    if (hideOnSinglePage && total <= pageSize) return null;
    const pagerList = [];
    const pagerProps = {
        rootPrefixCls: prefixCls,
        onClick: handleChange,
        onKeyPress: runIfEnter,
        showTitle: showTitle,
        itemRender: itemRender,
        page: -1,
        className: paginationClassNames?.item,
        style: styles?.item
    };
    const prevPage = current - 1 > 0 ? current - 1 : 0;
    const nextPage = current + 1 < allPages ? current + 1 : allPages;
    const goButton = showQuickJumper && showQuickJumper.goButton;
    // ================== Simple ==================
    // FIXME: ts type
    const isReadOnly = typeof simple === 'object' ? simple.readOnly : !simple;
    let gotoButton = goButton;
    let simplePager = null;
    if (simple) {
        // ====== Simple quick jump ======
        if (goButton) {
            if (typeof goButton === 'boolean') gotoButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("button", {
                type: "button",
                onClick: handleGoTO,
                onKeyUp: handleGoTO
            }, locale.jump_to_confirm);
            else gotoButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("span", {
                onClick: handleGoTO,
                onKeyUp: handleGoTO
            }, goButton);
            gotoButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("li", {
                title: showTitle ? `${locale.jump_to}${current}/${allPages}` : null,
                className: `${prefixCls}-simple-pager`
            }, gotoButton);
        }
        simplePager = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("li", {
            title: showTitle ? `${current}/${allPages}` : null,
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-simple-pager`, paginationClassNames?.item),
            style: styles?.item
        }, isReadOnly ? internalInputVal : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("input", {
            type: "text",
            "aria-label": locale.jump_to,
            value: internalInputVal,
            disabled: disabled,
            onKeyDown: handleKeyDown,
            onKeyUp: handleKeyUp,
            onChange: handleKeyUp,
            onBlur: handleBlur,
            size: 3
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("span", {
            className: `${prefixCls}-slash`
        }, "/"), allPages);
    }
    // ====================== Normal ======================
    const pageBufferSize = showLessItems ? 1 : 2;
    if (allPages <= 3 + pageBufferSize * 2) {
        if (!allPages) pagerList.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $96124fb0b3db03dd$export$2e2bcd8739ae039), $046ea69c7c6e9f97$var$_extends({}, pagerProps, {
            key: "noPager",
            page: 1,
            className: `${prefixCls}-item-disabled`
        })));
        for(let i = 1; i <= allPages; i += 1)pagerList.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $96124fb0b3db03dd$export$2e2bcd8739ae039), $046ea69c7c6e9f97$var$_extends({}, pagerProps, {
            key: i,
            page: i,
            active: current === i
        })));
    } else {
        const prevItemTitle = showLessItems ? locale.prev_3 : locale.prev_5;
        const nextItemTitle = showLessItems ? locale.next_3 : locale.next_5;
        const jumpPrevContent = itemRender(jumpPrevPage, 'jump-prev', getItemIcon(jumpPrevIcon, 'prev page'));
        const jumpNextContent = itemRender(jumpNextPage, 'jump-next', getItemIcon(jumpNextIcon, 'next page'));
        if (showPrevNextJumpers) {
            jumpPrev = jumpPrevContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("li", {
                title: showTitle ? prevItemTitle : null,
                key: "prev",
                onClick: jumpPrevHandle,
                tabIndex: 0,
                onKeyDown: runIfEnterJumpPrev,
                className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-jump-prev`, {
                    [`${prefixCls}-jump-prev-custom-icon`]: !!jumpPrevIcon
                })
            }, jumpPrevContent) : null;
            jumpNext = jumpNextContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("li", {
                title: showTitle ? nextItemTitle : null,
                key: "next",
                onClick: jumpNextHandle,
                tabIndex: 0,
                onKeyDown: runIfEnterJumpNext,
                className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-jump-next`, {
                    [`${prefixCls}-jump-next-custom-icon`]: !!jumpNextIcon
                })
            }, jumpNextContent) : null;
        }
        let left = Math.max(1, current - pageBufferSize);
        let right = Math.min(current + pageBufferSize, allPages);
        if (current - 1 <= pageBufferSize) right = 1 + pageBufferSize * 2;
        if (allPages - current <= pageBufferSize) left = allPages - pageBufferSize * 2;
        const hasJumpPrev = !!jumpPrev && current - 1 >= pageBufferSize * 2 && current !== 3;
        const hasJumpNext = !!jumpNext && allPages - current >= pageBufferSize * 2 && current !== allPages - 2;
        if (!showLessItems && hasJumpPrev && right !== allPages) left += 1;
        if (!showLessItems && hasJumpNext && left !== 1) right -= 1;
        for(let i = left; i <= right; i += 1)pagerList.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $96124fb0b3db03dd$export$2e2bcd8739ae039), $046ea69c7c6e9f97$var$_extends({}, pagerProps, {
            key: i,
            page: i,
            active: current === i
        })));
        if (hasJumpPrev) {
            pagerList[0] = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).cloneElement(pagerList[0], {
                className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-item-after-jump-prev`, pagerList[0].props.className)
            });
            pagerList.unshift(jumpPrev);
        }
        if (hasJumpNext) {
            const lastOne = pagerList[pagerList.length - 1];
            pagerList[pagerList.length - 1] = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).cloneElement(lastOne, {
                className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-item-before-jump-next`, lastOne.props.className)
            });
            pagerList.push(jumpNext);
        }
        if (left !== 1) pagerList.unshift(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $96124fb0b3db03dd$export$2e2bcd8739ae039), $046ea69c7c6e9f97$var$_extends({}, pagerProps, {
            key: 1,
            page: 1
        })));
        if (right !== allPages) pagerList.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $96124fb0b3db03dd$export$2e2bcd8739ae039), $046ea69c7c6e9f97$var$_extends({}, pagerProps, {
            key: allPages,
            page: allPages
        })));
    }
    let prev = renderPrev(prevPage);
    if (prev) {
        const prevDisabled = !hasPrev || !allPages;
        prev = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("li", {
            title: showTitle ? locale.prev_page : null,
            onClick: prevHandle,
            tabIndex: prevDisabled ? null : 0,
            onKeyDown: runIfEnterPrev,
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-prev`, paginationClassNames?.item, {
                [`${prefixCls}-disabled`]: prevDisabled
            }),
            style: styles?.item,
            "aria-disabled": prevDisabled
        }, prev);
    }
    let next = renderNext(nextPage);
    if (next) {
        let nextDisabled, nextTabIndex;
        if (simple) {
            nextDisabled = !hasNext;
            nextTabIndex = hasPrev ? 0 : null;
        } else {
            nextDisabled = !hasNext || !allPages;
            nextTabIndex = nextDisabled ? null : 0;
        }
        next = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("li", {
            title: showTitle ? locale.next_page : null,
            onClick: nextHandle,
            tabIndex: nextTabIndex,
            onKeyDown: runIfEnterNext,
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-next`, paginationClassNames?.item, {
                [`${prefixCls}-disabled`]: nextDisabled
            }),
            style: styles?.item,
            "aria-disabled": nextDisabled
        }, next);
    }
    const cls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, className, {
        [`${prefixCls}-start`]: align === 'start',
        [`${prefixCls}-center`]: align === 'center',
        [`${prefixCls}-end`]: align === 'end',
        [`${prefixCls}-simple`]: simple,
        [`${prefixCls}-disabled`]: disabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("ul", $046ea69c7c6e9f97$var$_extends({
        className: cls,
        style: style,
        ref: paginationRef
    }, dataOrAriaAttributeProps), totalText, prev, simple ? simplePager : pagerList, next, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $3adc21240feb6180$export$2e2bcd8739ae039), {
        locale: locale,
        rootPrefixCls: prefixCls,
        disabled: disabled,
        selectPrefixCls: selectPrefixCls,
        changeSize: changePageSize,
        pageSize: pageSize,
        pageSizeOptions: pageSizeOptions,
        quickGo: shouldDisplayQuickJumper ? handleChange : null,
        goButton: gotoButton,
        showSizeChanger: showSizeChanger,
        sizeChangerRender: sizeChangerRender
    }));
};
var $046ea69c7c6e9f97$export$2e2bcd8739ae039 = $046ea69c7c6e9f97$var$Pagination;














var $5E6i4 = parcelRequire("5E6i4");


var $5E6i4 = parcelRequire("5E6i4");



var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");
const $09ec21b47d4e555d$export$9ea6397a890aa3e5 = (prefixCls, displayValues, allowClear, clearIcon, disabled = false, mergedSearchValue, mode)=>{
    // Convert boolean to object first
    const allowClearConfig = (0, $5E6i4.useMemo)(()=>{
        if (typeof allowClear === 'boolean') return {
            allowClear: allowClear
        };
        if (allowClear && typeof allowClear === 'object') return allowClear;
        return {
            allowClear: false
        };
    }, [
        allowClear
    ]);
    return (0, $5E6i4.useMemo)(()=>{
        const mergedAllowClear = !disabled && allowClearConfig.allowClear !== false && (displayValues.length || mergedSearchValue) && !(mode === 'combobox' && mergedSearchValue === '');
        return {
            allowClear: mergedAllowClear,
            clearIcon: mergedAllowClear ? allowClearConfig.clearIcon || clearIcon || "\xd7" : null,
            label: mergedAllowClear ? allowClearConfig.label ?? 'Clear' : ''
        };
    }, [
        allowClearConfig,
        clearIcon,
        disabled,
        displayValues.length,
        mergedSearchValue,
        mode
    ]);
};


/**
 * BaseSelect provide some parsed data into context.
 * You can use this hooks to get them.
 */ 
var $5E6i4 = parcelRequire("5E6i4");
const $f8edc52e57f85cd2$export$8234047c0aea33cf = /*#__PURE__*/ $5E6i4.createContext(null);
function $f8edc52e57f85cd2$export$2e2bcd8739ae039() {
    return $5E6i4.useContext($f8edc52e57f85cd2$export$8234047c0aea33cf);
}



var $5E6i4 = parcelRequire("5E6i4");
function $6e548070dde05c41$export$2e2bcd8739ae039(duration = 250) {
    const lockRef = $5E6i4.useRef(null);
    const timeoutRef = $5E6i4.useRef(null);
    // Clean up
    $5E6i4.useEffect(()=>()=>{
            window.clearTimeout(timeoutRef.current);
        }, []);
    function doLock(locked) {
        if (locked || lockRef.current === null) lockRef.current = locked;
        window.clearTimeout(timeoutRef.current);
        timeoutRef.current = window.setTimeout(()=>{
            lockRef.current = null;
        }, duration);
    }
    return [
        ()=>lockRef.current,
        doLock
    ];
}



var $5E6i4 = parcelRequire("5E6i4");

function $3ed06527d513db1e$export$4ac6a1c95deee4c5(elements, target) {
    return elements.filter((element)=>element).some((element)=>element.contains(target) || element === target);
}
function $3ed06527d513db1e$export$2e2bcd8739ae039(elements, open, triggerOpen, customizedTrigger) {
    const onGlobalMouseDown = (0, $68990f4402d2f009$export$2e2bcd8739ae039)((event)=>{
        // If trigger is customized, Trigger will take control of popupVisible
        if (customizedTrigger) return;
        let target = event.target;
        if (target.shadowRoot && event.composed) target = event.composedPath()[0] || target;
        if (event._ori_target) target = event._ori_target;
        if (open && // Marked by SelectInput mouseDown event
        !$3ed06527d513db1e$export$4ac6a1c95deee4c5(elements(), target)) // Should trigger close
        triggerOpen(false);
    });
    $5E6i4.useEffect(()=>{
        window.addEventListener('mousedown', onGlobalMouseDown);
        return ()=>window.removeEventListener('mousedown', onGlobalMouseDown);
    }, [
        onGlobalMouseDown
    ]);
}





var $5E6i4 = parcelRequire("5E6i4");
function $c4a7ac5582d8ea9a$var$_extends() {
    $c4a7ac5582d8ea9a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c4a7ac5582d8ea9a$var$_extends.apply(this, arguments);
}
const $c4a7ac5582d8ea9a$var$getBuiltInPlacements = (popupMatchSelectWidth)=>{
    // Enable horizontal overflow auto-adjustment when a custom dropdown width is provided
    const adjustX = popupMatchSelectWidth === true ? 0 : 1;
    return {
        bottomLeft: {
            points: [
                'tl',
                'bl'
            ],
            offset: [
                0,
                4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            },
            htmlRegion: 'scroll'
        },
        bottomRight: {
            points: [
                'tr',
                'br'
            ],
            offset: [
                0,
                4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            },
            htmlRegion: 'scroll'
        },
        topLeft: {
            points: [
                'bl',
                'tl'
            ],
            offset: [
                0,
                -4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            },
            htmlRegion: 'scroll'
        },
        topRight: {
            points: [
                'br',
                'tr'
            ],
            offset: [
                0,
                -4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            },
            htmlRegion: 'scroll'
        }
    };
};
const $c4a7ac5582d8ea9a$var$SelectTrigger = (props, ref)=>{
    const { prefixCls: prefixCls, disabled: disabled, visible: visible, children: children, popupElement: popupElement, animation: animation, transitionName: transitionName, popupStyle: popupStyle, popupClassName: popupClassName, direction: direction = 'ltr', placement: placement, builtinPlacements: builtinPlacements, popupMatchSelectWidth: popupMatchSelectWidth, popupRender: popupRender, popupAlign: popupAlign, getPopupContainer: getPopupContainer, empty: empty, onPopupVisibleChange: onPopupVisibleChange, onPopupMouseEnter: onPopupMouseEnter, onPopupMouseDown: onPopupMouseDown, onPopupBlur: onPopupBlur, ...restProps } = props;
    // We still use `dropdown` className to keep compatibility
    // This is used for:
    // 1. Styles
    // 2. Animation
    // 3. Theme customization
    // Please do not modify this since it's a breaking change
    const popupPrefixCls = `${prefixCls}-dropdown`;
    let popupNode = popupElement;
    if (popupRender) popupNode = popupRender(popupElement);
    const mergedBuiltinPlacements = $5E6i4.useMemo(()=>builtinPlacements || $c4a7ac5582d8ea9a$var$getBuiltInPlacements(popupMatchSelectWidth), [
        builtinPlacements,
        popupMatchSelectWidth
    ]);
    // ===================== Motion ======================
    const mergedTransitionName = animation ? `${popupPrefixCls}-${animation}` : transitionName;
    // =================== Popup Width ===================
    const isNumberPopupWidth = typeof popupMatchSelectWidth === 'number';
    const stretch = $5E6i4.useMemo(()=>{
        return popupMatchSelectWidth === false || isNumberPopupWidth ? 'minWidth' : 'width';
    }, [
        popupMatchSelectWidth,
        isNumberPopupWidth
    ]);
    let mergedPopupStyle = popupStyle;
    if (isNumberPopupWidth) mergedPopupStyle = {
        ...popupStyle,
        width: popupMatchSelectWidth
    };
    // ======================= Ref =======================
    const triggerPopupRef = $5E6i4.useRef(null);
    $5E6i4.useImperativeHandle(ref, ()=>({
            getPopupElement: ()=>triggerPopupRef.current?.popupElement
        }));
    return /*#__PURE__*/ $5E6i4.createElement((0, $5ff8ad2f21affc17$export$2e2bcd8739ae039), $c4a7ac5582d8ea9a$var$_extends({}, restProps, {
        showAction: onPopupVisibleChange ? [
            'click'
        ] : [],
        hideAction: onPopupVisibleChange ? [
            'click'
        ] : [],
        popupPlacement: placement || (direction === 'rtl' ? 'bottomRight' : 'bottomLeft'),
        builtinPlacements: mergedBuiltinPlacements,
        prefixCls: popupPrefixCls,
        popupMotion: {
            motionName: mergedTransitionName
        },
        popup: /*#__PURE__*/ $5E6i4.createElement("div", {
            onMouseEnter: onPopupMouseEnter,
            onMouseDown: onPopupMouseDown,
            onBlur: onPopupBlur
        }, popupNode),
        ref: triggerPopupRef,
        stretch: stretch,
        popupAlign: popupAlign,
        popupVisible: visible,
        getPopupContainer: getPopupContainer,
        popupClassName: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(popupClassName, {
            [`${popupPrefixCls}-empty`]: empty
        }),
        popupStyle: mergedPopupStyle,
        onPopupVisibleChange: onPopupVisibleChange
    }), children);
};
const $c4a7ac5582d8ea9a$var$RefSelectTrigger = /*#__PURE__*/ $5E6i4.forwardRef($c4a7ac5582d8ea9a$var$SelectTrigger);
var $c4a7ac5582d8ea9a$export$2e2bcd8739ae039 = $c4a7ac5582d8ea9a$var$RefSelectTrigger;



function $3ce246e399c3e069$var$getKey(data, index) {
    const { key: key } = data;
    let value;
    if ('value' in data) ({ value: value } = data);
    if (key !== null && key !== undefined) return key;
    if (value !== undefined) return value;
    return `rc-index-key-${index}`;
}
function $3ce246e399c3e069$export$be48fd776273e509(value) {
    return typeof value !== 'undefined' && !Number.isNaN(value);
}
function $3ce246e399c3e069$export$6c519d302dced239(fieldNames, childrenAsData) {
    const { label: label, value: value, options: options, groupLabel: groupLabel } = fieldNames || {};
    const mergedLabel = label || (childrenAsData ? 'children' : 'label');
    return {
        label: mergedLabel,
        value: value || 'value',
        options: options || 'options',
        groupLabel: groupLabel || mergedLabel
    };
}
function $3ce246e399c3e069$export$7baa7c13b358b002(options, { fieldNames: fieldNames, childrenAsData: childrenAsData } = {}) {
    const flattenList = [];
    const { label: fieldLabel, value: fieldValue, options: fieldOptions, groupLabel: groupLabel } = $3ce246e399c3e069$export$6c519d302dced239(fieldNames, false);
    function dig(list, isGroupOption) {
        if (!Array.isArray(list)) return;
        list.forEach((data)=>{
            if (isGroupOption || !(fieldOptions in data)) {
                const value = data[fieldValue];
                // Option
                flattenList.push({
                    key: $3ce246e399c3e069$var$getKey(data, flattenList.length),
                    groupOption: isGroupOption,
                    data: data,
                    label: data[fieldLabel],
                    value: value
                });
            } else {
                let grpLabel = data[groupLabel];
                if (grpLabel === undefined && childrenAsData) grpLabel = data.label;
                // Option Group
                flattenList.push({
                    key: $3ce246e399c3e069$var$getKey(data, flattenList.length),
                    group: true,
                    data: data,
                    label: grpLabel
                });
                dig(data[fieldOptions], true);
            }
        });
    }
    dig(options, false);
    return flattenList;
}
function $3ce246e399c3e069$export$d0b21b213c8c013c(option) {
    const newOption = {
        ...option
    };
    if (!('props' in newOption)) Object.defineProperty(newOption, 'props', {
        get () {
            (0, $f757b9ac02fa080d$export$2e2bcd8739ae039)(false, 'Return type is option instead of Option instance. Please read value directly instead of reading from `props`.');
            return newOption;
        }
    });
    return newOption;
}
const $3ce246e399c3e069$export$a09ca2a89e052b14 = (text, tokens, end)=>{
    if (!tokens || !tokens.length) return null;
    let match = false;
    const separate = (str, [token, ...restTokens])=>{
        if (!token) return [
            str
        ];
        const list = str.split(token);
        match = match || list.length > 1;
        return list.reduce((prevList, unitStr)=>[
                ...prevList,
                ...separate(unitStr, restTokens)
            ], []).filter(Boolean);
    };
    const list = separate(text, tokens);
    if (match) return typeof end !== 'undefined' ? list.slice(0, end) : list;
    else return null;
};



var $5E6i4 = parcelRequire("5E6i4");
function $67cbad3cc08c1d01$export$2e2bcd8739ae039(props) {
    const { visible: visible, values: values } = props;
    if (!visible) return null;
    // Only cut part of values since it's a screen reader
    const MAX_COUNT = 50;
    return /*#__PURE__*/ $5E6i4.createElement("span", {
        "aria-live": "polite",
        style: {
            width: 0,
            height: 0,
            position: 'absolute',
            overflow: 'hidden',
            opacity: 0
        }
    }, `${values.slice(0, MAX_COUNT).map(({ label: label, value: value })=>[
            'number',
            'string'
        ].includes(typeof label) ? label : value).join(', ')}`, values.length > MAX_COUNT ? ', ...' : null);
}




var $5E6i4 = parcelRequire("5E6i4");
const $a41696bb0f5549a4$var$internalMacroTask = (fn)=>{
    const channel = new MessageChannel();
    channel.port1.onmessage = fn;
    channel.port2.postMessage(null);
};
const $a41696bb0f5549a4$export$f1309b2412c6fa89 = (fn, times = 1)=>{
    if (times <= 0) {
        fn();
        return;
    }
    $a41696bb0f5549a4$var$internalMacroTask(()=>{
        $a41696bb0f5549a4$export$f1309b2412c6fa89(fn, times - 1);
    });
};
function $a41696bb0f5549a4$export$2e2bcd8739ae039(defaultOpen, propOpen, onOpen, postOpen) {
    // SSR not support Portal which means we need delay `open` for the first time render
    const [rendered, setRendered] = (0, $5E6i4.useState)(false);
    (0, $5E6i4.useEffect)(()=>{
        setRendered(true);
    }, []);
    const [stateOpen, internalSetOpen] = (0, $e18df22f16a16360$export$2e2bcd8739ae039)(defaultOpen, propOpen);
    // Lock for options update
    const [lock, setLock] = (0, $5E6i4.useState)(false);
    // During SSR, always return false for open state
    const ssrSafeOpen = rendered ? stateOpen : false;
    const mergedOpen = postOpen(ssrSafeOpen);
    const taskIdRef = (0, $5E6i4.useRef)(0);
    const triggerEvent = (0, $68990f4402d2f009$export$2e2bcd8739ae039)((nextOpen)=>{
        if (onOpen && mergedOpen !== nextOpen) onOpen(nextOpen);
        internalSetOpen(nextOpen);
    });
    const toggleOpen = (0, $68990f4402d2f009$export$2e2bcd8739ae039)((nextOpen, config = {})=>{
        const { cancelFun: cancelFun } = config;
        taskIdRef.current += 1;
        const id = taskIdRef.current;
        const nextOpenVal = typeof nextOpen === 'boolean' ? nextOpen : !mergedOpen;
        setLock(!nextOpenVal);
        function triggerUpdate() {
            if (// Always check if id is match
            id === taskIdRef.current && // Check if need to cancel
            !cancelFun?.()) {
                triggerEvent(nextOpenVal);
                setLock(false);
            }
        }
        // Weak update can be ignored
        if (nextOpenVal) triggerUpdate();
        else $a41696bb0f5549a4$export$f1309b2412c6fa89(()=>{
            triggerUpdate();
        });
    });
    return [
        ssrSafeOpen,
        mergedOpen,
        toggleOpen,
        lock
    ];
}



var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");
function $1fc6cbee5efa74a7$export$2e2bcd8739ae039(props) {
    const { children: children, ...restProps } = props;
    if (!children) return null;
    return /*#__PURE__*/ $5E6i4.createElement("div", restProps, children);
}



var $5E6i4 = parcelRequire("5E6i4");


var $5E6i4 = parcelRequire("5E6i4");


var $5E6i4 = parcelRequire("5E6i4");


var $5E6i4 = parcelRequire("5E6i4");
const $a0dedad8e6c3a502$var$SelectInputContext = /*#__PURE__*/ $5E6i4.createContext(null);
function $a0dedad8e6c3a502$export$7785dec5a5aec756() {
    return $5E6i4.useContext($a0dedad8e6c3a502$var$SelectInputContext);
}
var $a0dedad8e6c3a502$export$2e2bcd8739ae039 = $a0dedad8e6c3a502$var$SelectInputContext;




const $05b879d6c95f41e2$var$Input = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { onChange: onChange, onKeyDown: onKeyDown, onBlur: onBlur, style: style, syncWidth: syncWidth, value: value, className: className, autoComplete: autoComplete, ...restProps } = props;
    const { prefixCls: prefixCls, mode: mode, onSearch: onSearch, onSearchSubmit: onSearchSubmit, onInputBlur: onInputBlur, autoFocus: autoFocus, tokenWithEnter: tokenWithEnter, placeholder: placeholder, components: { input: InputComponent = 'input' } } = (0, $a0dedad8e6c3a502$export$7785dec5a5aec756)();
    const { id: id, classNames: classNames, styles: styles, open: open, activeDescendantId: activeDescendantId, role: role, disabled: disabled } = (0, $f8edc52e57f85cd2$export$2e2bcd8739ae039)() || {};
    const inputCls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-input`, classNames?.input, className);
    // Used to handle input method composition status
    const compositionStatusRef = $5E6i4.useRef(false);
    // Used to handle paste content, similar to original Selector implementation
    const pastedTextRef = $5E6i4.useRef(null);
    // ============================== Refs ==============================
    const inputRef = $5E6i4.useRef(null);
    $5E6i4.useImperativeHandle(ref, ()=>inputRef.current);
    // ============================== Data ==============================
    // Handle input changes
    const handleChange = (event)=>{
        let { value: nextVal } = event.target;
        // Handle pasted text with tokenWithEnter, similar to original Selector implementation
        if (tokenWithEnter && pastedTextRef.current && /[\r\n]/.test(pastedTextRef.current)) {
            // CRLF will be treated as a single space for input element
            const replacedText = pastedTextRef.current.replace(/[\r\n]+$/, '').replace(/\r\n/g, ' ').replace(/[\r\n]/g, ' ');
            nextVal = nextVal.replace(replacedText, pastedTextRef.current);
        }
        // Reset pasted text reference
        pastedTextRef.current = null;
        // Call onSearch callback
        if (onSearch) onSearch(nextVal, true, compositionStatusRef.current);
        // Call original onChange callback
        onChange?.(event);
    };
    // ============================ Keyboard ============================
    // Handle keyboard events
    const handleKeyDown = (event)=>{
        const { key: key } = event;
        const { value: nextVal } = event.currentTarget;
        // Handle Enter key submission - referencing Selector implementation
        if (key === 'Enter' && mode === 'tags' && !open && !compositionStatusRef.current && onSearchSubmit) onSearchSubmit(nextVal);
        // Call original onKeyDown callback
        onKeyDown?.(event);
    };
    // Handle blur events
    const handleBlur = (event)=>{
        // Call onInputBlur callback
        onInputBlur?.();
        // Call original onBlur callback
        onBlur?.(event);
    };
    // Handle input method composition start
    const handleCompositionStart = ()=>{
        compositionStatusRef.current = true;
    };
    // Handle input method composition end
    const handleCompositionEnd = (event)=>{
        compositionStatusRef.current = false;
        // Trigger search when input method composition ends, similar to original Selector
        if (mode !== 'combobox') {
            const { value: nextVal } = event.currentTarget;
            onSearch?.(nextVal, true, false);
        }
    };
    // Handle paste events to track pasted content
    const handlePaste = (event)=>{
        const { clipboardData: clipboardData } = event;
        const pastedValue = clipboardData?.getData('text');
        pastedTextRef.current = pastedValue || '';
    };
    // ============================= Width ==============================
    const [widthCssVar, setWidthCssVar] = $5E6i4.useState(undefined);
    // When syncWidth is enabled, adjust input width based on content
    (0, $518ae471aa4f03a7$export$2e2bcd8739ae039)(()=>{
        const input = inputRef.current;
        if (syncWidth && input) {
            input.style.width = '0px';
            const scrollWidth = input.scrollWidth;
            setWidthCssVar(scrollWidth);
            // Reset input style
            input.style.width = '';
        }
    }, [
        syncWidth,
        value
    ]);
    // ============================= Render =============================
    // Extract shared input props
    const sharedInputProps = {
        id: id,
        type: 'text',
        ...restProps,
        ref: inputRef,
        style: {
            ...styles?.input,
            ...style,
            '--select-input-width': widthCssVar
        },
        autoFocus: autoFocus,
        autoComplete: autoComplete || 'new-password',
        className: inputCls,
        disabled: disabled,
        value: value || '',
        onChange: handleChange,
        onKeyDown: handleKeyDown,
        onBlur: handleBlur,
        onPaste: handlePaste,
        onCompositionStart: handleCompositionStart,
        onCompositionEnd: handleCompositionEnd,
        // Accessibility attributes
        role: role || 'combobox',
        'aria-expanded': open || false,
        'aria-haspopup': 'listbox',
        'aria-owns': open ? `${id}_list` : undefined,
        'aria-autocomplete': 'list',
        'aria-controls': open ? `${id}_list` : undefined,
        'aria-activedescendant': open ? activeDescendantId : undefined
    };
    // Handle different InputComponent types
    if (/*#__PURE__*/ $5E6i4.isValidElement(InputComponent)) {
        // If InputComponent is a ReactElement, use cloneElement with merged props
        const existingProps = InputComponent.props || {};
        // Start with shared props as base
        const mergedProps = {
            placeholder: props.placeholder || placeholder,
            ...sharedInputProps,
            ...existingProps
        };
        // Batch update function calls
        Object.keys(existingProps).forEach((key)=>{
            const existingValue = existingProps[key];
            if (typeof existingValue === 'function') // Merge event handlers
            mergedProps[key] = (...args)=>{
                existingValue(...args);
                sharedInputProps[key]?.(...args);
            };
        });
        // Update ref
        mergedProps.ref = (0, $92c8c75386168ffc$export$ab452c34e8e05029)(InputComponent.ref, sharedInputProps.ref);
        return /*#__PURE__*/ $5E6i4.cloneElement(InputComponent, mergedProps);
    }
    // If InputComponent is a component type, render normally
    const Component = InputComponent;
    return /*#__PURE__*/ $5E6i4.createElement(Component, sharedInputProps);
});
var $05b879d6c95f41e2$export$2e2bcd8739ae039 = $05b879d6c95f41e2$var$Input;





var $5E6i4 = parcelRequire("5E6i4");



function $f0376e6fe4efcda6$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, placeholder: placeholder, displayValues: displayValues } = (0, $a0dedad8e6c3a502$export$7785dec5a5aec756)();
    const { classNames: classNames, styles: styles } = (0, $f8edc52e57f85cd2$export$2e2bcd8739ae039)();
    const { show: show = true } = props;
    if (displayValues.length) return null;
    return /*#__PURE__*/ $5E6i4.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-placeholder`, classNames?.placeholder),
        style: {
            ...show ? {} : {
                visibility: 'hidden'
            },
            ...styles?.placeholder
        }
    }, placeholder);
}



var $5E6i4 = parcelRequire("5E6i4");
// Use any here since we do not get the type during compilation
/**
 * SelectContext is only used for Select. BaseSelect should not consume this context.
 */ const $16a1c90a675c0816$var$SelectContext = /*#__PURE__*/ $5E6i4.createContext(null);
var $16a1c90a675c0816$export$2e2bcd8739ae039 = $16a1c90a675c0816$var$SelectContext;


function $b61800e39bc1fac7$export$45b10814cc054894(value) {
    if (Array.isArray(value)) return value;
    return value !== undefined ? [
        value
    ] : [];
}
const $b61800e39bc1fac7$export$7383f122bf48ec30 = typeof window !== 'undefined' && window.document && window.document.documentElement;
const $b61800e39bc1fac7$export$df7146797a248522 = $b61800e39bc1fac7$export$7383f122bf48ec30;
function $b61800e39bc1fac7$export$96bdbc84526f3739(value) {
    return value !== undefined && value !== null;
}
function $b61800e39bc1fac7$export$9d186c3672bb89c6(value) {
    return !value && value !== 0;
}
function $b61800e39bc1fac7$var$isTitleType(title) {
    return [
        'string',
        'number'
    ].includes(typeof title);
}
function $b61800e39bc1fac7$export$70d1bf7729efff40(item) {
    let title = undefined;
    if (item) {
        if ($b61800e39bc1fac7$var$isTitleType(item.title)) title = item.title.toString();
        else if ($b61800e39bc1fac7$var$isTitleType(item.label)) title = item.label.toString();
    }
    return title;
}


function $421cccf8e153499a$var$_extends() {
    $421cccf8e153499a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $421cccf8e153499a$var$_extends.apply(this, arguments);
}
const $421cccf8e153499a$var$SingleContent = /*#__PURE__*/ $5E6i4.forwardRef(({ inputProps: inputProps }, ref)=>{
    const { prefixCls: prefixCls, searchValue: searchValue, activeValue: activeValue, displayValues: displayValues, maxLength: maxLength, mode: mode, components: components } = (0, $a0dedad8e6c3a502$export$7785dec5a5aec756)();
    const { triggerOpen: triggerOpen, title: rootTitle, showSearch: showSearch, classNames: classNames, styles: styles } = (0, $f8edc52e57f85cd2$export$2e2bcd8739ae039)();
    const selectContext = $5E6i4.useContext((0, $16a1c90a675c0816$export$2e2bcd8739ae039));
    const [inputChanged, setInputChanged] = $5E6i4.useState(false);
    const combobox = mode === 'combobox';
    const displayValue = displayValues[0];
    // Implement the same logic as the old SingleSelector
    const mergedSearchValue = $5E6i4.useMemo(()=>{
        if (combobox && activeValue && !inputChanged && triggerOpen) return activeValue;
        return showSearch ? searchValue : '';
    }, [
        combobox,
        activeValue,
        inputChanged,
        triggerOpen,
        searchValue,
        showSearch
    ]);
    const [optionClassName, optionStyle, optionTitle, hasOptionStyle] = $5E6i4.useMemo(()=>{
        let className;
        let style;
        let titleValue;
        if (displayValue && selectContext?.flattenOptions) {
            const option = selectContext.flattenOptions.find((opt)=>opt.value === displayValue.value);
            if (option?.data) {
                className = option.data.className;
                style = option.data.style;
                titleValue = (0, $b61800e39bc1fac7$export$70d1bf7729efff40)(option.data);
            }
        }
        if (displayValue && !titleValue) titleValue = (0, $b61800e39bc1fac7$export$70d1bf7729efff40)(displayValue);
        if (rootTitle !== undefined) titleValue = rootTitle;
        const nextHasStyle = !!className || !!style;
        return [
            className,
            style,
            titleValue,
            nextHasStyle
        ];
    }, [
        displayValue,
        selectContext?.flattenOptions,
        rootTitle
    ]);
    $5E6i4.useEffect(()=>{
        if (combobox) setInputChanged(false);
    }, [
        combobox,
        activeValue
    ]);
    // ========================== Render ==========================
    const showHasValueCls = displayValue && displayValue.label !== null && displayValue.label !== undefined && String(displayValue.label).trim() !== '';
    // Render value
    // Only render value when not using custom input in combobox mode
    const shouldRenderValue = !(combobox && components?.input);
    const renderValue = shouldRenderValue ? displayValue ? hasOptionStyle ? /*#__PURE__*/ $5E6i4.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-content-value`, optionClassName),
        style: {
            ...mergedSearchValue ? {
                visibility: 'hidden'
            } : {},
            ...optionStyle
        },
        title: optionTitle
    }, displayValue.label) : displayValue.label : /*#__PURE__*/ $5E6i4.createElement((0, $f0376e6fe4efcda6$export$2e2bcd8739ae039), {
        show: !mergedSearchValue
    }) : null;
    // Render
    return /*#__PURE__*/ $5E6i4.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-content`, showHasValueCls && `${prefixCls}-content-has-value`, mergedSearchValue && `${prefixCls}-content-has-search-value`, hasOptionStyle && `${prefixCls}-content-has-option-style`, classNames?.content),
        style: styles?.content,
        title: hasOptionStyle ? undefined : optionTitle
    }, renderValue, /*#__PURE__*/ $5E6i4.createElement((0, $05b879d6c95f41e2$export$2e2bcd8739ae039), $421cccf8e153499a$var$_extends({
        ref: ref
    }, inputProps, {
        value: mergedSearchValue,
        maxLength: mode === 'combobox' ? maxLength : undefined,
        onChange: (e)=>{
            setInputChanged(true);
            inputProps.onChange?.(e);
        }
    })));
});
var $421cccf8e153499a$export$2e2bcd8739ae039 = $421cccf8e153499a$var$SingleContent;



var $5E6i4 = parcelRequire("5E6i4");





var $5E6i4 = parcelRequire("5E6i4");

/**
 * Small wrapper for Select icons (clear/arrow/etc.).
 * Prevents default mousedown to avoid blurring or caret moves, and
 * renders a custom icon or a fallback icon span.
 *
 * DOM structure:
 * <span className={className} ...>
 *   { icon || <span className={`${className}-icon`}>{children}</span> }
 * </span>
 */ const $67d82b95e172ce8b$var$TransBtn = (props)=>{
    const { className: className, style: style, customizeIcon: customizeIcon, customizeIconProps: customizeIconProps, children: children, onMouseDown: onMouseDown, onClick: onClick } = props;
    const icon = typeof customizeIcon === 'function' ? customizeIcon(customizeIconProps) : customizeIcon;
    return /*#__PURE__*/ $5E6i4.createElement("span", {
        className: className,
        onMouseDown: (event)=>{
            event.preventDefault();
            onMouseDown?.(event);
        },
        style: {
            userSelect: 'none',
            WebkitUserSelect: 'none',
            ...style
        },
        unselectable: "on",
        onClick: onClick,
        "aria-hidden": true
    }, icon !== undefined ? icon : /*#__PURE__*/ $5E6i4.createElement("span", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(className.split(/\s+/).map((cls)=>`${cls}-icon`))
    }, children));
};
var $67d82b95e172ce8b$export$2e2bcd8739ae039 = $67d82b95e172ce8b$var$TransBtn;





function $9dfc756246d1c8fc$var$_extends() {
    $9dfc756246d1c8fc$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9dfc756246d1c8fc$var$_extends.apply(this, arguments);
}
function $9dfc756246d1c8fc$var$itemKey(value) {
    return value.key ?? value.value;
}
const $9dfc756246d1c8fc$var$onPreventMouseDown = (event)=>{
    event.preventDefault();
    event.stopPropagation();
};
var $9dfc756246d1c8fc$export$2e2bcd8739ae039 = /*#__PURE__*/ $5E6i4.forwardRef(function MultipleContent({ inputProps: inputProps }, ref) {
    const { prefixCls: prefixCls, displayValues: displayValues, searchValue: searchValue, mode: mode, onSelectorRemove: onSelectorRemove, removeIcon: removeIconFromContext } = (0, $a0dedad8e6c3a502$export$7785dec5a5aec756)();
    const { disabled: disabled, showSearch: showSearch, triggerOpen: triggerOpen, rawOpen: rawOpen, toggleOpen: toggleOpen, autoClearSearchValue: autoClearSearchValue, tagRender: tagRenderFromContext, maxTagPlaceholder: maxTagPlaceholderFromContext, maxTagTextLength: maxTagTextLength, maxTagCount: maxTagCount, classNames: classNames, styles: styles } = (0, $f8edc52e57f85cd2$export$2e2bcd8739ae039)();
    const selectionItemPrefixCls = `${prefixCls}-selection-item`;
    // ===================== Search ======================
    // Apply autoClearSearchValue logic: when dropdown is closed and autoClearSearchValue is not false (default true), clear search value
    // Use rawOpen to avoid clearing search when emptyListContent blocks open
    let computedSearchValue = searchValue;
    if (!rawOpen && mode === 'multiple' && autoClearSearchValue !== false) computedSearchValue = '';
    const inputValue = showSearch ? computedSearchValue || '' : '';
    const inputEditable = showSearch && !disabled;
    // Props from context with safe defaults
    const removeIcon = removeIconFromContext ?? "\xd7";
    const maxTagPlaceholder = maxTagPlaceholderFromContext ?? ((omittedValues)=>`+ ${omittedValues.length} ...`);
    const tagRender = tagRenderFromContext;
    const onToggleOpen = (newOpen)=>{
        toggleOpen(newOpen);
    };
    const onRemove = (value)=>{
        onSelectorRemove?.(value);
    };
    // ======================== Item ========================
    // >>> Render Selector Node. Includes Item & Rest
    const defaultRenderSelector = (item, content, itemDisabled, closable, onClose)=>/*#__PURE__*/ $5E6i4.createElement("span", {
            title: (0, $b61800e39bc1fac7$export$70d1bf7729efff40)(item),
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(selectionItemPrefixCls, {
                [`${selectionItemPrefixCls}-disabled`]: itemDisabled
            }, classNames?.item),
            style: styles?.item
        }, /*#__PURE__*/ $5E6i4.createElement("span", {
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${selectionItemPrefixCls}-content`, classNames?.itemContent),
            style: styles?.itemContent
        }, content), closable && /*#__PURE__*/ $5E6i4.createElement((0, $67d82b95e172ce8b$export$2e2bcd8739ae039), {
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${selectionItemPrefixCls}-remove`, classNames?.itemRemove),
            style: styles?.itemRemove,
            onMouseDown: $9dfc756246d1c8fc$var$onPreventMouseDown,
            onClick: onClose,
            customizeIcon: removeIcon
        }, "\xD7"));
    const customizeRenderSelector = (value, content, itemDisabled, closable, onClose, isMaxTag, info)=>{
        const onMouseDown = (e)=>{
            $9dfc756246d1c8fc$var$onPreventMouseDown(e);
            onToggleOpen(!triggerOpen);
        };
        return /*#__PURE__*/ $5E6i4.createElement("span", {
            onMouseDown: onMouseDown
        }, tagRender({
            label: content,
            value: value,
            index: info?.index,
            disabled: itemDisabled,
            closable: closable,
            onClose: onClose,
            isMaxTag: !!isMaxTag
        }));
    };
    // ====================== Overflow ======================
    const renderItem = (valueItem, info)=>{
        const { disabled: itemDisabled, label: label, value: value } = valueItem;
        const closable = !disabled && !itemDisabled;
        let displayLabel = label;
        if (typeof maxTagTextLength === 'number') {
            if (typeof label === 'string' || typeof label === 'number') {
                const strLabel = String(displayLabel);
                if (strLabel.length > maxTagTextLength) displayLabel = `${strLabel.slice(0, maxTagTextLength)}...`;
            }
        }
        const onClose = (event)=>{
            if (event) event.stopPropagation();
            onRemove(valueItem);
        };
        return typeof tagRender === 'function' ? customizeRenderSelector(value, displayLabel, itemDisabled, closable, onClose, undefined, info) : defaultRenderSelector(valueItem, displayLabel, itemDisabled, closable, onClose);
    };
    const renderRest = (omittedValues)=>{
        // https://github.com/ant-design/ant-design/issues/48930
        if (!displayValues.length) return null;
        const content = typeof maxTagPlaceholder === 'function' ? maxTagPlaceholder(omittedValues) : maxTagPlaceholder;
        return typeof tagRender === 'function' ? customizeRenderSelector(undefined, content, false, false, undefined, true) : defaultRenderSelector({
            title: content
        }, content, false);
    };
    // ======================= Render =======================
    return /*#__PURE__*/ $5E6i4.createElement((0, $5dd265eef1cc92c5$export$2e2bcd8739ae039), {
        prefixCls: `${prefixCls}-content`,
        className: classNames?.content,
        style: styles?.content,
        prefix: !displayValues.length && !inputValue && /*#__PURE__*/ $5E6i4.createElement((0, $f0376e6fe4efcda6$export$2e2bcd8739ae039), null),
        data: displayValues,
        renderItem: renderItem,
        renderRest: renderRest,
        suffix: /*#__PURE__*/ $5E6i4.createElement((0, $05b879d6c95f41e2$export$2e2bcd8739ae039), $9dfc756246d1c8fc$var$_extends({
            ref: ref,
            disabled: disabled,
            readOnly: !inputEditable
        }, inputProps, {
            value: inputValue || '',
            syncWidth: true
        })),
        itemKey: $9dfc756246d1c8fc$var$itemKey,
        maxCount: maxTagCount
    });
});




const $0a0785a3a5cb9ce8$var$SelectContent = /*#__PURE__*/ $5E6i4.forwardRef(function SelectContent(_, ref) {
    const { multiple: multiple, onInputKeyDown: onInputKeyDown, tabIndex: tabIndex } = (0, $a0dedad8e6c3a502$export$7785dec5a5aec756)();
    const baseProps = (0, $f8edc52e57f85cd2$export$2e2bcd8739ae039)();
    const { showSearch: showSearch } = baseProps;
    const ariaProps = (0, $78cde6532419ffca$export$2e2bcd8739ae039)(baseProps, {
        aria: true
    });
    const sharedInputProps = {
        ...ariaProps,
        onKeyDown: onInputKeyDown,
        readOnly: !showSearch,
        tabIndex: tabIndex
    };
    if (multiple) return /*#__PURE__*/ $5E6i4.createElement((0, $9dfc756246d1c8fc$export$2e2bcd8739ae039), {
        ref: ref,
        inputProps: sharedInputProps
    });
    return /*#__PURE__*/ $5E6i4.createElement((0, $421cccf8e153499a$export$2e2bcd8739ae039), {
        ref: ref,
        inputProps: sharedInputProps
    });
});
var $0a0785a3a5cb9ce8$export$2e2bcd8739ae039 = $0a0785a3a5cb9ce8$var$SelectContent;






function $00a5c4cee6f3de1e$export$48ac81d4a07c29c(currentKeyCode) {
    return(// Undefined for Edge bug:
    // https://github.com/ant-design/ant-design/issues/51292
    currentKeyCode && // Other keys
    ![
        // System function button
        (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).ESC,
        (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).SHIFT,
        (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).BACKSPACE,
        (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).TAB,
        (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).WIN_KEY,
        (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).ALT,
        (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).META,
        (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).WIN_KEY_RIGHT,
        (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).CTRL,
        (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).SEMICOLON,
        (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).EQUALS,
        (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).CAPS_LOCK,
        (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).CONTEXT_MENU,
        // Arrow keys - should not trigger open when navigating in input
        (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).UP,
        // KeyCode.DOWN,
        (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).LEFT,
        (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).RIGHT,
        // F1-F12
        (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).F1,
        (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).F2,
        (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).F3,
        (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).F4,
        (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).F5,
        (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).F6,
        (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).F7,
        (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).F8,
        (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).F9,
        (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).F10,
        (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).F11,
        (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).F12
    ].includes(currentKeyCode));
}



function $779d8a5e82bddc46$var$_extends() {
    $779d8a5e82bddc46$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $779d8a5e82bddc46$var$_extends.apply(this, arguments);
}
const $779d8a5e82bddc46$var$DEFAULT_OMIT_PROPS = [
    'value',
    'onChange',
    'removeIcon',
    'placeholder',
    'maxTagCount',
    'maxTagTextLength',
    'maxTagPlaceholder',
    'choiceTransitionName',
    'onInputKeyDown',
    'onPopupScroll',
    'tabIndex',
    'activeValue',
    'onSelectorRemove',
    'focused'
];
var $779d8a5e82bddc46$export$2e2bcd8739ae039 = /*#__PURE__*/ $5E6i4.forwardRef(function SelectInput(props, ref) {
    const { prefixCls: // Style
    prefixCls, className: className, style: style, prefix: // UI
    prefix, suffix: suffix, clearIcon: clearIcon, clearLabel: clearLabel, children: children, multiple: // Data
    multiple, displayValues: displayValues, placeholder: placeholder, mode: mode, searchValue: // Search
    searchValue, onSearch: onSearch, onSearchSubmit: onSearchSubmit, onInputBlur: onInputBlur, maxLength: // Input
    maxLength, autoFocus: autoFocus, onMouseDown: // Events
    onMouseDown, onClearMouseDown: onClearMouseDown, onInputKeyDown: onInputKeyDown, onSelectorRemove: onSelectorRemove, tokenWithEnter: // Token handling
    tokenWithEnter, components: // Components
    components, ...restProps } = props;
    const { triggerOpen: triggerOpen, toggleOpen: toggleOpen, showSearch: showSearch, disabled: disabled, loading: loading, classNames: classNames, styles: styles } = (0, $f8edc52e57f85cd2$export$2e2bcd8739ae039)();
    const rootRef = $5E6i4.useRef(null);
    const inputRef = $5E6i4.useRef(null);
    // Handle keyboard events similar to original Selector
    const onInternalInputKeyDown = (0, $68990f4402d2f009$export$2e2bcd8739ae039)((event)=>{
        const { which: which } = event;
        // Compatible with multiple lines in TextArea
        const isTextAreaElement = inputRef.current instanceof HTMLTextAreaElement;
        // Prevent default behavior for up/down arrows when dropdown is open
        if (!isTextAreaElement && triggerOpen && (which === (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).UP || which === (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).DOWN)) event.preventDefault();
        // Call the original onInputKeyDown callback
        if (onInputKeyDown) onInputKeyDown(event);
        // Move within the text box for TextArea
        if (isTextAreaElement && !triggerOpen && ~[
            (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).UP,
            (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).DOWN,
            (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).LEFT,
            (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).RIGHT
        ].indexOf(which)) return;
        // Open dropdown when a valid open key is pressed
        const isModifier = event.ctrlKey || event.altKey || event.metaKey;
        if (!isModifier && (0, $00a5c4cee6f3de1e$export$48ac81d4a07c29c)(which)) toggleOpen(true);
    });
    // ====================== Refs ======================
    $5E6i4.useImperativeHandle(ref, ()=>{
        return {
            focus: (options)=>{
                // Focus the inner input if available, otherwise fall back to root div.
                (inputRef.current || rootRef.current).focus?.(options);
            },
            blur: ()=>{
                (inputRef.current || rootRef.current).blur?.();
            },
            // Use getDOM to handle nested nativeElement structure (e.g., when RootComponent is antd Input)
            nativeElement: (0, $b1bf69966442e513$export$9aa546fdc20ae5b3)(rootRef.current)
        };
    });
    // ====================== Open ======================
    const onInternalMouseDown = (0, $68990f4402d2f009$export$2e2bcd8739ae039)((event)=>{
        if (!disabled) {
            const inputDOM = (0, $b1bf69966442e513$export$9aa546fdc20ae5b3)(inputRef.current);
            // https://github.com/ant-design/ant-design/issues/56002
            // Tell `useSelectTriggerControl` to ignore this event
            // When icon is dynamic render, the parentNode will miss
            // so we need to mark the event directly
            event.nativeEvent._ori_target = inputDOM;
            const isClickOnInput = inputDOM === event.target || inputDOM?.contains(event.target);
            if (inputDOM && !isClickOnInput) event.preventDefault();
            // Check if we should prevent closing when clicking on selector
            // Don't close if: open && not multiple && (combobox mode || showSearch)
            const shouldPreventCloseOnSingle = triggerOpen && !multiple && (mode === 'combobox' || showSearch);
            // Don't close if: open && multiple && click on input
            const shouldPreventCloseOnMultipleInput = triggerOpen && multiple && isClickOnInput;
            const shouldPreventClose = shouldPreventCloseOnSingle || shouldPreventCloseOnMultipleInput;
            if (!event.nativeEvent._select_lazy) {
                inputRef.current?.focus();
                // Only toggle open if we should not prevent close
                if (!shouldPreventClose) toggleOpen();
            } else if (triggerOpen && !multiple) // Lazy should also close when click clear icon in single select.
            toggleOpen(false);
        }
        onMouseDown?.(event);
    });
    // ===================== Clear ======================
    // The clear button lives inside the select root, whose `onKeyDown` treats
    // Enter/Space as "open the dropdown" and calls `preventDefault` on them.
    // That would cancel the native button activation, so keyboard users would
    // never get the `click` event which performs the clear. Keep the activation
    // keys scoped to the button itself.
    const onClearKeyDown = (event)=>{
        if (event.key === 'Enter' || event.key === ' ') event.stopPropagation();
    };
    // =================== Components ===================
    const { root: RootComponent } = components;
    // ===================== Render =====================
    const domProps = (0, $48bd91d9f828de66$export$2e2bcd8739ae039)(restProps, $779d8a5e82bddc46$var$DEFAULT_OMIT_PROPS);
    const ariaProps = (0, $78cde6532419ffca$export$2e2bcd8739ae039)(domProps, {
        aria: true
    });
    const ariaKeys = Object.keys(ariaProps);
    // Create context value with wrapped callbacks
    const contextValue = {
        ...props,
        onInputKeyDown: onInternalInputKeyDown
    };
    if (RootComponent) {
        const originProps = RootComponent.props || {};
        const mergedProps = {
            ...originProps,
            ...domProps
        };
        Object.keys(originProps).forEach((key)=>{
            const originVal = originProps[key];
            const domVal = domProps[key];
            if (typeof originVal === 'function' && typeof domVal === 'function') mergedProps[key] = (...args)=>{
                domVal(...args);
                originVal(...args);
            };
        });
        if (/*#__PURE__*/ $5E6i4.isValidElement(RootComponent)) return /*#__PURE__*/ $5E6i4.cloneElement(RootComponent, {
            ...mergedProps,
            ref: (0, $92c8c75386168ffc$export$ab452c34e8e05029)(RootComponent.ref, rootRef)
        });
        return /*#__PURE__*/ $5E6i4.createElement(RootComponent, $779d8a5e82bddc46$var$_extends({}, mergedProps, {
            ref: rootRef
        }));
    }
    return /*#__PURE__*/ $5E6i4.createElement((0, $a0dedad8e6c3a502$export$2e2bcd8739ae039).Provider, {
        value: contextValue
    }, /*#__PURE__*/ $5E6i4.createElement("div", $779d8a5e82bddc46$var$_extends({}, (0, $48bd91d9f828de66$export$2e2bcd8739ae039)(domProps, ariaKeys), {
        // Style
        ref: rootRef,
        className: className,
        style: style,
        onMouseDown: onInternalMouseDown
    }), /*#__PURE__*/ $5E6i4.createElement((0, $1fc6cbee5efa74a7$export$2e2bcd8739ae039), {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-prefix`, classNames?.prefix),
        style: styles?.prefix
    }, prefix), /*#__PURE__*/ $5E6i4.createElement((0, $0a0785a3a5cb9ce8$export$2e2bcd8739ae039), {
        ref: inputRef
    }), /*#__PURE__*/ $5E6i4.createElement((0, $1fc6cbee5efa74a7$export$2e2bcd8739ae039), {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-suffix`, {
            [`${prefixCls}-suffix-loading`]: loading
        }, classNames?.suffix),
        style: styles?.suffix
    }, suffix), clearIcon && /*#__PURE__*/ $5E6i4.createElement("button", {
        type: "button",
        "aria-label": clearLabel,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-clear`, classNames?.clear),
        style: styles?.clear,
        onMouseDown: (e)=>{
            // Keep focus on the input and mark the native event so the root
            // `onInternalMouseDown` handler does not open the dropdown.
            // This must run on mousedown because the root handler fires
            // before the button's onClick.
            e.preventDefault();
            e.nativeEvent._select_lazy = true;
        },
        onKeyDown: onClearKeyDown,
        onClick: onClearMouseDown
    }, clearIcon), children));
});



var $5E6i4 = parcelRequire("5E6i4");
function $ed52dac55bcb96a6$export$2e2bcd8739ae039(components, getInputElement, getRawInputElement) {
    return $5E6i4.useMemo(()=>{
        let { root: root, input: input } = components || {};
        // root: getRawInputElement
        if (getRawInputElement) root = getRawInputElement();
        // input: getInputElement
        if (getInputElement) input = getInputElement();
        return {
            root: root,
            input: input
        };
    }, [
        components,
        getInputElement,
        getRawInputElement
    ]);
}


function $32059bf47b698759$var$_extends() {
    $32059bf47b698759$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $32059bf47b698759$var$_extends.apply(this, arguments);
}
const $32059bf47b698759$export$7f654ad2a77ad2ac = (mode)=>mode === 'tags' || mode === 'multiple';
const $32059bf47b698759$var$BaseSelect = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { id: id, prefixCls: prefixCls, className: className, styles: styles, classNames: classNames, showSearch: showSearch, tagRender: tagRender, showScrollBar: showScrollBar = 'optional', direction: direction, omitDomProps: omitDomProps, displayValues: // Value
    displayValues, onDisplayValuesChange: onDisplayValuesChange, emptyOptions: emptyOptions, notFoundContent: notFoundContent = 'Not Found', onClear: onClear, maxCount: maxCount, placeholder: placeholder, mode: // Mode
    mode, disabled: // Status
    disabled, loading: loading, getInputElement: // Customize Input
    getInputElement, getRawInputElement: getRawInputElement, open: // Open
    open, defaultOpen: defaultOpen, onPopupVisibleChange: onPopupVisibleChange, activeValue: // Active
    activeValue, onActiveValueChange: onActiveValueChange, activeDescendantId: activeDescendantId, searchValue: // Search
    searchValue, autoClearSearchValue: autoClearSearchValue, onSearch: onSearch, onSearchSplit: onSearchSplit, tokenSeparators: tokenSeparators, allowClear: // Icons
    allowClear, prefix: prefix, suffix: suffix, suffixIcon: suffixIcon, clearIcon: clearIcon, OptionList: // Dropdown
    OptionList, animation: animation, transitionName: transitionName, popupStyle: popupStyle, popupClassName: popupClassName, popupMatchSelectWidth: popupMatchSelectWidth, popupRender: popupRender, popupAlign: popupAlign, placement: placement, builtinPlacements: builtinPlacements, getPopupContainer: getPopupContainer, showAction: // Focus
    showAction = [], onFocus: onFocus, onBlur: onBlur, onKeyUp: // Rest Events
    onKeyUp, onKeyDown: onKeyDown, onMouseDown: onMouseDown, components: // Components
    components, // Rest Props
    ...restProps } = props;
    // ============================== MISC ==============================
    const multiple = $32059bf47b698759$export$7f654ad2a77ad2ac(mode);
    // ============================== Refs ==============================
    const containerRef = $5E6i4.useRef(null);
    const triggerRef = $5E6i4.useRef(null);
    const listRef = $5E6i4.useRef(null);
    /** Used for component focused management */ const [focused, setFocused] = $5E6i4.useState(false);
    // =========================== Imperative ===========================
    $5E6i4.useImperativeHandle(ref, ()=>({
            focus: containerRef.current?.focus,
            blur: containerRef.current?.blur,
            scrollTo: (arg)=>listRef.current?.scrollTo(arg),
            nativeElement: (0, $b1bf69966442e513$export$9aa546fdc20ae5b3)(containerRef.current)
        }));
    // =========================== Components ===========================
    const mergedComponents = (0, $ed52dac55bcb96a6$export$2e2bcd8739ae039)(components, getInputElement, getRawInputElement);
    // ========================== Search Value ==========================
    const mergedSearchValue = $5E6i4.useMemo(()=>{
        if (mode !== 'combobox') return searchValue;
        const val = displayValues[0]?.value;
        return typeof val === 'string' || typeof val === 'number' ? String(val) : '';
    }, [
        searchValue,
        mode,
        displayValues
    ]);
    // ========================== Custom Input ==========================
    // Only works in `combobox`
    const customizeInputElement = mode === 'combobox' && typeof getInputElement === 'function' && getInputElement() || null;
    // ============================== Open ==============================
    // Not trigger `open` when `notFoundContent` is empty
    const emptyListContent = !notFoundContent && emptyOptions;
    const [rawOpen, mergedOpen, triggerOpen, lockOptions] = (0, $a41696bb0f5549a4$export$2e2bcd8739ae039)(defaultOpen || false, open, onPopupVisibleChange, (nextOpen)=>disabled || emptyListContent ? false : nextOpen);
    // ============================= Search =============================
    const tokenWithEnter = $5E6i4.useMemo(()=>typeof tokenSeparators === 'function' || (tokenSeparators || []).some((tokenSeparator)=>[
                '\n',
                '\r\n'
            ].includes(tokenSeparator)), [
        tokenSeparators
    ]);
    const splitByTokenSeparators = $5E6i4.useMemo(()=>{
        if (typeof tokenSeparators === 'function') return (input, end)=>{
            const tokens = tokenSeparators(input);
            const isUnchanged = Array.isArray(tokens) && tokens.length === 1 && tokens[0] === input;
            if (!Array.isArray(tokens) || !tokens.length || isUnchanged) return null;
            return typeof end !== 'undefined' ? tokens.slice(0, end) : tokens;
        };
        return (input, end)=>(0, $3ce246e399c3e069$export$a09ca2a89e052b14)(input, tokenSeparators, end);
    }, [
        tokenSeparators
    ]);
    const onInternalSearch = (searchText, fromTyping, isCompositing)=>{
        if (multiple && (0, $3ce246e399c3e069$export$be48fd776273e509)(maxCount) && displayValues.length >= maxCount) return;
        let ret = true;
        let newSearchText = searchText;
        onActiveValueChange?.(null);
        const cap = (0, $3ce246e399c3e069$export$be48fd776273e509)(maxCount) ? maxCount - displayValues.length : undefined;
        const patchLabels = isCompositing ? null : splitByTokenSeparators(searchText, cap);
        // Ignore combobox since it's not split-able
        if (mode !== 'combobox' && patchLabels) {
            newSearchText = '';
            onSearchSplit?.(patchLabels);
            // Should close when paste finish
            triggerOpen(false);
            // Tell Selector that break next actions
            ret = false;
        }
        if (onSearch && mergedSearchValue !== newSearchText) onSearch(newSearchText, {
            source: fromTyping ? 'typing' : 'effect'
        });
        // Open if from typing
        if (searchText && fromTyping && ret) triggerOpen(true);
        return ret;
    };
    // Only triggered when menu is closed & mode is tags
    // If menu is open, OptionList will take charge
    // If mode isn't tags, press enter is not meaningful when you can't see any option
    const onInternalSearchSubmit = (searchText)=>{
        // prevent empty tags from appearing when you click the Enter button
        if (!searchText || !searchText.trim()) return;
        onSearch(searchText, {
            source: 'submit'
        });
    };
    // Clean up search value when the dropdown is closed.
    // We use `rawOpen` here to avoid clearing the search input when the dropdown is
    // programmatically closed due to `notFoundContent={null}` and no matching options.
    // This allows the user to continue typing their search query.
    $5E6i4.useEffect(()=>{
        if (!rawOpen && !multiple && mode !== 'combobox') onInternalSearch('', false, false);
    }, [
        rawOpen
    ]);
    // ============================ Disabled ============================
    // Close dropdown & remove focus state when disabled change
    $5E6i4.useEffect(()=>{
        // After onBlur is triggered, the focused does not need to be reset
        if (disabled) {
            triggerOpen(false);
            setFocused(false);
        }
    }, [
        disabled,
        mergedOpen
    ]);
    // ============================ Keyboard ============================
    /**
   * We record input value here to check if can press to clean up by backspace
   * - null: Key is not down, this is reset by key up
   * - true: Search text is empty when first time backspace down
   * - false: Search text is not empty when first time backspace down
   */ const [getClearLock, setClearLock] = (0, $6e548070dde05c41$export$2e2bcd8739ae039)();
    const keyLockRef = $5E6i4.useRef(false);
    // KeyDown
    const onInternalKeyDown = (event)=>{
        const clearLock = getClearLock();
        const { key: key } = event;
        const isEnterKey = key === 'Enter';
        const isSpaceKey = key === ' ';
        // Enter or Space opens dropdown (ARIA combobox: spacebar should open)
        if (isEnterKey || isSpaceKey) {
            // Do not submit form when type in the input; prevent Space from scrolling page
            const isCombobox = mode === 'combobox';
            const isEditable = isCombobox || showSearch;
            if (isSpaceKey && !isEditable || isEnterKey && !isCombobox) event.preventDefault();
            // We only manage open state here, close logic should handle by list component
            if (!mergedOpen) triggerOpen(true);
        }
        setClearLock(!!mergedSearchValue);
        // Remove value by `backspace`
        if (key === 'Backspace' && !clearLock && multiple && !mergedSearchValue && displayValues.length) {
            const cloneDisplayValues = [
                ...displayValues
            ];
            let removedDisplayValue = null;
            for(let i = cloneDisplayValues.length - 1; i >= 0; i -= 1){
                const current = cloneDisplayValues[i];
                if (!current.disabled) {
                    cloneDisplayValues.splice(i, 1);
                    removedDisplayValue = current;
                    break;
                }
            }
            if (removedDisplayValue) onDisplayValuesChange(cloneDisplayValues, {
                type: 'remove',
                values: [
                    removedDisplayValue
                ]
            });
        }
        if (mergedOpen && (!isEnterKey || !keyLockRef.current) && !isSpaceKey) {
            // Lock the Enter key after it is pressed to avoid repeated triggering of the onChange event.
            if (isEnterKey) keyLockRef.current = true;
            listRef.current?.onKeyDown(event);
        }
        onKeyDown?.(event);
    };
    // KeyUp
    const onInternalKeyUp = (event, ...rest)=>{
        if (mergedOpen) listRef.current?.onKeyUp(event, ...rest);
        if (event.key === 'Enter') keyLockRef.current = false;
        onKeyUp?.(event, ...rest);
    };
    // ============================ Selector ============================
    const onSelectorRemove = (0, $68990f4402d2f009$export$2e2bcd8739ae039)((val)=>{
        const newValues = displayValues.filter((i)=>i !== val);
        onDisplayValuesChange(newValues, {
            type: 'remove',
            values: [
                val
            ]
        });
    });
    const onInputBlur = ()=>{
        // Unlock the Enter key after the input blur; otherwise, the Enter key needs to be pressed twice to trigger the correct effect.
        keyLockRef.current = false;
    };
    // ========================== Focus / Blur ==========================
    const getSelectElements = ()=>[
            (0, $b1bf69966442e513$export$9aa546fdc20ae5b3)(containerRef.current),
            triggerRef.current?.getPopupElement()
        ];
    // Close when click on non-select element
    (0, $3ed06527d513db1e$export$2e2bcd8739ae039)(getSelectElements, mergedOpen, triggerOpen, !!mergedComponents.root);
    // ========================== Focus / Blur ==========================
    const internalMouseDownRef = $5E6i4.useRef(false);
    const onInternalFocus = (event)=>{
        setFocused(true);
        if (!disabled) {
            // `showAction` should handle `focus` if set
            if (showAction.includes('focus')) triggerOpen(true);
            onFocus?.(event);
        }
    };
    const onRootBlur = ()=>{
        // Delay close should check the activeElement
        if (mergedOpen && !internalMouseDownRef.current) triggerOpen(false, {
            cancelFun: ()=>(0, $3ed06527d513db1e$export$4ac6a1c95deee4c5)(getSelectElements(), document.activeElement)
        });
    };
    const onInternalBlur = (event)=>{
        setFocused(false);
        if (mergedSearchValue) {
            // `tags` mode should move `searchValue` into values
            if (mode === 'tags') onSearch(mergedSearchValue, {
                source: 'submit'
            });
            else if (mode === 'multiple') // `multiple` mode only clean the search value but not trigger event
            onSearch('', {
                source: 'blur'
            });
        }
        onRootBlur();
        if (!disabled) onBlur?.(event);
    };
    const onRootMouseDown = (event, ...restArgs)=>{
        const { target: target } = event;
        const popupElement = triggerRef.current?.getPopupElement();
        // We should give focus back to selector if clicked item is not focusable
        if (popupElement?.contains(target) && triggerOpen) // Tell `open` not to close since it's safe in the popup
        triggerOpen(true);
        onMouseDown?.(event, ...restArgs);
        internalMouseDownRef.current = true;
        (0, $a41696bb0f5549a4$export$f1309b2412c6fa89)(()=>{
            internalMouseDownRef.current = false;
        });
    };
    // ============================ Dropdown ============================
    const [, forceUpdate] = $5E6i4.useState({});
    // We need force update here since popup dom is render async
    function onPopupMouseEnter() {
        forceUpdate({});
    }
    // Used for raw custom input trigger
    let onTriggerVisibleChange;
    if (!!mergedComponents.root) onTriggerVisibleChange = (newOpen)=>{
        triggerOpen(newOpen);
    };
    // ============================ Context =============================
    const baseSelectContext = $5E6i4.useMemo(()=>({
            ...props,
            notFoundContent: notFoundContent,
            open: mergedOpen,
            triggerOpen: mergedOpen,
            rawOpen: rawOpen,
            id: id,
            showSearch: showSearch,
            multiple: multiple,
            toggleOpen: triggerOpen,
            showScrollBar: showScrollBar,
            styles: styles,
            classNames: classNames,
            lockOptions: lockOptions
        }), [
        props,
        notFoundContent,
        triggerOpen,
        id,
        showSearch,
        multiple,
        mergedOpen,
        rawOpen,
        showScrollBar,
        styles,
        classNames,
        lockOptions
    ]);
    // ==================================================================
    // ==                            Render                            ==
    // ==================================================================
    // ============================= Suffix =============================
    const mergedSuffixIcon = $5E6i4.useMemo(()=>{
        const nextSuffix = suffix ?? suffixIcon;
        if (typeof nextSuffix === 'function') return nextSuffix({
            searchValue: mergedSearchValue,
            open: mergedOpen,
            focused: focused,
            showSearch: showSearch,
            loading: loading
        });
        return nextSuffix;
    }, [
        suffix,
        suffixIcon,
        mergedSearchValue,
        mergedOpen,
        focused,
        showSearch,
        loading
    ]);
    // ============================= Clear ==============================
    const onClearMouseDown = ()=>{
        onClear?.();
        containerRef.current?.focus();
        onDisplayValuesChange([], {
            type: 'clear',
            values: displayValues
        });
        onInternalSearch('', false, false);
    };
    const { allowClear: mergedAllowClear, clearIcon: clearNode, label: clearLabel } = (0, $09ec21b47d4e555d$export$9ea6397a890aa3e5)(prefixCls, displayValues, allowClear, clearIcon, disabled, mergedSearchValue, mode);
    // =========================== OptionList ===========================
    const optionList = /*#__PURE__*/ $5E6i4.createElement(OptionList, {
        ref: listRef
    });
    // ============================= Select =============================
    const mergedClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, className, {
        [`${prefixCls}-focused`]: focused,
        [`${prefixCls}-multiple`]: multiple,
        [`${prefixCls}-single`]: !multiple,
        [`${prefixCls}-allow-clear`]: mergedAllowClear,
        [`${prefixCls}-show-arrow`]: mergedSuffixIcon !== undefined && mergedSuffixIcon !== null,
        [`${prefixCls}-disabled`]: disabled,
        [`${prefixCls}-loading`]: loading,
        [`${prefixCls}-open`]: mergedOpen,
        [`${prefixCls}-customize-input`]: customizeInputElement,
        [`${prefixCls}-show-search`]: showSearch
    });
    // >>> Render
    let renderNode = /*#__PURE__*/ $5E6i4.createElement((0, $779d8a5e82bddc46$export$2e2bcd8739ae039), $32059bf47b698759$var$_extends({}, restProps, {
        // Ref
        ref: containerRef,
        prefixCls: prefixCls,
        className: mergedClassName,
        focused: focused,
        prefix: prefix,
        suffix: mergedSuffixIcon,
        clearIcon: clearNode,
        clearLabel: clearLabel,
        multiple: multiple,
        mode: mode,
        displayValues: displayValues,
        placeholder: placeholder,
        searchValue: mergedSearchValue,
        activeValue: activeValue,
        onSearch: onInternalSearch,
        onSearchSubmit: onInternalSearchSubmit,
        onInputBlur: onInputBlur,
        onFocus: onInternalFocus,
        onBlur: onInternalBlur,
        onClearMouseDown: onClearMouseDown,
        onKeyDown: onInternalKeyDown,
        onKeyUp: onInternalKeyUp,
        onSelectorRemove: onSelectorRemove,
        tokenWithEnter: tokenWithEnter,
        onMouseDown: onRootMouseDown,
        components: mergedComponents
    }));
    renderNode = /*#__PURE__*/ $5E6i4.createElement((0, $c4a7ac5582d8ea9a$export$2e2bcd8739ae039), {
        ref: triggerRef,
        disabled: disabled,
        prefixCls: prefixCls,
        visible: mergedOpen,
        popupElement: optionList,
        animation: animation,
        transitionName: transitionName,
        popupStyle: popupStyle,
        popupClassName: popupClassName,
        direction: direction,
        popupMatchSelectWidth: popupMatchSelectWidth,
        popupRender: popupRender,
        popupAlign: popupAlign,
        placement: placement,
        builtinPlacements: builtinPlacements,
        getPopupContainer: getPopupContainer,
        empty: emptyOptions,
        onPopupVisibleChange: onTriggerVisibleChange,
        onPopupMouseEnter: onPopupMouseEnter,
        onPopupMouseDown: onRootMouseDown,
        onPopupBlur: onRootBlur
    }, renderNode);
    return /*#__PURE__*/ $5E6i4.createElement((0, $f8edc52e57f85cd2$export$8234047c0aea33cf).Provider, {
        value: baseSelectContext
    }, /*#__PURE__*/ $5E6i4.createElement((0, $67cbad3cc08c1d01$export$2e2bcd8739ae039), {
        visible: focused && !mergedOpen,
        values: displayValues
    }), renderNode);
});
var $32059bf47b698759$export$2e2bcd8739ae039 = $32059bf47b698759$var$BaseSelect;


/* istanbul ignore file */ /** This is a placeholder, not real render in dom */ const $d4ce7be070373b1a$var$OptGroup = ()=>null;
$d4ce7be070373b1a$var$OptGroup.isSelectOptGroup = true;
var $d4ce7be070373b1a$export$2e2bcd8739ae039 = $d4ce7be070373b1a$var$OptGroup;


/* istanbul ignore file */ /** This is a placeholder, not real render in dom */ const $517d2aa070de0b1c$var$Option = ()=>null;
$517d2aa070de0b1c$var$Option.isSelectOption = true;
var $517d2aa070de0b1c$export$2e2bcd8739ae039 = $517d2aa070de0b1c$var$Option;








var $5E6i4 = parcelRequire("5E6i4");

var $ibUU1 = parcelRequire("ibUU1");

var $5E6i4 = parcelRequire("5E6i4");


function $963d6756fdbd2f36$var$_extends() {
    $963d6756fdbd2f36$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $963d6756fdbd2f36$var$_extends.apply(this, arguments);
}
/**
 * Fill component to provided the scroll content real height.
 */ const $963d6756fdbd2f36$var$Filler = /*#__PURE__*/ $5E6i4.forwardRef(({ height: height, offsetY: offsetY, offsetX: offsetX, children: children, prefixCls: prefixCls, onInnerResize: onInnerResize, innerProps: innerProps, rtl: rtl, extra: extra }, ref)=>{
    let outerStyle = {};
    let innerStyle = {
        display: 'flex',
        flexDirection: 'column'
    };
    if (offsetY !== undefined) {
        // Not set `width` since this will break `sticky: right`
        outerStyle = {
            height: height,
            position: 'relative',
            overflow: 'hidden'
        };
        innerStyle = {
            ...innerStyle,
            transform: `translateY(${offsetY}px)`,
            [rtl ? 'marginRight' : 'marginLeft']: -offsetX || 0,
            position: 'absolute',
            left: 0,
            right: 0,
            top: 0
        };
    }
    return /*#__PURE__*/ $5E6i4.createElement("div", {
        style: outerStyle
    }, /*#__PURE__*/ $5E6i4.createElement((0, $3a396118caae8741$export$2e2bcd8739ae039), {
        onResize: ({ offsetHeight: offsetHeight })=>{
            if (offsetHeight && onInnerResize) onInnerResize();
        }
    }, /*#__PURE__*/ $5E6i4.createElement("div", $963d6756fdbd2f36$var$_extends({
        style: innerStyle,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)({
            [`${prefixCls}-holder-inner`]: prefixCls
        }),
        ref: ref
    }, innerProps), children, extra)));
});
$963d6756fdbd2f36$var$Filler.displayName = 'Filler';
var $963d6756fdbd2f36$export$2e2bcd8739ae039 = $963d6756fdbd2f36$var$Filler;



var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");
function $ea846a00603f80cc$export$6d08773d2e66f8f2({ children: children, setRef: setRef }) {
    const refFunc = $5E6i4.useCallback((node)=>{
        setRef(node);
    }, [
        setRef
    ]);
    return /*#__PURE__*/ $5E6i4.cloneElement(children, {
        ref: refFunc
    });
}


function $63f1f7cc6578a6d1$export$2e2bcd8739ae039(list, startIndex, endIndex, scrollWidth, offsetX, setNodeRef, renderFunc, { getKey: getKey }) {
    return list.slice(startIndex, endIndex + 1).map((item, index)=>{
        const eleIndex = startIndex + index;
        const node = renderFunc(item, eleIndex, {
            style: {
                width: scrollWidth
            },
            offsetX: offsetX
        });
        const key = getKey(item);
        return /*#__PURE__*/ $5E6i4.createElement((0, $ea846a00603f80cc$export$6d08773d2e66f8f2), {
            key: key,
            setRef: (ele)=>setNodeRef(item, ele)
        }, node);
    });
}



var $5E6i4 = parcelRequire("5E6i4");
/**
 * Get index with specific start index one by one. e.g.
 * min: 3, max: 9, start: 6
 *
 * Return index is:
 * [0]: 6
 * [1]: 7
 * [2]: 5
 * [3]: 8
 * [4]: 4
 * [5]: 9
 * [6]: 3
 */ function $6ce0c180786fe7b6$export$38f9023d45dd4a23(min, max, start, index) {
    const beforeCount = start - min;
    const afterCount = max - start;
    const balanceCount = Math.min(beforeCount, afterCount) * 2;
    // Balance
    if (index <= balanceCount) {
        const stepIndex = Math.floor(index / 2);
        if (index % 2) return start + stepIndex + 1;
        return start - stepIndex;
    }
    // One is out of range
    if (beforeCount > afterCount) return start - (index - afterCount);
    return start + (index - beforeCount);
}
function $6ce0c180786fe7b6$export$418b8d8b03eefdf5(originList, targetList, getKey) {
    const originLen = originList.length;
    const targetLen = targetList.length;
    let shortList;
    let longList;
    if (originLen === 0 && targetLen === 0) return null;
    if (originLen < targetLen) {
        shortList = originList;
        longList = targetList;
    } else {
        shortList = targetList;
        longList = originList;
    }
    const notExistKey = {
        __EMPTY_ITEM__: true
    };
    function getItemKey(item) {
        if (item !== undefined) return getKey(item);
        return notExistKey;
    }
    // Loop to find diff one
    let diffIndex = null;
    let multiple = Math.abs(originLen - targetLen) !== 1;
    for(let i = 0; i < longList.length; i += 1){
        const shortKey = getItemKey(shortList[i]);
        const longKey = getItemKey(longList[i]);
        if (shortKey !== longKey) {
            diffIndex = i;
            multiple = multiple || shortKey !== getItemKey(longList[i + 1]);
            break;
        }
    }
    return diffIndex === null ? null : {
        index: diffIndex,
        multiple: multiple
    };
}


function $c16becaf7617e3eb$export$2e2bcd8739ae039(data, getKey, onDiff) {
    const [prevData, setPrevData] = $5E6i4.useState(data);
    const [diffItem, setDiffItem] = $5E6i4.useState(null);
    $5E6i4.useEffect(()=>{
        const diff = (0, $6ce0c180786fe7b6$export$418b8d8b03eefdf5)(prevData || [], data || [], getKey);
        if (diff?.index !== undefined) {
            onDiff?.(diff.index);
            setDiffItem(data[diff.index]);
        }
        setPrevData(data);
    }, [
        data
    ]);
    return [
        diffItem
    ];
}




var $5E6i4 = parcelRequire("5E6i4");
const $49a040637e6c6530$var$isFF = typeof navigator === 'object' && /Firefox/i.test(navigator.userAgent);
var $49a040637e6c6530$export$2e2bcd8739ae039 = $49a040637e6c6530$var$isFF;



var $5E6i4 = parcelRequire("5E6i4");
var $068ed404520c9f75$export$2e2bcd8739ae039 = (isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight)=>{
    // Do lock for a wheel when scrolling
    const lockRef = (0, $5E6i4.useRef)(false);
    const lockTimeoutRef = (0, $5E6i4.useRef)(null);
    function lockScroll() {
        clearTimeout(lockTimeoutRef.current);
        lockRef.current = true;
        lockTimeoutRef.current = setTimeout(()=>{
            lockRef.current = false;
        }, 50);
    }
    // Pass to ref since global add is in closure
    const scrollPingRef = (0, $5E6i4.useRef)({
        top: isScrollAtTop,
        bottom: isScrollAtBottom,
        left: isScrollAtLeft,
        right: isScrollAtRight
    });
    scrollPingRef.current.top = isScrollAtTop;
    scrollPingRef.current.bottom = isScrollAtBottom;
    scrollPingRef.current.left = isScrollAtLeft;
    scrollPingRef.current.right = isScrollAtRight;
    return (isHorizontal, delta, smoothOffset = false)=>{
        const originScroll = isHorizontal ? // Pass origin wheel when on the left
        delta < 0 && scrollPingRef.current.left || // Pass origin wheel when on the right
        delta > 0 && scrollPingRef.current.right // Pass origin wheel when on the top
         : delta < 0 && scrollPingRef.current.top || // Pass origin wheel when on the bottom
        delta > 0 && scrollPingRef.current.bottom;
        if (smoothOffset && originScroll) {
            // No need lock anymore when it's smooth offset from touchMove interval
            clearTimeout(lockTimeoutRef.current);
            lockRef.current = false;
        } else if (!originScroll || lockRef.current) lockScroll();
        return !lockRef.current && originScroll;
    };
};


function $27bc909874d4fe33$export$2e2bcd8739ae039(inVirtual, isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight, horizontalScroll, /***
 * Return `true` when you need to prevent default event
 */ onWheelDelta) {
    const offsetRef = (0, $5E6i4.useRef)(0);
    const nextFrameRef = (0, $5E6i4.useRef)(null);
    // Firefox patch
    const wheelValueRef = (0, $5E6i4.useRef)(null);
    const isMouseScrollRef = (0, $5E6i4.useRef)(false);
    // Scroll status sync
    const originScroll = (0, $068ed404520c9f75$export$2e2bcd8739ae039)(isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight);
    function onWheelY(e, deltaY) {
        (0, $1d949665862f071a$export$2e2bcd8739ae039).cancel(nextFrameRef.current);
        // Do nothing when scroll at the edge, Skip check when is in scroll
        if (originScroll(false, deltaY)) return;
        // Skip if nest List has handled this event
        const event = e;
        if (!event._virtualHandled) event._virtualHandled = true;
        else return;
        offsetRef.current += deltaY;
        wheelValueRef.current = deltaY;
        // Proxy of scroll events
        if (!(0, $49a040637e6c6530$export$2e2bcd8739ae039)) event.preventDefault();
        nextFrameRef.current = (0, $1d949665862f071a$export$2e2bcd8739ae039)(()=>{
            // Patch a multiple for Firefox to fix wheel number too small
            // ref: https://github.com/ant-design/ant-design/issues/26372#issuecomment-679460266
            const patchMultiple = isMouseScrollRef.current ? 10 : 1;
            onWheelDelta(offsetRef.current * patchMultiple, false);
            offsetRef.current = 0;
        });
    }
    function onWheelX(event, deltaX) {
        onWheelDelta(deltaX, true);
        if (!(0, $49a040637e6c6530$export$2e2bcd8739ae039)) event.preventDefault();
    }
    // Check for which direction does wheel do. `sx` means `shift + wheel`
    const wheelDirectionRef = (0, $5E6i4.useRef)(null);
    const wheelDirectionCleanRef = (0, $5E6i4.useRef)(null);
    function onWheel(event) {
        if (!inVirtual) return;
        // Wait for 2 frame to clean direction
        (0, $1d949665862f071a$export$2e2bcd8739ae039).cancel(wheelDirectionCleanRef.current);
        wheelDirectionCleanRef.current = (0, $1d949665862f071a$export$2e2bcd8739ae039)(()=>{
            wheelDirectionRef.current = null;
        }, 2);
        const { deltaX: deltaX, deltaY: deltaY, shiftKey: shiftKey } = event;
        let mergedDeltaX = deltaX;
        let mergedDeltaY = deltaY;
        if (wheelDirectionRef.current === 'sx' || !wheelDirectionRef.current && (shiftKey || false) && deltaY && !deltaX) {
            mergedDeltaX = deltaY;
            mergedDeltaY = 0;
            wheelDirectionRef.current = 'sx';
        }
        const absX = Math.abs(mergedDeltaX);
        const absY = Math.abs(mergedDeltaY);
        if (wheelDirectionRef.current === null) wheelDirectionRef.current = horizontalScroll && absX > absY ? 'x' : 'y';
        if (wheelDirectionRef.current === 'y') onWheelY(event, mergedDeltaY);
        else onWheelX(event, mergedDeltaX);
    }
    // A patch for firefox
    function onFireFoxScroll(event) {
        if (!inVirtual) return;
        isMouseScrollRef.current = event.detail === wheelValueRef.current;
    }
    return [
        onWheel,
        onFireFoxScroll
    ];
}



var $5E6i4 = parcelRequire("5E6i4");
function $ce89db4e81652662$export$a1d82723752af087(mergedData, getKey, heights, itemHeight) {
    const [key2Index, bottomList] = $5E6i4.useMemo(()=>[
            new Map(),
            []
        ], [
        mergedData,
        heights.id,
        itemHeight
    ]);
    const getSize = (startKey, endKey = startKey)=>{
        // Get from cache first
        let startIndex = key2Index.get(startKey);
        let endIndex = key2Index.get(endKey);
        // Loop to fill the cache
        if (startIndex === undefined || endIndex === undefined) {
            const dataLen = mergedData.length;
            for(let i = bottomList.length; i < dataLen; i += 1){
                const item = mergedData[i];
                const key = getKey(item);
                key2Index.set(key, i);
                const cacheHeight = heights.get(key) ?? itemHeight;
                bottomList[i] = (bottomList[i - 1] || 0) + cacheHeight;
                if (key === startKey) startIndex = i;
                if (key === endKey) endIndex = i;
                if (startIndex !== undefined && endIndex !== undefined) break;
            }
        }
        return {
            top: bottomList[startIndex - 1] || 0,
            bottom: bottomList[endIndex]
        };
    };
    return getSize;
}



var $5E6i4 = parcelRequire("5E6i4");
// Firefox has low performance of map.
class $eab3615709e18f64$var$CacheMap {
    maps;
    // Used for cache key
    // `useMemo` no need to update if `id` not change
    id = 0;
    diffRecords = new Map();
    constructor(){
        this.maps = Object.create(null);
    }
    set(key, value) {
        // Record prev value
        this.diffRecords.set(key, this.maps[key]);
        this.maps[key] = value;
        this.id += 1;
    }
    get(key) {
        return this.maps[key];
    }
    /**
   * CacheMap will record the key changed.
   * To help to know what's update in the next render.
   */ resetRecord() {
        this.diffRecords.clear();
    }
    getRecord() {
        return this.diffRecords;
    }
}
var $eab3615709e18f64$export$2e2bcd8739ae039 = $eab3615709e18f64$var$CacheMap;


function $d727f5dda72e582d$var$parseNumber(value) {
    const num = parseFloat(value);
    return isNaN(num) ? 0 : num;
}
function $d727f5dda72e582d$export$2e2bcd8739ae039(getKey, onItemAdd, onItemRemove) {
    const [updatedMark, setUpdatedMark] = $5E6i4.useState(0);
    const instanceRef = (0, $5E6i4.useRef)(new Map());
    const heightsRef = (0, $5E6i4.useRef)(new (0, $eab3615709e18f64$export$2e2bcd8739ae039)());
    const promiseIdRef = (0, $5E6i4.useRef)(0);
    function cancelRaf() {
        promiseIdRef.current += 1;
    }
    function collectHeight(sync = false) {
        cancelRaf();
        const doCollect = ()=>{
            let changed = false;
            instanceRef.current.forEach((element, key)=>{
                if (element && element.offsetParent) {
                    const { offsetHeight: offsetHeight } = element;
                    const { marginTop: marginTop, marginBottom: marginBottom } = getComputedStyle(element);
                    const marginTopNum = $d727f5dda72e582d$var$parseNumber(marginTop);
                    const marginBottomNum = $d727f5dda72e582d$var$parseNumber(marginBottom);
                    const totalHeight = offsetHeight + marginTopNum + marginBottomNum;
                    if (heightsRef.current.get(key) !== totalHeight) {
                        heightsRef.current.set(key, totalHeight);
                        changed = true;
                    }
                }
            });
            // Always trigger update mark to tell parent that should re-calculate heights when resized
            if (changed) setUpdatedMark((c)=>c + 1);
        };
        if (sync) doCollect();
        else {
            promiseIdRef.current += 1;
            const id = promiseIdRef.current;
            Promise.resolve().then(()=>{
                if (id === promiseIdRef.current) doCollect();
            });
        }
    }
    function setInstanceRef(item, instance) {
        const key = getKey(item);
        const origin = instanceRef.current.get(key);
        if (instance) {
            instanceRef.current.set(key, instance);
            collectHeight();
        } else instanceRef.current.delete(key);
        // Instance changed
        if (!origin !== !instance) {
            if (instance) onItemAdd?.(item);
            else onItemRemove?.(item);
        }
    }
    (0, $5E6i4.useEffect)(()=>{
        return cancelRaf;
    }, []);
    return [
        setInstanceRef,
        collectHeight,
        heightsRef.current,
        updatedMark
    ];
}




var $5E6i4 = parcelRequire("5E6i4");
const $94379c5f48956caf$var$SMOOTH_PTG = 14 / 15;
function $94379c5f48956caf$export$2e2bcd8739ae039(inVirtual, listRef, callback) {
    const touchedRef = (0, $5E6i4.useRef)(false);
    const touchXRef = (0, $5E6i4.useRef)(0);
    const touchYRef = (0, $5E6i4.useRef)(0);
    const elementRef = (0, $5E6i4.useRef)(null);
    // Smooth scroll
    const intervalRef = (0, $5E6i4.useRef)(null);
    /* eslint-disable prefer-const */ let cleanUpEvents;
    const onTouchMove = (e)=>{
        if (touchedRef.current) {
            const currentX = Math.ceil(e.touches[0].pageX);
            const currentY = Math.ceil(e.touches[0].pageY);
            let offsetX = touchXRef.current - currentX;
            let offsetY = touchYRef.current - currentY;
            const isHorizontal = Math.abs(offsetX) > Math.abs(offsetY);
            if (isHorizontal) touchXRef.current = currentX;
            else touchYRef.current = currentY;
            const scrollHandled = callback(isHorizontal, isHorizontal ? offsetX : offsetY, false, e);
            if (scrollHandled) e.preventDefault();
            // Smooth interval
            clearInterval(intervalRef.current);
            if (scrollHandled) intervalRef.current = setInterval(()=>{
                if (isHorizontal) offsetX *= $94379c5f48956caf$var$SMOOTH_PTG;
                else offsetY *= $94379c5f48956caf$var$SMOOTH_PTG;
                const offset = Math.floor(isHorizontal ? offsetX : offsetY);
                if (!callback(isHorizontal, offset, true) || Math.abs(offset) <= 0.1) clearInterval(intervalRef.current);
            }, 16);
        }
    };
    const onTouchEnd = ()=>{
        touchedRef.current = false;
        cleanUpEvents();
    };
    const onTouchStart = (e)=>{
        cleanUpEvents();
        if (e.touches.length === 1 && !touchedRef.current) {
            touchedRef.current = true;
            touchXRef.current = Math.ceil(e.touches[0].pageX);
            touchYRef.current = Math.ceil(e.touches[0].pageY);
            elementRef.current = e.target;
            elementRef.current.addEventListener('touchmove', onTouchMove, {
                passive: false
            });
            elementRef.current.addEventListener('touchend', onTouchEnd, {
                passive: true
            });
        }
    };
    cleanUpEvents = ()=>{
        if (elementRef.current) {
            elementRef.current.removeEventListener('touchmove', onTouchMove);
            elementRef.current.removeEventListener('touchend', onTouchEnd);
        }
    };
    (0, $518ae471aa4f03a7$export$2e2bcd8739ae039)(()=>{
        if (inVirtual) listRef.current.addEventListener('touchstart', onTouchStart, {
            passive: true
        });
        return ()=>{
            listRef.current?.removeEventListener('touchstart', onTouchStart);
            cleanUpEvents();
            clearInterval(intervalRef.current);
        };
    }, [
        inVirtual
    ]);
}





var $5E6i4 = parcelRequire("5E6i4");
function $3c41b881139c85ea$var$smoothScrollOffset(offset) {
    return Math.floor(offset ** 0.5);
}
function $3c41b881139c85ea$export$dbd0143e191dc2e5(e, horizontal) {
    const obj = 'touches' in e ? e.touches[0] : e;
    return obj[horizontal ? 'pageX' : 'pageY'] - window[horizontal ? 'scrollX' : 'scrollY'];
}
/**
 * Check the element itself or any of its ancestors is draggable.
 * Use the IDL attribute instead of `[draggable]` selector so that
 * implicitly draggable elements (`a[href]`, `img`) are also covered.
 */ function $3c41b881139c85ea$var$isDraggable(ele) {
    let current = ele;
    while(current){
        if (current.draggable) return true;
        current = current.parentElement;
    }
    return false;
}
function $3c41b881139c85ea$export$2e2bcd8739ae039(inVirtual, componentRef, onScrollOffset) {
    $5E6i4.useEffect(()=>{
        const ele = componentRef.current;
        if (inVirtual && ele) {
            let mouseDownLock = false;
            let rafId;
            let offset;
            const stopScroll = ()=>{
                (0, $1d949665862f071a$export$2e2bcd8739ae039).cancel(rafId);
            };
            const continueScroll = ()=>{
                stopScroll();
                rafId = (0, $1d949665862f071a$export$2e2bcd8739ae039)(()=>{
                    onScrollOffset(offset);
                    continueScroll();
                });
            };
            const clearDragState = ()=>{
                mouseDownLock = false;
                stopScroll();
            };
            const onMouseDown = (e)=>{
                // Skip if element set draggable
                // Note the mousedown target is the deepest node in the event path (e.g. the
                // title span inside a Tree node), while `draggable` is set on the ancestor.
                if ($3c41b881139c85ea$var$isDraggable(e.target) || e.button !== 0) return;
                // Skip if nest List has handled this event
                const event = e;
                if (!event._virtualHandled) {
                    event._virtualHandled = true;
                    mouseDownLock = true;
                }
            };
            const onMouseMove = (e)=>{
                if (mouseDownLock) {
                    const mouseY = $3c41b881139c85ea$export$dbd0143e191dc2e5(e, false);
                    const { top: top, bottom: bottom } = ele.getBoundingClientRect();
                    if (mouseY <= top) {
                        const diff = top - mouseY;
                        offset = -$3c41b881139c85ea$var$smoothScrollOffset(diff);
                        continueScroll();
                    } else if (mouseY >= bottom) {
                        const diff = mouseY - bottom;
                        offset = $3c41b881139c85ea$var$smoothScrollOffset(diff);
                        continueScroll();
                    } else stopScroll();
                }
            };
            ele.addEventListener('mousedown', onMouseDown);
            ele.ownerDocument.addEventListener('mouseup', clearDragState);
            ele.ownerDocument.addEventListener('mousemove', onMouseMove);
            ele.ownerDocument.addEventListener('dragend', clearDragState);
            return ()=>{
                ele.removeEventListener('mousedown', onMouseDown);
                ele.ownerDocument.removeEventListener('mouseup', clearDragState);
                ele.ownerDocument.removeEventListener('mousemove', onMouseMove);
                ele.ownerDocument.removeEventListener('dragend', clearDragState);
                stopScroll();
            };
        }
    }, [
        inVirtual
    ]);
}



var $5E6i4 = parcelRequire("5E6i4");

const $f43447a2ebba3f64$var$MAX_TIMES = 10;
function $f43447a2ebba3f64$var$getOffset(rawOffset, info) {
    const resolvedOffset = typeof rawOffset === 'function' ? rawOffset(info) : rawOffset;
    return Number.isFinite(resolvedOffset) ? resolvedOffset : 0;
}
function $f43447a2ebba3f64$export$2e2bcd8739ae039(containerRef, data, heights, itemHeight, getKey, getSize, collectHeight, syncScrollTop, triggerFlash) {
    const scrollRef = $5E6i4.useRef(undefined);
    const [syncState, setSyncState] = $5E6i4.useState(null);
    // ========================== Sync Scroll ==========================
    (0, $518ae471aa4f03a7$export$2e2bcd8739ae039)(()=>{
        if (syncState && syncState.times < $f43447a2ebba3f64$var$MAX_TIMES) {
            // Never reach
            if (!containerRef.current) {
                setSyncState((ori)=>({
                        ...ori
                    }));
                return;
            }
            collectHeight();
            const { targetAlign: targetAlign, originAlign: originAlign, offset: rawOffset } = syncState;
            const index = syncState.index >= 0 ? syncState.index : data.findIndex((item)=>getKey(item) === syncState.key);
            const mergedAlign = targetAlign || originAlign;
            const offset = $f43447a2ebba3f64$var$getOffset(rawOffset, {
                getSize: getSize,
                align: mergedAlign
            });
            const height = containerRef.current.clientHeight;
            let needCollectHeight = index < 0;
            let newTargetAlign = targetAlign;
            let targetTop = null;
            // Go to next frame if height not exist
            if (height && index >= 0) {
                // Get top & bottom
                let stackTop = 0;
                let itemTop = 0;
                let itemBottom = 0;
                const maxLen = Math.min(data.length - 1, index);
                for(let i = 0; i <= maxLen; i += 1){
                    const key = getKey(data[i]);
                    itemTop = stackTop;
                    const cacheHeight = heights.get(key);
                    itemBottom = itemTop + (cacheHeight === undefined ? itemHeight : cacheHeight);
                    stackTop = itemBottom;
                }
                // Check if need sync height (visible range has item not record height)
                let leftHeight = mergedAlign === 'top' ? offset : height - offset;
                for(let i = maxLen; i >= 0; i -= 1){
                    const key = getKey(data[i]);
                    const cacheHeight = heights.get(key);
                    if (cacheHeight === undefined) {
                        needCollectHeight = true;
                        break;
                    }
                    leftHeight -= cacheHeight;
                    if (leftHeight <= 0) break;
                }
                // Scroll to
                switch(mergedAlign){
                    case 'top':
                        targetTop = itemTop - offset;
                        break;
                    case 'bottom':
                        targetTop = itemBottom - height + offset;
                        break;
                    default:
                        {
                            const { scrollTop: scrollTop } = containerRef.current;
                            const scrollBottom = scrollTop + height;
                            if (itemTop < scrollTop) newTargetAlign = 'top';
                            else if (itemBottom > scrollBottom) newTargetAlign = 'bottom';
                        }
                }
                if (targetTop !== null) syncScrollTop(targetTop);
                // One more time for sync
                if (targetTop !== syncState.lastTop) needCollectHeight = true;
            }
            // Trigger next effect
            if (needCollectHeight) setSyncState((prev)=>({
                    ...prev,
                    times: prev.times + 1,
                    index: index,
                    targetAlign: newTargetAlign,
                    lastTop: targetTop
                }));
        }
    }, [
        syncState,
        containerRef.current
    ]);
    // =========================== Scroll To ===========================
    return (arg)=>{
        // When not argument provided, we think dev may want to show the scrollbar
        if (arg === null || arg === undefined) {
            triggerFlash();
            return;
        }
        // Normal scroll logic
        (0, $1d949665862f071a$export$2e2bcd8739ae039).cancel(scrollRef.current);
        if (typeof arg === 'number') syncScrollTop(arg);
        else if (arg && typeof arg === 'object') {
            let index;
            let key;
            const { align: align } = arg;
            if ('index' in arg) ({ index: index } = arg);
            else {
                key = arg.key;
                index = data.findIndex((item)=>getKey(item) === key);
            }
            const { offset: rawOffset = 0 } = arg;
            setSyncState({
                times: 0,
                index: index,
                key: key,
                offset: rawOffset,
                originAlign: align
            });
        }
    };
}





var $5E6i4 = parcelRequire("5E6i4");

function $3ae37e0b942ef93f$var$getScrollOffsetByThumbTop(thumbTop, enabledScrollRange, enabledOffsetRange) {
    if (enabledScrollRange <= 0 || enabledOffsetRange <= 0) return 0;
    const mergedThumbTop = Math.max(Math.min(thumbTop, enabledOffsetRange), 0);
    const ptg = mergedThumbTop / enabledOffsetRange;
    let nextScrollOffset = Math.ceil(ptg * enabledScrollRange);
    nextScrollOffset = Math.max(nextScrollOffset, 0);
    nextScrollOffset = Math.min(nextScrollOffset, enabledScrollRange);
    return nextScrollOffset;
}
const $3ae37e0b942ef93f$var$ScrollBar = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, rtl: rtl, scrollOffset: scrollOffset, scrollRange: scrollRange, onStartMove: onStartMove, onStopMove: onStopMove, onScroll: onScroll, horizontal: horizontal, spinSize: spinSize, containerSize: containerSize, style: style, thumbStyle: propsThumbStyle, showScrollBar: showScrollBar } = props;
    const [dragging, setDragging] = $5E6i4.useState(false);
    const [pageXY, setPageXY] = $5E6i4.useState(null);
    const [startTop, setStartTop] = $5E6i4.useState(null);
    const isLTR = !rtl;
    // ========================= Refs =========================
    const scrollbarRef = $5E6i4.useRef(null);
    const thumbRef = $5E6i4.useRef(null);
    // ======================= Visible ========================
    const [visible, setVisible] = $5E6i4.useState(showScrollBar);
    const visibleTimeoutRef = $5E6i4.useRef(undefined);
    const delayHidden = ()=>{
        if (showScrollBar === true || showScrollBar === false) return;
        clearTimeout(visibleTimeoutRef.current);
        setVisible(true);
        visibleTimeoutRef.current = setTimeout(()=>{
            setVisible(false);
        }, 3000);
    };
    // ======================== Range =========================
    const enableScrollRange = scrollRange - containerSize || 0;
    const enableOffsetRange = containerSize - spinSize || 0;
    // ========================= Top ==========================
    const top = $5E6i4.useMemo(()=>{
        if (scrollOffset === 0 || enableScrollRange === 0) return 0;
        const ptg = scrollOffset / enableScrollRange;
        return ptg * enableOffsetRange;
    }, [
        scrollOffset,
        enableScrollRange,
        enableOffsetRange
    ]);
    // ====================== Container =======================
    const isThumbTarget = (target)=>{
        return !!target && thumbRef.current?.contains(target);
    };
    const scrollToTrackPosition = (e)=>{
        const scrollbarEle = scrollbarRef.current;
        if (!scrollbarEle) return;
        const rect = scrollbarEle.getBoundingClientRect();
        const pagePosition = (0, $3c41b881139c85ea$export$dbd0143e191dc2e5)(e, horizontal);
        let nextTop;
        if (!Number.isFinite(pagePosition)) return;
        if (horizontal) {
            const horizontalStart = isLTR ? rect.left : rect.right;
            if (!Number.isFinite(horizontalStart)) return;
            nextTop = (isLTR ? pagePosition - horizontalStart : horizontalStart - pagePosition) - spinSize / 2;
        } else {
            if (!Number.isFinite(rect.top)) return;
            nextTop = pagePosition - rect.top - spinSize / 2;
        }
        onScroll($3ae37e0b942ef93f$var$getScrollOffsetByThumbTop(nextTop, enableScrollRange, enableOffsetRange), horizontal);
    };
    const onContainerMouseDown = (e)=>{
        e.stopPropagation();
        e.preventDefault();
        if (e.button !== 0 || isThumbTarget(e.target)) return;
        scrollToTrackPosition(e);
    };
    // ======================== Thumb =========================
    const stateRef = $5E6i4.useRef({
        top: top,
        dragging: dragging,
        pageY: pageXY,
        startTop: startTop
    });
    stateRef.current = {
        top: top,
        dragging: dragging,
        pageY: pageXY,
        startTop: startTop
    };
    const onThumbMouseDown = (0, $68990f4402d2f009$export$2e2bcd8739ae039)((e)=>{
        setDragging(true);
        setPageXY((0, $3c41b881139c85ea$export$dbd0143e191dc2e5)(e, horizontal));
        setStartTop(stateRef.current.top);
        onStartMove();
        e.stopPropagation();
        e.preventDefault();
    });
    // ======================== Effect ========================
    // React make event as passive, but we need to preventDefault
    // Add event on dom directly instead.
    // ref: https://github.com/facebook/react/issues/9809
    $5E6i4.useEffect(()=>{
        const onScrollbarTouchStart = (e)=>{
            e.preventDefault();
        };
        const scrollbarEle = scrollbarRef.current;
        const thumbEle = thumbRef.current;
        scrollbarEle.addEventListener('touchstart', onScrollbarTouchStart, {
            passive: false
        });
        thumbEle.addEventListener('touchstart', onThumbMouseDown, {
            passive: false
        });
        return ()=>{
            scrollbarEle.removeEventListener('touchstart', onScrollbarTouchStart);
            thumbEle.removeEventListener('touchstart', onThumbMouseDown);
        };
    }, [
        onThumbMouseDown
    ]);
    // Pass to effect
    const enableScrollRangeRef = $5E6i4.useRef(undefined);
    enableScrollRangeRef.current = enableScrollRange;
    const enableOffsetRangeRef = $5E6i4.useRef(undefined);
    enableOffsetRangeRef.current = enableOffsetRange;
    $5E6i4.useEffect(()=>{
        if (dragging) {
            let moveRafId;
            const onMouseMove = (e)=>{
                const { dragging: stateDragging, pageY: statePageY, startTop: stateStartTop } = stateRef.current;
                (0, $1d949665862f071a$export$2e2bcd8739ae039).cancel(moveRafId);
                const rect = scrollbarRef.current.getBoundingClientRect();
                const scale = containerSize / (horizontal ? rect.width : rect.height);
                if (stateDragging) {
                    const offset = ((0, $3c41b881139c85ea$export$dbd0143e191dc2e5)(e, horizontal) - statePageY) * scale;
                    let newTop = stateStartTop;
                    if (!isLTR && horizontal) newTop -= offset;
                    else newTop += offset;
                    const tmpEnableScrollRange = enableScrollRangeRef.current;
                    const tmpEnableOffsetRange = enableOffsetRangeRef.current;
                    const newScrollTop = $3ae37e0b942ef93f$var$getScrollOffsetByThumbTop(newTop, tmpEnableScrollRange, tmpEnableOffsetRange);
                    moveRafId = (0, $1d949665862f071a$export$2e2bcd8739ae039)(()=>{
                        onScroll(newScrollTop, horizontal);
                    });
                }
            };
            const onMouseUp = ()=>{
                setDragging(false);
                onStopMove();
            };
            window.addEventListener('mousemove', onMouseMove, {
                passive: true
            });
            window.addEventListener('touchmove', onMouseMove, {
                passive: true
            });
            window.addEventListener('mouseup', onMouseUp, {
                passive: true
            });
            window.addEventListener('touchend', onMouseUp, {
                passive: true
            });
            return ()=>{
                window.removeEventListener('mousemove', onMouseMove);
                window.removeEventListener('touchmove', onMouseMove);
                window.removeEventListener('mouseup', onMouseUp);
                window.removeEventListener('touchend', onMouseUp);
                (0, $1d949665862f071a$export$2e2bcd8739ae039).cancel(moveRafId);
            };
        }
    }, [
        dragging
    ]);
    $5E6i4.useEffect(()=>{
        delayHidden();
        return ()=>{
            clearTimeout(visibleTimeoutRef.current);
        };
    }, [
        scrollOffset
    ]);
    // ====================== Imperative ======================
    $5E6i4.useImperativeHandle(ref, ()=>({
            delayHidden: delayHidden
        }));
    // ======================== Render ========================
    const scrollbarPrefixCls = `${prefixCls}-scrollbar`;
    const containerStyle = {
        position: 'absolute',
        visibility: visible ? null : 'hidden'
    };
    const thumbStyle = {
        position: 'absolute',
        borderRadius: 99,
        background: 'var(--rc-virtual-list-scrollbar-bg, rgba(0, 0, 0, 0.5))',
        cursor: 'pointer',
        userSelect: 'none'
    };
    if (horizontal) {
        Object.assign(containerStyle, {
            height: 8,
            left: 0,
            right: 0,
            bottom: 0
        });
        Object.assign(thumbStyle, {
            height: '100%',
            width: spinSize,
            [isLTR ? 'left' : 'right']: top
        });
    } else {
        Object.assign(containerStyle, {
            width: 8,
            top: 0,
            bottom: 0,
            [isLTR ? 'right' : 'left']: 0
        });
        Object.assign(thumbStyle, {
            width: '100%',
            height: spinSize,
            top: top
        });
    }
    return /*#__PURE__*/ $5E6i4.createElement("div", {
        ref: scrollbarRef,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(scrollbarPrefixCls, {
            [`${scrollbarPrefixCls}-horizontal`]: horizontal,
            [`${scrollbarPrefixCls}-vertical`]: !horizontal,
            [`${scrollbarPrefixCls}-visible`]: visible
        }),
        style: {
            ...containerStyle,
            ...style
        },
        onMouseDown: onContainerMouseDown,
        onMouseMove: delayHidden
    }, /*#__PURE__*/ $5E6i4.createElement("div", {
        ref: thumbRef,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${scrollbarPrefixCls}-thumb`, {
            [`${scrollbarPrefixCls}-thumb-moving`]: dragging
        }),
        style: {
            ...thumbStyle,
            ...propsThumbStyle
        },
        onMouseDown: onThumbMouseDown
    }));
});
var $3ae37e0b942ef93f$export$2e2bcd8739ae039 = $3ae37e0b942ef93f$var$ScrollBar;


const $a590a749ffccbd07$var$MIN_SIZE = 20;
function $a590a749ffccbd07$export$f2ca68955ab35ace(containerSize = 0, scrollRange = 0) {
    let baseSize = containerSize / scrollRange * containerSize;
    if (isNaN(baseSize)) baseSize = 0;
    baseSize = Math.max(baseSize, $a590a749ffccbd07$var$MIN_SIZE);
    return Math.floor(baseSize);
}


function $3099990fc0ae0e67$var$_extends() {
    $3099990fc0ae0e67$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3099990fc0ae0e67$var$_extends.apply(this, arguments);
}
const $3099990fc0ae0e67$var$EMPTY_DATA = [];
const $3099990fc0ae0e67$var$ScrollStyle = {
    overflowY: 'auto',
    overflowAnchor: 'none'
};
function $3099990fc0ae0e67$export$cc3be4e46e8486ed(props, ref) {
    const { prefixCls: prefixCls = 'rc-virtual-list', className: className, height: height, itemHeight: itemHeight, fullHeight: fullHeight = true, style: style, data: data, children: children, itemKey: itemKey, virtual: virtual, direction: direction, scrollWidth: scrollWidth, component: Component = 'div', onScroll: onScroll, onVirtualScroll: onVirtualScroll, onVisibleChange: onVisibleChange, innerProps: innerProps, extraRender: extraRender, styles: styles, showScrollBar: showScrollBar = 'optional', ...restProps } = props;
    // =============================== Item Key ===============================
    const getKey = $5E6i4.useCallback((item)=>{
        if (typeof itemKey === 'function') return itemKey(item);
        return item?.[itemKey];
    }, [
        itemKey
    ]);
    // ================================ Height ================================
    const [setInstanceRef, collectHeight, heights, heightUpdatedMark] = (0, $d727f5dda72e582d$export$2e2bcd8739ae039)(getKey, null, null);
    // ================================= MISC =================================
    const useVirtual = !!(virtual !== false && height && itemHeight);
    const containerHeight = $5E6i4.useMemo(()=>Object.values(heights.maps).reduce((total, curr)=>total + curr, 0), [
        heights.id,
        heights.maps
    ]);
    const inVirtual = useVirtual && data && (Math.max(itemHeight * data.length, containerHeight) > height || !!scrollWidth);
    const isRTL = direction === 'rtl';
    const mergedClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, {
        [`${prefixCls}-rtl`]: isRTL
    }, className);
    const mergedData = data || $3099990fc0ae0e67$var$EMPTY_DATA;
    const componentRef = (0, $5E6i4.useRef)(null);
    const fillerInnerRef = (0, $5E6i4.useRef)(null);
    const containerRef = (0, $5E6i4.useRef)(null);
    // =============================== Item Key ===============================
    const [offsetTop, setOffsetTop] = (0, $5E6i4.useState)(0);
    const [offsetLeft, setOffsetLeft] = (0, $5E6i4.useState)(0);
    const [scrollMoving, setScrollMoving] = (0, $5E6i4.useState)(false);
    const onScrollbarStartMove = ()=>{
        setScrollMoving(true);
    };
    const onScrollbarStopMove = ()=>{
        setScrollMoving(false);
    };
    const sharedConfig = {
        getKey: getKey
    };
    // ================================ Scroll ================================
    function syncScrollTop(newTop) {
        setOffsetTop((origin)=>{
            let value;
            if (typeof newTop === 'function') value = newTop(origin);
            else value = newTop;
            const alignedTop = keepInRange(value);
            componentRef.current.scrollTop = alignedTop;
            return alignedTop;
        });
    }
    // ================================ Legacy ================================
    // Put ref here since the range is generate by follow
    const rangeRef = (0, $5E6i4.useRef)({
        start: 0,
        end: mergedData.length
    });
    const diffItemRef = (0, $5E6i4.useRef)(undefined);
    const [diffItem] = (0, $c16becaf7617e3eb$export$2e2bcd8739ae039)(mergedData, getKey);
    diffItemRef.current = diffItem;
    // ========================== Visible Calculation =========================
    const { scrollHeight: scrollHeight, start: start, end: end, offset: fillerOffset } = $5E6i4.useMemo(()=>{
        if (!useVirtual) return {
            scrollHeight: undefined,
            start: 0,
            end: mergedData.length - 1,
            offset: undefined
        };
        // Always use virtual scroll bar in avoid shaking
        if (!inVirtual) return {
            scrollHeight: fillerInnerRef.current?.offsetHeight || 0,
            start: 0,
            end: mergedData.length - 1,
            offset: undefined
        };
        let itemTop = 0;
        let startIndex;
        let startOffset;
        let endIndex;
        const dataLen = mergedData.length;
        for(let i = 0; i < dataLen; i += 1){
            const item = mergedData[i];
            const key = getKey(item);
            const cacheHeight = heights.get(key);
            const currentItemBottom = itemTop + (cacheHeight === undefined ? itemHeight : cacheHeight);
            // Check item top in the range
            if (currentItemBottom >= offsetTop && startIndex === undefined) {
                startIndex = i;
                startOffset = itemTop;
            }
            // Check item bottom in the range. We will render additional one item for motion usage
            if (currentItemBottom > offsetTop + height && endIndex === undefined) endIndex = i;
            itemTop = currentItemBottom;
        }
        // When scrollTop at the end but data cut to small count will reach this
        if (startIndex === undefined) {
            startIndex = 0;
            startOffset = 0;
            endIndex = Math.ceil(height / itemHeight);
        }
        if (endIndex === undefined) endIndex = mergedData.length - 1;
        // Give cache to improve scroll experience
        endIndex = Math.min(endIndex + 1, mergedData.length - 1);
        return {
            scrollHeight: itemTop,
            start: startIndex,
            end: endIndex,
            offset: startOffset
        };
    }, [
        inVirtual,
        useVirtual,
        offsetTop,
        mergedData,
        heightUpdatedMark,
        height
    ]);
    rangeRef.current.start = start;
    rangeRef.current.end = end;
    // When scroll up, first visible item get real height may not same as `itemHeight`,
    // Which will make scroll jump.
    // Let's sync scroll top to avoid jump
    $5E6i4.useLayoutEffect(()=>{
        const changedRecord = heights.getRecord();
        if (changedRecord.size === 1) {
            const recordKey = Array.from(changedRecord.keys())[0];
            const prevCacheHeight = changedRecord.get(recordKey);
            // Quick switch data may cause `start` not in `mergedData` anymore
            const startItem = mergedData[start];
            if (startItem && prevCacheHeight === undefined) {
                const startIndexKey = getKey(startItem);
                if (startIndexKey === recordKey) {
                    const realStartHeight = heights.get(recordKey);
                    const diffHeight = realStartHeight - itemHeight;
                    syncScrollTop((ori)=>{
                        return ori + diffHeight;
                    });
                }
            }
        }
        heights.resetRecord();
    }, [
        scrollHeight
    ]);
    // ================================= Size =================================
    const [size, setSize] = $5E6i4.useState({
        width: 0,
        height: height
    });
    const onHolderResize = (sizeInfo)=>{
        setSize({
            width: sizeInfo.offsetWidth,
            height: sizeInfo.offsetHeight
        });
    };
    // Hack on scrollbar to enable flash call
    const verticalScrollBarRef = (0, $5E6i4.useRef)(null);
    const horizontalScrollBarRef = (0, $5E6i4.useRef)(null);
    const horizontalScrollBarSpinSize = $5E6i4.useMemo(()=>(0, $a590a749ffccbd07$export$f2ca68955ab35ace)(size.width, scrollWidth), [
        size.width,
        scrollWidth
    ]);
    const verticalScrollBarSpinSize = $5E6i4.useMemo(()=>(0, $a590a749ffccbd07$export$f2ca68955ab35ace)(size.height, scrollHeight), [
        size.height,
        scrollHeight
    ]);
    // =============================== In Range ===============================
    const maxScrollHeight = scrollHeight - height;
    const maxScrollHeightRef = (0, $5E6i4.useRef)(maxScrollHeight);
    maxScrollHeightRef.current = maxScrollHeight;
    function keepInRange(newScrollTop) {
        let newTop = newScrollTop;
        if (!Number.isNaN(maxScrollHeightRef.current)) newTop = Math.min(newTop, maxScrollHeightRef.current);
        newTop = Math.max(newTop, 0);
        return newTop;
    }
    const isScrollAtTop = offsetTop <= 0;
    const isScrollAtBottom = offsetTop >= maxScrollHeight;
    const isScrollAtLeft = offsetLeft <= 0;
    const isScrollAtRight = offsetLeft >= scrollWidth;
    const originScroll = (0, $068ed404520c9f75$export$2e2bcd8739ae039)(isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight);
    // ================================ Scroll ================================
    const getVirtualScrollInfo = ()=>({
            x: isRTL ? -offsetLeft : offsetLeft,
            y: offsetTop
        });
    const lastVirtualScrollInfoRef = (0, $5E6i4.useRef)(getVirtualScrollInfo());
    const triggerScroll = (0, $68990f4402d2f009$export$2e2bcd8739ae039)((params)=>{
        if (onVirtualScroll) {
            const nextInfo = {
                ...getVirtualScrollInfo(),
                ...params
            };
            // Trigger when offset changed
            if (lastVirtualScrollInfoRef.current.x !== nextInfo.x || lastVirtualScrollInfoRef.current.y !== nextInfo.y) {
                onVirtualScroll(nextInfo);
                lastVirtualScrollInfoRef.current = nextInfo;
            }
        }
    });
    function onScrollBar(newScrollOffset, horizontal) {
        const newOffset = newScrollOffset;
        if (horizontal) {
            (0, $ibUU1.flushSync)(()=>{
                setOffsetLeft(newOffset);
            });
            triggerScroll();
        } else syncScrollTop(newOffset);
    }
    // When data size reduce. It may trigger native scroll event back to fit scroll position
    function onFallbackScroll(e) {
        const { scrollTop: newScrollTop } = e.currentTarget;
        if (newScrollTop !== offsetTop) syncScrollTop(newScrollTop);
        // Trigger origin onScroll
        onScroll?.(e);
        triggerScroll();
    }
    const keepInHorizontalRange = (nextOffsetLeft)=>{
        let tmpOffsetLeft = nextOffsetLeft;
        const max = !!scrollWidth ? scrollWidth - size.width : 0;
        tmpOffsetLeft = Math.max(tmpOffsetLeft, 0);
        tmpOffsetLeft = Math.min(tmpOffsetLeft, max);
        return tmpOffsetLeft;
    };
    const onWheelDelta = (0, $68990f4402d2f009$export$2e2bcd8739ae039)((offsetXY, fromHorizontal)=>{
        if (fromHorizontal) {
            (0, $ibUU1.flushSync)(()=>{
                setOffsetLeft((left)=>{
                    const nextOffsetLeft = left + (isRTL ? -offsetXY : offsetXY);
                    return keepInHorizontalRange(nextOffsetLeft);
                });
            });
            triggerScroll();
        } else syncScrollTop((top)=>{
            const newTop = top + offsetXY;
            return newTop;
        });
    });
    // Since this added in global,should use ref to keep update
    const [onRawWheel, onFireFoxScroll] = (0, $27bc909874d4fe33$export$2e2bcd8739ae039)(useVirtual, isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight, !!scrollWidth, onWheelDelta);
    // Mobile touch move
    (0, $94379c5f48956caf$export$2e2bcd8739ae039)(useVirtual, componentRef, (isHorizontal, delta, smoothOffset, e)=>{
        const event = e;
        if (originScroll(isHorizontal, delta, smoothOffset)) return false;
        // Fix nest List trigger TouchMove event
        if (!event || !event._virtualHandled) {
            if (event) event._virtualHandled = true;
            onRawWheel({
                preventDefault () {},
                deltaX: isHorizontal ? delta : 0,
                deltaY: isHorizontal ? 0 : delta
            });
            return true;
        }
        return false;
    });
    // MouseDown drag for scroll
    (0, $3c41b881139c85ea$export$2e2bcd8739ae039)(inVirtual, componentRef, (offset)=>{
        syncScrollTop((top)=>top + offset);
    });
    (0, $518ae471aa4f03a7$export$2e2bcd8739ae039)(()=>{
        // Firefox only
        function onMozMousePixelScroll(e) {
            // scrolling at top/bottom limit
            const scrollingUpAtTop = isScrollAtTop && e.detail < 0;
            const scrollingDownAtBottom = isScrollAtBottom && e.detail > 0;
            if (useVirtual && !scrollingUpAtTop && !scrollingDownAtBottom) e.preventDefault();
        }
        const componentEle = componentRef.current;
        componentEle.addEventListener('wheel', onRawWheel, {
            passive: false
        });
        componentEle.addEventListener('DOMMouseScroll', onFireFoxScroll, {
            passive: true
        });
        componentEle.addEventListener('MozMousePixelScroll', onMozMousePixelScroll, {
            passive: false
        });
        return ()=>{
            componentEle.removeEventListener('wheel', onRawWheel);
            componentEle.removeEventListener('DOMMouseScroll', onFireFoxScroll);
            componentEle.removeEventListener('MozMousePixelScroll', onMozMousePixelScroll);
        };
    }, [
        useVirtual,
        isScrollAtTop,
        isScrollAtBottom
    ]);
    // Sync scroll left
    (0, $518ae471aa4f03a7$export$2e2bcd8739ae039)(()=>{
        if (scrollWidth) {
            const newOffsetLeft = keepInHorizontalRange(offsetLeft);
            setOffsetLeft(newOffsetLeft);
            triggerScroll({
                x: newOffsetLeft
            });
        }
    }, [
        size.width,
        scrollWidth
    ]);
    // ================================= Ref ==================================
    const delayHideScrollBar = ()=>{
        verticalScrollBarRef.current?.delayHidden();
        horizontalScrollBarRef.current?.delayHidden();
    };
    const getSize = (0, $ce89db4e81652662$export$a1d82723752af087)(mergedData, getKey, heights, itemHeight);
    const scrollTo = (0, $f43447a2ebba3f64$export$2e2bcd8739ae039)(componentRef, mergedData, heights, itemHeight, getKey, getSize, ()=>collectHeight(true), syncScrollTop, delayHideScrollBar);
    $5E6i4.useImperativeHandle(ref, ()=>({
            nativeElement: containerRef.current,
            getScrollInfo: getVirtualScrollInfo,
            scrollTo: (config)=>{
                function isPosScroll(arg) {
                    return arg && typeof arg === 'object' && ('left' in arg || 'top' in arg);
                }
                if (isPosScroll(config)) {
                    // Scroll X
                    if (config.left !== undefined) setOffsetLeft(keepInHorizontalRange(config.left));
                    // Scroll Y
                    scrollTo(config.top);
                } else scrollTo(config);
            }
        }));
    // ================================ Effect ================================
    /** We need told outside that some list not rendered */ (0, $518ae471aa4f03a7$export$2e2bcd8739ae039)(()=>{
        if (onVisibleChange) {
            const renderList = mergedData.slice(start, end + 1);
            onVisibleChange(renderList, mergedData);
        }
    }, [
        start,
        end,
        mergedData
    ]);
    // ================================ Extra =================================
    const extraContent = extraRender?.({
        start: start,
        end: end,
        virtual: inVirtual,
        offsetX: offsetLeft,
        scrollTop: offsetTop,
        offsetY: fillerOffset,
        rtl: isRTL,
        getSize: getSize
    });
    // ================================ Render ================================
    const listChildren = (0, $63f1f7cc6578a6d1$export$2e2bcd8739ae039)(mergedData, start, end, scrollWidth, offsetLeft, setInstanceRef, children, sharedConfig);
    let componentStyle = null;
    if (height) {
        componentStyle = {
            [fullHeight ? 'height' : 'maxHeight']: height,
            ...$3099990fc0ae0e67$var$ScrollStyle
        };
        if (useVirtual) {
            componentStyle.overflowY = 'hidden';
            if (scrollWidth) componentStyle.overflowX = 'hidden';
            if (scrollMoving) componentStyle.pointerEvents = 'none';
        }
    }
    const containerProps = {};
    if (isRTL) containerProps.dir = 'rtl';
    return /*#__PURE__*/ $5E6i4.createElement("div", $3099990fc0ae0e67$var$_extends({
        ref: containerRef,
        style: {
            ...style,
            position: 'relative'
        },
        className: mergedClassName
    }, containerProps, restProps), /*#__PURE__*/ $5E6i4.createElement((0, $3a396118caae8741$export$2e2bcd8739ae039), {
        onResize: onHolderResize
    }, /*#__PURE__*/ $5E6i4.createElement(Component, {
        className: `${prefixCls}-holder`,
        style: componentStyle,
        ref: componentRef,
        onScroll: onFallbackScroll,
        onMouseEnter: delayHideScrollBar
    }, /*#__PURE__*/ $5E6i4.createElement((0, $963d6756fdbd2f36$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        height: scrollHeight,
        offsetX: offsetLeft,
        offsetY: fillerOffset,
        scrollWidth: scrollWidth,
        onInnerResize: collectHeight,
        ref: fillerInnerRef,
        innerProps: innerProps,
        rtl: isRTL,
        extra: extraContent
    }, listChildren))), inVirtual && scrollHeight > height && /*#__PURE__*/ $5E6i4.createElement((0, $3ae37e0b942ef93f$export$2e2bcd8739ae039), {
        ref: verticalScrollBarRef,
        prefixCls: prefixCls,
        scrollOffset: offsetTop,
        scrollRange: scrollHeight,
        rtl: isRTL,
        onScroll: onScrollBar,
        onStartMove: onScrollbarStartMove,
        onStopMove: onScrollbarStopMove,
        spinSize: verticalScrollBarSpinSize,
        containerSize: size.height,
        style: styles?.verticalScrollBar,
        thumbStyle: styles?.verticalScrollBarThumb,
        showScrollBar: showScrollBar
    }), inVirtual && scrollWidth > size.width && /*#__PURE__*/ $5E6i4.createElement((0, $3ae37e0b942ef93f$export$2e2bcd8739ae039), {
        ref: horizontalScrollBarRef,
        prefixCls: prefixCls,
        scrollOffset: offsetLeft,
        scrollRange: scrollWidth,
        rtl: isRTL,
        onScroll: onScrollBar,
        onStartMove: onScrollbarStartMove,
        onStopMove: onScrollbarStopMove,
        spinSize: horizontalScrollBarSpinSize,
        containerSize: size.width,
        horizontal: true,
        style: styles?.horizontalScrollBar,
        thumbStyle: styles?.horizontalScrollBarThumb,
        showScrollBar: showScrollBar
    }));
}
const $3099990fc0ae0e67$var$List = /*#__PURE__*/ $5E6i4.forwardRef($3099990fc0ae0e67$export$cc3be4e46e8486ed);
$3099990fc0ae0e67$var$List.displayName = 'List';
var $3099990fc0ae0e67$export$2e2bcd8739ae039 = $3099990fc0ae0e67$var$List;



var $5E6i4 = parcelRequire("5E6i4");

const $9c521479cc343c12$var$List = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>(0, $3099990fc0ae0e67$export$cc3be4e46e8486ed)({
        ...props,
        virtual: false
    }, ref));
$9c521479cc343c12$var$List.displayName = 'List';
var $9c521479cc343c12$export$2e2bcd8739ae039 = $9c521479cc343c12$var$List;


var $75a873d99b2d1d23$export$2e2bcd8739ae039 = (0, $3099990fc0ae0e67$export$2e2bcd8739ae039);



var $5E6i4 = parcelRequire("5E6i4");



/* istanbul ignore file */ function $0f2d09672a1e097c$export$3bbcfec016973a77() {
    return /(mac\sos|macintosh)/i.test(navigator.appVersion);
}



function $ffe5269d4e4beef0$var$_extends() {
    $ffe5269d4e4beef0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ffe5269d4e4beef0$var$_extends.apply(this, arguments);
}
// export interface OptionListProps<OptionsType extends object[]> {
function $ffe5269d4e4beef0$var$isTitleType(content) {
    return typeof content === 'string' || typeof content === 'number';
}
/**
 * Using virtual list of option display.
 * Will fallback to dom if use customize render.
 */ const $ffe5269d4e4beef0$var$OptionList = (_, ref)=>{
    const { prefixCls: prefixCls, id: id, open: open, multiple: multiple, mode: mode, searchValue: searchValue, toggleOpen: toggleOpen, notFoundContent: notFoundContent, onPopupScroll: onPopupScroll, showScrollBar: showScrollBar, lockOptions: lockOptions } = (0, $f8edc52e57f85cd2$export$2e2bcd8739ae039)();
    const { maxCount: maxCount, flattenOptions: flattenOptions, onActiveValue: onActiveValue, defaultActiveFirstOption: defaultActiveFirstOption, onSelect: onSelect, menuItemSelectedIcon: menuItemSelectedIcon, rawValues: rawValues, fieldNames: fieldNames, virtual: virtual, direction: direction, listHeight: listHeight, listItemHeight: listItemHeight, optionRender: optionRender, classNames: contextClassNames, styles: contextStyles } = $5E6i4.useContext((0, $16a1c90a675c0816$export$2e2bcd8739ae039));
    const itemPrefixCls = `${prefixCls}-item`;
    const memoFlattenOptions = (0, $8ae08502d6a327d3$export$2e2bcd8739ae039)(()=>flattenOptions, [
        open,
        lockOptions
    ], (prev, next)=>next[0] && !next[1]);
    // =========================== List ===========================
    const listRef = $5E6i4.useRef(null);
    const overMaxCount = $5E6i4.useMemo(()=>multiple && (0, $3ce246e399c3e069$export$be48fd776273e509)(maxCount) && rawValues?.size >= maxCount, [
        multiple,
        maxCount,
        rawValues?.size
    ]);
    const onListMouseDown = (event)=>{
        event.preventDefault();
    };
    const scrollIntoView = (args)=>{
        listRef.current?.scrollTo(typeof args === 'number' ? {
            index: args
        } : args);
    };
    // https://github.com/ant-design/ant-design/issues/34975
    const isSelected = $5E6i4.useCallback((value)=>{
        if (mode === 'combobox') return false;
        return rawValues.has(value);
    }, [
        mode,
        [
            ...rawValues
        ].toString(),
        rawValues.size
    ]);
    // ========================== Active ==========================
    const getEnabledActiveIndex = (index, offset = 1)=>{
        const len = memoFlattenOptions.length;
        for(let i = 0; i < len; i += 1){
            const current = (index + i * offset + len) % len;
            const { group: group, data: data } = memoFlattenOptions[current] || {};
            if (!group && !data?.disabled && (isSelected(data.value) || !overMaxCount)) return current;
        }
        return -1;
    };
    const [activeIndex, setActiveIndex] = $5E6i4.useState(()=>getEnabledActiveIndex(0));
    const setActive = (index, fromKeyboard = false)=>{
        setActiveIndex(index);
        const info = {
            source: fromKeyboard ? 'keyboard' : 'mouse'
        };
        // Trigger active event
        const flattenItem = memoFlattenOptions[index];
        if (!flattenItem) {
            onActiveValue(null, -1, info);
            return;
        }
        onActiveValue(flattenItem.value, index, info);
    };
    // Auto active first item when list length or searchValue changed
    (0, $5E6i4.useEffect)(()=>{
        setActive(defaultActiveFirstOption !== false ? getEnabledActiveIndex(0) : -1);
    }, [
        memoFlattenOptions.length,
        searchValue
    ]);
    // https://github.com/ant-design/ant-design/issues/48036
    const isAriaSelected = $5E6i4.useCallback((value)=>{
        if (mode === 'combobox') return String(value).toLowerCase() === searchValue.toLowerCase();
        return rawValues.has(value);
    }, [
        mode,
        searchValue,
        [
            ...rawValues
        ].toString(),
        rawValues.size
    ]);
    // Auto scroll to item position in single mode
    (0, $5E6i4.useEffect)(()=>{
        /**
     * React will skip `onChange` when component update.
     * `setActive` function will call root accessibility state update which makes re-render.
     * So we need to delay to let Input component trigger onChange first.
     */ let timeoutId;
        if (!multiple && open && rawValues.size === 1) {
            const value = Array.from(rawValues)[0];
            // Scroll to the option closest to the searchValue if searching.
            const index = memoFlattenOptions.findIndex(({ data: data })=>searchValue ? String(data.value).startsWith(searchValue) : data.value === value);
            if (index !== -1) {
                setActive(index);
                timeoutId = setTimeout(()=>{
                    scrollIntoView(index);
                });
            }
        }
        // Force trigger scrollbar visible when open
        if (open) listRef.current?.scrollTo(undefined);
        return ()=>clearTimeout(timeoutId);
    }, [
        open,
        searchValue
    ]);
    // ========================== Values ==========================
    const onSelectValue = (value)=>{
        if (value !== undefined) onSelect(value, {
            selected: !rawValues.has(value)
        });
        // Single mode should always close by select
        if (!multiple) toggleOpen(false);
    };
    // ========================= Keyboard =========================
    $5E6i4.useImperativeHandle(ref, ()=>({
            onKeyDown: (event)=>{
                const { which: which, ctrlKey: ctrlKey } = event;
                switch(which){
                    // >>> Arrow keys & ctrl + n/p on Mac
                    case (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).N:
                    case (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).P:
                    case (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).UP:
                    case (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).DOWN:
                        {
                            let offset = 0;
                            if (which === (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).UP) offset = -1;
                            else if (which === (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).DOWN) offset = 1;
                            else if ((0, $0f2d09672a1e097c$export$3bbcfec016973a77)() && ctrlKey) {
                                if (which === (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).N) offset = 1;
                                else if (which === (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).P) offset = -1;
                            }
                            if (offset !== 0) {
                                const nextActiveIndex = getEnabledActiveIndex(activeIndex + offset, offset);
                                scrollIntoView(nextActiveIndex);
                                setActive(nextActiveIndex, true);
                            }
                            break;
                        }
                    // >>> Select (Tab / Enter)
                    case (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).TAB:
                    case (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).ENTER:
                        {
                            // value
                            const item = memoFlattenOptions[activeIndex];
                            if (!item || item.data.disabled) return onSelectValue(undefined);
                            if (!overMaxCount || rawValues.has(item.value)) onSelectValue(item.value);
                            else onSelectValue(undefined);
                            if (open) event.preventDefault();
                            break;
                        }
                    // >>> Close
                    case (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).ESC:
                        toggleOpen(false);
                        if (open) event.stopPropagation();
                }
            },
            onKeyUp: ()=>{},
            scrollTo: (index)=>{
                scrollIntoView(index);
            }
        }));
    // ========================== Render ==========================
    if (memoFlattenOptions.length === 0) return /*#__PURE__*/ $5E6i4.createElement("div", {
        role: "listbox",
        id: `${id}_list`,
        className: `${itemPrefixCls}-empty`,
        onMouseDown: onListMouseDown
    }, notFoundContent);
    const omitFieldNameList = Object.keys(fieldNames).map((key)=>fieldNames[key]);
    const getLabel = (item)=>item.label;
    function getItemAriaProps(item, index) {
        const { group: group } = item;
        return {
            role: group ? 'presentation' : 'option',
            id: `${id}_list_${index}`
        };
    }
    const renderItem = (index)=>{
        const item = memoFlattenOptions[index];
        if (!item) return null;
        const itemData = item.data || {};
        const { value: value, disabled: disabled } = itemData;
        const { group: group } = item;
        const attrs = (0, $78cde6532419ffca$export$2e2bcd8739ae039)(itemData, true);
        const mergedLabel = getLabel(item);
        return item ? /*#__PURE__*/ $5E6i4.createElement("div", $ffe5269d4e4beef0$var$_extends({
            "aria-label": typeof mergedLabel === 'string' && !group ? mergedLabel : null
        }, attrs, {
            key: index
        }, getItemAriaProps(item, index), {
            "aria-selected": isAriaSelected(value),
            "aria-disabled": disabled
        }), value) : null;
    };
    const a11yProps = {
        role: 'listbox',
        id: `${id}_list`
    };
    return /*#__PURE__*/ $5E6i4.createElement($5E6i4.Fragment, null, virtual && /*#__PURE__*/ $5E6i4.createElement("div", $ffe5269d4e4beef0$var$_extends({}, a11yProps, {
        style: {
            height: 0,
            width: 0,
            overflow: 'hidden'
        }
    }), renderItem(activeIndex - 1), renderItem(activeIndex), renderItem(activeIndex + 1)), /*#__PURE__*/ $5E6i4.createElement((0, $75a873d99b2d1d23$export$2e2bcd8739ae039), {
        prefixCls: `${prefixCls}-dropdown-list`,
        itemKey: "key",
        ref: listRef,
        data: memoFlattenOptions,
        height: listHeight,
        itemHeight: listItemHeight,
        fullHeight: false,
        onMouseDown: onListMouseDown,
        onScroll: onPopupScroll,
        virtual: virtual,
        direction: direction,
        innerProps: virtual ? null : a11yProps,
        showScrollBar: showScrollBar,
        className: contextClassNames?.popup?.list,
        style: contextStyles?.popup?.list
    }, (item, itemIndex)=>{
        const { group: group, groupOption: groupOption, data: data, label: label, value: value } = item;
        const { key: key } = data;
        // Group
        if (group) {
            const groupTitle = data.title ?? ($ffe5269d4e4beef0$var$isTitleType(label) ? label.toString() : undefined);
            return /*#__PURE__*/ $5E6i4.createElement("div", {
                className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(itemPrefixCls, `${itemPrefixCls}-group`, data.className),
                title: groupTitle
            }, label !== undefined ? label : key);
        }
        const { disabled: disabled, title: title, children: children, style: style, className: className, ...otherProps } = data;
        const passedProps = (0, $48bd91d9f828de66$export$2e2bcd8739ae039)(otherProps, omitFieldNameList);
        // Option
        const selected = isSelected(value);
        const mergedDisabled = disabled || !selected && overMaxCount;
        const optionPrefixCls = `${itemPrefixCls}-option`;
        const optionClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(itemPrefixCls, optionPrefixCls, className, contextClassNames?.popup?.listItem, {
            [`${optionPrefixCls}-grouped`]: groupOption,
            [`${optionPrefixCls}-active`]: activeIndex === itemIndex && !mergedDisabled,
            [`${optionPrefixCls}-disabled`]: mergedDisabled,
            [`${optionPrefixCls}-selected`]: selected
        });
        const mergedLabel = getLabel(item);
        const iconVisible = !menuItemSelectedIcon || typeof menuItemSelectedIcon === 'function' || selected;
        // https://github.com/ant-design/ant-design/issues/34145
        const content = typeof mergedLabel === 'number' ? mergedLabel : mergedLabel || value;
        // https://github.com/ant-design/ant-design/issues/26717
        let optionTitle = $ffe5269d4e4beef0$var$isTitleType(content) ? content.toString() : undefined;
        if (title !== undefined) optionTitle = title;
        return /*#__PURE__*/ $5E6i4.createElement("div", $ffe5269d4e4beef0$var$_extends({}, (0, $78cde6532419ffca$export$2e2bcd8739ae039)(passedProps), !virtual ? getItemAriaProps(item, itemIndex) : {}, {
            "aria-selected": virtual ? undefined : isAriaSelected(value),
            "aria-disabled": mergedDisabled,
            className: optionClassName,
            title: optionTitle,
            onMouseMove: ()=>{
                if (activeIndex === itemIndex || mergedDisabled) return;
                setActive(itemIndex);
            },
            onClick: ()=>{
                if (!mergedDisabled) onSelectValue(value);
            },
            style: {
                ...contextStyles?.popup?.listItem,
                ...style
            }
        }), /*#__PURE__*/ $5E6i4.createElement("div", {
            className: `${optionPrefixCls}-content`
        }, typeof optionRender === 'function' ? optionRender(item, {
            index: itemIndex
        }) : content), /*#__PURE__*/ $5E6i4.isValidElement(menuItemSelectedIcon) || selected, iconVisible && /*#__PURE__*/ $5E6i4.createElement((0, $67d82b95e172ce8b$export$2e2bcd8739ae039), {
            className: `${itemPrefixCls}-option-state`,
            customizeIcon: menuItemSelectedIcon,
            customizeIconProps: {
                value: value,
                disabled: mergedDisabled,
                isSelected: selected
            }
        }, selected ? "\u2713" : null));
    }));
};
const $ffe5269d4e4beef0$var$RefOptionList = /*#__PURE__*/ $5E6i4.forwardRef($ffe5269d4e4beef0$var$OptionList);
var $ffe5269d4e4beef0$export$2e2bcd8739ae039 = $ffe5269d4e4beef0$var$RefOptionList;




var $5E6i4 = parcelRequire("5E6i4");
var /**
 * Cache `value` related LabeledValue & options.
 */ $57b34f1c19cfa3c8$export$2e2bcd8739ae039 = (labeledValues, valueOptions)=>{
    const cacheRef = $5E6i4.useRef({
        values: new Map(),
        options: new Map()
    });
    const filledLabeledValues = $5E6i4.useMemo(()=>{
        const { values: prevValueCache, options: prevOptionCache } = cacheRef.current;
        // Fill label by cache
        const patchedValues = labeledValues.map((item)=>{
            if (item.label === undefined) return {
                ...item,
                label: prevValueCache.get(item.value)?.label
            };
            return item;
        });
        // Refresh cache
        const valueCache = new Map();
        const optionCache = new Map();
        patchedValues.forEach((item)=>{
            valueCache.set(item.value, item);
            optionCache.set(item.value, valueOptions.get(item.value) || prevOptionCache.get(item.value));
        });
        cacheRef.current.values = valueCache;
        cacheRef.current.options = optionCache;
        return patchedValues;
    }, [
        labeledValues,
        valueOptions
    ]);
    const getOption = $5E6i4.useCallback((val)=>valueOptions.get(val) || cacheRef.current.options.get(val), [
        valueOptions
    ]);
    return [
        filledLabeledValues,
        getOption
    ];
};



var $5E6i4 = parcelRequire("5E6i4");


function $8506ae0ee4831011$var$includes(test, search) {
    return (0, $b61800e39bc1fac7$export$45b10814cc054894)(test).join('').toUpperCase().includes(search);
}
var $8506ae0ee4831011$export$2e2bcd8739ae039 = (options, fieldNames, searchValue, filterOption, optionFilterProp)=>{
    return $5E6i4.useMemo(()=>{
        if (!searchValue || filterOption === false) return options;
        const { options: fieldOptions, label: fieldLabel, value: fieldValue } = fieldNames;
        const filteredOptions = [];
        const customizeFilter = typeof filterOption === 'function';
        const upperSearch = searchValue.toUpperCase();
        const filterFunc = customizeFilter ? filterOption : (_, option)=>{
            // Use provided `optionFilterProp`
            if (optionFilterProp && optionFilterProp.length) return optionFilterProp.some((prop)=>$8506ae0ee4831011$var$includes(option[prop], upperSearch));
            // Auto select `label` or `value` by option type
            if (option[fieldOptions]) // hack `fieldLabel` since `OptionGroup` children is not `label`
            return $8506ae0ee4831011$var$includes(option[fieldLabel !== 'children' ? fieldLabel : 'label'], upperSearch);
            return $8506ae0ee4831011$var$includes(option[fieldValue], upperSearch);
        };
        const wrapOption = customizeFilter ? (opt)=>(0, $3ce246e399c3e069$export$d0b21b213c8c013c)(opt) : (opt)=>opt;
        options.forEach((item)=>{
            // Group should check child options
            if (item[fieldOptions]) {
                // Check group first
                const matchGroup = filterFunc(searchValue, wrapOption(item));
                if (matchGroup) filteredOptions.push(item);
                else {
                    // Check option
                    const subOptions = item[fieldOptions].filter((subItem)=>filterFunc(searchValue, wrapOption(subItem)));
                    if (subOptions.length) filteredOptions.push({
                        ...item,
                        [fieldOptions]: subOptions
                    });
                }
                return;
            }
            if (filterFunc(searchValue, wrapOption(item))) filteredOptions.push(item);
        });
        return filteredOptions;
    }, [
        options,
        filterOption,
        optionFilterProp,
        searchValue,
        fieldNames
    ]);
};



var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");

function $b7011195d9dbdcc6$var$convertNodeToOption(node) {
    const { key: key, props: { children: children, value: value, ...restProps } } = node;
    return {
        key: key,
        value: value !== undefined ? value : key,
        children: children,
        ...restProps
    };
}
function $b7011195d9dbdcc6$export$3beca35db74c3985(nodes, optionOnly = false) {
    return (0, $2ec1a2166f2295ea$export$2e2bcd8739ae039)(nodes).map((node, index)=>{
        if (!/*#__PURE__*/ $5E6i4.isValidElement(node) || !node.type) return null;
        const { type: { isSelectOptGroup: isSelectOptGroup }, key: key, props: { children: children, ...restProps } } = node;
        if (optionOnly || !isSelectOptGroup) return $b7011195d9dbdcc6$var$convertNodeToOption(node);
        return {
            key: `__RC_SELECT_GRP__${key === null ? index : key}__`,
            label: key,
            ...restProps,
            options: $b7011195d9dbdcc6$export$3beca35db74c3985(children)
        };
    }).filter((data)=>data);
}


/**
 * Parse `children` to `options` if `options` is not provided.
 * Then flatten the `options`.
 */ const $d2fc2be924ec6158$var$useOptions = (options, children, fieldNames, optionFilterProp, optionLabelProp)=>{
    return $5E6i4.useMemo(()=>{
        let mergedOptions = options;
        const childrenAsData = !options;
        if (childrenAsData) mergedOptions = (0, $b7011195d9dbdcc6$export$3beca35db74c3985)(children);
        const valueOptions = new Map();
        const labelOptions = new Map();
        const setLabelOptions = (labelOptionsMap, option, key)=>{
            if (key && typeof key === 'string') labelOptionsMap.set(option[key], option);
        };
        const dig = (optionList, isChildren = false)=>{
            // for loop to speed up collection speed
            for(let i = 0; i < optionList.length; i += 1){
                const option = optionList[i];
                if (!option[fieldNames.options] || isChildren) {
                    valueOptions.set(option[fieldNames.value], option);
                    setLabelOptions(labelOptions, option, fieldNames.label);
                    // https://github.com/ant-design/ant-design/issues/35304
                    optionFilterProp.forEach((prop)=>{
                        setLabelOptions(labelOptions, option, prop);
                    });
                    setLabelOptions(labelOptions, option, optionLabelProp);
                } else dig(option[fieldNames.options], true);
            }
        };
        dig(mergedOptions);
        return {
            options: mergedOptions,
            valueOptions: valueOptions,
            labelOptions: labelOptions
        };
    }, [
        options,
        children,
        fieldNames,
        optionFilterProp,
        optionLabelProp
    ]);
};
var $d2fc2be924ec6158$export$2e2bcd8739ae039 = $d2fc2be924ec6158$var$useOptions;



var $5E6i4 = parcelRequire("5E6i4");
function $b8f0d5caf7f1e667$export$2e2bcd8739ae039(callback) {
    const funcRef = $5E6i4.useRef(callback);
    funcRef.current = callback;
    const cacheFn = $5E6i4.useCallback((...args)=>{
        return funcRef.current(...args);
    }, []);
    return cacheFn;
}






var $5E6i4 = parcelRequire("5E6i4");



function $42ab4bbcaa6d7aa5$var$warningProps(props) {
    const { mode: mode, options: options, children: children, backfill: backfill, allowClear: allowClear, placeholder: placeholder, getInputElement: getInputElement, showSearch: showSearch, onSearch: onSearch, defaultOpen: defaultOpen, autoFocus: autoFocus, labelInValue: labelInValue, value: value, optionLabelProp: optionLabelProp } = props;
    const multiple = (0, $32059bf47b698759$export$7f654ad2a77ad2ac)(mode);
    const mergedShowSearch = showSearch !== undefined ? showSearch : multiple || mode === 'combobox';
    const mergedOptions = options || (0, $b7011195d9dbdcc6$export$3beca35db74c3985)(children);
    // `tags` should not set option as disabled
    (0, $f757b9ac02fa080d$export$2e2bcd8739ae039)(mode !== 'tags' || mergedOptions.every((opt)=>!opt.disabled), 'Please avoid setting option to disabled in tags mode since user can always type text as tag.');
    // `combobox` & `tags` should option be `string` type
    if (mode === 'tags' || mode === 'combobox') {
        const hasNumberValue = mergedOptions.some((item)=>{
            if (item.options) return item.options.some((opt)=>typeof ('value' in opt ? opt.value : opt.key) === 'number');
            return typeof ('value' in item ? item.value : item.key) === 'number';
        });
        (0, $f757b9ac02fa080d$export$2e2bcd8739ae039)(!hasNumberValue, '`value` of Option should not use number type when `mode` is `tags` or `combobox`.');
    }
    // `combobox` should not use `optionLabelProp`
    (0, $f757b9ac02fa080d$export$2e2bcd8739ae039)(mode !== 'combobox' || !optionLabelProp, '`combobox` mode not support `optionLabelProp`. Please set `value` on Option directly.');
    // Only `combobox` support `backfill`
    (0, $f757b9ac02fa080d$export$2e2bcd8739ae039)(mode === 'combobox' || !backfill, '`backfill` only works with `combobox` mode.');
    // Only `combobox` support `getInputElement`
    (0, $f757b9ac02fa080d$export$2e2bcd8739ae039)(mode === 'combobox' || !getInputElement, '`getInputElement` only work with `combobox` mode.');
    // Customize `getInputElement` should not use `allowClear` & `placeholder`
    (0, $f757b9ac02fa080d$export$89ff31684837bbbf)(mode !== 'combobox' || !getInputElement || !allowClear || !placeholder, 'Customize `getInputElement` should customize clear and placeholder logic instead of configuring `allowClear` and `placeholder`.');
    // `onSearch` should use in `combobox` or `showSearch`
    if (onSearch && !mergedShowSearch && mode !== 'combobox' && mode !== 'tags') (0, $f757b9ac02fa080d$export$2e2bcd8739ae039)(false, '`onSearch` should work with `showSearch` instead of use alone.');
    (0, $f757b9ac02fa080d$export$89ff31684837bbbf)(!defaultOpen || autoFocus, '`defaultOpen` makes Select open without focus which means it will not close by click outside. You can set `autoFocus` if needed.');
    if (value !== undefined && value !== null) {
        const values = (0, $b61800e39bc1fac7$export$45b10814cc054894)(value);
        (0, $f757b9ac02fa080d$export$2e2bcd8739ae039)(!labelInValue || values.every((val)=>typeof val === 'object' && ('key' in val || 'value' in val)), '`value` should in shape of `{ value: string | number, label?: ReactNode }` when you set `labelInValue` to `true`');
        (0, $f757b9ac02fa080d$export$2e2bcd8739ae039)(!multiple || Array.isArray(value), '`value` should be array when `mode` is `multiple` or `tags`');
    }
    // Syntactic sugar should use correct children type
    if (children) {
        let invalidateChildType = null;
        (0, $2ec1a2166f2295ea$export$2e2bcd8739ae039)(children).some((node)=>{
            if (!/*#__PURE__*/ $5E6i4.isValidElement(node) || !node.type) return false;
            const { type: type } = node;
            if (type.isSelectOption) return false;
            if (type.isSelectOptGroup) {
                const allChildrenValid = (0, $2ec1a2166f2295ea$export$2e2bcd8739ae039)(node.props.children).every((subNode)=>{
                    if (!/*#__PURE__*/ $5E6i4.isValidElement(subNode) || !node.type || subNode.type.isSelectOption) return true;
                    invalidateChildType = subNode.type;
                    return false;
                });
                if (allChildrenValid) return false;
                return true;
            }
            invalidateChildType = type;
            return true;
        });
        if (invalidateChildType) (0, $f757b9ac02fa080d$export$2e2bcd8739ae039)(false, `\`children\` should be \`Select.Option\` or \`Select.OptGroup\` instead of \`${invalidateChildType.displayName || invalidateChildType.name || invalidateChildType}\`.`);
    }
}
function $42ab4bbcaa6d7aa5$export$c33a1be4de1ec2c(options, fieldNames) {
    if (options) {
        const recursiveOptions = (optionsList, inGroup = false)=>{
            for(let i = 0; i < optionsList.length; i++){
                const option = optionsList[i];
                if (option[fieldNames?.value] === null) {
                    (0, $f757b9ac02fa080d$export$2e2bcd8739ae039)(false, '`value` in Select options should not be `null`.');
                    return true;
                }
                if (!inGroup && Array.isArray(option[fieldNames?.options]) && recursiveOptions(option[fieldNames?.options], true)) break;
            }
        };
        recursiveOptions(options);
    }
}
var $42ab4bbcaa6d7aa5$export$2e2bcd8739ae039 = $42ab4bbcaa6d7aa5$var$warningProps;



var $5E6i4 = parcelRequire("5E6i4");
function $2847dab7330aefe4$export$2e2bcd8739ae039(showSearch, props, mode) {
    const { filterOption: filterOption, searchValue: searchValue, optionFilterProp: optionFilterProp, filterSort: filterSort, onSearch: onSearch, autoClearSearchValue: autoClearSearchValue } = props;
    return $5E6i4.useMemo(()=>{
        const isObject = typeof showSearch === 'object';
        const searchConfig = {
            filterOption: filterOption,
            searchValue: searchValue,
            optionFilterProp: optionFilterProp,
            filterSort: filterSort,
            onSearch: onSearch,
            autoClearSearchValue: autoClearSearchValue,
            ...isObject ? showSearch : {}
        };
        return [
            isObject || mode === 'combobox' || mode === 'tags' || mode === 'multiple' && showSearch === undefined ? true : showSearch,
            searchConfig
        ];
    }, [
        mode,
        showSearch,
        filterOption,
        searchValue,
        optionFilterProp,
        filterSort,
        onSearch,
        autoClearSearchValue
    ]);
}


function $7335896b854451df$var$_extends() {
    $7335896b854451df$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7335896b854451df$var$_extends.apply(this, arguments);
}
const $7335896b854451df$var$OMIT_DOM_PROPS = [
    'inputValue'
];
function $7335896b854451df$var$isRawValue(value) {
    return !value || typeof value !== 'object';
}
const $7335896b854451df$var$Select = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { id: id, mode: mode, prefixCls: prefixCls = 'rc-select', backfill: backfill, fieldNames: fieldNames, showSearch: // Search
    showSearch, searchValue: legacySearchValue, onSearch: legacyOnSearch, autoClearSearchValue: legacyAutoClearSearchValue, filterOption: legacyFilterOption, optionFilterProp: legacyOptionFilterProp, filterSort: legacyFilterSort, onSelect: // Select
    onSelect, onDeselect: onDeselect, onActive: onActive, popupMatchSelectWidth: popupMatchSelectWidth = true, optionLabelProp: optionLabelProp, options: options, optionRender: optionRender, children: children, defaultActiveFirstOption: defaultActiveFirstOption, menuItemSelectedIcon: menuItemSelectedIcon, virtual: virtual, direction: direction, listHeight: listHeight = 200, listItemHeight: listItemHeight = 20, labelRender: labelRender, value: // Value
    value, defaultValue: defaultValue, labelInValue: labelInValue, onChange: onChange, maxCount: maxCount, classNames: classNames, styles: styles, ...restProps } = props;
    const searchProps = {
        searchValue: legacySearchValue,
        onSearch: legacyOnSearch,
        autoClearSearchValue: legacyAutoClearSearchValue,
        filterOption: legacyFilterOption,
        optionFilterProp: legacyOptionFilterProp,
        filterSort: legacyFilterSort
    };
    const [mergedShowSearch, searchConfig] = (0, $2847dab7330aefe4$export$2e2bcd8739ae039)(showSearch, searchProps, mode);
    const { filterOption: filterOption, searchValue: searchValue, optionFilterProp: optionFilterProp, filterSort: filterSort, onSearch: onSearch, autoClearSearchValue: autoClearSearchValue = true } = searchConfig;
    const normalizedOptionFilterProp = $5E6i4.useMemo(()=>{
        if (!optionFilterProp) return [];
        return Array.isArray(optionFilterProp) ? optionFilterProp : [
            optionFilterProp
        ];
    }, [
        optionFilterProp
    ]);
    const mergedId = (0, $378d6dcdebc6b864$export$2e2bcd8739ae039)(id);
    const multiple = (0, $32059bf47b698759$export$7f654ad2a77ad2ac)(mode);
    const childrenAsData = !!(!options && children);
    const mergedFilterOption = $5E6i4.useMemo(()=>{
        if (filterOption === undefined && mode === 'combobox') return false;
        return filterOption;
    }, [
        filterOption,
        mode
    ]);
    // ========================= FieldNames =========================
    const mergedFieldNames = $5E6i4.useMemo(()=>(0, $3ce246e399c3e069$export$6c519d302dced239)(fieldNames, childrenAsData), /* eslint-disable react-hooks/exhaustive-deps */ [
        // We stringify fieldNames to avoid unnecessary re-renders.
        JSON.stringify(fieldNames),
        childrenAsData
    ]);
    // =========================== Search ===========================
    const [internalSearchValue, setSearchValue] = (0, $e18df22f16a16360$export$2e2bcd8739ae039)('', searchValue);
    const mergedSearchValue = internalSearchValue || '';
    // =========================== Option ===========================
    const parsedOptions = (0, $d2fc2be924ec6158$export$2e2bcd8739ae039)(options, children, mergedFieldNames, normalizedOptionFilterProp, optionLabelProp);
    const { valueOptions: valueOptions, labelOptions: labelOptions, options: mergedOptions } = parsedOptions;
    // ========================= Wrap Value =========================
    const convert2LabelValues = $5E6i4.useCallback((draftValues)=>{
        // Convert to array
        const valueList = (0, $b61800e39bc1fac7$export$45b10814cc054894)(draftValues);
        // Convert to labelInValue type
        return valueList.map((val)=>{
            let rawValue;
            let rawLabel;
            let rawDisabled;
            let rawTitle;
            // Fill label & value
            if ($7335896b854451df$var$isRawValue(val)) rawValue = val;
            else {
                rawLabel = val.label;
                rawValue = val.value;
            }
            const option = valueOptions.get(rawValue);
            if (option) {
                // Fill missing props
                if (rawLabel === undefined) rawLabel = option?.[optionLabelProp || mergedFieldNames.label];
                rawDisabled = option?.disabled;
                rawTitle = option?.title;
            }
            return {
                label: rawLabel,
                value: rawValue,
                key: rawValue,
                disabled: rawDisabled,
                title: rawTitle
            };
        });
    }, [
        mergedFieldNames,
        optionLabelProp,
        valueOptions
    ]);
    // =========================== Values ===========================
    const [internalValue, setInternalValue] = (0, $e18df22f16a16360$export$2e2bcd8739ae039)(defaultValue, value);
    // Merged value with LabelValueType
    const rawLabeledValues = $5E6i4.useMemo(()=>{
        const newInternalValue = multiple && internalValue === null ? [] : internalValue;
        const values = convert2LabelValues(newInternalValue);
        // combobox no need save value when it's no value (exclude value equal 0)
        if (mode === 'combobox' && (0, $b61800e39bc1fac7$export$9d186c3672bb89c6)(values[0]?.value)) return [];
        return values;
    }, [
        internalValue,
        convert2LabelValues,
        mode,
        multiple
    ]);
    // Fill label with cache to avoid option remove
    const [mergedValues, getMixedOption] = (0, $57b34f1c19cfa3c8$export$2e2bcd8739ae039)(rawLabeledValues, valueOptions);
    const displayValues = $5E6i4.useMemo(()=>{
        // `null` need show as placeholder instead
        // https://github.com/ant-design/ant-design/issues/25057
        if (!mode && mergedValues.length === 1) {
            const firstValue = mergedValues[0];
            if (firstValue.value === null && (firstValue.label === null || firstValue.label === undefined)) return [];
        }
        return mergedValues.map((item)=>({
                ...item,
                label: (typeof labelRender === 'function' ? labelRender(item) : item.label) ?? item.value
            }));
    }, [
        mode,
        mergedValues,
        labelRender
    ]);
    /** Convert `displayValues` to raw value type set */ const rawValues = $5E6i4.useMemo(()=>new Set(mergedValues.map((val)=>val.value)), [
        mergedValues
    ]);
    $5E6i4.useEffect(()=>{
        if (mode === 'combobox') {
            const strValue = mergedValues[0]?.value;
            setSearchValue((0, $b61800e39bc1fac7$export$96bdbc84526f3739)(strValue) ? String(strValue) : '');
        }
    }, [
        mergedValues
    ]);
    // ======================= Display Option =======================
    // Create a placeholder item if not exist in `options`
    const createTagOption = (0, $b8f0d5caf7f1e667$export$2e2bcd8739ae039)((val, label)=>{
        const mergedLabel = label ?? val;
        return {
            [mergedFieldNames.value]: val,
            [mergedFieldNames.label]: mergedLabel
        };
    });
    // Fill tag as option if mode is `tags`
    const filledTagOptions = $5E6i4.useMemo(()=>{
        if (mode !== 'tags') return mergedOptions;
        // >>> Tag mode
        const cloneOptions = [
            ...mergedOptions
        ];
        // Check if value exist in options (include new patch item)
        const existOptions = (val)=>valueOptions.has(val);
        // Fill current value as option
        [
            ...mergedValues
        ].sort((a, b)=>a.value < b.value ? -1 : 1).forEach((item)=>{
            const val = item.value;
            if (!existOptions(val)) cloneOptions.push(createTagOption(val, item.label));
        });
        return cloneOptions;
    }, [
        createTagOption,
        mergedOptions,
        valueOptions,
        mergedValues,
        mode
    ]);
    const filteredOptions = (0, $8506ae0ee4831011$export$2e2bcd8739ae039)(filledTagOptions, mergedFieldNames, mergedSearchValue, mergedFilterOption, normalizedOptionFilterProp);
    // Fill options with search value if needed
    const filledSearchOptions = $5E6i4.useMemo(()=>{
        const hasItemMatchingSearch = (item)=>{
            if (normalizedOptionFilterProp.length) return normalizedOptionFilterProp.some((prop)=>item?.[prop] === mergedSearchValue);
            return item?.value === mergedSearchValue;
        };
        if (mode !== 'tags' || !mergedSearchValue || filteredOptions.some((item)=>hasItemMatchingSearch(item))) return filteredOptions;
        // ignore when search value equal select input value
        if (filteredOptions.some((item)=>item[mergedFieldNames.value] === mergedSearchValue)) return filteredOptions;
        // Skip creating temp tag option if it matches a disabled option value
        if (valueOptions.get(mergedSearchValue)?.disabled) return filteredOptions;
        // Fill search value as option
        return [
            createTagOption(mergedSearchValue),
            ...filteredOptions
        ];
    }, [
        createTagOption,
        normalizedOptionFilterProp,
        mode,
        filteredOptions,
        mergedSearchValue,
        mergedFieldNames,
        valueOptions
    ]);
    const sorter = (inputOptions)=>{
        const sortedOptions = [
            ...inputOptions
        ].sort((a, b)=>filterSort(a, b, {
                searchValue: mergedSearchValue
            }));
        return sortedOptions.map((item)=>{
            if (Array.isArray(item.options)) return {
                ...item,
                options: item.options.length > 0 ? sorter(item.options) : item.options
            };
            return item;
        });
    };
    const orderedFilteredOptions = $5E6i4.useMemo(()=>{
        if (!filterSort) return filledSearchOptions;
        return sorter(filledSearchOptions);
    }, [
        filledSearchOptions,
        filterSort,
        mergedSearchValue
    ]);
    const displayOptions = $5E6i4.useMemo(()=>(0, $3ce246e399c3e069$export$7baa7c13b358b002)(orderedFilteredOptions, {
            fieldNames: mergedFieldNames,
            childrenAsData: childrenAsData
        }), [
        orderedFilteredOptions,
        mergedFieldNames,
        childrenAsData
    ]);
    // =========================== Change ===========================
    const triggerChange = (values)=>{
        const labeledValues = convert2LabelValues(values);
        setInternalValue(labeledValues);
        if (onChange && // Trigger event only when value changed
        (labeledValues.length !== mergedValues.length || labeledValues.some((newVal, index)=>mergedValues[index]?.value !== newVal?.value))) {
            const returnValues = labelInValue ? labeledValues.map(({ label: l, value: v })=>({
                    label: l,
                    value: v
                })) : labeledValues.map((v)=>v.value);
            const returnOptions = labeledValues.map((v)=>(0, $3ce246e399c3e069$export$d0b21b213c8c013c)(getMixedOption(v.value)));
            onChange(// Value
            multiple ? returnValues : returnValues[0], // Option
            multiple ? returnOptions : returnOptions[0]);
        }
    };
    // ======================= Accessibility ========================
    const [activeValue, setActiveValue] = $5E6i4.useState(null);
    const [accessibilityIndex, setAccessibilityIndex] = $5E6i4.useState(0);
    const mergedDefaultActiveFirstOption = defaultActiveFirstOption !== undefined ? defaultActiveFirstOption : mode !== 'combobox';
    const activeEventRef = $5E6i4.useRef(undefined);
    const onActiveValue = $5E6i4.useCallback((active, index, { source: source = 'keyboard' } = {})=>{
        setAccessibilityIndex(index);
        if (backfill && mode === 'combobox' && active !== null && source === 'keyboard') setActiveValue(String(active));
        // Active will call multiple times.
        // We only need trigger the last one.
        const promise = Promise.resolve().then(()=>{
            if (activeEventRef.current === promise) onActive?.(active);
        });
        activeEventRef.current = promise;
    }, [
        backfill,
        mode,
        onActive
    ]);
    // ========================= OptionList =========================
    const triggerSelect = (val, selected, type)=>{
        const getSelectEnt = ()=>{
            const option = getMixedOption(val);
            return [
                labelInValue ? {
                    label: option?.[mergedFieldNames.label],
                    value: val
                } : val,
                (0, $3ce246e399c3e069$export$d0b21b213c8c013c)(option)
            ];
        };
        if (selected && onSelect) {
            const [wrappedValue, option] = getSelectEnt();
            onSelect(wrappedValue, option);
        } else if (!selected && onDeselect && type !== 'clear') {
            const [wrappedValue, option] = getSelectEnt();
            onDeselect(wrappedValue, option);
        }
    };
    // Used for OptionList selection
    const onInternalSelect = (0, $b8f0d5caf7f1e667$export$2e2bcd8739ae039)((val, info)=>{
        let cloneValues;
        // Single mode always trigger select only with option list
        const mergedSelect = multiple ? info.selected : true;
        if (mergedSelect) cloneValues = multiple ? [
            ...mergedValues,
            val
        ] : [
            val
        ];
        else cloneValues = mergedValues.filter((v)=>v.value !== val);
        triggerChange(cloneValues);
        triggerSelect(val, mergedSelect);
        // Clean search value if single or configured
        if (mode === 'combobox') setActiveValue('');
        else if (!(0, $32059bf47b698759$export$7f654ad2a77ad2ac) || autoClearSearchValue) {
            setSearchValue('');
            setActiveValue('');
        }
    });
    // ======================= Display Change =======================
    // BaseSelect display values change
    const onDisplayValuesChange = (nextValues, info)=>{
        triggerChange(nextValues);
        const { type: type, values: values } = info;
        if (type === 'remove' || type === 'clear') values.forEach((item)=>{
            triggerSelect(item.value, false, type);
        });
    };
    // =========================== Search ===========================
    const onInternalSearch = (searchText, info)=>{
        setSearchValue(searchText);
        setActiveValue(null);
        // [Submit] Tag mode should flush input
        if (info.source === 'submit') {
            const formatted = (searchText || '').trim();
            // prevent empty tags from appearing when you click the Enter button
            if (formatted) {
                // Skip disabled options in tags mode
                if (valueOptions.get(formatted)?.disabled) {
                    setSearchValue('');
                    return;
                }
                const newRawValues = Array.from(new Set([
                    ...rawValues,
                    formatted
                ]));
                triggerChange(newRawValues);
                triggerSelect(formatted, true);
                setSearchValue('');
            }
            return;
        }
        if (info.source !== 'blur') {
            if (mode === 'combobox') triggerChange(searchText);
            onSearch?.(searchText);
        }
    };
    const onInternalSearchSplit = (words)=>{
        let patchValues = words;
        if (mode !== 'tags') patchValues = words.map((word)=>{
            const opt = labelOptions.get(word);
            return opt?.value;
        }).filter((val)=>val !== undefined);
        // Filter out disabled option values in tags mode
        if (mode === 'tags') patchValues = patchValues.filter((val)=>!valueOptions.get(val)?.disabled);
        const newRawValues = Array.from(new Set([
            ...rawValues,
            ...patchValues
        ]));
        triggerChange(newRawValues);
        newRawValues.forEach((newRawValue)=>{
            triggerSelect(newRawValue, true);
        });
    };
    // ========================== Context ===========================
    const selectContext = $5E6i4.useMemo(()=>{
        const realVirtual = virtual !== false && popupMatchSelectWidth !== false;
        return {
            ...parsedOptions,
            flattenOptions: displayOptions,
            onActiveValue: onActiveValue,
            defaultActiveFirstOption: mergedDefaultActiveFirstOption,
            onSelect: onInternalSelect,
            menuItemSelectedIcon: menuItemSelectedIcon,
            rawValues: rawValues,
            fieldNames: mergedFieldNames,
            virtual: realVirtual,
            direction: direction,
            listHeight: listHeight,
            listItemHeight: listItemHeight,
            childrenAsData: childrenAsData,
            maxCount: maxCount,
            optionRender: optionRender,
            classNames: classNames,
            styles: styles
        };
    }, [
        maxCount,
        parsedOptions,
        displayOptions,
        onActiveValue,
        mergedDefaultActiveFirstOption,
        onInternalSelect,
        menuItemSelectedIcon,
        rawValues,
        mergedFieldNames,
        virtual,
        popupMatchSelectWidth,
        direction,
        listHeight,
        listItemHeight,
        childrenAsData,
        optionRender,
        classNames,
        styles
    ]);
    // ==============================================================
    // ==                          Render                          ==
    // ==============================================================
    return /*#__PURE__*/ $5E6i4.createElement((0, $16a1c90a675c0816$export$2e2bcd8739ae039).Provider, {
        value: selectContext
    }, /*#__PURE__*/ $5E6i4.createElement((0, $32059bf47b698759$export$2e2bcd8739ae039), $7335896b854451df$var$_extends({}, restProps, {
        // >>> MISC
        id: mergedId,
        prefixCls: prefixCls,
        ref: ref,
        omitDomProps: $7335896b854451df$var$OMIT_DOM_PROPS,
        mode: mode,
        classNames: classNames,
        styles: styles,
        displayValues: displayValues,
        onDisplayValuesChange: onDisplayValuesChange,
        maxCount: maxCount,
        direction: direction,
        showSearch: mergedShowSearch,
        searchValue: mergedSearchValue,
        onSearch: onInternalSearch,
        autoClearSearchValue: autoClearSearchValue,
        onSearchSplit: onInternalSearchSplit,
        popupMatchSelectWidth: popupMatchSelectWidth,
        OptionList: (0, $ffe5269d4e4beef0$export$2e2bcd8739ae039),
        emptyOptions: !displayOptions.length,
        activeValue: activeValue,
        activeDescendantId: `${mergedId}_list_${accessibilityIndex}`
    })));
});
const $7335896b854451df$var$TypedSelect = $7335896b854451df$var$Select;
$7335896b854451df$var$TypedSelect.Option = (0, $517d2aa070de0b1c$export$2e2bcd8739ae039);
$7335896b854451df$var$TypedSelect.OptGroup = (0, $d4ce7be070373b1a$export$2e2bcd8739ae039);
var $7335896b854451df$export$2e2bcd8739ae039 = $7335896b854451df$var$TypedSelect;






var $9ea266dab750ec84$export$2e2bcd8739ae039 = (0, $7335896b854451df$export$2e2bcd8739ae039);







const $90c6d941485868aa$var$normalizeIcon = (value, key, fallback)=>{
    if (value === false) return null; // Explicitly return null when value is false
    if (value === true) return fallback; // Return fallback when value is true
    // More explicit if statement, avoiding inline if
    if (value && key && value[key] !== undefined) return value[key]; // Return value[key] if it's explicitly defined
    return fallback; // Return fallback when no value is found
};
var $90c6d941485868aa$export$2e2bcd8739ae039 = $90c6d941485868aa$var$normalizeIcon;








var $5E6i4 = parcelRequire("5E6i4");


"use client";
const $683e48f5302a9848$var$DefaultRenderEmpty = (props)=>{
    const { componentName: componentName } = props;
    const { getPrefixCls: getPrefixCls } = (0, $5E6i4.useContext)((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
    const prefix = getPrefixCls('empty');
    switch(componentName){
        case 'Table':
        case 'List':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $3a3a0d3a83db59d1$export$2e2bcd8739ae039), {
                image: (0, $3a3a0d3a83db59d1$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE
            });
        case 'Select':
        case 'TreeSelect':
        case 'Cascader':
        case 'Transfer':
        case 'Mentions':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $3a3a0d3a83db59d1$export$2e2bcd8739ae039), {
                image: (0, $3a3a0d3a83db59d1$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                className: `${prefix}-small`
            });
        /**
     * This type of component should satisfy the nullish coalescing operator(??) on the left-hand side.
     * to let the component itself implement the logic.
     * For example `Table.filter`.
     */ case 'Table.filter':
            // why `null`? legacy react16 node type `undefined` is not allowed.
            return null;
        default:
            // Should never hit if we take all the component into consider.
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $3a3a0d3a83db59d1$export$2e2bcd8739ae039), null);
    }
};
var $683e48f5302a9848$export$2e2bcd8739ae039 = $683e48f5302a9848$var$DefaultRenderEmpty;









const $58eb6d395d8edc2e$var$getBuiltInPlacements = (popupOverflow)=>{
    const htmlRegion = popupOverflow === 'scroll' ? 'scroll' : 'visible';
    const sharedConfig = {
        overflow: {
            adjustX: true,
            adjustY: true,
            shiftY: true
        },
        htmlRegion: htmlRegion,
        dynamicInset: true
    };
    return {
        bottomLeft: {
            ...sharedConfig,
            points: [
                'tl',
                'bl'
            ],
            offset: [
                0,
                4
            ]
        },
        bottomRight: {
            ...sharedConfig,
            points: [
                'tr',
                'br'
            ],
            offset: [
                0,
                4
            ]
        },
        topLeft: {
            ...sharedConfig,
            points: [
                'bl',
                'tl'
            ],
            offset: [
                0,
                -4
            ]
        },
        topRight: {
            ...sharedConfig,
            points: [
                'br',
                'tr'
            ],
            offset: [
                0,
                -4
            ]
        }
    };
};
function $58eb6d395d8edc2e$var$mergedBuiltinPlacements(buildInPlacements, popupOverflow) {
    return buildInPlacements || $58eb6d395d8edc2e$var$getBuiltInPlacements(popupOverflow);
}
var $58eb6d395d8edc2e$export$2e2bcd8739ae039 = $58eb6d395d8edc2e$var$mergedBuiltinPlacements;







const $1631e1f97f1bf184$var$genItemStyle = (token)=>{
    const { optionHeight: optionHeight, optionFontSize: optionFontSize, optionLineHeight: optionLineHeight, optionPadding: optionPadding } = token;
    return {
        position: 'relative',
        display: 'block',
        minHeight: optionHeight,
        padding: optionPadding,
        color: token.colorText,
        fontWeight: 400,
        fontSize: optionFontSize,
        lineHeight: optionLineHeight,
        boxSizing: 'border-box'
    };
};
const $1631e1f97f1bf184$var$genSingleStyle = (token)=>{
    const { antCls: antCls, componentCls: componentCls } = token;
    const selectItemCls = `${componentCls}-item`;
    const slideUpEnterActive = `&${antCls}-slide-up-enter${antCls}-slide-up-enter-active`;
    const slideUpAppearActive = `&${antCls}-slide-up-appear${antCls}-slide-up-appear-active`;
    const slideUpLeaveActive = `&${antCls}-slide-up-leave${antCls}-slide-up-leave-active`;
    const dropdownPlacementCls = `${componentCls}-dropdown-placement-`;
    const selectedItemCls = `${selectItemCls}-option-selected`;
    return [
        {
            [`${componentCls}-dropdown`]: {
                // ========================== Popup ==========================
                ...(0, $cd5a520fee8002b4$export$23997c3e44cc1c59)(token),
                position: 'absolute',
                top: -9999,
                zIndex: token.zIndexPopup,
                boxSizing: 'border-box',
                padding: token.paddingXXS,
                overflow: 'hidden',
                fontSize: token.fontSize,
                // Fix select render lag of long text in chrome
                // https://github.com/ant-design/ant-design/issues/11456
                // https://github.com/ant-design/ant-design/issues/11843
                fontVariant: 'initial',
                backgroundColor: token.colorBgElevated,
                borderRadius: token.borderRadiusLG,
                outline: 'none',
                boxShadow: token.boxShadowSecondary,
                [`
          ${slideUpEnterActive}${dropdownPlacementCls}bottomLeft,
          ${slideUpAppearActive}${dropdownPlacementCls}bottomLeft
        `]: {
                    animationName: (0, $8c07f7e527e50277$export$e801b802b037de6a)
                },
                [`
          ${slideUpEnterActive}${dropdownPlacementCls}topLeft,
          ${slideUpAppearActive}${dropdownPlacementCls}topLeft,
          ${slideUpEnterActive}${dropdownPlacementCls}topRight,
          ${slideUpAppearActive}${dropdownPlacementCls}topRight
        `]: {
                    animationName: (0, $8c07f7e527e50277$export$dd9f089fa5e819fe)
                },
                [`${slideUpLeaveActive}${dropdownPlacementCls}bottomLeft`]: {
                    animationName: (0, $8c07f7e527e50277$export$f40f41df328ebc38)
                },
                [`
          ${slideUpLeaveActive}${dropdownPlacementCls}topLeft,
          ${slideUpLeaveActive}${dropdownPlacementCls}topRight
        `]: {
                    animationName: (0, $8c07f7e527e50277$export$f7243fdb9c27c3b7)
                },
                '&-hidden': {
                    display: 'none'
                },
                [`${componentCls}-dropdown-list-scrollbar`]: {
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: token.colorFillQuaternary
                    }
                },
                [selectItemCls]: {
                    ...$1631e1f97f1bf184$var$genItemStyle(token),
                    cursor: 'pointer',
                    transition: `background-color ${token.motionDurationSlow} ease`,
                    borderRadius: token.borderRadiusSM,
                    // =========== Group ============
                    '&-group': {
                        color: token.colorTextDescription,
                        fontSize: token.fontSizeSM,
                        cursor: 'default'
                    },
                    // =========== Option ===========
                    '&-option': {
                        display: 'flex',
                        '&-content': {
                            flex: 'auto',
                            ...(0, $cd5a520fee8002b4$export$b2b65df0d0824629)
                        },
                        '&-state': {
                            flex: 'none',
                            display: 'flex',
                            alignItems: 'center'
                        },
                        [`&-selected:not(${selectItemCls}-option-disabled)`]: {
                            color: token.optionSelectedColor,
                            fontWeight: token.optionSelectedFontWeight,
                            backgroundColor: token.optionSelectedBg,
                            [`${selectItemCls}-option-state`]: {
                                color: token.colorPrimary
                            }
                        },
                        [`&-active:not(${selectItemCls}-option-disabled)`]: {
                            backgroundColor: token.optionActiveBg
                        },
                        [`&-selected${selectItemCls}-option-active:not(${selectItemCls}-option-disabled)`]: {
                            backgroundColor: token.controlItemBgActiveHover
                        },
                        '&-disabled': {
                            [`&${selectItemCls}-option-selected`]: {
                                backgroundColor: token.colorBgContainerDisabled
                            },
                            color: token.colorTextDisabled,
                            cursor: 'not-allowed'
                        },
                        '&-grouped': {
                            paddingInlineStart: token.calc(token.controlPaddingHorizontal).mul(2).equal()
                        }
                    },
                    '&-empty': {
                        ...$1631e1f97f1bf184$var$genItemStyle(token),
                        color: token.colorTextDisabled
                    }
                },
                // https://github.com/ant-design/ant-design/pull/46646
                [`${selectedItemCls}:has(+ ${selectedItemCls})`]: {
                    borderEndStartRadius: 0,
                    borderEndEndRadius: 0,
                    [`& + ${selectedItemCls}`]: {
                        borderStartStartRadius: 0,
                        borderStartEndRadius: 0
                    }
                },
                // =========================== RTL ===========================
                '&-rtl': {
                    direction: 'rtl'
                }
            }
        },
        // Follow code may reuse in other components
        (0, $8c07f7e527e50277$export$9018e60daecf7a6c)(token, 'slide-up'),
        (0, $8c07f7e527e50277$export$9018e60daecf7a6c)(token, 'slide-down'),
        (0, $87a972ff193f83db$export$913b1b7e3288c319)(token, 'move-up'),
        (0, $87a972ff193f83db$export$913b1b7e3288c319)(token, 'move-down')
    ];
};
var $1631e1f97f1bf184$export$2e2bcd8739ae039 = $1631e1f97f1bf184$var$genSingleStyle;





const $0523a424fd253878$var$genSelectInputCustomizeStyle = (token)=>{
    const { antCls: antCls, componentCls: componentCls } = token;
    const transparentBackground = {
        background: 'transparent'
    };
    const disabledCustomizedInputSelector = [
        '> input[disabled]',
        '> textarea[disabled]',
        `> ${componentCls}-input`,
        `> ${antCls}-input-affix-wrapper-disabled`,
        `> ${antCls}-input-search`
    ].join(', ');
    return {
        [`&${componentCls}-customize`]: {
            border: 0,
            padding: 0,
            fontSize: 'inherit',
            lineHeight: 'inherit',
            [`${componentCls}-placeholder`]: {
                display: 'none'
            },
            [`${componentCls}-content`]: {
                margin: 0,
                padding: 0,
                '&-value': {
                    display: 'none'
                }
            },
            [`&${componentCls}-filled ${componentCls}-content`]: {
                [`${antCls}-input-filled`]: transparentBackground
            },
            [`&${componentCls}-disabled ${componentCls}-content`]: {
                [disabledCustomizedInputSelector]: transparentBackground,
                'input[disabled], textarea[disabled]': transparentBackground
            }
        }
    };
};
var $0523a424fd253878$export$2e2bcd8739ae039 = $0523a424fd253878$var$genSelectInputCustomizeStyle;




const $d73c4b7f6333583d$var$FIXED_INPUT_MIN_WIDTH = 4;
const $d73c4b7f6333583d$var$genSelectInputMultipleStyle = (token)=>{
    const { componentCls: componentCls, calc: calc, iconCls: iconCls, paddingXS: paddingXS, paddingXXS: paddingXXS, INTERNAL_FIXED_ITEM_MARGIN: INTERNAL_FIXED_ITEM_MARGIN, lineWidth: lineWidth, lineType: lineType, colorIcon: colorIcon, colorIconHover: colorIconHover, inputPaddingHorizontalBase: inputPaddingHorizontalBase, antCls: antCls } = token;
    const [varName, varRef] = (0, $761caadb5301aee1$export$d82b8f66c5649e14)(antCls, 'select');
    return {
        '&-multiple': {
            [varName('multi-item-background')]: token.multipleItemBg,
            [varName('multi-item-border-color')]: 'transparent',
            [varName('multi-item-border-radius')]: token.borderRadiusSM,
            [varName('multi-item-height')]: token.multipleItemHeight,
            [varName('multi-padding-base')]: `calc((${varRef('height')} - ${varRef('multi-item-height')}) / 2)`,
            [varName('multi-padding-vertical')]: `calc(${varRef('multi-padding-base')} - ${INTERNAL_FIXED_ITEM_MARGIN} - ${lineWidth})`,
            [varName('multi-item-padding-horizontal')]: `calc(${inputPaddingHorizontalBase} - ${varRef('multi-padding-vertical')} - ${lineWidth} * 2)`,
            // ========================================================
            // ==                        Base                        ==
            // ========================================================
            // ========================= Root =========================
            paddingBlock: varRef('multi-padding-vertical'),
            paddingInlineStart: `calc(${varRef('multi-padding-base')} - ${lineWidth})`,
            // ======================== Prefix ========================
            [`${componentCls}-prefix`]: {
                marginInlineStart: varRef('multi-item-padding-horizontal')
            },
            [`${componentCls}-prefix + ${componentCls}-content`]: {
                [`${componentCls}-placeholder`]: {
                    insetInlineStart: 0
                },
                [`${componentCls}-content-item${componentCls}-content-item-suffix`]: {
                    marginInlineStart: 0
                }
            },
            // ===================== Placeholder ======================
            [`${componentCls}-placeholder`]: {
                position: 'absolute',
                lineHeight: varRef('line-height'),
                insetInlineStart: varRef('multi-item-padding-horizontal'),
                width: `calc(100% - ${varRef('multi-item-padding-horizontal')})`,
                top: '50%',
                transform: 'translateY(-50%)'
            },
            // ======================= Content ========================
            [`${componentCls}-content`]: {
                flexWrap: 'wrap',
                alignItems: 'center',
                lineHeight: 1,
                '&-item-prefix': {
                    height: varRef('font-size')
                },
                '&-item': {
                    lineHeight: 1,
                    maxWidth: `calc(100% - ${$d73c4b7f6333583d$var$FIXED_INPUT_MIN_WIDTH}px)`
                },
                [`${componentCls}-content-item-prefix + ${componentCls}-content-item-suffix,
          ${componentCls}-content-item-suffix:first-child`]: {
                    marginInlineStart: varRef('multi-item-padding-horizontal')
                },
                [`${componentCls}-selection-item`]: {
                    lineHeight: `calc(${varRef('multi-item-height')} - ${lineWidth} * 2)`,
                    border: `${lineWidth} ${lineType} ${varRef('multi-item-border-color')}`,
                    display: 'flex',
                    marginBlock: INTERNAL_FIXED_ITEM_MARGIN,
                    marginInlineEnd: calc(INTERNAL_FIXED_ITEM_MARGIN).mul(2).equal(),
                    background: varRef('multi-item-background'),
                    borderRadius: varRef('multi-item-border-radius'),
                    paddingInlineStart: paddingXS,
                    paddingInlineEnd: paddingXXS,
                    transition: [
                        'height',
                        'line-height',
                        'padding'
                    ].map((key)=>`${key} ${token.motionDurationSlow}`).join(','),
                    // >>> Content
                    '&-content': {
                        ...(0, $cd5a520fee8002b4$export$b2b65df0d0824629),
                        marginInlineEnd: paddingXXS
                    },
                    // >>> Remove
                    '&-remove': {
                        ...(0, $cd5a520fee8002b4$export$171ccda7bc085e59)(),
                        display: 'inline-flex',
                        alignItems: 'center',
                        color: colorIcon,
                        fontWeight: 700,
                        fontSize: 10,
                        lineHeight: 'inherit',
                        cursor: 'pointer',
                        [`> ${iconCls}`]: {
                            verticalAlign: '-0.2em'
                        },
                        '&:hover': {
                            color: colorIconHover
                        }
                    }
                },
                [`${componentCls}-input`]: {
                    lineHeight: calc(INTERNAL_FIXED_ITEM_MARGIN).mul(2).add(varRef('multi-item-height')).equal(),
                    width: `calc(var(--select-input-width, 0) * 1px)`,
                    minWidth: $d73c4b7f6333583d$var$FIXED_INPUT_MIN_WIDTH,
                    maxWidth: '100%',
                    transition: `line-height ${token.motionDurationSlow}`
                }
            },
            // ========================================================
            // ==                        Size                        ==
            // ========================================================
            [`&${componentCls}-sm`]: {
                [varName('multi-item-height')]: token.multipleItemHeightSM,
                [varName('multi-item-border-radius')]: token.borderRadiusXS
            },
            [`&${componentCls}-lg`]: {
                [varName('multi-item-height')]: token.multipleItemHeightLG,
                [varName('multi-item-border-radius')]: token.borderRadius
            },
            // ========================================================
            // ==                      Variants                      ==
            // ========================================================
            [`&${componentCls}-filled`]: {
                [varName('multi-item-border-color')]: token.colorSplit,
                [varName('multi-item-background')]: token.colorBgContainer,
                [`&${componentCls}-disabled`]: {
                    [varName('multi-item-border-color')]: 'transparent'
                }
            }
        }
    };
};
var $d73c4b7f6333583d$export$2e2bcd8739ae039 = $d73c4b7f6333583d$var$genSelectInputMultipleStyle;


/** Set CSS variables and hover/focus styles for a Select input based on provided colors. */ const $5ea16ceeb6ae0cce$var$genSelectInputVariableStyle = (token, colors)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    const [varName] = (0, $761caadb5301aee1$export$d82b8f66c5649e14)(antCls, 'select');
    const { border: border, borderHover: borderHover, borderActive: borderActive, borderOutline: borderOutline } = colors;
    const baseBG = colors.background || token.selectorBg || token.colorBgContainer;
    return {
        [varName('border-color')]: border,
        [varName('background-color')]: baseBG,
        [varName('affix-color')]: colors.affixColor,
        [`&:not(${componentCls}-disabled)`]: {
            '&:hover': {
                [varName('border-color')]: borderHover,
                [varName('background-color')]: colors.backgroundHover || baseBG
            },
            [`&${componentCls}-focused`]: {
                [varName('border-color')]: borderActive,
                [varName('background-color')]: colors.backgroundActive || baseBG,
                boxShadow: `0 0 0 ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.controlOutlineWidth)} ${borderOutline}`
            }
        },
        [`&${componentCls}-disabled`]: {
            [varName('border-color')]: colors.borderDisabled || colors.border,
            [varName('background-color')]: colors.backgroundDisabled || colors.background
        }
    };
};
/** Generate variant-scoped variable styles and status overrides for a Select input */ const $5ea16ceeb6ae0cce$var$genSelectInputVariantStyle = (token, variant, colors, errorColors, warningColors, patchStyle)=>{
    const { componentCls: componentCls } = token;
    return {
        [`&${componentCls}-${variant}`]: [
            $5ea16ceeb6ae0cce$var$genSelectInputVariableStyle(token, colors),
            {
                [`&${componentCls}-status-error`]: $5ea16ceeb6ae0cce$var$genSelectInputVariableStyle(token, {
                    ...colors,
                    ...errorColors
                }),
                [`&${componentCls}-status-warning`]: $5ea16ceeb6ae0cce$var$genSelectInputVariableStyle(token, {
                    ...colors,
                    ...warningColors
                })
            },
            patchStyle
        ]
    };
};
const $5ea16ceeb6ae0cce$var$genSelectInputFocusVisibleStyle = (token, outlineColor)=>({
        outline: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.lineWidthFocus)} ${token.lineType} ${outlineColor}`,
        outlineOffset: (0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.calc(token.lineWidth).mul(-1).equal()),
        transition: [
            `outline-offset`,
            `outline`
        ].map((prop)=>`${prop} 0s`).join(', ')
    });
const $5ea16ceeb6ae0cce$var$genSelectInputStyle = (token)=>{
    const { componentCls: componentCls, fontHeight: fontHeight, controlHeight: controlHeight, fontSizeIcon: fontSizeIcon, showArrowPaddingInlineEnd: showArrowPaddingInlineEnd, iconCls: iconCls, antCls: antCls, max: max, calc: calc } = token;
    const [varName, varRef] = (0, $761caadb5301aee1$export$d82b8f66c5649e14)(antCls, 'select');
    const contentMarginInlineEnd = max(calc(showArrowPaddingInlineEnd).sub(fontSizeIcon).equal(), 0);
    return {
        [componentCls]: [
            {
                // Border
                [varName('border-radius')]: token.borderRadius,
                [varName('border-color')]: '#000',
                [varName('border-size')]: token.lineWidth,
                // Background
                [varName('background-color')]: token.colorBgContainer,
                // Font
                [varName('font-size')]: token.fontSize,
                [varName('line-height')]: token.lineHeight,
                [varName('font-height')]: fontHeight,
                [varName('color')]: token.colorText,
                [varName('affix-color')]: token.colorText,
                // Size
                [varName('height')]: controlHeight,
                [varName('padding-horizontal')]: calc(token.paddingSM).sub(token.lineWidth).equal(),
                [varName('padding-vertical')]: `calc((${varRef('height')} - ${varRef('font-height')}) / 2 - ${varRef('border-size')})`,
                // ==========================================================
                // ==                         Base                         ==
                // ==========================================================
                ...(0, $cd5a520fee8002b4$export$23997c3e44cc1c59)(token),
                display: 'inline-flex',
                // gap: calc(token.paddingXXS).mul(1.5).equal(),
                flexWrap: 'nowrap',
                position: 'relative',
                transition: `all ${token.motionDurationSlow}`,
                alignItems: 'flex-start',
                outline: 0,
                cursor: 'pointer',
                // Border
                borderRadius: varRef('border-radius'),
                borderWidth: varRef('border-size'),
                borderStyle: token.lineType,
                borderColor: varRef('border-color'),
                // Background
                background: varRef('background-color'),
                // Font
                fontSize: varRef('font-size'),
                lineHeight: varRef('line-height'),
                color: varRef('color'),
                // Padding
                paddingInline: varRef('padding-horizontal'),
                paddingBlock: varRef('padding-vertical'),
                // ========================= Prefix =========================
                [`${componentCls}-prefix`]: {
                    color: varRef('affix-color'),
                    flex: 'none',
                    lineHeight: 1
                },
                // ====================== Placeholder =======================
                [`${componentCls}-placeholder`]: {
                    ...(0, $cd5a520fee8002b4$export$b2b65df0d0824629),
                    color: token.colorTextPlaceholder,
                    pointerEvents: 'none',
                    zIndex: 1
                },
                // ======================== Content =========================
                [`${componentCls}-content`]: {
                    flex: 'auto',
                    minWidth: 0,
                    position: 'relative',
                    display: 'flex',
                    marginInlineEnd: contentMarginInlineEnd,
                    '&:before': {
                        content: '"\\a0"',
                        width: 0,
                        overflow: 'hidden'
                    },
                    // >>> Value
                    '&-value': {
                        visibility: 'inherit'
                    },
                    // >>> Input: should only take effect for not customize mode
                    // input element with readOnly use cursor pointer
                    'input[readonly]': {
                        cursor: 'inherit',
                        caretColor: 'transparent'
                    }
                },
                // ========================= Suffix =========================
                [`${componentCls}-suffix`]: {
                    flex: 'none',
                    color: token.colorTextQuaternary,
                    fontSize: token.fontSizeIcon,
                    lineHeight: 1,
                    transition: [
                        'opacity',
                        'color'
                    ].map((prop)=>`${prop} ${token.motionDurationMid} ease`).join(', '),
                    '> :not(:last-child)': {
                        marginInlineEnd: token.marginXS
                    }
                },
                [`${componentCls}-prefix, ${componentCls}-suffix`]: {
                    alignSelf: 'center',
                    [iconCls]: {
                        verticalAlign: 'top'
                    }
                },
                // ==========================================================
                // ==                       Disabled                       ==
                // ==========================================================
                '&-disabled': {
                    background: token.colorBgContainerDisabled,
                    [varName('color')]: token.colorTextDisabled,
                    cursor: 'not-allowed',
                    input: {
                        cursor: 'not-allowed'
                    }
                },
                // ==========================================================
                // ==                         Size                         ==
                // ==========================================================
                '&-sm': {
                    [varName('height')]: token.controlHeightSM,
                    [varName('padding-horizontal')]: calc(token.paddingXS).sub(token.lineWidth).equal(),
                    [varName('border-radius')]: token.borderRadiusSM,
                    [`${componentCls}-clear`]: {
                        insetInlineEnd: varRef('padding-horizontal')
                    }
                },
                '&-lg': {
                    [varName('height')]: token.controlHeightLG,
                    [varName('font-size')]: token.fontSizeLG,
                    [varName('line-height')]: token.lineHeightLG,
                    [varName('font-height')]: token.fontHeightLG,
                    [varName('border-radius')]: token.borderRadiusLG
                }
            },
            // ============================================================
            // ==                         Input                          ==
            // ============================================================
            {
                [`&:not(${componentCls}-customize)`]: {
                    [`${componentCls}-input`]: {
                        outline: 'none',
                        background: 'transparent',
                        appearance: 'none',
                        border: 0,
                        margin: 0,
                        padding: 0,
                        color: varRef('color'),
                        fontFamily: 'inherit',
                        fontSize: 'inherit',
                        '&::-webkit-search-cancel-button': {
                            display: 'none',
                            appearance: 'none'
                        }
                    }
                }
            },
            // ============================================================
            // ==                         Single                         ==
            // ============================================================
            {
                [`&-single:not(${componentCls}-customize)`]: {
                    [`${componentCls}-input`]: {
                        position: 'absolute',
                        inset: 0,
                        lineHeight: 'inherit'
                    },
                    // Content center align
                    [`${componentCls}-content`]: {
                        ...(0, $cd5a520fee8002b4$export$b2b65df0d0824629),
                        alignSelf: 'center',
                        '&-has-value': {
                            display: 'block',
                            '&:before': {
                                display: 'none'
                            }
                        },
                        '&-has-search-value': {
                            color: 'transparent',
                            [`> *:not(${componentCls}-input)`]: {
                                opacity: 0
                            }
                        },
                        // >>> Value
                        '&-value': {
                            transition: `all ${token.motionDurationMid} ${token.motionEaseInOut}`,
                            zIndex: 1,
                            opacity: 1
                        }
                    },
                    // Dim the selected content while the dropdown is open. Shared by all select-like
                    // components (Select / Cascader / TreeSelect) since they render through the same
                    // `content` structure.
                    [`&${componentCls}-open ${componentCls}-content`]: {
                        '&-has-value': {
                            opacity: 0.25
                        },
                        '&-has-search-value': {
                            opacity: 1,
                            transition: `opacity ${token.motionDurationMid} ${token.motionEaseInOut}`,
                            color: 'transparent',
                            [`> *:not(${componentCls}-input)`]: {
                                opacity: 0
                            }
                        }
                    }
                }
            },
            // ======================== Show Search =======================
            {
                [`&-show-search:not(${componentCls}-customize-input):not(${componentCls}-disabled)`]: {
                    cursor: 'text'
                }
            },
            // ============================================================
            // ==                        Multiple                        ==
            // ============================================================
            (0, $d73c4b7f6333583d$export$2e2bcd8739ae039)(token),
            // ========================= Variant ==========================
            // >>> Outlined
            $5ea16ceeb6ae0cce$var$genSelectInputVariantStyle(token, 'outlined', {
                border: token.colorBorder,
                borderHover: token.hoverBorderColor,
                borderActive: token.activeBorderColor,
                borderOutline: token.activeOutlineColor,
                borderDisabled: token.colorBorderDisabled
            }, // Error
            {
                border: token.colorError,
                borderHover: token.colorErrorBorderHover,
                borderActive: token.colorError,
                borderOutline: token.colorErrorOutline,
                affixColor: token.colorErrorAffix
            }, // Warning
            {
                border: token.colorWarning,
                borderHover: token.colorWarningHover,
                borderActive: token.colorWarning,
                borderOutline: token.colorWarningOutline,
                affixColor: token.colorWarningAffix
            }),
            // >>> Filled
            $5ea16ceeb6ae0cce$var$genSelectInputVariantStyle(token, 'filled', {
                border: 'transparent',
                borderHover: 'transparent',
                borderActive: token.activeBorderColor,
                borderOutline: 'transparent',
                borderDisabled: token.colorBorderDisabled,
                background: token.colorFillTertiary,
                backgroundHover: token.colorFillSecondary,
                backgroundActive: token.colorBgContainer
            }, // Error
            {
                color: token.colorErrorText,
                background: token.colorErrorBg,
                backgroundHover: token.colorErrorBgHover,
                borderActive: token.colorError
            }, // Warning
            {
                background: token.colorWarningBg,
                backgroundHover: token.colorWarningBgHover,
                borderActive: token.colorWarning
            }),
            // >>> Borderless
            $5ea16ceeb6ae0cce$var$genSelectInputVariantStyle(token, 'borderless', {
                border: 'transparent',
                borderHover: 'transparent',
                borderActive: 'transparent',
                borderOutline: 'transparent',
                background: 'transparent'
            }, {}, {}, {
                [`&:not(${componentCls}-disabled):has(input:focus-visible), &:not(${componentCls}-disabled):has(textarea:focus-visible)`]: $5ea16ceeb6ae0cce$var$genSelectInputFocusVisibleStyle(token, token.activeBorderColor),
                [`&${componentCls}-status-error:not(${componentCls}-disabled):has(input:focus-visible), &${componentCls}-status-error:not(${componentCls}-disabled):has(textarea:focus-visible)`]: $5ea16ceeb6ae0cce$var$genSelectInputFocusVisibleStyle(token, token.colorError),
                [`&${componentCls}-status-warning:not(${componentCls}-disabled):has(input:focus-visible), &${componentCls}-status-warning:not(${componentCls}-disabled):has(textarea:focus-visible)`]: $5ea16ceeb6ae0cce$var$genSelectInputFocusVisibleStyle(token, token.colorWarning)
            }),
            // Underlined
            $5ea16ceeb6ae0cce$var$genSelectInputVariantStyle(token, 'underlined', {
                border: token.colorBorder,
                borderHover: token.hoverBorderColor,
                borderActive: token.activeBorderColor,
                borderOutline: 'transparent'
            }, // Error
            {
                border: token.colorError,
                borderHover: token.colorErrorBorderHover,
                borderActive: token.colorError
            }, // Warning
            {
                border: token.colorWarning,
                borderHover: token.colorWarningHover,
                borderActive: token.colorWarning
            }, {
                borderRadius: 0,
                borderTopColor: 'transparent',
                borderInlineColor: 'transparent'
            }),
            // ============================================================
            // ==                         Custom                         ==
            // ============================================================
            (0, $0523a424fd253878$export$2e2bcd8739ae039)(token)
        ]
    };
};
var $5ea16ceeb6ae0cce$export$2e2bcd8739ae039 = $5ea16ceeb6ae0cce$var$genSelectInputStyle;


const $4ace31f3fb410ffd$export$9ca1be8807fe0675 = (token)=>{
    const { fontSize: fontSize, lineHeight: lineHeight, lineWidth: lineWidth, lineWidthFocus: lineWidthFocus, controlHeight: controlHeight, controlHeightSM: controlHeightSM, controlHeightLG: controlHeightLG, paddingXXS: paddingXXS, controlPaddingHorizontal: controlPaddingHorizontal, zIndexPopupBase: zIndexPopupBase, colorText: colorText, fontWeightStrong: fontWeightStrong, controlItemBgActive: controlItemBgActive, controlItemBgHover: controlItemBgHover, colorBgContainer: colorBgContainer, colorFillSecondary: colorFillSecondary, colorBgContainerDisabled: colorBgContainerDisabled, colorTextDisabled: colorTextDisabled, colorPrimaryHover: colorPrimaryHover, colorPrimary: colorPrimary, controlOutline: controlOutline } = token;
    // Item height default use `controlHeight - 2 * paddingXXS`,
    // but some case `paddingXXS=0`.
    // Let's fallback it.
    const dblPaddingXXS = paddingXXS * 2;
    const dblLineWidth = lineWidth * 2;
    const multipleItemHeight = Math.min(controlHeight - dblPaddingXXS, controlHeight - dblLineWidth);
    const multipleItemHeightSM = Math.min(controlHeightSM - dblPaddingXXS, controlHeightSM - dblLineWidth);
    const multipleItemHeightLG = Math.min(controlHeightLG - dblPaddingXXS, controlHeightLG - dblLineWidth);
    // FIXED_ITEM_MARGIN is a hardcode calculation since calc not support rounding
    const INTERNAL_FIXED_ITEM_MARGIN = Math.floor(paddingXXS / 2);
    const componentToken = {
        lineWidthFocus: lineWidthFocus === 0 ? 0 : lineWidth,
        INTERNAL_FIXED_ITEM_MARGIN: INTERNAL_FIXED_ITEM_MARGIN,
        zIndexPopup: zIndexPopupBase + 50,
        optionSelectedColor: colorText,
        optionSelectedFontWeight: fontWeightStrong,
        optionSelectedBg: controlItemBgActive,
        optionActiveBg: controlItemBgHover,
        optionPadding: `${(controlHeight - fontSize * lineHeight) / 2}px ${controlPaddingHorizontal}px`,
        optionFontSize: fontSize,
        optionLineHeight: lineHeight,
        optionHeight: controlHeight,
        selectorBg: colorBgContainer,
        clearBg: colorBgContainer,
        singleItemHeightLG: controlHeightLG,
        multipleItemBg: colorFillSecondary,
        multipleItemBorderColor: 'transparent',
        multipleItemHeight: multipleItemHeight,
        multipleItemHeightSM: multipleItemHeightSM,
        multipleItemHeightLG: multipleItemHeightLG,
        multipleSelectorBgDisabled: colorBgContainerDisabled,
        multipleItemColorDisabled: colorTextDisabled,
        multipleItemBorderColorDisabled: 'transparent',
        showArrowPaddingInlineEnd: Math.ceil(token.fontSize * 1.25),
        hoverBorderColor: colorPrimaryHover,
        activeBorderColor: colorPrimary,
        activeOutlineColor: controlOutline,
        selectAffixPadding: paddingXXS
    };
    return componentToken;
};


// =============================== Base ===============================
const $04ac73adaceba54b$var$genBaseStyle = (token)=>{
    const { antCls: antCls, componentCls: componentCls, motionDurationMid: motionDurationMid, inputPaddingHorizontalBase: inputPaddingHorizontalBase } = token;
    const hoverShowClearStyle = {
        [`${componentCls}-clear`]: {
            opacity: 1
        },
        [`${componentCls}-suffix:not(:last-child)`]: {
            opacity: 0,
            pointerEvents: 'none'
        },
        [`&${componentCls}-allow-clear:not(${componentCls}-show-arrow):not(${componentCls}-customize) ${componentCls}-content`]: {
            marginInlineEnd: token.showArrowPaddingInlineEnd
        }
    };
    return {
        [componentCls]: {
            ...(0, $cd5a520fee8002b4$export$23997c3e44cc1c59)(token),
            // ======================== Selection ========================
            [`${componentCls}-selection-item`]: {
                flex: 1,
                fontWeight: 400,
                position: 'relative',
                userSelect: 'none',
                ...(0, $cd5a520fee8002b4$export$b2b65df0d0824629),
                // https://github.com/ant-design/ant-design/issues/40421
                [`> ${antCls}-typography`]: {
                    display: 'inline'
                }
            },
            // ========================= Prefix ==========================
            [`${componentCls}-prefix`]: {
                flex: 'none',
                marginInlineEnd: token.selectAffixPadding
            },
            // ========================== Clear ==========================
            [`${componentCls}-clear`]: {
                position: 'absolute',
                top: '50%',
                insetInlineStart: 'auto',
                insetInlineEnd: inputPaddingHorizontalBase,
                zIndex: 1,
                display: 'inline-block',
                width: token.fontSizeIcon,
                height: token.fontSizeIcon,
                marginTop: token.calc(token.fontSizeIcon).mul(-1).div(2).equal(),
                padding: 0,
                background: 'transparent',
                color: token.colorTextQuaternary,
                fontSize: token.fontSizeIcon,
                fontFamily: 'inherit',
                fontStyle: 'normal',
                lineHeight: 1,
                textAlign: 'center',
                textTransform: 'none',
                appearance: 'none',
                border: 0,
                cursor: 'pointer',
                opacity: 0,
                transition: [
                    'color',
                    'opacity'
                ].map((prop)=>`${prop} ${motionDurationMid} ease`).join(', '),
                textRendering: 'auto',
                // https://github.com/ant-design/ant-design/issues/54205
                // Force GPU compositing on Safari to prevent flickering on opacity/transform transitions
                transform: 'translateZ(0)',
                '&:before': {
                    display: 'block'
                },
                '&:hover': {
                    color: token.colorIcon
                }
            },
            '@media(hover:none)': hoverShowClearStyle,
            '&:hover': hoverShowClearStyle
        },
        // ========================= Feedback ==========================
        [`${componentCls}-status`]: {
            '&-error, &-warning, &-success, &-validating': {
                [`&${componentCls}-has-feedback`]: {
                    [`${componentCls}-clear`]: {
                        insetInlineEnd: token.calc(inputPaddingHorizontalBase).add(token.fontSize).add(token.paddingXS).equal()
                    }
                }
            }
        }
    };
};
// ============================== Styles ==============================
const $04ac73adaceba54b$var$genSelectStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return [
        {
            [componentCls]: {
                // ==================== In Form ====================
                [`&${componentCls}-in-form-item`]: {
                    width: '100%'
                }
            }
        },
        // =====================================================
        // ==                       LTR                       ==
        // =====================================================
        // Base
        $04ac73adaceba54b$var$genBaseStyle(token),
        // Dropdown
        (0, $1631e1f97f1bf184$export$2e2bcd8739ae039)(token),
        // =====================================================
        // ==                       RTL                       ==
        // =====================================================
        {
            [`${componentCls}-rtl`]: {
                direction: 'rtl'
            }
        },
        // =====================================================
        // ==             Space Compact                       ==
        // =====================================================
        (0, $1829499b88c32c7f$export$b1208b23589b4b73)(token, {
            focusElCls: `${componentCls}-focused`
        })
    ];
};
var // ============================== Export ==============================
$04ac73adaceba54b$export$2e2bcd8739ae039 = (0, $761caadb5301aee1$export$51ec95de45185b42)('Select', (token, { rootPrefixCls: rootPrefixCls })=>{
    const selectToken = (0, $f564548c7b6877d5$export$4950aa0f605343fb)(token, {
        rootPrefixCls: rootPrefixCls,
        inputPaddingHorizontalBase: token.calc(token.paddingSM).sub(token.lineWidth).equal(),
        multipleSelectItemHeight: token.multipleItemHeight,
        selectHeight: token.controlHeight
    });
    return [
        $04ac73adaceba54b$var$genSelectStyle(selectToken),
        (0, $5ea16ceeb6ae0cce$export$2e2bcd8739ae039)(selectToken)
    ];
}, (0, $4ace31f3fb410ffd$export$9ca1be8807fe0675), {
    unitless: {
        optionLineHeight: true,
        optionSelectedFontWeight: true
    }
});



var $5E6i4 = parcelRequire("5E6i4");








"use client";
function $0baaf2329f2cfb2e$export$2e2bcd8739ae039({ suffixIcon: suffixIcon, contextSuffixIcon: contextSuffixIcon, clearIcon: clearIcon, contextClearIcon: contextClearIcon, menuItemSelectedIcon: menuItemSelectedIcon, contextMenuItemSelectedIcon: contextMenuItemSelectedIcon, removeIcon: removeIcon, contextRemoveIcon: contextRemoveIcon, loading: loading, loadingIcon: loadingIcon, contextLoadingIcon: contextLoadingIcon, searchIcon: searchIcon, contextSearchIcon: contextSearchIcon, multiple: multiple, hasFeedback: hasFeedback, showSuffixIcon: showSuffixIcon, feedbackIcon: feedbackIcon, showArrow: showArrow, componentName: componentName }) {
    return $5E6i4.useMemo(()=>{
        // Clear Icon
        const mergedClearIcon = (0, $c3b60ef18d99af24$export$2e2bcd8739ae039)(clearIcon, contextClearIcon, /*#__PURE__*/ $5E6i4.createElement((0, $18493f15518cd625$export$2e2bcd8739ae039), null));
        // Validation Feedback Icon
        const getSuffixIconNode = (arrowIcon)=>{
            if (suffixIcon === null && !hasFeedback && !showArrow) return null;
            return /*#__PURE__*/ $5E6i4.createElement($5E6i4.Fragment, null, showSuffixIcon !== false && arrowIcon, hasFeedback && feedbackIcon);
        };
        // Arrow item icon
        let mergedSuffixIcon = null;
        if (suffixIcon !== undefined) mergedSuffixIcon = getSuffixIconNode(suffixIcon);
        else if (loading) mergedSuffixIcon = getSuffixIconNode((0, $c3b60ef18d99af24$export$2e2bcd8739ae039)(loadingIcon, contextLoadingIcon, /*#__PURE__*/ $5E6i4.createElement((0, $6e3183dc0ea574da$export$2e2bcd8739ae039), {
            spin: true
        })));
        else mergedSuffixIcon = ({ open: open, showSearch: showSearch })=>{
            if (open && showSearch) return getSuffixIconNode((0, $c3b60ef18d99af24$export$2e2bcd8739ae039)(searchIcon, contextSearchIcon, /*#__PURE__*/ $5E6i4.createElement((0, $f9679d6a5def8308$export$2e2bcd8739ae039), null)));
            return getSuffixIconNode((0, $c3b60ef18d99af24$export$2e2bcd8739ae039)(contextSuffixIcon, /*#__PURE__*/ $5E6i4.createElement((0, $55e38791308df946$export$2e2bcd8739ae039), null)));
        };
        // Checked item icon
        const mergedItemIcon = (0, $c3b60ef18d99af24$export$2e2bcd8739ae039)(menuItemSelectedIcon, contextMenuItemSelectedIcon, multiple ? /*#__PURE__*/ $5E6i4.createElement((0, $9eb4119242359573$export$2e2bcd8739ae039), null) : null);
        const mergedRemoveIcon = (0, $c3b60ef18d99af24$export$2e2bcd8739ae039)(removeIcon, contextRemoveIcon, /*#__PURE__*/ $5E6i4.createElement((0, $80d24bc031ad50e3$export$2e2bcd8739ae039), null));
        return {
            clearIcon: mergedClearIcon,
            suffixIcon: mergedSuffixIcon,
            itemIcon: mergedItemIcon,
            removeIcon: mergedRemoveIcon
        };
    }, [
        suffixIcon,
        contextSuffixIcon,
        clearIcon,
        contextClearIcon,
        menuItemSelectedIcon,
        contextMenuItemSelectedIcon,
        removeIcon,
        contextRemoveIcon,
        loading,
        loadingIcon,
        contextLoadingIcon,
        searchIcon,
        contextSearchIcon,
        multiple,
        hasFeedback,
        showSuffixIcon,
        feedbackIcon,
        showArrow
    ]);
}



var $5E6i4 = parcelRequire("5E6i4");

"use client";
function $af80b8422a940c5e$var$usePopupRender(renderFn) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useMemo(()=>{
        if (!renderFn) return undefined;
        return (...args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $33ed3a59b63447d5$export$2e2bcd8739ae039), {
                space: true
            }, renderFn.apply(void 0, args));
    }, [
        renderFn
    ]);
}
var $af80b8422a940c5e$export$2e2bcd8739ae039 = $af80b8422a940c5e$var$usePopupRender;


/**
 * Since Select, TreeSelect, Cascader is same Select like component.
 * We just use same hook to handle this logic.
 *
 * If `suffixIcon` is not equal to `null`, always show it.
 */ function $045cc6d2b15fee0a$export$2e2bcd8739ae039(suffixIcon, showArrow) {
    return showArrow !== undefined ? showArrow : suffixIcon !== null;
}


"use client";
const $5a2f22a270cf838a$var$SECRET_COMBOBOX_MODE_DO_NOT_USE = 'SECRET_COMBOBOX_MODE_DO_NOT_USE';
const $5a2f22a270cf838a$var$InternalSelect = (props, ref)=>{
    const { prefixCls: customizePrefixCls, bordered: bordered, className: className, rootClassName: rootClassName, getPopupContainer: getPopupContainer, popupClassName: popupClassName, dropdownClassName: dropdownClassName, listHeight: listHeight = 256, placement: placement, listItemHeight: customListItemHeight, size: customizeSize, disabled: customDisabled, notFoundContent: notFoundContent, status: customStatus, builtinPlacements: builtinPlacements, dropdownMatchSelectWidth: dropdownMatchSelectWidth, popupMatchSelectWidth: popupMatchSelectWidth, direction: propDirection, style: style, allowClear: allowClear, variant: customizeVariant, popupStyle: popupStyle, dropdownStyle: dropdownStyle, transitionName: transitionName, tagRender: tagRender, maxCount: maxCount, prefix: prefix, dropdownRender: dropdownRender, popupRender: /**
     * @since 5.25.0
     */ popupRender, onDropdownVisibleChange: onDropdownVisibleChange, onOpenChange: onOpenChange, styles: styles, classNames: classNames, clearIcon: clearIcon, showSearch: showSearch, ...rest } = props;
    const { getPopupContainer: getContextPopupContainer, getPrefixCls: getPrefixCls, renderEmpty: renderEmpty, direction: contextDirection, virtual: virtual, popupMatchSelectWidth: contextPopupMatchSelectWidth, popupOverflow: popupOverflow } = $5E6i4.useContext((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
    const { showSearch: contextShowSearch, allowClear: contextAllowClear, style: contextStyle, styles: contextStyles, className: contextClassName, classNames: contextClassNames, clearIcon: contextClearIcon, loadingIcon: contextLoadingIcon, menuItemSelectedIcon: contextMenuItemSelectedIcon, removeIcon: contextRemoveIcon, suffixIcon: contextSuffixIcon } = (0, $519f2fad435b3034$export$46f4bd6436a25a31)('select');
    const [, token] = (0, $cb3a44f4e76623bb$export$2e2bcd8739ae039)();
    const listItemHeight = customListItemHeight ?? token?.controlHeight;
    const prefixCls = getPrefixCls('select', customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const direction = propDirection ?? contextDirection;
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $3ee2444c5d59b36b$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    const [variant, enableVariantCls] = (0, $23d5b57d8a25ce6e$export$2e2bcd8739ae039)('select', customizeVariant, bordered);
    const rootCls = (0, $d104ec5f99ed66d7$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $04ac73adaceba54b$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const mode = $5E6i4.useMemo(()=>{
        const { mode: m } = props;
        if (m === 'combobox') return undefined;
        if (m === $5a2f22a270cf838a$var$SECRET_COMBOBOX_MODE_DO_NOT_USE) return 'combobox';
        return m;
    }, [
        props.mode
    ]);
    const isMultiple = mode === 'multiple' || mode === 'tags';
    const showSuffixIcon = (0, $045cc6d2b15fee0a$export$2e2bcd8739ae039)(props.suffixIcon, props.showArrow);
    const mergedPopupMatchSelectWidth = popupMatchSelectWidth ?? dropdownMatchSelectWidth ?? contextPopupMatchSelectWidth;
    const mergedPopupRender = (0, $af80b8422a940c5e$export$2e2bcd8739ae039)(popupRender || dropdownRender);
    const mergedOnOpenChange = onOpenChange || onDropdownVisibleChange;
    // ===================== Form Status =====================
    const { status: contextStatus, hasFeedback: hasFeedback, isFormItemInput: isFormItemInput, feedbackIcon: feedbackIcon } = $5E6i4.useContext((0, $e785311f53d64def$export$bbb5553c6c7a14ed));
    const mergedStatus = (0, $842ff74e676bf26d$export$314e193082d7ba49)(contextStatus, customStatus);
    // ===================== Empty =====================
    let mergedNotFound;
    if (notFoundContent !== undefined) mergedNotFound = notFoundContent;
    else if (mode === 'combobox') mergedNotFound = null;
    else mergedNotFound = renderEmpty?.('Select') || /*#__PURE__*/ $5E6i4.createElement((0, $683e48f5302a9848$export$2e2bcd8739ae039), {
        componentName: "Select"
    });
    // ===================== Icons =====================
    const { suffixIcon: suffixIcon, itemIcon: itemIcon, removeIcon: removeIcon, clearIcon: mergedClearIcon } = (0, $0baaf2329f2cfb2e$export$2e2bcd8739ae039)({
        ...rest,
        multiple: isMultiple,
        hasFeedback: hasFeedback,
        feedbackIcon: feedbackIcon,
        showSuffixIcon: showSuffixIcon,
        prefixCls: prefixCls,
        componentName: 'Select',
        clearIcon: clearIcon,
        searchIcon: (0, $90c6d941485868aa$export$2e2bcd8739ae039)(showSearch, 'searchIcon'),
        contextClearIcon: contextClearIcon,
        contextLoadingIcon: contextLoadingIcon,
        contextMenuItemSelectedIcon: contextMenuItemSelectedIcon,
        contextRemoveIcon: contextRemoveIcon,
        contextSearchIcon: (0, $90c6d941485868aa$export$2e2bcd8739ae039)(contextShowSearch, 'searchIcon'),
        contextSuffixIcon: contextSuffixIcon
    });
    const finalAllowClear = allowClear ?? contextAllowClear;
    const mergedAllowClear = finalAllowClear === true ? {
        clearIcon: mergedClearIcon
    } : finalAllowClear;
    const mergedShowSearch = showSearch ?? contextShowSearch;
    const selectProps = (0, $48bd91d9f828de66$export$2e2bcd8739ae039)(rest, [
        'suffixIcon',
        'itemIcon'
    ]);
    const mergedSize = (0, $4bfc7567df2a969e$export$2e2bcd8739ae039)((ctx)=>customizeSize ?? compactSize ?? ctx);
    // ===================== Disabled =====================
    const disabled = $5E6i4.useContext((0, $2ab14018ea5b2d79$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled ?? disabled;
    // ========== Merged Props for Semantic ==================
    const mergedProps = {
        ...props,
        variant: variant,
        status: mergedStatus,
        disabled: mergedDisabled,
        size: mergedSize
    };
    const contextStyleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $722c8632ba7bdb89$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    }, {
        popup: {
            _default: 'root'
        }
    });
    const mergedPopupClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(mergedClassNames.popup.root, popupClassName, dropdownClassName, {
        [`${prefixCls}-dropdown-${direction}`]: direction === 'rtl'
    }, rootClassName, cssVarCls, rootCls, hashId);
    const mergedPopupStyle = {
        ...mergedStyles.popup?.root,
        ...popupStyle ?? dropdownStyle
    };
    const mergedClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)({
        [`${prefixCls}-lg`]: mergedSize === 'large',
        [`${prefixCls}-sm`]: mergedSize === 'small',
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-${variant}`]: enableVariantCls,
        [`${prefixCls}-in-form-item`]: isFormItemInput
    }, (0, $842ff74e676bf26d$export$b08e7b47149942a2)(prefixCls, mergedStatus, hasFeedback), compactItemClassnames, contextClassName, className, mergedClassNames.root, rootClassName, cssVarCls, rootCls, hashId);
    // ===================== Placement =====================
    const memoPlacement = $5E6i4.useMemo(()=>{
        if (placement !== undefined) return placement;
        return direction === 'rtl' ? 'bottomRight' : 'bottomLeft';
    }, [
        placement,
        direction
    ]);
    var oldProp, newProp;
    // ====================== zIndex =========================
    const [zIndex] = (0, $09c5eb33e460ecef$export$3e7906d4075187a4)('SelectLike', mergedStyles.popup.root?.zIndex ?? mergedPopupStyle.zIndex);
    // ====================== Render =======================
    return /*#__PURE__*/ $5E6i4.createElement((0, $9ea266dab750ec84$export$2e2bcd8739ae039), {
        ref: ref,
        virtual: virtual,
        classNames: mergedClassNames,
        styles: mergedStyles,
        showSearch: mergedShowSearch,
        ...selectProps,
        style: mergedStyles.root,
        popupMatchSelectWidth: mergedPopupMatchSelectWidth,
        transitionName: (0, $c2c363b881b49d51$export$27c72201b1d09951)(rootPrefixCls, 'slide-up', transitionName),
        builtinPlacements: (0, $58eb6d395d8edc2e$export$2e2bcd8739ae039)(builtinPlacements, popupOverflow),
        listHeight: listHeight,
        listItemHeight: listItemHeight,
        mode: mode,
        prefixCls: prefixCls,
        placement: memoPlacement,
        direction: direction,
        prefix: prefix,
        suffixIcon: suffixIcon,
        menuItemSelectedIcon: itemIcon,
        removeIcon: removeIcon,
        allowClear: mergedAllowClear,
        notFoundContent: mergedNotFound,
        className: mergedClassName,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        popupClassName: mergedPopupClassName,
        disabled: mergedDisabled,
        popupStyle: {
            ...mergedStyles.popup.root,
            ...mergedPopupStyle,
            zIndex: zIndex
        },
        maxCount: isMultiple ? maxCount : undefined,
        tagRender: isMultiple ? tagRender : undefined,
        popupRender: mergedPopupRender,
        onPopupVisibleChange: mergedOnOpenChange
    });
};
const $5a2f22a270cf838a$var$Select = /*#__PURE__*/ $5E6i4.forwardRef($5a2f22a270cf838a$var$InternalSelect);
// We don't care debug panel
/* istanbul ignore next */ const $5a2f22a270cf838a$var$PurePanel = (0, $f49bb770731dacb5$export$2e2bcd8739ae039)($5a2f22a270cf838a$var$Select, 'popupAlign');
$5a2f22a270cf838a$var$Select.SECRET_COMBOBOX_MODE_DO_NOT_USE = $5a2f22a270cf838a$var$SECRET_COMBOBOX_MODE_DO_NOT_USE;
$5a2f22a270cf838a$var$Select.Option = (0, $517d2aa070de0b1c$export$2e2bcd8739ae039);
$5a2f22a270cf838a$var$Select.OptGroup = (0, $d4ce7be070373b1a$export$2e2bcd8739ae039);
$5a2f22a270cf838a$var$Select._InternalPanelDoNotUseOrYouWillBeFired = $5a2f22a270cf838a$var$PurePanel;
var $5a2f22a270cf838a$export$2e2bcd8739ae039 = $5a2f22a270cf838a$var$Select;









const $dff214286d5693a2$var$genPaginationDisabledStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-disabled`]: {
            '&, &:hover': {
                cursor: 'not-allowed',
                [`${componentCls}-item-link`]: {
                    color: token.colorTextDisabled,
                    cursor: 'not-allowed'
                }
            },
            '&:focus-visible': {
                cursor: 'not-allowed',
                [`${componentCls}-item-link`]: {
                    color: token.colorTextDisabled,
                    cursor: 'not-allowed'
                }
            }
        },
        [`&${componentCls}-disabled`]: {
            cursor: 'not-allowed',
            [`${componentCls}-item`]: {
                cursor: 'not-allowed',
                backgroundColor: 'transparent',
                '&:hover, &:active': {
                    backgroundColor: 'transparent'
                },
                a: {
                    color: token.colorTextDisabled,
                    backgroundColor: 'transparent',
                    border: 'none',
                    cursor: 'not-allowed'
                },
                '&-active': {
                    borderColor: token.colorBorder,
                    backgroundColor: token.itemActiveBgDisabled,
                    '&:hover, &:active': {
                        backgroundColor: token.itemActiveBgDisabled
                    },
                    a: {
                        color: token.itemActiveColorDisabled
                    }
                }
            },
            [`${componentCls}-item-link`]: {
                color: token.colorTextDisabled,
                cursor: 'not-allowed',
                '&:hover, &:active': {
                    backgroundColor: 'transparent'
                },
                [`${componentCls}-simple&`]: {
                    backgroundColor: 'transparent',
                    '&:hover, &:active': {
                        backgroundColor: 'transparent'
                    }
                }
            },
            [`${componentCls}-simple-pager`]: {
                color: token.colorTextDisabled
            },
            [`${componentCls}-jump-prev, ${componentCls}-jump-next`]: {
                [`${componentCls}-item-link-icon`]: {
                    opacity: 0
                },
                [`${componentCls}-item-ellipsis`]: {
                    opacity: 1
                }
            }
        }
    };
};
const $dff214286d5693a2$var$genPaginationSmallStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`&${componentCls}-small ${componentCls}-options`]: {
            marginInlineStart: token.paginationMiniOptionsMarginInlineStart,
            '&-quick-jumper': {
                input: {
                    ...(0, $2a8a1036c9d4d150$export$bb047f62c5a56f90)(token),
                    width: token.paginationMiniQuickJumperInputWidth
                }
            }
        }
    };
};
const $dff214286d5693a2$var$genPaginationLargeStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`&${componentCls}-large ${componentCls}-options`]: {
            '&-quick-jumper': {
                input: {
                    ...(0, $2a8a1036c9d4d150$export$88e04420bb2dc003)(token)
                }
            }
        }
    };
};
const $dff214286d5693a2$var$genPaginationSimpleStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    const [, varRef] = (0, $761caadb5301aee1$export$d82b8f66c5649e14)(antCls, 'pagination');
    return {
        [`&${componentCls}-simple`]: {
            [`${componentCls}-prev, ${componentCls}-next`]: {
                height: varRef(`item-size-actual`),
                lineHeight: varRef(`item-size-actual`),
                verticalAlign: 'top',
                [`${componentCls}-item-link`]: {
                    height: varRef(`item-size-actual`),
                    backgroundColor: 'transparent',
                    border: 0,
                    '&:hover': {
                        backgroundColor: token.colorBgTextHover
                    },
                    '&:active': {
                        backgroundColor: token.colorBgTextActive
                    },
                    '&::after': {
                        height: varRef(`item-size-actual`),
                        lineHeight: varRef(`item-size-actual`)
                    }
                }
            },
            [`${componentCls}-simple-pager`]: {
                display: 'inline-flex',
                alignItems: 'center',
                height: varRef(`item-size-actual`),
                marginInlineEnd: varRef(`item-spacing-actual`),
                input: {
                    boxSizing: 'border-box',
                    height: '100%',
                    width: token.quickJumperInputWidth,
                    padding: `0 ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.paginationItemPaddingInline)}`,
                    textAlign: 'center',
                    backgroundColor: token.itemInputBg,
                    border: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                    borderRadius: token.borderRadius,
                    outline: 'none',
                    transition: `border-color ${token.motionDurationMid}`,
                    color: 'inherit',
                    '&:hover': {
                        borderColor: token.colorPrimary
                    },
                    '&:focus': {
                        borderColor: token.colorPrimaryHover,
                        boxShadow: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.inputOutlineOffset)} 0 ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.controlOutlineWidth)} ${token.controlOutline}`
                    },
                    '&[disabled]': {
                        color: token.colorTextDisabled,
                        backgroundColor: token.colorBgContainerDisabled,
                        borderColor: token.colorBorder,
                        cursor: 'not-allowed'
                    }
                }
            },
            [`&${componentCls}-disabled`]: {
                [`${componentCls}-prev, ${componentCls}-next`]: {
                    [`${componentCls}-item-link`]: {
                        '&:hover, &:active': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            },
            [`&${componentCls}-small`]: {
                [`${componentCls}-simple-pager`]: {
                    input: {
                        width: token.paginationMiniQuickJumperInputWidth
                    }
                }
            }
        }
    };
};
const $dff214286d5693a2$var$genPaginationInputVariantStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const inputSelector = `${componentCls}-options-quick-jumper input, ${componentCls}-simple-pager input`;
    return {
        [`&${componentCls}-filled`]: {
            [inputSelector]: {
                background: token.colorFillTertiary,
                borderColor: 'transparent',
                '&:hover': {
                    background: token.colorFillSecondary
                },
                '&:focus': {
                    borderColor: token.activeBorderColor,
                    outline: 0,
                    backgroundColor: token.activeBg
                },
                '&[disabled]': {
                    ...(0, $abfb65067786f0b7$export$12789f962d420a93)(token)
                }
            }
        },
        [`&${componentCls}-borderless`]: {
            [inputSelector]: {
                background: 'transparent',
                border: 'none',
                '&:focus': {
                    outline: 'none',
                    boxShadow: 'none'
                },
                '&[disabled]': {
                    color: token.colorTextDisabled,
                    cursor: 'not-allowed'
                }
            }
        },
        [`&${componentCls}-underlined`]: {
            [inputSelector]: {
                background: token.colorBgContainer,
                borderWidth: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.lineWidth)} 0`,
                borderStyle: `${token.lineType} none`,
                borderColor: `transparent transparent ${token.colorBorder} transparent`,
                borderRadius: 0,
                '&:hover': {
                    borderColor: `transparent transparent ${token.hoverBorderColor} transparent`,
                    backgroundColor: token.hoverBg
                },
                '&:focus': {
                    borderColor: `transparent transparent ${token.activeBorderColor} transparent`,
                    outline: 0,
                    backgroundColor: token.activeBg
                },
                '&[disabled]': {
                    color: token.colorTextDisabled,
                    boxShadow: 'none',
                    cursor: 'not-allowed'
                }
            }
        }
    };
};
const $dff214286d5693a2$var$genPaginationJumpStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, sizeLG: sizeLG, antCls: antCls } = token;
    const [, varRef] = (0, $761caadb5301aee1$export$d82b8f66c5649e14)(antCls, 'pagination');
    return {
        [`${componentCls}-jump-prev, ${componentCls}-jump-next`]: {
            outline: 0,
            [`${componentCls}-item-container`]: {
                position: 'relative',
                [`${componentCls}-item-link-icon`]: {
                    color: token.colorPrimary,
                    fontSize: token.fontSizeSM,
                    opacity: 0,
                    transition: `all ${token.motionDurationMid}`,
                    '&-svg': {
                        top: 0,
                        insetInlineEnd: 0,
                        bottom: 0,
                        insetInlineStart: 0,
                        margin: 'auto'
                    }
                },
                [`${componentCls}-item-ellipsis`]: {
                    position: 'absolute',
                    inset: 0,
                    display: 'inline-flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    margin: 'auto',
                    color: token.colorTextDisabled,
                    textAlign: 'center',
                    opacity: 1,
                    transition: `all ${token.motionDurationMid}`,
                    [`${iconCls}-ellipsis > svg`]: {
                        width: sizeLG,
                        height: sizeLG
                    }
                }
            },
            '&:hover': {
                [`${componentCls}-item-link-icon`]: {
                    opacity: 1
                },
                [`${componentCls}-item-ellipsis`]: {
                    opacity: 0
                }
            }
        },
        [`
    ${componentCls}-prev,
    ${componentCls}-jump-prev,
    ${componentCls}-jump-next
    `]: {
            marginInlineEnd: varRef(`item-spacing-actual`)
        },
        [`
    ${componentCls}-prev,
    ${componentCls}-next,
    ${componentCls}-jump-prev,
    ${componentCls}-jump-next
    `]: {
            display: 'inline-block',
            minWidth: varRef(`item-size-actual`),
            height: varRef(`item-size-actual`),
            color: token.colorText,
            fontFamily: token.fontFamily,
            lineHeight: varRef(`item-size-actual`),
            textAlign: 'center',
            verticalAlign: 'middle',
            listStyle: 'none',
            borderRadius: token.borderRadius,
            cursor: 'pointer',
            transition: `all ${token.motionDurationMid}`
        },
        [`${componentCls}-prev, ${componentCls}-next`]: {
            outline: 0,
            button: {
                color: token.colorText,
                cursor: 'pointer',
                userSelect: 'none'
            },
            [`${componentCls}-item-link`]: {
                display: 'block',
                width: '100%',
                height: '100%',
                padding: 0,
                fontSize: token.fontSizeSM,
                textAlign: 'center',
                backgroundColor: 'transparent',
                border: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} transparent`,
                borderRadius: token.borderRadius,
                outline: 'none',
                transition: `all ${token.motionDurationMid}`
            },
            [`&:hover ${componentCls}-item-link`]: {
                backgroundColor: token.colorBgTextHover
            },
            [`&:active ${componentCls}-item-link`]: {
                backgroundColor: token.colorBgTextActive
            },
            [`&${componentCls}-disabled:hover`]: {
                [`${componentCls}-item-link`]: {
                    backgroundColor: 'transparent'
                }
            }
        },
        [`${componentCls}-slash`]: {
            marginInlineEnd: token.paginationSlashMarginInlineEnd,
            marginInlineStart: token.paginationSlashMarginInlineStart
        },
        [`${componentCls}-options`]: {
            display: 'inline-block',
            marginInlineStart: token.margin,
            verticalAlign: 'middle',
            [`&-size-changer, &-size-changer${componentCls}-options-size-changer-select`]: {
                width: 'auto'
            },
            '&-quick-jumper': {
                display: 'inline-block',
                height: varRef(`item-size-actual`),
                marginInlineStart: token.marginXS,
                lineHeight: varRef(`item-size-actual`),
                verticalAlign: 'baseline',
                input: {
                    ...(0, $2a8a1036c9d4d150$export$8c9a381315f3ebcd)(token),
                    ...(0, $abfb65067786f0b7$export$8c569e4cc3fd115f)(token, {
                        borderColor: token.colorBorder,
                        hoverBorderColor: token.colorPrimaryHover,
                        activeBorderColor: token.colorPrimary,
                        activeShadow: token.activeShadow
                    }),
                    '&[disabled]': {
                        ...(0, $abfb65067786f0b7$export$12789f962d420a93)(token)
                    },
                    width: token.quickJumperInputWidth,
                    height: varRef(`item-size-actual`),
                    boxSizing: 'border-box',
                    margin: 0,
                    marginInlineStart: varRef(`item-spacing-actual`),
                    marginInlineEnd: varRef(`item-spacing-actual`)
                }
            }
        }
    };
};
const $dff214286d5693a2$var$genPaginationItemStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    const [, varRef] = (0, $761caadb5301aee1$export$d82b8f66c5649e14)(antCls, 'pagination');
    return {
        [`${componentCls}-item`]: {
            display: 'inline-block',
            minWidth: varRef(`item-size-actual`),
            height: varRef(`item-size-actual`),
            marginInlineEnd: varRef(`item-spacing-actual`),
            fontFamily: token.fontFamily,
            lineHeight: (0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.calc(varRef('item-size-actual')).sub(2).equal()),
            textAlign: 'center',
            verticalAlign: 'middle',
            listStyle: 'none',
            backgroundColor: token.itemBg,
            border: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} transparent`,
            borderRadius: token.borderRadius,
            outline: 0,
            cursor: 'pointer',
            userSelect: 'none',
            a: {
                display: 'block',
                padding: `0 ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.paginationItemPaddingInline)}`,
                color: token.colorText,
                '&:hover': {
                    textDecoration: 'none'
                }
            },
            [`&:not(${componentCls}-item-active)`]: {
                '&:hover': {
                    transition: `all ${token.motionDurationMid}`,
                    backgroundColor: token.colorBgTextHover
                },
                '&:active': {
                    backgroundColor: token.colorBgTextActive
                }
            },
            '&-active': {
                fontWeight: token.fontWeightStrong,
                backgroundColor: token.itemActiveBg,
                borderColor: token.colorPrimary,
                a: {
                    color: token.itemActiveColor
                },
                '&:hover': {
                    borderColor: token.colorPrimaryHover
                },
                '&:hover a': {
                    color: token.itemActiveColorHover
                }
            }
        }
    };
};
const $dff214286d5693a2$var$genPaginationStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    const [varName, varRef] = (0, $761caadb5301aee1$export$d82b8f66c5649e14)(antCls, 'pagination');
    return {
        [componentCls]: {
            [varName(`item-size-actual`)]: (0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.itemSize),
            [varName(`item-spacing-actual`)]: (0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.marginXS),
            '&-small': {
                [varName(`item-size-actual`)]: (0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.itemSizeSM),
                [varName(`item-spacing-actual`)]: (0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.marginXXS)
            },
            '&-large': {
                [varName(`item-size-actual`)]: (0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.itemSizeLG),
                [varName(`item-spacing-actual`)]: (0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.marginSM)
            },
            ...(0, $cd5a520fee8002b4$export$23997c3e44cc1c59)(token),
            display: 'flex',
            alignItems: 'center',
            '&-start': {
                justifyContent: 'start'
            },
            '&-center': {
                justifyContent: 'center'
            },
            '&-end': {
                justifyContent: 'end'
            },
            'ul, ol': {
                margin: 0,
                padding: 0,
                listStyle: 'none'
            },
            '&::after': {
                display: 'block',
                clear: 'both',
                height: 0,
                overflow: 'hidden',
                visibility: 'hidden',
                content: '""'
            },
            [`${componentCls}-total-text`]: {
                display: 'inline-block',
                height: varRef(`item-size-actual`),
                marginInlineEnd: varRef(`item-spacing-actual`),
                lineHeight: (0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.calc(varRef(`item-size-actual`)).sub(2).equal()),
                verticalAlign: 'middle'
            },
            // item style
            ...$dff214286d5693a2$var$genPaginationItemStyle(token),
            // jump btn style
            ...$dff214286d5693a2$var$genPaginationJumpStyle(token),
            // simple style
            ...$dff214286d5693a2$var$genPaginationSimpleStyle(token),
            // input variant style
            ...$dff214286d5693a2$var$genPaginationInputVariantStyle(token),
            // size style
            ...$dff214286d5693a2$var$genPaginationSmallStyle(token),
            ...$dff214286d5693a2$var$genPaginationLargeStyle(token),
            // disabled style
            ...$dff214286d5693a2$var$genPaginationDisabledStyle(token),
            // media query style
            [`@media only screen and (max-width: ${token.screenLG}px)`]: {
                [`${componentCls}-item`]: {
                    '&-after-jump-prev, &-before-jump-next': {
                        display: 'none'
                    }
                }
            },
            [`@media only screen and (max-width: ${token.screenSM}px)`]: {
                [`${componentCls}-options`]: {
                    display: 'none'
                }
            }
        },
        // rtl style
        [`&${token.componentCls}-rtl`]: {
            direction: 'rtl'
        }
    };
};
const $dff214286d5693a2$var$genPaginationFocusStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}:not(${componentCls}-disabled)`]: {
            [`${componentCls}-item`]: {
                ...(0, $cd5a520fee8002b4$export$a44db842bcb28231)(token)
            },
            [`${componentCls}-jump-prev, ${componentCls}-jump-next`]: {
                '&:focus-visible': {
                    [`${componentCls}-item-link-icon`]: {
                        opacity: 1
                    },
                    [`${componentCls}-item-ellipsis`]: {
                        opacity: 0
                    },
                    ...(0, $cd5a520fee8002b4$export$6539948f0a737e39)(token)
                }
            },
            [`${componentCls}-prev, ${componentCls}-next`]: {
                [`&:focus-visible ${componentCls}-item-link`]: (0, $cd5a520fee8002b4$export$6539948f0a737e39)(token)
            }
        }
    };
};
const $dff214286d5693a2$export$9ca1be8807fe0675 = (token)=>({
        itemBg: token.colorBgContainer,
        itemSize: token.controlHeight,
        itemSizeSM: token.controlHeightSM,
        itemSizeLG: token.controlHeightLG,
        itemActiveBg: token.colorBgContainer,
        itemActiveColor: token.colorPrimary,
        itemActiveColorHover: token.colorPrimaryHover,
        itemLinkBg: token.colorBgContainer,
        itemActiveColorDisabled: token.colorTextDisabled,
        itemActiveBgDisabled: token.controlItemBgActiveDisabled,
        itemInputBg: token.colorBgContainer,
        miniOptionsSizeChangerTop: 0,
        ...(0, $9d8327093d1cc6a4$export$bd8b682992bc9781)(token)
    });
const $dff214286d5693a2$export$362fb92a8f81bbf9 = (token)=>(0, $f564548c7b6877d5$export$4950aa0f605343fb)(token, {
        inputOutlineOffset: 0,
        quickJumperInputWidth: token.calc(token.controlHeightLG).mul(1.25).equal(),
        paginationMiniOptionsMarginInlineStart: token.calc(token.marginXXS).div(2).equal(),
        paginationMiniQuickJumperInputWidth: token.calc(token.controlHeightLG).mul(1.1).equal(),
        paginationItemPaddingInline: token.calc(token.marginXXS).mul(1.5).equal(),
        paginationEllipsisLetterSpacing: token.calc(token.marginXXS).div(2).equal(),
        paginationSlashMarginInlineStart: token.marginSM,
        paginationSlashMarginInlineEnd: token.marginSM,
        paginationEllipsisTextIndent: '0.13em' // magic for ui experience
    }, (0, $9d8327093d1cc6a4$export$a157d95850191a12)(token));
var // ============================== Export ==============================
$dff214286d5693a2$export$2e2bcd8739ae039 = (0, $761caadb5301aee1$export$51ec95de45185b42)('Pagination', (token)=>{
    const paginationToken = $dff214286d5693a2$export$362fb92a8f81bbf9(token);
    return [
        $dff214286d5693a2$var$genPaginationStyle(paginationToken),
        $dff214286d5693a2$var$genPaginationFocusStyle(paginationToken)
    ];
}, $dff214286d5693a2$export$9ca1be8807fe0675);





const $02949e5b2bab70b4$var$genBorderedStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}${componentCls}-bordered${componentCls}-disabled`]: {
            '&, &:hover': {
                [`${componentCls}-item-link`]: {
                    borderColor: token.colorBorder
                }
            },
            '&:focus-visible': {
                [`${componentCls}-item-link`]: {
                    borderColor: token.colorBorder
                }
            },
            [`${componentCls}-item, ${componentCls}-item-link`]: {
                backgroundColor: token.colorBgContainerDisabled,
                borderColor: token.colorBorder,
                [`&:hover:not(${componentCls}-item-active)`]: {
                    backgroundColor: token.colorBgContainerDisabled,
                    borderColor: token.colorBorder,
                    a: {
                        color: token.colorTextDisabled
                    }
                },
                [`&${componentCls}-item-active`]: {
                    backgroundColor: token.itemActiveBgDisabled
                }
            },
            [`${componentCls}-prev, ${componentCls}-next`]: {
                '&:hover button': {
                    backgroundColor: token.colorBgContainerDisabled,
                    borderColor: token.colorBorder,
                    color: token.colorTextDisabled
                },
                [`${componentCls}-item-link`]: {
                    backgroundColor: token.colorBgContainerDisabled,
                    borderColor: token.colorBorder
                }
            }
        },
        [`${componentCls}${componentCls}-bordered`]: {
            [`${componentCls}-prev, ${componentCls}-next`]: {
                '&:hover button': {
                    borderColor: token.colorPrimaryHover,
                    backgroundColor: token.itemBg
                },
                [`${componentCls}-item-link`]: {
                    backgroundColor: token.itemLinkBg,
                    borderColor: token.colorBorder
                },
                [`&:hover ${componentCls}-item-link`]: {
                    borderColor: token.colorPrimary,
                    backgroundColor: token.itemBg,
                    color: token.colorPrimary
                },
                [`&${componentCls}-disabled`]: {
                    [`${componentCls}-item-link`]: {
                        borderColor: token.colorBorder,
                        color: token.colorTextDisabled
                    }
                }
            },
            [`${componentCls}-item`]: {
                backgroundColor: token.itemBg,
                border: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                [`&:hover:not(${componentCls}-item-active)`]: {
                    borderColor: token.colorPrimary,
                    backgroundColor: token.itemBg,
                    a: {
                        color: token.colorPrimary
                    }
                },
                '&-active': {
                    borderColor: token.colorPrimary
                }
            }
        }
    };
};
var $02949e5b2bab70b4$export$2e2bcd8739ae039 = (0, $761caadb5301aee1$export$1537386bc155ea56)([
    'Pagination',
    'bordered'
], (token)=>{
    const paginationToken = (0, $dff214286d5693a2$export$362fb92a8f81bbf9)(token);
    return $02949e5b2bab70b4$var$genBorderedStyle(paginationToken);
}, (0, $dff214286d5693a2$export$9ca1be8807fe0675));



var $5E6i4 = parcelRequire("5E6i4");

function $1dc0d21818f0cdd1$export$2e2bcd8739ae039(showSizeChanger) {
    return (0, $5E6i4.useMemo)(()=>{
        if (typeof showSizeChanger === 'boolean') return [
            showSizeChanger,
            {}
        ];
        if ((0, $addbc2fddcbb77a9$export$53b83ca8eaab0383)(showSizeChanger)) return [
            true,
            showSizeChanger
        ];
        return [
            undefined,
            undefined
        ];
    }, [
        showSizeChanger
    ]);
}


"use client";
const $c6dadb39962942ee$var$Pagination = (props)=>{
    const { align: align, prefixCls: customizePrefixCls, selectPrefixCls: customizeSelectPrefixCls, className: className, rootClassName: rootClassName, style: style, size: customizeSize, locale: customLocale, responsive: responsive, showSizeChanger: showSizeChanger, components: components, selectComponentClass: selectComponentClass, pageSizeOptions: pageSizeOptions, styles: styles, classNames: classNames, ...restProps } = props;
    const { xs: xs } = (0, $0fea836ebed3c499$export$2e2bcd8739ae039)(responsive);
    const [, token] = (0, $cb3a44f4e76623bb$export$2e2bcd8739ae039)();
    const { getPrefixCls: getPrefixCls, direction: direction, showSizeChanger: contextShowSizeChangerConfig, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles, totalBoundaryShowSizeChanger: contextTotalBoundaryShowSizeChanger } = (0, $519f2fad435b3034$export$46f4bd6436a25a31)('pagination');
    const prefixCls = getPrefixCls('pagination', customizePrefixCls);
    // Style
    const [hashId, cssVarCls] = (0, $dff214286d5693a2$export$2e2bcd8739ae039)(prefixCls);
    // ============================== Size ==============================
    const mergedSize = (0, $4bfc7567df2a969e$export$2e2bcd8739ae039)(customizeSize);
    const isSmall = mergedSize === 'small' || !!(xs && !mergedSize && responsive);
    const [inputVariant, enableInputVariantCls] = (0, $23d5b57d8a25ce6e$export$2e2bcd8739ae039)('input');
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        size: mergedSize
    };
    // ========================= Style ==========================
    const contextStyleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $722c8632ba7bdb89$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    });
    // ============================= Locale =============================
    const [contextLocale] = (0, $a2f3e1f88973a5e2$export$2e2bcd8739ae039)('Pagination', (0, $32946ac6dcaa91b3$export$2e2bcd8739ae039));
    const locale = {
        ...contextLocale,
        ...customLocale
    };
    // ========================== Size Changer ==========================
    // Merge the props showSizeChanger
    const [propShowSizeChanger, propSizeChangerSelectProps] = (0, $1dc0d21818f0cdd1$export$2e2bcd8739ae039)(showSizeChanger);
    const [contextShowSizeChanger, contextSizeChangerSelectProps] = (0, $1dc0d21818f0cdd1$export$2e2bcd8739ae039)(contextShowSizeChangerConfig);
    const mergedShowSizeChanger = propShowSizeChanger ?? contextShowSizeChanger;
    const mergedShowSizeChangerSelectProps = propSizeChangerSelectProps ?? contextSizeChangerSelectProps;
    const SizeChanger = selectComponentClass || (0, $5a2f22a270cf838a$export$2e2bcd8739ae039);
    // Generate options
    const mergedPageSizeOptions = $5E6i4.useMemo(()=>{
        return pageSizeOptions ? pageSizeOptions.map(Number) : undefined;
    }, [
        pageSizeOptions
    ]);
    // Render size changer
    const sizeChangerRender = (info)=>{
        const { disabled: disabled, size: pageSize, onSizeChange: onSizeChange, 'aria-label': ariaLabel, className: sizeChangerClassName, options: options } = info;
        const SizeChangerComponent = components?.sizeChanger;
        if (SizeChangerComponent) return /*#__PURE__*/ $5E6i4.createElement(SizeChangerComponent, {
            value: pageSize,
            onChange: onSizeChange,
            disabled: !!disabled,
            className: sizeChangerClassName
        });
        const { className: propSizeChangerClassName, onChange: propSizeChangerOnChange } = mergedShowSizeChangerSelectProps || {};
        // Origin Select is using Select.Option,
        // So it make the option value must be string
        // Just for compatible
        const selectedValue = options.find((option)=>String(option.value) === String(pageSize))?.value;
        return /*#__PURE__*/ $5E6i4.createElement(SizeChanger, {
            disabled: disabled,
            showSearch: true,
            popupMatchSelectWidth: false,
            getPopupContainer: (triggerNode)=>triggerNode.parentNode,
            "aria-label": ariaLabel,
            options: options,
            ...mergedShowSizeChangerSelectProps,
            value: selectedValue,
            onChange: (nextSize, option)=>{
                onSizeChange?.(nextSize);
                propSizeChangerOnChange?.(nextSize, option);
            },
            size: mergedSize,
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-options-size-changer-select`, sizeChangerClassName, propSizeChangerClassName)
        });
    };
    // ============================= Render =============================
    const iconsProps = $5E6i4.useMemo(()=>{
        const ellipsis = /*#__PURE__*/ $5E6i4.createElement("span", {
            className: `${prefixCls}-item-ellipsis`
        }, /*#__PURE__*/ $5E6i4.createElement((0, $bc99f102364e8dbf$export$2e2bcd8739ae039), null));
        const prevIcon = /*#__PURE__*/ $5E6i4.createElement("button", {
            className: `${prefixCls}-item-link`,
            type: "button",
            tabIndex: -1
        }, direction === 'rtl' ? /*#__PURE__*/ $5E6i4.createElement((0, $adbdeb3aab803740$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $5E6i4.createElement((0, $2abf808b8f2c53a3$export$2e2bcd8739ae039), null));
        const nextIcon = /*#__PURE__*/ $5E6i4.createElement("button", {
            className: `${prefixCls}-item-link`,
            type: "button",
            tabIndex: -1
        }, direction === 'rtl' ? /*#__PURE__*/ $5E6i4.createElement((0, $2abf808b8f2c53a3$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $5E6i4.createElement((0, $adbdeb3aab803740$export$2e2bcd8739ae039), null));
        const jumpPrevIcon = /*#__PURE__*/ $5E6i4.createElement("a", {
            className: `${prefixCls}-item-link`
        }, /*#__PURE__*/ $5E6i4.createElement("div", {
            className: `${prefixCls}-item-container`
        }, direction === 'rtl' ? /*#__PURE__*/ $5E6i4.createElement((0, $e42cf5ddc79412c9$export$2e2bcd8739ae039), {
            className: `${prefixCls}-item-link-icon`
        }) : /*#__PURE__*/ $5E6i4.createElement((0, $70a2db1425a9091c$export$2e2bcd8739ae039), {
            className: `${prefixCls}-item-link-icon`
        }), ellipsis));
        const jumpNextIcon = /*#__PURE__*/ $5E6i4.createElement("a", {
            className: `${prefixCls}-item-link`
        }, /*#__PURE__*/ $5E6i4.createElement("div", {
            className: `${prefixCls}-item-container`
        }, direction === 'rtl' ? /*#__PURE__*/ $5E6i4.createElement((0, $70a2db1425a9091c$export$2e2bcd8739ae039), {
            className: `${prefixCls}-item-link-icon`
        }) : /*#__PURE__*/ $5E6i4.createElement((0, $e42cf5ddc79412c9$export$2e2bcd8739ae039), {
            className: `${prefixCls}-item-link-icon`
        }), ellipsis));
        return {
            prevIcon: prevIcon,
            nextIcon: nextIcon,
            jumpPrevIcon: jumpPrevIcon,
            jumpNextIcon: jumpNextIcon
        };
    }, [
        direction,
        prefixCls
    ]);
    const selectPrefixCls = getPrefixCls('select', customizeSelectPrefixCls);
    const extendedClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)({
        [`${prefixCls}-${align}`]: !!align,
        [`${prefixCls}-${mergedSize}`]: mergedSize,
        [`${prefixCls}-${inputVariant}`]: enableInputVariantCls && inputVariant !== 'outlined',
        /** @deprecated Should be removed in v7 */ [`${prefixCls}-mini`]: isSmall,
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-bordered`]: token.wireframe
    }, contextClassName, className, rootClassName, mergedClassNames.root, hashId, cssVarCls);
    const mergedStyle = {
        ...mergedStyles.root
    };
    return /*#__PURE__*/ $5E6i4.createElement($5E6i4.Fragment, null, token.wireframe && /*#__PURE__*/ $5E6i4.createElement((0, $02949e5b2bab70b4$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }), /*#__PURE__*/ $5E6i4.createElement((0, $046ea69c7c6e9f97$export$2e2bcd8739ae039), {
        ...iconsProps,
        ...restProps,
        styles: mergedStyles,
        classNames: mergedClassNames,
        style: mergedStyle,
        prefixCls: prefixCls,
        selectPrefixCls: selectPrefixCls,
        className: extendedClassName,
        locale: locale,
        pageSizeOptions: mergedPageSizeOptions,
        showSizeChanger: mergedShowSizeChanger,
        totalBoundaryShowSizeChanger: restProps.totalBoundaryShowSizeChanger ?? contextTotalBoundaryShowSizeChanger,
        sizeChangerRender: sizeChangerRender
    }));
};
var $c6dadb39962942ee$export$2e2bcd8739ae039 = $c6dadb39962942ee$var$Pagination;


"use client";
var $c8ee2867395b7990$export$2e2bcd8739ae039 = (0, $c6dadb39962942ee$export$2e2bcd8739ae039);


var $8728cf26869ed5b2$exports = {};
var $e2a68dd7b8e7177c$exports = {};
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
$e2a68dd7b8e7177c$exports = $e2a68dd7b8e7177c$var$Stream;

var $9KgKE = parcelRequire("9KgKE");
var $e2a68dd7b8e7177c$require$EE = $9KgKE.EventEmitter;

var $9YOog = parcelRequire("9YOog");
$9YOog($e2a68dd7b8e7177c$var$Stream, $e2a68dd7b8e7177c$require$EE);

$e2a68dd7b8e7177c$var$Stream.Readable = (parcelRequire("ljYrj"));

$e2a68dd7b8e7177c$var$Stream.Writable = (parcelRequire("eAzUD"));

$e2a68dd7b8e7177c$var$Stream.Duplex = (parcelRequire("5PuTj"));

$e2a68dd7b8e7177c$var$Stream.Transform = (parcelRequire("9Pily"));

$e2a68dd7b8e7177c$var$Stream.PassThrough = (parcelRequire("euhdJ"));

$e2a68dd7b8e7177c$var$Stream.finished = (parcelRequire("iMJxh"));

$e2a68dd7b8e7177c$var$Stream.pipeline = (parcelRequire("atWzg"));
// Backwards-compat with node 0.4.x
$e2a68dd7b8e7177c$var$Stream.Stream = $e2a68dd7b8e7177c$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $e2a68dd7b8e7177c$var$Stream() {
    $e2a68dd7b8e7177c$require$EE.call(this);
}
$e2a68dd7b8e7177c$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($e2a68dd7b8e7177c$require$EE.listenerCount(this, 'error') === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on('error', onerror);
    dest.on('error', onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};


var $8728cf26869ed5b2$require$WritableStream = $e2a68dd7b8e7177c$exports.Writable;
var $04debabf9f18a7a1$exports = {};
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $4Jj9n = parcelRequire("4Jj9n");
var $04debabf9f18a7a1$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $04debabf9f18a7a1$var$formatRegExp = /%[sdj%]/g;
$04debabf9f18a7a1$exports.format = function(f) {
    if (!$04debabf9f18a7a1$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($04debabf9f18a7a1$var$inspect(arguments[i]));
        return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($04debabf9f18a7a1$var$formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch(x){
            case '%s':
                return String(args[i++]);
            case '%d':
                return Number(args[i++]);
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return '[Circular]';
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($04debabf9f18a7a1$var$isNull(x) || !$04debabf9f18a7a1$var$isObject(x)) str += ' ' + x;
    else str += ' ' + $04debabf9f18a7a1$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
$04debabf9f18a7a1$exports.deprecate = function(fn, msg) {
    var warned;
    return function() {
        return $04debabf9f18a7a1$exports.deprecate(fn, msg).apply(this, arguments);
    };
    function deprecated() {
        if (!warned) {
            if ($4Jj9n.throwDeprecation) throw new Error(msg);
            else if ($4Jj9n.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
};
var $04debabf9f18a7a1$var$debugs = {};
var $04debabf9f18a7a1$var$debugEnvRegex = /^$/;
var $04debabf9f18a7a1$var$debugEnv;
$04debabf9f18a7a1$exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$04debabf9f18a7a1$var$debugs[set]) {
        if ($04debabf9f18a7a1$var$debugEnvRegex.test(set)) {
            var pid = $4Jj9n.pid;
            $04debabf9f18a7a1$var$debugs[set] = function() {
                var msg = $04debabf9f18a7a1$exports.format.apply($04debabf9f18a7a1$exports, arguments);
                console.error('%s %d: %s', set, pid, msg);
            };
        } else $04debabf9f18a7a1$var$debugs[set] = function() {};
    }
    return $04debabf9f18a7a1$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $04debabf9f18a7a1$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $04debabf9f18a7a1$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($04debabf9f18a7a1$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    $04debabf9f18a7a1$exports._extend(ctx, opts);
    // set default options
    if ($04debabf9f18a7a1$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($04debabf9f18a7a1$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($04debabf9f18a7a1$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($04debabf9f18a7a1$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $04debabf9f18a7a1$var$stylizeWithColor;
    return $04debabf9f18a7a1$var$formatValue(ctx, obj, ctx.depth);
}
$04debabf9f18a7a1$exports.inspect = $04debabf9f18a7a1$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$04debabf9f18a7a1$var$inspect.colors = {
    'bold': [
        1,
        22
    ],
    'italic': [
        3,
        23
    ],
    'underline': [
        4,
        24
    ],
    'inverse': [
        7,
        27
    ],
    'white': [
        37,
        39
    ],
    'grey': [
        90,
        39
    ],
    'black': [
        30,
        39
    ],
    'blue': [
        34,
        39
    ],
    'cyan': [
        36,
        39
    ],
    'green': [
        32,
        39
    ],
    'magenta': [
        35,
        39
    ],
    'red': [
        31,
        39
    ],
    'yellow': [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$04debabf9f18a7a1$var$inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
};
function $04debabf9f18a7a1$var$stylizeWithColor(str, styleType) {
    var style = $04debabf9f18a7a1$var$inspect.styles[styleType];
    if (style) return '\u001b[' + $04debabf9f18a7a1$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $04debabf9f18a7a1$var$inspect.colors[style][1] + 'm';
    else return str;
}
function $04debabf9f18a7a1$var$stylizeNoColor(str, styleType) {
    return str;
}
function $04debabf9f18a7a1$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $04debabf9f18a7a1$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $04debabf9f18a7a1$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== $04debabf9f18a7a1$exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$04debabf9f18a7a1$var$isString(ret)) ret = $04debabf9f18a7a1$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $04debabf9f18a7a1$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $04debabf9f18a7a1$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($04debabf9f18a7a1$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $04debabf9f18a7a1$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($04debabf9f18a7a1$var$isFunction(value)) {
            var name = value.name ? ': ' + value.name : '';
            return ctx.stylize('[Function' + name + ']', 'special');
        }
        if ($04debabf9f18a7a1$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        if ($04debabf9f18a7a1$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
        if ($04debabf9f18a7a1$var$isError(value)) return $04debabf9f18a7a1$var$formatError(value);
    }
    var base = '', array = false, braces = [
        '{',
        '}'
    ];
    // Make Array say that they are Array
    if ($04debabf9f18a7a1$var$isArray(value)) {
        array = true;
        braces = [
            '[',
            ']'
        ];
    }
    // Make functions say that they are functions
    if ($04debabf9f18a7a1$var$isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
    }
    // Make RegExps say that they are RegExps
    if ($04debabf9f18a7a1$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($04debabf9f18a7a1$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($04debabf9f18a7a1$var$isError(value)) base = ' ' + $04debabf9f18a7a1$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($04debabf9f18a7a1$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        else return ctx.stylize('[Object]', 'special');
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $04debabf9f18a7a1$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $04debabf9f18a7a1$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $04debabf9f18a7a1$var$reduceToSingleString(output, base, braces);
}
function $04debabf9f18a7a1$var$formatPrimitive(ctx, value) {
    if ($04debabf9f18a7a1$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if ($04debabf9f18a7a1$var$isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
    }
    if ($04debabf9f18a7a1$var$isNumber(value)) return ctx.stylize('' + value, 'number');
    if ($04debabf9f18a7a1$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if ($04debabf9f18a7a1$var$isNull(value)) return ctx.stylize('null', 'null');
}
function $04debabf9f18a7a1$var$formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
}
function $04debabf9f18a7a1$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($04debabf9f18a7a1$var$hasOwnProperty(value, String(i))) output.push($04debabf9f18a7a1$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push('');
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($04debabf9f18a7a1$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $04debabf9f18a7a1$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
        else str = ctx.stylize('[Getter]', 'special');
    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
    if (!$04debabf9f18a7a1$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($04debabf9f18a7a1$var$isNull(recurseTimes)) str = $04debabf9f18a7a1$var$formatValue(ctx, desc.value, null);
            else str = $04debabf9f18a7a1$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf('\n') > -1) {
                if (array) str = str.split('\n').map(function(line) {
                    return '  ' + line;
                }).join('\n').slice(2);
                else str = '\n' + str.split('\n').map(function(line) {
                    return '   ' + line;
                }).join('\n');
            }
        } else str = ctx.stylize('[Circular]', 'special');
    }
    if ($04debabf9f18a7a1$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, 'name');
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, 'string');
        }
    }
    return name + ': ' + str;
}
function $04debabf9f18a7a1$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf('\n') >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
$04debabf9f18a7a1$exports.types = (parcelRequire("e9HhI"));
function $04debabf9f18a7a1$var$isArray(ar) {
    return Array.isArray(ar);
}
$04debabf9f18a7a1$exports.isArray = $04debabf9f18a7a1$var$isArray;
function $04debabf9f18a7a1$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
$04debabf9f18a7a1$exports.isBoolean = $04debabf9f18a7a1$var$isBoolean;
function $04debabf9f18a7a1$var$isNull(arg) {
    return arg === null;
}
$04debabf9f18a7a1$exports.isNull = $04debabf9f18a7a1$var$isNull;
function $04debabf9f18a7a1$var$isNullOrUndefined(arg) {
    return arg == null;
}
$04debabf9f18a7a1$exports.isNullOrUndefined = $04debabf9f18a7a1$var$isNullOrUndefined;
function $04debabf9f18a7a1$var$isNumber(arg) {
    return typeof arg === 'number';
}
$04debabf9f18a7a1$exports.isNumber = $04debabf9f18a7a1$var$isNumber;
function $04debabf9f18a7a1$var$isString(arg) {
    return typeof arg === 'string';
}
$04debabf9f18a7a1$exports.isString = $04debabf9f18a7a1$var$isString;
function $04debabf9f18a7a1$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
$04debabf9f18a7a1$exports.isSymbol = $04debabf9f18a7a1$var$isSymbol;
function $04debabf9f18a7a1$var$isUndefined(arg) {
    return arg === void 0;
}
$04debabf9f18a7a1$exports.isUndefined = $04debabf9f18a7a1$var$isUndefined;
function $04debabf9f18a7a1$var$isRegExp(re) {
    return $04debabf9f18a7a1$var$isObject(re) && $04debabf9f18a7a1$var$objectToString(re) === '[object RegExp]';
}
$04debabf9f18a7a1$exports.isRegExp = $04debabf9f18a7a1$var$isRegExp;
$04debabf9f18a7a1$exports.types.isRegExp = $04debabf9f18a7a1$var$isRegExp;
function $04debabf9f18a7a1$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
$04debabf9f18a7a1$exports.isObject = $04debabf9f18a7a1$var$isObject;
function $04debabf9f18a7a1$var$isDate(d) {
    return $04debabf9f18a7a1$var$isObject(d) && $04debabf9f18a7a1$var$objectToString(d) === '[object Date]';
}
$04debabf9f18a7a1$exports.isDate = $04debabf9f18a7a1$var$isDate;
$04debabf9f18a7a1$exports.types.isDate = $04debabf9f18a7a1$var$isDate;
function $04debabf9f18a7a1$var$isError(e) {
    return $04debabf9f18a7a1$var$isObject(e) && ($04debabf9f18a7a1$var$objectToString(e) === '[object Error]' || e instanceof Error);
}
$04debabf9f18a7a1$exports.isError = $04debabf9f18a7a1$var$isError;
$04debabf9f18a7a1$exports.types.isNativeError = $04debabf9f18a7a1$var$isError;
function $04debabf9f18a7a1$var$isFunction(arg) {
    return typeof arg === 'function';
}
$04debabf9f18a7a1$exports.isFunction = $04debabf9f18a7a1$var$isFunction;
function $04debabf9f18a7a1$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
$04debabf9f18a7a1$exports.isPrimitive = $04debabf9f18a7a1$var$isPrimitive;

$04debabf9f18a7a1$exports.isBuffer = (parcelRequire("gVfcn"));
function $04debabf9f18a7a1$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $04debabf9f18a7a1$var$pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
}
var $04debabf9f18a7a1$var$months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
// 26 Feb 16:19:34
function $04debabf9f18a7a1$var$timestamp() {
    var d = new Date();
    var time = [
        $04debabf9f18a7a1$var$pad(d.getHours()),
        $04debabf9f18a7a1$var$pad(d.getMinutes()),
        $04debabf9f18a7a1$var$pad(d.getSeconds())
    ].join(':');
    return [
        d.getDate(),
        $04debabf9f18a7a1$var$months[d.getMonth()],
        time
    ].join(' ');
}
// log is just a thin wrapper to console.log that prepends a timestamp
$04debabf9f18a7a1$exports.log = function() {
    console.log('%s - %s', $04debabf9f18a7a1$var$timestamp(), $04debabf9f18a7a1$exports.format.apply($04debabf9f18a7a1$exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ $04debabf9f18a7a1$exports.inherits = (parcelRequire("9YOog"));
$04debabf9f18a7a1$exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$04debabf9f18a7a1$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $04debabf9f18a7a1$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $04debabf9f18a7a1$var$kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
$04debabf9f18a7a1$exports.promisify = function promisify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    if ($04debabf9f18a7a1$var$kCustomPromisifiedSymbol && original[$04debabf9f18a7a1$var$kCustomPromisifiedSymbol]) {
        var fn = original[$04debabf9f18a7a1$var$kCustomPromisifiedSymbol];
        if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $04debabf9f18a7a1$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($04debabf9f18a7a1$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $04debabf9f18a7a1$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $04debabf9f18a7a1$var$getOwnPropertyDescriptors(original));
};
$04debabf9f18a7a1$exports.promisify.custom = $04debabf9f18a7a1$var$kCustomPromisifiedSymbol;
function $04debabf9f18a7a1$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error('Promise was rejected with a falsy value');
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $04debabf9f18a7a1$var$callbackify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $4Jj9n.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $4Jj9n.nextTick($04debabf9f18a7a1$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $04debabf9f18a7a1$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
$04debabf9f18a7a1$exports.callbackify = $04debabf9f18a7a1$var$callbackify;


var $06e325d38b16b6ec$exports = {};
/**
 * Create a blob builder even when vendor prefixes exist
 */ var $06e325d38b16b6ec$var$BlobBuilder = $parcel$global.BlobBuilder || $parcel$global.WebKitBlobBuilder || $parcel$global.MSBlobBuilder || $parcel$global.MozBlobBuilder;
/**
 * Check if Blob constructor is supported
 */ var $06e325d38b16b6ec$var$blobSupported = function() {
    try {
        var a = new Blob([
            'hi'
        ]);
        return a.size === 2;
    } catch (e) {
        return false;
    }
}();
/**
 * Check if Blob constructor supports ArrayBufferViews
 * Fails in Safari 6, so we need to map to ArrayBuffers there.
 */ var $06e325d38b16b6ec$var$blobSupportsArrayBufferView = $06e325d38b16b6ec$var$blobSupported && function() {
    try {
        var b = new Blob([
            new Uint8Array([
                1,
                2
            ])
        ]);
        return b.size === 2;
    } catch (e) {
        return false;
    }
}();
/**
 * Check if BlobBuilder is supported
 */ var $06e325d38b16b6ec$var$blobBuilderSupported = $06e325d38b16b6ec$var$BlobBuilder && $06e325d38b16b6ec$var$BlobBuilder.prototype.append && $06e325d38b16b6ec$var$BlobBuilder.prototype.getBlob;
/**
 * Helper function that maps ArrayBufferViews to ArrayBuffers
 * Used by BlobBuilder constructor and old browsers that didn't
 * support it in the Blob constructor.
 */ function $06e325d38b16b6ec$var$mapArrayBufferViews(ary) {
    for(var i = 0; i < ary.length; i++){
        var chunk = ary[i];
        if (chunk.buffer instanceof ArrayBuffer) {
            var buf = chunk.buffer;
            // if this is a subarray, make a copy so we only
            // include the subarray region from the underlying buffer
            if (chunk.byteLength !== buf.byteLength) {
                var copy = new Uint8Array(chunk.byteLength);
                copy.set(new Uint8Array(buf, chunk.byteOffset, chunk.byteLength));
                buf = copy.buffer;
            }
            ary[i] = buf;
        }
    }
}
function $06e325d38b16b6ec$var$BlobBuilderConstructor(ary, options) {
    options = options || {};
    var bb = new $06e325d38b16b6ec$var$BlobBuilder();
    $06e325d38b16b6ec$var$mapArrayBufferViews(ary);
    for(var i = 0; i < ary.length; i++)bb.append(ary[i]);
    return options.type ? bb.getBlob(options.type) : bb.getBlob();
}
function $06e325d38b16b6ec$var$BlobConstructor(ary, options) {
    $06e325d38b16b6ec$var$mapArrayBufferViews(ary);
    return new Blob(ary, options || {});
}
$06e325d38b16b6ec$exports = function() {
    if ($06e325d38b16b6ec$var$blobSupported) return $06e325d38b16b6ec$var$blobSupportsArrayBufferView ? $parcel$global.Blob : $06e325d38b16b6ec$var$BlobConstructor;
    else if ($06e325d38b16b6ec$var$blobBuilderSupported) return $06e325d38b16b6ec$var$BlobBuilderConstructor;
    else return undefined;
}();


var $8728cf26869ed5b2$var$URL = $parcel$global.URL || $parcel$global.webkitURL || $parcel$global.mozURL;
function $8728cf26869ed5b2$var$BlobStream() {
    if (!(this instanceof $8728cf26869ed5b2$var$BlobStream)) return new $8728cf26869ed5b2$var$BlobStream;
    $8728cf26869ed5b2$require$WritableStream.call(this);
    this._chunks = [];
    this._blob = null;
    this.length = 0;
}
$04debabf9f18a7a1$exports.inherits($8728cf26869ed5b2$var$BlobStream, $8728cf26869ed5b2$require$WritableStream);
$8728cf26869ed5b2$var$BlobStream.prototype._write = function(chunk, encoding, callback) {
    // convert chunks to Uint8Arrays (e.g. Buffer when array fallback is being used)
    if (!(chunk instanceof Uint8Array)) chunk = new Uint8Array(chunk);
    this.length += chunk.length;
    this._chunks.push(chunk);
    callback();
};
$8728cf26869ed5b2$var$BlobStream.prototype.toBlob = function(type) {
    type = type || 'application/octet-stream';
    // cache the blob if needed
    if (!this._blob) {
        this._blob = new $06e325d38b16b6ec$exports(this._chunks, {
            type: type
        });
        this._chunks = []; // free memory
    }
    // if the cached blob's type doesn't match the requested type, make a new blob
    if (this._blob.type !== type) this._blob = new $06e325d38b16b6ec$exports([
        this._blob
    ], {
        type: type
    });
    return this._blob;
};
$8728cf26869ed5b2$var$BlobStream.prototype.toBlobURL = function(type) {
    return $8728cf26869ed5b2$var$URL.createObjectURL(this.toBlob(type));
};
$8728cf26869ed5b2$exports = $8728cf26869ed5b2$var$BlobStream;




var $5pSp9 = parcelRequire("5pSp9");

var $5E6i4 = parcelRequire("5E6i4");



var $b4Fkn = parcelRequire("b4Fkn");

/**
 * Utilities for hex, bytes, CSPRNG.
 * @module
 */ /*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // We use WebCrypto aka globalThis.crypto, which exists in browsers and node.js 16+.
// node.js versions earlier than v19 don't declare it in global scope.
// For node.js, package.json#exports field mapping rewrites import
// from `crypto` to `cryptoNode`, which imports native module.
// Makes the utils un-importable in browsers without a bundler.
// Once node.js 18 is deprecated (2025-04-30), we can just drop the import.
const $bc0136535a79b37d$export$7effb53edfc7fa2d = typeof globalThis === 'object' && 'crypto' in globalThis ? globalThis.crypto : undefined;


function $f354203f433ec289$export$c6fabfbfd097fc30(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === 'Uint8Array';
}
function $f354203f433ec289$export$75364c6cb16d43b6(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error('positive integer expected, got ' + n);
}
function $f354203f433ec289$export$e8a750b9efad93f5(b, ...lengths) {
    if (!$f354203f433ec289$export$c6fabfbfd097fc30(b)) throw new Error('Uint8Array expected');
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error('Uint8Array expected of length ' + lengths + ', got length=' + b.length);
}
function $f354203f433ec289$export$3ff5a4f04de7e52e(h) {
    if (typeof h !== 'function' || typeof h.create !== 'function') throw new Error('Hash should be wrapped by utils.createHasher');
    $f354203f433ec289$export$75364c6cb16d43b6(h.outputLen);
    $f354203f433ec289$export$75364c6cb16d43b6(h.blockLen);
}
function $f354203f433ec289$export$20871f6b1d047d77(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error('Hash instance has been destroyed');
    if (checkFinished && instance.finished) throw new Error('Hash#digest() has already been called');
}
function $f354203f433ec289$export$e8e53abee12b995e(out, instance) {
    $f354203f433ec289$export$e8a750b9efad93f5(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error('digestInto() expects output buffer of length at least ' + min);
}
function $f354203f433ec289$export$9813fca58c0b9f71(arr) {
    return new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
}
function $f354203f433ec289$export$8bacf4ad828c7fe7(arr) {
    return new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
}
function $f354203f433ec289$export$cf0b2a6c63f9e656(...arrays) {
    for(let i = 0; i < arrays.length; i++)arrays[i].fill(0);
}
function $f354203f433ec289$export$d7febe7b891e79f0(arr) {
    return new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
}
function $f354203f433ec289$export$466993d7d0d272aa(word, shift) {
    return word << 32 - shift | word >>> shift;
}
function $f354203f433ec289$export$ac5e39599698b562(word, shift) {
    return word << shift | word >>> 32 - shift >>> 0;
}
const $f354203f433ec289$export$a0f88e38d4cf9577 = /* @__PURE__ */ (()=>new Uint8Array(new Uint32Array([
        0x11223344
    ]).buffer)[0] === 0x44)();
function $f354203f433ec289$export$a4170f7f8be47425(word) {
    return word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
}
const $f354203f433ec289$export$e108944b32ae0e38 = $f354203f433ec289$export$a0f88e38d4cf9577 ? (n)=>n : (n)=>$f354203f433ec289$export$a4170f7f8be47425(n);
const $f354203f433ec289$export$4a0a88cc2d284e7f = $f354203f433ec289$export$e108944b32ae0e38;
function $f354203f433ec289$export$97b40fc37f25d711(arr) {
    for(let i = 0; i < arr.length; i++)arr[i] = $f354203f433ec289$export$a4170f7f8be47425(arr[i]);
    return arr;
}
const $f354203f433ec289$export$f3e5ccb1e5f96d20 = $f354203f433ec289$export$a0f88e38d4cf9577 ? (u)=>u : $f354203f433ec289$export$97b40fc37f25d711;
// Built-in hex conversion https://caniuse.com/mdn-javascript_builtins_uint8array_fromhex
const $f354203f433ec289$var$hasHexBuiltin = /* @__PURE__ */ (()=>// @ts-ignore
    typeof Uint8Array.from([]).toHex === 'function' && typeof Uint8Array.fromHex === 'function')();
// Array where index 0xf0 (240) is mapped to string 'f0'
const $f354203f433ec289$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, '0'));
function $f354203f433ec289$export$58b867e287a802c8(bytes) {
    $f354203f433ec289$export$e8a750b9efad93f5(bytes);
    // @ts-ignore
    if ($f354203f433ec289$var$hasHexBuiltin) return bytes.toHex();
    // pre-caching improves the speed 6x
    let hex = '';
    for(let i = 0; i < bytes.length; i++)hex += $f354203f433ec289$var$hexes[bytes[i]];
    return hex;
}
// We use optimized technique to convert hex string to byte array
const $f354203f433ec289$var$asciis = {
    _0: 48,
    _9: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $f354203f433ec289$var$asciiToBase16(ch) {
    if (ch >= $f354203f433ec289$var$asciis._0 && ch <= $f354203f433ec289$var$asciis._9) return ch - $f354203f433ec289$var$asciis._0; // '2' => 50-48
    if (ch >= $f354203f433ec289$var$asciis.A && ch <= $f354203f433ec289$var$asciis.F) return ch - ($f354203f433ec289$var$asciis.A - 10); // 'B' => 66-(65-10)
    if (ch >= $f354203f433ec289$var$asciis.a && ch <= $f354203f433ec289$var$asciis.f) return ch - ($f354203f433ec289$var$asciis.a - 10); // 'b' => 98-(97-10)
    return;
}
function $f354203f433ec289$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== 'string') throw new Error('hex string expected, got ' + typeof hex);
    // @ts-ignore
    if ($f354203f433ec289$var$hasHexBuiltin) return Uint8Array.fromHex(hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error('hex string expected, got unpadded hex of length ' + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $f354203f433ec289$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $f354203f433ec289$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2; // multiply first octet, e.g. 'a3' => 10*16+3 => 160 + 3 => 163
    }
    return array;
}
const $f354203f433ec289$export$bdd553fddd433dcb = async ()=>{};
async function $f354203f433ec289$export$57207d71b8c929c8(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await $f354203f433ec289$export$bdd553fddd433dcb();
        ts += diff;
    }
}
function $f354203f433ec289$export$3df70a15530b5e81(str) {
    if (typeof str !== 'string') throw new Error('string expected');
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
function $f354203f433ec289$export$5f46301b4a1d43db(bytes) {
    return new TextDecoder().decode(bytes);
}
function $f354203f433ec289$export$30a71edf0753ed6b(data) {
    if (typeof data === 'string') data = $f354203f433ec289$export$3df70a15530b5e81(data);
    $f354203f433ec289$export$e8a750b9efad93f5(data);
    return data;
}
function $f354203f433ec289$export$e01ba4a527b8942d(data) {
    if (typeof data === 'string') data = $f354203f433ec289$export$3df70a15530b5e81(data);
    $f354203f433ec289$export$e8a750b9efad93f5(data);
    return data;
}
function $f354203f433ec289$export$287dd7971339c972(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        $f354203f433ec289$export$e8a750b9efad93f5(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
function $f354203f433ec289$export$6fcee72895eceb1e(defaults, opts) {
    if (opts !== undefined && ({}).toString.call(opts) !== '[object Object]') throw new Error('options should be object or undefined');
    const merged = Object.assign(defaults, opts);
    return merged;
}
class $f354203f433ec289$export$ab85ecd77ce6a5cd {
}
function $f354203f433ec289$export$14b114effbc08b6b(hashCons) {
    const hashC = (msg)=>hashCons().update($f354203f433ec289$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
function $f354203f433ec289$export$aaa6b3684f701ca2(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($f354203f433ec289$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $f354203f433ec289$export$741ac6dc04ed5295(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($f354203f433ec289$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
const $f354203f433ec289$export$f081816339df1972 = $f354203f433ec289$export$14b114effbc08b6b;
const $f354203f433ec289$export$b465638d1569a3ae = $f354203f433ec289$export$aaa6b3684f701ca2;
const $f354203f433ec289$export$e18964dbd6e083c1 = $f354203f433ec289$export$741ac6dc04ed5295;
function $f354203f433ec289$export$5f828d93ff035aa8(bytesLength = 32) {
    if ((0, $bc0136535a79b37d$export$7effb53edfc7fa2d) && typeof (0, $bc0136535a79b37d$export$7effb53edfc7fa2d).getRandomValues === 'function') return (0, $bc0136535a79b37d$export$7effb53edfc7fa2d).getRandomValues(new Uint8Array(bytesLength));
    // Legacy Node.js compatibility
    if ((0, $bc0136535a79b37d$export$7effb53edfc7fa2d) && typeof (0, $bc0136535a79b37d$export$7effb53edfc7fa2d).randomBytes === 'function') return Uint8Array.from((0, $bc0136535a79b37d$export$7effb53edfc7fa2d).randomBytes(bytesLength));
    throw new Error('crypto.getRandomValues must be defined');
}


// DEFLATE is a complex format; to read this code, you should probably check the RFC first:
// https://tools.ietf.org/html/rfc1951
// You may also wish to take a look at the guide I made about this program:
// https://gist.github.com/101arrowz/253f31eb5abc3d9275ab943003ffecad
// Some of the following code is similar to that of UZIP.js:
// https://github.com/photopea/UZIP.js
// However, the vast majority of the codebase has diverged from UZIP.js to increase performance and reduce bundle size.
// Sometimes 0 will appear where -1 would be more appropriate. This is because using a uint
// is better for memory in most engines (I *think*).
var $cb0093123c05defe$var$ch2 = {};
var $cb0093123c05defe$var$wk = function(c, id, msg, transfer, cb) {
    var w = new Worker($cb0093123c05defe$var$ch2[id] || ($cb0093123c05defe$var$ch2[id] = URL.createObjectURL(new Blob([
        c + ';addEventListener("error",function(e){e=e.error;postMessage({$e$:[e.message,e.code,e.stack]})})'
    ], {
        type: 'text/javascript'
    }))));
    w.onmessage = function(e) {
        var d = e.data, ed = d.$e$;
        if (ed) {
            var err = new Error(ed[0]);
            err['code'] = ed[1];
            err.stack = ed[2];
            cb(err, null);
        } else cb(null, d);
    };
    w.postMessage(msg, transfer);
    return w;
};
// aliases for shorter compressed code (most minifers don't do this)
var $cb0093123c05defe$var$u8 = Uint8Array, $cb0093123c05defe$var$u16 = Uint16Array, $cb0093123c05defe$var$i32 = Int32Array;
// fixed length extra bits
var $cb0093123c05defe$var$fleb = new $cb0093123c05defe$var$u8([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    /* unused */ 0,
    0,
    /* impossible */ 0
]);
// fixed distance extra bits
var $cb0093123c05defe$var$fdeb = new $cb0093123c05defe$var$u8([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    /* unused */ 0,
    0
]);
// code length index map
var $cb0093123c05defe$var$clim = new $cb0093123c05defe$var$u8([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
// get base, reverse index map from extra bits
var $cb0093123c05defe$var$freb = function(eb, start) {
    var b = new $cb0093123c05defe$var$u16(31);
    for(var i = 0; i < 31; ++i)b[i] = start += 1 << eb[i - 1];
    // numbers here are at max 18 bits
    var r = new $cb0093123c05defe$var$i32(b[30]);
    for(var i = 1; i < 30; ++i)for(var j = b[i]; j < b[i + 1]; ++j)r[j] = j - b[i] << 5 | i;
    return {
        b: b,
        r: r
    };
};
var $cb0093123c05defe$var$_a = $cb0093123c05defe$var$freb($cb0093123c05defe$var$fleb, 2), $cb0093123c05defe$var$fl = $cb0093123c05defe$var$_a.b, $cb0093123c05defe$var$revfl = $cb0093123c05defe$var$_a.r;
// we can ignore the fact that the other numbers are wrong; they never happen anyway
$cb0093123c05defe$var$fl[28] = 258, $cb0093123c05defe$var$revfl[258] = 28;
var $cb0093123c05defe$var$_b = $cb0093123c05defe$var$freb($cb0093123c05defe$var$fdeb, 0), $cb0093123c05defe$var$fd = $cb0093123c05defe$var$_b.b, $cb0093123c05defe$var$revfd = $cb0093123c05defe$var$_b.r;
// map of value to reverse (assuming 16 bits)
var $cb0093123c05defe$var$rev = new $cb0093123c05defe$var$u16(32768);
for(var $cb0093123c05defe$var$i = 0; $cb0093123c05defe$var$i < 32768; ++$cb0093123c05defe$var$i){
    // reverse table algorithm from SO
    var $cb0093123c05defe$var$x = ($cb0093123c05defe$var$i & 0xAAAA) >> 1 | ($cb0093123c05defe$var$i & 0x5555) << 1;
    $cb0093123c05defe$var$x = ($cb0093123c05defe$var$x & 0xCCCC) >> 2 | ($cb0093123c05defe$var$x & 0x3333) << 2;
    $cb0093123c05defe$var$x = ($cb0093123c05defe$var$x & 0xF0F0) >> 4 | ($cb0093123c05defe$var$x & 0x0F0F) << 4;
    $cb0093123c05defe$var$rev[$cb0093123c05defe$var$i] = (($cb0093123c05defe$var$x & 0xFF00) >> 8 | ($cb0093123c05defe$var$x & 0x00FF) << 8) >> 1;
}
// create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?
var $cb0093123c05defe$var$hMap = function(cd, mb, r) {
    var s = cd.length;
    // index
    var i = 0;
    // u16 "map": index -> # of codes with bit length = index
    var l = new $cb0093123c05defe$var$u16(mb);
    // length of cd must be 288 (total # of codes)
    for(; i < s; ++i)if (cd[i]) ++l[cd[i] - 1];
    // u16 "map": index -> minimum code for bit length = index
    var le = new $cb0093123c05defe$var$u16(mb);
    for(i = 1; i < mb; ++i)le[i] = le[i - 1] + l[i - 1] << 1;
    var co;
    if (r) {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new $cb0093123c05defe$var$u16(1 << mb);
        // bits to remove for reverser
        var rvb = 15 - mb;
        for(i = 0; i < s; ++i)// ignore 0 lengths
        if (cd[i]) {
            // num encoding both symbol and bits read
            var sv = i << 4 | cd[i];
            // free bits
            var r_1 = mb - cd[i];
            // start value
            var v = le[cd[i] - 1]++ << r_1;
            // m is end value
            for(var m = v | (1 << r_1) - 1; v <= m; ++v)// every 16 bit value starting with the code yields the same result
            co[$cb0093123c05defe$var$rev[v] >> rvb] = sv;
        }
    } else {
        co = new $cb0093123c05defe$var$u16(s);
        for(i = 0; i < s; ++i)if (cd[i]) co[i] = $cb0093123c05defe$var$rev[le[cd[i] - 1]++] >> 15 - cd[i];
    }
    return co;
};
// fixed length tree
var $cb0093123c05defe$var$flt = new $cb0093123c05defe$var$u8(288);
for(var $cb0093123c05defe$var$i = 0; $cb0093123c05defe$var$i < 144; ++$cb0093123c05defe$var$i)$cb0093123c05defe$var$flt[$cb0093123c05defe$var$i] = 8;
for(var $cb0093123c05defe$var$i = 144; $cb0093123c05defe$var$i < 256; ++$cb0093123c05defe$var$i)$cb0093123c05defe$var$flt[$cb0093123c05defe$var$i] = 9;
for(var $cb0093123c05defe$var$i = 256; $cb0093123c05defe$var$i < 280; ++$cb0093123c05defe$var$i)$cb0093123c05defe$var$flt[$cb0093123c05defe$var$i] = 7;
for(var $cb0093123c05defe$var$i = 280; $cb0093123c05defe$var$i < 288; ++$cb0093123c05defe$var$i)$cb0093123c05defe$var$flt[$cb0093123c05defe$var$i] = 8;
// fixed distance tree
var $cb0093123c05defe$var$fdt = new $cb0093123c05defe$var$u8(32);
for(var $cb0093123c05defe$var$i = 0; $cb0093123c05defe$var$i < 32; ++$cb0093123c05defe$var$i)$cb0093123c05defe$var$fdt[$cb0093123c05defe$var$i] = 5;
// fixed length map
var $cb0093123c05defe$var$flm = /*#__PURE__*/ $cb0093123c05defe$var$hMap($cb0093123c05defe$var$flt, 9, 0), $cb0093123c05defe$var$flrm = /*#__PURE__*/ $cb0093123c05defe$var$hMap($cb0093123c05defe$var$flt, 9, 1);
// fixed distance map
var $cb0093123c05defe$var$fdm = /*#__PURE__*/ $cb0093123c05defe$var$hMap($cb0093123c05defe$var$fdt, 5, 0), $cb0093123c05defe$var$fdrm = /*#__PURE__*/ $cb0093123c05defe$var$hMap($cb0093123c05defe$var$fdt, 5, 1);
// find max of array
var $cb0093123c05defe$var$max = function(a) {
    var m = a[0];
    for(var i = 1; i < a.length; ++i)if (a[i] > m) m = a[i];
    return m;
};
// read d, starting at bit p and mask with m
var $cb0093123c05defe$var$bits = function(d, p, m) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8) >> (p & 7) & m;
};
// read d, starting at bit p continuing for at least 16 bits
var $cb0093123c05defe$var$bits16 = function(d, p) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8 | d[o + 2] << 16) >> (p & 7);
};
// get end of byte
var $cb0093123c05defe$var$shft = function(p) {
    return (p + 7) / 8 | 0;
};
// typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice
var $cb0093123c05defe$var$slc = function(v, s, e) {
    if (s == null || s < 0) s = 0;
    if (e == null || e > v.length) e = v.length;
    // can't use .constructor in case user-supplied
    return new $cb0093123c05defe$var$u8(v.subarray(s, e));
};
var $cb0093123c05defe$export$ae5516a5a74c19a8 = {
    UnexpectedEOF: 0,
    InvalidBlockType: 1,
    InvalidLengthLiteral: 2,
    InvalidDistance: 3,
    StreamFinished: 4,
    NoStreamHandler: 5,
    InvalidHeader: 6,
    NoCallback: 7,
    InvalidUTF8: 8,
    ExtraFieldTooLong: 9,
    InvalidDate: 10,
    FilenameTooLong: 11,
    StreamFinishing: 12,
    InvalidZipData: 13,
    UnknownCompressionMethod: 14
};
// error codes
var $cb0093123c05defe$var$ec = [
    'unexpected EOF',
    'invalid block type',
    'invalid length/literal',
    'invalid distance',
    'stream finished',
    'no stream handler',
    ,
    'no callback',
    'invalid UTF-8 data',
    'extra field too long',
    'date not in range 1980-2099',
    'filename too long',
    'stream finishing',
    'invalid zip data'
];
var $cb0093123c05defe$var$err = function(ind, msg, nt) {
    var e = new Error(msg || $cb0093123c05defe$var$ec[ind]);
    e.code = ind;
    if (Error.captureStackTrace) Error.captureStackTrace(e, $cb0093123c05defe$var$err);
    if (!nt) throw e;
    return e;
};
// expands raw DEFLATE data
var $cb0093123c05defe$var$inflt = function(dat, st, buf, dict) {
    // source length       dict length
    var sl = dat.length, dl = dict ? dict.length : 0;
    if (!sl || st.f && !st.l) return buf || new $cb0093123c05defe$var$u8(0);
    var noBuf = !buf;
    // have to estimate size
    var resize = noBuf || st.i != 2;
    // no state
    var noSt = st.i;
    // Assumes roughly 33% compression ratio average
    if (noBuf) buf = new $cb0093123c05defe$var$u8(sl * 3);
    // ensure buffer can fit at least l elements
    var cbuf = function(l) {
        var bl = buf.length;
        // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            var nbuf = new $cb0093123c05defe$var$u8(Math.max(bl * 2, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    //  last chunk         bitpos           bytes
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    // total bits
    var tbts = sl * 8;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            final = $cb0093123c05defe$var$bits(dat, pos, 1);
            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            var type = $cb0093123c05defe$var$bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                var s = $cb0093123c05defe$var$shft(pos) + 4, l = dat[s - 4] | dat[s - 3] << 8, t = s + l;
                if (t > sl) {
                    if (noSt) $cb0093123c05defe$var$err(0);
                    break;
                }
                // ensure size
                if (resize) cbuf(bt + l);
                // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt);
                // Get new bitpos, update byte count
                st.b = bt += l, st.p = pos = t * 8, st.f = final;
                continue;
            } else if (type == 1) lm = $cb0093123c05defe$var$flrm, dm = $cb0093123c05defe$var$fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                //  literal                            lengths
                var hLit = $cb0093123c05defe$var$bits(dat, pos, 31) + 257, hcLen = $cb0093123c05defe$var$bits(dat, pos + 10, 15) + 4;
                var tl = hLit + $cb0093123c05defe$var$bits(dat, pos + 5, 31) + 1;
                pos += 14;
                // length+distance tree
                var ldt = new $cb0093123c05defe$var$u8(tl);
                // code length tree
                var clt = new $cb0093123c05defe$var$u8(19);
                for(var i = 0; i < hcLen; ++i)// use index map to get real code
                clt[$cb0093123c05defe$var$clim[i]] = $cb0093123c05defe$var$bits(dat, pos + i * 3, 7);
                pos += hcLen * 3;
                // code lengths bits
                var clb = $cb0093123c05defe$var$max(clt), clbmsk = (1 << clb) - 1;
                // code lengths map
                var clm = $cb0093123c05defe$var$hMap(clt, clb, 1);
                for(var i = 0; i < tl;){
                    var r = clm[$cb0093123c05defe$var$bits(dat, pos, clbmsk)];
                    // bits read
                    pos += r & 15;
                    // symbol
                    var s = r >> 4;
                    // code length to copy
                    if (s < 16) ldt[i++] = s;
                    else {
                        //  copy   count
                        var c = 0, n = 0;
                        if (s == 16) n = 3 + $cb0093123c05defe$var$bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                        else if (s == 17) n = 3 + $cb0093123c05defe$var$bits(dat, pos, 7), pos += 3;
                        else if (s == 18) n = 11 + $cb0093123c05defe$var$bits(dat, pos, 127), pos += 7;
                        while(n--)ldt[i++] = c;
                    }
                }
                //    length tree                 distance tree
                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                // max length bits
                lbt = $cb0093123c05defe$var$max(lt);
                // max dist bits
                dbt = $cb0093123c05defe$var$max(dt);
                lm = $cb0093123c05defe$var$hMap(lt, lbt, 1);
                dm = $cb0093123c05defe$var$hMap(dt, dbt, 1);
            } else $cb0093123c05defe$var$err(1);
            if (pos > tbts) {
                if (noSt) $cb0093123c05defe$var$err(0);
                break;
            }
        }
        // Make sure the buffer can hold this + the largest possible addition
        // Maximum chunk size (practically, theoretically infinite) is 2^17
        if (resize) cbuf(bt + 131072);
        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        var lpos = pos;
        for(;; lpos = pos){
            // bits read, code
            var c = lm[$cb0093123c05defe$var$bits16(dat, pos) & lms], sym = c >> 4;
            pos += c & 15;
            if (pos > tbts) {
                if (noSt) $cb0093123c05defe$var$err(0);
                break;
            }
            if (!c) $cb0093123c05defe$var$err(2);
            if (sym < 256) buf[bt++] = sym;
            else if (sym == 256) {
                lpos = pos, lm = null;
                break;
            } else {
                var add = sym - 254;
                // no extra bits needed if less
                if (sym > 264) {
                    // index
                    var i = sym - 257, b = $cb0093123c05defe$var$fleb[i];
                    add = $cb0093123c05defe$var$bits(dat, pos, (1 << b) - 1) + $cb0093123c05defe$var$fl[i];
                    pos += b;
                }
                // dist
                var d = dm[$cb0093123c05defe$var$bits16(dat, pos) & dms], dsym = d >> 4;
                if (!d) $cb0093123c05defe$var$err(3);
                pos += d & 15;
                var dt = $cb0093123c05defe$var$fd[dsym];
                if (dsym > 3) {
                    var b = $cb0093123c05defe$var$fdeb[dsym];
                    dt += $cb0093123c05defe$var$bits16(dat, pos) & (1 << b) - 1, pos += b;
                }
                if (pos > tbts) {
                    if (noSt) $cb0093123c05defe$var$err(0);
                    break;
                }
                if (resize) cbuf(bt + 131072);
                var end = bt + add;
                if (bt < dt) {
                    var shift = dl - dt, dend = Math.min(dt, end);
                    if (shift + bt < 0) $cb0093123c05defe$var$err(3);
                    for(; bt < dend; ++bt)buf[bt] = dict[shift + bt];
                }
                for(; bt < end; ++bt)buf[bt] = buf[bt - dt];
            }
        }
        st.l = lm, st.p = lpos, st.b = bt, st.f = final;
        if (lm) final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    }while (!final);
    // don't reallocate for streams or user buffers
    return bt != buf.length && noBuf ? $cb0093123c05defe$var$slc(buf, 0, bt) : buf.subarray(0, bt);
};
// starting at p, write the minimum number of bits that can hold v to d
var $cb0093123c05defe$var$wbits = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
};
// starting at p, write the minimum number of bits (>8) that can hold v to d
var $cb0093123c05defe$var$wbits16 = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
    d[o + 2] |= v >> 16;
};
// creates code lengths from a frequency table
var $cb0093123c05defe$var$hTree = function(d, mb) {
    // Need extra info to make a tree
    var t = [];
    for(var i = 0; i < d.length; ++i)if (d[i]) t.push({
        s: i,
        f: d[i]
    });
    var s = t.length;
    var t2 = t.slice();
    if (!s) return {
        t: $cb0093123c05defe$var$et,
        l: 0
    };
    if (s == 1) {
        var v = new $cb0093123c05defe$var$u8(t[0].s + 1);
        v[t[0].s] = 1;
        return {
            t: v,
            l: 1
        };
    }
    t.sort(function(a, b) {
        return a.f - b.f;
    });
    // after i2 reaches last ind, will be stopped
    // freq must be greater than largest possible number of symbols
    t.push({
        s: -1,
        f: 25001
    });
    var l = t[0], r = t[1], i0 = 0, i1 = 1, i2 = 2;
    t[0] = {
        s: -1,
        f: l.f + r.f,
        l: l,
        r: r
    };
    // efficient algorithm from UZIP.js
    // i0 is lookbehind, i2 is lookahead - after processing two low-freq
    // symbols that combined have high freq, will start processing i2 (high-freq,
    // non-composite) symbols instead
    // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
    while(i1 != s - 1){
        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
        t[i1++] = {
            s: -1,
            f: l.f + r.f,
            l: l,
            r: r
        };
    }
    var maxSym = t2[0].s;
    for(var i = 1; i < s; ++i)if (t2[i].s > maxSym) maxSym = t2[i].s;
    // code lengths
    var tr = new $cb0093123c05defe$var$u16(maxSym + 1);
    // max bits in tree
    var mbt = $cb0093123c05defe$var$ln(t[i1 - 1], tr, 0);
    if (mbt > mb) {
        // more algorithms from UZIP.js
        // TODO: find out how this code works (debt)
        //  ind    debt
        var i = 0, dt = 0;
        //    left            cost
        var lft = mbt - mb, cst = 1 << lft;
        t2.sort(function(a, b) {
            return tr[b.s] - tr[a.s] || a.f - b.f;
        });
        for(; i < s; ++i){
            var i2_1 = t2[i].s;
            if (tr[i2_1] > mb) {
                dt += cst - (1 << mbt - tr[i2_1]);
                tr[i2_1] = mb;
            } else break;
        }
        dt >>= lft;
        while(dt > 0){
            var i2_2 = t2[i].s;
            if (tr[i2_2] < mb) dt -= 1 << mb - tr[i2_2]++ - 1;
            else ++i;
        }
        for(; i >= 0 && dt; --i){
            var i2_3 = t2[i].s;
            if (tr[i2_3] == mb) {
                --tr[i2_3];
                ++dt;
            }
        }
        mbt = mb;
    }
    return {
        t: new $cb0093123c05defe$var$u8(tr),
        l: mbt
    };
};
// get the max length and assign length codes
var $cb0093123c05defe$var$ln = function(n, l, d) {
    return n.s == -1 ? Math.max($cb0093123c05defe$var$ln(n.l, l, d + 1), $cb0093123c05defe$var$ln(n.r, l, d + 1)) : l[n.s] = d;
};
// length codes generation
var $cb0093123c05defe$var$lc = function(c) {
    var s = c.length;
    // Note that the semicolon was intentional
    while(s && !c[--s]);
    var cl = new $cb0093123c05defe$var$u16(++s);
    //  ind      num         streak
    var cli = 0, cln = c[0], cls = 1;
    var w = function(v) {
        cl[cli++] = v;
    };
    for(var i = 1; i <= s; ++i)if (c[i] == cln && i != s) ++cls;
    else {
        if (!cln && cls > 2) {
            for(; cls > 138; cls -= 138)w(32754);
            if (cls > 2) {
                w(cls > 10 ? cls - 11 << 5 | 28690 : cls - 3 << 5 | 12305);
                cls = 0;
            }
        } else if (cls > 3) {
            w(cln), --cls;
            for(; cls > 6; cls -= 6)w(8304);
            if (cls > 2) w(cls - 3 << 5 | 8208), cls = 0;
        }
        while(cls--)w(cln);
        cls = 1;
        cln = c[i];
    }
    return {
        c: cl.subarray(0, cli),
        n: s
    };
};
// calculate the length of output from tree, code lengths
var $cb0093123c05defe$var$clen = function(cf, cl) {
    var l = 0;
    for(var i = 0; i < cl.length; ++i)l += cf[i] * cl[i];
    return l;
};
// writes a fixed block
// returns the new bit pos
var $cb0093123c05defe$var$wfblk = function(out, pos, dat) {
    // no need to write 00 as type: TypedArray defaults to 0
    var s = dat.length;
    var o = $cb0093123c05defe$var$shft(pos + 2);
    out[o] = s & 255;
    out[o + 1] = s >> 8;
    out[o + 2] = out[o] ^ 255;
    out[o + 3] = out[o + 1] ^ 255;
    for(var i = 0; i < s; ++i)out[o + i + 4] = dat[i];
    return (o + 4 + s) * 8;
};
// writes a block
var $cb0093123c05defe$var$wblk = function(dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
    $cb0093123c05defe$var$wbits(out, p++, final);
    ++lf[256];
    var _a = $cb0093123c05defe$var$hTree(lf, 15), dlt = _a.t, mlb = _a.l;
    var _b = $cb0093123c05defe$var$hTree(df, 15), ddt = _b.t, mdb = _b.l;
    var _c = $cb0093123c05defe$var$lc(dlt), lclt = _c.c, nlc = _c.n;
    var _d = $cb0093123c05defe$var$lc(ddt), lcdt = _d.c, ndc = _d.n;
    var lcfreq = new $cb0093123c05defe$var$u16(19);
    for(var i = 0; i < lclt.length; ++i)++lcfreq[lclt[i] & 31];
    for(var i = 0; i < lcdt.length; ++i)++lcfreq[lcdt[i] & 31];
    var _e = $cb0093123c05defe$var$hTree(lcfreq, 7), lct = _e.t, mlcb = _e.l;
    var nlcc = 19;
    for(; nlcc > 4 && !lct[$cb0093123c05defe$var$clim[nlcc - 1]]; --nlcc);
    var flen = bl + 5 << 3;
    var ftlen = $cb0093123c05defe$var$clen(lf, $cb0093123c05defe$var$flt) + $cb0093123c05defe$var$clen(df, $cb0093123c05defe$var$fdt) + eb;
    var dtlen = $cb0093123c05defe$var$clen(lf, dlt) + $cb0093123c05defe$var$clen(df, ddt) + eb + 14 + 3 * nlcc + $cb0093123c05defe$var$clen(lcfreq, lct) + 2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18];
    if (bs >= 0 && flen <= ftlen && flen <= dtlen) return $cb0093123c05defe$var$wfblk(out, p, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    $cb0093123c05defe$var$wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
    if (dtlen < ftlen) {
        lm = $cb0093123c05defe$var$hMap(dlt, mlb, 0), ll = dlt, dm = $cb0093123c05defe$var$hMap(ddt, mdb, 0), dl = ddt;
        var llm = $cb0093123c05defe$var$hMap(lct, mlcb, 0);
        $cb0093123c05defe$var$wbits(out, p, nlc - 257);
        $cb0093123c05defe$var$wbits(out, p + 5, ndc - 1);
        $cb0093123c05defe$var$wbits(out, p + 10, nlcc - 4);
        p += 14;
        for(var i = 0; i < nlcc; ++i)$cb0093123c05defe$var$wbits(out, p + 3 * i, lct[$cb0093123c05defe$var$clim[i]]);
        p += 3 * nlcc;
        var lcts = [
            lclt,
            lcdt
        ];
        for(var it = 0; it < 2; ++it){
            var clct = lcts[it];
            for(var i = 0; i < clct.length; ++i){
                var len = clct[i] & 31;
                $cb0093123c05defe$var$wbits(out, p, llm[len]), p += lct[len];
                if (len > 15) $cb0093123c05defe$var$wbits(out, p, clct[i] >> 5 & 127), p += clct[i] >> 12;
            }
        }
    } else lm = $cb0093123c05defe$var$flm, ll = $cb0093123c05defe$var$flt, dm = $cb0093123c05defe$var$fdm, dl = $cb0093123c05defe$var$fdt;
    for(var i = 0; i < li; ++i){
        var sym = syms[i];
        if (sym > 255) {
            var len = sym >> 18 & 31;
            $cb0093123c05defe$var$wbits16(out, p, lm[len + 257]), p += ll[len + 257];
            if (len > 7) $cb0093123c05defe$var$wbits(out, p, sym >> 23 & 31), p += $cb0093123c05defe$var$fleb[len];
            var dst = sym & 31;
            $cb0093123c05defe$var$wbits16(out, p, dm[dst]), p += dl[dst];
            if (dst > 3) $cb0093123c05defe$var$wbits16(out, p, sym >> 5 & 8191), p += $cb0093123c05defe$var$fdeb[dst];
        } else $cb0093123c05defe$var$wbits16(out, p, lm[sym]), p += ll[sym];
    }
    $cb0093123c05defe$var$wbits16(out, p, lm[256]);
    return p + ll[256];
};
// deflate options (nice << 13) | chain
var $cb0093123c05defe$var$deo = /*#__PURE__*/ new $cb0093123c05defe$var$i32([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]);
// empty
var $cb0093123c05defe$var$et = /*#__PURE__*/ new $cb0093123c05defe$var$u8(0);
// compresses data into a raw DEFLATE buffer
var $cb0093123c05defe$var$dflt = function(dat, lvl, plvl, pre, post, st) {
    var s = st.z || dat.length;
    var o = new $cb0093123c05defe$var$u8(pre + s + 5 * (1 + Math.ceil(s / 7000)) + post);
    // writing to this writes to the output buffer
    var w = o.subarray(pre, o.length - post);
    var lst = st.l;
    var pos = (st.r || 0) & 7;
    if (lvl) {
        if (pos) w[0] = st.r >> 3;
        var opt = $cb0093123c05defe$var$deo[lvl - 1];
        var n = opt >> 13, c = opt & 8191;
        var msk_1 = (1 << plvl) - 1;
        //    prev 2-byte val map    curr 2-byte val map
        var prev = st.p || new $cb0093123c05defe$var$u16(32768), head = st.h || new $cb0093123c05defe$var$u16(msk_1 + 1);
        var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
        var hsh = function(i) {
            return (dat[i] ^ dat[i + 1] << bs1_1 ^ dat[i + 2] << bs2_1) & msk_1;
        };
        // 24576 is an arbitrary number of maximum symbols per block
        // 424 buffer for last block
        var syms = new $cb0093123c05defe$var$i32(25000);
        // length/literal freq   distance freq
        var lf = new $cb0093123c05defe$var$u16(288), df = new $cb0093123c05defe$var$u16(32);
        //  l/lcnt  exbits  index          l/lind  waitdx          blkpos
        var lc_1 = 0, eb = 0, i = st.i || 0, li = 0, wi = st.w || 0, bs = 0;
        for(; i + 2 < s; ++i){
            // hash value
            var hv = hsh(i);
            // index mod 32768    previous index mod
            var imod = i & 32767, pimod = head[hv];
            prev[imod] = pimod;
            head[hv] = imod;
            // We always should modify head and prev, but only add symbols if
            // this data is not yet processed ("wait" for wait index)
            if (wi <= i) {
                // bytes remaining
                var rem = s - i;
                if ((lc_1 > 7000 || li > 24576) && (rem > 423 || !lst)) {
                    pos = $cb0093123c05defe$var$wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                    li = lc_1 = eb = 0, bs = i;
                    for(var j = 0; j < 286; ++j)lf[j] = 0;
                    for(var j = 0; j < 30; ++j)df[j] = 0;
                }
                //  len    dist   chain
                var l = 2, d = 0, ch_1 = c, dif = imod - pimod & 32767;
                if (rem > 2 && hv == hsh(i - dif)) {
                    var maxn = Math.min(n, rem) - 1;
                    var maxd = Math.min(32767, i);
                    // max possible length
                    // not capped at dif because decompressors implement "rolling" index population
                    var ml = Math.min(258, rem);
                    while(dif <= maxd && --ch_1 && imod != pimod){
                        if (dat[i + l] == dat[i + l - dif]) {
                            var nl = 0;
                            for(; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl);
                            if (nl > l) {
                                l = nl, d = dif;
                                // break out early when we reach "nice" (we are satisfied enough)
                                if (nl > maxn) break;
                                // now, find the rarest 2-byte sequence within this
                                // length of literals and search for that instead.
                                // Much faster than just using the start
                                var mmd = Math.min(dif, nl - 2);
                                var md = 0;
                                for(var j = 0; j < mmd; ++j){
                                    var ti = i - dif + j & 32767;
                                    var pti = prev[ti];
                                    var cd = ti - pti & 32767;
                                    if (cd > md) md = cd, pimod = ti;
                                }
                            }
                        }
                        // check the previous match
                        imod = pimod, pimod = prev[imod];
                        dif += imod - pimod & 32767;
                    }
                }
                // d will be nonzero only when a match was found
                if (d) {
                    // store both dist and len data in one int32
                    // Make sure this is recognized as a len/dist with 28th bit (2^28)
                    syms[li++] = 268435456 | $cb0093123c05defe$var$revfl[l] << 18 | $cb0093123c05defe$var$revfd[d];
                    var lin = $cb0093123c05defe$var$revfl[l] & 31, din = $cb0093123c05defe$var$revfd[d] & 31;
                    eb += $cb0093123c05defe$var$fleb[lin] + $cb0093123c05defe$var$fdeb[din];
                    ++lf[257 + lin];
                    ++df[din];
                    wi = i + l;
                    ++lc_1;
                } else {
                    syms[li++] = dat[i];
                    ++lf[dat[i]];
                }
            }
        }
        for(i = Math.max(i, wi); i < s; ++i){
            syms[li++] = dat[i];
            ++lf[dat[i]];
        }
        pos = $cb0093123c05defe$var$wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
        if (!lst) {
            st.r = pos & 7 | w[pos / 8 | 0] << 3;
            // shft(pos) now 1 less if pos & 7 != 0
            pos -= 7;
            st.h = head, st.p = prev, st.i = i, st.w = wi;
        }
    } else {
        for(var i = st.w || 0; i < s + lst; i += 65535){
            // end
            var e = i + 65535;
            if (e >= s) {
                // write final block
                w[pos / 8 | 0] = lst;
                e = s;
            }
            pos = $cb0093123c05defe$var$wfblk(w, pos + 1, dat.subarray(i, e));
        }
        st.i = s;
    }
    return $cb0093123c05defe$var$slc(o, 0, pre + $cb0093123c05defe$var$shft(pos) + post);
};
// CRC32 table
var $cb0093123c05defe$var$crct = /*#__PURE__*/ function() {
    var t = new Int32Array(256);
    for(var i = 0; i < 256; ++i){
        var c = i, k = 9;
        while(--k)c = (c & 1 && -306674912) ^ c >>> 1;
        t[i] = c;
    }
    return t;
}();
// CRC32
var $cb0093123c05defe$var$crc = function() {
    var c = -1;
    return {
        p: function(d) {
            // closures have awful performance
            var cr = c;
            for(var i = 0; i < d.length; ++i)cr = $cb0093123c05defe$var$crct[cr & 255 ^ d[i]] ^ cr >>> 8;
            c = cr;
        },
        d: function() {
            return ~c;
        }
    };
};
// Adler32
var $cb0093123c05defe$var$adler = function() {
    var a = 1, b = 0;
    return {
        p: function(d) {
            // closures have awful performance
            var n = a, m = b;
            var l = d.length | 0;
            for(var i = 0; i != l;){
                var e = Math.min(i + 2655, l);
                for(; i < e; ++i)m += n += d[i];
                n = (n & 65535) + 15 * (n >> 16), m = (m & 65535) + 15 * (m >> 16);
            }
            a = n, b = m;
        },
        d: function() {
            a %= 65521, b %= 65521;
            return (a & 255) << 24 | (a & 0xFF00) << 8 | (b & 255) << 8 | b >> 8;
        }
    };
};
// deflate with opts
var $cb0093123c05defe$var$dopt = function(dat, opt, pre, post, st) {
    if (!st) {
        st = {
            l: 1
        };
        if (opt.dictionary) {
            var dict = opt.dictionary.subarray(-32768);
            var newDat = new $cb0093123c05defe$var$u8(dict.length + dat.length);
            newDat.set(dict);
            newDat.set(dat, dict.length);
            dat = newDat;
            st.w = dict.length;
        }
    }
    return $cb0093123c05defe$var$dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? st.l ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 20 : 12 + opt.mem, pre, post, st);
};
// Walmart object spread
var $cb0093123c05defe$var$mrg = function(a, b) {
    var o = {};
    for(var k in a)o[k] = a[k];
    for(var k in b)o[k] = b[k];
    return o;
};
// worker clone
// This is possibly the craziest part of the entire codebase, despite how simple it may seem.
// The only parameter to this function is a closure that returns an array of variables outside of the function scope.
// We're going to try to figure out the variable names used in the closure as strings because that is crucial for workerization.
// We will return an object mapping of true variable name to value (basically, the current scope as a JS object).
// The reason we can't just use the original variable names is minifiers mangling the toplevel scope.
// This took me three weeks to figure out how to do.
var $cb0093123c05defe$var$wcln = function(fn, fnStr, td) {
    var dt = fn();
    var st = fn.toString();
    var ks = st.slice(st.indexOf('[') + 1, st.lastIndexOf(']')).replace(/\s+/g, '').split(',');
    for(var i = 0; i < dt.length; ++i){
        var v = dt[i], k = ks[i];
        if (typeof v == 'function') {
            fnStr += ';' + k + '=';
            var st_1 = v.toString();
            if (v.prototype) {
                // for global objects
                if (st_1.indexOf('[native code]') != -1) {
                    var spInd = st_1.indexOf(' ', 8) + 1;
                    fnStr += st_1.slice(spInd, st_1.indexOf('(', spInd));
                } else {
                    fnStr += st_1;
                    for(var t in v.prototype)fnStr += ';' + k + '.prototype.' + t + '=' + v.prototype[t].toString();
                }
            } else fnStr += st_1;
        } else td[k] = v;
    }
    return fnStr;
};
var $cb0093123c05defe$var$ch = [];
// clone bufs
var $cb0093123c05defe$var$cbfs = function(v) {
    var tl = [];
    for(var k in v)if (v[k].buffer) tl.push((v[k] = new v[k].constructor(v[k])).buffer);
    return tl;
};
// use a worker to execute code
var $cb0093123c05defe$var$wrkr = function(fns, init, id, cb) {
    if (!$cb0093123c05defe$var$ch[id]) {
        var fnStr = '', td_1 = {}, m = fns.length - 1;
        for(var i = 0; i < m; ++i)fnStr = $cb0093123c05defe$var$wcln(fns[i], fnStr, td_1);
        $cb0093123c05defe$var$ch[id] = {
            c: $cb0093123c05defe$var$wcln(fns[m], fnStr, td_1),
            e: td_1
        };
    }
    var td = $cb0093123c05defe$var$mrg({}, $cb0093123c05defe$var$ch[id].e);
    return $cb0093123c05defe$var$wk($cb0093123c05defe$var$ch[id].c + ';onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=' + init.toString() + '}', id, td, $cb0093123c05defe$var$cbfs(td), cb);
};
// base async inflate fn
var $cb0093123c05defe$var$bInflt = function() {
    return [
        $cb0093123c05defe$var$u8,
        $cb0093123c05defe$var$u16,
        $cb0093123c05defe$var$i32,
        $cb0093123c05defe$var$fleb,
        $cb0093123c05defe$var$fdeb,
        $cb0093123c05defe$var$clim,
        $cb0093123c05defe$var$fl,
        $cb0093123c05defe$var$fd,
        $cb0093123c05defe$var$flrm,
        $cb0093123c05defe$var$fdrm,
        $cb0093123c05defe$var$rev,
        $cb0093123c05defe$var$ec,
        $cb0093123c05defe$var$hMap,
        $cb0093123c05defe$var$max,
        $cb0093123c05defe$var$bits,
        $cb0093123c05defe$var$bits16,
        $cb0093123c05defe$var$shft,
        $cb0093123c05defe$var$slc,
        $cb0093123c05defe$var$err,
        $cb0093123c05defe$var$inflt,
        $cb0093123c05defe$export$90366d8b308ba94a,
        $cb0093123c05defe$var$pbf,
        $cb0093123c05defe$var$gopt
    ];
};
var $cb0093123c05defe$var$bDflt = function() {
    return [
        $cb0093123c05defe$var$u8,
        $cb0093123c05defe$var$u16,
        $cb0093123c05defe$var$i32,
        $cb0093123c05defe$var$fleb,
        $cb0093123c05defe$var$fdeb,
        $cb0093123c05defe$var$clim,
        $cb0093123c05defe$var$revfl,
        $cb0093123c05defe$var$revfd,
        $cb0093123c05defe$var$flm,
        $cb0093123c05defe$var$flt,
        $cb0093123c05defe$var$fdm,
        $cb0093123c05defe$var$fdt,
        $cb0093123c05defe$var$rev,
        $cb0093123c05defe$var$deo,
        $cb0093123c05defe$var$et,
        $cb0093123c05defe$var$hMap,
        $cb0093123c05defe$var$wbits,
        $cb0093123c05defe$var$wbits16,
        $cb0093123c05defe$var$hTree,
        $cb0093123c05defe$var$ln,
        $cb0093123c05defe$var$lc,
        $cb0093123c05defe$var$clen,
        $cb0093123c05defe$var$wfblk,
        $cb0093123c05defe$var$wblk,
        $cb0093123c05defe$var$shft,
        $cb0093123c05defe$var$slc,
        $cb0093123c05defe$var$dflt,
        $cb0093123c05defe$var$dopt,
        $cb0093123c05defe$export$21533ff51b8a0b4a,
        $cb0093123c05defe$var$pbf
    ];
};
// gzip extra
var $cb0093123c05defe$var$gze = function() {
    return [
        $cb0093123c05defe$var$gzh,
        $cb0093123c05defe$var$gzhl,
        $cb0093123c05defe$var$wbytes,
        $cb0093123c05defe$var$crc,
        $cb0093123c05defe$var$crct
    ];
};
// gunzip extra
var $cb0093123c05defe$var$guze = function() {
    return [
        $cb0093123c05defe$var$gzs,
        $cb0093123c05defe$var$gzl
    ];
};
// zlib extra
var $cb0093123c05defe$var$zle = function() {
    return [
        $cb0093123c05defe$var$zlh,
        $cb0093123c05defe$var$wbytes,
        $cb0093123c05defe$var$adler
    ];
};
// unzlib extra
var $cb0093123c05defe$var$zule = function() {
    return [
        $cb0093123c05defe$var$zls
    ];
};
// post buf
var $cb0093123c05defe$var$pbf = function(msg) {
    return postMessage(msg, [
        msg.buffer
    ]);
};
// get opts
var $cb0093123c05defe$var$gopt = function(o) {
    return o && {
        out: o.size && new $cb0093123c05defe$var$u8(o.size),
        dictionary: o.dictionary
    };
};
// async helper
var $cb0093123c05defe$var$cbify = function(dat, opts, fns, init, id, cb) {
    var w = $cb0093123c05defe$var$wrkr(fns, init, id, function(err, dat) {
        w.terminate();
        cb(err, dat);
    });
    w.postMessage([
        dat,
        opts
    ], opts.consume ? [
        dat.buffer
    ] : []);
    return function() {
        w.terminate();
    };
};
// auto stream
var $cb0093123c05defe$var$astrm = function(strm) {
    strm.ondata = function(dat, final) {
        return postMessage([
            dat,
            final
        ], [
            dat.buffer
        ]);
    };
    return function(ev) {
        if (ev.data[0]) {
            strm.push(ev.data[0], ev.data[1]);
            postMessage([
                ev.data[0].length
            ]);
        } else strm.flush(ev.data[1]);
    };
};
// async stream attach
var $cb0093123c05defe$var$astrmify = function(fns, strm, opts, init, id, flush, ext) {
    var t;
    var w = $cb0093123c05defe$var$wrkr(fns, init, id, function(err, dat) {
        if (err) w.terminate(), strm.ondata.call(strm, err);
        else if (!Array.isArray(dat)) ext(dat);
        else if (dat.length == 1) {
            strm.queuedSize -= dat[0];
            if (strm.ondrain) strm.ondrain(dat[0]);
        } else {
            if (dat[1]) w.terminate();
            strm.ondata.call(strm, err, dat[0], dat[1]);
        }
    });
    w.postMessage(opts);
    strm.queuedSize = 0;
    strm.push = function(d, f) {
        if (!strm.ondata) $cb0093123c05defe$var$err(5);
        if (t) strm.ondata($cb0093123c05defe$var$err(4, 0, 1), null, !!f);
        strm.queuedSize += d.length;
        // can fail for cross-realm Uint8Array, but ok - only a small performance penalty
        w.postMessage([
            d,
            t = f
        ], d.buffer instanceof ArrayBuffer ? [
            d.buffer
        ] : []);
    };
    strm.terminate = function() {
        w.terminate();
    };
    if (flush) strm.flush = function(sync) {
        w.postMessage([
            0,
            sync
        ]);
    };
};
// read 2 bytes
var $cb0093123c05defe$var$b2 = function(d, b) {
    return d[b] | d[b + 1] << 8;
};
// read 4 bytes
var $cb0093123c05defe$var$b4 = function(d, b) {
    return (d[b] | d[b + 1] << 8 | d[b + 2] << 16 | d[b + 3] << 24) >>> 0;
};
// read 8 bytes
var $cb0093123c05defe$var$b8 = function(d, b) {
    return $cb0093123c05defe$var$b4(d, b) + $cb0093123c05defe$var$b4(d, b + 4) * 4294967296;
};
// write bytes
var $cb0093123c05defe$var$wbytes = function(d, b, v) {
    for(; v; ++b)d[b] = v, v >>>= 8;
};
// gzip header
var $cb0093123c05defe$var$gzh = function(c, o) {
    var fn = o.filename;
    c[0] = 31, c[1] = 139, c[2] = 8, c[8] = o.level < 2 ? 4 : o.level == 9 ? 2 : 0, c[9] = 3; // assume Unix
    if (o.mtime != 0) $cb0093123c05defe$var$wbytes(c, 4, Math.floor(new Date(o.mtime || Date.now()) / 1000));
    if (fn) {
        c[3] = 8;
        for(var i = 0; i <= fn.length; ++i)c[i + 10] = fn.charCodeAt(i);
    }
};
// gzip footer: -8 to -4 = CRC, -4 to -0 is length
// gzip start
var $cb0093123c05defe$var$gzs = function(d) {
    if (d[0] != 31 || d[1] != 139 || d[2] != 8) $cb0093123c05defe$var$err(6, 'invalid gzip data');
    var flg = d[3];
    var st = 10;
    if (flg & 4) st += (d[10] | d[11] << 8) + 2;
    for(var zs = (flg >> 3 & 1) + (flg >> 4 & 1); zs > 0; zs -= !d[st++]);
    return st + (flg & 2);
};
// gzip length
var $cb0093123c05defe$var$gzl = function(d) {
    var l = d.length;
    return (d[l - 4] | d[l - 3] << 8 | d[l - 2] << 16 | d[l - 1] << 24) >>> 0;
};
// gzip header length
var $cb0093123c05defe$var$gzhl = function(o) {
    return 10 + (o.filename ? o.filename.length + 1 : 0);
};
// zlib header
var $cb0093123c05defe$var$zlh = function(c, o) {
    var lv = o.level, fl = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    c[0] = 120, c[1] = fl << 6 | (o.dictionary && 32);
    c[1] |= 31 - (c[0] << 8 | c[1]) % 31;
    if (o.dictionary) {
        var h = $cb0093123c05defe$var$adler();
        h.p(o.dictionary);
        $cb0093123c05defe$var$wbytes(c, 2, h.d());
    }
};
// zlib start
var $cb0093123c05defe$var$zls = function(d, dict) {
    if ((d[0] & 15) != 8 || d[0] >> 4 > 7 || (d[0] << 8 | d[1]) % 31) $cb0093123c05defe$var$err(6, 'invalid zlib data');
    if ((d[1] >> 5 & 1) == +!dict) $cb0093123c05defe$var$err(6, 'invalid zlib data: ' + (d[1] & 32 ? 'need' : 'unexpected') + ' dictionary');
    return (d[1] >> 3 & 4) + 2;
};
function $cb0093123c05defe$var$StrmOpt(opts, cb) {
    if (typeof opts == 'function') cb = opts, opts = {};
    this.ondata = cb;
    return opts;
}
/**
 * Streaming DEFLATE compression
 */ var $cb0093123c05defe$export$ae157b6234afe138 = /*#__PURE__*/ function() {
    function Deflate(opts, cb) {
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        this.o = opts || {};
        this.s = {
            l: 0,
            i: 32768,
            w: 32768,
            z: 32768
        };
        // Buffer length must always be 0 mod 32768 for index calculations to be correct when modifying head and prev
        // 98304 = 32768 (lookback) + 65536 (common chunk size)
        this.b = new $cb0093123c05defe$var$u8(98304);
        if (this.o.dictionary) {
            var dict = this.o.dictionary.subarray(-32768);
            this.b.set(dict, 32768 - dict.length);
            this.s.i = 32768 - dict.length;
        }
    }
    Deflate.prototype.p = function(c, f) {
        this.ondata($cb0093123c05defe$var$dopt(c, this.o, 0, 0, this.s), f);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Deflate.prototype.push = function(chunk, final) {
        if (!this.ondata) $cb0093123c05defe$var$err(5);
        if (this.s.l) $cb0093123c05defe$var$err(4);
        var endLen = chunk.length + this.s.z;
        if (endLen > this.b.length) {
            if (endLen > 2 * this.b.length - 32768) {
                var newBuf = new $cb0093123c05defe$var$u8(endLen & -32768);
                newBuf.set(this.b.subarray(0, this.s.z));
                this.b = newBuf;
            }
            var split = this.b.length - this.s.z;
            this.b.set(chunk.subarray(0, split), this.s.z);
            this.s.z = this.b.length;
            this.p(this.b, false);
            this.b.set(this.b.subarray(-32768));
            this.b.set(chunk.subarray(split), 32768);
            this.s.z = chunk.length - split + 32768;
            this.s.i = 32766, this.s.w = 32768;
        } else {
            this.b.set(chunk, this.s.z);
            this.s.z += chunk.length;
        }
        this.s.l = final & 1;
        if (this.s.z > this.s.w + 8191 || final) {
            this.p(this.b, final || false);
            this.s.w = this.s.i, this.s.i -= 2;
        }
        if (final) {
            // cleanup unneeded buffers/state to reduce memory usage
            this.s = this.o = {};
            this.b = $cb0093123c05defe$var$et;
        }
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * deflated output for small inputs.
     * @param sync Whether to flush to a byte boundary. A sync flush takes 4-5
     *             extra bytes, but guarantees all pushed data is immediately
     *             decompressible. A separate DEFLATE stream may be concatenated
     *             with the current output after a sync flush.
     */ Deflate.prototype.flush = function(sync) {
        if (!this.ondata) $cb0093123c05defe$var$err(5);
        if (this.s.l) $cb0093123c05defe$var$err(4);
        this.p(this.b, false);
        this.s.w = this.s.i, this.s.i -= 2;
        // could technically skip writing the type-0 block for (this.s.r & 7) == 0,
        // but the deterministic trailer (00 00 FF FF) is useful in some situations
        if (sync) {
            var c = new $cb0093123c05defe$var$u8(6);
            c[0] = this.s.r >> 3;
            // write empty, non-final type-0 block
            var ep = $cb0093123c05defe$var$wfblk(c, this.s.r, $cb0093123c05defe$var$et);
            this.s.r = 0;
            this.ondata(c.subarray(0, ep >> 3), false);
        }
    };
    return Deflate;
}();
/**
 * Asynchronous streaming DEFLATE compression
 */ var $cb0093123c05defe$export$84e526fabcba03e3 = /*#__PURE__*/ function() {
    function AsyncDeflate(opts, cb) {
        $cb0093123c05defe$var$astrmify([
            $cb0093123c05defe$var$bDflt,
            function() {
                return [
                    $cb0093123c05defe$var$astrm,
                    $cb0093123c05defe$export$ae157b6234afe138
                ];
            }
        ], this, $cb0093123c05defe$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $cb0093123c05defe$export$ae157b6234afe138(ev.data);
            onmessage = $cb0093123c05defe$var$astrm(strm);
        }, 6, 1);
    }
    return AsyncDeflate;
}();
function $cb0093123c05defe$export$2316623ecd1285ab(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $cb0093123c05defe$var$err(7);
    return $cb0093123c05defe$var$cbify(data, opts, [
        $cb0093123c05defe$var$bDflt
    ], function(ev) {
        return $cb0093123c05defe$var$pbf($cb0093123c05defe$export$21533ff51b8a0b4a(ev.data[0], ev.data[1]));
    }, 0, cb);
}
function $cb0093123c05defe$export$21533ff51b8a0b4a(data, opts) {
    return $cb0093123c05defe$var$dopt(data, opts || {}, 0, 0);
}
/**
 * Streaming DEFLATE decompression
 */ var $cb0093123c05defe$export$d1de70a877d6e43c = /*#__PURE__*/ function() {
    function Inflate(opts, cb) {
        // no StrmOpt here to avoid adding to workerizer
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        var dict = opts && opts.dictionary && opts.dictionary.subarray(-32768);
        this.s = {
            i: 0,
            b: dict ? dict.length : 0
        };
        this.o = new $cb0093123c05defe$var$u8(32768);
        this.p = new $cb0093123c05defe$var$u8(0);
        if (dict) this.o.set(dict);
    }
    Inflate.prototype.e = function(c) {
        if (!this.ondata) $cb0093123c05defe$var$err(5);
        if (this.d) $cb0093123c05defe$var$err(4);
        if (!this.p.length) this.p = c;
        else if (c.length) {
            var n = new $cb0093123c05defe$var$u8(this.p.length + c.length);
            n.set(this.p), n.set(c, this.p.length), this.p = n;
        }
    };
    Inflate.prototype.c = function(final) {
        this.s.i = +(this.d = final || false);
        var bts = this.s.b;
        var dt = $cb0093123c05defe$var$inflt(this.p, this.s, this.o);
        this.ondata($cb0093123c05defe$var$slc(dt, bts, this.s.b), this.d);
        this.o = $cb0093123c05defe$var$slc(dt, this.s.b - 32768), this.s.b = this.o.length;
        this.p = $cb0093123c05defe$var$slc(this.p, this.s.p / 8 | 0), this.s.p &= 7;
    };
    /**
     * Pushes a chunk to be inflated
     * @param chunk The chunk to push
     * @param final Whether this is the final chunk
     */ Inflate.prototype.push = function(chunk, final) {
        this.e(chunk), this.c(final);
    };
    return Inflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression
 */ var $cb0093123c05defe$export$fff8358d6dbaa9cc = /*#__PURE__*/ function() {
    function AsyncInflate(opts, cb) {
        $cb0093123c05defe$var$astrmify([
            $cb0093123c05defe$var$bInflt,
            function() {
                return [
                    $cb0093123c05defe$var$astrm,
                    $cb0093123c05defe$export$d1de70a877d6e43c
                ];
            }
        ], this, $cb0093123c05defe$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $cb0093123c05defe$export$d1de70a877d6e43c(ev.data);
            onmessage = $cb0093123c05defe$var$astrm(strm);
        }, 7, 0);
    }
    return AsyncInflate;
}();
function $cb0093123c05defe$export$cae1ce83fe4a1782(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $cb0093123c05defe$var$err(7);
    return $cb0093123c05defe$var$cbify(data, opts, [
        $cb0093123c05defe$var$bInflt
    ], function(ev) {
        return $cb0093123c05defe$var$pbf($cb0093123c05defe$export$90366d8b308ba94a(ev.data[0], $cb0093123c05defe$var$gopt(ev.data[1])));
    }, 1, cb);
}
function $cb0093123c05defe$export$90366d8b308ba94a(data, opts) {
    return $cb0093123c05defe$var$inflt(data, {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
// before you yell at me for not just using extends, my reason is that TS inheritance is hard to workerize.
/**
 * Streaming GZIP compression
 */ var $cb0093123c05defe$export$8e4b66d280bf8342 = /*#__PURE__*/ function() {
    function Gzip(opts, cb) {
        this.c = $cb0093123c05defe$var$crc();
        this.l = 0;
        this.v = 1;
        $cb0093123c05defe$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gzip.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        this.l += chunk.length;
        $cb0093123c05defe$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Gzip.prototype.p = function(c, f) {
        var raw = $cb0093123c05defe$var$dopt(c, this.o, this.v && $cb0093123c05defe$var$gzhl(this.o), f && 8, this.s);
        if (this.v) $cb0093123c05defe$var$gzh(raw, this.o), this.v = 0;
        if (f) $cb0093123c05defe$var$wbytes(raw, raw.length - 8, this.c.d()), $cb0093123c05defe$var$wbytes(raw, raw.length - 4, this.l);
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * GZIPped output for small inputs.
     * @param sync Whether to flush to a byte boundary. A sync flush takes 4-5
     *             extra bytes, but guarantees all pushed data is immediately
     *             decompressible.
     */ Gzip.prototype.flush = function(sync) {
        $cb0093123c05defe$export$ae157b6234afe138.prototype.flush.call(this, sync);
    };
    return Gzip;
}();
/**
 * Asynchronous streaming GZIP compression
 */ var $cb0093123c05defe$export$b4c75ae96cdf708b = /*#__PURE__*/ function() {
    function AsyncGzip(opts, cb) {
        $cb0093123c05defe$var$astrmify([
            $cb0093123c05defe$var$bDflt,
            $cb0093123c05defe$var$gze,
            function() {
                return [
                    $cb0093123c05defe$var$astrm,
                    $cb0093123c05defe$export$ae157b6234afe138,
                    $cb0093123c05defe$export$8e4b66d280bf8342
                ];
            }
        ], this, $cb0093123c05defe$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $cb0093123c05defe$export$8e4b66d280bf8342(ev.data);
            onmessage = $cb0093123c05defe$var$astrm(strm);
        }, 8, 1);
    }
    return AsyncGzip;
}();
function $cb0093123c05defe$export$69f0ea7cf3a331a8(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $cb0093123c05defe$var$err(7);
    return $cb0093123c05defe$var$cbify(data, opts, [
        $cb0093123c05defe$var$bDflt,
        $cb0093123c05defe$var$gze,
        function() {
            return [
                $cb0093123c05defe$export$3d616c3fb3e15483
            ];
        }
    ], function(ev) {
        return $cb0093123c05defe$var$pbf($cb0093123c05defe$export$3d616c3fb3e15483(ev.data[0], ev.data[1]));
    }, 2, cb);
}
function $cb0093123c05defe$export$3d616c3fb3e15483(data, opts) {
    if (!opts) opts = {};
    var c = $cb0093123c05defe$var$crc(), l = data.length;
    c.p(data);
    var d = $cb0093123c05defe$var$dopt(data, opts, $cb0093123c05defe$var$gzhl(opts), 8), s = d.length;
    return $cb0093123c05defe$var$gzh(d, opts), $cb0093123c05defe$var$wbytes(d, s - 8, c.d()), $cb0093123c05defe$var$wbytes(d, s - 4, l), d;
}
/**
 * Streaming single or multi-member GZIP decompression
 */ var $cb0093123c05defe$export$4cb607de6db70415 = /*#__PURE__*/ function() {
    function Gunzip(opts, cb) {
        this.v = 1;
        this.r = 0;
        $cb0093123c05defe$export$d1de70a877d6e43c.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GUNZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gunzip.prototype.push = function(chunk, final) {
        $cb0093123c05defe$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        this.r += chunk.length;
        if (this.v) {
            var p = this.p.subarray(this.v - 1);
            var s = p.length > 3 ? $cb0093123c05defe$var$gzs(p) : 4;
            if (s > p.length) {
                if (!final) return;
            } else if (this.v > 1 && this.onmember) this.onmember(this.r - p.length);
            this.p = p.subarray(s), this.v = 0;
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $cb0093123c05defe$export$d1de70a877d6e43c.prototype.c.call(this, 0);
        // process concatenated GZIP
        if (this.s.f && !this.s.l) {
            this.v = $cb0093123c05defe$var$shft(this.s.p) + 9;
            this.s = {
                i: 0
            };
            this.o = new $cb0093123c05defe$var$u8(0);
            this.push(new $cb0093123c05defe$var$u8(0), final);
        } else if (final) $cb0093123c05defe$export$d1de70a877d6e43c.prototype.c.call(this, final);
    };
    return Gunzip;
}();
/**
 * Asynchronous streaming single or multi-member GZIP decompression
 */ var $cb0093123c05defe$export$d5adcdd968132151 = /*#__PURE__*/ function() {
    function AsyncGunzip(opts, cb) {
        var _this = this;
        $cb0093123c05defe$var$astrmify([
            $cb0093123c05defe$var$bInflt,
            $cb0093123c05defe$var$guze,
            function() {
                return [
                    $cb0093123c05defe$var$astrm,
                    $cb0093123c05defe$export$d1de70a877d6e43c,
                    $cb0093123c05defe$export$4cb607de6db70415
                ];
            }
        ], this, $cb0093123c05defe$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $cb0093123c05defe$export$4cb607de6db70415(ev.data);
            strm.onmember = function(offset) {
                return postMessage(offset);
            };
            onmessage = $cb0093123c05defe$var$astrm(strm);
        }, 9, 0, function(offset) {
            return _this.onmember && _this.onmember(offset);
        });
    }
    return AsyncGunzip;
}();
function $cb0093123c05defe$export$b6df3e950734d697(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $cb0093123c05defe$var$err(7);
    return $cb0093123c05defe$var$cbify(data, opts, [
        $cb0093123c05defe$var$bInflt,
        $cb0093123c05defe$var$guze,
        function() {
            return [
                $cb0093123c05defe$export$c80456f7aaba691c
            ];
        }
    ], function(ev) {
        return $cb0093123c05defe$var$pbf($cb0093123c05defe$export$c80456f7aaba691c(ev.data[0], ev.data[1]));
    }, 3, cb);
}
function $cb0093123c05defe$export$c80456f7aaba691c(data, opts) {
    var st = $cb0093123c05defe$var$gzs(data);
    if (st + 8 > data.length) $cb0093123c05defe$var$err(6, 'invalid gzip data');
    return $cb0093123c05defe$var$inflt(data.subarray(st, -8), {
        i: 2
    }, opts && opts.out || new $cb0093123c05defe$var$u8($cb0093123c05defe$var$gzl(data)), opts && opts.dictionary);
}
/**
 * Streaming Zlib compression
 */ var $cb0093123c05defe$export$4187ccf2467013b9 = /*#__PURE__*/ function() {
    function Zlib(opts, cb) {
        this.c = $cb0093123c05defe$var$adler();
        this.v = 1;
        $cb0093123c05defe$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be zlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Zlib.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        $cb0093123c05defe$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Zlib.prototype.p = function(c, f) {
        var raw = $cb0093123c05defe$var$dopt(c, this.o, this.v && (this.o.dictionary ? 6 : 2), f && 4, this.s);
        if (this.v) $cb0093123c05defe$var$zlh(raw, this.o), this.v = 0;
        if (f) $cb0093123c05defe$var$wbytes(raw, raw.length - 4, this.c.d());
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * zlibbed output for small inputs.
     * @param sync Whether to flush to a byte boundary. A sync flush takes 4-5
     *             extra bytes, but guarantees all pushed data is immediately
     *             decompressible.
     */ Zlib.prototype.flush = function(sync) {
        $cb0093123c05defe$export$ae157b6234afe138.prototype.flush.call(this, sync);
    };
    return Zlib;
}();
/**
 * Asynchronous streaming Zlib compression
 */ var $cb0093123c05defe$export$bedbe3a2c2136490 = /*#__PURE__*/ function() {
    function AsyncZlib(opts, cb) {
        $cb0093123c05defe$var$astrmify([
            $cb0093123c05defe$var$bDflt,
            $cb0093123c05defe$var$zle,
            function() {
                return [
                    $cb0093123c05defe$var$astrm,
                    $cb0093123c05defe$export$ae157b6234afe138,
                    $cb0093123c05defe$export$4187ccf2467013b9
                ];
            }
        ], this, $cb0093123c05defe$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $cb0093123c05defe$export$4187ccf2467013b9(ev.data);
            onmessage = $cb0093123c05defe$var$astrm(strm);
        }, 10, 1);
    }
    return AsyncZlib;
}();
function $cb0093123c05defe$export$925212de7058410b(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $cb0093123c05defe$var$err(7);
    return $cb0093123c05defe$var$cbify(data, opts, [
        $cb0093123c05defe$var$bDflt,
        $cb0093123c05defe$var$zle,
        function() {
            return [
                $cb0093123c05defe$export$f87121a6d50aff25
            ];
        }
    ], function(ev) {
        return $cb0093123c05defe$var$pbf($cb0093123c05defe$export$f87121a6d50aff25(ev.data[0], ev.data[1]));
    }, 4, cb);
}
function $cb0093123c05defe$export$f87121a6d50aff25(data, opts) {
    if (!opts) opts = {};
    var a = $cb0093123c05defe$var$adler();
    a.p(data);
    var d = $cb0093123c05defe$var$dopt(data, opts, opts.dictionary ? 6 : 2, 4);
    return $cb0093123c05defe$var$zlh(d, opts), $cb0093123c05defe$var$wbytes(d, d.length - 4, a.d()), d;
}
/**
 * Streaming Zlib decompression
 */ var $cb0093123c05defe$export$af2424f875ff1b17 = /*#__PURE__*/ function() {
    function Unzlib(opts, cb) {
        $cb0093123c05defe$export$d1de70a877d6e43c.call(this, opts, cb);
        this.v = opts && opts.dictionary ? 2 : 1;
    }
    /**
     * Pushes a chunk to be unzlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzlib.prototype.push = function(chunk, final) {
        $cb0093123c05defe$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        if (this.v) {
            if (this.p.length < 6 && !final) return;
            this.p = this.p.subarray($cb0093123c05defe$var$zls(this.p, this.v - 1)), this.v = 0;
        }
        if (final) {
            if (this.p.length < 4) $cb0093123c05defe$var$err(6, 'invalid zlib data');
            this.p = this.p.subarray(0, -4);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $cb0093123c05defe$export$d1de70a877d6e43c.prototype.c.call(this, final);
    };
    return Unzlib;
}();
/**
 * Asynchronous streaming Zlib decompression
 */ var $cb0093123c05defe$export$cf6668790220dcad = /*#__PURE__*/ function() {
    function AsyncUnzlib(opts, cb) {
        $cb0093123c05defe$var$astrmify([
            $cb0093123c05defe$var$bInflt,
            $cb0093123c05defe$var$zule,
            function() {
                return [
                    $cb0093123c05defe$var$astrm,
                    $cb0093123c05defe$export$d1de70a877d6e43c,
                    $cb0093123c05defe$export$af2424f875ff1b17
                ];
            }
        ], this, $cb0093123c05defe$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $cb0093123c05defe$export$af2424f875ff1b17(ev.data);
            onmessage = $cb0093123c05defe$var$astrm(strm);
        }, 11, 0);
    }
    return AsyncUnzlib;
}();
function $cb0093123c05defe$export$ca7cbb494e731274(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $cb0093123c05defe$var$err(7);
    return $cb0093123c05defe$var$cbify(data, opts, [
        $cb0093123c05defe$var$bInflt,
        $cb0093123c05defe$var$zule,
        function() {
            return [
                $cb0093123c05defe$export$9ec8134f0f1b9fc6
            ];
        }
    ], function(ev) {
        return $cb0093123c05defe$var$pbf($cb0093123c05defe$export$9ec8134f0f1b9fc6(ev.data[0], $cb0093123c05defe$var$gopt(ev.data[1])));
    }, 5, cb);
}
function $cb0093123c05defe$export$9ec8134f0f1b9fc6(data, opts) {
    return $cb0093123c05defe$var$inflt(data.subarray($cb0093123c05defe$var$zls(data, opts && opts.dictionary), -4), {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
/**
 * Streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $cb0093123c05defe$export$578fe199ef655b76 = /*#__PURE__*/ function() {
    function Decompress(opts, cb) {
        this.o = $cb0093123c05defe$var$StrmOpt.call(this, opts, cb) || {};
        this.G = $cb0093123c05defe$export$4cb607de6db70415;
        this.I = $cb0093123c05defe$export$d1de70a877d6e43c;
        this.Z = $cb0093123c05defe$export$af2424f875ff1b17;
    }
    // init substream
    // overriden by AsyncDecompress
    Decompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(dat, final) {
            _this.ondata(dat, final);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Decompress.prototype.push = function(chunk, final) {
        if (!this.ondata) $cb0093123c05defe$var$err(5);
        if (!this.s) {
            if (this.p && this.p.length) {
                var n = new $cb0093123c05defe$var$u8(this.p.length + chunk.length);
                n.set(this.p), n.set(chunk, this.p.length);
            } else this.p = chunk;
            if (this.p.length > 2) {
                this.s = this.p[0] == 31 && this.p[1] == 139 && this.p[2] == 8 ? new this.G(this.o) : (this.p[0] & 15) != 8 || this.p[0] >> 4 > 7 || (this.p[0] << 8 | this.p[1]) % 31 ? new this.I(this.o) : new this.Z(this.o);
                this.i();
                this.s.push(this.p, final);
                this.p = null;
            }
        } else this.s.push(chunk, final);
    };
    return Decompress;
}();
/**
 * Asynchronous streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $cb0093123c05defe$export$ae2c1d81988d4b43 = /*#__PURE__*/ function() {
    function AsyncDecompress(opts, cb) {
        $cb0093123c05defe$export$578fe199ef655b76.call(this, opts, cb);
        this.queuedSize = 0;
        this.G = $cb0093123c05defe$export$d5adcdd968132151;
        this.I = $cb0093123c05defe$export$fff8358d6dbaa9cc;
        this.Z = $cb0093123c05defe$export$cf6668790220dcad;
    }
    AsyncDecompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(err, dat, final) {
            _this.ondata(err, dat, final);
        };
        this.s.ondrain = function(size) {
            _this.queuedSize -= size;
            if (_this.ondrain) _this.ondrain(size);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncDecompress.prototype.push = function(chunk, final) {
        this.queuedSize += chunk.length;
        $cb0093123c05defe$export$578fe199ef655b76.prototype.push.call(this, chunk, final);
    };
    return AsyncDecompress;
}();
function $cb0093123c05defe$export$678d868aab8fb3c7(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $cb0093123c05defe$var$err(7);
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $cb0093123c05defe$export$b6df3e950734d697(data, opts, cb) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $cb0093123c05defe$export$cae1ce83fe4a1782(data, opts, cb) : $cb0093123c05defe$export$ca7cbb494e731274(data, opts, cb);
}
function $cb0093123c05defe$export$c4bdbbbc9a4faabe(data, opts) {
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $cb0093123c05defe$export$c80456f7aaba691c(data, opts) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $cb0093123c05defe$export$90366d8b308ba94a(data, opts) : $cb0093123c05defe$export$9ec8134f0f1b9fc6(data, opts);
}
// flatten a directory structure
var $cb0093123c05defe$var$fltn = function(d, p, t, o) {
    for(var k in d){
        var val = d[k], n = p + k, op = o;
        if (Array.isArray(val)) op = $cb0093123c05defe$var$mrg(o, val[1]), val = val[0];
        if (ArrayBuffer.isView(val)) t[n] = [
            val,
            op
        ];
        else {
            t[n += '/'] = [
                new $cb0093123c05defe$var$u8(0),
                op
            ];
            $cb0093123c05defe$var$fltn(val, n, t, o);
        }
    }
};
// text encoder
var $cb0093123c05defe$var$te = typeof TextEncoder != 'undefined' && /*#__PURE__*/ new TextEncoder();
// text decoder
var $cb0093123c05defe$var$td = typeof TextDecoder != 'undefined' && /*#__PURE__*/ new TextDecoder();
// text decoder stream
var $cb0093123c05defe$var$tds = 0;
try {
    $cb0093123c05defe$var$td.decode($cb0093123c05defe$var$et, {
        stream: true
    });
    $cb0093123c05defe$var$tds = 1;
} catch (e) {}
// decode UTF8
var $cb0093123c05defe$var$dutf8 = function(d) {
    for(var r = '', i = 0;;){
        var c = d[i++];
        var eb = (c > 127) + (c > 223) + (c > 239);
        if (i + eb > d.length) return {
            s: r,
            r: $cb0093123c05defe$var$slc(d, i - 1)
        };
        if (!eb) r += String.fromCharCode(c);
        else if (eb == 3) c = ((c & 15) << 18 | (d[i++] & 63) << 12 | (d[i++] & 63) << 6 | d[i++] & 63) - 65536, r += String.fromCharCode(55296 | c >> 10, 56320 | c & 1023);
        else if (eb & 1) r += String.fromCharCode((c & 31) << 6 | d[i++] & 63);
        else r += String.fromCharCode((c & 15) << 12 | (d[i++] & 63) << 6 | d[i++] & 63);
    }
};
/**
 * Streaming UTF-8 decoding
 */ var $cb0093123c05defe$export$ba46860a31c72e94 = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is decoded
     */ function DecodeUTF8(cb) {
        this.ondata = cb;
        if ($cb0093123c05defe$var$tds) this.t = new TextDecoder();
        else this.p = $cb0093123c05defe$var$et;
    }
    /**
     * Pushes a chunk to be decoded from UTF-8 binary
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ DecodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $cb0093123c05defe$var$err(5);
        final = !!final;
        if (this.t) {
            this.ondata(this.t.decode(chunk, {
                stream: true
            }), final);
            if (final) {
                if (this.t.decode().length) $cb0093123c05defe$var$err(8);
                this.t = null;
            }
            return;
        }
        if (!this.p) $cb0093123c05defe$var$err(4);
        var dat = new $cb0093123c05defe$var$u8(this.p.length + chunk.length);
        dat.set(this.p);
        dat.set(chunk, this.p.length);
        var _a = $cb0093123c05defe$var$dutf8(dat), s = _a.s, r = _a.r;
        if (final) {
            if (r.length) $cb0093123c05defe$var$err(8);
            this.p = null;
        } else this.p = r;
        this.ondata(s, final);
    };
    return DecodeUTF8;
}();
/**
 * Streaming UTF-8 encoding
 */ var $cb0093123c05defe$export$283f13d12b1b210e = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is encoded
     */ function EncodeUTF8(cb) {
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be encoded to UTF-8
     * @param chunk The string data to push
     * @param final Whether this is the last chunk
     */ EncodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $cb0093123c05defe$var$err(5);
        if (this.d) $cb0093123c05defe$var$err(4);
        this.ondata($cb0093123c05defe$export$366b39a6daa8ed7a(chunk), this.d = final || false);
    };
    return EncodeUTF8;
}();
function $cb0093123c05defe$export$366b39a6daa8ed7a(str, latin1) {
    if (latin1) {
        var ar_1 = new $cb0093123c05defe$var$u8(str.length);
        for(var i = 0; i < str.length; ++i)ar_1[i] = str.charCodeAt(i);
        return ar_1;
    }
    if ($cb0093123c05defe$var$te) return $cb0093123c05defe$var$te.encode(str);
    var l = str.length;
    var ar = new $cb0093123c05defe$var$u8(str.length + (str.length >> 1));
    var ai = 0;
    var w = function(v) {
        ar[ai++] = v;
    };
    for(var i = 0; i < l; ++i){
        if (ai + 5 > ar.length) {
            var n = new $cb0093123c05defe$var$u8(ai + 8 + (l - i << 1));
            n.set(ar);
            ar = n;
        }
        var c = str.charCodeAt(i);
        if (c < 128 || latin1) w(c);
        else if (c < 2048) w(192 | c >> 6), w(128 | c & 63);
        else if (c > 55295 && c < 57344) c = 65536 + (c & 1047552) | str.charCodeAt(++i) & 1023, w(240 | c >> 18), w(128 | c >> 12 & 63), w(128 | c >> 6 & 63), w(128 | c & 63);
        else w(224 | c >> 12), w(128 | c >> 6 & 63), w(128 | c & 63);
    }
    return $cb0093123c05defe$var$slc(ar, 0, ai);
}
function $cb0093123c05defe$export$adb211f8cb999894(dat, latin1) {
    if (latin1) {
        var r = '';
        for(var i = 0; i < dat.length; i += 16384)r += String.fromCharCode.apply(null, dat.subarray(i, i + 16384));
        return r;
    } else if ($cb0093123c05defe$var$td) return $cb0093123c05defe$var$td.decode(dat);
    else {
        var _a = $cb0093123c05defe$var$dutf8(dat), s = _a.s, r = _a.r;
        if (r.length) $cb0093123c05defe$var$err(8);
        return s;
    }
}
// deflate bit flag
var $cb0093123c05defe$var$dbf = function(l) {
    return l == 1 ? 3 : l < 6 ? 2 : l == 9 ? 1 : 0;
};
// skip local zip header
var $cb0093123c05defe$var$slzh = function(d, b) {
    return b + 30 + $cb0093123c05defe$var$b2(d, b + 26) + $cb0093123c05defe$var$b2(d, b + 28);
};
// read zip header
var $cb0093123c05defe$var$zh = function(d, b, z) {
    var fnl = $cb0093123c05defe$var$b2(d, b + 28), efl = $cb0093123c05defe$var$b2(d, b + 30), fn = $cb0093123c05defe$export$adb211f8cb999894(d.subarray(b + 46, b + 46 + fnl), !($cb0093123c05defe$var$b2(d, b + 8) & 2048)), es = b + 46 + fnl;
    var _a = $cb0093123c05defe$var$z64hs(d, es, efl, z, $cb0093123c05defe$var$b4(d, b + 20), $cb0093123c05defe$var$b4(d, b + 24), $cb0093123c05defe$var$b4(d, b + 42)), sc = _a[0], su = _a[1], off = _a[2];
    return [
        $cb0093123c05defe$var$b2(d, b + 10),
        sc,
        su,
        fn,
        es + efl + $cb0093123c05defe$var$b2(d, b + 32),
        off
    ];
};
// read zip64 header sizes
var $cb0093123c05defe$var$z64hs = function(d, b, l, z, sc, su, off) {
    var nsc = sc == 4294967295, nsu = su == 4294967295, noff = off == 4294967295, e = b + l;
    var nf = nsc + nsu + noff;
    if (z && nf) {
        for(; b + 4 < e; b += 4 + $cb0093123c05defe$var$b2(d, b + 2)){
            if ($cb0093123c05defe$var$b2(d, b) == 1) return [
                nsc ? $cb0093123c05defe$var$b8(d, b + 4 + 8 * nsu) : sc,
                nsu ? $cb0093123c05defe$var$b8(d, b + 4) : su,
                noff ? $cb0093123c05defe$var$b8(d, b + 4 + 8 * (nsu + nsc)) : off,
                1
            ];
        }
        // z == 2 for unknown whether or not zip64
        if (z < 2) $cb0093123c05defe$var$err(13);
    }
    return [
        sc,
        su,
        off,
        0
    ];
};
// extra field length
var $cb0093123c05defe$var$exfl = function(ex) {
    var le = 0;
    if (ex) for(var k in ex){
        var l = ex[k].length;
        if (l > 65535) $cb0093123c05defe$var$err(9);
        le += l + 4;
    }
    return le;
};
// write zip header
var $cb0093123c05defe$var$wzh = function(d, b, f, fn, u, c, ce, co) {
    var fl = fn.length, ex = f.extra, col = co && co.length;
    var exl = $cb0093123c05defe$var$exfl(ex);
    $cb0093123c05defe$var$wbytes(d, b, ce != null ? 0x2014B50 : 0x4034B50), b += 4;
    if (ce != null) d[b++] = 20, d[b++] = f.os;
    d[b] = 20, b += 2; // spec compliance? what's that?
    d[b++] = f.flag << 1 | (c < 0 && 8), d[b++] = u && 8;
    d[b++] = f.compression & 255, d[b++] = f.compression >> 8;
    var dt = new Date(f.mtime == null ? Date.now() : f.mtime), y = dt.getFullYear() - 1980;
    if (y < 0 || y > 119) $cb0093123c05defe$var$err(10);
    $cb0093123c05defe$var$wbytes(d, b, y << 25 | dt.getMonth() + 1 << 21 | dt.getDate() << 16 | dt.getHours() << 11 | dt.getMinutes() << 5 | dt.getSeconds() >> 1), b += 4;
    if (c != -1) {
        $cb0093123c05defe$var$wbytes(d, b, f.crc);
        $cb0093123c05defe$var$wbytes(d, b + 4, c < 0 ? -c - 2 : c);
        $cb0093123c05defe$var$wbytes(d, b + 8, f.size);
    }
    $cb0093123c05defe$var$wbytes(d, b + 12, fl);
    $cb0093123c05defe$var$wbytes(d, b + 14, exl), b += 16;
    if (ce != null) {
        $cb0093123c05defe$var$wbytes(d, b, col);
        $cb0093123c05defe$var$wbytes(d, b + 6, f.attrs);
        $cb0093123c05defe$var$wbytes(d, b + 10, ce), b += 14;
    }
    d.set(fn, b);
    b += fl;
    if (exl) for(var k in ex){
        var exf = ex[k], l = exf.length;
        $cb0093123c05defe$var$wbytes(d, b, +k);
        $cb0093123c05defe$var$wbytes(d, b + 2, l);
        d.set(exf, b + 4), b += 4 + l;
    }
    if (col) d.set(co, b), b += col;
    return b;
};
// write zip footer (end of central directory)
var $cb0093123c05defe$var$wzf = function(o, b, c, d, e) {
    $cb0093123c05defe$var$wbytes(o, b, 0x6054B50); // skip disk
    $cb0093123c05defe$var$wbytes(o, b + 8, c);
    $cb0093123c05defe$var$wbytes(o, b + 10, c);
    $cb0093123c05defe$var$wbytes(o, b + 12, d);
    $cb0093123c05defe$var$wbytes(o, b + 16, e);
};
/**
 * A pass-through stream to keep data uncompressed in a ZIP archive.
 */ var $cb0093123c05defe$export$2b25194e1767ea06 = /*#__PURE__*/ function() {
    /**
     * Creates a pass-through stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     */ function ZipPassThrough(filename) {
        this.filename = filename;
        this.c = $cb0093123c05defe$var$crc();
        this.size = 0;
        this.compression = 0;
    }
    /**
     * Processes a chunk and pushes to the output stream. You can override this
     * method in a subclass for custom behavior, but by default this passes
     * the data through. You must call this.ondata(err, chunk, final) at some
     * point in this method.
     * @param chunk The chunk to process
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.process = function(chunk, final) {
        this.ondata(null, chunk, final);
    };
    /**
     * Pushes a chunk to be added. If you are subclassing this with a custom
     * compression algorithm, note that you must push data from the source
     * file only, pre-compression.
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.push = function(chunk, final) {
        if (!this.ondata) $cb0093123c05defe$var$err(5);
        this.c.p(chunk);
        this.size += chunk.length;
        if (final) this.crc = this.c.d();
        // we shouldn't really do this cast, but properly handling ArrayBufferLike
        // makes the API unergonomic with Buffer
        this.process(chunk, final || false);
    };
    return ZipPassThrough;
}();
// I don't extend because TypeScript extension adds 1kB of runtime bloat
/**
 * Streaming DEFLATE compression for ZIP archives. Prefer using AsyncZipDeflate
 * for better performance
 */ var $cb0093123c05defe$export$f7e481ca646388b6 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function ZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        $cb0093123c05defe$export$2b25194e1767ea06.call(this, filename);
        this.d = new $cb0093123c05defe$export$ae157b6234afe138(opts, function(dat, final) {
            _this.ondata(null, dat, final);
        });
        this.compression = 8;
        this.flag = $cb0093123c05defe$var$dbf(opts.level);
    }
    ZipDeflate.prototype.process = function(chunk, final) {
        try {
            this.d.push(chunk, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipDeflate.prototype.push = function(chunk, final) {
        $cb0093123c05defe$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return ZipDeflate;
}();
/**
 * Asynchronous streaming DEFLATE compression for ZIP archives
 */ var $cb0093123c05defe$export$ffb5e59e179924b2 = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function AsyncZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        $cb0093123c05defe$export$2b25194e1767ea06.call(this, filename);
        this.d = new $cb0093123c05defe$export$84e526fabcba03e3(opts, function(err, dat, final) {
            _this.ondata(err, dat, final);
        });
        this.compression = 8;
        this.flag = $cb0093123c05defe$var$dbf(opts.level);
        this.terminate = this.d.terminate;
    }
    AsyncZipDeflate.prototype.process = function(chunk, final) {
        this.d.push(chunk, final);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncZipDeflate.prototype.push = function(chunk, final) {
        $cb0093123c05defe$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return AsyncZipDeflate;
}();
// TODO: Better tree shaking
/**
 * A zippable archive to which files can incrementally be added
 */ var $cb0093123c05defe$export$9a4d4a7c32a75d2f = /*#__PURE__*/ function() {
    /**
     * Creates an empty ZIP archive to which files can be added
     * @param cb The callback to call whenever data for the generated ZIP archive
     *           is available
     */ function Zip(cb) {
        this.ondata = cb;
        this.u = [];
        this.d = 1;
    }
    /**
     * Adds a file to the ZIP archive
     * @param file The file stream to add
     */ Zip.prototype.add = function(file) {
        var _this = this;
        if (!this.ondata) $cb0093123c05defe$var$err(5);
        // finishing or finished
        if (this.d & 2) this.ondata($cb0093123c05defe$var$err(4 + (this.d & 1) * 8, 0, 1), null, false);
        else {
            var f = $cb0093123c05defe$export$366b39a6daa8ed7a(file.filename), fl_1 = f.length;
            var com = file.comment, o = com && $cb0093123c05defe$export$366b39a6daa8ed7a(com);
            var u = fl_1 != file.filename.length || o && com.length != o.length;
            var hl_1 = fl_1 + $cb0093123c05defe$var$exfl(file.extra) + 30;
            if (fl_1 > 65535) this.ondata($cb0093123c05defe$var$err(11, 0, 1), null, false);
            var header = new $cb0093123c05defe$var$u8(hl_1);
            $cb0093123c05defe$var$wzh(header, 0, file, f, u, -1);
            var chks_1 = [
                header
            ];
            var pAll_1 = function() {
                for(var _i = 0, chks_2 = chks_1; _i < chks_2.length; _i++){
                    var chk = chks_2[_i];
                    _this.ondata(null, chk, false);
                }
                chks_1 = [];
            };
            var tr_1 = this.d;
            this.d = 0;
            var ind_1 = this.u.length;
            var uf_1 = $cb0093123c05defe$var$mrg(file, {
                f: f,
                u: u,
                o: o,
                t: function() {
                    if (file.terminate) file.terminate();
                },
                r: function() {
                    pAll_1();
                    if (tr_1) {
                        var nxt = _this.u[ind_1 + 1];
                        if (nxt) nxt.r();
                        else _this.d = 1;
                    }
                    tr_1 = 1;
                }
            });
            var cl_1 = 0;
            file.ondata = function(err, dat, final) {
                if (err) {
                    _this.ondata(err, dat, final);
                    _this.terminate();
                } else {
                    cl_1 += dat.length;
                    chks_1.push(dat);
                    if (final) {
                        var dd = new $cb0093123c05defe$var$u8(16);
                        $cb0093123c05defe$var$wbytes(dd, 0, 0x8074B50);
                        $cb0093123c05defe$var$wbytes(dd, 4, file.crc);
                        $cb0093123c05defe$var$wbytes(dd, 8, cl_1);
                        $cb0093123c05defe$var$wbytes(dd, 12, file.size);
                        chks_1.push(dd);
                        uf_1.c = cl_1, uf_1.b = hl_1 + cl_1 + 16, uf_1.crc = file.crc, uf_1.size = file.size;
                        if (tr_1) uf_1.r();
                        tr_1 = 1;
                    } else if (tr_1) pAll_1();
                }
            };
            this.u.push(uf_1);
        }
    };
    /**
     * Ends the process of adding files and prepares to emit the final chunks.
     * This *must* be called after adding all desired files for the resulting
     * ZIP file to work properly.
     */ Zip.prototype.end = function() {
        var _this = this;
        if (this.d & 2) {
            this.ondata($cb0093123c05defe$var$err(4 + (this.d & 1) * 8, 0, 1), null, true);
            return;
        }
        if (this.d) this.e();
        else this.u.push({
            r: function() {
                if (!(_this.d & 1)) return;
                _this.u.splice(-1, 1);
                _this.e();
            },
            t: function() {}
        });
        this.d = 3;
    };
    Zip.prototype.e = function() {
        var bt = 0, l = 0, tl = 0;
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            tl += 46 + f.f.length + $cb0093123c05defe$var$exfl(f.extra) + (f.o ? f.o.length : 0);
        }
        var out = new $cb0093123c05defe$var$u8(tl + 22);
        for(var _b = 0, _c = this.u; _b < _c.length; _b++){
            var f = _c[_b];
            $cb0093123c05defe$var$wzh(out, bt, f, f.f, f.u, -f.c - 2, l, f.o);
            bt += 46 + f.f.length + $cb0093123c05defe$var$exfl(f.extra) + (f.o ? f.o.length : 0), l += f.b;
        }
        $cb0093123c05defe$var$wzf(out, bt, this.u.length, tl, l);
        this.ondata(null, out, true);
        this.d = 2;
    };
    /**
     * A method to terminate any internal workers used by the stream. Subsequent
     * calls to add() will fail.
     */ Zip.prototype.terminate = function() {
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            f.t();
        }
        this.d = 2;
    };
    return Zip;
}();
function $cb0093123c05defe$export$8901015135f2fb22(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $cb0093123c05defe$var$err(7);
    var r = {};
    $cb0093123c05defe$var$fltn(data, '', r, opts);
    var k = Object.keys(r);
    var lft = k.length, o = 0, tot = 0;
    var slft = lft, files = new Array(lft);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var cbd = function(a, b) {
        $cb0093123c05defe$var$mt(function() {
            cb(a, b);
        });
    };
    $cb0093123c05defe$var$mt(function() {
        cbd = cb;
    });
    var cbf = function() {
        var out = new $cb0093123c05defe$var$u8(tot + 22), oe = o, cdl = tot - o;
        tot = 0;
        for(var i = 0; i < slft; ++i){
            var f = files[i];
            try {
                var l = f.c.length;
                $cb0093123c05defe$var$wzh(out, tot, f, f.f, f.u, l);
                var badd = 30 + f.f.length + $cb0093123c05defe$var$exfl(f.extra);
                var loc = tot + badd;
                out.set(f.c, loc);
                $cb0093123c05defe$var$wzh(out, o, f, f.f, f.u, l, tot, f.m), o += 16 + badd + (f.m ? f.m.length : 0), tot = loc + l;
            } catch (e) {
                return cbd(e, null);
            }
        }
        $cb0093123c05defe$var$wzf(out, o, files.length, cdl, oe);
        cbd(null, out);
    };
    if (!lft) cbf();
    var _loop_1 = function(i) {
        var fn = k[i];
        var _a = r[fn], file = _a[0], p = _a[1];
        var c = $cb0093123c05defe$var$crc(), size = file.length;
        c.p(file);
        var f = $cb0093123c05defe$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $cb0093123c05defe$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $cb0093123c05defe$var$exfl(p.extra);
        var compression = p.level == 0 ? 0 : 8;
        var cbl = function(e, d) {
            if (e) {
                tAll();
                cbd(e, null);
            } else {
                var l = d.length;
                files[i] = $cb0093123c05defe$var$mrg(p, {
                    size: size,
                    crc: c.d(),
                    c: d,
                    f: f,
                    m: m,
                    u: s != fn.length || m && com.length != ms,
                    compression: compression
                });
                o += 30 + s + exl + l;
                tot += 76 + 2 * (s + exl) + (ms || 0) + l;
                if (!--lft) cbf();
            }
        };
        if (s > 65535) cbl($cb0093123c05defe$var$err(11, 0, 1), null);
        if (!compression) cbl(null, file);
        else if (size < 160000) try {
            cbl(null, $cb0093123c05defe$export$21533ff51b8a0b4a(file, p));
        } catch (e) {
            cbl(e, null);
        }
        else term.push($cb0093123c05defe$export$2316623ecd1285ab(file, p, cbl));
    };
    // Cannot use lft because it can decrease
    for(var i = 0; i < slft; ++i)_loop_1(i);
    return tAll;
}
function $cb0093123c05defe$export$eb1654f146d54eb3(data, opts) {
    if (!opts) opts = {};
    var r = {};
    var files = [];
    $cb0093123c05defe$var$fltn(data, '', r, opts);
    var o = 0;
    var tot = 0;
    for(var fn in r){
        var _a = r[fn], file = _a[0], p = _a[1];
        var compression = p.level == 0 ? 0 : 8;
        var f = $cb0093123c05defe$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $cb0093123c05defe$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $cb0093123c05defe$var$exfl(p.extra);
        if (s > 65535) $cb0093123c05defe$var$err(11);
        var d = compression ? $cb0093123c05defe$export$21533ff51b8a0b4a(file, p) : file, l = d.length;
        var c = $cb0093123c05defe$var$crc();
        c.p(file);
        files.push($cb0093123c05defe$var$mrg(p, {
            size: file.length,
            crc: c.d(),
            c: d,
            f: f,
            m: m,
            u: s != fn.length || m && com.length != ms,
            o: o,
            compression: compression
        }));
        o += 30 + s + exl + l;
        tot += 76 + 2 * (s + exl) + (ms || 0) + l;
    }
    var out = new $cb0093123c05defe$var$u8(tot + 22), oe = o, cdl = tot - o;
    for(var i = 0; i < files.length; ++i){
        var f = files[i];
        $cb0093123c05defe$var$wzh(out, f.o, f, f.f, f.u, f.c.length);
        var badd = 30 + f.f.length + $cb0093123c05defe$var$exfl(f.extra);
        out.set(f.c, f.o + badd);
        $cb0093123c05defe$var$wzh(out, o, f, f.f, f.u, f.c.length, f.o, f.m), o += 16 + badd + (f.m ? f.m.length : 0);
    }
    $cb0093123c05defe$var$wzf(out, o, files.length, cdl, oe);
    return out;
}
/**
 * Streaming pass-through decompression for ZIP archives
 */ var $cb0093123c05defe$export$93f81d5bbbb7c6bf = /*#__PURE__*/ function() {
    function UnzipPassThrough() {}
    UnzipPassThrough.prototype.push = function(chunk, final) {
        // same as ZipPassThrough: cast to retain Buffer ergonomics
        this.ondata(null, chunk, final);
    };
    UnzipPassThrough.compression = 0;
    return UnzipPassThrough;
}();
/**
 * Streaming DEFLATE decompression for ZIP archives. Prefer AsyncZipInflate for
 * better performance.
 */ var $cb0093123c05defe$export$eb188945cc39e642 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function UnzipInflate() {
        var _this = this;
        this.i = new $cb0093123c05defe$export$d1de70a877d6e43c(function(dat, final) {
            _this.ondata(null, dat, final);
        });
    }
    UnzipInflate.prototype.push = function(chunk, final) {
        try {
            this.i.push(chunk, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    UnzipInflate.compression = 8;
    return UnzipInflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression for ZIP archives
 */ var $cb0093123c05defe$export$6235d84645dad4f9 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function AsyncUnzipInflate(_, sz) {
        var _this = this;
        if (sz < 320000) this.i = new $cb0093123c05defe$export$d1de70a877d6e43c(function(dat, final) {
            _this.ondata(null, dat, final);
        });
        else {
            this.i = new $cb0093123c05defe$export$fff8358d6dbaa9cc(function(err, dat, final) {
                _this.ondata(err, dat, final);
            });
            this.terminate = this.i.terminate;
        }
    }
    AsyncUnzipInflate.prototype.push = function(chunk, final) {
        if (this.i.terminate) chunk = $cb0093123c05defe$var$slc(chunk, 0);
        this.i.push(chunk, final);
    };
    AsyncUnzipInflate.compression = 8;
    return AsyncUnzipInflate;
}();
/**
 * A ZIP archive decompression stream that emits files as they are discovered
 */ var $cb0093123c05defe$export$9b7485f84cbaaa56 = /*#__PURE__*/ function() {
    /**
     * Creates a ZIP decompression stream
     * @param cb The callback to call whenever a file in the ZIP archive is found
     */ function Unzip(cb) {
        this.onfile = cb;
        this.k = [];
        this.o = {
            0: $cb0093123c05defe$export$93f81d5bbbb7c6bf
        };
        this.p = $cb0093123c05defe$var$et;
    }
    /**
     * Pushes a chunk to be unzipped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzip.prototype.push = function(chunk, final) {
        var _this = this;
        if (!this.onfile) $cb0093123c05defe$var$err(5);
        if (!this.p) $cb0093123c05defe$var$err(4);
        if (this.c > 0) {
            var len = Math.min(this.c, chunk.length);
            var toAdd = chunk.subarray(0, len);
            this.c -= len;
            if (this.d) this.d.push(toAdd, !this.c);
            else this.k[0].push(toAdd);
            chunk = chunk.subarray(len);
            if (chunk.length) return this.push(chunk, final);
        } else {
            var f = 0, i = 0, is = void 0, buf = void 0;
            if (!this.p.length) buf = chunk;
            else if (!chunk.length) buf = this.p;
            else {
                buf = new $cb0093123c05defe$var$u8(this.p.length + chunk.length);
                buf.set(this.p), buf.set(chunk, this.p.length);
            }
            var l = buf.length, oc = this.c, add = oc && this.d;
            var _loop_2 = function() {
                var sig = $cb0093123c05defe$var$b4(buf, i);
                if (sig == 0x4034B50) {
                    f = 1, is = i;
                    this_1.d = null;
                    this_1.c = 0;
                    var bf = $cb0093123c05defe$var$b2(buf, i + 6), cmp_1 = $cb0093123c05defe$var$b2(buf, i + 8), u = bf & 2048, dd = bf & 8, fnl = $cb0093123c05defe$var$b2(buf, i + 26), es = $cb0093123c05defe$var$b2(buf, i + 28);
                    if (l > i + 30 + fnl + es) {
                        var chks_3 = [];
                        this_1.k.unshift(chks_3);
                        f = 2;
                        var lsc = $cb0093123c05defe$var$b4(buf, i + 18), lsu = $cb0093123c05defe$var$b4(buf, i + 22);
                        var fn_1 = $cb0093123c05defe$export$adb211f8cb999894(buf.subarray(i + 30, i += 30 + fnl), !u);
                        var _a = $cb0093123c05defe$var$z64hs(buf, i, es, 2, lsc, lsu, 0), sc_1 = _a[0], su_1 = _a[1], z64 = _a[3];
                        if (dd) sc_1 = -1 - z64;
                        i += es;
                        this_1.c = sc_1;
                        var d_1;
                        var file_1 = {
                            name: fn_1,
                            compression: cmp_1,
                            start: function() {
                                if (!file_1.ondata) $cb0093123c05defe$var$err(5);
                                if (!sc_1) file_1.ondata(null, $cb0093123c05defe$var$et, true);
                                else {
                                    var ctr = _this.o[cmp_1];
                                    if (!ctr) file_1.ondata($cb0093123c05defe$var$err(14, 'unknown compression type ' + cmp_1, 1), null, false);
                                    d_1 = sc_1 < 0 ? new ctr(fn_1) : new ctr(fn_1, sc_1, su_1);
                                    d_1.ondata = function(err, dat, final) {
                                        file_1.ondata(err, dat, final);
                                    };
                                    for(var _i = 0, chks_4 = chks_3; _i < chks_4.length; _i++){
                                        var dat = chks_4[_i];
                                        d_1.push(dat, false);
                                    }
                                    if (_this.k[0] == chks_3 && _this.c) _this.d = d_1;
                                    else d_1.push($cb0093123c05defe$var$et, true);
                                }
                            },
                            terminate: function() {
                                if (d_1 && d_1.terminate) d_1.terminate();
                            }
                        };
                        if (sc_1 >= 0) file_1.size = sc_1, file_1.originalSize = su_1;
                        this_1.onfile(file_1);
                    }
                    return "break";
                } else if (oc) {
                    if (sig == 0x8074B50) {
                        is = i += 12 + (oc == -2 && 8), f = 3, this_1.c = 0;
                        return "break";
                    } else if (sig == 0x2014B50) {
                        is = i -= 4, f = 3, this_1.c = 0;
                        return "break";
                    }
                }
            };
            var this_1 = this;
            for(; i < l - 4; ++i){
                var state_1 = _loop_2();
                if (state_1 === "break") break;
            }
            this.p = $cb0093123c05defe$var$et;
            if (oc < 0) {
                var dat = f ? buf.subarray(0, is - 12 - (oc == -2 && 8) - ($cb0093123c05defe$var$b4(buf, is - 16) == 0x8074B50 && 4)) : buf.subarray(0, i);
                if (add) add.push(dat, !!f);
                else this.k[+(f == 2)].push(dat);
            }
            if (f & 2) return this.push(buf.subarray(i), final);
            this.p = buf.subarray(i);
        }
        if (final) {
            if (this.c) $cb0093123c05defe$var$err(13);
            this.p = null;
        }
    };
    /**
     * Registers a decoder with the stream, allowing for files compressed with
     * the compression type provided to be expanded correctly
     * @param decoder The decoder constructor
     */ Unzip.prototype.register = function(decoder) {
        this.o[decoder.compression] = decoder;
    };
    return Unzip;
}();
var $cb0093123c05defe$var$mt = typeof queueMicrotask == 'function' ? queueMicrotask : typeof setTimeout == 'function' ? setTimeout : function(fn) {
    fn();
};
function $cb0093123c05defe$export$23c8d3f8757cab88(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $cb0093123c05defe$var$err(7);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var files = {};
    var cbd = function(a, b) {
        $cb0093123c05defe$var$mt(function() {
            cb(a, b);
        });
    };
    $cb0093123c05defe$var$mt(function() {
        cbd = cb;
    });
    var e = data.length - 22;
    for(; $cb0093123c05defe$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) {
        cbd($cb0093123c05defe$var$err(13, 0, 1), null);
        return tAll;
    }
    var lft = $cb0093123c05defe$var$b2(data, e + 8);
    if (lft) {
        var c = lft;
        var o = $cb0093123c05defe$var$b4(data, e + 16);
        var z = $cb0093123c05defe$var$b4(data, e - 20) == 0x7064B50;
        if (z) {
            var ze = $cb0093123c05defe$var$b4(data, e - 12);
            z = $cb0093123c05defe$var$b4(data, ze) == 0x6064B50;
            if (z) {
                c = lft = $cb0093123c05defe$var$b4(data, ze + 32);
                o = $cb0093123c05defe$var$b4(data, ze + 48);
            }
        }
        var fltr = opts && opts.filter;
        var _loop_3 = function(i) {
            var _a = $cb0093123c05defe$var$zh(data, o, z), c_1 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $cb0093123c05defe$var$slzh(data, off);
            o = no;
            var cbl = function(e, d) {
                if (e) {
                    tAll();
                    cbd(e, null);
                } else {
                    if (d) files[fn] = d;
                    if (!--lft) cbd(null, files);
                }
            };
            if (!fltr || fltr({
                name: fn,
                size: sc,
                originalSize: su,
                compression: c_1
            })) {
                if (!c_1) cbl(null, $cb0093123c05defe$var$slc(data, b, b + sc));
                else if (c_1 == 8) {
                    var infl = data.subarray(b, b + sc);
                    // Synchronously decompress under 512KB, or barely-compressed data
                    if (su < 524288 || sc > 0.8 * su) try {
                        cbl(null, $cb0093123c05defe$export$90366d8b308ba94a(infl, {
                            out: new $cb0093123c05defe$var$u8(su)
                        }));
                    } catch (e) {
                        cbl(e, null);
                    }
                    else term.push($cb0093123c05defe$export$cae1ce83fe4a1782(infl, {
                        size: su
                    }, cbl));
                } else cbl($cb0093123c05defe$var$err(14, 'unknown compression type ' + c_1, 1), null);
            } else cbl(null, null);
        };
        for(var i = 0; i < c; ++i)_loop_3(i);
    } else cbd(null, {});
    return tAll;
}
function $cb0093123c05defe$export$c757709326bb5901(data, opts) {
    var files = {};
    var e = data.length - 22;
    for(; $cb0093123c05defe$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) $cb0093123c05defe$var$err(13);
    var c = $cb0093123c05defe$var$b2(data, e + 8);
    if (!c) return {};
    var o = $cb0093123c05defe$var$b4(data, e + 16);
    var z = $cb0093123c05defe$var$b4(data, e - 20) == 0x7064B50;
    if (z) {
        var ze = $cb0093123c05defe$var$b4(data, e - 12);
        z = $cb0093123c05defe$var$b4(data, ze) == 0x6064B50;
        if (z) {
            c = $cb0093123c05defe$var$b4(data, ze + 32);
            o = $cb0093123c05defe$var$b4(data, ze + 48);
        }
    }
    var fltr = opts && opts.filter;
    for(var i = 0; i < c; ++i){
        var _a = $cb0093123c05defe$var$zh(data, o, z), c_2 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $cb0093123c05defe$var$slzh(data, off);
        o = no;
        if (!fltr || fltr({
            name: fn,
            size: sc,
            originalSize: su,
            compression: c_2
        })) {
            if (!c_2) files[fn] = $cb0093123c05defe$var$slc(data, b, b + sc);
            else if (c_2 == 8) files[fn] = $cb0093123c05defe$export$90366d8b308ba94a(data.subarray(b, b + sc), {
                out: new $cb0093123c05defe$var$u8(su)
            });
            else $cb0093123c05defe$var$err(14, 'unknown compression type ' + c_2);
        }
    }
    return files;
}


/**
 * [AES](https://en.wikipedia.org/wiki/Advanced_Encryption_Standard)
 * a.k.a. Advanced Encryption Standard
 * is a variant of Rijndael block cipher, standardized by NIST in 2001.
 * We provide the fastest available pure JS implementation.
 *
 * Data is split into 128-bit blocks. Encrypted in 10/12/14 rounds (128/192/256 bits). In every round:
 * 1. **S-box**, table substitution
 * 2. **Shift rows**, cyclic shift left of all rows of data array
 * 3. **Mix columns**, multiplying every column by fixed polynomial
 * 4. **Add round key**, round_key xor i-th column of array
 *
 * Check out [FIPS-197](https://csrc.nist.gov/files/pubs/fips/197/final/docs/fips-197.pdf)
 * and [original proposal](https://csrc.nist.gov/csrc/media/projects/cryptographic-standards-and-guidelines/documents/aes-development/rijndael-ammended.pdf)
 * @module
 */ /**
 * GHash from AES-GCM and its little-endian "mirror image" Polyval from AES-SIV.
 *
 * Implemented in terms of GHash with conversion function for keys
 * GCM GHASH from
 * [NIST SP800-38d](https://nvlpubs.nist.gov/nistpubs/Legacy/SP/nistspecialpublication800-38d.pdf),
 * SIV from
 * [RFC 8452](https://datatracker.ietf.org/doc/html/rfc8452).
 *
 * GHASH   modulo: x^128 + x^7   + x^2   + x     + 1
 * POLYVAL modulo: x^128 + x^127 + x^126 + x^121 + 1
 *
 * @module
 */ // prettier-ignore
/**
 * Utilities for hex, bytes, CSPRNG.
 * @module
 */ /*! noble-ciphers - MIT License (c) 2023 Paul Miller (paulmillr.com) */ /** Checks if something is Uint8Array. Be careful: nodejs Buffer will return true. */ function $104df8da2312fc03$export$c6fabfbfd097fc30(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === 'Uint8Array';
}
function $104df8da2312fc03$export$809304d28d77d92d(b) {
    if (typeof b !== 'boolean') throw new Error(`boolean expected, not ${b}`);
}
function $104df8da2312fc03$export$75364c6cb16d43b6(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error('positive integer expected, got ' + n);
}
function $104df8da2312fc03$export$e8a750b9efad93f5(b, ...lengths) {
    if (!$104df8da2312fc03$export$c6fabfbfd097fc30(b)) throw new Error('Uint8Array expected');
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error('Uint8Array expected of length ' + lengths + ', got length=' + b.length);
}
function $104df8da2312fc03$export$3ff5a4f04de7e52e(h) {
    if (typeof h !== 'function' || typeof h.create !== 'function') throw new Error('Hash should be wrapped by utils.createHasher');
    $104df8da2312fc03$export$75364c6cb16d43b6(h.outputLen);
    $104df8da2312fc03$export$75364c6cb16d43b6(h.blockLen);
}
function $104df8da2312fc03$export$20871f6b1d047d77(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error('Hash instance has been destroyed');
    if (checkFinished && instance.finished) throw new Error('Hash#digest() has already been called');
}
function $104df8da2312fc03$export$e8e53abee12b995e(out, instance) {
    $104df8da2312fc03$export$e8a750b9efad93f5(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error('digestInto() expects output buffer of length at least ' + min);
}
function $104df8da2312fc03$export$9813fca58c0b9f71(arr) {
    return new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
}
function $104df8da2312fc03$export$8bacf4ad828c7fe7(arr) {
    return new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
}
function $104df8da2312fc03$export$cf0b2a6c63f9e656(...arrays) {
    for(let i = 0; i < arrays.length; i++)arrays[i].fill(0);
}
function $104df8da2312fc03$export$d7febe7b891e79f0(arr) {
    return new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
}
const $104df8da2312fc03$export$a0f88e38d4cf9577 = /* @__PURE__ */ (()=>new Uint8Array(new Uint32Array([
        0x11223344
    ]).buffer)[0] === 0x44)();
// Built-in hex conversion https://caniuse.com/mdn-javascript_builtins_uint8array_fromhex
const $104df8da2312fc03$var$hasHexBuiltin = /* @__PURE__ */ (()=>// @ts-ignore
    typeof Uint8Array.from([]).toHex === 'function' && typeof Uint8Array.fromHex === 'function')();
// Array where index 0xf0 (240) is mapped to string 'f0'
const $104df8da2312fc03$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, '0'));
function $104df8da2312fc03$export$58b867e287a802c8(bytes) {
    $104df8da2312fc03$export$e8a750b9efad93f5(bytes);
    // @ts-ignore
    if ($104df8da2312fc03$var$hasHexBuiltin) return bytes.toHex();
    // pre-caching improves the speed 6x
    let hex = '';
    for(let i = 0; i < bytes.length; i++)hex += $104df8da2312fc03$var$hexes[bytes[i]];
    return hex;
}
// We use optimized technique to convert hex string to byte array
const $104df8da2312fc03$var$asciis = {
    _0: 48,
    _9: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $104df8da2312fc03$var$asciiToBase16(ch) {
    if (ch >= $104df8da2312fc03$var$asciis._0 && ch <= $104df8da2312fc03$var$asciis._9) return ch - $104df8da2312fc03$var$asciis._0; // '2' => 50-48
    if (ch >= $104df8da2312fc03$var$asciis.A && ch <= $104df8da2312fc03$var$asciis.F) return ch - ($104df8da2312fc03$var$asciis.A - 10); // 'B' => 66-(65-10)
    if (ch >= $104df8da2312fc03$var$asciis.a && ch <= $104df8da2312fc03$var$asciis.f) return ch - ($104df8da2312fc03$var$asciis.a - 10); // 'b' => 98-(97-10)
    return;
}
function $104df8da2312fc03$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== 'string') throw new Error('hex string expected, got ' + typeof hex);
    // @ts-ignore
    if ($104df8da2312fc03$var$hasHexBuiltin) return Uint8Array.fromHex(hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error('hex string expected, got unpadded hex of length ' + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $104df8da2312fc03$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $104df8da2312fc03$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2; // multiply first octet, e.g. 'a3' => 10*16+3 => 160 + 3 => 163
    }
    return array;
}
function $104df8da2312fc03$export$d57f2bacc26b4249(hex) {
    if (typeof hex !== 'string') throw new Error('hex string expected, got ' + typeof hex);
    return BigInt(hex === '' ? '0' : '0x' + hex); // Big Endian
}
function $104df8da2312fc03$export$d609354794974f8(bytes) {
    return $104df8da2312fc03$export$d57f2bacc26b4249($104df8da2312fc03$export$58b867e287a802c8(bytes));
}
function $104df8da2312fc03$export$1459dafd057611cb(n, len) {
    return $104df8da2312fc03$export$31c96b9df38bc8d4(n.toString(16).padStart(len * 2, '0'));
}
const $104df8da2312fc03$export$bdd553fddd433dcb = async ()=>{};
function $104df8da2312fc03$export$3df70a15530b5e81(str) {
    if (typeof str !== 'string') throw new Error('string expected');
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
function $104df8da2312fc03$export$5f46301b4a1d43db(bytes) {
    return new TextDecoder().decode(bytes);
}
function $104df8da2312fc03$export$30a71edf0753ed6b(data) {
    if (typeof data === 'string') data = $104df8da2312fc03$export$3df70a15530b5e81(data);
    else if ($104df8da2312fc03$export$c6fabfbfd097fc30(data)) data = $104df8da2312fc03$export$56728fb2d7dba34e(data);
    else throw new Error('Uint8Array expected, got ' + typeof data);
    return data;
}
function $104df8da2312fc03$export$8a4fd82309bf1d6a(a, b) {
    return a.buffer === b.buffer && // best we can do, may fail with an obscure Proxy
    a.byteOffset < b.byteOffset + b.byteLength && // a starts before b end
    b.byteOffset < a.byteOffset + a.byteLength // b starts before a end
    ;
}
function $104df8da2312fc03$export$8ee902273e96266b(input, output) {
    // This is very cursed. It works somehow, but I'm completely unsure,
    // reasoning about overlapping aligned windows is very hard.
    if ($104df8da2312fc03$export$8a4fd82309bf1d6a(input, output) && input.byteOffset < output.byteOffset) throw new Error('complex overlap of input and output is not supported');
}
function $104df8da2312fc03$export$287dd7971339c972(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        $104df8da2312fc03$export$e8a750b9efad93f5(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
function $104df8da2312fc03$export$6fcee72895eceb1e(defaults, opts) {
    if (opts == null || typeof opts !== 'object') throw new Error('options must be defined');
    const merged = Object.assign(defaults, opts);
    return merged;
}
function $104df8da2312fc03$export$2aa59cef064b0333(a, b) {
    if (a.length !== b.length) return false;
    let diff = 0;
    for(let i = 0; i < a.length; i++)diff |= a[i] ^ b[i];
    return diff === 0;
}
class $104df8da2312fc03$export$ab85ecd77ce6a5cd {
}
const $104df8da2312fc03$export$9a6138f9eba70f82 = (params, constructor)=>{
    function wrappedCipher(key, ...args) {
        // Validate key
        $104df8da2312fc03$export$e8a750b9efad93f5(key);
        // Big-Endian hardware is rare. Just in case someone still decides to run ciphers:
        if (!$104df8da2312fc03$export$a0f88e38d4cf9577) throw new Error('Non little-endian hardware is not yet supported');
        // Validate nonce if nonceLength is present
        if (params.nonceLength !== undefined) {
            const nonce = args[0];
            if (!nonce) throw new Error('nonce / iv required');
            if (params.varSizeNonce) $104df8da2312fc03$export$e8a750b9efad93f5(nonce);
            else $104df8da2312fc03$export$e8a750b9efad93f5(nonce, params.nonceLength);
        }
        // Validate AAD if tagLength present
        const tagl = params.tagLength;
        if (tagl && args[1] !== undefined) $104df8da2312fc03$export$e8a750b9efad93f5(args[1]);
        const cipher = constructor(key, ...args);
        const checkOutput = (fnLength, output)=>{
            if (output !== undefined) {
                if (fnLength !== 2) throw new Error('cipher output not supported');
                $104df8da2312fc03$export$e8a750b9efad93f5(output);
            }
        };
        // Create wrapped cipher with validation and single-use encryption
        let called = false;
        const wrCipher = {
            encrypt (data, output) {
                if (called) throw new Error('cannot encrypt() twice with same key + nonce');
                called = true;
                $104df8da2312fc03$export$e8a750b9efad93f5(data);
                checkOutput(cipher.encrypt.length, output);
                return cipher.encrypt(data, output);
            },
            decrypt (data, output) {
                $104df8da2312fc03$export$e8a750b9efad93f5(data);
                if (tagl && data.length < tagl) throw new Error('invalid ciphertext length: smaller than tagLength=' + tagl);
                checkOutput(cipher.decrypt.length, output);
                return cipher.decrypt(data, output);
            }
        };
        return wrCipher;
    }
    Object.assign(wrappedCipher, params);
    return wrappedCipher;
};
function $104df8da2312fc03$export$e504884fb8831d9d(expectedLength, out, onlyAligned = true) {
    if (out === undefined) return new Uint8Array(expectedLength);
    if (out.length !== expectedLength) throw new Error('invalid output length, expected ' + expectedLength + ', got: ' + out.length);
    if (onlyAligned && !$104df8da2312fc03$export$c50aefb83d1cf2a2(out)) throw new Error('invalid output, must be aligned');
    return out;
}
function $104df8da2312fc03$export$b13f930c762582ab(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === 'function') return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
function $104df8da2312fc03$export$342c09f6517ae3b8(dataLength, aadLength, isLE) {
    $104df8da2312fc03$export$809304d28d77d92d(isLE);
    const num = new Uint8Array(16);
    const view = $104df8da2312fc03$export$d7febe7b891e79f0(num);
    $104df8da2312fc03$export$b13f930c762582ab(view, 0, BigInt(aadLength), isLE);
    $104df8da2312fc03$export$b13f930c762582ab(view, 8, BigInt(dataLength), isLE);
    return num;
}
function $104df8da2312fc03$export$c50aefb83d1cf2a2(bytes) {
    return bytes.byteOffset % 4 === 0;
}
function $104df8da2312fc03$export$56728fb2d7dba34e(bytes) {
    return Uint8Array.from(bytes);
}


const $2d3326bc82ba9784$var$BLOCK_SIZE = 16;
// TODO: rewrite
// temporary padding buffer
const $2d3326bc82ba9784$var$ZEROS16 = /* @__PURE__ */ new Uint8Array(16);
const $2d3326bc82ba9784$var$ZEROS32 = (0, $104df8da2312fc03$export$8bacf4ad828c7fe7)($2d3326bc82ba9784$var$ZEROS16);
const $2d3326bc82ba9784$var$POLY = 0xe1; // v = 2*v % POLY
// v = 2*v % POLY
// NOTE: because x + x = 0 (add/sub is same), mul2(x) != x+x
// We can multiply any number using montgomery ladder and this function (works as double, add is simple xor)
const $2d3326bc82ba9784$var$mul2 = (s0, s1, s2, s3)=>{
    const hiBit = s3 & 1;
    return {
        s3: s2 << 31 | s3 >>> 1,
        s2: s1 << 31 | s2 >>> 1,
        s1: s0 << 31 | s1 >>> 1,
        s0: s0 >>> 1 ^ $2d3326bc82ba9784$var$POLY << 24 & -(hiBit & 1)
    };
};
const $2d3326bc82ba9784$var$swapLE = (n)=>(n >>> 0 & 0xff) << 24 | (n >>> 8 & 0xff) << 16 | (n >>> 16 & 0xff) << 8 | n >>> 24 & 0xff | 0;
function $2d3326bc82ba9784$export$9517f61de5da9b07(k) {
    k.reverse();
    const hiBit = k[15] & 1;
    // k >>= 1
    let carry = 0;
    for(let i = 0; i < k.length; i++){
        const t = k[i];
        k[i] = t >>> 1 | carry;
        carry = (t & 1) << 7;
    }
    k[0] ^= -hiBit & 0xe1; // if (hiBit) n ^= 0xe1000000000000000000000000000000;
    return k;
}
const $2d3326bc82ba9784$var$estimateWindow = (bytes)=>{
    if (bytes > 65536) return 8;
    if (bytes > 1024) return 4;
    return 2;
};
class $2d3326bc82ba9784$var$GHASH {
    // We select bits per window adaptively based on expectedLength
    constructor(key, expectedLength){
        this.blockLen = $2d3326bc82ba9784$var$BLOCK_SIZE;
        this.outputLen = $2d3326bc82ba9784$var$BLOCK_SIZE;
        this.s0 = 0;
        this.s1 = 0;
        this.s2 = 0;
        this.s3 = 0;
        this.finished = false;
        key = (0, $104df8da2312fc03$export$30a71edf0753ed6b)(key);
        (0, $104df8da2312fc03$export$e8a750b9efad93f5)(key, 16);
        const kView = (0, $104df8da2312fc03$export$d7febe7b891e79f0)(key);
        let k0 = kView.getUint32(0, false);
        let k1 = kView.getUint32(4, false);
        let k2 = kView.getUint32(8, false);
        let k3 = kView.getUint32(12, false);
        // generate table of doubled keys (half of montgomery ladder)
        const doubles = [];
        for(let i = 0; i < 128; i++){
            doubles.push({
                s0: $2d3326bc82ba9784$var$swapLE(k0),
                s1: $2d3326bc82ba9784$var$swapLE(k1),
                s2: $2d3326bc82ba9784$var$swapLE(k2),
                s3: $2d3326bc82ba9784$var$swapLE(k3)
            });
            ({ s0: k0, s1: k1, s2: k2, s3: k3 } = $2d3326bc82ba9784$var$mul2(k0, k1, k2, k3));
        }
        const W = $2d3326bc82ba9784$var$estimateWindow(expectedLength || 1024);
        if (![
            1,
            2,
            4,
            8
        ].includes(W)) throw new Error('ghash: invalid window size, expected 2, 4 or 8');
        this.W = W;
        const bits = 128; // always 128 bits;
        const windows = bits / W;
        const windowSize = this.windowSize = 2 ** W;
        const items = [];
        // Create precompute table for window of W bits
        for(let w = 0; w < windows; w++)// truth table: 00, 01, 10, 11
        for(let byte = 0; byte < windowSize; byte++){
            // prettier-ignore
            let s0 = 0, s1 = 0, s2 = 0, s3 = 0;
            for(let j = 0; j < W; j++){
                const bit = byte >>> W - j - 1 & 1;
                if (!bit) continue;
                const { s0: d0, s1: d1, s2: d2, s3: d3 } = doubles[W * w + j];
                s0 ^= d0, s1 ^= d1, s2 ^= d2, s3 ^= d3;
            }
            items.push({
                s0: s0,
                s1: s1,
                s2: s2,
                s3: s3
            });
        }
        this.t = items;
    }
    _updateBlock(s0, s1, s2, s3) {
        s0 ^= this.s0, s1 ^= this.s1, s2 ^= this.s2, s3 ^= this.s3;
        const { W: W, t: t, windowSize: windowSize } = this;
        // prettier-ignore
        let o0 = 0, o1 = 0, o2 = 0, o3 = 0;
        const mask = (1 << W) - 1; // 2**W will kill performance.
        let w = 0;
        for (const num of [
            s0,
            s1,
            s2,
            s3
        ])for(let bytePos = 0; bytePos < 4; bytePos++){
            const byte = num >>> 8 * bytePos & 0xff;
            for(let bitPos = 8 / W - 1; bitPos >= 0; bitPos--){
                const bit = byte >>> W * bitPos & mask;
                const { s0: e0, s1: e1, s2: e2, s3: e3 } = t[w * windowSize + bit];
                o0 ^= e0, o1 ^= e1, o2 ^= e2, o3 ^= e3;
                w += 1;
            }
        }
        this.s0 = o0;
        this.s1 = o1;
        this.s2 = o2;
        this.s3 = o3;
    }
    update(data) {
        (0, $104df8da2312fc03$export$20871f6b1d047d77)(this);
        data = (0, $104df8da2312fc03$export$30a71edf0753ed6b)(data);
        (0, $104df8da2312fc03$export$e8a750b9efad93f5)(data);
        const b32 = (0, $104df8da2312fc03$export$8bacf4ad828c7fe7)(data);
        const blocks = Math.floor(data.length / $2d3326bc82ba9784$var$BLOCK_SIZE);
        const left = data.length % $2d3326bc82ba9784$var$BLOCK_SIZE;
        for(let i = 0; i < blocks; i++)this._updateBlock(b32[i * 4 + 0], b32[i * 4 + 1], b32[i * 4 + 2], b32[i * 4 + 3]);
        if (left) {
            $2d3326bc82ba9784$var$ZEROS16.set(data.subarray(blocks * $2d3326bc82ba9784$var$BLOCK_SIZE));
            this._updateBlock($2d3326bc82ba9784$var$ZEROS32[0], $2d3326bc82ba9784$var$ZEROS32[1], $2d3326bc82ba9784$var$ZEROS32[2], $2d3326bc82ba9784$var$ZEROS32[3]);
            (0, $104df8da2312fc03$export$cf0b2a6c63f9e656)($2d3326bc82ba9784$var$ZEROS32); // clean tmp buffer
        }
        return this;
    }
    destroy() {
        const { t: t } = this;
        // clean precompute table
        for (const elm of t)elm.s0 = 0, elm.s1 = 0, elm.s2 = 0, elm.s3 = 0;
    }
    digestInto(out) {
        (0, $104df8da2312fc03$export$20871f6b1d047d77)(this);
        (0, $104df8da2312fc03$export$e8e53abee12b995e)(out, this);
        this.finished = true;
        const { s0: s0, s1: s1, s2: s2, s3: s3 } = this;
        const o32 = (0, $104df8da2312fc03$export$8bacf4ad828c7fe7)(out);
        o32[0] = s0;
        o32[1] = s1;
        o32[2] = s2;
        o32[3] = s3;
        return out;
    }
    digest() {
        const res = new Uint8Array($2d3326bc82ba9784$var$BLOCK_SIZE);
        this.digestInto(res);
        this.destroy();
        return res;
    }
}
class $2d3326bc82ba9784$var$Polyval extends $2d3326bc82ba9784$var$GHASH {
    constructor(key, expectedLength){
        key = (0, $104df8da2312fc03$export$30a71edf0753ed6b)(key);
        (0, $104df8da2312fc03$export$e8a750b9efad93f5)(key);
        const ghKey = $2d3326bc82ba9784$export$9517f61de5da9b07((0, $104df8da2312fc03$export$56728fb2d7dba34e)(key));
        super(ghKey, expectedLength);
        (0, $104df8da2312fc03$export$cf0b2a6c63f9e656)(ghKey);
    }
    update(data) {
        data = (0, $104df8da2312fc03$export$30a71edf0753ed6b)(data);
        (0, $104df8da2312fc03$export$20871f6b1d047d77)(this);
        const b32 = (0, $104df8da2312fc03$export$8bacf4ad828c7fe7)(data);
        const left = data.length % $2d3326bc82ba9784$var$BLOCK_SIZE;
        const blocks = Math.floor(data.length / $2d3326bc82ba9784$var$BLOCK_SIZE);
        for(let i = 0; i < blocks; i++)this._updateBlock($2d3326bc82ba9784$var$swapLE(b32[i * 4 + 3]), $2d3326bc82ba9784$var$swapLE(b32[i * 4 + 2]), $2d3326bc82ba9784$var$swapLE(b32[i * 4 + 1]), $2d3326bc82ba9784$var$swapLE(b32[i * 4 + 0]));
        if (left) {
            $2d3326bc82ba9784$var$ZEROS16.set(data.subarray(blocks * $2d3326bc82ba9784$var$BLOCK_SIZE));
            this._updateBlock($2d3326bc82ba9784$var$swapLE($2d3326bc82ba9784$var$ZEROS32[3]), $2d3326bc82ba9784$var$swapLE($2d3326bc82ba9784$var$ZEROS32[2]), $2d3326bc82ba9784$var$swapLE($2d3326bc82ba9784$var$ZEROS32[1]), $2d3326bc82ba9784$var$swapLE($2d3326bc82ba9784$var$ZEROS32[0]));
            (0, $104df8da2312fc03$export$cf0b2a6c63f9e656)($2d3326bc82ba9784$var$ZEROS32);
        }
        return this;
    }
    digestInto(out) {
        (0, $104df8da2312fc03$export$20871f6b1d047d77)(this);
        (0, $104df8da2312fc03$export$e8e53abee12b995e)(out, this);
        this.finished = true;
        // tmp ugly hack
        const { s0: s0, s1: s1, s2: s2, s3: s3 } = this;
        const o32 = (0, $104df8da2312fc03$export$8bacf4ad828c7fe7)(out);
        o32[0] = s0;
        o32[1] = s1;
        o32[2] = s2;
        o32[3] = s3;
        return out.reverse();
    }
}
function $2d3326bc82ba9784$var$wrapConstructorWithKey(hashCons) {
    const hashC = (msg, key)=>hashCons(key, msg.length).update((0, $104df8da2312fc03$export$30a71edf0753ed6b)(msg)).digest();
    const tmp = hashCons(new Uint8Array(16), 0);
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (key, expectedLength)=>hashCons(key, expectedLength);
    return hashC;
}
const $2d3326bc82ba9784$export$f562b99c67f83a33 = $2d3326bc82ba9784$var$wrapConstructorWithKey((key, expectedLength)=>new $2d3326bc82ba9784$var$GHASH(key, expectedLength));
const $2d3326bc82ba9784$export$4dd5f33d13f59946 = $2d3326bc82ba9784$var$wrapConstructorWithKey((key, expectedLength)=>new $2d3326bc82ba9784$var$Polyval(key, expectedLength));



const $0d86ce4f5243a4d8$var$BLOCK_SIZE = 16;
const $0d86ce4f5243a4d8$var$BLOCK_SIZE32 = 4;
const $0d86ce4f5243a4d8$var$EMPTY_BLOCK = /* @__PURE__ */ new Uint8Array($0d86ce4f5243a4d8$var$BLOCK_SIZE);
const $0d86ce4f5243a4d8$var$POLY = 0x11b; // 1 + x + x**3 + x**4 + x**8
// TODO: remove multiplication, binary ops only
function $0d86ce4f5243a4d8$var$mul2(n) {
    return n << 1 ^ $0d86ce4f5243a4d8$var$POLY & -(n >> 7);
}
function $0d86ce4f5243a4d8$var$mul(a, b) {
    let res = 0;
    for(; b > 0; b >>= 1){
        // Montgomery ladder
        res ^= a & -(b & 1); // if (b&1) res ^=a (but const-time).
        a = $0d86ce4f5243a4d8$var$mul2(a); // a = 2*a
    }
    return res;
}
// AES S-box is generated using finite field inversion,
// an affine transform, and xor of a constant 0x63.
const $0d86ce4f5243a4d8$var$sbox = /* @__PURE__ */ (()=>{
    const t = new Uint8Array(256);
    for(let i = 0, x = 1; i < 256; i++, x ^= $0d86ce4f5243a4d8$var$mul2(x))t[i] = x;
    const box = new Uint8Array(256);
    box[0] = 0x63; // first elm
    for(let i = 0; i < 255; i++){
        let x = t[255 - i];
        x |= x << 8;
        box[t[i]] = (x ^ x >> 4 ^ x >> 5 ^ x >> 6 ^ x >> 7 ^ 0x63) & 0xff;
    }
    (0, $104df8da2312fc03$export$cf0b2a6c63f9e656)(t);
    return box;
})();
// Inverted S-box
const $0d86ce4f5243a4d8$var$invSbox = /* @__PURE__ */ $0d86ce4f5243a4d8$var$sbox.map((_, j)=>$0d86ce4f5243a4d8$var$sbox.indexOf(j));
// Rotate u32 by 8
const $0d86ce4f5243a4d8$var$rotr32_8 = (n)=>n << 24 | n >>> 8;
const $0d86ce4f5243a4d8$var$rotl32_8 = (n)=>n << 8 | n >>> 24;
// The byte swap operation for uint32 (LE<->BE)
const $0d86ce4f5243a4d8$var$byteSwap = (word)=>word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
// T-table is optimization suggested in 5.2 of original proposal (missed from FIPS-197). Changes:
// - LE instead of BE
// - bigger tables: T0 and T1 are merged into T01 table and T2 & T3 into T23;
//   so index is u16, instead of u8. This speeds up things, unexpectedly
function $0d86ce4f5243a4d8$var$genTtable(sbox, fn) {
    if (sbox.length !== 256) throw new Error('Wrong sbox length');
    const T0 = new Uint32Array(256).map((_, j)=>fn(sbox[j]));
    const T1 = T0.map($0d86ce4f5243a4d8$var$rotl32_8);
    const T2 = T1.map($0d86ce4f5243a4d8$var$rotl32_8);
    const T3 = T2.map($0d86ce4f5243a4d8$var$rotl32_8);
    const T01 = new Uint32Array(65536);
    const T23 = new Uint32Array(65536);
    const sbox2 = new Uint16Array(65536);
    for(let i = 0; i < 256; i++)for(let j = 0; j < 256; j++){
        const idx = i * 256 + j;
        T01[idx] = T0[i] ^ T1[j];
        T23[idx] = T2[i] ^ T3[j];
        sbox2[idx] = sbox[i] << 8 | sbox[j];
    }
    return {
        sbox: sbox,
        sbox2: sbox2,
        T0: T0,
        T1: T1,
        T2: T2,
        T3: T3,
        T01: T01,
        T23: T23
    };
}
const $0d86ce4f5243a4d8$var$tableEncoding = /* @__PURE__ */ $0d86ce4f5243a4d8$var$genTtable($0d86ce4f5243a4d8$var$sbox, (s)=>$0d86ce4f5243a4d8$var$mul(s, 3) << 24 | s << 16 | s << 8 | $0d86ce4f5243a4d8$var$mul(s, 2));
const $0d86ce4f5243a4d8$var$tableDecoding = /* @__PURE__ */ $0d86ce4f5243a4d8$var$genTtable($0d86ce4f5243a4d8$var$invSbox, (s)=>$0d86ce4f5243a4d8$var$mul(s, 11) << 24 | $0d86ce4f5243a4d8$var$mul(s, 13) << 16 | $0d86ce4f5243a4d8$var$mul(s, 9) << 8 | $0d86ce4f5243a4d8$var$mul(s, 14));
const $0d86ce4f5243a4d8$var$xPowers = /* @__PURE__ */ (()=>{
    const p = new Uint8Array(16);
    for(let i = 0, x = 1; i < 16; i++, x = $0d86ce4f5243a4d8$var$mul2(x))p[i] = x;
    return p;
})();
/** Key expansion used in CTR. */ function $0d86ce4f5243a4d8$var$expandKeyLE(key) {
    (0, $104df8da2312fc03$export$e8a750b9efad93f5)(key);
    const len = key.length;
    if (![
        16,
        24,
        32
    ].includes(len)) throw new Error('aes: invalid key size, should be 16, 24 or 32, got ' + len);
    const { sbox2: sbox2 } = $0d86ce4f5243a4d8$var$tableEncoding;
    const toClean = [];
    if (!(0, $104df8da2312fc03$export$c50aefb83d1cf2a2)(key)) toClean.push(key = (0, $104df8da2312fc03$export$56728fb2d7dba34e)(key));
    const k32 = (0, $104df8da2312fc03$export$8bacf4ad828c7fe7)(key);
    const Nk = k32.length;
    const subByte = (n)=>$0d86ce4f5243a4d8$var$applySbox(sbox2, n, n, n, n);
    const xk = new Uint32Array(len + 28); // expanded key
    xk.set(k32);
    // 4.3.1 Key expansion
    for(let i = Nk; i < xk.length; i++){
        let t = xk[i - 1];
        if (i % Nk === 0) t = subByte($0d86ce4f5243a4d8$var$rotr32_8(t)) ^ $0d86ce4f5243a4d8$var$xPowers[i / Nk - 1];
        else if (Nk > 6 && i % Nk === 4) t = subByte(t);
        xk[i] = xk[i - Nk] ^ t;
    }
    (0, $104df8da2312fc03$export$cf0b2a6c63f9e656)(...toClean);
    return xk;
}
function $0d86ce4f5243a4d8$var$expandKeyDecLE(key) {
    const encKey = $0d86ce4f5243a4d8$var$expandKeyLE(key);
    const xk = encKey.slice();
    const Nk = encKey.length;
    const { sbox2: sbox2 } = $0d86ce4f5243a4d8$var$tableEncoding;
    const { T0: T0, T1: T1, T2: T2, T3: T3 } = $0d86ce4f5243a4d8$var$tableDecoding;
    // Inverse key by chunks of 4 (rounds)
    for(let i = 0; i < Nk; i += 4)for(let j = 0; j < 4; j++)xk[i + j] = encKey[Nk - i - 4 + j];
    (0, $104df8da2312fc03$export$cf0b2a6c63f9e656)(encKey);
    // apply InvMixColumn except first & last round
    for(let i = 4; i < Nk - 4; i++){
        const x = xk[i];
        const w = $0d86ce4f5243a4d8$var$applySbox(sbox2, x, x, x, x);
        xk[i] = T0[w & 0xff] ^ T1[w >>> 8 & 0xff] ^ T2[w >>> 16 & 0xff] ^ T3[w >>> 24];
    }
    return xk;
}
// Apply tables
function $0d86ce4f5243a4d8$var$apply0123(T01, T23, s0, s1, s2, s3) {
    return T01[s0 << 8 & 0xff00 | s1 >>> 8 & 0xff] ^ T23[s2 >>> 8 & 0xff00 | s3 >>> 24 & 0xff];
}
function $0d86ce4f5243a4d8$var$applySbox(sbox2, s0, s1, s2, s3) {
    return sbox2[s0 & 0xff | s1 & 0xff00] | sbox2[s2 >>> 16 & 0xff | s3 >>> 16 & 0xff00] << 16;
}
function $0d86ce4f5243a4d8$var$encrypt(xk, s0, s1, s2, s3) {
    const { sbox2: sbox2, T01: T01, T23: T23 } = $0d86ce4f5243a4d8$var$tableEncoding;
    let k = 0;
    s0 ^= xk[k++], s1 ^= xk[k++], s2 ^= xk[k++], s3 ^= xk[k++];
    const rounds = xk.length / 4 - 2;
    for(let i = 0; i < rounds; i++){
        const t0 = xk[k++] ^ $0d86ce4f5243a4d8$var$apply0123(T01, T23, s0, s1, s2, s3);
        const t1 = xk[k++] ^ $0d86ce4f5243a4d8$var$apply0123(T01, T23, s1, s2, s3, s0);
        const t2 = xk[k++] ^ $0d86ce4f5243a4d8$var$apply0123(T01, T23, s2, s3, s0, s1);
        const t3 = xk[k++] ^ $0d86ce4f5243a4d8$var$apply0123(T01, T23, s3, s0, s1, s2);
        s0 = t0, s1 = t1, s2 = t2, s3 = t3;
    }
    // last round (without mixcolumns, so using SBOX2 table)
    const t0 = xk[k++] ^ $0d86ce4f5243a4d8$var$applySbox(sbox2, s0, s1, s2, s3);
    const t1 = xk[k++] ^ $0d86ce4f5243a4d8$var$applySbox(sbox2, s1, s2, s3, s0);
    const t2 = xk[k++] ^ $0d86ce4f5243a4d8$var$applySbox(sbox2, s2, s3, s0, s1);
    const t3 = xk[k++] ^ $0d86ce4f5243a4d8$var$applySbox(sbox2, s3, s0, s1, s2);
    return {
        s0: t0,
        s1: t1,
        s2: t2,
        s3: t3
    };
}
// Can't be merged with encrypt: arg positions for apply0123 / applySbox are different
function $0d86ce4f5243a4d8$var$decrypt(xk, s0, s1, s2, s3) {
    const { sbox2: sbox2, T01: T01, T23: T23 } = $0d86ce4f5243a4d8$var$tableDecoding;
    let k = 0;
    s0 ^= xk[k++], s1 ^= xk[k++], s2 ^= xk[k++], s3 ^= xk[k++];
    const rounds = xk.length / 4 - 2;
    for(let i = 0; i < rounds; i++){
        const t0 = xk[k++] ^ $0d86ce4f5243a4d8$var$apply0123(T01, T23, s0, s3, s2, s1);
        const t1 = xk[k++] ^ $0d86ce4f5243a4d8$var$apply0123(T01, T23, s1, s0, s3, s2);
        const t2 = xk[k++] ^ $0d86ce4f5243a4d8$var$apply0123(T01, T23, s2, s1, s0, s3);
        const t3 = xk[k++] ^ $0d86ce4f5243a4d8$var$apply0123(T01, T23, s3, s2, s1, s0);
        s0 = t0, s1 = t1, s2 = t2, s3 = t3;
    }
    // Last round
    const t0 = xk[k++] ^ $0d86ce4f5243a4d8$var$applySbox(sbox2, s0, s3, s2, s1);
    const t1 = xk[k++] ^ $0d86ce4f5243a4d8$var$applySbox(sbox2, s1, s0, s3, s2);
    const t2 = xk[k++] ^ $0d86ce4f5243a4d8$var$applySbox(sbox2, s2, s1, s0, s3);
    const t3 = xk[k++] ^ $0d86ce4f5243a4d8$var$applySbox(sbox2, s3, s2, s1, s0);
    return {
        s0: t0,
        s1: t1,
        s2: t2,
        s3: t3
    };
}
// TODO: investigate merging with ctr32
function $0d86ce4f5243a4d8$var$ctrCounter(xk, nonce, src, dst) {
    (0, $104df8da2312fc03$export$e8a750b9efad93f5)(nonce, $0d86ce4f5243a4d8$var$BLOCK_SIZE);
    (0, $104df8da2312fc03$export$e8a750b9efad93f5)(src);
    const srcLen = src.length;
    dst = (0, $104df8da2312fc03$export$e504884fb8831d9d)(srcLen, dst);
    (0, $104df8da2312fc03$export$8ee902273e96266b)(src, dst);
    const ctr = nonce;
    const c32 = (0, $104df8da2312fc03$export$8bacf4ad828c7fe7)(ctr);
    // Fill block (empty, ctr=0)
    let { s0: s0, s1: s1, s2: s2, s3: s3 } = $0d86ce4f5243a4d8$var$encrypt(xk, c32[0], c32[1], c32[2], c32[3]);
    const src32 = (0, $104df8da2312fc03$export$8bacf4ad828c7fe7)(src);
    const dst32 = (0, $104df8da2312fc03$export$8bacf4ad828c7fe7)(dst);
    // process blocks
    for(let i = 0; i + 4 <= src32.length; i += 4){
        dst32[i + 0] = src32[i + 0] ^ s0;
        dst32[i + 1] = src32[i + 1] ^ s1;
        dst32[i + 2] = src32[i + 2] ^ s2;
        dst32[i + 3] = src32[i + 3] ^ s3;
        // Full 128 bit counter with wrap around
        let carry = 1;
        for(let i = ctr.length - 1; i >= 0; i--){
            carry = carry + (ctr[i] & 0xff) | 0;
            ctr[i] = carry & 0xff;
            carry >>>= 8;
        }
        ({ s0: s0, s1: s1, s2: s2, s3: s3 } = $0d86ce4f5243a4d8$var$encrypt(xk, c32[0], c32[1], c32[2], c32[3]));
    }
    // leftovers (less than block)
    // It's possible to handle > u32 fast, but is it worth it?
    const start = $0d86ce4f5243a4d8$var$BLOCK_SIZE * Math.floor(src32.length / $0d86ce4f5243a4d8$var$BLOCK_SIZE32);
    if (start < srcLen) {
        const b32 = new Uint32Array([
            s0,
            s1,
            s2,
            s3
        ]);
        const buf = (0, $104df8da2312fc03$export$9813fca58c0b9f71)(b32);
        for(let i = start, pos = 0; i < srcLen; i++, pos++)dst[i] = src[i] ^ buf[pos];
        (0, $104df8da2312fc03$export$cf0b2a6c63f9e656)(b32);
    }
    return dst;
}
// AES CTR with overflowing 32 bit counter
// It's possible to do 32le significantly simpler (and probably faster) by using u32.
// But, we need both, and perf bottleneck is in ghash anyway.
function $0d86ce4f5243a4d8$var$ctr32(xk, isLE, nonce, src, dst) {
    (0, $104df8da2312fc03$export$e8a750b9efad93f5)(nonce, $0d86ce4f5243a4d8$var$BLOCK_SIZE);
    (0, $104df8da2312fc03$export$e8a750b9efad93f5)(src);
    dst = (0, $104df8da2312fc03$export$e504884fb8831d9d)(src.length, dst);
    const ctr = nonce; // write new value to nonce, so it can be re-used
    const c32 = (0, $104df8da2312fc03$export$8bacf4ad828c7fe7)(ctr);
    const view = (0, $104df8da2312fc03$export$d7febe7b891e79f0)(ctr);
    const src32 = (0, $104df8da2312fc03$export$8bacf4ad828c7fe7)(src);
    const dst32 = (0, $104df8da2312fc03$export$8bacf4ad828c7fe7)(dst);
    const ctrPos = isLE ? 0 : 12;
    const srcLen = src.length;
    // Fill block (empty, ctr=0)
    let ctrNum = view.getUint32(ctrPos, isLE); // read current counter value
    let { s0: s0, s1: s1, s2: s2, s3: s3 } = $0d86ce4f5243a4d8$var$encrypt(xk, c32[0], c32[1], c32[2], c32[3]);
    // process blocks
    for(let i = 0; i + 4 <= src32.length; i += 4){
        dst32[i + 0] = src32[i + 0] ^ s0;
        dst32[i + 1] = src32[i + 1] ^ s1;
        dst32[i + 2] = src32[i + 2] ^ s2;
        dst32[i + 3] = src32[i + 3] ^ s3;
        ctrNum = ctrNum + 1 >>> 0; // u32 wrap
        view.setUint32(ctrPos, ctrNum, isLE);
        ({ s0: s0, s1: s1, s2: s2, s3: s3 } = $0d86ce4f5243a4d8$var$encrypt(xk, c32[0], c32[1], c32[2], c32[3]));
    }
    // leftovers (less than a block)
    const start = $0d86ce4f5243a4d8$var$BLOCK_SIZE * Math.floor(src32.length / $0d86ce4f5243a4d8$var$BLOCK_SIZE32);
    if (start < srcLen) {
        const b32 = new Uint32Array([
            s0,
            s1,
            s2,
            s3
        ]);
        const buf = (0, $104df8da2312fc03$export$9813fca58c0b9f71)(b32);
        for(let i = start, pos = 0; i < srcLen; i++, pos++)dst[i] = src[i] ^ buf[pos];
        (0, $104df8da2312fc03$export$cf0b2a6c63f9e656)(b32);
    }
    return dst;
}
const $0d86ce4f5243a4d8$export$5f70e4be40e1a294 = /* @__PURE__ */ (0, $104df8da2312fc03$export$9a6138f9eba70f82)({
    blockSize: 16,
    nonceLength: 16
}, function aesctr(key, nonce) {
    function processCtr(buf, dst) {
        (0, $104df8da2312fc03$export$e8a750b9efad93f5)(buf);
        if (dst !== undefined) {
            (0, $104df8da2312fc03$export$e8a750b9efad93f5)(dst);
            if (!(0, $104df8da2312fc03$export$c50aefb83d1cf2a2)(dst)) throw new Error('unaligned destination');
        }
        const xk = $0d86ce4f5243a4d8$var$expandKeyLE(key);
        const n = (0, $104df8da2312fc03$export$56728fb2d7dba34e)(nonce); // align + avoid changing
        const toClean = [
            xk,
            n
        ];
        if (!(0, $104df8da2312fc03$export$c50aefb83d1cf2a2)(buf)) toClean.push(buf = (0, $104df8da2312fc03$export$56728fb2d7dba34e)(buf));
        const out = $0d86ce4f5243a4d8$var$ctrCounter(xk, n, buf, dst);
        (0, $104df8da2312fc03$export$cf0b2a6c63f9e656)(...toClean);
        return out;
    }
    return {
        encrypt: (plaintext, dst)=>processCtr(plaintext, dst),
        decrypt: (ciphertext, dst)=>processCtr(ciphertext, dst)
    };
});
function $0d86ce4f5243a4d8$var$validateBlockDecrypt(data) {
    (0, $104df8da2312fc03$export$e8a750b9efad93f5)(data);
    if (data.length % $0d86ce4f5243a4d8$var$BLOCK_SIZE !== 0) throw new Error('aes-(cbc/ecb).decrypt ciphertext should consist of blocks with size ' + $0d86ce4f5243a4d8$var$BLOCK_SIZE);
}
function $0d86ce4f5243a4d8$var$validateBlockEncrypt(plaintext, pcks5, dst) {
    (0, $104df8da2312fc03$export$e8a750b9efad93f5)(plaintext);
    let outLen = plaintext.length;
    const remaining = outLen % $0d86ce4f5243a4d8$var$BLOCK_SIZE;
    if (!pcks5 && remaining !== 0) throw new Error('aec/(cbc-ecb): unpadded plaintext with disabled padding');
    if (!(0, $104df8da2312fc03$export$c50aefb83d1cf2a2)(plaintext)) plaintext = (0, $104df8da2312fc03$export$56728fb2d7dba34e)(plaintext);
    const b = (0, $104df8da2312fc03$export$8bacf4ad828c7fe7)(plaintext);
    if (pcks5) {
        let left = $0d86ce4f5243a4d8$var$BLOCK_SIZE - remaining;
        if (!left) left = $0d86ce4f5243a4d8$var$BLOCK_SIZE; // if no bytes left, create empty padding block
        outLen = outLen + left;
    }
    dst = (0, $104df8da2312fc03$export$e504884fb8831d9d)(outLen, dst);
    (0, $104df8da2312fc03$export$8ee902273e96266b)(plaintext, dst);
    const o = (0, $104df8da2312fc03$export$8bacf4ad828c7fe7)(dst);
    return {
        b: b,
        o: o,
        out: dst
    };
}
function $0d86ce4f5243a4d8$var$validatePCKS(data, pcks5) {
    if (!pcks5) return data;
    const len = data.length;
    if (!len) throw new Error('aes/pcks5: empty ciphertext not allowed');
    const lastByte = data[len - 1];
    if (lastByte <= 0 || lastByte > 16) throw new Error('aes/pcks5: wrong padding');
    const out = data.subarray(0, -lastByte);
    for(let i = 0; i < lastByte; i++)if (data[len - i - 1] !== lastByte) throw new Error('aes/pcks5: wrong padding');
    return out;
}
function $0d86ce4f5243a4d8$var$padPCKS(left) {
    const tmp = new Uint8Array(16);
    const tmp32 = (0, $104df8da2312fc03$export$8bacf4ad828c7fe7)(tmp);
    tmp.set(left);
    const paddingByte = $0d86ce4f5243a4d8$var$BLOCK_SIZE - left.length;
    for(let i = $0d86ce4f5243a4d8$var$BLOCK_SIZE - paddingByte; i < $0d86ce4f5243a4d8$var$BLOCK_SIZE; i++)tmp[i] = paddingByte;
    return tmp32;
}
const $0d86ce4f5243a4d8$export$bf364bd2354bf4a = /* @__PURE__ */ (0, $104df8da2312fc03$export$9a6138f9eba70f82)({
    blockSize: 16
}, function aesecb(key, opts = {}) {
    const pcks5 = !opts.disablePadding;
    return {
        encrypt (plaintext, dst) {
            const { b: b, o: o, out: _out } = $0d86ce4f5243a4d8$var$validateBlockEncrypt(plaintext, pcks5, dst);
            const xk = $0d86ce4f5243a4d8$var$expandKeyLE(key);
            let i = 0;
            for(; i + 4 <= b.length;){
                const { s0: s0, s1: s1, s2: s2, s3: s3 } = $0d86ce4f5243a4d8$var$encrypt(xk, b[i + 0], b[i + 1], b[i + 2], b[i + 3]);
                o[i++] = s0, o[i++] = s1, o[i++] = s2, o[i++] = s3;
            }
            if (pcks5) {
                const tmp32 = $0d86ce4f5243a4d8$var$padPCKS(plaintext.subarray(i * 4));
                const { s0: s0, s1: s1, s2: s2, s3: s3 } = $0d86ce4f5243a4d8$var$encrypt(xk, tmp32[0], tmp32[1], tmp32[2], tmp32[3]);
                o[i++] = s0, o[i++] = s1, o[i++] = s2, o[i++] = s3;
            }
            (0, $104df8da2312fc03$export$cf0b2a6c63f9e656)(xk);
            return _out;
        },
        decrypt (ciphertext, dst) {
            $0d86ce4f5243a4d8$var$validateBlockDecrypt(ciphertext);
            const xk = $0d86ce4f5243a4d8$var$expandKeyDecLE(key);
            dst = (0, $104df8da2312fc03$export$e504884fb8831d9d)(ciphertext.length, dst);
            const toClean = [
                xk
            ];
            if (!(0, $104df8da2312fc03$export$c50aefb83d1cf2a2)(ciphertext)) toClean.push(ciphertext = (0, $104df8da2312fc03$export$56728fb2d7dba34e)(ciphertext));
            (0, $104df8da2312fc03$export$8ee902273e96266b)(ciphertext, dst);
            const b = (0, $104df8da2312fc03$export$8bacf4ad828c7fe7)(ciphertext);
            const o = (0, $104df8da2312fc03$export$8bacf4ad828c7fe7)(dst);
            for(let i = 0; i + 4 <= b.length;){
                const { s0: s0, s1: s1, s2: s2, s3: s3 } = $0d86ce4f5243a4d8$var$decrypt(xk, b[i + 0], b[i + 1], b[i + 2], b[i + 3]);
                o[i++] = s0, o[i++] = s1, o[i++] = s2, o[i++] = s3;
            }
            (0, $104df8da2312fc03$export$cf0b2a6c63f9e656)(...toClean);
            return $0d86ce4f5243a4d8$var$validatePCKS(dst, pcks5);
        }
    };
});
const $0d86ce4f5243a4d8$export$f98efb84b25ee206 = /* @__PURE__ */ (0, $104df8da2312fc03$export$9a6138f9eba70f82)({
    blockSize: 16,
    nonceLength: 16
}, function aescbc(key, iv, opts = {}) {
    const pcks5 = !opts.disablePadding;
    return {
        encrypt (plaintext, dst) {
            const xk = $0d86ce4f5243a4d8$var$expandKeyLE(key);
            const { b: b, o: o, out: _out } = $0d86ce4f5243a4d8$var$validateBlockEncrypt(plaintext, pcks5, dst);
            let _iv = iv;
            const toClean = [
                xk
            ];
            if (!(0, $104df8da2312fc03$export$c50aefb83d1cf2a2)(_iv)) toClean.push(_iv = (0, $104df8da2312fc03$export$56728fb2d7dba34e)(_iv));
            const n32 = (0, $104df8da2312fc03$export$8bacf4ad828c7fe7)(_iv);
            // prettier-ignore
            let s0 = n32[0], s1 = n32[1], s2 = n32[2], s3 = n32[3];
            let i = 0;
            for(; i + 4 <= b.length;){
                s0 ^= b[i + 0], s1 ^= b[i + 1], s2 ^= b[i + 2], s3 ^= b[i + 3];
                ({ s0: s0, s1: s1, s2: s2, s3: s3 } = $0d86ce4f5243a4d8$var$encrypt(xk, s0, s1, s2, s3));
                o[i++] = s0, o[i++] = s1, o[i++] = s2, o[i++] = s3;
            }
            if (pcks5) {
                const tmp32 = $0d86ce4f5243a4d8$var$padPCKS(plaintext.subarray(i * 4));
                s0 ^= tmp32[0], s1 ^= tmp32[1], s2 ^= tmp32[2], s3 ^= tmp32[3];
                ({ s0: s0, s1: s1, s2: s2, s3: s3 } = $0d86ce4f5243a4d8$var$encrypt(xk, s0, s1, s2, s3));
                o[i++] = s0, o[i++] = s1, o[i++] = s2, o[i++] = s3;
            }
            (0, $104df8da2312fc03$export$cf0b2a6c63f9e656)(...toClean);
            return _out;
        },
        decrypt (ciphertext, dst) {
            $0d86ce4f5243a4d8$var$validateBlockDecrypt(ciphertext);
            const xk = $0d86ce4f5243a4d8$var$expandKeyDecLE(key);
            let _iv = iv;
            const toClean = [
                xk
            ];
            if (!(0, $104df8da2312fc03$export$c50aefb83d1cf2a2)(_iv)) toClean.push(_iv = (0, $104df8da2312fc03$export$56728fb2d7dba34e)(_iv));
            const n32 = (0, $104df8da2312fc03$export$8bacf4ad828c7fe7)(_iv);
            dst = (0, $104df8da2312fc03$export$e504884fb8831d9d)(ciphertext.length, dst);
            if (!(0, $104df8da2312fc03$export$c50aefb83d1cf2a2)(ciphertext)) toClean.push(ciphertext = (0, $104df8da2312fc03$export$56728fb2d7dba34e)(ciphertext));
            (0, $104df8da2312fc03$export$8ee902273e96266b)(ciphertext, dst);
            const b = (0, $104df8da2312fc03$export$8bacf4ad828c7fe7)(ciphertext);
            const o = (0, $104df8da2312fc03$export$8bacf4ad828c7fe7)(dst);
            // prettier-ignore
            let s0 = n32[0], s1 = n32[1], s2 = n32[2], s3 = n32[3];
            for(let i = 0; i + 4 <= b.length;){
                // prettier-ignore
                const ps0 = s0, ps1 = s1, ps2 = s2, ps3 = s3;
                s0 = b[i + 0], s1 = b[i + 1], s2 = b[i + 2], s3 = b[i + 3];
                const { s0: o0, s1: o1, s2: o2, s3: o3 } = $0d86ce4f5243a4d8$var$decrypt(xk, s0, s1, s2, s3);
                o[i++] = o0 ^ ps0, o[i++] = o1 ^ ps1, o[i++] = o2 ^ ps2, o[i++] = o3 ^ ps3;
            }
            (0, $104df8da2312fc03$export$cf0b2a6c63f9e656)(...toClean);
            return $0d86ce4f5243a4d8$var$validatePCKS(dst, pcks5);
        }
    };
});
const $0d86ce4f5243a4d8$export$385fe64256455ced = /* @__PURE__ */ (0, $104df8da2312fc03$export$9a6138f9eba70f82)({
    blockSize: 16,
    nonceLength: 16
}, function aescfb(key, iv) {
    function processCfb(src, isEncrypt, dst) {
        (0, $104df8da2312fc03$export$e8a750b9efad93f5)(src);
        const srcLen = src.length;
        dst = (0, $104df8da2312fc03$export$e504884fb8831d9d)(srcLen, dst);
        if ((0, $104df8da2312fc03$export$8a4fd82309bf1d6a)(src, dst)) throw new Error('overlapping src and dst not supported.');
        const xk = $0d86ce4f5243a4d8$var$expandKeyLE(key);
        let _iv = iv;
        const toClean = [
            xk
        ];
        if (!(0, $104df8da2312fc03$export$c50aefb83d1cf2a2)(_iv)) toClean.push(_iv = (0, $104df8da2312fc03$export$56728fb2d7dba34e)(_iv));
        if (!(0, $104df8da2312fc03$export$c50aefb83d1cf2a2)(src)) toClean.push(src = (0, $104df8da2312fc03$export$56728fb2d7dba34e)(src));
        const src32 = (0, $104df8da2312fc03$export$8bacf4ad828c7fe7)(src);
        const dst32 = (0, $104df8da2312fc03$export$8bacf4ad828c7fe7)(dst);
        const next32 = isEncrypt ? dst32 : src32;
        const n32 = (0, $104df8da2312fc03$export$8bacf4ad828c7fe7)(_iv);
        // prettier-ignore
        let s0 = n32[0], s1 = n32[1], s2 = n32[2], s3 = n32[3];
        for(let i = 0; i + 4 <= src32.length;){
            const { s0: e0, s1: e1, s2: e2, s3: e3 } = $0d86ce4f5243a4d8$var$encrypt(xk, s0, s1, s2, s3);
            dst32[i + 0] = src32[i + 0] ^ e0;
            dst32[i + 1] = src32[i + 1] ^ e1;
            dst32[i + 2] = src32[i + 2] ^ e2;
            dst32[i + 3] = src32[i + 3] ^ e3;
            s0 = next32[i++], s1 = next32[i++], s2 = next32[i++], s3 = next32[i++];
        }
        // leftovers (less than block)
        const start = $0d86ce4f5243a4d8$var$BLOCK_SIZE * Math.floor(src32.length / $0d86ce4f5243a4d8$var$BLOCK_SIZE32);
        if (start < srcLen) {
            ({ s0: s0, s1: s1, s2: s2, s3: s3 } = $0d86ce4f5243a4d8$var$encrypt(xk, s0, s1, s2, s3));
            const buf = (0, $104df8da2312fc03$export$9813fca58c0b9f71)(new Uint32Array([
                s0,
                s1,
                s2,
                s3
            ]));
            for(let i = start, pos = 0; i < srcLen; i++, pos++)dst[i] = src[i] ^ buf[pos];
            (0, $104df8da2312fc03$export$cf0b2a6c63f9e656)(buf);
        }
        (0, $104df8da2312fc03$export$cf0b2a6c63f9e656)(...toClean);
        return dst;
    }
    return {
        encrypt: (plaintext, dst)=>processCfb(plaintext, true, dst),
        decrypt: (ciphertext, dst)=>processCfb(ciphertext, false, dst)
    };
});
// TODO: merge with chacha, however gcm has bitLen while chacha has byteLen
function $0d86ce4f5243a4d8$var$computeTag(fn, isLE, key, data, AAD) {
    const aadLength = AAD ? AAD.length : 0;
    const h = fn.create(key, data.length + aadLength);
    if (AAD) h.update(AAD);
    const num = (0, $104df8da2312fc03$export$342c09f6517ae3b8)(8 * data.length, 8 * aadLength, isLE);
    h.update(data);
    h.update(num);
    const res = h.digest();
    (0, $104df8da2312fc03$export$cf0b2a6c63f9e656)(num);
    return res;
}
const $0d86ce4f5243a4d8$export$1c2d3f5179fe12a4 = /* @__PURE__ */ (0, $104df8da2312fc03$export$9a6138f9eba70f82)({
    blockSize: 16,
    nonceLength: 12,
    tagLength: 16,
    varSizeNonce: true
}, function aesgcm(key, nonce, AAD) {
    // NIST 800-38d doesn't enforce minimum nonce length.
    // We enforce 8 bytes for compat with openssl.
    // 12 bytes are recommended. More than 12 bytes would be converted into 12.
    if (nonce.length < 8) throw new Error('aes/gcm: invalid nonce length');
    const tagLength = 16;
    function _computeTag(authKey, tagMask, data) {
        const tag = $0d86ce4f5243a4d8$var$computeTag((0, $2d3326bc82ba9784$export$f562b99c67f83a33), false, authKey, data, AAD);
        for(let i = 0; i < tagMask.length; i++)tag[i] ^= tagMask[i];
        return tag;
    }
    function deriveKeys() {
        const xk = $0d86ce4f5243a4d8$var$expandKeyLE(key);
        const authKey = $0d86ce4f5243a4d8$var$EMPTY_BLOCK.slice();
        const counter = $0d86ce4f5243a4d8$var$EMPTY_BLOCK.slice();
        $0d86ce4f5243a4d8$var$ctr32(xk, false, counter, counter, authKey);
        // NIST 800-38d, page 15: different behavior for 96-bit and non-96-bit nonces
        if (nonce.length === 12) counter.set(nonce);
        else {
            const nonceLen = $0d86ce4f5243a4d8$var$EMPTY_BLOCK.slice();
            const view = (0, $104df8da2312fc03$export$d7febe7b891e79f0)(nonceLen);
            (0, $104df8da2312fc03$export$b13f930c762582ab)(view, 8, BigInt(nonce.length * 8), false);
            // ghash(nonce || u64be(0) || u64be(nonceLen*8))
            const g = (0, $2d3326bc82ba9784$export$f562b99c67f83a33).create(authKey).update(nonce).update(nonceLen);
            g.digestInto(counter); // digestInto doesn't trigger '.destroy'
            g.destroy();
        }
        const tagMask = $0d86ce4f5243a4d8$var$ctr32(xk, false, counter, $0d86ce4f5243a4d8$var$EMPTY_BLOCK);
        return {
            xk: xk,
            authKey: authKey,
            counter: counter,
            tagMask: tagMask
        };
    }
    return {
        encrypt (plaintext) {
            const { xk: xk, authKey: authKey, counter: counter, tagMask: tagMask } = deriveKeys();
            const out = new Uint8Array(plaintext.length + tagLength);
            const toClean = [
                xk,
                authKey,
                counter,
                tagMask
            ];
            if (!(0, $104df8da2312fc03$export$c50aefb83d1cf2a2)(plaintext)) toClean.push(plaintext = (0, $104df8da2312fc03$export$56728fb2d7dba34e)(plaintext));
            $0d86ce4f5243a4d8$var$ctr32(xk, false, counter, plaintext, out.subarray(0, plaintext.length));
            const tag = _computeTag(authKey, tagMask, out.subarray(0, out.length - tagLength));
            toClean.push(tag);
            out.set(tag, plaintext.length);
            (0, $104df8da2312fc03$export$cf0b2a6c63f9e656)(...toClean);
            return out;
        },
        decrypt (ciphertext) {
            const { xk: xk, authKey: authKey, counter: counter, tagMask: tagMask } = deriveKeys();
            const toClean = [
                xk,
                authKey,
                tagMask,
                counter
            ];
            if (!(0, $104df8da2312fc03$export$c50aefb83d1cf2a2)(ciphertext)) toClean.push(ciphertext = (0, $104df8da2312fc03$export$56728fb2d7dba34e)(ciphertext));
            const data = ciphertext.subarray(0, -tagLength);
            const passedTag = ciphertext.subarray(-tagLength);
            const tag = _computeTag(authKey, tagMask, data);
            toClean.push(tag);
            if (!(0, $104df8da2312fc03$export$2aa59cef064b0333)(tag, passedTag)) throw new Error('aes/gcm: invalid ghash tag');
            const out = $0d86ce4f5243a4d8$var$ctr32(xk, false, counter, data);
            (0, $104df8da2312fc03$export$cf0b2a6c63f9e656)(...toClean);
            return out;
        }
    };
});
const $0d86ce4f5243a4d8$var$limit = (name, min, max)=>(value)=>{
        if (!Number.isSafeInteger(value) || min > value || value > max) {
            const minmax = '[' + min + '..' + max + ']';
            throw new Error('' + name + ': expected value in range ' + minmax + ', got ' + value);
        }
    };
const $0d86ce4f5243a4d8$export$d27cb3d8a42e5ca1 = /* @__PURE__ */ (0, $104df8da2312fc03$export$9a6138f9eba70f82)({
    blockSize: 16,
    nonceLength: 12,
    tagLength: 16,
    varSizeNonce: true
}, function aessiv(key, nonce, AAD) {
    const tagLength = 16;
    // From RFC 8452: Section 6
    const AAD_LIMIT = $0d86ce4f5243a4d8$var$limit('AAD', 0, 2 ** 36);
    const PLAIN_LIMIT = $0d86ce4f5243a4d8$var$limit('plaintext', 0, 2 ** 36);
    const NONCE_LIMIT = $0d86ce4f5243a4d8$var$limit('nonce', 12, 12);
    const CIPHER_LIMIT = $0d86ce4f5243a4d8$var$limit('ciphertext', 16, 2 ** 36 + 16);
    (0, $104df8da2312fc03$export$e8a750b9efad93f5)(key, 16, 24, 32);
    NONCE_LIMIT(nonce.length);
    if (AAD !== undefined) AAD_LIMIT(AAD.length);
    function deriveKeys() {
        const xk = $0d86ce4f5243a4d8$var$expandKeyLE(key);
        const encKey = new Uint8Array(key.length);
        const authKey = new Uint8Array(16);
        const toClean = [
            xk,
            encKey
        ];
        let _nonce = nonce;
        if (!(0, $104df8da2312fc03$export$c50aefb83d1cf2a2)(_nonce)) toClean.push(_nonce = (0, $104df8da2312fc03$export$56728fb2d7dba34e)(_nonce));
        const n32 = (0, $104df8da2312fc03$export$8bacf4ad828c7fe7)(_nonce);
        // prettier-ignore
        let s0 = 0, s1 = n32[0], s2 = n32[1], s3 = n32[2];
        let counter = 0;
        for (const derivedKey of [
            authKey,
            encKey
        ].map((0, $104df8da2312fc03$export$8bacf4ad828c7fe7))){
            const d32 = (0, $104df8da2312fc03$export$8bacf4ad828c7fe7)(derivedKey);
            for(let i = 0; i < d32.length; i += 2){
                // aes(u32le(0) || nonce)[:8] || aes(u32le(1) || nonce)[:8] ...
                const { s0: o0, s1: o1 } = $0d86ce4f5243a4d8$var$encrypt(xk, s0, s1, s2, s3);
                d32[i + 0] = o0;
                d32[i + 1] = o1;
                s0 = ++counter; // increment counter inside state
            }
        }
        const res = {
            authKey: authKey,
            encKey: $0d86ce4f5243a4d8$var$expandKeyLE(encKey)
        };
        // Cleanup
        (0, $104df8da2312fc03$export$cf0b2a6c63f9e656)(...toClean);
        return res;
    }
    function _computeTag(encKey, authKey, data) {
        const tag = $0d86ce4f5243a4d8$var$computeTag((0, $2d3326bc82ba9784$export$4dd5f33d13f59946), true, authKey, data, AAD);
        // Compute the expected tag by XORing S_s and the nonce, clearing the
        // most significant bit of the last byte and encrypting with the
        // message-encryption key.
        for(let i = 0; i < 12; i++)tag[i] ^= nonce[i];
        tag[15] &= 0x7f; // Clear the highest bit
        // encrypt tag as block
        const t32 = (0, $104df8da2312fc03$export$8bacf4ad828c7fe7)(tag);
        // prettier-ignore
        let s0 = t32[0], s1 = t32[1], s2 = t32[2], s3 = t32[3];
        ({ s0: s0, s1: s1, s2: s2, s3: s3 } = $0d86ce4f5243a4d8$var$encrypt(encKey, s0, s1, s2, s3));
        t32[0] = s0, t32[1] = s1, t32[2] = s2, t32[3] = s3;
        return tag;
    }
    // actual decrypt/encrypt of message.
    function processSiv(encKey, tag, input) {
        let block = (0, $104df8da2312fc03$export$56728fb2d7dba34e)(tag);
        block[15] |= 0x80; // Force highest bit
        const res = $0d86ce4f5243a4d8$var$ctr32(encKey, true, block, input);
        // Cleanup
        (0, $104df8da2312fc03$export$cf0b2a6c63f9e656)(block);
        return res;
    }
    return {
        encrypt (plaintext) {
            PLAIN_LIMIT(plaintext.length);
            const { encKey: encKey, authKey: authKey } = deriveKeys();
            const tag = _computeTag(encKey, authKey, plaintext);
            const toClean = [
                encKey,
                authKey,
                tag
            ];
            if (!(0, $104df8da2312fc03$export$c50aefb83d1cf2a2)(plaintext)) toClean.push(plaintext = (0, $104df8da2312fc03$export$56728fb2d7dba34e)(plaintext));
            const out = new Uint8Array(plaintext.length + tagLength);
            out.set(tag, plaintext.length);
            out.set(processSiv(encKey, tag, plaintext));
            // Cleanup
            (0, $104df8da2312fc03$export$cf0b2a6c63f9e656)(...toClean);
            return out;
        },
        decrypt (ciphertext) {
            CIPHER_LIMIT(ciphertext.length);
            const tag = ciphertext.subarray(-tagLength);
            const { encKey: encKey, authKey: authKey } = deriveKeys();
            const toClean = [
                encKey,
                authKey
            ];
            if (!(0, $104df8da2312fc03$export$c50aefb83d1cf2a2)(ciphertext)) toClean.push(ciphertext = (0, $104df8da2312fc03$export$56728fb2d7dba34e)(ciphertext));
            const plaintext = processSiv(encKey, tag, ciphertext.subarray(0, -tagLength));
            const expectedTag = _computeTag(encKey, authKey, plaintext);
            toClean.push(expectedTag);
            if (!(0, $104df8da2312fc03$export$2aa59cef064b0333)(tag, expectedTag)) {
                (0, $104df8da2312fc03$export$cf0b2a6c63f9e656)(...toClean);
                throw new Error('invalid polyval tag');
            }
            // Cleanup
            (0, $104df8da2312fc03$export$cf0b2a6c63f9e656)(...toClean);
            return plaintext;
        }
    };
});
const $0d86ce4f5243a4d8$export$f45e8835a0f9974d = $0d86ce4f5243a4d8$export$d27cb3d8a42e5ca1;
function $0d86ce4f5243a4d8$var$isBytes32(a) {
    return a instanceof Uint32Array || ArrayBuffer.isView(a) && a.constructor.name === 'Uint32Array';
}
function $0d86ce4f5243a4d8$var$encryptBlock(xk, block) {
    (0, $104df8da2312fc03$export$e8a750b9efad93f5)(block, 16);
    if (!$0d86ce4f5243a4d8$var$isBytes32(xk)) throw new Error('_encryptBlock accepts result of expandKeyLE');
    const b32 = (0, $104df8da2312fc03$export$8bacf4ad828c7fe7)(block);
    let { s0: s0, s1: s1, s2: s2, s3: s3 } = $0d86ce4f5243a4d8$var$encrypt(xk, b32[0], b32[1], b32[2], b32[3]);
    b32[0] = s0, b32[1] = s1, b32[2] = s2, b32[3] = s3;
    return block;
}
function $0d86ce4f5243a4d8$var$decryptBlock(xk, block) {
    (0, $104df8da2312fc03$export$e8a750b9efad93f5)(block, 16);
    if (!$0d86ce4f5243a4d8$var$isBytes32(xk)) throw new Error('_decryptBlock accepts result of expandKeyLE');
    const b32 = (0, $104df8da2312fc03$export$8bacf4ad828c7fe7)(block);
    let { s0: s0, s1: s1, s2: s2, s3: s3 } = $0d86ce4f5243a4d8$var$decrypt(xk, b32[0], b32[1], b32[2], b32[3]);
    b32[0] = s0, b32[1] = s1, b32[2] = s2, b32[3] = s3;
    return block;
}
/**
 * AES-W (base for AESKW/AESKWP).
 * Specs: [SP800-38F](https://nvlpubs.nist.gov/nistpubs/SpecialPublications/NIST.SP.800-38F.pdf),
 * [RFC 3394](https://datatracker.ietf.org/doc/rfc3394/),
 * [RFC 5649](https://datatracker.ietf.org/doc/rfc5649/).
 */ const $0d86ce4f5243a4d8$var$AESW = {
    /*
    High-level pseudocode:
    ```
    A: u64 = IV
    out = []
    for (let i=0, ctr = 0; i<6; i++) {
      for (const chunk of chunks(plaintext, 8)) {
        A ^= swapEndianess(ctr++)
        [A, res] = chunks(encrypt(A || chunk), 8);
        out ||= res
      }
    }
    out = A || out
    ```
    Decrypt is the same, but reversed.
    */ encrypt (kek, out) {
        // Size is limited to 4GB, otherwise ctr will overflow and we'll need to switch to bigints.
        // If you need it larger, open an issue.
        if (out.length >= 2 ** 32) throw new Error('plaintext should be less than 4gb');
        const xk = $0d86ce4f5243a4d8$var$expandKeyLE(kek);
        if (out.length === 16) $0d86ce4f5243a4d8$var$encryptBlock(xk, out);
        else {
            const o32 = (0, $104df8da2312fc03$export$8bacf4ad828c7fe7)(out);
            // prettier-ignore
            let a0 = o32[0], a1 = o32[1]; // A
            for(let j = 0, ctr = 1; j < 6; j++)for(let pos = 2; pos < o32.length; pos += 2, ctr++){
                const { s0: s0, s1: s1, s2: s2, s3: s3 } = $0d86ce4f5243a4d8$var$encrypt(xk, a0, a1, o32[pos], o32[pos + 1]);
                // A = MSB(64, B) ^ t where t = (n*j)+i
                a0 = s0, a1 = s1 ^ $0d86ce4f5243a4d8$var$byteSwap(ctr), o32[pos] = s2, o32[pos + 1] = s3;
            }
            o32[0] = a0, o32[1] = a1; // out = A || out
        }
        xk.fill(0);
    },
    decrypt (kek, out) {
        if (out.length - 8 >= 2 ** 32) throw new Error('ciphertext should be less than 4gb');
        const xk = $0d86ce4f5243a4d8$var$expandKeyDecLE(kek);
        const chunks = out.length / 8 - 1; // first chunk is IV
        if (chunks === 1) $0d86ce4f5243a4d8$var$decryptBlock(xk, out);
        else {
            const o32 = (0, $104df8da2312fc03$export$8bacf4ad828c7fe7)(out);
            // prettier-ignore
            let a0 = o32[0], a1 = o32[1]; // A
            for(let j = 0, ctr = chunks * 6; j < 6; j++)for(let pos = chunks * 2; pos >= 1; pos -= 2, ctr--){
                a1 ^= $0d86ce4f5243a4d8$var$byteSwap(ctr);
                const { s0: s0, s1: s1, s2: s2, s3: s3 } = $0d86ce4f5243a4d8$var$decrypt(xk, a0, a1, o32[pos], o32[pos + 1]);
                a0 = s0, a1 = s1, o32[pos] = s2, o32[pos + 1] = s3;
            }
            o32[0] = a0, o32[1] = a1;
        }
        xk.fill(0);
    }
};
const $0d86ce4f5243a4d8$var$AESKW_IV = /* @__PURE__ */ new Uint8Array(8).fill(0xa6); // A6A6A6A6A6A6A6A6
const $0d86ce4f5243a4d8$export$2d31b8efd960783 = /* @__PURE__ */ (0, $104df8da2312fc03$export$9a6138f9eba70f82)({
    blockSize: 8
}, (kek)=>({
        encrypt (plaintext) {
            if (!plaintext.length || plaintext.length % 8 !== 0) throw new Error('invalid plaintext length');
            if (plaintext.length === 8) throw new Error('8-byte keys not allowed in AESKW, use AESKWP instead');
            const out = (0, $104df8da2312fc03$export$287dd7971339c972)($0d86ce4f5243a4d8$var$AESKW_IV, plaintext);
            $0d86ce4f5243a4d8$var$AESW.encrypt(kek, out);
            return out;
        },
        decrypt (ciphertext) {
            // ciphertext must be at least 24 bytes and a multiple of 8 bytes
            // 24 because should have at least two block (1 iv + 2).
            // Replace with 16 to enable '8-byte keys'
            if (ciphertext.length % 8 !== 0 || ciphertext.length < 24) throw new Error('invalid ciphertext length');
            const out = (0, $104df8da2312fc03$export$56728fb2d7dba34e)(ciphertext);
            $0d86ce4f5243a4d8$var$AESW.decrypt(kek, out);
            if (!(0, $104df8da2312fc03$export$2aa59cef064b0333)(out.subarray(0, 8), $0d86ce4f5243a4d8$var$AESKW_IV)) throw new Error('integrity check failed');
            out.subarray(0, 8).fill(0); // ciphertext.subarray(0, 8) === IV, but we clean it anyway
            return out.subarray(8);
        }
    }));
/*
We don't support 8-byte keys. The rabbit hole:

- Wycheproof says: "NIST SP 800-38F does not define the wrapping of 8 byte keys.
  RFC 3394 Section 2  on the other hand specifies that 8 byte keys are wrapped
  by directly encrypting one block with AES."
    - https://github.com/C2SP/wycheproof/blob/master/doc/key_wrap.md
    - "RFC 3394 specifies in Section 2, that the input for the key wrap
      algorithm must be at least two blocks and otherwise the constant
      field and key are simply encrypted with ECB as a single block"
- What RFC 3394 actually says (in Section 2):
    - "Before being wrapped, the key data is parsed into n blocks of 64 bits.
      The only restriction the key wrap algorithm places on n is that n be
      at least two"
    - "For key data with length less than or equal to 64 bits, the constant
      field used in this specification and the key data form a single
      128-bit codebook input making this key wrap unnecessary."
- Which means "assert(n >= 2)" and "use something else for 8 byte keys"
- NIST SP800-38F actually prohibits 8-byte in "5.3.1 Mandatory Limits".
  It states that plaintext for KW should be "2 to 2^54 -1 semiblocks".
- So, where does "directly encrypt single block with AES" come from?
    - Not RFC 3394. Pseudocode of key wrap in 2.2 explicitly uses
      loop of 6 for any code path
    - There is a weird W3C spec:
      https://www.w3.org/TR/2002/REC-xmlenc-core-20021210/Overview.html#kw-aes128
    - This spec is outdated, as admitted by Wycheproof authors
    - There is RFC 5649 for padded key wrap, which is padding construction on
      top of AESKW. In '4.1.2' it says: "If the padded plaintext contains exactly
      eight octets, then prepend the AIV as defined in Section 3 above to P[1] and
      encrypt the resulting 128-bit block using AES in ECB mode [Modes] with key
      K (the KEK).  In this case, the output is two 64-bit blocks C[0] and C[1]:"
    - Browser subtle crypto is actually crashes on wrapping keys less than 16 bytes:
      `Error: error:1C8000E6:Provider routines::invalid input length] { opensslErrorStack: [ 'error:030000BD:digital envelope routines::update error' ]`

In the end, seems like a bug in Wycheproof.
The 8-byte check can be easily disabled inside of AES_W.
*/ const $0d86ce4f5243a4d8$var$AESKWP_IV = 0xa65959a6; // single u32le value
const $0d86ce4f5243a4d8$export$37b019a3c0609713 = /* @__PURE__ */ (0, $104df8da2312fc03$export$9a6138f9eba70f82)({
    blockSize: 8
}, (kek)=>({
        encrypt (plaintext) {
            if (!plaintext.length) throw new Error('invalid plaintext length');
            const padded = Math.ceil(plaintext.length / 8) * 8;
            const out = new Uint8Array(8 + padded);
            out.set(plaintext, 8);
            const out32 = (0, $104df8da2312fc03$export$8bacf4ad828c7fe7)(out);
            out32[0] = $0d86ce4f5243a4d8$var$AESKWP_IV;
            out32[1] = $0d86ce4f5243a4d8$var$byteSwap(plaintext.length);
            $0d86ce4f5243a4d8$var$AESW.encrypt(kek, out);
            return out;
        },
        decrypt (ciphertext) {
            // 16 because should have at least one block
            if (ciphertext.length < 16) throw new Error('invalid ciphertext length');
            const out = (0, $104df8da2312fc03$export$56728fb2d7dba34e)(ciphertext);
            const o32 = (0, $104df8da2312fc03$export$8bacf4ad828c7fe7)(out);
            $0d86ce4f5243a4d8$var$AESW.decrypt(kek, out);
            const len = $0d86ce4f5243a4d8$var$byteSwap(o32[1]) >>> 0;
            const padded = Math.ceil(len / 8) * 8;
            if (o32[0] !== $0d86ce4f5243a4d8$var$AESKWP_IV || out.length - 8 !== padded) throw new Error('integrity check failed');
            for(let i = len; i < padded; i++)if (out[8 + i] !== 0) throw new Error('integrity check failed');
            out.subarray(0, 8).fill(0); // ciphertext.subarray(0, 8) === IV, but we clean it anyway
            return out.subarray(8, 8 + len);
        }
    }));
const $0d86ce4f5243a4d8$export$aa1c11b655786597 = {
    expandKeyLE: $0d86ce4f5243a4d8$var$expandKeyLE,
    expandKeyDecLE: $0d86ce4f5243a4d8$var$expandKeyDecLE,
    encrypt: $0d86ce4f5243a4d8$var$encrypt,
    decrypt: $0d86ce4f5243a4d8$var$decrypt,
    encryptBlock: $0d86ce4f5243a4d8$var$encryptBlock,
    decryptBlock: $0d86ce4f5243a4d8$var$decryptBlock,
    ctrCounter: $0d86ce4f5243a4d8$var$ctrCounter,
    ctr32: $0d86ce4f5243a4d8$var$ctr32
};


// Node back-compat.
const $ddbeea1419c36d9b$var$ENCODING_MAPPING = {
    utf16le: 'utf-16le',
    ucs2: 'utf-16le',
    utf16be: 'utf-16be'
};
class $ddbeea1419c36d9b$export$c18b354bac7948e9 {
    constructor(buffer){
        this.buffer = buffer;
        this.view = new DataView(buffer.buffer, buffer.byteOffset, buffer.byteLength);
        this.pos = 0;
        this.length = this.buffer.length;
    }
    readString(length, encoding = 'ascii') {
        encoding = $ddbeea1419c36d9b$var$ENCODING_MAPPING[encoding] || encoding;
        let buf = this.readBuffer(length);
        try {
            let decoder = new TextDecoder(encoding);
            return decoder.decode(buf);
        } catch (err) {
            return buf;
        }
    }
    readBuffer(length) {
        return this.buffer.slice(this.pos, this.pos += length);
    }
    readUInt24BE() {
        return (this.readUInt16BE() << 8) + this.readUInt8();
    }
    readUInt24LE() {
        return this.readUInt16LE() + (this.readUInt8() << 16);
    }
    readInt24BE() {
        return (this.readInt16BE() << 8) + this.readUInt8();
    }
    readInt24LE() {
        return this.readUInt16LE() + (this.readInt8() << 16);
    }
}
$ddbeea1419c36d9b$export$c18b354bac7948e9.TYPES = {
    UInt8: 1,
    UInt16: 2,
    UInt24: 3,
    UInt32: 4,
    Int8: 1,
    Int16: 2,
    Int24: 3,
    Int32: 4,
    Float: 4,
    Double: 8
};
for (let key of Object.getOwnPropertyNames(DataView.prototype))if (key.slice(0, 3) === 'get') {
    let type = key.slice(3).replace('Ui', 'UI');
    if (type === 'Float32') type = 'Float';
    else if (type === 'Float64') type = 'Double';
    let bytes = $ddbeea1419c36d9b$export$c18b354bac7948e9.TYPES[type];
    $ddbeea1419c36d9b$export$c18b354bac7948e9.prototype['read' + type + (bytes === 1 ? '' : 'BE')] = function() {
        const ret = this.view[key](this.pos, false);
        this.pos += bytes;
        return ret;
    };
    if (bytes !== 1) $ddbeea1419c36d9b$export$c18b354bac7948e9.prototype['read' + type + 'LE'] = function() {
        const ret = this.view[key](this.pos, true);
        this.pos += bytes;
        return ret;
    };
}


const $68a919ce215921d9$var$textEncoder = new TextEncoder();
const $68a919ce215921d9$var$isBigEndian = new Uint8Array(new Uint16Array([
    0x1234
]).buffer)[0] == 0x12;
class $68a919ce215921d9$export$9b4f661deaa36c3e {
    constructor(buffer){
        this.buffer = buffer;
        this.view = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
        this.pos = 0;
    }
    writeBuffer(buffer) {
        this.buffer.set(buffer, this.pos);
        this.pos += buffer.length;
    }
    writeString(string, encoding = 'ascii') {
        let buf;
        switch(encoding){
            case 'utf16le':
            case 'utf16-le':
            case 'ucs2':
                buf = $68a919ce215921d9$var$stringToUtf16(string, $68a919ce215921d9$var$isBigEndian);
                break;
            case 'utf16be':
            case 'utf16-be':
                buf = $68a919ce215921d9$var$stringToUtf16(string, !$68a919ce215921d9$var$isBigEndian);
                break;
            case 'utf8':
                buf = $68a919ce215921d9$var$textEncoder.encode(string);
                break;
            case 'ascii':
                buf = $68a919ce215921d9$var$stringToAscii(string);
                break;
            default:
                throw new Error(`Unsupported encoding: ${encoding}`);
        }
        this.writeBuffer(buf);
    }
    writeUInt24BE(val) {
        this.buffer[this.pos++] = val >>> 16 & 0xff;
        this.buffer[this.pos++] = val >>> 8 & 0xff;
        this.buffer[this.pos++] = val & 0xff;
    }
    writeUInt24LE(val) {
        this.buffer[this.pos++] = val & 0xff;
        this.buffer[this.pos++] = val >>> 8 & 0xff;
        this.buffer[this.pos++] = val >>> 16 & 0xff;
    }
    writeInt24BE(val) {
        if (val >= 0) this.writeUInt24BE(val);
        else this.writeUInt24BE(val + 0xffffff + 1);
    }
    writeInt24LE(val) {
        if (val >= 0) this.writeUInt24LE(val);
        else this.writeUInt24LE(val + 0xffffff + 1);
    }
    fill(val, length) {
        if (length < this.buffer.length) {
            this.buffer.fill(val, this.pos, this.pos + length);
            this.pos += length;
        } else {
            const buf = new Uint8Array(length);
            buf.fill(val);
            this.writeBuffer(buf);
        }
    }
}
function $68a919ce215921d9$var$stringToUtf16(string, swap) {
    let buf = new Uint16Array(string.length);
    for(let i = 0; i < string.length; i++){
        let code = string.charCodeAt(i);
        if (swap) code = code >> 8 | (code & 0xff) << 8;
        buf[i] = code;
    }
    return new Uint8Array(buf.buffer);
}
function $68a919ce215921d9$var$stringToAscii(string) {
    let buf = new Uint8Array(string.length);
    for(let i = 0; i < string.length; i++)// Match node.js behavior - encoding allows 8-bit rather than 7-bit.
    buf[i] = string.charCodeAt(i);
    return buf;
}
for (let key of Object.getOwnPropertyNames(DataView.prototype))if (key.slice(0, 3) === 'set') {
    let type = key.slice(3).replace('Ui', 'UI');
    if (type === 'Float32') type = 'Float';
    else if (type === 'Float64') type = 'Double';
    let bytes = (0, $ddbeea1419c36d9b$export$c18b354bac7948e9).TYPES[type];
    $68a919ce215921d9$export$9b4f661deaa36c3e.prototype['write' + type + (bytes === 1 ? '' : 'BE')] = function(value) {
        this.view[key](this.pos, value, false);
        this.pos += bytes;
    };
    if (bytes !== 1) $68a919ce215921d9$export$9b4f661deaa36c3e.prototype['write' + type + 'LE'] = function(value) {
        this.view[key](this.pos, value, true);
        this.pos += bytes;
    };
}





class $69b6396049c9443f$export$ef88aa0d34c34520 {
    fromBuffer(buffer) {
        let stream = new (0, $ddbeea1419c36d9b$export$c18b354bac7948e9)(buffer);
        return this.decode(stream);
    }
    toBuffer(value) {
        let size = this.size(value);
        let buffer = new Uint8Array(size);
        let stream = new (0, $68a919ce215921d9$export$9b4f661deaa36c3e)(buffer);
        this.encode(stream, value);
        return buffer;
    }
}




class $2b9a2a5e7d043014$export$fffa67e515d04022 extends (0, $69b6396049c9443f$export$ef88aa0d34c34520) {
    constructor(type, endian = 'BE'){
        super();
        this.type = type;
        this.endian = endian;
        this.fn = this.type;
        if (this.type[this.type.length - 1] !== '8') this.fn += this.endian;
    }
    size() {
        return (0, $ddbeea1419c36d9b$export$c18b354bac7948e9).TYPES[this.type];
    }
    decode(stream) {
        return stream[`read${this.fn}`]();
    }
    encode(stream, val) {
        return stream[`write${this.fn}`](val);
    }
}
const $2b9a2a5e7d043014$export$52e103c63c4e68cf = new $2b9a2a5e7d043014$export$fffa67e515d04022('UInt8');
const $2b9a2a5e7d043014$export$60dfe43c8297a8f8 = new $2b9a2a5e7d043014$export$fffa67e515d04022('UInt16', 'BE');
const $2b9a2a5e7d043014$export$56bd24b5a3ee8456 = $2b9a2a5e7d043014$export$60dfe43c8297a8f8;
const $2b9a2a5e7d043014$export$b92d76f0ca6d1789 = new $2b9a2a5e7d043014$export$fffa67e515d04022('UInt16', 'LE');
const $2b9a2a5e7d043014$export$255f45171f96b50c = new $2b9a2a5e7d043014$export$fffa67e515d04022('UInt24', 'BE');
const $2b9a2a5e7d043014$export$1925298fbd719b21 = $2b9a2a5e7d043014$export$255f45171f96b50c;
const $2b9a2a5e7d043014$export$758e1dafc8dc7271 = new $2b9a2a5e7d043014$export$fffa67e515d04022('UInt24', 'LE');
const $2b9a2a5e7d043014$export$74c16dba6c885532 = new $2b9a2a5e7d043014$export$fffa67e515d04022('UInt32', 'BE');
const $2b9a2a5e7d043014$export$de9ffb9418dd7d0d = $2b9a2a5e7d043014$export$74c16dba6c885532;
const $2b9a2a5e7d043014$export$5f744bb30a534bc9 = new $2b9a2a5e7d043014$export$fffa67e515d04022('UInt32', 'LE');
const $2b9a2a5e7d043014$export$5984f25eab09961f = new $2b9a2a5e7d043014$export$fffa67e515d04022('Int8');
const $2b9a2a5e7d043014$export$198ae7d10d26a900 = new $2b9a2a5e7d043014$export$fffa67e515d04022('Int16', 'BE');
const $2b9a2a5e7d043014$export$c35c15c7caeff2b6 = $2b9a2a5e7d043014$export$198ae7d10d26a900;
const $2b9a2a5e7d043014$export$399cc4b7169e5aed = new $2b9a2a5e7d043014$export$fffa67e515d04022('Int16', 'LE');
const $2b9a2a5e7d043014$export$3676d1f71eca2ec0 = new $2b9a2a5e7d043014$export$fffa67e515d04022('Int24', 'BE');
const $2b9a2a5e7d043014$export$73f695d681ac61f9 = $2b9a2a5e7d043014$export$3676d1f71eca2ec0;
const $2b9a2a5e7d043014$export$671f8672dbd40a4 = new $2b9a2a5e7d043014$export$fffa67e515d04022('Int24', 'LE');
const $2b9a2a5e7d043014$export$78a2ac3d09dd42d5 = new $2b9a2a5e7d043014$export$fffa67e515d04022('Int32', 'BE');
const $2b9a2a5e7d043014$export$1d95835383bb05a = $2b9a2a5e7d043014$export$78a2ac3d09dd42d5;
const $2b9a2a5e7d043014$export$5ec1f146e759329a = new $2b9a2a5e7d043014$export$fffa67e515d04022('Int32', 'LE');
const $2b9a2a5e7d043014$export$92b5c14c6abb5c97 = new $2b9a2a5e7d043014$export$fffa67e515d04022('Float', 'BE');
const $2b9a2a5e7d043014$export$6b5cd3983e3ee5ab = $2b9a2a5e7d043014$export$92b5c14c6abb5c97;
const $2b9a2a5e7d043014$export$6d20592bc4cb19d9 = new $2b9a2a5e7d043014$export$fffa67e515d04022('Float', 'LE');
const $2b9a2a5e7d043014$export$e50b9e97e4d43631 = new $2b9a2a5e7d043014$export$fffa67e515d04022('Double', 'BE');
const $2b9a2a5e7d043014$export$7b3cbda67be88f5f = $2b9a2a5e7d043014$export$e50b9e97e4d43631;
const $2b9a2a5e7d043014$export$6f53315aa512b751 = new $2b9a2a5e7d043014$export$fffa67e515d04022('Double', 'LE');
class $2b9a2a5e7d043014$export$13475bbd2a37a9b4 extends $2b9a2a5e7d043014$export$fffa67e515d04022 {
    constructor(size, endian, fracBits = size >> 1){
        super(`Int${size}`, endian);
        this._point = 1 << fracBits;
    }
    decode(stream) {
        return super.decode(stream) / this._point;
    }
    encode(stream, val) {
        return super.encode(stream, val * this._point | 0);
    }
}
const $2b9a2a5e7d043014$export$f87b441e6bd90278 = new $2b9a2a5e7d043014$export$13475bbd2a37a9b4(16, 'BE');
const $2b9a2a5e7d043014$export$a3abada75ef55921 = $2b9a2a5e7d043014$export$f87b441e6bd90278;
const $2b9a2a5e7d043014$export$3752a2886837dc22 = new $2b9a2a5e7d043014$export$13475bbd2a37a9b4(16, 'LE');
const $2b9a2a5e7d043014$export$dd71d8d9bc792632 = new $2b9a2a5e7d043014$export$13475bbd2a37a9b4(32, 'BE');
const $2b9a2a5e7d043014$export$e913265d48471f2d = $2b9a2a5e7d043014$export$dd71d8d9bc792632;
const $2b9a2a5e7d043014$export$7fc47db6a5fc8223 = new $2b9a2a5e7d043014$export$13475bbd2a37a9b4(32, 'LE');



function $69cd4678dd9eb847$export$83b6dc3503c1fda6(length, stream, parent) {
    let res;
    if (typeof length === 'number') res = length;
    else if (typeof length === 'function') res = length.call(parent, parent);
    else if (parent && typeof length === 'string') res = parent[length];
    else if (stream && length instanceof (0, $2b9a2a5e7d043014$export$fffa67e515d04022)) res = length.decode(stream);
    if (isNaN(res)) throw new Error('Not a fixed size');
    return res;
}
class $69cd4678dd9eb847$export$41705b1d644e0f14 {
    constructor(opts = {}){
        this.enumerable = true;
        this.configurable = true;
        for(let key in opts){
            const val = opts[key];
            this[key] = val;
        }
    }
}


class $089ebb4f86db9da2$export$c4be6576ca6fe4aa extends (0, $69b6396049c9443f$export$ef88aa0d34c34520) {
    constructor(type, length, lengthType = 'count'){
        super();
        this.type = type;
        this.length = length;
        this.lengthType = lengthType;
    }
    decode(stream, parent) {
        let length;
        const { pos: pos } = stream;
        const res = [];
        let ctx = parent;
        if (this.length != null) length = $69cd4678dd9eb847$export$83b6dc3503c1fda6(this.length, stream, parent);
        if (this.length instanceof (0, $2b9a2a5e7d043014$export$fffa67e515d04022)) {
            // define hidden properties
            Object.defineProperties(res, {
                parent: {
                    value: parent
                },
                _startOffset: {
                    value: pos
                },
                _currentOffset: {
                    value: 0,
                    writable: true
                },
                _length: {
                    value: length
                }
            });
            ctx = res;
        }
        if (length == null || this.lengthType === 'bytes') {
            const target = length != null ? stream.pos + length : (parent != null ? parent._length : undefined) ? parent._startOffset + parent._length : stream.length;
            while(stream.pos < target)res.push(this.type.decode(stream, ctx));
        } else for(let i = 0, end = length; i < end; i++)res.push(this.type.decode(stream, ctx));
        return res;
    }
    size(array, ctx, includePointers = true) {
        if (!array) return this.type.size(null, ctx) * $69cd4678dd9eb847$export$83b6dc3503c1fda6(this.length, null, ctx);
        let size = 0;
        if (this.length instanceof (0, $2b9a2a5e7d043014$export$fffa67e515d04022)) {
            size += this.length.size();
            ctx = {
                parent: ctx,
                pointerSize: 0
            };
        }
        for (let item of array)size += this.type.size(item, ctx);
        if (ctx && includePointers && this.length instanceof (0, $2b9a2a5e7d043014$export$fffa67e515d04022)) size += ctx.pointerSize;
        return size;
    }
    encode(stream, array, parent) {
        let ctx = parent;
        if (this.length instanceof (0, $2b9a2a5e7d043014$export$fffa67e515d04022)) {
            ctx = {
                pointers: [],
                startOffset: stream.pos,
                parent: parent
            };
            ctx.pointerOffset = stream.pos + this.size(array, ctx, false);
            this.length.encode(stream, array.length);
        }
        for (let item of array)this.type.encode(stream, item, ctx);
        if (this.length instanceof (0, $2b9a2a5e7d043014$export$fffa67e515d04022)) {
            let i = 0;
            while(i < ctx.pointers.length){
                const ptr = ctx.pointers[i++];
                ptr.type.encode(stream, ptr.val, ptr.parent);
            }
        }
    }
}





class $ed4a2faff705c483$export$5576c026028d4983 extends (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa) {
    decode(stream, parent) {
        const { pos: pos } = stream;
        const length = $69cd4678dd9eb847$export$83b6dc3503c1fda6(this.length, stream, parent);
        if (this.length instanceof (0, $2b9a2a5e7d043014$export$fffa67e515d04022)) parent = {
            parent: parent,
            _startOffset: pos,
            _currentOffset: 0,
            _length: length
        };
        const res = new $ed4a2faff705c483$var$LazyArrayValue(this.type, length, stream, parent);
        stream.pos += length * this.type.size(null, parent);
        return res;
    }
    size(val, ctx) {
        if (val instanceof $ed4a2faff705c483$var$LazyArrayValue) val = val.toArray();
        return super.size(val, ctx);
    }
    encode(stream, val, ctx) {
        if (val instanceof $ed4a2faff705c483$var$LazyArrayValue) val = val.toArray();
        return super.encode(stream, val, ctx);
    }
}
class $ed4a2faff705c483$var$LazyArrayValue {
    constructor(type, length, stream, ctx){
        this.type = type;
        this.length = length;
        this.stream = stream;
        this.ctx = ctx;
        this.base = this.stream.pos;
        this.items = [];
    }
    get(index) {
        if (index < 0 || index >= this.length) return undefined;
        if (this.items[index] == null) {
            const { pos: pos } = this.stream;
            this.stream.pos = this.base + this.type.size(null, this.ctx) * index;
            this.items[index] = this.type.decode(this.stream, this.ctx);
            this.stream.pos = pos;
        }
        return this.items[index];
    }
    toArray() {
        const result = [];
        for(let i = 0, end = this.length; i < end; i++)result.push(this.get(i));
        return result;
    }
}



class $701e08229fc30ff7$export$96b43b8a49f688ea extends (0, $69b6396049c9443f$export$ef88aa0d34c34520) {
    constructor(type, flags = []){
        super();
        this.type = type;
        this.flags = flags;
    }
    decode(stream) {
        const val = this.type.decode(stream);
        const res = {};
        for(let i = 0; i < this.flags.length; i++){
            const flag = this.flags[i];
            if (flag != null) res[flag] = !!(val & 1 << i);
        }
        return res;
    }
    size() {
        return this.type.size();
    }
    encode(stream, keys) {
        let val = 0;
        for(let i = 0; i < this.flags.length; i++){
            const flag = this.flags[i];
            if (flag != null) {
                if (keys[flag]) val |= 1 << i;
            }
        }
        return this.type.encode(stream, val);
    }
}



class $1bc4cfc021edd608$export$ff887cefee4d61ec extends (0, $69b6396049c9443f$export$ef88aa0d34c34520) {
    constructor(type){
        super();
        this.type = type;
    }
    decode(stream, parent) {
        return !!this.type.decode(stream, parent);
    }
    size(val, parent) {
        return this.type.size(val, parent);
    }
    encode(stream, val, parent) {
        return this.type.encode(stream, +val, parent);
    }
}





class $272db5812670c438$export$7d22a0eea6656474 extends (0, $69b6396049c9443f$export$ef88aa0d34c34520) {
    constructor(length){
        super();
        this.length = length;
    }
    decode(stream, parent) {
        const length = $69cd4678dd9eb847$export$83b6dc3503c1fda6(this.length, stream, parent);
        return stream.readBuffer(length);
    }
    size(val, parent) {
        if (!val) return $69cd4678dd9eb847$export$83b6dc3503c1fda6(this.length, null, parent);
        let len = val.length;
        if (this.length instanceof (0, $2b9a2a5e7d043014$export$fffa67e515d04022)) len += this.length.size();
        return len;
    }
    encode(stream, buf, parent) {
        if (this.length instanceof (0, $2b9a2a5e7d043014$export$fffa67e515d04022)) this.length.encode(stream, buf.length);
        return stream.writeBuffer(buf);
    }
}



class $7bd1b355091c7493$export$deb82508dd66d288 extends (0, $69b6396049c9443f$export$ef88aa0d34c34520) {
    constructor(type, options = []){
        super();
        this.type = type;
        this.options = options;
    }
    decode(stream) {
        const index = this.type.decode(stream);
        return this.options[index] || index;
    }
    size() {
        return this.type.size();
    }
    encode(stream, val) {
        const index = this.options.indexOf(val);
        if (index === -1) throw new Error(`Unknown option in enum: ${val}`);
        return this.type.encode(stream, index);
    }
}



class $72804d503192edec$export$7acb7b24c478f9c6 extends (0, $69b6396049c9443f$export$ef88aa0d34c34520) {
    constructor(type, condition = true){
        super();
        this.type = type;
        this.condition = condition;
    }
    decode(stream, parent) {
        let { condition: condition } = this;
        if (typeof condition === 'function') condition = condition.call(parent, parent);
        if (condition) return this.type.decode(stream, parent);
    }
    size(val, parent) {
        let { condition: condition } = this;
        if (typeof condition === 'function') condition = condition.call(parent, parent);
        if (condition) return this.type.size(val, parent);
        else return 0;
    }
    encode(stream, val, parent) {
        let { condition: condition } = this;
        if (typeof condition === 'function') condition = condition.call(parent, parent);
        if (condition) return this.type.encode(stream, val, parent);
    }
}




class $f612a7b97d3685e8$export$da9b5fe187a9aa1 extends (0, $69b6396049c9443f$export$ef88aa0d34c34520) {
    constructor(type, count = 1){
        super();
        this.type = type;
        this.count = count;
    }
    decode(stream, parent) {
        stream.pos += this.size(null, parent);
        return undefined;
    }
    size(data, parent) {
        const count = $69cd4678dd9eb847$export$83b6dc3503c1fda6(this.count, null, parent);
        return this.type.size() * count;
    }
    encode(stream, val, parent) {
        return stream.fill(0, this.size(val, parent));
    }
}





class $b2061d4384f873cb$export$89b8e0fa65f6a914 extends (0, $69b6396049c9443f$export$ef88aa0d34c34520) {
    constructor(length, encoding = 'ascii'){
        super();
        this.length = length;
        this.encoding = encoding;
    }
    decode(stream, parent) {
        let length, pos;
        let { encoding: encoding } = this;
        if (typeof encoding === 'function') encoding = encoding.call(parent, parent) || 'ascii';
        let width = $b2061d4384f873cb$var$encodingWidth(encoding);
        if (this.length != null) length = $69cd4678dd9eb847$export$83b6dc3503c1fda6(this.length, stream, parent);
        else {
            let buffer;
            ({ buffer: buffer, length: length, pos: pos } = stream);
            while(pos < length - width + 1 && (buffer[pos] !== 0x00 || width === 2 && buffer[pos + 1] !== 0x00))pos += width;
            length = pos - stream.pos;
        }
        const string = stream.readString(length, encoding);
        if (this.length == null && stream.pos < stream.length) stream.pos += width;
        return string;
    }
    size(val, parent) {
        // Use the defined value if no value was given
        if (val === undefined || val === null) return $69cd4678dd9eb847$export$83b6dc3503c1fda6(this.length, null, parent);
        let { encoding: encoding } = this;
        if (typeof encoding === 'function') encoding = encoding.call(parent != null ? parent.val : undefined, parent != null ? parent.val : undefined) || 'ascii';
        if (encoding === 'utf16be') encoding = 'utf16le';
        let size = $b2061d4384f873cb$var$byteLength(val, encoding);
        if (this.length instanceof (0, $2b9a2a5e7d043014$export$fffa67e515d04022)) size += this.length.size();
        if (this.length == null) size += $b2061d4384f873cb$var$encodingWidth(encoding);
        return size;
    }
    encode(stream, val, parent) {
        let { encoding: encoding } = this;
        if (typeof encoding === 'function') encoding = encoding.call(parent != null ? parent.val : undefined, parent != null ? parent.val : undefined) || 'ascii';
        if (this.length instanceof (0, $2b9a2a5e7d043014$export$fffa67e515d04022)) this.length.encode(stream, $b2061d4384f873cb$var$byteLength(val, encoding));
        stream.writeString(val, encoding);
        if (this.length == null) return $b2061d4384f873cb$var$encodingWidth(encoding) == 2 ? stream.writeUInt16LE(0x0000) : stream.writeUInt8(0x00);
    }
}
function $b2061d4384f873cb$var$encodingWidth(encoding) {
    switch(encoding){
        case 'ascii':
        case 'utf8':
            return 1;
        case 'utf16le':
        case 'utf16-le':
        case 'utf-16be':
        case 'utf-16le':
        case 'utf16be':
        case 'utf16-be':
        case 'ucs2':
            return 2;
        default:
            //TODO: assume all other encodings are 1-byters
            //throw new Error('Unknown encoding ' + encoding);
            return 1;
    }
}
function $b2061d4384f873cb$var$byteLength(string, encoding) {
    switch(encoding){
        case 'ascii':
            return string.length;
        case 'utf8':
            let len = 0;
            for(let i = 0; i < string.length; i++){
                let c = string.charCodeAt(i);
                if (c >= 0xd800 && c <= 0xdbff && i < string.length - 1) {
                    let c2 = string.charCodeAt(++i);
                    if ((c2 & 0xfc00) === 0xdc00) c = ((c & 0x3ff) << 10) + (c2 & 0x3ff) + 0x10000;
                    else // unmatched surrogate.
                    i--;
                }
                if ((c & 0xffffff80) === 0) len++;
                else if ((c & 0xfffff800) === 0) len += 2;
                else if ((c & 0xffff0000) === 0) len += 3;
                else if ((c & 0xffe00000) === 0) len += 4;
            }
            return len;
        case 'utf16le':
        case 'utf16-le':
        case 'utf16be':
        case 'utf16-be':
        case 'ucs2':
            return string.length * 2;
        default:
            throw new Error('Unknown encoding ' + encoding);
    }
}




class $e3f85bd82b272d37$export$eabc71f011df675a extends (0, $69b6396049c9443f$export$ef88aa0d34c34520) {
    constructor(fields = {}){
        super();
        this.fields = fields;
    }
    decode(stream, parent, length = 0) {
        const res = this._setup(stream, parent, length);
        this._parseFields(stream, res, this.fields);
        if (this.process != null) this.process.call(res, stream);
        return res;
    }
    _setup(stream, parent, length) {
        const res = {};
        // define hidden properties
        Object.defineProperties(res, {
            parent: {
                value: parent
            },
            _startOffset: {
                value: stream.pos
            },
            _currentOffset: {
                value: 0,
                writable: true
            },
            _length: {
                value: length
            }
        });
        return res;
    }
    _parseFields(stream, res, fields) {
        for(let key in fields){
            var val;
            const type = fields[key];
            if (typeof type === 'function') val = type.call(res, res);
            else val = type.decode(stream, res);
            if (val !== undefined) {
                if (val instanceof $69cd4678dd9eb847$export$41705b1d644e0f14) Object.defineProperty(res, key, val);
                else res[key] = val;
            }
            res._currentOffset = stream.pos - res._startOffset;
        }
    }
    size(val, parent, includePointers = true) {
        if (val == null) val = {};
        const ctx = {
            parent: parent,
            val: val,
            pointerSize: 0
        };
        if (this.preEncode != null) this.preEncode.call(val);
        let size = 0;
        for(let key in this.fields){
            const type = this.fields[key];
            if (type.size != null) size += type.size(val[key], ctx);
        }
        if (includePointers) size += ctx.pointerSize;
        return size;
    }
    encode(stream, val, parent) {
        let type;
        if (this.preEncode != null) this.preEncode.call(val, stream);
        const ctx = {
            pointers: [],
            startOffset: stream.pos,
            parent: parent,
            val: val,
            pointerSize: 0
        };
        ctx.pointerOffset = stream.pos + this.size(val, ctx, false);
        for(let key in this.fields){
            type = this.fields[key];
            if (type.encode != null) type.encode(stream, val[key], ctx);
        }
        let i = 0;
        while(i < ctx.pointers.length){
            const ptr = ctx.pointers[i++];
            ptr.type.encode(stream, ptr.val, ptr.parent);
        }
    }
}



const $00bf8c7e3dccf9c9$var$getPath = (object, pathArray)=>{
    return pathArray.reduce((prevObj, key)=>prevObj && prevObj[key], object);
};
class $00bf8c7e3dccf9c9$export$95a8b60f4da7dec8 extends (0, $e3f85bd82b272d37$export$eabc71f011df675a) {
    constructor(type, versions = {}){
        super();
        this.type = type;
        this.versions = versions;
        if (typeof type === 'string') this.versionPath = type.split('.');
    }
    decode(stream, parent, length = 0) {
        const res = this._setup(stream, parent, length);
        if (typeof this.type === 'string') res.version = $00bf8c7e3dccf9c9$var$getPath(parent, this.versionPath);
        else res.version = this.type.decode(stream);
        if (this.versions.header) this._parseFields(stream, res, this.versions.header);
        const fields = this.versions[res.version];
        if (fields == null) throw new Error(`Unknown version ${res.version}`);
        if (fields instanceof $00bf8c7e3dccf9c9$export$95a8b60f4da7dec8) return fields.decode(stream, parent);
        this._parseFields(stream, res, fields);
        if (this.process != null) this.process.call(res, stream);
        return res;
    }
    size(val, parent, includePointers = true) {
        let key, type;
        if (!val) throw new Error('Not a fixed size');
        if (this.preEncode != null) this.preEncode.call(val);
        const ctx = {
            parent: parent,
            val: val,
            pointerSize: 0
        };
        let size = 0;
        if (typeof this.type !== 'string') size += this.type.size(val.version, ctx);
        if (this.versions.header) for(key in this.versions.header){
            type = this.versions.header[key];
            if (type.size != null) size += type.size(val[key], ctx);
        }
        const fields = this.versions[val.version];
        if (fields == null) throw new Error(`Unknown version ${val.version}`);
        for(key in fields){
            type = fields[key];
            if (type.size != null) size += type.size(val[key], ctx);
        }
        if (includePointers) size += ctx.pointerSize;
        return size;
    }
    encode(stream, val, parent) {
        let key, type;
        if (this.preEncode != null) this.preEncode.call(val, stream);
        const ctx = {
            pointers: [],
            startOffset: stream.pos,
            parent: parent,
            val: val,
            pointerSize: 0
        };
        ctx.pointerOffset = stream.pos + this.size(val, ctx, false);
        if (typeof this.type !== 'string') this.type.encode(stream, val.version);
        if (this.versions.header) for(key in this.versions.header){
            type = this.versions.header[key];
            if (type.encode != null) type.encode(stream, val[key], ctx);
        }
        const fields = this.versions[val.version];
        for(key in fields){
            type = fields[key];
            if (type.encode != null) type.encode(stream, val[key], ctx);
        }
        let i = 0;
        while(i < ctx.pointers.length){
            const ptr = ctx.pointers[i++];
            ptr.type.encode(stream, ptr.val, ptr.parent);
        }
    }
}






class $19bca402104b2cc3$export$b56007f12edf0c17 extends (0, $69b6396049c9443f$export$ef88aa0d34c34520) {
    constructor(offsetType, type, options = {}){
        super();
        this.offsetType = offsetType;
        this.type = type;
        this.options = options;
        if (this.type === 'void') this.type = null;
        if (this.options.type == null) this.options.type = 'local';
        if (this.options.allowNull == null) this.options.allowNull = true;
        if (this.options.nullValue == null) this.options.nullValue = 0;
        if (this.options.lazy == null) this.options.lazy = false;
        if (this.options.relativeTo) {
            if (typeof this.options.relativeTo !== 'function') throw new Error('relativeTo option must be a function');
            this.relativeToGetter = options.relativeTo;
        }
    }
    decode(stream, ctx) {
        const offset = this.offsetType.decode(stream, ctx);
        // handle NULL pointers
        if (offset === this.options.nullValue && this.options.allowNull) return null;
        let relative;
        switch(this.options.type){
            case 'local':
                relative = ctx._startOffset;
                break;
            case 'immediate':
                relative = stream.pos - this.offsetType.size();
                break;
            case 'parent':
                relative = ctx.parent._startOffset;
                break;
            default:
                var c = ctx;
                while(c.parent)c = c.parent;
                relative = c._startOffset || 0;
        }
        if (this.options.relativeTo) relative += this.relativeToGetter(ctx);
        const ptr = offset + relative;
        if (this.type != null) {
            let val = null;
            const decodeValue = ()=>{
                if (val != null) return val;
                const { pos: pos } = stream;
                stream.pos = ptr;
                val = this.type.decode(stream, ctx);
                stream.pos = pos;
                return val;
            };
            // If this is a lazy pointer, define a getter to decode only when needed.
            // This obviously only works when the pointer is contained by a Struct.
            if (this.options.lazy) return new $69cd4678dd9eb847$export$41705b1d644e0f14({
                get: decodeValue
            });
            return decodeValue();
        } else return ptr;
    }
    size(val, ctx) {
        const parent = ctx;
        switch(this.options.type){
            case 'local':
            case 'immediate':
                break;
            case 'parent':
                ctx = ctx.parent;
                break;
            default:
                while(ctx.parent)ctx = ctx.parent;
        }
        let { type: type } = this;
        if (type == null) {
            if (!(val instanceof $19bca402104b2cc3$export$df5cb1f3d04f5a0f)) throw new Error("Must be a VoidPointer");
            ({ type: type } = val);
            val = val.value;
        }
        if (val && ctx) {
            // Must be written as two separate lines rather than += in case `type.size` mutates ctx.pointerSize.
            let size = type.size(val, parent);
            ctx.pointerSize += size;
        }
        return this.offsetType.size();
    }
    encode(stream, val, ctx) {
        let relative;
        const parent = ctx;
        if (val == null) {
            this.offsetType.encode(stream, this.options.nullValue);
            return;
        }
        switch(this.options.type){
            case 'local':
                relative = ctx.startOffset;
                break;
            case 'immediate':
                relative = stream.pos + this.offsetType.size(val, parent);
                break;
            case 'parent':
                ctx = ctx.parent;
                relative = ctx.startOffset;
                break;
            default:
                relative = 0;
                while(ctx.parent)ctx = ctx.parent;
        }
        if (this.options.relativeTo) relative += this.relativeToGetter(parent.val);
        this.offsetType.encode(stream, ctx.pointerOffset - relative);
        let { type: type } = this;
        if (type == null) {
            if (!(val instanceof $19bca402104b2cc3$export$df5cb1f3d04f5a0f)) throw new Error("Must be a VoidPointer");
            ({ type: type } = val);
            val = val.value;
        }
        ctx.pointers.push({
            type: type,
            val: val,
            parent: parent
        });
        return ctx.pointerOffset += type.size(val, parent);
    }
}
class $19bca402104b2cc3$export$df5cb1f3d04f5a0f {
    constructor(type, value){
        this.type = type;
        this.value = value;
    }
}




function $1d8e073d1256147c$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}



var $c7e0a6ffc4b4ae5b$exports = {};
'use strict';
// do not edit .js files directly - edit src/index.jst
$c7e0a6ffc4b4ae5b$exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};



var $6ocIT = parcelRequire("6ocIT");
var $82c8d86aa310da61$exports = {};
var $e3ea9b0a4b34b121$exports = {};
var $e3ea9b0a4b34b121$var$TINF_OK = 0;
var $e3ea9b0a4b34b121$var$TINF_DATA_ERROR = -3;
function $e3ea9b0a4b34b121$var$Tree() {
    this.table = new Uint16Array(16); /* table of code length counts */ 
    this.trans = new Uint16Array(288); /* code -> symbol translation table */ 
}
function $e3ea9b0a4b34b121$var$Data(source, dest) {
    this.source = source;
    this.sourceIndex = 0;
    this.tag = 0;
    this.bitcount = 0;
    this.dest = dest;
    this.destLen = 0;
    this.ltree = new $e3ea9b0a4b34b121$var$Tree(); /* dynamic length/symbol tree */ 
    this.dtree = new $e3ea9b0a4b34b121$var$Tree(); /* dynamic distance tree */ 
}
/* --------------------------------------------------- *
 * -- uninitialized global data (static structures) -- *
 * --------------------------------------------------- */ var $e3ea9b0a4b34b121$var$sltree = new $e3ea9b0a4b34b121$var$Tree();
var $e3ea9b0a4b34b121$var$sdtree = new $e3ea9b0a4b34b121$var$Tree();
/* extra bits and base tables for length codes */ var $e3ea9b0a4b34b121$var$length_bits = new Uint8Array(30);
var $e3ea9b0a4b34b121$var$length_base = new Uint16Array(30);
/* extra bits and base tables for distance codes */ var $e3ea9b0a4b34b121$var$dist_bits = new Uint8Array(30);
var $e3ea9b0a4b34b121$var$dist_base = new Uint16Array(30);
/* special ordering of code length codes */ var $e3ea9b0a4b34b121$var$clcidx = new Uint8Array([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
/* used by tinf_decode_trees, avoids allocations every call */ var $e3ea9b0a4b34b121$var$code_tree = new $e3ea9b0a4b34b121$var$Tree();
var $e3ea9b0a4b34b121$var$lengths = new Uint8Array(320);
/* ----------------------- *
 * -- utility functions -- *
 * ----------------------- */ /* build extra bits and base tables */ function $e3ea9b0a4b34b121$var$tinf_build_bits_base(bits, base, delta, first) {
    var i, sum;
    /* build bits table */ for(i = 0; i < delta; ++i)bits[i] = 0;
    for(i = 0; i < 30 - delta; ++i)bits[i + delta] = i / delta | 0;
    /* build base table */ for(sum = first, i = 0; i < 30; ++i){
        base[i] = sum;
        sum += 1 << bits[i];
    }
}
/* build the fixed huffman trees */ function $e3ea9b0a4b34b121$var$tinf_build_fixed_trees(lt, dt) {
    var i;
    /* build fixed length tree */ for(i = 0; i < 7; ++i)lt.table[i] = 0;
    lt.table[7] = 24;
    lt.table[8] = 152;
    lt.table[9] = 112;
    for(i = 0; i < 24; ++i)lt.trans[i] = 256 + i;
    for(i = 0; i < 144; ++i)lt.trans[24 + i] = i;
    for(i = 0; i < 8; ++i)lt.trans[168 + i] = 280 + i;
    for(i = 0; i < 112; ++i)lt.trans[176 + i] = 144 + i;
    /* build fixed distance tree */ for(i = 0; i < 5; ++i)dt.table[i] = 0;
    dt.table[5] = 32;
    for(i = 0; i < 32; ++i)dt.trans[i] = i;
}
/* given an array of code lengths, build a tree */ var $e3ea9b0a4b34b121$var$offs = new Uint16Array(16);
function $e3ea9b0a4b34b121$var$tinf_build_tree(t, lengths, off, num) {
    var i, sum;
    /* clear code length count table */ for(i = 0; i < 16; ++i)t.table[i] = 0;
    /* scan symbol lengths, and sum code length counts */ for(i = 0; i < num; ++i)t.table[lengths[off + i]]++;
    t.table[0] = 0;
    /* compute offset table for distribution sort */ for(sum = 0, i = 0; i < 16; ++i){
        $e3ea9b0a4b34b121$var$offs[i] = sum;
        sum += t.table[i];
    }
    /* create code->symbol translation table (symbols sorted by code) */ for(i = 0; i < num; ++i)if (lengths[off + i]) t.trans[$e3ea9b0a4b34b121$var$offs[lengths[off + i]]++] = i;
}
/* ---------------------- *
 * -- decode functions -- *
 * ---------------------- */ /* get one bit from source stream */ function $e3ea9b0a4b34b121$var$tinf_getbit(d) {
    /* check if tag is empty */ if (!d.bitcount--) {
        /* load next tag */ d.tag = d.source[d.sourceIndex++];
        d.bitcount = 7;
    }
    /* shift bit out of tag */ var bit = d.tag & 1;
    d.tag >>>= 1;
    return bit;
}
/* read a num bit value from a stream and add base */ function $e3ea9b0a4b34b121$var$tinf_read_bits(d, num, base) {
    if (!num) return base;
    while(d.bitcount < 24){
        d.tag |= d.source[d.sourceIndex++] << d.bitcount;
        d.bitcount += 8;
    }
    var val = d.tag & 0xffff >>> 16 - num;
    d.tag >>>= num;
    d.bitcount -= num;
    return val + base;
}
/* given a data stream and a tree, decode a symbol */ function $e3ea9b0a4b34b121$var$tinf_decode_symbol(d, t) {
    while(d.bitcount < 24){
        d.tag |= d.source[d.sourceIndex++] << d.bitcount;
        d.bitcount += 8;
    }
    var sum = 0, cur = 0, len = 0;
    var tag = d.tag;
    /* get more bits while code value is above sum */ do {
        cur = 2 * cur + (tag & 1);
        tag >>>= 1;
        ++len;
        sum += t.table[len];
        cur -= t.table[len];
    }while (cur >= 0);
    d.tag = tag;
    d.bitcount -= len;
    return t.trans[sum + cur];
}
/* given a data stream, decode dynamic trees from it */ function $e3ea9b0a4b34b121$var$tinf_decode_trees(d, lt, dt) {
    var hlit, hdist, hclen;
    var i, num, length;
    /* get 5 bits HLIT (257-286) */ hlit = $e3ea9b0a4b34b121$var$tinf_read_bits(d, 5, 257);
    /* get 5 bits HDIST (1-32) */ hdist = $e3ea9b0a4b34b121$var$tinf_read_bits(d, 5, 1);
    /* get 4 bits HCLEN (4-19) */ hclen = $e3ea9b0a4b34b121$var$tinf_read_bits(d, 4, 4);
    for(i = 0; i < 19; ++i)$e3ea9b0a4b34b121$var$lengths[i] = 0;
    /* read code lengths for code length alphabet */ for(i = 0; i < hclen; ++i){
        /* get 3 bits code length (0-7) */ var clen = $e3ea9b0a4b34b121$var$tinf_read_bits(d, 3, 0);
        $e3ea9b0a4b34b121$var$lengths[$e3ea9b0a4b34b121$var$clcidx[i]] = clen;
    }
    /* build code length tree */ $e3ea9b0a4b34b121$var$tinf_build_tree($e3ea9b0a4b34b121$var$code_tree, $e3ea9b0a4b34b121$var$lengths, 0, 19);
    /* decode code lengths for the dynamic trees */ for(num = 0; num < hlit + hdist;){
        var sym = $e3ea9b0a4b34b121$var$tinf_decode_symbol(d, $e3ea9b0a4b34b121$var$code_tree);
        switch(sym){
            case 16:
                /* copy previous code length 3-6 times (read 2 bits) */ var prev = $e3ea9b0a4b34b121$var$lengths[num - 1];
                for(length = $e3ea9b0a4b34b121$var$tinf_read_bits(d, 2, 3); length; --length)$e3ea9b0a4b34b121$var$lengths[num++] = prev;
                break;
            case 17:
                /* repeat code length 0 for 3-10 times (read 3 bits) */ for(length = $e3ea9b0a4b34b121$var$tinf_read_bits(d, 3, 3); length; --length)$e3ea9b0a4b34b121$var$lengths[num++] = 0;
                break;
            case 18:
                /* repeat code length 0 for 11-138 times (read 7 bits) */ for(length = $e3ea9b0a4b34b121$var$tinf_read_bits(d, 7, 11); length; --length)$e3ea9b0a4b34b121$var$lengths[num++] = 0;
                break;
            default:
                /* values 0-15 represent the actual code lengths */ $e3ea9b0a4b34b121$var$lengths[num++] = sym;
                break;
        }
    }
    /* build dynamic trees */ $e3ea9b0a4b34b121$var$tinf_build_tree(lt, $e3ea9b0a4b34b121$var$lengths, 0, hlit);
    $e3ea9b0a4b34b121$var$tinf_build_tree(dt, $e3ea9b0a4b34b121$var$lengths, hlit, hdist);
}
/* ----------------------------- *
 * -- block inflate functions -- *
 * ----------------------------- */ /* given a stream and two trees, inflate a block of data */ function $e3ea9b0a4b34b121$var$tinf_inflate_block_data(d, lt, dt) {
    while(true){
        var sym = $e3ea9b0a4b34b121$var$tinf_decode_symbol(d, lt);
        /* check for end of block */ if (sym === 256) return $e3ea9b0a4b34b121$var$TINF_OK;
        if (sym < 256) d.dest[d.destLen++] = sym;
        else {
            var length, dist, offs;
            var i;
            sym -= 257;
            /* possibly get more bits from length code */ length = $e3ea9b0a4b34b121$var$tinf_read_bits(d, $e3ea9b0a4b34b121$var$length_bits[sym], $e3ea9b0a4b34b121$var$length_base[sym]);
            dist = $e3ea9b0a4b34b121$var$tinf_decode_symbol(d, dt);
            /* possibly get more bits from distance code */ offs = d.destLen - $e3ea9b0a4b34b121$var$tinf_read_bits(d, $e3ea9b0a4b34b121$var$dist_bits[dist], $e3ea9b0a4b34b121$var$dist_base[dist]);
            /* copy match */ for(i = offs; i < offs + length; ++i)d.dest[d.destLen++] = d.dest[i];
        }
    }
}
/* inflate an uncompressed block of data */ function $e3ea9b0a4b34b121$var$tinf_inflate_uncompressed_block(d) {
    var length, invlength;
    var i;
    /* unread from bitbuffer */ while(d.bitcount > 8){
        d.sourceIndex--;
        d.bitcount -= 8;
    }
    /* get length */ length = d.source[d.sourceIndex + 1];
    length = 256 * length + d.source[d.sourceIndex];
    /* get one's complement of length */ invlength = d.source[d.sourceIndex + 3];
    invlength = 256 * invlength + d.source[d.sourceIndex + 2];
    /* check length */ if (length !== (~invlength & 0x0000ffff)) return $e3ea9b0a4b34b121$var$TINF_DATA_ERROR;
    d.sourceIndex += 4;
    /* copy block */ for(i = length; i; --i)d.dest[d.destLen++] = d.source[d.sourceIndex++];
    /* make sure we start next block on a byte boundary */ d.bitcount = 0;
    return $e3ea9b0a4b34b121$var$TINF_OK;
}
/* inflate stream from source to dest */ function $e3ea9b0a4b34b121$var$tinf_uncompress(source, dest) {
    var d = new $e3ea9b0a4b34b121$var$Data(source, dest);
    var bfinal, btype, res;
    do {
        /* read final block flag */ bfinal = $e3ea9b0a4b34b121$var$tinf_getbit(d);
        /* read block type (2 bits) */ btype = $e3ea9b0a4b34b121$var$tinf_read_bits(d, 2, 0);
        /* decompress block */ switch(btype){
            case 0:
                /* decompress uncompressed block */ res = $e3ea9b0a4b34b121$var$tinf_inflate_uncompressed_block(d);
                break;
            case 1:
                /* decompress block with fixed huffman trees */ res = $e3ea9b0a4b34b121$var$tinf_inflate_block_data(d, $e3ea9b0a4b34b121$var$sltree, $e3ea9b0a4b34b121$var$sdtree);
                break;
            case 2:
                /* decompress block with dynamic huffman trees */ $e3ea9b0a4b34b121$var$tinf_decode_trees(d, d.ltree, d.dtree);
                res = $e3ea9b0a4b34b121$var$tinf_inflate_block_data(d, d.ltree, d.dtree);
                break;
            default:
                res = $e3ea9b0a4b34b121$var$TINF_DATA_ERROR;
        }
        if (res !== $e3ea9b0a4b34b121$var$TINF_OK) throw new Error('Data error');
    }while (!bfinal);
    if (d.destLen < d.dest.length) {
        if (typeof d.dest.slice === 'function') return d.dest.slice(0, d.destLen);
        else return d.dest.subarray(0, d.destLen);
    }
    return d.dest;
}
/* -------------------- *
 * -- initialization -- *
 * -------------------- */ /* build fixed huffman trees */ $e3ea9b0a4b34b121$var$tinf_build_fixed_trees($e3ea9b0a4b34b121$var$sltree, $e3ea9b0a4b34b121$var$sdtree);
/* build extra bits and base tables */ $e3ea9b0a4b34b121$var$tinf_build_bits_base($e3ea9b0a4b34b121$var$length_bits, $e3ea9b0a4b34b121$var$length_base, 4, 3);
$e3ea9b0a4b34b121$var$tinf_build_bits_base($e3ea9b0a4b34b121$var$dist_bits, $e3ea9b0a4b34b121$var$dist_base, 2, 1);
/* fix a special case */ $e3ea9b0a4b34b121$var$length_bits[28] = 0;
$e3ea9b0a4b34b121$var$length_base[28] = 258;
$e3ea9b0a4b34b121$exports = $e3ea9b0a4b34b121$var$tinf_uncompress;


var $00106d990fcbff41$exports = {};
const $00106d990fcbff41$var$isBigEndian = new Uint8Array(new Uint32Array([
    0x12345678
]).buffer)[0] === 0x12;
const $00106d990fcbff41$var$swap = (b, n, m)=>{
    let i = b[n];
    b[n] = b[m];
    b[m] = i;
};
const $00106d990fcbff41$var$swap32 = (array)=>{
    const len = array.length;
    for(let i = 0; i < len; i += 4){
        $00106d990fcbff41$var$swap(array, i, i + 3);
        $00106d990fcbff41$var$swap(array, i + 1, i + 2);
    }
};
const $00106d990fcbff41$var$swap32LE = (array)=>{
    if ($00106d990fcbff41$var$isBigEndian) $00106d990fcbff41$var$swap32(array);
};
$00106d990fcbff41$exports = {
    swap32LE: $00106d990fcbff41$var$swap32LE
};


var $82c8d86aa310da61$require$swap32LE = $00106d990fcbff41$exports.swap32LE;
// Shift size for getting the index-1 table offset.
const $82c8d86aa310da61$var$SHIFT_1 = 11;
// Shift size for getting the index-2 table offset.
const $82c8d86aa310da61$var$SHIFT_2 = 5;
// Difference between the two shift sizes,
// for getting an index-1 offset from an index-2 offset. 6=11-5
const $82c8d86aa310da61$var$SHIFT_1_2 = $82c8d86aa310da61$var$SHIFT_1 - $82c8d86aa310da61$var$SHIFT_2;
// Number of index-1 entries for the BMP. 32=0x20
// This part of the index-1 table is omitted from the serialized form.
const $82c8d86aa310da61$var$OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> $82c8d86aa310da61$var$SHIFT_1;
// Number of entries in an index-2 block. 64=0x40
const $82c8d86aa310da61$var$INDEX_2_BLOCK_LENGTH = 1 << $82c8d86aa310da61$var$SHIFT_1_2;
// Mask for getting the lower bits for the in-index-2-block offset. */
const $82c8d86aa310da61$var$INDEX_2_MASK = $82c8d86aa310da61$var$INDEX_2_BLOCK_LENGTH - 1;
// Shift size for shifting left the index array values.
// Increases possible data size with 16-bit index values at the cost
// of compactability.
// This requires data blocks to be aligned by DATA_GRANULARITY.
const $82c8d86aa310da61$var$INDEX_SHIFT = 2;
// Number of entries in a data block. 32=0x20
const $82c8d86aa310da61$var$DATA_BLOCK_LENGTH = 1 << $82c8d86aa310da61$var$SHIFT_2;
// Mask for getting the lower bits for the in-data-block offset.
const $82c8d86aa310da61$var$DATA_MASK = $82c8d86aa310da61$var$DATA_BLOCK_LENGTH - 1;
// The part of the index-2 table for U+D800..U+DBFF stores values for
// lead surrogate code _units_ not code _points_.
// Values for lead surrogate code _points_ are indexed with this portion of the table.
// Length=32=0x20=0x400>>SHIFT_2. (There are 1024=0x400 lead surrogates.)
const $82c8d86aa310da61$var$LSCP_INDEX_2_OFFSET = 0x10000 >> $82c8d86aa310da61$var$SHIFT_2;
const $82c8d86aa310da61$var$LSCP_INDEX_2_LENGTH = 0x400 >> $82c8d86aa310da61$var$SHIFT_2;
// Count the lengths of both BMP pieces. 2080=0x820
const $82c8d86aa310da61$var$INDEX_2_BMP_LENGTH = $82c8d86aa310da61$var$LSCP_INDEX_2_OFFSET + $82c8d86aa310da61$var$LSCP_INDEX_2_LENGTH;
// The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
// Length 32=0x20 for lead bytes C0..DF, regardless of SHIFT_2.
const $82c8d86aa310da61$var$UTF8_2B_INDEX_2_OFFSET = $82c8d86aa310da61$var$INDEX_2_BMP_LENGTH;
const $82c8d86aa310da61$var$UTF8_2B_INDEX_2_LENGTH = 32; // U+0800 is the first code point after 2-byte UTF-8
// The index-1 table, only used for supplementary code points, at offset 2112=0x840.
// Variable length, for code points up to highStart, where the last single-value range starts.
// Maximum length 512=0x200=0x100000>>SHIFT_1.
// (For 0x100000 supplementary code points U+10000..U+10ffff.)
//
// The part of the index-2 table for supplementary code points starts
// after this index-1 table.
//
// Both the index-1 table and the following part of the index-2 table
// are omitted completely if there is only BMP data.
const $82c8d86aa310da61$var$INDEX_1_OFFSET = $82c8d86aa310da61$var$UTF8_2B_INDEX_2_OFFSET + $82c8d86aa310da61$var$UTF8_2B_INDEX_2_LENGTH;
// The alignment size of a data block. Also the granularity for compaction.
const $82c8d86aa310da61$var$DATA_GRANULARITY = 1 << $82c8d86aa310da61$var$INDEX_SHIFT;
class $82c8d86aa310da61$var$UnicodeTrie {
    constructor(data){
        const isBuffer = typeof data.readUInt32BE === 'function' && typeof data.slice === 'function';
        if (isBuffer || data instanceof Uint8Array) {
            // read binary format
            let uncompressedLength;
            if (isBuffer) {
                this.highStart = data.readUInt32LE(0);
                this.errorValue = data.readUInt32LE(4);
                uncompressedLength = data.readUInt32LE(8);
                data = data.slice(12);
            } else {
                const view = new DataView(data.buffer);
                this.highStart = view.getUint32(0, true);
                this.errorValue = view.getUint32(4, true);
                uncompressedLength = view.getUint32(8, true);
                data = data.subarray(12);
            }
            // double inflate the actual trie data
            data = $e3ea9b0a4b34b121$exports(data, new Uint8Array(uncompressedLength));
            data = $e3ea9b0a4b34b121$exports(data, new Uint8Array(uncompressedLength));
            // swap bytes from little-endian
            $82c8d86aa310da61$require$swap32LE(data);
            this.data = new Uint32Array(data.buffer);
        } else // pre-parsed data
        ({ data: this.data, highStart: this.highStart, errorValue: this.errorValue } = data);
    }
    get(codePoint) {
        let index;
        if (codePoint < 0 || codePoint > 0x10ffff) return this.errorValue;
        if (codePoint < 0xd800 || codePoint > 0xdbff && codePoint <= 0xffff) {
            // Ordinary BMP code point, excluding leading surrogates.
            // BMP uses a single level lookup.  BMP index starts at offset 0 in the index.
            // data is stored in the index array itself.
            index = (this.data[codePoint >> $82c8d86aa310da61$var$SHIFT_2] << $82c8d86aa310da61$var$INDEX_SHIFT) + (codePoint & $82c8d86aa310da61$var$DATA_MASK);
            return this.data[index];
        }
        if (codePoint <= 0xffff) {
            // Lead Surrogate Code Point.  A Separate index section is stored for
            // lead surrogate code units and code points.
            //   The main index has the code unit data.
            //   For this function, we need the code point data.
            index = (this.data[$82c8d86aa310da61$var$LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> $82c8d86aa310da61$var$SHIFT_2)] << $82c8d86aa310da61$var$INDEX_SHIFT) + (codePoint & $82c8d86aa310da61$var$DATA_MASK);
            return this.data[index];
        }
        if (codePoint < this.highStart) {
            // Supplemental code point, use two-level lookup.
            index = this.data[$82c8d86aa310da61$var$INDEX_1_OFFSET - $82c8d86aa310da61$var$OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> $82c8d86aa310da61$var$SHIFT_1)];
            index = this.data[index + (codePoint >> $82c8d86aa310da61$var$SHIFT_2 & $82c8d86aa310da61$var$INDEX_2_MASK)];
            index = (index << $82c8d86aa310da61$var$INDEX_SHIFT) + (codePoint & $82c8d86aa310da61$var$DATA_MASK);
            return this.data[index];
        }
        return this.data[this.data.length - $82c8d86aa310da61$var$DATA_GRANULARITY];
    }
}
$82c8d86aa310da61$exports = $82c8d86aa310da61$var$UnicodeTrie;


function $d6a5237190dccd49$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
var $d6a5237190dccd49$var$$f4087201da764553$exports = {};
$d6a5237190dccd49$var$$f4087201da764553$exports = JSON.parse('{"categories":["Cc","Zs","Po","Sc","Ps","Pe","Sm","Pd","Nd","Lu","Sk","Pc","Ll","So","Lo","Pi","Cf","No","Pf","Lt","Lm","Mn","Me","Mc","Nl","Zl","Zp","Cs","Co"],"combiningClasses":["Not_Reordered","Above","Above_Right","Below","Attached_Above_Right","Attached_Below","Overlay","Iota_Subscript","Double_Below","Double_Above","Below_Right","Above_Left","CCC10","CCC11","CCC12","CCC13","CCC14","CCC15","CCC16","CCC17","CCC18","CCC19","CCC20","CCC21","CCC22","CCC23","CCC24","CCC25","CCC30","CCC31","CCC32","CCC27","CCC28","CCC29","CCC33","CCC34","CCC35","CCC36","Nukta","Virama","CCC84","CCC91","CCC103","CCC107","CCC118","CCC122","CCC129","CCC130","CCC132","Attached_Above","Below_Left","Left","Kana_Voicing","CCC26","Right"],"scripts":["Common","Latin","Bopomofo","Inherited","Greek","Coptic","Cyrillic","Armenian","Hebrew","Arabic","Syriac","Thaana","Nko","Samaritan","Mandaic","Devanagari","Bengali","Gurmukhi","Gujarati","Oriya","Tamil","Telugu","Kannada","Malayalam","Sinhala","Thai","Lao","Tibetan","Myanmar","Georgian","Hangul","Ethiopic","Cherokee","Canadian_Aboriginal","Ogham","Runic","Tagalog","Hanunoo","Buhid","Tagbanwa","Khmer","Mongolian","Limbu","Tai_Le","New_Tai_Lue","Buginese","Tai_Tham","Balinese","Sundanese","Batak","Lepcha","Ol_Chiki","Braille","Glagolitic","Tifinagh","Han","Hiragana","Katakana","Yi","Lisu","Vai","Bamum","Syloti_Nagri","Phags_Pa","Saurashtra","Kayah_Li","Rejang","Javanese","Cham","Tai_Viet","Meetei_Mayek","null","Linear_B","Lycian","Carian","Old_Italic","Gothic","Old_Permic","Ugaritic","Old_Persian","Deseret","Shavian","Osmanya","Osage","Elbasan","Caucasian_Albanian","Linear_A","Cypriot","Imperial_Aramaic","Palmyrene","Nabataean","Hatran","Phoenician","Lydian","Meroitic_Hieroglyphs","Meroitic_Cursive","Kharoshthi","Old_South_Arabian","Old_North_Arabian","Manichaean","Avestan","Inscriptional_Parthian","Inscriptional_Pahlavi","Psalter_Pahlavi","Old_Turkic","Old_Hungarian","Hanifi_Rohingya","Old_Sogdian","Sogdian","Elymaic","Brahmi","Kaithi","Sora_Sompeng","Chakma","Mahajani","Sharada","Khojki","Multani","Khudawadi","Grantha","Newa","Tirhuta","Siddham","Modi","Takri","Ahom","Dogra","Warang_Citi","Nandinagari","Zanabazar_Square","Soyombo","Pau_Cin_Hau","Bhaiksuki","Marchen","Masaram_Gondi","Gunjala_Gondi","Makasar","Cuneiform","Egyptian_Hieroglyphs","Anatolian_Hieroglyphs","Mro","Bassa_Vah","Pahawh_Hmong","Medefaidrin","Miao","Tangut","Nushu","Duployan","SignWriting","Nyiakeng_Puachue_Hmong","Wancho","Mende_Kikakui","Adlam"],"eaw":["N","Na","A","W","H","F"]}');
const $d6a5237190dccd49$var$$747425b437e121da$var$trie = new (0, (/*@__PURE__*/$parcel$interopDefault($82c8d86aa310da61$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($6ocIT))).toByteArray("AAARAAAAAADwfAEAZXl5ONRt+/5bPVFZimRfKoTQJNm37CGE7Iw0j3UsTWKsoyI7kwyyTiEUzSD7NiEzhWYijH0wMVkHE4Mx49fzfo+3nuP4/fdZjvv+XNd5n/d9nef1WZvmKhTxiZndzDQBSEYQqxqKwnsKvGQucFh+6t6cJ792ePQBZv5S9yXSwkyjf/P4T7mTNnIAv1dOVhMlR9lflbUL9JeJguqsjvG9NTj/wLb566VAURnLo2vvRi89S3gW/33ihh2eXpDn40BIW7REl/7coRKIhAFlAiOtbLDTt6mMb4GzMF1gNnvX/sBxtbsAIjfztCNcQjcNDtLThRvuXu5M5g/CBjaLBE4lJm4qy/oZD97+IJryApcXfgWYlkvWbhfXgujOJKVu8B+ozqTLbxyJ5kNiR75CxDqfBM9eOlDMmGeoZ0iQbbS5VUplIwI+ZNXEKQVJxlwqjhOY7w3XwPesbLK5JZE+Tt4X8q8km0dzInsPPzbscrjBMVjF5mOHSeRdJVgKUjLTHiHqXSPkep8N/zFk8167KLp75f6RndkvzdfB6Uz3MmqvRArzdCbs1/iRZjYPLLF3U8Qs+H+Rb8iK51a6NIV2V9+07uJsTGFWpPz8J++7iRu2B6eAKlK/kujrLthwaD/7a6J5w90TusnH1JMAc+gNrql4aspOUG/RrsxUKmPzhHgP4Bleru+6Vfc/MBjgXVx7who94nPn7MPFrnwQP7g0k0Dq0h2GSKO6fTZ8nLodN1SiOUj/5EL/Xo1DBvRm0wmrh3x6phcJ20/9CuMr5h8WPqXMSasLoLHoufTmE7mzYrs6B0dY7KjuCogKqsvxnxAwXWvd9Puc9PnE8DOHT2INHxRlIyVHrqZahtfV2E/A2PDdtA3ewlRHMtFIBKO/T4IozWTQZ+mb+gdKuk/ZHrqloucKdsOSJmlWTSntWjcxVMjUmroXLM10I6TwDLnBq4LP69TxgVeyGsd8yHvhF8ydPlrNRSNs9EP7WmeuSE7Lu10JbOuQcJw/63sDp68wB9iwP5AO+mBpV0R5VDDeyQUFCel1G+4KHBgEVFS0YK+m2sXLWLuGTlkVAd97WwKKdacjWElRCuDRauf33l/yVcDF6sVPKeTes99FC1NpNWcpieGSV/IbO8PCTy5pbUR1U8lxzf4T+y6fZMxOz3LshkQLeeDSd0WmUrQgajmbktrxsb2AZ0ACw2Vgni+gV/m+KvCRWLg08Clx7uhql+v9XySGcjjOHlsp8vBw/e8HS7dtiqF6T/XcSXuaMW66GF1g4q9YyBadHqy3Y5jin1c7yZos6BBr6dsomSHxiUHanYtcYQwnMMZhRhOnaYJeyJzaRuukyCUh48+e/BUvk/aEfDp8ag+jD64BHxNnQ5v/E7WRk7eLjGV13I3oqy45YNONi/1op1oDr7rPjkhPsTXgUpQtGDPlIs55KhQaic9kSGs/UrZ2QKQOflB8MTEQxRF9pullToWO7Eplan6mcMRFnUu2441yxi23x+KqKlr7RWWsi9ZXMWlr8vfP3llk1m2PRj0yudccxBuoa7VfIgRmnFPGX6Pm1WIfMm/Rm4n/xTn8IGqA0GWuqgu48pEUO0U9nN+ZdIvFpPb7VDPphIfRZxznlHeVFebkd9l+raXy9BpTMcIUIvBfgHEb6ndGo8VUkxpief14KjzFOcaANfgvFpvyY8lE8lE4raHizLpluPzMks1hx/e1Hok5yV0p7qQH7GaYeMzzZTFvRpv6k6iaJ4yNqzBvN8J7B430h2wFm1IBPcqbou33G7/NWPgopl4Mllla6e24L3TOTVNkza2zv3QKuDWTeDpClCEYgTQ+5vEBSQZs/rMF50+sm4jofTgWLqgX1x3TkrDEVaRqfY/xZizFZ3Y8/DFEFD31VSfBQ5raEB6nHnZh6ddehtclQJ8fBrldyIh99LNnV32HzKEej04hk6SYjdauCa4aYW0ru/QxvQRGzLKOAQszf3ixJypTW3WWL6BLSF2EMCMIw7OUvWBC6A/gDc2D1jvBapMCc7ztx6jYczwTKsRLL6dMNXb83HS8kdD0pTMMj161zbVHkU0mhSHo9SlBDDXdN6hDvRGizmohtIyR3ot8tF5iUG4GLNcXeGvBudSFrHu+bVZb9jirNVG+rQPI51A7Hu8/b0UeaIaZ4UgDO68PkYx3PE2HWpKapJ764Kxt5TFYpywMy4DLQqVRy11I7SOLhxUFmqiEK52NaijWArIfCg6qG8q5eSiwRCJb1R7GDJG74TrYgx/lVq7w9++Kh929xSJEaoSse5fUOQg9nMAnIZv+7fwVRcNv3gOHI46Vb5jYUC66PYHO6lS+TOmvEQjuYmx4RkffYGxqZIp/DPWNHAixbRBc+XKE3JEOgs4jIwu/dSAwhydruOGF39co91aTs85JJ3Z/LpXoF43hUwJsb/M1Chzdn8HX8vLXnqWUKvRhNLpfAF4PTFqva1sBQG0J+59HyYfmQ3oa4/sxZdapVLlo/fooxSXi/dOEQWIWq8E0FkttEyTFXR2aNMPINMIzZwCNEheYTVltsdaLkMyKoEUluPNAYCM2IG3br0DLy0fVNWKHtbSKbBjfiw7Lu06gQFalC7RC9BwRMSpLYDUo9pDtDfzwUiPJKLJ2LGcSphWBadOI/iJjNqUHV7ucG8yC6+iNM9QYElqBR7ECFXrcTgWQ3eG/tCWacT9bxIkfmxPmi3vOd36KxihAJA73vWNJ+Y9oapXNscVSVqS5g15xOWND/WuUCcA9YAAg6WFbjHamrblZ5c0L6Zx1X58ZittGcfDKU697QRSqW/g+RofNRyvrWMrBn44cPvkRe2HdTu/Cq01C5/riWPHZyXPKHuSDDdW8c1XPgd6ogvLh20qEIu8c19sqr4ufyHrwh37ZN5MkvY1dsGmEz9pUBTxWrvvhNyODyX2Q1k/fbX/T/vbHNcBrmjgDtvBdtZrVtiIg5iXQuzO/DEMvRX8Mi1zymSlt92BGILeKItjoShJXE/H7xwnf0Iewb8BFieJ9MflEBCQYEDm8eZniiEPfGoaYiiEdhQxHQNr2AuRdmbL9mcl18Kumh+HEZLp6z+j35ML9zTbUwahUZCyQQOgQrGfdfQtaR/OYJ/9dYXb2TWZFMijfCA8Nov4sa5FFDUe1T68h4q08WDE7JbbDiej4utRMR9ontevxlXv6LuJTXt1YEv8bDzEt683PuSsIN0afvu0rcBu9AbXZbkOG3K3AhtqQ28N23lXm7S3Yn6KXmAhBhz+GeorJJ4XxO/b3vZk2LXp42+QvsVxGSNVpfSctIFMTR1bD9t70i6sfNF3WKz/uKDEDCpzzztwhL45lsw89H2IpWN10sXHRlhDse9KCdpP5qNNpU84cTY+aiqswqR8XZ9ea0KbVRwRuOGQU3csAtV2fSbnq47U6es6rKlWLWhg3s/B9C9g+oTyp6RtIldR51OOkP5/6nSy6itUVPcMNOp4M/hDdKOz3uK6srbdxOrc2cJgr1Sg02oBxxSky6V7JaG+ziNwlfqnjnvh2/uq1lKfbp+qpwq/D/5OI5gkFl5CejKGxfc2YVJfGqc4E0x5e9PHK2ukbHNI7/RZV6LNe65apbTGjoCaQls0txPPbmQbCQn+/upCoXRZy9yzorWJvZ0KWcbXlBxU/d5I4ERUTxMuVWhSMmF677LNN7NnLwsmKawXkCgbrpcluOl0WChR1qhtSrxGXHu251dEItYhYX3snvn1gS2uXuzdTxCJjZtjsip0iT2sDC0qMS7Bk9su2NyXjFK5/f5ZoWwofg3DtTyjaFqspnOOTSh8xK/CKUFS57guVEkw9xoQuRCwwEO9Lu9z2vYxSa9NFV8DvSxv2C4WYLYF8Nrc4DzWkzNsk81JJOlZ/LYJrGCoj4MmZpnf3AXmzxT4rtl9jsqljEyedz468SGKdBiQzyz/qWKEhFg45ZczlZZ3KGL3l6sn+3TTa3zMVMhPa1obGp/z+fvY0QXTrJTf1XAT3EtQdUfYYlmWZyvPZ/6rWwU7UOQei7pVE0osgN94Iy+T1+omE6z4Rh2O20FjgBeK2y1mcoFiMDOJvuZPn5Moy9fmFH3wyfKvn4+TwfLvt/lHTTVnvrtoUWRBiQXhiNM8nE6ZoWeux/Z0b2unRcdUzdDpmL7CAgd1ToRXwgmHTZOgiGtVT+xr1QH9ObebRTT4NzL+XSpLuuWp62GqQvJVTPoZOeJCb6gIwd9XHMftQ+Kc08IKKdKQANSJ1a2gve3JdRhO0+tNiYzWAZfd7isoeBu67W7xuK8WX7nhJURld98Inb0t/dWOSau/kDvV4DJo/cImw9AO2Gvq0F2n0M7yIZKL8amMbjYld+qFls7hq8Acvq97K2PrCaomuUiesu7qNanGupEl6J/iem8lyr/NMnsTr6o41PO0yhQh3hPFN0wJP7S830je9iTBLzUNgYH+gUZpROo3rN2qgCI+6GewpX8w8CH+ro6QrWiStqmcMzVa3vEel+3/dDxMp0rDv1Q6wTMS3K64zTT6RWzK1y643im25Ja7X2ePCV2mTswd/4jshZPo4bLnerqIosq/hy2bKUAmVn9n4oun1+a0DIZ56UhVwmZHdUNpLa8gmPvxS1eNvCF1T0wo1wKPdCJi0qOrWz7oYRTzgTtkzEzZn308XSLwUog4OWGKJzCn/3FfF9iA32dZHSv30pRCM3KBY9WZoRhtdK/ChHk6DEQBsfV6tN2o1Cn0mLtPBfnkS+qy1L2xfFe9TQPtDE1Be44RTl82E9hPT2rS2+93LFbzhQQO3C/hD2jRFH3BWWbasAfuMhRJFcTri73eE835y016s22DjoFJ862WvLj69fu2TgSF3RHia9D5DSitlQAXYCnbdqjPkR287Lh6dCHDapos+eFDvcZPP2edPmTFxznJE/EBLoQQ0Qmn9EkZOyJmHxMbvKYb8o21ZHmv5YLqgsEPk9gWZwYQY9wLqGXuax/8QlV5qDaPbq9pLPT1yp+zOWKmraEy1OUJI7zdEcEmvBpbdwLrDCgEb2xX8S/nxZgjK4bRi+pbOmbh8bEeoPvU/L9ndx9kntlDALbdAvp0O8ZC3zSUnFg4cePsw7jxewWvL7HRSBLUn6J7vTH9uld5N76JFPgBCdXGF221oEJk++XfRwXplLSyrVO7HFWBEs99nTazKveW3HpbD4dH/YmdAl+lwbSt8BQWyTG7jAsACI7bPPUU9hI9XUHWqQOuezHzUjnx5Qqs6T1qNHfTTHleDtmqK7flA9a0gz2nycIpz1FHBuWxKNtUeTdqP29Fb3tv+tl5JyBqXoR+vCsdzZwZUhf6Lu8bvkB9yQP4x7GGegB0ym0Lpl03Q7e+C0cDsm9GSDepCDji7nUslLyYyluPfvLyKaDSX4xpR+nVYQjQQn5F8KbY1gbIVLiK1J3mW90zTyR1bqApX2BlWh7KG8LAY9/S9nWC0XXh9pZZo6xuir12T43rkaGfQssbQyIslA7uJnSHOV22NhlNtUo0czxPAsXhh8tIQYaTM4l/yAlZlydTcXhlG22Gs/n3BxKBd/3ZjYwg3NaUurVXhNB+afVnFfNr9TbC9ksNdvwpNfeHanyJ8M6GrIVfLlYAPv0ILe4dn0Z+BJSbJkN7eZY/c6+6ttDYcIDeUKIDXqUSE42Xdh5nRbuaObozjht0HJ5H1e+em+NJi/+8kQlyjCbJpPckwThZeIF9/u7lrVIKNeJLCN/TpPAeXxvd31/CUDWHK9MuP1V1TJgngzi4V0qzS3SW3Qy5UiGHqg02wQa5tsEl9s/X9nNMosgLlUgZSfCBj1DiypLfhr9/r0nR0XY2tmhDOcUS4E7cqa4EJBhzqvpbZa35Q5Iz5EqmhYiOGDAYk606Tv74+KGfPjKVuP15rIzgW0I7/niOu9el/sn2bRye0gV+GrePDRDMHjwO1lEdeXH8N+UTO3IoN18kpI3tPxz+fY+n2MGMSGFHAx/83tKeJOl+2i+f1O9v6FfEDBbqrw+lpM8Anav7zHNr7hE78nXUtPNodMbCnITWA7Ma/IHlZ50F9hWge/wzOvSbtqFVFtkS8Of2nssjZwbSFdU+VO8z6tCEc9UA9ACxT5zIUeSrkBB/v1krOpm7bVMrGxEKfI6LcnpB4D8bvn2hDKGqKrJaVAJuDaBEY3F7eXyqnFWlOoFV/8ZLspZiZd7orXLhd4mhHQgbuKbHjJWUzrnm0Dxw/LJLzXCkh7slMxKo8uxZIWZfdKHlfI7uj3LP6ARAuWdF7ZmZ7daOKqKGbz5LxOggTgS39oEioYmrqkCeUDvbxkBYKeHhcLmMN8dMF01ZMb32IpL/cH8R7VHQSI5I0YfL14g9d7P/6cjB1JXXxbozEDbsrPdmL8ph7QW10jio+v7YsqHKQ6xrBbOVtxU0/nFfzUGZwIBLwyUvg49ii+54nv9FyECBpURnQK4Ox6N7lw5fsjdd5l/2SwBcAHMJoyjO1Pifye2dagaOwCVMqdJWAo77pvBe0zdJcTWu5fdzPNfV2p1pc7/JKQ8zhKkwsOELUDhXygPJ5oR8Vpk2lsCen3D3QOQp2zdrSZHjVBstDF/wWO98rrkQ6/7zt/Drip7OHIug1lomNdmRaHRrjmqeodn22sesQQPgzimPOMqC60a5+i/UYh51uZm+ijWkkaI2xjrBO2558DZNZMiuDQlaVAvBy2wLn/bR3FrNzfnO/9oDztYqxZrr7JMIhqmrochbqmQnKowxW29bpqTaJu7kW1VotC72QkYX8OoDDdMDwV1kJRk3mufgJBzf+iwFRJ7XWQwO5ujVglgFgHtycWiMLx5N+6XU+TulLabWjOzoao03fniUW0xvIJNPbk7CQlFZd/RCOPvgQbLjh5ITE8NVJeKt3HGr6JTnFdIzcVOlEtwqbIIX0IM7saC+4N5047MTJ9+Wn11EhyEPIlwsHE5utCeXRjQzlrR+R1Cf/qDzcNbqLXdk3J7gQ39VUrrEkS/VMWjjg+t2oYrqB0tUZClcUF6+LBC3EQ7KnGIwm/qjZX4GKPtjTX1zQKV6nPAb2t/Rza5IqKRf8i2DFEhV/YSifX0YwsiF6TQnp48Gr65TFq0zUe6LGjiY7fq0LSGKL1VnC6ESI2yxvt3XqBx53B3gSlGFeJcPbUbonW1E9E9m4NfuwPh+t5QjRxX34lvBPVxwQd7aeTd+r9dw5CiP1pt8wMZoMdni7GapYdo6KPgeQKcmlFfq4UYhvV0IBgeiR3RnTMBaqDqpZrTRyLdsp4l0IXZTdErfH0sN3dqBG5vRIx3VgCYcHmmkqJ8Hyu3s9K9uBD1d8cZUEx3qYcF5vsqeRpF1GOg8emeWM2OmBlWPdZ6qAXwm3nENFyh+kvXk132PfWAlN0kb7yh4fz2T7VWUY/hEXX5DvxGABC03XRpyOG8t/u3Gh5tZdpsSV9AWaxJN7zwhVglgII1gV28tUViyqn4UMdIh5t+Ea2zo7PO48oba0TwQbiSZOH4YhD578kPF3reuaP7LujPMsjHmaDuId9XEaZBCJhbXJbRg5VCk3KJpryH/+8S3wdhR47pdFcmpZG2p0Bpjp/VbvalgIZMllYX5L31aMPdt1J7r/7wbixt0Mnz2ZvNGTARHPVD+2O1D8SGpWXlVnP2ekgon55YiinADDynyaXtZDXueVqbuTi8z8cHHK325pgqM+mWZwzHeEreMvhZopAScXM14SJHpGwZyRljMlDvcMm9FZ/1e9+r/puOnpXOtc9Iu2fmgBfEP9cGW1Fzb1rGlfJ08pACtq1ZW18bf2cevebzVeHbaA50G9qoUp39JWdPHbYkPCRXjt4gzlq3Cxge28Mky8MoS/+On72kc+ZI2xBtgJytpAQHQ1zrEddMIVyR5urX6yBNu8v5lKC8eLdGKTJtbgIZ3ZyTzSfWmx9f+cvcJe8yM39K/djkp2aUTE/9m2Lj5jg7b8vdRAer7DO3SyLNHs1CAm5x5iAdh2yGJYivArZbCBNY88Tw+w+C1Tbt7wK3zl2rzTHo/D8/gb3c3mYrnEIEipYqPUcdWjnTsSw471O3EUN7Gtg4NOAs9PJrxm03VuZKa5xwXAYCjt7Gs01Km6T2DhOYUMoFcCSu7Hk1p3yP1eG+M3v3Q5luAze6WwBnZIYO0TCucPWK+UJ36KoJ8Y+vpavhLO8g5ed704IjlQdfemrMu//EvPYXTQSGIPPfiagJS9nMqP5IvkxN9pvuJz7h8carPXTKMq8jnTeL0STan6dnLTAqwIswcIwWDR2KwbGddAVN8SYWRB7kfBfBRkSXzvHlIF8D6jo64kUzYk5o/n8oLjKqat0rdXvQ86MkwQGMnnlcasqPPT2+mVtUGb32KuH6cyZQenrRG11TArcAl27+nvOMBDe++EKHf4YdyGf7mznzOz33cFFGEcv329p4qG2hoaQ8ULiMyVz6ENcxhoqGnFIdupcn7GICQWuw3yO3W8S33mzCcMYJ8ywc7U7rmaQf/W5K63Gr4bVTpXOyOp4tbaPyIaatBNpXqlmQUTSZXjxPr19+73PSaT+QnI35YsWn6WpfJjRtK8vlJZoTSgjaRU39AGCkWOZtifJrnefCrqwTKDFmuWUCukEsYcRrMzCoit28wYpP7kSVjMD8WJYQiNc2blMjuqYegmf6SsfC1jqz8XzghMlOX+gn/MKZmgljszrmehEa4V98VreJDxYvHr3j7IeJB9/sBZV41BWT/AZAjuC5XorlIPnZgBAniBEhanp0/0+qZmEWDpu8ige1hUPIyTo6T6gDEcFhWSoduNh8YSu65KgMOGBw7VlNYzNIgwHtq9KP2yyTVysqX5v12sf7D+vQUdR2dRDvCV40rIInXSLWT/yrC6ExOQxBJwIDbeZcl3z1yR5Rj3l8IGpxspapnvBL+fwupA3b6fkFceID9wgiM1ILB0cHVdvo/R4xg8yqKXT8efl0GnGX1/27FUYeUW2L/GNRGGWVGp3i91oaJkb4rybENHre9a2P5viz/yqk8ngWUUS+Kv+fu+9BLFnfLiLXOFcIeBJLhnayCiuDRSqcx0Qu68gVsGYc6EHD500Fkt+gpDj6gvr884n8wZ5o6q7xtL5wA0beXQnffWYkZrs2NGIRgQbsc5NB302SVx+R4ROvmgZaR8wBcji128BMfJ9kcvJ4DC+bQ57kRmv5yxgU4ngZfn0/JNZ8JBwxjTqS+s9kjJFG1unGUGLwMiIuXUD9EFhNIJuyCEAmVZSIGKH4G6v1gRR1LyzQKH2ZqiI1DnHMoDEZspbDjTeaFIAbSvjSq3A+n46y9hhVM8wIpnARSXyzmOD96d9UXvFroSPgGw1dq2vdEqDq9fJN1EbL2WulNmHkFDvxSO9ZT/RX/Bw2gA/BrF90XrJACereVfbV/YXaKfp77Nmx5NjEIUlxojsy7iN7nBHSZigfsbFyVOX1ZTeCCxvqnRSExP4lk5ZeYlRu9caaa743TWNdchRIhEWwadsBIe245C8clpaZ4zrPsk+OwXzxWCvRRumyNSLW5KWaSJyJU95cwheK76gr7228spZ3hmTtLyrfM2QRFqZFMR8/Q6yWfVgwTdfX2Ry4w3+eAO/5VT5nFb5NlzXPvBEAWrNZ6Q3jbH0RF4vcbp+fDngf/ywpoyNQtjrfvcq93AVb1RDWRghvyqgI2BkMr1rwYi8gizZ0G9GmPpMeqPerAQ0dJbzx+KAFM4IBq6iSLpZHUroeyfd9o5o+4fR2EtsZBoJORQEA4SW0CmeXSnblx2e9QkCHIodyqV6+g5ETEpZsLqnd/Na60EKPX/tQpPEcO+COIBPcQdszDzSiHGyQFPly/7KciUh1u+mFfxTCHGv9nn2WqndGgeGjQ/kr02qmTBX7Hc1qiEvgiSz1Tz/sy7Es29wvn6FrDGPP7asXlhOaiHxOctPvTptFA1kHFUk8bME7SsTSnGbFbUrssxrq70LhoSh5OwvQna+w84XdXhZb2sloJ4ZsCg3j+PrjJL08/JBi5zGd6ud/ZxhmcGKLOXPcNunQq5ESW92iJvfsuRrNYtawWwSmNhPYoFj2QqWNF0ffLpGt/ad24RJ8vkb5sXkpyKXmvFG5Vcdzf/44k3PBL/ojJ52+kWGzOArnyp5f969oV3J2c4Li27Nkova9VwRNVKqN0V+gV+mTHitgkXV30aWd3A1RSildEleiNPA+5cp+3+T7X+xfHiRZXQ1s4FA9TxIcnveQs9JSZ5r5qNmgqlW4zMtZ6rYNvgmyVcywKtu8ZxnSbS5vXlBV+NXdIfi3+xzrnJ0TkFL+Un8v1PWOC2PPFCjVPq7qTH7mOpzOYj/b4h0ceT+eHgr97Jqhb1ziVfeANzfN8bFUhPKBi7hJBCukQnB0aGjFTYLJPXL26lQ2b80xrOD5cFWgA8hz3St0e69kwNnD3+nX3gy12FjrjO+ddRvvvfyV3SWbXcxqNHfmsb9u1TV+wHTb9B07/L2sB8WUHJ9eeNomDyysEWZ0deqEhH/oWI2oiEh526gvAK1Nx2kIhNvkYR+tPYHEa9j+nd1VBpQP1uzSjIDO+fDDB7uy029rRjDC5Sk6aKczyz1D5uA9Lu+Rrrapl8JXNL3VRllNQH2K1ZFxOpX8LprttfqQ56MbPM0IttUheXWD/mROOeFqGUbL+kUOVlXLTFX/525g4faLEFO4qWWdmOXMNvVjpIVTWt650HfQjX9oT3Dg5Au6+v1/Ci78La6ZOngYCFPT1AUwxQuZ0yt5xKdNXLaDTISMTeCj16XTryhM36K2mfGRIgot71voWs8tTpL/f1rvcwv3LSDf+/G8THCT7NpfHWcW+lsF/ol8q9Bi6MezNTqp0rpp/kJRiVfNrX/w27cRRTu8RIIqtUblBMkxy4jwAVqCjUJkiPBj2cAoVloG8B2/N5deLdMhDb7xs5nhd3dubJhuj8WbaFRyu1L678DHhhA+rMimNo4C1kGpp0tD/qnCfCFHejpf0LJX43OTr578PY0tnIIrlWyNYyuR/ie6j2xNb1OV6u0dOX/1Dtcd7+ya9W+rY2LmnyQMtk8SMLTon8RAdwOaN2tNg5zVnDKlmVeOxPV2vhHIo9QEPV7jc3f+zVDquiNg1OaHX3cZXJDRY5MJpo+VanAcmqp4oasYLG+wrXUL5vJU0kqk2hGEskhP+Jjigrz1l6QnEwp6n8PMVeJp70Ii6ppeaK9GhF6fJE00ceLyxv08tKiPat4QdxZFgSbQknnEiCLD8Qc1rjazVKM3r3gXnnMeONgdz/yFV1q+haaN+wnF3Fn4uYCI9XsKOuVwDD0LsCO/f0gj5cmxCFcr7sclIcefWjvore+3aSU474cyqDVxH7w1RX3CHsaqsMRX17ZLgjsDXws3kLm2XJdM3Ku383UXqaHqsywzPhx7NFir0Fqjym/w6cxD2U9ypa3dx7Z12w/fi3Jps8sqJ8f8Ah8aZAvkHXvIRyrsxK7rrFaNNdNvjI8+3Emri195DCNa858anj2Qdny6Czshkn4N2+1m+k5S8sunX3Ja7I+JutRzg1mc2e9Yc0Zv9PZn1SwhxIdU9sXwZRTd/J5FoUm0e+PYREeHg3oc2YYzGf2xfJxXExt4pT3RfDRHvMXLUmoXOy63xv5pLuhOEax0dRgSywZ/GH+YBXFgCeTU0hZ8SPEFsn8punp1Kurd1KgXxUZ+la3R5+4ePGR4ZF5UQtOa83+Vj8zh80dfzbhxWCeoJnQ4dkZJM4drzknZOOKx2n3WrvJnzFIS8p0xeic+M3ZRVXIp10tV2DyYKwRxLzulPwzHcLlYTxl4PF7v8l106Azr+6wBFejbq/3P72C/0j78cepY9990/d4eAurn2lqdGKLU8FffnMw7cY7pVeXJRMU73Oxwi2g2vh/+4gX8dvbjfojn/eLVhhYl8GthwCQ50KcZq4z2JeW5eeOnJWFQEnVxDoG459TaC4zXybECEoJ0V5q1tXrQbDMtUxeTV6Pdt1/zJuc7TJoV/9YZFWxUtCf6Ou3Vd/vR/vG0138hJQrHkNeoep5dLe+6umcSquKvMaFpm3EZHDBOvCi0XYyIFHMgX7Cqp3JVXlxJFwQfHSaIUEbI2u1lBVUdlNw4Qa9UsLPEK94Qiln3pyKxQVCeNlx8yd7EegVNQBkFLabKvnietYVB4IPZ1fSor82arbgYec8aSdFMaIluYTYuNx32SxfrjKUdPGq+UNp5YpydoEG3xVLixtmHO9zXxKAnHnPuH2fPGrjx0GcuCDEU+yXUtXh6nfUL+cykws1gJ5vkfYFaFBr9PdCXvVf35OJQxzUMmWjv0W6uGJK11uAGDqSpOwCf6rouSIjPVgw57cJCOQ4b9tkI/Y5WNon9Swe72aZryKo8d+HyHBEdWJKrkary0LIGczA4Irq353Wc0Zga3om7UQiAGCvIl8GGyaqz5zH+1gMP5phWUCpKtttWIyicz09vXg76GxkmiGSMQ06Z9X8BUwqOtauDbPIf4rpK/yYoeAHxJ9soXS9VDe1Aw+awOOxaN8foLrif0TXBvQ55dtRtulRq9emFDBxlQcqKCaD8NeTSE7FOHvcjf/+oKbbtRqz9gbofoc2EzQ3pL6W5JdfJzAWmOk8oeoECe90lVMruwl/ltM015P/zIPazqvdvFmLNVHMIZrwiQ2tIKtGh6PDVH+85ew3caqVt2BsDv5rOcu3G9srQWd7NmgtzCRUXLYknYRSwtH9oUtkqyN3CfP20xQ1faXQl4MEmjQehWR6GmGnkdpYNQYeIG408yAX7uCZmYUic9juOfb+Re28+OVOB+scYK4DaPcBe+5wmji9gymtkMpKo4UKqCz7yxzuN8VIlx9yNozpRJpNaWHtaZVEqP45n2JemTlYBSmNIK1FuSYAUQ1yBLnKxevrjayd+h2i8PjdB3YY6b0nr3JuOXGpPMyh4V2dslpR3DFEvgpsBLqhqLDOWP4yEvIL6f21PpA7/8B"));
const $d6a5237190dccd49$var$$747425b437e121da$var$log2 = Math.log2 || ((n)=>Math.log(n) / Math.LN2);
const $d6a5237190dccd49$var$$747425b437e121da$var$bits = (n)=>$d6a5237190dccd49$var$$747425b437e121da$var$log2(n) + 1 | 0;
// compute the number of bits stored for each field
const $d6a5237190dccd49$var$$747425b437e121da$var$CATEGORY_BITS = $d6a5237190dccd49$var$$747425b437e121da$var$bits(/*@__PURE__*/ $d6a5237190dccd49$var$$parcel$interopDefault($d6a5237190dccd49$var$$f4087201da764553$exports).categories.length - 1);
const $d6a5237190dccd49$var$$747425b437e121da$var$COMBINING_BITS = $d6a5237190dccd49$var$$747425b437e121da$var$bits(/*@__PURE__*/ $d6a5237190dccd49$var$$parcel$interopDefault($d6a5237190dccd49$var$$f4087201da764553$exports).combiningClasses.length - 1);
const $d6a5237190dccd49$var$$747425b437e121da$var$SCRIPT_BITS = $d6a5237190dccd49$var$$747425b437e121da$var$bits(/*@__PURE__*/ $d6a5237190dccd49$var$$parcel$interopDefault($d6a5237190dccd49$var$$f4087201da764553$exports).scripts.length - 1);
const $d6a5237190dccd49$var$$747425b437e121da$var$EAW_BITS = $d6a5237190dccd49$var$$747425b437e121da$var$bits(/*@__PURE__*/ $d6a5237190dccd49$var$$parcel$interopDefault($d6a5237190dccd49$var$$f4087201da764553$exports).eaw.length - 1);
const $d6a5237190dccd49$var$$747425b437e121da$var$NUMBER_BITS = 10;
// compute shift and mask values for each field
const $d6a5237190dccd49$var$$747425b437e121da$var$CATEGORY_SHIFT = $d6a5237190dccd49$var$$747425b437e121da$var$COMBINING_BITS + $d6a5237190dccd49$var$$747425b437e121da$var$SCRIPT_BITS + $d6a5237190dccd49$var$$747425b437e121da$var$EAW_BITS + $d6a5237190dccd49$var$$747425b437e121da$var$NUMBER_BITS;
const $d6a5237190dccd49$var$$747425b437e121da$var$COMBINING_SHIFT = $d6a5237190dccd49$var$$747425b437e121da$var$SCRIPT_BITS + $d6a5237190dccd49$var$$747425b437e121da$var$EAW_BITS + $d6a5237190dccd49$var$$747425b437e121da$var$NUMBER_BITS;
const $d6a5237190dccd49$var$$747425b437e121da$var$SCRIPT_SHIFT = $d6a5237190dccd49$var$$747425b437e121da$var$EAW_BITS + $d6a5237190dccd49$var$$747425b437e121da$var$NUMBER_BITS;
const $d6a5237190dccd49$var$$747425b437e121da$var$EAW_SHIFT = $d6a5237190dccd49$var$$747425b437e121da$var$NUMBER_BITS;
const $d6a5237190dccd49$var$$747425b437e121da$var$CATEGORY_MASK = (1 << $d6a5237190dccd49$var$$747425b437e121da$var$CATEGORY_BITS) - 1;
const $d6a5237190dccd49$var$$747425b437e121da$var$COMBINING_MASK = (1 << $d6a5237190dccd49$var$$747425b437e121da$var$COMBINING_BITS) - 1;
const $d6a5237190dccd49$var$$747425b437e121da$var$SCRIPT_MASK = (1 << $d6a5237190dccd49$var$$747425b437e121da$var$SCRIPT_BITS) - 1;
const $d6a5237190dccd49$var$$747425b437e121da$var$EAW_MASK = (1 << $d6a5237190dccd49$var$$747425b437e121da$var$EAW_BITS) - 1;
const $d6a5237190dccd49$var$$747425b437e121da$var$NUMBER_MASK = (1 << $d6a5237190dccd49$var$$747425b437e121da$var$NUMBER_BITS) - 1;
function $d6a5237190dccd49$export$410364bbb673ddbc(codePoint) {
    const val = $d6a5237190dccd49$var$$747425b437e121da$var$trie.get(codePoint);
    return /*@__PURE__*/ $d6a5237190dccd49$var$$parcel$interopDefault($d6a5237190dccd49$var$$f4087201da764553$exports).categories[val >> $d6a5237190dccd49$var$$747425b437e121da$var$CATEGORY_SHIFT & $d6a5237190dccd49$var$$747425b437e121da$var$CATEGORY_MASK];
}
function $d6a5237190dccd49$export$c03b919c6651ed55(codePoint) {
    const val = $d6a5237190dccd49$var$$747425b437e121da$var$trie.get(codePoint);
    return /*@__PURE__*/ $d6a5237190dccd49$var$$parcel$interopDefault($d6a5237190dccd49$var$$f4087201da764553$exports).combiningClasses[val >> $d6a5237190dccd49$var$$747425b437e121da$var$COMBINING_SHIFT & $d6a5237190dccd49$var$$747425b437e121da$var$COMBINING_MASK];
}
function $d6a5237190dccd49$export$941569448d136665(codePoint) {
    const val = $d6a5237190dccd49$var$$747425b437e121da$var$trie.get(codePoint);
    return /*@__PURE__*/ $d6a5237190dccd49$var$$parcel$interopDefault($d6a5237190dccd49$var$$f4087201da764553$exports).scripts[val >> $d6a5237190dccd49$var$$747425b437e121da$var$SCRIPT_SHIFT & $d6a5237190dccd49$var$$747425b437e121da$var$SCRIPT_MASK];
}
function $d6a5237190dccd49$export$92f6187db8ca6d26(codePoint) {
    const val = $d6a5237190dccd49$var$$747425b437e121da$var$trie.get(codePoint);
    return /*@__PURE__*/ $d6a5237190dccd49$var$$parcel$interopDefault($d6a5237190dccd49$var$$f4087201da764553$exports).eaw[val >> $d6a5237190dccd49$var$$747425b437e121da$var$EAW_SHIFT & $d6a5237190dccd49$var$$747425b437e121da$var$EAW_MASK];
}
function $d6a5237190dccd49$export$7d1258ebb7625a0d(codePoint) {
    let val = $d6a5237190dccd49$var$$747425b437e121da$var$trie.get(codePoint);
    let num = val & $d6a5237190dccd49$var$$747425b437e121da$var$NUMBER_MASK;
    if (num === 0) return null;
    else if (num <= 50) return num - 1;
    else if (num < 0x1e0) {
        const numerator = (num >> 4) - 12;
        const denominator = (num & 0xf) + 1;
        return numerator / denominator;
    } else if (num < 0x300) {
        val = (num >> 5) - 14;
        let exp = (num & 0x1f) + 2;
        while(exp > 0){
            val *= 10;
            exp--;
        }
        return val;
    } else {
        val = (num >> 2) - 0xbf;
        let exp = (num & 3) + 1;
        while(exp > 0){
            val *= 60;
            exp--;
        }
        return val;
    }
}
function $d6a5237190dccd49$export$52c8ea63abd07594(codePoint) {
    const category = $d6a5237190dccd49$export$410364bbb673ddbc(codePoint);
    return category === "Lu" || category === "Ll" || category === "Lt" || category === "Lm" || category === "Lo" || category === "Nl";
}
function $d6a5237190dccd49$export$727d9dbc4fbb948f(codePoint) {
    return $d6a5237190dccd49$export$410364bbb673ddbc(codePoint) === "Nd";
}
function $d6a5237190dccd49$export$a5b49f4dc6a07d2c(codePoint) {
    const category = $d6a5237190dccd49$export$410364bbb673ddbc(codePoint);
    return category === "Pc" || category === "Pd" || category === "Pe" || category === "Pf" || category === "Pi" || category === "Po" || category === "Ps";
}
function $d6a5237190dccd49$export$7b6804e8df61fcf5(codePoint) {
    return $d6a5237190dccd49$export$410364bbb673ddbc(codePoint) === "Ll";
}
function $d6a5237190dccd49$export$aebd617640818cda(codePoint) {
    return $d6a5237190dccd49$export$410364bbb673ddbc(codePoint) === "Lu";
}
function $d6a5237190dccd49$export$de8b4ee23b2cf823(codePoint) {
    return $d6a5237190dccd49$export$410364bbb673ddbc(codePoint) === "Lt";
}
function $d6a5237190dccd49$export$3c52dd84024ae72c(codePoint) {
    const category = $d6a5237190dccd49$export$410364bbb673ddbc(codePoint);
    return category === "Zs" || category === "Zl" || category === "Zp";
}
function $d6a5237190dccd49$export$a11bdcffe109e74b(codePoint) {
    const category = $d6a5237190dccd49$export$410364bbb673ddbc(codePoint);
    return category === "Nd" || category === "No" || category === "Nl" || category === "Lu" || category === "Ll" || category === "Lt" || category === "Lm" || category === "Lo" || category === "Me" || category === "Mc";
}
function $d6a5237190dccd49$export$e33ad6871e762338(codePoint) {
    const category = $d6a5237190dccd49$export$410364bbb673ddbc(codePoint);
    return category === "Mn" || category === "Me" || category === "Mc";
}
var $d6a5237190dccd49$export$2e2bcd8739ae039 = {
    getCategory: $d6a5237190dccd49$export$410364bbb673ddbc,
    getCombiningClass: $d6a5237190dccd49$export$c03b919c6651ed55,
    getScript: $d6a5237190dccd49$export$941569448d136665,
    getEastAsianWidth: $d6a5237190dccd49$export$92f6187db8ca6d26,
    getNumericValue: $d6a5237190dccd49$export$7d1258ebb7625a0d,
    isAlphabetic: $d6a5237190dccd49$export$52c8ea63abd07594,
    isDigit: $d6a5237190dccd49$export$727d9dbc4fbb948f,
    isPunctuation: $d6a5237190dccd49$export$a5b49f4dc6a07d2c,
    isLowerCase: $d6a5237190dccd49$export$7b6804e8df61fcf5,
    isUpperCase: $d6a5237190dccd49$export$aebd617640818cda,
    isTitleCase: $d6a5237190dccd49$export$de8b4ee23b2cf823,
    isWhiteSpace: $d6a5237190dccd49$export$3c52dd84024ae72c,
    isBaseForm: $d6a5237190dccd49$export$a11bdcffe109e74b,
    isMark: $d6a5237190dccd49$export$e33ad6871e762338
};



var $c6d6097ed0788124$exports = {};
'use strict';
var $c6d6097ed0788124$var$INITIAL_STATE = 1;
var $c6d6097ed0788124$var$FAIL_STATE = 0;
/**
 * A StateMachine represents a deterministic finite automaton.
 * It can perform matches over a sequence of values, similar to a regular expression.
 */ class $c6d6097ed0788124$var$StateMachine {
    constructor(dfa){
        this.stateTable = dfa.stateTable;
        this.accepting = dfa.accepting;
        this.tags = dfa.tags;
    }
    /**
   * Returns an iterable object that yields pattern matches over the input sequence.
   * Matches are of the form [startIndex, endIndex, tags].
   */ match(str) {
        var self = this;
        return {
            *[Symbol.iterator] () {
                var state = $c6d6097ed0788124$var$INITIAL_STATE;
                var startRun = null;
                var lastAccepting = null;
                var lastState = null;
                for(var p = 0; p < str.length; p++){
                    var c = str[p];
                    lastState = state;
                    state = self.stateTable[state][c];
                    if (state === $c6d6097ed0788124$var$FAIL_STATE) {
                        // yield the last match if any
                        if (startRun != null && lastAccepting != null && lastAccepting >= startRun) yield [
                            startRun,
                            lastAccepting,
                            self.tags[lastState]
                        ];
                         // reset the state as if we started over from the initial state
                        state = self.stateTable[$c6d6097ed0788124$var$INITIAL_STATE][c];
                        startRun = null;
                    } // start a run if not in the failure state
                    if (state !== $c6d6097ed0788124$var$FAIL_STATE && startRun == null) startRun = p;
                     // if accepting, mark the potential match end
                    if (self.accepting[state]) lastAccepting = p;
                     // reset the state to the initial state if we get into the failure state
                    if (state === $c6d6097ed0788124$var$FAIL_STATE) state = $c6d6097ed0788124$var$INITIAL_STATE;
                } // yield the last match if any
                if (startRun != null && lastAccepting != null && lastAccepting >= startRun) yield [
                    startRun,
                    lastAccepting,
                    self.tags[state]
                ];
            }
        };
    }
    /**
   * For each match over the input sequence, action functions matching
   * the tag definitions in the input pattern are called with the startIndex,
   * endIndex, and sub-match sequence.
   */ apply(str, actions) {
        for (var [start, end, tags] of this.match(str)){
            for (var tag of tags)if (typeof actions[tag] === 'function') actions[tag](start, end, str.slice(start, end + 1));
        }
    }
}
$c6d6097ed0788124$exports = $c6d6097ed0788124$var$StateMachine;


var $13713ba45ec0095d$exports = {};

var $cbQCu = parcelRequire("cbQCu");
var $13713ba45ec0095d$require$Buffer = $cbQCu.Buffer;
var $13713ba45ec0095d$var$clone = function() {
    'use strict';
    function _instanceof(obj, type) {
        return type != null && obj instanceof type;
    }
    var nativeMap;
    try {
        nativeMap = Map;
    } catch (_) {
        // maybe a reference error because no `Map`. Give it a dummy value that no
        // value will ever be an instanceof.
        nativeMap = function() {};
    }
    var nativeSet;
    try {
        nativeSet = Set;
    } catch (_) {
        nativeSet = function() {};
    }
    var nativePromise;
    try {
        nativePromise = Promise;
    } catch (_) {
        nativePromise = function() {};
    }
    /**
 * Clones (copies) an Object using deep copying.
 *
 * This function supports circular references by default, but if you are certain
 * there are no circular references in your object, you can save some CPU time
 * by calling clone(obj, false).
 *
 * Caution: if `circular` is false and `parent` contains circular references,
 * your program may enter an infinite loop and crash.
 *
 * @param `parent` - the object to be cloned
 * @param `circular` - set to true if the object to be cloned may contain
 *    circular references. (optional - true by default)
 * @param `depth` - set to a number if the object is only to be cloned to
 *    a particular depth. (optional - defaults to Infinity)
 * @param `prototype` - sets the prototype to be used when cloning an object.
 *    (optional - defaults to parent prototype).
 * @param `includeNonEnumerable` - set to true if the non-enumerable properties
 *    should be cloned as well. Non-enumerable properties on the prototype
 *    chain will be ignored. (optional - false by default)
*/ function clone(parent, circular, depth, prototype, includeNonEnumerable) {
        if (typeof circular === 'object') {
            depth = circular.depth;
            prototype = circular.prototype;
            includeNonEnumerable = circular.includeNonEnumerable;
            circular = circular.circular;
        }
        // maintain two arrays for circular references, where corresponding parents
        // and children have the same index
        var allParents = [];
        var allChildren = [];
        var useBuffer = typeof $13713ba45ec0095d$require$Buffer != 'undefined';
        if (typeof circular == 'undefined') circular = true;
        if (typeof depth == 'undefined') depth = Infinity;
        // recurse this function so we don't reset allParents and allChildren
        function _clone(parent, depth) {
            // cloning null always returns null
            if (parent === null) return null;
            if (depth === 0) return parent;
            var child;
            var proto;
            if (typeof parent != 'object') return parent;
            if (_instanceof(parent, nativeMap)) child = new nativeMap();
            else if (_instanceof(parent, nativeSet)) child = new nativeSet();
            else if (_instanceof(parent, nativePromise)) child = new nativePromise(function(resolve, reject) {
                parent.then(function(value) {
                    resolve(_clone(value, depth - 1));
                }, function(err) {
                    reject(_clone(err, depth - 1));
                });
            });
            else if (clone.__isArray(parent)) child = [];
            else if (clone.__isRegExp(parent)) {
                child = new RegExp(parent.source, __getRegExpFlags(parent));
                if (parent.lastIndex) child.lastIndex = parent.lastIndex;
            } else if (clone.__isDate(parent)) child = new Date(parent.getTime());
            else if (useBuffer && $13713ba45ec0095d$require$Buffer.isBuffer(parent)) {
                if ($13713ba45ec0095d$require$Buffer.allocUnsafe) // Node.js >= 4.5.0
                child = $13713ba45ec0095d$require$Buffer.allocUnsafe(parent.length);
                else // Older Node.js versions
                child = new $13713ba45ec0095d$require$Buffer(parent.length);
                parent.copy(child);
                return child;
            } else if (_instanceof(parent, Error)) child = Object.create(parent);
            else if (typeof prototype == 'undefined') {
                proto = Object.getPrototypeOf(parent);
                child = Object.create(proto);
            } else {
                child = Object.create(prototype);
                proto = prototype;
            }
            if (circular) {
                var index = allParents.indexOf(parent);
                if (index != -1) return allChildren[index];
                allParents.push(parent);
                allChildren.push(child);
            }
            if (_instanceof(parent, nativeMap)) parent.forEach(function(value, key) {
                var keyChild = _clone(key, depth - 1);
                var valueChild = _clone(value, depth - 1);
                child.set(keyChild, valueChild);
            });
            if (_instanceof(parent, nativeSet)) parent.forEach(function(value) {
                var entryChild = _clone(value, depth - 1);
                child.add(entryChild);
            });
            for(var i in parent){
                var attrs;
                if (proto) attrs = Object.getOwnPropertyDescriptor(proto, i);
                if (attrs && attrs.set == null) continue;
                child[i] = _clone(parent[i], depth - 1);
            }
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(parent);
                for(var i = 0; i < symbols.length; i++){
                    // Don't need to worry about cloning a symbol because it is a primitive,
                    // like a number or string.
                    var symbol = symbols[i];
                    var descriptor = Object.getOwnPropertyDescriptor(parent, symbol);
                    if (descriptor && !descriptor.enumerable && !includeNonEnumerable) continue;
                    child[symbol] = _clone(parent[symbol], depth - 1);
                    if (!descriptor.enumerable) Object.defineProperty(child, symbol, {
                        enumerable: false
                    });
                }
            }
            if (includeNonEnumerable) {
                var allPropertyNames = Object.getOwnPropertyNames(parent);
                for(var i = 0; i < allPropertyNames.length; i++){
                    var propertyName = allPropertyNames[i];
                    var descriptor = Object.getOwnPropertyDescriptor(parent, propertyName);
                    if (descriptor && descriptor.enumerable) continue;
                    child[propertyName] = _clone(parent[propertyName], depth - 1);
                    Object.defineProperty(child, propertyName, {
                        enumerable: false
                    });
                }
            }
            return child;
        }
        return _clone(parent, depth);
    }
    /**
 * Simple flat clone using prototype, accepts only objects, usefull for property
 * override on FLAT configuration object (no nested props).
 *
 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
 * works.
 */ clone.clonePrototype = function clonePrototype(parent) {
        if (parent === null) return null;
        var c = function() {};
        c.prototype = parent;
        return new c();
    };
    // private utility functions
    function __objToStr(o) {
        return Object.prototype.toString.call(o);
    }
    clone.__objToStr = __objToStr;
    function __isDate(o) {
        return typeof o === 'object' && __objToStr(o) === '[object Date]';
    }
    clone.__isDate = __isDate;
    function __isArray(o) {
        return typeof o === 'object' && __objToStr(o) === '[object Array]';
    }
    clone.__isArray = __isArray;
    function __isRegExp(o) {
        return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
    }
    clone.__isRegExp = __isRegExp;
    function __getRegExpFlags(re) {
        var flags = '';
        if (re.global) flags += 'g';
        if (re.ignoreCase) flags += 'i';
        if (re.multiline) flags += 'm';
        return flags;
    }
    clone.__getRegExpFlags = __getRegExpFlags;
    return clone;
}();
if ($13713ba45ec0095d$exports) $13713ba45ec0095d$exports = $13713ba45ec0095d$var$clone;



var $fd75a3cd9cfec8fb$exports = {};

$fd75a3cd9cfec8fb$exports = (parcelRequire("FSPyV")).BrotliDecompressBuffer;


function $6d519e6f260f4e02$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $6d519e6f260f4e02$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
var $6d519e6f260f4e02$var$$d636bc798e7178db$exports = {};
$6d519e6f260f4e02$var$$parcel$export($6d519e6f260f4e02$var$$d636bc798e7178db$exports, "logErrors", ()=>$6d519e6f260f4e02$export$bd5c5d8b8dcafd78);
$6d519e6f260f4e02$var$$parcel$export($6d519e6f260f4e02$var$$d636bc798e7178db$exports, "registerFormat", ()=>$6d519e6f260f4e02$export$36b2f24e97d43be);
$6d519e6f260f4e02$var$$parcel$export($6d519e6f260f4e02$var$$d636bc798e7178db$exports, "create", ()=>$6d519e6f260f4e02$export$185802fd694ee1f5);
$6d519e6f260f4e02$var$$parcel$export($6d519e6f260f4e02$var$$d636bc798e7178db$exports, "defaultLanguage", ()=>$6d519e6f260f4e02$export$42940898df819940);
$6d519e6f260f4e02$var$$parcel$export($6d519e6f260f4e02$var$$d636bc798e7178db$exports, "setDefaultLanguage", ()=>$6d519e6f260f4e02$export$5157e7780d44cc36);
let $6d519e6f260f4e02$export$bd5c5d8b8dcafd78 = false;
let $6d519e6f260f4e02$var$$d636bc798e7178db$var$formats = [];
function $6d519e6f260f4e02$export$36b2f24e97d43be(format) {
    $6d519e6f260f4e02$var$$d636bc798e7178db$var$formats.push(format);
}
function $6d519e6f260f4e02$export$185802fd694ee1f5(buffer, postscriptName) {
    for(let i = 0; i < $6d519e6f260f4e02$var$$d636bc798e7178db$var$formats.length; i++){
        let format = $6d519e6f260f4e02$var$$d636bc798e7178db$var$formats[i];
        if (format.probe(buffer)) {
            let font = new format(new (0, $ddbeea1419c36d9b$export$c18b354bac7948e9)(buffer));
            if (postscriptName) return font.getFont(postscriptName);
            return font;
        }
    }
    throw new Error('Unknown font format');
}
let $6d519e6f260f4e02$export$42940898df819940 = 'en';
function $6d519e6f260f4e02$export$5157e7780d44cc36(lang = 'en') {
    $6d519e6f260f4e02$export$42940898df819940 = lang;
}
/**
 * This decorator caches the results of a getter or method such that
 * the results are lazily computed once, and then cached.
 * @private
 */ function $6d519e6f260f4e02$var$$e71565f2ce09cb6b$export$69a3209f1a06c04d(target, key, descriptor) {
    if (descriptor.get) {
        let get = descriptor.get;
        descriptor.get = function() {
            let value = get.call(this);
            Object.defineProperty(this, key, {
                value: value
            });
            return value;
        };
    } else if (typeof descriptor.value === 'function') {
        let fn = descriptor.value;
        return {
            get () {
                let cache = new Map;
                function memoized(...args) {
                    let key = args.length > 0 ? args[0] : 'value';
                    if (cache.has(key)) return cache.get(key);
                    let result = fn.apply(this, args);
                    cache.set(key, result);
                    return result;
                }
                Object.defineProperty(this, key, {
                    value: memoized
                });
                return memoized;
            }
        };
    }
}
let $6d519e6f260f4e02$var$$26a62205ad06574e$var$SubHeader = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    firstCode: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    entryCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    idDelta: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    idRangeOffset: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456)
});
let $6d519e6f260f4e02$var$$26a62205ad06574e$var$CmapGroup = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    startCharCode: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    endCharCode: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    glyphID: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d)
});
let $6d519e6f260f4e02$var$$26a62205ad06574e$var$UnicodeValueRange = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    startUnicodeValue: (0, $2b9a2a5e7d043014$export$1925298fbd719b21),
    additionalCount: (0, $2b9a2a5e7d043014$export$52e103c63c4e68cf)
});
let $6d519e6f260f4e02$var$$26a62205ad06574e$var$UVSMapping = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    unicodeValue: (0, $2b9a2a5e7d043014$export$1925298fbd719b21),
    glyphID: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456)
});
let $6d519e6f260f4e02$var$$26a62205ad06574e$var$DefaultUVS = new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$26a62205ad06574e$var$UnicodeValueRange, (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d));
let $6d519e6f260f4e02$var$$26a62205ad06574e$var$NonDefaultUVS = new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$26a62205ad06574e$var$UVSMapping, (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d));
let $6d519e6f260f4e02$var$$26a62205ad06574e$var$VarSelectorRecord = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    varSelector: (0, $2b9a2a5e7d043014$export$1925298fbd719b21),
    defaultUVS: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), $6d519e6f260f4e02$var$$26a62205ad06574e$var$DefaultUVS, {
        type: 'parent'
    }),
    nonDefaultUVS: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), $6d519e6f260f4e02$var$$26a62205ad06574e$var$NonDefaultUVS, {
        type: 'parent'
    })
});
let $6d519e6f260f4e02$var$$26a62205ad06574e$var$CmapSubtable = new (0, $00bf8c7e3dccf9c9$export$95a8b60f4da7dec8)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), {
    0: {
        length: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        language: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        codeMap: new (0, $ed4a2faff705c483$export$5576c026028d4983)((0, $2b9a2a5e7d043014$export$52e103c63c4e68cf), 256)
    },
    2: {
        length: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        language: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        subHeaderKeys: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), 256),
        subHeaderCount: (t)=>Math.max.apply(Math, t.subHeaderKeys),
        subHeaders: new (0, $ed4a2faff705c483$export$5576c026028d4983)($6d519e6f260f4e02$var$$26a62205ad06574e$var$SubHeader, 'subHeaderCount'),
        glyphIndexArray: new (0, $ed4a2faff705c483$export$5576c026028d4983)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), 'subHeaderCount')
    },
    4: {
        length: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        language: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        segCountX2: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        segCount: (t)=>t.segCountX2 >> 1,
        searchRange: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        entrySelector: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        rangeShift: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        endCode: new (0, $ed4a2faff705c483$export$5576c026028d4983)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), 'segCount'),
        reservedPad: new (0, $f612a7b97d3685e8$export$da9b5fe187a9aa1)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456)),
        startCode: new (0, $ed4a2faff705c483$export$5576c026028d4983)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), 'segCount'),
        idDelta: new (0, $ed4a2faff705c483$export$5576c026028d4983)((0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6), 'segCount'),
        idRangeOffset: new (0, $ed4a2faff705c483$export$5576c026028d4983)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), 'segCount'),
        glyphIndexArray: new (0, $ed4a2faff705c483$export$5576c026028d4983)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), (t)=>(t.length - t._currentOffset) / 2)
    },
    6: {
        length: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        language: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        firstCode: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        entryCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        glyphIndices: new (0, $ed4a2faff705c483$export$5576c026028d4983)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), 'entryCount')
    },
    8: {
        reserved: new (0, $f612a7b97d3685e8$export$da9b5fe187a9aa1)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456)),
        length: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
        language: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        is32: new (0, $ed4a2faff705c483$export$5576c026028d4983)((0, $2b9a2a5e7d043014$export$52e103c63c4e68cf), 8192),
        nGroups: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
        groups: new (0, $ed4a2faff705c483$export$5576c026028d4983)($6d519e6f260f4e02$var$$26a62205ad06574e$var$CmapGroup, 'nGroups')
    },
    10: {
        reserved: new (0, $f612a7b97d3685e8$export$da9b5fe187a9aa1)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456)),
        length: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
        language: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
        firstCode: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
        entryCount: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
        glyphIndices: new (0, $ed4a2faff705c483$export$5576c026028d4983)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), 'numChars')
    },
    12: {
        reserved: new (0, $f612a7b97d3685e8$export$da9b5fe187a9aa1)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456)),
        length: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
        language: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
        nGroups: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
        groups: new (0, $ed4a2faff705c483$export$5576c026028d4983)($6d519e6f260f4e02$var$$26a62205ad06574e$var$CmapGroup, 'nGroups')
    },
    13: {
        reserved: new (0, $f612a7b97d3685e8$export$da9b5fe187a9aa1)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456)),
        length: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
        language: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
        nGroups: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
        groups: new (0, $ed4a2faff705c483$export$5576c026028d4983)($6d519e6f260f4e02$var$$26a62205ad06574e$var$CmapGroup, 'nGroups')
    },
    14: {
        length: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
        numRecords: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
        varSelectors: new (0, $ed4a2faff705c483$export$5576c026028d4983)($6d519e6f260f4e02$var$$26a62205ad06574e$var$VarSelectorRecord, 'numRecords')
    }
});
let $6d519e6f260f4e02$var$$26a62205ad06574e$var$CmapEntry = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    platformID: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    encodingID: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    table: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), $6d519e6f260f4e02$var$$26a62205ad06574e$var$CmapSubtable, {
        type: 'parent',
        lazy: true
    })
});
var $6d519e6f260f4e02$var$$26a62205ad06574e$export$2e2bcd8739ae039 = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    version: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    numSubtables: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    tables: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$26a62205ad06574e$var$CmapEntry, 'numSubtables')
});
var $6d519e6f260f4e02$var$$f2612a29f92ac062$export$2e2bcd8739ae039 = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    version: (0, $2b9a2a5e7d043014$export$1d95835383bb05a),
    revision: (0, $2b9a2a5e7d043014$export$1d95835383bb05a),
    checkSumAdjustment: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    magicNumber: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    flags: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    unitsPerEm: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    created: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$1d95835383bb05a), 2),
    modified: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$1d95835383bb05a), 2),
    xMin: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    yMin: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    xMax: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    yMax: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    macStyle: new (0, $701e08229fc30ff7$export$96b43b8a49f688ea)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), [
        'bold',
        'italic',
        'underline',
        'outline',
        'shadow',
        'condensed',
        'extended'
    ]),
    lowestRecPPEM: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    fontDirectionHint: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    indexToLocFormat: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    glyphDataFormat: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6 // 0 for current format
    )
});
var $6d519e6f260f4e02$var$$2c179dd593583073$export$2e2bcd8739ae039 = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    version: (0, $2b9a2a5e7d043014$export$1d95835383bb05a),
    ascent: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    descent: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    lineGap: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    advanceWidthMax: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    minLeftSideBearing: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    minRightSideBearing: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    xMaxExtent: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    caretSlopeRise: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    caretSlopeRun: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    caretOffset: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    reserved: new (0, $f612a7b97d3685e8$export$da9b5fe187a9aa1)((0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6), 4),
    metricDataFormat: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    numberOfMetrics: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456 // Number of advance widths in 'hmtx' table
    )
});
let $6d519e6f260f4e02$var$$bdc9060542264b85$var$HmtxEntry = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    advance: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    bearing: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6)
});
var $6d519e6f260f4e02$var$$bdc9060542264b85$export$2e2bcd8739ae039 = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    metrics: new (0, $ed4a2faff705c483$export$5576c026028d4983)($6d519e6f260f4e02$var$$bdc9060542264b85$var$HmtxEntry, (t)=>t.parent.hhea.numberOfMetrics),
    bearings: new (0, $ed4a2faff705c483$export$5576c026028d4983)((0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6), (t)=>t.parent.maxp.numGlyphs - t.parent.hhea.numberOfMetrics)
});
var $6d519e6f260f4e02$var$$dbf51cb3d3fe409d$export$2e2bcd8739ae039 = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    version: (0, $2b9a2a5e7d043014$export$1d95835383bb05a),
    numGlyphs: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    maxPoints: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    maxContours: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    maxComponentPoints: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    maxComponentContours: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    maxZones: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    maxTwilightPoints: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    maxStorage: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    maxFunctionDefs: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    maxInstructionDefs: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    maxStackElements: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    maxSizeOfInstructions: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    maxComponentElements: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    maxComponentDepth: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456 // Maximum levels of recursion; 1 for simple components
    )
});
/**
 * Gets an encoding name from platform, encoding, and language ids.
 * Returned encoding names can be used in iconv-lite to decode text.
 */ function $6d519e6f260f4e02$var$$e449ad78d50845fe$export$badc544e0651b6b1(platformID, encodingID, languageID = 0) {
    if (platformID === 1 && $6d519e6f260f4e02$var$$e449ad78d50845fe$export$479e671907f486d1[languageID]) return $6d519e6f260f4e02$var$$e449ad78d50845fe$export$479e671907f486d1[languageID];
    return $6d519e6f260f4e02$var$$e449ad78d50845fe$export$6fef87b7618bdf0b[platformID][encodingID];
}
const $6d519e6f260f4e02$var$$e449ad78d50845fe$var$SINGLE_BYTE_ENCODINGS = new Set([
    'x-mac-roman',
    'x-mac-cyrillic',
    'iso-8859-6',
    'iso-8859-8'
]);
const $6d519e6f260f4e02$var$$e449ad78d50845fe$var$MAC_ENCODINGS = {
    'x-mac-croatian': "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\u0160\u2122\xb4\xa8\u2260\u017D\xd8\u221E\xb1\u2264\u2265\u2206\xb5\u2202\u2211\u220F\u0161\u222B\xaa\xba\u03A9\u017E\xf8\xbf\xa1\xac\u221A\u0192\u2248\u0106\xab\u010C\u2026 \xc0\xc3\xd5\u0152\u0153\u0110\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\uF8FF\xa9\u2044\u20AC\u2039\u203A\xc6\xbb\u2013\xb7\u201A\u201E\u2030\xc2\u0107\xc1\u010D\xc8\xcd\xce\xcf\xcc\xd3\xd4\u0111\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u03C0\xcb\u02DA\xb8\xca\xe6\u02C7",
    'x-mac-gaelic': "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u1E02\xb1\u2264\u2265\u1E03\u010A\u010B\u1E0A\u1E0B\u1E1E\u1E1F\u0120\u0121\u1E40\xe6\xf8\u1E41\u1E56\u1E57\u027C\u0192\u017F\u1E60\xab\xbb\u2026 \xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\u1E61\u1E9B\xff\u0178\u1E6A\u20AC\u2039\u203A\u0176\u0177\u1E6B\xb7\u1EF2\u1EF3\u204A\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\u2663\xd2\xda\xdb\xd9\u0131\xdd\xfd\u0174\u0175\u1E84\u1E85\u1E80\u1E81\u1E82\u1E83",
    'x-mac-greek': "\xc4\xb9\xb2\xc9\xb3\xd6\xdc\u0385\xe0\xe2\xe4\u0384\xa8\xe7\xe9\xe8\xea\xeb\xa3\u2122\xee\xef\u2022\xbd\u2030\xf4\xf6\xa6\u20AC\xf9\xfb\xfc\u2020\u0393\u0394\u0398\u039B\u039E\u03A0\xdf\xae\xa9\u03A3\u03AA\xa7\u2260\xb0\xb7\u0391\xb1\u2264\u2265\xa5\u0392\u0395\u0396\u0397\u0399\u039A\u039C\u03A6\u03AB\u03A8\u03A9\u03AC\u039D\xac\u039F\u03A1\u2248\u03A4\xab\xbb\u2026 \u03A5\u03A7\u0386\u0388\u0153\u2013\u2015\u201C\u201D\u2018\u2019\xf7\u0389\u038A\u038C\u038E\u03AD\u03AE\u03AF\u03CC\u038F\u03CD\u03B1\u03B2\u03C8\u03B4\u03B5\u03C6\u03B3\u03B7\u03B9\u03BE\u03BA\u03BB\u03BC\u03BD\u03BF\u03C0\u03CE\u03C1\u03C3\u03C4\u03B8\u03C9\u03C2\u03C7\u03C5\u03B6\u03CA\u03CB\u0390\u03B0\xad",
    'x-mac-icelandic': "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\xdd\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u03A9\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026 \xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\u20AC\xd0\xf0\xde\xfe\xfd\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uF8FF\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7",
    'x-mac-inuit': "\u1403\u1404\u1405\u1406\u140A\u140B\u1431\u1432\u1433\u1434\u1438\u1439\u1449\u144E\u144F\u1450\u1451\u1455\u1456\u1466\u146D\u146E\u146F\u1470\u1472\u1473\u1483\u148B\u148C\u148D\u148E\u1490\u1491\xb0\u14A1\u14A5\u14A6\u2022\xb6\u14A7\xae\xa9\u2122\u14A8\u14AA\u14AB\u14BB\u14C2\u14C3\u14C4\u14C5\u14C7\u14C8\u14D0\u14EF\u14F0\u14F1\u14F2\u14F4\u14F5\u1505\u14D5\u14D6\u14D7\u14D8\u14DA\u14DB\u14EA\u1528\u1529\u152A\u152B\u152D\u2026 \u152E\u153E\u1555\u1556\u1557\u2013\u2014\u201C\u201D\u2018\u2019\u1558\u1559\u155A\u155D\u1546\u1547\u1548\u1549\u154B\u154C\u1550\u157F\u1580\u1581\u1582\u1583\u1584\u1585\u158F\u1590\u1591\u1592\u1593\u1594\u1595\u1671\u1672\u1673\u1674\u1675\u1676\u1596\u15A0\u15A1\u15A2\u15A3\u15A4\u15A5\u15A6\u157C\u0141\u0142",
    'x-mac-ce': "\xc4\u0100\u0101\xc9\u0104\xd6\xdc\xe1\u0105\u010C\xe4\u010D\u0106\u0107\xe9\u0179\u017A\u010E\xed\u010F\u0112\u0113\u0116\xf3\u0117\xf4\xf6\xf5\xfa\u011A\u011B\xfc\u2020\xb0\u0118\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\u0119\xa8\u2260\u0123\u012E\u012F\u012A\u2264\u2265\u012B\u0136\u2202\u2211\u0142\u013B\u013C\u013D\u013E\u0139\u013A\u0145\u0146\u0143\xac\u221A\u0144\u0147\u2206\xab\xbb\u2026 \u0148\u0150\xd5\u0151\u014C\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\u014D\u0154\u0155\u0158\u2039\u203A\u0159\u0156\u0157\u0160\u201A\u201E\u0161\u015A\u015B\xc1\u0164\u0165\xcd\u017D\u017E\u016A\xd3\xd4\u016B\u016E\xda\u016F\u0170\u0171\u0172\u0173\xdd\xfd\u0137\u017B\u0141\u017C\u0122\u02C7",
    'x-mac-romanian': "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\u0102\u0218\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u03A9\u0103\u0219\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026 \xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\u20AC\u2039\u203A\u021A\u021B\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uF8FF\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7",
    'x-mac-turkish': "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u03A9\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026 \xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u011E\u011F\u0130\u0131\u015E\u015F\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uF8FF\xd2\xda\xdb\xd9\uF8A0\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7"
};
const $6d519e6f260f4e02$var$$e449ad78d50845fe$var$encodingCache = new Map();
function $6d519e6f260f4e02$var$$e449ad78d50845fe$export$1dceb3c14ed68bee(encoding) {
    let cached = $6d519e6f260f4e02$var$$e449ad78d50845fe$var$encodingCache.get(encoding);
    if (cached) return cached;
    // These encodings aren't supported by TextDecoder.
    let mapping = $6d519e6f260f4e02$var$$e449ad78d50845fe$var$MAC_ENCODINGS[encoding];
    if (mapping) {
        let res = new Map();
        for(let i = 0; i < mapping.length; i++)res.set(mapping.charCodeAt(i), 0x80 + i);
        $6d519e6f260f4e02$var$$e449ad78d50845fe$var$encodingCache.set(encoding, res);
        return res;
    }
    // Only single byte encodings can be mapped 1:1.
    if ($6d519e6f260f4e02$var$$e449ad78d50845fe$var$SINGLE_BYTE_ENCODINGS.has(encoding)) {
        // TextEncoder only supports utf8, whereas TextDecoder supports legacy encodings.
        // Use this to create a mapping of code points.
        let decoder = new TextDecoder(encoding);
        let mapping = new Uint8Array(0x80);
        for(let i = 0; i < 0x80; i++)mapping[i] = 0x80 + i;
        let res = new Map();
        let s = decoder.decode(mapping);
        for(let i = 0; i < 0x80; i++)res.set(s.charCodeAt(i), 0x80 + i);
        $6d519e6f260f4e02$var$$e449ad78d50845fe$var$encodingCache.set(encoding, res);
        return res;
    }
}
const $6d519e6f260f4e02$var$$e449ad78d50845fe$export$6fef87b7618bdf0b = [
    // unicode
    [
        'utf-16be',
        'utf-16be',
        'utf-16be',
        'utf-16be',
        'utf-16be',
        'utf-16be',
        'utf-16be'
    ],
    // macintosh
    // Mappings available at http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/
    // 0	Roman                 17	Malayalam
    // 1	Japanese	            18	Sinhalese
    // 2	Traditional Chinese	  19	Burmese
    // 3	Korean	              20	Khmer
    // 4	Arabic	              21	Thai
    // 5	Hebrew	              22	Laotian
    // 6	Greek	                23	Georgian
    // 7	Russian	              24	Armenian
    // 8	RSymbol	              25	Simplified Chinese
    // 9	Devanagari	          26	Tibetan
    // 10	Gurmukhi	            27	Mongolian
    // 11	Gujarati	            28	Geez
    // 12	Oriya	                29	Slavic
    // 13	Bengali	              30	Vietnamese
    // 14	Tamil	                31	Sindhi
    // 15	Telugu	              32	(Uninterpreted)
    // 16	Kannada
    [
        'x-mac-roman',
        'shift-jis',
        'big5',
        'euc-kr',
        'iso-8859-6',
        'iso-8859-8',
        'x-mac-greek',
        'x-mac-cyrillic',
        'x-mac-symbol',
        'x-mac-devanagari',
        'x-mac-gurmukhi',
        'x-mac-gujarati',
        'Oriya',
        'Bengali',
        'Tamil',
        'Telugu',
        'Kannada',
        'Malayalam',
        'Sinhalese',
        'Burmese',
        'Khmer',
        'iso-8859-11',
        'Laotian',
        'Georgian',
        'Armenian',
        'gbk',
        'Tibetan',
        'Mongolian',
        'Geez',
        'x-mac-ce',
        'Vietnamese',
        'Sindhi'
    ],
    // ISO (deprecated)
    [
        'ascii',
        null,
        'iso-8859-1'
    ],
    // windows
    // Docs here: http://msdn.microsoft.com/en-us/library/system.text.encoding(v=vs.110).aspx
    [
        'symbol',
        'utf-16be',
        'shift-jis',
        'gb18030',
        'big5',
        'euc-kr',
        'johab',
        null,
        null,
        null,
        'utf-16be'
    ]
];
const $6d519e6f260f4e02$var$$e449ad78d50845fe$export$479e671907f486d1 = {
    15: 'x-mac-icelandic',
    17: 'x-mac-turkish',
    18: 'x-mac-croatian',
    24: 'x-mac-ce',
    25: 'x-mac-ce',
    26: 'x-mac-ce',
    27: 'x-mac-ce',
    28: 'x-mac-ce',
    30: 'x-mac-icelandic',
    37: 'x-mac-romanian',
    38: 'x-mac-ce',
    39: 'x-mac-ce',
    40: 'x-mac-ce',
    143: 'x-mac-inuit',
    146: 'x-mac-gaelic'
};
const $6d519e6f260f4e02$var$$e449ad78d50845fe$export$2092376fd002e13 = [
    // unicode
    [],
    {
        0: 'en',
        30: 'fo',
        60: 'ks',
        90: 'rw',
        1: 'fr',
        31: 'fa',
        61: 'ku',
        91: 'rn',
        2: 'de',
        32: 'ru',
        62: 'sd',
        92: 'ny',
        3: 'it',
        33: 'zh',
        63: 'bo',
        93: 'mg',
        4: 'nl',
        34: 'nl-BE',
        64: 'ne',
        94: 'eo',
        5: 'sv',
        35: 'ga',
        65: 'sa',
        128: 'cy',
        6: 'es',
        36: 'sq',
        66: 'mr',
        129: 'eu',
        7: 'da',
        37: 'ro',
        67: 'bn',
        130: 'ca',
        8: 'pt',
        38: 'cz',
        68: 'as',
        131: 'la',
        9: 'no',
        39: 'sk',
        69: 'gu',
        132: 'qu',
        10: 'he',
        40: 'si',
        70: 'pa',
        133: 'gn',
        11: 'ja',
        41: 'yi',
        71: 'or',
        134: 'ay',
        12: 'ar',
        42: 'sr',
        72: 'ml',
        135: 'tt',
        13: 'fi',
        43: 'mk',
        73: 'kn',
        136: 'ug',
        14: 'el',
        44: 'bg',
        74: 'ta',
        137: 'dz',
        15: 'is',
        45: 'uk',
        75: 'te',
        138: 'jv',
        16: 'mt',
        46: 'be',
        76: 'si',
        139: 'su',
        17: 'tr',
        47: 'uz',
        77: 'my',
        140: 'gl',
        18: 'hr',
        48: 'kk',
        78: 'km',
        141: 'af',
        19: 'zh-Hant',
        49: 'az-Cyrl',
        79: 'lo',
        142: 'br',
        20: 'ur',
        50: 'az-Arab',
        80: 'vi',
        143: 'iu',
        21: 'hi',
        51: 'hy',
        81: 'id',
        144: 'gd',
        22: 'th',
        52: 'ka',
        82: 'tl',
        145: 'gv',
        23: 'ko',
        53: 'mo',
        83: 'ms',
        146: 'ga',
        24: 'lt',
        54: 'ky',
        84: 'ms-Arab',
        147: 'to',
        25: 'pl',
        55: 'tg',
        85: 'am',
        148: 'el-polyton',
        26: 'hu',
        56: 'tk',
        86: 'ti',
        149: 'kl',
        27: 'es',
        57: 'mn-CN',
        87: 'om',
        150: 'az',
        28: 'lv',
        58: 'mn',
        88: 'so',
        151: 'nn',
        29: 'se',
        59: 'ps',
        89: 'sw'
    },
    // ISO (deprecated)
    [],
    {
        0x0436: 'af',
        0x4009: 'en-IN',
        0x0487: 'rw',
        0x0432: 'tn',
        0x041C: 'sq',
        0x1809: 'en-IE',
        0x0441: 'sw',
        0x045B: 'si',
        0x0484: 'gsw',
        0x2009: 'en-JM',
        0x0457: 'kok',
        0x041B: 'sk',
        0x045E: 'am',
        0x4409: 'en-MY',
        0x0412: 'ko',
        0x0424: 'sl',
        0x1401: 'ar-DZ',
        0x1409: 'en-NZ',
        0x0440: 'ky',
        0x2C0A: 'es-AR',
        0x3C01: 'ar-BH',
        0x3409: 'en-PH',
        0x0454: 'lo',
        0x400A: 'es-BO',
        0x0C01: 'ar',
        0x4809: 'en-SG',
        0x0426: 'lv',
        0x340A: 'es-CL',
        0x0801: 'ar-IQ',
        0x1C09: 'en-ZA',
        0x0427: 'lt',
        0x240A: 'es-CO',
        0x2C01: 'ar-JO',
        0x2C09: 'en-TT',
        0x082E: 'dsb',
        0x140A: 'es-CR',
        0x3401: 'ar-KW',
        0x0809: 'en-GB',
        0x046E: 'lb',
        0x1C0A: 'es-DO',
        0x3001: 'ar-LB',
        0x0409: 'en',
        0x042F: 'mk',
        0x300A: 'es-EC',
        0x1001: 'ar-LY',
        0x3009: 'en-ZW',
        0x083E: 'ms-BN',
        0x440A: 'es-SV',
        0x1801: 'ary',
        0x0425: 'et',
        0x043E: 'ms',
        0x100A: 'es-GT',
        0x2001: 'ar-OM',
        0x0438: 'fo',
        0x044C: 'ml',
        0x480A: 'es-HN',
        0x4001: 'ar-QA',
        0x0464: 'fil',
        0x043A: 'mt',
        0x080A: 'es-MX',
        0x0401: 'ar-SA',
        0x040B: 'fi',
        0x0481: 'mi',
        0x4C0A: 'es-NI',
        0x2801: 'ar-SY',
        0x080C: 'fr-BE',
        0x047A: 'arn',
        0x180A: 'es-PA',
        0x1C01: 'aeb',
        0x0C0C: 'fr-CA',
        0x044E: 'mr',
        0x3C0A: 'es-PY',
        0x3801: 'ar-AE',
        0x040C: 'fr',
        0x047C: 'moh',
        0x280A: 'es-PE',
        0x2401: 'ar-YE',
        0x140C: 'fr-LU',
        0x0450: 'mn',
        0x500A: 'es-PR',
        0x042B: 'hy',
        0x180C: 'fr-MC',
        0x0850: 'mn-CN',
        0x0C0A: 'es',
        0x044D: 'as',
        0x100C: 'fr-CH',
        0x0461: 'ne',
        0x040A: 'es',
        0x082C: 'az-Cyrl',
        0x0462: 'fy',
        0x0414: 'nb',
        0x540A: 'es-US',
        0x042C: 'az',
        0x0456: 'gl',
        0x0814: 'nn',
        0x380A: 'es-UY',
        0x046D: 'ba',
        0x0437: 'ka',
        0x0482: 'oc',
        0x200A: 'es-VE',
        0x042D: 'eu',
        0x0C07: 'de-AT',
        0x0448: 'or',
        0x081D: 'sv-FI',
        0x0423: 'be',
        0x0407: 'de',
        0x0463: 'ps',
        0x041D: 'sv',
        0x0845: 'bn',
        0x1407: 'de-LI',
        0x0415: 'pl',
        0x045A: 'syr',
        0x0445: 'bn-IN',
        0x1007: 'de-LU',
        0x0416: 'pt',
        0x0428: 'tg',
        0x201A: 'bs-Cyrl',
        0x0807: 'de-CH',
        0x0816: 'pt-PT',
        0x085F: 'tzm',
        0x141A: 'bs',
        0x0408: 'el',
        0x0446: 'pa',
        0x0449: 'ta',
        0x047E: 'br',
        0x046F: 'kl',
        0x046B: 'qu-BO',
        0x0444: 'tt',
        0x0402: 'bg',
        0x0447: 'gu',
        0x086B: 'qu-EC',
        0x044A: 'te',
        0x0403: 'ca',
        0x0468: 'ha',
        0x0C6B: 'qu',
        0x041E: 'th',
        0x0C04: 'zh-HK',
        0x040D: 'he',
        0x0418: 'ro',
        0x0451: 'bo',
        0x1404: 'zh-MO',
        0x0439: 'hi',
        0x0417: 'rm',
        0x041F: 'tr',
        0x0804: 'zh',
        0x040E: 'hu',
        0x0419: 'ru',
        0x0442: 'tk',
        0x1004: 'zh-SG',
        0x040F: 'is',
        0x243B: 'smn',
        0x0480: 'ug',
        0x0404: 'zh-TW',
        0x0470: 'ig',
        0x103B: 'smj-NO',
        0x0422: 'uk',
        0x0483: 'co',
        0x0421: 'id',
        0x143B: 'smj',
        0x042E: 'hsb',
        0x041A: 'hr',
        0x045D: 'iu',
        0x0C3B: 'se-FI',
        0x0420: 'ur',
        0x101A: 'hr-BA',
        0x085D: 'iu-Latn',
        0x043B: 'se',
        0x0843: 'uz-Cyrl',
        0x0405: 'cs',
        0x083C: 'ga',
        0x083B: 'se-SE',
        0x0443: 'uz',
        0x0406: 'da',
        0x0434: 'xh',
        0x203B: 'sms',
        0x042A: 'vi',
        0x048C: 'prs',
        0x0435: 'zu',
        0x183B: 'sma-NO',
        0x0452: 'cy',
        0x0465: 'dv',
        0x0410: 'it',
        0x1C3B: 'sms',
        0x0488: 'wo',
        0x0813: 'nl-BE',
        0x0810: 'it-CH',
        0x044F: 'sa',
        0x0485: 'sah',
        0x0413: 'nl',
        0x0411: 'ja',
        0x1C1A: 'sr-Cyrl-BA',
        0x0478: 'ii',
        0x0C09: 'en-AU',
        0x044B: 'kn',
        0x0C1A: 'sr',
        0x046A: 'yo',
        0x2809: 'en-BZ',
        0x043F: 'kk',
        0x181A: 'sr-Latn-BA',
        0x1009: 'en-CA',
        0x0453: 'km',
        0x081A: 'sr-Latn',
        0x2409: 'en-029',
        0x0486: 'quc',
        0x046C: 'nso'
    }
];
let $6d519e6f260f4e02$var$$2bcf221753ec8e32$var$NameRecord = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    platformID: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    encodingID: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    languageID: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    nameID: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    length: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    string: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), new (0, $b2061d4384f873cb$export$89b8e0fa65f6a914)('length', (t)=>$6d519e6f260f4e02$var$$e449ad78d50845fe$export$badc544e0651b6b1(t.platformID, t.encodingID, t.languageID)), {
        type: 'parent',
        relativeTo: (ctx)=>ctx.parent.stringOffset,
        allowNull: false
    })
});
let $6d519e6f260f4e02$var$$2bcf221753ec8e32$var$LangTagRecord = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    length: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    tag: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), new (0, $b2061d4384f873cb$export$89b8e0fa65f6a914)('length', 'utf16be'), {
        type: 'parent',
        relativeTo: (ctx)=>ctx.stringOffset
    })
});
var $6d519e6f260f4e02$var$$2bcf221753ec8e32$var$NameTable = new (0, $00bf8c7e3dccf9c9$export$95a8b60f4da7dec8)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), {
    0: {
        count: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        stringOffset: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        records: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$2bcf221753ec8e32$var$NameRecord, 'count')
    },
    1: {
        count: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        stringOffset: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        records: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$2bcf221753ec8e32$var$NameRecord, 'count'),
        langTagCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        langTags: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$2bcf221753ec8e32$var$LangTagRecord, 'langTagCount')
    }
});
var $6d519e6f260f4e02$var$$2bcf221753ec8e32$export$2e2bcd8739ae039 = $6d519e6f260f4e02$var$$2bcf221753ec8e32$var$NameTable;
const $6d519e6f260f4e02$var$$2bcf221753ec8e32$var$NAMES = [
    'copyright',
    'fontFamily',
    'fontSubfamily',
    'uniqueSubfamily',
    'fullName',
    'version',
    'postscriptName',
    'trademark',
    'manufacturer',
    'designer',
    'description',
    'vendorURL',
    'designerURL',
    'license',
    'licenseURL',
    null,
    'preferredFamily',
    'preferredSubfamily',
    'compatibleFull',
    'sampleText',
    'postscriptCIDFontName',
    'wwsFamilyName',
    'wwsSubfamilyName'
];
$6d519e6f260f4e02$var$$2bcf221753ec8e32$var$NameTable.process = function(stream) {
    var records = {};
    for (let record of this.records){
        // find out what language this is for
        let language = $6d519e6f260f4e02$var$$e449ad78d50845fe$export$2092376fd002e13[record.platformID][record.languageID];
        if (language == null && this.langTags != null && record.languageID >= 0x8000) language = this.langTags[record.languageID - 0x8000].tag;
        if (language == null) language = record.platformID + '-' + record.languageID;
        // if the nameID is >= 256, it is a font feature record (AAT)
        let key = record.nameID >= 256 ? 'fontFeatures' : $6d519e6f260f4e02$var$$2bcf221753ec8e32$var$NAMES[record.nameID] || record.nameID;
        if (records[key] == null) records[key] = {};
        let obj = records[key];
        if (record.nameID >= 256) obj = obj[record.nameID] || (obj[record.nameID] = {});
        if (typeof record.string === 'string' || typeof obj[language] !== 'string') obj[language] = record.string;
    }
    this.records = records;
};
$6d519e6f260f4e02$var$$2bcf221753ec8e32$var$NameTable.preEncode = function() {
    if (Array.isArray(this.records)) return;
    this.version = 0;
    let records = [];
    for(let key in this.records){
        let val = this.records[key];
        if (key === 'fontFeatures') continue;
        records.push({
            platformID: 3,
            encodingID: 1,
            languageID: 0x409,
            nameID: $6d519e6f260f4e02$var$$2bcf221753ec8e32$var$NAMES.indexOf(key),
            length: val.en.length * 2,
            string: val.en
        });
        if (key === 'postscriptName') records.push({
            platformID: 1,
            encodingID: 0,
            languageID: 0,
            nameID: $6d519e6f260f4e02$var$$2bcf221753ec8e32$var$NAMES.indexOf(key),
            length: val.en.length,
            string: val.en
        });
    }
    this.records = records;
    this.count = records.length;
    this.stringOffset = $6d519e6f260f4e02$var$$2bcf221753ec8e32$var$NameTable.size(this, null, false);
};
var $6d519e6f260f4e02$var$$84b272aa31b70606$var$OS2 = new (0, $00bf8c7e3dccf9c9$export$95a8b60f4da7dec8)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), {
    header: {
        xAvgCharWidth: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
        usWeightClass: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        usWidthClass: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        fsType: new (0, $701e08229fc30ff7$export$96b43b8a49f688ea)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), [
            null,
            'noEmbedding',
            'viewOnly',
            'editable',
            null,
            null,
            null,
            null,
            'noSubsetting',
            'bitmapOnly'
        ]),
        ySubscriptXSize: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
        ySubscriptYSize: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
        ySubscriptXOffset: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
        ySubscriptYOffset: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
        ySuperscriptXSize: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
        ySuperscriptYSize: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
        ySuperscriptXOffset: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
        ySuperscriptYOffset: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
        yStrikeoutSize: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
        yStrikeoutPosition: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
        sFamilyClass: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
        panose: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$52e103c63c4e68cf), 10),
        ulCharRange: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), 4),
        vendorID: new (0, $b2061d4384f873cb$export$89b8e0fa65f6a914)(4),
        fsSelection: new (0, $701e08229fc30ff7$export$96b43b8a49f688ea)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), [
            'italic',
            'underscore',
            'negative',
            'outlined',
            'strikeout',
            'bold',
            'regular',
            'useTypoMetrics',
            'wws',
            'oblique'
        ]),
        usFirstCharIndex: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        usLastCharIndex: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456 // The maximum Unicode index in this font
        )
    },
    // The Apple version of this table ends here, but the Microsoft one continues on...
    0: {},
    1: {
        typoAscender: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
        typoDescender: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
        typoLineGap: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
        winAscent: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        winDescent: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        codePageRange: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), 2)
    },
    2: {
        // these should be common with version 1 somehow
        typoAscender: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
        typoDescender: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
        typoLineGap: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
        winAscent: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        winDescent: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        codePageRange: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), 2),
        xHeight: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
        capHeight: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
        defaultChar: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        breakChar: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        maxContent: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456)
    },
    5: {
        typoAscender: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
        typoDescender: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
        typoLineGap: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
        winAscent: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        winDescent: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        codePageRange: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), 2),
        xHeight: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
        capHeight: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
        defaultChar: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        breakChar: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        maxContent: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        usLowerOpticalPointSize: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        usUpperOpticalPointSize: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456)
    }
});
let $6d519e6f260f4e02$var$$84b272aa31b70606$var$versions = $6d519e6f260f4e02$var$$84b272aa31b70606$var$OS2.versions;
$6d519e6f260f4e02$var$$84b272aa31b70606$var$versions[3] = $6d519e6f260f4e02$var$$84b272aa31b70606$var$versions[4] = $6d519e6f260f4e02$var$$84b272aa31b70606$var$versions[2];
var $6d519e6f260f4e02$var$$84b272aa31b70606$export$2e2bcd8739ae039 = $6d519e6f260f4e02$var$$84b272aa31b70606$var$OS2;
var $6d519e6f260f4e02$var$$32d9e2eb9565d93c$export$2e2bcd8739ae039 = new (0, $00bf8c7e3dccf9c9$export$95a8b60f4da7dec8)((0, $2b9a2a5e7d043014$export$e913265d48471f2d), {
    header: {
        italicAngle: (0, $2b9a2a5e7d043014$export$e913265d48471f2d),
        underlinePosition: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
        underlineThickness: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
        isFixedPitch: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
        minMemType42: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
        maxMemType42: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
        minMemType1: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
        maxMemType1: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d // Maximum memory usage when a TrueType font is downloaded as a Type 1 font
        )
    },
    1: {},
    2: {
        numberOfGlyphs: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        glyphNameIndex: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), 'numberOfGlyphs'),
        names: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)(new (0, $b2061d4384f873cb$export$89b8e0fa65f6a914)((0, $2b9a2a5e7d043014$export$52e103c63c4e68cf)))
    },
    2.5: {
        numberOfGlyphs: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        offsets: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$52e103c63c4e68cf), 'numberOfGlyphs')
    },
    3: {},
    4: {
        map: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), (t)=>t.parent.maxp.numGlyphs)
    }
});
var $6d519e6f260f4e02$var$$5202bd9d9ad8eaac$export$2e2bcd8739ae039 = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    controlValues: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6))
});
var // These instructions are known as the font program. The main use of this table
// is for the definition of functions that are used in many different glyph programs.
$6d519e6f260f4e02$var$$5c0f37ca5ffb1850$export$2e2bcd8739ae039 = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    instructions: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$52e103c63c4e68cf))
});
let $6d519e6f260f4e02$var$$2b2b260902b1c57e$var$loca = new (0, $00bf8c7e3dccf9c9$export$95a8b60f4da7dec8)('head.indexToLocFormat', {
    0: {
        offsets: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456))
    },
    1: {
        offsets: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d))
    }
});
$6d519e6f260f4e02$var$$2b2b260902b1c57e$var$loca.process = function() {
    if (this.version === 0 && !this._processed) {
        for(let i = 0; i < this.offsets.length; i++)this.offsets[i] <<= 1;
        this._processed = true;
    }
};
$6d519e6f260f4e02$var$$2b2b260902b1c57e$var$loca.preEncode = function() {
    if (this.version === 0 && this._processed !== false) {
        for(let i = 0; i < this.offsets.length; i++)this.offsets[i] >>>= 1;
        this._processed = false;
    }
};
var $6d519e6f260f4e02$var$$2b2b260902b1c57e$export$2e2bcd8739ae039 = $6d519e6f260f4e02$var$$2b2b260902b1c57e$var$loca;
var $6d519e6f260f4e02$var$$7afb878c7bea4f66$export$2e2bcd8739ae039 = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    controlValueProgram: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$52e103c63c4e68cf))
});
var $6d519e6f260f4e02$var$$6c92b6371bce8bd9$export$2e2bcd8739ae039 = new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)(new (0, $272db5812670c438$export$7d22a0eea6656474));
class $6d519e6f260f4e02$var$$43e9821ef3717eec$export$2e2bcd8739ae039 {
    getCFFVersion(ctx) {
        while(ctx && !ctx.hdrSize)ctx = ctx.parent;
        return ctx ? ctx.version : -1;
    }
    decode(stream, parent) {
        let version = this.getCFFVersion(parent);
        let count = version >= 2 ? stream.readUInt32BE() : stream.readUInt16BE();
        if (count === 0) return [];
        let offSize = stream.readUInt8();
        let offsetType;
        if (offSize === 1) offsetType = (0, $2b9a2a5e7d043014$export$52e103c63c4e68cf);
        else if (offSize === 2) offsetType = (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456);
        else if (offSize === 3) offsetType = (0, $2b9a2a5e7d043014$export$1925298fbd719b21);
        else if (offSize === 4) offsetType = (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d);
        else throw new Error(`Bad offset size in CFFIndex: ${offSize} ${stream.pos}`);
        let ret = [];
        let startPos = stream.pos + (count + 1) * offSize - 1;
        let start = offsetType.decode(stream);
        for(let i = 0; i < count; i++){
            let end = offsetType.decode(stream);
            if (this.type != null) {
                let pos = stream.pos;
                stream.pos = startPos + start;
                parent.length = end - start;
                ret.push(this.type.decode(stream, parent));
                stream.pos = pos;
            } else ret.push({
                offset: startPos + start,
                length: end - start
            });
            start = end;
        }
        stream.pos = startPos + start;
        return ret;
    }
    size(arr, parent) {
        let size = 2;
        if (arr.length === 0) return size;
        let type = this.type || new (0, $272db5812670c438$export$7d22a0eea6656474);
        // find maximum offset to detminine offset type
        let offset = 1;
        for(let i = 0; i < arr.length; i++){
            let item = arr[i];
            offset += type.size(item, parent);
        }
        let offsetType;
        if (offset <= 0xff) offsetType = (0, $2b9a2a5e7d043014$export$52e103c63c4e68cf);
        else if (offset <= 0xffff) offsetType = (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456);
        else if (offset <= 0xffffff) offsetType = (0, $2b9a2a5e7d043014$export$1925298fbd719b21);
        else if (offset <= 0xffffffff) offsetType = (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d);
        else throw new Error("Bad offset in CFFIndex");
        size += 1 + offsetType.size() * (arr.length + 1);
        size += offset - 1;
        return size;
    }
    encode(stream, arr, parent) {
        stream.writeUInt16BE(arr.length);
        if (arr.length === 0) return;
        let type = this.type || new (0, $272db5812670c438$export$7d22a0eea6656474);
        // find maximum offset to detminine offset type
        let sizes = [];
        let offset = 1;
        for (let item of arr){
            let s = type.size(item, parent);
            sizes.push(s);
            offset += s;
        }
        let offsetType;
        if (offset <= 0xff) offsetType = (0, $2b9a2a5e7d043014$export$52e103c63c4e68cf);
        else if (offset <= 0xffff) offsetType = (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456);
        else if (offset <= 0xffffff) offsetType = (0, $2b9a2a5e7d043014$export$1925298fbd719b21);
        else if (offset <= 0xffffffff) offsetType = (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d);
        else throw new Error("Bad offset in CFFIndex");
        // write offset size
        stream.writeUInt8(offsetType.size());
        // write elements
        offset = 1;
        offsetType.encode(stream, offset);
        for (let size of sizes){
            offset += size;
            offsetType.encode(stream, offset);
        }
        for (let item of arr)type.encode(stream, item, parent);
        return;
    }
    constructor(type){
        this.type = type;
    }
}
const $6d519e6f260f4e02$var$$c2d28e92708f99da$var$FLOAT_EOF = 0xf;
const $6d519e6f260f4e02$var$$c2d28e92708f99da$var$FLOAT_LOOKUP = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '.',
    'E',
    'E-',
    null,
    '-'
];
const $6d519e6f260f4e02$var$$c2d28e92708f99da$var$FLOAT_ENCODE_LOOKUP = {
    '.': 10,
    'E': 11,
    'E-': 12,
    '-': 14
};
class $6d519e6f260f4e02$var$$c2d28e92708f99da$export$2e2bcd8739ae039 {
    static decode(stream, value) {
        if (32 <= value && value <= 246) return value - 139;
        if (247 <= value && value <= 250) return (value - 247) * 256 + stream.readUInt8() + 108;
        if (251 <= value && value <= 254) return -(value - 251) * 256 - stream.readUInt8() - 108;
        if (value === 28) return stream.readInt16BE();
        if (value === 29) return stream.readInt32BE();
        if (value === 30) {
            let str = '';
            while(true){
                let b = stream.readUInt8();
                let n1 = b >> 4;
                if (n1 === $6d519e6f260f4e02$var$$c2d28e92708f99da$var$FLOAT_EOF) break;
                str += $6d519e6f260f4e02$var$$c2d28e92708f99da$var$FLOAT_LOOKUP[n1];
                let n2 = b & 15;
                if (n2 === $6d519e6f260f4e02$var$$c2d28e92708f99da$var$FLOAT_EOF) break;
                str += $6d519e6f260f4e02$var$$c2d28e92708f99da$var$FLOAT_LOOKUP[n2];
            }
            return parseFloat(str);
        }
        return null;
    }
    static size(value) {
        // if the value needs to be forced to the largest size (32 bit)
        // e.g. for unknown pointers, set to 32768
        if (value.forceLarge) value = 32768;
        if ((value | 0) !== value) {
            let str = '' + value;
            return 1 + Math.ceil((str.length + 1) / 2);
        } else if (-107 <= value && value <= 107) return 1;
        else if (108 <= value && value <= 1131 || -1131 <= value && value <= -108) return 2;
        else if (-32768 <= value && value <= 32767) return 3;
        else return 5;
    }
    static encode(stream, value) {
        // if the value needs to be forced to the largest size (32 bit)
        // e.g. for unknown pointers, save the old value and set to 32768
        let val = Number(value);
        if (value.forceLarge) {
            stream.writeUInt8(29);
            return stream.writeInt32BE(val);
        } else if ((val | 0) !== val) {
            stream.writeUInt8(30);
            let str = '' + val;
            for(let i = 0; i < str.length; i += 2){
                let c1 = str[i];
                let n1 = $6d519e6f260f4e02$var$$c2d28e92708f99da$var$FLOAT_ENCODE_LOOKUP[c1] || +c1;
                if (i === str.length - 1) var n2 = $6d519e6f260f4e02$var$$c2d28e92708f99da$var$FLOAT_EOF;
                else {
                    let c2 = str[i + 1];
                    var n2 = $6d519e6f260f4e02$var$$c2d28e92708f99da$var$FLOAT_ENCODE_LOOKUP[c2] || +c2;
                }
                stream.writeUInt8(n1 << 4 | n2 & 15);
            }
            if (n2 !== $6d519e6f260f4e02$var$$c2d28e92708f99da$var$FLOAT_EOF) return stream.writeUInt8($6d519e6f260f4e02$var$$c2d28e92708f99da$var$FLOAT_EOF << 4);
        } else if (-107 <= val && val <= 107) return stream.writeUInt8(val + 139);
        else if (108 <= val && val <= 1131) {
            val -= 108;
            stream.writeUInt8((val >> 8) + 247);
            return stream.writeUInt8(val & 0xff);
        } else if (-1131 <= val && val <= -108) {
            val = -val - 108;
            stream.writeUInt8((val >> 8) + 251);
            return stream.writeUInt8(val & 0xff);
        } else if (-32768 <= val && val <= 32767) {
            stream.writeUInt8(28);
            return stream.writeInt16BE(val);
        } else {
            stream.writeUInt8(29);
            return stream.writeInt32BE(val);
        }
    }
}
class $6d519e6f260f4e02$var$$61aa549f16d58b9b$export$2e2bcd8739ae039 {
    decodeOperands(type, stream, ret, operands) {
        if (Array.isArray(type)) return operands.map((op, i)=>this.decodeOperands(type[i], stream, ret, [
                op
            ]));
        else if (type.decode != null) return type.decode(stream, ret, operands);
        else switch(type){
            case 'number':
            case 'offset':
            case 'sid':
                return operands[0];
            case 'boolean':
                return !!operands[0];
            default:
                return operands;
        }
    }
    encodeOperands(type, stream, ctx, operands) {
        if (Array.isArray(type)) return operands.map((op, i)=>this.encodeOperands(type[i], stream, ctx, op)[0]);
        else if (type.encode != null) return type.encode(stream, operands, ctx);
        else if (typeof operands === 'number') return [
            operands
        ];
        else if (typeof operands === 'boolean') return [
            +operands
        ];
        else if (Array.isArray(operands)) return operands;
        else return [
            operands
        ];
    }
    decode(stream, parent) {
        let end = stream.pos + parent.length;
        let ret = {};
        let operands = [];
        // define hidden properties
        Object.defineProperties(ret, {
            parent: {
                value: parent
            },
            _startOffset: {
                value: stream.pos
            }
        });
        // fill in defaults
        for(let key in this.fields){
            let field = this.fields[key];
            ret[field[1]] = field[3];
        }
        while(stream.pos < end){
            let b = stream.readUInt8();
            if (b < 28) {
                if (b === 12) b = b << 8 | stream.readUInt8();
                let field = this.fields[b];
                if (!field) throw new Error(`Unknown operator ${b}`);
                let val = this.decodeOperands(field[2], stream, ret, operands);
                if (val != null) {
                    if (val instanceof (0, $69cd4678dd9eb847$export$41705b1d644e0f14)) Object.defineProperty(ret, field[1], val);
                    else ret[field[1]] = val;
                }
                operands = [];
            } else operands.push($6d519e6f260f4e02$var$$c2d28e92708f99da$export$2e2bcd8739ae039.decode(stream, b));
        }
        return ret;
    }
    size(dict, parent, includePointers = true) {
        let ctx = {
            parent: parent,
            val: dict,
            pointerSize: 0,
            startOffset: parent.startOffset || 0
        };
        let len = 0;
        for(let k in this.fields){
            let field = this.fields[k];
            let val = dict[field[1]];
            if (val == null || (0, (/*@__PURE__*/$parcel$interopDefault($c7e0a6ffc4b4ae5b$exports)))(val, field[3])) continue;
            let operands = this.encodeOperands(field[2], null, ctx, val);
            for (let op of operands)len += $6d519e6f260f4e02$var$$c2d28e92708f99da$export$2e2bcd8739ae039.size(op);
            let key = Array.isArray(field[0]) ? field[0] : [
                field[0]
            ];
            len += key.length;
        }
        if (includePointers) len += ctx.pointerSize;
        return len;
    }
    encode(stream, dict, parent) {
        let ctx = {
            pointers: [],
            startOffset: stream.pos,
            parent: parent,
            val: dict,
            pointerSize: 0
        };
        ctx.pointerOffset = stream.pos + this.size(dict, ctx, false);
        for (let field of this.ops){
            let val = dict[field[1]];
            if (val == null || (0, (/*@__PURE__*/$parcel$interopDefault($c7e0a6ffc4b4ae5b$exports)))(val, field[3])) continue;
            let operands = this.encodeOperands(field[2], stream, ctx, val);
            for (let op of operands)$6d519e6f260f4e02$var$$c2d28e92708f99da$export$2e2bcd8739ae039.encode(stream, op);
            let key = Array.isArray(field[0]) ? field[0] : [
                field[0]
            ];
            for (let op of key)stream.writeUInt8(op);
        }
        let i = 0;
        while(i < ctx.pointers.length){
            let ptr = ctx.pointers[i++];
            ptr.type.encode(stream, ptr.val, ptr.parent);
        }
        return;
    }
    constructor(ops = []){
        this.ops = ops;
        this.fields = {};
        for (let field of ops){
            let key = Array.isArray(field[0]) ? field[0][0] << 8 | field[0][1] : field[0];
            this.fields[key] = field;
        }
    }
}
class $6d519e6f260f4e02$var$$0e34a43d05bde82c$export$2e2bcd8739ae039 extends (0, $19bca402104b2cc3$export$b56007f12edf0c17) {
    decode(stream, parent, operands) {
        this.offsetType = {
            decode: ()=>operands[0]
        };
        return super.decode(stream, parent, operands);
    }
    encode(stream, value, ctx) {
        if (!stream) {
            // compute the size (so ctx.pointerSize is correct)
            this.offsetType = {
                size: ()=>0
            };
            this.size(value, ctx);
            return [
                new $6d519e6f260f4e02$var$$0e34a43d05bde82c$var$Ptr(0)
            ];
        }
        let ptr = null;
        this.offsetType = {
            encode: (stream, val)=>ptr = val
        };
        super.encode(stream, value, ctx);
        return [
            new $6d519e6f260f4e02$var$$0e34a43d05bde82c$var$Ptr(ptr)
        ];
    }
    constructor(type, options = {}){
        if (options.type == null) options.type = 'global';
        super(null, type, options);
    }
}
class $6d519e6f260f4e02$var$$0e34a43d05bde82c$var$Ptr {
    valueOf() {
        return this.val;
    }
    constructor(val){
        this.val = val;
        this.forceLarge = true;
    }
}
class $6d519e6f260f4e02$var$$6d59db2e29cc77b3$var$CFFBlendOp {
    static decode(stream, parent, operands) {
        let numBlends = operands.pop();
        // TODO: actually blend. For now just consume the deltas
        // since we don't use any of the values anyway.
        while(operands.length > numBlends)operands.pop();
    }
}
var $6d519e6f260f4e02$var$$6d59db2e29cc77b3$export$2e2bcd8739ae039 = new $6d519e6f260f4e02$var$$61aa549f16d58b9b$export$2e2bcd8739ae039([
    // key       name                    type                                          default
    [
        6,
        'BlueValues',
        'delta',
        null
    ],
    [
        7,
        'OtherBlues',
        'delta',
        null
    ],
    [
        8,
        'FamilyBlues',
        'delta',
        null
    ],
    [
        9,
        'FamilyOtherBlues',
        'delta',
        null
    ],
    [
        [
            12,
            9
        ],
        'BlueScale',
        'number',
        0.039625
    ],
    [
        [
            12,
            10
        ],
        'BlueShift',
        'number',
        7
    ],
    [
        [
            12,
            11
        ],
        'BlueFuzz',
        'number',
        1
    ],
    [
        10,
        'StdHW',
        'number',
        null
    ],
    [
        11,
        'StdVW',
        'number',
        null
    ],
    [
        [
            12,
            12
        ],
        'StemSnapH',
        'delta',
        null
    ],
    [
        [
            12,
            13
        ],
        'StemSnapV',
        'delta',
        null
    ],
    [
        [
            12,
            14
        ],
        'ForceBold',
        'boolean',
        false
    ],
    [
        [
            12,
            17
        ],
        'LanguageGroup',
        'number',
        0
    ],
    [
        [
            12,
            18
        ],
        'ExpansionFactor',
        'number',
        0.06
    ],
    [
        [
            12,
            19
        ],
        'initialRandomSeed',
        'number',
        0
    ],
    [
        20,
        'defaultWidthX',
        'number',
        0
    ],
    [
        21,
        'nominalWidthX',
        'number',
        0
    ],
    [
        22,
        'vsindex',
        'number',
        0
    ],
    [
        23,
        'blend',
        $6d519e6f260f4e02$var$$6d59db2e29cc77b3$var$CFFBlendOp,
        null
    ],
    [
        19,
        'Subrs',
        new $6d519e6f260f4e02$var$$0e34a43d05bde82c$export$2e2bcd8739ae039(new $6d519e6f260f4e02$var$$43e9821ef3717eec$export$2e2bcd8739ae039, {
            type: 'local'
        }),
        null
    ]
]);
// Automatically generated from Appendix A of the CFF specification; do
// not edit. Length should be 391.
var $6d519e6f260f4e02$var$$229224aec43783c5$export$2e2bcd8739ae039 = [
    ".notdef",
    "space",
    "exclam",
    "quotedbl",
    "numbersign",
    "dollar",
    "percent",
    "ampersand",
    "quoteright",
    "parenleft",
    "parenright",
    "asterisk",
    "plus",
    "comma",
    "hyphen",
    "period",
    "slash",
    "zero",
    "one",
    "two",
    "three",
    "four",
    "five",
    "six",
    "seven",
    "eight",
    "nine",
    "colon",
    "semicolon",
    "less",
    "equal",
    "greater",
    "question",
    "at",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    "bracketleft",
    "backslash",
    "bracketright",
    "asciicircum",
    "underscore",
    "quoteleft",
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
    "braceleft",
    "bar",
    "braceright",
    "asciitilde",
    "exclamdown",
    "cent",
    "sterling",
    "fraction",
    "yen",
    "florin",
    "section",
    "currency",
    "quotesingle",
    "quotedblleft",
    "guillemotleft",
    "guilsinglleft",
    "guilsinglright",
    "fi",
    "fl",
    "endash",
    "dagger",
    "daggerdbl",
    "periodcentered",
    "paragraph",
    "bullet",
    "quotesinglbase",
    "quotedblbase",
    "quotedblright",
    "guillemotright",
    "ellipsis",
    "perthousand",
    "questiondown",
    "grave",
    "acute",
    "circumflex",
    "tilde",
    "macron",
    "breve",
    "dotaccent",
    "dieresis",
    "ring",
    "cedilla",
    "hungarumlaut",
    "ogonek",
    "caron",
    "emdash",
    "AE",
    "ordfeminine",
    "Lslash",
    "Oslash",
    "OE",
    "ordmasculine",
    "ae",
    "dotlessi",
    "lslash",
    "oslash",
    "oe",
    "germandbls",
    "onesuperior",
    "logicalnot",
    "mu",
    "trademark",
    "Eth",
    "onehalf",
    "plusminus",
    "Thorn",
    "onequarter",
    "divide",
    "brokenbar",
    "degree",
    "thorn",
    "threequarters",
    "twosuperior",
    "registered",
    "minus",
    "eth",
    "multiply",
    "threesuperior",
    "copyright",
    "Aacute",
    "Acircumflex",
    "Adieresis",
    "Agrave",
    "Aring",
    "Atilde",
    "Ccedilla",
    "Eacute",
    "Ecircumflex",
    "Edieresis",
    "Egrave",
    "Iacute",
    "Icircumflex",
    "Idieresis",
    "Igrave",
    "Ntilde",
    "Oacute",
    "Ocircumflex",
    "Odieresis",
    "Ograve",
    "Otilde",
    "Scaron",
    "Uacute",
    "Ucircumflex",
    "Udieresis",
    "Ugrave",
    "Yacute",
    "Ydieresis",
    "Zcaron",
    "aacute",
    "acircumflex",
    "adieresis",
    "agrave",
    "aring",
    "atilde",
    "ccedilla",
    "eacute",
    "ecircumflex",
    "edieresis",
    "egrave",
    "iacute",
    "icircumflex",
    "idieresis",
    "igrave",
    "ntilde",
    "oacute",
    "ocircumflex",
    "odieresis",
    "ograve",
    "otilde",
    "scaron",
    "uacute",
    "ucircumflex",
    "udieresis",
    "ugrave",
    "yacute",
    "ydieresis",
    "zcaron",
    "exclamsmall",
    "Hungarumlautsmall",
    "dollaroldstyle",
    "dollarsuperior",
    "ampersandsmall",
    "Acutesmall",
    "parenleftsuperior",
    "parenrightsuperior",
    "twodotenleader",
    "onedotenleader",
    "zerooldstyle",
    "oneoldstyle",
    "twooldstyle",
    "threeoldstyle",
    "fouroldstyle",
    "fiveoldstyle",
    "sixoldstyle",
    "sevenoldstyle",
    "eightoldstyle",
    "nineoldstyle",
    "commasuperior",
    "threequartersemdash",
    "periodsuperior",
    "questionsmall",
    "asuperior",
    "bsuperior",
    "centsuperior",
    "dsuperior",
    "esuperior",
    "isuperior",
    "lsuperior",
    "msuperior",
    "nsuperior",
    "osuperior",
    "rsuperior",
    "ssuperior",
    "tsuperior",
    "ff",
    "ffi",
    "ffl",
    "parenleftinferior",
    "parenrightinferior",
    "Circumflexsmall",
    "hyphensuperior",
    "Gravesmall",
    "Asmall",
    "Bsmall",
    "Csmall",
    "Dsmall",
    "Esmall",
    "Fsmall",
    "Gsmall",
    "Hsmall",
    "Ismall",
    "Jsmall",
    "Ksmall",
    "Lsmall",
    "Msmall",
    "Nsmall",
    "Osmall",
    "Psmall",
    "Qsmall",
    "Rsmall",
    "Ssmall",
    "Tsmall",
    "Usmall",
    "Vsmall",
    "Wsmall",
    "Xsmall",
    "Ysmall",
    "Zsmall",
    "colonmonetary",
    "onefitted",
    "rupiah",
    "Tildesmall",
    "exclamdownsmall",
    "centoldstyle",
    "Lslashsmall",
    "Scaronsmall",
    "Zcaronsmall",
    "Dieresissmall",
    "Brevesmall",
    "Caronsmall",
    "Dotaccentsmall",
    "Macronsmall",
    "figuredash",
    "hypheninferior",
    "Ogoneksmall",
    "Ringsmall",
    "Cedillasmall",
    "questiondownsmall",
    "oneeighth",
    "threeeighths",
    "fiveeighths",
    "seveneighths",
    "onethird",
    "twothirds",
    "zerosuperior",
    "foursuperior",
    "fivesuperior",
    "sixsuperior",
    "sevensuperior",
    "eightsuperior",
    "ninesuperior",
    "zeroinferior",
    "oneinferior",
    "twoinferior",
    "threeinferior",
    "fourinferior",
    "fiveinferior",
    "sixinferior",
    "seveninferior",
    "eightinferior",
    "nineinferior",
    "centinferior",
    "dollarinferior",
    "periodinferior",
    "commainferior",
    "Agravesmall",
    "Aacutesmall",
    "Acircumflexsmall",
    "Atildesmall",
    "Adieresissmall",
    "Aringsmall",
    "AEsmall",
    "Ccedillasmall",
    "Egravesmall",
    "Eacutesmall",
    "Ecircumflexsmall",
    "Edieresissmall",
    "Igravesmall",
    "Iacutesmall",
    "Icircumflexsmall",
    "Idieresissmall",
    "Ethsmall",
    "Ntildesmall",
    "Ogravesmall",
    "Oacutesmall",
    "Ocircumflexsmall",
    "Otildesmall",
    "Odieresissmall",
    "OEsmall",
    "Oslashsmall",
    "Ugravesmall",
    "Uacutesmall",
    "Ucircumflexsmall",
    "Udieresissmall",
    "Yacutesmall",
    "Thornsmall",
    "Ydieresissmall",
    "001.000",
    "001.001",
    "001.002",
    "001.003",
    "Black",
    "Bold",
    "Book",
    "Light",
    "Medium",
    "Regular",
    "Roman",
    "Semibold"
];
let $6d519e6f260f4e02$var$$bc0433d9b7e41f5f$export$dee0027060fa13bd = [
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    'space',
    'exclam',
    'quotedbl',
    'numbersign',
    'dollar',
    'percent',
    'ampersand',
    'quoteright',
    'parenleft',
    'parenright',
    'asterisk',
    'plus',
    'comma',
    'hyphen',
    'period',
    'slash',
    'zero',
    'one',
    'two',
    'three',
    'four',
    'five',
    'six',
    'seven',
    'eight',
    'nine',
    'colon',
    'semicolon',
    'less',
    'equal',
    'greater',
    'question',
    'at',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    'bracketleft',
    'backslash',
    'bracketright',
    'asciicircum',
    'underscore',
    'quoteleft',
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
    'braceleft',
    'bar',
    'braceright',
    'asciitilde',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    'exclamdown',
    'cent',
    'sterling',
    'fraction',
    'yen',
    'florin',
    'section',
    'currency',
    'quotesingle',
    'quotedblleft',
    'guillemotleft',
    'guilsinglleft',
    'guilsinglright',
    'fi',
    'fl',
    '',
    'endash',
    'dagger',
    'daggerdbl',
    'periodcentered',
    '',
    'paragraph',
    'bullet',
    'quotesinglbase',
    'quotedblbase',
    'quotedblright',
    'guillemotright',
    'ellipsis',
    'perthousand',
    '',
    'questiondown',
    '',
    'grave',
    'acute',
    'circumflex',
    'tilde',
    'macron',
    'breve',
    'dotaccent',
    'dieresis',
    '',
    'ring',
    'cedilla',
    '',
    'hungarumlaut',
    'ogonek',
    'caron',
    'emdash',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    'AE',
    '',
    'ordfeminine',
    '',
    '',
    '',
    '',
    'Lslash',
    'Oslash',
    'OE',
    'ordmasculine',
    '',
    '',
    '',
    '',
    '',
    'ae',
    '',
    '',
    '',
    'dotlessi',
    '',
    '',
    'lslash',
    'oslash',
    'oe',
    'germandbls'
];
let $6d519e6f260f4e02$var$$bc0433d9b7e41f5f$export$4f58f497e14a53c3 = [
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    'space',
    'exclamsmall',
    'Hungarumlautsmall',
    '',
    'dollaroldstyle',
    'dollarsuperior',
    'ampersandsmall',
    'Acutesmall',
    'parenleftsuperior',
    'parenrightsuperior',
    'twodotenleader',
    'onedotenleader',
    'comma',
    'hyphen',
    'period',
    'fraction',
    'zerooldstyle',
    'oneoldstyle',
    'twooldstyle',
    'threeoldstyle',
    'fouroldstyle',
    'fiveoldstyle',
    'sixoldstyle',
    'sevenoldstyle',
    'eightoldstyle',
    'nineoldstyle',
    'colon',
    'semicolon',
    'commasuperior',
    'threequartersemdash',
    'periodsuperior',
    'questionsmall',
    '',
    'asuperior',
    'bsuperior',
    'centsuperior',
    'dsuperior',
    'esuperior',
    '',
    '',
    'isuperior',
    '',
    '',
    'lsuperior',
    'msuperior',
    'nsuperior',
    'osuperior',
    '',
    '',
    'rsuperior',
    'ssuperior',
    'tsuperior',
    '',
    'ff',
    'fi',
    'fl',
    'ffi',
    'ffl',
    'parenleftinferior',
    '',
    'parenrightinferior',
    'Circumflexsmall',
    'hyphensuperior',
    'Gravesmall',
    'Asmall',
    'Bsmall',
    'Csmall',
    'Dsmall',
    'Esmall',
    'Fsmall',
    'Gsmall',
    'Hsmall',
    'Ismall',
    'Jsmall',
    'Ksmall',
    'Lsmall',
    'Msmall',
    'Nsmall',
    'Osmall',
    'Psmall',
    'Qsmall',
    'Rsmall',
    'Ssmall',
    'Tsmall',
    'Usmall',
    'Vsmall',
    'Wsmall',
    'Xsmall',
    'Ysmall',
    'Zsmall',
    'colonmonetary',
    'onefitted',
    'rupiah',
    'Tildesmall',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    'exclamdownsmall',
    'centoldstyle',
    'Lslashsmall',
    '',
    '',
    'Scaronsmall',
    'Zcaronsmall',
    'Dieresissmall',
    'Brevesmall',
    'Caronsmall',
    '',
    'Dotaccentsmall',
    '',
    '',
    'Macronsmall',
    '',
    '',
    'figuredash',
    'hypheninferior',
    '',
    '',
    'Ogoneksmall',
    'Ringsmall',
    'Cedillasmall',
    '',
    '',
    '',
    'onequarter',
    'onehalf',
    'threequarters',
    'questiondownsmall',
    'oneeighth',
    'threeeighths',
    'fiveeighths',
    'seveneighths',
    'onethird',
    'twothirds',
    '',
    '',
    'zerosuperior',
    'onesuperior',
    'twosuperior',
    'threesuperior',
    'foursuperior',
    'fivesuperior',
    'sixsuperior',
    'sevensuperior',
    'eightsuperior',
    'ninesuperior',
    'zeroinferior',
    'oneinferior',
    'twoinferior',
    'threeinferior',
    'fourinferior',
    'fiveinferior',
    'sixinferior',
    'seveninferior',
    'eightinferior',
    'nineinferior',
    'centinferior',
    'dollarinferior',
    'periodinferior',
    'commainferior',
    'Agravesmall',
    'Aacutesmall',
    'Acircumflexsmall',
    'Atildesmall',
    'Adieresissmall',
    'Aringsmall',
    'AEsmall',
    'Ccedillasmall',
    'Egravesmall',
    'Eacutesmall',
    'Ecircumflexsmall',
    'Edieresissmall',
    'Igravesmall',
    'Iacutesmall',
    'Icircumflexsmall',
    'Idieresissmall',
    'Ethsmall',
    'Ntildesmall',
    'Ogravesmall',
    'Oacutesmall',
    'Ocircumflexsmall',
    'Otildesmall',
    'Odieresissmall',
    'OEsmall',
    'Oslashsmall',
    'Ugravesmall',
    'Uacutesmall',
    'Ucircumflexsmall',
    'Udieresissmall',
    'Yacutesmall',
    'Thornsmall',
    'Ydieresissmall'
];
let $6d519e6f260f4e02$var$$ef658f5c9a1488b2$export$c33b50336c234f16 = [
    '.notdef',
    'space',
    'exclam',
    'quotedbl',
    'numbersign',
    'dollar',
    'percent',
    'ampersand',
    'quoteright',
    'parenleft',
    'parenright',
    'asterisk',
    'plus',
    'comma',
    'hyphen',
    'period',
    'slash',
    'zero',
    'one',
    'two',
    'three',
    'four',
    'five',
    'six',
    'seven',
    'eight',
    'nine',
    'colon',
    'semicolon',
    'less',
    'equal',
    'greater',
    'question',
    'at',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    'bracketleft',
    'backslash',
    'bracketright',
    'asciicircum',
    'underscore',
    'quoteleft',
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
    'braceleft',
    'bar',
    'braceright',
    'asciitilde',
    'exclamdown',
    'cent',
    'sterling',
    'fraction',
    'yen',
    'florin',
    'section',
    'currency',
    'quotesingle',
    'quotedblleft',
    'guillemotleft',
    'guilsinglleft',
    'guilsinglright',
    'fi',
    'fl',
    'endash',
    'dagger',
    'daggerdbl',
    'periodcentered',
    'paragraph',
    'bullet',
    'quotesinglbase',
    'quotedblbase',
    'quotedblright',
    'guillemotright',
    'ellipsis',
    'perthousand',
    'questiondown',
    'grave',
    'acute',
    'circumflex',
    'tilde',
    'macron',
    'breve',
    'dotaccent',
    'dieresis',
    'ring',
    'cedilla',
    'hungarumlaut',
    'ogonek',
    'caron',
    'emdash',
    'AE',
    'ordfeminine',
    'Lslash',
    'Oslash',
    'OE',
    'ordmasculine',
    'ae',
    'dotlessi',
    'lslash',
    'oslash',
    'oe',
    'germandbls',
    'onesuperior',
    'logicalnot',
    'mu',
    'trademark',
    'Eth',
    'onehalf',
    'plusminus',
    'Thorn',
    'onequarter',
    'divide',
    'brokenbar',
    'degree',
    'thorn',
    'threequarters',
    'twosuperior',
    'registered',
    'minus',
    'eth',
    'multiply',
    'threesuperior',
    'copyright',
    'Aacute',
    'Acircumflex',
    'Adieresis',
    'Agrave',
    'Aring',
    'Atilde',
    'Ccedilla',
    'Eacute',
    'Ecircumflex',
    'Edieresis',
    'Egrave',
    'Iacute',
    'Icircumflex',
    'Idieresis',
    'Igrave',
    'Ntilde',
    'Oacute',
    'Ocircumflex',
    'Odieresis',
    'Ograve',
    'Otilde',
    'Scaron',
    'Uacute',
    'Ucircumflex',
    'Udieresis',
    'Ugrave',
    'Yacute',
    'Ydieresis',
    'Zcaron',
    'aacute',
    'acircumflex',
    'adieresis',
    'agrave',
    'aring',
    'atilde',
    'ccedilla',
    'eacute',
    'ecircumflex',
    'edieresis',
    'egrave',
    'iacute',
    'icircumflex',
    'idieresis',
    'igrave',
    'ntilde',
    'oacute',
    'ocircumflex',
    'odieresis',
    'ograve',
    'otilde',
    'scaron',
    'uacute',
    'ucircumflex',
    'udieresis',
    'ugrave',
    'yacute',
    'ydieresis',
    'zcaron'
];
let $6d519e6f260f4e02$var$$ef658f5c9a1488b2$export$3ed0f9e1fee8d489 = [
    '.notdef',
    'space',
    'exclamsmall',
    'Hungarumlautsmall',
    'dollaroldstyle',
    'dollarsuperior',
    'ampersandsmall',
    'Acutesmall',
    'parenleftsuperior',
    'parenrightsuperior',
    'twodotenleader',
    'onedotenleader',
    'comma',
    'hyphen',
    'period',
    'fraction',
    'zerooldstyle',
    'oneoldstyle',
    'twooldstyle',
    'threeoldstyle',
    'fouroldstyle',
    'fiveoldstyle',
    'sixoldstyle',
    'sevenoldstyle',
    'eightoldstyle',
    'nineoldstyle',
    'colon',
    'semicolon',
    'commasuperior',
    'threequartersemdash',
    'periodsuperior',
    'questionsmall',
    'asuperior',
    'bsuperior',
    'centsuperior',
    'dsuperior',
    'esuperior',
    'isuperior',
    'lsuperior',
    'msuperior',
    'nsuperior',
    'osuperior',
    'rsuperior',
    'ssuperior',
    'tsuperior',
    'ff',
    'fi',
    'fl',
    'ffi',
    'ffl',
    'parenleftinferior',
    'parenrightinferior',
    'Circumflexsmall',
    'hyphensuperior',
    'Gravesmall',
    'Asmall',
    'Bsmall',
    'Csmall',
    'Dsmall',
    'Esmall',
    'Fsmall',
    'Gsmall',
    'Hsmall',
    'Ismall',
    'Jsmall',
    'Ksmall',
    'Lsmall',
    'Msmall',
    'Nsmall',
    'Osmall',
    'Psmall',
    'Qsmall',
    'Rsmall',
    'Ssmall',
    'Tsmall',
    'Usmall',
    'Vsmall',
    'Wsmall',
    'Xsmall',
    'Ysmall',
    'Zsmall',
    'colonmonetary',
    'onefitted',
    'rupiah',
    'Tildesmall',
    'exclamdownsmall',
    'centoldstyle',
    'Lslashsmall',
    'Scaronsmall',
    'Zcaronsmall',
    'Dieresissmall',
    'Brevesmall',
    'Caronsmall',
    'Dotaccentsmall',
    'Macronsmall',
    'figuredash',
    'hypheninferior',
    'Ogoneksmall',
    'Ringsmall',
    'Cedillasmall',
    'onequarter',
    'onehalf',
    'threequarters',
    'questiondownsmall',
    'oneeighth',
    'threeeighths',
    'fiveeighths',
    'seveneighths',
    'onethird',
    'twothirds',
    'zerosuperior',
    'onesuperior',
    'twosuperior',
    'threesuperior',
    'foursuperior',
    'fivesuperior',
    'sixsuperior',
    'sevensuperior',
    'eightsuperior',
    'ninesuperior',
    'zeroinferior',
    'oneinferior',
    'twoinferior',
    'threeinferior',
    'fourinferior',
    'fiveinferior',
    'sixinferior',
    'seveninferior',
    'eightinferior',
    'nineinferior',
    'centinferior',
    'dollarinferior',
    'periodinferior',
    'commainferior',
    'Agravesmall',
    'Aacutesmall',
    'Acircumflexsmall',
    'Atildesmall',
    'Adieresissmall',
    'Aringsmall',
    'AEsmall',
    'Ccedillasmall',
    'Egravesmall',
    'Eacutesmall',
    'Ecircumflexsmall',
    'Edieresissmall',
    'Igravesmall',
    'Iacutesmall',
    'Icircumflexsmall',
    'Idieresissmall',
    'Ethsmall',
    'Ntildesmall',
    'Ogravesmall',
    'Oacutesmall',
    'Ocircumflexsmall',
    'Otildesmall',
    'Odieresissmall',
    'OEsmall',
    'Oslashsmall',
    'Ugravesmall',
    'Uacutesmall',
    'Ucircumflexsmall',
    'Udieresissmall',
    'Yacutesmall',
    'Thornsmall',
    'Ydieresissmall'
];
let $6d519e6f260f4e02$var$$ef658f5c9a1488b2$export$dc28be11139d4120 = [
    '.notdef',
    'space',
    'dollaroldstyle',
    'dollarsuperior',
    'parenleftsuperior',
    'parenrightsuperior',
    'twodotenleader',
    'onedotenleader',
    'comma',
    'hyphen',
    'period',
    'fraction',
    'zerooldstyle',
    'oneoldstyle',
    'twooldstyle',
    'threeoldstyle',
    'fouroldstyle',
    'fiveoldstyle',
    'sixoldstyle',
    'sevenoldstyle',
    'eightoldstyle',
    'nineoldstyle',
    'colon',
    'semicolon',
    'commasuperior',
    'threequartersemdash',
    'periodsuperior',
    'asuperior',
    'bsuperior',
    'centsuperior',
    'dsuperior',
    'esuperior',
    'isuperior',
    'lsuperior',
    'msuperior',
    'nsuperior',
    'osuperior',
    'rsuperior',
    'ssuperior',
    'tsuperior',
    'ff',
    'fi',
    'fl',
    'ffi',
    'ffl',
    'parenleftinferior',
    'parenrightinferior',
    'hyphensuperior',
    'colonmonetary',
    'onefitted',
    'rupiah',
    'centoldstyle',
    'figuredash',
    'hypheninferior',
    'onequarter',
    'onehalf',
    'threequarters',
    'oneeighth',
    'threeeighths',
    'fiveeighths',
    'seveneighths',
    'onethird',
    'twothirds',
    'zerosuperior',
    'onesuperior',
    'twosuperior',
    'threesuperior',
    'foursuperior',
    'fivesuperior',
    'sixsuperior',
    'sevensuperior',
    'eightsuperior',
    'ninesuperior',
    'zeroinferior',
    'oneinferior',
    'twoinferior',
    'threeinferior',
    'fourinferior',
    'fiveinferior',
    'sixinferior',
    'seveninferior',
    'eightinferior',
    'nineinferior',
    'centinferior',
    'dollarinferior',
    'periodinferior',
    'commainferior'
];
//########################
// Scripts and Languages #
//########################
let $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$var$LangSysTable = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    reserved: new (0, $f612a7b97d3685e8$export$da9b5fe187a9aa1)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456)),
    reqFeatureIndex: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    featureCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    featureIndexes: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), 'featureCount')
});
let $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$var$LangSysRecord = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    tag: new (0, $b2061d4384f873cb$export$89b8e0fa65f6a914)(4),
    langSys: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$var$LangSysTable, {
        type: 'parent'
    })
});
let $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$var$Script = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    defaultLangSys: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$var$LangSysTable),
    count: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    langSysRecords: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$var$LangSysRecord, 'count')
});
let $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$var$ScriptRecord = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    tag: new (0, $b2061d4384f873cb$export$89b8e0fa65f6a914)(4),
    script: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$var$Script, {
        type: 'parent'
    })
});
let $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$3e15fc05ce864229 = new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$var$ScriptRecord, (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456));
//#######################
// Features and Lookups #
//#######################
let $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$var$FeatureParams = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    version: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    nameID: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456)
});
let $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$6e91cf7616333d5 = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    featureParams: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$var$FeatureParams),
    lookupCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    lookupListIndexes: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), 'lookupCount')
});
let $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$var$FeatureRecord = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    tag: new (0, $b2061d4384f873cb$export$89b8e0fa65f6a914)(4),
    feature: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$6e91cf7616333d5, {
        type: 'parent'
    })
});
let $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$aa18130def4b6cb4 = new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$var$FeatureRecord, (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456));
let $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$var$LookupFlags = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    markAttachmentType: (0, $2b9a2a5e7d043014$export$52e103c63c4e68cf),
    flags: new (0, $701e08229fc30ff7$export$96b43b8a49f688ea)((0, $2b9a2a5e7d043014$export$52e103c63c4e68cf), [
        'rightToLeft',
        'ignoreBaseGlyphs',
        'ignoreLigatures',
        'ignoreMarks',
        'useMarkFilteringSet'
    ])
});
function $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$df0008c6ff2da22a(SubTable) {
    let Lookup = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
        lookupType: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        flags: $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$var$LookupFlags,
        subTableCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        subTables: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)(new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), SubTable), 'subTableCount'),
        markFilteringSet: new (0, $72804d503192edec$export$7acb7b24c478f9c6)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), (t)=>t.flags.flags.useMarkFilteringSet)
    });
    return new (0, $ed4a2faff705c483$export$5576c026028d4983)(new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), Lookup), (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456));
}
//#################
// Coverage Table #
//#################
let $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$var$RangeRecord = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    start: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    end: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    startCoverageIndex: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456)
});
let $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$17608c3f81a6111 = new (0, $00bf8c7e3dccf9c9$export$95a8b60f4da7dec8)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), {
    1: {
        glyphCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        glyphs: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), 'glyphCount')
    },
    2: {
        rangeCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        rangeRecords: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$var$RangeRecord, 'rangeCount')
    }
});
//#########################
// Class Definition Table #
//#########################
let $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$var$ClassRangeRecord = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    start: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    end: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    class: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456)
});
let $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$843d551fbbafef71 = new (0, $00bf8c7e3dccf9c9$export$95a8b60f4da7dec8)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), {
    1: {
        startGlyph: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        glyphCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        classValueArray: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), 'glyphCount')
    },
    2: {
        classRangeCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        classRangeRecord: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$var$ClassRangeRecord, 'classRangeCount')
    }
});
let $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$8215d14a63d9fb10 = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    a: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    b: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    deltaFormat: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456)
});
//#############################################
// Contextual Substitution/Positioning Tables #
//#############################################
let $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$var$LookupRecord = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    sequenceIndex: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    lookupListIndex: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456)
});
let $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$var$Rule = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    glyphCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    lookupCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    input: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), (t)=>t.glyphCount - 1),
    lookupRecords: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$var$LookupRecord, 'lookupCount')
});
let $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$var$RuleSet = new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)(new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$var$Rule), (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456));
let $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$var$ClassRule = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    glyphCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    lookupCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    classes: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), (t)=>t.glyphCount - 1),
    lookupRecords: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$var$LookupRecord, 'lookupCount')
});
let $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$var$ClassSet = new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)(new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$var$ClassRule), (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456));
let $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$841858b892ce1f4c = new (0, $00bf8c7e3dccf9c9$export$95a8b60f4da7dec8)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), {
    1: {
        coverage: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$17608c3f81a6111),
        ruleSetCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        ruleSets: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)(new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$var$RuleSet), 'ruleSetCount')
    },
    2: {
        coverage: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$17608c3f81a6111),
        classDef: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$843d551fbbafef71),
        classSetCnt: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        classSet: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)(new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$var$ClassSet), 'classSetCnt')
    },
    3: {
        glyphCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        lookupCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        coverages: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)(new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$17608c3f81a6111), 'glyphCount'),
        lookupRecords: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$var$LookupRecord, 'lookupCount')
    }
});
//######################################################
// Chaining Contextual Substitution/Positioning Tables #
//######################################################
let $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$var$ChainRule = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    backtrackGlyphCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    backtrack: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), 'backtrackGlyphCount'),
    inputGlyphCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    input: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), (t)=>t.inputGlyphCount - 1),
    lookaheadGlyphCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    lookahead: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), 'lookaheadGlyphCount'),
    lookupCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    lookupRecords: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$var$LookupRecord, 'lookupCount')
});
let $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$var$ChainRuleSet = new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)(new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$var$ChainRule), (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456));
let $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$5e6d09e6861162f6 = new (0, $00bf8c7e3dccf9c9$export$95a8b60f4da7dec8)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), {
    1: {
        coverage: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$17608c3f81a6111),
        chainCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        chainRuleSets: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)(new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$var$ChainRuleSet), 'chainCount')
    },
    2: {
        coverage: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$17608c3f81a6111),
        backtrackClassDef: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$843d551fbbafef71),
        inputClassDef: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$843d551fbbafef71),
        lookaheadClassDef: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$843d551fbbafef71),
        chainCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        chainClassSet: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)(new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$var$ChainRuleSet), 'chainCount')
    },
    3: {
        backtrackGlyphCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        backtrackCoverage: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)(new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$17608c3f81a6111), 'backtrackGlyphCount'),
        inputGlyphCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        inputCoverage: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)(new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$17608c3f81a6111), 'inputGlyphCount'),
        lookaheadGlyphCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        lookaheadCoverage: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)(new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$17608c3f81a6111), 'lookaheadGlyphCount'),
        lookupCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        lookupRecords: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$var$LookupRecord, 'lookupCount')
    }
});
/*******************
 * Variation Store *
 *******************/ let $6d519e6f260f4e02$var$$1a47b0c45c1c22fe$var$F2DOT14 = new (0, $2b9a2a5e7d043014$export$13475bbd2a37a9b4)(16, 'BE', 14);
let $6d519e6f260f4e02$var$$1a47b0c45c1c22fe$var$RegionAxisCoordinates = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    startCoord: $6d519e6f260f4e02$var$$1a47b0c45c1c22fe$var$F2DOT14,
    peakCoord: $6d519e6f260f4e02$var$$1a47b0c45c1c22fe$var$F2DOT14,
    endCoord: $6d519e6f260f4e02$var$$1a47b0c45c1c22fe$var$F2DOT14
});
let $6d519e6f260f4e02$var$$1a47b0c45c1c22fe$var$VariationRegionList = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    axisCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    regionCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    variationRegions: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)(new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$1a47b0c45c1c22fe$var$RegionAxisCoordinates, 'axisCount'), 'regionCount')
});
let $6d519e6f260f4e02$var$$1a47b0c45c1c22fe$var$DeltaSet = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    shortDeltas: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6), (t)=>t.parent.shortDeltaCount),
    regionDeltas: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$5984f25eab09961f), (t)=>t.parent.regionIndexCount - t.parent.shortDeltaCount),
    deltas: (t)=>t.shortDeltas.concat(t.regionDeltas)
});
let $6d519e6f260f4e02$var$$1a47b0c45c1c22fe$var$ItemVariationData = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    itemCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    shortDeltaCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    regionIndexCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    regionIndexes: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), 'regionIndexCount'),
    deltaSets: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$1a47b0c45c1c22fe$var$DeltaSet, 'itemCount')
});
let $6d519e6f260f4e02$var$$1a47b0c45c1c22fe$export$fe1b122a2710f241 = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    format: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    variationRegionList: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), $6d519e6f260f4e02$var$$1a47b0c45c1c22fe$var$VariationRegionList),
    variationDataCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    itemVariationData: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)(new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), $6d519e6f260f4e02$var$$1a47b0c45c1c22fe$var$ItemVariationData), 'variationDataCount')
});
/**********************
 * Feature Variations *
 **********************/ let $6d519e6f260f4e02$var$$1a47b0c45c1c22fe$var$ConditionTable = new (0, $00bf8c7e3dccf9c9$export$95a8b60f4da7dec8)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), {
    1: {
        axisIndex: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        axisIndex: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        filterRangeMinValue: $6d519e6f260f4e02$var$$1a47b0c45c1c22fe$var$F2DOT14,
        filterRangeMaxValue: $6d519e6f260f4e02$var$$1a47b0c45c1c22fe$var$F2DOT14
    }
});
let $6d519e6f260f4e02$var$$1a47b0c45c1c22fe$var$ConditionSet = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    conditionCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    conditionTable: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)(new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), $6d519e6f260f4e02$var$$1a47b0c45c1c22fe$var$ConditionTable), 'conditionCount')
});
let $6d519e6f260f4e02$var$$1a47b0c45c1c22fe$var$FeatureTableSubstitutionRecord = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    featureIndex: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    alternateFeatureTable: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$6e91cf7616333d5, {
        type: 'parent'
    })
});
let $6d519e6f260f4e02$var$$1a47b0c45c1c22fe$var$FeatureTableSubstitution = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    version: (0, $2b9a2a5e7d043014$export$e913265d48471f2d),
    substitutionCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    substitutions: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$1a47b0c45c1c22fe$var$FeatureTableSubstitutionRecord, 'substitutionCount')
});
let $6d519e6f260f4e02$var$$1a47b0c45c1c22fe$var$FeatureVariationRecord = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    conditionSet: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), $6d519e6f260f4e02$var$$1a47b0c45c1c22fe$var$ConditionSet, {
        type: 'parent'
    }),
    featureTableSubstitution: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), $6d519e6f260f4e02$var$$1a47b0c45c1c22fe$var$FeatureTableSubstitution, {
        type: 'parent'
    })
});
let $6d519e6f260f4e02$var$$1a47b0c45c1c22fe$export$441b70b7971dd419 = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    majorVersion: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    minorVersion: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    featureVariationRecordCount: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    featureVariationRecords: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$1a47b0c45c1c22fe$var$FeatureVariationRecord, 'featureVariationRecordCount')
});
// Checks if an operand is an index of a predefined value,
// otherwise delegates to the provided type.
class $6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$var$PredefinedOp {
    decode(stream, parent, operands) {
        if (this.predefinedOps[operands[0]]) return this.predefinedOps[operands[0]];
        return this.type.decode(stream, parent, operands);
    }
    size(value, ctx) {
        return this.type.size(value, ctx);
    }
    encode(stream, value, ctx) {
        let index = this.predefinedOps.indexOf(value);
        if (index !== -1) return index;
        return this.type.encode(stream, value, ctx);
    }
    constructor(predefinedOps, type){
        this.predefinedOps = predefinedOps;
        this.type = type;
    }
}
class $6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$var$CFFEncodingVersion extends (0, $2b9a2a5e7d043014$export$fffa67e515d04022) {
    decode(stream) {
        return (0, $2b9a2a5e7d043014$export$52e103c63c4e68cf).decode(stream) & 0x7f;
    }
    constructor(){
        super('UInt8');
    }
}
let $6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$var$Range1 = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    first: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    nLeft: (0, $2b9a2a5e7d043014$export$52e103c63c4e68cf)
});
let $6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$var$Range2 = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    first: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    nLeft: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456)
});
let $6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$var$CFFCustomEncoding = new (0, $00bf8c7e3dccf9c9$export$95a8b60f4da7dec8)(new $6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$var$CFFEncodingVersion(), {
    0: {
        nCodes: (0, $2b9a2a5e7d043014$export$52e103c63c4e68cf),
        codes: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$52e103c63c4e68cf), 'nCodes')
    },
    1: {
        nRanges: (0, $2b9a2a5e7d043014$export$52e103c63c4e68cf),
        ranges: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$var$Range1, 'nRanges')
    }
});
let $6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$var$CFFEncoding = new $6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$var$PredefinedOp([
    $6d519e6f260f4e02$var$$bc0433d9b7e41f5f$export$dee0027060fa13bd,
    $6d519e6f260f4e02$var$$bc0433d9b7e41f5f$export$4f58f497e14a53c3
], new $6d519e6f260f4e02$var$$0e34a43d05bde82c$export$2e2bcd8739ae039($6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$var$CFFCustomEncoding, {
    lazy: true
}));
// Decodes an array of ranges until the total
// length is equal to the provided length.
class $6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$var$RangeArray extends (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa) {
    decode(stream, parent) {
        let length = (0, $69cd4678dd9eb847$export$83b6dc3503c1fda6)(this.length, stream, parent);
        let count = 0;
        let res = [];
        while(count < length){
            let range = this.type.decode(stream, parent);
            range.offset = count;
            count += range.nLeft + 1;
            res.push(range);
        }
        return res;
    }
}
let $6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$var$CFFCustomCharset = new (0, $00bf8c7e3dccf9c9$export$95a8b60f4da7dec8)((0, $2b9a2a5e7d043014$export$52e103c63c4e68cf), {
    0: {
        glyphs: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), (t)=>t.parent.CharStrings.length - 1)
    },
    1: {
        ranges: new $6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$var$RangeArray($6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$var$Range1, (t)=>t.parent.CharStrings.length - 1)
    },
    2: {
        ranges: new $6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$var$RangeArray($6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$var$Range2, (t)=>t.parent.CharStrings.length - 1)
    }
});
let $6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$var$CFFCharset = new $6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$var$PredefinedOp([
    $6d519e6f260f4e02$var$$ef658f5c9a1488b2$export$c33b50336c234f16,
    $6d519e6f260f4e02$var$$ef658f5c9a1488b2$export$3ed0f9e1fee8d489,
    $6d519e6f260f4e02$var$$ef658f5c9a1488b2$export$dc28be11139d4120
], new $6d519e6f260f4e02$var$$0e34a43d05bde82c$export$2e2bcd8739ae039($6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$var$CFFCustomCharset, {
    lazy: true
}));
let $6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$var$FDRange3 = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    first: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    fd: (0, $2b9a2a5e7d043014$export$52e103c63c4e68cf)
});
let $6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$var$FDRange4 = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    first: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    fd: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456)
});
let $6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$var$FDSelect = new (0, $00bf8c7e3dccf9c9$export$95a8b60f4da7dec8)((0, $2b9a2a5e7d043014$export$52e103c63c4e68cf), {
    0: {
        fds: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$52e103c63c4e68cf), (t)=>t.parent.CharStrings.length)
    },
    3: {
        nRanges: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        ranges: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$var$FDRange3, 'nRanges'),
        sentinel: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456)
    },
    4: {
        nRanges: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
        ranges: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$var$FDRange4, 'nRanges'),
        sentinel: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d)
    }
});
let $6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$var$ptr = new $6d519e6f260f4e02$var$$0e34a43d05bde82c$export$2e2bcd8739ae039($6d519e6f260f4e02$var$$6d59db2e29cc77b3$export$2e2bcd8739ae039);
class $6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$var$CFFPrivateOp {
    decode(stream, parent, operands) {
        parent.length = operands[0];
        return $6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$var$ptr.decode(stream, parent, [
            operands[1]
        ]);
    }
    size(dict, ctx) {
        return [
            $6d519e6f260f4e02$var$$6d59db2e29cc77b3$export$2e2bcd8739ae039.size(dict, ctx, false),
            $6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$var$ptr.size(dict, ctx)[0]
        ];
    }
    encode(stream, dict, ctx) {
        return [
            $6d519e6f260f4e02$var$$6d59db2e29cc77b3$export$2e2bcd8739ae039.size(dict, ctx, false),
            $6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$var$ptr.encode(stream, dict, ctx)[0]
        ];
    }
}
let $6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$var$FontDict = new $6d519e6f260f4e02$var$$61aa549f16d58b9b$export$2e2bcd8739ae039([
    // key       name                   type(s)                                 default
    [
        18,
        'Private',
        new $6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$var$CFFPrivateOp,
        null
    ],
    [
        [
            12,
            38
        ],
        'FontName',
        'sid',
        null
    ],
    [
        [
            12,
            7
        ],
        'FontMatrix',
        'array',
        [
            0.001,
            0,
            0,
            0.001,
            0,
            0
        ]
    ],
    [
        [
            12,
            5
        ],
        'PaintType',
        'number',
        0
    ]
]);
let $6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$var$CFFTopDict = new $6d519e6f260f4e02$var$$61aa549f16d58b9b$export$2e2bcd8739ae039([
    // key       name                   type(s)                                 default
    [
        [
            12,
            30
        ],
        'ROS',
        [
            'sid',
            'sid',
            'number'
        ],
        null
    ],
    [
        0,
        'version',
        'sid',
        null
    ],
    [
        1,
        'Notice',
        'sid',
        null
    ],
    [
        [
            12,
            0
        ],
        'Copyright',
        'sid',
        null
    ],
    [
        2,
        'FullName',
        'sid',
        null
    ],
    [
        3,
        'FamilyName',
        'sid',
        null
    ],
    [
        4,
        'Weight',
        'sid',
        null
    ],
    [
        [
            12,
            1
        ],
        'isFixedPitch',
        'boolean',
        false
    ],
    [
        [
            12,
            2
        ],
        'ItalicAngle',
        'number',
        0
    ],
    [
        [
            12,
            3
        ],
        'UnderlinePosition',
        'number',
        -100
    ],
    [
        [
            12,
            4
        ],
        'UnderlineThickness',
        'number',
        50
    ],
    [
        [
            12,
            5
        ],
        'PaintType',
        'number',
        0
    ],
    [
        [
            12,
            6
        ],
        'CharstringType',
        'number',
        2
    ],
    [
        [
            12,
            7
        ],
        'FontMatrix',
        'array',
        [
            0.001,
            0,
            0,
            0.001,
            0,
            0
        ]
    ],
    [
        13,
        'UniqueID',
        'number',
        null
    ],
    [
        5,
        'FontBBox',
        'array',
        [
            0,
            0,
            0,
            0
        ]
    ],
    [
        [
            12,
            8
        ],
        'StrokeWidth',
        'number',
        0
    ],
    [
        14,
        'XUID',
        'array',
        null
    ],
    [
        15,
        'charset',
        $6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$var$CFFCharset,
        $6d519e6f260f4e02$var$$ef658f5c9a1488b2$export$c33b50336c234f16
    ],
    [
        16,
        'Encoding',
        $6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$var$CFFEncoding,
        $6d519e6f260f4e02$var$$bc0433d9b7e41f5f$export$dee0027060fa13bd
    ],
    [
        17,
        'CharStrings',
        new $6d519e6f260f4e02$var$$0e34a43d05bde82c$export$2e2bcd8739ae039(new $6d519e6f260f4e02$var$$43e9821ef3717eec$export$2e2bcd8739ae039),
        null
    ],
    [
        18,
        'Private',
        new $6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$var$CFFPrivateOp,
        null
    ],
    [
        [
            12,
            20
        ],
        'SyntheticBase',
        'number',
        null
    ],
    [
        [
            12,
            21
        ],
        'PostScript',
        'sid',
        null
    ],
    [
        [
            12,
            22
        ],
        'BaseFontName',
        'sid',
        null
    ],
    [
        [
            12,
            23
        ],
        'BaseFontBlend',
        'delta',
        null
    ],
    // CID font specific
    [
        [
            12,
            31
        ],
        'CIDFontVersion',
        'number',
        0
    ],
    [
        [
            12,
            32
        ],
        'CIDFontRevision',
        'number',
        0
    ],
    [
        [
            12,
            33
        ],
        'CIDFontType',
        'number',
        0
    ],
    [
        [
            12,
            34
        ],
        'CIDCount',
        'number',
        8720
    ],
    [
        [
            12,
            35
        ],
        'UIDBase',
        'number',
        null
    ],
    [
        [
            12,
            37
        ],
        'FDSelect',
        new $6d519e6f260f4e02$var$$0e34a43d05bde82c$export$2e2bcd8739ae039($6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$var$FDSelect),
        null
    ],
    [
        [
            12,
            36
        ],
        'FDArray',
        new $6d519e6f260f4e02$var$$0e34a43d05bde82c$export$2e2bcd8739ae039(new $6d519e6f260f4e02$var$$43e9821ef3717eec$export$2e2bcd8739ae039($6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$var$FontDict)),
        null
    ],
    [
        [
            12,
            38
        ],
        'FontName',
        'sid',
        null
    ]
]);
let $6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$var$VariationStore = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    length: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    itemVariationStore: $6d519e6f260f4e02$var$$1a47b0c45c1c22fe$export$fe1b122a2710f241
});
let $6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$var$CFF2TopDict = new $6d519e6f260f4e02$var$$61aa549f16d58b9b$export$2e2bcd8739ae039([
    [
        [
            12,
            7
        ],
        'FontMatrix',
        'array',
        [
            0.001,
            0,
            0,
            0.001,
            0,
            0
        ]
    ],
    [
        17,
        'CharStrings',
        new $6d519e6f260f4e02$var$$0e34a43d05bde82c$export$2e2bcd8739ae039(new $6d519e6f260f4e02$var$$43e9821ef3717eec$export$2e2bcd8739ae039),
        null
    ],
    [
        [
            12,
            37
        ],
        'FDSelect',
        new $6d519e6f260f4e02$var$$0e34a43d05bde82c$export$2e2bcd8739ae039($6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$var$FDSelect),
        null
    ],
    [
        [
            12,
            36
        ],
        'FDArray',
        new $6d519e6f260f4e02$var$$0e34a43d05bde82c$export$2e2bcd8739ae039(new $6d519e6f260f4e02$var$$43e9821ef3717eec$export$2e2bcd8739ae039($6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$var$FontDict)),
        null
    ],
    [
        24,
        'vstore',
        new $6d519e6f260f4e02$var$$0e34a43d05bde82c$export$2e2bcd8739ae039($6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$var$VariationStore),
        null
    ],
    [
        25,
        'maxstack',
        'number',
        193
    ]
]);
let $6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$var$CFFTop = new (0, $00bf8c7e3dccf9c9$export$95a8b60f4da7dec8)((0, $2b9a2a5e7d043014$export$a3abada75ef55921), {
    1: {
        hdrSize: (0, $2b9a2a5e7d043014$export$52e103c63c4e68cf),
        offSize: (0, $2b9a2a5e7d043014$export$52e103c63c4e68cf),
        nameIndex: new $6d519e6f260f4e02$var$$43e9821ef3717eec$export$2e2bcd8739ae039(new (0, $b2061d4384f873cb$export$89b8e0fa65f6a914)('length')),
        topDictIndex: new $6d519e6f260f4e02$var$$43e9821ef3717eec$export$2e2bcd8739ae039($6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$var$CFFTopDict),
        stringIndex: new $6d519e6f260f4e02$var$$43e9821ef3717eec$export$2e2bcd8739ae039(new (0, $b2061d4384f873cb$export$89b8e0fa65f6a914)('length')),
        globalSubrIndex: new $6d519e6f260f4e02$var$$43e9821ef3717eec$export$2e2bcd8739ae039
    },
    2: {
        hdrSize: (0, $2b9a2a5e7d043014$export$52e103c63c4e68cf),
        length: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        topDict: $6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$var$CFF2TopDict,
        globalSubrIndex: new $6d519e6f260f4e02$var$$43e9821ef3717eec$export$2e2bcd8739ae039
    }
});
var $6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$export$2e2bcd8739ae039 = $6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$var$CFFTop;
class $6d519e6f260f4e02$var$$822ac0d589e4e237$var$CFFFont {
    static decode(stream) {
        return new $6d519e6f260f4e02$var$$822ac0d589e4e237$var$CFFFont(stream);
    }
    decode() {
        let start = this.stream.pos;
        let top = $6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$export$2e2bcd8739ae039.decode(this.stream);
        for(let key in top){
            let val = top[key];
            this[key] = val;
        }
        if (this.version < 2) {
            if (this.topDictIndex.length !== 1) throw new Error("Only a single font is allowed in CFF");
            this.topDict = this.topDictIndex[0];
        }
        this.isCIDFont = this.topDict.ROS != null;
        return this;
    }
    string(sid) {
        if (this.version >= 2) return null;
        if (sid < $6d519e6f260f4e02$var$$229224aec43783c5$export$2e2bcd8739ae039.length) return $6d519e6f260f4e02$var$$229224aec43783c5$export$2e2bcd8739ae039[sid];
        return this.stringIndex[sid - $6d519e6f260f4e02$var$$229224aec43783c5$export$2e2bcd8739ae039.length];
    }
    get postscriptName() {
        if (this.version < 2) return this.nameIndex[0];
        return null;
    }
    get fullName() {
        return this.string(this.topDict.FullName);
    }
    get familyName() {
        return this.string(this.topDict.FamilyName);
    }
    getCharString(glyph) {
        this.stream.pos = this.topDict.CharStrings[glyph].offset;
        return this.stream.readBuffer(this.topDict.CharStrings[glyph].length);
    }
    getGlyphName(gid) {
        // CFF2 glyph names are in the post table.
        if (this.version >= 2) return null;
        // CID-keyed fonts don't have glyph names
        if (this.isCIDFont) return null;
        let { charset: charset } = this.topDict;
        if (Array.isArray(charset)) return charset[gid];
        if (gid === 0) return '.notdef';
        gid -= 1;
        switch(charset.version){
            case 0:
                return this.string(charset.glyphs[gid]);
            case 1:
            case 2:
                for(let i = 0; i < charset.ranges.length; i++){
                    let range = charset.ranges[i];
                    if (range.offset <= gid && gid <= range.offset + range.nLeft) return this.string(range.first + (gid - range.offset));
                }
                break;
        }
        return null;
    }
    fdForGlyph(gid) {
        if (!this.topDict.FDSelect) return null;
        switch(this.topDict.FDSelect.version){
            case 0:
                return this.topDict.FDSelect.fds[gid];
            case 3:
            case 4:
                let { ranges: ranges } = this.topDict.FDSelect;
                let low = 0;
                let high = ranges.length - 1;
                while(low <= high){
                    let mid = low + high >> 1;
                    if (gid < ranges[mid].first) high = mid - 1;
                    else if (mid < high && gid >= ranges[mid + 1].first) low = mid + 1;
                    else return ranges[mid].fd;
                }
            default:
                throw new Error(`Unknown FDSelect version: ${this.topDict.FDSelect.version}`);
        }
    }
    privateDictForGlyph(gid) {
        if (this.topDict.FDSelect) {
            let fd = this.fdForGlyph(gid);
            if (this.topDict.FDArray[fd]) return this.topDict.FDArray[fd].Private;
            return null;
        }
        if (this.version < 2) return this.topDict.Private;
        return this.topDict.FDArray[0].Private;
    }
    constructor(stream){
        this.stream = stream;
        this.decode();
    }
}
var $6d519e6f260f4e02$var$$822ac0d589e4e237$export$2e2bcd8739ae039 = $6d519e6f260f4e02$var$$822ac0d589e4e237$var$CFFFont;
let $6d519e6f260f4e02$var$$2bbf2bc1ce37cd8f$var$VerticalOrigin = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    glyphIndex: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    vertOriginY: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6)
});
var $6d519e6f260f4e02$var$$2bbf2bc1ce37cd8f$export$2e2bcd8739ae039 = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    majorVersion: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    minorVersion: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    defaultVertOriginY: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    numVertOriginYMetrics: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    metrics: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$2bbf2bc1ce37cd8f$var$VerticalOrigin, 'numVertOriginYMetrics')
});
let $6d519e6f260f4e02$var$$0941618dc22a946d$export$16b227cb15d716a0 = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    height: (0, $2b9a2a5e7d043014$export$52e103c63c4e68cf),
    width: (0, $2b9a2a5e7d043014$export$52e103c63c4e68cf),
    horiBearingX: (0, $2b9a2a5e7d043014$export$5984f25eab09961f),
    horiBearingY: (0, $2b9a2a5e7d043014$export$5984f25eab09961f),
    horiAdvance: (0, $2b9a2a5e7d043014$export$52e103c63c4e68cf),
    vertBearingX: (0, $2b9a2a5e7d043014$export$5984f25eab09961f),
    vertBearingY: (0, $2b9a2a5e7d043014$export$5984f25eab09961f),
    vertAdvance: (0, $2b9a2a5e7d043014$export$52e103c63c4e68cf)
});
let $6d519e6f260f4e02$var$$0941618dc22a946d$export$62c53e75f69bfe12 = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    height: (0, $2b9a2a5e7d043014$export$52e103c63c4e68cf),
    width: (0, $2b9a2a5e7d043014$export$52e103c63c4e68cf),
    bearingX: (0, $2b9a2a5e7d043014$export$5984f25eab09961f),
    bearingY: (0, $2b9a2a5e7d043014$export$5984f25eab09961f),
    advance: (0, $2b9a2a5e7d043014$export$52e103c63c4e68cf)
});
let $6d519e6f260f4e02$var$$0941618dc22a946d$var$EBDTComponent = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    glyph: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    xOffset: (0, $2b9a2a5e7d043014$export$5984f25eab09961f),
    yOffset: (0, $2b9a2a5e7d043014$export$5984f25eab09961f)
});
class $6d519e6f260f4e02$var$$0941618dc22a946d$var$ByteAligned {
}
class $6d519e6f260f4e02$var$$0941618dc22a946d$var$BitAligned {
}
let $6d519e6f260f4e02$var$$0941618dc22a946d$export$f1f5ddeb20d14f = new (0, $00bf8c7e3dccf9c9$export$95a8b60f4da7dec8)('version', {
    1: {
        metrics: $6d519e6f260f4e02$var$$0941618dc22a946d$export$62c53e75f69bfe12,
        data: $6d519e6f260f4e02$var$$0941618dc22a946d$var$ByteAligned
    },
    2: {
        metrics: $6d519e6f260f4e02$var$$0941618dc22a946d$export$62c53e75f69bfe12,
        data: $6d519e6f260f4e02$var$$0941618dc22a946d$var$BitAligned
    },
    // format 3 is deprecated
    // format 4 is not supported by Microsoft
    5: {
        data: $6d519e6f260f4e02$var$$0941618dc22a946d$var$BitAligned
    },
    6: {
        metrics: $6d519e6f260f4e02$var$$0941618dc22a946d$export$16b227cb15d716a0,
        data: $6d519e6f260f4e02$var$$0941618dc22a946d$var$ByteAligned
    },
    7: {
        metrics: $6d519e6f260f4e02$var$$0941618dc22a946d$export$16b227cb15d716a0,
        data: $6d519e6f260f4e02$var$$0941618dc22a946d$var$BitAligned
    },
    8: {
        metrics: $6d519e6f260f4e02$var$$0941618dc22a946d$export$62c53e75f69bfe12,
        pad: new (0, $f612a7b97d3685e8$export$da9b5fe187a9aa1)((0, $2b9a2a5e7d043014$export$52e103c63c4e68cf)),
        numComponents: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        components: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$0941618dc22a946d$var$EBDTComponent, 'numComponents')
    },
    9: {
        metrics: $6d519e6f260f4e02$var$$0941618dc22a946d$export$16b227cb15d716a0,
        pad: new (0, $f612a7b97d3685e8$export$da9b5fe187a9aa1)((0, $2b9a2a5e7d043014$export$52e103c63c4e68cf)),
        numComponents: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        components: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$0941618dc22a946d$var$EBDTComponent, 'numComponents')
    },
    17: {
        metrics: $6d519e6f260f4e02$var$$0941618dc22a946d$export$62c53e75f69bfe12,
        dataLen: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
        data: new (0, $272db5812670c438$export$7d22a0eea6656474)('dataLen')
    },
    18: {
        metrics: $6d519e6f260f4e02$var$$0941618dc22a946d$export$16b227cb15d716a0,
        dataLen: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
        data: new (0, $272db5812670c438$export$7d22a0eea6656474)('dataLen')
    },
    19: {
        dataLen: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
        data: new (0, $272db5812670c438$export$7d22a0eea6656474)('dataLen')
    }
});
let $6d519e6f260f4e02$var$$9911c4c7201c13de$var$SBitLineMetrics = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    ascender: (0, $2b9a2a5e7d043014$export$5984f25eab09961f),
    descender: (0, $2b9a2a5e7d043014$export$5984f25eab09961f),
    widthMax: (0, $2b9a2a5e7d043014$export$52e103c63c4e68cf),
    caretSlopeNumerator: (0, $2b9a2a5e7d043014$export$5984f25eab09961f),
    caretSlopeDenominator: (0, $2b9a2a5e7d043014$export$5984f25eab09961f),
    caretOffset: (0, $2b9a2a5e7d043014$export$5984f25eab09961f),
    minOriginSB: (0, $2b9a2a5e7d043014$export$5984f25eab09961f),
    minAdvanceSB: (0, $2b9a2a5e7d043014$export$5984f25eab09961f),
    maxBeforeBL: (0, $2b9a2a5e7d043014$export$5984f25eab09961f),
    minAfterBL: (0, $2b9a2a5e7d043014$export$5984f25eab09961f),
    pad: new (0, $f612a7b97d3685e8$export$da9b5fe187a9aa1)((0, $2b9a2a5e7d043014$export$5984f25eab09961f), 2)
});
let $6d519e6f260f4e02$var$$9911c4c7201c13de$var$CodeOffsetPair = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    glyphCode: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    offset: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456)
});
let $6d519e6f260f4e02$var$$9911c4c7201c13de$var$IndexSubtable = new (0, $00bf8c7e3dccf9c9$export$95a8b60f4da7dec8)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), {
    header: {
        imageFormat: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        imageDataOffset: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d)
    },
    1: {
        offsetArray: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), (t)=>t.parent.lastGlyphIndex - t.parent.firstGlyphIndex + 1)
    },
    2: {
        imageSize: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
        bigMetrics: $6d519e6f260f4e02$var$$0941618dc22a946d$export$16b227cb15d716a0
    },
    3: {
        offsetArray: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), (t)=>t.parent.lastGlyphIndex - t.parent.firstGlyphIndex + 1)
    },
    4: {
        numGlyphs: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
        glyphArray: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$9911c4c7201c13de$var$CodeOffsetPair, (t)=>t.numGlyphs + 1)
    },
    5: {
        imageSize: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
        bigMetrics: $6d519e6f260f4e02$var$$0941618dc22a946d$export$16b227cb15d716a0,
        numGlyphs: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
        glyphCodeArray: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), 'numGlyphs')
    }
});
let $6d519e6f260f4e02$var$$9911c4c7201c13de$var$IndexSubtableArray = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    firstGlyphIndex: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    lastGlyphIndex: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    subtable: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), $6d519e6f260f4e02$var$$9911c4c7201c13de$var$IndexSubtable)
});
let $6d519e6f260f4e02$var$$9911c4c7201c13de$var$BitmapSizeTable = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    indexSubTableArray: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$9911c4c7201c13de$var$IndexSubtableArray, 1), {
        type: 'parent'
    }),
    indexTablesSize: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    numberOfIndexSubTables: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    colorRef: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    hori: $6d519e6f260f4e02$var$$9911c4c7201c13de$var$SBitLineMetrics,
    vert: $6d519e6f260f4e02$var$$9911c4c7201c13de$var$SBitLineMetrics,
    startGlyphIndex: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    endGlyphIndex: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    ppemX: (0, $2b9a2a5e7d043014$export$52e103c63c4e68cf),
    ppemY: (0, $2b9a2a5e7d043014$export$52e103c63c4e68cf),
    bitDepth: (0, $2b9a2a5e7d043014$export$52e103c63c4e68cf),
    flags: new (0, $701e08229fc30ff7$export$96b43b8a49f688ea)((0, $2b9a2a5e7d043014$export$52e103c63c4e68cf), [
        'horizontal',
        'vertical'
    ])
});
var $6d519e6f260f4e02$var$$9911c4c7201c13de$export$2e2bcd8739ae039 = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    version: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    numSizes: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    sizes: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$9911c4c7201c13de$var$BitmapSizeTable, 'numSizes')
});
let $6d519e6f260f4e02$var$$abb847051efd51b1$var$ImageTable = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    ppem: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    resolution: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    imageOffsets: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)(new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), 'void'), (t)=>t.parent.parent.maxp.numGlyphs + 1)
});
var // It includes several image tables with images for each bitmap glyph
// of several different sizes.
$6d519e6f260f4e02$var$$abb847051efd51b1$export$2e2bcd8739ae039 = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    version: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    flags: new (0, $701e08229fc30ff7$export$96b43b8a49f688ea)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), [
        'renderOutlines'
    ]),
    numImgTables: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    imageTables: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)(new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), $6d519e6f260f4e02$var$$abb847051efd51b1$var$ImageTable), 'numImgTables')
});
let $6d519e6f260f4e02$var$$eb629188f3dfefdd$var$LayerRecord = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    gid: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    paletteIndex: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456 // Index value to use in the appropriate palette. This value must
    )
}); // be less than numPaletteEntries in the CPAL table, except for
// the special case noted below. Each palette entry is 16 bits.
// A palette index of 0xFFFF is a special case indicating that
// the text foreground color should be used.
let $6d519e6f260f4e02$var$$eb629188f3dfefdd$var$BaseGlyphRecord = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    gid: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    // and is not rendered for color.
    firstLayerIndex: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    // There will be numLayers consecutive entries for this base glyph.
    numLayers: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456)
});
var $6d519e6f260f4e02$var$$eb629188f3dfefdd$export$2e2bcd8739ae039 = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    version: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    numBaseGlyphRecords: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    baseGlyphRecord: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$eb629188f3dfefdd$var$BaseGlyphRecord, 'numBaseGlyphRecords')),
    layerRecords: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$eb629188f3dfefdd$var$LayerRecord, 'numLayerRecords'), {
        lazy: true
    }),
    numLayerRecords: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456)
});
let $6d519e6f260f4e02$var$$08734b8e7dc64587$var$ColorRecord = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    blue: (0, $2b9a2a5e7d043014$export$52e103c63c4e68cf),
    green: (0, $2b9a2a5e7d043014$export$52e103c63c4e68cf),
    red: (0, $2b9a2a5e7d043014$export$52e103c63c4e68cf),
    alpha: (0, $2b9a2a5e7d043014$export$52e103c63c4e68cf)
});
var $6d519e6f260f4e02$var$$08734b8e7dc64587$export$2e2bcd8739ae039 = new (0, $00bf8c7e3dccf9c9$export$95a8b60f4da7dec8)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), {
    header: {
        numPaletteEntries: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        numPalettes: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        numColorRecords: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        colorRecords: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$08734b8e7dc64587$var$ColorRecord, 'numColorRecords')),
        colorRecordIndices: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), 'numPalettes')
    },
    0: {},
    1: {
        offsetPaletteTypeArray: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), 'numPalettes')),
        offsetPaletteLabelArray: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), 'numPalettes')),
        offsetPaletteEntryLabelArray: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), 'numPaletteEntries'))
    }
});
let $6d519e6f260f4e02$var$$497cef411d884e34$var$BaseCoord = new (0, $00bf8c7e3dccf9c9$export$95a8b60f4da7dec8)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), {
    1: {
        coordinate: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6 // X or Y value, in design units
        )
    },
    2: {
        coordinate: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
        referenceGlyph: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        baseCoordPoint: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456 // Index of contour point on the referenceGlyph
        )
    },
    3: {
        coordinate: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
        deviceTable: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$8215d14a63d9fb10) // Device table for X or Y value
    }
});
let $6d519e6f260f4e02$var$$497cef411d884e34$var$BaseValues = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    defaultIndex: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    baseCoordCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    baseCoords: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)(new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$497cef411d884e34$var$BaseCoord), 'baseCoordCount')
});
let $6d519e6f260f4e02$var$$497cef411d884e34$var$FeatMinMaxRecord = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    tag: new (0, $b2061d4384f873cb$export$89b8e0fa65f6a914)(4),
    minCoord: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$497cef411d884e34$var$BaseCoord, {
        type: 'parent'
    }),
    maxCoord: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$497cef411d884e34$var$BaseCoord, {
        type: 'parent'
    }) // May be NULL
});
let $6d519e6f260f4e02$var$$497cef411d884e34$var$MinMax = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    minCoord: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$497cef411d884e34$var$BaseCoord),
    maxCoord: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$497cef411d884e34$var$BaseCoord),
    featMinMaxCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    featMinMaxRecords: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$497cef411d884e34$var$FeatMinMaxRecord, 'featMinMaxCount') // In alphabetical order
});
let $6d519e6f260f4e02$var$$497cef411d884e34$var$BaseLangSysRecord = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    tag: new (0, $b2061d4384f873cb$export$89b8e0fa65f6a914)(4),
    minMax: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$497cef411d884e34$var$MinMax, {
        type: 'parent'
    })
});
let $6d519e6f260f4e02$var$$497cef411d884e34$var$BaseScript = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    baseValues: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$497cef411d884e34$var$BaseValues),
    defaultMinMax: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$497cef411d884e34$var$MinMax),
    baseLangSysCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    baseLangSysRecords: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$497cef411d884e34$var$BaseLangSysRecord, 'baseLangSysCount') // in alphabetical order by BaseLangSysTag
});
let $6d519e6f260f4e02$var$$497cef411d884e34$var$BaseScriptRecord = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    tag: new (0, $b2061d4384f873cb$export$89b8e0fa65f6a914)(4),
    script: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$497cef411d884e34$var$BaseScript, {
        type: 'parent'
    })
});
let $6d519e6f260f4e02$var$$497cef411d884e34$var$BaseScriptList = new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$497cef411d884e34$var$BaseScriptRecord, (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456));
// Array of 4-byte baseline identification tags-must be in alphabetical order
let $6d519e6f260f4e02$var$$497cef411d884e34$var$BaseTagList = new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)(new (0, $b2061d4384f873cb$export$89b8e0fa65f6a914)(4), (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456));
let $6d519e6f260f4e02$var$$497cef411d884e34$var$Axis = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    baseTagList: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$497cef411d884e34$var$BaseTagList),
    baseScriptList: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$497cef411d884e34$var$BaseScriptList)
});
var $6d519e6f260f4e02$var$$497cef411d884e34$export$2e2bcd8739ae039 = new (0, $00bf8c7e3dccf9c9$export$95a8b60f4da7dec8)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), {
    header: {
        horizAxis: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$497cef411d884e34$var$Axis),
        vertAxis: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$497cef411d884e34$var$Axis) // May be NULL
    },
    0x00010000: {},
    0x00010001: {
        itemVariationStore: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), $6d519e6f260f4e02$var$$1a47b0c45c1c22fe$export$fe1b122a2710f241)
    }
});
let $6d519e6f260f4e02$var$$cf5f33c63ef209e6$var$AttachPoint = new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456));
let $6d519e6f260f4e02$var$$cf5f33c63ef209e6$var$AttachList = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    coverage: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$17608c3f81a6111),
    glyphCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    attachPoints: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)(new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$cf5f33c63ef209e6$var$AttachPoint), 'glyphCount')
});
let $6d519e6f260f4e02$var$$cf5f33c63ef209e6$var$CaretValue = new (0, $00bf8c7e3dccf9c9$export$95a8b60f4da7dec8)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), {
    1: {
        coordinate: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6)
    },
    2: {
        caretValuePoint: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456)
    },
    3: {
        coordinate: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
        deviceTable: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$8215d14a63d9fb10)
    }
});
let $6d519e6f260f4e02$var$$cf5f33c63ef209e6$var$LigGlyph = new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)(new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$cf5f33c63ef209e6$var$CaretValue), (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456));
let $6d519e6f260f4e02$var$$cf5f33c63ef209e6$var$LigCaretList = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    coverage: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$17608c3f81a6111),
    ligGlyphCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    ligGlyphs: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)(new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$cf5f33c63ef209e6$var$LigGlyph), 'ligGlyphCount')
});
let $6d519e6f260f4e02$var$$cf5f33c63ef209e6$var$MarkGlyphSetsDef = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    markSetTableFormat: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    markSetCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    coverage: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)(new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$17608c3f81a6111), 'markSetCount')
});
var $6d519e6f260f4e02$var$$cf5f33c63ef209e6$export$2e2bcd8739ae039 = new (0, $00bf8c7e3dccf9c9$export$95a8b60f4da7dec8)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), {
    header: {
        glyphClassDef: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$843d551fbbafef71),
        attachList: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$cf5f33c63ef209e6$var$AttachList),
        ligCaretList: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$cf5f33c63ef209e6$var$LigCaretList),
        markAttachClassDef: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$843d551fbbafef71)
    },
    0x00010000: {},
    0x00010002: {
        markGlyphSetsDef: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$cf5f33c63ef209e6$var$MarkGlyphSetsDef)
    },
    0x00010003: {
        markGlyphSetsDef: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$cf5f33c63ef209e6$var$MarkGlyphSetsDef),
        itemVariationStore: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), $6d519e6f260f4e02$var$$1a47b0c45c1c22fe$export$fe1b122a2710f241)
    }
});
let $6d519e6f260f4e02$var$$47e0e8ef515d9903$var$ValueFormat = new (0, $701e08229fc30ff7$export$96b43b8a49f688ea)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), [
    'xPlacement',
    'yPlacement',
    'xAdvance',
    'yAdvance',
    'xPlaDevice',
    'yPlaDevice',
    'xAdvDevice',
    'yAdvDevice'
]);
let $6d519e6f260f4e02$var$$47e0e8ef515d9903$var$types = {
    xPlacement: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    yPlacement: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    xAdvance: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    yAdvance: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    xPlaDevice: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$8215d14a63d9fb10, {
        type: 'global',
        relativeTo: (ctx)=>ctx.rel
    }),
    yPlaDevice: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$8215d14a63d9fb10, {
        type: 'global',
        relativeTo: (ctx)=>ctx.rel
    }),
    xAdvDevice: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$8215d14a63d9fb10, {
        type: 'global',
        relativeTo: (ctx)=>ctx.rel
    }),
    yAdvDevice: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$8215d14a63d9fb10, {
        type: 'global',
        relativeTo: (ctx)=>ctx.rel
    })
};
class $6d519e6f260f4e02$var$$47e0e8ef515d9903$var$ValueRecord {
    buildStruct(parent) {
        let struct = parent;
        while(!struct[this.key] && struct.parent)struct = struct.parent;
        if (!struct[this.key]) return;
        let fields = {};
        fields.rel = ()=>struct._startOffset;
        let format = struct[this.key];
        for(let key in format)if (format[key]) fields[key] = $6d519e6f260f4e02$var$$47e0e8ef515d9903$var$types[key];
        return new (0, $e3f85bd82b272d37$export$eabc71f011df675a)(fields);
    }
    size(val, ctx) {
        return this.buildStruct(ctx).size(val, ctx);
    }
    decode(stream, parent) {
        let res = this.buildStruct(parent).decode(stream, parent);
        delete res.rel;
        return res;
    }
    constructor(key = 'valueFormat'){
        this.key = key;
    }
}
let $6d519e6f260f4e02$var$$47e0e8ef515d9903$var$PairValueRecord = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    secondGlyph: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    value1: new $6d519e6f260f4e02$var$$47e0e8ef515d9903$var$ValueRecord('valueFormat1'),
    value2: new $6d519e6f260f4e02$var$$47e0e8ef515d9903$var$ValueRecord('valueFormat2')
});
let $6d519e6f260f4e02$var$$47e0e8ef515d9903$var$PairSet = new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$47e0e8ef515d9903$var$PairValueRecord, (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456));
let $6d519e6f260f4e02$var$$47e0e8ef515d9903$var$Class2Record = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    value1: new $6d519e6f260f4e02$var$$47e0e8ef515d9903$var$ValueRecord('valueFormat1'),
    value2: new $6d519e6f260f4e02$var$$47e0e8ef515d9903$var$ValueRecord('valueFormat2')
});
let $6d519e6f260f4e02$var$$47e0e8ef515d9903$var$Anchor = new (0, $00bf8c7e3dccf9c9$export$95a8b60f4da7dec8)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), {
    1: {
        xCoordinate: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
        yCoordinate: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6)
    },
    2: {
        xCoordinate: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
        yCoordinate: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
        anchorPoint: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456)
    },
    3: {
        xCoordinate: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
        yCoordinate: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
        xDeviceTable: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$8215d14a63d9fb10),
        yDeviceTable: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$8215d14a63d9fb10)
    }
});
let $6d519e6f260f4e02$var$$47e0e8ef515d9903$var$EntryExitRecord = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    entryAnchor: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$47e0e8ef515d9903$var$Anchor, {
        type: 'parent'
    }),
    exitAnchor: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$47e0e8ef515d9903$var$Anchor, {
        type: 'parent'
    })
});
let $6d519e6f260f4e02$var$$47e0e8ef515d9903$var$MarkRecord = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    class: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    markAnchor: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$47e0e8ef515d9903$var$Anchor, {
        type: 'parent'
    })
});
let $6d519e6f260f4e02$var$$47e0e8ef515d9903$var$MarkArray = new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$47e0e8ef515d9903$var$MarkRecord, (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456));
let $6d519e6f260f4e02$var$$47e0e8ef515d9903$var$BaseRecord = new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)(new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$47e0e8ef515d9903$var$Anchor), (t)=>t.parent.classCount);
let $6d519e6f260f4e02$var$$47e0e8ef515d9903$var$BaseArray = new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$47e0e8ef515d9903$var$BaseRecord, (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456));
let $6d519e6f260f4e02$var$$47e0e8ef515d9903$var$ComponentRecord = new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)(new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$47e0e8ef515d9903$var$Anchor), (t)=>t.parent.parent.classCount);
let $6d519e6f260f4e02$var$$47e0e8ef515d9903$var$LigatureAttach = new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$47e0e8ef515d9903$var$ComponentRecord, (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456));
let $6d519e6f260f4e02$var$$47e0e8ef515d9903$var$LigatureArray = new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)(new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$47e0e8ef515d9903$var$LigatureAttach), (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456));
let $6d519e6f260f4e02$var$$47e0e8ef515d9903$export$73a8cfb19cd43a0f = new (0, $00bf8c7e3dccf9c9$export$95a8b60f4da7dec8)('lookupType', {
    1: new (0, $00bf8c7e3dccf9c9$export$95a8b60f4da7dec8)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), {
        1: {
            coverage: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$17608c3f81a6111),
            valueFormat: $6d519e6f260f4e02$var$$47e0e8ef515d9903$var$ValueFormat,
            value: new $6d519e6f260f4e02$var$$47e0e8ef515d9903$var$ValueRecord()
        },
        2: {
            coverage: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$17608c3f81a6111),
            valueFormat: $6d519e6f260f4e02$var$$47e0e8ef515d9903$var$ValueFormat,
            valueCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
            values: new (0, $ed4a2faff705c483$export$5576c026028d4983)(new $6d519e6f260f4e02$var$$47e0e8ef515d9903$var$ValueRecord(), 'valueCount')
        }
    }),
    2: new (0, $00bf8c7e3dccf9c9$export$95a8b60f4da7dec8)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), {
        1: {
            coverage: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$17608c3f81a6111),
            valueFormat1: $6d519e6f260f4e02$var$$47e0e8ef515d9903$var$ValueFormat,
            valueFormat2: $6d519e6f260f4e02$var$$47e0e8ef515d9903$var$ValueFormat,
            pairSetCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
            pairSets: new (0, $ed4a2faff705c483$export$5576c026028d4983)(new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$47e0e8ef515d9903$var$PairSet), 'pairSetCount')
        },
        2: {
            coverage: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$17608c3f81a6111),
            valueFormat1: $6d519e6f260f4e02$var$$47e0e8ef515d9903$var$ValueFormat,
            valueFormat2: $6d519e6f260f4e02$var$$47e0e8ef515d9903$var$ValueFormat,
            classDef1: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$843d551fbbafef71),
            classDef2: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$843d551fbbafef71),
            class1Count: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
            class2Count: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
            classRecords: new (0, $ed4a2faff705c483$export$5576c026028d4983)(new (0, $ed4a2faff705c483$export$5576c026028d4983)($6d519e6f260f4e02$var$$47e0e8ef515d9903$var$Class2Record, 'class2Count'), 'class1Count')
        }
    }),
    3: {
        format: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        coverage: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$17608c3f81a6111),
        entryExitCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        entryExitRecords: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$47e0e8ef515d9903$var$EntryExitRecord, 'entryExitCount')
    },
    4: {
        format: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        markCoverage: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$17608c3f81a6111),
        baseCoverage: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$17608c3f81a6111),
        classCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        markArray: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$47e0e8ef515d9903$var$MarkArray),
        baseArray: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$47e0e8ef515d9903$var$BaseArray)
    },
    5: {
        format: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        markCoverage: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$17608c3f81a6111),
        ligatureCoverage: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$17608c3f81a6111),
        classCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        markArray: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$47e0e8ef515d9903$var$MarkArray),
        ligatureArray: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$47e0e8ef515d9903$var$LigatureArray)
    },
    6: {
        format: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        mark1Coverage: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$17608c3f81a6111),
        mark2Coverage: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$17608c3f81a6111),
        classCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        mark1Array: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$47e0e8ef515d9903$var$MarkArray),
        mark2Array: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$47e0e8ef515d9903$var$BaseArray)
    },
    7: $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$841858b892ce1f4c,
    8: $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$5e6d09e6861162f6,
    9: {
        posFormat: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        lookupType: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        extension: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), null)
    }
});
// Fix circular reference
$6d519e6f260f4e02$var$$47e0e8ef515d9903$export$73a8cfb19cd43a0f.versions[9].extension.type = $6d519e6f260f4e02$var$$47e0e8ef515d9903$export$73a8cfb19cd43a0f;
var $6d519e6f260f4e02$var$$47e0e8ef515d9903$export$2e2bcd8739ae039 = new (0, $00bf8c7e3dccf9c9$export$95a8b60f4da7dec8)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), {
    header: {
        scriptList: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$3e15fc05ce864229),
        featureList: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$aa18130def4b6cb4),
        lookupList: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), new $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$df0008c6ff2da22a($6d519e6f260f4e02$var$$47e0e8ef515d9903$export$73a8cfb19cd43a0f))
    },
    0x00010000: {},
    0x00010001: {
        featureVariations: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), $6d519e6f260f4e02$var$$1a47b0c45c1c22fe$export$441b70b7971dd419)
    }
});
let $6d519e6f260f4e02$var$$d3f442064af66e06$var$Sequence = new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456));
let $6d519e6f260f4e02$var$$d3f442064af66e06$var$AlternateSet = $6d519e6f260f4e02$var$$d3f442064af66e06$var$Sequence;
let $6d519e6f260f4e02$var$$d3f442064af66e06$var$Ligature = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    glyph: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    compCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    components: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), (t)=>t.compCount - 1)
});
let $6d519e6f260f4e02$var$$d3f442064af66e06$var$LigatureSet = new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)(new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$d3f442064af66e06$var$Ligature), (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456));
let $6d519e6f260f4e02$var$$d3f442064af66e06$var$GSUBLookup = new (0, $00bf8c7e3dccf9c9$export$95a8b60f4da7dec8)('lookupType', {
    1: new (0, $00bf8c7e3dccf9c9$export$95a8b60f4da7dec8)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), {
        1: {
            coverage: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$17608c3f81a6111),
            deltaGlyphID: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6)
        },
        2: {
            coverage: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$17608c3f81a6111),
            glyphCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
            substitute: new (0, $ed4a2faff705c483$export$5576c026028d4983)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), 'glyphCount')
        }
    }),
    2: {
        substFormat: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        coverage: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$17608c3f81a6111),
        count: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        sequences: new (0, $ed4a2faff705c483$export$5576c026028d4983)(new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$d3f442064af66e06$var$Sequence), 'count')
    },
    3: {
        substFormat: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        coverage: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$17608c3f81a6111),
        count: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        alternateSet: new (0, $ed4a2faff705c483$export$5576c026028d4983)(new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$d3f442064af66e06$var$AlternateSet), 'count')
    },
    4: {
        substFormat: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        coverage: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$17608c3f81a6111),
        count: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        ligatureSets: new (0, $ed4a2faff705c483$export$5576c026028d4983)(new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$d3f442064af66e06$var$LigatureSet), 'count')
    },
    5: $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$841858b892ce1f4c,
    6: $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$5e6d09e6861162f6,
    7: {
        substFormat: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        lookupType: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        extension: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), null)
    },
    8: {
        substFormat: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        coverage: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$17608c3f81a6111),
        backtrackCoverage: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)(new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$17608c3f81a6111), 'backtrackGlyphCount'),
        lookaheadGlyphCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        lookaheadCoverage: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)(new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$17608c3f81a6111), 'lookaheadGlyphCount'),
        glyphCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        substitutes: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), 'glyphCount')
    }
});
// Fix circular reference
$6d519e6f260f4e02$var$$d3f442064af66e06$var$GSUBLookup.versions[7].extension.type = $6d519e6f260f4e02$var$$d3f442064af66e06$var$GSUBLookup;
var $6d519e6f260f4e02$var$$d3f442064af66e06$export$2e2bcd8739ae039 = new (0, $00bf8c7e3dccf9c9$export$95a8b60f4da7dec8)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), {
    header: {
        scriptList: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$3e15fc05ce864229),
        featureList: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$aa18130def4b6cb4),
        lookupList: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), new $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$df0008c6ff2da22a($6d519e6f260f4e02$var$$d3f442064af66e06$var$GSUBLookup))
    },
    0x00010000: {},
    0x00010001: {
        featureVariations: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), $6d519e6f260f4e02$var$$1a47b0c45c1c22fe$export$441b70b7971dd419)
    }
});
let $6d519e6f260f4e02$var$$71cfb3c4767fbd0c$var$JstfGSUBModList = new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456));
let $6d519e6f260f4e02$var$$71cfb3c4767fbd0c$var$JstfPriority = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    shrinkageEnableGSUB: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$71cfb3c4767fbd0c$var$JstfGSUBModList),
    shrinkageDisableGSUB: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$71cfb3c4767fbd0c$var$JstfGSUBModList),
    shrinkageEnableGPOS: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$71cfb3c4767fbd0c$var$JstfGSUBModList),
    shrinkageDisableGPOS: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$71cfb3c4767fbd0c$var$JstfGSUBModList),
    shrinkageJstfMax: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), new $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$df0008c6ff2da22a($6d519e6f260f4e02$var$$47e0e8ef515d9903$export$73a8cfb19cd43a0f)),
    extensionEnableGSUB: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$71cfb3c4767fbd0c$var$JstfGSUBModList),
    extensionDisableGSUB: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$71cfb3c4767fbd0c$var$JstfGSUBModList),
    extensionEnableGPOS: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$71cfb3c4767fbd0c$var$JstfGSUBModList),
    extensionDisableGPOS: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$71cfb3c4767fbd0c$var$JstfGSUBModList),
    extensionJstfMax: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), new $6d519e6f260f4e02$var$$7cbbe4e24ef3cb75$export$df0008c6ff2da22a($6d519e6f260f4e02$var$$47e0e8ef515d9903$export$73a8cfb19cd43a0f))
});
let $6d519e6f260f4e02$var$$71cfb3c4767fbd0c$var$JstfLangSys = new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)(new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$71cfb3c4767fbd0c$var$JstfPriority), (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456));
let $6d519e6f260f4e02$var$$71cfb3c4767fbd0c$var$JstfLangSysRecord = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    tag: new (0, $b2061d4384f873cb$export$89b8e0fa65f6a914)(4),
    jstfLangSys: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$71cfb3c4767fbd0c$var$JstfLangSys)
});
let $6d519e6f260f4e02$var$$71cfb3c4767fbd0c$var$JstfScript = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    extenderGlyphs: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456))),
    defaultLangSys: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$71cfb3c4767fbd0c$var$JstfLangSys),
    langSysCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    langSysRecords: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$71cfb3c4767fbd0c$var$JstfLangSysRecord, 'langSysCount')
});
let $6d519e6f260f4e02$var$$71cfb3c4767fbd0c$var$JstfScriptRecord = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    tag: new (0, $b2061d4384f873cb$export$89b8e0fa65f6a914)(4),
    script: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$71cfb3c4767fbd0c$var$JstfScript, {
        type: 'parent'
    })
});
var $6d519e6f260f4e02$var$$71cfb3c4767fbd0c$export$2e2bcd8739ae039 = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    version: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    scriptCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    scriptList: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$71cfb3c4767fbd0c$var$JstfScriptRecord, 'scriptCount')
});
// TODO: add this to restructure
class $6d519e6f260f4e02$var$$d059a6bd2d3b5b63$var$VariableSizeNumber {
    decode(stream, parent) {
        switch(this.size(0, parent)){
            case 1:
                return stream.readUInt8();
            case 2:
                return stream.readUInt16BE();
            case 3:
                return stream.readUInt24BE();
            case 4:
                return stream.readUInt32BE();
        }
    }
    size(val, parent) {
        return (0, $69cd4678dd9eb847$export$83b6dc3503c1fda6)(this._size, null, parent);
    }
    constructor(size){
        this._size = size;
    }
}
let $6d519e6f260f4e02$var$$d059a6bd2d3b5b63$var$MapDataEntry = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    entry: new $6d519e6f260f4e02$var$$d059a6bd2d3b5b63$var$VariableSizeNumber((t)=>((t.parent.entryFormat & 0x0030) >> 4) + 1),
    outerIndex: (t)=>t.entry >> (t.parent.entryFormat & 0x000F) + 1,
    innerIndex: (t)=>t.entry & (1 << (t.parent.entryFormat & 0x000F) + 1) - 1
});
let $6d519e6f260f4e02$var$$d059a6bd2d3b5b63$var$DeltaSetIndexMap = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    entryFormat: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    mapCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    mapData: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$d059a6bd2d3b5b63$var$MapDataEntry, 'mapCount')
});
var $6d519e6f260f4e02$var$$d059a6bd2d3b5b63$export$2e2bcd8739ae039 = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    majorVersion: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    minorVersion: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    itemVariationStore: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), $6d519e6f260f4e02$var$$1a47b0c45c1c22fe$export$fe1b122a2710f241),
    advanceWidthMapping: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), $6d519e6f260f4e02$var$$d059a6bd2d3b5b63$var$DeltaSetIndexMap),
    LSBMapping: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), $6d519e6f260f4e02$var$$d059a6bd2d3b5b63$var$DeltaSetIndexMap),
    RSBMapping: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), $6d519e6f260f4e02$var$$d059a6bd2d3b5b63$var$DeltaSetIndexMap)
});
let $6d519e6f260f4e02$var$$dceeca3e1977ce30$var$Signature = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    format: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    length: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    offset: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d)
});
let $6d519e6f260f4e02$var$$dceeca3e1977ce30$var$SignatureBlock = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    reserved: new (0, $f612a7b97d3685e8$export$da9b5fe187a9aa1)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), 2),
    cbSignature: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    signature: new (0, $272db5812670c438$export$7d22a0eea6656474)('cbSignature')
});
var $6d519e6f260f4e02$var$$dceeca3e1977ce30$export$2e2bcd8739ae039 = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    ulVersion: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    usNumSigs: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    usFlag: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    signatures: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$dceeca3e1977ce30$var$Signature, 'usNumSigs'),
    signatureBlocks: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$dceeca3e1977ce30$var$SignatureBlock, 'usNumSigs')
});
let $6d519e6f260f4e02$var$$8acd740a9435aad0$var$GaspRange = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    rangeMaxPPEM: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    rangeGaspBehavior: new (0, $701e08229fc30ff7$export$96b43b8a49f688ea)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), [
        'grayscale',
        'gridfit',
        'symmetricSmoothing',
        'symmetricGridfit' // only in version 1, for ClearType
    ])
});
var $6d519e6f260f4e02$var$$8acd740a9435aad0$export$2e2bcd8739ae039 = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    version: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    numRanges: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    gaspRanges: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$8acd740a9435aad0$var$GaspRange, 'numRanges') // Sorted by ppem
});
let $6d519e6f260f4e02$var$$b5f380243c34d6a0$var$DeviceRecord = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    pixelSize: (0, $2b9a2a5e7d043014$export$52e103c63c4e68cf),
    maximumWidth: (0, $2b9a2a5e7d043014$export$52e103c63c4e68cf),
    widths: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$52e103c63c4e68cf), (t)=>t.parent.parent.maxp.numGlyphs)
});
var $6d519e6f260f4e02$var$$b5f380243c34d6a0$export$2e2bcd8739ae039 = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    version: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    numRecords: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    sizeDeviceRecord: (0, $2b9a2a5e7d043014$export$1d95835383bb05a),
    records: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$b5f380243c34d6a0$var$DeviceRecord, 'numRecords')
});
let $6d519e6f260f4e02$var$$ca2df1256966e313$var$KernPair = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    left: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    right: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    value: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6)
});
let $6d519e6f260f4e02$var$$ca2df1256966e313$var$ClassTable = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    firstGlyph: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    nGlyphs: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    offsets: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), 'nGlyphs'),
    max: (t)=>t.offsets.length && Math.max.apply(Math, t.offsets)
});
let $6d519e6f260f4e02$var$$ca2df1256966e313$var$Kern2Array = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    off: (t)=>t._startOffset - t.parent.parent._startOffset,
    len: (t)=>((t.parent.leftTable.max - t.off) / t.parent.rowWidth + 1) * (t.parent.rowWidth / 2),
    values: new (0, $ed4a2faff705c483$export$5576c026028d4983)((0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6), 'len')
});
let $6d519e6f260f4e02$var$$ca2df1256966e313$var$KernSubtable = new (0, $00bf8c7e3dccf9c9$export$95a8b60f4da7dec8)('format', {
    0: {
        nPairs: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        searchRange: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        entrySelector: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        rangeShift: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        pairs: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$ca2df1256966e313$var$KernPair, 'nPairs')
    },
    2: {
        rowWidth: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        leftTable: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$ca2df1256966e313$var$ClassTable, {
            type: 'parent'
        }),
        rightTable: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$ca2df1256966e313$var$ClassTable, {
            type: 'parent'
        }),
        array: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$ca2df1256966e313$var$Kern2Array, {
            type: 'parent'
        })
    },
    3: {
        glyphCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        kernValueCount: (0, $2b9a2a5e7d043014$export$52e103c63c4e68cf),
        leftClassCount: (0, $2b9a2a5e7d043014$export$52e103c63c4e68cf),
        rightClassCount: (0, $2b9a2a5e7d043014$export$52e103c63c4e68cf),
        flags: (0, $2b9a2a5e7d043014$export$52e103c63c4e68cf),
        kernValue: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6), 'kernValueCount'),
        leftClass: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$52e103c63c4e68cf), 'glyphCount'),
        rightClass: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$52e103c63c4e68cf), 'glyphCount'),
        kernIndex: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$52e103c63c4e68cf), (t)=>t.leftClassCount * t.rightClassCount)
    }
});
let $6d519e6f260f4e02$var$$ca2df1256966e313$var$KernTable = new (0, $00bf8c7e3dccf9c9$export$95a8b60f4da7dec8)('version', {
    0: {
        subVersion: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        length: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        format: (0, $2b9a2a5e7d043014$export$52e103c63c4e68cf),
        coverage: new (0, $701e08229fc30ff7$export$96b43b8a49f688ea)((0, $2b9a2a5e7d043014$export$52e103c63c4e68cf), [
            'horizontal',
            'minimum',
            'crossStream',
            'override' // If set to 1 the value in this table replaces the accumulated value
        ]),
        subtable: $6d519e6f260f4e02$var$$ca2df1256966e313$var$KernSubtable,
        padding: new (0, $f612a7b97d3685e8$export$da9b5fe187a9aa1)((0, $2b9a2a5e7d043014$export$52e103c63c4e68cf), (t)=>t.length - t._currentOffset)
    },
    1: {
        length: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
        coverage: new (0, $701e08229fc30ff7$export$96b43b8a49f688ea)((0, $2b9a2a5e7d043014$export$52e103c63c4e68cf), [
            null,
            null,
            null,
            null,
            null,
            'variation',
            'crossStream',
            'vertical' // Set if table has vertical kerning values
        ]),
        format: (0, $2b9a2a5e7d043014$export$52e103c63c4e68cf),
        tupleIndex: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        subtable: $6d519e6f260f4e02$var$$ca2df1256966e313$var$KernSubtable,
        padding: new (0, $f612a7b97d3685e8$export$da9b5fe187a9aa1)((0, $2b9a2a5e7d043014$export$52e103c63c4e68cf), (t)=>t.length - t._currentOffset)
    }
});
var $6d519e6f260f4e02$var$$ca2df1256966e313$export$2e2bcd8739ae039 = new (0, $00bf8c7e3dccf9c9$export$95a8b60f4da7dec8)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), {
    0: {
        nTables: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        tables: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$ca2df1256966e313$var$KernTable, 'nTables')
    },
    1: {
        reserved: new (0, $f612a7b97d3685e8$export$da9b5fe187a9aa1)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456)),
        nTables: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
        tables: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$ca2df1256966e313$var$KernTable, 'nTables')
    }
});
var // Records the ppem for each glyph at which the scaling becomes linear again,
// despite instructions effecting the advance width
$6d519e6f260f4e02$var$$7a9f92b0c46ebe33$export$2e2bcd8739ae039 = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    version: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    numGlyphs: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    yPels: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$52e103c63c4e68cf), 'numGlyphs')
});
var // NOTE: The PCLT table is strongly discouraged for OpenType fonts with TrueType outlines
$6d519e6f260f4e02$var$$2b2ccc419d152631$export$2e2bcd8739ae039 = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    version: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    fontNumber: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    pitch: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    xHeight: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    style: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    typeFamily: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    capHeight: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    symbolSet: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    typeface: new (0, $b2061d4384f873cb$export$89b8e0fa65f6a914)(16),
    characterComplement: new (0, $b2061d4384f873cb$export$89b8e0fa65f6a914)(8),
    fileName: new (0, $b2061d4384f873cb$export$89b8e0fa65f6a914)(6),
    strokeWeight: new (0, $b2061d4384f873cb$export$89b8e0fa65f6a914)(1),
    widthType: new (0, $b2061d4384f873cb$export$89b8e0fa65f6a914)(1),
    serifStyle: (0, $2b9a2a5e7d043014$export$52e103c63c4e68cf),
    reserved: new (0, $f612a7b97d3685e8$export$da9b5fe187a9aa1)((0, $2b9a2a5e7d043014$export$52e103c63c4e68cf))
});
// VDMX tables contain ascender/descender overrides for certain (usually small)
// sizes. This is needed in order to match font metrics on Windows.
let $6d519e6f260f4e02$var$$ca5b40b9bcda9c9b$var$Ratio = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    bCharSet: (0, $2b9a2a5e7d043014$export$52e103c63c4e68cf),
    xRatio: (0, $2b9a2a5e7d043014$export$52e103c63c4e68cf),
    yStartRatio: (0, $2b9a2a5e7d043014$export$52e103c63c4e68cf),
    yEndRatio: (0, $2b9a2a5e7d043014$export$52e103c63c4e68cf // Ending y-Ratio value
    )
});
let $6d519e6f260f4e02$var$$ca5b40b9bcda9c9b$var$vTable = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    yPelHeight: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    yMax: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    yMin: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6 // Minimum value (in pels) for this yPelHeight
    )
});
let $6d519e6f260f4e02$var$$ca5b40b9bcda9c9b$var$VdmxGroup = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    recs: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    startsz: (0, $2b9a2a5e7d043014$export$52e103c63c4e68cf),
    endsz: (0, $2b9a2a5e7d043014$export$52e103c63c4e68cf),
    entries: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$ca5b40b9bcda9c9b$var$vTable, 'recs') // The VDMX records
});
var $6d519e6f260f4e02$var$$ca5b40b9bcda9c9b$export$2e2bcd8739ae039 = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    version: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    numRecs: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    numRatios: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    ratioRanges: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$ca5b40b9bcda9c9b$var$Ratio, 'numRatios'),
    offsets: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), 'numRatios'),
    groups: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$ca5b40b9bcda9c9b$var$VdmxGroup, 'numRecs') // The actual VDMX groupings
});
var $6d519e6f260f4e02$var$$69530a3c40755af0$export$2e2bcd8739ae039 = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    version: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    ascent: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    descent: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    lineGap: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    advanceHeightMax: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    minTopSideBearing: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    minBottomSideBearing: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    yMaxExtent: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    caretSlopeRise: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    caretSlopeRun: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    caretOffset: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    reserved: new (0, $f612a7b97d3685e8$export$da9b5fe187a9aa1)((0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6), 4),
    metricDataFormat: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    numberOfMetrics: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456 // Number of advance heights in the Vertical Metrics table
    )
});
let $6d519e6f260f4e02$var$$344073dd270f0e62$var$VmtxEntry = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    advance: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    bearing: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6 // The top sidebearing of the glyph
    )
});
var $6d519e6f260f4e02$var$$344073dd270f0e62$export$2e2bcd8739ae039 = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    metrics: new (0, $ed4a2faff705c483$export$5576c026028d4983)($6d519e6f260f4e02$var$$344073dd270f0e62$var$VmtxEntry, (t)=>t.parent.vhea.numberOfMetrics),
    bearings: new (0, $ed4a2faff705c483$export$5576c026028d4983)((0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6), (t)=>t.parent.maxp.numGlyphs - t.parent.vhea.numberOfMetrics)
});
let $6d519e6f260f4e02$var$$3793b781918cfced$var$shortFrac = new (0, $2b9a2a5e7d043014$export$13475bbd2a37a9b4)(16, 'BE', 14);
let $6d519e6f260f4e02$var$$3793b781918cfced$var$Correspondence = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    fromCoord: $6d519e6f260f4e02$var$$3793b781918cfced$var$shortFrac,
    toCoord: $6d519e6f260f4e02$var$$3793b781918cfced$var$shortFrac
});
let $6d519e6f260f4e02$var$$3793b781918cfced$var$Segment = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    pairCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    correspondence: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$3793b781918cfced$var$Correspondence, 'pairCount')
});
var $6d519e6f260f4e02$var$$3793b781918cfced$export$2e2bcd8739ae039 = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    version: (0, $2b9a2a5e7d043014$export$e913265d48471f2d),
    axisCount: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    segment: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$3793b781918cfced$var$Segment, 'axisCount')
});
class $6d519e6f260f4e02$var$$6cb7dd5f47d82580$var$UnboundedArrayAccessor {
    getItem(index) {
        if (this._items[index] == null) {
            let pos = this.stream.pos;
            this.stream.pos = this.base + this.type.size(null, this.parent) * index;
            this._items[index] = this.type.decode(this.stream, this.parent);
            this.stream.pos = pos;
        }
        return this._items[index];
    }
    inspect() {
        return `[UnboundedArray ${this.type.constructor.name}]`;
    }
    constructor(type, stream, parent){
        this.type = type;
        this.stream = stream;
        this.parent = parent;
        this.base = this.stream.pos;
        this._items = [];
    }
}
class $6d519e6f260f4e02$var$$6cb7dd5f47d82580$export$c5af1eebc882e39a extends (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa) {
    decode(stream, parent) {
        return new $6d519e6f260f4e02$var$$6cb7dd5f47d82580$var$UnboundedArrayAccessor(this.type, stream, parent);
    }
    constructor(type){
        super(type, 0);
    }
}
let $6d519e6f260f4e02$var$$6cb7dd5f47d82580$export$8351f8c2ae2f103c = function(ValueType = (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456)) {
    // Helper class that makes internal structures invisible to pointers
    class Shadow {
        decode(stream, ctx) {
            ctx = ctx.parent.parent;
            return this.type.decode(stream, ctx);
        }
        size(val, ctx) {
            ctx = ctx.parent.parent;
            return this.type.size(val, ctx);
        }
        encode(stream, val, ctx) {
            ctx = ctx.parent.parent;
            return this.type.encode(stream, val, ctx);
        }
        constructor(type){
            this.type = type;
        }
    }
    ValueType = new Shadow(ValueType);
    let BinarySearchHeader = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
        unitSize: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        nUnits: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        searchRange: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        entrySelector: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        rangeShift: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456)
    });
    let LookupSegmentSingle = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
        lastGlyph: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        firstGlyph: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        value: ValueType
    });
    let LookupSegmentArray = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
        lastGlyph: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        firstGlyph: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        values: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)(ValueType, (t)=>t.lastGlyph - t.firstGlyph + 1), {
            type: 'parent'
        })
    });
    let LookupSingle = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
        glyph: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        value: ValueType
    });
    return new (0, $00bf8c7e3dccf9c9$export$95a8b60f4da7dec8)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), {
        0: {
            values: new $6d519e6f260f4e02$var$$6cb7dd5f47d82580$export$c5af1eebc882e39a(ValueType) // length == number of glyphs maybe?
        },
        2: {
            binarySearchHeader: BinarySearchHeader,
            segments: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)(LookupSegmentSingle, (t)=>t.binarySearchHeader.nUnits)
        },
        4: {
            binarySearchHeader: BinarySearchHeader,
            segments: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)(LookupSegmentArray, (t)=>t.binarySearchHeader.nUnits)
        },
        6: {
            binarySearchHeader: BinarySearchHeader,
            segments: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)(LookupSingle, (t)=>t.binarySearchHeader.nUnits)
        },
        8: {
            firstGlyph: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
            count: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
            values: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)(ValueType, 'count')
        }
    });
};
function $6d519e6f260f4e02$var$$6cb7dd5f47d82580$export$79f7d93d790934ba(entryData = {}, lookupType = (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456)) {
    let entry = Object.assign({
        newState: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        flags: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456)
    }, entryData);
    let Entry = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)(entry);
    let StateArray = new $6d519e6f260f4e02$var$$6cb7dd5f47d82580$export$c5af1eebc882e39a(new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), (t)=>t.nClasses));
    let StateHeader = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
        nClasses: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
        classTable: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), new $6d519e6f260f4e02$var$$6cb7dd5f47d82580$export$8351f8c2ae2f103c(lookupType)),
        stateArray: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), StateArray),
        entryTable: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), new $6d519e6f260f4e02$var$$6cb7dd5f47d82580$export$c5af1eebc882e39a(Entry))
    });
    return StateHeader;
}
function $6d519e6f260f4e02$var$$6cb7dd5f47d82580$export$105027425199cc51(entryData = {}, lookupType = (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456)) {
    let ClassLookupTable = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
        version () {
            return 8;
        },
        firstGlyph: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        values: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$52e103c63c4e68cf), (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456))
    });
    let entry = Object.assign({
        newStateOffset: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        // convert offset to stateArray index
        newState: (t)=>(t.newStateOffset - (t.parent.stateArray.base - t.parent._startOffset)) / t.parent.nClasses,
        flags: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456)
    }, entryData);
    let Entry = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)(entry);
    let StateArray = new $6d519e6f260f4e02$var$$6cb7dd5f47d82580$export$c5af1eebc882e39a(new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$52e103c63c4e68cf), (t)=>t.nClasses));
    let StateHeader1 = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
        nClasses: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        classTable: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), ClassLookupTable),
        stateArray: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), StateArray),
        entryTable: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), new $6d519e6f260f4e02$var$$6cb7dd5f47d82580$export$c5af1eebc882e39a(Entry))
    });
    return StateHeader1;
}
let $6d519e6f260f4e02$var$$6a3746e8c708f5a3$var$BslnSubtable = new (0, $00bf8c7e3dccf9c9$export$95a8b60f4da7dec8)('format', {
    0: {
        deltas: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6), 32)
    },
    1: {
        deltas: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6), 32),
        mappingData: new $6d519e6f260f4e02$var$$6cb7dd5f47d82580$export$8351f8c2ae2f103c((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456))
    },
    2: {
        standardGlyph: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        controlPoints: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), 32)
    },
    3: {
        standardGlyph: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        controlPoints: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), 32),
        mappingData: new $6d519e6f260f4e02$var$$6cb7dd5f47d82580$export$8351f8c2ae2f103c((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456))
    }
});
var $6d519e6f260f4e02$var$$6a3746e8c708f5a3$export$2e2bcd8739ae039 = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    version: (0, $2b9a2a5e7d043014$export$e913265d48471f2d),
    format: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    defaultBaseline: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    subtable: $6d519e6f260f4e02$var$$6a3746e8c708f5a3$var$BslnSubtable
});
let $6d519e6f260f4e02$var$$d0c76fac617b308a$var$Setting = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    setting: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    nameIndex: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    name: (t)=>t.parent.parent.parent.name.records.fontFeatures[t.nameIndex]
});
let $6d519e6f260f4e02$var$$d0c76fac617b308a$var$FeatureName = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    feature: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    nSettings: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    settingTable: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$d0c76fac617b308a$var$Setting, 'nSettings'), {
        type: 'parent'
    }),
    featureFlags: new (0, $701e08229fc30ff7$export$96b43b8a49f688ea)((0, $2b9a2a5e7d043014$export$52e103c63c4e68cf), [
        null,
        null,
        null,
        null,
        null,
        null,
        'hasDefault',
        'exclusive'
    ]),
    defaultSetting: (0, $2b9a2a5e7d043014$export$52e103c63c4e68cf),
    nameIndex: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    name: (t)=>t.parent.parent.name.records.fontFeatures[t.nameIndex]
});
var $6d519e6f260f4e02$var$$d0c76fac617b308a$export$2e2bcd8739ae039 = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    version: (0, $2b9a2a5e7d043014$export$e913265d48471f2d),
    featureNameCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    reserved1: new (0, $f612a7b97d3685e8$export$da9b5fe187a9aa1)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456)),
    reserved2: new (0, $f612a7b97d3685e8$export$da9b5fe187a9aa1)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d)),
    featureNames: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$d0c76fac617b308a$var$FeatureName, 'featureNameCount')
});
let $6d519e6f260f4e02$var$$e83fd065f00fcd01$var$Axis = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    axisTag: new (0, $b2061d4384f873cb$export$89b8e0fa65f6a914)(4),
    minValue: (0, $2b9a2a5e7d043014$export$e913265d48471f2d),
    defaultValue: (0, $2b9a2a5e7d043014$export$e913265d48471f2d),
    maxValue: (0, $2b9a2a5e7d043014$export$e913265d48471f2d),
    flags: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    nameID: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    name: (t)=>t.parent.parent.name.records.fontFeatures[t.nameID]
});
let $6d519e6f260f4e02$var$$e83fd065f00fcd01$var$Instance = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    nameID: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    name: (t)=>t.parent.parent.name.records.fontFeatures[t.nameID],
    flags: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    coord: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$e913265d48471f2d), (t)=>t.parent.axisCount),
    postscriptNameID: new (0, $72804d503192edec$export$7acb7b24c478f9c6)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), (t)=>t.parent.instanceSize - t._currentOffset > 0)
});
var $6d519e6f260f4e02$var$$e83fd065f00fcd01$export$2e2bcd8739ae039 = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    version: (0, $2b9a2a5e7d043014$export$e913265d48471f2d),
    offsetToData: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    countSizePairs: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    axisCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    axisSize: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    instanceCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    instanceSize: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    axis: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$e83fd065f00fcd01$var$Axis, 'axisCount'),
    instance: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$e83fd065f00fcd01$var$Instance, 'instanceCount')
});
let $6d519e6f260f4e02$var$$dbe33c8d3a7f131c$var$shortFrac = new (0, $2b9a2a5e7d043014$export$13475bbd2a37a9b4)(16, 'BE', 14);
class $6d519e6f260f4e02$var$$dbe33c8d3a7f131c$var$Offset {
    static decode(stream, parent) {
        // In short format, offsets are multiplied by 2.
        // This doesn't seem to be documented by Apple, but it
        // is implemented this way in Freetype.
        return parent.flags ? stream.readUInt32BE() : stream.readUInt16BE() * 2;
    }
}
let $6d519e6f260f4e02$var$$dbe33c8d3a7f131c$var$gvar = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    version: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    reserved: new (0, $f612a7b97d3685e8$export$da9b5fe187a9aa1)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456)),
    axisCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    globalCoordCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    globalCoords: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)(new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$dbe33c8d3a7f131c$var$shortFrac, 'axisCount'), 'globalCoordCount')),
    glyphCount: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    flags: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    offsetToData: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    offsets: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)(new (0, $19bca402104b2cc3$export$b56007f12edf0c17)($6d519e6f260f4e02$var$$dbe33c8d3a7f131c$var$Offset, 'void', {
        relativeTo: (ctx)=>ctx.offsetToData,
        allowNull: false
    }), (t)=>t.glyphCount + 1)
});
var $6d519e6f260f4e02$var$$dbe33c8d3a7f131c$export$2e2bcd8739ae039 = $6d519e6f260f4e02$var$$dbe33c8d3a7f131c$var$gvar;
let $6d519e6f260f4e02$var$$05b01887df96c4ee$var$ClassTable = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    length: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    coverage: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    subFeatureFlags: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    stateTable: new $6d519e6f260f4e02$var$$6cb7dd5f47d82580$export$105027425199cc51
});
let $6d519e6f260f4e02$var$$05b01887df96c4ee$var$WidthDeltaRecord = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    justClass: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    beforeGrowLimit: (0, $2b9a2a5e7d043014$export$e913265d48471f2d),
    beforeShrinkLimit: (0, $2b9a2a5e7d043014$export$e913265d48471f2d),
    afterGrowLimit: (0, $2b9a2a5e7d043014$export$e913265d48471f2d),
    afterShrinkLimit: (0, $2b9a2a5e7d043014$export$e913265d48471f2d),
    growFlags: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    shrinkFlags: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456)
});
let $6d519e6f260f4e02$var$$05b01887df96c4ee$var$WidthDeltaCluster = new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$05b01887df96c4ee$var$WidthDeltaRecord, (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d));
let $6d519e6f260f4e02$var$$05b01887df96c4ee$var$ActionData = new (0, $00bf8c7e3dccf9c9$export$95a8b60f4da7dec8)('actionType', {
    0: {
        lowerLimit: (0, $2b9a2a5e7d043014$export$e913265d48471f2d),
        upperLimit: (0, $2b9a2a5e7d043014$export$e913265d48471f2d),
        order: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        glyphs: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456))
    },
    1: {
        addGlyph: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456)
    },
    2: {
        substThreshold: (0, $2b9a2a5e7d043014$export$e913265d48471f2d),
        addGlyph: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        substGlyph: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456)
    },
    3: {},
    4: {
        variationAxis: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
        minimumLimit: (0, $2b9a2a5e7d043014$export$e913265d48471f2d),
        noStretchValue: (0, $2b9a2a5e7d043014$export$e913265d48471f2d),
        maximumLimit: (0, $2b9a2a5e7d043014$export$e913265d48471f2d)
    },
    5: {
        flags: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
        glyph: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456)
    }
});
let $6d519e6f260f4e02$var$$05b01887df96c4ee$var$Action = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    actionClass: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    actionType: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    actionLength: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    actionData: $6d519e6f260f4e02$var$$05b01887df96c4ee$var$ActionData,
    padding: new (0, $f612a7b97d3685e8$export$da9b5fe187a9aa1)((0, $2b9a2a5e7d043014$export$52e103c63c4e68cf), (t)=>t.actionLength - t._currentOffset)
});
let $6d519e6f260f4e02$var$$05b01887df96c4ee$var$PostcompensationAction = new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$05b01887df96c4ee$var$Action, (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d));
let $6d519e6f260f4e02$var$$05b01887df96c4ee$var$PostCompensationTable = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    lookupTable: new $6d519e6f260f4e02$var$$6cb7dd5f47d82580$export$8351f8c2ae2f103c(new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$05b01887df96c4ee$var$PostcompensationAction))
});
let $6d519e6f260f4e02$var$$05b01887df96c4ee$var$JustificationTable = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    classTable: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$05b01887df96c4ee$var$ClassTable, {
        type: 'parent'
    }),
    wdcOffset: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    postCompensationTable: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$05b01887df96c4ee$var$PostCompensationTable, {
        type: 'parent'
    }),
    widthDeltaClusters: new $6d519e6f260f4e02$var$$6cb7dd5f47d82580$export$8351f8c2ae2f103c(new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$05b01887df96c4ee$var$WidthDeltaCluster, {
        type: 'parent',
        relativeTo: (ctx)=>ctx.wdcOffset
    }))
});
var $6d519e6f260f4e02$var$$05b01887df96c4ee$export$2e2bcd8739ae039 = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    version: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    format: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    horizontal: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$05b01887df96c4ee$var$JustificationTable),
    vertical: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$05b01887df96c4ee$var$JustificationTable)
});
let $6d519e6f260f4e02$var$$03ee6ebd54db1053$var$LigatureData = {
    action: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456)
};
let $6d519e6f260f4e02$var$$03ee6ebd54db1053$var$ContextualData = {
    markIndex: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    currentIndex: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456)
};
let $6d519e6f260f4e02$var$$03ee6ebd54db1053$var$InsertionData = {
    currentInsertIndex: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    markedInsertIndex: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456)
};
let $6d519e6f260f4e02$var$$03ee6ebd54db1053$var$SubstitutionTable = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    items: new $6d519e6f260f4e02$var$$6cb7dd5f47d82580$export$c5af1eebc882e39a(new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), new $6d519e6f260f4e02$var$$6cb7dd5f47d82580$export$8351f8c2ae2f103c))
});
let $6d519e6f260f4e02$var$$03ee6ebd54db1053$var$SubtableData = new (0, $00bf8c7e3dccf9c9$export$95a8b60f4da7dec8)('type', {
    0: {
        stateTable: new $6d519e6f260f4e02$var$$6cb7dd5f47d82580$export$79f7d93d790934ba
    },
    1: {
        stateTable: new $6d519e6f260f4e02$var$$6cb7dd5f47d82580$export$79f7d93d790934ba($6d519e6f260f4e02$var$$03ee6ebd54db1053$var$ContextualData),
        substitutionTable: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), $6d519e6f260f4e02$var$$03ee6ebd54db1053$var$SubstitutionTable)
    },
    2: {
        stateTable: new $6d519e6f260f4e02$var$$6cb7dd5f47d82580$export$79f7d93d790934ba($6d519e6f260f4e02$var$$03ee6ebd54db1053$var$LigatureData),
        ligatureActions: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), new $6d519e6f260f4e02$var$$6cb7dd5f47d82580$export$c5af1eebc882e39a((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d))),
        components: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), new $6d519e6f260f4e02$var$$6cb7dd5f47d82580$export$c5af1eebc882e39a((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456))),
        ligatureList: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), new $6d519e6f260f4e02$var$$6cb7dd5f47d82580$export$c5af1eebc882e39a((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456)))
    },
    4: {
        lookupTable: new $6d519e6f260f4e02$var$$6cb7dd5f47d82580$export$8351f8c2ae2f103c
    },
    5: {
        stateTable: new $6d519e6f260f4e02$var$$6cb7dd5f47d82580$export$79f7d93d790934ba($6d519e6f260f4e02$var$$03ee6ebd54db1053$var$InsertionData),
        insertionActions: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), new $6d519e6f260f4e02$var$$6cb7dd5f47d82580$export$c5af1eebc882e39a((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456)))
    }
});
let $6d519e6f260f4e02$var$$03ee6ebd54db1053$var$Subtable = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    length: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    coverage: (0, $2b9a2a5e7d043014$export$1925298fbd719b21),
    type: (0, $2b9a2a5e7d043014$export$52e103c63c4e68cf),
    subFeatureFlags: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    table: $6d519e6f260f4e02$var$$03ee6ebd54db1053$var$SubtableData,
    padding: new (0, $f612a7b97d3685e8$export$da9b5fe187a9aa1)((0, $2b9a2a5e7d043014$export$52e103c63c4e68cf), (t)=>t.length - t._currentOffset)
});
let $6d519e6f260f4e02$var$$03ee6ebd54db1053$var$FeatureEntry = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    featureType: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    featureSetting: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    enableFlags: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    disableFlags: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d)
});
let $6d519e6f260f4e02$var$$03ee6ebd54db1053$var$MorxChain = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    defaultFlags: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    chainLength: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    nFeatureEntries: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    nSubtables: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    features: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$03ee6ebd54db1053$var$FeatureEntry, 'nFeatureEntries'),
    subtables: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$03ee6ebd54db1053$var$Subtable, 'nSubtables')
});
var $6d519e6f260f4e02$var$$03ee6ebd54db1053$export$2e2bcd8739ae039 = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    version: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    unused: new (0, $f612a7b97d3685e8$export$da9b5fe187a9aa1)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456)),
    nChains: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    chains: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$03ee6ebd54db1053$var$MorxChain, 'nChains')
});
let $6d519e6f260f4e02$var$$b7492a80b0d1a056$var$OpticalBounds = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    left: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    top: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    right: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    bottom: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6)
});
var $6d519e6f260f4e02$var$$b7492a80b0d1a056$export$2e2bcd8739ae039 = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    version: (0, $2b9a2a5e7d043014$export$e913265d48471f2d),
    format: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    lookupTable: new $6d519e6f260f4e02$var$$6cb7dd5f47d82580$export$8351f8c2ae2f103c($6d519e6f260f4e02$var$$b7492a80b0d1a056$var$OpticalBounds)
});
let $6d519e6f260f4e02$var$$c3395722bea751e2$var$tables = {};
var $6d519e6f260f4e02$var$$c3395722bea751e2$export$2e2bcd8739ae039 = $6d519e6f260f4e02$var$$c3395722bea751e2$var$tables;
$6d519e6f260f4e02$var$$c3395722bea751e2$var$tables.cmap = $6d519e6f260f4e02$var$$26a62205ad06574e$export$2e2bcd8739ae039;
$6d519e6f260f4e02$var$$c3395722bea751e2$var$tables.head = $6d519e6f260f4e02$var$$f2612a29f92ac062$export$2e2bcd8739ae039;
$6d519e6f260f4e02$var$$c3395722bea751e2$var$tables.hhea = $6d519e6f260f4e02$var$$2c179dd593583073$export$2e2bcd8739ae039;
$6d519e6f260f4e02$var$$c3395722bea751e2$var$tables.hmtx = $6d519e6f260f4e02$var$$bdc9060542264b85$export$2e2bcd8739ae039;
$6d519e6f260f4e02$var$$c3395722bea751e2$var$tables.maxp = $6d519e6f260f4e02$var$$dbf51cb3d3fe409d$export$2e2bcd8739ae039;
$6d519e6f260f4e02$var$$c3395722bea751e2$var$tables.name = $6d519e6f260f4e02$var$$2bcf221753ec8e32$export$2e2bcd8739ae039;
$6d519e6f260f4e02$var$$c3395722bea751e2$var$tables['OS/2'] = $6d519e6f260f4e02$var$$84b272aa31b70606$export$2e2bcd8739ae039;
$6d519e6f260f4e02$var$$c3395722bea751e2$var$tables.post = $6d519e6f260f4e02$var$$32d9e2eb9565d93c$export$2e2bcd8739ae039;
$6d519e6f260f4e02$var$$c3395722bea751e2$var$tables.fpgm = $6d519e6f260f4e02$var$$5c0f37ca5ffb1850$export$2e2bcd8739ae039;
$6d519e6f260f4e02$var$$c3395722bea751e2$var$tables.loca = $6d519e6f260f4e02$var$$2b2b260902b1c57e$export$2e2bcd8739ae039;
$6d519e6f260f4e02$var$$c3395722bea751e2$var$tables.prep = $6d519e6f260f4e02$var$$7afb878c7bea4f66$export$2e2bcd8739ae039;
$6d519e6f260f4e02$var$$c3395722bea751e2$var$tables['cvt '] = $6d519e6f260f4e02$var$$5202bd9d9ad8eaac$export$2e2bcd8739ae039;
$6d519e6f260f4e02$var$$c3395722bea751e2$var$tables.glyf = $6d519e6f260f4e02$var$$6c92b6371bce8bd9$export$2e2bcd8739ae039;
$6d519e6f260f4e02$var$$c3395722bea751e2$var$tables['CFF '] = $6d519e6f260f4e02$var$$822ac0d589e4e237$export$2e2bcd8739ae039;
$6d519e6f260f4e02$var$$c3395722bea751e2$var$tables['CFF2'] = $6d519e6f260f4e02$var$$822ac0d589e4e237$export$2e2bcd8739ae039;
$6d519e6f260f4e02$var$$c3395722bea751e2$var$tables.VORG = $6d519e6f260f4e02$var$$2bbf2bc1ce37cd8f$export$2e2bcd8739ae039;
$6d519e6f260f4e02$var$$c3395722bea751e2$var$tables.EBLC = $6d519e6f260f4e02$var$$9911c4c7201c13de$export$2e2bcd8739ae039;
$6d519e6f260f4e02$var$$c3395722bea751e2$var$tables.CBLC = $6d519e6f260f4e02$var$$c3395722bea751e2$var$tables.EBLC;
$6d519e6f260f4e02$var$$c3395722bea751e2$var$tables.sbix = $6d519e6f260f4e02$var$$abb847051efd51b1$export$2e2bcd8739ae039;
$6d519e6f260f4e02$var$$c3395722bea751e2$var$tables.COLR = $6d519e6f260f4e02$var$$eb629188f3dfefdd$export$2e2bcd8739ae039;
$6d519e6f260f4e02$var$$c3395722bea751e2$var$tables.CPAL = $6d519e6f260f4e02$var$$08734b8e7dc64587$export$2e2bcd8739ae039;
$6d519e6f260f4e02$var$$c3395722bea751e2$var$tables.BASE = $6d519e6f260f4e02$var$$497cef411d884e34$export$2e2bcd8739ae039;
$6d519e6f260f4e02$var$$c3395722bea751e2$var$tables.GDEF = $6d519e6f260f4e02$var$$cf5f33c63ef209e6$export$2e2bcd8739ae039;
$6d519e6f260f4e02$var$$c3395722bea751e2$var$tables.GPOS = $6d519e6f260f4e02$var$$47e0e8ef515d9903$export$2e2bcd8739ae039;
$6d519e6f260f4e02$var$$c3395722bea751e2$var$tables.GSUB = $6d519e6f260f4e02$var$$d3f442064af66e06$export$2e2bcd8739ae039;
$6d519e6f260f4e02$var$$c3395722bea751e2$var$tables.JSTF = $6d519e6f260f4e02$var$$71cfb3c4767fbd0c$export$2e2bcd8739ae039;
$6d519e6f260f4e02$var$$c3395722bea751e2$var$tables.HVAR = $6d519e6f260f4e02$var$$d059a6bd2d3b5b63$export$2e2bcd8739ae039;
$6d519e6f260f4e02$var$$c3395722bea751e2$var$tables.DSIG = $6d519e6f260f4e02$var$$dceeca3e1977ce30$export$2e2bcd8739ae039;
$6d519e6f260f4e02$var$$c3395722bea751e2$var$tables.gasp = $6d519e6f260f4e02$var$$8acd740a9435aad0$export$2e2bcd8739ae039;
$6d519e6f260f4e02$var$$c3395722bea751e2$var$tables.hdmx = $6d519e6f260f4e02$var$$b5f380243c34d6a0$export$2e2bcd8739ae039;
$6d519e6f260f4e02$var$$c3395722bea751e2$var$tables.kern = $6d519e6f260f4e02$var$$ca2df1256966e313$export$2e2bcd8739ae039;
$6d519e6f260f4e02$var$$c3395722bea751e2$var$tables.LTSH = $6d519e6f260f4e02$var$$7a9f92b0c46ebe33$export$2e2bcd8739ae039;
$6d519e6f260f4e02$var$$c3395722bea751e2$var$tables.PCLT = $6d519e6f260f4e02$var$$2b2ccc419d152631$export$2e2bcd8739ae039;
$6d519e6f260f4e02$var$$c3395722bea751e2$var$tables.VDMX = $6d519e6f260f4e02$var$$ca5b40b9bcda9c9b$export$2e2bcd8739ae039;
$6d519e6f260f4e02$var$$c3395722bea751e2$var$tables.vhea = $6d519e6f260f4e02$var$$69530a3c40755af0$export$2e2bcd8739ae039;
$6d519e6f260f4e02$var$$c3395722bea751e2$var$tables.vmtx = $6d519e6f260f4e02$var$$344073dd270f0e62$export$2e2bcd8739ae039;
$6d519e6f260f4e02$var$$c3395722bea751e2$var$tables.avar = $6d519e6f260f4e02$var$$3793b781918cfced$export$2e2bcd8739ae039;
$6d519e6f260f4e02$var$$c3395722bea751e2$var$tables.bsln = $6d519e6f260f4e02$var$$6a3746e8c708f5a3$export$2e2bcd8739ae039;
$6d519e6f260f4e02$var$$c3395722bea751e2$var$tables.feat = $6d519e6f260f4e02$var$$d0c76fac617b308a$export$2e2bcd8739ae039;
$6d519e6f260f4e02$var$$c3395722bea751e2$var$tables.fvar = $6d519e6f260f4e02$var$$e83fd065f00fcd01$export$2e2bcd8739ae039;
$6d519e6f260f4e02$var$$c3395722bea751e2$var$tables.gvar = $6d519e6f260f4e02$var$$dbe33c8d3a7f131c$export$2e2bcd8739ae039;
$6d519e6f260f4e02$var$$c3395722bea751e2$var$tables.just = $6d519e6f260f4e02$var$$05b01887df96c4ee$export$2e2bcd8739ae039;
$6d519e6f260f4e02$var$$c3395722bea751e2$var$tables.morx = $6d519e6f260f4e02$var$$03ee6ebd54db1053$export$2e2bcd8739ae039;
$6d519e6f260f4e02$var$$c3395722bea751e2$var$tables.opbd = $6d519e6f260f4e02$var$$b7492a80b0d1a056$export$2e2bcd8739ae039;
let $6d519e6f260f4e02$var$$816c07a04b6dba87$var$TableEntry = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    tag: new (0, $b2061d4384f873cb$export$89b8e0fa65f6a914)(4),
    checkSum: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    offset: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), 'void', {
        type: 'global'
    }),
    length: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d)
});
let $6d519e6f260f4e02$var$$816c07a04b6dba87$var$Directory = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    tag: new (0, $b2061d4384f873cb$export$89b8e0fa65f6a914)(4),
    numTables: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    searchRange: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    entrySelector: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    rangeShift: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    tables: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$816c07a04b6dba87$var$TableEntry, 'numTables')
});
$6d519e6f260f4e02$var$$816c07a04b6dba87$var$Directory.process = function() {
    let tables = {};
    for (let table of this.tables)tables[table.tag] = table;
    this.tables = tables;
};
$6d519e6f260f4e02$var$$816c07a04b6dba87$var$Directory.preEncode = function() {
    if (!Array.isArray(this.tables)) {
        let tables = [];
        for(let tag in this.tables){
            let table = this.tables[tag];
            if (table) tables.push({
                tag: tag,
                checkSum: 0,
                offset: new (0, $19bca402104b2cc3$export$df5cb1f3d04f5a0f)($6d519e6f260f4e02$var$$c3395722bea751e2$export$2e2bcd8739ae039[tag], table),
                length: $6d519e6f260f4e02$var$$c3395722bea751e2$export$2e2bcd8739ae039[tag].size(table)
            });
        }
        this.tables = tables;
    }
    this.tag = 'true';
    this.numTables = this.tables.length;
    let maxExponentFor2 = Math.floor(Math.log(this.numTables) / Math.LN2);
    let maxPowerOf2 = Math.pow(2, maxExponentFor2);
    this.searchRange = maxPowerOf2 * 16;
    this.entrySelector = Math.log(maxPowerOf2) / Math.LN2;
    this.rangeShift = this.numTables * 16 - this.searchRange;
};
var $6d519e6f260f4e02$var$$816c07a04b6dba87$export$2e2bcd8739ae039 = $6d519e6f260f4e02$var$$816c07a04b6dba87$var$Directory;
function $6d519e6f260f4e02$var$$12727730ddfc8bfe$export$2e0ae67339d5f1ac(arr, cmp) {
    let min = 0;
    let max = arr.length - 1;
    while(min <= max){
        let mid = min + max >> 1;
        let res = cmp(arr[mid]);
        if (res < 0) max = mid - 1;
        else if (res > 0) min = mid + 1;
        else return mid;
    }
    return -1;
}
function $6d519e6f260f4e02$var$$12727730ddfc8bfe$export$d02631cccf789723(index, end) {
    let range = [];
    while(index < end)range.push(index++);
    return range;
}
const $6d519e6f260f4e02$var$$12727730ddfc8bfe$export$3d28c1996ced1f14 = new TextDecoder('ascii');
// Based on https://github.com/niklasvh/base64-arraybuffer. MIT license.
const $6d519e6f260f4e02$var$$12727730ddfc8bfe$var$CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
const $6d519e6f260f4e02$var$$12727730ddfc8bfe$var$LOOKUP = new Uint8Array(256);
for(let i = 0; i < $6d519e6f260f4e02$var$$12727730ddfc8bfe$var$CHARS.length; i++)$6d519e6f260f4e02$var$$12727730ddfc8bfe$var$LOOKUP[$6d519e6f260f4e02$var$$12727730ddfc8bfe$var$CHARS.charCodeAt(i)] = i;
function $6d519e6f260f4e02$var$$12727730ddfc8bfe$export$94fdf11bafc8de6b(base64) {
    let bufferLength = base64.length * 0.75;
    if (base64[base64.length - 1] === '=') {
        bufferLength--;
        if (base64[base64.length - 2] === '=') bufferLength--;
    }
    let bytes = new Uint8Array(bufferLength);
    let p = 0;
    for(let i = 0, len = base64.length; i < len; i += 4){
        let encoded1 = $6d519e6f260f4e02$var$$12727730ddfc8bfe$var$LOOKUP[base64.charCodeAt(i)];
        let encoded2 = $6d519e6f260f4e02$var$$12727730ddfc8bfe$var$LOOKUP[base64.charCodeAt(i + 1)];
        let encoded3 = $6d519e6f260f4e02$var$$12727730ddfc8bfe$var$LOOKUP[base64.charCodeAt(i + 2)];
        let encoded4 = $6d519e6f260f4e02$var$$12727730ddfc8bfe$var$LOOKUP[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return bytes;
}
class $6d519e6f260f4e02$var$$f08dd41ef10b694c$export$2e2bcd8739ae039 {
    findSubtable(cmapTable, pairs) {
        for (let [platformID, encodingID] of pairs)for (let cmap of cmapTable.tables){
            if (cmap.platformID === platformID && cmap.encodingID === encodingID) return cmap.table;
        }
        return null;
    }
    lookup(codepoint, variationSelector) {
        // If there is no Unicode cmap in this font, we need to re-encode
        // the codepoint in the encoding that the cmap supports.
        if (this.encoding) codepoint = this.encoding.get(codepoint) || codepoint;
        else if (variationSelector) {
            let gid = this.getVariationSelector(codepoint, variationSelector);
            if (gid) return gid;
        }
        let cmap = this.cmap;
        switch(cmap.version){
            case 0:
                return cmap.codeMap.get(codepoint) || 0;
            case 4:
                {
                    let min = 0;
                    let max = cmap.segCount - 1;
                    while(min <= max){
                        let mid = min + max >> 1;
                        if (codepoint < cmap.startCode.get(mid)) max = mid - 1;
                        else if (codepoint > cmap.endCode.get(mid)) min = mid + 1;
                        else {
                            let rangeOffset = cmap.idRangeOffset.get(mid);
                            let gid;
                            if (rangeOffset === 0) gid = codepoint + cmap.idDelta.get(mid);
                            else {
                                let index = rangeOffset / 2 + (codepoint - cmap.startCode.get(mid)) - (cmap.segCount - mid);
                                gid = cmap.glyphIndexArray.get(index) || 0;
                                if (gid !== 0) gid += cmap.idDelta.get(mid);
                            }
                            return gid & 0xffff;
                        }
                    }
                    return 0;
                }
            case 8:
                throw new Error('TODO: cmap format 8');
            case 6:
            case 10:
                return cmap.glyphIndices.get(codepoint - cmap.firstCode) || 0;
            case 12:
            case 13:
                {
                    let min = 0;
                    let max = cmap.nGroups - 1;
                    while(min <= max){
                        let mid = min + max >> 1;
                        let group = cmap.groups.get(mid);
                        if (codepoint < group.startCharCode) max = mid - 1;
                        else if (codepoint > group.endCharCode) min = mid + 1;
                        else {
                            if (cmap.version === 12) return group.glyphID + (codepoint - group.startCharCode);
                            else return group.glyphID;
                        }
                    }
                    return 0;
                }
            case 14:
                throw new Error('TODO: cmap format 14');
            default:
                throw new Error(`Unknown cmap format ${cmap.version}`);
        }
    }
    getVariationSelector(codepoint, variationSelector) {
        if (!this.uvs) return 0;
        let selectors = this.uvs.varSelectors.toArray();
        let i = $6d519e6f260f4e02$var$$12727730ddfc8bfe$export$2e0ae67339d5f1ac(selectors, (x)=>variationSelector - x.varSelector);
        let sel = selectors[i];
        if (i !== -1 && sel.defaultUVS) i = $6d519e6f260f4e02$var$$12727730ddfc8bfe$export$2e0ae67339d5f1ac(sel.defaultUVS, (x)=>codepoint < x.startUnicodeValue ? -1 : codepoint > x.startUnicodeValue + x.additionalCount ? 1 : 0);
        if (i !== -1 && sel.nonDefaultUVS) {
            i = $6d519e6f260f4e02$var$$12727730ddfc8bfe$export$2e0ae67339d5f1ac(sel.nonDefaultUVS, (x)=>codepoint - x.unicodeValue);
            if (i !== -1) return sel.nonDefaultUVS[i].glyphID;
        }
        return 0;
    }
    getCharacterSet() {
        let cmap = this.cmap;
        switch(cmap.version){
            case 0:
                return $6d519e6f260f4e02$var$$12727730ddfc8bfe$export$d02631cccf789723(0, cmap.codeMap.length);
            case 4:
                {
                    let res = [];
                    let endCodes = cmap.endCode.toArray();
                    for(let i = 0; i < endCodes.length; i++){
                        let tail = endCodes[i] + 1;
                        let start = cmap.startCode.get(i);
                        res.push(...$6d519e6f260f4e02$var$$12727730ddfc8bfe$export$d02631cccf789723(start, tail));
                    }
                    return res;
                }
            case 8:
                throw new Error('TODO: cmap format 8');
            case 6:
            case 10:
                return $6d519e6f260f4e02$var$$12727730ddfc8bfe$export$d02631cccf789723(cmap.firstCode, cmap.firstCode + cmap.glyphIndices.length);
            case 12:
            case 13:
                {
                    let res = [];
                    for (let group of cmap.groups.toArray())res.push(...$6d519e6f260f4e02$var$$12727730ddfc8bfe$export$d02631cccf789723(group.startCharCode, group.endCharCode + 1));
                    return res;
                }
            case 14:
                throw new Error('TODO: cmap format 14');
            default:
                throw new Error(`Unknown cmap format ${cmap.version}`);
        }
    }
    codePointsForGlyph(gid) {
        let cmap = this.cmap;
        switch(cmap.version){
            case 0:
                {
                    let res = [];
                    for(let i = 0; i < 256; i++)if (cmap.codeMap.get(i) === gid) res.push(i);
                    return res;
                }
            case 4:
                {
                    let res = [];
                    for(let i = 0; i < cmap.segCount; i++){
                        let end = cmap.endCode.get(i);
                        let start = cmap.startCode.get(i);
                        let rangeOffset = cmap.idRangeOffset.get(i);
                        let delta = cmap.idDelta.get(i);
                        for(var c = start; c <= end; c++){
                            let g = 0;
                            if (rangeOffset === 0) g = c + delta;
                            else {
                                let index = rangeOffset / 2 + (c - start) - (cmap.segCount - i);
                                g = cmap.glyphIndexArray.get(index) || 0;
                                if (g !== 0) g += delta;
                            }
                            if (g === gid) res.push(c);
                        }
                    }
                    return res;
                }
            case 12:
                {
                    let res = [];
                    for (let group of cmap.groups.toArray())if (gid >= group.glyphID && gid <= group.glyphID + (group.endCharCode - group.startCharCode)) res.push(group.startCharCode + (gid - group.glyphID));
                    return res;
                }
            case 13:
                {
                    let res = [];
                    for (let group of cmap.groups.toArray())if (gid === group.glyphID) res.push(...$6d519e6f260f4e02$var$$12727730ddfc8bfe$export$d02631cccf789723(group.startCharCode, group.endCharCode + 1));
                    return res;
                }
            default:
                throw new Error(`Unknown cmap format ${cmap.version}`);
        }
    }
    constructor(cmapTable){
        // Attempt to find a Unicode cmap first
        this.encoding = null;
        this.cmap = this.findSubtable(cmapTable, [
            // 32-bit subtables
            [
                3,
                10
            ],
            [
                0,
                6
            ],
            [
                0,
                4
            ],
            // 16-bit subtables
            [
                3,
                1
            ],
            [
                0,
                3
            ],
            [
                0,
                2
            ],
            [
                0,
                1
            ],
            [
                0,
                0
            ]
        ]);
        // If not unicode cmap was found, take the first table with a supported encoding.
        if (!this.cmap) for (let cmap of cmapTable.tables){
            let encoding = $6d519e6f260f4e02$var$$e449ad78d50845fe$export$badc544e0651b6b1(cmap.platformID, cmap.encodingID, cmap.table.language - 1);
            let mapping = $6d519e6f260f4e02$var$$e449ad78d50845fe$export$1dceb3c14ed68bee(encoding);
            if (mapping) {
                this.cmap = cmap.table;
                this.encoding = mapping;
            }
        }
        if (!this.cmap) throw new Error("Could not find a supported cmap table");
        this.uvs = this.findSubtable(cmapTable, [
            [
                0,
                5
            ]
        ]);
        if (this.uvs && this.uvs.version !== 14) this.uvs = null;
    }
}
(0, $04dbd055bc5edd2b$export$29e00dfd3077644b)([
    $6d519e6f260f4e02$var$$e71565f2ce09cb6b$export$69a3209f1a06c04d
], $6d519e6f260f4e02$var$$f08dd41ef10b694c$export$2e2bcd8739ae039.prototype, "getCharacterSet", null);
(0, $04dbd055bc5edd2b$export$29e00dfd3077644b)([
    $6d519e6f260f4e02$var$$e71565f2ce09cb6b$export$69a3209f1a06c04d
], $6d519e6f260f4e02$var$$f08dd41ef10b694c$export$2e2bcd8739ae039.prototype, "codePointsForGlyph", null);
class $6d519e6f260f4e02$var$$0bba3a9db57637f3$export$2e2bcd8739ae039 {
    process(glyphs, positions) {
        for(let glyphIndex = 0; glyphIndex < glyphs.length - 1; glyphIndex++){
            let left = glyphs[glyphIndex].id;
            let right = glyphs[glyphIndex + 1].id;
            positions[glyphIndex].xAdvance += this.getKerning(left, right);
        }
    }
    getKerning(left, right) {
        let res = 0;
        for (let table of this.kern.tables){
            if (table.coverage.crossStream) continue;
            switch(table.version){
                case 0:
                    if (!table.coverage.horizontal) continue;
                    break;
                case 1:
                    if (table.coverage.vertical || table.coverage.variation) continue;
                    break;
                default:
                    throw new Error(`Unsupported kerning table version ${table.version}`);
            }
            let val = 0;
            let s = table.subtable;
            switch(table.format){
                case 0:
                    let pairIdx = $6d519e6f260f4e02$var$$12727730ddfc8bfe$export$2e0ae67339d5f1ac(s.pairs, function(pair) {
                        return left - pair.left || right - pair.right;
                    });
                    if (pairIdx >= 0) val = s.pairs[pairIdx].value;
                    break;
                case 2:
                    let leftOffset = 0, rightOffset = 0;
                    if (left >= s.leftTable.firstGlyph && left < s.leftTable.firstGlyph + s.leftTable.nGlyphs) leftOffset = s.leftTable.offsets[left - s.leftTable.firstGlyph];
                    else leftOffset = s.array.off;
                    if (right >= s.rightTable.firstGlyph && right < s.rightTable.firstGlyph + s.rightTable.nGlyphs) rightOffset = s.rightTable.offsets[right - s.rightTable.firstGlyph];
                    let index = (leftOffset + rightOffset - s.array.off) / 2;
                    val = s.array.values.get(index);
                    break;
                case 3:
                    if (left >= s.glyphCount || right >= s.glyphCount) return 0;
                    val = s.kernValue[s.kernIndex[s.leftClass[left] * s.rightClassCount + s.rightClass[right]]];
                    break;
                default:
                    throw new Error(`Unsupported kerning sub-table format ${table.format}`);
            }
            // Microsoft supports the override flag, which resets the result
            // Otherwise, the sum of the results from all subtables is returned
            if (table.coverage.override) res = val;
            else res += val;
        }
        return res;
    }
    constructor(font){
        this.kern = font.kern;
    }
}
class $6d519e6f260f4e02$var$$0a4bdfeb6dfd6f5e$export$2e2bcd8739ae039 {
    positionGlyphs(glyphs, positions) {
        // find each base + mark cluster, and position the marks relative to the base
        let clusterStart = 0;
        let clusterEnd = 0;
        for(let index = 0; index < glyphs.length; index++){
            let glyph = glyphs[index];
            if (glyph.isMark) clusterEnd = index;
            else {
                if (clusterStart !== clusterEnd) this.positionCluster(glyphs, positions, clusterStart, clusterEnd);
                clusterStart = clusterEnd = index;
            }
        }
        if (clusterStart !== clusterEnd) this.positionCluster(glyphs, positions, clusterStart, clusterEnd);
        return positions;
    }
    positionCluster(glyphs, positions, clusterStart, clusterEnd) {
        let base = glyphs[clusterStart];
        let baseBox = base.cbox.copy();
        // adjust bounding box for ligature glyphs
        if (base.codePoints.length > 1) baseBox.minX += (base.codePoints.length - 1) * baseBox.width / base.codePoints.length;
        let xOffset = -positions[clusterStart].xAdvance;
        let yOffset = 0;
        let yGap = this.font.unitsPerEm / 16;
        // position each of the mark glyphs relative to the base glyph
        for(let index = clusterStart + 1; index <= clusterEnd; index++){
            let mark = glyphs[index];
            let markBox = mark.cbox;
            let position = positions[index];
            let combiningClass = this.getCombiningClass(mark.codePoints[0]);
            if (combiningClass !== 'Not_Reordered') {
                position.xOffset = position.yOffset = 0;
                // x positioning
                switch(combiningClass){
                    case 'Double_Above':
                    case 'Double_Below':
                        // LTR. TODO: RTL support.
                        position.xOffset += baseBox.minX - markBox.width / 2 - markBox.minX;
                        break;
                    case 'Attached_Below_Left':
                    case 'Below_Left':
                    case 'Above_Left':
                        // left align
                        position.xOffset += baseBox.minX - markBox.minX;
                        break;
                    case 'Attached_Above_Right':
                    case 'Below_Right':
                    case 'Above_Right':
                        // right align
                        position.xOffset += baseBox.maxX - markBox.width - markBox.minX;
                        break;
                    default:
                        // center align
                        position.xOffset += baseBox.minX + (baseBox.width - markBox.width) / 2 - markBox.minX;
                }
                // y positioning
                switch(combiningClass){
                    case 'Double_Below':
                    case 'Below_Left':
                    case 'Below':
                    case 'Below_Right':
                    case 'Attached_Below_Left':
                    case 'Attached_Below':
                        // add a small gap between the glyphs if they are not attached
                        if (combiningClass === 'Attached_Below_Left' || combiningClass === 'Attached_Below') baseBox.minY += yGap;
                        position.yOffset = -baseBox.minY - markBox.maxY;
                        baseBox.minY += markBox.height;
                        break;
                    case 'Double_Above':
                    case 'Above_Left':
                    case 'Above':
                    case 'Above_Right':
                    case 'Attached_Above':
                    case 'Attached_Above_Right':
                        // add a small gap between the glyphs if they are not attached
                        if (combiningClass === 'Attached_Above' || combiningClass === 'Attached_Above_Right') baseBox.maxY += yGap;
                        position.yOffset = baseBox.maxY - markBox.minY;
                        baseBox.maxY += markBox.height;
                        break;
                }
                position.xAdvance = position.yAdvance = 0;
                position.xOffset += xOffset;
                position.yOffset += yOffset;
            } else {
                xOffset -= position.xAdvance;
                yOffset -= position.yAdvance;
            }
        }
        return;
    }
    getCombiningClass(codePoint) {
        let combiningClass = (0, $d6a5237190dccd49$export$c03b919c6651ed55)(codePoint);
        // Thai / Lao need some per-character work
        if ((codePoint & -256) === 0x0e00) {
            if (combiningClass === 'Not_Reordered') switch(codePoint){
                case 0x0e31:
                case 0x0e34:
                case 0x0e35:
                case 0x0e36:
                case 0x0e37:
                case 0x0e47:
                case 0x0e4c:
                case 0x0e3d:
                case 0x0e4e:
                    return 'Above_Right';
                case 0x0eb1:
                case 0x0eb4:
                case 0x0eb5:
                case 0x0eb6:
                case 0x0eb7:
                case 0x0ebb:
                case 0x0ecc:
                case 0x0ecd:
                    return 'Above';
                case 0x0ebc:
                    return 'Below';
            }
            else if (codePoint === 0x0e3a) return 'Below_Right';
        }
        switch(combiningClass){
            // Hebrew
            case 'CCC10':
            case 'CCC11':
            case 'CCC12':
            case 'CCC13':
            case 'CCC14':
            case 'CCC15':
            case 'CCC16':
            case 'CCC17':
            case 'CCC18':
            case 'CCC20':
            case 'CCC22':
                return 'Below';
            case 'CCC23':
                return 'Attached_Above';
            case 'CCC24':
                return 'Above_Right';
            case 'CCC25':
            case 'CCC19':
                return 'Above_Left';
            case 'CCC26':
                return 'Above';
            case 'CCC21':
                break;
            // Arabic and Syriac
            case 'CCC27':
            case 'CCC28':
            case 'CCC30':
            case 'CCC31':
            case 'CCC33':
            case 'CCC34':
            case 'CCC35':
            case 'CCC36':
                return 'Above';
            case 'CCC29':
            case 'CCC32':
                return 'Below';
            // Thai
            case 'CCC103':
                return 'Below_Right';
            case 'CCC107':
                return 'Above_Right';
            // Lao
            case 'CCC118':
                return 'Below';
            case 'CCC122':
                return 'Above';
            // Tibetan
            case 'CCC129':
            case 'CCC132':
                return 'Below';
            case 'CCC130':
                return 'Above';
        }
        return combiningClass;
    }
    constructor(font){
        this.font = font;
    }
}
/**
 * Represents a glyph bounding box
 */ class $6d519e6f260f4e02$var$$f34600ab9d7f70d8$export$2e2bcd8739ae039 {
    /**
   * The width of the bounding box
   * @type {number}
   */ get width() {
        return this.maxX - this.minX;
    }
    /**
   * The height of the bounding box
   * @type {number}
   */ get height() {
        return this.maxY - this.minY;
    }
    addPoint(x, y) {
        if (Math.abs(x) !== Infinity) {
            if (x < this.minX) this.minX = x;
            if (x > this.maxX) this.maxX = x;
        }
        if (Math.abs(y) !== Infinity) {
            if (y < this.minY) this.minY = y;
            if (y > this.maxY) this.maxY = y;
        }
    }
    copy() {
        return new $6d519e6f260f4e02$var$$f34600ab9d7f70d8$export$2e2bcd8739ae039(this.minX, this.minY, this.maxX, this.maxY);
    }
    constructor(minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity){
        /**
     * The minimum X position in the bounding box
     * @type {number}
     */ this.minX = minX;
        /**
     * The minimum Y position in the bounding box
     * @type {number}
     */ this.minY = minY;
        /**
     * The maxmimum X position in the bounding box
     * @type {number}
     */ this.maxX = maxX;
        /**
     * The maxmimum Y position in the bounding box
     * @type {number}
     */ this.maxY = maxY;
    }
}
// This maps the Unicode Script property to an OpenType script tag
// Data from http://www.microsoft.com/typography/otspec/scripttags.htm
// and http://www.unicode.org/Public/UNIDATA/PropertyValueAliases.txt.
const $6d519e6f260f4e02$var$$130d1a642ebcd2b7$var$UNICODE_SCRIPTS = {
    Caucasian_Albanian: 'aghb',
    Arabic: 'arab',
    Imperial_Aramaic: 'armi',
    Armenian: 'armn',
    Avestan: 'avst',
    Balinese: 'bali',
    Bamum: 'bamu',
    Bassa_Vah: 'bass',
    Batak: 'batk',
    Bengali: [
        'bng2',
        'beng'
    ],
    Bopomofo: 'bopo',
    Brahmi: 'brah',
    Braille: 'brai',
    Buginese: 'bugi',
    Buhid: 'buhd',
    Chakma: 'cakm',
    Canadian_Aboriginal: 'cans',
    Carian: 'cari',
    Cham: 'cham',
    Cherokee: 'cher',
    Coptic: 'copt',
    Cypriot: 'cprt',
    Cyrillic: 'cyrl',
    Devanagari: [
        'dev2',
        'deva'
    ],
    Deseret: 'dsrt',
    Duployan: 'dupl',
    Egyptian_Hieroglyphs: 'egyp',
    Elbasan: 'elba',
    Ethiopic: 'ethi',
    Georgian: 'geor',
    Glagolitic: 'glag',
    Gothic: 'goth',
    Grantha: 'gran',
    Greek: 'grek',
    Gujarati: [
        'gjr2',
        'gujr'
    ],
    Gurmukhi: [
        'gur2',
        'guru'
    ],
    Hangul: 'hang',
    Han: 'hani',
    Hanunoo: 'hano',
    Hebrew: 'hebr',
    Hiragana: 'hira',
    Pahawh_Hmong: 'hmng',
    Katakana_Or_Hiragana: 'hrkt',
    Old_Italic: 'ital',
    Javanese: 'java',
    Kayah_Li: 'kali',
    Katakana: 'kana',
    Kharoshthi: 'khar',
    Khmer: 'khmr',
    Khojki: 'khoj',
    Kannada: [
        'knd2',
        'knda'
    ],
    Kaithi: 'kthi',
    Tai_Tham: 'lana',
    Lao: 'lao ',
    Latin: 'latn',
    Lepcha: 'lepc',
    Limbu: 'limb',
    Linear_A: 'lina',
    Linear_B: 'linb',
    Lisu: 'lisu',
    Lycian: 'lyci',
    Lydian: 'lydi',
    Mahajani: 'mahj',
    Mandaic: 'mand',
    Manichaean: 'mani',
    Mende_Kikakui: 'mend',
    Meroitic_Cursive: 'merc',
    Meroitic_Hieroglyphs: 'mero',
    Malayalam: [
        'mlm2',
        'mlym'
    ],
    Modi: 'modi',
    Mongolian: 'mong',
    Mro: 'mroo',
    Meetei_Mayek: 'mtei',
    Myanmar: [
        'mym2',
        'mymr'
    ],
    Old_North_Arabian: 'narb',
    Nabataean: 'nbat',
    Nko: 'nko ',
    Ogham: 'ogam',
    Ol_Chiki: 'olck',
    Old_Turkic: 'orkh',
    Oriya: [
        'ory2',
        'orya'
    ],
    Osmanya: 'osma',
    Palmyrene: 'palm',
    Pau_Cin_Hau: 'pauc',
    Old_Permic: 'perm',
    Phags_Pa: 'phag',
    Inscriptional_Pahlavi: 'phli',
    Psalter_Pahlavi: 'phlp',
    Phoenician: 'phnx',
    Miao: 'plrd',
    Inscriptional_Parthian: 'prti',
    Rejang: 'rjng',
    Runic: 'runr',
    Samaritan: 'samr',
    Old_South_Arabian: 'sarb',
    Saurashtra: 'saur',
    Shavian: 'shaw',
    Sharada: 'shrd',
    Siddham: 'sidd',
    Khudawadi: 'sind',
    Sinhala: 'sinh',
    Sora_Sompeng: 'sora',
    Sundanese: 'sund',
    Syloti_Nagri: 'sylo',
    Syriac: 'syrc',
    Tagbanwa: 'tagb',
    Takri: 'takr',
    Tai_Le: 'tale',
    New_Tai_Lue: 'talu',
    Tamil: [
        'tml2',
        'taml'
    ],
    Tai_Viet: 'tavt',
    Telugu: [
        'tel2',
        'telu'
    ],
    Tifinagh: 'tfng',
    Tagalog: 'tglg',
    Thaana: 'thaa',
    Thai: 'thai',
    Tibetan: 'tibt',
    Tirhuta: 'tirh',
    Ugaritic: 'ugar',
    Vai: 'vai ',
    Warang_Citi: 'wara',
    Old_Persian: 'xpeo',
    Cuneiform: 'xsux',
    Yi: 'yi  ',
    Inherited: 'zinh',
    Common: 'zyyy',
    Unknown: 'zzzz'
};
const $6d519e6f260f4e02$var$$130d1a642ebcd2b7$var$OPENTYPE_SCRIPTS = {};
for(let script in $6d519e6f260f4e02$var$$130d1a642ebcd2b7$var$UNICODE_SCRIPTS){
    let tag = $6d519e6f260f4e02$var$$130d1a642ebcd2b7$var$UNICODE_SCRIPTS[script];
    if (Array.isArray(tag)) for (let t of tag)$6d519e6f260f4e02$var$$130d1a642ebcd2b7$var$OPENTYPE_SCRIPTS[t] = script;
    else $6d519e6f260f4e02$var$$130d1a642ebcd2b7$var$OPENTYPE_SCRIPTS[tag] = script;
}
function $6d519e6f260f4e02$var$$130d1a642ebcd2b7$export$b32f0b5f69d65e51(script) {
    return $6d519e6f260f4e02$var$$130d1a642ebcd2b7$var$UNICODE_SCRIPTS[script];
}
function $6d519e6f260f4e02$var$$130d1a642ebcd2b7$export$ce50e82f12a827a4(tag) {
    return $6d519e6f260f4e02$var$$130d1a642ebcd2b7$var$OPENTYPE_SCRIPTS[tag];
}
function $6d519e6f260f4e02$var$$130d1a642ebcd2b7$export$e5cb25e204fb8450(string) {
    let len = string.length;
    let idx = 0;
    while(idx < len){
        let code = string.charCodeAt(idx++);
        // Check if this is a high surrogate
        if (0xd800 <= code && code <= 0xdbff && idx < len) {
            let next = string.charCodeAt(idx);
            // Check if this is a low surrogate
            if (0xdc00 <= next && next <= 0xdfff) {
                idx++;
                code = ((code & 0x3FF) << 10) + (next & 0x3FF) + 0x10000;
            }
        }
        let script = (0, $d6a5237190dccd49$export$941569448d136665)(code);
        if (script !== 'Common' && script !== 'Inherited' && script !== 'Unknown') return $6d519e6f260f4e02$var$$130d1a642ebcd2b7$var$UNICODE_SCRIPTS[script];
    }
    return $6d519e6f260f4e02$var$$130d1a642ebcd2b7$var$UNICODE_SCRIPTS.Unknown;
}
function $6d519e6f260f4e02$var$$130d1a642ebcd2b7$export$16fab0757cfc223d(codePoints) {
    for(let i = 0; i < codePoints.length; i++){
        let codePoint = codePoints[i];
        let script = (0, $d6a5237190dccd49$export$941569448d136665)(codePoint);
        if (script !== 'Common' && script !== 'Inherited' && script !== 'Unknown') return $6d519e6f260f4e02$var$$130d1a642ebcd2b7$var$UNICODE_SCRIPTS[script];
    }
    return $6d519e6f260f4e02$var$$130d1a642ebcd2b7$var$UNICODE_SCRIPTS.Unknown;
}
// The scripts in this map are written from right to left
const $6d519e6f260f4e02$var$$130d1a642ebcd2b7$var$RTL = {
    arab: true,
    hebr: true,
    syrc: true,
    thaa: true,
    cprt: true,
    khar: true,
    phnx: true,
    'nko ': true,
    lydi: true,
    avst: true,
    armi: true,
    phli: true,
    prti: true,
    sarb: true,
    orkh: true,
    samr: true,
    mand: true,
    merc: true,
    mero: true,
    // Unicode 7.0 (not listed on http://www.microsoft.com/typography/otspec/scripttags.htm)
    mani: true,
    mend: true,
    nbat: true,
    narb: true,
    palm: true,
    phlp: true // Psalter Pahlavi
};
function $6d519e6f260f4e02$var$$130d1a642ebcd2b7$export$9fddb9d0dd7d8a54(script) {
    if ($6d519e6f260f4e02$var$$130d1a642ebcd2b7$var$RTL[script]) return 'rtl';
    return 'ltr';
}
class $6d519e6f260f4e02$var$$be07b3e97a42687a$export$2e2bcd8739ae039 {
    /**
   * The total advance width of the run.
   * @type {number}
   */ get advanceWidth() {
        let width = 0;
        for (let position of this.positions)width += position.xAdvance;
        return width;
    }
    /**
  * The total advance height of the run.
  * @type {number}
  */ get advanceHeight() {
        let height = 0;
        for (let position of this.positions)height += position.yAdvance;
        return height;
    }
    /**
  * The bounding box containing all glyphs in the run.
  * @type {BBox}
  */ get bbox() {
        let bbox = new $6d519e6f260f4e02$var$$f34600ab9d7f70d8$export$2e2bcd8739ae039;
        let x = 0;
        let y = 0;
        for(let index = 0; index < this.glyphs.length; index++){
            let glyph = this.glyphs[index];
            let p = this.positions[index];
            let b = glyph.bbox;
            bbox.addPoint(b.minX + x + p.xOffset, b.minY + y + p.yOffset);
            bbox.addPoint(b.maxX + x + p.xOffset, b.maxY + y + p.yOffset);
            x += p.xAdvance;
            y += p.yAdvance;
        }
        return bbox;
    }
    constructor(glyphs, features, script, language, direction){
        /**
     * An array of Glyph objects in the run
     * @type {Glyph[]}
     */ this.glyphs = glyphs;
        /**
     * An array of GlyphPosition objects for each glyph in the run
     * @type {GlyphPosition[]}
     */ this.positions = null;
        /**
     * The script that was requested for shaping. This was either passed in or detected automatically.
     * @type {string}
     */ this.script = script;
        /**
     * The language requested for shaping, as passed in. If `null`, the default language for the
     * script was used.
     * @type {string}
     */ this.language = language || null;
        /**
     * The direction requested for shaping, as passed in (either ltr or rtl).
     * If `null`, the default direction of the script is used.
     * @type {string}
     */ this.direction = direction || $6d519e6f260f4e02$var$$130d1a642ebcd2b7$export$9fddb9d0dd7d8a54(script);
        /**
     * The features requested during shaping. This is a combination of user
     * specified features and features chosen by the shaper.
     * @type {object}
     */ this.features = {};
        // Convert features to an object
        if (Array.isArray(features)) for (let tag of features)this.features[tag] = true;
        else if (typeof features === 'object') this.features = features;
    }
}
/**
 * Represents positioning information for a glyph in a GlyphRun.
 */ class $6d519e6f260f4e02$var$$1ac75d9a55b67f01$export$2e2bcd8739ae039 {
    constructor(xAdvance = 0, yAdvance = 0, xOffset = 0, yOffset = 0){
        /**
     * The amount to move the virtual pen in the X direction after rendering this glyph.
     * @type {number}
     */ this.xAdvance = xAdvance;
        /**
     * The amount to move the virtual pen in the Y direction after rendering this glyph.
     * @type {number}
     */ this.yAdvance = yAdvance;
        /**
     * The offset from the pen position in the X direction at which to render this glyph.
     * @type {number}
     */ this.xOffset = xOffset;
        /**
     * The offset from the pen position in the Y direction at which to render this glyph.
     * @type {number}
     */ this.yOffset = yOffset;
    }
}
// see https://developer.apple.com/fonts/TrueType-Reference-Manual/RM09/AppendixF.html
// and /System/Library/Frameworks/CoreText.framework/Versions/A/Headers/SFNTLayoutTypes.h on a Mac
const $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$features = {
    allTypographicFeatures: {
        code: 0,
        exclusive: false,
        allTypeFeatures: 0
    },
    ligatures: {
        code: 1,
        exclusive: false,
        requiredLigatures: 0,
        commonLigatures: 2,
        rareLigatures: 4,
        // logos: 6
        rebusPictures: 8,
        diphthongLigatures: 10,
        squaredLigatures: 12,
        abbrevSquaredLigatures: 14,
        symbolLigatures: 16,
        contextualLigatures: 18,
        historicalLigatures: 20
    },
    cursiveConnection: {
        code: 2,
        exclusive: true,
        unconnected: 0,
        partiallyConnected: 1,
        cursive: 2
    },
    letterCase: {
        code: 3,
        exclusive: true
    },
    // upperAndLowerCase: 0          # deprecated
    // allCaps: 1                    # deprecated
    // allLowerCase: 2               # deprecated
    // smallCaps: 3                  # deprecated
    // initialCaps: 4                # deprecated
    // initialCapsAndSmallCaps: 5    # deprecated
    verticalSubstitution: {
        code: 4,
        exclusive: false,
        substituteVerticalForms: 0
    },
    linguisticRearrangement: {
        code: 5,
        exclusive: false,
        linguisticRearrangement: 0
    },
    numberSpacing: {
        code: 6,
        exclusive: true,
        monospacedNumbers: 0,
        proportionalNumbers: 1,
        thirdWidthNumbers: 2,
        quarterWidthNumbers: 3
    },
    smartSwash: {
        code: 8,
        exclusive: false,
        wordInitialSwashes: 0,
        wordFinalSwashes: 2,
        // lineInitialSwashes: 4
        // lineFinalSwashes: 6
        nonFinalSwashes: 8
    },
    diacritics: {
        code: 9,
        exclusive: true,
        showDiacritics: 0,
        hideDiacritics: 1,
        decomposeDiacritics: 2
    },
    verticalPosition: {
        code: 10,
        exclusive: true,
        normalPosition: 0,
        superiors: 1,
        inferiors: 2,
        ordinals: 3,
        scientificInferiors: 4
    },
    fractions: {
        code: 11,
        exclusive: true,
        noFractions: 0,
        verticalFractions: 1,
        diagonalFractions: 2
    },
    overlappingCharacters: {
        code: 13,
        exclusive: false,
        preventOverlap: 0
    },
    typographicExtras: {
        code: 14,
        exclusive: false,
        // hyphensToEmDash: 0
        // hyphenToEnDash: 2
        slashedZero: 4
    },
    // formInterrobang: 6
    // smartQuotes: 8
    // periodsToEllipsis: 10
    mathematicalExtras: {
        code: 15,
        exclusive: false,
        // hyphenToMinus: 0
        // asteristoMultiply: 2
        // slashToDivide: 4
        // inequalityLigatures: 6
        // exponents: 8
        mathematicalGreek: 10
    },
    ornamentSets: {
        code: 16,
        exclusive: true,
        noOrnaments: 0,
        dingbats: 1,
        piCharacters: 2,
        fleurons: 3,
        decorativeBorders: 4,
        internationalSymbols: 5,
        mathSymbols: 6
    },
    characterAlternatives: {
        code: 17,
        exclusive: true,
        noAlternates: 0
    },
    // user defined options
    designComplexity: {
        code: 18,
        exclusive: true,
        designLevel1: 0,
        designLevel2: 1,
        designLevel3: 2,
        designLevel4: 3,
        designLevel5: 4
    },
    styleOptions: {
        code: 19,
        exclusive: true,
        noStyleOptions: 0,
        displayText: 1,
        engravedText: 2,
        illuminatedCaps: 3,
        titlingCaps: 4,
        tallCaps: 5
    },
    characterShape: {
        code: 20,
        exclusive: true,
        traditionalCharacters: 0,
        simplifiedCharacters: 1,
        JIS1978Characters: 2,
        JIS1983Characters: 3,
        JIS1990Characters: 4,
        traditionalAltOne: 5,
        traditionalAltTwo: 6,
        traditionalAltThree: 7,
        traditionalAltFour: 8,
        traditionalAltFive: 9,
        expertCharacters: 10,
        JIS2004Characters: 11,
        hojoCharacters: 12,
        NLCCharacters: 13,
        traditionalNamesCharacters: 14
    },
    numberCase: {
        code: 21,
        exclusive: true,
        lowerCaseNumbers: 0,
        upperCaseNumbers: 1
    },
    textSpacing: {
        code: 22,
        exclusive: true,
        proportionalText: 0,
        monospacedText: 1,
        halfWidthText: 2,
        thirdWidthText: 3,
        quarterWidthText: 4,
        altProportionalText: 5,
        altHalfWidthText: 6
    },
    transliteration: {
        code: 23,
        exclusive: true,
        noTransliteration: 0
    },
    // hanjaToHangul: 1
    // hiraganaToKatakana: 2
    // katakanaToHiragana: 3
    // kanaToRomanization: 4
    // romanizationToHiragana: 5
    // romanizationToKatakana: 6
    // hanjaToHangulAltOne: 7
    // hanjaToHangulAltTwo: 8
    // hanjaToHangulAltThree: 9
    annotation: {
        code: 24,
        exclusive: true,
        noAnnotation: 0,
        boxAnnotation: 1,
        roundedBoxAnnotation: 2,
        circleAnnotation: 3,
        invertedCircleAnnotation: 4,
        parenthesisAnnotation: 5,
        periodAnnotation: 6,
        romanNumeralAnnotation: 7,
        diamondAnnotation: 8,
        invertedBoxAnnotation: 9,
        invertedRoundedBoxAnnotation: 10
    },
    kanaSpacing: {
        code: 25,
        exclusive: true,
        fullWidthKana: 0,
        proportionalKana: 1
    },
    ideographicSpacing: {
        code: 26,
        exclusive: true,
        fullWidthIdeographs: 0,
        proportionalIdeographs: 1,
        halfWidthIdeographs: 2
    },
    unicodeDecomposition: {
        code: 27,
        exclusive: false,
        canonicalComposition: 0,
        compatibilityComposition: 2,
        transcodingComposition: 4
    },
    rubyKana: {
        code: 28,
        exclusive: false,
        // noRubyKana: 0     # deprecated - use rubyKanaOff instead
        // rubyKana: 1     # deprecated - use rubyKanaOn instead
        rubyKana: 2
    },
    CJKSymbolAlternatives: {
        code: 29,
        exclusive: true,
        noCJKSymbolAlternatives: 0,
        CJKSymbolAltOne: 1,
        CJKSymbolAltTwo: 2,
        CJKSymbolAltThree: 3,
        CJKSymbolAltFour: 4,
        CJKSymbolAltFive: 5
    },
    ideographicAlternatives: {
        code: 30,
        exclusive: true,
        noIdeographicAlternatives: 0,
        ideographicAltOne: 1,
        ideographicAltTwo: 2,
        ideographicAltThree: 3,
        ideographicAltFour: 4,
        ideographicAltFive: 5
    },
    CJKVerticalRomanPlacement: {
        code: 31,
        exclusive: true,
        CJKVerticalRomanCentered: 0,
        CJKVerticalRomanHBaseline: 1
    },
    italicCJKRoman: {
        code: 32,
        exclusive: false,
        // noCJKItalicRoman: 0     # deprecated - use CJKItalicRomanOff instead
        // CJKItalicRoman: 1     # deprecated - use CJKItalicRomanOn instead
        CJKItalicRoman: 2
    },
    caseSensitiveLayout: {
        code: 33,
        exclusive: false,
        caseSensitiveLayout: 0,
        caseSensitiveSpacing: 2
    },
    alternateKana: {
        code: 34,
        exclusive: false,
        alternateHorizKana: 0,
        alternateVertKana: 2
    },
    stylisticAlternatives: {
        code: 35,
        exclusive: false,
        noStylisticAlternates: 0,
        stylisticAltOne: 2,
        stylisticAltTwo: 4,
        stylisticAltThree: 6,
        stylisticAltFour: 8,
        stylisticAltFive: 10,
        stylisticAltSix: 12,
        stylisticAltSeven: 14,
        stylisticAltEight: 16,
        stylisticAltNine: 18,
        stylisticAltTen: 20,
        stylisticAltEleven: 22,
        stylisticAltTwelve: 24,
        stylisticAltThirteen: 26,
        stylisticAltFourteen: 28,
        stylisticAltFifteen: 30,
        stylisticAltSixteen: 32,
        stylisticAltSeventeen: 34,
        stylisticAltEighteen: 36,
        stylisticAltNineteen: 38,
        stylisticAltTwenty: 40
    },
    contextualAlternates: {
        code: 36,
        exclusive: false,
        contextualAlternates: 0,
        swashAlternates: 2,
        contextualSwashAlternates: 4
    },
    lowerCase: {
        code: 37,
        exclusive: true,
        defaultLowerCase: 0,
        lowerCaseSmallCaps: 1,
        lowerCasePetiteCaps: 2
    },
    upperCase: {
        code: 38,
        exclusive: true,
        defaultUpperCase: 0,
        upperCaseSmallCaps: 1,
        upperCasePetiteCaps: 2
    },
    languageTag: {
        code: 39,
        exclusive: true
    },
    CJKRomanSpacing: {
        code: 103,
        exclusive: true,
        halfWidthCJKRoman: 0,
        proportionalCJKRoman: 1,
        defaultCJKRoman: 2,
        fullWidthCJKRoman: 3
    }
};
const $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature = (name, selector)=>[
        $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$features[name].code,
        $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$features[name][selector]
    ];
const $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$OTMapping = {
    rlig: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('ligatures', 'requiredLigatures'),
    clig: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('ligatures', 'contextualLigatures'),
    dlig: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('ligatures', 'rareLigatures'),
    hlig: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('ligatures', 'historicalLigatures'),
    liga: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('ligatures', 'commonLigatures'),
    hist: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('ligatures', 'historicalLigatures'),
    smcp: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('lowerCase', 'lowerCaseSmallCaps'),
    pcap: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('lowerCase', 'lowerCasePetiteCaps'),
    frac: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('fractions', 'diagonalFractions'),
    dnom: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('fractions', 'diagonalFractions'),
    numr: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('fractions', 'diagonalFractions'),
    afrc: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('fractions', 'verticalFractions'),
    // aalt
    // abvf, abvm, abvs, akhn, blwf, blwm, blws, cfar, cjct, cpsp, falt, isol, jalt, ljmo, mset?
    // ltra, ltrm, nukt, pref, pres, pstf, psts, rand, rkrf, rphf, rtla, rtlm, size, tjmo, tnum?
    // unic, vatu, vhal, vjmo, vpal, vrt2
    // dist -> trak table?
    // kern, vkrn -> kern table
    // lfbd + opbd + rtbd -> opbd table?
    // mark, mkmk -> acnt table?
    // locl -> languageTag + ltag table
    case: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('caseSensitiveLayout', 'caseSensitiveLayout'),
    ccmp: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('unicodeDecomposition', 'canonicalComposition'),
    cpct: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('CJKVerticalRomanPlacement', 'CJKVerticalRomanCentered'),
    valt: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('CJKVerticalRomanPlacement', 'CJKVerticalRomanCentered'),
    swsh: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('contextualAlternates', 'swashAlternates'),
    cswh: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('contextualAlternates', 'contextualSwashAlternates'),
    curs: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('cursiveConnection', 'cursive'),
    c2pc: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('upperCase', 'upperCasePetiteCaps'),
    c2sc: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('upperCase', 'upperCaseSmallCaps'),
    init: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('smartSwash', 'wordInitialSwashes'),
    fin2: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('smartSwash', 'wordFinalSwashes'),
    medi: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('smartSwash', 'nonFinalSwashes'),
    med2: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('smartSwash', 'nonFinalSwashes'),
    fin3: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('smartSwash', 'wordFinalSwashes'),
    fina: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('smartSwash', 'wordFinalSwashes'),
    pkna: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('kanaSpacing', 'proportionalKana'),
    half: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('textSpacing', 'halfWidthText'),
    halt: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('textSpacing', 'altHalfWidthText'),
    hkna: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('alternateKana', 'alternateHorizKana'),
    vkna: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('alternateKana', 'alternateVertKana'),
    // hngl: feature 'transliteration', 'hanjaToHangulSelector' # deprecated
    ital: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('italicCJKRoman', 'CJKItalicRoman'),
    lnum: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('numberCase', 'upperCaseNumbers'),
    onum: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('numberCase', 'lowerCaseNumbers'),
    mgrk: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('mathematicalExtras', 'mathematicalGreek'),
    // nalt: not enough info. what type of annotation?
    // ornm: ditto, which ornament style?
    calt: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('contextualAlternates', 'contextualAlternates'),
    vrt2: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('verticalSubstitution', 'substituteVerticalForms'),
    vert: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('verticalSubstitution', 'substituteVerticalForms'),
    tnum: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('numberSpacing', 'monospacedNumbers'),
    pnum: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('numberSpacing', 'proportionalNumbers'),
    sups: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('verticalPosition', 'superiors'),
    subs: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('verticalPosition', 'inferiors'),
    ordn: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('verticalPosition', 'ordinals'),
    pwid: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('textSpacing', 'proportionalText'),
    hwid: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('textSpacing', 'halfWidthText'),
    qwid: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('textSpacing', 'quarterWidthText'),
    twid: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('textSpacing', 'thirdWidthText'),
    fwid: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('textSpacing', 'proportionalText'),
    palt: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('textSpacing', 'altProportionalText'),
    trad: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('characterShape', 'traditionalCharacters'),
    smpl: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('characterShape', 'simplifiedCharacters'),
    jp78: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('characterShape', 'JIS1978Characters'),
    jp83: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('characterShape', 'JIS1983Characters'),
    jp90: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('characterShape', 'JIS1990Characters'),
    jp04: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('characterShape', 'JIS2004Characters'),
    expt: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('characterShape', 'expertCharacters'),
    hojo: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('characterShape', 'hojoCharacters'),
    nlck: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('characterShape', 'NLCCharacters'),
    tnam: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('characterShape', 'traditionalNamesCharacters'),
    ruby: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('rubyKana', 'rubyKana'),
    titl: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('styleOptions', 'titlingCaps'),
    zero: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('typographicExtras', 'slashedZero'),
    ss01: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('stylisticAlternatives', 'stylisticAltOne'),
    ss02: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('stylisticAlternatives', 'stylisticAltTwo'),
    ss03: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('stylisticAlternatives', 'stylisticAltThree'),
    ss04: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('stylisticAlternatives', 'stylisticAltFour'),
    ss05: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('stylisticAlternatives', 'stylisticAltFive'),
    ss06: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('stylisticAlternatives', 'stylisticAltSix'),
    ss07: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('stylisticAlternatives', 'stylisticAltSeven'),
    ss08: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('stylisticAlternatives', 'stylisticAltEight'),
    ss09: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('stylisticAlternatives', 'stylisticAltNine'),
    ss10: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('stylisticAlternatives', 'stylisticAltTen'),
    ss11: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('stylisticAlternatives', 'stylisticAltEleven'),
    ss12: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('stylisticAlternatives', 'stylisticAltTwelve'),
    ss13: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('stylisticAlternatives', 'stylisticAltThirteen'),
    ss14: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('stylisticAlternatives', 'stylisticAltFourteen'),
    ss15: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('stylisticAlternatives', 'stylisticAltFifteen'),
    ss16: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('stylisticAlternatives', 'stylisticAltSixteen'),
    ss17: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('stylisticAlternatives', 'stylisticAltSeventeen'),
    ss18: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('stylisticAlternatives', 'stylisticAltEighteen'),
    ss19: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('stylisticAlternatives', 'stylisticAltNineteen'),
    ss20: $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$feature('stylisticAlternatives', 'stylisticAltTwenty')
};
// salt: feature 'stylisticAlternatives', 'stylisticAltOne' # hmm, which one to choose
// Add cv01-cv99 features
for(let i = 1; i <= 99; i++)$6d519e6f260f4e02$var$$3b6302b64eccc32c$var$OTMapping[`cv${`00${i}`.slice(-2)}`] = [
    $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$features.characterAlternatives.code,
    i
];
// create inverse mapping
let $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$AATMapping = {};
for(let ot in $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$OTMapping){
    let aat = $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$OTMapping[ot];
    if ($6d519e6f260f4e02$var$$3b6302b64eccc32c$var$AATMapping[aat[0]] == null) $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$AATMapping[aat[0]] = {};
    $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$AATMapping[aat[0]][aat[1]] = ot;
}
function $6d519e6f260f4e02$var$$3b6302b64eccc32c$export$b813f7d2a1677c16(features) {
    let res = {};
    for(let k in features){
        let r;
        if (r = $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$OTMapping[k]) {
            if (res[r[0]] == null) res[r[0]] = {};
            res[r[0]][r[1]] = features[k];
        }
    }
    return res;
}
// Maps strings in a [featureType, featureSetting]
// to their equivalent number codes
function $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$mapFeatureStrings(f) {
    let [type, setting] = f;
    if (isNaN(type)) var typeCode = $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$features[type] && $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$features[type].code;
    else var typeCode = type;
    if (isNaN(setting)) var settingCode = $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$features[type] && $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$features[type][setting];
    else var settingCode = setting;
    return [
        typeCode,
        settingCode
    ];
}
function $6d519e6f260f4e02$var$$3b6302b64eccc32c$export$bd6df347a4f391c4(features) {
    let res = {};
    if (Array.isArray(features)) for(let k = 0; k < features.length; k++){
        let r;
        let f = $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$mapFeatureStrings(features[k]);
        if (r = $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$AATMapping[f[0]] && $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$AATMapping[f[0]][f[1]]) res[r] = true;
    }
    else if (typeof features === 'object') for(let type in features){
        let feature = features[type];
        for(let setting in feature){
            let r;
            let f = $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$mapFeatureStrings([
                type,
                setting
            ]);
            if (feature[setting] && (r = $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$AATMapping[f[0]] && $6d519e6f260f4e02$var$$3b6302b64eccc32c$var$AATMapping[f[0]][f[1]])) res[r] = true;
        }
    }
    return Object.keys(res);
}
class $6d519e6f260f4e02$var$$ff5ce077dae0f144$export$2e2bcd8739ae039 {
    lookup(glyph) {
        switch(this.table.version){
            case 0:
                return this.table.values.getItem(glyph);
            case 2:
            case 4:
                {
                    let min = 0;
                    let max = this.table.binarySearchHeader.nUnits - 1;
                    while(min <= max){
                        var mid = min + max >> 1;
                        var seg = this.table.segments[mid];
                        // special end of search value
                        if (seg.firstGlyph === 0xffff) return null;
                        if (glyph < seg.firstGlyph) max = mid - 1;
                        else if (glyph > seg.lastGlyph) min = mid + 1;
                        else {
                            if (this.table.version === 2) return seg.value;
                            else return seg.values[glyph - seg.firstGlyph];
                        }
                    }
                    return null;
                }
            case 6:
                {
                    let min = 0;
                    let max = this.table.binarySearchHeader.nUnits - 1;
                    while(min <= max){
                        var mid = min + max >> 1;
                        var seg = this.table.segments[mid];
                        // special end of search value
                        if (seg.glyph === 0xffff) return null;
                        if (glyph < seg.glyph) max = mid - 1;
                        else if (glyph > seg.glyph) min = mid + 1;
                        else return seg.value;
                    }
                    return null;
                }
            case 8:
                return this.table.values[glyph - this.table.firstGlyph];
            default:
                throw new Error(`Unknown lookup table format: ${this.table.version}`);
        }
    }
    glyphsForValue(classValue) {
        let res = [];
        switch(this.table.version){
            case 2:
            case 4:
                for (let segment of this.table.segments)if (this.table.version === 2 && segment.value === classValue) res.push(...$6d519e6f260f4e02$var$$12727730ddfc8bfe$export$d02631cccf789723(segment.firstGlyph, segment.lastGlyph + 1));
                else {
                    for(let index = 0; index < segment.values.length; index++)if (segment.values[index] === classValue) res.push(segment.firstGlyph + index);
                }
                break;
            case 6:
                for (let segment of this.table.segments)if (segment.value === classValue) res.push(segment.glyph);
                break;
            case 8:
                for(let i = 0; i < this.table.values.length; i++)if (this.table.values[i] === classValue) res.push(this.table.firstGlyph + i);
                break;
            default:
                throw new Error(`Unknown lookup table format: ${this.table.version}`);
        }
        return res;
    }
    constructor(table){
        this.table = table;
    }
}
(0, $04dbd055bc5edd2b$export$29e00dfd3077644b)([
    $6d519e6f260f4e02$var$$e71565f2ce09cb6b$export$69a3209f1a06c04d
], $6d519e6f260f4e02$var$$ff5ce077dae0f144$export$2e2bcd8739ae039.prototype, "glyphsForValue", null);
const $6d519e6f260f4e02$var$$50c7aac9316f2948$var$START_OF_TEXT_STATE = 0;
const $6d519e6f260f4e02$var$$50c7aac9316f2948$var$START_OF_LINE_STATE = 1;
const $6d519e6f260f4e02$var$$50c7aac9316f2948$var$END_OF_TEXT_CLASS = 0;
const $6d519e6f260f4e02$var$$50c7aac9316f2948$var$OUT_OF_BOUNDS_CLASS = 1;
const $6d519e6f260f4e02$var$$50c7aac9316f2948$var$DELETED_GLYPH_CLASS = 2;
const $6d519e6f260f4e02$var$$50c7aac9316f2948$var$END_OF_LINE_CLASS = 3;
const $6d519e6f260f4e02$var$$50c7aac9316f2948$var$DONT_ADVANCE = 0x4000;
class $6d519e6f260f4e02$var$$50c7aac9316f2948$export$2e2bcd8739ae039 {
    process(glyphs, reverse, processEntry) {
        let currentState = $6d519e6f260f4e02$var$$50c7aac9316f2948$var$START_OF_TEXT_STATE; // START_OF_LINE_STATE is used for kashida glyph insertions sometimes I think?
        let index = reverse ? glyphs.length - 1 : 0;
        let dir = reverse ? -1 : 1;
        while(dir === 1 && index <= glyphs.length || dir === -1 && index >= -1){
            let glyph = null;
            let classCode = $6d519e6f260f4e02$var$$50c7aac9316f2948$var$OUT_OF_BOUNDS_CLASS;
            let shouldAdvance = true;
            if (index === glyphs.length || index === -1) classCode = $6d519e6f260f4e02$var$$50c7aac9316f2948$var$END_OF_TEXT_CLASS;
            else {
                glyph = glyphs[index];
                if (glyph.id === 0xffff) classCode = $6d519e6f260f4e02$var$$50c7aac9316f2948$var$DELETED_GLYPH_CLASS;
                else {
                    classCode = this.lookupTable.lookup(glyph.id);
                    if (classCode == null) classCode = $6d519e6f260f4e02$var$$50c7aac9316f2948$var$OUT_OF_BOUNDS_CLASS;
                }
            }
            let row = this.stateTable.stateArray.getItem(currentState);
            let entryIndex = row[classCode];
            let entry = this.stateTable.entryTable.getItem(entryIndex);
            if (classCode !== $6d519e6f260f4e02$var$$50c7aac9316f2948$var$END_OF_TEXT_CLASS && classCode !== $6d519e6f260f4e02$var$$50c7aac9316f2948$var$DELETED_GLYPH_CLASS) {
                processEntry(glyph, entry, index);
                shouldAdvance = !(entry.flags & $6d519e6f260f4e02$var$$50c7aac9316f2948$var$DONT_ADVANCE);
            }
            currentState = entry.newState;
            if (shouldAdvance) index += dir;
        }
        return glyphs;
    }
    /**
   * Performs a depth-first traversal of the glyph strings
   * represented by the state machine.
   */ traverse(opts, state = 0, visited = new Set) {
        if (visited.has(state)) return;
        visited.add(state);
        let { nClasses: nClasses, stateArray: stateArray, entryTable: entryTable } = this.stateTable;
        let row = stateArray.getItem(state);
        // Skip predefined classes
        for(let classCode = 4; classCode < nClasses; classCode++){
            let entryIndex = row[classCode];
            let entry = entryTable.getItem(entryIndex);
            // Try all glyphs in the class
            for (let glyph of this.lookupTable.glyphsForValue(classCode)){
                if (opts.enter) opts.enter(glyph, entry);
                if (entry.newState !== 0) this.traverse(opts, entry.newState, visited);
                if (opts.exit) opts.exit(glyph, entry);
            }
        }
    }
    constructor(stateTable){
        this.stateTable = stateTable;
        this.lookupTable = new $6d519e6f260f4e02$var$$ff5ce077dae0f144$export$2e2bcd8739ae039(stateTable.classTable);
    }
}
// indic replacement flags
const $6d519e6f260f4e02$var$$55f71433a605c87d$var$MARK_FIRST = 0x8000;
const $6d519e6f260f4e02$var$$55f71433a605c87d$var$MARK_LAST = 0x2000;
const $6d519e6f260f4e02$var$$55f71433a605c87d$var$VERB = 0x000F;
// contextual substitution and glyph insertion flag
const $6d519e6f260f4e02$var$$55f71433a605c87d$var$SET_MARK = 0x8000;
// ligature entry flags
const $6d519e6f260f4e02$var$$55f71433a605c87d$var$SET_COMPONENT = 0x8000;
const $6d519e6f260f4e02$var$$55f71433a605c87d$var$PERFORM_ACTION = 0x2000;
// ligature action masks
const $6d519e6f260f4e02$var$$55f71433a605c87d$var$LAST_MASK = 0x80000000;
const $6d519e6f260f4e02$var$$55f71433a605c87d$var$STORE_MASK = 0x40000000;
const $6d519e6f260f4e02$var$$55f71433a605c87d$var$OFFSET_MASK = 0x3FFFFFFF;
const $6d519e6f260f4e02$var$$55f71433a605c87d$var$VERTICAL_ONLY = 0x800000;
const $6d519e6f260f4e02$var$$55f71433a605c87d$var$REVERSE_DIRECTION = 0x400000;
const $6d519e6f260f4e02$var$$55f71433a605c87d$var$HORIZONTAL_AND_VERTICAL = 0x200000;
// glyph insertion flags
const $6d519e6f260f4e02$var$$55f71433a605c87d$var$CURRENT_IS_KASHIDA_LIKE = 0x2000;
const $6d519e6f260f4e02$var$$55f71433a605c87d$var$MARKED_IS_KASHIDA_LIKE = 0x1000;
const $6d519e6f260f4e02$var$$55f71433a605c87d$var$CURRENT_INSERT_BEFORE = 0x0800;
const $6d519e6f260f4e02$var$$55f71433a605c87d$var$MARKED_INSERT_BEFORE = 0x0400;
const $6d519e6f260f4e02$var$$55f71433a605c87d$var$CURRENT_INSERT_COUNT = 0x03E0;
const $6d519e6f260f4e02$var$$55f71433a605c87d$var$MARKED_INSERT_COUNT = 0x001F;
class $6d519e6f260f4e02$var$$55f71433a605c87d$export$2e2bcd8739ae039 {
    // Processes an array of glyphs and applies the specified features
    // Features should be in the form of {featureType:{featureSetting:boolean}}
    process(glyphs, features = {}) {
        for (let chain of this.morx.chains){
            let flags = chain.defaultFlags;
            // enable/disable the requested features
            for (let feature of chain.features){
                let f;
                if (f = features[feature.featureType]) {
                    if (f[feature.featureSetting]) {
                        flags &= feature.disableFlags;
                        flags |= feature.enableFlags;
                    } else if (f[feature.featureSetting] === false) {
                        flags |= ~feature.disableFlags;
                        flags &= ~feature.enableFlags;
                    }
                }
            }
            for (let subtable of chain.subtables)if (subtable.subFeatureFlags & flags) this.processSubtable(subtable, glyphs);
        }
        // remove deleted glyphs
        let index = glyphs.length - 1;
        while(index >= 0){
            if (glyphs[index].id === 0xffff) glyphs.splice(index, 1);
            index--;
        }
        return glyphs;
    }
    processSubtable(subtable, glyphs) {
        this.subtable = subtable;
        this.glyphs = glyphs;
        if (this.subtable.type === 4) {
            this.processNoncontextualSubstitutions(this.subtable, this.glyphs);
            return;
        }
        this.ligatureStack = [];
        this.markedGlyph = null;
        this.firstGlyph = null;
        this.lastGlyph = null;
        this.markedIndex = null;
        let stateMachine = this.getStateMachine(subtable);
        let process = this.getProcessor();
        let reverse = !!(this.subtable.coverage & $6d519e6f260f4e02$var$$55f71433a605c87d$var$REVERSE_DIRECTION);
        return stateMachine.process(this.glyphs, reverse, process);
    }
    getStateMachine(subtable) {
        return new $6d519e6f260f4e02$var$$50c7aac9316f2948$export$2e2bcd8739ae039(subtable.table.stateTable);
    }
    getProcessor() {
        switch(this.subtable.type){
            case 0:
                return this.processIndicRearragement;
            case 1:
                return this.processContextualSubstitution;
            case 2:
                return this.processLigature;
            case 4:
                return this.processNoncontextualSubstitutions;
            case 5:
                return this.processGlyphInsertion;
            default:
                throw new Error(`Invalid morx subtable type: ${this.subtable.type}`);
        }
    }
    processIndicRearragement(glyph, entry, index) {
        if (entry.flags & $6d519e6f260f4e02$var$$55f71433a605c87d$var$MARK_FIRST) this.firstGlyph = index;
        if (entry.flags & $6d519e6f260f4e02$var$$55f71433a605c87d$var$MARK_LAST) this.lastGlyph = index;
        $6d519e6f260f4e02$var$$55f71433a605c87d$var$reorderGlyphs(this.glyphs, entry.flags & $6d519e6f260f4e02$var$$55f71433a605c87d$var$VERB, this.firstGlyph, this.lastGlyph);
    }
    processContextualSubstitution(glyph, entry, index) {
        let subsitutions = this.subtable.table.substitutionTable.items;
        if (entry.markIndex !== 0xffff) {
            let lookup = subsitutions.getItem(entry.markIndex);
            let lookupTable = new $6d519e6f260f4e02$var$$ff5ce077dae0f144$export$2e2bcd8739ae039(lookup);
            glyph = this.glyphs[this.markedGlyph];
            var gid = lookupTable.lookup(glyph.id);
            if (gid) this.glyphs[this.markedGlyph] = this.font.getGlyph(gid, glyph.codePoints);
        }
        if (entry.currentIndex !== 0xffff) {
            let lookup = subsitutions.getItem(entry.currentIndex);
            let lookupTable = new $6d519e6f260f4e02$var$$ff5ce077dae0f144$export$2e2bcd8739ae039(lookup);
            glyph = this.glyphs[index];
            var gid = lookupTable.lookup(glyph.id);
            if (gid) this.glyphs[index] = this.font.getGlyph(gid, glyph.codePoints);
        }
        if (entry.flags & $6d519e6f260f4e02$var$$55f71433a605c87d$var$SET_MARK) this.markedGlyph = index;
    }
    processLigature(glyph, entry, index) {
        if (entry.flags & $6d519e6f260f4e02$var$$55f71433a605c87d$var$SET_COMPONENT) this.ligatureStack.push(index);
        if (entry.flags & $6d519e6f260f4e02$var$$55f71433a605c87d$var$PERFORM_ACTION) {
            let actions = this.subtable.table.ligatureActions;
            let components = this.subtable.table.components;
            let ligatureList = this.subtable.table.ligatureList;
            let actionIndex = entry.action;
            let last = false;
            let ligatureIndex = 0;
            let codePoints = [];
            let ligatureGlyphs = [];
            while(!last){
                let componentGlyph = this.ligatureStack.pop();
                codePoints.unshift(...this.glyphs[componentGlyph].codePoints);
                let action = actions.getItem(actionIndex++);
                last = !!(action & $6d519e6f260f4e02$var$$55f71433a605c87d$var$LAST_MASK);
                let store = !!(action & $6d519e6f260f4e02$var$$55f71433a605c87d$var$STORE_MASK);
                let offset = (action & $6d519e6f260f4e02$var$$55f71433a605c87d$var$OFFSET_MASK) << 2 >> 2; // sign extend 30 to 32 bits
                offset += this.glyphs[componentGlyph].id;
                let component = components.getItem(offset);
                ligatureIndex += component;
                if (last || store) {
                    let ligatureEntry = ligatureList.getItem(ligatureIndex);
                    this.glyphs[componentGlyph] = this.font.getGlyph(ligatureEntry, codePoints);
                    ligatureGlyphs.push(componentGlyph);
                    ligatureIndex = 0;
                    codePoints = [];
                } else this.glyphs[componentGlyph] = this.font.getGlyph(0xffff);
            }
            // Put ligature glyph indexes back on the stack
            this.ligatureStack.push(...ligatureGlyphs);
        }
    }
    processNoncontextualSubstitutions(subtable, glyphs, index) {
        let lookupTable = new $6d519e6f260f4e02$var$$ff5ce077dae0f144$export$2e2bcd8739ae039(subtable.table.lookupTable);
        for(index = 0; index < glyphs.length; index++){
            let glyph = glyphs[index];
            if (glyph.id !== 0xffff) {
                let gid = lookupTable.lookup(glyph.id);
                if (gid) glyphs[index] = this.font.getGlyph(gid, glyph.codePoints);
            }
        }
    }
    _insertGlyphs(glyphIndex, insertionActionIndex, count, isBefore) {
        let insertions = [];
        while(count--){
            let gid = this.subtable.table.insertionActions.getItem(insertionActionIndex++);
            insertions.push(this.font.getGlyph(gid));
        }
        if (!isBefore) glyphIndex++;
        this.glyphs.splice(glyphIndex, 0, ...insertions);
    }
    processGlyphInsertion(glyph, entry, index) {
        if (entry.flags & $6d519e6f260f4e02$var$$55f71433a605c87d$var$SET_MARK) this.markedIndex = index;
        if (entry.markedInsertIndex !== 0xffff) {
            let count = (entry.flags & $6d519e6f260f4e02$var$$55f71433a605c87d$var$MARKED_INSERT_COUNT) >>> 5;
            let isBefore = !!(entry.flags & $6d519e6f260f4e02$var$$55f71433a605c87d$var$MARKED_INSERT_BEFORE);
            this._insertGlyphs(this.markedIndex, entry.markedInsertIndex, count, isBefore);
        }
        if (entry.currentInsertIndex !== 0xffff) {
            let count = (entry.flags & $6d519e6f260f4e02$var$$55f71433a605c87d$var$CURRENT_INSERT_COUNT) >>> 5;
            let isBefore = !!(entry.flags & $6d519e6f260f4e02$var$$55f71433a605c87d$var$CURRENT_INSERT_BEFORE);
            this._insertGlyphs(index, entry.currentInsertIndex, count, isBefore);
        }
    }
    getSupportedFeatures() {
        let features = [];
        for (let chain of this.morx.chains)for (let feature of chain.features)features.push([
            feature.featureType,
            feature.featureSetting
        ]);
        return features;
    }
    generateInputs(gid) {
        if (!this.inputCache) this.generateInputCache();
        return this.inputCache[gid] || [];
    }
    generateInputCache() {
        this.inputCache = {};
        for (let chain of this.morx.chains){
            let flags = chain.defaultFlags;
            for (let subtable of chain.subtables)if (subtable.subFeatureFlags & flags) this.generateInputsForSubtable(subtable);
        }
    }
    generateInputsForSubtable(subtable) {
        // Currently, only supporting ligature subtables.
        if (subtable.type !== 2) return;
        let reverse = !!(subtable.coverage & $6d519e6f260f4e02$var$$55f71433a605c87d$var$REVERSE_DIRECTION);
        if (reverse) throw new Error('Reverse subtable, not supported.');
        this.subtable = subtable;
        this.ligatureStack = [];
        let stateMachine = this.getStateMachine(subtable);
        let process = this.getProcessor();
        let input = [];
        let stack = [];
        this.glyphs = [];
        stateMachine.traverse({
            enter: (glyph, entry)=>{
                let glyphs = this.glyphs;
                stack.push({
                    glyphs: glyphs.slice(),
                    ligatureStack: this.ligatureStack.slice()
                });
                // Add glyph to input and glyphs to process.
                let g = this.font.getGlyph(glyph);
                input.push(g);
                glyphs.push(input[input.length - 1]);
                // Process ligature substitution
                process(glyphs[glyphs.length - 1], entry, glyphs.length - 1);
                // Add input to result if only one matching (non-deleted) glyph remains.
                let count = 0;
                let found = 0;
                for(let i = 0; i < glyphs.length && count <= 1; i++)if (glyphs[i].id !== 0xffff) {
                    count++;
                    found = glyphs[i].id;
                }
                if (count === 1) {
                    let result = input.map((g)=>g.id);
                    let cache = this.inputCache[found];
                    if (cache) cache.push(result);
                    else this.inputCache[found] = [
                        result
                    ];
                }
            },
            exit: ()=>{
                ({ glyphs: this.glyphs, ligatureStack: this.ligatureStack } = stack.pop());
                input.pop();
            }
        });
    }
    constructor(font){
        this.processIndicRearragement = this.processIndicRearragement.bind(this);
        this.processContextualSubstitution = this.processContextualSubstitution.bind(this);
        this.processLigature = this.processLigature.bind(this);
        this.processNoncontextualSubstitutions = this.processNoncontextualSubstitutions.bind(this);
        this.processGlyphInsertion = this.processGlyphInsertion.bind(this);
        this.font = font;
        this.morx = font.morx;
        this.inputCache = null;
    }
}
(0, $04dbd055bc5edd2b$export$29e00dfd3077644b)([
    $6d519e6f260f4e02$var$$e71565f2ce09cb6b$export$69a3209f1a06c04d
], $6d519e6f260f4e02$var$$55f71433a605c87d$export$2e2bcd8739ae039.prototype, "getStateMachine", null);
// swaps the glyphs in rangeA with those in rangeB
// reverse the glyphs inside those ranges if specified
// ranges are in [offset, length] format
function $6d519e6f260f4e02$var$$55f71433a605c87d$var$swap(glyphs, rangeA, rangeB, reverseA = false, reverseB = false) {
    let end = glyphs.splice(rangeB[0] - (rangeB[1] - 1), rangeB[1]);
    if (reverseB) end.reverse();
    let start = glyphs.splice(rangeA[0], rangeA[1], ...end);
    if (reverseA) start.reverse();
    glyphs.splice(rangeB[0] - (rangeA[1] - 1), 0, ...start);
    return glyphs;
}
function $6d519e6f260f4e02$var$$55f71433a605c87d$var$reorderGlyphs(glyphs, verb, firstGlyph, lastGlyph) {
    let length = lastGlyph - firstGlyph + 1;
    switch(verb){
        case 0:
            return glyphs;
        case 1:
            return $6d519e6f260f4e02$var$$55f71433a605c87d$var$swap(glyphs, [
                firstGlyph,
                1
            ], [
                lastGlyph,
                0
            ]);
        case 2:
            return $6d519e6f260f4e02$var$$55f71433a605c87d$var$swap(glyphs, [
                firstGlyph,
                0
            ], [
                lastGlyph,
                1
            ]);
        case 3:
            return $6d519e6f260f4e02$var$$55f71433a605c87d$var$swap(glyphs, [
                firstGlyph,
                1
            ], [
                lastGlyph,
                1
            ]);
        case 4:
            return $6d519e6f260f4e02$var$$55f71433a605c87d$var$swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                0
            ]);
        case 5:
            return $6d519e6f260f4e02$var$$55f71433a605c87d$var$swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                0
            ], true, false);
        case 6:
            return $6d519e6f260f4e02$var$$55f71433a605c87d$var$swap(glyphs, [
                firstGlyph,
                0
            ], [
                lastGlyph,
                2
            ]);
        case 7:
            return $6d519e6f260f4e02$var$$55f71433a605c87d$var$swap(glyphs, [
                firstGlyph,
                0
            ], [
                lastGlyph,
                2
            ], false, true);
        case 8:
            return $6d519e6f260f4e02$var$$55f71433a605c87d$var$swap(glyphs, [
                firstGlyph,
                1
            ], [
                lastGlyph,
                2
            ]);
        case 9:
            return $6d519e6f260f4e02$var$$55f71433a605c87d$var$swap(glyphs, [
                firstGlyph,
                1
            ], [
                lastGlyph,
                2
            ], false, true);
        case 10:
            return $6d519e6f260f4e02$var$$55f71433a605c87d$var$swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                1
            ]);
        case 11:
            return $6d519e6f260f4e02$var$$55f71433a605c87d$var$swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                1
            ], true, false);
        case 12:
            return $6d519e6f260f4e02$var$$55f71433a605c87d$var$swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                2
            ]);
        case 13:
            return $6d519e6f260f4e02$var$$55f71433a605c87d$var$swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                2
            ], true, false);
        case 14:
            return $6d519e6f260f4e02$var$$55f71433a605c87d$var$swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                2
            ], false, true);
        case 15:
            return $6d519e6f260f4e02$var$$55f71433a605c87d$var$swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                2
            ], true, true);
        default:
            throw new Error(`Unknown verb: ${verb}`);
    }
}
class $6d519e6f260f4e02$var$$ba6dd74203be8728$export$2e2bcd8739ae039 {
    substitute(glyphRun) {
        // AAT expects the glyphs to be in visual order prior to morx processing,
        // so reverse the glyphs if the script is right-to-left.
        if (glyphRun.direction === 'rtl') glyphRun.glyphs.reverse();
        this.morxProcessor.process(glyphRun.glyphs, $6d519e6f260f4e02$var$$3b6302b64eccc32c$export$b813f7d2a1677c16(glyphRun.features));
    }
    getAvailableFeatures(script, language) {
        return $6d519e6f260f4e02$var$$3b6302b64eccc32c$export$bd6df347a4f391c4(this.morxProcessor.getSupportedFeatures());
    }
    stringsForGlyph(gid) {
        let glyphStrings = this.morxProcessor.generateInputs(gid);
        let result = new Set;
        for (let glyphs of glyphStrings)this._addStrings(glyphs, 0, result, '');
        return result;
    }
    _addStrings(glyphs, index, strings, string) {
        let codePoints = this.font._cmapProcessor.codePointsForGlyph(glyphs[index]);
        for (let codePoint of codePoints){
            let s = string + String.fromCodePoint(codePoint);
            if (index < glyphs.length - 1) this._addStrings(glyphs, index + 1, strings, s);
            else strings.add(s);
        }
    }
    constructor(font){
        this.font = font;
        this.morxProcessor = new $6d519e6f260f4e02$var$$55f71433a605c87d$export$2e2bcd8739ae039(font);
        this.fallbackPosition = false;
    }
}
class $6d519e6f260f4e02$var$$94d7a73bd2edfc9a$export$2e2bcd8739ae039 {
    /**
   * Adds the given features to the last stage.
   * Ignores features that have already been applied.
   */ _addFeatures(features, global) {
        let stageIndex = this.stages.length - 1;
        let stage = this.stages[stageIndex];
        for (let feature of features)if (this.allFeatures[feature] == null) {
            stage.push(feature);
            this.allFeatures[feature] = stageIndex;
            if (global) this.globalFeatures[feature] = true;
        }
    }
    /**
   * Add features to the last stage
   */ add(arg, global = true) {
        if (this.stages.length === 0) this.stages.push([]);
        if (typeof arg === 'string') arg = [
            arg
        ];
        if (Array.isArray(arg)) this._addFeatures(arg, global);
        else if (typeof arg === 'object') {
            this._addFeatures(arg.global || [], true);
            this._addFeatures(arg.local || [], false);
        } else throw new Error("Unsupported argument to ShapingPlan#add");
    }
    /**
   * Add a new stage
   */ addStage(arg, global) {
        if (typeof arg === 'function') this.stages.push(arg, []);
        else {
            this.stages.push([]);
            this.add(arg, global);
        }
    }
    setFeatureOverrides(features) {
        if (Array.isArray(features)) this.add(features);
        else if (typeof features === 'object') for(let tag in features){
            if (features[tag]) this.add(tag);
            else if (this.allFeatures[tag] != null) {
                let stage = this.stages[this.allFeatures[tag]];
                stage.splice(stage.indexOf(tag), 1);
                delete this.allFeatures[tag];
                delete this.globalFeatures[tag];
            }
        }
    }
    /**
   * Assigns the global features to the given glyphs
   */ assignGlobalFeatures(glyphs) {
        for (let glyph of glyphs)for(let feature in this.globalFeatures)glyph.features[feature] = true;
    }
    /**
   * Executes the planned stages using the given OTProcessor
   */ process(processor, glyphs, positions) {
        for (let stage of this.stages){
            if (typeof stage === 'function') {
                if (!positions) stage(this.font, glyphs, this);
            } else if (stage.length > 0) processor.applyFeatures(stage, glyphs, positions);
        }
    }
    constructor(font, script, direction){
        this.font = font;
        this.script = script;
        this.direction = direction;
        this.stages = [];
        this.globalFeatures = {};
        this.allFeatures = {};
    }
}
const $6d519e6f260f4e02$var$$649970d87335b30f$var$VARIATION_FEATURES = [
    'rvrn'
];
const $6d519e6f260f4e02$var$$649970d87335b30f$var$COMMON_FEATURES = [
    'ccmp',
    'locl',
    'rlig',
    'mark',
    'mkmk'
];
const $6d519e6f260f4e02$var$$649970d87335b30f$var$FRACTIONAL_FEATURES = [
    'frac',
    'numr',
    'dnom'
];
const $6d519e6f260f4e02$var$$649970d87335b30f$var$HORIZONTAL_FEATURES = [
    'calt',
    'clig',
    'liga',
    'rclt',
    'curs',
    'kern'
];
const $6d519e6f260f4e02$var$$649970d87335b30f$var$VERTICAL_FEATURES = [
    'vert'
];
const $6d519e6f260f4e02$var$$649970d87335b30f$var$DIRECTIONAL_FEATURES = {
    ltr: [
        'ltra',
        'ltrm'
    ],
    rtl: [
        'rtla',
        'rtlm'
    ]
};
class $6d519e6f260f4e02$var$$649970d87335b30f$export$2e2bcd8739ae039 {
    static plan(plan, glyphs, features) {
        // Plan the features we want to apply
        this.planPreprocessing(plan);
        this.planFeatures(plan);
        this.planPostprocessing(plan, features);
        // Assign the global features to all the glyphs
        plan.assignGlobalFeatures(glyphs);
        // Assign local features to glyphs
        this.assignFeatures(plan, glyphs);
    }
    static planPreprocessing(plan) {
        plan.add({
            global: [
                ...$6d519e6f260f4e02$var$$649970d87335b30f$var$VARIATION_FEATURES,
                ...$6d519e6f260f4e02$var$$649970d87335b30f$var$DIRECTIONAL_FEATURES[plan.direction]
            ],
            local: $6d519e6f260f4e02$var$$649970d87335b30f$var$FRACTIONAL_FEATURES
        });
    }
    static planFeatures(plan) {
    // Do nothing by default. Let subclasses override this.
    }
    static planPostprocessing(plan, userFeatures) {
        plan.add([
            ...$6d519e6f260f4e02$var$$649970d87335b30f$var$COMMON_FEATURES,
            ...$6d519e6f260f4e02$var$$649970d87335b30f$var$HORIZONTAL_FEATURES
        ]);
        plan.setFeatureOverrides(userFeatures);
    }
    static assignFeatures(plan, glyphs) {
        // Enable contextual fractions
        for(let i = 0; i < glyphs.length; i++){
            let glyph = glyphs[i];
            if (glyph.codePoints[0] === 0x2044) {
                let start = i;
                let end = i + 1;
                // Apply numerator
                while(start > 0 && (0, $d6a5237190dccd49$export$727d9dbc4fbb948f)(glyphs[start - 1].codePoints[0])){
                    glyphs[start - 1].features.numr = true;
                    glyphs[start - 1].features.frac = true;
                    start--;
                }
                // Apply denominator
                while(end < glyphs.length && (0, $d6a5237190dccd49$export$727d9dbc4fbb948f)(glyphs[end].codePoints[0])){
                    glyphs[end].features.dnom = true;
                    glyphs[end].features.frac = true;
                    end++;
                }
                // Apply fraction slash
                glyph.features.frac = true;
                i = end - 1;
            }
        }
    }
}
(0, $1d8e073d1256147c$export$71511d61b312f219)($6d519e6f260f4e02$var$$649970d87335b30f$export$2e2bcd8739ae039, "zeroMarkWidths", 'AFTER_GPOS');
const $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$trie = new (0, (/*@__PURE__*/$parcel$interopDefault($82c8d86aa310da61$exports)))($6d519e6f260f4e02$var$$12727730ddfc8bfe$export$94fdf11bafc8de6b("APABAAAAAAAAOAAAAf0BAv7tmi1MxDAUx7vtvjhAgcDgkEgEAnmXEBIMCYaEcygEiqBQ4FAkCE4ikUgMiiBJSAgSiUQSDMn9L9eSl6bddddug9t7yS/trevre+3r27pcNxZiG+yCfdCVv/9LeQxOwRm4AJegD27ALbgD9+ABPJF+z+BN/h7yDj5k/VOWX6SdmU5+wLWknggxDxaS8u0qiiX4uiz9XamQ3wzDMAzDMAzDMAzDVI/h959V/v7BMAzDMAzDMLlyNTNiMSdewVxbiA44B4/guz1qW58VYlMI0WsJ0W+N6kXw0spvPtdwhtkwnGM6uLaV4Xyzg3v3PM9DPfQ/sOg4xPWjipy31P8LTqbU304c/cLCUmWJLNB2Uz2U1KTeRKNmKHVMfbJC+/0loTZRH/W5cvEvBJPMbREkWt3FD1NcqXZBSpuE2Ad0PBehPtNrPtIEdYP+hiRt/V1jIiE69X4NT/uVZI3PUHE9bm5M7ePGdZWy951v7Nn6j8v1WWKP3mt6ttnsigx6VN7Vc0VomSSGqW2mGNP1muZPl7LfjNUaKNFtDGVf2fvE9O7VlBS5j333c5p/eeoOqcs1R/hIqDWLJ7TTlksirVT1SI7l8k4Yp+g3jafGcrU1RM6l9th80XOpnlN97bDNY4i4s61B0Si/ipa0uHMl6zqEjlFfCZm/TM8KmzQDjmuTAQ=="));
const $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$FEATURES = [
    'isol',
    'fina',
    'fin2',
    'fin3',
    'medi',
    'med2',
    'init'
];
const $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$ShapingClasses = {
    Non_Joining: 0,
    Left_Joining: 1,
    Right_Joining: 2,
    Dual_Joining: 3,
    Join_Causing: 3,
    ALAPH: 4,
    'DALATH RISH': 5,
    Transparent: 6
};
const $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$ISOL = 'isol';
const $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$FINA = 'fina';
const $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$FIN2 = 'fin2';
const $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$FIN3 = 'fin3';
const $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$MEDI = 'medi';
const $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$MED2 = 'med2';
const $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$INIT = 'init';
const $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$NONE = null;
// Each entry is [prevAction, curAction, nextState]
const $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$STATE_TABLE = [
    //   Non_Joining,        Left_Joining,       Right_Joining,     Dual_Joining,           ALAPH,            DALATH RISH
    // State 0: prev was U,  not willing to join.
    [
        [
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$NONE,
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$NONE,
            0
        ],
        [
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$NONE,
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$ISOL,
            2
        ],
        [
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$NONE,
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$ISOL,
            1
        ],
        [
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$NONE,
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$ISOL,
            2
        ],
        [
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$NONE,
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$ISOL,
            1
        ],
        [
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$NONE,
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$ISOL,
            6
        ]
    ],
    // State 1: prev was R or ISOL/ALAPH,  not willing to join.
    [
        [
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$NONE,
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$NONE,
            0
        ],
        [
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$NONE,
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$ISOL,
            2
        ],
        [
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$NONE,
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$ISOL,
            1
        ],
        [
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$NONE,
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$ISOL,
            2
        ],
        [
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$NONE,
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$FIN2,
            5
        ],
        [
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$NONE,
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$ISOL,
            6
        ]
    ],
    // State 2: prev was D/L in ISOL form,  willing to join.
    [
        [
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$NONE,
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$NONE,
            0
        ],
        [
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$NONE,
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$ISOL,
            2
        ],
        [
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$INIT,
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$FINA,
            1
        ],
        [
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$INIT,
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$FINA,
            3
        ],
        [
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$INIT,
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$FINA,
            4
        ],
        [
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$INIT,
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$FINA,
            6
        ]
    ],
    // State 3: prev was D in FINA form,  willing to join.
    [
        [
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$NONE,
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$NONE,
            0
        ],
        [
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$NONE,
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$ISOL,
            2
        ],
        [
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$MEDI,
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$FINA,
            1
        ],
        [
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$MEDI,
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$FINA,
            3
        ],
        [
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$MEDI,
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$FINA,
            4
        ],
        [
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$MEDI,
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$FINA,
            6
        ]
    ],
    // State 4: prev was FINA ALAPH,  not willing to join.
    [
        [
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$NONE,
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$NONE,
            0
        ],
        [
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$NONE,
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$ISOL,
            2
        ],
        [
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$MED2,
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$ISOL,
            1
        ],
        [
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$MED2,
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$ISOL,
            2
        ],
        [
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$MED2,
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$FIN2,
            5
        ],
        [
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$MED2,
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$ISOL,
            6
        ]
    ],
    // State 5: prev was FIN2/FIN3 ALAPH,  not willing to join.
    [
        [
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$NONE,
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$NONE,
            0
        ],
        [
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$NONE,
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$ISOL,
            2
        ],
        [
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$ISOL,
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$ISOL,
            1
        ],
        [
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$ISOL,
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$ISOL,
            2
        ],
        [
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$ISOL,
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$FIN2,
            5
        ],
        [
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$ISOL,
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$ISOL,
            6
        ]
    ],
    // State 6: prev was DALATH/RISH,  not willing to join.
    [
        [
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$NONE,
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$NONE,
            0
        ],
        [
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$NONE,
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$ISOL,
            2
        ],
        [
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$NONE,
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$ISOL,
            1
        ],
        [
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$NONE,
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$ISOL,
            2
        ],
        [
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$NONE,
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$FIN3,
            5
        ],
        [
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$NONE,
            $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$ISOL,
            6
        ]
    ]
];
class $6d519e6f260f4e02$var$$764eb544bbe1ccf0$export$2e2bcd8739ae039 extends $6d519e6f260f4e02$var$$649970d87335b30f$export$2e2bcd8739ae039 {
    static planFeatures(plan) {
        plan.add([
            'ccmp',
            'locl'
        ]);
        for(let i = 0; i < $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$FEATURES.length; i++){
            let feature = $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$FEATURES[i];
            plan.addStage(feature, false);
        }
        plan.addStage('mset');
    }
    static assignFeatures(plan, glyphs) {
        super.assignFeatures(plan, glyphs);
        let prev = -1;
        let state = 0;
        let actions = [];
        // Apply the state machine to map glyphs to features
        for(let i = 0; i < glyphs.length; i++){
            let curAction, prevAction;
            var glyph = glyphs[i];
            let type = $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$getShapingClass(glyph.codePoints[0]);
            if (type === $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$ShapingClasses.Transparent) {
                actions[i] = $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$NONE;
                continue;
            }
            [prevAction, curAction, state] = $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$STATE_TABLE[state][type];
            if (prevAction !== $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$NONE && prev !== -1) actions[prev] = prevAction;
            actions[i] = curAction;
            prev = i;
        }
        // Apply the chosen features to their respective glyphs
        for(let index = 0; index < glyphs.length; index++){
            let feature;
            var glyph = glyphs[index];
            if (feature = actions[index]) glyph.features[feature] = true;
        }
    }
}
function $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$getShapingClass(codePoint) {
    let res = $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$trie.get(codePoint);
    if (res) return res - 1;
    let category = (0, $d6a5237190dccd49$export$410364bbb673ddbc)(codePoint);
    if (category === 'Mn' || category === 'Me' || category === 'Cf') return $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$ShapingClasses.Transparent;
    return $6d519e6f260f4e02$var$$764eb544bbe1ccf0$var$ShapingClasses.Non_Joining;
}
class $6d519e6f260f4e02$var$$85d408632270248b$export$2e2bcd8739ae039 {
    reset(options = {}, index = 0) {
        this.options = options;
        this.flags = options.flags || {};
        this.markAttachmentType = options.markAttachmentType || 0;
        this.index = index;
    }
    get cur() {
        return this.glyphs[this.index] || null;
    }
    shouldIgnore(glyph) {
        return this.flags.ignoreMarks && glyph.isMark || this.flags.ignoreBaseGlyphs && glyph.isBase || this.flags.ignoreLigatures && glyph.isLigature || this.markAttachmentType && glyph.isMark && glyph.markAttachmentType !== this.markAttachmentType;
    }
    move(dir) {
        this.index += dir;
        while(0 <= this.index && this.index < this.glyphs.length && this.shouldIgnore(this.glyphs[this.index]))this.index += dir;
        if (0 > this.index || this.index >= this.glyphs.length) return null;
        return this.glyphs[this.index];
    }
    next() {
        return this.move(1);
    }
    prev() {
        return this.move(-1);
    }
    peek(count = 1) {
        let idx = this.index;
        let res = this.increment(count);
        this.index = idx;
        return res;
    }
    peekIndex(count = 1) {
        let idx = this.index;
        this.increment(count);
        let res = this.index;
        this.index = idx;
        return res;
    }
    increment(count = 1) {
        let dir = count < 0 ? -1 : 1;
        count = Math.abs(count);
        while(count--)this.move(dir);
        return this.glyphs[this.index];
    }
    constructor(glyphs, options){
        this.glyphs = glyphs;
        this.reset(options);
    }
}
const $6d519e6f260f4e02$var$$a83b9c36aaa94fd3$var$DEFAULT_SCRIPTS = [
    'DFLT',
    'dflt',
    'latn'
];
class $6d519e6f260f4e02$var$$a83b9c36aaa94fd3$export$2e2bcd8739ae039 {
    findScript(script) {
        if (this.table.scriptList == null) return null;
        if (!Array.isArray(script)) script = [
            script
        ];
        for (let s of script)for (let entry of this.table.scriptList){
            if (entry.tag === s) return entry;
        }
        return null;
    }
    selectScript(script, language, direction) {
        let changed = false;
        let entry;
        if (!this.script || script !== this.scriptTag) {
            entry = this.findScript(script);
            if (!entry) entry = this.findScript($6d519e6f260f4e02$var$$a83b9c36aaa94fd3$var$DEFAULT_SCRIPTS);
            if (!entry) return this.scriptTag;
            this.scriptTag = entry.tag;
            this.script = entry.script;
            this.language = null;
            this.languageTag = null;
            changed = true;
        }
        if (!direction || direction !== this.direction) this.direction = direction || $6d519e6f260f4e02$var$$130d1a642ebcd2b7$export$9fddb9d0dd7d8a54(script);
        if (language && language.length < 4) language += ' '.repeat(4 - language.length);
        if (!language || language !== this.languageTag) {
            this.language = null;
            for (let lang of this.script.langSysRecords)if (lang.tag === language) {
                this.language = lang.langSys;
                this.languageTag = lang.tag;
                break;
            }
            if (!this.language) {
                this.language = this.script.defaultLangSys;
                this.languageTag = null;
            }
            changed = true;
        }
        // Build a feature lookup table
        if (changed) {
            this.features = {};
            if (this.language) for (let featureIndex of this.language.featureIndexes){
                let record = this.table.featureList[featureIndex];
                let substituteFeature = this.substituteFeatureForVariations(featureIndex);
                this.features[record.tag] = substituteFeature || record.feature;
            }
        }
        return this.scriptTag;
    }
    lookupsForFeatures(userFeatures = [], exclude) {
        let lookups = [];
        for (let tag of userFeatures){
            let feature = this.features[tag];
            if (!feature) continue;
            for (let lookupIndex of feature.lookupListIndexes){
                if (exclude && exclude.indexOf(lookupIndex) !== -1) continue;
                lookups.push({
                    feature: tag,
                    index: lookupIndex,
                    lookup: this.table.lookupList.get(lookupIndex)
                });
            }
        }
        lookups.sort((a, b)=>a.index - b.index);
        return lookups;
    }
    substituteFeatureForVariations(featureIndex) {
        if (this.variationsIndex === -1) return null;
        let record = this.table.featureVariations.featureVariationRecords[this.variationsIndex];
        let substitutions = record.featureTableSubstitution.substitutions;
        for (let substitution of substitutions){
            if (substitution.featureIndex === featureIndex) return substitution.alternateFeatureTable;
        }
        return null;
    }
    findVariationsIndex(coords) {
        let variations = this.table.featureVariations;
        if (!variations) return -1;
        let records = variations.featureVariationRecords;
        for(let i = 0; i < records.length; i++){
            let conditions = records[i].conditionSet.conditionTable;
            if (this.variationConditionsMatch(conditions, coords)) return i;
        }
        return -1;
    }
    variationConditionsMatch(conditions, coords) {
        return conditions.every((condition)=>{
            let coord = condition.axisIndex < coords.length ? coords[condition.axisIndex] : 0;
            return condition.filterRangeMinValue <= coord && coord <= condition.filterRangeMaxValue;
        });
    }
    applyFeatures(userFeatures, glyphs, advances) {
        let lookups = this.lookupsForFeatures(userFeatures);
        this.applyLookups(lookups, glyphs, advances);
    }
    applyLookups(lookups, glyphs, positions) {
        this.glyphs = glyphs;
        this.positions = positions;
        this.glyphIterator = new $6d519e6f260f4e02$var$$85d408632270248b$export$2e2bcd8739ae039(glyphs);
        for (let { feature: feature, lookup: lookup } of lookups){
            this.currentFeature = feature;
            this.glyphIterator.reset(lookup.flags);
            while(this.glyphIterator.index < glyphs.length){
                if (!(feature in this.glyphIterator.cur.features)) {
                    this.glyphIterator.next();
                    continue;
                }
                for (let table of lookup.subTables){
                    let res = this.applyLookup(lookup.lookupType, table);
                    if (res) break;
                }
                this.glyphIterator.next();
            }
        }
    }
    applyLookup(lookup, table) {
        throw new Error("applyLookup must be implemented by subclasses");
    }
    applyLookupList(lookupRecords) {
        let options = this.glyphIterator.options;
        let glyphIndex = this.glyphIterator.index;
        for (let lookupRecord of lookupRecords){
            // Reset flags and find glyph index for this lookup record
            this.glyphIterator.reset(options, glyphIndex);
            this.glyphIterator.increment(lookupRecord.sequenceIndex);
            // Get the lookup and setup flags for subtables
            let lookup = this.table.lookupList.get(lookupRecord.lookupListIndex);
            this.glyphIterator.reset(lookup.flags, this.glyphIterator.index);
            // Apply lookup subtables until one matches
            for (let table of lookup.subTables){
                if (this.applyLookup(lookup.lookupType, table)) break;
            }
        }
        this.glyphIterator.reset(options, glyphIndex);
        return true;
    }
    coverageIndex(coverage, glyph) {
        if (glyph == null) glyph = this.glyphIterator.cur.id;
        switch(coverage.version){
            case 1:
                return coverage.glyphs.indexOf(glyph);
            case 2:
                for (let range of coverage.rangeRecords){
                    if (range.start <= glyph && glyph <= range.end) return range.startCoverageIndex + glyph - range.start;
                }
                break;
        }
        return -1;
    }
    match(sequenceIndex, sequence, fn, matched) {
        let pos = this.glyphIterator.index;
        let glyph = this.glyphIterator.increment(sequenceIndex);
        let idx = 0;
        while(idx < sequence.length && glyph && fn(sequence[idx], glyph)){
            if (matched) matched.push(this.glyphIterator.index);
            idx++;
            glyph = this.glyphIterator.next();
        }
        this.glyphIterator.index = pos;
        if (idx < sequence.length) return false;
        return matched || true;
    }
    sequenceMatches(sequenceIndex, sequence) {
        return this.match(sequenceIndex, sequence, (component, glyph)=>component === glyph.id);
    }
    sequenceMatchIndices(sequenceIndex, sequence) {
        return this.match(sequenceIndex, sequence, (component, glyph)=>{
            // If the current feature doesn't apply to this glyph,
            if (!(this.currentFeature in glyph.features)) return false;
            return component === glyph.id;
        }, []);
    }
    coverageSequenceMatches(sequenceIndex, sequence) {
        return this.match(sequenceIndex, sequence, (coverage, glyph)=>this.coverageIndex(coverage, glyph.id) >= 0);
    }
    getClassID(glyph, classDef) {
        switch(classDef.version){
            case 1:
                let i = glyph - classDef.startGlyph;
                if (i >= 0 && i < classDef.classValueArray.length) return classDef.classValueArray[i];
                break;
            case 2:
                for (let range of classDef.classRangeRecord){
                    if (range.start <= glyph && glyph <= range.end) return range.class;
                }
                break;
        }
        return 0;
    }
    classSequenceMatches(sequenceIndex, sequence, classDef) {
        return this.match(sequenceIndex, sequence, (classID, glyph)=>classID === this.getClassID(glyph.id, classDef));
    }
    applyContext(table) {
        let index, set;
        switch(table.version){
            case 1:
                index = this.coverageIndex(table.coverage);
                if (index === -1) return false;
                set = table.ruleSets[index];
                for (let rule of set){
                    if (this.sequenceMatches(1, rule.input)) return this.applyLookupList(rule.lookupRecords);
                }
                break;
            case 2:
                if (this.coverageIndex(table.coverage) === -1) return false;
                index = this.getClassID(this.glyphIterator.cur.id, table.classDef);
                if (index === -1) return false;
                set = table.classSet[index];
                for (let rule of set){
                    if (this.classSequenceMatches(1, rule.classes, table.classDef)) return this.applyLookupList(rule.lookupRecords);
                }
                break;
            case 3:
                if (this.coverageSequenceMatches(0, table.coverages)) return this.applyLookupList(table.lookupRecords);
                break;
        }
        return false;
    }
    applyChainingContext(table) {
        let index;
        switch(table.version){
            case 1:
                index = this.coverageIndex(table.coverage);
                if (index === -1) return false;
                let set = table.chainRuleSets[index];
                for (let rule of set){
                    if (this.sequenceMatches(-rule.backtrack.length, rule.backtrack) && this.sequenceMatches(1, rule.input) && this.sequenceMatches(1 + rule.input.length, rule.lookahead)) return this.applyLookupList(rule.lookupRecords);
                }
                break;
            case 2:
                if (this.coverageIndex(table.coverage) === -1) return false;
                index = this.getClassID(this.glyphIterator.cur.id, table.inputClassDef);
                let rules = table.chainClassSet[index];
                if (!rules) return false;
                for (let rule of rules){
                    if (this.classSequenceMatches(-rule.backtrack.length, rule.backtrack, table.backtrackClassDef) && this.classSequenceMatches(1, rule.input, table.inputClassDef) && this.classSequenceMatches(1 + rule.input.length, rule.lookahead, table.lookaheadClassDef)) return this.applyLookupList(rule.lookupRecords);
                }
                break;
            case 3:
                if (this.coverageSequenceMatches(-table.backtrackGlyphCount, table.backtrackCoverage) && this.coverageSequenceMatches(0, table.inputCoverage) && this.coverageSequenceMatches(table.inputGlyphCount, table.lookaheadCoverage)) return this.applyLookupList(table.lookupRecords);
                break;
        }
        return false;
    }
    constructor(font, table){
        this.font = font;
        this.table = table;
        this.script = null;
        this.scriptTag = null;
        this.language = null;
        this.languageTag = null;
        this.features = {};
        this.lookups = {};
        // Setup variation substitutions
        this.variationsIndex = font._variationProcessor ? this.findVariationsIndex(font._variationProcessor.normalizedCoords) : -1;
        // initialize to default script + language
        this.selectScript();
        // current context (set by applyFeatures)
        this.glyphs = [];
        this.positions = []; // only used by GPOS
        this.ligatureID = 1;
        this.currentFeature = null;
    }
}
class $6d519e6f260f4e02$var$$10e7b257e1a9a756$export$2e2bcd8739ae039 {
    get id() {
        return this._id;
    }
    set id(id) {
        this._id = id;
        this.substituted = true;
        let GDEF = this._font.GDEF;
        if (GDEF && GDEF.glyphClassDef) {
            // TODO: clean this up
            let classID = $6d519e6f260f4e02$var$$a83b9c36aaa94fd3$export$2e2bcd8739ae039.prototype.getClassID(id, GDEF.glyphClassDef);
            this.isBase = classID === 1;
            this.isLigature = classID === 2;
            this.isMark = classID === 3;
            this.markAttachmentType = GDEF.markAttachClassDef ? $6d519e6f260f4e02$var$$a83b9c36aaa94fd3$export$2e2bcd8739ae039.prototype.getClassID(id, GDEF.markAttachClassDef) : 0;
        } else {
            this.isMark = this.codePoints.length > 0 && this.codePoints.every((0, $d6a5237190dccd49$export$e33ad6871e762338));
            this.isBase = !this.isMark;
            this.isLigature = this.codePoints.length > 1;
            this.markAttachmentType = 0;
        }
    }
    copy() {
        return new $6d519e6f260f4e02$var$$10e7b257e1a9a756$export$2e2bcd8739ae039(this._font, this.id, this.codePoints, this.features);
    }
    constructor(font, id, codePoints = [], features){
        this._font = font;
        this.codePoints = codePoints;
        this.id = id;
        this.features = {};
        if (Array.isArray(features)) for(let i = 0; i < features.length; i++){
            let feature = features[i];
            this.features[feature] = true;
        }
        else if (typeof features === 'object') Object.assign(this.features, features);
        this.ligatureID = null;
        this.ligatureComponent = null;
        this.isLigated = false;
        this.cursiveAttachment = null;
        this.markAttachment = null;
        this.shaperInfo = null;
        this.substituted = false;
        this.isMultiplied = false;
    }
}
class $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$export$2e2bcd8739ae039 extends $6d519e6f260f4e02$var$$649970d87335b30f$export$2e2bcd8739ae039 {
    static planFeatures(plan) {
        plan.add([
            'ljmo',
            'vjmo',
            'tjmo'
        ], false);
    }
    static assignFeatures(plan, glyphs) {
        let state = 0;
        let i = 0;
        while(i < glyphs.length){
            let action;
            let glyph = glyphs[i];
            let code = glyph.codePoints[0];
            let type = $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$getType(code);
            [action, state] = $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$STATE_TABLE[state][type];
            switch(action){
                case $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$DECOMPOSE:
                    // Decompose the composed syllable if it is not supported by the font.
                    if (!plan.font.hasGlyphForCodePoint(code)) i = $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$decompose(glyphs, i, plan.font);
                    break;
                case $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$COMPOSE:
                    // Found a decomposed syllable. Try to compose if supported by the font.
                    i = $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$compose(glyphs, i, plan.font);
                    break;
                case $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$TONE_MARK:
                    // Got a valid syllable, followed by a tone mark. Move the tone mark to the beginning of the syllable.
                    $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$reorderToneMark(glyphs, i, plan.font);
                    break;
                case $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$INVALID:
                    // Tone mark has no valid syllable to attach to, so insert a dotted circle
                    i = $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$insertDottedCircle(glyphs, i, plan.font);
                    break;
            }
            i++;
        }
    }
}
(0, $1d8e073d1256147c$export$71511d61b312f219)($6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$export$2e2bcd8739ae039, "zeroMarkWidths", 'NONE');
const $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$HANGUL_BASE = 0xac00;
const $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$HANGUL_END = 0xd7a4;
const $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$HANGUL_COUNT = $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$HANGUL_END - $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$HANGUL_BASE + 1;
const $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$L_BASE = 0x1100; // lead
const $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$V_BASE = 0x1161; // vowel
const $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$T_BASE = 0x11a7; // trail
const $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$L_COUNT = 19;
const $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$V_COUNT = 21;
const $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$T_COUNT = 28;
const $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$L_END = $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$L_BASE + $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$L_COUNT - 1;
const $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$V_END = $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$V_BASE + $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$V_COUNT - 1;
const $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$T_END = $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$T_BASE + $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$T_COUNT - 1;
const $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$DOTTED_CIRCLE = 0x25cc;
const $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$isL = (code)=>0x1100 <= code && code <= 0x115f || 0xa960 <= code && code <= 0xa97c;
const $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$isV = (code)=>0x1160 <= code && code <= 0x11a7 || 0xd7b0 <= code && code <= 0xd7c6;
const $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$isT = (code)=>0x11a8 <= code && code <= 0x11ff || 0xd7cb <= code && code <= 0xd7fb;
const $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$isTone = (code)=>0x302e <= code && code <= 0x302f;
const $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$isLVT = (code)=>$6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$HANGUL_BASE <= code && code <= $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$HANGUL_END;
const $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$isLV = (code)=>code - $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$HANGUL_BASE < $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$HANGUL_COUNT && (code - $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$HANGUL_BASE) % $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$T_COUNT === 0;
const $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$isCombiningL = (code)=>$6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$L_BASE <= code && code <= $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$L_END;
const $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$isCombiningV = (code)=>$6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$V_BASE <= code && code <= $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$V_END;
const $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$isCombiningT = (code)=>$6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$T_BASE + 1 && 1 <= code && code <= $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$T_END;
// Character categories
const $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$X = 0; // Other character
const $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$L = 1; // Leading consonant
const $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$V = 2; // Medial vowel
const $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$T = 3; // Trailing consonant
const $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$LV = 4; // Composed <LV> syllable
const $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$LVT = 5; // Composed <LVT> syllable
const $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$M = 6; // Tone mark
// This function classifies a character using the above categories.
function $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$getType(code) {
    if ($6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$isL(code)) return $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$L;
    if ($6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$isV(code)) return $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$V;
    if ($6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$isT(code)) return $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$T;
    if ($6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$isLV(code)) return $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$LV;
    if ($6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$isLVT(code)) return $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$LVT;
    if ($6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$isTone(code)) return $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$M;
    return $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$X;
}
// State machine actions
const $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$NO_ACTION = 0;
const $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$DECOMPOSE = 1;
const $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$COMPOSE = 2;
const $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$TONE_MARK = 4;
const $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$INVALID = 5;
// Build a state machine that accepts valid syllables, and applies actions along the way.
// The logic this is implementing is documented at the top of the file.
const $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$STATE_TABLE = [
    //       X                 L                 V                T                  LV                LVT               M
    // State 0: start state
    [
        [
            $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$NO_ACTION,
            0
        ],
        [
            $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$NO_ACTION,
            1
        ],
        [
            $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$NO_ACTION,
            0
        ],
        [
            $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$NO_ACTION,
            0
        ],
        [
            $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$DECOMPOSE,
            2
        ],
        [
            $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$DECOMPOSE,
            3
        ],
        [
            $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$INVALID,
            0
        ]
    ],
    // State 1: <L>
    [
        [
            $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$NO_ACTION,
            0
        ],
        [
            $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$NO_ACTION,
            1
        ],
        [
            $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$COMPOSE,
            2
        ],
        [
            $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$NO_ACTION,
            0
        ],
        [
            $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$DECOMPOSE,
            2
        ],
        [
            $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$DECOMPOSE,
            3
        ],
        [
            $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$INVALID,
            0
        ]
    ],
    // State 2: <L,V> or <LV>
    [
        [
            $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$NO_ACTION,
            0
        ],
        [
            $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$NO_ACTION,
            1
        ],
        [
            $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$NO_ACTION,
            0
        ],
        [
            $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$COMPOSE,
            3
        ],
        [
            $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$DECOMPOSE,
            2
        ],
        [
            $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$DECOMPOSE,
            3
        ],
        [
            $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$TONE_MARK,
            0
        ]
    ],
    // State 3: <L,V,T> or <LVT>
    [
        [
            $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$NO_ACTION,
            0
        ],
        [
            $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$NO_ACTION,
            1
        ],
        [
            $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$NO_ACTION,
            0
        ],
        [
            $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$NO_ACTION,
            0
        ],
        [
            $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$DECOMPOSE,
            2
        ],
        [
            $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$DECOMPOSE,
            3
        ],
        [
            $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$TONE_MARK,
            0
        ]
    ]
];
function $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$getGlyph(font, code, features) {
    return new $6d519e6f260f4e02$var$$10e7b257e1a9a756$export$2e2bcd8739ae039(font, font.glyphForCodePoint(code).id, [
        code
    ], features);
}
function $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$decompose(glyphs, i, font) {
    let glyph = glyphs[i];
    let code = glyph.codePoints[0];
    let s = code - $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$HANGUL_BASE;
    let t = $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$T_BASE + s % $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$T_COUNT;
    s = s / $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$T_COUNT | 0;
    let l = $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$L_BASE + s / $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$V_COUNT | 0;
    let v = $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$V_BASE + s % $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$V_COUNT;
    // Don't decompose if all of the components are not available
    if (!font.hasGlyphForCodePoint(l) || !font.hasGlyphForCodePoint(v) || t !== $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$T_BASE && !font.hasGlyphForCodePoint(t)) return i;
    // Replace the current glyph with decomposed L, V, and T glyphs,
    // and apply the proper OpenType features to each component.
    let ljmo = $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$getGlyph(font, l, glyph.features);
    ljmo.features.ljmo = true;
    let vjmo = $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$getGlyph(font, v, glyph.features);
    vjmo.features.vjmo = true;
    let insert = [
        ljmo,
        vjmo
    ];
    if (t > $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$T_BASE) {
        let tjmo = $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$getGlyph(font, t, glyph.features);
        tjmo.features.tjmo = true;
        insert.push(tjmo);
    }
    glyphs.splice(i, 1, ...insert);
    return i + insert.length - 1;
}
function $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$compose(glyphs, i, font) {
    let glyph = glyphs[i];
    let code = glyphs[i].codePoints[0];
    let type = $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$getType(code);
    let prev = glyphs[i - 1].codePoints[0];
    let prevType = $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$getType(prev);
    // Figure out what type of syllable we're dealing with
    let lv, ljmo, vjmo, tjmo;
    if (prevType === $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$LV && type === $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$T) {
        // <LV,T>
        lv = prev;
        tjmo = glyph;
    } else {
        if (type === $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$V) {
            // <L,V>
            ljmo = glyphs[i - 1];
            vjmo = glyph;
        } else {
            // <L,V,T>
            ljmo = glyphs[i - 2];
            vjmo = glyphs[i - 1];
            tjmo = glyph;
        }
        let l = ljmo.codePoints[0];
        let v = vjmo.codePoints[0];
        // Make sure L and V are combining characters
        if ($6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$isCombiningL(l) && $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$isCombiningV(v)) lv = $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$HANGUL_BASE + ((l - $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$L_BASE) * $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$V_COUNT + (v - $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$V_BASE)) * $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$T_COUNT;
    }
    let t = tjmo && tjmo.codePoints[0] || $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$T_BASE;
    if (lv != null && (t === $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$T_BASE || $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$isCombiningT(t))) {
        let s = lv + (t - $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$T_BASE);
        // Replace with a composed glyph if supported by the font,
        // otherwise apply the proper OpenType features to each component.
        if (font.hasGlyphForCodePoint(s)) {
            let del = prevType === $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$V ? 3 : 2;
            glyphs.splice(i - del + 1, del, $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$getGlyph(font, s, glyph.features));
            return i - del + 1;
        }
    }
    // Didn't compose (either a non-combining component or unsupported by font).
    if (ljmo) ljmo.features.ljmo = true;
    if (vjmo) vjmo.features.vjmo = true;
    if (tjmo) tjmo.features.tjmo = true;
    if (prevType === $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$LV) {
        // Sequence was originally <L,V>, which got combined earlier.
        // Either the T was non-combining, or the LVT glyph wasn't supported.
        // Decompose the glyph again and apply OT features.
        $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$decompose(glyphs, i - 1, font);
        return i + 1;
    }
    return i;
}
function $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$getLength(code) {
    switch($6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$getType(code)){
        case $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$LV:
        case $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$LVT:
            return 1;
        case $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$V:
            return 2;
        case $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$T:
            return 3;
    }
}
function $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$reorderToneMark(glyphs, i, font) {
    let glyph = glyphs[i];
    let code = glyphs[i].codePoints[0];
    // Move tone mark to the beginning of the previous syllable, unless it is zero width
    if (font.glyphForCodePoint(code).advanceWidth === 0) return;
    let prev = glyphs[i - 1].codePoints[0];
    let len = $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$getLength(prev);
    glyphs.splice(i, 1);
    return glyphs.splice(i - len, 0, glyph);
}
function $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$insertDottedCircle(glyphs, i, font) {
    let glyph = glyphs[i];
    let code = glyphs[i].codePoints[0];
    if (font.hasGlyphForCodePoint($6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$DOTTED_CIRCLE)) {
        let dottedCircle = $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$getGlyph(font, $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$var$DOTTED_CIRCLE, glyph.features);
        // If the tone mark is zero width, insert the dotted circle before, otherwise after
        let idx = font.glyphForCodePoint(code).advanceWidth === 0 ? i : i + 1;
        glyphs.splice(idx, 0, dottedCircle);
        i++;
    }
    return i;
}
var $6d519e6f260f4e02$var$$4b0735ca6c692ea5$exports = {};
$6d519e6f260f4e02$var$$4b0735ca6c692ea5$exports = JSON.parse("{\"stateTable\":[[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,2,3,4,5,6,7,8,9,0,10,11,11,12,13,14,15,16,17],[0,0,0,18,19,20,21,22,23,0,24,0,0,25,26,0,0,27,0],[0,0,0,28,29,30,31,32,33,0,34,0,0,35,36,0,0,37,0],[0,0,0,38,5,7,7,8,9,0,10,0,0,0,13,0,0,16,0],[0,39,0,0,0,40,41,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,43,44,44,8,9,0,0,0,0,12,43,0,0,0,0],[0,0,0,0,43,44,44,8,9,0,0,0,0,0,43,0,0,0,0],[0,0,0,45,46,47,48,49,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,50,0,0,51,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,52,0,0,0,0,0,0,0,0],[0,0,0,53,54,55,56,57,58,0,59,0,0,60,61,0,0,62,0],[0,0,0,4,5,7,7,8,9,0,10,0,0,0,13,0,0,16,0],[0,63,64,0,0,40,41,0,9,0,10,0,0,0,42,0,63,0,0],[0,2,3,4,5,6,7,8,9,0,10,11,11,12,13,0,2,16,0],[0,0,0,18,65,20,21,22,23,0,24,0,0,25,26,0,0,27,0],[0,0,0,0,66,67,67,8,9,0,10,0,0,0,68,0,0,0,0],[0,0,0,69,0,70,70,0,71,0,72,0,0,0,0,0,0,0,0],[0,0,0,73,19,74,74,22,23,0,24,0,0,0,26,0,0,27,0],[0,75,0,0,0,76,77,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,79,80,80,22,23,0,0,0,0,25,79,0,0,0,0],[0,0,0,18,19,20,74,22,23,0,24,0,0,25,26,0,0,27,0],[0,0,0,81,82,83,84,85,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,86,0,0,87,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,88,0,0,0,0,0,0,0,0],[0,0,0,18,19,74,74,22,23,0,24,0,0,0,26,0,0,27,0],[0,89,90,0,0,76,77,0,23,0,24,0,0,0,78,0,89,0,0],[0,0,0,0,91,92,92,22,23,0,24,0,0,0,93,0,0,0,0],[0,0,0,94,29,95,31,32,33,0,34,0,0,0,36,0,0,37,0],[0,96,0,0,0,97,98,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,100,101,101,32,33,0,0,0,0,35,100,0,0,0,0],[0,0,0,0,100,101,101,32,33,0,0,0,0,0,100,0,0,0,0],[0,0,0,102,103,104,105,106,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,107,0,0,108,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,109,0,0,0,0,0,0,0,0],[0,0,0,28,29,95,31,32,33,0,34,0,0,0,36,0,0,37,0],[0,110,111,0,0,97,98,0,33,0,34,0,0,0,99,0,110,0,0],[0,0,0,0,112,113,113,32,33,0,34,0,0,0,114,0,0,0,0],[0,0,0,0,5,7,7,8,9,0,10,0,0,0,13,0,0,16,0],[0,0,0,115,116,117,118,8,9,0,10,0,0,119,120,0,0,16,0],[0,0,0,0,0,121,121,0,9,0,10,0,0,0,42,0,0,0,0],[0,39,0,122,0,123,123,8,9,0,10,0,0,0,42,0,39,0,0],[0,124,64,0,0,0,0,0,0,0,0,0,0,0,0,0,124,0,0],[0,39,0,0,0,121,125,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,0,126,126,8,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,46,47,48,49,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,47,47,49,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,127,127,49,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,128,127,127,49,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,129,130,131,132,133,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,50,0,0,0,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,134,0,0,0,0,0,0,0,0],[0,0,0,135,54,56,56,57,58,0,59,0,0,0,61,0,0,62,0],[0,136,0,0,0,137,138,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,140,141,141,57,58,0,0,0,0,60,140,0,0,0,0],[0,0,0,0,140,141,141,57,58,0,0,0,0,0,140,0,0,0,0],[0,0,0,142,143,144,145,146,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,147,0,0,148,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,149,0,0,0,0,0,0,0,0],[0,0,0,53,54,56,56,57,58,0,59,0,0,0,61,0,0,62,0],[0,150,151,0,0,137,138,0,58,0,59,0,0,0,139,0,150,0,0],[0,0,0,0,152,153,153,57,58,0,59,0,0,0,154,0,0,0,0],[0,0,0,155,116,156,157,8,9,0,10,0,0,158,120,0,0,16,0],[0,0,0,0,0,121,121,0,9,0,10,0,0,0,0,0,0,0,0],[0,75,3,4,5,159,160,8,161,0,162,0,11,12,163,0,75,16,0],[0,0,0,0,0,40,164,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,165,44,44,8,9,0,0,0,0,0,165,0,0,0,0],[0,124,64,0,0,40,164,0,9,0,10,0,0,0,42,0,124,0,0],[0,0,0,0,0,70,70,0,71,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,71,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,166,0,0,167,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,168,0,0,0,0,0,0,0,0],[0,0,0,0,19,74,74,22,23,0,24,0,0,0,26,0,0,27,0],[0,0,0,0,79,80,80,22,23,0,0,0,0,0,79,0,0,0,0],[0,0,0,169,170,171,172,22,23,0,24,0,0,173,174,0,0,27,0],[0,0,0,0,0,175,175,0,23,0,24,0,0,0,78,0,0,0,0],[0,75,0,176,0,177,177,22,23,0,24,0,0,0,78,0,75,0,0],[0,178,90,0,0,0,0,0,0,0,0,0,0,0,0,0,178,0,0],[0,75,0,0,0,175,179,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,0,180,180,22,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,82,83,84,85,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,83,83,85,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,181,181,85,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,182,181,181,85,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,183,184,185,186,187,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,86,0,0,0,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,188,0,0,0,0,0,0,0,0],[0,0,0,189,170,190,191,22,23,0,24,0,0,192,174,0,0,27,0],[0,0,0,0,0,175,175,0,23,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,76,193,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,194,80,80,22,23,0,0,0,0,0,194,0,0,0,0],[0,178,90,0,0,76,193,0,23,0,24,0,0,0,78,0,178,0,0],[0,0,0,0,29,95,31,32,33,0,34,0,0,0,36,0,0,37,0],[0,0,0,0,100,101,101,32,33,0,0,0,0,0,100,0,0,0,0],[0,0,0,195,196,197,198,32,33,0,34,0,0,199,200,0,0,37,0],[0,0,0,0,0,201,201,0,33,0,34,0,0,0,99,0,0,0,0],[0,96,0,202,0,203,203,32,33,0,34,0,0,0,99,0,96,0,0],[0,204,111,0,0,0,0,0,0,0,0,0,0,0,0,0,204,0,0],[0,96,0,0,0,201,205,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,0,206,206,32,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,103,104,105,106,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,104,104,106,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,207,207,106,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,208,207,207,106,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,209,210,211,212,213,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,107,0,0,0,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,214,0,0,0,0,0,0,0,0],[0,0,0,215,196,216,217,32,33,0,34,0,0,218,200,0,0,37,0],[0,0,0,0,0,201,201,0,33,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,97,219,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,220,101,101,32,33,0,0,0,0,0,220,0,0,0,0],[0,204,111,0,0,97,219,0,33,0,34,0,0,0,99,0,204,0,0],[0,0,0,221,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,223,0,0,0,40,224,0,9,0,10,0,0,0,42,0,223,0,0],[0,0,0,0,225,44,44,8,9,0,0,0,0,119,225,0,0,0,0],[0,0,0,115,116,117,222,8,9,0,10,0,0,119,120,0,0,16,0],[0,0,0,115,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,226,64,0,0,40,224,0,9,0,10,0,0,0,42,0,226,0,0],[0,0,0,0,0,0,0,0,9,0,0,0,0,0,0,0,0,0,0],[0,39,0,0,0,121,121,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,0,44,44,8,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,227,0,228,229,0,9,0,10,0,0,230,0,0,0,0,0],[0,39,0,122,0,121,121,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,0,0,0,8,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,231,231,49,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,232,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,130,131,132,133,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,131,131,133,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,233,233,133,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,234,233,233,133,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,235,236,237,238,239,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,54,56,56,57,58,0,59,0,0,0,61,0,0,62,0],[0,0,0,240,241,242,243,57,58,0,59,0,0,244,245,0,0,62,0],[0,0,0,0,0,246,246,0,58,0,59,0,0,0,139,0,0,0,0],[0,136,0,247,0,248,248,57,58,0,59,0,0,0,139,0,136,0,0],[0,249,151,0,0,0,0,0,0,0,0,0,0,0,0,0,249,0,0],[0,136,0,0,0,246,250,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,0,251,251,57,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,143,144,145,146,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,144,144,146,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,252,252,146,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,253,252,252,146,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,254,255,256,257,258,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,147,0,0,0,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,259,0,0,0,0,0,0,0,0],[0,0,0,260,241,261,262,57,58,0,59,0,0,263,245,0,0,62,0],[0,0,0,0,0,246,246,0,58,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,137,264,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,265,141,141,57,58,0,0,0,0,0,265,0,0,0,0],[0,249,151,0,0,137,264,0,58,0,59,0,0,0,139,0,249,0,0],[0,0,0,221,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,9,0,0,0,0,158,225,0,0,0,0],[0,0,0,155,116,156,222,8,9,0,10,0,0,158,120,0,0,16,0],[0,0,0,155,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,0,0,0,43,266,266,8,161,0,24,0,0,12,267,0,0,0,0],[0,75,0,176,43,268,268,269,161,0,24,0,0,0,267,0,75,0,0],[0,0,0,0,0,270,0,0,271,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,272,0,0,0,0,0,0,0,0],[0,273,274,0,0,40,41,0,9,0,10,0,0,0,42,0,273,0,0],[0,0,0,40,0,123,123,8,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,121,275,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,166,0,0,0,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,276,0,0,0,0,0,0,0,0],[0,0,0,277,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,279,0,0,0,76,280,0,23,0,24,0,0,0,78,0,279,0,0],[0,0,0,0,281,80,80,22,23,0,0,0,0,173,281,0,0,0,0],[0,0,0,169,170,171,278,22,23,0,24,0,0,173,174,0,0,27,0],[0,0,0,169,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,282,90,0,0,76,280,0,23,0,24,0,0,0,78,0,282,0,0],[0,0,0,0,0,0,0,0,23,0,0,0,0,0,0,0,0,0,0],[0,75,0,0,0,175,175,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,0,80,80,22,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,283,0,284,285,0,23,0,24,0,0,286,0,0,0,0,0],[0,75,0,176,0,175,175,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,0,0,0,22,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,287,287,85,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,288,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,184,185,186,187,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,185,185,187,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,289,289,187,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,290,289,289,187,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,291,292,293,294,295,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,277,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,0,0,0,281,80,80,22,23,0,0,0,0,192,281,0,0,0,0],[0,0,0,189,170,190,278,22,23,0,24,0,0,192,174,0,0,27,0],[0,0,0,189,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,0,0,76,0,177,177,22,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,175,296,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,297,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,299,0,0,0,97,300,0,33,0,34,0,0,0,99,0,299,0,0],[0,0,0,0,301,101,101,32,33,0,0,0,0,199,301,0,0,0,0],[0,0,0,195,196,197,298,32,33,0,34,0,0,199,200,0,0,37,0],[0,0,0,195,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,302,111,0,0,97,300,0,33,0,34,0,0,0,99,0,302,0,0],[0,0,0,0,0,0,0,0,33,0,0,0,0,0,0,0,0,0,0],[0,96,0,0,0,201,201,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,0,101,101,32,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,303,0,304,305,0,33,0,34,0,0,306,0,0,0,0,0],[0,96,0,202,0,201,201,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,0,0,0,32,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,307,307,106,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,308,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,210,211,212,213,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,211,211,213,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,309,309,213,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,310,309,309,213,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,311,312,313,314,315,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,297,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,0,0,0,301,101,101,32,33,0,0,0,0,218,301,0,0,0,0],[0,0,0,215,196,216,298,32,33,0,34,0,0,218,200,0,0,37,0],[0,0,0,215,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,0,0,97,0,203,203,32,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,201,316,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,9,0,0,0,0,0,225,0,0,0,0],[0,0,0,317,318,319,320,8,9,0,10,0,0,321,322,0,0,16,0],[0,223,0,323,0,123,123,8,9,0,10,0,0,0,42,0,223,0,0],[0,223,0,0,0,121,324,0,9,0,10,0,0,0,42,0,223,0,0],[0,0,0,325,318,326,327,8,9,0,10,0,0,328,322,0,0,16,0],[0,0,0,64,0,121,121,0,9,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,9,0,0,0,0,230,0,0,0,0,0],[0,0,0,227,0,228,121,0,9,0,10,0,0,230,0,0,0,0,0],[0,0,0,227,0,121,121,0,9,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,49,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,46,0,0],[0,0,0,0,0,329,329,133,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,330,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,236,237,238,239,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,237,237,239,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,331,331,239,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,332,331,331,239,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,333,40,121,334,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,335,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,337,0,0,0,137,338,0,58,0,59,0,0,0,139,0,337,0,0],[0,0,0,0,339,141,141,57,58,0,0,0,0,244,339,0,0,0,0],[0,0,0,240,241,242,336,57,58,0,59,0,0,244,245,0,0,62,0],[0,0,0,240,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,340,151,0,0,137,338,0,58,0,59,0,0,0,139,0,340,0,0],[0,0,0,0,0,0,0,0,58,0,0,0,0,0,0,0,0,0,0],[0,136,0,0,0,246,246,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,0,141,141,57,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,341,0,342,343,0,58,0,59,0,0,344,0,0,0,0,0],[0,136,0,247,0,246,246,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,0,0,0,57,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,345,345,146,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,346,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,255,256,257,258,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,256,256,258,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,347,347,258,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,348,347,347,258,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,349,350,351,352,353,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,335,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,0,0,0,339,141,141,57,58,0,0,0,0,263,339,0,0,0,0],[0,0,0,260,241,261,336,57,58,0,59,0,0,263,245,0,0,62,0],[0,0,0,260,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,0,0,137,0,248,248,57,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,246,354,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,126,126,8,23,0,0,0,0,0,0,0,0,0,0],[0,355,90,0,0,121,125,0,9,0,10,0,0,0,42,0,355,0,0],[0,0,0,0,0,356,356,269,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,357,358,359,360,361,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,270,0,0,0,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,363,0,0,0,0,0,0,0,0],[0,0,0,364,116,365,366,8,161,0,162,0,0,367,120,0,0,16,0],[0,0,0,0,0,368,368,0,161,0,162,0,0,0,0,0,0,0,0],[0,0,0,40,0,121,121,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,0,0,0,281,80,80,22,23,0,0,0,0,0,281,0,0,0,0],[0,0,0,369,370,371,372,22,23,0,24,0,0,373,374,0,0,27,0],[0,279,0,375,0,177,177,22,23,0,24,0,0,0,78,0,279,0,0],[0,279,0,0,0,175,376,0,23,0,24,0,0,0,78,0,279,0,0],[0,0,0,377,370,378,379,22,23,0,24,0,0,380,374,0,0,27,0],[0,0,0,90,0,175,175,0,23,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,23,0,0,0,0,286,0,0,0,0,0],[0,0,0,283,0,284,175,0,23,0,24,0,0,286,0,0,0,0,0],[0,0,0,283,0,175,175,0,23,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,85,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,82,0,0],[0,0,0,0,0,381,381,187,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,382,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,292,293,294,295,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,293,293,295,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,383,383,295,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,384,383,383,295,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,385,76,175,386,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,76,0,175,175,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,0,0,0,301,101,101,32,33,0,0,0,0,0,301,0,0,0,0],[0,0,0,387,388,389,390,32,33,0,34,0,0,391,392,0,0,37,0],[0,299,0,393,0,203,203,32,33,0,34,0,0,0,99,0,299,0,0],[0,299,0,0,0,201,394,0,33,0,34,0,0,0,99,0,299,0,0],[0,0,0,395,388,396,397,32,33,0,34,0,0,398,392,0,0,37,0],[0,0,0,111,0,201,201,0,33,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,33,0,0,0,0,306,0,0,0,0,0],[0,0,0,303,0,304,201,0,33,0,34,0,0,306,0,0,0,0,0],[0,0,0,303,0,201,201,0,33,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,106,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,103,0,0],[0,0,0,0,0,399,399,213,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,400,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,312,313,314,315,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,313,313,315,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,401,401,315,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,402,401,401,315,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,403,97,201,404,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,97,0,201,201,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,405,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,407,0,0,0,40,408,0,9,0,10,0,0,0,42,0,407,0,0],[0,0,0,0,409,44,44,8,9,0,0,0,0,321,409,0,0,0,0],[0,0,0,317,318,319,406,8,9,0,10,0,0,321,322,0,0,16,0],[0,0,0,317,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,410,64,0,0,40,408,0,9,0,10,0,0,0,42,0,410,0,0],[0,223,0,0,0,121,121,0,9,0,10,0,0,0,42,0,223,0,0],[0,223,0,323,0,121,121,0,9,0,10,0,0,0,42,0,223,0,0],[0,0,0,405,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,0,0,0,409,44,44,8,9,0,0,0,0,328,409,0,0,0,0],[0,0,0,325,318,326,406,8,9,0,10,0,0,328,322,0,0,16,0],[0,0,0,325,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,0,0,0,0,0,0,133,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,130,0,0],[0,0,0,0,0,411,411,239,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,412,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,40,121,334,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,413,0,0,0,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,0,0,0,339,141,141,57,58,0,0,0,0,0,339,0,0,0,0],[0,0,0,414,415,416,417,57,58,0,59,0,0,418,419,0,0,62,0],[0,337,0,420,0,248,248,57,58,0,59,0,0,0,139,0,337,0,0],[0,337,0,0,0,246,421,0,58,0,59,0,0,0,139,0,337,0,0],[0,0,0,422,415,423,424,57,58,0,59,0,0,425,419,0,0,62,0],[0,0,0,151,0,246,246,0,58,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,58,0,0,0,0,344,0,0,0,0,0],[0,0,0,341,0,342,246,0,58,0,59,0,0,344,0,0,0,0,0],[0,0,0,341,0,246,246,0,58,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,146,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,143,0,0],[0,0,0,0,0,426,426,258,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,427,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,350,351,352,353,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,351,351,353,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,428,428,353,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,429,428,428,353,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,430,137,246,431,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,137,0,246,246,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,432,116,433,434,8,161,0,162,0,0,435,120,0,0,16,0],[0,0,0,0,0,180,180,269,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,358,359,360,361,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,359,359,361,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,436,436,361,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,437,436,436,361,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,438,439,440,441,442,161,0,162,0,0,0,362,0,0,0,0],[0,443,274,0,0,0,0,0,0,0,0,0,0,0,0,0,443,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,444,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,161,0,0,0,0,367,225,0,0,0,0],[0,0,0,364,116,365,445,8,161,0,162,0,0,367,120,0,0,16,0],[0,0,0,364,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,0,0,0,0,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,446,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,448,0,0,0,76,449,0,23,0,24,0,0,0,78,0,448,0,0],[0,0,0,0,450,80,80,22,23,0,0,0,0,373,450,0,0,0,0],[0,0,0,369,370,371,447,22,23,0,24,0,0,373,374,0,0,27,0],[0,0,0,369,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,451,90,0,0,76,449,0,23,0,24,0,0,0,78,0,451,0,0],[0,279,0,0,0,175,175,0,23,0,24,0,0,0,78,0,279,0,0],[0,279,0,375,0,175,175,0,23,0,24,0,0,0,78,0,279,0,0],[0,0,0,446,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,0,0,0,450,80,80,22,23,0,0,0,0,380,450,0,0,0,0],[0,0,0,377,370,378,447,22,23,0,24,0,0,380,374,0,0,27,0],[0,0,0,377,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,0,0,0,0,0,0,187,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,184,0,0],[0,0,0,0,0,452,452,295,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,453,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,76,175,386,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,454,0,0,0,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,455,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,457,0,0,0,97,458,0,33,0,34,0,0,0,99,0,457,0,0],[0,0,0,0,459,101,101,32,33,0,0,0,0,391,459,0,0,0,0],[0,0,0,387,388,389,456,32,33,0,34,0,0,391,392,0,0,37,0],[0,0,0,387,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,460,111,0,0,97,458,0,33,0,34,0,0,0,99,0,460,0,0],[0,299,0,0,0,201,201,0,33,0,34,0,0,0,99,0,299,0,0],[0,299,0,393,0,201,201,0,33,0,34,0,0,0,99,0,299,0,0],[0,0,0,455,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,0,0,0,459,101,101,32,33,0,0,0,0,398,459,0,0,0,0],[0,0,0,395,388,396,456,32,33,0,34,0,0,398,392,0,0,37,0],[0,0,0,395,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,0,0,0,0,0,0,213,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,210,0,0],[0,0,0,0,0,461,461,315,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,462,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,97,201,404,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,463,0,0,0,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,0,0,0,409,44,44,8,9,0,0,0,0,0,409,0,0,0,0],[0,0,0,464,465,466,467,8,9,0,10,0,0,468,469,0,0,16,0],[0,407,0,470,0,123,123,8,9,0,10,0,0,0,42,0,407,0,0],[0,407,0,0,0,121,471,0,9,0,10,0,0,0,42,0,407,0,0],[0,0,0,472,465,473,474,8,9,0,10,0,0,475,469,0,0,16,0],[0,0,0,0,0,0,0,239,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,236,0,0],[0,0,0,0,0,0,476,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,477,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,479,0,0,0,137,480,0,58,0,59,0,0,0,139,0,479,0,0],[0,0,0,0,481,141,141,57,58,0,0,0,0,418,481,0,0,0,0],[0,0,0,414,415,416,478,57,58,0,59,0,0,418,419,0,0,62,0],[0,0,0,414,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,482,151,0,0,137,480,0,58,0,59,0,0,0,139,0,482,0,0],[0,337,0,0,0,246,246,0,58,0,59,0,0,0,139,0,337,0,0],[0,337,0,420,0,246,246,0,58,0,59,0,0,0,139,0,337,0,0],[0,0,0,477,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,0,0,0,481,141,141,57,58,0,0,0,0,425,481,0,0,0,0],[0,0,0,422,415,423,478,57,58,0,59,0,0,425,419,0,0,62,0],[0,0,0,422,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,0,0,0,0,0,0,258,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,255,0,0],[0,0,0,0,0,483,483,353,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,484,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,137,246,431,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,485,0,0,0,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,444,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,161,0,0,0,0,435,225,0,0,0,0],[0,0,0,432,116,433,445,8,161,0,162,0,0,435,120,0,0,16,0],[0,0,0,432,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,0,486,486,361,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,487,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,439,440,441,442,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,440,440,442,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,488,488,442,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,489,488,488,442,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,490,491,492,493,494,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,495,0,496,497,0,161,0,162,0,0,498,0,0,0,0,0],[0,0,0,0,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,161,0,0,0,0,0,225,0,0,0,0],[0,0,0,0,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,0,0,0,450,80,80,22,23,0,0,0,0,0,450,0,0,0,0],[0,0,0,499,500,501,502,22,23,0,24,0,0,503,504,0,0,27,0],[0,448,0,505,0,177,177,22,23,0,24,0,0,0,78,0,448,0,0],[0,448,0,0,0,175,506,0,23,0,24,0,0,0,78,0,448,0,0],[0,0,0,507,500,508,509,22,23,0,24,0,0,510,504,0,0,27,0],[0,0,0,0,0,0,0,295,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,292,0,0],[0,0,0,0,0,0,511,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,0,0,0,459,101,101,32,33,0,0,0,0,0,459,0,0,0,0],[0,0,0,512,513,514,515,32,33,0,34,0,0,516,517,0,0,37,0],[0,457,0,518,0,203,203,32,33,0,34,0,0,0,99,0,457,0,0],[0,457,0,0,0,201,519,0,33,0,34,0,0,0,99,0,457,0,0],[0,0,0,520,513,521,522,32,33,0,34,0,0,523,517,0,0,37,0],[0,0,0,0,0,0,0,315,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,312,0,0],[0,0,0,0,0,0,524,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,525,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,527,0,0,0,40,528,0,9,0,10,0,0,0,42,0,527,0,0],[0,0,0,0,529,44,44,8,9,0,0,0,0,468,529,0,0,0,0],[0,0,0,464,465,466,526,8,9,0,10,0,0,468,469,0,0,16,0],[0,0,0,464,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,530,64,0,0,40,528,0,9,0,10,0,0,0,42,0,530,0,0],[0,407,0,0,0,121,121,0,9,0,10,0,0,0,42,0,407,0,0],[0,407,0,470,0,121,121,0,9,0,10,0,0,0,42,0,407,0,0],[0,0,0,525,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,0,0,0,529,44,44,8,9,0,0,0,0,475,529,0,0,0,0],[0,0,0,472,465,473,526,8,9,0,10,0,0,475,469,0,0,16,0],[0,0,0,472,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,40,0,0],[0,0,0,0,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,0,0,0,481,141,141,57,58,0,0,0,0,0,481,0,0,0,0],[0,0,0,531,532,533,534,57,58,0,59,0,0,535,536,0,0,62,0],[0,479,0,537,0,248,248,57,58,0,59,0,0,0,139,0,479,0,0],[0,479,0,0,0,246,538,0,58,0,59,0,0,0,139,0,479,0,0],[0,0,0,539,532,540,541,57,58,0,59,0,0,542,536,0,0,62,0],[0,0,0,0,0,0,0,353,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,350,0,0],[0,0,0,0,0,0,543,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,361,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,358,0,0],[0,0,0,0,0,544,544,442,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,545,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,491,492,493,494,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,492,492,494,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,546,546,494,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,547,546,546,494,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,548,549,368,550,0,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,274,0,368,368,0,161,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,161,0,0,0,0,498,0,0,0,0,0],[0,0,0,495,0,496,368,0,161,0,162,0,0,498,0,0,0,0,0],[0,0,0,495,0,368,368,0,161,0,162,0,0,0,0,0,0,0,0],[0,0,0,551,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,553,0,0,0,76,554,0,23,0,24,0,0,0,78,0,553,0,0],[0,0,0,0,555,80,80,22,23,0,0,0,0,503,555,0,0,0,0],[0,0,0,499,500,501,552,22,23,0,24,0,0,503,504,0,0,27,0],[0,0,0,499,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,556,90,0,0,76,554,0,23,0,24,0,0,0,78,0,556,0,0],[0,448,0,0,0,175,175,0,23,0,24,0,0,0,78,0,448,0,0],[0,448,0,505,0,175,175,0,23,0,24,0,0,0,78,0,448,0,0],[0,0,0,551,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,0,0,0,555,80,80,22,23,0,0,0,0,510,555,0,0,0,0],[0,0,0,507,500,508,552,22,23,0,24,0,0,510,504,0,0,27,0],[0,0,0,507,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,76,0,0],[0,0,0,557,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,559,0,0,0,97,560,0,33,0,34,0,0,0,99,0,559,0,0],[0,0,0,0,561,101,101,32,33,0,0,0,0,516,561,0,0,0,0],[0,0,0,512,513,514,558,32,33,0,34,0,0,516,517,0,0,37,0],[0,0,0,512,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,562,111,0,0,97,560,0,33,0,34,0,0,0,99,0,562,0,0],[0,457,0,0,0,201,201,0,33,0,34,0,0,0,99,0,457,0,0],[0,457,0,518,0,201,201,0,33,0,34,0,0,0,99,0,457,0,0],[0,0,0,557,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,0,0,0,561,101,101,32,33,0,0,0,0,523,561,0,0,0,0],[0,0,0,520,513,521,558,32,33,0,34,0,0,523,517,0,0,37,0],[0,0,0,520,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,97,0,0],[0,0,0,0,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,0,0,0,529,44,44,8,9,0,0,0,0,0,529,0,0,0,0],[0,0,0,563,66,564,565,8,9,0,10,0,0,566,68,0,0,16,0],[0,527,0,567,0,123,123,8,9,0,10,0,0,0,42,0,527,0,0],[0,527,0,0,0,121,568,0,9,0,10,0,0,0,42,0,527,0,0],[0,0,0,569,66,570,571,8,9,0,10,0,0,572,68,0,0,16,0],[0,0,0,573,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,575,0,0,0,137,576,0,58,0,59,0,0,0,139,0,575,0,0],[0,0,0,0,577,141,141,57,58,0,0,0,0,535,577,0,0,0,0],[0,0,0,531,532,533,574,57,58,0,59,0,0,535,536,0,0,62,0],[0,0,0,531,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,578,151,0,0,137,576,0,58,0,59,0,0,0,139,0,578,0,0],[0,479,0,0,0,246,246,0,58,0,59,0,0,0,139,0,479,0,0],[0,479,0,537,0,246,246,0,58,0,59,0,0,0,139,0,479,0,0],[0,0,0,573,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,0,0,0,577,141,141,57,58,0,0,0,0,542,577,0,0,0,0],[0,0,0,539,532,540,574,57,58,0,59,0,0,542,536,0,0,62,0],[0,0,0,539,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,137,0,0],[0,0,0,0,0,0,0,442,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,439,0,0],[0,0,0,0,0,579,579,494,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,580,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,549,368,550,0,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,368,368,0,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,581,0,0,0,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,0,0,0,555,80,80,22,23,0,0,0,0,0,555,0,0,0,0],[0,0,0,582,91,583,584,22,23,0,24,0,0,585,93,0,0,27,0],[0,553,0,586,0,177,177,22,23,0,24,0,0,0,78,0,553,0,0],[0,553,0,0,0,175,587,0,23,0,24,0,0,0,78,0,553,0,0],[0,0,0,588,91,589,590,22,23,0,24,0,0,591,93,0,0,27,0],[0,0,0,0,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,0,0,0,561,101,101,32,33,0,0,0,0,0,561,0,0,0,0],[0,0,0,592,112,593,594,32,33,0,34,0,0,595,114,0,0,37,0],[0,559,0,596,0,203,203,32,33,0,34,0,0,0,99,0,559,0,0],[0,559,0,0,0,201,597,0,33,0,34,0,0,0,99,0,559,0,0],[0,0,0,598,112,599,600,32,33,0,34,0,0,601,114,0,0,37,0],[0,0,0,602,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,0,165,44,44,8,9,0,0,0,0,566,165,0,0,0,0],[0,0,0,563,66,564,67,8,9,0,10,0,0,566,68,0,0,16,0],[0,0,0,563,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,527,0,0,0,121,121,0,9,0,10,0,0,0,42,0,527,0,0],[0,527,0,567,0,121,121,0,9,0,10,0,0,0,42,0,527,0,0],[0,0,0,602,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,0,165,44,44,8,9,0,0,0,0,572,165,0,0,0,0],[0,0,0,569,66,570,67,8,9,0,10,0,0,572,68,0,0,16,0],[0,0,0,569,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,0,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,0,0,0,577,141,141,57,58,0,0,0,0,0,577,0,0,0,0],[0,0,0,603,152,604,605,57,58,0,59,0,0,606,154,0,0,62,0],[0,575,0,607,0,248,248,57,58,0,59,0,0,0,139,0,575,0,0],[0,575,0,0,0,246,608,0,58,0,59,0,0,0,139,0,575,0,0],[0,0,0,609,152,610,611,57,58,0,59,0,0,612,154,0,0,62,0],[0,0,0,0,0,0,0,494,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,491,0,0],[0,0,0,0,0,0,613,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,614,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,0,194,80,80,22,23,0,0,0,0,585,194,0,0,0,0],[0,0,0,582,91,583,92,22,23,0,24,0,0,585,93,0,0,27,0],[0,0,0,582,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,553,0,0,0,175,175,0,23,0,24,0,0,0,78,0,553,0,0],[0,553,0,586,0,175,175,0,23,0,24,0,0,0,78,0,553,0,0],[0,0,0,614,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,0,194,80,80,22,23,0,0,0,0,591,194,0,0,0,0],[0,0,0,588,91,589,92,22,23,0,24,0,0,591,93,0,0,27,0],[0,0,0,588,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,615,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,220,101,101,32,33,0,0,0,0,595,220,0,0,0,0],[0,0,0,592,112,593,113,32,33,0,34,0,0,595,114,0,0,37,0],[0,0,0,592,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,559,0,0,0,201,201,0,33,0,34,0,0,0,99,0,559,0,0],[0,559,0,596,0,201,201,0,33,0,34,0,0,0,99,0,559,0,0],[0,0,0,615,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,220,101,101,32,33,0,0,0,0,601,220,0,0,0,0],[0,0,0,598,112,599,113,32,33,0,34,0,0,601,114,0,0,37,0],[0,0,0,598,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,616,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,0,0,0,265,141,141,57,58,0,0,0,0,606,265,0,0,0,0],[0,0,0,603,152,604,153,57,58,0,59,0,0,606,154,0,0,62,0],[0,0,0,603,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,575,0,0,0,246,246,0,58,0,59,0,0,0,139,0,575,0,0],[0,575,0,607,0,246,246,0,58,0,59,0,0,0,139,0,575,0,0],[0,0,0,616,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,0,0,0,265,141,141,57,58,0,0,0,0,612,265,0,0,0,0],[0,0,0,609,152,610,153,57,58,0,59,0,0,612,154,0,0,62,0],[0,0,0,609,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,549,0,0],[0,0,0,0,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,0,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0]],\"accepting\":[false,true,true,true,true,true,false,false,true,true,true,true,true,true,true,true,true,true,true,true,false,true,true,true,true,true,true,true,true,true,false,true,true,true,true,true,true,true,true,true,true,true,false,true,false,true,true,false,false,true,true,true,true,true,true,false,false,true,true,true,true,true,true,true,true,true,true,false,true,true,false,true,true,true,false,true,true,true,false,true,false,true,true,false,false,true,true,true,true,true,true,true,false,true,true,false,true,true,true,false,true,false,true,true,false,false,true,true,true,true,true,true,true,false,true,true,true,false,true,true,true,false,true,false,true,true,false,false,false,true,true,false,false,true,true,true,true,true,true,false,true,false,true,true,false,false,true,true,true,true,true,true,true,false,true,true,false,true,true,true,true,true,true,true,true,true,true,true,true,true,true,false,true,true,true,false,true,false,true,true,false,false,false,true,true,false,false,true,true,true,false,true,true,true,true,true,true,false,true,true,true,false,true,false,true,true,false,false,false,true,true,false,false,true,true,true,false,true,true,true,true,true,false,true,true,true,true,true,false,true,true,false,false,false,false,true,true,false,false,true,true,true,false,true,true,true,false,true,false,true,true,false,false,false,true,true,false,false,true,true,true,false,true,true,true,true,false,true,false,true,true,true,true,true,true,true,true,true,false,true,true,true,true,true,false,true,true,false,false,false,false,true,true,false,false,true,true,true,false,true,true,true,true,true,false,true,true,false,false,false,false,true,true,false,false,true,true,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,true,false,true,false,true,true,true,true,true,false,true,true,false,false,false,false,true,true,false,false,true,true,true,false,true,true,false,false,true,false,true,true,false,true,true,false,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,true,false,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,true,false,true,false,true,true,true,true,false,false,false,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,true,false,true,false,true,true,false,false,true,true,false,false,true,true,true,false,true,false,true,true,true,true,false,false,false,true,false,true,true,true,true,false,false,false,true,true,false,true,true,true,true,true,true,false,true,true,false,true,false,true,true,true,true,false,false,false,false,false,false,false,true,true,false,false,true,true,false,true,true,true,true,false,true,true,true,true,true,true,false,true,true,false,true,true,false,true,true,true,true,true,true,false,true,true,false,true,false,true,true,true,true,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,false,true,true,false,true,false,true,true,true,true,true,false,true,true,true,true,true,false,true,true,true,true,true,false,true,true,true,false,true,true,true,true,false,false,false,true,false,true,true,true,true,true,false,true,true,true,false,true,true,true,true,true,false,true,true,true,true,false,true,true,true,true,true,false,true,true,false,true,true,true],\"tags\":[[],[\"broken_cluster\"],[\"consonant_syllable\"],[\"vowel_syllable\"],[\"broken_cluster\"],[\"broken_cluster\"],[],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"standalone_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"consonant_syllable\"],[\"broken_cluster\"],[\"symbol_cluster\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"symbol_cluster\"],[],[\"symbol_cluster\"],[\"symbol_cluster\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"broken_cluster\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[],[],[],[\"broken_cluster\"],[\"broken_cluster\"],[],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"symbol_cluster\"],[\"symbol_cluster\"],[\"symbol_cluster\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[],[],[],[],[\"broken_cluster\"],[\"broken_cluster\"],[],[],[\"broken_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"broken_cluster\"],[],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[\"broken_cluster\"],[\"symbol_cluster\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[],[],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[],[],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"broken_cluster\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[],[],[],[],[\"broken_cluster\"],[],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[],[],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[],[],[\"consonant_syllable\",\"broken_cluster\"],[],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[],[],[],[\"consonant_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[],[],[],[\"vowel_syllable\"],[],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[],[],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[],[],[],[\"standalone_cluster\"],[],[\"consonant_syllable\",\"broken_cluster\"],[],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[],[],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[],[],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[],[],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[],[],[\"broken_cluster\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[],[],[],[],[],[],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[],[],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[],[],[],[],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[],[],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"broken_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"consonant_syllable\"],[\"vowel_syllable\"],[\"standalone_cluster\"]]}");
var $6d519e6f260f4e02$var$$aa333a9607471296$exports = {};
$6d519e6f260f4e02$var$$aa333a9607471296$exports = JSON.parse("{\"categories\":[\"O\",\"IND\",\"S\",\"GB\",\"B\",\"FM\",\"CGJ\",\"VMAbv\",\"VMPst\",\"VAbv\",\"VPst\",\"CMBlw\",\"VPre\",\"VBlw\",\"H\",\"VMBlw\",\"CMAbv\",\"MBlw\",\"CS\",\"R\",\"SUB\",\"MPst\",\"MPre\",\"FAbv\",\"FPst\",\"FBlw\",\"null\",\"SMAbv\",\"SMBlw\",\"VMPre\",\"ZWNJ\",\"ZWJ\",\"WJ\",\"M\",\"VS\",\"N\",\"HN\",\"MAbv\"],\"decompositions\":{\"2507\":[2503,2494],\"2508\":[2503,2519],\"2888\":[2887,2902],\"2891\":[2887,2878],\"2892\":[2887,2903],\"3018\":[3014,3006],\"3019\":[3015,3006],\"3020\":[3014,3031],\"3144\":[3142,3158],\"3264\":[3263,3285],\"3271\":[3270,3285],\"3272\":[3270,3286],\"3274\":[3270,3266],\"3275\":[3270,3266,3285],\"3402\":[3398,3390],\"3403\":[3399,3390],\"3404\":[3398,3415],\"3546\":[3545,3530],\"3548\":[3545,3535],\"3549\":[3545,3535,3530],\"3550\":[3545,3551],\"3635\":[3661,3634],\"3763\":[3789,3762],\"3955\":[3953,3954],\"3957\":[3953,3956],\"3958\":[4018,3968],\"3959\":[4018,3953,3968],\"3960\":[4019,3968],\"3961\":[4019,3953,3968],\"3969\":[3953,3968],\"6971\":[6970,6965],\"6973\":[6972,6965],\"6976\":[6974,6965],\"6977\":[6975,6965],\"6979\":[6978,6965],\"69934\":[69937,69927],\"69935\":[69938,69927],\"70475\":[70471,70462],\"70476\":[70471,70487],\"70843\":[70841,70842],\"70844\":[70841,70832],\"70846\":[70841,70845],\"71098\":[71096,71087],\"71099\":[71097,71087]},\"stateTable\":[[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[2,2,3,4,4,5,0,6,7,8,9,10,11,12,13,14,15,16,0,17,18,11,19,20,21,22,0,0,0,23,0,0,2,0,0,24,0,25],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,26,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,27,28,0,0,0,0,0,27,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,34,35,36,37,38,39,40,0,0,41,35,42,43,44,45,0,0,0,46,0,0,0,0,39,0,0,47],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,0,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,7,0,0,0,0,0,0,0,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,0,0,12,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,9,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,10,11,12,13,14,0,16,0,0,18,11,19,20,21,22,0,0,0,23,0,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,9,0,0,12,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,0,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,7,0,0,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,10,11,12,13,14,15,16,0,0,18,11,19,20,21,22,0,0,0,23,0,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,0,0,0,0,11,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,4,4,5,0,6,7,8,9,10,11,12,13,14,15,16,0,0,18,11,19,20,21,22,0,0,0,23,0,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,48,11,12,13,14,48,16,0,0,18,11,19,20,21,22,0,0,0,23,0,0,0,0,49,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,16,0,0,0,11,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,21,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,21,22,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,0,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,50,0,51,0],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,16,0,0,0,11,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,27,28,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,28,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,0,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,31,0,0,0,0,0,0,0,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,0,0,36,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,33,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,34,35,36,37,38,0,40,0,0,41,35,42,43,44,45,0,0,0,46,0,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,33,0,0,36,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,41,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,31,0,0,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,34,35,36,37,38,39,40,0,0,41,35,42,43,44,45,0,0,0,46,0,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,0,0,0,0,35,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,52,35,36,37,38,52,40,0,0,41,35,42,43,44,45,0,0,0,46,0,0,0,0,53,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,40,0,0,0,35,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,44,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,44,45,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,0,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,40,0,0,0,35,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,48,11,12,13,14,0,16,0,0,18,11,19,20,21,22,0,0,0,23,0,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,48,11,12,13,14,48,16,0,0,18,11,19,20,21,22,0,0,0,23,0,0,0,0,0,0,0,25],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,51,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,54,0,0],[0,0,0,0,0,29,0,30,31,32,33,52,35,36,37,38,0,40,0,0,41,35,42,43,44,45,0,0,0,46,0,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,52,35,36,37,38,52,40,0,0,41,35,42,43,44,45,0,0,0,46,0,0,0,0,0,0,0,47],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,50,0,51,0]],\"accepting\":[false,true,true,true,true,true,true,true,true,true,true,true,true,false,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true],\"tags\":[[],[\"broken_cluster\"],[\"independent_cluster\"],[\"symbol_cluster\"],[\"standard_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"numeral_cluster\"],[\"broken_cluster\"],[\"independent_cluster\"],[\"symbol_cluster\"],[\"symbol_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"virama_terminated_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"numeral_cluster\"],[\"number_joiner_terminated_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"numeral_cluster\"]]}");
// Cateories used in the OpenType spec:
// https://www.microsoft.com/typography/otfntdev/devanot/shaping.aspx
const $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$a513ea61a7bee91c = {
    X: 1,
    C: 2,
    V: 4,
    N: 8,
    H: 16,
    ZWNJ: 32,
    ZWJ: 64,
    M: 128,
    SM: 256,
    VD: 512,
    A: 1024,
    Placeholder: 2048,
    Dotted_Circle: 4096,
    RS: 8192,
    Coeng: 16384,
    Repha: 32768,
    Ra: 65536,
    CM: 131072,
    Symbol: 262144 // Avagraha, etc that take marks (SM,A,VD).
};
const $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0 = {
    Start: 1,
    Ra_To_Become_Reph: 2,
    Pre_M: 4,
    Pre_C: 8,
    Base_C: 16,
    After_Main: 32,
    Above_C: 64,
    Before_Sub: 128,
    Below_C: 256,
    After_Sub: 512,
    Before_Post: 1024,
    Post_C: 2048,
    After_Post: 4096,
    Final_C: 8192,
    SMVD: 16384,
    End: 32768
};
const $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$8519deaa7de2b07 = $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$a513ea61a7bee91c.C | $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$a513ea61a7bee91c.Ra | $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$a513ea61a7bee91c.CM | $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$a513ea61a7bee91c.V | $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$a513ea61a7bee91c.Placeholder | $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$a513ea61a7bee91c.Dotted_Circle;
const $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$bbcd928767338e0d = $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$a513ea61a7bee91c.ZWJ | $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$a513ea61a7bee91c.ZWNJ;
const $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$ca9599b2a300afc = $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$a513ea61a7bee91c.H | $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$a513ea61a7bee91c.Coeng;
const $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$e99d119da76a0fc5 = {
    Default: {
        hasOldSpec: false,
        virama: 0,
        basePos: 'Last',
        rephPos: $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Before_Post,
        rephMode: 'Implicit',
        blwfMode: 'Pre_And_Post'
    },
    Devanagari: {
        hasOldSpec: true,
        virama: 0x094D,
        basePos: 'Last',
        rephPos: $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Before_Post,
        rephMode: 'Implicit',
        blwfMode: 'Pre_And_Post'
    },
    Bengali: {
        hasOldSpec: true,
        virama: 0x09CD,
        basePos: 'Last',
        rephPos: $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.After_Sub,
        rephMode: 'Implicit',
        blwfMode: 'Pre_And_Post'
    },
    Gurmukhi: {
        hasOldSpec: true,
        virama: 0x0A4D,
        basePos: 'Last',
        rephPos: $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Before_Sub,
        rephMode: 'Implicit',
        blwfMode: 'Pre_And_Post'
    },
    Gujarati: {
        hasOldSpec: true,
        virama: 0x0ACD,
        basePos: 'Last',
        rephPos: $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Before_Post,
        rephMode: 'Implicit',
        blwfMode: 'Pre_And_Post'
    },
    Oriya: {
        hasOldSpec: true,
        virama: 0x0B4D,
        basePos: 'Last',
        rephPos: $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.After_Main,
        rephMode: 'Implicit',
        blwfMode: 'Pre_And_Post'
    },
    Tamil: {
        hasOldSpec: true,
        virama: 0x0BCD,
        basePos: 'Last',
        rephPos: $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.After_Post,
        rephMode: 'Implicit',
        blwfMode: 'Pre_And_Post'
    },
    Telugu: {
        hasOldSpec: true,
        virama: 0x0C4D,
        basePos: 'Last',
        rephPos: $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.After_Post,
        rephMode: 'Explicit',
        blwfMode: 'Post_Only'
    },
    Kannada: {
        hasOldSpec: true,
        virama: 0x0CCD,
        basePos: 'Last',
        rephPos: $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.After_Post,
        rephMode: 'Implicit',
        blwfMode: 'Post_Only'
    },
    Malayalam: {
        hasOldSpec: true,
        virama: 0x0D4D,
        basePos: 'Last',
        rephPos: $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.After_Main,
        rephMode: 'Log_Repha',
        blwfMode: 'Pre_And_Post'
    },
    // Handled by UniversalShaper
    // Sinhala: {
    //   hasOldSpec: false,
    //   virama: 0x0DCA,
    //   basePos: 'Last_Sinhala',
    //   rephPos: POSITIONS.After_Main,
    //   rephMode: 'Explicit',
    //   blwfMode: 'Pre_And_Post'
    // },
    Khmer: {
        hasOldSpec: false,
        virama: 0x17D2,
        basePos: 'First',
        rephPos: $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Ra_To_Become_Reph,
        rephMode: 'Vis_Repha',
        blwfMode: 'Pre_And_Post'
    }
};
const $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$f647c9cfdd77d95a = {
    // Khmer
    0x17BE: [
        0x17C1,
        0x17BE
    ],
    0x17BF: [
        0x17C1,
        0x17BF
    ],
    0x17C0: [
        0x17C1,
        0x17C0
    ],
    0x17C4: [
        0x17C1,
        0x17C4
    ],
    0x17C5: [
        0x17C1,
        0x17C5
    ]
};
const { decompositions: $6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$decompositions } = /*@__PURE__*/ $6d519e6f260f4e02$var$$parcel$interopDefault($6d519e6f260f4e02$var$$aa333a9607471296$exports);
const $6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$trie = new (0, (/*@__PURE__*/$parcel$interopDefault($82c8d86aa310da61$exports)))($6d519e6f260f4e02$var$$12727730ddfc8bfe$export$94fdf11bafc8de6b("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"));
const $6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$stateMachine = new (0, (/*@__PURE__*/$parcel$interopDefault($c6d6097ed0788124$exports)))(/*@__PURE__*/ $6d519e6f260f4e02$var$$parcel$interopDefault($6d519e6f260f4e02$var$$4b0735ca6c692ea5$exports));
class $6d519e6f260f4e02$var$$7826f90f6f0cecc9$export$2e2bcd8739ae039 extends $6d519e6f260f4e02$var$$649970d87335b30f$export$2e2bcd8739ae039 {
    static planFeatures(plan) {
        plan.addStage($6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$setupSyllables);
        plan.addStage([
            'locl',
            'ccmp'
        ]);
        plan.addStage($6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$initialReordering);
        plan.addStage('nukt');
        plan.addStage('akhn');
        plan.addStage('rphf', false);
        plan.addStage('rkrf');
        plan.addStage('pref', false);
        plan.addStage('blwf', false);
        plan.addStage('abvf', false);
        plan.addStage('half', false);
        plan.addStage('pstf', false);
        plan.addStage('vatu');
        plan.addStage('cjct');
        plan.addStage('cfar', false);
        plan.addStage($6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$finalReordering);
        plan.addStage({
            local: [
                'init'
            ],
            global: [
                'pres',
                'abvs',
                'blws',
                'psts',
                'haln',
                'dist',
                'abvm',
                'blwm',
                'calt',
                'clig'
            ]
        });
        // Setup the indic config for the selected script
        plan.unicodeScript = $6d519e6f260f4e02$var$$130d1a642ebcd2b7$export$ce50e82f12a827a4(plan.script);
        plan.indicConfig = $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$e99d119da76a0fc5[plan.unicodeScript] || $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$e99d119da76a0fc5.Default;
        plan.isOldSpec = plan.indicConfig.hasOldSpec && plan.script[plan.script.length - 1] !== '2';
    // TODO: turn off kern (Khmer) and liga features.
    }
    static assignFeatures(plan, glyphs) {
        // Decompose split matras
        // TODO: do this in a more general unicode normalizer
        for(let i = glyphs.length - 1; i >= 0; i--){
            let codepoint = glyphs[i].codePoints[0];
            let d = $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$f647c9cfdd77d95a[codepoint] || $6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$decompositions[codepoint];
            if (d) {
                let decomposed = d.map((c)=>{
                    let g = plan.font.glyphForCodePoint(c);
                    return new $6d519e6f260f4e02$var$$10e7b257e1a9a756$export$2e2bcd8739ae039(plan.font, g.id, [
                        c
                    ], glyphs[i].features);
                });
                glyphs.splice(i, 1, ...decomposed);
            }
        }
    }
}
(0, $1d8e073d1256147c$export$71511d61b312f219)($6d519e6f260f4e02$var$$7826f90f6f0cecc9$export$2e2bcd8739ae039, "zeroMarkWidths", 'NONE');
function $6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$indicCategory(glyph) {
    return $6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$trie.get(glyph.codePoints[0]) >> 8;
}
function $6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$indicPosition(glyph) {
    return 1 << ($6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$trie.get(glyph.codePoints[0]) & 0xff);
}
class $6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$IndicInfo {
    constructor(category, position, syllableType, syllable){
        this.category = category;
        this.position = position;
        this.syllableType = syllableType;
        this.syllable = syllable;
    }
}
function $6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$setupSyllables(font, glyphs) {
    let syllable = 0;
    let last = 0;
    for (let [start, end, tags] of $6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$stateMachine.match(glyphs.map($6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$indicCategory))){
        if (start > last) {
            ++syllable;
            for(let i = last; i < start; i++)glyphs[i].shaperInfo = new $6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$IndicInfo($6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$a513ea61a7bee91c.X, $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.End, 'non_indic_cluster', syllable);
        }
        ++syllable;
        // Create shaper info
        for(let i = start; i <= end; i++)glyphs[i].shaperInfo = new $6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$IndicInfo(1 << $6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$indicCategory(glyphs[i]), $6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$indicPosition(glyphs[i]), tags[0], syllable);
        last = end + 1;
    }
    if (last < glyphs.length) {
        ++syllable;
        for(let i = last; i < glyphs.length; i++)glyphs[i].shaperInfo = new $6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$IndicInfo($6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$a513ea61a7bee91c.X, $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.End, 'non_indic_cluster', syllable);
    }
}
function $6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$isConsonant(glyph) {
    return glyph.shaperInfo.category & $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$8519deaa7de2b07;
}
function $6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$isJoiner(glyph) {
    return glyph.shaperInfo.category & $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$bbcd928767338e0d;
}
function $6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$isHalantOrCoeng(glyph) {
    return glyph.shaperInfo.category & $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$ca9599b2a300afc;
}
function $6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$wouldSubstitute(glyphs, feature) {
    for (let glyph of glyphs)glyph.features = {
        [feature]: true
    };
    let GSUB = glyphs[0]._font._layoutEngine.engine.GSUBProcessor;
    GSUB.applyFeatures([
        feature
    ], glyphs);
    return glyphs.length === 1;
}
function $6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$consonantPosition(font, consonant, virama) {
    let glyphs = [
        virama,
        consonant,
        virama
    ];
    if ($6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$wouldSubstitute(glyphs.slice(0, 2), 'blwf') || $6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$wouldSubstitute(glyphs.slice(1, 3), 'blwf')) return $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Below_C;
    else if ($6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$wouldSubstitute(glyphs.slice(0, 2), 'pstf') || $6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$wouldSubstitute(glyphs.slice(1, 3), 'pstf')) return $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Post_C;
    else if ($6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$wouldSubstitute(glyphs.slice(0, 2), 'pref') || $6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$wouldSubstitute(glyphs.slice(1, 3), 'pref')) return $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Post_C;
    return $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Base_C;
}
function $6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$initialReordering(font, glyphs, plan) {
    let indicConfig = plan.indicConfig;
    let features = font._layoutEngine.engine.GSUBProcessor.features;
    let dottedCircle = font.glyphForCodePoint(0x25cc).id;
    let virama = font.glyphForCodePoint(indicConfig.virama).id;
    if (virama) {
        let info = new $6d519e6f260f4e02$var$$10e7b257e1a9a756$export$2e2bcd8739ae039(font, virama, [
            indicConfig.virama
        ]);
        for(let i = 0; i < glyphs.length; i++)if (glyphs[i].shaperInfo.position === $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Base_C) glyphs[i].shaperInfo.position = $6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$consonantPosition(font, glyphs[i].copy(), info);
    }
    for(let start = 0, end = $6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$nextSyllable(glyphs, 0); start < glyphs.length; start = end, end = $6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$nextSyllable(glyphs, start)){
        let { category: category, syllableType: syllableType } = glyphs[start].shaperInfo;
        if (syllableType === 'symbol_cluster' || syllableType === 'non_indic_cluster') continue;
        if (syllableType === 'broken_cluster' && dottedCircle) {
            let g = new $6d519e6f260f4e02$var$$10e7b257e1a9a756$export$2e2bcd8739ae039(font, dottedCircle, [
                0x25cc
            ]);
            g.shaperInfo = new $6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$IndicInfo(1 << $6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$indicCategory(g), $6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$indicPosition(g), glyphs[start].shaperInfo.syllableType, glyphs[start].shaperInfo.syllable);
            // Insert after possible Repha.
            let i = start;
            while(i < end && glyphs[i].shaperInfo.category === $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$a513ea61a7bee91c.Repha)i++;
            glyphs.splice(i++, 0, g);
            end++;
        }
        // 1. Find base consonant:
        //
        // The shaping engine finds the base consonant of the syllable, using the
        // following algorithm: starting from the end of the syllable, move backwards
        // until a consonant is found that does not have a below-base or post-base
        // form (post-base forms have to follow below-base forms), or that is not a
        // pre-base reordering Ra, or arrive at the first consonant. The consonant
        // stopped at will be the base.
        let base = end;
        let limit = start;
        let hasReph = false;
        // If the syllable starts with Ra + Halant (in a script that has Reph)
        // and has more than one consonant, Ra is excluded from candidates for
        // base consonants.
        if (indicConfig.rephPos !== $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Ra_To_Become_Reph && features.rphf && start + 3 <= end && (indicConfig.rephMode === 'Implicit' && !$6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$isJoiner(glyphs[start + 2]) || indicConfig.rephMode === 'Explicit' && glyphs[start + 2].shaperInfo.category === $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$a513ea61a7bee91c.ZWJ)) {
            // See if it matches the 'rphf' feature.
            let g = [
                glyphs[start].copy(),
                glyphs[start + 1].copy(),
                glyphs[start + 2].copy()
            ];
            if ($6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$wouldSubstitute(g.slice(0, 2), 'rphf') || indicConfig.rephMode === 'Explicit' && $6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$wouldSubstitute(g, 'rphf')) {
                limit += 2;
                while(limit < end && $6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$isJoiner(glyphs[limit]))limit++;
                base = start;
                hasReph = true;
            }
        } else if (indicConfig.rephMode === 'Log_Repha' && glyphs[start].shaperInfo.category === $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$a513ea61a7bee91c.Repha) {
            limit++;
            while(limit < end && $6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$isJoiner(glyphs[limit]))limit++;
            base = start;
            hasReph = true;
        }
        switch(indicConfig.basePos){
            case 'Last':
                {
                    // starting from the end of the syllable, move backwards
                    let i = end;
                    let seenBelow = false;
                    do {
                        let info = glyphs[--i].shaperInfo;
                        // until a consonant is found
                        if ($6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$isConsonant(glyphs[i])) {
                            // that does not have a below-base or post-base form
                            // (post-base forms have to follow below-base forms),
                            if (info.position !== $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Below_C && (info.position !== $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Post_C || seenBelow)) {
                                base = i;
                                break;
                            }
                            // or that is not a pre-base reordering Ra,
                            //
                            // IMPLEMENTATION NOTES:
                            //
                            // Our pre-base reordering Ra's are marked POS_POST_C, so will be skipped
                            // by the logic above already.
                            //
                            // or arrive at the first consonant. The consonant stopped at will
                            // be the base.
                            if (info.position === $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Below_C) seenBelow = true;
                            base = i;
                        } else if (start < i && info.category === $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$a513ea61a7bee91c.ZWJ && glyphs[i - 1].shaperInfo.category === $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$a513ea61a7bee91c.H) break;
                    }while (i > limit);
                    break;
                }
            case 'First':
                // The first consonant is always the base.
                base = start;
                // Mark all subsequent consonants as below.
                for(let i = base + 1; i < end; i++)if ($6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$isConsonant(glyphs[i])) glyphs[i].shaperInfo.position = $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Below_C;
        }
        // If the syllable starts with Ra + Halant (in a script that has Reph)
        // and has more than one consonant, Ra is excluded from candidates for
        // base consonants.
        //
        //  Only do this for unforced Reph. (ie. not for Ra,H,ZWJ)
        if (hasReph && base === start && limit - base <= 2) hasReph = false;
        // 2. Decompose and reorder Matras:
        //
        // Each matra and any syllable modifier sign in the cluster are moved to the
        // appropriate position relative to the consonant(s) in the cluster. The
        // shaping engine decomposes two- or three-part matras into their constituent
        // parts before any repositioning. Matra characters are classified by which
        // consonant in a conjunct they have affinity for and are reordered to the
        // following positions:
        //
        //   o Before first half form in the syllable
        //   o After subjoined consonants
        //   o After post-form consonant
        //   o After main consonant (for above marks)
        //
        // IMPLEMENTATION NOTES:
        //
        // The normalize() routine has already decomposed matras for us, so we don't
        // need to worry about that.
        // 3.  Reorder marks to canonical order:
        //
        // Adjacent nukta and halant or nukta and vedic sign are always repositioned
        // if necessary, so that the nukta is first.
        //
        // IMPLEMENTATION NOTES:
        //
        // We don't need to do this: the normalize() routine already did this for us.
        // Reorder characters
        for(let i = start; i < base; i++){
            let info = glyphs[i].shaperInfo;
            info.position = Math.min($6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Pre_C, info.position);
        }
        if (base < end) glyphs[base].shaperInfo.position = $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Base_C;
        // Mark final consonants.  A final consonant is one appearing after a matra,
        // like in Khmer.
        for(let i = base + 1; i < end; i++)if (glyphs[i].shaperInfo.category === $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$a513ea61a7bee91c.M) {
            for(let j = i + 1; j < end; j++)if ($6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$isConsonant(glyphs[j])) {
                glyphs[j].shaperInfo.position = $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Final_C;
                break;
            }
            break;
        }
        // Handle beginning Ra
        if (hasReph) glyphs[start].shaperInfo.position = $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Ra_To_Become_Reph;
        // For old-style Indic script tags, move the first post-base Halant after
        // last consonant.
        //
        // Reports suggest that in some scripts Uniscribe does this only if there
        // is *not* a Halant after last consonant already (eg. Kannada), while it
        // does it unconditionally in other scripts (eg. Malayalam).  We don't
        // currently know about other scripts, so we single out Malayalam for now.
        //
        // Kannada test case:
        // U+0C9A,U+0CCD,U+0C9A,U+0CCD
        // With some versions of Lohit Kannada.
        // https://bugs.freedesktop.org/show_bug.cgi?id=59118
        //
        // Malayalam test case:
        // U+0D38,U+0D4D,U+0D31,U+0D4D,U+0D31,U+0D4D
        // With lohit-ttf-20121122/Lohit-Malayalam.ttf
        if (plan.isOldSpec) {
            let disallowDoubleHalants = plan.unicodeScript !== 'Malayalam';
            for(let i = base + 1; i < end; i++)if (glyphs[i].shaperInfo.category === $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$a513ea61a7bee91c.H) {
                let j;
                for(j = end - 1; j > i; j--){
                    if ($6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$isConsonant(glyphs[j]) || disallowDoubleHalants && glyphs[j].shaperInfo.category === $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$a513ea61a7bee91c.H) break;
                }
                if (glyphs[j].shaperInfo.category !== $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$a513ea61a7bee91c.H && j > i) {
                    // Move Halant to after last consonant.
                    let t = glyphs[i];
                    glyphs.splice(i, 0, ...glyphs.splice(i + 1, j - i));
                    glyphs[j] = t;
                }
                break;
            }
        }
        // Attach misc marks to previous char to move with them.
        let lastPos = $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Start;
        for(let i = start; i < end; i++){
            let info = glyphs[i].shaperInfo;
            if (info.category & ($6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$bbcd928767338e0d | $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$a513ea61a7bee91c.N | $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$a513ea61a7bee91c.RS | $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$a513ea61a7bee91c.CM | $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$ca9599b2a300afc & info.category)) {
                info.position = lastPos;
                if (info.category === $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$a513ea61a7bee91c.H && info.position === $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Pre_M) {
                    // Uniscribe doesn't move the Halant with Left Matra.
                    // TEST: U+092B,U+093F,U+094DE
                    // We follow.  This is important for the Sinhala
                    // U+0DDA split matra since it decomposes to U+0DD9,U+0DCA
                    // where U+0DD9 is a left matra and U+0DCA is the virama.
                    // We don't want to move the virama with the left matra.
                    // TEST: U+0D9A,U+0DDA
                    for(let j = i; j > start; j--)if (glyphs[j - 1].shaperInfo.position !== $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Pre_M) {
                        info.position = glyphs[j - 1].shaperInfo.position;
                        break;
                    }
                }
            } else if (info.position !== $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.SMVD) lastPos = info.position;
        }
        // For post-base consonants let them own anything before them
        // since the last consonant or matra.
        let last = base;
        for(let i = base + 1; i < end; i++){
            if ($6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$isConsonant(glyphs[i])) {
                for(let j = last + 1; j < i; j++)if (glyphs[j].shaperInfo.position < $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.SMVD) glyphs[j].shaperInfo.position = glyphs[i].shaperInfo.position;
                last = i;
            } else if (glyphs[i].shaperInfo.category === $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$a513ea61a7bee91c.M) last = i;
        }
        let arr = glyphs.slice(start, end);
        arr.sort((a, b)=>a.shaperInfo.position - b.shaperInfo.position);
        glyphs.splice(start, arr.length, ...arr);
        // Find base again
        for(let i = start; i < end; i++)if (glyphs[i].shaperInfo.position === $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Base_C) {
            base = i;
            break;
        }
        // Setup features now
        // Reph
        for(let i = start; i < end && glyphs[i].shaperInfo.position === $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Ra_To_Become_Reph; i++)glyphs[i].features.rphf = true;
        // Pre-base
        let blwf = !plan.isOldSpec && indicConfig.blwfMode === 'Pre_And_Post';
        for(let i = start; i < base; i++){
            glyphs[i].features.half = true;
            if (blwf) glyphs[i].features.blwf = true;
        }
        // Post-base
        for(let i = base + 1; i < end; i++){
            glyphs[i].features.abvf = true;
            glyphs[i].features.pstf = true;
            glyphs[i].features.blwf = true;
        }
        if (plan.isOldSpec && plan.unicodeScript === 'Devanagari') {
            // Old-spec eye-lash Ra needs special handling.  From the
            // spec:
            //
            // "The feature 'below-base form' is applied to consonants
            // having below-base forms and following the base consonant.
            // The exception is vattu, which may appear below half forms
            // as well as below the base glyph. The feature 'below-base
            // form' will be applied to all such occurrences of Ra as well."
            //
            // Test case: U+0924,U+094D,U+0930,U+094d,U+0915
            // with Sanskrit 2003 font.
            //
            // However, note that Ra,Halant,ZWJ is the correct way to
            // request eyelash form of Ra, so we wouldbn't inhibit it
            // in that sequence.
            //
            // Test case: U+0924,U+094D,U+0930,U+094d,U+200D,U+0915
            for(let i = start; i + 1 < base; i++)if (glyphs[i].shaperInfo.category === $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$a513ea61a7bee91c.Ra && glyphs[i + 1].shaperInfo.category === $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$a513ea61a7bee91c.H && (i + 1 === base || glyphs[i + 2].shaperInfo.category === $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$a513ea61a7bee91c.ZWJ)) {
                glyphs[i].features.blwf = true;
                glyphs[i + 1].features.blwf = true;
            }
        }
        let prefLen = 2;
        if (features.pref && base + prefLen < end) for(let i = base + 1; i + prefLen - 1 < end; i++){
            let g = [
                glyphs[i].copy(),
                glyphs[i + 1].copy()
            ];
            if ($6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$wouldSubstitute(g, 'pref')) {
                for(let j = 0; j < prefLen; j++)glyphs[i++].features.pref = true;
                // Mark the subsequent stuff with 'cfar'.  Used in Khmer.
                // Read the feature spec.
                // This allows distinguishing the following cases with MS Khmer fonts:
                // U+1784,U+17D2,U+179A,U+17D2,U+1782
                // U+1784,U+17D2,U+1782,U+17D2,U+179A
                if (features.cfar) for(; i < end; i++)glyphs[i].features.cfar = true;
                break;
            }
        }
        // Apply ZWJ/ZWNJ effects
        for(let i = start + 1; i < end; i++)if ($6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$isJoiner(glyphs[i])) {
            let nonJoiner = glyphs[i].shaperInfo.category === $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$a513ea61a7bee91c.ZWNJ;
            let j = i;
            do {
                j--;
                // ZWJ/ZWNJ should disable CJCT.  They do that by simply
                // being there, since we don't skip them for the CJCT
                // feature (ie. F_MANUAL_ZWJ)
                // A ZWNJ disables HALF.
                if (nonJoiner) delete glyphs[j].features.half;
            }while (j > start && !$6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$isConsonant(glyphs[j]));
        }
    }
}
function $6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$finalReordering(font, glyphs, plan) {
    let indicConfig = plan.indicConfig;
    let features = font._layoutEngine.engine.GSUBProcessor.features;
    for(let start = 0, end = $6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$nextSyllable(glyphs, 0); start < glyphs.length; start = end, end = $6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$nextSyllable(glyphs, start)){
        // 4. Final reordering:
        //
        // After the localized forms and basic shaping forms GSUB features have been
        // applied (see below), the shaping engine performs some final glyph
        // reordering before applying all the remaining font features to the entire
        // cluster.
        let tryPref = !!features.pref;
        // Find base again
        let base = start;
        for(; base < end; base++)if (glyphs[base].shaperInfo.position >= $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Base_C) {
            if (tryPref && base + 1 < end) {
                for(let i = base + 1; i < end; i++)if (glyphs[i].features.pref) {
                    if (!(glyphs[i].substituted && glyphs[i].isLigated && !glyphs[i].isMultiplied)) {
                        // Ok, this was a 'pref' candidate but didn't form any.
                        // Base is around here...
                        base = i;
                        while(base < end && $6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$isHalantOrCoeng(glyphs[base]))base++;
                        glyphs[base].shaperInfo.position = $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.BASE_C;
                        tryPref = false;
                    }
                    break;
                }
            }
            // For Malayalam, skip over unformed below- (but NOT post-) forms.
            if (plan.unicodeScript === 'Malayalam') for(let i = base + 1; i < end; i++){
                while(i < end && $6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$isJoiner(glyphs[i]))i++;
                if (i === end || !$6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$isHalantOrCoeng(glyphs[i])) break;
                i++; // Skip halant.
                while(i < end && $6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$isJoiner(glyphs[i]))i++;
                if (i < end && $6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$isConsonant(glyphs[i]) && glyphs[i].shaperInfo.position === $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Below_C) {
                    base = i;
                    glyphs[base].shaperInfo.position = $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Base_C;
                }
            }
            if (start < base && glyphs[base].shaperInfo.position > $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Base_C) base--;
            break;
        }
        if (base === end && start < base && glyphs[base - 1].shaperInfo.category === $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$a513ea61a7bee91c.ZWJ) base--;
        if (base < end) while(start < base && glyphs[base].shaperInfo.category & ($6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$a513ea61a7bee91c.N | $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$ca9599b2a300afc))base--;
        // o Reorder matras:
        //
        // If a pre-base matra character had been reordered before applying basic
        // features, the glyph can be moved closer to the main consonant based on
        // whether half-forms had been formed. Actual position for the matra is
        // defined as “after last standalone halant glyph, after initial matra
        // position and before the main consonant”. If ZWJ or ZWNJ follow this
        // halant, position is moved after it.
        //
        if (start + 1 < end && start < base) {
            // If we lost track of base, alas, position before last thingy.
            let newPos = base === end ? base - 2 : base - 1;
            // Malayalam / Tamil do not have "half" forms or explicit virama forms.
            // The glyphs formed by 'half' are Chillus or ligated explicit viramas.
            // We want to position matra after them.
            if (plan.unicodeScript !== 'Malayalam' && plan.unicodeScript !== 'Tamil') {
                while(newPos > start && !(glyphs[newPos].shaperInfo.category & ($6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$a513ea61a7bee91c.M | $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$ca9599b2a300afc)))newPos--;
                // If we found no Halant we are done.
                // Otherwise only proceed if the Halant does
                // not belong to the Matra itself!
                if ($6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$isHalantOrCoeng(glyphs[newPos]) && glyphs[newPos].shaperInfo.position !== $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Pre_M) {
                    if (newPos + 1 < end && $6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$isJoiner(glyphs[newPos + 1])) newPos++;
                } else newPos = start; // No move.
            }
            if (start < newPos && glyphs[newPos].shaperInfo.position !== $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Pre_M) {
                // Now go see if there's actually any matras...
                for(let i = newPos; i > start; i--)if (glyphs[i - 1].shaperInfo.position === $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Pre_M) {
                    let oldPos = i - 1;
                    if (oldPos < base && base <= newPos) base--;
                    let tmp = glyphs[oldPos];
                    glyphs.splice(oldPos, 0, ...glyphs.splice(oldPos + 1, newPos - oldPos));
                    glyphs[newPos] = tmp;
                    newPos--;
                }
            }
        }
        // o Reorder reph:
        //
        // Reph’s original position is always at the beginning of the syllable,
        // (i.e. it is not reordered at the character reordering stage). However,
        // it will be reordered according to the basic-forms shaping results.
        // Possible positions for reph, depending on the script, are; after main,
        // before post-base consonant forms, and after post-base consonant forms.
        // Two cases:
        //
        // - If repha is encoded as a sequence of characters (Ra,H or Ra,H,ZWJ), then
        //   we should only move it if the sequence ligated to the repha form.
        //
        // - If repha is encoded separately and in the logical position, we should only
        //   move it if it did NOT ligate.  If it ligated, it's probably the font trying
        //   to make it work without the reordering.
        if (start + 1 < end && glyphs[start].shaperInfo.position === $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Ra_To_Become_Reph && glyphs[start].shaperInfo.category === $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$a513ea61a7bee91c.Repha !== (glyphs[start].isLigated && !glyphs[start].isMultiplied)) {
            let newRephPos;
            let rephPos = indicConfig.rephPos;
            let found = false;
            // 1. If reph should be positioned after post-base consonant forms,
            //    proceed to step 5.
            if (rephPos !== $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.After_Post) {
                //  2. If the reph repositioning class is not after post-base: target
                //     position is after the first explicit halant glyph between the
                //     first post-reph consonant and last main consonant. If ZWJ or ZWNJ
                //     are following this halant, position is moved after it. If such
                //     position is found, this is the target position. Otherwise,
                //     proceed to the next step.
                //
                //     Note: in old-implementation fonts, where classifications were
                //     fixed in shaping engine, there was no case where reph position
                //     will be found on this step.
                newRephPos = start + 1;
                while(newRephPos < base && !$6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$isHalantOrCoeng(glyphs[newRephPos]))newRephPos++;
                if (newRephPos < base && $6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$isHalantOrCoeng(glyphs[newRephPos])) {
                    // ->If ZWJ or ZWNJ are following this halant, position is moved after it.
                    if (newRephPos + 1 < base && $6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$isJoiner(glyphs[newRephPos + 1])) newRephPos++;
                    found = true;
                }
                // 3. If reph should be repositioned after the main consonant: find the
                //    first consonant not ligated with main, or find the first
                //    consonant that is not a potential pre-base reordering Ra.
                if (!found && rephPos === $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.After_Main) {
                    newRephPos = base;
                    while(newRephPos + 1 < end && glyphs[newRephPos + 1].shaperInfo.position <= $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.After_Main)newRephPos++;
                    found = newRephPos < end;
                }
                // 4. If reph should be positioned before post-base consonant, find
                //    first post-base classified consonant not ligated with main. If no
                //    consonant is found, the target position should be before the
                //    first matra, syllable modifier sign or vedic sign.
                //
                // This is our take on what step 4 is trying to say (and failing, BADLY).
                if (!found && rephPos === $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.After_Sub) {
                    newRephPos = base;
                    while(newRephPos + 1 < end && !(glyphs[newRephPos + 1].shaperInfo.position & ($6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Post_C | $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.After_Post | $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.SMVD)))newRephPos++;
                    found = newRephPos < end;
                }
            }
            //  5. If no consonant is found in steps 3 or 4, move reph to a position
            //     immediately before the first post-base matra, syllable modifier
            //     sign or vedic sign that has a reordering class after the intended
            //     reph position. For example, if the reordering position for reph
            //     is post-main, it will skip above-base matras that also have a
            //     post-main position.
            if (!found) {
                // Copied from step 2.
                newRephPos = start + 1;
                while(newRephPos < base && !$6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$isHalantOrCoeng(glyphs[newRephPos]))newRephPos++;
                if (newRephPos < base && $6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$isHalantOrCoeng(glyphs[newRephPos])) {
                    // ->If ZWJ or ZWNJ are following this halant, position is moved after it.
                    if (newRephPos + 1 < base && $6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$isJoiner(glyphs[newRephPos + 1])) newRephPos++;
                    found = true;
                }
            }
            // 6. Otherwise, reorder reph to the end of the syllable.
            if (!found) {
                newRephPos = end - 1;
                while(newRephPos > start && glyphs[newRephPos].shaperInfo.position === $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.SMVD)newRephPos--;
                // If the Reph is to be ending up after a Matra,Halant sequence,
                // position it before that Halant so it can interact with the Matra.
                // However, if it's a plain Consonant,Halant we shouldn't do that.
                // Uniscribe doesn't do this.
                // TEST: U+0930,U+094D,U+0915,U+094B,U+094D
                if ($6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$isHalantOrCoeng(glyphs[newRephPos])) {
                    for(let i = base + 1; i < newRephPos; i++)if (glyphs[i].shaperInfo.category === $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$a513ea61a7bee91c.M) newRephPos--;
                }
            }
            let reph = glyphs[start];
            glyphs.splice(start, 0, ...glyphs.splice(start + 1, newRephPos - start));
            glyphs[newRephPos] = reph;
            if (start < base && base <= newRephPos) base--;
        }
        // o Reorder pre-base reordering consonants:
        //
        // If a pre-base reordering consonant is found, reorder it according to
        // the following rules:
        if (tryPref && base + 1 < end) {
            for(let i = base + 1; i < end; i++)if (glyphs[i].features.pref) {
                // 1. Only reorder a glyph produced by substitution during application
                //    of the <pref> feature. (Note that a font may shape a Ra consonant with
                //    the feature generally but block it in certain contexts.)
                // Note: We just check that something got substituted.  We don't check that
                // the <pref> feature actually did it...
                //
                // Reorder pref only if it ligated.
                if (glyphs[i].isLigated && !glyphs[i].isMultiplied) {
                    // 2. Try to find a target position the same way as for pre-base matra.
                    //    If it is found, reorder pre-base consonant glyph.
                    //
                    // 3. If position is not found, reorder immediately before main
                    //    consonant.
                    let newPos = base;
                    // Malayalam / Tamil do not have "half" forms or explicit virama forms.
                    // The glyphs formed by 'half' are Chillus or ligated explicit viramas.
                    // We want to position matra after them.
                    if (plan.unicodeScript !== 'Malayalam' && plan.unicodeScript !== 'Tamil') {
                        while(newPos > start && !(glyphs[newPos - 1].shaperInfo.category & ($6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$a513ea61a7bee91c.M | $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$ca9599b2a300afc)))newPos--;
                        // In Khmer coeng model, a H,Ra can go *after* matras.  If it goes after a
                        // split matra, it should be reordered to *before* the left part of such matra.
                        if (newPos > start && glyphs[newPos - 1].shaperInfo.category === $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$a513ea61a7bee91c.M) {
                            let oldPos = i;
                            for(let j = base + 1; j < oldPos; j++)if (glyphs[j].shaperInfo.category === $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$a513ea61a7bee91c.M) {
                                newPos--;
                                break;
                            }
                        }
                    }
                    if (newPos > start && $6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$isHalantOrCoeng(glyphs[newPos - 1])) {
                        if (newPos < end && $6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$isJoiner(glyphs[newPos])) newPos++;
                    }
                    let oldPos = i;
                    let tmp = glyphs[oldPos];
                    glyphs.splice(newPos + 1, 0, ...glyphs.splice(newPos, oldPos - newPos));
                    glyphs[newPos] = tmp;
                    if (newPos <= base && base < oldPos) base++;
                }
                break;
            }
        }
        // Apply 'init' to the Left Matra if it's a word start.
        if (glyphs[start].shaperInfo.position === $6d519e6f260f4e02$var$$90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Pre_M && (!start || !/Cf|Mn/.test((0, $d6a5237190dccd49$export$410364bbb673ddbc)(glyphs[start - 1].codePoints[0])))) glyphs[start].features.init = true;
    }
}
function $6d519e6f260f4e02$var$$7826f90f6f0cecc9$var$nextSyllable(glyphs, start) {
    if (start >= glyphs.length) return start;
    let syllable = glyphs[start].shaperInfo.syllable;
    while(++start < glyphs.length && glyphs[start].shaperInfo.syllable === syllable);
    return start;
}
const { categories: $6d519e6f260f4e02$var$$7ab494fe977143c6$var$categories, decompositions: $6d519e6f260f4e02$var$$7ab494fe977143c6$var$decompositions } = /*@__PURE__*/ $6d519e6f260f4e02$var$$parcel$interopDefault($6d519e6f260f4e02$var$$aa333a9607471296$exports);
const $6d519e6f260f4e02$var$$7ab494fe977143c6$var$trie = new (0, (/*@__PURE__*/$parcel$interopDefault($82c8d86aa310da61$exports)))($6d519e6f260f4e02$var$$12727730ddfc8bfe$export$94fdf11bafc8de6b("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"));
const $6d519e6f260f4e02$var$$7ab494fe977143c6$var$stateMachine = new (0, (/*@__PURE__*/$parcel$interopDefault($c6d6097ed0788124$exports)))(/*@__PURE__*/ $6d519e6f260f4e02$var$$parcel$interopDefault($6d519e6f260f4e02$var$$aa333a9607471296$exports));
class $6d519e6f260f4e02$var$$7ab494fe977143c6$export$2e2bcd8739ae039 extends $6d519e6f260f4e02$var$$649970d87335b30f$export$2e2bcd8739ae039 {
    static planFeatures(plan) {
        plan.addStage($6d519e6f260f4e02$var$$7ab494fe977143c6$var$setupSyllables);
        // Default glyph pre-processing group
        plan.addStage([
            'locl',
            'ccmp',
            'nukt',
            'akhn'
        ]);
        // Reordering group
        plan.addStage($6d519e6f260f4e02$var$$7ab494fe977143c6$var$clearSubstitutionFlags);
        plan.addStage([
            'rphf'
        ], false);
        plan.addStage($6d519e6f260f4e02$var$$7ab494fe977143c6$var$recordRphf);
        plan.addStage($6d519e6f260f4e02$var$$7ab494fe977143c6$var$clearSubstitutionFlags);
        plan.addStage([
            'pref'
        ]);
        plan.addStage($6d519e6f260f4e02$var$$7ab494fe977143c6$var$recordPref);
        // Orthographic unit shaping group
        plan.addStage([
            'rkrf',
            'abvf',
            'blwf',
            'half',
            'pstf',
            'vatu',
            'cjct'
        ]);
        plan.addStage($6d519e6f260f4e02$var$$7ab494fe977143c6$var$reorder);
        // Topographical features
        // Scripts that need this are handled by the Arabic shaper, not implemented here for now.
        // plan.addStage(['isol', 'init', 'medi', 'fina', 'med2', 'fin2', 'fin3'], false);
        // Standard topographic presentation and positional feature application
        plan.addStage([
            'abvs',
            'blws',
            'pres',
            'psts',
            'dist',
            'abvm',
            'blwm'
        ]);
    }
    static assignFeatures(plan, glyphs) {
        // Decompose split vowels
        // TODO: do this in a more general unicode normalizer
        for(let i = glyphs.length - 1; i >= 0; i--){
            let codepoint = glyphs[i].codePoints[0];
            if ($6d519e6f260f4e02$var$$7ab494fe977143c6$var$decompositions[codepoint]) {
                let decomposed = $6d519e6f260f4e02$var$$7ab494fe977143c6$var$decompositions[codepoint].map((c)=>{
                    let g = plan.font.glyphForCodePoint(c);
                    return new $6d519e6f260f4e02$var$$10e7b257e1a9a756$export$2e2bcd8739ae039(plan.font, g.id, [
                        c
                    ], glyphs[i].features);
                });
                glyphs.splice(i, 1, ...decomposed);
            }
        }
    }
}
(0, $1d8e073d1256147c$export$71511d61b312f219)($6d519e6f260f4e02$var$$7ab494fe977143c6$export$2e2bcd8739ae039, "zeroMarkWidths", 'BEFORE_GPOS');
function $6d519e6f260f4e02$var$$7ab494fe977143c6$var$useCategory(glyph) {
    return $6d519e6f260f4e02$var$$7ab494fe977143c6$var$trie.get(glyph.codePoints[0]);
}
class $6d519e6f260f4e02$var$$7ab494fe977143c6$var$USEInfo {
    constructor(category, syllableType, syllable){
        this.category = category;
        this.syllableType = syllableType;
        this.syllable = syllable;
    }
}
function $6d519e6f260f4e02$var$$7ab494fe977143c6$var$setupSyllables(font, glyphs) {
    let syllable = 0;
    for (let [start, end, tags] of $6d519e6f260f4e02$var$$7ab494fe977143c6$var$stateMachine.match(glyphs.map($6d519e6f260f4e02$var$$7ab494fe977143c6$var$useCategory))){
        ++syllable;
        // Create shaper info
        for(let i = start; i <= end; i++)glyphs[i].shaperInfo = new $6d519e6f260f4e02$var$$7ab494fe977143c6$var$USEInfo($6d519e6f260f4e02$var$$7ab494fe977143c6$var$categories[$6d519e6f260f4e02$var$$7ab494fe977143c6$var$useCategory(glyphs[i])], tags[0], syllable);
        // Assign rphf feature
        let limit = glyphs[start].shaperInfo.category === 'R' ? 1 : Math.min(3, end - start);
        for(let i = start; i < start + limit; i++)glyphs[i].features.rphf = true;
    }
}
function $6d519e6f260f4e02$var$$7ab494fe977143c6$var$clearSubstitutionFlags(font, glyphs) {
    for (let glyph of glyphs)glyph.substituted = false;
}
function $6d519e6f260f4e02$var$$7ab494fe977143c6$var$recordRphf(font, glyphs) {
    for (let glyph of glyphs)if (glyph.substituted && glyph.features.rphf) glyph.shaperInfo.category = 'R';
}
function $6d519e6f260f4e02$var$$7ab494fe977143c6$var$recordPref(font, glyphs) {
    for (let glyph of glyphs)if (glyph.substituted) glyph.shaperInfo.category = 'VPre';
}
function $6d519e6f260f4e02$var$$7ab494fe977143c6$var$reorder(font, glyphs) {
    let dottedCircle = font.glyphForCodePoint(0x25cc).id;
    for(let start = 0, end = $6d519e6f260f4e02$var$$7ab494fe977143c6$var$nextSyllable(glyphs, 0); start < glyphs.length; start = end, end = $6d519e6f260f4e02$var$$7ab494fe977143c6$var$nextSyllable(glyphs, start)){
        let i, j;
        let info = glyphs[start].shaperInfo;
        let type = info.syllableType;
        // Only a few syllable types need reordering.
        if (type !== 'virama_terminated_cluster' && type !== 'standard_cluster' && type !== 'broken_cluster') continue;
        // Insert a dotted circle glyph in broken clusters.
        if (type === 'broken_cluster' && dottedCircle) {
            let g = new $6d519e6f260f4e02$var$$10e7b257e1a9a756$export$2e2bcd8739ae039(font, dottedCircle, [
                0x25cc
            ]);
            g.shaperInfo = info;
            // Insert after possible Repha.
            for(i = start; i < end && glyphs[i].shaperInfo.category === 'R'; i++);
            glyphs.splice(++i, 0, g);
            end++;
        }
        // Move things forward.
        if (info.category === 'R' && end - start > 1) for(i = start + 1; i < end; i++){
            info = glyphs[i].shaperInfo;
            if ($6d519e6f260f4e02$var$$7ab494fe977143c6$var$isBase(info) || $6d519e6f260f4e02$var$$7ab494fe977143c6$var$isHalant(glyphs[i])) {
                // If we hit a halant, move before it; otherwise it's a base: move to it's
                // place, and shift things in between backward.
                if ($6d519e6f260f4e02$var$$7ab494fe977143c6$var$isHalant(glyphs[i])) i--;
                glyphs.splice(start, 0, ...glyphs.splice(start + 1, i - start), glyphs[i]);
                break;
            }
        }
        // Move things back.
        for(i = start, j = end; i < end; i++){
            info = glyphs[i].shaperInfo;
            if ($6d519e6f260f4e02$var$$7ab494fe977143c6$var$isBase(info) || $6d519e6f260f4e02$var$$7ab494fe977143c6$var$isHalant(glyphs[i])) // place, and shift things in between backward.
            j = $6d519e6f260f4e02$var$$7ab494fe977143c6$var$isHalant(glyphs[i]) ? i + 1 : i;
            else if ((info.category === 'VPre' || info.category === 'VMPre') && j < i) glyphs.splice(j, 1, glyphs[i], ...glyphs.splice(j, i - j));
        }
    }
}
function $6d519e6f260f4e02$var$$7ab494fe977143c6$var$nextSyllable(glyphs, start) {
    if (start >= glyphs.length) return start;
    let syllable = glyphs[start].shaperInfo.syllable;
    while(++start < glyphs.length && glyphs[start].shaperInfo.syllable === syllable);
    return start;
}
function $6d519e6f260f4e02$var$$7ab494fe977143c6$var$isHalant(glyph) {
    return glyph.shaperInfo.category === 'H' && !glyph.isLigated;
}
function $6d519e6f260f4e02$var$$7ab494fe977143c6$var$isBase(info) {
    return info.category === 'B' || info.category === 'GB';
}
const $6d519e6f260f4e02$var$$102b6fe50f1d50b4$var$SHAPERS = {
    arab: $6d519e6f260f4e02$var$$764eb544bbe1ccf0$export$2e2bcd8739ae039,
    mong: $6d519e6f260f4e02$var$$764eb544bbe1ccf0$export$2e2bcd8739ae039,
    syrc: $6d519e6f260f4e02$var$$764eb544bbe1ccf0$export$2e2bcd8739ae039,
    'nko ': $6d519e6f260f4e02$var$$764eb544bbe1ccf0$export$2e2bcd8739ae039,
    phag: $6d519e6f260f4e02$var$$764eb544bbe1ccf0$export$2e2bcd8739ae039,
    mand: $6d519e6f260f4e02$var$$764eb544bbe1ccf0$export$2e2bcd8739ae039,
    mani: $6d519e6f260f4e02$var$$764eb544bbe1ccf0$export$2e2bcd8739ae039,
    phlp: $6d519e6f260f4e02$var$$764eb544bbe1ccf0$export$2e2bcd8739ae039,
    hang: $6d519e6f260f4e02$var$$e1c6bbc8cb416f8c$export$2e2bcd8739ae039,
    bng2: $6d519e6f260f4e02$var$$7826f90f6f0cecc9$export$2e2bcd8739ae039,
    beng: $6d519e6f260f4e02$var$$7826f90f6f0cecc9$export$2e2bcd8739ae039,
    dev2: $6d519e6f260f4e02$var$$7826f90f6f0cecc9$export$2e2bcd8739ae039,
    deva: $6d519e6f260f4e02$var$$7826f90f6f0cecc9$export$2e2bcd8739ae039,
    gjr2: $6d519e6f260f4e02$var$$7826f90f6f0cecc9$export$2e2bcd8739ae039,
    gujr: $6d519e6f260f4e02$var$$7826f90f6f0cecc9$export$2e2bcd8739ae039,
    guru: $6d519e6f260f4e02$var$$7826f90f6f0cecc9$export$2e2bcd8739ae039,
    gur2: $6d519e6f260f4e02$var$$7826f90f6f0cecc9$export$2e2bcd8739ae039,
    knda: $6d519e6f260f4e02$var$$7826f90f6f0cecc9$export$2e2bcd8739ae039,
    knd2: $6d519e6f260f4e02$var$$7826f90f6f0cecc9$export$2e2bcd8739ae039,
    mlm2: $6d519e6f260f4e02$var$$7826f90f6f0cecc9$export$2e2bcd8739ae039,
    mlym: $6d519e6f260f4e02$var$$7826f90f6f0cecc9$export$2e2bcd8739ae039,
    ory2: $6d519e6f260f4e02$var$$7826f90f6f0cecc9$export$2e2bcd8739ae039,
    orya: $6d519e6f260f4e02$var$$7826f90f6f0cecc9$export$2e2bcd8739ae039,
    taml: $6d519e6f260f4e02$var$$7826f90f6f0cecc9$export$2e2bcd8739ae039,
    tml2: $6d519e6f260f4e02$var$$7826f90f6f0cecc9$export$2e2bcd8739ae039,
    telu: $6d519e6f260f4e02$var$$7826f90f6f0cecc9$export$2e2bcd8739ae039,
    tel2: $6d519e6f260f4e02$var$$7826f90f6f0cecc9$export$2e2bcd8739ae039,
    khmr: $6d519e6f260f4e02$var$$7826f90f6f0cecc9$export$2e2bcd8739ae039,
    bali: $6d519e6f260f4e02$var$$7ab494fe977143c6$export$2e2bcd8739ae039,
    batk: $6d519e6f260f4e02$var$$7ab494fe977143c6$export$2e2bcd8739ae039,
    brah: $6d519e6f260f4e02$var$$7ab494fe977143c6$export$2e2bcd8739ae039,
    bugi: $6d519e6f260f4e02$var$$7ab494fe977143c6$export$2e2bcd8739ae039,
    buhd: $6d519e6f260f4e02$var$$7ab494fe977143c6$export$2e2bcd8739ae039,
    cakm: $6d519e6f260f4e02$var$$7ab494fe977143c6$export$2e2bcd8739ae039,
    cham: $6d519e6f260f4e02$var$$7ab494fe977143c6$export$2e2bcd8739ae039,
    dupl: $6d519e6f260f4e02$var$$7ab494fe977143c6$export$2e2bcd8739ae039,
    egyp: $6d519e6f260f4e02$var$$7ab494fe977143c6$export$2e2bcd8739ae039,
    gran: $6d519e6f260f4e02$var$$7ab494fe977143c6$export$2e2bcd8739ae039,
    hano: $6d519e6f260f4e02$var$$7ab494fe977143c6$export$2e2bcd8739ae039,
    java: $6d519e6f260f4e02$var$$7ab494fe977143c6$export$2e2bcd8739ae039,
    kthi: $6d519e6f260f4e02$var$$7ab494fe977143c6$export$2e2bcd8739ae039,
    kali: $6d519e6f260f4e02$var$$7ab494fe977143c6$export$2e2bcd8739ae039,
    khar: $6d519e6f260f4e02$var$$7ab494fe977143c6$export$2e2bcd8739ae039,
    khoj: $6d519e6f260f4e02$var$$7ab494fe977143c6$export$2e2bcd8739ae039,
    sind: $6d519e6f260f4e02$var$$7ab494fe977143c6$export$2e2bcd8739ae039,
    lepc: $6d519e6f260f4e02$var$$7ab494fe977143c6$export$2e2bcd8739ae039,
    limb: $6d519e6f260f4e02$var$$7ab494fe977143c6$export$2e2bcd8739ae039,
    mahj: $6d519e6f260f4e02$var$$7ab494fe977143c6$export$2e2bcd8739ae039,
    // mand: UniversalShaper, // Mandaic
    // mani: UniversalShaper, // Manichaean
    mtei: $6d519e6f260f4e02$var$$7ab494fe977143c6$export$2e2bcd8739ae039,
    modi: $6d519e6f260f4e02$var$$7ab494fe977143c6$export$2e2bcd8739ae039,
    // mong: UniversalShaper, // Mongolian
    // 'nko ': UniversalShaper, // N’Ko
    hmng: $6d519e6f260f4e02$var$$7ab494fe977143c6$export$2e2bcd8739ae039,
    // phag: UniversalShaper, // Phags-pa
    // phlp: UniversalShaper, // Psalter Pahlavi
    rjng: $6d519e6f260f4e02$var$$7ab494fe977143c6$export$2e2bcd8739ae039,
    saur: $6d519e6f260f4e02$var$$7ab494fe977143c6$export$2e2bcd8739ae039,
    shrd: $6d519e6f260f4e02$var$$7ab494fe977143c6$export$2e2bcd8739ae039,
    sidd: $6d519e6f260f4e02$var$$7ab494fe977143c6$export$2e2bcd8739ae039,
    sinh: $6d519e6f260f4e02$var$$7826f90f6f0cecc9$export$2e2bcd8739ae039,
    sund: $6d519e6f260f4e02$var$$7ab494fe977143c6$export$2e2bcd8739ae039,
    sylo: $6d519e6f260f4e02$var$$7ab494fe977143c6$export$2e2bcd8739ae039,
    tglg: $6d519e6f260f4e02$var$$7ab494fe977143c6$export$2e2bcd8739ae039,
    tagb: $6d519e6f260f4e02$var$$7ab494fe977143c6$export$2e2bcd8739ae039,
    tale: $6d519e6f260f4e02$var$$7ab494fe977143c6$export$2e2bcd8739ae039,
    lana: $6d519e6f260f4e02$var$$7ab494fe977143c6$export$2e2bcd8739ae039,
    tavt: $6d519e6f260f4e02$var$$7ab494fe977143c6$export$2e2bcd8739ae039,
    takr: $6d519e6f260f4e02$var$$7ab494fe977143c6$export$2e2bcd8739ae039,
    tibt: $6d519e6f260f4e02$var$$7ab494fe977143c6$export$2e2bcd8739ae039,
    tfng: $6d519e6f260f4e02$var$$7ab494fe977143c6$export$2e2bcd8739ae039,
    tirh: $6d519e6f260f4e02$var$$7ab494fe977143c6$export$2e2bcd8739ae039,
    latn: $6d519e6f260f4e02$var$$649970d87335b30f$export$2e2bcd8739ae039,
    DFLT: $6d519e6f260f4e02$var$$649970d87335b30f$export$2e2bcd8739ae039 // Default
};
function $6d519e6f260f4e02$var$$102b6fe50f1d50b4$export$7877a478dd30fd3d(script) {
    if (!Array.isArray(script)) script = [
        script
    ];
    for (let s of script){
        let shaper = $6d519e6f260f4e02$var$$102b6fe50f1d50b4$var$SHAPERS[s];
        if (shaper) return shaper;
    }
    return $6d519e6f260f4e02$var$$649970d87335b30f$export$2e2bcd8739ae039;
}
class $6d519e6f260f4e02$var$$0a876c45f1f7c41c$export$2e2bcd8739ae039 extends $6d519e6f260f4e02$var$$a83b9c36aaa94fd3$export$2e2bcd8739ae039 {
    applyLookup(lookupType, table) {
        switch(lookupType){
            case 1:
                {
                    let index = this.coverageIndex(table.coverage);
                    if (index === -1) return false;
                    let glyph = this.glyphIterator.cur;
                    switch(table.version){
                        case 1:
                            glyph.id = glyph.id + table.deltaGlyphID & 0xffff;
                            break;
                        case 2:
                            glyph.id = table.substitute.get(index);
                            break;
                    }
                    return true;
                }
            case 2:
                {
                    let index = this.coverageIndex(table.coverage);
                    if (index !== -1) {
                        let sequence = table.sequences.get(index);
                        if (sequence.length === 0) {
                            // If the sequence length is zero, delete the glyph.
                            // The OpenType spec disallows this, but seems like Harfbuzz and Uniscribe allow it.
                            this.glyphs.splice(this.glyphIterator.index, 1);
                            return true;
                        }
                        this.glyphIterator.cur.id = sequence[0];
                        this.glyphIterator.cur.ligatureComponent = 0;
                        let features = this.glyphIterator.cur.features;
                        let curGlyph = this.glyphIterator.cur;
                        let replacement = sequence.slice(1).map((gid, i)=>{
                            let glyph = new $6d519e6f260f4e02$var$$10e7b257e1a9a756$export$2e2bcd8739ae039(this.font, gid, undefined, features);
                            glyph.shaperInfo = curGlyph.shaperInfo;
                            glyph.isLigated = curGlyph.isLigated;
                            glyph.ligatureComponent = i + 1;
                            glyph.substituted = true;
                            glyph.isMultiplied = true;
                            return glyph;
                        });
                        this.glyphs.splice(this.glyphIterator.index + 1, 0, ...replacement);
                        return true;
                    }
                    return false;
                }
            case 3:
                {
                    let index = this.coverageIndex(table.coverage);
                    if (index !== -1) {
                        let USER_INDEX = 0; // TODO
                        this.glyphIterator.cur.id = table.alternateSet.get(index)[USER_INDEX];
                        return true;
                    }
                    return false;
                }
            case 4:
                {
                    let index = this.coverageIndex(table.coverage);
                    if (index === -1) return false;
                    for (let ligature of table.ligatureSets.get(index)){
                        let matched = this.sequenceMatchIndices(1, ligature.components);
                        if (!matched) continue;
                        let curGlyph = this.glyphIterator.cur;
                        // Concatenate all of the characters the new ligature will represent
                        let characters = curGlyph.codePoints.slice();
                        for (let index of matched)characters.push(...this.glyphs[index].codePoints);
                        // Create the replacement ligature glyph
                        let ligatureGlyph = new $6d519e6f260f4e02$var$$10e7b257e1a9a756$export$2e2bcd8739ae039(this.font, ligature.glyph, characters, curGlyph.features);
                        ligatureGlyph.shaperInfo = curGlyph.shaperInfo;
                        ligatureGlyph.isLigated = true;
                        ligatureGlyph.substituted = true;
                        // From Harfbuzz:
                        // - If it *is* a mark ligature, we don't allocate a new ligature id, and leave
                        //   the ligature to keep its old ligature id.  This will allow it to attach to
                        //   a base ligature in GPOS.  Eg. if the sequence is: LAM,LAM,SHADDA,FATHA,HEH,
                        //   and LAM,LAM,HEH for a ligature, they will leave SHADDA and FATHA with a
                        //   ligature id and component value of 2.  Then if SHADDA,FATHA form a ligature
                        //   later, we don't want them to lose their ligature id/component, otherwise
                        //   GPOS will fail to correctly position the mark ligature on top of the
                        //   LAM,LAM,HEH ligature. See https://bugzilla.gnome.org/show_bug.cgi?id=676343
                        //
                        // - If a ligature is formed of components that some of which are also ligatures
                        //   themselves, and those ligature components had marks attached to *their*
                        //   components, we have to attach the marks to the new ligature component
                        //   positions!  Now *that*'s tricky!  And these marks may be following the
                        //   last component of the whole sequence, so we should loop forward looking
                        //   for them and update them.
                        //
                        //   Eg. the sequence is LAM,LAM,SHADDA,FATHA,HEH, and the font first forms a
                        //   'calt' ligature of LAM,HEH, leaving the SHADDA and FATHA with a ligature
                        //   id and component == 1.  Now, during 'liga', the LAM and the LAM-HEH ligature
                        //   form a LAM-LAM-HEH ligature.  We need to reassign the SHADDA and FATHA to
                        //   the new ligature with a component value of 2.
                        //
                        //   This in fact happened to a font...  See https://bugzilla.gnome.org/show_bug.cgi?id=437633
                        let isMarkLigature = curGlyph.isMark;
                        for(let i = 0; i < matched.length && isMarkLigature; i++)isMarkLigature = this.glyphs[matched[i]].isMark;
                        ligatureGlyph.ligatureID = isMarkLigature ? null : this.ligatureID++;
                        let lastLigID = curGlyph.ligatureID;
                        let lastNumComps = curGlyph.codePoints.length;
                        let curComps = lastNumComps;
                        let idx = this.glyphIterator.index + 1;
                        // Set ligatureID and ligatureComponent on glyphs that were skipped in the matched sequence.
                        // This allows GPOS to attach marks to the correct ligature components.
                        for (let matchIndex of matched){
                            // Don't assign new ligature components for mark ligatures (see above)
                            if (isMarkLigature) idx = matchIndex;
                            else while(idx < matchIndex){
                                var ligatureComponent = curComps - lastNumComps + Math.min(this.glyphs[idx].ligatureComponent || 1, lastNumComps);
                                this.glyphs[idx].ligatureID = ligatureGlyph.ligatureID;
                                this.glyphs[idx].ligatureComponent = ligatureComponent;
                                idx++;
                            }
                            lastLigID = this.glyphs[idx].ligatureID;
                            lastNumComps = this.glyphs[idx].codePoints.length;
                            curComps += lastNumComps;
                            idx++; // skip base glyph
                        }
                        // Adjust ligature components for any marks following
                        if (lastLigID && !isMarkLigature) for(let i = idx; i < this.glyphs.length; i++){
                            if (this.glyphs[i].ligatureID === lastLigID) {
                                var ligatureComponent = curComps - lastNumComps + Math.min(this.glyphs[i].ligatureComponent || 1, lastNumComps);
                                this.glyphs[i].ligatureComponent = ligatureComponent;
                            } else break;
                        }
                        // Delete the matched glyphs, and replace the current glyph with the ligature glyph
                        for(let i = matched.length - 1; i >= 0; i--)this.glyphs.splice(matched[i], 1);
                        this.glyphs[this.glyphIterator.index] = ligatureGlyph;
                        return true;
                    }
                    return false;
                }
            case 5:
                return this.applyContext(table);
            case 6:
                return this.applyChainingContext(table);
            case 7:
                return this.applyLookup(table.lookupType, table.extension);
            default:
                throw new Error(`GSUB lookupType ${lookupType} is not supported`);
        }
    }
}
class $6d519e6f260f4e02$var$$c96c93587d49c14d$export$2e2bcd8739ae039 extends $6d519e6f260f4e02$var$$a83b9c36aaa94fd3$export$2e2bcd8739ae039 {
    applyPositionValue(sequenceIndex, value) {
        let position = this.positions[this.glyphIterator.peekIndex(sequenceIndex)];
        if (value.xAdvance != null) position.xAdvance += value.xAdvance;
        if (value.yAdvance != null) position.yAdvance += value.yAdvance;
        if (value.xPlacement != null) position.xOffset += value.xPlacement;
        if (value.yPlacement != null) position.yOffset += value.yPlacement;
        // Adjustments for font variations
        let variationProcessor = this.font._variationProcessor;
        let variationStore = this.font.GDEF && this.font.GDEF.itemVariationStore;
        if (variationProcessor && variationStore) {
            if (value.xPlaDevice) position.xOffset += variationProcessor.getDelta(variationStore, value.xPlaDevice.a, value.xPlaDevice.b);
            if (value.yPlaDevice) position.yOffset += variationProcessor.getDelta(variationStore, value.yPlaDevice.a, value.yPlaDevice.b);
            if (value.xAdvDevice) position.xAdvance += variationProcessor.getDelta(variationStore, value.xAdvDevice.a, value.xAdvDevice.b);
            if (value.yAdvDevice) position.yAdvance += variationProcessor.getDelta(variationStore, value.yAdvDevice.a, value.yAdvDevice.b);
        }
    // TODO: device tables
    }
    applyLookup(lookupType, table) {
        switch(lookupType){
            case 1:
                {
                    let index = this.coverageIndex(table.coverage);
                    if (index === -1) return false;
                    switch(table.version){
                        case 1:
                            this.applyPositionValue(0, table.value);
                            break;
                        case 2:
                            this.applyPositionValue(0, table.values.get(index));
                            break;
                    }
                    return true;
                }
            case 2:
                {
                    let nextGlyph = this.glyphIterator.peek();
                    if (!nextGlyph) return false;
                    let index = this.coverageIndex(table.coverage);
                    if (index === -1) return false;
                    switch(table.version){
                        case 1:
                            let set = table.pairSets.get(index);
                            for (let pair of set)if (pair.secondGlyph === nextGlyph.id) {
                                this.applyPositionValue(0, pair.value1);
                                this.applyPositionValue(1, pair.value2);
                                return true;
                            }
                            return false;
                        case 2:
                            let class1 = this.getClassID(this.glyphIterator.cur.id, table.classDef1);
                            let class2 = this.getClassID(nextGlyph.id, table.classDef2);
                            if (class1 === -1 || class2 === -1) return false;
                            var pair = table.classRecords.get(class1).get(class2);
                            this.applyPositionValue(0, pair.value1);
                            this.applyPositionValue(1, pair.value2);
                            return true;
                    }
                }
            case 3:
                {
                    let nextIndex = this.glyphIterator.peekIndex();
                    let nextGlyph = this.glyphs[nextIndex];
                    if (!nextGlyph) return false;
                    let curRecord = table.entryExitRecords[this.coverageIndex(table.coverage)];
                    if (!curRecord || !curRecord.exitAnchor) return false;
                    let nextRecord = table.entryExitRecords[this.coverageIndex(table.coverage, nextGlyph.id)];
                    if (!nextRecord || !nextRecord.entryAnchor) return false;
                    let entry = this.getAnchor(nextRecord.entryAnchor);
                    let exit = this.getAnchor(curRecord.exitAnchor);
                    let cur = this.positions[this.glyphIterator.index];
                    let next = this.positions[nextIndex];
                    let d;
                    switch(this.direction){
                        case 'ltr':
                            cur.xAdvance = exit.x + cur.xOffset;
                            d = entry.x + next.xOffset;
                            next.xAdvance -= d;
                            next.xOffset -= d;
                            break;
                        case 'rtl':
                            d = exit.x + cur.xOffset;
                            cur.xAdvance -= d;
                            cur.xOffset -= d;
                            next.xAdvance = entry.x + next.xOffset;
                            break;
                    }
                    if (this.glyphIterator.flags.rightToLeft) {
                        this.glyphIterator.cur.cursiveAttachment = nextIndex;
                        cur.yOffset = entry.y - exit.y;
                    } else {
                        nextGlyph.cursiveAttachment = this.glyphIterator.index;
                        cur.yOffset = exit.y - entry.y;
                    }
                    return true;
                }
            case 4:
                {
                    let markIndex = this.coverageIndex(table.markCoverage);
                    if (markIndex === -1) return false;
                    // search backward for a base glyph
                    let baseGlyphIndex = this.glyphIterator.index;
                    while(--baseGlyphIndex >= 0 && (this.glyphs[baseGlyphIndex].isMark || this.glyphs[baseGlyphIndex].ligatureComponent > 0));
                    if (baseGlyphIndex < 0) return false;
                    let baseIndex = this.coverageIndex(table.baseCoverage, this.glyphs[baseGlyphIndex].id);
                    if (baseIndex === -1) return false;
                    let markRecord = table.markArray[markIndex];
                    let baseAnchor = table.baseArray[baseIndex][markRecord.class];
                    this.applyAnchor(markRecord, baseAnchor, baseGlyphIndex);
                    return true;
                }
            case 5:
                {
                    let markIndex = this.coverageIndex(table.markCoverage);
                    if (markIndex === -1) return false;
                    // search backward for a base glyph
                    let baseGlyphIndex = this.glyphIterator.index;
                    while(--baseGlyphIndex >= 0 && this.glyphs[baseGlyphIndex].isMark);
                    if (baseGlyphIndex < 0) return false;
                    let ligIndex = this.coverageIndex(table.ligatureCoverage, this.glyphs[baseGlyphIndex].id);
                    if (ligIndex === -1) return false;
                    let ligAttach = table.ligatureArray[ligIndex];
                    let markGlyph = this.glyphIterator.cur;
                    let ligGlyph = this.glyphs[baseGlyphIndex];
                    let compIndex = ligGlyph.ligatureID && ligGlyph.ligatureID === markGlyph.ligatureID && markGlyph.ligatureComponent > 0 ? Math.min(markGlyph.ligatureComponent, ligGlyph.codePoints.length) - 1 : ligGlyph.codePoints.length - 1;
                    let markRecord = table.markArray[markIndex];
                    let baseAnchor = ligAttach[compIndex][markRecord.class];
                    this.applyAnchor(markRecord, baseAnchor, baseGlyphIndex);
                    return true;
                }
            case 6:
                {
                    let mark1Index = this.coverageIndex(table.mark1Coverage);
                    if (mark1Index === -1) return false;
                    // get the previous mark to attach to
                    let prevIndex = this.glyphIterator.peekIndex(-1);
                    let prev = this.glyphs[prevIndex];
                    if (!prev || !prev.isMark) return false;
                    let cur = this.glyphIterator.cur;
                    // The following logic was borrowed from Harfbuzz
                    let good = false;
                    if (cur.ligatureID === prev.ligatureID) {
                        if (!cur.ligatureID) good = true;
                        else if (cur.ligatureComponent === prev.ligatureComponent) good = true;
                    } else // itself is a ligature, in which case match.
                    if (cur.ligatureID && !cur.ligatureComponent || prev.ligatureID && !prev.ligatureComponent) good = true;
                    if (!good) return false;
                    let mark2Index = this.coverageIndex(table.mark2Coverage, prev.id);
                    if (mark2Index === -1) return false;
                    let markRecord = table.mark1Array[mark1Index];
                    let baseAnchor = table.mark2Array[mark2Index][markRecord.class];
                    this.applyAnchor(markRecord, baseAnchor, prevIndex);
                    return true;
                }
            case 7:
                return this.applyContext(table);
            case 8:
                return this.applyChainingContext(table);
            case 9:
                return this.applyLookup(table.lookupType, table.extension);
            default:
                throw new Error(`Unsupported GPOS table: ${lookupType}`);
        }
    }
    applyAnchor(markRecord, baseAnchor, baseGlyphIndex) {
        let baseCoords = this.getAnchor(baseAnchor);
        let markCoords = this.getAnchor(markRecord.markAnchor);
        let basePos = this.positions[baseGlyphIndex];
        let markPos = this.positions[this.glyphIterator.index];
        markPos.xOffset = baseCoords.x - markCoords.x;
        markPos.yOffset = baseCoords.y - markCoords.y;
        this.glyphIterator.cur.markAttachment = baseGlyphIndex;
    }
    getAnchor(anchor) {
        // TODO: contour point, device tables
        let x = anchor.xCoordinate;
        let y = anchor.yCoordinate;
        // Adjustments for font variations
        let variationProcessor = this.font._variationProcessor;
        let variationStore = this.font.GDEF && this.font.GDEF.itemVariationStore;
        if (variationProcessor && variationStore) {
            if (anchor.xDeviceTable) x += variationProcessor.getDelta(variationStore, anchor.xDeviceTable.a, anchor.xDeviceTable.b);
            if (anchor.yDeviceTable) y += variationProcessor.getDelta(variationStore, anchor.yDeviceTable.a, anchor.yDeviceTable.b);
        }
        return {
            x: x,
            y: y
        };
    }
    applyFeatures(userFeatures, glyphs, advances) {
        super.applyFeatures(userFeatures, glyphs, advances);
        for(var i = 0; i < this.glyphs.length; i++)this.fixCursiveAttachment(i);
        this.fixMarkAttachment();
    }
    fixCursiveAttachment(i) {
        let glyph = this.glyphs[i];
        if (glyph.cursiveAttachment != null) {
            let j = glyph.cursiveAttachment;
            glyph.cursiveAttachment = null;
            this.fixCursiveAttachment(j);
            this.positions[i].yOffset += this.positions[j].yOffset;
        }
    }
    fixMarkAttachment() {
        for(let i = 0; i < this.glyphs.length; i++){
            let glyph = this.glyphs[i];
            if (glyph.markAttachment != null) {
                let j = glyph.markAttachment;
                this.positions[i].xOffset += this.positions[j].xOffset;
                this.positions[i].yOffset += this.positions[j].yOffset;
                if (this.direction === 'ltr') for(let k = j; k < i; k++){
                    this.positions[i].xOffset -= this.positions[k].xAdvance;
                    this.positions[i].yOffset -= this.positions[k].yAdvance;
                }
                else for(let k = j + 1; k < i + 1; k++){
                    this.positions[i].xOffset += this.positions[k].xAdvance;
                    this.positions[i].yOffset += this.positions[k].yAdvance;
                }
            }
        }
    }
}
class $6d519e6f260f4e02$var$$a62492810de27e3d$export$2e2bcd8739ae039 {
    setup(glyphRun) {
        // Map glyphs to GlyphInfo objects so data can be passed between
        // GSUB and GPOS without mutating the real (shared) Glyph objects.
        this.glyphInfos = glyphRun.glyphs.map((glyph)=>new $6d519e6f260f4e02$var$$10e7b257e1a9a756$export$2e2bcd8739ae039(this.font, glyph.id, [
                ...glyph.codePoints
            ]));
        // Select a script based on what is available in GSUB/GPOS.
        let script = null;
        if (this.GPOSProcessor) script = this.GPOSProcessor.selectScript(glyphRun.script, glyphRun.language, glyphRun.direction);
        if (this.GSUBProcessor) script = this.GSUBProcessor.selectScript(glyphRun.script, glyphRun.language, glyphRun.direction);
        // Choose a shaper based on the script, and setup a shaping plan.
        // This determines which features to apply to which glyphs.
        this.shaper = $6d519e6f260f4e02$var$$102b6fe50f1d50b4$export$7877a478dd30fd3d(script);
        this.plan = new $6d519e6f260f4e02$var$$94d7a73bd2edfc9a$export$2e2bcd8739ae039(this.font, script, glyphRun.direction);
        this.shaper.plan(this.plan, this.glyphInfos, glyphRun.features);
        // Assign chosen features to output glyph run
        for(let key in this.plan.allFeatures)glyphRun.features[key] = true;
    }
    substitute(glyphRun) {
        if (this.GSUBProcessor) {
            this.plan.process(this.GSUBProcessor, this.glyphInfos);
            // Map glyph infos back to normal Glyph objects
            glyphRun.glyphs = this.glyphInfos.map((glyphInfo)=>this.font.getGlyph(glyphInfo.id, glyphInfo.codePoints));
        }
    }
    position(glyphRun) {
        if (this.shaper.zeroMarkWidths === 'BEFORE_GPOS') this.zeroMarkAdvances(glyphRun.positions);
        if (this.GPOSProcessor) this.plan.process(this.GPOSProcessor, this.glyphInfos, glyphRun.positions);
        if (this.shaper.zeroMarkWidths === 'AFTER_GPOS') this.zeroMarkAdvances(glyphRun.positions);
        // Reverse the glyphs and positions if the script is right-to-left
        if (glyphRun.direction === 'rtl') {
            glyphRun.glyphs.reverse();
            glyphRun.positions.reverse();
        }
        return this.GPOSProcessor && this.GPOSProcessor.features;
    }
    zeroMarkAdvances(positions) {
        for(let i = 0; i < this.glyphInfos.length; i++)if (this.glyphInfos[i].isMark) {
            positions[i].xAdvance = 0;
            positions[i].yAdvance = 0;
        }
    }
    cleanup() {
        this.glyphInfos = null;
        this.plan = null;
        this.shaper = null;
    }
    getAvailableFeatures(script, language) {
        let features = [];
        if (this.GSUBProcessor) {
            this.GSUBProcessor.selectScript(script, language);
            features.push(...Object.keys(this.GSUBProcessor.features));
        }
        if (this.GPOSProcessor) {
            this.GPOSProcessor.selectScript(script, language);
            features.push(...Object.keys(this.GPOSProcessor.features));
        }
        return features;
    }
    constructor(font){
        this.font = font;
        this.glyphInfos = null;
        this.plan = null;
        this.GSUBProcessor = null;
        this.GPOSProcessor = null;
        this.fallbackPosition = true;
        if (font.GSUB) this.GSUBProcessor = new $6d519e6f260f4e02$var$$0a876c45f1f7c41c$export$2e2bcd8739ae039(font, font.GSUB);
        if (font.GPOS) this.GPOSProcessor = new $6d519e6f260f4e02$var$$c96c93587d49c14d$export$2e2bcd8739ae039(font, font.GPOS);
    }
}
class $6d519e6f260f4e02$var$$4c0a7fa5df7a9ab1$export$2e2bcd8739ae039 {
    layout(string, features, script, language, direction) {
        // Make the features parameter optional
        if (typeof features === 'string') {
            direction = language;
            language = script;
            script = features;
            features = [];
        }
        // Map string to glyphs if needed
        if (typeof string === 'string') {
            // Attempt to detect the script from the string if not provided.
            if (script == null) script = $6d519e6f260f4e02$var$$130d1a642ebcd2b7$export$e5cb25e204fb8450(string);
            var glyphs = this.font.glyphsForString(string);
        } else {
            // Attempt to detect the script from the glyph code points if not provided.
            if (script == null) {
                let codePoints = [];
                for (let glyph of string)codePoints.push(...glyph.codePoints);
                script = $6d519e6f260f4e02$var$$130d1a642ebcd2b7$export$16fab0757cfc223d(codePoints);
            }
            var glyphs = string;
        }
        let glyphRun = new $6d519e6f260f4e02$var$$be07b3e97a42687a$export$2e2bcd8739ae039(glyphs, features, script, language, direction);
        // Return early if there are no glyphs
        if (glyphs.length === 0) {
            glyphRun.positions = [];
            return glyphRun;
        }
        // Setup the advanced layout engine
        if (this.engine && this.engine.setup) this.engine.setup(glyphRun);
        // Substitute and position the glyphs
        this.substitute(glyphRun);
        this.position(glyphRun);
        this.hideDefaultIgnorables(glyphRun.glyphs, glyphRun.positions);
        // Let the layout engine clean up any state it might have
        if (this.engine && this.engine.cleanup) this.engine.cleanup();
        return glyphRun;
    }
    substitute(glyphRun) {
        // Call the advanced layout engine to make substitutions
        if (this.engine && this.engine.substitute) this.engine.substitute(glyphRun);
    }
    position(glyphRun) {
        // Get initial glyph positions
        glyphRun.positions = glyphRun.glyphs.map((glyph)=>new $6d519e6f260f4e02$var$$1ac75d9a55b67f01$export$2e2bcd8739ae039(glyph.advanceWidth));
        let positioned = null;
        // Call the advanced layout engine. Returns the features applied.
        if (this.engine && this.engine.position) positioned = this.engine.position(glyphRun);
        // if there is no GPOS table, use unicode properties to position marks.
        if (!positioned && (!this.engine || this.engine.fallbackPosition)) {
            if (!this.unicodeLayoutEngine) this.unicodeLayoutEngine = new $6d519e6f260f4e02$var$$0a4bdfeb6dfd6f5e$export$2e2bcd8739ae039(this.font);
            this.unicodeLayoutEngine.positionGlyphs(glyphRun.glyphs, glyphRun.positions);
        }
        // if kerning is not supported by GPOS, do kerning with the TrueType/AAT kern table
        if ((!positioned || !positioned.kern) && glyphRun.features.kern !== false && this.font.kern) {
            if (!this.kernProcessor) this.kernProcessor = new $6d519e6f260f4e02$var$$0bba3a9db57637f3$export$2e2bcd8739ae039(this.font);
            this.kernProcessor.process(glyphRun.glyphs, glyphRun.positions);
            glyphRun.features.kern = true;
        }
    }
    hideDefaultIgnorables(glyphs, positions) {
        let space = this.font.glyphForCodePoint(0x20);
        for(let i = 0; i < glyphs.length; i++)if (this.isDefaultIgnorable(glyphs[i].codePoints[0])) {
            glyphs[i] = space;
            positions[i].xAdvance = 0;
            positions[i].yAdvance = 0;
        }
    }
    isDefaultIgnorable(ch) {
        // From DerivedCoreProperties.txt in the Unicode database,
        // minus U+115F, U+1160, U+3164 and U+FFA0, which is what
        // Harfbuzz and Uniscribe do.
        let plane = ch >> 16;
        if (plane === 0) switch(ch >> 8){
            case 0x00:
                return ch === 0x00AD;
            case 0x03:
                return ch === 0x034F;
            case 0x06:
                return ch === 0x061C;
            case 0x17:
                return 0x17B4 <= ch && ch <= 0x17B5;
            case 0x18:
                return 0x180B <= ch && ch <= 0x180E;
            case 0x20:
                return 0x200B <= ch && ch <= 0x200F || 0x202A <= ch && ch <= 0x202E || 0x2060 <= ch && ch <= 0x206F;
            case 0xFE:
                return 0xFE00 <= ch && ch <= 0xFE0F || ch === 0xFEFF;
            case 0xFF:
                return 0xFFF0 <= ch && ch <= 0xFFF8;
            default:
                return false;
        }
        else switch(plane){
            case 0x01:
                return 0x1BCA0 <= ch && ch <= 0x1BCA3 || 0x1D173 <= ch && ch <= 0x1D17A;
            case 0x0E:
                return 0xE0000 <= ch && ch <= 0xE0FFF;
            default:
                return false;
        }
    }
    getAvailableFeatures(script, language) {
        let features = [];
        if (this.engine) features.push(...this.engine.getAvailableFeatures(script, language));
        if (this.font.kern && features.indexOf('kern') === -1) features.push('kern');
        return features;
    }
    stringsForGlyph(gid) {
        let result = new Set;
        let codePoints = this.font._cmapProcessor.codePointsForGlyph(gid);
        for (let codePoint of codePoints)result.add(String.fromCodePoint(codePoint));
        if (this.engine && this.engine.stringsForGlyph) for (let string of this.engine.stringsForGlyph(gid))result.add(string);
        return Array.from(result);
    }
    constructor(font){
        this.font = font;
        this.unicodeLayoutEngine = null;
        this.kernProcessor = null;
        // Choose an advanced layout engine. We try the AAT morx table first since more
        // scripts are currently supported because the shaping logic is built into the font.
        if (this.font.morx) this.engine = new $6d519e6f260f4e02$var$$ba6dd74203be8728$export$2e2bcd8739ae039(this.font);
        else if (this.font.GSUB || this.font.GPOS) this.engine = new $6d519e6f260f4e02$var$$a62492810de27e3d$export$2e2bcd8739ae039(this.font);
    }
}
const $6d519e6f260f4e02$var$$f43aec954cdfdf21$var$SVG_COMMANDS = {
    moveTo: 'M',
    lineTo: 'L',
    quadraticCurveTo: 'Q',
    bezierCurveTo: 'C',
    closePath: 'Z'
};
class $6d519e6f260f4e02$var$$f43aec954cdfdf21$export$2e2bcd8739ae039 {
    /**
   * Compiles the path to a JavaScript function that can be applied with
   * a graphics context in order to render the path.
   * @return {string}
   */ toFunction() {
        return (ctx)=>{
            this.commands.forEach((c)=>{
                return ctx[c.command].apply(ctx, c.args);
            });
        };
    }
    /**
   * Converts the path to an SVG path data string
   * @return {string}
   */ toSVG() {
        let cmds = this.commands.map((c)=>{
            let args = c.args.map((arg)=>Math.round(arg * 100) / 100);
            return `${$6d519e6f260f4e02$var$$f43aec954cdfdf21$var$SVG_COMMANDS[c.command]}${args.join(' ')}`;
        });
        return cmds.join('');
    }
    /**
   * Gets the "control box" of a path.
   * This is like the bounding box, but it includes all points including
   * control points of bezier segments and is much faster to compute than
   * the real bounding box.
   * @type {BBox}
   */ get cbox() {
        if (!this._cbox) {
            let cbox = new $6d519e6f260f4e02$var$$f34600ab9d7f70d8$export$2e2bcd8739ae039;
            for (let command of this.commands)for(let i = 0; i < command.args.length; i += 2)cbox.addPoint(command.args[i], command.args[i + 1]);
            this._cbox = Object.freeze(cbox);
        }
        return this._cbox;
    }
    /**
   * Gets the exact bounding box of the path by evaluating curve segments.
   * Slower to compute than the control box, but more accurate.
   * @type {BBox}
   */ get bbox() {
        if (this._bbox) return this._bbox;
        let bbox = new $6d519e6f260f4e02$var$$f34600ab9d7f70d8$export$2e2bcd8739ae039;
        let cx = 0, cy = 0;
        let f = (t)=>Math.pow(1 - t, 3) * p0[i] + 3 * Math.pow(1 - t, 2) * t * p1[i] + 3 * (1 - t) * Math.pow(t, 2) * p2[i] + Math.pow(t, 3) * p3[i];
        for (let c of this.commands)switch(c.command){
            case 'moveTo':
            case 'lineTo':
                let [x, y] = c.args;
                bbox.addPoint(x, y);
                cx = x;
                cy = y;
                break;
            case 'quadraticCurveTo':
            case 'bezierCurveTo':
                if (c.command === 'quadraticCurveTo') {
                    // http://fontforge.org/bezier.html
                    var [qp1x, qp1y, p3x, p3y] = c.args;
                    var cp1x = cx + 2 / 3 * (qp1x - cx); // CP1 = QP0 + 2/3 * (QP1-QP0)
                    var cp1y = cy + 2 / 3 * (qp1y - cy);
                    var cp2x = p3x + 2 / 3 * (qp1x - p3x); // CP2 = QP2 + 2/3 * (QP1-QP2)
                    var cp2y = p3y + 2 / 3 * (qp1y - p3y);
                } else var [cp1x, cp1y, cp2x, cp2y, p3x, p3y] = c.args;
                // http://blog.hackers-cafe.net/2009/06/how-to-calculate-bezier-curves-bounding.html
                bbox.addPoint(p3x, p3y);
                var p0 = [
                    cx,
                    cy
                ];
                var p1 = [
                    cp1x,
                    cp1y
                ];
                var p2 = [
                    cp2x,
                    cp2y
                ];
                var p3 = [
                    p3x,
                    p3y
                ];
                for(var i = 0; i <= 1; i++){
                    let b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
                    let a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
                    c = 3 * p1[i] - 3 * p0[i];
                    if (a === 0) {
                        if (b === 0) continue;
                        let t = -c / b;
                        if (0 < t && t < 1) {
                            if (i === 0) bbox.addPoint(f(t), bbox.maxY);
                            else if (i === 1) bbox.addPoint(bbox.maxX, f(t));
                        }
                        continue;
                    }
                    let b2ac = Math.pow(b, 2) - 4 * c * a;
                    if (b2ac < 0) continue;
                    let t1 = (-b + Math.sqrt(b2ac)) / (2 * a);
                    if (0 < t1 && t1 < 1) {
                        if (i === 0) bbox.addPoint(f(t1), bbox.maxY);
                        else if (i === 1) bbox.addPoint(bbox.maxX, f(t1));
                    }
                    let t2 = (-b - Math.sqrt(b2ac)) / (2 * a);
                    if (0 < t2 && t2 < 1) {
                        if (i === 0) bbox.addPoint(f(t2), bbox.maxY);
                        else if (i === 1) bbox.addPoint(bbox.maxX, f(t2));
                    }
                }
                cx = p3x;
                cy = p3y;
                break;
        }
        return this._bbox = Object.freeze(bbox);
    }
    /**
   * Applies a mapping function to each point in the path.
   * @param {function} fn
   * @return {Path}
   */ mapPoints(fn) {
        let path = new $6d519e6f260f4e02$var$$f43aec954cdfdf21$export$2e2bcd8739ae039;
        for (let c of this.commands){
            let args = [];
            for(let i = 0; i < c.args.length; i += 2){
                let [x, y] = fn(c.args[i], c.args[i + 1]);
                args.push(x, y);
            }
            path[c.command](...args);
        }
        return path;
    }
    /**
   * Transforms the path by the given matrix.
   */ transform(m0, m1, m2, m3, m4, m5) {
        return this.mapPoints((x, y)=>{
            const tx = m0 * x + m2 * y + m4;
            const ty = m1 * x + m3 * y + m5;
            return [
                tx,
                ty
            ];
        });
    }
    /**
   * Translates the path by the given offset.
   */ translate(x, y) {
        return this.transform(1, 0, 0, 1, x, y);
    }
    /**
   * Rotates the path by the given angle (in radians).
   */ rotate(angle) {
        let cos = Math.cos(angle);
        let sin = Math.sin(angle);
        return this.transform(cos, sin, -sin, cos, 0, 0);
    }
    /**
   * Scales the path.
   */ scale(scaleX, scaleY = scaleX) {
        return this.transform(scaleX, 0, 0, scaleY, 0, 0);
    }
    constructor(){
        this.commands = [];
        this._bbox = null;
        this._cbox = null;
    }
}
for (let command of [
    'moveTo',
    'lineTo',
    'quadraticCurveTo',
    'bezierCurveTo',
    'closePath'
])$6d519e6f260f4e02$var$$f43aec954cdfdf21$export$2e2bcd8739ae039.prototype[command] = function(...args) {
    this._bbox = this._cbox = null;
    this.commands.push({
        command: command,
        args: args
    });
    return this;
};
var $6d519e6f260f4e02$var$$7713b9b7b438dff8$export$2e2bcd8739ae039 = [
    '.notdef',
    '.null',
    'nonmarkingreturn',
    'space',
    'exclam',
    'quotedbl',
    'numbersign',
    'dollar',
    'percent',
    'ampersand',
    'quotesingle',
    'parenleft',
    'parenright',
    'asterisk',
    'plus',
    'comma',
    'hyphen',
    'period',
    'slash',
    'zero',
    'one',
    'two',
    'three',
    'four',
    'five',
    'six',
    'seven',
    'eight',
    'nine',
    'colon',
    'semicolon',
    'less',
    'equal',
    'greater',
    'question',
    'at',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    'bracketleft',
    'backslash',
    'bracketright',
    'asciicircum',
    'underscore',
    'grave',
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
    'braceleft',
    'bar',
    'braceright',
    'asciitilde',
    'Adieresis',
    'Aring',
    'Ccedilla',
    'Eacute',
    'Ntilde',
    'Odieresis',
    'Udieresis',
    'aacute',
    'agrave',
    'acircumflex',
    'adieresis',
    'atilde',
    'aring',
    'ccedilla',
    'eacute',
    'egrave',
    'ecircumflex',
    'edieresis',
    'iacute',
    'igrave',
    'icircumflex',
    'idieresis',
    'ntilde',
    'oacute',
    'ograve',
    'ocircumflex',
    'odieresis',
    'otilde',
    'uacute',
    'ugrave',
    'ucircumflex',
    'udieresis',
    'dagger',
    'degree',
    'cent',
    'sterling',
    'section',
    'bullet',
    'paragraph',
    'germandbls',
    'registered',
    'copyright',
    'trademark',
    'acute',
    'dieresis',
    'notequal',
    'AE',
    'Oslash',
    'infinity',
    'plusminus',
    'lessequal',
    'greaterequal',
    'yen',
    'mu',
    'partialdiff',
    'summation',
    'product',
    'pi',
    'integral',
    'ordfeminine',
    'ordmasculine',
    'Omega',
    'ae',
    'oslash',
    'questiondown',
    'exclamdown',
    'logicalnot',
    'radical',
    'florin',
    'approxequal',
    'Delta',
    'guillemotleft',
    'guillemotright',
    'ellipsis',
    'nonbreakingspace',
    'Agrave',
    'Atilde',
    'Otilde',
    'OE',
    'oe',
    'endash',
    'emdash',
    'quotedblleft',
    'quotedblright',
    'quoteleft',
    'quoteright',
    'divide',
    'lozenge',
    'ydieresis',
    'Ydieresis',
    'fraction',
    'currency',
    'guilsinglleft',
    'guilsinglright',
    'fi',
    'fl',
    'daggerdbl',
    'periodcentered',
    'quotesinglbase',
    'quotedblbase',
    'perthousand',
    'Acircumflex',
    'Ecircumflex',
    'Aacute',
    'Edieresis',
    'Egrave',
    'Iacute',
    'Icircumflex',
    'Idieresis',
    'Igrave',
    'Oacute',
    'Ocircumflex',
    'apple',
    'Ograve',
    'Uacute',
    'Ucircumflex',
    'Ugrave',
    'dotlessi',
    'circumflex',
    'tilde',
    'macron',
    'breve',
    'dotaccent',
    'ring',
    'cedilla',
    'hungarumlaut',
    'ogonek',
    'caron',
    'Lslash',
    'lslash',
    'Scaron',
    'scaron',
    'Zcaron',
    'zcaron',
    'brokenbar',
    'Eth',
    'eth',
    'Yacute',
    'yacute',
    'Thorn',
    'thorn',
    'minus',
    'multiply',
    'onesuperior',
    'twosuperior',
    'threesuperior',
    'onehalf',
    'onequarter',
    'threequarters',
    'franc',
    'Gbreve',
    'gbreve',
    'Idotaccent',
    'Scedilla',
    'scedilla',
    'Cacute',
    'cacute',
    'Ccaron',
    'ccaron',
    'dcroat'
];
class $6d519e6f260f4e02$var$$f92906be28e61769$export$2e2bcd8739ae039 {
    _getPath() {
        return new $6d519e6f260f4e02$var$$f43aec954cdfdf21$export$2e2bcd8739ae039();
    }
    _getCBox() {
        return this.path.cbox;
    }
    _getBBox() {
        return this.path.bbox;
    }
    _getTableMetrics(table) {
        if (this.id < table.metrics.length) return table.metrics.get(this.id);
        let metric = table.metrics.get(table.metrics.length - 1);
        let res = {
            advance: metric ? metric.advance : 0,
            bearing: table.bearings.get(this.id - table.metrics.length) || 0
        };
        return res;
    }
    _getMetrics(cbox) {
        if (this._metrics) return this._metrics;
        let { advance: advanceWidth, bearing: leftBearing } = this._getTableMetrics(this._font.hmtx);
        // For vertical metrics, use vmtx if available, or fall back to global data from OS/2 or hhea
        if (this._font.vmtx) var { advance: advanceHeight, bearing: topBearing } = this._getTableMetrics(this._font.vmtx);
        else {
            let os2;
            if (typeof cbox === 'undefined' || cbox === null) ({ cbox: cbox } = this);
            if ((os2 = this._font['OS/2']) && os2.version > 0) {
                var advanceHeight = Math.abs(os2.typoAscender - os2.typoDescender);
                var topBearing = os2.typoAscender - cbox.maxY;
            } else {
                let { hhea: hhea } = this._font;
                var advanceHeight = Math.abs(hhea.ascent - hhea.descent);
                var topBearing = hhea.ascent - cbox.maxY;
            }
        }
        if (this._font._variationProcessor && this._font.HVAR) advanceWidth += this._font._variationProcessor.getAdvanceAdjustment(this.id, this._font.HVAR);
        return this._metrics = {
            advanceWidth: advanceWidth,
            advanceHeight: advanceHeight,
            leftBearing: leftBearing,
            topBearing: topBearing
        };
    }
    /**
   * The glyph’s control box.
   * This is often the same as the bounding box, but is faster to compute.
   * Because of the way bezier curves are defined, some of the control points
   * can be outside of the bounding box. Where `bbox` takes this into account,
   * `cbox` does not. Thus, cbox is less accurate, but faster to compute.
   * See [here](http://www.freetype.org/freetype2/docs/glyphs/glyphs-6.html#section-2)
   * for a more detailed description.
   *
   * @type {BBox}
   */ get cbox() {
        return this._getCBox();
    }
    /**
   * The glyph’s bounding box, i.e. the rectangle that encloses the
   * glyph outline as tightly as possible.
   * @type {BBox}
   */ get bbox() {
        return this._getBBox();
    }
    /**
   * A vector Path object representing the glyph outline.
   * @type {Path}
   */ get path() {
        // Cache the path so we only decode it once
        // Decoding is actually performed by subclasses
        return this._getPath();
    }
    /**
   * Returns a path scaled to the given font size.
   * @param {number} size
   * @return {Path}
   */ getScaledPath(size) {
        let scale = 1 / this._font.unitsPerEm * size;
        return this.path.scale(scale);
    }
    /**
   * The glyph's advance width.
   * @type {number}
   */ get advanceWidth() {
        return this._getMetrics().advanceWidth;
    }
    /**
   * The glyph's advance height.
   * @type {number}
   */ get advanceHeight() {
        return this._getMetrics().advanceHeight;
    }
    get ligatureCaretPositions() {}
    _getName() {
        let { post: post } = this._font;
        if (!post) return null;
        switch(post.version){
            case 1:
                return $6d519e6f260f4e02$var$$7713b9b7b438dff8$export$2e2bcd8739ae039[this.id];
            case 2:
                let id = post.glyphNameIndex[this.id];
                if (id < $6d519e6f260f4e02$var$$7713b9b7b438dff8$export$2e2bcd8739ae039.length) return $6d519e6f260f4e02$var$$7713b9b7b438dff8$export$2e2bcd8739ae039[id];
                return post.names[id - $6d519e6f260f4e02$var$$7713b9b7b438dff8$export$2e2bcd8739ae039.length];
            case 2.5:
                return $6d519e6f260f4e02$var$$7713b9b7b438dff8$export$2e2bcd8739ae039[this.id + post.offsets[this.id]];
            case 4:
                return String.fromCharCode(post.map[this.id]);
        }
    }
    /**
   * The glyph's name
   * @type {string}
   */ get name() {
        return this._getName();
    }
    /**
   * Renders the glyph to the given graphics context, at the specified font size.
   * @param {CanvasRenderingContext2d} ctx
   * @param {number} size
   */ render(ctx, size) {
        ctx.save();
        let scale = 1 / this._font.head.unitsPerEm * size;
        ctx.scale(scale, scale);
        let fn = this.path.toFunction();
        fn(ctx);
        ctx.fill();
        ctx.restore();
    }
    constructor(id, codePoints, font){
        /**
     * The glyph id in the font
     * @type {number}
     */ this.id = id;
        /**
     * An array of unicode code points that are represented by this glyph.
     * There can be multiple code points in the case of ligatures and other glyphs
     * that represent multiple visual characters.
     * @type {number[]}
     */ this.codePoints = codePoints;
        this._font = font;
        // TODO: get this info from GDEF if available
        this.isMark = this.codePoints.length > 0 && this.codePoints.every((0, $d6a5237190dccd49$export$e33ad6871e762338));
        this.isLigature = this.codePoints.length > 1;
    }
}
(0, $04dbd055bc5edd2b$export$29e00dfd3077644b)([
    $6d519e6f260f4e02$var$$e71565f2ce09cb6b$export$69a3209f1a06c04d
], $6d519e6f260f4e02$var$$f92906be28e61769$export$2e2bcd8739ae039.prototype, "cbox", null);
(0, $04dbd055bc5edd2b$export$29e00dfd3077644b)([
    $6d519e6f260f4e02$var$$e71565f2ce09cb6b$export$69a3209f1a06c04d
], $6d519e6f260f4e02$var$$f92906be28e61769$export$2e2bcd8739ae039.prototype, "bbox", null);
(0, $04dbd055bc5edd2b$export$29e00dfd3077644b)([
    $6d519e6f260f4e02$var$$e71565f2ce09cb6b$export$69a3209f1a06c04d
], $6d519e6f260f4e02$var$$f92906be28e61769$export$2e2bcd8739ae039.prototype, "path", null);
(0, $04dbd055bc5edd2b$export$29e00dfd3077644b)([
    $6d519e6f260f4e02$var$$e71565f2ce09cb6b$export$69a3209f1a06c04d
], $6d519e6f260f4e02$var$$f92906be28e61769$export$2e2bcd8739ae039.prototype, "advanceWidth", null);
(0, $04dbd055bc5edd2b$export$29e00dfd3077644b)([
    $6d519e6f260f4e02$var$$e71565f2ce09cb6b$export$69a3209f1a06c04d
], $6d519e6f260f4e02$var$$f92906be28e61769$export$2e2bcd8739ae039.prototype, "advanceHeight", null);
(0, $04dbd055bc5edd2b$export$29e00dfd3077644b)([
    $6d519e6f260f4e02$var$$e71565f2ce09cb6b$export$69a3209f1a06c04d
], $6d519e6f260f4e02$var$$f92906be28e61769$export$2e2bcd8739ae039.prototype, "name", null);
// The header for both simple and composite glyphs
let $6d519e6f260f4e02$var$$69aac16029968692$var$GlyfHeader = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    numberOfContours: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    xMin: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    yMin: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    xMax: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    yMax: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6)
});
// Flags for simple glyphs
const $6d519e6f260f4e02$var$$69aac16029968692$var$ON_CURVE = 1;
const $6d519e6f260f4e02$var$$69aac16029968692$var$X_SHORT_VECTOR = 2;
const $6d519e6f260f4e02$var$$69aac16029968692$var$Y_SHORT_VECTOR = 4;
const $6d519e6f260f4e02$var$$69aac16029968692$var$REPEAT = 8;
const $6d519e6f260f4e02$var$$69aac16029968692$var$SAME_X = 16;
const $6d519e6f260f4e02$var$$69aac16029968692$var$SAME_Y = 32;
// Flags for composite glyphs
const $6d519e6f260f4e02$var$$69aac16029968692$var$ARG_1_AND_2_ARE_WORDS = 1;
const $6d519e6f260f4e02$var$$69aac16029968692$var$ARGS_ARE_XY_VALUES = 2;
const $6d519e6f260f4e02$var$$69aac16029968692$var$ROUND_XY_TO_GRID = 4;
const $6d519e6f260f4e02$var$$69aac16029968692$var$WE_HAVE_A_SCALE = 8;
const $6d519e6f260f4e02$var$$69aac16029968692$var$MORE_COMPONENTS = 32;
const $6d519e6f260f4e02$var$$69aac16029968692$var$WE_HAVE_AN_X_AND_Y_SCALE = 64;
const $6d519e6f260f4e02$var$$69aac16029968692$var$WE_HAVE_A_TWO_BY_TWO = 128;
const $6d519e6f260f4e02$var$$69aac16029968692$var$WE_HAVE_INSTRUCTIONS = 256;
const $6d519e6f260f4e02$var$$69aac16029968692$var$USE_MY_METRICS = 512;
const $6d519e6f260f4e02$var$$69aac16029968692$var$OVERLAP_COMPOUND = 1024;
const $6d519e6f260f4e02$var$$69aac16029968692$var$SCALED_COMPONENT_OFFSET = 2048;
const $6d519e6f260f4e02$var$$69aac16029968692$var$UNSCALED_COMPONENT_OFFSET = 4096;
class $6d519e6f260f4e02$var$$69aac16029968692$export$baf26146a414f24a {
    copy() {
        return new $6d519e6f260f4e02$var$$69aac16029968692$export$baf26146a414f24a(this.onCurve, this.endContour, this.x, this.y);
    }
    constructor(onCurve, endContour, x = 0, y = 0){
        this.onCurve = onCurve;
        this.endContour = endContour;
        this.x = x;
        this.y = y;
    }
}
// Represents a component in a composite glyph
class $6d519e6f260f4e02$var$$69aac16029968692$var$Component {
    constructor(glyphID, dx, dy){
        this.glyphID = glyphID;
        this.dx = dx;
        this.dy = dy;
        this.pos = 0;
        this.scaleX = this.scaleY = 1;
        this.scale01 = this.scale10 = 0;
    }
}
class $6d519e6f260f4e02$var$$69aac16029968692$export$2e2bcd8739ae039 extends $6d519e6f260f4e02$var$$f92906be28e61769$export$2e2bcd8739ae039 {
    // Parses just the glyph header and returns the bounding box
    _getCBox(internal) {
        // We need to decode the glyph if variation processing is requested,
        // so it's easier just to recompute the path's cbox after decoding.
        if (this._font._variationProcessor && !internal) return this.path.cbox;
        let stream = this._font._getTableStream('glyf');
        stream.pos += this._font.loca.offsets[this.id];
        let glyph = $6d519e6f260f4e02$var$$69aac16029968692$var$GlyfHeader.decode(stream);
        let cbox = new $6d519e6f260f4e02$var$$f34600ab9d7f70d8$export$2e2bcd8739ae039(glyph.xMin, glyph.yMin, glyph.xMax, glyph.yMax);
        return Object.freeze(cbox);
    }
    // Parses a single glyph coordinate
    _parseGlyphCoord(stream, prev, short, same) {
        if (short) {
            var val = stream.readUInt8();
            if (!same) val = -val;
            val += prev;
        } else if (same) var val = prev;
        else var val = prev + stream.readInt16BE();
        return val;
    }
    // Decodes the glyph data into points for simple glyphs,
    // or components for composite glyphs
    _decode() {
        let glyfPos = this._font.loca.offsets[this.id];
        let nextPos = this._font.loca.offsets[this.id + 1];
        // Nothing to do if there is no data for this glyph
        if (glyfPos === nextPos) return null;
        let stream = this._font._getTableStream('glyf');
        stream.pos += glyfPos;
        let startPos = stream.pos;
        let glyph = $6d519e6f260f4e02$var$$69aac16029968692$var$GlyfHeader.decode(stream);
        if (glyph.numberOfContours > 0) this._decodeSimple(glyph, stream);
        else if (glyph.numberOfContours < 0) this._decodeComposite(glyph, stream, startPos);
        return glyph;
    }
    _decodeSimple(glyph, stream) {
        // this is a simple glyph
        glyph.points = [];
        let endPtsOfContours = new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), glyph.numberOfContours).decode(stream);
        glyph.instructions = new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$52e103c63c4e68cf), (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456)).decode(stream);
        let flags = [];
        let numCoords = endPtsOfContours[endPtsOfContours.length - 1] + 1;
        while(flags.length < numCoords){
            var flag = stream.readUInt8();
            flags.push(flag);
            // check for repeat flag
            if (flag & $6d519e6f260f4e02$var$$69aac16029968692$var$REPEAT) {
                let count = stream.readUInt8();
                for(let j = 0; j < count; j++)flags.push(flag);
            }
        }
        for(var i = 0; i < flags.length; i++){
            var flag = flags[i];
            let point = new $6d519e6f260f4e02$var$$69aac16029968692$export$baf26146a414f24a(!!(flag & $6d519e6f260f4e02$var$$69aac16029968692$var$ON_CURVE), endPtsOfContours.indexOf(i) >= 0, 0, 0);
            glyph.points.push(point);
        }
        let px = 0;
        for(var i = 0; i < flags.length; i++){
            var flag = flags[i];
            glyph.points[i].x = px = this._parseGlyphCoord(stream, px, flag & $6d519e6f260f4e02$var$$69aac16029968692$var$X_SHORT_VECTOR, flag & $6d519e6f260f4e02$var$$69aac16029968692$var$SAME_X);
        }
        let py = 0;
        for(var i = 0; i < flags.length; i++){
            var flag = flags[i];
            glyph.points[i].y = py = this._parseGlyphCoord(stream, py, flag & $6d519e6f260f4e02$var$$69aac16029968692$var$Y_SHORT_VECTOR, flag & $6d519e6f260f4e02$var$$69aac16029968692$var$SAME_Y);
        }
        if (this._font._variationProcessor) {
            let points = glyph.points.slice();
            points.push(...this._getPhantomPoints(glyph));
            this._font._variationProcessor.transformPoints(this.id, points);
            glyph.phantomPoints = points.slice(-4);
        }
        return;
    }
    _decodeComposite(glyph, stream, offset = 0) {
        // this is a composite glyph
        glyph.components = [];
        let haveInstructions = false;
        let flags = $6d519e6f260f4e02$var$$69aac16029968692$var$MORE_COMPONENTS;
        while(flags & $6d519e6f260f4e02$var$$69aac16029968692$var$MORE_COMPONENTS){
            flags = stream.readUInt16BE();
            let gPos = stream.pos - offset;
            let glyphID = stream.readUInt16BE();
            if (!haveInstructions) haveInstructions = (flags & $6d519e6f260f4e02$var$$69aac16029968692$var$WE_HAVE_INSTRUCTIONS) !== 0;
            if (flags & $6d519e6f260f4e02$var$$69aac16029968692$var$ARG_1_AND_2_ARE_WORDS) {
                var dx = stream.readInt16BE();
                var dy = stream.readInt16BE();
            } else {
                var dx = stream.readInt8();
                var dy = stream.readInt8();
            }
            var component = new $6d519e6f260f4e02$var$$69aac16029968692$var$Component(glyphID, dx, dy);
            component.pos = gPos;
            if (flags & $6d519e6f260f4e02$var$$69aac16029968692$var$WE_HAVE_A_SCALE) component.scaleX = component.scaleY = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
            else if (flags & $6d519e6f260f4e02$var$$69aac16029968692$var$WE_HAVE_AN_X_AND_Y_SCALE) {
                component.scaleX = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                component.scaleY = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
            } else if (flags & $6d519e6f260f4e02$var$$69aac16029968692$var$WE_HAVE_A_TWO_BY_TWO) {
                component.scaleX = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                component.scale01 = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                component.scale10 = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                component.scaleY = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
            }
            glyph.components.push(component);
        }
        if (this._font._variationProcessor) {
            let points = [];
            for(let j = 0; j < glyph.components.length; j++){
                var component = glyph.components[j];
                points.push(new $6d519e6f260f4e02$var$$69aac16029968692$export$baf26146a414f24a(true, true, component.dx, component.dy));
            }
            points.push(...this._getPhantomPoints(glyph));
            this._font._variationProcessor.transformPoints(this.id, points);
            glyph.phantomPoints = points.splice(-4, 4);
            for(let i = 0; i < points.length; i++){
                let point = points[i];
                glyph.components[i].dx = point.x;
                glyph.components[i].dy = point.y;
            }
        }
        return haveInstructions;
    }
    _getPhantomPoints(glyph) {
        let cbox = this._getCBox(true);
        if (this._metrics == null) this._metrics = $6d519e6f260f4e02$var$$f92906be28e61769$export$2e2bcd8739ae039.prototype._getMetrics.call(this, cbox);
        let { advanceWidth: advanceWidth, advanceHeight: advanceHeight, leftBearing: leftBearing, topBearing: topBearing } = this._metrics;
        return [
            new $6d519e6f260f4e02$var$$69aac16029968692$export$baf26146a414f24a(false, true, glyph.xMin - leftBearing, 0),
            new $6d519e6f260f4e02$var$$69aac16029968692$export$baf26146a414f24a(false, true, glyph.xMin - leftBearing + advanceWidth, 0),
            new $6d519e6f260f4e02$var$$69aac16029968692$export$baf26146a414f24a(false, true, 0, glyph.yMax + topBearing),
            new $6d519e6f260f4e02$var$$69aac16029968692$export$baf26146a414f24a(false, true, 0, glyph.yMax + topBearing + advanceHeight)
        ];
    }
    // Decodes font data, resolves composite glyphs, and returns an array of contours
    _getContours() {
        let glyph = this._decode();
        if (!glyph) return [];
        let points = [];
        if (glyph.numberOfContours < 0) for (let component of glyph.components){
            let contours = this._font.getGlyph(component.glyphID)._getContours();
            for(let i = 0; i < contours.length; i++){
                let contour = contours[i];
                for(let j = 0; j < contour.length; j++){
                    let point = contour[j];
                    let x = point.x * component.scaleX + point.y * component.scale01 + component.dx;
                    let y = point.y * component.scaleY + point.x * component.scale10 + component.dy;
                    points.push(new $6d519e6f260f4e02$var$$69aac16029968692$export$baf26146a414f24a(point.onCurve, point.endContour, x, y));
                }
            }
        }
        else points = glyph.points || [];
        // Recompute and cache metrics if we performed variation processing, and don't have an HVAR table
        if (glyph.phantomPoints && !this._font.directory.tables.HVAR) {
            this._metrics.advanceWidth = glyph.phantomPoints[1].x - glyph.phantomPoints[0].x;
            this._metrics.advanceHeight = glyph.phantomPoints[3].y - glyph.phantomPoints[2].y;
            this._metrics.leftBearing = glyph.xMin - glyph.phantomPoints[0].x;
            this._metrics.topBearing = glyph.phantomPoints[2].y - glyph.yMax;
        }
        let contours = [];
        let cur = [];
        for(let k = 0; k < points.length; k++){
            var point = points[k];
            cur.push(point);
            if (point.endContour) {
                contours.push(cur);
                cur = [];
            }
        }
        return contours;
    }
    _getMetrics() {
        if (this._metrics) return this._metrics;
        let cbox = this._getCBox(true);
        super._getMetrics(cbox);
        if (this._font._variationProcessor && !this._font.HVAR) this.path;
        return this._metrics;
    }
    // Converts contours to a Path object that can be rendered
    _getPath() {
        let contours = this._getContours();
        let path = new $6d519e6f260f4e02$var$$f43aec954cdfdf21$export$2e2bcd8739ae039;
        for(let i = 0; i < contours.length; i++){
            let contour = contours[i];
            let firstPt = contour[0];
            let lastPt = contour[contour.length - 1];
            let start = 0;
            if (firstPt.onCurve) {
                // The first point will be consumed by the moveTo command, so skip in the loop
                var curvePt = null;
                start = 1;
            } else {
                if (lastPt.onCurve) firstPt = lastPt;
                else firstPt = new $6d519e6f260f4e02$var$$69aac16029968692$export$baf26146a414f24a(false, false, (firstPt.x + lastPt.x) / 2, (firstPt.y + lastPt.y) / 2);
                var curvePt = firstPt;
            }
            path.moveTo(firstPt.x, firstPt.y);
            for(let j = start; j < contour.length; j++){
                let pt = contour[j];
                let prevPt = j === 0 ? firstPt : contour[j - 1];
                if (prevPt.onCurve && pt.onCurve) path.lineTo(pt.x, pt.y);
                else if (prevPt.onCurve && !pt.onCurve) var curvePt = pt;
                else if (!prevPt.onCurve && !pt.onCurve) {
                    let midX = (prevPt.x + pt.x) / 2;
                    let midY = (prevPt.y + pt.y) / 2;
                    path.quadraticCurveTo(prevPt.x, prevPt.y, midX, midY);
                    var curvePt = pt;
                } else if (!prevPt.onCurve && pt.onCurve) {
                    path.quadraticCurveTo(curvePt.x, curvePt.y, pt.x, pt.y);
                    var curvePt = null;
                } else throw new Error("Unknown TTF path state");
            }
            // Connect the first and last points
            if (curvePt) path.quadraticCurveTo(curvePt.x, curvePt.y, firstPt.x, firstPt.y);
            path.closePath();
        }
        return path;
    }
    constructor(...args){
        super(...args);
        (0, $1d8e073d1256147c$export$71511d61b312f219)(this, "type", 'TTF');
    }
}
class $6d519e6f260f4e02$var$$62cc5109c6101893$export$2e2bcd8739ae039 extends $6d519e6f260f4e02$var$$f92906be28e61769$export$2e2bcd8739ae039 {
    _getName() {
        if (this._font.CFF2) return super._getName();
        return this._font['CFF '].getGlyphName(this.id);
    }
    bias(s) {
        if (s.length < 1240) return 107;
        else if (s.length < 33900) return 1131;
        else return 32768;
    }
    _getPath() {
        let cff = this._font.CFF2 || this._font['CFF '];
        let { stream: stream } = cff;
        let str = cff.topDict.CharStrings[this.id];
        let end = str.offset + str.length;
        stream.pos = str.offset;
        let path = new $6d519e6f260f4e02$var$$f43aec954cdfdf21$export$2e2bcd8739ae039;
        let stack = [];
        let trans = [];
        let width = null;
        let nStems = 0;
        let x = 0, y = 0;
        let usedGsubrs;
        let usedSubrs;
        let open = false;
        this._usedGsubrs = usedGsubrs = {};
        this._usedSubrs = usedSubrs = {};
        let gsubrs = cff.globalSubrIndex || [];
        let gsubrsBias = this.bias(gsubrs);
        let privateDict = cff.privateDictForGlyph(this.id) || {};
        let subrs = privateDict.Subrs || [];
        let subrsBias = this.bias(subrs);
        let vstore = cff.topDict.vstore && cff.topDict.vstore.itemVariationStore;
        let vsindex = privateDict.vsindex;
        let variationProcessor = this._font._variationProcessor;
        function checkWidth() {
            if (width == null) width = stack.shift() + privateDict.nominalWidthX;
        }
        function parseStems() {
            if (stack.length % 2 !== 0) checkWidth();
            nStems += stack.length >> 1;
            return stack.length = 0;
        }
        function moveTo(x, y) {
            if (open) path.closePath();
            path.moveTo(x, y);
            open = true;
        }
        let parse = function() {
            while(stream.pos < end){
                let op = stream.readUInt8();
                if (op < 32) {
                    let index, subr, phase;
                    let c1x, c1y, c2x, c2y, c3x, c3y;
                    let c4x, c4y, c5x, c5y, c6x, c6y;
                    let pts;
                    switch(op){
                        case 1:
                        case 3:
                        case 18:
                        case 23:
                            parseStems();
                            break;
                        case 4:
                            if (stack.length > 1) checkWidth();
                            y += stack.shift();
                            moveTo(x, y);
                            break;
                        case 5:
                            while(stack.length >= 2){
                                x += stack.shift();
                                y += stack.shift();
                                path.lineTo(x, y);
                            }
                            break;
                        case 6:
                        case 7:
                            phase = op === 6;
                            while(stack.length >= 1){
                                if (phase) x += stack.shift();
                                else y += stack.shift();
                                path.lineTo(x, y);
                                phase = !phase;
                            }
                            break;
                        case 8:
                            while(stack.length > 0){
                                c1x = x + stack.shift();
                                c1y = y + stack.shift();
                                c2x = c1x + stack.shift();
                                c2y = c1y + stack.shift();
                                x = c2x + stack.shift();
                                y = c2y + stack.shift();
                                path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                            }
                            break;
                        case 10:
                            index = stack.pop() + subrsBias;
                            subr = subrs[index];
                            if (subr) {
                                usedSubrs[index] = true;
                                let p = stream.pos;
                                let e = end;
                                stream.pos = subr.offset;
                                end = subr.offset + subr.length;
                                parse();
                                stream.pos = p;
                                end = e;
                            }
                            break;
                        case 11:
                            if (cff.version >= 2) break;
                            return;
                        case 14:
                            if (cff.version >= 2) break;
                            if (stack.length > 0) checkWidth();
                            if (open) {
                                path.closePath();
                                open = false;
                            }
                            break;
                        case 15:
                            if (cff.version < 2) throw new Error('vsindex operator not supported in CFF v1');
                            vsindex = stack.pop();
                            break;
                        case 16:
                            {
                                if (cff.version < 2) throw new Error('blend operator not supported in CFF v1');
                                if (!variationProcessor) throw new Error('blend operator in non-variation font');
                                let blendVector = variationProcessor.getBlendVector(vstore, vsindex);
                                let numBlends = stack.pop();
                                let numOperands = numBlends * blendVector.length;
                                let delta = stack.length - numOperands;
                                let base = delta - numBlends;
                                for(let i = 0; i < numBlends; i++){
                                    let sum = stack[base + i];
                                    for(let j = 0; j < blendVector.length; j++)sum += blendVector[j] * stack[delta++];
                                    stack[base + i] = sum;
                                }
                                while(numOperands--)stack.pop();
                                break;
                            }
                        case 19:
                        case 20:
                            parseStems();
                            stream.pos += nStems + 7 >> 3;
                            break;
                        case 21:
                            if (stack.length > 2) checkWidth();
                            x += stack.shift();
                            y += stack.shift();
                            moveTo(x, y);
                            break;
                        case 22:
                            if (stack.length > 1) checkWidth();
                            x += stack.shift();
                            moveTo(x, y);
                            break;
                        case 24:
                            while(stack.length >= 8){
                                c1x = x + stack.shift();
                                c1y = y + stack.shift();
                                c2x = c1x + stack.shift();
                                c2y = c1y + stack.shift();
                                x = c2x + stack.shift();
                                y = c2y + stack.shift();
                                path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                            }
                            x += stack.shift();
                            y += stack.shift();
                            path.lineTo(x, y);
                            break;
                        case 25:
                            while(stack.length >= 8){
                                x += stack.shift();
                                y += stack.shift();
                                path.lineTo(x, y);
                            }
                            c1x = x + stack.shift();
                            c1y = y + stack.shift();
                            c2x = c1x + stack.shift();
                            c2y = c1y + stack.shift();
                            x = c2x + stack.shift();
                            y = c2y + stack.shift();
                            path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                            break;
                        case 26:
                            if (stack.length % 2) x += stack.shift();
                            while(stack.length >= 4){
                                c1x = x;
                                c1y = y + stack.shift();
                                c2x = c1x + stack.shift();
                                c2y = c1y + stack.shift();
                                x = c2x;
                                y = c2y + stack.shift();
                                path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                            }
                            break;
                        case 27:
                            if (stack.length % 2) y += stack.shift();
                            while(stack.length >= 4){
                                c1x = x + stack.shift();
                                c1y = y;
                                c2x = c1x + stack.shift();
                                c2y = c1y + stack.shift();
                                x = c2x + stack.shift();
                                y = c2y;
                                path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                            }
                            break;
                        case 28:
                            stack.push(stream.readInt16BE());
                            break;
                        case 29:
                            index = stack.pop() + gsubrsBias;
                            subr = gsubrs[index];
                            if (subr) {
                                usedGsubrs[index] = true;
                                let p = stream.pos;
                                let e = end;
                                stream.pos = subr.offset;
                                end = subr.offset + subr.length;
                                parse();
                                stream.pos = p;
                                end = e;
                            }
                            break;
                        case 30:
                        case 31:
                            phase = op === 31;
                            while(stack.length >= 4){
                                if (phase) {
                                    c1x = x + stack.shift();
                                    c1y = y;
                                    c2x = c1x + stack.shift();
                                    c2y = c1y + stack.shift();
                                    y = c2y + stack.shift();
                                    x = c2x + (stack.length === 1 ? stack.shift() : 0);
                                } else {
                                    c1x = x;
                                    c1y = y + stack.shift();
                                    c2x = c1x + stack.shift();
                                    c2y = c1y + stack.shift();
                                    x = c2x + stack.shift();
                                    y = c2y + (stack.length === 1 ? stack.shift() : 0);
                                }
                                path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                                phase = !phase;
                            }
                            break;
                        case 12:
                            op = stream.readUInt8();
                            switch(op){
                                case 3:
                                    let a = stack.pop();
                                    let b = stack.pop();
                                    stack.push(a && b ? 1 : 0);
                                    break;
                                case 4:
                                    a = stack.pop();
                                    b = stack.pop();
                                    stack.push(a || b ? 1 : 0);
                                    break;
                                case 5:
                                    a = stack.pop();
                                    stack.push(a ? 0 : 1);
                                    break;
                                case 9:
                                    a = stack.pop();
                                    stack.push(Math.abs(a));
                                    break;
                                case 10:
                                    a = stack.pop();
                                    b = stack.pop();
                                    stack.push(a + b);
                                    break;
                                case 11:
                                    a = stack.pop();
                                    b = stack.pop();
                                    stack.push(a - b);
                                    break;
                                case 12:
                                    a = stack.pop();
                                    b = stack.pop();
                                    stack.push(a / b);
                                    break;
                                case 14:
                                    a = stack.pop();
                                    stack.push(-a);
                                    break;
                                case 15:
                                    a = stack.pop();
                                    b = stack.pop();
                                    stack.push(a === b ? 1 : 0);
                                    break;
                                case 18:
                                    stack.pop();
                                    break;
                                case 20:
                                    let val = stack.pop();
                                    let idx = stack.pop();
                                    trans[idx] = val;
                                    break;
                                case 21:
                                    idx = stack.pop();
                                    stack.push(trans[idx] || 0);
                                    break;
                                case 22:
                                    let s1 = stack.pop();
                                    let s2 = stack.pop();
                                    let v1 = stack.pop();
                                    let v2 = stack.pop();
                                    stack.push(v1 <= v2 ? s1 : s2);
                                    break;
                                case 23:
                                    stack.push(Math.random());
                                    break;
                                case 24:
                                    a = stack.pop();
                                    b = stack.pop();
                                    stack.push(a * b);
                                    break;
                                case 26:
                                    a = stack.pop();
                                    stack.push(Math.sqrt(a));
                                    break;
                                case 27:
                                    a = stack.pop();
                                    stack.push(a, a);
                                    break;
                                case 28:
                                    a = stack.pop();
                                    b = stack.pop();
                                    stack.push(b, a);
                                    break;
                                case 29:
                                    idx = stack.pop();
                                    if (idx < 0) idx = 0;
                                    else if (idx > stack.length - 1) idx = stack.length - 1;
                                    stack.push(stack[idx]);
                                    break;
                                case 30:
                                    let n = stack.pop();
                                    let j = stack.pop();
                                    if (j >= 0) while(j > 0){
                                        var t = stack[n - 1];
                                        for(let i = n - 2; i >= 0; i--)stack[i + 1] = stack[i];
                                        stack[0] = t;
                                        j--;
                                    }
                                    else while(j < 0){
                                        var t = stack[0];
                                        for(let i = 0; i <= n; i++)stack[i] = stack[i + 1];
                                        stack[n - 1] = t;
                                        j++;
                                    }
                                    break;
                                case 34:
                                    c1x = x + stack.shift();
                                    c1y = y;
                                    c2x = c1x + stack.shift();
                                    c2y = c1y + stack.shift();
                                    c3x = c2x + stack.shift();
                                    c3y = c2y;
                                    c4x = c3x + stack.shift();
                                    c4y = c3y;
                                    c5x = c4x + stack.shift();
                                    c5y = c4y;
                                    c6x = c5x + stack.shift();
                                    c6y = c5y;
                                    x = c6x;
                                    y = c6y;
                                    path.bezierCurveTo(c1x, c1y, c2x, c2y, c3x, c3y);
                                    path.bezierCurveTo(c4x, c4y, c5x, c5y, c6x, c6y);
                                    break;
                                case 35:
                                    pts = [];
                                    for(let i = 0; i <= 5; i++){
                                        x += stack.shift();
                                        y += stack.shift();
                                        pts.push(x, y);
                                    }
                                    path.bezierCurveTo(...pts.slice(0, 6));
                                    path.bezierCurveTo(...pts.slice(6));
                                    stack.shift(); // fd
                                    break;
                                case 36:
                                    c1x = x + stack.shift();
                                    c1y = y + stack.shift();
                                    c2x = c1x + stack.shift();
                                    c2y = c1y + stack.shift();
                                    c3x = c2x + stack.shift();
                                    c3y = c2y;
                                    c4x = c3x + stack.shift();
                                    c4y = c3y;
                                    c5x = c4x + stack.shift();
                                    c5y = c4y + stack.shift();
                                    c6x = c5x + stack.shift();
                                    c6y = c5y;
                                    x = c6x;
                                    y = c6y;
                                    path.bezierCurveTo(c1x, c1y, c2x, c2y, c3x, c3y);
                                    path.bezierCurveTo(c4x, c4y, c5x, c5y, c6x, c6y);
                                    break;
                                case 37:
                                    let startx = x;
                                    let starty = y;
                                    pts = [];
                                    for(let i = 0; i <= 4; i++){
                                        x += stack.shift();
                                        y += stack.shift();
                                        pts.push(x, y);
                                    }
                                    if (Math.abs(x - startx) > Math.abs(y - starty)) {
                                        x += stack.shift();
                                        y = starty;
                                    } else {
                                        x = startx;
                                        y += stack.shift();
                                    }
                                    pts.push(x, y);
                                    path.bezierCurveTo(...pts.slice(0, 6));
                                    path.bezierCurveTo(...pts.slice(6));
                                    break;
                                default:
                                    throw new Error(`Unknown op: 12 ${op}`);
                            }
                            break;
                        default:
                            throw new Error(`Unknown op: ${op}`);
                    }
                } else if (op < 247) stack.push(op - 139);
                else if (op < 251) {
                    var b1 = stream.readUInt8();
                    stack.push((op - 247) * 256 + b1 + 108);
                } else if (op < 255) {
                    var b1 = stream.readUInt8();
                    stack.push(-(op - 251) * 256 - b1 - 108);
                } else stack.push(stream.readInt32BE() / 65536);
            }
        };
        parse();
        if (open) path.closePath();
        return path;
    }
    constructor(...args){
        super(...args);
        (0, $1d8e073d1256147c$export$71511d61b312f219)(this, "type", 'CFF');
    }
}
let $6d519e6f260f4e02$var$$25d8f049c222084c$var$SBIXImage = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    originX: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    originY: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    type: new (0, $b2061d4384f873cb$export$89b8e0fa65f6a914)(4),
    data: new (0, $272db5812670c438$export$7d22a0eea6656474)((t)=>t.parent.buflen - t._currentOffset)
});
class $6d519e6f260f4e02$var$$25d8f049c222084c$export$2e2bcd8739ae039 extends $6d519e6f260f4e02$var$$69aac16029968692$export$2e2bcd8739ae039 {
    /**
   * Returns an object representing a glyph image at the given point size.
   * The object has a data property with a Buffer containing the actual image data,
   * along with the image type, and origin.
   *
   * @param {number} size
   * @return {object}
   */ getImageForSize(size) {
        for(let i = 0; i < this._font.sbix.imageTables.length; i++){
            var table = this._font.sbix.imageTables[i];
            if (table.ppem >= size) break;
        }
        let offsets = table.imageOffsets;
        let start = offsets[this.id];
        let end = offsets[this.id + 1];
        if (start === end) return null;
        this._font.stream.pos = start;
        return $6d519e6f260f4e02$var$$25d8f049c222084c$var$SBIXImage.decode(this._font.stream, {
            buflen: end - start
        });
    }
    render(ctx, size) {
        let img = this.getImageForSize(size);
        if (img != null) {
            let scale = size / this._font.unitsPerEm;
            ctx.image(img.data, {
                height: size,
                x: img.originX,
                y: (this.bbox.minY - img.originY) * scale
            });
        }
        if (this._font.sbix.flags.renderOutlines) super.render(ctx, size);
    }
    constructor(...args){
        super(...args);
        (0, $1d8e073d1256147c$export$71511d61b312f219)(this, "type", 'SBIX');
    }
}
class $6d519e6f260f4e02$var$$0d411f0165859681$var$COLRLayer {
    constructor(glyph, color){
        this.glyph = glyph;
        this.color = color;
    }
}
class $6d519e6f260f4e02$var$$0d411f0165859681$export$2e2bcd8739ae039 extends $6d519e6f260f4e02$var$$f92906be28e61769$export$2e2bcd8739ae039 {
    _getBBox() {
        let bbox = new $6d519e6f260f4e02$var$$f34600ab9d7f70d8$export$2e2bcd8739ae039;
        for(let i = 0; i < this.layers.length; i++){
            let layer = this.layers[i];
            let b = layer.glyph.bbox;
            bbox.addPoint(b.minX, b.minY);
            bbox.addPoint(b.maxX, b.maxY);
        }
        return bbox;
    }
    /**
   * Returns an array of objects containing the glyph and color for
   * each layer in the composite color glyph.
   * @type {object[]}
   */ get layers() {
        let cpal = this._font.CPAL;
        let colr = this._font.COLR;
        let low = 0;
        let high = colr.baseGlyphRecord.length - 1;
        while(low <= high){
            let mid = low + high >> 1;
            var rec = colr.baseGlyphRecord[mid];
            if (this.id < rec.gid) high = mid - 1;
            else if (this.id > rec.gid) low = mid + 1;
            else {
                var baseLayer = rec;
                break;
            }
        }
        // if base glyph not found in COLR table,
        // default to normal glyph from glyf or CFF
        if (baseLayer == null) {
            var g = this._font._getBaseGlyph(this.id);
            var color = {
                red: 0,
                green: 0,
                blue: 0,
                alpha: 255
            };
            return [
                new $6d519e6f260f4e02$var$$0d411f0165859681$var$COLRLayer(g, color)
            ];
        }
        // otherwise, return an array of all the layers
        let layers = [];
        for(let i = baseLayer.firstLayerIndex; i < baseLayer.firstLayerIndex + baseLayer.numLayers; i++){
            var rec = colr.layerRecords[i];
            var color = cpal.colorRecords[rec.paletteIndex];
            var g = this._font._getBaseGlyph(rec.gid);
            layers.push(new $6d519e6f260f4e02$var$$0d411f0165859681$var$COLRLayer(g, color));
        }
        return layers;
    }
    render(ctx, size) {
        for (let { glyph: glyph, color: color } of this.layers){
            ctx.fillColor([
                color.red,
                color.green,
                color.blue
            ], color.alpha / 255 * 100);
            glyph.render(ctx, size);
        }
        return;
    }
    constructor(...args){
        super(...args);
        (0, $1d8e073d1256147c$export$71511d61b312f219)(this, "type", 'COLR');
    }
}
const $6d519e6f260f4e02$var$$0bb840cac04e911b$var$TUPLES_SHARE_POINT_NUMBERS = 0x8000;
const $6d519e6f260f4e02$var$$0bb840cac04e911b$var$TUPLE_COUNT_MASK = 0x0fff;
const $6d519e6f260f4e02$var$$0bb840cac04e911b$var$EMBEDDED_TUPLE_COORD = 0x8000;
const $6d519e6f260f4e02$var$$0bb840cac04e911b$var$INTERMEDIATE_TUPLE = 0x4000;
const $6d519e6f260f4e02$var$$0bb840cac04e911b$var$PRIVATE_POINT_NUMBERS = 0x2000;
const $6d519e6f260f4e02$var$$0bb840cac04e911b$var$TUPLE_INDEX_MASK = 0x0fff;
const $6d519e6f260f4e02$var$$0bb840cac04e911b$var$POINTS_ARE_WORDS = 0x80;
const $6d519e6f260f4e02$var$$0bb840cac04e911b$var$POINT_RUN_COUNT_MASK = 0x7f;
const $6d519e6f260f4e02$var$$0bb840cac04e911b$var$DELTAS_ARE_ZERO = 0x80;
const $6d519e6f260f4e02$var$$0bb840cac04e911b$var$DELTAS_ARE_WORDS = 0x40;
const $6d519e6f260f4e02$var$$0bb840cac04e911b$var$DELTA_RUN_COUNT_MASK = 0x3f;
class $6d519e6f260f4e02$var$$0bb840cac04e911b$export$2e2bcd8739ae039 {
    normalizeCoords(coords) {
        // the default mapping is linear along each axis, in two segments:
        // from the minValue to defaultValue, and from defaultValue to maxValue.
        let normalized = [];
        for(var i = 0; i < this.font.fvar.axis.length; i++){
            let axis = this.font.fvar.axis[i];
            if (coords[i] < axis.defaultValue) normalized.push((coords[i] - axis.defaultValue + Number.EPSILON) / (axis.defaultValue - axis.minValue + Number.EPSILON));
            else normalized.push((coords[i] - axis.defaultValue + Number.EPSILON) / (axis.maxValue - axis.defaultValue + Number.EPSILON));
        }
        // if there is an avar table, the normalized value is calculated
        // by interpolating between the two nearest mapped values.
        if (this.font.avar) for(var i = 0; i < this.font.avar.segment.length; i++){
            let segment = this.font.avar.segment[i];
            for(let j = 0; j < segment.correspondence.length; j++){
                let pair = segment.correspondence[j];
                if (j >= 1 && normalized[i] < pair.fromCoord) {
                    let prev = segment.correspondence[j - 1];
                    normalized[i] = ((normalized[i] - prev.fromCoord) * (pair.toCoord - prev.toCoord) + Number.EPSILON) / (pair.fromCoord - prev.fromCoord + Number.EPSILON) + prev.toCoord;
                    break;
                }
            }
        }
        return normalized;
    }
    transformPoints(gid, glyphPoints) {
        if (!this.font.fvar || !this.font.gvar) return;
        let { gvar: gvar } = this.font;
        if (gid >= gvar.glyphCount) return;
        let offset = gvar.offsets[gid];
        if (offset === gvar.offsets[gid + 1]) return;
        // Read the gvar data for this glyph
        let { stream: stream } = this.font;
        stream.pos = offset;
        if (stream.pos >= stream.length) return;
        let tupleCount = stream.readUInt16BE();
        let offsetToData = offset + stream.readUInt16BE();
        if (tupleCount & $6d519e6f260f4e02$var$$0bb840cac04e911b$var$TUPLES_SHARE_POINT_NUMBERS) {
            var here = stream.pos;
            stream.pos = offsetToData;
            var sharedPoints = this.decodePoints();
            offsetToData = stream.pos;
            stream.pos = here;
        }
        let origPoints = glyphPoints.map((pt)=>pt.copy());
        tupleCount &= $6d519e6f260f4e02$var$$0bb840cac04e911b$var$TUPLE_COUNT_MASK;
        for(let i = 0; i < tupleCount; i++){
            let tupleDataSize = stream.readUInt16BE();
            let tupleIndex = stream.readUInt16BE();
            if (tupleIndex & $6d519e6f260f4e02$var$$0bb840cac04e911b$var$EMBEDDED_TUPLE_COORD) {
                var tupleCoords = [];
                for(let a = 0; a < gvar.axisCount; a++)tupleCoords.push(stream.readInt16BE() / 16384);
            } else {
                if ((tupleIndex & $6d519e6f260f4e02$var$$0bb840cac04e911b$var$TUPLE_INDEX_MASK) >= gvar.globalCoordCount) throw new Error('Invalid gvar table');
                var tupleCoords = gvar.globalCoords[tupleIndex & $6d519e6f260f4e02$var$$0bb840cac04e911b$var$TUPLE_INDEX_MASK];
            }
            if (tupleIndex & $6d519e6f260f4e02$var$$0bb840cac04e911b$var$INTERMEDIATE_TUPLE) {
                var startCoords = [];
                for(let a = 0; a < gvar.axisCount; a++)startCoords.push(stream.readInt16BE() / 16384);
                var endCoords = [];
                for(let a = 0; a < gvar.axisCount; a++)endCoords.push(stream.readInt16BE() / 16384);
            }
            // Get the factor at which to apply this tuple
            let factor = this.tupleFactor(tupleIndex, tupleCoords, startCoords, endCoords);
            if (factor === 0) {
                offsetToData += tupleDataSize;
                continue;
            }
            var here = stream.pos;
            stream.pos = offsetToData;
            if (tupleIndex & $6d519e6f260f4e02$var$$0bb840cac04e911b$var$PRIVATE_POINT_NUMBERS) var points = this.decodePoints();
            else var points = sharedPoints;
            // points.length = 0 means there are deltas for all points
            let nPoints = points.length === 0 ? glyphPoints.length : points.length;
            let xDeltas = this.decodeDeltas(nPoints);
            let yDeltas = this.decodeDeltas(nPoints);
            if (points.length === 0) for(let i = 0; i < glyphPoints.length; i++){
                var point = glyphPoints[i];
                point.x += Math.round(xDeltas[i] * factor);
                point.y += Math.round(yDeltas[i] * factor);
            }
            else {
                let outPoints = origPoints.map((pt)=>pt.copy());
                let hasDelta = glyphPoints.map(()=>false);
                for(let i = 0; i < points.length; i++){
                    let idx = points[i];
                    if (idx < glyphPoints.length) {
                        let point = outPoints[idx];
                        hasDelta[idx] = true;
                        point.x += xDeltas[i] * factor;
                        point.y += yDeltas[i] * factor;
                    }
                }
                this.interpolateMissingDeltas(outPoints, origPoints, hasDelta);
                for(let i = 0; i < glyphPoints.length; i++){
                    let deltaX = outPoints[i].x - origPoints[i].x;
                    let deltaY = outPoints[i].y - origPoints[i].y;
                    glyphPoints[i].x = Math.round(glyphPoints[i].x + deltaX);
                    glyphPoints[i].y = Math.round(glyphPoints[i].y + deltaY);
                }
            }
            offsetToData += tupleDataSize;
            stream.pos = here;
        }
    }
    decodePoints() {
        let stream = this.font.stream;
        let count = stream.readUInt8();
        if (count & $6d519e6f260f4e02$var$$0bb840cac04e911b$var$POINTS_ARE_WORDS) count = (count & $6d519e6f260f4e02$var$$0bb840cac04e911b$var$POINT_RUN_COUNT_MASK) << 8 | stream.readUInt8();
        let points = new Uint16Array(count);
        let i = 0;
        let point = 0;
        while(i < count){
            let run = stream.readUInt8();
            let runCount = (run & $6d519e6f260f4e02$var$$0bb840cac04e911b$var$POINT_RUN_COUNT_MASK) + 1;
            let fn = run & $6d519e6f260f4e02$var$$0bb840cac04e911b$var$POINTS_ARE_WORDS ? stream.readUInt16 : stream.readUInt8;
            for(let j = 0; j < runCount && i < count; j++){
                point += fn.call(stream);
                points[i++] = point;
            }
        }
        return points;
    }
    decodeDeltas(count) {
        let stream = this.font.stream;
        let i = 0;
        let deltas = new Int16Array(count);
        while(i < count){
            let run = stream.readUInt8();
            let runCount = (run & $6d519e6f260f4e02$var$$0bb840cac04e911b$var$DELTA_RUN_COUNT_MASK) + 1;
            if (run & $6d519e6f260f4e02$var$$0bb840cac04e911b$var$DELTAS_ARE_ZERO) i += runCount;
            else {
                let fn = run & $6d519e6f260f4e02$var$$0bb840cac04e911b$var$DELTAS_ARE_WORDS ? stream.readInt16BE : stream.readInt8;
                for(let j = 0; j < runCount && i < count; j++)deltas[i++] = fn.call(stream);
            }
        }
        return deltas;
    }
    tupleFactor(tupleIndex, tupleCoords, startCoords, endCoords) {
        let normalized = this.normalizedCoords;
        let { gvar: gvar } = this.font;
        let factor = 1;
        for(let i = 0; i < gvar.axisCount; i++){
            if (tupleCoords[i] === 0) continue;
            if (normalized[i] === 0) return 0;
            if ((tupleIndex & $6d519e6f260f4e02$var$$0bb840cac04e911b$var$INTERMEDIATE_TUPLE) === 0) {
                if (normalized[i] < Math.min(0, tupleCoords[i]) || normalized[i] > Math.max(0, tupleCoords[i])) return 0;
                factor = (factor * normalized[i] + Number.EPSILON) / (tupleCoords[i] + Number.EPSILON);
            } else {
                if (normalized[i] < startCoords[i] || normalized[i] > endCoords[i]) return 0;
                else if (normalized[i] < tupleCoords[i]) factor = factor * (normalized[i] - startCoords[i] + Number.EPSILON) / (tupleCoords[i] - startCoords[i] + Number.EPSILON);
                else factor = factor * (endCoords[i] - normalized[i] + Number.EPSILON) / (endCoords[i] - tupleCoords[i] + Number.EPSILON);
            }
        }
        return factor;
    }
    // Interpolates points without delta values.
    // Needed for the Ø and Q glyphs in Skia.
    // Algorithm from Freetype.
    interpolateMissingDeltas(points, inPoints, hasDelta) {
        if (points.length === 0) return;
        let point = 0;
        while(point < points.length){
            let firstPoint = point;
            // find the end point of the contour
            let endPoint = point;
            let pt = points[endPoint];
            while(!pt.endContour)pt = points[++endPoint];
            // find the first point that has a delta
            while(point <= endPoint && !hasDelta[point])point++;
            if (point > endPoint) continue;
            let firstDelta = point;
            let curDelta = point;
            point++;
            while(point <= endPoint){
                // find the next point with a delta, and interpolate intermediate points
                if (hasDelta[point]) {
                    this.deltaInterpolate(curDelta + 1, point - 1, curDelta, point, inPoints, points);
                    curDelta = point;
                }
                point++;
            }
            // shift contour if we only have a single delta
            if (curDelta === firstDelta) this.deltaShift(firstPoint, endPoint, curDelta, inPoints, points);
            else {
                // otherwise, handle the remaining points at the end and beginning of the contour
                this.deltaInterpolate(curDelta + 1, endPoint, curDelta, firstDelta, inPoints, points);
                if (firstDelta > 0) this.deltaInterpolate(firstPoint, firstDelta - 1, curDelta, firstDelta, inPoints, points);
            }
            point = endPoint + 1;
        }
    }
    deltaInterpolate(p1, p2, ref1, ref2, inPoints, outPoints) {
        if (p1 > p2) return;
        let iterable = [
            'x',
            'y'
        ];
        for(let i = 0; i < iterable.length; i++){
            let k = iterable[i];
            if (inPoints[ref1][k] > inPoints[ref2][k]) {
                var p = ref1;
                ref1 = ref2;
                ref2 = p;
            }
            let in1 = inPoints[ref1][k];
            let in2 = inPoints[ref2][k];
            let out1 = outPoints[ref1][k];
            let out2 = outPoints[ref2][k];
            // If the reference points have the same coordinate but different
            // delta, inferred delta is zero.  Otherwise interpolate.
            if (in1 !== in2 || out1 === out2) {
                let scale = in1 === in2 ? 0 : (out2 - out1) / (in2 - in1);
                for(let p = p1; p <= p2; p++){
                    let out = inPoints[p][k];
                    if (out <= in1) out += out1 - in1;
                    else if (out >= in2) out += out2 - in2;
                    else out = out1 + (out - in1) * scale;
                    outPoints[p][k] = out;
                }
            }
        }
    }
    deltaShift(p1, p2, ref, inPoints, outPoints) {
        let deltaX = outPoints[ref].x - inPoints[ref].x;
        let deltaY = outPoints[ref].y - inPoints[ref].y;
        if (deltaX === 0 && deltaY === 0) return;
        for(let p = p1; p <= p2; p++)if (p !== ref) {
            outPoints[p].x += deltaX;
            outPoints[p].y += deltaY;
        }
    }
    getAdvanceAdjustment(gid, table) {
        let outerIndex, innerIndex;
        if (table.advanceWidthMapping) {
            let idx = gid;
            if (idx >= table.advanceWidthMapping.mapCount) idx = table.advanceWidthMapping.mapCount - 1;
            let entryFormat = table.advanceWidthMapping.entryFormat;
            ({ outerIndex: outerIndex, innerIndex: innerIndex } = table.advanceWidthMapping.mapData[idx]);
        } else {
            outerIndex = 0;
            innerIndex = gid;
        }
        return this.getDelta(table.itemVariationStore, outerIndex, innerIndex);
    }
    // See pseudo code from `Font Variations Overview'
    // in the OpenType specification.
    getDelta(itemStore, outerIndex, innerIndex) {
        if (outerIndex >= itemStore.itemVariationData.length) return 0;
        let varData = itemStore.itemVariationData[outerIndex];
        if (innerIndex >= varData.deltaSets.length) return 0;
        let deltaSet = varData.deltaSets[innerIndex];
        let blendVector = this.getBlendVector(itemStore, outerIndex);
        let netAdjustment = 0;
        for(let master = 0; master < varData.regionIndexCount; master++)netAdjustment += deltaSet.deltas[master] * blendVector[master];
        return netAdjustment;
    }
    getBlendVector(itemStore, outerIndex) {
        let varData = itemStore.itemVariationData[outerIndex];
        if (this.blendVectors.has(varData)) return this.blendVectors.get(varData);
        let normalizedCoords = this.normalizedCoords;
        let blendVector = [];
        // outer loop steps through master designs to be blended
        for(let master = 0; master < varData.regionIndexCount; master++){
            let scalar = 1;
            let regionIndex = varData.regionIndexes[master];
            let axes = itemStore.variationRegionList.variationRegions[regionIndex];
            // inner loop steps through axes in this region
            for(let j = 0; j < axes.length; j++){
                let axis = axes[j];
                let axisScalar;
                // compute the scalar contribution of this axis
                // ignore invalid ranges
                if (axis.startCoord > axis.peakCoord || axis.peakCoord > axis.endCoord) axisScalar = 1;
                else if (axis.startCoord < 0 && axis.endCoord > 0 && axis.peakCoord !== 0) axisScalar = 1;
                else if (axis.peakCoord === 0) axisScalar = 1;
                else if (normalizedCoords[j] < axis.startCoord || normalizedCoords[j] > axis.endCoord) axisScalar = 0;
                else {
                    if (normalizedCoords[j] === axis.peakCoord) axisScalar = 1;
                    else if (normalizedCoords[j] < axis.peakCoord) axisScalar = (normalizedCoords[j] - axis.startCoord + Number.EPSILON) / (axis.peakCoord - axis.startCoord + Number.EPSILON);
                    else axisScalar = (axis.endCoord - normalizedCoords[j] + Number.EPSILON) / (axis.endCoord - axis.peakCoord + Number.EPSILON);
                }
                // take product of all the axis scalars
                scalar *= axisScalar;
            }
            blendVector[master] = scalar;
        }
        this.blendVectors.set(varData, blendVector);
        return blendVector;
    }
    constructor(font, coords){
        this.font = font;
        this.normalizedCoords = this.normalizeCoords(coords);
        this.blendVectors = new Map;
    }
}
const $6d519e6f260f4e02$var$$5cc7476da92df375$var$resolved = Promise.resolve();
class $6d519e6f260f4e02$var$$5cc7476da92df375$export$2e2bcd8739ae039 {
    includeGlyph(glyph) {
        if (typeof glyph === 'object') glyph = glyph.id;
        if (this.mapping[glyph] == null) {
            this.glyphs.push(glyph);
            this.mapping[glyph] = this.glyphs.length - 1;
        }
        return this.mapping[glyph];
    }
    constructor(font){
        this.font = font;
        this.glyphs = [];
        this.mapping = {};
        // always include the missing glyph
        this.includeGlyph(0);
    }
}
// Flags for simple glyphs
const $6d519e6f260f4e02$var$$807e58506be70005$var$ON_CURVE = 1;
const $6d519e6f260f4e02$var$$807e58506be70005$var$X_SHORT_VECTOR = 2;
const $6d519e6f260f4e02$var$$807e58506be70005$var$Y_SHORT_VECTOR = 4;
const $6d519e6f260f4e02$var$$807e58506be70005$var$REPEAT = 8;
const $6d519e6f260f4e02$var$$807e58506be70005$var$SAME_X = 16;
const $6d519e6f260f4e02$var$$807e58506be70005$var$SAME_Y = 32;
class $6d519e6f260f4e02$var$$807e58506be70005$var$Point {
    static size(val) {
        return val >= 0 && val <= 255 ? 1 : 2;
    }
    static encode(stream, value) {
        if (value >= 0 && value <= 255) stream.writeUInt8(value);
        else stream.writeInt16BE(value);
    }
}
let $6d519e6f260f4e02$var$$807e58506be70005$var$Glyf = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    numberOfContours: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    xMin: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    yMin: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    xMax: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    yMax: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    endPtsOfContours: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), 'numberOfContours'),
    instructions: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$52e103c63c4e68cf), (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456)),
    flags: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$52e103c63c4e68cf), 0),
    xPoints: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$807e58506be70005$var$Point, 0),
    yPoints: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$807e58506be70005$var$Point, 0)
});
class $6d519e6f260f4e02$var$$807e58506be70005$export$2e2bcd8739ae039 {
    encodeSimple(path, instructions = []) {
        let endPtsOfContours = [];
        let xPoints = [];
        let yPoints = [];
        let flags = [];
        let same = 0;
        let lastX = 0, lastY = 0, lastFlag = 0;
        let pointCount = 0;
        for(let i = 0; i < path.commands.length; i++){
            let c = path.commands[i];
            for(let j = 0; j < c.args.length; j += 2){
                let x = c.args[j];
                let y = c.args[j + 1];
                let flag = 0;
                // If the ending point of a quadratic curve is the midpoint
                // between the control point and the control point of the next
                // quadratic curve, we can omit the ending point.
                if (c.command === 'quadraticCurveTo' && j === 2) {
                    let next = path.commands[i + 1];
                    if (next && next.command === 'quadraticCurveTo') {
                        let midX = (lastX + next.args[0]) / 2;
                        let midY = (lastY + next.args[1]) / 2;
                        if (x === midX && y === midY) continue;
                    }
                }
                // All points except control points are on curve.
                if (!(c.command === 'quadraticCurveTo' && j === 0)) flag |= $6d519e6f260f4e02$var$$807e58506be70005$var$ON_CURVE;
                flag = this._encodePoint(x, lastX, xPoints, flag, $6d519e6f260f4e02$var$$807e58506be70005$var$X_SHORT_VECTOR, $6d519e6f260f4e02$var$$807e58506be70005$var$SAME_X);
                flag = this._encodePoint(y, lastY, yPoints, flag, $6d519e6f260f4e02$var$$807e58506be70005$var$Y_SHORT_VECTOR, $6d519e6f260f4e02$var$$807e58506be70005$var$SAME_Y);
                if (flag === lastFlag && same < 255) {
                    flags[flags.length - 1] |= $6d519e6f260f4e02$var$$807e58506be70005$var$REPEAT;
                    same++;
                } else {
                    if (same > 0) {
                        flags.push(same);
                        same = 0;
                    }
                    flags.push(flag);
                    lastFlag = flag;
                }
                lastX = x;
                lastY = y;
                pointCount++;
            }
            if (c.command === 'closePath') endPtsOfContours.push(pointCount - 1);
        }
        // Close the path if the last command didn't already
        if (path.commands.length > 1 && path.commands[path.commands.length - 1].command !== 'closePath') endPtsOfContours.push(pointCount - 1);
        let bbox = path.bbox;
        let glyf = {
            numberOfContours: endPtsOfContours.length,
            xMin: bbox.minX,
            yMin: bbox.minY,
            xMax: bbox.maxX,
            yMax: bbox.maxY,
            endPtsOfContours: endPtsOfContours,
            instructions: instructions,
            flags: flags,
            xPoints: xPoints,
            yPoints: yPoints
        };
        let size = $6d519e6f260f4e02$var$$807e58506be70005$var$Glyf.size(glyf);
        let tail = 4 - size % 4;
        let stream = new (0, $68a919ce215921d9$export$9b4f661deaa36c3e)(size + tail);
        $6d519e6f260f4e02$var$$807e58506be70005$var$Glyf.encode(stream, glyf);
        // Align to 4-byte length
        if (tail !== 0) stream.fill(0, tail);
        return stream.buffer;
    }
    _encodePoint(value, last, points, flag, shortFlag, sameFlag) {
        let diff = value - last;
        if (value === last) flag |= sameFlag;
        else {
            if (-255 <= diff && diff <= 255) {
                flag |= shortFlag;
                if (diff < 0) diff = -diff;
                else flag |= sameFlag;
            }
            points.push(diff);
        }
        return flag;
    }
}
class $6d519e6f260f4e02$var$$4abbb6a5dbdc441a$export$2e2bcd8739ae039 extends $6d519e6f260f4e02$var$$5cc7476da92df375$export$2e2bcd8739ae039 {
    _addGlyph(gid) {
        let glyph = this.font.getGlyph(gid);
        let glyf = glyph._decode();
        // get the offset to the glyph from the loca table
        let curOffset = this.font.loca.offsets[gid];
        let nextOffset = this.font.loca.offsets[gid + 1];
        let stream = this.font._getTableStream('glyf');
        stream.pos += curOffset;
        let buffer = stream.readBuffer(nextOffset - curOffset);
        // if it is a compound glyph, include its components
        if (glyf && glyf.numberOfContours < 0) {
            buffer = new Uint8Array(buffer);
            let view = new DataView(buffer.buffer);
            for (let component of glyf.components){
                gid = this.includeGlyph(component.glyphID);
                view.setUint16(component.pos, gid);
            }
        } else if (glyf && this.font._variationProcessor) buffer = this.glyphEncoder.encodeSimple(glyph.path, glyf.instructions);
        this.glyf.push(buffer);
        this.loca.offsets.push(this.offset);
        this.hmtx.metrics.push({
            advance: glyph.advanceWidth,
            bearing: glyph._getMetrics().leftBearing
        });
        this.offset += buffer.length;
        return this.glyf.length - 1;
    }
    encode() {
        // tables required by PDF spec:
        //   head, hhea, loca, maxp, cvt , prep, glyf, hmtx, fpgm
        //
        // additional tables required for standalone fonts:
        //   name, cmap, OS/2, post
        this.glyf = [];
        this.offset = 0;
        this.loca = {
            offsets: [],
            version: this.font.loca.version
        };
        this.hmtx = {
            metrics: [],
            bearings: []
        };
        // include all the glyphs
        // not using a for loop because we need to support adding more
        // glyphs to the array as we go, and CoffeeScript caches the length.
        let i = 0;
        while(i < this.glyphs.length)this._addGlyph(this.glyphs[i++]);
        let maxp = (0, (/*@__PURE__*/$parcel$interopDefault($13713ba45ec0095d$exports)))(this.font.maxp);
        maxp.numGlyphs = this.glyf.length;
        this.loca.offsets.push(this.offset);
        let head = (0, (/*@__PURE__*/$parcel$interopDefault($13713ba45ec0095d$exports)))(this.font.head);
        head.indexToLocFormat = this.loca.version;
        let hhea = (0, (/*@__PURE__*/$parcel$interopDefault($13713ba45ec0095d$exports)))(this.font.hhea);
        hhea.numberOfMetrics = this.hmtx.metrics.length;
        // map = []
        // for index in [0...256]
        //     if index < @numGlyphs
        //         map[index] = index
        //     else
        //         map[index] = 0
        //
        // cmapTable =
        //     version: 0
        //     length: 262
        //     language: 0
        //     codeMap: map
        //
        // cmap =
        //     version: 0
        //     numSubtables: 1
        //     tables: [
        //         platformID: 1
        //         encodingID: 0
        //         table: cmapTable
        //     ]
        // TODO: subset prep, cvt, fpgm?
        return $6d519e6f260f4e02$var$$816c07a04b6dba87$export$2e2bcd8739ae039.toBuffer({
            tables: {
                head: head,
                hhea: hhea,
                loca: this.loca,
                maxp: maxp,
                'cvt ': this.font['cvt '],
                prep: this.font.prep,
                glyf: this.glyf,
                hmtx: this.hmtx,
                fpgm: this.font.fpgm
            }
        });
    }
    constructor(font){
        super(font);
        this.glyphEncoder = new $6d519e6f260f4e02$var$$807e58506be70005$export$2e2bcd8739ae039;
    }
}
class $6d519e6f260f4e02$var$$001d739428a71d5a$export$2e2bcd8739ae039 extends $6d519e6f260f4e02$var$$5cc7476da92df375$export$2e2bcd8739ae039 {
    subsetCharstrings() {
        this.charstrings = [];
        let gsubrs = {};
        for (let gid of this.glyphs){
            this.charstrings.push(this.cff.getCharString(gid));
            let glyph = this.font.getGlyph(gid);
            let path = glyph.path; // this causes the glyph to be parsed
            for(let subr in glyph._usedGsubrs)gsubrs[subr] = true;
        }
        this.gsubrs = this.subsetSubrs(this.cff.globalSubrIndex, gsubrs);
    }
    subsetSubrs(subrs, used) {
        let res = [];
        for(let i = 0; i < subrs.length; i++){
            let subr = subrs[i];
            if (used[i]) {
                this.cff.stream.pos = subr.offset;
                res.push(this.cff.stream.readBuffer(subr.length));
            } else res.push(new Uint8Array([
                11
            ])); // return
        }
        return res;
    }
    subsetFontdict(topDict) {
        topDict.FDArray = [];
        topDict.FDSelect = {
            version: 0,
            fds: []
        };
        let used_fds = {};
        let used_subrs = [];
        let fd_select = {};
        for (let gid of this.glyphs){
            let fd = this.cff.fdForGlyph(gid);
            if (fd == null) continue;
            if (!used_fds[fd]) {
                topDict.FDArray.push(Object.assign({}, this.cff.topDict.FDArray[fd]));
                used_subrs.push({});
                fd_select[fd] = topDict.FDArray.length - 1;
            }
            used_fds[fd] = true;
            topDict.FDSelect.fds.push(fd_select[fd]);
            let glyph = this.font.getGlyph(gid);
            let path = glyph.path; // this causes the glyph to be parsed
            for(let subr in glyph._usedSubrs)used_subrs[fd_select[fd]][subr] = true;
        }
        for(let i = 0; i < topDict.FDArray.length; i++){
            let dict = topDict.FDArray[i];
            delete dict.FontName;
            if (dict.Private && dict.Private.Subrs) {
                dict.Private = Object.assign({}, dict.Private);
                dict.Private.Subrs = this.subsetSubrs(dict.Private.Subrs, used_subrs[i]);
            }
        }
        return;
    }
    createCIDFontdict(topDict) {
        let used_subrs = {};
        for (let gid of this.glyphs){
            let glyph = this.font.getGlyph(gid);
            let path = glyph.path; // this causes the glyph to be parsed
            for(let subr in glyph._usedSubrs)used_subrs[subr] = true;
        }
        let privateDict = Object.assign({}, this.cff.topDict.Private);
        if (this.cff.topDict.Private && this.cff.topDict.Private.Subrs) privateDict.Subrs = this.subsetSubrs(this.cff.topDict.Private.Subrs, used_subrs);
        topDict.FDArray = [
            {
                Private: privateDict
            }
        ];
        return topDict.FDSelect = {
            version: 3,
            nRanges: 1,
            ranges: [
                {
                    first: 0,
                    fd: 0
                }
            ],
            sentinel: this.charstrings.length
        };
    }
    addString(string) {
        if (!string) return null;
        if (!this.strings) this.strings = [];
        this.strings.push(string);
        return $6d519e6f260f4e02$var$$229224aec43783c5$export$2e2bcd8739ae039.length + this.strings.length - 1;
    }
    encode() {
        this.subsetCharstrings();
        let charset = {
            version: this.charstrings.length > 255 ? 2 : 1,
            ranges: [
                {
                    first: 1,
                    nLeft: this.charstrings.length - 2
                }
            ]
        };
        let topDict = Object.assign({}, this.cff.topDict);
        topDict.Private = null;
        topDict.charset = charset;
        topDict.Encoding = null;
        topDict.CharStrings = this.charstrings;
        for (let key of [
            'version',
            'Notice',
            'Copyright',
            'FullName',
            'FamilyName',
            'Weight',
            'PostScript',
            'BaseFontName',
            'FontName'
        ])topDict[key] = this.addString(this.cff.string(topDict[key]));
        topDict.ROS = [
            this.addString('Adobe'),
            this.addString('Identity'),
            0
        ];
        topDict.CIDCount = this.charstrings.length;
        if (this.cff.isCIDFont) this.subsetFontdict(topDict);
        else this.createCIDFontdict(topDict);
        let top = {
            version: 1,
            hdrSize: this.cff.hdrSize,
            offSize: 4,
            header: this.cff.header,
            nameIndex: [
                this.cff.postscriptName
            ],
            topDictIndex: [
                topDict
            ],
            stringIndex: this.strings,
            globalSubrIndex: this.gsubrs
        };
        return $6d519e6f260f4e02$var$$b84fd3dd9d8eddb2$export$2e2bcd8739ae039.toBuffer(top);
    }
    constructor(font){
        super(font);
        this.cff = this.font['CFF '];
        if (!this.cff) throw new Error('Not a CFF Font');
    }
}
class $6d519e6f260f4e02$var$$4c1709dee528ea76$export$2e2bcd8739ae039 {
    static probe(buffer) {
        let format = $6d519e6f260f4e02$var$$12727730ddfc8bfe$export$3d28c1996ced1f14.decode(buffer.slice(0, 4));
        return format === 'true' || format === 'OTTO' || format === String.fromCharCode(0, 1, 0, 0);
    }
    setDefaultLanguage(lang = null) {
        this.defaultLanguage = lang;
    }
    _getTable(table) {
        if (!(table.tag in this._tables)) try {
            this._tables[table.tag] = this._decodeTable(table);
        } catch (e) {
            if ($6d519e6f260f4e02$export$bd5c5d8b8dcafd78) {
                console.error(`Error decoding table ${table.tag}`);
                console.error(e.stack);
            }
        }
        return this._tables[table.tag];
    }
    _getTableStream(tag) {
        let table = this.directory.tables[tag];
        if (table) {
            this.stream.pos = table.offset;
            return this.stream;
        }
        return null;
    }
    _decodeDirectory() {
        return this.directory = $6d519e6f260f4e02$var$$816c07a04b6dba87$export$2e2bcd8739ae039.decode(this.stream, {
            _startOffset: 0
        });
    }
    _decodeTable(table) {
        let pos = this.stream.pos;
        let stream = this._getTableStream(table.tag);
        let result = $6d519e6f260f4e02$var$$c3395722bea751e2$export$2e2bcd8739ae039[table.tag].decode(stream, this, table.length);
        this.stream.pos = pos;
        return result;
    }
    /**
   * Gets a string from the font's `name` table
   * `lang` is a BCP-47 language code.
   * @return {string}
   */ getName(key, lang = this.defaultLanguage || $6d519e6f260f4e02$export$42940898df819940) {
        let record = this.name && this.name.records[key];
        if (record) return record[lang] || record[this.defaultLanguage] || record[$6d519e6f260f4e02$export$42940898df819940] || record['en'] || record[Object.keys(record)[0]] // Seriously, ANY language would be fine
         || null;
        return null;
    }
    /**
   * The unique PostScript name for this font, e.g. "Helvetica-Bold"
   * @type {string}
   */ get postscriptName() {
        return this.getName('postscriptName');
    }
    /**
   * The font's full name, e.g. "Helvetica Bold"
   * @type {string}
   */ get fullName() {
        return this.getName('fullName');
    }
    /**
   * The font's family name, e.g. "Helvetica"
   * @type {string}
   */ get familyName() {
        return this.getName('fontFamily');
    }
    /**
   * The font's sub-family, e.g. "Bold".
   * @type {string}
   */ get subfamilyName() {
        return this.getName('fontSubfamily');
    }
    /**
   * The font's copyright information
   * @type {string}
   */ get copyright() {
        return this.getName('copyright');
    }
    /**
   * The font's version number
   * @type {string}
   */ get version() {
        return this.getName('version');
    }
    /**
   * The font’s [ascender](https://en.wikipedia.org/wiki/Ascender_(typography))
   * @type {number}
   */ get ascent() {
        return this.hhea.ascent;
    }
    /**
   * The font’s [descender](https://en.wikipedia.org/wiki/Descender)
   * @type {number}
   */ get descent() {
        return this.hhea.descent;
    }
    /**
   * The amount of space that should be included between lines
   * @type {number}
   */ get lineGap() {
        return this.hhea.lineGap;
    }
    /**
   * The offset from the normal underline position that should be used
   * @type {number}
   */ get underlinePosition() {
        return this.post.underlinePosition;
    }
    /**
   * The weight of the underline that should be used
   * @type {number}
   */ get underlineThickness() {
        return this.post.underlineThickness;
    }
    /**
   * If this is an italic font, the angle the cursor should be drawn at to match the font design
   * @type {number}
   */ get italicAngle() {
        return this.post.italicAngle;
    }
    /**
   * The height of capital letters above the baseline.
   * See [here](https://en.wikipedia.org/wiki/Cap_height) for more details.
   * @type {number}
   */ get capHeight() {
        let os2 = this['OS/2'];
        return os2 ? os2.capHeight : this.ascent;
    }
    /**
   * The height of lower case letters in the font.
   * See [here](https://en.wikipedia.org/wiki/X-height) for more details.
   * @type {number}
   */ get xHeight() {
        let os2 = this['OS/2'];
        return os2 ? os2.xHeight : 0;
    }
    /**
   * The number of glyphs in the font.
   * @type {number}
   */ get numGlyphs() {
        return this.maxp.numGlyphs;
    }
    /**
   * The size of the font’s internal coordinate grid
   * @type {number}
   */ get unitsPerEm() {
        return this.head.unitsPerEm;
    }
    /**
   * The font’s bounding box, i.e. the box that encloses all glyphs in the font.
   * @type {BBox}
   */ get bbox() {
        return Object.freeze(new $6d519e6f260f4e02$var$$f34600ab9d7f70d8$export$2e2bcd8739ae039(this.head.xMin, this.head.yMin, this.head.xMax, this.head.yMax));
    }
    get _cmapProcessor() {
        return new $6d519e6f260f4e02$var$$f08dd41ef10b694c$export$2e2bcd8739ae039(this.cmap);
    }
    /**
   * An array of all of the unicode code points supported by the font.
   * @type {number[]}
   */ get characterSet() {
        return this._cmapProcessor.getCharacterSet();
    }
    /**
   * Returns whether there is glyph in the font for the given unicode code point.
   *
   * @param {number} codePoint
   * @return {boolean}
   */ hasGlyphForCodePoint(codePoint) {
        return !!this._cmapProcessor.lookup(codePoint);
    }
    /**
   * Maps a single unicode code point to a Glyph object.
   * Does not perform any advanced substitutions (there is no context to do so).
   *
   * @param {number} codePoint
   * @return {Glyph}
   */ glyphForCodePoint(codePoint) {
        return this.getGlyph(this._cmapProcessor.lookup(codePoint), [
            codePoint
        ]);
    }
    /**
   * Returns an array of Glyph objects for the given string.
   * This is only a one-to-one mapping from characters to glyphs.
   * For most uses, you should use font.layout (described below), which
   * provides a much more advanced mapping supporting AAT and OpenType shaping.
   *
   * @param {string} string
   * @return {Glyph[]}
   */ glyphsForString(string) {
        let glyphs = [];
        let len = string.length;
        let idx = 0;
        let last = -1;
        let state = -1;
        while(idx <= len){
            let code = 0;
            let nextState = 0;
            if (idx < len) {
                // Decode the next codepoint from UTF 16
                code = string.charCodeAt(idx++);
                if (0xd800 <= code && code <= 0xdbff && idx < len) {
                    let next = string.charCodeAt(idx);
                    if (0xdc00 <= next && next <= 0xdfff) {
                        idx++;
                        code = ((code & 0x3ff) << 10) + (next & 0x3ff) + 0x10000;
                    }
                }
                // Compute the next state: 1 if the next codepoint is a variation selector, 0 otherwise.
                nextState = 0xfe00 <= code && code <= 0xfe0f || 0xe0100 <= code && code <= 0xe01ef ? 1 : 0;
            } else idx++;
            if (state === 0 && nextState === 1) glyphs.push(this.getGlyph(this._cmapProcessor.lookup(last, code), [
                last,
                code
            ]));
            else if (state === 0 && nextState === 0) glyphs.push(this.glyphForCodePoint(last));
            last = code;
            state = nextState;
        }
        return glyphs;
    }
    get _layoutEngine() {
        return new $6d519e6f260f4e02$var$$4c0a7fa5df7a9ab1$export$2e2bcd8739ae039(this);
    }
    /**
   * Returns a GlyphRun object, which includes an array of Glyphs and GlyphPositions for the given string.
   *
   * @param {string} string
   * @param {string[]} [userFeatures]
   * @param {string} [script]
   * @param {string} [language]
   * @param {string} [direction]
   * @return {GlyphRun}
   */ layout(string, userFeatures, script, language, direction) {
        return this._layoutEngine.layout(string, userFeatures, script, language, direction);
    }
    /**
   * Returns an array of strings that map to the given glyph id.
   * @param {number} gid - glyph id
   */ stringsForGlyph(gid) {
        return this._layoutEngine.stringsForGlyph(gid);
    }
    /**
   * An array of all [OpenType feature tags](https://www.microsoft.com/typography/otspec/featuretags.htm)
   * (or mapped AAT tags) supported by the font.
   * The features parameter is an array of OpenType feature tags to be applied in addition to the default set.
   * If this is an AAT font, the OpenType feature tags are mapped to AAT features.
   *
   * @type {string[]}
   */ get availableFeatures() {
        return this._layoutEngine.getAvailableFeatures();
    }
    getAvailableFeatures(script, language) {
        return this._layoutEngine.getAvailableFeatures(script, language);
    }
    _getBaseGlyph(glyph, characters = []) {
        if (!this._glyphs[glyph]) {
            if (this.directory.tables.glyf) this._glyphs[glyph] = new $6d519e6f260f4e02$var$$69aac16029968692$export$2e2bcd8739ae039(glyph, characters, this);
            else if (this.directory.tables['CFF '] || this.directory.tables.CFF2) this._glyphs[glyph] = new $6d519e6f260f4e02$var$$62cc5109c6101893$export$2e2bcd8739ae039(glyph, characters, this);
        }
        return this._glyphs[glyph] || null;
    }
    /**
   * Returns a glyph object for the given glyph id.
   * You can pass the array of code points this glyph represents for
   * your use later, and it will be stored in the glyph object.
   *
   * @param {number} glyph
   * @param {number[]} characters
   * @return {Glyph}
   */ getGlyph(glyph, characters = []) {
        if (!this._glyphs[glyph]) {
            if (this.directory.tables.sbix) this._glyphs[glyph] = new $6d519e6f260f4e02$var$$25d8f049c222084c$export$2e2bcd8739ae039(glyph, characters, this);
            else if (this.directory.tables.COLR && this.directory.tables.CPAL) this._glyphs[glyph] = new $6d519e6f260f4e02$var$$0d411f0165859681$export$2e2bcd8739ae039(glyph, characters, this);
            else this._getBaseGlyph(glyph, characters);
        }
        return this._glyphs[glyph] || null;
    }
    /**
   * Returns a Subset for this font.
   * @return {Subset}
   */ createSubset() {
        if (this.directory.tables['CFF ']) return new $6d519e6f260f4e02$var$$001d739428a71d5a$export$2e2bcd8739ae039(this);
        return new $6d519e6f260f4e02$var$$4abbb6a5dbdc441a$export$2e2bcd8739ae039(this);
    }
    /**
   * Returns an object describing the available variation axes
   * that this font supports. Keys are setting tags, and values
   * contain the axis name, range, and default value.
   *
   * @type {object}
   */ get variationAxes() {
        let res = {};
        if (!this.fvar) return res;
        for (let axis of this.fvar.axis)res[axis.axisTag.trim()] = {
            name: axis.name.en,
            min: axis.minValue,
            default: axis.defaultValue,
            max: axis.maxValue
        };
        return res;
    }
    /**
   * Returns an object describing the named variation instances
   * that the font designer has specified. Keys are variation names
   * and values are the variation settings for this instance.
   *
   * @type {object}
   */ get namedVariations() {
        let res = {};
        if (!this.fvar) return res;
        for (let instance of this.fvar.instance){
            let settings = {};
            for(let i = 0; i < this.fvar.axis.length; i++){
                let axis = this.fvar.axis[i];
                settings[axis.axisTag.trim()] = instance.coord[i];
            }
            res[instance.name.en] = settings;
        }
        return res;
    }
    /**
   * Returns a new font with the given variation settings applied.
   * Settings can either be an instance name, or an object containing
   * variation tags as specified by the `variationAxes` property.
   *
   * @param {object} settings
   * @return {TTFFont}
   */ getVariation(settings) {
        if (!(this.directory.tables.fvar && (this.directory.tables.gvar && this.directory.tables.glyf || this.directory.tables.CFF2))) throw new Error('Variations require a font with the fvar, gvar and glyf, or CFF2 tables.');
        if (typeof settings === 'string') settings = this.namedVariations[settings];
        if (typeof settings !== 'object') throw new Error('Variation settings must be either a variation name or settings object.');
        // normalize the coordinates
        let coords = this.fvar.axis.map((axis, i)=>{
            let axisTag = axis.axisTag.trim();
            if (axisTag in settings) return Math.max(axis.minValue, Math.min(axis.maxValue, settings[axisTag]));
            else return axis.defaultValue;
        });
        let stream = new (0, $ddbeea1419c36d9b$export$c18b354bac7948e9)(this.stream.buffer);
        stream.pos = this._directoryPos;
        let font = new $6d519e6f260f4e02$var$$4c1709dee528ea76$export$2e2bcd8739ae039(stream, coords);
        font._tables = this._tables;
        return font;
    }
    get _variationProcessor() {
        if (!this.fvar) return null;
        let variationCoords = this.variationCoords;
        // Ignore if no variation coords and not CFF2
        if (!variationCoords && !this.CFF2) return null;
        if (!variationCoords) variationCoords = this.fvar.axis.map((axis)=>axis.defaultValue);
        return new $6d519e6f260f4e02$var$$0bb840cac04e911b$export$2e2bcd8739ae039(this, variationCoords);
    }
    // Standardized format plugin API
    getFont(name) {
        return this.getVariation(name);
    }
    constructor(stream, variationCoords = null){
        (0, $1d8e073d1256147c$export$71511d61b312f219)(this, "type", 'TTF');
        this.defaultLanguage = null;
        this.stream = stream;
        this.variationCoords = variationCoords;
        this._directoryPos = this.stream.pos;
        this._tables = {};
        this._glyphs = {};
        this._decodeDirectory();
        // define properties for each table to lazily parse
        for(let tag in this.directory.tables){
            let table = this.directory.tables[tag];
            if ($6d519e6f260f4e02$var$$c3395722bea751e2$export$2e2bcd8739ae039[tag] && table.length > 0) Object.defineProperty(this, tag, {
                get: this._getTable.bind(this, table)
            });
        }
    }
}
(0, $04dbd055bc5edd2b$export$29e00dfd3077644b)([
    $6d519e6f260f4e02$var$$e71565f2ce09cb6b$export$69a3209f1a06c04d
], $6d519e6f260f4e02$var$$4c1709dee528ea76$export$2e2bcd8739ae039.prototype, "bbox", null);
(0, $04dbd055bc5edd2b$export$29e00dfd3077644b)([
    $6d519e6f260f4e02$var$$e71565f2ce09cb6b$export$69a3209f1a06c04d
], $6d519e6f260f4e02$var$$4c1709dee528ea76$export$2e2bcd8739ae039.prototype, "_cmapProcessor", null);
(0, $04dbd055bc5edd2b$export$29e00dfd3077644b)([
    $6d519e6f260f4e02$var$$e71565f2ce09cb6b$export$69a3209f1a06c04d
], $6d519e6f260f4e02$var$$4c1709dee528ea76$export$2e2bcd8739ae039.prototype, "characterSet", null);
(0, $04dbd055bc5edd2b$export$29e00dfd3077644b)([
    $6d519e6f260f4e02$var$$e71565f2ce09cb6b$export$69a3209f1a06c04d
], $6d519e6f260f4e02$var$$4c1709dee528ea76$export$2e2bcd8739ae039.prototype, "_layoutEngine", null);
(0, $04dbd055bc5edd2b$export$29e00dfd3077644b)([
    $6d519e6f260f4e02$var$$e71565f2ce09cb6b$export$69a3209f1a06c04d
], $6d519e6f260f4e02$var$$4c1709dee528ea76$export$2e2bcd8739ae039.prototype, "variationAxes", null);
(0, $04dbd055bc5edd2b$export$29e00dfd3077644b)([
    $6d519e6f260f4e02$var$$e71565f2ce09cb6b$export$69a3209f1a06c04d
], $6d519e6f260f4e02$var$$4c1709dee528ea76$export$2e2bcd8739ae039.prototype, "namedVariations", null);
(0, $04dbd055bc5edd2b$export$29e00dfd3077644b)([
    $6d519e6f260f4e02$var$$e71565f2ce09cb6b$export$69a3209f1a06c04d
], $6d519e6f260f4e02$var$$4c1709dee528ea76$export$2e2bcd8739ae039.prototype, "_variationProcessor", null);
let $6d519e6f260f4e02$var$$c1726355ecc5b889$var$WOFFDirectoryEntry = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    tag: new (0, $b2061d4384f873cb$export$89b8e0fa65f6a914)(4),
    offset: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), 'void', {
        type: 'global'
    }),
    compLength: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    length: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    origChecksum: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d)
});
let $6d519e6f260f4e02$var$$c1726355ecc5b889$var$WOFFDirectory = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    tag: new (0, $b2061d4384f873cb$export$89b8e0fa65f6a914)(4),
    flavor: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    length: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    numTables: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    reserved: new (0, $f612a7b97d3685e8$export$da9b5fe187a9aa1)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456)),
    totalSfntSize: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    majorVersion: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    minorVersion: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    metaOffset: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    metaLength: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    metaOrigLength: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    privOffset: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    privLength: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    tables: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$c1726355ecc5b889$var$WOFFDirectoryEntry, 'numTables')
});
$6d519e6f260f4e02$var$$c1726355ecc5b889$var$WOFFDirectory.process = function() {
    let tables = {};
    for (let table of this.tables)tables[table.tag] = table;
    this.tables = tables;
};
var $6d519e6f260f4e02$var$$c1726355ecc5b889$export$2e2bcd8739ae039 = $6d519e6f260f4e02$var$$c1726355ecc5b889$var$WOFFDirectory;
class $6d519e6f260f4e02$var$$760785214b9fc52c$export$2e2bcd8739ae039 extends $6d519e6f260f4e02$var$$4c1709dee528ea76$export$2e2bcd8739ae039 {
    static probe(buffer) {
        return $6d519e6f260f4e02$var$$12727730ddfc8bfe$export$3d28c1996ced1f14.decode(buffer.slice(0, 4)) === 'wOFF';
    }
    _decodeDirectory() {
        this.directory = $6d519e6f260f4e02$var$$c1726355ecc5b889$export$2e2bcd8739ae039.decode(this.stream, {
            _startOffset: 0
        });
    }
    _getTableStream(tag) {
        let table = this.directory.tables[tag];
        if (table) {
            this.stream.pos = table.offset;
            if (table.compLength < table.length) {
                this.stream.pos += 2; // skip deflate header
                let outBuffer = new Uint8Array(table.length);
                let buf = (0, (/*@__PURE__*/$parcel$interopDefault($e3ea9b0a4b34b121$exports)))(this.stream.readBuffer(table.compLength - 2), outBuffer);
                return new (0, $ddbeea1419c36d9b$export$c18b354bac7948e9)(buf);
            } else return this.stream;
        }
        return null;
    }
    constructor(...args){
        super(...args);
        (0, $1d8e073d1256147c$export$71511d61b312f219)(this, "type", 'WOFF');
    }
}
class $6d519e6f260f4e02$var$$8046190c9f1ad19e$export$2e2bcd8739ae039 extends $6d519e6f260f4e02$var$$69aac16029968692$export$2e2bcd8739ae039 {
    _decode() {
        // We have to decode in advance (in WOFF2Font), so just return the pre-decoded data.
        return this._font._transformedGlyphs[this.id];
    }
    _getCBox() {
        return this.path.bbox;
    }
    constructor(...args){
        super(...args);
        (0, $1d8e073d1256147c$export$71511d61b312f219)(this, "type", 'WOFF2');
    }
}
const $6d519e6f260f4e02$var$$c28ec7bbb3b8de3a$var$Base128 = {
    decode (stream) {
        let result = 0;
        let iterable = [
            0,
            1,
            2,
            3,
            4
        ];
        for(let j = 0; j < iterable.length; j++){
            let i = iterable[j];
            let code = stream.readUInt8();
            // If any of the top seven bits are set then we're about to overflow.
            if (result & 0xe0000000) throw new Error('Overflow');
            result = result << 7 | code & 0x7f;
            if ((code & 0x80) === 0) return result;
        }
        throw new Error('Bad base 128 number');
    }
};
let $6d519e6f260f4e02$var$$c28ec7bbb3b8de3a$var$knownTags = [
    'cmap',
    'head',
    'hhea',
    'hmtx',
    'maxp',
    'name',
    'OS/2',
    'post',
    'cvt ',
    'fpgm',
    'glyf',
    'loca',
    'prep',
    'CFF ',
    'VORG',
    'EBDT',
    'EBLC',
    'gasp',
    'hdmx',
    'kern',
    'LTSH',
    'PCLT',
    'VDMX',
    'vhea',
    'vmtx',
    'BASE',
    'GDEF',
    'GPOS',
    'GSUB',
    'EBSC',
    'JSTF',
    'MATH',
    'CBDT',
    'CBLC',
    'COLR',
    'CPAL',
    'SVG ',
    'sbix',
    'acnt',
    'avar',
    'bdat',
    'bloc',
    'bsln',
    'cvar',
    'fdsc',
    'feat',
    'fmtx',
    'fvar',
    'gvar',
    'hsty',
    'just',
    'lcar',
    'mort',
    'morx',
    'opbd',
    'prop',
    'trak',
    'Zapf',
    'Silf',
    'Glat',
    'Gloc',
    'Feat',
    'Sill'
];
let $6d519e6f260f4e02$var$$c28ec7bbb3b8de3a$var$WOFF2DirectoryEntry = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    flags: (0, $2b9a2a5e7d043014$export$52e103c63c4e68cf),
    customTag: new (0, $72804d503192edec$export$7acb7b24c478f9c6)(new (0, $b2061d4384f873cb$export$89b8e0fa65f6a914)(4), (t)=>(t.flags & 0x3f) === 0x3f),
    tag: (t)=>t.customTag || $6d519e6f260f4e02$var$$c28ec7bbb3b8de3a$var$knownTags[t.flags & 0x3f],
    length: $6d519e6f260f4e02$var$$c28ec7bbb3b8de3a$var$Base128,
    transformVersion: (t)=>t.flags >>> 6 & 0x03,
    transformed: (t)=>t.tag === 'glyf' || t.tag === 'loca' ? t.transformVersion === 0 : t.transformVersion !== 0,
    transformLength: new (0, $72804d503192edec$export$7acb7b24c478f9c6)($6d519e6f260f4e02$var$$c28ec7bbb3b8de3a$var$Base128, (t)=>t.transformed)
});
let $6d519e6f260f4e02$var$$c28ec7bbb3b8de3a$var$WOFF2Directory = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    tag: new (0, $b2061d4384f873cb$export$89b8e0fa65f6a914)(4),
    flavor: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    length: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    numTables: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    reserved: new (0, $f612a7b97d3685e8$export$da9b5fe187a9aa1)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456)),
    totalSfntSize: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    totalCompressedSize: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    majorVersion: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    minorVersion: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    metaOffset: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    metaLength: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    metaOrigLength: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    privOffset: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    privLength: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    tables: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$c28ec7bbb3b8de3a$var$WOFF2DirectoryEntry, 'numTables')
});
$6d519e6f260f4e02$var$$c28ec7bbb3b8de3a$var$WOFF2Directory.process = function() {
    let tables = {};
    for(let i = 0; i < this.tables.length; i++){
        let table = this.tables[i];
        tables[table.tag] = table;
    }
    return this.tables = tables;
};
var $6d519e6f260f4e02$var$$c28ec7bbb3b8de3a$export$2e2bcd8739ae039 = $6d519e6f260f4e02$var$$c28ec7bbb3b8de3a$var$WOFF2Directory;
class $6d519e6f260f4e02$var$$21ee218f84ac7f32$export$2e2bcd8739ae039 extends $6d519e6f260f4e02$var$$4c1709dee528ea76$export$2e2bcd8739ae039 {
    static probe(buffer) {
        return $6d519e6f260f4e02$var$$12727730ddfc8bfe$export$3d28c1996ced1f14.decode(buffer.slice(0, 4)) === 'wOF2';
    }
    _decodeDirectory() {
        this.directory = $6d519e6f260f4e02$var$$c28ec7bbb3b8de3a$export$2e2bcd8739ae039.decode(this.stream);
        this._dataPos = this.stream.pos;
    }
    _decompress() {
        // decompress data and setup table offsets if we haven't already
        if (!this._decompressed) {
            this.stream.pos = this._dataPos;
            let buffer = this.stream.readBuffer(this.directory.totalCompressedSize);
            let decompressedSize = 0;
            for(let tag in this.directory.tables){
                let entry = this.directory.tables[tag];
                entry.offset = decompressedSize;
                decompressedSize += entry.transformLength != null ? entry.transformLength : entry.length;
            }
            let decompressed = (0, (/*@__PURE__*/$parcel$interopDefault($fd75a3cd9cfec8fb$exports)))(buffer, decompressedSize);
            if (!decompressed) throw new Error('Error decoding compressed data in WOFF2');
            this.stream = new (0, $ddbeea1419c36d9b$export$c18b354bac7948e9)(decompressed);
            this._decompressed = true;
        }
    }
    _decodeTable(table) {
        this._decompress();
        return super._decodeTable(table);
    }
    // Override this method to get a glyph and return our
    // custom subclass if there is a glyf table.
    _getBaseGlyph(glyph, characters = []) {
        if (!this._glyphs[glyph]) {
            if (this.directory.tables.glyf && this.directory.tables.glyf.transformed) {
                if (!this._transformedGlyphs) this._transformGlyfTable();
                return this._glyphs[glyph] = new $6d519e6f260f4e02$var$$8046190c9f1ad19e$export$2e2bcd8739ae039(glyph, characters, this);
            } else return super._getBaseGlyph(glyph, characters);
        }
    }
    _transformGlyfTable() {
        this._decompress();
        this.stream.pos = this.directory.tables.glyf.offset;
        let table = $6d519e6f260f4e02$var$$21ee218f84ac7f32$var$GlyfTable.decode(this.stream);
        let glyphs = [];
        for(let index = 0; index < table.numGlyphs; index++){
            let glyph = {};
            let nContours = table.nContours.readInt16BE();
            glyph.numberOfContours = nContours;
            if (nContours > 0) {
                let nPoints = [];
                let totalPoints = 0;
                for(let i = 0; i < nContours; i++){
                    let r = $6d519e6f260f4e02$var$$21ee218f84ac7f32$var$read255UInt16(table.nPoints);
                    totalPoints += r;
                    nPoints.push(totalPoints);
                }
                glyph.points = $6d519e6f260f4e02$var$$21ee218f84ac7f32$var$decodeTriplet(table.flags, table.glyphs, totalPoints);
                for(let i = 0; i < nContours; i++)glyph.points[nPoints[i] - 1].endContour = true;
                var instructionSize = $6d519e6f260f4e02$var$$21ee218f84ac7f32$var$read255UInt16(table.glyphs);
            } else if (nContours < 0) {
                let haveInstructions = $6d519e6f260f4e02$var$$69aac16029968692$export$2e2bcd8739ae039.prototype._decodeComposite.call({
                    _font: this
                }, glyph, table.composites);
                if (haveInstructions) var instructionSize = $6d519e6f260f4e02$var$$21ee218f84ac7f32$var$read255UInt16(table.glyphs);
            }
            glyphs.push(glyph);
        }
        this._transformedGlyphs = glyphs;
    }
    constructor(...args){
        super(...args);
        (0, $1d8e073d1256147c$export$71511d61b312f219)(this, "type", 'WOFF2');
    }
}
// Special class that accepts a length and returns a sub-stream for that data
class $6d519e6f260f4e02$var$$21ee218f84ac7f32$var$Substream {
    decode(stream, parent) {
        return new (0, $ddbeea1419c36d9b$export$c18b354bac7948e9)(this._buf.decode(stream, parent));
    }
    constructor(length){
        this.length = length;
        this._buf = new (0, $272db5812670c438$export$7d22a0eea6656474)(length);
    }
}
// This struct represents the entire glyf table
let $6d519e6f260f4e02$var$$21ee218f84ac7f32$var$GlyfTable = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    version: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    numGlyphs: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    indexFormat: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    nContourStreamSize: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    nPointsStreamSize: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    flagStreamSize: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    glyphStreamSize: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    compositeStreamSize: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    bboxStreamSize: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    instructionStreamSize: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    nContours: new $6d519e6f260f4e02$var$$21ee218f84ac7f32$var$Substream('nContourStreamSize'),
    nPoints: new $6d519e6f260f4e02$var$$21ee218f84ac7f32$var$Substream('nPointsStreamSize'),
    flags: new $6d519e6f260f4e02$var$$21ee218f84ac7f32$var$Substream('flagStreamSize'),
    glyphs: new $6d519e6f260f4e02$var$$21ee218f84ac7f32$var$Substream('glyphStreamSize'),
    composites: new $6d519e6f260f4e02$var$$21ee218f84ac7f32$var$Substream('compositeStreamSize'),
    bboxes: new $6d519e6f260f4e02$var$$21ee218f84ac7f32$var$Substream('bboxStreamSize'),
    instructions: new $6d519e6f260f4e02$var$$21ee218f84ac7f32$var$Substream('instructionStreamSize')
});
const $6d519e6f260f4e02$var$$21ee218f84ac7f32$var$WORD_CODE = 253;
const $6d519e6f260f4e02$var$$21ee218f84ac7f32$var$ONE_MORE_BYTE_CODE2 = 254;
const $6d519e6f260f4e02$var$$21ee218f84ac7f32$var$ONE_MORE_BYTE_CODE1 = 255;
const $6d519e6f260f4e02$var$$21ee218f84ac7f32$var$LOWEST_U_CODE = 253;
function $6d519e6f260f4e02$var$$21ee218f84ac7f32$var$read255UInt16(stream) {
    let code = stream.readUInt8();
    if (code === $6d519e6f260f4e02$var$$21ee218f84ac7f32$var$WORD_CODE) return stream.readUInt16BE();
    if (code === $6d519e6f260f4e02$var$$21ee218f84ac7f32$var$ONE_MORE_BYTE_CODE1) return stream.readUInt8() + $6d519e6f260f4e02$var$$21ee218f84ac7f32$var$LOWEST_U_CODE;
    if (code === $6d519e6f260f4e02$var$$21ee218f84ac7f32$var$ONE_MORE_BYTE_CODE2) return stream.readUInt8() + $6d519e6f260f4e02$var$$21ee218f84ac7f32$var$LOWEST_U_CODE * 2;
    return code;
}
function $6d519e6f260f4e02$var$$21ee218f84ac7f32$var$withSign(flag, baseval) {
    return flag & 1 ? baseval : -baseval;
}
function $6d519e6f260f4e02$var$$21ee218f84ac7f32$var$decodeTriplet(flags, glyphs, nPoints) {
    let y;
    let x = y = 0;
    let res = [];
    for(let i = 0; i < nPoints; i++){
        let dx = 0, dy = 0;
        let flag = flags.readUInt8();
        let onCurve = !(flag >> 7);
        flag &= 0x7f;
        if (flag < 10) {
            dx = 0;
            dy = $6d519e6f260f4e02$var$$21ee218f84ac7f32$var$withSign(flag, ((flag & 14) << 7) + glyphs.readUInt8());
        } else if (flag < 20) {
            dx = $6d519e6f260f4e02$var$$21ee218f84ac7f32$var$withSign(flag, ((flag - 10 & 14) << 7) + glyphs.readUInt8());
            dy = 0;
        } else if (flag < 84) {
            var b0 = flag - 20;
            var b1 = glyphs.readUInt8();
            dx = $6d519e6f260f4e02$var$$21ee218f84ac7f32$var$withSign(flag, 1 + (b0 & 0x30) + (b1 >> 4));
            dy = $6d519e6f260f4e02$var$$21ee218f84ac7f32$var$withSign(flag >> 1, 1 + ((b0 & 0x0c) << 2) + (b1 & 0x0f));
        } else if (flag < 120) {
            var b0 = flag - 84;
            dx = $6d519e6f260f4e02$var$$21ee218f84ac7f32$var$withSign(flag, 1 + (b0 / 12 << 8) + glyphs.readUInt8());
            dy = $6d519e6f260f4e02$var$$21ee218f84ac7f32$var$withSign(flag >> 1, 1 + (b0 % 12 >> 2 << 8) + glyphs.readUInt8());
        } else if (flag < 124) {
            var b1 = glyphs.readUInt8();
            let b2 = glyphs.readUInt8();
            dx = $6d519e6f260f4e02$var$$21ee218f84ac7f32$var$withSign(flag, (b1 << 4) + (b2 >> 4));
            dy = $6d519e6f260f4e02$var$$21ee218f84ac7f32$var$withSign(flag >> 1, ((b2 & 0x0f) << 8) + glyphs.readUInt8());
        } else {
            dx = $6d519e6f260f4e02$var$$21ee218f84ac7f32$var$withSign(flag, glyphs.readUInt16BE());
            dy = $6d519e6f260f4e02$var$$21ee218f84ac7f32$var$withSign(flag >> 1, glyphs.readUInt16BE());
        }
        x += dx;
        y += dy;
        res.push(new $6d519e6f260f4e02$var$$69aac16029968692$export$baf26146a414f24a(onCurve, false, x, y));
    }
    return res;
}
let $6d519e6f260f4e02$var$$cd5853a56c68fec7$var$TTCHeader = new (0, $00bf8c7e3dccf9c9$export$95a8b60f4da7dec8)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), {
    0x00010000: {
        numFonts: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
        offsets: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), 'numFonts')
    },
    0x00020000: {
        numFonts: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
        offsets: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), 'numFonts'),
        dsigTag: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
        dsigLength: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
        dsigOffset: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d)
    }
});
class $6d519e6f260f4e02$var$$cd5853a56c68fec7$export$2e2bcd8739ae039 {
    static probe(buffer) {
        return $6d519e6f260f4e02$var$$12727730ddfc8bfe$export$3d28c1996ced1f14.decode(buffer.slice(0, 4)) === 'ttcf';
    }
    getFont(name) {
        for (let offset of this.header.offsets){
            let stream = new (0, $ddbeea1419c36d9b$export$c18b354bac7948e9)(this.stream.buffer);
            stream.pos = offset;
            let font = new $6d519e6f260f4e02$var$$4c1709dee528ea76$export$2e2bcd8739ae039(stream);
            if (font.postscriptName === name || font.postscriptName instanceof Uint8Array && name instanceof Uint8Array && font.postscriptName.every((v, i)=>name[i] === v)) return font;
        }
        return null;
    }
    get fonts() {
        let fonts = [];
        for (let offset of this.header.offsets){
            let stream = new (0, $ddbeea1419c36d9b$export$c18b354bac7948e9)(this.stream.buffer);
            stream.pos = offset;
            fonts.push(new $6d519e6f260f4e02$var$$4c1709dee528ea76$export$2e2bcd8739ae039(stream));
        }
        return fonts;
    }
    constructor(stream){
        (0, $1d8e073d1256147c$export$71511d61b312f219)(this, "type", 'TTC');
        this.stream = stream;
        if (stream.readString(4) !== 'ttcf') throw new Error('Not a TrueType collection');
        this.header = $6d519e6f260f4e02$var$$cd5853a56c68fec7$var$TTCHeader.decode(stream);
    }
}
let $6d519e6f260f4e02$var$$05f49f930186144e$var$DFontName = new (0, $b2061d4384f873cb$export$89b8e0fa65f6a914)((0, $2b9a2a5e7d043014$export$52e103c63c4e68cf));
let $6d519e6f260f4e02$var$$05f49f930186144e$var$DFontData = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    len: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    buf: new (0, $272db5812670c438$export$7d22a0eea6656474)('len')
});
let $6d519e6f260f4e02$var$$05f49f930186144e$var$Ref = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    id: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    nameOffset: (0, $2b9a2a5e7d043014$export$c35c15c7caeff2b6),
    attr: (0, $2b9a2a5e7d043014$export$52e103c63c4e68cf),
    dataOffset: (0, $2b9a2a5e7d043014$export$1925298fbd719b21),
    handle: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d)
});
let $6d519e6f260f4e02$var$$05f49f930186144e$var$Type = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    name: new (0, $b2061d4384f873cb$export$89b8e0fa65f6a914)(4),
    maxTypeIndex: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    refList: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$05f49f930186144e$var$Ref, (t)=>t.maxTypeIndex + 1), {
        type: 'parent'
    })
});
let $6d519e6f260f4e02$var$$05f49f930186144e$var$TypeList = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    length: (0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456),
    types: new (0, $089ebb4f86db9da2$export$c4be6576ca6fe4aa)($6d519e6f260f4e02$var$$05f49f930186144e$var$Type, (t)=>t.length + 1)
});
let $6d519e6f260f4e02$var$$05f49f930186144e$var$DFontMap = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    reserved: new (0, $f612a7b97d3685e8$export$da9b5fe187a9aa1)((0, $2b9a2a5e7d043014$export$52e103c63c4e68cf), 24),
    typeList: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), $6d519e6f260f4e02$var$$05f49f930186144e$var$TypeList),
    nameListOffset: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$56bd24b5a3ee8456), 'void')
});
let $6d519e6f260f4e02$var$$05f49f930186144e$var$DFontHeader = new (0, $e3f85bd82b272d37$export$eabc71f011df675a)({
    dataOffset: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    map: new (0, $19bca402104b2cc3$export$b56007f12edf0c17)((0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d), $6d519e6f260f4e02$var$$05f49f930186144e$var$DFontMap),
    dataLength: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d),
    mapLength: (0, $2b9a2a5e7d043014$export$de9ffb9418dd7d0d)
});
class $6d519e6f260f4e02$var$$05f49f930186144e$export$2e2bcd8739ae039 {
    static probe(buffer) {
        let stream = new (0, $ddbeea1419c36d9b$export$c18b354bac7948e9)(buffer);
        try {
            var header = $6d519e6f260f4e02$var$$05f49f930186144e$var$DFontHeader.decode(stream);
        } catch (e) {
            return false;
        }
        for (let type of header.map.typeList.types){
            if (type.name === 'sfnt') return true;
        }
        return false;
    }
    getFont(name) {
        if (!this.sfnt) return null;
        for (let ref of this.sfnt.refList){
            let pos = this.header.dataOffset + ref.dataOffset + 4;
            let stream = new (0, $ddbeea1419c36d9b$export$c18b354bac7948e9)(this.stream.buffer.slice(pos));
            let font = new $6d519e6f260f4e02$var$$4c1709dee528ea76$export$2e2bcd8739ae039(stream);
            if (font.postscriptName === name || font.postscriptName instanceof Uint8Array && name instanceof Uint8Array && font.postscriptName.every((v, i)=>name[i] === v)) return font;
        }
        return null;
    }
    get fonts() {
        let fonts = [];
        for (let ref of this.sfnt.refList){
            let pos = this.header.dataOffset + ref.dataOffset + 4;
            let stream = new (0, $ddbeea1419c36d9b$export$c18b354bac7948e9)(this.stream.buffer.slice(pos));
            fonts.push(new $6d519e6f260f4e02$var$$4c1709dee528ea76$export$2e2bcd8739ae039(stream));
        }
        return fonts;
    }
    constructor(stream){
        (0, $1d8e073d1256147c$export$71511d61b312f219)(this, "type", 'DFont');
        this.stream = stream;
        this.header = $6d519e6f260f4e02$var$$05f49f930186144e$var$DFontHeader.decode(this.stream);
        for (let type of this.header.map.typeList.types){
            for (let ref of type.refList)if (ref.nameOffset >= 0) {
                this.stream.pos = ref.nameOffset + this.header.map.nameListOffset;
                ref.name = $6d519e6f260f4e02$var$$05f49f930186144e$var$DFontName.decode(this.stream);
            } else ref.name = null;
            if (type.name === 'sfnt') this.sfnt = type;
        }
    }
}
$6d519e6f260f4e02$export$36b2f24e97d43be($6d519e6f260f4e02$var$$4c1709dee528ea76$export$2e2bcd8739ae039);
$6d519e6f260f4e02$export$36b2f24e97d43be($6d519e6f260f4e02$var$$760785214b9fc52c$export$2e2bcd8739ae039);
$6d519e6f260f4e02$export$36b2f24e97d43be($6d519e6f260f4e02$var$$21ee218f84ac7f32$export$2e2bcd8739ae039);
$6d519e6f260f4e02$export$36b2f24e97d43be($6d519e6f260f4e02$var$$cd5853a56c68fec7$export$2e2bcd8739ae039);
$6d519e6f260f4e02$export$36b2f24e97d43be($6d519e6f260f4e02$var$$05f49f930186144e$export$2e2bcd8739ae039);



var $747671422c5180f9$exports = {};
var $747671422c5180f9$var$lookup = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
(function(exports1) {
    'use strict';
    var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
    var PLUS = '+'.charCodeAt(0);
    var SLASH = '/'.charCodeAt(0);
    var NUMBER = '0'.charCodeAt(0);
    var LOWER = 'a'.charCodeAt(0);
    var UPPER = 'A'.charCodeAt(0);
    var PLUS_URL_SAFE = '-'.charCodeAt(0);
    var SLASH_URL_SAFE = '_'.charCodeAt(0);
    function decode(elt) {
        var code = elt.charCodeAt(0);
        if (code === PLUS || code === PLUS_URL_SAFE) return 62 // '+'
        ;
        if (code === SLASH || code === SLASH_URL_SAFE) return 63 // '/'
        ;
        if (code < NUMBER) return -1 //no match
        ;
        if (code < NUMBER + 10) return code - NUMBER + 26 + 26;
        if (code < UPPER + 26) return code - UPPER;
        if (code < LOWER + 26) return code - LOWER + 26;
    }
    function b64ToByteArray(b64) {
        var i, j, l, tmp, placeHolders, arr;
        if (b64.length % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
        // the number of equal signs (place holders)
        // if there are two placeholders, than the two characters before it
        // represent one byte
        // if there is only one, then the three characters before it represent 2 bytes
        // this is just a cheap hack to not do indexOf twice
        var len = b64.length;
        placeHolders = '=' === b64.charAt(len - 2) ? 2 : '=' === b64.charAt(len - 1) ? 1 : 0;
        // base64 is 4/3 + up to two characters of the original data
        arr = new Arr(b64.length * 3 / 4 - placeHolders);
        // if there are placeholders, only get up to the last complete 4 chars
        l = placeHolders > 0 ? b64.length - 4 : b64.length;
        var L = 0;
        function push(v) {
            arr[L++] = v;
        }
        for(i = 0, j = 0; i < l; i += 4, j += 3){
            tmp = decode(b64.charAt(i)) << 18 | decode(b64.charAt(i + 1)) << 12 | decode(b64.charAt(i + 2)) << 6 | decode(b64.charAt(i + 3));
            push((tmp & 0xFF0000) >> 16);
            push((tmp & 0xFF00) >> 8);
            push(tmp & 0xFF);
        }
        if (placeHolders === 2) {
            tmp = decode(b64.charAt(i)) << 2 | decode(b64.charAt(i + 1)) >> 4;
            push(tmp & 0xFF);
        } else if (placeHolders === 1) {
            tmp = decode(b64.charAt(i)) << 10 | decode(b64.charAt(i + 1)) << 4 | decode(b64.charAt(i + 2)) >> 2;
            push(tmp >> 8 & 0xFF);
            push(tmp & 0xFF);
        }
        return arr;
    }
    function uint8ToBase64(uint8) {
        var i, extraBytes = uint8.length % 3, output = "", temp, length;
        function encode(num) {
            return $747671422c5180f9$var$lookup.charAt(num);
        }
        function tripletToBase64(num) {
            return encode(num >> 18 & 0x3F) + encode(num >> 12 & 0x3F) + encode(num >> 6 & 0x3F) + encode(num & 0x3F);
        }
        // go through the array every three bytes, we'll deal with trailing stuff later
        for(i = 0, length = uint8.length - extraBytes; i < length; i += 3){
            temp = (uint8[i] << 16) + (uint8[i + 1] << 8) + uint8[i + 2];
            output += tripletToBase64(temp);
        }
        // pad the end with zeros, but make sure to not forget the extra bytes
        switch(extraBytes){
            case 1:
                temp = uint8[uint8.length - 1];
                output += encode(temp >> 2);
                output += encode(temp << 4 & 0x3F);
                output += '==';
                break;
            case 2:
                temp = (uint8[uint8.length - 2] << 8) + uint8[uint8.length - 1];
                output += encode(temp >> 10);
                output += encode(temp >> 4 & 0x3F);
                output += encode(temp << 2 & 0x3F);
                output += '=';
                break;
        }
        return output;
    }
    exports1.toByteArray = b64ToByteArray;
    exports1.fromByteArray = uint8ToBase64;
})($747671422c5180f9$exports);


var $2a7b720d535c27e6$export$2e2bcd8739ae039 = {};
"use strict";
const $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$af862512e23cb54 = 0; // Opening punctuation
const $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$9bf3043cb7503aa1 = 1; // Closing punctuation
const $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$6d0b2a5dd774590a = 2; // Closing parenthesis
const $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$bf0b2277bd569ea1 = 3; // Ambiguous quotation
const $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$bad2a840ccda93b6 = 4; // Glue
const $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$fb4028874a74450 = 5; // Non-starters
const $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$463bd1ce0149c55e = 6; // Exclamation/Interrogation
const $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$2e8caadc521d7cbb = 7; // Symbols allowing break after
const $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$bfe27467c1de9413 = 8; // Infix separator
const $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$af5f8d68aad3cd3a = 9; // Prefix
const $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$6b7e017d6825d38f = 10; // Postfix
const $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$8227ca023eb0daaa = 11; // Numeric
const $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$1bb1140fe1358b00 = 12; // Alphabetic
const $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$f3e416a182673355 = 13; // Hebrew Letter
const $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$8be180ec26319f9f = 14; // Ideographic
const $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$70824c8942178d60 = 15; // Inseparable characters
const $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$24aa617c849a894a = 16; // Hyphen
const $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$a73c4d14459b698d = 17; // Break after
const $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$921068d8846a1559 = 18; // Break before
const $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$8b85a4f193482778 = 19; // Break on either side (but not pair)
const $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$b2fd9c01d360241f = 20; // Zero-width space
const $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$dcd191669c0a595f = 21; // Combining marks
const $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$9e5d732f3676a9ba = 22; // Word joiner
const $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$cb94397127ac9363 = 23; // Hangul LV
const $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$746be9e3a3dfff1f = 24; // Hangul LVT
const $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$96e3e682276c47cf = 25; // Hangul L Jamo
const $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$fc2ff69ee2cb01bf = 26; // Hangul V Jamo
const $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$8999624a7bae9d04 = 27; // Hangul T Jamo
const $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$1dff41d5c0caca01 = 28; // Regional Indicator
const $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$ddb7a6c76d9d93eb = 29; // Emoji Base
const $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$7e93eb3105e4786d = 30; // Emoji Modifier
const $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$30a74a373318dec6 = 31; // Zero Width Joiner
const $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$54caeea5e6dab1f = 32; // Contingent break
const $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$d710c5f50fc7496a = 33; // Ambiguous (Alphabetic or Ideograph)
const $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$66498d28055820a9 = 34; // Break (mandatory)
const $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$eb6c6d0b7c8826f2 = 35; // Conditional Japanese Starter
const $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$de92be486109a1df = 36; // Carriage return
const $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$606cfc2a8896c91f = 37; // Line feed
const $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$e51d3c675bb0140d = 38; // Next line
const $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$da51c6332ad11d7b = 39; // South-East Asian
const $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$bea437c40441867d = 40; // Surrogates
const $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$c4c7eecbfed13dc9 = 41; // Space
const $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$98e1f8a379849661 = 42; // Unknown
const $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745 = 0; // Direct break opportunity
const $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e = 1; // Indirect break opportunity
const $2a7b720d535c27e6$var$$32627af916ac1b00$export$e4965ce242860454 = 2; // Indirect break opportunity for combining marks
const $2a7b720d535c27e6$var$$32627af916ac1b00$export$8f14048969dcd45e = 3; // Prohibited break for combining marks
const $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4 = 4; // Prohibited break
const $2a7b720d535c27e6$var$$32627af916ac1b00$export$5bdb8ccbf5c57afc = [
    //OP   , CL    , CP    , QU    , GL    , NS    , EX    , SY    , IS    , PR    , PO    , NU    , AL    , HL    , ID    , IN    , HY    , BA    , BB    , B2    , ZW    , CM    , WJ    , H2    , H3    , JL    , JV    , JT    , RI    , EB    , EM    , ZWJ   , CB
    [
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$8f14048969dcd45e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4
    ],
    [
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$e4965ce242860454,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$e4965ce242860454,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$e4965ce242860454,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e
    ],
    [
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$e4965ce242860454,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e
    ],
    [
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$e4965ce242860454,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$e4965ce242860454,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$e4965ce242860454,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$e4965ce242860454,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$e4965ce242860454,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$e4965ce242860454,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$e4965ce242860454,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$e4965ce242860454,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$e4965ce242860454,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$e4965ce242860454,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$e4965ce242860454,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$e4965ce242860454,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$e4965ce242860454,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$e4965ce242860454,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$e4965ce242860454,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$e4965ce242860454,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$e4965ce242860454,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e
    ],
    [
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$e4965ce242860454,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$e4965ce242860454,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$e4965ce242860454,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$e4965ce242860454,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$e4965ce242860454,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$e4965ce242860454,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$e4965ce242860454,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$e4965ce242860454,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$e4965ce242860454,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745
    ],
    [
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$e4965ce242860454,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e,
        $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745
    ] // CB
];
const $2a7b720d535c27e6$var$$557adaaeb0c7885f$var$data = (0, (/*@__PURE__*/$parcel$interopDefault($747671422c5180f9$exports))).toByteArray("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");
const $2a7b720d535c27e6$var$$557adaaeb0c7885f$var$classTrie = new (0, (/*@__PURE__*/$parcel$interopDefault($82c8d86aa310da61$exports)))($2a7b720d535c27e6$var$$557adaaeb0c7885f$var$data);
const $2a7b720d535c27e6$var$$557adaaeb0c7885f$var$mapClass = function(c) {
    switch(c){
        case $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$d710c5f50fc7496a:
            return $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$1bb1140fe1358b00;
        case $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$da51c6332ad11d7b:
        case $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$bea437c40441867d:
        case $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$98e1f8a379849661:
            return $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$1bb1140fe1358b00;
        case $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$eb6c6d0b7c8826f2:
            return $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$fb4028874a74450;
        default:
            return c;
    }
};
const $2a7b720d535c27e6$var$$557adaaeb0c7885f$var$mapFirst = function(c) {
    switch(c){
        case $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$606cfc2a8896c91f:
        case $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$e51d3c675bb0140d:
            return $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$66498d28055820a9;
        case $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$c4c7eecbfed13dc9:
            return $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$9e5d732f3676a9ba;
        default:
            return c;
    }
};
class $2a7b720d535c27e6$var$$557adaaeb0c7885f$var$Break {
    constructor(position, required = false){
        this.position = position;
        this.required = required;
    }
}
class $2a7b720d535c27e6$var$$557adaaeb0c7885f$var$LineBreaker {
    nextCodePoint() {
        const code = this.string.charCodeAt(this.pos++);
        const next = this.string.charCodeAt(this.pos);
        // If a surrogate pair
        if (0xd800 <= code && code <= 0xdbff && 0xdc00 <= next && next <= 0xdfff) {
            this.pos++;
            return (code - 0xd800) * 0x400 + (next - 0xdc00) + 0x10000;
        }
        return code;
    }
    nextCharClass() {
        return $2a7b720d535c27e6$var$$557adaaeb0c7885f$var$mapClass($2a7b720d535c27e6$var$$557adaaeb0c7885f$var$classTrie.get(this.nextCodePoint()));
    }
    getSimpleBreak() {
        // handle classes not handled by the pair table
        switch(this.nextClass){
            case $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$c4c7eecbfed13dc9:
                return false;
            case $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$66498d28055820a9:
            case $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$606cfc2a8896c91f:
            case $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$e51d3c675bb0140d:
                this.curClass = $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$66498d28055820a9;
                return false;
            case $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$de92be486109a1df:
                this.curClass = $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$de92be486109a1df;
                return false;
        }
        return null;
    }
    getPairTableBreak(lastClass) {
        // if not handled already, use the pair table
        let shouldBreak = false;
        switch($2a7b720d535c27e6$var$$32627af916ac1b00$export$5bdb8ccbf5c57afc[this.curClass][this.nextClass]){
            case $2a7b720d535c27e6$var$$32627af916ac1b00$export$98f50d781a474745:
                shouldBreak = true;
                break;
            case $2a7b720d535c27e6$var$$32627af916ac1b00$export$12ee1f8f5315ca7e:
                shouldBreak = lastClass === $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$c4c7eecbfed13dc9;
                break;
            case $2a7b720d535c27e6$var$$32627af916ac1b00$export$e4965ce242860454:
                shouldBreak = lastClass === $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$c4c7eecbfed13dc9;
                if (!shouldBreak) {
                    shouldBreak = false;
                    return shouldBreak;
                }
                break;
            case $2a7b720d535c27e6$var$$32627af916ac1b00$export$8f14048969dcd45e:
                if (lastClass !== $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$c4c7eecbfed13dc9) return shouldBreak;
                break;
            case $2a7b720d535c27e6$var$$32627af916ac1b00$export$133eb141bf58aff4:
                break;
        }
        if (this.LB8a) shouldBreak = false;
        // Rule LB21a
        if (this.LB21a && (this.curClass === $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$24aa617c849a894a || this.curClass === $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$a73c4d14459b698d)) {
            shouldBreak = false;
            this.LB21a = false;
        } else this.LB21a = this.curClass === $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$f3e416a182673355;
        // Rule LB30a
        if (this.curClass === $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$1dff41d5c0caca01) {
            this.LB30a++;
            if (this.LB30a == 2 && this.nextClass === $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$1dff41d5c0caca01) {
                shouldBreak = true;
                this.LB30a = 0;
            }
        } else this.LB30a = 0;
        this.curClass = this.nextClass;
        return shouldBreak;
    }
    nextBreak() {
        // get the first char if we're at the beginning of the string
        if (this.curClass == null) {
            let firstClass = this.nextCharClass();
            this.curClass = $2a7b720d535c27e6$var$$557adaaeb0c7885f$var$mapFirst(firstClass);
            this.nextClass = firstClass;
            this.LB8a = firstClass === $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$30a74a373318dec6;
            this.LB30a = 0;
        }
        while(this.pos < this.string.length){
            this.lastPos = this.pos;
            const lastClass = this.nextClass;
            this.nextClass = this.nextCharClass();
            // explicit newline
            if (this.curClass === $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$66498d28055820a9 || this.curClass === $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$de92be486109a1df && this.nextClass !== $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$606cfc2a8896c91f) {
                this.curClass = $2a7b720d535c27e6$var$$557adaaeb0c7885f$var$mapFirst($2a7b720d535c27e6$var$$557adaaeb0c7885f$var$mapClass(this.nextClass));
                return new $2a7b720d535c27e6$var$$557adaaeb0c7885f$var$Break(this.lastPos, true);
            }
            let shouldBreak = this.getSimpleBreak();
            if (shouldBreak === null) shouldBreak = this.getPairTableBreak(lastClass);
            // Rule LB8a
            this.LB8a = this.nextClass === $2a7b720d535c27e6$var$$1627905f8be2ef3f$export$30a74a373318dec6;
            if (shouldBreak) return new $2a7b720d535c27e6$var$$557adaaeb0c7885f$var$Break(this.lastPos);
        }
        if (this.lastPos < this.string.length) {
            this.lastPos = this.string.length;
            return new $2a7b720d535c27e6$var$$557adaaeb0c7885f$var$Break(this.string.length);
        }
        return null;
    }
    constructor(string){
        this.string = string;
        this.pos = 0;
        this.lastPos = 0;
        this.curClass = null;
        this.nextClass = null;
        this.LB8a = false;
        this.LB21a = false;
        this.LB30a = 0;
    }
}
$2a7b720d535c27e6$export$2e2bcd8739ae039 = $2a7b720d535c27e6$var$$557adaaeb0c7885f$var$LineBreaker;



const $527168479d9b53ce$var$inflate = (0, $cb0093123c05defe$export$ca7cbb494e731274);
class $527168479d9b53ce$export$2e2bcd8739ae039 {
    static decode(path, fn) {
        throw new Error('PNG.decode not available in browser build');
    }
    static load(path) {
        throw new Error('PNG.load not available in browser build');
    }
    constructor(data){
        let i;
        this.data = data;
        this.pos = 8; // Skip the default header
        this.palette = [];
        this.imgData = [];
        this.transparency = {};
        this.text = {};
        while(true){
            const chunkSize = this.readUInt32();
            let section = '';
            for(i = 0; i < 4; i++)section += String.fromCharCode(this.data[this.pos++]);
            switch(section){
                case 'IHDR':
                    // we can grab  interesting values from here (like width, height, etc)
                    this.width = this.readUInt32();
                    this.height = this.readUInt32();
                    this.bits = this.data[this.pos++];
                    this.colorType = this.data[this.pos++];
                    this.compressionMethod = this.data[this.pos++];
                    this.filterMethod = this.data[this.pos++];
                    this.interlaceMethod = this.data[this.pos++];
                    break;
                case 'PLTE':
                    this.palette = this.read(chunkSize);
                    break;
                case 'IDAT':
                    for(i = 0; i < chunkSize; i++)this.imgData.push(this.data[this.pos++]);
                    break;
                case 'tRNS':
                    // This chunk can only occur once and it must occur after the
                    // PLTE chunk and before the IDAT chunk.
                    this.transparency = {};
                    switch(this.colorType){
                        case 3:
                            // Indexed color, RGB. Each byte in this chunk is an alpha for
                            // the palette index in the PLTE ("palette") chunk up until the
                            // last non-opaque entry. Set up an array, stretching over all
                            // palette entries which will be 0 (opaque) or 1 (transparent).
                            this.transparency.indexed = this.read(chunkSize);
                            var short = 255 - this.transparency.indexed.length;
                            if (short > 0) for(i = 0; i < short; i++)this.transparency.indexed.push(255);
                            break;
                        case 0:
                            // Greyscale. Corresponding to entries in the PLTE chunk.
                            // Grey is two bytes, range 0 .. (2 ^ bit-depth) - 1
                            this.transparency.grayscale = this.read(chunkSize)[0];
                            break;
                        case 2:
                            // True color with proper alpha channel.
                            this.transparency.rgb = this.read(chunkSize);
                            break;
                    }
                    break;
                case 'tEXt':
                    var text = this.read(chunkSize);
                    var index = text.indexOf(0);
                    var key = String.fromCharCode.apply(String, text.slice(0, index));
                    this.text[key] = String.fromCharCode.apply(String, text.slice(index + 1));
                    break;
                case 'IEND':
                    // we've got everything we need!
                    switch(this.colorType){
                        case 0:
                        case 3:
                        case 4:
                            this.colors = 1;
                            break;
                        case 2:
                        case 6:
                            this.colors = 3;
                            break;
                    }
                    this.hasAlphaChannel = [
                        4,
                        6
                    ].includes(this.colorType);
                    var colors = this.colors + (this.hasAlphaChannel ? 1 : 0);
                    this.pixelBitlength = this.bits * colors;
                    switch(this.colors){
                        case 1:
                            this.colorSpace = 'DeviceGray';
                            break;
                        case 3:
                            this.colorSpace = 'DeviceRGB';
                            break;
                    }
                    this.imgData = new Uint8Array(this.imgData);
                    return;
                default:
                    // unknown (or unimportant) section, skip it
                    this.pos += chunkSize;
            }
            this.pos += 4; // Skip the CRC
            if (this.pos > this.data.length) throw new Error('Incomplete or corrupt PNG file');
        }
    }
    read(bytes) {
        const result = new Array(bytes);
        for(let i = 0; i < bytes; i++)result[i] = this.data[this.pos++];
        return result;
    }
    readUInt32() {
        const b1 = this.data[this.pos++] << 24;
        const b2 = this.data[this.pos++] << 16;
        const b3 = this.data[this.pos++] << 8;
        const b4 = this.data[this.pos++];
        return b1 | b2 | b3 | b4;
    }
    readUInt16() {
        const b1 = this.data[this.pos++] << 8;
        const b2 = this.data[this.pos++];
        return b1 | b2;
    }
    decodePixels(fn) {
        return $527168479d9b53ce$var$inflate(new Uint8Array(this.imgData), (err, data)=>{
            if (err) throw err;
            const { width: width, height: height } = this;
            const pixelBytes = this.pixelBitlength / 8;
            const pixels = new Uint8Array(width * height * pixelBytes);
            const { length: length } = data;
            let pos = 0;
            function pass(x0, y0, dx, dy, singlePass = false) {
                const w = Math.ceil((width - x0) / dx);
                const h = Math.ceil((height - y0) / dy);
                const scanlineLength = pixelBytes * w;
                const buffer = singlePass ? pixels : new Uint8Array(scanlineLength * h);
                let row = 0;
                let c = 0;
                while(row < h && pos < length){
                    var byte, col, i, left, upper;
                    switch(data[pos++]){
                        case 0:
                            for(i = 0; i < scanlineLength; i++)buffer[c++] = data[pos++];
                            break;
                        case 1:
                            for(i = 0; i < scanlineLength; i++){
                                byte = data[pos++];
                                left = i < pixelBytes ? 0 : buffer[c - pixelBytes];
                                buffer[c++] = (byte + left) % 256;
                            }
                            break;
                        case 2:
                            for(i = 0; i < scanlineLength; i++){
                                byte = data[pos++];
                                col = (i - i % pixelBytes) / pixelBytes;
                                upper = row && buffer[(row - 1) * scanlineLength + col * pixelBytes + i % pixelBytes];
                                buffer[c++] = (upper + byte) % 256;
                            }
                            break;
                        case 3:
                            for(i = 0; i < scanlineLength; i++){
                                byte = data[pos++];
                                col = (i - i % pixelBytes) / pixelBytes;
                                left = i < pixelBytes ? 0 : buffer[c - pixelBytes];
                                upper = row && buffer[(row - 1) * scanlineLength + col * pixelBytes + i % pixelBytes];
                                buffer[c++] = (byte + Math.floor((left + upper) / 2)) % 256;
                            }
                            break;
                        case 4:
                            for(i = 0; i < scanlineLength; i++){
                                var paeth, upperLeft;
                                byte = data[pos++];
                                col = (i - i % pixelBytes) / pixelBytes;
                                left = i < pixelBytes ? 0 : buffer[c - pixelBytes];
                                if (row === 0) upper = upperLeft = 0;
                                else {
                                    upper = buffer[(row - 1) * scanlineLength + col * pixelBytes + i % pixelBytes];
                                    upperLeft = col && buffer[(row - 1) * scanlineLength + (col - 1) * pixelBytes + i % pixelBytes];
                                }
                                const p = left + upper - upperLeft;
                                const pa = Math.abs(p - left);
                                const pb = Math.abs(p - upper);
                                const pc = Math.abs(p - upperLeft);
                                if (pa <= pb && pa <= pc) paeth = left;
                                else if (pb <= pc) paeth = upper;
                                else paeth = upperLeft;
                                buffer[c++] = (byte + paeth) % 256;
                            }
                            break;
                        default:
                            throw new Error(`Invalid filter algorithm: ${data[pos - 1]}`);
                    }
                    if (!singlePass) {
                        let pixelsPos = ((y0 + row * dy) * width + x0) * pixelBytes;
                        let bufferPos = row * scanlineLength;
                        for(i = 0; i < w; i++){
                            for(let j = 0; j < pixelBytes; j++)pixels[pixelsPos++] = buffer[bufferPos++];
                            pixelsPos += (dx - 1) * pixelBytes;
                        }
                    }
                    row++;
                }
            }
            if (this.interlaceMethod === 1) {
                /*
          1 6 4 6 2 6 4 6
          7 7 7 7 7 7 7 7
          5 6 5 6 5 6 5 6
          7 7 7 7 7 7 7 7
          3 6 4 6 3 6 4 6
          7 7 7 7 7 7 7 7
          5 6 5 6 5 6 5 6
          7 7 7 7 7 7 7 7
        */ pass(0, 0, 8, 8); // 1
                pass(4, 0, 8, 8); // 2
                pass(0, 4, 4, 8); // 3
                pass(2, 0, 4, 4); // 4
                pass(0, 2, 2, 4); // 5
                pass(1, 0, 2, 2); // 6
                pass(0, 1, 1, 2); // 7
            } else pass(0, 0, 1, 1, true);
            return fn(pixels);
        });
    }
    decodePalette() {
        const { palette: palette } = this;
        const { length: length } = palette;
        const transparency = this.transparency.indexed || [];
        const ret = new Uint8Array(transparency.length + length);
        let pos = 0;
        let c = 0;
        for(let i = 0; i < length; i += 3){
            var left;
            ret[pos++] = palette[i];
            ret[pos++] = palette[i + 1];
            ret[pos++] = palette[i + 2];
            ret[pos++] = (left = transparency[c++]) != null ? left : 255;
        }
        return ret;
    }
    copyToImageData(imageData, pixels) {
        let j, k;
        let { colors: colors } = this;
        let palette = null;
        let alpha = this.hasAlphaChannel;
        if (this.palette.length) {
            palette = this._decodedPalette || (this._decodedPalette = this.decodePalette());
            colors = 4;
            alpha = true;
        }
        const data = imageData.data || imageData;
        const { length: length } = data;
        const input = palette || pixels;
        let i = j = 0;
        if (colors === 1) while(i < length){
            k = palette ? pixels[i / 4] * 4 : j;
            const v = input[k++];
            data[i++] = v;
            data[i++] = v;
            data[i++] = v;
            data[i++] = alpha ? input[k++] : 255;
            j = k;
        }
        else while(i < length){
            k = palette ? pixels[i / 4] * 4 : j;
            data[i++] = input[k++];
            data[i++] = input[k++];
            data[i++] = input[k++];
            data[i++] = alpha ? input[k++] : 255;
            j = k;
        }
    }
    decode(fn) {
        const ret = new Uint8Array(this.width * this.height * 4);
        return this.decodePixels((pixels)=>{
            this.copyToImageData(ret, pixels);
            return fn(ret);
        });
    }
}


class $6c341d77d66c320e$var$EventEmitter {
    constructor(){
        this._listeners = Object.create(null);
    }
    on(event, listener) {
        (this._listeners[event] || (this._listeners[event] = [])).push(listener);
        return this;
    }
    once(event, listener) {
        const wrapper = (...args)=>{
            this.off(event, wrapper);
            listener(...args);
        };
        return this.on(event, wrapper);
    }
    off(event, listener) {
        const listeners = this._listeners[event];
        if (listeners) {
            const index = listeners.indexOf(listener);
            if (index !== -1) listeners.splice(index, 1);
        }
        return this;
    }
    emit(event, ...args) {
        const listeners = this._listeners[event];
        if (!listeners) return false;
        for (const listener of listeners.slice())listener(...args);
        return listeners.length > 0;
    }
}
class $6c341d77d66c320e$var$Readable extends $6c341d77d66c320e$var$EventEmitter {
    constructor(){
        super();
        this._buffer = [];
        this._flowing = false;
        this._scheduled = false;
        this._finished = false;
        this._endEmitted = false;
    }
    on(event, listener) {
        super.on(event, listener);
        if (event === 'data') this.resume();
        return this;
    }
    push(chunk) {
        if (chunk === null) this._finished = true;
        else this._buffer.push(chunk);
        this._schedule();
        return true;
    }
    resume() {
        this._flowing = true;
        this._schedule();
        return this;
    }
    pause() {
        this._flowing = false;
        return this;
    }
    pipe(destination) {
        this.on('data', (chunk)=>{
            if (destination.write(chunk) === false) {
                this.pause();
                destination.once('drain', ()=>this.resume());
            }
        });
        this.on('end', ()=>destination.end());
        return destination;
    }
    _schedule() {
        if (this._scheduled || !this._flowing) return;
        this._scheduled = true;
        queueMicrotask(()=>{
            this._scheduled = false;
            this._drain();
        });
    }
    _drain() {
        while(this._flowing && this._buffer.length > 0)this.emit('data', this._buffer.shift());
        if (this._flowing && this._finished && !this._endEmitted) {
            this._endEmitted = true;
            this.emit('end');
        }
    }
    async *[Symbol.asyncIterator]() {
        const chunks = [];
        let ended = false;
        let notify = null;
        const wake = ()=>{
            const resolve = notify;
            notify = null;
            if (resolve) resolve();
        };
        this.on('data', (chunk)=>{
            chunks.push(chunk);
            wake();
        });
        this.on('end', ()=>{
            ended = true;
            wake();
        });
        for(;;){
            while(chunks.length > 0)yield chunks.shift();
            if (ended) return;
            await new Promise((resolve)=>{
                notify = resolve;
            });
        }
    }
}
class $6c341d77d66c320e$var$PDFAbstractReference {
    toString() {
        throw new Error('Must be implemented by subclasses');
    }
}
class $6c341d77d66c320e$var$PDFTree {
    constructor(options = {}){
        this._items = {};
        this.limits = typeof options.limits === 'boolean' ? options.limits : true;
    }
    add(key, val) {
        return this._items[key] = val;
    }
    get(key) {
        return this._items[key];
    }
    toString(encryptFn = null) {
        const sortedKeys = Object.keys(this._items).sort((a, b)=>this._compareKeys(a, b));
        const out = [
            '<<'
        ];
        if (this.limits && sortedKeys.length > 1) {
            const first = sortedKeys[0], last = sortedKeys[sortedKeys.length - 1];
            out.push(`  /Limits ${$6c341d77d66c320e$var$PDFObject.convert([
                this._dataForKey(first),
                this._dataForKey(last)
            ], encryptFn)}`);
        }
        out.push(`  /${this._keysName()} [`);
        for (let key of sortedKeys)out.push(`    ${$6c341d77d66c320e$var$PDFObject.convert(this._dataForKey(key), encryptFn)} ${$6c341d77d66c320e$var$PDFObject.convert(this._items[key], encryptFn)}`);
        out.push(']');
        out.push('>>');
        return out.join('\n');
    }
    _compareKeys() {
        throw new Error('Must be implemented by subclasses');
    }
    _keysName() {
        throw new Error('Must be implemented by subclasses');
    }
    _dataForKey() {
        throw new Error('Must be implemented by subclasses');
    }
}
class $6c341d77d66c320e$var$SpotColor {
    constructor(doc, name, C, M, Y, K){
        this.id = 'CS' + Object.keys(doc.spotColors).length;
        this.name = name;
        this.values = [
            C,
            M,
            Y,
            K
        ];
        this.ref = doc.ref([
            'Separation',
            $6c341d77d66c320e$var$escapeName(this.name),
            'DeviceCMYK',
            {
                Range: [
                    0,
                    1,
                    0,
                    1,
                    0,
                    1,
                    0,
                    1
                ],
                C0: [
                    0,
                    0,
                    0,
                    0
                ],
                C1: this.values.map((value)=>value / 100),
                FunctionType: 2,
                Domain: [
                    0,
                    1
                ],
                N: 1
            }
        ]);
        this.ref.end();
    }
    toString() {
        return `${this.ref.id} 0 R`;
    }
}
const $6c341d77d66c320e$var$toBinaryString = (bytes)=>{
    const chunkSize = 0x8000;
    let out = '';
    for(let i = 0; i < bytes.length; i += chunkSize){
        const end = Math.min(i + chunkSize, bytes.length);
        out += String.fromCharCode.apply(null, bytes.subarray(i, end));
    }
    return out;
};
const $6c341d77d66c320e$var$fromBinaryString = (str)=>{
    const out = new Uint8Array(str.length);
    for(let i = 0; i < str.length; i++)out[i] = str.charCodeAt(i) & 0xff;
    return out;
};
const $6c341d77d66c320e$var$fromBase64 = (b64)=>{
    const binary = atob(b64);
    const out = new Uint8Array(binary.length);
    for(let i = 0; i < binary.length; i++)out[i] = binary.charCodeAt(i);
    return out;
};
const $6c341d77d66c320e$var$concat = (chunks)=>{
    let length = 0;
    for (const chunk of chunks)length += chunk.length;
    const out = new Uint8Array(length);
    let offset = 0;
    for (const chunk of chunks){
        out.set(chunk, offset);
        offset += chunk.length;
    }
    return out;
};
const $6c341d77d66c320e$var$toUTF16BE = (str)=>{
    const out = new Uint8Array((str.length + 1) * 2);
    out[0] = 0xfe;
    out[1] = 0xff;
    for(let i = 0; i < str.length; i++){
        const code = str.charCodeAt(i);
        out[i * 2 + 2] = code >> 8;
        out[i * 2 + 3] = code & 0xff;
    }
    return out;
};
const $6c341d77d66c320e$var$readUInt16BE = (bytes, offset = 0)=>(bytes[offset] << 8 | bytes[offset + 1]) >>> 0;
const $6c341d77d66c320e$var$readUInt16LE = (bytes, offset = 0)=>(bytes[offset + 1] << 8 | bytes[offset]) >>> 0;
const $6c341d77d66c320e$var$readUInt32BE = (bytes, offset = 0)=>bytes[offset] * 0x1000000 + (bytes[offset + 1] << 16 | bytes[offset + 2] << 8 | bytes[offset + 3]) >>> 0;
const $6c341d77d66c320e$var$readUInt32LE = (bytes, offset = 0)=>(bytes[offset] | bytes[offset + 1] << 8 | bytes[offset + 2] << 16) + bytes[offset + 3] * 0x1000000 >>> 0;
const $6c341d77d66c320e$var$pad = (str, length)=>(Array(length + 1).join('0') + str).slice(-length);
const $6c341d77d66c320e$var$isSafeCharCode = (code)=>{
    if (code > 0x7f) return true;
    return code > 0x20 && code !== 0x7f && code !== 0x23 && code !== 0x25 && code !== 0x28 && code !== 0x29 && code !== 0x2f && code !== 0x3c && code !== 0x3e && code !== 0x5b && code !== 0x5d && code !== 0x7b && code !== 0x7d;
};
const $6c341d77d66c320e$var$escapableRe = /[\n\r\t\b\f()\\]/g;
const $6c341d77d66c320e$var$escapable = {
    '\n': '\\n',
    '\r': '\\r',
    '\t': '\\t',
    '\b': '\\b',
    '\f': '\\f',
    '\\': '\\\\',
    '(': '\\(',
    ')': '\\)'
};
const $6c341d77d66c320e$var$escapeName = function(name) {
    let escapedName = '';
    for (const char of name){
        const code = char.charCodeAt(0);
        if ($6c341d77d66c320e$var$isSafeCharCode(code)) escapedName += char;
        else escapedName += `#${code.toString(16).toUpperCase().padStart(2, '0')}`;
    }
    return escapedName;
};
class $6c341d77d66c320e$var$PDFObject {
    static convert(object, encryptFn = null) {
        if (typeof object === 'string') return `/${object}`;
        else if (object instanceof String) {
            let string = object;
            let isUnicode = false;
            for(let i = 0, end = string.length; i < end; i++)if (string.charCodeAt(i) > 0x7f) {
                isUnicode = true;
                break;
            }
            let stringBytes;
            if (isUnicode) stringBytes = $6c341d77d66c320e$var$toUTF16BE(string.valueOf());
            else stringBytes = $6c341d77d66c320e$var$fromBinaryString(string.valueOf());
            if (encryptFn) stringBytes = encryptFn(stringBytes);
            string = $6c341d77d66c320e$var$toBinaryString(stringBytes);
            string = string.replace($6c341d77d66c320e$var$escapableRe, (c)=>$6c341d77d66c320e$var$escapable[c]);
            return `(${string})`;
        } else if (object instanceof Uint8Array) return `<${(0, $f354203f433ec289$export$58b867e287a802c8)(object)}>`;
        else if (object instanceof $6c341d77d66c320e$var$PDFTree) return object.toString(encryptFn);
        else if (object instanceof $6c341d77d66c320e$var$PDFAbstractReference || object instanceof $6c341d77d66c320e$var$SpotColor) return object.toString();
        else if (object instanceof Date) {
            let string = `D:${$6c341d77d66c320e$var$pad(object.getUTCFullYear(), 4)}` + $6c341d77d66c320e$var$pad(object.getUTCMonth() + 1, 2) + $6c341d77d66c320e$var$pad(object.getUTCDate(), 2) + $6c341d77d66c320e$var$pad(object.getUTCHours(), 2) + $6c341d77d66c320e$var$pad(object.getUTCMinutes(), 2) + $6c341d77d66c320e$var$pad(object.getUTCSeconds(), 2) + 'Z';
            if (encryptFn) {
                string = $6c341d77d66c320e$var$toBinaryString(encryptFn($6c341d77d66c320e$var$fromBinaryString(string)));
                string = string.replace($6c341d77d66c320e$var$escapableRe, (c)=>$6c341d77d66c320e$var$escapable[c]);
            }
            return `(${string})`;
        } else if (Array.isArray(object)) {
            const items = [];
            for(let i = 0; i < object.length; i++){
                const e = object[i];
                items.push($6c341d77d66c320e$var$PDFObject.convert(e === undefined ? null : e, encryptFn));
            }
            return `[${items.join(' ')}]`;
        } else if (({}).toString.call(object) === '[object Object]') {
            const out = [
                '<<'
            ];
            for(let key in object){
                const val = object[key];
                if (val === undefined) continue;
                out.push(`/${key} ${$6c341d77d66c320e$var$PDFObject.convert(val, encryptFn)}`);
            }
            out.push('>>');
            return out.join('\n');
        } else if (typeof object === 'number') return $6c341d77d66c320e$var$PDFObject.number(object);
        else return `${object}`;
    }
    static number(n) {
        if (n > -1000000000000000000000 && n < 1e21) return Math.round(n * 1e6) / 1e6;
        throw new Error(`unsupported number: ${n}`);
    }
}
var $6c341d77d66c320e$var$zlib = {
    deflateSync: (data)=>(0, $cb0093123c05defe$export$f87121a6d50aff25)(data)
};
class $6c341d77d66c320e$var$PDFReference extends $6c341d77d66c320e$var$PDFAbstractReference {
    constructor(document, id, data = {}){
        super();
        this.document = document;
        this.id = id;
        this.data = data;
        this.gen = 0;
        this.compress = this.document.compress && !this.data.Filter;
        this.uncompressedLength = 0;
        this.buffer = [];
    }
    write(chunk) {
        if (!(chunk instanceof Uint8Array)) chunk = $6c341d77d66c320e$var$fromBinaryString(chunk + '\n');
        this.uncompressedLength += chunk.length;
        if (this.data.Length == null) this.data.Length = 0;
        this.buffer.push(chunk);
        this.data.Length += chunk.length;
        if (this.compress) this.data.Filter = 'FlateDecode';
    }
    end(chunk) {
        if (chunk) this.write(chunk);
        this.finalize();
    }
    finalize() {
        this.offset = this.document._offset;
        const encryptFn = this.document._security ? this.document._security.getEncryptFn(this.id, this.gen) : null;
        if (this.buffer.length) {
            this.buffer = $6c341d77d66c320e$var$concat(this.buffer);
            if (this.compress) this.buffer = $6c341d77d66c320e$var$zlib.deflateSync(this.buffer);
            if (encryptFn) this.buffer = encryptFn(this.buffer);
            this.data.Length = this.buffer.length;
        }
        this.document._write(`${this.id} ${this.gen} obj`);
        this.document._write($6c341d77d66c320e$var$PDFObject.convert(this.data, encryptFn));
        if (this.buffer.length) {
            this.document._write('stream');
            this.document._write(this.buffer);
            this.buffer = [];
            this.document._write('\nendstream');
        }
        this.document._write('endobj');
        this.document._refEnd(this);
    }
    toString() {
        return `${this.id} ${this.gen} R`;
    }
}
const $6c341d77d66c320e$var$fArray = new Float32Array(1);
const $6c341d77d66c320e$var$uArray = new Uint32Array($6c341d77d66c320e$var$fArray.buffer);
function $6c341d77d66c320e$var$PDFNumber(n) {
    const rounded = Math.fround(n);
    if (rounded <= n) return rounded;
    $6c341d77d66c320e$var$fArray[0] = n;
    if (n <= 0) $6c341d77d66c320e$var$uArray[0] += 1;
    else $6c341d77d66c320e$var$uArray[0] -= 1;
    return $6c341d77d66c320e$var$fArray[0];
}
function $6c341d77d66c320e$var$normalizeSides(sides, defaultDefinition, transformer = (v)=>v) {
    if (sides == null || typeof sides === 'object' && Object.keys(sides).length === 0) sides = defaultDefinition;
    if (sides == null || typeof sides !== 'object') sides = {
        top: sides,
        right: sides,
        bottom: sides,
        left: sides
    };
    else if (Array.isArray(sides)) {
        if (sides.length === 2) sides = {
            vertical: sides[0],
            horizontal: sides[1]
        };
        else sides = {
            top: sides[0],
            right: sides[1],
            bottom: sides[2],
            left: sides[3]
        };
    }
    if ('vertical' in sides || 'horizontal' in sides) sides = {
        top: sides.vertical,
        right: sides.horizontal,
        bottom: sides.vertical,
        left: sides.horizontal
    };
    return {
        top: transformer(sides.top),
        right: transformer(sides.right),
        bottom: transformer(sides.bottom),
        left: transformer(sides.left)
    };
}
const $6c341d77d66c320e$var$MM_TO_CM = 0.1;
const $6c341d77d66c320e$var$CM_TO_IN = 1 / 2.54;
const $6c341d77d66c320e$var$PX_TO_IN = 1 / 96;
const $6c341d77d66c320e$var$IN_TO_PT = 72;
const $6c341d77d66c320e$var$PC_TO_PT = 12;
function $6c341d77d66c320e$var$cosine(a) {
    if (a === 0) return 1;
    if (a === 90) return 0;
    if (a === 180) return -1;
    if (a === 270) return 0;
    return Math.cos(a * Math.PI / 180);
}
function $6c341d77d66c320e$var$sine(a) {
    if (a === 0) return 0;
    if (a === 90) return 1;
    if (a === 180) return 0;
    if (a === 270) return -1;
    return Math.sin(a * Math.PI / 180);
}
const $6c341d77d66c320e$var$DEFAULT_MARGINS = {
    top: 72,
    left: 72,
    bottom: 72,
    right: 72
};
const $6c341d77d66c320e$var$SIZES = {
    '4A0': [
        4767.87,
        6740.79
    ],
    '2A0': [
        3370.39,
        4767.87
    ],
    A0: [
        2383.94,
        3370.39
    ],
    A1: [
        1683.78,
        2383.94
    ],
    A2: [
        1190.55,
        1683.78
    ],
    A3: [
        841.89,
        1190.55
    ],
    A4: [
        595.28,
        841.89
    ],
    A5: [
        419.53,
        595.28
    ],
    A6: [
        297.64,
        419.53
    ],
    A7: [
        209.76,
        297.64
    ],
    A8: [
        147.4,
        209.76
    ],
    A9: [
        104.88,
        147.4
    ],
    A10: [
        73.7,
        104.88
    ],
    B0: [
        2834.65,
        4008.19
    ],
    B1: [
        2004.09,
        2834.65
    ],
    B2: [
        1417.32,
        2004.09
    ],
    B3: [
        1000.63,
        1417.32
    ],
    B4: [
        708.66,
        1000.63
    ],
    B5: [
        498.9,
        708.66
    ],
    B6: [
        354.33,
        498.9
    ],
    B7: [
        249.45,
        354.33
    ],
    B8: [
        175.75,
        249.45
    ],
    B9: [
        124.72,
        175.75
    ],
    B10: [
        87.87,
        124.72
    ],
    C0: [
        2599.37,
        3676.54
    ],
    C1: [
        1836.85,
        2599.37
    ],
    C2: [
        1298.27,
        1836.85
    ],
    C3: [
        918.43,
        1298.27
    ],
    C4: [
        649.13,
        918.43
    ],
    C5: [
        459.21,
        649.13
    ],
    C6: [
        323.15,
        459.21
    ],
    C7: [
        229.61,
        323.15
    ],
    C8: [
        161.57,
        229.61
    ],
    C9: [
        113.39,
        161.57
    ],
    C10: [
        79.37,
        113.39
    ],
    RA0: [
        2437.8,
        3458.27
    ],
    RA1: [
        1729.13,
        2437.8
    ],
    RA2: [
        1218.9,
        1729.13
    ],
    RA3: [
        864.57,
        1218.9
    ],
    RA4: [
        609.45,
        864.57
    ],
    SRA0: [
        2551.18,
        3628.35
    ],
    SRA1: [
        1814.17,
        2551.18
    ],
    SRA2: [
        1275.59,
        1814.17
    ],
    SRA3: [
        907.09,
        1275.59
    ],
    SRA4: [
        637.8,
        907.09
    ],
    EXECUTIVE: [
        521.86,
        756.0
    ],
    FOLIO: [
        612.0,
        936.0
    ],
    LEGAL: [
        612.0,
        1008.0
    ],
    LETTER: [
        612.0,
        792.0
    ],
    TABLOID: [
        792.0,
        1224.0
    ]
};
class $6c341d77d66c320e$var$PDFPage {
    constructor(document, options){
        this.document = document;
        this._options = options;
        this.size = options.size || 'letter';
        this.layout = options.layout || 'portrait';
        this.userUnit = options.userUnit || 1.0;
        const dimensions = Array.isArray(this.size) ? this.size : $6c341d77d66c320e$var$SIZES[this.size.toUpperCase()];
        this.width = dimensions[this.layout === 'portrait' ? 0 : 1];
        this.height = dimensions[this.layout === 'portrait' ? 1 : 0];
        this.content = this.document.ref();
        this.margins = $6c341d77d66c320e$var$normalizeSides(options.margin ?? options.margins, $6c341d77d66c320e$var$DEFAULT_MARGINS, (x)=>document.sizeToPoint(x, 0, this));
        this.resources = this.document.ref({
            ProcSet: [
                'PDF',
                'Text',
                'ImageB',
                'ImageC',
                'ImageI'
            ]
        });
        this.dictionary = this.document.ref({
            Type: 'Page',
            Parent: this.document._root.data.Pages,
            MediaBox: [
                0,
                0,
                this.width,
                this.height
            ],
            Contents: this.content,
            Resources: this.resources,
            UserUnit: this.userUnit
        });
        this.markings = [];
    }
    get fonts() {
        const data = this.resources.data;
        return data.Font != null ? data.Font : data.Font = {};
    }
    get xobjects() {
        const data = this.resources.data;
        return data.XObject != null ? data.XObject : data.XObject = {};
    }
    get ext_gstates() {
        const data = this.resources.data;
        return data.ExtGState != null ? data.ExtGState : data.ExtGState = {};
    }
    get patterns() {
        const data = this.resources.data;
        return data.Pattern != null ? data.Pattern : data.Pattern = {};
    }
    get colorSpaces() {
        const data = this.resources.data;
        return data.ColorSpace || (data.ColorSpace = {});
    }
    get annotations() {
        const data = this.dictionary.data;
        return data.Annots != null ? data.Annots : data.Annots = [];
    }
    get structParentTreeKey() {
        const data = this.dictionary.data;
        return data.StructParents != null ? data.StructParents : data.StructParents = this.document.createStructParentTreeNextKey();
    }
    get contentWidth() {
        return this.width - this.margins.left - this.margins.right;
    }
    get contentHeight() {
        return this.height - this.margins.top - this.margins.bottom;
    }
    maxY() {
        return this.height - this.margins.bottom;
    }
    write(chunk) {
        return this.content.write(chunk);
    }
    _setTabOrder() {
        if (!this.dictionary.Tabs && this.document.hasMarkInfoDictionary()) this.dictionary.data.Tabs = 'S';
    }
    end() {
        this._setTabOrder();
        this.dictionary.end();
        this.resources.data.ColorSpace = this.resources.data.ColorSpace || {};
        for (let color of Object.values(this.document.spotColors))this.resources.data.ColorSpace[color.id] = color;
        this.resources.end();
        return this.content.end();
    }
}
class $6c341d77d66c320e$var$PDFNameTree extends $6c341d77d66c320e$var$PDFTree {
    _compareKeys(a, b) {
        return a.localeCompare(b);
    }
    _keysName() {
        return 'Names';
    }
    _dataForKey(k) {
        return new String(k);
    }
}
function $6c341d77d66c320e$var$isBytes(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === 'Uint8Array';
}
function $6c341d77d66c320e$var$abytes(b, ...lengths) {
    if (!$6c341d77d66c320e$var$isBytes(b)) throw new Error('Uint8Array expected');
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error('Uint8Array expected of length ' + lengths + ', got length=' + b.length);
}
function $6c341d77d66c320e$var$aexists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error('Hash instance has been destroyed');
    if (checkFinished && instance.finished) throw new Error('Hash#digest() has already been called');
}
function $6c341d77d66c320e$var$aoutput(out, instance) {
    $6c341d77d66c320e$var$abytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error('digestInto() expects output buffer of length at least ' + min);
}
function $6c341d77d66c320e$var$clean(...arrays) {
    for(let i = 0; i < arrays.length; i++)arrays[i].fill(0);
}
function $6c341d77d66c320e$var$createView(arr) {
    return new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
}
function $6c341d77d66c320e$var$rotr(word, shift) {
    return word << 32 - shift | word >>> shift;
}
function $6c341d77d66c320e$var$rotl(word, shift) {
    return word << shift | word >>> 32 - shift >>> 0;
}
(()=>new Uint8Array(new Uint32Array([
        0x11223344
    ]).buffer)[0] === 0x44)();
(()=>typeof Uint8Array.from([]).toHex === 'function' && typeof Uint8Array.fromHex === 'function')();
Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, '0'));
function $6c341d77d66c320e$var$utf8ToBytes(str) {
    if (typeof str !== 'string') throw new Error('string expected');
    return new Uint8Array(new TextEncoder().encode(str));
}
function $6c341d77d66c320e$var$toBytes(data) {
    if (typeof data === 'string') data = $6c341d77d66c320e$var$utf8ToBytes(data);
    $6c341d77d66c320e$var$abytes(data);
    return data;
}
class $6c341d77d66c320e$var$Hash {
}
function $6c341d77d66c320e$var$createHasher(hashCons) {
    const hashC = (msg)=>hashCons().update($6c341d77d66c320e$var$toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
function $6c341d77d66c320e$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === 'function') return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
function $6c341d77d66c320e$var$Chi(a, b, c) {
    return a & b ^ ~a & c;
}
function $6c341d77d66c320e$var$Maj(a, b, c) {
    return a & b ^ a & c ^ b & c;
}
class $6c341d77d66c320e$var$HashMD extends $6c341d77d66c320e$var$Hash {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.buffer = new Uint8Array(blockLen);
        this.view = $6c341d77d66c320e$var$createView(this.buffer);
    }
    update(data) {
        $6c341d77d66c320e$var$aexists(this);
        data = $6c341d77d66c320e$var$toBytes(data);
        $6c341d77d66c320e$var$abytes(data);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            if (take === blockLen) {
                const dataView = $6c341d77d66c320e$var$createView(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        $6c341d77d66c320e$var$aexists(this);
        $6c341d77d66c320e$var$aoutput(out, this);
        this.finished = true;
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        buffer[pos++] = 128;
        $6c341d77d66c320e$var$clean(this.buffer.subarray(pos));
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        $6c341d77d66c320e$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = $6c341d77d66c320e$var$createView(out);
        const len = this.outputLen;
        if (len % 4) throw new Error('_sha2: outputLen should be aligned to 32bit');
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error('_sha2: outputLen bigger than state');
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.destroyed = destroyed;
        to.finished = finished;
        to.length = length;
        to.pos = pos;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
    clone() {
        return this._cloneInto();
    }
}
const $6c341d77d66c320e$var$SHA256_IV = Uint32Array.from([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
const $6c341d77d66c320e$var$SHA224_IV = Uint32Array.from([
    0xc1059ed8,
    0x367cd507,
    0x3070dd17,
    0xf70e5939,
    0xffc00b31,
    0x68581511,
    0x64f98fa7,
    0xbefa4fa4
]);
const $6c341d77d66c320e$var$SHA384_IV = Uint32Array.from([
    0xcbbb9d5d,
    0xc1059ed8,
    0x629a292a,
    0x367cd507,
    0x9159015a,
    0x3070dd17,
    0x152fecd8,
    0xf70e5939,
    0x67332667,
    0xffc00b31,
    0x8eb44a87,
    0x68581511,
    0xdb0c2e0d,
    0x64f98fa7,
    0x47b5481d,
    0xbefa4fa4
]);
const $6c341d77d66c320e$var$SHA512_IV = Uint32Array.from([
    0x6a09e667,
    0xf3bcc908,
    0xbb67ae85,
    0x84caa73b,
    0x3c6ef372,
    0xfe94f82b,
    0xa54ff53a,
    0x5f1d36f1,
    0x510e527f,
    0xade682d1,
    0x9b05688c,
    0x2b3e6c1f,
    0x1f83d9ab,
    0xfb41bd6b,
    0x5be0cd19,
    0x137e2179
]);
const $6c341d77d66c320e$var$SHA1_IV = Uint32Array.from([
    0x67452301,
    0xefcdab89,
    0x98badcfe,
    0x10325476,
    0xc3d2e1f0
]);
const $6c341d77d66c320e$var$SHA1_W = new Uint32Array(80);
class $6c341d77d66c320e$var$SHA1 extends $6c341d77d66c320e$var$HashMD {
    constructor(){
        super(64, 20, 8, false);
        this.A = $6c341d77d66c320e$var$SHA1_IV[0] | 0;
        this.B = $6c341d77d66c320e$var$SHA1_IV[1] | 0;
        this.C = $6c341d77d66c320e$var$SHA1_IV[2] | 0;
        this.D = $6c341d77d66c320e$var$SHA1_IV[3] | 0;
        this.E = $6c341d77d66c320e$var$SHA1_IV[4] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E } = this;
        return [
            A,
            B,
            C,
            D,
            E
        ];
    }
    set(A, B, C, D, E) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
    }
    process(view, offset) {
        for(let i = 0; i < 16; i++, offset += 4)$6c341d77d66c320e$var$SHA1_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 80; i++)$6c341d77d66c320e$var$SHA1_W[i] = $6c341d77d66c320e$var$rotl($6c341d77d66c320e$var$SHA1_W[i - 3] ^ $6c341d77d66c320e$var$SHA1_W[i - 8] ^ $6c341d77d66c320e$var$SHA1_W[i - 14] ^ $6c341d77d66c320e$var$SHA1_W[i - 16], 1);
        let { A: A, B: B, C: C, D: D, E: E } = this;
        for(let i = 0; i < 80; i++){
            let F, K;
            if (i < 20) {
                F = $6c341d77d66c320e$var$Chi(B, C, D);
                K = 0x5a827999;
            } else if (i < 40) {
                F = B ^ C ^ D;
                K = 0x6ed9eba1;
            } else if (i < 60) {
                F = $6c341d77d66c320e$var$Maj(B, C, D);
                K = 0x8f1bbcdc;
            } else {
                F = B ^ C ^ D;
                K = 0xca62c1d6;
            }
            const T = $6c341d77d66c320e$var$rotl(A, 5) + F + E + K + $6c341d77d66c320e$var$SHA1_W[i] | 0;
            E = D;
            D = C;
            C = $6c341d77d66c320e$var$rotl(B, 30);
            B = A;
            A = T;
        }
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        this.set(A, B, C, D, E);
    }
    roundClean() {
        $6c341d77d66c320e$var$clean($6c341d77d66c320e$var$SHA1_W);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0);
        $6c341d77d66c320e$var$clean(this.buffer);
    }
}
$6c341d77d66c320e$var$createHasher(()=>new $6c341d77d66c320e$var$SHA1());
const $6c341d77d66c320e$var$p32 = Math.pow(2, 32);
const $6c341d77d66c320e$var$K = Array.from({
    length: 64
}, (_, i)=>Math.floor($6c341d77d66c320e$var$p32 * Math.abs(Math.sin(i + 1))));
const $6c341d77d66c320e$var$MD5_IV = $6c341d77d66c320e$var$SHA1_IV.slice(0, 4);
const $6c341d77d66c320e$var$MD5_W = new Uint32Array(16);
class $6c341d77d66c320e$var$MD5 extends $6c341d77d66c320e$var$HashMD {
    constructor(){
        super(64, 16, 8, true);
        this.A = $6c341d77d66c320e$var$MD5_IV[0] | 0;
        this.B = $6c341d77d66c320e$var$MD5_IV[1] | 0;
        this.C = $6c341d77d66c320e$var$MD5_IV[2] | 0;
        this.D = $6c341d77d66c320e$var$MD5_IV[3] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D } = this;
        return [
            A,
            B,
            C,
            D
        ];
    }
    set(A, B, C, D) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
    }
    process(view, offset) {
        for(let i = 0; i < 16; i++, offset += 4)$6c341d77d66c320e$var$MD5_W[i] = view.getUint32(offset, true);
        let { A: A, B: B, C: C, D: D } = this;
        for(let i = 0; i < 64; i++){
            let F, g, s;
            if (i < 16) {
                F = $6c341d77d66c320e$var$Chi(B, C, D);
                g = i;
                s = [
                    7,
                    12,
                    17,
                    22
                ];
            } else if (i < 32) {
                F = $6c341d77d66c320e$var$Chi(D, B, C);
                g = (5 * i + 1) % 16;
                s = [
                    5,
                    9,
                    14,
                    20
                ];
            } else if (i < 48) {
                F = B ^ C ^ D;
                g = (3 * i + 5) % 16;
                s = [
                    4,
                    11,
                    16,
                    23
                ];
            } else {
                F = C ^ (B | ~D);
                g = 7 * i % 16;
                s = [
                    6,
                    10,
                    15,
                    21
                ];
            }
            F = F + A + $6c341d77d66c320e$var$K[i] + $6c341d77d66c320e$var$MD5_W[g];
            A = D;
            D = C;
            C = B;
            B = B + $6c341d77d66c320e$var$rotl(F, s[i % 4]);
        }
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        this.set(A, B, C, D);
    }
    roundClean() {
        $6c341d77d66c320e$var$clean($6c341d77d66c320e$var$MD5_W);
    }
    destroy() {
        this.set(0, 0, 0, 0);
        $6c341d77d66c320e$var$clean(this.buffer);
    }
}
const $6c341d77d66c320e$var$md5 = $6c341d77d66c320e$var$createHasher(()=>new $6c341d77d66c320e$var$MD5());
const $6c341d77d66c320e$var$Rho160 = Uint8Array.from([
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8
]);
const $6c341d77d66c320e$var$Id160 = (()=>Uint8Array.from(new Array(16).fill(0).map((_, i)=>i)))();
const $6c341d77d66c320e$var$Pi160 = (()=>$6c341d77d66c320e$var$Id160.map((i)=>(9 * i + 5) % 16))();
const $6c341d77d66c320e$var$idxLR = (()=>{
    const L = [
        $6c341d77d66c320e$var$Id160
    ];
    const R = [
        $6c341d77d66c320e$var$Pi160
    ];
    const res = [
        L,
        R
    ];
    for(let i = 0; i < 4; i++)for (let j of res)j.push(j[i].map((k)=>$6c341d77d66c320e$var$Rho160[k]));
    return res;
})();
const $6c341d77d66c320e$var$idxL = (()=>$6c341d77d66c320e$var$idxLR[0])();
const $6c341d77d66c320e$var$idxR = (()=>$6c341d77d66c320e$var$idxLR[1])();
const $6c341d77d66c320e$var$shifts160 = [
    [
        11,
        14,
        15,
        12,
        5,
        8,
        7,
        9,
        11,
        13,
        14,
        15,
        6,
        7,
        9,
        8
    ],
    [
        12,
        13,
        11,
        15,
        6,
        9,
        9,
        7,
        12,
        15,
        11,
        13,
        7,
        8,
        7,
        7
    ],
    [
        13,
        15,
        14,
        11,
        7,
        7,
        6,
        8,
        13,
        14,
        13,
        12,
        5,
        5,
        6,
        9
    ],
    [
        14,
        11,
        12,
        14,
        8,
        6,
        5,
        5,
        15,
        12,
        15,
        14,
        9,
        9,
        8,
        6
    ],
    [
        15,
        12,
        13,
        13,
        9,
        5,
        8,
        6,
        14,
        11,
        12,
        11,
        8,
        6,
        5,
        5
    ]
].map((i)=>Uint8Array.from(i));
const $6c341d77d66c320e$var$shiftsL160 = $6c341d77d66c320e$var$idxL.map((idx, i)=>idx.map((j)=>$6c341d77d66c320e$var$shifts160[i][j]));
const $6c341d77d66c320e$var$shiftsR160 = $6c341d77d66c320e$var$idxR.map((idx, i)=>idx.map((j)=>$6c341d77d66c320e$var$shifts160[i][j]));
const $6c341d77d66c320e$var$Kl160 = Uint32Array.from([
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
]);
const $6c341d77d66c320e$var$Kr160 = Uint32Array.from([
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
]);
function $6c341d77d66c320e$var$ripemd_f(group, x, y, z) {
    if (group === 0) return x ^ y ^ z;
    if (group === 1) return x & y | ~x & z;
    if (group === 2) return (x | ~y) ^ z;
    if (group === 3) return x & z | y & ~z;
    return x ^ (y | ~z);
}
const $6c341d77d66c320e$var$BUF_160 = new Uint32Array(16);
class $6c341d77d66c320e$var$RIPEMD160 extends $6c341d77d66c320e$var$HashMD {
    constructor(){
        super(64, 20, 8, true);
        this.h0 = 1732584193;
        this.h1 = -271733879;
        this.h2 = -1732584194;
        this.h3 = 271733878;
        this.h4 = -1009589776;
    }
    get() {
        const { h0: h0, h1: h1, h2: h2, h3: h3, h4: h4 } = this;
        return [
            h0,
            h1,
            h2,
            h3,
            h4
        ];
    }
    set(h0, h1, h2, h3, h4) {
        this.h0 = h0 | 0;
        this.h1 = h1 | 0;
        this.h2 = h2 | 0;
        this.h3 = h3 | 0;
        this.h4 = h4 | 0;
    }
    process(view, offset) {
        for(let i = 0; i < 16; i++, offset += 4)$6c341d77d66c320e$var$BUF_160[i] = view.getUint32(offset, true);
        let al = this.h0 | 0, ar = al, bl = this.h1 | 0, br = bl, cl = this.h2 | 0, cr = cl, dl = this.h3 | 0, dr = dl, el = this.h4 | 0, er = el;
        for(let group = 0; group < 5; group++){
            const rGroup = 4 - group;
            const hbl = $6c341d77d66c320e$var$Kl160[group], hbr = $6c341d77d66c320e$var$Kr160[group];
            const rl = $6c341d77d66c320e$var$idxL[group], rr = $6c341d77d66c320e$var$idxR[group];
            const sl = $6c341d77d66c320e$var$shiftsL160[group], sr = $6c341d77d66c320e$var$shiftsR160[group];
            for(let i = 0; i < 16; i++){
                const tl = $6c341d77d66c320e$var$rotl(al + $6c341d77d66c320e$var$ripemd_f(group, bl, cl, dl) + $6c341d77d66c320e$var$BUF_160[rl[i]] + hbl, sl[i]) + el | 0;
                al = el, el = dl, dl = $6c341d77d66c320e$var$rotl(cl, 10) | 0, cl = bl, bl = tl;
            }
            for(let i = 0; i < 16; i++){
                const tr = $6c341d77d66c320e$var$rotl(ar + $6c341d77d66c320e$var$ripemd_f(rGroup, br, cr, dr) + $6c341d77d66c320e$var$BUF_160[rr[i]] + hbr, sr[i]) + er | 0;
                ar = er, er = dr, dr = $6c341d77d66c320e$var$rotl(cr, 10) | 0, cr = br, br = tr;
            }
        }
        this.set(this.h1 + cl + dr | 0, this.h2 + dl + er | 0, this.h3 + el + ar | 0, this.h4 + al + br | 0, this.h0 + bl + cr | 0);
    }
    roundClean() {
        $6c341d77d66c320e$var$clean($6c341d77d66c320e$var$BUF_160);
    }
    destroy() {
        this.destroyed = true;
        $6c341d77d66c320e$var$clean(this.buffer);
        this.set(0, 0, 0, 0, 0);
    }
}
$6c341d77d66c320e$var$createHasher(()=>new $6c341d77d66c320e$var$RIPEMD160());
function $6c341d77d66c320e$var$md5Hash(data) {
    return $6c341d77d66c320e$var$md5.create().update(data).digest();
}
function $6c341d77d66c320e$var$md5Hex(data) {
    return (0, $f354203f433ec289$export$58b867e287a802c8)($6c341d77d66c320e$var$md5Hash(data));
}
const $6c341d77d66c320e$var$U32_MASK64 = BigInt(2 ** 32 - 1);
const $6c341d77d66c320e$var$_32n = BigInt(32);
function $6c341d77d66c320e$var$fromBig(n, le = false) {
    if (le) return {
        h: Number(n & $6c341d77d66c320e$var$U32_MASK64),
        l: Number(n >> $6c341d77d66c320e$var$_32n & $6c341d77d66c320e$var$U32_MASK64)
    };
    return {
        h: Number(n >> $6c341d77d66c320e$var$_32n & $6c341d77d66c320e$var$U32_MASK64) | 0,
        l: Number(n & $6c341d77d66c320e$var$U32_MASK64) | 0
    };
}
function $6c341d77d66c320e$var$split(lst, le = false) {
    const len = lst.length;
    let Ah = new Uint32Array(len);
    let Al = new Uint32Array(len);
    for(let i = 0; i < len; i++){
        const { h: h, l: l } = $6c341d77d66c320e$var$fromBig(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
const $6c341d77d66c320e$var$shrSH = (h, _l, s)=>h >>> s;
const $6c341d77d66c320e$var$shrSL = (h, l, s)=>h << 32 - s | l >>> s;
const $6c341d77d66c320e$var$rotrSH = (h, l, s)=>h >>> s | l << 32 - s;
const $6c341d77d66c320e$var$rotrSL = (h, l, s)=>h << 32 - s | l >>> s;
const $6c341d77d66c320e$var$rotrBH = (h, l, s)=>h << 64 - s | l >>> s - 32;
const $6c341d77d66c320e$var$rotrBL = (h, l, s)=>h >>> s - 32 | l << 64 - s;
function $6c341d77d66c320e$var$add(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
const $6c341d77d66c320e$var$add3L = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
const $6c341d77d66c320e$var$add3H = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
const $6c341d77d66c320e$var$add4L = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
const $6c341d77d66c320e$var$add4H = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
const $6c341d77d66c320e$var$add5L = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
const $6c341d77d66c320e$var$add5H = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
const $6c341d77d66c320e$var$SHA256_K = Uint32Array.from([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
const $6c341d77d66c320e$var$SHA256_W = new Uint32Array(64);
class $6c341d77d66c320e$var$SHA256 extends $6c341d77d66c320e$var$HashMD {
    constructor(outputLen = 32){
        super(64, outputLen, 8, false);
        this.A = $6c341d77d66c320e$var$SHA256_IV[0] | 0;
        this.B = $6c341d77d66c320e$var$SHA256_IV[1] | 0;
        this.C = $6c341d77d66c320e$var$SHA256_IV[2] | 0;
        this.D = $6c341d77d66c320e$var$SHA256_IV[3] | 0;
        this.E = $6c341d77d66c320e$var$SHA256_IV[4] | 0;
        this.F = $6c341d77d66c320e$var$SHA256_IV[5] | 0;
        this.G = $6c341d77d66c320e$var$SHA256_IV[6] | 0;
        this.H = $6c341d77d66c320e$var$SHA256_IV[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        for(let i = 0; i < 16; i++, offset += 4)$6c341d77d66c320e$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $6c341d77d66c320e$var$SHA256_W[i - 15];
            const W2 = $6c341d77d66c320e$var$SHA256_W[i - 2];
            const s0 = $6c341d77d66c320e$var$rotr(W15, 7) ^ $6c341d77d66c320e$var$rotr(W15, 18) ^ W15 >>> 3;
            const s1 = $6c341d77d66c320e$var$rotr(W2, 17) ^ $6c341d77d66c320e$var$rotr(W2, 19) ^ W2 >>> 10;
            $6c341d77d66c320e$var$SHA256_W[i] = s1 + $6c341d77d66c320e$var$SHA256_W[i - 7] + s0 + $6c341d77d66c320e$var$SHA256_W[i - 16] | 0;
        }
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = $6c341d77d66c320e$var$rotr(E, 6) ^ $6c341d77d66c320e$var$rotr(E, 11) ^ $6c341d77d66c320e$var$rotr(E, 25);
            const T1 = H + sigma1 + $6c341d77d66c320e$var$Chi(E, F, G) + $6c341d77d66c320e$var$SHA256_K[i] + $6c341d77d66c320e$var$SHA256_W[i] | 0;
            const sigma0 = $6c341d77d66c320e$var$rotr(A, 2) ^ $6c341d77d66c320e$var$rotr(A, 13) ^ $6c341d77d66c320e$var$rotr(A, 22);
            const T2 = sigma0 + $6c341d77d66c320e$var$Maj(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        $6c341d77d66c320e$var$clean($6c341d77d66c320e$var$SHA256_W);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        $6c341d77d66c320e$var$clean(this.buffer);
    }
}
class $6c341d77d66c320e$var$SHA224 extends $6c341d77d66c320e$var$SHA256 {
    constructor(){
        super(28);
        this.A = $6c341d77d66c320e$var$SHA224_IV[0] | 0;
        this.B = $6c341d77d66c320e$var$SHA224_IV[1] | 0;
        this.C = $6c341d77d66c320e$var$SHA224_IV[2] | 0;
        this.D = $6c341d77d66c320e$var$SHA224_IV[3] | 0;
        this.E = $6c341d77d66c320e$var$SHA224_IV[4] | 0;
        this.F = $6c341d77d66c320e$var$SHA224_IV[5] | 0;
        this.G = $6c341d77d66c320e$var$SHA224_IV[6] | 0;
        this.H = $6c341d77d66c320e$var$SHA224_IV[7] | 0;
    }
}
const $6c341d77d66c320e$var$K512 = (()=>$6c341d77d66c320e$var$split([
        '0x428a2f98d728ae22',
        '0x7137449123ef65cd',
        '0xb5c0fbcfec4d3b2f',
        '0xe9b5dba58189dbbc',
        '0x3956c25bf348b538',
        '0x59f111f1b605d019',
        '0x923f82a4af194f9b',
        '0xab1c5ed5da6d8118',
        '0xd807aa98a3030242',
        '0x12835b0145706fbe',
        '0x243185be4ee4b28c',
        '0x550c7dc3d5ffb4e2',
        '0x72be5d74f27b896f',
        '0x80deb1fe3b1696b1',
        '0x9bdc06a725c71235',
        '0xc19bf174cf692694',
        '0xe49b69c19ef14ad2',
        '0xefbe4786384f25e3',
        '0x0fc19dc68b8cd5b5',
        '0x240ca1cc77ac9c65',
        '0x2de92c6f592b0275',
        '0x4a7484aa6ea6e483',
        '0x5cb0a9dcbd41fbd4',
        '0x76f988da831153b5',
        '0x983e5152ee66dfab',
        '0xa831c66d2db43210',
        '0xb00327c898fb213f',
        '0xbf597fc7beef0ee4',
        '0xc6e00bf33da88fc2',
        '0xd5a79147930aa725',
        '0x06ca6351e003826f',
        '0x142929670a0e6e70',
        '0x27b70a8546d22ffc',
        '0x2e1b21385c26c926',
        '0x4d2c6dfc5ac42aed',
        '0x53380d139d95b3df',
        '0x650a73548baf63de',
        '0x766a0abb3c77b2a8',
        '0x81c2c92e47edaee6',
        '0x92722c851482353b',
        '0xa2bfe8a14cf10364',
        '0xa81a664bbc423001',
        '0xc24b8b70d0f89791',
        '0xc76c51a30654be30',
        '0xd192e819d6ef5218',
        '0xd69906245565a910',
        '0xf40e35855771202a',
        '0x106aa07032bbd1b8',
        '0x19a4c116b8d2d0c8',
        '0x1e376c085141ab53',
        '0x2748774cdf8eeb99',
        '0x34b0bcb5e19b48a8',
        '0x391c0cb3c5c95a63',
        '0x4ed8aa4ae3418acb',
        '0x5b9cca4f7763e373',
        '0x682e6ff3d6b2b8a3',
        '0x748f82ee5defb2fc',
        '0x78a5636f43172f60',
        '0x84c87814a1f0ab72',
        '0x8cc702081a6439ec',
        '0x90befffa23631e28',
        '0xa4506cebde82bde9',
        '0xbef9a3f7b2c67915',
        '0xc67178f2e372532b',
        '0xca273eceea26619c',
        '0xd186b8c721c0c207',
        '0xeada7dd6cde0eb1e',
        '0xf57d4f7fee6ed178',
        '0x06f067aa72176fba',
        '0x0a637dc5a2c898a6',
        '0x113f9804bef90dae',
        '0x1b710b35131c471b',
        '0x28db77f523047d84',
        '0x32caab7b40c72493',
        '0x3c9ebe0a15c9bebc',
        '0x431d67c49c100d4c',
        '0x4cc5d4becb3e42b6',
        '0x597f299cfc657e2a',
        '0x5fcb6fab3ad6faec',
        '0x6c44198c4a475817'
    ].map((n)=>BigInt(n))))();
const $6c341d77d66c320e$var$SHA512_Kh = (()=>$6c341d77d66c320e$var$K512[0])();
const $6c341d77d66c320e$var$SHA512_Kl = (()=>$6c341d77d66c320e$var$K512[1])();
const $6c341d77d66c320e$var$SHA512_W_H = new Uint32Array(80);
const $6c341d77d66c320e$var$SHA512_W_L = new Uint32Array(80);
class $6c341d77d66c320e$var$SHA512 extends $6c341d77d66c320e$var$HashMD {
    constructor(outputLen = 64){
        super(128, outputLen, 16, false);
        this.Ah = $6c341d77d66c320e$var$SHA512_IV[0] | 0;
        this.Al = $6c341d77d66c320e$var$SHA512_IV[1] | 0;
        this.Bh = $6c341d77d66c320e$var$SHA512_IV[2] | 0;
        this.Bl = $6c341d77d66c320e$var$SHA512_IV[3] | 0;
        this.Ch = $6c341d77d66c320e$var$SHA512_IV[4] | 0;
        this.Cl = $6c341d77d66c320e$var$SHA512_IV[5] | 0;
        this.Dh = $6c341d77d66c320e$var$SHA512_IV[6] | 0;
        this.Dl = $6c341d77d66c320e$var$SHA512_IV[7] | 0;
        this.Eh = $6c341d77d66c320e$var$SHA512_IV[8] | 0;
        this.El = $6c341d77d66c320e$var$SHA512_IV[9] | 0;
        this.Fh = $6c341d77d66c320e$var$SHA512_IV[10] | 0;
        this.Fl = $6c341d77d66c320e$var$SHA512_IV[11] | 0;
        this.Gh = $6c341d77d66c320e$var$SHA512_IV[12] | 0;
        this.Gl = $6c341d77d66c320e$var$SHA512_IV[13] | 0;
        this.Hh = $6c341d77d66c320e$var$SHA512_IV[14] | 0;
        this.Hl = $6c341d77d66c320e$var$SHA512_IV[15] | 0;
    }
    get() {
        const { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        return [
            Ah,
            Al,
            Bh,
            Bl,
            Ch,
            Cl,
            Dh,
            Dl,
            Eh,
            El,
            Fh,
            Fl,
            Gh,
            Gl,
            Hh,
            Hl
        ];
    }
    set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    }
    process(view, offset) {
        for(let i = 0; i < 16; i++, offset += 4){
            $6c341d77d66c320e$var$SHA512_W_H[i] = view.getUint32(offset);
            $6c341d77d66c320e$var$SHA512_W_L[i] = view.getUint32(offset += 4);
        }
        for(let i = 16; i < 80; i++){
            const W15h = $6c341d77d66c320e$var$SHA512_W_H[i - 15] | 0;
            const W15l = $6c341d77d66c320e$var$SHA512_W_L[i - 15] | 0;
            const s0h = $6c341d77d66c320e$var$rotrSH(W15h, W15l, 1) ^ $6c341d77d66c320e$var$rotrSH(W15h, W15l, 8) ^ $6c341d77d66c320e$var$shrSH(W15h, W15l, 7);
            const s0l = $6c341d77d66c320e$var$rotrSL(W15h, W15l, 1) ^ $6c341d77d66c320e$var$rotrSL(W15h, W15l, 8) ^ $6c341d77d66c320e$var$shrSL(W15h, W15l, 7);
            const W2h = $6c341d77d66c320e$var$SHA512_W_H[i - 2] | 0;
            const W2l = $6c341d77d66c320e$var$SHA512_W_L[i - 2] | 0;
            const s1h = $6c341d77d66c320e$var$rotrSH(W2h, W2l, 19) ^ $6c341d77d66c320e$var$rotrBH(W2h, W2l, 61) ^ $6c341d77d66c320e$var$shrSH(W2h, W2l, 6);
            const s1l = $6c341d77d66c320e$var$rotrSL(W2h, W2l, 19) ^ $6c341d77d66c320e$var$rotrBL(W2h, W2l, 61) ^ $6c341d77d66c320e$var$shrSL(W2h, W2l, 6);
            const SUMl = $6c341d77d66c320e$var$add4L(s0l, s1l, $6c341d77d66c320e$var$SHA512_W_L[i - 7], $6c341d77d66c320e$var$SHA512_W_L[i - 16]);
            const SUMh = $6c341d77d66c320e$var$add4H(SUMl, s0h, s1h, $6c341d77d66c320e$var$SHA512_W_H[i - 7], $6c341d77d66c320e$var$SHA512_W_H[i - 16]);
            $6c341d77d66c320e$var$SHA512_W_H[i] = SUMh | 0;
            $6c341d77d66c320e$var$SHA512_W_L[i] = SUMl | 0;
        }
        let { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        for(let i = 0; i < 80; i++){
            const sigma1h = $6c341d77d66c320e$var$rotrSH(Eh, El, 14) ^ $6c341d77d66c320e$var$rotrSH(Eh, El, 18) ^ $6c341d77d66c320e$var$rotrBH(Eh, El, 41);
            const sigma1l = $6c341d77d66c320e$var$rotrSL(Eh, El, 14) ^ $6c341d77d66c320e$var$rotrSL(Eh, El, 18) ^ $6c341d77d66c320e$var$rotrBL(Eh, El, 41);
            const CHIh = Eh & Fh ^ ~Eh & Gh;
            const CHIl = El & Fl ^ ~El & Gl;
            const T1ll = $6c341d77d66c320e$var$add5L(Hl, sigma1l, CHIl, $6c341d77d66c320e$var$SHA512_Kl[i], $6c341d77d66c320e$var$SHA512_W_L[i]);
            const T1h = $6c341d77d66c320e$var$add5H(T1ll, Hh, sigma1h, CHIh, $6c341d77d66c320e$var$SHA512_Kh[i], $6c341d77d66c320e$var$SHA512_W_H[i]);
            const T1l = T1ll | 0;
            const sigma0h = $6c341d77d66c320e$var$rotrSH(Ah, Al, 28) ^ $6c341d77d66c320e$var$rotrBH(Ah, Al, 34) ^ $6c341d77d66c320e$var$rotrBH(Ah, Al, 39);
            const sigma0l = $6c341d77d66c320e$var$rotrSL(Ah, Al, 28) ^ $6c341d77d66c320e$var$rotrBL(Ah, Al, 34) ^ $6c341d77d66c320e$var$rotrBL(Ah, Al, 39);
            const MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
            const MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            ({ h: Eh, l: El } = $6c341d77d66c320e$var$add(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            const All = $6c341d77d66c320e$var$add3L(T1l, sigma0l, MAJl);
            Ah = $6c341d77d66c320e$var$add3H(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        ({ h: Ah, l: Al } = $6c341d77d66c320e$var$add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
        ({ h: Bh, l: Bl } = $6c341d77d66c320e$var$add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
        ({ h: Ch, l: Cl } = $6c341d77d66c320e$var$add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
        ({ h: Dh, l: Dl } = $6c341d77d66c320e$var$add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
        ({ h: Eh, l: El } = $6c341d77d66c320e$var$add(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
        ({ h: Fh, l: Fl } = $6c341d77d66c320e$var$add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
        ({ h: Gh, l: Gl } = $6c341d77d66c320e$var$add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
        ({ h: Hh, l: Hl } = $6c341d77d66c320e$var$add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    }
    roundClean() {
        $6c341d77d66c320e$var$clean($6c341d77d66c320e$var$SHA512_W_H, $6c341d77d66c320e$var$SHA512_W_L);
    }
    destroy() {
        $6c341d77d66c320e$var$clean(this.buffer);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
class $6c341d77d66c320e$var$SHA384 extends $6c341d77d66c320e$var$SHA512 {
    constructor(){
        super(48);
        this.Ah = $6c341d77d66c320e$var$SHA384_IV[0] | 0;
        this.Al = $6c341d77d66c320e$var$SHA384_IV[1] | 0;
        this.Bh = $6c341d77d66c320e$var$SHA384_IV[2] | 0;
        this.Bl = $6c341d77d66c320e$var$SHA384_IV[3] | 0;
        this.Ch = $6c341d77d66c320e$var$SHA384_IV[4] | 0;
        this.Cl = $6c341d77d66c320e$var$SHA384_IV[5] | 0;
        this.Dh = $6c341d77d66c320e$var$SHA384_IV[6] | 0;
        this.Dl = $6c341d77d66c320e$var$SHA384_IV[7] | 0;
        this.Eh = $6c341d77d66c320e$var$SHA384_IV[8] | 0;
        this.El = $6c341d77d66c320e$var$SHA384_IV[9] | 0;
        this.Fh = $6c341d77d66c320e$var$SHA384_IV[10] | 0;
        this.Fl = $6c341d77d66c320e$var$SHA384_IV[11] | 0;
        this.Gh = $6c341d77d66c320e$var$SHA384_IV[12] | 0;
        this.Gl = $6c341d77d66c320e$var$SHA384_IV[13] | 0;
        this.Hh = $6c341d77d66c320e$var$SHA384_IV[14] | 0;
        this.Hl = $6c341d77d66c320e$var$SHA384_IV[15] | 0;
    }
}
const $6c341d77d66c320e$var$T224_IV = Uint32Array.from([
    0x8c3d37c8,
    0x19544da2,
    0x73e19966,
    0x89dcd4d6,
    0x1dfab7ae,
    0x32ff9c82,
    0x679dd514,
    0x582f9fcf,
    0x0f6d2b69,
    0x7bd44da8,
    0x77e36f73,
    0x04c48942,
    0x3f9d85a8,
    0x6a1d36c8,
    0x1112e6ad,
    0x91d692a1
]);
const $6c341d77d66c320e$var$T256_IV = Uint32Array.from([
    0x22312194,
    0xfc2bf72c,
    0x9f555fa3,
    0xc84c64c2,
    0x2393b86b,
    0x6f53b151,
    0x96387719,
    0x5940eabd,
    0x96283ee2,
    0xa88effe3,
    0xbe5e1e25,
    0x53863992,
    0x2b0199fc,
    0x2c85b8aa,
    0x0eb72ddc,
    0x81c52ca2
]);
class $6c341d77d66c320e$var$SHA512_224 extends $6c341d77d66c320e$var$SHA512 {
    constructor(){
        super(28);
        this.Ah = $6c341d77d66c320e$var$T224_IV[0] | 0;
        this.Al = $6c341d77d66c320e$var$T224_IV[1] | 0;
        this.Bh = $6c341d77d66c320e$var$T224_IV[2] | 0;
        this.Bl = $6c341d77d66c320e$var$T224_IV[3] | 0;
        this.Ch = $6c341d77d66c320e$var$T224_IV[4] | 0;
        this.Cl = $6c341d77d66c320e$var$T224_IV[5] | 0;
        this.Dh = $6c341d77d66c320e$var$T224_IV[6] | 0;
        this.Dl = $6c341d77d66c320e$var$T224_IV[7] | 0;
        this.Eh = $6c341d77d66c320e$var$T224_IV[8] | 0;
        this.El = $6c341d77d66c320e$var$T224_IV[9] | 0;
        this.Fh = $6c341d77d66c320e$var$T224_IV[10] | 0;
        this.Fl = $6c341d77d66c320e$var$T224_IV[11] | 0;
        this.Gh = $6c341d77d66c320e$var$T224_IV[12] | 0;
        this.Gl = $6c341d77d66c320e$var$T224_IV[13] | 0;
        this.Hh = $6c341d77d66c320e$var$T224_IV[14] | 0;
        this.Hl = $6c341d77d66c320e$var$T224_IV[15] | 0;
    }
}
class $6c341d77d66c320e$var$SHA512_256 extends $6c341d77d66c320e$var$SHA512 {
    constructor(){
        super(32);
        this.Ah = $6c341d77d66c320e$var$T256_IV[0] | 0;
        this.Al = $6c341d77d66c320e$var$T256_IV[1] | 0;
        this.Bh = $6c341d77d66c320e$var$T256_IV[2] | 0;
        this.Bl = $6c341d77d66c320e$var$T256_IV[3] | 0;
        this.Ch = $6c341d77d66c320e$var$T256_IV[4] | 0;
        this.Cl = $6c341d77d66c320e$var$T256_IV[5] | 0;
        this.Dh = $6c341d77d66c320e$var$T256_IV[6] | 0;
        this.Dl = $6c341d77d66c320e$var$T256_IV[7] | 0;
        this.Eh = $6c341d77d66c320e$var$T256_IV[8] | 0;
        this.El = $6c341d77d66c320e$var$T256_IV[9] | 0;
        this.Fh = $6c341d77d66c320e$var$T256_IV[10] | 0;
        this.Fl = $6c341d77d66c320e$var$T256_IV[11] | 0;
        this.Gh = $6c341d77d66c320e$var$T256_IV[12] | 0;
        this.Gl = $6c341d77d66c320e$var$T256_IV[13] | 0;
        this.Hh = $6c341d77d66c320e$var$T256_IV[14] | 0;
        this.Hl = $6c341d77d66c320e$var$T256_IV[15] | 0;
    }
}
const $6c341d77d66c320e$var$sha256 = $6c341d77d66c320e$var$createHasher(()=>new $6c341d77d66c320e$var$SHA256());
$6c341d77d66c320e$var$createHasher(()=>new $6c341d77d66c320e$var$SHA224());
$6c341d77d66c320e$var$createHasher(()=>new $6c341d77d66c320e$var$SHA512());
$6c341d77d66c320e$var$createHasher(()=>new $6c341d77d66c320e$var$SHA384());
$6c341d77d66c320e$var$createHasher(()=>new $6c341d77d66c320e$var$SHA512_256());
$6c341d77d66c320e$var$createHasher(()=>new $6c341d77d66c320e$var$SHA512_224());
function $6c341d77d66c320e$var$sha256Hash(data) {
    return $6c341d77d66c320e$var$sha256(data);
}
function $6c341d77d66c320e$var$aesCbcEncrypt(data, key, iv, padding = true) {
    return (0, $0d86ce4f5243a4d8$export$f98efb84b25ee206)(key, iv, {
        disablePadding: !padding
    }).encrypt(data);
}
function $6c341d77d66c320e$var$aesEcbEncrypt(data, key) {
    return (0, $0d86ce4f5243a4d8$export$bf364bd2354bf4a)(key, {
        disablePadding: true
    }).encrypt(data);
}
function $6c341d77d66c320e$var$rc4(data, key) {
    const s = new Uint8Array(256);
    for(let i = 0; i < 256; i++)s[i] = i;
    let j = 0;
    for(let i = 0; i < 256; i++){
        j = j + s[i] + key[i % key.length] & 0xff;
        [s[i], s[j]] = [
            s[j],
            s[i]
        ];
    }
    const output = new Uint8Array(data.length);
    for(let i = 0, j = 0, k = 0; k < data.length; k++){
        i = i + 1 & 0xff;
        j = j + s[i] & 0xff;
        [s[i], s[j]] = [
            s[j],
            s[i]
        ];
        output[k] = data[k] ^ s[s[i] + s[j] & 0xff];
    }
    return output;
}
function $6c341d77d66c320e$var$randomBytes(length) {
    const bytes = new Uint8Array(length);
    globalThis.crypto.getRandomValues(bytes);
    return bytes;
}
function $6c341d77d66c320e$var$inRange(value, rangeGroup) {
    if (value < rangeGroup[0]) return false;
    let startRange = 0;
    let endRange = rangeGroup.length / 2;
    while(startRange <= endRange){
        const middleRange = Math.floor((startRange + endRange) / 2);
        const arrayIndex = middleRange * 2;
        if (value >= rangeGroup[arrayIndex] && value <= rangeGroup[arrayIndex + 1]) return true;
        if (value > rangeGroup[arrayIndex + 1]) startRange = middleRange + 1;
        else endRange = middleRange - 1;
    }
    return false;
}
const $6c341d77d66c320e$var$unassigned_code_points = [
    0x0221,
    0x0221,
    0x0234,
    0x024f,
    0x02ae,
    0x02af,
    0x02ef,
    0x02ff,
    0x0350,
    0x035f,
    0x0370,
    0x0373,
    0x0376,
    0x0379,
    0x037b,
    0x037d,
    0x037f,
    0x0383,
    0x038b,
    0x038b,
    0x038d,
    0x038d,
    0x03a2,
    0x03a2,
    0x03cf,
    0x03cf,
    0x03f7,
    0x03ff,
    0x0487,
    0x0487,
    0x04cf,
    0x04cf,
    0x04f6,
    0x04f7,
    0x04fa,
    0x04ff,
    0x0510,
    0x0530,
    0x0557,
    0x0558,
    0x0560,
    0x0560,
    0x0588,
    0x0588,
    0x058b,
    0x0590,
    0x05a2,
    0x05a2,
    0x05ba,
    0x05ba,
    0x05c5,
    0x05cf,
    0x05eb,
    0x05ef,
    0x05f5,
    0x060b,
    0x060d,
    0x061a,
    0x061c,
    0x061e,
    0x0620,
    0x0620,
    0x063b,
    0x063f,
    0x0656,
    0x065f,
    0x06ee,
    0x06ef,
    0x06ff,
    0x06ff,
    0x070e,
    0x070e,
    0x072d,
    0x072f,
    0x074b,
    0x077f,
    0x07b2,
    0x0900,
    0x0904,
    0x0904,
    0x093a,
    0x093b,
    0x094e,
    0x094f,
    0x0955,
    0x0957,
    0x0971,
    0x0980,
    0x0984,
    0x0984,
    0x098d,
    0x098e,
    0x0991,
    0x0992,
    0x09a9,
    0x09a9,
    0x09b1,
    0x09b1,
    0x09b3,
    0x09b5,
    0x09ba,
    0x09bb,
    0x09bd,
    0x09bd,
    0x09c5,
    0x09c6,
    0x09c9,
    0x09ca,
    0x09ce,
    0x09d6,
    0x09d8,
    0x09db,
    0x09de,
    0x09de,
    0x09e4,
    0x09e5,
    0x09fb,
    0x0a01,
    0x0a03,
    0x0a04,
    0x0a0b,
    0x0a0e,
    0x0a11,
    0x0a12,
    0x0a29,
    0x0a29,
    0x0a31,
    0x0a31,
    0x0a34,
    0x0a34,
    0x0a37,
    0x0a37,
    0x0a3a,
    0x0a3b,
    0x0a3d,
    0x0a3d,
    0x0a43,
    0x0a46,
    0x0a49,
    0x0a4a,
    0x0a4e,
    0x0a58,
    0x0a5d,
    0x0a5d,
    0x0a5f,
    0x0a65,
    0x0a75,
    0x0a80,
    0x0a84,
    0x0a84,
    0x0a8c,
    0x0a8c,
    0x0a8e,
    0x0a8e,
    0x0a92,
    0x0a92,
    0x0aa9,
    0x0aa9,
    0x0ab1,
    0x0ab1,
    0x0ab4,
    0x0ab4,
    0x0aba,
    0x0abb,
    0x0ac6,
    0x0ac6,
    0x0aca,
    0x0aca,
    0x0ace,
    0x0acf,
    0x0ad1,
    0x0adf,
    0x0ae1,
    0x0ae5,
    0x0af0,
    0x0b00,
    0x0b04,
    0x0b04,
    0x0b0d,
    0x0b0e,
    0x0b11,
    0x0b12,
    0x0b29,
    0x0b29,
    0x0b31,
    0x0b31,
    0x0b34,
    0x0b35,
    0x0b3a,
    0x0b3b,
    0x0b44,
    0x0b46,
    0x0b49,
    0x0b4a,
    0x0b4e,
    0x0b55,
    0x0b58,
    0x0b5b,
    0x0b5e,
    0x0b5e,
    0x0b62,
    0x0b65,
    0x0b71,
    0x0b81,
    0x0b84,
    0x0b84,
    0x0b8b,
    0x0b8d,
    0x0b91,
    0x0b91,
    0x0b96,
    0x0b98,
    0x0b9b,
    0x0b9b,
    0x0b9d,
    0x0b9d,
    0x0ba0,
    0x0ba2,
    0x0ba5,
    0x0ba7,
    0x0bab,
    0x0bad,
    0x0bb6,
    0x0bb6,
    0x0bba,
    0x0bbd,
    0x0bc3,
    0x0bc5,
    0x0bc9,
    0x0bc9,
    0x0bce,
    0x0bd6,
    0x0bd8,
    0x0be6,
    0x0bf3,
    0x0c00,
    0x0c04,
    0x0c04,
    0x0c0d,
    0x0c0d,
    0x0c11,
    0x0c11,
    0x0c29,
    0x0c29,
    0x0c34,
    0x0c34,
    0x0c3a,
    0x0c3d,
    0x0c45,
    0x0c45,
    0x0c49,
    0x0c49,
    0x0c4e,
    0x0c54,
    0x0c57,
    0x0c5f,
    0x0c62,
    0x0c65,
    0x0c70,
    0x0c81,
    0x0c84,
    0x0c84,
    0x0c8d,
    0x0c8d,
    0x0c91,
    0x0c91,
    0x0ca9,
    0x0ca9,
    0x0cb4,
    0x0cb4,
    0x0cba,
    0x0cbd,
    0x0cc5,
    0x0cc5,
    0x0cc9,
    0x0cc9,
    0x0cce,
    0x0cd4,
    0x0cd7,
    0x0cdd,
    0x0cdf,
    0x0cdf,
    0x0ce2,
    0x0ce5,
    0x0cf0,
    0x0d01,
    0x0d04,
    0x0d04,
    0x0d0d,
    0x0d0d,
    0x0d11,
    0x0d11,
    0x0d29,
    0x0d29,
    0x0d3a,
    0x0d3d,
    0x0d44,
    0x0d45,
    0x0d49,
    0x0d49,
    0x0d4e,
    0x0d56,
    0x0d58,
    0x0d5f,
    0x0d62,
    0x0d65,
    0x0d70,
    0x0d81,
    0x0d84,
    0x0d84,
    0x0d97,
    0x0d99,
    0x0db2,
    0x0db2,
    0x0dbc,
    0x0dbc,
    0x0dbe,
    0x0dbf,
    0x0dc7,
    0x0dc9,
    0x0dcb,
    0x0dce,
    0x0dd5,
    0x0dd5,
    0x0dd7,
    0x0dd7,
    0x0de0,
    0x0df1,
    0x0df5,
    0x0e00,
    0x0e3b,
    0x0e3e,
    0x0e5c,
    0x0e80,
    0x0e83,
    0x0e83,
    0x0e85,
    0x0e86,
    0x0e89,
    0x0e89,
    0x0e8b,
    0x0e8c,
    0x0e8e,
    0x0e93,
    0x0e98,
    0x0e98,
    0x0ea0,
    0x0ea0,
    0x0ea4,
    0x0ea4,
    0x0ea6,
    0x0ea6,
    0x0ea8,
    0x0ea9,
    0x0eac,
    0x0eac,
    0x0eba,
    0x0eba,
    0x0ebe,
    0x0ebf,
    0x0ec5,
    0x0ec5,
    0x0ec7,
    0x0ec7,
    0x0ece,
    0x0ecf,
    0x0eda,
    0x0edb,
    0x0ede,
    0x0eff,
    0x0f48,
    0x0f48,
    0x0f6b,
    0x0f70,
    0x0f8c,
    0x0f8f,
    0x0f98,
    0x0f98,
    0x0fbd,
    0x0fbd,
    0x0fcd,
    0x0fce,
    0x0fd0,
    0x0fff,
    0x1022,
    0x1022,
    0x1028,
    0x1028,
    0x102b,
    0x102b,
    0x1033,
    0x1035,
    0x103a,
    0x103f,
    0x105a,
    0x109f,
    0x10c6,
    0x10cf,
    0x10f9,
    0x10fa,
    0x10fc,
    0x10ff,
    0x115a,
    0x115e,
    0x11a3,
    0x11a7,
    0x11fa,
    0x11ff,
    0x1207,
    0x1207,
    0x1247,
    0x1247,
    0x1249,
    0x1249,
    0x124e,
    0x124f,
    0x1257,
    0x1257,
    0x1259,
    0x1259,
    0x125e,
    0x125f,
    0x1287,
    0x1287,
    0x1289,
    0x1289,
    0x128e,
    0x128f,
    0x12af,
    0x12af,
    0x12b1,
    0x12b1,
    0x12b6,
    0x12b7,
    0x12bf,
    0x12bf,
    0x12c1,
    0x12c1,
    0x12c6,
    0x12c7,
    0x12cf,
    0x12cf,
    0x12d7,
    0x12d7,
    0x12ef,
    0x12ef,
    0x130f,
    0x130f,
    0x1311,
    0x1311,
    0x1316,
    0x1317,
    0x131f,
    0x131f,
    0x1347,
    0x1347,
    0x135b,
    0x1360,
    0x137d,
    0x139f,
    0x13f5,
    0x1400,
    0x1677,
    0x167f,
    0x169d,
    0x169f,
    0x16f1,
    0x16ff,
    0x170d,
    0x170d,
    0x1715,
    0x171f,
    0x1737,
    0x173f,
    0x1754,
    0x175f,
    0x176d,
    0x176d,
    0x1771,
    0x1771,
    0x1774,
    0x177f,
    0x17dd,
    0x17df,
    0x17ea,
    0x17ff,
    0x180f,
    0x180f,
    0x181a,
    0x181f,
    0x1878,
    0x187f,
    0x18aa,
    0x1dff,
    0x1e9c,
    0x1e9f,
    0x1efa,
    0x1eff,
    0x1f16,
    0x1f17,
    0x1f1e,
    0x1f1f,
    0x1f46,
    0x1f47,
    0x1f4e,
    0x1f4f,
    0x1f58,
    0x1f58,
    0x1f5a,
    0x1f5a,
    0x1f5c,
    0x1f5c,
    0x1f5e,
    0x1f5e,
    0x1f7e,
    0x1f7f,
    0x1fb5,
    0x1fb5,
    0x1fc5,
    0x1fc5,
    0x1fd4,
    0x1fd5,
    0x1fdc,
    0x1fdc,
    0x1ff0,
    0x1ff1,
    0x1ff5,
    0x1ff5,
    0x1fff,
    0x1fff,
    0x2053,
    0x2056,
    0x2058,
    0x205e,
    0x2064,
    0x2069,
    0x2072,
    0x2073,
    0x208f,
    0x209f,
    0x20b2,
    0x20cf,
    0x20eb,
    0x20ff,
    0x213b,
    0x213c,
    0x214c,
    0x2152,
    0x2184,
    0x218f,
    0x23cf,
    0x23ff,
    0x2427,
    0x243f,
    0x244b,
    0x245f,
    0x24ff,
    0x24ff,
    0x2614,
    0x2615,
    0x2618,
    0x2618,
    0x267e,
    0x267f,
    0x268a,
    0x2700,
    0x2705,
    0x2705,
    0x270a,
    0x270b,
    0x2728,
    0x2728,
    0x274c,
    0x274c,
    0x274e,
    0x274e,
    0x2753,
    0x2755,
    0x2757,
    0x2757,
    0x275f,
    0x2760,
    0x2795,
    0x2797,
    0x27b0,
    0x27b0,
    0x27bf,
    0x27cf,
    0x27ec,
    0x27ef,
    0x2b00,
    0x2e7f,
    0x2e9a,
    0x2e9a,
    0x2ef4,
    0x2eff,
    0x2fd6,
    0x2fef,
    0x2ffc,
    0x2fff,
    0x3040,
    0x3040,
    0x3097,
    0x3098,
    0x3100,
    0x3104,
    0x312d,
    0x3130,
    0x318f,
    0x318f,
    0x31b8,
    0x31ef,
    0x321d,
    0x321f,
    0x3244,
    0x3250,
    0x327c,
    0x327e,
    0x32cc,
    0x32cf,
    0x32ff,
    0x32ff,
    0x3377,
    0x337a,
    0x33de,
    0x33df,
    0x33ff,
    0x33ff,
    0x4db6,
    0x4dff,
    0x9fa6,
    0x9fff,
    0xa48d,
    0xa48f,
    0xa4c7,
    0xabff,
    0xd7a4,
    0xd7ff,
    0xfa2e,
    0xfa2f,
    0xfa6b,
    0xfaff,
    0xfb07,
    0xfb12,
    0xfb18,
    0xfb1c,
    0xfb37,
    0xfb37,
    0xfb3d,
    0xfb3d,
    0xfb3f,
    0xfb3f,
    0xfb42,
    0xfb42,
    0xfb45,
    0xfb45,
    0xfbb2,
    0xfbd2,
    0xfd40,
    0xfd4f,
    0xfd90,
    0xfd91,
    0xfdc8,
    0xfdcf,
    0xfdfd,
    0xfdff,
    0xfe10,
    0xfe1f,
    0xfe24,
    0xfe2f,
    0xfe47,
    0xfe48,
    0xfe53,
    0xfe53,
    0xfe67,
    0xfe67,
    0xfe6c,
    0xfe6f,
    0xfe75,
    0xfe75,
    0xfefd,
    0xfefe,
    0xff00,
    0xff00,
    0xffbf,
    0xffc1,
    0xffc8,
    0xffc9,
    0xffd0,
    0xffd1,
    0xffd8,
    0xffd9,
    0xffdd,
    0xffdf,
    0xffe7,
    0xffe7,
    0xffef,
    0xfff8,
    0x10000,
    0x102ff,
    0x1031f,
    0x1031f,
    0x10324,
    0x1032f,
    0x1034b,
    0x103ff,
    0x10426,
    0x10427,
    0x1044e,
    0x1cfff,
    0x1d0f6,
    0x1d0ff,
    0x1d127,
    0x1d129,
    0x1d1de,
    0x1d3ff,
    0x1d455,
    0x1d455,
    0x1d49d,
    0x1d49d,
    0x1d4a0,
    0x1d4a1,
    0x1d4a3,
    0x1d4a4,
    0x1d4a7,
    0x1d4a8,
    0x1d4ad,
    0x1d4ad,
    0x1d4ba,
    0x1d4ba,
    0x1d4bc,
    0x1d4bc,
    0x1d4c1,
    0x1d4c1,
    0x1d4c4,
    0x1d4c4,
    0x1d506,
    0x1d506,
    0x1d50b,
    0x1d50c,
    0x1d515,
    0x1d515,
    0x1d51d,
    0x1d51d,
    0x1d53a,
    0x1d53a,
    0x1d53f,
    0x1d53f,
    0x1d545,
    0x1d545,
    0x1d547,
    0x1d549,
    0x1d551,
    0x1d551,
    0x1d6a4,
    0x1d6a7,
    0x1d7ca,
    0x1d7cd,
    0x1d800,
    0x1fffd,
    0x2a6d7,
    0x2f7ff,
    0x2fa1e,
    0x2fffd,
    0x30000,
    0x3fffd,
    0x40000,
    0x4fffd,
    0x50000,
    0x5fffd,
    0x60000,
    0x6fffd,
    0x70000,
    0x7fffd,
    0x80000,
    0x8fffd,
    0x90000,
    0x9fffd,
    0xa0000,
    0xafffd,
    0xb0000,
    0xbfffd,
    0xc0000,
    0xcfffd,
    0xd0000,
    0xdfffd,
    0xe0000,
    0xe0000,
    0xe0002,
    0xe001f,
    0xe0080,
    0xefffd
];
const $6c341d77d66c320e$var$isUnassignedCodePoint = (character)=>$6c341d77d66c320e$var$inRange(character, $6c341d77d66c320e$var$unassigned_code_points);
const $6c341d77d66c320e$var$commonly_mapped_to_nothing = [
    0x00ad,
    0x00ad,
    0x034f,
    0x034f,
    0x1806,
    0x1806,
    0x180b,
    0x180b,
    0x180c,
    0x180c,
    0x180d,
    0x180d,
    0x200b,
    0x200b,
    0x200c,
    0x200c,
    0x200d,
    0x200d,
    0x2060,
    0x2060,
    0xfe00,
    0xfe00,
    0xfe01,
    0xfe01,
    0xfe02,
    0xfe02,
    0xfe03,
    0xfe03,
    0xfe04,
    0xfe04,
    0xfe05,
    0xfe05,
    0xfe06,
    0xfe06,
    0xfe07,
    0xfe07,
    0xfe08,
    0xfe08,
    0xfe09,
    0xfe09,
    0xfe0a,
    0xfe0a,
    0xfe0b,
    0xfe0b,
    0xfe0c,
    0xfe0c,
    0xfe0d,
    0xfe0d,
    0xfe0e,
    0xfe0e,
    0xfe0f,
    0xfe0f,
    0xfeff,
    0xfeff
];
const $6c341d77d66c320e$var$isCommonlyMappedToNothing = (character)=>$6c341d77d66c320e$var$inRange(character, $6c341d77d66c320e$var$commonly_mapped_to_nothing);
const $6c341d77d66c320e$var$non_ASCII_space_characters = [
    0x00a0,
    0x00a0,
    0x1680,
    0x1680,
    0x2000,
    0x2000,
    0x2001,
    0x2001,
    0x2002,
    0x2002,
    0x2003,
    0x2003,
    0x2004,
    0x2004,
    0x2005,
    0x2005,
    0x2006,
    0x2006,
    0x2007,
    0x2007,
    0x2008,
    0x2008,
    0x2009,
    0x2009,
    0x200a,
    0x200a,
    0x200b,
    0x200b,
    0x202f,
    0x202f,
    0x205f,
    0x205f,
    0x3000,
    0x3000
];
const $6c341d77d66c320e$var$isNonASCIISpaceCharacter = (character)=>$6c341d77d66c320e$var$inRange(character, $6c341d77d66c320e$var$non_ASCII_space_characters);
const $6c341d77d66c320e$var$non_ASCII_controls_characters = [
    0x0080,
    0x009f,
    0x06dd,
    0x06dd,
    0x070f,
    0x070f,
    0x180e,
    0x180e,
    0x200c,
    0x200c,
    0x200d,
    0x200d,
    0x2028,
    0x2028,
    0x2029,
    0x2029,
    0x2060,
    0x2060,
    0x2061,
    0x2061,
    0x2062,
    0x2062,
    0x2063,
    0x2063,
    0x206a,
    0x206f,
    0xfeff,
    0xfeff,
    0xfff9,
    0xfffc,
    0x1d173,
    0x1d17a
];
const $6c341d77d66c320e$var$non_character_codepoints = [
    0xfdd0,
    0xfdef,
    0xfffe,
    0xffff,
    0x1fffe,
    0x1ffff,
    0x2fffe,
    0x2ffff,
    0x3fffe,
    0x3ffff,
    0x4fffe,
    0x4ffff,
    0x5fffe,
    0x5ffff,
    0x6fffe,
    0x6ffff,
    0x7fffe,
    0x7ffff,
    0x8fffe,
    0x8ffff,
    0x9fffe,
    0x9ffff,
    0xafffe,
    0xaffff,
    0xbfffe,
    0xbffff,
    0xcfffe,
    0xcffff,
    0xdfffe,
    0xdffff,
    0xefffe,
    0xeffff,
    0x10fffe,
    0x10ffff
];
const $6c341d77d66c320e$var$prohibited_characters = [
    0,
    0x001f,
    0x007f,
    0x007f,
    0x0340,
    0x0340,
    0x0341,
    0x0341,
    0x200e,
    0x200e,
    0x200f,
    0x200f,
    0x202a,
    0x202a,
    0x202b,
    0x202b,
    0x202c,
    0x202c,
    0x202d,
    0x202d,
    0x202e,
    0x202e,
    0x206a,
    0x206a,
    0x206b,
    0x206b,
    0x206c,
    0x206c,
    0x206d,
    0x206d,
    0x206e,
    0x206e,
    0x206f,
    0x206f,
    0x2ff0,
    0x2ffb,
    0xd800,
    0xdfff,
    0xe000,
    0xf8ff,
    0xfff9,
    0xfff9,
    0xfffa,
    0xfffa,
    0xfffb,
    0xfffb,
    0xfffc,
    0xfffc,
    0xfffd,
    0xfffd,
    0xe0001,
    0xe0001,
    0xe0020,
    0xe007f,
    0xf0000,
    0xffffd,
    0x100000,
    0x10fffd
];
const $6c341d77d66c320e$var$isProhibitedCharacter = (character)=>$6c341d77d66c320e$var$inRange(character, $6c341d77d66c320e$var$non_ASCII_space_characters) || $6c341d77d66c320e$var$inRange(character, $6c341d77d66c320e$var$prohibited_characters) || $6c341d77d66c320e$var$inRange(character, $6c341d77d66c320e$var$non_ASCII_controls_characters) || $6c341d77d66c320e$var$inRange(character, $6c341d77d66c320e$var$non_character_codepoints);
const $6c341d77d66c320e$var$bidirectional_r_al = [
    0x05be,
    0x05be,
    0x05c0,
    0x05c0,
    0x05c3,
    0x05c3,
    0x05d0,
    0x05ea,
    0x05f0,
    0x05f4,
    0x061b,
    0x061b,
    0x061f,
    0x061f,
    0x0621,
    0x063a,
    0x0640,
    0x064a,
    0x066d,
    0x066f,
    0x0671,
    0x06d5,
    0x06dd,
    0x06dd,
    0x06e5,
    0x06e6,
    0x06fa,
    0x06fe,
    0x0700,
    0x070d,
    0x0710,
    0x0710,
    0x0712,
    0x072c,
    0x0780,
    0x07a5,
    0x07b1,
    0x07b1,
    0x200f,
    0x200f,
    0xfb1d,
    0xfb1d,
    0xfb1f,
    0xfb28,
    0xfb2a,
    0xfb36,
    0xfb38,
    0xfb3c,
    0xfb3e,
    0xfb3e,
    0xfb40,
    0xfb41,
    0xfb43,
    0xfb44,
    0xfb46,
    0xfbb1,
    0xfbd3,
    0xfd3d,
    0xfd50,
    0xfd8f,
    0xfd92,
    0xfdc7,
    0xfdf0,
    0xfdfc,
    0xfe70,
    0xfe74,
    0xfe76,
    0xfefc
];
const $6c341d77d66c320e$var$isBidirectionalRAL = (character)=>$6c341d77d66c320e$var$inRange(character, $6c341d77d66c320e$var$bidirectional_r_al);
const $6c341d77d66c320e$var$bidirectional_l = [
    0x0041,
    0x005a,
    0x0061,
    0x007a,
    0x00aa,
    0x00aa,
    0x00b5,
    0x00b5,
    0x00ba,
    0x00ba,
    0x00c0,
    0x00d6,
    0x00d8,
    0x00f6,
    0x00f8,
    0x0220,
    0x0222,
    0x0233,
    0x0250,
    0x02ad,
    0x02b0,
    0x02b8,
    0x02bb,
    0x02c1,
    0x02d0,
    0x02d1,
    0x02e0,
    0x02e4,
    0x02ee,
    0x02ee,
    0x037a,
    0x037a,
    0x0386,
    0x0386,
    0x0388,
    0x038a,
    0x038c,
    0x038c,
    0x038e,
    0x03a1,
    0x03a3,
    0x03ce,
    0x03d0,
    0x03f5,
    0x0400,
    0x0482,
    0x048a,
    0x04ce,
    0x04d0,
    0x04f5,
    0x04f8,
    0x04f9,
    0x0500,
    0x050f,
    0x0531,
    0x0556,
    0x0559,
    0x055f,
    0x0561,
    0x0587,
    0x0589,
    0x0589,
    0x0903,
    0x0903,
    0x0905,
    0x0939,
    0x093d,
    0x0940,
    0x0949,
    0x094c,
    0x0950,
    0x0950,
    0x0958,
    0x0961,
    0x0964,
    0x0970,
    0x0982,
    0x0983,
    0x0985,
    0x098c,
    0x098f,
    0x0990,
    0x0993,
    0x09a8,
    0x09aa,
    0x09b0,
    0x09b2,
    0x09b2,
    0x09b6,
    0x09b9,
    0x09be,
    0x09c0,
    0x09c7,
    0x09c8,
    0x09cb,
    0x09cc,
    0x09d7,
    0x09d7,
    0x09dc,
    0x09dd,
    0x09df,
    0x09e1,
    0x09e6,
    0x09f1,
    0x09f4,
    0x09fa,
    0x0a05,
    0x0a0a,
    0x0a0f,
    0x0a10,
    0x0a13,
    0x0a28,
    0x0a2a,
    0x0a30,
    0x0a32,
    0x0a33,
    0x0a35,
    0x0a36,
    0x0a38,
    0x0a39,
    0x0a3e,
    0x0a40,
    0x0a59,
    0x0a5c,
    0x0a5e,
    0x0a5e,
    0x0a66,
    0x0a6f,
    0x0a72,
    0x0a74,
    0x0a83,
    0x0a83,
    0x0a85,
    0x0a8b,
    0x0a8d,
    0x0a8d,
    0x0a8f,
    0x0a91,
    0x0a93,
    0x0aa8,
    0x0aaa,
    0x0ab0,
    0x0ab2,
    0x0ab3,
    0x0ab5,
    0x0ab9,
    0x0abd,
    0x0ac0,
    0x0ac9,
    0x0ac9,
    0x0acb,
    0x0acc,
    0x0ad0,
    0x0ad0,
    0x0ae0,
    0x0ae0,
    0x0ae6,
    0x0aef,
    0x0b02,
    0x0b03,
    0x0b05,
    0x0b0c,
    0x0b0f,
    0x0b10,
    0x0b13,
    0x0b28,
    0x0b2a,
    0x0b30,
    0x0b32,
    0x0b33,
    0x0b36,
    0x0b39,
    0x0b3d,
    0x0b3e,
    0x0b40,
    0x0b40,
    0x0b47,
    0x0b48,
    0x0b4b,
    0x0b4c,
    0x0b57,
    0x0b57,
    0x0b5c,
    0x0b5d,
    0x0b5f,
    0x0b61,
    0x0b66,
    0x0b70,
    0x0b83,
    0x0b83,
    0x0b85,
    0x0b8a,
    0x0b8e,
    0x0b90,
    0x0b92,
    0x0b95,
    0x0b99,
    0x0b9a,
    0x0b9c,
    0x0b9c,
    0x0b9e,
    0x0b9f,
    0x0ba3,
    0x0ba4,
    0x0ba8,
    0x0baa,
    0x0bae,
    0x0bb5,
    0x0bb7,
    0x0bb9,
    0x0bbe,
    0x0bbf,
    0x0bc1,
    0x0bc2,
    0x0bc6,
    0x0bc8,
    0x0bca,
    0x0bcc,
    0x0bd7,
    0x0bd7,
    0x0be7,
    0x0bf2,
    0x0c01,
    0x0c03,
    0x0c05,
    0x0c0c,
    0x0c0e,
    0x0c10,
    0x0c12,
    0x0c28,
    0x0c2a,
    0x0c33,
    0x0c35,
    0x0c39,
    0x0c41,
    0x0c44,
    0x0c60,
    0x0c61,
    0x0c66,
    0x0c6f,
    0x0c82,
    0x0c83,
    0x0c85,
    0x0c8c,
    0x0c8e,
    0x0c90,
    0x0c92,
    0x0ca8,
    0x0caa,
    0x0cb3,
    0x0cb5,
    0x0cb9,
    0x0cbe,
    0x0cbe,
    0x0cc0,
    0x0cc4,
    0x0cc7,
    0x0cc8,
    0x0cca,
    0x0ccb,
    0x0cd5,
    0x0cd6,
    0x0cde,
    0x0cde,
    0x0ce0,
    0x0ce1,
    0x0ce6,
    0x0cef,
    0x0d02,
    0x0d03,
    0x0d05,
    0x0d0c,
    0x0d0e,
    0x0d10,
    0x0d12,
    0x0d28,
    0x0d2a,
    0x0d39,
    0x0d3e,
    0x0d40,
    0x0d46,
    0x0d48,
    0x0d4a,
    0x0d4c,
    0x0d57,
    0x0d57,
    0x0d60,
    0x0d61,
    0x0d66,
    0x0d6f,
    0x0d82,
    0x0d83,
    0x0d85,
    0x0d96,
    0x0d9a,
    0x0db1,
    0x0db3,
    0x0dbb,
    0x0dbd,
    0x0dbd,
    0x0dc0,
    0x0dc6,
    0x0dcf,
    0x0dd1,
    0x0dd8,
    0x0ddf,
    0x0df2,
    0x0df4,
    0x0e01,
    0x0e30,
    0x0e32,
    0x0e33,
    0x0e40,
    0x0e46,
    0x0e4f,
    0x0e5b,
    0x0e81,
    0x0e82,
    0x0e84,
    0x0e84,
    0x0e87,
    0x0e88,
    0x0e8a,
    0x0e8a,
    0x0e8d,
    0x0e8d,
    0x0e94,
    0x0e97,
    0x0e99,
    0x0e9f,
    0x0ea1,
    0x0ea3,
    0x0ea5,
    0x0ea5,
    0x0ea7,
    0x0ea7,
    0x0eaa,
    0x0eab,
    0x0ead,
    0x0eb0,
    0x0eb2,
    0x0eb3,
    0x0ebd,
    0x0ebd,
    0x0ec0,
    0x0ec4,
    0x0ec6,
    0x0ec6,
    0x0ed0,
    0x0ed9,
    0x0edc,
    0x0edd,
    0x0f00,
    0x0f17,
    0x0f1a,
    0x0f34,
    0x0f36,
    0x0f36,
    0x0f38,
    0x0f38,
    0x0f3e,
    0x0f47,
    0x0f49,
    0x0f6a,
    0x0f7f,
    0x0f7f,
    0x0f85,
    0x0f85,
    0x0f88,
    0x0f8b,
    0x0fbe,
    0x0fc5,
    0x0fc7,
    0x0fcc,
    0x0fcf,
    0x0fcf,
    0x1000,
    0x1021,
    0x1023,
    0x1027,
    0x1029,
    0x102a,
    0x102c,
    0x102c,
    0x1031,
    0x1031,
    0x1038,
    0x1038,
    0x1040,
    0x1057,
    0x10a0,
    0x10c5,
    0x10d0,
    0x10f8,
    0x10fb,
    0x10fb,
    0x1100,
    0x1159,
    0x115f,
    0x11a2,
    0x11a8,
    0x11f9,
    0x1200,
    0x1206,
    0x1208,
    0x1246,
    0x1248,
    0x1248,
    0x124a,
    0x124d,
    0x1250,
    0x1256,
    0x1258,
    0x1258,
    0x125a,
    0x125d,
    0x1260,
    0x1286,
    0x1288,
    0x1288,
    0x128a,
    0x128d,
    0x1290,
    0x12ae,
    0x12b0,
    0x12b0,
    0x12b2,
    0x12b5,
    0x12b8,
    0x12be,
    0x12c0,
    0x12c0,
    0x12c2,
    0x12c5,
    0x12c8,
    0x12ce,
    0x12d0,
    0x12d6,
    0x12d8,
    0x12ee,
    0x12f0,
    0x130e,
    0x1310,
    0x1310,
    0x1312,
    0x1315,
    0x1318,
    0x131e,
    0x1320,
    0x1346,
    0x1348,
    0x135a,
    0x1361,
    0x137c,
    0x13a0,
    0x13f4,
    0x1401,
    0x1676,
    0x1681,
    0x169a,
    0x16a0,
    0x16f0,
    0x1700,
    0x170c,
    0x170e,
    0x1711,
    0x1720,
    0x1731,
    0x1735,
    0x1736,
    0x1740,
    0x1751,
    0x1760,
    0x176c,
    0x176e,
    0x1770,
    0x1780,
    0x17b6,
    0x17be,
    0x17c5,
    0x17c7,
    0x17c8,
    0x17d4,
    0x17da,
    0x17dc,
    0x17dc,
    0x17e0,
    0x17e9,
    0x1810,
    0x1819,
    0x1820,
    0x1877,
    0x1880,
    0x18a8,
    0x1e00,
    0x1e9b,
    0x1ea0,
    0x1ef9,
    0x1f00,
    0x1f15,
    0x1f18,
    0x1f1d,
    0x1f20,
    0x1f45,
    0x1f48,
    0x1f4d,
    0x1f50,
    0x1f57,
    0x1f59,
    0x1f59,
    0x1f5b,
    0x1f5b,
    0x1f5d,
    0x1f5d,
    0x1f5f,
    0x1f7d,
    0x1f80,
    0x1fb4,
    0x1fb6,
    0x1fbc,
    0x1fbe,
    0x1fbe,
    0x1fc2,
    0x1fc4,
    0x1fc6,
    0x1fcc,
    0x1fd0,
    0x1fd3,
    0x1fd6,
    0x1fdb,
    0x1fe0,
    0x1fec,
    0x1ff2,
    0x1ff4,
    0x1ff6,
    0x1ffc,
    0x200e,
    0x200e,
    0x2071,
    0x2071,
    0x207f,
    0x207f,
    0x2102,
    0x2102,
    0x2107,
    0x2107,
    0x210a,
    0x2113,
    0x2115,
    0x2115,
    0x2119,
    0x211d,
    0x2124,
    0x2124,
    0x2126,
    0x2126,
    0x2128,
    0x2128,
    0x212a,
    0x212d,
    0x212f,
    0x2131,
    0x2133,
    0x2139,
    0x213d,
    0x213f,
    0x2145,
    0x2149,
    0x2160,
    0x2183,
    0x2336,
    0x237a,
    0x2395,
    0x2395,
    0x249c,
    0x24e9,
    0x3005,
    0x3007,
    0x3021,
    0x3029,
    0x3031,
    0x3035,
    0x3038,
    0x303c,
    0x3041,
    0x3096,
    0x309d,
    0x309f,
    0x30a1,
    0x30fa,
    0x30fc,
    0x30ff,
    0x3105,
    0x312c,
    0x3131,
    0x318e,
    0x3190,
    0x31b7,
    0x31f0,
    0x321c,
    0x3220,
    0x3243,
    0x3260,
    0x327b,
    0x327f,
    0x32b0,
    0x32c0,
    0x32cb,
    0x32d0,
    0x32fe,
    0x3300,
    0x3376,
    0x337b,
    0x33dd,
    0x33e0,
    0x33fe,
    0x3400,
    0x4db5,
    0x4e00,
    0x9fa5,
    0xa000,
    0xa48c,
    0xac00,
    0xd7a3,
    0xd800,
    0xfa2d,
    0xfa30,
    0xfa6a,
    0xfb00,
    0xfb06,
    0xfb13,
    0xfb17,
    0xff21,
    0xff3a,
    0xff41,
    0xff5a,
    0xff66,
    0xffbe,
    0xffc2,
    0xffc7,
    0xffca,
    0xffcf,
    0xffd2,
    0xffd7,
    0xffda,
    0xffdc,
    0x10300,
    0x1031e,
    0x10320,
    0x10323,
    0x10330,
    0x1034a,
    0x10400,
    0x10425,
    0x10428,
    0x1044d,
    0x1d000,
    0x1d0f5,
    0x1d100,
    0x1d126,
    0x1d12a,
    0x1d166,
    0x1d16a,
    0x1d172,
    0x1d183,
    0x1d184,
    0x1d18c,
    0x1d1a9,
    0x1d1ae,
    0x1d1dd,
    0x1d400,
    0x1d454,
    0x1d456,
    0x1d49c,
    0x1d49e,
    0x1d49f,
    0x1d4a2,
    0x1d4a2,
    0x1d4a5,
    0x1d4a6,
    0x1d4a9,
    0x1d4ac,
    0x1d4ae,
    0x1d4b9,
    0x1d4bb,
    0x1d4bb,
    0x1d4bd,
    0x1d4c0,
    0x1d4c2,
    0x1d4c3,
    0x1d4c5,
    0x1d505,
    0x1d507,
    0x1d50a,
    0x1d50d,
    0x1d514,
    0x1d516,
    0x1d51c,
    0x1d51e,
    0x1d539,
    0x1d53b,
    0x1d53e,
    0x1d540,
    0x1d544,
    0x1d546,
    0x1d546,
    0x1d54a,
    0x1d550,
    0x1d552,
    0x1d6a3,
    0x1d6a8,
    0x1d7c9,
    0x20000,
    0x2a6d6,
    0x2f800,
    0x2fa1d,
    0xf0000,
    0xffffd,
    0x100000,
    0x10fffd
];
const $6c341d77d66c320e$var$isBidirectionalL = (character)=>$6c341d77d66c320e$var$inRange(character, $6c341d77d66c320e$var$bidirectional_l);
const $6c341d77d66c320e$var$mapping2space = $6c341d77d66c320e$var$isNonASCIISpaceCharacter;
const $6c341d77d66c320e$var$mapping2nothing = $6c341d77d66c320e$var$isCommonlyMappedToNothing;
const $6c341d77d66c320e$var$getCodePoint = (character)=>character.codePointAt(0);
const $6c341d77d66c320e$var$first = (x)=>x[0];
const $6c341d77d66c320e$var$last = (x)=>x[x.length - 1];
function $6c341d77d66c320e$var$toCodePoints(input) {
    const codepoints = [];
    const size = input.length;
    for(let i = 0; i < size; i += 1){
        const before = input.charCodeAt(i);
        if (before >= 0xd800 && before <= 0xdbff && size > i + 1) {
            const next = input.charCodeAt(i + 1);
            if (next >= 0xdc00 && next <= 0xdfff) {
                codepoints.push((before - 0xd800) * 0x400 + next - 0xdc00 + 0x10000);
                i += 1;
                continue;
            }
        }
        codepoints.push(before);
    }
    return codepoints;
}
function $6c341d77d66c320e$var$saslprep(input, opts = {}) {
    if (typeof input !== 'string') throw new TypeError('Expected string.');
    if (input.length === 0) return '';
    const mapped_input = $6c341d77d66c320e$var$toCodePoints(input).map((character)=>$6c341d77d66c320e$var$mapping2space(character) ? 0x20 : character).filter((character)=>!$6c341d77d66c320e$var$mapping2nothing(character));
    const normalized_input = String.fromCodePoint.apply(null, mapped_input).normalize('NFKC');
    const normalized_map = $6c341d77d66c320e$var$toCodePoints(normalized_input);
    const hasProhibited = normalized_map.some($6c341d77d66c320e$var$isProhibitedCharacter);
    if (hasProhibited) throw new Error('Prohibited character, see https://tools.ietf.org/html/rfc4013#section-2.3');
    if (opts.allowUnassigned !== true) {
        const hasUnassigned = normalized_map.some($6c341d77d66c320e$var$isUnassignedCodePoint);
        if (hasUnassigned) throw new Error('Unassigned code point, see https://tools.ietf.org/html/rfc4013#section-2.5');
    }
    const hasBidiRAL = normalized_map.some($6c341d77d66c320e$var$isBidirectionalRAL);
    const hasBidiL = normalized_map.some($6c341d77d66c320e$var$isBidirectionalL);
    if (hasBidiRAL && hasBidiL) throw new Error("String must not contain RandALCat and LCat at the same time, see https://tools.ietf.org/html/rfc3454#section-6");
    const isFirstBidiRAL = $6c341d77d66c320e$var$isBidirectionalRAL($6c341d77d66c320e$var$getCodePoint($6c341d77d66c320e$var$first(normalized_input)));
    const isLastBidiRAL = $6c341d77d66c320e$var$isBidirectionalRAL($6c341d77d66c320e$var$getCodePoint($6c341d77d66c320e$var$last(normalized_input)));
    if (hasBidiRAL && !(isFirstBidiRAL && isLastBidiRAL)) throw new Error("Bidirectional RandALCat character must be the first and the last character of the string, see https://tools.ietf.org/html/rfc3454#section-6");
    return normalized_input;
}
class $6c341d77d66c320e$var$PDFSecurity {
    static generateFileID(info = {}) {
        let infoStr = `${info.CreationDate.getTime()}\n`;
        for(let key in info){
            if (!info.hasOwnProperty(key)) continue;
            infoStr += `${key}: ${info[key].valueOf()}\n`;
        }
        return $6c341d77d66c320e$var$md5Hash(infoStr);
    }
    static generateRandomWordArray(bytes) {
        return $6c341d77d66c320e$var$randomBytes(bytes);
    }
    static create(document, options = {}) {
        if (!options.ownerPassword && !options.userPassword) return null;
        return new $6c341d77d66c320e$var$PDFSecurity(document, options);
    }
    constructor(document, options = {}){
        if (!options.ownerPassword && !options.userPassword) throw new Error('None of owner password and user password is defined.');
        this.document = document;
        this._setupEncryption(options);
    }
    _setupEncryption(options) {
        switch(options.pdfVersion){
            case '1.4':
            case '1.5':
                this.version = 2;
                break;
            case '1.6':
            case '1.7':
                this.version = 4;
                break;
            case '1.7ext3':
                this.version = 5;
                break;
            default:
                this.version = 1;
                break;
        }
        const encDict = {
            Filter: 'Standard'
        };
        switch(this.version){
            case 1:
            case 2:
            case 4:
                this._setupEncryptionV1V2V4(this.version, encDict, options);
                break;
            case 5:
                this._setupEncryptionV5(encDict, options);
                break;
        }
        this.dictionary = this.document.ref(encDict);
    }
    _setupEncryptionV1V2V4(v, encDict, options) {
        let r, permissions;
        switch(v){
            case 1:
                r = 2;
                this.keyBits = 40;
                permissions = $6c341d77d66c320e$var$getPermissionsR2(options.permissions);
                break;
            case 2:
                r = 3;
                this.keyBits = 128;
                permissions = $6c341d77d66c320e$var$getPermissionsR3(options.permissions);
                break;
            case 4:
                r = 4;
                this.keyBits = 128;
                permissions = $6c341d77d66c320e$var$getPermissionsR3(options.permissions);
                break;
        }
        const paddedUserPassword = $6c341d77d66c320e$var$processPasswordR2R3R4(options.userPassword);
        const paddedOwnerPassword = options.ownerPassword ? $6c341d77d66c320e$var$processPasswordR2R3R4(options.ownerPassword) : paddedUserPassword;
        const ownerPasswordEntry = $6c341d77d66c320e$var$getOwnerPasswordR2R3R4(r, this.keyBits, paddedUserPassword, paddedOwnerPassword);
        this.encryptionKey = $6c341d77d66c320e$var$getEncryptionKeyR2R3R4(r, this.keyBits, this.document._id, paddedUserPassword, ownerPasswordEntry, permissions);
        let userPasswordEntry;
        if (r === 2) userPasswordEntry = $6c341d77d66c320e$var$getUserPasswordR2(this.encryptionKey);
        else userPasswordEntry = $6c341d77d66c320e$var$getUserPasswordR3R4(this.document._id, this.encryptionKey);
        encDict.V = v;
        if (v >= 2) encDict.Length = this.keyBits;
        if (v === 4) {
            encDict.CF = {
                StdCF: {
                    AuthEvent: 'DocOpen',
                    CFM: 'AESV2',
                    Length: this.keyBits / 8
                }
            };
            encDict.StmF = 'StdCF';
            encDict.StrF = 'StdCF';
        }
        encDict.R = r;
        encDict.O = ownerPasswordEntry;
        encDict.U = userPasswordEntry;
        encDict.P = permissions;
    }
    _setupEncryptionV5(encDict, options) {
        this.keyBits = 256;
        const permissions = $6c341d77d66c320e$var$getPermissionsR3(options.permissions);
        const processedUserPassword = $6c341d77d66c320e$var$processPasswordR5(options.userPassword);
        const processedOwnerPassword = options.ownerPassword ? $6c341d77d66c320e$var$processPasswordR5(options.ownerPassword) : processedUserPassword;
        this.encryptionKey = $6c341d77d66c320e$var$getEncryptionKeyR5($6c341d77d66c320e$var$PDFSecurity.generateRandomWordArray);
        const userPasswordEntry = $6c341d77d66c320e$var$getUserPasswordR5(processedUserPassword, $6c341d77d66c320e$var$PDFSecurity.generateRandomWordArray);
        const userKeySalt = userPasswordEntry.slice(40, 48);
        const userEncryptionKeyEntry = $6c341d77d66c320e$var$getUserEncryptionKeyR5(processedUserPassword, userKeySalt, this.encryptionKey);
        const ownerPasswordEntry = $6c341d77d66c320e$var$getOwnerPasswordR5(processedOwnerPassword, userPasswordEntry, $6c341d77d66c320e$var$PDFSecurity.generateRandomWordArray);
        const ownerKeySalt = ownerPasswordEntry.slice(40, 48);
        const ownerEncryptionKeyEntry = $6c341d77d66c320e$var$getOwnerEncryptionKeyR5(processedOwnerPassword, ownerKeySalt, userPasswordEntry, this.encryptionKey);
        const permsEntry = $6c341d77d66c320e$var$getEncryptedPermissionsR5(permissions, this.encryptionKey, $6c341d77d66c320e$var$PDFSecurity.generateRandomWordArray);
        encDict.V = 5;
        encDict.Length = this.keyBits;
        encDict.CF = {
            StdCF: {
                AuthEvent: 'DocOpen',
                CFM: 'AESV3',
                Length: this.keyBits / 8
            }
        };
        encDict.StmF = 'StdCF';
        encDict.StrF = 'StdCF';
        encDict.R = 5;
        encDict.O = ownerPasswordEntry;
        encDict.OE = ownerEncryptionKeyEntry;
        encDict.U = userPasswordEntry;
        encDict.UE = userEncryptionKeyEntry;
        encDict.P = permissions;
        encDict.Perms = permsEntry;
    }
    getEncryptFn(obj, gen) {
        let digest;
        if (this.version < 5) {
            const suffix = new Uint8Array([
                obj & 0xff,
                obj >> 8 & 0xff,
                obj >> 16 & 0xff,
                gen & 0xff,
                gen >> 8 & 0xff
            ]);
            digest = (0, $f354203f433ec289$export$287dd7971339c972)(this.encryptionKey, suffix);
        }
        if (this.version === 1 || this.version === 2) {
            let key = $6c341d77d66c320e$var$md5Hash(digest);
            const keyLen = Math.min(16, this.keyBits / 8 + 5);
            key = key.slice(0, keyLen);
            return (buffer)=>$6c341d77d66c320e$var$rc4(buffer, key);
        }
        let key;
        if (this.version === 4) {
            const saltMarker = new Uint8Array([
                0x73,
                0x41,
                0x6c,
                0x54
            ]);
            key = $6c341d77d66c320e$var$md5Hash((0, $f354203f433ec289$export$287dd7971339c972)(digest, saltMarker));
        } else key = this.encryptionKey;
        const iv = $6c341d77d66c320e$var$PDFSecurity.generateRandomWordArray(16);
        return (buffer)=>{
            const encrypted = $6c341d77d66c320e$var$aesCbcEncrypt(buffer, key, iv, true);
            return (0, $f354203f433ec289$export$287dd7971339c972)(iv, encrypted);
        };
    }
    end() {
        this.dictionary.end();
    }
}
function $6c341d77d66c320e$var$getPermissionsR2(permissionObject = {}) {
    let permissions = -64;
    if (permissionObject.printing) permissions |= 4;
    if (permissionObject.modifying) permissions |= 8;
    if (permissionObject.copying) permissions |= 16;
    if (permissionObject.annotating) permissions |= 32;
    return permissions;
}
function $6c341d77d66c320e$var$getPermissionsR3(permissionObject = {}) {
    let permissions = -3904;
    if (permissionObject.printing === 'lowResolution') permissions |= 4;
    if (permissionObject.printing === 'highResolution') permissions |= 2052;
    if (permissionObject.modifying) permissions |= 8;
    if (permissionObject.copying) permissions |= 16;
    if (permissionObject.annotating) permissions |= 32;
    if (permissionObject.fillingForms) permissions |= 256;
    if (permissionObject.contentAccessibility) permissions |= 512;
    if (permissionObject.documentAssembly) permissions |= 1024;
    return permissions;
}
function $6c341d77d66c320e$var$getUserPasswordR2(encryptionKey) {
    return $6c341d77d66c320e$var$rc4($6c341d77d66c320e$var$processPasswordR2R3R4(), encryptionKey);
}
function $6c341d77d66c320e$var$getUserPasswordR3R4(documentId, encryptionKey) {
    const key = encryptionKey.slice();
    let cipher = $6c341d77d66c320e$var$md5Hash((0, $f354203f433ec289$export$287dd7971339c972)($6c341d77d66c320e$var$processPasswordR2R3R4(), new Uint8Array(documentId)));
    for(let i = 0; i < 20; i++){
        const xorKey = new Uint8Array(key.length);
        for(let j = 0; j < key.length; j++)xorKey[j] = encryptionKey[j] ^ i;
        cipher = $6c341d77d66c320e$var$rc4(cipher, xorKey);
    }
    const result = new Uint8Array(32);
    result.set(cipher);
    return result;
}
function $6c341d77d66c320e$var$getOwnerPasswordR2R3R4(r, keyBits, paddedUserPassword, paddedOwnerPassword) {
    let digest = paddedOwnerPassword;
    let round = r >= 3 ? 51 : 1;
    for(let i = 0; i < round; i++)digest = $6c341d77d66c320e$var$md5Hash(digest);
    const keyLen = keyBits / 8;
    let key = digest.slice(0, keyLen);
    let cipher = paddedUserPassword;
    round = r >= 3 ? 20 : 1;
    for(let i = 0; i < round; i++){
        const xorKey = new Uint8Array(keyLen);
        for(let j = 0; j < keyLen; j++)xorKey[j] = key[j] ^ i;
        cipher = $6c341d77d66c320e$var$rc4(cipher, xorKey);
    }
    return cipher;
}
function $6c341d77d66c320e$var$getEncryptionKeyR2R3R4(r, keyBits, documentId, paddedUserPassword, ownerPasswordEntry, permissions) {
    const permBytes = new Uint8Array([
        permissions & 0xff,
        permissions >> 8 & 0xff,
        permissions >> 16 & 0xff,
        permissions >> 24 & 0xff
    ]);
    let key = (0, $f354203f433ec289$export$287dd7971339c972)(paddedUserPassword, ownerPasswordEntry, permBytes, new Uint8Array(documentId));
    const round = r >= 3 ? 51 : 1;
    const keyLen = keyBits / 8;
    for(let i = 0; i < round; i++){
        key = $6c341d77d66c320e$var$md5Hash(key);
        key = key.slice(0, keyLen);
    }
    return key;
}
function $6c341d77d66c320e$var$getUserPasswordR5(processedUserPassword, generateRandomWordArray) {
    const validationSalt = generateRandomWordArray(8);
    const keySalt = generateRandomWordArray(8);
    const hash = $6c341d77d66c320e$var$sha256Hash((0, $f354203f433ec289$export$287dd7971339c972)(processedUserPassword, validationSalt));
    return (0, $f354203f433ec289$export$287dd7971339c972)(hash, validationSalt, keySalt);
}
function $6c341d77d66c320e$var$getUserEncryptionKeyR5(processedUserPassword, userKeySalt, encryptionKey) {
    const key = $6c341d77d66c320e$var$sha256Hash((0, $f354203f433ec289$export$287dd7971339c972)(processedUserPassword, userKeySalt));
    const iv = new Uint8Array(16);
    return $6c341d77d66c320e$var$aesCbcEncrypt(encryptionKey, key, iv, false);
}
function $6c341d77d66c320e$var$getOwnerPasswordR5(processedOwnerPassword, userPasswordEntry, generateRandomWordArray) {
    const validationSalt = generateRandomWordArray(8);
    const keySalt = generateRandomWordArray(8);
    const hash = $6c341d77d66c320e$var$sha256Hash((0, $f354203f433ec289$export$287dd7971339c972)(processedOwnerPassword, validationSalt, userPasswordEntry));
    return (0, $f354203f433ec289$export$287dd7971339c972)(hash, validationSalt, keySalt);
}
function $6c341d77d66c320e$var$getOwnerEncryptionKeyR5(processedOwnerPassword, ownerKeySalt, userPasswordEntry, encryptionKey) {
    const key = $6c341d77d66c320e$var$sha256Hash((0, $f354203f433ec289$export$287dd7971339c972)(processedOwnerPassword, ownerKeySalt, userPasswordEntry));
    const iv = new Uint8Array(16);
    return $6c341d77d66c320e$var$aesCbcEncrypt(encryptionKey, key, iv, false);
}
function $6c341d77d66c320e$var$getEncryptionKeyR5(generateRandomWordArray) {
    return generateRandomWordArray(32);
}
function $6c341d77d66c320e$var$getEncryptedPermissionsR5(permissions, encryptionKey, generateRandomWordArray) {
    const data = new Uint8Array(16);
    data[0] = permissions & 0xff;
    data[1] = permissions >> 8 & 0xff;
    data[2] = permissions >> 16 & 0xff;
    data[3] = permissions >> 24 & 0xff;
    data[4] = 0xff;
    data[5] = 0xff;
    data[6] = 0xff;
    data[7] = 0xff;
    data[8] = 0x54;
    data[9] = 0x61;
    data[10] = 0x64;
    data[11] = 0x62;
    const randomPart = generateRandomWordArray(4);
    data.set(randomPart, 12);
    return $6c341d77d66c320e$var$aesEcbEncrypt(data, encryptionKey);
}
function $6c341d77d66c320e$var$processPasswordR2R3R4(password = '') {
    const out = new Uint8Array(32);
    const length = password.length;
    let index = 0;
    while(index < length && index < 32){
        const code = password.charCodeAt(index);
        if (code > 0xff) throw new Error('Password contains one or more invalid characters.');
        out[index] = code;
        index++;
    }
    while(index < 32){
        out[index] = $6c341d77d66c320e$var$PASSWORD_PADDING[index - length];
        index++;
    }
    return out;
}
function $6c341d77d66c320e$var$processPasswordR5(password = '') {
    password = unescape(encodeURIComponent($6c341d77d66c320e$var$saslprep(password)));
    const length = Math.min(127, password.length);
    const out = new Uint8Array(length);
    for(let i = 0; i < length; i++)out[i] = password.charCodeAt(i);
    return out;
}
const $6c341d77d66c320e$var$PASSWORD_PADDING = [
    0x28,
    0xbf,
    0x4e,
    0x5e,
    0x4e,
    0x75,
    0x8a,
    0x41,
    0x64,
    0x00,
    0x4e,
    0x56,
    0xff,
    0xfa,
    0x01,
    0x08,
    0x2e,
    0x2e,
    0x00,
    0xb6,
    0xd0,
    0x68,
    0x3e,
    0x80,
    0x2f,
    0x0c,
    0xa9,
    0xfe,
    0x64,
    0x53,
    0x69,
    0x7a
];
const { number: $6c341d77d66c320e$var$number$2 } = $6c341d77d66c320e$var$PDFObject;
let $6c341d77d66c320e$var$PDFGradient$1 = class PDFGradient {
    constructor(doc){
        this.doc = doc;
        this.stops = [];
        this.embedded = false;
        this.transform = [
            1,
            0,
            0,
            1,
            0,
            0
        ];
    }
    stop(pos, color, opacity) {
        if (opacity == null) opacity = 1;
        color = this.doc._normalizeColor(color);
        if (this.stops.length === 0) {
            if (color.length === 3) this._colorSpace = 'DeviceRGB';
            else if (color.length === 4) this._colorSpace = 'DeviceCMYK';
            else if (color.length === 1) this._colorSpace = 'DeviceGray';
            else throw new Error('Unknown color space');
        } else if (this._colorSpace === 'DeviceRGB' && color.length !== 3 || this._colorSpace === 'DeviceCMYK' && color.length !== 4 || this._colorSpace === 'DeviceGray' && color.length !== 1) throw new Error('All gradient stops must use the same color space');
        opacity = Math.max(0, Math.min(1, opacity));
        this.stops.push([
            pos,
            color,
            opacity
        ]);
        return this;
    }
    setTransform(m11, m12, m21, m22, dx, dy) {
        this.transform = [
            m11,
            m12,
            m21,
            m22,
            dx,
            dy
        ];
        return this;
    }
    embed(m) {
        let fn;
        const stopsLength = this.stops.length;
        if (stopsLength === 0) return;
        this.embedded = true;
        this.matrix = m;
        const last = this.stops[stopsLength - 1];
        if (last[0] < 1) this.stops.push([
            1,
            last[1],
            last[2]
        ]);
        const bounds = [];
        const encode = [];
        const stops = [];
        for(let i = 0; i < stopsLength - 1; i++){
            encode.push(0, 1);
            if (i + 2 !== stopsLength) bounds.push(this.stops[i + 1][0]);
            fn = this.doc.ref({
                FunctionType: 2,
                Domain: [
                    0,
                    1
                ],
                C0: this.stops[i + 0][1],
                C1: this.stops[i + 1][1],
                N: 1
            });
            stops.push(fn);
            fn.end();
        }
        if (stopsLength === 1) fn = stops[0];
        else {
            fn = this.doc.ref({
                FunctionType: 3,
                Domain: [
                    0,
                    1
                ],
                Functions: stops,
                Bounds: bounds,
                Encode: encode
            });
            fn.end();
        }
        this.id = `Sh${++this.doc._gradCount}`;
        const shader = this.shader(fn);
        shader.end();
        const pattern = this.doc.ref({
            Type: 'Pattern',
            PatternType: 2,
            Shading: shader,
            Matrix: this.matrix.map($6c341d77d66c320e$var$number$2)
        });
        pattern.end();
        if (this.stops.some((stop)=>stop[2] < 1)) {
            let grad = this.opacityGradient();
            grad._colorSpace = 'DeviceGray';
            for (let stop of this.stops)grad.stop(stop[0], [
                stop[2]
            ]);
            grad = grad.embed(this.matrix);
            const pageBBox = [
                0,
                0,
                this.doc.page.width,
                this.doc.page.height
            ];
            const form = this.doc.ref({
                Type: 'XObject',
                Subtype: 'Form',
                FormType: 1,
                BBox: pageBBox,
                Group: {
                    Type: 'Group',
                    S: 'Transparency',
                    CS: 'DeviceGray'
                },
                Resources: {
                    ProcSet: [
                        'PDF',
                        'Text',
                        'ImageB',
                        'ImageC',
                        'ImageI'
                    ],
                    Pattern: {
                        Sh1: grad
                    }
                }
            });
            form.write('/Pattern cs /Sh1 scn');
            form.end(`${pageBBox.join(' ')} re f`);
            const gstate = this.doc.ref({
                Type: 'ExtGState',
                SMask: {
                    Type: 'Mask',
                    S: 'Luminosity',
                    G: form
                }
            });
            gstate.end();
            const opacityPattern = this.doc.ref({
                Type: 'Pattern',
                PatternType: 1,
                PaintType: 1,
                TilingType: 2,
                BBox: pageBBox,
                XStep: pageBBox[2],
                YStep: pageBBox[3],
                Resources: {
                    ProcSet: [
                        'PDF',
                        'Text',
                        'ImageB',
                        'ImageC',
                        'ImageI'
                    ],
                    Pattern: {
                        Sh1: pattern
                    },
                    ExtGState: {
                        Gs1: gstate
                    }
                }
            });
            opacityPattern.write('/Gs1 gs /Pattern cs /Sh1 scn');
            opacityPattern.end(`${pageBBox.join(' ')} re f`);
            this.doc.page.patterns[this.id] = opacityPattern;
        } else this.doc.page.patterns[this.id] = pattern;
        return pattern;
    }
    apply(stroke) {
        const [m0, m1, m2, m3, m4, m5] = this.doc._ctm;
        const [m11, m12, m21, m22, dx, dy] = this.transform;
        const m = [
            m0 * m11 + m2 * m12,
            m1 * m11 + m3 * m12,
            m0 * m21 + m2 * m22,
            m1 * m21 + m3 * m22,
            m0 * dx + m2 * dy + m4,
            m1 * dx + m3 * dy + m5
        ];
        if (!this.embedded || m.join(' ') !== this.matrix.join(' ')) this.embed(m);
        this.doc._setColorSpace('Pattern', stroke);
        const op = stroke ? 'SCN' : 'scn';
        return this.doc.addContent(`/${this.id} ${op}`);
    }
};
let $6c341d77d66c320e$var$PDFLinearGradient$1 = class PDFLinearGradient extends $6c341d77d66c320e$var$PDFGradient$1 {
    constructor(doc, x1, y1, x2, y2){
        super(doc);
        this.x1 = x1;
        this.y1 = y1;
        this.x2 = x2;
        this.y2 = y2;
    }
    shader(fn) {
        return this.doc.ref({
            ShadingType: 2,
            ColorSpace: this._colorSpace,
            Coords: [
                this.x1,
                this.y1,
                this.x2,
                this.y2
            ],
            Function: fn,
            Extend: [
                true,
                true
            ]
        });
    }
    opacityGradient() {
        return new PDFLinearGradient(this.doc, this.x1, this.y1, this.x2, this.y2);
    }
};
let $6c341d77d66c320e$var$PDFRadialGradient$1 = class PDFRadialGradient extends $6c341d77d66c320e$var$PDFGradient$1 {
    constructor(doc, x1, y1, r1, x2, y2, r2){
        super(doc);
        this.doc = doc;
        this.x1 = x1;
        this.y1 = y1;
        this.r1 = r1;
        this.x2 = x2;
        this.y2 = y2;
        this.r2 = r2;
    }
    shader(fn) {
        return this.doc.ref({
            ShadingType: 3,
            ColorSpace: this._colorSpace,
            Coords: [
                this.x1,
                this.y1,
                this.r1,
                this.x2,
                this.y2,
                this.r2
            ],
            Function: fn,
            Extend: [
                true,
                true
            ]
        });
    }
    opacityGradient() {
        return new PDFRadialGradient(this.doc, this.x1, this.y1, this.r1, this.x2, this.y2, this.r2);
    }
};
var $6c341d77d66c320e$var$Gradient = {
    PDFGradient: $6c341d77d66c320e$var$PDFGradient$1,
    PDFLinearGradient: $6c341d77d66c320e$var$PDFLinearGradient$1,
    PDFRadialGradient: $6c341d77d66c320e$var$PDFRadialGradient$1
};
const $6c341d77d66c320e$var$underlyingColorSpaces = [
    'DeviceCMYK',
    'DeviceRGB'
];
let $6c341d77d66c320e$var$PDFTilingPattern$1 = class PDFTilingPattern {
    constructor(doc, bBox, xStep, yStep, stream){
        this.doc = doc;
        this.bBox = bBox;
        this.xStep = xStep;
        this.yStep = yStep;
        this.stream = stream;
    }
    createPattern() {
        const resources = this.doc.ref();
        resources.end();
        const [m0, m1, m2, m3, m4, m5] = this.doc._ctm;
        const [m11, m12, m21, m22, dx, dy] = [
            1,
            0,
            0,
            1,
            0,
            0
        ];
        const m = [
            m0 * m11 + m2 * m12,
            m1 * m11 + m3 * m12,
            m0 * m21 + m2 * m22,
            m1 * m21 + m3 * m22,
            m0 * dx + m2 * dy + m4,
            m1 * dx + m3 * dy + m5
        ];
        const pattern = this.doc.ref({
            Type: 'Pattern',
            PatternType: 1,
            PaintType: 2,
            TilingType: 2,
            BBox: this.bBox,
            XStep: this.xStep,
            YStep: this.yStep,
            Matrix: m.map((v)=>+v.toFixed(5)),
            Resources: resources
        });
        pattern.end(this.stream);
        return pattern;
    }
    embedPatternColorSpaces() {
        $6c341d77d66c320e$var$underlyingColorSpaces.forEach((csName)=>{
            const csId = this.getPatternColorSpaceId(csName);
            if (this.doc.page.colorSpaces[csId]) return;
            const cs = this.doc.ref([
                'Pattern',
                csName
            ]);
            cs.end();
            this.doc.page.colorSpaces[csId] = cs;
        });
    }
    getPatternColorSpaceId(underlyingColorspace) {
        return `CsP${underlyingColorspace}`;
    }
    embed() {
        if (!this.id) {
            this.doc._patternCount = this.doc._patternCount + 1;
            this.id = 'P' + this.doc._patternCount;
            this.pattern = this.createPattern();
        }
        if (!this.doc.page.patterns[this.id]) this.doc.page.patterns[this.id] = this.pattern;
    }
    apply(stroke, patternColor) {
        this.embedPatternColorSpaces();
        this.embed();
        const normalizedColor = this.doc._normalizeColor(patternColor);
        if (!normalizedColor) throw Error(`invalid pattern color. (value: ${patternColor})`);
        const csId = this.getPatternColorSpaceId(this.doc._getColorSpace(normalizedColor));
        this.doc._setColorSpace(csId, stroke);
        const op = stroke ? 'SCN' : 'scn';
        return this.doc.addContent(`${normalizedColor.join(' ')} /${this.id} ${op}`);
    }
};
var $6c341d77d66c320e$var$pattern = {
    PDFTilingPattern: $6c341d77d66c320e$var$PDFTilingPattern$1
};
const { PDFGradient: $6c341d77d66c320e$var$PDFGradient, PDFLinearGradient: $6c341d77d66c320e$var$PDFLinearGradient, PDFRadialGradient: $6c341d77d66c320e$var$PDFRadialGradient } = $6c341d77d66c320e$var$Gradient;
const { PDFTilingPattern: $6c341d77d66c320e$var$PDFTilingPattern } = $6c341d77d66c320e$var$pattern;
var $6c341d77d66c320e$var$ColorMixin = {
    initColor () {
        this.spotColors = {};
        this._opacityRegistry = {};
        this._opacityCount = 0;
        this._patternCount = 0;
        this._gradCount = 0;
    },
    _normalizeColor (color) {
        if (typeof color === 'string') {
            if (color.charAt(0) === '#') {
                if (color.length === 4) color = color.replace(/#([0-9A-F])([0-9A-F])([0-9A-F])/i, '#$1$1$2$2$3$3');
                const hex = parseInt(color.slice(1), 16);
                color = [
                    hex >> 16,
                    hex >> 8 & 0xff,
                    hex & 0xff
                ];
            } else if ($6c341d77d66c320e$var$namedColors[color.toLowerCase()]) color = $6c341d77d66c320e$var$namedColors[color.toLowerCase()];
            else if (this.spotColors[color]) return this.spotColors[color];
        }
        if (Array.isArray(color)) {
            if (color.length === 3) color = color.map((part)=>part / 255);
            else if (color.length === 4) color = color.map((part)=>part / 100);
            return color;
        }
        return null;
    },
    _setColor (color, stroke) {
        if (color instanceof $6c341d77d66c320e$var$PDFGradient) {
            color.apply(stroke);
            return true;
        } else if (Array.isArray(color) && color[0] instanceof $6c341d77d66c320e$var$PDFTilingPattern) {
            color[0].apply(stroke, color[1]);
            return true;
        }
        return this._setColorCore(color, stroke);
    },
    _setColorCore (color, stroke) {
        color = this._normalizeColor(color);
        if (!color) return false;
        const op = stroke ? 'SCN' : 'scn';
        const space = this._getColorSpace(color);
        this._setColorSpace(space, stroke);
        if (color instanceof $6c341d77d66c320e$var$SpotColor) {
            this.page.colorSpaces[color.id] = color.ref;
            this.addContent(`1 ${op}`);
        } else this.addContent(`${color.join(' ')} ${op}`);
        return true;
    },
    _setColorSpace (space, stroke) {
        const op = stroke ? 'CS' : 'cs';
        return this.addContent(`/${space} ${op}`);
    },
    _getColorSpace (color) {
        if (color instanceof $6c341d77d66c320e$var$SpotColor) return color.id;
        return color.length === 4 ? 'DeviceCMYK' : 'DeviceRGB';
    },
    fillColor (color, opacity) {
        const set = this._setColor(color, false);
        if (set) this.fillOpacity(opacity);
        this._fillColor = [
            color,
            opacity
        ];
        return this;
    },
    strokeColor (color, opacity) {
        const set = this._setColor(color, true);
        if (set) this.strokeOpacity(opacity);
        return this;
    },
    opacity (opacity) {
        this._doOpacity(opacity, opacity);
        return this;
    },
    fillOpacity (opacity) {
        this._doOpacity(opacity, null);
        return this;
    },
    strokeOpacity (opacity) {
        this._doOpacity(null, opacity);
        return this;
    },
    _doOpacity (fillOpacity, strokeOpacity) {
        let dictionary, name;
        if (fillOpacity == null && strokeOpacity == null) return;
        if (fillOpacity != null) fillOpacity = Math.max(0, Math.min(1, fillOpacity));
        if (strokeOpacity != null) strokeOpacity = Math.max(0, Math.min(1, strokeOpacity));
        const key = `${fillOpacity}_${strokeOpacity}`;
        if (this._opacityRegistry[key]) [dictionary, name] = this._opacityRegistry[key];
        else {
            dictionary = {
                Type: 'ExtGState'
            };
            if (fillOpacity != null) dictionary.ca = fillOpacity;
            if (strokeOpacity != null) dictionary.CA = strokeOpacity;
            dictionary = this.ref(dictionary);
            dictionary.end();
            const id = ++this._opacityCount;
            name = `Gs${id}`;
            this._opacityRegistry[key] = [
                dictionary,
                name
            ];
        }
        this.page.ext_gstates[name] = dictionary;
        return this.addContent(`/${name} gs`);
    },
    linearGradient (x1, y1, x2, y2) {
        return new $6c341d77d66c320e$var$PDFLinearGradient(this, x1, y1, x2, y2);
    },
    radialGradient (x1, y1, r1, x2, y2, r2) {
        return new $6c341d77d66c320e$var$PDFRadialGradient(this, x1, y1, r1, x2, y2, r2);
    },
    pattern (bbox, xStep, yStep, stream) {
        return new $6c341d77d66c320e$var$PDFTilingPattern(this, bbox, xStep, yStep, stream);
    },
    addSpotColor (name, C, M, Y, K) {
        const color = new $6c341d77d66c320e$var$SpotColor(this, name, C, M, Y, K);
        this.spotColors[name] = color;
        return this;
    }
};
var $6c341d77d66c320e$var$namedColors = {
    aliceblue: [
        240,
        248,
        255
    ],
    antiquewhite: [
        250,
        235,
        215
    ],
    aqua: [
        0,
        255,
        255
    ],
    aquamarine: [
        127,
        255,
        212
    ],
    azure: [
        240,
        255,
        255
    ],
    beige: [
        245,
        245,
        220
    ],
    bisque: [
        255,
        228,
        196
    ],
    black: [
        0,
        0,
        0
    ],
    blanchedalmond: [
        255,
        235,
        205
    ],
    blue: [
        0,
        0,
        255
    ],
    blueviolet: [
        138,
        43,
        226
    ],
    brown: [
        165,
        42,
        42
    ],
    burlywood: [
        222,
        184,
        135
    ],
    cadetblue: [
        95,
        158,
        160
    ],
    chartreuse: [
        127,
        255,
        0
    ],
    chocolate: [
        210,
        105,
        30
    ],
    coral: [
        255,
        127,
        80
    ],
    cornflowerblue: [
        100,
        149,
        237
    ],
    cornsilk: [
        255,
        248,
        220
    ],
    crimson: [
        220,
        20,
        60
    ],
    cyan: [
        0,
        255,
        255
    ],
    darkblue: [
        0,
        0,
        139
    ],
    darkcyan: [
        0,
        139,
        139
    ],
    darkgoldenrod: [
        184,
        134,
        11
    ],
    darkgray: [
        169,
        169,
        169
    ],
    darkgreen: [
        0,
        100,
        0
    ],
    darkgrey: [
        169,
        169,
        169
    ],
    darkkhaki: [
        189,
        183,
        107
    ],
    darkmagenta: [
        139,
        0,
        139
    ],
    darkolivegreen: [
        85,
        107,
        47
    ],
    darkorange: [
        255,
        140,
        0
    ],
    darkorchid: [
        153,
        50,
        204
    ],
    darkred: [
        139,
        0,
        0
    ],
    darksalmon: [
        233,
        150,
        122
    ],
    darkseagreen: [
        143,
        188,
        143
    ],
    darkslateblue: [
        72,
        61,
        139
    ],
    darkslategray: [
        47,
        79,
        79
    ],
    darkslategrey: [
        47,
        79,
        79
    ],
    darkturquoise: [
        0,
        206,
        209
    ],
    darkviolet: [
        148,
        0,
        211
    ],
    deeppink: [
        255,
        20,
        147
    ],
    deepskyblue: [
        0,
        191,
        255
    ],
    dimgray: [
        105,
        105,
        105
    ],
    dimgrey: [
        105,
        105,
        105
    ],
    dodgerblue: [
        30,
        144,
        255
    ],
    firebrick: [
        178,
        34,
        34
    ],
    floralwhite: [
        255,
        250,
        240
    ],
    forestgreen: [
        34,
        139,
        34
    ],
    fuchsia: [
        255,
        0,
        255
    ],
    gainsboro: [
        220,
        220,
        220
    ],
    ghostwhite: [
        248,
        248,
        255
    ],
    gold: [
        255,
        215,
        0
    ],
    goldenrod: [
        218,
        165,
        32
    ],
    gray: [
        128,
        128,
        128
    ],
    grey: [
        128,
        128,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    greenyellow: [
        173,
        255,
        47
    ],
    honeydew: [
        240,
        255,
        240
    ],
    hotpink: [
        255,
        105,
        180
    ],
    indianred: [
        205,
        92,
        92
    ],
    indigo: [
        75,
        0,
        130
    ],
    ivory: [
        255,
        255,
        240
    ],
    khaki: [
        240,
        230,
        140
    ],
    lavender: [
        230,
        230,
        250
    ],
    lavenderblush: [
        255,
        240,
        245
    ],
    lawngreen: [
        124,
        252,
        0
    ],
    lemonchiffon: [
        255,
        250,
        205
    ],
    lightblue: [
        173,
        216,
        230
    ],
    lightcoral: [
        240,
        128,
        128
    ],
    lightcyan: [
        224,
        255,
        255
    ],
    lightgoldenrodyellow: [
        250,
        250,
        210
    ],
    lightgray: [
        211,
        211,
        211
    ],
    lightgreen: [
        144,
        238,
        144
    ],
    lightgrey: [
        211,
        211,
        211
    ],
    lightpink: [
        255,
        182,
        193
    ],
    lightsalmon: [
        255,
        160,
        122
    ],
    lightseagreen: [
        32,
        178,
        170
    ],
    lightskyblue: [
        135,
        206,
        250
    ],
    lightslategray: [
        119,
        136,
        153
    ],
    lightslategrey: [
        119,
        136,
        153
    ],
    lightsteelblue: [
        176,
        196,
        222
    ],
    lightyellow: [
        255,
        255,
        224
    ],
    lime: [
        0,
        255,
        0
    ],
    limegreen: [
        50,
        205,
        50
    ],
    linen: [
        250,
        240,
        230
    ],
    magenta: [
        255,
        0,
        255
    ],
    maroon: [
        128,
        0,
        0
    ],
    mediumaquamarine: [
        102,
        205,
        170
    ],
    mediumblue: [
        0,
        0,
        205
    ],
    mediumorchid: [
        186,
        85,
        211
    ],
    mediumpurple: [
        147,
        112,
        219
    ],
    mediumseagreen: [
        60,
        179,
        113
    ],
    mediumslateblue: [
        123,
        104,
        238
    ],
    mediumspringgreen: [
        0,
        250,
        154
    ],
    mediumturquoise: [
        72,
        209,
        204
    ],
    mediumvioletred: [
        199,
        21,
        133
    ],
    midnightblue: [
        25,
        25,
        112
    ],
    mintcream: [
        245,
        255,
        250
    ],
    mistyrose: [
        255,
        228,
        225
    ],
    moccasin: [
        255,
        228,
        181
    ],
    navajowhite: [
        255,
        222,
        173
    ],
    navy: [
        0,
        0,
        128
    ],
    oldlace: [
        253,
        245,
        230
    ],
    olive: [
        128,
        128,
        0
    ],
    olivedrab: [
        107,
        142,
        35
    ],
    orange: [
        255,
        165,
        0
    ],
    orangered: [
        255,
        69,
        0
    ],
    orchid: [
        218,
        112,
        214
    ],
    palegoldenrod: [
        238,
        232,
        170
    ],
    palegreen: [
        152,
        251,
        152
    ],
    paleturquoise: [
        175,
        238,
        238
    ],
    palevioletred: [
        219,
        112,
        147
    ],
    papayawhip: [
        255,
        239,
        213
    ],
    peachpuff: [
        255,
        218,
        185
    ],
    peru: [
        205,
        133,
        63
    ],
    pink: [
        255,
        192,
        203
    ],
    plum: [
        221,
        160,
        221
    ],
    powderblue: [
        176,
        224,
        230
    ],
    purple: [
        128,
        0,
        128
    ],
    red: [
        255,
        0,
        0
    ],
    rosybrown: [
        188,
        143,
        143
    ],
    royalblue: [
        65,
        105,
        225
    ],
    saddlebrown: [
        139,
        69,
        19
    ],
    salmon: [
        250,
        128,
        114
    ],
    sandybrown: [
        244,
        164,
        96
    ],
    seagreen: [
        46,
        139,
        87
    ],
    seashell: [
        255,
        245,
        238
    ],
    sienna: [
        160,
        82,
        45
    ],
    silver: [
        192,
        192,
        192
    ],
    skyblue: [
        135,
        206,
        235
    ],
    slateblue: [
        106,
        90,
        205
    ],
    slategray: [
        112,
        128,
        144
    ],
    slategrey: [
        112,
        128,
        144
    ],
    snow: [
        255,
        250,
        250
    ],
    springgreen: [
        0,
        255,
        127
    ],
    steelblue: [
        70,
        130,
        180
    ],
    tan: [
        210,
        180,
        140
    ],
    teal: [
        0,
        128,
        128
    ],
    thistle: [
        216,
        191,
        216
    ],
    tomato: [
        255,
        99,
        71
    ],
    turquoise: [
        64,
        224,
        208
    ],
    violet: [
        238,
        130,
        238
    ],
    wheat: [
        245,
        222,
        179
    ],
    white: [
        255,
        255,
        255
    ],
    whitesmoke: [
        245,
        245,
        245
    ],
    yellow: [
        255,
        255,
        0
    ],
    yellowgreen: [
        154,
        205,
        50
    ]
};
let $6c341d77d66c320e$var$cx, $6c341d77d66c320e$var$cy, $6c341d77d66c320e$var$px, $6c341d77d66c320e$var$py, $6c341d77d66c320e$var$sx, $6c341d77d66c320e$var$sy;
$6c341d77d66c320e$var$cx = $6c341d77d66c320e$var$cy = $6c341d77d66c320e$var$px = $6c341d77d66c320e$var$py = $6c341d77d66c320e$var$sx = $6c341d77d66c320e$var$sy = 0;
const $6c341d77d66c320e$var$parameters = {
    A: 7,
    a: 7,
    C: 6,
    c: 6,
    H: 1,
    h: 1,
    L: 2,
    l: 2,
    M: 2,
    m: 2,
    Q: 4,
    q: 4,
    S: 4,
    s: 4,
    T: 2,
    t: 2,
    V: 1,
    v: 1,
    Z: 0,
    z: 0
};
const $6c341d77d66c320e$var$isCommand = function(c) {
    return c in $6c341d77d66c320e$var$parameters;
};
const $6c341d77d66c320e$var$isWsp = function(c) {
    const codePoint = c.codePointAt(0);
    return codePoint === 0x20 || codePoint === 0x9 || codePoint === 0xd || codePoint === 0xa;
};
const $6c341d77d66c320e$var$isDigit = function(c) {
    const codePoint = c.codePointAt(0);
    if (codePoint == null) return false;
    return 48 <= codePoint && codePoint <= 57;
};
const $6c341d77d66c320e$var$readNumber = function(string, cursor) {
    let i = cursor;
    let value = '';
    let state = 'none';
    for(; i < string.length; i += 1){
        const c = string[i];
        if (c === '+' || c === '-') {
            if (state === 'none') {
                state = 'sign';
                value += c;
                continue;
            }
            if (state === 'e') {
                state = 'exponent_sign';
                value += c;
                continue;
            }
        }
        if ($6c341d77d66c320e$var$isDigit(c)) {
            if (state === 'none' || state === 'sign' || state === 'whole') {
                state = 'whole';
                value += c;
                continue;
            }
            if (state === 'decimal_point' || state === 'decimal') {
                state = 'decimal';
                value += c;
                continue;
            }
            if (state === 'e' || state === 'exponent_sign' || state === 'exponent') {
                state = 'exponent';
                value += c;
                continue;
            }
        }
        if (c === '.') {
            if (state === 'none' || state === 'sign' || state === 'whole') {
                state = 'decimal_point';
                value += c;
                continue;
            }
        }
        if (c === 'E' || c === 'e') {
            if (state === 'whole' || state === 'decimal_point' || state === 'decimal') {
                state = 'e';
                value += c;
                continue;
            }
        }
        break;
    }
    const number = Number.parseFloat(value);
    if (Number.isNaN(number)) return [
        cursor,
        null
    ];
    return [
        i - 1,
        number
    ];
};
const $6c341d77d66c320e$var$parse = function(path) {
    const pathData = [];
    let command = null;
    let args = [];
    let argsCount = 0;
    let canHaveComma = false;
    let hadComma = false;
    for(let i = 0; i < path.length; i += 1){
        const c = path.charAt(i);
        if ($6c341d77d66c320e$var$isWsp(c)) continue;
        if (canHaveComma && c === ',') {
            if (hadComma) break;
            hadComma = true;
            continue;
        }
        if ($6c341d77d66c320e$var$isCommand(c)) {
            if (hadComma) return pathData;
            if (command == null) {
                if (c !== 'M' && c !== 'm') return pathData;
            } else {
                if (args.length !== 0) return pathData;
            }
            command = c;
            args = [];
            argsCount = $6c341d77d66c320e$var$parameters[command];
            canHaveComma = false;
            if (argsCount === 0) pathData.push({
                command: command,
                args: args
            });
            continue;
        }
        if (command == null) return pathData;
        let newCursor = i;
        let number = null;
        if (command === 'A' || command === 'a') {
            const position = args.length;
            if (position === 0 || position === 1) {
                if (c !== '+' && c !== '-') [newCursor, number] = $6c341d77d66c320e$var$readNumber(path, i);
            }
            if (position === 2 || position === 5 || position === 6) [newCursor, number] = $6c341d77d66c320e$var$readNumber(path, i);
            if (position === 3 || position === 4) {
                if (c === '0') number = 0;
                if (c === '1') number = 1;
            }
        } else [newCursor, number] = $6c341d77d66c320e$var$readNumber(path, i);
        if (number == null) return pathData;
        args.push(number);
        canHaveComma = true;
        hadComma = false;
        i = newCursor;
        if (args.length === argsCount) {
            pathData.push({
                command: command,
                args: args
            });
            if (command === 'M') command = 'L';
            if (command === 'm') command = 'l';
            args = [];
        }
    }
    return pathData;
};
const $6c341d77d66c320e$var$apply = function(commands, doc) {
    $6c341d77d66c320e$var$cx = $6c341d77d66c320e$var$cy = $6c341d77d66c320e$var$px = $6c341d77d66c320e$var$py = $6c341d77d66c320e$var$sx = $6c341d77d66c320e$var$sy = 0;
    for(let i = 0; i < commands.length; i++){
        const c = commands[i];
        if (typeof $6c341d77d66c320e$var$runners[c.command] === 'function') $6c341d77d66c320e$var$runners[c.command](doc, c.args);
    }
};
const $6c341d77d66c320e$var$runners = {
    M (doc, a) {
        $6c341d77d66c320e$var$cx = a[0];
        $6c341d77d66c320e$var$cy = a[1];
        $6c341d77d66c320e$var$px = $6c341d77d66c320e$var$py = null;
        $6c341d77d66c320e$var$sx = $6c341d77d66c320e$var$cx;
        $6c341d77d66c320e$var$sy = $6c341d77d66c320e$var$cy;
        return doc.moveTo($6c341d77d66c320e$var$cx, $6c341d77d66c320e$var$cy);
    },
    m (doc, a) {
        $6c341d77d66c320e$var$cx += a[0];
        $6c341d77d66c320e$var$cy += a[1];
        $6c341d77d66c320e$var$px = $6c341d77d66c320e$var$py = null;
        $6c341d77d66c320e$var$sx = $6c341d77d66c320e$var$cx;
        $6c341d77d66c320e$var$sy = $6c341d77d66c320e$var$cy;
        return doc.moveTo($6c341d77d66c320e$var$cx, $6c341d77d66c320e$var$cy);
    },
    C (doc, a) {
        $6c341d77d66c320e$var$cx = a[4];
        $6c341d77d66c320e$var$cy = a[5];
        $6c341d77d66c320e$var$px = a[2];
        $6c341d77d66c320e$var$py = a[3];
        return doc.bezierCurveTo(...a);
    },
    c (doc, a) {
        doc.bezierCurveTo(a[0] + $6c341d77d66c320e$var$cx, a[1] + $6c341d77d66c320e$var$cy, a[2] + $6c341d77d66c320e$var$cx, a[3] + $6c341d77d66c320e$var$cy, a[4] + $6c341d77d66c320e$var$cx, a[5] + $6c341d77d66c320e$var$cy);
        $6c341d77d66c320e$var$px = $6c341d77d66c320e$var$cx + a[2];
        $6c341d77d66c320e$var$py = $6c341d77d66c320e$var$cy + a[3];
        $6c341d77d66c320e$var$cx += a[4];
        return $6c341d77d66c320e$var$cy += a[5];
    },
    S (doc, a) {
        if ($6c341d77d66c320e$var$px === null) {
            $6c341d77d66c320e$var$px = $6c341d77d66c320e$var$cx;
            $6c341d77d66c320e$var$py = $6c341d77d66c320e$var$cy;
        }
        doc.bezierCurveTo($6c341d77d66c320e$var$cx - ($6c341d77d66c320e$var$px - $6c341d77d66c320e$var$cx), $6c341d77d66c320e$var$cy - ($6c341d77d66c320e$var$py - $6c341d77d66c320e$var$cy), a[0], a[1], a[2], a[3]);
        $6c341d77d66c320e$var$px = a[0];
        $6c341d77d66c320e$var$py = a[1];
        $6c341d77d66c320e$var$cx = a[2];
        return $6c341d77d66c320e$var$cy = a[3];
    },
    s (doc, a) {
        if ($6c341d77d66c320e$var$px === null) {
            $6c341d77d66c320e$var$px = $6c341d77d66c320e$var$cx;
            $6c341d77d66c320e$var$py = $6c341d77d66c320e$var$cy;
        }
        doc.bezierCurveTo($6c341d77d66c320e$var$cx - ($6c341d77d66c320e$var$px - $6c341d77d66c320e$var$cx), $6c341d77d66c320e$var$cy - ($6c341d77d66c320e$var$py - $6c341d77d66c320e$var$cy), $6c341d77d66c320e$var$cx + a[0], $6c341d77d66c320e$var$cy + a[1], $6c341d77d66c320e$var$cx + a[2], $6c341d77d66c320e$var$cy + a[3]);
        $6c341d77d66c320e$var$px = $6c341d77d66c320e$var$cx + a[0];
        $6c341d77d66c320e$var$py = $6c341d77d66c320e$var$cy + a[1];
        $6c341d77d66c320e$var$cx += a[2];
        return $6c341d77d66c320e$var$cy += a[3];
    },
    Q (doc, a) {
        $6c341d77d66c320e$var$px = a[0];
        $6c341d77d66c320e$var$py = a[1];
        $6c341d77d66c320e$var$cx = a[2];
        $6c341d77d66c320e$var$cy = a[3];
        return doc.quadraticCurveTo(a[0], a[1], $6c341d77d66c320e$var$cx, $6c341d77d66c320e$var$cy);
    },
    q (doc, a) {
        doc.quadraticCurveTo(a[0] + $6c341d77d66c320e$var$cx, a[1] + $6c341d77d66c320e$var$cy, a[2] + $6c341d77d66c320e$var$cx, a[3] + $6c341d77d66c320e$var$cy);
        $6c341d77d66c320e$var$px = $6c341d77d66c320e$var$cx + a[0];
        $6c341d77d66c320e$var$py = $6c341d77d66c320e$var$cy + a[1];
        $6c341d77d66c320e$var$cx += a[2];
        return $6c341d77d66c320e$var$cy += a[3];
    },
    T (doc, a) {
        if ($6c341d77d66c320e$var$px === null) {
            $6c341d77d66c320e$var$px = $6c341d77d66c320e$var$cx;
            $6c341d77d66c320e$var$py = $6c341d77d66c320e$var$cy;
        } else {
            $6c341d77d66c320e$var$px = $6c341d77d66c320e$var$cx - ($6c341d77d66c320e$var$px - $6c341d77d66c320e$var$cx);
            $6c341d77d66c320e$var$py = $6c341d77d66c320e$var$cy - ($6c341d77d66c320e$var$py - $6c341d77d66c320e$var$cy);
        }
        doc.quadraticCurveTo($6c341d77d66c320e$var$px, $6c341d77d66c320e$var$py, a[0], a[1]);
        $6c341d77d66c320e$var$px = $6c341d77d66c320e$var$cx - ($6c341d77d66c320e$var$px - $6c341d77d66c320e$var$cx);
        $6c341d77d66c320e$var$py = $6c341d77d66c320e$var$cy - ($6c341d77d66c320e$var$py - $6c341d77d66c320e$var$cy);
        $6c341d77d66c320e$var$cx = a[0];
        return $6c341d77d66c320e$var$cy = a[1];
    },
    t (doc, a) {
        if ($6c341d77d66c320e$var$px === null) {
            $6c341d77d66c320e$var$px = $6c341d77d66c320e$var$cx;
            $6c341d77d66c320e$var$py = $6c341d77d66c320e$var$cy;
        } else {
            $6c341d77d66c320e$var$px = $6c341d77d66c320e$var$cx - ($6c341d77d66c320e$var$px - $6c341d77d66c320e$var$cx);
            $6c341d77d66c320e$var$py = $6c341d77d66c320e$var$cy - ($6c341d77d66c320e$var$py - $6c341d77d66c320e$var$cy);
        }
        doc.quadraticCurveTo($6c341d77d66c320e$var$px, $6c341d77d66c320e$var$py, $6c341d77d66c320e$var$cx + a[0], $6c341d77d66c320e$var$cy + a[1]);
        $6c341d77d66c320e$var$cx += a[0];
        return $6c341d77d66c320e$var$cy += a[1];
    },
    A (doc, a) {
        $6c341d77d66c320e$var$solveArc(doc, $6c341d77d66c320e$var$cx, $6c341d77d66c320e$var$cy, a);
        $6c341d77d66c320e$var$cx = a[5];
        return $6c341d77d66c320e$var$cy = a[6];
    },
    a (doc, a) {
        a[5] += $6c341d77d66c320e$var$cx;
        a[6] += $6c341d77d66c320e$var$cy;
        $6c341d77d66c320e$var$solveArc(doc, $6c341d77d66c320e$var$cx, $6c341d77d66c320e$var$cy, a);
        $6c341d77d66c320e$var$cx = a[5];
        return $6c341d77d66c320e$var$cy = a[6];
    },
    L (doc, a) {
        $6c341d77d66c320e$var$cx = a[0];
        $6c341d77d66c320e$var$cy = a[1];
        $6c341d77d66c320e$var$px = $6c341d77d66c320e$var$py = null;
        return doc.lineTo($6c341d77d66c320e$var$cx, $6c341d77d66c320e$var$cy);
    },
    l (doc, a) {
        $6c341d77d66c320e$var$cx += a[0];
        $6c341d77d66c320e$var$cy += a[1];
        $6c341d77d66c320e$var$px = $6c341d77d66c320e$var$py = null;
        return doc.lineTo($6c341d77d66c320e$var$cx, $6c341d77d66c320e$var$cy);
    },
    H (doc, a) {
        $6c341d77d66c320e$var$cx = a[0];
        $6c341d77d66c320e$var$px = $6c341d77d66c320e$var$py = null;
        return doc.lineTo($6c341d77d66c320e$var$cx, $6c341d77d66c320e$var$cy);
    },
    h (doc, a) {
        $6c341d77d66c320e$var$cx += a[0];
        $6c341d77d66c320e$var$px = $6c341d77d66c320e$var$py = null;
        return doc.lineTo($6c341d77d66c320e$var$cx, $6c341d77d66c320e$var$cy);
    },
    V (doc, a) {
        $6c341d77d66c320e$var$cy = a[0];
        $6c341d77d66c320e$var$px = $6c341d77d66c320e$var$py = null;
        return doc.lineTo($6c341d77d66c320e$var$cx, $6c341d77d66c320e$var$cy);
    },
    v (doc, a) {
        $6c341d77d66c320e$var$cy += a[0];
        $6c341d77d66c320e$var$px = $6c341d77d66c320e$var$py = null;
        return doc.lineTo($6c341d77d66c320e$var$cx, $6c341d77d66c320e$var$cy);
    },
    Z (doc) {
        doc.closePath();
        $6c341d77d66c320e$var$cx = $6c341d77d66c320e$var$sx;
        return $6c341d77d66c320e$var$cy = $6c341d77d66c320e$var$sy;
    },
    z (doc) {
        doc.closePath();
        $6c341d77d66c320e$var$cx = $6c341d77d66c320e$var$sx;
        return $6c341d77d66c320e$var$cy = $6c341d77d66c320e$var$sy;
    }
};
const $6c341d77d66c320e$var$solveArc = function(doc, x, y, coords) {
    const [rx, ry, rot, large, sweep, ex, ey] = coords;
    const segs = $6c341d77d66c320e$var$arcToSegments(ex, ey, rx, ry, large, sweep, rot, x, y);
    for (let seg of segs){
        const bez = $6c341d77d66c320e$var$segmentToBezier(...seg);
        doc.bezierCurveTo(...bez);
    }
};
const $6c341d77d66c320e$var$arcToSegments = function(x, y, rx, ry, large, sweep, rotateX, ox, oy) {
    const th = rotateX * (Math.PI / 180);
    const sin_th = Math.sin(th);
    const cos_th = Math.cos(th);
    rx = Math.abs(rx);
    ry = Math.abs(ry);
    $6c341d77d66c320e$var$px = cos_th * (ox - x) * 0.5 + sin_th * (oy - y) * 0.5;
    $6c341d77d66c320e$var$py = cos_th * (oy - y) * 0.5 - sin_th * (ox - x) * 0.5;
    let pl = $6c341d77d66c320e$var$px * $6c341d77d66c320e$var$px / (rx * rx) + $6c341d77d66c320e$var$py * $6c341d77d66c320e$var$py / (ry * ry);
    if (pl > 1) {
        pl = Math.sqrt(pl);
        rx *= pl;
        ry *= pl;
    }
    const a00 = cos_th / rx;
    const a01 = sin_th / rx;
    const a10 = -sin_th / ry;
    const a11 = cos_th / ry;
    const x0 = a00 * ox + a01 * oy;
    const y0 = a10 * ox + a11 * oy;
    const x1 = a00 * x + a01 * y;
    const y1 = a10 * x + a11 * y;
    const d = (x1 - x0) * (x1 - x0) + (y1 - y0) * (y1 - y0);
    let sfactor_sq = 1 / d - 0.25;
    if (sfactor_sq < 0) sfactor_sq = 0;
    let sfactor = Math.sqrt(sfactor_sq);
    if (sweep === large) sfactor = -sfactor;
    const xc = 0.5 * (x0 + x1) - sfactor * (y1 - y0);
    const yc = 0.5 * (y0 + y1) + sfactor * (x1 - x0);
    const th0 = Math.atan2(y0 - yc, x0 - xc);
    const th1 = Math.atan2(y1 - yc, x1 - xc);
    let th_arc = th1 - th0;
    if (th_arc < 0 && sweep === 1) th_arc += 2 * Math.PI;
    else if (th_arc > 0 && sweep === 0) th_arc -= 2 * Math.PI;
    const segments = Math.ceil(Math.abs(th_arc / (Math.PI * 0.5 + 0.001)));
    const result = [];
    for(let i = 0; i < segments; i++){
        const th2 = th0 + i * th_arc / segments;
        const th3 = th0 + (i + 1) * th_arc / segments;
        result[i] = [
            xc,
            yc,
            th2,
            th3,
            rx,
            ry,
            sin_th,
            cos_th
        ];
    }
    return result;
};
const $6c341d77d66c320e$var$segmentToBezier = function(cx, cy, th0, th1, rx, ry, sin_th, cos_th) {
    const a00 = cos_th * rx;
    const a01 = -sin_th * ry;
    const a10 = sin_th * rx;
    const a11 = cos_th * ry;
    const th_half = 0.5 * (th1 - th0);
    const t = 8 / 3 * Math.sin(th_half * 0.5) * Math.sin(th_half * 0.5) / Math.sin(th_half);
    const x1 = cx + Math.cos(th0) - t * Math.sin(th0);
    const y1 = cy + Math.sin(th0) + t * Math.cos(th0);
    const x3 = cx + Math.cos(th1);
    const y3 = cy + Math.sin(th1);
    const x2 = x3 + t * Math.sin(th1);
    const y2 = y3 - t * Math.cos(th1);
    return [
        a00 * x1 + a01 * y1,
        a10 * x1 + a11 * y1,
        a00 * x2 + a01 * y2,
        a10 * x2 + a11 * y2,
        a00 * x3 + a01 * y3,
        a10 * x3 + a11 * y3
    ];
};
class $6c341d77d66c320e$var$SVGPath {
    static apply(doc, path) {
        const commands = $6c341d77d66c320e$var$parse(path);
        $6c341d77d66c320e$var$apply(commands, doc);
    }
}
const { number: $6c341d77d66c320e$var$number$1 } = $6c341d77d66c320e$var$PDFObject;
const $6c341d77d66c320e$var$KAPPA = 4.0 * ((Math.sqrt(2) - 1.0) / 3.0);
var $6c341d77d66c320e$var$VectorMixin = {
    initVector () {
        this._ctm = [
            1,
            0,
            0,
            1,
            0,
            0
        ];
        this._ctmStack = [];
    },
    save () {
        this._ctmStack.push(this._ctm.slice());
        return this.addContent('q');
    },
    restore () {
        this._ctm = this._ctmStack.pop() || [
            1,
            0,
            0,
            1,
            0,
            0
        ];
        return this.addContent('Q');
    },
    closePath () {
        return this.addContent('h');
    },
    lineWidth (w) {
        return this.addContent(`${$6c341d77d66c320e$var$number$1(w)} w`);
    },
    _CAP_STYLES: {
        BUTT: 0,
        ROUND: 1,
        SQUARE: 2
    },
    lineCap (c) {
        if (typeof c === 'string') c = this._CAP_STYLES[c.toUpperCase()];
        return this.addContent(`${c} J`);
    },
    _JOIN_STYLES: {
        MITER: 0,
        ROUND: 1,
        BEVEL: 2
    },
    lineJoin (j) {
        if (typeof j === 'string') j = this._JOIN_STYLES[j.toUpperCase()];
        return this.addContent(`${j} j`);
    },
    miterLimit (m) {
        return this.addContent(`${$6c341d77d66c320e$var$number$1(m)} M`);
    },
    dash (length, options = {}) {
        const originalLength = length;
        if (!Array.isArray(length)) length = [
            length,
            options.space || length
        ];
        const valid = length.every((x)=>Number.isFinite(x) && x > 0);
        if (!valid) throw new Error(`dash(${JSON.stringify(originalLength)}, ${JSON.stringify(options)}) invalid, lengths must be numeric and greater than zero`);
        length = length.map($6c341d77d66c320e$var$number$1).join(' ');
        return this.addContent(`[${length}] ${$6c341d77d66c320e$var$number$1(options.phase || 0)} d`);
    },
    undash () {
        return this.addContent('[] 0 d');
    },
    moveTo (x, y) {
        return this.addContent(`${$6c341d77d66c320e$var$number$1(x)} ${$6c341d77d66c320e$var$number$1(y)} m`);
    },
    lineTo (x, y) {
        return this.addContent(`${$6c341d77d66c320e$var$number$1(x)} ${$6c341d77d66c320e$var$number$1(y)} l`);
    },
    bezierCurveTo (cp1x, cp1y, cp2x, cp2y, x, y) {
        return this.addContent(`${$6c341d77d66c320e$var$number$1(cp1x)} ${$6c341d77d66c320e$var$number$1(cp1y)} ${$6c341d77d66c320e$var$number$1(cp2x)} ${$6c341d77d66c320e$var$number$1(cp2y)} ${$6c341d77d66c320e$var$number$1(x)} ${$6c341d77d66c320e$var$number$1(y)} c`);
    },
    quadraticCurveTo (cpx, cpy, x, y) {
        return this.addContent(`${$6c341d77d66c320e$var$number$1(cpx)} ${$6c341d77d66c320e$var$number$1(cpy)} ${$6c341d77d66c320e$var$number$1(x)} ${$6c341d77d66c320e$var$number$1(y)} v`);
    },
    rect (x, y, w, h) {
        return this.addContent(`${$6c341d77d66c320e$var$number$1(x)} ${$6c341d77d66c320e$var$number$1(y)} ${$6c341d77d66c320e$var$number$1(w)} ${$6c341d77d66c320e$var$number$1(h)} re`);
    },
    roundedRect (x, y, w, h, borderRadius) {
        if (borderRadius == null) borderRadius = 0;
        let radii;
        if (Array.isArray(borderRadius)) radii = borderRadius.slice(0, 4);
        else radii = [
            borderRadius,
            borderRadius,
            borderRadius,
            borderRadius
        ];
        const limit = Math.min(0.5 * w, 0.5 * h);
        const rTL = Math.max(0, Math.min(radii[0] || 0, limit));
        const rTR = Math.max(0, Math.min(radii[1] || 0, limit));
        const rBR = Math.max(0, Math.min(radii[2] || 0, limit));
        const rBL = Math.max(0, Math.min(radii[3] || 0, limit));
        const cpTR = rTR * (1.0 - $6c341d77d66c320e$var$KAPPA);
        const cpBR = rBR * (1.0 - $6c341d77d66c320e$var$KAPPA);
        const cpBL = rBL * (1.0 - $6c341d77d66c320e$var$KAPPA);
        const cpTL = rTL * (1.0 - $6c341d77d66c320e$var$KAPPA);
        this.moveTo(x + rTL, y);
        this.lineTo(x + w - rTR, y);
        if (rTR > 0) this.bezierCurveTo(x + w - cpTR, y, x + w, y + cpTR, x + w, y + rTR);
        this.lineTo(x + w, y + h - rBR);
        if (rBR > 0) this.bezierCurveTo(x + w, y + h - cpBR, x + w - cpBR, y + h, x + w - rBR, y + h);
        this.lineTo(x + rBL, y + h);
        if (rBL > 0) this.bezierCurveTo(x + cpBL, y + h, x, y + h - cpBL, x, y + h - rBL);
        this.lineTo(x, y + rTL);
        if (rTL > 0) this.bezierCurveTo(x, y + cpTL, x + cpTL, y, x + rTL, y);
        return this.closePath();
    },
    ellipse (x, y, r1, r2) {
        if (r2 == null) r2 = r1;
        x -= r1;
        y -= r2;
        const ox = r1 * $6c341d77d66c320e$var$KAPPA;
        const oy = r2 * $6c341d77d66c320e$var$KAPPA;
        const xe = x + r1 * 2;
        const ye = y + r2 * 2;
        const xm = x + r1;
        const ym = y + r2;
        this.moveTo(x, ym);
        this.bezierCurveTo(x, ym - oy, xm - ox, y, xm, y);
        this.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym);
        this.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
        this.bezierCurveTo(xm - ox, ye, x, ym + oy, x, ym);
        return this.closePath();
    },
    circle (x, y, radius) {
        return this.ellipse(x, y, radius);
    },
    arc (x, y, radius, startAngle, endAngle, anticlockwise) {
        if (anticlockwise == null) anticlockwise = false;
        const TWO_PI = 2.0 * Math.PI;
        const HALF_PI = 0.5 * Math.PI;
        let deltaAng = endAngle - startAngle;
        if (Math.abs(deltaAng) > TWO_PI) deltaAng = TWO_PI;
        else if (deltaAng !== 0 && anticlockwise !== deltaAng < 0) {
            const dir = anticlockwise ? -1 : 1;
            deltaAng = dir * TWO_PI + deltaAng;
        }
        const numSegs = Math.ceil(Math.abs(deltaAng) / HALF_PI);
        const segAng = deltaAng / numSegs;
        const handleLen = segAng / HALF_PI * $6c341d77d66c320e$var$KAPPA * radius;
        let curAng = startAngle;
        let deltaCx = -Math.sin(curAng) * handleLen;
        let deltaCy = Math.cos(curAng) * handleLen;
        let ax = x + Math.cos(curAng) * radius;
        let ay = y + Math.sin(curAng) * radius;
        this.moveTo(ax, ay);
        for(let segIdx = 0; segIdx < numSegs; segIdx++){
            const cp1x = ax + deltaCx;
            const cp1y = ay + deltaCy;
            curAng += segAng;
            ax = x + Math.cos(curAng) * radius;
            ay = y + Math.sin(curAng) * radius;
            deltaCx = -Math.sin(curAng) * handleLen;
            deltaCy = Math.cos(curAng) * handleLen;
            const cp2x = ax - deltaCx;
            const cp2y = ay - deltaCy;
            this.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, ax, ay);
        }
        return this;
    },
    polygon (...points) {
        this.moveTo(...points.shift() || []);
        for (let point of points)this.lineTo(...point || []);
        return this.closePath();
    },
    path (path) {
        $6c341d77d66c320e$var$SVGPath.apply(this, path);
        return this;
    },
    _windingRule (rule) {
        if (/even-?odd/.test(rule)) return '*';
        return '';
    },
    fill (color, rule) {
        if (/(even-?odd)|(non-?zero)/.test(color)) {
            rule = color;
            color = null;
        }
        if (color) this.fillColor(color);
        return this.addContent(`f${this._windingRule(rule)}`);
    },
    stroke (color) {
        if (color) this.strokeColor(color);
        return this.addContent('S');
    },
    fillAndStroke (fillColor, strokeColor, rule) {
        if (strokeColor == null) strokeColor = fillColor;
        const isFillRule = /(even-?odd)|(non-?zero)/;
        if (isFillRule.test(fillColor)) {
            rule = fillColor;
            fillColor = null;
        }
        if (isFillRule.test(strokeColor)) {
            rule = strokeColor;
            strokeColor = fillColor;
        }
        if (fillColor) {
            this.fillColor(fillColor);
            this.strokeColor(strokeColor);
        }
        return this.addContent(`B${this._windingRule(rule)}`);
    },
    clip (rule) {
        return this.addContent(`W${this._windingRule(rule)} n`);
    },
    transform (m11, m12, m21, m22, dx, dy) {
        if (m11 === 1 && m12 === 0 && m21 === 0 && m22 === 1 && dx === 0 && dy === 0) return this;
        const m = this._ctm;
        const [m0, m1, m2, m3, m4, m5] = m;
        m[0] = m0 * m11 + m2 * m12;
        m[1] = m1 * m11 + m3 * m12;
        m[2] = m0 * m21 + m2 * m22;
        m[3] = m1 * m21 + m3 * m22;
        m[4] = m0 * dx + m2 * dy + m4;
        m[5] = m1 * dx + m3 * dy + m5;
        const values = [
            m11,
            m12,
            m21,
            m22,
            dx,
            dy
        ].map((v)=>$6c341d77d66c320e$var$number$1(v)).join(' ');
        return this.addContent(`${values} cm`);
    },
    translate (x, y) {
        return this.transform(1, 0, 0, 1, x, y);
    },
    rotate (angle, options = {}) {
        let y;
        const rad = angle * Math.PI / 180;
        const cos = Math.cos(rad);
        const sin = Math.sin(rad);
        let x = y = 0;
        if (options.origin != null) {
            [x, y] = options.origin;
            const x1 = x * cos - y * sin;
            const y1 = x * sin + y * cos;
            x -= x1;
            y -= y1;
        }
        return this.transform(cos, sin, -sin, cos, x, y);
    },
    scale (xFactor, yFactor, options = {}) {
        let y;
        if (yFactor == null) yFactor = xFactor;
        if (typeof yFactor === 'object') {
            options = yFactor;
            yFactor = xFactor;
        }
        let x = y = 0;
        if (options.origin != null) {
            [x, y] = options.origin;
            x -= xFactor * x;
            y -= yFactor * y;
        }
        return this.transform(xFactor, 0, 0, yFactor, x, y);
    }
};
const $6c341d77d66c320e$var$unsupported = (path)=>{
    throw new Error(`Cannot read '${path}': file paths are not supported outside of Node. ` + 'Pass a Uint8Array, ArrayBuffer or a data URL instead.');
};
const $6c341d77d66c320e$var$registeredFiles = new Map();
const $6c341d77d66c320e$var$getTimestamp = (value, name, defaultValue)=>{
    if (value === undefined) return defaultValue;
    if (!(value instanceof Date) || Number.isNaN(value.getTime())) throw new TypeError(`Expected options.${name} to be a valid Date`);
    return value.getTime();
};
function $6c341d77d66c320e$export$abdfd5efb7925f68(path, data, options = {}) {
    if (typeof path !== 'string') throw new TypeError(`Expected a string for path, got ${typeof path}`);
    if (data === undefined) {
        $6c341d77d66c320e$var$registeredFiles.delete(path);
        return;
    }
    if (!(data instanceof Uint8Array)) throw new TypeError(`Expected a Uint8Array or undefined for data, got ${typeof data}`);
    if (options === null || typeof options !== 'object') throw new TypeError(`Expected options to be an object`);
    const registeredAt = Date.now();
    $6c341d77d66c320e$var$registeredFiles.set(path, {
        data: data,
        birthtime: $6c341d77d66c320e$var$getTimestamp(options.birthtime, 'birthtime', registeredAt),
        ctime: $6c341d77d66c320e$var$getTimestamp(options.ctime, 'ctime', registeredAt)
    });
}
var $6c341d77d66c320e$var$fs = {
    readFileSync (path) {
        if ($6c341d77d66c320e$var$registeredFiles.has(path)) return $6c341d77d66c320e$var$registeredFiles.get(path).data;
        return $6c341d77d66c320e$var$unsupported(path);
    },
    statSync (path) {
        if ($6c341d77d66c320e$var$registeredFiles.has(path)) {
            const { birthtime: birthtime, ctime: ctime } = $6c341d77d66c320e$var$registeredFiles.get(path);
            return {
                birthtime: new Date(birthtime),
                ctime: new Date(ctime)
            };
        }
        return $6c341d77d66c320e$var$unsupported(path);
    }
};
const $6c341d77d66c320e$var$WIN_ANSI_MAP = {
    402: 131,
    8211: 150,
    8212: 151,
    8216: 145,
    8217: 146,
    8218: 130,
    8220: 147,
    8221: 148,
    8222: 132,
    8224: 134,
    8225: 135,
    8226: 149,
    8230: 133,
    8364: 128,
    8240: 137,
    8249: 139,
    8250: 155,
    710: 136,
    8482: 153,
    338: 140,
    339: 156,
    732: 152,
    352: 138,
    353: 154,
    376: 159,
    381: 142,
    382: 158
};
const $6c341d77d66c320e$var$characters = `\
.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef
  
space         exclam         quotedbl       numbersign
dollar        percent        ampersand      quotesingle
parenleft     parenright     asterisk       plus
comma         hyphen         period         slash
zero          one            two            three
four          five           six            seven
eight         nine           colon          semicolon
less          equal          greater        question
  
at            A              B              C
D             E              F              G
H             I              J              K
L             M              N              O
P             Q              R              S
T             U              V              W
X             Y              Z              bracketleft
backslash     bracketright   asciicircum    underscore
  
grave         a              b              c
d             e              f              g
h             i              j              k
l             m              n              o
p             q              r              s
t             u              v              w
x             y              z              braceleft
bar           braceright     asciitilde     .notdef
  
Euro          .notdef        quotesinglbase florin
quotedblbase  ellipsis       dagger         daggerdbl
circumflex    perthousand    Scaron         guilsinglleft
OE            .notdef        Zcaron         .notdef
.notdef       quoteleft      quoteright     quotedblleft
quotedblright bullet         endash         emdash
tilde         trademark      scaron         guilsinglright
oe            .notdef        zcaron         ydieresis
  
space         exclamdown     cent           sterling
currency      yen            brokenbar      section
dieresis      copyright      ordfeminine    guillemotleft
logicalnot    hyphen         registered     macron
degree        plusminus      twosuperior    threesuperior
acute         mu             paragraph      periodcentered
cedilla       onesuperior    ordmasculine   guillemotright
onequarter    onehalf        threequarters  questiondown
  
Agrave        Aacute         Acircumflex    Atilde
Adieresis     Aring          AE             Ccedilla
Egrave        Eacute         Ecircumflex    Edieresis
Igrave        Iacute         Icircumflex    Idieresis
Eth           Ntilde         Ograve         Oacute
Ocircumflex   Otilde         Odieresis      multiply
Oslash        Ugrave         Uacute         Ucircumflex
Udieresis     Yacute         Thorn          germandbls
  
agrave        aacute         acircumflex    atilde
adieresis     aring          ae             ccedilla
egrave        eacute         ecircumflex    edieresis
igrave        iacute         icircumflex    idieresis
eth           ntilde         ograve         oacute
ocircumflex   otilde         odieresis      divide
oslash        ugrave         uacute         ucircumflex
udieresis     yacute         thorn          ydieresis\
`.split(/\s+/);
class $6c341d77d66c320e$var$AFMFont {
    constructor(data){
        this.name = data.name;
        this.bbox = data.bbox.slice();
        this.ascender = data.ascender;
        this.descender = data.descender;
        this.xHeight = data.xHeight;
        this.capHeight = data.capHeight;
        this.lineGap = this.bbox[3] - this.bbox[1] - (this.ascender - this.descender);
        const glyphNames = data.glyphNames.split(' ');
        this.glyphWidths = Object.fromEntries(glyphNames.map((name, index)=>[
                name,
                data.glyphWidths[index]
            ]));
        this.kernPairs = {};
        for(let index = 0; index < data.kernPairs.length; index += 2){
            const amount = data.kernPairs[index];
            let pairId = 0;
            for (const delta of data.kernPairs[index + 1]){
                pairId += delta;
                const left = Math.floor(pairId / glyphNames.length);
                const right = pairId % glyphNames.length;
                this.kernPairs[`${glyphNames[left]}\0${glyphNames[right]}`] = amount;
            }
        }
    }
    encodeText(text) {
        const res = [];
        for(let i = 0, len = text.length; i < len; i++){
            let char = text.charCodeAt(i);
            char = $6c341d77d66c320e$var$WIN_ANSI_MAP[char] || char;
            res.push(char.toString(16));
        }
        return res;
    }
    glyphsForString(string) {
        const glyphs = [];
        for(let i = 0, len = string.length; i < len; i++){
            const charCode = string.charCodeAt(i);
            glyphs.push(this.characterToGlyph(charCode));
        }
        return glyphs;
    }
    characterToGlyph(character) {
        return $6c341d77d66c320e$var$characters[$6c341d77d66c320e$var$WIN_ANSI_MAP[character] || character] || '.notdef';
    }
    widthOfGlyph(glyph) {
        return this.glyphWidths[glyph] || 0;
    }
    getKernPair(left, right) {
        return this.kernPairs[left + '\0' + right] || 0;
    }
    advancesForGlyphs(glyphs) {
        const advances = [];
        for(let index = 0; index < glyphs.length; index++){
            const left = glyphs[index];
            const right = glyphs[index + 1];
            advances.push(this.widthOfGlyph(left) + this.getKernPair(left, right));
        }
        return advances;
    }
}
class $6c341d77d66c320e$var$PDFFont {
    constructor(){}
    encode() {
        throw new Error('Must be implemented by subclasses');
    }
    widthOfString() {
        throw new Error('Must be implemented by subclasses');
    }
    ref() {
        return this.dictionary != null ? this.dictionary : this.dictionary = this.document.ref();
    }
    finalize() {
        if (this.embedded || this.dictionary == null) return;
        this.embed();
        this.embedded = true;
    }
    embed() {
        throw new Error('Must be implemented by subclasses');
    }
    lineHeight(size, includeGap = false) {
        const gap = includeGap ? this.lineGap : 0;
        return (this.ascender + gap - this.descender) / 1000 * size;
    }
}
class $6c341d77d66c320e$var$StandardFont extends $6c341d77d66c320e$var$PDFFont {
    constructor(document, fontData, id){
        super();
        this.document = document;
        this.name = fontData.name;
        this.id = id;
        this.font = new $6c341d77d66c320e$var$AFMFont(fontData);
        ({ ascender: this.ascender, descender: this.descender, bbox: this.bbox, lineGap: this.lineGap, xHeight: this.xHeight, capHeight: this.capHeight } = this.font);
    }
    embed() {
        this.dictionary.data = {
            Type: 'Font',
            BaseFont: this.name,
            Subtype: 'Type1',
            Encoding: 'WinAnsiEncoding'
        };
        return this.dictionary.end();
    }
    encode(text) {
        const encoded = this.font.encodeText(text);
        const glyphs = this.font.glyphsForString(`${text}`);
        const advances = this.font.advancesForGlyphs(glyphs);
        const positions = [];
        for(let i = 0; i < glyphs.length; i++){
            const glyph = glyphs[i];
            positions.push({
                xAdvance: advances[i],
                yAdvance: 0,
                xOffset: 0,
                yOffset: 0,
                advanceWidth: this.font.widthOfGlyph(glyph)
            });
        }
        return [
            encoded,
            positions
        ];
    }
    widthOfString(string, size) {
        const glyphs = this.font.glyphsForString(`${string}`);
        const advances = this.font.advancesForGlyphs(glyphs);
        let width = 0;
        for (let advance of advances)width += advance;
        const scale = size / 1000;
        return width * scale;
    }
}
const $6c341d77d66c320e$var$toHex = function(num) {
    return `0000${num.toString(16)}`.slice(-4);
};
class $6c341d77d66c320e$var$EmbeddedFont extends $6c341d77d66c320e$var$PDFFont {
    constructor(document, font, id){
        super();
        this.document = document;
        this.font = font;
        this.id = id;
        this.subset = this.font.createSubset();
        this.unicode = [
            [
                0
            ]
        ];
        this.widths = [
            this.font.getGlyph(0).advanceWidth
        ];
        this.name = this.font.postscriptName;
        this.scale = 1000 / this.font.unitsPerEm;
        this.ascender = this.font.ascent * this.scale;
        this.descender = this.font.descent * this.scale;
        this.xHeight = this.font.xHeight * this.scale;
        this.capHeight = this.font.capHeight * this.scale;
        this.lineGap = this.font.lineGap * this.scale;
        this.bbox = this.font.bbox;
        if (document.options.fontLayoutCache !== false) this.layoutCache = Object.create(null);
    }
    layoutRun(text, features) {
        const run = this.font.layout(text, features);
        for(let i = 0; i < run.positions.length; i++){
            const position = run.positions[i];
            for(let key in position)position[key] *= this.scale;
            position.advanceWidth = run.glyphs[i].advanceWidth * this.scale;
        }
        return run;
    }
    layoutCached(text) {
        if (!this.layoutCache) return this.layoutRun(text);
        let cached;
        if (cached = this.layoutCache[text]) return cached;
        const run = this.layoutRun(text);
        this.layoutCache[text] = run;
        return run;
    }
    layout(text, features, onlyWidth) {
        if (features) return this.layoutRun(text, features);
        let glyphs = onlyWidth ? null : [];
        let positions = onlyWidth ? null : [];
        let advanceWidth = 0;
        let last = 0;
        let index = 0;
        while(index <= text.length){
            var needle;
            if (index === text.length && last < index || (needle = text.charAt(index), [
                ' ',
                '\t'
            ].includes(needle))) {
                const run = this.layoutCached(text.slice(last, ++index));
                if (!onlyWidth) {
                    glyphs = glyphs.concat(run.glyphs);
                    positions = positions.concat(run.positions);
                }
                advanceWidth += run.advanceWidth;
                last = index;
            } else index++;
        }
        return {
            glyphs: glyphs,
            positions: positions,
            advanceWidth: advanceWidth
        };
    }
    encode(text, features) {
        const { glyphs: glyphs, positions: positions } = this.layout(text, features);
        const res = [];
        for(let i = 0; i < glyphs.length; i++){
            const glyph = glyphs[i];
            const gid = this.subset.includeGlyph(glyph.id);
            res.push(`0000${gid.toString(16)}`.slice(-4));
            if (this.widths[gid] == null) this.widths[gid] = glyph.advanceWidth * this.scale;
            if (this.unicode[gid] == null) this.unicode[gid] = glyph.codePoints;
        }
        return [
            res,
            positions
        ];
    }
    widthOfString(string, size, features) {
        const width = this.layout(string, features, true).advanceWidth;
        const scale = size / 1000;
        return width * scale;
    }
    embed() {
        const isCFF = this.subset.cff != null;
        const fontFile = this.document.ref();
        if (isCFF) fontFile.data.Subtype = 'CIDFontType0C';
        fontFile.end(this.subset.encode());
        const familyClass = ((this.font['OS/2'] != null ? this.font['OS/2'].sFamilyClass : undefined) || 0) >> 8;
        let flags = 0;
        if (this.font.post.isFixedPitch) flags |= 1;
        if (1 <= familyClass && familyClass <= 7) flags |= 2;
        flags |= 4;
        if (familyClass === 10) flags |= 8;
        if (this.font.head.macStyle.italic) flags |= 64;
        const tag = [
            1,
            2,
            3,
            4,
            5,
            6
        ].map((i)=>String.fromCharCode((this.id.charCodeAt(i) || 73) + 17)).join('');
        const name = tag + '+' + this.font.postscriptName?.replaceAll(' ', '_');
        const { bbox: bbox } = this.font;
        const descriptor = this.document.ref({
            Type: 'FontDescriptor',
            FontName: name,
            Flags: flags,
            FontBBox: [
                bbox.minX * this.scale,
                bbox.minY * this.scale,
                bbox.maxX * this.scale,
                bbox.maxY * this.scale
            ],
            ItalicAngle: this.font.italicAngle,
            Ascent: this.ascender,
            Descent: this.descender,
            CapHeight: (this.font.capHeight || this.font.ascent) * this.scale,
            XHeight: (this.font.xHeight || 0) * this.scale,
            StemV: 0
        });
        if (isCFF) descriptor.data.FontFile3 = fontFile;
        else descriptor.data.FontFile2 = fontFile;
        if (this.document.subset && this.document.subset === 1) {
            const maxCID = this.widths.length - 1;
            const cidSetBuffer = new Uint8Array(Math.ceil((maxCID + 1) / 8));
            for(let cid = 0; cid <= maxCID; cid++)if (this.widths[cid] != null) cidSetBuffer[Math.floor(cid / 8)] |= 0x80 >> cid % 8;
            const CIDSetRef = this.document.ref();
            CIDSetRef.write(cidSetBuffer);
            CIDSetRef.end();
            descriptor.data.CIDSet = CIDSetRef;
        }
        descriptor.end();
        const descendantFontData = {
            Type: 'Font',
            Subtype: 'CIDFontType0',
            BaseFont: name,
            CIDSystemInfo: {
                Registry: new String('Adobe'),
                Ordering: new String('Identity'),
                Supplement: 0
            },
            FontDescriptor: descriptor,
            W: [
                0,
                this.widths
            ]
        };
        if (!isCFF) {
            descendantFontData.Subtype = 'CIDFontType2';
            descendantFontData.CIDToGIDMap = 'Identity';
        }
        const descendantFont = this.document.ref(descendantFontData);
        descendantFont.end();
        this.dictionary.data = {
            Type: 'Font',
            Subtype: 'Type0',
            BaseFont: name,
            Encoding: 'Identity-H',
            DescendantFonts: [
                descendantFont
            ],
            ToUnicode: this.toUnicodeCmap()
        };
        return this.dictionary.end();
    }
    toUnicodeCmap() {
        const cmap = this.document.ref();
        const entries = [];
        for (let codePoints of this.unicode){
            const encoded = [];
            for (let value of codePoints){
                if (value > 0xffff) {
                    value -= 0x10000;
                    encoded.push($6c341d77d66c320e$var$toHex(value >>> 10 & 0x3ff | 0xd800));
                    value = 0xdc00 | value & 0x3ff;
                }
                encoded.push($6c341d77d66c320e$var$toHex(value));
            }
            entries.push(`<${encoded.join(' ')}>`);
        }
        const chunkSize = 256;
        const chunks = Math.ceil(entries.length / chunkSize);
        const ranges = [];
        for(let i = 0; i < chunks; i++){
            const start = i * chunkSize;
            const end = Math.min((i + 1) * chunkSize, entries.length);
            ranges.push(`<${$6c341d77d66c320e$var$toHex(start)}> <${$6c341d77d66c320e$var$toHex(end - 1)}> [${entries.slice(start, end).join(' ')}]`);
        }
        cmap.end(`\
/CIDInit /ProcSet findresource begin
12 dict begin
begincmap
/CIDSystemInfo <<
  /Registry (Adobe)
  /Ordering (UCS)
  /Supplement 0
>> def
/CMapName /Adobe-Identity-UCS def
/CMapType 2 def
1 begincodespacerange
<0000><ffff>
endcodespacerange
${ranges.length} beginbfrange
${ranges.join('\n')}
endbfrange
endcmap
CMapName currentdict /CMap defineresource pop
end
end\
`);
        return cmap;
    }
}
const $6c341d77d66c320e$var$STANDARD_FONT_NAMES = [
    'Courier',
    'Courier-Bold',
    'Courier-BoldOblique',
    'Courier-Oblique',
    'Helvetica',
    'Helvetica-Bold',
    'Helvetica-BoldOblique',
    'Helvetica-Oblique',
    'Symbol',
    'Times-Bold',
    'Times-BoldItalic',
    'Times-Italic',
    'Times-Roman',
    'ZapfDingbats'
];
const $6c341d77d66c320e$var$STANDARD_FONT_NAME_SET = new Set($6c341d77d66c320e$var$STANDARD_FONT_NAMES);
const $6c341d77d66c320e$var$validateFontData = (fontData, expectedName)=>{
    if (fontData == null || typeof fontData !== 'object' || !$6c341d77d66c320e$var$STANDARD_FONT_NAME_SET.has(fontData.name) || expectedName != null && fontData.name !== expectedName) throw new TypeError('Invalid standard font data.');
};
const $6c341d77d66c320e$var$standardFonts = new Map();
const $6c341d77d66c320e$var$isStandardFont = (name)=>$6c341d77d66c320e$var$STANDARD_FONT_NAME_SET.has(name);
const $6c341d77d66c320e$export$ffca4ad96161f2b1 = (...fontData)=>{
    for (const data of fontData){
        $6c341d77d66c320e$var$validateFontData(data);
        $6c341d77d66c320e$var$standardFonts.set(data.name, data);
    }
};
const $6c341d77d66c320e$var$getStandardFont = (name)=>{
    if (!$6c341d77d66c320e$var$STANDARD_FONT_NAME_SET.has(name)) return null;
    const font = $6c341d77d66c320e$var$standardFonts.get(name);
    if (font == null) throw new Error(`Standard font "${name}" is not registered. ` + 'Call registerStdFonts() before using it.');
    if (typeof font !== 'function') return font;
    const data = font();
    $6c341d77d66c320e$var$validateFontData(data, name);
    $6c341d77d66c320e$var$standardFonts.set(name, data);
    return data;
};
class $6c341d77d66c320e$var$PDFFontFactory {
    static open(document, src, family, id) {
        let font;
        if (typeof src === 'string') {
            if ($6c341d77d66c320e$var$isStandardFont(src)) return new $6c341d77d66c320e$var$StandardFont(document, $6c341d77d66c320e$var$getStandardFont(src), id);
            src = $6c341d77d66c320e$var$fs.readFileSync(src);
        }
        if (src instanceof Uint8Array) font = (0, $6d519e6f260f4e02$export$185802fd694ee1f5)(src, family);
        else if (src instanceof ArrayBuffer) font = (0, $6d519e6f260f4e02$export$185802fd694ee1f5)(new Uint8Array(src), family);
        else if (typeof src?.layout === 'function') font = src;
        if (font == null) throw new Error('Not a supported font format or standard PDF font.');
        return new $6c341d77d66c320e$var$EmbeddedFont(document, font, id);
    }
}
const $6c341d77d66c320e$var$isEqualFont = (font1, font2)=>{
    if (font1.font._tables?.head?.checkSumAdjustment !== font2.font._tables?.head?.checkSumAdjustment) return false;
    if (JSON.stringify(font1.font._tables?.name?.records) !== JSON.stringify(font2.font._tables?.name?.records)) return false;
    return true;
};
var $6c341d77d66c320e$var$FontsMixin = {
    initFonts (defaultFont = 'Helvetica', defaultFontFamily = null, defaultFontSize = 12) {
        this._fontFamilies = {};
        this._fontCount = 0;
        this._fontSource = defaultFont;
        this._fontFamily = defaultFontFamily;
        this._fontSize = defaultFontSize;
        this._font = null;
        this._remSize = defaultFontSize;
        this._registeredFonts = {};
        if (defaultFont) this.font(defaultFont, defaultFontFamily);
    },
    font (src, family, size) {
        let cacheKey, font;
        if (typeof family === 'number') {
            size = family;
            family = null;
        }
        if (typeof src === 'string' && this._registeredFonts[src]) {
            cacheKey = src;
            ({ src: src, family: family } = this._registeredFonts[src]);
        } else {
            cacheKey = family || src;
            if (typeof cacheKey !== 'string') cacheKey = null;
        }
        this._fontSource = src;
        this._fontFamily = family;
        if (size != null) this.fontSize(size);
        if (font = this._fontFamilies[cacheKey]) {
            this._font = font;
            return this;
        }
        const id = `F${++this._fontCount}`;
        this._font = $6c341d77d66c320e$var$PDFFontFactory.open(this, src, family, id);
        if ((font = this._fontFamilies[this._font.name]) && $6c341d77d66c320e$var$isEqualFont(this._font, font)) {
            this._font = font;
            return this;
        }
        if (cacheKey) this._fontFamilies[cacheKey] = this._font;
        if (this._font.name && !this._fontFamilies[this._font.name]) this._fontFamilies[this._font.name] = this._font;
        if (!cacheKey && (!this._font.name || this._fontFamilies[this._font.name] !== this._font)) this._fontFamilies[this._font.id] = this._font;
        return this;
    },
    fontSize (_fontSize) {
        this._fontSize = this.sizeToPoint(_fontSize);
        return this;
    },
    currentLineHeight (includeGap) {
        return this._font.lineHeight(this._fontSize, includeGap);
    },
    registerFont (name, src, family) {
        this._registeredFonts[name] = {
            src: src,
            family: family
        };
        return this;
    },
    sizeToPoint (size, defaultValue = 0, page = this.page, percentageWidth) {
        if (!percentageWidth) percentageWidth = this._fontSize;
        if (typeof defaultValue !== 'number') defaultValue = this.sizeToPoint(defaultValue);
        if (size === undefined) return defaultValue;
        if (typeof size === 'number') return size;
        if (typeof size === 'boolean') return Number(size);
        const match = String(size).match(/((\d+)?(\.\d+)?)(em|in|px|cm|mm|pc|ex|ch|rem|vw|vh|vmin|vmax|%|pt)?/);
        if (!match) throw new Error(`Unsupported size '${size}'`);
        let multiplier;
        switch(match[4]){
            case 'em':
                multiplier = this._fontSize;
                break;
            case 'in':
                multiplier = $6c341d77d66c320e$var$IN_TO_PT;
                break;
            case 'px':
                multiplier = $6c341d77d66c320e$var$PX_TO_IN * $6c341d77d66c320e$var$IN_TO_PT;
                break;
            case 'cm':
                multiplier = $6c341d77d66c320e$var$CM_TO_IN * $6c341d77d66c320e$var$IN_TO_PT;
                break;
            case 'mm':
                multiplier = $6c341d77d66c320e$var$MM_TO_CM * $6c341d77d66c320e$var$CM_TO_IN * $6c341d77d66c320e$var$IN_TO_PT;
                break;
            case 'pc':
                multiplier = $6c341d77d66c320e$var$PC_TO_PT;
                break;
            case 'ex':
                multiplier = this.currentLineHeight();
                break;
            case 'ch':
                multiplier = this.widthOfString('0');
                break;
            case 'rem':
                multiplier = this._remSize;
                break;
            case 'vw':
                multiplier = page.width / 100;
                break;
            case 'vh':
                multiplier = page.height / 100;
                break;
            case 'vmin':
                multiplier = Math.min(page.width, page.height) / 100;
                break;
            case 'vmax':
                multiplier = Math.max(page.width, page.height) / 100;
                break;
            case '%':
                multiplier = percentageWidth / 100;
                break;
            case 'pt':
            default:
                multiplier = 1;
        }
        return multiplier * Number(match[1]);
    }
};
const $6c341d77d66c320e$var$SOFT_HYPHEN = '\u00AD';
const $6c341d77d66c320e$var$HYPHEN = '-';
class $6c341d77d66c320e$export$68c28438b26ae806 extends $6c341d77d66c320e$var$EventEmitter {
    constructor(document, options){
        super();
        this.document = document;
        this.horizontalScaling = options.horizontalScaling || 100;
        this.indent = (options.indent || 0) * this.horizontalScaling / 100;
        this.indentAllLines = options.indentAllLines || false;
        this.characterSpacing = (options.characterSpacing || 0) * this.horizontalScaling / 100;
        this.wordSpacing = (options.wordSpacing === 0) * this.horizontalScaling / 100;
        this.columns = options.columns || 1;
        this.columnGap = (options.columnGap != null ? options.columnGap : 18) * this.horizontalScaling / 100;
        this.lineWidth = (options.width * this.horizontalScaling / 100 - this.columnGap * (this.columns - 1)) / this.columns;
        this.spaceLeft = this.lineWidth;
        this.startX = this.document.x;
        this.startY = this.document.y;
        this.column = 1;
        this.ellipsis = options.ellipsis;
        this.continuedX = 0;
        this.indentApplied = false;
        this.features = options.features;
        if (options.height != null) {
            this.height = options.height;
            this.maxY = $6c341d77d66c320e$var$PDFNumber(this.startY + options.height);
        } else this.maxY = $6c341d77d66c320e$var$PDFNumber(this.document.page.maxY());
        this.on('firstLine', (options)=>{
            const continuation = this.continuedX;
            const indent = continuation || this.indent;
            if (continuation || !this.indentApplied) {
                this.document.x += indent;
                this.lineWidth -= indent;
                this.indentApplied = true;
            }
            if (options.indentAllLines) {
                if (continuation) this.once('line', ()=>{
                    this.document.x -= continuation;
                    this.lineWidth += continuation;
                });
                return;
            }
            this.once('line', ()=>{
                this.document.x -= indent;
                this.lineWidth += indent;
                this.indentApplied = false;
                if (options.continued && !this.continuedX) this.continuedX = this.indent;
                if (!options.continued) this.continuedX = 0;
            });
        });
        this.on('lastLine', (options)=>{
            const { align: align } = options;
            if (align === 'justify') options.align = 'left';
            this.lastLine = true;
            this.once('line', ()=>{
                this.document.y += options.paragraphGap || 0;
                options.align = align;
                return this.lastLine = false;
            });
        });
    }
    wordWidth(word) {
        return $6c341d77d66c320e$var$PDFNumber(this.document.widthOfString(word, this) + this.characterSpacing + this.wordSpacing);
    }
    canFit(word, w) {
        if (word[word.length - 1] != $6c341d77d66c320e$var$SOFT_HYPHEN) return w <= this.spaceLeft;
        return w + this.wordWidth($6c341d77d66c320e$var$HYPHEN) <= this.spaceLeft;
    }
    eachWord(text, fn) {
        let bk;
        const breaker = new (0, $2a7b720d535c27e6$export$2e2bcd8739ae039)(text);
        let last = null;
        const wordWidths = Object.create(null);
        while(bk = breaker.nextBreak()){
            var shouldContinue;
            let word = text.slice((last != null ? last.position : undefined) || 0, bk.position);
            let w = wordWidths[word] != null ? wordWidths[word] : wordWidths[word] = this.wordWidth(word);
            if (w > this.lineWidth + this.continuedX) {
                let lbk = last;
                const fbk = {};
                while(word.length){
                    var l, mightGrow;
                    if (w > this.spaceLeft) {
                        l = Math.ceil(this.spaceLeft / (w / word.length));
                        w = this.wordWidth(word.slice(0, l));
                        mightGrow = w <= this.spaceLeft && l < word.length;
                    } else l = word.length;
                    let mustShrink = w > this.spaceLeft && l > 0;
                    while(mustShrink || mightGrow)if (mustShrink) {
                        w = this.wordWidth(word.slice(0, --l));
                        mustShrink = w > this.spaceLeft && l > 0;
                    } else {
                        w = this.wordWidth(word.slice(0, ++l));
                        mustShrink = w > this.spaceLeft && l > 0;
                        mightGrow = w <= this.spaceLeft && l < word.length;
                    }
                    if (l === 0 && this.spaceLeft === this.lineWidth) l = 1;
                    fbk.required = bk.required || l < word.length;
                    shouldContinue = fn(word.slice(0, l), w, fbk, lbk);
                    lbk = {
                        required: false
                    };
                    word = word.slice(l);
                    w = this.wordWidth(word);
                    if (shouldContinue === false) break;
                }
            } else shouldContinue = fn(word, w, bk, last);
            if (shouldContinue === false) break;
            last = bk;
        }
    }
    wrap(text, options) {
        const { document: document } = this;
        this.horizontalScaling = options.horizontalScaling || 100;
        if (options.indent != null) this.indent = options.indent * this.horizontalScaling / 100;
        if (options.characterSpacing != null) this.characterSpacing = options.characterSpacing * this.horizontalScaling / 100;
        if (options.wordSpacing != null) this.wordSpacing = options.wordSpacing * this.horizontalScaling / 100;
        if (options.ellipsis != null) this.ellipsis = options.ellipsis;
        const nextY = document.y + document.currentLineHeight(true);
        if (document.y > this.maxY || nextY > this.maxY) this.nextSection();
        let buffer = '';
        let textWidth = 0;
        let wc = 0;
        let lc = 0;
        let continueY = document.y;
        const emitLine = ()=>{
            options.textWidth = textWidth + this.wordSpacing * (wc - 1);
            options.wordCount = wc;
            options.lineWidth = this.lineWidth;
            continueY = document.y;
            this.emit('line', buffer, options, this);
            return lc++;
        };
        this.emit('sectionStart', options, this);
        this.eachWord(text, (word, w, bk, last)=>{
            if (last == null || last.required) {
                this.emit('firstLine', options, this);
                this.spaceLeft = this.lineWidth;
            }
            if (this.canFit(word, w)) {
                buffer += word;
                textWidth += w;
                wc++;
            }
            if (bk.required || !this.canFit(word, w)) {
                const lh = document.currentLineHeight(true);
                if (this.height != null && this.ellipsis && $6c341d77d66c320e$var$PDFNumber(document.y + lh * 2) > this.maxY && this.column >= this.columns) {
                    if (this.ellipsis === true) this.ellipsis = "\u2026";
                    buffer = buffer.replace(/\s+$/, '');
                    textWidth = this.wordWidth(buffer + this.ellipsis);
                    while(buffer && textWidth > this.lineWidth){
                        buffer = buffer.slice(0, -1).replace(/\s+$/, '');
                        textWidth = this.wordWidth(buffer + this.ellipsis);
                    }
                    if (textWidth <= this.lineWidth) buffer = buffer + this.ellipsis;
                    textWidth = this.wordWidth(buffer);
                }
                if (bk.required) {
                    if (w > this.spaceLeft) {
                        emitLine();
                        buffer = word;
                        textWidth = w;
                        wc = 1;
                    }
                    this.emit('lastLine', options, this);
                }
                if (buffer[buffer.length - 1] == $6c341d77d66c320e$var$SOFT_HYPHEN) {
                    buffer = buffer.slice(0, -1) + $6c341d77d66c320e$var$HYPHEN;
                    this.spaceLeft -= this.wordWidth($6c341d77d66c320e$var$HYPHEN);
                }
                emitLine();
                if ($6c341d77d66c320e$var$PDFNumber(document.y + lh) > this.maxY) {
                    this.emit('sectionEnd', options, this);
                    const shouldContinue = this.nextSection();
                    if (!shouldContinue) {
                        wc = 0;
                        buffer = '';
                        return false;
                    }
                    this.emit('sectionStart', options, this);
                }
                if (bk.required) {
                    this.spaceLeft = this.lineWidth;
                    buffer = '';
                    textWidth = 0;
                    return wc = 0;
                } else {
                    this.spaceLeft = this.lineWidth - w;
                    buffer = word;
                    textWidth = w;
                    return wc = 1;
                }
            } else return this.spaceLeft -= w;
        });
        if (wc > 0) {
            this.emit('lastLine', options, this);
            emitLine();
        }
        this.emit('sectionEnd', options, this);
        if (options.continued === true) {
            if (lc > 1) this.continuedX = 0;
            this.continuedX += options.textWidth || 0;
            document.y = continueY;
        } else document.x = this.startX;
    }
    nextSection(options) {
        if (++this.column > this.columns) {
            if (this.height != null) return false;
            this.document.continueOnNewPage();
            this.column = 1;
            this.startY = this.document.page.margins.top;
            this.maxY = this.document.page.maxY();
            if (this.indentAllLines) {
                if (this.indentApplied) this.document.x += this.continuedX || this.indent;
            } else this.document.x = this.startX;
            if (this.document._fillColor) this.document.fillColor(...this.document._fillColor);
            this.emit('pageBreak', options, this);
        } else {
            this.document.x += this.lineWidth + this.columnGap;
            this.document.y = this.startY;
            this.emit('columnBreak', options, this);
        }
        return true;
    }
}
const { number: $6c341d77d66c320e$var$number } = $6c341d77d66c320e$var$PDFObject;
function $6c341d77d66c320e$var$formatListLabel(n, listType) {
    if (listType === 'numbered') return `${n}.`;
    var letter = String.fromCharCode((n - 1) % 26 + 65);
    var times = Math.floor((n - 1) / 26 + 1);
    var text = Array(times + 1).join(letter);
    return `${text}.`;
}
var $6c341d77d66c320e$var$TextMixin = {
    initText () {
        this._line = this._line.bind(this);
        this.x = 0;
        this.y = 0;
        this._lineGap = 0;
    },
    lineGap (_lineGap) {
        this._lineGap = _lineGap;
        return this;
    },
    moveDown (lines) {
        if (lines == null) lines = 1;
        this.y += this.currentLineHeight(true) * lines + this._lineGap;
        return this;
    },
    moveUp (lines) {
        if (lines == null) lines = 1;
        this.y -= this.currentLineHeight(true) * lines + this._lineGap;
        return this;
    },
    _text (text, x, y, options, lineCallback) {
        options = this._initOptions(x, y, options);
        text = text == null ? '' : `${text}`;
        if (options.wordSpacing) text = text.replace(/\s{2,}/g, ' ');
        const addStructure = ()=>{
            if (options.structParent) options.structParent.add(this.struct(options.structType || 'P', [
                this.markStructureContent(options.structType || 'P')
            ]));
        };
        if (options.rotation !== 0) {
            this.save();
            this.rotate(-options.rotation, {
                origin: [
                    this.x,
                    this.y
                ]
            });
        }
        if (options.width) {
            let wrapper = this._wrapper;
            if (!wrapper) {
                wrapper = new $6c341d77d66c320e$export$68c28438b26ae806(this, options);
                wrapper.on('line', lineCallback);
                wrapper.on('firstLine', addStructure);
            }
            this._wrapper = options.continued ? wrapper : null;
            this._textOptions = options.continued ? options : null;
            wrapper.wrap(text, options);
        } else for (let line of text.split('\n')){
            addStructure();
            lineCallback(line, options);
        }
        if (options.rotation !== 0) this.restore();
        return this;
    },
    text (text, x, y, options) {
        return this._text(text, x, y, options, this._line);
    },
    widthOfString (string, options = {}) {
        const horizontalScaling = options.horizontalScaling || 100;
        return (this._font.widthOfString(string, this._fontSize, options.features) + (options.characterSpacing || 0) * (string.length - 1)) * horizontalScaling / 100;
    },
    boundsOfString (string, x, y, options) {
        options = this._initOptions(x, y, options);
        ({ x: x, y: y } = this);
        const lineGap = options.lineGap ?? this._lineGap ?? 0;
        const lineHeight = this.currentLineHeight(true) + lineGap;
        let contentWidth = 0;
        string = String(string ?? '');
        if (options.wordSpacing) string = string.replace(/\s{2,}/g, ' ');
        if (options.width) {
            let wrapper = new $6c341d77d66c320e$export$68c28438b26ae806(this, options);
            wrapper.on('line', (text, options)=>{
                this.y += lineHeight;
                text = text.replace(/\n/g, '');
                if (text.length) {
                    let wordSpacing = options.wordSpacing ?? 0;
                    const characterSpacing = options.characterSpacing ?? 0;
                    if (options.width && options.align === 'justify') {
                        const words = text.trim().split(/\s+/);
                        const textWidth = this.widthOfString(text.replace(/\s+/g, ''), options);
                        const spaceWidth = this.widthOfString(' ') + characterSpacing;
                        wordSpacing = Math.max(0, (options.lineWidth - textWidth) / Math.max(1, words.length - 1) - spaceWidth);
                    }
                    contentWidth = Math.max(contentWidth, options.textWidth + wordSpacing * (options.wordCount - 1) + characterSpacing * (text.length - 1));
                }
            });
            wrapper.wrap(string, options);
        } else for (let line of string.split('\n')){
            const lineWidth = this.widthOfString(line, options);
            this.y += lineHeight;
            contentWidth = Math.max(contentWidth, lineWidth);
        }
        let contentHeight = this.y - y;
        if (options.height) contentHeight = Math.min(contentHeight, options.height);
        this.x = x;
        this.y = y;
        if (options.rotation === 0) return {
            x: x,
            y: y,
            width: contentWidth,
            height: contentHeight
        };
        else if (options.rotation === 90) return {
            x: x,
            y: y - contentWidth,
            width: contentHeight,
            height: contentWidth
        };
        else if (options.rotation === 180) return {
            x: x - contentWidth,
            y: y - contentHeight,
            width: contentWidth,
            height: contentHeight
        };
        else if (options.rotation === 270) return {
            x: x - contentHeight,
            y: y,
            width: contentHeight,
            height: contentWidth
        };
        const cos = $6c341d77d66c320e$var$cosine(options.rotation);
        const sin = $6c341d77d66c320e$var$sine(options.rotation);
        const x1 = x;
        const y1 = y;
        const x2 = x + contentWidth * cos;
        const y2 = y - contentWidth * sin;
        const x3 = x + contentWidth * cos + contentHeight * sin;
        const y3 = y - contentWidth * sin + contentHeight * cos;
        const x4 = x + contentHeight * sin;
        const y4 = y + contentHeight * cos;
        const xMin = Math.min(x1, x2, x3, x4);
        const xMax = Math.max(x1, x2, x3, x4);
        const yMin = Math.min(y1, y2, y3, y4);
        const yMax = Math.max(y1, y2, y3, y4);
        return {
            x: xMin,
            y: yMin,
            width: xMax - xMin,
            height: yMax - yMin
        };
    },
    heightOfString (text, options) {
        const { x: x, y: y } = this;
        options = this._initOptions(options);
        options.height = Infinity;
        const lineGap = options.lineGap || this._lineGap || 0;
        this._text(text, this.x, this.y, options, ()=>{
            this.y += this.currentLineHeight(true) + lineGap;
        });
        const height = this.y - y;
        this.x = x;
        this.y = y;
        return height;
    },
    list (list, x, y, options) {
        options = this._initOptions(x, y, options);
        const listType = options.listType || 'bullet';
        const unit = Math.round(this._font.ascender / 1000 * this._fontSize);
        const midLine = unit / 2;
        const r = options.bulletRadius || unit / 3;
        const indent = options.textIndent || (listType === 'bullet' ? r * 5 : unit * 2);
        const itemIndent = options.bulletIndent || (listType === 'bullet' ? r * 8 : unit * 2);
        let level = 1;
        const items = [];
        const levels = [];
        const numbers = [];
        var flatten = function(list) {
            let n = 1;
            for(let i = 0; i < list.length; i++){
                const item = list[i];
                if (Array.isArray(item)) {
                    level++;
                    flatten(item);
                    level--;
                } else {
                    items.push(item);
                    levels.push(level);
                    if (listType !== 'bullet') numbers.push(n++);
                }
            }
        };
        flatten(list);
        const drawListItem = function(listItem, i) {
            const wrapper = new $6c341d77d66c320e$export$68c28438b26ae806(this, options);
            wrapper.on('line', this._line);
            level = 1;
            wrapper.once('firstLine', ()=>{
                let item, itemType, labelType, bodyType;
                if (options.structParent) {
                    if (options.structTypes) [itemType, labelType, bodyType] = options.structTypes;
                    else [itemType, labelType, bodyType] = [
                        'LI',
                        'Lbl',
                        'LBody'
                    ];
                }
                if (itemType) {
                    item = this.struct(itemType);
                    options.structParent.add(item);
                } else if (options.structParent) item = options.structParent;
                let l;
                if ((l = levels[i++]) !== level) {
                    const diff = itemIndent * (l - level);
                    this.x += diff;
                    wrapper.lineWidth -= diff;
                    level = l;
                }
                if (item && (labelType || bodyType)) item.add(this.struct(labelType || bodyType, [
                    this.markStructureContent(labelType || bodyType)
                ]));
                switch(listType){
                    case 'bullet':
                        this.circle(this.x - indent + r, this.y + midLine, r);
                        this.fill();
                        break;
                    case 'numbered':
                    case 'lettered':
                        var text = $6c341d77d66c320e$var$formatListLabel(numbers[i - 1], listType);
                        this._fragment(text, this.x - indent, this.y, options);
                        break;
                }
                if (item && labelType && bodyType) item.add(this.struct(bodyType, [
                    this.markStructureContent(bodyType)
                ]));
                if (item && item !== options.structParent) item.end();
            });
            wrapper.on('sectionStart', ()=>{
                const pos = indent + itemIndent * (level - 1);
                this.x += pos;
                wrapper.lineWidth -= pos;
            });
            wrapper.on('sectionEnd', ()=>{
                const pos = indent + itemIndent * (level - 1);
                this.x -= pos;
                wrapper.lineWidth += pos;
            });
            wrapper.wrap(listItem, options);
        };
        for(let i = 0; i < items.length; i++)drawListItem.call(this, items[i], i);
        return this;
    },
    _initOptions (x = {}, y, options = {}) {
        if (x && typeof x === 'object') {
            options = x;
            x = null;
        }
        const result = Object.assign({}, options);
        if (this._textOptions) for(let key in this._textOptions){
            const val = this._textOptions[key];
            if (key !== 'continued') {
                if (result[key] === undefined) result[key] = val;
            }
        }
        if (x != null) this.x = x;
        if (y != null) this.y = y;
        if (result.lineBreak !== false) {
            if (result.width == null) result.width = this.page.width - this.x - this.page.margins.right;
            result.width = Math.max(result.width, 0);
        }
        if (!result.columns) result.columns = 0;
        if (result.columnGap == null) result.columnGap = 18;
        result.rotation = Number(result.rotation ?? 0) % 360;
        if (result.rotation < 0) result.rotation += 360;
        return result;
    },
    _line (text, options = {}, wrapper) {
        this._fragment(text, this.x, this.y, options);
        if (wrapper) {
            const lineGap = options.lineGap || this._lineGap || 0;
            this.y += this.currentLineHeight(true) + lineGap;
        } else this.x += this.widthOfString(text, options);
    },
    _fragment (text, x, y, options) {
        let dy, encoded, i, positions, textWidth, words;
        text = `${text}`.replace(/\n/g, '');
        if (text.length === 0) return;
        const align = options.align || 'left';
        let wordSpacing = options.wordSpacing || 0;
        const characterSpacing = options.characterSpacing || 0;
        const horizontalScaling = options.horizontalScaling || 100;
        if (options.width) switch(align){
            case 'right':
                textWidth = this.widthOfString(text.replace(/\s+$/, ''), options);
                x += options.lineWidth - textWidth;
                break;
            case 'center':
                x += options.lineWidth / 2 - options.textWidth / 2;
                break;
            case 'justify':
                words = text.trim().split(/\s+/);
                textWidth = this.widthOfString(text.replace(/\s+/g, ''), options);
                var spaceWidth = this.widthOfString(' ') + characterSpacing;
                wordSpacing = Math.max(0, (options.lineWidth - textWidth) / Math.max(1, words.length - 1) - spaceWidth);
                break;
        }
        if (typeof options.baseline === 'number') dy = -options.baseline;
        else {
            switch(options.baseline){
                case 'svg-middle':
                    dy = 0.5 * this._font.xHeight;
                    break;
                case 'middle':
                case 'svg-central':
                    dy = 0.5 * (this._font.descender + this._font.ascender);
                    break;
                case 'bottom':
                case 'ideographic':
                    dy = this._font.descender;
                    break;
                case 'alphabetic':
                    dy = 0;
                    break;
                case 'mathematical':
                    dy = 0.5 * this._font.ascender;
                    break;
                case 'hanging':
                    dy = 0.8 * this._font.ascender;
                    break;
                case 'top':
                    dy = this._font.ascender;
                    break;
                default:
                    dy = this._font.ascender;
            }
            dy = dy / 1000 * this._fontSize;
        }
        const measuredWidth = options.textWidth ?? this.widthOfString(text, options) - characterSpacing * (text.length - 1);
        const measuredWordCount = options.wordCount ?? (text.trim() ? text.trim().split(/\s+/).length : 0);
        const renderedWidth = measuredWidth + wordSpacing * (measuredWordCount - 1) + characterSpacing * (text.length - 1);
        if (options.link != null) {
            const linkOptions = {};
            if (this._currentStructureElement && this._currentStructureElement.dictionary.data.S === 'Link') linkOptions.structParent = this._currentStructureElement;
            this.link(x, y, renderedWidth, this.currentLineHeight(), options.link, linkOptions);
        }
        if (options.goTo != null) this.goTo(x, y, renderedWidth, this.currentLineHeight(), options.goTo);
        if (options.destination != null) this.addNamedDestination(options.destination, 'XYZ', x, y, null);
        if (options.underline) {
            this.save();
            if (!options.stroke) this.strokeColor(...this._fillColor || []);
            const lineWidth = this._fontSize < 10 ? 0.5 : Math.floor(this._fontSize / 10);
            this.lineWidth(lineWidth);
            let lineY = y + this.currentLineHeight() - lineWidth;
            this.moveTo(x, lineY);
            this.lineTo(x + renderedWidth, lineY);
            this.stroke();
            this.restore();
        }
        if (options.strike) {
            this.save();
            if (!options.stroke) this.strokeColor(...this._fillColor || []);
            const lineWidth = this._fontSize < 10 ? 0.5 : Math.floor(this._fontSize / 10);
            this.lineWidth(lineWidth);
            let lineY = y + this.currentLineHeight() / 2;
            this.moveTo(x, lineY);
            this.lineTo(x + renderedWidth, lineY);
            this.stroke();
            this.restore();
        }
        this.save();
        if (options.oblique) {
            let skew;
            if (typeof options.oblique === 'number') skew = -Math.tan(options.oblique * Math.PI / 180);
            else skew = -0.25;
            this.transform(1, 0, 0, 1, x, y);
            this.transform(1, 0, skew, 1, -skew * dy, 0);
            this.transform(1, 0, 0, 1, -x, -y);
        }
        this.transform(1, 0, 0, -1, 0, this.page.height);
        y = this.page.height - y - dy;
        if (this.page.fonts[this._font.id] == null) this.page.fonts[this._font.id] = this._font.ref();
        this.addContent('BT');
        this.addContent(`1 0 0 1 ${$6c341d77d66c320e$var$number(x)} ${$6c341d77d66c320e$var$number(y)} Tm`);
        this.addContent(`/${this._font.id} ${$6c341d77d66c320e$var$number(this._fontSize)} Tf`);
        const mode = options.fill && options.stroke ? 2 : options.stroke ? 1 : 0;
        if (mode) this.addContent(`${mode} Tr`);
        if (characterSpacing) this.addContent(`${$6c341d77d66c320e$var$number(characterSpacing)} Tc`);
        if (horizontalScaling !== 100) this.addContent(`${horizontalScaling} Tz`);
        if (wordSpacing) {
            words = text.trim().split(/\s+/);
            wordSpacing += this.widthOfString(' ') + characterSpacing;
            wordSpacing *= 1000 / this._fontSize;
            encoded = [];
            positions = [];
            for (let word of words){
                const [encodedWord, positionsWord] = this._font.encode(word, options.features);
                encoded = encoded.concat(encodedWord);
                positions = positions.concat(positionsWord);
                const space = {};
                const object = positions[positions.length - 1];
                for(let key in object){
                    const val = object[key];
                    space[key] = val;
                }
                space.xAdvance += wordSpacing;
                positions[positions.length - 1] = space;
            }
        } else [encoded, positions] = this._font.encode(text, options.features);
        const scale = this._fontSize / 1000;
        const commands = [];
        let last = 0;
        let hadOffset = false;
        const addSegment = (cur)=>{
            if (last < cur) {
                const hex = encoded.slice(last, cur).join('');
                const advance = positions[cur - 1].xAdvance - positions[cur - 1].advanceWidth;
                commands.push(`<${hex}> ${$6c341d77d66c320e$var$number(-advance)}`);
            }
            last = cur;
        };
        const flush = (i)=>{
            addSegment(i);
            if (commands.length > 0) {
                this.addContent(`[${commands.join(' ')}] TJ`);
                commands.length = 0;
            }
        };
        for(i = 0; i < positions.length; i++){
            const pos = positions[i];
            if (pos.xOffset || pos.yOffset) {
                flush(i);
                this.addContent(`1 0 0 1 ${$6c341d77d66c320e$var$number(x + pos.xOffset * scale)} ${$6c341d77d66c320e$var$number(y + pos.yOffset * scale)} Tm`);
                flush(i + 1);
                hadOffset = true;
            } else {
                if (hadOffset) {
                    this.addContent(`1 0 0 1 ${$6c341d77d66c320e$var$number(x)} ${$6c341d77d66c320e$var$number(y)} Tm`);
                    hadOffset = false;
                }
                if (pos.xAdvance - pos.advanceWidth !== 0) addSegment(i + 1);
            }
            x += pos.xAdvance * scale;
        }
        flush(i);
        this.addContent('ET');
        this.restore();
    }
};
const $6c341d77d66c320e$var$parseExifOrientation = (data)=>{
    if (!data || data.length < 20) return null;
    let pos = 2;
    while(pos < data.length - 4){
        while(pos < data.length && data[pos] !== 0xff)pos++;
        if (pos >= data.length - 4) return null;
        const marker = $6c341d77d66c320e$var$readUInt16BE(data, pos);
        pos += 2;
        if (marker === 0xffda) return null;
        if (marker >= 0xffd0 && marker <= 0xffd9 || marker === 0xff01) continue;
        if (pos + 2 > data.length) return null;
        const segmentLength = $6c341d77d66c320e$var$readUInt16BE(data, pos);
        if (marker === 0xffe1 && pos + 8 <= data.length) {
            const exifHeader = $6c341d77d66c320e$var$toBinaryString(data.subarray(pos + 2, pos + 8));
            if (exifHeader === 'Exif\x00\x00') {
                const tiffStart = pos + 8;
                if (tiffStart + 8 > data.length) return null;
                const byteOrder = $6c341d77d66c320e$var$toBinaryString(data.subarray(tiffStart, tiffStart + 2));
                const isLittleEndian = byteOrder === 'II';
                if (!isLittleEndian && byteOrder !== 'MM') return null;
                const read16 = isLittleEndian ? (o)=>$6c341d77d66c320e$var$readUInt16LE(data, o) : (o)=>$6c341d77d66c320e$var$readUInt16BE(data, o);
                const read32 = isLittleEndian ? (o)=>$6c341d77d66c320e$var$readUInt32LE(data, o) : (o)=>$6c341d77d66c320e$var$readUInt32BE(data, o);
                if (read16(tiffStart + 2) !== 42) return null;
                const ifdPos = tiffStart + read32(tiffStart + 4);
                if (ifdPos + 2 > data.length) return null;
                const entryCount = read16(ifdPos);
                for(let i = 0; i < entryCount; i++){
                    const entryPos = ifdPos + 2 + i * 12;
                    if (entryPos + 12 > data.length) return null;
                    if (read16(entryPos) === 0x0112) {
                        const value = read16(entryPos + 8);
                        return value >= 1 && value <= 8 ? value : null;
                    }
                }
                return null;
            }
        }
        pos += segmentLength;
    }
    return null;
};
const $6c341d77d66c320e$var$MARKERS = [
    0xffc0,
    0xffc1,
    0xffc2,
    0xffc3,
    0xffc5,
    0xffc6,
    0xffc7,
    0xffc8,
    0xffc9,
    0xffca,
    0xffcb,
    0xffcc,
    0xffcd,
    0xffce,
    0xffcf
];
const $6c341d77d66c320e$var$COLOR_SPACE_MAP = {
    1: 'DeviceGray',
    3: 'DeviceRGB',
    4: 'DeviceCMYK'
};
class $6c341d77d66c320e$var$JPEG {
    constructor(data, label){
        let marker;
        this.data = data;
        this.label = label;
        if ($6c341d77d66c320e$var$readUInt16BE(this.data, 0) !== 0xffd8) throw 'SOI not found in JPEG';
        this.orientation = $6c341d77d66c320e$var$parseExifOrientation(this.data) || 1;
        let pos = 2;
        while(pos < this.data.length){
            while(pos < this.data.length && this.data[pos] !== 0xff)pos++;
            if (pos >= this.data.length) break;
            marker = $6c341d77d66c320e$var$readUInt16BE(this.data, pos);
            pos += 2;
            if ($6c341d77d66c320e$var$MARKERS.includes(marker)) break;
            pos += $6c341d77d66c320e$var$readUInt16BE(this.data, pos);
        }
        if (!$6c341d77d66c320e$var$MARKERS.includes(marker)) throw 'Invalid JPEG.';
        pos += 2;
        this.bits = this.data[pos++];
        this.height = $6c341d77d66c320e$var$readUInt16BE(this.data, pos);
        pos += 2;
        this.width = $6c341d77d66c320e$var$readUInt16BE(this.data, pos);
        pos += 2;
        const channels = this.data[pos];
        this.colorSpace = $6c341d77d66c320e$var$COLOR_SPACE_MAP[channels];
        this.obj = null;
    }
    embed(document) {
        if (this.obj) return;
        this.obj = document.ref({
            Type: 'XObject',
            Subtype: 'Image',
            BitsPerComponent: this.bits,
            Width: this.width,
            Height: this.height,
            ColorSpace: this.colorSpace,
            Filter: 'DCTDecode'
        });
        if (this.colorSpace === 'DeviceCMYK') this.obj.data['Decode'] = [
            1.0,
            0.0,
            1.0,
            0.0,
            1.0,
            0.0,
            1.0,
            0.0
        ];
        this.obj.end(this.data);
        return this.data = null;
    }
}
class $6c341d77d66c320e$var$PNGImage {
    constructor(data, label){
        this.label = label;
        this.image = new (0, $527168479d9b53ce$export$2e2bcd8739ae039)(data);
        this.width = this.image.width;
        this.height = this.image.height;
        this.imgData = this.image.imgData;
        this.obj = null;
    }
    embed(document) {
        this.document = document;
        if (this.obj) return;
        const { image: image, height: height, width: width } = this;
        const hasAlphaChannel = image.hasAlphaChannel;
        const isInterlaced = image.interlaceMethod === 1;
        const obj = this.obj = document.ref({
            Type: 'XObject',
            Subtype: 'Image',
            BitsPerComponent: hasAlphaChannel ? 8 : image.bits,
            Width: width,
            Height: height,
            Filter: 'FlateDecode'
        });
        if (!hasAlphaChannel) {
            const params = document.ref({
                Predictor: isInterlaced ? 1 : 15,
                Colors: image.colors,
                BitsPerComponent: image.bits,
                Columns: width
            });
            obj.data['DecodeParms'] = params;
            params.end();
        }
        if (image.palette.length === 0) obj.data['ColorSpace'] = image.colorSpace;
        else {
            const palette = document.ref();
            palette.end(new Uint8Array(image.palette));
            obj.data['ColorSpace'] = [
                'Indexed',
                'DeviceRGB',
                image.palette.length / 3 - 1,
                palette
            ];
        }
        if (image.transparency.grayscale != null) {
            const val = image.transparency.grayscale;
            obj.data['Mask'] = [
                val,
                val
            ];
        } else if (image.transparency.rgb) {
            const { rgb: rgb } = image.transparency;
            const mask = [];
            for (let x of rgb)mask.push(x, x);
            obj.data['Mask'] = mask;
        } else if (image.transparency.indexed) return this.loadIndexedAlphaChannel();
        else if (hasAlphaChannel) return this.splitAlphaChannel();
        if (isInterlaced && true) return this.decodeData();
        this.finalize();
    }
    finalize() {
        if (this.alphaChannel) {
            const sMask = this.document.ref({
                Type: 'XObject',
                Subtype: 'Image',
                Height: this.height,
                Width: this.width,
                BitsPerComponent: 8,
                Filter: 'FlateDecode',
                ColorSpace: 'DeviceGray',
                Decode: [
                    0,
                    1
                ]
            });
            sMask.end(this.alphaChannel);
            this.obj.data['SMask'] = sMask;
        }
        this.obj.end(this.imgData);
        this.image = null;
        return this.imgData = null;
    }
    splitAlphaChannel() {
        return this.image.decodePixels((pixels)=>{
            let a, p;
            const colorCount = this.image.colors;
            const pixelCount = this.width * this.height;
            const imgData = new Uint8Array(pixelCount * colorCount);
            const alphaChannel = new Uint8Array(pixelCount);
            let i = p = a = 0;
            const len = pixels.length;
            const skipByteCount = this.image.bits === 16 ? 1 : 0;
            while(i < len){
                for(let colorIndex = 0; colorIndex < colorCount; colorIndex++){
                    imgData[p++] = pixels[i++];
                    i += skipByteCount;
                }
                alphaChannel[a++] = pixels[i++];
                i += skipByteCount;
            }
            this.imgData = $6c341d77d66c320e$var$zlib.deflateSync(imgData);
            this.alphaChannel = $6c341d77d66c320e$var$zlib.deflateSync(alphaChannel);
            return this.finalize();
        });
    }
    loadIndexedAlphaChannel() {
        const transparency = this.image.transparency.indexed;
        const isInterlaced = this.image.interlaceMethod === 1;
        return this.image.decodePixels((pixels)=>{
            const alphaChannel = new Uint8Array(this.width * this.height);
            let i = 0;
            for(let j = 0, end = pixels.length; j < end; j++)alphaChannel[i++] = transparency[pixels[j]];
            if (isInterlaced) this.imgData = $6c341d77d66c320e$var$zlib.deflateSync(pixels);
            this.alphaChannel = $6c341d77d66c320e$var$zlib.deflateSync(alphaChannel);
            return this.finalize();
        });
    }
    decodeData() {
        this.image.decodePixels((pixels)=>{
            this.imgData = $6c341d77d66c320e$var$zlib.deflateSync(pixels);
            this.finalize();
        });
    }
}
class $6c341d77d66c320e$var$PDFImage {
    static open(src, label) {
        let data;
        if (src instanceof Uint8Array) data = src;
        else if (src instanceof ArrayBuffer) data = new Uint8Array(src);
        else {
            const match = /^data:.+?;base64,(.*)$/.exec(src);
            if (match) data = $6c341d77d66c320e$var$fromBase64(match[1]);
            else {
                data = $6c341d77d66c320e$var$fs.readFileSync(src);
                if (!data) return;
            }
        }
        if (data[0] === 0xff && data[1] === 0xd8) return new $6c341d77d66c320e$var$JPEG(data, label);
        else if (data[0] === 0x89 && data[1] === 0x50 && data[2] === 0x4e && data[3] === 0x47) return new $6c341d77d66c320e$var$PNGImage(data, label);
        else throw new Error('Unknown image format.');
    }
}
var $6c341d77d66c320e$var$ImagesMixin = {
    initImages () {
        this._imageRegistry = {};
        this._imageCount = 0;
    },
    image (src, x, y, options = {}) {
        let bh, bp, bw, image, ip, left, left1, originX, originY;
        if (typeof x === 'object') {
            options = x;
            x = null;
        }
        const ignoreOrientation = options.ignoreOrientation || options.ignoreOrientation !== false && this.options.ignoreOrientation;
        const inDocumentFlow = typeof y !== 'number';
        x = (left = x != null ? x : options.x) != null ? left : this.x;
        y = (left1 = y != null ? y : options.y) != null ? left1 : this.y;
        if (typeof src === 'string') image = this._imageRegistry[src];
        if (!image) {
            if (src.width && src.height) image = src;
            else image = this.openImage(src);
        }
        if (!image.obj) image.embed(this);
        if (this.page.xobjects[image.label] == null) this.page.xobjects[image.label] = image.obj;
        let { width: width, height: height } = image;
        if (!ignoreOrientation && image.orientation > 4) [width, height] = [
            height,
            width
        ];
        let w = options.width || width;
        let h = options.height || height;
        if (options.width && !options.height) {
            const wp = w / width;
            w = width * wp;
            h = height * wp;
        } else if (options.height && !options.width) {
            const hp = h / height;
            w = width * hp;
            h = height * hp;
        } else if (options.scale) {
            w = width * options.scale;
            h = height * options.scale;
        } else if (options.fit) {
            [bw, bh] = options.fit;
            bp = bw / bh;
            ip = width / height;
            if (ip > bp) {
                w = bw;
                h = bw / ip;
            } else {
                h = bh;
                w = bh * ip;
            }
        } else if (options.cover) {
            [bw, bh] = options.cover;
            bp = bw / bh;
            ip = width / height;
            if (ip > bp) {
                h = bh;
                w = bh * ip;
            } else {
                w = bw;
                h = bw / ip;
            }
        }
        if (options.fit || options.cover) {
            if (options.align === 'center') x = x + bw / 2 - w / 2;
            else if (options.align === 'right') x = x + bw - w;
            if (options.valign === 'center') y = y + bh / 2 - h / 2;
            else if (options.valign === 'bottom') y = y + bh - h;
        }
        let rotateAngle = 0;
        let xTransform = x;
        let yTransform = y;
        let hTransform = h;
        let wTransform = w;
        if (!ignoreOrientation) switch(image.orientation){
            default:
            case 1:
                hTransform = -h;
                yTransform += h;
                break;
            case 2:
                wTransform = -w;
                hTransform = -h;
                xTransform += w;
                yTransform += h;
                break;
            case 3:
                originX = x;
                originY = y;
                hTransform = -h;
                xTransform -= w;
                rotateAngle = 180;
                break;
            case 4:
                break;
            case 5:
                originX = x;
                originY = y;
                wTransform = h;
                hTransform = w;
                yTransform -= hTransform;
                rotateAngle = 90;
                break;
            case 6:
                originX = x;
                originY = y;
                wTransform = h;
                hTransform = -w;
                rotateAngle = 90;
                break;
            case 7:
                originX = x;
                originY = y;
                hTransform = -w;
                wTransform = -h;
                xTransform += h;
                rotateAngle = 90;
                break;
            case 8:
                originX = x;
                originY = y;
                wTransform = h;
                hTransform = -w;
                xTransform -= h;
                yTransform += w;
                rotateAngle = -90;
                break;
        }
        else {
            hTransform = -h;
            yTransform += h;
        }
        if (options.link != null) this.link(x, y, w, h, options.link);
        if (options.goTo != null) this.goTo(x, y, w, h, options.goTo);
        if (options.destination != null) this.addNamedDestination(options.destination, 'XYZ', x, y, null);
        if (inDocumentFlow) this.y += h;
        this.save();
        if (options.opacity != null) this._doOpacity(options.opacity, null);
        if (rotateAngle) this.rotate(rotateAngle, {
            origin: [
                originX,
                originY
            ]
        });
        this.transform(wTransform, 0, 0, hTransform, xTransform, yTransform);
        this.addContent(`/${image.label} Do`);
        this.restore();
        return this;
    },
    openImage (src) {
        let image;
        if (typeof src === 'string') image = this._imageRegistry[src];
        if (!image) {
            image = $6c341d77d66c320e$var$PDFImage.open(src, `I${++this._imageCount}`);
            if (typeof src === 'string') this._imageRegistry[src] = image;
        }
        return image;
    }
};
class $6c341d77d66c320e$var$PDFAnnotationReference {
    constructor(annotationRef){
        this.annotationRef = annotationRef;
    }
}
var $6c341d77d66c320e$var$AnnotationsMixin = {
    annotate (x, y, w, h, options) {
        const { structParent: structParent, color: color, ...annotations } = options;
        annotations.Type = 'Annot';
        annotations.Rect = this._convertRect(x, y, w, h);
        annotations.Border = [
            0,
            0,
            0
        ];
        if (annotations.Subtype === 'Link' && typeof annotations.F === 'undefined') annotations.F = 4;
        if (annotations.Subtype !== 'Link') {
            if (annotations.C == null) annotations.C = this._normalizeColor(color || [
                0,
                0,
                0
            ]);
        }
        if (typeof annotations.Dest === 'string') annotations.Dest = new String(annotations.Dest);
        const ref = this.ref(annotations);
        this.page.annotations.push(ref);
        if (typeof structParent?.add === 'function') {
            const annotRef = new $6c341d77d66c320e$var$PDFAnnotationReference(ref);
            structParent.add(annotRef);
        }
        ref.end();
        return this;
    },
    note (x, y, w, h, contents, options) {
        const annotationOptions = {
            ...options,
            Subtype: 'Text',
            Contents: new String(contents)
        };
        if (annotationOptions.Name == null) annotationOptions.Name = 'Comment';
        if (annotationOptions.color == null) annotationOptions.color = [
            243,
            223,
            92
        ];
        return this.annotate(x, y, w, h, annotationOptions);
    },
    goTo (x, y, w, h, name, options) {
        const annotateOptions = {
            ...options,
            Subtype: 'Link',
            A: this.ref({
                S: 'GoTo',
                D: new String(name)
            })
        };
        annotateOptions.A.end();
        return this.annotate(x, y, w, h, annotateOptions);
    },
    link (x, y, w, h, url, options) {
        const annotateOptions = {
            ...options,
            Subtype: 'Link'
        };
        if (typeof url === 'number') {
            const pages = this._root.data.Pages.data;
            if (url >= 0 && url < pages.Kids.length) {
                annotateOptions.A = this.ref({
                    S: 'GoTo',
                    D: [
                        pages.Kids[url],
                        'XYZ',
                        null,
                        null,
                        null
                    ]
                });
                annotateOptions.A.end();
            } else throw new Error(`The document has no page ${url}`);
        } else {
            annotateOptions.A = this.ref({
                S: 'URI',
                URI: new String(url)
            });
            annotateOptions.A.end();
        }
        if (annotateOptions.structParent && !annotateOptions.Contents) annotateOptions.Contents = new String('');
        return this.annotate(x, y, w, h, annotateOptions);
    },
    _markup (x, y, w, h, options) {
        const [x1, y1, x2, y2] = this._convertRect(x, y, w, h);
        return this.annotate(x, y, w, h, {
            ...options,
            QuadPoints: [
                x1,
                y2,
                x2,
                y2,
                x1,
                y1,
                x2,
                y1
            ],
            Contents: new String()
        });
    },
    highlight (x, y, w, h, options) {
        const annotationOptions = {
            ...options,
            Subtype: 'Highlight'
        };
        if (annotationOptions.color == null) annotationOptions.color = [
            241,
            238,
            148
        ];
        return this._markup(x, y, w, h, annotationOptions);
    },
    underline (x, y, w, h, options) {
        const annotationOptions = {
            ...options,
            Subtype: 'Underline'
        };
        return this._markup(x, y, w, h, annotationOptions);
    },
    strike (x, y, w, h, options) {
        const annotationOptions = {
            ...options,
            Subtype: 'StrikeOut'
        };
        return this._markup(x, y, w, h, annotationOptions);
    },
    lineAnnotation (x1, y1, x2, y2, options) {
        const annotationOptions = {
            ...options,
            Subtype: 'Line',
            Contents: new String(),
            L: [
                x1,
                this.page.height - y1,
                x2,
                this.page.height - y2
            ]
        };
        return this.annotate(x1, y1, x2, y2, annotationOptions);
    },
    rectAnnotation (x, y, w, h, options) {
        const annotationOptions = {
            ...options,
            Subtype: 'Square',
            Contents: new String()
        };
        return this.annotate(x, y, w, h, annotationOptions);
    },
    ellipseAnnotation (x, y, w, h, options) {
        const annotationOptions = {
            ...options,
            Subtype: 'Circle',
            Contents: new String()
        };
        return this.annotate(x, y, w, h, annotationOptions);
    },
    textAnnotation (x, y, w, h, text, options) {
        const annotationOptions = {
            ...options,
            Subtype: 'FreeText',
            Contents: new String(text),
            DA: new String()
        };
        return this.annotate(x, y, w, h, annotationOptions);
    },
    fileAnnotation (x, y, w, h, file = {}, options) {
        const filespec = this.file(file.src, Object.assign({
            hidden: true
        }, file));
        const annotationOptions = {
            ...options,
            Subtype: 'FileAttachment',
            FS: filespec
        };
        if (annotationOptions.Contents) annotationOptions.Contents = new String(annotationOptions.Contents);
        else if (filespec.data.Desc) annotationOptions.Contents = new String(filespec.data.Desc);
        return this.annotate(x, y, w, h, annotationOptions);
    },
    _convertRect (x1, y1, w, h) {
        let y2 = y1;
        y1 += h;
        let x2 = x1 + w;
        const [m0, m1, m2, m3, m4, m5] = this._ctm;
        x1 = m0 * x1 + m2 * y1 + m4;
        y1 = m1 * x1 + m3 * y1 + m5;
        x2 = m0 * x2 + m2 * y2 + m4;
        y2 = m1 * x2 + m3 * y2 + m5;
        return [
            x1,
            y1,
            x2,
            y2
        ];
    }
};
const $6c341d77d66c320e$var$DEFAULT_OPTIONS = {
    top: 0,
    left: 0,
    zoom: 0,
    fit: true,
    pageNumber: null,
    expanded: false
};
class $6c341d77d66c320e$var$PDFOutline {
    constructor(document, parent, title, dest, options = $6c341d77d66c320e$var$DEFAULT_OPTIONS){
        this.document = document;
        this.options = options;
        this.outlineData = {};
        if (dest !== null) {
            const destWidth = dest.data.MediaBox[2];
            const destHeight = dest.data.MediaBox[3];
            const top = destHeight - (options.top || 0);
            const left = destWidth - (options.left || 0);
            const zoom = options.zoom || 0;
            this.outlineData['Dest'] = options.fit ? [
                dest,
                'Fit'
            ] : [
                dest,
                'XYZ',
                left,
                top,
                zoom
            ];
        }
        if (parent !== null) this.outlineData['Parent'] = parent;
        if (title !== null) this.outlineData['Title'] = new String(title);
        this.dictionary = this.document.ref(this.outlineData);
        this.children = [];
    }
    addItem(title, options = $6c341d77d66c320e$var$DEFAULT_OPTIONS) {
        const pages = this.document._root.data.Pages.data.Kids;
        const dest = options.pageNumber != null ? pages[options.pageNumber] : this.document.page.dictionary;
        const result = new $6c341d77d66c320e$var$PDFOutline(this.document, this.dictionary, title, dest, options);
        this.children.push(result);
        return result;
    }
    endOutline() {
        if (this.children.length > 0) {
            if (this.options.expanded) this.outlineData.Count = this.children.length;
            const first = this.children[0], last = this.children[this.children.length - 1];
            this.outlineData.First = first.dictionary;
            this.outlineData.Last = last.dictionary;
            for(let i = 0, len = this.children.length; i < len; i++){
                const child = this.children[i];
                if (i > 0) child.outlineData.Prev = this.children[i - 1].dictionary;
                if (i < this.children.length - 1) child.outlineData.Next = this.children[i + 1].dictionary;
                child.endOutline();
            }
        }
        return this.dictionary.end();
    }
}
var $6c341d77d66c320e$var$OutlineMixin = {
    initOutline () {
        this.outline = new $6c341d77d66c320e$var$PDFOutline(this, null, null, null);
    },
    endOutline () {
        this.outline.endOutline();
        if (this.outline.children.length > 0) {
            this._root.data.Outlines = this.outline.dictionary;
            return this._root.data.PageMode = this._root.data.PageMode || 'UseOutlines';
        }
    }
};
class $6c341d77d66c320e$var$PDFStructureContent {
    constructor(pageRef, mcid){
        this.refs = [
            {
                pageRef: pageRef,
                mcid: mcid
            }
        ];
    }
    push(structContent) {
        structContent.refs.forEach((ref)=>this.refs.push(ref));
    }
}
class $6c341d77d66c320e$var$PDFStructureElement {
    constructor(document, type, options = {}, children = null){
        this.document = document;
        this._attached = false;
        this._ended = false;
        this._flushed = false;
        this.dictionary = document.ref({
            S: type
        });
        const data = this.dictionary.data;
        if (Array.isArray(options) || this._isValidChild(options)) {
            children = options;
            options = {};
        }
        if (options.title) data.T = new String(options.title);
        if (options.lang) data.Lang = new String(options.lang);
        if (options.alt) data.Alt = new String(options.alt);
        if (options.expanded) data.E = new String(options.expanded);
        if (options.actual) data.ActualText = new String(options.actual);
        const hasBbox = Array.isArray(options.bbox) && options.bbox.length === 4;
        const hasPlacement = typeof options.placement === 'string';
        if (hasBbox || hasPlacement) {
            const attrs = {
                O: 'Layout'
            };
            attrs.Placement = hasPlacement ? options.placement : 'Block';
            if (hasBbox) {
                const height = document.page.height;
                attrs.BBox = [
                    options.bbox[0],
                    height - options.bbox[3],
                    options.bbox[2],
                    height - options.bbox[1]
                ];
            }
            data.A = attrs;
        }
        if (options.scope) data.A = {
            ...data.A || {},
            O: 'Table',
            Scope: options.scope
        };
        this._children = [];
        if (children) {
            if (!Array.isArray(children)) children = [
                children
            ];
            children.forEach((child)=>this.add(child));
            this.end();
        }
    }
    add(child) {
        if (this._ended) throw new Error(`Cannot add child to already-ended structure element`);
        if (!this._isValidChild(child)) throw new Error(`Invalid structure element child`);
        if (child instanceof $6c341d77d66c320e$var$PDFStructureElement) {
            child.setParent(this.dictionary);
            if (this._attached) child.setAttached();
        }
        if (child instanceof $6c341d77d66c320e$var$PDFStructureContent) this._addContentToParentTree(child);
        if (child instanceof $6c341d77d66c320e$var$PDFAnnotationReference) this._addAnnotationToParentTree(child.annotationRef);
        if (typeof child === 'function' && this._attached) child = this._contentForClosure(child);
        this._children.push(child);
        return this;
    }
    _addContentToParentTree(content) {
        content.refs.forEach(({ pageRef: pageRef, mcid: mcid })=>{
            const pageStructParents = this.document.getStructParentTree().get(pageRef.data.StructParents);
            pageStructParents[mcid] = this.dictionary;
        });
    }
    _addAnnotationToParentTree(annotRef) {
        const parentTreeKey = this.document.createStructParentTreeNextKey();
        annotRef.data.StructParent = parentTreeKey;
        const parentTree = this.document.getStructParentTree();
        parentTree.add(parentTreeKey, this.dictionary);
    }
    setParent(parentRef) {
        if (this.dictionary.data.P) throw new Error(`Structure element added to more than one parent`);
        this.dictionary.data.P = parentRef;
        this._flush();
    }
    setAttached() {
        if (this._attached) return;
        this._children.forEach((child, index)=>{
            if (child instanceof $6c341d77d66c320e$var$PDFStructureElement) child.setAttached();
            if (typeof child === 'function') this._children[index] = this._contentForClosure(child);
        });
        this._attached = true;
        this._flush();
    }
    end() {
        if (this._ended) return;
        this._children.filter((child)=>child instanceof $6c341d77d66c320e$var$PDFStructureElement).forEach((child)=>child.end());
        this._ended = true;
        this._flush();
    }
    _isValidChild(child) {
        return child instanceof $6c341d77d66c320e$var$PDFStructureElement || child instanceof $6c341d77d66c320e$var$PDFStructureContent || child instanceof $6c341d77d66c320e$var$PDFAnnotationReference || typeof child === 'function';
    }
    _contentForClosure(closure) {
        const content = this.document.markStructureContent(this.dictionary.data.S);
        const prevStructElement = this.document._currentStructureElement;
        this.document._currentStructureElement = this;
        const wasEnded = this._ended;
        this._ended = false;
        closure();
        this._ended = wasEnded;
        this.document._currentStructureElement = prevStructElement;
        this.document.endMarkedContent();
        this._addContentToParentTree(content);
        return content;
    }
    _isFlushable() {
        if (!this.dictionary.data.P || !this._ended) return false;
        return this._children.every((child)=>{
            if (typeof child === 'function') return false;
            if (child instanceof $6c341d77d66c320e$var$PDFStructureElement) return child._isFlushable();
            return true;
        });
    }
    _flush() {
        if (this._flushed || !this._isFlushable()) return;
        this.dictionary.data.K = [];
        this._children.forEach((child)=>this._flushChild(child));
        this.dictionary.end();
        this._children = [];
        this.dictionary.data.K = null;
        this._flushed = true;
    }
    _flushChild(child) {
        if (child instanceof $6c341d77d66c320e$var$PDFStructureElement) this.dictionary.data.K.push(child.dictionary);
        if (child instanceof $6c341d77d66c320e$var$PDFStructureContent) child.refs.forEach(({ pageRef: pageRef, mcid: mcid })=>{
            if (!this.dictionary.data.Pg) this.dictionary.data.Pg = pageRef;
            if (this.dictionary.data.Pg === pageRef) this.dictionary.data.K.push(mcid);
            else this.dictionary.data.K.push({
                Type: 'MCR',
                Pg: pageRef,
                MCID: mcid
            });
        });
        if (child instanceof $6c341d77d66c320e$var$PDFAnnotationReference) {
            const pageRef = this.document.page.dictionary;
            const objr = {
                Type: 'OBJR',
                Obj: child.annotationRef,
                Pg: pageRef
            };
            this.dictionary.data.K.push(objr);
        }
    }
}
class $6c341d77d66c320e$var$PDFNumberTree extends $6c341d77d66c320e$var$PDFTree {
    _compareKeys(a, b) {
        return parseInt(a) - parseInt(b);
    }
    _keysName() {
        return 'Nums';
    }
    _dataForKey(k) {
        return parseInt(k);
    }
}
var $6c341d77d66c320e$var$MarkingsMixin = {
    initMarkings (options) {
        this.structChildren = [];
        if (options.tagged) {
            this.getMarkInfoDictionary().data.Marked = true;
            this.getStructTreeRoot();
        }
    },
    markContent (tag, options = null) {
        if (tag === 'Artifact' || options && options.mcid) {
            let toClose = 0;
            this.page.markings.forEach((marking)=>{
                if (toClose || marking.structContent || marking.tag === 'Artifact') toClose++;
            });
            while(toClose--)this.endMarkedContent();
        }
        if (!options) {
            this.page.markings.push({
                tag: tag
            });
            this.addContent(`/${tag} BMC`);
            return this;
        }
        this.page.markings.push({
            tag: tag,
            options: options
        });
        const dictionary = {};
        if (typeof options.mcid !== 'undefined') dictionary.MCID = options.mcid;
        if (tag === 'Artifact') {
            if (typeof options.type === 'string') dictionary.Type = options.type;
            if (Array.isArray(options.bbox)) dictionary.BBox = [
                options.bbox[0],
                this.page.height - options.bbox[3],
                options.bbox[2],
                this.page.height - options.bbox[1]
            ];
            if (Array.isArray(options.attached) && options.attached.every((val)=>typeof val === 'string')) dictionary.Attached = options.attached;
        }
        if (tag === 'Span') {
            if (options.lang) dictionary.Lang = new String(options.lang);
            if (options.alt) dictionary.Alt = new String(options.alt);
            if (options.expanded) dictionary.E = new String(options.expanded);
            if (options.actual) dictionary.ActualText = new String(options.actual);
        }
        this.addContent(`/${tag} ${$6c341d77d66c320e$var$PDFObject.convert(dictionary)} BDC`);
        return this;
    },
    markStructureContent (tag, options = {}) {
        const pageStructParents = this.getStructParentTree().get(this.page.structParentTreeKey);
        const mcid = pageStructParents.length;
        pageStructParents.push(null);
        this.markContent(tag, {
            ...options,
            mcid: mcid
        });
        const structContent = new $6c341d77d66c320e$var$PDFStructureContent(this.page.dictionary, mcid);
        this.page.markings.slice(-1)[0].structContent = structContent;
        return structContent;
    },
    endMarkedContent () {
        this.page.markings.pop();
        this.addContent('EMC');
        if (this._textOptions) {
            delete this._textOptions.link;
            delete this._textOptions.goTo;
            delete this._textOptions.destination;
            delete this._textOptions.underline;
            delete this._textOptions.strike;
        }
        return this;
    },
    struct (type, options = {}, children = null) {
        return new $6c341d77d66c320e$var$PDFStructureElement(this, type, options, children);
    },
    addStructure (structElem) {
        const structTreeRoot = this.getStructTreeRoot();
        structElem.setParent(structTreeRoot);
        structElem.setAttached();
        this.structChildren.push(structElem);
        if (!structTreeRoot.data.K) structTreeRoot.data.K = [];
        structTreeRoot.data.K.push(structElem.dictionary);
        return this;
    },
    initPageMarkings (pageMarkings) {
        pageMarkings.forEach((marking)=>{
            if (marking.structContent) {
                const structContent = marking.structContent;
                const newStructContent = this.markStructureContent(marking.tag, marking.options);
                structContent.push(newStructContent);
                this.page.markings.slice(-1)[0].structContent = structContent;
            } else this.markContent(marking.tag, marking.options);
        });
    },
    endPageMarkings (page) {
        const pageMarkings = page.markings;
        pageMarkings.forEach(()=>page.write('EMC'));
        page.markings = [];
        return pageMarkings;
    },
    getMarkInfoDictionary () {
        if (!this._root.data.MarkInfo) this._root.data.MarkInfo = this.ref({});
        return this._root.data.MarkInfo;
    },
    hasMarkInfoDictionary () {
        return !!this._root.data.MarkInfo;
    },
    getStructTreeRoot () {
        if (!this._root.data.StructTreeRoot) this._root.data.StructTreeRoot = this.ref({
            Type: 'StructTreeRoot',
            ParentTree: new $6c341d77d66c320e$var$PDFNumberTree(),
            ParentTreeNextKey: 0
        });
        return this._root.data.StructTreeRoot;
    },
    getStructParentTree () {
        return this.getStructTreeRoot().data.ParentTree;
    },
    createStructParentTreeNextKey () {
        this.getMarkInfoDictionary();
        const structTreeRoot = this.getStructTreeRoot();
        const key = structTreeRoot.data.ParentTreeNextKey++;
        structTreeRoot.data.ParentTree.add(key, []);
        return key;
    },
    endMarkings () {
        const structTreeRoot = this._root.data.StructTreeRoot;
        if (structTreeRoot) {
            structTreeRoot.end();
            this.structChildren.forEach((structElem)=>structElem.end());
        }
        if (this._root.data.MarkInfo) this._root.data.MarkInfo.end();
    }
};
const $6c341d77d66c320e$var$FIELD_FLAGS = {
    readOnly: 1,
    required: 2,
    noExport: 4,
    multiline: 0x1000,
    password: 0x2000,
    toggleToOffButton: 0x4000,
    radioButton: 0x8000,
    pushButton: 0x10000,
    combo: 0x20000,
    edit: 0x40000,
    sort: 0x80000,
    multiSelect: 0x200000,
    noSpell: 0x400000
};
const $6c341d77d66c320e$var$FIELD_JUSTIFY = {
    left: 0,
    center: 1,
    right: 2
};
const $6c341d77d66c320e$var$VALUE_MAP = {
    value: 'V',
    defaultValue: 'DV'
};
const $6c341d77d66c320e$var$FORMAT_SPECIAL = {
    zip: '0',
    zipPlus4: '1',
    zip4: '1',
    phone: '2',
    ssn: '3'
};
const $6c341d77d66c320e$var$FORMAT_DEFAULT = {
    number: {
        nDec: 0,
        sepComma: false,
        negStyle: 'MinusBlack',
        currency: '',
        currencyPrepend: true
    },
    percent: {
        nDec: 0,
        sepComma: false
    }
};
function $6c341d77d66c320e$var$mapTypeAndFlags(type, userOptions, pdfObject) {
    let flags = userOptions.Ff ?? 0;
    if (type === 'text') pdfObject.FT = 'Tx';
    else if (type === 'pushButton') {
        pdfObject.FT = 'Btn';
        flags |= $6c341d77d66c320e$var$FIELD_FLAGS.pushButton;
    } else if (type === 'radioButton') {
        pdfObject.FT = 'Btn';
        flags |= $6c341d77d66c320e$var$FIELD_FLAGS.radioButton;
    } else if (type === 'checkbox') pdfObject.FT = 'Btn';
    else if (type === 'combo') {
        pdfObject.FT = 'Ch';
        flags |= $6c341d77d66c320e$var$FIELD_FLAGS.combo;
    } else if (type === 'list') pdfObject.FT = 'Ch';
    else if (type) throw new Error(`Invalid form annotation type '${type}'`);
    Object.keys(userOptions).forEach((key)=>{
        if ($6c341d77d66c320e$var$FIELD_FLAGS[key] && userOptions[key]) flags |= $6c341d77d66c320e$var$FIELD_FLAGS[key];
    });
    if (flags !== 0) pdfObject.Ff = flags;
}
function $6c341d77d66c320e$var$mapJustify(userOptions, pdfObject) {
    const result = $6c341d77d66c320e$var$FIELD_JUSTIFY[userOptions.align];
    if (typeof result === 'number' && result !== 0) pdfObject.Q = result;
}
function $6c341d77d66c320e$var$mapStrings(options, pdfObject) {
    if (Array.isArray(options.select) && options.select.length) pdfObject.Opt = options.select.map((s)=>{
        if (typeof s === 'string') return new String(s);
        return s;
    });
    Object.keys($6c341d77d66c320e$var$VALUE_MAP).forEach((key)=>{
        if (key in options) {
            const value = options[key] ?? '';
            pdfObject[$6c341d77d66c320e$var$VALUE_MAP[key]] = typeof value === 'string' ? new String(value) : value;
        }
    });
    if (options.MK?.CA) pdfObject.MK = {
        CA: new String(options.MK.CA)
    };
    if (options.label) {
        pdfObject.MK = options.MK ?? {};
        pdfObject.MK.CA = new String(options.label);
    }
}
function $6c341d77d66c320e$var$mapFormat(options, pdfObject) {
    const f = options.format;
    if (f?.type) {
        let fnKeystroke;
        let fnFormat;
        let params = '';
        if ($6c341d77d66c320e$var$FORMAT_SPECIAL[f.type] !== undefined) {
            fnKeystroke = `AFSpecial_Keystroke`;
            fnFormat = `AFSpecial_Format`;
            params = $6c341d77d66c320e$var$FORMAT_SPECIAL[f.type];
        } else {
            let format = f.type.charAt(0).toUpperCase() + f.type.slice(1);
            fnKeystroke = `AF${format}_Keystroke`;
            fnFormat = `AF${format}_Format`;
            if (f.type === 'date') {
                fnKeystroke += 'Ex';
                fnFormat += 'Ex';
                params = '"' + String(f.param) + '"';
            } else if (f.type === 'time') params = String(f.param);
            else if (f.type === 'number') {
                let p = Object.assign({}, $6c341d77d66c320e$var$FORMAT_DEFAULT.number, f);
                params = String([
                    String(p.nDec),
                    p.sepComma ? '0' : '1',
                    '"' + p.negStyle + '"',
                    'null',
                    '"' + p.currency + '"',
                    String(p.currencyPrepend)
                ].join(','));
            } else if (f.type === 'percent') {
                let p = Object.assign({}, $6c341d77d66c320e$var$FORMAT_DEFAULT.percent, f);
                params = String([
                    String(p.nDec),
                    p.sepComma ? '0' : '1'
                ].join(','));
            }
        }
        pdfObject.AA = options.AA ?? {};
        pdfObject.AA.K = {
            S: 'JavaScript',
            JS: new String(`${fnKeystroke}(${params});`)
        };
        pdfObject.AA.F = {
            S: 'JavaScript',
            JS: new String(`${fnFormat}(${params});`)
        };
    }
}
var $6c341d77d66c320e$var$AcroFormMixin = {
    initForm () {
        if (!this._font) throw new Error('Must set a font before calling initForm method');
        this._acroform = {
            fonts: {},
            defaultFont: this._font.name
        };
        this._acroform.fonts[this._font.id] = this._font.ref();
        let data = {
            Fields: [],
            NeedAppearances: true,
            DA: new String(`/${this._font.id} 0 Tf 0 g`),
            DR: {
                Font: {}
            }
        };
        data.DR.Font[this._font.id] = this._font.ref();
        const AcroForm = this.ref(data);
        this._root.data.AcroForm = AcroForm;
        return this;
    },
    endAcroForm () {
        if (this._root.data.AcroForm) {
            if (!Object.keys(this._acroform.fonts).length && !this._acroform.defaultFont) throw new Error('No fonts specified for PDF form');
            let fontDict = this._root.data.AcroForm.data.DR.Font;
            Object.keys(this._acroform.fonts).forEach((name)=>{
                fontDict[name] = this._acroform.fonts[name];
            });
            this._root.data.AcroForm.data.Fields.forEach((fieldRef)=>{
                this._endChild(fieldRef);
            });
            this._root.data.AcroForm.end();
        }
        return this;
    },
    _endChild (ref) {
        if (Array.isArray(ref.data.Kids)) {
            ref.data.Kids.forEach((childRef)=>{
                this._endChild(childRef);
            });
            ref.end();
        }
        return this;
    },
    formField (name, options = {}) {
        let fieldDict = this._fieldDict(name, null, options);
        let fieldRef = this.ref(fieldDict);
        this._addToParent(fieldRef);
        return fieldRef;
    },
    formAnnotation (name, type, x, y, w, h, options = {}) {
        let fieldDict = this._fieldDict(name, type, options);
        fieldDict.Subtype = 'Widget';
        if (fieldDict.F === undefined) fieldDict.F = 4;
        this.annotate(x, y, w, h, fieldDict);
        let annotRef = this.page.annotations[this.page.annotations.length - 1];
        return this._addToParent(annotRef);
    },
    formText (name, x, y, w, h, options = {}) {
        return this.formAnnotation(name, 'text', x, y, w, h, options);
    },
    formPushButton (name, x, y, w, h, options = {}) {
        return this.formAnnotation(name, 'pushButton', x, y, w, h, options);
    },
    formCombo (name, x, y, w, h, options = {}) {
        return this.formAnnotation(name, 'combo', x, y, w, h, options);
    },
    formList (name, x, y, w, h, options = {}) {
        return this.formAnnotation(name, 'list', x, y, w, h, options);
    },
    formRadioButton (name, x, y, w, h, options = {}) {
        return this.formAnnotation(name, 'radioButton', x, y, w, h, options);
    },
    formCheckbox (name, x, y, w, h, options = {}) {
        return this.formAnnotation(name, 'checkbox', x, y, w, h, options);
    },
    _addToParent (fieldRef) {
        let parent = fieldRef.data.Parent;
        if (parent) {
            if (!parent.data.Kids) parent.data.Kids = [];
            parent.data.Kids.push(fieldRef);
        } else this._root.data.AcroForm.data.Fields.push(fieldRef);
        return this;
    },
    _fieldDict (name, type, options = {}) {
        if (!this._acroform) throw new Error('Call document.initForm() method before adding form elements to document');
        const pdfObject = {};
        $6c341d77d66c320e$var$mapTypeAndFlags(type, options, pdfObject);
        $6c341d77d66c320e$var$mapJustify(options, pdfObject);
        this._mapFont(options, pdfObject);
        $6c341d77d66c320e$var$mapStrings(options, pdfObject);
        this._mapColors(options, pdfObject);
        $6c341d77d66c320e$var$mapFormat(options, pdfObject);
        pdfObject.T = new String(name);
        if (options.parent) pdfObject.Parent = options.parent;
        return pdfObject;
    },
    _mapColors (options, pdfObject) {
        let color = this._normalizeColor(options.backgroundColor);
        if (color) {
            pdfObject.MK = pdfObject.MK ? pdfObject.MK : {};
            pdfObject.MK.BG = color;
        }
        color = this._normalizeColor(options.borderColor);
        if (color) {
            if (!pdfObject.MK) pdfObject.MK = {};
            pdfObject.MK.BC = color;
        }
    },
    _mapFont (options, pdfObject) {
        const { _acroform: _acroform, _font: _font } = this;
        if (_acroform.fonts[_font.id] == null) _acroform.fonts[_font.id] = _font.ref();
        if (_acroform.defaultFont !== _font.name) {
            pdfObject.DR = {
                Font: {}
            };
            const fontSize = options.fontSize || 0;
            pdfObject.DR.Font[_font.id] = _font.ref();
            pdfObject.DA = new String(`/${_font.id} ${fontSize} Tf 0 g`);
        }
    }
};
var $6c341d77d66c320e$var$AttachmentsMixin = {
    file (src, options = {}) {
        options.name = options.name || src;
        options.relationship = options.relationship || 'Unspecified';
        const refBody = {
            Type: 'EmbeddedFile',
            Params: {}
        };
        let data;
        if (!src) throw new Error('No src specified');
        if (src instanceof Uint8Array) data = src;
        else if (src instanceof ArrayBuffer) data = new Uint8Array(src);
        else {
            const match = /^data:(.*?);base64,(.*)$/.exec(src);
            if (match) {
                if (match[1]) refBody.Subtype = $6c341d77d66c320e$var$escapeName(match[1]);
                data = $6c341d77d66c320e$var$fromBase64(match[2]);
            } else {
                data = $6c341d77d66c320e$var$fs.readFileSync(src);
                if (!data) throw new Error(`Could not read contents of file at filepath ${src}`);
                const { birthtime: birthtime, ctime: ctime } = $6c341d77d66c320e$var$fs.statSync(src);
                refBody.Params.CreationDate = birthtime;
                refBody.Params.ModDate = ctime;
            }
        }
        if (options.creationDate instanceof Date) refBody.Params.CreationDate = options.creationDate;
        if (options.modifiedDate instanceof Date) refBody.Params.ModDate = options.modifiedDate;
        if (options.type) refBody.Subtype = $6c341d77d66c320e$var$escapeName(options.type);
        const checksum = $6c341d77d66c320e$var$md5Hex(new Uint8Array(data));
        refBody.Params.CheckSum = new String(checksum);
        refBody.Params.Size = data.byteLength;
        let ref;
        if (!this._fileRegistry) this._fileRegistry = {};
        let file = this._fileRegistry[options.name];
        if (file && $6c341d77d66c320e$var$isEqual(refBody, file)) ref = file.ref;
        else {
            ref = this.ref(refBody);
            ref.end(data);
            this._fileRegistry[options.name] = {
                ...refBody,
                ref: ref
            };
        }
        const fileSpecBody = {
            Type: 'Filespec',
            AFRelationship: options.relationship,
            F: new String(options.name),
            EF: {
                F: ref
            },
            UF: new String(options.name)
        };
        if (options.description) fileSpecBody.Desc = new String(options.description);
        const filespec = this.ref(fileSpecBody);
        filespec.end();
        if (!options.hidden) this.addNamedEmbeddedFile(options.name, filespec);
        if (this._root.data.AF) this._root.data.AF.push(filespec);
        else this._root.data.AF = [
            filespec
        ];
        return filespec;
    }
};
function $6c341d77d66c320e$var$isEqual(a, b) {
    return a.Subtype === b.Subtype && a.Params.CheckSum.toString() === b.Params.CheckSum.toString() && a.Params.Size === b.Params.Size && $6c341d77d66c320e$var$isSameDate(a.Params.CreationDate, b.Params.CreationDate) && $6c341d77d66c320e$var$isSameDate(a.Params.ModDate, b.Params.ModDate);
}
function $6c341d77d66c320e$var$isSameDate(a, b) {
    if (a === undefined || b === undefined) return a === b;
    return a.getTime() === b.getTime();
}
var $ab2a63b5603ac64d$exports = {};
$ab2a63b5603ac64d$exports = import.meta.resolve("eDEmL");


const $6c341d77d66c320e$var$ICC_PROFILE_PATH = new URL($ab2a63b5603ac64d$exports).href;
let $6c341d77d66c320e$var$iccProfile;
var $6c341d77d66c320e$var$PDFA = {
    initPDFA (pSubset) {
        if (pSubset.charAt(pSubset.length - 3) === '-') {
            this.subset_conformance = pSubset.charAt(pSubset.length - 1).toUpperCase();
            this.subset = parseInt(pSubset.charAt(pSubset.length - 2));
        } else {
            this.subset_conformance = 'B';
            this.subset = parseInt(pSubset.charAt(pSubset.length - 1));
        }
    },
    endSubset () {
        this._addPdfaMetadata();
        this._addColorOutputIntent();
    },
    _addColorOutputIntent () {
        if (!$6c341d77d66c320e$var$iccProfile) $6c341d77d66c320e$var$iccProfile = $6c341d77d66c320e$var$fs.readFileSync($6c341d77d66c320e$var$ICC_PROFILE_PATH);
        const colorProfileRef = this.ref({
            Length: $6c341d77d66c320e$var$iccProfile.length,
            N: 3
        });
        colorProfileRef.write($6c341d77d66c320e$var$iccProfile);
        colorProfileRef.end();
        const intentRef = this.ref({
            Type: 'OutputIntent',
            S: 'GTS_PDFA1',
            Info: new String('sRGB IEC61966-2.1'),
            OutputConditionIdentifier: new String('sRGB IEC61966-2.1'),
            DestOutputProfile: colorProfileRef
        });
        intentRef.end();
        this._root.data.OutputIntents = [
            intentRef
        ];
    },
    _getPdfaid () {
        return `
        <rdf:Description xmlns:pdfaid="http://www.aiim.org/pdfa/ns/id/" rdf:about="">
            <pdfaid:part>${this.subset}</pdfaid:part>
            <pdfaid:conformance>${this.subset_conformance}</pdfaid:conformance>
        </rdf:Description>
        `;
    },
    _addPdfaMetadata () {
        this.appendXML(this._getPdfaid());
    }
};
var $6c341d77d66c320e$var$PDFUA = {
    initPDFUA () {
        this.subset = 1;
    },
    endSubset () {
        this._addPdfuaMetadata();
    },
    _addPdfuaMetadata () {
        this.appendXML(this._getPdfuaid());
    },
    _getPdfuaid () {
        return `
        <rdf:Description xmlns:pdfuaid="http://www.aiim.org/pdfua/ns/id/" rdf:about="">
            <pdfuaid:part>${this.subset}</pdfuaid:part>
        </rdf:Description>
        `;
    }
};
var $6c341d77d66c320e$var$SubsetMixin = {
    _importSubset (subset) {
        Object.assign(this, subset);
    },
    initSubset (options) {
        switch(options.subset){
            case 'PDF/A-1':
            case 'PDF/A-1a':
            case 'PDF/A-1b':
            case 'PDF/A-2':
            case 'PDF/A-2a':
            case 'PDF/A-2b':
            case 'PDF/A-3':
            case 'PDF/A-3a':
            case 'PDF/A-3b':
                this._importSubset($6c341d77d66c320e$var$PDFA);
                this.initPDFA(options.subset);
                break;
            case 'PDF/UA':
                this._importSubset($6c341d77d66c320e$var$PDFUA);
                this.initPDFUA();
                break;
        }
    }
};
const $6c341d77d66c320e$var$ROW_FIELDS = [
    'height',
    'minHeight',
    'maxHeight'
];
const $6c341d77d66c320e$var$COLUMN_FIELDS = [
    'width',
    'minWidth',
    'maxWidth'
];
function $6c341d77d66c320e$var$memoize(fn, maxSize) {
    const cache = new Map();
    return function(...args) {
        const key = args[0];
        if (!cache.has(key)) {
            cache.set(key, fn(...args));
            if (cache.size > maxSize) cache.delete(cache.keys().next());
        }
        return cache.get(key);
    };
}
function $6c341d77d66c320e$var$isObject(item) {
    return item && typeof item === 'object' && !Array.isArray(item);
}
function $6c341d77d66c320e$var$deepMerge(target, ...sources) {
    if (!$6c341d77d66c320e$var$isObject(target)) return target;
    target = $6c341d77d66c320e$var$deepClone(target);
    for (const source of sources){
        if ($6c341d77d66c320e$var$isObject(source)) for(const key in source){
            if ($6c341d77d66c320e$var$isObject(source[key])) {
                if (!(key in target)) target[key] = {};
                target[key] = $6c341d77d66c320e$var$deepMerge(target[key], source[key]);
            } else if (source[key] !== undefined) target[key] = $6c341d77d66c320e$var$deepClone(source[key]);
        }
    }
    return target;
}
function $6c341d77d66c320e$var$deepClone(obj) {
    let result = obj;
    if (obj && typeof obj == 'object') {
        result = Array.isArray(obj) ? [] : {};
        for(const key in obj)result[key] = $6c341d77d66c320e$var$deepClone(obj[key]);
    }
    return result;
}
function $6c341d77d66c320e$var$normalizedDefaultStyle(defaultStyleInternal) {
    let defaultStyle = defaultStyleInternal;
    if (typeof defaultStyle !== 'object') defaultStyle = {
        text: defaultStyle
    };
    const defaultRowStyle = Object.fromEntries(Object.entries(defaultStyle).filter(([k])=>$6c341d77d66c320e$var$ROW_FIELDS.includes(k)));
    const defaultColStyle = Object.fromEntries(Object.entries(defaultStyle).filter(([k])=>$6c341d77d66c320e$var$COLUMN_FIELDS.includes(k)));
    defaultStyle.padding = $6c341d77d66c320e$var$normalizeSides(defaultStyle.padding);
    defaultStyle.border = $6c341d77d66c320e$var$normalizeSides(defaultStyle.border);
    defaultStyle.borderColor = $6c341d77d66c320e$var$normalizeSides(defaultStyle.borderColor);
    defaultStyle.align = $6c341d77d66c320e$var$normalizeAlignment(defaultStyle.align);
    return {
        defaultStyle: defaultStyle,
        defaultRowStyle: defaultRowStyle,
        defaultColStyle: defaultColStyle
    };
}
function $6c341d77d66c320e$var$normalizedRowStyle(defaultRowStyle, rowStyleInternal, i) {
    let rowStyle = rowStyleInternal(i);
    if (rowStyle == null || typeof rowStyle !== 'object') rowStyle = {
        height: rowStyle
    };
    rowStyle.padding = $6c341d77d66c320e$var$normalizeSides(rowStyle.padding);
    rowStyle.border = $6c341d77d66c320e$var$normalizeSides(rowStyle.border);
    rowStyle.borderColor = $6c341d77d66c320e$var$normalizeSides(rowStyle.borderColor);
    rowStyle.align = $6c341d77d66c320e$var$normalizeAlignment(rowStyle.align);
    rowStyle = $6c341d77d66c320e$var$deepMerge(defaultRowStyle, rowStyle);
    const document = this.document;
    const page = document.page;
    const contentHeight = page.contentHeight;
    if (rowStyle.height == null || rowStyle.height === 'auto') rowStyle.height = 'auto';
    else rowStyle.height = document.sizeToPoint(rowStyle.height, 0, page, contentHeight);
    rowStyle.minHeight = document.sizeToPoint(rowStyle.minHeight, 0, page, contentHeight);
    rowStyle.maxHeight = document.sizeToPoint(rowStyle.maxHeight, 0, page, contentHeight);
    return rowStyle;
}
function $6c341d77d66c320e$var$normalizedColumnStyle(defaultColStyle, colStyleInternal, i) {
    let colStyle = colStyleInternal(i);
    if (colStyle == null || typeof colStyle !== 'object') colStyle = {
        width: colStyle
    };
    colStyle.padding = $6c341d77d66c320e$var$normalizeSides(colStyle.padding);
    colStyle.border = $6c341d77d66c320e$var$normalizeSides(colStyle.border);
    colStyle.borderColor = $6c341d77d66c320e$var$normalizeSides(colStyle.borderColor);
    colStyle.align = $6c341d77d66c320e$var$normalizeAlignment(colStyle.align);
    colStyle = $6c341d77d66c320e$var$deepMerge(defaultColStyle, colStyle);
    if (colStyle.width == null || colStyle.width === '*') colStyle.width = '*';
    else colStyle.width = this.document.sizeToPoint(colStyle.width, 0, this.document.page, this._maxWidth);
    colStyle.minWidth = this.document.sizeToPoint(colStyle.minWidth, 0, this.document.page, this._maxWidth);
    colStyle.maxWidth = this.document.sizeToPoint(colStyle.maxWidth, 0, this.document.page, this._maxWidth);
    return colStyle;
}
function $6c341d77d66c320e$var$normalizeAlignment(align) {
    return align == null || typeof align === 'string' ? {
        x: align,
        y: align
    } : align;
}
function $6c341d77d66c320e$var$normalizeTable() {
    const doc = this.document;
    const opts = this.opts;
    let index = doc._tableIndex++;
    this._id = new String(opts.id ?? `table-${index}`);
    this._position = {
        x: doc.sizeToPoint(opts.position?.x, doc.x),
        y: doc.sizeToPoint(opts.position?.y, doc.y)
    };
    this._maxWidth = doc.sizeToPoint(opts.maxWidth, doc.page.width - doc.page.margins.right - this._position.x);
    const { defaultStyle: defaultStyle, defaultColStyle: defaultColStyle, defaultRowStyle: defaultRowStyle } = $6c341d77d66c320e$var$normalizedDefaultStyle(opts.defaultStyle);
    this._defaultStyle = defaultStyle;
    let colStyle;
    if (opts.columnStyles) {
        if (Array.isArray(opts.columnStyles)) colStyle = (i)=>opts.columnStyles[i];
        else if (typeof opts.columnStyles === 'function') colStyle = $6c341d77d66c320e$var$memoize((i)=>opts.columnStyles(i), Infinity);
        else if (typeof opts.columnStyles === 'object') colStyle = ()=>opts.columnStyles;
    }
    if (!colStyle) colStyle = ()=>({});
    this._colStyle = $6c341d77d66c320e$var$normalizedColumnStyle.bind(this, defaultColStyle, colStyle);
    let rowStyle;
    if (opts.rowStyles) {
        if (Array.isArray(opts.rowStyles)) rowStyle = (i)=>opts.rowStyles[i];
        else if (typeof opts.rowStyles === 'function') rowStyle = $6c341d77d66c320e$var$memoize((i)=>opts.rowStyles(i), 10);
        else if (typeof opts.rowStyles === 'object') rowStyle = ()=>opts.rowStyles;
    }
    if (!rowStyle) rowStyle = ()=>({});
    this._rowStyle = $6c341d77d66c320e$var$normalizedRowStyle.bind(this, defaultRowStyle, rowStyle);
}
function $6c341d77d66c320e$var$normalizeText(text) {
    if (text != null) text = `${text}`;
    return text;
}
function $6c341d77d66c320e$var$normalizeCell(cell, rowIndex, colIndex) {
    const colStyle = this._colStyle(colIndex);
    let rowStyle = this._rowStyle(rowIndex);
    const font = {};
    for (const level of [
        colStyle.font,
        rowStyle.font,
        cell.font
    ]){
        if (level == null) continue;
        if (level.src != null) {
            font.src = level.src;
            font.family = level.family;
        } else if (level.family != null) font.family = level.family;
        if (level.size != null) font.size = level.size;
    }
    const customFont = Object.values(font).filter((v)=>v != null).length > 0;
    const doc = this.document;
    const rollbackFont = doc._fontSource;
    const rollbackFontSize = doc._fontSize;
    const rollbackFontFamily = doc._fontFamily;
    if (customFont) {
        if (font.src) doc.font(font.src, font.family);
        if (font.size) doc.fontSize(font.size);
        rowStyle = this._rowStyle(rowIndex);
    }
    cell.padding = $6c341d77d66c320e$var$normalizeSides(cell.padding);
    cell.border = $6c341d77d66c320e$var$normalizeSides(cell.border);
    cell.borderColor = $6c341d77d66c320e$var$normalizeSides(cell.borderColor);
    const config = $6c341d77d66c320e$var$deepMerge(this._defaultStyle, colStyle, rowStyle, cell);
    config.rowIndex = rowIndex;
    config.colIndex = colIndex;
    config.font = font ?? {};
    config.customFont = customFont;
    config.text = $6c341d77d66c320e$var$normalizeText(config.text);
    config.rowSpan = config.rowSpan ?? 1;
    config.colSpan = config.colSpan ?? 1;
    config.padding = $6c341d77d66c320e$var$normalizeSides(config.padding, '0.25em', (x)=>doc.sizeToPoint(x, '0.25em'));
    config.border = $6c341d77d66c320e$var$normalizeSides(config.border, 1, (x)=>doc.sizeToPoint(x, 1));
    config.borderColor = $6c341d77d66c320e$var$normalizeSides(config.borderColor, 'black', (x)=>x ?? 'black');
    config.align = $6c341d77d66c320e$var$normalizeAlignment(config.align);
    config.align.x = config.align.x ?? 'left';
    config.align.y = config.align.y ?? 'top';
    config.textStroke = doc.sizeToPoint(config.textStroke, 0);
    config.textStrokeColor = config.textStrokeColor ?? 'black';
    config.textColor = config.textColor ?? 'black';
    config.textOptions = config.textOptions ?? {};
    config.id = new String(config.id ?? `${this._id}-${rowIndex}-${colIndex}`);
    config.type = config.type?.toUpperCase() === 'TH' ? 'TH' : 'TD';
    if (config.scope) {
        config.scope = config.scope.toLowerCase();
        if (config.scope === 'row') config.scope = 'Row';
        else if (config.scope === 'both') config.scope = 'Both';
        else if (config.scope === 'column') config.scope = 'Column';
    }
    if (typeof this.opts.debug === 'boolean') config.debug = this.opts.debug;
    if (customFont) doc.font(rollbackFont, rollbackFontFamily, rollbackFontSize);
    return config;
}
function $6c341d77d66c320e$var$normalizeRow(row, rowIndex) {
    if (!this._cellClaim) this._cellClaim = new Set();
    let colIndex = 0;
    return row.map((cell)=>{
        if (cell == null || typeof cell !== 'object') cell = {
            text: cell
        };
        while(this._cellClaim.has(`${rowIndex},${colIndex}`))colIndex++;
        cell = $6c341d77d66c320e$var$normalizeCell.call(this, cell, rowIndex, colIndex);
        for(let i = 0; i < cell.rowSpan; i++)for(let j = 0; j < cell.colSpan; j++)this._cellClaim.add(`${rowIndex + i},${colIndex + j}`);
        colIndex += cell.colSpan;
        return cell;
    });
}
function $6c341d77d66c320e$var$ensure(row) {
    this._columnWidths = [];
    $6c341d77d66c320e$var$ensureColumnWidths.call(this, row.reduce((a, cell)=>a + cell.colSpan, 0));
    this._rowHeights = [];
    this._rowYPos = [
        this._position.y
    ];
    this._rowBuffer = new Set();
}
function $6c341d77d66c320e$var$ensureColumnWidths(numCols) {
    let starColumnIndexes = [];
    let starMinAcc = 0;
    let unclaimedWidth = this._maxWidth;
    for(let i = 0; i < numCols; i++){
        let col = this._colStyle(i);
        if (col.width === '*') {
            starColumnIndexes[i] = col;
            starMinAcc += col.minWidth;
        } else {
            unclaimedWidth -= col.width;
            this._columnWidths[i] = col.width;
        }
    }
    let starColCount = starColumnIndexes.reduce((x)=>x + 1, 0);
    if (starMinAcc >= unclaimedWidth) starColumnIndexes.forEach((cell, i)=>{
        this._columnWidths[i] = cell.minWidth;
    });
    else if (starColCount > 0) starColumnIndexes.forEach((col, i)=>{
        let starSize = unclaimedWidth / starColCount;
        this._columnWidths[i] = Math.max(starSize, col.minWidth);
        if (col.maxWidth > 0) this._columnWidths[i] = Math.min(this._columnWidths[i], col.maxWidth);
        unclaimedWidth -= this._columnWidths[i];
        starColCount--;
    });
    let tempX = this._position.x;
    this._columnXPos = Array.from(this._columnWidths, (v)=>{
        const t = tempX;
        tempX += v;
        return t;
    });
}
function $6c341d77d66c320e$var$measure(row, rowIndex) {
    row.forEach((cell)=>this._rowBuffer.add(cell));
    if (rowIndex > 0) this._rowYPos[rowIndex] = this._rowYPos[rowIndex - 1] + this._rowHeights[rowIndex - 1];
    const rowStyle = this._rowStyle(rowIndex);
    let toRender = [];
    this._rowBuffer.forEach((cell)=>{
        if (cell.rowIndex + cell.rowSpan - 1 === rowIndex) {
            toRender.push($6c341d77d66c320e$var$measureCell.call(this, cell, rowStyle.height));
            this._rowBuffer.delete(cell);
        }
    });
    let rowHeight = rowStyle.height;
    if (rowHeight === 'auto') rowHeight = toRender.reduce((acc, cell)=>{
        let minHeight = cell.textBounds.height + cell.padding.top + cell.padding.bottom;
        for(let i = 0; i < cell.rowSpan - 1; i++)minHeight -= this._rowHeights[cell.rowIndex + i];
        return Math.max(acc, minHeight);
    }, 0);
    rowHeight = Math.max(rowHeight, rowStyle.minHeight);
    if (rowStyle.maxHeight > 0) rowHeight = Math.min(rowHeight, rowStyle.maxHeight);
    this._rowHeights[rowIndex] = rowHeight;
    let newPage = false;
    if (rowHeight > this.document.page.contentHeight) {
        console.warn(new Error(`Row ${rowIndex} requested more than the safe page height, row has been clamped`).stack.slice(7));
        this._rowHeights[rowIndex] = this.document.page.maxY() - this._rowYPos[rowIndex];
    } else if (this._rowYPos[rowIndex] + rowHeight >= this.document.page.maxY()) {
        this._rowYPos[rowIndex] = this.document.page.margins.top;
        newPage = true;
    }
    return {
        newPage: newPage,
        toRender: toRender.map((cell)=>$6c341d77d66c320e$var$measureCell.call(this, cell, rowHeight))
    };
}
function $6c341d77d66c320e$var$measureCell(cell, rowHeight) {
    let cellWidth = 0;
    for(let i = 0; i < cell.colSpan; i++)cellWidth += this._columnWidths[cell.colIndex + i];
    let cellHeight = rowHeight;
    if (cellHeight === 'auto') cellHeight = this.document.page.contentHeight;
    else for(let i = 0; i < cell.rowSpan - 1; i++)cellHeight += this._rowHeights[cell.rowIndex + i];
    const textAllocatedWidth = cellWidth - cell.padding.left - cell.padding.right;
    const textAllocatedHeight = cellHeight - cell.padding.top - cell.padding.bottom;
    const rotation = cell.textOptions.rotation ?? 0;
    const { width: textMaxWidth, height: textMaxHeight } = $6c341d77d66c320e$var$computeBounds(rotation, textAllocatedWidth, textAllocatedHeight);
    const textOptions = {
        align: cell.align.x,
        ellipsis: true,
        stroke: cell.textStroke > 0,
        fill: true,
        width: textMaxWidth,
        height: textMaxHeight,
        rotation: rotation,
        ...cell.textOptions
    };
    let textBounds = {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    };
    if (cell.text) {
        const rollbackFont = this.document._fontSource;
        const rollbackFontSize = this.document._fontSize;
        const rollbackFontFamily = this.document._fontFamily;
        if (cell.font?.src) this.document.font(cell.font.src, cell.font?.family);
        if (cell.font?.size) this.document.fontSize(cell.font.size);
        const unRotatedTextBounds = this.document.boundsOfString(cell.text, 0, 0, {
            ...textOptions,
            rotation: 0
        });
        textOptions.width = unRotatedTextBounds.width;
        textOptions.height = unRotatedTextBounds.height;
        textBounds = this.document.boundsOfString(cell.text, 0, 0, textOptions);
        this.document.font(rollbackFont, rollbackFontFamily, rollbackFontSize);
    }
    return {
        ...cell,
        textOptions: textOptions,
        x: this._columnXPos[cell.colIndex],
        y: this._rowYPos[cell.rowIndex],
        textX: this._columnXPos[cell.colIndex] + cell.padding.left,
        textY: this._rowYPos[cell.rowIndex] + cell.padding.top,
        width: cellWidth,
        height: cellHeight,
        textAllocatedHeight: textAllocatedHeight,
        textAllocatedWidth: textAllocatedWidth,
        textBounds: textBounds
    };
}
function $6c341d77d66c320e$var$computeBounds(rotation, allocWidth, allocHeight) {
    let textMaxWidth, textMaxHeight;
    const cos = $6c341d77d66c320e$var$cosine(rotation);
    const sin = $6c341d77d66c320e$var$sine(rotation);
    if (rotation === 0 || rotation === 180) {
        textMaxWidth = allocWidth;
        textMaxHeight = allocHeight;
    } else if (rotation === 90 || rotation === 270) {
        textMaxWidth = allocHeight;
        textMaxHeight = allocWidth;
    } else if (rotation < 90 || rotation > 180 && rotation < 270) {
        textMaxWidth = allocWidth / (2 * cos);
        textMaxHeight = allocWidth / (2 * sin);
    } else {
        textMaxHeight = allocWidth / (2 * cos);
        textMaxWidth = allocWidth / (2 * sin);
    }
    const EF = sin * textMaxWidth;
    const FG = cos * textMaxHeight;
    if (EF + FG > allocHeight) {
        const denominator = cos * cos - sin * sin;
        if (rotation === 0 || rotation === 180) {
            textMaxWidth = allocWidth;
            textMaxHeight = allocHeight;
        } else if (rotation === 90 || rotation === 270) {
            textMaxWidth = allocHeight;
            textMaxHeight = allocWidth;
        } else if (rotation < 90 || rotation > 180 && rotation < 270) {
            textMaxWidth = (allocWidth * cos - allocHeight * sin) / denominator;
            textMaxHeight = (allocHeight * cos - allocWidth * sin) / denominator;
        } else {
            textMaxHeight = (allocWidth * cos - allocHeight * sin) / denominator;
            textMaxWidth = (allocHeight * cos - allocWidth * sin) / denominator;
        }
    }
    return {
        width: Math.abs(textMaxWidth),
        height: Math.abs(textMaxHeight)
    };
}
function $6c341d77d66c320e$var$accommodateTable() {
    const structParent = this.opts.structParent;
    if (structParent) {
        this._tableStruct = this.document.struct('Table');
        this._tableStruct.dictionary.data.ID = this._id;
        if (structParent instanceof $6c341d77d66c320e$var$PDFStructureElement) structParent.add(this._tableStruct);
        else if (structParent instanceof $6c341d77d66c320e$export$e7ec69c418f2855a) structParent.addStructure(this._tableStruct);
        this._headerRowLookup = {};
        this._headerColumnLookup = {};
    }
}
function $6c341d77d66c320e$var$accommodateCleanup() {
    if (this._tableStruct) this._tableStruct.end();
}
function $6c341d77d66c320e$var$accessibleRow(row, rowIndex, renderCell) {
    const rowStruct = this.document.struct('TR');
    rowStruct.dictionary.data.ID = new String(`${this._id}-${rowIndex}`);
    this._tableStruct.add(rowStruct);
    row.forEach((cell)=>renderCell(cell, rowStruct));
    rowStruct.end();
}
function $6c341d77d66c320e$var$accessibleCell(cell, rowStruct, callback) {
    const doc = this.document;
    const cellStruct = doc.struct(cell.type, {
        title: cell.title
    });
    cellStruct.dictionary.data.ID = cell.id;
    rowStruct.add(cellStruct);
    const padding = cell.padding;
    const border = cell.border;
    const attributes = {
        O: 'Table',
        Width: cell.width,
        Height: cell.height,
        Padding: [
            padding.top,
            padding.bottom,
            padding.left,
            padding.right
        ],
        RowSpan: cell.rowSpan > 1 ? cell.rowSpan : undefined,
        ColSpan: cell.colSpan > 1 ? cell.colSpan : undefined,
        BorderThickness: [
            border.top,
            border.bottom,
            border.left,
            border.right
        ]
    };
    if (cell.type === 'TH') {
        if (cell.scope === 'Row' || cell.scope === 'Both') {
            for(let i = 0; i < cell.rowSpan; i++){
                if (!this._headerRowLookup[cell.rowIndex + i]) this._headerRowLookup[cell.rowIndex + i] = [];
                this._headerRowLookup[cell.rowIndex + i].push(cell.id);
            }
            attributes.Scope = cell.scope;
        }
        if (cell.scope === 'Column' || cell.scope === 'Both') {
            for(let i = 0; i < cell.colSpan; i++){
                if (!this._headerColumnLookup[cell.colIndex + i]) this._headerColumnLookup[cell.colIndex + i] = [];
                this._headerColumnLookup[cell.colIndex + i].push(cell.id);
            }
            attributes.Scope = cell.scope;
        }
    }
    const Headers = new Set([
        ...Array.from({
            length: cell.colSpan
        }, (_, i)=>this._headerColumnLookup[cell.colIndex + i]).flat(),
        ...Array.from({
            length: cell.rowSpan
        }, (_, i)=>this._headerRowLookup[cell.rowIndex + i]).flat()
    ].filter(Boolean));
    if (Headers.size) attributes.Headers = Array.from(Headers);
    const normalizeColor = doc._normalizeColor;
    if (cell.backgroundColor != null) attributes.BackgroundColor = normalizeColor(cell.backgroundColor);
    const hasBorder = [
        border.top,
        border.bottom,
        border.left,
        border.right
    ];
    if (hasBorder.some((x)=>x)) {
        const borderColor = cell.borderColor;
        attributes.BorderColor = [
            hasBorder[0] ? normalizeColor(borderColor.top) : null,
            hasBorder[1] ? normalizeColor(borderColor.bottom) : null,
            hasBorder[2] ? normalizeColor(borderColor.left) : null,
            hasBorder[3] ? normalizeColor(borderColor.right) : null
        ];
    }
    Object.keys(attributes).forEach((key)=>attributes[key] === undefined && delete attributes[key]);
    cellStruct.dictionary.data.A = doc.ref(attributes);
    cellStruct.add(callback);
    cellStruct.end();
    cellStruct.dictionary.data.A.end();
}
function $6c341d77d66c320e$var$renderRow(row, rowIndex) {
    if (this._tableStruct) $6c341d77d66c320e$var$accessibleRow.call(this, row, rowIndex, $6c341d77d66c320e$var$renderCell.bind(this));
    else row.forEach((cell)=>$6c341d77d66c320e$var$renderCell.call(this, cell));
    return this._rowYPos[rowIndex] + this._rowHeights[rowIndex];
}
function $6c341d77d66c320e$var$renderCell(cell, rowStruct) {
    const cellRenderer = ()=>{
        if (cell.backgroundColor != null) this.document.save().fillColor(cell.backgroundColor).rect(cell.x, cell.y, cell.width, cell.height).fill().restore();
        $6c341d77d66c320e$var$renderBorder.call(this, cell.border, cell.borderColor, cell.x, cell.y, cell.width, cell.height);
        if (cell.debug) {
            this.document.save();
            this.document.dash(1, {
                space: 1
            }).lineWidth(1).strokeOpacity(0.3);
            this.document.rect(cell.x, cell.y, cell.width, cell.height).stroke('green');
            this.document.restore();
        }
        if (cell.text) $6c341d77d66c320e$var$renderCellText.call(this, cell);
    };
    if (rowStruct) $6c341d77d66c320e$var$accessibleCell.call(this, cell, rowStruct, cellRenderer);
    else cellRenderer();
}
function $6c341d77d66c320e$var$renderCellText(cell) {
    const doc = this.document;
    const rollbackFont = doc._fontSource;
    const rollbackFontSize = doc._fontSize;
    const rollbackFontFamily = doc._fontFamily;
    if (cell.customFont) {
        if (cell.font.src) doc.font(cell.font.src, cell.font.family);
        if (cell.font.size) doc.fontSize(cell.font.size);
    }
    const x = cell.textX;
    const y = cell.textY;
    const Ah = cell.textAllocatedHeight;
    const Aw = cell.textAllocatedWidth;
    const Cw = cell.textBounds.width;
    const Ch = cell.textBounds.height;
    const Ox = -cell.textBounds.x;
    const Oy = -cell.textBounds.y;
    const PxScale = cell.align.x === 'right' ? 1 : cell.align.x === 'center' ? 0.5 : 0;
    const Px = (Aw - Cw) * PxScale;
    const PyScale = cell.align.y === 'bottom' ? 1 : cell.align.y === 'center' ? 0.5 : 0;
    const Py = (Ah - Ch) * PyScale;
    const dx = Px + Ox;
    const dy = Py + Oy;
    if (cell.debug) {
        doc.save();
        doc.dash(1, {
            space: 1
        }).lineWidth(1).strokeOpacity(0.3);
        if (cell.text) doc.moveTo(x + Px, y).lineTo(x + Px, y + Ah).moveTo(x + Px + Cw, y).lineTo(x + Px + Cw, y + Ah).stroke('blue').moveTo(x, y + Py).lineTo(x + Aw, y + Py).moveTo(x, y + Py + Ch).lineTo(x + Aw, y + Py + Ch).stroke('green');
        doc.rect(x, y, Aw, Ah).stroke('orange');
        doc.restore();
    }
    doc.save().rect(x, y, Aw, Ah).clip();
    doc.fillColor(cell.textColor).strokeColor(cell.textStrokeColor);
    if (cell.textStroke > 0) doc.lineWidth(cell.textStroke);
    doc.text(cell.text, x + dx, y + dy, cell.textOptions);
    doc.restore();
    if (cell.font) doc.font(rollbackFont, rollbackFontFamily, rollbackFontSize);
}
function $6c341d77d66c320e$var$renderBorder(border, borderColor, x, y, width, height, mask) {
    border = Object.fromEntries(Object.entries(border).map(([k, v])=>[
            k,
            mask && !mask[k] ? 0 : v
        ]));
    const doc = this.document;
    if ([
        border.right,
        border.bottom,
        border.left
    ].every((val)=>val === border.top)) {
        if (border.top > 0) doc.save().lineWidth(border.top).strokeColor(borderColor.top).rect(x, y, width, height).stroke().restore();
    } else {
        if (border.top > 0) doc.save().lineWidth(border.top).moveTo(x, y).strokeColor(borderColor.top).lineTo(x + width, y).stroke().restore();
        if (border.right > 0) doc.save().lineWidth(border.right).moveTo(x + width, y).strokeColor(borderColor.right).lineTo(x + width, y + height).stroke().restore();
        if (border.bottom > 0) doc.save().lineWidth(border.bottom).moveTo(x + width, y + height).strokeColor(borderColor.bottom).lineTo(x, y + height).stroke().restore();
        if (border.left > 0) doc.save().lineWidth(border.left).moveTo(x, y + height).strokeColor(borderColor.left).lineTo(x, y).stroke().restore();
    }
}
class $6c341d77d66c320e$var$PDFTable {
    constructor(document, opts = {}){
        this.document = document;
        this.opts = Object.freeze(opts);
        $6c341d77d66c320e$var$normalizeTable.call(this);
        $6c341d77d66c320e$var$accommodateTable.call(this);
        this._currRowIndex = 0;
        this._ended = false;
        if (opts.data) {
            for (const row of opts.data)this.row(row);
            return this.end();
        }
    }
    row(row, lastRow = false) {
        if (this._ended) throw new Error(`Table was marked as ended on row ${this._currRowIndex}`);
        row = Array.from(row);
        row = $6c341d77d66c320e$var$normalizeRow.call(this, row, this._currRowIndex);
        if (this._currRowIndex === 0) $6c341d77d66c320e$var$ensure.call(this, row);
        const { newPage: newPage, toRender: toRender } = $6c341d77d66c320e$var$measure.call(this, row, this._currRowIndex);
        if (newPage) this.document.continueOnNewPage();
        const yPos = $6c341d77d66c320e$var$renderRow.call(this, toRender, this._currRowIndex);
        this.document.x = this._position.x;
        this.document.y = yPos;
        if (lastRow) return this.end();
        this._currRowIndex++;
        return this;
    }
    end() {
        while(this._rowBuffer?.size)this.row([]);
        this._ended = true;
        $6c341d77d66c320e$var$accommodateCleanup.call(this);
        return this.document;
    }
}
var $6c341d77d66c320e$var$TableMixin = {
    initTables () {
        this._tableIndex = 0;
    },
    table (opts) {
        return new $6c341d77d66c320e$var$PDFTable(this, opts);
    }
};
class $6c341d77d66c320e$var$PDFMetadata {
    constructor(){
        this._metadata = `
        <?xpacket begin="\ufeff" id="W5M0MpCehiHzreSzNTczkc9d"?>
            <x:xmpmeta xmlns:x="adobe:ns:meta/">
                <rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">
        `;
    }
    _closeTags() {
        this._metadata = this._metadata.concat(`
                </rdf:RDF>
            </x:xmpmeta>
        <?xpacket end="w"?>
        `);
    }
    append(xml, newline = true) {
        this._metadata = this._metadata.concat(xml);
        if (newline) this._metadata = this._metadata.concat('\n');
    }
    getXML() {
        return this._metadata;
    }
    getLength() {
        return this._metadata.length;
    }
    end() {
        this._closeTags();
        this._metadata = this._metadata.trim();
    }
}
var $6c341d77d66c320e$var$MetadataMixin = {
    initMetadata () {
        this.metadata = new $6c341d77d66c320e$var$PDFMetadata();
    },
    appendXML (xml, newline = true) {
        this.metadata.append(xml, newline);
    },
    _addInfo () {
        this.appendXML(`
        <rdf:Description rdf:about="" xmlns:xmp="http://ns.adobe.com/xap/1.0/">
            <xmp:CreateDate>${this.info.CreationDate.toISOString().split('.')[0] + 'Z'}</xmp:CreateDate>
            <xmp:CreatorTool>${this.info.Creator}</xmp:CreatorTool>
        </rdf:Description>
        `);
        if (this.info.Title || this.info.Author || this.info.Subject) {
            this.appendXML(`
            <rdf:Description rdf:about="" xmlns:dc="http://purl.org/dc/elements/1.1/">
            `);
            if (this.info.Title) this.appendXML(`
                <dc:title>
                    <rdf:Alt>
                        <rdf:li xml:lang="x-default">${this.info.Title}</rdf:li>
                    </rdf:Alt>
                </dc:title>
                `);
            if (this.info.Author) this.appendXML(`
                <dc:creator>
                    <rdf:Seq>
                        <rdf:li>${this.info.Author}</rdf:li>
                    </rdf:Seq>
                </dc:creator>
                `);
            if (this.info.Subject) this.appendXML(`
                <dc:description>
                    <rdf:Alt>
                        <rdf:li xml:lang="x-default">${this.info.Subject}</rdf:li>
                    </rdf:Alt>
                </dc:description>
                `);
            this.appendXML(`
            </rdf:Description>
            `);
        }
        this.appendXML(`
        <rdf:Description rdf:about="" xmlns:pdf="http://ns.adobe.com/pdf/1.3/">
            <pdf:Producer>${this.info.Producer}</pdf:Producer>`, false);
        if (this.info.Keywords) this.appendXML(`
            <pdf:Keywords>${this.info.Keywords}</pdf:Keywords>`, false);
        this.appendXML(`
        </rdf:Description>
        `);
    },
    endMetadata () {
        this._addInfo();
        this.metadata.end();
        if (this.version != 1.3) {
            this.metadataRef = this.ref({
                length: this.metadata.getLength(),
                Type: 'Metadata',
                Subtype: 'XML'
            });
            this.metadataRef.compress = false;
            this.metadataRef.write(new TextEncoder().encode(this.metadata.getXML()));
            this.metadataRef.end();
            this._root.data.Metadata = this.metadataRef;
        }
    }
};
class $6c341d77d66c320e$export$e7ec69c418f2855a extends $6c341d77d66c320e$var$Readable {
    constructor(options = {}){
        super(options);
        this.options = options;
        switch(options.pdfVersion){
            case '1.4':
                this.version = 1.4;
                break;
            case '1.5':
                this.version = 1.5;
                break;
            case '1.6':
                this.version = 1.6;
                break;
            case '1.7':
            case '1.7ext3':
                this.version = 1.7;
                break;
            default:
                this.version = 1.3;
                break;
        }
        this.compress = this.options.compress != null ? this.options.compress : true;
        this._pageBuffer = [];
        this._pageBufferStart = 0;
        this._offsets = [];
        this._waiting = 0;
        this._ended = false;
        this._offset = 0;
        const Pages = this.ref({
            Type: 'Pages',
            Count: 0,
            Kids: []
        });
        const Names = this.ref({
            Dests: new $6c341d77d66c320e$var$PDFNameTree()
        });
        this._root = this.ref({
            Type: 'Catalog',
            Pages: Pages,
            Names: Names
        });
        if (this.options.lang) this._root.data.Lang = new String(this.options.lang);
        if (this.options.pageLayout) {
            const layout = this.options.pageLayout;
            this._root.data.PageLayout = layout.charAt(0).toUpperCase() + layout.slice(1);
        }
        this.page = null;
        this.initMetadata();
        this.initColor();
        this.initVector();
        this.initFonts(options.font);
        this.initText();
        this.initImages();
        this.initOutline();
        this.initMarkings(options);
        this.initTables();
        this.initSubset(options);
        this.info = {
            Producer: 'PDFKit',
            Creator: 'PDFKit',
            CreationDate: new Date()
        };
        if (this.options.info) for(let key in this.options.info){
            const val = this.options.info[key];
            this.info[key] = val;
        }
        if (this.options.displayTitle) this._root.data.ViewerPreferences = this.ref({
            DisplayDocTitle: true
        });
        this._id = $6c341d77d66c320e$var$PDFSecurity.generateFileID(this.info);
        this._security = $6c341d77d66c320e$var$PDFSecurity.create(this, options);
        this._write(`%PDF-${this.version}`);
        this._write('%\xFF\xFF\xFF\xFF');
        if (this.options.autoFirstPage !== false) this.addPage();
    }
    addPage(options) {
        const documentOptions = this.options;
        if (!documentOptions.bufferPages) this.flushPages();
        const font = options?.font;
        if (font) this.font(font, options.fontFamily);
        const fontSize = options?.fontSize;
        if (fontSize) this.fontSize(fontSize);
        this.page = new $6c341d77d66c320e$var$PDFPage(this, options || documentOptions);
        this._pageBuffer.push(this.page);
        const pages = this._root.data.Pages.data;
        pages.Kids.push(this.page.dictionary);
        pages.Count++;
        this.x = this.page.margins.left;
        this.y = this.page.margins.top;
        this._ctm = [
            1,
            0,
            0,
            1,
            0,
            0
        ];
        this.transform(1, 0, 0, -1, 0, this.page.height);
        this.emit('pageAdded');
        return this;
    }
    continueOnNewPage(options) {
        const pageMarkings = this.endPageMarkings(this.page);
        this.addPage(options ?? this.page._options);
        this.initPageMarkings(pageMarkings);
        return this;
    }
    bufferedPageRange() {
        return {
            start: this._pageBufferStart,
            count: this._pageBuffer.length
        };
    }
    switchToPage(n) {
        let page;
        if (!(page = this._pageBuffer[n - this._pageBufferStart])) throw new Error(`switchToPage(${n}) out of bounds, current buffer covers pages ${this._pageBufferStart} to ${this._pageBufferStart + this._pageBuffer.length - 1}`);
        return this.page = page;
    }
    flushPages() {
        const pages = this._pageBuffer;
        this._pageBuffer = [];
        this._pageBufferStart += pages.length;
        for (let page of pages){
            this.endPageMarkings(page);
            page.end();
        }
    }
    addNamedDestination(name, ...args) {
        if (args.length === 0) args = [
            'XYZ',
            null,
            null,
            null
        ];
        if (args[0] === 'XYZ' && args[2] !== null) args[2] = this.page.height - args[2];
        args.unshift(this.page.dictionary);
        this._root.data.Names.data.Dests.add(name, args);
    }
    addNamedEmbeddedFile(name, ref) {
        if (!ref) throw new Error(`No ref specified for embedded file ${name}`);
        if (!this._root.data.Names.data.EmbeddedFiles) this._root.data.Names.data.EmbeddedFiles = new $6c341d77d66c320e$var$PDFNameTree({
            limits: false
        });
        this._root.data.Names.data.EmbeddedFiles.add(name, ref);
    }
    addNamedJavaScript(name, js) {
        if (!this._root.data.Names.data.JavaScript) this._root.data.Names.data.JavaScript = new $6c341d77d66c320e$var$PDFNameTree();
        let data = {
            JS: new String(js),
            S: 'JavaScript'
        };
        this._root.data.Names.data.JavaScript.add(name, data);
    }
    ref(data) {
        const ref = new $6c341d77d66c320e$var$PDFReference(this, this._offsets.length + 1, data);
        this._offsets.push(null);
        this._waiting++;
        return ref;
    }
    _read() {}
    _write(data) {
        if (!(data instanceof Uint8Array)) data = $6c341d77d66c320e$var$fromBinaryString(data + '\n');
        this.push(data);
        this._offset += data.length;
    }
    addContent(data) {
        this.page.write(data);
        return this;
    }
    _refEnd(ref) {
        this._offsets[ref.id - 1] = ref.offset;
        if (--this._waiting === 0 && this._ended) {
            this._finalize();
            this._ended = false;
        }
    }
    end() {
        this.flushPages();
        this._info = this.ref();
        for(let key in this.info){
            let val = this.info[key];
            if (typeof val === 'string') val = new String(val);
            let entry = this.ref(val);
            entry.end();
            this._info.data[key] = entry;
        }
        this._info.end();
        for(let name in this._fontFamilies){
            const font = this._fontFamilies[name];
            font.finalize();
        }
        this.endOutline();
        this.endMarkings();
        if (this.subset) this.endSubset();
        this.endMetadata();
        this._root.end();
        this._root.data.Pages.end();
        this._root.data.Names.end();
        this.endAcroForm();
        if (this._root.data.ViewerPreferences) this._root.data.ViewerPreferences.end();
        if (this._security) this._security.end();
        if (this._waiting === 0) this._finalize();
        else this._ended = true;
    }
    _finalize() {
        const xRefOffset = this._offset;
        this._write('xref');
        this._write(`0 ${this._offsets.length + 1}`);
        this._write('0000000000 65535 f ');
        for (let offset of this._offsets){
            offset = `0000000000${offset}`.slice(-10);
            this._write(offset + ' 00000 n ');
        }
        const trailer = {
            Size: this._offsets.length + 1,
            Root: this._root,
            Info: this._info,
            ID: [
                this._id,
                this._id
            ]
        };
        if (this._security) trailer.Encrypt = this._security.dictionary;
        this._write('trailer');
        this._write($6c341d77d66c320e$var$PDFObject.convert(trailer));
        this._write('startxref');
        this._write(`${xRefOffset}`);
        this._write('%%EOF');
        this.push(null);
    }
    toString() {
        return '[object PDFDocument]';
    }
}
const $6c341d77d66c320e$var$mixin = (methods)=>{
    Object.assign($6c341d77d66c320e$export$e7ec69c418f2855a.prototype, methods);
};
$6c341d77d66c320e$var$mixin($6c341d77d66c320e$var$MetadataMixin);
$6c341d77d66c320e$var$mixin($6c341d77d66c320e$var$ColorMixin);
$6c341d77d66c320e$var$mixin($6c341d77d66c320e$var$VectorMixin);
$6c341d77d66c320e$var$mixin($6c341d77d66c320e$var$FontsMixin);
$6c341d77d66c320e$var$mixin($6c341d77d66c320e$var$TextMixin);
$6c341d77d66c320e$var$mixin($6c341d77d66c320e$var$ImagesMixin);
$6c341d77d66c320e$var$mixin($6c341d77d66c320e$var$AnnotationsMixin);
$6c341d77d66c320e$var$mixin($6c341d77d66c320e$var$OutlineMixin);
$6c341d77d66c320e$var$mixin($6c341d77d66c320e$var$MarkingsMixin);
$6c341d77d66c320e$var$mixin($6c341d77d66c320e$var$AcroFormMixin);
$6c341d77d66c320e$var$mixin($6c341d77d66c320e$var$AttachmentsMixin);
$6c341d77d66c320e$var$mixin($6c341d77d66c320e$var$SubsetMixin);
$6c341d77d66c320e$var$mixin($6c341d77d66c320e$var$TableMixin);
var $6c341d77d66c320e$var$iccProfileBase64 = "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";
$6c341d77d66c320e$export$abdfd5efb7925f68($6c341d77d66c320e$var$ICC_PROFILE_PATH, $6c341d77d66c320e$var$fromBase64($6c341d77d66c320e$var$iccProfileBase64));


var $9d23502c9c68cad6$export$39b482c5e57630a8 = 'space exclam quotedbl numbersign dollar percent ampersand quotesingle parenleft parenright asterisk plus comma hyphen period slash zero one two three four five six seven eight nine colon semicolon less equal greater question at A B C D E F G H I J K L M N O P Q R S T U V W X Y Z bracketleft backslash bracketright asciicircum underscore grave a b c d e f g h i j k l m n o p q r s t u v w x y z braceleft bar braceright asciitilde Euro quotesinglbase florin quotedblbase ellipsis dagger daggerdbl circumflex perthousand Scaron guilsinglleft OE Zcaron quoteleft quoteright quotedblleft quotedblright bullet endash emdash tilde trademark scaron guilsinglright oe zcaron ydieresis exclamdown cent sterling currency yen brokenbar section dieresis copyright ordfeminine guillemotleft logicalnot registered macron degree plusminus twosuperior threesuperior acute mu paragraph periodcentered cedilla onesuperior ordmasculine guillemotright onequarter onehalf threequarters questiondown Agrave Aacute Acircumflex Atilde Adieresis Aring AE Ccedilla Egrave Eacute Ecircumflex Edieresis Igrave Iacute Icircumflex Idieresis Eth Ntilde Ograve Oacute Ocircumflex Otilde Odieresis multiply Oslash Ugrave Uacute Ucircumflex Udieresis Yacute Thorn germandbls agrave aacute acircumflex atilde adieresis aring ae ccedilla egrave eacute ecircumflex edieresis igrave iacute icircumflex idieresis eth ntilde ograve oacute ocircumflex otilde odieresis divide oslash ugrave uacute ucircumflex udieresis yacute thorn';


var $0fc9b74018d222f3$export$2e2bcd8739ae039 = {
    name: 'Courier',
    bbox: [
        -23,
        -250,
        715,
        805
    ],
    ascender: 629,
    descender: -157,
    xHeight: 426,
    capHeight: 562,
    glyphNames: $9d23502c9c68cad6$export$39b482c5e57630a8,
    glyphWidths: [
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600
    ],
    kernPairs: []
};



var $0e62a4a1dcf5f25a$export$2e2bcd8739ae039 = {
    name: 'Courier-Bold',
    bbox: [
        -113,
        -250,
        749,
        801
    ],
    ascender: 629,
    descender: -157,
    xHeight: 439,
    capHeight: 562,
    glyphNames: $9d23502c9c68cad6$export$39b482c5e57630a8,
    glyphWidths: [
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600
    ],
    kernPairs: []
};



var $a2e17dca7060ac99$export$2e2bcd8739ae039 = {
    name: 'Courier-BoldOblique',
    bbox: [
        -57,
        -250,
        869,
        801
    ],
    ascender: 629,
    descender: -157,
    xHeight: 439,
    capHeight: 562,
    glyphNames: $9d23502c9c68cad6$export$39b482c5e57630a8,
    glyphWidths: [
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600
    ],
    kernPairs: []
};



var $b0cb573fd137196f$export$2e2bcd8739ae039 = {
    name: 'Courier-Oblique',
    bbox: [
        -27,
        -250,
        849,
        805
    ],
    ascender: 629,
    descender: -157,
    xHeight: 426,
    capHeight: 562,
    glyphNames: $9d23502c9c68cad6$export$39b482c5e57630a8,
    glyphWidths: [
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600
    ],
    kernPairs: []
};



var $6d664a6b179e58ef$export$2e2bcd8739ae039 = {
    name: 'Helvetica',
    bbox: [
        -166,
        -225,
        1000,
        931
    ],
    ascender: 718,
    descender: -207,
    xHeight: 523,
    capHeight: 718,
    glyphNames: $9d23502c9c68cad6$export$39b482c5e57630a8,
    glyphWidths: [
        278,
        278,
        355,
        556,
        556,
        889,
        667,
        191,
        333,
        333,
        389,
        584,
        278,
        333,
        278,
        278,
        556,
        556,
        556,
        556,
        556,
        556,
        556,
        556,
        556,
        556,
        278,
        278,
        584,
        584,
        584,
        556,
        1015,
        667,
        667,
        722,
        722,
        667,
        611,
        778,
        722,
        278,
        500,
        667,
        556,
        833,
        722,
        778,
        667,
        778,
        722,
        667,
        611,
        722,
        667,
        944,
        667,
        667,
        611,
        278,
        278,
        278,
        469,
        556,
        333,
        556,
        556,
        500,
        556,
        556,
        278,
        556,
        556,
        222,
        222,
        500,
        222,
        833,
        556,
        556,
        556,
        556,
        333,
        500,
        278,
        556,
        500,
        722,
        500,
        500,
        500,
        334,
        260,
        334,
        584,
        556,
        222,
        556,
        333,
        1000,
        556,
        556,
        333,
        1000,
        667,
        333,
        1000,
        611,
        222,
        222,
        333,
        333,
        350,
        556,
        1000,
        333,
        1000,
        500,
        333,
        944,
        500,
        500,
        333,
        556,
        556,
        556,
        556,
        260,
        556,
        333,
        737,
        370,
        556,
        584,
        737,
        333,
        400,
        584,
        333,
        333,
        333,
        556,
        537,
        278,
        333,
        333,
        365,
        556,
        834,
        834,
        834,
        611,
        667,
        667,
        667,
        667,
        667,
        667,
        1000,
        722,
        667,
        667,
        667,
        667,
        278,
        278,
        278,
        278,
        722,
        722,
        778,
        778,
        778,
        778,
        778,
        584,
        778,
        722,
        722,
        722,
        722,
        667,
        667,
        611,
        556,
        556,
        556,
        556,
        556,
        556,
        889,
        500,
        556,
        556,
        556,
        556,
        278,
        278,
        278,
        278,
        556,
        556,
        556,
        556,
        556,
        556,
        556,
        584,
        611,
        556,
        556,
        556,
        556,
        500,
        556
    ],
    kernPairs: [
        -180,
        [
            10332,
            2
        ],
        -160,
        [
            9569
        ],
        -150,
        [
            8182,
            2
        ],
        -140,
        [
            9517,
            54,
            70,
            1552,
            1074,
            1,
            1,
            51,
            4,
            10,
            105,
            1,
            1,
            1,
            1,
            1,
            3,
            1,
            1,
            1,
            7,
            1,
            1,
            1,
            1,
            2,
            26464,
            1,
            1,
            51,
            4,
            10,
            105,
            1,
            1,
            2,
            1,
            3,
            1,
            1,
            1,
            7,
            1,
            1,
            1,
            1,
            2
        ],
        -125,
        [
            11622,
            2
        ],
        -120,
        [
            7147,
            3206,
            119,
            1,
            1,
            1,
            1,
            1,
            715,
            2,
            19,
            32,
            4,
            10,
            3,
            3,
            2,
            2,
            63,
            1,
            1,
            1,
            1,
            1,
            27,
            1,
            1,
            2,
            1,
            4,
            1,
            1,
            7,
            1,
            1,
            2,
            2,
            1,
            1,
            1,
            1,
            1,
            21339,
            215,
            215,
            215,
            215,
            215
        ],
        -110,
        [
            9512,
            2,
            2774,
            52,
            67,
            1,
            1,
            1,
            1,
            1,
            52,
            1,
            1,
            1,
            26481,
            52,
            67,
            1,
            1,
            1,
            1,
            1,
            52,
            1,
            1,
            1
        ],
        -100,
        [
            2689,
            2,
            428,
            2,
            4031,
            124,
            11871,
            2,
            6878,
            2,
            6708,
            124,
            91,
            124,
            91,
            124,
            91,
            124,
            91,
            124,
            91,
            124,
            11871,
            2
        ],
        -95,
        [
            44732,
            2
        ],
        -90,
        [
            57,
            124,
            7616,
            124
        ],
        -85,
        [
            12302,
            123,
            1,
            1,
            1,
            1,
            2,
            26531,
            123,
            1,
            1,
            1,
            1,
            2,
            5717
        ],
        -80,
        [
            8203,
            119,
            1,
            1,
            1,
            1,
            1,
            3296,
            20,
            36,
            10,
            73,
            1,
            1,
            1,
            1,
            1,
            35,
            1,
            1,
            1,
            7,
            1,
            1,
            1,
            1,
            2,
            19,
            2,
            6663,
            2
        ],
        -70,
        [
            7149,
            603,
            2,
            40,
            1721,
            647,
            124,
            1389,
            20,
            99,
            1,
            1,
            1,
            1,
            1,
            20,
            1,
            1,
            1,
            11613,
            9299,
            215,
            215,
            215,
            215,
            215,
            2798,
            124,
            91,
            124,
            91,
            124,
            91,
            124,
            91,
            124,
            306,
            124,
            1081,
            5704,
            1,
            2,
            32,
            92
        ],
        -60,
        [
            108,
            2902,
            7151,
            1140,
            66,
            5,
            13,
            896,
            1,
            6435,
            2,
            17887,
            215,
            215,
            215,
            215,
            430,
            1045,
            1
        ],
        -57,
        [
            23328,
            216
        ],
        -55,
        [
            44785,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            5,
            27,
            3,
            64,
            1,
            1,
            1,
            1,
            1,
            2,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            2,
            1,
            1,
            1,
            1,
            1,
            2,
            1,
            1,
            1,
            1
        ],
        -50,
        [
            52,
            2,
            5536,
            215,
            1343,
            2,
            122,
            1,
            1,
            1,
            960,
            119,
            1,
            1,
            1,
            1,
            1,
            933,
            42,
            32,
            49,
            1,
            1,
            1,
            1,
            2,
            37,
            701,
            230,
            10,
            113,
            1,
            1,
            1,
            7,
            1,
            1,
            1,
            1,
            2,
            276,
            3,
            124,
            927,
            119,
            1,
            1,
            1,
            1,
            1,
            5660,
            2,
            5859,
            14,
            1,
            34,
            9181,
            2,
            122,
            1,
            1,
            1,
            88,
            2,
            122,
            1,
            1,
            1,
            88,
            2,
            122,
            1,
            1,
            1,
            88,
            2,
            122,
            1,
            1,
            1,
            88,
            2,
            122,
            1,
            1,
            1,
            88,
            2,
            122,
            1,
            1,
            1,
            2669,
            215,
            215,
            215,
            215,
            430
        ],
        -45,
        [
            8252
        ],
        -40,
        [
            55,
            7126,
            1,
            2,
            32,
            92,
            465,
            22,
            97,
            1,
            1,
            1,
            1,
            1,
            1417,
            10,
            113,
            1,
            1,
            1,
            7,
            1,
            1,
            1,
            1,
            2,
            664,
            2,
            38,
            228,
            119,
            1,
            1,
            1,
            1,
            1,
            294,
            124,
            1,
            1,
            1,
            297,
            123,
            1,
            1,
            1,
            1,
            2,
            51,
            2,
            19,
            119,
            1,
            1,
            1,
            1,
            1,
            84,
            1,
            12,
            8,
            123,
            1,
            1,
            1,
            1,
            2,
            52,
            52,
            119,
            1,
            1,
            1,
            1,
            1,
            2188,
            2,
            2793,
            2,
            6866,
            8901,
            1,
            2,
            32,
            92,
            88,
            1,
            2,
            32,
            92,
            88,
            1,
            2,
            32,
            92,
            88,
            1,
            2,
            32,
            92,
            88,
            1,
            2,
            32,
            92,
            88,
            1,
            2,
            32,
            92,
            2594,
            2,
            38,
            175,
            2,
            38,
            175,
            2,
            38,
            175,
            2,
            38,
            175,
            2,
            38,
            390,
            2,
            38,
            175,
            2,
            19,
            119,
            1,
            1,
            1,
            1,
            1,
            70,
            2,
            19,
            119,
            1,
            1,
            1,
            1,
            1,
            70,
            2,
            19,
            119,
            1,
            1,
            1,
            1,
            1,
            70,
            2,
            19,
            119,
            1,
            1,
            1,
            1,
            1,
            4585,
            2,
            213,
            2,
            213,
            2,
            213,
            2,
            213,
            2
        ],
        -35,
        [
            17212,
            2
        ],
        -30,
        [
            110,
            7020,
            4,
            8,
            2,
            36,
            74,
            11,
            1,
            1,
            1,
            1,
            2,
            33,
            1,
            1,
            1,
            230,
            2,
            700,
            10,
            113,
            1,
            1,
            1,
            7,
            1,
            1,
            1,
            1,
            2,
            664,
            2,
            286,
            124,
            1,
            1,
            1,
            92,
            32,
            92,
            487,
            642,
            3,
            1089,
            10,
            6,
            107,
            1,
            1,
            1,
            7,
            1,
            1,
            1,
            1,
            2,
            1,
            1,
            1,
            1,
            2027,
            32,
            92,
            733,
            2,
            139,
            2,
            51,
            4,
            10,
            105,
            1,
            1,
            1,
            1,
            1,
            3,
            1,
            1,
            1,
            7,
            1,
            1,
            1,
            1,
            2,
            311,
            32,
            92,
            1380,
            1,
            32,
            92,
            91,
            32,
            92,
            519,
            1057,
            123,
            1,
            1,
            1,
            6127,
            7473,
            4,
            8,
            2,
            36,
            74,
            11,
            1,
            1,
            1,
            1,
            2,
            33,
            1,
            1,
            1,
            38,
            4,
            8,
            2,
            36,
            74,
            11,
            1,
            1,
            1,
            1,
            2,
            33,
            1,
            1,
            1,
            38,
            4,
            8,
            2,
            36,
            74,
            11,
            1,
            1,
            1,
            1,
            2,
            33,
            1,
            1,
            1,
            38,
            4,
            8,
            2,
            36,
            74,
            11,
            1,
            1,
            1,
            1,
            2,
            33,
            1,
            1,
            1,
            38,
            4,
            8,
            2,
            36,
            74,
            11,
            1,
            1,
            1,
            1,
            2,
            33,
            1,
            1,
            1,
            38,
            4,
            8,
            2,
            36,
            74,
            11,
            1,
            1,
            1,
            1,
            2,
            33,
            1,
            1,
            1,
            230,
            2,
            2406,
            215,
            215,
            215,
            215,
            430,
            1754,
            32,
            92,
            91,
            32,
            92,
            91,
            32,
            92,
            91,
            32,
            92,
            91,
            32,
            92,
            91,
            32,
            92,
            518,
            2,
            213,
            2,
            213,
            2,
            213,
            2,
            1505,
            1,
            32,
            92,
            90,
            1,
            32,
            92,
            90,
            1,
            32,
            92,
            90,
            1,
            32,
            92,
            90,
            1,
            32,
            92
        ],
        -25,
        [
            18555,
            4,
            10,
            105,
            1,
            1,
            1,
            1,
            1,
            3,
            1,
            1,
            1,
            7,
            1,
            1,
            1,
            1,
            2
        ],
        -20,
        [
            7322,
            2,
            1739,
            32,
            20,
            67,
            1,
            1,
            1,
            1,
            1,
            27,
            1,
            1,
            1,
            1,
            1,
            20,
            1,
            1,
            1,
            896,
            119,
            1,
            1,
            1,
            1,
            1,
            535,
            123,
            1,
            1,
            1,
            1,
            2,
            51,
            2,
            227,
            1,
            665,
            42,
            32,
            49,
            1,
            1,
            1,
            1,
            2,
            37,
            290,
            124,
            1609,
            1,
            204,
            9,
            1,
            3,
            32,
            88,
            1,
            1,
            1,
            1,
            77,
            442,
            2,
            32,
            92,
            1146,
            10,
            113,
            1,
            1,
            1,
            7,
            1,
            1,
            1,
            1,
            2,
            523,
            2344,
            4,
            10,
            105,
            1,
            1,
            1,
            1,
            1,
            3,
            1,
            1,
            1,
            7,
            1,
            1,
            1,
            1,
            2,
            3029,
            2,
            3706,
            4,
            10,
            105,
            1,
            1,
            1,
            1,
            1,
            3,
            1,
            1,
            1,
            7,
            1,
            1,
            1,
            1,
            2,
            10360,
            119,
            1,
            1,
            1,
            1,
            1,
            91,
            119,
            1,
            1,
            1,
            1,
            1,
            91,
            119,
            1,
            1,
            1,
            1,
            1,
            91,
            119,
            1,
            1,
            1,
            1,
            1,
            91,
            119,
            1,
            1,
            1,
            1,
            1,
            306,
            119,
            1,
            1,
            1,
            1,
            1,
            991,
            124,
            534,
            1,
            214,
            1,
            214,
            1,
            214,
            1,
            214,
            1,
            214,
            1,
            418,
            227,
            2,
            32,
            92,
            89,
            2,
            32,
            92,
            89,
            2,
            32,
            92,
            89,
            2,
            32,
            92,
            1163,
            2559,
            4,
            10,
            105,
            1,
            1,
            1,
            1,
            1,
            3,
            1,
            1,
            1,
            7,
            1,
            1,
            1,
            1,
            2
        ],
        -15,
        [
            14417,
            430,
            2,
            1795,
            32,
            92,
            91,
            32,
            92,
            88,
            1,
            785,
            2,
            911,
            119,
            1,
            1,
            1,
            1,
            1,
            525,
            10,
            113,
            1,
            1,
            1,
            7,
            1,
            1,
            1,
            1,
            2,
            5609,
            2,
            700,
            10,
            113,
            1,
            1,
            1,
            7,
            1,
            1,
            1,
            1,
            2,
            15069,
            215,
            2,
            213,
            2,
            213,
            2,
            213,
            2,
            1365,
            32,
            92,
            88,
            1,
            214,
            1,
            214,
            1,
            214,
            1,
            214,
            1
        ],
        -10,
        [
            7363,
            124,
            1,
            1,
            1,
            3098,
            124,
            1,
            1,
            1,
            3541,
            1091,
            1293,
            124,
            1,
            1,
            1,
            88,
            124,
            1,
            1,
            1,
            713,
            119,
            1,
            1,
            1,
            1,
            1,
            955,
            10,
            113,
            1,
            1,
            1,
            7,
            1,
            1,
            1,
            1,
            2,
            24387,
            124,
            1,
            1,
            1
        ],
        15,
        [
            17703,
            2,
            1,
            9,
            111,
            1,
            1,
            1,
            10,
            1,
            1,
            1
        ],
        25,
        [
            17707,
            1,
            123
        ],
        30,
        [
            17656,
            1,
            53,
            6,
            3,
            32,
            92
        ],
        40,
        [
            17714
        ],
        50,
        [
            15159
        ],
        60,
        [
            15161
        ]
    ]
};



var $ab4284c8a2bc6ad6$export$2e2bcd8739ae039 = {
    name: 'Helvetica-Bold',
    bbox: [
        -170,
        -228,
        1003,
        962
    ],
    ascender: 718,
    descender: -207,
    xHeight: 532,
    capHeight: 718,
    glyphNames: $9d23502c9c68cad6$export$39b482c5e57630a8,
    glyphWidths: [
        278,
        333,
        474,
        556,
        556,
        889,
        722,
        238,
        333,
        333,
        389,
        584,
        278,
        333,
        278,
        278,
        556,
        556,
        556,
        556,
        556,
        556,
        556,
        556,
        556,
        556,
        333,
        333,
        584,
        584,
        584,
        611,
        975,
        722,
        722,
        722,
        722,
        667,
        611,
        778,
        722,
        278,
        556,
        722,
        611,
        833,
        722,
        778,
        667,
        778,
        722,
        667,
        611,
        722,
        667,
        944,
        667,
        667,
        611,
        333,
        278,
        333,
        584,
        556,
        333,
        556,
        611,
        556,
        611,
        556,
        333,
        611,
        611,
        278,
        278,
        556,
        278,
        889,
        611,
        611,
        611,
        611,
        389,
        556,
        333,
        611,
        556,
        778,
        556,
        556,
        500,
        389,
        280,
        389,
        584,
        556,
        278,
        556,
        500,
        1000,
        556,
        556,
        333,
        1000,
        667,
        333,
        1000,
        611,
        278,
        278,
        500,
        500,
        350,
        556,
        1000,
        333,
        1000,
        556,
        333,
        944,
        500,
        556,
        333,
        556,
        556,
        556,
        556,
        280,
        556,
        333,
        737,
        370,
        556,
        584,
        737,
        333,
        400,
        584,
        333,
        333,
        333,
        611,
        556,
        278,
        333,
        333,
        365,
        556,
        834,
        834,
        834,
        611,
        722,
        722,
        722,
        722,
        722,
        722,
        1000,
        722,
        667,
        667,
        667,
        667,
        278,
        278,
        278,
        278,
        722,
        722,
        778,
        778,
        778,
        778,
        778,
        584,
        778,
        722,
        722,
        722,
        722,
        667,
        667,
        611,
        556,
        556,
        556,
        556,
        556,
        556,
        889,
        556,
        556,
        556,
        556,
        556,
        278,
        278,
        278,
        278,
        611,
        611,
        611,
        611,
        611,
        611,
        611,
        584,
        611,
        611,
        611,
        611,
        611,
        556,
        611
    ],
    kernPairs: [
        -140,
        [
            9569,
            2
        ],
        -120,
        [
            57,
            124,
            2508,
            2,
            428,
            2,
            6396,
            124,
            691,
            2,
            859,
            429,
            2
        ],
        -110,
        [
            7152,
            124,
            2238,
            2774,
            119,
            1,
            1,
            1,
            1,
            1,
            20325,
            124,
            91,
            124,
            91,
            124,
            91,
            124,
            91,
            124,
            91,
            124,
            5012,
            119,
            1,
            1,
            1,
            1,
            1
        ],
        -100,
        [
            52,
            8130,
            2,
            2169,
            119,
            1,
            1,
            1,
            1,
            1,
            1790,
            2,
            65,
            6,
            117,
            1,
            1,
            1,
            1,
            2,
            1,
            1,
            1,
            1,
            26460,
            2,
            65,
            6,
            117,
            1,
            1,
            1,
            1,
            2,
            1,
            1,
            1,
            1
        ],
        -90,
        [
            7147,
            2365,
            1701,
            52,
            67,
            1,
            1,
            1,
            1,
            1,
            52,
            1,
            1,
            1,
            297,
            123,
            1,
            1,
            1,
            1,
            2,
            502,
            119,
            1,
            1,
            1,
            1,
            1,
            20288,
            215,
            215,
            215,
            215,
            215,
            5173,
            119,
            1,
            1,
            1,
            1,
            1
        ],
        -80,
        [
            54,
            1,
            55,
            7039,
            1054,
            119,
            1,
            1,
            1,
            1,
            1,
            1188,
            1677,
            2,
            51,
            14,
            3,
            102,
            1,
            1,
            1,
            1,
            1,
            13,
            1,
            1,
            1,
            1,
            2,
            235,
            20,
            119,
            1,
            1,
            1,
            1,
            1,
            70,
            2,
            485,
            123,
            1,
            1,
            1,
            6052,
            2,
            643,
            2,
            4286,
            68,
            362,
            2162,
            2,
            6705,
            215,
            215,
            215,
            215,
            215,
            5175,
            123,
            1,
            1,
            1,
            6697,
            2
        ],
        -70,
        [
            7797,
            124,
            2241,
            124,
            2016,
            123,
            1,
            1,
            1,
            1,
            2,
            24176,
            124,
            91,
            124,
            91,
            124,
            91,
            124,
            91,
            124,
            306,
            124,
            941,
            123,
            1,
            1,
            1,
            1,
            2
        ],
        -60,
        [
            108,
            7042,
            4099,
            18,
            2,
            32,
            71,
            1,
            1,
            1,
            18,
            282,
            20,
            99,
            1,
            1,
            1,
            1,
            1,
            20,
            1,
            1,
            1,
            36,
            46,
            73,
            1,
            1,
            1,
            1,
            1,
            45,
            1,
            1,
            1,
            1,
            2,
            5609,
            2,
            5874,
            34,
            9183,
            215,
            215,
            215,
            215,
            215
        ],
        -50,
        [
            7134,
            14,
            124,
            1,
            1,
            1,
            2863,
            21,
            1,
            1,
            96,
            1,
            1,
            1,
            1,
            1,
            542,
            3,
            124,
            497,
            119,
            1,
            1,
            1,
            1,
            1,
            97,
            8,
            22,
            101,
            1,
            1,
            1,
            1,
            2,
            16,
            1,
            1,
            1,
            476,
            1,
            20437,
            14,
            124,
            1,
            1,
            1,
            74,
            14,
            124,
            1,
            1,
            1,
            74,
            14,
            124,
            1,
            1,
            1,
            74,
            14,
            124,
            1,
            1,
            1,
            74,
            14,
            124,
            1,
            1,
            1,
            74,
            14,
            124,
            1,
            1,
            1,
            2648,
            21,
            1,
            1,
            96,
            1,
            1,
            1,
            1,
            1,
            91,
            21,
            1,
            1,
            96,
            1,
            1,
            1,
            1,
            1,
            91,
            21,
            1,
            1,
            96,
            1,
            1,
            1,
            1,
            1,
            91,
            21,
            1,
            1,
            96,
            1,
            1,
            1,
            1,
            1,
            91,
            21,
            1,
            1,
            96,
            1,
            1,
            1,
            1,
            1,
            306,
            21,
            1,
            1,
            96,
            1,
            1,
            1,
            1,
            1,
            91,
            119,
            1,
            1,
            1,
            1,
            1,
            91,
            119,
            1,
            1,
            1,
            1,
            1,
            91,
            119,
            1,
            1,
            1,
            1,
            1,
            91,
            119,
            1,
            1,
            1,
            1,
            1,
            84,
            1
        ],
        -46,
        [
            23328,
            216
        ],
        -45,
        [
            11910,
            124,
            1,
            1,
            1
        ],
        -40,
        [
            2580,
            430,
            2580,
            215,
            1325,
            12,
            2,
            37,
            73,
            11,
            1,
            1,
            1,
            1,
            2,
            502,
            21,
            1,
            97,
            1,
            1,
            1,
            1,
            1,
            1437,
            32,
            92,
            659,
            2,
            38,
            242,
            123,
            1,
            1,
            1,
            1,
            2,
            277,
            401,
            1,
            20,
            123,
            1,
            1,
            1,
            1,
            2,
            280,
            1,
            201,
            52,
            119,
            1,
            1,
            1,
            1,
            1,
            4842,
            1861,
            2,
            4798,
            9198,
            12,
            2,
            37,
            73,
            11,
            1,
            1,
            1,
            1,
            2,
            74,
            12,
            2,
            37,
            73,
            11,
            1,
            1,
            1,
            1,
            2,
            74,
            12,
            2,
            37,
            73,
            11,
            1,
            1,
            1,
            1,
            2,
            74,
            12,
            2,
            37,
            73,
            11,
            1,
            1,
            1,
            1,
            2,
            74,
            12,
            2,
            37,
            73,
            11,
            1,
            1,
            1,
            1,
            2,
            74,
            12,
            2,
            37,
            73,
            11,
            1,
            1,
            1,
            1,
            2,
            2631,
            2,
            38,
            175,
            2,
            38,
            175,
            2,
            38,
            175,
            2,
            38,
            175,
            2,
            38,
            390,
            2,
            38,
            5409
        ],
        -35,
        [
            9324,
            123,
            1,
            1,
            1,
            1,
            2,
            2441,
            123,
            1,
            1,
            1
        ],
        -30,
        [
            7180,
            2,
            2,
            32,
            88,
            1,
            1,
            1,
            1,
            35,
            119,
            1,
            1,
            1,
            1,
            1,
            285,
            2,
            1538,
            38,
            85,
            1,
            1,
            1,
            1,
            2,
            33,
            1,
            1,
            1,
            92,
            32,
            92,
            712,
            4,
            115,
            1,
            1,
            1,
            1,
            1,
            3,
            1,
            1,
            1,
            892,
            2,
            5235,
            32,
            92,
            305,
            1496,
            123,
            1,
            1,
            1,
            1,
            2,
            502,
            119,
            1,
            1,
            1,
            1,
            1,
            6756,
            119,
            1,
            1,
            1,
            1,
            1,
            6561,
            2,
            2,
            32,
            88,
            1,
            1,
            1,
            1,
            87,
            2,
            2,
            32,
            88,
            1,
            1,
            1,
            1,
            87,
            2,
            2,
            32,
            88,
            1,
            1,
            1,
            1,
            87,
            2,
            2,
            32,
            88,
            1,
            1,
            1,
            1,
            87,
            2,
            2,
            32,
            88,
            1,
            1,
            1,
            1,
            87,
            2,
            2,
            32,
            88,
            1,
            1,
            1,
            1,
            4099,
            2,
            213,
            2,
            213,
            2,
            213,
            2,
            4804,
            215,
            215,
            215,
            215,
            430,
            1052,
            119,
            1,
            1,
            1,
            1,
            1
        ],
        -25,
        [
            19214,
            123,
            1,
            1,
            1,
            1,
            2,
            6751,
            123,
            1,
            1,
            1,
            1,
            2,
            19651,
            123,
            1,
            1,
            1,
            1,
            2
        ],
        -20,
        [
            8235,
            119,
            1,
            1,
            1,
            1,
            1,
            683,
            2,
            19,
            52,
            67,
            1,
            1,
            1,
            1,
            1,
            52,
            1,
            1,
            1,
            1555,
            5,
            1,
            117,
            1,
            1,
            1,
            1,
            2,
            1,
            1,
            1,
            1,
            942,
            42,
            32,
            49,
            1,
            1,
            1,
            1,
            2,
            37,
            2026,
            32,
            92,
            87,
            1,
            3,
            32,
            88,
            1,
            1,
            1,
            1,
            77,
            1,
            648,
            123,
            1,
            1,
            1,
            1,
            2,
            311,
            32,
            92,
            947,
            124,
            1,
            1,
            1,
            92,
            32,
            92,
            88,
            3,
            32,
            92,
            445,
            54,
            1,
            11,
            2,
            110,
            11,
            1,
            1,
            1,
            1,
            2,
            717,
            119,
            1,
            1,
            1,
            1,
            1,
            105,
            123,
            1,
            1,
            1,
            1,
            2,
            4598,
            10,
            16128,
            32,
            92,
            91,
            32,
            92,
            91,
            32,
            92,
            91,
            32,
            92,
            91,
            32,
            92,
            91,
            32,
            92,
            292,
            1,
            2163,
            32,
            92,
            88,
            3,
            32,
            92,
            88,
            3,
            32,
            92,
            88,
            3,
            32,
            92,
            88,
            3,
            32,
            92,
            88,
            3,
            32,
            92,
            303,
            3,
            32,
            92
        ],
        -15,
        [
            9314,
            123,
            1,
            1,
            1,
            4621,
            1,
            644,
            1,
            2,
            32,
            92,
            88,
            1,
            1,
            1,
            32,
            92,
            1156,
            123,
            1,
            1,
            1,
            1,
            2,
            94,
            2,
            32,
            92,
            519,
            217,
            32,
            92,
            288,
            12,
            34,
            185,
            7310,
            14404,
            1,
            214,
            1,
            214,
            1,
            214,
            1,
            214,
            1,
            214,
            1,
            644,
            1,
            1,
            1,
            32,
            92,
            88,
            1,
            1,
            1,
            32,
            92,
            88,
            1,
            1,
            1,
            32,
            92,
            88,
            1,
            1,
            1,
            32,
            92,
            1379,
            215,
            215,
            215,
            215,
            430
        ],
        -10,
        [
            7363,
            124,
            1,
            1,
            1,
            3098,
            124,
            1,
            1,
            1,
            1136,
            1,
            2194,
            220,
            211,
            17,
            32,
            92,
            70,
            374,
            2,
            55,
            123,
            1,
            1,
            1,
            91,
            1519,
            124,
            1,
            1,
            1,
            2007,
            123,
            1,
            1,
            1,
            89,
            123,
            1,
            1,
            1,
            6754,
            123,
            1,
            1,
            1,
            13421,
            215,
            215,
            215,
            215,
            215,
            431,
            17,
            32,
            92,
            2022,
            124,
            1,
            1,
            1,
            2437,
            123,
            1,
            1,
            1
        ],
        10,
        [
            14847,
            487,
            123,
            1,
            1,
            1,
            2256,
            3,
            32,
            92,
            1576,
            123,
            1,
            1,
            1,
            6324,
            123,
            1,
            1,
            1,
            15297,
            215,
            215,
            215
        ],
        20,
        [
            10547,
            2,
            4300,
            2865,
            23580,
            215,
            215,
            215
        ],
        30,
        [
            15159,
            2
        ]
    ]
};



var $9d2d78b79956c642$export$2e2bcd8739ae039 = {
    name: 'Helvetica-BoldOblique',
    bbox: [
        -174,
        -228,
        1114,
        962
    ],
    ascender: 718,
    descender: -207,
    xHeight: 532,
    capHeight: 718,
    glyphNames: $9d23502c9c68cad6$export$39b482c5e57630a8,
    glyphWidths: [
        278,
        333,
        474,
        556,
        556,
        889,
        722,
        238,
        333,
        333,
        389,
        584,
        278,
        333,
        278,
        278,
        556,
        556,
        556,
        556,
        556,
        556,
        556,
        556,
        556,
        556,
        333,
        333,
        584,
        584,
        584,
        611,
        975,
        722,
        722,
        722,
        722,
        667,
        611,
        778,
        722,
        278,
        556,
        722,
        611,
        833,
        722,
        778,
        667,
        778,
        722,
        667,
        611,
        722,
        667,
        944,
        667,
        667,
        611,
        333,
        278,
        333,
        584,
        556,
        333,
        556,
        611,
        556,
        611,
        556,
        333,
        611,
        611,
        278,
        278,
        556,
        278,
        889,
        611,
        611,
        611,
        611,
        389,
        556,
        333,
        611,
        556,
        778,
        556,
        556,
        500,
        389,
        280,
        389,
        584,
        556,
        278,
        556,
        500,
        1000,
        556,
        556,
        333,
        1000,
        667,
        333,
        1000,
        611,
        278,
        278,
        500,
        500,
        350,
        556,
        1000,
        333,
        1000,
        556,
        333,
        944,
        500,
        556,
        333,
        556,
        556,
        556,
        556,
        280,
        556,
        333,
        737,
        370,
        556,
        584,
        737,
        333,
        400,
        584,
        333,
        333,
        333,
        611,
        556,
        278,
        333,
        333,
        365,
        556,
        834,
        834,
        834,
        611,
        722,
        722,
        722,
        722,
        722,
        722,
        1000,
        722,
        667,
        667,
        667,
        667,
        278,
        278,
        278,
        278,
        722,
        722,
        778,
        778,
        778,
        778,
        778,
        584,
        778,
        722,
        722,
        722,
        722,
        667,
        667,
        611,
        556,
        556,
        556,
        556,
        556,
        556,
        889,
        556,
        556,
        556,
        556,
        556,
        278,
        278,
        278,
        278,
        611,
        611,
        611,
        611,
        611,
        611,
        611,
        584,
        611,
        611,
        611,
        611,
        611,
        556,
        611
    ],
    kernPairs: [
        -140,
        [
            9569,
            2
        ],
        -120,
        [
            57,
            124,
            2508,
            2,
            428,
            2,
            6396,
            124,
            691,
            2,
            859,
            429,
            2
        ],
        -110,
        [
            7152,
            124,
            2238,
            2774,
            119,
            1,
            1,
            1,
            1,
            1,
            20325,
            124,
            91,
            124,
            91,
            124,
            91,
            124,
            91,
            124,
            91,
            124,
            5012,
            119,
            1,
            1,
            1,
            1,
            1
        ],
        -100,
        [
            52,
            8130,
            2,
            2169,
            119,
            1,
            1,
            1,
            1,
            1,
            1790,
            2,
            65,
            6,
            117,
            1,
            1,
            1,
            1,
            2,
            1,
            1,
            1,
            1,
            26460,
            2,
            65,
            6,
            117,
            1,
            1,
            1,
            1,
            2,
            1,
            1,
            1,
            1
        ],
        -90,
        [
            7147,
            2365,
            1701,
            52,
            67,
            1,
            1,
            1,
            1,
            1,
            52,
            1,
            1,
            1,
            297,
            123,
            1,
            1,
            1,
            1,
            2,
            502,
            119,
            1,
            1,
            1,
            1,
            1,
            20288,
            215,
            215,
            215,
            215,
            215,
            5173,
            119,
            1,
            1,
            1,
            1,
            1
        ],
        -80,
        [
            54,
            1,
            55,
            7039,
            1054,
            119,
            1,
            1,
            1,
            1,
            1,
            1188,
            1677,
            2,
            51,
            14,
            3,
            102,
            1,
            1,
            1,
            1,
            1,
            13,
            1,
            1,
            1,
            1,
            2,
            235,
            20,
            119,
            1,
            1,
            1,
            1,
            1,
            70,
            2,
            485,
            123,
            1,
            1,
            1,
            6052,
            2,
            643,
            2,
            4286,
            68,
            362,
            2162,
            2,
            6705,
            215,
            215,
            215,
            215,
            215,
            5175,
            123,
            1,
            1,
            1,
            6697,
            2
        ],
        -70,
        [
            7797,
            124,
            2241,
            124,
            2016,
            123,
            1,
            1,
            1,
            1,
            2,
            24176,
            124,
            91,
            124,
            91,
            124,
            91,
            124,
            91,
            124,
            306,
            124,
            941,
            123,
            1,
            1,
            1,
            1,
            2
        ],
        -60,
        [
            108,
            7042,
            4099,
            18,
            2,
            32,
            71,
            1,
            1,
            1,
            18,
            282,
            20,
            99,
            1,
            1,
            1,
            1,
            1,
            20,
            1,
            1,
            1,
            36,
            46,
            73,
            1,
            1,
            1,
            1,
            1,
            45,
            1,
            1,
            1,
            1,
            2,
            5609,
            2,
            5874,
            34,
            9183,
            215,
            215,
            215,
            215,
            215
        ],
        -50,
        [
            7134,
            14,
            124,
            1,
            1,
            1,
            2863,
            21,
            1,
            1,
            96,
            1,
            1,
            1,
            1,
            1,
            542,
            3,
            124,
            497,
            119,
            1,
            1,
            1,
            1,
            1,
            97,
            8,
            22,
            101,
            1,
            1,
            1,
            1,
            2,
            16,
            1,
            1,
            1,
            476,
            1,
            20437,
            14,
            124,
            1,
            1,
            1,
            74,
            14,
            124,
            1,
            1,
            1,
            74,
            14,
            124,
            1,
            1,
            1,
            74,
            14,
            124,
            1,
            1,
            1,
            74,
            14,
            124,
            1,
            1,
            1,
            74,
            14,
            124,
            1,
            1,
            1,
            2648,
            21,
            1,
            1,
            96,
            1,
            1,
            1,
            1,
            1,
            91,
            21,
            1,
            1,
            96,
            1,
            1,
            1,
            1,
            1,
            91,
            21,
            1,
            1,
            96,
            1,
            1,
            1,
            1,
            1,
            91,
            21,
            1,
            1,
            96,
            1,
            1,
            1,
            1,
            1,
            91,
            21,
            1,
            1,
            96,
            1,
            1,
            1,
            1,
            1,
            306,
            21,
            1,
            1,
            96,
            1,
            1,
            1,
            1,
            1,
            91,
            119,
            1,
            1,
            1,
            1,
            1,
            91,
            119,
            1,
            1,
            1,
            1,
            1,
            91,
            119,
            1,
            1,
            1,
            1,
            1,
            91,
            119,
            1,
            1,
            1,
            1,
            1,
            84,
            1
        ],
        -46,
        [
            23328,
            216
        ],
        -45,
        [
            11910,
            124,
            1,
            1,
            1
        ],
        -40,
        [
            2580,
            430,
            2580,
            215,
            1325,
            12,
            2,
            37,
            73,
            11,
            1,
            1,
            1,
            1,
            2,
            502,
            21,
            1,
            97,
            1,
            1,
            1,
            1,
            1,
            1437,
            32,
            92,
            659,
            2,
            38,
            242,
            123,
            1,
            1,
            1,
            1,
            2,
            277,
            401,
            1,
            20,
            123,
            1,
            1,
            1,
            1,
            2,
            280,
            1,
            201,
            52,
            119,
            1,
            1,
            1,
            1,
            1,
            4842,
            1861,
            2,
            4798,
            9198,
            12,
            2,
            37,
            73,
            11,
            1,
            1,
            1,
            1,
            2,
            74,
            12,
            2,
            37,
            73,
            11,
            1,
            1,
            1,
            1,
            2,
            74,
            12,
            2,
            37,
            73,
            11,
            1,
            1,
            1,
            1,
            2,
            74,
            12,
            2,
            37,
            73,
            11,
            1,
            1,
            1,
            1,
            2,
            74,
            12,
            2,
            37,
            73,
            11,
            1,
            1,
            1,
            1,
            2,
            74,
            12,
            2,
            37,
            73,
            11,
            1,
            1,
            1,
            1,
            2,
            2631,
            2,
            38,
            175,
            2,
            38,
            175,
            2,
            38,
            175,
            2,
            38,
            175,
            2,
            38,
            390,
            2,
            38,
            5409
        ],
        -35,
        [
            9324,
            123,
            1,
            1,
            1,
            1,
            2,
            2441,
            123,
            1,
            1,
            1
        ],
        -30,
        [
            7180,
            2,
            2,
            32,
            88,
            1,
            1,
            1,
            1,
            35,
            119,
            1,
            1,
            1,
            1,
            1,
            285,
            2,
            1538,
            38,
            85,
            1,
            1,
            1,
            1,
            2,
            33,
            1,
            1,
            1,
            92,
            32,
            92,
            712,
            4,
            115,
            1,
            1,
            1,
            1,
            1,
            3,
            1,
            1,
            1,
            892,
            2,
            5235,
            32,
            92,
            305,
            1496,
            123,
            1,
            1,
            1,
            1,
            2,
            502,
            119,
            1,
            1,
            1,
            1,
            1,
            6756,
            119,
            1,
            1,
            1,
            1,
            1,
            6561,
            2,
            2,
            32,
            88,
            1,
            1,
            1,
            1,
            87,
            2,
            2,
            32,
            88,
            1,
            1,
            1,
            1,
            87,
            2,
            2,
            32,
            88,
            1,
            1,
            1,
            1,
            87,
            2,
            2,
            32,
            88,
            1,
            1,
            1,
            1,
            87,
            2,
            2,
            32,
            88,
            1,
            1,
            1,
            1,
            87,
            2,
            2,
            32,
            88,
            1,
            1,
            1,
            1,
            4099,
            2,
            213,
            2,
            213,
            2,
            213,
            2,
            4804,
            215,
            215,
            215,
            215,
            430,
            1052,
            119,
            1,
            1,
            1,
            1,
            1
        ],
        -25,
        [
            19214,
            123,
            1,
            1,
            1,
            1,
            2,
            6751,
            123,
            1,
            1,
            1,
            1,
            2,
            19651,
            123,
            1,
            1,
            1,
            1,
            2
        ],
        -20,
        [
            8235,
            119,
            1,
            1,
            1,
            1,
            1,
            683,
            2,
            19,
            52,
            67,
            1,
            1,
            1,
            1,
            1,
            52,
            1,
            1,
            1,
            1555,
            5,
            1,
            117,
            1,
            1,
            1,
            1,
            2,
            1,
            1,
            1,
            1,
            942,
            42,
            32,
            49,
            1,
            1,
            1,
            1,
            2,
            37,
            2026,
            32,
            92,
            87,
            1,
            3,
            32,
            88,
            1,
            1,
            1,
            1,
            77,
            1,
            648,
            123,
            1,
            1,
            1,
            1,
            2,
            311,
            32,
            92,
            947,
            124,
            1,
            1,
            1,
            92,
            32,
            92,
            88,
            3,
            32,
            92,
            445,
            54,
            1,
            11,
            2,
            110,
            11,
            1,
            1,
            1,
            1,
            2,
            717,
            119,
            1,
            1,
            1,
            1,
            1,
            105,
            123,
            1,
            1,
            1,
            1,
            2,
            4598,
            10,
            16128,
            32,
            92,
            91,
            32,
            92,
            91,
            32,
            92,
            91,
            32,
            92,
            91,
            32,
            92,
            91,
            32,
            92,
            292,
            1,
            2163,
            32,
            92,
            88,
            3,
            32,
            92,
            88,
            3,
            32,
            92,
            88,
            3,
            32,
            92,
            88,
            3,
            32,
            92,
            88,
            3,
            32,
            92,
            303,
            3,
            32,
            92
        ],
        -15,
        [
            9314,
            123,
            1,
            1,
            1,
            4621,
            1,
            644,
            1,
            2,
            32,
            92,
            88,
            1,
            1,
            1,
            32,
            92,
            1156,
            123,
            1,
            1,
            1,
            1,
            2,
            94,
            2,
            32,
            92,
            519,
            217,
            32,
            92,
            288,
            12,
            34,
            185,
            7310,
            14404,
            1,
            214,
            1,
            214,
            1,
            214,
            1,
            214,
            1,
            214,
            1,
            644,
            1,
            1,
            1,
            32,
            92,
            88,
            1,
            1,
            1,
            32,
            92,
            88,
            1,
            1,
            1,
            32,
            92,
            88,
            1,
            1,
            1,
            32,
            92,
            1379,
            215,
            215,
            215,
            215,
            430
        ],
        -10,
        [
            7363,
            124,
            1,
            1,
            1,
            3098,
            124,
            1,
            1,
            1,
            1136,
            1,
            2194,
            220,
            211,
            17,
            32,
            92,
            70,
            374,
            2,
            55,
            123,
            1,
            1,
            1,
            91,
            1519,
            124,
            1,
            1,
            1,
            2007,
            123,
            1,
            1,
            1,
            89,
            123,
            1,
            1,
            1,
            6754,
            123,
            1,
            1,
            1,
            13421,
            215,
            215,
            215,
            215,
            215,
            431,
            17,
            32,
            92,
            2022,
            124,
            1,
            1,
            1,
            2437,
            123,
            1,
            1,
            1
        ],
        10,
        [
            14847,
            487,
            123,
            1,
            1,
            1,
            2256,
            3,
            32,
            92,
            1576,
            123,
            1,
            1,
            1,
            6324,
            123,
            1,
            1,
            1,
            15297,
            215,
            215,
            215
        ],
        20,
        [
            10547,
            2,
            4300,
            2865,
            23580,
            215,
            215,
            215
        ],
        30,
        [
            15159,
            2
        ]
    ]
};



var $b0a3a94375bda3fe$export$2e2bcd8739ae039 = {
    name: 'Helvetica-Oblique',
    bbox: [
        -170,
        -225,
        1116,
        931
    ],
    ascender: 718,
    descender: -207,
    xHeight: 523,
    capHeight: 718,
    glyphNames: $9d23502c9c68cad6$export$39b482c5e57630a8,
    glyphWidths: [
        278,
        278,
        355,
        556,
        556,
        889,
        667,
        191,
        333,
        333,
        389,
        584,
        278,
        333,
        278,
        278,
        556,
        556,
        556,
        556,
        556,
        556,
        556,
        556,
        556,
        556,
        278,
        278,
        584,
        584,
        584,
        556,
        1015,
        667,
        667,
        722,
        722,
        667,
        611,
        778,
        722,
        278,
        500,
        667,
        556,
        833,
        722,
        778,
        667,
        778,
        722,
        667,
        611,
        722,
        667,
        944,
        667,
        667,
        611,
        278,
        278,
        278,
        469,
        556,
        333,
        556,
        556,
        500,
        556,
        556,
        278,
        556,
        556,
        222,
        222,
        500,
        222,
        833,
        556,
        556,
        556,
        556,
        333,
        500,
        278,
        556,
        500,
        722,
        500,
        500,
        500,
        334,
        260,
        334,
        584,
        556,
        222,
        556,
        333,
        1000,
        556,
        556,
        333,
        1000,
        667,
        333,
        1000,
        611,
        222,
        222,
        333,
        333,
        350,
        556,
        1000,
        333,
        1000,
        500,
        333,
        944,
        500,
        500,
        333,
        556,
        556,
        556,
        556,
        260,
        556,
        333,
        737,
        370,
        556,
        584,
        737,
        333,
        400,
        584,
        333,
        333,
        333,
        556,
        537,
        278,
        333,
        333,
        365,
        556,
        834,
        834,
        834,
        611,
        667,
        667,
        667,
        667,
        667,
        667,
        1000,
        722,
        667,
        667,
        667,
        667,
        278,
        278,
        278,
        278,
        722,
        722,
        778,
        778,
        778,
        778,
        778,
        584,
        778,
        722,
        722,
        722,
        722,
        667,
        667,
        611,
        556,
        556,
        556,
        556,
        556,
        556,
        889,
        500,
        556,
        556,
        556,
        556,
        278,
        278,
        278,
        278,
        556,
        556,
        556,
        556,
        556,
        556,
        556,
        584,
        611,
        556,
        556,
        556,
        556,
        500,
        556
    ],
    kernPairs: [
        -180,
        [
            10332,
            2
        ],
        -160,
        [
            9569
        ],
        -150,
        [
            8182,
            2
        ],
        -140,
        [
            9517,
            54,
            70,
            1552,
            1074,
            1,
            1,
            51,
            4,
            10,
            105,
            1,
            1,
            1,
            1,
            1,
            3,
            1,
            1,
            1,
            7,
            1,
            1,
            1,
            1,
            2,
            26464,
            1,
            1,
            51,
            4,
            10,
            105,
            1,
            1,
            2,
            1,
            3,
            1,
            1,
            1,
            7,
            1,
            1,
            1,
            1,
            2
        ],
        -125,
        [
            11622,
            2
        ],
        -120,
        [
            7147,
            3206,
            119,
            1,
            1,
            1,
            1,
            1,
            715,
            2,
            19,
            32,
            4,
            10,
            3,
            3,
            2,
            2,
            63,
            1,
            1,
            1,
            1,
            1,
            27,
            1,
            1,
            2,
            1,
            4,
            1,
            1,
            7,
            1,
            1,
            2,
            2,
            1,
            1,
            1,
            1,
            1,
            21339,
            215,
            215,
            215,
            215,
            215
        ],
        -110,
        [
            9512,
            2,
            2774,
            52,
            67,
            1,
            1,
            1,
            1,
            1,
            52,
            1,
            1,
            1,
            26481,
            52,
            67,
            1,
            1,
            1,
            1,
            1,
            52,
            1,
            1,
            1
        ],
        -100,
        [
            2689,
            2,
            428,
            2,
            4031,
            124,
            11871,
            2,
            6878,
            2,
            6708,
            124,
            91,
            124,
            91,
            124,
            91,
            124,
            91,
            124,
            91,
            124,
            11871,
            2
        ],
        -95,
        [
            44732,
            2
        ],
        -90,
        [
            57,
            124,
            7616,
            124
        ],
        -85,
        [
            12302,
            123,
            1,
            1,
            1,
            1,
            2,
            26531,
            123,
            1,
            1,
            1,
            1,
            2,
            5717
        ],
        -80,
        [
            8203,
            119,
            1,
            1,
            1,
            1,
            1,
            3296,
            20,
            36,
            10,
            73,
            1,
            1,
            1,
            1,
            1,
            35,
            1,
            1,
            1,
            7,
            1,
            1,
            1,
            1,
            2,
            19,
            2,
            6663,
            2
        ],
        -70,
        [
            7149,
            603,
            2,
            40,
            1721,
            647,
            124,
            1389,
            20,
            99,
            1,
            1,
            1,
            1,
            1,
            20,
            1,
            1,
            1,
            11613,
            9299,
            215,
            215,
            215,
            215,
            215,
            2798,
            124,
            91,
            124,
            91,
            124,
            91,
            124,
            91,
            124,
            306,
            124,
            1081,
            5704,
            1,
            2,
            32,
            92
        ],
        -60,
        [
            108,
            2902,
            7151,
            1140,
            66,
            5,
            13,
            896,
            1,
            6435,
            2,
            17887,
            215,
            215,
            215,
            215,
            430,
            1045,
            1
        ],
        -57,
        [
            23328,
            216
        ],
        -55,
        [
            44785,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            5,
            27,
            3,
            64,
            1,
            1,
            1,
            1,
            1,
            2,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            2,
            1,
            1,
            1,
            1,
            1,
            2,
            1,
            1,
            1,
            1
        ],
        -50,
        [
            52,
            2,
            5536,
            215,
            1343,
            2,
            122,
            1,
            1,
            1,
            960,
            119,
            1,
            1,
            1,
            1,
            1,
            933,
            42,
            32,
            49,
            1,
            1,
            1,
            1,
            2,
            37,
            701,
            230,
            10,
            113,
            1,
            1,
            1,
            7,
            1,
            1,
            1,
            1,
            2,
            276,
            3,
            124,
            927,
            119,
            1,
            1,
            1,
            1,
            1,
            5660,
            2,
            5859,
            14,
            1,
            34,
            9181,
            2,
            122,
            1,
            1,
            1,
            88,
            2,
            122,
            1,
            1,
            1,
            88,
            2,
            122,
            1,
            1,
            1,
            88,
            2,
            122,
            1,
            1,
            1,
            88,
            2,
            122,
            1,
            1,
            1,
            88,
            2,
            122,
            1,
            1,
            1,
            2669,
            215,
            215,
            215,
            215,
            430
        ],
        -45,
        [
            8252
        ],
        -40,
        [
            55,
            7126,
            1,
            2,
            32,
            92,
            465,
            22,
            97,
            1,
            1,
            1,
            1,
            1,
            1417,
            10,
            113,
            1,
            1,
            1,
            7,
            1,
            1,
            1,
            1,
            2,
            664,
            2,
            38,
            228,
            119,
            1,
            1,
            1,
            1,
            1,
            294,
            124,
            1,
            1,
            1,
            297,
            123,
            1,
            1,
            1,
            1,
            2,
            51,
            2,
            19,
            119,
            1,
            1,
            1,
            1,
            1,
            84,
            1,
            12,
            8,
            123,
            1,
            1,
            1,
            1,
            2,
            52,
            52,
            119,
            1,
            1,
            1,
            1,
            1,
            2188,
            2,
            2793,
            2,
            6866,
            8901,
            1,
            2,
            32,
            92,
            88,
            1,
            2,
            32,
            92,
            88,
            1,
            2,
            32,
            92,
            88,
            1,
            2,
            32,
            92,
            88,
            1,
            2,
            32,
            92,
            88,
            1,
            2,
            32,
            92,
            2594,
            2,
            38,
            175,
            2,
            38,
            175,
            2,
            38,
            175,
            2,
            38,
            175,
            2,
            38,
            390,
            2,
            38,
            175,
            2,
            19,
            119,
            1,
            1,
            1,
            1,
            1,
            70,
            2,
            19,
            119,
            1,
            1,
            1,
            1,
            1,
            70,
            2,
            19,
            119,
            1,
            1,
            1,
            1,
            1,
            70,
            2,
            19,
            119,
            1,
            1,
            1,
            1,
            1,
            4585,
            2,
            213,
            2,
            213,
            2,
            213,
            2,
            213,
            2
        ],
        -35,
        [
            17212,
            2
        ],
        -30,
        [
            110,
            7020,
            4,
            8,
            2,
            36,
            74,
            11,
            1,
            1,
            1,
            1,
            2,
            33,
            1,
            1,
            1,
            230,
            2,
            700,
            10,
            113,
            1,
            1,
            1,
            7,
            1,
            1,
            1,
            1,
            2,
            664,
            2,
            286,
            124,
            1,
            1,
            1,
            92,
            32,
            92,
            487,
            642,
            3,
            1089,
            10,
            6,
            107,
            1,
            1,
            1,
            7,
            1,
            1,
            1,
            1,
            2,
            1,
            1,
            1,
            1,
            2027,
            32,
            92,
            733,
            2,
            139,
            2,
            51,
            4,
            10,
            105,
            1,
            1,
            1,
            1,
            1,
            3,
            1,
            1,
            1,
            7,
            1,
            1,
            1,
            1,
            2,
            311,
            32,
            92,
            1380,
            1,
            32,
            92,
            91,
            32,
            92,
            519,
            1057,
            123,
            1,
            1,
            1,
            6127,
            7473,
            4,
            8,
            2,
            36,
            74,
            11,
            1,
            1,
            1,
            1,
            2,
            33,
            1,
            1,
            1,
            38,
            4,
            8,
            2,
            36,
            74,
            11,
            1,
            1,
            1,
            1,
            2,
            33,
            1,
            1,
            1,
            38,
            4,
            8,
            2,
            36,
            74,
            11,
            1,
            1,
            1,
            1,
            2,
            33,
            1,
            1,
            1,
            38,
            4,
            8,
            2,
            36,
            74,
            11,
            1,
            1,
            1,
            1,
            2,
            33,
            1,
            1,
            1,
            38,
            4,
            8,
            2,
            36,
            74,
            11,
            1,
            1,
            1,
            1,
            2,
            33,
            1,
            1,
            1,
            38,
            4,
            8,
            2,
            36,
            74,
            11,
            1,
            1,
            1,
            1,
            2,
            33,
            1,
            1,
            1,
            230,
            2,
            2406,
            215,
            215,
            215,
            215,
            430,
            1754,
            32,
            92,
            91,
            32,
            92,
            91,
            32,
            92,
            91,
            32,
            92,
            91,
            32,
            92,
            91,
            32,
            92,
            518,
            2,
            213,
            2,
            213,
            2,
            213,
            2,
            1505,
            1,
            32,
            92,
            90,
            1,
            32,
            92,
            90,
            1,
            32,
            92,
            90,
            1,
            32,
            92,
            90,
            1,
            32,
            92
        ],
        -25,
        [
            18555,
            4,
            10,
            105,
            1,
            1,
            1,
            1,
            1,
            3,
            1,
            1,
            1,
            7,
            1,
            1,
            1,
            1,
            2
        ],
        -20,
        [
            7322,
            2,
            1739,
            32,
            20,
            67,
            1,
            1,
            1,
            1,
            1,
            27,
            1,
            1,
            1,
            1,
            1,
            20,
            1,
            1,
            1,
            896,
            119,
            1,
            1,
            1,
            1,
            1,
            535,
            123,
            1,
            1,
            1,
            1,
            2,
            51,
            2,
            227,
            1,
            665,
            42,
            32,
            49,
            1,
            1,
            1,
            1,
            2,
            37,
            290,
            124,
            1609,
            1,
            204,
            9,
            1,
            3,
            32,
            88,
            1,
            1,
            1,
            1,
            77,
            442,
            2,
            32,
            92,
            1146,
            10,
            113,
            1,
            1,
            1,
            7,
            1,
            1,
            1,
            1,
            2,
            523,
            2344,
            4,
            10,
            105,
            1,
            1,
            1,
            1,
            1,
            3,
            1,
            1,
            1,
            7,
            1,
            1,
            1,
            1,
            2,
            3029,
            2,
            3706,
            4,
            10,
            105,
            1,
            1,
            1,
            1,
            1,
            3,
            1,
            1,
            1,
            7,
            1,
            1,
            1,
            1,
            2,
            10360,
            119,
            1,
            1,
            1,
            1,
            1,
            91,
            119,
            1,
            1,
            1,
            1,
            1,
            91,
            119,
            1,
            1,
            1,
            1,
            1,
            91,
            119,
            1,
            1,
            1,
            1,
            1,
            91,
            119,
            1,
            1,
            1,
            1,
            1,
            306,
            119,
            1,
            1,
            1,
            1,
            1,
            991,
            124,
            534,
            1,
            214,
            1,
            214,
            1,
            214,
            1,
            214,
            1,
            214,
            1,
            418,
            227,
            2,
            32,
            92,
            89,
            2,
            32,
            92,
            89,
            2,
            32,
            92,
            89,
            2,
            32,
            92,
            1163,
            2559,
            4,
            10,
            105,
            1,
            1,
            1,
            1,
            1,
            3,
            1,
            1,
            1,
            7,
            1,
            1,
            1,
            1,
            2
        ],
        -15,
        [
            14417,
            430,
            2,
            1795,
            32,
            92,
            91,
            32,
            92,
            88,
            1,
            785,
            2,
            911,
            119,
            1,
            1,
            1,
            1,
            1,
            525,
            10,
            113,
            1,
            1,
            1,
            7,
            1,
            1,
            1,
            1,
            2,
            5609,
            2,
            700,
            10,
            113,
            1,
            1,
            1,
            7,
            1,
            1,
            1,
            1,
            2,
            15069,
            215,
            2,
            213,
            2,
            213,
            2,
            213,
            2,
            1365,
            32,
            92,
            88,
            1,
            214,
            1,
            214,
            1,
            214,
            1,
            214,
            1
        ],
        -10,
        [
            7363,
            124,
            1,
            1,
            1,
            3098,
            124,
            1,
            1,
            1,
            3541,
            1091,
            1293,
            124,
            1,
            1,
            1,
            88,
            124,
            1,
            1,
            1,
            713,
            119,
            1,
            1,
            1,
            1,
            1,
            955,
            10,
            113,
            1,
            1,
            1,
            7,
            1,
            1,
            1,
            1,
            2,
            24387,
            124,
            1,
            1,
            1
        ],
        15,
        [
            17703,
            2,
            1,
            9,
            111,
            1,
            1,
            1,
            10,
            1,
            1,
            1
        ],
        25,
        [
            17707,
            1,
            123
        ],
        30,
        [
            17656,
            1,
            53,
            6,
            3,
            32,
            92
        ],
        40,
        [
            17714
        ],
        50,
        [
            15159
        ],
        60,
        [
            15161
        ]
    ]
};


var $4db498f87ff4c14a$export$2e2bcd8739ae039 = {
    name: 'Symbol',
    bbox: [
        -180,
        -293,
        1090,
        1010
    ],
    ascender: 0,
    descender: 0,
    xHeight: 0,
    capHeight: 0,
    glyphNames: 'space exclam numbersign percent ampersand parenleft parenright plus comma period slash zero one two three four five six seven eight nine colon semicolon less equal greater question bracketleft bracketright underscore braceleft bar braceright Euro florin ellipsis bullet logicalnot degree plusminus mu multiply divide',
    glyphWidths: [
        250,
        333,
        500,
        833,
        778,
        333,
        333,
        549,
        250,
        250,
        278,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        278,
        278,
        549,
        549,
        549,
        444,
        333,
        333,
        500,
        480,
        200,
        480,
        750,
        500,
        1000,
        460,
        713,
        400,
        549,
        576,
        549,
        549
    ],
    kernPairs: []
};



var $3be06c0bc7b739ff$export$2e2bcd8739ae039 = {
    name: 'Times-Bold',
    bbox: [
        -168,
        -218,
        1000,
        935
    ],
    ascender: 683,
    descender: -217,
    xHeight: 461,
    capHeight: 676,
    glyphNames: $9d23502c9c68cad6$export$39b482c5e57630a8,
    glyphWidths: [
        250,
        333,
        555,
        500,
        500,
        1000,
        833,
        278,
        333,
        333,
        500,
        570,
        250,
        333,
        250,
        278,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        333,
        333,
        570,
        570,
        570,
        500,
        930,
        722,
        667,
        722,
        722,
        667,
        611,
        778,
        778,
        389,
        500,
        778,
        667,
        944,
        722,
        778,
        611,
        778,
        722,
        556,
        667,
        722,
        722,
        1000,
        722,
        722,
        667,
        333,
        278,
        333,
        581,
        500,
        333,
        500,
        556,
        444,
        556,
        444,
        333,
        500,
        556,
        278,
        333,
        556,
        278,
        833,
        556,
        500,
        556,
        556,
        444,
        389,
        333,
        556,
        500,
        722,
        500,
        500,
        444,
        394,
        220,
        394,
        520,
        500,
        333,
        500,
        500,
        1000,
        500,
        500,
        333,
        1000,
        556,
        333,
        1000,
        667,
        333,
        333,
        500,
        500,
        350,
        500,
        1000,
        333,
        1000,
        389,
        333,
        722,
        444,
        500,
        333,
        500,
        500,
        500,
        500,
        220,
        500,
        333,
        747,
        300,
        500,
        570,
        747,
        333,
        400,
        570,
        300,
        300,
        333,
        556,
        540,
        250,
        333,
        300,
        330,
        500,
        750,
        750,
        750,
        500,
        722,
        722,
        722,
        722,
        722,
        722,
        1000,
        722,
        667,
        667,
        667,
        667,
        389,
        389,
        389,
        389,
        722,
        722,
        778,
        778,
        778,
        778,
        778,
        570,
        778,
        722,
        722,
        722,
        722,
        722,
        611,
        556,
        500,
        500,
        500,
        500,
        500,
        500,
        722,
        444,
        444,
        444,
        444,
        444,
        278,
        278,
        278,
        278,
        500,
        556,
        500,
        500,
        500,
        500,
        500,
        570,
        500,
        556,
        556,
        556,
        556,
        500,
        556
    ],
    kernPairs: [
        -145,
        [
            7149,
            4475,
            21110,
            215,
            215,
            215,
            215,
            215
        ],
        -135,
        [
            11643,
            119,
            1,
            1,
            1,
            1,
            1
        ],
        -130,
        [
            7150,
            25585,
            215,
            215,
            215,
            215,
            215
        ],
        -129,
        [
            11622
        ],
        -120,
        [
            11858,
            119,
            1,
            1,
            1,
            1,
            1
        ],
        -111,
        [
            12324,
            10,
            114,
            1,
            8,
            1,
            1,
            1,
            1,
            2,
            26521,
            10,
            114,
            1,
            8,
            1,
            1,
            1,
            1,
            2
        ],
        -110,
        [
            8184,
            1385,
            765,
            1954,
            119,
            1,
            1,
            1,
            1,
            1,
            26536,
            119,
            1,
            1,
            1,
            1,
            1
        ],
        -100,
        [
            7152,
            29,
            95,
            4403,
            10,
            113,
            1,
            1,
            1,
            7,
            1,
            1,
            1,
            1,
            2,
            5826,
            15093,
            29,
            95,
            91,
            29,
            95,
            91,
            29,
            95,
            91,
            29,
            95,
            91,
            29,
            95,
            91,
            29,
            95
        ],
        -95,
        [
            7147,
            25585,
            215,
            215,
            215,
            215,
            215
        ],
        -92,
        [
            8182,
            1330,
            2,
            1,
            2,
            124,
            691,
            861,
            52,
            4,
            10,
            6,
            100,
            4,
            4,
            1,
            8,
            1,
            1,
            1,
            1,
            2,
            1,
            1,
            1,
            1,
            244,
            1,
            38,
            20,
            99,
            1,
            1,
            1,
            1,
            1,
            20,
            1,
            1,
            1,
            15,
            2,
            428,
            1,
            1,
            12,
            1,
            58,
            124,
            1,
            1,
            1,
            5175,
            21285,
            1,
            1,
            12,
            1,
            58,
            124,
            1,
            1,
            1
        ],
        -90,
        [
            7182,
            1021,
            119,
            1,
            1,
            1,
            1,
            1,
            2867,
            19,
            119,
            1,
            1,
            1,
            1,
            1,
            21430,
            215,
            215,
            215,
            215,
            215
        ],
        -85,
        [
            12320,
            119,
            1,
            1,
            1,
            1,
            1,
            26536,
            119,
            1,
            1,
            1,
            1,
            1
        ],
        -75,
        [
            11904,
            123,
            1,
            1,
            1,
            1,
            2
        ],
        -74,
        [
            7184,
            20,
            12,
            92,
            3045,
            119,
            1,
            1,
            1,
            1,
            1,
            715,
            14,
            1,
            55,
            5,
            356,
            11812,
            9334,
            20,
            12,
            92,
            91,
            20,
            12,
            92,
            91,
            20,
            12,
            92,
            91,
            20,
            12,
            92,
            91,
            20,
            12,
            92,
            91,
            20,
            12,
            92
        ],
        -71,
        [
            12447,
            3,
            26657,
            3
        ],
        -70,
        [
            18504,
            215,
            430,
            6880,
            19780
        ],
        -65,
        [
            11890,
            4,
            115,
            1,
            1,
            1,
            1,
            1,
            3,
            1,
            1,
            1
        ],
        -63,
        [
            23328,
            216
        ],
        -60,
        [
            11428,
            119,
            1,
            1,
            1,
            1,
            1,
            362,
            32,
            92,
            26050,
            119,
            1,
            1,
            1,
            1,
            1,
            91,
            119,
            1,
            1,
            1,
            1,
            1,
            91,
            119,
            1,
            1,
            1,
            1,
            1,
            91,
            119,
            1,
            1,
            1,
            1,
            1
        ],
        -55,
        [
            33,
            24,
            95,
            1,
            1,
            1,
            1,
            1,
            24,
            2508,
            430,
            2,
            4009,
            4,
            120,
            2295,
            32,
            92,
            1131,
            1047,
            1,
            6650,
            215,
            430,
            6880,
            6688,
            4,
            120,
            91,
            4,
            120,
            91,
            4,
            120,
            91,
            4,
            120,
            91,
            4,
            120,
            91,
            4,
            120,
            11893
        ],
        -52,
        [
            11364,
            2,
            1,
            1,
            4,
            3
        ],
        -50,
        [
            7148,
            32,
            92,
            1,
            1,
            1,
            29,
            1,
            1,
            1,
            2852,
            1,
            2,
            124,
            1121,
            2,
            501,
            124,
            1,
            1,
            1,
            20696,
            32,
            92,
            1,
            1,
            1,
            29,
            1,
            1,
            1,
            56,
            32,
            92,
            1,
            1,
            1,
            29,
            1,
            1,
            1,
            56,
            32,
            92,
            1,
            1,
            1,
            29,
            1,
            1,
            1,
            56,
            32,
            92,
            1,
            1,
            1,
            29,
            1,
            1,
            1,
            56,
            32,
            92,
            1,
            1,
            1,
            29,
            1,
            1,
            1,
            56,
            32,
            92,
            1,
            1,
            1,
            29,
            1,
            1,
            1,
            2637,
            1,
            2,
            124,
            88,
            1,
            2,
            124,
            88,
            1,
            2,
            124,
            88,
            1,
            2,
            124,
            88,
            1,
            2,
            124,
            303,
            1,
            2,
            124,
            46,
            2,
            213,
            2,
            213,
            2,
            213,
            2
        ],
        -45,
        [
            54,
            2637,
            4451,
            2,
            121,
            1,
            1,
            1,
            1,
            2,
            2063,
            32,
            92,
            2199,
            123,
            1,
            1,
            1,
            1,
            2,
            20941,
            2,
            121,
            1,
            1,
            1,
            1,
            2,
            86,
            2,
            121,
            1,
            1,
            1,
            1,
            2,
            86,
            2,
            121,
            1,
            1,
            1,
            1,
            2,
            86,
            2,
            121,
            1,
            1,
            1,
            1,
            2,
            86,
            2,
            121,
            1,
            1,
            1,
            1,
            2,
            86,
            2,
            121,
            1,
            1,
            1,
            1,
            2
        ],
        -40,
        [
            7794,
            1,
            2,
            124,
            2217,
            19,
            4,
            96,
            1,
            1,
            1,
            1,
            1,
            540,
            3402,
            2652,
            19727,
            19,
            4,
            96,
            1,
            1,
            1,
            1,
            1,
            91,
            19,
            4,
            96,
            1,
            1,
            1,
            1,
            1,
            91,
            19,
            4,
            96,
            1,
            1,
            1,
            1,
            1,
            91,
            19,
            4,
            96,
            1,
            1,
            1,
            1,
            1,
            91,
            19,
            4,
            96,
            1,
            1,
            1,
            1,
            1,
            306,
            19,
            4,
            96,
            1,
            1,
            1,
            1,
            1,
            5304
        ],
        -37,
        [
            11683,
            123,
            1,
            1,
            1,
            29,
            490,
            124,
            5191,
            5875,
            34,
            15436,
            124
        ],
        -35,
        [
            7773,
            119,
            1,
            1,
            1,
            1,
            1,
            2908,
            2,
            124,
            1371,
            123,
            1,
            1,
            1,
            1,
            2,
            26531,
            123,
            1,
            1,
            1,
            1,
            2
        ],
        -34,
        [
            11269,
            32,
            92
        ],
        -30,
        [
            52,
            3,
            7288,
            119,
            1,
            1,
            1,
            1,
            1,
            1596,
            119,
            1,
            1,
            1,
            1,
            1,
            105,
            123,
            1,
            1,
            1,
            1,
            2,
            1376,
            6,
            117,
            1,
            1,
            1,
            1,
            2,
            1,
            1,
            1,
            1,
            719
        ],
        -25,
        [
            7175,
            1060,
            4,
            10,
            105,
            1,
            1,
            1,
            1,
            1,
            3,
            1,
            1,
            1,
            7,
            1,
            1,
            1,
            1,
            2,
            936,
            10,
            113,
            1,
            1,
            1,
            7,
            1,
            1,
            1,
            1,
            2,
            4608,
            1062,
            6,
            123,
            1,
            1,
            1,
            1,
            2,
            3956,
            123,
            1,
            1,
            1,
            1,
            2,
            6751,
            123,
            1,
            1,
            1,
            1,
            2,
            6537,
            215,
            215,
            215,
            215,
            215,
            5811,
            215,
            215,
            215,
            215,
            215,
            5153,
            123,
            1,
            1,
            1,
            1,
            2
        ],
        -20,
        [
            7754,
            1290,
            527,
            352,
            119,
            1,
            1,
            1,
            1,
            1,
            342,
            10,
            113,
            1,
            1,
            1,
            7,
            1,
            1,
            1,
            1,
            2,
            21,
            3726,
            124,
            1,
            1,
            1,
            9101,
            14,
            4,
            12847,
            119,
            1,
            1,
            1,
            1,
            1
        ],
        -18,
        [
            11227,
            26,
            97,
            1,
            1,
            1,
            1,
            2,
            21,
            521,
            124,
            5675,
            2,
            10,
            2,
            110,
            1,
            1,
            1,
            1,
            7,
            1,
            1,
            1,
            1,
            2
        ],
        -15,
        [
            9095,
            4,
            10,
            6,
            99,
            1,
            1,
            1,
            1,
            1,
            3,
            1,
            1,
            1,
            7,
            1,
            1,
            1,
            1,
            2,
            1,
            1,
            1,
            1,
            88,
            124,
            1,
            1,
            1,
            4819,
            431,
            214,
            141,
            2,
            215,
            290,
            32,
            92,
            511,
            10,
            32,
            81,
            1,
            1,
            1,
            1,
            2,
            5,
            1370,
            123,
            23535,
            215,
            215,
            215
        ],
        -10,
        [
            7363,
            124,
            1,
            1,
            1,
            2895,
            119,
            1,
            1,
            1,
            1,
            1,
            79,
            124,
            1,
            1,
            1,
            1157,
            123,
            1,
            1,
            1,
            1,
            2,
            2255,
            1525,
            413,
            123,
            1,
            1,
            1,
            751,
            1,
            629,
            9,
            6,
            839,
            4,
            10,
            105,
            1,
            1,
            1,
            1,
            1,
            3,
            1,
            1,
            1,
            7,
            1,
            1,
            1,
            1,
            2,
            86,
            123,
            1,
            1,
            1,
            1,
            2,
            291,
            123,
            1,
            1,
            1,
            3923,
            119,
            1,
            1,
            1,
            1,
            1,
            306,
            119,
            1,
            1,
            1,
            1,
            1,
            2277,
            123,
            1,
            1,
            1,
            16016,
            215,
            215,
            215,
            645,
            1,
            214,
            1,
            214,
            1,
            214,
            1,
            214,
            1,
            429,
            1,
            1057,
            123,
            1,
            1,
            1
        ],
        50,
        [
            15161
        ],
        55,
        [
            15159
        ]
    ]
};



var $0fd0af161dc7ec84$export$2e2bcd8739ae039 = {
    name: 'Times-BoldItalic',
    bbox: [
        -200,
        -218,
        996,
        921
    ],
    ascender: 683,
    descender: -217,
    xHeight: 462,
    capHeight: 669,
    glyphNames: $9d23502c9c68cad6$export$39b482c5e57630a8,
    glyphWidths: [
        250,
        389,
        555,
        500,
        500,
        833,
        778,
        278,
        333,
        333,
        500,
        570,
        250,
        333,
        250,
        278,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        333,
        333,
        570,
        570,
        570,
        500,
        832,
        667,
        667,
        667,
        722,
        667,
        667,
        722,
        778,
        389,
        500,
        667,
        611,
        889,
        722,
        722,
        611,
        722,
        667,
        556,
        611,
        722,
        667,
        889,
        667,
        611,
        611,
        333,
        278,
        333,
        570,
        500,
        333,
        500,
        500,
        444,
        500,
        444,
        333,
        500,
        556,
        278,
        278,
        500,
        278,
        778,
        556,
        500,
        500,
        500,
        389,
        389,
        278,
        556,
        444,
        667,
        500,
        444,
        389,
        348,
        220,
        348,
        570,
        500,
        333,
        500,
        500,
        1000,
        500,
        500,
        333,
        1000,
        556,
        333,
        944,
        611,
        333,
        333,
        500,
        500,
        350,
        500,
        1000,
        333,
        1000,
        389,
        333,
        722,
        389,
        444,
        389,
        500,
        500,
        500,
        500,
        220,
        500,
        333,
        747,
        266,
        500,
        606,
        747,
        333,
        400,
        570,
        300,
        300,
        333,
        576,
        500,
        250,
        333,
        300,
        300,
        500,
        750,
        750,
        750,
        500,
        667,
        667,
        667,
        667,
        667,
        667,
        944,
        667,
        667,
        667,
        667,
        667,
        389,
        389,
        389,
        389,
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        570,
        722,
        722,
        722,
        722,
        722,
        611,
        611,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        722,
        444,
        444,
        444,
        444,
        444,
        278,
        278,
        278,
        278,
        500,
        556,
        500,
        500,
        500,
        500,
        500,
        570,
        500,
        556,
        556,
        556,
        556,
        444,
        500
    ],
    kernPairs: [
        -129,
        [
            8182,
            2,
            2148,
            2,
            1288,
            2
        ],
        -111,
        [
            11675,
            4,
            10,
            105,
            1,
            1,
            1,
            1,
            1,
            4,
            1,
            8,
            1,
            1,
            1,
            1,
            2,
            506,
            10,
            114,
            9,
            1,
            1,
            1,
            1,
            2,
            26521,
            10,
            114,
            9,
            1,
            1,
            1,
            1,
            2
        ],
        -100,
        [
            7150,
            1053,
            36,
            83,
            1,
            1,
            1,
            1,
            1,
            35,
            1,
            1,
            1,
            24370,
            215,
            215,
            215,
            215,
            215
        ],
        -95,
        [
            2689,
            2,
            428,
            2,
            4028,
            1086,
            119,
            1,
            1,
            1,
            1,
            1,
            2900,
            123,
            1,
            1,
            1,
            1,
            2,
            21346,
            215,
            215,
            215,
            215,
            215
        ],
        -92,
        [
            11192,
            1,
            1,
            51,
            4,
            115,
            1,
            1,
            1,
            1,
            1,
            4,
            1,
            893,
            1,
            13,
            1,
            38,
            20,
            99,
            1,
            1,
            1,
            1,
            1,
            20,
            1,
            1,
            1,
            26460,
            1,
            13,
            1,
            38,
            20,
            99,
            1,
            1,
            1,
            1,
            1,
            20,
            1,
            1,
            1
        ],
        -90,
        [
            11894,
            124,
            1
        ],
        -85,
        [
            10353,
            119,
            1,
            1,
            1,
            1,
            1,
            1166,
            119,
            1,
            1,
            1,
            1,
            1,
            123,
            119,
            1,
            1,
            1,
            1,
            1
        ],
        -80,
        [
            11904,
            123,
            1,
            1,
            1,
            1,
            2
        ],
        -74,
        [
            7181,
            1,
            2,
            20,
            12,
            92,
            3898,
            1,
            429,
            1,
            200,
            2,
            19,
            119,
            1,
            1,
            1,
            1,
            1,
            287,
            19,
            119,
            1,
            1,
            1,
            1,
            1,
            10916,
            107,
            83,
            26,
            8,
            9214,
            1,
            2,
            20,
            12,
            92,
            88,
            1,
            2,
            20,
            12,
            92,
            88,
            1,
            2,
            20,
            12,
            92,
            88,
            1,
            2,
            20,
            12,
            92,
            88,
            1,
            2,
            20,
            12,
            92,
            88,
            1,
            2,
            20,
            12,
            92,
            4961,
            19,
            119,
            1,
            1,
            1,
            1,
            1
        ],
        -71,
        [
            11802,
            3,
            642,
            2,
            1,
            26657,
            2,
            1
        ],
        -70,
        [
            54,
            1,
            2,
            124,
            6971,
            124,
            973,
            123,
            1,
            1,
            1,
            1,
            2,
            3245,
            21114,
            124,
            91,
            124,
            91,
            124,
            91,
            124,
            91,
            124,
            91,
            124
        ],
        -65,
        [
            7130,
            124,
            10388,
            2,
            15071,
            124,
            91,
            124,
            91,
            124,
            91,
            124,
            91,
            124,
            91,
            124
        ],
        -60,
        [
            7134,
            25585,
            215,
            215,
            215,
            215,
            215
        ],
        -55,
        [
            7144,
            3,
            2422,
            830,
            123,
            1,
            1,
            1,
            1,
            2,
            685,
            119,
            1,
            1,
            1,
            1,
            1,
            346,
            12,
            112,
            12,
            1,
            1,
            1,
            29,
            1,
            58,
            4,
            32,
            88,
            1,
            1,
            1,
            1,
            290,
            124,
            20277,
            3,
            212,
            3,
            212,
            3,
            212,
            3,
            212,
            3,
            212,
            3,
            5181,
            124
        ],
        -52,
        [
            11372,
            3
        ],
        -50,
        [
            7142,
            6,
            117,
            1,
            1,
            1,
            1,
            2,
            1,
            1,
            1,
            1,
            519,
            3,
            124,
            331,
            1907,
            1,
            2,
            124,
            103,
            123,
            1,
            1,
            1,
            1323,
            179,
            3,
            20707,
            6,
            117,
            1,
            1,
            1,
            1,
            2,
            1,
            1,
            1,
            1,
            82,
            6,
            117,
            1,
            1,
            1,
            1,
            2,
            1,
            1,
            1,
            1,
            82,
            6,
            117,
            1,
            1,
            1,
            1,
            2,
            1,
            1,
            1,
            1,
            82,
            6,
            117,
            1,
            1,
            1,
            1,
            2,
            1,
            1,
            1,
            1,
            82,
            6,
            117,
            1,
            1,
            1,
            1,
            2,
            1,
            1,
            1,
            1,
            82,
            6,
            117,
            1,
            1,
            1,
            1,
            2,
            1,
            1,
            1,
            1,
            2669,
            1,
            2,
            124,
            88,
            1,
            2,
            124,
            88,
            1,
            2,
            124,
            88,
            1,
            2,
            124,
            88,
            1,
            2,
            124,
            303,
            1,
            2,
            124
        ],
        -45,
        [
            11428,
            119,
            1,
            1,
            1,
            1,
            1,
            26536,
            119,
            1,
            1,
            1,
            1,
            1,
            91,
            119,
            1,
            1,
            1,
            1,
            1,
            91,
            119,
            1,
            1,
            1,
            1,
            1,
            91,
            119,
            1,
            1,
            1,
            1,
            1
        ],
        -40,
        [
            7795,
            448,
            123,
            1,
            1,
            1,
            726,
            4,
            10,
            6,
            99,
            1,
            1,
            1,
            1,
            1,
            3,
            1,
            1,
            1,
            7,
            1,
            1,
            1,
            1,
            2,
            1,
            1,
            1,
            1,
            896,
            19,
            4,
            96,
            1,
            1,
            1,
            1,
            1,
            123,
            119,
            1,
            1,
            1,
            1,
            1,
            288,
            6,
            117,
            1,
            1,
            1,
            1,
            2,
            1,
            1,
            1,
            1,
            3274,
            2652,
            19727,
            19,
            4,
            96,
            1,
            1,
            1,
            1,
            1,
            91,
            19,
            4,
            96,
            1,
            1,
            1,
            1,
            1,
            91,
            19,
            4,
            96,
            1,
            1,
            1,
            1,
            1,
            91,
            19,
            4,
            96,
            1,
            1,
            1,
            1,
            1,
            91,
            19,
            4,
            96,
            1,
            1,
            1,
            1,
            1,
            306,
            19,
            4,
            96,
            1,
            1,
            1,
            1,
            1,
            5304
        ],
        -37,
        [
            33,
            119,
            1,
            1,
            1,
            1,
            1,
            9357,
            1,
            2,
            32,
            32,
            60,
            32,
            1580,
            9,
            3,
            2,
            2,
            32,
            76,
            12,
            1,
            1,
            1,
            1,
            505,
            124,
            6480,
            2,
            213,
            2,
            428,
            2,
            4370,
            2508,
            2,
            19778,
            2
        ],
        -30,
        [
            7180,
            124,
            1,
            1,
            1,
            1985,
            123,
            1,
            1,
            1,
            1,
            2,
            502,
            119,
            1,
            1,
            1,
            1,
            1,
            755,
            855,
            123,
            1,
            1,
            1,
            1,
            2,
            4408,
            123,
            1,
            1,
            1,
            16445,
            124,
            1,
            1,
            1,
            88,
            124,
            1,
            1,
            1,
            88,
            124,
            1,
            1,
            1,
            88,
            124,
            1,
            1,
            1,
            88,
            124,
            1,
            1,
            1,
            88,
            124,
            1,
            1,
            1,
            2401,
            119,
            1,
            1,
            1,
            1,
            1
        ],
        -25,
        [
            7343,
            119,
            1,
            1,
            1,
            1,
            1,
            306,
            119,
            1,
            1,
            1,
            1,
            1,
            1166,
            119,
            1,
            1,
            1,
            1,
            1,
            127,
            10,
            113,
            1,
            1,
            1,
            7,
            1,
            1,
            1,
            1,
            2,
            2849,
            123,
            1,
            1,
            1,
            1,
            2,
            4641,
            21890,
            123,
            1,
            1,
            1,
            1,
            2,
            4426,
            215,
            215,
            215,
            215,
            430
        ],
        -20,
        [
            9330,
            4,
            32,
            88,
            1,
            1,
            1,
            1,
            4817,
            124,
            1,
            1,
            1
        ],
        -18,
        [
            9512,
            1292,
            1,
            2,
            124,
            296,
            123,
            1,
            1,
            1,
            1,
            2,
            3764
        ],
        -15,
        [
            11872,
            123,
            1,
            1,
            1,
            1,
            2,
            5070,
            1488,
            10,
            113,
            1,
            1,
            1,
            7,
            1,
            1,
            1,
            1,
            2,
            86,
            123,
            1,
            1,
            1,
            1,
            2,
            4590,
            14,
            4,
            19995,
            215,
            215,
            215,
            215,
            430
        ],
        -10,
        [
            7363,
            124,
            1,
            1,
            1,
            1552,
            2,
            1544,
            124,
            1,
            1,
            1,
            934,
            2607,
            221,
            3,
            421,
            161,
            2,
            55,
            10,
            114,
            9,
            1,
            1,
            1,
            3,
            946,
            123,
            1,
            1,
            1,
            1,
            2,
            740,
            1,
            32,
            92,
            1572,
            4,
            115,
            1,
            1,
            1,
            1,
            1,
            3,
            1,
            1,
            1,
            89,
            123,
            1,
            1,
            1,
            22022,
            3,
            206,
            215,
            215,
            215,
            1527,
            1,
            32,
            92,
            90,
            1,
            32,
            92,
            90,
            1,
            32,
            92,
            90,
            1,
            32,
            92,
            90,
            1,
            32,
            92,
            305,
            1,
            32,
            92
        ],
        55,
        [
            15159
        ]
    ]
};



var $6dae8573ff48be68$export$2e2bcd8739ae039 = {
    name: 'Times-Italic',
    bbox: [
        -169,
        -217,
        1010,
        883
    ],
    ascender: 683,
    descender: -217,
    xHeight: 441,
    capHeight: 653,
    glyphNames: $9d23502c9c68cad6$export$39b482c5e57630a8,
    glyphWidths: [
        250,
        333,
        420,
        500,
        500,
        833,
        778,
        214,
        333,
        333,
        500,
        675,
        250,
        333,
        250,
        278,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        333,
        333,
        675,
        675,
        675,
        500,
        920,
        611,
        611,
        667,
        722,
        611,
        611,
        722,
        722,
        333,
        444,
        667,
        556,
        833,
        667,
        722,
        611,
        722,
        611,
        500,
        556,
        722,
        611,
        833,
        611,
        556,
        556,
        389,
        278,
        389,
        422,
        500,
        333,
        500,
        500,
        444,
        500,
        444,
        278,
        500,
        500,
        278,
        278,
        444,
        278,
        722,
        500,
        500,
        500,
        500,
        389,
        389,
        278,
        500,
        444,
        667,
        444,
        444,
        389,
        400,
        275,
        400,
        541,
        500,
        333,
        500,
        556,
        889,
        500,
        500,
        333,
        1000,
        500,
        333,
        944,
        556,
        333,
        333,
        556,
        556,
        350,
        500,
        889,
        333,
        980,
        389,
        333,
        667,
        389,
        444,
        389,
        500,
        500,
        500,
        500,
        275,
        500,
        333,
        760,
        276,
        500,
        675,
        760,
        333,
        400,
        675,
        300,
        300,
        333,
        500,
        523,
        250,
        333,
        300,
        310,
        500,
        750,
        750,
        750,
        500,
        611,
        611,
        611,
        611,
        611,
        611,
        889,
        667,
        611,
        611,
        611,
        611,
        333,
        333,
        333,
        333,
        722,
        667,
        722,
        722,
        722,
        722,
        722,
        675,
        722,
        722,
        722,
        722,
        722,
        556,
        611,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        667,
        444,
        444,
        444,
        444,
        444,
        278,
        278,
        278,
        278,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        675,
        500,
        500,
        500,
        500,
        500,
        444,
        500
    ],
    kernPairs: [
        -140,
        [
            2689,
            2,
            428,
            2
        ],
        -135,
        [
            8182,
            2,
            2148,
            2
        ],
        -129,
        [
            11622,
            2
        ],
        -115,
        [
            8203,
            119,
            1,
            1,
            1,
            1,
            1
        ],
        -111,
        [
            11675,
            4,
            10,
            105,
            1,
            1,
            1,
            1,
            1,
            4,
            1,
            8,
            1,
            1,
            1,
            1,
            2,
            5824,
            2,
            5684,
            107,
            109
        ],
        -105,
        [
            7149,
            1100,
            123,
            1,
            1,
            1,
            1,
            2,
            24356,
            215,
            215,
            215,
            215,
            215
        ],
        -95,
        [
            7150,
            25585,
            215,
            215,
            215,
            215,
            215
        ],
        -92,
        [
            11245,
            4,
            10,
            105,
            1,
            1,
            1,
            1,
            1,
            4,
            9,
            1,
            1,
            1,
            1,
            2,
            449,
            2,
            51,
            4,
            10,
            105,
            1,
            1,
            1,
            1,
            1,
            4,
            1,
            8,
            1,
            1,
            1,
            1,
            2,
            234,
            2,
            51,
            4,
            10,
            6,
            99,
            1,
            1,
            1,
            1,
            1,
            4,
            1,
            8,
            1,
            1,
            1,
            1,
            2,
            1,
            1,
            1,
            1,
            26460,
            2,
            51,
            4,
            10,
            6,
            99,
            1,
            1,
            1,
            1,
            1,
            4,
            1,
            8,
            1,
            1,
            1,
            1,
            2,
            1,
            1,
            1,
            1
        ],
        -90,
        [
            10353,
            119,
            1,
            1,
            1,
            1,
            1
        ],
        -80,
        [
            10385,
            4,
            10,
            105,
            1,
            1,
            1,
            1,
            1,
            3,
            1,
            1,
            1,
            7,
            1,
            1,
            1,
            1,
            2
        ],
        -75,
        [
            57,
            124,
            8054,
            4,
            115,
            1,
            1,
            1,
            1,
            1,
            3,
            1,
            1,
            1
        ],
        -74,
        [
            11192,
            1,
            1,
            73,
            2,
            124,
            244,
            46,
            12,
            112,
            12,
            1,
            1,
            1,
            446,
            60,
            124,
            6050,
            2,
            213,
            2,
            20209,
            60,
            124
        ],
        -71,
        [
            11802,
            3
        ],
        -70,
        [
            11914,
            32,
            92
        ],
        -65,
        [
            11207,
            429,
            215,
            1,
            429,
            1,
            26659,
            1
        ],
        -60,
        [
            11643,
            119,
            1,
            1,
            1,
            1,
            1,
            91,
            119,
            1,
            1,
            1,
            1,
            1
        ],
        -55,
        [
            7152,
            29,
            1,
            2,
            32,
            60,
            32,
            944,
            1262,
            1,
            623,
            119,
            1,
            1,
            1,
            1,
            1,
            944,
            47,
            9,
            3,
            112,
            12,
            1,
            1,
            1,
            231,
            275,
            12,
            112,
            12,
            1,
            1,
            1,
            7110,
            2,
            6878,
            2,
            6708,
            29,
            1,
            2,
            32,
            60,
            32,
            59,
            29,
            1,
            2,
            32,
            60,
            32,
            59,
            29,
            1,
            2,
            32,
            60,
            32,
            59,
            29,
            1,
            2,
            32,
            60,
            32,
            59,
            29,
            1,
            2,
            32,
            60,
            32,
            59,
            29,
            1,
            2,
            32,
            60,
            32,
            2615,
            119,
            1,
            1,
            1,
            1,
            1,
            91,
            119,
            1,
            1,
            1,
            1,
            1,
            91,
            119,
            1,
            1,
            1,
            1,
            1,
            91,
            119,
            1,
            1,
            1,
            1,
            1,
            91,
            119,
            1,
            1,
            1,
            1,
            1,
            306,
            119,
            1,
            1,
            1,
            1,
            1,
            7810,
            2
        ],
        -52,
        [
            11372,
            2,
            1,
            642,
            3,
            427,
            3,
            26657,
            3
        ],
        -50,
        [
            7148,
            124,
            1,
            1,
            1,
            2017,
            123,
            1,
            1,
            1,
            1,
            2,
            738,
            1,
            2,
            124,
            927,
            119,
            1,
            1,
            1,
            1,
            1,
            951,
            119,
            1,
            1,
            1,
            1,
            1,
            20321,
            124,
            1,
            1,
            1,
            88,
            124,
            1,
            1,
            1,
            88,
            124,
            1,
            1,
            1,
            88,
            124,
            1,
            1,
            1,
            88,
            124,
            1,
            1,
            1,
            88,
            124,
            1,
            1,
            1,
            2669,
            1,
            2,
            124,
            88,
            1,
            2,
            124,
            88,
            1,
            2,
            124,
            88,
            1,
            2,
            124,
            88,
            1,
            2,
            124,
            303,
            1,
            2,
            124,
            927,
            119,
            1,
            1,
            1,
            1,
            1
        ],
        -45,
        [
            8243,
            123,
            1,
            1,
            1,
            9340,
            123,
            1,
            1,
            1,
            1,
            2
        ],
        -40,
        [
            55,
            7087,
            2,
            121,
            1,
            1,
            1,
            1,
            2,
            523,
            1,
            2,
            124,
            1142,
            119,
            1,
            1,
            1,
            1,
            1,
            137,
            6,
            4,
            32,
            81,
            1,
            1,
            1,
            1,
            2,
            1,
            1,
            1,
            1,
            1,
            699,
            4,
            636,
            6,
            117,
            1,
            1,
            1,
            1,
            2,
            1,
            1,
            1,
            1,
            498,
            119,
            1,
            1,
            1,
            1,
            1,
            2652,
            702,
            1950,
            6662,
            34,
            9175,
            2,
            121,
            1,
            1,
            1,
            1,
            2,
            86,
            2,
            121,
            1,
            1,
            1,
            1,
            2,
            86,
            2,
            121,
            1,
            1,
            1,
            1,
            2,
            86,
            2,
            121,
            1,
            1,
            1,
            1,
            2,
            86,
            2,
            121,
            1,
            1,
            1,
            1,
            2,
            86,
            2,
            121,
            1,
            1,
            1,
            1,
            2,
            2671,
            4,
            211,
            4,
            211,
            4,
            211,
            4,
            211,
            4,
            426,
            4,
            192,
            119,
            1,
            1,
            1,
            1,
            1,
            91,
            119,
            1,
            1,
            1,
            1,
            1,
            91,
            119,
            1,
            1,
            1,
            1,
            1,
            91,
            119,
            1,
            1,
            1,
            1,
            1,
            2494,
            215,
            215,
            215,
            1305
        ],
        -37,
        [
            7147,
            57,
            2365,
            2269,
            5859,
            1,
            1,
            2,
            10,
            110,
            1,
            1,
            1,
            1,
            14907,
            57,
            158,
            57,
            158,
            57,
            158,
            57,
            158,
            57,
            158,
            57
        ],
        -35,
        [
            54,
            7080,
            639,
            119,
            1,
            1,
            1,
            1,
            1,
            1198,
            20,
            99,
            1,
            1,
            1,
            1,
            1,
            20,
            1,
            1,
            1,
            72,
            123,
            1,
            1,
            1,
            23279,
            215,
            215,
            215,
            215,
            215
        ],
        -34,
        [
            11301,
            505,
            2,
            1,
            642,
            2,
            1,
            26657,
            2,
            1
        ],
        -30,
        [
            7130,
            124,
            2295,
            32,
            92,
            1984,
            123,
            1,
            1,
            1,
            1,
            2,
            3138,
            32,
            92,
            8471,
            9196,
            124,
            91,
            124,
            91,
            124,
            91,
            124,
            91,
            124,
            91,
            124,
            7455,
            32,
            92,
            91,
            32,
            92,
            91,
            32,
            92,
            91,
            32,
            92
        ],
        -27,
        [
            9923,
            119,
            1,
            1,
            1,
            1,
            1,
            26321,
            119,
            1,
            1,
            1,
            1,
            1
        ],
        -25,
        [
            7343,
            119,
            1,
            1,
            1,
            1,
            1,
            1575,
            2,
            55,
            10,
            113,
            1,
            1,
            1,
            7,
            1,
            1,
            1,
            1,
            2,
            2169,
            2,
            463,
            123,
            1,
            1,
            1,
            1,
            2,
            11502,
            14,
            14550,
            2,
            213,
            2,
            213,
            2,
            213,
            2
        ],
        -20,
        [
            7180,
            124,
            1,
            1,
            1,
            2205,
            5,
            124,
            4634,
            124,
            1,
            1,
            1,
            78,
            443,
            200,
            2520,
            15122,
            124,
            1,
            1,
            1,
            88,
            124,
            1,
            1,
            1,
            88,
            124,
            1,
            1,
            1,
            88,
            124,
            1,
            1,
            1,
            88,
            124,
            1,
            1,
            1,
            88,
            124,
            1,
            1,
            1,
            7173,
            228,
            215,
            215,
            215
        ],
        -18,
        [
            33,
            19,
            100,
            1,
            1,
            1,
            1,
            1,
            10647,
            1,
            2,
            124,
            296,
            123,
            1,
            1,
            1,
            1,
            2,
            3764
        ],
        -15,
        [
            12302,
            123,
            1,
            1,
            1,
            1,
            2,
            2046,
            372,
            72,
            1,
            142,
            215,
            2416,
            119,
            1,
            1,
            1,
            1,
            1,
            21143,
            123,
            1,
            1,
            1,
            1,
            2,
            2046,
            157,
            72,
            1,
            142,
            72,
            1,
            142,
            72,
            1,
            142,
            72,
            1
        ],
        -10,
        [
            7363,
            124,
            1,
            1,
            1,
            3098,
            124,
            1,
            1,
            1,
            3331,
            801,
            215,
            215,
            57,
            2,
            121,
            1,
            1,
            1,
            734,
            10,
            10,
            32,
            71,
            1,
            1,
            1,
            7,
            1,
            1,
            1,
            1,
            2,
            5,
            718,
            15,
            642,
            34,
            5774,
            16110,
            215,
            215,
            215,
            215,
            215,
            586,
            215,
            215,
            215,
            1564,
            15,
            200,
            15,
            200,
            15,
            200,
            15,
            200,
            15,
            415,
            15
        ],
        92,
        [
            15159
        ]
    ]
};



var $8da7183c34612edd$export$2e2bcd8739ae039 = {
    name: 'Times-Roman',
    bbox: [
        -168,
        -218,
        1000,
        898
    ],
    ascender: 683,
    descender: -217,
    xHeight: 450,
    capHeight: 662,
    glyphNames: $9d23502c9c68cad6$export$39b482c5e57630a8,
    glyphWidths: [
        250,
        333,
        408,
        500,
        500,
        833,
        778,
        180,
        333,
        333,
        500,
        564,
        250,
        333,
        250,
        278,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        278,
        278,
        564,
        564,
        564,
        444,
        921,
        722,
        667,
        667,
        722,
        611,
        556,
        722,
        722,
        333,
        389,
        722,
        611,
        889,
        722,
        722,
        556,
        722,
        667,
        556,
        611,
        722,
        722,
        944,
        722,
        722,
        611,
        333,
        278,
        333,
        469,
        500,
        333,
        444,
        500,
        444,
        500,
        444,
        333,
        500,
        500,
        278,
        278,
        500,
        278,
        778,
        500,
        500,
        500,
        500,
        333,
        389,
        278,
        500,
        500,
        722,
        500,
        500,
        444,
        480,
        200,
        480,
        541,
        500,
        333,
        500,
        444,
        1000,
        500,
        500,
        333,
        1000,
        556,
        333,
        889,
        611,
        333,
        333,
        444,
        444,
        350,
        500,
        1000,
        333,
        980,
        389,
        333,
        722,
        444,
        500,
        333,
        500,
        500,
        500,
        500,
        200,
        500,
        333,
        760,
        276,
        500,
        564,
        760,
        333,
        400,
        564,
        300,
        300,
        333,
        500,
        453,
        250,
        333,
        300,
        310,
        500,
        750,
        750,
        750,
        444,
        722,
        722,
        722,
        722,
        722,
        722,
        889,
        667,
        611,
        611,
        611,
        611,
        333,
        333,
        333,
        333,
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        564,
        722,
        722,
        722,
        722,
        722,
        722,
        556,
        500,
        444,
        444,
        444,
        444,
        444,
        444,
        667,
        444,
        444,
        444,
        444,
        444,
        278,
        278,
        278,
        278,
        500,
        500,
        500,
        500,
        500,
        500,
        500,
        564,
        500,
        500,
        500,
        500,
        500,
        500,
        500
    ],
    kernPairs: [
        -135,
        [
            7149,
            4494,
            119,
            1,
            1,
            1,
            1,
            1,
            20967,
            215,
            215,
            215,
            215,
            215
        ],
        -129,
        [
            11622,
            2,
            65,
            124,
            1,
            4,
            449,
            2,
            26658,
            2
        ],
        -120,
        [
            11858,
            119,
            1,
            1,
            1,
            1,
            1,
            306,
            119,
            1,
            1,
            1,
            1,
            1,
            26536,
            119,
            1,
            1,
            1,
            1,
            1
        ],
        -111,
        [
            7147,
            57,
            3128,
            2,
            1341,
            4,
            116,
            4,
            4,
            465,
            72,
            125,
            1,
            20266,
            57,
            158,
            57,
            158,
            57,
            158,
            57,
            158,
            57,
            158,
            57,
            5064,
            72,
            125,
            1
        ],
        -110,
        [
            12334,
            124,
            1,
            4,
            26531,
            124,
            1,
            4
        ],
        -105,
        [
            7152,
            124,
            25461,
            124,
            91,
            124,
            91,
            124,
            91,
            124,
            91,
            124,
            91,
            124
        ],
        -100,
        [
            9514,
            3,
            124,
            1982,
            697,
            4,
            116,
            1,
            3,
            4,
            1,
            26531,
            4,
            116,
            1,
            3,
            4,
            1
        ],
        -93,
        [
            11213,
            119,
            1,
            1,
            1,
            1,
            1
        ],
        -92,
        [
            7182,
            2,
            32,
            92,
            2204,
            57,
            784,
            119,
            1,
            1,
            1,
            1,
            1,
            716,
            644,
            2,
            442,
            1,
            20485,
            2,
            32,
            92,
            89,
            2,
            32,
            92,
            89,
            2,
            32,
            92,
            89,
            2,
            32,
            92,
            89,
            2,
            32,
            92,
            89,
            2,
            32,
            92,
            4973,
            1
        ],
        -90,
        [
            57,
            124,
            6969,
            25585,
            215,
            215,
            215,
            215,
            215
        ],
        -89,
        [
            11812,
            3,
            1
        ],
        -80,
        [
            8182,
            2,
            2620,
            441,
            14,
            8,
            2,
            32,
            64,
            1,
            3,
            13,
            1,
            1,
            1,
            1,
            2,
            5,
            497,
            4,
            10,
            105,
            1,
            1,
            1,
            1,
            1,
            4,
            1,
            8,
            1,
            1,
            1,
            1,
            2,
            11220,
            119,
            1,
            1,
            1,
            1,
            1,
            306,
            119,
            1,
            1,
            1,
            1,
            1
        ],
        -75,
        [
            11695,
            124,
            1,
            1,
            1
        ],
        -74,
        [
            7181,
            1022,
            119,
            1,
            1,
            1,
            1,
            1,
            1188,
            1677,
            2,
            442,
            1,
            11691,
            107,
            109,
            9222,
            215,
            215,
            215,
            215,
            215
        ],
        -73,
        [
            11914,
            32,
            92
        ],
        -71,
        [
            11794,
            2,
            1,
            1,
            4,
            2,
            1,
            659,
            3,
            26657,
            3
        ],
        -70,
        [
            2689,
            2,
            428,
            2,
            8128,
            123,
            1,
            1,
            1083,
            3,
            1,
            26656,
            3,
            1
        ],
        -65,
        [
            10807,
            124,
            907,
            6664,
            2,
            213,
            2,
            428,
            2,
            6878,
            2,
            19778,
            2
        ],
        -60,
        [
            9063,
            119,
            1,
            1,
            1,
            1,
            1,
            1615,
            881,
            124,
            632,
            3,
            1,
            4,
            3,
            26649,
            3,
            1,
            4,
            3
        ],
        -55,
        [
            33,
            119,
            1,
            1,
            1,
            1,
            1,
            6985,
            2,
            4,
            117,
            1,
            1,
            1,
            1,
            2,
            1,
            1,
            1,
            1,
            522,
            124,
            1628,
            32,
            92,
            1132,
            402,
            1121,
            124,
            5192,
            5874,
            34,
            9175,
            2,
            4,
            117,
            1,
            1,
            1,
            1,
            2,
            1,
            1,
            1,
            1,
            82,
            2,
            4,
            117,
            1,
            1,
            1,
            1,
            2,
            1,
            1,
            1,
            1,
            82,
            2,
            4,
            117,
            1,
            1,
            1,
            1,
            2,
            1,
            1,
            1,
            1,
            82,
            2,
            4,
            117,
            1,
            1,
            1,
            1,
            2,
            1,
            1,
            1,
            1,
            82,
            2,
            4,
            117,
            1,
            1,
            1,
            1,
            2,
            1,
            1,
            1,
            1,
            82,
            2,
            4,
            117,
            1,
            1,
            1,
            1,
            2,
            1,
            1,
            1,
            1,
            5053,
            124
        ],
        -50,
        [
            54,
            10105,
            3,
            124,
            920,
            704,
            124,
            1,
            1,
            1,
            11466,
            14,
            4,
            13083,
            3,
            124,
            88,
            3,
            124,
            88,
            3,
            124,
            88,
            3,
            124,
            88,
            3,
            124,
            303,
            3,
            124
        ],
        -45,
        [
            11265,
            124,
            1,
            1,
            1
        ],
        -40,
        [
            7130,
            4,
            120,
            519,
            21,
            98,
            1,
            1,
            1,
            1,
            1,
            2260,
            4,
            636,
            6,
            117,
            1,
            1,
            1,
            1,
            2,
            1,
            1,
            1,
            1,
            434,
            3,
            1,
            60,
            119,
            1,
            1,
            1,
            1,
            1,
            105,
            123,
            1,
            1,
            1,
            1,
            2,
            112,
            119,
            3,
            2,
            2182,
            2652,
            786,
            15073,
            4,
            120,
            91,
            4,
            120,
            91,
            4,
            120,
            91,
            4,
            120,
            91,
            4,
            120,
            91,
            4,
            120,
            2688,
            4,
            211,
            4,
            211,
            4,
            211,
            4,
            211,
            4,
            426,
            4,
            192,
            119,
            1,
            1,
            1,
            1,
            1,
            91,
            119,
            1,
            1,
            1,
            1,
            1,
            91,
            119,
            1,
            1,
            1,
            1,
            1,
            91,
            119,
            1,
            1,
            1,
            1,
            1,
            4444
        ],
        -37,
        [
            11851,
            1
        ],
        -35,
        [
            7343,
            119,
            1,
            1,
            1,
            1,
            1,
            1857,
            123,
            1,
            1,
            1,
            1,
            2,
            470,
            119,
            1,
            1,
            1,
            1,
            1,
            91,
            22,
            97,
            1,
            1,
            1,
            1,
            1,
            991,
            9,
            115,
            24991,
            119,
            1,
            1,
            1,
            1,
            1,
            91,
            22,
            97,
            1,
            1,
            1,
            1,
            1,
            91,
            22,
            97,
            1,
            1,
            1,
            1,
            1,
            91,
            22,
            97,
            1,
            1,
            1,
            1,
            1,
            91,
            22,
            97,
            1,
            1,
            1,
            1,
            1,
            91,
            22,
            97,
            1,
            1,
            1,
            1,
            1,
            306,
            22,
            97,
            1,
            1,
            1,
            1,
            1
        ],
        -30,
        [
            55,
            7740,
            1497,
            123,
            1,
            1,
            1,
            1,
            2,
            1954,
            927,
            123,
            1,
            1,
            1,
            1,
            2,
            26531,
            123,
            1,
            1,
            1,
            1,
            2
        ],
        -25,
        [
            9314,
            20,
            32,
            71,
            1,
            1,
            1,
            18,
            5463,
            1,
            198,
            661,
            1291,
            1483,
            119,
            1,
            1,
            1,
            1,
            1,
            22687,
            1,
            214,
            1,
            214,
            1,
            214,
            1,
            214,
            215,
            215,
            215,
            646,
            215,
            215,
            215,
            215,
            430
        ],
        -20,
        [
            11806,
            2,
            1,
            2252,
            214,
            124,
            1,
            1,
            1,
            721,
            124,
            2396,
            926,
            123,
            1,
            1,
            1,
            1,
            2,
            20948,
            215,
            215,
            215,
            215,
            215
        ],
        -18,
        [
            52,
            11175,
            123,
            1,
            1,
            1,
            1,
            2,
            6345,
            5818
        ],
        -15,
        [
            8235,
            14,
            105,
            1,
            1,
            1,
            1,
            1,
            13,
            1,
            1,
            1,
            1,
            2,
            952,
            124,
            1,
            1,
            1,
            928,
            119,
            1,
            1,
            1,
            1,
            1,
            1140,
            2413,
            214,
            218,
            32,
            92,
            288,
            17,
            1,
            32,
            92,
            1166,
            32,
            92,
            521,
            32,
            92,
            88,
            1488,
            123,
            1,
            1,
            1,
            304,
            123,
            1,
            1,
            1,
            20532,
            215,
            215,
            215,
            215,
            215,
            432,
            32,
            92,
            73,
            17,
            1,
            32,
            92,
            73,
            17,
            1,
            32,
            92,
            73,
            17,
            1,
            32,
            92,
            73,
            17,
            1,
            32,
            92,
            1166,
            32,
            92,
            88,
            215,
            215,
            215,
            215,
            430
        ],
        -10,
        [
            7363,
            124,
            1,
            1,
            1,
            3098,
            124,
            1,
            1,
            1,
            1157,
            123,
            1,
            1,
            1,
            1,
            2,
            3114,
            119,
            1,
            1,
            1,
            1,
            1,
            955,
            10,
            113,
            1,
            1,
            1,
            7,
            1,
            1,
            1,
            1,
            2,
            94,
            647,
            32,
            92,
            91,
            32,
            92,
            1357,
            14,
            105,
            1,
            1,
            1,
            1,
            1,
            13,
            1,
            1,
            1,
            1,
            2,
            4598,
            20008,
            32,
            92,
            91,
            32,
            92,
            91,
            32,
            92,
            91,
            32,
            92,
            91,
            32,
            92,
            306,
            32,
            92
        ],
        -5,
        [
            15330,
            119,
            1,
            1,
            1,
            1,
            1,
            115,
            32,
            92
        ],
        55,
        [
            15159
        ]
    ]
};


var $c146c79ad7b7f1b4$export$2e2bcd8739ae039 = {
    name: 'ZapfDingbats',
    bbox: [
        -1,
        -143,
        981,
        820
    ],
    ascender: 0,
    descender: 0,
    xHeight: 0,
    capHeight: 0,
    glyphNames: 'space',
    glyphWidths: [
        278
    ],
    kernPairs: []
};


/*
 * Since pdfkit 0.20, browser builds have to register the metrics of the standard fonts they use. A PDFDocument opens
 * Helvetica and svg-to-pdfkit maps the text of an SVG to the Helvetica, Times and Courier families, so all 14 standard
 * fonts are registered, as all of them were built in before.
 */ (0, $6c341d77d66c320e$export$ffca4ad96161f2b1)((0, $0fc9b74018d222f3$export$2e2bcd8739ae039), (0, $0e62a4a1dcf5f25a$export$2e2bcd8739ae039), (0, $a2e17dca7060ac99$export$2e2bcd8739ae039), (0, $b0cb573fd137196f$export$2e2bcd8739ae039), (0, $6d664a6b179e58ef$export$2e2bcd8739ae039), (0, $ab4284c8a2bc6ad6$export$2e2bcd8739ae039), (0, $9d2d78b79956c642$export$2e2bcd8739ae039), (0, $b0a3a94375bda3fe$export$2e2bcd8739ae039), (0, $4db498f87ff4c14a$export$2e2bcd8739ae039), (0, $3be06c0bc7b739ff$export$2e2bcd8739ae039), (0, $0fd0af161dc7ec84$export$2e2bcd8739ae039), (0, $6dae8573ff48be68$export$2e2bcd8739ae039), (0, $8da7183c34612edd$export$2e2bcd8739ae039), (0, $c146c79ad7b7f1b4$export$2e2bcd8739ae039));
var $8ef89c7a1ffa2c2d$export$2e2bcd8739ae039 = (0, $6c341d77d66c320e$export$e7ec69c418f2855a);



const $f622dfa4f509b5fa$export$8daf375224658067 = 'music-sheet-selection';
const { Option: $f622dfa4f509b5fa$var$Option, OptGroup: $f622dfa4f509b5fa$var$OptGroup } = (0, $5a2f22a270cf838a$export$2e2bcd8739ae039);
const $f622dfa4f509b5fa$var$AlignedPagination = (0, $07090e743135ae89$export$2e2bcd8739ae039)((0, $c8ee2867395b7990$export$2e2bcd8739ae039))`
  .ant-pagination-item-link {
    line-height: 0;
  }
`;
const $f622dfa4f509b5fa$var$MusicSheetSelection = ({ currentPage: currentPage, isMusicSheetRendered: isMusicSheetRendered, musicSheets: musicSheets, numberOfPages: numberOfPages, selectedMusicSheetID: selectedMusicSheetID, setConfiguringID: setConfiguringID, setCurrentPage: setCurrentPage, setIsMusicSheetRendered: setIsMusicSheetRendered, setNewPattern: setNewPattern, setNumberOfPages: setNumberOfPages, setPatterns: setPatterns, setSelectedMusicSheetID: setSelectedMusicSheetID, setShowOnBoarding: setShowOnBoarding, setSuggestingID: setSuggestingID })=>{
    const [theme, setTheme] = (0, $5E6i4.useContext)((0, $3c154bbb0fa44c80$export$2c657da244d00bd6));
    // The button's tooltip would cover the confirmation's buttons.
    const [isConfirmingDeletion, setIsConfirmingDeletion] = (0, $5E6i4.useState)(false);
    const { t: translate } = (0, $705ab703c44be5bc$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
        className: "flex flex-1 flex-wrap items-center justify-evenly gap-x-4 gap-y-2",
        id: $f622dfa4f509b5fa$export$8daf375224658067,
        children: [
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("div", {
                className: "min-w-0 max-w-full",
                children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $5a2f22a270cf838a$export$2e2bcd8739ae039), {
                    "aria-label": translate('musicSheetSelection.label'),
                    style: {
                        maxWidth: '100%',
                        width: 350
                    },
                    // Styles the options in the list only, rc-select would also apply an option's own className to the value.
                    classNames: {
                        popup: {
                            listItem: 'mb-4 font-bold tracking-tight text-gray-900'
                        }
                    },
                    popupMatchSelectWidth: false,
                    onChange: (value)=>{
                        setIsMusicSheetRendered(false);
                        setNumberOfPages(undefined);
                        setSelectedMusicSheetID(value);
                    },
                    size: "large",
                    value: selectedMusicSheetID,
                    children: Object.entries((0, $5pSp9.groupBy)(musicSheets, 'category')).map(([category, musicSheetsInCategory])=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($f622dfa4f509b5fa$var$OptGroup, {
                            label: translate(`musicSheets.${category}`, {
                                defaultValue: category
                            }),
                            children: musicSheetsInCategory.map((musicSheet)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($f622dfa4f509b5fa$var$Option, {
                                    value: musicSheet.id,
                                    children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("b", {
                                        children: translate('musicSheets.title', {
                                            composer: musicSheet.composer,
                                            title: translate(`musicSheets.${musicSheet.title}`, {
                                                defaultValue: musicSheet.title
                                            })
                                        })
                                    })
                                }, musicSheet.id))
                        }, category))
                })
            }),
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($f622dfa4f509b5fa$var$AlignedPagination, {
                current: currentPage,
                defaultPageSize: 1,
                disabled: !isMusicSheetRendered,
                onChange: (pageNumber)=>setCurrentPage(pageNumber),
                size: "small",
                total: numberOfPages
            }),
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $1bb718ecb5669b36$export$2e2bcd8739ae039), {
                        title: translate('toolbar.tour'),
                        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $67d71c16fdfc3a0e$export$2e2bcd8739ae039), {
                            "aria-label": translate('toolbar.tour'),
                            className: "mr-2",
                            icon: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $d65423fe016bd8b5$export$2e2bcd8739ae039), {}),
                            onClick: ()=>setShowOnBoarding(true),
                            shape: "circle",
                            size: "small"
                        })
                    }),
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $1bb718ecb5669b36$export$2e2bcd8739ae039), {
                        title: translate('toolbar.exportPDF'),
                        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $67d71c16fdfc3a0e$export$2e2bcd8739ae039), {
                            "aria-label": translate('toolbar.exportPDF'),
                            className: "mr-2",
                            icon: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $093f7bace4fdf24c$export$2e2bcd8739ae039), {}),
                            onClick: ()=>{
                                const selectedMusicSheet = musicSheets.find((musicSheet)=>musicSheet.id === selectedMusicSheetID);
                                const pdfDocument = new (0, $8ef89c7a1ffa2c2d$export$2e2bcd8739ae039)({
                                    autoFirstPage: false,
                                    info: {
                                        Title: selectedMusicSheet.title,
                                        Subject: translate('melodyAnalysis')
                                    },
                                    size: 'A4'
                                });
                                const stream = pdfDocument.pipe((0, (/*@__PURE__*/$parcel$interopDefault($8728cf26869ed5b2$exports)))());
                                for(let pageNumber = 1; pageNumber <= numberOfPages; pageNumber++){
                                    const pageContent = document.querySelector((0, $2c02c8dc1811708f$export$ca52df61d3bbb90)(pageNumber));
                                    pdfDocument.addPage();
                                    (0, (/*@__PURE__*/$parcel$interopDefault($b4Fkn)))(pdfDocument, pageContent.outerHTML, 0, 0, {
                                        preserveAspectRatio: 'xMidYMid meet'
                                    });
                                }
                                pdfDocument.end();
                                stream.on('finish', function() {
                                    const blob = this.toBlob();
                                    (0, $ed2b12aa71a74467$exports.saveAs)(blob, `${translate(`musicSheets.${selectedMusicSheet.title}`, {
                                        defaultValue: selectedMusicSheet.title
                                    })}.pdf`);
                                });
                            },
                            size: "small",
                            shape: "circle"
                        })
                    }),
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $ee1d917a45794f63$export$2e2bcd8739ae039), {
                        cancelText: translate('toolbar.cancel'),
                        okButtonProps: {
                            danger: true
                        },
                        okText: translate('toolbar.delete'),
                        onOpenChange: setIsConfirmingDeletion,
                        onConfirm: ()=>{
                            setConfiguringID(undefined);
                            setNewPattern(undefined);
                            setPatterns([]);
                            setSuggestingID(undefined);
                        },
                        title: translate('toolbar.deleteAllConfirm'),
                        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $1bb718ecb5669b36$export$2e2bcd8739ae039), {
                            open: isConfirmingDeletion ? false : undefined,
                            title: translate('toolbar.deleteAll'),
                            children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $67d71c16fdfc3a0e$export$2e2bcd8739ae039), {
                                "aria-label": translate('toolbar.deleteAll'),
                                className: "mr-2",
                                danger: true,
                                icon: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $424ba773c7c920f3$export$2e2bcd8739ae039), {}),
                                size: "small",
                                shape: "circle"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $c89b7140c7bc4e1c$export$2e2bcd8739ae039), {
                        menu: {
                            items: [
                                {
                                    key: 'color-by-voice',
                                    label: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $7f1dcd4b821f85a8$export$2e2bcd8739ae039), {
                                        checked: theme.colorByVoice,
                                        onChange: (event)=>setTheme((oldTheme)=>({
                                                    ...oldTheme,
                                                    colorByVoice: event.target.checked,
                                                    colorVoices: oldTheme.colorVoices
                                                })),
                                        children: translate('settings.colorByVoice')
                                    })
                                },
                                {
                                    key: 'color-voices',
                                    label: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $7f1dcd4b821f85a8$export$2e2bcd8739ae039), {
                                        checked: theme.colorVoices,
                                        onChange: (event)=>setTheme((oldTheme)=>({
                                                    ...oldTheme,
                                                    colorByVoice: oldTheme.colorByVoice,
                                                    colorVoices: event.target.checked
                                                })),
                                        children: translate('settings.colorVoices')
                                    })
                                }
                            ]
                        },
                        placement: "bottomRight",
                        trigger: [
                            'click'
                        ],
                        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $67d71c16fdfc3a0e$export$2e2bcd8739ae039), {
                            "aria-label": translate('toolbar.settings'),
                            icon: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $a988bc300b3d4f80$export$2e2bcd8739ae039), {}),
                            size: "small",
                            shape: "circle",
                            title: translate('toolbar.settings')
                        })
                    })
                ]
            })
        ]
    });
};
var $f622dfa4f509b5fa$export$2e2bcd8739ae039 = $f622dfa4f509b5fa$var$MusicSheetSelection;





var $5E6i4 = parcelRequire("5E6i4");


var $5E6i4 = parcelRequire("5E6i4");
// src/useBreakpoint.tsx

var $5E6i4 = parcelRequire("5E6i4");
// src/helpers.ts
function $672b606f04caafab$var$isOfType(type) {
    return (value)=>typeof value === type;
}
var $672b606f04caafab$var$isFunction = $672b606f04caafab$var$isOfType("function");
var $672b606f04caafab$var$isNull = (value)=>{
    return value === null;
};
var $672b606f04caafab$var$isRegex = (value)=>{
    return Object.prototype.toString.call(value).slice(8, -1) === "RegExp";
};
var $672b606f04caafab$var$isObject = (value)=>{
    return !$672b606f04caafab$var$isUndefined(value) && !$672b606f04caafab$var$isNull(value) && ($672b606f04caafab$var$isFunction(value) || typeof value === "object");
};
var $672b606f04caafab$var$isUndefined = $672b606f04caafab$var$isOfType("undefined");
// src/index.ts
function $672b606f04caafab$var$compareObjects(left, right, seen) {
    if ($672b606f04caafab$var$hasSeen(seen, left, right)) return true;
    $672b606f04caafab$var$markSeen(seen, left, right);
    if (left.constructor !== right.constructor) return false;
    if (Array.isArray(left) && Array.isArray(right)) return $672b606f04caafab$var$equalArray(left, right, seen);
    if (left instanceof Map && right instanceof Map) return $672b606f04caafab$var$equalMap(left, right, seen);
    if (left instanceof Set && right instanceof Set) return $672b606f04caafab$var$equalSet(left, right);
    if (left instanceof WeakMap || left instanceof WeakSet) return false;
    if (ArrayBuffer.isView(left) && ArrayBuffer.isView(right)) return $672b606f04caafab$var$equalArrayBuffer(left, right);
    if ($672b606f04caafab$var$isRegex(left) && $672b606f04caafab$var$isRegex(right)) return left.source === right.source && left.flags === right.flags;
    if (left instanceof Error && right instanceof Error) return $672b606f04caafab$var$equalError(left, right, seen);
    if (left.valueOf !== Object.prototype.valueOf) return left.valueOf() === right.valueOf();
    if (left.toString !== Object.prototype.toString) return left.toString() === right.toString();
    return $672b606f04caafab$var$equalPlainObject(left, right, seen);
}
function $672b606f04caafab$var$compareValues(left, right, seen) {
    if (left === right) return true;
    if (Number.isNaN(left) && Number.isNaN(right)) return true;
    if (!left || !$672b606f04caafab$var$isObject(left) || !right || !$672b606f04caafab$var$isObject(right)) return false;
    return $672b606f04caafab$var$compareObjects(left, right, seen);
}
function $672b606f04caafab$var$equalArray(left, right, seen) {
    const { length: length } = left;
    if (length !== right.length) return false;
    for(let index = length; index-- !== 0;){
        if (!$672b606f04caafab$var$compareValues(left[index], right[index], seen)) return false;
    }
    return true;
}
function $672b606f04caafab$var$equalArrayBuffer(left, right) {
    if (left.byteLength !== right.byteLength) return false;
    const view1 = new DataView(left.buffer);
    const view2 = new DataView(right.buffer);
    let index = left.byteLength;
    while(index--){
        if (view1.getUint8(index) !== view2.getUint8(index)) return false;
    }
    return true;
}
function $672b606f04caafab$var$equalError(left, right, seen) {
    return left.message === right.message && left.name === right.name && $672b606f04caafab$var$compareValues(left.cause, right.cause, seen);
}
function $672b606f04caafab$var$equalMap(left, right, seen) {
    if (left.size !== right.size) return false;
    for (const entry of left.entries()){
        if (!right.has(entry[0])) return false;
    }
    for (const entry of left.entries()){
        if (!$672b606f04caafab$var$compareValues(entry[1], right.get(entry[0]), seen)) return false;
    }
    return true;
}
function $672b606f04caafab$var$equalPlainObject(left, right, seen) {
    const leftKeys = Object.keys(left);
    if (leftKeys.length !== Object.keys(right).length) return false;
    for(let index = leftKeys.length; index-- !== 0;){
        if (!Object.prototype.hasOwnProperty.call(right, leftKeys[index])) return false;
    }
    for(let index = leftKeys.length; index-- !== 0;){
        const key = leftKeys[index];
        if (key === "_owner" && left.$$typeof) continue;
        if (!$672b606f04caafab$var$compareValues(left[key], right[key], seen)) return false;
    }
    return true;
}
function $672b606f04caafab$var$equalSet(left, right) {
    if (left.size !== right.size) return false;
    for (const entry of left.entries()){
        if (!right.has(entry[0])) return false;
    }
    return true;
}
function $672b606f04caafab$var$hasSeen(seen, left, right) {
    return seen.get(left)?.has(right) ?? false;
}
function $672b606f04caafab$var$markSeen(seen, left, right) {
    let set = seen.get(left);
    if (!set) {
        set = /* @__PURE__ */ new WeakSet();
        seen.set(left, set);
    }
    set.add(right);
}
function $672b606f04caafab$export$2e2bcd8739ae039(left, right) {
    return $672b606f04caafab$var$compareValues(left, right, /* @__PURE__ */ new WeakMap());
}


// src/utils.ts
function $934659347f213961$var$canUseDOM() {
    return !!(typeof window !== "undefined" && window?.document?.createElement);
}
function $934659347f213961$var$getElement(target) {
    if (!$934659347f213961$var$canUseDOM()) return null;
    let targetEl;
    if (typeof target === "string") targetEl = document.querySelector(target);
    else targetEl = target && "current" in target ? target.current : target;
    return targetEl;
}
function $934659347f213961$var$isPlainObject(value) {
    if (Object.prototype.toString.call(value) !== "[object Object]") return false;
    const prototype = Object.getPrototypeOf(value);
    return prototype === null || prototype === Object.getPrototypeOf({});
}
function $934659347f213961$var$isPrimitive(value) {
    return value !== Object(value);
}
function $934659347f213961$var$isString(value) {
    return typeof value === "string";
}
function $934659347f213961$var$isURL(value) {
    if (!$934659347f213961$var$isString(value)) return false;
    try {
        new URL(value);
        return true;
    } catch  {
        return false;
    }
}
function $934659347f213961$var$noop() {
    return void 0;
}
function $934659347f213961$var$off(target, ...rest) {
    if (target && target.removeEventListener) target.removeEventListener(...rest);
}
function $934659347f213961$var$on(target, ...rest) {
    if (target && target.addEventListener) target.addEventListener(...rest);
}
function $934659347f213961$var$validateDependencies(dependencies, name, fallback) {}
// src/useBreakpoint.tsx
var $934659347f213961$var$defaultBreakpoints = {
    xs: 0,
    sm: 400,
    md: 768,
    lg: 1024,
    xl: 1280
};
function $934659347f213961$export$199d6754bdf4e1e3(customBreakpoints, initialWidth = Infinity, initialHeight = Infinity) {
    const breakpoints = customBreakpoints ?? $934659347f213961$var$defaultBreakpoints;
    const sizes = (0, $5E6i4.useMemo)(()=>Object.entries(breakpoints).sort(([, aSize], [, bSize])=>bSize - aSize), [
        breakpoints
    ]);
    const smallestBreakpoint = sizes[sizes.length - 1];
    smallestBreakpoint[1];
    const getScreen = (0, $5E6i4.useCallback)(()=>{
        const height = $934659347f213961$var$canUseDOM() ? window.innerHeight : initialHeight;
        const width = $934659347f213961$var$canUseDOM() ? window.innerWidth : initialWidth;
        const size = sizes.find(([, s])=>s <= width) || sizes[0];
        const orientation = width > height ? "landscape" : "portrait";
        return {
            between: (min, max, andOrientation)=>width >= breakpoints[min] && width < breakpoints[max] && (!andOrientation || andOrientation === orientation),
            min: (breakpoint, andOrientation)=>width >= breakpoints[breakpoint] && (!andOrientation || andOrientation === orientation),
            max: (breakpoint, andOrientation)=>width < breakpoints[breakpoint] && (!andOrientation || andOrientation === orientation),
            orientation: orientation,
            size: size[0]
        };
    }, [
        breakpoints,
        initialHeight,
        initialWidth,
        sizes
    ]);
    const [screen, setScreen] = (0, $5E6i4.useState)(getScreen);
    (0, $5E6i4.useEffect)(()=>{
        const onResize = ()=>{
            setScreen((previous)=>{
                const current = getScreen();
                return current.size !== previous.size || current.orientation !== previous.orientation ? current : previous;
            });
        };
        $934659347f213961$var$on(window, "resize", onResize);
        return ()=>$934659347f213961$var$off(window, "resize", onResize);
    }, [
        getScreen
    ]);
    return screen;
}
function $934659347f213961$export$5424e08130ed6901(callback, dependencies) {
    $934659347f213961$var$validateDependencies(dependencies, "useCallbackDeepCompare", "useCallback");
    const ref = (0, $5E6i4.useRef)(dependencies);
    const callbackRef = (0, $5E6i4.useRef)(callback);
    if (!(0, $672b606f04caafab$export$2e2bcd8739ae039)(dependencies, ref.current)) {
        ref.current = dependencies;
        callbackRef.current = callback;
    }
    return (0, $5E6i4.useCallback)((...arguments_)=>callbackRef.current(...arguments_), // eslint-disable-next-line react-hooks/exhaustive-deps
    ref.current);
}
function $934659347f213961$export$3b0408fa4567aa7b(effect, dependencies) {
    $934659347f213961$var$validateDependencies(dependencies, "useEffectDeepCompare", "useEffect");
    const ref = (0, $5E6i4.useRef)(dependencies);
    if (!(0, $672b606f04caafab$export$2e2bcd8739ae039)(dependencies, ref.current)) ref.current = dependencies;
    (0, $5E6i4.useEffect)(effect, ref.current);
}
function $934659347f213961$export$5964c316e853650f() {
    const isFirstRender = (0, $5E6i4.useRef)(true);
    if (isFirstRender.current) {
        isFirstRender.current = false;
        return true;
    }
    return isFirstRender.current;
}
// src/useMemoizedValue.ts
function $934659347f213961$export$587475f9c8f166d3(value) {
    const [stableValue, setStableValue] = (0, $5E6i4.useState)(()=>value);
    const isFirstRender = $934659347f213961$export$5964c316e853650f();
    $934659347f213961$export$3b0408fa4567aa7b(()=>{
        if (isFirstRender) return;
        setStableValue(()=>value);
    }, [
        value
    ]);
    return stableValue;
}
// src/useClickOutside.ts
function $934659347f213961$export$1896bab46732d207(callback) {
    const ref = (0, $5E6i4.useRef)(null);
    const memoizedCallback = $934659347f213961$export$587475f9c8f166d3(callback);
    (0, $5E6i4.useEffect)(()=>{
        const handleClick = (event)=>{
            if (!ref.current?.contains(event.target)) memoizedCallback();
        };
        $934659347f213961$var$on(document, "click", handleClick);
        return ()=>{
            $934659347f213961$var$off(document, "click", handleClick);
        };
    }, [
        memoizedCallback
    ]);
    return ref;
}
function $934659347f213961$export$496315a1608d9602(effect, dependencies) {
    const isFirstRender = $934659347f213961$export$5964c316e853650f();
    (0, $5E6i4.useEffect)(()=>{
        if (!isFirstRender) return effect();
        return void 0;
    }, dependencies);
}
// src/useDataChanges.tsx
function $934659347f213961$export$f95fe7f8be13a45b(data, nameOrOptions = {}) {
    const previousData = (0, $5E6i4.useRef)(data);
    const [changes, setChanges] = (0, $5E6i4.useState)(void 0);
    const { comparison: comparison = "shallow", name: name, only: only, skipLog: skipLog = false } = $934659347f213961$export$587475f9c8f166d3($934659347f213961$var$isString(nameOrOptions) ? {
        name: nameOrOptions
    } : nameOrOptions);
    $934659347f213961$export$496315a1608d9602(()=>{
        const keysToCheck = only ?? Object.keys({
            ...previousData.current,
            ...data
        });
        const changesObject = {};
        keysToCheck.forEach((key)=>{
            const hasChanged = comparison === "deep" ? !(0, $672b606f04caafab$export$2e2bcd8739ae039)(previousData.current[key], data[key]) : previousData.current[key] !== data[key];
            if (hasChanged) changesObject[key] = {
                from: previousData.current[key],
                to: data[key]
            };
        });
        const hasChanges = Object.keys(changesObject).length > 0;
        setChanges(hasChanges ? changesObject : void 0);
        if (hasChanges && !skipLog) {
            const nameToken = name ? `: ${name}` : "";
            console.log(`[data-changes${nameToken}]`, changesObject);
        }
        previousData.current = data;
    }, [
        name,
        data,
        only,
        comparison,
        skipLog
    ]);
    return changes;
}
function $934659347f213961$export$21805fee57372823(callback, delayMs = 250, dependencies = []) {
    const status = (0, $5E6i4.useRef)("pending");
    const timeout = (0, $5E6i4.useRef)(null);
    const savedCallback = (0, $5E6i4.useRef)(callback);
    const isFirstRender = $934659347f213961$export$5964c316e853650f();
    const clear = (0, $5E6i4.useCallback)(()=>{
        status.current = "cancelled";
        timeout.current && clearTimeout(timeout.current);
    }, []);
    const set = (0, $5E6i4.useCallback)(()=>{
        status.current = "pending";
        timeout.current && clearTimeout(timeout.current);
        timeout.current = setTimeout(()=>{
            status.current = "completed";
            savedCallback.current();
        }, delayMs);
    }, [
        delayMs
    ]);
    const getStatus = (0, $5E6i4.useCallback)(()=>status.current, []);
    (0, $5E6i4.useEffect)(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    $934659347f213961$export$3b0408fa4567aa7b(()=>{
        if (!isFirstRender) {
            set();
            return clear;
        }
        return void 0;
    }, [
        set,
        clear,
        dependencies,
        delayMs
    ]);
    return {
        cancel: clear,
        getStatus: getStatus
    };
}
function $934659347f213961$export$b558662bb0641046(effect) {
    const destroyFn = (0, $5E6i4.useRef)(null);
    const effectCalled = (0, $5E6i4.useRef)(false);
    const effectFn = (0, $5E6i4.useRef)(effect);
    (0, $5E6i4.useEffect)(()=>{
        if (!effectCalled.current) {
            destroyFn.current = effectFn.current();
            effectCalled.current = true;
        }
        return ()=>{
            if (destroyFn.current) {
                destroyFn.current();
                destroyFn.current = null;
            }
        };
    }, []);
}
// src/defaults.ts
var $934659347f213961$var$defaultElementDimensions = {
    absoluteHeight: 0,
    absoluteWidth: 0,
    bottom: 0,
    height: 0,
    left: 0,
    right: 0,
    top: 0,
    width: 0,
    x: 0,
    y: 0
};
var $934659347f213961$export$700979bc83e7db82 = $934659347f213961$var$canUseDOM() ? (0, $5E6i4.useLayoutEffect) : (0, $5E6i4.useEffect);
function $934659347f213961$export$683480f191c0e3ea(target, debounce = 0) {
    const [element, setElement] = (0, $5E6i4.useState)($934659347f213961$var$getElement(target));
    const [value, setValue] = (0, $5E6i4.useState)();
    const timeoutRef = (0, $5E6i4.useRef)(null);
    const isFirstCall = (0, $5E6i4.useRef)(true);
    const observer = (0, $5E6i4.useMemo)(()=>{
        if (!$934659347f213961$var$canUseDOM()) return {};
        return new window.ResizeObserver((entries)=>{
            if (debounce && !isFirstCall.current) {
                if (timeoutRef.current) window.clearTimeout(timeoutRef.current);
                timeoutRef.current = window.setTimeout(()=>{
                    setValue(entries[0]);
                }, debounce);
                return;
            }
            setValue(entries[0]);
            isFirstCall.current = false;
        });
    }, [
        debounce
    ]);
    $934659347f213961$export$700979bc83e7db82(()=>{
        setElement($934659347f213961$var$getElement(target));
    }, [
        target
    ]);
    $934659347f213961$export$700979bc83e7db82(()=>{
        if (!$934659347f213961$var$canUseDOM() || !(observer instanceof ResizeObserver)) return ()=>void 0;
        if (!element) return ()=>void 0;
        observer.observe(element);
        return ()=>{
            observer.disconnect();
        };
    }, [
        element,
        observer
    ]);
    return value;
}
// src/useElementMeasure.tsx
function $934659347f213961$var$getElementMeasure(element) {
    if (!$934659347f213961$var$canUseDOM() || !element) return $934659347f213961$var$defaultElementDimensions;
    const { bottom: bottom, height: height, left: left, right: right, top: top, width: width, x: x, y: y } = element.getBoundingClientRect();
    const { borderBottom: borderBottom, borderLeft: borderLeft, borderRight: borderRight, borderTop: borderTop, paddingBottom: paddingBottom, paddingLeft: paddingLeft, paddingRight: paddingRight, paddingTop: paddingTop } = getComputedStyle(element);
    return {
        absoluteHeight: height - $934659347f213961$var$parseFloatValue(paddingTop) - $934659347f213961$var$parseFloatValue(paddingBottom) - $934659347f213961$var$parseFloatValue(borderTop) - $934659347f213961$var$parseFloatValue(borderBottom),
        absoluteWidth: width - $934659347f213961$var$parseFloatValue(paddingLeft) - $934659347f213961$var$parseFloatValue(paddingRight) - $934659347f213961$var$parseFloatValue(borderLeft) - $934659347f213961$var$parseFloatValue(borderRight),
        bottom: bottom,
        height: height,
        left: left,
        right: right,
        top: top,
        width: width,
        x: x,
        y: y
    };
}
function $934659347f213961$var$parseFloatValue(value) {
    const parsed = parseFloat(value);
    return Number.isNaN(parsed) ? 0 : parsed;
}
function $934659347f213961$export$1baf07b85290305e(target, debounce = 0) {
    const [element, setElement] = (0, $5E6i4.useState)($934659347f213961$var$getElement(target));
    const [dimensions, setDimensions] = (0, $5E6i4.useState)($934659347f213961$var$getElementMeasure(element));
    const entry = $934659347f213961$export$683480f191c0e3ea(element, debounce);
    $934659347f213961$export$700979bc83e7db82(()=>{
        const nextElement = $934659347f213961$var$getElement(target);
        setElement(nextElement);
        setDimensions($934659347f213961$var$getElementMeasure(nextElement));
    }, [
        target
    ]);
    $934659347f213961$export$700979bc83e7db82(()=>{
        if (!entry) return;
        const { bottom: bottom, height: height, left: left, right: right, top: top, width: width, x: x, y: y } = entry.contentRect;
        const { blockSize: blockSize, inlineSize: inlineSize } = entry.borderBoxSize[0];
        setDimensions({
            absoluteHeight: blockSize,
            absoluteWidth: inlineSize,
            bottom: bottom,
            height: height,
            left: left,
            right: right,
            top: top,
            width: width,
            x: x,
            y: y
        });
    }, [
        entry
    ]);
    return dimensions;
}
function $934659347f213961$export$80c2a3957bcb42ea() {
    const isMounted = (0, $5E6i4.useRef)(false);
    (0, $5E6i4.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return (0, $5E6i4.useCallback)(()=>isMounted.current, []);
}
function $934659347f213961$export$5cae361ad82dce8b(state) {
    const ref = (0, $5E6i4.useRef)(void 0);
    (0, $5E6i4.useEffect)(()=>{
        ref.current = state;
    });
    return ref.current;
}
function $934659347f213961$export$89c35abda4d6d7ba(initialState = {}) {
    const [state, set] = (0, $5E6i4.useState)(initialState);
    const setState = (0, $5E6i4.useCallback)((patch)=>{
        set((previousState)=>({
                ...previousState,
                ...patch instanceof Function ? patch(previousState) : patch
            }));
    }, []);
    return [
        state,
        setState
    ];
}
// src/useFetch.ts
var $934659347f213961$export$efb9d22e8516fca0 = {
    IDLE: "IDLE",
    LOADING: "LOADING",
    SUCCESS: "SUCCESS",
    ERROR: "ERROR"
};
var $934659347f213961$var$globalCache = /* @__PURE__ */ new Map();
async function $934659347f213961$var$request(options) {
    const { body: body, headers: headers = {}, method: method = "GET", mode: mode = "cors", type: type = "json", url: url = "" } = options;
    const contentTypes = {
        json: "application/json",
        urlencoded: "application/x-www-form-urlencoded"
    };
    const params = {
        body: void 0,
        cache: "no-store",
        headers: {
            Accept: "application/json",
            "Content-Type": contentTypes[type],
            ...headers
        },
        method: method,
        mode: mode,
        credentials: void 0
    };
    if (body) params.body = $934659347f213961$var$isPlainObject(body) && type === "json" ? JSON.stringify(body) : body;
    try {
        const response = await fetch(url, params);
        let content;
        try {
            content = await response.json();
        } catch  {
            content = await response.text();
        }
        if (response.status > 299) {
            const error = new Error(response.statusText);
            error.status = response.status;
            error.response = content;
            throw error;
        }
        return content;
    } catch (error) {
        const fetchError = new Error("Network request failed");
        fetchError.status = 0;
        fetchError.response = error instanceof Error ? error.message : error;
        throw fetchError;
    }
}
var $934659347f213961$var$useFetchCache = {
    /**
   * Retrieve data from the cache.
   * @param url The URL to retrieve data for.
   * @returns Cached data or `undefined` if not found or expired.
   */ get (url) {
        const cached = $934659347f213961$var$globalCache.get(url);
        if (cached && Date.now() < cached.expiry) return cached;
        $934659347f213961$var$globalCache.delete(url);
        return void 0;
    },
    /**
   * Set data in the cache.
   * @param url The URL to cache data for.
   * @param data The data to cache.
   * @param ttl Time-to-live in milliseconds.
   */ set (url, data, ttl) {
        $934659347f213961$var$globalCache.set(url, {
            data: data,
            expiry: Date.now() + ttl
        });
    },
    /**
   * Clear the cache.
   * @param url Optional URL to clear. Clears all cache if not specified.
   */ clear (url) {
        if (url) $934659347f213961$var$globalCache.delete(url);
        else $934659347f213961$var$globalCache.clear();
    },
    /**
   * Check if a URL is cached and still valid.
   * @param url The URL to check.
   * @returns `true` if cached and valid, `false` otherwise.
   */ has (url) {
        const cached = $934659347f213961$var$globalCache.get(url);
        return !!cached && Date.now() < cached.expiry;
    }
};
function $934659347f213961$export$d852f5f778460fa4(urlOrOptions) {
    const { cacheTTL: cacheTTL = 0, onError: onError, onFinally: onFinally, onLoading: onLoading, onSuccess: onSuccess, retries: retries = 0, retryDelay: retryDelay = (attempt)=>attempt * 1e3, wait: wait = false, ...options } = $934659347f213961$export$587475f9c8f166d3($934659347f213961$var$isURL(urlOrOptions) ? {
        type: "json",
        url: urlOrOptions
    } : urlOrOptions);
    const [{ data: data, error: error, isCached: isCached, retryCount: retryCount, status: status, url: url }, setState] = $934659347f213961$export$89c35abda4d6d7ba({
        data: void 0,
        error: void 0,
        isCached: false,
        retryCount: null,
        status: $934659347f213961$export$efb9d22e8516fca0.IDLE,
        url: options.url
    });
    const isMounted = $934659347f213961$export$80c2a3957bcb42ea();
    const previousRetryCount = $934659347f213961$export$5cae361ad82dce8b(retryCount);
    if (!$934659347f213961$var$isPlainObject(options) || !$934659347f213961$var$isURL(url)) throw new Error("Expected an options object or URL");
    const getData = (0, $5E6i4.useCallback)((eraseData)=>{
        setState((s)=>({
                data: eraseData ? void 0 : s.data,
                error: void 0,
                isCached: false,
                status: $934659347f213961$export$efb9d22e8516fca0.LOADING
            }));
        onLoading?.();
        if (cacheTTL && $934659347f213961$var$useFetchCache.has(url) && !eraseData) {
            const cached = $934659347f213961$var$useFetchCache.get(url);
            if (cached) {
                setState({
                    data: cached.data,
                    error: void 0,
                    isCached: true,
                    status: $934659347f213961$export$efb9d22e8516fca0.SUCCESS
                });
                onSuccess?.(cached.data);
                onFinally?.();
                return;
            }
        }
        $934659347f213961$var$request({
            ...options
        }).then((response)=>{
            if (!isMounted()) return;
            if (cacheTTL) $934659347f213961$var$useFetchCache.set(url, response, cacheTTL);
            setState({
                data: response,
                retryCount: null,
                status: $934659347f213961$export$efb9d22e8516fca0.SUCCESS
            });
            onSuccess?.(response);
        }).catch((responseError)=>{
            if (!isMounted()) return;
            const counter = retryCount ?? 0;
            if (!retries || counter >= retries) {
                setState({
                    error: responseError,
                    status: $934659347f213961$export$efb9d22e8516fca0.ERROR
                });
                onError?.(responseError);
            }
            if (retries && counter < retries) setState({
                retryCount: counter + 1
            });
        }).finally(()=>{
            if (isMounted()) onFinally?.();
        });
    }, [
        cacheTTL,
        isMounted,
        onError,
        onFinally,
        onLoading,
        onSuccess,
        options,
        retries,
        retryCount,
        setState,
        url
    ]);
    (0, $5E6i4.useEffect)(()=>{
        if (url !== options.url) setState({
            data: void 0,
            error: void 0,
            status: $934659347f213961$export$efb9d22e8516fca0.IDLE,
            url: options.url
        });
    }, [
        options.url,
        setState,
        url
    ]);
    (0, $5E6i4.useEffect)(()=>{
        if (status === $934659347f213961$export$efb9d22e8516fca0.IDLE && !wait) getData();
    }, [
        getData,
        status,
        wait
    ]);
    (0, $5E6i4.useEffect)(()=>{
        if (retries && typeof retryCount === "number" && retryCount !== previousRetryCount) setTimeout(getData, typeof retryDelay === "function" ? retryDelay(retryCount) : retryDelay);
    }, [
        getData,
        previousRetryCount,
        retries,
        retryCount,
        retryDelay
    ]);
    const isError = (0, $5E6i4.useCallback)(()=>status === $934659347f213961$export$efb9d22e8516fca0.ERROR, [
        status
    ]);
    const isFetched = (0, $5E6i4.useCallback)(()=>[
            $934659347f213961$export$efb9d22e8516fca0.SUCCESS,
            $934659347f213961$export$efb9d22e8516fca0.ERROR
        ].includes(status), [
        status
    ]);
    const isLoading = (0, $5E6i4.useCallback)(()=>status === $934659347f213961$export$efb9d22e8516fca0.LOADING, [
        status
    ]);
    const isPaused = (0, $5E6i4.useCallback)(()=>status === $934659347f213961$export$efb9d22e8516fca0.IDLE && wait, [
        status,
        wait
    ]);
    const isSuccess = (0, $5E6i4.useCallback)(()=>status === $934659347f213961$export$efb9d22e8516fca0.SUCCESS, [
        status
    ]);
    const refetch = (0, $5E6i4.useCallback)((eraseData = false)=>getData(eraseData), [
        getData
    ]);
    return (0, $5E6i4.useMemo)(()=>({
            data: data,
            error: error,
            isCached: isCached,
            isError: isError,
            isFetched: isFetched,
            isLoading: isLoading,
            isPaused: isPaused,
            isSuccess: isSuccess,
            refetch: refetch,
            retryCount: retryCount,
            status: status,
            url: url
        }), [
        data,
        error,
        isCached,
        isError,
        isFetched,
        isLoading,
        isPaused,
        isSuccess,
        refetch,
        retryCount,
        status,
        url
    ]);
}
function $934659347f213961$export$1d120d47ef527b1d(value, callback) {
    const previous = $934659347f213961$export$5cae361ad82dce8b(value);
    const hasChanged = typeof previous !== "undefined" && previous !== value;
    (0, $5E6i4.useEffect)(()=>{
        if (hasChanged) callback?.(previous);
    }, [
        callback,
        hasChanged,
        previous
    ]);
    return [
        hasChanged,
        previous
    ];
}
function $934659347f213961$export$a7395f9832c00176(target, options) {
    const { delay: delay = 0, once: once = false, root: root = null, rootMargin: rootMargin = "0%", threshold: threshold = 0 } = options || {};
    const [value, setValue] = (0, $5E6i4.useState)();
    const disabled = value?.isIntersecting && once;
    const observer = (0, $5E6i4.useMemo)(()=>{
        if (!$934659347f213961$var$canUseDOM()) return {};
        return new IntersectionObserver(([entry])=>{
            if (delay) {
                setTimeout(()=>setValue(entry), delay);
                return;
            }
            setValue(entry);
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
    }, [
        delay,
        root,
        rootMargin,
        threshold
    ]);
    (0, $5E6i4.useEffect)(()=>{
        if (!$934659347f213961$var$canUseDOM() || !(observer instanceof IntersectionObserver) || disabled) return ()=>void 0;
        const element = $934659347f213961$var$getElement(target);
        if (!element) return ()=>void 0;
        observer.observe(element);
        return ()=>observer.disconnect();
    }, [
        target,
        root,
        rootMargin,
        disabled,
        observer
    ]);
    return value;
}
function $934659347f213961$export$f4b266cd2aae9cb1(callback, delayMs = 100) {
    const savedCallback = (0, $5E6i4.useRef)(callback);
    (0, $5E6i4.useEffect)(()=>{
        savedCallback.current = callback;
    });
    (0, $5E6i4.useEffect)(()=>{
        if (delayMs !== null) {
            const interval = setInterval(()=>savedCallback.current(), delayMs);
            return ()=>{
                clearInterval(interval);
            };
        }
        return void 0;
    }, [
        delayMs
    ]);
}
function $934659347f213961$export$d4b699e2c1148419(value) {
    const ref = (0, $5E6i4.useRef)(value);
    (0, $5E6i4.useEffect)(()=>{
        ref.current = value;
    });
    return ref;
}
function $934659347f213961$export$5253e3e8eecae0a3(mount, unmount) {
    (0, $5E6i4.useEffect)(()=>{
        mount();
        return unmount;
    }, []);
}
function $934659347f213961$var$useLocalStorageHook(key, initialValue, options) {
    if (!key) throw new Error('useLocalStorage: "key" is required');
    const deserializer = (0, $5E6i4.useMemo)(()=>options?.raw ? (value)=>value : options?.deserializer ?? JSON.parse, [
        options
    ]);
    const serializer = (0, $5E6i4.useMemo)(()=>options?.raw ? String : options?.serializer ?? JSON.stringify, [
        options
    ]);
    const initializer = (0, $5E6i4.useRef)((k)=>{
        try {
            const localStorageValue = localStorage.getItem(k);
            if (localStorageValue !== null) return deserializer(localStorageValue);
            initialValue && localStorage.setItem(k, serializer(initialValue));
            return initialValue;
        } catch  {
            return initialValue;
        }
    });
    const [state, setState] = (0, $5E6i4.useState)(()=>initializer.current(key));
    (0, $5E6i4.useLayoutEffect)(()=>setState(initializer.current(key)), [
        key
    ]);
    const set = (0, $5E6i4.useCallback)((patch)=>{
        try {
            const newState = patch instanceof Function ? patch(state) : patch;
            if (typeof newState === "undefined") return;
            let value;
            if (options) {
                if (options.raw) value = typeof newState === "string" ? newState : JSON.stringify(newState);
                else if (options?.serializer) value = options.serializer(newState);
                else value = JSON.stringify(newState);
            } else value = JSON.stringify(newState);
            localStorage.setItem(key, value);
            setState(deserializer(value));
        } catch  {}
    }, [
        deserializer,
        key,
        options,
        state
    ]);
    const remove = (0, $5E6i4.useCallback)(()=>{
        try {
            localStorage.removeItem(key);
            setState(void 0);
        } catch  {}
    }, [
        key,
        setState
    ]);
    return [
        state,
        set,
        remove
    ];
}
function $934659347f213961$var$useLocalStorageSSR(_key, initialValue, _options) {
    return [
        initialValue,
        $934659347f213961$var$noop,
        $934659347f213961$var$noop
    ];
}
var $934659347f213961$export$86e2cef2561044ac = $934659347f213961$var$canUseDOM() ? $934659347f213961$var$useLocalStorageHook : $934659347f213961$var$useLocalStorageSSR;
// src/useLocation.ts
function $934659347f213961$export$45d76561a5302f2b() {
    const { hash: hash, host: host, hostname: hostname, href: href, origin: origin, pathname: pathname, port: port, protocol: protocol, search: search } = window.location;
    const query = search ? search.slice(1).split("&").reduce((acc, pair)=>{
        const [key, value] = pair.split("=");
        if (key && value) acc[key] = value;
        return acc;
    }, {}) : {};
    return {
        hash: hash,
        host: host,
        hostname: hostname,
        href: href,
        origin: origin,
        pathname: pathname,
        port: port,
        protocol: protocol,
        query: query,
        search: search
    };
}
function $934659347f213961$export$32d5543ab307c01(input) {
    const getMatches = (query)=>{
        if (!$934659347f213961$var$canUseDOM()) return false;
        return window.matchMedia(query).matches;
    };
    const [matches, setMatches] = (0, $5E6i4.useState)(getMatches(input));
    function handleChange() {
        setMatches(getMatches(input));
    }
    (0, $5E6i4.useEffect)(()=>{
        const matchMedia = window.matchMedia(input);
        handleChange();
        try {
            matchMedia.addEventListener("change", handleChange);
        } catch  {
            matchMedia.addListener(handleChange);
        }
        return ()=>{
            try {
                matchMedia.removeEventListener("change", handleChange);
            } catch  {
                matchMedia.removeListener(handleChange);
            }
        };
    }, [
        input
    ]);
    return matches;
}
function $934659347f213961$export$75842ffadd0a4898(factory, dependencies) {
    $934659347f213961$var$validateDependencies(dependencies, "useMemoDeepCompare", "useMemo");
    const ref = (0, $5E6i4.useRef)(dependencies);
    if (!(0, $672b606f04caafab$export$2e2bcd8739ae039)(dependencies, ref.current)) ref.current = dependencies;
    return (0, $5E6i4.useMemo)(factory, ref.current);
}
function $934659347f213961$export$74665b213cb5c4cf(...refs) {
    return (0, $5E6i4.useCallback)((value)=>{
        for (const ref of refs){
            if (typeof ref === "function") ref(value);
            else if (ref && typeof ref === "object") ref.current = value;
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    refs);
}
function $934659347f213961$export$17f7c8f694d207ce(callback) {
    (0, $5E6i4.useEffect)(()=>{
        callback();
    }, []);
}
function $934659347f213961$export$392544347a18b6ea(callback) {
    const hasBeenCalled = (0, $5E6i4.useRef)(false);
    if (hasBeenCalled.current) return;
    callback();
    hasBeenCalled.current = true;
}
// src/usePersistentState.ts
function $934659347f213961$var$getState(initialState, savedState, shouldOverride, restoreProperties) {
    if (shouldOverride) {
        const initialStateKeys = Object.keys(initialState);
        const savedStateKeys = savedState ? Object.keys(savedState) : [];
        const restorePropertiesKeys = restoreProperties ? Object.keys(restoreProperties) : [];
        if (![
            ...initialStateKeys,
            ...restorePropertiesKeys
        ].every((k)=>savedStateKeys.includes(k))) return {
            ...initialState,
            ...restoreProperties
        };
        return {
            ...savedState,
            ...restoreProperties
        };
    }
    return {
        ...savedState,
        ...restoreProperties
    };
}
function $934659347f213961$export$3f593372777bd353(key, initialState, options) {
    const { overrideDivergentSavedState: overrideDivergentSavedState = false, resetProperties: resetProperties } = options || {};
    const [value, setValue, remove] = $934659347f213961$export$86e2cef2561044ac(key, initialState);
    const [state, setState] = $934659347f213961$export$89c35abda4d6d7ba($934659347f213961$var$getState(initialState, value, overrideDivergentSavedState, resetProperties));
    $934659347f213961$export$3b0408fa4567aa7b(()=>{
        setValue(state);
    }, [
        setValue,
        state
    ]);
    return [
        state,
        setState,
        remove
    ];
}
function $934659347f213961$export$894a34a32cdbdc06(name) {
    const count = (0, $5E6i4.useRef)(1);
    (0, $5E6i4.useEffect)(()=>{
        count.current += 1;
    });
    console.log(`%c${name || "RenderCount"}: %c${count.current}`, "font-size: 14px;  font-weight: bold;", "color: #999; font-size: 14px;");
    return count.current;
}
function $934659347f213961$export$1d3955b0b5cace9c(src, idOrOptions = {}) {
    const options = (0, $5E6i4.useMemo)(()=>$934659347f213961$var$isString(idOrOptions) ? {
            id: idOrOptions
        } : idOrOptions, [
        idOrOptions
    ]);
    const script = (0, $5E6i4.useRef)(null);
    const [state, setState] = (0, $5E6i4.useState)({
        loaded: false,
        error: false
    });
    const onLoad = (0, $5E6i4.useCallback)(()=>{
        setState({
            loaded: true,
            error: false
        });
    }, []);
    const onError = (0, $5E6i4.useCallback)(()=>{
        if (script.current) script.current.remove();
        setState({
            loaded: false,
            error: true
        });
    }, []);
    (0, $5E6i4.useEffect)(()=>{
        if (!$934659347f213961$var$canUseDOM() || script.current) return void 0;
        const element = document.createElement("script");
        element.async = options.async ?? true;
        element.defer = options.defer ?? false;
        element.type = options.type || "text/javascript";
        element.id = options.id || src;
        element.src = src;
        script.current = element;
        const { current: current } = script;
        $934659347f213961$var$on(current, "load", onLoad);
        $934659347f213961$var$on(current, "error", onError);
        document.body.appendChild(current);
        return ()=>{
            $934659347f213961$var$off(current, "load", onLoad);
            $934659347f213961$var$off(current, "error", onError);
        };
    }, [
        onError,
        onLoad,
        options,
        src
    ]);
    return [
        state.loaded,
        state.error
    ];
}
function $934659347f213961$export$89e33b3d84d8c331(callback) {
    const callbackRef = $934659347f213961$export$d4b699e2c1148419(callback);
    (0, $5E6i4.useEffect)(()=>{
        return ()=>callbackRef.current();
    }, []);
}
// src/useThrottle.ts
function $934659347f213961$export$8b7b9481d6186f21(callback, delayMs = 500, trailing = false) {
    const [now, setNow] = (0, $5E6i4.useState)(0);
    const callbackRef = (0, $5E6i4.useRef)(callback);
    const hasPendingCall = (0, $5E6i4.useRef)(false);
    const timer = (0, $5E6i4.useRef)(void 0);
    (0, $5E6i4.useEffect)(()=>{
        callbackRef.current = callback;
    }, [
        callback
    ]);
    (0, $5E6i4.useEffect)(()=>{
        if (!now) return;
        if (!timer.current) {
            callbackRef.current();
            const timerCallback = ()=>{
                if (hasPendingCall.current) {
                    hasPendingCall.current = false;
                    if (trailing) callbackRef.current();
                    timer.current = void 0;
                } else timer.current = void 0;
            };
            timer.current = window.setTimeout(timerCallback, delayMs);
        } else hasPendingCall.current = true;
    }, [
        delayMs,
        now,
        trailing
    ]);
    $934659347f213961$export$89e33b3d84d8c331(()=>{
        window.clearTimeout(timer.current);
        timer.current = void 0;
    });
    return ()=>setNow(Date.now());
}
function $934659347f213961$export$dc58a0cc2d0e92f6(value, delayMs) {
    const [throttledValue, setThrottledValue] = (0, $5E6i4.useState)(value);
    const hasNextValue = (0, $5E6i4.useRef)(false);
    const nextValue = (0, $5E6i4.useRef)(null);
    const timer = (0, $5E6i4.useRef)(void 0);
    (0, $5E6i4.useEffect)(()=>{
        if (!timer.current) {
            setThrottledValue(value);
            const timeoutCallback = ()=>{
                if (hasNextValue.current) {
                    hasNextValue.current = false;
                    setThrottledValue(nextValue.current);
                    timer.current = window.setTimeout(timeoutCallback, delayMs);
                } else timer.current = void 0;
            };
            timer.current = window.setTimeout(timeoutCallback, delayMs);
        } else {
            hasNextValue.current = true;
            nextValue.current = value;
        }
    }, [
        delayMs,
        value
    ]);
    $934659347f213961$export$89e33b3d84d8c331(()=>{
        window.clearTimeout(timer.current);
        timer.current = void 0;
    });
    return throttledValue;
}
function $934659347f213961$export$d8e6abf214c9ec0f(callback, delayMs = 0) {
    const status = (0, $5E6i4.useRef)("pending");
    const timeout = (0, $5E6i4.useRef)(null);
    const savedCallback = (0, $5E6i4.useRef)(callback);
    const clear = (0, $5E6i4.useCallback)(()=>{
        status.current = "cancelled";
        timeout.current && clearTimeout(timeout.current);
    }, []);
    const set = (0, $5E6i4.useCallback)(()=>{
        status.current = "pending";
        timeout.current && clearTimeout(timeout.current);
        timeout.current = setTimeout(()=>{
            status.current = "completed";
            savedCallback.current();
        }, delayMs);
    }, [
        delayMs
    ]);
    const getStatus = (0, $5E6i4.useCallback)(()=>status.current, []);
    (0, $5E6i4.useEffect)(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, $5E6i4.useEffect)(()=>{
        set();
        return clear;
    }, [
        set,
        clear
    ]);
    return {
        cancel: clear,
        getStatus: getStatus,
        reset: set
    };
}
function $934659347f213961$export$cbe85ee05b554577(initialValue = true) {
    const [value, toggle] = (0, $5E6i4.useReducer)((state, nextValue)=>typeof nextValue === "boolean" ? nextValue : !state, initialValue);
    const toggleOn = (0, $5E6i4.useCallback)(()=>toggle(true), []);
    const toggleOff = (0, $5E6i4.useCallback)(()=>toggle(false), []);
    return [
        value,
        {
            toggle: toggle,
            toggleOn: toggleOn,
            toggleOff: toggleOff
        }
    ];
}
var $934659347f213961$var$updateReducer = (number)=>(number + 1) % 1e6;
function $934659347f213961$export$74524c73191a667c() {
    const [, update] = (0, $5E6i4.useReducer)($934659347f213961$var$updateReducer, 0);
    return update;
}
function $934659347f213961$export$42c02f33970a2afa(debounce = 0) {
    const [size, setSize] = (0, $5E6i4.useState)({
        height: $934659347f213961$var$canUseDOM() ? window.innerHeight : 0,
        width: $934659347f213961$var$canUseDOM() ? window.innerWidth : 0
    });
    const timeoutRef = (0, $5E6i4.useRef)(0);
    const handleResize = (0, $5E6i4.useRef)(()=>{
        window.clearTimeout(timeoutRef.current);
        timeoutRef.current = window.setTimeout(()=>{
            setSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        }, debounce);
    });
    (0, $5E6i4.useEffect)(()=>{
        if (!$934659347f213961$var$canUseDOM()) return ()=>void 0;
        const getSize = handleResize.current;
        setSize({
            height: window.innerHeight,
            width: window.innerWidth
        });
        $934659347f213961$var$on(window, "resize", getSize);
        return ()=>{
            $934659347f213961$var$off(window, "resize", getSize);
        };
    }, []);
    return size;
}



// src/helpers.ts
var $209e2c4c2fa2f6ac$var$objectTypes = [
    "Array",
    "ArrayBuffer",
    "AsyncFunction",
    "AsyncGenerator",
    "AsyncGeneratorFunction",
    "Date",
    "Error",
    "Function",
    "Generator",
    "GeneratorFunction",
    "HTMLElement",
    "Map",
    "Object",
    "Promise",
    "RegExp",
    "Set",
    "URL",
    "WeakMap",
    "WeakSet"
];
var $209e2c4c2fa2f6ac$var$primitiveTypes = [
    "bigint",
    "boolean",
    "null",
    "number",
    "string",
    "symbol",
    "undefined"
];
function $209e2c4c2fa2f6ac$var$getObjectType(value) {
    const objectTypeName = Object.prototype.toString.call(value).slice(8, -1);
    if (/HTML\w+Element/.test(objectTypeName)) return "HTMLElement";
    if ($209e2c4c2fa2f6ac$var$isObjectType(objectTypeName)) return objectTypeName;
    return void 0;
}
function $209e2c4c2fa2f6ac$var$isObjectOfType(type) {
    return (value)=>$209e2c4c2fa2f6ac$var$getObjectType(value) === type;
}
function $209e2c4c2fa2f6ac$var$isObjectType(name) {
    return $209e2c4c2fa2f6ac$var$objectTypes.includes(name);
}
function $209e2c4c2fa2f6ac$var$isOfType(type) {
    return (value)=>typeof value === type;
}
function $209e2c4c2fa2f6ac$var$isPrimitiveType(name) {
    return $209e2c4c2fa2f6ac$var$primitiveTypes.includes(name);
}
// src/standalone.ts
var $209e2c4c2fa2f6ac$var$DOM_PROPERTIES_TO_CHECK = [
    "innerHTML",
    "ownerDocument",
    "style",
    "attributes",
    "nodeValue"
];
var $209e2c4c2fa2f6ac$var$isArray = (value)=>Array.isArray(value);
var $209e2c4c2fa2f6ac$var$isAsyncGeneratorFunction = (value)=>$209e2c4c2fa2f6ac$var$getObjectType(value) === "AsyncGeneratorFunction";
var $209e2c4c2fa2f6ac$var$isAsyncFunction = /* @__PURE__ */ $209e2c4c2fa2f6ac$var$isObjectOfType("AsyncFunction");
var $209e2c4c2fa2f6ac$var$isBigInt = /* @__PURE__ */ $209e2c4c2fa2f6ac$var$isOfType("bigint");
var $209e2c4c2fa2f6ac$var$isBoolean = (value)=>{
    return value === true || value === false;
};
var $209e2c4c2fa2f6ac$var$isDate = /* @__PURE__ */ $209e2c4c2fa2f6ac$var$isObjectOfType("Date");
var $209e2c4c2fa2f6ac$var$isError = /* @__PURE__ */ $209e2c4c2fa2f6ac$var$isObjectOfType("Error");
var $209e2c4c2fa2f6ac$var$isFunction = /* @__PURE__ */ $209e2c4c2fa2f6ac$var$isOfType("function");
var $209e2c4c2fa2f6ac$var$isGeneratorFunction = /* @__PURE__ */ $209e2c4c2fa2f6ac$var$isObjectOfType("GeneratorFunction");
var $209e2c4c2fa2f6ac$var$isInteger = (value)=>{
    return typeof value === "number" && Number.isInteger(value);
};
var $209e2c4c2fa2f6ac$var$isMap = /* @__PURE__ */ $209e2c4c2fa2f6ac$var$isObjectOfType("Map");
var $209e2c4c2fa2f6ac$var$isNan = (value)=>{
    return Number.isNaN(value);
};
var $209e2c4c2fa2f6ac$var$isNull = (value)=>{
    return value === null;
};
var $209e2c4c2fa2f6ac$var$isPlainFunction = /* @__PURE__ */ $209e2c4c2fa2f6ac$var$isObjectOfType("Function");
var $209e2c4c2fa2f6ac$var$isPromise = /* @__PURE__ */ $209e2c4c2fa2f6ac$var$isObjectOfType("Promise");
var $209e2c4c2fa2f6ac$var$isRegexp = /* @__PURE__ */ $209e2c4c2fa2f6ac$var$isObjectOfType("RegExp");
var $209e2c4c2fa2f6ac$var$isSet = /* @__PURE__ */ $209e2c4c2fa2f6ac$var$isObjectOfType("Set");
var $209e2c4c2fa2f6ac$var$isString = /* @__PURE__ */ $209e2c4c2fa2f6ac$var$isOfType("string");
var $209e2c4c2fa2f6ac$var$isSymbol = /* @__PURE__ */ $209e2c4c2fa2f6ac$var$isOfType("symbol");
var $209e2c4c2fa2f6ac$var$isUndefined = /* @__PURE__ */ $209e2c4c2fa2f6ac$var$isOfType("undefined");
var $209e2c4c2fa2f6ac$var$isWeakMap = /* @__PURE__ */ $209e2c4c2fa2f6ac$var$isObjectOfType("WeakMap");
var $209e2c4c2fa2f6ac$var$isWeakSet = /* @__PURE__ */ $209e2c4c2fa2f6ac$var$isObjectOfType("WeakSet");
var $209e2c4c2fa2f6ac$var$isNullOrUndefined = (value)=>{
    return $209e2c4c2fa2f6ac$var$isNull(value) || $209e2c4c2fa2f6ac$var$isUndefined(value);
};
var $209e2c4c2fa2f6ac$var$isDefined = (value)=>!$209e2c4c2fa2f6ac$var$isUndefined(value);
var $209e2c4c2fa2f6ac$var$isNumber = (value)=>{
    return $209e2c4c2fa2f6ac$var$isOfType("number")(value) && !$209e2c4c2fa2f6ac$var$isNan(value);
};
var $209e2c4c2fa2f6ac$var$isNonEmptyString = (value)=>{
    return $209e2c4c2fa2f6ac$var$isString(value) && value.trim().length > 0;
};
var $209e2c4c2fa2f6ac$var$isNumericString = (value)=>{
    if (!$209e2c4c2fa2f6ac$var$isString(value) || value.length === 0) return false;
    const trimmed = value.trim();
    return trimmed.length > 0 && Number.isFinite(Number(trimmed));
};
var $209e2c4c2fa2f6ac$var$isObject = (value)=>{
    return !$209e2c4c2fa2f6ac$var$isNullOrUndefined(value) && ($209e2c4c2fa2f6ac$var$isFunction(value) || typeof value === "object");
};
var $209e2c4c2fa2f6ac$var$isPlainObject = (value)=>{
    if ($209e2c4c2fa2f6ac$var$getObjectType(value) !== "Object") return false;
    const prototype = Object.getPrototypeOf(value);
    return prototype === null || prototype === Object.getPrototypeOf({});
};
var $209e2c4c2fa2f6ac$var$isPrimitive = (value)=>$209e2c4c2fa2f6ac$var$isNull(value) || $209e2c4c2fa2f6ac$var$isPrimitiveType(typeof value);
var $209e2c4c2fa2f6ac$var$isUrl = (value)=>{
    return $209e2c4c2fa2f6ac$var$getObjectType(value) === "URL";
};
var $209e2c4c2fa2f6ac$var$isIterable = (value)=>{
    return !$209e2c4c2fa2f6ac$var$isNullOrUndefined(value) && $209e2c4c2fa2f6ac$var$isFunction(value[Symbol.iterator]);
};
var $209e2c4c2fa2f6ac$var$isGenerator = (value)=>{
    return $209e2c4c2fa2f6ac$var$isIterable(value) && $209e2c4c2fa2f6ac$var$isFunction(value.next) && $209e2c4c2fa2f6ac$var$isFunction(value.throw);
};
var $209e2c4c2fa2f6ac$var$isClass = (value)=>{
    return $209e2c4c2fa2f6ac$var$isFunction(value) && /^class\s/.test(value.toString());
};
var $209e2c4c2fa2f6ac$var$isArrayOf = (target, predicate)=>{
    if (!$209e2c4c2fa2f6ac$var$isArray(target) || !$209e2c4c2fa2f6ac$var$isFunction(predicate)) return false;
    return target.every((d)=>predicate(d));
};
var $209e2c4c2fa2f6ac$var$isDomElement = (value)=>{
    return $209e2c4c2fa2f6ac$var$isObject(value) && !$209e2c4c2fa2f6ac$var$isPlainObject(value) && value.nodeType === 1 && $209e2c4c2fa2f6ac$var$isString(value.nodeName) && $209e2c4c2fa2f6ac$var$DOM_PROPERTIES_TO_CHECK.every((property)=>property in value);
};
var $209e2c4c2fa2f6ac$var$isEmpty = (value)=>{
    return $209e2c4c2fa2f6ac$var$isString(value) && value.length === 0 || $209e2c4c2fa2f6ac$var$isArray(value) && value.length === 0 || $209e2c4c2fa2f6ac$var$isObject(value) && !$209e2c4c2fa2f6ac$var$isMap(value) && !$209e2c4c2fa2f6ac$var$isSet(value) && Object.keys(value).length === 0 || $209e2c4c2fa2f6ac$var$isSet(value) && value.size === 0 || $209e2c4c2fa2f6ac$var$isMap(value) && value.size === 0;
};
var $209e2c4c2fa2f6ac$var$isInstanceOf = (instance, class_)=>{
    if (!instance || !class_) return false;
    return Object.getPrototypeOf(instance) === class_.prototype;
};
var $209e2c4c2fa2f6ac$var$isOneOf = (target, value)=>{
    if (!$209e2c4c2fa2f6ac$var$isArray(target)) return false;
    return target.indexOf(value) > -1;
};
var $209e2c4c2fa2f6ac$var$isPropertyOf = (target, key, predicate)=>{
    if (!$209e2c4c2fa2f6ac$var$isObject(target) || !key) return false;
    const value = target[key];
    if ($209e2c4c2fa2f6ac$var$isFunction(predicate)) return predicate(value);
    return $209e2c4c2fa2f6ac$var$isDefined(value);
};
// src/index.ts
function $209e2c4c2fa2f6ac$var$is(value) {
    if (value === null) return "null";
    switch(typeof value){
        case "bigint":
            return "bigint";
        case "boolean":
            return "boolean";
        case "number":
            return "number";
        case "string":
            return "string";
        case "symbol":
            return "symbol";
        case "undefined":
            return "undefined";
        default:
    }
    if ($209e2c4c2fa2f6ac$var$isArray(value)) return "Array";
    if ($209e2c4c2fa2f6ac$var$isPlainFunction(value)) return "Function";
    const tagType = $209e2c4c2fa2f6ac$var$getObjectType(value);
    if (tagType) return tagType;
    return "Object";
}
$209e2c4c2fa2f6ac$var$is.array = $209e2c4c2fa2f6ac$var$isArray;
$209e2c4c2fa2f6ac$var$is.arrayOf = $209e2c4c2fa2f6ac$var$isArrayOf;
$209e2c4c2fa2f6ac$var$is.asyncGeneratorFunction = $209e2c4c2fa2f6ac$var$isAsyncGeneratorFunction;
$209e2c4c2fa2f6ac$var$is.asyncFunction = $209e2c4c2fa2f6ac$var$isAsyncFunction;
$209e2c4c2fa2f6ac$var$is.bigint = $209e2c4c2fa2f6ac$var$isBigInt;
$209e2c4c2fa2f6ac$var$is.boolean = $209e2c4c2fa2f6ac$var$isBoolean;
$209e2c4c2fa2f6ac$var$is.class = $209e2c4c2fa2f6ac$var$isClass;
$209e2c4c2fa2f6ac$var$is.date = $209e2c4c2fa2f6ac$var$isDate;
$209e2c4c2fa2f6ac$var$is.defined = $209e2c4c2fa2f6ac$var$isDefined;
$209e2c4c2fa2f6ac$var$is.domElement = $209e2c4c2fa2f6ac$var$isDomElement;
$209e2c4c2fa2f6ac$var$is.empty = $209e2c4c2fa2f6ac$var$isEmpty;
$209e2c4c2fa2f6ac$var$is.error = $209e2c4c2fa2f6ac$var$isError;
$209e2c4c2fa2f6ac$var$is.function = $209e2c4c2fa2f6ac$var$isFunction;
$209e2c4c2fa2f6ac$var$is.generator = $209e2c4c2fa2f6ac$var$isGenerator;
$209e2c4c2fa2f6ac$var$is.generatorFunction = $209e2c4c2fa2f6ac$var$isGeneratorFunction;
$209e2c4c2fa2f6ac$var$is.instanceOf = $209e2c4c2fa2f6ac$var$isInstanceOf;
$209e2c4c2fa2f6ac$var$is.integer = $209e2c4c2fa2f6ac$var$isInteger;
$209e2c4c2fa2f6ac$var$is.iterable = $209e2c4c2fa2f6ac$var$isIterable;
$209e2c4c2fa2f6ac$var$is.map = $209e2c4c2fa2f6ac$var$isMap;
$209e2c4c2fa2f6ac$var$is.nan = $209e2c4c2fa2f6ac$var$isNan;
$209e2c4c2fa2f6ac$var$is.null = $209e2c4c2fa2f6ac$var$isNull;
$209e2c4c2fa2f6ac$var$is.nullOrUndefined = $209e2c4c2fa2f6ac$var$isNullOrUndefined;
$209e2c4c2fa2f6ac$var$is.nonEmptyString = $209e2c4c2fa2f6ac$var$isNonEmptyString;
$209e2c4c2fa2f6ac$var$is.number = $209e2c4c2fa2f6ac$var$isNumber;
$209e2c4c2fa2f6ac$var$is.numericString = $209e2c4c2fa2f6ac$var$isNumericString;
$209e2c4c2fa2f6ac$var$is.object = $209e2c4c2fa2f6ac$var$isObject;
$209e2c4c2fa2f6ac$var$is.oneOf = $209e2c4c2fa2f6ac$var$isOneOf;
$209e2c4c2fa2f6ac$var$is.plainFunction = $209e2c4c2fa2f6ac$var$isPlainFunction;
$209e2c4c2fa2f6ac$var$is.plainObject = $209e2c4c2fa2f6ac$var$isPlainObject;
$209e2c4c2fa2f6ac$var$is.primitive = $209e2c4c2fa2f6ac$var$isPrimitive;
$209e2c4c2fa2f6ac$var$is.promise = $209e2c4c2fa2f6ac$var$isPromise;
$209e2c4c2fa2f6ac$var$is.propertyOf = $209e2c4c2fa2f6ac$var$isPropertyOf;
$209e2c4c2fa2f6ac$var$is.regexp = $209e2c4c2fa2f6ac$var$isRegexp;
$209e2c4c2fa2f6ac$var$is.set = $209e2c4c2fa2f6ac$var$isSet;
$209e2c4c2fa2f6ac$var$is.string = $209e2c4c2fa2f6ac$var$isString;
$209e2c4c2fa2f6ac$var$is.symbol = $209e2c4c2fa2f6ac$var$isSymbol;
$209e2c4c2fa2f6ac$var$is.undefined = $209e2c4c2fa2f6ac$var$isUndefined;
$209e2c4c2fa2f6ac$var$is.url = $209e2c4c2fa2f6ac$var$isUrl;
$209e2c4c2fa2f6ac$var$is.weakMap = $209e2c4c2fa2f6ac$var$isWeakMap;
$209e2c4c2fa2f6ac$var$is.weakSet = $209e2c4c2fa2f6ac$var$isWeakSet;
var $209e2c4c2fa2f6ac$export$2e2bcd8739ae039 = $209e2c4c2fa2f6ac$var$is;
 /* v8 ignore next -- @preserve */ 

var $72058227f48a8157$exports = {};
"use strict";
var $72058227f48a8157$var$hasProps = function(jsx) {
    return Object.prototype.hasOwnProperty.call(jsx, 'props');
};
var $72058227f48a8157$var$reduceJsxToString = function(previous, current) {
    return previous + $72058227f48a8157$var$innerText(current);
};
var $72058227f48a8157$var$innerText = function(jsx) {
    if (jsx === null || typeof jsx === 'boolean' || typeof jsx === 'undefined') return '';
    if (typeof jsx === 'number') return jsx.toString();
    if (typeof jsx === 'string') return jsx;
    if (Array.isArray(jsx)) return jsx.reduce($72058227f48a8157$var$reduceJsxToString, '');
    if ($72058227f48a8157$var$hasProps(jsx) && Object.prototype.hasOwnProperty.call(jsx.props, 'children')) return $72058227f48a8157$var$innerText(jsx.props.children);
    return '';
};
$72058227f48a8157$var$innerText.default = $72058227f48a8157$var$innerText;
$72058227f48a8157$exports = $72058227f48a8157$var$innerText;


var $653da11647de05d0$exports = {};
'use strict';
// based on https://github.com/TehShrike/deepmerge
// MIT License
// Copyright (c) 2012 - 2022 James Halliday, Josh Duff, and other contributors of deepmerge
const $653da11647de05d0$var$JSON_PROTO = Object.getPrototypeOf({});
function $653da11647de05d0$var$defaultIsMergeableObjectFactory() {
    return function defaultIsMergeableObject(value) {
        return typeof value === 'object' && value !== null && !(value instanceof RegExp) && !(value instanceof Date);
    };
}
function $653da11647de05d0$var$deepmergeConstructor(options) {
    function isNotPrototypeKey(value) {
        return value !== 'constructor' && value !== 'prototype' && value !== '__proto__';
    }
    function cloneArray(value) {
        let i = 0;
        const il = value.length;
        const result = new Array(il);
        for(i; i < il; ++i)result[i] = clone(value[i]);
        return result;
    }
    function cloneObject(target) {
        const result = {};
        if (cloneProtoObject && Object.getPrototypeOf(target) !== $653da11647de05d0$var$JSON_PROTO) return cloneProtoObject(target);
        const targetKeys = getKeys(target);
        let i, il, key;
        for(i = 0, il = targetKeys.length; i < il; ++i)isNotPrototypeKey(key = targetKeys[i]) && (result[key] = clone(target[key]));
        return result;
    }
    function concatArrays(target, source) {
        const tl = target.length;
        const sl = source.length;
        let i = 0;
        const result = new Array(tl + sl);
        for(i; i < tl; ++i)result[i] = clone(target[i]);
        for(i = 0; i < sl; ++i)result[i + tl] = clone(source[i]);
        return result;
    }
    const propertyIsEnumerable = Object.prototype.propertyIsEnumerable;
    function getSymbolsAndKeys(value) {
        const result = Object.keys(value);
        const keys = Object.getOwnPropertySymbols(value);
        for(let i = 0, il = keys.length; i < il; ++i)propertyIsEnumerable.call(value, keys[i]) && result.push(keys[i]);
        return result;
    }
    const getKeys = options?.symbols ? getSymbolsAndKeys : Object.keys;
    const cloneProtoObject = typeof options?.cloneProtoObject === 'function' ? options.cloneProtoObject : undefined;
    const isMergeableObject = typeof options?.isMergeableObject === 'function' ? options.isMergeableObject : $653da11647de05d0$var$defaultIsMergeableObjectFactory();
    const onlyDefinedProperties = options?.onlyDefinedProperties === true;
    function isPrimitive(value) {
        return typeof value !== 'object' || value === null;
    }
    const mergeArray = options && typeof options.mergeArray === 'function' ? options.mergeArray({
        clone: clone,
        deepmerge: _deepmerge,
        getKeys: getKeys,
        isMergeableObject: isMergeableObject
    }) : concatArrays;
    function clone(entry) {
        return isMergeableObject(entry) ? Array.isArray(entry) ? cloneArray(entry) : cloneObject(entry) : entry;
    }
    function mergeObject(target, source) {
        const result = {};
        const targetKeys = getKeys(target);
        const sourceKeys = getKeys(source);
        let i, il, key;
        for(i = 0, il = targetKeys.length; i < il; ++i)isNotPrototypeKey(key = targetKeys[i]) && sourceKeys.indexOf(key) === -1 && (result[key] = clone(target[key]));
        for(i = 0, il = sourceKeys.length; i < il; ++i){
            if (!isNotPrototypeKey(key = sourceKeys[i])) continue;
            if (key in target) {
                if (targetKeys.indexOf(key) !== -1) {
                    if (cloneProtoObject && isMergeableObject(source[key]) && Object.getPrototypeOf(source[key]) !== $653da11647de05d0$var$JSON_PROTO) result[key] = cloneProtoObject(source[key]);
                    else result[key] = _deepmerge(target[key], source[key]);
                }
            } else {
                if (onlyDefinedProperties && typeof source[key] === 'undefined') continue;
                result[key] = clone(source[key]);
            }
        }
        return result;
    }
    function _deepmerge(target, source) {
        if (onlyDefinedProperties && typeof source === 'undefined') return clone(target);
        const sourceIsArray = Array.isArray(source);
        const targetIsArray = Array.isArray(target);
        if (isPrimitive(source)) return source;
        else if (!isMergeableObject(target)) return clone(source);
        else if (sourceIsArray && targetIsArray) return mergeArray(target, source);
        else if (sourceIsArray !== targetIsArray) return clone(source);
        else return mergeObject(target, source);
    }
    function _deepmergeAll() {
        switch(arguments.length){
            case 0:
                return {};
            case 1:
                return clone(arguments[0]);
            case 2:
                return _deepmerge(arguments[0], arguments[1]);
        }
        let result;
        for(let i = 0, il = arguments.length; i < il; ++i)result = _deepmerge(result, arguments[i]);
        return result;
    }
    return options?.all ? _deepmergeAll : _deepmerge;
}
$653da11647de05d0$exports = $653da11647de05d0$var$deepmergeConstructor;
$653da11647de05d0$exports.default = $653da11647de05d0$var$deepmergeConstructor;
$653da11647de05d0$exports.deepmerge = $653da11647de05d0$var$deepmergeConstructor;
Object.defineProperty($653da11647de05d0$exports, 'isMergeableObject', {
    get: $653da11647de05d0$var$defaultIsMergeableObjectFactory
});



var $8240c897140e47e1$exports = {};
var $8240c897140e47e1$var$E_NOSCROLL = new Error('Element already at target scroll position');
var $8240c897140e47e1$var$E_CANCELLED = new Error('Scroll cancelled');
var $8240c897140e47e1$var$min = Math.min;
var $8240c897140e47e1$var$ms = Date.now;
$8240c897140e47e1$exports = {
    left: $8240c897140e47e1$var$make('scrollLeft'),
    top: $8240c897140e47e1$var$make('scrollTop')
};
function $8240c897140e47e1$var$make(prop) {
    return function scroll(el, to, opts, cb) {
        opts = opts || {};
        if (typeof opts == 'function') cb = opts, opts = {};
        if (typeof cb != 'function') cb = $8240c897140e47e1$var$noop;
        var start = $8240c897140e47e1$var$ms();
        var from = el[prop];
        var ease = opts.ease || $8240c897140e47e1$var$inOutSine;
        var duration = !isNaN(opts.duration) ? +opts.duration : 350;
        var cancelled = false;
        return from === to ? cb($8240c897140e47e1$var$E_NOSCROLL, el[prop]) : requestAnimationFrame(animate), cancel;
        function cancel() {
            cancelled = true;
        }
        function animate(timestamp) {
            if (cancelled) return cb($8240c897140e47e1$var$E_CANCELLED, el[prop]);
            var now = $8240c897140e47e1$var$ms();
            var time = $8240c897140e47e1$var$min(1, (now - start) / duration);
            var eased = ease(time);
            el[prop] = eased * (to - from) + from;
            time < 1 ? requestAnimationFrame(animate) : requestAnimationFrame(function() {
                cb(null, el[prop]);
            });
        }
    };
}
function $8240c897140e47e1$var$inOutSine(n) {
    return 0.5 * (1 - Math.cos(Math.PI * n));
}
function $8240c897140e47e1$var$noop() {}


var $6ddd06ae6fd6816d$exports = {};
(function(root, factory) {
    if (typeof define === "function" && define.amd) define([], factory);
    else if ($6ddd06ae6fd6816d$exports) $6ddd06ae6fd6816d$exports = factory();
    else root.Scrollparent = factory();
})($6ddd06ae6fd6816d$exports, function() {
    function isScrolling(node) {
        var overflow = getComputedStyle(node, null).getPropertyValue("overflow");
        return overflow.indexOf("scroll") > -1 || overflow.indexOf("auto") > -1;
    }
    function scrollParent(node) {
        if (!(node instanceof HTMLElement || node instanceof SVGElement)) return undefined;
        var current = node.parentNode;
        while(current.parentNode){
            if (isScrolling(current)) return current;
            current = current.parentNode;
        }
        return document.scrollingElement || document.documentElement;
    }
    return scrollParent;
});



var $ibUU1 = parcelRequire("ibUU1");
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $b9e86319c193cbcf$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $b9e86319c193cbcf$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $b9e86319c193cbcf$export$803cd8101b6c182b = /*#__PURE__*/ $b9e86319c193cbcf$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $b9e86319c193cbcf$export$27b07d8a310ed8b5[0], side + "-" + $b9e86319c193cbcf$export$27b07d8a310ed8b5[1]), []);
const $b9e86319c193cbcf$export$96ec731ed4dcb222 = Math.min;
const $b9e86319c193cbcf$export$8960430cfd85939f = Math.max;
const $b9e86319c193cbcf$export$2077e0241d6afd3c = Math.round;
const $b9e86319c193cbcf$export$a3fe094919f356fd = Math.floor;
const $b9e86319c193cbcf$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $b9e86319c193cbcf$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $b9e86319c193cbcf$export$7d15b64cf5a3a4c4(start, value, end) {
    return $b9e86319c193cbcf$export$8960430cfd85939f(start, $b9e86319c193cbcf$export$96ec731ed4dcb222(value, end));
}
function $b9e86319c193cbcf$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $b9e86319c193cbcf$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $b9e86319c193cbcf$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $b9e86319c193cbcf$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $b9e86319c193cbcf$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $b9e86319c193cbcf$export$f28e8f882010718a(placement) {
    const firstChar = placement[0];
    return firstChar === 't' || firstChar === 'b' ? 'y' : 'x';
}
function $b9e86319c193cbcf$export$2b57e0052a6d6d4c(placement) {
    return $b9e86319c193cbcf$export$8a000a963141ac32($b9e86319c193cbcf$export$f28e8f882010718a(placement));
}
function $b9e86319c193cbcf$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $b9e86319c193cbcf$export$f0989780f32bfcda(placement);
    const alignmentAxis = $b9e86319c193cbcf$export$2b57e0052a6d6d4c(placement);
    const length = $b9e86319c193cbcf$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $b9e86319c193cbcf$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $b9e86319c193cbcf$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $b9e86319c193cbcf$export$496432a3699e50b1(placement) {
    const oppositePlacement = $b9e86319c193cbcf$export$9c5e28bad23365fa(placement);
    return [
        $b9e86319c193cbcf$export$2b182c584985588b(placement),
        oppositePlacement,
        $b9e86319c193cbcf$export$2b182c584985588b(oppositePlacement)
    ];
}
function $b9e86319c193cbcf$export$2b182c584985588b(placement) {
    return placement.includes('start') ? placement.replace('start', 'end') : placement.replace('end', 'start');
}
const $b9e86319c193cbcf$var$lrPlacement = [
    'left',
    'right'
];
const $b9e86319c193cbcf$var$rlPlacement = [
    'right',
    'left'
];
const $b9e86319c193cbcf$var$tbPlacement = [
    'top',
    'bottom'
];
const $b9e86319c193cbcf$var$btPlacement = [
    'bottom',
    'top'
];
function $b9e86319c193cbcf$var$getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? $b9e86319c193cbcf$var$rlPlacement : $b9e86319c193cbcf$var$lrPlacement;
            return isStart ? $b9e86319c193cbcf$var$lrPlacement : $b9e86319c193cbcf$var$rlPlacement;
        case 'left':
        case 'right':
            return isStart ? $b9e86319c193cbcf$var$tbPlacement : $b9e86319c193cbcf$var$btPlacement;
        default:
            return [];
    }
}
function $b9e86319c193cbcf$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $b9e86319c193cbcf$export$f0989780f32bfcda(placement);
    let list = $b9e86319c193cbcf$var$getSideList($b9e86319c193cbcf$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($b9e86319c193cbcf$export$2b182c584985588b));
    }
    return list;
}
function $b9e86319c193cbcf$export$9c5e28bad23365fa(placement) {
    const side = $b9e86319c193cbcf$export$3c915306cb7fc97a(placement);
    return $b9e86319c193cbcf$var$oppositeSideMap[side] + placement.slice(side.length);
}
function $b9e86319c193cbcf$export$1c66dbf1a9e34223(padding) {
    var _padding$top, _padding$right, _padding$bottom, _padding$left;
    return {
        top: (_padding$top = padding.top) != null ? _padding$top : 0,
        right: (_padding$right = padding.right) != null ? _padding$right : 0,
        bottom: (_padding$bottom = padding.bottom) != null ? _padding$bottom : 0,
        left: (_padding$left = padding.left) != null ? _padding$left : 0
    };
}
function $b9e86319c193cbcf$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $b9e86319c193cbcf$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $b9e86319c193cbcf$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $03977f4973bb2b13$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $b9e86319c193cbcf$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $b9e86319c193cbcf$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $b9e86319c193cbcf$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $b9e86319c193cbcf$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    const alignment = (0, $b9e86319c193cbcf$export$f0989780f32bfcda)(placement);
    if (alignment) coords[alignmentAxis] += commonAlign * (alignment === 'end' ? 1 : -1) * (rtl && isVertical ? -1 : 1);
    return coords;
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $03977f4973bb2b13$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $b9e86319c193cbcf$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $b9e86319c193cbcf$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $b9e86319c193cbcf$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) && await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $b9e86319c193cbcf$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
// Maximum number of resets that can occur before bailing to avoid infinite reset loops.
const $03977f4973bb2b13$var$MAX_RESET_COUNT = 50;
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $03977f4973bb2b13$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const platformWithDetectOverflow = platform.detectOverflow ? platform : {
        ...platform,
        detectOverflow: $03977f4973bb2b13$export$37b6bde19b108ecc
    };
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $03977f4973bb2b13$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let resetCount = 0;
    const middlewareData = {};
    for(let i = 0; i < middleware.length; i++){
        const currentMiddleware = middleware[i];
        if (!currentMiddleware) continue;
        const { name: name, fn: fn } = currentMiddleware;
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platformWithDetectOverflow,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData[name] = {
            ...middlewareData[name],
            ...data
        };
        if (reset && resetCount < $03977f4973bb2b13$var$MAX_RESET_COUNT) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $03977f4973bb2b13$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $03977f4973bb2b13$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $b9e86319c193cbcf$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $b9e86319c193cbcf$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $b9e86319c193cbcf$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $b9e86319c193cbcf$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $b9e86319c193cbcf$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $b9e86319c193cbcf$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $b9e86319c193cbcf$export$7d15b64cf5a3a4c4)(minPadding, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $b9e86319c193cbcf$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < minPadding ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < minPadding ? center - minPadding : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $03977f4973bb2b13$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $b9e86319c193cbcf$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $b9e86319c193cbcf$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $b9e86319c193cbcf$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $b9e86319c193cbcf$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $b9e86319c193cbcf$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $03977f4973bb2b13$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $b9e86319c193cbcf$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $b9e86319c193cbcf$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $b9e86319c193cbcf$export$803cd8101b6c182b) ? $03977f4973bb2b13$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const alignmentSides = (0, $b9e86319c193cbcf$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            const currentOverflows = [
                overflow[(0, $b9e86319c193cbcf$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $b9e86319c193cbcf$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $b9e86319c193cbcf$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $03977f4973bb2b13$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $b9e86319c193cbcf$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $b9e86319c193cbcf$export$3c915306cb7fc97a)(placement);
            const initialSideAxis = (0, $b9e86319c193cbcf$export$f28e8f882010718a)(initialPlacement);
            const isBasePlacement = (0, $b9e86319c193cbcf$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $b9e86319c193cbcf$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $b9e86319c193cbcf$export$496432a3699e50b1)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $b9e86319c193cbcf$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $b9e86319c193cbcf$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, $b9e86319c193cbcf$export$f28e8f882010718a)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, $b9e86319c193cbcf$export$f28e8f882010718a)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $b9e86319c193cbcf$export$f28e8f882010718a)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $03977f4973bb2b13$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $03977f4973bb2b13$var$isAnySideFullyClipped(overflow) {
    return (0, $b9e86319c193cbcf$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $03977f4973bb2b13$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects, platform: platform } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $b9e86319c193cbcf$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $03977f4973bb2b13$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $03977f4973bb2b13$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $03977f4973bb2b13$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $03977f4973bb2b13$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $03977f4973bb2b13$var$getBoundingRect(rects) {
    const minX = (0, $b9e86319c193cbcf$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $b9e86319c193cbcf$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $b9e86319c193cbcf$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $b9e86319c193cbcf$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $03977f4973bb2b13$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $b9e86319c193cbcf$export$ee05aea0aeecbad4)($03977f4973bb2b13$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $03977f4973bb2b13$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $b9e86319c193cbcf$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            // No rects (e.g. a hidden or detached reference, or a collapsed range) —
            // keep the existing reference rect rather than resetting to an invalid
            // one with non-finite values.
            if (!nativeClientRects.length) return {};
            const clientRects = $03977f4973bb2b13$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $b9e86319c193cbcf$export$ee05aea0aeecbad4)($03977f4973bb2b13$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $b9e86319c193cbcf$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && (clientRects[0].left > clientRects[1].right || clientRects[1].left > clientRects[0].right) && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $b9e86319c193cbcf$export$f28e8f882010718a)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $b9e86319c193cbcf$export$3c915306cb7fc97a)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        return (0, $b9e86319c193cbcf$export$ee05aea0aeecbad4)({
                            x: left,
                            y: top,
                            width: right - left,
                            height: bottom - top
                        });
                    }
                    const isLeftSide = (0, $b9e86319c193cbcf$export$3c915306cb7fc97a)(placement) === 'left';
                    const maxRight = (0, $b9e86319c193cbcf$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $b9e86319c193cbcf$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    return (0, $b9e86319c193cbcf$export$ee05aea0aeecbad4)({
                        x: minLeft,
                        y: top,
                        width: maxRight - minLeft,
                        height: bottom - top
                    });
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const $03977f4973bb2b13$var$originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $03977f4973bb2b13$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $b9e86319c193cbcf$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $b9e86319c193cbcf$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $b9e86319c193cbcf$export$f28e8f882010718a)(placement) === 'y';
    const mainAxisMulti = $03977f4973bb2b13$var$originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $b9e86319c193cbcf$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $03977f4973bb2b13$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $03977f4973bb2b13$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $03977f4973bb2b13$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, platform: platform } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $b9e86319c193cbcf$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const crossAxis = (0, $b9e86319c193cbcf$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $b9e86319c193cbcf$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const clampCoord = (axis, coord)=>(0, $b9e86319c193cbcf$export$7d15b64cf5a3a4c4)(coord + overflow[axis === 'y' ? 'top' : 'left'], coord, coord - overflow[axis === 'y' ? 'bottom' : 'right']);
            if (checkMainAxis) mainAxisCoord = clampCoord(mainAxis, mainAxisCoord);
            if (checkCrossAxis) crossAxisCoord = clampCoord(crossAxis, crossAxisCoord);
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $03977f4973bb2b13$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            var _rawOffset$mainAxis, _rawOffset$crossAxis;
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $b9e86319c193cbcf$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $b9e86319c193cbcf$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $b9e86319c193cbcf$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $b9e86319c193cbcf$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: (_rawOffset$mainAxis = rawOffset.mainAxis) != null ? _rawOffset$mainAxis : 0,
                crossAxis: (_rawOffset$crossAxis = rawOffset.crossAxis) != null ? _rawOffset$crossAxis : 0
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = $03977f4973bb2b13$var$originSides.has((0, $b9e86319c193cbcf$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
// Method syntax keeps callback parameters bivariant, but expressing the
// explicit `| undefined` required by `exactOptionalPropertyTypes` needs
// property syntax, which is contravariant under `strictFunctionTypes`.
// Extracting the function from a method position restores that bivariance so
// consumers can still assign callbacks with narrower parameter types.
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $03977f4973bb2b13$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $b9e86319c193cbcf$export$fef61f332f2c0afc)(options, state);
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const side = (0, $b9e86319c193cbcf$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $b9e86319c193cbcf$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $b9e86319c193cbcf$export$f28e8f882010718a)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $b9e86319c193cbcf$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $b9e86319c193cbcf$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const shiftData = state.middlewareData.shift;
            const noShift = !shiftData;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (shiftData != null && shiftData.enabled.x) availableWidth = maximumClippingWidth;
            if (shiftData != null && shiftData.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                if (isYAxis) availableWidth = width - 2 * (0, $b9e86319c193cbcf$export$8960430cfd85939f)(overflow.left, overflow.right);
                else availableHeight = height - 2 * (0, $b9e86319c193cbcf$export$8960430cfd85939f)(overflow.top, overflow.bottom);
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $65e1f2ae51cf1f63$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $65e1f2ae51cf1f63$export$651544f548703224(node) {
    if ($65e1f2ae51cf1f63$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $65e1f2ae51cf1f63$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $65e1f2ae51cf1f63$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($65e1f2ae51cf1f63$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $65e1f2ae51cf1f63$export$8ee0fc9ee280b4ee(value) {
    if (!$65e1f2ae51cf1f63$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $65e1f2ae51cf1f63$export$38b2d434cce3ea22(value).Node;
}
function $65e1f2ae51cf1f63$export$45a5e7f76e0caa8d(value) {
    if (!$65e1f2ae51cf1f63$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $65e1f2ae51cf1f63$export$38b2d434cce3ea22(value).Element;
}
function $65e1f2ae51cf1f63$export$1b3bfaa9684536aa(value) {
    if (!$65e1f2ae51cf1f63$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $65e1f2ae51cf1f63$export$38b2d434cce3ea22(value).HTMLElement;
}
function $65e1f2ae51cf1f63$export$af51f0f06c0f328a(value) {
    if (!$65e1f2ae51cf1f63$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $65e1f2ae51cf1f63$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $65e1f2ae51cf1f63$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $65e1f2ae51cf1f63$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && display !== 'inline' && display !== 'contents';
}
function $65e1f2ae51cf1f63$export$71535ffaa902797f(element) {
    return /^(table|td|th)$/.test($65e1f2ae51cf1f63$export$651544f548703224(element));
}
function $65e1f2ae51cf1f63$export$89e651af02346cd4(element) {
    try {
        if (element.matches(':popover-open')) return true;
    } catch (_e) {
    // no-op
    }
    try {
        return element.matches(':modal');
    } catch (_e) {
        return false;
    }
}
const $65e1f2ae51cf1f63$var$willChangeRe = /transform|translate|scale|rotate|perspective|filter/;
const $65e1f2ae51cf1f63$var$containRe = /paint|layout|strict|content/;
const $65e1f2ae51cf1f63$var$isNotNone = (value)=>!!value && value !== 'none';
let $65e1f2ae51cf1f63$var$isWebKitValue;
function $65e1f2ae51cf1f63$export$d6c4e8150c35fed1(elementOrCss) {
    const css = $65e1f2ae51cf1f63$export$45a5e7f76e0caa8d(elementOrCss) ? $65e1f2ae51cf1f63$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return $65e1f2ae51cf1f63$var$isNotNone(css.transform) || $65e1f2ae51cf1f63$var$isNotNone(css.translate) || $65e1f2ae51cf1f63$var$isNotNone(css.scale) || $65e1f2ae51cf1f63$var$isNotNone(css.rotate) || $65e1f2ae51cf1f63$var$isNotNone(css.perspective) || !$65e1f2ae51cf1f63$export$78551043582a6a98() && ($65e1f2ae51cf1f63$var$isNotNone(css.backdropFilter) || $65e1f2ae51cf1f63$var$isNotNone(css.filter)) || $65e1f2ae51cf1f63$var$willChangeRe.test(css.willChange || '') || $65e1f2ae51cf1f63$var$containRe.test(css.contain || '');
}
function $65e1f2ae51cf1f63$export$940d8225183e1404(element) {
    let currentNode = $65e1f2ae51cf1f63$export$4e12058fc4d51d56(element);
    while($65e1f2ae51cf1f63$export$1b3bfaa9684536aa(currentNode) && !$65e1f2ae51cf1f63$export$d1162fb0b6d4cd51(currentNode)){
        if ($65e1f2ae51cf1f63$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($65e1f2ae51cf1f63$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $65e1f2ae51cf1f63$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $65e1f2ae51cf1f63$export$78551043582a6a98() {
    if ($65e1f2ae51cf1f63$var$isWebKitValue == null) $65e1f2ae51cf1f63$var$isWebKitValue = typeof CSS !== 'undefined' && CSS.supports && CSS.supports('-webkit-backdrop-filter', 'none');
    return $65e1f2ae51cf1f63$var$isWebKitValue;
}
function $65e1f2ae51cf1f63$export$d1162fb0b6d4cd51(node) {
    return /^(html|body|#document)$/.test($65e1f2ae51cf1f63$export$651544f548703224(node));
}
function $65e1f2ae51cf1f63$export$3735103072e4a80(element) {
    return $65e1f2ae51cf1f63$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $65e1f2ae51cf1f63$export$dc8fc79fa2800137(element) {
    if ($65e1f2ae51cf1f63$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $65e1f2ae51cf1f63$export$4e12058fc4d51d56(node) {
    if ($65e1f2ae51cf1f63$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $65e1f2ae51cf1f63$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $65e1f2ae51cf1f63$export$e495491855dc5418(node);
    return $65e1f2ae51cf1f63$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $65e1f2ae51cf1f63$export$7cd01a57c8ca906c(node) {
    const parentNode = $65e1f2ae51cf1f63$export$4e12058fc4d51d56(node);
    if ($65e1f2ae51cf1f63$export$d1162fb0b6d4cd51(parentNode)) return (node.ownerDocument || node).body;
    if ($65e1f2ae51cf1f63$export$1b3bfaa9684536aa(parentNode) && $65e1f2ae51cf1f63$export$989e911fa9af580a(parentNode)) return parentNode;
    return $65e1f2ae51cf1f63$export$7cd01a57c8ca906c(parentNode);
}
function $65e1f2ae51cf1f63$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $65e1f2ae51cf1f63$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $65e1f2ae51cf1f63$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $65e1f2ae51cf1f63$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $65e1f2ae51cf1f63$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $65e1f2ae51cf1f63$export$3b57c1601291186b(frameElement) : []);
    } else return list.concat(scrollableAncestor, $65e1f2ae51cf1f63$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $65e1f2ae51cf1f63$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $b6afb10360273f49$var$getCssDimensions(element) {
    const css = (0, $65e1f2ae51cf1f63$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $65e1f2ae51cf1f63$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $b9e86319c193cbcf$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $b9e86319c193cbcf$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $b6afb10360273f49$var$unwrapElement(element) {
    return !(0, $65e1f2ae51cf1f63$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $b6afb10360273f49$var$getScale(element) {
    const domElement = $b6afb10360273f49$var$unwrapElement(element);
    if (!(0, $65e1f2ae51cf1f63$export$1b3bfaa9684536aa)(domElement)) return (0, $b9e86319c193cbcf$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $b6afb10360273f49$var$getCssDimensions(domElement);
    let x = ($ ? (0, $b9e86319c193cbcf$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $b9e86319c193cbcf$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $b6afb10360273f49$var$noOffsets = /*#__PURE__*/ (0, $b9e86319c193cbcf$export$a397704b5e280835)(0);
function $b6afb10360273f49$var$getVisualOffsets(element) {
    const win = (0, $65e1f2ae51cf1f63$export$38b2d434cce3ea22)(element);
    if (!(0, $65e1f2ae51cf1f63$export$78551043582a6a98)() || !win.visualViewport) return $b6afb10360273f49$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $b6afb10360273f49$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    return !!floatingOffsetParent && isFixed && floatingOffsetParent === (0, $65e1f2ae51cf1f63$export$38b2d434cce3ea22)(element);
}
function $b6afb10360273f49$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $b6afb10360273f49$var$unwrapElement(element);
    let scale = (0, $b9e86319c193cbcf$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $65e1f2ae51cf1f63$export$45a5e7f76e0caa8d)(offsetParent)) scale = $b6afb10360273f49$var$getScale(offsetParent);
        } else scale = $b6afb10360273f49$var$getScale(element);
    }
    const visualOffsets = $b6afb10360273f49$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $b6afb10360273f49$var$getVisualOffsets(domElement) : (0, $b9e86319c193cbcf$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement && offsetParent) {
        const win = (0, $65e1f2ae51cf1f63$export$38b2d434cce3ea22)(domElement);
        const offsetWin = (0, $65e1f2ae51cf1f63$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $65e1f2ae51cf1f63$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $65e1f2ae51cf1f63$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetWin !== currentWin){
            const iframeScale = $b6afb10360273f49$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $65e1f2ae51cf1f63$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $65e1f2ae51cf1f63$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $65e1f2ae51cf1f63$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $b9e86319c193cbcf$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $b6afb10360273f49$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $65e1f2ae51cf1f63$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $b6afb10360273f49$var$getBoundingClientRect((0, $65e1f2ae51cf1f63$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $b6afb10360273f49$var$getHTMLOffset(documentElement, scroll) {
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - $b6afb10360273f49$var$getWindowScrollBarX(documentElement, htmlRect);
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $b6afb10360273f49$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $65e1f2ae51cf1f63$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? (0, $65e1f2ae51cf1f63$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $b9e86319c193cbcf$export$a397704b5e280835)(1);
    const offsets = (0, $b9e86319c193cbcf$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $65e1f2ae51cf1f63$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isFixed) {
        if ((0, $65e1f2ae51cf1f63$export$651544f548703224)(offsetParent) !== 'body' || (0, $65e1f2ae51cf1f63$export$989e911fa9af580a)(documentElement)) scroll = (0, $65e1f2ae51cf1f63$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $b6afb10360273f49$var$getBoundingClientRect(offsetParent);
            scale = $b6afb10360273f49$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $b6afb10360273f49$var$getHTMLOffset(documentElement, scroll) : (0, $b9e86319c193cbcf$export$a397704b5e280835)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $b6afb10360273f49$var$getClientRects(element) {
    return element.getClientRects ? Array.from(element.getClientRects()) : [];
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $b6afb10360273f49$var$getDocumentRect(html) {
    const scroll = (0, $65e1f2ae51cf1f63$export$dc8fc79fa2800137)(html);
    const body = html.ownerDocument.body;
    const width = (0, $b9e86319c193cbcf$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $b9e86319c193cbcf$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $b6afb10360273f49$var$getWindowScrollBarX(html);
    const y = -scroll.scrollTop;
    if ((0, $65e1f2ae51cf1f63$export$3735103072e4a80)(body).direction === 'rtl') x += (0, $b9e86319c193cbcf$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
const $b6afb10360273f49$var$SCROLLBAR_MAX = 25;
function $b6afb10360273f49$var$getViewportRect(element, strategy, rootBoundary) {
    if (rootBoundary === void 0) rootBoundary = 'viewport';
    const isLayoutViewport = rootBoundary === 'layoutViewport';
    const win = (0, $65e1f2ae51cf1f63$export$38b2d434cce3ea22)(element);
    const html = (0, $65e1f2ae51cf1f63$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        // Client coordinates are relative to the layout viewport, except in
        // WebKit with an `absolute` strategy, where they are relative to the
        // visual viewport.
        const layoutRelativeClientCoords = !(0, $65e1f2ae51cf1f63$export$78551043582a6a98)() || strategy === 'fixed';
        if (isLayoutViewport) {
            if (!layoutRelativeClientCoords) {
                x = -visualViewport.offsetLeft;
                y = -visualViewport.offsetTop;
            }
        } else {
            width = visualViewport.width;
            height = visualViewport.height;
            if (layoutRelativeClientCoords) {
                x = visualViewport.offsetLeft;
                y = visualViewport.offsetTop;
            }
        }
    }
    const windowScrollbarX = $b6afb10360273f49$var$getWindowScrollBarX(html);
    // `scrollbar-gutter: stable` on the <html> reserves gutter space that shrinks
    // the visual width but isn't reflected in `html.clientWidth`, so subtract it.
    // Only the inline-end (right) gutter can hold the scrollbar; `both-edges` also
    // reserves an empty inline-start gutter that clips nothing, so exclude just
    // the one scrollbar-side gutter — halve the measured (two-gutter) total. A
    // left-side scrollbar (`windowScrollbarX > 0`) is already handled by
    // `getHTMLOffset`/`visualViewport.width`; skip it here.
    if (windowScrollbarX <= 0) {
        const doc = html.ownerDocument;
        const body = doc.body;
        const bodyStyles = getComputedStyle(body);
        const bodyMarginInline = doc.compatMode === 'CSS1Compat' ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        const reservedWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        const gutter = getComputedStyle(html).scrollbarGutter === 'stable both-edges' ? reservedWidth / 2 : reservedWidth;
        if (gutter <= $b6afb10360273f49$var$SCROLLBAR_MAX) width -= gutter;
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $b6afb10360273f49$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $b6afb10360273f49$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = $b6afb10360273f49$var$getScale(element);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $b6afb10360273f49$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport' || clippingAncestor === 'layoutViewport') rect = $b6afb10360273f49$var$getViewportRect(element, strategy, clippingAncestor);
    else if (clippingAncestor === 'document') rect = $b6afb10360273f49$var$getDocumentRect((0, $65e1f2ae51cf1f63$export$e495491855dc5418)(element));
    else if ((0, $65e1f2ae51cf1f63$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $b6afb10360273f49$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $b6afb10360273f49$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $b9e86319c193cbcf$export$ee05aea0aeecbad4)(rect);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $b6afb10360273f49$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $65e1f2ae51cf1f63$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $65e1f2ae51cf1f63$export$45a5e7f76e0caa8d)(el) && (0, $65e1f2ae51cf1f63$export$651544f548703224)(el) !== 'body');
    let lastKeptComputedStyle = null;
    const elementIsFixed = (0, $65e1f2ae51cf1f63$export$3735103072e4a80)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $65e1f2ae51cf1f63$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $65e1f2ae51cf1f63$export$45a5e7f76e0caa8d)(currentNode) && !(0, $65e1f2ae51cf1f63$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $65e1f2ae51cf1f63$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $65e1f2ae51cf1f63$export$d6c4e8150c35fed1)(currentNode);
        // Position of the containing block chain below the current node. A fixed
        // element whose containing block hasn't been found yet is a fixed chain.
        const lastPosition = lastKeptComputedStyle ? lastKeptComputedStyle.position : elementIsFixed ? 'fixed' : '';
        // A non-containing ancestor does not clip the element when the chain
        // below it escapes it: a fixed chain escapes all ancestors up to the
        // next containing block, an absolute chain escapes static ancestors.
        const shouldDropCurrentNode = !currentNodeIsContaining && (lastPosition === 'fixed' || lastPosition === 'absolute' && computedStyle.position === 'static');
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // The kept node carries the chain position for the next iteration.
        lastKeptComputedStyle = computedStyle;
        currentNode = (0, $65e1f2ae51cf1f63$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $b6afb10360273f49$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $65e1f2ae51cf1f63$export$89e651af02346cd4)(element) ? [] : $b6afb10360273f49$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstRect = $b6afb10360273f49$var$getClientRectFromClippingAncestor(element, clippingAncestors[0], strategy);
    let top = firstRect.top;
    let right = firstRect.right;
    let bottom = firstRect.bottom;
    let left = firstRect.left;
    for(let i = 1; i < clippingAncestors.length; i++){
        const rect = $b6afb10360273f49$var$getClientRectFromClippingAncestor(element, clippingAncestors[i], strategy);
        top = (0, $b9e86319c193cbcf$export$8960430cfd85939f)(rect.top, top);
        right = (0, $b9e86319c193cbcf$export$96ec731ed4dcb222)(rect.right, right);
        bottom = (0, $b9e86319c193cbcf$export$96ec731ed4dcb222)(rect.bottom, bottom);
        left = (0, $b9e86319c193cbcf$export$8960430cfd85939f)(rect.left, left);
    }
    return {
        width: right - left,
        height: bottom - top,
        x: left,
        y: top
    };
}
function $b6afb10360273f49$var$getDimensions(element) {
    const { width: width, height: height } = $b6afb10360273f49$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $b6afb10360273f49$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $65e1f2ae51cf1f63$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $65e1f2ae51cf1f63$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $b6afb10360273f49$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $b9e86319c193cbcf$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isFixed) {
        if ((0, $65e1f2ae51cf1f63$export$651544f548703224)(offsetParent) !== 'body' || (0, $65e1f2ae51cf1f63$export$989e911fa9af580a)(documentElement)) scroll = (0, $65e1f2ae51cf1f63$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $b6afb10360273f49$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    if (!isOffsetParentAnElement && documentElement) offsets.x = $b6afb10360273f49$var$getWindowScrollBarX(documentElement);
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $b6afb10360273f49$var$getHTMLOffset(documentElement, scroll) : (0, $b9e86319c193cbcf$export$a397704b5e280835)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $b6afb10360273f49$var$isStaticPositioned(element) {
    return (0, $65e1f2ae51cf1f63$export$3735103072e4a80)(element).position === 'static';
}
function $b6afb10360273f49$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $65e1f2ae51cf1f63$export$1b3bfaa9684536aa)(element) || (0, $65e1f2ae51cf1f63$export$3735103072e4a80)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $65e1f2ae51cf1f63$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $b6afb10360273f49$var$getOffsetParent(element, polyfill) {
    const win = (0, $65e1f2ae51cf1f63$export$38b2d434cce3ea22)(element);
    if ((0, $65e1f2ae51cf1f63$export$89e651af02346cd4)(element)) return win;
    if (!(0, $65e1f2ae51cf1f63$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $65e1f2ae51cf1f63$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $65e1f2ae51cf1f63$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $65e1f2ae51cf1f63$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$b6afb10360273f49$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $65e1f2ae51cf1f63$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $b6afb10360273f49$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $65e1f2ae51cf1f63$export$71535ffaa902797f)(offsetParent) && $b6afb10360273f49$var$isStaticPositioned(offsetParent))offsetParent = $b6afb10360273f49$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $65e1f2ae51cf1f63$export$d1162fb0b6d4cd51)(offsetParent) && $b6afb10360273f49$var$isStaticPositioned(offsetParent) && !(0, $65e1f2ae51cf1f63$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $65e1f2ae51cf1f63$export$940d8225183e1404)(element) || win;
}
const $b6afb10360273f49$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $b6afb10360273f49$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $b6afb10360273f49$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $b6afb10360273f49$var$isRTL(element) {
    return (0, $65e1f2ae51cf1f63$export$3735103072e4a80)(element).direction === 'rtl';
}
const $b6afb10360273f49$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $b6afb10360273f49$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $65e1f2ae51cf1f63$export$e495491855dc5418,
    getClippingRect: $b6afb10360273f49$var$getClippingRect,
    getOffsetParent: $b6afb10360273f49$var$getOffsetParent,
    getElementRects: $b6afb10360273f49$var$getElementRects,
    getClientRects: $b6afb10360273f49$var$getClientRects,
    getDimensions: $b6afb10360273f49$var$getDimensions,
    getScale: $b6afb10360273f49$var$getScale,
    isElement: $65e1f2ae51cf1f63$export$45a5e7f76e0caa8d,
    isRTL: $b6afb10360273f49$var$isRTL
};
function $b6afb10360273f49$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $b6afb10360273f49$var$observeMove(element, onMove, ancestorResize) {
    let io = null;
    let timeoutId;
    const root = (0, $65e1f2ae51cf1f63$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $b9e86319c193cbcf$export$a3fe094919f356fd)(top);
        const insetRight = (0, $b9e86319c193cbcf$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $b9e86319c193cbcf$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $b9e86319c193cbcf$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $b9e86319c193cbcf$export$8960430cfd85939f)(0, (0, $b9e86319c193cbcf$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            // The entry is a snapshot, so the reference may have moved since the
            // intersection was computed (under performance constraints, or between
            // consecutive frames of a multi-frame layout shift). The reported ratio
            // and the observed area are stale in that case and cannot be trusted to
            // detect subsequent movement, so refresh regardless of the ratio.
            if (!$b6afb10360273f49$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) return refresh();
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped in place, the ratio is 0. Throttle
                // the refresh to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    const win = (0, $65e1f2ae51cf1f63$export$38b2d434cce3ea22)(element);
    // The window is a resize ancestor, so when `ancestorResize` is enabled its
    // listener already runs the update on resize. Here we only need to rebuild
    // the `IntersectionObserver` for the new root size, skipping a redundant
    // update. When `ancestorResize` is disabled, this becomes the sole update.
    const handleResize = ()=>refresh(ancestorResize);
    win.addEventListener('resize', handleResize);
    refresh(true);
    return ()=>{
        win.removeEventListener('resize', handleResize);
        cleanup();
    };
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $b6afb10360273f49$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $b6afb10360273f49$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $65e1f2ae51cf1f63$export$3b57c1601291186b)(referenceEl) : [],
        ...floating ? (0, $65e1f2ae51cf1f63$export$3b57c1601291186b)(floating) : []
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update);
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $b6afb10360273f49$var$observeMove(referenceEl, update, ancestorResize) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver && floating) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        if (floating) resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $b6afb10360273f49$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $b6afb10360273f49$var$getBoundingClientRect(reference);
        if (prevRefRect && !$b6afb10360273f49$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $b6afb10360273f49$export$37b6bde19b108ecc = (0, $03977f4973bb2b13$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $b6afb10360273f49$export$cc800923e997bb8 = (0, $03977f4973bb2b13$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $b6afb10360273f49$export$91fb6ecbd551914 = (0, $03977f4973bb2b13$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $b6afb10360273f49$export$fba63a578e423eb = (0, $03977f4973bb2b13$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $b6afb10360273f49$export$8a83211c878a3f1f = (0, $03977f4973bb2b13$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $b6afb10360273f49$export$346677f925de839c = (0, $03977f4973bb2b13$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $b6afb10360273f49$export$fe8985bb6374093c = (0, $03977f4973bb2b13$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $b6afb10360273f49$export$f2120bbfa5450bd2 = (0, $03977f4973bb2b13$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $b6afb10360273f49$export$18c8ad048e32c7d5 = (0, $03977f4973bb2b13$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $b6afb10360273f49$export$7bf07e38f3dc4b69 = (0, $03977f4973bb2b13$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $b6afb10360273f49$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = options != null ? options : {};
    const platformWithCache = {
        ...$b6afb10360273f49$export$722a64dea1b767dc,
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $03977f4973bb2b13$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $5E6i4 = parcelRequire("5E6i4");

var $ibUU1 = parcelRequire("ibUU1");
var $579fdd7a121bbebe$var$isClient = typeof document !== 'undefined';
var $579fdd7a121bbebe$var$noop = function noop() {};
var $579fdd7a121bbebe$var$index = $579fdd7a121bbebe$var$isClient ? (0, $5E6i4.useLayoutEffect) : $579fdd7a121bbebe$var$noop;
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $579fdd7a121bbebe$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === 'function' && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === 'object') {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$579fdd7a121bbebe$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            if (!$579fdd7a121bbebe$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $579fdd7a121bbebe$var$getDPR(element) {
    if (typeof window === 'undefined') return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $579fdd7a121bbebe$var$roundByDPR(element, value) {
    const dpr = $579fdd7a121bbebe$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $579fdd7a121bbebe$var$useLatestRef(value) {
    const ref = $5E6i4.useRef(value);
    $579fdd7a121bbebe$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $579fdd7a121bbebe$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform: transform = true, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $5E6i4.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $5E6i4.useState(middleware);
    if (!$579fdd7a121bbebe$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $5E6i4.useState(null);
    const [_floating, _setFloating] = $5E6i4.useState(null);
    const setReference = $5E6i4.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = $5E6i4.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $5E6i4.useRef(null);
    const floatingRef = $5E6i4.useRef(null);
    const dataRef = $5E6i4.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = $579fdd7a121bbebe$var$useLatestRef(whileElementsMounted);
    const platformRef = $579fdd7a121bbebe$var$useLatestRef(platform);
    const openRef = $579fdd7a121bbebe$var$useLatestRef(open);
    const update = $5E6i4.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $b6afb10360273f49$export$48a53dcb22e581d0)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                // The floating element's position may be recomputed while it's closed
                // but still mounted (such as when transitioning out). To ensure
                // `isPositioned` will be `false` initially on the next open, avoid
                // setting it to `true` when `open === false` (must be specified).
                isPositioned: openRef.current !== false
            };
            if (isMountedRef.current && !$579fdd7a121bbebe$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $ibUU1.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef,
        openRef
    ]);
    $579fdd7a121bbebe$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $5E6i4.useRef(false);
    $579fdd7a121bbebe$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $579fdd7a121bbebe$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = $5E6i4.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $5E6i4.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $5E6i4.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $579fdd7a121bbebe$var$roundByDPR(elements.floating, data.x);
        const y = $579fdd7a121bbebe$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$579fdd7a121bbebe$var$getDPR(elements.floating) >= 1.5 && {
                willChange: 'transform'
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $5E6i4.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $579fdd7a121bbebe$var$arrow$1 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, 'current');
    }
    return {
        name: 'arrow',
        options: options,
        fn (state) {
            const { element: element, padding: padding } = typeof options === 'function' ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $b6afb10360273f49$export$f2120bbfa5450bd2)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, $b6afb10360273f49$export$f2120bbfa5450bd2)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $579fdd7a121bbebe$export$cc800923e997bb8 = (options, deps)=>{
    const result = (0, $b6afb10360273f49$export$cc800923e997bb8)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $579fdd7a121bbebe$export$fba63a578e423eb = (options, deps)=>{
    const result = (0, $b6afb10360273f49$export$fba63a578e423eb)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $579fdd7a121bbebe$export$7bf07e38f3dc4b69 = (options, deps)=>{
    const result = (0, $b6afb10360273f49$export$7bf07e38f3dc4b69)(options);
    return {
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $579fdd7a121bbebe$export$8a83211c878a3f1f = (options, deps)=>{
    const result = (0, $b6afb10360273f49$export$8a83211c878a3f1f)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $579fdd7a121bbebe$export$346677f925de839c = (options, deps)=>{
    const result = (0, $b6afb10360273f49$export$346677f925de839c)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $579fdd7a121bbebe$export$91fb6ecbd551914 = (options, deps)=>{
    const result = (0, $b6afb10360273f49$export$91fb6ecbd551914)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $579fdd7a121bbebe$export$fe8985bb6374093c = (options, deps)=>{
    const result = (0, $b6afb10360273f49$export$fe8985bb6374093c)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $579fdd7a121bbebe$export$18c8ad048e32c7d5 = (options, deps)=>{
    const result = (0, $b6afb10360273f49$export$18c8ad048e32c7d5)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $579fdd7a121bbebe$export$f2120bbfa5450bd2 = (options, deps)=>{
    const result = $579fdd7a121bbebe$var$arrow$1(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};


'use client';
//#region src/defaults.ts
const $1a9bd18e23abd3f1$export$ba43bf67f3d48107 = {
    arrowBase: 32,
    arrowColor: "#ffffff",
    arrowSize: 16,
    arrowSpacing: 12,
    backgroundColor: "#ffffff",
    beaconSize: 36,
    beaconTrigger: "click",
    beforeTimeout: 5e3,
    blockTargetInteraction: false,
    buttons: [
        "back",
        "close",
        "primary"
    ],
    closeButtonAction: "close",
    disableFocusTrap: false,
    dismissKeyAction: "close",
    hideOverlay: false,
    loaderDelay: 300,
    offset: 10,
    overlayClickAction: "close",
    overlayColor: "#00000080",
    primaryColor: "#000000",
    scrollDuration: 300,
    scrollOffset: 20,
    showProgress: false,
    skipBeacon: false,
    skipScroll: false,
    spotlightPadding: 10,
    spotlightRadius: 4,
    targetWaitTimeout: 1e3,
    textColor: "#000000",
    width: 380,
    zIndex: 100
};
const $1a9bd18e23abd3f1$var$defaultFloatingOptions = {
    beaconOptions: {
        offset: -18
    }
};
const $1a9bd18e23abd3f1$export$d7f512c98c859244 = {
    back: "Back",
    close: "Close",
    last: "Last",
    next: "Next",
    nextWithProgress: "Next ({current} of {total})",
    open: "Open the dialog",
    skip: "Skip"
};
const $1a9bd18e23abd3f1$var$defaultStep = {
    isFixed: false,
    locale: $1a9bd18e23abd3f1$export$d7f512c98c859244,
    placement: "bottom"
};
const $1a9bd18e23abd3f1$var$defaultProps = {
    continuous: false,
    debug: false,
    run: false,
    scrollToFirstStep: false,
    steps: []
};
//#endregion
//#region src/literals/index.ts
const $1a9bd18e23abd3f1$export$92a1a3b7554e9387 = {
    INIT: "init",
    START: "start",
    STOP: "stop",
    RESET: "reset",
    PREV: "prev",
    NEXT: "next",
    GO: "go",
    CLOSE: "close",
    SKIP: "skip",
    REPLAY: "replay",
    UPDATE: "update",
    COMPLETE: "complete"
};
const $1a9bd18e23abd3f1$export$fa3d5b535a2458a1 = {
    TOUR_START: "tour:start",
    STEP_BEFORE_HOOK: "step:before_hook",
    STEP_BEFORE: "step:before",
    SCROLL_START: "scroll:start",
    SCROLL_END: "scroll:end",
    BEACON: "beacon",
    TOOLTIP: "tooltip",
    STEP_AFTER: "step:after",
    STEP_AFTER_HOOK: "step:after_hook",
    TOUR_END: "tour:end",
    TOUR_STATUS: "tour:status",
    TARGET_NOT_FOUND: "error:target_not_found",
    ERROR: "error"
};
const $1a9bd18e23abd3f1$export$2cb9787dd463cbf4 = {
    INIT: "init",
    READY: "ready",
    BEACON_BEFORE: "beacon_before",
    BEACON: "beacon",
    TOOLTIP_BEFORE: "tooltip_before",
    TOOLTIP: "tooltip",
    COMPLETE: "complete"
};
const $1a9bd18e23abd3f1$export$ccee77ec32a436d7 = {
    BUTTON_BACK: "button_back",
    BUTTON_CLOSE: "button_close",
    BUTTON_PRIMARY: "button_primary",
    BUTTON_SKIP: "button_skip",
    KEYBOARD: "keyboard",
    OVERLAY: "overlay"
};
const $1a9bd18e23abd3f1$export$e50006273435e7d4 = {
    IDLE: "idle",
    READY: "ready",
    WAITING: "waiting",
    RUNNING: "running",
    PAUSED: "paused",
    SKIPPED: "skipped",
    FINISHED: "finished"
};
const $1a9bd18e23abd3f1$export$a42db32261056924 = "react-joyride-portal";
//#endregion
//#region src/modules/helpers.tsx
/**
* Remove properties with undefined value from an object
*/ function $1a9bd18e23abd3f1$var$cleanUpObject(input) {
    const output = {};
    for(const key in input)if (input[key] !== void 0) output[key] = input[key];
    return output;
}
function $1a9bd18e23abd3f1$var$deepMerge(...objects) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($653da11647de05d0$exports)))({
        all: true,
        isMergeableObject: (value)=>!(!(0, $209e2c4c2fa2f6ac$export$2e2bcd8739ae039).plainObject(value) || (0, $5E6i4.isValidElement)(value))
    })(...objects);
}
/**
* Get Object type
*/ function $1a9bd18e23abd3f1$var$getObjectType(value) {
    return Object.prototype.toString.call(value).slice(8, -1).toLowerCase();
}
function $1a9bd18e23abd3f1$var$getReactNodeText(input, options = {}) {
    const { defaultValue: defaultValue, step: step, steps: steps } = options;
    let text = (0, (/*@__PURE__*/$parcel$interopDefault($72058227f48a8157$exports)))(input);
    if (!text) {
        if ((0, $5E6i4.isValidElement)(input) && !Object.values(input.props).length && $1a9bd18e23abd3f1$var$getObjectType(input.type) === "function") try {
            text = $1a9bd18e23abd3f1$var$getReactNodeText(input.type({}), options);
        } catch  {
            text = (0, (/*@__PURE__*/$parcel$interopDefault($72058227f48a8157$exports)))(defaultValue);
        }
        else text = (0, (/*@__PURE__*/$parcel$interopDefault($72058227f48a8157$exports)))(defaultValue);
    } else if ((text.includes("{current}") || text.includes("{total}")) && step && steps) text = text.replace("{current}", step.toString()).replace("{total}", steps.toString());
    return text;
}
/**
* Log method calls if debug is enabled
*/ function $1a9bd18e23abd3f1$var$log(debug, scope, title, ...data) {
    if (!debug) return;
    const now = /* @__PURE__ */ new Date();
    const time = `${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}:${String(now.getSeconds()).padStart(2, "0")}.${String(now.getMilliseconds()).padStart(3, "0")}`;
    console.log(`${scope} %c${title}%c ${time}`, "font-weight: bold", "color: gray; font-weight: normal", ...data);
}
/**
* Merges the defaultProps with literal values with the incoming props, removing undefined values from it that would override the defaultProps.
* The result is a type-safe object with the defaultProps as required properties.
*/ function $1a9bd18e23abd3f1$var$mergeProps(defaultProps, props) {
    const cleanProps = $1a9bd18e23abd3f1$var$cleanUpObject(props);
    return {
        ...defaultProps,
        ...cleanProps
    };
}
/**
* A function that does nothing.
*/ function $1a9bd18e23abd3f1$var$noop() {}
/**
* Type-safe Object.keys()
*/ function $1a9bd18e23abd3f1$var$objectKeys(input) {
    return Object.keys(input);
}
/**
* Remove properties from an object
*/ function $1a9bd18e23abd3f1$var$omit(input, ...filter) {
    if (!(0, $209e2c4c2fa2f6ac$export$2e2bcd8739ae039).plainObject(input)) throw new TypeError("Expected an object");
    const output = {};
    for(const key in input)/* istanbul ignore else */ if (({}).hasOwnProperty.call(input, key) && !filter.includes(key)) output[key] = input[key];
    return output;
}
/**
* Select properties from an object
*/ function $1a9bd18e23abd3f1$var$pick(input, ...filter) {
    if (!(0, $209e2c4c2fa2f6ac$export$2e2bcd8739ae039).plainObject(input)) throw new TypeError("Expected an object");
    if (!filter.length) return input;
    const output = {};
    for(const key in input)/* istanbul ignore else */ if (({}).hasOwnProperty.call(input, key) && filter.includes(key)) output[key] = input[key];
    return output;
}
function $1a9bd18e23abd3f1$var$replaceLocaleContent(input, step, steps) {
    const replacer = (text)=>text.replace("{current}", String(step)).replace("{total}", String(steps));
    if ($1a9bd18e23abd3f1$var$getObjectType(input) === "string") return replacer(input);
    if (!(0, $5E6i4.isValidElement)(input)) return input;
    const { children: children } = input.props;
    if ((0, $209e2c4c2fa2f6ac$export$2e2bcd8739ae039).string(children) && children.includes("{current}")) return (0, $5E6i4.cloneElement)(input, {
        children: replacer(children)
    });
    if (Array.isArray(children)) return (0, $5E6i4.cloneElement)(input, {
        children: children.map((child)=>{
            if (typeof child === "string") return replacer(child);
            return $1a9bd18e23abd3f1$var$replaceLocaleContent(child, step, steps);
        })
    });
    if ((0, $209e2c4c2fa2f6ac$export$2e2bcd8739ae039).function(input.type) && !Object.values(input.props).length) try {
        return $1a9bd18e23abd3f1$var$replaceLocaleContent(input.type({}), step, steps);
    } catch  {
        return input;
    }
    return input;
}
/**
* Sort object keys
*/ function $1a9bd18e23abd3f1$var$sortObjectKeys(input) {
    return $1a9bd18e23abd3f1$var$objectKeys(input).sort().reduce((acc, key)=>{
        acc[key] = input[key];
        return acc;
    }, {});
}
//#endregion
//#region src/modules/dom.ts
function $1a9bd18e23abd3f1$var$canUseDOM() {
    return !!(typeof window !== "undefined" && window.document?.createElement);
}
/**
* Find the bounding client rect
*/ function $1a9bd18e23abd3f1$var$getClientRect(element) {
    if (!element) return null;
    return element.getBoundingClientRect();
}
/**
* Helper function to get the browser-normalized "document height"
*/ function $1a9bd18e23abd3f1$var$getDocumentHeight(median = false) {
    const { body: body, documentElement: documentElement } = document;
    if (!body || !documentElement) return 0;
    if (median) {
        const heights = [
            body.scrollHeight,
            body.offsetHeight,
            documentElement.clientHeight,
            documentElement.scrollHeight,
            documentElement.offsetHeight
        ].sort((a, b)=>a - b);
        const middle = Math.floor(heights.length / 2);
        if (heights.length % 2 === 0) return (heights[middle - 1] + heights[middle]) / 2;
        return heights[middle];
    }
    return Math.max(body.scrollHeight, body.offsetHeight, documentElement.clientHeight, documentElement.scrollHeight, documentElement.offsetHeight);
}
/**
* Find and return the target DOM element based on a step's 'target'.
*/ function $1a9bd18e23abd3f1$var$getElement(element) {
    if (!element) return null;
    if (typeof element === "function") try {
        return element();
    } catch (error) {
        return null;
    }
    if (typeof element === "object" && "current" in element) return element.current;
    if (typeof element === "string") try {
        return document.querySelector(element);
    } catch (error) {
        return null;
    }
    return element;
}
/**
* Return the target's top position in document space (viewport top + scroll − offset).
*/ function $1a9bd18e23abd3f1$var$getElementPosition(element, offset, isFixed) {
    const elementRect = $1a9bd18e23abd3f1$var$getClientRect(element);
    const parent = $1a9bd18e23abd3f1$var$getScrollParent(element);
    const hasScrollParent = parent ? !parent.isSameNode($1a9bd18e23abd3f1$var$scrollDocument()) : false;
    const isFixedTarget = isFixed ?? $1a9bd18e23abd3f1$var$hasPosition(element);
    let parentTop = 0;
    let top = elementRect?.top ?? 0;
    if (hasScrollParent && isFixedTarget) top = elementRect?.top ?? 0;
    else if (parent instanceof HTMLElement) {
        parentTop = parent.scrollTop;
        if (!hasScrollParent && !isFixedTarget) top += parentTop;
        if (!parent.isSameNode($1a9bd18e23abd3f1$var$scrollDocument())) top += $1a9bd18e23abd3f1$var$scrollDocument().scrollTop;
    }
    return Math.floor(top - offset);
}
/**
* Get the scroll parent of an element.
* If the detected parent doesn't actually scroll, fall back to the document.
*/ function $1a9bd18e23abd3f1$var$getScrollParent(element, forListener) {
    if (!element) return $1a9bd18e23abd3f1$var$scrollDocument();
    const parent = (0, (/*@__PURE__*/$parcel$interopDefault($6ddd06ae6fd6816d$exports)))(element);
    if (parent) {
        if (parent.isSameNode($1a9bd18e23abd3f1$var$scrollDocument())) {
            if (forListener) return document;
            return $1a9bd18e23abd3f1$var$scrollDocument();
        }
        if (!(parent.scrollHeight > parent.offsetHeight)) return $1a9bd18e23abd3f1$var$scrollDocument();
    }
    return parent;
}
function $1a9bd18e23abd3f1$var$getScrollTargetToCenter(element) {
    const rect = element.getBoundingClientRect();
    const documentElement = $1a9bd18e23abd3f1$var$scrollDocument();
    const containerCenter = rect.top + rect.height / 2;
    const viewportCenter = window.innerHeight / 2;
    return Math.max(0, documentElement.scrollTop + containerCenter - viewportCenter);
}
/**
* Get the scrollTop position
*/ function $1a9bd18e23abd3f1$var$getScrollTo(element, offset) {
    if (!element) return 0;
    const parentElement = (0, (/*@__PURE__*/$parcel$interopDefault($6ddd06ae6fd6816d$exports)))(element) ?? $1a9bd18e23abd3f1$var$scrollDocument();
    const scrollMarginTop = parseFloat(getComputedStyle(element).scrollMarginTop) || 0;
    const parentRect = $1a9bd18e23abd3f1$var$getClientRect(parentElement);
    const parentScrollTop = parentElement.scrollTop ?? 0;
    const { offsetTop: offsetTop = 0, scrollTop: scrollTop = 0 } = parentElement;
    let top = element.getBoundingClientRect().top + scrollTop;
    if (!!offsetTop && ($1a9bd18e23abd3f1$var$hasCustomScrollParent(element) || $1a9bd18e23abd3f1$var$hasCustomOffsetParent(element))) {
        const elementRect = element.getBoundingClientRect();
        const elementTopInContainer = elementRect.top - (parentRect?.top ?? 0);
        const elementBottomInContainer = elementTopInContainer + elementRect.height;
        const containerHeight = parentElement.clientHeight;
        const margin = containerHeight * .2;
        if (elementTopInContainer >= margin && elementBottomInContainer <= containerHeight - margin) top = parentScrollTop;
        else top = elementTopInContainer + parentScrollTop;
    }
    const output = Math.floor(top - offset - scrollMarginTop);
    return output < 0 ? 0 : output;
}
/**
* Check if the element has custom offset parent
*/ function $1a9bd18e23abd3f1$var$hasCustomOffsetParent(element) {
    return element.offsetParent !== document.body;
}
/**
* Check if the element has custom scroll parent
*/ function $1a9bd18e23abd3f1$var$hasCustomScrollParent(element) {
    if (!element) return false;
    const parent = $1a9bd18e23abd3f1$var$getScrollParent(element);
    return parent ? !parent.isSameNode($1a9bd18e23abd3f1$var$scrollDocument()) : false;
}
/**
* Check if an element has fixed/sticky position
*/ function $1a9bd18e23abd3f1$var$hasPosition(el, type = "fixed") {
    if (!el || !(el instanceof Element)) return false;
    const { nodeName: nodeName } = el;
    if (nodeName === "BODY" || nodeName === "HTML") return false;
    if (getComputedStyle(el).position === type) return true;
    if (!el.parentNode) return false;
    return $1a9bd18e23abd3f1$var$hasPosition(el.parentNode, type);
}
/**
* Check if the element is visible
*/ function $1a9bd18e23abd3f1$var$isElementVisible(element) {
    if (!element) return false;
    let parentElement = element;
    while(parentElement){
        if (parentElement === document.body) break;
        if (parentElement instanceof HTMLElement) {
            const { display: display, visibility: visibility } = getComputedStyle(parentElement);
            if (display === "none" || visibility === "hidden") return false;
        }
        parentElement = parentElement.parentElement ?? null;
    }
    return true;
}
function $1a9bd18e23abd3f1$var$needsScrolling(options) {
    const { isFirstStep: isFirstStep, scrollToFirstStep: scrollToFirstStep, step: step, target: target, targetLifecycle: targetLifecycle } = options;
    if (step.skipScroll || isFirstStep && !scrollToFirstStep && targetLifecycle !== $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.TOOLTIP || step.placement === "center") return false;
    const parent = target?.isConnected ? $1a9bd18e23abd3f1$var$getScrollParent(target) : $1a9bd18e23abd3f1$var$scrollDocument();
    const isCustomScrollParent = parent ? !parent.isSameNode($1a9bd18e23abd3f1$var$scrollDocument()) : false;
    if ((step.isFixed || $1a9bd18e23abd3f1$var$hasPosition(target)) && !isCustomScrollParent) return false;
    return parent.scrollHeight > parent.clientHeight;
}
function $1a9bd18e23abd3f1$var$scrollDocument() {
    return document.scrollingElement ?? document.documentElement;
}
/**
* Scroll to position
*/ function $1a9bd18e23abd3f1$var$scrollTo(value, options) {
    const { duration: duration, element: element } = options;
    let cancel = ()=>{};
    const promise = new Promise((resolve)=>{
        const { scrollTop: scrollTop } = element;
        const limit = value > scrollTop ? value - scrollTop : scrollTop - value;
        cancel = (0, (/*@__PURE__*/$parcel$interopDefault($8240c897140e47e1$exports))).top(element, value, {
            duration: limit < 100 ? 50 : duration
        }, ()=>{
            resolve();
        });
    });
    return {
        cancel: cancel,
        promise: promise
    };
}
//#endregion
//#region src/styles.ts
/**
* Convert hex to RGB
*/ function $1a9bd18e23abd3f1$var$hexToRGB(hex) {
    const properHex = hex.replace(/^#?([\da-f])([\da-f])([\da-f])$/i, (_m, r, g, b)=>r + r + g + g + b + b);
    const result = /^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})/i.exec(properHex);
    return result ? [
        parseInt(result[1], 16),
        parseInt(result[2], 16),
        parseInt(result[3], 16)
    ] : [];
}
const $1a9bd18e23abd3f1$var$buttonReset = {
    backgroundColor: "transparent",
    border: 0,
    borderRadius: 0,
    color: "#555555",
    cursor: "pointer",
    fontSize: 16,
    lineHeight: 1,
    padding: 0,
    WebkitAppearance: "none"
};
const $1a9bd18e23abd3f1$var$buttonBase = {
    ...$1a9bd18e23abd3f1$var$buttonReset,
    borderRadius: 4,
    padding: 8
};
function $1a9bd18e23abd3f1$var$getStyles(props, step) {
    const { styles: styles } = props;
    const mergedStyles = $1a9bd18e23abd3f1$var$deepMerge(styles ?? {}, step.styles ?? {});
    let { width: width } = step;
    if ($1a9bd18e23abd3f1$var$canUseDOM()) width = typeof width === "number" && window.innerWidth < width ? window.innerWidth - 30 : width;
    const overlay = {
        bottom: 0,
        left: 0,
        overflow: "hidden",
        position: "absolute",
        right: 0,
        top: 0,
        zIndex: step.zIndex
    };
    return $1a9bd18e23abd3f1$var$deepMerge({
        arrow: {
            alignItems: "center",
            color: step.arrowColor,
            display: "inline-flex",
            justifyContent: "center",
            position: "absolute"
        },
        beaconWrapper: {
            ...$1a9bd18e23abd3f1$var$buttonReset,
            display: "inline-flex",
            borderRadius: "50%",
            position: "relative"
        },
        beacon: {
            height: step.beaconSize,
            width: step.beaconSize
        },
        beaconInner: {
            animation: "joyride-beacon-inner 1.2s infinite ease-in-out",
            backgroundColor: step.primaryColor,
            borderRadius: "50%",
            display: "block",
            height: "50%",
            left: "50%",
            opacity: .7,
            position: "absolute",
            top: "50%",
            transform: "translate(-50%, -50%)",
            width: "50%"
        },
        beaconOuter: {
            animation: "joyride-beacon-outer 1.2s infinite ease-in-out",
            backgroundColor: `rgba(${$1a9bd18e23abd3f1$var$hexToRGB(step.primaryColor).join(",")}, 0.2)`,
            border: `2px solid ${step.primaryColor}`,
            borderRadius: "50%",
            boxSizing: "border-box",
            display: "block",
            height: "100%",
            left: 0,
            opacity: .9,
            position: "absolute",
            top: 0,
            transformOrigin: "center",
            width: "100%"
        },
        buttonBack: {
            ...$1a9bd18e23abd3f1$var$buttonBase,
            color: step.primaryColor,
            marginLeft: "auto",
            marginRight: 5
        },
        buttonClose: {
            ...$1a9bd18e23abd3f1$var$buttonBase,
            color: step.textColor,
            height: 12,
            padding: 8,
            position: "absolute",
            right: 0,
            top: 0,
            width: 12
        },
        buttonPrimary: {
            ...$1a9bd18e23abd3f1$var$buttonBase,
            backgroundColor: step.primaryColor,
            color: step.backgroundColor
        },
        buttonSkip: {
            ...$1a9bd18e23abd3f1$var$buttonBase,
            color: step.textColor,
            fontSize: 14
        },
        floater: {
            display: "inline-block",
            filter: "drop-shadow(0 0 3px rgba(0, 0, 0, 0.3))",
            maxWidth: "100%",
            transition: "opacity 0.3s"
        },
        loader: {
            alignItems: "center",
            display: "flex",
            height: 48,
            inset: 0,
            justifyContent: "center",
            pointerEvents: "none",
            position: "fixed",
            width: 48,
            zIndex: step.zIndex + 1
        },
        overlay: {
            ...overlay,
            backgroundColor: step.overlayColor
        },
        spotlight: {},
        tooltip: {
            backgroundColor: step.backgroundColor,
            borderRadius: 5,
            boxSizing: "border-box",
            color: step.textColor,
            fontSize: 16,
            maxWidth: "100%",
            padding: 12,
            position: "relative",
            width: width
        },
        tooltipContainer: {
            lineHeight: 1.4,
            textAlign: "center"
        },
        tooltipTitle: {
            fontSize: 18,
            margin: 0
        },
        tooltipContent: {
            paddingBottom: 12,
            paddingTop: 12
        },
        tooltipFooter: {
            alignItems: "center",
            display: "flex",
            justifyContent: "flex-end"
        },
        tooltipFooterSpacer: {
            flex: 1
        }
    }, mergedStyles);
}
//#endregion
//#region src/modules/step.ts
const $1a9bd18e23abd3f1$var$optionFieldNames = [
    "after",
    "arrowBase",
    "arrowColor",
    "arrowSize",
    "arrowSpacing",
    "backgroundColor",
    "beaconSize",
    "beaconTrigger",
    "before",
    "beforeTimeout",
    "buttons",
    "closeButtonAction",
    "skipBeacon",
    "dismissKeyAction",
    "disableFocusTrap",
    "hideOverlay",
    "skipScroll",
    "blockTargetInteraction",
    "loaderDelay",
    "offset",
    "overlayClickAction",
    "overlayColor",
    "primaryColor",
    "scrollDuration",
    "scrollOffset",
    "showProgress",
    "spotlightPadding",
    "spotlightRadius",
    "targetWaitTimeout",
    "textColor",
    "width",
    "zIndex"
];
function $1a9bd18e23abd3f1$var$getMergedStep(props, currentStep) {
    if (!currentStep) return null;
    const mergedStep = $1a9bd18e23abd3f1$var$deepMerge($1a9bd18e23abd3f1$var$defaultStep, $1a9bd18e23abd3f1$var$pick(props, "arrowComponent", "beaconComponent", "floatingOptions", "loaderComponent", "locale", "styles", "tooltipComponent"), currentStep);
    const mergedOptions = $1a9bd18e23abd3f1$var$deepMerge($1a9bd18e23abd3f1$export$ba43bf67f3d48107, props.options ?? {}, $1a9bd18e23abd3f1$var$pick(currentStep, ...$1a9bd18e23abd3f1$var$optionFieldNames));
    const mergedStyles = $1a9bd18e23abd3f1$var$getStyles(props, {
        ...mergedStep,
        ...mergedOptions
    });
    const floatingOptions = $1a9bd18e23abd3f1$var$deepMerge($1a9bd18e23abd3f1$var$defaultFloatingOptions, props.floatingOptions ?? {}, mergedStep.floatingOptions ?? {});
    return {
        ...mergedStep,
        ...mergedOptions,
        locale: $1a9bd18e23abd3f1$var$deepMerge($1a9bd18e23abd3f1$export$d7f512c98c859244, props.locale ?? {}, mergedStep.locale || {}),
        floatingOptions: floatingOptions,
        spotlightPadding: $1a9bd18e23abd3f1$var$normalizeSpotlightPadding(mergedOptions.spotlightPadding),
        styles: mergedStyles
    };
}
function $1a9bd18e23abd3f1$var$normalizeSpotlightPadding(value) {
    if (typeof value === "number") return {
        top: value,
        right: value,
        bottom: value,
        left: value
    };
    return {
        top: value?.top ?? 0,
        right: value?.right ?? 0,
        bottom: value?.bottom ?? 0,
        left: value?.left ?? 0
    };
}
/**
* Decide if the step shouldn't skip the beacon
*/ function $1a9bd18e23abd3f1$var$shouldHideBeacon(step, state, continuous) {
    const { action: action } = state;
    const withContinuous = continuous && [
        $1a9bd18e23abd3f1$export$92a1a3b7554e9387.PREV,
        $1a9bd18e23abd3f1$export$92a1a3b7554e9387.NEXT
    ].includes(action);
    return step.skipBeacon || step.placement === "center" || withContinuous;
}
/**
* Validate if a step is valid
*/ function $1a9bd18e23abd3f1$var$validateStep(step, debug = false) {
    if (!(0, $209e2c4c2fa2f6ac$export$2e2bcd8739ae039).plainObject(step)) {
        $1a9bd18e23abd3f1$var$log(debug, "tour", "step must be an object");
        return false;
    }
    if (!step.target) {
        $1a9bd18e23abd3f1$var$log(debug, "tour", "target is missing from the step");
        return false;
    }
    return true;
}
/**
* Validate if steps are valid
*/ function $1a9bd18e23abd3f1$var$validateSteps(steps, debug = false) {
    if (!(0, $209e2c4c2fa2f6ac$export$2e2bcd8739ae039).array(steps)) {
        $1a9bd18e23abd3f1$var$log(debug, "tour", "steps must be an array");
        return false;
    }
    return steps.every((d)=>$1a9bd18e23abd3f1$var$validateStep(d, debug));
}
//#endregion
//#region src/modules/store.ts
var $1a9bd18e23abd3f1$var$Store = class {
    beaconPosition = null;
    debug;
    eventListeners = /* @__PURE__ */ new Map();
    listeners = /* @__PURE__ */ new Set();
    props;
    snapshot;
    state;
    steps;
    tooltipPosition = null;
    constructor(options){
        const { initialStepIndex: initialStepIndex, stepIndex: stepIndex, steps: steps = [] } = options ?? {};
        const isControlled = (0, $209e2c4c2fa2f6ac$export$2e2bcd8739ae039).number(stepIndex);
        let startIndex = 0;
        this.debug = options?.debug ?? false;
        if (isControlled) {
            startIndex = stepIndex;
            if ((0, $209e2c4c2fa2f6ac$export$2e2bcd8739ae039).number(initialStepIndex)) $1a9bd18e23abd3f1$var$log(this.debug, "tour", "initialStepIndex is ignored in controlled mode");
        } else if ((0, $209e2c4c2fa2f6ac$export$2e2bcd8739ae039).number(initialStepIndex)) {
            if (initialStepIndex >= 0 && initialStepIndex < steps.length) startIndex = initialStepIndex;
            else if (steps.length > 0) $1a9bd18e23abd3f1$var$log(this.debug, "tour", "initialStepIndex is out of bounds");
        }
        this.props = options ?? {
            steps: []
        };
        this.steps = steps;
        this.state = {
            action: $1a9bd18e23abd3f1$export$92a1a3b7554e9387.INIT,
            controlled: isControlled,
            index: startIndex,
            lifecycle: $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.INIT,
            origin: null,
            positioned: false,
            scrolling: false,
            size: steps.length,
            status: steps.length ? $1a9bd18e23abd3f1$export$e50006273435e7d4.READY : $1a9bd18e23abd3f1$export$e50006273435e7d4.IDLE,
            waiting: false
        };
        this.snapshot = Object.freeze({
            ...this.state
        });
    }
    applyTransitions(draft) {
        if (draft.status === $1a9bd18e23abd3f1$export$e50006273435e7d4.WAITING && draft.size > 0) return {
            ...draft,
            status: $1a9bd18e23abd3f1$export$e50006273435e7d4.RUNNING
        };
        return draft;
    }
    getStep(nextIndex) {
        return $1a9bd18e23abd3f1$var$getMergedStep(this.props, this.steps[nextIndex ?? this.state.index]);
    }
    cleanupPositionData = ()=>{
        this.beaconPosition = null;
        this.tooltipPosition = null;
    };
    getPositionData = (name)=>{
        if (name === "beacon") return this.beaconPosition;
        return this.tooltipPosition;
    };
    getServerSnapshot = ()=>this.snapshot;
    getSnapshot = ()=>this.snapshot;
    getEventState = ()=>$1a9bd18e23abd3f1$var$omit(this.snapshot, "positioned");
    getState = ()=>$1a9bd18e23abd3f1$var$omit(this.snapshot, "positioned");
    setPositionData = (name, data)=>{
        if ((name === "beacon" ? this.beaconPosition : this.tooltipPosition)?.placement !== data.placement) $1a9bd18e23abd3f1$var$log(this.debug, `step:${this.state.index}`, "positioned", `${name} ${data.placement}`);
        if (name === "beacon") this.beaconPosition = data;
        else this.tooltipPosition = data;
        if ((this.state.lifecycle === $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.BEACON_BEFORE || this.state.lifecycle === $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.TOOLTIP_BEFORE) && !this.state.positioned) this.updateState({
            positioned: true
        });
        const onPosition = this.getStep()?.floatingOptions?.onPosition;
        if (onPosition) onPosition(data);
    };
    setSteps = (steps)=>{
        this.steps = steps;
        this.updateState({
            size: steps.length
        });
    };
    dispatch = (data, controls)=>{
        const handlers = this.eventListeners.get(data.type);
        if (handlers) for (const handler of handlers)try {
            handler(data, controls);
        } catch  {}
    };
    on = (eventType, handler)=>{
        let handlers = this.eventListeners.get(eventType);
        if (!handlers) {
            handlers = /* @__PURE__ */ new Set();
            this.eventListeners.set(eventType, handlers);
        }
        handlers.add(handler);
        return ()=>{
            handlers.delete(handler);
        };
    };
    subscribe = (listener)=>{
        this.listeners.add(listener);
        return ()=>{
            this.listeners.delete(listener);
        };
    };
    updateState = (patch, forceIndex = false)=>{
        const { controlled: controlled, index: index } = this.state;
        const previousSnapshot = this.snapshot;
        const resolvedIndex = controlled && !forceIndex && patch.index !== void 0 ? index : patch.index ?? index;
        const merged = {
            action: patch.action ?? this.state.action,
            controlled: controlled,
            index: resolvedIndex,
            lifecycle: patch.lifecycle ?? this.state.lifecycle,
            origin: patch.origin ?? null,
            positioned: patch.positioned ?? this.state.positioned,
            scrolling: patch.scrolling ?? this.state.scrolling,
            size: patch.size ?? this.state.size,
            status: patch.status ?? this.state.status,
            waiting: patch.waiting ?? this.state.waiting
        };
        const final = this.applyTransitions(merged);
        this.state = final;
        if (!(0, $672b606f04caafab$export$2e2bcd8739ae039)(previousSnapshot, final)) {
            this.snapshot = Object.freeze({
                ...final
            });
            for (const listener of this.listeners)listener(this.snapshot);
        }
    };
};
function $1a9bd18e23abd3f1$var$createStore(options) {
    return new $1a9bd18e23abd3f1$var$Store(options);
}
//#endregion
//#region src/hooks/useControls.ts
function $1a9bd18e23abd3f1$var$getUpdatedIndex(nextIndex, size) {
    return Math.min(Math.max(nextIndex, 0), size);
}
function $1a9bd18e23abd3f1$var$useControls(store, debug, clearFailures) {
    const debugRef = (0, $5E6i4.useRef)(debug);
    const clearFailuresRef = (0, $5E6i4.useRef)(clearFailures);
    debugRef.current = debug;
    clearFailuresRef.current = clearFailures;
    return (0, $5E6i4.useMemo)(()=>{
        const getState = ()=>store.current.getSnapshot();
        const close = (origin = null)=>{
            const { index: index, status: status } = getState();
            if (status !== $1a9bd18e23abd3f1$export$e50006273435e7d4.RUNNING) return;
            store.current.updateState({
                action: $1a9bd18e23abd3f1$export$92a1a3b7554e9387.CLOSE,
                index: index + 1,
                origin: origin,
                lifecycle: $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.COMPLETE,
                positioned: false,
                scrolling: false,
                waiting: false
            });
        };
        const go = (nextIndex)=>{
            const { controlled: controlled, size: size, status: status } = getState();
            if (controlled) {
                $1a9bd18e23abd3f1$var$log(debugRef.current, "tour", "go() is not supported in controlled mode");
                return;
            }
            if (status !== $1a9bd18e23abd3f1$export$e50006273435e7d4.RUNNING) return;
            store.current.updateState({
                action: $1a9bd18e23abd3f1$export$92a1a3b7554e9387.GO,
                index: nextIndex,
                lifecycle: $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.COMPLETE,
                positioned: false,
                scrolling: false,
                status: nextIndex < size ? status : $1a9bd18e23abd3f1$export$e50006273435e7d4.FINISHED,
                waiting: false
            });
        };
        const info = ()=>$1a9bd18e23abd3f1$var$omit(store.current.getSnapshot(), "positioned");
        const next = (origin)=>{
            const { index: index, size: size, status: status } = getState();
            if (status !== $1a9bd18e23abd3f1$export$e50006273435e7d4.RUNNING) return;
            store.current.updateState({
                action: $1a9bd18e23abd3f1$export$92a1a3b7554e9387.NEXT,
                index: $1a9bd18e23abd3f1$var$getUpdatedIndex(index + 1, size),
                lifecycle: $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.COMPLETE,
                origin: origin,
                positioned: false,
                scrolling: false,
                waiting: false
            });
        };
        const open = ()=>{
            const { status: status } = getState();
            if (status !== $1a9bd18e23abd3f1$export$e50006273435e7d4.RUNNING) return;
            store.current.updateState({
                action: $1a9bd18e23abd3f1$export$92a1a3b7554e9387.UPDATE,
                lifecycle: $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.TOOLTIP_BEFORE,
                positioned: false,
                scrolling: false,
                waiting: false
            });
        };
        const previous = (origin)=>{
            const { index: index, size: size, status: status } = getState();
            if (status !== $1a9bd18e23abd3f1$export$e50006273435e7d4.RUNNING) return;
            store.current.updateState({
                action: $1a9bd18e23abd3f1$export$92a1a3b7554e9387.PREV,
                index: $1a9bd18e23abd3f1$var$getUpdatedIndex(index - 1, size),
                lifecycle: $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.COMPLETE,
                origin: origin,
                positioned: false,
                scrolling: false,
                waiting: false
            });
        };
        const replay = (origin)=>{
            const { lifecycle: lifecycle, status: status } = getState();
            if (status !== $1a9bd18e23abd3f1$export$e50006273435e7d4.RUNNING || lifecycle !== $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.TOOLTIP) return;
            store.current.updateState({
                action: $1a9bd18e23abd3f1$export$92a1a3b7554e9387.REPLAY,
                lifecycle: $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.COMPLETE,
                origin: origin,
                positioned: false,
                scrolling: false,
                waiting: false
            });
        };
        const reset = (restart = false)=>{
            const { controlled: controlled } = getState();
            if (controlled) {
                $1a9bd18e23abd3f1$var$log(debugRef.current, "tour", "reset() is not supported in controlled mode");
                return;
            }
            clearFailuresRef.current();
            store.current.updateState({
                action: $1a9bd18e23abd3f1$export$92a1a3b7554e9387.RESET,
                index: 0,
                lifecycle: $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.INIT,
                positioned: false,
                scrolling: false,
                status: restart ? $1a9bd18e23abd3f1$export$e50006273435e7d4.RUNNING : $1a9bd18e23abd3f1$export$e50006273435e7d4.READY,
                waiting: false
            });
        };
        const skip = (origin)=>{
            const { status: status } = getState();
            if (status !== $1a9bd18e23abd3f1$export$e50006273435e7d4.RUNNING) return;
            store.current.updateState({
                action: $1a9bd18e23abd3f1$export$92a1a3b7554e9387.SKIP,
                lifecycle: $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.COMPLETE,
                origin: origin,
                positioned: false,
                scrolling: false,
                status: $1a9bd18e23abd3f1$export$e50006273435e7d4.SKIPPED,
                waiting: false
            });
        };
        const start = (nextIndex)=>{
            const { index: index, size: size } = getState();
            clearFailuresRef.current();
            store.current.updateState({
                action: $1a9bd18e23abd3f1$export$92a1a3b7554e9387.START,
                index: (0, $209e2c4c2fa2f6ac$export$2e2bcd8739ae039).number(nextIndex) ? nextIndex : index,
                lifecycle: $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.INIT,
                positioned: false,
                scrolling: false,
                status: size ? $1a9bd18e23abd3f1$export$e50006273435e7d4.RUNNING : $1a9bd18e23abd3f1$export$e50006273435e7d4.WAITING,
                waiting: false
            }, true);
        };
        const stop = (advance = false)=>{
            const { index: index, status: status } = getState();
            if ([
                $1a9bd18e23abd3f1$export$e50006273435e7d4.FINISHED,
                $1a9bd18e23abd3f1$export$e50006273435e7d4.SKIPPED
            ].includes(status)) return;
            store.current.updateState({
                action: $1a9bd18e23abd3f1$export$92a1a3b7554e9387.STOP,
                index: index + (advance ? 1 : 0),
                lifecycle: $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.COMPLETE,
                positioned: false,
                scrolling: false,
                status: $1a9bd18e23abd3f1$export$e50006273435e7d4.PAUSED,
                waiting: false
            });
        };
        return {
            close: close,
            go: go,
            info: info,
            next: next,
            open: open,
            prev: previous,
            replay: replay,
            reset: reset,
            skip: skip,
            start: start,
            stop: stop
        };
    }, [
        store
    ]);
}
//#endregion
//#region src/hooks/useDebugLogger.ts
const $1a9bd18e23abd3f1$var$skipFields = /* @__PURE__ */ new Set([
    "origin",
    "positioned"
]);
function $1a9bd18e23abd3f1$var$useDebugLogger(store, debug) {
    const previousRef = (0, $5E6i4.useRef)(null);
    (0, $5E6i4.useEffect)(()=>{
        if (!debug) return;
        const current = store.current.getSnapshot();
        $1a9bd18e23abd3f1$var$log(true, "tour", "init", current);
        previousRef.current = current;
        return store.current.subscribe((state)=>{
            const previous = previousRef.current;
            previousRef.current = state;
            if (!previous) return;
            const changes = {};
            let isTourLevel = false;
            for (const key of Object.keys(state))if (state[key] !== previous[key] && !$1a9bd18e23abd3f1$var$skipFields.has(key)) {
                changes[key] = {
                    from: previous[key],
                    to: state[key]
                };
                if (key === "status" || key === "size") isTourLevel = true;
            }
            if (Object.keys(changes).length) {
                if (!(!isTourLevel && state.index >= state.size)) $1a9bd18e23abd3f1$var$log(true, isTourLevel ? "tour" : `step:${state.index}`, "state", changes);
            }
        });
    }, [
        debug,
        store
    ]);
}
//#endregion
//#region src/hooks/useEventEmitter.ts
function $1a9bd18e23abd3f1$var$useEventEmitter(onEvent, controls, store) {
    const onEventRef = (0, $5E6i4.useRef)(onEvent);
    const controlsRef = (0, $5E6i4.useRef)(controls);
    onEventRef.current = onEvent;
    controlsRef.current = controls;
    return (0, $5E6i4.useCallback)((type, step, overrides)=>{
        const data = {
            ...store.current.getEventState(),
            error: null,
            scroll: null,
            step: step,
            type: type,
            ...overrides
        };
        onEventRef.current?.(data, controlsRef.current);
        store.current.dispatch(data, controlsRef.current);
    }, [
        store
    ]);
}
//#endregion
//#region src/modules/changes.ts
function $1a9bd18e23abd3f1$var$treeChanges(state, previous) {
    return {
        hasChanged (key) {
            return state[key] !== previous[key];
        },
        hasChangedTo (key, value) {
            const current = state[key];
            const previousValue = previous[key];
            if (Array.isArray(value)) return value.includes(current) && !value.includes(previousValue);
            return current === value && previousValue !== value;
        },
        previous: previous
    };
}
//#endregion
//#region src/hooks/useLifecycleEffect.ts
function $1a9bd18e23abd3f1$var$useLifecycleEffect(options) {
    const { addFailure: addFailure, controls: controls, emitEvent: emitEvent, previousState: previousState, props: props, state: state, step: step, store: store } = options;
    const { action: action, index: index, lifecycle: lifecycle, positioned: positioned, scrolling: scrolling, size: size, status: status } = state;
    const previousStep = (0, $934659347f213961$export$5cae361ad82dce8b)(step) ?? null;
    const lastAction = (0, $5E6i4.useRef)(null);
    const propsRef = (0, $5E6i4.useRef)(props);
    const stateRef = (0, $5E6i4.useRef)(state);
    const previousStateRef = (0, $5E6i4.useRef)(previousState);
    const stepRef = (0, $5E6i4.useRef)(step);
    const previousStepRef = (0, $5E6i4.useRef)(previousStep);
    const controlsRef = (0, $5E6i4.useRef)(controls);
    const pollingRef = (0, $5E6i4.useRef)(null);
    const pollingTargetRef = (0, $5E6i4.useRef)(null);
    const beforeRef = (0, $5E6i4.useRef)(null);
    propsRef.current = props;
    stateRef.current = state;
    previousStateRef.current = previousState;
    stepRef.current = step;
    previousStepRef.current = previousStep;
    controlsRef.current = controls;
    const cleanup = ()=>{
        if (pollingRef.current) {
            clearInterval(pollingRef.current);
            pollingRef.current = null;
        }
        pollingTargetRef.current = null;
        if (beforeRef.current) {
            beforeRef.current.cancel();
            beforeRef.current = null;
        }
    };
    (0, $5E6i4.useEffect)(()=>{
        if (!previousStateRef.current) return;
        const { hasChangedTo: hasChangedTo } = $1a9bd18e23abd3f1$var$treeChanges(stateRef.current, previousStateRef.current);
        const isAfterAction = hasChangedTo("action", [
            $1a9bd18e23abd3f1$export$92a1a3b7554e9387.NEXT,
            $1a9bd18e23abd3f1$export$92a1a3b7554e9387.PREV,
            $1a9bd18e23abd3f1$export$92a1a3b7554e9387.SKIP,
            $1a9bd18e23abd3f1$export$92a1a3b7554e9387.CLOSE,
            $1a9bd18e23abd3f1$export$92a1a3b7554e9387.REPLAY
        ]);
        const isStaleAfterStart = action === $1a9bd18e23abd3f1$export$92a1a3b7554e9387.START && (lastAction.current === $1a9bd18e23abd3f1$export$92a1a3b7554e9387.CLOSE || lastAction.current === $1a9bd18e23abd3f1$export$92a1a3b7554e9387.REPLAY);
        if (isAfterAction || isStaleAfterStart) lastAction.current = action;
    }, [
        action
    ]);
    (0, $5E6i4.useEffect)(()=>{
        if (!previousStateRef.current) return ()=>{
            cleanup();
        };
        const { hasChanged: hasChanged } = $1a9bd18e23abd3f1$var$treeChanges(stateRef.current, previousStateRef.current);
        const currentStep = stepRef.current;
        if (hasChanged("index")) cleanup();
        if (status !== $1a9bd18e23abd3f1$export$e50006273435e7d4.RUNNING || !currentStep || lifecycle !== $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.INIT) return ()=>{
            cleanup();
        };
        const { hasChangedTo: hasStatusChangedTo } = $1a9bd18e23abd3f1$var$treeChanges(stateRef.current, previousStateRef.current);
        if (hasStatusChangedTo("status", $1a9bd18e23abd3f1$export$e50006273435e7d4.RUNNING) && [
            $1a9bd18e23abd3f1$export$e50006273435e7d4.IDLE,
            $1a9bd18e23abd3f1$export$e50006273435e7d4.READY,
            $1a9bd18e23abd3f1$export$e50006273435e7d4.PAUSED
        ].includes(previousStateRef.current.status)) emitEvent($1a9bd18e23abd3f1$export$fa3d5b535a2458a1.TOUR_START, currentStep);
        store.current.cleanupPositionData();
        const { debug: debug } = propsRef.current;
        if (currentStep.before && !beforeRef.current) {
            $1a9bd18e23abd3f1$var$log(debug, `step:${index}`, "before()", currentStep);
            beforeRef.current = {
                cancel: ()=>{}
            };
            store.current.updateState({
                waiting: true
            });
            emitEvent($1a9bd18e23abd3f1$export$fa3d5b535a2458a1.STEP_BEFORE_HOOK, currentStep, {
                action: lastAction.current ?? stateRef.current.action
            });
            const proceed = ()=>{
                beforeRef.current = null;
                store.current.updateState({
                    action: lastAction.current ?? stateRef.current.action,
                    waiting: false,
                    lifecycle: $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.READY
                });
            };
            const abortController = new AbortController();
            const timeout = currentStep.beforeTimeout;
            beforeRef.current = {
                cancel: ()=>abortController.abort()
            };
            const timeoutId = timeout ? setTimeout(()=>{
                if (!abortController.signal.aborted) {
                    $1a9bd18e23abd3f1$var$log(debug, `step:${index}`, "before()", "timed out", `${timeout}ms`);
                    abortController.abort();
                    addFailure(currentStep, "before_hook");
                    emitEvent($1a9bd18e23abd3f1$export$fa3d5b535a2458a1.ERROR, currentStep, {
                        error: /* @__PURE__ */ new Error("Step before hook timed out")
                    });
                    proceed();
                }
            }, timeout) : null;
            currentStep.before({
                ...store.current.getState(),
                action: lastAction.current ?? store.current.getState().action,
                step: currentStep
            }).then(()=>{
                if (!abortController.signal.aborted) {
                    if (timeoutId) clearTimeout(timeoutId);
                    proceed();
                }
            }).catch((error)=>{
                if (!abortController.signal.aborted) {
                    if (timeoutId) clearTimeout(timeoutId);
                    addFailure(currentStep, "before_hook");
                    emitEvent($1a9bd18e23abd3f1$export$fa3d5b535a2458a1.ERROR, currentStep, {
                        error: error instanceof Error ? error : new Error(String(error))
                    });
                    proceed();
                }
            });
        } else if (!beforeRef.current) {
            if (pollingRef.current && pollingTargetRef.current !== currentStep.target) cleanup();
            const element = $1a9bd18e23abd3f1$var$getElement(currentStep.target);
            if (element && $1a9bd18e23abd3f1$var$isElementVisible(element)) {
                cleanup();
                store.current.updateState({
                    action: lastAction.current ?? $1a9bd18e23abd3f1$export$92a1a3b7554e9387.UPDATE,
                    lifecycle: $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.READY,
                    waiting: false
                });
            } else if (currentStep.targetWaitTimeout === 0) store.current.updateState({
                action: lastAction.current ?? $1a9bd18e23abd3f1$export$92a1a3b7554e9387.UPDATE,
                lifecycle: $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.READY,
                waiting: false
            });
            else if (!pollingRef.current) {
                const { targetWaitTimeout: targetWaitTimeout } = currentStep;
                const startTime = Date.now();
                pollingTargetRef.current = currentStep.target;
                $1a9bd18e23abd3f1$var$log(debug, `step:${index}`, "polling", "started", `${targetWaitTimeout}ms`);
                store.current.updateState({
                    waiting: true
                });
                pollingRef.current = setInterval(()=>{
                    const el = $1a9bd18e23abd3f1$var$getElement(currentStep.target);
                    const elapsed = Date.now() - startTime;
                    const timedOut = elapsed >= targetWaitTimeout;
                    if (el && $1a9bd18e23abd3f1$var$isElementVisible(el) || timedOut) {
                        $1a9bd18e23abd3f1$var$log(debug, `step:${index}`, "polling", el && $1a9bd18e23abd3f1$var$isElementVisible(el) ? "found" : "timed out", `${elapsed}ms`);
                        cleanup();
                        store.current.updateState({
                            action: lastAction.current ?? $1a9bd18e23abd3f1$export$92a1a3b7554e9387.UPDATE,
                            lifecycle: $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.READY,
                            waiting: false
                        });
                    }
                }, 100);
            }
        }
        return ()=>{
            cleanup();
        };
    }, [
        addFailure,
        emitEvent,
        index,
        lifecycle,
        status,
        store
    ]);
    (0, $5E6i4.useEffect)(()=>{
        if (!previousStateRef.current) return;
        const { hasChanged: hasChanged, hasChangedTo: hasChangedTo, previous: previous } = $1a9bd18e23abd3f1$var$treeChanges(stateRef.current, previousStateRef.current);
        const currentStep = stepRef.current;
        if (!currentStep) return;
        const element = $1a9bd18e23abd3f1$var$getElement(currentStep.target);
        const elementExists = !!element;
        if (elementExists && $1a9bd18e23abd3f1$var$isElementVisible(element)) {
            if (hasChangedTo("lifecycle", $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.READY) && previous.lifecycle === $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.INIT) emitEvent($1a9bd18e23abd3f1$export$fa3d5b535a2458a1.STEP_BEFORE, currentStep, {
                action: lastAction.current ?? stateRef.current.action
            });
            if (hasChangedTo("lifecycle", $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.READY)) {
                const currentState = stateRef.current;
                const finalLifecycle = $1a9bd18e23abd3f1$var$shouldHideBeacon(currentStep, currentState, propsRef.current.continuous) ? $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.TOOLTIP : $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.BEACON;
                const target = $1a9bd18e23abd3f1$var$getElement(currentStep.scrollTarget ?? currentStep.spotlightTarget ?? currentStep.target);
                const willScroll = $1a9bd18e23abd3f1$var$needsScrolling({
                    isFirstStep: currentState.index === 0,
                    scrollToFirstStep: propsRef.current.scrollToFirstStep,
                    step: currentStep,
                    target: target,
                    targetLifecycle: finalLifecycle
                });
                const beforeLifecycle = finalLifecycle === $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.TOOLTIP ? $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.TOOLTIP_BEFORE : $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.BEACON_BEFORE;
                $1a9bd18e23abd3f1$var$log(propsRef.current.debug, `step:${index}`, "scroll", willScroll ? "needed" : "skipped");
                store.current.updateState({
                    action: $1a9bd18e23abd3f1$export$92a1a3b7554e9387.UPDATE,
                    lifecycle: beforeLifecycle,
                    scrolling: willScroll
                });
            }
        } else if (stateRef.current.status === $1a9bd18e23abd3f1$export$e50006273435e7d4.RUNNING && lifecycle !== $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.INIT && lifecycle !== $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.COMPLETE && hasChanged("lifecycle")) {
            $1a9bd18e23abd3f1$var$log(propsRef.current.debug, `step:${index}`, elementExists ? "Target not visible" : "Target not mounted", currentStep);
            addFailure(currentStep, "target_not_found");
            emitEvent($1a9bd18e23abd3f1$export$fa3d5b535a2458a1.TARGET_NOT_FOUND, currentStep);
            const currentState = stateRef.current;
            if (!currentState.controlled) store.current.updateState({
                action: $1a9bd18e23abd3f1$export$92a1a3b7554e9387.UPDATE,
                index: currentState.index + (currentState.action === $1a9bd18e23abd3f1$export$92a1a3b7554e9387.PREV ? -1 : 1),
                lifecycle: $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.INIT
            });
        }
    }, [
        addFailure,
        emitEvent,
        index,
        lifecycle,
        store
    ]);
    (0, $5E6i4.useEffect)(()=>{
        if (!previousStateRef.current) return;
        const { hasChangedTo: hasChangedTo, previous: previous } = $1a9bd18e23abd3f1$var$treeChanges(stateRef.current, previousStateRef.current);
        const currentStep = stepRef.current;
        const previousStepValue = previousStepRef.current;
        if (currentStep && hasChangedTo("lifecycle", $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.TOOLTIP_BEFORE) && previous.lifecycle === $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.BEACON) {
            const target = $1a9bd18e23abd3f1$var$getElement(currentStep.scrollTarget ?? currentStep.spotlightTarget ?? currentStep.target);
            if ($1a9bd18e23abd3f1$var$needsScrolling({
                isFirstStep: stateRef.current.index === 0,
                scrollToFirstStep: propsRef.current.scrollToFirstStep,
                step: currentStep,
                target: target,
                targetLifecycle: $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.TOOLTIP
            })) {
                store.current.updateState({
                    scrolling: true,
                    positioned: false
                });
                return;
            }
        }
        const isBeforePhase = lifecycle === $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.BEACON_BEFORE || lifecycle === $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.TOOLTIP_BEFORE;
        if (currentStep && isBeforePhase && !scrolling) {
            const finalLifecycle = lifecycle === $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.TOOLTIP_BEFORE ? $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.TOOLTIP : $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.BEACON;
            store.current.updateState({
                action: $1a9bd18e23abd3f1$export$92a1a3b7554e9387.UPDATE,
                lifecycle: finalLifecycle
            });
        }
        if (currentStep && hasChangedTo("lifecycle", $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.BEACON)) emitEvent($1a9bd18e23abd3f1$export$fa3d5b535a2458a1.BEACON, currentStep);
        if (currentStep && hasChangedTo("lifecycle", $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.TOOLTIP)) emitEvent($1a9bd18e23abd3f1$export$fa3d5b535a2458a1.TOOLTIP, currentStep);
        const currentState = stateRef.current;
        if ((currentState.status === $1a9bd18e23abd3f1$export$e50006273435e7d4.RUNNING || currentState.controlled && currentState.status === $1a9bd18e23abd3f1$export$e50006273435e7d4.PAUSED && !!currentStep) && previousStepValue && hasChangedTo("lifecycle", $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.COMPLETE) && previous.lifecycle === $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.TOOLTIP) {
            emitEvent($1a9bd18e23abd3f1$export$fa3d5b535a2458a1.STEP_AFTER, previousStepValue, {
                action: lastAction.current ?? $1a9bd18e23abd3f1$export$92a1a3b7554e9387.UPDATE,
                index: previous.index ?? currentState.index,
                lifecycle: currentState.lifecycle
            });
            if (previousStepValue.after) {
                emitEvent($1a9bd18e23abd3f1$export$fa3d5b535a2458a1.STEP_AFTER_HOOK, previousStepValue, {
                    action: lastAction.current ?? $1a9bd18e23abd3f1$export$92a1a3b7554e9387.UPDATE,
                    index: previous.index ?? currentState.index,
                    lifecycle: currentState.lifecycle
                });
                try {
                    previousStepValue.after({
                        ...store.current.getState(),
                        action: lastAction.current ?? $1a9bd18e23abd3f1$export$92a1a3b7554e9387.UPDATE,
                        index: previous.index ?? currentState.index,
                        lifecycle: currentState.lifecycle,
                        step: previousStepValue
                    });
                } catch  {}
            }
        }
    }, [
        emitEvent,
        lifecycle,
        positioned,
        scrolling,
        store
    ]);
    (0, $5E6i4.useEffect)(()=>{
        if (!previousStateRef.current) return;
        const { hasChangedTo: hasChangedTo, previous: previous } = $1a9bd18e23abd3f1$var$treeChanges(stateRef.current, previousStateRef.current);
        const currentStep = stepRef.current;
        const previousStepValue = previousStepRef.current;
        if (hasChangedTo("action", $1a9bd18e23abd3f1$export$92a1a3b7554e9387.REPLAY) && hasChangedTo("lifecycle", $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.COMPLETE)) {
            store.current.updateState({
                lifecycle: $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.INIT
            });
            return;
        }
        if (size && !currentStep && lifecycle === $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.INIT) store.current.updateState({
            action: $1a9bd18e23abd3f1$export$92a1a3b7554e9387.UPDATE,
            lifecycle: $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.COMPLETE,
            status: $1a9bd18e23abd3f1$export$e50006273435e7d4.FINISHED
        });
        if (!stateRef.current.controlled && status === $1a9bd18e23abd3f1$export$e50006273435e7d4.RUNNING && hasChangedTo("lifecycle", $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.COMPLETE) && index < size) store.current.updateState({
            action: $1a9bd18e23abd3f1$export$92a1a3b7554e9387.UPDATE,
            lifecycle: $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.INIT
        });
        if (hasChangedTo("lifecycle", $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.COMPLETE) && index >= size) store.current.updateState({
            action: $1a9bd18e23abd3f1$export$92a1a3b7554e9387.UPDATE,
            lifecycle: $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.COMPLETE,
            status: $1a9bd18e23abd3f1$export$e50006273435e7d4.FINISHED
        });
        const tourEndStep = currentStep ?? previousStepValue ?? $1a9bd18e23abd3f1$var$getMergedStep(propsRef.current, propsRef.current.steps[index - 1]);
        if (tourEndStep && hasChangedTo("status", [
            $1a9bd18e23abd3f1$export$e50006273435e7d4.FINISHED,
            $1a9bd18e23abd3f1$export$e50006273435e7d4.SKIPPED
        ])) {
            let tourEndIndex;
            if (currentStep) tourEndIndex = index;
            else if (previousStepValue) tourEndIndex = previous.index ?? index;
            else tourEndIndex = index - 1;
            emitEvent($1a9bd18e23abd3f1$export$fa3d5b535a2458a1.TOUR_END, tourEndStep, {
                index: tourEndIndex
            });
            if (!stateRef.current.controlled) controlsRef.current.reset();
            lastAction.current = null;
        }
        if (currentStep && hasChangedTo("action", $1a9bd18e23abd3f1$export$92a1a3b7554e9387.STOP)) {
            lastAction.current = null;
            emitEvent($1a9bd18e23abd3f1$export$fa3d5b535a2458a1.TOUR_STATUS, currentStep);
        }
        if (currentStep && hasChangedTo("action", $1a9bd18e23abd3f1$export$92a1a3b7554e9387.RESET)) {
            emitEvent($1a9bd18e23abd3f1$export$fa3d5b535a2458a1.TOUR_STATUS, currentStep);
            lastAction.current = null;
        }
    }, [
        action,
        emitEvent,
        index,
        lifecycle,
        size,
        status,
        store
    ]);
}
//#endregion
//#region src/hooks/usePropSync.ts
function $1a9bd18e23abd3f1$var$usePropSync({ controls: controls, emitEvent: emitEvent, props: props, state: state, store: store }) {
    const { debug: debug, initialStepIndex: initialStepIndex, run: run, stepIndex: stepIndex, steps: steps } = props;
    const previousPropsRef = (0, $5E6i4.useRef)(void 0);
    const stateRef = (0, $5E6i4.useRef)(state);
    const controlsRef = (0, $5E6i4.useRef)(controls);
    stateRef.current = state;
    controlsRef.current = controls;
    (0, $5E6i4.useEffect)(()=>{
        const previousProps = previousPropsRef.current;
        previousPropsRef.current = props;
        if (!previousProps || props === previousProps) return;
        const { hasChanged: hasChanged } = $1a9bd18e23abd3f1$var$treeChanges(props, previousProps);
        if (!(0, $672b606f04caafab$export$2e2bcd8739ae039)(previousProps.steps, steps)) {
            if ($1a9bd18e23abd3f1$var$validateSteps(steps, debug)) store.current.setSteps(steps);
            else {
                $1a9bd18e23abd3f1$var$log(debug, "tour", "Steps are not valid", steps);
                emitEvent($1a9bd18e23abd3f1$export$fa3d5b535a2458a1.ERROR, steps[0] ?? {
                    target: "",
                    content: ""
                }, {
                    error: /* @__PURE__ */ new Error("Steps are not valid")
                });
            }
        }
        if (hasChanged("run")) {
            if (run) {
                if (store.current.getState().size) controlsRef.current.start(stepIndex ?? initialStepIndex);
            } else controlsRef.current.stop();
        } else if ((0, $209e2c4c2fa2f6ac$export$2e2bcd8739ae039).number(stepIndex) && hasChanged("stepIndex")) {
            const nextAction = (0, $209e2c4c2fa2f6ac$export$2e2bcd8739ae039).number(previousProps.stepIndex) && previousProps.stepIndex < stepIndex ? $1a9bd18e23abd3f1$export$92a1a3b7554e9387.NEXT : $1a9bd18e23abd3f1$export$92a1a3b7554e9387.PREV;
            if (![
                $1a9bd18e23abd3f1$export$e50006273435e7d4.FINISHED,
                $1a9bd18e23abd3f1$export$e50006273435e7d4.SKIPPED
            ].includes(stateRef.current.status)) store.current.updateState({
                action: nextAction,
                index: stepIndex,
                lifecycle: $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.INIT,
                positioned: false
            }, true);
        }
    }, [
        debug,
        emitEvent,
        initialStepIndex,
        props,
        run,
        stepIndex,
        steps,
        store
    ]);
}
//#endregion
//#region src/hooks/useScrollEffect.ts
function $1a9bd18e23abd3f1$var$adjustForPlacement(scrollY, options) {
    const { beaconPosition: beaconPosition, lifecycle: lifecycle, scrollOffset: scrollOffset, step: step } = options;
    if (step.scrollTarget || step.spotlightTarget) return Math.max(0, scrollY);
    let adjustedY = scrollY - step.spotlightPadding.top;
    if (lifecycle === $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.BEACON_BEFORE && beaconPosition?.placement) {
        const y = $1a9bd18e23abd3f1$var$getMainAxisOffset(beaconPosition);
        if (![
            "bottom"
        ].includes(beaconPosition.placement)) adjustedY += Math.floor(y - scrollOffset);
    } else if (lifecycle === $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.TOOLTIP_BEFORE) {
        const { placement: placement } = step;
        if (placement === "top") {
            const floaterHeight = document.querySelector(".react-joyride__floater")?.getBoundingClientRect().height ?? 0;
            const arrowSize = step.floatingOptions?.hideArrow ? 0 : step.arrowSize;
            const gap = step.offset + step.spotlightPadding.top + arrowSize;
            adjustedY -= floaterHeight + gap;
        } else if (placement === "left" || placement === "right") {
            const floaterHeight = document.querySelector(".react-joyride__floater")?.getBoundingClientRect().height ?? 0;
            const targetHeight = $1a9bd18e23abd3f1$var$getElement(step.target)?.getBoundingClientRect().height ?? 0;
            const floaterTopY = scrollOffset + step.spotlightPadding.top + targetHeight / 2 - floaterHeight / 2;
            if (floaterTopY < scrollOffset) adjustedY -= scrollOffset - floaterTopY;
        }
    }
    return Math.max(0, adjustedY);
}
function $1a9bd18e23abd3f1$var$getMainAxisOffset(data) {
    const offsetData = data.middlewareData?.offset;
    if (!offsetData) return 0;
    return [
        "left",
        "right"
    ].some((p)=>data.placement.startsWith(p)) ? offsetData.x : offsetData.y;
}
function $1a9bd18e23abd3f1$var$useScrollEffect({ emitEvent: emitEvent, previousState: previousState, props: props, state: state, step: step, store: store }) {
    const { index: index, lifecycle: lifecycle, positioned: positioned, scrolling: scrolling, status: status } = state;
    const cancelScrollRef = (0, $5E6i4.useRef)(null);
    const stateRef = (0, $5E6i4.useRef)(state);
    const previousStateRef = (0, $5E6i4.useRef)(previousState);
    const propsRef = (0, $5E6i4.useRef)(props);
    const stepRef = (0, $5E6i4.useRef)(step);
    stateRef.current = state;
    previousStateRef.current = previousState;
    propsRef.current = props;
    stepRef.current = step;
    (0, $5E6i4.useEffect)(()=>{
        return ()=>{
            cancelScrollRef.current?.();
        };
    }, []);
    (0, $5E6i4.useEffect)(()=>{
        if (!previousStateRef.current || !stepRef.current) return;
        const { hasChangedTo: hasChangedTo } = $1a9bd18e23abd3f1$var$treeChanges(stateRef.current, previousStateRef.current);
        const currentStep = stepRef.current;
        const { debug: debug } = propsRef.current;
        const { scrollDuration: scrollDuration } = currentStep;
        const isBeforePhase = lifecycle === $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.BEACON_BEFORE || lifecycle === $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.TOOLTIP_BEFORE;
        if (status === $1a9bd18e23abd3f1$export$e50006273435e7d4.RUNNING && isBeforePhase && scrolling && hasChangedTo("positioned", true)) {
            const target = $1a9bd18e23abd3f1$var$getElement(currentStep.scrollTarget ?? currentStep.spotlightTarget ?? currentStep.target);
            const beaconPosition = store.current.getPositionData("beacon");
            const scrollParent = $1a9bd18e23abd3f1$var$getScrollParent(target);
            const hasCustomScroll = scrollParent ? !scrollParent.isSameNode($1a9bd18e23abd3f1$var$scrollDocument()) : false;
            cancelScrollRef.current?.();
            const handleScroll = async ()=>{
                if (hasCustomScroll && !$1a9bd18e23abd3f1$var$hasPosition(scrollParent)) {
                    const pageElement = $1a9bd18e23abd3f1$var$scrollDocument();
                    const pageScrollY = $1a9bd18e23abd3f1$var$getScrollTargetToCenter(scrollParent);
                    const pageScrollData = {
                        initial: pageElement.scrollTop,
                        target: pageScrollY,
                        element: pageElement,
                        duration: scrollDuration
                    };
                    emitEvent($1a9bd18e23abd3f1$export$fa3d5b535a2458a1.SCROLL_START, currentStep, {
                        scroll: pageScrollData
                    });
                    const { cancel: cancelPage, promise: pagePromise } = $1a9bd18e23abd3f1$var$scrollTo(pageScrollY, {
                        element: pageElement,
                        duration: scrollDuration
                    });
                    cancelScrollRef.current = cancelPage;
                    await pagePromise;
                    emitEvent($1a9bd18e23abd3f1$export$fa3d5b535a2458a1.SCROLL_END, currentStep, {
                        scroll: pageScrollData
                    });
                }
                const baseScrollY = Math.floor($1a9bd18e23abd3f1$var$getScrollTo(target, currentStep.scrollOffset)) || 0;
                const scrollY = hasCustomScroll ? baseScrollY : $1a9bd18e23abd3f1$var$adjustForPlacement(baseScrollY, {
                    beaconPosition: beaconPosition,
                    lifecycle: lifecycle,
                    scrollOffset: currentStep.scrollOffset,
                    step: currentStep
                });
                $1a9bd18e23abd3f1$var$log(debug, `step:${index}`, "scroll", hasCustomScroll ? "custom" : "document", `${baseScrollY} \u{2192} ${scrollY}`);
                const scrollElement = scrollParent;
                const scrollData = {
                    initial: scrollElement.scrollTop,
                    target: scrollY,
                    element: scrollElement,
                    duration: scrollDuration
                };
                emitEvent($1a9bd18e23abd3f1$export$fa3d5b535a2458a1.SCROLL_START, currentStep, {
                    scroll: scrollData
                });
                const { cancel: cancel, promise: promise } = $1a9bd18e23abd3f1$var$scrollTo(scrollY, {
                    element: scrollElement,
                    duration: scrollDuration
                });
                cancelScrollRef.current = cancel;
                await promise;
                emitEvent($1a9bd18e23abd3f1$export$fa3d5b535a2458a1.SCROLL_END, currentStep, {
                    scroll: scrollData
                });
                store.current.updateState({
                    scrolling: false
                });
            };
            handleScroll().catch(()=>{
                store.current.updateState({
                    scrolling: false
                });
            });
        }
    }, [
        emitEvent,
        index,
        lifecycle,
        positioned,
        scrolling,
        status,
        store
    ]);
}
//#endregion
//#region src/hooks/useTourEngine.ts
function $1a9bd18e23abd3f1$var$useTourEngine(props) {
    const mergedProps = (0, $934659347f213961$export$75842ffadd0a4898)(()=>$1a9bd18e23abd3f1$var$mergeProps($1a9bd18e23abd3f1$var$defaultProps, props), [
        props
    ]);
    const { debug: debug, initialStepIndex: initialStepIndex, onEvent: onEvent, run: run, stepIndex: stepIndex, steps: steps } = mergedProps;
    const store = (0, $5E6i4.useRef)($1a9bd18e23abd3f1$var$createStore(mergedProps));
    const state = (0, $ee5b9e121318164d$exports.useSyncExternalStore)(store.current.subscribe, store.current.getSnapshot, store.current.getServerSnapshot);
    const [failures, setFailures] = (0, $5E6i4.useState)([]);
    const addFailure = (0, $5E6i4.useCallback)((failedStep, reason)=>{
        setFailures((previous)=>[
                ...previous,
                {
                    reason: reason,
                    step: failedStep
                }
            ]);
    }, []);
    const clearFailures = (0, $5E6i4.useCallback)(()=>{
        setFailures([]);
    }, []);
    $1a9bd18e23abd3f1$var$useDebugLogger(store, debug);
    const controls = $1a9bd18e23abd3f1$var$useControls(store, debug, clearFailures);
    const emitEvent = $1a9bd18e23abd3f1$var$useEventEmitter(onEvent, controls, store);
    const { index: index, size: size, status: status } = state;
    const previousState = (0, $934659347f213961$export$5cae361ad82dce8b)(state);
    const step = (0, $5E6i4.useMemo)(()=>$1a9bd18e23abd3f1$var$getMergedStep(mergedProps, steps[index]), [
        index,
        mergedProps,
        steps
    ]);
    (0, $934659347f213961$export$17f7c8f694d207ce)(()=>{
        if (run && size && $1a9bd18e23abd3f1$var$validateSteps(steps, debug)) controls.start(stepIndex ?? initialStepIndex);
    });
    (0, $934659347f213961$export$496315a1608d9602)(()=>{
        if (run && size && status === $1a9bd18e23abd3f1$export$e50006273435e7d4.IDLE) store.current.updateState({
            status: $1a9bd18e23abd3f1$export$e50006273435e7d4.READY
        });
    }, [
        run,
        size,
        status
    ]);
    $1a9bd18e23abd3f1$var$usePropSync({
        controls: controls,
        emitEvent: emitEvent,
        props: mergedProps,
        state: state,
        store: store
    });
    $1a9bd18e23abd3f1$var$useLifecycleEffect({
        addFailure: addFailure,
        controls: controls,
        emitEvent: emitEvent,
        previousState: previousState,
        props: mergedProps,
        state: state,
        step: step,
        store: store
    });
    $1a9bd18e23abd3f1$var$useScrollEffect({
        emitEvent: emitEvent,
        previousState: previousState,
        props: mergedProps,
        state: state,
        step: step,
        store: store
    });
    return {
        controls: controls,
        failures: failures,
        mergedProps: mergedProps,
        state: state,
        step: step,
        store: store
    };
}
//#endregion
//#region src/hooks/usePortalElement.ts
function $1a9bd18e23abd3f1$var$usePortalElement(portalElement) {
    const [element, setElement] = (0, $5E6i4.useState)(null);
    (0, $5E6i4.useEffect)(()=>{
        let createdElement = null;
        let isExternal = false;
        if (portalElement) {
            if ((0, $209e2c4c2fa2f6ac$export$2e2bcd8739ae039).domElement(portalElement)) {
                createdElement = portalElement;
                isExternal = true;
            } else {
                const portal = document.querySelector(portalElement);
                if (portal) createdElement = portal;
            }
        } else {
            const portal = document.createElement("div");
            portal.id = $1a9bd18e23abd3f1$export$a42db32261056924;
            document.body.appendChild(portal);
            createdElement = portal;
        }
        setElement(createdElement);
        return ()=>{
            if (!createdElement || isExternal) return;
            if (createdElement.parentNode === document.body) document.body.removeChild(createdElement);
        };
    }, [
        portalElement
    ]);
    return element;
}
//#endregion
//#region src/components/Loader.tsx
const $1a9bd18e23abd3f1$var$spinnerStyles = {
    animation: "joyride-loader-spin 1s linear infinite",
    border: "5px solid rgba(0, 0, 0, 0.1)",
    borderRadius: "50%",
    borderTopColor: "#555"
};
function $1a9bd18e23abd3f1$var$JoyrideLoader({ nonce: nonce, step: step }) {
    const { loaderComponent: loaderComponent } = step;
    const hasLoaderComponent = Boolean(loaderComponent);
    (0, $5E6i4.useEffect)(()=>{
        if (hasLoaderComponent) return $1a9bd18e23abd3f1$var$noop;
        if (document.getElementById("joyride-loader-animation")) return $1a9bd18e23abd3f1$var$noop;
        const style = document.createElement("style");
        style.id = "joyride-loader-animation";
        if (nonce) style.setAttribute("nonce", nonce);
        style.appendChild(document.createTextNode(`
        @keyframes joyride-loader-spin {
          to { transform: rotate(360deg); }
        }
      `));
        document.head.appendChild(style);
        return ()=>{
            const insertedStyle = document.getElementById("joyride-loader-animation");
            if (insertedStyle?.parentNode) insertedStyle.parentNode.removeChild(insertedStyle);
        };
    }, [
        hasLoaderComponent,
        nonce
    ]);
    if (loaderComponent === null) return null;
    const { height: height, width: width, ...loaderStyle } = step.styles.loader;
    let content;
    if (loaderComponent) {
        const CustomLoader = loaderComponent;
        content = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement(CustomLoader, {
            step: step
        });
    } else content = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("div", {
        style: {
            ...$1a9bd18e23abd3f1$var$spinnerStyles,
            height: height,
            width: width,
            borderTopColor: step.primaryColor
        }
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("div", {
        className: "react-joyride__loader",
        "data-testid": "loader",
        style: loaderStyle
    }, content);
}
//#endregion
//#region src/hooks/useTargetPosition.ts
const $1a9bd18e23abd3f1$var$defaultRect = {
    height: 0,
    isFixed: false,
    left: 0,
    top: 0,
    width: 0
};
function $1a9bd18e23abd3f1$var$computeRect(target, spotlightPadding) {
    const element = $1a9bd18e23abd3f1$var$getElement(target);
    if (!element) return $1a9bd18e23abd3f1$var$defaultRect;
    const elementRect = $1a9bd18e23abd3f1$var$getClientRect(element);
    const isFixed = $1a9bd18e23abd3f1$var$hasPosition(element);
    const top = $1a9bd18e23abd3f1$var$getElementPosition(element, spotlightPadding.top, isFixed);
    return {
        height: Math.round((elementRect?.height ?? 0) + spotlightPadding.top + spotlightPadding.bottom),
        isFixed: isFixed,
        left: Math.round((elementRect?.left ?? 0) - spotlightPadding.left),
        top: top,
        width: Math.round((elementRect?.width ?? 0) + spotlightPadding.left + spotlightPadding.right)
    };
}
function $1a9bd18e23abd3f1$var$useTargetPosition(target, spotlightPadding, force) {
    const [rect, setRect] = (0, $5E6i4.useState)(()=>$1a9bd18e23abd3f1$var$computeRect(target, spotlightPadding));
    const timeoutRef = (0, $5E6i4.useRef)(void 0);
    const scrollParentRef = (0, $5E6i4.useRef)(null);
    const previousForceRef = (0, $5E6i4.useRef)(force);
    const observerRef = (0, $5E6i4.useRef)(null);
    const updateRect = (0, $5E6i4.useCallback)(()=>{
        clearTimeout(timeoutRef.current);
        timeoutRef.current = window.setTimeout(()=>{
            setRect((previous)=>{
                const next = $1a9bd18e23abd3f1$var$computeRect(target, spotlightPadding);
                if (previous.top === next.top && previous.left === next.left && previous.width === next.width && previous.height === next.height && previous.isFixed === next.isFixed) return previous;
                return next;
            });
        }, 100);
    }, [
        target,
        spotlightPadding
    ]);
    (0, $5E6i4.useEffect)(()=>{
        let mutationObserver = null;
        const setup = (element)=>{
            scrollParentRef.current = $1a9bd18e23abd3f1$var$getScrollParent(element, true);
            if (scrollParentRef.current) scrollParentRef.current.addEventListener("scroll", updateRect, {
                passive: true
            });
            window.addEventListener("scroll", updateRect, {
                passive: true
            });
            window.addEventListener("resize", updateRect);
            if (typeof ResizeObserver !== "undefined") {
                observerRef.current = new ResizeObserver(updateRect);
                observerRef.current.observe(element);
            }
            setRect($1a9bd18e23abd3f1$var$computeRect(target, spotlightPadding));
        };
        const element = $1a9bd18e23abd3f1$var$getElement(target);
        if (element) setup(element);
        else {
            mutationObserver = new MutationObserver(()=>{
                const el = $1a9bd18e23abd3f1$var$getElement(target);
                if (el) {
                    mutationObserver?.disconnect();
                    mutationObserver = null;
                    setup(el);
                }
            });
            mutationObserver.observe(document.body, {
                childList: true,
                subtree: true
            });
        }
        return ()=>{
            mutationObserver?.disconnect();
            if (scrollParentRef.current) scrollParentRef.current.removeEventListener("scroll", updateRect);
            window.removeEventListener("scroll", updateRect);
            window.removeEventListener("resize", updateRect);
            observerRef.current?.disconnect();
            clearTimeout(timeoutRef.current);
        };
    }, [
        target,
        spotlightPadding,
        updateRect
    ]);
    (0, $5E6i4.useEffect)(()=>{
        if (previousForceRef.current && !force) setRect($1a9bd18e23abd3f1$var$computeRect(target, spotlightPadding));
        previousForceRef.current = force;
    }, [
        force,
        target,
        spotlightPadding
    ]);
    let finalRect = rect;
    if (previousForceRef.current && !force) finalRect = $1a9bd18e23abd3f1$var$computeRect(target, spotlightPadding);
    return finalRect;
}
//#endregion
//#region src/modules/svg.ts
function $1a9bd18e23abd3f1$var$generateOverlayPath(overlayWidth, overlayHeight, cutout) {
    let path = `M0 0H${overlayWidth}V${overlayHeight}H0Z`;
    if (cutout) path += ` ${cutout}`;
    return path;
}
function $1a9bd18e23abd3f1$var$generateSpotlightPath(x, y, width, height, borderRadius) {
    if (width <= 0 || height <= 0) return "";
    const r = Math.max(0, Math.min(borderRadius, width / 2, height / 2));
    let path = `M${x + r} ${y}`;
    path += `H${x + width - r}`;
    path += `A${r} ${r} 0 0 1 ${x + width} ${y + r}`;
    path += `V${y + height - r}`;
    path += `A${r} ${r} 0 0 1 ${x + width - r} ${y + height}`;
    path += `H${x + r}`;
    path += `A${r} ${r} 0 0 1 ${x} ${y + height - r}`;
    path += `V${y + r}`;
    path += `A${r} ${r} 0 0 1 ${x + r} ${y}Z`;
    return path;
}
//#endregion
//#region src/components/Overlay.tsx
const $1a9bd18e23abd3f1$var$hiddenLifecycles = [
    $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.BEACON_BEFORE,
    $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.BEACON
];
function $1a9bd18e23abd3f1$var$JoyrideOverlay(props) {
    const { blockTargetInteraction: blockTargetInteraction, continuous: continuous, hideOverlay: hideOverlay, lifecycle: lifecycle, onClickOverlay: onClickOverlay, overlayClickAction: overlayClickAction, placement: placement, portalElement: portalElement, scrolling: scrolling, spotlightPadding: spotlightPadding, spotlightRadius: spotlightRadius, spotlightTarget: spotlightTarget, styles: styles, target: target, waiting: waiting } = props;
    const windowSize = (0, $934659347f213961$export$42c02f33970a2afa)();
    const targetRect = $1a9bd18e23abd3f1$var$useTargetPosition(spotlightTarget ?? target, spotlightPadding, scrolling || waiting);
    const overlayRef = (0, $5E6i4.useRef)(null);
    const svgRef = (0, $5E6i4.useRef)(null);
    const showSpotlight = (lifecycle === $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.TOOLTIP || lifecycle === $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.TOOLTIP_BEFORE) && placement !== "center";
    const [spotlightReady, setSpotlightReady] = (0, $5E6i4.useState)(false);
    const container = portalElement ? overlayRef.current?.offsetParent : null;
    const overlayWidth = container?.clientWidth ?? windowSize.width;
    const overlayHeight = container?.clientHeight ?? $1a9bd18e23abd3f1$var$getDocumentHeight() ?? windowSize.height;
    const overlayColor = styles.overlay?.backgroundColor ?? "rgba(0, 0, 0, 0.5)";
    const overlayStyles = (0, $5E6i4.useMemo)(()=>{
        const { backgroundColor: _bg, mixBlendMode: _mbm, ...rest } = styles.overlay;
        return {
            height: overlayHeight,
            pointerEvents: "none",
            ...rest
        };
    }, [
        overlayHeight,
        styles.overlay
    ]);
    const showCutout = showSpotlight && !scrolling && !waiting;
    (0, $5E6i4.useEffect)(()=>{
        if (showCutout) requestAnimationFrame(()=>setSpotlightReady(true));
        else setSpotlightReady(false);
    }, [
        showCutout
    ]);
    const isHiddenInContinuous = continuous && $1a9bd18e23abd3f1$var$hiddenLifecycles.includes(lifecycle);
    const isHiddenInNonContinuous = !continuous && lifecycle !== $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.TOOLTIP;
    if (hideOverlay || !waiting && (isHiddenInContinuous || isHiddenInNonContinuous)) return null;
    let coverPath = "";
    if (showCutout) {
        let originTop = 0;
        let originLeft = 0;
        const svg = svgRef.current;
        if (portalElement && svg && !targetRect.isFixed) {
            const rect = svg.getBoundingClientRect();
            originTop = rect.top + $1a9bd18e23abd3f1$var$scrollDocument().scrollTop;
            originLeft = rect.left;
        }
        coverPath = $1a9bd18e23abd3f1$var$generateSpotlightPath(targetRect.left - originLeft, targetRect.top - originTop, targetRect.width, targetRect.height, spotlightRadius);
    }
    const path = $1a9bd18e23abd3f1$var$generateOverlayPath(overlayWidth, overlayHeight, coverPath);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("div", {
        ref: overlayRef,
        "aria-hidden": "true",
        className: "react-joyride__overlay",
        "data-testid": "overlay",
        style: overlayStyles
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("svg", {
        ref: svgRef,
        className: "react-joyride__spotlight",
        "data-testid": "spotlight",
        style: {
            height: overlayHeight,
            left: 0,
            position: targetRect.isFixed ? "fixed" : "absolute",
            top: 0,
            width: overlayWidth
        }
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("path", {
        d: path,
        fill: overlayColor,
        fillRule: "evenodd",
        onClick: onClickOverlay,
        style: {
            cursor: overlayClickAction ? "pointer" : "default",
            pointerEvents: "auto"
        }
    }), coverPath && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("path", {
        d: coverPath,
        fill: overlayColor,
        style: {
            opacity: spotlightReady ? 0 : 1,
            pointerEvents: blockTargetInteraction ? "auto" : "none",
            transition: "opacity 0.2s"
        }
    }), coverPath && Object.keys(styles.spotlight).length > 0 && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("path", {
        d: coverPath,
        fill: "none",
        style: {
            pointerEvents: "none"
        },
        ...styles.spotlight
    })));
}
//#endregion
//#region src/components/Portal.tsx
function $1a9bd18e23abd3f1$var$JoyridePortal(props) {
    const { children: children, element: element } = props;
    if (!element) return null;
    return (0, $ibUU1.createPortal)(children, element);
}
//#endregion
//#region src/hooks/useFocusTrap.ts
const $1a9bd18e23abd3f1$var$TABBABLE_SELECTOR = "a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), area[href], [tabindex]:not([tabindex=\"-1\"]), [contenteditable]";
function $1a9bd18e23abd3f1$var$useFocusTrap(element, selector) {
    const previousFocus = (0, $5E6i4.useRef)(null);
    (0, $5E6i4.useEffect)(()=>{
        if (!element) return $1a9bd18e23abd3f1$var$noop;
        previousFocus.current = document.activeElement;
        const handleKeyDown = (event)=>{
            if (event.key !== "Tab") return;
            const elements = [
                ...element.querySelectorAll($1a9bd18e23abd3f1$var$TABBABLE_SELECTOR)
            ];
            const { shiftKey: shiftKey } = event;
            if (!elements.length) return;
            event.preventDefault();
            let index = document.activeElement ? elements.indexOf(document.activeElement) : 0;
            if (index === -1 || !shiftKey && index + 1 === elements.length) index = 0;
            else if (shiftKey && index === 0) index = elements.length - 1;
            else index += shiftKey ? -1 : 1;
            elements[index].focus();
        };
        element.addEventListener("keydown", handleKeyDown, false);
        let timerId;
        if (selector) {
            const target = element.querySelector(selector);
            if (target) timerId = setTimeout(()=>{
                target.focus({
                    preventScroll: true
                });
            }, 100);
        }
        return ()=>{
            element.removeEventListener("keydown", handleKeyDown);
            if (timerId !== void 0) clearTimeout(timerId);
            previousFocus.current?.focus({
                preventScroll: true
            });
        };
    }, [
        element,
        selector
    ]);
}
//#endregion
//#region src/components/Arrow.tsx
function $1a9bd18e23abd3f1$var$getDimensions(placement, base, size) {
    const [side] = placement.split("-");
    switch(side){
        case "top":
        case "bottom":
            return {
                width: base,
                height: size
            };
        case "left":
        case "right":
            return {
                width: size,
                height: base
            };
        default:
            return null;
    }
}
function $1a9bd18e23abd3f1$var$getPoints(placement, base, size) {
    const [side] = placement.split("-");
    switch(side){
        case "top":
            return {
                points: `0,0 ${base / 2},${size} ${base},0`,
                ...$1a9bd18e23abd3f1$var$getDimensions(placement, base, size)
            };
        case "bottom":
            return {
                points: `${base},${size} ${base / 2},0 0,${size}`,
                ...$1a9bd18e23abd3f1$var$getDimensions(placement, base, size)
            };
        case "left":
            return {
                points: `0,0 ${size},${base / 2} 0,${base}`,
                ...$1a9bd18e23abd3f1$var$getDimensions(placement, base, size)
            };
        case "right":
            return {
                points: `${size},${base} ${size},0 0,${base / 2}`,
                ...$1a9bd18e23abd3f1$var$getDimensions(placement, base, size)
            };
        default:
            return null;
    }
}
function $1a9bd18e23abd3f1$var$getPositionStyle(placement, position, size, base) {
    if (!position) return {};
    const [side] = placement.split("-");
    switch(side){
        case "top":
            return {
                bottom: -size,
                left: position.x ?? 0,
                ...$1a9bd18e23abd3f1$var$getDimensions(placement, base, size)
            };
        case "bottom":
            return {
                top: -size,
                left: position.x ?? 0,
                ...$1a9bd18e23abd3f1$var$getDimensions(placement, base, size)
            };
        case "left":
            return {
                right: -size,
                top: position.y ?? 0,
                ...$1a9bd18e23abd3f1$var$getDimensions(placement, base, size)
            };
        case "right":
            return {
                left: -size,
                top: position.y ?? 0,
                ...$1a9bd18e23abd3f1$var$getDimensions(placement, base, size)
            };
        default:
            return {};
    }
}
function $1a9bd18e23abd3f1$var$Arrow({ arrowComponent: arrowComponent, arrowRef: arrowRef, base: base, placement: placement, position: position, size: size, styles: styles }) {
    const ArrowComponent = arrowComponent;
    let content = null;
    if (ArrowComponent) {
        if (!$1a9bd18e23abd3f1$var$getDimensions(placement, base, size)) return null;
        content = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("span", {
            style: {
                flexShrink: 0
            }
        }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement(ArrowComponent, {
            base: base,
            placement: placement,
            size: size
        }));
    } else {
        const svg = $1a9bd18e23abd3f1$var$getPoints(placement, base, size);
        if (!svg) return null;
        content = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("svg", {
            height: svg.height,
            width: svg.width,
            xmlns: "http://www.w3.org/2000/svg"
        }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("polygon", {
            fill: "currentColor",
            points: svg.points
        }));
    }
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("span", {
        ref: arrowRef,
        className: "react-joyride__arrow",
        "data-testid": "arrow",
        style: {
            ...styles,
            ...$1a9bd18e23abd3f1$var$getPositionStyle(placement, position, size, base),
            ...position ? {} : {
                visibility: "hidden"
            }
        }
    }, content);
}
//#endregion
//#region src/components/Beacon.tsx
function $1a9bd18e23abd3f1$var$JoyrideBeacon(props) {
    const { beaconComponent: beaconComponent, continuous: continuous, index: index, isLastStep: isLastStep, locale: locale, nonce: nonce, onInteract: onInteract, shouldFocus: shouldFocus, size: size, step: step, styles: styles } = props;
    const beaconRef = (0, $5E6i4.useRef)(null);
    const hasBeaconComponent = Boolean(beaconComponent);
    (0, $5E6i4.useEffect)(()=>{
        if (hasBeaconComponent) return $1a9bd18e23abd3f1$var$noop;
        if (document.getElementById("joyride-beacon-animation")) return $1a9bd18e23abd3f1$var$noop;
        const style = document.createElement("style");
        style.id = "joyride-beacon-animation";
        if (nonce) style.setAttribute("nonce", nonce);
        style.appendChild(document.createTextNode(`
        @keyframes joyride-beacon-inner {
          20% {
            opacity: 0.9;
          }

          90% {
            opacity: 0.7;
          }
        }

        @keyframes joyride-beacon-outer {
          0% {
            transform: scale(1);
          }

          45% {
            opacity: 0.7;
            transform: scale(0.75);
          }

          100% {
            opacity: 0.9;
            transform: scale(1);
          }
        }
      `));
        document.head.appendChild(style);
        const focusTimer = setTimeout(()=>{
            if ((0, $209e2c4c2fa2f6ac$export$2e2bcd8739ae039).domElement(beaconRef.current) && shouldFocus) beaconRef.current.focus();
        }, 0);
        return ()=>{
            clearTimeout(focusTimer);
            const insertedStyle = document.getElementById("joyride-beacon-animation");
            if (insertedStyle?.parentNode) insertedStyle.parentNode.removeChild(insertedStyle);
        };
    }, [
        hasBeaconComponent,
        nonce,
        shouldFocus
    ]);
    const title = $1a9bd18e23abd3f1$var$getReactNodeText(locale.open);
    let content;
    if (beaconComponent) {
        const BeaconComponent = beaconComponent;
        content = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement(BeaconComponent, {
            continuous: continuous,
            index: index,
            isLastStep: isLastStep,
            size: size,
            step: step
        });
    } else content = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("span", {
        style: styles.beacon
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("span", {
        style: styles.beaconOuter
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("span", {
        style: styles.beaconInner
    }));
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("button", {
        ref: beaconRef,
        "aria-label": title,
        className: "react-joyride__beacon",
        "data-testid": "button-beacon",
        onClick: onInteract,
        onMouseEnter: onInteract,
        style: styles.beaconWrapper,
        title: title,
        type: "button"
    }, content);
}
//#endregion
//#region src/components/Tooltip/CloseButton.tsx
function $1a9bd18e23abd3f1$var$JoyrideTooltipCloseButton({ styles: styles, ...props }) {
    const { color: color, height: height, width: width, ...style } = styles;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("button", {
        style: style,
        type: "button",
        ...props
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("svg", {
        height: typeof height === "number" ? `${height}px` : height,
        preserveAspectRatio: "xMidYMid",
        version: "1.1",
        viewBox: "0 0 18 18",
        width: typeof width === "number" ? `${width}px` : width,
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("g", null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("path", {
        d: "M8.13911129,9.00268191 L0.171521827,17.0258467 C-0.0498027049,17.248715 -0.0498027049,17.6098394 0.171521827,17.8327545 C0.28204354,17.9443526 0.427188206,17.9998706 0.572051765,17.9998706 C0.71714958,17.9998706 0.862013139,17.9443526 0.972581703,17.8327545 L9.0000937,9.74924618 L17.0276057,17.8327545 C17.1384085,17.9443526 17.2832721,17.9998706 17.4281356,17.9998706 C17.5729992,17.9998706 17.718097,17.9443526 17.8286656,17.8327545 C18.0499901,17.6098862 18.0499901,17.2487618 17.8286656,17.0258467 L9.86135722,9.00268191 L17.8340066,0.973848225 C18.0553311,0.750979934 18.0553311,0.389855532 17.8340066,0.16694039 C17.6126821,-0.0556467968 17.254037,-0.0556467968 17.0329467,0.16694039 L9.00042166,8.25611765 L0.967006424,0.167268345 C0.745681892,-0.0553188426 0.387317931,-0.0553188426 0.165993399,0.167268345 C-0.0553311331,0.390136635 -0.0553311331,0.751261038 0.165993399,0.974176179 L8.13920499,9.00268191 L8.13911129,9.00268191 Z",
        fill: color
    }))));
}
//#endregion
//#region src/components/Tooltip/DefaultTooltip.tsx
function $1a9bd18e23abd3f1$var$JoyrideDefaultTooltip(props) {
    const { backProps: backProps, closeProps: closeProps, index: index, isLastStep: isLastStep, primaryProps: primaryProps, skipProps: skipProps, step: step, tooltipProps: tooltipProps } = props;
    const { buttons: buttons, content: content, styles: styles, title: title } = step;
    const buttonElements = {};
    if (buttons.includes("primary")) buttonElements.primary = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("button", {
        "data-testid": "button-primary",
        style: styles.buttonPrimary,
        type: "button",
        ...primaryProps
    });
    if (buttons.includes("skip") && !isLastStep) buttonElements.skip = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("button", {
        "aria-live": "off",
        "data-testid": "button-skip",
        style: styles.buttonSkip,
        type: "button",
        ...skipProps
    });
    if (buttons.includes("back") && index > 0) buttonElements.back = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("button", {
        "data-testid": "button-back",
        style: styles.buttonBack,
        type: "button",
        ...backProps
    });
    buttonElements.close = buttons.includes("close") && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement($1a9bd18e23abd3f1$var$JoyrideTooltipCloseButton, {
        "data-testid": "button-close",
        styles: styles.buttonClose,
        ...closeProps
    });
    const ariaProps = title ? {
        "aria-labelledby": "joyride-tooltip-title",
        "aria-describedby": "joyride-tooltip-content"
    } : {
        "aria-label": $1a9bd18e23abd3f1$var$getReactNodeText(content),
        "aria-describedby": "joyride-tooltip-content"
    };
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("div", {
        key: "JoyrideTooltip",
        className: "react-joyride__tooltip",
        "data-joyride-step": index,
        ...step.id && {
            "data-joyride-id": step.id
        },
        style: styles.tooltip,
        ...tooltipProps,
        ...ariaProps
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("div", {
        style: styles.tooltipContainer
    }, title && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("h4", {
        id: "joyride-tooltip-title",
        style: styles.tooltipTitle
    }, title), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("div", {
        id: "joyride-tooltip-content",
        style: styles.tooltipContent
    }, content)), buttons.some((b)=>b === "back" || b === "primary" || b === "skip") && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("div", {
        style: styles.tooltipFooter
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("div", {
        style: styles.tooltipFooterSpacer
    }, buttonElements.skip), buttonElements.back, buttonElements.primary), buttonElements.close);
}
//#endregion
//#region src/components/Tooltip/index.tsx
function $1a9bd18e23abd3f1$var$Tooltip(props) {
    const { continuous: continuous, controls: controls, index: index, isLastStep: isLastStep, size: size, step: step } = props;
    const handleClickBack = (event)=>{
        event.preventDefault();
        controls.prev($1a9bd18e23abd3f1$export$ccee77ec32a436d7.BUTTON_BACK);
    };
    const handleClickClose = (event)=>{
        event.preventDefault();
        if (step.closeButtonAction === "skip") controls.skip($1a9bd18e23abd3f1$export$ccee77ec32a436d7.BUTTON_CLOSE);
        else if (step.closeButtonAction === "replay") controls.replay($1a9bd18e23abd3f1$export$ccee77ec32a436d7.BUTTON_CLOSE);
        else controls.close($1a9bd18e23abd3f1$export$ccee77ec32a436d7.BUTTON_CLOSE);
    };
    const handleClickPrimary = (event)=>{
        event.preventDefault();
        if (!continuous) {
            controls.close($1a9bd18e23abd3f1$export$ccee77ec32a436d7.BUTTON_PRIMARY);
            return;
        }
        controls.next($1a9bd18e23abd3f1$export$ccee77ec32a436d7.BUTTON_PRIMARY);
    };
    const handleClickSkip = (event)=>{
        event.preventDefault();
        controls.skip($1a9bd18e23abd3f1$export$ccee77ec32a436d7.BUTTON_SKIP);
    };
    const getElementsProps = ()=>{
        const { back: back, close: close, last: last, next: next, nextWithProgress: nextWithProgress, skip: skip } = step.locale;
        const backText = $1a9bd18e23abd3f1$var$getReactNodeText(back);
        const closeText = $1a9bd18e23abd3f1$var$getReactNodeText(close);
        const lastText = $1a9bd18e23abd3f1$var$getReactNodeText(last);
        const nextText = $1a9bd18e23abd3f1$var$getReactNodeText(next);
        const skipText = $1a9bd18e23abd3f1$var$getReactNodeText(skip);
        let primary = close;
        let primaryText = closeText;
        if (continuous) {
            primary = next;
            primaryText = nextText;
            if (step.showProgress && !isLastStep) {
                const labelWithProgress = $1a9bd18e23abd3f1$var$getReactNodeText(nextWithProgress, {
                    step: index + 1,
                    steps: size
                });
                primary = $1a9bd18e23abd3f1$var$replaceLocaleContent(nextWithProgress, index + 1, size);
                primaryText = labelWithProgress;
            }
            if (isLastStep) {
                primary = last;
                primaryText = lastText;
            }
        }
        return {
            backProps: {
                "aria-label": backText,
                children: back,
                "data-action": "back",
                onClick: handleClickBack,
                role: "button",
                title: backText
            },
            closeProps: {
                "aria-label": closeText,
                children: close,
                "data-action": "close",
                onClick: handleClickClose,
                role: "button",
                title: closeText
            },
            primaryProps: {
                "aria-label": primaryText,
                children: primary,
                "data-action": "primary",
                onClick: handleClickPrimary,
                role: "button",
                title: primaryText
            },
            skipProps: {
                "aria-label": skipText,
                children: skip,
                "data-action": "skip",
                onClick: handleClickSkip,
                role: "button",
                title: skipText
            },
            tooltipProps: {
                "aria-modal": true,
                role: "alertdialog"
            }
        };
    };
    const { arrowComponent: arrowComponent, beaconComponent: beaconComponent, tooltipComponent: tooltipComponent, ...stepProps } = step;
    let component;
    if (tooltipComponent) {
        const TooltipComponent = tooltipComponent;
        component = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement(TooltipComponent, {
            ...getElementsProps(),
            continuous: continuous,
            controls: controls,
            index: index,
            isLastStep: isLastStep,
            size: size,
            step: stepProps
        });
    } else component = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement($1a9bd18e23abd3f1$var$JoyrideDefaultTooltip, {
        ...getElementsProps(),
        continuous: continuous,
        controls: controls,
        index: index,
        isLastStep: isLastStep,
        size: size,
        step: stepProps
    });
    return component;
}
//#endregion
//#region src/components/Floater.tsx
function $1a9bd18e23abd3f1$var$getFallbackPlacements(placement) {
    if (placement.startsWith("left")) return [
        "top",
        "bottom"
    ];
    if (placement.startsWith("right")) return [
        "bottom",
        "top"
    ];
}
function $1a9bd18e23abd3f1$var$getFlipMiddleware(isAuto, step, tooltipPlacement) {
    if (isAuto) return [
        (0, $579fdd7a121bbebe$export$91fb6ecbd551914)()
    ];
    if (step.floatingOptions?.flipOptions === false) return [];
    return [
        (0, $579fdd7a121bbebe$export$8a83211c878a3f1f)({
            crossAxis: false,
            fallbackPlacements: $1a9bd18e23abd3f1$var$getFallbackPlacements(tooltipPlacement),
            padding: 20,
            ...step.floatingOptions?.flipOptions
        })
    ];
}
function $1a9bd18e23abd3f1$var$JoyrideFloater(props) {
    const { continuous: continuous, controls: controls, index: index, lifecycle: lifecycle, nonce: nonce, open: open, portalElement: portalElement, setPositionData: setPositionData, setTooltipRef: setTooltipRef, shouldScroll: shouldScroll, size: size, step: step, target: target, updateState: updateState } = props;
    const arrowRef = (0, $5E6i4.useRef)(null);
    const beaconMiddlewareRef = (0, $5E6i4.useRef)({});
    const tooltipMiddlewareRef = (0, $5E6i4.useRef)({});
    const isCenter = step.placement === "center";
    const isAuto = step.placement === "auto";
    const centerReference = (0, $5E6i4.useMemo)(()=>({
            getBoundingClientRect: ()=>({
                    x: window.innerWidth / 2,
                    y: window.innerHeight / 2,
                    top: window.innerHeight / 2,
                    left: window.innerWidth / 2,
                    bottom: window.innerHeight / 2,
                    right: window.innerWidth / 2,
                    width: 0,
                    height: 0
                })
        }), []);
    const scrollParent = (0, $5E6i4.useMemo)(()=>$1a9bd18e23abd3f1$var$hasCustomScrollParent(target) ? $1a9bd18e23abd3f1$var$getScrollParent(target) : void 0, [
        target
    ]);
    const isFixedTarget = (0, $5E6i4.useMemo)(()=>$1a9bd18e23abd3f1$var$hasPosition(target), [
        target
    ]);
    const boundaryOptions = (0, $5E6i4.useMemo)(()=>scrollParent ? {
            boundary: scrollParent,
            rootBoundary: "viewport"
        } : {}, [
        scrollParent
    ]);
    const tooltipPlacement = isCenter || isAuto ? "bottom" : step.placement;
    const strategy = isCenter ? "fixed" : step.floatingOptions?.strategy ?? (step.isFixed || isFixedTarget ? "fixed" : "absolute");
    const tooltipMiddleware = (0, $5E6i4.useMemo)(()=>isCenter ? [
            {
                name: "center",
                fn: ({ rects: rects })=>({
                        x: (window.innerWidth - rects.floating.width) / 2,
                        y: (window.innerHeight - rects.floating.height) / 2
                    })
            }
        ] : [
            (0, $579fdd7a121bbebe$export$cc800923e997bb8)(({ placement: currentPlacement })=>{
                let side = "right";
                if (currentPlacement.startsWith("top")) side = "top";
                else if (currentPlacement.startsWith("bottom")) side = "bottom";
                else if (currentPlacement.startsWith("left")) side = "left";
                const padding = step.spotlightTarget ? 0 : step.spotlightPadding[side];
                return step.offset + padding + (step.floatingOptions?.hideArrow ? 0 : step.arrowSize);
            }, [
                step.offset,
                step.spotlightPadding,
                step.spotlightTarget,
                step.arrowSize,
                step.floatingOptions?.hideArrow
            ]),
            ...$1a9bd18e23abd3f1$var$getFlipMiddleware(isAuto, step, tooltipPlacement),
            (0, $579fdd7a121bbebe$export$fba63a578e423eb)({
                padding: 10,
                ...boundaryOptions,
                ...step.floatingOptions?.shiftOptions
            }),
            ...step.floatingOptions?.hideArrow ? [] : [
                (0, $579fdd7a121bbebe$export$f2120bbfa5450bd2)({
                    element: arrowRef,
                    padding: step.arrowSpacing
                }, [
                    step.arrowSpacing,
                    step.arrowBase
                ])
            ],
            ...step.floatingOptions?.middleware ?? []
        ], [
        isCenter,
        step,
        isAuto,
        tooltipPlacement,
        boundaryOptions
    ]);
    const tooltipFloating = (0, $579fdd7a121bbebe$export$4e02a5c1d08bac65)({
        ...isCenter ? {
            elements: {
                reference: centerReference
            }
        } : {},
        placement: tooltipPlacement,
        strategy: strategy,
        middleware: tooltipMiddleware
    });
    const beaconFloating = (0, $579fdd7a121bbebe$export$4e02a5c1d08bac65)({
        strategy: strategy,
        placement: step.beaconPlacement ?? (isAuto || isCenter ? "bottom" : step.placement),
        middleware: (0, $5E6i4.useMemo)(()=>[
                (0, $579fdd7a121bbebe$export$cc800923e997bb8)(step.floatingOptions?.beaconOptions?.offset ?? -18)
            ], [
            step.floatingOptions?.beaconOptions?.offset
        ]),
        whileElementsMounted: (0, $b6afb10360273f49$export$deee3a793edee05f)
    });
    tooltipMiddlewareRef.current = tooltipFloating.middlewareData;
    beaconMiddlewareRef.current = beaconFloating.middlewareData;
    (0, $5E6i4.useEffect)(()=>{
        const { floating: floating, reference: reference } = tooltipFloating.elements;
        if (!reference || !floating || lifecycle !== $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.TOOLTIP) return;
        return (0, $b6afb10360273f49$export$deee3a793edee05f)(reference, floating, tooltipFloating.update, step.floatingOptions?.autoUpdate);
    }, [
        lifecycle,
        tooltipFloating.update,
        step.floatingOptions?.autoUpdate,
        step.target,
        tooltipFloating.elements
    ]);
    (0, $5E6i4.useEffect)(()=>{
        if (!isCenter && target) tooltipFloating.refs.setReference(target);
        if (target) beaconFloating.refs.setReference(target);
    }, [
        beaconFloating.refs,
        isCenter,
        target,
        tooltipFloating.refs
    ]);
    (0, $5E6i4.useEffect)(()=>{
        if (tooltipFloating.isPositioned) setPositionData("tooltip", {
            placement: tooltipFloating.placement,
            x: tooltipFloating.x ?? 0,
            y: tooltipFloating.y ?? 0,
            middlewareData: tooltipMiddlewareRef.current
        });
    }, [
        setPositionData,
        tooltipFloating.isPositioned,
        tooltipFloating.placement,
        tooltipFloating.x,
        tooltipFloating.y
    ]);
    (0, $5E6i4.useEffect)(()=>{
        if (beaconFloating.isPositioned) setPositionData("beacon", {
            placement: beaconFloating.placement,
            x: beaconFloating.x ?? 0,
            y: beaconFloating.y ?? 0,
            middlewareData: beaconMiddlewareRef.current
        });
    }, [
        setPositionData,
        beaconFloating.isPositioned,
        beaconFloating.placement,
        beaconFloating.x,
        beaconFloating.y
    ]);
    const zIndex = step.zIndex + 1;
    const handleBeaconInteraction = (0, $5E6i4.useCallback)((event)=>{
        if (event.type === "mouseenter" && step.beaconTrigger !== "hover") return;
        updateState({
            lifecycle: $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.TOOLTIP_BEFORE,
            positioned: false
        });
    }, [
        step.beaconTrigger,
        updateState
    ]);
    const floaterRef = (0, $5E6i4.useCallback)((node)=>{
        if (node) {
            tooltipFloating.refs.setFloating(node);
            setTooltipRef(node);
        }
    }, [
        tooltipFloating.refs,
        setTooltipRef
    ]);
    const { arrow: arrowStyles, floater: floaterStyles } = step.styles;
    let content = null;
    if (lifecycle === $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.TOOLTIP || lifecycle === $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.TOOLTIP_BEFORE) {
        const styles = $1a9bd18e23abd3f1$var$sortObjectKeys({
            ...floaterStyles,
            ...tooltipFloating.floatingStyles,
            zIndex: zIndex,
            opacity: open && tooltipFloating.isPositioned ? 1 : 0,
            ...!open && {
                transition: "none"
            }
        });
        content = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("div", {
            ref: floaterRef,
            className: "react-joyride__floater",
            "data-testid": "floater",
            id: `react-joyride-step-${index}`,
            style: styles
        }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement($1a9bd18e23abd3f1$var$Tooltip, {
            continuous: continuous,
            controls: controls,
            index: index,
            isLastStep: index + 1 === size,
            size: size,
            step: step
        }), !isCenter && !step.floatingOptions?.hideArrow && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement($1a9bd18e23abd3f1$var$Arrow, {
            arrowComponent: step.arrowComponent,
            arrowRef: arrowRef,
            base: step.arrowBase,
            placement: tooltipFloating.placement,
            position: tooltipFloating.middlewareData.arrow,
            size: step.arrowSize,
            styles: arrowStyles
        }));
    } else if (lifecycle === $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.BEACON || lifecycle === $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.BEACON_BEFORE) content = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("div", {
        ref: beaconFloating.refs.setFloating,
        className: "react-joyride__floater",
        "data-testid": "floater-beacon",
        id: `react-joyride-step-${index}-beacon`,
        style: $1a9bd18e23abd3f1$var$sortObjectKeys({
            ...beaconFloating.floatingStyles,
            zIndex: zIndex
        })
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement($1a9bd18e23abd3f1$var$JoyrideBeacon, {
        beaconComponent: step.beaconComponent,
        continuous: continuous,
        index: index,
        isLastStep: index + 1 === size,
        locale: step.locale,
        nonce: nonce,
        onInteract: handleBeaconInteraction,
        shouldFocus: shouldScroll,
        size: size,
        step: step,
        styles: step.styles
    }));
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement($1a9bd18e23abd3f1$var$JoyridePortal, {
        element: portalElement
    }, content);
}
//#endregion
//#region src/components/Step.tsx
function $1a9bd18e23abd3f1$var$JoyrideStep(props) {
    const { continuous: continuous, controls: controls, index: index, lifecycle: lifecycle, nonce: nonce, portalElement: portalElement, setPositionData: setPositionData, shouldScroll: shouldScroll, size: size, step: step, updateState: updateState } = props;
    const [tooltipElement, setTooltipElement] = (0, $5E6i4.useState)(null);
    $1a9bd18e23abd3f1$var$useFocusTrap(step.disableFocusTrap ? null : tooltipElement, "[data-action=primary]");
    const target = $1a9bd18e23abd3f1$var$getElement(step.target);
    const open = lifecycle === $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.TOOLTIP;
    if (!$1a9bd18e23abd3f1$var$validateStep(step) || !(0, $209e2c4c2fa2f6ac$export$2e2bcd8739ae039).domElement(target)) return null;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement($1a9bd18e23abd3f1$var$JoyrideFloater, {
        key: `JoyrideStep-${index}`,
        continuous: continuous,
        controls: controls,
        index: index,
        lifecycle: lifecycle,
        nonce: nonce,
        open: open,
        portalElement: portalElement,
        setPositionData: setPositionData,
        setTooltipRef: setTooltipElement,
        shouldScroll: shouldScroll,
        size: size,
        step: step,
        target: target,
        updateState: updateState
    });
}
//#endregion
//#region src/components/TourRenderer.tsx
function $1a9bd18e23abd3f1$var$TourRenderer({ controls: controls, mergedProps: mergedProps, state: state, step: step, store: store }) {
    const { continuous: continuous, debug: debug, nonce: nonce, portalElement: portalElement, scrollToFirstStep: scrollToFirstStep } = mergedProps;
    const element = $1a9bd18e23abd3f1$var$usePortalElement(portalElement);
    const { index: index, lifecycle: lifecycle, status: status } = state;
    const isRunning = status === $1a9bd18e23abd3f1$export$e50006273435e7d4.RUNNING;
    const [showLoader, setShowLoader] = (0, $5E6i4.useState)(false);
    const loaderTimerRef = (0, $5E6i4.useRef)(null);
    const loaderDelay = step?.loaderDelay ?? 0;
    (0, $5E6i4.useEffect)(()=>{
        if (state.waiting) {
            if (loaderDelay === 0) setShowLoader(true);
            else loaderTimerRef.current = setTimeout(()=>{
                setShowLoader(true);
            }, loaderDelay);
        } else setShowLoader(false);
        return ()=>{
            if (loaderTimerRef.current) {
                clearTimeout(loaderTimerRef.current);
                loaderTimerRef.current = null;
            }
        };
    }, [
        loaderDelay,
        state.waiting
    ]);
    (0, $5E6i4.useEffect)(()=>{
        if (!isRunning) return;
        const handleKeyboard = (event)=>{
            if (!step || lifecycle !== $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.TOOLTIP) return;
            if (event.key === "Escape" && step.dismissKeyAction) {
                if (step.dismissKeyAction === "next") controls.next($1a9bd18e23abd3f1$export$ccee77ec32a436d7.KEYBOARD);
                else if (step.dismissKeyAction === "replay") controls.replay($1a9bd18e23abd3f1$export$ccee77ec32a436d7.KEYBOARD);
                else controls.close($1a9bd18e23abd3f1$export$ccee77ec32a436d7.KEYBOARD);
            }
        };
        document.body.addEventListener("keydown", handleKeyboard, {
            passive: true
        });
        return ()=>{
            document.body.removeEventListener("keydown", handleKeyboard);
        };
    }, [
        controls,
        isRunning,
        lifecycle,
        step
    ]);
    const handleClickOverlay = (0, $5E6i4.useCallback)(()=>{
        switch(step?.overlayClickAction){
            case "close":
                controls.close($1a9bd18e23abd3f1$export$ccee77ec32a436d7.OVERLAY);
                break;
            case "next":
                controls.next($1a9bd18e23abd3f1$export$ccee77ec32a436d7.OVERLAY);
                break;
            case "replay":
                controls.replay($1a9bd18e23abd3f1$export$ccee77ec32a436d7.OVERLAY);
                break;
        }
    }, [
        controls,
        step?.overlayClickAction
    ]);
    if (!step || !isRunning) return null;
    const hideOverlay = state.action === $1a9bd18e23abd3f1$export$92a1a3b7554e9387.START && !step.skipBeacon && step.placement !== "center";
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).Fragment, null, lifecycle !== $1a9bd18e23abd3f1$export$2cb9787dd463cbf4.INIT && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement($1a9bd18e23abd3f1$var$JoyrideStep, {
        ...state,
        continuous: continuous,
        controls: controls,
        debug: debug,
        nonce: nonce,
        portalElement: element,
        setPositionData: store.current.setPositionData,
        shouldScroll: !step.skipScroll && (index !== 0 || scrollToFirstStep),
        step: step,
        updateState: store.current.updateState
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement($1a9bd18e23abd3f1$var$JoyridePortal, {
        element: element
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).Fragment, null, showLoader && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement($1a9bd18e23abd3f1$var$JoyrideLoader, {
        nonce: nonce,
        step: step
    }), !hideOverlay && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement($1a9bd18e23abd3f1$var$JoyrideOverlay, {
        ...step,
        continuous: continuous,
        lifecycle: lifecycle,
        onClickOverlay: handleClickOverlay,
        portalElement: portalElement ? element : null,
        scrolling: state.scrolling,
        waiting: state.waiting
    }))));
}
//#endregion
//#region src/hooks/useJoyride.tsx
function $1a9bd18e23abd3f1$export$8ed378b618066557(props) {
    const { controls: controls, failures: failures, mergedProps: mergedProps, state: state, step: step, store: store } = $1a9bd18e23abd3f1$var$useTourEngine(props);
    return {
        controls: controls,
        failures: failures,
        on: (0, $5E6i4.useCallback)((eventType, handler)=>store.current.on(eventType, handler), [
            store
        ]),
        state: (0, $5E6i4.useMemo)(()=>$1a9bd18e23abd3f1$var$omit(state, "positioned"), [
            state
        ]),
        step: step,
        Tour: $1a9bd18e23abd3f1$var$canUseDOM() ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement($1a9bd18e23abd3f1$var$TourRenderer, {
            controls: controls,
            mergedProps: mergedProps,
            state: state,
            step: step,
            store: store
        }) : null
    };
}
//#endregion
//#region src/index.tsx
function $1a9bd18e23abd3f1$var$JoyrideTour(props) {
    const { Tour: Tour } = $1a9bd18e23abd3f1$export$8ed378b618066557(props);
    return Tour;
}
function $1a9bd18e23abd3f1$export$dea3f86268c96277(props) {
    if (!$1a9bd18e23abd3f1$var$canUseDOM()) return null;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement($1a9bd18e23abd3f1$var$JoyrideTour, props);
}










var $5E6i4 = parcelRequire("5E6i4");










var $5E6i4 = parcelRequire("5E6i4");




var $5E6i4 = parcelRequire("5E6i4");

"use client";
const $3ca7e3706e6e1e5b$var$UnitNumber = (props)=>{
    const { prefixCls: prefixCls, value: value, current: current, offset: offset = 0 } = props;
    let style;
    if (offset) style = {
        position: 'absolute',
        top: `${offset}00%`,
        left: 0
    };
    return /*#__PURE__*/ $5E6i4.createElement("span", {
        style: style,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-only-unit`, {
            current: current
        })
    }, value);
};
function $3ca7e3706e6e1e5b$var$getOffset(start, end, unit) {
    let index = start;
    let offset = 0;
    while((index + 10) % 10 !== end){
        index += unit;
        offset += unit;
    }
    return offset;
}
const $3ca7e3706e6e1e5b$var$SingleNumber = (props)=>{
    const { prefixCls: prefixCls, count: originCount, value: originValue } = props;
    const value = Number(originValue);
    const count = Math.abs(originCount);
    const [prevValue, setPrevValue] = $5E6i4.useState(value);
    const [prevCount, setPrevCount] = $5E6i4.useState(count);
    // ============================= Events =============================
    const onTransitionEnd = ()=>{
        setPrevValue(value);
        setPrevCount(count);
    };
    // Fallback if transition events are not supported
    $5E6i4.useEffect(()=>{
        const timer = setTimeout(onTransitionEnd, 1000);
        return ()=>clearTimeout(timer);
    }, [
        value
    ]);
    // ============================= Render =============================
    // Render unit list
    let unitNodes;
    let offsetStyle;
    if (prevValue === value || Number.isNaN(value) || Number.isNaN(prevValue)) {
        // Nothing to change
        unitNodes = [
            /*#__PURE__*/ $5E6i4.createElement($3ca7e3706e6e1e5b$var$UnitNumber, {
                ...props,
                key: value,
                current: true
            })
        ];
        offsetStyle = {
            transition: 'none'
        };
    } else {
        unitNodes = [];
        // Fill basic number units
        const end = value + 10;
        const unitNumberList = [];
        for(let index = value; index <= end; index += 1)unitNumberList.push(index);
        const unit = prevCount < count ? 1 : -1;
        // Fill with number unit nodes
        const prevIndex = unitNumberList.findIndex((n)=>n % 10 === prevValue);
        // Cut list
        const cutUnitNumberList = unit < 0 ? unitNumberList.slice(0, prevIndex + 1) : unitNumberList.slice(prevIndex);
        unitNodes = cutUnitNumberList.map((n, index)=>{
            const singleUnit = n % 10;
            return /*#__PURE__*/ $5E6i4.createElement($3ca7e3706e6e1e5b$var$UnitNumber, {
                ...props,
                key: n,
                value: singleUnit,
                offset: unit < 0 ? index - prevIndex : index,
                current: index === prevIndex
            });
        });
        // Calculate container offset value
        offsetStyle = {
            transform: `translateY(${-$3ca7e3706e6e1e5b$var$getOffset(prevValue, value, unit)}00%)`
        };
    }
    return /*#__PURE__*/ $5E6i4.createElement("span", {
        className: `${prefixCls}-only`,
        style: offsetStyle,
        onTransitionEnd: onTransitionEnd
    }, unitNodes);
};
var $3ca7e3706e6e1e5b$export$2e2bcd8739ae039 = $3ca7e3706e6e1e5b$var$SingleNumber;


"use client";
const $a1d9c2a3cab7613a$var$ScrollNumber = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, count: count, className: className, motionClassName: motionClassName, style: style, title: title, show: show, component: Component = 'sup', children: children, ...restProps } = props;
    const { getPrefixCls: getPrefixCls } = $5E6i4.useContext((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('scroll-number', customizePrefixCls);
    // ============================ Render ============================
    const newProps = {
        ...restProps,
        'data-show': show,
        style: style,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, className, motionClassName),
        title: title
    };
    // Only integer need motion
    let numberNodes = count;
    if (count && Number(count) % 1 === 0) {
        const numberList = String(count).split('');
        numberNodes = /*#__PURE__*/ $5E6i4.createElement("bdi", null, numberList.map((num, i)=>/*#__PURE__*/ $5E6i4.createElement((0, $3ca7e3706e6e1e5b$export$2e2bcd8739ae039), {
                prefixCls: prefixCls,
                count: Number(count),
                value: num,
                // eslint-disable-next-line react/no-array-index-key
                key: numberList.length - i
            })));
    }
    // allow specify the border
    // mock border-color by box-shadow for compatible with old usage:
    // <Badge count={4} style={{ backgroundColor: '#fff', color: '#999', borderColor: '#d9d9d9' }} />
    if (style?.borderColor) newProps.style = {
        ...style,
        boxShadow: `0 0 0 1px ${style.borderColor} inset`
    };
    if (children) return (0, $552e20b6ec4e63a6$export$e530037191fcd5d7)(children, (oriProps)=>({
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-custom-component`, oriProps?.className, motionClassName)
        }));
    return /*#__PURE__*/ $5E6i4.createElement(Component, {
        ...newProps,
        ref: ref
    }, numberNodes);
});
var $a1d9c2a3cab7613a$export$2e2bcd8739ae039 = $a1d9c2a3cab7613a$var$ScrollNumber;





const $8919342769d31526$var$antStatusProcessing = new (0, $14544cbeb8c8473b$export$2e2bcd8739ae039)('antStatusProcessing', {
    '0%': {
        transform: 'scale(0.8)',
        opacity: 0.5
    },
    '100%': {
        transform: 'scale(2.4)',
        opacity: 0
    }
});
const $8919342769d31526$var$antZoomBadgeIn = new (0, $14544cbeb8c8473b$export$2e2bcd8739ae039)('antZoomBadgeIn', {
    '0%': {
        transform: 'scale(0) translate(50%, -50%)',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1) translate(50%, -50%)'
    }
});
const $8919342769d31526$var$antZoomBadgeOut = new (0, $14544cbeb8c8473b$export$2e2bcd8739ae039)('antZoomBadgeOut', {
    '0%': {
        transform: 'scale(1) translate(50%, -50%)'
    },
    '100%': {
        transform: 'scale(0) translate(50%, -50%)',
        opacity: 0
    }
});
const $8919342769d31526$var$antNoWrapperZoomBadgeIn = new (0, $14544cbeb8c8473b$export$2e2bcd8739ae039)('antNoWrapperZoomBadgeIn', {
    '0%': {
        transform: 'scale(0)',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)'
    }
});
const $8919342769d31526$var$antNoWrapperZoomBadgeOut = new (0, $14544cbeb8c8473b$export$2e2bcd8739ae039)('antNoWrapperZoomBadgeOut', {
    '0%': {
        transform: 'scale(1)'
    },
    '100%': {
        transform: 'scale(0)',
        opacity: 0
    }
});
const $8919342769d31526$var$antBadgeLoadingCircle = new (0, $14544cbeb8c8473b$export$2e2bcd8739ae039)('antBadgeLoadingCircle', {
    '0%': {
        transformOrigin: '50%'
    },
    '100%': {
        transform: 'translate(50%, -50%) rotate(360deg)',
        transformOrigin: '50%'
    }
});
const $8919342769d31526$var$genSharedBadgeStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, antCls: antCls, badgeShadowSize: badgeShadowSize, textFontSize: textFontSize, textFontSizeSM: textFontSizeSM, statusSize: statusSize, dotSize: dotSize, textFontWeight: textFontWeight, indicatorHeight: indicatorHeight, indicatorHeightSM: indicatorHeightSM, marginXS: marginXS, calc: calc } = token;
    const numberPrefixCls = `${antCls}-scroll-number`;
    const colorPreset = (0, $eeb2a6150e6f408f$export$2e2bcd8739ae039)(token, (colorKey, { darkColor: darkColor })=>({
            [`&${componentCls} ${componentCls}-color-${colorKey}`]: {
                background: darkColor,
                [`&:not(${componentCls}-count)`]: {
                    color: darkColor
                },
                'a:hover &': {
                    background: darkColor
                }
            }
        }));
    return {
        [componentCls]: {
            ...(0, $cd5a520fee8002b4$export$23997c3e44cc1c59)(token),
            position: 'relative',
            display: 'inline-block',
            width: 'fit-content',
            lineHeight: 1,
            [`${componentCls}-count`]: {
                display: 'inline-flex',
                justifyContent: 'center',
                zIndex: token.indicatorZIndex,
                minWidth: indicatorHeight,
                height: indicatorHeight,
                color: token.badgeTextColor,
                fontWeight: textFontWeight,
                fontSize: textFontSize,
                lineHeight: (0, $56bae8a99c3cba6e$export$523c0b569236b342)(indicatorHeight),
                whiteSpace: 'nowrap',
                textAlign: 'center',
                background: token.badgeColor,
                borderRadius: calc(indicatorHeight).div(2).equal(),
                boxShadow: `0 0 0 ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(badgeShadowSize)} ${token.badgeShadowColor}`,
                transition: `background-color ${token.motionDurationMid}`,
                a: {
                    color: token.badgeTextColor
                },
                'a:hover': {
                    color: token.badgeTextColor
                },
                'a:hover &': {
                    background: token.badgeColorHover
                }
            },
            [`${componentCls}-count-sm`]: {
                minWidth: indicatorHeightSM,
                height: indicatorHeightSM,
                fontSize: textFontSizeSM,
                lineHeight: (0, $56bae8a99c3cba6e$export$523c0b569236b342)(indicatorHeightSM),
                borderRadius: calc(indicatorHeightSM).div(2).equal()
            },
            [`${componentCls}-multiple-words`]: {
                paddingInline: token.paddingInline,
                bdi: {
                    unicodeBidi: 'plaintext'
                }
            },
            [`${componentCls}-dot`]: {
                zIndex: token.indicatorZIndex,
                width: dotSize,
                minWidth: dotSize,
                height: dotSize,
                background: token.badgeColor,
                borderRadius: '100%',
                boxShadow: `0 0 0 ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(badgeShadowSize)} ${token.badgeShadowColor}`
            },
            [`${componentCls}-count, ${componentCls}-dot, ${numberPrefixCls}-custom-component`]: {
                position: 'absolute',
                top: 0,
                insetInlineEnd: 0,
                transform: 'translate(50%, -50%)',
                transformOrigin: '100% 0%',
                [`&${iconCls}-spin`]: {
                    animationName: $8919342769d31526$var$antBadgeLoadingCircle,
                    animationDuration: '1s',
                    animationIterationCount: 'infinite',
                    animationTimingFunction: 'linear'
                }
            },
            [`&${componentCls}-status`]: {
                lineHeight: 'inherit',
                verticalAlign: 'baseline',
                [`${componentCls}-status-dot`]: {
                    position: 'relative',
                    top: -1,
                    // Magic number, but seems better experience
                    display: 'inline-block',
                    width: statusSize,
                    height: statusSize,
                    verticalAlign: 'middle',
                    borderRadius: '50%'
                },
                [`${componentCls}-status-success`]: {
                    backgroundColor: token.colorSuccess
                },
                [`${componentCls}-status-processing`]: {
                    overflow: 'visible',
                    color: token.colorInfoTextHover,
                    backgroundColor: token.colorInfo,
                    borderColor: 'currentcolor',
                    '&::after': {
                        position: 'absolute',
                        top: 0,
                        insetInlineStart: 0,
                        width: '100%',
                        height: '100%',
                        borderWidth: badgeShadowSize,
                        borderStyle: 'solid',
                        borderColor: 'inherit',
                        borderRadius: '50%',
                        animationName: $8919342769d31526$var$antStatusProcessing,
                        animationDuration: token.badgeProcessingDuration,
                        animationIterationCount: 'infinite',
                        animationTimingFunction: 'ease-in-out',
                        content: '""'
                    }
                },
                [`${componentCls}-status-default`]: {
                    backgroundColor: token.colorTextPlaceholder
                },
                [`${componentCls}-status-error`]: {
                    backgroundColor: token.colorError
                },
                [`${componentCls}-status-warning`]: {
                    backgroundColor: token.colorWarning
                },
                [`${componentCls}-status-text`]: {
                    marginInlineStart: marginXS,
                    color: token.colorText,
                    fontSize: token.fontSize
                }
            },
            ...colorPreset,
            [`${componentCls}-zoom-appear, ${componentCls}-zoom-enter`]: {
                animationName: $8919342769d31526$var$antZoomBadgeIn,
                animationDuration: token.motionDurationSlow,
                animationTimingFunction: token.motionEaseOutBack,
                animationFillMode: 'both'
            },
            [`${componentCls}-zoom-leave`]: {
                animationName: $8919342769d31526$var$antZoomBadgeOut,
                animationDuration: token.motionDurationSlow,
                animationTimingFunction: token.motionEaseOutBack,
                animationFillMode: 'both'
            },
            [`&${componentCls}-not-a-wrapper`]: {
                [`${componentCls}-zoom-appear, ${componentCls}-zoom-enter`]: {
                    animationName: $8919342769d31526$var$antNoWrapperZoomBadgeIn,
                    animationDuration: token.motionDurationSlow,
                    animationTimingFunction: token.motionEaseOutBack
                },
                [`${componentCls}-zoom-leave`]: {
                    animationName: $8919342769d31526$var$antNoWrapperZoomBadgeOut,
                    animationDuration: token.motionDurationSlow,
                    animationTimingFunction: token.motionEaseOutBack
                },
                [`&:not(${componentCls}-status)`]: {
                    verticalAlign: 'middle'
                },
                [`${numberPrefixCls}-custom-component, ${componentCls}-count`]: {
                    transform: 'none'
                },
                [`${numberPrefixCls}-custom-component, ${numberPrefixCls}`]: {
                    position: 'relative',
                    top: 'auto',
                    display: 'block',
                    transformOrigin: '50% 50%'
                }
            },
            [numberPrefixCls]: {
                overflow: 'hidden',
                transition: `all ${token.motionDurationMid} ${token.motionEaseOutBack}`,
                [`${numberPrefixCls}-only`]: {
                    position: 'relative',
                    display: 'inline-block',
                    height: indicatorHeight,
                    transition: `all ${token.motionDurationSlow} ${token.motionEaseOutBack}`,
                    WebkitTransformStyle: 'preserve-3d',
                    WebkitBackfaceVisibility: 'hidden'
                }
            },
            // ====================== RTL =======================
            '&-rtl': {
                direction: 'rtl',
                [`${componentCls}-count, ${componentCls}-dot, ${numberPrefixCls}-custom-component`]: {
                    transform: 'translate(-50%, -50%)'
                }
            }
        }
    };
};
const $8919342769d31526$export$362fb92a8f81bbf9 = (token)=>{
    const { fontHeight: fontHeight, lineWidth: lineWidth, marginXS: marginXS, colorBorderBg: colorBorderBg } = token;
    const badgeFontHeight = fontHeight;
    const badgeShadowSize = lineWidth;
    const badgeTextColor = token.colorTextLightSolid;
    const badgeColor = token.colorError;
    const badgeColorHover = token.colorErrorHover;
    const badgeToken = (0, $f564548c7b6877d5$export$4950aa0f605343fb)(token, {
        badgeFontHeight: badgeFontHeight,
        badgeShadowSize: badgeShadowSize,
        badgeTextColor: badgeTextColor,
        badgeColor: badgeColor,
        badgeColorHover: badgeColorHover,
        badgeShadowColor: colorBorderBg,
        badgeProcessingDuration: '1.2s',
        badgeRibbonOffset: marginXS,
        // Follow token just by Design. Not related with token
        badgeRibbonCornerTransform: 'scaleY(0.75)',
        badgeRibbonCornerFilter: `brightness(75%)`
    });
    return badgeToken;
};
const $8919342769d31526$export$9ca1be8807fe0675 = (token)=>{
    const { fontSize: fontSize, lineHeight: lineHeight, fontSizeSM: fontSizeSM, lineWidth: lineWidth, paddingXS: paddingXS } = token;
    return {
        indicatorZIndex: 'auto',
        indicatorHeight: Math.round(fontSize * lineHeight) - 2 * lineWidth,
        indicatorHeightSM: fontSize,
        dotSize: fontSizeSM / 2,
        textFontSize: fontSizeSM,
        textFontSizeSM: fontSizeSM,
        textFontWeight: 'normal',
        statusSize: fontSizeSM / 2,
        paddingInline: paddingXS
    };
};
var $8919342769d31526$export$2e2bcd8739ae039 = (0, $761caadb5301aee1$export$51ec95de45185b42)('Badge', (token)=>{
    const badgeToken = $8919342769d31526$export$362fb92a8f81bbf9(token);
    return $8919342769d31526$var$genSharedBadgeStyle(badgeToken);
}, $8919342769d31526$export$9ca1be8807fe0675);


"use client";
const $3d5a75703d7e1a49$var$Badge = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, scrollNumberPrefixCls: customizeScrollNumberPrefixCls, children: children, status: status, text: text, color: color, count: count = null, overflowCount: overflowCount = 99, dot: dot = false, size: size = 'medium', title: title, offset: offset, style: style, className: className, rootClassName: rootClassName, classNames: classNames, styles: styles, showZero: showZero = false, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $519f2fad435b3034$export$46f4bd6436a25a31)('badge');
    const prefixCls = getPrefixCls('badge', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $8919342769d31526$export$2e2bcd8739ae039)(prefixCls);
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        overflowCount: overflowCount,
        size: size,
        dot: dot,
        showZero: showZero
    };
    // ================================ Misc ================================
    const numberedDisplayCount = count > overflowCount ? `${overflowCount}+` : count;
    const isZero = numberedDisplayCount === '0' || numberedDisplayCount === 0 || text === '0' || text === 0;
    const ignoreCount = count === null || isZero && !showZero;
    const hasStatus = ((0, $b63de2b9864a5d1a$export$826fff653a329e83)(status) || (0, $b63de2b9864a5d1a$export$826fff653a329e83)(color)) && ignoreCount;
    const hasStatusValue = (0, $b63de2b9864a5d1a$export$826fff653a329e83)(status) || !isZero;
    const isStatusBadge = Boolean(!children && hasStatus && (text || hasStatusValue));
    // =============================== Styles ===============================
    const offsetStyle = (0, $5E6i4.useMemo)(()=>{
        if (!offset) return undefined;
        const horizontalOffset = Number.parseFloat(offset[0]);
        return {
            marginTop: offset[1],
            insetInlineEnd: -horizontalOffset
        };
    }, [
        offset
    ]);
    const mergedStyle = (0, $5E6i4.useMemo)(()=>({
            ...offsetStyle,
            ...contextStyle,
            ...style
        }), [
        offsetStyle,
        style,
        contextStyle
    ]);
    const legacyStyleKey = isStatusBadge ? 'root' : 'indicator';
    const contextLegacyStyle = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(contextStyle, legacyStyleKey);
    const componentLegacyStyle = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(style, legacyStyleKey);
    const [mergedClassNames, mergedStyles] = (0, $722c8632ba7bdb89$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextLegacyStyle,
        styles,
        componentLegacyStyle
    ], {
        props: mergedProps
    });
    const showAsDot = dot && !isZero;
    const mergedCount = showAsDot ? '' : numberedDisplayCount;
    const isHidden = (0, $5E6i4.useMemo)(()=>{
        const isEmpty = !(0, $b63de2b9864a5d1a$export$72280d5f896dac9a)(mergedCount) && !(0, $b63de2b9864a5d1a$export$72280d5f896dac9a)(text);
        return (isEmpty || isZero && !showZero) && !showAsDot;
    }, [
        mergedCount,
        isZero,
        showZero,
        showAsDot,
        text
    ]);
    // Count should be cache in case hidden change it
    const countRef = (0, $5E6i4.useRef)(count);
    if (!isHidden) countRef.current = count;
    const livingCount = countRef.current;
    // We need cache count since remove motion should not change count display
    const displayCountRef = (0, $5E6i4.useRef)(mergedCount);
    if (!isHidden) displayCountRef.current = mergedCount;
    const displayCount = displayCountRef.current;
    // We will cache the dot status to avoid shaking on leaved motion
    const isDotRef = (0, $5E6i4.useRef)(showAsDot);
    if (!isHidden) isDotRef.current = showAsDot;
    // =============================== Render ===============================
    // >>> Title
    const fallbackTitleNode = (0, $addbc2fddcbb77a9$export$844ec244b1367d54)(livingCount) || (0, $addbc2fddcbb77a9$export$7e4aa119212bc614)(livingCount) ? livingCount : undefined;
    const titleNode = title === null || title === false ? undefined : title ?? fallbackTitleNode;
    // >>> Status Text
    const showStatusTextNode = !isHidden && (text === 0 ? showZero : !!text && text !== true);
    const statusTextNode = !showStatusTextNode ? null : /*#__PURE__*/ $5E6i4.createElement("span", {
        style: isStatusBadge ? {
            color: mergedStyles.root?.color
        } : undefined,
        className: `${prefixCls}-status-text`
    }, text);
    // >>> Display Component
    const displayNode = (0, $addbc2fddcbb77a9$export$53b83ca8eaab0383)(livingCount) ? (0, $552e20b6ec4e63a6$export$e530037191fcd5d7)(livingCount, (oriProps)=>({
            style: {
                ...mergedStyle,
                ...oriProps.style
            }
        })) : undefined;
    // InternalColor
    const isInternalColor = (0, $34c0f54ad93821fb$export$ee62ebd6a58c4884)(color, false);
    // Shared styles
    const statusCls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(mergedClassNames.indicator, {
        [`${prefixCls}-status-dot`]: hasStatus,
        [`${prefixCls}-status-${status}`]: !!status,
        [`${prefixCls}-color-${color}`]: isInternalColor
    });
    const statusStyle = {};
    if (color && !isInternalColor) {
        statusStyle.color = color;
        statusStyle.background = color;
    }
    const badgeClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, {
        [`${prefixCls}-status`]: hasStatus,
        [`${prefixCls}-not-a-wrapper`]: !children,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, className, rootClassName, contextClassName, mergedClassNames.root, hashId, cssVarCls);
    // <Badge status="success" />
    if (isStatusBadge) return /*#__PURE__*/ $5E6i4.createElement("span", {
        ref: ref,
        ...restProps,
        className: badgeClassName,
        style: {
            ...offsetStyle,
            ...mergedStyles.root
        }
    }, /*#__PURE__*/ $5E6i4.createElement("span", {
        className: statusCls,
        style: {
            ...mergedStyles.indicator,
            ...statusStyle
        }
    }), statusTextNode);
    return /*#__PURE__*/ $5E6i4.createElement("span", {
        ref: ref,
        ...restProps,
        className: badgeClassName,
        style: mergedStyles.root
    }, children, /*#__PURE__*/ $5E6i4.createElement((0, $5371a8954d0d2416$export$2e2bcd8739ae039), {
        visible: !isHidden,
        motionName: `${prefixCls}-zoom`,
        motionAppear: false,
        motionDeadline: 1000
    }, ({ className: motionClassName })=>{
        const scrollNumberPrefixCls = getPrefixCls('scroll-number', customizeScrollNumberPrefixCls);
        const isDot = isDotRef.current;
        const scrollNumberCls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(mergedClassNames.indicator, {
            [`${prefixCls}-dot`]: isDot,
            [`${prefixCls}-count`]: !isDot,
            [`${prefixCls}-count-sm`]: size === 'small',
            [`${prefixCls}-multiple-words`]: !isDot && displayCount && displayCount.toString().length > 1,
            [`${prefixCls}-status-${status}`]: !!status,
            [`${prefixCls}-color-${color}`]: isInternalColor
        });
        const scrollNumberStyle = {
            ...offsetStyle,
            ...mergedStyles.indicator
        };
        if (color && !isInternalColor) scrollNumberStyle.background = color;
        return /*#__PURE__*/ $5E6i4.createElement((0, $a1d9c2a3cab7613a$export$2e2bcd8739ae039), {
            prefixCls: scrollNumberPrefixCls,
            show: !isHidden,
            motionClassName: motionClassName,
            className: scrollNumberCls,
            count: displayCount,
            title: titleNode,
            style: scrollNumberStyle,
            key: "scrollNumber"
        }, displayNode);
    }), statusTextNode);
});
var $3d5a75703d7e1a49$export$2e2bcd8739ae039 = $3d5a75703d7e1a49$var$Badge;



var $5E6i4 = parcelRequire("5E6i4");








// ============================== Ribbon ==============================
const $cd715fba7cc25edb$var$genRibbonStyle = (token)=>{
    const { antCls: antCls, badgeFontHeight: badgeFontHeight, marginXS: marginXS, badgeRibbonOffset: badgeRibbonOffset, calc: calc } = token;
    const ribbonPrefixCls = `${antCls}-ribbon`;
    const ribbonWrapperPrefixCls = `${antCls}-ribbon-wrapper`;
    const statusRibbonPreset = (0, $eeb2a6150e6f408f$export$2e2bcd8739ae039)(token, (colorKey, { darkColor: darkColor })=>({
            [`&${ribbonPrefixCls}-color-${colorKey}`]: {
                background: darkColor,
                color: darkColor
            }
        }));
    return {
        [ribbonWrapperPrefixCls]: {
            position: 'relative'
        },
        [ribbonPrefixCls]: {
            ...(0, $cd5a520fee8002b4$export$23997c3e44cc1c59)(token),
            position: 'absolute',
            top: marginXS,
            padding: `0 ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.paddingXS)}`,
            color: token.colorPrimary,
            lineHeight: (0, $56bae8a99c3cba6e$export$523c0b569236b342)(badgeFontHeight),
            whiteSpace: 'nowrap',
            backgroundColor: token.colorPrimary,
            borderRadius: token.borderRadiusSM,
            [`${ribbonPrefixCls}-content`]: {
                color: token.badgeTextColor
            },
            [`${ribbonPrefixCls}-corner`]: {
                position: 'absolute',
                top: '100%',
                width: badgeRibbonOffset,
                height: badgeRibbonOffset,
                color: 'currentcolor',
                border: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(calc(badgeRibbonOffset).div(2).equal())} solid`,
                transform: token.badgeRibbonCornerTransform,
                transformOrigin: 'top',
                filter: token.badgeRibbonCornerFilter
            },
            ...statusRibbonPreset,
            [`&${ribbonPrefixCls}-placement-end`]: {
                insetInlineEnd: calc(badgeRibbonOffset).mul(-1).equal(),
                borderEndEndRadius: 0,
                [`${ribbonPrefixCls}-corner`]: {
                    insetInlineEnd: 0,
                    borderInlineEndColor: 'transparent',
                    borderBlockEndColor: 'transparent'
                }
            },
            [`&${ribbonPrefixCls}-placement-start`]: {
                insetInlineStart: calc(badgeRibbonOffset).mul(-1).equal(),
                borderEndStartRadius: 0,
                [`${ribbonPrefixCls}-corner`]: {
                    insetInlineStart: 0,
                    borderBlockEndColor: 'transparent',
                    borderInlineStartColor: 'transparent'
                }
            },
            // ====================== RTL =======================
            '&-rtl': {
                direction: 'rtl'
            }
        }
    };
};
var // ============================== Export ==============================
$cd715fba7cc25edb$export$2e2bcd8739ae039 = (0, $761caadb5301aee1$export$51ec95de45185b42)([
    'Badge',
    'Ribbon'
], (token)=>{
    const badgeToken = (0, $8919342769d31526$export$362fb92a8f81bbf9)(token);
    return $cd715fba7cc25edb$var$genRibbonStyle(badgeToken);
}, (0, $8919342769d31526$export$9ca1be8807fe0675));


"use client";
const $f28677f39a557586$var$Ribbon = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { className: className, prefixCls: customizePrefixCls, style: style, color: color, children: children, text: text, placement: placement = 'end', rootClassName: rootClassName, styles: styles, classNames: ribbonClassNames } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $519f2fad435b3034$export$46f4bd6436a25a31)('ribbon');
    const prefixCls = getPrefixCls('ribbon', customizePrefixCls);
    const wrapperCls = `${prefixCls}-wrapper`;
    const [hashId, cssVarCls] = (0, $cd715fba7cc25edb$export$2e2bcd8739ae039)(prefixCls, wrapperCls);
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        placement: placement
    };
    const contextIndicatorStyle = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(contextStyle, 'indicator');
    const indicatorStyle = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(style, 'indicator');
    const [mergedClassNames, mergedStyles] = (0, $722c8632ba7bdb89$export$648566b068f28737)([
        contextClassNames,
        ribbonClassNames
    ], [
        contextStyles,
        contextIndicatorStyle,
        styles,
        indicatorStyle
    ], {
        props: mergedProps
    });
    const colorInPreset = (0, $34c0f54ad93821fb$export$ee62ebd6a58c4884)(color, false);
    const ribbonCls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-placement-${placement}`, {
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-color-${color}`]: colorInPreset
    }, className, contextClassName, mergedClassNames.indicator);
    const colorStyle = {};
    const cornerColorStyle = {};
    if (color && !colorInPreset) {
        colorStyle.background = color;
        cornerColorStyle.color = color;
    }
    const nativeElementRef = $5E6i4.useRef(null);
    $5E6i4.useImperativeHandle(ref, ()=>({
            nativeElement: nativeElementRef.current
        }));
    return /*#__PURE__*/ $5E6i4.createElement("div", {
        ref: nativeElementRef,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(wrapperCls, rootClassName, hashId, cssVarCls, mergedClassNames.root),
        style: mergedStyles.root
    }, children, /*#__PURE__*/ $5E6i4.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(ribbonCls, hashId),
        style: {
            ...colorStyle,
            ...mergedStyles.indicator
        }
    }, /*#__PURE__*/ $5E6i4.createElement("span", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-content`, mergedClassNames.content),
        style: mergedStyles.content
    }, text), /*#__PURE__*/ $5E6i4.createElement("div", {
        className: `${prefixCls}-corner`,
        style: cornerColorStyle
    })));
});
var $f28677f39a557586$export$2e2bcd8739ae039 = $f28677f39a557586$var$Ribbon;


"use client";
const $df6cdd65e5b6fc4b$var$Badge = (0, $3d5a75703d7e1a49$export$2e2bcd8739ae039);
$df6cdd65e5b6fc4b$var$Badge.Ribbon = (0, $f28677f39a557586$export$2e2bcd8739ae039);
var $df6cdd65e5b6fc4b$export$2e2bcd8739ae039 = $df6cdd65e5b6fc4b$var$Badge;


var $5E6i4 = parcelRequire("5E6i4");






var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");

var $ibUU1 = parcelRequire("ibUU1");
function $5561a86ac9e01902$export$622cea445a1c5b7d(value, min, max) {
    return (value - min) / (max - min);
}
function $5561a86ac9e01902$export$a41628415415e6e(direction, value, min, max) {
    const offset = $5561a86ac9e01902$export$622cea445a1c5b7d(value, min, max);
    const positionStyle = {};
    switch(direction){
        case 'rtl':
            positionStyle.right = `${offset * 100}%`;
            positionStyle.transform = 'translateX(50%)';
            break;
        case 'btt':
            positionStyle.bottom = `${offset * 100}%`;
            positionStyle.transform = 'translateY(50%)';
            break;
        case 'ttb':
            positionStyle.top = `${offset * 100}%`;
            positionStyle.transform = 'translateY(-50%)';
            break;
        default:
            positionStyle.left = `${offset * 100}%`;
            positionStyle.transform = 'translateX(-50%)';
            break;
    }
    return positionStyle;
}
function $5561a86ac9e01902$export$ddfa24987dade61b(value, index) {
    return Array.isArray(value) ? value[index] : value;
}





var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");
const $ffd145c695cfc287$var$SliderContext = /*#__PURE__*/ $5E6i4.createContext({
    min: 0,
    max: 0,
    direction: 'ltr',
    step: 1,
    includedStart: 0,
    includedEnd: 0,
    tabIndex: 0,
    keyboard: true,
    styles: {},
    classNames: {},
    isHandleDisabled: ()=>false
});
var $ffd145c695cfc287$export$2e2bcd8739ae039 = $ffd145c695cfc287$var$SliderContext;
const $ffd145c695cfc287$export$e508d6f1a100e5dd = /*#__PURE__*/ $5E6i4.createContext({});



function $743aa8dccca17144$var$_extends() {
    $743aa8dccca17144$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $743aa8dccca17144$var$_extends.apply(this, arguments);
}
const $743aa8dccca17144$var$Handle = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, value: value, valueIndex: valueIndex, onStartMove: onStartMove, onDelete: onDelete, style: style, render: render, dragging: dragging, draggingDelete: draggingDelete, onOffsetChange: onOffsetChange, onChangeComplete: onChangeComplete, onFocus: onFocus, onMouseEnter: onMouseEnter, ...restProps } = props;
    const { min: min, max: max, direction: direction, keyboard: keyboard, range: range, tabIndex: tabIndex, ariaLabelForHandle: ariaLabelForHandle, ariaLabelledByForHandle: ariaLabelledByForHandle, ariaRequired: ariaRequired, ariaValueTextFormatterForHandle: ariaValueTextFormatterForHandle, styles: styles, classNames: classNames, isHandleDisabled: isHandleDisabled } = $5E6i4.useContext((0, $ffd145c695cfc287$export$2e2bcd8739ae039));
    const mergedDisabled = isHandleDisabled(valueIndex);
    const handlePrefixCls = `${prefixCls}-handle`;
    // ============================ Events ============================
    const onInternalStartMove = (e)=>{
        if (mergedDisabled) {
            e.stopPropagation();
            return;
        }
        onStartMove(e, valueIndex);
    };
    const onInternalFocus = (e)=>{
        onFocus?.(e, valueIndex);
    };
    const onInternalMouseEnter = (e)=>{
        onMouseEnter(e, valueIndex);
    };
    // =========================== Keyboard ===========================
    const onKeyDown = (e)=>{
        if (!mergedDisabled && keyboard) {
            let offset;
            // Change the value
            switch(e.which || e.keyCode){
                case (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).LEFT:
                    offset = direction === 'ltr' || direction === 'btt' ? -1 : 1;
                    break;
                case (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).RIGHT:
                    offset = direction === 'ltr' || direction === 'btt' ? 1 : -1;
                    break;
                // Up is plus
                case (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).UP:
                    offset = direction !== 'ttb' ? 1 : -1;
                    break;
                // Down is minus
                case (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).DOWN:
                    offset = direction !== 'ttb' ? -1 : 1;
                    break;
                case (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).HOME:
                    offset = 'min';
                    break;
                case (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).END:
                    offset = 'max';
                    break;
                case (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).PAGE_UP:
                    offset = 2;
                    break;
                case (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).PAGE_DOWN:
                    offset = -2;
                    break;
                case (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).BACKSPACE:
                case (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).DELETE:
                    onDelete?.(valueIndex);
                    break;
            }
            if (offset !== undefined) {
                e.preventDefault();
                onOffsetChange(offset, valueIndex);
            }
        }
    };
    const handleKeyUp = (e)=>{
        switch(e.which || e.keyCode){
            case (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).LEFT:
            case (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).RIGHT:
            case (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).UP:
            case (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).DOWN:
            case (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).HOME:
            case (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).END:
            case (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).PAGE_UP:
            case (0, $e7fae2d8671aa5c7$export$2e2bcd8739ae039).PAGE_DOWN:
                onChangeComplete?.();
                break;
        }
    };
    // ============================ Offset ============================
    const positionStyle = (0, $5561a86ac9e01902$export$a41628415415e6e)(direction, value, min, max);
    // ============================ Render ============================
    let divProps = {};
    if (valueIndex !== null) divProps = {
        tabIndex: mergedDisabled ? undefined : (0, $5561a86ac9e01902$export$ddfa24987dade61b)(tabIndex, valueIndex) ?? undefined,
        role: 'slider',
        'aria-valuemin': min,
        'aria-valuemax': max,
        'aria-valuenow': value,
        'aria-disabled': mergedDisabled,
        'aria-label': (0, $5561a86ac9e01902$export$ddfa24987dade61b)(ariaLabelForHandle, valueIndex),
        'aria-labelledby': (0, $5561a86ac9e01902$export$ddfa24987dade61b)(ariaLabelledByForHandle, valueIndex),
        'aria-required': (0, $5561a86ac9e01902$export$ddfa24987dade61b)(ariaRequired, valueIndex),
        'aria-valuetext': (0, $5561a86ac9e01902$export$ddfa24987dade61b)(ariaValueTextFormatterForHandle, valueIndex)?.(value),
        'aria-orientation': direction === 'ltr' || direction === 'rtl' ? 'horizontal' : 'vertical',
        onMouseDown: onInternalStartMove,
        onTouchStart: onInternalStartMove,
        onFocus: onInternalFocus,
        onMouseEnter: onInternalMouseEnter,
        onKeyDown: onKeyDown,
        onKeyUp: handleKeyUp
    };
    let handleNode = /*#__PURE__*/ $5E6i4.createElement("div", $743aa8dccca17144$var$_extends({
        ref: ref,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(handlePrefixCls, {
            [`${handlePrefixCls}-${valueIndex + 1}`]: valueIndex !== null && range,
            [`${handlePrefixCls}-dragging`]: dragging,
            [`${handlePrefixCls}-dragging-delete`]: draggingDelete,
            [`${handlePrefixCls}-disabled`]: mergedDisabled
        }, classNames.handle),
        style: {
            ...positionStyle,
            ...style,
            ...styles.handle
        }
    }, divProps, restProps));
    // Customize
    if (render) handleNode = render(handleNode, {
        index: valueIndex,
        prefixCls: prefixCls,
        value: value,
        dragging: dragging,
        draggingDelete: draggingDelete
    });
    return handleNode;
});
var $743aa8dccca17144$export$2e2bcd8739ae039 = $743aa8dccca17144$var$Handle;


function $bdd9ef17f45b64b8$var$_extends() {
    $bdd9ef17f45b64b8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bdd9ef17f45b64b8$var$_extends.apply(this, arguments);
}
const $bdd9ef17f45b64b8$var$Handles = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, style: style, onStartMove: onStartMove, onOffsetChange: onOffsetChange, values: values, handleRender: handleRender, activeHandleRender: activeHandleRender, draggingIndex: draggingIndex, draggingDelete: draggingDelete, onFocus: onFocus, ...restProps } = props;
    const handlesRef = $5E6i4.useRef({});
    // =========================== Active ===========================
    const [activeVisible, setActiveVisible] = $5E6i4.useState(false);
    const [activeIndex, setActiveIndex] = $5E6i4.useState(-1);
    const onActive = (index)=>{
        setActiveIndex(index);
        setActiveVisible(true);
    };
    const onHandleFocus = (e, index)=>{
        onActive(index);
        onFocus?.(e);
    };
    const onHandleMouseEnter = (e, index)=>{
        onActive(index);
    };
    // =========================== Render ===========================
    $5E6i4.useImperativeHandle(ref, ()=>({
            focus: (index)=>{
                handlesRef.current[index]?.focus();
            },
            hideHelp: ()=>{
                (0, $ibUU1.flushSync)(()=>{
                    setActiveVisible(false);
                });
            }
        }));
    // =========================== Render ===========================
    // Handle Props
    const handleProps = {
        prefixCls: prefixCls,
        onStartMove: onStartMove,
        onOffsetChange: onOffsetChange,
        render: handleRender,
        onFocus: onHandleFocus,
        onMouseEnter: onHandleMouseEnter,
        ...restProps
    };
    return /*#__PURE__*/ $5E6i4.createElement($5E6i4.Fragment, null, values.map((value, index)=>{
        const dragging = draggingIndex === index;
        return /*#__PURE__*/ $5E6i4.createElement((0, $743aa8dccca17144$export$2e2bcd8739ae039), $bdd9ef17f45b64b8$var$_extends({
            ref: (node)=>{
                if (!node) delete handlesRef.current[index];
                else handlesRef.current[index] = node;
            },
            dragging: dragging,
            draggingDelete: dragging && draggingDelete,
            style: (0, $5561a86ac9e01902$export$ddfa24987dade61b)(style, index),
            key: index,
            value: value,
            valueIndex: index
        }, handleProps));
    }), activeHandleRender && activeVisible && /*#__PURE__*/ $5E6i4.createElement((0, $743aa8dccca17144$export$2e2bcd8739ae039), $bdd9ef17f45b64b8$var$_extends({
        key: "a11y"
    }, handleProps, {
        value: values[activeIndex],
        valueIndex: null,
        dragging: draggingIndex !== -1,
        draggingDelete: draggingDelete,
        render: activeHandleRender,
        style: {
            pointerEvents: 'none'
        },
        tabIndex: undefined,
        "aria-hidden": true
    })));
});
var $bdd9ef17f45b64b8$export$2e2bcd8739ae039 = $bdd9ef17f45b64b8$var$Handles;



var $5E6i4 = parcelRequire("5E6i4");


var $5E6i4 = parcelRequire("5E6i4");


const $2657cb05eb44258a$var$Mark = (props)=>{
    const { prefixCls: prefixCls, style: style, children: children, value: value, onClick: onClick } = props;
    const { min: min, max: max, direction: direction, includedStart: includedStart, includedEnd: includedEnd, included: included } = $5E6i4.useContext((0, $ffd145c695cfc287$export$2e2bcd8739ae039));
    const textCls = `${prefixCls}-text`;
    // ============================ Offset ============================
    const positionStyle = (0, $5561a86ac9e01902$export$a41628415415e6e)(direction, value, min, max);
    return /*#__PURE__*/ $5E6i4.createElement("span", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(textCls, {
            [`${textCls}-active`]: included && includedStart <= value && value <= includedEnd
        }),
        style: {
            ...positionStyle,
            ...style
        },
        onMouseDown: (e)=>{
            e.stopPropagation();
        },
        onClick: ()=>{
            onClick(value);
        }
    }, children);
};
var $2657cb05eb44258a$export$2e2bcd8739ae039 = $2657cb05eb44258a$var$Mark;


const $1e8304ebcb5e5845$var$Marks = (props)=>{
    const { prefixCls: prefixCls, marks: marks = [], onClick: onClick } = props;
    const markPrefixCls = `${prefixCls}-mark`;
    // Not render mark if empty
    if (!marks.length) return null;
    return /*#__PURE__*/ $5E6i4.createElement("div", {
        className: markPrefixCls
    }, marks.map(({ value: value, style: style, label: label })=>/*#__PURE__*/ $5E6i4.createElement((0, $2657cb05eb44258a$export$2e2bcd8739ae039), {
            key: value,
            prefixCls: markPrefixCls,
            style: style,
            value: value,
            onClick: onClick
        }, label)));
};
var $1e8304ebcb5e5845$export$2e2bcd8739ae039 = $1e8304ebcb5e5845$var$Marks;



var $5E6i4 = parcelRequire("5E6i4");



var $5E6i4 = parcelRequire("5E6i4");


const $b7603e93bbeda0cf$var$Dot = (props)=>{
    const { prefixCls: prefixCls, value: value, style: style, activeStyle: activeStyle } = props;
    const { min: min, max: max, direction: direction, included: included, includedStart: includedStart, includedEnd: includedEnd } = $5E6i4.useContext((0, $ffd145c695cfc287$export$2e2bcd8739ae039));
    const dotClassName = `${prefixCls}-dot`;
    const active = included && includedStart <= value && value <= includedEnd;
    // ============================ Offset ============================
    let mergedStyle = {
        ...(0, $5561a86ac9e01902$export$a41628415415e6e)(direction, value, min, max),
        ...typeof style === 'function' ? style(value) : style
    };
    if (active) mergedStyle = {
        ...mergedStyle,
        ...typeof activeStyle === 'function' ? activeStyle(value) : activeStyle
    };
    return /*#__PURE__*/ $5E6i4.createElement("span", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(dotClassName, {
            [`${dotClassName}-active`]: active
        }),
        style: mergedStyle
    });
};
var $b7603e93bbeda0cf$export$2e2bcd8739ae039 = $b7603e93bbeda0cf$var$Dot;


const $576ee1b5ad1f065c$var$Steps = (props)=>{
    const { prefixCls: prefixCls, marks: marks, dots: dots, style: style, activeStyle: activeStyle } = props;
    const { min: min, max: max, step: step } = $5E6i4.useContext((0, $ffd145c695cfc287$export$2e2bcd8739ae039));
    const stepDots = $5E6i4.useMemo(()=>{
        const dotSet = new Set();
        // Add marks
        marks.forEach((mark)=>{
            dotSet.add(mark.value);
        });
        // Fill dots
        if (dots && step !== null) {
            let current = min;
            while(current <= max){
                dotSet.add(current);
                current += step;
            }
        }
        return Array.from(dotSet);
    }, [
        min,
        max,
        step,
        dots,
        marks
    ]);
    return /*#__PURE__*/ $5E6i4.createElement("div", {
        className: `${prefixCls}-step`
    }, stepDots.map((dotValue)=>/*#__PURE__*/ $5E6i4.createElement((0, $b7603e93bbeda0cf$export$2e2bcd8739ae039), {
            prefixCls: prefixCls,
            key: dotValue,
            value: dotValue,
            style: style,
            activeStyle: activeStyle
        })));
};
var $576ee1b5ad1f065c$export$2e2bcd8739ae039 = $576ee1b5ad1f065c$var$Steps;




var $5E6i4 = parcelRequire("5E6i4");




var $5E6i4 = parcelRequire("5E6i4");


const $90869c71b2979dee$var$Track = (props)=>{
    const { prefixCls: prefixCls, style: style, start: start, end: end, index: index, onStartMove: onStartMove, replaceCls: replaceCls } = props;
    const { direction: direction, min: min, max: max, disabled: disabled, range: range, classNames: classNames } = $5E6i4.useContext((0, $ffd145c695cfc287$export$2e2bcd8739ae039));
    const trackPrefixCls = `${prefixCls}-track`;
    const offsetStart = (0, $5561a86ac9e01902$export$622cea445a1c5b7d)(start, min, max);
    const offsetEnd = (0, $5561a86ac9e01902$export$622cea445a1c5b7d)(end, min, max);
    // ============================ Events ============================
    const onInternalStartMove = (e)=>{
        if (!disabled && onStartMove) onStartMove(e, -1);
    };
    // ============================ Render ============================
    const positionStyle = {};
    switch(direction){
        case 'rtl':
            positionStyle.right = `${offsetStart * 100}%`;
            positionStyle.width = `${offsetEnd * 100 - offsetStart * 100}%`;
            break;
        case 'btt':
            positionStyle.bottom = `${offsetStart * 100}%`;
            positionStyle.height = `${offsetEnd * 100 - offsetStart * 100}%`;
            break;
        case 'ttb':
            positionStyle.top = `${offsetStart * 100}%`;
            positionStyle.height = `${offsetEnd * 100 - offsetStart * 100}%`;
            break;
        default:
            positionStyle.left = `${offsetStart * 100}%`;
            positionStyle.width = `${offsetEnd * 100 - offsetStart * 100}%`;
    }
    const className = replaceCls || (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(trackPrefixCls, {
        [`${trackPrefixCls}-${index + 1}`]: index !== null && range,
        [`${prefixCls}-track-draggable`]: onStartMove
    }, classNames.track);
    return /*#__PURE__*/ $5E6i4.createElement("div", {
        className: className,
        style: {
            ...positionStyle,
            ...style
        },
        onMouseDown: onInternalStartMove,
        onTouchStart: onInternalStartMove
    });
};
var $90869c71b2979dee$export$2e2bcd8739ae039 = $90869c71b2979dee$var$Track;


const $fae1650a2411504e$var$Tracks = (props)=>{
    const { prefixCls: prefixCls, style: style, values: values, startPoint: startPoint, onStartMove: propsOnStartMove } = props;
    const { included: included, range: range, min: min, styles: styles, classNames: classNames, isHandleDisabled: isHandleDisabled } = $5E6i4.useContext((0, $ffd145c695cfc287$export$2e2bcd8739ae039));
    const hasDisabledHandle = $5E6i4.useMemo(()=>values.some((_, index)=>isHandleDisabled(index)), [
        isHandleDisabled,
        values
    ]);
    const onStartMove = hasDisabledHandle ? undefined : propsOnStartMove;
    // =========================== List ===========================
    const trackList = $5E6i4.useMemo(()=>{
        if (!range) {
            // null value do not have track
            if (values.length === 0) return [];
            const startValue = startPoint ?? min;
            const endValue = values[0];
            return [
                {
                    start: Math.min(startValue, endValue),
                    end: Math.max(startValue, endValue)
                }
            ];
        }
        // Multiple
        const list = [];
        for(let i = 0; i < values.length - 1; i += 1)list.push({
            start: values[i],
            end: values[i + 1]
        });
        return list;
    }, [
        values,
        range,
        startPoint,
        min
    ]);
    if (!included) return null;
    // ========================== Render ==========================
    const tracksNode = trackList?.length && (classNames.tracks || styles.tracks) ? /*#__PURE__*/ $5E6i4.createElement((0, $90869c71b2979dee$export$2e2bcd8739ae039), {
        index: null,
        prefixCls: prefixCls,
        start: trackList[0].start,
        end: trackList[trackList.length - 1].end,
        replaceCls: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(classNames.tracks, `${prefixCls}-tracks`),
        style: styles.tracks
    }) : null;
    return /*#__PURE__*/ $5E6i4.createElement($5E6i4.Fragment, null, tracksNode, trackList.map(({ start: start, end: end }, index)=>/*#__PURE__*/ $5E6i4.createElement((0, $90869c71b2979dee$export$2e2bcd8739ae039), {
            index: index,
            prefixCls: prefixCls,
            style: {
                ...(0, $5561a86ac9e01902$export$ddfa24987dade61b)(style, index),
                ...styles.track
            },
            start: start,
            end: end,
            key: index,
            onStartMove: onStartMove
        })));
};
var $fae1650a2411504e$export$2e2bcd8739ae039 = $fae1650a2411504e$var$Tracks;




var $5E6i4 = parcelRequire("5E6i4");
const $d9f0de39574d0a17$var$useDisabled = (rawDisabled)=>{
    const isHandleDisabled = $5E6i4.useCallback((index)=>{
        if (typeof rawDisabled === 'boolean') return rawDisabled;
        return rawDisabled[index] ?? false;
    }, [
        rawDisabled
    ]);
    const getDisabledState = $5E6i4.useCallback((rawValues)=>{
        if (typeof rawDisabled === 'boolean') return [
            rawDisabled,
            rawDisabled && rawValues.length > 0
        ];
        return [
            rawValues.length > 0 && rawValues.every((_, index)=>isHandleDisabled(index)),
            rawValues.some((_, index)=>isHandleDisabled(index))
        ];
    }, [
        rawDisabled,
        isHandleDisabled
    ]);
    return $5E6i4.useMemo(()=>[
            isHandleDisabled,
            getDisabledState
        ], [
        isHandleDisabled,
        getDisabledState
    ]);
};
var $d9f0de39574d0a17$export$2e2bcd8739ae039 = $d9f0de39574d0a17$var$useDisabled;



var $5E6i4 = parcelRequire("5E6i4");



/** Drag to delete offset. It's a user experience number for dragging out */ const $307af469bdc621c7$var$REMOVE_DIST = 130;
function $307af469bdc621c7$var$getPosition(e) {
    const obj = 'targetTouches' in e ? e.targetTouches[0] : e;
    return {
        pageX: obj.pageX,
        pageY: obj.pageY
    };
}
function $307af469bdc621c7$var$useDrag(containerRef, direction, rawValues, min, max, formatValue, triggerChange, finishChange, offsetValues, editable, minCount, isHandleDisabled) {
    const [draggingValue, setDraggingValue] = $5E6i4.useState(null);
    const [draggingIndex, setDraggingIndex] = $5E6i4.useState(-1);
    const [draggingDelete, setDraggingDelete] = $5E6i4.useState(false);
    const [cacheValues, setCacheValues] = $5E6i4.useState(rawValues);
    const [originValues, setOriginValues] = $5E6i4.useState(rawValues);
    const mouseMoveEventRef = $5E6i4.useRef(null);
    const mouseUpEventRef = $5E6i4.useRef(null);
    const touchEventTargetRef = $5E6i4.useRef(null);
    const { onDragStart: onDragStart, onDragChange: onDragChange } = $5E6i4.useContext((0, $ffd145c695cfc287$export$e508d6f1a100e5dd));
    (0, $518ae471aa4f03a7$export$2e2bcd8739ae039)(()=>{
        if (draggingIndex === -1) setCacheValues(rawValues);
    }, [
        rawValues,
        draggingIndex
    ]);
    // Clean up event
    $5E6i4.useEffect(()=>()=>{
            if (mouseMoveEventRef.current) document.removeEventListener('mousemove', mouseMoveEventRef.current);
            if (mouseUpEventRef.current) document.removeEventListener('mouseup', mouseUpEventRef.current);
            if (touchEventTargetRef.current) {
                if (mouseMoveEventRef.current) touchEventTargetRef.current.removeEventListener('touchmove', mouseMoveEventRef.current);
                if (mouseUpEventRef.current) touchEventTargetRef.current.removeEventListener('touchend', mouseUpEventRef.current);
            }
        }, []);
    const flushValues = (nextValues, nextValue, deleteMark)=>{
        // Perf: Only update state when value changed
        if (nextValue !== undefined) setDraggingValue(nextValue);
        setCacheValues(nextValues);
        let changeValues = nextValues;
        if (deleteMark) changeValues = nextValues.filter((_, i)=>i !== draggingIndex);
        triggerChange(changeValues);
        // Optional callback for drag change (not used in current implementation)
        if (onDragChange) onDragChange({
            rawValues: nextValues,
            deleteIndex: deleteMark ? draggingIndex : -1,
            draggingIndex: draggingIndex,
            draggingValue: nextValue
        });
    };
    const updateCacheValue = (0, $68990f4402d2f009$export$2e2bcd8739ae039)((valueIndex, offsetPercent, deleteMark)=>{
        if (valueIndex === -1) {
            // >>>> Dragging on the track
            // Defensive: should not happen as Tracks/index.tsx blocks this when any handle is disabled
            if (originValues.some((_, index)=>isHandleDisabled(index))) return;
            const startValue = originValues[0];
            const endValue = originValues[originValues.length - 1];
            const maxStartOffset = min - startValue;
            const maxEndOffset = max - endValue;
            // Get valid offset
            let offset = offsetPercent * (max - min);
            offset = Math.max(offset, maxStartOffset);
            offset = Math.min(offset, maxEndOffset);
            // Use first value to revert back of valid offset (like steps marks)
            const formatStartValue = formatValue(startValue + offset);
            offset = formatStartValue - startValue;
            const cloneCacheValues = originValues.map((val)=>val + offset);
            flushValues(cloneCacheValues);
        } else {
            // >>>> Dragging on the handle
            const offsetDist = (max - min) * offsetPercent;
            // Always start with the valueIndex origin value
            const cloneValues = [
                ...cacheValues
            ];
            cloneValues[valueIndex] = originValues[valueIndex];
            const next = offsetValues(cloneValues, offsetDist, valueIndex, 'dist');
            flushValues(next.values, next.value, deleteMark);
        }
    });
    const onStartMove = (e, valueIndex, startValues)=>{
        e.stopPropagation();
        const initialValues = startValues || rawValues;
        // Defensive: should not happen as Handle.tsx blocks this when handle is disabled
        if (isHandleDisabled(valueIndex)) return;
        const originValue = initialValues[valueIndex];
        setDraggingIndex(valueIndex);
        setDraggingValue(originValue);
        setOriginValues(initialValues);
        setCacheValues(initialValues);
        setDraggingDelete(false);
        const { pageX: startX, pageY: startY } = $307af469bdc621c7$var$getPosition(e);
        // We declare it here since closure can't get outer latest value
        let deleteMark = false;
        // Optional callback for drag start (not used in current implementation)
        if (onDragStart) onDragStart({
            rawValues: initialValues,
            draggingIndex: valueIndex,
            draggingValue: originValue
        });
        // Moving
        const onMouseMove = (event)=>{
            event.preventDefault();
            const { pageX: moveX, pageY: moveY } = $307af469bdc621c7$var$getPosition(event);
            const offsetX = moveX - startX;
            const offsetY = moveY - startY;
            const { width: width, height: height } = containerRef.current.getBoundingClientRect();
            let offSetPercent;
            let removeDist;
            switch(direction){
                case 'btt':
                    offSetPercent = -offsetY / height;
                    removeDist = offsetX;
                    break;
                case 'ttb':
                    offSetPercent = offsetY / height;
                    removeDist = offsetX;
                    break;
                case 'rtl':
                    offSetPercent = -offsetX / width;
                    removeDist = offsetY;
                    break;
                default:
                    offSetPercent = offsetX / width;
                    removeDist = offsetY;
            }
            // Check if need mark remove
            deleteMark = editable ? Math.abs(removeDist) > $307af469bdc621c7$var$REMOVE_DIST && minCount < cacheValues.length : false;
            setDraggingDelete(deleteMark);
            updateCacheValue(valueIndex, offSetPercent, deleteMark);
        };
        // End
        const onMouseUp = (event)=>{
            event.preventDefault();
            document.removeEventListener('mouseup', onMouseUp);
            document.removeEventListener('mousemove', onMouseMove);
            if (touchEventTargetRef.current) {
                if (mouseMoveEventRef.current) touchEventTargetRef.current.removeEventListener('touchmove', mouseMoveEventRef.current);
                if (mouseUpEventRef.current) touchEventTargetRef.current.removeEventListener('touchend', mouseUpEventRef.current);
            }
            mouseMoveEventRef.current = null;
            mouseUpEventRef.current = null;
            touchEventTargetRef.current = null;
            finishChange(deleteMark);
            setDraggingIndex(-1);
            setDraggingDelete(false);
        };
        document.addEventListener('mouseup', onMouseUp);
        document.addEventListener('mousemove', onMouseMove);
        e.currentTarget.addEventListener('touchend', onMouseUp);
        e.currentTarget.addEventListener('touchmove', onMouseMove);
        mouseMoveEventRef.current = onMouseMove;
        mouseUpEventRef.current = onMouseUp;
        touchEventTargetRef.current = e.currentTarget;
    };
    // Only return cache value when it mapping with rawValues
    const returnValues = $5E6i4.useMemo(()=>{
        const sourceValues = [
            ...rawValues
        ].sort((a, b)=>a - b);
        const targetValues = [
            ...cacheValues
        ].sort((a, b)=>a - b);
        const counts = {};
        targetValues.forEach((val)=>{
            counts[val] = (counts[val] || 0) + 1;
        });
        sourceValues.forEach((val)=>{
            counts[val] = (counts[val] || 0) - 1;
        });
        const maxDiffCount = editable ? 1 : 0;
        const diffCount = Object.values(counts).reduce((prev, next)=>prev + Math.abs(next), 0);
        return diffCount <= maxDiffCount ? cacheValues : rawValues;
    }, [
        rawValues,
        cacheValues,
        editable
    ]);
    return [
        draggingIndex,
        draggingValue,
        draggingDelete,
        returnValues,
        onStartMove
    ];
}
var $307af469bdc621c7$export$2e2bcd8739ae039 = $307af469bdc621c7$var$useDrag;



var $5E6i4 = parcelRequire("5E6i4");
const $45abc8b0d493b13d$export$205603655568a9fa = (values, valueIndex, min, max, pushable, isHandleDisabled)=>{
    const pushGap = typeof pushable === 'number' ? pushable : 0;
    let minBound = min;
    let maxBound = max;
    for(let i = valueIndex - 1; i >= 0; i -= 1)if (isHandleDisabled(i)) {
        minBound = values[i] + pushGap;
        break;
    }
    for(let i = valueIndex + 1; i < values.length; i += 1)if (isHandleDisabled(i)) {
        maxBound = values[i] - pushGap;
        break;
    }
    return [
        minBound,
        maxBound
    ];
};
const $45abc8b0d493b13d$export$83e80e8c13bf4564 = (values, targetValue, min, max, pushable, isHandleDisabled)=>{
    let closestIndex = -1;
    let closestDist = max - min;
    values.forEach((value, index)=>{
        if (isHandleDisabled(index)) return;
        const [minBound, maxBound] = $45abc8b0d493b13d$export$205603655568a9fa(values, index, min, max, pushable, isHandleDisabled);
        if (minBound <= targetValue && targetValue <= maxBound) {
            const dist = Math.abs(targetValue - value);
            if (dist <= closestDist) {
                closestDist = dist;
                closestIndex = index;
            }
        }
    });
    return closestIndex;
};
function $45abc8b0d493b13d$export$2e2bcd8739ae039(min, max, step, markList, allowCross, pushable, isHandleDisabled) {
    const formatRangeValue = $5E6i4.useCallback((val)=>Math.max(min, Math.min(max, val)), [
        min,
        max
    ]);
    const formatStepValue = $5E6i4.useCallback((val)=>{
        if (step !== null) {
            const stepValue = min + Math.round((formatRangeValue(val) - min) / step) * step;
            // Cut number in case to be like 0.30000000000000004
            const getDecimal = (num)=>(String(num).split('.')[1] || '').length;
            const maxDecimal = Math.max(getDecimal(step), getDecimal(max), getDecimal(min));
            const fixedValue = Number(stepValue.toFixed(maxDecimal));
            return min <= fixedValue && fixedValue <= max ? fixedValue : null;
        }
        return null;
    }, [
        step,
        min,
        max,
        formatRangeValue
    ]);
    const formatValue = $5E6i4.useCallback((val)=>{
        const formatNextValue = formatRangeValue(val);
        // List align values
        const alignValues = markList.map((mark)=>mark.value);
        if (step !== null) alignValues.push(formatStepValue(val));
        // min & max
        alignValues.push(min, max);
        // Align with marks
        let closeValue = alignValues[0];
        let closeDist = max - min;
        alignValues.forEach((alignValue)=>{
            const dist = Math.abs(formatNextValue - alignValue);
            if (dist <= closeDist) {
                closeValue = alignValue;
                closeDist = dist;
            }
        });
        return closeValue;
    }, [
        min,
        max,
        markList,
        step,
        formatRangeValue,
        formatStepValue
    ]);
    // ========================== Offset ==========================
    // Single Value
    const offsetValue = (values, offset, valueIndex, mode = 'unit')=>{
        if (typeof offset === 'number') {
            let nextValue;
            const originValue = values[valueIndex];
            // Only used for `dist` mode
            const targetDistValue = originValue + offset;
            // Compare next step value & mark value which is best match
            let potentialValues = [];
            markList.forEach((mark)=>{
                potentialValues.push(mark.value);
            });
            // Min & Max
            potentialValues.push(min, max);
            // In case origin value is align with mark but not with step
            potentialValues.push(formatStepValue(originValue));
            // Put offset step value also
            const sign = offset > 0 ? 1 : -1;
            if (mode === 'unit') potentialValues.push(formatStepValue(originValue + sign * step));
            else potentialValues.push(formatStepValue(targetDistValue));
            // Find close one
            potentialValues = potentialValues.filter((val)=>val !== null)// Remove reverse value
            .filter((val)=>offset < 0 ? val <= originValue : val >= originValue);
            if (mode === 'unit') // `unit` mode can not contain itself
            potentialValues = potentialValues.filter((val)=>val !== originValue);
            const compareValue = mode === 'unit' ? originValue : targetDistValue;
            nextValue = potentialValues[0];
            let valueDist = Math.abs(nextValue - compareValue);
            potentialValues.forEach((potentialValue)=>{
                const dist = Math.abs(potentialValue - compareValue);
                if (dist < valueDist) {
                    nextValue = potentialValue;
                    valueDist = dist;
                }
            });
            // Out of range will back to range
            if (nextValue === undefined) return offset < 0 ? min : max;
            // `dist` mode
            if (mode === 'dist') return nextValue;
            // `unit` mode may need another round
            if (Math.abs(offset) > 1) {
                const cloneValues = [
                    ...values
                ];
                cloneValues[valueIndex] = nextValue;
                return offsetValue(cloneValues, offset - sign, valueIndex, mode);
            }
            return nextValue;
        } else if (offset === 'min') return min;
        else if (offset === 'max') return max;
        // Unreachable since `offset` is typed as number | 'min' | 'max'.
        return max;
    };
    /** Same as `offsetValue` but return `changed` mark to tell value changed */ const offsetChangedValue = (values, offset, valueIndex, mode = 'unit')=>{
        const originValue = values[valueIndex];
        const nextValue = offsetValue(values, offset, valueIndex, mode);
        return {
            value: nextValue,
            changed: nextValue !== originValue
        };
    };
    const needPush = (dist)=>{
        return pushable === null && dist === 0 || typeof pushable === 'number' && dist < pushable;
    };
    // Values
    const offsetValues = (values, offset, valueIndex, mode = 'unit')=>{
        const nextValues = values.map(formatValue);
        const originValue = nextValues[valueIndex];
        const [minBound, maxBound] = $45abc8b0d493b13d$export$205603655568a9fa(nextValues, valueIndex, min, max, pushable, isHandleDisabled);
        const nextValue = offsetValue(nextValues, offset, valueIndex, mode);
        nextValues[valueIndex] = nextValue;
        if (minBound <= maxBound) nextValues[valueIndex] = Math.max(minBound, Math.min(maxBound, nextValues[valueIndex]));
        else nextValues[valueIndex] = originValue;
        if (allowCross === false) {
            // >>>>> Allow Cross
            const pushNum = pushable || 0;
            // ============ AllowCross ===============
            if (valueIndex > 0 && nextValues[valueIndex - 1] !== originValue) nextValues[valueIndex] = Math.max(nextValues[valueIndex], nextValues[valueIndex - 1] + pushNum);
            if (valueIndex < nextValues.length - 1 && nextValues[valueIndex + 1] !== originValue) nextValues[valueIndex] = Math.min(nextValues[valueIndex], nextValues[valueIndex + 1] - pushNum);
        } else if (typeof pushable === 'number' || pushable === null) {
            // >>>>> Pushable
            // =============== Push ==================
            // >>>>>> Basic push
            // End values
            for(let i = valueIndex + 1; i < nextValues.length; i += 1){
                if (isHandleDisabled(i)) break;
                let changed = true;
                while(needPush(nextValues[i] - nextValues[i - 1]) && changed)({ value: nextValues[i], changed: changed } = offsetChangedValue(nextValues, 1, i));
                const [, itemMaxBound] = $45abc8b0d493b13d$export$205603655568a9fa(nextValues, i, min, max, pushable, isHandleDisabled);
                nextValues[i] = Math.min(nextValues[i], itemMaxBound);
            }
            // Start values
            for(let i = valueIndex; i > 0; i -= 1){
                if (isHandleDisabled(i - 1)) break;
                let changed = true;
                while(needPush(nextValues[i] - nextValues[i - 1]) && changed)({ value: nextValues[i - 1], changed: changed } = offsetChangedValue(nextValues, -1, i - 1));
                const [itemMinBound] = $45abc8b0d493b13d$export$205603655568a9fa(nextValues, i - 1, min, max, pushable, isHandleDisabled);
                nextValues[i - 1] = Math.max(nextValues[i - 1], itemMinBound);
            }
            // >>>>> Revert back to safe push range
            // End to Start
            for(let i = nextValues.length - 1; i > 0; i -= 1){
                if (isHandleDisabled(i) || isHandleDisabled(i - 1)) continue;
                let changed = true;
                while(needPush(nextValues[i] - nextValues[i - 1]) && changed)({ value: nextValues[i - 1], changed: changed } = offsetChangedValue(nextValues, -1, i - 1));
                const [itemMinBound] = $45abc8b0d493b13d$export$205603655568a9fa(nextValues, i - 1, min, max, pushable, isHandleDisabled);
                nextValues[i - 1] = Math.max(nextValues[i - 1], itemMinBound);
            }
            // Start to End
            for(let i = 0; i < nextValues.length - 1; i += 1){
                if (isHandleDisabled(i) || isHandleDisabled(i + 1)) continue;
                let changed = true;
                while(needPush(nextValues[i + 1] - nextValues[i]) && changed)({ value: nextValues[i + 1], changed: changed } = offsetChangedValue(nextValues, 1, i + 1));
                const [, itemMaxBound] = $45abc8b0d493b13d$export$205603655568a9fa(nextValues, i + 1, min, max, pushable, isHandleDisabled);
                nextValues[i + 1] = Math.min(nextValues[i + 1], itemMaxBound);
            }
        }
        return {
            value: nextValues[valueIndex],
            values: nextValues
        };
    };
    return [
        formatValue,
        offsetValues
    ];
}




var $5E6i4 = parcelRequire("5E6i4");
function $d3489ca016efa3a0$export$2e2bcd8739ae039(range) {
    return (0, $5E6i4.useMemo)(()=>{
        if (range === true || !range) return [
            !!range,
            false,
            false,
            0
        ];
        const { editable: editable, draggableTrack: draggableTrack, minCount: minCount, maxCount: maxCount } = range;
        return [
            true,
            !!editable,
            !editable && !!draggableTrack,
            minCount || 0,
            maxCount
        ];
    }, [
        range
    ]);
}


/**
 * New:
 * - click mark to update range value
 * - handleRender
 * - Fix handle with count not correct
 * - Fix pushable not work in some case
 * - No more FindDOMNode
 * - Move all position related style into inline style
 * - Key: up is plus, down is minus
 * - fix Key with step = null not align with marks
 * - Change range should not trigger onChange
 * - keyboard support pushable
 */ const $4ec6a25eb05d360d$var$Slider = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls = 'rc-slider', className: className, style: style, classNames: classNames, styles: styles, id: id, disabled: rawDisabled = false, keyboard: keyboard = true, autoFocus: autoFocus, onFocus: onFocus, onBlur: onBlur, min: // Value
    min = 0, max: max = 100, step: step = 1, value: value, defaultValue: defaultValue, range: range, count: count, onChange: onChange, onBeforeChange: onBeforeChange, onAfterChange: onAfterChange, onChangeComplete: onChangeComplete, allowCross: // Cross
    allowCross = true, pushable: pushable = false, reverse: // Direction
    reverse, vertical: vertical, included: // Style
    included = true, startPoint: startPoint, trackStyle: trackStyle, handleStyle: handleStyle, railStyle: railStyle, dotStyle: dotStyle, activeDotStyle: activeDotStyle, marks: // Decorations
    marks, dots: dots, handleRender: // Components
    handleRender, activeHandleRender: activeHandleRender, track: track, tabIndex: // Accessibility
    tabIndex = 0, ariaLabelForHandle: ariaLabelForHandle, ariaLabelledByForHandle: ariaLabelledByForHandle, ariaRequired: ariaRequired, ariaValueTextFormatterForHandle: ariaValueTextFormatterForHandle } = props;
    const handlesRef = $5E6i4.useRef(null);
    const containerRef = $5E6i4.useRef(null);
    const [mergedValue, setValue] = (0, $e18df22f16a16360$export$2e2bcd8739ae039)(defaultValue, value);
    const direction = $5E6i4.useMemo(()=>{
        if (vertical) return reverse ? 'ttb' : 'btt';
        return reverse ? 'rtl' : 'ltr';
    }, [
        reverse,
        vertical
    ]);
    // ============================ Range =============================
    const [rangeEnabled, rangeEditable, rangeDraggableTrack, minCount, maxCount] = (0, $d3489ca016efa3a0$export$2e2bcd8739ae039)(range);
    const mergedMin = $5E6i4.useMemo(()=>isFinite(min) ? min : 0, [
        min
    ]);
    const mergedMax = $5E6i4.useMemo(()=>isFinite(max) ? max : 100, [
        max
    ]);
    // ============================= Step =============================
    const mergedStep = $5E6i4.useMemo(()=>step !== null && step <= 0 ? 1 : step, [
        step
    ]);
    // ============================= Push =============================
    const mergedPush = $5E6i4.useMemo(()=>{
        if (typeof pushable === 'boolean') return pushable ? mergedStep : false;
        return pushable >= 0 ? pushable : false;
    }, [
        pushable,
        mergedStep
    ]);
    // ============================ Marks =============================
    const markList = $5E6i4.useMemo(()=>{
        const markRecord = marks || {};
        return Object.keys(markRecord).map((key)=>{
            const mark = markRecord[key];
            const markObj = {
                value: Number(key)
            };
            if (mark && typeof mark === 'object' && !/*#__PURE__*/ $5E6i4.isValidElement(mark) && ('label' in mark || 'style' in mark)) {
                markObj.style = mark.style;
                markObj.label = mark.label;
            } else markObj.label = mark;
            return markObj;
        }).filter(({ label: label })=>label || typeof label === 'number').sort((a, b)=>a.value - b.value);
    }, [
        marks
    ]);
    // ============================ Disabled ============================
    const [isHandleDisabled, getDisabledState] = (0, $d9f0de39574d0a17$export$2e2bcd8739ae039)(rawDisabled);
    // ============================ Format ============================
    const [formatValue, offsetValues] = (0, $45abc8b0d493b13d$export$2e2bcd8739ae039)(mergedMin, mergedMax, mergedStep, markList, allowCross, mergedPush, isHandleDisabled);
    // ============================ Values ============================
    const rawValues = $5E6i4.useMemo(()=>{
        const valueList = mergedValue === null || mergedValue === undefined ? [] : Array.isArray(mergedValue) ? mergedValue : [
            mergedValue
        ];
        const [val0 = mergedMin] = valueList;
        let returnValues = mergedValue === null ? [] : [
            val0
        ];
        // Format as range
        if (rangeEnabled) {
            returnValues = [
                ...valueList
            ];
            // When count provided or value is `undefined`, we fill values
            if (count || mergedValue === undefined) {
                const pointCount = count !== undefined && count >= 0 ? count + 1 : 2;
                returnValues = returnValues.slice(0, pointCount);
                // Fill with count
                while(returnValues.length < pointCount)returnValues.push(returnValues[returnValues.length - 1] ?? mergedMin);
            }
            returnValues.sort((a, b)=>a - b);
        }
        // Align in range
        returnValues.forEach((val, index)=>{
            returnValues[index] = formatValue(val);
        });
        return returnValues;
    }, [
        mergedValue,
        rangeEnabled,
        mergedMin,
        count,
        formatValue
    ]);
    const [disabled, hasDisabledHandle] = $5E6i4.useMemo(()=>getDisabledState(rawValues), [
        getDisabledState,
        rawValues
    ]);
    const effectiveRangeEditable = rangeEditable && !hasDisabledHandle;
    // =========================== onChange ===========================
    const getTriggerValue = (triggerValues)=>rangeEnabled ? triggerValues : triggerValues[0];
    const triggerChange = (0, $68990f4402d2f009$export$2e2bcd8739ae039)((nextValues)=>{
        // Order first
        const cloneNextValues = [
            ...nextValues
        ].sort((a, b)=>a - b);
        // Trigger event if needed
        if (onChange && !(0, $f9cb347037ae4280$export$2e2bcd8739ae039)(cloneNextValues, rawValues, true)) onChange(getTriggerValue(cloneNextValues));
        // We set this later since it will re-render component immediately
        setValue(cloneNextValues);
    });
    const finishChange = (0, $68990f4402d2f009$export$2e2bcd8739ae039)((draggingDelete)=>{
        // Trigger from `useDrag` will tell if it's a delete action
        if (draggingDelete) handlesRef.current.hideHelp();
        const finishValue = getTriggerValue(rawValues);
        onAfterChange?.(finishValue);
        (0, $f757b9ac02fa080d$export$2e2bcd8739ae039)(!onAfterChange, '[rc-slider] `onAfterChange` is deprecated. Please use `onChangeComplete` instead.');
        onChangeComplete?.(finishValue);
    });
    const onDelete = (index)=>{
        if (disabled || !effectiveRangeEditable || rawValues.length <= minCount) return;
        const cloneNextValues = [
            ...rawValues
        ];
        cloneNextValues.splice(index, 1);
        onBeforeChange?.(getTriggerValue(cloneNextValues));
        triggerChange(cloneNextValues);
        const nextFocusIndex = Math.max(0, index - 1);
        handlesRef.current.hideHelp();
        handlesRef.current.focus(nextFocusIndex);
    };
    const [draggingIndex, draggingValue, draggingDelete, cacheValues, onStartDrag] = (0, $307af469bdc621c7$export$2e2bcd8739ae039)(containerRef, direction, rawValues, mergedMin, mergedMax, formatValue, triggerChange, finishChange, offsetValues, effectiveRangeEditable, minCount, isHandleDisabled);
    /**
   * When `rangeEditable` will insert a new value in the values array.
   * Else it will replace the value in the values array.
   */ const changeToCloseValue = (newValue, e)=>{
        if (!disabled) {
            const valueIndex = rawValues.length ? (0, $45abc8b0d493b13d$export$83e80e8c13bf4564)(rawValues, newValue, mergedMin, mergedMax, mergedPush, isHandleDisabled) : 0;
            if (valueIndex === -1) return;
            // Create new values
            const cloneNextValues = [
                ...rawValues
            ];
            let valueBeforeIndex = 0; // Record the index which value < newValue
            const valueDist = rawValues.length ? Math.abs(newValue - rawValues[valueIndex]) : mergedMax - mergedMin;
            rawValues.forEach((val, index)=>{
                if (val < newValue) valueBeforeIndex = index;
            });
            let focusIndex = valueIndex;
            if (effectiveRangeEditable && valueDist !== 0 && (!maxCount || rawValues.length < maxCount)) {
                cloneNextValues.splice(valueBeforeIndex + 1, 0, newValue);
                focusIndex = valueBeforeIndex + 1;
            } else {
                cloneNextValues[valueIndex] = newValue;
                focusIndex = valueIndex;
            }
            // Fill value to match default 2 (only when `rawValues` is empty)
            if (rangeEnabled && !rawValues.length && count === undefined) cloneNextValues.push(newValue);
            const nextValue = getTriggerValue(cloneNextValues);
            onBeforeChange?.(nextValue);
            triggerChange(cloneNextValues);
            if (e) {
                document.activeElement?.blur?.();
                handlesRef.current.focus(focusIndex);
                onStartDrag(e, focusIndex, cloneNextValues);
            } else {
                // https://github.com/ant-design/ant-design/issues/49997
                onAfterChange?.(nextValue);
                (0, $f757b9ac02fa080d$export$2e2bcd8739ae039)(!onAfterChange, '[rc-slider] `onAfterChange` is deprecated. Please use `onChangeComplete` instead.');
                onChangeComplete?.(nextValue);
            }
        }
    };
    // ============================ Click =============================
    const onSliderMouseDown = (e)=>{
        e.preventDefault();
        const { width: width, height: height, left: left, top: top, bottom: bottom, right: right } = containerRef.current.getBoundingClientRect();
        const { clientX: clientX, clientY: clientY } = e;
        let percent;
        switch(direction){
            case 'btt':
                percent = (bottom - clientY) / height;
                break;
            case 'ttb':
                percent = (clientY - top) / height;
                break;
            case 'rtl':
                percent = (right - clientX) / width;
                break;
            default:
                percent = (clientX - left) / width;
        }
        const nextValue = mergedMin + percent * (mergedMax - mergedMin);
        changeToCloseValue(formatValue(nextValue), e);
    };
    // =========================== Keyboard ===========================
    const [keyboardValue, setKeyboardValue] = $5E6i4.useState(null);
    const onHandleOffsetChange = (offset, valueIndex)=>{
        if (!disabled && !isHandleDisabled(valueIndex)) {
            const next = offsetValues(rawValues, offset, valueIndex);
            onBeforeChange?.(getTriggerValue(rawValues));
            triggerChange(next.values);
            setKeyboardValue({
                value: next.value,
                index: valueIndex
            });
        }
    };
    $5E6i4.useEffect(()=>{
        if (keyboardValue !== null) {
            const { value: nextKeyboardValue, index: index } = keyboardValue;
            const valueIndex = rawValues[index] === nextKeyboardValue ? index : rawValues.indexOf(nextKeyboardValue);
            if (valueIndex >= 0) handlesRef.current.focus(valueIndex);
        }
        setKeyboardValue(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        keyboardValue
    ]);
    // ============================= Drag =============================
    const mergedDraggableTrack = $5E6i4.useMemo(()=>{
        if (rangeDraggableTrack && mergedStep === null) return false;
        return rangeDraggableTrack;
    }, [
        rangeDraggableTrack,
        mergedStep
    ]);
    const onStartMove = (0, $68990f4402d2f009$export$2e2bcd8739ae039)((e, valueIndex)=>{
        onStartDrag(e, valueIndex);
        onBeforeChange?.(getTriggerValue(rawValues));
    });
    // Auto focus for updated handle
    const dragging = draggingIndex !== -1;
    $5E6i4.useEffect(()=>{
        if (!dragging) {
            const valueIndex = rawValues.lastIndexOf(draggingValue);
            handlesRef.current.focus(valueIndex);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dragging
    ]);
    // =========================== Included ===========================
    const sortedCacheValues = $5E6i4.useMemo(()=>[
            ...cacheValues
        ].sort((a, b)=>a - b), [
        cacheValues
    ]);
    // Provide a range values with included [min, max]
    // Used for Track, Mark & Dot
    const [includedStart, includedEnd] = $5E6i4.useMemo(()=>{
        if (!rangeEnabled) return [
            mergedMin,
            sortedCacheValues[0]
        ];
        return [
            sortedCacheValues[0],
            sortedCacheValues[sortedCacheValues.length - 1]
        ];
    }, [
        sortedCacheValues,
        rangeEnabled,
        mergedMin
    ]);
    // ============================= Refs =============================
    $5E6i4.useImperativeHandle(ref, ()=>({
            focus: ()=>{
                handlesRef.current.focus(0);
            },
            blur: ()=>{
                const { activeElement: activeElement } = document;
                if (containerRef.current?.contains(activeElement)) activeElement?.blur();
            }
        }));
    // ========================== Auto Focus ==========================
    const autoFocusRef = $5E6i4.useRef(autoFocus);
    $5E6i4.useEffect(()=>{
        if (autoFocusRef.current) handlesRef.current.focus(0);
    }, []);
    // =========================== Context ============================
    const context = $5E6i4.useMemo(()=>({
            min: mergedMin,
            max: mergedMax,
            direction: direction,
            disabled: disabled,
            keyboard: keyboard,
            step: mergedStep,
            included: included,
            includedStart: includedStart,
            includedEnd: includedEnd,
            range: rangeEnabled,
            tabIndex: tabIndex,
            ariaLabelForHandle: ariaLabelForHandle,
            ariaLabelledByForHandle: ariaLabelledByForHandle,
            ariaRequired: ariaRequired,
            ariaValueTextFormatterForHandle: ariaValueTextFormatterForHandle,
            styles: styles || {},
            classNames: classNames || {},
            isHandleDisabled: isHandleDisabled
        }), [
        mergedMin,
        mergedMax,
        direction,
        disabled,
        keyboard,
        mergedStep,
        included,
        includedStart,
        includedEnd,
        rangeEnabled,
        tabIndex,
        ariaLabelForHandle,
        ariaLabelledByForHandle,
        ariaRequired,
        ariaValueTextFormatterForHandle,
        styles,
        classNames,
        isHandleDisabled
    ]);
    // ============================ Render ============================
    return /*#__PURE__*/ $5E6i4.createElement((0, $ffd145c695cfc287$export$2e2bcd8739ae039).Provider, {
        value: context
    }, /*#__PURE__*/ $5E6i4.createElement("div", {
        ref: containerRef,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, className, {
            [`${prefixCls}-disabled`]: disabled,
            [`${prefixCls}-vertical`]: vertical,
            [`${prefixCls}-horizontal`]: !vertical,
            [`${prefixCls}-with-marks`]: markList.length
        }),
        style: style,
        onMouseDown: onSliderMouseDown,
        id: id
    }, /*#__PURE__*/ $5E6i4.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-rail`, classNames?.rail),
        style: {
            ...railStyle,
            ...styles?.rail
        }
    }), track !== false && /*#__PURE__*/ $5E6i4.createElement((0, $fae1650a2411504e$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        style: trackStyle,
        values: rawValues,
        startPoint: startPoint,
        onStartMove: mergedDraggableTrack ? onStartMove : undefined
    }), /*#__PURE__*/ $5E6i4.createElement((0, $576ee1b5ad1f065c$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        marks: markList,
        dots: dots,
        style: dotStyle,
        activeStyle: activeDotStyle
    }), /*#__PURE__*/ $5E6i4.createElement((0, $bdd9ef17f45b64b8$export$2e2bcd8739ae039), {
        ref: handlesRef,
        prefixCls: prefixCls,
        style: handleStyle,
        values: cacheValues,
        draggingIndex: draggingIndex,
        draggingDelete: draggingDelete,
        onStartMove: onStartMove,
        onOffsetChange: onHandleOffsetChange,
        onFocus: onFocus,
        onBlur: onBlur,
        handleRender: handleRender,
        activeHandleRender: activeHandleRender,
        onChangeComplete: finishChange,
        onDelete: effectiveRangeEditable ? onDelete : undefined
    }), /*#__PURE__*/ $5E6i4.createElement((0, $1e8304ebcb5e5845$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        marks: markList,
        onClick: changeToCloseValue
    })));
});
var $4ec6a25eb05d360d$export$2e2bcd8739ae039 = $4ec6a25eb05d360d$var$Slider;



var $d583be797c5dfc28$export$2e2bcd8739ae039 = (0, $4ec6a25eb05d360d$export$2e2bcd8739ae039);











var $5E6i4 = parcelRequire("5E6i4");
/** @private Internal context. Do not use in your production. */ const $8d950bc97ea25604$var$SliderInternalContext = /*#__PURE__*/ (0, $5E6i4.createContext)({});
var $8d950bc97ea25604$export$2e2bcd8739ae039 = $8d950bc97ea25604$var$SliderInternalContext;



var $5E6i4 = parcelRequire("5E6i4");


"use client";
const $5ddabdb2a5cda8bc$var$SliderTooltip = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { open: open, draggingDelete: draggingDelete, value: value } = props;
    const innerRef = (0, $5E6i4.useRef)(null);
    const mergedOpen = open && !draggingDelete;
    const rafRef = (0, $5E6i4.useRef)(null);
    function cancelKeepAlign() {
        (0, $1d949665862f071a$export$2e2bcd8739ae039).cancel(rafRef.current);
        rafRef.current = null;
    }
    function keepAlign() {
        rafRef.current = (0, $1d949665862f071a$export$2e2bcd8739ae039)(()=>{
            innerRef.current?.forceAlign();
            rafRef.current = null;
        });
    }
    $5E6i4.useEffect(()=>{
        if (mergedOpen) keepAlign();
        else cancelKeepAlign();
        return cancelKeepAlign;
    }, [
        mergedOpen,
        props.title,
        value
    ]);
    return /*#__PURE__*/ $5E6i4.createElement((0, $1bb718ecb5669b36$export$2e2bcd8739ae039), {
        ref: (0, $92c8c75386168ffc$export$ab452c34e8e05029)(innerRef, ref),
        ...props,
        open: mergedOpen
    });
});
var $5ddabdb2a5cda8bc$export$2e2bcd8739ae039 = $5ddabdb2a5cda8bc$var$SliderTooltip;






// =============================== Base ===============================
const $b0121261e9bc0850$var$genBaseStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls, controlSize: controlSize, dotSize: dotSize, marginFull: marginFull, marginPart: marginPart, colorFillContentHover: colorFillContentHover, handleColorDisabled: handleColorDisabled, calc: calc, handleSize: handleSize, handleSizeHover: handleSizeHover, handleActiveColor: handleActiveColor, handleActiveOutlineColor: handleActiveOutlineColor, handleLineWidth: handleLineWidth, handleLineWidthHover: handleLineWidthHover, motionDurationMid: motionDurationMid } = token;
    const disabledHandle = {
        backgroundColor: token.colorBgElevated,
        cursor: 'not-allowed',
        width: handleSize,
        height: handleSize,
        boxShadow: `0 0 0 ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(handleLineWidth)} ${handleColorDisabled}`,
        insetInlineStart: 0,
        insetBlockStart: 0
    };
    return {
        [componentCls]: {
            ...(0, $cd5a520fee8002b4$export$23997c3e44cc1c59)(token),
            position: 'relative',
            height: controlSize,
            margin: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(marginPart)} ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(marginFull)}`,
            padding: 0,
            cursor: 'pointer',
            touchAction: 'none',
            // https://github.com/ant-design/ant-design/issues/55686
            // Prevent text selection on adjacent content when dragging the handle in Safari.
            userSelect: 'none',
            '&-vertical': {
                margin: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(marginFull)} ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(marginPart)}`
            },
            [`${componentCls}-rail`]: {
                position: 'absolute',
                backgroundColor: token.railBg,
                borderRadius: token.borderRadiusXS,
                transition: `background-color ${motionDurationMid}`
            },
            [`${componentCls}-track,${componentCls}-tracks`]: {
                position: 'absolute',
                transition: `background-color ${motionDurationMid}`
            },
            [`${componentCls}-track`]: {
                backgroundColor: token.trackBg,
                borderRadius: token.borderRadiusXS
            },
            [`${componentCls}-track-draggable`]: {
                boxSizing: 'content-box',
                backgroundClip: 'content-box',
                border: 'solid rgba(0,0,0,0)'
            },
            '&:hover': {
                [`${componentCls}-rail`]: {
                    backgroundColor: token.railHoverBg
                },
                [`${componentCls}-track`]: {
                    backgroundColor: token.trackHoverBg
                },
                [`${componentCls}-dot`]: {
                    borderColor: colorFillContentHover
                },
                [`${componentCls}-handle:not(${componentCls}-handle-disabled)::after`]: {
                    boxShadow: `0 0 0 ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(handleLineWidth)} ${token.colorPrimaryBorderHover}`
                },
                [`${componentCls}-dot-active`]: {
                    borderColor: token.dotActiveBorderColor
                }
            },
            [`${componentCls}-handle`]: {
                position: 'absolute',
                width: handleSize,
                height: handleSize,
                outline: 'none',
                userSelect: 'none',
                // Dragging status
                '&-dragging-delete': {
                    opacity: 0
                },
                // 扩大选区
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    insetInlineStart: calc(handleLineWidth).mul(-1).equal(),
                    insetBlockStart: calc(handleLineWidth).mul(-1).equal(),
                    width: calc(handleSize).add(calc(handleLineWidth).mul(2)).equal(),
                    height: calc(handleSize).add(calc(handleLineWidth).mul(2)).equal(),
                    backgroundColor: 'transparent'
                },
                '&::after': {
                    content: '""',
                    position: 'absolute',
                    insetBlockStart: 0,
                    insetInlineStart: 0,
                    width: handleSize,
                    height: handleSize,
                    backgroundColor: token.colorBgElevated,
                    boxShadow: `0 0 0 ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(handleLineWidth)} ${token.handleColor}`,
                    outline: `0px solid transparent`,
                    borderRadius: '50%',
                    cursor: 'pointer',
                    transition: [
                        'inset-inline-start',
                        'inset-block-start',
                        'width',
                        'height',
                        'box-shadow',
                        'outline'
                    ].map((prop)=>`${prop} ${motionDurationMid}`).join(', ')
                },
                '&:hover, &:active, &:focus': {
                    [`&:not(${componentCls}-handle-disabled)::before`]: {
                        insetInlineStart: calc(handleSizeHover).sub(handleSize).div(2).add(handleLineWidthHover).mul(-1).equal(),
                        insetBlockStart: calc(handleSizeHover).sub(handleSize).div(2).add(handleLineWidthHover).mul(-1).equal(),
                        width: calc(handleSizeHover).add(calc(handleLineWidthHover).mul(2)).equal(),
                        height: calc(handleSizeHover).add(calc(handleLineWidthHover).mul(2)).equal()
                    },
                    [`&:not(${componentCls}-handle-disabled)::after`]: {
                        boxShadow: `0 0 0 ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(handleLineWidthHover)} ${handleActiveColor}`,
                        outline: `6px solid ${handleActiveOutlineColor}`,
                        width: handleSizeHover,
                        height: handleSizeHover,
                        insetInlineStart: token.calc(handleSize).sub(handleSizeHover).div(2).equal(),
                        insetBlockStart: token.calc(handleSize).sub(handleSizeHover).div(2).equal()
                    }
                }
            },
            [`&-lock ${componentCls}-handle`]: {
                '&::before, &::after': {
                    transition: 'none'
                }
            },
            [`${componentCls}-mark`]: {
                position: 'absolute',
                fontSize: token.fontSize
            },
            [`${componentCls}-mark-text`]: {
                position: 'absolute',
                display: 'inline-block',
                color: token.colorTextDescription,
                textAlign: 'center',
                wordBreak: 'keep-all',
                cursor: 'pointer',
                userSelect: 'none',
                '&-active': {
                    color: token.colorText
                }
            },
            [`${componentCls}-step`]: {
                position: 'absolute',
                background: 'transparent',
                pointerEvents: 'none'
            },
            [`${componentCls}-dot`]: {
                position: 'absolute',
                width: dotSize,
                height: dotSize,
                backgroundColor: token.colorBgElevated,
                border: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(handleLineWidth)} solid ${token.dotBorderColor}`,
                borderRadius: '50%',
                cursor: 'pointer',
                transition: `border-color ${token.motionDurationSlow}`,
                pointerEvents: 'auto',
                '&-active': {
                    borderColor: token.dotActiveBorderColor
                }
            },
            [`&${componentCls}-disabled`]: {
                cursor: 'not-allowed',
                [`${componentCls}-rail`]: {
                    backgroundColor: `${token.railBg} !important`
                },
                [`${componentCls}-track`]: {
                    backgroundColor: `${token.trackBgDisabled} !important`
                },
                [`
          ${componentCls}-dot
        `]: {
                    backgroundColor: token.colorBgElevated,
                    borderColor: token.trackBgDisabled,
                    boxShadow: 'none',
                    cursor: 'not-allowed'
                },
                [`${componentCls}-handle::after`]: {
                    ...disabledHandle
                },
                [`
          ${componentCls}-mark-text,
          ${componentCls}-dot
        `]: {
                    cursor: `not-allowed !important`
                }
            },
            [`${componentCls}-handle-disabled::after`]: {
                ...disabledHandle
            },
            [`&-tooltip ${antCls}-tooltip-container`]: {
                minWidth: 'unset'
            }
        }
    };
};
// ============================ Horizontal ============================
const $b0121261e9bc0850$var$genDirectionStyle = (token, horizontal)=>{
    const { componentCls: componentCls, railSize: railSize, handleSize: handleSize, dotSize: dotSize, marginFull: marginFull, calc: calc } = token;
    const railPadding = horizontal ? 'paddingBlock' : 'paddingInline';
    const full = horizontal ? 'width' : 'height';
    const part = horizontal ? 'height' : 'width';
    const handlePos = horizontal ? 'insetBlockStart' : 'insetInlineStart';
    const markInset = horizontal ? 'top' : 'insetInlineStart';
    const handlePosSize = calc(railSize).mul(3).sub(handleSize).div(2).equal();
    const draggableBorderSize = calc(handleSize).sub(railSize).div(2).equal();
    const draggableBorder = horizontal ? {
        borderWidth: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(draggableBorderSize)} 0`,
        transform: `translateY(${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(calc(draggableBorderSize).mul(-1).equal())})`
    } : {
        borderWidth: `0 ${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(draggableBorderSize)}`,
        transform: `translateX(${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.calc(draggableBorderSize).mul(-1).equal())})`
    };
    return {
        [railPadding]: railSize,
        [part]: calc(railSize).mul(3).equal(),
        [`${componentCls}-rail`]: {
            [full]: '100%',
            [part]: railSize
        },
        [`${componentCls}-track,${componentCls}-tracks`]: {
            [part]: railSize
        },
        [`${componentCls}-track-draggable`]: {
            ...draggableBorder
        },
        [`${componentCls}-handle`]: {
            [handlePos]: handlePosSize
        },
        [`${componentCls}-mark`]: {
            // Reset all
            insetInlineStart: 0,
            top: 0,
            // https://github.com/ant-design/ant-design/issues/43731
            [markInset]: calc(railSize).mul(3).add(horizontal ? 0 : marginFull).equal(),
            [full]: '100%'
        },
        [`${componentCls}-step`]: {
            // Reset all
            insetInlineStart: 0,
            top: 0,
            [markInset]: railSize,
            [full]: '100%',
            [part]: railSize
        },
        [`${componentCls}-dot`]: {
            position: 'absolute',
            [handlePos]: calc(railSize).sub(dotSize).div(2).equal()
        }
    };
};
// ============================ Horizontal ============================
const $b0121261e9bc0850$var$genHorizontalStyle = (token)=>{
    const { componentCls: componentCls, marginPartWithMark: marginPartWithMark } = token;
    return {
        [`${componentCls}-horizontal`]: {
            ...$b0121261e9bc0850$var$genDirectionStyle(token, true),
            [`&${componentCls}-with-marks`]: {
                marginBottom: marginPartWithMark
            }
        }
    };
};
// ============================= Vertical =============================
const $b0121261e9bc0850$var$genVerticalStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-vertical`]: {
            ...$b0121261e9bc0850$var$genDirectionStyle(token, false),
            height: '100%'
        }
    };
};
const $b0121261e9bc0850$export$9ca1be8807fe0675 = (token)=>{
    // Handle line width is always width-er 1px
    const increaseHandleWidth = 1;
    const controlSize = token.controlHeightLG / 4;
    const controlSizeHover = token.controlHeightSM / 2;
    const handleLineWidth = token.lineWidth + increaseHandleWidth;
    const handleLineWidthHover = token.lineWidth + increaseHandleWidth * 1.5;
    const handleActiveColor = token.colorPrimary;
    const handleActiveOutlineColor = new (0, $1b0a692e36565107$export$2c4f38d6c0ecc25a)(handleActiveColor).setA(0.2).toRgbString();
    return {
        controlSize: controlSize,
        railSize: 4,
        handleSize: controlSize,
        handleSizeHover: controlSizeHover,
        dotSize: 8,
        handleLineWidth: handleLineWidth,
        handleLineWidthHover: handleLineWidthHover,
        railBg: token.colorFillTertiary,
        railHoverBg: token.colorFillSecondary,
        trackBg: token.colorPrimaryBorder,
        trackHoverBg: token.colorPrimaryBorderHover,
        handleColor: token.colorPrimaryBorder,
        handleActiveColor: handleActiveColor,
        handleActiveOutlineColor: handleActiveOutlineColor,
        handleColorDisabled: new (0, $1b0a692e36565107$export$2c4f38d6c0ecc25a)(token.colorTextDisabled).onBackground(token.colorBgContainer).toHexString(),
        dotBorderColor: token.colorBorderSecondary,
        dotActiveBorderColor: token.colorPrimaryBorder,
        trackBgDisabled: token.colorBgContainerDisabled
    };
};
var $b0121261e9bc0850$export$2e2bcd8739ae039 = (0, $761caadb5301aee1$export$51ec95de45185b42)('Slider', (token)=>{
    const sliderToken = (0, $f564548c7b6877d5$export$4950aa0f605343fb)(token, {
        marginPart: token.calc(token.controlHeight).sub(token.controlSize).div(2).equal(),
        marginFull: token.calc(token.controlSize).div(2).equal(),
        marginPartWithMark: token.calc(token.controlHeightLG).sub(token.controlSize).equal()
    });
    return [
        $b0121261e9bc0850$var$genBaseStyle(sliderToken),
        $b0121261e9bc0850$var$genHorizontalStyle(sliderToken),
        $b0121261e9bc0850$var$genVerticalStyle(sliderToken)
    ];
}, $b0121261e9bc0850$export$9ca1be8807fe0675);


"use client";
function $e720e40d3dabd8a5$var$getTipFormatter(tipFormatter) {
    if (tipFormatter || tipFormatter === null) return tipFormatter;
    return (val)=>(0, $addbc2fddcbb77a9$export$7e4aa119212bc614)(val) ? val.toString() : '';
}
const $e720e40d3dabd8a5$var$Slider = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, range: range, className: className, rootClassName: rootClassName, style: style, disabled: disabled, tooltip: // Deprecated Props
    tooltip = {}, onChangeComplete: onChangeComplete, classNames: classNames, styles: styles, vertical: vertical, orientation: orientation, ...restProps } = props;
    const [, mergedVertical] = (0, $a77e455e2dd6afec$export$550084c67147f6c4)(orientation, vertical);
    const { getPrefixCls: getPrefixCls, direction: contextDirection, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles, getPopupContainer: getPopupContainer } = (0, $519f2fad435b3034$export$46f4bd6436a25a31)('slider');
    const contextDisabled = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useContext((0, $2ab14018ea5b2d79$export$2e2bcd8739ae039));
    const mergedDisabled = disabled ?? contextDisabled;
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        disabled: mergedDisabled,
        vertical: mergedVertical
    };
    const contextStyleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $722c8632ba7bdb89$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    });
    // ============================= Context ==============================
    const { handleRender: contextHandleRender, direction: internalContextDirection } = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useContext((0, $8d950bc97ea25604$export$2e2bcd8739ae039));
    const mergedDirection = internalContextDirection || contextDirection;
    const isRTL = mergedDirection === 'rtl';
    // =============================== Open ===============================
    const [hoverOpen, setHoverOpen] = (0, $2114fb66f76f632e$export$2e2bcd8739ae039)(false);
    const [focusOpen, setFocusOpen] = (0, $2114fb66f76f632e$export$2e2bcd8739ae039)(false);
    const tooltipProps = {
        ...tooltip
    };
    const { open: tooltipOpen, placement: tooltipPlacement, getPopupContainer: getTooltipPopupContainer, prefixCls: customizeTooltipPrefixCls, formatter: tipFormatter } = tooltipProps;
    const lockOpen = tooltipOpen;
    const activeOpen = (hoverOpen || focusOpen) && lockOpen !== false;
    const mergedTipFormatter = $e720e40d3dabd8a5$var$getTipFormatter(tipFormatter);
    // ============================= Change ==============================
    const [dragging, setDragging] = (0, $2114fb66f76f632e$export$2e2bcd8739ae039)(false);
    const onInternalChangeComplete = (nextValues)=>{
        onChangeComplete?.(nextValues);
        setDragging(false);
    };
    // ============================ Placement ============================
    const getTooltipPlacement = (placement, vert)=>{
        if (placement) return placement;
        if (!vert) return 'top';
        return isRTL ? 'left' : 'right';
    };
    // ============================== Style ===============================
    const prefixCls = getPrefixCls('slider', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $b0121261e9bc0850$export$2e2bcd8739ae039)(prefixCls);
    const rootClassNames = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(className, contextClassName, mergedClassNames.root, rootClassName, {
        [`${prefixCls}-rtl`]: isRTL,
        [`${prefixCls}-lock`]: dragging
    }, hashId, cssVarCls);
    // make reverse default on rtl direction
    if (isRTL && !mergedVertical) restProps.reverse = !restProps.reverse;
    var deprecatedName, newName;
    // ============================== Handle ==============================
    (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useEffect(()=>{
        const onMouseUp = ()=>{
            // Delay for 1 frame to make the click to enable hide tooltip
            // even when the handle is focused
            (0, $1d949665862f071a$export$2e2bcd8739ae039)(()=>{
                setFocusOpen(false);
            }, 1);
        };
        document.addEventListener('mouseup', onMouseUp);
        return ()=>{
            document.removeEventListener('mouseup', onMouseUp);
        };
    }, []);
    const useActiveTooltipHandle = range && !lockOpen;
    const handleRender = contextHandleRender || ((node, info)=>{
        const { index: index } = info;
        const nodeProps = node.props;
        function proxyEvent(eventName, event) {
            nodeProps[eventName]?.(event);
        }
        const passedProps = {
            ...nodeProps,
            onMouseEnter: (e)=>{
                setHoverOpen(true, true);
                proxyEvent('onMouseEnter', e);
            },
            onMouseLeave: (e)=>{
                setHoverOpen(false);
                proxyEvent('onMouseLeave', e);
            },
            onMouseDown: (e)=>{
                setFocusOpen(true, true);
                setDragging(true, true);
                proxyEvent('onMouseDown', e);
            },
            onFocus: (e)=>{
                setFocusOpen(true, true);
                proxyEvent('onFocus', e);
            },
            onBlur: (e)=>{
                setFocusOpen(false);
                proxyEvent('onBlur', e);
            }
        };
        const cloneNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).cloneElement(node, passedProps);
        const open = (!!lockOpen || activeOpen) && mergedTipFormatter !== null;
        // Wrap on handle with Tooltip when is single mode or multiple with all show tooltip
        if (!useActiveTooltipHandle) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $5ddabdb2a5cda8bc$export$2e2bcd8739ae039), {
            ...tooltipProps,
            prefixCls: getPrefixCls('tooltip', customizeTooltipPrefixCls),
            title: mergedTipFormatter ? mergedTipFormatter(info.value) : undefined,
            value: info.value,
            open: open,
            placement: getTooltipPlacement(tooltipPlacement, mergedVertical),
            key: index,
            classNames: {
                root: `${prefixCls}-tooltip`
            },
            getPopupContainer: getTooltipPopupContainer || getPopupContainer
        }, cloneNode);
        return cloneNode;
    });
    // ========================== Active Handle ===========================
    const activeHandleRender = useActiveTooltipHandle ? (handle, info)=>{
        const cloneNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).cloneElement(handle, {
            style: {
                ...handle.props.style,
                visibility: 'hidden'
            }
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $5ddabdb2a5cda8bc$export$2e2bcd8739ae039), {
            ...tooltipProps,
            prefixCls: getPrefixCls('tooltip', customizeTooltipPrefixCls),
            title: mergedTipFormatter ? mergedTipFormatter(info.value) : undefined,
            open: mergedTipFormatter !== null && activeOpen,
            placement: getTooltipPlacement(tooltipPlacement, mergedVertical),
            key: "tooltip",
            classNames: {
                root: `${prefixCls}-tooltip`
            },
            getPopupContainer: getTooltipPopupContainer || getPopupContainer,
            draggingDelete: info.draggingDelete
        }, cloneNode);
    } : undefined;
    // ============================== Render ==============================
    const rootStyle = {
        ...mergedStyles.root
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $d583be797c5dfc28$export$2e2bcd8739ae039), {
        ...restProps,
        classNames: mergedClassNames,
        styles: mergedStyles,
        step: restProps.step,
        range: range,
        className: rootClassNames,
        style: rootStyle,
        disabled: mergedDisabled,
        vertical: mergedVertical,
        ref: ref,
        prefixCls: prefixCls,
        handleRender: handleRender,
        activeHandleRender: activeHandleRender,
        onChangeComplete: onInternalChangeComplete
    });
});
var $e720e40d3dabd8a5$export$2e2bcd8739ae039 = $e720e40d3dabd8a5$var$Slider;


var $5E6i4 = parcelRequire("5E6i4");

/* eslint-disable no-undefined,no-param-reassign,no-shadow */ /**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param {number} delay -                  A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher)
 *                                            are most useful.
 * @param {Function} callback -               A function to be executed after delay milliseconds. The `this` context and all arguments are passed through,
 *                                            as-is, to `callback` when the throttled-function is executed.
 * @param {object} [options] -              An object to configure options.
 * @param {boolean} [options.noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds
 *                                            while the throttled-function is being called. If noTrailing is false or unspecified, callback will be executed
 *                                            one final time after the last throttled-function call. (After the throttled-function has not been called for
 *                                            `delay` milliseconds, the internal counter is reset).
 * @param {boolean} [options.noLeading] -   Optional, defaults to false. If noLeading is false, the first throttled-function call will execute callback
 *                                            immediately. If noLeading is true, the first the callback execution will be skipped. It should be noted that
 *                                            callback will never executed if both noLeading = true and noTrailing = true.
 * @param {boolean} [options.debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is
 *                                            false (at end), schedule `callback` to execute after `delay` ms.
 *
 * @returns {Function} A new, throttled, function.
 */ function $da0e211d02f808af$export$de363e709c412c8a(delay, callback, options) {
    var _ref = options || {}, _ref$noTrailing = _ref.noTrailing, noTrailing = _ref$noTrailing === void 0 ? false : _ref$noTrailing, _ref$noLeading = _ref.noLeading, noLeading = _ref$noLeading === void 0 ? false : _ref$noLeading, _ref$debounceMode = _ref.debounceMode, debounceMode = _ref$debounceMode === void 0 ? undefined : _ref$debounceMode;
    /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */ var timeoutID;
    var cancelled = false;
    // Keep track of the last time `callback` was executed.
    var lastExec = 0;
    // Function to clear existing timeout
    function clearExistingTimeout() {
        if (timeoutID) clearTimeout(timeoutID);
    }
    // Function to cancel next exec
    function cancel(options) {
        var _ref2 = options || {}, _ref2$upcomingOnly = _ref2.upcomingOnly, upcomingOnly = _ref2$upcomingOnly === void 0 ? false : _ref2$upcomingOnly;
        clearExistingTimeout();
        cancelled = !upcomingOnly;
    }
    /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */ function wrapper() {
        for(var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++)arguments_[_key] = arguments[_key];
        var self = this;
        var elapsed = Date.now() - lastExec;
        if (cancelled) return;
        // Execute `callback` and update the `lastExec` timestamp.
        function exec() {
            lastExec = Date.now();
            callback.apply(self, arguments_);
        }
        /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */ function clear() {
            timeoutID = undefined;
        }
        if (!noLeading && debounceMode && !timeoutID) /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`
       * and noLeading != true.
       */ exec();
        clearExistingTimeout();
        if (debounceMode === undefined && elapsed > delay) {
            if (noLeading) {
                /*
         * In throttle mode with noLeading, if `delay` time has
         * been exceeded, update `lastExec` and schedule `callback`
         * to execute after `delay` ms.
         */ lastExec = Date.now();
                if (!noTrailing) timeoutID = setTimeout(debounceMode ? clear : exec, delay);
            } else /*
         * In throttle mode without noLeading, if `delay` time has been exceeded, execute
         * `callback`.
         */ exec();
        } else if (noTrailing !== true) /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */ timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
    wrapper.cancel = cancel;
    // Return the wrapper function.
    return wrapper;
}
/* eslint-disable no-undefined */ /**
 * Debounce execution of a function. Debouncing, unlike throttling,
 * guarantees that a function is only executed a single time, either at the
 * very beginning of a series of calls, or at the very end.
 *
 * @param {number} delay -               A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param {Function} callback -          A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                        to `callback` when the debounced-function is executed.
 * @param {object} [options] -           An object to configure options.
 * @param {boolean} [options.atBegin] -  Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
 *                                        after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
 *                                        (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
 *
 * @returns {Function} A new, debounced function.
 */ function $da0e211d02f808af$export$61fc7d43ac8f84b0(delay, callback, options) {
    var _ref = options || {}, _ref$atBegin = _ref.atBegin, atBegin = _ref$atBegin === void 0 ? false : _ref$atBegin;
    return $da0e211d02f808af$export$de363e709c412c8a(delay, callback, {
        debounceMode: atBegin !== false
    });
}







var $5E6i4 = parcelRequire("5E6i4");



var $5E6i4 = parcelRequire("5E6i4");


var $5E6i4 = parcelRequire("5E6i4");


"use client";
const $2afe55710226bd78$var$viewSize = 100;
const $2afe55710226bd78$var$borderWidth = $2afe55710226bd78$var$viewSize / 5;
const $2afe55710226bd78$var$radius = $2afe55710226bd78$var$viewSize / 2 - $2afe55710226bd78$var$borderWidth / 2;
const $2afe55710226bd78$var$circumference = $2afe55710226bd78$var$radius * 2 * Math.PI;
const $2afe55710226bd78$var$position = 50;
const $2afe55710226bd78$var$CustomCircle = (props)=>{
    const { dotClassName: dotClassName, style: style, hasCircleCls: hasCircleCls } = props;
    return /*#__PURE__*/ $5E6i4.createElement("circle", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${dotClassName}-circle`, {
            [`${dotClassName}-circle-bg`]: hasCircleCls
        }),
        r: $2afe55710226bd78$var$radius,
        cx: $2afe55710226bd78$var$position,
        cy: $2afe55710226bd78$var$position,
        strokeWidth: $2afe55710226bd78$var$borderWidth,
        style: style
    });
};
const $2afe55710226bd78$var$Progress = ({ percent: percent, prefixCls: prefixCls })=>{
    const dotClassName = `${prefixCls}-dot`;
    const holderClassName = `${dotClassName}-holder`;
    const hideClassName = `${holderClassName}-hidden`;
    const [render, setRender] = $5E6i4.useState(false);
    // ==================== Visible =====================
    (0, $518ae471aa4f03a7$export$2e2bcd8739ae039)(()=>{
        if (percent !== 0) setRender(true);
    }, [
        percent
    ]);
    // ==================== Progress ====================
    const safePtg = Math.max(Math.min(percent, 100), 0);
    // ===================== Render =====================
    if (!render) return null;
    const circleStyle = {
        strokeDashoffset: `${$2afe55710226bd78$var$circumference / 4}`,
        strokeDasharray: `${$2afe55710226bd78$var$circumference * safePtg / 100} ${$2afe55710226bd78$var$circumference * (100 - safePtg) / 100}`
    };
    return /*#__PURE__*/ $5E6i4.createElement("span", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(holderClassName, `${dotClassName}-progress`, {
            [hideClassName]: safePtg <= 0
        })
    }, /*#__PURE__*/ $5E6i4.createElement("svg", {
        viewBox: `0 0 ${$2afe55710226bd78$var$viewSize} ${$2afe55710226bd78$var$viewSize}`,
        role: "progressbar",
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuenow": safePtg
    }, /*#__PURE__*/ $5E6i4.createElement($2afe55710226bd78$var$CustomCircle, {
        dotClassName: dotClassName,
        hasCircleCls: true
    }), /*#__PURE__*/ $5E6i4.createElement($2afe55710226bd78$var$CustomCircle, {
        dotClassName: dotClassName,
        style: circleStyle
    })));
};
var $2afe55710226bd78$export$2e2bcd8739ae039 = $2afe55710226bd78$var$Progress;


"use client";
function $c74b9a1d88ef7368$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, percent: percent = 0, className: className, style: style } = props;
    const dotClassName = `${prefixCls}-dot`;
    const holderClassName = `${dotClassName}-holder`;
    const hideClassName = `${holderClassName}-hidden`;
    // ===================== Render =====================
    return /*#__PURE__*/ $5E6i4.createElement($5E6i4.Fragment, null, /*#__PURE__*/ $5E6i4.createElement("span", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(holderClassName, className, percent > 0 && hideClassName),
        style: style
    }, /*#__PURE__*/ $5E6i4.createElement("span", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(dotClassName, `${prefixCls}-dot-spin`)
    }, [
        1,
        2,
        3,
        4
    ].map((i)=>/*#__PURE__*/ $5E6i4.createElement("i", {
            className: `${prefixCls}-dot-item`,
            key: i
        })))), /*#__PURE__*/ $5E6i4.createElement((0, $2afe55710226bd78$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        percent: percent
    }));
}


"use client";
function $97b04b50a4526d8b$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, indicator: indicator, percent: percent, className: className, style: style } = props;
    const dotClassName = `${prefixCls}-dot`;
    if (indicator && /*#__PURE__*/ $5E6i4.isValidElement(indicator)) return (0, $552e20b6ec4e63a6$export$e530037191fcd5d7)(indicator, (currentProps)=>({
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(currentProps.className, dotClassName, className),
            style: {
                ...currentProps.style,
                ...style
            },
            percent: percent
        }));
    return /*#__PURE__*/ $5E6i4.createElement((0, $c74b9a1d88ef7368$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        percent: percent,
        className: className,
        style: style
    });
}






const $e13f625e45e7cbcc$var$antSpinMove = new (0, $14544cbeb8c8473b$export$2e2bcd8739ae039)('antSpinMove', {
    to: {
        opacity: 1
    }
});
const $e13f625e45e7cbcc$var$antRotate = new (0, $14544cbeb8c8473b$export$2e2bcd8739ae039)('antRotate', {
    to: {
        transform: 'rotate(405deg)'
    }
});
// =============================== Spin ===============================
const $e13f625e45e7cbcc$var$genSpinStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const sectionCls = `${componentCls}-section`;
    return {
        [componentCls]: {
            ...(0, $cd5a520fee8002b4$export$23997c3e44cc1c59)(token),
            position: 'relative',
            '&-rtl': {
                direction: 'rtl'
            },
            // ========================== Section ===========================
            [`&${sectionCls}, > ${sectionCls}`]: {
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                gap: token.paddingSM,
                color: token.colorPrimary
            },
            [`&${sectionCls}`]: {
                display: 'inline-flex'
            },
            [`> ${sectionCls}`]: {
                position: 'absolute',
                top: '50%',
                left: {
                    _skip_check_: true,
                    value: '50%'
                },
                transform: 'translate(-50%, -50%)',
                zIndex: 1
            },
            [`${componentCls}-description`]: {
                fontSize: token.fontSize,
                lineHeight: 1
            },
            // ========================= Container ==========================
            [`${componentCls}-container`]: {
                position: 'relative',
                transition: `opacity ${token.motionDurationSlow}`,
                '&::after': {
                    position: 'absolute',
                    top: 0,
                    insetInlineEnd: 0,
                    bottom: 0,
                    insetInlineStart: 0,
                    zIndex: 10,
                    width: '100%',
                    height: '100%',
                    background: token.colorBgContainer,
                    opacity: 0,
                    transition: `all ${token.motionDurationSlow}`,
                    content: '""',
                    pointerEvents: 'none'
                }
            },
            // ========================== Spinning ==========================
            '&-spinning': {
                [`${componentCls}-description`]: {
                    textShadow: `0 0px 5px ${token.colorBgContainer}`
                },
                [`${componentCls}-container`]: {
                    clear: 'both',
                    opacity: 0.5,
                    userSelect: 'none',
                    pointerEvents: 'none',
                    '&::after': {
                        opacity: 0.4,
                        pointerEvents: 'auto'
                    }
                }
            },
            // ========================= Fullscreen =========================
            '&-fullscreen': {
                position: 'fixed',
                inset: 0,
                backgroundColor: token.colorBgMask,
                zIndex: token.zIndexPopupBase,
                opacity: 0,
                pointerEvents: 'none',
                transition: `all ${token.motionDurationMid}`,
                [`&${componentCls}-spinning`]: {
                    opacity: 1,
                    pointerEvents: 'auto'
                },
                [`> ${sectionCls}`]: {
                    color: token.colorWhite,
                    [`${componentCls}-description`]: {
                        color: token.colorTextLightSolid
                    }
                }
            }
        }
    };
};
// ============================ Indicator =============================
const $e13f625e45e7cbcc$var$genIndicatorStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls, motionDurationSlow: motionDurationSlow } = token;
    const [varName, varRef] = (0, $761caadb5301aee1$export$d82b8f66c5649e14)(antCls, 'spin');
    return {
        [componentCls]: {
            [varName('dot-holder-size')]: token.dotSize,
            [varName('dot-item-size')]: `calc((${varRef('dot-holder-size')} - ${token.marginXXS} / 2) / 2)`,
            [`${componentCls}-dot`]: {
                // >>> holder
                '&-holder': {
                    width: '1em',
                    height: '1em',
                    fontSize: varRef('dot-holder-size'),
                    display: 'inline-block',
                    transition: [
                        'transform',
                        'opacity'
                    ].map((prop)=>`${prop} ${motionDurationSlow} ease`).join(', '),
                    transformOrigin: '50% 50%',
                    lineHeight: 1,
                    '&-hidden': {
                        transform: 'scale(0.3)',
                        opacity: 0
                    }
                },
                // >>> holder > dot
                position: 'relative',
                display: 'inline-block',
                fontSize: varRef('dot-holder-size'),
                width: '1em',
                height: '1em',
                '&-spin': {
                    transform: 'rotate(45deg)',
                    animationName: $e13f625e45e7cbcc$var$antRotate,
                    animationDuration: '1.2s',
                    animationIterationCount: 'infinite',
                    animationTimingFunction: 'linear'
                },
                // >>> holder > dot > item
                '&-item': {
                    position: 'absolute',
                    display: 'block',
                    width: varRef('dot-item-size'),
                    height: varRef('dot-item-size'),
                    background: 'currentColor',
                    borderRadius: '100%',
                    transform: 'scale(0.75)',
                    transformOrigin: '50% 50%',
                    opacity: 0.3,
                    animationName: $e13f625e45e7cbcc$var$antSpinMove,
                    animationDuration: '1s',
                    animationIterationCount: 'infinite',
                    animationTimingFunction: 'linear',
                    animationDirection: 'alternate',
                    '&:nth-child(1)': {
                        top: 0,
                        insetInlineStart: 0,
                        animationDelay: '0s'
                    },
                    '&:nth-child(2)': {
                        top: 0,
                        insetInlineEnd: 0,
                        animationDelay: '0.4s'
                    },
                    '&:nth-child(3)': {
                        insetInlineEnd: 0,
                        bottom: 0,
                        animationDelay: '0.8s'
                    },
                    '&:nth-child(4)': {
                        bottom: 0,
                        insetInlineStart: 0,
                        animationDelay: '1.2s'
                    }
                },
                // ========================= Progress =========================
                '&-progress': {
                    position: 'absolute',
                    left: '50%',
                    top: 0,
                    transform: 'translateX(-50%)'
                },
                '&-circle': {
                    strokeLinecap: 'round',
                    transition: [
                        'stroke-dashoffset',
                        'stroke-dasharray',
                        'stroke',
                        'stroke-width',
                        'opacity'
                    ].map((item)=>`${item} ${motionDurationSlow} ease`).join(','),
                    fillOpacity: 0,
                    stroke: 'currentcolor'
                },
                '&-circle-bg': {
                    stroke: token.colorFillSecondary
                }
            }
        }
    };
};
// =============================== Size ===============================
const $e13f625e45e7cbcc$var$genSizeStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const [varName] = (0, $761caadb5301aee1$export$d82b8f66c5649e14)(token.antCls, 'spin');
    return {
        [componentCls]: {
            '&-sm': {
                [varName('dot-holder-size')]: token.dotSizeSM
            },
            '&-lg': {
                [varName('dot-holder-size')]: token.dotSizeLG
            }
        }
    };
};
const $e13f625e45e7cbcc$export$9ca1be8807fe0675 = (token)=>{
    const { controlHeightLG: controlHeightLG, controlHeight: controlHeight } = token;
    return {
        contentHeight: 400,
        dotSize: controlHeightLG / 2,
        dotSizeSM: controlHeightLG * 0.35,
        dotSizeLG: controlHeight
    };
};
var // ============================== Export ==============================
$e13f625e45e7cbcc$export$2e2bcd8739ae039 = (0, $761caadb5301aee1$export$51ec95de45185b42)('Spin', (token)=>{
    const spinToken = (0, $f564548c7b6877d5$export$4950aa0f605343fb)(token, {
        spinDotDefault: token.colorTextDescription
    });
    return [
        $e13f625e45e7cbcc$var$genSpinStyle(spinToken),
        $e13f625e45e7cbcc$var$genIndicatorStyle(spinToken),
        $e13f625e45e7cbcc$var$genSizeStyle(spinToken)
    ];
}, $e13f625e45e7cbcc$export$9ca1be8807fe0675);



var $5E6i4 = parcelRequire("5E6i4");
const $b2d5973c579e32f5$var$AUTO_INTERVAL = 200;
const $b2d5973c579e32f5$var$STEP_BUCKETS = [
    [
        30,
        0.05
    ],
    [
        70,
        0.03
    ],
    [
        96,
        0.01
    ]
];
function $b2d5973c579e32f5$export$2e2bcd8739ae039(spinning, percent) {
    const [mockPercent, setMockPercent] = $5E6i4.useState(0);
    const mockIntervalRef = $5E6i4.useRef(null);
    const isAuto = percent === 'auto';
    $5E6i4.useEffect(()=>{
        if (isAuto && spinning) {
            setMockPercent(0);
            mockIntervalRef.current = setInterval(()=>{
                setMockPercent((prev)=>{
                    const restPTG = 100 - prev;
                    for(let i = 0; i < $b2d5973c579e32f5$var$STEP_BUCKETS.length; i += 1){
                        const [limit, stepPtg] = $b2d5973c579e32f5$var$STEP_BUCKETS[i];
                        if (prev <= limit) return prev + restPTG * stepPtg;
                    }
                    return prev;
                });
            }, $b2d5973c579e32f5$var$AUTO_INTERVAL);
        }
        return ()=>{
            if (mockIntervalRef.current) {
                clearInterval(mockIntervalRef.current);
                mockIntervalRef.current = null;
            }
        };
    }, [
        isAuto,
        spinning
    ]);
    return isAuto ? mockPercent : percent;
}


"use client";
// Render indicator
let $ae2aafd1f3045853$var$defaultIndicator;
function $ae2aafd1f3045853$var$shouldDelay(spinning, delay) {
    return !!spinning && !!delay && !Number.isNaN(Number(delay));
}
const $ae2aafd1f3045853$var$Spin = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, spinning: customSpinning = true, delay: delay = 0, className: className, rootClassName: rootClassName, size: size, tip: tip, description: description, wrapperClassName: wrapperClassName, style: style, children: children, fullscreen: fullscreen = false, indicator: indicator, percent: percent, classNames: classNames, styles: styles, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, indicator: contextIndicator, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $519f2fad435b3034$export$46f4bd6436a25a31)('spin');
    const prefixCls = getPrefixCls('spin', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $e13f625e45e7cbcc$export$2e2bcd8739ae039)(prefixCls);
    const [spinning, setSpinning] = $5E6i4.useState(()=>customSpinning && !$ae2aafd1f3045853$var$shouldDelay(customSpinning, delay));
    const mergedPercent = (0, $b2d5973c579e32f5$export$2e2bcd8739ae039)(spinning, percent);
    $5E6i4.useEffect(()=>{
        if (customSpinning) {
            const showSpinning = (0, $da0e211d02f808af$export$61fc7d43ac8f84b0)(delay, ()=>{
                setSpinning(true);
            });
            showSpinning();
            return ()=>{
                showSpinning?.cancel?.();
            };
        }
        setSpinning(false);
    }, [
        delay,
        customSpinning
    ]);
    // ======================= Size ======================
    const mergedSize = (0, $4bfc7567df2a969e$export$2e2bcd8739ae039)((ctx)=>size ?? ctx);
    // ======================= Description ======================
    const mergedDescription = description ?? tip;
    // =============== Merged Props for Semantic ================
    const mergedProps = {
        ...props,
        size: mergedSize,
        spinning: spinning,
        tip: mergedDescription,
        description: mergedDescription,
        fullscreen: fullscreen,
        children: children,
        percent: mergedPercent
    };
    // ========================= Style ==========================
    const contextStyleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(contextStyle);
    const [mergedClassNames, mergedStyles] = (0, $722c8632ba7bdb89$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles
    ], {
        props: mergedProps
    });
    // ======================= Indicator ========================
    const mergedIndicator = indicator ?? contextIndicator ?? $ae2aafd1f3045853$var$defaultIndicator;
    // ========================= Render =========================
    const hasChildren = typeof children !== 'undefined';
    const isNested = hasChildren || fullscreen;
    const indicatorNode = /*#__PURE__*/ $5E6i4.createElement($5E6i4.Fragment, null, /*#__PURE__*/ $5E6i4.createElement((0, $97b04b50a4526d8b$export$2e2bcd8739ae039), {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(mergedClassNames.indicator),
        style: mergedStyles.indicator,
        prefixCls: prefixCls,
        indicator: mergedIndicator,
        percent: mergedPercent
    }), mergedDescription && /*#__PURE__*/ $5E6i4.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-description`, mergedClassNames.tip, mergedClassNames.description),
        style: {
            ...mergedStyles.tip,
            ...mergedStyles.description
        }
    }, mergedDescription));
    const nativeElementRef = $5E6i4.useRef(null);
    $5E6i4.useImperativeHandle(ref, ()=>({
            nativeElement: nativeElementRef.current
        }));
    return /*#__PURE__*/ $5E6i4.createElement("div", {
        ref: nativeElementRef,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, {
            [`${prefixCls}-sm`]: mergedSize === 'small',
            [`${prefixCls}-lg`]: mergedSize === 'large',
            [`${prefixCls}-spinning`]: spinning,
            [`${prefixCls}-rtl`]: direction === 'rtl',
            [`${prefixCls}-fullscreen`]: fullscreen
        }, rootClassName, mergedClassNames.root, fullscreen && mergedClassNames.mask, isNested ? wrapperClassName : [
            `${prefixCls}-section`,
            mergedClassNames.section
        ], contextClassName, className, hashId, cssVarCls),
        style: {
            ...mergedStyles.root,
            ...!isNested ? mergedStyles.section : {},
            ...fullscreen ? mergedStyles.mask : {},
            ...style
        },
        "aria-live": "polite",
        "aria-busy": spinning,
        ...restProps
    }, spinning && (isNested ? /*#__PURE__*/ $5E6i4.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-section`, mergedClassNames.section),
        style: mergedStyles.section
    }, indicatorNode) : indicatorNode), hasChildren && /*#__PURE__*/ $5E6i4.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-container`, mergedClassNames.container),
        style: mergedStyles.container
    }, children));
});
$ae2aafd1f3045853$var$Spin.setDefaultIndicator = (indicator)=>{
    $ae2aafd1f3045853$var$defaultIndicator = indicator;
};
var $ae2aafd1f3045853$export$2e2bcd8739ae039 = $ae2aafd1f3045853$var$Spin;


var $5E6i4 = parcelRequire("5E6i4");












var $5E6i4 = parcelRequire("5E6i4");









// ============================== Styles ==============================
const $e312f225f43cda12$var$genBaseStyle = (token)=>{
    const { paddingXXS: paddingXXS, lineWidth: lineWidth, tagPaddingHorizontal: tagPaddingHorizontal, componentCls: componentCls, calc: calc } = token;
    const paddingInline = calc(tagPaddingHorizontal).sub(lineWidth).equal();
    const iconMarginInline = calc(paddingXXS).sub(lineWidth).equal();
    return {
        // Result
        [componentCls]: {
            ...(0, $cd5a520fee8002b4$export$23997c3e44cc1c59)(token),
            display: 'inline-block',
            height: 'auto',
            paddingInline: paddingInline,
            fontSize: token.tagFontSize,
            lineHeight: token.tagLineHeight,
            whiteSpace: 'nowrap',
            backgroundColor: token.defaultBg,
            border: `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
            borderRadius: token.borderRadiusSM,
            opacity: 1,
            transition: `all ${token.motionDurationMid}`,
            textAlign: 'start',
            position: 'relative',
            // RTL
            [`&${componentCls}-rtl`]: {
                direction: 'rtl'
            },
            '&, a, a:hover': {
                color: token.defaultColor
            },
            [`${componentCls}-close-icon`]: {
                marginInlineStart: iconMarginInline,
                fontSize: token.tagIconSize,
                color: token.colorIcon,
                cursor: 'pointer',
                transition: `all ${token.motionDurationMid}`,
                '&:hover': {
                    color: token.colorTextHeading
                }
            },
            '&-checkable': {
                backgroundColor: 'transparent',
                borderColor: 'transparent',
                cursor: 'pointer',
                [`&:not(${componentCls}-checkable-checked):hover`]: {
                    color: token.colorPrimary,
                    backgroundColor: token.colorFillSecondary
                },
                '&:active, &-checked': {
                    color: token.colorTextLightSolid
                },
                '&-checked': {
                    backgroundColor: token.colorPrimary,
                    '&:hover': {
                        backgroundColor: token.colorPrimaryHover
                    }
                },
                '&:active': {
                    backgroundColor: token.colorPrimaryActive
                },
                '&-disabled': {
                    cursor: 'not-allowed',
                    [`&:not(${componentCls}-checkable-checked)`]: {
                        color: token.colorTextDisabled,
                        '&:hover': {
                            backgroundColor: 'transparent'
                        }
                    },
                    [`&${componentCls}-checkable-checked`]: {
                        color: token.colorTextDisabled,
                        backgroundColor: token.colorBgContainerDisabled
                    },
                    '&:hover, &:active': {
                        backgroundColor: token.colorBgContainerDisabled,
                        color: token.colorTextDisabled
                    },
                    [`&:not(${componentCls}-checkable-checked):hover`]: {
                        color: token.colorTextDisabled
                    }
                },
                '&-group': {
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: token.paddingXS
                }
            },
            '&-hidden': {
                display: 'none'
            },
            // Icons from third-party libraries are a bare `<svg>`, which none of the `.anticon`
            // rules reach. An `<svg>` has no baseline of its own, so it is aligned by its bottom
            // margin edge (CSS 2.1 §10.8.1) and rides above the text. Centre it instead: unlike an
            // `.anticon` (whose `<svg>` is always `1em`, so a fixed `-0.125em` nudge suffices), a
            // third-party `<svg>` may be sized in `px`, so the correction must not depend on size.
            // `display: inline-block` keeps it an atomic inline box so `vertical-align` still applies even
            // under a CSS reset that forces `svg { display: block }` (e.g. Tailwind Preflight), which would
            // otherwise drop the icon onto its own line. `vertical-align: middle` centres the margin box on
            // the x-height line; `margin-block-end` then lifts it by half its own value onto the cap-height
            // centre (capHeight − xHeight ≈ 0.2em across typical fonts), keeping it centred at any icon size.
            // Only matches a bare `<svg>`: an `.anticon` keeps its `<svg>` one level deeper.
            '> svg': {
                display: 'inline-block',
                verticalAlign: 'middle',
                marginBlockEnd: '0.2em'
            },
            // To ensure that a space will be placed between character and `Icon`.
            [`> ${token.iconCls} + span, > span + ${token.iconCls}, > svg + span, > span + svg`]: {
                marginInlineStart: paddingInline
            }
        },
        [`&${token.componentCls}-solid`]: {
            borderColor: 'transparent',
            color: token.colorTextLightSolid,
            backgroundColor: token.colorBgSolid,
            [`&${componentCls}-default`]: {
                color: token.solidTextColor
            }
        },
        [`${componentCls}-filled`]: {
            borderColor: 'transparent',
            backgroundColor: token.tagBorderlessBg
        },
        [`&${componentCls}-disabled`]: {
            color: token.colorTextDisabled,
            cursor: 'not-allowed',
            backgroundColor: token.colorBgContainerDisabled,
            a: {
                cursor: 'not-allowed',
                pointerEvents: 'none',
                color: token.colorTextDisabled,
                '&:hover': {
                    color: token.colorTextDisabled
                }
            },
            'a&': {
                '&:hover, &:active': {
                    color: token.colorTextDisabled
                }
            },
            [`&${componentCls}-outlined`]: {
                borderColor: token.colorBorderDisabled
            },
            [`&${componentCls}-solid, &${componentCls}-filled`]: {
                color: token.colorTextDisabled,
                [`${componentCls}-close-icon`]: {
                    color: token.colorTextDisabled
                }
            },
            [`${componentCls}-close-icon`]: {
                cursor: 'not-allowed',
                color: token.colorTextDisabled,
                '&:hover': {
                    color: token.colorTextDisabled
                }
            }
        }
    };
};
const $e312f225f43cda12$export$362fb92a8f81bbf9 = (token)=>{
    const { lineWidth: lineWidth, fontSizeIcon: fontSizeIcon, calc: calc } = token;
    const tagFontSize = token.fontSizeSM;
    const tagToken = (0, $f564548c7b6877d5$export$4950aa0f605343fb)(token, {
        tagFontSize: tagFontSize,
        tagLineHeight: (0, $56bae8a99c3cba6e$export$523c0b569236b342)(calc(token.lineHeightSM).mul(tagFontSize).equal()),
        tagIconSize: calc(fontSizeIcon).sub(calc(lineWidth).mul(2)).equal(),
        // Tag icon is much smaller
        tagPaddingHorizontal: 8,
        // Fixed padding.
        tagBorderlessBg: token.defaultBg
    });
    return tagToken;
};
const $e312f225f43cda12$export$9ca1be8807fe0675 = (token)=>{
    const solidTextColor = (0, $44905ec240f468f5$export$6341b37cb79161da)(new (0, $a3fe15cc837afc75$export$e8cc8a2e87e145b4)(token.colorBgSolid), '#fff') ? '#000' : '#fff';
    return {
        defaultBg: new (0, $1b0a692e36565107$export$2c4f38d6c0ecc25a)(token.colorFillTertiary).onBackground(token.colorBgContainer).toHexString(),
        defaultColor: token.colorText,
        solidTextColor: solidTextColor
    };
};
var $e312f225f43cda12$export$2e2bcd8739ae039 = (0, $761caadb5301aee1$export$51ec95de45185b42)('Tag', (token)=>{
    const tagToken = $e312f225f43cda12$export$362fb92a8f81bbf9(token);
    return $e312f225f43cda12$var$genBaseStyle(tagToken);
}, $e312f225f43cda12$export$9ca1be8807fe0675);


"use client";
const $898aaea1775edea0$var$CheckableTag = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, style: style, className: className, checked: checked, children: children, icon: icon, onChange: onChange, onClick: onClick, onKeyDown: onKeyDown, disabled: customDisabled, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, tag: tag } = $5E6i4.useContext((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
    const disabled = $5E6i4.useContext((0, $2ab14018ea5b2d79$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled ?? disabled;
    const handleClick = (e)=>{
        if (mergedDisabled) return;
        onChange?.(!checked);
        onClick?.(e);
    };
    const handleKeyDown = (e)=>{
        onKeyDown?.(e);
        if (e.defaultPrevented || mergedDisabled) return;
        if (e.key === ' ') {
            e.preventDefault();
            if (!e.repeat) onChange?.(!checked);
        }
    };
    const prefixCls = getPrefixCls('tag', customizePrefixCls);
    // Style
    const [hashId, cssVarCls] = (0, $e312f225f43cda12$export$2e2bcd8739ae039)(prefixCls);
    const cls = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-checkable`, {
        [`${prefixCls}-checkable-checked`]: checked,
        [`${prefixCls}-checkable-disabled`]: mergedDisabled
    }, tag?.className, className, hashId, cssVarCls);
    return /*#__PURE__*/ $5E6i4.createElement("span", {
        ...restProps,
        ref: ref,
        role: "checkbox",
        "aria-checked": checked,
        "aria-disabled": mergedDisabled || undefined,
        tabIndex: mergedDisabled ? -1 : 0,
        style: {
            ...tag?.style,
            ...style
        },
        className: cls,
        onClick: handleClick,
        onKeyDown: handleKeyDown
    }, icon, /*#__PURE__*/ $5E6i4.createElement("span", null, children));
});
var $898aaea1775edea0$export$2e2bcd8739ae039 = $898aaea1775edea0$var$CheckableTag;




var $5E6i4 = parcelRequire("5E6i4");








"use client";
const $ba7a8dd02bba8dd0$var$CheckableTagGroup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).forwardRef((props, ref)=>{
    const { id: id, prefixCls: customizePrefixCls, rootClassName: rootClassName, className: className, style: style, classNames: classNames, styles: styles, disabled: disabled, options: options, value: value, defaultValue: defaultValue, onChange: onChange, multiple: multiple, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $519f2fad435b3034$export$46f4bd6436a25a31)('tag');
    const prefixCls = getPrefixCls('tag', customizePrefixCls);
    const groupPrefixCls = `${prefixCls}-checkable-group`;
    const rootCls = (0, $d104ec5f99ed66d7$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $e312f225f43cda12$export$2e2bcd8739ae039)(prefixCls, rootCls);
    // ====================== Styles ======================
    const contextStyleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $722c8632ba7bdb89$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: props
    });
    // =============================== Option ===============================
    const parsedOptions = (0, $5E6i4.useMemo)(()=>{
        if (!Array.isArray(options)) return [];
        return options.map((option)=>{
            if ((0, $addbc2fddcbb77a9$export$53b83ca8eaab0383)(option)) return option;
            return {
                value: option,
                label: option
            };
        });
    }, [
        options
    ]);
    // =============================== Values ===============================
    const [mergedValue, setMergedValue] = (0, $e18df22f16a16360$export$2e2bcd8739ae039)(defaultValue, value);
    const handleChange = (checked, option)=>{
        let newValue = null;
        if (multiple) {
            const valueList = mergedValue || [];
            newValue = checked ? [].concat((0, $0acfae8147afe964$export$2e2bcd8739ae039)(valueList), [
                option.value
            ]) : valueList.filter((item)=>item !== option.value);
        } else newValue = checked ? option.value : null;
        setMergedValue(newValue);
        onChange?.(newValue); // TS not support generic type in function call
    };
    // ================================ Refs ================================
    const divRef = (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).useRef(null);
    (0, $5E6i4.useImperativeHandle)(ref, ()=>({
            nativeElement: divRef.current
        }));
    // ================================ ARIA ================================
    const ariaProps = (0, $78cde6532419ffca$export$2e2bcd8739ae039)(restProps, {
        aria: true,
        data: true
    });
    // =============================== Render ===============================
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement("div", {
        ...ariaProps,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(groupPrefixCls, contextClassName, rootClassName, {
            [`${groupPrefixCls}-disabled`]: disabled,
            [`${groupPrefixCls}-rtl`]: direction === 'rtl'
        }, hashId, cssVarCls, className, mergedClassNames.root),
        style: mergedStyles.root,
        id: id,
        ref: divRef
    }, parsedOptions.map((option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5E6i4))).createElement((0, $898aaea1775edea0$export$2e2bcd8739ae039), {
            key: option.value,
            className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${groupPrefixCls}-item`, mergedClassNames.item, option.className),
            style: {
                ...mergedStyles.item,
                ...option.style
            },
            checked: multiple ? (mergedValue || []).includes(option.value) : mergedValue === option.value,
            onChange: (checked)=>handleChange(checked, option),
            disabled: disabled
        }, option.label)));
});
var $ba7a8dd02bba8dd0$export$2e2bcd8739ae039 = $ba7a8dd02bba8dd0$var$CheckableTagGroup;



var $5E6i4 = parcelRequire("5E6i4");


function $491d175c9ed3ac56$export$2e2bcd8739ae039(props, contextVariant) {
    const { color: color, variant: variant, bordered: bordered } = props;
    return $5E6i4.useMemo(()=>{
        const isInverseColor = color?.endsWith('-inverse');
        // =================== Variant ===================
        let nextVariant;
        if (variant) // `variant` first
        nextVariant = variant;
        else if (isInverseColor) // Fallback if using inverse color
        nextVariant = 'solid';
        else if (bordered === false) // Fallback if using filled
        nextVariant = 'filled';
        else // Finally not conflict, use context
        nextVariant = contextVariant || 'filled';
        // ==================== Color ====================
        let nextColor = isInverseColor ? color?.replace('-inverse', '') : color;
        if (nextColor === undefined && nextVariant === 'solid') nextColor = 'default';
        // =============== Preset & Status ===============
        const nextIsPreset = (0, $34c0f54ad93821fb$export$ee62ebd6a58c4884)(nextColor);
        const nextIsStatus = (0, $34c0f54ad93821fb$export$88a0ba1f7d1ea40e)(nextColor);
        // ================== Customize ==================
        // When `color` is not preset color,
        // dynamic calculate the color pair.
        const tagStyle = {};
        if (!nextIsPreset && !nextIsStatus && nextColor) {
            if (nextVariant === 'solid') tagStyle.backgroundColor = color;
            else {
                const hsl = new (0, $1b0a692e36565107$export$2c4f38d6c0ecc25a)(nextColor).toHsl();
                hsl.l = 0.95;
                tagStyle.backgroundColor = new (0, $1b0a692e36565107$export$2c4f38d6c0ecc25a)(hsl).toHexString();
                tagStyle.color = color;
                if (nextVariant === 'outlined') tagStyle.borderColor = color;
            }
        }
        return [
            nextVariant,
            nextColor,
            nextIsPreset,
            nextIsStatus,
            tagStyle
        ];
    }, [
        color,
        variant,
        bordered,
        contextVariant
    ]);
}



// Style as status component


// ============================== Preset ==============================
const $20bffa9c83dcf709$var$genPresetStyle = (token)=>(0, $eeb2a6150e6f408f$export$2e2bcd8739ae039)(token, (colorKey, { textColor: textColor, lightBorderColor: lightBorderColor, lightColor: lightColor, darkColor: darkColor })=>({
            [`${token.componentCls}${token.componentCls}-${colorKey}:not(${token.componentCls}-disabled)`]: {
                [`&${token.componentCls}-outlined`]: {
                    backgroundColor: lightColor,
                    borderColor: lightBorderColor,
                    color: textColor
                },
                [`&${token.componentCls}-solid`]: {
                    backgroundColor: darkColor,
                    borderColor: darkColor,
                    color: token.colorTextLightSolid
                },
                [`&${token.componentCls}-filled`]: {
                    backgroundColor: lightColor,
                    color: textColor
                }
            }
        }));
var // ============================== Export ==============================
$20bffa9c83dcf709$export$2e2bcd8739ae039 = (0, $761caadb5301aee1$export$1537386bc155ea56)([
    'Tag',
    'preset'
], (token)=>{
    const tagToken = (0, $e312f225f43cda12$export$362fb92a8f81bbf9)(token);
    return $20bffa9c83dcf709$var$genPresetStyle(tagToken);
}, (0, $e312f225f43cda12$export$9ca1be8807fe0675));



function $395677dd0fceee54$export$2e2bcd8739ae039(str) {
    if (typeof str !== 'string') return str;
    const ret = str.charAt(0).toUpperCase() + str.slice(1);
    return ret;
}



const $57e628f8b732169c$var$genTagStatusStyle = (token, status, cssVariableType)=>{
    const capitalizedCssVariableType = (0, $395677dd0fceee54$export$2e2bcd8739ae039)(cssVariableType);
    return {
        [`${token.componentCls}${token.componentCls}-${status}:not(${token.componentCls}-disabled)`]: {
            [`&${token.componentCls}-outlined`]: {
                backgroundColor: token[`color${capitalizedCssVariableType}Bg`],
                borderColor: token[`color${capitalizedCssVariableType}Border`],
                color: token[`color${cssVariableType}`]
            },
            [`&${token.componentCls}-solid`]: {
                backgroundColor: token[`color${cssVariableType}`],
                borderColor: token[`color${cssVariableType}`]
            },
            [`&${token.componentCls}-filled`]: {
                backgroundColor: token[`color${capitalizedCssVariableType}Bg`],
                color: token[`color${cssVariableType}`]
            }
        }
    };
};
var // ============================== Export ==============================
$57e628f8b732169c$export$2e2bcd8739ae039 = (0, $761caadb5301aee1$export$1537386bc155ea56)([
    'Tag',
    'status'
], (token)=>{
    const tagToken = (0, $e312f225f43cda12$export$362fb92a8f81bbf9)(token);
    return [
        $57e628f8b732169c$var$genTagStatusStyle(tagToken, 'success', 'Success'),
        $57e628f8b732169c$var$genTagStatusStyle(tagToken, 'processing', 'Info'),
        $57e628f8b732169c$var$genTagStatusStyle(tagToken, 'error', 'Error'),
        $57e628f8b732169c$var$genTagStatusStyle(tagToken, 'warning', 'Warning')
    ];
}, (0, $e312f225f43cda12$export$9ca1be8807fe0675));


"use client";
const $8fc97680f2a1b34a$var$InternalTag = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, children: children, icon: icon, color: color, variant: _variant, onClose: onClose, bordered: bordered, disabled: customDisabled, href: href, target: target, styles: styles, classNames: classNames, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, variant: contextVariant, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $519f2fad435b3034$export$46f4bd6436a25a31)('tag');
    // ====================== Colors ======================
    const [mergedVariant, mergedColor, isPreset, isStatus, customTagStyle] = (0, $491d175c9ed3ac56$export$2e2bcd8739ae039)(props, contextVariant);
    const isInternalColor = isPreset || isStatus;
    // ===================== Disabled =====================
    const disabled = $5E6i4.useContext((0, $2ab14018ea5b2d79$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled ?? disabled;
    const { tag: tagContext } = $5E6i4.useContext((0, $519f2fad435b3034$export$a92f85ab3e9ad68b));
    const [visible, setVisible] = $5E6i4.useState(true);
    const domProps = (0, $48bd91d9f828de66$export$2e2bcd8739ae039)(restProps, [
        'closeIcon',
        'closable'
    ]);
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        color: mergedColor,
        variant: mergedVariant,
        disabled: mergedDisabled
    };
    // ====================== Styles ======================
    const contextStyleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $722c8632ba7bdb89$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    });
    const tagStyle = $5E6i4.useMemo(()=>{
        let nextTagStyle = mergedStyles.root;
        if (!mergedDisabled) nextTagStyle = {
            ...customTagStyle,
            ...nextTagStyle
        };
        return nextTagStyle;
    }, [
        mergedStyles.root,
        customTagStyle,
        mergedDisabled
    ]);
    const prefixCls = getPrefixCls('tag', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $e312f225f43cda12$export$2e2bcd8739ae039)(prefixCls);
    const tagClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, contextClassName, mergedClassNames.root, `${prefixCls}-${mergedVariant}`, {
        [`${prefixCls}-${mergedColor}`]: isInternalColor,
        [`${prefixCls}-hidden`]: !visible,
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-disabled`]: mergedDisabled
    }, className, rootClassName, hashId, cssVarCls);
    // ===================== Closable =====================
    const triggerClose = (e)=>{
        if (mergedDisabled) return;
        e.stopPropagation();
        onClose?.(e);
        if (e.defaultPrevented) return;
        if (href) e.preventDefault();
        setVisible(false);
    };
    const handleCloseKeyDown = (e)=>{
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            if (!e.repeat) e.currentTarget.click();
        }
    };
    const [, mergedCloseIcon] = (0, $be8e19a8189a28c3$export$aa101db403ccf5f3)((0, $be8e19a8189a28c3$export$51ad9c30389f050b)(props), (0, $be8e19a8189a28c3$export$51ad9c30389f050b)(tagContext), {
        closable: false,
        closeIconRender: (iconNode)=>{
            const replacement = /*#__PURE__*/ $5E6i4.createElement("span", {
                role: "button",
                tabIndex: mergedDisabled ? -1 : 0,
                "aria-disabled": mergedDisabled || undefined,
                className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-close-icon`, mergedClassNames.close),
                onClick: triggerClose,
                onKeyDown: handleCloseKeyDown,
                style: mergedStyles.close
            }, iconNode);
            return (0, $552e20b6ec4e63a6$export$2dfe578f95754f6a)(iconNode, replacement, (originProps)=>({
                    onClick: (e)=>{
                        originProps?.onClick?.(e);
                        triggerClose(e);
                    },
                    onKeyDown: (e)=>{
                        originProps?.onKeyDown?.(e);
                        if (!e.defaultPrevented) handleCloseKeyDown(e);
                    },
                    role: 'button',
                    tabIndex: mergedDisabled ? -1 : 0,
                    'aria-disabled': mergedDisabled || undefined,
                    className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(originProps?.className, `${prefixCls}-close-icon`, mergedClassNames.close),
                    style: {
                        ...mergedStyles.close,
                        ...originProps?.style
                    }
                }));
        }
    });
    // ====================== Render ======================
    const isNeedWave = (0, $addbc2fddcbb77a9$export$f6e2535fb5126e54)(restProps.onClick) || children && children.type === 'a';
    const iconNode = (0, $552e20b6ec4e63a6$export$e530037191fcd5d7)(icon, {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(/*#__PURE__*/ $5E6i4.isValidElement(icon) ? icon.props?.className : undefined, mergedClassNames.icon),
        style: mergedStyles.icon
    });
    const child = iconNode ? /*#__PURE__*/ $5E6i4.createElement($5E6i4.Fragment, null, iconNode, (0, $b63de2b9864a5d1a$export$72280d5f896dac9a)(children) && /*#__PURE__*/ $5E6i4.createElement("span", {
        className: mergedClassNames.content,
        style: mergedStyles.content
    }, children)) : children;
    const TagWrapper = href ? 'a' : 'span';
    const tagNode = /*#__PURE__*/ $5E6i4.createElement(TagWrapper, {
        ...domProps,
        ref: ref,
        className: tagClassName,
        style: tagStyle,
        href: mergedDisabled ? undefined : href,
        target: target,
        onClick: mergedDisabled ? undefined : domProps.onClick,
        ...href && mergedDisabled ? {
            'aria-disabled': true
        } : {}
    }, child, mergedCloseIcon, isPreset && /*#__PURE__*/ $5E6i4.createElement((0, $20bffa9c83dcf709$export$2e2bcd8739ae039), {
        key: "preset",
        prefixCls: prefixCls
    }), isStatus && /*#__PURE__*/ $5E6i4.createElement((0, $57e628f8b732169c$export$2e2bcd8739ae039), {
        key: "status",
        prefixCls: prefixCls
    }));
    return isNeedWave ? /*#__PURE__*/ $5E6i4.createElement((0, $fac597d347ed38a8$export$2e2bcd8739ae039), {
        component: "Tag"
    }, tagNode) : tagNode;
});
const $8fc97680f2a1b34a$var$Tag = $8fc97680f2a1b34a$var$InternalTag;
$8fc97680f2a1b34a$var$Tag.CheckableTag = (0, $898aaea1775edea0$export$2e2bcd8739ae039);
$8fc97680f2a1b34a$var$Tag.CheckableTagGroup = (0, $ba7a8dd02bba8dd0$export$2e2bcd8739ae039);
var $8fc97680f2a1b34a$export$2e2bcd8739ae039 = $8fc97680f2a1b34a$var$Tag;



var $5pSp9 = parcelRequire("5pSp9");

var $5E6i4 = parcelRequire("5E6i4");








const $ce8d4034349042ca$export$64871731f2699300 = 'suggestions';
const { CheckableTag: $ce8d4034349042ca$var$CheckableTag } = (0, $8fc97680f2a1b34a$export$2e2bcd8739ae039);
const { Title: $ce8d4034349042ca$var$Title } = (0, $1356cdf58e4737d7$export$2e2bcd8739ae039);
const $ce8d4034349042ca$var$AlignedButton = (0, $07090e743135ae89$export$2e2bcd8739ae039)((0, $67d71c16fdfc3a0e$export$2e2bcd8739ae039))`
  align-items: center;
  display: flex;
  justify-content: center;

  .ant-btn-loading-icon {
    display: flex;
  }
`;
const $ce8d4034349042ca$var$AlignedSpin = (0, $07090e743135ae89$export$2e2bcd8739ae039)((0, $ae2aafd1f3045853$export$2e2bcd8739ae039))`
  display: flex;

  .ant-spin {
    line-height: unset;
  }
`;
const $ce8d4034349042ca$var$CompactCheckableTag = (0, $07090e743135ae89$export$2e2bcd8739ae039)($ce8d4034349042ca$var$CheckableTag)`
  margin: 0 !important;
  margin-right: 0.25rem !important;
`;
const $ce8d4034349042ca$var$CompressedBadge = (0, $07090e743135ae89$export$2e2bcd8739ae039)((0, $df6cdd65e5b6fc4b$export$2e2bcd8739ae039))`
  line-height: normal;
`;
/*
 * The classes of the states never compete for the same property: Tailwind 4 orders competing utilities differently
 * than Tailwind 3 (e.g. border-blue-500 before border-gray-300). This reproduces the Tailwind 3 result, in which a
 * hover:border-gray-300 of disabled images lost against hover:border-blue-500.
 */ const $ce8d4034349042ca$var$checkedStyles = 'border-blue-500 border-2';
const $ce8d4034349042ca$var$uncheckedStyles = 'border-gray-300';
const $ce8d4034349042ca$var$disabledStyles = 'cursor-not-allowed opacity-25';
const $ce8d4034349042ca$var$enabledStyles = 'cursor-pointer';
/**
 * The operators of a discovered family: how many of its entries each relates to the first entry (backend relations,
 * see operatorOfRelation), and which of them are highlighted in the sheet and the timeline.
 */ const $ce8d4034349042ca$var$FamilySuggestions = ({ family: { color: color, family: family, hiddenOperators: hiddenOperators, isShown: isShown, label: label, name: name, ...on } })=>{
    const { t: translate } = (0, $705ab703c44be5bc$export$9fc83ad70ead8663)();
    const entriesOf = (operator)=>family.occurrences.filter((entry)=>(0, $e1cb3d9aadafb6a6$export$a7dac0142870f4ff)(entry.relation) === operator);
    const asWritten = family.occurrences.filter((entry)=>(0, $e1cb3d9aadafb6a6$export$a7dac0142870f4ff)(entry.relation) === undefined).length;
    const related = family.occurrences.length - asWritten;
    const available = (0, $e5b6a001e5093ab5$export$6adedf16424adf7b).filter((operator)=>entriesOf(operator).length > 0);
    const shown = available.filter((operator)=>!hiddenOperators.includes(operator));
    const allShown = available.length > 0 && shown.length === available.length;
    const toggle = (operator)=>on.onHideOperators(hiddenOperators.includes(operator) ? hiddenOperators.filter((hidden)=>hidden !== operator) : [
            ...hiddenOperators,
            operator
        ]);
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
        className: "mb-5 mt-3 flex flex-col",
        "data-family": family.label,
        id: "suggestions-family",
        children: [
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
                className: "flex items-center gap-1.5",
                children: [
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("span", {
                        className: "flex h-6 min-w-6 shrink-0 items-center justify-center rounded-full px-1 text-xs font-bold",
                        style: {
                            background: color,
                            color: (0, $a9ceb34ac62682a2$export$2e2bcd8739ae039).mostReadable(color, [
                                '#ffffff',
                                '#0b0b0b'
                            ]).toHexString()
                        },
                        children: label
                    }),
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("span", {
                        className: "text-sm font-semibold text-slate-900",
                        children: name
                    })
                ]
            }),
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("p", {
                className: "m-0 mt-1 text-xs text-slate-600",
                id: "suggestions-family-summary",
                children: translate('suggestions.family.summary', {
                    entries: translate('family.entries', {
                        count: family.occurrences.length
                    }),
                    related: related,
                    self: asWritten
                })
            }),
            !isShown && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("p", {
                className: "m-0 mt-1 flex flex-wrap items-center gap-1 text-xs text-slate-600",
                children: [
                    translate('suggestions.family.hidden'),
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $67d71c16fdfc3a0e$export$2e2bcd8739ae039), {
                        onClick: on.onShow,
                        size: "small",
                        type: "link",
                        children: translate('suggestions.family.show')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
                className: "mb-4 mt-4 flex flex-col",
                children: [
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $1bb718ecb5669b36$export$2e2bcd8739ae039), {
                        placement: "right",
                        title: translate('suggestions.family.all'),
                        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $7f1dcd4b821f85a8$export$2e2bcd8739ae039), {
                            checked: allShown,
                            className: "!mb-2 !ml-1 self-start",
                            disabled: available.length === 0,
                            indeterminate: shown.length > 0 && !allShown,
                            onChange: ()=>on.onHideOperators(allShown ? [
                                    ...new Set([
                                        ...hiddenOperators,
                                        ...available
                                    ])
                                ] : hiddenOperators.filter((hidden)=>!available.includes(hidden))),
                            children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
                                className: "flex items-center",
                                children: [
                                    translate('suggestions.operators.all.title'),
                                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $df6cdd65e5b6fc4b$export$2e2bcd8739ae039), {
                                        className: "!ml-1.5",
                                        count: related,
                                        showZero: true,
                                        size: "small",
                                        style: {
                                            backgroundColor: '#1890ff'
                                        }
                                    })
                                ]
                            })
                        })
                    }),
                    (0, $e5b6a001e5093ab5$export$6adedf16424adf7b).map((operator)=>{
                        const entries = entriesOf(operator);
                        const isDisabled = entries.length === 0;
                        const isChecked = !isDisabled && !hiddenOperators.includes(operator);
                        const title = translate(`suggestions.operators.${operator}.title`);
                        return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $1bb718ecb5669b36$export$2e2bcd8739ae039), {
                            placement: "right",
                            title: isDisabled ? (0, $e1cb3d9aadafb6a6$export$65a30acd6eb445c4).includes(operator) ? translate('suggestions.family.none', {
                                label: label
                            }) : translate('suggestions.family.notSearched') : translate('suggestions.family.toggle', {
                                count: entries.length
                            }),
                            children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
                                className: "grid mt-3",
                                "data-operator": operator,
                                onMouseEnter: ()=>!isDisabled && on.onHoverOccurrences(entries),
                                onMouseLeave: ()=>!isDisabled && on.onHoverOccurrences([]),
                                style: {
                                    gridTemplateColumns: 'fit-content(20%) fit-content(80%)'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($ce8d4034349042ca$var$CompressedBadge, {
                                        className: "!mr-2",
                                        color: "blue",
                                        count: entries.length,
                                        offset: [
                                            0,
                                            1
                                        ],
                                        size: "small",
                                        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("button", {
                                            "aria-checked": isChecked,
                                            "aria-disabled": isDisabled,
                                            "aria-label": title,
                                            className: "p-0",
                                            onClick: ()=>!isDisabled && toggle(operator),
                                            role: "checkbox",
                                            style: {
                                                background: 'transparent',
                                                border: 0,
                                                display: 'block'
                                            },
                                            type: "button",
                                            children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("img", {
                                                alt: operator,
                                                className: `block p-0.5 border border-solid rounded ${isDisabled ? '' : 'hover:border-blue-500'} ${isChecked ? $ce8d4034349042ca$var$checkedStyles : $ce8d4034349042ca$var$uncheckedStyles} ${isDisabled ? $ce8d4034349042ca$var$disabledStyles : $ce8d4034349042ca$var$enabledStyles}`,
                                                height: 24,
                                                src: (0, $e5b6a001e5093ab5$export$95535b6ba8828fcd)(operator),
                                                width: 24
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
                                        className: `flex flex-col leading-none ${isDisabled ? 'opacity-50' : ''}`,
                                        style: {
                                            fontSize: 'small'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("span", {
                                                className: "font-bold",
                                                children: title
                                            }),
                                            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("span", {
                                                className: "mt-0.5",
                                                children: operator === (0, $e5b6a001e5093ab5$export$fa5f90bfb4dbdbcd).DEVIATION ? translate('suggestions.family.deviation') : translate(`suggestions.operators.${operator}.description`)
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, operator);
                    })
                ]
            }),
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("p", {
                className: "m-0 text-xs text-slate-500",
                children: translate('suggestions.family.searchHint')
            })
        ]
    });
};
const $ce8d4034349042ca$var$Suggestions = ({ configuringID: configuringID, family: family, hoveredPatternIDs: hoveredPatternIDs, musicSheetID: musicSheetID, newPattern: newPattern, noteElements: noteElements, patterns: patterns, setConfiguringID: setConfiguringID, setHoveredPatternIDs: setHoveredPatternIDs, setNewPattern: setNewPattern, setPatterns: setPatterns, setSuggestingID: setSuggestingID, setVisibleOperatorsByDefault: setVisibleOperatorsByDefault, suggestingID: suggestingID, visibleOperatorsByDefault: visibleOperatorsByDefault })=>{
    const [deviationPercentages, setDeviationPercentages] = (0, $5E6i4.useState)(new Map());
    const [isTonal, setIsTonal] = (0, $5E6i4.useState)(true);
    const { loadingStatus: loadingStatus, updateDeviationOperator: updateDeviationOperator } = (0, $19aaa313855abf25$export$2e2bcd8739ae039)(musicSheetID, noteElements, newPattern, deviationPercentages.get(configuringID) || (0, $9ecda7333d28e490$export$9ca2902b8ce32929), isTonal, patterns, setNewPattern, setPatterns);
    const [selection] = (0, $5E6i4.useContext)((0, $ca0029180522dabd$export$7c7a4fd7f1336e2c));
    const [visibleOperators, setVisibleOperators] = (0, $5E6i4.useState)(new Map());
    const { t: translate } = (0, $705ab703c44be5bc$export$9fc83ad70ead8663)();
    const configuringPattern = patterns.find((pattern)=>pattern.id === configuringID);
    const patternsConnected = patterns.find((pattern)=>pattern.id === configuringID)?.connectedToByOperator.length || 0;
    // "All" means every operator that found related patterns (audit ISSUE-020: it compared with all eight).
    const availableOperators = Object.values((0, $e5b6a001e5093ab5$export$fa5f90bfb4dbdbcd)).filter((operator)=>configuringPattern?.connectedToByOperator.some((target)=>target.byOperator === operator));
    const allAvailableVisible = availableOperators.length > 0 && availableOperators.every((operator)=>(visibleOperators.get(configuringID) ?? []).includes(operator));
    const makePatternVisible = ()=>setPatterns((oldPatterns)=>{
            const oldPattern = oldPatterns.find(({ id: id })=>id === configuringID);
            if (oldPattern) oldPattern.connectedToByOperator.forEach((target)=>{
                const targetPattern = oldPatterns.find(({ id: id })=>id === target.id);
                if (targetPattern) targetPattern.isVisible = visibleOperators.get(configuringID).contains(target.byOperator);
            });
            return [
                ...oldPatterns
            ];
        });
    (0, $5E6i4.useEffect)(()=>{
        patterns.forEach((pattern)=>{
            if (!deviationPercentages.has(pattern.id)) setDeviationPercentages((oldDeviationPercentages)=>new Map(oldDeviationPercentages).set(pattern.id, (0, $9ecda7333d28e490$export$9ca2902b8ce32929)));
            if (!visibleOperators.has(pattern.id)) setVisibleOperators((oldVisibleOperators)=>new Map(oldVisibleOperators).set(pattern.id, visibleOperatorsByDefault));
        });
    }, [
        patterns
    ]);
    (0, $5E6i4.useEffect)(()=>{
        if (configuringPattern) setPatterns((oldPatterns)=>{
            const oldPattern = oldPatterns.find(({ id: id })=>id === configuringID);
            if (oldPattern) oldPattern.connectedToByOperator.forEach(({ id: connectedPatternID, byOperator: byOperator })=>{
                const connectedPattern = oldPatterns.find(({ id: id })=>id === connectedPatternID);
                if (connectedPattern) connectedPattern.isVisible = visibleOperators.get(configuringID).contains(byOperator);
            });
            return [
                ...oldPatterns
            ];
        });
    }, [
        visibleOperators
    ]);
    // A parameter of the operators (paper 7.2): tonal variants keep the scale steps, real ones the semitones. It applies
    // to the next search too, so it stays at hand while no pattern is selected.
    const tonalSwitch = /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
        className: "mt-3 flex items-center justify-center gap-1.5 text-xs",
        children: [
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $bccd02a83058d871$export$2e2bcd8739ae039), {
                "aria-label": translate('suggestions.tonal'),
                checked: isTonal,
                onChange: setIsTonal,
                size: "small"
            }),
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("span", {
                children: translate('suggestions.tonal')
            }),
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $1bb718ecb5669b36$export$2e2bcd8739ae039), {
                title: translate('suggestions.tonalTooltip'),
                children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $f572dd29a59c22b6$export$2e2bcd8739ae039), {})
            })
        ]
    });
    const title = /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)($ce8d4034349042ca$var$Title, {
        className: "flex items-center",
        level: 5,
        children: [
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $b38986e5c635d7ef$export$2e2bcd8739ae039), {
                className: "mr-1",
                twoToneColor: "orange"
            }),
            translate('suggestions.title')
        ]
    });
    // A discovered family: its entries by operator. Neither a family nor an own pattern: a hint instead of a wall of
    // disabled operators.
    if (family && (!configuringPattern || configuringID === `family-${family.family.label}`)) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
        className: "mb-5 mt-5 pr-2.5 flex flex-col",
        id: $ce8d4034349042ca$export$64871731f2699300,
        children: [
            title,
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($ce8d4034349042ca$var$FamilySuggestions, {
                family: family
            }, family.family.label)
        ]
    });
    if (!configuringPattern) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
        className: "mb-5 mt-5 pr-2.5 flex flex-col",
        id: $ce8d4034349042ca$export$64871731f2699300,
        children: [
            title,
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("p", {
                className: "m-0 mt-3 text-sm text-slate-500",
                id: "suggestions-hint",
                children: translate('suggestions.hint')
            }),
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("div", {
                className: "mt-6",
                children: tonalSwitch
            })
        ]
    });
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
        className: "mb-5 mt-5 pr-2.5 flex flex-col",
        id: $ce8d4034349042ca$export$64871731f2699300,
        children: [
            title,
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
                className: "mb-8 mt-5 flex flex-col",
                children: [
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $7f1dcd4b821f85a8$export$2e2bcd8739ae039), {
                        checked: allAvailableVisible,
                        className: "!mb-2 !ml-1",
                        disabled: !configuringPattern || configuringPattern.connectedToByOperator.length === 0 || Array.from(loadingStatus.values()).some((isLoading)=>isLoading) || selection.focusingID !== undefined,
                        indeterminate: (visibleOperators.get(configuringID)?.length ?? 0) > 0 && !allAvailableVisible,
                        onChange: ()=>{
                            setVisibleOperators((previouslyVisibleOperators)=>{
                                previouslyVisibleOperators.set(configuringID, allAvailableVisible ? [] : availableOperators);
                                return new Map(previouslyVisibleOperators);
                            });
                            makePatternVisible();
                        },
                        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                translate('suggestions.operators.all.title'),
                                /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $df6cdd65e5b6fc4b$export$2e2bcd8739ae039), {
                                    className: "!ml-1.5",
                                    count: patternsConnected,
                                    size: "small",
                                    style: {
                                        backgroundColor: '#1890ff'
                                    }
                                })
                            ]
                        })
                    }),
                    (0, $e5b6a001e5093ab5$export$6adedf16424adf7b).map((operator)=>{
                        const patternsConnectedByOperator = patterns.find((pattern)=>pattern.id === configuringID)?.connectedToByOperator.filter((source)=>source.byOperator === operator).length || 0;
                        const isAccepted = configuringID !== undefined && suggestingID === undefined;
                        const isChecked = visibleOperators.get(configuringID)?.includes(operator);
                        const isLoading = loadingStatus.has(operator) && loadingStatus.get(operator);
                        const isDisabled = !configuringPattern || patternsConnectedByOperator === 0 || isLoading || selection.focusingID !== undefined;
                        return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
                            className: "grid mt-3",
                            onMouseEnter: ()=>{
                                if (isDisabled) return;
                                const hoveredPatternIDs = patterns.find((pattern)=>pattern.id === configuringID)?.connectedToByOperator.filter((target)=>target.byOperator === operator).map((connection)=>connection.id);
                                setPatterns((oldPatterns)=>{
                                    oldPatterns.forEach((oldPattern)=>{
                                        if (hoveredPatternIDs.includes(oldPattern.id)) oldPattern.isVisible = true;
                                    });
                                    return [
                                        ...oldPatterns
                                    ];
                                });
                                setHoveredPatternIDs(hoveredPatternIDs);
                            },
                            onMouseLeave: ()=>{
                                if (isDisabled) return;
                                setPatterns((oldPatterns)=>{
                                    oldPatterns.forEach((oldPattern)=>{
                                        if (hoveredPatternIDs.includes(oldPattern.id)) oldPattern.isVisible = isChecked;
                                    });
                                    setHoveredPatternIDs([]);
                                    return [
                                        ...oldPatterns
                                    ];
                                });
                            },
                            style: {
                                gridTemplateColumns: 'fit-content(20%) fit-content(80%)'
                            },
                            children: [
                                /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($ce8d4034349042ca$var$CompressedBadge, {
                                    className: "!mr-2",
                                    color: "blue",
                                    count: patternsConnectedByOperator,
                                    offset: [
                                        0,
                                        1
                                    ],
                                    size: "small",
                                    children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("img", {
                                        alt: operator,
                                        className: `p-0.5 border border-solid hover:border-blue-500 rounded ${isChecked ? $ce8d4034349042ca$var$checkedStyles : $ce8d4034349042ca$var$uncheckedStyles} ${isDisabled ? $ce8d4034349042ca$var$disabledStyles : $ce8d4034349042ca$var$enabledStyles}`,
                                        height: 24,
                                        onClick: ()=>{
                                            if (isDisabled) return;
                                            setPatterns((oldPatterns)=>{
                                                const oldPattern = oldPatterns.find(({ id: id })=>id === configuringID);
                                                if (oldPattern) oldPattern.connectedToByOperator.forEach((target)=>{
                                                    const targetPattern = oldPatterns.find(({ id: id })=>id === target.id);
                                                    if (targetPattern) targetPattern.isVisible = !isChecked;
                                                });
                                                return [
                                                    ...oldPatterns
                                                ];
                                            });
                                            setVisibleOperators((previouslyVisibleOperators)=>{
                                                const newVisibleOperators = isChecked ? previouslyVisibleOperators.get(configuringID).filter((visibleOperator)=>visibleOperator !== operator) : previouslyVisibleOperators.get(configuringID).concat(operator);
                                                previouslyVisibleOperators.set(configuringID, newVisibleOperators);
                                                return new Map(previouslyVisibleOperators);
                                            });
                                        },
                                        src: (0, $e5b6a001e5093ab5$export$95535b6ba8828fcd)(operator),
                                        width: 24
                                    })
                                }),
                                /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
                                    className: "flex flex-col leading-none",
                                    style: {
                                        fontSize: 'small'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
                                            className: "flex items-center",
                                            children: [
                                                /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("span", {
                                                    className: "font-bold",
                                                    children: translate(`suggestions.operators.${operator}.title`)
                                                }),
                                                isLoading && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($ce8d4034349042ca$var$AlignedSpin, {
                                                    className: "!ml-1",
                                                    indicator: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $6e3183dc0ea574da$export$2e2bcd8739ae039), {
                                                        style: {
                                                            fontSize: 'small'
                                                        },
                                                        spin: true
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("span", {
                                            className: "mt-0.5",
                                            children: operator === (0, $e5b6a001e5093ab5$export$fa5f90bfb4dbdbcd).DEVIATION ? /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $88057c7a4a6367ee$export$8d6a9236f2e3f2ce), {
                                                components: [
                                                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($ce8d4034349042ca$var$ChangeableDeviationPercentage, {
                                                        deviationPercentage: deviationPercentages.get(configuringID) || (0, $9ecda7333d28e490$export$9ca2902b8ce32929),
                                                        isDisabled: isDisabled || isAccepted,
                                                        setDeviationPercentage: (newDeviationPercentage)=>{
                                                            setDeviationPercentages((oldDeviationPercentages)=>new Map(oldDeviationPercentages).set(configuringID, newDeviationPercentage));
                                                            updateDeviationOperator(configuringID, newDeviationPercentage);
                                                        }
                                                    })
                                                ],
                                                i18nKey: `suggestions.operators.${operator}.description`,
                                                values: {
                                                    deviationPercentage: deviationPercentages
                                                }
                                            }) : translate(`suggestions.operators.${operator}.description`)
                                        })
                                    ]
                                })
                            ]
                        }, operator);
                    }),
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
                        className: "mt-6 flex items-center justify-center text-xs",
                        children: [
                            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($ce8d4034349042ca$var$CompactCheckableTag, {
                                checked: (0, $5pSp9.isEqual)(visibleOperatorsByDefault, visibleOperators.get(configuringID)),
                                onChange: (checked)=>checked && setVisibleOperatorsByDefault(visibleOperators.get(configuringID)),
                                children: translate('suggestions.useAsDefault')
                            }),
                            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $1bb718ecb5669b36$export$2e2bcd8739ae039), {
                                title: translate('suggestions.useAsDefaultTooltip'),
                                children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $f572dd29a59c22b6$export$2e2bcd8739ae039), {})
                            })
                        ]
                    }),
                    tonalSwitch
                ]
            }),
            suggestingID !== undefined && configuringPattern?.isUserDefined && // Sticky, so the decision stays in view however long the list of operators is (audit ISSUE-004).
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
                className: "sticky bottom-0 z-[1] flex flex-col bg-white pb-2 pt-2",
                children: [
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($ce8d4034349042ca$var$AlignedButton, {
                        className: "mb-1 self-center",
                        icon: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $9eb4119242359573$export$2e2bcd8739ae039), {}),
                        loading: Array.from(loadingStatus.values()).some((isLoading)=>isLoading),
                        onClick: ()=>{
                            makePatternVisible();
                            setConfiguringID(undefined);
                            setNewPattern(undefined);
                            setSuggestingID(undefined);
                        },
                        size: "small",
                        type: "primary",
                        children: translate('suggestions.accept')
                    }),
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($ce8d4034349042ca$var$AlignedButton, {
                        className: "self-center",
                        danger: true,
                        icon: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $80d24bc031ad50e3$export$2e2bcd8739ae039), {}),
                        loading: Array.from(loadingStatus.values()).some((isLoading)=>isLoading),
                        onClick: ()=>{
                            setPatterns((oldPatterns)=>{
                                const oldPattern = oldPatterns.find(({ id: id })=>id === suggestingID);
                                const oldPatternIndex = oldPatterns.findIndex(({ id: id })=>id === suggestingID);
                                if (oldPattern && oldPatternIndex !== -1) {
                                    oldPattern.connectedToByOperator.forEach(({ id: connectedID })=>{
                                        const oldConnectedPatternIndex = oldPatterns.findIndex(({ id: id })=>id === connectedID);
                                        if (oldConnectedPatternIndex !== -1) oldPatterns.splice(oldConnectedPatternIndex, 1);
                                    });
                                    oldPatterns.splice(oldPatternIndex, 1);
                                }
                                return [
                                    ...oldPatterns
                                ];
                            });
                            setVisibleOperators((previouslyVisibleOperators)=>{
                                previouslyVisibleOperators.delete(suggestingID);
                                return new Map(previouslyVisibleOperators);
                            });
                            setConfiguringID(undefined);
                            setNewPattern(undefined);
                            setSuggestingID(undefined);
                        },
                        size: "small",
                        type: "primary",
                        children: translate('suggestions.decline')
                    })
                ]
            }),
            suggestingID === undefined && configuringID !== undefined && !configuringPattern?.isUserDefined && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $90cae257cc958273$exports.Fragment), {
                children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($ce8d4034349042ca$var$AlignedButton, {
                    className: "self-center",
                    disabled: configuringPattern.hasBeenQueried,
                    icon: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $f9679d6a5def8308$export$2e2bcd8739ae039), {}),
                    onClick: ()=>setNewPattern(configuringPattern),
                    size: "small",
                    type: "primary",
                    children: translate('suggestions.generate')
                })
            })
        ]
    });
};
const $ce8d4034349042ca$var$ChangeableDeviationPercentage = ({ deviationPercentage: deviationPercentage, isDisabled: isDisabled, setDeviationPercentage: setDeviationPercentage })=>{
    const maximum = 50;
    const minimum = 5;
    const { t: translate } = (0, $705ab703c44be5bc$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $93eb2f6d46bfe5a2$export$2e2bcd8739ae039), {
        content: ()=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("span", {
                                className: "flex-1 mr-1 text-gray-500 text-xs whitespace-nowrap",
                                children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("i", {
                                    children: [
                                        minimum,
                                        " %"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $e720e40d3dabd8a5$export$2e2bcd8739ae039), {
                                autoFocus: true,
                                className: "w-[90%]",
                                defaultValue: deviationPercentage,
                                disabled: isDisabled,
                                max: maximum,
                                min: minimum,
                                onChangeComplete: setDeviationPercentage
                            }),
                            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("span", {
                                className: "flex-1 ml-1 text-gray-500 text-xs whitespace-nowrap",
                                children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("i", {
                                    children: [
                                        maximum,
                                        " %"
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("span", {
                        className: "block pb-1.5 text-gray-500 leading-none",
                        style: {
                            fontSize: 11
                        },
                        children: translate('suggestions.operators.deviation.disclaimer')
                    })
                ]
            }),
        id: "deviation-percentage-slider",
        styles: {
            container: {
                padding: '0 0.5rem'
            },
            content: {
                padding: 0
            },
            root: {
                width: 250
            }
        },
        trigger: "click",
        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("button", {
            "aria-label": translate('suggestions.deviationThreshold', {
                percentage: deviationPercentage
            }),
            className: "cursor-pointer p-0 font-bold",
            style: {
                background: 'transparent',
                border: 0,
                color: (0, $37058c64b679ada5$export$2aa0182783e7e9de).primary,
                font: 'inherit'
            },
            type: "button",
            children: [
                deviationPercentage,
                " %"
            ]
        })
    });
};
var $ce8d4034349042ca$export$2e2bcd8739ae039 = $ce8d4034349042ca$var$Suggestions;






var $5pSp9 = parcelRequire("5pSp9");

var $5E6i4 = parcelRequire("5E6i4");







// @visx/visx re-exports every visx package as a namespace.
const { ParentSize: $63f88f8247c03421$var$ParentSize } = (0, $c54f2a1238da1ae4$exports);
const { scaleLinear: $63f88f8247c03421$var$scaleLinear } = (0, $b2a13829cfbee039$exports);
const { Line: $63f88f8247c03421$var$Line } = (0, $236064fbb945a850$exports);
const { Text: $63f88f8247c03421$var$Text } = (0, $eff7bcaf5d7bfb95$exports);
const $63f88f8247c03421$export$47d16f31bd7c7a56 = 'timeline';
// The pointer has to rest this long on the timeline before the sheet turns to the page below it: moving across the
// timeline to the views below no longer flips pages (audit ISSUE-012), while resting on it does as in the paper.
const $63f88f8247c03421$var$pageDwell = 250;
// Text of the occurrence marks: xx-small is about 9 px, i.e. about 5.5 px per character.
const $63f88f8247c03421$var$characterWidth = 5.5;
/** The label as far as it fits on its mark (audit ISSUE-015: "C..." stood for CS1, CS2 and every other label). */ const $63f88f8247c03421$var$fittingLabel = (label, width)=>{
    const fitting = Math.floor((width - 2) / $63f88f8247c03421$var$characterWidth);
    if (label.length <= Math.max(fitting, 1)) return label;
    // Without room for an ellipsis the first characters stay, e.g. A' for A'''' (not A, which is another pattern).
    return fitting <= 2 ? label.slice(0, Math.max(fitting, 1)) : `${label.slice(0, fitting - 1)}\u{2026}`;
};
const $63f88f8247c03421$var$toSVG = (svg, position)=>{
    const domPoint = new DOMPoint(position.x, position.y);
    const transformMatrix = svg.getScreenCTM();
    const translatedPoint = domPoint.matrixTransform(transformMatrix.inverse());
    return {
        x: translatedPoint.x,
        y: translatedPoint.y
    };
};
const $63f88f8247c03421$var$Timeline = ({ absoluteOffsetPageMap: absoluteOffsetPageMap, hoveredOccurrenceIndex: hoveredOccurrenceIndex, hoveredOccurrences: hoveredOccurrences, hoveredPatternIDs: hoveredPatternIDs, onPlayOccurrence: onPlayOccurrence, patterns: patterns, playingOccurrenceKey: playingOccurrenceKey, selectedMusicSheet: selectedMusicSheet, setConfiguringID: setConfiguringID, setCurrentPage: setCurrentPage, setHoveredOccurrenceIndex: setHoveredOccurrenceIndex, setHoveredPatternIDs: setHoveredPatternIDs, voices: voices })=>{
    const { t: translate } = (0, $705ab703c44be5bc$export$9fc83ad70ead8663)();
    const pageTimer = (0, $5E6i4.useRef)(undefined);
    const leftPadding = 50;
    const padding = 25;
    // Below the page labels, every voice gets a band of the same height; its line runs through the middle.
    const topMargin = 14;
    const bottomMargin = 4;
    const voiceCount = voices.length;
    const voiceLineWidth = 1;
    return(// visx 4 renders the children absolutely positioned: without flexShrink the flex column would squeeze the timeline.
    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($63f88f8247c03421$var$ParentSize, {
        className: "mr-5",
        id: $63f88f8247c03421$export$47d16f31bd7c7a56,
        parentSizeStyles: {
            flexShrink: 0,
            height: 250
        },
        children: (parent)=>{
            const lineWidth = parent.width - leftPadding - padding;
            const bandHeight = (parent.height - topMargin - bottomMargin) / Math.max(voiceCount, 1);
            const pageLabelSpacing = 48;
            let lastPageLabelX = -Infinity;
            const offsetsByPage = (0, $5pSp9.groupBy)(Array.from(absoluteOffsetPageMap.entries()), ([, page])=>page);
            const offsetScale = $63f88f8247c03421$var$scaleLinear({
                domain: [
                    0,
                    selectedMusicSheet?.lastOffset
                ],
                range: [
                    0,
                    lineWidth
                ],
                round: true
            });
            const svg = (0, $5E6i4.useRef)(null);
            /** The page of the sheet that shows the music below the pointer. */ const pageAt = (event)=>{
                const { x: x } = $63f88f8247c03421$var$toSVG(svg.current, {
                    x: event.clientX,
                    y: event.clientY
                });
                if (x < leftPadding || x > leftPadding + lineWidth) return undefined;
                const offset = offsetScale.invert(x - leftPadding);
                let page = 1;
                for (const [pageOffset, pageOfOffset] of absoluteOffsetPageMap.entries()){
                    if (offset > pageOffset) page = pageOfOffset;
                    else break;
                }
                return page;
            };
            if (selectedMusicSheet === undefined || absoluteOffsetPageMap.size === 0) return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("div", {
                className: "animate-pulse",
                style: {
                    height: 150
                },
                children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("div", {
                    className: "w-full h-full mb-3 mt-3 rounded-md bg-gray-200"
                })
            });
            else return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("svg", {
                height: parent.height,
                onClick: (event)=>{
                    const page = pageAt(event);
                    window.clearTimeout(pageTimer.current);
                    if (page !== undefined) setCurrentPage(page);
                },
                onMouseLeave: ()=>window.clearTimeout(pageTimer.current),
                onMouseMove: (event)=>{
                    const page = pageAt(event);
                    window.clearTimeout(pageTimer.current);
                    if (page !== undefined) pageTimer.current = window.setTimeout(()=>setCurrentPage(page), $63f88f8247c03421$var$pageDwell);
                },
                ref: svg,
                width: parent.width,
                children: [
                    Object.values(offsetsByPage).map((offsets, pageIndex)=>{
                        if (pageIndex === 0) return null;
                        const firstPageOffset = offsets[0][0];
                        const x = leftPadding + offsetScale(firstPageOffset);
                        // Narrow timelines of long pieces label only every so many page breaks.
                        const showLabel = x - lastPageLabelX >= pageLabelSpacing;
                        if (showLabel) lastPageLabelX = x;
                        return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("g", {
                            children: [
                                showLabel && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("text", {
                                    fill: "#5b6472",
                                    style: {
                                        fontSize: 10,
                                        textAnchor: 'middle'
                                    },
                                    x: x,
                                    y: 9,
                                    children: translate('timeline.page', {
                                        page: pageIndex + 1
                                    })
                                }),
                                /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($63f88f8247c03421$var$Line, {
                                    from: {
                                        x: x,
                                        y: 12
                                    },
                                    style: {
                                        stroke: 'grey',
                                        strokeDasharray: 2,
                                        strokeOpacity: (0, $9ecda7333d28e490$export$7395e4cb572e863b),
                                        strokeWidth: voiceLineWidth
                                    },
                                    to: {
                                        x: x,
                                        y: parent.height - 10
                                    }
                                }, pageIndex)
                            ]
                        }, pageIndex);
                    }),
                    voices.map((voice, index)=>/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($63f88f8247c03421$var$VoiceLine, {
                            hoveredOccurrenceIndex: hoveredOccurrenceIndex,
                            hoveredOccurrences: hoveredOccurrences,
                            hoveredPatternIDs: hoveredPatternIDs,
                            bandHeight: bandHeight,
                            lastOffset: selectedMusicSheet?.lastOffset,
                            leftPadding: leftPadding,
                            lineWidth: lineWidth,
                            parentWidth: parent.width,
                            patterns: patterns.filter((pattern)=>pattern.occurrences.some((occurrence)=>occurrence.voiceNumber === voice.number)),
                            onPlayOccurrence: onPlayOccurrence,
                            playingOccurrenceKey: playingOccurrenceKey,
                            setConfiguringID: setConfiguringID,
                            setHoveredOccurrenceIndex: setHoveredOccurrenceIndex,
                            setHoveredPatternIDs: setHoveredPatternIDs,
                            voice: voice,
                            voiceLineWidth: voiceLineWidth,
                            y: topMargin + bandHeight * (index + 0.5)
                        }, voice.number))
                ]
            });
        }
    }));
};
const $63f88f8247c03421$var$VoiceLine = ({ bandHeight: bandHeight, hoveredOccurrenceIndex: hoveredOccurrenceIndex, hoveredOccurrences: hoveredOccurrences, hoveredPatternIDs: hoveredPatternIDs, lastOffset: lastOffset, leftPadding: leftPadding, lineWidth: lineWidth, onPlayOccurrence: onPlayOccurrence, parentWidth: parentWidth, patterns: patterns, playingOccurrenceKey: playingOccurrenceKey, setConfiguringID: setConfiguringID, setHoveredOccurrenceIndex: setHoveredOccurrenceIndex, setHoveredPatternIDs: setHoveredPatternIDs, voice: voice, voiceLineWidth: voiceLineWidth, y: y })=>{
    const { t: translate } = (0, $705ab703c44be5bc$export$9fc83ad70ead8663)();
    const [selection] = (0, $5E6i4.useContext)((0, $ca0029180522dabd$export$7c7a4fd7f1336e2c));
    const [theme] = (0, $5E6i4.useContext)((0, $3c154bbb0fa44c80$export$2c657da244d00bd6));
    const color = theme.colorByVoice || theme.colorVoices ? voice.color : (0, $9ecda7333d28e490$export$d87c4465c591a827);
    const label = translate('family.voice', {
        voice: voice.number
    });
    const offsetScale = $63f88f8247c03421$var$scaleLinear({
        domain: [
            0,
            lastOffset
        ],
        range: [
            0,
            lineWidth
        ],
        round: true
    });
    const textBackgroundCornerRadius = 2;
    const textHeight = 15;
    const textPadding = 5;
    const textWidth = 35;
    const minimumOccurrenceWidthInOffsets = 2.5;
    const widthOf = (occurrence)=>offsetScale(Math.max(occurrence.lastOffset - occurrence.firstOffset, minimumOccurrenceWidthInOffsets));
    const visibleOccurrences = lastOffset ? patterns.filter((pattern)=>pattern.isVisible && (selection.focusingID === undefined || selection.focusingID === pattern.id)).flatMap((pattern)=>pattern.occurrences.filter((occurrence)=>occurrence.voiceNumber === voice.number).map((occurrence, occurrenceIndex)=>({
                occurrence: occurrence,
                occurrenceIndex: occurrenceIndex,
                pattern: pattern
            }))) : [];
    // Overlapping occurrences get lanes of their own (audit ISSUE-014: they were drawn on top of each other). Greedy
    // interval partitioning in pixels; the lanes share the voice's band and become thinner when there are many.
    const laneEnds = [];
    const laneOf = new Map();
    [
        ...visibleOccurrences
    ].sort((first, second)=>first.occurrence.firstOffset - second.occurrence.firstOffset).forEach((item)=>{
        const start = offsetScale(item.occurrence.firstOffset);
        let lane = laneEnds.findIndex((end)=>end < start);
        if (lane === -1) lane = laneEnds.length;
        laneEnds[lane] = start + widthOf(item.occurrence);
        laneOf.set(item, lane);
    });
    const laneGap = 2;
    const laneCount = Math.min(Math.max(laneEnds.length, 1), Math.max(1, Math.floor((bandHeight - 6) / 10)));
    const occurrenceHeight = Math.min(20, (bandHeight - 6) / laneCount - laneGap);
    const lanesTop = y - (laneCount * occurrenceHeight + (laneCount - 1) * laneGap) / 2;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("g", {
        children: [
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("rect", {
                fill: color,
                fillOpacity: (0, $9ecda7333d28e490$export$da8fddcadef8a54b),
                height: textHeight,
                rx: textBackgroundCornerRadius,
                ry: textBackgroundCornerRadius,
                width: textWidth + textPadding * 2,
                x: 0,
                y: y - textHeight / 2
            }),
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("text", {
                fill: (0, $a9ceb34ac62682a2$export$2e2bcd8739ae039).mostReadable(color, [
                    '#000',
                    '#808080',
                    '#fff'
                ]).toHexString(),
                style: {
                    dominantBaseline: 'central',
                    fontSize: 'xx-small'
                },
                textLength: textWidth,
                x: textPadding,
                y: y,
                children: label
            }),
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($63f88f8247c03421$var$Line, {
                from: {
                    x: leftPadding,
                    y: y
                },
                style: {
                    stroke: color,
                    strokeOpacity: (0, $9ecda7333d28e490$export$7395e4cb572e863b),
                    strokeWidth: voiceLineWidth
                },
                to: {
                    x: parentWidth,
                    y: y
                }
            }, voice.number),
            visibleOccurrences.map((item)=>{
                const { occurrence: occurrence, occurrenceIndex: occurrenceIndex, pattern: pattern } = item;
                const globalOccurrenceIndex = pattern.occurrences.indexOf(occurrence);
                const debouncedOnMouseEnter = (0, $5pSp9.debounce)(()=>{
                    setHoveredOccurrenceIndex(globalOccurrenceIndex);
                    setHoveredPatternIDs([
                        pattern.id
                    ]);
                }, 150);
                const durationInOffsets = occurrence.lastOffset - occurrence.firstOffset;
                const isPlaying = playingOccurrenceKey === (0, $e5b6a001e5093ab5$export$90f4947a2fe01997)(occurrence);
                const occurrenceWidth = widthOf(occurrence);
                const occurrenceX = leftPadding + offsetScale(occurrence.firstOffset);
                const occurrenceY = lanesTop + (laneOf.get(item) ?? 0) % laneCount * (occurrenceHeight + laneGap);
                const shouldBeTransparent = hoveredPatternIDs.length > 0 && !hoveredPatternIDs.includes(pattern.id) || hoveredOccurrenceIndex !== undefined && globalOccurrenceIndex !== hoveredOccurrenceIndex || hoveredOccurrences.length > 0 && !hoveredOccurrences.some((hoveredOccurrence)=>(0, $e5b6a001e5093ab5$export$973cb4c224e2e27b)(occurrence, hoveredOccurrence));
                return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $7a1d887315ca37d3$export$2e2bcd8739ae039), {
                    hint: translate('timeline.playHint'),
                    pattern: pattern,
                    shouldDisplayDisclaimer: durationInOffsets < minimumOccurrenceWidthInOffsets,
                    children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("g", {
                        onMouseEnter: (event)=>{
                            const group = event.target.tagName === 'g' ? event.target : event.target.parentElement;
                            (0, $4506c173c1ba6b79$export$2e2bcd8739ae039)(group).raise();
                            debouncedOnMouseEnter();
                        },
                        onMouseLeave: ()=>{
                            setHoveredOccurrenceIndex(undefined);
                            setHoveredPatternIDs([]);
                            debouncedOnMouseEnter.cancel();
                        },
                        style: {
                            fillOpacity: shouldBeTransparent ? (0, $9ecda7333d28e490$export$e33e649b64add65d) : (0, $9ecda7333d28e490$export$47a4f6ea72e40329)
                        },
                        children: [
                            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("rect", {
                                className: "cursor-pointer",
                                "data-playing": isPlaying || undefined,
                                fill: pattern.color,
                                height: occurrenceHeight,
                                onClick: ()=>setConfiguringID(pattern.id),
                                onDoubleClick: ()=>onPlayOccurrence(occurrence),
                                rx: 2,
                                ry: 2,
                                // The entry that sounds is outlined.
                                stroke: isPlaying ? '#0b0b0b' : undefined,
                                strokeWidth: isPlaying ? 2 : undefined,
                                width: occurrenceWidth,
                                x: occurrenceX,
                                y: occurrenceY
                            }),
                            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($63f88f8247c03421$var$Text, {
                                // The whole mark configures its pattern, including its label (audit ISSUE-017).
                                pointerEvents: "none",
                                fill: (0, $a9ceb34ac62682a2$export$2e2bcd8739ae039).mostReadable(pattern.color, [
                                    '#000',
                                    '#808080',
                                    '#fff'
                                ]).toHexString(),
                                fontSize: "xx-small",
                                textAnchor: "middle",
                                verticalAnchor: "middle",
                                x: occurrenceX + occurrenceWidth / 2,
                                y: occurrenceY + occurrenceHeight / 2,
                                children: $63f88f8247c03421$var$fittingLabel(pattern.label ?? '', occurrenceWidth)
                            })
                        ]
                    })
                }, `${pattern.id}-${occurrenceIndex}`);
            })
        ]
    });
};
var $63f88f8247c03421$export$2e2bcd8739ae039 = $63f88f8247c03421$var$Timeline;


const $b9ae4ce9d6b4bc54$var$nextFrames = ()=>new Promise((resolve)=>requestAnimationFrame(()=>requestAnimationFrame(()=>resolve())));
// Content and title are translation keys, the tooltip translates them.
const $b9ae4ce9d6b4bc54$var$tourSteps = (showTab)=>{
    // The steps of the analysis column first open their tab, whose content is laid out before the step looks for it.
    const inTab = (tab)=>async ()=>{
            showTab(tab);
            await $b9ae4ce9d6b4bc54$var$nextFrames();
        };
    return [
        {
            content: 'onBoarding.step1.description',
            placement: 'right',
            skipBeacon: true,
            target: `#${(0, $2c02c8dc1811708f$export$37a550b61ef27b21)}`,
            title: 'onBoarding.step1.title'
        },
        {
            content: 'onBoarding.step2.description',
            placement: 'bottom',
            skipBeacon: true,
            target: (0, $2c02c8dc1811708f$export$d6389a1ed25e8b6b),
            title: 'onBoarding.step2.title'
        },
        {
            content: 'onBoarding.step3.description',
            placement: 'bottom',
            skipBeacon: true,
            target: `#${(0, $63f88f8247c03421$export$47d16f31bd7c7a56)}`,
            title: 'onBoarding.step3.title'
        },
        {
            before: inTab('discovery'),
            content: 'onBoarding.discovery.description',
            placement: 'left',
            skipBeacon: true,
            target: `#${(0, $824a58fb00160520$export$7ad4c67c1e638f8e)}`,
            title: 'onBoarding.discovery.title'
        },
        {
            before: inTab('operators'),
            content: 'onBoarding.step4.description',
            placement: 'left',
            skipBeacon: true,
            target: `#${(0, $ce8d4034349042ca$export$64871731f2699300)}`,
            title: 'onBoarding.step4.title'
        },
        {
            before: inTab('operators'),
            content: 'onBoarding.step5.description',
            placement: 'left',
            skipBeacon: true,
            target: `#${(0, $2b5809ac53051808$export$6b145896f7568079)}`,
            title: 'onBoarding.step5.title'
        },
        {
            before: inTab('operators'),
            content: 'onBoarding.step6.description',
            placement: 'top',
            skipBeacon: true,
            target: `#${(0, $a2d27d3e8912bfe6$export$212b69dfa18d3b40)}`,
            title: 'onBoarding.step6.title'
        }
    ];
};
const $b9ae4ce9d6b4bc54$var$Tooltip = ({ continuous: continuous, index: index, size: size, step: step, backProps: backProps, closeProps: closeProps, primaryProps: primaryProps, skipProps: skipProps, tooltipProps: tooltipProps })=>{
    const { t: translate } = (0, $705ab703c44be5bc$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $93eb2f6d46bfe5a2$export$2e2bcd8739ae039), {
            ...tooltipProps,
            content: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)((0, $90cae257cc958273$exports.Fragment), {
                children: [
                    translate(step.content),
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
                        className: "mt-4 flex items-center justify-between gap-4",
                        children: [
                            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $67d71c16fdfc3a0e$export$2e2bcd8739ae039), {
                                ...skipProps,
                                size: "small",
                                type: "link",
                                children: translate('onBoarding.tooltip.skip')
                            }),
                            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("span", {
                                className: "text-xs text-slate-600",
                                style: {
                                    fontVariantNumeric: 'tabular-nums'
                                },
                                children: translate('onBoarding.tooltip.progress', {
                                    current: index + 1,
                                    total: size
                                })
                            }),
                            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $67d71c16fdfc3a0e$export$2e2bcd8739ae039), {
                                        ...backProps,
                                        className: "mr-4",
                                        disabled: index === 0,
                                        size: "small",
                                        children: translate('onBoarding.tooltip.back')
                                    }),
                                    continuous && index < size - 1 ? /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $67d71c16fdfc3a0e$export$2e2bcd8739ae039), {
                                        ...primaryProps,
                                        size: "small",
                                        type: "primary",
                                        children: translate('onBoarding.tooltip.next')
                                    }) : /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $67d71c16fdfc3a0e$export$2e2bcd8739ae039), {
                                        ...closeProps,
                                        size: "small",
                                        type: "primary",
                                        children: translate('onBoarding.tooltip.close')
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            open: true,
            placement: step.placement,
            // Tailwind's max-w-sm (24rem), antd 6 sets its own max-width on the root.
            styles: {
                root: {
                    maxWidth: '24rem'
                }
            },
            title: translate(step.title)
        })
    });
};
const $b9ae4ce9d6b4bc54$var$OnBoarding = ({ isVisible: isVisible, setIsVisible: setIsVisible, showTab: showTab })=>{
    const steps = (0, $5E6i4.useMemo)(()=>$b9ae4ce9d6b4bc54$var$tourSteps(showTab), [
        showTab
    ]);
    return isVisible ? /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $1a9bd18e23abd3f1$export$dea3f86268c96277), {
        continuous: true,
        onEvent: (event)=>(event.action === (0, $1a9bd18e23abd3f1$export$92a1a3b7554e9387).CLOSE || event.action === (0, $1a9bd18e23abd3f1$export$92a1a3b7554e9387).SKIP) && setIsVisible(false),
        // As in react-joyride 2, the highlighted element does not take clicks during the tour.
        options: {
            blockTargetInteraction: true
        },
        run: true,
        steps: steps,
        tooltipComponent: $b9ae4ce9d6b4bc54$var$Tooltip
    }) : null;
};
var $b9ae4ce9d6b4bc54$export$2e2bcd8739ae039 = $b9ae4ce9d6b4bc54$var$OnBoarding;




var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $a25894260bdbc132$var$BorderOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    },
    "name": "border",
    "theme": "outlined"
};
var $a25894260bdbc132$export$2e2bcd8739ae039 = $a25894260bdbc132$var$BorderOutlined;



function $56068ff655eff194$var$_extends() {
    $56068ff655eff194$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $56068ff655eff194$var$_extends.apply(this, arguments);
}
const $56068ff655eff194$var$BorderOutlined = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $56068ff655eff194$var$_extends({}, props, {
        ref: ref,
        icon: (0, $a25894260bdbc132$export$2e2bcd8739ae039)
    }));
/**![border](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg4MCAxMTJIMTQ0Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnY3MzZjMCAxNy43IDE0LjMgMzIgMzIgMzJoNzM2YzE3LjcgMCAzMi0xNC4zIDMyLTMyVjE0NGMwLTE3LjctMTQuMy0zMi0zMi0zMnptLTQwIDcyOEgxODRWMTg0aDY1NnY2NTZ6IiAvPjwvc3ZnPg==) */ const $56068ff655eff194$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($56068ff655eff194$var$BorderOutlined);
var $56068ff655eff194$export$2e2bcd8739ae039 = $56068ff655eff194$var$RefIcon;



var $5E6i4 = parcelRequire("5E6i4");


var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $c314edcbda8d995e$var$MinusOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M872 474H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "minus",
    "theme": "outlined"
};
var $c314edcbda8d995e$export$2e2bcd8739ae039 = $c314edcbda8d995e$var$MinusOutlined;



function $36f12e0863de9bb9$var$_extends() {
    $36f12e0863de9bb9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $36f12e0863de9bb9$var$_extends.apply(this, arguments);
}
const $36f12e0863de9bb9$var$MinusOutlined = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $36f12e0863de9bb9$var$_extends({}, props, {
        ref: ref,
        icon: (0, $c314edcbda8d995e$export$2e2bcd8739ae039)
    }));
/**![minus](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg3MiA0NzRIMTUyYy00LjQgMC04IDMuNi04IDh2NjBjMCA0LjQgMy42IDggOCA4aDcyMGM0LjQgMCA4LTMuNiA4LTh2LTYwYzAtNC40LTMuNi04LTgtOHoiIC8+PC9zdmc+) */ const $36f12e0863de9bb9$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($36f12e0863de9bb9$var$MinusOutlined);
var $36f12e0863de9bb9$export$2e2bcd8739ae039 = $36f12e0863de9bb9$var$RefIcon;




var $5E6i4 = parcelRequire("5E6i4");
// This icon file is generated automatically.
var $03de11db0322b591$var$UpOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3A8 8 0 00140 768h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z"
                }
            }
        ]
    },
    "name": "up",
    "theme": "outlined"
};
var $03de11db0322b591$export$2e2bcd8739ae039 = $03de11db0322b591$var$UpOutlined;



function $90957df98867018c$var$_extends() {
    $90957df98867018c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $90957df98867018c$var$_extends.apply(this, arguments);
}
const $90957df98867018c$var$UpOutlined = (props, ref)=>/*#__PURE__*/ $5E6i4.createElement((0, $599f238375a1dc0a$export$2e2bcd8739ae039), $90957df98867018c$var$_extends({}, props, {
        ref: ref,
        icon: (0, $03de11db0322b591$export$2e2bcd8739ae039)
    }));
/**![up](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg5MC41IDc1NS4zTDUzNy45IDI2OS4yYy0xMi44LTE3LjYtMzktMTcuNi01MS43IDBMMTMzLjUgNzU1LjNBOCA4IDAgMDAxNDAgNzY4aDc1YzUuMSAwIDkuOS0yLjUgMTIuOS02LjZMNTEyIDM2OS44bDI4NC4xIDM5MS42YzMgNC4xIDcuOCA2LjYgMTIuOSA2LjZoNzVjNi41IDAgMTAuMy03LjQgNi41LTEyLjd6IiAvPjwvc3ZnPg==) */ const $90957df98867018c$var$RefIcon = /*#__PURE__*/ $5E6i4.forwardRef($90957df98867018c$var$UpOutlined);
var $90957df98867018c$export$2e2bcd8739ae039 = $90957df98867018c$var$RefIcon;


/* eslint-disable max-classes-per-file */ 



function $d936cc65b3667829$export$d5c7b2f63580e8f5() {
    return typeof BigInt === 'function';
}


function $83678e1fefd0ab61$export$dd1bc94b04021eeb(value) {
    return !value && value !== 0 && !Number.isNaN(value) || !String(value).trim();
}
function $83678e1fefd0ab61$export$5be79a0015c5ab12(numStr) {
    var str = numStr.trim();
    var negative = str.startsWith('-');
    if (negative) str = str.slice(1);
    str = str// Remove decimal 0. `1.000` => `1.`, `1.100` => `1.1`
    .replace(/(\.\d*[^0])0*$/, '$1')// Remove useless decimal. `1.` => `1`
    .replace(/\.0*$/, '')// Remove integer 0. `0001` => `1`, 000.1' => `.1`
    .replace(/^0+/, '');
    if (str.startsWith('.')) str = "0".concat(str);
    var trimStr = str || '0';
    var splitNumber = trimStr.split('.');
    var integerStr = splitNumber[0] || '0';
    var decimalStr = splitNumber[1] || '0';
    if (integerStr === '0' && decimalStr === '0') negative = false;
    var negativeStr = negative ? '-' : '';
    return {
        negative: negative,
        negativeStr: negativeStr,
        trimStr: trimStr,
        integerStr: integerStr,
        decimalStr: decimalStr,
        fullStr: "".concat(negativeStr).concat(trimStr)
    };
}
function $83678e1fefd0ab61$export$ee6c12ef7f6d8b32(number) {
    var str = String(number);
    return !Number.isNaN(Number(str)) && str.includes('e');
}
/**
 * Parse a scientific-notation string into reusable parts.
 *
 * The idea is to split the value into mantissa and exponent first, then
 * normalize the mantissa into sign, integer/decimal segments, and a compact
 * digit sequence so later logic can move the decimal point without re-parsing.
 */ function $83678e1fefd0ab61$var$parseScientificNotation(numStr) {
    var _numStr$toLowerCase$s = numStr.toLowerCase().split('e'), _numStr$toLowerCase$s2 = (0, $9f30dc2f29991165$export$2e2bcd8739ae039)(_numStr$toLowerCase$s, 2), mantissa = _numStr$toLowerCase$s2[0], _numStr$toLowerCase$s3 = _numStr$toLowerCase$s2[1], exponent = _numStr$toLowerCase$s3 === void 0 ? '0' : _numStr$toLowerCase$s3;
    var negative = mantissa.startsWith('-');
    var unsignedMantissa = negative ? mantissa.slice(1) : mantissa;
    var _unsignedMantissa$spl = unsignedMantissa.split('.'), _unsignedMantissa$spl2 = (0, $9f30dc2f29991165$export$2e2bcd8739ae039)(_unsignedMantissa$spl, 2), _unsignedMantissa$spl3 = _unsignedMantissa$spl2[0], integer = _unsignedMantissa$spl3 === void 0 ? '0' : _unsignedMantissa$spl3, _unsignedMantissa$spl4 = _unsignedMantissa$spl2[1], decimal = _unsignedMantissa$spl4 === void 0 ? '' : _unsignedMantissa$spl4;
    var digits = "".concat(integer).concat(decimal).replace(/^0+/, '') || '0';
    return {
        decimal: decimal,
        digits: digits,
        exponent: Number(exponent),
        integer: integer,
        negative: negative
    };
}
/**
 * Expand parsed scientific notation into a plain decimal string.
 *
 * The core idea is to calculate where the decimal point lands after applying
 * the exponent, then rebuild the string by either padding zeros or inserting
 * the decimal point inside the normalized digit sequence.
 */ function $83678e1fefd0ab61$var$expandScientificNotation(parsed) {
    var decimal = parsed.decimal, digits = parsed.digits, exponent = parsed.exponent, integer = parsed.integer, negative = parsed.negative;
    if (digits === '0') return '0';
    var integerDigits = integer.replace(/^0+/, '').length;
    var leadingDecimalZeros = (decimal.match(/^0*/) || [
        ''
    ])[0].length;
    var initialDecimalIndex = integerDigits || -leadingDecimalZeros;
    var decimalIndex = initialDecimalIndex + exponent;
    var expanded = '';
    if (decimalIndex <= 0) expanded = "0.".concat('0'.repeat(-decimalIndex)).concat(digits);
    else if (decimalIndex >= digits.length) expanded = "".concat(digits).concat('0'.repeat(decimalIndex - digits.length));
    else expanded = "".concat(digits.slice(0, decimalIndex), ".").concat(digits.slice(decimalIndex));
    return "".concat(negative ? '-' : '').concat(expanded);
}
function $83678e1fefd0ab61$var$getScientificPrecision(parsed) {
    if (parsed.exponent >= 0) return Math.max(0, parsed.decimal.length - parsed.exponent);
    return Math.abs(parsed.exponent) + parsed.decimal.length;
}
function $83678e1fefd0ab61$export$2e56483e4ad90ee6(number) {
    var numStr = String(number);
    if ($83678e1fefd0ab61$export$ee6c12ef7f6d8b32(number)) return $83678e1fefd0ab61$var$getScientificPrecision($83678e1fefd0ab61$var$parseScientificNotation(numStr));
    return numStr.includes('.') && $83678e1fefd0ab61$export$b3d198e17b370bec(numStr) ? numStr.length - numStr.indexOf('.') - 1 : 0;
}
function $83678e1fefd0ab61$export$fdc98affa95a4322(number) {
    var numStr = String(number);
    if ($83678e1fefd0ab61$export$ee6c12ef7f6d8b32(number)) {
        if (number > Number.MAX_SAFE_INTEGER) return String((0, $d936cc65b3667829$export$d5c7b2f63580e8f5)() ? BigInt(number).toString() : Number.MAX_SAFE_INTEGER);
        if (number < Number.MIN_SAFE_INTEGER) return String((0, $d936cc65b3667829$export$d5c7b2f63580e8f5)() ? BigInt(number).toString() : Number.MIN_SAFE_INTEGER);
        var parsed = $83678e1fefd0ab61$var$parseScientificNotation(numStr);
        var precision = $83678e1fefd0ab61$var$getScientificPrecision(parsed);
        numStr = precision > 100 ? $83678e1fefd0ab61$var$expandScientificNotation(parsed) : number.toFixed(precision);
    }
    return $83678e1fefd0ab61$export$5be79a0015c5ab12(numStr).fullStr;
}
function $83678e1fefd0ab61$export$b3d198e17b370bec(num) {
    if (typeof num === 'number') return !Number.isNaN(num);
    // Empty
    if (!num) return false;
    return(// Normal type: 11.28
    /^\s*-?\d+(\.\d+)?\s*$/.test(num) || // Pre-number: 1.
    /^\s*-?\d+\.\s*$/.test(num) || // Post-number: .1
    /^\s*-?\.\d+\s*$/.test(num));
}


var $40d0f469f1221c8d$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function BigIntDecimal(value) {
        (0, $dbd531af97203a2f$export$2e2bcd8739ae039)(this, BigIntDecimal);
        (0, $80456ca0b72106f4$export$2e2bcd8739ae039)(this, "origin", '');
        (0, $80456ca0b72106f4$export$2e2bcd8739ae039)(this, "negative", void 0);
        (0, $80456ca0b72106f4$export$2e2bcd8739ae039)(this, "integer", void 0);
        (0, $80456ca0b72106f4$export$2e2bcd8739ae039)(this, "decimal", void 0);
        /** BigInt will convert `0009` to `9`. We need record the len of decimal */ (0, $80456ca0b72106f4$export$2e2bcd8739ae039)(this, "decimalLen", void 0);
        (0, $80456ca0b72106f4$export$2e2bcd8739ae039)(this, "empty", void 0);
        (0, $80456ca0b72106f4$export$2e2bcd8739ae039)(this, "nan", void 0);
        if ((0, $83678e1fefd0ab61$export$dd1bc94b04021eeb)(value)) {
            this.empty = true;
            return;
        }
        this.origin = String(value);
        // Act like Number convert
        if (value === '-' || Number.isNaN(value)) {
            this.nan = true;
            return;
        }
        var mergedValue = value;
        // We need convert back to Number since it require `toFixed` to handle this
        if ((0, $83678e1fefd0ab61$export$ee6c12ef7f6d8b32)(mergedValue)) mergedValue = Number(mergedValue);
        mergedValue = typeof mergedValue === 'string' ? mergedValue : (0, $83678e1fefd0ab61$export$fdc98affa95a4322)(mergedValue);
        if ((0, $83678e1fefd0ab61$export$b3d198e17b370bec)(mergedValue)) {
            var trimRet = (0, $83678e1fefd0ab61$export$5be79a0015c5ab12)(mergedValue);
            this.negative = trimRet.negative;
            var numbers = trimRet.trimStr.split('.');
            this.integer = BigInt(numbers[0]);
            var decimalStr = numbers[1] || '0';
            this.decimal = BigInt(decimalStr);
            this.decimalLen = decimalStr.length;
        } else this.nan = true;
    }
    (0, $bffd9344780d0102$export$2e2bcd8739ae039)(BigIntDecimal, [
        {
            key: "getMark",
            value: function getMark() {
                return this.negative ? '-' : '';
            }
        },
        {
            key: "getIntegerStr",
            value: function getIntegerStr() {
                return this.integer.toString();
            }
        },
        {
            key: "getDecimalStr",
            value: function getDecimalStr() {
                return this.decimal.toString().padStart(this.decimalLen, '0');
            }
        },
        {
            key: "alignDecimal",
            value: function alignDecimal(decimalLength) {
                var str = "".concat(this.getMark()).concat(this.getIntegerStr()).concat(this.getDecimalStr().padEnd(decimalLength, '0'));
                return BigInt(str);
            }
        },
        {
            key: "negate",
            value: function negate() {
                var clone = new BigIntDecimal(this.toString());
                clone.negative = !clone.negative;
                return clone;
            }
        },
        {
            key: "cal",
            value: function cal(offset, calculator, calDecimalLen) {
                var maxDecimalLength = Math.max(this.getDecimalStr().length, offset.getDecimalStr().length);
                var myAlignedDecimal = this.alignDecimal(maxDecimalLength);
                var offsetAlignedDecimal = offset.alignDecimal(maxDecimalLength);
                var valueStr = calculator(myAlignedDecimal, offsetAlignedDecimal).toString();
                var nextDecimalLength = calDecimalLen(maxDecimalLength);
                // We need fill string length back to `maxDecimalLength` to avoid parser failed
                var _trimNumber = (0, $83678e1fefd0ab61$export$5be79a0015c5ab12)(valueStr), negativeStr = _trimNumber.negativeStr, trimStr = _trimNumber.trimStr;
                var hydrateValueStr = "".concat(negativeStr).concat(trimStr.padStart(nextDecimalLength + 1, '0'));
                return new BigIntDecimal("".concat(hydrateValueStr.slice(0, -nextDecimalLength), ".").concat(hydrateValueStr.slice(-nextDecimalLength)));
            }
        },
        {
            key: "add",
            value: function add(value) {
                if (this.isInvalidate()) return new BigIntDecimal(value);
                var offset = new BigIntDecimal(value);
                if (offset.isInvalidate()) return this;
                return this.cal(offset, function(num1, num2) {
                    return num1 + num2;
                }, function(len) {
                    return len;
                });
            }
        },
        {
            key: "multi",
            value: function multi(value) {
                var target = new BigIntDecimal(value);
                if (this.isInvalidate() || target.isInvalidate()) return new BigIntDecimal(NaN);
                return this.cal(target, function(num1, num2) {
                    return num1 * num2;
                }, function(len) {
                    return len * 2;
                });
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return this.empty;
            }
        },
        {
            key: "isNaN",
            value: function isNaN() {
                return this.nan;
            }
        },
        {
            key: "isInvalidate",
            value: function isInvalidate() {
                return this.isEmpty() || this.isNaN();
            }
        },
        {
            key: "equals",
            value: function equals(target) {
                return this.toString() === (target === null || target === void 0 ? void 0 : target.toString());
            }
        },
        {
            key: "lessEquals",
            value: function lessEquals(target) {
                return this.add(target.negate().toString()).toNumber() <= 0;
            }
        },
        {
            key: "toNumber",
            value: function toNumber() {
                if (this.isNaN()) return NaN;
                return Number(this.toString());
            }
        },
        {
            key: "toString",
            value: function toString() {
                var safe = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                if (!safe) return this.origin;
                if (this.isInvalidate()) return '';
                return (0, $83678e1fefd0ab61$export$5be79a0015c5ab12)("".concat(this.getMark()).concat(this.getIntegerStr(), ".").concat(this.getDecimalStr())).fullStr;
            }
        }
    ]);
    return BigIntDecimal;
}();






/**
 * We can remove this when IE not support anymore
 */ var $fe23300c0596b936$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function NumberDecimal(value) {
        (0, $dbd531af97203a2f$export$2e2bcd8739ae039)(this, NumberDecimal);
        (0, $80456ca0b72106f4$export$2e2bcd8739ae039)(this, "origin", '');
        (0, $80456ca0b72106f4$export$2e2bcd8739ae039)(this, "number", void 0);
        (0, $80456ca0b72106f4$export$2e2bcd8739ae039)(this, "empty", void 0);
        if ((0, $83678e1fefd0ab61$export$dd1bc94b04021eeb)(value)) {
            this.empty = true;
            return;
        }
        this.origin = String(value);
        this.number = Number(value);
    }
    (0, $bffd9344780d0102$export$2e2bcd8739ae039)(NumberDecimal, [
        {
            key: "negate",
            value: function negate() {
                return new NumberDecimal(-this.toNumber());
            }
        },
        {
            key: "add",
            value: function add(value) {
                if (this.isInvalidate()) return new NumberDecimal(value);
                var target = Number(value);
                if (Number.isNaN(target)) return this;
                var number = this.number + target;
                // [Legacy] Back to safe integer
                if (number > Number.MAX_SAFE_INTEGER) return new NumberDecimal(Number.MAX_SAFE_INTEGER);
                if (number < Number.MIN_SAFE_INTEGER) return new NumberDecimal(Number.MIN_SAFE_INTEGER);
                var maxPrecision = Math.max((0, $83678e1fefd0ab61$export$2e56483e4ad90ee6)(this.number), (0, $83678e1fefd0ab61$export$2e56483e4ad90ee6)(target));
                return new NumberDecimal(number.toFixed(maxPrecision));
            }
        },
        {
            key: "multi",
            value: function multi(value) {
                var target = Number(value);
                if (this.isInvalidate() || Number.isNaN(target)) return new NumberDecimal(NaN);
                var number = this.number * target;
                // [Legacy] Back to safe integer
                if (number > Number.MAX_SAFE_INTEGER) return new NumberDecimal(Number.MAX_SAFE_INTEGER);
                if (number < Number.MIN_SAFE_INTEGER) return new NumberDecimal(Number.MIN_SAFE_INTEGER);
                var maxPrecision = Math.max((0, $83678e1fefd0ab61$export$2e56483e4ad90ee6)(this.number), (0, $83678e1fefd0ab61$export$2e56483e4ad90ee6)(target));
                return new NumberDecimal(number.toFixed(maxPrecision));
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return this.empty;
            }
        },
        {
            key: "isNaN",
            value: function isNaN() {
                return Number.isNaN(this.number);
            }
        },
        {
            key: "isInvalidate",
            value: function isInvalidate() {
                return this.isEmpty() || this.isNaN();
            }
        },
        {
            key: "equals",
            value: function equals(target) {
                return this.toNumber() === (target === null || target === void 0 ? void 0 : target.toNumber());
            }
        },
        {
            key: "lessEquals",
            value: function lessEquals(target) {
                return this.add(target.negate().toString()).toNumber() <= 0;
            }
        },
        {
            key: "toNumber",
            value: function toNumber() {
                return this.number;
            }
        },
        {
            key: "toString",
            value: function toString() {
                var safe = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                if (!safe) return this.origin;
                if (this.isInvalidate()) return '';
                if ((0, $83678e1fefd0ab61$export$ee6c12ef7f6d8b32)(this.number) && (0, $83678e1fefd0ab61$export$2e56483e4ad90ee6)(this.number) > 100) return String(this.number);
                return (0, $83678e1fefd0ab61$export$fdc98affa95a4322)(this.number);
            }
        }
    ]);
    return NumberDecimal;
}();




function $d90165bad2ef40a9$export$2e2bcd8739ae039(value) {
    // We use BigInt here.
    // Will fallback to Number if not support.
    if ((0, $d936cc65b3667829$export$d5c7b2f63580e8f5)()) return new (0, $40d0f469f1221c8d$export$2e2bcd8739ae039)(value);
    return new (0, $fe23300c0596b936$export$2e2bcd8739ae039)(value);
}
function $d90165bad2ef40a9$export$a81f732198733497(numStr, separatorStr, precision) {
    var cutOnly = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (numStr === '') return '';
    var _trimNumber = (0, $83678e1fefd0ab61$export$5be79a0015c5ab12)(numStr), negativeStr = _trimNumber.negativeStr, integerStr = _trimNumber.integerStr, decimalStr = _trimNumber.decimalStr;
    var precisionDecimalStr = "".concat(separatorStr).concat(decimalStr);
    var numberWithoutDecimal = "".concat(negativeStr).concat(integerStr);
    if (precision >= 0) {
        // We will get last + 1 number to check if need advanced number
        var advancedNum = Number(decimalStr[precision]);
        if (advancedNum >= 5 && !cutOnly) {
            var advancedDecimal = $d90165bad2ef40a9$export$2e2bcd8739ae039(numStr).add("".concat(negativeStr, "0.").concat('0'.repeat(precision)).concat(10 - advancedNum));
            return $d90165bad2ef40a9$export$a81f732198733497(advancedDecimal.toString(), separatorStr, precision, cutOnly);
        }
        if (precision === 0) return numberWithoutDecimal;
        return "".concat(numberWithoutDecimal).concat(separatorStr).concat(decimalStr.padEnd(precision, '0').slice(0, precision));
    }
    if (precisionDecimalStr === '.0') return numberWithoutDecimal;
    return "".concat(numberWithoutDecimal).concat(precisionDecimalStr);
}



var $d2d85e5443ef1c59$export$2e2bcd8739ae039 = (0, $d90165bad2ef40a9$export$2e2bcd8739ae039);






var $5E6i4 = parcelRequire("5E6i4");

var $5E6i4 = parcelRequire("5E6i4");

function $13421a2c0d2bc9a7$export$2e2bcd8739ae039(input, focused) {
    const selectionRef = (0, $5E6i4.useRef)(null);
    function recordCursor() {
        // Record position
        try {
            const { selectionStart: start, selectionEnd: end, value: value } = input;
            const beforeTxt = value.substring(0, start);
            const afterTxt = value.substring(end);
            selectionRef.current = {
                start: start,
                end: end,
                value: value,
                beforeTxt: beforeTxt,
                afterTxt: afterTxt
            };
        } catch (e) {
        // Fix error in Chrome:
        // Failed to read the 'selectionStart' property from 'HTMLInputElement'
        // http://stackoverflow.com/q/21177489/3040605
        }
    }
    /**
   * Restore logic:
   *  1. back string same
   *  2. start string same
   */ function restoreCursor() {
        if (input && selectionRef.current && focused) try {
            const { value: value } = input;
            const { beforeTxt: beforeTxt, afterTxt: afterTxt, start: start } = selectionRef.current;
            let startPos = value.length;
            if (value.startsWith(beforeTxt)) startPos = beforeTxt.length;
            else if (value.endsWith(afterTxt)) startPos = value.length - selectionRef.current.afterTxt.length;
            else {
                const beforeLastChar = beforeTxt[start - 1];
                const newIndex = value.indexOf(beforeLastChar, start - 1);
                if (newIndex !== -1) startPos = newIndex + 1;
            }
            input.setSelectionRange(startPos, startPos);
        } catch (e) {
            (0, $f757b9ac02fa080d$export$2e2bcd8739ae039)(false, `Something warning of cursor restore. Please fire issue about this: ${e.message}`);
        }
    }
    return [
        recordCursor,
        restoreCursor
    ];
}


/* eslint-disable react/no-unknown-property */ 


var $5E6i4 = parcelRequire("5E6i4");
/**
 * When click and hold on a button - the speed of auto changing the value.
 */ const $fca8a8d4b64b05fd$var$STEP_INTERVAL = 200;
/**
 * When click and hold on a button - the delay before auto changing the value.
 */ const $fca8a8d4b64b05fd$var$STEP_DELAY = 600;
function $fca8a8d4b64b05fd$export$2e2bcd8739ae039({ prefixCls: prefixCls, action: action, children: children, disabled: disabled, className: className, style: style, onStep: onStep }) {
    // ======================== MISC ========================
    const isUpAction = action === 'up';
    // ======================== Step ========================
    const stepTimeoutRef = $5E6i4.useRef();
    const frameIds = $5E6i4.useRef([]);
    const onStopStep = ()=>{
        clearTimeout(stepTimeoutRef.current);
    };
    // We will interval update step when hold mouse down
    const onStepMouseDown = (e)=>{
        e.preventDefault();
        onStopStep();
        onStep(isUpAction, 'handler');
        // Loop step for interval
        function loopStep() {
            onStep(isUpAction, 'handler');
            stepTimeoutRef.current = setTimeout(loopStep, $fca8a8d4b64b05fd$var$STEP_INTERVAL);
        }
        // First time press will wait some time to trigger loop step update
        stepTimeoutRef.current = setTimeout(loopStep, $fca8a8d4b64b05fd$var$STEP_DELAY);
    };
    $5E6i4.useEffect(()=>()=>{
            onStopStep();
            frameIds.current.forEach((id)=>{
                (0, $1d949665862f071a$export$2e2bcd8739ae039).cancel(id);
            });
        }, []);
    // ======================= Render =======================
    const actionClassName = `${prefixCls}-action`;
    const mergedClassName = (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(actionClassName, `${actionClassName}-${action}`, {
        [`${actionClassName}-${action}-disabled`]: disabled
    }, className);
    // fix: https://github.com/ant-design/ant-design/issues/43088
    // In Safari, When we fire onmousedown and onmouseup events in quick succession,
    // there may be a problem that the onmouseup events are executed first,
    // resulting in a disordered program execution.
    // So, we need to use requestAnimationFrame to ensure that the onmouseup event is executed after the onmousedown event.
    const safeOnStopStep = ()=>frameIds.current.push((0, $1d949665862f071a$export$2e2bcd8739ae039)(onStopStep));
    return /*#__PURE__*/ $5E6i4.createElement("span", {
        unselectable: "on",
        role: "button",
        onMouseUp: safeOnStopStep,
        onMouseLeave: safeOnStopStep,
        onMouseDown: (e)=>{
            onStepMouseDown(e);
        },
        "aria-label": isUpAction ? 'Increase Value' : 'Decrease Value',
        "aria-disabled": disabled,
        className: mergedClassName,
        style: style
    }, children || /*#__PURE__*/ $5E6i4.createElement("span", {
        unselectable: "on",
        className: `${prefixCls}-action-${action}-inner`
    }));
}



function $a60f2bb11a0143ad$export$d2883c6c6307c415(step) {
    const stepStr = typeof step === 'number' ? (0, $83678e1fefd0ab61$export$fdc98affa95a4322)(step) : (0, $83678e1fefd0ab61$export$5be79a0015c5ab12)(step).fullStr;
    const hasPoint = stepStr.includes('.');
    if (!hasPoint) return step + '0';
    return (0, $83678e1fefd0ab61$export$5be79a0015c5ab12)(stepStr.replace(/(\d)\.(\d)/g, '$1$2.')).fullStr;
}





var $5E6i4 = parcelRequire("5E6i4");

var /**
 * Always trigger latest once when call multiple time
 */ $c85a5b43dd67a6a5$export$2e2bcd8739ae039 = ()=>{
    const idRef = (0, $5E6i4.useRef)(0);
    const cleanUp = ()=>{
        (0, $1d949665862f071a$export$2e2bcd8739ae039).cancel(idRef.current);
    };
    (0, $5E6i4.useEffect)(()=>cleanUp, []);
    return (callback)=>{
        cleanUp();
        idRef.current = (0, $1d949665862f071a$export$2e2bcd8739ae039)(()=>{
            callback();
        });
    };
};


function $e1227780c569ad6d$var$_extends() {
    $e1227780c569ad6d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e1227780c569ad6d$var$_extends.apply(this, arguments);
}
/**
 * We support `stringMode` which need handle correct type when user call in onChange
 * format max or min value
 * 1. if isInvalid return null
 * 2. if precision is undefined, return decimal
 * 3. format with precision
 *    I. if max > 0, round down with precision. Example: max= 3.5, precision=0  afterFormat: 3
 *    II. if max < 0, round up with precision. Example: max= -3.5, precision=0  afterFormat: -4
 *    III. if min > 0, round up with precision. Example: min= 3.5, precision=0  afterFormat: 4
 *    IV. if min < 0, round down with precision. Example: max= -3.5, precision=0  afterFormat: -3
 */ const $e1227780c569ad6d$var$getDecimalValue = (stringMode, decimalValue)=>{
    if (stringMode || decimalValue.isEmpty()) return decimalValue.toString();
    return decimalValue.toNumber();
};
const $e1227780c569ad6d$var$getDecimalIfValidate = (value)=>{
    const decimal = (0, $d2d85e5443ef1c59$export$2e2bcd8739ae039)(value);
    return decimal.isInvalidate() ? null : decimal;
};
const $e1227780c569ad6d$var$InputNumber = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { mode: mode = 'input', prefixCls: prefixCls = 'rc-input-number', className: className, style: style, classNames: classNames, styles: styles, min: min, max: max, step: step = 1, defaultValue: defaultValue, value: value, disabled: disabled, readOnly: readOnly, upHandler: upHandler, downHandler: downHandler, keyboard: keyboard, changeOnWheel: changeOnWheel = false, controls: controls = true, prefix: prefix, suffix: suffix, stringMode: stringMode, parser: parser, formatter: formatter, precision: precision, decimalSeparator: decimalSeparator, onChange: onChange, onInput: onInput, onPressEnter: onPressEnter, onStep: onStep, onMouseDown: // Mouse Events
    onMouseDown, onClick: onClick, onMouseUp: onMouseUp, onMouseLeave: onMouseLeave, onMouseMove: onMouseMove, onMouseEnter: onMouseEnter, onMouseOut: onMouseOut, changeOnBlur: changeOnBlur = true, ...restProps } = props;
    const [focus, setFocus] = $5E6i4.useState(false);
    const userTypingRef = $5E6i4.useRef(false);
    const compositionRef = $5E6i4.useRef(false);
    const shiftKeyRef = $5E6i4.useRef(false);
    // ============================= Refs =============================
    const rootRef = $5E6i4.useRef(null);
    const inputRef = $5E6i4.useRef(null);
    $5E6i4.useImperativeHandle(ref, ()=>(0, $873f3974af782749$export$2e2bcd8739ae039)(inputRef.current, {
            focus: (option)=>{
                (0, $806ab00ed04609c6$export$2b92016deb0b7aad)(inputRef.current, option);
            },
            blur: ()=>{
                inputRef.current?.blur();
            },
            nativeElement: rootRef.current
        }));
    // ============================ Value =============================
    // Real value control
    const [decimalValue, setDecimalValue] = $5E6i4.useState(()=>(0, $d2d85e5443ef1c59$export$2e2bcd8739ae039)(value ?? defaultValue));
    function setUncontrolledDecimalValue(newDecimal) {
        if (value === undefined) setDecimalValue(newDecimal);
    }
    // ====================== Parser & Formatter ======================
    /**
   * `precision` is used for formatter & onChange.
   * It will auto generate by `value` & `step`.
   * But it will not block user typing.
   *
   * Note: Auto generate `precision` is used for legacy logic.
   * We should remove this since we already support high precision with BigInt.
   *
   * @param number  Provide which number should calculate precision
   * @param userTyping  Change by user typing
   */ const getPrecision = $5E6i4.useCallback((numStr, userTyping)=>{
        if (userTyping) return undefined;
        if (precision >= 0) return precision;
        return Math.max((0, $83678e1fefd0ab61$export$2e56483e4ad90ee6)(numStr), (0, $83678e1fefd0ab61$export$2e56483e4ad90ee6)(step));
    }, [
        precision,
        step
    ]);
    // >>> Parser
    const mergedParser = $5E6i4.useCallback((num)=>{
        const numStr = String(num);
        if (parser) return parser(numStr);
        let parsedStr = numStr;
        if (decimalSeparator) parsedStr = parsedStr.replace(decimalSeparator, '.');
        // [Legacy] We still support auto convert `$ 123,456` to `123456`
        return parsedStr.replace(/[^\w.-]+/g, '');
    }, [
        parser,
        decimalSeparator
    ]);
    // >>> Formatter
    const inputValueRef = $5E6i4.useRef('');
    const mergedFormatter = $5E6i4.useCallback((number, userTyping)=>{
        if (formatter) return formatter(number, {
            userTyping: userTyping,
            input: String(inputValueRef.current)
        });
        let str = typeof number === 'number' ? (0, $83678e1fefd0ab61$export$fdc98affa95a4322)(number) : number;
        // User typing will not auto format with precision directly
        if (!userTyping) {
            const mergedPrecision = getPrecision(str, userTyping);
            if ((0, $83678e1fefd0ab61$export$b3d198e17b370bec)(str) && (decimalSeparator || mergedPrecision >= 0)) {
                // Separator
                const separatorStr = decimalSeparator || '.';
                str = (0, $d90165bad2ef40a9$export$a81f732198733497)(str, separatorStr, mergedPrecision);
            }
        }
        return str;
    }, [
        formatter,
        getPrecision,
        decimalSeparator
    ]);
    // ========================== InputValue ==========================
    /**
   * Input text value control
   *
   * User can not update input content directly. It updates with follow rules by priority:
   *  1. controlled `value` changed
   *    * [SPECIAL] Typing like `1.` should not immediately convert to `1`
   *  2. User typing with format (not precision)
   *  3. Blur or Enter trigger revalidate
   */ const [inputValue, setInternalInputValue] = $5E6i4.useState(()=>{
        const initValue = defaultValue ?? value;
        if (decimalValue.isInvalidate() && [
            'string',
            'number'
        ].includes(typeof initValue)) return Number.isNaN(initValue) ? '' : initValue;
        return mergedFormatter(decimalValue.toString(), false);
    });
    inputValueRef.current = inputValue;
    // Should always be string
    function setInputValue(newValue, userTyping) {
        setInternalInputValue(mergedFormatter(// Invalidate number is sometime passed by external control, we should let it go
        // Otherwise is controlled by internal interactive logic which check by userTyping
        // You can ref 'show limited value when input is not focused' test for more info.
        newValue.isInvalidate() ? newValue.toString(false) : newValue.toString(!userTyping), userTyping));
    }
    // >>> Max & Min limit
    const maxDecimal = $5E6i4.useMemo(()=>$e1227780c569ad6d$var$getDecimalIfValidate(max), [
        max,
        precision
    ]);
    const minDecimal = $5E6i4.useMemo(()=>$e1227780c569ad6d$var$getDecimalIfValidate(min), [
        min,
        precision
    ]);
    const upDisabled = $5E6i4.useMemo(()=>{
        if (!maxDecimal || !decimalValue || decimalValue.isInvalidate()) return false;
        return maxDecimal.lessEquals(decimalValue);
    }, [
        maxDecimal,
        decimalValue
    ]);
    const downDisabled = $5E6i4.useMemo(()=>{
        if (!minDecimal || !decimalValue || decimalValue.isInvalidate()) return false;
        return decimalValue.lessEquals(minDecimal);
    }, [
        minDecimal,
        decimalValue
    ]);
    // Cursor controller
    const [recordCursor, restoreCursor] = (0, $13421a2c0d2bc9a7$export$2e2bcd8739ae039)(inputRef.current, focus);
    // ============================= Data =============================
    /**
   * Find target value closet within range.
   * e.g. [11, 28]:
   *    3  => 11
   *    23 => 23
   *    99 => 28
   */ const getRangeValue = (target)=>{
        // target > max
        if (maxDecimal && !target.lessEquals(maxDecimal)) return maxDecimal;
        // target < min
        if (minDecimal && !minDecimal.lessEquals(target)) return minDecimal;
        return null;
    };
    /**
   * Check value is in [min, max] range
   */ const isInRange = (target)=>!getRangeValue(target);
    /**
   * Trigger `onChange` if value validated and not equals of origin.
   * Return the value that re-align in range.
   */ const triggerValueUpdate = (newValue, userTyping)=>{
        let updateValue = newValue;
        let isRangeValidate = isInRange(updateValue) || updateValue.isEmpty();
        // Skip align value when trigger value is empty.
        // We just trigger onChange(null)
        // This should not block user typing
        if (!updateValue.isEmpty() && !userTyping) {
            // Revert value in range if needed
            updateValue = getRangeValue(updateValue) || updateValue;
            isRangeValidate = true;
        }
        if (!readOnly && !disabled && isRangeValidate) {
            const numStr = updateValue.toString();
            const mergedPrecision = getPrecision(numStr, userTyping);
            if (mergedPrecision >= 0) {
                updateValue = (0, $d2d85e5443ef1c59$export$2e2bcd8739ae039)((0, $d90165bad2ef40a9$export$a81f732198733497)(numStr, '.', mergedPrecision));
                // When to fixed. The value may out of min & max range.
                // 4 in [0, 3.8] => 3.8 => 4 (toFixed)
                if (!isInRange(updateValue)) updateValue = (0, $d2d85e5443ef1c59$export$2e2bcd8739ae039)((0, $d90165bad2ef40a9$export$a81f732198733497)(numStr, '.', mergedPrecision, true));
            }
            // Trigger event
            if (!updateValue.equals(decimalValue)) {
                setUncontrolledDecimalValue(updateValue);
                onChange?.(updateValue.isEmpty() ? null : $e1227780c569ad6d$var$getDecimalValue(stringMode, updateValue));
                // Reformat input if value is not controlled
                if (value === undefined) setInputValue(updateValue, userTyping);
            }
            return updateValue;
        }
        return decimalValue;
    };
    // ========================== User Input ==========================
    const onNextPromise = (0, $c85a5b43dd67a6a5$export$2e2bcd8739ae039)();
    // >>> Collect input value
    const collectInputValue = (inputStr)=>{
        recordCursor();
        // Update inputValue in case input can not parse as number
        // Refresh ref value immediately since it may used by formatter
        inputValueRef.current = inputStr;
        setInternalInputValue(inputStr);
        // Parse number
        if (!compositionRef.current) {
            const finalValue = mergedParser(inputStr);
            const finalDecimal = (0, $d2d85e5443ef1c59$export$2e2bcd8739ae039)(finalValue);
            if (!finalDecimal.isNaN()) triggerValueUpdate(finalDecimal, true);
        }
        // Trigger onInput later to let user customize value if they want to handle something after onChange
        onInput?.(inputStr);
        // optimize for chinese input experience
        // https://github.com/ant-design/ant-design/issues/8196
        onNextPromise(()=>{
            let nextInputStr = inputStr;
            if (!parser) nextInputStr = inputStr.replace(/。/g, '.');
            if (nextInputStr !== inputStr) collectInputValue(nextInputStr);
        });
    };
    // >>> Composition
    const onCompositionStart = ()=>{
        compositionRef.current = true;
    };
    const onCompositionEnd = ()=>{
        compositionRef.current = false;
        collectInputValue(inputRef.current.value);
    };
    // >>> Input
    const onInternalInput = (e)=>{
        collectInputValue(e.target.value);
    };
    // ============================= Step =============================
    const onInternalStep = (0, $68990f4402d2f009$export$2e2bcd8739ae039)((up, emitter)=>{
        // Ignore step since out of range
        if (up && upDisabled || !up && downDisabled) return;
        // Clear typing status since it may be caused by up & down key.
        // We should sync with input value.
        userTypingRef.current = false;
        let stepDecimal = (0, $d2d85e5443ef1c59$export$2e2bcd8739ae039)(shiftKeyRef.current ? (0, $a60f2bb11a0143ad$export$d2883c6c6307c415)(step) : step);
        if (!up) stepDecimal = stepDecimal.negate();
        const target = (decimalValue || (0, $d2d85e5443ef1c59$export$2e2bcd8739ae039)(0)).add(stepDecimal.toString());
        const updatedValue = triggerValueUpdate(target, false);
        onStep?.($e1227780c569ad6d$var$getDecimalValue(stringMode, updatedValue), {
            offset: shiftKeyRef.current ? (0, $a60f2bb11a0143ad$export$d2883c6c6307c415)(step) : step,
            type: up ? 'up' : 'down',
            emitter: emitter
        });
        inputRef.current?.focus();
    });
    // ============================ Flush =============================
    /**
   * Flush current input content to trigger value change & re-formatter input if needed.
   * This will always flush input value for update.
   * If it's invalidate, will fallback to last validate value.
   */ const flushInputValue = (userTyping)=>{
        const parsedValue = (0, $d2d85e5443ef1c59$export$2e2bcd8739ae039)(mergedParser(inputValue));
        let formatValue;
        if (!parsedValue.isNaN()) // Only validate value or empty value can be re-fill to inputValue
        // Reassign the formatValue within ranged of trigger control
        formatValue = triggerValueUpdate(parsedValue, userTyping);
        else formatValue = triggerValueUpdate(decimalValue, userTyping);
        if (value !== undefined) // Reset back with controlled value first
        setInputValue(decimalValue, false);
        else if (!formatValue.isNaN()) // Reset input back since no validate value
        setInputValue(formatValue, false);
    };
    // Solve the issue of the event triggering sequence when entering numbers in chinese input (Safari)
    const onBeforeInput = ()=>{
        userTypingRef.current = true;
    };
    const onKeyDown = (event)=>{
        const { key: key, shiftKey: shiftKey } = event;
        userTypingRef.current = true;
        shiftKeyRef.current = shiftKey;
        if (key === 'Enter') {
            if (!compositionRef.current) userTypingRef.current = false;
            flushInputValue(false);
            onPressEnter?.(event);
        }
        if (keyboard === false) return;
        // Do step
        if (!compositionRef.current && [
            'Up',
            'ArrowUp',
            'Down',
            'ArrowDown'
        ].includes(key)) {
            onInternalStep(key === 'Up' || key === 'ArrowUp', 'keyboard');
            event.preventDefault();
        }
    };
    const onKeyUp = ()=>{
        userTypingRef.current = false;
        shiftKeyRef.current = false;
    };
    $5E6i4.useEffect(()=>{
        if (changeOnWheel && focus) {
            const onWheel = (event)=>{
                // moving mouse wheel rises wheel event with deltaY < 0
                // scroll value grows from top to bottom, as screen Y coordinate
                onInternalStep(event.deltaY < 0, 'wheel');
                event.preventDefault();
            };
            const input = inputRef.current;
            if (input) {
                // React onWheel is passive and we can't preventDefault() in it.
                // That's why we should subscribe with DOM listener
                // https://stackoverflow.com/questions/63663025/react-onwheel-handler-cant-preventdefault-because-its-a-passive-event-listenev
                input.addEventListener('wheel', onWheel, {
                    passive: false
                });
                return ()=>input.removeEventListener('wheel', onWheel);
            }
        }
    });
    // >>> Focus & Blur
    const onBlur = ()=>{
        if (changeOnBlur) flushInputValue(false);
        setFocus(false);
        userTypingRef.current = false;
    };
    // >>> Mouse events
    const onInternalMouseDown = (event)=>{
        if (inputRef.current && event.target !== inputRef.current) {
            inputRef.current.focus();
            event.preventDefault();
        }
        onMouseDown?.(event);
    };
    // ========================== Controlled ==========================
    // Input by precision & formatter
    (0, $518ae471aa4f03a7$export$9283e56bae2f7b0f)(()=>{
        if (!decimalValue.isInvalidate()) setInputValue(decimalValue, false);
    }, [
        precision,
        formatter
    ]);
    // Input by value
    (0, $518ae471aa4f03a7$export$9283e56bae2f7b0f)(()=>{
        const newValue = (0, $d2d85e5443ef1c59$export$2e2bcd8739ae039)(value);
        setDecimalValue(newValue);
        const currentParsedValue = (0, $d2d85e5443ef1c59$export$2e2bcd8739ae039)(mergedParser(inputValue));
        // When user typing from `1.2` to `1.`, we should not convert to `1` immediately.
        // But let it go if user set `formatter`
        if (!newValue.equals(currentParsedValue) || !userTypingRef.current || formatter) // Update value as effect
        setInputValue(newValue, userTypingRef.current);
    }, [
        value
    ]);
    // ============================ Cursor ============================
    (0, $518ae471aa4f03a7$export$9283e56bae2f7b0f)(()=>{
        if (formatter) restoreCursor();
    }, [
        inputValue
    ]);
    // ============================ Render ============================
    // >>>>>> Handler
    const sharedHandlerProps = {
        prefixCls: prefixCls,
        onStep: onInternalStep,
        className: classNames?.action,
        style: styles?.action
    };
    const upNode = /*#__PURE__*/ $5E6i4.createElement((0, $fca8a8d4b64b05fd$export$2e2bcd8739ae039), $e1227780c569ad6d$var$_extends({}, sharedHandlerProps, {
        action: "up",
        disabled: upDisabled
    }), upHandler);
    const downNode = /*#__PURE__*/ $5E6i4.createElement((0, $fca8a8d4b64b05fd$export$2e2bcd8739ae039), $e1227780c569ad6d$var$_extends({}, sharedHandlerProps, {
        action: "down",
        disabled: downDisabled
    }), downHandler);
    // >>>>>> Render
    return /*#__PURE__*/ $5E6i4.createElement("div", {
        ref: rootRef,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-mode-${mode}`, className, classNames?.root, {
            [`${prefixCls}-focused`]: focus,
            [`${prefixCls}-disabled`]: disabled,
            [`${prefixCls}-readonly`]: readOnly,
            [`${prefixCls}-not-a-number`]: decimalValue.isNaN(),
            [`${prefixCls}-out-of-range`]: !decimalValue.isInvalidate() && !isInRange(decimalValue)
        }),
        style: {
            ...styles?.root,
            ...style
        },
        onMouseDown: onInternalMouseDown,
        onMouseUp: onMouseUp,
        onMouseLeave: onMouseLeave,
        onMouseMove: onMouseMove,
        onMouseEnter: onMouseEnter,
        onMouseOut: onMouseOut,
        onClick: onClick,
        onFocus: ()=>{
            setFocus(true);
        },
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onCompositionStart: onCompositionStart,
        onCompositionEnd: onCompositionEnd,
        onBeforeInput: onBeforeInput
    }, mode === 'spinner' && controls && downNode, prefix !== undefined && /*#__PURE__*/ $5E6i4.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-prefix`, classNames?.prefix),
        style: styles?.prefix
    }, prefix), /*#__PURE__*/ $5E6i4.createElement("input", $e1227780c569ad6d$var$_extends({
        autoComplete: "off",
        role: "spinbutton",
        "aria-valuemin": min,
        "aria-valuemax": max,
        "aria-valuenow": decimalValue.isInvalidate() ? null : decimalValue.toString(),
        step: step,
        ref: inputRef,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-input`, classNames?.input),
        style: styles?.input,
        value: inputValue,
        onChange: onInternalInput,
        disabled: disabled,
        readOnly: readOnly
    }, restProps)), suffix !== undefined && /*#__PURE__*/ $5E6i4.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-suffix`, classNames?.suffix),
        style: styles?.suffix
    }, suffix), mode === 'spinner' && controls && upNode, mode === 'input' && controls && /*#__PURE__*/ $5E6i4.createElement("div", {
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-actions`, classNames?.actions),
        style: styles?.actions
    }, upNode, downNode));
});
var $e1227780c569ad6d$export$2e2bcd8739ae039 = $e1227780c569ad6d$var$InputNumber;


var $ce69d83304c1f7a1$export$2e2bcd8739ae039 = (0, $e1227780c569ad6d$export$2e2bcd8739ae039);


























const $25348be903d9ac29$export$9ca1be8807fe0675 = (token)=>{
    const handleVisible = token.handleVisible ?? 'auto';
    const handleWidth = token.controlHeightSM - token.lineWidth * 2;
    return {
        ...(0, $9d8327093d1cc6a4$export$bd8b682992bc9781)(token),
        controlWidth: 90,
        handleWidth: handleWidth,
        handleFontSize: token.fontSize / 2,
        handleVisible: handleVisible,
        handleActiveBg: token.colorFillAlter,
        handleBg: token.colorBgContainer,
        filledHandleBg: new (0, $1b0a692e36565107$export$2c4f38d6c0ecc25a)(token.colorFillSecondary).onBackground(token.colorBgContainer).toHexString(),
        handleHoverColor: token.colorPrimary,
        handleBorderColor: token.colorBorder,
        handleOpacity: handleVisible === true ? 1 : 0,
        handleVisibleWidth: handleVisible === true ? handleWidth : 0
    };
};


const $59e8f7e0c7785ad1$var$genInputNumberStyles = (token)=>{
    const { componentCls: componentCls, lineWidth: lineWidth, lineType: lineType, borderRadius: borderRadius, inputFontSizeSM: inputFontSizeSM, inputFontSizeLG: inputFontSizeLG, colorError: colorError, paddingInlineSM: paddingInlineSM, paddingBlockSM: paddingBlockSM, paddingBlockLG: paddingBlockLG, paddingInlineLG: paddingInlineLG, colorIcon: colorIcon, colorTextDisabled: colorTextDisabled, motionDurationMid: motionDurationMid, handleHoverColor: handleHoverColor, handleOpacity: handleOpacity, paddingInline: paddingInline, paddingBlock: paddingBlock, handleBg: handleBg, handleActiveBg: handleActiveBg, inputAffixPadding: inputAffixPadding, borderRadiusSM: borderRadiusSM, controlWidth: controlWidth, handleBorderColor: handleBorderColor, filledHandleBg: filledHandleBg, lineHeightLG: lineHeightLG, antCls: antCls } = token;
    const borderStyle = `${(0, $56bae8a99c3cba6e$export$523c0b569236b342)(lineWidth)} ${lineType} ${handleBorderColor}`;
    const [varName, varRef] = (0, $761caadb5301aee1$export$d82b8f66c5649e14)(antCls, 'input-number');
    return [
        // ==========================================================
        // ==                         Base                         ==
        // ==========================================================
        {
            [componentCls]: {
                ...(0, $cd5a520fee8002b4$export$23997c3e44cc1c59)(token),
                ...(0, $2a8a1036c9d4d150$export$8c9a381315f3ebcd)(token),
                [varName('input-padding-block')]: (0, $56bae8a99c3cba6e$export$523c0b569236b342)(paddingBlock),
                [varName('input-padding-inline')]: (0, $56bae8a99c3cba6e$export$523c0b569236b342)(paddingInline),
                display: 'inline-flex',
                width: controlWidth,
                margin: 0,
                paddingBlock: 0,
                borderRadius: borderRadius,
                // ======================= Variants =======================
                ...(0, $abfb65067786f0b7$export$53795bafd774ce02)(token, {
                    [`${componentCls}-actions`]: {
                        background: handleBg,
                        [`${componentCls}-action-down`]: {
                            borderBlockStart: borderStyle
                        }
                    }
                }),
                ...(0, $abfb65067786f0b7$export$b8365cd7e6671d79)(token, {
                    [`${componentCls}-actions`]: {
                        background: filledHandleBg,
                        [`${componentCls}-action-down`]: {
                            borderBlockStart: borderStyle
                        }
                    },
                    '&:focus-within': {
                        [`${componentCls}-actions`]: {
                            background: handleBg
                        }
                    }
                }),
                ...(0, $abfb65067786f0b7$export$34771e60e0439351)(token, {
                    [`${componentCls}-actions`]: {
                        background: handleBg,
                        [`${componentCls}-action-down`]: {
                            borderBlockStart: borderStyle
                        }
                    }
                }),
                ...(0, $abfb65067786f0b7$export$b6de5da7f39edfcb)(token),
                // InputNumber 两层结构：borderless 补偿只加在内层 input 的 CSS 变量上，避免外层+内层双重 padding 导致高度异常
                [`&${componentCls}-borderless`]: {
                    paddingBlock: 0,
                    [varName('input-padding-block')]: (0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.calc(paddingBlock).add(lineWidth).equal())
                },
                [`&${componentCls}-borderless${componentCls}-sm`]: {
                    paddingBlock: 0,
                    [varName('input-padding-block')]: (0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.calc(paddingBlockSM).add(lineWidth).equal())
                },
                [`&${componentCls}-borderless${componentCls}-lg`]: {
                    paddingBlock: 0,
                    [varName('input-padding-block')]: (0, $56bae8a99c3cba6e$export$523c0b569236b342)(token.calc(paddingBlockLG).add(lineWidth).equal())
                },
                // ========================= RTL ==========================
                '&-rtl': {
                    direction: 'rtl',
                    [`${componentCls}-input`]: {
                        direction: 'rtl'
                    }
                },
                // ===================== Out Of Range =====================
                [`&${componentCls}-out-of-range`]: {
                    [`${componentCls}-input`]: {
                        color: colorError
                    }
                },
                // ======================== Input =========================
                [`${componentCls}-input`]: {
                    ...(0, $cd5a520fee8002b4$export$23997c3e44cc1c59)(token),
                    width: '100%',
                    paddingBlock: varRef('input-padding-block'),
                    textAlign: 'start',
                    backgroundColor: 'transparent',
                    border: 0,
                    borderRadius: 0,
                    outline: 0,
                    transition: `all ${motionDurationMid} linear`,
                    appearance: 'textfield',
                    fontSize: 'inherit',
                    lineHeight: 'inherit',
                    ...(0, $2a8a1036c9d4d150$export$92095d0f4c77bd56)(token.colorTextPlaceholder),
                    '&[type="number"]::-webkit-inner-spin-button, &[type="number"]::-webkit-outer-spin-button': {
                        margin: 0,
                        appearance: 'none'
                    }
                },
                [`&:hover ${componentCls}-handler-wrap, &-focused ${componentCls}-handler-wrap`]: {
                    width: token.handleWidth,
                    opacity: 1
                },
                // ======================= Disabled =======================
                [`&-disabled ${componentCls}-input`]: {
                    cursor: 'not-allowed',
                    color: token.colorTextDisabled
                }
            }
        },
        // ==========================================================
        // ==                        Action                        ==
        // ==========================================================
        {
            [componentCls]: {
                // ======================= Shared =======================
                [`${componentCls}-action`]: {
                    ...(0, $cd5a520fee8002b4$export$171ccda7bc085e59)(),
                    userSelect: 'none',
                    overflow: 'hidden',
                    fontWeight: 700,
                    lineHeight: 0,
                    textAlign: 'center',
                    cursor: 'pointer',
                    transition: `all ${motionDurationMid} linear`,
                    // Active: change background not disabled only;
                    [`&:active:not(${componentCls}-action-up-disabled):not(${componentCls}-action-down-disabled)`]: {
                        background: handleActiveBg
                    },
                    // Hover: change color not disabled only;
                    [`&:hover:not(${componentCls}-action-up-disabled):not(${componentCls}-action-down-disabled)`]: {
                        color: handleHoverColor
                    },
                    [`&${componentCls}-action-up-disabled, &${componentCls}-action-down-disabled`]: {
                        cursor: 'not-allowed',
                        color: colorTextDisabled
                    }
                },
                // ===================== Input Mode =====================
                '&-mode-input': {
                    overflow: 'hidden',
                    [`${componentCls}-actions`]: {
                        position: 'absolute',
                        insetBlockStart: 0,
                        insetInlineEnd: 0,
                        width: token.handleVisibleWidth,
                        opacity: handleOpacity,
                        height: '100%',
                        borderRadius: 0,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'stretch',
                        transition: `all ${motionDurationMid}`,
                        overflow: 'hidden',
                        // Fix input number inside Menu makes icon too large
                        // We arise the selector priority by nest selector here
                        // https://github.com/ant-design/ant-design/issues/14367
                        [`${componentCls}-action`]: {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flex: 'auto',
                            height: '40%',
                            marginInlineEnd: 0,
                            fontSize: token.handleFontSize
                        }
                    },
                    [`&:hover ${componentCls}-actions, &-focused ${componentCls}-actions`]: {
                        width: token.handleWidth,
                        opacity: 1
                    },
                    [`${componentCls}-action`]: {
                        color: colorIcon,
                        height: '50%',
                        borderInlineStart: borderStyle,
                        // Hover: change height not disabled only;
                        [`&:hover:not(${componentCls}-action-up-disabled):not(${componentCls}-action-down-disabled)`]: {
                            height: `60%`
                        }
                    },
                    [`&${componentCls}-disabled, &${componentCls}-readonly`]: {
                        [`${componentCls}-actions`]: {
                            display: 'none'
                        }
                    }
                },
                // ==================== Spinner Mode ====================
                [`&${componentCls}-mode-spinner`]: {
                    padding: 0,
                    width: 'auto',
                    [`${componentCls}-action`]: {
                        flex: 'none',
                        paddingInline: varRef('input-padding-inline'),
                        '&-up': {
                            borderInlineStart: borderStyle
                        },
                        '&-down': {
                            borderInlineEnd: borderStyle
                        }
                    },
                    [`${componentCls}-input`]: {
                        textAlign: 'center',
                        paddingInline: varRef('input-padding-inline')
                    }
                }
            }
        },
        // ==========================================================
        // ==                         Size                         ==
        // ==========================================================
        {
            [componentCls]: {
                '&-lg': {
                    [varName('input-padding-block')]: (0, $56bae8a99c3cba6e$export$523c0b569236b342)(paddingBlockLG),
                    [varName('input-padding-inline')]: (0, $56bae8a99c3cba6e$export$523c0b569236b342)(paddingInlineLG),
                    paddingBlock: 0,
                    fontSize: inputFontSizeLG,
                    lineHeight: lineHeightLG
                },
                '&-sm': {
                    [varName('input-padding-block')]: (0, $56bae8a99c3cba6e$export$523c0b569236b342)(paddingBlockSM),
                    [varName('input-padding-inline')]: (0, $56bae8a99c3cba6e$export$523c0b569236b342)(paddingInlineSM),
                    paddingBlock: 0,
                    fontSize: inputFontSizeSM,
                    borderRadius: borderRadiusSM
                }
            }
        },
        // ==========================================================
        // ==                      Pre/Suffix                      ==
        // ==========================================================
        {
            [componentCls]: {
                [`${componentCls}-prefix, ${componentCls}-suffix`]: {
                    display: 'flex',
                    flex: 'none',
                    alignItems: 'center',
                    alignSelf: 'center',
                    pointerEvents: 'none'
                },
                [`${componentCls}-prefix`]: {
                    marginInlineEnd: inputAffixPadding
                },
                [`${componentCls}-suffix`]: {
                    height: '100%',
                    marginInlineStart: inputAffixPadding,
                    transition: `margin ${motionDurationMid}`
                },
                [`&:hover:not(${componentCls}-without-controls)`]: {
                    [`${componentCls}-suffix`]: {
                        marginInlineEnd: token.handleWidth
                    }
                }
            }
        }
    ];
};
const $59e8f7e0c7785ad1$var$genCompatibleStyles = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    return {
        [`${componentCls}-addon`]: {
            [`&:has(${antCls}-select)`]: {
                border: 0,
                padding: 0
            }
        }
    };
};
var $59e8f7e0c7785ad1$export$2e2bcd8739ae039 = (0, $761caadb5301aee1$export$51ec95de45185b42)('InputNumber', (token)=>{
    const inputNumberToken = (0, $f564548c7b6877d5$export$4950aa0f605343fb)(token, (0, $9d8327093d1cc6a4$export$a157d95850191a12)(token));
    return [
        $59e8f7e0c7785ad1$var$genInputNumberStyles(inputNumberToken),
        $59e8f7e0c7785ad1$var$genCompatibleStyles(inputNumberToken),
        // =====================================================
        // ==             Space Compact                       ==
        // =====================================================
        (0, $1829499b88c32c7f$export$b1208b23589b4b73)(inputNumberToken)
    ];
}, (0, $25348be903d9ac29$export$9ca1be8807fe0675), {
    unitless: {
        handleOpacity: true
    },
    resetFont: false
});


"use client";
const $78ce9c1f424ce4a2$var$InternalInputNumber = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const inputRef = $5E6i4.useRef(null);
    $5E6i4.useImperativeHandle(ref, ()=>inputRef.current);
    const { rootClassName: rootClassName, size: customizeSize, disabled: customDisabled, prefixCls: prefixCls, addonBefore: _addonBefore, addonAfter: _addonAfter, prefix: prefix, suffix: suffix, bordered: bordered, readOnly: readOnly, status: status, controls: controls = true, variant: customVariant, className: className, style: style, classNames: classNames, styles: styles, mode: mode, ...others } = props;
    const { direction: direction, className: contextClassName, style: contextStyle, styles: contextStyles, classNames: contextClassNames } = (0, $519f2fad435b3034$export$46f4bd6436a25a31)('inputNumber');
    // ===================== Disabled =====================
    const disabled = $5E6i4.useContext((0, $2ab14018ea5b2d79$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled ?? disabled;
    // controls && !mergedDisabled && !readOnly;
    const mergedControls = $5E6i4.useMemo(()=>{
        if (!controls || mergedDisabled || readOnly) return false;
        return controls;
    }, [
        controls,
        mergedDisabled,
        readOnly
    ]);
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $3ee2444c5d59b36b$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    let upIcon = mode === 'spinner' ? /*#__PURE__*/ $5E6i4.createElement((0, $9a6c2ad1f374ce69$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $5E6i4.createElement((0, $90957df98867018c$export$2e2bcd8739ae039), null);
    let downIcon = mode === 'spinner' ? /*#__PURE__*/ $5E6i4.createElement((0, $36f12e0863de9bb9$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $5E6i4.createElement((0, $55e38791308df946$export$2e2bcd8739ae039), null);
    const controlsTemp = typeof mergedControls === 'boolean' ? mergedControls : undefined;
    if ((0, $addbc2fddcbb77a9$export$53b83ca8eaab0383)(mergedControls)) {
        upIcon = mergedControls.upIcon || upIcon;
        downIcon = mergedControls.downIcon || downIcon;
    }
    const { hasFeedback: hasFeedback, isFormItemInput: isFormItemInput, feedbackIcon: feedbackIcon } = $5E6i4.useContext((0, $e785311f53d64def$export$bbb5553c6c7a14ed));
    const mergedSize = (0, $4bfc7567df2a969e$export$2e2bcd8739ae039)((ctx)=>customizeSize ?? compactSize ?? ctx);
    const [variant, enableVariantCls] = (0, $23d5b57d8a25ce6e$export$2e2bcd8739ae039)('inputNumber', customVariant, bordered);
    const suffixNode = (hasFeedback || suffix) && /*#__PURE__*/ $5E6i4.createElement($5E6i4.Fragment, null, suffix, hasFeedback && feedbackIcon);
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        size: mergedSize,
        disabled: mergedDisabled,
        controls: mergedControls
    };
    const contextStyleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $722c8632ba7bdb89$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $722c8632ba7bdb89$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    });
    return /*#__PURE__*/ $5E6i4.createElement((0, $ce69d83304c1f7a1$export$2e2bcd8739ae039), {
        ref: inputRef,
        mode: mode,
        disabled: mergedDisabled,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(className, rootClassName, mergedClassNames.root, contextClassName, compactItemClassnames, (0, $842ff74e676bf26d$export$b08e7b47149942a2)(prefixCls, status, hasFeedback), {
            [`${prefixCls}-${variant}`]: enableVariantCls,
            [`${prefixCls}-lg`]: mergedSize === 'large',
            [`${prefixCls}-sm`]: mergedSize === 'small',
            [`${prefixCls}-rtl`]: direction === 'rtl',
            [`${prefixCls}-in-form-item`]: isFormItemInput,
            [`${prefixCls}-without-controls`]: !mergedControls
        }),
        style: mergedStyles.root,
        upHandler: upIcon,
        downHandler: downIcon,
        prefixCls: prefixCls,
        readOnly: readOnly,
        controls: controlsTemp,
        prefix: prefix,
        suffix: suffixNode,
        classNames: mergedClassNames,
        styles: mergedStyles,
        ...others
    });
});
// ===================================================================
// ==                          InputNumber                          ==
// ===================================================================
const $78ce9c1f424ce4a2$var$InputNumber = /*#__PURE__*/ $5E6i4.forwardRef((props, ref)=>{
    const { addonBefore: addonBefore, addonAfter: addonAfter, prefixCls: customizePrefixCls, className: className, status: customStatus, rootClassName: rootClassName, ...rest } = props;
    const { getPrefixCls: getPrefixCls } = (0, $519f2fad435b3034$export$46f4bd6436a25a31)('inputNumber');
    const prefixCls = getPrefixCls('input-number', customizePrefixCls);
    const { status: contextStatus } = $5E6i4.useContext((0, $e785311f53d64def$export$bbb5553c6c7a14ed));
    const mergedStatus = (0, $842ff74e676bf26d$export$314e193082d7ba49)(contextStatus, customStatus);
    const rootCls = (0, $d104ec5f99ed66d7$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $59e8f7e0c7785ad1$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const hasLegacyAddon = addonBefore || addonAfter;
    var prop, newProp;
    // ====================== Render ======================
    const inputNumberNode = /*#__PURE__*/ $5E6i4.createElement($78ce9c1f424ce4a2$var$InternalInputNumber, {
        ref: ref,
        ...rest,
        prefixCls: prefixCls,
        status: mergedStatus,
        className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(cssVarCls, rootCls, hashId, className),
        rootClassName: !hasLegacyAddon ? rootClassName : undefined
    });
    if (hasLegacyAddon) {
        const renderAddon = (node)=>{
            if (!node) return null;
            return /*#__PURE__*/ $5E6i4.createElement((0, $ed27646e7d1d36cb$export$2e2bcd8739ae039), {
                className: (0, $ee9d4e7b280b4edb$export$4f5d2d50c9deca37)(`${prefixCls}-addon`, cssVarCls, hashId),
                variant: props.variant,
                disabled: props.disabled,
                status: mergedStatus
            }, /*#__PURE__*/ $5E6i4.createElement((0, $33ed3a59b63447d5$export$2e2bcd8739ae039), {
                form: true
            }, node));
        };
        const addonBeforeNode = renderAddon(addonBefore);
        const addonAfterNode = renderAddon(addonAfter);
        return /*#__PURE__*/ $5E6i4.createElement((0, $3ee2444c5d59b36b$export$2e2bcd8739ae039), {
            rootClassName: rootClassName
        }, addonBeforeNode, inputNumberNode, addonAfterNode);
    }
    return inputNumberNode;
});
const $78ce9c1f424ce4a2$var$TypedInputNumber = $78ce9c1f424ce4a2$var$InputNumber;
/** @private Internal Component. Do not use in your production. */ const $78ce9c1f424ce4a2$var$PureInputNumber = (props)=>/*#__PURE__*/ $5E6i4.createElement((0, $58662003e62ec648$export$2e2bcd8739ae039), {
        theme: {
            components: {
                InputNumber: {
                    handleVisible: true
                }
            }
        }
    }, /*#__PURE__*/ $5E6i4.createElement($78ce9c1f424ce4a2$var$InputNumber, {
        ...props
    }));
$78ce9c1f424ce4a2$var$TypedInputNumber._InternalPanelDoNotUseOrYouWillBeFired = $78ce9c1f424ce4a2$var$PureInputNumber;
var $78ce9c1f424ce4a2$export$2e2bcd8739ae039 = $78ce9c1f424ce4a2$var$TypedInputNumber;




var $5E6i4 = parcelRequire("5E6i4");





const $0bdfeeb528269652$var$defaultTempo = 80;
/** The number of the bar at the offset. */ const $0bdfeeb528269652$var$barAt = (measures, offset)=>{
    let bar = measures[0]?.[1];
    for (const [start, number] of measures){
        if (start > offset + 1e-6) break;
        bar = number;
    }
    return bar;
};
/**
 * Plays the whole piece on the piano, all voices, from the page on view (paper, 7.2: audio playback). While it plays,
 * the notes that sound light up in the sheet and the pages turn with it (`onPosition`).
 */ const $0bdfeeb528269652$var$ScorePlayer = ({ musicSheetID: musicSheetID, noteElements: noteElements, onPosition: onPosition, startOffset: startOffset })=>{
    const { t: translate } = (0, $705ab703c44be5bc$export$9fc83ad70ead8663)();
    const [performance, setPerformance] = (0, $5E6i4.useState)();
    const [loadError, setLoadError] = (0, $5E6i4.useState)();
    const [bpm, setBpm] = (0, $5E6i4.useState)();
    const [status, setStatus] = (0, $5E6i4.useState)('idle');
    const [bar, setBar] = (0, $5E6i4.useState)();
    const playback = (0, $5E6i4.useRef)(undefined);
    const following = (0, $5E6i4.useRef)(undefined);
    const pausedAt = (0, $5E6i4.useRef)(undefined);
    const latestOnPosition = (0, $5E6i4.useRef)(onPosition);
    latestOnPosition.current = onPosition;
    // The written notes of the sheet, drawn anew when the sheet is zoomed: the following reads the latest ones.
    const spans = (0, $5E6i4.useMemo)(()=>(0, $4276fbe97a4bd973$export$4c117c7f2bc3ff1a)(noteElements), [
        noteElements
    ]);
    const latestSpans = (0, $5E6i4.useRef)(spans);
    latestSpans.current = spans;
    (0, $5E6i4.useEffect)(()=>{
        let isCurrent = true;
        (0, $0d16547caa56a13b$export$2e2bcd8739ae039).get(`${(0, $f3690857a25f275e$export$959cc5b93fe4d66)()}/performance/${musicSheetID}`).then(({ data: data })=>isCurrent && setPerformance(data)).catch((error)=>isCurrent && setLoadError((0, $d65ba47825fbd282$export$d78e6d61b3e1e377)(error)));
        return ()=>{
            isCurrent = false;
            following.current?.stop();
            if (playback.current) {
                const ending = playback.current;
                playback.current = undefined;
                ending.stop();
            }
        };
    }, [
        musicSheetID
    ]);
    const tempo = bpm ?? performance?.tempo ?? $0bdfeeb528269652$var$defaultTempo;
    const start = (from, atTempo = tempo)=>{
        if (!performance) return;
        const started = (0, $358762616e4a14c0$export$751dc8e9fbdf4292)(performance.notes, atTempo, from);
        playback.current = started;
        pausedAt.current = undefined;
        setStatus('loading');
        setBar($0bdfeeb528269652$var$barAt(performance.measures, from));
        // The sounding notes light up; the bar and the page follow (the page only when it changes).
        following.current?.release();
        following.current = (0, $4276fbe97a4bd973$export$8f0a8bcebb0f44bb)(()=>latestSpans.current, started, {
            onOffset: (offset)=>{
                setBar($0bdfeeb528269652$var$barAt(performance.measures, offset));
                latestOnPosition.current(offset);
            }
        });
        started.started.then(()=>{
            if (playback.current === started) setStatus('playing');
        });
        started.finished.then(()=>{
            // Ended by itself or by another playback (a family): not by pausing or stopping here.
            if (playback.current !== started) return;
            playback.current = undefined;
            setBar(undefined);
            setStatus('idle');
        });
    };
    const pause = ()=>{
        const pausing = playback.current;
        if (!pausing) return;
        pausedAt.current = pausing.position();
        playback.current = undefined;
        // The notes stay lit where the piece paused.
        following.current?.release();
        pausing.stop();
        setStatus('paused');
    };
    const stop = ()=>{
        const stopping = playback.current;
        playback.current = undefined;
        pausedAt.current = undefined;
        stopping?.stop();
        following.current?.stop();
        (0, $4276fbe97a4bd973$export$88e4cf4d18f1259e)();
        setBar(undefined);
        setStatus('idle');
    };
    const changeTempo = (value)=>{
        if (value === null || value < 30 || value > 240) return;
        setBpm(value);
        // A playing piece goes on from where it is, at the new tempo.
        if (playback.current && (status === 'playing' || status === 'loading')) {
            const position = playback.current.position();
            const changing = playback.current;
            playback.current = undefined;
            following.current?.release();
            changing.stop();
            start(position, value);
        }
    };
    const playLabel = loadError ? translate('piece.failed', {
        reason: loadError
    }) : status === 'playing' || status === 'loading' ? translate('piece.pause') : status === 'paused' ? translate('piece.resume') : startOffset > 0 ? translate('piece.playFromPage') : translate('piece.play');
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
        "aria-label": translate('piece.player'),
        className: "flex items-center gap-1",
        role: "group",
        children: [
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $1bb718ecb5669b36$export$2e2bcd8739ae039), {
                title: playLabel,
                children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $67d71c16fdfc3a0e$export$2e2bcd8739ae039), {
                    "aria-label": playLabel,
                    disabled: !performance,
                    icon: status === 'loading' ? /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $6e3183dc0ea574da$export$2e2bcd8739ae039), {}) : status === 'playing' ? /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $c28cb742fc860797$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $39b91140dd0153e5$export$2e2bcd8739ae039), {}),
                    onClick: ()=>{
                        if (status === 'playing' || status === 'loading') pause();
                        else if (status === 'paused' && pausedAt.current !== undefined) start(pausedAt.current);
                        else start(startOffset);
                    },
                    type: status === 'playing' ? 'primary' : 'default'
                })
            }),
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $1bb718ecb5669b36$export$2e2bcd8739ae039), {
                title: translate('piece.stop'),
                children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $67d71c16fdfc3a0e$export$2e2bcd8739ae039), {
                    "aria-label": translate('piece.stop'),
                    disabled: status === 'idle',
                    icon: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $56068ff655eff194$export$2e2bcd8739ae039), {}),
                    onClick: stop
                })
            }),
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $1bb718ecb5669b36$export$2e2bcd8739ae039), {
                title: translate('piece.tempo'),
                children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $78ce9c1f424ce4a2$export$2e2bcd8739ae039), {
                    "aria-label": translate('piece.tempo'),
                    disabled: !performance,
                    max: 240,
                    min: 30,
                    onChange: changeTempo,
                    prefix: "\u2669 =",
                    step: 4,
                    style: {
                        width: 96
                    },
                    value: tempo
                })
            }),
            bar !== undefined && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("span", {
                className: "whitespace-nowrap px-1 text-sm tabular-nums text-slate-600",
                children: translate('piece.bar', {
                    bar: bar
                })
            })
        ]
    });
};
var $0bdfeeb528269652$export$2e2bcd8739ae039 = $0bdfeeb528269652$var$ScorePlayer;








const { Content: $cd93687958c8007e$var$Content, Header: $cd93687958c8007e$var$Header } = (0, $0d4ee2ac959080b7$export$2e2bcd8739ae039);
const $cd93687958c8007e$var$AlignedSegmented = (0, $07090e743135ae89$export$2e2bcd8739ae039)((0, $c5c464a2c0131554$export$2e2bcd8739ae039))`
  .ant-segmented-item-label {
    align-items: center;
    display: flex;
  }
`;
const $cd93687958c8007e$var$FullHeightLayout = (0, $07090e743135ae89$export$2e2bcd8739ae039)((0, $0d4ee2ac959080b7$export$2e2bcd8739ae039))`
  height: 100%;
`;
const $cd93687958c8007e$export$4109eb0f73e5aa5e = 'main-wrapper';
const $cd93687958c8007e$var$App = ()=>{
    const [absoluteOffsetPageMap, setAbsoluteOffsetPageMap] = (0, $5E6i4.useState)(new Map());
    const [analysisTab, setAnalysisTab] = (0, $5E6i4.useState)('discovery');
    const [configuringID, setConfiguringID] = (0, $5E6i4.useState)(undefined);
    const [currentPage, setCurrentPage] = (0, $5E6i4.useState)(1);
    const [hoveredOccurrenceIndex, setHoveredOccurrenceIndex] = (0, $5E6i4.useState)(undefined);
    const [hoveredOccurrences, setHoveredOccurrences] = (0, $5E6i4.useState)([]);
    const [hoveredPatternIDs, setHoveredPatternIDs] = (0, $5E6i4.useState)([]);
    const [isImportOpen, setIsImportOpen] = (0, $5E6i4.useState)(false);
    const [isMusicSheetRendered, setIsMusicSheetRendered] = (0, $5E6i4.useState)(false);
    const [newPattern, setNewPattern] = (0, $5E6i4.useState)(undefined);
    const [noteBeamElements, setNoteBeamElements] = (0, $5E6i4.useState)();
    const [noteElements, setNoteElements] = (0, $5E6i4.useState)();
    const [noteStemElements, setNoteStemElements] = (0, $5E6i4.useState)();
    const [numberOfPages, setNumberOfPages] = (0, $5E6i4.useState)();
    const [patterns, setPatterns] = (0, $5E6i4.useState)([]);
    const [playing, setPlaying] = (0, $5E6i4.useState)();
    const [selectedFamilyLabel, setSelectedFamilyLabel] = (0, $5E6i4.useState)();
    const [selectedMusicSheetID, setSelectedMusicSheetID] = (0, $5E6i4.useState)();
    const { error: musicSheetError, musicSheet: selectedMusicSheet, retry: retryMusicSheet } = (0, $d4f658ebaa5fa4e2$export$2e2bcd8739ae039)(selectedMusicSheetID);
    const [showOnBoarding, setShowOnBoarding] = (0, $5E6i4.useState)(false);
    const [suggestingID, setSuggestionsID] = (0, $5E6i4.useState)(undefined);
    const [theme, setTheme] = (0, $5E6i4.useContext)((0, $3c154bbb0fa44c80$export$2c657da244d00bd6));
    const [sheetZoom, setSheetZoom] = (0, $5E6i4.useState)(1);
    // Names the analyst gave discovered families (by discovery label); the others keep their starting names.
    const [familyNames, setFamilyNames] = (0, $5E6i4.useState)({});
    // Per discovered family (by discovery label), the operators whose entries are not highlighted (Suggestions panel).
    const [hiddenFamilyOperators, setHiddenFamilyOperators] = (0, $5E6i4.useState)({});
    const [pageMode, setPageMode] = (0, $5E6i4.useState)((0, $8d63fa2ce3e90264$export$afdcfb9c771acb68));
    const [visibleOperatorsByDefault, setVisibleOperatorsByDefault] = (0, $5E6i4.useState)([
        (0, $e5b6a001e5093ab5$export$fa5f90bfb4dbdbcd).TRANSPOSITION
    ]);
    const { i18n: i18n, t: translate } = (0, $705ab703c44be5bc$export$9fc83ad70ead8663)();
    const [musicSheets, reloadMusicSheets] = (0, $c7fcea0757360e52$export$2e2bcd8739ae039)();
    const voices = (0, $5aca9bb8bf7cde88$export$2e2bcd8739ae039)(selectedMusicSheetID);
    const discovery = (0, $17f5ed32910eebd4$export$481489d69a51404e)(selectedMusicSheetID);
    const families = discovery.data?.families ?? [];
    const labels = (0, $5E6i4.useMemo)(()=>(0, $e1cb3d9aadafb6a6$export$6afe0ab465872e57)(families), [
        discovery.data
    ]);
    const colors = (0, $5E6i4.useMemo)(()=>(0, $e1cb3d9aadafb6a6$export$9acc1e2b46fd8bf0)(families), [
        discovery.data
    ]);
    const ownPatterns = (0, $5E6i4.useMemo)(()=>(0, $e1cb3d9aadafb6a6$export$f4d0e6dd0d97d17a)(families, patterns), [
        discovery.data,
        patterns
    ]);
    const selectedFamily = families.find((family)=>family.label === selectedFamilyLabel);
    const visibleFamilyLabels = families.filter((family)=>patterns.some((pattern)=>pattern.id === (0, $e1cb3d9aadafb6a6$export$2744a1649c52e395)(family))).map((family)=>family.label);
    // The pattern the analyst configures, if it is one of their own: its family is shown under "Transitions".
    const configuringPattern = patterns.find((pattern)=>pattern.id === configuringID);
    const ownPattern = configuringPattern && !configuringPattern.id.startsWith('family-') ? configuringPattern : undefined;
    const ownFamily = (0, $17f5ed32910eebd4$export$228b4754f835d468)(selectedMusicSheetID, ownPattern?.occurrences[0]);
    // A found pattern clicked in the sheet or the timeline: its family from the discovery (no extra request).
    const configuringFamily = families.find((family)=>(0, $e1cb3d9aadafb6a6$export$2744a1649c52e395)(family) === configuringID);
    // The family the Suggestions panel shows the operators of: one clicked in the sheet, the timeline or the graph, or
    // the one selected among the discovered patterns, unless the analyst configures a pattern of their own.
    const suggestionsFamily = configuringFamily ?? (configuringPattern === undefined ? selectedFamily : undefined);
    (0, $5E6i4.useEffect)(()=>{
        if (configuringFamily) setSelectedFamilyLabel(configuringFamily.label);
    }, [
        configuringID
    ]);
    (0, $5E6i4.useEffect)(()=>{
        setSelectedFamilyLabel(undefined);
        setFamilyNames({});
        setHiddenFamilyOperators({});
        (0, $358762616e4a14c0$export$1fdcd79d502f9726)();
    }, [
        selectedMusicSheetID
    ]);
    // Autosave per piece (audit ISSUE-003). The notes of a piece are mapped once per rendering, after its patterns were
    // reset: that is the moment to restore. Saving waits for the restore, so an empty list never overwrites saved work.
    const [restoredSheetID, setRestoredSheetID] = (0, $5E6i4.useState)();
    const analysisFileInput = (0, $5E6i4.useRef)(null);
    const applyAnalysis = (saved)=>{
        const analysis = (0, $7964b3472f9be00d$export$efc1b22afdb7650d)(saved);
        analysis.patterns.forEach((pattern)=>(0, $e5b6a001e5093ab5$export$6be52bf1a7712494).take(pattern.label));
        setPatterns(analysis.patterns.map((pattern)=>({
                ...pattern
            })));
        if (analysis.defaultOperators?.length) setVisibleOperatorsByDefault(analysis.defaultOperators);
        setFamilyNames(analysis.names ?? {});
        setConfiguringID(undefined);
        setNewPattern(undefined);
        setSuggestionsID(undefined);
    };
    (0, $5E6i4.useEffect)(()=>{
        if (!noteElements || !selectedMusicSheet) return;
        const saved = (0, $7964b3472f9be00d$export$b1a8c52f0d825e19)(selectedMusicSheet);
        if (saved) applyAnalysis(saved);
        setRestoredSheetID(selectedMusicSheet.id);
    }, [
        noteElements
    ]);
    const currentAnalysis = ()=>selectedMusicSheet && {
            app: 'MelodyVis',
            defaultOperators: visibleOperatorsByDefault,
            names: familyNames,
            palette: (0, $7964b3472f9be00d$export$b869dd214721594c),
            patterns: patterns,
            savedAt: new Date().toISOString(),
            sheet: {
                composer: selectedMusicSheet.composer,
                title: selectedMusicSheet.title
            },
            version: 1
        };
    (0, $5E6i4.useEffect)(()=>{
        if (!selectedMusicSheet || restoredSheetID !== selectedMusicSheet.id) return;
        (0, $7964b3472f9be00d$export$d412665dc8645c41)(currentAnalysis());
    }, [
        patterns,
        visibleOperatorsByDefault,
        familyNames,
        restoredSheetID
    ]);
    const exportAnalysis = ()=>{
        const analysis = currentAnalysis();
        if (!analysis) return;
        (0, $ed2b12aa71a74467$exports.saveAs)(new Blob([
            JSON.stringify(analysis, null, 2)
        ], {
            type: 'application/json'
        }), (0, $7964b3472f9be00d$export$9065fc7c63285a7c)(analysis.sheet));
    };
    const importAnalysis = async (file)=>{
        try {
            const analysis = (0, $7964b3472f9be00d$export$b04f786813930233)(await file.text());
            if (selectedMusicSheet && analysis.sheet.title !== selectedMusicSheet.title) {
                (0, $f7b22aa7c8982991$export$2e2bcd8739ae039).error(translate('analysis.otherPiece', {
                    title: analysis.sheet.title
                }));
                return;
            }
            applyAnalysis(analysis);
            (0, $f7b22aa7c8982991$export$2e2bcd8739ae039).success(translate('analysis.imported', {
                count: analysis.patterns.length
            }));
        } catch (error) {
            (0, $f7b22aa7c8982991$export$2e2bcd8739ae039).error(translate('analysis.invalid', {
                reason: error.message
            }));
        }
    };
    // Selecting notes in the sheet starts the paper's operator workflow.
    (0, $5E6i4.useEffect)(()=>{
        if (newPattern) setAnalysisTab('operators');
    }, [
        newPattern
    ]);
    // A new selection accepts the pattern whose suggestions were still open, as "Accept" would: its default operator
    // groups become visible (audit ISSUE-002: it used to be deleted silently).
    const previousSuggestingID = (0, $5E6i4.useRef)(undefined);
    (0, $5E6i4.useEffect)(()=>{
        const pendingID = previousSuggestingID.current;
        previousSuggestingID.current = suggestingID;
        if (!pendingID || pendingID === suggestingID || !suggestingID) return;
        setPatterns((oldPatterns)=>{
            const pending = oldPatterns.find((pattern)=>pattern.id === pendingID);
            if (!pending) return oldPatterns;
            pending.connectedToByOperator.filter((connection)=>visibleOperatorsByDefault.includes(connection.byOperator)).forEach((connection)=>{
                const group = oldPatterns.find((pattern)=>pattern.id === connection.id);
                if (group) group.isVisible = true;
            });
            return [
                ...oldPatterns
            ];
        });
    }, [
        suggestingID
    ]);
    (0, $5E6i4.useEffect)(()=>{
        if (theme.colorByVoice) {
            // Retain the current colors of the patterns to re-use them after coloring by pattern, again.
            setTheme((oldTheme)=>({
                    ...oldTheme,
                    availablePatternColors: [
                        ...oldTheme.availablePatternColors,
                        ...patterns.map((pattern)=>pattern.color).reverse()
                    ]
                }));
            setPatterns((oldPatterns)=>{
                oldPatterns.forEach((oldPattern)=>oldPattern.color = theme.getVoiceColor((0, $19aaa313855abf25$export$930cf99cc5aa91c0)(oldPattern)));
                return [
                    ...oldPatterns
                ];
            });
        } else setPatterns((oldPatterns)=>{
            oldPatterns.forEach((oldPattern)=>{
                oldPattern.color = oldPattern.id.startsWith('family-') ? colors[oldPattern.id.slice(7)] : theme.availablePatternColors.pop();
            });
            return [
                ...oldPatterns
            ];
        });
    }, [
        theme.colorByVoice
    ]);
    (0, $5E6i4.useEffect)(()=>{
        if (absoluteOffsetPageMap.size > 0 && (hoveredPatternIDs.length > 0 || hoveredOccurrences.length > 0) && patterns.length > 0) {
            let firstOffset;
            const hoveredPatterns = patterns.filter((pattern)=>hoveredPatternIDs.includes(pattern.id));
            if (hoveredOccurrenceIndex !== undefined && hoveredPatterns.length === 1) {
                // Undefined for one render after entries of the pattern were hidden (Suggestions panel).
                const hoveredOccurrence = hoveredPatterns[0].occurrences[hoveredOccurrenceIndex];
                firstOffset = hoveredOccurrence?.firstOffset;
            } else if (hoveredOccurrences.length > 0) firstOffset = Math.min(...hoveredOccurrences.map((occurrence)=>occurrence.firstOffset));
            else firstOffset = Math.min(...hoveredPatterns.flatMap((hoveredPattern)=>hoveredPattern.occurrences.map((occurrence)=>occurrence.firstOffset)));
            const occurrencePage = absoluteOffsetPageMap.get(firstOffset);
            if (occurrencePage !== undefined && occurrencePage !== currentPage) setCurrentPage(occurrencePage);
        }
    }, [
        absoluteOffsetPageMap,
        hoveredOccurrenceIndex,
        hoveredOccurrences,
        hoveredPatternIDs
    ]);
    const describeFamily = (family)=>translate('discovery.patternDescription', {
            bars: `${family.occurrences[0].measure}\u{2013}${family.occurrences[family.occurrences.length - 1].endMeasure}`,
            count: family.occurrences.length,
            role: (0, $e1cb3d9aadafb6a6$export$a4c5785abc7a1dc3)(family, labels, translate, familyNames)
        });
    const renameFamily = (family, name)=>setFamilyNames((oldNames)=>{
            const names = {
                ...oldNames
            };
            const trimmed = name.trim();
            // An empty name, or the starting name, goes back to the starting name.
            if (!trimmed || trimmed === (0, $e1cb3d9aadafb6a6$export$4fc16528823cd7fe)(family, labels, translate)) delete names[family.label];
            else names[family.label] = trimmed;
            return names;
        });
    const showFamilies = (shown, visible)=>setPatterns((oldPatterns)=>{
            const ids = shown.map((0, $e1cb3d9aadafb6a6$export$2744a1649c52e395));
            const others = oldPatterns.filter((pattern)=>!ids.includes(pattern.id));
            if (!visible) return others;
            return [
                ...others,
                ...shown.map((family)=>(0, $e1cb3d9aadafb6a6$export$143875a47b2f2313)(family, (0, $e1cb3d9aadafb6a6$export$2744a1649c52e395)(family), theme.colorByVoice ? theme.getVoiceColor(family.prototype.voiceNumber) : colors[family.label], describeFamily(family), labels[family.label], hiddenFamilyOperators[family.label]))
            ];
        });
    // Shown families follow the current discovery: a saved or imported analysis keeps which families were shown, while
    // their notes, labels and colours come from the discovery (they change with its algorithm and the palette). A colour
    // the analyst chose for a family stays; automatic ones (earlier palettes, voices, today's roles) are renewed.
    (0, $5E6i4.useEffect)(()=>{
        if (!discovery.data || !selectedMusicSheet || restoredSheetID !== selectedMusicSheet.id) return;
        if (discovery.data.title !== selectedMusicSheet.title) return;
        const automaticColors = new Set([
            ...Object.values(colors),
            ...(0, $3c154bbb0fa44c80$export$93fd56124d1d45f2)
        ]);
        setPatterns((oldPatterns)=>{
            let isChanged = false;
            const synced = oldPatterns.flatMap((pattern)=>{
                if (!pattern.id.startsWith('family-')) return [
                    pattern
                ];
                const family = families.find((candidate)=>(0, $e1cb3d9aadafb6a6$export$2744a1649c52e395)(candidate) === pattern.id);
                if (family === undefined) {
                    isChanged = true;
                    return [];
                }
                const current = (0, $e1cb3d9aadafb6a6$export$143875a47b2f2313)(family, pattern.id, theme.colorByVoice ? theme.getVoiceColor(family.prototype.voiceNumber) : colors[family.label], describeFamily(family), labels[family.label], hiddenFamilyOperators[family.label]);
                const isAutomatic = (0, $49db07fe7d01393c$export$932d21e2ddb1af9d)(pattern.color) || automaticColors.has(pattern.color);
                const updated = {
                    ...current,
                    color: isAutomatic ? current.color : pattern.color,
                    // Derived from the shown families by the effect below.
                    connectedToByOccurrences: pattern.connectedToByOccurrences,
                    isLocked: pattern.isLocked,
                    isVisible: pattern.isVisible
                };
                if ((0, $5pSp9.isEqual)(updated, pattern)) return [
                    pattern
                ];
                isChanged = true;
                return [
                    updated
                ];
            });
            return isChanged ? synced : oldPatterns;
        });
    }, [
        discovery.data,
        restoredSheetID,
        familyNames,
        hiddenFamilyOperators
    ]);
    // Shown families are connected in the graph by the entries they share (see familyConnections).
    const shownFamilyKey = visibleFamilyLabels.slice().sort().join('|');
    (0, $5E6i4.useEffect)(()=>{
        const connections = (0, $e1cb3d9aadafb6a6$export$3fe853e13e85c15c)(families, patterns.map((pattern)=>pattern.id));
        setPatterns((oldPatterns)=>{
            let isChanged = false;
            const connected = oldPatterns.map((pattern)=>{
                const current = connections.get(pattern.id);
                if (current === undefined || (0, $5pSp9.isEqual)(current, pattern.connectedToByOccurrences)) return pattern;
                isChanged = true;
                return {
                    ...pattern,
                    connectedToByOccurrences: current
                };
            });
            return isChanged ? connected : oldPatterns;
        });
    }, [
        discovery.data,
        shownFamilyKey
    ]);
    const selectFamily = (family)=>{
        setSelectedFamilyLabel(family.label);
        if (!visibleFamilyLabels.includes(family.label)) showFamilies([
            family
        ], true);
    };
    // The whole piece plays from the beginning of the page on view (from its very beginning on page 1); playing music
    // turns the pages with it.
    const pageStarts = (0, $5E6i4.useMemo)(()=>[
            ...absoluteOffsetPageMap.entries()
        ].sort(([first], [second])=>first - second), [
        absoluteOffsetPageMap
    ]);
    const pageStartOffset = currentPage <= 1 ? 0 : pageStarts.find(([, page])=>page === currentPage)?.[0] ?? 0;
    const showPageOf = (offset)=>{
        let low = 0;
        let high = pageStarts.length - 1;
        let page;
        while(low <= high){
            const middle = low + high >> 1;
            if (pageStarts[middle][0] <= offset + 1e-6) {
                page = pageStarts[middle][1];
                low = middle + 1;
            } else high = middle - 1;
        }
        if (page !== undefined) setCurrentPage(page);
    };
    const latestShowPageOf = (0, $5E6i4.useRef)(showPageOf);
    latestShowPageOf.current = showPageOf;
    // The written notes of the sheet (drawn anew when it is zoomed); a playing entry lights up its own notes.
    const noteSpans = (0, $5E6i4.useMemo)(()=>(0, $4276fbe97a4bd973$export$4c117c7f2bc3ff1a)(noteElements), [
        noteElements
    ]);
    const latestNoteSpans = (0, $5E6i4.useRef)(noteSpans);
    latestNoteSpans.current = noteSpans;
    const followEntry = (playback, entry)=>{
        latestShowPageOf.current(entry.firstOffset);
        (0, $4276fbe97a4bd973$export$8f0a8bcebb0f44bb)(()=>latestNoteSpans.current, playback, {
            isFollowed: (span)=>span.voice === entry.voiceNumber && span.onset >= entry.firstOffset - 1e-6 && span.onset <= entry.lastOffset + 1e-6,
            offsetAt: (position)=>entry.firstOffset + position,
            onOffset: (offset)=>latestShowPageOf.current(Math.min(offset, entry.lastOffset))
        });
    };
    const playFamily = (family)=>{
        if (playing?.label === family.label) {
            playing.playback.stop();
            setPlaying(undefined);
            return;
        }
        let onset = 0;
        const notes = family.notes.map((name, index)=>{
            const note = {
                duration: family.rhythm[index],
                midi: name === 'rest' ? [] : [
                    (0, $358762616e4a14c0$export$4059236bd5acc6d)(name)
                ],
                onset: onset
            };
            onset += family.rhythm[index];
            return note;
        });
        const playback = (0, $358762616e4a14c0$export$899fbdb5fa08b653)(notes);
        setPlaying({
            label: family.label,
            playback: playback
        });
        followEntry(playback, family.prototype);
        playback.finished.then(()=>setPlaying((current)=>current?.playback === playback ? undefined : current));
    };
    const playOccurrence = async (occurrence)=>{
        let notes;
        try {
            notes = (await (0, $0d16547caa56a13b$export$2e2bcd8739ae039).get(`${(0, $f3690857a25f275e$export$959cc5b93fe4d66)()}/notes/${selectedMusicSheetID}`, {
                params: {
                    firstOffset: occurrence.firstOffset,
                    lastOffset: occurrence.lastOffset,
                    voiceNumber: occurrence.voiceNumber
                }
            })).data;
        } catch (error) {
            (0, $f7b22aa7c8982991$export$2e2bcd8739ae039).error(translate('audio.failed', {
                reason: (0, $d65ba47825fbd282$export$d78e6d61b3e1e377)(error)
            }));
            return;
        }
        const playback = (0, $358762616e4a14c0$export$899fbdb5fa08b653)(notes);
        setPlaying({
            label: (0, $e5b6a001e5093ab5$export$90f4947a2fe01997)(occurrence),
            playback: playback
        });
        followEntry(playback, occurrence);
        playback.finished.then(()=>setPlaying((current)=>current?.playback === playback ? undefined : current));
    };
    const hoverOccurrence = (occurrence)=>setHoveredOccurrences(occurrence ? [
            occurrence
        ] : []);
    const voiceNumbers = voices.map((voice)=>voice.number);
    const lastOffset = selectedMusicSheet?.lastOffset ?? 0;
    return /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)($cd93687958c8007e$var$FullHeightLayout, {
        className: "melodyvis-shell",
        children: [
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)($cd93687958c8007e$var$Header, {
                className: "flex items-center gap-4 border-0 border-b border-solid border-slate-200",
                // antd's component styles are unlayered and beat Tailwind's utilities (see index.css), so inline.
                style: {
                    background: '#ffffff',
                    flexWrap: 'wrap',
                    height: 'auto',
                    lineHeight: 1.5,
                    padding: '8px 20px',
                    rowGap: 8
                },
                children: [
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("h1", {
                        className: "m-0 whitespace-nowrap text-lg font-semibold tracking-tight text-slate-900",
                        children: "MelodyVis"
                    }),
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("div", {
                        className: "min-w-0 flex-[1_1_520px]",
                        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $f622dfa4f509b5fa$export$2e2bcd8739ae039), {
                            currentPage: currentPage,
                            isMusicSheetRendered: isMusicSheetRendered,
                            musicSheets: musicSheets,
                            numberOfPages: numberOfPages,
                            selectedMusicSheetID: selectedMusicSheetID,
                            setConfiguringID: setConfiguringID,
                            setCurrentPage: setCurrentPage,
                            setIsMusicSheetRendered: setIsMusicSheetRendered,
                            setNewPattern: setNewPattern,
                            setNumberOfPages: setNumberOfPages,
                            setPatterns: setPatterns,
                            setSelectedMusicSheetID: setSelectedMusicSheetID,
                            setShowOnBoarding: setShowOnBoarding,
                            setSuggestingID: setSuggestionsID
                        })
                    }),
                    selectedMusicSheetID && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $8d63fa2ce3e90264$export$74e82acf0257e796), {
                        onChange: setPageMode,
                        pageMode: pageMode
                    }),
                    selectedMusicSheetID && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $8d63fa2ce3e90264$export$2e2bcd8739ae039), {
                        onChange: setSheetZoom,
                        zoom: sheetZoom
                    }),
                    selectedMusicSheetID && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $0bdfeeb528269652$export$2e2bcd8739ae039), {
                        musicSheetID: selectedMusicSheetID,
                        noteElements: noteElements,
                        onPosition: showPageOf,
                        startOffset: pageStartOffset
                    }, selectedMusicSheetID),
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $c89b7140c7bc4e1c$export$2e2bcd8739ae039), {
                        menu: {
                            items: [
                                {
                                    icon: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $dd5f5231574dd3a6$export$2e2bcd8739ae039), {}),
                                    key: 'export',
                                    label: translate('analysis.export')
                                },
                                {
                                    icon: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $492357fb2ab06613$export$2e2bcd8739ae039), {}),
                                    key: 'import',
                                    label: translate('analysis.import')
                                }
                            ],
                            onClick: ({ key: key })=>key === 'export' ? exportAnalysis() : analysisFileInput.current?.click()
                        },
                        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)((0, $67d71c16fdfc3a0e$export$2e2bcd8739ae039), {
                            children: [
                                translate('analysis.menu'),
                                " ",
                                /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $55e38791308df946$export$2e2bcd8739ae039), {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("input", {
                        accept: ".json,application/json",
                        "aria-label": translate('analysis.import'),
                        className: "hidden",
                        onChange: (event)=>{
                            const file = event.target.files?.[0];
                            if (file) importAnalysis(file);
                            event.target.value = '';
                        },
                        ref: analysisFileInput,
                        type: "file"
                    }),
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $1bb718ecb5669b36$export$2e2bcd8739ae039), {
                        title: translate('import.title'),
                        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $67d71c16fdfc3a0e$export$2e2bcd8739ae039), {
                            icon: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $6b83eb880a64fd9b$export$2e2bcd8739ae039), {}),
                            onClick: ()=>setIsImportOpen(true),
                            children: translate('import.button')
                        })
                    }),
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)($cd93687958c8007e$var$AlignedSegmented, {
                        "aria-label": translate('language'),
                        onChange: (language)=>i18n.changeLanguage(language),
                        options: [
                            {
                                icon: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("img", {
                                    alt: "Deutsch",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($785b271c4db4a8c1$exports))),
                                    title: "Deutsch",
                                    width: 16
                                }),
                                value: 'de'
                            },
                            {
                                icon: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("img", {
                                    alt: "English",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($ee66faefadc56a3e$exports))),
                                    title: "English",
                                    width: 16
                                }),
                                value: 'en'
                            }
                        ],
                        size: "small",
                        value: i18n.languages[0]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)($cd93687958c8007e$var$Content, {
                className: "min-h-0 bg-white px-5 pb-3 pt-3",
                children: [
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $b9ae4ce9d6b4bc54$export$2e2bcd8739ae039), {
                        isVisible: showOnBoarding,
                        setIsVisible: setShowOnBoarding,
                        showTab: setAnalysisTab
                    }),
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $ce683bf34071f3bb$export$2e2bcd8739ae039), {
                        isOpen: isImportOpen,
                        onClose: ()=>setIsImportOpen(false),
                        onImported: async (sheet)=>{
                            await reloadMusicSheets();
                            setSelectedMusicSheetID(sheet.id);
                        }
                    }),
                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
                        className: "melodyvis-workspace",
                        id: $cd93687958c8007e$export$4109eb0f73e5aa5e,
                        children: [
                            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
                                className: "melodyvis-sheet-column relative",
                                children: [
                                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $e241e8c3cc886a95$export$2e2bcd8739ae039), {
                                        name: translate('views.sheet'),
                                        resetKey: selectedMusicSheetID,
                                        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $2c02c8dc1811708f$export$2e2bcd8739ae039), {
                                            currentPage: currentPage,
                                            hoveredOccurrenceIndex: hoveredOccurrenceIndex,
                                            hoveredOccurrences: hoveredOccurrences,
                                            hoveredPatternIDs: hoveredPatternIDs,
                                            isMusicSheetRendered: isMusicSheetRendered,
                                            musicSheets: musicSheets,
                                            noteBeamElements: noteBeamElements,
                                            noteElements: noteElements,
                                            noteStemElements: noteStemElements,
                                            numberOfPages: numberOfPages,
                                            pageMode: pageMode,
                                            patterns: patterns,
                                            selectedMusicSheet: selectedMusicSheet,
                                            setAbsoluteOffsetPageMap: setAbsoluteOffsetPageMap,
                                            setConfiguringID: setConfiguringID,
                                            setCurrentPage: setCurrentPage,
                                            setHoveredOccurrenceIndex: setHoveredOccurrenceIndex,
                                            setHoveredPatternIDs: setHoveredPatternIDs,
                                            setIsMusicSheetRendered: setIsMusicSheetRendered,
                                            setNewPattern: setNewPattern,
                                            setNoteBeamElements: setNoteBeamElements,
                                            setNoteElements: setNoteElements,
                                            setNoteStemElements: setNoteStemElements,
                                            setNumberOfPages: setNumberOfPages,
                                            setPatterns: setPatterns,
                                            setSelectedMusicSheetID: setSelectedMusicSheetID,
                                            setSuggestingID: setSuggestionsID,
                                            setZoom: setSheetZoom,
                                            suggestingID: suggestingID,
                                            voices: voices,
                                            zoom: sheetZoom
                                        })
                                    }),
                                    musicSheetError && // Over the sheet, which stays mounted: the next selection renders as usual (audit F09).
                                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("div", {
                                        className: "absolute inset-0 z-10 flex items-start justify-center bg-white pt-16",
                                        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $31b03c1d2148500a$export$2e2bcd8739ae039), {
                                            extra: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $67d71c16fdfc3a0e$export$2e2bcd8739ae039), {
                                                onClick: retryMusicSheet,
                                                type: "primary",
                                                children: translate('musicSheetError.retry')
                                            }),
                                            status: "warning",
                                            subTitle: musicSheetError,
                                            title: translate('musicSheetError.title')
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
                                className: "melodyvis-analysis-column",
                                children: [
                                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $e241e8c3cc886a95$export$2e2bcd8739ae039), {
                                        name: translate('views.timeline'),
                                        resetKey: selectedMusicSheetID,
                                        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $63f88f8247c03421$export$2e2bcd8739ae039), {
                                            absoluteOffsetPageMap: absoluteOffsetPageMap,
                                            hoveredOccurrenceIndex: hoveredOccurrenceIndex,
                                            hoveredOccurrences: hoveredOccurrences,
                                            hoveredPatternIDs: hoveredPatternIDs,
                                            patterns: patterns,
                                            selectedMusicSheet: selectedMusicSheet,
                                            setConfiguringID: setConfiguringID,
                                            setCurrentPage: setCurrentPage,
                                            setHoveredOccurrenceIndex: setHoveredOccurrenceIndex,
                                            setHoveredPatternIDs: setHoveredPatternIDs,
                                            onPlayOccurrence: playOccurrence,
                                            playingOccurrenceKey: playing?.label,
                                            voices: voices
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $c7fd5f6d0100ca71$export$2e2bcd8739ae039), {
                                        activeKey: analysisTab,
                                        className: "min-h-0 flex-1",
                                        items: [
                                            {
                                                children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $e241e8c3cc886a95$export$2e2bcd8739ae039), {
                                                    name: translate('views.discovery'),
                                                    resetKey: selectedMusicSheetID,
                                                    children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
                                                        className: "flex min-h-0 flex-col gap-4",
                                                        id: (0, $824a58fb00160520$export$7ad4c67c1e638f8e),
                                                        children: [
                                                            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $824a58fb00160520$export$2e2bcd8739ae039), {
                                                                colors: colors,
                                                                discovery: discovery.data,
                                                                error: discovery.error,
                                                                isLoading: discovery.isLoading,
                                                                labels: labels,
                                                                names: familyNames,
                                                                onPlay: playFamily,
                                                                onRename: renameFamily,
                                                                onSelect: selectFamily,
                                                                onToggle: (family)=>showFamilies([
                                                                        family
                                                                    ], !visibleFamilyLabels.includes(family.label)),
                                                                onToggleAll: (visible)=>showFamilies(families, visible),
                                                                ownPatterns: ownPatterns,
                                                                playingLabel: playing?.label,
                                                                selectedLabel: selectedFamilyLabel,
                                                                visibleLabels: visibleFamilyLabels
                                                            }),
                                                            selectedFamily && /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $bda569642168ffcb$export$2e2bcd8739ae039), {
                                                                family: {
                                                                    ...selectedFamily,
                                                                    label: labels[selectedFamily.label]
                                                                },
                                                                lastOffset: lastOffset,
                                                                onHoverOccurrence: hoverOccurrence,
                                                                onPlayOccurrence: playOccurrence,
                                                                onSelectOccurrence: (occurrence)=>{
                                                                    const page = absoluteOffsetPageMap.get(occurrence.firstOffset);
                                                                    if (page !== undefined) setCurrentPage(page);
                                                                },
                                                                voices: voiceNumbers
                                                            })
                                                        ]
                                                    })
                                                }),
                                                key: 'discovery',
                                                label: translate('discovery.title')
                                            },
                                            {
                                                children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $e241e8c3cc886a95$export$2e2bcd8739ae039), {
                                                    name: translate('views.operators'),
                                                    resetKey: selectedMusicSheetID,
                                                    children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsxs)("div", {
                                                        className: "grid h-full min-h-[36rem] grid-cols-[fit-content(190px)_minmax(0,1fr)] gap-x-2",
                                                        style: {
                                                            height: '-webkit-fill-available'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $ce8d4034349042ca$export$2e2bcd8739ae039), {
                                                                configuringID: configuringID,
                                                                family: suggestionsFamily && {
                                                                    color: patterns.find((pattern)=>pattern.id === (0, $e1cb3d9aadafb6a6$export$2744a1649c52e395)(suggestionsFamily))?.color ?? colors[suggestionsFamily.label],
                                                                    family: suggestionsFamily,
                                                                    hiddenOperators: hiddenFamilyOperators[suggestionsFamily.label] ?? [],
                                                                    isShown: visibleFamilyLabels.includes(suggestionsFamily.label),
                                                                    label: labels[suggestionsFamily.label],
                                                                    name: (0, $e1cb3d9aadafb6a6$export$a4c5785abc7a1dc3)(suggestionsFamily, labels, translate, familyNames),
                                                                    onHideOperators: (hidden)=>setHiddenFamilyOperators((oldHidden)=>({
                                                                                ...oldHidden,
                                                                                [suggestionsFamily.label]: hidden
                                                                            })),
                                                                    onHoverOccurrences: setHoveredOccurrences,
                                                                    onShow: ()=>showFamilies([
                                                                            suggestionsFamily
                                                                        ], true)
                                                                },
                                                                hoveredPatternIDs: hoveredPatternIDs,
                                                                musicSheetID: selectedMusicSheetID,
                                                                noteElements: noteElements,
                                                                newPattern: newPattern,
                                                                patterns: patterns,
                                                                setConfiguringID: setConfiguringID,
                                                                setHoveredPatternIDs: setHoveredPatternIDs,
                                                                setNewPattern: setNewPattern,
                                                                setPatterns: setPatterns,
                                                                setSuggestingID: setSuggestionsID,
                                                                setVisibleOperatorsByDefault: setVisibleOperatorsByDefault,
                                                                suggestingID: suggestingID,
                                                                visibleOperatorsByDefault: visibleOperatorsByDefault
                                                            }),
                                                            /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $2b5809ac53051808$export$2e2bcd8739ae039), {
                                                                configuringID: configuringID,
                                                                hoveredOccurrences: hoveredOccurrences,
                                                                hoveredPatternIDs: hoveredPatternIDs,
                                                                patterns: patterns,
                                                                setConfiguringID: setConfiguringID,
                                                                setHoveredOccurrenceIndex: setHoveredOccurrenceIndex,
                                                                setHoveredOccurrences: setHoveredOccurrences,
                                                                setHoveredPatternIDs: setHoveredPatternIDs,
                                                                setPatterns: setPatterns,
                                                                setSuggestingID: setSuggestionsID
                                                            })
                                                        ]
                                                    })
                                                }),
                                                // Kept mounted: the operator search and the graph layout keep their state across tab switches.
                                                forceRender: true,
                                                key: 'operators',
                                                label: translate('tabs.operators')
                                            },
                                            {
                                                children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $e241e8c3cc886a95$export$2e2bcd8739ae039), {
                                                    name: translate('views.transitions'),
                                                    resetKey: selectedMusicSheetID,
                                                    children: ownPattern ? ownFamily.data ? /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $bda569642168ffcb$export$2e2bcd8739ae039), {
                                                        family: {
                                                            ...ownFamily.data,
                                                            label: ownPattern.label
                                                        },
                                                        lastOffset: lastOffset,
                                                        onHoverOccurrence: hoverOccurrence,
                                                        onPlayOccurrence: playOccurrence,
                                                        onSelectOccurrence: (occurrence)=>{
                                                            const page = absoluteOffsetPageMap.get(occurrence.firstOffset);
                                                            if (page !== undefined) setCurrentPage(page);
                                                        },
                                                        voices: voiceNumbers
                                                    }) : /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("p", {
                                                        className: "text-sm text-slate-500",
                                                        children: ownFamily.error ?? translate('transitions.loading')
                                                    }) : configuringFamily ? /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $bda569642168ffcb$export$2e2bcd8739ae039), {
                                                        family: {
                                                            ...configuringFamily,
                                                            label: labels[configuringFamily.label]
                                                        },
                                                        lastOffset: lastOffset,
                                                        onHoverOccurrence: hoverOccurrence,
                                                        onPlayOccurrence: playOccurrence,
                                                        onSelectOccurrence: (occurrence)=>{
                                                            const page = absoluteOffsetPageMap.get(occurrence.firstOffset);
                                                            if (page !== undefined) setCurrentPage(page);
                                                        },
                                                        voices: voiceNumbers
                                                    }) : /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)("p", {
                                                        className: "text-sm text-slate-500",
                                                        children: translate('transitions.hint')
                                                    })
                                                }),
                                                key: 'transitions',
                                                label: translate('tabs.transitions')
                                            }
                                        ],
                                        onChange: (key)=>setAnalysisTab(key),
                                        size: "small"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $cd93687958c8007e$export$2e2bcd8739ae039 = $cd93687958c8007e$var$App;





(0, $f5efe749b20fa0f3$export$2e2bcd8739ae039).use((0, $2e6ea1df9a18d47e$export$2e2bcd8739ae039)).use((0, $f7af809e3f6ff502$export$ae7e14d40d89f296)).init({
    fallbackLng: 'en',
    load: 'languageOnly',
    nsSeparator: ';',
    // Part of the hashed script: a browser can no longer pair a cached translation file of an older build with a
    // newer script, which showed raw keys such as "discovery.roles.theme" instead of the texts.
    resources: {
        de: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($16d711b5d7ddc5c0$exports)))
        },
        en: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($494d8c6bff879d7b$exports)))
        }
    },
    supportedLngs: [
        'en',
        'de'
    ]
});
(0, $3b51c8a0c5045117$exports.createRoot)(document.getElementById('app')).render(/*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $3c154bbb0fa44c80$export$2e2bcd8739ae039), {
    children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $ca0029180522dabd$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $90cae257cc958273$exports.jsx)((0, $cd93687958c8007e$export$2e2bcd8739ae039), {})
    })
}));


//# sourceMappingURL=app.3de789a0.js.map
